(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
/*!
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md.
 */
!function(t){const e=t.en=t.en||{};e.dictionary=Object.assign(e.dictionary||{},{"%0 of %1":"%0 of %1","Block quote":"Block quote",Bold:"Bold","Bulleted List":"Bulleted List",Cancel:"Cancel","Cannot upload file:":"Cannot upload file:","Centered image":"Centered image","Change image text alternative":"Change image text alternative","Choose heading":"Choose heading",Column:"Column","Could not insert image at the current position.":"Could not insert image at the current position.","Could not obtain resized image URL.":"Could not obtain resized image URL.","Decrease indent":"Decrease indent","Delete column":"Delete column","Delete row":"Delete row",Downloadable:"Downloadable","Dropdown toolbar":"Dropdown toolbar","Edit link":"Edit link","Editor toolbar":"Editor toolbar","Enter image caption":"Enter image caption","Full size image":"Full size image","Header column":"Header column","Header row":"Header row",Heading:"Heading","Heading 1":"Heading 1","Heading 2":"Heading 2","Heading 3":"Heading 3","Heading 4":"Heading 4","Heading 5":"Heading 5","Heading 6":"Heading 6","Image toolbar":"Image toolbar","image widget":"image widget","Increase indent":"Increase indent","Insert column left":"Insert column left","Insert column right":"Insert column right","Insert image":"Insert image","Insert image or file":"Insert image or file","Insert media":"Insert media","Insert paragraph after block":"Insert paragraph after block","Insert paragraph before block":"Insert paragraph before block","Insert row above":"Insert row above","Insert row below":"Insert row below","Insert table":"Insert table","Inserting image failed":"Inserting image failed",Italic:"Italic","Left aligned image":"Left aligned image",Link:"Link","Link URL":"Link URL","Media URL":"Media URL","media widget":"media widget","Merge cell down":"Merge cell down","Merge cell left":"Merge cell left","Merge cell right":"Merge cell right","Merge cell up":"Merge cell up","Merge cells":"Merge cells",Next:"Next","Numbered List":"Numbered List","Open in a new tab":"Open in a new tab","Open link in new tab":"Open link in new tab",Paragraph:"Paragraph","Paste the media URL in the input.":"Paste the media URL in the input.",Previous:"Previous",Redo:"Redo","Rich Text Editor":"Rich Text Editor","Rich Text Editor, %0":"Rich Text Editor, %0","Right aligned image":"Right aligned image",Row:"Row",Save:"Save","Select all":"Select all","Select column":"Select column","Select row":"Select row","Selecting resized image failed":"Selecting resized image failed","Show more items":"Show more items","Side image":"Side image","Split cell horizontally":"Split cell horizontally","Split cell vertically":"Split cell vertically","Table toolbar":"Table toolbar","Text alternative":"Text alternative","The URL must not be empty.":"The URL must not be empty.","This link has no URL":"This link has no URL","This media URL is not supported.":"This media URL is not supported.","Tip: Paste the URL into the content to embed faster.":"Tip: Paste the URL into the content to embed faster.",Undo:"Undo",Unlink:"Unlink","Upload failed":"Upload failed","Upload in progress":"Upload in progress","Widget toolbar":"Widget toolbar"})}(window.CKEDITOR_TRANSLATIONS||(window.CKEDITOR_TRANSLATIONS={})),function(t,e){"object"==typeof exports&&"object"==typeof module?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.ClassicEditor=e():t.ClassicEditor=e()}(window,(function(){return function(t){var e={};function n(i){if(e[i])return e[i].exports;var o=e[i]={i:i,l:!1,exports:{}};return t[i].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=t,n.c=e,n.d=function(t,e,i){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:i})},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var i=Object.create(null);if(n.r(i),Object.defineProperty(i,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var o in t)n.d(i,o,function(e){return t[e]}.bind(null,o));return i},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="",n(n.s=96)}([function(t,e,n){"use strict";n.d(e,"b",(function(){return i})),n.d(e,"a",(function(){return o}));class i extends Error{constructor(t,e,n){t=o(t),n&&(t+=" "+JSON.stringify(n)),super(t),this.name="CKEditorError",this.context=e,this.data=n}is(t){return"CKEditorError"===t}static rethrowUnexpectedError(t,e){if(t.is&&t.is("CKEditorError"))throw t;const n=new i(t.message,e);throw n.stack=t.stack,n}}function o(t){const e=t.match(/^([^:]+):/);return e?t+` Read more: https://ckeditor.com/docs/ckeditor5/latest/framework/guides/support/error-codes.html#error-${e[1]}\n`:t}},function(t,e,n){"use strict";var i,o=function(){return void 0===i&&(i=Boolean(window&&document&&document.all&&!window.atob)),i},r=function(){var t={};return function(e){if(void 0===t[e]){var n=document.querySelector(e);if(window.HTMLIFrameElement&&n instanceof window.HTMLIFrameElement)try{n=n.contentDocument.head}catch(t){n=null}t[e]=n}return t[e]}}(),s=[];function a(t){for(var e=-1,n=0;n<s.length;n++)if(s[n].identifier===t){e=n;break}return e}function c(t,e){for(var n={},i=[],o=0;o<t.length;o++){var r=t[o],c=e.base?r[0]+e.base:r[0],l=n[c]||0,d="".concat(c," ").concat(l);n[c]=l+1;var u=a(d),h={css:r[1],media:r[2],sourceMap:r[3]};-1!==u?(s[u].references++,s[u].updater(h)):s.push({identifier:d,updater:p(h,e),references:1}),i.push(d)}return i}function l(t){var e=document.createElement("style"),i=t.attributes||{};if(void 0===i.nonce){var o=n.nc;o&&(i.nonce=o)}if(Object.keys(i).forEach((function(t){e.setAttribute(t,i[t])})),"function"==typeof t.insert)t.insert(e);else{var s=r(t.insert||"head");if(!s)throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");s.appendChild(e)}return e}var d,u=(d=[],function(t,e){return d[t]=e,d.filter(Boolean).join("\n")});function h(t,e,n,i){var o=n?"":i.media?"@media ".concat(i.media," {").concat(i.css,"}"):i.css;if(t.styleSheet)t.styleSheet.cssText=u(e,o);else{var r=document.createTextNode(o),s=t.childNodes;s[e]&&t.removeChild(s[e]),s.length?t.insertBefore(r,s[e]):t.appendChild(r)}}function f(t,e,n){var i=n.css,o=n.media,r=n.sourceMap;if(o?t.setAttribute("media",o):t.removeAttribute("media"),r&&btoa&&(i+="\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(r))))," */")),t.styleSheet)t.styleSheet.cssText=i;else{for(;t.firstChild;)t.removeChild(t.firstChild);t.appendChild(document.createTextNode(i))}}var g=null,m=0;function p(t,e){var n,i,o;if(e.singleton){var r=m++;n=g||(g=l(e)),i=h.bind(null,n,r,!1),o=h.bind(null,n,r,!0)}else n=l(e),i=f.bind(null,n,e),o=function(){!function(t){if(null===t.parentNode)return!1;t.parentNode.removeChild(t)}(n)};return i(t),function(e){if(e){if(e.css===t.css&&e.media===t.media&&e.sourceMap===t.sourceMap)return;i(t=e)}else o()}}t.exports=function(t,e){(e=e||{}).singleton||"boolean"==typeof e.singleton||(e.singleton=o());var n=c(t=t||[],e);return function(t){if(t=t||[],"[object Array]"===Object.prototype.toString.call(t)){for(var i=0;i<n.length;i++){var o=a(n[i]);s[o].references--}for(var r=c(t,e),l=0;l<n.length;l++){var d=a(n[l]);0===s[d].references&&(s[d].updater(),s.splice(d,1))}n=r}}}},,function(t,e,n){"use strict";var i=n(7),o="object"==typeof self&&self&&self.Object===Object&&self,r=i.a||o||Function("return this")();e.a=r},function(t,e,n){"use strict";(function(t){var i=n(3),o=n(12),r="object"==typeof exports&&exports&&!exports.nodeType&&exports,s=r&&"object"==typeof t&&t&&!t.nodeType&&t,a=s&&s.exports===r?i.a.Buffer:void 0,c=(a?a.isBuffer:void 0)||o.a;e.a=c}).call(this,n(9)(t))},function(t,e,n){"use strict";(function(t){var i=n(7),o="object"==typeof exports&&exports&&!exports.nodeType&&exports,r=o&&"object"==typeof t&&t&&!t.nodeType&&t,s=r&&r.exports===o&&i.a.process,a=function(){try{var t=r&&r.require&&r.require("util").types;return t||s&&s.binding&&s.binding("util")}catch(t){}}();e.a=a}).call(this,n(9)(t))},function(t,e,n){"use strict";(function(t){var e=n(0);const i="object"==typeof window?window:t;if(i.CKEDITOR_VERSION)throw new e.b("ckeditor-duplicated-modules: Some CKEditor 5 modules are duplicated.",null);i.CKEDITOR_VERSION="20.0.0"}).call(this,n(10))},function(t,e,n){"use strict";(function(t){var n="object"==typeof t&&t&&t.Object===Object&&t;e.a=n}).call(this,n(10))},function(t,e,n){"use strict";(function(t){var i=n(3),o="object"==typeof exports&&exports&&!exports.nodeType&&exports,r=o&&"object"==typeof t&&t&&!t.nodeType&&t,s=r&&r.exports===o?i.a.Buffer:void 0,a=s?s.allocUnsafe:void 0;e.a=function(t,e){if(e)return t.slice();var n=t.length,i=a?a(n):new t.constructor(n);return t.copy(i),i}}).call(this,n(9)(t))},function(t,e){t.exports=function(t){if(!t.webpackPolyfill){var e=Object.create(t);e.children||(e.children=[]),Object.defineProperty(e,"loaded",{enumerable:!0,get:function(){return e.l}}),Object.defineProperty(e,"id",{enumerable:!0,get:function(){return e.i}}),Object.defineProperty(e,"exports",{enumerable:!0}),e.webpackPolyfill=1}return e}},function(t,e){var n;n=function(){return this}();try{n=n||new Function("return this")()}catch(t){"object"==typeof window&&(n=window)}t.exports=n},function(t,e,n){var i=n(1),o=n(71);"string"==typeof(o=o.__esModule?o.default:o)&&(o=[[t.i,o,""]]);var r={injectType:"singletonStyleTag",attributes:{"data-cke":!0},insert:"head",singleton:!0};i(o,r);t.exports=o.locals||{}},function(t,e,n){"use strict";e.a=function(){return!1}},function(t,e,n){var i=n(1),o=n(14);"string"==typeof(o=o.__esModule?o.default:o)&&(o=[[t.i,o,""]]);var r={injectType:"singletonStyleTag",attributes:{"data-cke":!0},insert:"head",singleton:!0};i(o,r);t.exports=o.locals||{}},function(t,e){t.exports=".ck.ck-placeholder:before,.ck .ck-placeholder:before{content:attr(data-placeholder);pointer-events:none}.ck.ck-read-only .ck-placeholder:before{display:none}.ck.ck-placeholder:before,.ck .ck-placeholder:before{cursor:text;color:var(--ck-color-engine-placeholder-text)}"},function(t,e,n){var i=n(1),o=n(16);"string"==typeof(o=o.__esModule?o.default:o)&&(o=[[t.i,o,""]]);var r={injectType:"singletonStyleTag",attributes:{"data-cke":!0},insert:"head",singleton:!0};i(o,r);t.exports=o.locals||{}},function(t,e){t.exports=".ck-hidden{display:none!important}.ck.ck-reset,.ck.ck-reset_all,.ck.ck-reset_all *{box-sizing:border-box;width:auto;height:auto;position:static}:root{--ck-z-default:1;--ck-z-modal:calc(var(--ck-z-default) + 999);--ck-color-base-foreground:#fafafa;--ck-color-base-background:#fff;--ck-color-base-border:#c4c4c4;--ck-color-base-action:#61b045;--ck-color-base-focus:#6cb5f9;--ck-color-base-text:#333;--ck-color-base-active:#198cf0;--ck-color-base-active-focus:#0e7fe1;--ck-color-base-error:#db3700;--ck-color-focus-border-coordinates:208,79%,51%;--ck-color-focus-border:hsl(var(--ck-color-focus-border-coordinates));--ck-color-focus-outer-shadow:#bcdefb;--ck-color-focus-disabled-shadow:rgba(119,186,248,0.3);--ck-color-focus-error-shadow:rgba(255,64,31,0.3);--ck-color-text:var(--ck-color-base-text);--ck-color-shadow-drop:rgba(0,0,0,0.15);--ck-color-shadow-drop-active:rgba(0,0,0,0.2);--ck-color-shadow-inner:rgba(0,0,0,0.1);--ck-color-button-default-background:transparent;--ck-color-button-default-hover-background:#e6e6e6;--ck-color-button-default-active-background:#d9d9d9;--ck-color-button-default-active-shadow:#bfbfbf;--ck-color-button-default-disabled-background:transparent;--ck-color-button-on-background:#dedede;--ck-color-button-on-hover-background:#c4c4c4;--ck-color-button-on-active-background:#bababa;--ck-color-button-on-active-shadow:#a1a1a1;--ck-color-button-on-disabled-background:#dedede;--ck-color-button-action-background:var(--ck-color-base-action);--ck-color-button-action-hover-background:#579e3d;--ck-color-button-action-active-background:#53973b;--ck-color-button-action-active-shadow:#498433;--ck-color-button-action-disabled-background:#7ec365;--ck-color-button-action-text:var(--ck-color-base-background);--ck-color-button-save:#008a00;--ck-color-button-cancel:#db3700;--ck-color-switch-button-off-background:#b0b0b0;--ck-color-switch-button-off-hover-background:#a3a3a3;--ck-color-switch-button-on-background:var(--ck-color-button-action-background);--ck-color-switch-button-on-hover-background:#579e3d;--ck-color-switch-button-inner-background:var(--ck-color-base-background);--ck-color-switch-button-inner-shadow:rgba(0,0,0,0.1);--ck-color-dropdown-panel-background:var(--ck-color-base-background);--ck-color-dropdown-panel-border:var(--ck-color-base-border);--ck-color-input-background:var(--ck-color-base-background);--ck-color-input-border:#c7c7c7;--ck-color-input-error-border:var(--ck-color-base-error);--ck-color-input-text:var(--ck-color-base-text);--ck-color-input-disabled-background:#f2f2f2;--ck-color-input-disabled-border:#c7c7c7;--ck-color-input-disabled-text:#5c5c5c;--ck-color-list-background:var(--ck-color-base-background);--ck-color-list-button-hover-background:var(--ck-color-button-default-hover-background);--ck-color-list-button-on-background:var(--ck-color-base-active);--ck-color-list-button-on-background-focus:var(--ck-color-base-active-focus);--ck-color-list-button-on-text:var(--ck-color-base-background);--ck-color-panel-background:var(--ck-color-base-background);--ck-color-panel-border:var(--ck-color-base-border);--ck-color-toolbar-background:var(--ck-color-base-foreground);--ck-color-toolbar-border:var(--ck-color-base-border);--ck-color-tooltip-background:var(--ck-color-base-text);--ck-color-tooltip-text:var(--ck-color-base-background);--ck-color-engine-placeholder-text:#707070;--ck-color-upload-bar-background:#6cb5f9;--ck-color-link-default:#0000f0;--ck-color-link-selected-background:rgba(31,177,255,0.1);--ck-color-link-fake-selection:rgba(31,177,255,0.3);--ck-disabled-opacity:.5;--ck-focus-outer-shadow-geometry:0 0 0 3px;--ck-focus-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-outer-shadow);--ck-focus-disabled-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-disabled-shadow);--ck-focus-error-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-error-shadow);--ck-focus-ring:1px solid var(--ck-color-focus-border);--ck-font-size-base:13px;--ck-line-height-base:1.84615;--ck-font-face:Helvetica,Arial,Tahoma,Verdana,Sans-Serif;--ck-font-size-tiny:0.7em;--ck-font-size-small:0.75em;--ck-font-size-normal:1em;--ck-font-size-big:1.4em;--ck-font-size-large:1.8em;--ck-ui-component-min-height:2.3em}.ck.ck-reset,.ck.ck-reset_all,.ck.ck-reset_all *{margin:0;padding:0;border:0;background:transparent;text-decoration:none;vertical-align:middle;transition:none;word-wrap:break-word}.ck.ck-reset_all,.ck.ck-reset_all *{border-collapse:collapse;font:normal normal normal var(--ck-font-size-base)/var(--ck-line-height-base) var(--ck-font-face);color:var(--ck-color-text);text-align:left;white-space:nowrap;cursor:auto;float:none}.ck.ck-reset_all .ck-rtl *{text-align:right}.ck.ck-reset_all iframe{vertical-align:inherit}.ck.ck-reset_all textarea{white-space:pre-wrap}.ck.ck-reset_all input[type=password],.ck.ck-reset_all input[type=text],.ck.ck-reset_all textarea{cursor:text}.ck.ck-reset_all input[type=password][disabled],.ck.ck-reset_all input[type=text][disabled],.ck.ck-reset_all textarea[disabled]{cursor:default}.ck.ck-reset_all fieldset{padding:10px;border:2px groove #dfdee3}.ck.ck-reset_all button::-moz-focus-inner{padding:0;border:0}.ck[dir=rtl],.ck[dir=rtl] .ck{text-align:right}:root{--ck-border-radius:2px;--ck-inner-shadow:2px 2px 3px var(--ck-color-shadow-inner) inset;--ck-drop-shadow:0 1px 2px 1px var(--ck-color-shadow-drop);--ck-drop-shadow-active:0 3px 6px 1px var(--ck-color-shadow-drop-active);--ck-spacing-unit:0.6em;--ck-spacing-large:calc(var(--ck-spacing-unit)*1.5);--ck-spacing-standard:var(--ck-spacing-unit);--ck-spacing-medium:calc(var(--ck-spacing-unit)*0.8);--ck-spacing-small:calc(var(--ck-spacing-unit)*0.5);--ck-spacing-tiny:calc(var(--ck-spacing-unit)*0.3);--ck-spacing-extra-tiny:calc(var(--ck-spacing-unit)*0.16)}"},function(t,e,n){var i=n(1),o=n(18);"string"==typeof(o=o.__esModule?o.default:o)&&(o=[[t.i,o,""]]);var r={injectType:"singletonStyleTag",attributes:{"data-cke":!0},insert:"head",singleton:!0};i(o,r);t.exports=o.locals||{}},function(t,e){t.exports=":root{--ck-color-editable-blur-selection:#d9d9d9}.ck.ck-editor__editable:not(.ck-editor__nested-editable){border-radius:0}.ck-rounded-corners .ck.ck-editor__editable:not(.ck-editor__nested-editable),.ck.ck-editor__editable:not(.ck-editor__nested-editable).ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-editor__editable:not(.ck-editor__nested-editable).ck-focused{outline:none;border:var(--ck-focus-ring);box-shadow:var(--ck-inner-shadow),0 0}.ck.ck-editor__editable_inline{overflow:auto;padding:0 var(--ck-spacing-standard);border:1px solid transparent}.ck.ck-editor__editable_inline[dir=ltr]{text-align:left}.ck.ck-editor__editable_inline[dir=rtl]{text-align:right}.ck.ck-editor__editable_inline>:first-child{margin-top:var(--ck-spacing-large)}.ck.ck-editor__editable_inline>:last-child{margin-bottom:var(--ck-spacing-large)}.ck.ck-editor__editable_inline.ck-blurred ::selection{background:var(--ck-color-editable-blur-selection)}.ck.ck-balloon-panel.ck-toolbar-container[class*=arrow_n]:after{border-bottom-color:var(--ck-color-base-foreground)}.ck.ck-balloon-panel.ck-toolbar-container[class*=arrow_s]:after{border-top-color:var(--ck-color-base-foreground)}"},function(t,e,n){var i=n(1),o=n(20);"string"==typeof(o=o.__esModule?o.default:o)&&(o=[[t.i,o,""]]);var r={injectType:"singletonStyleTag",attributes:{"data-cke":!0},insert:"head",singleton:!0};i(o,r);t.exports=o.locals||{}},function(t,e){t.exports=".ck.ck-label{display:block}.ck.ck-voice-label{display:none}.ck.ck-label{font-weight:700}"},function(t,e,n){var i=n(1),o=n(22);"string"==typeof(o=o.__esModule?o.default:o)&&(o=[[t.i,o,""]]);var r={injectType:"singletonStyleTag",attributes:{"data-cke":!0},insert:"head",singleton:!0};i(o,r);t.exports=o.locals||{}},function(t,e){t.exports=".ck.ck-sticky-panel .ck-sticky-panel__content_sticky{z-index:var(--ck-z-modal);position:fixed;top:0}.ck.ck-sticky-panel .ck-sticky-panel__content_sticky_bottom-limit{top:auto;position:absolute}.ck.ck-sticky-panel .ck-sticky-panel__content_sticky{box-shadow:var(--ck-drop-shadow),0 0;border-width:0 1px 1px;border-top-left-radius:0;border-top-right-radius:0}"},function(t,e,n){var i=n(1),o=n(24);"string"==typeof(o=o.__esModule?o.default:o)&&(o=[[t.i,o,""]]);var r={injectType:"singletonStyleTag",attributes:{"data-cke":!0},insert:"head",singleton:!0};i(o,r);t.exports=o.locals||{}},function(t,e){t.exports=".ck.ck-dropdown{display:inline-block;position:relative}.ck.ck-dropdown .ck-dropdown__arrow{pointer-events:none;z-index:var(--ck-z-default)}.ck.ck-dropdown .ck-button.ck-dropdown__button{width:100%}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on .ck-tooltip{display:none}.ck.ck-dropdown .ck-dropdown__panel{-webkit-backface-visibility:hidden;display:none;z-index:var(--ck-z-modal);position:absolute}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel-visible{display:inline-block}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_ne,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nw{bottom:100%}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sw{top:100%;bottom:auto}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_ne,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se{left:0}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sw{right:0}:root{--ck-dropdown-arrow-size:calc(0.5*var(--ck-icon-size))}.ck.ck-dropdown{font-size:inherit}.ck.ck-dropdown .ck-dropdown__arrow{width:var(--ck-dropdown-arrow-size)}[dir=ltr] .ck.ck-dropdown .ck-dropdown__arrow{right:var(--ck-spacing-standard);margin-left:var(--ck-spacing-standard)}[dir=rtl] .ck.ck-dropdown .ck-dropdown__arrow{left:var(--ck-spacing-standard);margin-right:var(--ck-spacing-small)}.ck.ck-dropdown.ck-disabled .ck-dropdown__arrow{opacity:var(--ck-disabled-opacity)}[dir=ltr] .ck.ck-dropdown .ck-button.ck-dropdown__button:not(.ck-button_with-text){padding-left:var(--ck-spacing-small)}[dir=rtl] .ck.ck-dropdown .ck-button.ck-dropdown__button:not(.ck-button_with-text){padding-right:var(--ck-spacing-small)}.ck.ck-dropdown .ck-button.ck-dropdown__button .ck-button__label{width:7em;overflow:hidden;text-overflow:ellipsis}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-disabled .ck-button__label{opacity:var(--ck-disabled-opacity)}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on{border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-dropdown__button_label-width_auto .ck-button__label{width:auto}.ck.ck-dropdown__panel{border-radius:0}.ck-rounded-corners .ck.ck-dropdown__panel,.ck.ck-dropdown__panel.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-dropdown__panel{box-shadow:var(--ck-drop-shadow),0 0;background:var(--ck-color-dropdown-panel-background);border:1px solid var(--ck-color-dropdown-panel-border);bottom:0;min-width:100%}.ck.ck-dropdown__panel.ck-dropdown__panel_se{border-top-left-radius:0}.ck.ck-dropdown__panel.ck-dropdown__panel_sw{border-top-right-radius:0}.ck.ck-dropdown__panel.ck-dropdown__panel_ne{border-bottom-left-radius:0}.ck.ck-dropdown__panel.ck-dropdown__panel_nw{border-bottom-right-radius:0}"},function(t,e,n){var i=n(1),o=n(26);"string"==typeof(o=o.__esModule?o.default:o)&&(o=[[t.i,o,""]]);var r={injectType:"singletonStyleTag",attributes:{"data-cke":!0},insert:"head",singleton:!0};i(o,r);t.exports=o.locals||{}},function(t,e){t.exports=".ck.ck-icon{vertical-align:middle}:root{--ck-icon-size:calc(var(--ck-line-height-base)*var(--ck-font-size-normal))}.ck.ck-icon{width:var(--ck-icon-size);height:var(--ck-icon-size);font-size:.8333350694em;will-change:transform}.ck.ck-icon,.ck.ck-icon *{color:inherit;cursor:inherit}.ck.ck-icon :not([fill]){fill:currentColor}"},function(t,e,n){var i=n(1),o=n(28);"string"==typeof(o=o.__esModule?o.default:o)&&(o=[[t.i,o,""]]);var r={injectType:"singletonStyleTag",attributes:{"data-cke":!0},insert:"head",singleton:!0};i(o,r);t.exports=o.locals||{}},function(t,e){t.exports='.ck.ck-tooltip,.ck.ck-tooltip .ck-tooltip__text:after{position:absolute;pointer-events:none;-webkit-backface-visibility:hidden}.ck.ck-tooltip{visibility:hidden;opacity:0;display:none;z-index:var(--ck-z-modal)}.ck.ck-tooltip .ck-tooltip__text{display:inline-block}.ck.ck-tooltip .ck-tooltip__text:after{content:"";width:0;height:0}:root{--ck-tooltip-arrow-size:5px}.ck.ck-tooltip{left:50%;top:0;transition:opacity .2s ease-in-out .2s}.ck.ck-tooltip .ck-tooltip__text{border-radius:0}.ck-rounded-corners .ck.ck-tooltip .ck-tooltip__text,.ck.ck-tooltip .ck-tooltip__text.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-tooltip .ck-tooltip__text{font-size:.9em;line-height:1.5;color:var(--ck-color-tooltip-text);padding:var(--ck-spacing-small) var(--ck-spacing-medium);background:var(--ck-color-tooltip-background);position:relative;left:-50%}.ck.ck-tooltip .ck-tooltip__text:after{transition:opacity .2s ease-in-out .2s;border-style:solid;left:50%}.ck.ck-tooltip.ck-tooltip_s{bottom:calc(-1*var(--ck-tooltip-arrow-size));transform:translateY(100%)}.ck.ck-tooltip.ck-tooltip_s .ck-tooltip__text:after{top:calc(-1*var(--ck-tooltip-arrow-size));transform:translateX(-50%);border-left-color:transparent;border-bottom-color:var(--ck-color-tooltip-background);border-right-color:transparent;border-top-color:transparent;border-left-width:var(--ck-tooltip-arrow-size);border-bottom-width:var(--ck-tooltip-arrow-size);border-right-width:var(--ck-tooltip-arrow-size);border-top-width:0}.ck.ck-tooltip.ck-tooltip_n{top:calc(-1*var(--ck-tooltip-arrow-size));transform:translateY(-100%)}.ck.ck-tooltip.ck-tooltip_n .ck-tooltip__text:after{bottom:calc(-1*var(--ck-tooltip-arrow-size));transform:translateX(-50%);border-left-color:transparent;border-bottom-color:transparent;border-right-color:transparent;border-top-color:var(--ck-color-tooltip-background);border-left-width:var(--ck-tooltip-arrow-size);border-bottom-width:0;border-right-width:var(--ck-tooltip-arrow-size);border-top-width:var(--ck-tooltip-arrow-size)}'},function(t,e,n){var i=n(1),o=n(30);"string"==typeof(o=o.__esModule?o.default:o)&&(o=[[t.i,o,""]]);var r={injectType:"singletonStyleTag",attributes:{"data-cke":!0},insert:"head",singleton:!0};i(o,r);t.exports=o.locals||{}},function(t,e){t.exports=".ck.ck-button,a.ck.ck-button{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.ck.ck-button .ck-tooltip,a.ck.ck-button .ck-tooltip{display:block}@media (hover:none){.ck.ck-button .ck-tooltip,a.ck.ck-button .ck-tooltip{display:none}}.ck.ck-button,a.ck.ck-button{position:relative;display:inline-flex;align-items:center;justify-content:left}.ck.ck-button .ck-button__label,a.ck.ck-button .ck-button__label{display:none}.ck.ck-button.ck-button_with-text .ck-button__label,a.ck.ck-button.ck-button_with-text .ck-button__label{display:inline-block}.ck.ck-button:not(.ck-button_with-text),a.ck.ck-button:not(.ck-button_with-text){justify-content:center}.ck.ck-button:hover .ck-tooltip,a.ck.ck-button:hover .ck-tooltip{visibility:visible;opacity:1}.ck.ck-button:focus:not(:hover) .ck-tooltip,a.ck.ck-button:focus:not(:hover) .ck-tooltip{display:none}.ck.ck-button,a.ck.ck-button{background:var(--ck-color-button-default-background)}.ck.ck-button:not(.ck-disabled):hover,a.ck.ck-button:not(.ck-disabled):hover{background:var(--ck-color-button-default-hover-background)}.ck.ck-button:not(.ck-disabled):active,a.ck.ck-button:not(.ck-disabled):active{background:var(--ck-color-button-default-active-background);box-shadow:inset 0 2px 2px var(--ck-color-button-default-active-shadow)}.ck.ck-button.ck-disabled,a.ck.ck-button.ck-disabled{background:var(--ck-color-button-default-disabled-background)}.ck.ck-button,a.ck.ck-button{border-radius:0}.ck-rounded-corners .ck.ck-button,.ck-rounded-corners a.ck.ck-button,.ck.ck-button.ck-rounded-corners,a.ck.ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-button,a.ck.ck-button{white-space:nowrap;cursor:default;vertical-align:middle;padding:var(--ck-spacing-tiny);text-align:center;min-width:var(--ck-ui-component-min-height);min-height:var(--ck-ui-component-min-height);line-height:1;font-size:inherit;border:1px solid transparent;transition:box-shadow .2s ease-in-out,border .2s ease-in-out;-webkit-appearance:none}.ck.ck-button:active,.ck.ck-button:focus,a.ck.ck-button:active,a.ck.ck-button:focus{outline:none;border:var(--ck-focus-ring);box-shadow:var(--ck-focus-outer-shadow),0 0}.ck.ck-button .ck-button__icon use,.ck.ck-button .ck-button__icon use *,a.ck.ck-button .ck-button__icon use,a.ck.ck-button .ck-button__icon use *{color:inherit}.ck.ck-button .ck-button__label,a.ck.ck-button .ck-button__label{font-size:inherit;font-weight:inherit;color:inherit;cursor:inherit;vertical-align:middle}[dir=ltr] .ck.ck-button .ck-button__label,[dir=ltr] a.ck.ck-button .ck-button__label{text-align:left}[dir=rtl] .ck.ck-button .ck-button__label,[dir=rtl] a.ck.ck-button .ck-button__label{text-align:right}.ck.ck-button .ck-button__keystroke,a.ck.ck-button .ck-button__keystroke{color:inherit}[dir=ltr] .ck.ck-button .ck-button__keystroke,[dir=ltr] a.ck.ck-button .ck-button__keystroke{margin-left:var(--ck-spacing-large)}[dir=rtl] .ck.ck-button .ck-button__keystroke,[dir=rtl] a.ck.ck-button .ck-button__keystroke{margin-right:var(--ck-spacing-large)}.ck.ck-button .ck-button__keystroke,a.ck.ck-button .ck-button__keystroke{font-weight:700;opacity:.7}.ck.ck-button.ck-disabled:active,.ck.ck-button.ck-disabled:focus,a.ck.ck-button.ck-disabled:active,a.ck.ck-button.ck-disabled:focus{box-shadow:var(--ck-focus-disabled-outer-shadow),0 0}.ck.ck-button.ck-disabled .ck-button__icon,a.ck.ck-button.ck-disabled .ck-button__icon{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-disabled .ck-button__label,a.ck.ck-button.ck-disabled .ck-button__label{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-disabled .ck-button__keystroke,a.ck.ck-button.ck-disabled .ck-button__keystroke{opacity:.3}.ck.ck-button.ck-button_with-text,a.ck.ck-button.ck-button_with-text{padding:var(--ck-spacing-tiny) var(--ck-spacing-standard)}[dir=ltr] .ck.ck-button.ck-button_with-text .ck-button__icon,[dir=ltr] a.ck.ck-button.ck-button_with-text .ck-button__icon{margin-left:calc(-1*var(--ck-spacing-small));margin-right:var(--ck-spacing-small)}[dir=rtl] .ck.ck-button.ck-button_with-text .ck-button__icon,[dir=rtl] a.ck.ck-button.ck-button_with-text .ck-button__icon{margin-right:calc(-1*var(--ck-spacing-small));margin-left:var(--ck-spacing-small)}.ck.ck-button.ck-button_with-keystroke .ck-button__label,a.ck.ck-button.ck-button_with-keystroke .ck-button__label{flex-grow:1}.ck.ck-button.ck-on,a.ck.ck-button.ck-on{background:var(--ck-color-button-on-background)}.ck.ck-button.ck-on:not(.ck-disabled):hover,a.ck.ck-button.ck-on:not(.ck-disabled):hover{background:var(--ck-color-button-on-hover-background)}.ck.ck-button.ck-on:not(.ck-disabled):active,a.ck.ck-button.ck-on:not(.ck-disabled):active{background:var(--ck-color-button-on-active-background);box-shadow:inset 0 2px 2px var(--ck-color-button-on-active-shadow)}.ck.ck-button.ck-on.ck-disabled,a.ck.ck-button.ck-on.ck-disabled{background:var(--ck-color-button-on-disabled-background)}.ck.ck-button.ck-button-save,a.ck.ck-button.ck-button-save{color:var(--ck-color-button-save)}.ck.ck-button.ck-button-cancel,a.ck.ck-button.ck-button-cancel{color:var(--ck-color-button-cancel)}.ck.ck-button-action,a.ck.ck-button-action{background:var(--ck-color-button-action-background)}.ck.ck-button-action:not(.ck-disabled):hover,a.ck.ck-button-action:not(.ck-disabled):hover{background:var(--ck-color-button-action-hover-background)}.ck.ck-button-action:not(.ck-disabled):active,a.ck.ck-button-action:not(.ck-disabled):active{background:var(--ck-color-button-action-active-background);box-shadow:inset 0 2px 2px var(--ck-color-button-action-active-shadow)}.ck.ck-button-action.ck-disabled,a.ck.ck-button-action.ck-disabled{background:var(--ck-color-button-action-disabled-background)}.ck.ck-button-action,a.ck.ck-button-action{color:var(--ck-color-button-action-text)}.ck.ck-button-bold,a.ck.ck-button-bold{font-weight:700}"},function(t,e,n){var i=n(1),o=n(32);"string"==typeof(o=o.__esModule?o.default:o)&&(o=[[t.i,o,""]]);var r={injectType:"singletonStyleTag",attributes:{"data-cke":!0},insert:"head",singleton:!0};i(o,r);t.exports=o.locals||{}},function(t,e){t.exports=".ck.ck-list{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none;display:flex;flex-direction:column}.ck.ck-list .ck-list__item,.ck.ck-list .ck-list__separator{display:block}.ck.ck-list .ck-list__item>:focus{position:relative;z-index:var(--ck-z-default)}.ck.ck-list{border-radius:0}.ck-rounded-corners .ck.ck-list,.ck.ck-list.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-list{list-style-type:none;background:var(--ck-color-list-background)}.ck.ck-list__item{cursor:default;min-width:12em}.ck.ck-list__item .ck-button{min-height:unset;width:100%;text-align:left;border-radius:0;padding:calc(0.2*var(--ck-line-height-base)*var(--ck-font-size-base)) calc(0.4*var(--ck-line-height-base)*var(--ck-font-size-base))}.ck.ck-list__item .ck-button .ck-button__label{line-height:calc(1.2*var(--ck-line-height-base)*var(--ck-font-size-base))}.ck.ck-list__item .ck-button:active{box-shadow:none}.ck.ck-list__item .ck-button.ck-on{background:var(--ck-color-list-button-on-background);color:var(--ck-color-list-button-on-text)}.ck.ck-list__item .ck-button.ck-on:active{box-shadow:none}.ck.ck-list__item .ck-button.ck-on:hover:not(.ck-disabled){background:var(--ck-color-list-button-on-background-focus)}.ck.ck-list__item .ck-button.ck-on:focus:not(.ck-disabled){border-color:var(--ck-color-base-background)}.ck.ck-list__item .ck-button:hover:not(.ck-disabled){background:var(--ck-color-list-button-hover-background)}.ck.ck-list__item .ck-switchbutton.ck-on{background:var(--ck-color-list-background);color:inherit}.ck.ck-list__item .ck-switchbutton.ck-on:hover:not(.ck-disabled){background:var(--ck-color-list-button-hover-background);color:inherit}.ck.ck-list__separator{height:1px;width:100%;background:var(--ck-color-base-border)}"},function(t,e,n){var i=n(1),o=n(34);"string"==typeof(o=o.__esModule?o.default:o)&&(o=[[t.i,o,""]]);var r={injectType:"singletonStyleTag",attributes:{"data-cke":!0},insert:"head",singleton:!0};i(o,r);t.exports=o.locals||{}},function(t,e){t.exports=".ck.ck-button.ck-switchbutton .ck-button__toggle,.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{display:block}:root{--ck-switch-button-toggle-width:2.6153846154em;--ck-switch-button-toggle-inner-size:1.0769230769em;--ck-switch-button-toggle-spacing:1px;--ck-switch-button-translation:calc(var(--ck-switch-button-toggle-width) - var(--ck-switch-button-toggle-inner-size) - 2*var(--ck-switch-button-toggle-spacing))}[dir=ltr] .ck.ck-button.ck-switchbutton .ck-button__label{margin-right:calc(2*var(--ck-spacing-large))}[dir=rtl] .ck.ck-button.ck-switchbutton .ck-button__label{margin-left:calc(2*var(--ck-spacing-large))}.ck.ck-button.ck-switchbutton .ck-button__toggle{border-radius:0}.ck-rounded-corners .ck.ck-button.ck-switchbutton .ck-button__toggle,.ck.ck-button.ck-switchbutton .ck-button__toggle.ck-rounded-corners{border-radius:var(--ck-border-radius)}[dir=ltr] .ck.ck-button.ck-switchbutton .ck-button__toggle{margin-left:auto}[dir=rtl] .ck.ck-button.ck-switchbutton .ck-button__toggle{margin-right:auto}.ck.ck-button.ck-switchbutton .ck-button__toggle{transition:background .4s ease;width:var(--ck-switch-button-toggle-width);background:var(--ck-color-switch-button-off-background)}.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{border-radius:0}.ck-rounded-corners .ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner,.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner.ck-rounded-corners{border-radius:var(--ck-border-radius);border-radius:calc(0.5*var(--ck-border-radius))}.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{margin:var(--ck-switch-button-toggle-spacing);width:var(--ck-switch-button-toggle-inner-size);height:var(--ck-switch-button-toggle-inner-size);background:var(--ck-color-switch-button-inner-background);transition:all .3s ease}.ck.ck-button.ck-switchbutton .ck-button__toggle:hover{background:var(--ck-color-switch-button-off-hover-background)}.ck.ck-button.ck-switchbutton .ck-button__toggle:hover .ck-button__toggle__inner{box-shadow:0 0 0 5px var(--ck-color-switch-button-inner-shadow)}.ck.ck-button.ck-switchbutton.ck-disabled .ck-button__toggle{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle{background:var(--ck-color-switch-button-on-background)}.ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle:hover{background:var(--ck-color-switch-button-on-hover-background)}[dir=ltr] .ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle .ck-button__toggle__inner{transform:translateX(var(--ck-switch-button-translation))}[dir=rtl] .ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle .ck-button__toggle__inner{transform:translateX(calc(-1*var(--ck-switch-button-translation)))}"},function(t,e,n){var i=n(1),o=n(36);"string"==typeof(o=o.__esModule?o.default:o)&&(o=[[t.i,o,""]]);var r={injectType:"singletonStyleTag",attributes:{"data-cke":!0},insert:"head",singleton:!0};i(o,r);t.exports=o.locals||{}},function(t,e){t.exports=".ck.ck-toolbar-dropdown .ck.ck-toolbar .ck.ck-toolbar__items{flex-wrap:nowrap}.ck.ck-toolbar-dropdown .ck-dropdown__panel .ck-button:focus{z-index:calc(var(--ck-z-default) + 1)}.ck.ck-toolbar-dropdown .ck-toolbar{border:0}"},function(t,e,n){var i=n(1),o=n(38);"string"==typeof(o=o.__esModule?o.default:o)&&(o=[[t.i,o,""]]);var r={injectType:"singletonStyleTag",attributes:{"data-cke":!0},insert:"head",singleton:!0};i(o,r);t.exports=o.locals||{}},function(t,e){t.exports=".ck.ck-dropdown .ck-dropdown__panel .ck-list{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list,.ck.ck-dropdown .ck-dropdown__panel .ck-list.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0}.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button,.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button,.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-top-right-radius:0}"},function(t,e,n){var i=n(1),o=n(40);"string"==typeof(o=o.__esModule?o.default:o)&&(o=[[t.i,o,""]]);var r={injectType:"singletonStyleTag",attributes:{"data-cke":!0},insert:"head",singleton:!0};i(o,r);t.exports=o.locals||{}},function(t,e){t.exports=".ck.ck-toolbar{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none;display:flex;flex-flow:row nowrap;align-items:center}.ck.ck-toolbar>.ck-toolbar__items{display:flex;flex-flow:row wrap;align-items:center;flex-grow:1}.ck.ck-toolbar .ck.ck-toolbar__separator{display:inline-block}.ck.ck-toolbar .ck.ck-toolbar__separator:first-child,.ck.ck-toolbar .ck.ck-toolbar__separator:last-child{display:none}.ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items{flex-wrap:nowrap}.ck.ck-toolbar.ck-toolbar_vertical>.ck-toolbar__items{flex-direction:column}.ck.ck-toolbar.ck-toolbar_floating>.ck-toolbar__items{flex-wrap:nowrap}.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown>.ck-dropdown__button .ck-dropdown__arrow{display:none}.ck.ck-toolbar{border-radius:0}.ck-rounded-corners .ck.ck-toolbar,.ck.ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-toolbar{background:var(--ck-color-toolbar-background);padding:0 var(--ck-spacing-small);border:1px solid var(--ck-color-toolbar-border)}.ck.ck-toolbar .ck.ck-toolbar__separator{align-self:stretch;width:1px;min-width:1px;margin-top:0;margin-bottom:0;background:var(--ck-color-toolbar-border)}.ck.ck-toolbar>.ck-toolbar__items>*{margin-top:var(--ck-spacing-small);margin-bottom:var(--ck-spacing-small);margin-right:var(--ck-spacing-small)}.ck.ck-toolbar>.ck-toolbar__items:empty+.ck.ck-toolbar__separator{display:none}.ck.ck-toolbar>.ck-toolbar__items>*,.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown{margin-top:var(--ck-spacing-small);margin-bottom:var(--ck-spacing-small)}.ck.ck-toolbar.ck-toolbar_vertical{padding:0}.ck.ck-toolbar.ck-toolbar_vertical>.ck-toolbar__items>.ck{width:100%;margin:0;border-radius:0;border:0}.ck.ck-toolbar.ck-toolbar_compact{padding:0}.ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>*{margin:0}.ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>:not(:first-child):not(:last-child){border-radius:0}.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown>.ck.ck-button.ck-dropdown__button{padding-left:var(--ck-spacing-tiny)}.ck-toolbar-container .ck.ck-toolbar{border:0}.ck.ck-toolbar[dir=rtl]>.ck-toolbar__items>.ck,[dir=rtl] .ck.ck-toolbar>.ck-toolbar__items>.ck{margin-right:0}.ck.ck-toolbar[dir=rtl]:not(.ck-toolbar_compact)>.ck-toolbar__items>.ck,[dir=rtl] .ck.ck-toolbar:not(.ck-toolbar_compact)>.ck-toolbar__items>.ck{margin-left:var(--ck-spacing-small)}.ck.ck-toolbar[dir=rtl]>.ck-toolbar__items>.ck:last-child,[dir=rtl] .ck.ck-toolbar>.ck-toolbar__items>.ck:last-child{margin-left:0}.ck.ck-toolbar[dir=rtl].ck-toolbar_compact>.ck-toolbar__items>.ck:first-child,[dir=rtl] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:first-child{border-top-left-radius:0;border-bottom-left-radius:0}.ck.ck-toolbar[dir=rtl].ck-toolbar_compact>.ck-toolbar__items>.ck:last-child,[dir=rtl] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:last-child{border-top-right-radius:0;border-bottom-right-radius:0}.ck.ck-toolbar[dir=rtl]>.ck.ck-toolbar__separator,[dir=rtl] .ck.ck-toolbar>.ck.ck-toolbar__separator{margin-left:var(--ck-spacing-small)}.ck.ck-toolbar[dir=rtl].ck-toolbar_grouping>.ck-toolbar__items:not(:empty):not(:only-child),[dir=rtl] .ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items:not(:empty):not(:only-child){margin-left:var(--ck-spacing-small)}.ck.ck-toolbar[dir=ltr]>.ck-toolbar__items>.ck:last-child,[dir=ltr] .ck.ck-toolbar>.ck-toolbar__items>.ck:last-child{margin-right:0}.ck.ck-toolbar[dir=ltr].ck-toolbar_compact>.ck-toolbar__items>.ck:first-child,[dir=ltr] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:first-child{border-top-right-radius:0;border-bottom-right-radius:0}.ck.ck-toolbar[dir=ltr].ck-toolbar_compact>.ck-toolbar__items>.ck:last-child,[dir=ltr] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:last-child{border-top-left-radius:0;border-bottom-left-radius:0}.ck.ck-toolbar[dir=ltr]>.ck.ck-toolbar__separator,[dir=ltr] .ck.ck-toolbar>.ck.ck-toolbar__separator{margin-right:var(--ck-spacing-small)}.ck.ck-toolbar[dir=ltr].ck-toolbar_grouping>.ck-toolbar__items:not(:empty):not(:only-child),[dir=ltr] .ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items:not(:empty):not(:only-child){margin-right:var(--ck-spacing-small)}"},function(t,e,n){var i=n(1),o=n(42);"string"==typeof(o=o.__esModule?o.default:o)&&(o=[[t.i,o,""]]);var r={injectType:"singletonStyleTag",attributes:{"data-cke":!0},insert:"head",singleton:!0};i(o,r);t.exports=o.locals||{}},function(t,e){t.exports=".ck.ck-editor{position:relative}.ck.ck-editor .ck-editor__top .ck-sticky-panel .ck-toolbar{z-index:var(--ck-z-modal)}.ck.ck-editor__top .ck-sticky-panel .ck-toolbar{border-radius:0}.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar,.ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius);border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-editor__top .ck-sticky-panel .ck-toolbar{border-bottom-width:0}.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar{border-bottom-width:1px;border-radius:0}.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar,.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius);border-radius:0}.ck.ck-editor__main>.ck-editor__editable{background:var(--ck-color-base-background);border-radius:0}.ck-rounded-corners .ck.ck-editor__main>.ck-editor__editable,.ck.ck-editor__main>.ck-editor__editable.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-top-right-radius:0}.ck.ck-editor__main>.ck-editor__editable:not(.ck-focused){border-color:var(--ck-color-base-border)}"},function(t,e,n){var i=n(1),o=n(44);"string"==typeof(o=o.__esModule?o.default:o)&&(o=[[t.i,o,""]]);var r={injectType:"singletonStyleTag",attributes:{"data-cke":!0},insert:"head",singleton:!0};i(o,r);t.exports=o.locals||{}},function(t,e){t.exports=".ck-content blockquote{overflow:hidden;padding-right:1.5em;padding-left:1.5em;margin-left:0;margin-right:0;font-style:italic;border-left:5px solid #ccc}.ck-content[dir=rtl] blockquote{border-left:0;border-right:5px solid #ccc}"},function(t,e,n){var i=n(1),o=n(46);"string"==typeof(o=o.__esModule?o.default:o)&&(o=[[t.i,o,""]]);var r={injectType:"singletonStyleTag",attributes:{"data-cke":!0},insert:"head",singleton:!0};i(o,r);t.exports=o.locals||{}},function(t,e){t.exports=':root{--ck-balloon-panel-arrow-z-index:calc(var(--ck-z-default) - 3)}.ck.ck-balloon-panel{display:none;position:absolute;z-index:var(--ck-z-modal)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after,.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{content:"";position:absolute}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel[class*=arrow_n]:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel[class*=arrow_n]:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel[class*=arrow_s]:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel[class*=arrow_s]:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel.ck-balloon-panel_visible{display:block}:root{--ck-balloon-arrow-offset:2px;--ck-balloon-arrow-height:10px;--ck-balloon-arrow-half-width:8px}.ck.ck-balloon-panel{border-radius:0}.ck-rounded-corners .ck.ck-balloon-panel,.ck.ck-balloon-panel.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-balloon-panel{box-shadow:var(--ck-drop-shadow),0 0;min-height:15px;background:var(--ck-color-panel-background);border:1px solid var(--ck-color-panel-border)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after,.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{width:0;height:0;border-style:solid}.ck.ck-balloon-panel[class*=arrow_n]:after,.ck.ck-balloon-panel[class*=arrow_n]:before{border-left-width:var(--ck-balloon-arrow-half-width);border-bottom-width:var(--ck-balloon-arrow-height);border-right-width:var(--ck-balloon-arrow-half-width);border-top-width:0}.ck.ck-balloon-panel[class*=arrow_n]:before{border-bottom-color:var(--ck-color-panel-border)}.ck.ck-balloon-panel[class*=arrow_n]:after,.ck.ck-balloon-panel[class*=arrow_n]:before{border-left-color:transparent;border-right-color:transparent;border-top-color:transparent}.ck.ck-balloon-panel[class*=arrow_n]:after{border-bottom-color:var(--ck-color-panel-background);margin-top:var(--ck-balloon-arrow-offset)}.ck.ck-balloon-panel[class*=arrow_s]:after,.ck.ck-balloon-panel[class*=arrow_s]:before{border-left-width:var(--ck-balloon-arrow-half-width);border-bottom-width:0;border-right-width:var(--ck-balloon-arrow-half-width);border-top-width:var(--ck-balloon-arrow-height)}.ck.ck-balloon-panel[class*=arrow_s]:before{border-top-color:var(--ck-color-panel-border)}.ck.ck-balloon-panel[class*=arrow_s]:after,.ck.ck-balloon-panel[class*=arrow_s]:before{border-left-color:transparent;border-bottom-color:transparent;border-right-color:transparent}.ck.ck-balloon-panel[class*=arrow_s]:after{border-top-color:var(--ck-color-panel-background);margin-bottom:var(--ck-balloon-arrow-offset)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_n:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_n:before{left:50%;margin-left:calc(-1*var(--ck-balloon-arrow-half-width));top:calc(-1*var(--ck-balloon-arrow-height))}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nw:before{left:calc(2*var(--ck-balloon-arrow-half-width));top:calc(-1*var(--ck-balloon-arrow-height))}.ck.ck-balloon-panel.ck-balloon-panel_arrow_ne:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_ne:before{right:calc(2*var(--ck-balloon-arrow-half-width));top:calc(-1*var(--ck-balloon-arrow-height))}.ck.ck-balloon-panel.ck-balloon-panel_arrow_s:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_s:before{left:50%;margin-left:calc(-1*var(--ck-balloon-arrow-half-width));bottom:calc(-1*var(--ck-balloon-arrow-height))}.ck.ck-balloon-panel.ck-balloon-panel_arrow_sw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_sw:before{left:calc(2*var(--ck-balloon-arrow-half-width));bottom:calc(-1*var(--ck-balloon-arrow-height))}.ck.ck-balloon-panel.ck-balloon-panel_arrow_se:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_se:before{right:calc(2*var(--ck-balloon-arrow-half-width));bottom:calc(-1*var(--ck-balloon-arrow-height))}.ck.ck-balloon-panel.ck-balloon-panel_arrow_sme:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_sme:before{right:25%;margin-right:calc(2*var(--ck-balloon-arrow-half-width));bottom:calc(-1*var(--ck-balloon-arrow-height))}.ck.ck-balloon-panel.ck-balloon-panel_arrow_smw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_smw:before{left:25%;margin-left:calc(2*var(--ck-balloon-arrow-half-width));bottom:calc(-1*var(--ck-balloon-arrow-height))}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nme:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nme:before{right:25%;margin-right:calc(2*var(--ck-balloon-arrow-half-width));top:calc(-1*var(--ck-balloon-arrow-height))}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nmw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nmw:before{left:25%;margin-left:calc(2*var(--ck-balloon-arrow-half-width));top:calc(-1*var(--ck-balloon-arrow-height))}'},function(t,e,n){var i=n(1),o=n(48);"string"==typeof(o=o.__esModule?o.default:o)&&(o=[[t.i,o,""]]);var r={injectType:"singletonStyleTag",attributes:{"data-cke":!0},insert:"head",singleton:!0};i(o,r);t.exports=o.locals||{}},function(t,e){t.exports=".ck .ck-link_selected{background:var(--ck-color-link-selected-background)}.ck .ck-fake-link-selection{background:var(--ck-color-link-fake-selection)}.ck .ck-fake-link-selection_collapsed{height:100%;border-right:1px solid var(--ck-color-base-text);margin-right:-1px;outline:1px solid hsla(0,0%,100%,.5)}"},function(t,e,n){var i=n(1),o=n(50);"string"==typeof(o=o.__esModule?o.default:o)&&(o=[[t.i,o,""]]);var r={injectType:"singletonStyleTag",attributes:{"data-cke":!0},insert:"head",singleton:!0};i(o,r);t.exports=o.locals||{}},function(t,e){t.exports='.ck .ck-widget .ck-widget__type-around__button{display:block;position:absolute;overflow:hidden;z-index:var(--ck-z-default)}.ck .ck-widget .ck-widget__type-around__button svg{position:absolute;top:50%;left:50%;z-index:calc(var(--ck-z-default) + 2)}.ck .ck-widget .ck-widget__type-around__button.ck-widget__type-around__button_before{top:calc(-0.5*var(--ck-widget-outline-thickness));left:min(10%,30px);transform:translateY(-50%)}.ck .ck-widget .ck-widget__type-around__button.ck-widget__type-around__button_after{bottom:calc(-0.5*var(--ck-widget-outline-thickness));right:min(10%,30px);transform:translateY(50%)}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:after,.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__button:hover:after{content:"";display:block;position:absolute;top:1px;left:1px;z-index:calc(var(--ck-z-default) + 1)}.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__fake-caret{display:none;position:absolute;left:0;right:0}.ck .ck-widget:hover>.ck-widget__type-around>.ck-widget__type-around__fake-caret{left:calc(-1*var(--ck-widget-outline-thickness));right:calc(-1*var(--ck-widget-outline-thickness))}.ck .ck-widget.ck-widget_type-around_show-fake-caret_before>.ck-widget__type-around>.ck-widget__type-around__fake-caret{top:calc(-1*var(--ck-widget-outline-thickness) - 1px);display:block}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after>.ck-widget__type-around>.ck-widget__type-around__fake-caret{bottom:calc(-1*var(--ck-widget-outline-thickness) - 1px);display:block}.ck.ck-editor__editable.ck-read-only .ck-widget__type-around,.ck.ck-editor__editable.ck-restricted-editing_mode_restricted .ck-widget__type-around{display:none}:root{--ck-widget-type-around-button-size:20px;--ck-color-widget-type-around-button-active:var(--ck-color-focus-border);--ck-color-widget-type-around-button-hover:var(--ck-color-widget-hover-border);--ck-color-widget-type-around-button-blurred-editable:var(--ck-color-widget-blurred-border);--ck-color-widget-type-around-button-radar-start-alpha:0;--ck-color-widget-type-around-button-radar-end-alpha:.3;--ck-color-widget-type-around-button-icon:var(--ck-color-base-background)}.ck .ck-widget .ck-widget__type-around__button{width:var(--ck-widget-type-around-button-size);height:var(--ck-widget-type-around-button-size);background:var(--ck-color-widget-type-around-button);border-radius:100px;transition:opacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),background var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);opacity:0;pointer-events:none}.ck .ck-widget .ck-widget__type-around__button svg{width:10px;height:8px;transform:translate(-50%,-50%);transition:transform .5s ease;margin-top:1px}.ck .ck-widget .ck-widget__type-around__button svg *{stroke-dasharray:10;stroke-dashoffset:0;fill:none;stroke:var(--ck-color-widget-type-around-button-icon);stroke-width:1.5px;stroke-linecap:round;stroke-linejoin:round}.ck .ck-widget .ck-widget__type-around__button svg line{stroke-dasharray:7}.ck .ck-widget .ck-widget__type-around__button:hover{animation:ck-widget-type-around-button-sonar 1s ease infinite}.ck .ck-widget .ck-widget__type-around__button:hover svg polyline{animation:ck-widget-type-around-arrow-dash 2s linear}.ck .ck-widget .ck-widget__type-around__button:hover svg line{animation:ck-widget-type-around-arrow-tip-dash 2s linear}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button,.ck .ck-widget:hover>.ck-widget__type-around>.ck-widget__type-around__button{opacity:1;pointer-events:auto}.ck .ck-widget:not(.ck-widget_selected)>.ck-widget__type-around>.ck-widget__type-around__button{background:var(--ck-color-widget-type-around-button-hover)}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button,.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__button:hover{background:var(--ck-color-widget-type-around-button-active)}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:after,.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__button:hover:after{width:calc(var(--ck-widget-type-around-button-size) - 2px);height:calc(var(--ck-widget-type-around-button-size) - 2px);border-radius:100px;background:linear-gradient(135deg,hsla(0,0%,100%,0),hsla(0,0%,100%,.3))}.ck .ck-widget.ck-widget_with-selection-handle>.ck-widget__type-around>.ck-widget__type-around__button_before{margin-left:20px}.ck .ck-widget .ck-widget__type-around__fake-caret{pointer-events:none;height:1px;animation:ck-widget-type-around-fake-caret-pulse 1s linear infinite normal forwards;outline:1px solid hsla(0,0%,100%,.5);background:var(--ck-color-base-text)}.ck .ck-widget.ck-widget_selected.ck-widget_type-around_show-fake-caret_after,.ck .ck-widget.ck-widget_selected.ck-widget_type-around_show-fake-caret_before{outline-color:transparent}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_selected:hover,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_selected:hover{outline-color:var(--ck-color-widget-hover-border)}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after>.ck-widget__type-around>.ck-widget__type-around__button,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before>.ck-widget__type-around>.ck-widget__type-around__button{opacity:0;pointer-events:none}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle{opacity:0}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_selected.ck-widget_with-resizer>.ck-widget__resizer,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_selected.ck-widget_with-resizer>.ck-widget__resizer{opacity:0}.ck-editor__nested-editable.ck-editor__editable_selected .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button,.ck-editor__nested-editable.ck-editor__editable_selected .ck-widget:hover>.ck-widget__type-around>.ck-widget__type-around__button{opacity:0;pointer-events:none}.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:not(:hover){background:var(--ck-color-widget-type-around-button-blurred-editable)}.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:not(:hover) svg *{stroke:#999}@keyframes ck-widget-type-around-arrow-dash{0%{stroke-dashoffset:10}20%,to{stroke-dashoffset:0}}@keyframes ck-widget-type-around-arrow-tip-dash{0%,20%{stroke-dashoffset:7}40%,to{stroke-dashoffset:0}}@keyframes ck-widget-type-around-button-sonar{0%{box-shadow:0 0 0 0 hsla(var(--ck-color-focus-border-coordinates),var(--ck-color-widget-type-around-button-radar-start-alpha))}50%{box-shadow:0 0 0 5px hsla(var(--ck-color-focus-border-coordinates),var(--ck-color-widget-type-around-button-radar-end-alpha))}to{box-shadow:0 0 0 5px hsla(var(--ck-color-focus-border-coordinates),var(--ck-color-widget-type-around-button-radar-start-alpha))}}@keyframes ck-widget-type-around-fake-caret-pulse{0%{opacity:1}49%{opacity:1}50%{opacity:0}99%{opacity:0}to{opacity:1}}'},function(t,e,n){var i=n(1),o=n(52);"string"==typeof(o=o.__esModule?o.default:o)&&(o=[[t.i,o,""]]);var r={injectType:"singletonStyleTag",attributes:{"data-cke":!0},insert:"head",singleton:!0};i(o,r);t.exports=o.locals||{}},function(t,e){t.exports=":root{--ck-color-resizer:var(--ck-color-focus-border);--ck-resizer-size:10px;--ck-resizer-border-width:1px;--ck-resizer-border-radius:2px;--ck-resizer-offset:calc(var(--ck-resizer-size)/-2 - 2px);--ck-resizer-tooltip-offset:10px;--ck-color-resizer-tooltip-background:#262626;--ck-color-resizer-tooltip-text:#f2f2f2}.ck .ck-widget,.ck .ck-widget.ck-widget_with-selection-handle{position:relative}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{position:absolute}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon{display:block}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected .ck-widget__selection-handle,.ck .ck-widget.ck-widget_with-selection-handle:hover .ck-widget__selection-handle{visibility:visible}.ck .ck-size-view{background:var(--ck-color-resizer-tooltip-background);color:var(--ck-color-resizer-tooltip-text);border:1px solid var(--ck-color-resizer-tooltip-text);border-radius:var(--ck-resizer-border-radius);font-size:var(--ck-font-size-tiny);display:block;padding:var(--ck-spacing-small)}.ck .ck-size-view.ck-orientation-bottom-left,.ck .ck-size-view.ck-orientation-bottom-right,.ck .ck-size-view.ck-orientation-top-left,.ck .ck-size-view.ck-orientation-top-right{position:absolute}.ck .ck-size-view.ck-orientation-top-left{top:var(--ck-resizer-tooltip-offset);left:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-top-right{top:var(--ck-resizer-tooltip-offset);right:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-bottom-right{bottom:var(--ck-resizer-tooltip-offset);right:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-bottom-left{bottom:var(--ck-resizer-tooltip-offset);left:var(--ck-resizer-tooltip-offset)}:root{--ck-widget-outline-thickness:3px;--ck-widget-handler-icon-size:16px;--ck-widget-handler-animation-duration:200ms;--ck-widget-handler-animation-curve:ease;--ck-color-widget-blurred-border:#dedede;--ck-color-widget-hover-border:#ffc83d;--ck-color-widget-editable-focus-background:var(--ck-color-base-background);--ck-color-widget-drag-handler-icon-color:var(--ck-color-base-background)}.ck .ck-widget{outline-width:var(--ck-widget-outline-thickness);outline-style:solid;outline-color:transparent;transition:outline-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve)}.ck .ck-widget.ck-widget_selected,.ck .ck-widget.ck-widget_selected:hover{outline:var(--ck-widget-outline-thickness) solid var(--ck-color-focus-border)}.ck .ck-widget:hover{outline-color:var(--ck-color-widget-hover-border)}.ck .ck-editor__nested-editable{border:1px solid transparent}.ck .ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck .ck-editor__nested-editable:focus{outline:none;border:var(--ck-focus-ring);box-shadow:var(--ck-inner-shadow),0 0;background-color:var(--ck-color-widget-editable-focus-background)}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{padding:4px;box-sizing:border-box;background-color:transparent;opacity:0;transition:background-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),visibility var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),opacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);border-radius:var(--ck-border-radius) var(--ck-border-radius) 0 0;transform:translateY(-100%);left:calc(0px - var(--ck-widget-outline-thickness))}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon{width:var(--ck-widget-handler-icon-size);height:var(--ck-widget-handler-icon-size);color:var(--ck-color-widget-drag-handler-icon-color)}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator{opacity:0;transition:opacity .3s var(--ck-widget-handler-animation-curve)}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle:hover .ck-icon .ck-icon__selected-indicator{opacity:1}.ck .ck-widget.ck-widget_with-selection-handle:hover .ck-widget__selection-handle{opacity:1;background-color:var(--ck-color-widget-hover-border)}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected .ck-widget__selection-handle,.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected:hover .ck-widget__selection-handle{opacity:1;background-color:var(--ck-color-focus-border)}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected .ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator,.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected:hover .ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator{opacity:1}.ck[dir=rtl] .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{left:auto;right:calc(0px - var(--ck-widget-outline-thickness))}.ck.ck-editor__editable.ck-read-only .ck-widget{transition:none}.ck.ck-editor__editable.ck-read-only .ck-widget:not(.ck-widget_selected){--ck-widget-outline-thickness:0px}.ck.ck-editor__editable.ck-read-only .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle,.ck.ck-editor__editable.ck-read-only .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle:hover{background:var(--ck-color-widget-blurred-border)}.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected:hover{outline-color:var(--ck-color-widget-blurred-border)}.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected.ck-widget_with-selection-handle .ck-widget__selection-handle,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected.ck-widget_with-selection-handle .ck-widget__selection-handle:hover,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected:hover.ck-widget_with-selection-handle .ck-widget__selection-handle,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected:hover.ck-widget_with-selection-handle .ck-widget__selection-handle:hover{background:var(--ck-color-widget-blurred-border)}.ck.ck-editor__editable>.ck-widget.ck-widget_with-selection-handle:first-child,.ck.ck-editor__editable blockquote>.ck-widget.ck-widget_with-selection-handle:first-child{margin-top:calc(1em + var(--ck-widget-handler-icon-size))}"},function(t,e,n){var i=n(1),o=n(54);"string"==typeof(o=o.__esModule?o.default:o)&&(o=[[t.i,o,""]]);var r={injectType:"singletonStyleTag",attributes:{"data-cke":!0},insert:"head",singleton:!0};i(o,r);t.exports=o.locals||{}},function(t,e){t.exports=".ck.ck-labeled-field-view .ck-labeled-field-view__status{font-size:var(--ck-font-size-small);margin-top:var(--ck-spacing-small);white-space:normal}.ck.ck-labeled-field-view .ck-labeled-field-view__status_error{color:var(--ck-color-base-error)}.ck.ck-labeled-field-view>.ck.ck-label{width:100%;text-overflow:ellipsis;overflow:hidden}"},function(t,e,n){var i=n(1),o=n(56);"string"==typeof(o=o.__esModule?o.default:o)&&(o=[[t.i,o,""]]);var r={injectType:"singletonStyleTag",attributes:{"data-cke":!0},insert:"head",singleton:!0};i(o,r);t.exports=o.locals||{}},function(t,e){t.exports=":root{--ck-input-text-width:18em}.ck.ck-input-text{border-radius:0}.ck-rounded-corners .ck.ck-input-text,.ck.ck-input-text.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-input-text{box-shadow:var(--ck-inner-shadow),0 0;background:var(--ck-color-input-background);border:1px solid var(--ck-color-input-border);padding:var(--ck-spacing-extra-tiny) var(--ck-spacing-medium);min-width:var(--ck-input-text-width);min-height:var(--ck-ui-component-min-height);transition:box-shadow .2s ease-in-out,border .2s ease-in-out}.ck.ck-input-text:focus{outline:none;border:var(--ck-focus-ring);box-shadow:var(--ck-focus-outer-shadow),var(--ck-inner-shadow)}.ck.ck-input-text[readonly]{border:1px solid var(--ck-color-input-disabled-border);background:var(--ck-color-input-disabled-background);color:var(--ck-color-input-disabled-text)}.ck.ck-input-text[readonly]:focus{box-shadow:var(--ck-focus-disabled-outer-shadow),var(--ck-inner-shadow)}.ck.ck-input-text.ck-error{border-color:var(--ck-color-input-error-border);animation:ck-text-input-shake .3s ease both}.ck.ck-input-text.ck-error:focus{box-shadow:var(--ck-focus-error-outer-shadow),var(--ck-inner-shadow)}@keyframes ck-text-input-shake{20%{transform:translateX(-2px)}40%{transform:translateX(2px)}60%{transform:translateX(-1px)}80%{transform:translateX(1px)}}"},function(t,e,n){var i=n(1),o=n(58);"string"==typeof(o=o.__esModule?o.default:o)&&(o=[[t.i,o,""]]);var r={injectType:"singletonStyleTag",attributes:{"data-cke":!0},insert:"head",singleton:!0};i(o,r);t.exports=o.locals||{}},function(t,e){t.exports=".ck.ck-text-alternative-form{display:flex;flex-direction:row;flex-wrap:nowrap}.ck.ck-text-alternative-form .ck-labeled-field-view{display:inline-block}.ck.ck-text-alternative-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-text-alternative-form{flex-wrap:wrap}.ck.ck-text-alternative-form .ck-labeled-field-view{flex-basis:100%}.ck.ck-text-alternative-form .ck-button{flex-basis:50%}}.ck.ck-text-alternative-form{padding:var(--ck-spacing-standard)}.ck.ck-text-alternative-form:focus{outline:none}[dir=ltr] .ck.ck-text-alternative-form>:not(:first-child),[dir=rtl] .ck.ck-text-alternative-form>:not(:last-child){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-text-alternative-form{padding:0;width:calc(0.8*var(--ck-input-text-width))}.ck.ck-text-alternative-form .ck-labeled-field-view{margin:var(--ck-spacing-standard) var(--ck-spacing-standard) 0}.ck.ck-text-alternative-form .ck-labeled-field-view .ck-input-text{min-width:0;width:100%}.ck.ck-text-alternative-form .ck-button{padding:var(--ck-spacing-standard);margin-top:var(--ck-spacing-standard);border-radius:0;border:0;border-top:1px solid var(--ck-color-base-border)}[dir=ltr] .ck.ck-text-alternative-form .ck-button{margin-left:0}[dir=ltr] .ck.ck-text-alternative-form .ck-button:first-of-type{border-right:1px solid var(--ck-color-base-border)}[dir=rtl] .ck.ck-text-alternative-form .ck-button{margin-left:0}[dir=rtl] .ck.ck-text-alternative-form .ck-button:last-of-type{border-right:1px solid var(--ck-color-base-border)}}"},function(t,e,n){var i=n(1),o=n(60);"string"==typeof(o=o.__esModule?o.default:o)&&(o=[[t.i,o,""]]);var r={injectType:"singletonStyleTag",attributes:{"data-cke":!0},insert:"head",singleton:!0};i(o,r);t.exports=o.locals||{}},function(t,e){t.exports=".ck .ck-balloon-rotator__navigation{display:flex;align-items:center;justify-content:center}.ck .ck-balloon-rotator__content .ck-toolbar{justify-content:center}.ck .ck-balloon-rotator__navigation{background:var(--ck-color-toolbar-background);border-bottom:1px solid var(--ck-color-toolbar-border);padding:0 var(--ck-spacing-small)}.ck .ck-balloon-rotator__navigation>*{margin-right:var(--ck-spacing-small);margin-top:var(--ck-spacing-small);margin-bottom:var(--ck-spacing-small)}.ck .ck-balloon-rotator__navigation .ck-balloon-rotator__counter{margin-right:var(--ck-spacing-standard);margin-left:var(--ck-spacing-small)}.ck .ck-balloon-rotator__content .ck.ck-annotation-wrapper{box-shadow:none}"},function(t,e,n){var i=n(1),o=n(62);"string"==typeof(o=o.__esModule?o.default:o)&&(o=[[t.i,o,""]]);var r={injectType:"singletonStyleTag",attributes:{"data-cke":!0},insert:"head",singleton:!0};i(o,r);t.exports=o.locals||{}},function(t,e){t.exports=".ck .ck-fake-panel{position:absolute;z-index:calc(var(--ck-z-modal) - 1)}.ck .ck-fake-panel div{position:absolute}.ck .ck-fake-panel div:first-child{z-index:2}.ck .ck-fake-panel div:nth-child(2){z-index:1}:root{--ck-balloon-fake-panel-offset-horizontal:6px;--ck-balloon-fake-panel-offset-vertical:6px}.ck .ck-fake-panel div{box-shadow:var(--ck-drop-shadow),0 0;min-height:15px;background:var(--ck-color-panel-background);border:1px solid var(--ck-color-panel-border);border-radius:var(--ck-border-radius);width:100%;height:100%}.ck .ck-fake-panel div:first-child{margin-left:var(--ck-balloon-fake-panel-offset-horizontal);margin-top:var(--ck-balloon-fake-panel-offset-vertical)}.ck .ck-fake-panel div:nth-child(2){margin-left:calc(var(--ck-balloon-fake-panel-offset-horizontal)*2);margin-top:calc(var(--ck-balloon-fake-panel-offset-vertical)*2)}.ck .ck-fake-panel div:nth-child(3){margin-left:calc(var(--ck-balloon-fake-panel-offset-horizontal)*3);margin-top:calc(var(--ck-balloon-fake-panel-offset-vertical)*3)}.ck .ck-balloon-panel_arrow_s+.ck-fake-panel,.ck .ck-balloon-panel_arrow_se+.ck-fake-panel,.ck .ck-balloon-panel_arrow_sw+.ck-fake-panel{--ck-balloon-fake-panel-offset-vertical:-6px}"},function(t,e,n){var i=n(1),o=n(64);"string"==typeof(o=o.__esModule?o.default:o)&&(o=[[t.i,o,""]]);var r={injectType:"singletonStyleTag",attributes:{"data-cke":!0},insert:"head",singleton:!0};i(o,r);t.exports=o.locals||{}},function(t,e){t.exports=".ck-content .image{display:table;clear:both;text-align:center;margin:1em auto}.ck-content .image img{display:block;margin:0 auto;max-width:100%;min-width:50px}"},function(t,e,n){var i=n(1),o=n(66);"string"==typeof(o=o.__esModule?o.default:o)&&(o=[[t.i,o,""]]);var r={injectType:"singletonStyleTag",attributes:{"data-cke":!0},insert:"head",singleton:!0};i(o,r);t.exports=o.locals||{}},function(t,e){t.exports=".ck.ck-editor__editable .image{position:relative}.ck.ck-editor__editable .image .ck-progress-bar{position:absolute;top:0;left:0}.ck.ck-editor__editable .image.ck-appear{animation:fadeIn .7s}.ck.ck-editor__editable .image .ck-progress-bar{height:2px;width:0;background:var(--ck-color-upload-bar-background);transition:width .1s}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}"},function(t,e,n){var i=n(1),o=n(68);"string"==typeof(o=o.__esModule?o.default:o)&&(o=[[t.i,o,""]]);var r={injectType:"singletonStyleTag",attributes:{"data-cke":!0},insert:"head",singleton:!0};i(o,r);t.exports=o.locals||{}},function(t,e){t.exports='.ck-image-upload-complete-icon{display:block;position:absolute;top:10px;right:10px;border-radius:50%}.ck-image-upload-complete-icon:after{content:"";position:absolute}:root{--ck-color-image-upload-icon:#fff;--ck-color-image-upload-icon-background:#008a00;--ck-image-upload-icon-size:20px;--ck-image-upload-icon-width:2px}.ck-image-upload-complete-icon{width:var(--ck-image-upload-icon-size);height:var(--ck-image-upload-icon-size);opacity:0;background:var(--ck-color-image-upload-icon-background);animation-name:ck-upload-complete-icon-show,ck-upload-complete-icon-hide;animation-fill-mode:forwards,forwards;animation-duration:.5s,.5s;font-size:var(--ck-image-upload-icon-size);animation-delay:0ms,3s}.ck-image-upload-complete-icon:after{left:25%;top:50%;opacity:0;height:0;width:0;transform:scaleX(-1) rotate(135deg);transform-origin:left top;border-top:var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);border-right:var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);animation-name:ck-upload-complete-icon-check;animation-duration:.5s;animation-delay:.5s;animation-fill-mode:forwards;box-sizing:border-box}@keyframes ck-upload-complete-icon-show{0%{opacity:0}to{opacity:1}}@keyframes ck-upload-complete-icon-hide{0%{opacity:1}to{opacity:0}}@keyframes ck-upload-complete-icon-check{0%{opacity:1;width:0;height:0}33%{width:.3em;height:0}to{opacity:1;width:.3em;height:.45em}}'},function(t,e,n){var i=n(1),o=n(70);"string"==typeof(o=o.__esModule?o.default:o)&&(o=[[t.i,o,""]]);var r={injectType:"singletonStyleTag",attributes:{"data-cke":!0},insert:"head",singleton:!0};i(o,r);t.exports=o.locals||{}},function(t,e){t.exports='.ck .ck-upload-placeholder-loader{position:absolute;display:flex;align-items:center;justify-content:center;top:0;left:0}.ck .ck-upload-placeholder-loader:before{content:"";position:relative}:root{--ck-color-upload-placeholder-loader:#b3b3b3;--ck-upload-placeholder-loader-size:32px}.ck .ck-image-upload-placeholder{width:100%;margin:0}.ck .ck-upload-placeholder-loader{width:100%;height:100%}.ck .ck-upload-placeholder-loader:before{width:var(--ck-upload-placeholder-loader-size);height:var(--ck-upload-placeholder-loader-size);border-radius:50%;border-top:3px solid var(--ck-color-upload-placeholder-loader);border-right:2px solid transparent;animation:ck-upload-placeholder-loader 1s linear infinite}@keyframes ck-upload-placeholder-loader{to{transform:rotate(1turn)}}'},function(t,e){t.exports=".ck.ck-heading_heading1{font-size:20px}.ck.ck-heading_heading2{font-size:17px}.ck.ck-heading_heading3{font-size:14px}.ck[class*=ck-heading_heading]{font-weight:700}.ck.ck-dropdown.ck-heading-dropdown .ck-dropdown__button .ck-button__label{width:8em}.ck.ck-dropdown.ck-heading-dropdown .ck-dropdown__panel .ck-list__item{min-width:18em}"},function(t,e,n){var i=n(1),o=n(73);"string"==typeof(o=o.__esModule?o.default:o)&&(o=[[t.i,o,""]]);var r={injectType:"singletonStyleTag",attributes:{"data-cke":!0},insert:"head",singleton:!0};i(o,r);t.exports=o.locals||{}},function(t,e){t.exports=".ck-content .image>figcaption{display:table-caption;caption-side:bottom;word-break:break-word;color:#333;background-color:#f7f7f7;padding:.6em;font-size:.75em;outline-offset:-1px}"},function(t,e,n){var i=n(1),o=n(75);"string"==typeof(o=o.__esModule?o.default:o)&&(o=[[t.i,o,""]]);var r={injectType:"singletonStyleTag",attributes:{"data-cke":!0},insert:"head",singleton:!0};i(o,r);t.exports=o.locals||{}},function(t,e){t.exports=":root{--ck-image-style-spacing:1.5em}.ck-content .image-style-align-center,.ck-content .image-style-align-left,.ck-content .image-style-align-right,.ck-content .image-style-side{max-width:50%}.ck-content .image-style-side{float:right;margin-left:var(--ck-image-style-spacing)}.ck-content .image-style-align-left{float:left;margin-right:var(--ck-image-style-spacing)}.ck-content .image-style-align-center{margin-left:auto;margin-right:auto}.ck-content .image-style-align-right{float:right;margin-left:var(--ck-image-style-spacing)}"},function(t,e,n){var i=n(1),o=n(77);"string"==typeof(o=o.__esModule?o.default:o)&&(o=[[t.i,o,""]]);var r={injectType:"singletonStyleTag",attributes:{"data-cke":!0},insert:"head",singleton:!0};i(o,r);t.exports=o.locals||{}},function(t,e){t.exports=".ck.ck-link-form{display:flex}.ck.ck-link-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-link-form{flex-wrap:wrap}.ck.ck-link-form .ck-labeled-field-view{flex-basis:100%}.ck.ck-link-form .ck-button{flex-basis:50%}}.ck.ck-link-form_layout-vertical{display:block}.ck.ck-link-form{padding:var(--ck-spacing-standard)}.ck.ck-link-form:focus{outline:none}[dir=ltr] .ck.ck-link-form>:not(:first-child),[dir=rtl] .ck.ck-link-form>:not(:last-child){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-link-form{padding:0;width:calc(0.8*var(--ck-input-text-width))}.ck.ck-link-form .ck-labeled-field-view{margin:var(--ck-spacing-standard) var(--ck-spacing-standard) 0}.ck.ck-link-form .ck-labeled-field-view .ck-input-text{min-width:0;width:100%}.ck.ck-link-form .ck-button{padding:var(--ck-spacing-standard);margin-top:var(--ck-spacing-standard);border-radius:0;border:0;border-top:1px solid var(--ck-color-base-border)}[dir=ltr] .ck.ck-link-form .ck-button{margin-left:0}[dir=ltr] .ck.ck-link-form .ck-button:first-of-type{border-right:1px solid var(--ck-color-base-border)}[dir=rtl] .ck.ck-link-form .ck-button{margin-left:0}[dir=rtl] .ck.ck-link-form .ck-button:last-of-type{border-right:1px solid var(--ck-color-base-border)}}.ck.ck-link-form_layout-vertical{padding:0;min-width:var(--ck-input-text-width)}.ck.ck-link-form_layout-vertical .ck-labeled-field-view{margin:var(--ck-spacing-standard) var(--ck-spacing-standard) var(--ck-spacing-small)}.ck.ck-link-form_layout-vertical .ck-labeled-field-view .ck-input-text{min-width:0;width:100%}.ck.ck-link-form_layout-vertical .ck-button{padding:var(--ck-spacing-standard);margin:0;border-radius:0;border:0;border-top:1px solid var(--ck-color-base-border);width:50%}[dir=ltr] .ck.ck-link-form_layout-vertical .ck-button{margin-left:0}[dir=ltr] .ck.ck-link-form_layout-vertical .ck-button:first-of-type{border-right:1px solid var(--ck-color-base-border)}[dir=rtl] .ck.ck-link-form_layout-vertical .ck-button{margin-left:0}[dir=rtl] .ck.ck-link-form_layout-vertical .ck-button:last-of-type{border-right:1px solid var(--ck-color-base-border)}.ck.ck-link-form_layout-vertical .ck.ck-list{margin-left:0}.ck.ck-link-form_layout-vertical .ck.ck-list .ck-button.ck-switchbutton{border:0;width:100%}.ck.ck-link-form_layout-vertical .ck.ck-list .ck-button.ck-switchbutton:hover{background:none}"},function(t,e,n){var i=n(1),o=n(79);"string"==typeof(o=o.__esModule?o.default:o)&&(o=[[t.i,o,""]]);var r={injectType:"singletonStyleTag",attributes:{"data-cke":!0},insert:"head",singleton:!0};i(o,r);t.exports=o.locals||{}},function(t,e){t.exports=".ck.ck-link-actions{display:flex;flex-direction:row;flex-wrap:nowrap}.ck.ck-link-actions .ck-link-actions__preview{display:inline-block}.ck.ck-link-actions .ck-link-actions__preview .ck-button__label{overflow:hidden}@media screen and (max-width:600px){.ck.ck-link-actions{flex-wrap:wrap}.ck.ck-link-actions .ck-link-actions__preview{flex-basis:100%}.ck.ck-link-actions .ck-button:not(.ck-link-actions__preview){flex-basis:50%}}.ck.ck-link-actions{padding:var(--ck-spacing-standard)}.ck.ck-link-actions .ck-button.ck-link-actions__preview{padding-left:0;padding-right:0}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label{padding:0 var(--ck-spacing-medium);color:var(--ck-color-link-default);text-overflow:ellipsis;cursor:pointer;max-width:var(--ck-input-text-width);min-width:3em;text-align:center}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label:hover{text-decoration:underline}.ck.ck-link-actions .ck-button.ck-link-actions__preview,.ck.ck-link-actions .ck-button.ck-link-actions__preview:active,.ck.ck-link-actions .ck-button.ck-link-actions__preview:focus,.ck.ck-link-actions .ck-button.ck-link-actions__preview:hover{background:none}.ck.ck-link-actions .ck-button.ck-link-actions__preview:active{box-shadow:none}.ck.ck-link-actions .ck-button.ck-link-actions__preview:focus .ck-button__label{text-decoration:underline}.ck.ck-link-actions:focus{outline:none}[dir=ltr] .ck.ck-link-actions .ck-button:not(:first-child),[dir=rtl] .ck.ck-link-actions .ck-button:not(:last-child){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-link-actions{padding:0;width:calc(0.8*var(--ck-input-text-width))}.ck.ck-link-actions .ck-button.ck-link-actions__preview{margin:var(--ck-spacing-standard) var(--ck-spacing-standard) 0}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label{min-width:0;max-width:100%}.ck.ck-link-actions .ck-button:not(.ck-link-actions__preview){padding:var(--ck-spacing-standard);margin-top:var(--ck-spacing-standard);border-radius:0;border:0;border-top:1px solid var(--ck-color-base-border)}[dir=ltr] .ck.ck-link-actions .ck-button:not(.ck-link-actions__preview){margin-left:0}[dir=ltr] .ck.ck-link-actions .ck-button:not(.ck-link-actions__preview):first-of-type{border-right:1px solid var(--ck-color-base-border)}[dir=rtl] .ck.ck-link-actions .ck-button:not(.ck-link-actions__preview){margin-left:0}[dir=rtl] .ck.ck-link-actions .ck-button:not(.ck-link-actions__preview):last-of-type{border-right:1px solid var(--ck-color-base-border)}}"},function(t,e,n){var i=n(1),o=n(81);"string"==typeof(o=o.__esModule?o.default:o)&&(o=[[t.i,o,""]]);var r={injectType:"singletonStyleTag",attributes:{"data-cke":!0},insert:"head",singleton:!0};i(o,r);t.exports=o.locals||{}},function(t,e){t.exports='.ck-media__wrapper .ck-media__placeholder{display:flex;flex-direction:column;align-items:center}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url .ck-tooltip{display:block}@media (hover:none){.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url .ck-tooltip{display:none}}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url{max-width:100%;position:relative}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url:hover .ck-tooltip{visibility:visible;opacity:1}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url .ck-media__placeholder__url__text{overflow:hidden;display:block}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="google.com/maps"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck-media__placeholder__icon *{display:none}.ck-editor__editable:not(.ck-read-only) .ck-media__wrapper>:not(.ck-media__placeholder),.ck-editor__editable:not(.ck-read-only) .ck-widget:not(.ck-widget_selected) .ck-media__placeholder{pointer-events:none}:root{--ck-media-embed-placeholder-icon-size:3em;--ck-color-media-embed-placeholder-url-text:#757575;--ck-color-media-embed-placeholder-url-text-hover:var(--ck-color-base-text)}.ck-media__wrapper{margin:0 auto}.ck-media__wrapper .ck-media__placeholder{padding:calc(3*var(--ck-spacing-standard));background:var(--ck-color-base-foreground)}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__icon{min-width:var(--ck-media-embed-placeholder-icon-size);height:var(--ck-media-embed-placeholder-icon-size);margin-bottom:var(--ck-spacing-large);background-position:50%;background-size:cover}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__icon .ck-icon{width:100%;height:100%}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url__text{color:var(--ck-color-media-embed-placeholder-url-text);white-space:nowrap;text-align:center;font-style:italic;text-overflow:ellipsis}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:var(--ck-color-media-embed-placeholder-url-text-hover);cursor:pointer;text-decoration:underline}.ck-media__wrapper[data-oembed-url*="open.spotify.com"]{max-width:300px;max-height:380px}.ck-media__wrapper[data-oembed-url*="google.com/maps"] .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,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)}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder{background:#4268b3}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAyNCIgaGVpZ2h0PSIxMDI0IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik05NjcuNDg0IDBINTYuNTE3QzI1LjMwNCAwIDAgMjUuMzA0IDAgNTYuNTE3djkxMC45NjZDMCA5OTguNjk0IDI1LjI5NyAxMDI0IDU2LjUyMiAxMDI0SDU0N1Y2MjhINDE0VjQ3M2gxMzNWMzU5LjAyOWMwLTEzMi4yNjIgODAuNzczLTIwNC4yODIgMTk4Ljc1Ni0yMDQuMjgyIDU2LjUxMyAwIDEwNS4wODYgNC4yMDggMTE5LjI0NCA2LjA4OVYyOTlsLTgxLjYxNi4wMzdjLTYzLjk5MyAwLTc2LjM4NCAzMC40OTItNzYuMzg0IDc1LjIzNlY0NzNoMTUzLjQ4N2wtMTkuOTg2IDE1NUg3MDd2Mzk2aDI2MC40ODRjMzEuMjEzIDAgNTYuNTE2LTI1LjMwMyA1Ni41MTYtNTYuNTE2VjU2LjUxNUMxMDI0IDI1LjMwMyA5OTguNjk3IDAgOTY3LjQ4NCAwIiBmaWxsPSIjRkZGRkZFIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=)}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__url__text{color:#cdf}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder{background:linear-gradient(-135deg,#1400c7,#b800b1,#f50000)}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,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)}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__url__text{color:#ffe0fe}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder{background:linear-gradient(90deg,#71c6f4,#0d70a5)}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MDAgNDAwIj48cGF0aCBkPSJNNDAwIDIwMGMwIDExMC41LTg5LjUgMjAwLTIwMCAyMDBTMCAzMTAuNSAwIDIwMCA4OS41IDAgMjAwIDBzMjAwIDg5LjUgMjAwIDIwMHpNMTYzLjQgMzA1LjVjODguNyAwIDEzNy4yLTczLjUgMTM3LjItMTM3LjIgMC0yLjEgMC00LjItLjEtNi4yIDkuNC02LjggMTcuNi0xNS4zIDI0LjEtMjUtOC42IDMuOC0xNy45IDYuNC0yNy43IDcuNiAxMC02IDE3LjYtMTUuNCAyMS4yLTI2LjctOS4zIDUuNS0xOS42IDkuNS0zMC42IDExLjctOC44LTkuNC0yMS4zLTE1LjItMzUuMi0xNS4yLTI2LjYgMC00OC4yIDIxLjYtNDguMiA0OC4yIDAgMy44LjQgNy41IDEuMyAxMS00MC4xLTItNzUuNi0yMS4yLTk5LjQtNTAuNC00LjEgNy4xLTYuNSAxNS40LTYuNSAyNC4yIDAgMTYuNyA4LjUgMzEuNSAyMS41IDQwLjEtNy45LS4yLTE1LjMtMi40LTIxLjgtNnYuNmMwIDIzLjQgMTYuNiA0Mi44IDM4LjcgNDcuMy00IDEuMS04LjMgMS43LTEyLjcgMS43LTMuMSAwLTYuMS0uMy05LjEtLjkgNi4xIDE5LjIgMjMuOSAzMy4xIDQ1IDMzLjUtMTYuNSAxMi45LTM3LjMgMjAuNi01OS45IDIwLjYtMy45IDAtNy43LS4yLTExLjUtLjcgMjEuMSAxMy44IDQ2LjUgMjEuOCA3My43IDIxLjgiIGZpbGw9IiNmZmYiLz48L3N2Zz4=)}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__url__text{color:#b8e6ff}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}'},function(t,e,n){var i=n(1),o=n(83);"string"==typeof(o=o.__esModule?o.default:o)&&(o=[[t.i,o,""]]);var r={injectType:"singletonStyleTag",attributes:{"data-cke":!0},insert:"head",singleton:!0};i(o,r);t.exports=o.locals||{}},function(t,e){t.exports=".ck.ck-media-form{display:flex;align-items:flex-start;flex-direction:row;flex-wrap:nowrap}.ck.ck-media-form .ck-labeled-field-view{display:inline-block}.ck.ck-media-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-media-form{flex-wrap:wrap}.ck.ck-media-form .ck-labeled-field-view{flex-basis:100%}.ck.ck-media-form .ck-button{flex-basis:50%}}.ck.ck-media-form{padding:var(--ck-spacing-standard)}.ck.ck-media-form:focus{outline:none}[dir=ltr] .ck.ck-media-form>:not(:first-child),[dir=rtl] .ck.ck-media-form>:not(:last-child){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-media-form{padding:0;width:calc(0.8*var(--ck-input-text-width))}.ck.ck-media-form .ck-labeled-field-view{margin:var(--ck-spacing-standard) var(--ck-spacing-standard) 0}.ck.ck-media-form .ck-labeled-field-view .ck-input-text{min-width:0;width:100%}.ck.ck-media-form .ck-labeled-field-view .ck-labeled-field-view__error{white-space:normal}.ck.ck-media-form .ck-button{padding:var(--ck-spacing-standard);margin-top:var(--ck-spacing-standard);border-radius:0;border:0;border-top:1px solid var(--ck-color-base-border)}[dir=ltr] .ck.ck-media-form .ck-button{margin-left:0}[dir=ltr] .ck.ck-media-form .ck-button:first-of-type{border-right:1px solid var(--ck-color-base-border)}[dir=rtl] .ck.ck-media-form .ck-button{margin-left:0}[dir=rtl] .ck.ck-media-form .ck-button:last-of-type{border-right:1px solid var(--ck-color-base-border)}}"},function(t,e,n){var i=n(1),o=n(85);"string"==typeof(o=o.__esModule?o.default:o)&&(o=[[t.i,o,""]]);var r={injectType:"singletonStyleTag",attributes:{"data-cke":!0},insert:"head",singleton:!0};i(o,r);t.exports=o.locals||{}},function(t,e){t.exports=".ck-content .media{clear:both;margin:1em 0;display:block;min-width:15em}"},function(t,e,n){var i=n(1),o=n(87);"string"==typeof(o=o.__esModule?o.default:o)&&(o=[[t.i,o,""]]);var r={injectType:"singletonStyleTag",attributes:{"data-cke":!0},insert:"head",singleton:!0};i(o,r);t.exports=o.locals||{}},function(t,e){t.exports=":root{--ck-color-table-focused-cell-background:rgba(158,207,250,0.3)}.ck-widget.table td.ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck-widget.table td.ck-editor__nested-editable:focus,.ck-widget.table th.ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck-widget.table th.ck-editor__nested-editable:focus{background:var(--ck-color-table-focused-cell-background);border-style:none;outline:1px solid var(--ck-color-focus-border);outline-offset:-1px}"},function(t,e,n){var i=n(1),o=n(89);"string"==typeof(o=o.__esModule?o.default:o)&&(o=[[t.i,o,""]]);var r={injectType:"singletonStyleTag",attributes:{"data-cke":!0},insert:"head",singleton:!0};i(o,r);t.exports=o.locals||{}},function(t,e){t.exports=".ck.ck-splitbutton{font-size:inherit}.ck.ck-splitbutton .ck-splitbutton__action:focus{z-index:calc(var(--ck-z-default) + 1)}.ck.ck-splitbutton.ck-splitbutton_open>.ck-button .ck-tooltip{display:none}:root{--ck-color-split-button-hover-background:#ebebeb;--ck-color-split-button-hover-border:#b3b3b3}[dir=ltr] .ck.ck-splitbutton>.ck-splitbutton__action{border-top-right-radius:unset;border-bottom-right-radius:unset}[dir=rtl] .ck.ck-splitbutton>.ck-splitbutton__action{border-top-left-radius:unset;border-bottom-left-radius:unset}.ck.ck-splitbutton>.ck-splitbutton__arrow{min-width:unset}[dir=ltr] .ck.ck-splitbutton>.ck-splitbutton__arrow{border-radius:0}.ck-rounded-corners [dir=ltr] .ck.ck-splitbutton>.ck-splitbutton__arrow,[dir=ltr] .ck.ck-splitbutton>.ck-splitbutton__arrow.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:unset;border-bottom-left-radius:unset}[dir=rtl] .ck.ck-splitbutton>.ck-splitbutton__arrow{border-top-right-radius:unset;border-bottom-right-radius:unset}.ck.ck-splitbutton>.ck-splitbutton__arrow svg{width:var(--ck-dropdown-arrow-size)}.ck.ck-splitbutton.ck-splitbutton_open>.ck-button:not(.ck-on):not(.ck-disabled):not(:hover),.ck.ck-splitbutton:hover>.ck-button:not(.ck-on):not(.ck-disabled):not(:hover){background:var(--ck-color-split-button-hover-background)}[dir=ltr] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled),[dir=ltr] .ck.ck-splitbutton:hover>.ck-splitbutton__arrow:not(.ck-disabled){border-left-color:var(--ck-color-split-button-hover-border)}[dir=rtl] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled),[dir=rtl] .ck.ck-splitbutton:hover>.ck-splitbutton__arrow:not(.ck-disabled){border-right-color:var(--ck-color-split-button-hover-border)}.ck.ck-splitbutton.ck-splitbutton_open{border-radius:0}.ck-rounded-corners .ck.ck-splitbutton.ck-splitbutton_open,.ck.ck-splitbutton.ck-splitbutton_open.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck-rounded-corners .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__action,.ck.ck-splitbutton.ck-splitbutton_open.ck-rounded-corners>.ck-splitbutton__action{border-bottom-left-radius:0}.ck-rounded-corners .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow,.ck.ck-splitbutton.ck-splitbutton_open.ck-rounded-corners>.ck-splitbutton__arrow{border-bottom-right-radius:0}"},function(t,e,n){var i=n(1),o=n(91);"string"==typeof(o=o.__esModule?o.default:o)&&(o=[[t.i,o,""]]);var r={injectType:"singletonStyleTag",attributes:{"data-cke":!0},insert:"head",singleton:!0};i(o,r);t.exports=o.locals||{}},function(t,e){t.exports=".ck .ck-insert-table-dropdown__grid{display:flex;flex-direction:row;flex-wrap:wrap}:root{--ck-insert-table-dropdown-padding:10px;--ck-insert-table-dropdown-box-height:11px;--ck-insert-table-dropdown-box-width:12px;--ck-insert-table-dropdown-box-margin:1px}.ck .ck-insert-table-dropdown__grid{width:calc(var(--ck-insert-table-dropdown-box-width)*10 + var(--ck-insert-table-dropdown-box-margin)*20 + var(--ck-insert-table-dropdown-padding)*2);padding:var(--ck-insert-table-dropdown-padding) var(--ck-insert-table-dropdown-padding) 0}.ck .ck-insert-table-dropdown__label{text-align:center}.ck .ck-insert-table-dropdown-grid-box{width:var(--ck-insert-table-dropdown-box-width);height:var(--ck-insert-table-dropdown-box-height);margin:var(--ck-insert-table-dropdown-box-margin);border:1px solid var(--ck-color-base-border);border-radius:1px}.ck .ck-insert-table-dropdown-grid-box.ck-on{border-color:var(--ck-color-focus-border);background:var(--ck-color-focus-outer-shadow)}"},function(t,e,n){var i=n(1),o=n(93);"string"==typeof(o=o.__esModule?o.default:o)&&(o=[[t.i,o,""]]);var r={injectType:"singletonStyleTag",attributes:{"data-cke":!0},insert:"head",singleton:!0};i(o,r);t.exports=o.locals||{}},function(t,e){t.exports=':root{--ck-table-selected-cell-background:rgba(158,207,250,0.3)}.ck.ck-editor__editable .table table td.ck-editor__editable_selected,.ck.ck-editor__editable .table table th.ck-editor__editable_selected{position:relative;caret-color:transparent;outline:unset;box-shadow:unset}.ck.ck-editor__editable .table table td.ck-editor__editable_selected:after,.ck.ck-editor__editable .table table th.ck-editor__editable_selected:after{content:"";pointer-events:none;background-color:var(--ck-table-selected-cell-background);position:absolute;top:0;left:0;right:0;bottom:0}.ck.ck-editor__editable .table table td.ck-editor__editable_selected ::selection,.ck.ck-editor__editable .table table td.ck-editor__editable_selected:focus,.ck.ck-editor__editable .table table th.ck-editor__editable_selected ::selection,.ck.ck-editor__editable .table table th.ck-editor__editable_selected:focus{background-color:transparent}.ck.ck-editor__editable .table table td.ck-editor__editable_selected .ck-widget_selected,.ck.ck-editor__editable .table table th.ck-editor__editable_selected .ck-widget_selected{outline:unset}'},function(t,e,n){var i=n(1),o=n(95);"string"==typeof(o=o.__esModule?o.default:o)&&(o=[[t.i,o,""]]);var r={injectType:"singletonStyleTag",attributes:{"data-cke":!0},insert:"head",singleton:!0};i(o,r);t.exports=o.locals||{}},function(t,e){t.exports=".ck-content .table{margin:1em auto;display:table}.ck-content .table table{border-collapse:collapse;border-spacing:0;width:100%;height:100%;border:1px double #b3b3b3}.ck-content .table table td,.ck-content .table table th{min-width:2em;padding:.4em;border:1px solid #bfbfbf}.ck-content .table table th{font-weight:700;background:hsla(0,0%,0%,5%)}.ck-content[dir=rtl] .table th{text-align:right}.ck-content[dir=ltr] .table th{text-align:left}"},function(t,e,n){"use strict";n.r(e),n.d(e,"default",(function(){return pb}));var i=n(3),o=i.a.Symbol,r=Object.prototype,s=r.hasOwnProperty,a=r.toString,c=o?o.toStringTag:void 0;var l=function(t){var e=s.call(t,c),n=t[c];try{t[c]=void 0;var i=!0}catch(t){}var o=a.call(t);return i&&(e?t[c]=n:delete t[c]),o},d=Object.prototype.toString;var u=function(t){return d.call(t)},h=o?o.toStringTag:void 0;var f=function(t){return null==t?void 0===t?"[object Undefined]":"[object Null]":h&&h in Object(t)?l(t):u(t)};var g=function(t,e){return function(n){return t(e(n))}},m=g(Object.getPrototypeOf,Object);var p=function(t){return null!=t&&"object"==typeof t},b=Function.prototype,w=Object.prototype,k=b.toString,_=w.hasOwnProperty,v=k.call(Object);var y=function(t){if(!p(t)||"[object Object]"!=f(t))return!1;var e=m(t);if(null===e)return!0;var n=_.call(e,"constructor")&&e.constructor;return"function"==typeof n&&n instanceof n&&k.call(n)==v};var x=function(){this.__data__=[],this.size=0};var A=function(t,e){return t===e||t!=t&&e!=e};var C=function(t,e){for(var n=t.length;n--;)if(A(t[n][0],e))return n;return-1},T=Array.prototype.splice;var P=function(t){var e=this.__data__,n=C(e,t);return!(n<0)&&(n==e.length-1?e.pop():T.call(e,n,1),--this.size,!0)};var S=function(t){var e=this.__data__,n=C(e,t);return n<0?void 0:e[n][1]};var E=function(t){return C(this.__data__,t)>-1};var M=function(t,e){var n=this.__data__,i=C(n,t);return i<0?(++this.size,n.push([t,e])):n[i][1]=e,this};function I(t){var e=-1,n=null==t?0:t.length;for(this.clear();++e<n;){var i=t[e];this.set(i[0],i[1])}}I.prototype.clear=x,I.prototype.delete=P,I.prototype.get=S,I.prototype.has=E,I.prototype.set=M;var N=I;var O=function(){this.__data__=new N,this.size=0};var R=function(t){var e=this.__data__,n=e.delete(t);return this.size=e.size,n};var D=function(t){return this.__data__.get(t)};var L=function(t){return this.__data__.has(t)};var j=function(t){var e=typeof t;return null!=t&&("object"==e||"function"==e)};var V,z=function(t){if(!j(t))return!1;var e=f(t);return"[object Function]"==e||"[object GeneratorFunction]"==e||"[object AsyncFunction]"==e||"[object Proxy]"==e},B=i.a["__core-js_shared__"],F=(V=/[^.]+$/.exec(B&&B.keys&&B.keys.IE_PROTO||""))?"Symbol(src)_1."+V:"";var U=function(t){return!!F&&F in t},H=Function.prototype.toString;var W=function(t){if(null!=t){try{return H.call(t)}catch(t){}try{return t+""}catch(t){}}return""},q=/^\[object .+?Constructor\]$/,Y=Function.prototype,G=Object.prototype,$=Y.toString,K=G.hasOwnProperty,Q=RegExp("^"+$.call(K).replace(/[\\^$.*+?()[\]{}|]/g,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$");var J=function(t){return!(!j(t)||U(t))&&(z(t)?Q:q).test(W(t))};var Z=function(t,e){return null==t?void 0:t[e]};var X=function(t,e){var n=Z(t,e);return J(n)?n:void 0},tt=X(i.a,"Map"),et=X(Object,"create");var nt=function(){this.__data__=et?et(null):{},this.size=0};var it=function(t){var e=this.has(t)&&delete this.__data__[t];return this.size-=e?1:0,e},ot=Object.prototype.hasOwnProperty;var rt=function(t){var e=this.__data__;if(et){var n=e[t];return"__lodash_hash_undefined__"===n?void 0:n}return ot.call(e,t)?e[t]:void 0},st=Object.prototype.hasOwnProperty;var at=function(t){var e=this.__data__;return et?void 0!==e[t]:st.call(e,t)};var ct=function(t,e){var n=this.__data__;return this.size+=this.has(t)?0:1,n[t]=et&&void 0===e?"__lodash_hash_undefined__":e,this};function lt(t){var e=-1,n=null==t?0:t.length;for(this.clear();++e<n;){var i=t[e];this.set(i[0],i[1])}}lt.prototype.clear=nt,lt.prototype.delete=it,lt.prototype.get=rt,lt.prototype.has=at,lt.prototype.set=ct;var dt=lt;var ut=function(){this.size=0,this.__data__={hash:new dt,map:new(tt||N),string:new dt}};var ht=function(t){var e=typeof t;return"string"==e||"number"==e||"symbol"==e||"boolean"==e?"__proto__"!==t:null===t};var ft=function(t,e){var n=t.__data__;return ht(e)?n["string"==typeof e?"string":"hash"]:n.map};var gt=function(t){var e=ft(this,t).delete(t);return this.size-=e?1:0,e};var mt=function(t){return ft(this,t).get(t)};var pt=function(t){return ft(this,t).has(t)};var bt=function(t,e){var n=ft(this,t),i=n.size;return n.set(t,e),this.size+=n.size==i?0:1,this};function wt(t){var e=-1,n=null==t?0:t.length;for(this.clear();++e<n;){var i=t[e];this.set(i[0],i[1])}}wt.prototype.clear=ut,wt.prototype.delete=gt,wt.prototype.get=mt,wt.prototype.has=pt,wt.prototype.set=bt;var kt=wt;var _t=function(t,e){var n=this.__data__;if(n instanceof N){var i=n.__data__;if(!tt||i.length<199)return i.push([t,e]),this.size=++n.size,this;n=this.__data__=new kt(i)}return n.set(t,e),this.size=n.size,this};function vt(t){var e=this.__data__=new N(t);this.size=e.size}vt.prototype.clear=O,vt.prototype.delete=R,vt.prototype.get=D,vt.prototype.has=L,vt.prototype.set=_t;var yt=vt;var xt=function(t,e){for(var n=-1,i=null==t?0:t.length;++n<i&&!1!==e(t[n],n,t););return t},At=function(){try{var t=X(Object,"defineProperty");return t({},"",{}),t}catch(t){}}();var Ct=function(t,e,n){"__proto__"==e&&At?At(t,e,{configurable:!0,enumerable:!0,value:n,writable:!0}):t[e]=n},Tt=Object.prototype.hasOwnProperty;var Pt=function(t,e,n){var i=t[e];Tt.call(t,e)&&A(i,n)&&(void 0!==n||e in t)||Ct(t,e,n)};var St=function(t,e,n,i){var o=!n;n||(n={});for(var r=-1,s=e.length;++r<s;){var a=e[r],c=i?i(n[a],t[a],a,n,t):void 0;void 0===c&&(c=t[a]),o?Ct(n,a,c):Pt(n,a,c)}return n};var Et=function(t,e){for(var n=-1,i=Array(t);++n<t;)i[n]=e(n);return i};var Mt=function(t){return p(t)&&"[object Arguments]"==f(t)},It=Object.prototype,Nt=It.hasOwnProperty,Ot=It.propertyIsEnumerable,Rt=Mt(function(){return arguments}())?Mt:function(t){return p(t)&&Nt.call(t,"callee")&&!Ot.call(t,"callee")},Dt=Array.isArray,Lt=n(4),jt=/^(?:0|[1-9]\d*)$/;var Vt=function(t,e){var n=typeof t;return!!(e=null==e?9007199254740991:e)&&("number"==n||"symbol"!=n&&jt.test(t))&&t>-1&&t%1==0&&t<e};var zt=function(t){return"number"==typeof t&&t>-1&&t%1==0&&t<=9007199254740991},Bt={};Bt["[object Float32Array]"]=Bt["[object Float64Array]"]=Bt["[object Int8Array]"]=Bt["[object Int16Array]"]=Bt["[object Int32Array]"]=Bt["[object Uint8Array]"]=Bt["[object Uint8ClampedArray]"]=Bt["[object Uint16Array]"]=Bt["[object Uint32Array]"]=!0,Bt["[object Arguments]"]=Bt["[object Array]"]=Bt["[object ArrayBuffer]"]=Bt["[object Boolean]"]=Bt["[object DataView]"]=Bt["[object Date]"]=Bt["[object Error]"]=Bt["[object Function]"]=Bt["[object Map]"]=Bt["[object Number]"]=Bt["[object Object]"]=Bt["[object RegExp]"]=Bt["[object Set]"]=Bt["[object String]"]=Bt["[object WeakMap]"]=!1;var Ft=function(t){return p(t)&&zt(t.length)&&!!Bt[f(t)]};var Ut=function(t){return function(e){return t(e)}},Ht=n(5),Wt=Ht.a&&Ht.a.isTypedArray,qt=Wt?Ut(Wt):Ft,Yt=Object.prototype.hasOwnProperty;var Gt=function(t,e){var n=Dt(t),i=!n&&Rt(t),o=!n&&!i&&Object(Lt.a)(t),r=!n&&!i&&!o&&qt(t),s=n||i||o||r,a=s?Et(t.length,String):[],c=a.length;for(var l in t)!e&&!Yt.call(t,l)||s&&("length"==l||o&&("offset"==l||"parent"==l)||r&&("buffer"==l||"byteLength"==l||"byteOffset"==l)||Vt(l,c))||a.push(l);return a},$t=Object.prototype;var Kt=function(t){var e=t&&t.constructor;return t===("function"==typeof e&&e.prototype||$t)},Qt=g(Object.keys,Object),Jt=Object.prototype.hasOwnProperty;var Zt=function(t){if(!Kt(t))return Qt(t);var e=[];for(var n in Object(t))Jt.call(t,n)&&"constructor"!=n&&e.push(n);return e};var Xt=function(t){return null!=t&&zt(t.length)&&!z(t)};var te=function(t){return Xt(t)?Gt(t):Zt(t)};var ee=function(t,e){return t&&St(e,te(e),t)};var ne=function(t){var e=[];if(null!=t)for(var n in Object(t))e.push(n);return e},ie=Object.prototype.hasOwnProperty;var oe=function(t){if(!j(t))return ne(t);var e=Kt(t),n=[];for(var i in t)("constructor"!=i||!e&&ie.call(t,i))&&n.push(i);return n};var re=function(t){return Xt(t)?Gt(t,!0):oe(t)};var se=function(t,e){return t&&St(e,re(e),t)},ae=n(8);var ce=function(t,e){var n=-1,i=t.length;for(e||(e=Array(i));++n<i;)e[n]=t[n];return e};var le=function(t,e){for(var n=-1,i=null==t?0:t.length,o=0,r=[];++n<i;){var s=t[n];e(s,n,t)&&(r[o++]=s)}return r};var de=function(){return[]},ue=Object.prototype.propertyIsEnumerable,he=Object.getOwnPropertySymbols,fe=he?function(t){return null==t?[]:(t=Object(t),le(he(t),(function(e){return ue.call(t,e)})))}:de;var ge=function(t,e){return St(t,fe(t),e)};var me=function(t,e){for(var n=-1,i=e.length,o=t.length;++n<i;)t[o+n]=e[n];return t},pe=Object.getOwnPropertySymbols?function(t){for(var e=[];t;)me(e,fe(t)),t=m(t);return e}:de;var be=function(t,e){return St(t,pe(t),e)};var we=function(t,e,n){var i=e(t);return Dt(t)?i:me(i,n(t))};var ke=function(t){return we(t,te,fe)};var _e=function(t){return we(t,re,pe)},ve=X(i.a,"DataView"),ye=X(i.a,"Promise"),xe=X(i.a,"Set"),Ae=X(i.a,"WeakMap"),Ce=W(ve),Te=W(tt),Pe=W(ye),Se=W(xe),Ee=W(Ae),Me=f;(ve&&"[object DataView]"!=Me(new ve(new ArrayBuffer(1)))||tt&&"[object Map]"!=Me(new tt)||ye&&"[object Promise]"!=Me(ye.resolve())||xe&&"[object Set]"!=Me(new xe)||Ae&&"[object WeakMap]"!=Me(new Ae))&&(Me=function(t){var e=f(t),n="[object Object]"==e?t.constructor:void 0,i=n?W(n):"";if(i)switch(i){case Ce:return"[object DataView]";case Te:return"[object Map]";case Pe:return"[object Promise]";case Se:return"[object Set]";case Ee:return"[object WeakMap]"}return e});var Ie=Me,Ne=Object.prototype.hasOwnProperty;var Oe=function(t){var e=t.length,n=new t.constructor(e);return e&&"string"==typeof t[0]&&Ne.call(t,"index")&&(n.index=t.index,n.input=t.input),n},Re=i.a.Uint8Array;var De=function(t){var e=new t.constructor(t.byteLength);return new Re(e).set(new Re(t)),e};var Le=function(t,e){var n=e?De(t.buffer):t.buffer;return new t.constructor(n,t.byteOffset,t.byteLength)},je=/\w*$/;var Ve=function(t){var e=new t.constructor(t.source,je.exec(t));return e.lastIndex=t.lastIndex,e},ze=o?o.prototype:void 0,Be=ze?ze.valueOf:void 0;var Fe=function(t){return Be?Object(Be.call(t)):{}};var Ue=function(t,e){var n=e?De(t.buffer):t.buffer;return new t.constructor(n,t.byteOffset,t.length)};var He=function(t,e,n){var i=t.constructor;switch(e){case"[object ArrayBuffer]":return De(t);case"[object Boolean]":case"[object Date]":return new i(+t);case"[object DataView]":return Le(t,n);case"[object Float32Array]":case"[object Float64Array]":case"[object Int8Array]":case"[object Int16Array]":case"[object Int32Array]":case"[object Uint8Array]":case"[object Uint8ClampedArray]":case"[object Uint16Array]":case"[object Uint32Array]":return Ue(t,n);case"[object Map]":return new i;case"[object Number]":case"[object String]":return new i(t);case"[object RegExp]":return Ve(t);case"[object Set]":return new i;case"[object Symbol]":return Fe(t)}},We=Object.create,qe=function(){function t(){}return function(e){if(!j(e))return{};if(We)return We(e);t.prototype=e;var n=new t;return t.prototype=void 0,n}}();var Ye=function(t){return"function"!=typeof t.constructor||Kt(t)?{}:qe(m(t))};var Ge=function(t){return p(t)&&"[object Map]"==Ie(t)},$e=Ht.a&&Ht.a.isMap,Ke=$e?Ut($e):Ge;var Qe=function(t){return p(t)&&"[object Set]"==Ie(t)},Je=Ht.a&&Ht.a.isSet,Ze=Je?Ut(Je):Qe,Xe={};Xe["[object Arguments]"]=Xe["[object Array]"]=Xe["[object ArrayBuffer]"]=Xe["[object DataView]"]=Xe["[object Boolean]"]=Xe["[object Date]"]=Xe["[object Float32Array]"]=Xe["[object Float64Array]"]=Xe["[object Int8Array]"]=Xe["[object Int16Array]"]=Xe["[object Int32Array]"]=Xe["[object Map]"]=Xe["[object Number]"]=Xe["[object Object]"]=Xe["[object RegExp]"]=Xe["[object Set]"]=Xe["[object String]"]=Xe["[object Symbol]"]=Xe["[object Uint8Array]"]=Xe["[object Uint8ClampedArray]"]=Xe["[object Uint16Array]"]=Xe["[object Uint32Array]"]=!0,Xe["[object Error]"]=Xe["[object Function]"]=Xe["[object WeakMap]"]=!1;var tn=function t(e,n,i,o,r,s){var a,c=1&n,l=2&n,d=4&n;if(i&&(a=r?i(e,o,r,s):i(e)),void 0!==a)return a;if(!j(e))return e;var u=Dt(e);if(u){if(a=Oe(e),!c)return ce(e,a)}else{var h=Ie(e),f="[object Function]"==h||"[object GeneratorFunction]"==h;if(Object(Lt.a)(e))return Object(ae.a)(e,c);if("[object Object]"==h||"[object Arguments]"==h||f&&!r){if(a=l||f?{}:Ye(e),!c)return l?be(e,se(a,e)):ge(e,ee(a,e))}else{if(!Xe[h])return r?e:{};a=He(e,h,c)}}s||(s=new yt);var g=s.get(e);if(g)return g;s.set(e,a),Ze(e)?e.forEach((function(o){a.add(t(o,n,i,o,e,s))})):Ke(e)&&e.forEach((function(o,r){a.set(r,t(o,n,i,r,e,s))}));var m=d?l?_e:ke:l?keysIn:te,p=u?void 0:m(e);return xt(p||e,(function(o,r){p&&(o=e[r=o]),Pt(a,r,t(o,n,i,r,e,s))})),a};var en=function(t,e){return tn(t,5,e="function"==typeof e?e:void 0)};var nn=function(t){return p(t)&&1===t.nodeType&&!y(t)};class on{constructor(t,e){this._config={},e&&this.define(rn(e)),t&&this._setObjectToTarget(this._config,t)}set(t,e){this._setToTarget(this._config,t,e)}define(t,e){this._setToTarget(this._config,t,e,!0)}get(t){return this._getFromSource(this._config,t)}*names(){for(const t of Object.keys(this._config))yield t}_setToTarget(t,e,n,i=!1){if(y(e))return void this._setObjectToTarget(t,e,i);const o=e.split(".");e=o.pop();for(const e of o)y(t[e])||(t[e]={}),t=t[e];if(y(n))return y(t[e])||(t[e]={}),t=t[e],void this._setObjectToTarget(t,n,i);i&&void 0!==t[e]||(t[e]=n)}_getFromSource(t,e){const n=e.split(".");e=n.pop();for(const e of n){if(!y(t[e])){t=null;break}t=t[e]}return t?rn(t[e]):void 0}_setObjectToTarget(t,e,n){Object.keys(e).forEach(i=>{this._setToTarget(t,i,e[i],n)})}}function rn(t){return en(t,sn)}function sn(t){return nn(t)?t:void 0}var an=function(){return function t(){t.called=!0}};class cn{constructor(t,e){this.source=t,this.name=e,this.path=[],this.stop=an(),this.off=an()}}const ln=new Array(256).fill().map((t,e)=>("0"+e.toString(16)).slice(-2));function dn(){const t=4294967296*Math.random()>>>0,e=4294967296*Math.random()>>>0,n=4294967296*Math.random()>>>0,i=4294967296*Math.random()>>>0;return"e"+ln[t>>0&255]+ln[t>>8&255]+ln[t>>16&255]+ln[t>>24&255]+ln[e>>0&255]+ln[e>>8&255]+ln[e>>16&255]+ln[e>>24&255]+ln[n>>0&255]+ln[n>>8&255]+ln[n>>16&255]+ln[n>>24&255]+ln[i>>0&255]+ln[i>>8&255]+ln[i>>16&255]+ln[i>>24&255]}var un={get(t){return"number"!=typeof t?this[t]||this.normal:t},highest:1e5,high:1e3,normal:0,low:-1e3,lowest:-1e5},hn=(n(6),n(0));const fn=Symbol("listeningTo"),gn=Symbol("emitterId");var mn={on(t,e,n={}){this.listenTo(this,t,e,n)},once(t,e,n){let i=!1;this.listenTo(this,t,(function(t,...n){i||(i=!0,t.off(),e.call(this,t,...n))}),n)},off(t,e){this.stopListening(this,t,e)},listenTo(t,e,n,i={}){let o,r;this[fn]||(this[fn]={});const s=this[fn];bn(t)||pn(t);const a=bn(t);(o=s[a])||(o=s[a]={emitter:t,callbacks:{}}),(r=o.callbacks[e])||(r=o.callbacks[e]=[]),r.push(n),function(t,e){const n=wn(t);if(n[e])return;let i=e,o=null;const r=[];for(;""!==i&&!n[i];)n[i]={callbacks:[],childEvents:[]},r.push(n[i]),o&&n[i].childEvents.push(o),o=i,i=i.substr(0,i.lastIndexOf(":"));if(""!==i){for(const t of r)t.callbacks=n[i].callbacks.slice();n[i].childEvents.push(o)}}(t,e);const c=kn(t,e),l=un.get(i.priority),d={callback:n,priority:l};for(const t of c){let e=!1;for(let n=0;n<t.length;n++)if(t[n].priority<l){t.splice(n,0,d),e=!0;break}e||t.push(d)}},stopListening(t,e,n){const i=this[fn];let o=t&&bn(t);const r=i&&o&&i[o],s=r&&e&&r.callbacks[e];if(!(!i||t&&!r||e&&!s))if(n)vn(t,e,n);else if(s){for(;n=s.pop();)vn(t,e,n);delete r.callbacks[e]}else if(r){for(e in r.callbacks)this.stopListening(t,e);delete i[o]}else{for(o in i)this.stopListening(i[o].emitter);delete this[fn]}},fire(t,...e){try{const n=t instanceof cn?t:new cn(this,t),i=n.name;let o=function t(e,n){let i;if(!e._events||!(i=e._events[n])||!i.callbacks.length)return n.indexOf(":")>-1?t(e,n.substr(0,n.lastIndexOf(":"))):null;return i.callbacks}(this,i);if(n.path.push(this),o){const t=[n,...e];o=Array.from(o);for(let e=0;e<o.length&&(o[e].callback.apply(this,t),n.off.called&&(delete n.off.called,vn(this,i,o[e].callback)),!n.stop.called);e++);}if(this._delegations){const t=this._delegations.get(i),o=this._delegations.get("*");t&&_n(t,n,e),o&&_n(o,n,e)}return n.return}catch(t){hn.b.rethrowUnexpectedError(t,this)}},delegate(...t){return{to:(e,n)=>{this._delegations||(this._delegations=new Map),t.forEach(t=>{const i=this._delegations.get(t);i?i.set(e,n):this._delegations.set(t,new Map([[e,n]]))})}}},stopDelegating(t,e){if(this._delegations)if(t)if(e){const n=this._delegations.get(t);n&&n.delete(e)}else this._delegations.delete(t);else this._delegations.clear()}};function pn(t,e){t[gn]||(t[gn]=e||dn())}function bn(t){return t[gn]}function wn(t){return t._events||Object.defineProperty(t,"_events",{value:{}}),t._events}function kn(t,e){const n=wn(t)[e];if(!n)return[];let i=[n.callbacks];for(let e=0;e<n.childEvents.length;e++){const o=kn(t,n.childEvents[e]);i=i.concat(o)}return i}function _n(t,e,n){for(let[i,o]of t){o?"function"==typeof o&&(o=o(e.name)):o=e.name;const t=new cn(e.source,o);t.path=[...e.path],i.fire(t,...n)}}function vn(t,e,n){const i=kn(t,e);for(const t of i)for(let e=0;e<t.length;e++)t[e].callback==n&&(t.splice(e,1),e--)}function yn(t){return!(!t||!t[Symbol.iterator])}function xn(t,...e){e.forEach(e=>{Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e)).forEach(n=>{if(n in t.prototype)return;const i=Object.getOwnPropertyDescriptor(e,n);i.enumerable=!1,Object.defineProperty(t.prototype,n,i)})})}class An{constructor(t={},e={}){const n=yn(t);if(n||(e=t),this._items=[],this._itemMap=new Map,this._idProperty=e.idProperty||"id",this._bindToExternalToInternalMap=new WeakMap,this._bindToInternalToExternalMap=new WeakMap,this._skippedIndexesFromExternal=[],n)for(const e of t)this._items.push(e),this._itemMap.set(this._getItemIdBeforeAdding(e),e)}get length(){return this._items.length}get first(){return this._items[0]||null}get last(){return this._items[this.length-1]||null}add(t,e){const n=this._getItemIdBeforeAdding(t);if(void 0===e)e=this._items.length;else if(e>this._items.length||e<0)throw new hn.b("collection-add-item-invalid-index",this);return this._items.splice(e,0,t),this._itemMap.set(n,t),this.fire("add",t,e),this}get(t){let e;if("string"==typeof t)e=this._itemMap.get(t);else{if("number"!=typeof t)throw new hn.b("collection-get-invalid-arg: Index or id must be given.",this);e=this._items[t]}return e||null}has(t){if("string"==typeof t)return this._itemMap.has(t);{const e=t[this._idProperty];return this._itemMap.has(e)}}getIndex(t){let e;return e="string"==typeof t?this._itemMap.get(t):t,this._items.indexOf(e)}remove(t){let e,n,i,o=!1;const r=this._idProperty;if("string"==typeof t?(n=t,i=this._itemMap.get(n),o=!i,i&&(e=this._items.indexOf(i))):"number"==typeof t?(e=t,i=this._items[e],o=!i,i&&(n=i[r])):(i=t,n=i[r],e=this._items.indexOf(i),o=-1==e||!this._itemMap.get(n)),o)throw new hn.b("collection-remove-404: Item not found.",this);this._items.splice(e,1),this._itemMap.delete(n);const s=this._bindToInternalToExternalMap.get(i);return this._bindToInternalToExternalMap.delete(i),this._bindToExternalToInternalMap.delete(s),this.fire("remove",i,e),i}map(t,e){return this._items.map(t,e)}find(t,e){return this._items.find(t,e)}filter(t,e){return this._items.filter(t,e)}clear(){for(this._bindToCollection&&(this.stopListening(this._bindToCollection),this._bindToCollection=null);this.length;)this.remove(0)}bindTo(t){if(this._bindToCollection)throw new hn.b("collection-bind-to-rebind: The collection cannot be bound more than once.",this);return this._bindToCollection=t,{as:t=>{this._setUpBindToBinding(e=>new t(e))},using:t=>{"function"==typeof t?this._setUpBindToBinding(e=>t(e)):this._setUpBindToBinding(e=>e[t])}}}_setUpBindToBinding(t){const e=this._bindToCollection,n=(n,i,o)=>{const r=e._bindToCollection==this,s=e._bindToInternalToExternalMap.get(i);if(r&&s)this._bindToExternalToInternalMap.set(i,s),this._bindToInternalToExternalMap.set(s,i);else{const n=t(i);if(!n)return void this._skippedIndexesFromExternal.push(o);let r=o;for(const t of this._skippedIndexesFromExternal)o>t&&r--;for(const t of e._skippedIndexesFromExternal)r>=t&&r++;this._bindToExternalToInternalMap.set(i,n),this._bindToInternalToExternalMap.set(n,i),this.add(n,r);for(let t=0;t<e._skippedIndexesFromExternal.length;t++)r<=e._skippedIndexesFromExternal[t]&&e._skippedIndexesFromExternal[t]++}};for(const t of e)n(0,t,e.getIndex(t));this.listenTo(e,"add",n),this.listenTo(e,"remove",(t,e,n)=>{const i=this._bindToExternalToInternalMap.get(e);i&&this.remove(i),this._skippedIndexesFromExternal=this._skippedIndexesFromExternal.reduce((t,e)=>(n<e&&t.push(e-1),n>e&&t.push(e),t),[])})}_getItemIdBeforeAdding(t){const e=this._idProperty;let n;if(e in t){if(n=t[e],"string"!=typeof n)throw new hn.b("collection-add-invalid-id",this);if(this.get(n))throw new hn.b("collection-add-item-already-exists",this)}else t[e]=n=dn();return n}[Symbol.iterator](){return this._items[Symbol.iterator]()}}xn(An,mn);class Cn{constructor(t,e=[],n=[]){this._context=t,this._plugins=new Map,this._availablePlugins=new Map;for(const t of e)t.pluginName&&this._availablePlugins.set(t.pluginName,t);this._contextPlugins=new Map;for(const[t,e]of n)this._contextPlugins.set(t,e),this._contextPlugins.set(e,t),t.pluginName&&this._availablePlugins.set(t.pluginName,t)}*[Symbol.iterator](){for(const t of this._plugins)"function"==typeof t[0]&&(yield t)}get(t){const e=this._plugins.get(t);if(!e){const e="plugincollection-plugin-not-loaded: The requested plugin is not loaded.";let n=t;throw"function"==typeof t&&(n=t.pluginName||t.name),new hn.b(e,this._context,{plugin:n})}return e}has(t){return this._plugins.has(t)}init(t,e=[]){const n=this,i=this._context,o=new Set,r=[],s=h(t),a=h(e),c=function(t){const e=[];for(const n of t)u(n)||e.push(n);return e.length?e:null}(t);if(c){const t="plugincollection-plugin-not-found: Some plugins are not available and could not be loaded.";return console.error(Object(hn.a)(t),{plugins:c}),Promise.reject(new hn.b(t,i,{plugins:c}))}return Promise.all(s.map(l)).then(()=>d(r,"init")).then(()=>d(r,"afterInit")).then(()=>r);function l(t){if(!a.includes(t)&&!n._plugins.has(t)&&!o.has(t))return function(t){return new Promise(s=>{o.add(t),t.requires&&t.requires.forEach(n=>{const o=u(n);if(t.isContextPlugin&&!o.isContextPlugin)throw new hn.b("plugincollection-context-required: Context plugin can not require plugin which is not a context plugin",null,{plugin:o.name,requiredBy:t.name});if(e.includes(o))throw new hn.b("plugincollection-required: Cannot load a plugin because one of its dependencies is listed inthe `removePlugins` option.",i,{plugin:o.name,requiredBy:t.name});l(o)});const a=n._contextPlugins.get(t)||new t(i);n._add(t,a),r.push(a),s()})}(t).catch(e=>{throw console.error(Object(hn.a)("plugincollection-load: It was not possible to load the plugin."),{plugin:t}),e})}function d(t,e){return t.reduce((t,i)=>i[e]?n._contextPlugins.has(i)?t:t.then(i[e].bind(i)):t,Promise.resolve())}function u(t){return"function"==typeof t?t:n._availablePlugins.get(t)}function h(t){return t.map(t=>u(t)).filter(t=>!!t)}}destroy(){const t=[];for(const[,e]of this)"function"!=typeof e.destroy||this._contextPlugins.has(e)||t.push(e.destroy());return Promise.all(t)}_add(t,e){this._plugins.set(t,e);const n=t.pluginName;if(n){if(this._plugins.has(n))throw new hn.b("plugincollection-plugin-name-conflict: Two plugins with the same name were loaded.",null,{pluginName:n,plugin1:this._plugins.get(n).constructor,plugin2:t});this._plugins.set(n,e)}}}function Tn(t,e,n=1){if("number"!=typeof n)throw new hn.b("translation-service-quantity-not-a-number: Expecting `quantity` to be a number.",null,{quantity:n});const i=Object.keys(window.CKEDITOR_TRANSLATIONS).length;1===i&&(t=Object.keys(window.CKEDITOR_TRANSLATIONS)[0]);const o=e.id||e.string;if(0===i||!function(t,e){return!!window.CKEDITOR_TRANSLATIONS[t]&&!!window.CKEDITOR_TRANSLATIONS[t].dictionary[e]}(t,o))return 1!==n?e.plural:e.string;const r=window.CKEDITOR_TRANSLATIONS[t].dictionary,s=window.CKEDITOR_TRANSLATIONS[t].getPluralForm||(t=>1===t?0:1);if("string"==typeof r[o])return r[o];const a=Number(s(n));return r[o][a]}xn(Cn,mn),window.CKEDITOR_TRANSLATIONS||(window.CKEDITOR_TRANSLATIONS={});const Pn=["ar","fa","he","ku","ug"];class Sn{constructor(t={}){this.uiLanguage=t.uiLanguage||"en",this.contentLanguage=t.contentLanguage||this.uiLanguage,this.uiLanguageDirection=En(this.uiLanguage),this.contentLanguageDirection=En(this.contentLanguage),this.t=(t,e)=>this._t(t,e)}get language(){return console.warn("locale-deprecated-language-property: The Locale#language property has been deprecated and will be removed in the near future. Please use #uiLanguage and #contentLanguage properties instead."),this.uiLanguage}_t(t,e=[]){Array.isArray(e)||(e=[e]),"string"==typeof t&&(t={string:t});const n=!!t.plural?e[0]:1;return function(t,e){return t.replace(/%(\d+)/g,(t,n)=>n<e.length?e[n]:t)}(Tn(this.uiLanguage,t,n),e)}}function En(t){return Pn.includes(t)?"rtl":"ltr"}class Mn{constructor(t){this.config=new on(t,this.constructor.defaultConfig);const e=this.constructor.builtinPlugins;this.config.define("plugins",e),this.plugins=new Cn(this,e);const n=this.config.get("language")||{};this.locale=new Sn({uiLanguage:"string"==typeof n?n:n.ui,contentLanguage:this.config.get("language.content")}),this.t=this.locale.t,this.editors=new An,this._contextOwner=null}initPlugins(){const t=this.config.get("plugins")||[];for(const e of t){if("function"!=typeof e)throw new hn.b("context-initplugins-constructor-only: Only a constructor function is allowed as a context plugin.",null,{Plugin:e});if(!0!==e.isContextPlugin)throw new hn.b("context-initplugins-invalid-plugin: Only a plugin marked as a context plugin is allowed to be used with a context.",null,{Plugin:e})}return this.plugins.init(t)}destroy(){return Promise.all(Array.from(this.editors,t=>t.destroy())).then(()=>this.plugins.destroy())}_addEditor(t,e){if(this._contextOwner)throw new hn.b("context-addEditor-private-context: Cannot add multiple editors to the context which is created by the editor.");this.editors.add(t),e&&(this._contextOwner=t)}_removeEditor(t){return this.editors.has(t)&&this.editors.remove(t),this._contextOwner===t?this.destroy():Promise.resolve()}_getEditorConfig(){const t={};for(const e of this.config.names())["plugins","removePlugins","extraPlugins"].includes(e)||(t[e]=this.config.get(e));return t}static create(t){return new Promise(e=>{const n=new this(t);e(n.initPlugins().then(()=>n))})}}function In(t,e){const n=Math.min(t.length,e.length);for(let i=0;i<n;i++)if(t[i]!=e[i])return i;return t.length==e.length?"same":t.length<e.length?"prefix":"extension"}var Nn=function(t){return tn(t,4)};class On{constructor(t){this.document=t,this.parent=null}get index(){let t;if(!this.parent)return null;if(-1==(t=this.parent.getChildIndex(this)))throw new hn.b("view-node-not-found-in-parent: The node's parent does not contain this node.",this);return t}get nextSibling(){const t=this.index;return null!==t&&this.parent.getChild(t+1)||null}get previousSibling(){const t=this.index;return null!==t&&this.parent.getChild(t-1)||null}get root(){let t=this;for(;t.parent;)t=t.parent;return t}isAttached(){return this.root.is("rootElement")}getPath(){const t=[];let e=this;for(;e.parent;)t.unshift(e.index),e=e.parent;return t}getAncestors(t={includeSelf:!1,parentFirst:!1}){const e=[];let n=t.includeSelf?this:this.parent;for(;n;)e[t.parentFirst?"push":"unshift"](n),n=n.parent;return e}getCommonAncestor(t,e={}){const n=this.getAncestors(e),i=t.getAncestors(e);let o=0;for(;n[o]==i[o]&&n[o];)o++;return 0===o?null:n[o-1]}isBefore(t){if(this==t)return!1;if(this.root!==t.root)return!1;const e=this.getPath(),n=t.getPath(),i=In(e,n);switch(i){case"prefix":return!0;case"extension":return!1;default:return e[i]<n[i]}}isAfter(t){return this!=t&&(this.root===t.root&&!this.isBefore(t))}_remove(){this.parent._removeChildren(this.index)}_fireChange(t,e){this.fire("change:"+t,e),this.parent&&this.parent._fireChange(t,e)}toJSON(){const t=Nn(this);return delete t.parent,t}is(t){return"node"===t||"view:node"===t}}xn(On,mn);class Rn extends On{constructor(t,e){super(t),this._textData=e}is(t){return"text"===t||"view:text"===t||"node"===t||"view:node"===t}get data(){return this._textData}get _data(){return this.data}set _data(t){this._fireChange("text",this),this._textData=t}isSimilar(t){return t instanceof Rn&&(this===t||this.data===t.data)}_clone(){return new Rn(this.document,this.data)}}class Dn{constructor(t,e,n){if(this.textNode=t,e<0||e>t.data.length)throw new hn.b("view-textproxy-wrong-offsetintext: Given offsetInText value is incorrect.",this);if(n<0||e+n>t.data.length)throw new hn.b("view-textproxy-wrong-length: Given length value is incorrect.",this);this.data=t.data.substring(e,e+n),this.offsetInText=e}get offsetSize(){return this.data.length}get isPartial(){return this.data.length!==this.textNode.data.length}get parent(){return this.textNode.parent}get root(){return this.textNode.root}get document(){return this.textNode.document}is(t){return"textProxy"===t||"view:textProxy"===t}getAncestors(t={includeSelf:!1,parentFirst:!1}){const e=[];let n=t.includeSelf?this.textNode:this.parent;for(;null!==n;)e[t.parentFirst?"push":"unshift"](n),n=n.parent;return e}}function Ln(t){return yn(t)?new Map(t):function(t){const e=new Map;for(const n in t)e.set(n,t[n]);return e}(t)}class jn{constructor(...t){this._patterns=[],this.add(...t)}add(...t){for(let e of t)("string"==typeof e||e instanceof RegExp)&&(e={name:e}),e.classes&&("string"==typeof e.classes||e.classes instanceof RegExp)&&(e.classes=[e.classes]),this._patterns.push(e)}match(...t){for(const e of t)for(const t of this._patterns){const n=Vn(e,t);if(n)return{element:e,pattern:t,match:n}}return null}matchAll(...t){const e=[];for(const n of t)for(const t of this._patterns){const i=Vn(n,t);i&&e.push({element:n,pattern:t,match:i})}return e.length>0?e:null}getElementName(){if(1!==this._patterns.length)return null;const t=this._patterns[0],e=t.name;return"function"==typeof t||!e||e instanceof RegExp?null:e}}function Vn(t,e){if("function"==typeof e)return e(t);const n={};return e.name&&(n.name=function(t,e){if(t instanceof RegExp)return t.test(e);return t===e}(e.name,t.name),!n.name)||e.attributes&&(n.attributes=function(t,e){const n=[];for(const i in t){const o=t[i];if(!e.hasAttribute(i))return null;{const t=e.getAttribute(i);if(!0===o)n.push(i);else if(o instanceof RegExp){if(!o.test(t))return null;n.push(i)}else{if(t!==o)return null;n.push(i)}}}return n}(e.attributes,t),!n.attributes)?null:!(e.classes&&(n.classes=function(t,e){const n=[];for(const i of t)if(i instanceof RegExp){const t=e.getClassNames();for(const e of t)i.test(e)&&n.push(e);if(0===n.length)return null}else{if(!e.hasClass(i))return null;n.push(i)}return n}(e.classes,t),!n.classes))&&(!(e.styles&&(n.styles=function(t,e){const n=[];for(const i in t){const o=t[i];if(!e.hasStyle(i))return null;{const t=e.getStyle(i);if(o instanceof RegExp){if(!o.test(t))return null;n.push(i)}else{if(t!==o)return null;n.push(i)}}}return n}(e.styles,t),!n.styles))&&n)}var zn=function(t){return"symbol"==typeof t||p(t)&&"[object Symbol]"==f(t)},Bn=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,Fn=/^\w*$/;var Un=function(t,e){if(Dt(t))return!1;var n=typeof t;return!("number"!=n&&"symbol"!=n&&"boolean"!=n&&null!=t&&!zn(t))||(Fn.test(t)||!Bn.test(t)||null!=e&&t in Object(e))};function Hn(t,e){if("function"!=typeof t||null!=e&&"function"!=typeof e)throw new TypeError("Expected a function");var n=function(){var i=arguments,o=e?e.apply(this,i):i[0],r=n.cache;if(r.has(o))return r.get(o);var s=t.apply(this,i);return n.cache=r.set(o,s)||r,s};return n.cache=new(Hn.Cache||kt),n}Hn.Cache=kt;var Wn=Hn;var qn=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,Yn=/\\(\\)?/g,Gn=function(t){var e=Wn(t,(function(t){return 500===n.size&&n.clear(),t})),n=e.cache;return e}((function(t){var e=[];return 46===t.charCodeAt(0)&&e.push(""),t.replace(qn,(function(t,n,i,o){e.push(i?o.replace(Yn,"$1"):n||t)})),e}));var $n=function(t,e){for(var n=-1,i=null==t?0:t.length,o=Array(i);++n<i;)o[n]=e(t[n],n,t);return o},Kn=o?o.prototype:void 0,Qn=Kn?Kn.toString:void 0;var Jn=function t(e){if("string"==typeof e)return e;if(Dt(e))return $n(e,t)+"";if(zn(e))return Qn?Qn.call(e):"";var n=e+"";return"0"==n&&1/e==-1/0?"-0":n};var Zn=function(t){return null==t?"":Jn(t)};var Xn=function(t,e){return Dt(t)?t:Un(t,e)?[t]:Gn(Zn(t))};var ti=function(t){var e=null==t?0:t.length;return e?t[e-1]:void 0};var ei=function(t){if("string"==typeof t||zn(t))return t;var e=t+"";return"0"==e&&1/t==-1/0?"-0":e};var ni=function(t,e){for(var n=0,i=(e=Xn(e,t)).length;null!=t&&n<i;)t=t[ei(e[n++])];return n&&n==i?t:void 0};var ii=function(t,e,n){var i=-1,o=t.length;e<0&&(e=-e>o?0:o+e),(n=n>o?o:n)<0&&(n+=o),o=e>n?0:n-e>>>0,e>>>=0;for(var r=Array(o);++i<o;)r[i]=t[i+e];return r};var oi=function(t,e){return e.length<2?t:ni(t,ii(e,0,-1))};var ri=function(t,e){return e=Xn(e,t),null==(t=oi(t,e))||delete t[ei(ti(e))]};var si=function(t,e){return null==t||ri(t,e)};var ai=function(t,e,n){var i=null==t?void 0:ni(t,e);return void 0===i?n:i};var ci=function(t,e,n){(void 0!==n&&!A(t[e],n)||void 0===n&&!(e in t))&&Ct(t,e,n)};var li=function(t){return function(e,n,i){for(var o=-1,r=Object(e),s=i(e),a=s.length;a--;){var c=s[t?a:++o];if(!1===n(r[c],c,r))break}return e}}();var di=function(t){return p(t)&&Xt(t)};var ui=function(t,e){if(("constructor"!==e||"function"!=typeof t[e])&&"__proto__"!=e)return t[e]};var hi=function(t){return St(t,re(t))};var fi=function(t,e,n,i,o,r,s){var a=ui(t,n),c=ui(e,n),l=s.get(c);if(l)ci(t,n,l);else{var d=r?r(a,c,n+"",t,e,s):void 0,u=void 0===d;if(u){var h=Dt(c),f=!h&&Object(Lt.a)(c),g=!h&&!f&&qt(c);d=c,h||f||g?Dt(a)?d=a:di(a)?d=ce(a):f?(u=!1,d=Object(ae.a)(c,!0)):g?(u=!1,d=Ue(c,!0)):d=[]:y(c)||Rt(c)?(d=a,Rt(a)?d=hi(a):j(a)&&!z(a)||(d=Ye(c))):u=!1}u&&(s.set(c,d),o(d,c,i,r,s),s.delete(c)),ci(t,n,d)}};var gi=function t(e,n,i,o,r){e!==n&&li(n,(function(s,a){if(r||(r=new yt),j(s))fi(e,n,a,i,t,o,r);else{var c=o?o(ui(e,a),s,a+"",e,n,r):void 0;void 0===c&&(c=s),ci(e,a,c)}}),re)};var mi=function(t){return t};var pi=function(t,e,n){switch(n.length){case 0:return t.call(e);case 1:return t.call(e,n[0]);case 2:return t.call(e,n[0],n[1]);case 3:return t.call(e,n[0],n[1],n[2])}return t.apply(e,n)},bi=Math.max;var wi=function(t,e,n){return e=bi(void 0===e?t.length-1:e,0),function(){for(var i=arguments,o=-1,r=bi(i.length-e,0),s=Array(r);++o<r;)s[o]=i[e+o];o=-1;for(var a=Array(e+1);++o<e;)a[o]=i[o];return a[e]=n(s),pi(t,this,a)}};var ki=function(t){return function(){return t}},_i=At?function(t,e){return At(t,"toString",{configurable:!0,enumerable:!1,value:ki(e),writable:!0})}:mi,vi=Date.now;var yi=function(t){var e=0,n=0;return function(){var i=vi(),o=16-(i-n);if(n=i,o>0){if(++e>=800)return arguments[0]}else e=0;return t.apply(void 0,arguments)}}(_i);var xi=function(t,e){return yi(wi(t,e,mi),t+"")};var Ai=function(t,e,n){if(!j(n))return!1;var i=typeof e;return!!("number"==i?Xt(n)&&Vt(e,n.length):"string"==i&&e in n)&&A(n[e],t)};var Ci=function(t){return xi((function(e,n){var i=-1,o=n.length,r=o>1?n[o-1]:void 0,s=o>2?n[2]:void 0;for(r=t.length>3&&"function"==typeof r?(o--,r):void 0,s&&Ai(n[0],n[1],s)&&(r=o<3?void 0:r,o=1),e=Object(e);++i<o;){var a=n[i];a&&t(e,a,i,r)}return e}))},Ti=Ci((function(t,e,n){gi(t,e,n)}));var Pi=function(t,e,n,i){if(!j(t))return t;for(var o=-1,r=(e=Xn(e,t)).length,s=r-1,a=t;null!=a&&++o<r;){var c=ei(e[o]),l=n;if(o!=s){var d=a[c];void 0===(l=i?i(d,c,a):void 0)&&(l=j(d)?d:Vt(e[o+1])?[]:{})}Pt(a,c,l),a=a[c]}return t};var Si=function(t,e,n){return null==t?t:Pi(t,e,n)};class Ei{constructor(t){this._styles={},this._styleProcessor=t}get isEmpty(){const t=Object.entries(this._styles);return!Array.from(t).length}get size(){return this.isEmpty?0:this.getStyleNames().length}setTo(t){this.clear();const e=Array.from(function(t){let e=null,n=0,i=0,o=null;const r=new Map;if(""===t)return r;";"!=t.charAt(t.length-1)&&(t+=";");for(let s=0;s<t.length;s++){const a=t.charAt(s);if(null===e)switch(a){case":":o||(o=t.substr(n,s-n),i=s+1);break;case'"':case"'":e=a;break;case";":{const e=t.substr(i,s-i);o&&r.set(o.trim(),e.trim()),o=null,n=s+1;break}}else a===e&&(e=null)}return r}(t).entries());for(const[t,n]of e)this._styleProcessor.toNormalizedForm(t,n,this._styles)}has(t){if(this.isEmpty)return!1;const e=this._styleProcessor.getReducedForm(t,this._styles).find(([e])=>e===t);return Array.isArray(e)}set(t,e){if(j(t))for(const[e,n]of Object.entries(t))this._styleProcessor.toNormalizedForm(e,n,this._styles);else this._styleProcessor.toNormalizedForm(t,e,this._styles)}remove(t){const e=Ii(t);si(this._styles,e),delete this._styles[t],this._cleanEmptyObjectsOnPath(e)}getNormalized(t){return this._styleProcessor.getNormalized(t,this._styles)}toString(){return this.isEmpty?"":this._getStylesEntries().map(t=>t.join(":")).sort().join(";")+";"}getAsString(t){if(this.isEmpty)return;if(this._styles[t]&&!j(this._styles[t]))return this._styles[t];const e=this._styleProcessor.getReducedForm(t,this._styles).find(([e])=>e===t);return Array.isArray(e)?e[1]:void 0}getStyleNames(){if(this.isEmpty)return[];return this._getStylesEntries().map(([t])=>t)}clear(){this._styles={}}_getStylesEntries(){const t=[],e=Object.keys(this._styles);for(const n of e)t.push(...this._styleProcessor.getReducedForm(n,this._styles));return t}_cleanEmptyObjectsOnPath(t){const e=t.split(".");if(!(e.length>1))return;const n=e.splice(0,e.length-1).join("."),i=ai(this._styles,n);if(!i)return;!Array.from(Object.keys(i)).length&&this.remove(n)}}class Mi{constructor(){this._normalizers=new Map,this._extractors=new Map,this._reducers=new Map,this._consumables=new Map}toNormalizedForm(t,e,n){if(j(e))Ni(n,Ii(t),e);else if(this._normalizers.has(t)){const i=this._normalizers.get(t),{path:o,value:r}=i(e);Ni(n,o,r)}else Ni(n,t,e)}getNormalized(t,e){if(!t)return Ti({},e);if(void 0!==e[t])return e[t];if(this._extractors.has(t)){const n=this._extractors.get(t);if("string"==typeof n)return ai(e,n);const i=n(t,e);if(i)return i}return ai(e,Ii(t))}getReducedForm(t,e){const n=this.getNormalized(t,e);if(void 0===n)return[];if(this._reducers.has(t)){return this._reducers.get(t)(n)}return[[t,n]]}getRelatedStyles(t){return this._consumables.get(t)||[]}setNormalizer(t,e){this._normalizers.set(t,e)}setExtractor(t,e){this._extractors.set(t,e)}setReducer(t,e){this._reducers.set(t,e)}setStyleRelation(t,e){this._mapStyleNames(t,e);for(const n of e)this._mapStyleNames(n,[t])}_mapStyleNames(t,e){this._consumables.has(t)||this._consumables.set(t,[]),this._consumables.get(t).push(...e)}}function Ii(t){return t.replace("-",".")}function Ni(t,e,n){let i=n;j(n)&&(i=Ti({},ai(t,e),n)),Si(t,e,i)}class Oi extends On{constructor(t,e,n,i){if(super(t),this.name=e,this._attrs=function(t){t=Ln(t);for(const[e,n]of t)null===n?t.delete(e):"string"!=typeof n&&t.set(e,String(n));return t}(n),this._children=[],i&&this._insertChild(0,i),this._classes=new Set,this._attrs.has("class")){const t=this._attrs.get("class");Ri(this._classes,t),this._attrs.delete("class")}this._styles=new Ei(this.document.stylesProcessor),this._attrs.has("style")&&(this._styles.setTo(this._attrs.get("style")),this._attrs.delete("style")),this._customProperties=new Map}get childCount(){return this._children.length}get isEmpty(){return 0===this._children.length}is(t,e=null){return e?e===this.name&&("element"===t||"view:element"===t):t===this.name||t==="view:"+this.name||"element"===t||"view:element"===t||"node"===t||"view:node"===t}getChild(t){return this._children[t]}getChildIndex(t){return this._children.indexOf(t)}getChildren(){return this._children[Symbol.iterator]()}*getAttributeKeys(){this._classes.size>0&&(yield"class"),this._styles.isEmpty||(yield"style"),yield*this._attrs.keys()}*getAttributes(){yield*this._attrs.entries(),this._classes.size>0&&(yield["class",this.getAttribute("class")]),this._styles.isEmpty||(yield["style",this.getAttribute("style")])}getAttribute(t){if("class"==t)return this._classes.size>0?[...this._classes].join(" "):void 0;if("style"==t){const t=this._styles.toString();return""==t?void 0:t}return this._attrs.get(t)}hasAttribute(t){return"class"==t?this._classes.size>0:"style"==t?!this._styles.isEmpty:this._attrs.has(t)}isSimilar(t){if(!(t instanceof Oi))return!1;if(this===t)return!0;if(this.name!=t.name)return!1;if(this._attrs.size!==t._attrs.size||this._classes.size!==t._classes.size||this._styles.size!==t._styles.size)return!1;for(const[e,n]of this._attrs)if(!t._attrs.has(e)||t._attrs.get(e)!==n)return!1;for(const e of this._classes)if(!t._classes.has(e))return!1;for(const e of this._styles.getStyleNames())if(!t._styles.has(e)||t._styles.getAsString(e)!==this._styles.getAsString(e))return!1;return!0}hasClass(...t){for(const e of t)if(!this._classes.has(e))return!1;return!0}getClassNames(){return this._classes.keys()}getStyle(t){return this._styles.getAsString(t)}getNormalizedStyle(t){return this._styles.getNormalized(t)}getStyleNames(){return this._styles.getStyleNames()}hasStyle(...t){for(const e of t)if(!this._styles.has(e))return!1;return!0}findAncestor(...t){const e=new jn(...t);let n=this.parent;for(;n;){if(e.match(n))return n;n=n.parent}return null}getCustomProperty(t){return this._customProperties.get(t)}*getCustomProperties(){yield*this._customProperties.entries()}getIdentity(){const t=Array.from(this._classes).sort().join(","),e=this._styles.toString(),n=Array.from(this._attrs).map(t=>`${t[0]}="${t[1]}"`).sort().join(" ");return this.name+(""==t?"":` class="${t}"`)+(e?` style="${e}"`:"")+(""==n?"":" "+n)}_clone(t=!1){const e=[];if(t)for(const n of this.getChildren())e.push(n._clone(t));const n=new this.constructor(this.document,this.name,this._attrs,e);return n._classes=new Set(this._classes),n._styles.set(this._styles.getNormalized()),n._customProperties=new Map(this._customProperties),n.getFillerOffset=this.getFillerOffset,n}_appendChild(t){return this._insertChild(this.childCount,t)}_insertChild(t,e){this._fireChange("children",this);let n=0;const i=function(t,e){if("string"==typeof e)return[new Rn(t,e)];yn(e)||(e=[e]);return Array.from(e).map(e=>"string"==typeof e?new Rn(t,e):e instanceof Dn?new Rn(t,e.data):e)}(this.document,e);for(const e of i)null!==e.parent&&e._remove(),e.parent=this,e.document=this.document,this._children.splice(t,0,e),t++,n++;return n}_removeChildren(t,e=1){this._fireChange("children",this);for(let n=t;n<t+e;n++)this._children[n].parent=null;return this._children.splice(t,e)}_setAttribute(t,e){e=String(e),this._fireChange("attributes",this),"class"==t?Ri(this._classes,e):"style"==t?this._styles.setTo(e):this._attrs.set(t,e)}_removeAttribute(t){return this._fireChange("attributes",this),"class"==t?this._classes.size>0&&(this._classes.clear(),!0):"style"==t?!this._styles.isEmpty&&(this._styles.clear(),!0):this._attrs.delete(t)}_addClass(t){this._fireChange("attributes",this),(t=Array.isArray(t)?t:[t]).forEach(t=>this._classes.add(t))}_removeClass(t){this._fireChange("attributes",this),(t=Array.isArray(t)?t:[t]).forEach(t=>this._classes.delete(t))}_setStyle(t,e){this._fireChange("attributes",this),this._styles.set(t,e)}_removeStyle(t){this._fireChange("attributes",this),(t=Array.isArray(t)?t:[t]).forEach(t=>this._styles.remove(t))}_setCustomProperty(t,e){this._customProperties.set(t,e)}_removeCustomProperty(t){return this._customProperties.delete(t)}}function Ri(t,e){const n=e.split(/\s+/);t.clear(),n.forEach(e=>t.add(e))}class Di extends Oi{constructor(t,e,n,i){super(t,e,n,i),this.getFillerOffset=Li}is(t,e=null){return e?e===this.name&&("containerElement"===t||"view:containerElement"===t||"element"===t||"view:element"===t):"containerElement"===t||"view:containerElement"===t||t===this.name||t==="view:"+this.name||"element"===t||"view:element"===t||"node"===t||"view:node"===t}}function Li(){const t=[...this.getChildren()],e=t[this.childCount-1];if(e&&e.is("element","br"))return this.childCount;for(const e of t)if(!e.is("uiElement"))return null;return this.childCount}var ji=Ci((function(t,e){St(e,re(e),t)}));const Vi=Symbol("observableProperties"),zi=Symbol("boundObservables"),Bi=Symbol("boundProperties"),Fi={set(t,e){if(j(t))return void Object.keys(t).forEach(e=>{this.set(e,t[e])},this);Hi(this);const n=this[Vi];if(t in this&&!n.has(t))throw new hn.b("observable-set-cannot-override: Cannot override an existing property.",this);Object.defineProperty(this,t,{enumerable:!0,configurable:!0,get:()=>n.get(t),set(e){const i=n.get(t);let o=this.fire("set:"+t,t,e,i);void 0===o&&(o=e),i===o&&n.has(t)||(n.set(t,o),this.fire("change:"+t,t,o,i))}}),this[t]=e},bind(...t){if(!t.length||!Yi(t))throw new hn.b("observable-bind-wrong-properties: All properties must be strings.",this);if(new Set(t).size!==t.length)throw new hn.b("observable-bind-duplicate-properties: Properties must be unique.",this);Hi(this);const e=this[Bi];t.forEach(t=>{if(e.has(t))throw new hn.b("observable-bind-rebind: Cannot bind the same property more than once.",this)});const n=new Map;return t.forEach(t=>{const i={property:t,to:[]};e.set(t,i),n.set(t,i)}),{to:Wi,toMany:qi,_observable:this,_bindProperties:t,_to:[],_bindings:n}},unbind(...t){if(!this[Vi])return;const e=this[Bi],n=this[zi];if(t.length){if(!Yi(t))throw new hn.b("observable-unbind-wrong-properties: Properties must be strings.",this);t.forEach(t=>{const i=e.get(t);if(!i)return;let o,r,s,a;i.to.forEach(t=>{o=t[0],r=t[1],s=n.get(o),a=s[r],a.delete(i),a.size||delete s[r],Object.keys(s).length||(n.delete(o),this.stopListening(o,"change"))}),e.delete(t)})}else n.forEach((t,e)=>{this.stopListening(e,"change")}),n.clear(),e.clear()},decorate(t){const e=this[t];if(!e)throw new hn.b("observablemixin-cannot-decorate-undefined: Cannot decorate an undefined method.",this,{object:this,methodName:t});this.on(t,(t,n)=>{t.return=e.apply(this,n)}),this[t]=function(...e){return this.fire(t,e)}}};ji(Fi,mn);var Ui=Fi;function Hi(t){t[Vi]||(Object.defineProperty(t,Vi,{value:new Map}),Object.defineProperty(t,zi,{value:new Map}),Object.defineProperty(t,Bi,{value:new Map}))}function Wi(...t){const e=function(...t){if(!t.length)throw new hn.b("observable-bind-to-parse-error: Invalid argument syntax in `to()`.",null);const e={to:[]};let n;"function"==typeof t[t.length-1]&&(e.callback=t.pop());return t.forEach(t=>{if("string"==typeof t)n.properties.push(t);else{if("object"!=typeof t)throw new hn.b("observable-bind-to-parse-error: Invalid argument syntax in `to()`.",null);n={observable:t,properties:[]},e.to.push(n)}}),e}(...t),n=Array.from(this._bindings.keys()),i=n.length;if(!e.callback&&e.to.length>1)throw new hn.b("observable-bind-to-no-callback: Binding multiple observables only possible with callback.",this);if(i>1&&e.callback)throw new hn.b("observable-bind-to-extra-callback: Cannot bind multiple properties and use a callback in one binding.",this);var o;e.to.forEach(t=>{if(t.properties.length&&t.properties.length!==i)throw new hn.b("observable-bind-to-properties-length: The number of properties must match.",this);t.properties.length||(t.properties=this._bindProperties)}),this._to=e.to,e.callback&&(this._bindings.get(n[0]).callback=e.callback),o=this._observable,this._to.forEach(t=>{const e=o[zi];let n;e.get(t.observable)||o.listenTo(t.observable,"change",(i,r)=>{n=e.get(t.observable)[r],n&&n.forEach(t=>{Gi(o,t.property)})})}),function(t){let e;t._bindings.forEach((n,i)=>{t._to.forEach(o=>{e=o.properties[n.callback?0:t._bindProperties.indexOf(i)],n.to.push([o.observable,e]),function(t,e,n,i){const o=t[zi],r=o.get(n),s=r||{};s[i]||(s[i]=new Set);s[i].add(e),r||o.set(n,s)}(t._observable,n,o.observable,e)})})}(this),this._bindProperties.forEach(t=>{Gi(this._observable,t)})}function qi(t,e,n){if(this._bindings.size>1)throw new hn.b("observable-bind-to-many-not-one-binding: Cannot bind multiple properties with toMany().",this);this.to(...function(t,e){const n=t.map(t=>[t,e]);return Array.prototype.concat.apply([],n)}(t,e),n)}function Yi(t){return t.every(t=>"string"==typeof t)}function Gi(t,e){const n=t[Bi].get(e);let i;n.callback?i=n.callback.apply(t,n.to.map(t=>t[0][t[1]])):(i=n.to[0],i=i[0][i[1]]),Object.prototype.hasOwnProperty.call(t,e)?t[e]=i:t.set(e,i)}class $i extends Di{constructor(t,e,n,i){super(t,e,n,i),this.set("isReadOnly",!1),this.set("isFocused",!1),this.bind("isReadOnly").to(t),this.bind("isFocused").to(t,"isFocused",e=>e&&t.selection.editableElement==this),this.listenTo(t.selection,"change",()=>{this.isFocused=t.isFocused&&t.selection.editableElement==this})}is(t,e=null){return e?e===this.name&&("editableElement"===t||"view:editableElement"===t||"containerElement"===t||"view:containerElement"===t||"element"===t||"view:element"===t):"editableElement"===t||"view:editableElement"===t||"containerElement"===t||"view:containerElement"===t||t===this.name||t==="view:"+this.name||"element"===t||"view:element"===t||"node"===t||"view:node"===t}destroy(){this.stopListening()}}xn($i,Ui);const Ki=Symbol("rootName");class Qi extends $i{constructor(t,e){super(t,e),this.rootName="main"}is(t,e=null){return e?e===this.name&&("rootElement"===t||"view:rootElement"===t||"editableElement"===t||"view:editableElement"===t||"containerElement"===t||"view:containerElement"===t||"element"===t||"view:element"===t):"rootElement"===t||"view:rootElement"===t||"editableElement"===t||"view:editableElement"===t||"containerElement"===t||"view:containerElement"===t||t===this.name||t==="view:"+this.name||"element"===t||"view:element"===t||"node"===t||"view:node"===t}get rootName(){return this.getCustomProperty(Ki)}set rootName(t){this._setCustomProperty(Ki,t)}set _name(t){this.name=t}}class Ji{constructor(t={}){if(!t.boundaries&&!t.startPosition)throw new hn.b("view-tree-walker-no-start-position: Neither boundaries nor starting position have been defined.",null);if(t.direction&&"forward"!=t.direction&&"backward"!=t.direction)throw new hn.b("view-tree-walker-unknown-direction: Only `backward` and `forward` direction allowed.",t.startPosition,{direction:t.direction});this.boundaries=t.boundaries||null,t.startPosition?this.position=Zi._createAt(t.startPosition):this.position=Zi._createAt(t.boundaries["backward"==t.direction?"end":"start"]),this.direction=t.direction||"forward",this.singleCharacters=!!t.singleCharacters,this.shallow=!!t.shallow,this.ignoreElementEnd=!!t.ignoreElementEnd,this._boundaryStartParent=this.boundaries?this.boundaries.start.parent:null,this._boundaryEndParent=this.boundaries?this.boundaries.end.parent:null}[Symbol.iterator](){return this}skip(t){let e,n,i;do{i=this.position,({done:e,value:n}=this.next())}while(!e&&t(n));e||(this.position=i)}next(){return"forward"==this.direction?this._next():this._previous()}_next(){let t=this.position.clone();const e=this.position,n=t.parent;if(null===n.parent&&t.offset===n.childCount)return{done:!0};if(n===this._boundaryEndParent&&t.offset==this.boundaries.end.offset)return{done:!0};let i;if(n instanceof Rn){if(t.isAtEnd)return this.position=Zi._createAfter(n),this._next();i=n.data[t.offset]}else i=n.getChild(t.offset);if(i instanceof Oi)return this.shallow?t.offset++:t=new Zi(i,0),this.position=t,this._formatReturnValue("elementStart",i,e,t,1);if(i instanceof Rn){if(this.singleCharacters)return t=new Zi(i,0),this.position=t,this._next();{let n,o=i.data.length;return i==this._boundaryEndParent?(o=this.boundaries.end.offset,n=new Dn(i,0,o),t=Zi._createAfter(n)):(n=new Dn(i,0,i.data.length),t.offset++),this.position=t,this._formatReturnValue("text",n,e,t,o)}}if("string"==typeof i){let i;if(this.singleCharacters)i=1;else{i=(n===this._boundaryEndParent?this.boundaries.end.offset:n.data.length)-t.offset}const o=new Dn(n,t.offset,i);return t.offset+=i,this.position=t,this._formatReturnValue("text",o,e,t,i)}return t=Zi._createAfter(n),this.position=t,this.ignoreElementEnd?this._next():this._formatReturnValue("elementEnd",n,e,t)}_previous(){let t=this.position.clone();const e=this.position,n=t.parent;if(null===n.parent&&0===t.offset)return{done:!0};if(n==this._boundaryStartParent&&t.offset==this.boundaries.start.offset)return{done:!0};let i;if(n instanceof Rn){if(t.isAtStart)return this.position=Zi._createBefore(n),this._previous();i=n.data[t.offset-1]}else i=n.getChild(t.offset-1);if(i instanceof Oi)return this.shallow?(t.offset--,this.position=t,this._formatReturnValue("elementStart",i,e,t,1)):(t=new Zi(i,i.childCount),this.position=t,this.ignoreElementEnd?this._previous():this._formatReturnValue("elementEnd",i,e,t));if(i instanceof Rn){if(this.singleCharacters)return t=new Zi(i,i.data.length),this.position=t,this._previous();{let n,o=i.data.length;if(i==this._boundaryStartParent){const e=this.boundaries.start.offset;n=new Dn(i,e,i.data.length-e),o=n.data.length,t=Zi._createBefore(n)}else n=new Dn(i,0,i.data.length),t.offset--;return this.position=t,this._formatReturnValue("text",n,e,t,o)}}if("string"==typeof i){let i;if(this.singleCharacters)i=1;else{const e=n===this._boundaryStartParent?this.boundaries.start.offset:0;i=t.offset-e}t.offset-=i;const o=new Dn(n,t.offset,i);return this.position=t,this._formatReturnValue("text",o,e,t,i)}return t=Zi._createBefore(n),this.position=t,this._formatReturnValue("elementStart",n,e,t,1)}_formatReturnValue(t,e,n,i,o){return e instanceof Dn&&(e.offsetInText+e.data.length==e.textNode.data.length&&("forward"!=this.direction||this.boundaries&&this.boundaries.end.isEqual(this.position)?n=Zi._createAfter(e.textNode):(i=Zi._createAfter(e.textNode),this.position=i)),0===e.offsetInText&&("backward"!=this.direction||this.boundaries&&this.boundaries.start.isEqual(this.position)?n=Zi._createBefore(e.textNode):(i=Zi._createBefore(e.textNode),this.position=i))),{done:!1,value:{type:t,item:e,previousPosition:n,nextPosition:i,length:o}}}}class Zi{constructor(t,e){this.parent=t,this.offset=e}get nodeAfter(){return this.parent.is("text")?null:this.parent.getChild(this.offset)||null}get nodeBefore(){return this.parent.is("text")?null:this.parent.getChild(this.offset-1)||null}get isAtStart(){return 0===this.offset}get isAtEnd(){const t=this.parent.is("text")?this.parent.data.length:this.parent.childCount;return this.offset===t}get root(){return this.parent.root}get editableElement(){let t=this.parent;for(;!(t instanceof $i);){if(!t.parent)return null;t=t.parent}return t}getShiftedBy(t){const e=Zi._createAt(this),n=e.offset+t;return e.offset=n<0?0:n,e}getLastMatchingPosition(t,e={}){e.startPosition=this;const n=new Ji(e);return n.skip(t),n.position}getAncestors(){return this.parent.is("documentFragment")?[this.parent]:this.parent.getAncestors({includeSelf:!0})}getCommonAncestor(t){const e=this.getAncestors(),n=t.getAncestors();let i=0;for(;e[i]==n[i]&&e[i];)i++;return 0===i?null:e[i-1]}is(t){return"position"===t||"view:position"===t}isEqual(t){return this.parent==t.parent&&this.offset==t.offset}isBefore(t){return"before"==this.compareWith(t)}isAfter(t){return"after"==this.compareWith(t)}compareWith(t){if(this.root!==t.root)return"different";if(this.isEqual(t))return"same";const e=this.parent.is("node")?this.parent.getPath():[],n=t.parent.is("node")?t.parent.getPath():[];e.push(this.offset),n.push(t.offset);const i=In(e,n);switch(i){case"prefix":return"before";case"extension":return"after";default:return e[i]<n[i]?"before":"after"}}getWalker(t={}){return t.startPosition=this,new Ji(t)}clone(){return new Zi(this.parent,this.offset)}static _createAt(t,e){if(t instanceof Zi)return new this(t.parent,t.offset);{const n=t;if("end"==e)e=n.is("text")?n.data.length:n.childCount;else{if("before"==e)return this._createBefore(n);if("after"==e)return this._createAfter(n);if(0!==e&&!e)throw new hn.b("view-createPositionAt-offset-required: View#createPositionAt() requires the offset when the first parameter is a view item.",n)}return new Zi(n,e)}}static _createAfter(t){if(t.is("textProxy"))return new Zi(t.textNode,t.offsetInText+t.data.length);if(!t.parent)throw new hn.b("view-position-after-root: You can not make position after root.",t,{root:t});return new Zi(t.parent,t.index+1)}static _createBefore(t){if(t.is("textProxy"))return new Zi(t.textNode,t.offsetInText);if(!t.parent)throw new hn.b("view-position-before-root: You can not make position before root.",t,{root:t});return new Zi(t.parent,t.index)}}class Xi{constructor(t,e=null){this.start=t.clone(),this.end=e?e.clone():t.clone()}*[Symbol.iterator](){yield*new Ji({boundaries:this,ignoreElementEnd:!0})}get isCollapsed(){return this.start.isEqual(this.end)}get isFlat(){return this.start.parent===this.end.parent}get root(){return this.start.root}getEnlarged(){let t=this.start.getLastMatchingPosition(to,{direction:"backward"}),e=this.end.getLastMatchingPosition(to);return t.parent.is("text")&&t.isAtStart&&(t=Zi._createBefore(t.parent)),e.parent.is("text")&&e.isAtEnd&&(e=Zi._createAfter(e.parent)),new Xi(t,e)}getTrimmed(){let t=this.start.getLastMatchingPosition(to);if(t.isAfter(this.end)||t.isEqual(this.end))return new Xi(t,t);let e=this.end.getLastMatchingPosition(to,{direction:"backward"});const n=t.nodeAfter,i=e.nodeBefore;return n&&n.is("text")&&(t=new Zi(n,0)),i&&i.is("text")&&(e=new Zi(i,i.data.length)),new Xi(t,e)}isEqual(t){return this==t||this.start.isEqual(t.start)&&this.end.isEqual(t.end)}containsPosition(t){return t.isAfter(this.start)&&t.isBefore(this.end)}containsRange(t,e=!1){t.isCollapsed&&(e=!1);const n=this.containsPosition(t.start)||e&&this.start.isEqual(t.start),i=this.containsPosition(t.end)||e&&this.end.isEqual(t.end);return n&&i}getDifference(t){const e=[];return this.isIntersecting(t)?(this.containsPosition(t.start)&&e.push(new Xi(this.start,t.start)),this.containsPosition(t.end)&&e.push(new Xi(t.end,this.end))):e.push(this.clone()),e}getIntersection(t){if(this.isIntersecting(t)){let e=this.start,n=this.end;return this.containsPosition(t.start)&&(e=t.start),this.containsPosition(t.end)&&(n=t.end),new Xi(e,n)}return null}getWalker(t={}){return t.boundaries=this,new Ji(t)}getCommonAncestor(){return this.start.getCommonAncestor(this.end)}getContainedElement(){if(this.isCollapsed)return null;let t=this.start.nodeAfter,e=this.end.nodeBefore;return this.start.parent.is("text")&&this.start.isAtEnd&&this.start.parent.nextSibling&&(t=this.start.parent.nextSibling),this.end.parent.is("text")&&this.end.isAtStart&&this.end.parent.previousSibling&&(e=this.end.parent.previousSibling),t&&t.is("element")&&t===e?t:null}clone(){return new Xi(this.start,this.end)}*getItems(t={}){t.boundaries=this,t.ignoreElementEnd=!0;const e=new Ji(t);for(const t of e)yield t.item}*getPositions(t={}){t.boundaries=this;const e=new Ji(t);yield e.position;for(const t of e)yield t.nextPosition}is(t){return"range"===t||"view:range"===t}isIntersecting(t){return this.start.isBefore(t.end)&&this.end.isAfter(t.start)}static _createFromParentsAndOffsets(t,e,n,i){return new this(new Zi(t,e),new Zi(n,i))}static _createFromPositionAndShift(t,e){const n=t,i=t.getShiftedBy(e);return e>0?new this(n,i):new this(i,n)}static _createIn(t){return this._createFromParentsAndOffsets(t,0,t,t.childCount)}static _createOn(t){const e=t.is("textProxy")?t.offsetSize:1;return this._createFromPositionAndShift(Zi._createBefore(t),e)}}function to(t){return!(!t.item.is("attributeElement")&&!t.item.is("uiElement"))}function eo(t){let e=0;for(const n of t)e++;return e}class no{constructor(t=null,e,n){this._ranges=[],this._lastRangeBackward=!1,this._isFake=!1,this._fakeSelectionLabel="",this.setTo(t,e,n)}get isFake(){return this._isFake}get fakeSelectionLabel(){return this._fakeSelectionLabel}get anchor(){if(!this._ranges.length)return null;const t=this._ranges[this._ranges.length-1];return(this._lastRangeBackward?t.end:t.start).clone()}get focus(){if(!this._ranges.length)return null;const t=this._ranges[this._ranges.length-1];return(this._lastRangeBackward?t.start:t.end).clone()}get isCollapsed(){return 1===this.rangeCount&&this._ranges[0].isCollapsed}get rangeCount(){return this._ranges.length}get isBackward(){return!this.isCollapsed&&this._lastRangeBackward}get editableElement(){return this.anchor?this.anchor.editableElement:null}*getRanges(){for(const t of this._ranges)yield t.clone()}getFirstRange(){let t=null;for(const e of this._ranges)t&&!e.start.isBefore(t.start)||(t=e);return t?t.clone():null}getLastRange(){let t=null;for(const e of this._ranges)t&&!e.end.isAfter(t.end)||(t=e);return t?t.clone():null}getFirstPosition(){const t=this.getFirstRange();return t?t.start.clone():null}getLastPosition(){const t=this.getLastRange();return t?t.end.clone():null}isEqual(t){if(this.isFake!=t.isFake)return!1;if(this.isFake&&this.fakeSelectionLabel!=t.fakeSelectionLabel)return!1;if(this.rangeCount!=t.rangeCount)return!1;if(0===this.rangeCount)return!0;if(!this.anchor.isEqual(t.anchor)||!this.focus.isEqual(t.focus))return!1;for(const e of this._ranges){let n=!1;for(const i of t._ranges)if(e.isEqual(i)){n=!0;break}if(!n)return!1}return!0}isSimilar(t){if(this.isBackward!=t.isBackward)return!1;const e=eo(this.getRanges());if(e!=eo(t.getRanges()))return!1;if(0==e)return!0;for(let e of this.getRanges()){e=e.getTrimmed();let n=!1;for(let i of t.getRanges())if(i=i.getTrimmed(),e.start.isEqual(i.start)&&e.end.isEqual(i.end)){n=!0;break}if(!n)return!1}return!0}getSelectedElement(){return 1!==this.rangeCount?null:this.getFirstRange().getContainedElement()}setTo(t,e,n){if(null===t)this._setRanges([]),this._setFakeOptions(e);else if(t instanceof no||t instanceof io)this._setRanges(t.getRanges(),t.isBackward),this._setFakeOptions({fake:t.isFake,label:t.fakeSelectionLabel});else if(t instanceof Xi)this._setRanges([t],e&&e.backward),this._setFakeOptions(e);else if(t instanceof Zi)this._setRanges([new Xi(t)]),this._setFakeOptions(e);else if(t instanceof On){const i=!!n&&!!n.backward;let o;if(void 0===e)throw new hn.b("view-selection-setTo-required-second-parameter: selection.setTo requires the second parameter when the first parameter is a node.",this);o="in"==e?Xi._createIn(t):"on"==e?Xi._createOn(t):new Xi(Zi._createAt(t,e)),this._setRanges([o],i),this._setFakeOptions(n)}else{if(!yn(t))throw new hn.b("view-selection-setTo-not-selectable: Cannot set selection to given place.",this);this._setRanges(t,e&&e.backward),this._setFakeOptions(e)}this.fire("change")}setFocus(t,e){if(null===this.anchor)throw new hn.b("view-selection-setFocus-no-ranges: Cannot set selection focus if there are no ranges in selection.",this);const n=Zi._createAt(t,e);if("same"==n.compareWith(this.focus))return;const i=this.anchor;this._ranges.pop(),"before"==n.compareWith(i)?this._addRange(new Xi(n,i),!0):this._addRange(new Xi(i,n)),this.fire("change")}is(t){return"selection"===t||"view:selection"===t}_setRanges(t,e=!1){t=Array.from(t),this._ranges=[];for(const e of t)this._addRange(e);this._lastRangeBackward=!!e}_setFakeOptions(t={}){this._isFake=!!t.fake,this._fakeSelectionLabel=t.fake&&t.label||""}_addRange(t,e=!1){if(!(t instanceof Xi))throw new hn.b("view-selection-add-range-not-range: Selection range set to an object that is not an instance of view.Range",this);this._pushRange(t),this._lastRangeBackward=!!e}_pushRange(t){for(const e of this._ranges)if(t.isIntersecting(e))throw new hn.b("view-selection-range-intersects: Trying to add a range that intersects with another range from selection.",this,{addedRange:t,intersectingRange:e});this._ranges.push(new Xi(t.start,t.end))}}xn(no,mn);class io{constructor(t=null,e,n){this._selection=new no,this._selection.delegate("change").to(this),this._selection.setTo(t,e,n)}get isFake(){return this._selection.isFake}get fakeSelectionLabel(){return this._selection.fakeSelectionLabel}get anchor(){return this._selection.anchor}get focus(){return this._selection.focus}get isCollapsed(){return this._selection.isCollapsed}get rangeCount(){return this._selection.rangeCount}get isBackward(){return this._selection.isBackward}get editableElement(){return this._selection.editableElement}get _ranges(){return this._selection._ranges}*getRanges(){yield*this._selection.getRanges()}getFirstRange(){return this._selection.getFirstRange()}getLastRange(){return this._selection.getLastRange()}getFirstPosition(){return this._selection.getFirstPosition()}getLastPosition(){return this._selection.getLastPosition()}getSelectedElement(){return this._selection.getSelectedElement()}isEqual(t){return this._selection.isEqual(t)}isSimilar(t){return this._selection.isSimilar(t)}is(t){return"selection"===t||"documentSelection"==t||"view:selection"==t||"view:documentSelection"==t}_setTo(t,e,n){this._selection.setTo(t,e,n)}_setFocus(t,e){this._selection.setFocus(t,e)}}xn(io,mn);class oo{constructor(t){this.selection=new io,this.roots=new An({idProperty:"rootName"}),this.stylesProcessor=t,this.set("isReadOnly",!1),this.set("isFocused",!1),this.set("isComposing",!1),this._postFixers=new Set}getRoot(t="main"){return this.roots.get(t)}registerPostFixer(t){this._postFixers.add(t)}destroy(){this.roots.map(t=>t.destroy()),this.stopListening()}_callPostFixers(t){let e=!1;do{for(const n of this._postFixers)if(e=n(t),e)break}while(e)}}xn(oo,Ui);class ro extends Oi{constructor(t,e,n,i){super(t,e,n,i),this.getFillerOffset=so,this._priority=10,this._id=null,this._clonesGroup=null}get priority(){return this._priority}get id(){return this._id}getElementsWithSameId(){if(null===this.id)throw new hn.b("attribute-element-get-elements-with-same-id-no-id: Cannot get elements with the same id for an attribute element without id.",this);return new Set(this._clonesGroup)}is(t,e=null){return e?e===this.name&&("attributeElement"===t||"view:attributeElement"===t||"element"===t||"view:element"===t):"attributeElement"===t||"view:attributeElement"===t||t===this.name||t==="view:"+this.name||"element"===t||"view:element"===t||"node"===t||"view:node"===t}isSimilar(t){return null!==this.id||null!==t.id?this.id===t.id:super.isSimilar(t)&&this.priority==t.priority}_clone(t){const e=super._clone(t);return e._priority=this._priority,e._id=this._id,e}}function so(){if(ao(this))return null;let t=this.parent;for(;t&&t.is("attributeElement");){if(ao(t)>1)return null;t=t.parent}return!t||ao(t)>1?null:this.childCount}function ao(t){return Array.from(t.getChildren()).filter(t=>!t.is("uiElement")).length}ro.DEFAULT_PRIORITY=10;class co extends Oi{constructor(t,e,n,i){super(t,e,n,i),this.getFillerOffset=lo}is(t,e=null){return e?e===this.name&&("emptyElement"===t||"view:emptyElement"===t||"element"===t||"view:element"===t):"emptyElement"===t||"view:emptyElement"===t||t===this.name||t==="view:"+this.name||"element"===t||"view:element"===t||"node"===t||"view:node"===t}_insertChild(t,e){if(e&&(e instanceof On||Array.from(e).length>0))throw new hn.b("view-emptyelement-cannot-add: Cannot add child nodes to EmptyElement instance.",[this,e])}}function lo(){return null}const uo=navigator.userAgent.toLowerCase();var ho={isMac:function(t){return t.indexOf("macintosh")>-1}(uo),isGecko:function(t){return!!t.match(/gecko\/\d+/)}(uo),isSafari:function(t){return t.indexOf(" applewebkit/")>-1&&-1===t.indexOf("chrome")}(uo),isAndroid:function(t){return t.indexOf("android")>-1}(uo),features:{isRegExpUnicodePropertySupported:function(){let t=!1;try{t=0==="ć".search(new RegExp("[\\p{L}]","u"))}catch(t){}return t}()}};const fo={"⌘":"ctrl","⇧":"shift","⌥":"alt"},go={ctrl:"⌘",shift:"⇧",alt:"⌥"},mo=function(){const t={arrowleft:37,arrowup:38,arrowright:39,arrowdown:40,backspace:8,delete:46,enter:13,space:32,esc:27,tab:9,ctrl:1114112,cmd:1114112,shift:2228224,alt:4456448};for(let e=65;e<=90;e++){const n=String.fromCharCode(e);t[n.toLowerCase()]=e}for(let e=48;e<=57;e++)t[e-48]=e;for(let e=112;e<=123;e++)t["f"+(e-111)]=e;return t}();function po(t){let e;if("string"==typeof t){if(e=mo[t.toLowerCase()],!e)throw new hn.b("keyboard-unknown-key: Unknown key name.",null,{key:t})}else e=t.keyCode+(t.altKey?mo.alt:0)+(t.ctrlKey?mo.ctrl:0)+(t.shiftKey?mo.shift:0);return e}function bo(t){return"string"==typeof t&&(t=yo(t)),t.map(t=>"string"==typeof t?po(t):t).reduce((t,e)=>e+t,0)}function wo(t){return ho.isMac?yo(t).map(t=>go[t.toLowerCase()]||t).reduce((t,e)=>t.slice(-1)in fo?t+e:t+"+"+e):t}function ko(t){return t==mo.arrowright||t==mo.arrowleft||t==mo.arrowup||t==mo.arrowdown}function _o(t,e){const n="ltr"===e;switch(t){case mo.arrowleft:return n?"left":"right";case mo.arrowright:return n?"right":"left";case mo.arrowup:return"up";case mo.arrowdown:return"down"}}function vo(t,e){const n=_o(t,e);return"down"===n||"right"===n}function yo(t){return t.split(/\s*\+\s*/)}class xo extends Oi{constructor(t,e,n,i){super(t,e,n,i),this.getFillerOffset=Co}is(t,e=null){return e?e===this.name&&("uiElement"===t||"view:uiElement"===t||"element"===t||"view:element"===t):"uiElement"===t||"view:uiElement"===t||t===this.name||t==="view:"+this.name||"element"===t||"view:element"===t||"node"===t||"view:node"===t}_insertChild(t,e){if(e&&(e instanceof On||Array.from(e).length>0))throw new hn.b("view-uielement-cannot-add: Cannot add child nodes to UIElement instance.",this)}render(t){return this.toDomElement(t)}toDomElement(t){const e=t.createElement(this.name);for(const t of this.getAttributeKeys())e.setAttribute(t,this.getAttribute(t));return e}}function Ao(t){t.document.on("keydown",(e,n)=>function(t,e,n){if(e.keyCode==mo.arrowright){const t=e.domTarget.ownerDocument.defaultView.getSelection(),i=1==t.rangeCount&&t.getRangeAt(0).collapsed;if(i||e.shiftKey){const e=t.focusNode,o=t.focusOffset,r=n.domPositionToView(e,o);if(null===r)return;let s=!1;const a=r.getLastMatchingPosition(t=>(t.item.is("uiElement")&&(s=!0),!(!t.item.is("uiElement")&&!t.item.is("attributeElement"))));if(s){const e=n.viewPositionToDom(a);i?t.collapse(e.parent,e.offset):t.extend(e.parent,e.offset)}}}}(0,n,t.domConverter))}function Co(){return null}class To{constructor(t,e){this.document=t,this._children=[],e&&this._insertChild(0,e)}[Symbol.iterator](){return this._children[Symbol.iterator]()}get childCount(){return this._children.length}get isEmpty(){return 0===this.childCount}get root(){return this}get parent(){return null}is(t){return"documentFragment"===t||"view:documentFragment"===t}_appendChild(t){return this._insertChild(this.childCount,t)}getChild(t){return this._children[t]}getChildIndex(t){return this._children.indexOf(t)}getChildren(){return this._children[Symbol.iterator]()}_insertChild(t,e){this._fireChange("children",this);let n=0;const i=function(t,e){if("string"==typeof e)return[new Rn(t,e)];yn(e)||(e=[e]);return Array.from(e).map(e=>"string"==typeof e?new Rn(t,e):e instanceof Dn?new Rn(t,e.data):e)}(this.document,e);for(const e of i)null!==e.parent&&e._remove(),e.parent=this,this._children.splice(t,0,e),t++,n++;return n}_removeChildren(t,e=1){this._fireChange("children",this);for(let n=t;n<t+e;n++)this._children[n].parent=null;return this._children.splice(t,e)}_fireChange(t,e){this.fire("change:"+t,e)}}xn(To,mn);class Po{constructor(t){this.document=t,this._cloneGroups=new Map}setSelection(t,e,n){this.document.selection._setTo(t,e,n)}setSelectionFocus(t,e){this.document.selection._setFocus(t,e)}createText(t){return new Rn(this.document,t)}createAttributeElement(t,e,n={}){const i=new ro(this.document,t,e);return n.priority&&(i._priority=n.priority),n.id&&(i._id=n.id),i}createContainerElement(t,e){return new Di(this.document,t,e)}createEditableElement(t,e){const n=new $i(this.document,t,e);return n._document=this.document,n}createEmptyElement(t,e){return new co(this.document,t,e)}createUIElement(t,e,n){const i=new xo(this.document,t,e);return n&&(i.render=n),i}setAttribute(t,e,n){n._setAttribute(t,e)}removeAttribute(t,e){e._removeAttribute(t)}addClass(t,e){e._addClass(t)}removeClass(t,e){e._removeClass(t)}setStyle(t,e,n){y(t)&&void 0===n&&(n=e),n._setStyle(t,e)}removeStyle(t,e){e._removeStyle(t)}setCustomProperty(t,e,n){n._setCustomProperty(t,e)}removeCustomProperty(t,e){return e._removeCustomProperty(t)}breakAttributes(t){return t instanceof Zi?this._breakAttributes(t):this._breakAttributesRange(t)}breakContainer(t){const e=t.parent;if(!e.is("containerElement"))throw new hn.b("view-writer-break-non-container-element: Trying to break an element which is not a container element.",this.document);if(!e.parent)throw new hn.b("view-writer-break-root: Trying to break root element.",this.document);if(t.isAtStart)return Zi._createBefore(e);if(!t.isAtEnd){const n=e._clone(!1);this.insert(Zi._createAfter(e),n);const i=new Xi(t,Zi._createAt(e,"end")),o=new Zi(n,0);this.move(i,o)}return Zi._createAfter(e)}mergeAttributes(t){const e=t.offset,n=t.parent;if(n.is("text"))return t;if(n.is("attributeElement")&&0===n.childCount){const t=n.parent,e=n.index;return n._remove(),this._removeFromClonedElementsGroup(n),this.mergeAttributes(new Zi(t,e))}const i=n.getChild(e-1),o=n.getChild(e);if(!i||!o)return t;if(i.is("text")&&o.is("text"))return No(i,o);if(i.is("attributeElement")&&o.is("attributeElement")&&i.isSimilar(o)){const t=i.childCount;return i._appendChild(o.getChildren()),o._remove(),this._removeFromClonedElementsGroup(o),this.mergeAttributes(new Zi(i,t))}return t}mergeContainers(t){const e=t.nodeBefore,n=t.nodeAfter;if(!(e&&n&&e.is("containerElement")&&n.is("containerElement")))throw new hn.b("view-writer-merge-containers-invalid-position: Element before and after given position cannot be merged.",this.document);const i=e.getChild(e.childCount-1),o=i instanceof Rn?Zi._createAt(i,"end"):Zi._createAt(e,"end");return this.move(Xi._createIn(n),Zi._createAt(e,"end")),this.remove(Xi._createOn(n)),o}insert(t,e){(function t(e,n){for(const i of e){if(!Oo.some(t=>i instanceof t))throw new hn.b("view-writer-insert-invalid-node",n);i.is("text")||t(i.getChildren(),n)}})(e=yn(e)?[...e]:[e],this.document);const n=So(t);if(!n)throw new hn.b("view-writer-invalid-position-container",this.document);const i=this._breakAttributes(t,!0),o=n._insertChild(i.offset,e);for(const t of e)this._addToClonedElementsGroup(t);const r=i.getShiftedBy(o),s=this.mergeAttributes(i);if(0===o)return new Xi(s,s);{s.isEqual(i)||r.offset--;const t=this.mergeAttributes(r);return new Xi(s,t)}}remove(t){const e=t instanceof Xi?t:Xi._createOn(t);if(Do(e,this.document),e.isCollapsed)return new To(this.document);const{start:n,end:i}=this._breakAttributesRange(e,!0),o=n.parent,r=i.offset-n.offset,s=o._removeChildren(n.offset,r);for(const t of s)this._removeFromClonedElementsGroup(t);const a=this.mergeAttributes(n);return e.start=a,e.end=a.clone(),new To(this.document,s)}clear(t,e){Do(t,this.document);const n=t.getWalker({direction:"backward",ignoreElementEnd:!0});for(const i of n){const n=i.item;let o;if(n.is("element")&&e.isSimilar(n))o=Xi._createOn(n);else if(!i.nextPosition.isAfter(t.start)&&n.is("textProxy")){const t=n.getAncestors().find(t=>t.is("element")&&e.isSimilar(t));t&&(o=Xi._createIn(t))}o&&(o.end.isAfter(t.end)&&(o.end=t.end),o.start.isBefore(t.start)&&(o.start=t.start),this.remove(o))}}move(t,e){let n;if(e.isAfter(t.end)){const i=(e=this._breakAttributes(e,!0)).parent,o=i.childCount;t=this._breakAttributesRange(t,!0),n=this.remove(t),e.offset+=i.childCount-o}else n=this.remove(t);return this.insert(e,n)}wrap(t,e){if(!(e instanceof ro))throw new hn.b("view-writer-wrap-invalid-attribute",this.document);if(Do(t,this.document),t.isCollapsed){let i=t.start;i.parent.is("element")&&(n=i.parent,!Array.from(n.getChildren()).some(t=>!t.is("uiElement")))&&(i=i.getLastMatchingPosition(t=>t.item.is("uiElement"))),i=this._wrapPosition(i,e);const o=this.document.selection;return o.isCollapsed&&o.getFirstPosition().isEqual(t.start)&&this.setSelection(i),new Xi(i)}return this._wrapRange(t,e);var n}unwrap(t,e){if(!(e instanceof ro))throw new hn.b("view-writer-unwrap-invalid-attribute",this.document);if(Do(t,this.document),t.isCollapsed)return t;const{start:n,end:i}=this._breakAttributesRange(t,!0),o=n.parent,r=this._unwrapChildren(o,n.offset,i.offset,e),s=this.mergeAttributes(r.start);s.isEqual(r.start)||r.end.offset--;const a=this.mergeAttributes(r.end);return new Xi(s,a)}rename(t,e){const n=new Di(this.document,t,e.getAttributes());return this.insert(Zi._createAfter(e),n),this.move(Xi._createIn(e),Zi._createAt(n,0)),this.remove(Xi._createOn(e)),n}clearClonedElementsGroup(t){this._cloneGroups.delete(t)}createPositionAt(t,e){return Zi._createAt(t,e)}createPositionAfter(t){return Zi._createAfter(t)}createPositionBefore(t){return Zi._createBefore(t)}createRange(t,e){return new Xi(t,e)}createRangeOn(t){return Xi._createOn(t)}createRangeIn(t){return Xi._createIn(t)}createSelection(t,e,n){return new no(t,e,n)}_wrapChildren(t,e,n,i){let o=e;const r=[];for(;o<n;){const e=t.getChild(o),n=e.is("text"),s=e.is("attributeElement"),a=e.is("emptyElement"),c=e.is("uiElement");if(s&&this._wrapAttributeElement(i,e))r.push(new Zi(t,o));else if(n||a||c||s&&Eo(i,e)){const n=i._clone();e._remove(),n._appendChild(e),t._insertChild(o,n),this._addToClonedElementsGroup(n),r.push(new Zi(t,o))}else s&&this._wrapChildren(e,0,e.childCount,i);o++}let s=0;for(const t of r){if(t.offset-=s,t.offset==e)continue;this.mergeAttributes(t).isEqual(t)||(s++,n--)}return Xi._createFromParentsAndOffsets(t,e,t,n)}_unwrapChildren(t,e,n,i){let o=e;const r=[];for(;o<n;){const e=t.getChild(o);if(e.is("attributeElement"))if(e.isSimilar(i)){const i=e.getChildren(),s=e.childCount;e._remove(),t._insertChild(o,i),this._removeFromClonedElementsGroup(e),r.push(new Zi(t,o),new Zi(t,o+s)),o+=s,n+=s-1}else this._unwrapAttributeElement(i,e)?(r.push(new Zi(t,o),new Zi(t,o+1)),o++):(this._unwrapChildren(e,0,e.childCount,i),o++);else o++}let s=0;for(const t of r){if(t.offset-=s,t.offset==e||t.offset==n)continue;this.mergeAttributes(t).isEqual(t)||(s++,n--)}return Xi._createFromParentsAndOffsets(t,e,t,n)}_wrapRange(t,e){const{start:n,end:i}=this._breakAttributesRange(t,!0),o=n.parent,r=this._wrapChildren(o,n.offset,i.offset,e),s=this.mergeAttributes(r.start);s.isEqual(r.start)||r.end.offset--;const a=this.mergeAttributes(r.end);return new Xi(s,a)}_wrapPosition(t,e){if(e.isSimilar(t.parent))return Mo(t.clone());t.parent.is("text")&&(t=Io(t));const n=this.createAttributeElement();n._priority=Number.POSITIVE_INFINITY,n.isSimilar=()=>!1,t.parent._insertChild(t.offset,n);const i=new Xi(t,t.getShiftedBy(1));this.wrap(i,e);const o=new Zi(n.parent,n.index);n._remove();const r=o.nodeBefore,s=o.nodeAfter;return r instanceof Rn&&s instanceof Rn?No(r,s):Mo(o)}_wrapAttributeElement(t,e){if(!Lo(t,e))return!1;if(t.name!==e.name||t.priority!==e.priority)return!1;for(const n of t.getAttributeKeys())if("class"!==n&&"style"!==n&&e.hasAttribute(n)&&e.getAttribute(n)!==t.getAttribute(n))return!1;for(const n of t.getStyleNames())if(e.hasStyle(n)&&e.getStyle(n)!==t.getStyle(n))return!1;for(const n of t.getAttributeKeys())"class"!==n&&"style"!==n&&(e.hasAttribute(n)||this.setAttribute(n,t.getAttribute(n),e));for(const n of t.getStyleNames())e.hasStyle(n)||this.setStyle(n,t.getStyle(n),e);for(const n of t.getClassNames())e.hasClass(n)||this.addClass(n,e);return!0}_unwrapAttributeElement(t,e){if(!Lo(t,e))return!1;if(t.name!==e.name||t.priority!==e.priority)return!1;for(const n of t.getAttributeKeys())if("class"!==n&&"style"!==n&&(!e.hasAttribute(n)||e.getAttribute(n)!==t.getAttribute(n)))return!1;if(!e.hasClass(...t.getClassNames()))return!1;for(const n of t.getStyleNames())if(!e.hasStyle(n)||e.getStyle(n)!==t.getStyle(n))return!1;for(const n of t.getAttributeKeys())"class"!==n&&"style"!==n&&this.removeAttribute(n,e);return this.removeClass(Array.from(t.getClassNames()),e),this.removeStyle(Array.from(t.getStyleNames()),e),!0}_breakAttributesRange(t,e=!1){const n=t.start,i=t.end;if(Do(t,this.document),t.isCollapsed){const n=this._breakAttributes(t.start,e);return new Xi(n,n)}const o=this._breakAttributes(i,e),r=o.parent.childCount,s=this._breakAttributes(n,e);return o.offset+=o.parent.childCount-r,new Xi(s,o)}_breakAttributes(t,e=!1){const n=t.offset,i=t.parent;if(t.parent.is("emptyElement"))throw new hn.b("view-writer-cannot-break-empty-element",this.document);if(t.parent.is("uiElement"))throw new hn.b("view-writer-cannot-break-ui-element",this.document);if(!e&&i.is("text")&&Ro(i.parent))return t.clone();if(Ro(i))return t.clone();if(i.is("text"))return this._breakAttributes(Io(t),e);if(n==i.childCount){const t=new Zi(i.parent,i.index+1);return this._breakAttributes(t,e)}if(0===n){const t=new Zi(i.parent,i.index);return this._breakAttributes(t,e)}{const t=i.index+1,o=i._clone();i.parent._insertChild(t,o),this._addToClonedElementsGroup(o);const r=i.childCount-n,s=i._removeChildren(n,r);o._appendChild(s);const a=new Zi(i.parent,t);return this._breakAttributes(a,e)}}_addToClonedElementsGroup(t){if(!t.root.is("rootElement"))return;if(t.is("element"))for(const e of t.getChildren())this._addToClonedElementsGroup(e);const e=t.id;if(!e)return;let n=this._cloneGroups.get(e);n||(n=new Set,this._cloneGroups.set(e,n)),n.add(t),t._clonesGroup=n}_removeFromClonedElementsGroup(t){if(t.is("element"))for(const e of t.getChildren())this._removeFromClonedElementsGroup(e);const e=t.id;if(!e)return;const n=this._cloneGroups.get(e);n&&n.delete(t)}}function So(t){let e=t.parent;for(;!Ro(e);){if(!e)return;e=e.parent}return e}function Eo(t,e){return t.priority<e.priority||!(t.priority>e.priority)&&t.getIdentity()<e.getIdentity()}function Mo(t){const e=t.nodeBefore;if(e&&e.is("text"))return new Zi(e,e.data.length);const n=t.nodeAfter;return n&&n.is("text")?new Zi(n,0):t}function Io(t){if(t.offset==t.parent.data.length)return new Zi(t.parent.parent,t.parent.index+1);if(0===t.offset)return new Zi(t.parent.parent,t.parent.index);const e=t.parent.data.slice(t.offset);return t.parent._data=t.parent.data.slice(0,t.offset),t.parent.parent._insertChild(t.parent.index+1,new Rn(t.root.document,e)),new Zi(t.parent.parent,t.parent.index+1)}function No(t,e){const n=t.data.length;return t._data+=e.data,e._remove(),new Zi(t,n)}const Oo=[Rn,ro,Di,co,xo];function Ro(t){return t&&(t.is("containerElement")||t.is("documentFragment"))}function Do(t,e){const n=So(t.start),i=So(t.end);if(!n||!i||n!==i)throw new hn.b("view-writer-invalid-range-container",e)}function Lo(t,e){return null===t.id&&null===e.id}function jo(t){return"[object Text]"==Object.prototype.toString.call(t)}const Vo=t=>t.createTextNode(" "),zo=t=>{const e=t.createElement("br");return e.dataset.ckeFiller=!0,e},Bo=(()=>{let t="";for(let e=0;e<7;e++)t+="​";return t})();function Fo(t){return jo(t)&&t.data.substr(0,7)===Bo}function Uo(t){return 7==t.data.length&&Fo(t)}function Ho(t){return Fo(t)?t.data.slice(7):t.data}function Wo(t,e){if(e.keyCode==mo.arrowleft){const t=e.domTarget.ownerDocument.defaultView.getSelection();if(1==t.rangeCount&&t.getRangeAt(0).collapsed){const e=t.getRangeAt(0).startContainer,n=t.getRangeAt(0).startOffset;Fo(e)&&n<=7&&t.collapse(e,0)}}}function qo(t,e,n,i=!1){n=n||function(t,e){return t===e},Array.isArray(t)||(t=Array.prototype.slice.call(t)),Array.isArray(e)||(e=Array.prototype.slice.call(e));const o=function(t,e,n){const i=Yo(t,e,n);if(-1===i)return{firstIndex:-1,lastIndexOld:-1,lastIndexNew:-1};const o=Go(t,i),r=Go(e,i),s=Yo(o,r,n),a=t.length-s,c=e.length-s;return{firstIndex:i,lastIndexOld:a,lastIndexNew:c}}(t,e,n);return i?function(t,e){const{firstIndex:n,lastIndexOld:i,lastIndexNew:o}=t;if(-1===n)return Array(e).fill("equal");let r=[];n>0&&(r=r.concat(Array(n).fill("equal")));o-n>0&&(r=r.concat(Array(o-n).fill("insert")));i-n>0&&(r=r.concat(Array(i-n).fill("delete")));o<e&&(r=r.concat(Array(e-o).fill("equal")));return r}(o,e.length):function(t,e){const n=[],{firstIndex:i,lastIndexOld:o,lastIndexNew:r}=e;r-i>0&&n.push({index:i,type:"insert",values:t.slice(i,r)});o-i>0&&n.push({index:i+(r-i),type:"delete",howMany:o-i});return n}(e,o)}function Yo(t,e,n){for(let i=0;i<Math.max(t.length,e.length);i++)if(void 0===t[i]||void 0===e[i]||!n(t[i],e[i]))return i;return-1}function Go(t,e){return t.slice(e).reverse()}function $o(t,e,n){n=n||function(t,e){return t===e};const i=t.length,o=e.length;if(i>200||o>200||i+o>300)return $o.fastDiff(t,e,n,!0);let r,s;if(o<i){const n=t;t=e,e=n,r="delete",s="insert"}else r="insert",s="delete";const a=t.length,c=e.length,l=c-a,d={},u={};function h(i){const o=(void 0!==u[i-1]?u[i-1]:-1)+1,l=void 0!==u[i+1]?u[i+1]:-1,h=o>l?-1:1;d[i+h]&&(d[i]=d[i+h].slice(0)),d[i]||(d[i]=[]),d[i].push(o>l?r:s);let f=Math.max(o,l),g=f-i;for(;g<a&&f<c&&n(t[g],e[f]);)g++,f++,d[i].push("equal");return f}let f,g=0;do{for(f=-g;f<l;f++)u[f]=h(f);for(f=l+g;f>l;f--)u[f]=h(f);u[l]=h(l),g++}while(u[l]!==c);return d[l].slice(1)}function Ko(t,e,n){t.insertBefore(n,t.childNodes[e]||null)}function Qo(t){const e=t.parentNode;e&&e.removeChild(t)}function Jo(t){if(t){if(t.defaultView)return t instanceof t.defaultView.Document;if(t.ownerDocument&&t.ownerDocument.defaultView)return t instanceof t.ownerDocument.defaultView.Node}return!1}$o.fastDiff=qo;class Zo{constructor(t,e){this.domDocuments=new Set,this.domConverter=t,this.markedAttributes=new Set,this.markedChildren=new Set,this.markedTexts=new Set,this.selection=e,this.isFocused=!1,this._inlineFiller=null,this._fakeSelectionContainer=null}markToSync(t,e){if("text"===t)this.domConverter.mapViewToDom(e.parent)&&this.markedTexts.add(e);else{if(!this.domConverter.mapViewToDom(e))return;if("attributes"===t)this.markedAttributes.add(e);else{if("children"!==t)throw new hn.b("view-renderer-unknown-type: Unknown type passed to Renderer.markToSync.",this);this.markedChildren.add(e)}}}render(){let t;for(const t of this.markedChildren)this._updateChildrenMappings(t);this._inlineFiller&&!this._isSelectionInInlineFiller()&&this._removeInlineFiller(),this._inlineFiller?t=this._getInlineFillerPosition():this._needsInlineFillerAtSelection()&&(t=this.selection.getFirstPosition(),this.markedChildren.add(t.parent));for(const t of this.markedAttributes)this._updateAttrs(t);for(const e of this.markedChildren)this._updateChildren(e,{inlineFillerPosition:t});for(const e of this.markedTexts)!this.markedChildren.has(e.parent)&&this.domConverter.mapViewToDom(e.parent)&&this._updateText(e,{inlineFillerPosition:t});if(t){const e=this.domConverter.viewPositionToDom(t),n=e.parent.ownerDocument;Fo(e.parent)?this._inlineFiller=e.parent:this._inlineFiller=Xo(n,e.parent,e.offset)}else this._inlineFiller=null;this._updateSelection(),this._updateFocus(),this.markedTexts.clear(),this.markedAttributes.clear(),this.markedChildren.clear()}_updateChildrenMappings(t){const e=this.domConverter.mapViewToDom(t);if(!e)return;const n=this.domConverter.mapViewToDom(t).childNodes,i=Array.from(this.domConverter.viewChildrenToDom(t,e.ownerDocument,{withChildren:!1})),o=this._diffNodeLists(n,i),r=this._findReplaceActions(o,n,i);if(-1!==r.indexOf("replace")){const e={equal:0,insert:0,delete:0};for(const o of r)if("replace"===o){const o=e.equal+e.insert,r=e.equal+e.delete,s=t.getChild(o);s&&!s.is("uiElement")&&this._updateElementMappings(s,n[r]),Qo(i[o]),e.equal++}else e[o]++}}_updateElementMappings(t,e){this.domConverter.unbindDomElement(e),this.domConverter.bindElements(e,t),this.markedChildren.add(t),this.markedAttributes.add(t)}_getInlineFillerPosition(){const t=this.selection.getFirstPosition();return t.parent.is("text")?Zi._createBefore(this.selection.getFirstPosition().parent):t}_isSelectionInInlineFiller(){if(1!=this.selection.rangeCount||!this.selection.isCollapsed)return!1;const t=this.selection.getFirstPosition(),e=this.domConverter.viewPositionToDom(t);return!!(e&&jo(e.parent)&&Fo(e.parent))}_removeInlineFiller(){const t=this._inlineFiller;if(!Fo(t))throw new hn.b("view-renderer-filler-was-lost: The inline filler node was lost.",this);Uo(t)?t.parentNode.removeChild(t):t.data=t.data.substr(7),this._inlineFiller=null}_needsInlineFillerAtSelection(){if(1!=this.selection.rangeCount||!this.selection.isCollapsed)return!1;const t=this.selection.getFirstPosition(),e=t.parent,n=t.offset;if(!this.domConverter.mapViewToDom(e.root))return!1;if(!e.is("element"))return!1;if(!function(t){if("false"==t.getAttribute("contenteditable"))return!1;const e=t.findAncestor(t=>t.hasAttribute("contenteditable"));return!e||"true"==e.getAttribute("contenteditable")}(e))return!1;if(n===e.getFillerOffset())return!1;const i=t.nodeBefore,o=t.nodeAfter;return!(i instanceof Rn||o instanceof Rn)}_updateText(t,e){const n=this.domConverter.findCorrespondingDomText(t),i=this.domConverter.viewToDom(t,n.ownerDocument),o=n.data;let r=i.data;const s=e.inlineFillerPosition;if(s&&s.parent==t.parent&&s.offset==t.index&&(r=Bo+r),o!=r){const t=qo(o,r);for(const e of t)"insert"===e.type?n.insertData(e.index,e.values.join("")):n.deleteData(e.index,e.howMany)}}_updateAttrs(t){const e=this.domConverter.mapViewToDom(t);if(!e)return;const n=Array.from(e.attributes).map(t=>t.name),i=t.getAttributeKeys();for(const n of i)e.setAttribute(n,t.getAttribute(n));for(const i of n)t.hasAttribute(i)||e.removeAttribute(i)}_updateChildren(t,e){const n=this.domConverter.mapViewToDom(t);if(!n)return;const i=e.inlineFillerPosition,o=this.domConverter.mapViewToDom(t).childNodes,r=Array.from(this.domConverter.viewChildrenToDom(t,n.ownerDocument,{bind:!0,inlineFillerPosition:i}));i&&i.parent===t&&Xo(n.ownerDocument,r,i.offset);const s=this._diffNodeLists(o,r);let a=0;const c=new Set;for(const t of s)"delete"===t?(c.add(o[a]),Qo(o[a])):"equal"===t&&a++;a=0;for(const t of s)"insert"===t?(Ko(n,a,r[a]),a++):"equal"===t&&(this._markDescendantTextToSync(this.domConverter.domToView(r[a])),a++);for(const t of c)t.parentNode||this.domConverter.unbindDomElement(t)}_diffNodeLists(t,e){return $o(t=function(t,e){const n=Array.from(t);if(0==n.length||!e)return n;n[n.length-1]==e&&n.pop();return n}(t,this._fakeSelectionContainer),e,er.bind(null,this.domConverter))}_findReplaceActions(t,e,n){if(-1===t.indexOf("insert")||-1===t.indexOf("delete"))return t;let i=[],o=[],r=[];const s={equal:0,insert:0,delete:0};for(const a of t)"insert"===a?r.push(n[s.equal+s.insert]):"delete"===a?o.push(e[s.equal+s.delete]):(i=i.concat($o(o,r,tr).map(t=>"equal"===t?"replace":t)),i.push("equal"),o=[],r=[]),s[a]++;return i.concat($o(o,r,tr).map(t=>"equal"===t?"replace":t))}_markDescendantTextToSync(t){if(t)if(t.is("text"))this.markedTexts.add(t);else if(t.is("element"))for(const e of t.getChildren())this._markDescendantTextToSync(e)}_updateSelection(){if(0===this.selection.rangeCount)return this._removeDomSelection(),void this._removeFakeSelection();const t=this.domConverter.mapViewToDom(this.selection.editableElement);this.isFocused&&t&&(this.selection.isFake?this._updateFakeSelection(t):(this._removeFakeSelection(),this._updateDomSelection(t)))}_updateFakeSelection(t){const e=t.ownerDocument;this._fakeSelectionContainer||(this._fakeSelectionContainer=function(t){const e=t.createElement("div");return Object.assign(e.style,{position:"fixed",top:0,left:"-9999px",width:"42px"}),e.textContent=" ",e}(e));const n=this._fakeSelectionContainer;if(this.domConverter.bindFakeSelection(n,this.selection),!this._fakeSelectionNeedsUpdate(t))return;n.parentElement&&n.parentElement==t||t.appendChild(n),n.textContent=this.selection.fakeSelectionLabel||" ";const i=e.getSelection(),o=e.createRange();i.removeAllRanges(),o.selectNodeContents(n),i.addRange(o)}_updateDomSelection(t){const e=t.ownerDocument.defaultView.getSelection();if(!this._domSelectionNeedsUpdate(e))return;const n=this.domConverter.viewPositionToDom(this.selection.anchor),i=this.domConverter.viewPositionToDom(this.selection.focus);t.focus(),e.collapse(n.parent,n.offset),e.extend(i.parent,i.offset),ho.isGecko&&function(t,e){const n=t.parent;if(n.nodeType!=Node.ELEMENT_NODE||t.offset!=n.childNodes.length-1)return;const i=n.childNodes[t.offset];i&&"BR"==i.tagName&&e.addRange(e.getRangeAt(0))}(i,e)}_domSelectionNeedsUpdate(t){if(!this.domConverter.isDomSelectionCorrect(t))return!0;const e=t&&this.domConverter.domSelectionToView(t);return(!e||!this.selection.isEqual(e))&&!(!this.selection.isCollapsed&&this.selection.isSimilar(e))}_fakeSelectionNeedsUpdate(t){const e=this._fakeSelectionContainer,n=t.ownerDocument.getSelection();return!e||e.parentElement!==t||(n.anchorNode!==e&&!e.contains(n.anchorNode)||e.textContent!==this.selection.fakeSelectionLabel)}_removeDomSelection(){for(const t of this.domDocuments){if(t.getSelection().rangeCount){const e=t.activeElement,n=this.domConverter.mapDomToView(e);e&&n&&t.getSelection().removeAllRanges()}}}_removeFakeSelection(){const t=this._fakeSelectionContainer;t&&t.remove()}_updateFocus(){if(this.isFocused){const t=this.selection.editableElement;t&&this.domConverter.focus(t)}}}function Xo(t,e,n){const i=e instanceof Array?e:e.childNodes,o=i[n];if(jo(o))return o.data=Bo+o.data,o;{const o=t.createTextNode(Bo);return Array.isArray(e)?i.splice(n,0,o):Ko(e,n,o),o}}function tr(t,e){return Jo(t)&&Jo(e)&&!jo(t)&&!jo(e)&&t.nodeType!==Node.COMMENT_NODE&&e.nodeType!==Node.COMMENT_NODE&&t.tagName.toLowerCase()===e.tagName.toLowerCase()}function er(t,e,n){return e===n||(jo(e)&&jo(n)?e.data===n.data:!(!t.isBlockFiller(e)||!t.isBlockFiller(n)))}xn(Zo,Ui);var nr={window:window,document:document};function ir(t){let e=0;for(;t.previousSibling;)t=t.previousSibling,e++;return e}function or(t){const e=[];for(;t&&t.nodeType!=Node.DOCUMENT_NODE;)e.unshift(t),t=t.parentNode;return e}const rr=zo(document);class sr{constructor(t,e={}){this.document=t,this.blockFillerMode=e.blockFillerMode||"br",this.preElements=["pre"],this.blockElements=["p","div","h1","h2","h3","h4","h5","h6","li","dd","dt","figcaption"],this._blockFiller="br"==this.blockFillerMode?zo:Vo,this._domToViewMapping=new WeakMap,this._viewToDomMapping=new WeakMap,this._fakeSelectionMapping=new WeakMap}bindFakeSelection(t,e){this._fakeSelectionMapping.set(t,new no(e))}fakeSelectionToView(t){return this._fakeSelectionMapping.get(t)}bindElements(t,e){this._domToViewMapping.set(t,e),this._viewToDomMapping.set(e,t)}unbindDomElement(t){const e=this._domToViewMapping.get(t);if(e){this._domToViewMapping.delete(t),this._viewToDomMapping.delete(e);for(const e of t.childNodes)this.unbindDomElement(e)}}bindDocumentFragments(t,e){this._domToViewMapping.set(t,e),this._viewToDomMapping.set(e,t)}viewToDom(t,e,n={}){if(t.is("text")){const n=this._processDataFromViewText(t);return e.createTextNode(n)}{if(this.mapViewToDom(t))return this.mapViewToDom(t);let i;if(t.is("documentFragment"))i=e.createDocumentFragment(),n.bind&&this.bindDocumentFragments(i,t);else{if(t.is("uiElement"))return i=t.render(e),n.bind&&this.bindElements(i,t),i;i=t.hasAttribute("xmlns")?e.createElementNS(t.getAttribute("xmlns"),t.name):e.createElement(t.name),n.bind&&this.bindElements(i,t);for(const e of t.getAttributeKeys())i.setAttribute(e,t.getAttribute(e))}if(n.withChildren||void 0===n.withChildren)for(const o of this.viewChildrenToDom(t,e,n))i.appendChild(o);return i}}*viewChildrenToDom(t,e,n={}){const i=t.getFillerOffset&&t.getFillerOffset();let o=0;for(const r of t.getChildren())i===o&&(yield this._blockFiller(e)),yield this.viewToDom(r,e,n),o++;i===o&&(yield this._blockFiller(e))}viewRangeToDom(t){const e=this.viewPositionToDom(t.start),n=this.viewPositionToDom(t.end),i=document.createRange();return i.setStart(e.parent,e.offset),i.setEnd(n.parent,n.offset),i}viewPositionToDom(t){const e=t.parent;if(e.is("text")){const n=this.findCorrespondingDomText(e);if(!n)return null;let i=t.offset;return Fo(n)&&(i+=7),{parent:n,offset:i}}{let n,i,o;if(0===t.offset){if(n=this.mapViewToDom(e),!n)return null;o=n.childNodes[0]}else{const e=t.nodeBefore;if(i=e.is("text")?this.findCorrespondingDomText(e):this.mapViewToDom(t.nodeBefore),!i)return null;n=i.parentNode,o=i.nextSibling}if(jo(o)&&Fo(o))return{parent:o,offset:7};return{parent:n,offset:i?ir(i)+1:0}}}domToView(t,e={}){if(this.isBlockFiller(t,this.blockFillerMode))return null;const n=this.getParentUIElement(t,this._domToViewMapping);if(n)return n;if(jo(t)){if(Uo(t))return null;{const e=this._processDataFromDomText(t);return""===e?null:new Rn(this.document,e)}}if(this.isComment(t))return null;{if(this.mapDomToView(t))return this.mapDomToView(t);let n;if(this.isDocumentFragment(t))n=new To(this.document),e.bind&&this.bindDocumentFragments(t,n);else{const i=e.keepOriginalCase?t.tagName:t.tagName.toLowerCase();n=new Oi(this.document,i),e.bind&&this.bindElements(t,n);const o=t.attributes;for(let t=o.length-1;t>=0;t--)n._setAttribute(o[t].name,o[t].value)}if(e.withChildren||void 0===e.withChildren)for(const i of this.domChildrenToView(t,e))n._appendChild(i);return n}}*domChildrenToView(t,e={}){for(let n=0;n<t.childNodes.length;n++){const i=t.childNodes[n],o=this.domToView(i,e);null!==o&&(yield o)}}domSelectionToView(t){if(1===t.rangeCount){let e=t.getRangeAt(0).startContainer;jo(e)&&(e=e.parentNode);const n=this.fakeSelectionToView(e);if(n)return n}const e=this.isDomSelectionBackward(t),n=[];for(let e=0;e<t.rangeCount;e++){const i=t.getRangeAt(e),o=this.domRangeToView(i);o&&n.push(o)}return new no(n,{backward:e})}domRangeToView(t){const e=this.domPositionToView(t.startContainer,t.startOffset),n=this.domPositionToView(t.endContainer,t.endOffset);return e&&n?new Xi(e,n):null}domPositionToView(t,e){if(this.isBlockFiller(t,this.blockFillerMode))return this.domPositionToView(t.parentNode,ir(t));const n=this.mapDomToView(t);if(n&&n.is("uiElement"))return Zi._createBefore(n);if(jo(t)){if(Uo(t))return this.domPositionToView(t.parentNode,ir(t));const n=this.findCorrespondingViewText(t);let i=e;return n?(Fo(t)&&(i-=7,i=i<0?0:i),new Zi(n,i)):null}if(0===e){const e=this.mapDomToView(t);if(e)return new Zi(e,0)}else{const n=t.childNodes[e-1],i=jo(n)?this.findCorrespondingViewText(n):this.mapDomToView(n);if(i&&i.parent)return new Zi(i.parent,i.index+1)}return null}mapDomToView(t){return this.getParentUIElement(t)||this._domToViewMapping.get(t)}findCorrespondingViewText(t){if(Uo(t))return null;const e=this.getParentUIElement(t);if(e)return e;const n=t.previousSibling;if(n){if(!this.isElement(n))return null;const t=this.mapDomToView(n);if(t){return t.nextSibling instanceof Rn?t.nextSibling:null}}else{const e=this.mapDomToView(t.parentNode);if(e){const t=e.getChild(0);return t instanceof Rn?t:null}}return null}mapViewToDom(t){return this._viewToDomMapping.get(t)}findCorrespondingDomText(t){const e=t.previousSibling;return e&&this.mapViewToDom(e)?this.mapViewToDom(e).nextSibling:!e&&t.parent&&this.mapViewToDom(t.parent)?this.mapViewToDom(t.parent).childNodes[0]:null}focus(t){const e=this.mapViewToDom(t);if(e&&e.ownerDocument.activeElement!==e){const{scrollX:t,scrollY:n}=nr.window,i=[];cr(e,t=>{const{scrollLeft:e,scrollTop:n}=t;i.push([e,n])}),e.focus(),cr(e,t=>{const[e,n]=i.shift();t.scrollLeft=e,t.scrollTop=n}),nr.window.scrollTo(t,n)}}isElement(t){return t&&t.nodeType==Node.ELEMENT_NODE}isDocumentFragment(t){return t&&t.nodeType==Node.DOCUMENT_FRAGMENT_NODE}isComment(t){return t&&t.nodeType==Node.COMMENT_NODE}isBlockFiller(t){return"br"==this.blockFillerMode?t.isEqualNode(rr):!("BR"!==t.tagName||!lr(t,this.blockElements)||1!==t.parentNode.childNodes.length)||function(t,e){return jo(t)&&" "==t.data&&lr(t,e)&&1===t.parentNode.childNodes.length}(t,this.blockElements)}isDomSelectionBackward(t){if(t.isCollapsed)return!1;const e=document.createRange();e.setStart(t.anchorNode,t.anchorOffset),e.setEnd(t.focusNode,t.focusOffset);const n=e.collapsed;return e.detach(),n}getParentUIElement(t){const e=or(t);for(e.pop();e.length;){const t=e.pop(),n=this._domToViewMapping.get(t);if(n&&n.is("uiElement"))return n}return null}isDomSelectionCorrect(t){return this._isDomSelectionPositionCorrect(t.anchorNode,t.anchorOffset)&&this._isDomSelectionPositionCorrect(t.focusNode,t.focusOffset)}_isDomSelectionPositionCorrect(t,e){if(jo(t)&&Fo(t)&&e<7)return!1;if(this.isElement(t)&&Fo(t.childNodes[e]))return!1;const n=this.mapDomToView(t);return!n||!n.is("uiElement")}_processDataFromViewText(t){let e=t.data;if(t.getAncestors().some(t=>this.preElements.includes(t.name)))return e;if(" "==e.charAt(0)){const n=this._getTouchingViewTextNode(t,!1);!(n&&this._nodeEndsWithSpace(n))&&n||(e=" "+e.substr(1))}if(" "==e.charAt(e.length-1)){const n=this._getTouchingViewTextNode(t,!0);" "!=e.charAt(e.length-2)&&n&&" "!=n.data.charAt(0)||(e=e.substr(0,e.length-1)+" ")}return e.replace(/ {2}/g,"  ")}_nodeEndsWithSpace(t){if(t.getAncestors().some(t=>this.preElements.includes(t.name)))return!1;const e=this._processDataFromViewText(t);return" "==e.charAt(e.length-1)}_processDataFromDomText(t){let e=t.data;if(ar(t,this.preElements))return Ho(t);e=e.replace(/[ \n\t\r]{1,}/g," ");const n=this._getTouchingInlineDomNode(t,!1),i=this._getTouchingInlineDomNode(t,!0),o=this._checkShouldLeftTrimDomText(n),r=this._checkShouldRightTrimDomText(t,i);return o&&(e=e.replace(/^ /,"")),r&&(e=e.replace(/ $/,"")),e=Ho(new Text(e)),e=e.replace(/ \u00A0/g,"  "),(/( |\u00A0)\u00A0$/.test(e)||!i||i.data&&" "==i.data.charAt(0))&&(e=e.replace(/\u00A0$/," ")),o&&(e=e.replace(/^\u00A0/," ")),e}_checkShouldLeftTrimDomText(t){return!t||(!!nn(t)||/[^\S\u00A0]/.test(t.data.charAt(t.data.length-1)))}_checkShouldRightTrimDomText(t,e){return!e&&!Fo(t)}_getTouchingViewTextNode(t,e){const n=new Ji({startPosition:e?Zi._createAfter(t):Zi._createBefore(t),direction:e?"forward":"backward"});for(const t of n){if(t.item.is("containerElement"))return null;if(t.item.is("br"))return null;if(t.item.is("textProxy"))return t.item}return null}_getTouchingInlineDomNode(t,e){if(!t.parentNode)return null;const n=e?"nextNode":"previousNode",i=t.ownerDocument,o=or(t)[0],r=i.createTreeWalker(o,NodeFilter.SHOW_TEXT|NodeFilter.SHOW_ELEMENT,{acceptNode:t=>jo(t)||"BR"==t.tagName?NodeFilter.FILTER_ACCEPT:NodeFilter.FILTER_SKIP});r.currentNode=t;const s=r[n]();if(null!==s){const e=function(t,e){const n=or(t),i=or(e);let o=0;for(;n[o]==i[o]&&n[o];)o++;return 0===o?null:n[o-1]}(t,s);if(e&&!ar(t,this.blockElements,e)&&!ar(s,this.blockElements,e))return s}return null}}function ar(t,e,n){let i=or(t);return n&&(i=i.slice(i.indexOf(n)+1)),i.some(t=>t.tagName&&e.includes(t.tagName.toLowerCase()))}function cr(t,e){for(;t&&t!=nr.document;)e(t),t=t.parentNode}function lr(t,e){const n=t.parentNode;return n&&n.tagName&&e.includes(n.tagName.toLowerCase())}function dr(t){const e=Object.prototype.toString.apply(t);return"[object Window]"==e||"[object global]"==e}var ur=ji({},mn,{listenTo(t,...e){if(Jo(t)||dr(t)){const n=this._getProxyEmitter(t)||new hr(t);n.attach(...e),t=n}mn.listenTo.call(this,t,...e)},stopListening(t,e,n){if(Jo(t)||dr(t)){const e=this._getProxyEmitter(t);if(!e)return;t=e}mn.stopListening.call(this,t,e,n),t instanceof hr&&t.detach(e)},_getProxyEmitter(t){return e=this,n=fr(t),e[fn]&&e[fn][n]?e[fn][n].emitter:null;var e,n}});class hr{constructor(t){pn(this,fr(t)),this._domNode=t}}function fr(t){return t["data-ck-expando"]||(t["data-ck-expando"]=dn())}ji(hr.prototype,mn,{attach(t,e,n={}){if(this._domListeners&&this._domListeners[t])return;const i=this._createDomListener(t,!!n.useCapture);this._domNode.addEventListener(t,i,!!n.useCapture),this._domListeners||(this._domListeners={}),this._domListeners[t]=i},detach(t){let e;!this._domListeners[t]||(e=this._events[t])&&e.callbacks.length||this._domListeners[t].removeListener()},_createDomListener(t,e){const n=e=>{this.fire(t,e)};return n.removeListener=()=>{this._domNode.removeEventListener(t,n,e),delete this._domListeners[t]},n}});class gr{constructor(t){this.view=t,this.document=t.document,this.isEnabled=!1}enable(){this.isEnabled=!0}disable(){this.isEnabled=!1}destroy(){this.disable(),this.stopListening()}}xn(gr,ur);var mr=function(t){return this.__data__.set(t,"__lodash_hash_undefined__"),this};var pr=function(t){return this.__data__.has(t)};function br(t){var e=-1,n=null==t?0:t.length;for(this.__data__=new kt;++e<n;)this.add(t[e])}br.prototype.add=br.prototype.push=mr,br.prototype.has=pr;var wr=br;var kr=function(t,e){for(var n=-1,i=null==t?0:t.length;++n<i;)if(e(t[n],n,t))return!0;return!1};var _r=function(t,e){return t.has(e)};var vr=function(t,e,n,i,o,r){var s=1&n,a=t.length,c=e.length;if(a!=c&&!(s&&c>a))return!1;var l=r.get(t);if(l&&r.get(e))return l==e;var d=-1,u=!0,h=2&n?new wr:void 0;for(r.set(t,e),r.set(e,t);++d<a;){var f=t[d],g=e[d];if(i)var m=s?i(g,f,d,e,t,r):i(f,g,d,t,e,r);if(void 0!==m){if(m)continue;u=!1;break}if(h){if(!kr(e,(function(t,e){if(!_r(h,e)&&(f===t||o(f,t,n,i,r)))return h.push(e)}))){u=!1;break}}else if(f!==g&&!o(f,g,n,i,r)){u=!1;break}}return r.delete(t),r.delete(e),u};var yr=function(t){var e=-1,n=Array(t.size);return t.forEach((function(t,i){n[++e]=[i,t]})),n};var xr=function(t){var e=-1,n=Array(t.size);return t.forEach((function(t){n[++e]=t})),n},Ar=o?o.prototype:void 0,Cr=Ar?Ar.valueOf:void 0;var Tr=function(t,e,n,i,o,r,s){switch(n){case"[object DataView]":if(t.byteLength!=e.byteLength||t.byteOffset!=e.byteOffset)return!1;t=t.buffer,e=e.buffer;case"[object ArrayBuffer]":return!(t.byteLength!=e.byteLength||!r(new Re(t),new Re(e)));case"[object Boolean]":case"[object Date]":case"[object Number]":return A(+t,+e);case"[object Error]":return t.name==e.name&&t.message==e.message;case"[object RegExp]":case"[object String]":return t==e+"";case"[object Map]":var a=yr;case"[object Set]":var c=1&i;if(a||(a=xr),t.size!=e.size&&!c)return!1;var l=s.get(t);if(l)return l==e;i|=2,s.set(t,e);var d=vr(a(t),a(e),i,o,r,s);return s.delete(t),d;case"[object Symbol]":if(Cr)return Cr.call(t)==Cr.call(e)}return!1},Pr=Object.prototype.hasOwnProperty;var Sr=function(t,e,n,i,o,r){var s=1&n,a=ke(t),c=a.length;if(c!=ke(e).length&&!s)return!1;for(var l=c;l--;){var d=a[l];if(!(s?d in e:Pr.call(e,d)))return!1}var u=r.get(t);if(u&&r.get(e))return u==e;var h=!0;r.set(t,e),r.set(e,t);for(var f=s;++l<c;){var g=t[d=a[l]],m=e[d];if(i)var p=s?i(m,g,d,e,t,r):i(g,m,d,t,e,r);if(!(void 0===p?g===m||o(g,m,n,i,r):p)){h=!1;break}f||(f="constructor"==d)}if(h&&!f){var b=t.constructor,w=e.constructor;b==w||!("constructor"in t)||!("constructor"in e)||"function"==typeof b&&b instanceof b&&"function"==typeof w&&w instanceof w||(h=!1)}return r.delete(t),r.delete(e),h},Er=Object.prototype.hasOwnProperty;var Mr=function(t,e,n,i,o,r){var s=Dt(t),a=Dt(e),c=s?"[object Array]":Ie(t),l=a?"[object Array]":Ie(e),d="[object Object]"==(c="[object Arguments]"==c?"[object Object]":c),u="[object Object]"==(l="[object Arguments]"==l?"[object Object]":l),h=c==l;if(h&&Object(Lt.a)(t)){if(!Object(Lt.a)(e))return!1;s=!0,d=!1}if(h&&!d)return r||(r=new yt),s||qt(t)?vr(t,e,n,i,o,r):Tr(t,e,c,n,i,o,r);if(!(1&n)){var f=d&&Er.call(t,"__wrapped__"),g=u&&Er.call(e,"__wrapped__");if(f||g){var m=f?t.value():t,p=g?e.value():e;return r||(r=new yt),o(m,p,n,i,r)}}return!!h&&(r||(r=new yt),Sr(t,e,n,i,o,r))};var Ir=function t(e,n,i,o,r){return e===n||(null==e||null==n||!p(e)&&!p(n)?e!=e&&n!=n:Mr(e,n,i,o,t,r))};var Nr=function(t,e,n){var i=(n="function"==typeof n?n:void 0)?n(t,e):void 0;return void 0===i?Ir(t,e,void 0,n):!!i};class Or extends gr{constructor(t){super(t),this._config={childList:!0,characterData:!0,characterDataOldValue:!0,subtree:!0},this.domConverter=t.domConverter,this.renderer=t._renderer,this._domElements=[],this._mutationObserver=new window.MutationObserver(this._onMutations.bind(this))}flush(){this._onMutations(this._mutationObserver.takeRecords())}observe(t){this._domElements.push(t),this.isEnabled&&this._mutationObserver.observe(t,this._config)}enable(){super.enable();for(const t of this._domElements)this._mutationObserver.observe(t,this._config)}disable(){super.disable(),this._mutationObserver.disconnect()}destroy(){super.destroy(),this._mutationObserver.disconnect()}_onMutations(t){if(0===t.length)return;const e=this.domConverter,n=new Map,i=new Set;for(const n of t)if("childList"===n.type){const t=e.mapDomToView(n.target);if(t&&t.is("uiElement"))continue;t&&!this._isBogusBrMutation(n)&&i.add(t)}for(const o of t){const t=e.mapDomToView(o.target);if((!t||!t.is("uiElement"))&&"characterData"===o.type){const t=e.findCorrespondingViewText(o.target);t&&!i.has(t.parent)?n.set(t,{type:"text",oldText:t.data,newText:Ho(o.target),node:t}):!t&&Fo(o.target)&&i.add(e.mapDomToView(o.target.parentNode))}}const o=[];for(const t of n.values())this.renderer.markToSync("text",t.node),o.push(t);for(const t of i){const n=e.mapViewToDom(t),i=Array.from(t.getChildren()),r=Array.from(e.domChildrenToView(n,{withChildren:!1}));Nr(i,r,a)||(this.renderer.markToSync("children",t),o.push({type:"children",oldChildren:i,newChildren:r,node:t}))}const r=t[0].target.ownerDocument.getSelection();let s=null;if(r&&r.anchorNode){const t=e.domPositionToView(r.anchorNode,r.anchorOffset),n=e.domPositionToView(r.focusNode,r.focusOffset);t&&n&&(s=new no(t),s.setFocus(n))}function a(t,e){if(!Array.isArray(t))return t===e||!(!t.is("text")||!e.is("text"))&&t.data===e.data}o.length&&(this.document.fire("mutations",o,s),this.view.forceRender())}_isBogusBrMutation(t){let e=null;return null===t.nextSibling&&0===t.removedNodes.length&&1==t.addedNodes.length&&(e=this.domConverter.domToView(t.addedNodes[0],{withChildren:!1})),e&&e.is("element","br")}}class Rr{constructor(t,e,n){this.view=t,this.document=t.document,this.domEvent=e,this.domTarget=e.target,ji(this,n)}get target(){return this.view.domConverter.mapDomToView(this.domTarget)}preventDefault(){this.domEvent.preventDefault()}stopPropagation(){this.domEvent.stopPropagation()}}class Dr extends gr{constructor(t){super(t),this.useCapture=!1}observe(t){("string"==typeof this.domEventType?[this.domEventType]:this.domEventType).forEach(e=>{this.listenTo(t,e,(t,e)=>{this.isEnabled&&this.onDomEvent(e)},{useCapture:this.useCapture})})}fire(t,e,n){this.isEnabled&&this.document.fire(t,new Rr(this.view,e,n))}}class Lr extends Dr{constructor(t){super(t),this.domEventType=["keydown","keyup"]}onDomEvent(t){this.fire(t.type,t,{keyCode:t.keyCode,altKey:t.altKey,ctrlKey:t.ctrlKey||t.metaKey,shiftKey:t.shiftKey,get keystroke(){return po(this)}})}}var jr=function(){return i.a.Date.now()},Vr=/^\s+|\s+$/g,zr=/^[-+]0x[0-9a-f]+$/i,Br=/^0b[01]+$/i,Fr=/^0o[0-7]+$/i,Ur=parseInt;var Hr=function(t){if("number"==typeof t)return t;if(zn(t))return NaN;if(j(t)){var e="function"==typeof t.valueOf?t.valueOf():t;t=j(e)?e+"":e}if("string"!=typeof t)return 0===t?t:+t;t=t.replace(Vr,"");var n=Br.test(t);return n||Fr.test(t)?Ur(t.slice(2),n?2:8):zr.test(t)?NaN:+t},Wr=Math.max,qr=Math.min;var Yr=function(t,e,n){var i,o,r,s,a,c,l=0,d=!1,u=!1,h=!0;if("function"!=typeof t)throw new TypeError("Expected a function");function f(e){var n=i,r=o;return i=o=void 0,l=e,s=t.apply(r,n)}function g(t){return l=t,a=setTimeout(p,e),d?f(t):s}function m(t){var n=t-c;return void 0===c||n>=e||n<0||u&&t-l>=r}function p(){var t=jr();if(m(t))return b(t);a=setTimeout(p,function(t){var n=e-(t-c);return u?qr(n,r-(t-l)):n}(t))}function b(t){return a=void 0,h&&i?f(t):(i=o=void 0,s)}function w(){var t=jr(),n=m(t);if(i=arguments,o=this,c=t,n){if(void 0===a)return g(c);if(u)return clearTimeout(a),a=setTimeout(p,e),f(c)}return void 0===a&&(a=setTimeout(p,e)),s}return e=Hr(e)||0,j(n)&&(d=!!n.leading,r=(u="maxWait"in n)?Wr(Hr(n.maxWait)||0,e):r,h="trailing"in n?!!n.trailing:h),w.cancel=function(){void 0!==a&&clearTimeout(a),l=0,i=c=o=a=void 0},w.flush=function(){return void 0===a?s:b(jr())},w};class Gr extends gr{constructor(t){super(t),this._fireSelectionChangeDoneDebounced=Yr(t=>this.document.fire("selectionChangeDone",t),200)}observe(){const t=this.document;t.on("keydown",(e,n)=>{var i;t.selection.isFake&&((i=n.keyCode)==mo.arrowright||i==mo.arrowleft||i==mo.arrowup||i==mo.arrowdown)&&this.isEnabled&&(n.preventDefault(),this._handleSelectionMove(n.keyCode))},{priority:"lowest"})}destroy(){super.destroy(),this._fireSelectionChangeDoneDebounced.cancel()}_handleSelectionMove(t){const e=this.document.selection,n=new no(e.getRanges(),{backward:e.isBackward,fake:!1});t!=mo.arrowleft&&t!=mo.arrowup||n.setTo(n.getFirstPosition()),t!=mo.arrowright&&t!=mo.arrowdown||n.setTo(n.getLastPosition());const i={oldSelection:e,newSelection:n,domSelection:null};this.document.fire("selectionChange",i),this._fireSelectionChangeDoneDebounced(i)}}class $r extends gr{constructor(t){super(t),this.mutationObserver=t.getObserver(Or),this.selection=this.document.selection,this.domConverter=t.domConverter,this._documents=new WeakSet,this._fireSelectionChangeDoneDebounced=Yr(t=>this.document.fire("selectionChangeDone",t),200),this._clearInfiniteLoopInterval=setInterval(()=>this._clearInfiniteLoop(),1e3),this._loopbackCounter=0}observe(t){const e=t.ownerDocument;this._documents.has(e)||(this.listenTo(e,"selectionchange",()=>{this._handleSelectionChange(e)}),this._documents.add(e))}destroy(){super.destroy(),clearInterval(this._clearInfiniteLoopInterval),this._fireSelectionChangeDoneDebounced.cancel()}_handleSelectionChange(t){if(!this.isEnabled)return;this.mutationObserver.flush();const e=t.defaultView.getSelection(),n=this.domConverter.domSelectionToView(e);if(0!=n.rangeCount){if(this.view.hasDomSelection=!0,!(this.selection.isEqual(n)&&this.domConverter.isDomSelectionCorrect(e)||++this._loopbackCounter>60))if(this.selection.isSimilar(n))this.view.forceRender();else{const t={oldSelection:this.selection,newSelection:n,domSelection:e};this.document.fire("selectionChange",t),this._fireSelectionChangeDoneDebounced(t)}}else this.view.hasDomSelection=!1}_clearInfiniteLoop(){this._loopbackCounter=0}}class Kr extends Dr{constructor(t){super(t),this.domEventType=["focus","blur"],this.useCapture=!0;const e=this.document;e.on("focus",()=>{e.isFocused=!0,this._renderTimeoutId=setTimeout(()=>t.forceRender(),50)}),e.on("blur",(n,i)=>{const o=e.selection.editableElement;null!==o&&o!==i.target||(e.isFocused=!1,t.forceRender())})}onDomEvent(t){this.fire(t.type,t)}destroy(){this._renderTimeoutId&&clearTimeout(this._renderTimeoutId),super.destroy()}}class Qr extends Dr{constructor(t){super(t),this.domEventType=["compositionstart","compositionupdate","compositionend"];const e=this.document;e.on("compositionstart",()=>{e.isComposing=!0}),e.on("compositionend",()=>{e.isComposing=!1})}onDomEvent(t){this.fire(t.type,t)}}class Jr extends Dr{constructor(t){super(t),this.domEventType=["beforeinput"]}onDomEvent(t){this.fire(t.type,t)}}function Zr(t){return"[object Range]"==Object.prototype.toString.apply(t)}function Xr(t){const e=t.ownerDocument.defaultView.getComputedStyle(t);return{top:parseInt(e.borderTopWidth,10),right:parseInt(e.borderRightWidth,10),bottom:parseInt(e.borderBottomWidth,10),left:parseInt(e.borderLeftWidth,10)}}const ts=["top","right","bottom","left","width","height"];class es{constructor(t){const e=Zr(t);if(Object.defineProperty(this,"_source",{value:t._source||t,writable:!0,enumerable:!1}),nn(t)||e)ns(this,e?es.getDomRangeRects(t)[0]:t.getBoundingClientRect());else if(dr(t)){const{innerWidth:e,innerHeight:n}=t;ns(this,{top:0,right:e,bottom:n,left:0,width:e,height:n})}else ns(this,t)}clone(){return new es(this)}moveTo(t,e){return this.top=e,this.right=t+this.width,this.bottom=e+this.height,this.left=t,this}moveBy(t,e){return this.top+=e,this.right+=t,this.left+=t,this.bottom+=e,this}getIntersection(t){const e={top:Math.max(this.top,t.top),right:Math.min(this.right,t.right),bottom:Math.min(this.bottom,t.bottom),left:Math.max(this.left,t.left)};return e.width=e.right-e.left,e.height=e.bottom-e.top,e.width<0||e.height<0?null:new es(e)}getIntersectionArea(t){const e=this.getIntersection(t);return e?e.getArea():0}getArea(){return this.width*this.height}getVisible(){const t=this._source;let e=this.clone();if(!is(t)){let n=t.parentNode||t.commonAncestorContainer;for(;n&&!is(n);){const t=new es(n),i=e.getIntersection(t);if(!i)return null;i.getArea()<e.getArea()&&(e=i),n=n.parentNode}}return e}isEqual(t){for(const e of ts)if(this[e]!==t[e])return!1;return!0}contains(t){const e=this.getIntersection(t);return!(!e||!e.isEqual(t))}excludeScrollbarsAndBorders(){const t=this._source;let e,n,i;if(dr(t))e=t.innerWidth-t.document.documentElement.clientWidth,n=t.innerHeight-t.document.documentElement.clientHeight,i=t.getComputedStyle(t.document.documentElement).direction;else{const o=Xr(this._source);e=t.offsetWidth-t.clientWidth-o.left-o.right,n=t.offsetHeight-t.clientHeight-o.top-o.bottom,i=t.ownerDocument.defaultView.getComputedStyle(t).direction,this.left+=o.left,this.top+=o.top,this.right-=o.right,this.bottom-=o.bottom,this.width=this.right-this.left,this.height=this.bottom-this.top}return this.width-=e,"ltr"===i?this.right-=e:this.left+=e,this.height-=n,this.bottom-=n,this}static getDomRangeRects(t){const e=[],n=Array.from(t.getClientRects());if(n.length)for(const t of n)e.push(new es(t));else{let n=t.startContainer;jo(n)&&(n=n.parentNode);const i=new es(n.getBoundingClientRect());i.right=i.left,i.width=0,e.push(i)}return e}}function ns(t,e){for(const n of ts)t[n]=e[n]}function is(t){return!!nn(t)&&t===t.ownerDocument.body}function os({target:t,viewportOffset:e=0}){const n=us(t);let i=n,o=null;for(;i;){let r;r=hs(i==n?t:o),ss(r,()=>fs(t,i));const s=fs(t,i);if(rs(i,s,e),i.parent!=i){if(o=i.frameElement,i=i.parent,!o)return}else i=null}}function rs(t,e,n){const i=e.clone().moveBy(0,n),o=e.clone().moveBy(0,-n),r=new es(t).excludeScrollbarsAndBorders();if(![o,i].every(t=>r.contains(t))){let{scrollX:s,scrollY:a}=t;cs(o,r)?a-=r.top-e.top+n:as(i,r)&&(a+=e.bottom-r.bottom+n),ls(e,r)?s-=r.left-e.left+n:ds(e,r)&&(s+=e.right-r.right+n),t.scrollTo(s,a)}}function ss(t,e){const n=us(t);let i,o;for(;t!=n.document.body;)o=e(),i=new es(t).excludeScrollbarsAndBorders(),i.contains(o)||(cs(o,i)?t.scrollTop-=i.top-o.top:as(o,i)&&(t.scrollTop+=o.bottom-i.bottom),ls(o,i)?t.scrollLeft-=i.left-o.left:ds(o,i)&&(t.scrollLeft+=o.right-i.right)),t=t.parentNode}function as(t,e){return t.bottom>e.bottom}function cs(t,e){return t.top<e.top}function ls(t,e){return t.left<e.left}function ds(t,e){return t.right>e.right}function us(t){return Zr(t)?t.startContainer.ownerDocument.defaultView:t.ownerDocument.defaultView}function hs(t){if(Zr(t)){let e=t.commonAncestorContainer;return jo(e)&&(e=e.parentNode),e}return t.parentNode}function fs(t,e){const n=us(t),i=new es(t);if(n===e)return i;{let t=n;for(;t!=e;){const e=t.frameElement,n=new es(e).excludeScrollbarsAndBorders();i.moveBy(n.left,n.top),t=t.parent}}return i}Object.assign({},{scrollViewportToShowTarget:os,scrollAncestorsToShowTarget:function(t){ss(hs(t),()=>new es(t))}});class gs{constructor(t){this.document=new oo(t),this.domConverter=new sr(this.document),this.domRoots=new Map,this.set("isRenderingInProgress",!1),this.set("hasDomSelection",!1),this._renderer=new Zo(this.domConverter,this.document.selection),this._renderer.bind("isFocused").to(this.document),this._initialDomRootAttributes=new WeakMap,this._observers=new Map,this._ongoingChange=!1,this._postFixersInProgress=!1,this._renderingDisabled=!1,this._hasChangedSinceTheLastRendering=!1,this._writer=new Po(this.document),this.addObserver(Or),this.addObserver($r),this.addObserver(Kr),this.addObserver(Lr),this.addObserver(Gr),this.addObserver(Qr),ho.isAndroid&&this.addObserver(Jr),this.document.on("keydown",Wo),Ao(this),this.on("render",()=>{this._render(),this.document.fire("layoutChanged"),this._hasChangedSinceTheLastRendering=!1}),this.listenTo(this.document.selection,"change",()=>{this._hasChangedSinceTheLastRendering=!0})}attachDomRoot(t,e="main"){const n=this.document.getRoot(e);n._name=t.tagName.toLowerCase();const i={};for(const{name:e,value:o}of Array.from(t.attributes))i[e]=o,"class"===e?this._writer.addClass(o.split(" "),n):this._writer.setAttribute(e,o,n);this._initialDomRootAttributes.set(t,i);const o=()=>{this._writer.setAttribute("contenteditable",!n.isReadOnly,n),n.isReadOnly?this._writer.addClass("ck-read-only",n):this._writer.removeClass("ck-read-only",n)};o(),this.domRoots.set(e,t),this.domConverter.bindElements(t,n),this._renderer.markToSync("children",n),this._renderer.markToSync("attributes",n),this._renderer.domDocuments.add(t.ownerDocument),n.on("change:children",(t,e)=>this._renderer.markToSync("children",e)),n.on("change:attributes",(t,e)=>this._renderer.markToSync("attributes",e)),n.on("change:text",(t,e)=>this._renderer.markToSync("text",e)),n.on("change:isReadOnly",()=>this.change(o)),n.on("change",()=>{this._hasChangedSinceTheLastRendering=!0});for(const n of this._observers.values())n.observe(t,e)}detachDomRoot(t){const e=this.domRoots.get(t);Array.from(e.attributes).forEach(({name:t})=>e.removeAttribute(t));const n=this._initialDomRootAttributes.get(e);for(const t in n)e.setAttribute(t,n[t]);this.domRoots.delete(t),this.domConverter.unbindDomElement(e)}getDomRoot(t="main"){return this.domRoots.get(t)}addObserver(t){let e=this._observers.get(t);if(e)return e;e=new t(this),this._observers.set(t,e);for(const[t,n]of this.domRoots)e.observe(n,t);return e.enable(),e}getObserver(t){return this._observers.get(t)}disableObservers(){for(const t of this._observers.values())t.disable()}enableObservers(){for(const t of this._observers.values())t.enable()}scrollToTheSelection(){const t=this.document.selection.getFirstRange();t&&os({target:this.domConverter.viewRangeToDom(t),viewportOffset:20})}focus(){if(!this.document.isFocused){const t=this.document.selection.editableElement;t&&(this.domConverter.focus(t),this.forceRender())}}change(t){if(this.isRenderingInProgress||this._postFixersInProgress)throw new hn.b("cannot-change-view-tree: Attempting to make changes to the view when it is in an incorrect state: rendering or post-fixers are in progress. This may cause some unexpected behavior and inconsistency between the DOM and the view.",this);try{if(this._ongoingChange)return t(this._writer);this._ongoingChange=!0;const e=t(this._writer);return this._ongoingChange=!1,!this._renderingDisabled&&this._hasChangedSinceTheLastRendering&&(this._postFixersInProgress=!0,this.document._callPostFixers(this._writer),this._postFixersInProgress=!1,this.fire("render")),e}catch(t){hn.b.rethrowUnexpectedError(t,this)}}forceRender(){this._hasChangedSinceTheLastRendering=!0,this.change(()=>{})}destroy(){for(const t of this._observers.values())t.destroy();this.document.destroy(),this.stopListening()}createPositionAt(t,e){return Zi._createAt(t,e)}createPositionAfter(t){return Zi._createAfter(t)}createPositionBefore(t){return Zi._createBefore(t)}createRange(t,e){return new Xi(t,e)}createRangeOn(t){return Xi._createOn(t)}createRangeIn(t){return Xi._createIn(t)}createSelection(t,e,n){return new no(t,e,n)}_disableRendering(t){this._renderingDisabled=t,0==t&&this.change(()=>{})}_render(){this.isRenderingInProgress=!0,this.disableObservers(),this._renderer.render(),this.enableObservers(),this.isRenderingInProgress=!1}}xn(gs,Ui);class ms{constructor(t){this.parent=null,this._attrs=Ln(t)}get index(){let t;if(!this.parent)return null;if(null===(t=this.parent.getChildIndex(this)))throw new hn.b("model-node-not-found-in-parent: The node's parent does not contain this node.",this);return t}get startOffset(){let t;if(!this.parent)return null;if(null===(t=this.parent.getChildStartOffset(this)))throw new hn.b("model-node-not-found-in-parent: The node's parent does not contain this node.",this);return t}get offsetSize(){return 1}get endOffset(){return this.parent?this.startOffset+this.offsetSize:null}get nextSibling(){const t=this.index;return null!==t&&this.parent.getChild(t+1)||null}get previousSibling(){const t=this.index;return null!==t&&this.parent.getChild(t-1)||null}get root(){let t=this;for(;t.parent;)t=t.parent;return t}isAttached(){return this.root.is("rootElement")}getPath(){const t=[];let e=this;for(;e.parent;)t.unshift(e.startOffset),e=e.parent;return t}getAncestors(t={includeSelf:!1,parentFirst:!1}){const e=[];let n=t.includeSelf?this:this.parent;for(;n;)e[t.parentFirst?"push":"unshift"](n),n=n.parent;return e}getCommonAncestor(t,e={}){const n=this.getAncestors(e),i=t.getAncestors(e);let o=0;for(;n[o]==i[o]&&n[o];)o++;return 0===o?null:n[o-1]}isBefore(t){if(this==t)return!1;if(this.root!==t.root)return!1;const e=this.getPath(),n=t.getPath(),i=In(e,n);switch(i){case"prefix":return!0;case"extension":return!1;default:return e[i]<n[i]}}isAfter(t){return this!=t&&(this.root===t.root&&!this.isBefore(t))}hasAttribute(t){return this._attrs.has(t)}getAttribute(t){return this._attrs.get(t)}getAttributes(){return this._attrs.entries()}getAttributeKeys(){return this._attrs.keys()}toJSON(){const t={};return this._attrs.size&&(t.attributes=Array.from(this._attrs).reduce((t,e)=>(t[e[0]]=e[1],t),{})),t}is(t){return"node"===t||"model:node"===t}_clone(){return new ms(this._attrs)}_remove(){this.parent._removeChildren(this.index)}_setAttribute(t,e){this._attrs.set(t,e)}_setAttributesTo(t){this._attrs=Ln(t)}_removeAttribute(t){return this._attrs.delete(t)}_clearAttributes(){this._attrs.clear()}}class ps extends ms{constructor(t,e){super(e),this._data=t||""}get offsetSize(){return this.data.length}get data(){return this._data}is(t){return"text"===t||"model:text"===t||"node"===t||"model:node"===t}toJSON(){const t=super.toJSON();return t.data=this.data,t}_clone(){return new ps(this.data,this.getAttributes())}static fromJSON(t){return new ps(t.data,t.attributes)}}class bs{constructor(t,e,n){if(this.textNode=t,e<0||e>t.offsetSize)throw new hn.b("model-textproxy-wrong-offsetintext: Given offsetInText value is incorrect.",this);if(n<0||e+n>t.offsetSize)throw new hn.b("model-textproxy-wrong-length: Given length value is incorrect.",this);this.data=t.data.substring(e,e+n),this.offsetInText=e}get startOffset(){return null!==this.textNode.startOffset?this.textNode.startOffset+this.offsetInText:null}get offsetSize(){return this.data.length}get endOffset(){return null!==this.startOffset?this.startOffset+this.offsetSize:null}get isPartial(){return this.offsetSize!==this.textNode.offsetSize}get parent(){return this.textNode.parent}get root(){return this.textNode.root}is(t){return"textProxy"===t||"model:textProxy"===t}getPath(){const t=this.textNode.getPath();return t.length>0&&(t[t.length-1]+=this.offsetInText),t}getAncestors(t={includeSelf:!1,parentFirst:!1}){const e=[];let n=t.includeSelf?this:this.parent;for(;n;)e[t.parentFirst?"push":"unshift"](n),n=n.parent;return e}hasAttribute(t){return this.textNode.hasAttribute(t)}getAttribute(t){return this.textNode.getAttribute(t)}getAttributes(){return this.textNode.getAttributes()}getAttributeKeys(){return this.textNode.getAttributeKeys()}}class ws{constructor(t){this._nodes=[],t&&this._insertNodes(0,t)}[Symbol.iterator](){return this._nodes[Symbol.iterator]()}get length(){return this._nodes.length}get maxOffset(){return this._nodes.reduce((t,e)=>t+e.offsetSize,0)}getNode(t){return this._nodes[t]||null}getNodeIndex(t){const e=this._nodes.indexOf(t);return-1==e?null:e}getNodeStartOffset(t){const e=this.getNodeIndex(t);return null===e?null:this._nodes.slice(0,e).reduce((t,e)=>t+e.offsetSize,0)}indexToOffset(t){if(t==this._nodes.length)return this.maxOffset;const e=this._nodes[t];if(!e)throw new hn.b("model-nodelist-index-out-of-bounds: Given index cannot be found in the node list.",this);return this.getNodeStartOffset(e)}offsetToIndex(t){let e=0;for(const n of this._nodes){if(t>=e&&t<e+n.offsetSize)return this.getNodeIndex(n);e+=n.offsetSize}if(e!=t)throw new hn.b("model-nodelist-offset-out-of-bounds: Given offset cannot be found in the node list.",this,{offset:t,nodeList:this});return this.length}_insertNodes(t,e){for(const t of e)if(!(t instanceof ms))throw new hn.b("model-nodelist-insertNodes-not-node: Trying to insert an object which is not a Node instance.",this);this._nodes.splice(t,0,...e)}_removeNodes(t,e=1){return this._nodes.splice(t,e)}toJSON(){return this._nodes.map(t=>t.toJSON())}}class ks extends ms{constructor(t,e,n){super(e),this.name=t,this._children=new ws,n&&this._insertChild(0,n)}get childCount(){return this._children.length}get maxOffset(){return this._children.maxOffset}get isEmpty(){return 0===this.childCount}is(t,e=null){return e?e===this.name&&("element"===t||"model:element"===t):"element"===t||"model:element"===t||t===this.name||t==="model:"+this.name||"node"===t||"model:node"===t}getChild(t){return this._children.getNode(t)}getChildren(){return this._children[Symbol.iterator]()}getChildIndex(t){return this._children.getNodeIndex(t)}getChildStartOffset(t){return this._children.getNodeStartOffset(t)}offsetToIndex(t){return this._children.offsetToIndex(t)}getNodeByPath(t){let e=this;for(const n of t)e=e.getChild(e.offsetToIndex(n));return e}toJSON(){const t=super.toJSON();if(t.name=this.name,this._children.length>0){t.children=[];for(const e of this._children)t.children.push(e.toJSON())}return t}_clone(t=!1){const e=t?Array.from(this._children).map(t=>t._clone(!0)):null;return new ks(this.name,this.getAttributes(),e)}_appendChild(t){this._insertChild(this.childCount,t)}_insertChild(t,e){const n=function(t){if("string"==typeof t)return[new ps(t)];yn(t)||(t=[t]);return Array.from(t).map(t=>"string"==typeof t?new ps(t):t instanceof bs?new ps(t.data,t.getAttributes()):t)}(e);for(const t of n)null!==t.parent&&t._remove(),t.parent=this;this._children._insertNodes(t,n)}_removeChildren(t,e=1){const n=this._children._removeNodes(t,e);for(const t of n)t.parent=null;return n}static fromJSON(t){let e=null;if(t.children){e=[];for(const n of t.children)n.name?e.push(ks.fromJSON(n)):e.push(ps.fromJSON(n))}return new ks(t.name,t.attributes,e)}}class _s{constructor(t={}){if(!t.boundaries&&!t.startPosition)throw new hn.b("model-tree-walker-no-start-position: Neither boundaries nor starting position have been defined.",null);const e=t.direction||"forward";if("forward"!=e&&"backward"!=e)throw new hn.b("model-tree-walker-unknown-direction: Only `backward` and `forward` direction allowed.",t,{direction:e});this.direction=e,this.boundaries=t.boundaries||null,t.startPosition?this.position=t.startPosition.clone():this.position=ys._createAt(this.boundaries["backward"==this.direction?"end":"start"]),this.position.stickiness="toNone",this.singleCharacters=!!t.singleCharacters,this.shallow=!!t.shallow,this.ignoreElementEnd=!!t.ignoreElementEnd,this._boundaryStartParent=this.boundaries?this.boundaries.start.parent:null,this._boundaryEndParent=this.boundaries?this.boundaries.end.parent:null,this._visitedParent=this.position.parent}[Symbol.iterator](){return this}skip(t){let e,n,i,o;do{i=this.position,o=this._visitedParent,({done:e,value:n}=this.next())}while(!e&&t(n));e||(this.position=i,this._visitedParent=o)}next(){return"forward"==this.direction?this._next():this._previous()}_next(){const t=this.position,e=this.position.clone(),n=this._visitedParent;if(null===n.parent&&e.offset===n.maxOffset)return{done:!0};if(n===this._boundaryEndParent&&e.offset==this.boundaries.end.offset)return{done:!0};const i=e.parent,o=xs(e,i),r=o||As(e,i,o);if(r instanceof ks)return this.shallow?e.offset++:(e.path.push(0),this._visitedParent=r),this.position=e,vs("elementStart",r,t,e,1);if(r instanceof ps){let i;if(this.singleCharacters)i=1;else{let t=r.endOffset;this._boundaryEndParent==n&&this.boundaries.end.offset<t&&(t=this.boundaries.end.offset),i=t-e.offset}const o=e.offset-r.startOffset,s=new bs(r,o,i);return e.offset+=i,this.position=e,vs("text",s,t,e,i)}return e.path.pop(),e.offset++,this.position=e,this._visitedParent=n.parent,this.ignoreElementEnd?this._next():vs("elementEnd",n,t,e)}_previous(){const t=this.position,e=this.position.clone(),n=this._visitedParent;if(null===n.parent&&0===e.offset)return{done:!0};if(n==this._boundaryStartParent&&e.offset==this.boundaries.start.offset)return{done:!0};const i=e.parent,o=xs(e,i),r=o||Cs(e,i,o);if(r instanceof ks)return e.offset--,this.shallow?(this.position=e,vs("elementStart",r,t,e,1)):(e.path.push(r.maxOffset),this.position=e,this._visitedParent=r,this.ignoreElementEnd?this._previous():vs("elementEnd",r,t,e));if(r instanceof ps){let i;if(this.singleCharacters)i=1;else{let t=r.startOffset;this._boundaryStartParent==n&&this.boundaries.start.offset>t&&(t=this.boundaries.start.offset),i=e.offset-t}const o=e.offset-r.startOffset,s=new bs(r,o-i,i);return e.offset-=i,this.position=e,vs("text",s,t,e,i)}return e.path.pop(),this.position=e,this._visitedParent=n.parent,vs("elementStart",n,t,e,1)}}function vs(t,e,n,i,o){return{done:!1,value:{type:t,item:e,previousPosition:n,nextPosition:i,length:o}}}class ys{constructor(t,e,n="toNone"){if(!t.is("element")&&!t.is("documentFragment"))throw new hn.b("model-position-root-invalid: Position root invalid.",t);if(!(e instanceof Array)||0===e.length)throw new hn.b("model-position-path-incorrect-format: Position path must be an array with at least one item.",t,{path:e});t.is("rootElement")?e=e.slice():(e=[...t.getPath(),...e],t=t.root),this.root=t,this.path=e,this.stickiness=n}get offset(){return this.path[this.path.length-1]}set offset(t){this.path[this.path.length-1]=t}get parent(){let t=this.root;for(let e=0;e<this.path.length-1;e++)if(t=t.getChild(t.offsetToIndex(this.path[e])),!t)throw new hn.b("model-position-path-incorrect: The position's path is incorrect.",this,{position:this});if(t.is("text"))throw new hn.b("model-position-path-incorrect: The position's path is incorrect.",this,{position:this});return t}get index(){return this.parent.offsetToIndex(this.offset)}get textNode(){return xs(this,this.parent)}get nodeAfter(){const t=this.parent;return As(this,t,xs(this,t))}get nodeBefore(){const t=this.parent;return Cs(this,t,xs(this,t))}get isAtStart(){return 0===this.offset}get isAtEnd(){return this.offset==this.parent.maxOffset}compareWith(t){if(this.root!=t.root)return"different";const e=In(this.path,t.path);switch(e){case"same":return"same";case"prefix":return"before";case"extension":return"after";default:return this.path[e]<t.path[e]?"before":"after"}}getLastMatchingPosition(t,e={}){e.startPosition=this;const n=new _s(e);return n.skip(t),n.position}getParentPath(){return this.path.slice(0,-1)}getAncestors(){const t=this.parent;return t.is("documentFragment")?[t]:t.getAncestors({includeSelf:!0})}getCommonPath(t){if(this.root!=t.root)return[];const e=In(this.path,t.path),n="string"==typeof e?Math.min(this.path.length,t.path.length):e;return this.path.slice(0,n)}getCommonAncestor(t){const e=this.getAncestors(),n=t.getAncestors();let i=0;for(;e[i]==n[i]&&e[i];)i++;return 0===i?null:e[i-1]}getShiftedBy(t){const e=this.clone(),n=e.offset+t;return e.offset=n<0?0:n,e}isAfter(t){return"after"==this.compareWith(t)}isBefore(t){return"before"==this.compareWith(t)}isEqual(t){return"same"==this.compareWith(t)}isTouching(t){let e=null,n=null;switch(this.compareWith(t)){case"same":return!0;case"before":e=ys._createAt(this),n=ys._createAt(t);break;case"after":e=ys._createAt(t),n=ys._createAt(this);break;default:return!1}let i=e.parent;for(;e.path.length+n.path.length;){if(e.isEqual(n))return!0;if(e.path.length>n.path.length){if(e.offset!==i.maxOffset)return!1;e.path=e.path.slice(0,-1),i=i.parent,e.offset++}else{if(0!==n.offset)return!1;n.path=n.path.slice(0,-1)}}}is(t){return"position"===t||"model:position"===t}hasSameParentAs(t){if(this.root!==t.root)return!1;return"same"==In(this.getParentPath(),t.getParentPath())}getTransformedByOperation(t){let e;switch(t.type){case"insert":e=this._getTransformedByInsertOperation(t);break;case"move":case"remove":case"reinsert":e=this._getTransformedByMoveOperation(t);break;case"split":e=this._getTransformedBySplitOperation(t);break;case"merge":e=this._getTransformedByMergeOperation(t);break;default:e=ys._createAt(this)}return e}_getTransformedByInsertOperation(t){return this._getTransformedByInsertion(t.position,t.howMany)}_getTransformedByMoveOperation(t){return this._getTransformedByMove(t.sourcePosition,t.targetPosition,t.howMany)}_getTransformedBySplitOperation(t){const e=t.movedRange;return e.containsPosition(this)||e.start.isEqual(this)&&"toNext"==this.stickiness?this._getCombined(t.splitPosition,t.moveTargetPosition):t.graveyardPosition?this._getTransformedByMove(t.graveyardPosition,t.insertionPosition,1):this._getTransformedByInsertion(t.insertionPosition,1)}_getTransformedByMergeOperation(t){const e=t.movedRange;let n;return e.containsPosition(this)||e.start.isEqual(this)?(n=this._getCombined(t.sourcePosition,t.targetPosition),t.sourcePosition.isBefore(t.targetPosition)&&(n=n._getTransformedByDeletion(t.deletionPosition,1))):n=this.isEqual(t.deletionPosition)?ys._createAt(t.deletionPosition):this._getTransformedByMove(t.deletionPosition,t.graveyardPosition,1),n}_getTransformedByDeletion(t,e){const n=ys._createAt(this);if(this.root!=t.root)return n;if("same"==In(t.getParentPath(),this.getParentPath())){if(t.offset<this.offset){if(t.offset+e>this.offset)return null;n.offset-=e}}else if("prefix"==In(t.getParentPath(),this.getParentPath())){const i=t.path.length-1;if(t.offset<=this.path[i]){if(t.offset+e>this.path[i])return null;n.path[i]-=e}}return n}_getTransformedByInsertion(t,e){const n=ys._createAt(this);if(this.root!=t.root)return n;if("same"==In(t.getParentPath(),this.getParentPath()))(t.offset<this.offset||t.offset==this.offset&&"toPrevious"!=this.stickiness)&&(n.offset+=e);else if("prefix"==In(t.getParentPath(),this.getParentPath())){const i=t.path.length-1;t.offset<=this.path[i]&&(n.path[i]+=e)}return n}_getTransformedByMove(t,e,n){if(e=e._getTransformedByDeletion(t,n),t.isEqual(e))return ys._createAt(this);const i=this._getTransformedByDeletion(t,n);return null===i||t.isEqual(this)&&"toNext"==this.stickiness||t.getShiftedBy(n).isEqual(this)&&"toPrevious"==this.stickiness?this._getCombined(t,e):i._getTransformedByInsertion(e,n)}_getCombined(t,e){const n=t.path.length-1,i=ys._createAt(e);return i.stickiness=this.stickiness,i.offset=i.offset+this.path[n]-t.offset,i.path=[...i.path,...this.path.slice(n+1)],i}toJSON(){return{root:this.root.toJSON(),path:Array.from(this.path),stickiness:this.stickiness}}clone(){return new this.constructor(this.root,this.path,this.stickiness)}static _createAt(t,e,n="toNone"){if(t instanceof ys)return new ys(t.root,t.path,t.stickiness);{const i=t;if("end"==e)e=i.maxOffset;else{if("before"==e)return this._createBefore(i,n);if("after"==e)return this._createAfter(i,n);if(0!==e&&!e)throw new hn.b("model-createPositionAt-offset-required: Model#createPositionAt() requires the offset when the first parameter is a model item.",[this,t])}if(!i.is("element")&&!i.is("documentFragment"))throw new hn.b("model-position-parent-incorrect: Position parent have to be a element or document fragment.",[this,t]);const o=i.getPath();return o.push(e),new this(i.root,o,n)}}static _createAfter(t,e){if(!t.parent)throw new hn.b("model-position-after-root: You cannot make a position after root.",[this,t],{root:t});return this._createAt(t.parent,t.endOffset,e)}static _createBefore(t,e){if(!t.parent)throw new hn.b("model-position-before-root: You cannot make a position before root.",t,{root:t});return this._createAt(t.parent,t.startOffset,e)}static fromJSON(t,e){if("$graveyard"===t.root){const n=new ys(e.graveyard,t.path);return n.stickiness=t.stickiness,n}if(!e.getRoot(t.root))throw new hn.b("model-position-fromjson-no-root: Cannot create position for document. Root with specified name does not exist.",e,{rootName:t.root});return new ys(e.getRoot(t.root),t.path,t.stickiness)}}function xs(t,e){const n=e.getChild(e.offsetToIndex(t.offset));return n&&n.is("text")&&n.startOffset<t.offset?n:null}function As(t,e,n){return null!==n?null:e.getChild(e.offsetToIndex(t.offset))}function Cs(t,e,n){return null!==n?null:e.getChild(e.offsetToIndex(t.offset)-1)}class Ts{constructor(t,e=null){this.start=ys._createAt(t),this.end=e?ys._createAt(e):ys._createAt(t),this.start.stickiness=this.isCollapsed?"toNone":"toNext",this.end.stickiness=this.isCollapsed?"toNone":"toPrevious"}*[Symbol.iterator](){yield*new _s({boundaries:this,ignoreElementEnd:!0})}get isCollapsed(){return this.start.isEqual(this.end)}get isFlat(){return"same"==In(this.start.getParentPath(),this.end.getParentPath())}get root(){return this.start.root}containsPosition(t){return t.isAfter(this.start)&&t.isBefore(this.end)}containsRange(t,e=!1){t.isCollapsed&&(e=!1);const n=this.containsPosition(t.start)||e&&this.start.isEqual(t.start),i=this.containsPosition(t.end)||e&&this.end.isEqual(t.end);return n&&i}containsItem(t){const e=ys._createBefore(t);return this.containsPosition(e)||this.start.isEqual(e)}is(t){return"range"===t||"model:range"===t}isEqual(t){return this.start.isEqual(t.start)&&this.end.isEqual(t.end)}isIntersecting(t){return this.start.isBefore(t.end)&&this.end.isAfter(t.start)}getDifference(t){const e=[];return this.isIntersecting(t)?(this.containsPosition(t.start)&&e.push(new Ts(this.start,t.start)),this.containsPosition(t.end)&&e.push(new Ts(t.end,this.end))):e.push(new Ts(this.start,this.end)),e}getIntersection(t){if(this.isIntersecting(t)){let e=this.start,n=this.end;return this.containsPosition(t.start)&&(e=t.start),this.containsPosition(t.end)&&(n=t.end),new Ts(e,n)}return null}getMinimalFlatRanges(){const t=[],e=this.start.getCommonPath(this.end).length,n=ys._createAt(this.start);let i=n.parent;for(;n.path.length>e+1;){const e=i.maxOffset-n.offset;0!==e&&t.push(new Ts(n,n.getShiftedBy(e))),n.path=n.path.slice(0,-1),n.offset++,i=i.parent}for(;n.path.length<=this.end.path.length;){const e=this.end.path[n.path.length-1],i=e-n.offset;0!==i&&t.push(new Ts(n,n.getShiftedBy(i))),n.offset=e,n.path.push(0)}return t}getWalker(t={}){return t.boundaries=this,new _s(t)}*getItems(t={}){t.boundaries=this,t.ignoreElementEnd=!0;const e=new _s(t);for(const t of e)yield t.item}*getPositions(t={}){t.boundaries=this;const e=new _s(t);yield e.position;for(const t of e)yield t.nextPosition}getTransformedByOperation(t){switch(t.type){case"insert":return this._getTransformedByInsertOperation(t);case"move":case"remove":case"reinsert":return this._getTransformedByMoveOperation(t);case"split":return[this._getTransformedBySplitOperation(t)];case"merge":return[this._getTransformedByMergeOperation(t)]}return[new Ts(this.start,this.end)]}getTransformedByOperations(t){const e=[new Ts(this.start,this.end)];for(const n of t)for(let t=0;t<e.length;t++){const i=e[t].getTransformedByOperation(n);e.splice(t,1,...i),t+=i.length-1}for(let t=0;t<e.length;t++){const n=e[t];for(let i=t+1;i<e.length;i++){const t=e[i];(n.containsRange(t)||t.containsRange(n)||n.isEqual(t))&&e.splice(i,1)}}return e}getCommonAncestor(){return this.start.getCommonAncestor(this.end)}getContainedElement(){if(this.isCollapsed)return null;const t=this.start.nodeAfter,e=this.end.nodeBefore;return t&&t.is("element")&&t===e?t:null}toJSON(){return{start:this.start.toJSON(),end:this.end.toJSON()}}clone(){return new this.constructor(this.start,this.end)}_getTransformedByInsertOperation(t,e=!1){return this._getTransformedByInsertion(t.position,t.howMany,e)}_getTransformedByMoveOperation(t,e=!1){const n=t.sourcePosition,i=t.howMany,o=t.targetPosition;return this._getTransformedByMove(n,o,i,e)}_getTransformedBySplitOperation(t){const e=this.start._getTransformedBySplitOperation(t);let n=this.end._getTransformedBySplitOperation(t);return this.end.isEqual(t.insertionPosition)&&(n=this.end.getShiftedBy(1)),e.root!=n.root&&(n=this.end.getShiftedBy(-1)),new Ts(e,n)}_getTransformedByMergeOperation(t){if(this.start.isEqual(t.targetPosition)&&this.end.isEqual(t.deletionPosition))return new Ts(this.start);let e=this.start._getTransformedByMergeOperation(t),n=this.end._getTransformedByMergeOperation(t);return e.root!=n.root&&(n=this.end.getShiftedBy(-1)),e.isAfter(n)?(t.sourcePosition.isBefore(t.targetPosition)?(e=ys._createAt(n),e.offset=0):(t.deletionPosition.isEqual(e)||(n=t.deletionPosition),e=t.targetPosition),new Ts(e,n)):new Ts(e,n)}_getTransformedByInsertion(t,e,n=!1){if(n&&this.containsPosition(t))return[new Ts(this.start,t),new Ts(t.getShiftedBy(e),this.end._getTransformedByInsertion(t,e))];{const n=new Ts(this.start,this.end);return n.start=n.start._getTransformedByInsertion(t,e),n.end=n.end._getTransformedByInsertion(t,e),[n]}}_getTransformedByMove(t,e,n,i=!1){if(this.isCollapsed){const i=this.start._getTransformedByMove(t,e,n);return[new Ts(i)]}const o=Ts._createFromPositionAndShift(t,n),r=e._getTransformedByDeletion(t,n);if(this.containsPosition(e)&&!i&&(o.containsPosition(this.start)||o.containsPosition(this.end))){const i=this.start._getTransformedByMove(t,e,n),o=this.end._getTransformedByMove(t,e,n);return[new Ts(i,o)]}let s;const a=this.getDifference(o);let c=null;const l=this.getIntersection(o);if(1==a.length?c=new Ts(a[0].start._getTransformedByDeletion(t,n),a[0].end._getTransformedByDeletion(t,n)):2==a.length&&(c=new Ts(this.start,this.end._getTransformedByDeletion(t,n))),s=c?c._getTransformedByInsertion(r,n,null!==l||i):[],l){const t=new Ts(l.start._getCombined(o.start,r),l.end._getCombined(o.start,r));2==s.length?s.splice(1,0,t):s.push(t)}return s}_getTransformedByDeletion(t,e){let n=this.start._getTransformedByDeletion(t,e),i=this.end._getTransformedByDeletion(t,e);return null==n&&null==i?null:(null==n&&(n=t),null==i&&(i=t),new Ts(n,i))}static _createFromPositionAndShift(t,e){const n=t,i=t.getShiftedBy(e);return e>0?new this(n,i):new this(i,n)}static _createIn(t){return new this(ys._createAt(t,0),ys._createAt(t,t.maxOffset))}static _createOn(t){return this._createFromPositionAndShift(ys._createBefore(t),t.offsetSize)}static _createFromRanges(t){if(0===t.length)throw new hn.b("range-create-from-ranges-empty-array: At least one range has to be passed.",null);if(1==t.length)return t[0].clone();const e=t[0];t.sort((t,e)=>t.start.isAfter(e.start)?1:-1);const n=t.indexOf(e),i=new this(e.start,e.end);if(n>0)for(let e=n-1;t[e].end.isEqual(i.start);e++)i.start=ys._createAt(t[e].start);for(let e=n+1;e<t.length&&t[e].start.isEqual(i.end);e++)i.end=ys._createAt(t[e].end);return i}static fromJSON(t,e){return new this(ys.fromJSON(t.start,e),ys.fromJSON(t.end,e))}}class Ps{constructor(){this._modelToViewMapping=new WeakMap,this._viewToModelMapping=new WeakMap,this._viewToModelLengthCallbacks=new Map,this._markerNameToElements=new Map,this._elementToMarkerNames=new Map,this._unboundMarkerNames=new Set,this.on("modelToViewPosition",(t,e)=>{if(e.viewPosition)return;const n=this._modelToViewMapping.get(e.modelPosition.parent);e.viewPosition=this._findPositionIn(n,e.modelPosition.offset)},{priority:"low"}),this.on("viewToModelPosition",(t,e)=>{if(e.modelPosition)return;const n=this.findMappedViewAncestor(e.viewPosition),i=this._viewToModelMapping.get(n),o=this._toModelOffset(e.viewPosition.parent,e.viewPosition.offset,n);e.modelPosition=ys._createAt(i,o)},{priority:"low"})}bindElements(t,e){this._modelToViewMapping.set(t,e),this._viewToModelMapping.set(e,t)}unbindViewElement(t){const e=this.toModelElement(t);if(this._viewToModelMapping.delete(t),this._elementToMarkerNames.has(t))for(const e of this._elementToMarkerNames.get(t))this._unboundMarkerNames.add(e);this._modelToViewMapping.get(e)==t&&this._modelToViewMapping.delete(e)}unbindModelElement(t){const e=this.toViewElement(t);this._modelToViewMapping.delete(t),this._viewToModelMapping.get(e)==t&&this._viewToModelMapping.delete(e)}bindElementToMarker(t,e){const n=this._markerNameToElements.get(e)||new Set;n.add(t);const i=this._elementToMarkerNames.get(t)||new Set;i.add(e),this._markerNameToElements.set(e,n),this._elementToMarkerNames.set(t,i)}unbindElementFromMarkerName(t,e){const n=this._markerNameToElements.get(e);n&&(n.delete(t),0==n.size&&this._markerNameToElements.delete(e));const i=this._elementToMarkerNames.get(t);i&&(i.delete(e),0==i.size&&this._elementToMarkerNames.delete(t))}flushUnboundMarkerNames(){const t=Array.from(this._unboundMarkerNames);return this._unboundMarkerNames.clear(),t}clearBindings(){this._modelToViewMapping=new WeakMap,this._viewToModelMapping=new WeakMap,this._markerNameToElements=new Map,this._elementToMarkerNames=new Map,this._unboundMarkerNames=new Set}toModelElement(t){return this._viewToModelMapping.get(t)}toViewElement(t){return this._modelToViewMapping.get(t)}toModelRange(t){return new Ts(this.toModelPosition(t.start),this.toModelPosition(t.end))}toViewRange(t){return new Xi(this.toViewPosition(t.start),this.toViewPosition(t.end))}toModelPosition(t){const e={viewPosition:t,mapper:this};return this.fire("viewToModelPosition",e),e.modelPosition}toViewPosition(t,e={isPhantom:!1}){const n={modelPosition:t,mapper:this,isPhantom:e.isPhantom};return this.fire("modelToViewPosition",n),n.viewPosition}markerNameToElements(t){const e=this._markerNameToElements.get(t);if(!e)return null;const n=new Set;for(const t of e)if(t.is("attributeElement"))for(const e of t.getElementsWithSameId())n.add(e);else n.add(t);return n}registerViewToModelLength(t,e){this._viewToModelLengthCallbacks.set(t,e)}findMappedViewAncestor(t){let e=t.parent;for(;!this._viewToModelMapping.has(e);)e=e.parent;return e}_toModelOffset(t,e,n){if(n!=t){return this._toModelOffset(t.parent,t.index,n)+this._toModelOffset(t,e,t)}if(t.is("text"))return e;let i=0;for(let n=0;n<e;n++)i+=this.getModelLength(t.getChild(n));return i}getModelLength(t){if(this._viewToModelLengthCallbacks.get(t.name)){return this._viewToModelLengthCallbacks.get(t.name)(t)}if(this._viewToModelMapping.has(t))return 1;if(t.is("text"))return t.data.length;if(t.is("uiElement"))return 0;{let e=0;for(const n of t.getChildren())e+=this.getModelLength(n);return e}}_findPositionIn(t,e){let n,i=0,o=0,r=0;if(t.is("text"))return new Zi(t,e);for(;o<e;)n=t.getChild(r),i=this.getModelLength(n),o+=i,r++;return o==e?this._moveViewPositionToTextNode(new Zi(t,r)):this._findPositionIn(n,e-(o-i))}_moveViewPositionToTextNode(t){const e=t.nodeBefore,n=t.nodeAfter;return e instanceof Rn?new Zi(e,e.data.length):n instanceof Rn?new Zi(n,0):t}}xn(Ps,mn);class Ss{constructor(){this._consumable=new Map,this._textProxyRegistry=new Map}add(t,e){e=Es(e),t instanceof bs&&(t=this._getSymbolForTextProxy(t)),this._consumable.has(t)||this._consumable.set(t,new Map),this._consumable.get(t).set(e,!0)}consume(t,e){return e=Es(e),t instanceof bs&&(t=this._getSymbolForTextProxy(t)),!!this.test(t,e)&&(this._consumable.get(t).set(e,!1),!0)}test(t,e){e=Es(e),t instanceof bs&&(t=this._getSymbolForTextProxy(t));const n=this._consumable.get(t);if(void 0===n)return null;const i=n.get(e);return void 0===i?null:i}revert(t,e){e=Es(e),t instanceof bs&&(t=this._getSymbolForTextProxy(t));const n=this.test(t,e);return!1===n?(this._consumable.get(t).set(e,!0),!0):!0!==n&&null}_getSymbolForTextProxy(t){let e=null;const n=this._textProxyRegistry.get(t.startOffset);if(n){const i=n.get(t.endOffset);i&&(e=i.get(t.parent))}return e||(e=this._addSymbolForTextProxy(t.startOffset,t.endOffset,t.parent)),e}_addSymbolForTextProxy(t,e,n){const i=Symbol("textProxySymbol");let o,r;return o=this._textProxyRegistry.get(t),o||(o=new Map,this._textProxyRegistry.set(t,o)),r=o.get(e),r||(r=new Map,o.set(e,r)),r.set(n,i),i}}function Es(t){const e=t.split(":");return e.length>1?e[0]+":"+e[1]:e[0]}class Ms{constructor(t){this.conversionApi=ji({dispatcher:this},t)}convertChanges(t,e,n){for(const e of t.getMarkersToRemove())this.convertMarkerRemove(e.name,e.range,n);for(const e of t.getChanges())"insert"==e.type?this.convertInsert(Ts._createFromPositionAndShift(e.position,e.length),n):"remove"==e.type?this.convertRemove(e.position,e.length,e.name,n):this.convertAttribute(e.range,e.attributeKey,e.attributeOldValue,e.attributeNewValue,n);for(const t of this.conversionApi.mapper.flushUnboundMarkerNames()){const i=e.get(t).getRange();this.convertMarkerRemove(t,i,n),this.convertMarkerAdd(t,i,n)}for(const e of t.getMarkersToAdd())this.convertMarkerAdd(e.name,e.range,n)}convertInsert(t,e){this.conversionApi.writer=e,this.conversionApi.consumable=this._createInsertConsumable(t);for(const e of t){const t=e.item,n={item:t,range:Ts._createFromPositionAndShift(e.previousPosition,e.length)};this._testAndFire("insert",n);for(const e of t.getAttributeKeys())n.attributeKey=e,n.attributeOldValue=null,n.attributeNewValue=t.getAttribute(e),this._testAndFire("attribute:"+e,n)}this._clearConversionApi()}convertRemove(t,e,n,i){this.conversionApi.writer=i,this.fire("remove:"+n,{position:t,length:e},this.conversionApi),this._clearConversionApi()}convertAttribute(t,e,n,i,o){this.conversionApi.writer=o,this.conversionApi.consumable=this._createConsumableForRange(t,"attribute:"+e);for(const o of t){const t={item:o.item,range:Ts._createFromPositionAndShift(o.previousPosition,o.length),attributeKey:e,attributeOldValue:n,attributeNewValue:i};this._testAndFire("attribute:"+e,t)}this._clearConversionApi()}convertSelection(t,e,n){const i=Array.from(e.getMarkersAtPosition(t.getFirstPosition()));if(this.conversionApi.writer=n,this.conversionApi.consumable=this._createSelectionConsumable(t,i),this.fire("selection",{selection:t},this.conversionApi),t.isCollapsed){for(const e of i){const n=e.getRange();if(!Is(t.getFirstPosition(),e,this.conversionApi.mapper))continue;const i={item:t,markerName:e.name,markerRange:n};this.conversionApi.consumable.test(t,"addMarker:"+e.name)&&this.fire("addMarker:"+e.name,i,this.conversionApi)}for(const e of t.getAttributeKeys()){const n={item:t,range:t.getFirstRange(),attributeKey:e,attributeOldValue:null,attributeNewValue:t.getAttribute(e)};this.conversionApi.consumable.test(t,"attribute:"+n.attributeKey)&&this.fire("attribute:"+n.attributeKey+":$text",n,this.conversionApi)}this._clearConversionApi()}}convertMarkerAdd(t,e,n){if(!e.root.document||"$graveyard"==e.root.rootName)return;this.conversionApi.writer=n;const i="addMarker:"+t,o=new Ss;if(o.add(e,i),this.conversionApi.consumable=o,this.fire(i,{markerName:t,markerRange:e},this.conversionApi),o.test(e,i)){this.conversionApi.consumable=this._createConsumableForRange(e,i);for(const n of e.getItems()){if(!this.conversionApi.consumable.test(n,i))continue;const o={item:n,range:Ts._createOn(n),markerName:t,markerRange:e};this.fire(i,o,this.conversionApi)}this._clearConversionApi()}}convertMarkerRemove(t,e,n){e.root.document&&"$graveyard"!=e.root.rootName&&(this.conversionApi.writer=n,this.fire("removeMarker:"+t,{markerName:t,markerRange:e},this.conversionApi),this._clearConversionApi())}_createInsertConsumable(t){const e=new Ss;for(const n of t){const t=n.item;e.add(t,"insert");for(const n of t.getAttributeKeys())e.add(t,"attribute:"+n)}return e}_createConsumableForRange(t,e){const n=new Ss;for(const i of t.getItems())n.add(i,e);return n}_createSelectionConsumable(t,e){const n=new Ss;n.add(t,"selection");for(const i of e)n.add(t,"addMarker:"+i.name);for(const e of t.getAttributeKeys())n.add(t,"attribute:"+e);return n}_testAndFire(t,e){if(!this.conversionApi.consumable.test(e.item,t))return;const n=e.item.name||"$text";this.fire(t+":"+n,e,this.conversionApi)}_clearConversionApi(){delete this.conversionApi.writer,delete this.conversionApi.consumable}}function Is(t,e,n){const i=e.getRange(),o=Array.from(t.getAncestors());o.shift(),o.reverse();return!o.some(t=>{if(i.containsItem(t)){return!!n.toViewElement(t).getCustomProperty("addHighlight")}})}xn(Ms,mn);class Ns{constructor(t,e,n){this._lastRangeBackward=!1,this._ranges=[],this._attrs=new Map,t&&this.setTo(t,e,n)}get anchor(){if(this._ranges.length>0){const t=this._ranges[this._ranges.length-1];return this._lastRangeBackward?t.end:t.start}return null}get focus(){if(this._ranges.length>0){const t=this._ranges[this._ranges.length-1];return this._lastRangeBackward?t.start:t.end}return null}get isCollapsed(){return 1===this._ranges.length&&this._ranges[0].isCollapsed}get rangeCount(){return this._ranges.length}get isBackward(){return!this.isCollapsed&&this._lastRangeBackward}isEqual(t){if(this.rangeCount!=t.rangeCount)return!1;if(0===this.rangeCount)return!0;if(!this.anchor.isEqual(t.anchor)||!this.focus.isEqual(t.focus))return!1;for(const e of this._ranges){let n=!1;for(const i of t._ranges)if(e.isEqual(i)){n=!0;break}if(!n)return!1}return!0}*getRanges(){for(const t of this._ranges)yield new Ts(t.start,t.end)}getFirstRange(){let t=null;for(const e of this._ranges)t&&!e.start.isBefore(t.start)||(t=e);return t?new Ts(t.start,t.end):null}getLastRange(){let t=null;for(const e of this._ranges)t&&!e.end.isAfter(t.end)||(t=e);return t?new Ts(t.start,t.end):null}getFirstPosition(){const t=this.getFirstRange();return t?t.start.clone():null}getLastPosition(){const t=this.getLastRange();return t?t.end.clone():null}setTo(t,e,n){if(null===t)this._setRanges([]);else if(t instanceof Ns)this._setRanges(t.getRanges(),t.isBackward);else if(t&&"function"==typeof t.getRanges)this._setRanges(t.getRanges(),t.isBackward);else if(t instanceof Ts)this._setRanges([t],!!e&&!!e.backward);else if(t instanceof ys)this._setRanges([new Ts(t)]);else if(t instanceof ms){const i=!!n&&!!n.backward;let o;if("in"==e)o=Ts._createIn(t);else if("on"==e)o=Ts._createOn(t);else{if(void 0===e)throw new hn.b("model-selection-setTo-required-second-parameter: selection.setTo requires the second parameter when the first parameter is a node.",[this,t]);o=new Ts(ys._createAt(t,e))}this._setRanges([o],i)}else{if(!yn(t))throw new hn.b("model-selection-setTo-not-selectable: Cannot set the selection to the given place.",[this,t]);this._setRanges(t,e&&!!e.backward)}}_setRanges(t,e=!1){const n=(t=Array.from(t)).some(e=>{if(!(e instanceof Ts))throw new hn.b("model-selection-set-ranges-not-range: Selection range set to an object that is not an instance of model.Range.",[this,t]);return this._ranges.every(t=>!t.isEqual(e))});if(t.length!==this._ranges.length||n){this._removeAllRanges();for(const e of t)this._pushRange(e);this._lastRangeBackward=!!e,this.fire("change:range",{directChange:!0})}}setFocus(t,e){if(null===this.anchor)throw new hn.b("model-selection-setFocus-no-ranges: Cannot set selection focus if there are no ranges in selection.",[this,t]);const n=ys._createAt(t,e);if("same"==n.compareWith(this.focus))return;const i=this.anchor;this._ranges.length&&this._popRange(),"before"==n.compareWith(i)?(this._pushRange(new Ts(n,i)),this._lastRangeBackward=!0):(this._pushRange(new Ts(i,n)),this._lastRangeBackward=!1),this.fire("change:range",{directChange:!0})}getAttribute(t){return this._attrs.get(t)}getAttributes(){return this._attrs.entries()}getAttributeKeys(){return this._attrs.keys()}hasAttribute(t){return this._attrs.has(t)}removeAttribute(t){this.hasAttribute(t)&&(this._attrs.delete(t),this.fire("change:attribute",{attributeKeys:[t],directChange:!0}))}setAttribute(t,e){this.getAttribute(t)!==e&&(this._attrs.set(t,e),this.fire("change:attribute",{attributeKeys:[t],directChange:!0}))}getSelectedElement(){return 1!==this.rangeCount?null:this.getFirstRange().getContainedElement()}is(t){return"selection"===t||"model:selection"===t}*getSelectedBlocks(){const t=new WeakSet;for(const e of this.getRanges()){const n=Ds(e.start,t);n&&Ls(n,e)&&(yield n);for(const n of e.getWalker()){const i=n.item;"elementEnd"==n.type&&Rs(i,t,e)&&(yield i)}const i=Ds(e.end,t);i&&!e.end.isTouching(ys._createAt(i,0))&&Ls(i,e)&&(yield i)}}containsEntireContent(t=this.anchor.root){const e=ys._createAt(t,0),n=ys._createAt(t,"end");return e.isTouching(this.getFirstPosition())&&n.isTouching(this.getLastPosition())}_pushRange(t){this._checkRange(t),this._ranges.push(new Ts(t.start,t.end))}_checkRange(t){for(let e=0;e<this._ranges.length;e++)if(t.isIntersecting(this._ranges[e]))throw new hn.b("model-selection-range-intersects: Trying to add a range that intersects with another range in the selection.",[this,t],{addedRange:t,intersectingRange:this._ranges[e]})}_removeAllRanges(){for(;this._ranges.length>0;)this._popRange()}_popRange(){this._ranges.pop()}}function Os(t,e){return!e.has(t)&&(e.add(t),t.root.document.model.schema.isBlock(t)&&t.parent)}function Rs(t,e,n){return Os(t,e)&&Ls(t,n)}function Ds(t,e){const n=t.parent.root.document.model.schema,i=t.parent.getAncestors({parentFirst:!0,includeSelf:!0});let o=!1;const r=i.find(t=>!o&&(o=n.isLimit(t),!o&&Os(t,e)));return i.forEach(t=>e.add(t)),r}function Ls(t,e){const n=function(t){const e=t.root.document.model.schema;let n=t.parent;for(;n;){if(e.isBlock(n))return n;n=n.parent}}(t);if(!n)return!0;return!e.containsRange(Ts._createOn(n),!0)}xn(Ns,mn);class js extends Ts{constructor(t,e){super(t,e),Vs.call(this)}detach(){this.stopListening()}is(t){return"liveRange"===t||"model:liveRange"===t||"range"==t||"model:range"===t}toRange(){return new Ts(this.start,this.end)}static fromRange(t){return new js(t.start,t.end)}}function Vs(){this.listenTo(this.root.document.model,"applyOperation",(t,e)=>{const n=e[0];n.isDocumentOperation&&zs.call(this,n)},{priority:"low"})}function zs(t){const e=this.getTransformedByOperation(t),n=Ts._createFromRanges(e),i=!n.isEqual(this),o=function(t,e){switch(e.type){case"insert":return t.containsPosition(e.position);case"move":case"remove":case"reinsert":case"merge":return t.containsPosition(e.sourcePosition)||t.start.isEqual(e.sourcePosition)||t.containsPosition(e.targetPosition);case"split":return t.containsPosition(e.splitPosition)||t.containsPosition(e.insertionPosition)}return!1}(this,t);let r=null;if(i){"$graveyard"==n.root.rootName&&(r="remove"==t.type?t.sourcePosition:t.deletionPosition);const e=this.toRange();this.start=n.start,this.end=n.end,this.fire("change:range",e,{deletionPosition:r})}else o&&this.fire("change:content",this.toRange(),{deletionPosition:r})}xn(js,mn);class Bs{constructor(t){this._selection=new Fs(t),this._selection.delegate("change:range").to(this),this._selection.delegate("change:attribute").to(this),this._selection.delegate("change:marker").to(this)}get isCollapsed(){return this._selection.isCollapsed}get anchor(){return this._selection.anchor}get focus(){return this._selection.focus}get rangeCount(){return this._selection.rangeCount}get hasOwnRange(){return this._selection.hasOwnRange}get isBackward(){return this._selection.isBackward}get isGravityOverridden(){return this._selection.isGravityOverridden}get markers(){return this._selection.markers}get _ranges(){return this._selection._ranges}getRanges(){return this._selection.getRanges()}getFirstPosition(){return this._selection.getFirstPosition()}getLastPosition(){return this._selection.getLastPosition()}getFirstRange(){return this._selection.getFirstRange()}getLastRange(){return this._selection.getLastRange()}getSelectedBlocks(){return this._selection.getSelectedBlocks()}getSelectedElement(){return this._selection.getSelectedElement()}containsEntireContent(t){return this._selection.containsEntireContent(t)}destroy(){this._selection.destroy()}getAttributeKeys(){return this._selection.getAttributeKeys()}getAttributes(){return this._selection.getAttributes()}getAttribute(t){return this._selection.getAttribute(t)}hasAttribute(t){return this._selection.hasAttribute(t)}refresh(){this._selection._updateMarkers(),this._selection._updateAttributes(!1)}is(t){return"selection"===t||"model:selection"==t||"documentSelection"==t||"model:documentSelection"==t}_setFocus(t,e){this._selection.setFocus(t,e)}_setTo(t,e,n){this._selection.setTo(t,e,n)}_setAttribute(t,e){this._selection.setAttribute(t,e)}_removeAttribute(t){this._selection.removeAttribute(t)}_getStoredAttributes(){return this._selection._getStoredAttributes()}_overrideGravity(){return this._selection.overrideGravity()}_restoreGravity(t){this._selection.restoreGravity(t)}static _getStoreAttributeKey(t){return"selection:"+t}static _isStoreAttributeKey(t){return t.startsWith("selection:")}}xn(Bs,mn);class Fs extends Ns{constructor(t){super(),this.markers=new An({idProperty:"name"}),this._model=t.model,this._document=t,this._attributePriority=new Map,this._fixGraveyardRangesData=[],this._hasChangedRange=!1,this._overriddenGravityRegister=new Set,this.listenTo(this._model,"applyOperation",(t,e)=>{const n=e[0];if(n.isDocumentOperation&&"marker"!=n.type&&"rename"!=n.type&&"noop"!=n.type){for(;this._fixGraveyardRangesData.length;){const{liveRange:t,sourcePosition:e}=this._fixGraveyardRangesData.shift();this._fixGraveyardSelection(t,e)}this._hasChangedRange&&(this._hasChangedRange=!1,this.fire("change:range",{directChange:!1}))}},{priority:"lowest"}),this.on("change:range",()=>{for(const t of this.getRanges())if(!this._document._validateSelectionRange(t))throw new hn.b("document-selection-wrong-position: Range from document selection starts or ends at incorrect position.",this,{range:t})}),this.listenTo(this._model.markers,"update",()=>this._updateMarkers()),this.listenTo(this._document,"change",(t,e)=>{!function(t,e){const n=t.document.differ;for(const i of n.getChanges()){if("insert"!=i.type)continue;const n=i.position.parent;i.length===n.maxOffset&&t.enqueueChange(e,t=>{const e=Array.from(n.getAttributeKeys()).filter(t=>t.startsWith("selection:"));for(const i of e)t.removeAttribute(i,n)})}}(this._model,e)})}get isCollapsed(){return 0===this._ranges.length?this._document._getDefaultRange().isCollapsed:super.isCollapsed}get anchor(){return super.anchor||this._document._getDefaultRange().start}get focus(){return super.focus||this._document._getDefaultRange().end}get rangeCount(){return this._ranges.length?this._ranges.length:1}get hasOwnRange(){return this._ranges.length>0}get isGravityOverridden(){return!!this._overriddenGravityRegister.size}destroy(){for(let t=0;t<this._ranges.length;t++)this._ranges[t].detach();this.stopListening()}*getRanges(){this._ranges.length?yield*super.getRanges():yield this._document._getDefaultRange()}getFirstRange(){return super.getFirstRange()||this._document._getDefaultRange()}getLastRange(){return super.getLastRange()||this._document._getDefaultRange()}setTo(t,e,n){super.setTo(t,e,n),this._updateAttributes(!0),this._updateMarkers()}setFocus(t,e){super.setFocus(t,e),this._updateAttributes(!0),this._updateMarkers()}setAttribute(t,e){if(this._setAttribute(t,e)){const e=[t];this.fire("change:attribute",{attributeKeys:e,directChange:!0})}}removeAttribute(t){if(this._removeAttribute(t)){const e=[t];this.fire("change:attribute",{attributeKeys:e,directChange:!0})}}overrideGravity(){const t=dn();return this._overriddenGravityRegister.add(t),1===this._overriddenGravityRegister.size&&this._updateAttributes(!0),t}restoreGravity(t){if(!this._overriddenGravityRegister.has(t))throw new hn.b("document-selection-gravity-wrong-restore: Attempting to restore the selection gravity for an unknown UID.",this,{uid:t});this._overriddenGravityRegister.delete(t),this.isGravityOverridden||this._updateAttributes(!0)}_popRange(){this._ranges.pop().detach()}_pushRange(t){const e=this._prepareRange(t);e&&this._ranges.push(e)}_prepareRange(t){if(this._checkRange(t),t.root==this._document.graveyard)return;const e=js.fromRange(t);return e.on("change:range",(t,n,i)=>{this._hasChangedRange=!0,e.root==this._document.graveyard&&this._fixGraveyardRangesData.push({liveRange:e,sourcePosition:i.deletionPosition})}),e}_updateMarkers(){const t=[];let e=!1;for(const e of this._model.markers){const n=e.getRange();for(const i of this.getRanges())n.containsRange(i,!i.isCollapsed)&&t.push(e)}const n=Array.from(this.markers);for(const n of t)this.markers.has(n)||(this.markers.add(n),e=!0);for(const n of Array.from(this.markers))t.includes(n)||(this.markers.remove(n),e=!0);e&&this.fire("change:marker",{oldMarkers:n,directChange:!1})}_updateAttributes(t){const e=Ln(this._getSurroundingAttributes()),n=Ln(this.getAttributes());if(t)this._attributePriority=new Map,this._attrs=new Map;else for(const[t,e]of this._attributePriority)"low"==e&&(this._attrs.delete(t),this._attributePriority.delete(t));this._setAttributesTo(e);const i=[];for(const[t,e]of this.getAttributes())n.has(t)&&n.get(t)===e||i.push(t);for(const[t]of n)this.hasAttribute(t)||i.push(t);i.length>0&&this.fire("change:attribute",{attributeKeys:i,directChange:!1})}_setAttribute(t,e,n=!0){const i=n?"normal":"low";if("low"==i&&"normal"==this._attributePriority.get(t))return!1;return super.getAttribute(t)!==e&&(this._attrs.set(t,e),this._attributePriority.set(t,i),!0)}_removeAttribute(t,e=!0){const n=e?"normal":"low";return("low"!=n||"normal"!=this._attributePriority.get(t))&&(this._attributePriority.set(t,n),!!super.hasAttribute(t)&&(this._attrs.delete(t),!0))}_setAttributesTo(t){const e=new Set;for(const[e,n]of this.getAttributes())t.get(e)!==n&&this._removeAttribute(e,!1);for(const[n,i]of t){this._setAttribute(n,i,!1)&&e.add(n)}return e}*_getStoredAttributes(){const t=this.getFirstPosition().parent;if(this.isCollapsed&&t.isEmpty)for(const e of t.getAttributeKeys())if(e.startsWith("selection:")){const n=e.substr("selection:".length);yield[n,t.getAttribute(e)]}}_getSurroundingAttributes(){const t=this.getFirstPosition(),e=this._model.schema;let n=null;if(this.isCollapsed){const e=t.textNode?t.textNode:t.nodeBefore,i=t.textNode?t.textNode:t.nodeAfter;if(this.isGravityOverridden||(n=Us(e)),n||(n=Us(i)),!this.isGravityOverridden&&!n){let t=e;for(;t&&!n;)t=t.previousSibling,n=Us(t)}if(!n){let t=i;for(;t&&!n;)t=t.nextSibling,n=Us(t)}n||(n=this._getStoredAttributes())}else{const t=this.getFirstRange();for(const i of t){if(i.item.is("element")&&e.isObject(i.item))break;if("text"==i.type){n=i.item.getAttributes();break}}}return n}_fixGraveyardSelection(t,e){const n=e.clone(),i=this._model.schema.getNearestSelectionRange(n),o=this._ranges.indexOf(t);if(this._ranges.splice(o,1),t.detach(),i&&(r=i,this._ranges.every(t=>!r.isEqual(t)))){const t=this._prepareRange(i);this._ranges.splice(o,0,t)}var r}}function Us(t){return t instanceof bs||t instanceof ps?t.getAttributes():null}class Hs{constructor(t){this._dispatchers=t}add(t){for(const e of this._dispatchers)t(e);return this}}var Ws=function(t){return tn(t,5)};class qs extends Hs{elementToElement(t){return this.add(function(t){return(t=Ws(t)).view=Gs(t.view,"container"),e=>{var n;e.on("insert:"+t.model,(n=t.view,(t,e,i)=>{const o=n(e.item,i.writer);if(!o)return;if(!i.consumable.consume(e.item,"insert"))return;const r=i.mapper.toViewPosition(e.range.start);i.mapper.bindElements(e.item,o),i.writer.insert(r,o)}),{priority:t.converterPriority||"normal"})}}(t))}attributeToElement(t){return this.add(function(t){t=Ws(t);let e="attribute:"+(t.model.key?t.model.key:t.model);t.model.name&&(e+=":"+t.model.name);if(t.model.values)for(const e of t.model.values)t.view[e]=Gs(t.view[e],"attribute");else t.view=Gs(t.view,"attribute");const n=$s(t);return i=>{i.on(e,function(t){return(e,n,i)=>{const o=t(n.attributeOldValue,i.writer),r=t(n.attributeNewValue,i.writer);if(!o&&!r)return;if(!i.consumable.consume(n.item,e.name))return;const s=i.writer,a=s.document.selection;if(n.item instanceof Ns||n.item instanceof Bs)s.wrap(a.getFirstRange(),r);else{let t=i.mapper.toViewRange(n.range);null!==n.attributeOldValue&&o&&(t=s.unwrap(t,o)),null!==n.attributeNewValue&&r&&s.wrap(t,r)}}}(n),{priority:t.converterPriority||"normal"})}}(t))}attributeToAttribute(t){return this.add(function(t){t=Ws(t);let e="attribute:"+(t.model.key?t.model.key:t.model);t.model.name&&(e+=":"+t.model.name);if(t.model.values)for(const e of t.model.values)t.view[e]=Ks(t.view[e]);else t.view=Ks(t.view);const n=$s(t);return i=>{var o;i.on(e,(o=n,(t,e,n)=>{const i=o(e.attributeOldValue,e),r=o(e.attributeNewValue,e);if(!i&&!r)return;if(!n.consumable.consume(e.item,t.name))return;const s=n.mapper.toViewElement(e.item),a=n.writer;if(!s)throw new hn.b("conversion-attribute-to-attribute-on-text: Trying to convert text node's attribute with attribute-to-attribute converter.",[e,n]);if(null!==e.attributeOldValue&&i)if("class"==i.key){const t=Array.isArray(i.value)?i.value:[i.value];for(const e of t)a.removeClass(e,s)}else if("style"==i.key){const t=Object.keys(i.value);for(const e of t)a.removeStyle(e,s)}else a.removeAttribute(i.key,s);if(null!==e.attributeNewValue&&r)if("class"==r.key){const t=Array.isArray(r.value)?r.value:[r.value];for(const e of t)a.addClass(e,s)}else if("style"==r.key){const t=Object.keys(r.value);for(const e of t)a.setStyle(e,r.value[e],s)}else a.setAttribute(r.key,r.value,s)}),{priority:t.converterPriority||"normal"})}}(t))}markerToElement(t){return this.add(function(t){return(t=Ws(t)).view=Gs(t.view,"ui"),e=>{var n;e.on("addMarker:"+t.model,(n=t.view,(t,e,i)=>{e.isOpening=!0;const o=n(e,i.writer);e.isOpening=!1;const r=n(e,i.writer);if(!o||!r)return;const s=e.markerRange;if(s.isCollapsed&&!i.consumable.consume(s,t.name))return;for(const e of s)if(!i.consumable.consume(e.item,t.name))return;const a=i.mapper,c=i.writer;c.insert(a.toViewPosition(s.start),o),i.mapper.bindElementToMarker(o,e.markerName),s.isCollapsed||(c.insert(a.toViewPosition(s.end),r),i.mapper.bindElementToMarker(r,e.markerName)),t.stop()}),{priority:t.converterPriority||"normal"}),e.on("removeMarker:"+t.model,(t.view,(t,e,n)=>{const i=n.mapper.markerNameToElements(e.markerName);if(i){for(const t of i)n.mapper.unbindElementFromMarkerName(t,e.markerName),n.writer.clear(n.writer.createRangeOn(t),t);n.writer.clearClonedElementsGroup(e.markerName),t.stop()}}),{priority:t.converterPriority||"normal"})}}(t))}markerToHighlight(t){return this.add(function(t){return e=>{var n;e.on("addMarker:"+t.model,(n=t.view,(t,e,i)=>{if(!e.item)return;if(!(e.item instanceof Ns||e.item instanceof Bs||e.item.is("textProxy")))return;const o=Qs(n,e,i);if(!o)return;if(!i.consumable.consume(e.item,t.name))return;const r=i.writer,s=Ys(r,o),a=r.document.selection;if(e.item instanceof Ns||e.item instanceof Bs)r.wrap(a.getFirstRange(),s,a);else{const t=i.mapper.toViewRange(e.range),n=r.wrap(t,s);for(const t of n.getItems())if(t.is("attributeElement")&&t.isSimilar(s)){i.mapper.bindElementToMarker(t,e.markerName);break}}}),{priority:t.converterPriority||"normal"}),e.on("addMarker:"+t.model,function(t){return(e,n,i)=>{if(!n.item)return;if(!(n.item instanceof ks))return;const o=Qs(t,n,i);if(!o)return;if(!i.consumable.test(n.item,e.name))return;const r=i.mapper.toViewElement(n.item);if(r&&r.getCustomProperty("addHighlight")){i.consumable.consume(n.item,e.name);for(const t of Ts._createIn(n.item))i.consumable.consume(t.item,e.name);r.getCustomProperty("addHighlight")(r,o,i.writer),i.mapper.bindElementToMarker(r,n.markerName)}}}(t.view),{priority:t.converterPriority||"normal"}),e.on("removeMarker:"+t.model,function(t){return(e,n,i)=>{if(n.markerRange.isCollapsed)return;const o=Qs(t,n,i);if(!o)return;const r=Ys(i.writer,o),s=i.mapper.markerNameToElements(n.markerName);if(s){for(const t of s)i.mapper.unbindElementFromMarkerName(t,n.markerName),t.is("attributeElement")?i.writer.unwrap(i.writer.createRangeOn(t),r):t.getCustomProperty("removeHighlight")(t,o.id,i.writer);i.writer.clearClonedElementsGroup(n.markerName),e.stop()}}}(t.view),{priority:t.converterPriority||"normal"})}}(t))}}function Ys(t,e){const n=t.createAttributeElement("span",e.attributes);return e.classes&&n._addClass(e.classes),e.priority&&(n._priority=e.priority),n._id=e.id,n}function Gs(t,e){return"function"==typeof t?t:(n,i)=>function(t,e,n){"string"==typeof t&&(t={name:t});let i;const o=Object.assign({},t.attributes);if("container"==n)i=e.createContainerElement(t.name,o);else if("attribute"==n){const n={priority:t.priority||ro.DEFAULT_PRIORITY};i=e.createAttributeElement(t.name,o,n)}else i=e.createUIElement(t.name,o);if(t.styles){const n=Object.keys(t.styles);for(const o of n)e.setStyle(o,t.styles[o],i)}if(t.classes){const n=t.classes;if("string"==typeof n)e.addClass(n,i);else for(const t of n)e.addClass(t,i)}return i}(t,i,e)}function $s(t){return t.model.values?(e,n)=>{const i=t.view[e];return i?i(e,n):null}:t.view}function Ks(t){return"string"==typeof t?e=>({key:t,value:e}):"object"==typeof t?t.value?()=>t:e=>({key:t.key,value:e}):t}function Qs(t,e,n){const i="function"==typeof t?t(e,n):t;return i?(i.priority||(i.priority=10),i.id||(i.id=e.markerName),i):null}class Js extends Hs{elementToElement(t){return this.add(Zs(t))}elementToAttribute(t){return this.add(function(t){ta(t=Ws(t));const e=ea(t,!1),n=Xs(t.view),i=n?"element:"+n:"element";return n=>{n.on(i,e,{priority:t.converterPriority||"low"})}}(t))}attributeToAttribute(t){return this.add(function(t){t=Ws(t);let e=null;("string"==typeof t.view||t.view.key)&&(e=function(t){"string"==typeof t.view&&(t.view={key:t.view});const e=t.view.key;let n;if("class"==e||"style"==e){n={["class"==e?"classes":"styles"]:t.view.value}}else{const i=void 0===t.view.value?/[\s\S]*/:t.view.value;n={attributes:{[e]:i}}}t.view.name&&(n.name=t.view.name);return t.view=n,e}(t));ta(t,e);const n=ea(t,!0);return e=>{e.on("element",n,{priority:t.converterPriority||"low"})}}(t))}elementToMarker(t){return this.add(function(t){return function(t){const e=t.model;t.model=(t,n)=>{const i="string"==typeof e?e:e(t);return n.createElement("$marker",{"data-name":i})}}(t=Ws(t)),Zs(t)}(t))}}function Zs(t){const e=function(t){const e=t.view?new jn(t.view):null;return(n,i,o)=>{let r={};if(e){const t=e.match(i.viewItem);if(!t)return;r=t.match}r.name=!0;const s=(a=t.model,c=i.viewItem,l=o.writer,a instanceof Function?a(c,l):l.createElement(a));var a,c,l;if(!s)return;if(!o.consumable.test(i.viewItem,r))return;const d=o.splitToAllowedParent(s,i.modelCursor);if(!d)return;o.writer.insert(s,d.position),o.convertChildren(i.viewItem,o.writer.createPositionAt(s,0)),o.consumable.consume(i.viewItem,r);const u=o.getSplitParts(s);i.modelRange=new Ts(o.writer.createPositionBefore(s),o.writer.createPositionAfter(u[u.length-1])),d.cursorParent?i.modelCursor=o.writer.createPositionAt(d.cursorParent,0):i.modelCursor=i.modelRange.end}}(t=Ws(t)),n=Xs(t.view),i=n?"element:"+n:"element";return n=>{n.on(i,e,{priority:t.converterPriority||"normal"})}}function Xs(t){return"string"==typeof t?t:"object"==typeof t&&"string"==typeof t.name?t.name:null}function ta(t,e=null){const n=null===e||(t=>t.getAttribute(e)),i="object"!=typeof t.model?t.model:t.model.key,o="object"!=typeof t.model||void 0===t.model.value?n:t.model.value;t.model={key:i,value:o}}function ea(t,e){const n=new jn(t.view);return(i,o,r)=>{const s=n.match(o.viewItem);if(!s)return;const a=t.model.key,c="function"==typeof t.model.value?t.model.value(o.viewItem):t.model.value;if(null===c)return;if(!function(t,e){const n="function"==typeof t?t(e):t;if("object"==typeof n&&!Xs(n))return!1;return!n.classes&&!n.attributes&&!n.styles}(t.view,o.viewItem)?delete s.match.name:s.match.name=!0,!r.consumable.test(o.viewItem,s.match))return;o.modelRange||(o=Object.assign(o,r.convertChildren(o.viewItem,o.modelCursor)));(function(t,e,n,i){let o=!1;for(const r of Array.from(t.getItems({shallow:n})))i.schema.checkAttribute(r,e.key)&&(i.writer.setAttribute(e.key,e.value,r),o=!0);return o})(o.modelRange,{key:a,value:c},e,r)&&r.consumable.consume(o.viewItem,s.match)}}class na{constructor(t,e){this.model=t,this.view=new gs(e),this.mapper=new Ps,this.downcastDispatcher=new Ms({mapper:this.mapper});const n=this.model.document,i=n.selection,o=this.model.markers;this.listenTo(this.model,"_beforeChanges",()=>{this.view._disableRendering(!0)},{priority:"highest"}),this.listenTo(this.model,"_afterChanges",()=>{this.view._disableRendering(!1)},{priority:"lowest"}),this.listenTo(n,"change",()=>{this.view.change(t=>{this.downcastDispatcher.convertChanges(n.differ,o,t),this.downcastDispatcher.convertSelection(i,o,t)})},{priority:"low"}),this.listenTo(this.view.document,"selectionChange",function(t,e){return(n,i)=>{const o=i.newSelection,r=new Ns,s=[];for(const t of o.getRanges())s.push(e.toModelRange(t));r.setTo(s,{backward:o.isBackward}),r.isEqual(t.document.selection)||t.change(t=>{t.setSelection(r)})}}(this.model,this.mapper)),this.downcastDispatcher.on("insert:$text",(t,e,n)=>{if(!n.consumable.consume(e.item,"insert"))return;const i=n.writer,o=n.mapper.toViewPosition(e.range.start),r=i.createText(e.item.data);i.insert(o,r)},{priority:"lowest"}),this.downcastDispatcher.on("remove",(t,e,n)=>{const i=n.mapper.toViewPosition(e.position),o=e.position.getShiftedBy(e.length),r=n.mapper.toViewPosition(o,{isPhantom:!0}),s=n.writer.createRange(i,r),a=n.writer.remove(s.getTrimmed());for(const t of n.writer.createRangeIn(a).getItems())n.mapper.unbindViewElement(t)},{priority:"low"}),this.downcastDispatcher.on("selection",(t,e,n)=>{const i=n.writer,o=i.document.selection;for(const t of o.getRanges())t.isCollapsed&&t.end.parent.isAttached()&&n.writer.mergeAttributes(t.start);i.setSelection(null)},{priority:"low"}),this.downcastDispatcher.on("selection",(t,e,n)=>{const i=e.selection;if(i.isCollapsed)return;if(!n.consumable.consume(i,"selection"))return;const o=[];for(const t of i.getRanges()){const e=n.mapper.toViewRange(t);o.push(e)}n.writer.setSelection(o,{backward:i.isBackward})},{priority:"low"}),this.downcastDispatcher.on("selection",(t,e,n)=>{const i=e.selection;if(!i.isCollapsed)return;if(!n.consumable.consume(i,"selection"))return;const o=n.writer,r=i.getFirstPosition(),s=n.mapper.toViewPosition(r),a=o.breakAttributes(s);o.setSelection(a)},{priority:"low"}),this.view.document.roots.bindTo(this.model.document.roots).using(t=>{if("$graveyard"==t.rootName)return null;const e=new Qi(this.view.document,t.name);return e.rootName=t.rootName,this.mapper.bindElements(t,e),e})}destroy(){this.view.destroy(),this.stopListening()}}xn(na,Ui);class ia{constructor(){this._commands=new Map}add(t,e){this._commands.set(t,e)}get(t){return this._commands.get(t)}execute(t,...e){const n=this.get(t);if(!n)throw new hn.b("commandcollection-command-not-found: Command does not exist.",this,{commandName:t});n.execute(...e)}*names(){yield*this._commands.keys()}*commands(){yield*this._commands.values()}[Symbol.iterator](){return this._commands[Symbol.iterator]()}destroy(){for(const t of this.commands())t.destroy()}}class oa{constructor(){this._consumables=new Map}add(t,e){let n;t.is("text")||t.is("documentFragment")?this._consumables.set(t,!0):(this._consumables.has(t)?n=this._consumables.get(t):(n=new ra(t),this._consumables.set(t,n)),n.add(e))}test(t,e){const n=this._consumables.get(t);return void 0===n?null:t.is("text")||t.is("documentFragment")?n:n.test(e)}consume(t,e){return!!this.test(t,e)&&(t.is("text")||t.is("documentFragment")?this._consumables.set(t,!1):this._consumables.get(t).consume(e),!0)}revert(t,e){const n=this._consumables.get(t);void 0!==n&&(t.is("text")||t.is("documentFragment")?this._consumables.set(t,!0):n.revert(e))}static consumablesFromElement(t){const e={element:t,name:!0,attributes:[],classes:[],styles:[]},n=t.getAttributeKeys();for(const t of n)"style"!=t&&"class"!=t&&e.attributes.push(t);const i=t.getClassNames();for(const t of i)e.classes.push(t);const o=t.getStyleNames();for(const t of o)e.styles.push(t);return e}static createFrom(t,e){if(e||(e=new oa(t)),t.is("text"))return e.add(t),e;t.is("element")&&e.add(t,oa.consumablesFromElement(t)),t.is("documentFragment")&&e.add(t);for(const n of t.getChildren())e=oa.createFrom(n,e);return e}}class ra{constructor(t){this.element=t,this._canConsumeName=null,this._consumables={attributes:new Map,styles:new Map,classes:new Map}}add(t){t.name&&(this._canConsumeName=!0);for(const e in this._consumables)e in t&&this._add(e,t[e])}test(t){if(t.name&&!this._canConsumeName)return this._canConsumeName;for(const e in this._consumables)if(e in t){const n=this._test(e,t[e]);if(!0!==n)return n}return!0}consume(t){t.name&&(this._canConsumeName=!1);for(const e in this._consumables)e in t&&this._consume(e,t[e])}revert(t){t.name&&(this._canConsumeName=!0);for(const e in this._consumables)e in t&&this._revert(e,t[e])}_add(t,e){const n=Dt(e)?e:[e],i=this._consumables[t];for(const e of n){if("attributes"===t&&("class"===e||"style"===e))throw new hn.b("viewconsumable-invalid-attribute: Classes and styles should be handled separately.",this);if(i.set(e,!0),"styles"===t)for(const t of this.element.document.stylesProcessor.getRelatedStyles(e))i.set(t,!0)}}_test(t,e){const n=Dt(e)?e:[e],i=this._consumables[t];for(const e of n)if("attributes"!==t||"class"!==e&&"style"!==e){const t=i.get(e);if(void 0===t)return null;if(!t)return!1}else{const t="class"==e?"classes":"styles",n=this._test(t,[...this._consumables[t].keys()]);if(!0!==n)return n}return!0}_consume(t,e){const n=Dt(e)?e:[e],i=this._consumables[t];for(const e of n)if("attributes"!==t||"class"!==e&&"style"!==e){if(i.set(e,!1),"styles"==t)for(const t of this.element.document.stylesProcessor.getRelatedStyles(e))i.set(t,!1)}else{const t="class"==e?"classes":"styles";this._consume(t,[...this._consumables[t].keys()])}}_revert(t,e){const n=Dt(e)?e:[e],i=this._consumables[t];for(const e of n)if("attributes"!==t||"class"!==e&&"style"!==e){!1===i.get(e)&&i.set(e,!0)}else{const t="class"==e?"classes":"styles";this._revert(t,[...this._consumables[t].keys()])}}}class sa{constructor(){this._sourceDefinitions={},this._attributeProperties={},this.decorate("checkChild"),this.decorate("checkAttribute"),this.on("checkAttribute",(t,e)=>{e[0]=new aa(e[0])},{priority:"highest"}),this.on("checkChild",(t,e)=>{e[0]=new aa(e[0]),e[1]=this.getDefinition(e[1])},{priority:"highest"})}register(t,e){if(this._sourceDefinitions[t])throw new hn.b("schema-cannot-register-item-twice: A single item cannot be registered twice in the schema.",this,{itemName:t});this._sourceDefinitions[t]=[Object.assign({},e)],this._clearCache()}extend(t,e){if(!this._sourceDefinitions[t])throw new hn.b("schema-cannot-extend-missing-item: Cannot extend an item which was not registered yet.",this,{itemName:t});this._sourceDefinitions[t].push(Object.assign({},e)),this._clearCache()}getDefinitions(){return this._compiledDefinitions||this._compile(),this._compiledDefinitions}getDefinition(t){let e;return e="string"==typeof t?t:t.is&&(t.is("text")||t.is("textProxy"))?"$text":t.name,this.getDefinitions()[e]}isRegistered(t){return!!this.getDefinition(t)}isBlock(t){const e=this.getDefinition(t);return!(!e||!e.isBlock)}isLimit(t){const e=this.getDefinition(t);return!!e&&!(!e.isLimit&&!e.isObject)}isObject(t){const e=this.getDefinition(t);return!(!e||!e.isObject)}isInline(t){const e=this.getDefinition(t);return!(!e||!e.isInline)}checkChild(t,e){return!!e&&this._checkContextMatch(e,t)}checkAttribute(t,e){const n=this.getDefinition(t.last);return!!n&&n.allowAttributes.includes(e)}checkMerge(t,e=null){if(t instanceof ys){const e=t.nodeBefore,n=t.nodeAfter;if(!(e instanceof ks))throw new hn.b("schema-check-merge-no-element-before: The node before the merge position must be an element.",this);if(!(n instanceof ks))throw new hn.b("schema-check-merge-no-element-after: The node after the merge position must be an element.",this);return this.checkMerge(e,n)}for(const n of e.getChildren())if(!this.checkChild(t,n))return!1;return!0}addChildCheck(t){this.on("checkChild",(e,[n,i])=>{if(!i)return;const o=t(n,i);"boolean"==typeof o&&(e.stop(),e.return=o)},{priority:"high"})}addAttributeCheck(t){this.on("checkAttribute",(e,[n,i])=>{const o=t(n,i);"boolean"==typeof o&&(e.stop(),e.return=o)},{priority:"high"})}setAttributeProperties(t,e){this._attributeProperties[t]=Object.assign(this.getAttributeProperties(t),e)}getAttributeProperties(t){return this._attributeProperties[t]||{}}getLimitElement(t){let e;if(t instanceof ys)e=t.parent;else{e=(t instanceof Ts?[t]:Array.from(t.getRanges())).reduce((t,e)=>{const n=e.getCommonAncestor();return t?t.getCommonAncestor(n,{includeSelf:!0}):n},null)}for(;!this.isLimit(e)&&e.parent;)e=e.parent;return e}checkAttributeInSelection(t,e){if(t.isCollapsed){const n=[...t.getFirstPosition().getAncestors(),new ps("",t.getAttributes())];return this.checkAttribute(n,e)}{const n=t.getRanges();for(const t of n)for(const n of t)if(this.checkAttribute(n.item,e))return!0}return!1}*getValidRanges(t,e){t=function*(t){for(const e of t)yield*e.getMinimalFlatRanges()}(t);for(const n of t)yield*this._getValidRangesForRange(n,e)}getNearestSelectionRange(t,e="both"){if(this.checkChild(t,"$text"))return new Ts(t);let n,i;const o=t.getAncestors().reverse().find(t=>this.isLimit(t))||t.root;"both"!=e&&"backward"!=e||(n=new _s({boundaries:Ts._createIn(o),startPosition:t,direction:"backward"})),"both"!=e&&"forward"!=e||(i=new _s({boundaries:Ts._createIn(o),startPosition:t}));for(const t of function*(t,e){let n=!1;for(;!n;){if(n=!0,t){const e=t.next();e.done||(n=!1,yield{walker:t,value:e.value})}if(e){const t=e.next();t.done||(n=!1,yield{walker:e,value:t.value})}}}(n,i)){const e=t.walker==n?"elementEnd":"elementStart",i=t.value;if(i.type==e&&this.isObject(i.item))return Ts._createOn(i.item);if(this.checkChild(i.nextPosition,"$text"))return new Ts(i.nextPosition)}return null}findAllowedParent(t,e){let n=t.parent;for(;n;){if(this.checkChild(n,e))return n;if(this.isLimit(n))return null;n=n.parent}return null}removeDisallowedAttributes(t,e){for(const n of t)if(n.is("text"))wa(this,n,e);else{const t=Ts._createIn(n).getPositions();for(const n of t){wa(this,n.nodeBefore||n.parent,e)}}}createContext(t){return new aa(t)}_clearCache(){this._compiledDefinitions=null}_compile(){const t={},e=this._sourceDefinitions,n=Object.keys(e);for(const i of n)t[i]=ca(e[i],i);for(const e of n)la(t,e);for(const e of n)da(t,e);for(const e of n)ua(t,e),ha(t,e);for(const e of n)fa(t,e),ga(t,e);this._compiledDefinitions=t}_checkContextMatch(t,e,n=e.length-1){const i=e.getItem(n);if(t.allowIn.includes(i.name)){if(0==n)return!0;{const t=this.getDefinition(i);return this._checkContextMatch(t,e,n-1)}}return!1}*_getValidRangesForRange(t,e){let n=t.start,i=t.start;for(const o of t.getItems({shallow:!0}))o.is("element")&&(yield*this._getValidRangesForRange(Ts._createIn(o),e)),this.checkAttribute(o,e)||(n.isEqual(i)||(yield new Ts(n,i)),n=ys._createAfter(o)),i=ys._createAfter(o);n.isEqual(i)||(yield new Ts(n,i))}}xn(sa,Ui);class aa{constructor(t){if(t instanceof aa)return t;"string"==typeof t?t=[t]:Array.isArray(t)||(t=t.getAncestors({includeSelf:!0})),t[0]&&"string"!=typeof t[0]&&t[0].is("documentFragment")&&t.shift(),this._items=t.map(ba)}get length(){return this._items.length}get last(){return this._items[this._items.length-1]}[Symbol.iterator](){return this._items[Symbol.iterator]()}push(t){const e=new aa([t]);return e._items=[...this._items,...e._items],e}getItem(t){return this._items[t]}*getNames(){yield*this._items.map(t=>t.name)}endsWith(t){return Array.from(this.getNames()).join(" ").endsWith(t)}startsWith(t){return Array.from(this.getNames()).join(" ").startsWith(t)}}function ca(t,e){const n={name:e,allowIn:[],allowContentOf:[],allowWhere:[],allowAttributes:[],allowAttributesOf:[],inheritTypesFrom:[]};return function(t,e){for(const n of t){const t=Object.keys(n).filter(t=>t.startsWith("is"));for(const i of t)e[i]=n[i]}}(t,n),ma(t,n,"allowIn"),ma(t,n,"allowContentOf"),ma(t,n,"allowWhere"),ma(t,n,"allowAttributes"),ma(t,n,"allowAttributesOf"),ma(t,n,"inheritTypesFrom"),function(t,e){for(const n of t){const t=n.inheritAllFrom;t&&(e.allowContentOf.push(t),e.allowWhere.push(t),e.allowAttributesOf.push(t),e.inheritTypesFrom.push(t))}}(t,n),n}function la(t,e){for(const n of t[e].allowContentOf)if(t[n]){pa(t,n).forEach(t=>{t.allowIn.push(e)})}delete t[e].allowContentOf}function da(t,e){for(const n of t[e].allowWhere){const i=t[n];if(i){const n=i.allowIn;t[e].allowIn.push(...n)}}delete t[e].allowWhere}function ua(t,e){for(const n of t[e].allowAttributesOf){const i=t[n];if(i){const n=i.allowAttributes;t[e].allowAttributes.push(...n)}}delete t[e].allowAttributesOf}function ha(t,e){const n=t[e];for(const e of n.inheritTypesFrom){const i=t[e];if(i){const t=Object.keys(i).filter(t=>t.startsWith("is"));for(const e of t)e in n||(n[e]=i[e])}}delete n.inheritTypesFrom}function fa(t,e){const n=t[e],i=n.allowIn.filter(e=>t[e]);n.allowIn=Array.from(new Set(i))}function ga(t,e){const n=t[e];n.allowAttributes=Array.from(new Set(n.allowAttributes))}function ma(t,e,n){for(const i of t)"string"==typeof i[n]?e[n].push(i[n]):Array.isArray(i[n])&&e[n].push(...i[n])}function pa(t,e){const n=t[e];return(i=t,Object.keys(i).map(t=>i[t])).filter(t=>t.allowIn.includes(n.name));var i}function ba(t){return"string"==typeof t?{name:t,*getAttributeKeys(){},getAttribute(){}}:{name:t.is("element")?t.name:"$text",*getAttributeKeys(){yield*t.getAttributeKeys()},getAttribute:e=>t.getAttribute(e)}}function wa(t,e,n){for(const i of e.getAttributeKeys())t.checkAttribute(e,i)||n.removeAttribute(i,e)}class ka{constructor(t={}){this._splitParts=new Map,this._modelCursor=null,this.conversionApi=Object.assign({},t),this.conversionApi.convertItem=this._convertItem.bind(this),this.conversionApi.convertChildren=this._convertChildren.bind(this),this.conversionApi.splitToAllowedParent=this._splitToAllowedParent.bind(this),this.conversionApi.getSplitParts=this._getSplitParts.bind(this)}convert(t,e,n=["$root"]){this.fire("viewCleanup",t),this._modelCursor=function(t,e){let n;for(const i of new aa(t)){const t={};for(const e of i.getAttributeKeys())t[e]=i.getAttribute(e);const o=e.createElement(i.name,t);n&&e.append(o,n),n=ys._createAt(o,0)}return n}(n,e),this.conversionApi.writer=e,this.conversionApi.consumable=oa.createFrom(t),this.conversionApi.store={};const{modelRange:i}=this._convertItem(t,this._modelCursor),o=e.createDocumentFragment();if(i){this._removeEmptyElements();for(const t of Array.from(this._modelCursor.parent.getChildren()))e.append(t,o);o.markers=function(t,e){const n=new Set,i=new Map,o=Ts._createIn(t).getItems();for(const t of o)"$marker"==t.name&&n.add(t);for(const t of n){const n=t.getAttribute("data-name"),o=e.createPositionBefore(t);i.has(n)?i.get(n).end=o.clone():i.set(n,new Ts(o.clone())),e.remove(t)}return i}(o,e)}return this._modelCursor=null,this._splitParts.clear(),this.conversionApi.writer=null,this.conversionApi.store=null,o}_convertItem(t,e){const n=Object.assign({viewItem:t,modelCursor:e,modelRange:null});if(t.is("element")?this.fire("element:"+t.name,n,this.conversionApi):t.is("text")?this.fire("text",n,this.conversionApi):this.fire("documentFragment",n,this.conversionApi),n.modelRange&&!(n.modelRange instanceof Ts))throw new hn.b("view-conversion-dispatcher-incorrect-result: Incorrect conversion result was dropped.",this);return{modelRange:n.modelRange,modelCursor:n.modelCursor}}_convertChildren(t,e){const n=new Ts(e);let i=e;for(const e of Array.from(t.getChildren())){const t=this._convertItem(e,i);t.modelRange instanceof Ts&&(n.end=t.modelRange.end,i=t.modelCursor)}return{modelRange:n,modelCursor:i}}_splitToAllowedParent(t,e){const n=this.conversionApi.schema.findAllowedParent(e,t);if(!n)return null;if(n===e.parent)return{position:e};if(this._modelCursor.parent.getAncestors().includes(n))return null;const i=this.conversionApi.writer.split(e,n),o=[];for(const t of i.range.getWalker())if("elementEnd"==t.type)o.push(t.item);else{const e=o.pop(),n=t.item;this._registerSplitPair(e,n)}return{position:i.position,cursorParent:i.range.end.parent}}_registerSplitPair(t,e){this._splitParts.has(t)||this._splitParts.set(t,[t]);const n=this._splitParts.get(t);this._splitParts.set(e,n),n.push(e)}_getSplitParts(t){let e;return e=this._splitParts.has(t)?this._splitParts.get(t):[t],e}_removeEmptyElements(){let t=!1;for(const e of this._splitParts.keys())e.isEmpty&&(this.conversionApi.writer.remove(e),this._splitParts.delete(e),t=!0);t&&this._removeEmptyElements()}}xn(ka,mn);class _a{constructor(t,e){this.model=t,this.stylesProcessor=e,this.processor,this.mapper=new Ps,this.downcastDispatcher=new Ms({mapper:this.mapper}),this.downcastDispatcher.on("insert:$text",(t,e,n)=>{if(!n.consumable.consume(e.item,"insert"))return;const i=n.writer,o=n.mapper.toViewPosition(e.range.start),r=i.createText(e.item.data);i.insert(o,r)},{priority:"lowest"}),this.upcastDispatcher=new ka({schema:t.schema}),this.viewDocument=new oo(e),this._viewWriter=new Po(this.viewDocument),this.upcastDispatcher.on("text",(t,e,n)=>{if(n.schema.checkChild(e.modelCursor,"$text")&&n.consumable.consume(e.viewItem)){const t=n.writer.createText(e.viewItem.data);n.writer.insert(t,e.modelCursor),e.modelRange=Ts._createFromPositionAndShift(e.modelCursor,t.offsetSize),e.modelCursor=e.modelRange.end}},{priority:"lowest"}),this.upcastDispatcher.on("element",(t,e,n)=>{if(!e.modelRange&&n.consumable.consume(e.viewItem,{name:!0})){const{modelRange:t,modelCursor:i}=n.convertChildren(e.viewItem,e.modelCursor);e.modelRange=t,e.modelCursor=i}},{priority:"lowest"}),this.upcastDispatcher.on("documentFragment",(t,e,n)=>{if(!e.modelRange&&n.consumable.consume(e.viewItem,{name:!0})){const{modelRange:t,modelCursor:i}=n.convertChildren(e.viewItem,e.modelCursor);e.modelRange=t,e.modelCursor=i}},{priority:"lowest"}),this.decorate("init"),this.on("init",()=>{this.fire("ready")},{priority:"lowest"})}get(t){const{rootName:e="main",trim:n="empty"}=t||{};if(!this._checkIfRootsExists([e]))throw new hn.b("datacontroller-get-non-existent-root: Attempting to get data from a non-existing root.",this);const i=this.model.document.getRoot(e);return"empty"!==n||this.model.hasContent(i,{ignoreWhitespaces:!0})?this.stringify(i):""}stringify(t){const e=this.toView(t);return this.processor.toData(e)}toView(t){const e=this.viewDocument,n=this._viewWriter;this.mapper.clearBindings();const i=Ts._createIn(t),o=new To(e);if(this.mapper.bindElements(t,o),this.downcastDispatcher.convertInsert(i,n),!t.is("documentFragment")){const e=function(t){const e=[],n=t.root.document;if(!n)return[];const i=Ts._createIn(t);for(const t of n.model.markers){const n=i.getIntersection(t.getRange());n&&e.push([t.name,n])}return e}(t);for(const[t,i]of e)this.downcastDispatcher.convertMarkerAdd(t,i,n)}return o}init(t){if(this.model.document.version)throw new hn.b("datacontroller-init-document-not-empty: Trying to set initial data to not empty document.",this);let e={};if("string"==typeof t?e.main=t:e=t,!this._checkIfRootsExists(Object.keys(e)))throw new hn.b("datacontroller-init-non-existent-root: Attempting to init data on a non-existing root.",this);return this.model.enqueueChange("transparent",t=>{for(const n of Object.keys(e)){const i=this.model.document.getRoot(n);t.insert(this.parse(e[n],i),i,0)}}),Promise.resolve()}set(t){let e={};if("string"==typeof t?e.main=t:e=t,!this._checkIfRootsExists(Object.keys(e)))throw new hn.b("datacontroller-set-non-existent-root: Attempting to set data on a non-existing root.",this);this.model.enqueueChange("transparent",t=>{t.setSelection(null),t.removeSelectionAttribute(this.model.document.selection.getAttributeKeys());for(const n of Object.keys(e)){const i=this.model.document.getRoot(n);t.remove(t.createRangeIn(i)),t.insert(this.parse(e[n],i),i,0)}})}parse(t,e="$root"){const n=this.processor.toView(t);return this.toModel(n,e)}toModel(t,e="$root"){return this.model.change(n=>this.upcastDispatcher.convert(t,n,e))}addStyleProcessorRules(t){t(this.stylesProcessor)}destroy(){this.stopListening()}_checkIfRootsExists(t){for(const e of t)if(!this.model.document.getRootNames().includes(e))return!1;return!0}}xn(_a,Ui);class va{constructor(t,e){this._helpers=new Map,this._downcast=Array.isArray(t)?t:[t],this._createConversionHelpers({name:"downcast",dispatchers:this._downcast,isDowncast:!0}),this._upcast=Array.isArray(e)?e:[e],this._createConversionHelpers({name:"upcast",dispatchers:this._upcast,isDowncast:!1})}addAlias(t,e){const n=this._downcast.includes(e);if(!this._upcast.includes(e)&&!n)throw new hn.b("conversion-add-alias-dispatcher-not-registered: Trying to register and alias for a dispatcher that nas not been registered.",this);this._createConversionHelpers({name:t,dispatchers:[e],isDowncast:n})}for(t){if(!this._helpers.has(t))throw new hn.b("conversion-for-unknown-group: Trying to add a converter to an unknown dispatchers group.",this);return this._helpers.get(t)}elementToElement(t){this.for("downcast").elementToElement(t);for(const{model:e,view:n}of ya(t))this.for("upcast").elementToElement({model:e,view:n,converterPriority:t.converterPriority})}attributeToElement(t){this.for("downcast").attributeToElement(t);for(const{model:e,view:n}of ya(t))this.for("upcast").elementToAttribute({view:n,model:e,converterPriority:t.converterPriority})}attributeToAttribute(t){this.for("downcast").attributeToAttribute(t);for(const{model:e,view:n}of ya(t))this.for("upcast").attributeToAttribute({view:n,model:e})}_createConversionHelpers({name:t,dispatchers:e,isDowncast:n}){if(this._helpers.has(t))throw new hn.b("conversion-group-exists: Trying to register a group name that has already been registered.",this);const i=n?new qs(e):new Js(e);this._helpers.set(t,i)}}function*ya(t){if(t.model.values)for(const e of t.model.values){const n={key:t.model.key,value:e},i=t.view[e],o=t.upcastAlso?t.upcastAlso[e]:void 0;yield*xa(n,i,o)}else yield*xa(t.model,t.view,t.upcastAlso)}function*xa(t,e,n){if(yield{model:t,view:e},n){n=Array.isArray(n)?n:[n];for(const e of n)yield{model:t,view:e}}}class Aa{constructor(t="default"){this.operations=[],this.type=t}get baseVersion(){for(const t of this.operations)if(null!==t.baseVersion)return t.baseVersion;return null}addOperation(t){return t.batch=this,this.operations.push(t),t}}class Ca{constructor(t){this.baseVersion=t,this.isDocumentOperation=null!==this.baseVersion,this.batch=null}_validate(){}toJSON(){const t=Object.assign({},this);return t.__className=this.constructor.className,delete t.batch,delete t.isDocumentOperation,t}static get className(){return"Operation"}static fromJSON(t){return new this(t.baseVersion)}}class Ta{constructor(t){this.markers=new Map,this._children=new ws,t&&this._insertChild(0,t)}[Symbol.iterator](){return this.getChildren()}get childCount(){return this._children.length}get maxOffset(){return this._children.maxOffset}get isEmpty(){return 0===this.childCount}get root(){return this}get parent(){return null}is(t){return"documentFragment"===t||"model:documentFragment"===t}getChild(t){return this._children.getNode(t)}getChildren(){return this._children[Symbol.iterator]()}getChildIndex(t){return this._children.getNodeIndex(t)}getChildStartOffset(t){return this._children.getNodeStartOffset(t)}getPath(){return[]}getNodeByPath(t){let e=this;for(const n of t)e=e.getChild(e.offsetToIndex(n));return e}offsetToIndex(t){return this._children.offsetToIndex(t)}toJSON(){const t=[];for(const e of this._children)t.push(e.toJSON());return t}static fromJSON(t){const e=[];for(const n of t)n.name?e.push(ks.fromJSON(n)):e.push(ps.fromJSON(n));return new Ta(e)}_appendChild(t){this._insertChild(this.childCount,t)}_insertChild(t,e){const n=function(t){if("string"==typeof t)return[new ps(t)];yn(t)||(t=[t]);return Array.from(t).map(t=>"string"==typeof t?new ps(t):t instanceof bs?new ps(t.data,t.getAttributes()):t)}(e);for(const t of n)null!==t.parent&&t._remove(),t.parent=this;this._children._insertNodes(t,n)}_removeChildren(t,e=1){const n=this._children._removeNodes(t,e);for(const t of n)t.parent=null;return n}}function Pa(t,e){const n=(e=Ma(e)).reduce((t,e)=>t+e.offsetSize,0),i=t.parent;Na(t);const o=t.index;return i._insertChild(o,e),Ia(i,o+e.length),Ia(i,o),new Ts(t,t.getShiftedBy(n))}function Sa(t){if(!t.isFlat)throw new hn.b("operation-utils-remove-range-not-flat: Trying to remove a range which starts and ends in different element.",this);const e=t.start.parent;Na(t.start),Na(t.end);const n=e._removeChildren(t.start.index,t.end.index-t.start.index);return Ia(e,t.start.index),n}function Ea(t,e){if(!t.isFlat)throw new hn.b("operation-utils-move-range-not-flat: Trying to move a range which starts and ends in different element.",this);const n=Sa(t);return Pa(e=e._getTransformedByDeletion(t.start,t.end.offset-t.start.offset),n)}function Ma(t){const e=[];t instanceof Array||(t=[t]);for(let n=0;n<t.length;n++)if("string"==typeof t[n])e.push(new ps(t[n]));else if(t[n]instanceof bs)e.push(new ps(t[n].data,t[n].getAttributes()));else if(t[n]instanceof Ta||t[n]instanceof ws)for(const i of t[n])e.push(i);else t[n]instanceof ms&&e.push(t[n]);for(let t=1;t<e.length;t++){const n=e[t],i=e[t-1];n instanceof ps&&i instanceof ps&&Oa(n,i)&&(e.splice(t-1,2,new ps(i.data+n.data,i.getAttributes())),t--)}return e}function Ia(t,e){const n=t.getChild(e-1),i=t.getChild(e);if(n&&i&&n.is("text")&&i.is("text")&&Oa(n,i)){const o=new ps(n.data+i.data,n.getAttributes());t._removeChildren(e-1,2),t._insertChild(e-1,o)}}function Na(t){const e=t.textNode,n=t.parent;if(e){const i=t.offset-e.startOffset,o=e.index;n._removeChildren(o,1);const r=new ps(e.data.substr(0,i),e.getAttributes()),s=new ps(e.data.substr(i),e.getAttributes());n._insertChild(o,[r,s])}}function Oa(t,e){const n=t.getAttributes(),i=e.getAttributes();for(const t of n){if(t[1]!==e.getAttribute(t[0]))return!1;i.next()}return i.next().done}var Ra=function(t,e){return Ir(t,e)};class Da extends Ca{constructor(t,e,n,i,o){super(o),this.range=t.clone(),this.key=e,this.oldValue=void 0===n?null:n,this.newValue=void 0===i?null:i}get type(){return null===this.oldValue?"addAttribute":null===this.newValue?"removeAttribute":"changeAttribute"}clone(){return new Da(this.range,this.key,this.oldValue,this.newValue,this.baseVersion)}getReversed(){return new Da(this.range,this.key,this.newValue,this.oldValue,this.baseVersion+1)}toJSON(){const t=super.toJSON();return t.range=this.range.toJSON(),t}_validate(){if(!this.range.isFlat)throw new hn.b("attribute-operation-range-not-flat: The range to change is not flat.",this);for(const t of this.range.getItems({shallow:!0})){if(null!==this.oldValue&&!Ra(t.getAttribute(this.key),this.oldValue))throw new hn.b("attribute-operation-wrong-old-value: Changed node has different attribute value than operation's old attribute value.",this,{item:t,key:this.key,value:this.oldValue});if(null===this.oldValue&&null!==this.newValue&&t.hasAttribute(this.key))throw new hn.b("attribute-operation-attribute-exists: The attribute with given key already exists.",this,{node:t,key:this.key})}}_execute(){Ra(this.oldValue,this.newValue)||function(t,e,n){Na(t.start),Na(t.end);for(const i of t.getItems({shallow:!0})){const t=i.is("textProxy")?i.textNode:i;null!==n?t._setAttribute(e,n):t._removeAttribute(e),Ia(t.parent,t.index)}Ia(t.end.parent,t.end.index)}(this.range,this.key,this.newValue)}static get className(){return"AttributeOperation"}static fromJSON(t,e){return new Da(Ts.fromJSON(t.range,e),t.key,t.oldValue,t.newValue,t.baseVersion)}}class La extends Ca{constructor(t,e){super(null),this.sourcePosition=t.clone(),this.howMany=e}get type(){return"detach"}toJSON(){const t=super.toJSON();return t.sourcePosition=this.sourcePosition.toJSON(),t}_validate(){if(this.sourcePosition.root.document)throw new hn.b("detach-operation-on-document-node: Cannot detach document node.",this)}_execute(){Sa(Ts._createFromPositionAndShift(this.sourcePosition,this.howMany))}static get className(){return"DetachOperation"}}class ja extends Ca{constructor(t,e,n,i){super(i),this.sourcePosition=t.clone(),this.sourcePosition.stickiness="toNext",this.howMany=e,this.targetPosition=n.clone(),this.targetPosition.stickiness="toNone"}get type(){return"$graveyard"==this.targetPosition.root.rootName?"remove":"$graveyard"==this.sourcePosition.root.rootName?"reinsert":"move"}clone(){return new this.constructor(this.sourcePosition,this.howMany,this.targetPosition,this.baseVersion)}getMovedRangeStart(){return this.targetPosition._getTransformedByDeletion(this.sourcePosition,this.howMany)}getReversed(){const t=this.sourcePosition._getTransformedByInsertion(this.targetPosition,this.howMany);return new this.constructor(this.getMovedRangeStart(),this.howMany,t,this.baseVersion+1)}_validate(){const t=this.sourcePosition.parent,e=this.targetPosition.parent,n=this.sourcePosition.offset,i=this.targetPosition.offset;if(n+this.howMany>t.maxOffset)throw new hn.b("move-operation-nodes-do-not-exist: The nodes which should be moved do not exist.",this);if(t===e&&n<i&&i<n+this.howMany)throw new hn.b("move-operation-range-into-itself: Trying to move a range of nodes to the inside of that range.",this);if(this.sourcePosition.root==this.targetPosition.root&&"prefix"==In(this.sourcePosition.getParentPath(),this.targetPosition.getParentPath())){const t=this.sourcePosition.path.length-1;if(this.targetPosition.path[t]>=n&&this.targetPosition.path[t]<n+this.howMany)throw new hn.b("move-operation-node-into-itself: Trying to move a range of nodes into one of nodes from that range.",this)}}_execute(){Ea(Ts._createFromPositionAndShift(this.sourcePosition,this.howMany),this.targetPosition)}toJSON(){const t=super.toJSON();return t.sourcePosition=this.sourcePosition.toJSON(),t.targetPosition=this.targetPosition.toJSON(),t}static get className(){return"MoveOperation"}static fromJSON(t,e){const n=ys.fromJSON(t.sourcePosition,e),i=ys.fromJSON(t.targetPosition,e);return new this(n,t.howMany,i,t.baseVersion)}}class Va extends Ca{constructor(t,e,n){super(n),this.position=t.clone(),this.position.stickiness="toNone",this.nodes=new ws(Ma(e)),this.shouldReceiveAttributes=!1}get type(){return"insert"}get howMany(){return this.nodes.maxOffset}clone(){const t=new ws([...this.nodes].map(t=>t._clone(!0))),e=new Va(this.position,t,this.baseVersion);return e.shouldReceiveAttributes=this.shouldReceiveAttributes,e}getReversed(){const t=this.position.root.document.graveyard,e=new ys(t,[0]);return new ja(this.position,this.nodes.maxOffset,e,this.baseVersion+1)}_validate(){const t=this.position.parent;if(!t||t.maxOffset<this.position.offset)throw new hn.b("insert-operation-position-invalid: Insertion position is invalid.",this)}_execute(){const t=this.nodes;this.nodes=new ws([...t].map(t=>t._clone(!0))),Pa(this.position,t)}toJSON(){const t=super.toJSON();return t.position=this.position.toJSON(),t.nodes=this.nodes.toJSON(),t}static get className(){return"InsertOperation"}static fromJSON(t,e){const n=[];for(const e of t.nodes)e.name?n.push(ks.fromJSON(e)):n.push(ps.fromJSON(e));const i=new Va(ys.fromJSON(t.position,e),n,t.baseVersion);return i.shouldReceiveAttributes=t.shouldReceiveAttributes,i}}class za extends Ca{constructor(t,e,n,i,o,r){super(r),this.name=t,this.oldRange=e?e.clone():null,this.newRange=n?n.clone():null,this.affectsData=o,this._markers=i}get type(){return"marker"}clone(){return new za(this.name,this.oldRange,this.newRange,this._markers,this.affectsData,this.baseVersion)}getReversed(){return new za(this.name,this.newRange,this.oldRange,this._markers,this.affectsData,this.baseVersion+1)}_execute(){const t=this.newRange?"_set":"_remove";this._markers[t](this.name,this.newRange,!0,this.affectsData)}toJSON(){const t=super.toJSON();return this.oldRange&&(t.oldRange=this.oldRange.toJSON()),this.newRange&&(t.newRange=this.newRange.toJSON()),delete t._markers,t}static get className(){return"MarkerOperation"}static fromJSON(t,e){return new za(t.name,t.oldRange?Ts.fromJSON(t.oldRange,e):null,t.newRange?Ts.fromJSON(t.newRange,e):null,e.model.markers,t.affectsData,t.baseVersion)}}class Ba extends Ca{constructor(t,e,n,i){super(i),this.position=t,this.position.stickiness="toNext",this.oldName=e,this.newName=n}get type(){return"rename"}clone(){return new Ba(this.position.clone(),this.oldName,this.newName,this.baseVersion)}getReversed(){return new Ba(this.position.clone(),this.newName,this.oldName,this.baseVersion+1)}_validate(){const t=this.position.nodeAfter;if(!(t instanceof ks))throw new hn.b("rename-operation-wrong-position: Given position is invalid or node after it is not an instance of Element.",this);if(t.name!==this.oldName)throw new hn.b("rename-operation-wrong-name: Element to change has different name than operation's old name.",this)}_execute(){this.position.nodeAfter.name=this.newName}toJSON(){const t=super.toJSON();return t.position=this.position.toJSON(),t}static get className(){return"RenameOperation"}static fromJSON(t,e){return new Ba(ys.fromJSON(t.position,e),t.oldName,t.newName,t.baseVersion)}}class Fa extends Ca{constructor(t,e,n,i,o){super(o),this.root=t,this.key=e,this.oldValue=n,this.newValue=i}get type(){return null===this.oldValue?"addRootAttribute":null===this.newValue?"removeRootAttribute":"changeRootAttribute"}clone(){return new Fa(this.root,this.key,this.oldValue,this.newValue,this.baseVersion)}getReversed(){return new Fa(this.root,this.key,this.newValue,this.oldValue,this.baseVersion+1)}_validate(){if(this.root!=this.root.root||this.root.is("documentFragment"))throw new hn.b("rootattribute-operation-not-a-root: The element to change is not a root element.",this,{root:this.root,key:this.key});if(null!==this.oldValue&&this.root.getAttribute(this.key)!==this.oldValue)throw new hn.b("rootattribute-operation-wrong-old-value: Changed node has different attribute value than operation's old attribute value.",this,{root:this.root,key:this.key});if(null===this.oldValue&&null!==this.newValue&&this.root.hasAttribute(this.key))throw new hn.b("rootattribute-operation-attribute-exists: The attribute with given key already exists.",this,{root:this.root,key:this.key})}_execute(){null!==this.newValue?this.root._setAttribute(this.key,this.newValue):this.root._removeAttribute(this.key)}toJSON(){const t=super.toJSON();return t.root=this.root.toJSON(),t}static get className(){return"RootAttributeOperation"}static fromJSON(t,e){if(!e.getRoot(t.root))throw new hn.b("rootattribute-operation-fromjson-no-root: Cannot create RootAttributeOperation. Root with specified name does not exist.",this,{rootName:t.root});return new Fa(e.getRoot(t.root),t.key,t.oldValue,t.newValue,t.baseVersion)}}class Ua extends Ca{constructor(t,e,n,i,o){super(o),this.sourcePosition=t.clone(),this.sourcePosition.stickiness="toPrevious",this.howMany=e,this.targetPosition=n.clone(),this.targetPosition.stickiness="toNext",this.graveyardPosition=i.clone()}get type(){return"merge"}get deletionPosition(){return new ys(this.sourcePosition.root,this.sourcePosition.path.slice(0,-1))}get movedRange(){const t=this.sourcePosition.getShiftedBy(Number.POSITIVE_INFINITY);return new Ts(this.sourcePosition,t)}clone(){return new this.constructor(this.sourcePosition,this.howMany,this.targetPosition,this.graveyardPosition,this.baseVersion)}getReversed(){const t=this.targetPosition._getTransformedByMergeOperation(this),e=this.sourcePosition.path.slice(0,-1),n=new ys(this.sourcePosition.root,e)._getTransformedByMergeOperation(this),i=new Ha(t,this.howMany,this.graveyardPosition,this.baseVersion+1);return i.insertionPosition=n,i}_validate(){const t=this.sourcePosition.parent,e=this.targetPosition.parent;if(!t.parent)throw new hn.b("merge-operation-source-position-invalid: Merge source position is invalid.",this);if(!e.parent)throw new hn.b("merge-operation-target-position-invalid: Merge target position is invalid.",this);if(this.howMany!=t.maxOffset)throw new hn.b("merge-operation-how-many-invalid: Merge operation specifies wrong number of nodes to move.",this)}_execute(){const t=this.sourcePosition.parent;Ea(Ts._createIn(t),this.targetPosition),Ea(Ts._createOn(t),this.graveyardPosition)}toJSON(){const t=super.toJSON();return t.sourcePosition=t.sourcePosition.toJSON(),t.targetPosition=t.targetPosition.toJSON(),t.graveyardPosition=t.graveyardPosition.toJSON(),t}static get className(){return"MergeOperation"}static fromJSON(t,e){const n=ys.fromJSON(t.sourcePosition,e),i=ys.fromJSON(t.targetPosition,e),o=ys.fromJSON(t.graveyardPosition,e);return new this(n,t.howMany,i,o,t.baseVersion)}}class Ha extends Ca{constructor(t,e,n,i){super(i),this.splitPosition=t.clone(),this.splitPosition.stickiness="toNext",this.howMany=e,this.insertionPosition=Ha.getInsertionPosition(t),this.insertionPosition.stickiness="toNone",this.graveyardPosition=n?n.clone():null,this.graveyardPosition&&(this.graveyardPosition.stickiness="toNext")}get type(){return"split"}get moveTargetPosition(){const t=this.insertionPosition.path.slice();return t.push(0),new ys(this.insertionPosition.root,t)}get movedRange(){const t=this.splitPosition.getShiftedBy(Number.POSITIVE_INFINITY);return new Ts(this.splitPosition,t)}clone(){const t=new this.constructor(this.splitPosition,this.howMany,this.graveyardPosition,this.baseVersion);return t.insertionPosition=this.insertionPosition,t}getReversed(){const t=this.splitPosition.root.document.graveyard,e=new ys(t,[0]);return new Ua(this.moveTargetPosition,this.howMany,this.splitPosition,e,this.baseVersion+1)}_validate(){const t=this.splitPosition.parent,e=this.splitPosition.offset;if(!t||t.maxOffset<e)throw new hn.b("split-operation-position-invalid: Split position is invalid.",this);if(!t.parent)throw new hn.b("split-operation-split-in-root: Cannot split root element.",this);if(this.howMany!=t.maxOffset-this.splitPosition.offset)throw new hn.b("split-operation-how-many-invalid: Split operation specifies wrong number of nodes to move.",this);if(this.graveyardPosition&&!this.graveyardPosition.nodeAfter)throw new hn.b("split-operation-graveyard-position-invalid: Graveyard position invalid.",this)}_execute(){const t=this.splitPosition.parent;if(this.graveyardPosition)Ea(Ts._createFromPositionAndShift(this.graveyardPosition,1),this.insertionPosition);else{const e=t._clone();Pa(this.insertionPosition,e)}Ea(new Ts(ys._createAt(t,this.splitPosition.offset),ys._createAt(t,t.maxOffset)),this.moveTargetPosition)}toJSON(){const t=super.toJSON();return t.splitPosition=this.splitPosition.toJSON(),t.insertionPosition=this.insertionPosition.toJSON(),this.graveyardPosition&&(t.graveyardPosition=this.graveyardPosition.toJSON()),t}static get className(){return"SplitOperation"}static getInsertionPosition(t){const e=t.path.slice(0,-1);return e[e.length-1]++,new ys(t.root,e)}static fromJSON(t,e){const n=ys.fromJSON(t.splitPosition,e),i=ys.fromJSON(t.insertionPosition,e),o=t.graveyardPosition?ys.fromJSON(t.graveyardPosition,e):null,r=new this(n,t.howMany,o,t.baseVersion);return r.insertionPosition=i,r}}class Wa extends ks{constructor(t,e,n="main"){super(e),this._document=t,this.rootName=n}get document(){return this._document}is(t,e){return e?e===this.name&&("rootElement"===t||"model:rootElement"===t||"element"===t||"model:element"===t):"rootElement"===t||"model:rootElement"===t||"element"===t||"model:element"===t||t===this.name||t==="model:"+this.name||"node"===t||"model:node"===t}toJSON(){return this.rootName}}class qa{constructor(t,e){this.model=t,this.batch=e}createText(t,e){return new ps(t,e)}createElement(t,e){return new ks(t,e)}createDocumentFragment(){return new Ta}cloneElement(t,e=!0){return t._clone(e)}insert(t,e,n=0){if(this._assertWriterUsedCorrectly(),t instanceof ps&&""==t.data)return;const i=ys._createAt(e,n);if(t.parent){if(Qa(t.root,i.root))return void this.move(Ts._createOn(t),i);if(t.root.document)throw new hn.b("model-writer-insert-forbidden-move: Cannot move a node from a document to a different tree. It is forbidden to move a node that was already in a document outside of it.",this);this.remove(t)}const o=i.root.document?i.root.document.version:null,r=new Va(i,t,o);if(t instanceof ps&&(r.shouldReceiveAttributes=!0),this.batch.addOperation(r),this.model.applyOperation(r),t instanceof Ta)for(const[e,n]of t.markers){const t=ys._createAt(n.root,0),o={range:new Ts(n.start._getCombined(t,i),n.end._getCombined(t,i)),usingOperation:!0,affectsData:!0};this.model.markers.has(e)?this.updateMarker(e,o):this.addMarker(e,o)}}insertText(t,e,n,i){e instanceof Ta||e instanceof ks||e instanceof ys?this.insert(this.createText(t),e,n):this.insert(this.createText(t,e),n,i)}insertElement(t,e,n,i){e instanceof Ta||e instanceof ks||e instanceof ys?this.insert(this.createElement(t),e,n):this.insert(this.createElement(t,e),n,i)}append(t,e){this.insert(t,e,"end")}appendText(t,e,n){e instanceof Ta||e instanceof ks?this.insert(this.createText(t),e,"end"):this.insert(this.createText(t,e),n,"end")}appendElement(t,e,n){e instanceof Ta||e instanceof ks?this.insert(this.createElement(t),e,"end"):this.insert(this.createElement(t,e),n,"end")}setAttribute(t,e,n){if(this._assertWriterUsedCorrectly(),n instanceof Ts){const i=n.getMinimalFlatRanges();for(const n of i)Ya(this,t,e,n)}else Ga(this,t,e,n)}setAttributes(t,e){for(const[n,i]of Ln(t))this.setAttribute(n,i,e)}removeAttribute(t,e){if(this._assertWriterUsedCorrectly(),e instanceof Ts){const n=e.getMinimalFlatRanges();for(const e of n)Ya(this,t,null,e)}else Ga(this,t,null,e)}clearAttributes(t){this._assertWriterUsedCorrectly();const e=t=>{for(const e of t.getAttributeKeys())this.removeAttribute(e,t)};if(t instanceof Ts)for(const n of t.getItems())e(n);else e(t)}move(t,e,n){if(this._assertWriterUsedCorrectly(),!(t instanceof Ts))throw new hn.b("writer-move-invalid-range: Invalid range to move.",this);if(!t.isFlat)throw new hn.b("writer-move-range-not-flat: Range to move is not flat.",this);const i=ys._createAt(e,n);if(i.isEqual(t.start))return;if(this._addOperationForAffectedMarkers("move",t),!Qa(t.root,i.root))throw new hn.b("writer-move-different-document: Range is going to be moved between different documents.",this);const o=t.root.document?t.root.document.version:null,r=new ja(t.start,t.end.offset-t.start.offset,i,o);this.batch.addOperation(r),this.model.applyOperation(r)}remove(t){this._assertWriterUsedCorrectly();const e=(t instanceof Ts?t:Ts._createOn(t)).getMinimalFlatRanges().reverse();for(const t of e)this._addOperationForAffectedMarkers("move",t),Ka(t.start,t.end.offset-t.start.offset,this.batch,this.model)}merge(t){this._assertWriterUsedCorrectly();const e=t.nodeBefore,n=t.nodeAfter;if(this._addOperationForAffectedMarkers("merge",t),!(e instanceof ks))throw new hn.b("writer-merge-no-element-before: Node before merge position must be an element.",this);if(!(n instanceof ks))throw new hn.b("writer-merge-no-element-after: Node after merge position must be an element.",this);t.root.document?this._merge(t):this._mergeDetached(t)}createPositionFromPath(t,e,n){return this.model.createPositionFromPath(t,e,n)}createPositionAt(t,e){return this.model.createPositionAt(t,e)}createPositionAfter(t){return this.model.createPositionAfter(t)}createPositionBefore(t){return this.model.createPositionBefore(t)}createRange(t,e){return this.model.createRange(t,e)}createRangeIn(t){return this.model.createRangeIn(t)}createRangeOn(t){return this.model.createRangeOn(t)}createSelection(t,e,n){return this.model.createSelection(t,e,n)}_mergeDetached(t){const e=t.nodeBefore,n=t.nodeAfter;this.move(Ts._createIn(n),ys._createAt(e,"end")),this.remove(n)}_merge(t){const e=ys._createAt(t.nodeBefore,"end"),n=ys._createAt(t.nodeAfter,0),i=t.root.document.graveyard,o=new ys(i,[0]),r=t.root.document.version,s=new Ua(n,t.nodeAfter.maxOffset,e,o,r);this.batch.addOperation(s),this.model.applyOperation(s)}rename(t,e){if(this._assertWriterUsedCorrectly(),!(t instanceof ks))throw new hn.b("writer-rename-not-element-instance: Trying to rename an object which is not an instance of Element.",this);const n=t.root.document?t.root.document.version:null,i=new Ba(ys._createBefore(t),t.name,e,n);this.batch.addOperation(i),this.model.applyOperation(i)}split(t,e){this._assertWriterUsedCorrectly();let n,i,o=t.parent;if(!o.parent)throw new hn.b("writer-split-element-no-parent: Element with no parent can not be split.",this);if(e||(e=o.parent),!t.parent.getAncestors({includeSelf:!0}).includes(e))throw new hn.b("writer-split-invalid-limit-element: Limit element is not a position ancestor.",this);do{const e=o.root.document?o.root.document.version:null,r=o.maxOffset-t.offset,s=new Ha(t,r,null,e);this.batch.addOperation(s),this.model.applyOperation(s),n||i||(n=o,i=t.parent.nextSibling),o=(t=this.createPositionAfter(t.parent)).parent}while(o!==e);return{position:t,range:new Ts(ys._createAt(n,"end"),ys._createAt(i,0))}}wrap(t,e){if(this._assertWriterUsedCorrectly(),!t.isFlat)throw new hn.b("writer-wrap-range-not-flat: Range to wrap is not flat.",this);const n=e instanceof ks?e:new ks(e);if(n.childCount>0)throw new hn.b("writer-wrap-element-not-empty: Element to wrap with is not empty.",this);if(null!==n.parent)throw new hn.b("writer-wrap-element-attached: Element to wrap with is already attached to tree model.",this);this.insert(n,t.start);const i=new Ts(t.start.getShiftedBy(1),t.end.getShiftedBy(1));this.move(i,ys._createAt(n,0))}unwrap(t){if(this._assertWriterUsedCorrectly(),null===t.parent)throw new hn.b("writer-unwrap-element-no-parent: Trying to unwrap an element which has no parent.",this);this.move(Ts._createIn(t),this.createPositionAfter(t)),this.remove(t)}addMarker(t,e){if(this._assertWriterUsedCorrectly(),!e||"boolean"!=typeof e.usingOperation)throw new hn.b("writer-addMarker-no-usingOperation: The options.usingOperation parameter is required when adding a new marker.",this);const n=e.usingOperation,i=e.range,o=void 0!==e.affectsData&&e.affectsData;if(this.model.markers.has(t))throw new hn.b("writer-addMarker-marker-exists: Marker with provided name already exists.",this);if(!i)throw new hn.b("writer-addMarker-no-range: Range parameter is required when adding a new marker.",this);return n?($a(this,t,null,i,o),this.model.markers.get(t)):this.model.markers._set(t,i,n,o)}updateMarker(t,e){this._assertWriterUsedCorrectly();const n="string"==typeof t?t:t.name,i=this.model.markers.get(n);if(!i)throw new hn.b("writer-updateMarker-marker-not-exists: Marker with provided name does not exists.",this);if(!e)return void this.model.markers._refresh(i);const o="boolean"==typeof e.usingOperation,r="boolean"==typeof e.affectsData,s=r?e.affectsData:i.affectsData;if(!o&&!e.range&&!r)throw new hn.b("writer-updateMarker-wrong-options: One of the options is required - provide range, usingOperations or affectsData.",this);const a=i.getRange(),c=e.range?e.range:a;o&&e.usingOperation!==i.managedUsingOperations?e.usingOperation?$a(this,n,null,c,s):($a(this,n,a,null,s),this.model.markers._set(n,c,void 0,s)):i.managedUsingOperations?$a(this,n,a,c,s):this.model.markers._set(n,c,void 0,s)}removeMarker(t){this._assertWriterUsedCorrectly();const e="string"==typeof t?t:t.name;if(!this.model.markers.has(e))throw new hn.b("writer-removeMarker-no-marker: Trying to remove marker which does not exist.",this);const n=this.model.markers.get(e);if(!n.managedUsingOperations)return void this.model.markers._remove(e);$a(this,e,n.getRange(),null,n.affectsData)}setSelection(t,e,n){this._assertWriterUsedCorrectly(),this.model.document.selection._setTo(t,e,n)}setSelectionFocus(t,e){this._assertWriterUsedCorrectly(),this.model.document.selection._setFocus(t,e)}setSelectionAttribute(t,e){if(this._assertWriterUsedCorrectly(),"string"==typeof t)this._setSelectionAttribute(t,e);else for(const[e,n]of Ln(t))this._setSelectionAttribute(e,n)}removeSelectionAttribute(t){if(this._assertWriterUsedCorrectly(),"string"==typeof t)this._removeSelectionAttribute(t);else for(const e of t)this._removeSelectionAttribute(e)}overrideSelectionGravity(){return this.model.document.selection._overrideGravity()}restoreSelectionGravity(t){this.model.document.selection._restoreGravity(t)}_setSelectionAttribute(t,e){const n=this.model.document.selection;if(n.isCollapsed&&n.anchor.parent.isEmpty){const i=Bs._getStoreAttributeKey(t);this.setAttribute(i,e,n.anchor.parent)}n._setAttribute(t,e)}_removeSelectionAttribute(t){const e=this.model.document.selection;if(e.isCollapsed&&e.anchor.parent.isEmpty){const n=Bs._getStoreAttributeKey(t);this.removeAttribute(n,e.anchor.parent)}e._removeAttribute(t)}_assertWriterUsedCorrectly(){if(this.model._currentWriter!==this)throw new hn.b("writer-incorrect-use: Trying to use a writer outside the change() block.",this)}_addOperationForAffectedMarkers(t,e){for(const n of this.model.markers){if(!n.managedUsingOperations)continue;const i=n.getRange();let o=!1;if("move"===t)o=e.containsPosition(i.start)||e.start.isEqual(i.start)||e.containsPosition(i.end)||e.end.isEqual(i.end);else{const t=e.nodeBefore,n=e.nodeAfter,r=i.start.parent==t&&i.start.isAtEnd,s=i.end.parent==n&&0==i.end.offset,a=i.end.nodeAfter==n,c=i.start.nodeAfter==n;o=r||s||a||c}o&&this.updateMarker(n.name,{range:i})}}}function Ya(t,e,n,i){const o=t.model,r=o.document;let s,a,c,l=i.start;for(const t of i.getWalker({shallow:!0}))c=t.item.getAttribute(e),s&&a!=c&&(a!=n&&d(),l=s),s=t.nextPosition,a=c;function d(){const i=new Ts(l,s),c=i.root.document?r.version:null,d=new Da(i,e,a,n,c);t.batch.addOperation(d),o.applyOperation(d)}s instanceof ys&&s!=l&&a!=n&&d()}function Ga(t,e,n,i){const o=t.model,r=o.document,s=i.getAttribute(e);let a,c;if(s!=n){if(i.root===i){const t=i.document?r.version:null;c=new Fa(i,e,s,n,t)}else{a=new Ts(ys._createBefore(i),t.createPositionAfter(i));const o=a.root.document?r.version:null;c=new Da(a,e,s,n,o)}t.batch.addOperation(c),o.applyOperation(c)}}function $a(t,e,n,i,o){const r=t.model,s=r.document,a=new za(e,n,i,r.markers,o,s.version);t.batch.addOperation(a),r.applyOperation(a)}function Ka(t,e,n,i){let o;if(t.root.document){const n=i.document,r=new ys(n.graveyard,[0]);o=new ja(t,e,r,n.version)}else o=new La(t,e);n.addOperation(o),i.applyOperation(o)}function Qa(t,e){return t===e||t instanceof Wa&&e instanceof Wa}class Ja{constructor(t){this._markerCollection=t,this._changesInElement=new Map,this._elementSnapshots=new Map,this._changedMarkers=new Map,this._changeCount=0,this._cachedChanges=null,this._cachedChangesWithGraveyard=null}get isEmpty(){return 0==this._changesInElement.size&&0==this._changedMarkers.size}refreshItem(t){if(this._isInInsertedElement(t.parent))return;this._markRemove(t.parent,t.startOffset,t.offsetSize),this._markInsert(t.parent,t.startOffset,t.offsetSize);const e=Ts._createOn(t);for(const t of this._markerCollection.getMarkersIntersectingRange(e)){const e=t.getRange();this.bufferMarkerChange(t.name,e,e,t.affectsData)}this._cachedChanges=null}bufferOperation(t){switch(t.type){case"insert":if(this._isInInsertedElement(t.position.parent))return;this._markInsert(t.position.parent,t.position.offset,t.nodes.maxOffset);break;case"addAttribute":case"removeAttribute":case"changeAttribute":for(const e of t.range.getItems({shallow:!0}))this._isInInsertedElement(e.parent)||this._markAttribute(e);break;case"remove":case"move":case"reinsert":{if(t.sourcePosition.isEqual(t.targetPosition)||t.sourcePosition.getShiftedBy(t.howMany).isEqual(t.targetPosition))return;const e=this._isInInsertedElement(t.sourcePosition.parent),n=this._isInInsertedElement(t.targetPosition.parent);e||this._markRemove(t.sourcePosition.parent,t.sourcePosition.offset,t.howMany),n||this._markInsert(t.targetPosition.parent,t.getMovedRangeStart().offset,t.howMany);break}case"rename":{if(this._isInInsertedElement(t.position.parent))return;this._markRemove(t.position.parent,t.position.offset,1),this._markInsert(t.position.parent,t.position.offset,1);const e=Ts._createFromPositionAndShift(t.position,1);for(const t of this._markerCollection.getMarkersIntersectingRange(e)){const e=t.getRange();this.bufferMarkerChange(t.name,e,e,t.affectsData)}break}case"split":{const e=t.splitPosition.parent;this._isInInsertedElement(e)||this._markRemove(e,t.splitPosition.offset,t.howMany),this._isInInsertedElement(t.insertionPosition.parent)||this._markInsert(t.insertionPosition.parent,t.insertionPosition.offset,1),t.graveyardPosition&&this._markRemove(t.graveyardPosition.parent,t.graveyardPosition.offset,1);break}case"merge":{const e=t.sourcePosition.parent;this._isInInsertedElement(e.parent)||this._markRemove(e.parent,e.startOffset,1);const n=t.graveyardPosition.parent;this._markInsert(n,t.graveyardPosition.offset,1);const i=t.targetPosition.parent;this._isInInsertedElement(i)||this._markInsert(i,t.targetPosition.offset,e.maxOffset);break}}this._cachedChanges=null}bufferMarkerChange(t,e,n,i){const o=this._changedMarkers.get(t);o?(o.newRange=n,o.affectsData=i,null==o.oldRange&&null==o.newRange&&this._changedMarkers.delete(t)):this._changedMarkers.set(t,{oldRange:e,newRange:n,affectsData:i})}getMarkersToRemove(){const t=[];for(const[e,n]of this._changedMarkers)null!=n.oldRange&&t.push({name:e,range:n.oldRange});return t}getMarkersToAdd(){const t=[];for(const[e,n]of this._changedMarkers)null!=n.newRange&&t.push({name:e,range:n.newRange});return t}getChangedMarkers(){return Array.from(this._changedMarkers).map(t=>({name:t[0],data:{oldRange:t[1].oldRange,newRange:t[1].newRange}}))}hasDataChanges(){for(const[,t]of this._changedMarkers)if(t.affectsData)return!0;return this._changesInElement.size>0}getChanges(t={includeChangesInGraveyard:!1}){if(this._cachedChanges)return t.includeChangesInGraveyard?this._cachedChangesWithGraveyard.slice():this._cachedChanges.slice();const e=[];for(const t of this._changesInElement.keys()){const n=this._changesInElement.get(t).sort((t,e)=>t.offset===e.offset?t.type!=e.type?"remove"==t.type?-1:1:0:t.offset<e.offset?-1:1),i=this._elementSnapshots.get(t),o=Za(t.getChildren()),r=Xa(i.length,n);let s=0,a=0;for(const n of r)if("i"===n)e.push(this._getInsertDiff(t,s,o[s].name)),s++;else if("r"===n)e.push(this._getRemoveDiff(t,s,i[a].name)),a++;else if("a"===n){const n=o[s].attributes,r=i[a].attributes;let c;if("$text"==o[s].name)c=new Ts(ys._createAt(t,s),ys._createAt(t,s+1));else{const e=t.offsetToIndex(s);c=new Ts(ys._createAt(t,s),ys._createAt(t.getChild(e),0))}e.push(...this._getAttributesDiff(c,r,n)),s++,a++}else s++,a++}e.sort((t,e)=>t.position.root!=e.position.root?t.position.root.rootName<e.position.root.rootName?-1:1:t.position.isEqual(e.position)?t.changeCount-e.changeCount:t.position.isBefore(e.position)?-1:1);for(let t=1;t<e.length;t++){const n=e[t-1],i=e[t],o="remove"==n.type&&"remove"==i.type&&"$text"==n.name&&"$text"==i.name&&n.position.isEqual(i.position),r="insert"==n.type&&"insert"==i.type&&"$text"==n.name&&"$text"==i.name&&n.position.parent==i.position.parent&&n.position.offset+n.length==i.position.offset,s="attribute"==n.type&&"attribute"==i.type&&n.position.parent==i.position.parent&&n.range.isFlat&&i.range.isFlat&&n.position.offset+n.length==i.position.offset&&n.attributeKey==i.attributeKey&&n.attributeOldValue==i.attributeOldValue&&n.attributeNewValue==i.attributeNewValue;(o||r||s)&&(e[t-1].length++,s&&(e[t-1].range.end=e[t-1].range.end.getShiftedBy(1)),e.splice(t,1),t--)}for(const t of e)delete t.changeCount,"attribute"==t.type&&(delete t.position,delete t.length);return this._changeCount=0,this._cachedChangesWithGraveyard=e.slice(),this._cachedChanges=e.slice().filter(tc),t.includeChangesInGraveyard?this._cachedChangesWithGraveyard:this._cachedChanges}reset(){this._changesInElement.clear(),this._elementSnapshots.clear(),this._changedMarkers.clear(),this._cachedChanges=null}_markInsert(t,e,n){const i={type:"insert",offset:e,howMany:n,count:this._changeCount++};this._markChange(t,i)}_markRemove(t,e,n){const i={type:"remove",offset:e,howMany:n,count:this._changeCount++};this._markChange(t,i),this._removeAllNestedChanges(t,e,n)}_markAttribute(t){const e={type:"attribute",offset:t.startOffset,howMany:t.offsetSize,count:this._changeCount++};this._markChange(t.parent,e)}_markChange(t,e){this._makeSnapshot(t);const n=this._getChangesForElement(t);this._handleChange(e,n),n.push(e);for(let t=0;t<n.length;t++)n[t].howMany<1&&(n.splice(t,1),t--)}_getChangesForElement(t){let e;return this._changesInElement.has(t)?e=this._changesInElement.get(t):(e=[],this._changesInElement.set(t,e)),e}_makeSnapshot(t){this._elementSnapshots.has(t)||this._elementSnapshots.set(t,Za(t.getChildren()))}_handleChange(t,e){t.nodesToHandle=t.howMany;for(const n of e){const i=t.offset+t.howMany,o=n.offset+n.howMany;if("insert"==t.type&&("insert"==n.type&&(t.offset<=n.offset?n.offset+=t.howMany:t.offset<o&&(n.howMany+=t.nodesToHandle,t.nodesToHandle=0)),"remove"==n.type&&t.offset<n.offset&&(n.offset+=t.howMany),"attribute"==n.type))if(t.offset<=n.offset)n.offset+=t.howMany;else if(t.offset<o){const o=n.howMany;n.howMany=t.offset-n.offset,e.unshift({type:"attribute",offset:i,howMany:o-n.howMany,count:this._changeCount++})}if("remove"==t.type){if("insert"==n.type)if(i<=n.offset)n.offset-=t.howMany;else if(i<=o)if(t.offset<n.offset){const e=i-n.offset;n.offset=t.offset,n.howMany-=e,t.nodesToHandle-=e}else n.howMany-=t.nodesToHandle,t.nodesToHandle=0;else if(t.offset<=n.offset)t.nodesToHandle-=n.howMany,n.howMany=0;else if(t.offset<o){const e=o-t.offset;n.howMany-=e,t.nodesToHandle-=e}if("remove"==n.type&&(i<=n.offset?n.offset-=t.howMany:t.offset<n.offset&&(t.nodesToHandle+=n.howMany,n.howMany=0)),"attribute"==n.type)if(i<=n.offset)n.offset-=t.howMany;else if(t.offset<n.offset){const e=i-n.offset;n.offset=t.offset,n.howMany-=e}else if(t.offset<o)if(i<=o){const i=n.howMany;n.howMany=t.offset-n.offset;const o=i-n.howMany-t.nodesToHandle;e.unshift({type:"attribute",offset:t.offset,howMany:o,count:this._changeCount++})}else n.howMany-=o-t.offset}if("attribute"==t.type){if("insert"==n.type)if(t.offset<n.offset&&i>n.offset){if(i>o){const t={type:"attribute",offset:o,howMany:i-o,count:this._changeCount++};this._handleChange(t,e),e.push(t)}t.nodesToHandle=n.offset-t.offset,t.howMany=t.nodesToHandle}else t.offset>=n.offset&&t.offset<o&&(i>o?(t.nodesToHandle=i-o,t.offset=o):t.nodesToHandle=0);if("remove"==n.type&&t.offset<n.offset&&i>n.offset){const o={type:"attribute",offset:n.offset,howMany:i-n.offset,count:this._changeCount++};this._handleChange(o,e),e.push(o),t.nodesToHandle=n.offset-t.offset,t.howMany=t.nodesToHandle}"attribute"==n.type&&(t.offset>=n.offset&&i<=o?(t.nodesToHandle=0,t.howMany=0,t.offset=0):t.offset<=n.offset&&i>=o&&(n.howMany=0))}}t.howMany=t.nodesToHandle,delete t.nodesToHandle}_getInsertDiff(t,e,n){return{type:"insert",position:ys._createAt(t,e),name:n,length:1,changeCount:this._changeCount++}}_getRemoveDiff(t,e,n){return{type:"remove",position:ys._createAt(t,e),name:n,length:1,changeCount:this._changeCount++}}_getAttributesDiff(t,e,n){const i=[];n=new Map(n);for(const[o,r]of e){const e=n.has(o)?n.get(o):null;e!==r&&i.push({type:"attribute",position:t.start,range:t.clone(),length:1,attributeKey:o,attributeOldValue:r,attributeNewValue:e,changeCount:this._changeCount++}),n.delete(o)}for(const[e,o]of n)i.push({type:"attribute",position:t.start,range:t.clone(),length:1,attributeKey:e,attributeOldValue:null,attributeNewValue:o,changeCount:this._changeCount++});return i}_isInInsertedElement(t){const e=t.parent;if(!e)return!1;const n=this._changesInElement.get(e),i=t.startOffset;if(n)for(const t of n)if("insert"==t.type&&i>=t.offset&&i<t.offset+t.howMany)return!0;return this._isInInsertedElement(e)}_removeAllNestedChanges(t,e,n){const i=new Ts(ys._createAt(t,e),ys._createAt(t,e+n));for(const t of i.getItems({shallow:!0}))t.is("element")&&(this._elementSnapshots.delete(t),this._changesInElement.delete(t),this._removeAllNestedChanges(t,0,t.maxOffset))}}function Za(t){const e=[];for(const n of t)if(n.is("text"))for(let t=0;t<n.data.length;t++)e.push({name:"$text",attributes:new Map(n.getAttributes())});else e.push({name:n.name,attributes:new Map(n.getAttributes())});return e}function Xa(t,e){const n=[];let i=0,o=0;for(const t of e){if(t.offset>i){for(let e=0;e<t.offset-i;e++)n.push("e");o+=t.offset-i}if("insert"==t.type){for(let e=0;e<t.howMany;e++)n.push("i");i=t.offset+t.howMany}else if("remove"==t.type){for(let e=0;e<t.howMany;e++)n.push("r");i=t.offset,o+=t.howMany}else n.push(..."a".repeat(t.howMany).split("")),i=t.offset+t.howMany,o+=t.howMany}if(o<t)for(let e=0;e<t-o-i;e++)n.push("e");return n}function tc(t){const e=t.position&&"$graveyard"==t.position.root.rootName,n=t.range&&"$graveyard"==t.range.root.rootName;return!e&&!n}class ec{constructor(){this._operations=[],this._undoPairs=new Map,this._undoneOperations=new Set}addOperation(t){this._operations.includes(t)||this._operations.push(t)}getOperations(t=0,e=Number.POSITIVE_INFINITY){return t<0?[]:this._operations.slice(t,e)}getOperation(t){return this._operations[t]}setOperationAsUndone(t,e){this._undoPairs.set(e,t),this._undoneOperations.add(t)}isUndoingOperation(t){return this._undoPairs.has(t)}isUndoneOperation(t){return this._undoneOperations.has(t)}getUndoneOperation(t){return this._undoPairs.get(t)}}function nc(t,e){return!!(n=t.charAt(e-1))&&1==n.length&&/[\ud800-\udbff]/.test(n)&&function(t){return!!t&&1==t.length&&/[\udc00-\udfff]/.test(t)}(t.charAt(e));var n}function ic(t,e){return!!(n=t.charAt(e))&&1==n.length&&/[\u0300-\u036f\u1ab0-\u1aff\u1dc0-\u1dff\u20d0-\u20ff\ufe20-\ufe2f]/.test(n);var n}class oc{constructor(t){this.model=t,this.version=0,this.history=new ec(this),this.selection=new Bs(this),this.roots=new An({idProperty:"rootName"}),this.differ=new Ja(t.markers),this._postFixers=new Set,this._hasSelectionChangedFromTheLastChangeBlock=!1,this.createRoot("$root","$graveyard"),this.listenTo(t,"applyOperation",(t,e)=>{const n=e[0];if(n.isDocumentOperation&&n.baseVersion!==this.version)throw new hn.b("model-document-applyOperation-wrong-version: Only operations with matching versions can be applied.",this,{operation:n})},{priority:"highest"}),this.listenTo(t,"applyOperation",(t,e)=>{const n=e[0];n.isDocumentOperation&&this.differ.bufferOperation(n)},{priority:"high"}),this.listenTo(t,"applyOperation",(t,e)=>{const n=e[0];n.isDocumentOperation&&(this.version++,this.history.addOperation(n))},{priority:"low"}),this.listenTo(this.selection,"change",()=>{this._hasSelectionChangedFromTheLastChangeBlock=!0}),this.listenTo(t.markers,"update",(t,e,n,i)=>{this.differ.bufferMarkerChange(e.name,n,i,e.affectsData),null===n&&e.on("change",(t,n)=>{this.differ.bufferMarkerChange(e.name,n,e.getRange(),e.affectsData)})})}get graveyard(){return this.getRoot("$graveyard")}createRoot(t="$root",e="main"){if(this.roots.get(e))throw new hn.b("model-document-createRoot-name-exists: Root with specified name already exists.",this,{name:e});const n=new Wa(this,t,e);return this.roots.add(n),n}destroy(){this.selection.destroy(),this.stopListening()}getRoot(t="main"){return this.roots.get(t)}getRootNames(){return Array.from(this.roots,t=>t.rootName).filter(t=>"$graveyard"!=t)}registerPostFixer(t){this._postFixers.add(t)}toJSON(){const t=Nn(this);return t.selection="[engine.model.DocumentSelection]",t.model="[engine.model.Model]",t}_handleChangeBlock(t){this._hasDocumentChangedFromTheLastChangeBlock()&&(this._callPostFixers(t),this.selection.refresh(),this.differ.hasDataChanges()?this.fire("change:data",t.batch):this.fire("change",t.batch),this.selection.refresh(),this.differ.reset()),this._hasSelectionChangedFromTheLastChangeBlock=!1}_hasDocumentChangedFromTheLastChangeBlock(){return!this.differ.isEmpty||this._hasSelectionChangedFromTheLastChangeBlock}_getDefaultRoot(){for(const t of this.roots)if(t!==this.graveyard)return t;return this.graveyard}_getDefaultRange(){const t=this._getDefaultRoot(),e=this.model,n=e.schema,i=e.createPositionFromPath(t,[0]);return n.getNearestSelectionRange(i)||e.createRange(i)}_validateSelectionRange(t){return rc(t.start)&&rc(t.end)}_callPostFixers(t){let e=!1;do{for(const n of this._postFixers)if(this.selection.refresh(),e=n(t),e)break}while(e)}}function rc(t){const e=t.textNode;if(e){const n=e.data,i=t.offset-e.startOffset;return!nc(n,i)&&!ic(n,i)}return!0}xn(oc,mn);class sc{constructor(){this._markers=new Map}[Symbol.iterator](){return this._markers.values()}has(t){return this._markers.has(t)}get(t){return this._markers.get(t)||null}_set(t,e,n=!1,i=!1){const o=t instanceof ac?t.name:t,r=this._markers.get(o);if(r){const t=r.getRange();let s=!1;return t.isEqual(e)||(r._attachLiveRange(js.fromRange(e)),s=!0),n!=r.managedUsingOperations&&(r._managedUsingOperations=n,s=!0),"boolean"==typeof i&&i!=r.affectsData&&(r._affectsData=i,s=!0),s&&this.fire("update:"+o,r,t,e),r}const s=js.fromRange(e),a=new ac(o,s,n,i);return this._markers.set(o,a),this.fire("update:"+o,a,null,e),a}_remove(t){const e=t instanceof ac?t.name:t,n=this._markers.get(e);return!!n&&(this._markers.delete(e),this.fire("update:"+e,n,n.getRange(),null),this._destroyMarker(n),!0)}_refresh(t){const e=t instanceof ac?t.name:t,n=this._markers.get(e);if(!n)throw new hn.b("markercollection-refresh-marker-not-exists: Marker with provided name does not exists.",this);const i=n.getRange();this.fire("update:"+e,n,i,i,n.managedUsingOperations,n.affectsData)}*getMarkersAtPosition(t){for(const e of this)e.getRange().containsPosition(t)&&(yield e)}*getMarkersIntersectingRange(t){for(const e of this)null!==e.getRange().getIntersection(t)&&(yield e)}destroy(){for(const t of this._markers.values())this._destroyMarker(t);this._markers=null,this.stopListening()}*getMarkersGroup(t){for(const e of this._markers.values())e.name.startsWith(t+":")&&(yield e)}_destroyMarker(t){t.stopListening(),t._detachLiveRange()}}xn(sc,mn);class ac{constructor(t,e,n,i){this.name=t,this._liveRange=this._attachLiveRange(e),this._managedUsingOperations=n,this._affectsData=i}get managedUsingOperations(){if(!this._liveRange)throw new hn.b("marker-destroyed: Cannot use a destroyed marker instance.",this);return this._managedUsingOperations}get affectsData(){if(!this._liveRange)throw new hn.b("marker-destroyed: Cannot use a destroyed marker instance.",this);return this._affectsData}getStart(){if(!this._liveRange)throw new hn.b("marker-destroyed: Cannot use a destroyed marker instance.",this);return this._liveRange.start.clone()}getEnd(){if(!this._liveRange)throw new hn.b("marker-destroyed: Cannot use a destroyed marker instance.",this);return this._liveRange.end.clone()}getRange(){if(!this._liveRange)throw new hn.b("marker-destroyed: Cannot use a destroyed marker instance.",this);return this._liveRange.toRange()}is(t){return"marker"===t||"model:marker"===t}_attachLiveRange(t){return this._liveRange&&this._detachLiveRange(),t.delegate("change:range").to(this),t.delegate("change:content").to(this),this._liveRange=t,t}_detachLiveRange(){this._liveRange.stopDelegating("change:range",this),this._liveRange.stopDelegating("change:content",this),this._liveRange.detach(),this._liveRange=null}}xn(ac,mn);class cc extends Ca{get type(){return"noop"}clone(){return new cc(this.baseVersion)}getReversed(){return new cc(this.baseVersion+1)}_execute(){}static get className(){return"NoOperation"}}const lc={};lc[Da.className]=Da,lc[Va.className]=Va,lc[za.className]=za,lc[ja.className]=ja,lc[cc.className]=cc,lc[Ca.className]=Ca,lc[Ba.className]=Ba,lc[Fa.className]=Fa,lc[Ha.className]=Ha,lc[Ua.className]=Ua;class dc extends ys{constructor(t,e,n="toNone"){if(super(t,e,n),!this.root.is("rootElement"))throw new hn.b("model-liveposition-root-not-rootelement: LivePosition's root has to be an instance of RootElement.",t);uc.call(this)}detach(){this.stopListening()}is(t){return"livePosition"===t||"model:livePosition"===t||"position"==t||"model:position"===t}toPosition(){return new ys(this.root,this.path.slice(),this.stickiness)}static fromPosition(t,e){return new this(t.root,t.path.slice(),e||t.stickiness)}}function uc(){this.listenTo(this.root.document.model,"applyOperation",(t,e)=>{const n=e[0];n.isDocumentOperation&&hc.call(this,n)},{priority:"low"})}function hc(t){const e=this.getTransformedByOperation(t);if(!this.isEqual(e)){const t=this.toPosition();this.path=e.path,this.root=e.root,this.fire("change",t)}}xn(dc,mn);class fc{constructor(t,e,n){this.model=t,this.writer=e,this.position=n,this.canMergeWith=new Set([this.position.parent]),this.schema=t.schema,this._filterAttributesOf=[],this._affectedStart=null,this._affectedEnd=null}handleNodes(t,e){t=Array.from(t);for(let n=0;n<t.length;n++){const i=t[n];this._handleNode(i,{isFirst:0===n&&e.isFirst,isLast:n===t.length-1&&e.isLast})}this.schema.removeDisallowedAttributes(this._filterAttributesOf,this.writer),this._filterAttributesOf=[]}getSelectionRange(){return this.nodeToSelect?Ts._createOn(this.nodeToSelect):this.model.schema.getNearestSelectionRange(this.position)}getAffectedRange(){return this._affectedStart?new Ts(this._affectedStart,this._affectedEnd):null}destroy(){this._affectedStart&&this._affectedStart.detach(),this._affectedEnd&&this._affectedEnd.detach()}_handleNode(t,e){if(this.schema.isObject(t))return void this._handleObject(t,e);this._checkAndSplitToAllowedPosition(t,e)?(this._insert(t),this._mergeSiblingsOf(t,e)):this._handleDisallowedNode(t,e)}_handleObject(t,e){this._checkAndSplitToAllowedPosition(t)?this._insert(t):this._tryAutoparagraphing(t,e)}_handleDisallowedNode(t,e){t.is("element")?this.handleNodes(t.getChildren(),e):this._tryAutoparagraphing(t,e)}_insert(t){if(!this.schema.checkChild(this.position,t))throw new hn.b("insertcontent-wrong-position: Given node cannot be inserted on the given position.",this,{node:t,position:this.position});const e=dc.fromPosition(this.position,"toNext");this._setAffectedBoundaries(this.position),this.writer.insert(t,this.position),this.position=e.toPosition(),e.detach(),this.schema.isObject(t)&&!this.schema.checkChild(this.position,"$text")?this.nodeToSelect=t:this.nodeToSelect=null,this._filterAttributesOf.push(t)}_setAffectedBoundaries(t){this._affectedStart||(this._affectedStart=dc.fromPosition(t,"toPrevious")),this._affectedEnd&&!this._affectedEnd.isBefore(t)||(this._affectedEnd&&this._affectedEnd.detach(),this._affectedEnd=dc.fromPosition(t,"toNext"))}_mergeSiblingsOf(t,e){if(!(t instanceof ks))return;const n=this._canMergeLeft(t,e),i=this._canMergeRight(t,e),o=dc._createBefore(t);o.stickiness="toNext";const r=dc._createAfter(t);if(r.stickiness="toNext",n){const t=dc.fromPosition(this.position);t.stickiness="toNext",this._affectedStart.isEqual(o)&&(this._affectedStart.detach(),this._affectedStart=dc._createAt(o.nodeBefore,"end","toPrevious")),this.writer.merge(o),o.isEqual(this._affectedEnd)&&e.isLast&&(this._affectedEnd.detach(),this._affectedEnd=dc._createAt(o.nodeBefore,"end","toNext")),this.position=t.toPosition(),t.detach()}if(i){if(!this.position.isEqual(r))throw new hn.b("insertcontent-invalid-insertion-position",this);this.position=ys._createAt(r.nodeBefore,"end");const t=dc.fromPosition(this.position,"toPrevious");this._affectedEnd.isEqual(r)&&(this._affectedEnd.detach(),this._affectedEnd=dc._createAt(r.nodeBefore,"end","toNext")),this.writer.merge(r),r.getShiftedBy(-1).isEqual(this._affectedStart)&&e.isFirst&&(this._affectedStart.detach(),this._affectedStart=dc._createAt(r.nodeBefore,0,"toPrevious")),this.position=t.toPosition(),t.detach()}(n||i)&&this._filterAttributesOf.push(this.position.parent),o.detach(),r.detach()}_canMergeLeft(t,e){const n=t.previousSibling;return e.isFirst&&n instanceof ks&&this.canMergeWith.has(n)&&this.model.schema.checkMerge(n,t)}_canMergeRight(t,e){const n=t.nextSibling;return e.isLast&&n instanceof ks&&this.canMergeWith.has(n)&&this.model.schema.checkMerge(t,n)}_tryAutoparagraphing(t,e){const n=this.writer.createElement("paragraph");this._getAllowedIn(n,this.position.parent)&&this.schema.checkChild(n,t)&&(n._appendChild(t),this._handleNode(n,e))}_checkAndSplitToAllowedPosition(t){const e=this._getAllowedIn(t,this.position.parent);if(!e)return!1;for(;e!=this.position.parent;){if(this.schema.isLimit(this.position.parent))return!1;if(this.position.isAtStart){const t=this.position.parent;this.position=this.writer.createPositionBefore(t),t.isEmpty&&t.parent===e&&this.writer.remove(t)}else if(this.position.isAtEnd)this.position=this.writer.createPositionAfter(this.position.parent);else{const t=this.writer.createPositionAfter(this.position.parent);this._setAffectedBoundaries(this.position),this.writer.split(this.position),this.position=t,this.canMergeWith.add(this.position.nodeAfter)}}return!0}_getAllowedIn(t,e){return this.schema.checkChild(e,t)?e:e.parent?this._getAllowedIn(t,e.parent):null}}function gc(t,e,n={}){if(e.isCollapsed)return;const i=e.getFirstRange();if("$graveyard"==i.root.rootName)return;const o=t.schema;t.change(t=>{if(!n.doNotResetEntireContent&&function(t,e){const n=t.getLimitElement(e);if(!e.containsEntireContent(n))return!1;const i=e.getFirstRange();if(i.start.parent==i.end.parent)return!1;return t.checkChild(n,"paragraph")}(o,e))return void function(t,e){const n=t.model.schema.getLimitElement(e);t.remove(t.createRangeIn(n)),pc(t,t.createPositionAt(n,0),e)}(t,e);const[r,s]=function(t){const e=t.root.document.model,n=t.start;let i=t.end;if(e.hasContent(t,{ignoreMarkers:!0})){const n=function(t){const e=t.parent,n=e.root.document.model.schema,i=e.getAncestors({parentFirst:!0,includeSelf:!0});for(const t of i){if(n.isLimit(t))return null;if(n.isBlock(t))return t}}(i);if(n&&i.isTouching(e.createPositionAt(n,0))){const n=e.createSelection(t);e.modifySelection(n,{direction:"backward"}),i=n.getLastPosition()}}return[dc.fromPosition(n,"toPrevious"),dc.fromPosition(i,"toNext")]}(i);i.start.isTouching(i.end)||t.remove(i),n.leaveUnmerged||(!function(t,e,n){const i=t.model;if(!mc(t.model.schema,e,n))return;const[o,r]=function(t,e){const n=t.getAncestors(),i=e.getAncestors();let o=0;for(;n[o]&&n[o]==i[o];)o++;return[n[o],i[o]]}(e,n);!i.hasContent(o,{ignoreMarkers:!0})&&i.hasContent(r,{ignoreMarkers:!0})?function t(e,n,i,o){const r=n.parent,s=i.parent;if(r==o||s==o)return;n=e.createPositionAfter(r),(i=e.createPositionBefore(s)).isEqual(n)||e.insert(r,i);for(;n.parent.isEmpty;){const t=n.parent;n=e.createPositionBefore(t),e.remove(t)}if(i=e.createPositionBefore(s),function(t,e){const n=e.nodeBefore,i=e.nodeAfter;n.name!=i.name&&t.rename(n,i.name);t.clearAttributes(n),t.setAttributes(Object.fromEntries(i.getAttributes()),n),t.merge(e)}(e,i),!mc(e.model.schema,n,i))return;t(e,n,i,o)}(t,e,n,o.parent):function t(e,n,i,o){const r=n.parent,s=i.parent;if(r==o||s==o)return;n=e.createPositionAfter(r),(i=e.createPositionBefore(s)).isEqual(n)||e.insert(s,n);e.merge(n);for(;i.parent.isEmpty;){const t=i.parent;i=e.createPositionBefore(t),e.remove(t)}if(!mc(e.model.schema,n,i))return;t(e,n,i,o)}(t,e,n,o.parent)}(t,r,s),o.removeDisallowedAttributes(r.parent.getChildren(),t)),bc(t,e,r),!n.doNotAutoparagraph&&function(t,e){const n=t.checkChild(e,"$text"),i=t.checkChild(e,"paragraph");return!n&&i}(o,r)&&pc(t,r,e),r.detach(),s.detach()})}function mc(t,e,n){const i=e.parent,o=n.parent;return i!=o&&(!t.isLimit(i)&&!t.isLimit(o)&&function(t,e,n){const i=new Ts(t,e);for(const t of i.getWalker())if(n.isLimit(t.item))return!1;return!0}(e,n,t))}function pc(t,e,n){const i=t.createElement("paragraph");t.insert(i,e),bc(t,n,t.createPositionAt(i,0))}function bc(t,e,n){e instanceof Bs?t.setSelection(n):e.setTo(n)}function wc(t,e){if("text"==e.type)return"word"===t.unit?function(t,e){let n=t.position.textNode;if(n){let i=t.position.offset-n.startOffset;for(;!_c(n.data,i,e)&&!vc(n,i,e);){t.next();const o=e?t.position.nodeAfter:t.position.nodeBefore;if(o&&o.is("text")){const i=o.data.charAt(e?0:o.data.length-1);' ,.?!:;"-()'.includes(i)||(t.next(),n=t.position.textNode)}i=t.position.offset-n.startOffset}}return t.position}(t.walker,t.isForward):function(t,e){const n=t.position.textNode;if(n){const i=n.data;let o=t.position.offset-n.startOffset;for(;nc(i,o)||"character"==e&&ic(i,o);)t.next(),o=t.position.offset-n.startOffset}return t.position}(t.walker,t.unit,t.isForward);if(e.type==(t.isForward?"elementStart":"elementEnd")){if(t.schema.isObject(e.item))return ys._createAt(e.item,t.isForward?"after":"before");if(t.schema.checkChild(e.nextPosition,"$text"))return e.nextPosition}else{if(t.schema.isLimit(e.item))return void t.walker.skip(()=>!0);if(t.schema.checkChild(e.nextPosition,"$text"))return e.nextPosition}}function kc(t,e){const n=t.root,i=ys._createAt(n,e?"end":0);return e?new Ts(t,i):new Ts(i,t)}function _c(t,e,n){const i=e+(n?0:-1);return' ,.?!:;"-()'.includes(t.charAt(i))}function vc(t,e,n){return e===(n?t.endOffset:0)}function yc(t,e){const n=[];Array.from(t.getItems({direction:"backward"})).map(t=>e.createRangeOn(t)).filter(e=>(e.start.isAfter(t.start)||e.start.isEqual(t.start))&&(e.end.isBefore(t.end)||e.end.isEqual(t.end))).forEach(t=>{n.push(t.start.parent),e.remove(t)}),n.forEach(t=>{let n=t;for(;n.parent&&n.isEmpty;){const t=e.createRangeOn(n);n=n.parent,e.remove(t)}})}function xc(t){t.document.registerPostFixer(e=>function(t,e){const n=e.document.selection,i=e.schema,o=[];let r=!1;for(const t of n.getRanges()){const e=Ac(t,i);e&&!e.isEqual(t)?(o.push(e),r=!0):o.push(t)}r&&t.setSelection(function(t){const e=[];e.push(t.shift());for(const n of t){const t=e.pop();if(n.isIntersecting(t)){const i=t.start.isAfter(n.start)?n.start:t.start,o=t.end.isAfter(n.end)?t.end:n.end,r=new Ts(i,o);e.push(r)}else e.push(t),e.push(n)}return e}(o),{backward:n.isBackward})}(e,t))}function Ac(t,e){return t.isCollapsed?function(t,e){const n=t.start,i=e.getNearestSelectionRange(n);if(!i)return null;if(!i.isCollapsed)return i;const o=i.start;if(n.isEqual(o))return null;return new Ts(o)}(t,e):function(t,e){const n=t.start,i=t.end,o=e.checkChild(n,"$text"),r=e.checkChild(i,"$text"),s=e.getLimitElement(n),a=e.getLimitElement(i);if(s===a){if(o&&r)return null;if(function(t,e,n){const i=t.nodeAfter&&!n.isLimit(t.nodeAfter)||n.checkChild(t,"$text"),o=e.nodeBefore&&!n.isLimit(e.nodeBefore)||n.checkChild(e,"$text");return i||o}(n,i,e)){const t=n.nodeAfter&&e.isObject(n.nodeAfter)?null:e.getNearestSelectionRange(n,"forward"),o=i.nodeBefore&&e.isObject(i.nodeBefore)?null:e.getNearestSelectionRange(i,"backward"),r=t?t.start:n,s=o?o.start:i;return new Ts(r,s)}}const c=s&&!s.is("rootElement"),l=a&&!a.is("rootElement");if(c||l){const t=n.nodeAfter&&i.nodeBefore&&n.nodeAfter.parent===i.nodeBefore.parent,o=c&&(!t||!Tc(n.nodeAfter,e)),r=l&&(!t||!Tc(i.nodeBefore,e));let d=n,u=i;return o&&(d=ys._createBefore(Cc(s,e))),r&&(u=ys._createAfter(Cc(a,e))),new Ts(d,u)}return null}(t,e)}function Cc(t,e){let n=t,i=n;for(;e.isLimit(i)&&i.parent;)n=i,i=i.parent;return n}function Tc(t,e){return t&&e.isObject(t)}class Pc{constructor(){this.markers=new sc,this.document=new oc(this),this.schema=new sa,this._pendingChanges=[],this._currentWriter=null,["insertContent","deleteContent","modifySelection","getSelectedContent","applyOperation"].forEach(t=>this.decorate(t)),this.on("applyOperation",(t,e)=>{e[0]._validate()},{priority:"highest"}),this.schema.register("$root",{isLimit:!0}),this.schema.register("$block",{allowIn:"$root",isBlock:!0}),this.schema.register("$text",{allowIn:"$block",isInline:!0}),this.schema.register("$clipboardHolder",{allowContentOf:"$root",isLimit:!0}),this.schema.extend("$text",{allowIn:"$clipboardHolder"}),this.schema.register("$marker"),this.schema.addChildCheck((t,e)=>{if("$marker"===e.name)return!0}),xc(this)}change(t){try{return 0===this._pendingChanges.length?(this._pendingChanges.push({batch:new Aa,callback:t}),this._runPendingChanges()[0]):t(this._currentWriter)}catch(t){hn.b.rethrowUnexpectedError(t,this)}}enqueueChange(t,e){try{"string"==typeof t?t=new Aa(t):"function"==typeof t&&(e=t,t=new Aa),this._pendingChanges.push({batch:t,callback:e}),1==this._pendingChanges.length&&this._runPendingChanges()}catch(t){hn.b.rethrowUnexpectedError(t,this)}}applyOperation(t){t._execute()}insertContent(t,e,n){return function(t,e,n,i){return t.change(o=>{let r;r=n?n instanceof Ns||n instanceof Bs?n:o.createSelection(n,i):t.document.selection,r.isCollapsed||t.deleteContent(r,{doNotAutoparagraph:!0});const s=new fc(t,o,r.anchor);let a;a=e.is("documentFragment")?e.getChildren():[e],s.handleNodes(a,{isFirst:!0,isLast:!0});const c=s.getSelectionRange();c&&(r instanceof Bs?o.setSelection(c):r.setTo(c));const l=s.getAffectedRange()||t.createRange(r.anchor);return s.destroy(),l})}(this,t,e,n)}deleteContent(t,e){gc(this,t,e)}modifySelection(t,e){!function(t,e,n={}){const i=t.schema,o="backward"!=n.direction,r=n.unit?n.unit:"character",s=e.focus,a=new _s({boundaries:kc(s,o),singleCharacters:!0,direction:o?"forward":"backward"}),c={walker:a,schema:i,isForward:o,unit:r};let l;for(;l=a.next();){if(l.done)return;const n=wc(c,l.value);if(n)return void(e instanceof Bs?t.change(t=>{t.setSelectionFocus(n)}):e.setFocus(n))}}(this,t,e)}getSelectedContent(t){return function(t,e){return t.change(t=>{const n=t.createDocumentFragment(),i=e.getFirstRange();if(!i||i.isCollapsed)return n;const o=i.start.root,r=i.start.getCommonPath(i.end),s=o.getNodeByPath(r);let a;a=i.start.parent==i.end.parent?i:t.createRange(t.createPositionAt(s,i.start.path[r.length]),t.createPositionAt(s,i.end.path[r.length]+1));const c=a.end.offset-a.start.offset;for(const e of a.getItems({shallow:!0}))e.is("textProxy")?t.appendText(e.data,e.getAttributes(),n):t.append(t.cloneElement(e,!0),n);if(a!=i){const e=i._getTransformedByMove(a.start,t.createPositionAt(n,0),c)[0],o=t.createRange(t.createPositionAt(n,0),e.start);yc(t.createRange(e.end,t.createPositionAt(n,"end")),t),yc(o,t)}return n})}(this,t)}hasContent(t,e={}){const n=t instanceof ks?Ts._createIn(t):t;if(n.isCollapsed)return!1;const{ignoreWhitespaces:i=!1,ignoreMarkers:o=!1}=e;if(!o)for(const t of this.markers.getMarkersIntersectingRange(n))if(t.affectsData)return!0;for(const t of n.getItems())if(t.is("textProxy")){if(!i)return!0;if(-1!==t.data.search(/\S/))return!0}else if(this.schema.isObject(t))return!0;return!1}createPositionFromPath(t,e,n){return new ys(t,e,n)}createPositionAt(t,e){return ys._createAt(t,e)}createPositionAfter(t){return ys._createAfter(t)}createPositionBefore(t){return ys._createBefore(t)}createRange(t,e){return new Ts(t,e)}createRangeIn(t){return Ts._createIn(t)}createRangeOn(t){return Ts._createOn(t)}createSelection(t,e,n){return new Ns(t,e,n)}createBatch(t){return new Aa(t)}createOperationFromJSON(t){return class{static fromJSON(t,e){return lc[t.__className].fromJSON(t,e)}}.fromJSON(t,this.document)}destroy(){this.document.destroy(),this.stopListening()}_runPendingChanges(){const t=[];for(this.fire("_beforeChanges");this._pendingChanges.length;){const e=this._pendingChanges[0].batch;this._currentWriter=new qa(this,e);const n=this._pendingChanges[0].callback(this._currentWriter);t.push(n),this.document._handleChangeBlock(this._currentWriter),this._pendingChanges.shift(),this._currentWriter=null}return this.fire("_afterChanges"),t}}xn(Pc,Ui);class Sc{constructor(){this._listener=Object.create(ur)}listenTo(t){this._listener.listenTo(t,"keydown",(t,e)=>{this._listener.fire("_keydown:"+po(e),e)})}set(t,e,n={}){const i=bo(t),o=n.priority;this._listener.listenTo(this._listener,"_keydown:"+i,(t,n)=>{e(n,()=>{n.preventDefault(),n.stopPropagation(),t.stop()}),t.return=!0},{priority:o})}press(t){return!!this._listener.fire("_keydown:"+po(t),t)}destroy(){this._listener.stopListening()}}class Ec extends Sc{constructor(t){super(),this.editor=t}set(t,e,n={}){if("string"==typeof e){const t=e;e=(e,n)=>{this.editor.execute(t),n()}}super.set(t,e,n)}}class Mc{constructor(t={}){this._context=t.context||new Mn({language:t.language}),this._context._addEditor(this,!t.context);const e=Array.from(this.constructor.builtinPlugins||[]);this.config=new on(t,this.constructor.defaultConfig),this.config.define("plugins",e),this.config.define(this._context._getEditorConfig()),this.plugins=new Cn(this,e,this._context.plugins),this.locale=this._context.locale,this.t=this.locale.t,this.commands=new ia,this.set("state","initializing"),this.once("ready",()=>this.state="ready",{priority:"high"}),this.once("destroy",()=>this.state="destroyed",{priority:"high"}),this.set("isReadOnly",!1),this.model=new Pc;const n=new Mi;this.data=new _a(this.model,n),this.editing=new na(this.model,n),this.editing.view.document.bind("isReadOnly").to(this),this.conversion=new va([this.editing.downcastDispatcher,this.data.downcastDispatcher],this.data.upcastDispatcher),this.conversion.addAlias("dataDowncast",this.data.downcastDispatcher),this.conversion.addAlias("editingDowncast",this.editing.downcastDispatcher),this.keystrokes=new Ec(this),this.keystrokes.listenTo(this.editing.view.document)}initPlugins(){const t=this.config,e=t.get("plugins"),n=t.get("removePlugins")||[],i=t.get("extraPlugins")||[];return this.plugins.init(e.concat(i),n)}destroy(){let t=Promise.resolve();return"initializing"==this.state&&(t=new Promise(t=>this.once("ready",t))),t.then(()=>{this.fire("destroy"),this.stopListening(),this.commands.destroy()}).then(()=>this.plugins.destroy()).then(()=>{this.model.destroy(),this.data.destroy(),this.editing.destroy(),this.keystrokes.destroy()}).then(()=>this._context._removeEditor(this))}execute(...t){try{this.commands.execute(...t)}catch(t){hn.b.rethrowUnexpectedError(t,this)}}}xn(Mc,Ui);var Ic={setData(t){this.data.set(t)},getData(t){return this.data.get(t)}};var Nc={updateSourceElement(){if(!this.sourceElement)throw new hn.b("editor-missing-sourceelement: Cannot update the source element of a detached editor.",this);var t,e;t=this.sourceElement,e=this.data.get(),t instanceof HTMLTextAreaElement&&(t.value=e),t.innerHTML=e}};class Oc{getHtml(t){const e=document.implementation.createHTMLDocument("").createElement("div");return e.appendChild(t),e.innerHTML}}class Rc{constructor(t){this._domParser=new DOMParser,this._domConverter=new sr(t,{blockFillerMode:"nbsp"}),this._htmlWriter=new Oc}toData(t){const e=this._domConverter.viewToDom(t,document);return this._htmlWriter.getHtml(e)}toView(t){const e=this._toDom(t);return this._domConverter.domToView(e)}_toDom(t){const e=this._domParser.parseFromString(t,"text/html"),n=e.createDocumentFragment(),i=e.body.childNodes;for(;i.length>0;)n.appendChild(i[0]);return n}}class Dc{constructor(t){this.editor=t,this._components=new Map}*names(){for(const t of this._components.values())yield t.originalName}add(t,e){if(this.has(t))throw new hn.b("componentfactory-item-exists: The item already exists in the component factory.",this,{name:t});this._components.set(Lc(t),{callback:e,originalName:t})}create(t){if(!this.has(t))throw new hn.b("componentfactory-item-missing: The required component is not registered in the factory.",this,{name:t});return this._components.get(Lc(t)).callback(this.editor.locale)}has(t){return this._components.has(Lc(t))}}function Lc(t){return String(t).toLowerCase()}class jc{constructor(){this.set("isFocused",!1),this.set("focusedElement",null),this._elements=new Set,this._nextEventLoopTimeout=null}add(t){if(this._elements.has(t))throw new hn.b("focusTracker-add-element-already-exist",this);this.listenTo(t,"focus",()=>this._focus(t),{useCapture:!0}),this.listenTo(t,"blur",()=>this._blur(),{useCapture:!0}),this._elements.add(t)}remove(t){t===this.focusedElement&&this._blur(t),this._elements.has(t)&&(this.stopListening(t),this._elements.delete(t))}destroy(){this.stopListening()}_focus(t){clearTimeout(this._nextEventLoopTimeout),this.focusedElement=t,this.isFocused=!0}_blur(){clearTimeout(this._nextEventLoopTimeout),this._nextEventLoopTimeout=setTimeout(()=>{this.focusedElement=null,this.isFocused=!1},0)}}xn(jc,ur),xn(jc,Ui);class Vc{constructor(t){this.editor=t,this.componentFactory=new Dc(t),this.focusTracker=new jc,this._editableElementsMap=new Map,this.listenTo(t.editing.view.document,"layoutChanged",()=>this.update())}get element(){return null}update(){this.fire("update")}destroy(){this.stopListening(),this.focusTracker.destroy();for(const t of this._editableElementsMap.values())t.ckeditorInstance=null;this._editableElementsMap=new Map}setEditableElement(t,e){this._editableElementsMap.set(t,e),e.ckeditorInstance||(e.ckeditorInstance=this.editor)}getEditableElement(t="main"){return this._editableElementsMap.get(t)}getEditableElementsNames(){return this._editableElementsMap.keys()}get _editableElements(){return console.warn("editor-ui-deprecated-editable-elements: The EditorUI#_editableElements property has been deprecated and will be removed in the near future.",{editorUI:this}),this._editableElementsMap}}xn(Vc,mn);n(13);const zc=new WeakMap;function Bc(t){const{view:e,element:n,text:i,isDirectHost:o=!0}=t,r=e.document;zc.has(r)||(zc.set(r,new Map),r.registerPostFixer(t=>Uc(r,t))),zc.get(r).set(n,{text:i,isDirectHost:o}),e.change(t=>Uc(r,t))}function Fc(t,e){return!!e.hasClass("ck-placeholder")&&(t.removeClass("ck-placeholder",e),!0)}function Uc(t,e){const n=zc.get(t);let i=!1;for(const[t,o]of n)Hc(e,t,o)&&(i=!0);return i}function Hc(t,e,n){const{text:i,isDirectHost:o}=n,r=o?e:function(t){if(1===t.childCount){const e=t.getChild(0);if(e.is("element")&&!e.is("uiElement"))return e}return null}(e);let s=!1;return!!r&&(n.hostElement=r,r.getAttribute("data-placeholder")!==i&&(t.setAttribute("data-placeholder",i,r),s=!0),!function(t){if(!t.isAttached())return!1;const e=!Array.from(t.getChildren()).some(t=>!t.is("uiElement")),n=t.document;if(!n.isFocused&&e)return!0;const i=n.selection.anchor;return!(!e||!i||i.parent===t)}(r)?Fc(t,r)&&(s=!0):function(t,e){return!e.hasClass("ck-placeholder")&&(t.addClass("ck-placeholder",e),!0)}(t,r)&&(s=!0),s)}class Wc{constructor(){this._replacedElements=[]}replace(t,e){this._replacedElements.push({element:t,newElement:e}),t.style.display="none",e&&t.parentNode.insertBefore(e,t.nextSibling)}restore(){this._replacedElements.forEach(({element:t,newElement:e})=>{t.style.display="",e&&e.remove()}),this._replacedElements=[]}}class qc extends Vc{constructor(t,e){var n;super(t),this.view=e,this._toolbarConfig=(n=t.config.get("toolbar"),Array.isArray(n)?{items:n}:n?Object.assign({items:[]},n):{items:[]}),this._elementReplacer=new Wc}get element(){return this.view.element}init(t){const e=this.editor,n=this.view,i=e.editing.view,o=n.editable,r=i.document.getRoot();o.name=r.rootName,n.render();const s=o.element;this.setEditableElement(o.name,s),this.focusTracker.add(s),n.editable.bind("isFocused").to(this.focusTracker),i.attachDomRoot(s),t&&this._elementReplacer.replace(t,this.element),this._initPlaceholder(),this._initToolbar(),this.fire("ready")}destroy(){const t=this.view,e=this.editor.editing.view;this._elementReplacer.restore(),e.detachDomRoot(t.editable.name),t.destroy(),super.destroy()}_initToolbar(){const t=this.editor,e=this.view,n=t.editing.view;e.stickyPanel.bind("isActive").to(this.focusTracker,"isFocused"),e.stickyPanel.limiterElement=e.element,this._toolbarConfig.viewportTopOffset&&(e.stickyPanel.viewportTopOffset=this._toolbarConfig.viewportTopOffset),e.toolbar.fillFromConfig(this._toolbarConfig.items,this.componentFactory),function({origin:t,originKeystrokeHandler:e,originFocusTracker:n,toolbar:i,beforeFocus:o,afterBlur:r}){n.add(i.element),e.set("Alt+F10",(t,e)=>{n.isFocused&&!i.focusTracker.isFocused&&(o&&o(),i.focus(),e())}),i.keystrokes.set("Esc",(e,n)=>{i.focusTracker.isFocused&&(t.focus(),r&&r(),n())})}({origin:n,originFocusTracker:this.focusTracker,originKeystrokeHandler:t.keystrokes,toolbar:e.toolbar})}_initPlaceholder(){const t=this.editor,e=t.editing.view,n=e.document.getRoot(),i=t.sourceElement,o=t.config.get("placeholder")||i&&"textarea"===i.tagName.toLowerCase()&&i.getAttribute("placeholder");o&&Bc({view:e,element:n,text:o,isDirectHost:!1})}}class Yc extends An{constructor(t=[]){super(t,{idProperty:"viewUid"}),this.on("add",(t,e,n)=>{this._renderViewIntoCollectionParent(e,n)}),this.on("remove",(t,e)=>{e.element&&this._parentElement&&e.element.remove()}),this._parentElement=null}destroy(){this.map(t=>t.destroy())}setParent(t){this._parentElement=t;for(const t of this)this._renderViewIntoCollectionParent(t)}delegate(...t){if(!t.length||!t.every(t=>"string"==typeof t))throw new hn.b("ui-viewcollection-delegate-wrong-events: All event names must be strings.",this);return{to:e=>{for(const n of this)for(const i of t)n.delegate(i).to(e);this.on("add",(n,i)=>{for(const n of t)i.delegate(n).to(e)}),this.on("remove",(n,i)=>{for(const n of t)i.stopDelegating(n,e)})}}}_renderViewIntoCollectionParent(t,e){t.isRendered||t.render(),t.element&&this._parentElement&&this._parentElement.insertBefore(t.element,this._parentElement.children[e])}}class Gc{constructor(t){Object.assign(this,il(nl(t))),this._isRendered=!1,this._revertData=null}render(){const t=this._renderNode({intoFragment:!0});return this._isRendered=!0,t}apply(t){return this._revertData={children:[],bindings:[],attributes:{}},this._renderNode({node:t,isApplying:!0,revertData:this._revertData}),t}revert(t){if(!this._revertData)throw new hn.b("ui-template-revert-not-applied: Attempting to revert a template which has not been applied yet.",[this,t]);this._revertTemplateFromNode(t,this._revertData)}*getViews(){yield*function*t(e){if(e.children)for(const n of e.children)cl(n)?yield n:ll(n)&&(yield*t(n))}(this)}static bind(t,e){return{to:(n,i)=>new Kc({eventNameOrFunction:n,attribute:n,observable:t,emitter:e,callback:i}),if:(n,i,o)=>new Qc({observable:t,emitter:e,attribute:n,valueIfTrue:i,callback:o})}}static extend(t,e){if(t._isRendered)throw new hn.b("template-extend-render: Attempting to extend a template which has already been rendered.",[this,t]);!function t(e,n){n.attributes&&(e.attributes||(e.attributes={}),sl(e.attributes,n.attributes));n.eventListeners&&(e.eventListeners||(e.eventListeners={}),sl(e.eventListeners,n.eventListeners));n.text&&e.text.push(...n.text);if(n.children&&n.children.length){if(e.children.length!=n.children.length)throw new hn.b("ui-template-extend-children-mismatch: The number of children in extended definition does not match.",e);let i=0;for(const o of n.children)t(e.children[i++],o)}}(t,il(nl(e)))}_renderNode(t){let e;if(e=t.node?this.tag&&this.text:this.tag?this.text:!this.text,e)throw new hn.b('ui-template-wrong-syntax: Node definition must have either "tag" or "text" when rendering a new Node.',this);return this.text?this._renderText(t):this._renderElement(t)}_renderElement(t){let e=t.node;return e||(e=t.node=document.createElementNS(this.ns||"http://www.w3.org/1999/xhtml",this.tag)),this._renderAttributes(t),this._renderElementChildren(t),this._setUpListeners(t),e}_renderText(t){let e=t.node;return e?t.revertData.text=e.textContent:e=t.node=document.createTextNode(""),Jc(this.text)?this._bindToObservable({schema:this.text,updater:Xc(e),data:t}):e.textContent=this.text.join(""),e}_renderAttributes(t){let e,n,i,o;if(!this.attributes)return;const r=t.node,s=t.revertData;for(e in this.attributes)if(i=r.getAttribute(e),n=this.attributes[e],s&&(s.attributes[e]=i),o=j(n[0])&&n[0].ns?n[0].ns:null,Jc(n)){const a=o?n[0].value:n;s&&ul(e)&&a.unshift(i),this._bindToObservable({schema:a,updater:tl(r,e,o),data:t})}else"style"==e&&"string"!=typeof n[0]?this._renderStyleAttribute(n[0],t):(s&&i&&ul(e)&&n.unshift(i),n=n.map(t=>t&&t.value||t).reduce((t,e)=>t.concat(e),[]).reduce(rl,""),al(n)||r.setAttributeNS(o,e,n))}_renderStyleAttribute(t,e){const n=e.node;for(const i in t){const o=t[i];Jc(o)?this._bindToObservable({schema:[o],updater:el(n,i),data:e}):n.style[i]=o}}_renderElementChildren(t){const e=t.node,n=t.intoFragment?document.createDocumentFragment():e,i=t.isApplying;let o=0;for(const r of this.children)if(dl(r)){if(!i){r.setParent(e);for(const t of r)n.appendChild(t.element)}}else if(cl(r))i||(r.isRendered||r.render(),n.appendChild(r.element));else if(Jo(r))n.appendChild(r);else if(i){const e={children:[],bindings:[],attributes:{}};t.revertData.children.push(e),r._renderNode({node:n.childNodes[o++],isApplying:!0,revertData:e})}else n.appendChild(r.render());t.intoFragment&&e.appendChild(n)}_setUpListeners(t){if(this.eventListeners)for(const e in this.eventListeners){const n=this.eventListeners[e].map(n=>{const[i,o]=e.split("@");return n.activateDomEventListener(i,o,t)});t.revertData&&t.revertData.bindings.push(n)}}_bindToObservable({schema:t,updater:e,data:n}){const i=n.revertData;Zc(t,e,n);const o=t.filter(t=>!al(t)).filter(t=>t.observable).map(i=>i.activateAttributeListener(t,e,n));i&&i.bindings.push(o)}_revertTemplateFromNode(t,e){for(const t of e.bindings)for(const e of t)e();if(e.text)t.textContent=e.text;else{for(const n in e.attributes){const i=e.attributes[n];null===i?t.removeAttribute(n):t.setAttribute(n,i)}for(let n=0;n<e.children.length;++n)this._revertTemplateFromNode(t.childNodes[n],e.children[n])}}}xn(Gc,mn);class $c{constructor(t){Object.assign(this,t)}getValue(t){const e=this.observable[this.attribute];return this.callback?this.callback(e,t):e}activateAttributeListener(t,e,n){const i=()=>Zc(t,e,n);return this.emitter.listenTo(this.observable,"change:"+this.attribute,i),()=>{this.emitter.stopListening(this.observable,"change:"+this.attribute,i)}}}class Kc extends $c{activateDomEventListener(t,e,n){const i=(t,n)=>{e&&!n.target.matches(e)||("function"==typeof this.eventNameOrFunction?this.eventNameOrFunction(n):this.observable.fire(this.eventNameOrFunction,n))};return this.emitter.listenTo(n.node,t,i),()=>{this.emitter.stopListening(n.node,t,i)}}}class Qc extends $c{getValue(t){return!al(super.getValue(t))&&(this.valueIfTrue||!0)}}function Jc(t){return!!t&&(t.value&&(t=t.value),Array.isArray(t)?t.some(Jc):t instanceof $c)}function Zc(t,e,{node:n}){let i=function(t,e){return t.map(t=>t instanceof $c?t.getValue(e):t)}(t,n);i=1==t.length&&t[0]instanceof Qc?i[0]:i.reduce(rl,""),al(i)?e.remove():e.set(i)}function Xc(t){return{set(e){t.textContent=e},remove(){t.textContent=""}}}function tl(t,e,n){return{set(i){t.setAttributeNS(n,e,i)},remove(){t.removeAttributeNS(n,e)}}}function el(t,e){return{set(n){t.style[e]=n},remove(){t.style[e]=null}}}function nl(t){return en(t,t=>{if(t&&(t instanceof $c||ll(t)||cl(t)||dl(t)))return t})}function il(t){if("string"==typeof t?t=function(t){return{text:[t]}}(t):t.text&&function(t){Array.isArray(t.text)||(t.text=[t.text])}(t),t.on&&(t.eventListeners=function(t){for(const e in t)ol(t,e);return t}(t.on),delete t.on),!t.text){t.attributes&&function(t){for(const e in t)t[e].value&&(t[e].value=[].concat(t[e].value)),ol(t,e)}(t.attributes);const e=[];if(t.children)if(dl(t.children))e.push(t.children);else for(const n of t.children)ll(n)||cl(n)||Jo(n)?e.push(n):e.push(new Gc(n));t.children=e}return t}function ol(t,e){Array.isArray(t[e])||(t[e]=[t[e]])}function rl(t,e){return al(e)?t:al(t)?e:`${t} ${e}`}function sl(t,e){for(const n in e)t[n]?t[n].push(...e[n]):t[n]=e[n]}function al(t){return!t&&0!==t}function cl(t){return t instanceof hl}function ll(t){return t instanceof Gc}function dl(t){return t instanceof Yc}function ul(t){return"class"==t||"style"==t}n(15);class hl{constructor(t){this.element=null,this.isRendered=!1,this.locale=t,this.t=t&&t.t,this._viewCollections=new An,this._unboundChildren=this.createCollection(),this._viewCollections.on("add",(e,n)=>{n.locale=t}),this.decorate("render")}get bindTemplate(){return this._bindTemplate?this._bindTemplate:this._bindTemplate=Gc.bind(this,this)}createCollection(t){const e=new Yc(t);return this._viewCollections.add(e),e}registerChild(t){yn(t)||(t=[t]);for(const e of t)this._unboundChildren.add(e)}deregisterChild(t){yn(t)||(t=[t]);for(const e of t)this._unboundChildren.remove(e)}setTemplate(t){this.template=new Gc(t)}extendTemplate(t){Gc.extend(this.template,t)}render(){if(this.isRendered)throw new hn.b("ui-view-render-already-rendered: This View has already been rendered.",this);this.template&&(this.element=this.template.render(),this.registerChild(this.template.getViews())),this.isRendered=!0}destroy(){this.stopListening(),this._viewCollections.map(t=>t.destroy()),this.template&&this.template._revertData&&this.template.revert(this.element)}}xn(hl,ur),xn(hl,Ui);var fl=function(t){return"string"==typeof t||!Dt(t)&&p(t)&&"[object String]"==f(t)};class gl extends Yc{constructor(t,e=[]){super(e),this.locale=t}attachToDom(){this._bodyCollectionContainer=new Gc({tag:"div",attributes:{class:["ck","ck-reset_all","ck-body","ck-rounded-corners"],dir:this.locale.uiLanguageDirection},children:this}).render();let t=document.querySelector(".ck-body-wrapper");t||(t=function(t,e,n={},i=[]){const o=n&&n.xmlns,r=o?t.createElementNS(o,e):t.createElement(e);for(const t in n)r.setAttribute(t,n[t]);!fl(i)&&yn(i)||(i=[i]);for(let e of i)fl(e)&&(e=t.createTextNode(e)),r.appendChild(e);return r}(document,"div",{class:"ck-body-wrapper"}),document.body.appendChild(t)),t.appendChild(this._bodyCollectionContainer)}detachFromDom(){super.destroy(),this._bodyCollectionContainer&&this._bodyCollectionContainer.remove();const t=document.querySelector(".ck-body-wrapper");t&&0==t.childElementCount&&t.remove()}}n(17);class ml extends hl{constructor(t){super(t),this.body=new gl(t)}render(){super.render(),this.body.attachToDom()}destroy(){return this.body.detachFromDom(),super.destroy()}}n(19);class pl extends hl{constructor(t){super(t),this.set("text"),this.set("for"),this.id="ck-editor__label_"+dn();const e=this.bindTemplate;this.setTemplate({tag:"label",attributes:{class:["ck","ck-label"],id:this.id,for:e.to("for")},children:[{text:e.to("text")}]})}}class bl extends ml{constructor(t){super(t),this.top=this.createCollection(),this.main=this.createCollection(),this._voiceLabelView=this._createVoiceLabel(),this.setTemplate({tag:"div",attributes:{class:["ck","ck-reset","ck-editor","ck-rounded-corners"],role:"application",dir:t.uiLanguageDirection,lang:t.uiLanguage,"aria-labelledby":this._voiceLabelView.id},children:[this._voiceLabelView,{tag:"div",attributes:{class:["ck","ck-editor__top","ck-reset_all"],role:"presentation"},children:this.top},{tag:"div",attributes:{class:["ck","ck-editor__main"],role:"presentation"},children:this.main}]})}_createVoiceLabel(){const t=this.t,e=new pl;return e.text=t("Rich Text Editor"),e.extendTemplate({attributes:{class:"ck-voice-label"}}),e}}class wl extends hl{constructor(t,e,n){super(t),this.setTemplate({tag:"div",attributes:{class:["ck","ck-content","ck-editor__editable","ck-rounded-corners"],lang:t.contentLanguage,dir:t.contentLanguageDirection}}),this.name=null,this.set("isFocused",!1),this._editableElement=n,this._hasExternalElement=!!this._editableElement,this._editingView=e}render(){super.render(),this._hasExternalElement?this.template.apply(this.element=this._editableElement):this._editableElement=this.element,this.on("change:isFocused",()=>this._updateIsFocusedClasses()),this._updateIsFocusedClasses()}destroy(){this._hasExternalElement&&this.template.revert(this._editableElement),super.destroy()}_updateIsFocusedClasses(){const t=this._editingView;function e(e){t.change(n=>{const i=t.document.getRoot(e.name);n.addClass(e.isFocused?"ck-focused":"ck-blurred",i),n.removeClass(e.isFocused?"ck-blurred":"ck-focused",i)})}t.isRenderingInProgress?function n(i){t.once("change:isRenderingInProgress",(t,o,r)=>{r?n(i):e(i)})}(this):e(this)}}class kl extends wl{constructor(t,e,n){super(t,e,n),this.extendTemplate({attributes:{role:"textbox",class:"ck-editor__editable_inline"}})}render(){super.render();const t=this._editingView,e=this.t;t.change(n=>{const i=t.document.getRoot(this.name);n.setAttribute("aria-label",e("Rich Text Editor, %0",[this.name]),i)})}}function _l(t){return e=>e+t}n(21);const vl=_l("px");class yl extends hl{constructor(t){super(t);const e=this.bindTemplate;this.set("isActive",!1),this.set("isSticky",!1),this.set("limiterElement",null),this.set("limiterBottomOffset",50),this.set("viewportTopOffset",0),this.set("_marginLeft",null),this.set("_isStickyToTheLimiter",!1),this.set("_hasViewportTopOffset",!1),this.content=this.createCollection(),this._contentPanelPlaceholder=new Gc({tag:"div",attributes:{class:["ck","ck-sticky-panel__placeholder"],style:{display:e.to("isSticky",t=>t?"block":"none"),height:e.to("isSticky",t=>t?vl(this._panelRect.height):null)}}}).render(),this._contentPanel=new Gc({tag:"div",attributes:{class:["ck","ck-sticky-panel__content",e.if("isSticky","ck-sticky-panel__content_sticky"),e.if("_isStickyToTheLimiter","ck-sticky-panel__content_sticky_bottom-limit")],style:{width:e.to("isSticky",t=>t?vl(this._contentPanelPlaceholder.getBoundingClientRect().width):null),top:e.to("_hasViewportTopOffset",t=>t?vl(this.viewportTopOffset):null),bottom:e.to("_isStickyToTheLimiter",t=>t?vl(this.limiterBottomOffset):null),marginLeft:e.to("_marginLeft")}},children:this.content}).render(),this.setTemplate({tag:"div",attributes:{class:["ck","ck-sticky-panel"]},children:[this._contentPanelPlaceholder,this._contentPanel]})}render(){super.render(),this._checkIfShouldBeSticky(),this.listenTo(nr.window,"scroll",()=>{this._checkIfShouldBeSticky()}),this.listenTo(this,"change:isActive",()=>{this._checkIfShouldBeSticky()})}_checkIfShouldBeSticky(){const t=this._panelRect=this._contentPanel.getBoundingClientRect();let e;this.limiterElement?(e=this._limiterRect=this.limiterElement.getBoundingClientRect(),this.isSticky=this.isActive&&e.top<this.viewportTopOffset&&this._panelRect.height+this.limiterBottomOffset<e.height):this.isSticky=!1,this.isSticky?(this._isStickyToTheLimiter=e.bottom<t.height+this.limiterBottomOffset+this.viewportTopOffset,this._hasViewportTopOffset=!this._isStickyToTheLimiter&&!!this.viewportTopOffset,this._marginLeft=this._isStickyToTheLimiter?null:vl(-nr.window.scrollX)):(this._isStickyToTheLimiter=!1,this._hasViewportTopOffset=!1,this._marginLeft=null)}}class xl{constructor(t){if(Object.assign(this,t),t.actions&&t.keystrokeHandler)for(const e in t.actions){let n=t.actions[e];"string"==typeof n&&(n=[n]);for(const i of n)t.keystrokeHandler.set(i,(t,n)=>{this[e](),n()})}}get first(){return this.focusables.find(Al)||null}get last(){return this.focusables.filter(Al).slice(-1)[0]||null}get next(){return this._getFocusableItem(1)}get previous(){return this._getFocusableItem(-1)}get current(){let t=null;return null===this.focusTracker.focusedElement?null:(this.focusables.find((e,n)=>{const i=e.element===this.focusTracker.focusedElement;return i&&(t=n),i}),t)}focusFirst(){this._focus(this.first)}focusLast(){this._focus(this.last)}focusNext(){this._focus(this.next)}focusPrevious(){this._focus(this.previous)}_focus(t){t&&t.focus()}_getFocusableItem(t){const e=this.current,n=this.focusables.length;if(!n)return null;if(null===e)return this[1===t?"first":"last"];let i=(e+n+t)%n;do{const e=this.focusables.get(i);if(Al(e))return e;i=(i+n+t)%n}while(i!==e);return null}}function Al(t){return!(!t.focus||"none"==nr.window.getComputedStyle(t.element).display)}class Cl extends hl{constructor(t){super(t),this.setTemplate({tag:"span",attributes:{class:["ck","ck-toolbar__separator"]}})}}class Tl{constructor(t,e){Tl._observerInstance||Tl._createObserver(),this._element=t,this._callback=e,Tl._addElementCallback(t,e),Tl._observerInstance.observe(t)}destroy(){Tl._deleteElementCallback(this._element,this._callback)}static _addElementCallback(t,e){Tl._elementCallbacks||(Tl._elementCallbacks=new Map);let n=Tl._elementCallbacks.get(t);n||(n=new Set,Tl._elementCallbacks.set(t,n)),n.add(e)}static _deleteElementCallback(t,e){const n=Tl._getElementCallbacks(t);n&&(n.delete(e),n.size||(Tl._elementCallbacks.delete(t),Tl._observerInstance.unobserve(t))),Tl._elementCallbacks&&!Tl._elementCallbacks.size&&(Tl._observerInstance=null,Tl._elementCallbacks=null)}static _getElementCallbacks(t){return Tl._elementCallbacks?Tl._elementCallbacks.get(t):null}static _createObserver(){let t;t="function"==typeof nr.window.ResizeObserver?nr.window.ResizeObserver:Pl,Tl._observerInstance=new t(t=>{for(const e of t){if(!e.target.offsetParent)continue;const t=Tl._getElementCallbacks(e.target);if(t)for(const n of t)n(e)}})}}Tl._observerInstance=null,Tl._elementCallbacks=null;class Pl{constructor(t){this._callback=t,this._elements=new Set,this._previousRects=new Map,this._periodicCheckTimeout=null}observe(t){this._elements.add(t),this._checkElementRectsAndExecuteCallback(),1===this._elements.size&&this._startPeriodicCheck()}unobserve(t){this._elements.delete(t),this._previousRects.delete(t),this._elements.size||this._stopPeriodicCheck()}_startPeriodicCheck(){const t=()=>{this._checkElementRectsAndExecuteCallback(),this._periodicCheckTimeout=setTimeout(t,100)};this.listenTo(nr.window,"resize",()=>{this._checkElementRectsAndExecuteCallback()}),this._periodicCheckTimeout=setTimeout(t,100)}_stopPeriodicCheck(){clearTimeout(this._periodicCheckTimeout),this.stopListening(),this._previousRects.clear()}_checkElementRectsAndExecuteCallback(){const t=[];for(const e of this._elements)this._hasRectChanged(e)&&t.push({target:e,contentRect:this._previousRects.get(e)});t.length&&this._callback(t)}_hasRectChanged(t){if(!t.ownerDocument.body.contains(t))return!1;const e=new es(t),n=this._previousRects.get(t),i=!n||!n.isEqual(e);return this._previousRects.set(t,e),i}}xn(Pl,ur);class Sl extends hl{constructor(t){super(t);const e=this.bindTemplate;this.set("isVisible",!1),this.set("position","se"),this.children=this.createCollection(),this.setTemplate({tag:"div",attributes:{class:["ck","ck-reset","ck-dropdown__panel",e.to("position",t=>"ck-dropdown__panel_"+t),e.if("isVisible","ck-dropdown__panel-visible")]},children:this.children,on:{selectstart:e.to(t=>t.preventDefault())}})}focus(){this.children.length&&this.children.first.focus()}focusLast(){if(this.children.length){const t=this.children.last;"function"==typeof t.focusLast?t.focusLast():t.focus()}}}n(23);function El({element:t,target:e,positions:n,limiter:i,fitInViewport:o}){z(e)&&(e=e()),z(i)&&(i=i());const r=function(t){return t&&t.parentNode?t.offsetParent===nr.document.body?null:t.offsetParent:null}(t),s=new es(t),a=new es(e);let c,l;if(i||o){const t=function(t,e){const{elementRect:n,viewportRect:i}=e,o=n.getArea(),r=function(t,{targetRect:e,elementRect:n,limiterRect:i,viewportRect:o}){const r=[],s=n.getArea();for(const a of t){const t=Ml(a,e,n);if(!t)continue;const[c,l]=t;let d=0,u=0;if(i)if(o){const t=i.getIntersection(o);t&&(d=t.getIntersectionArea(l))}else d=i.getIntersectionArea(l);o&&(u=o.getIntersectionArea(l));const h={positionName:c,positionRect:l,limiterIntersectArea:d,viewportIntersectArea:u};if(d===s)return[h];r.push(h)}return r}(t,e);if(i){const t=Il(r.filter(({viewportIntersectArea:t})=>t===o),o);if(t)return t}return Il(r,o)}(n,{targetRect:a,elementRect:s,limiterRect:i&&new es(i).getVisible(),viewportRect:o&&new es(nr.window)});[l,c]=t||Ml(n[0],a,s)}else[l,c]=Ml(n[0],a,s);let d=Nl(c);return r&&(d=function({left:t,top:e},n){const i=Nl(new es(n)),o=Xr(n);return t-=i.left,e-=i.top,t+=n.scrollLeft,e+=n.scrollTop,t-=o.left,e-=o.top,{left:t,top:e}}(d,r)),{left:d.left,top:d.top,name:l}}function Ml(t,e,n){const i=t(e,n);if(!i)return null;const{left:o,top:r,name:s}=i;return[s,n.clone().moveTo(o,r)]}function Il(t,e){let n,i,o=0;for(const{positionName:r,positionRect:s,limiterIntersectArea:a,viewportIntersectArea:c}of t){if(a===e)return[r,s];const t=c**2+a**2;t>o&&(o=t,n=s,i=r)}return n?[i,n]:null}function Nl({left:t,top:e}){const{scrollX:n,scrollY:i}=nr.window;return{left:t+n,top:e+i}}class Ol extends hl{constructor(t,e,n){super(t);const i=this.bindTemplate;this.buttonView=e,this.panelView=n,this.set("isOpen",!1),this.set("isEnabled",!0),this.set("class"),this.set("id"),this.set("panelPosition","auto"),this.keystrokes=new Sc,this.setTemplate({tag:"div",attributes:{class:["ck","ck-dropdown",i.to("class"),i.if("isEnabled","ck-disabled",t=>!t)],id:i.to("id"),"aria-describedby":i.to("ariaDescribedById")},children:[e,n]}),e.extendTemplate({attributes:{class:["ck-dropdown__button"]}})}render(){super.render(),this.listenTo(this.buttonView,"open",()=>{this.isOpen=!this.isOpen}),this.panelView.bind("isVisible").to(this,"isOpen"),this.on("change:isOpen",()=>{this.isOpen&&("auto"===this.panelPosition?this.panelView.position=Ol._getOptimalPosition({element:this.panelView.element,target:this.buttonView.element,fitInViewport:!0,positions:this._panelPositions}).name:this.panelView.position=this.panelPosition)}),this.keystrokes.listenTo(this.element);const t=(t,e)=>{this.isOpen&&(this.buttonView.focus(),this.isOpen=!1,e())};this.keystrokes.set("arrowdown",(t,e)=>{this.buttonView.isEnabled&&!this.isOpen&&(this.isOpen=!0,e())}),this.keystrokes.set("arrowright",(t,e)=>{this.isOpen&&e()}),this.keystrokes.set("arrowleft",t),this.keystrokes.set("esc",t)}focus(){this.buttonView.focus()}get _panelPositions(){const{southEast:t,southWest:e,northEast:n,northWest:i}=Ol.defaultPanelPositions;return"ltr"===this.locale.uiLanguageDirection?[t,e,n,i]:[e,t,i,n]}}Ol.defaultPanelPositions={southEast:t=>({top:t.bottom,left:t.left,name:"se"}),southWest:(t,e)=>({top:t.bottom,left:t.left-e.width+t.width,name:"sw"}),northEast:(t,e)=>({top:t.top-e.height,left:t.left,name:"ne"}),northWest:(t,e)=>({top:t.bottom-e.height,left:t.left-e.width+t.width,name:"nw"})},Ol._getOptimalPosition=El;n(25);class Rl extends hl{constructor(){super();const t=this.bindTemplate;this.set("content",""),this.set("viewBox","0 0 20 20"),this.set("fillColor",""),this.setTemplate({tag:"svg",ns:"http://www.w3.org/2000/svg",attributes:{class:["ck","ck-icon"],viewBox:t.to("viewBox")}})}render(){super.render(),this._updateXMLContent(),this._colorFillPaths(),this.on("change:content",()=>{this._updateXMLContent(),this._colorFillPaths()}),this.on("change:fillColor",()=>{this._colorFillPaths()})}_updateXMLContent(){if(this.content){const t=(new DOMParser).parseFromString(this.content.trim(),"image/svg+xml").querySelector("svg"),e=t.getAttribute("viewBox");for(e&&(this.viewBox=e),this.element.innerHTML="";t.childNodes.length>0;)this.element.appendChild(t.childNodes[0])}}_colorFillPaths(){this.fillColor&&this.element.querySelectorAll(".ck-icon__fill").forEach(t=>{t.style.fill=this.fillColor})}}n(27);class Dl extends hl{constructor(t){super(t),this.set("text",""),this.set("position","s");const e=this.bindTemplate;this.setTemplate({tag:"span",attributes:{class:["ck","ck-tooltip",e.to("position",t=>"ck-tooltip_"+t),e.if("text","ck-hidden",t=>!t.trim())]},children:[{tag:"span",attributes:{class:["ck","ck-tooltip__text"]},children:[{text:e.to("text")}]}]})}}n(29);class Ll extends hl{constructor(t){super(t);const e=this.bindTemplate,n=dn();this.set("class"),this.set("labelStyle"),this.set("icon"),this.set("isEnabled",!0),this.set("isOn",!1),this.set("isVisible",!0),this.set("isToggleable",!1),this.set("keystroke"),this.set("label"),this.set("tabindex",-1),this.set("tooltip"),this.set("tooltipPosition","s"),this.set("type","button"),this.set("withText",!1),this.set("withKeystroke",!1),this.children=this.createCollection(),this.tooltipView=this._createTooltipView(),this.labelView=this._createLabelView(n),this.iconView=new Rl,this.iconView.extendTemplate({attributes:{class:"ck-button__icon"}}),this.keystrokeView=this._createKeystrokeView(),this.bind("_tooltipString").to(this,"tooltip",this,"label",this,"keystroke",this._getTooltipString.bind(this)),this.setTemplate({tag:"button",attributes:{class:["ck","ck-button",e.to("class"),e.if("isEnabled","ck-disabled",t=>!t),e.if("isVisible","ck-hidden",t=>!t),e.to("isOn",t=>t?"ck-on":"ck-off"),e.if("withText","ck-button_with-text"),e.if("withKeystroke","ck-button_with-keystroke")],type:e.to("type",t=>t||"button"),tabindex:e.to("tabindex"),"aria-labelledby":"ck-editor__aria-label_"+n,"aria-disabled":e.if("isEnabled",!0,t=>!t),"aria-pressed":e.to("isOn",t=>!!this.isToggleable&&String(t))},children:this.children,on:{mousedown:e.to(t=>{t.preventDefault()}),click:e.to(t=>{this.isEnabled?this.fire("execute"):t.preventDefault()})}})}render(){super.render(),this.icon&&(this.iconView.bind("content").to(this,"icon"),this.children.add(this.iconView)),this.children.add(this.tooltipView),this.children.add(this.labelView),this.withKeystroke&&this.children.add(this.keystrokeView)}focus(){this.element.focus()}_createTooltipView(){const t=new Dl;return t.bind("text").to(this,"_tooltipString"),t.bind("position").to(this,"tooltipPosition"),t}_createLabelView(t){const e=new hl,n=this.bindTemplate;return e.setTemplate({tag:"span",attributes:{class:["ck","ck-button__label"],style:n.to("labelStyle"),id:"ck-editor__aria-label_"+t},children:[{text:this.bindTemplate.to("label")}]}),e}_createKeystrokeView(){const t=new hl;return t.setTemplate({tag:"span",attributes:{class:["ck","ck-button__keystroke"]},children:[{text:this.bindTemplate.to("keystroke",t=>wo(t))}]}),t}_getTooltipString(t,e,n){return t?"string"==typeof t?t:(n&&(n=wo(n)),t instanceof Function?t(e,n):`${e}${n?` (${n})`:""}`):""}}var jl='<svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg"><path d="M.941 4.523a.75.75 0 1 1 1.06-1.06l3.006 3.005 3.005-3.005a.75.75 0 1 1 1.06 1.06l-3.549 3.55a.75.75 0 0 1-1.168-.136L.941 4.523z"/></svg>';class Vl extends Ll{constructor(t){super(t),this.arrowView=this._createArrowView(),this.extendTemplate({attributes:{"aria-haspopup":!0}}),this.delegate("execute").to(this,"open")}render(){super.render(),this.children.add(this.arrowView)}_createArrowView(){const t=new Rl;return t.content=jl,t.extendTemplate({attributes:{class:"ck-dropdown__arrow"}}),t}}n(31);class zl extends hl{constructor(){super(),this.items=this.createCollection(),this.focusTracker=new jc,this.keystrokes=new Sc,this._focusCycler=new xl({focusables:this.items,focusTracker:this.focusTracker,keystrokeHandler:this.keystrokes,actions:{focusPrevious:"arrowup",focusNext:"arrowdown"}}),this.setTemplate({tag:"ul",attributes:{class:["ck","ck-reset","ck-list"]},children:this.items})}render(){super.render();for(const t of this.items)this.focusTracker.add(t.element);this.items.on("add",(t,e)=>{this.focusTracker.add(e.element)}),this.items.on("remove",(t,e)=>{this.focusTracker.remove(e.element)}),this.keystrokes.listenTo(this.element)}focus(){this._focusCycler.focusFirst()}focusLast(){this._focusCycler.focusLast()}}class Bl extends hl{constructor(t){super(t),this.children=this.createCollection(),this.setTemplate({tag:"li",attributes:{class:["ck","ck-list__item"]},children:this.children})}focus(){this.children.first.focus()}}class Fl extends hl{constructor(t){super(t),this.setTemplate({tag:"li",attributes:{class:["ck","ck-list__separator"]}})}}n(33);class Ul extends Ll{constructor(t){super(t),this.isToggleable=!0,this.toggleSwitchView=this._createToggleView(),this.extendTemplate({attributes:{class:"ck-switchbutton"}})}render(){super.render(),this.children.add(this.toggleSwitchView)}_createToggleView(){const t=new hl;return t.setTemplate({tag:"span",attributes:{class:["ck","ck-button__toggle"]},children:[{tag:"span",attributes:{class:["ck","ck-button__toggle__inner"]}}]}),t}}function Hl({emitter:t,activator:e,callback:n,contextElements:i}){t.listenTo(document,"mousedown",(t,{target:o})=>{if(e()){for(const t of i)if(t.contains(o))return;n()}})}n(35),n(37);function Wl(t,e=Vl){const n=new e(t),i=new Sl(t),o=new Ol(t,n,i);return n.bind("isEnabled").to(o),n instanceof Vl?n.bind("isOn").to(o,"isOpen"):n.arrowView.bind("isOn").to(o,"isOpen"),function(t){(function(t){t.on("render",()=>{Hl({emitter:t,activator:()=>t.isOpen,callback:()=>{t.isOpen=!1},contextElements:[t.element]})})})(t),function(t){t.on("execute",e=>{e.source instanceof Ul||(t.isOpen=!1)})}(t),function(t){t.keystrokes.set("arrowdown",(e,n)=>{t.isOpen&&(t.panelView.focus(),n())}),t.keystrokes.set("arrowup",(e,n)=>{t.isOpen&&(t.panelView.focusLast(),n())})}(t)}(o),o}function ql(t,e){const n=t.locale,i=t.listView=new zl(n);i.items.bindTo(e).using(({type:t,model:e})=>{if("separator"===t)return new Fl(n);if("button"===t||"switchbutton"===t){const i=new Bl(n);let o;return o="button"===t?new Ll(n):new Ul(n),o.bind(...Object.keys(e)).to(e),o.delegate("execute").to(i),i.children.add(o),i}}),t.panelView.children.add(i),i.items.delegate("execute").to(t)}n(39);class Yl extends hl{constructor(t,e){super(t);const n=this.bindTemplate,i=this.t;var o;this.options=e||{},this.set("ariaLabel",i("Editor toolbar")),this.set("maxWidth","auto"),this.items=this.createCollection(),this.focusTracker=new jc,this.keystrokes=new Sc,this.set("class"),this.set("isCompact",!1),this.itemsView=new Gl(t),this.children=this.createCollection(),this.children.add(this.itemsView),this.focusables=this.createCollection(),this._focusCycler=new xl({focusables:this.focusables,focusTracker:this.focusTracker,keystrokeHandler:this.keystrokes,actions:{focusPrevious:["arrowleft","arrowup"],focusNext:["arrowright","arrowdown"]}}),this.setTemplate({tag:"div",attributes:{class:["ck","ck-toolbar",n.to("class"),n.if("isCompact","ck-toolbar_compact")],role:"toolbar","aria-label":n.to("ariaLabel"),style:{maxWidth:n.to("maxWidth")}},children:this.children,on:{mousedown:(o=this,o.bindTemplate.to(t=>{t.target===o.element&&t.preventDefault()}))}}),this._behavior=this.options.shouldGroupWhenFull?new Kl(this):new $l(this)}render(){super.render();for(const t of this.items)this.focusTracker.add(t.element);this.items.on("add",(t,e)=>{this.focusTracker.add(e.element)}),this.items.on("remove",(t,e)=>{this.focusTracker.remove(e.element)}),this.keystrokes.listenTo(this.element),this._behavior.render(this)}destroy(){return this._behavior.destroy(),super.destroy()}focus(){this._focusCycler.focusFirst()}focusLast(){this._focusCycler.focusLast()}fillFromConfig(t,e){t.map(t=>{"|"==t?this.items.add(new Cl):e.has(t)?this.items.add(e.create(t)):console.warn(Object(hn.a)("toolbarview-item-unavailable: The requested toolbar item is unavailable."),{name:t})})}}class Gl extends hl{constructor(t){super(t),this.children=this.createCollection(),this.setTemplate({tag:"div",attributes:{class:["ck","ck-toolbar__items"]},children:this.children})}}class $l{constructor(t){const e=t.bindTemplate;t.set("isVertical",!1),t.itemsView.children.bindTo(t.items).using(t=>t),t.focusables.bindTo(t.items).using(t=>t),t.extendTemplate({attributes:{class:[e.if("isVertical","ck-toolbar_vertical")]}})}render(){}destroy(){}}class Kl{constructor(t){this.viewChildren=t.children,this.viewFocusables=t.focusables,this.viewItemsView=t.itemsView,this.viewFocusTracker=t.focusTracker,this.viewLocale=t.locale,this.ungroupedItems=t.createCollection(),this.groupedItems=t.createCollection(),this.groupedItemsDropdown=this._createGroupedItemsDropdown(),this.resizeObserver=null,this.cachedPadding=null,this.shouldUpdateGroupingOnNextResize=!1,t.itemsView.children.bindTo(this.ungroupedItems).using(t=>t),this.ungroupedItems.on("add",this._updateFocusCycleableItems.bind(this)),this.ungroupedItems.on("remove",this._updateFocusCycleableItems.bind(this)),t.children.on("add",this._updateFocusCycleableItems.bind(this)),t.children.on("remove",this._updateFocusCycleableItems.bind(this)),t.items.on("add",(t,e,n)=>{n>this.ungroupedItems.length?this.groupedItems.add(e,n-this.ungroupedItems.length):this.ungroupedItems.add(e,n),this._updateGrouping()}),t.items.on("remove",(t,e,n)=>{n>this.ungroupedItems.length?this.groupedItems.remove(e):this.ungroupedItems.remove(e),this._updateGrouping()}),t.extendTemplate({attributes:{class:["ck-toolbar_grouping"]}})}render(t){this.viewElement=t.element,this._enableGroupingOnResize(),this._enableGroupingOnMaxWidthChange(t)}destroy(){this.groupedItemsDropdown.destroy(),this.resizeObserver.destroy()}_updateGrouping(){if(!this.viewElement.ownerDocument.body.contains(this.viewElement))return;if(!this.viewElement.offsetParent)return void(this.shouldUpdateGroupingOnNextResize=!0);let t;for(;this._areItemsOverflowing;)this._groupLastItem(),t=!0;if(!t&&this.groupedItems.length){for(;this.groupedItems.length&&!this._areItemsOverflowing;)this._ungroupFirstItem();this._areItemsOverflowing&&this._groupLastItem()}}get _areItemsOverflowing(){if(!this.ungroupedItems.length)return!1;const t=this.viewElement,e=this.viewLocale.uiLanguageDirection,n=new es(t.lastChild),i=new es(t);if(!this.cachedPadding){const n=nr.window.getComputedStyle(t),i="ltr"===e?"paddingRight":"paddingLeft";this.cachedPadding=Number.parseInt(n[i])}return"ltr"===e?n.right>i.right-this.cachedPadding:n.left<i.left+this.cachedPadding}_enableGroupingOnResize(){let t;this.resizeObserver=new Tl(this.viewElement,e=>{t&&t===e.contentRect.width&&!this.shouldUpdateGroupingOnNextResize||(this.shouldUpdateGroupingOnNextResize=!1,this._updateGrouping(),t=e.contentRect.width)}),this._updateGrouping()}_enableGroupingOnMaxWidthChange(t){t.on("change:maxWidth",()=>{this._updateGrouping()})}_groupLastItem(){this.groupedItems.length||(this.viewChildren.add(new Cl),this.viewChildren.add(this.groupedItemsDropdown),this.viewFocusTracker.add(this.groupedItemsDropdown.element)),this.groupedItems.add(this.ungroupedItems.remove(this.ungroupedItems.last),0)}_ungroupFirstItem(){this.ungroupedItems.add(this.groupedItems.remove(this.groupedItems.first)),this.groupedItems.length||(this.viewChildren.remove(this.groupedItemsDropdown),this.viewChildren.remove(this.viewChildren.last),this.viewFocusTracker.remove(this.groupedItemsDropdown.element))}_createGroupedItemsDropdown(){const t=this.viewLocale,e=t.t,n=Wl(t);return n.class="ck-toolbar__grouped-dropdown",n.panelPosition="ltr"===t.uiLanguageDirection?"sw":"se",function(t,e){const n=t.locale,i=n.t,o=t.toolbarView=new Yl(n);o.set("ariaLabel",i("Dropdown toolbar")),t.extendTemplate({attributes:{class:["ck-toolbar-dropdown"]}}),e.map(t=>o.items.add(t)),t.panelView.children.add(o),o.items.delegate("execute").to(t)}(n,[]),n.buttonView.set({label:e("Show more items"),tooltip:!0,icon:'<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><circle cx="9.5" cy="4.5" r="1.5"/><circle cx="9.5" cy="10.5" r="1.5"/><circle cx="9.5" cy="16.5" r="1.5"/></svg>'}),n.toolbarView.items.bindTo(this.groupedItems).using(t=>t),n}_updateFocusCycleableItems(){this.viewFocusables.clear(),this.ungroupedItems.map(t=>{this.viewFocusables.add(t)}),this.groupedItems.length&&this.viewFocusables.add(this.groupedItemsDropdown)}}n(41);class Ql extends bl{constructor(t,e,n={}){super(t),this.stickyPanel=new yl(t),this.toolbar=new Yl(t,{shouldGroupWhenFull:n.shouldToolbarGroupWhenFull}),this.editable=new kl(t,e)}render(){super.render(),this.stickyPanel.content.add(this.toolbar),this.top.add(this.stickyPanel),this.main.add(this.editable)}}class Jl extends Mc{constructor(t,e){super(e),nn(t)&&(this.sourceElement=t),this.data.processor=new Rc(this.data.viewDocument),this.model.document.createRoot();const n=!this.config.get("toolbar.shouldNotGroupWhenFull"),i=new Ql(this.locale,this.editing.view,{shouldToolbarGroupWhenFull:n});this.ui=new qc(this,i),function(t){if(!z(t.updateSourceElement))throw new hn.b("attachtoform-missing-elementapi-interface: Editor passed to attachToForm() must implement ElementApi.",t);const e=t.sourceElement;if(e&&"textarea"===e.tagName.toLowerCase()&&e.form){let n;const i=e.form,o=()=>t.updateSourceElement();z(i.submit)&&(n=i.submit,i.submit=()=>{o(),n.apply(i)}),i.addEventListener("submit",o),t.on("destroy",()=>{i.removeEventListener("submit",o),n&&(i.submit=n)})}}(this)}destroy(){return this.sourceElement&&this.updateSourceElement(),this.ui.destroy(),super.destroy()}static create(t,e={}){return new Promise(n=>{const i=new this(t,e);n(i.initPlugins().then(()=>i.ui.init(nn(t)?t:null)).then(()=>{if(!nn(t)&&e.initialData)throw new hn.b("editor-create-initial-data: The config.initialData option cannot be used together with initial data passed in Editor.create().",null);const n=e.initialData||function(t){return nn(t)?(e=t,e instanceof HTMLTextAreaElement?e.value:e.innerHTML):t;var e}(t);return i.data.init(n)}).then(()=>i.fire("ready")).then(()=>i))})}}xn(Jl,Ic),xn(Jl,Nc);class Zl{constructor(t){this.editor=t,this.set("isEnabled",!0),this._disableStack=new Set}forceDisabled(t){this._disableStack.add(t),1==this._disableStack.size&&(this.on("set:isEnabled",Xl,{priority:"highest"}),this.isEnabled=!1)}clearForceDisabled(t){this._disableStack.delete(t),0==this._disableStack.size&&(this.off("set:isEnabled",Xl),this.isEnabled=!0)}destroy(){this.stopListening()}static get isContextPlugin(){return!1}}function Xl(t){t.return=!1,t.stop()}xn(Zl,Ui);class td{constructor(t){this.files=function(t){const e=t.files?Array.from(t.files):[],n=t.items?Array.from(t.items):[];if(e.length)return e;return n.filter(t=>"file"===t.kind).map(t=>t.getAsFile())}(t),this._native=t}get types(){return this._native.types}getData(t){return this._native.getData(t)}setData(t,e){this._native.setData(t,e)}}class ed extends Dr{constructor(t){super(t);const e=this.document;function n(t,n){n.preventDefault();const i=n.dropRange?[n.dropRange]:Array.from(e.selection.getRanges()),o=new cn(e,"clipboardInput");e.fire(o,{dataTransfer:n.dataTransfer,targetRanges:i}),o.stop.called&&n.stopPropagation()}this.domEventType=["paste","copy","cut","drop","dragover"],this.listenTo(e,"paste",n,{priority:"low"}),this.listenTo(e,"drop",n,{priority:"low"})}onDomEvent(t){const e={dataTransfer:new td(t.clipboardData?t.clipboardData:t.dataTransfer)};"drop"==t.type&&(e.dropRange=function(t,e){const n=e.target.ownerDocument,i=e.clientX,o=e.clientY;let r;n.caretRangeFromPoint&&n.caretRangeFromPoint(i,o)?r=n.caretRangeFromPoint(i,o):e.rangeParent&&(r=n.createRange(),r.setStart(e.rangeParent,e.rangeOffset),r.collapse(!0));return r?t.domConverter.domRangeToView(r):t.document.selection.getFirstRange()}(this.view,t)),this.fire(t.type,t,e)}}const nd=["figcaption","li"];class id extends Zl{static get pluginName(){return"Clipboard"}init(){const t=this.editor,e=t.model.document,n=t.editing.view,i=n.document;function o(n,o){const r=o.dataTransfer;o.preventDefault();const s=t.data.toView(t.model.getSelectedContent(e.selection));i.fire("clipboardOutput",{dataTransfer:r,content:s,method:n.name})}this._htmlDataProcessor=new Rc(i),n.addObserver(ed),this.listenTo(i,"clipboardInput",e=>{t.isReadOnly&&e.stop()},{priority:"highest"}),this.listenTo(i,"clipboardInput",(t,e)=>{const i=e.dataTransfer;let o="";var r;i.getData("text/html")?o=function(t){return t.replace(/<span(?: class="Apple-converted-space"|)>(\s+)<\/span>/g,(t,e)=>1==e.length?" ":e)}(i.getData("text/html")):i.getData("text/plain")&&((r=(r=i.getData("text/plain")).replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/\n/g,"</p><p>").replace(/^\s/,"&nbsp;").replace(/\s$/,"&nbsp;").replace(/\s\s/g," &nbsp;")).indexOf("</p><p>")>-1&&(r=`<p>${r}</p>`),o=r),o=this._htmlDataProcessor.toView(o);const s=new cn(this,"inputTransformation");this.fire(s,{content:o,dataTransfer:i}),s.stop.called&&t.stop(),n.scrollToTheSelection()},{priority:"low"}),this.listenTo(this,"inputTransformation",(t,e)=>{if(!e.content.isEmpty){const n=this.editor.data,i=this.editor.model,o=n.toModel(e.content,"$clipboardHolder");if(0==o.childCount)return;i.insertContent(o),t.stop()}},{priority:"low"}),this.listenTo(i,"copy",o,{priority:"low"}),this.listenTo(i,"cut",(e,n)=>{t.isReadOnly?n.preventDefault():o(e,n)},{priority:"low"}),this.listenTo(i,"clipboardOutput",(n,i)=>{i.content.isEmpty||(i.dataTransfer.setData("text/html",this._htmlDataProcessor.toData(i.content)),i.dataTransfer.setData("text/plain",function t(e){let n="";if(e.is("text")||e.is("textProxy"))n=e.data;else if(e.is("img")&&e.hasAttribute("alt"))n=e.getAttribute("alt");else{let i=null;for(const o of e.getChildren()){const e=t(o);i&&(i.is("containerElement")||o.is("containerElement"))&&(nd.includes(i.name)||nd.includes(o.name)?n+="\n":n+="\n\n"),n+=e,i=o}}return n}(i.content))),"cut"==i.method&&t.model.deleteContent(e.selection)},{priority:"low"})}}class od{constructor(t){this.editor=t,this.set("value",void 0),this.set("isEnabled",!1),this._disableStack=new Set,this.decorate("execute"),this.listenTo(this.editor.model.document,"change",()=>{this.refresh()}),this.on("execute",t=>{this.isEnabled||t.stop()},{priority:"high"}),this.listenTo(t,"change:isReadOnly",(t,e,n)=>{n?this.forceDisabled("readOnlyMode"):this.clearForceDisabled("readOnlyMode")})}refresh(){this.isEnabled=!0}forceDisabled(t){this._disableStack.add(t),1==this._disableStack.size&&(this.on("set:isEnabled",rd,{priority:"highest"}),this.isEnabled=!1)}clearForceDisabled(t){this._disableStack.delete(t),0==this._disableStack.size&&(this.off("set:isEnabled",rd),this.refresh())}execute(){}destroy(){this.stopListening()}}function rd(t){t.return=!1,t.stop()}function*sd(t,e){for(const n of e)n&&t.getAttributeProperties(n[0]).copyOnEnter&&(yield n)}xn(od,Ui);class ad extends od{execute(){const t=this.editor.model,e=t.document;t.change(n=>{!function(t,e,n,i){const o=n.isCollapsed,r=n.getFirstRange(),s=r.start.parent,a=r.end.parent;if(i.isLimit(s)||i.isLimit(a))return void(o||s!=a||t.deleteContent(n));if(o){const t=sd(e.model.schema,n.getAttributes());cd(e,r.start),e.setSelectionAttribute(t)}else{const i=!(r.start.isAtStart&&r.end.isAtEnd),o=s==a;t.deleteContent(n,{leaveUnmerged:i}),i&&(o?cd(e,n.focus):e.setSelection(a,0))}}(this.editor.model,n,e.selection,t.schema),this.fire("afterExecute",{writer:n})})}}function cd(t,e){t.split(e),t.setSelection(e.parent.nextSibling,0)}class ld extends gr{constructor(t){super(t);const e=this.document;e.on("keydown",(t,n)=>{if(this.isEnabled&&n.keyCode==mo.enter){let i;e.once("enter",t=>i=t,{priority:"highest"}),e.fire("enter",new Rr(e,n.domEvent,{isSoft:n.shiftKey})),i&&i.stop.called&&t.stop()}})}observe(){}}class dd extends Zl{static get pluginName(){return"Enter"}init(){const t=this.editor,e=t.editing.view,n=e.document;e.addObserver(ld),t.commands.add("enter",new ad(t)),this.listenTo(n,"enter",(n,i)=>{i.preventDefault(),i.isSoft||(t.execute("enter"),e.scrollToTheSelection())},{priority:"low"})}}class ud extends od{execute(){const t=this.editor.model,e=t.document;t.change(n=>{!function(t,e,n){const i=n.isCollapsed,o=n.getFirstRange(),r=o.start.parent,s=o.end.parent,a=r==s;if(i){const i=sd(t.schema,n.getAttributes());hd(t,e,o.end),e.removeSelectionAttribute(n.getAttributeKeys()),e.setSelectionAttribute(i)}else{const i=!(o.start.isAtStart&&o.end.isAtEnd);t.deleteContent(n,{leaveUnmerged:i}),a?hd(t,e,n.focus):i&&e.setSelection(s,0)}}(t,n,e.selection),this.fire("afterExecute",{writer:n})})}refresh(){const t=this.editor.model,e=t.document;this.isEnabled=function(t,e){if(e.rangeCount>1)return!1;const n=e.anchor;if(!n||!t.checkChild(n,"softBreak"))return!1;const i=e.getFirstRange(),o=i.start.parent,r=i.end.parent;if((fd(o,t)||fd(r,t))&&o!==r)return!1;return!0}(t.schema,e.selection)}}function hd(t,e,n){const i=e.createElement("softBreak");t.insertContent(i,n),e.setSelection(i,"after")}function fd(t,e){return!t.is("rootElement")&&(e.isLimit(t)||fd(t.parent,e))}class gd extends Zl{static get pluginName(){return"ShiftEnter"}init(){const t=this.editor,e=t.model.schema,n=t.conversion,i=t.editing.view,o=i.document;e.register("softBreak",{allowWhere:"$text",isInline:!0}),n.for("upcast").elementToElement({model:"softBreak",view:"br"}),n.for("downcast").elementToElement({model:"softBreak",view:(t,e)=>e.createEmptyElement("br")}),i.addObserver(ld),t.commands.add("shiftEnter",new ud(t)),this.listenTo(o,"enter",(e,n)=>{n.preventDefault(),n.isSoft&&(t.execute("shiftEnter"),i.scrollToTheSelection())},{priority:"low"})}}class md extends od{execute(){const t=this.editor.model,e=t.document.selection;let n=t.schema.getLimitElement(e);if(e.containsEntireContent(n)||!pd(t.schema,n))do{if(n=n.parent,!n)return}while(!pd(t.schema,n));t.change(t=>{t.setSelection(n,"in")})}}function pd(t,e){return t.isLimit(e)&&(t.checkChild(e,"$text")||t.checkChild(e,"paragraph"))}const bd=bo("Ctrl+A");class wd extends Zl{static get pluginName(){return"SelectAllEditing"}init(){const t=this.editor,e=t.editing.view.document;t.commands.add("selectAll",new md(t)),this.listenTo(e,"keydown",(e,n)=>{po(n)===bd&&(t.execute("selectAll"),n.preventDefault())})}}class kd extends Zl{static get pluginName(){return"SelectAllUI"}init(){const t=this.editor;t.ui.componentFactory.add("selectAll",e=>{const n=t.commands.get("selectAll"),i=new Ll(e),o=e.t;return i.set({label:o("Select all"),icon:'<svg width="20" height="20" xmlns="http://www.w3.org/2000/svg"><path d="M.75 15.5a.75.75 0 0 1 .75.75V18l.008.09A.5.5 0 0 0 2 18.5h1.75a.75.75 0 1 1 0 1.5H1.5l-.144-.007a1.5 1.5 0 0 1-1.35-1.349L0 18.5v-2.25a.75.75 0 0 1 .75-.75zm18.5 0a.75.75 0 0 1 .75.75v2.25l-.007.144a1.5 1.5 0 0 1-1.349 1.35L18.5 20h-2.25a.75.75 0 1 1 0-1.5H18a.5.5 0 0 0 .492-.41L18.5 18v-1.75a.75.75 0 0 1 .75-.75zm-10.45 3c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2H7.2a.2.2 0 0 1-.2-.2v-1.1c0-.11.09-.2.2-.2h1.6zm4 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2h-1.6a.2.2 0 0 1-.2-.2v-1.1c0-.11.09-.2.2-.2h1.6zm.45-5.5a.75.75 0 1 1 0 1.5h-8.5a.75.75 0 1 1 0-1.5h8.5zM1.3 11c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2H.2a.2.2 0 0 1-.2-.2v-1.6c0-.11.09-.2.2-.2h1.1zm18.5 0c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2h-1.1a.2.2 0 0 1-.2-.2v-1.6c0-.11.09-.2.2-.2h1.1zm-4.55-2a.75.75 0 1 1 0 1.5H4.75a.75.75 0 1 1 0-1.5h10.5zM1.3 7c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2H.2a.2.2 0 0 1-.2-.2V7.2c0-.11.09-.2.2-.2h1.1zm18.5 0c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2h-1.1a.2.2 0 0 1-.2-.2V7.2c0-.11.09-.2.2-.2h1.1zm-4.55-2a.75.75 0 1 1 0 1.5h-2.5a.75.75 0 1 1 0-1.5h2.5zm-5 0a.75.75 0 1 1 0 1.5h-5.5a.75.75 0 0 1 0-1.5h5.5zm-6.5-5a.75.75 0 0 1 0 1.5H2a.5.5 0 0 0-.492.41L1.5 2v1.75a.75.75 0 0 1-1.5 0V1.5l.007-.144A1.5 1.5 0 0 1 1.356.006L1.5 0h2.25zM18.5 0l.144.007a1.5 1.5 0 0 1 1.35 1.349L20 1.5v2.25a.75.75 0 1 1-1.5 0V2l-.008-.09A.5.5 0 0 0 18 1.5h-1.75a.75.75 0 1 1 0-1.5h2.25zM8.8 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2H7.2a.2.2 0 0 1-.2-.2V.2c0-.11.09-.2.2-.2h1.6zm4 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2h-1.6a.2.2 0 0 1-.2-.2V.2c0-.11.09-.2.2-.2h1.6z"/></svg>',keystroke:"Ctrl+A",tooltip:!0}),i.bind("isOn","isEnabled").to(n,"value","isEnabled"),this.listenTo(i,"execute",()=>{t.execute("selectAll"),t.editing.view.focus()}),i})}}class _d extends Zl{static get requires(){return[wd,kd]}static get pluginName(){return"SelectAll"}}class vd{constructor(t,e=20){this.model=t,this.size=0,this.limit=e,this.isLocked=!1,this._changeCallback=(t,e)=>{"transparent"!=e.type&&e!==this._batch&&this._reset(!0)},this._selectionChangeCallback=()=>{this._reset()},this.model.document.on("change",this._changeCallback),this.model.document.selection.on("change:range",this._selectionChangeCallback),this.model.document.selection.on("change:attribute",this._selectionChangeCallback)}get batch(){return this._batch||(this._batch=this.model.createBatch()),this._batch}input(t){this.size+=t,this.size>=this.limit&&this._reset(!0)}lock(){this.isLocked=!0}unlock(){this.isLocked=!1}destroy(){this.model.document.off("change",this._changeCallback),this.model.document.selection.off("change:range",this._selectionChangeCallback),this.model.document.selection.off("change:attribute",this._selectionChangeCallback)}_reset(t){this.isLocked&&!t||(this._batch=null,this.size=0)}}class yd extends od{constructor(t,e){super(t),this._buffer=new vd(t.model,e),this._batches=new WeakSet}get buffer(){return this._buffer}destroy(){super.destroy(),this._buffer.destroy()}execute(t={}){const e=this.editor.model,n=e.document,i=t.text||"",o=i.length,r=t.range?e.createSelection(t.range):n.selection,s=t.resultRange;e.enqueueChange(this._buffer.batch,t=>{this._buffer.lock(),e.deleteContent(r),i&&e.insertContent(t.createText(i,n.selection.getAttributes()),r),s?t.setSelection(s):r.is("documentSelection")||t.setSelection(r),this._buffer.unlock(),this._buffer.input(o),this._batches.add(this._buffer.batch)})}}const xd=[po("arrowUp"),po("arrowRight"),po("arrowDown"),po("arrowLeft"),9,16,17,18,19,20,27,33,34,35,36,45,91,93,144,145,173,174,175,176,177,178,179,255];for(let t=112;t<=135;t++)xd.push(t);function Ad(t){return!!t.ctrlKey||xd.includes(t.keyCode)}function Cd(t){if(t.newChildren.length-t.oldChildren.length!=1)return;const e=function(t,e){const n=[];let i,o=0;return t.forEach(t=>{"equal"==t?(r(),o++):"insert"==t?(s("insert")?i.values.push(e[o]):(r(),i={type:"insert",index:o,values:[e[o]]}),o++):s("delete")?i.howMany++:(r(),i={type:"delete",index:o,howMany:1})}),r(),n;function r(){i&&(n.push(i),i=null)}function s(t){return i&&i.type==t}}($o(t.oldChildren,t.newChildren,Td),t.newChildren);if(e.length>1)return;const n=e[0];return n.values[0]&&n.values[0].is("text")?n:void 0}function Td(t,e){return t&&t.is("text")&&e&&e.is("text")?t.data===e.data:t===e}class Pd{constructor(t){this.editor=t,this.editing=this.editor.editing}handle(t,e){if(function(t){if(0==t.length)return!1;for(const e of t)if("children"===e.type&&!Cd(e))return!0;return!1}(t))this._handleContainerChildrenMutations(t,e);else for(const n of t)this._handleTextMutation(n,e),this._handleTextNodeInsertion(n)}_handleContainerChildrenMutations(t,e){const n=function(t){const e=t.map(t=>t.node).reduce((t,e)=>t.getCommonAncestor(e,{includeSelf:!0}));if(!e)return;return e.getAncestors({includeSelf:!0,parentFirst:!0}).find(t=>t.is("containerElement")||t.is("rootElement"))}(t);if(!n)return;const i=this.editor.editing.view.domConverter.mapViewToDom(n),o=new sr(this.editor.editing.view.document),r=this.editor.data.toModel(o.domToView(i)).getChild(0),s=this.editor.editing.mapper.toModelElement(n);if(!s)return;const a=Array.from(r.getChildren()),c=Array.from(s.getChildren()),l=a[a.length-1],d=c[c.length-1];l&&l.is("softBreak")&&d&&!d.is("softBreak")&&a.pop();const u=this.editor.model.schema;if(!Sd(a,u)||!Sd(c,u))return;const h=a.map(t=>t.is("text")?t.data:"@").join("").replace(/\u00A0/g," "),f=c.map(t=>t.is("text")?t.data:"@").join("").replace(/\u00A0/g," ");if(f===h)return;const g=$o(f,h),{firstChangeAt:m,insertions:p,deletions:b}=Ed(g);let w=null;e&&(w=this.editing.mapper.toModelRange(e.getFirstRange()));const k=h.substr(m,p),_=this.editor.model.createRange(this.editor.model.createPositionAt(s,m),this.editor.model.createPositionAt(s,m+b));this.editor.execute("input",{text:k,range:_,resultRange:w})}_handleTextMutation(t,e){if("text"!=t.type)return;const n=t.newText.replace(/\u00A0/g," "),i=t.oldText.replace(/\u00A0/g," ");if(i===n)return;const o=$o(i,n),{firstChangeAt:r,insertions:s,deletions:a}=Ed(o);let c=null;e&&(c=this.editing.mapper.toModelRange(e.getFirstRange()));const l=this.editing.view.createPositionAt(t.node,r),d=this.editing.mapper.toModelPosition(l),u=this.editor.model.createRange(d,d.getShiftedBy(a)),h=n.substr(r,s);this.editor.execute("input",{text:h,range:u,resultRange:c})}_handleTextNodeInsertion(t){if("children"!=t.type)return;const e=Cd(t),n=this.editing.view.createPositionAt(t.node,e.index),i=this.editing.mapper.toModelPosition(n),o=e.values[0].data;this.editor.execute("input",{text:o.replace(/\u00A0/g," "),range:this.editor.model.createRange(i)})}}function Sd(t,e){return t.every(t=>e.isInline(t))}function Ed(t){let e=null,n=null;for(let i=0;i<t.length;i++){"equal"!=t[i]&&(e=null===e?i:e,n=i)}let i=0,o=0;for(let r=e;r<=n;r++)"insert"!=t[r]&&i++,"delete"!=t[r]&&o++;return{insertions:o,deletions:i,firstChangeAt:e}}class Md extends Zl{static get pluginName(){return"Input"}init(){const t=this.editor,e=new yd(t,t.config.get("typing.undoStep")||20);t.commands.add("input",e),function(t){let e=null;const n=t.model,i=t.editing.view,o=t.commands.get("input");function r(t){const r=n.document,a=i.document.isComposing,c=e&&e.isEqual(r.selection);e=null,o.isEnabled&&(Ad(t)||r.selection.isCollapsed||a&&229===t.keyCode||!a&&229===t.keyCode&&c||s())}function s(){const t=o.buffer;t.lock(),n.enqueueChange(t.batch,()=>{n.deleteContent(n.document.selection)}),t.unlock()}ho.isAndroid?i.document.on("beforeinput",(t,e)=>r(e),{priority:"lowest"}):i.document.on("keydown",(t,e)=>r(e),{priority:"lowest"}),i.document.on("compositionstart",(function(){const t=n.document,e=1!==t.selection.rangeCount||t.selection.getFirstRange().isFlat;if(t.selection.isCollapsed||e)return;s()}),{priority:"lowest"}),i.document.on("compositionend",()=>{e=n.createSelection(n.document.selection)},{priority:"lowest"})}(t),function(t){t.editing.view.document.on("mutations",(e,n,i)=>{new Pd(t).handle(n,i)})}(t)}isInput(t){return this.editor.commands.get("input")._batches.has(t)}}class Id extends od{constructor(t,e){super(t),this.direction=e,this._buffer=new vd(t.model,t.config.get("typing.undoStep"))}get buffer(){return this._buffer}execute(t={}){const e=this.editor.model,n=e.document;e.enqueueChange(this._buffer.batch,i=>{this._buffer.lock();const o=i.createSelection(t.selection||n.selection),r=o.isCollapsed;if(o.isCollapsed&&e.modifySelection(o,{direction:this.direction,unit:t.unit}),this._shouldEntireContentBeReplacedWithParagraph(t.sequence||1))return void this._replaceEntireContentWithParagraph(i);if(o.isCollapsed)return;let s=0;o.getFirstRange().getMinimalFlatRanges().forEach(t=>{s+=eo(t.getWalker({singleCharacters:!0,ignoreElementEnd:!0,shallow:!0}))}),e.deleteContent(o,{doNotResetEntireContent:r,direction:this.direction}),this._buffer.input(s),i.setSelection(o),this._buffer.unlock()})}_shouldEntireContentBeReplacedWithParagraph(t){if(t>1)return!1;const e=this.editor.model,n=e.document.selection,i=e.schema.getLimitElement(n);if(!(n.isCollapsed&&n.containsEntireContent(i)))return!1;if(!e.schema.checkChild(i,"paragraph"))return!1;const o=i.getChild(0);return!o||"paragraph"!==o.name}_replaceEntireContentWithParagraph(t){const e=this.editor.model,n=e.document.selection,i=e.schema.getLimitElement(n),o=t.createElement("paragraph");t.remove(t.createRangeIn(i)),t.insert(o,i),t.setSelection(o,0)}}class Nd extends gr{constructor(t){super(t);const e=t.document;let n=0;function i(t,n,i){let o;e.once("delete",t=>o=t,{priority:Number.POSITIVE_INFINITY}),e.fire("delete",new Rr(e,n,i)),o&&o.stop.called&&t.stop()}e.on("keyup",(t,e)=>{e.keyCode!=mo.delete&&e.keyCode!=mo.backspace||(n=0)}),e.on("keydown",(t,e)=>{const o={};if(e.keyCode==mo.delete)o.direction="forward",o.unit="character";else{if(e.keyCode!=mo.backspace)return;o.direction="backward",o.unit="codePoint"}const r=ho.isMac?e.altKey:e.ctrlKey;o.unit=r?"word":o.unit,o.sequence=++n,i(t,e.domEvent,o)}),ho.isAndroid&&e.on("beforeinput",(e,n)=>{if("deleteContentBackward"!=n.domEvent.inputType)return;const o={unit:"codepoint",direction:"backward",sequence:1},r=n.domTarget.ownerDocument.defaultView.getSelection();r.anchorNode==r.focusNode&&r.anchorOffset+1!=r.focusOffset&&(o.selectionToRemove=t.domConverter.domSelectionToView(r)),i(e,n.domEvent,o)})}observe(){}}class Od extends Zl{static get pluginName(){return"Delete"}init(){const t=this.editor,e=t.editing.view,n=e.document;if(e.addObserver(Nd),t.commands.add("forwardDelete",new Id(t,"forward")),t.commands.add("delete",new Id(t,"backward")),this.listenTo(n,"delete",(n,i)=>{const o={unit:i.unit,sequence:i.sequence};if(i.selectionToRemove){const e=t.model.createSelection(),n=[];for(const e of i.selectionToRemove.getRanges())n.push(t.editing.mapper.toModelRange(e));e.setTo(n),o.selection=e}t.execute("forward"==i.direction?"forwardDelete":"delete",o),i.preventDefault(),e.scrollToTheSelection()}),ho.isAndroid){let t=null;this.listenTo(n,"delete",(e,n)=>{const i=n.domTarget.ownerDocument.defaultView.getSelection();t={anchorNode:i.anchorNode,anchorOffset:i.anchorOffset,focusNode:i.focusNode,focusOffset:i.focusOffset}},{priority:"lowest"}),this.listenTo(n,"keyup",(e,n)=>{if(t){const e=n.domTarget.ownerDocument.defaultView.getSelection();e.collapse(t.anchorNode,t.anchorOffset),e.extend(t.focusNode,t.focusOffset),t=null}})}}}class Rd extends Zl{static get requires(){return[Md,Od]}static get pluginName(){return"Typing"}}const Dd=new Map;function Ld(t,e,n){let i=Dd.get(t);i||(i=new Map,Dd.set(t,i)),i.set(e,n)}function jd(t){return[t]}function Vd(t,e,n={}){const i=function(t,e){const n=Dd.get(t);return n&&n.has(e)?n.get(e):jd}(t.constructor,e.constructor);try{return i(t=t.clone(),e,n)}catch(t){throw t}}function zd(t,e,n){t=t.slice(),e=e.slice();const i=new Bd(n.document,n.useRelations,n.forceWeakRemove);i.setOriginalOperations(t),i.setOriginalOperations(e);const o=i.originalOperations;if(0==t.length||0==e.length)return{operationsA:t,operationsB:e,originalOperations:o};const r=new WeakMap;for(const e of t)r.set(e,0);const s={nextBaseVersionA:t[t.length-1].baseVersion+1,nextBaseVersionB:e[e.length-1].baseVersion+1,originalOperationsACount:t.length,originalOperationsBCount:e.length};let a=0;for(;a<t.length;){const n=t[a],o=r.get(n);if(o==e.length){a++;continue}const s=e[o],c=Vd(n,s,i.getContext(n,s,!0)),l=Vd(s,n,i.getContext(s,n,!1));i.updateRelation(n,s),i.setOriginalOperations(c,n),i.setOriginalOperations(l,s);for(const t of c)r.set(t,o+l.length);t.splice(a,1,...c),e.splice(o,1,...l)}if(n.padWithNoOps){const n=t.length-s.originalOperationsACount,i=e.length-s.originalOperationsBCount;Ud(t,i-n),Ud(e,n-i)}return Fd(t,s.nextBaseVersionB),Fd(e,s.nextBaseVersionA),{operationsA:t,operationsB:e,originalOperations:o}}class Bd{constructor(t,e,n=!1){this.originalOperations=new Map,this._history=t.history,this._useRelations=e,this._forceWeakRemove=!!n,this._relations=new Map}setOriginalOperations(t,e=null){const n=e?this.originalOperations.get(e):null;for(const e of t)this.originalOperations.set(e,n||e)}updateRelation(t,e){switch(t.constructor){case ja:switch(e.constructor){case Ua:t.targetPosition.isEqual(e.sourcePosition)||e.movedRange.containsPosition(t.targetPosition)?this._setRelation(t,e,"insertAtSource"):t.targetPosition.isEqual(e.deletionPosition)?this._setRelation(t,e,"insertBetween"):t.targetPosition.isAfter(e.sourcePosition)&&this._setRelation(t,e,"moveTargetAfter");break;case ja:t.targetPosition.isEqual(e.sourcePosition)||t.targetPosition.isBefore(e.sourcePosition)?this._setRelation(t,e,"insertBefore"):this._setRelation(t,e,"insertAfter")}break;case Ha:switch(e.constructor){case Ua:t.splitPosition.isBefore(e.sourcePosition)&&this._setRelation(t,e,"splitBefore");break;case ja:(t.splitPosition.isEqual(e.sourcePosition)||t.splitPosition.isBefore(e.sourcePosition))&&this._setRelation(t,e,"splitBefore")}break;case Ua:switch(e.constructor){case Ua:t.targetPosition.isEqual(e.sourcePosition)||this._setRelation(t,e,"mergeTargetNotMoved"),t.sourcePosition.isEqual(e.targetPosition)&&this._setRelation(t,e,"mergeSourceNotMoved"),t.sourcePosition.isEqual(e.sourcePosition)&&this._setRelation(t,e,"mergeSameElement");break;case Ha:t.sourcePosition.isEqual(e.splitPosition)&&this._setRelation(t,e,"splitAtSource")}break;case za:{const n=t.newRange;if(!n)return;switch(e.constructor){case ja:{const i=Ts._createFromPositionAndShift(e.sourcePosition,e.howMany),o=i.containsPosition(n.start)||i.start.isEqual(n.start),r=i.containsPosition(n.end)||i.end.isEqual(n.end);!o&&!r||i.containsRange(n)||this._setRelation(t,e,{side:o?"left":"right",path:o?n.start.path.slice():n.end.path.slice()});break}case Ua:{const i=n.start.isEqual(e.targetPosition),o=n.start.isEqual(e.deletionPosition),r=n.end.isEqual(e.deletionPosition),s=n.end.isEqual(e.sourcePosition);(i||o||r||s)&&this._setRelation(t,e,{wasInLeftElement:i,wasStartBeforeMergedElement:o,wasEndBeforeMergedElement:r,wasInRightElement:s});break}}break}}}getContext(t,e,n){return{aIsStrong:n,aWasUndone:this._wasUndone(t),bWasUndone:this._wasUndone(e),abRelation:this._useRelations?this._getRelation(t,e):null,baRelation:this._useRelations?this._getRelation(e,t):null,forceWeakRemove:this._forceWeakRemove}}_wasUndone(t){const e=this.originalOperations.get(t);return e.wasUndone||this._history.isUndoneOperation(e)}_getRelation(t,e){const n=this.originalOperations.get(e),i=this._history.getUndoneOperation(n);if(!i)return null;const o=this.originalOperations.get(t),r=this._relations.get(o);return r&&r.get(i)||null}_setRelation(t,e,n){const i=this.originalOperations.get(t),o=this.originalOperations.get(e);let r=this._relations.get(i);r||(r=new Map,this._relations.set(i,r)),r.set(o,n)}}function Fd(t,e){for(const n of t)n.baseVersion=e++}function Ud(t,e){for(let n=0;n<e;n++)t.push(new cc(0))}function Hd(t,e,n){const i=t.nodes.getNode(0).getAttribute(e);if(i==n)return null;const o=new Ts(t.position,t.position.getShiftedBy(t.howMany));return new Da(o,e,i,n,0)}function Wd(t,e){return null===t.targetPosition._getTransformedByDeletion(e.sourcePosition,e.howMany)}function qd(t,e){const n=[];for(let i=0;i<t.length;i++){const o=t[i],r=new ja(o.start,o.end.offset-o.start.offset,e,0);n.push(r);for(let e=i+1;e<t.length;e++)t[e]=t[e]._getTransformedByMove(r.sourcePosition,r.targetPosition,r.howMany)[0];e=e._getTransformedByMove(r.sourcePosition,r.targetPosition,r.howMany)}return n}Ld(Da,Da,(t,e,n)=>{if(t.key===e.key&&t.range.start.hasSameParentAs(e.range.start)){const i=t.range.getDifference(e.range).map(e=>new Da(e,t.key,t.oldValue,t.newValue,0)),o=t.range.getIntersection(e.range);return o&&n.aIsStrong&&i.push(new Da(o,e.key,e.newValue,t.newValue,0)),0==i.length?[new cc(0)]:i}return[t]}),Ld(Da,Va,(t,e)=>{if(t.range.start.hasSameParentAs(e.position)&&t.range.containsPosition(e.position)){const n=t.range._getTransformedByInsertion(e.position,e.howMany,!e.shouldReceiveAttributes).map(e=>new Da(e,t.key,t.oldValue,t.newValue,t.baseVersion));if(e.shouldReceiveAttributes){const i=Hd(e,t.key,t.oldValue);i&&n.unshift(i)}return n}return t.range=t.range._getTransformedByInsertion(e.position,e.howMany,!1)[0],[t]}),Ld(Da,Ua,(t,e)=>{const n=[];t.range.start.hasSameParentAs(e.deletionPosition)&&(t.range.containsPosition(e.deletionPosition)||t.range.start.isEqual(e.deletionPosition))&&n.push(Ts._createFromPositionAndShift(e.graveyardPosition,1));const i=t.range._getTransformedByMergeOperation(e);return i.isCollapsed||n.push(i),n.map(e=>new Da(e,t.key,t.oldValue,t.newValue,t.baseVersion))}),Ld(Da,ja,(t,e)=>function(t,e){const n=Ts._createFromPositionAndShift(e.sourcePosition,e.howMany);let i=null,o=[];n.containsRange(t,!0)?i=t:t.start.hasSameParentAs(n.start)?(o=t.getDifference(n),i=t.getIntersection(n)):o=[t];const r=[];for(let t of o){t=t._getTransformedByDeletion(e.sourcePosition,e.howMany);const n=e.getMovedRangeStart(),i=t.start.hasSameParentAs(n);t=t._getTransformedByInsertion(n,e.howMany,i),r.push(...t)}i&&r.push(i._getTransformedByMove(e.sourcePosition,e.targetPosition,e.howMany,!1)[0]);return r}(t.range,e).map(e=>new Da(e,t.key,t.oldValue,t.newValue,t.baseVersion))),Ld(Da,Ha,(t,e)=>{if(t.range.end.isEqual(e.insertionPosition))return e.graveyardPosition||t.range.end.offset++,[t];if(t.range.start.hasSameParentAs(e.splitPosition)&&t.range.containsPosition(e.splitPosition)){const n=t.clone();return n.range=new Ts(e.moveTargetPosition.clone(),t.range.end._getCombined(e.splitPosition,e.moveTargetPosition)),t.range.end=e.splitPosition.clone(),t.range.end.stickiness="toPrevious",[t,n]}return t.range=t.range._getTransformedBySplitOperation(e),[t]}),Ld(Va,Da,(t,e)=>{const n=[t];if(t.shouldReceiveAttributes&&t.position.hasSameParentAs(e.range.start)&&e.range.containsPosition(t.position)){const i=Hd(t,e.key,e.newValue);i&&n.push(i)}return n}),Ld(Va,Va,(t,e,n)=>(t.position.isEqual(e.position)&&n.aIsStrong||(t.position=t.position._getTransformedByInsertOperation(e)),[t])),Ld(Va,ja,(t,e)=>(t.position=t.position._getTransformedByMoveOperation(e),[t])),Ld(Va,Ha,(t,e)=>(t.position=t.position._getTransformedBySplitOperation(e),[t])),Ld(Va,Ua,(t,e)=>(t.position=t.position._getTransformedByMergeOperation(e),[t])),Ld(za,Va,(t,e)=>(t.oldRange&&(t.oldRange=t.oldRange._getTransformedByInsertOperation(e)[0]),t.newRange&&(t.newRange=t.newRange._getTransformedByInsertOperation(e)[0]),[t])),Ld(za,za,(t,e,n)=>{if(t.name==e.name){if(!n.aIsStrong)return[new cc(0)];t.oldRange=e.newRange?e.newRange.clone():null}return[t]}),Ld(za,Ua,(t,e)=>(t.oldRange&&(t.oldRange=t.oldRange._getTransformedByMergeOperation(e)),t.newRange&&(t.newRange=t.newRange._getTransformedByMergeOperation(e)),[t])),Ld(za,ja,(t,e,n)=>{if(t.oldRange&&(t.oldRange=Ts._createFromRanges(t.oldRange._getTransformedByMoveOperation(e))),t.newRange){if(n.abRelation){const i=Ts._createFromRanges(t.newRange._getTransformedByMoveOperation(e));if("left"==n.abRelation.side&&e.targetPosition.isEqual(t.newRange.start))return t.newRange.start.path=n.abRelation.path,t.newRange.end=i.end,[t];if("right"==n.abRelation.side&&e.targetPosition.isEqual(t.newRange.end))return t.newRange.start=i.start,t.newRange.end.path=n.abRelation.path,[t]}t.newRange=Ts._createFromRanges(t.newRange._getTransformedByMoveOperation(e))}return[t]}),Ld(za,Ha,(t,e,n)=>{if(t.oldRange&&(t.oldRange=t.oldRange._getTransformedBySplitOperation(e)),t.newRange){if(n.abRelation){const i=t.newRange._getTransformedBySplitOperation(e);return t.newRange.start.isEqual(e.splitPosition)&&n.abRelation.wasStartBeforeMergedElement?t.newRange.start=ys._createAt(e.insertionPosition):t.newRange.start.isEqual(e.splitPosition)&&!n.abRelation.wasInLeftElement&&(t.newRange.start=ys._createAt(e.moveTargetPosition)),t.newRange.end.isEqual(e.splitPosition)&&n.abRelation.wasInRightElement?t.newRange.end=ys._createAt(e.moveTargetPosition):t.newRange.end.isEqual(e.splitPosition)&&n.abRelation.wasEndBeforeMergedElement?t.newRange.end=ys._createAt(e.insertionPosition):t.newRange.end=i.end,[t]}t.newRange=t.newRange._getTransformedBySplitOperation(e)}return[t]}),Ld(Ua,Va,(t,e)=>(t.sourcePosition.hasSameParentAs(e.position)&&(t.howMany+=e.howMany),t.sourcePosition=t.sourcePosition._getTransformedByInsertOperation(e),t.targetPosition=t.targetPosition._getTransformedByInsertOperation(e),[t])),Ld(Ua,Ua,(t,e,n)=>{if(t.sourcePosition.isEqual(e.sourcePosition)&&t.targetPosition.isEqual(e.targetPosition)){if(n.bWasUndone){const n=e.graveyardPosition.path.slice();return n.push(0),t.sourcePosition=new ys(e.graveyardPosition.root,n),t.howMany=0,[t]}return[new cc(0)]}if(t.sourcePosition.isEqual(e.sourcePosition)&&!t.targetPosition.isEqual(e.targetPosition)&&!n.bWasUndone&&"splitAtSource"!=n.abRelation){const i="$graveyard"==t.targetPosition.root.rootName,o="$graveyard"==e.targetPosition.root.rootName,r=i&&!o;if(o&&!i||!r&&n.aIsStrong){const n=e.targetPosition._getTransformedByMergeOperation(e),i=t.targetPosition._getTransformedByMergeOperation(e);return[new ja(n,t.howMany,i,0)]}return[new cc(0)]}return t.sourcePosition.hasSameParentAs(e.targetPosition)&&(t.howMany+=e.howMany),t.sourcePosition=t.sourcePosition._getTransformedByMergeOperation(e),t.targetPosition=t.targetPosition._getTransformedByMergeOperation(e),t.graveyardPosition.isEqual(e.graveyardPosition)&&n.aIsStrong||(t.graveyardPosition=t.graveyardPosition._getTransformedByMergeOperation(e)),[t]}),Ld(Ua,ja,(t,e,n)=>{const i=Ts._createFromPositionAndShift(e.sourcePosition,e.howMany);return"remove"==e.type&&!n.bWasUndone&&!n.forceWeakRemove&&t.deletionPosition.hasSameParentAs(e.sourcePosition)&&i.containsPosition(t.sourcePosition)?[new cc(0)]:(t.sourcePosition.hasSameParentAs(e.targetPosition)&&(t.howMany+=e.howMany),t.sourcePosition.hasSameParentAs(e.sourcePosition)&&(t.howMany-=e.howMany),t.sourcePosition=t.sourcePosition._getTransformedByMoveOperation(e),t.targetPosition=t.targetPosition._getTransformedByMoveOperation(e),t.graveyardPosition.isEqual(e.targetPosition)||(t.graveyardPosition=t.graveyardPosition._getTransformedByMoveOperation(e)),[t])}),Ld(Ua,Ha,(t,e,n)=>{if(e.graveyardPosition&&(t.graveyardPosition=t.graveyardPosition._getTransformedByDeletion(e.graveyardPosition,1),t.deletionPosition.isEqual(e.graveyardPosition)&&(t.howMany=e.howMany)),t.targetPosition.isEqual(e.splitPosition)){const i=0!=e.howMany,o=e.graveyardPosition&&t.deletionPosition.isEqual(e.graveyardPosition);if(i||o||"mergeTargetNotMoved"==n.abRelation)return t.sourcePosition=t.sourcePosition._getTransformedBySplitOperation(e),[t]}if(t.sourcePosition.isEqual(e.splitPosition)){if("mergeSourceNotMoved"==n.abRelation)return t.howMany=0,t.targetPosition=t.targetPosition._getTransformedBySplitOperation(e),[t];if("mergeSameElement"==n.abRelation||t.sourcePosition.offset>0)return t.sourcePosition=e.moveTargetPosition.clone(),t.targetPosition=t.targetPosition._getTransformedBySplitOperation(e),[t]}return t.sourcePosition.hasSameParentAs(e.splitPosition)&&(t.howMany=e.splitPosition.offset),t.sourcePosition=t.sourcePosition._getTransformedBySplitOperation(e),t.targetPosition=t.targetPosition._getTransformedBySplitOperation(e),[t]}),Ld(ja,Va,(t,e)=>{const n=Ts._createFromPositionAndShift(t.sourcePosition,t.howMany)._getTransformedByInsertOperation(e,!1)[0];return t.sourcePosition=n.start,t.howMany=n.end.offset-n.start.offset,t.targetPosition.isEqual(e.position)||(t.targetPosition=t.targetPosition._getTransformedByInsertOperation(e)),[t]}),Ld(ja,ja,(t,e,n)=>{const i=Ts._createFromPositionAndShift(t.sourcePosition,t.howMany),o=Ts._createFromPositionAndShift(e.sourcePosition,e.howMany);let r,s=n.aIsStrong,a=!n.aIsStrong;if("insertBefore"==n.abRelation||"insertAfter"==n.baRelation?a=!0:"insertAfter"!=n.abRelation&&"insertBefore"!=n.baRelation||(a=!1),r=t.targetPosition.isEqual(e.targetPosition)&&a?t.targetPosition._getTransformedByDeletion(e.sourcePosition,e.howMany):t.targetPosition._getTransformedByMove(e.sourcePosition,e.targetPosition,e.howMany),Wd(t,e)&&Wd(e,t))return[e.getReversed()];if(i.containsPosition(e.targetPosition)&&i.containsRange(o,!0))return i.start=i.start._getTransformedByMove(e.sourcePosition,e.targetPosition,e.howMany),i.end=i.end._getTransformedByMove(e.sourcePosition,e.targetPosition,e.howMany),qd([i],r);if(o.containsPosition(t.targetPosition)&&o.containsRange(i,!0))return i.start=i.start._getCombined(e.sourcePosition,e.getMovedRangeStart()),i.end=i.end._getCombined(e.sourcePosition,e.getMovedRangeStart()),qd([i],r);const c=In(t.sourcePosition.getParentPath(),e.sourcePosition.getParentPath());if("prefix"==c||"extension"==c)return i.start=i.start._getTransformedByMove(e.sourcePosition,e.targetPosition,e.howMany),i.end=i.end._getTransformedByMove(e.sourcePosition,e.targetPosition,e.howMany),qd([i],r);"remove"!=t.type||"remove"==e.type||n.aWasUndone||n.forceWeakRemove?"remove"==t.type||"remove"!=e.type||n.bWasUndone||n.forceWeakRemove||(s=!1):s=!0;const l=[],d=i.getDifference(o);for(const t of d){t.start=t.start._getTransformedByDeletion(e.sourcePosition,e.howMany),t.end=t.end._getTransformedByDeletion(e.sourcePosition,e.howMany);const n="same"==In(t.start.getParentPath(),e.getMovedRangeStart().getParentPath()),i=t._getTransformedByInsertion(e.getMovedRangeStart(),e.howMany,n);l.push(...i)}const u=i.getIntersection(o);return null!==u&&s&&(u.start=u.start._getCombined(e.sourcePosition,e.getMovedRangeStart()),u.end=u.end._getCombined(e.sourcePosition,e.getMovedRangeStart()),0===l.length?l.push(u):1==l.length?o.start.isBefore(i.start)||o.start.isEqual(i.start)?l.unshift(u):l.push(u):l.splice(1,0,u)),0===l.length?[new cc(t.baseVersion)]:qd(l,r)}),Ld(ja,Ha,(t,e,n)=>{let i=t.targetPosition.clone();t.targetPosition.isEqual(e.insertionPosition)&&e.graveyardPosition&&"moveTargetAfter"!=n.abRelation||(i=t.targetPosition._getTransformedBySplitOperation(e));const o=Ts._createFromPositionAndShift(t.sourcePosition,t.howMany);if(o.end.isEqual(e.insertionPosition))return e.graveyardPosition||t.howMany++,t.targetPosition=i,[t];if(o.start.hasSameParentAs(e.splitPosition)&&o.containsPosition(e.splitPosition)){let t=new Ts(e.splitPosition,o.end);t=t._getTransformedBySplitOperation(e);return qd([new Ts(o.start,e.splitPosition),t],i)}t.targetPosition.isEqual(e.splitPosition)&&"insertAtSource"==n.abRelation&&(i=e.moveTargetPosition),t.targetPosition.isEqual(e.insertionPosition)&&"insertBetween"==n.abRelation&&(i=t.targetPosition);const r=[o._getTransformedBySplitOperation(e)];if(e.graveyardPosition){const i=o.start.isEqual(e.graveyardPosition)||o.containsPosition(e.graveyardPosition);t.howMany>1&&i&&!n.aWasUndone&&r.push(Ts._createFromPositionAndShift(e.insertionPosition,1))}return qd(r,i)}),Ld(ja,Ua,(t,e,n)=>{const i=Ts._createFromPositionAndShift(t.sourcePosition,t.howMany);if(e.deletionPosition.hasSameParentAs(t.sourcePosition)&&i.containsPosition(e.sourcePosition))if("remove"!=t.type||n.forceWeakRemove){if(1==t.howMany)return n.bWasUndone?(t.sourcePosition=e.graveyardPosition.clone(),t.targetPosition=t.targetPosition._getTransformedByMergeOperation(e),[t]):[new cc(0)]}else if(!n.aWasUndone){const n=[];let i=e.graveyardPosition.clone(),o=e.targetPosition._getTransformedByMergeOperation(e);t.howMany>1&&(n.push(new ja(t.sourcePosition,t.howMany-1,t.targetPosition,0)),i=i._getTransformedByMove(t.sourcePosition,t.targetPosition,t.howMany-1),o=o._getTransformedByMove(t.sourcePosition,t.targetPosition,t.howMany-1));const r=e.deletionPosition._getCombined(t.sourcePosition,t.targetPosition),s=new ja(i,1,r,0),a=s.getMovedRangeStart().path.slice();a.push(0);const c=new ys(s.targetPosition.root,a);o=o._getTransformedByMove(i,r,1);const l=new ja(o,e.howMany,c,0);return n.push(s),n.push(l),n}const o=Ts._createFromPositionAndShift(t.sourcePosition,t.howMany)._getTransformedByMergeOperation(e);return t.sourcePosition=o.start,t.howMany=o.end.offset-o.start.offset,t.targetPosition=t.targetPosition._getTransformedByMergeOperation(e),[t]}),Ld(Ba,Va,(t,e)=>(t.position=t.position._getTransformedByInsertOperation(e),[t])),Ld(Ba,Ua,(t,e)=>t.position.isEqual(e.deletionPosition)?(t.position=e.graveyardPosition.clone(),t.position.stickiness="toNext",[t]):(t.position=t.position._getTransformedByMergeOperation(e),[t])),Ld(Ba,ja,(t,e)=>(t.position=t.position._getTransformedByMoveOperation(e),[t])),Ld(Ba,Ba,(t,e,n)=>{if(t.position.isEqual(e.position)){if(!n.aIsStrong)return[new cc(0)];t.oldName=e.newName}return[t]}),Ld(Ba,Ha,(t,e)=>{if("same"==In(t.position.path,e.splitPosition.getParentPath())&&!e.graveyardPosition){const e=new Ba(t.position.getShiftedBy(1),t.oldName,t.newName,0);return[t,e]}return t.position=t.position._getTransformedBySplitOperation(e),[t]}),Ld(Fa,Fa,(t,e,n)=>{if(t.root===e.root&&t.key===e.key){if(!n.aIsStrong||t.newValue===e.newValue)return[new cc(0)];t.oldValue=e.newValue}return[t]}),Ld(Ha,Va,(t,e)=>(t.splitPosition.hasSameParentAs(e.position)&&t.splitPosition.offset<e.position.offset&&(t.howMany+=e.howMany),t.splitPosition=t.splitPosition._getTransformedByInsertOperation(e),t.insertionPosition=Ha.getInsertionPosition(t.splitPosition),[t])),Ld(Ha,Ua,(t,e,n)=>{if(!t.graveyardPosition&&!n.bWasUndone&&t.splitPosition.hasSameParentAs(e.sourcePosition)){const n=e.graveyardPosition.path.slice();n.push(0);const i=new ys(e.graveyardPosition.root,n),o=Ha.getInsertionPosition(new ys(e.graveyardPosition.root,n)),r=new Ha(i,0,null,0);return r.insertionPosition=o,t.splitPosition=t.splitPosition._getTransformedByMergeOperation(e),t.insertionPosition=Ha.getInsertionPosition(t.splitPosition),t.graveyardPosition=r.insertionPosition.clone(),t.graveyardPosition.stickiness="toNext",[r,t]}return t.splitPosition.hasSameParentAs(e.deletionPosition)&&!t.splitPosition.isAfter(e.deletionPosition)&&t.howMany--,t.splitPosition.hasSameParentAs(e.targetPosition)&&(t.howMany+=e.howMany),t.splitPosition=t.splitPosition._getTransformedByMergeOperation(e),t.insertionPosition=Ha.getInsertionPosition(t.splitPosition),t.graveyardPosition&&(t.graveyardPosition=t.graveyardPosition._getTransformedByMergeOperation(e)),[t]}),Ld(Ha,ja,(t,e,n)=>{const i=Ts._createFromPositionAndShift(e.sourcePosition,e.howMany);if(t.graveyardPosition){const o=i.start.isEqual(t.graveyardPosition)||i.containsPosition(t.graveyardPosition);if(!n.bWasUndone&&o){const n=t.splitPosition._getTransformedByMoveOperation(e),i=t.graveyardPosition._getTransformedByMoveOperation(e),o=i.path.slice();o.push(0);const r=new ys(i.root,o);return[new ja(n,t.howMany,r,0)]}t.graveyardPosition=t.graveyardPosition._getTransformedByMoveOperation(e)}if(t.splitPosition.hasSameParentAs(e.sourcePosition)&&i.containsPosition(t.splitPosition)){const n=e.howMany-(t.splitPosition.offset-e.sourcePosition.offset);return t.howMany-=n,t.splitPosition.hasSameParentAs(e.targetPosition)&&t.splitPosition.offset<e.targetPosition.offset&&(t.howMany+=e.howMany),t.splitPosition=e.sourcePosition.clone(),t.insertionPosition=Ha.getInsertionPosition(t.splitPosition),[t]}return!t.splitPosition.isEqual(e.targetPosition)||"insertAtSource"!=n.baRelation&&"splitBefore"!=n.abRelation?(e.sourcePosition.isEqual(e.targetPosition)||(t.splitPosition.hasSameParentAs(e.sourcePosition)&&t.splitPosition.offset<=e.sourcePosition.offset&&(t.howMany-=e.howMany),t.splitPosition.hasSameParentAs(e.targetPosition)&&t.splitPosition.offset<e.targetPosition.offset&&(t.howMany+=e.howMany)),t.splitPosition.stickiness="toNone",t.splitPosition=t.splitPosition._getTransformedByMoveOperation(e),t.splitPosition.stickiness="toNext",t.graveyardPosition?t.insertionPosition=t.insertionPosition._getTransformedByMoveOperation(e):t.insertionPosition=Ha.getInsertionPosition(t.splitPosition),[t]):(t.howMany+=e.howMany,t.splitPosition=t.splitPosition._getTransformedByDeletion(e.sourcePosition,e.howMany),t.insertionPosition=Ha.getInsertionPosition(t.splitPosition),[t])}),Ld(Ha,Ha,(t,e,n)=>{if(t.splitPosition.isEqual(e.splitPosition)){if(!t.graveyardPosition&&!e.graveyardPosition)return[new cc(0)];if(t.graveyardPosition&&e.graveyardPosition&&t.graveyardPosition.isEqual(e.graveyardPosition))return[new cc(0)];if("splitBefore"==n.abRelation)return t.howMany=0,t.graveyardPosition=t.graveyardPosition._getTransformedBySplitOperation(e),[t]}if(t.graveyardPosition&&e.graveyardPosition&&t.graveyardPosition.isEqual(e.graveyardPosition)){const i="$graveyard"==t.splitPosition.root.rootName,o="$graveyard"==e.splitPosition.root.rootName,r=i&&!o;if(o&&!i||!r&&n.aIsStrong){const n=[];return e.howMany&&n.push(new ja(e.moveTargetPosition,e.howMany,e.splitPosition,0)),t.howMany&&n.push(new ja(t.splitPosition,t.howMany,t.moveTargetPosition,0)),n}return[new cc(0)]}if(t.graveyardPosition&&(t.graveyardPosition=t.graveyardPosition._getTransformedBySplitOperation(e)),t.splitPosition.isEqual(e.insertionPosition)&&"splitBefore"==n.abRelation)return t.howMany++,[t];if(e.splitPosition.isEqual(t.insertionPosition)&&"splitBefore"==n.baRelation){const n=e.insertionPosition.path.slice();n.push(0);const i=new ys(e.insertionPosition.root,n);return[t,new ja(t.insertionPosition,1,i,0)]}return t.splitPosition.hasSameParentAs(e.splitPosition)&&t.splitPosition.offset<e.splitPosition.offset&&(t.howMany-=e.howMany),t.splitPosition=t.splitPosition._getTransformedBySplitOperation(e),t.insertionPosition=Ha.getInsertionPosition(t.splitPosition),[t]});class Yd extends od{constructor(t){super(t),this._stack=[],this._createdBatches=new WeakSet,this.refresh()}refresh(){this.isEnabled=this._stack.length>0}addBatch(t){const e=this.editor.model.document.selection,n={ranges:e.hasOwnRange?Array.from(e.getRanges()):[],isBackward:e.isBackward};this._stack.push({batch:t,selection:n}),this.refresh()}clearStack(){this._stack=[],this.refresh()}_restoreSelection(t,e,n){const i=this.editor.model,o=i.document,r=[];for(const e of t){const t=Gd(e,n).find(t=>t.start.root!=o.graveyard);t&&r.push(t)}r.length&&i.change(t=>{t.setSelection(r,{backward:e})})}_undo(t,e){const n=this.editor.model,i=n.document;this._createdBatches.add(e);const o=t.operations.slice().filter(t=>t.isDocumentOperation);o.reverse();for(const t of o){const o=t.baseVersion+1,r=Array.from(i.history.getOperations(o)),s=zd([t.getReversed()],r,{useRelations:!0,document:this.editor.model.document,padWithNoOps:!1,forceWeakRemove:!0}).operationsA;for(const o of s)e.addOperation(o),n.applyOperation(o),i.history.setOperationAsUndone(t,o)}}}function Gd(t,e){const n=t.getTransformedByOperations(e);n.sort((t,e)=>t.start.isBefore(e.start)?-1:1);for(let t=1;t<n.length;t++){const e=n[t-1],i=n[t];e.end.isTouching(i.start)&&(e.end=i.end,n.splice(t,1),t--)}return n}class $d extends Yd{execute(t=null){const e=t?this._stack.findIndex(e=>e.batch==t):this._stack.length-1,n=this._stack.splice(e,1)[0],i=this.editor.model.createBatch("transparent");this.editor.model.enqueueChange(i,()=>{this._undo(n.batch,i);const t=this.editor.model.document.history.getOperations(n.batch.baseVersion);this._restoreSelection(n.selection.ranges,n.selection.isBackward,t),this.fire("revert",n.batch,i)}),this.refresh()}}class Kd extends Yd{execute(){const t=this._stack.pop(),e=this.editor.model.createBatch("transparent");this.editor.model.enqueueChange(e,()=>{const n=t.batch.operations[t.batch.operations.length-1].baseVersion+1,i=this.editor.model.document.history.getOperations(n);this._restoreSelection(t.selection.ranges,t.selection.isBackward,i),this._undo(t.batch,e)}),this.refresh()}}class Qd extends Zl{static get pluginName(){return"UndoEditing"}constructor(t){super(t),this._batchRegistry=new WeakSet}init(){const t=this.editor;this._undoCommand=new $d(t),this._redoCommand=new Kd(t),t.commands.add("undo",this._undoCommand),t.commands.add("redo",this._redoCommand),this.listenTo(t.model,"applyOperation",(t,e)=>{const n=e[0];if(!n.isDocumentOperation)return;const i=n.batch,o=this._redoCommand._createdBatches.has(i),r=this._undoCommand._createdBatches.has(i);this._batchRegistry.has(i)||"transparent"==i.type&&!o&&!r||(o?this._undoCommand.addBatch(i):r||(this._undoCommand.addBatch(i),this._redoCommand.clearStack()),this._batchRegistry.add(i))},{priority:"highest"}),this.listenTo(this._undoCommand,"revert",(t,e,n)=>{this._redoCommand.addBatch(n)}),t.keystrokes.set("CTRL+Z","undo"),t.keystrokes.set("CTRL+Y","redo"),t.keystrokes.set("CTRL+SHIFT+Z","redo")}}var Jd='<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M5.042 9.367l2.189 1.837a.75.75 0 0 1-.965 1.149l-3.788-3.18a.747.747 0 0 1-.21-.284.75.75 0 0 1 .17-.945L6.23 4.762a.75.75 0 1 1 .964 1.15L4.863 7.866h8.917A.75.75 0 0 1 14 7.9a4 4 0 1 1-1.477 7.718l.344-1.489a2.5 2.5 0 1 0 1.094-4.73l.008-.032H5.042z"/></svg>',Zd='<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M14.958 9.367l-2.189 1.837a.75.75 0 0 0 .965 1.149l3.788-3.18a.747.747 0 0 0 .21-.284.75.75 0 0 0-.17-.945L13.77 4.762a.75.75 0 1 0-.964 1.15l2.331 1.955H6.22A.75.75 0 0 0 6 7.9a4 4 0 1 0 1.477 7.718l-.344-1.489A2.5 2.5 0 1 1 6.039 9.4l-.008-.032h8.927z"/></svg>';class Xd extends Zl{init(){const t=this.editor,e=t.locale,n=t.t,i="ltr"==e.uiLanguageDirection?Jd:Zd,o="ltr"==e.uiLanguageDirection?Zd:Jd;this._addButton("undo",n("Undo"),"CTRL+Z",i),this._addButton("redo",n("Redo"),"CTRL+Y",o)}_addButton(t,e,n,i){const o=this.editor;o.ui.componentFactory.add(t,r=>{const s=o.commands.get(t),a=new Ll(r);return a.set({label:e,icon:i,keystroke:n,tooltip:!0}),a.bind("isEnabled").to(s,"isEnabled"),this.listenTo(a,"execute",()=>{o.execute(t),o.editing.view.focus()}),a})}}class tu extends Zl{static get requires(){return[Qd,Xd]}static get pluginName(){return"Undo"}}class eu{constructor(t){this.context=t}destroy(){this.stopListening()}static get isContextPlugin(){return!0}}xn(eu,Ui);class nu extends eu{static get pluginName(){return"PendingActions"}init(){this.set("hasAny",!1),this._actions=new An({idProperty:"_id"}),this._actions.delegate("add","remove").to(this)}add(t){if("string"!=typeof t)throw new hn.b("pendingactions-add-invalid-message: The message must be a string.",this);const e=Object.create(Ui);return e.set("message",t),this._actions.add(e),this.hasAny=!0,e}remove(t){this._actions.remove(t),this.hasAny=!!this._actions.length}get first(){return this._actions.get(0)}[Symbol.iterator](){return this._actions[Symbol.iterator]()}}class iu{constructor(){const t=new window.FileReader;this._reader=t,this._data=void 0,this.set("loaded",0),t.onprogress=t=>{this.loaded=t.loaded}}get error(){return this._reader.error}get data(){return this._data}read(t){const e=this._reader;return this.total=t.size,new Promise((n,i)=>{e.onload=()=>{const t=e.result;this._data=t,n(t)},e.onerror=()=>{i("error")},e.onabort=()=>{i("aborted")},this._reader.readAsDataURL(t)})}abort(){this._reader.abort()}}xn(iu,Ui);class ou extends Zl{static get pluginName(){return"FileRepository"}static get requires(){return[nu]}init(){this.loaders=new An,this.loaders.on("add",()=>this._updatePendingAction()),this.loaders.on("remove",()=>this._updatePendingAction()),this._loadersMap=new Map,this._pendingAction=null,this.set("uploaded",0),this.set("uploadTotal",null),this.bind("uploadedPercent").to(this,"uploaded",this,"uploadTotal",(t,e)=>e?t/e*100:0)}getLoader(t){return this._loadersMap.get(t)||null}createLoader(t){if(!this.createUploadAdapter)return console.warn(Object(hn.a)("filerepository-no-upload-adapter: Upload adapter is not defined.")),null;const e=new ru(Promise.resolve(t),this.createUploadAdapter);return this.loaders.add(e),this._loadersMap.set(t,e),t instanceof Promise&&e.file.then(t=>{this._loadersMap.set(t,e)}).catch(()=>{}),e.on("change:uploaded",()=>{let t=0;for(const e of this.loaders)t+=e.uploaded;this.uploaded=t}),e.on("change:uploadTotal",()=>{let t=0;for(const e of this.loaders)e.uploadTotal&&(t+=e.uploadTotal);this.uploadTotal=t}),e}destroyLoader(t){const e=t instanceof ru?t:this.getLoader(t);e._destroy(),this.loaders.remove(e),this._loadersMap.forEach((t,n)=>{t===e&&this._loadersMap.delete(n)})}_updatePendingAction(){const t=this.editor.plugins.get(nu);if(this.loaders.length){if(!this._pendingAction){const e=this.editor.t,n=t=>`${e("Upload in progress")} ${parseInt(t)}%.`;this._pendingAction=t.add(n(this.uploadedPercent)),this._pendingAction.bind("message").to(this,"uploadedPercent",n)}}else t.remove(this._pendingAction),this._pendingAction=null}}xn(ou,Ui);class ru{constructor(t,e){this.id=dn(),this._filePromiseWrapper=this._createFilePromiseWrapper(t),this._adapter=e(this),this._reader=new iu,this.set("status","idle"),this.set("uploaded",0),this.set("uploadTotal",null),this.bind("uploadedPercent").to(this,"uploaded",this,"uploadTotal",(t,e)=>e?t/e*100:0),this.set("uploadResponse",null)}get file(){return this._filePromiseWrapper?this._filePromiseWrapper.promise.then(t=>this._filePromiseWrapper?t:null):Promise.resolve(null)}get data(){return this._reader.data}read(){if("idle"!=this.status)throw new hn.b("filerepository-read-wrong-status: You cannot call read if the status is different than idle.",this);return this.status="reading",this.file.then(t=>this._reader.read(t)).then(t=>{if("reading"!==this.status)throw this.status;return this.status="idle",t}).catch(t=>{if("aborted"===t)throw this.status="aborted","aborted";throw this.status="error",this._reader.error?this._reader.error:t})}upload(){if("idle"!=this.status)throw new hn.b("filerepository-upload-wrong-status: You cannot call upload if the status is different than idle.",this);return this.status="uploading",this.file.then(()=>this._adapter.upload()).then(t=>(this.uploadResponse=t,this.status="idle",t)).catch(t=>{if("aborted"===this.status)throw"aborted";throw this.status="error",t})}abort(){const t=this.status;this.status="aborted",this._filePromiseWrapper.isFulfilled?"reading"==t?this._reader.abort():"uploading"==t&&this._adapter.abort&&this._adapter.abort():(this._filePromiseWrapper.promise.catch(()=>{}),this._filePromiseWrapper.rejecter("aborted")),this._destroy()}_destroy(){this._filePromiseWrapper=void 0,this._reader=void 0,this._adapter=void 0,this.uploadResponse=void 0}_createFilePromiseWrapper(t){const e={};return e.promise=new Promise((n,i)=>{e.rejecter=i,e.isFulfilled=!1,t.then(t=>{e.isFulfilled=!0,n(t)}).catch(t=>{e.isFulfilled=!0,i(t)})}),e}}xn(ru,Ui);function su(){let t=function(t){t=t.toLowerCase();const e=document.cookie.split(";");for(const n of e){const e=n.split("=");if(decodeURIComponent(e[0].trim().toLowerCase())===t)return decodeURIComponent(e[1])}return null}("ckCsrfToken");var e,n;return t&&40==t.length||(t=function(t){let e="";const n=new Uint8Array(t);window.crypto.getRandomValues(n);for(let t=0;t<n.length;t++){const i="abcdefghijklmnopqrstuvwxyz0123456789".charAt(n[t]%"abcdefghijklmnopqrstuvwxyz0123456789".length);e+=Math.random()>.5?i.toUpperCase():i}return e}(40),e="ckCsrfToken",n=t,document.cookie=encodeURIComponent(e)+"="+encodeURIComponent(n)+";path=/"),t}class au extends Zl{static get requires(){return[ou]}static get pluginName(){return"CKFinderUploadAdapter"}init(){const t=this.editor.config.get("ckfinder.uploadUrl");t&&(this.editor.plugins.get(ou).createUploadAdapter=e=>new cu(e,t,this.editor.t))}}class cu{constructor(t,e,n){this.loader=t,this.url=e,this.t=n}upload(){return this.loader.file.then(t=>new Promise((e,n)=>{this._initRequest(),this._initListeners(e,n,t),this._sendRequest(t)}))}abort(){this.xhr&&this.xhr.abort()}_initRequest(){const t=this.xhr=new XMLHttpRequest;t.open("POST",this.url,!0),t.responseType="json"}_initListeners(t,e,n){const i=this.xhr,o=this.loader,r=(0,this.t)("Cannot upload file:")+` ${n.name}.`;i.addEventListener("error",()=>e(r)),i.addEventListener("abort",()=>e()),i.addEventListener("load",()=>{const n=i.response;if(!n||!n.uploaded)return e(n&&n.error&&n.error.message?n.error.message:r);t({default:n.url})}),i.upload&&i.upload.addEventListener("progress",t=>{t.lengthComputable&&(o.uploadTotal=t.total,o.uploaded=t.loaded)})}_sendRequest(t){const e=new FormData;e.append("upload",t),e.append("ckCsrfToken",su()),this.xhr.send(e)}}function lu(t,e,n,i){let o,r=null;"function"==typeof i?o=i:(r=t.commands.get(i),o=()=>{t.execute(i)}),t.model.document.on("change:data",(i,s)=>{if(r&&!r.isEnabled||!e.isEnabled)return;if("transparent"==s.type)return;const a=Array.from(t.model.document.differ.getChanges()),c=a[0];if(1!=a.length||"insert"!==c.type||"$text"!=c.name||1!=c.length)return;const l=c.position.parent;if(!l.is("paragraph")||1!==l.childCount)return;const d=n.exec(l.getChild(0).data);d&&t.model.enqueueChange(t=>{const e=t.createPositionAt(l,0),n=t.createPositionAt(l,d[0].length),i=new js(e,n);!1!==o({match:d})&&t.remove(i),i.detach()})})}function du(t,e,n,i){let o,r;n instanceof RegExp?o=n:r=n,r=r||(t=>{let e;const n=[],i=[];for(;null!==(e=o.exec(t))&&!(e&&e.length<4);){let{index:t,1:o,2:r,3:s}=e;const a=o+r+s;t+=e[0].length-a.length;const c=[t,t+o.length],l=[t+o.length+r.length,t+o.length+r.length+s.length];n.push(c),n.push(l),i.push([t+o.length,t+o.length+r.length])}return{remove:n,format:i}}),t.model.document.on("change:data",(n,o)=>{if("transparent"==o.type||!e.isEnabled)return;const s=t.model,a=s.document.selection;if(!a.isCollapsed)return;const c=Array.from(s.document.differ.getChanges()),l=c[0];if(1!=c.length||"insert"!==l.type||"$text"!=l.name||1!=l.length)return;const d=a.focus,u=d.parent,{text:h,range:f}=function(t,e){let n=t.start;return{text:Array.from(t.getItems()).reduce((t,i)=>!i.is("text")&&!i.is("textProxy")||i.getAttribute("code")?(n=e.createPositionAfter(i),""):t+i.data,""),range:e.createRange(n,t.end)}}(s.createRange(s.createPositionAt(u,0),d),s),g=r(h),m=uu(f.start,g.format,s),p=uu(f.start,g.remove,s);m.length&&p.length&&s.enqueueChange(t=>{if(!1!==i(t,m))for(const e of p.reverse())t.remove(e)})})}function uu(t,e,n){return e.filter(t=>void 0!==t[0]&&void 0!==t[1]).map(e=>n.createRange(t.getShiftedBy(e[0]),t.getShiftedBy(e[1])))}function hu(t,e){return(n,i)=>{if(!t.commands.get(e).isEnabled)return!1;const o=t.model.schema.getValidRanges(i,e);for(const t of o)n.setAttribute(e,!0,t);n.removeSelectionAttribute(e)}}class fu extends od{constructor(t,e){super(t),this.attributeKey=e}refresh(){const t=this.editor.model,e=t.document;this.value=this._getValueFromFirstAllowedNode(),this.isEnabled=t.schema.checkAttributeInSelection(e.selection,this.attributeKey)}execute(t={}){const e=this.editor.model,n=e.document.selection,i=void 0===t.forceValue?!this.value:t.forceValue;e.change(t=>{if(n.isCollapsed)i?t.setSelectionAttribute(this.attributeKey,!0):t.removeSelectionAttribute(this.attributeKey);else{const o=e.schema.getValidRanges(n.getRanges(),this.attributeKey);for(const e of o)i?t.setAttribute(this.attributeKey,i,e):t.removeAttribute(this.attributeKey,e)}})}_getValueFromFirstAllowedNode(){const t=this.editor.model,e=t.schema,n=t.document.selection;if(n.isCollapsed)return n.hasAttribute(this.attributeKey);for(const t of n.getRanges())for(const n of t.getItems())if(e.checkAttribute(n,this.attributeKey))return n.hasAttribute(this.attributeKey);return!1}}class gu extends Zl{static get pluginName(){return"BoldEditing"}init(){const t=this.editor;t.model.schema.extend("$text",{allowAttributes:"bold"}),t.model.schema.setAttributeProperties("bold",{isFormatting:!0,copyOnEnter:!0}),t.conversion.attributeToElement({model:"bold",view:"strong",upcastAlso:["b",t=>{const e=t.getStyle("font-weight");return e?"bold"==e||Number(e)>=600?{name:!0,styles:["font-weight"]}:void 0:null}]}),t.commands.add("bold",new fu(t,"bold")),t.keystrokes.set("CTRL+B","bold")}}class mu extends Zl{init(){const t=this.editor,e=t.t;t.ui.componentFactory.add("bold",n=>{const i=t.commands.get("bold"),o=new Ll(n);return o.set({label:e("Bold"),icon:'<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10.187 17H5.773c-.637 0-1.092-.138-1.364-.415-.273-.277-.409-.718-.409-1.323V4.738c0-.617.14-1.062.419-1.332.279-.27.73-.406 1.354-.406h4.68c.69 0 1.288.041 1.793.124.506.083.96.242 1.36.478.341.197.644.447.906.75a3.262 3.262 0 0 1 .808 2.162c0 1.401-.722 2.426-2.167 3.075C15.05 10.175 16 11.315 16 13.01a3.756 3.756 0 0 1-2.296 3.504 6.1 6.1 0 0 1-1.517.377c-.571.073-1.238.11-2 .11zm-.217-6.217H7v4.087h3.069c1.977 0 2.965-.69 2.965-2.072 0-.707-.256-1.22-.768-1.537-.512-.319-1.277-.478-2.296-.478zM7 5.13v3.619h2.606c.729 0 1.292-.067 1.69-.2a1.6 1.6 0 0 0 .91-.765c.165-.267.247-.566.247-.897 0-.707-.26-1.176-.778-1.409-.519-.232-1.31-.348-2.375-.348H7z"/></svg>',keystroke:"CTRL+B",tooltip:!0,isToggleable:!0}),o.bind("isOn","isEnabled").to(i,"value","isEnabled"),this.listenTo(o,"execute",()=>{t.execute("bold"),t.editing.view.focus()}),o})}}class pu extends Zl{static get pluginName(){return"ItalicEditing"}init(){const t=this.editor;t.model.schema.extend("$text",{allowAttributes:"italic"}),t.model.schema.setAttributeProperties("italic",{isFormatting:!0,copyOnEnter:!0}),t.conversion.attributeToElement({model:"italic",view:"i",upcastAlso:["em",{styles:{"font-style":"italic"}}]}),t.commands.add("italic",new fu(t,"italic")),t.keystrokes.set("CTRL+I","italic")}}class bu extends Zl{init(){const t=this.editor,e=t.t;t.ui.componentFactory.add("italic",n=>{const i=t.commands.get("italic"),o=new Ll(n);return o.set({label:e("Italic"),icon:'<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M9.586 14.633l.021.004c-.036.335.095.655.393.962.082.083.173.15.274.201h1.474a.6.6 0 1 1 0 1.2H5.304a.6.6 0 0 1 0-1.2h1.15c.474-.07.809-.182 1.005-.334.157-.122.291-.32.404-.597l2.416-9.55a1.053 1.053 0 0 0-.281-.823 1.12 1.12 0 0 0-.442-.296H8.15a.6.6 0 0 1 0-1.2h6.443a.6.6 0 1 1 0 1.2h-1.195c-.376.056-.65.155-.823.296-.215.175-.423.439-.623.79l-2.366 9.347z"/></svg>',keystroke:"CTRL+I",tooltip:!0,isToggleable:!0}),o.bind("isOn","isEnabled").to(i,"value","isEnabled"),this.listenTo(o,"execute",()=>{t.execute("italic"),t.editing.view.focus()}),o})}}function wu(t){const e=t.next();return e.done?null:e.value}class ku extends od{refresh(){this.value=this._getValue(),this.isEnabled=this._checkEnabled()}execute(t={}){const e=this.editor.model,n=e.schema,i=e.document.selection,o=Array.from(i.getSelectedBlocks()),r=void 0===t.forceValue?!this.value:t.forceValue;e.change(t=>{if(r){const e=o.filter(t=>_u(t)||yu(n,t));this._applyQuote(t,e)}else this._removeQuote(t,o.filter(_u))})}_getValue(){const t=wu(this.editor.model.document.selection.getSelectedBlocks());return!(!t||!_u(t))}_checkEnabled(){if(this.value)return!0;const t=this.editor.model.document.selection,e=this.editor.model.schema,n=wu(t.getSelectedBlocks());return!!n&&yu(e,n)}_removeQuote(t,e){vu(t,e).reverse().forEach(e=>{if(e.start.isAtStart&&e.end.isAtEnd)return void t.unwrap(e.start.parent);if(e.start.isAtStart){const n=t.createPositionBefore(e.start.parent);return void t.move(e,n)}e.end.isAtEnd||t.split(e.end);const n=t.createPositionAfter(e.end.parent);t.move(e,n)})}_applyQuote(t,e){const n=[];vu(t,e).reverse().forEach(e=>{let i=_u(e.start);i||(i=t.createElement("blockQuote"),t.wrap(e,i)),n.push(i)}),n.reverse().reduce((e,n)=>e.nextSibling==n?(t.merge(t.createPositionAfter(e)),e):n)}}function _u(t){return"blockQuote"==t.parent.name?t.parent:null}function vu(t,e){let n,i=0;const o=[];for(;i<e.length;){const r=e[i],s=e[i+1];n||(n=t.createPositionBefore(r)),s&&r.nextSibling==s||(o.push(t.createRange(n,t.createPositionAfter(r))),n=null),i++}return o}function yu(t,e){const n=t.checkChild(e.parent,"blockQuote"),i=t.checkChild(["$root","blockQuote"],e);return n&&i}class xu extends Zl{static get pluginName(){return"BlockQuoteEditing"}init(){const t=this.editor,e=t.model.schema;t.commands.add("blockQuote",new ku(t)),e.register("blockQuote",{allowWhere:"$block",allowContentOf:"$root"}),e.addChildCheck((t,e)=>{if(t.endsWith("blockQuote")&&"blockQuote"==e.name)return!1}),t.conversion.elementToElement({model:"blockQuote",view:"blockquote"}),t.model.document.registerPostFixer(n=>{const i=t.model.document.differ.getChanges();for(const t of i)if("insert"==t.type){const i=t.position.nodeAfter;if(!i)continue;if(i.is("blockQuote")&&i.isEmpty)return n.remove(i),!0;if(i.is("blockQuote")&&!e.checkChild(t.position,i))return n.unwrap(i),!0;if(i.is("element")){const t=n.createRangeIn(i);for(const i of t.getItems())if(i.is("blockQuote")&&!e.checkChild(n.createPositionBefore(i),i))return n.unwrap(i),!0}}else if("remove"==t.type){const e=t.position.parent;if(e.is("blockQuote")&&e.isEmpty)return n.remove(e),!0}return!1})}afterInit(){const t=this.editor.commands.get("blockQuote");this.listenTo(this.editor.editing.view.document,"enter",(e,n)=>{const i=this.editor.model.document,o=i.selection.getLastPosition().parent;i.selection.isCollapsed&&o.isEmpty&&t.value&&(this.editor.execute("blockQuote"),this.editor.editing.view.scrollToTheSelection(),n.preventDefault(),e.stop())})}}n(43);class Au extends Zl{init(){const t=this.editor,e=t.t;t.ui.componentFactory.add("blockQuote",n=>{const i=t.commands.get("blockQuote"),o=new Ll(n);return o.set({label:e("Block quote"),icon:'<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 10.423a6.5 6.5 0 0 1 6.056-6.408l.038.67C6.448 5.423 5.354 7.663 5.22 10H9c.552 0 .5.432.5.986v4.511c0 .554-.448.503-1 .503h-5c-.552 0-.5-.449-.5-1.003v-4.574zm8 0a6.5 6.5 0 0 1 6.056-6.408l.038.67c-2.646.739-3.74 2.979-3.873 5.315H17c.552 0 .5.432.5.986v4.511c0 .554-.448.503-1 .503h-5c-.552 0-.5-.449-.5-1.003v-4.574z"/></svg>',tooltip:!0,isToggleable:!0}),o.bind("isOn","isEnabled").to(i,"value","isEnabled"),this.listenTo(o,"execute",()=>{t.execute("blockQuote"),t.editing.view.focus()}),o})}}class Cu extends Zl{static get pluginName(){return"CKFinderUI"}init(){const t=this.editor,e=t.ui.componentFactory,n=t.t;e.add("ckfinder",e=>{const i=t.commands.get("ckfinder"),o=new Ll(e);return o.set({label:n("Insert image or file"),icon:'<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.627 16.5zm5.873-.196zm0-7.001V8h-13v8.5h4.341c.191.54.457 1.044.785 1.5H2a1.5 1.5 0 0 1-1.5-1.5v-13A1.5 1.5 0 0 1 2 2h4.5a1.5 1.5 0 0 1 1.06.44L9.122 4H16a1.5 1.5 0 0 1 1.5 1.5v1A1.5 1.5 0 0 1 19 8v2.531a6.027 6.027 0 0 0-1.5-1.228zM16 6.5v-1H8.5l-2-2H2v13h1V8a1.5 1.5 0 0 1 1.5-1.5H16z"/><path d="M14.5 19.5a5 5 0 1 1 0-10 5 5 0 0 1 0 10zM15 14v-2h-1v2h-2v1h2v2h1v-2h2v-1h-2z"/></svg>',tooltip:!0}),o.bind("isEnabled").to(i),o.on("execute",()=>{t.execute("ckfinder"),t.editing.view.focus()}),o})}}class Tu extends gr{observe(t){this.listenTo(t,"load",(t,e)=>{"IMG"==e.target.tagName&&this._fireEvents(e)},{useCapture:!0})}_fireEvents(t){this.isEnabled&&(this.document.fire("layoutChanged"),this.document.fire("imageLoaded",t))}}class Pu{constructor(){this._stack=[]}add(t,e){const n=this._stack,i=n[0];this._insertDescriptor(t);const o=n[0];i===o||Su(i,o)||this.fire("change:top",{oldDescriptor:i,newDescriptor:o,writer:e})}remove(t,e){const n=this._stack,i=n[0];this._removeDescriptor(t);const o=n[0];i===o||Su(i,o)||this.fire("change:top",{oldDescriptor:i,newDescriptor:o,writer:e})}_insertDescriptor(t){const e=this._stack,n=e.findIndex(e=>e.id===t.id);if(Su(t,e[n]))return;n>-1&&e.splice(n,1);let i=0;for(;e[i]&&Eu(e[i],t);)i++;e.splice(i,0,t)}_removeDescriptor(t){const e=this._stack,n=e.findIndex(e=>e.id===t);n>-1&&e.splice(n,1)}}function Su(t,e){return t&&e&&t.priority==e.priority&&Mu(t.classes)==Mu(e.classes)}function Eu(t,e){return t.priority>e.priority||!(t.priority<e.priority)&&Mu(t.classes)>Mu(e.classes)}function Mu(t){return Array.isArray(t)?t.sort().join(","):t}xn(Pu,mn);n(45);const Iu=_l("px"),Nu=nr.document.body;class Ou extends hl{constructor(t){super(t);const e=this.bindTemplate;this.set("top",0),this.set("left",0),this.set("position","arrow_nw"),this.set("isVisible",!1),this.set("withArrow",!0),this.set("class"),this.content=this.createCollection(),this.setTemplate({tag:"div",attributes:{class:["ck","ck-balloon-panel",e.to("position",t=>"ck-balloon-panel_"+t),e.if("isVisible","ck-balloon-panel_visible"),e.if("withArrow","ck-balloon-panel_with-arrow"),e.to("class")],style:{top:e.to("top",Iu),left:e.to("left",Iu)}},children:this.content})}show(){this.isVisible=!0}hide(){this.isVisible=!1}attachTo(t){this.show();const e=Ou.defaultPositions,n=Object.assign({},{element:this.element,positions:[e.southArrowNorth,e.southArrowNorthMiddleWest,e.southArrowNorthMiddleEast,e.southArrowNorthWest,e.southArrowNorthEast,e.northArrowSouth,e.northArrowSouthMiddleWest,e.northArrowSouthMiddleEast,e.northArrowSouthWest,e.northArrowSouthEast],limiter:Nu,fitInViewport:!0},t),i=Ou._getOptimalPosition(n),o=parseInt(i.left),r=parseInt(i.top),s=i.name;Object.assign(this,{top:r,left:o,position:s})}pin(t){this.unpin(),this._pinWhenIsVisibleCallback=()=>{this.isVisible?this._startPinning(t):this._stopPinning()},this._startPinning(t),this.listenTo(this,"change:isVisible",this._pinWhenIsVisibleCallback)}unpin(){this._pinWhenIsVisibleCallback&&(this._stopPinning(),this.stopListening(this,"change:isVisible",this._pinWhenIsVisibleCallback),this._pinWhenIsVisibleCallback=null,this.hide())}_startPinning(t){this.attachTo(t);const e=Ru(t.target),n=t.limiter?Ru(t.limiter):Nu;this.listenTo(nr.document,"scroll",(i,o)=>{const r=o.target,s=e&&r.contains(e),a=n&&r.contains(n);!s&&!a&&e&&n||this.attachTo(t)},{useCapture:!0}),this.listenTo(nr.window,"resize",()=>{this.attachTo(t)})}_stopPinning(){this.stopListening(nr.document,"scroll"),this.stopListening(nr.window,"resize")}}function Ru(t){return nn(t)?t:Zr(t)?t.commonAncestorContainer:"function"==typeof t?Ru(t()):null}function Du(t,e){return t.top-e.height-Ou.arrowVerticalOffset}function Lu(t){return t.bottom+Ou.arrowVerticalOffset}Ou.arrowHorizontalOffset=25,Ou.arrowVerticalOffset=10,Ou._getOptimalPosition=El,Ou.defaultPositions={northWestArrowSouthWest:(t,e)=>({top:Du(t,e),left:t.left-Ou.arrowHorizontalOffset,name:"arrow_sw"}),northWestArrowSouthMiddleWest:(t,e)=>({top:Du(t,e),left:t.left-.25*e.width-Ou.arrowHorizontalOffset,name:"arrow_smw"}),northWestArrowSouth:(t,e)=>({top:Du(t,e),left:t.left-e.width/2,name:"arrow_s"}),northWestArrowSouthMiddleEast:(t,e)=>({top:Du(t,e),left:t.left-.75*e.width+Ou.arrowHorizontalOffset,name:"arrow_sme"}),northWestArrowSouthEast:(t,e)=>({top:Du(t,e),left:t.left-e.width+Ou.arrowHorizontalOffset,name:"arrow_se"}),northArrowSouthWest:(t,e)=>({top:Du(t,e),left:t.left+t.width/2-Ou.arrowHorizontalOffset,name:"arrow_sw"}),northArrowSouthMiddleWest:(t,e)=>({top:Du(t,e),left:t.left+t.width/2-.25*e.width-Ou.arrowHorizontalOffset,name:"arrow_smw"}),northArrowSouth:(t,e)=>({top:Du(t,e),left:t.left+t.width/2-e.width/2,name:"arrow_s"}),northArrowSouthMiddleEast:(t,e)=>({top:Du(t,e),left:t.left+t.width/2-.75*e.width+Ou.arrowHorizontalOffset,name:"arrow_sme"}),northArrowSouthEast:(t,e)=>({top:Du(t,e),left:t.left+t.width/2-e.width+Ou.arrowHorizontalOffset,name:"arrow_se"}),northEastArrowSouthWest:(t,e)=>({top:Du(t,e),left:t.right-Ou.arrowHorizontalOffset,name:"arrow_sw"}),northEastArrowSouthMiddleWest:(t,e)=>({top:Du(t,e),left:t.right-.25*e.width-Ou.arrowHorizontalOffset,name:"arrow_smw"}),northEastArrowSouth:(t,e)=>({top:Du(t,e),left:t.right-e.width/2,name:"arrow_s"}),northEastArrowSouthMiddleEast:(t,e)=>({top:Du(t,e),left:t.right-.75*e.width+Ou.arrowHorizontalOffset,name:"arrow_sme"}),northEastArrowSouthEast:(t,e)=>({top:Du(t,e),left:t.right-e.width+Ou.arrowHorizontalOffset,name:"arrow_se"}),southWestArrowNorthWest:(t,e)=>({top:Lu(t),left:t.left-Ou.arrowHorizontalOffset,name:"arrow_nw"}),southWestArrowNorthMiddleWest:(t,e)=>({top:Lu(t),left:t.left-.25*e.width-Ou.arrowHorizontalOffset,name:"arrow_nmw"}),southWestArrowNorth:(t,e)=>({top:Lu(t),left:t.left-e.width/2,name:"arrow_n"}),southWestArrowNorthMiddleEast:(t,e)=>({top:Lu(t),left:t.left-.75*e.width+Ou.arrowHorizontalOffset,name:"arrow_nme"}),southWestArrowNorthEast:(t,e)=>({top:Lu(t),left:t.left-e.width+Ou.arrowHorizontalOffset,name:"arrow_ne"}),southArrowNorthWest:(t,e)=>({top:Lu(t),left:t.left+t.width/2-Ou.arrowHorizontalOffset,name:"arrow_nw"}),southArrowNorthMiddleWest:(t,e)=>({top:Lu(t),left:t.left+t.width/2-.25*e.width-Ou.arrowHorizontalOffset,name:"arrow_nmw"}),southArrowNorth:(t,e)=>({top:Lu(t),left:t.left+t.width/2-e.width/2,name:"arrow_n"}),southArrowNorthMiddleEast:(t,e)=>({top:Lu(t),left:t.left+t.width/2-.75*e.width+Ou.arrowHorizontalOffset,name:"arrow_nme"}),southArrowNorthEast:(t,e)=>({top:Lu(t),left:t.left+t.width/2-e.width+Ou.arrowHorizontalOffset,name:"arrow_ne"}),southEastArrowNorthWest:(t,e)=>({top:Lu(t),left:t.right-Ou.arrowHorizontalOffset,name:"arrow_nw"}),southEastArrowNorthMiddleWest:(t,e)=>({top:Lu(t),left:t.right-.25*e.width-Ou.arrowHorizontalOffset,name:"arrow_nmw"}),southEastArrowNorth:(t,e)=>({top:Lu(t),left:t.right-e.width/2,name:"arrow_n"}),southEastArrowNorthMiddleEast:(t,e)=>({top:Lu(t),left:t.right-.75*e.width+Ou.arrowHorizontalOffset,name:"arrow_nme"}),southEastArrowNorthEast:(t,e)=>({top:Lu(t),left:t.right-e.width+Ou.arrowHorizontalOffset,name:"arrow_ne"})};function ju(t,e,n){return t&&zu(t)&&!n.isInline(e)}function Vu(t){return t.getAttribute("widget-type-around")}function zu(t){return!!t.is("element")&&!!t.getCustomProperty("widget")}function Bu(t,e,n={}){return e.setAttribute("contenteditable","false",t),e.addClass("ck-widget",t),e.setCustomProperty("widget",!0,t),t.getFillerOffset=Yu,n.label&&function(t,e,n){n.setCustomProperty("widgetLabel",e,t)}(t,n.label,e),n.hasSelectionHandle&&function(t,e){const n=e.createUIElement("div",{class:"ck ck-widget__selection-handle"},(function(t){const e=this.toDomElement(t),n=new Rl;return n.set("content",'<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M4 0v1H1v3H0V.5A.5.5 0 0 1 .5 0H4zm8 0h3.5a.5.5 0 0 1 .5.5V4h-1V1h-3V0zM4 16H.5a.5.5 0 0 1-.5-.5V12h1v3h3v1zm8 0v-1h3v-3h1v3.5a.5.5 0 0 1-.5.5H12z"/><path fill-opacity=".256" d="M1 1h14v14H1z"/><g class="ck-icon__selected-indicator"><path d="M7 0h2v1H7V0zM0 7h1v2H0V7zm15 0h1v2h-1V7zm-8 8h2v1H7v-1z"/><path fill-opacity=".254" d="M1 1h14v14H1z"/></g></svg>'),n.render(),e.appendChild(n.element),e}));e.insert(e.createPositionAt(t,0),n),e.addClass(["ck-widget_with-selection-handle"],t)}(t,e),Fu(t,e,(t,e,n)=>n.addClass(i(e.classes),t),(t,e,n)=>n.removeClass(i(e.classes),t)),t;function i(t){return Array.isArray(t)?t:[t]}}function Fu(t,e,n,i){const o=new Pu;o.on("change:top",(e,o)=>{o.oldDescriptor&&i(t,o.oldDescriptor,o.writer),o.newDescriptor&&n(t,o.newDescriptor,o.writer)}),e.setCustomProperty("addHighlight",(t,e,n)=>o.add(e,n),t),e.setCustomProperty("removeHighlight",(t,e,n)=>o.remove(e,n),t)}function Uu(t){const e=t.getCustomProperty("widgetLabel");return e?"function"==typeof e?e():e:""}function Hu(t,e){return e.addClass(["ck-editor__editable","ck-editor__nested-editable"],t),e.setAttribute("contenteditable",t.isReadOnly?"false":"true",t),t.on("change:isReadOnly",(n,i,o)=>{e.setAttribute("contenteditable",o?"false":"true",t)}),t.on("change:isFocused",(n,i,o)=>{o?e.addClass("ck-editor__nested-editable_focused",t):e.removeClass("ck-editor__nested-editable_focused",t)}),t}function Wu(t,e){const n=t.getSelectedElement();if(n){const i=Vu(t);if(i)return e.createPositionAt(n,i);if(e.schema.isBlock(n))return e.createPositionAfter(n)}const i=t.getSelectedBlocks().next().value;if(i){if(i.isEmpty)return e.createPositionAt(i,0);const n=e.createPositionAfter(i);return t.focus.isTouching(n)?n:e.createPositionBefore(i)}return t.focus}function qu(t,e){const n=new es(nr.window),i=n.getIntersection(t),o=e.height+Ou.arrowVerticalOffset;if(t.top-o>n.top||t.bottom+o<n.bottom)return null;const r=i||t,s=r.left+r.width/2-e.width/2;return{top:Math.max(t.top,0)+Ou.arrowVerticalOffset,left:s,name:"arrow_n"}}function Yu(){return null}function Gu(t){const e=t.getSelectedElement();return e&&function(t){return!!t.getCustomProperty("image")&&zu(t)}(e)?e:null}function $u(t){return!!t&&t.is("image")}function Ku(t,e,n={}){const i=t.createElement("image",n),o=Wu(e.document.selection,e);e.insertContent(i,o),i.parent&&t.setSelection(i,"on")}function Qu(t){const e=t.schema,n=t.document.selection;return function(t,e,n){const i=function(t,e){const n=Wu(t,e).parent;if(n.isEmpty&&!n.is("$root"))return n.parent;return n}(t,n);return e.checkChild(i,"image")}(n,e,t)&&!function(t,e){const n=t.getSelectedElement();return n&&e.isObject(n)}(n,e)&&function(t){return[...t.focus.getAncestors()].every(t=>!t.is("image"))}(n)}function Ju(t){const e=[];for(const n of t.getChildren())e.push(n),n.is("element")&&e.push(...n.getChildren());return e.find(t=>t.is("img"))}function Zu(t){return n=>{n.on(`attribute:${t}:image`,e)};function e(t,e,n){if(!n.consumable.consume(e.item,t.name))return;const i=n.writer,o=Ju(n.mapper.toViewElement(e.item));i.setAttribute(e.attributeKey,e.attributeNewValue||"",o)}}class Xu extends od{refresh(){this.isEnabled=Qu(this.editor.model)}execute(t){const e=this.editor.model;e.change(n=>{const i=Array.isArray(t.source)?t.source:[t.source];for(const t of i)Ku(n,e,{src:t})})}}class th extends Zl{static get pluginName(){return"ImageEditing"}init(){const t=this.editor,e=t.model.schema,n=t.t,i=t.conversion;t.editing.view.addObserver(Tu),e.register("image",{isObject:!0,isBlock:!0,allowWhere:"$block",allowAttributes:["alt","src","srcset"]}),i.for("dataDowncast").elementToElement({model:"image",view:(t,e)=>eh(e)}),i.for("editingDowncast").elementToElement({model:"image",view:(t,e)=>{return i=eh(e),o=e,r=n("image widget"),o.setCustomProperty("image",!0,i),Bu(i,o,{label:function(){const t=Ju(i).getAttribute("alt");return t?`${t} ${r}`:r}});var i,o,r}}),i.for("downcast").add(Zu("src")).add(Zu("alt")).add(function(){return e=>{e.on("attribute:srcset:image",t)};function t(t,e,n){if(!n.consumable.consume(e.item,t.name))return;const i=n.writer,o=Ju(n.mapper.toViewElement(e.item));if(null===e.attributeNewValue){const t=e.attributeOldValue;t.data&&(i.removeAttribute("srcset",o),i.removeAttribute("sizes",o),t.width&&i.removeAttribute("width",o))}else{const t=e.attributeNewValue;t.data&&(i.setAttribute("srcset",t.data,o),i.setAttribute("sizes","100vw",o),t.width&&i.setAttribute("width",t.width,o))}}}()),i.for("upcast").elementToElement({view:{name:"img",attributes:{src:!0}},model:(t,e)=>e.createElement("image",{src:t.getAttribute("src")})}).attributeToAttribute({view:{name:"img",key:"alt"},model:"alt"}).attributeToAttribute({view:{name:"img",key:"srcset"},model:{key:"srcset",value:t=>{const e={data:t.getAttribute("srcset")};return t.hasAttribute("width")&&(e.width=t.getAttribute("width")),e}}}).add(function(){return e=>{e.on("element:figure",t)};function t(t,e,n){if(!n.consumable.test(e.viewItem,{name:!0,classes:"image"}))return;const i=Ju(e.viewItem);if(!i||!i.hasAttribute("src")||!n.consumable.test(i,{name:!0}))return;const o=n.convertItem(i,e.modelCursor),r=wu(o.modelRange.getItems());r&&(n.convertChildren(e.viewItem,n.writer.createPositionAt(r,0)),e.modelRange=o.modelRange,e.modelCursor=o.modelCursor)}}()),t.commands.add("imageInsert",new Xu(t))}}function eh(t){const e=t.createEmptyElement("img"),n=t.createContainerElement("figure",{class:"image"});return t.insert(t.createPositionAt(n,0),e),n}class nh extends Dr{constructor(t){super(t),this.domEventType="mousedown"}onDomEvent(t){this.fire(t.type,t)}}class ih{constructor(t,e,n){this.model=t,this.attribute=n,this._modelSelection=t.document.selection,this._overrideUid=null,this._isNextGravityRestorationSkipped=!1,e.listenTo(this._modelSelection,"change:range",(t,e)=>{this._isNextGravityRestorationSkipped?this._isNextGravityRestorationSkipped=!1:this._isGravityOverridden&&(!e.directChange&&oh(this._modelSelection.getFirstPosition(),n)||this._restoreGravity())})}handleForwardMovement(t,e){const n=this.attribute;if(!(this._isGravityOverridden||t.isAtStart&&this._hasSelectionAttribute))return ah(t,n)&&this._hasSelectionAttribute?(this._preventCaretMovement(e),this._removeSelectionAttribute(),!0):rh(t,n)||sh(t,n)&&this._hasSelectionAttribute?(this._preventCaretMovement(e),this._overrideGravity(),!0):void 0}handleBackwardMovement(t,e){const n=this.attribute;return this._isGravityOverridden?ah(t,n)&&this._hasSelectionAttribute?(this._preventCaretMovement(e),this._restoreGravity(),this._removeSelectionAttribute(),!0):(this._preventCaretMovement(e),this._restoreGravity(),t.isAtStart&&this._removeSelectionAttribute(),!0):ah(t,n)&&!this._hasSelectionAttribute?(this._preventCaretMovement(e),this._setSelectionAttributeFromTheNodeBefore(t),!0):t.isAtEnd&&sh(t,n)?this._hasSelectionAttribute?void(ch(t,n)&&(this._skipNextAutomaticGravityRestoration(),this._overrideGravity())):(this._preventCaretMovement(e),this._setSelectionAttributeFromTheNodeBefore(t),!0):t.isAtStart?this._hasSelectionAttribute?(this._removeSelectionAttribute(),this._preventCaretMovement(e),!0):void 0:void(ch(t,n)&&(this._skipNextAutomaticGravityRestoration(),this._overrideGravity()))}get _isGravityOverridden(){return!!this._overrideUid}get _hasSelectionAttribute(){return this._modelSelection.hasAttribute(this.attribute)}_overrideGravity(){this._overrideUid=this.model.change(t=>t.overrideSelectionGravity())}_restoreGravity(){this.model.change(t=>{t.restoreSelectionGravity(this._overrideUid),this._overrideUid=null})}_preventCaretMovement(t){t.preventDefault()}_removeSelectionAttribute(){this.model.change(t=>{t.removeSelectionAttribute(this.attribute)})}_setSelectionAttributeFromTheNodeBefore(t){const e=this.attribute;this.model.change(n=>{n.setSelectionAttribute(this.attribute,t.nodeBefore.getAttribute(e))})}_skipNextAutomaticGravityRestoration(){this._isNextGravityRestorationSkipped=!0}}function oh(t,e){return rh(t,e)||sh(t,e)}function rh(t,e){const{nodeBefore:n,nodeAfter:i}=t,o=!!n&&n.hasAttribute(e);return!!i&&i.hasAttribute(e)&&(!o||n.getAttribute(e)!==i.getAttribute(e))}function sh(t,e){const{nodeBefore:n,nodeAfter:i}=t,o=!!n&&n.hasAttribute(e),r=!!i&&i.hasAttribute(e);return o&&(!r||n.getAttribute(e)!==i.getAttribute(e))}function ah(t,e){const{nodeBefore:n,nodeAfter:i}=t,o=!!n&&n.hasAttribute(e);if(!!i&&i.hasAttribute(e)&&o)return i.getAttribute(e)!==n.getAttribute(e)}function ch(t,e){return oh(t.getShiftedBy(-1),e)}function lh(t,e,n){return n.createRange(dh(t,e,!0,n),dh(t,e,!1,n))}function dh(t,e,n,i){let o=t.textNode||(n?t.nodeBefore:t.nodeAfter),r=null;for(;o&&o.getAttribute("linkHref")==e;)r=o,o=n?o.previousSibling:o.nextSibling;return r?i.createPositionAt(r,n?"before":"after"):t}class uh extends od{constructor(t){super(t),this.manualDecorators=new An}restoreManualDecoratorStates(){for(const t of this.manualDecorators)t.value=this._getDecoratorStateFromModel(t.id)}refresh(){const t=this.editor.model,e=t.document,n=wu(e.selection.getSelectedBlocks());n&&n.is("image")&&t.schema.checkAttribute("image","linkHref")?(this.value=n.getAttribute("linkHref"),this.isEnabled=t.schema.checkAttribute(n,"linkHref")):(this.value=e.selection.getAttribute("linkHref"),this.isEnabled=t.schema.checkAttributeInSelection(e.selection,"linkHref"));for(const t of this.manualDecorators)t.value=this._getDecoratorStateFromModel(t.id)}execute(t,e={}){const n=this.editor.model,i=n.document.selection,o=[],r=[];for(const t in e)e[t]?o.push(t):r.push(t);n.change(e=>{if(i.isCollapsed){const s=i.getFirstPosition();if(i.hasAttribute("linkHref")){const a=lh(s,i.getAttribute("linkHref"),n);e.setAttribute("linkHref",t,a),o.forEach(t=>{e.setAttribute(t,!0,a)}),r.forEach(t=>{e.removeAttribute(t,a)}),e.setSelection(e.createPositionAfter(a.end.nodeBefore))}else if(""!==t){const r=Ln(i.getAttributes());r.set("linkHref",t),o.forEach(t=>{r.set(t,!0)});const a=e.createText(t,r);n.insertContent(a,s),e.setSelection(e.createPositionAfter(a))}["linkHref",...o,...r].forEach(t=>{e.removeSelectionAttribute(t)})}else{const s=n.schema.getValidRanges(i.getRanges(),"linkHref"),a=[];for(const t of i.getSelectedBlocks())n.schema.checkAttribute(t,"linkHref")&&a.push(e.createRangeOn(t));const c=a.slice();for(const t of s)this._isRangeToUpdate(t,a)&&c.push(t);for(const n of c)e.setAttribute("linkHref",t,n),o.forEach(t=>{e.setAttribute(t,!0,n)}),r.forEach(t=>{e.removeAttribute(t,n)})}})}_getDecoratorStateFromModel(t){return this.editor.model.document.selection.getAttribute(t)}_isRangeToUpdate(t,e){for(const n of e)if(n.containsRange(t))return!1;return!0}}class hh extends od{refresh(){const t=this.editor.model,e=t.document,n=wu(e.selection.getSelectedBlocks());n&&n.is("image")&&t.schema.checkAttribute("image","linkHref")?this.isEnabled=t.schema.checkAttribute(n,"linkHref"):this.isEnabled=t.schema.checkAttributeInSelection(e.selection,"linkHref")}execute(){const t=this.editor,e=this.editor.model,n=e.document.selection,i=t.commands.get("link");e.change(t=>{const o=n.isCollapsed?[lh(n.getFirstPosition(),n.getAttribute("linkHref"),e)]:n.getRanges();for(const e of o)if(t.removeAttribute("linkHref",e),i)for(const n of i.manualDecorators)t.removeAttribute(n.id,e)})}}class fh{constructor(){this._definitions=new Set}get length(){return this._definitions.size}add(t){Array.isArray(t)?t.forEach(t=>this._definitions.add(t)):this._definitions.add(t)}getDispatcher(){return t=>{t.on("attribute:linkHref",(t,e,n)=>{if(!n.consumable.test(e.item,"attribute:linkHref"))return;const i=n.writer,o=i.document.selection;for(const t of this._definitions){const r=i.createAttributeElement("a",t.attributes,{priority:5});i.setCustomProperty("link",!0,r),t.callback(e.attributeNewValue)?e.item.is("selection")?i.wrap(o.getFirstRange(),r):i.wrap(n.mapper.toViewRange(e.range),r):i.unwrap(n.mapper.toViewRange(e.range),r)}},{priority:"high"})}}}class gh{constructor({id:t,label:e,attributes:n,defaultValue:i}){this.id=t,this.set("value"),this.defaultValue=i,this.label=e,this.attributes=n}}xn(gh,Ui);var mh=function(t,e,n){var i=t.length;return n=void 0===n?i:n,!e&&n>=i?t:ii(t,e,n)},ph=RegExp("[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]");var bh=function(t){return ph.test(t)};var wh=function(t){return t.split("")},kh="[\\ud800-\\udfff]",_h="[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]",vh="\\ud83c[\\udffb-\\udfff]",yh="[^\\ud800-\\udfff]",xh="(?:\\ud83c[\\udde6-\\uddff]){2}",Ah="[\\ud800-\\udbff][\\udc00-\\udfff]",Ch="(?:"+_h+"|"+vh+")"+"?",Th="[\\ufe0e\\ufe0f]?"+Ch+("(?:\\u200d(?:"+[yh,xh,Ah].join("|")+")[\\ufe0e\\ufe0f]?"+Ch+")*"),Ph="(?:"+[yh+_h+"?",_h,xh,Ah,kh].join("|")+")",Sh=RegExp(vh+"(?="+vh+")|"+Ph+Th,"g");var Eh=function(t){return t.match(Sh)||[]};var Mh=function(t){return bh(t)?Eh(t):wh(t)};var Ih=function(t){return function(e){e=Zn(e);var n=bh(e)?Mh(e):void 0,i=n?n[0]:e.charAt(0),o=n?mh(n,1).join(""):e.slice(1);return i[t]()+o}}("toUpperCase");const Nh=/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205f\u3000]/g,Oh=/^(?:(?:https?|ftps?|mailto):|[^a-z]|[a-z+.-]+(?:[^a-z+.:-]|$))/i;function Rh(t,e){const n=e.createAttributeElement("a",{href:t},{priority:5});return e.setCustomProperty("link",!0,n),n}function Dh(t){return function(t){return t.replace(Nh,"").match(Oh)}(t=String(t))?t:"#"}n(47);const Lh=/^(https?:)?\/\//;class jh extends Zl{static get pluginName(){return"LinkEditing"}constructor(t){super(t),t.config.define("link",{addTargetToExternalLinks:!1})}init(){const t=this.editor,e=t.locale;t.model.schema.extend("$text",{allowAttributes:"linkHref"}),t.conversion.for("dataDowncast").attributeToElement({model:"linkHref",view:Rh}),t.conversion.for("editingDowncast").attributeToElement({model:"linkHref",view:(t,e)=>Rh(Dh(t),e)}),t.conversion.for("upcast").elementToAttribute({view:{name:"a",attributes:{href:!0}},model:{key:"linkHref",value:t=>t.getAttribute("href")}}),t.commands.add("link",new uh(t)),t.commands.add("unlink",new hh(t));const n=function(t,e){const n={"Open in a new tab":t("Open in a new tab"),Downloadable:t("Downloadable")};return e.forEach(t=>(t.label&&n[t.label]&&(t.label=n[t.label]),t)),e}(t.t,function(t){const e=[];if(t)for(const[n,i]of Object.entries(t)){const t=Object.assign({},i,{id:"link"+Ih(n)});e.push(t)}return e}(t.config.get("link.decorators")));this._enableAutomaticDecorators(n.filter(t=>"automatic"===t.mode)),this._enableManualDecorators(n.filter(t=>"manual"===t.mode)),function({view:t,model:e,emitter:n,attribute:i,locale:o}){const r=new ih(e,n,i),s=e.document.selection;n.listenTo(t.document,"keydown",(t,e)=>{if(!s.isCollapsed)return;if(e.shiftKey||e.altKey||e.ctrlKey)return;const n=e.keyCode==mo.arrowright,i=e.keyCode==mo.arrowleft;if(!n&&!i)return;const a=s.getFirstPosition(),c=o.contentLanguageDirection;let l;l="ltr"===c&&n||"rtl"===c&&i?r.handleForwardMovement(a,e):r.handleBackwardMovement(a,e),l&&t.stop()},{priority:un.get("high")+1})}({view:t.editing.view,model:t.model,emitter:this,attribute:"linkHref",locale:e}),this._setupLinkHighlight(),this._enableInsertContentSelectionAttributesFixer(),this._enableClickingAfterLink()}_enableAutomaticDecorators(t){const e=this.editor,n=new fh;e.config.get("link.addTargetToExternalLinks")&&n.add({id:"linkIsExternal",mode:"automatic",callback:t=>Lh.test(t),attributes:{target:"_blank",rel:"noopener noreferrer"}}),n.add(t),n.length&&e.conversion.for("downcast").add(n.getDispatcher())}_enableManualDecorators(t){if(!t.length)return;const e=this.editor,n=e.commands.get("link").manualDecorators;t.forEach(t=>{e.model.schema.extend("$text",{allowAttributes:t.id}),n.add(new gh(t)),e.conversion.for("downcast").attributeToElement({model:t.id,view:(e,i)=>{if(e){const e=n.get(t.id).attributes,o=i.createAttributeElement("a",e,{priority:5});return i.setCustomProperty("link",!0,o),o}}}),e.conversion.for("upcast").elementToAttribute({view:{name:"a",attributes:n.get(t.id).attributes},model:{key:t.id}})})}_setupLinkHighlight(){const t=this.editor,e=t.editing.view,n=new Set;e.document.registerPostFixer(e=>{const i=t.model.document.selection;let o=!1;if(i.hasAttribute("linkHref")){const r=lh(i.getFirstPosition(),i.getAttribute("linkHref"),t.model),s=t.editing.mapper.toViewRange(r);for(const t of s.getItems())t.is("a")&&!t.hasClass("ck-link_selected")&&(e.addClass("ck-link_selected",t),n.add(t),o=!0)}return o}),t.conversion.for("editingDowncast").add(t=>{function i(){e.change(t=>{for(const e of n.values())t.removeClass("ck-link_selected",e),n.delete(e)})}t.on("insert",i,{priority:"highest"}),t.on("remove",i,{priority:"highest"}),t.on("attribute",i,{priority:"highest"}),t.on("selection",i,{priority:"highest"})})}_enableInsertContentSelectionAttributesFixer(){const t=this.editor.model,e=t.document.selection;t.on("insertContent",()=>{const n=e.anchor.nodeBefore,i=e.anchor.nodeAfter;e.hasAttribute("linkHref")&&n&&n.hasAttribute("linkHref")&&(i&&i.hasAttribute("linkHref")||t.change(e=>{[...t.document.selection.getAttributeKeys()].filter(t=>t.startsWith("link")).forEach(t=>e.removeSelectionAttribute(t))}))},{priority:"low"})}_enableClickingAfterLink(){const t=this.editor;t.editing.view.addObserver(nh);let e=!1;this.listenTo(t.editing.view.document,"mousedown",()=>{e=!0}),this.listenTo(t.editing.view.document,"selectionChange",()=>{if(!e)return;e=!1;const n=t.model.document.selection;if(!n.isCollapsed)return;if(!n.hasAttribute("linkHref"))return;const i=n.getFirstPosition(),o=lh(i,n.getAttribute("linkHref"),t.model);(i.isTouching(o.start)||i.isTouching(o.end))&&t.model.change(e=>{e.removeSelectionAttribute("linkHref");for(const n of t.commands.get("link").manualDecorators)e.removeSelectionAttribute(n.id)})})}}class Vh extends eu{static get pluginName(){return"Notification"}init(){this.on("show:warning",(t,e)=>{window.alert(e.message)},{priority:"lowest"})}showSuccess(t,e={}){this._showNotification({message:t,type:"success",namespace:e.namespace,title:e.title})}showInfo(t,e={}){this._showNotification({message:t,type:"info",namespace:e.namespace,title:e.title})}showWarning(t,e={}){this._showNotification({message:t,type:"warning",namespace:e.namespace,title:e.title})}_showNotification(t){const e="show:"+t.type+(t.namespace?":"+t.namespace:"");this.fire(e,{message:t.message,type:t.type,title:t.title||""})}}class zh extends od{constructor(t){super(t),this.stopListening(this.editor.model.document,"change"),this.listenTo(this.editor.model.document,"change",()=>this.refresh(),{priority:"low"})}refresh(){const t=this.editor.commands.get("imageInsert"),e=this.editor.commands.get("link");this.isEnabled=t.isEnabled||e.isEnabled}execute(){const t=this.editor,e=this.editor.config.get("ckfinder.openerMethod")||"modal";if("popup"!=e&&"modal"!=e)throw new hn.b('ckfinder-unknown-openerMethod: The openerMethod config option must by "popup" or "modal".',t);const n=this.editor.config.get("ckfinder.options")||{};n.chooseFiles=!0;const i=n.onInit;n.language||(n.language=t.locale.uiLanguage),n.onInit=e=>{i&&i(e),e.on("files:choose",n=>{const i=n.data.files.toArray(),o=i.filter(t=>!t.isImage()),r=i.filter(t=>t.isImage());for(const e of o)t.execute("link",e.getUrl());const s=[];for(const t of r){const n=t.getUrl();s.push(n||e.request("file:getProxyUrl",{file:t}))}s.length&&Bh(t,s)}),e.on("file:choose:resizedImage",e=>{const n=e.data.resizedUrl;if(n)Bh(t,[n]);else{const e=t.plugins.get("Notification"),n=t.locale.t;e.showWarning(n("Could not obtain resized image URL."),{title:n("Selecting resized image failed"),namespace:"ckfinder"})}})},window.CKFinder[e](n)}}function Bh(t,e){if(t.commands.get("imageInsert").isEnabled)t.execute("imageInsert",{source:e});else{const e=t.plugins.get("Notification"),n=t.locale.t;e.showWarning(n("Could not insert image at the current position."),{title:n("Inserting image failed"),namespace:"ckfinder"})}}class Fh extends Zl{static get pluginName(){return"CKFinderEditing"}static get requires(){return[Vh,th,jh]}init(){const t=this.editor;t.commands.add("ckfinder",new zh(t))}}const Uh=/^data:(\S*?);base64,/;class Hh{constructor(t,e,n){if(!t)throw new hn.b("fileuploader-missing-file: File must be provided as the first argument",null);if(!e)throw new hn.b("fileuploader-missing-token: Token must be provided as the second argument.",null);if(!n)throw new hn.b("fileuploader-missing-api-address: Api address must be provided as the third argument.",null);this.file=function(t){if("string"!=typeof t)return!1;const e=t.match(Uh);return!(!e||!e.length)}(t)?function(t,e=512){try{const n=t.match(Uh)[1],i=atob(t.replace(Uh,"")),o=[];for(let t=0;t<i.length;t+=e){const n=i.slice(t,t+e),r=new Array(n.length);for(let t=0;t<n.length;t++)r[t]=n.charCodeAt(t);o.push(new Uint8Array(r))}return new Blob(o,{type:n})}catch(t){throw new hn.b("fileuploader-decoding-image-data-error: Problem with decoding Base64 image data.",null)}}(t):t,this._token=e,this._apiAddress=n}onProgress(t){return this.on("progress",(e,n)=>t(n)),this}onError(t){return this.once("error",(e,n)=>t(n)),this}abort(){this.xhr.abort()}send(){return this._prepareRequest(),this._attachXHRListeners(),this._sendRequest()}_prepareRequest(){const t=new XMLHttpRequest;t.open("POST",this._apiAddress),t.setRequestHeader("Authorization",this._token.value),t.responseType="json",this.xhr=t}_attachXHRListeners(){const t=this,e=this.xhr;function n(e){return()=>t.fire("error",e)}e.addEventListener("error",n("Network Error")),e.addEventListener("abort",n("Abort")),e.upload&&e.upload.addEventListener("progress",t=>{t.lengthComputable&&this.fire("progress",{total:t.total,uploaded:t.loaded})}),e.addEventListener("load",()=>{const t=e.status,n=e.response;if(t<200||t>299)return this.fire("error",n.message||n.error)})}_sendRequest(){const t=new FormData,e=this.xhr;return t.append("file",this.file),new Promise((n,i)=>{e.addEventListener("load",()=>{const t=e.status,o=e.response;return t<200||t>299?o.message?i(new hn.b("fileuploader-uploading-data-failed: Uploading file failed.",this,{message:o.message})):i(o.error):n(o)}),e.addEventListener("error",()=>i(new Error("Network Error"))),e.addEventListener("abort",()=>i(new Error("Abort"))),e.send(t)})}}xn(Hh,mn);const Wh={refreshInterval:36e5,autoRefresh:!0};class qh{constructor(t,e=Wh){if(!t)throw new hn.b("token-missing-token-url: A `tokenUrl` must be provided as the first constructor argument.",this);this.set("value",e.initValue),this._refresh="function"==typeof t?t:()=>{return e=t,new Promise((t,n)=>{const i=new XMLHttpRequest;i.open("GET",e),i.addEventListener("load",()=>{const e=i.status,o=i.response;return e<200||e>299?n(new hn.b("token-cannot-download-new-token: Cannot download new token from the provided url.",null)):t(o)}),i.addEventListener("error",()=>n(new Error("Network Error"))),i.addEventListener("abort",()=>n(new Error("Abort"))),i.send()});var e},this._options=Object.assign({},Wh,e)}init(){return new Promise((t,e)=>{this._options.autoRefresh&&this._startRefreshing(),this.value?t(this):this.refreshToken().then(t).catch(e)})}refreshToken(){return this._refresh().then(t=>this.set("value",t)).then(()=>this)}destroy(){this._stopRefreshing()}_startRefreshing(){this._refreshInterval=setInterval(()=>this.refreshToken(),this._options.refreshInterval)}_stopRefreshing(){clearInterval(this._refreshInterval)}static create(t,e=Wh){return new qh(t,e).init()}}xn(qh,Ui);var Yh=qh;class Gh extends eu{static get pluginName(){return"CloudServices"}init(){const t=this.context.config.get("cloudServices")||{};for(const e in t)this[e]=t[e];if(this.tokenUrl)return this.token=new Gh.Token(this.tokenUrl),this.token.init();this.token=null}destroy(){super.destroy(),this.token&&this.token.destroy()}}Gh.Token=Yh;class $h extends Zl{static get requires(){return[ou,Gh]}init(){const t=this.editor,e=t.plugins.get(Gh),n=e.token,i=e.uploadUrl;n&&(this._uploadGateway=new $h._UploadGateway(n,i),t.plugins.get(ou).createUploadAdapter=t=>new Kh(this._uploadGateway,t))}}class Kh{constructor(t,e){this.uploadGateway=t,this.loader=e}upload(){return this.loader.file.then(t=>(this.fileUploader=this.uploadGateway.upload(t),this.fileUploader.on("progress",(t,e)=>{this.loader.uploadTotal=e.total,this.loader.uploaded=e.uploaded}),this.fileUploader.send()))}abort(){this.fileUploader.abort()}}$h._UploadGateway=class{constructor(t,e){if(!t)throw new hn.b("uploadgateway-missing-token: Token must be provided.",null);if(!e)throw new hn.b("uploadgateway-missing-api-address: Api address must be provided.",null);this._token=t,this._apiAddress=e}upload(t){return new Hh(t,this._token,this._apiAddress)}};n(49);const Qh=["before","after"],Jh=(new DOMParser).parseFromString('<svg viewBox="0 0 10 8" xmlns="http://www.w3.org/2000/svg"><polyline points="8.05541992 0.263427734 8.05541992 4.23461914 1.28417969 4.23461914" transform="translate(1,0)"></polyline><line x1="0" y1="4.21581031" x2="2" y2="2.17810059" transform="translate(1, 0)"></line><line x1="0" y1="6.21581031" x2="2" y2="4.17810059" transform="translate(2, 5.196955) scale(1, -1) translate(-1, -5.196955)"></line></svg>\n',"image/svg+xml").firstChild;class Zh extends Zl{static get pluginName(){return"WidgetTypeAround"}constructor(t){super(t),this._currentFakeCaretModelElement=null}init(){this._enableTypeAroundUIInjection(),this._enableInsertingParagraphsOnButtonClick(),this._enableInsertingParagraphsOnEnterKeypress(),this._enableInsertingParagraphsOnTypingKeystroke(),this._enableTypeAroundFakeCaretActivationUsingKeyboardArrows(),this._enableDeleteIntegration(),this._enableInsertContentIntegration()}destroy(){this._currentFakeCaretModelElement=null}_insertParagraph(t,e){const n=this.editor,i=n.editing.view;n.execute("insertParagraph",{position:n.model.createPositionAt(t,e)}),i.focus(),i.scrollToTheSelection()}_insertParagraphAccordingToFakeCaretPosition(){const t=this.editor.model.document.selection,e=Vu(t);if(!e)return!1;const n=t.getSelectedElement();return this._insertParagraph(n,e),!0}_enableTypeAroundUIInjection(){const t=this.editor,e=t.model.schema,n=t.locale.t,i={before:n("Insert paragraph before block"),after:n("Insert paragraph after block")};t.editing.downcastDispatcher.on("insert",(t,n,o)=>{const r=o.mapper.toViewElement(n.item);ju(r,n.item,e)&&function(t,e,n){const i=t.createUIElement("div",{class:"ck ck-reset_all ck-widget__type-around"},(function(t){const n=this.toDomElement(t);return function(t,e){for(const n of Qh){const i=new Gc({tag:"div",attributes:{class:["ck","ck-widget__type-around__button","ck-widget__type-around__button_"+n],title:e[n]},children:[t.ownerDocument.importNode(Jh,!0)]});t.appendChild(i.render())}}(n,e),function(t){const e=new Gc({tag:"div",attributes:{class:["ck","ck-widget__type-around__fake-caret"]}});t.appendChild(e.render())}(n),n}));t.insert(t.createPositionAt(n,"end"),i)}(o.writer,i,r)},{priority:"low"})}_enableTypeAroundFakeCaretActivationUsingKeyboardArrows(){const t=this.editor,e=t.model,n=e.document.selection,i=e.schema;function o(t){return"ck-widget_type-around_show-fake-caret_"+t}t.editing.view.document.on("keydown",(t,e)=>{ko(e.keyCode)&&this._handleArrowKeyPress(t,e)},{priority:un.get("high")+10}),n.on("change:range",(e,n)=>{n.directChange&&t.model.change(t=>{t.removeSelectionAttribute("widget-type-around")})}),e.document.on("change:data",()=>{const e=n.getSelectedElement();if(e){if(ju(t.editing.mapper.toViewElement(e),e,i))return}t.model.change(t=>{t.removeSelectionAttribute("widget-type-around")})}),t.editing.downcastDispatcher.on("selection",(t,e,n)=>{const r=n.writer;if(this._currentFakeCaretModelElement){const t=n.mapper.toViewElement(this._currentFakeCaretModelElement);t&&(r.removeClass(Qh.map(o),t),this._currentFakeCaretModelElement=null)}const s=e.selection.getSelectedElement();if(!s)return;const a=n.mapper.toViewElement(s);if(!ju(a,s,i))return;const c=Vu(e.selection);c&&(r.addClass(o(c),a),this._currentFakeCaretModelElement=s)}),this.listenTo(t.ui.focusTracker,"change:isFocused",(e,n,i)=>{i||t.model.change(t=>{t.removeSelectionAttribute("widget-type-around")})})}_handleArrowKeyPress(t,e){const n=this.editor,i=n.model,o=i.document.selection,r=i.schema,s=n.editing.view,a=vo(e.keyCode,n.locale.contentLanguageDirection),c=s.document.selection.getSelectedElement();let l;ju(c,n.editing.mapper.toModelElement(c),r)?l=this._handleArrowKeyPressOnSelectedWidget(a):o.isCollapsed&&(l=this._handleArrowKeyPressWhenSelectionNextToAWidget(a)),l&&(e.preventDefault(),t.stop())}_handleArrowKeyPressOnSelectedWidget(t){const e=this.editor.model,n=Vu(e.document.selection);return e.change(e=>{if(!n)return e.setSelectionAttribute("widget-type-around",t?"after":"before"),!0;if(!(n===(t?"after":"before")))return e.removeSelectionAttribute("widget-type-around"),!0;return!1})}_handleArrowKeyPressWhenSelectionNextToAWidget(t){const e=this.editor,n=e.model,i=n.schema,o=e.plugins.get("Widget"),r=o._getObjectElementNextToSelection(t);return!!ju(e.editing.mapper.toViewElement(r),r,i)&&(n.change(e=>{o._setSelectionOverElement(r),e.setSelectionAttribute("widget-type-around",t?"before":"after")}),!0)}_enableInsertingParagraphsOnButtonClick(){const t=this.editor,e=t.editing.view;e.document.on("mousedown",(n,i)=>{const o=i.domTarget.closest(".ck-widget__type-around__button");if(!o)return;const r=function(t){return t.classList.contains("ck-widget__type-around__button_before")?"before":"after"}(o),s=function(t,e){const n=t.closest(".ck-widget");return e.mapDomToView(n)}(o,e.domConverter),a=t.editing.mapper.toModelElement(s);this._insertParagraph(a,r),i.preventDefault(),n.stop()})}_enableInsertingParagraphsOnEnterKeypress(){const t=this.editor,e=t.editing.view;this.listenTo(e.document,"enter",(n,i)=>{const o=e.document.selection.getSelectedElement(),r=t.editing.mapper.toModelElement(o),s=t.model.schema;let a;this._insertParagraphAccordingToFakeCaretPosition()?a=!0:ju(o,r,s)&&(this._insertParagraph(r,i.isSoft?"before":"after"),a=!0),a&&(i.preventDefault(),n.stop())})}_enableInsertingParagraphsOnTypingKeystroke(){const t=this.editor.editing.view,e=[mo.enter,mo.delete,mo.backspace];t.document.on("keydown",(t,n)=>{e.includes(n.keyCode)||Ad(n)||this._insertParagraphAccordingToFakeCaretPosition()},{priority:un.get("high")+1})}_enableDeleteIntegration(){const t=this.editor,e=t.editing.view,n=t.model,i=n.schema;this.listenTo(e.document,"delete",(e,o)=>{const r=Vu(n.document.selection);if(!r)return;const s=o.direction,a=n.document.selection.getSelectedElement(),c="forward"==s;if("before"===r===c)t.execute("delete",{selection:n.createSelection(a,"on")});else{const e=i.getNearestSelectionRange(n.createPositionAt(a,r),s);if(e)if(e.isCollapsed){const o=n.createSelection(e.start);if(n.modifySelection(o,{direction:s}),o.focus.isEqual(e.start)){const t=function(t,e){let n=e;for(const i of e.getAncestors({parentFirst:!0})){if(i.childCount>1||t.isLimit(i))break;n=i}return n}(i,e.start.parent);n.deleteContent(n.createSelection(t,"on"),{doNotAutoparagraph:!0})}else n.change(n=>{n.setSelection(e),t.execute(c?"forwardDelete":"delete")})}else n.change(n=>{n.setSelection(e),t.execute(c?"forwardDelete":"delete")})}o.preventDefault(),e.stop()},{priority:un.get("high")+1})}_enableInsertContentIntegration(){const t=this.editor,e=this.editor.model,n=e.document.selection;this.listenTo(t.model,"insertContent",(t,[i,o])=>{if(o&&!o.is("documentSelection"))return;const r=Vu(n);return r?(t.stop(),e.change(t=>{const o=n.getSelectedElement(),s=e.createPositionAt(o,r),a=t.createSelection(s),c=e.insertContent(i,a);return t.setSelection(a),c})):void 0},{priority:"high"})}}n(51);class Xh extends Zl{static get pluginName(){return"Widget"}static get requires(){return[Zh]}init(){const t=this.editor.editing.view,e=t.document;this._previouslySelected=new Set,this.editor.editing.downcastDispatcher.on("selection",(t,e,n)=>{this._clearPreviouslySelectedWidgets(n.writer);const i=n.writer,o=i.document.selection,r=o.getSelectedElement();let s=null;for(const t of o.getRanges())for(const e of t){const t=e.item;zu(t)&&!tf(t,s)&&(i.addClass("ck-widget_selected",t),this._previouslySelected.add(t),s=t,t==r&&i.setSelection(o.getRanges(),{fake:!0,label:Uu(r)}))}},{priority:"low"}),t.addObserver(nh),this.listenTo(e,"mousedown",(...t)=>this._onMousedown(...t)),this.listenTo(e,"keydown",(...t)=>{this._handleSelectionChangeOnArrowKeyPress(...t)},{priority:"high"}),this.listenTo(e,"keydown",(...t)=>{this._preventDefaultOnArrowKeyPress(...t)},{priority:un.get("high")-20}),this.listenTo(e,"delete",(t,e)=>{this._handleDelete("forward"==e.direction)&&(e.preventDefault(),t.stop())},{priority:"high"})}_onMousedown(t,e){const n=this.editor,i=n.editing.view,o=i.document;let r=e.target;if(function(t){for(;t;){if(t.is("editableElement")&&!t.is("rootElement"))return!0;if(zu(t))return!1;t=t.parent}return!1}(r)){if(ho.isSafari&&e.domEvent.detail>=3){const t=n.editing.mapper.toModelElement(r);this.editor.model.change(n=>{e.preventDefault(),n.setSelection(t,"in")})}return}if(!zu(r)&&(r=r.findAncestor(zu),!r))return;e.preventDefault(),o.isFocused||i.focus();const s=n.editing.mapper.toModelElement(r);this._setSelectionOverElement(s)}_handleSelectionChangeOnArrowKeyPress(t,e){const n=e.keyCode;if(!ko(n))return;const i=this.editor.model,o=i.schema,r=i.document.selection,s=r.getSelectedElement(),a=vo(n,this.editor.locale.contentLanguageDirection);if(s&&o.isObject(s)){const n=a?r.getLastPosition():r.getFirstPosition(),s=o.getNearestSelectionRange(n,a?"forward":"backward");return void(s&&(i.change(t=>{t.setSelection(s)}),e.preventDefault(),t.stop()))}if(!r.isCollapsed)return;const c=this._getObjectElementNextToSelection(a);c&&o.isObject(c)&&(this._setSelectionOverElement(c),e.preventDefault(),t.stop())}_preventDefaultOnArrowKeyPress(t,e){if(!ko(e.keyCode))return;const n=this.editor.model,i=n.schema,o=n.document.selection.getSelectedElement();o&&i.isObject(o)&&(e.preventDefault(),t.stop())}_handleDelete(t){if(this.editor.isReadOnly)return;const e=this.editor.model.document.selection;if(!e.isCollapsed)return;const n=this._getObjectElementNextToSelection(t);return n?(this.editor.model.change(t=>{let i=e.anchor.parent;for(;i.isEmpty;){const e=i;i=e.parent,t.remove(e)}this._setSelectionOverElement(n)}),!0):void 0}_setSelectionOverElement(t){this.editor.model.change(e=>{e.setSelection(e.createRangeOn(t))})}_getObjectElementNextToSelection(t){const e=this.editor.model,n=e.schema,i=e.document.selection,o=e.createSelection(i);e.modifySelection(o,{direction:t?"forward":"backward"});const r=t?o.focus.nodeBefore:o.focus.nodeAfter;return r&&n.isObject(r)?r:null}_clearPreviouslySelectedWidgets(t){for(const e of this._previouslySelected)t.removeClass("ck-widget_selected",e);this._previouslySelected.clear()}}function tf(t,e){return!!e&&Array.from(t.getAncestors()).includes(e)}class ef extends od{refresh(){const t=this.editor.model.document.selection.getSelectedElement();this.isEnabled=$u(t),$u(t)&&t.hasAttribute("alt")?this.value=t.getAttribute("alt"):this.value=!1}execute(t){const e=this.editor.model,n=e.document.selection.getSelectedElement();e.change(e=>{e.setAttribute("alt",t.newValue,n)})}}class nf extends Zl{static get pluginName(){return"ImageTextAlternativeEditing"}init(){this.editor.commands.add("imageTextAlternative",new ef(this.editor))}}n(53);class of extends hl{constructor(t,e){super(t);const n="ck-labeled-field-view-"+dn(),i="ck-labeled-field-view-status-"+dn();this.fieldView=e(this,n,i),this.set("label"),this.set("isEnabled",!0),this.set("errorText",null),this.set("infoText",null),this.set("class"),this.labelView=this._createLabelView(n),this.statusView=this._createStatusView(i),this.bind("_statusText").to(this,"errorText",this,"infoText",(t,e)=>t||e);const o=this.bindTemplate;this.setTemplate({tag:"div",attributes:{class:["ck","ck-labeled-field-view",o.to("class"),o.if("isEnabled","ck-disabled",t=>!t)]},children:[this.labelView,this.fieldView,this.statusView]})}_createLabelView(t){const e=new pl(this.locale);return e.for=t,e.bind("text").to(this,"label"),e}_createStatusView(t){const e=new hl(this.locale),n=this.bindTemplate;return e.setTemplate({tag:"div",attributes:{class:["ck","ck-labeled-field-view__status",n.if("errorText","ck-labeled-field-view__status_error"),n.if("_statusText","ck-hidden",t=>!t)],id:t,role:n.if("errorText","alert")},children:[{text:n.to("_statusText")}]}),e}focus(){this.fieldView.focus()}}n(55);class rf extends hl{constructor(t){super(t),this.set("value"),this.set("id"),this.set("placeholder"),this.set("isReadOnly",!1),this.set("hasError",!1),this.set("ariaDescribedById");const e=this.bindTemplate;this.setTemplate({tag:"input",attributes:{type:"text",class:["ck","ck-input","ck-input-text",e.if("hasError","ck-error")],id:e.to("id"),placeholder:e.to("placeholder"),readonly:e.to("isReadOnly"),"aria-invalid":e.if("hasError",!0),"aria-describedby":e.to("ariaDescribedById")},on:{input:e.to("input")}})}render(){super.render();const t=t=>{this.element.value=t||0===t?t:""};t(this.value),this.on("change:value",(e,n,i)=>{t(i)})}select(){this.element.select()}focus(){this.element.focus()}}function sf(t,e,n){const i=new rf(t.locale);return i.set({id:e,ariaDescribedById:n}),i.bind("isReadOnly").to(t,"isEnabled",t=>!t),i.bind("hasError").to(t,"errorText",t=>!!t),i.on("input",()=>{t.errorText=null}),i}function af({view:t}){t.listenTo(t.element,"submit",(e,n)=>{n.preventDefault(),t.fire("submit")},{useCapture:!0})}var cf='<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.972 16.615a.997.997 0 0 1-.744-.292l-4.596-4.596a1 1 0 1 1 1.414-1.414l3.926 3.926 9.937-9.937a1 1 0 0 1 1.414 1.415L7.717 16.323a.997.997 0 0 1-.745.292z"/></svg>',lf='<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.591 10.177l4.243 4.242a1 1 0 0 1-1.415 1.415l-4.242-4.243-4.243 4.243a1 1 0 0 1-1.414-1.415l4.243-4.242L4.52 5.934A1 1 0 0 1 5.934 4.52l4.243 4.243 4.242-4.243a1 1 0 1 1 1.415 1.414l-4.243 4.243z"/></svg>';n(57);class df extends hl{constructor(t){super(t);const e=this.locale.t;this.focusTracker=new jc,this.keystrokes=new Sc,this.labeledInput=this._createLabeledInputView(),this.saveButtonView=this._createButton(e("Save"),cf,"ck-button-save"),this.saveButtonView.type="submit",this.cancelButtonView=this._createButton(e("Cancel"),lf,"ck-button-cancel","cancel"),this._focusables=new Yc,this._focusCycler=new xl({focusables:this._focusables,focusTracker:this.focusTracker,keystrokeHandler:this.keystrokes,actions:{focusPrevious:"shift + tab",focusNext:"tab"}}),this.setTemplate({tag:"form",attributes:{class:["ck","ck-text-alternative-form"],tabindex:"-1"},children:[this.labeledInput,this.saveButtonView,this.cancelButtonView]})}render(){super.render(),this.keystrokes.listenTo(this.element),af({view:this}),[this.labeledInput,this.saveButtonView,this.cancelButtonView].forEach(t=>{this._focusables.add(t),this.focusTracker.add(t.element)})}_createButton(t,e,n,i){const o=new Ll(this.locale);return o.set({label:t,icon:e,tooltip:!0}),o.extendTemplate({attributes:{class:n}}),i&&o.delegate("execute").to(this,i),o}_createLabeledInputView(){const t=this.locale.t,e=new of(this.locale,sf);return e.label=t("Text alternative"),e.fieldView.placeholder=t("Text alternative"),e}}n(59),n(61);const uf=_l("px");class hf extends Zl{static get pluginName(){return"ContextualBalloon"}constructor(t){super(t),this.positionLimiter=()=>{const t=this.editor.editing.view,e=t.document.selection.editableElement;return e?t.domConverter.mapViewToDom(e.root):null},this.set("visibleView",null),this.view=new Ou(t.locale),t.ui.view.body.add(this.view),t.ui.focusTracker.add(this.view.element),this._viewToStack=new Map,this._idToStack=new Map,this.set("_numberOfStacks",0),this.set("_singleViewMode",!1),this._rotatorView=this._createRotatorView(),this._fakePanelsView=this._createFakePanelsView()}hasView(t){return Array.from(this._viewToStack.keys()).includes(t)}add(t){if(this.hasView(t.view))throw new hn.b("contextualballoon-add-view-exist: Cannot add configuration of the same view twice.",[this,t]);const e=t.stackId||"main";if(!this._idToStack.has(e))return this._idToStack.set(e,new Map([[t.view,t]])),this._viewToStack.set(t.view,this._idToStack.get(e)),this._numberOfStacks=this._idToStack.size,void(this._visibleStack&&!t.singleViewMode||this.showStack(e));const n=this._idToStack.get(e);t.singleViewMode&&this.showStack(e),n.set(t.view,t),this._viewToStack.set(t.view,n),n===this._visibleStack&&this._showView(t)}remove(t){if(!this.hasView(t))throw new hn.b("contextualballoon-remove-view-not-exist: Cannot remove the configuration of a non-existent view.",[this,t]);const e=this._viewToStack.get(t);this._singleViewMode&&this.visibleView===t&&(this._singleViewMode=!1),this.visibleView===t&&(1===e.size?this._idToStack.size>1?this._showNextStack():(this.view.hide(),this.visibleView=null,this._rotatorView.hideView()):this._showView(Array.from(e.values())[e.size-2])),1===e.size?(this._idToStack.delete(this._getStackId(e)),this._numberOfStacks=this._idToStack.size):e.delete(t),this._viewToStack.delete(t)}updatePosition(t){t&&(this._visibleStack.get(this.visibleView).position=t),this.view.pin(this._getBalloonPosition()),this._fakePanelsView.updatePosition()}showStack(t){this.visibleStack=t;const e=this._idToStack.get(t);if(!e)throw new hn.b("contextualballoon-showstack-stack-not-exist: Cannot show a stack that does not exist.",this);this._visibleStack!==e&&this._showView(Array.from(e.values()).pop())}get _visibleStack(){return this._viewToStack.get(this.visibleView)}_getStackId(t){return Array.from(this._idToStack.entries()).find(e=>e[1]===t)[0]}_showNextStack(){const t=Array.from(this._idToStack.values());let e=t.indexOf(this._visibleStack)+1;t[e]||(e=0),this.showStack(this._getStackId(t[e]))}_showPrevStack(){const t=Array.from(this._idToStack.values());let e=t.indexOf(this._visibleStack)-1;t[e]||(e=t.length-1),this.showStack(this._getStackId(t[e]))}_createRotatorView(){const t=new ff(this.editor.locale),e=this.editor.locale.t;return this.view.content.add(t),t.bind("isNavigationVisible").to(this,"_numberOfStacks",this,"_singleViewMode",(t,e)=>!e&&t>1),t.on("change:isNavigationVisible",()=>this.updatePosition(),{priority:"low"}),t.bind("counter").to(this,"visibleView",this,"_numberOfStacks",(t,n)=>{if(n<2)return"";const i=Array.from(this._idToStack.values()).indexOf(this._visibleStack)+1;return e("%0 of %1",[i,n])}),t.buttonNextView.on("execute",()=>{t.focusTracker.isFocused&&this.editor.editing.view.focus(),this._showNextStack()}),t.buttonPrevView.on("execute",()=>{t.focusTracker.isFocused&&this.editor.editing.view.focus(),this._showPrevStack()}),t}_createFakePanelsView(){const t=new gf(this.editor.locale,this.view);return t.bind("numberOfPanels").to(this,"_numberOfStacks",this,"_singleViewMode",(t,e)=>!e&&t>=2?Math.min(t-1,2):0),t.listenTo(this.view,"change:top",()=>t.updatePosition()),t.listenTo(this.view,"change:left",()=>t.updatePosition()),this.editor.ui.view.body.add(t),t}_showView({view:t,balloonClassName:e="",withArrow:n=!0,singleViewMode:i=!1}){this.view.class=e,this.view.withArrow=n,this._rotatorView.showView(t),this.visibleView=t,this.view.pin(this._getBalloonPosition()),this._fakePanelsView.updatePosition(),i&&(this._singleViewMode=!0)}_getBalloonPosition(){let t=Array.from(this._visibleStack.values()).pop().position;return t&&!t.limiter&&(t=Object.assign({},t,{limiter:this.positionLimiter})),t}}class ff extends hl{constructor(t){super(t);const e=t.t,n=this.bindTemplate;this.set("isNavigationVisible",!0),this.focusTracker=new jc,this.buttonPrevView=this._createButtonView(e("Previous"),'<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.463 5.187a.888.888 0 1 1 1.254 1.255L9.16 10l3.557 3.557a.888.888 0 1 1-1.254 1.255L7.26 10.61a.888.888 0 0 1 .16-1.382l4.043-4.042z"/></svg>'),this.buttonNextView=this._createButtonView(e("Next"),'<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M8.537 14.813a.888.888 0 1 1-1.254-1.255L10.84 10 7.283 6.442a.888.888 0 1 1 1.254-1.255L12.74 9.39a.888.888 0 0 1-.16 1.382l-4.043 4.042z"/></svg>'),this.content=this.createCollection(),this.setTemplate({tag:"div",attributes:{class:["ck","ck-balloon-rotator"],"z-index":"-1"},children:[{tag:"div",attributes:{class:["ck-balloon-rotator__navigation",n.to("isNavigationVisible",t=>t?"":"ck-hidden")]},children:[this.buttonPrevView,{tag:"span",attributes:{class:["ck-balloon-rotator__counter"]},children:[{text:n.to("counter")}]},this.buttonNextView]},{tag:"div",attributes:{class:"ck-balloon-rotator__content"},children:this.content}]})}render(){super.render(),this.focusTracker.add(this.element)}showView(t){this.hideView(),this.content.add(t)}hideView(){this.content.clear()}_createButtonView(t,e){const n=new Ll(this.locale);return n.set({label:t,icon:e,tooltip:!0}),n}}class gf extends hl{constructor(t,e){super(t);const n=this.bindTemplate;this.set("top",0),this.set("left",0),this.set("height",0),this.set("width",0),this.set("numberOfPanels",0),this.content=this.createCollection(),this._balloonPanelView=e,this.setTemplate({tag:"div",attributes:{class:["ck-fake-panel",n.to("numberOfPanels",t=>t?"":"ck-hidden")],style:{top:n.to("top",uf),left:n.to("left",uf),width:n.to("width",uf),height:n.to("height",uf)}},children:this.content}),this.on("change:numberOfPanels",(t,e,n,i)=>{n>i?this._addPanels(n-i):this._removePanels(i-n),this.updatePosition()})}_addPanels(t){for(;t--;){const t=new hl;t.setTemplate({tag:"div"}),this.content.add(t),this.registerChild(t)}}_removePanels(t){for(;t--;){const t=this.content.last;this.content.remove(t),this.deregisterChild(t),t.destroy()}}updatePosition(){if(this.numberOfPanels){const{top:t,left:e}=this._balloonPanelView,{width:n,height:i}=new es(this._balloonPanelView.element);Object.assign(this,{top:t,left:e,width:n,height:i})}}}function mf(t){const e=t.editing.view,n=Ou.defaultPositions;return{target:e.domConverter.viewToDom(e.document.selection.getSelectedElement()),positions:[n.northArrowSouth,n.northArrowSouthWest,n.northArrowSouthEast,n.southArrowNorth,n.southArrowNorthWest,n.southArrowNorthEast]}}class pf extends Zl{static get requires(){return[hf]}static get pluginName(){return"ImageTextAlternativeUI"}init(){this._createButton(),this._createForm()}destroy(){super.destroy(),this._form.destroy()}_createButton(){const t=this.editor,e=t.t;t.ui.componentFactory.add("imageTextAlternative",n=>{const i=t.commands.get("imageTextAlternative"),o=new Ll(n);return o.set({label:e("Change image text alternative"),icon:'<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M5.085 6.22L2.943 4.078a.75.75 0 1 1 1.06-1.06l2.592 2.59A11.094 11.094 0 0 1 10 5.068c4.738 0 8.578 3.101 8.578 5.083 0 1.197-1.401 2.803-3.555 3.887l1.714 1.713a.75.75 0 0 1-.09 1.138.488.488 0 0 1-.15.084.75.75 0 0 1-.821-.16L6.17 7.304c-.258.11-.51.233-.757.365l6.239 6.24-.006.005.78.78c-.388.094-.78.166-1.174.215l-1.11-1.11h.011L4.55 8.197a7.2 7.2 0 0 0-.665.514l-.112.098 4.897 4.897-.005.006 1.276 1.276a10.164 10.164 0 0 1-1.477-.117l-.479-.479-.009.009-4.863-4.863-.022.031a2.563 2.563 0 0 0-.124.2c-.043.077-.08.158-.108.241a.534.534 0 0 0-.028.133.29.29 0 0 0 .008.072.927.927 0 0 0 .082.226c.067.133.145.26.234.379l3.242 3.365.025.01.59.623c-3.265-.918-5.59-3.155-5.59-4.668 0-1.194 1.448-2.838 3.663-3.93zm7.07.531a4.632 4.632 0 0 1 1.108 5.992l.345.344.046-.018a9.313 9.313 0 0 0 2-1.112c.256-.187.5-.392.727-.613.137-.134.27-.277.392-.431.072-.091.141-.185.203-.286.057-.093.107-.19.148-.292a.72.72 0 0 0 .036-.12.29.29 0 0 0 .008-.072.492.492 0 0 0-.028-.133.999.999 0 0 0-.036-.096 2.165 2.165 0 0 0-.071-.145 2.917 2.917 0 0 0-.125-.2 3.592 3.592 0 0 0-.263-.335 5.444 5.444 0 0 0-.53-.523 7.955 7.955 0 0 0-1.054-.768 9.766 9.766 0 0 0-1.879-.891c-.337-.118-.68-.219-1.027-.301zm-2.85.21l-.069.002a.508.508 0 0 0-.254.097.496.496 0 0 0-.104.679.498.498 0 0 0 .326.199l.045.005c.091.003.181.003.272.012a2.45 2.45 0 0 1 2.017 1.513c.024.061.043.125.069.185a.494.494 0 0 0 .45.287h.008a.496.496 0 0 0 .35-.158.482.482 0 0 0 .13-.335.638.638 0 0 0-.048-.219 3.379 3.379 0 0 0-.36-.723 3.438 3.438 0 0 0-2.791-1.543l-.028-.001h-.013z"/></svg>',tooltip:!0}),o.bind("isEnabled").to(i,"isEnabled"),this.listenTo(o,"execute",()=>{this._showForm()}),o})}_createForm(){const t=this.editor,e=t.editing.view.document;this._balloon=this.editor.plugins.get("ContextualBalloon"),this._form=new df(t.locale),this._form.render(),this.listenTo(this._form,"submit",()=>{t.execute("imageTextAlternative",{newValue:this._form.labeledInput.fieldView.element.value}),this._hideForm(!0)}),this.listenTo(this._form,"cancel",()=>{this._hideForm(!0)}),this._form.keystrokes.set("Esc",(t,e)=>{this._hideForm(!0),e()}),this.listenTo(t.ui,"update",()=>{Gu(e.selection)?this._isVisible&&function(t){const e=t.plugins.get("ContextualBalloon");if(Gu(t.editing.view.document.selection)){const n=mf(t);e.updatePosition(n)}}(t):this._hideForm(!0)}),Hl({emitter:this._form,activator:()=>this._isVisible,contextElements:[this._balloon.view.element],callback:()=>this._hideForm()})}_showForm(){if(this._isVisible)return;const t=this.editor,e=t.commands.get("imageTextAlternative"),n=this._form.labeledInput;this._isInBalloon||this._balloon.add({view:this._form,position:mf(t)}),n.fieldView.value=n.fieldView.element.value=e.value||"",this._form.labeledInput.fieldView.select()}_hideForm(t){this._isInBalloon&&(this._form.focusTracker.isFocused&&this._form.saveButtonView.focus(),this._balloon.remove(this._form),t&&this.editor.editing.view.focus())}get _isVisible(){return this._balloon.visibleView===this._form}get _isInBalloon(){return this._balloon.hasView(this._form)}}class bf extends Zl{static get requires(){return[nf,pf]}static get pluginName(){return"ImageTextAlternative"}}n(63);class wf extends Zl{static get requires(){return[th,Xh,bf]}static get pluginName(){return"Image"}}class kf extends hl{constructor(t){super(t),this.buttonView=new Ll(t),this._fileInputView=new _f(t),this._fileInputView.bind("acceptedType").to(this),this._fileInputView.bind("allowMultipleFiles").to(this),this._fileInputView.delegate("done").to(this),this.setTemplate({tag:"span",attributes:{class:"ck-file-dialog-button"},children:[this.buttonView,this._fileInputView]}),this.buttonView.on("execute",()=>{this._fileInputView.open()})}focus(){this.buttonView.focus()}}class _f extends hl{constructor(t){super(t),this.set("acceptedType"),this.set("allowMultipleFiles",!1);const e=this.bindTemplate;this.setTemplate({tag:"input",attributes:{class:["ck-hidden"],type:"file",tabindex:"-1",accept:e.to("acceptedType"),multiple:e.to("allowMultipleFiles")},on:{change:e.to(()=>{this.element&&this.element.files&&this.element.files.length&&this.fire("done",this.element.files),this.element.value=""})}})}open(){this.element.click()}}function vf(t){const e=t.map(t=>t.replace("+","\\+"));return new RegExp(`^image\\/(${e.join("|")})$`)}class yf extends Zl{init(){const t=this.editor,e=t.t;t.ui.componentFactory.add("imageUpload",n=>{const i=new kf(n),o=t.commands.get("imageUpload"),r=t.config.get("image.upload.types"),s=vf(r);return i.set({acceptedType:r.map(t=>"image/"+t).join(","),allowMultipleFiles:!0}),i.buttonView.set({label:e("Insert image"),icon:'<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.91 10.54c.26-.23.64-.21.88.03l3.36 3.14 2.23-2.06a.64.64 0 0 1 .87 0l2.52 2.97V4.5H3.2v10.12l3.71-4.08zm10.27-7.51c.6 0 1.09.47 1.09 1.05v11.84c0 .59-.49 1.06-1.09 1.06H2.79c-.6 0-1.09-.47-1.09-1.06V4.08c0-.58.49-1.05 1.1-1.05h14.38zm-5.22 5.56a1.96 1.96 0 1 1 3.4-1.96 1.96 1.96 0 0 1-3.4 1.96z"/></svg>',tooltip:!0}),i.buttonView.bind("isEnabled").to(o),i.on("done",(e,n)=>{const i=Array.from(n).filter(t=>s.test(t.type));i.length&&t.execute("imageUpload",{file:i})}),i})}}n(65),n(67),n(69);class xf extends Zl{constructor(t){super(t),this.placeholder="data:image/svg+xml;utf8,"+encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 700 250"><rect rx="4"/></svg>')}init(){this.editor.editing.downcastDispatcher.on("attribute:uploadStatus:image",(...t)=>this.uploadStatusChange(...t))}uploadStatusChange(t,e,n){const i=this.editor,o=e.item,r=o.getAttribute("uploadId");if(!n.consumable.consume(e.item,t.name))return;const s=i.plugins.get(ou),a=r?e.attributeNewValue:null,c=this.placeholder,l=i.editing.mapper.toViewElement(o),d=n.writer;if("reading"==a)return Af(l,d),void Cf(c,l,d);if("uploading"==a){const t=s.loaders.get(r);return Af(l,d),void(t?(Tf(l,d),function(t,e,n,i){const o=function(t){const e=t.createUIElement("div",{class:"ck-progress-bar"});return t.setCustomProperty("progressBar",!0,e),e}(e);e.insert(e.createPositionAt(t,"end"),o),n.on("change:uploadedPercent",(t,e,n)=>{i.change(t=>{t.setStyle("width",n+"%",o)})})}(l,d,t,i.editing.view),function(t,e,n){if(n.data){const i=Ju(t);e.setAttribute("src",n.data,i)}}(l,d,t)):Cf(c,l,d))}"complete"==a&&s.loaders.get(r)&&function(t,e,n){const i=e.createUIElement("div",{class:"ck-image-upload-complete-icon"});e.insert(e.createPositionAt(t,"end"),i),setTimeout(()=>{n.change(t=>t.remove(t.createRangeOn(i)))},3e3)}(l,d,i.editing.view),function(t,e){Sf(t,e,"progressBar")}(l,d),Tf(l,d),function(t,e){e.removeClass("ck-appear",t)}(l,d)}}function Af(t,e){t.hasClass("ck-appear")||e.addClass("ck-appear",t)}function Cf(t,e,n){e.hasClass("ck-image-upload-placeholder")||n.addClass("ck-image-upload-placeholder",e);const i=Ju(e);i.getAttribute("src")!==t&&n.setAttribute("src",t,i),Pf(e,"placeholder")||n.insert(n.createPositionAfter(i),function(t){const e=t.createUIElement("div",{class:"ck-upload-placeholder-loader"});return t.setCustomProperty("placeholder",!0,e),e}(n))}function Tf(t,e){t.hasClass("ck-image-upload-placeholder")&&e.removeClass("ck-image-upload-placeholder",t),Sf(t,e,"placeholder")}function Pf(t,e){for(const n of t.getChildren())if(n.getCustomProperty(e))return n}function Sf(t,e,n){const i=Pf(t,n);i&&e.remove(e.createRangeOn(i))}class Ef{constructor(t){this.document=t}createDocumentFragment(t){return new To(this.document,t)}createElement(t,e,n){return new Oi(this.document,t,e,n)}createText(t){return new Rn(this.document,t)}clone(t,e=!1){return t._clone(e)}appendChild(t,e){return e._appendChild(t)}insertChild(t,e,n){return n._insertChild(t,e)}removeChildren(t,e,n){return n._removeChildren(t,e)}remove(t){const e=t.parent;return e?this.removeChildren(e.getChildIndex(t),1,e):[]}replace(t,e){const n=t.parent;if(n){const i=n.getChildIndex(t);return this.removeChildren(i,1,n),this.insertChild(i,e,n),!0}return!1}unwrapElement(t){const e=t.parent;if(e){const n=e.getChildIndex(t);this.remove(t),this.insertChild(n,t.getChildren(),e)}}rename(t,e){const n=new Oi(this.document,t,e.getAttributes(),e.getChildren());return this.replace(e,n)?n:null}setAttribute(t,e,n){n._setAttribute(t,e)}removeAttribute(t,e){e._removeAttribute(t)}addClass(t,e){e._addClass(t)}removeClass(t,e){e._removeClass(t)}setStyle(t,e,n){y(t)&&void 0===n&&(n=e),n._setStyle(t,e)}removeStyle(t,e){e._removeStyle(t)}setCustomProperty(t,e,n){n._setCustomProperty(t,e)}removeCustomProperty(t,e){return e._removeCustomProperty(t)}createPositionAt(t,e){return Zi._createAt(t,e)}createPositionAfter(t){return Zi._createAfter(t)}createPositionBefore(t){return Zi._createBefore(t)}createRange(t,e){return new Xi(t,e)}createRangeOn(t){return Xi._createOn(t)}createRangeIn(t){return Xi._createIn(t)}createSelection(t,e,n){return new no(t,e,n)}}class Mf extends od{refresh(){this.isEnabled=Qu(this.editor.model)}execute(t){const e=this.editor,n=e.model,i=e.plugins.get(ou);n.change(e=>{const o=Array.isArray(t.file)?t.file:[t.file];for(const t of o)If(e,n,i,t)})}}function If(t,e,n,i){const o=n.createLoader(i);o&&Ku(t,e,{uploadId:o.id})}class Nf extends Zl{static get requires(){return[ou,Vh,id]}static get pluginName(){return"ImageUploadEditing"}constructor(t){super(t),t.config.define("image",{upload:{types:["jpeg","png","gif","bmp","webp","tiff"]}})}init(){const t=this.editor,e=t.model.document,n=t.model.schema,i=t.conversion,o=t.plugins.get(ou),r=vf(t.config.get("image.upload.types"));n.extend("image",{allowAttributes:["uploadId","uploadStatus"]}),t.commands.add("imageUpload",new Mf(t)),i.for("upcast").attributeToAttribute({view:{name:"img",key:"uploadId"},model:"uploadId"}),this.listenTo(t.editing.view.document,"clipboardInput",(e,n)=>{if(i=n.dataTransfer,Array.from(i.types).includes("text/html")&&""!==i.getData("text/html"))return;var i;const o=Array.from(n.dataTransfer.files).filter(t=>!!t&&r.test(t.type)),s=n.targetRanges.map(e=>t.editing.mapper.toModelRange(e));t.model.change(n=>{n.setSelection(s),o.length&&(e.stop(),t.model.enqueueChange("default",()=>{t.execute("imageUpload",{file:o})}))})}),this.listenTo(t.plugins.get(id),"inputTransformation",(e,n)=>{const i=Array.from(t.editing.view.createRangeIn(n.content)).filter(t=>{return!(!(e=t.item).is("element","img")||!e.getAttribute("src"))&&(e.getAttribute("src").match(/^data:image\/\w+;base64,/g)||e.getAttribute("src").match(/^blob:/g))&&!t.item.getAttribute("uploadProcessed");var e}).map(t=>{return{promise:(e=t.item,new Promise((t,n)=>{const i=e.getAttribute("src");fetch(i).then(t=>t.blob()).then(e=>{const n=function(t,e){return t.type?t.type:e.match(/data:(image\/\w+);base64/)?e.match(/data:(image\/\w+);base64/)[1].toLowerCase():"image/jpeg"}(e,i),o=n.replace("image/",""),r=new File([e],"image."+o,{type:n});t(r)}).catch(n)})),imageElement:t.item};var e});if(!i.length)return;const r=new Ef(t.editing.view.document);for(const t of i){r.setAttribute("uploadProcessed",!0,t.imageElement);const e=o.createLoader(t.promise);e&&(r.setAttribute("src","",t.imageElement),r.setAttribute("uploadId",e.id,t.imageElement))}}),t.editing.view.document.on("dragover",(t,e)=>{e.preventDefault()}),e.on("change",()=>{const n=e.differ.getChanges({includeChangesInGraveyard:!0});for(const e of n)if("insert"==e.type&&"$text"!=e.name){const n=e.position.nodeAfter,i="$graveyard"==e.position.root.rootName;for(const e of Of(t,n)){const t=e.getAttribute("uploadId");if(!t)continue;const n=o.loaders.get(t);n&&(i?n.abort():"idle"==n.status&&this._readAndUpload(n,e))}}})}_readAndUpload(t,e){const n=this.editor,i=n.model,o=n.locale.t,r=n.plugins.get(ou),s=n.plugins.get(Vh);return i.enqueueChange("transparent",t=>{t.setAttribute("uploadStatus","reading",e)}),t.read().then(()=>{const o=t.upload();if(ho.isSafari){const t=Ju(n.editing.mapper.toViewElement(e));n.editing.view.once("render",()=>{if(!t.parent)return;const e=n.editing.view.domConverter.mapViewToDom(t.parent);if(!e)return;const i=e.style.display;e.style.display="none",e._ckHack=e.offsetHeight,e.style.display=i})}return i.enqueueChange("transparent",t=>{t.setAttribute("uploadStatus","uploading",e)}),o}).then(t=>{i.enqueueChange("transparent",n=>{n.setAttributes({uploadStatus:"complete",src:t.default},e),this._parseAndSetSrcsetAttributeOnImage(t,e,n)}),a()}).catch(n=>{if("error"!==t.status&&"aborted"!==t.status)throw n;"error"==t.status&&n&&s.showWarning(n,{title:o("Upload failed"),namespace:"upload"}),a(),i.enqueueChange("transparent",t=>{t.remove(e)})});function a(){i.enqueueChange("transparent",t=>{t.removeAttribute("uploadId",e),t.removeAttribute("uploadStatus",e)}),r.destroyLoader(t)}}_parseAndSetSrcsetAttributeOnImage(t,e,n){let i=0;const o=Object.keys(t).filter(t=>{const e=parseInt(t,10);if(!isNaN(e))return i=Math.max(i,e),!0}).map(e=>`${t[e]} ${e}w`).join(", ");""!=o&&n.setAttribute("srcset",{data:o,width:i},e)}}function Of(t,e){return Array.from(t.model.createRangeOn(e)).filter(t=>t.item.is("image")).map(t=>t.item)}class Rf extends Zl{static get pluginName(){return"ImageUpload"}static get requires(){return[Nf,yf,xf]}}class Df extends od{refresh(){const t=this.editor.model,e=wu(t.document.selection.getSelectedBlocks());this.value=!!e&&e.is("paragraph"),this.isEnabled=!!e&&Lf(e,t.schema)}execute(t={}){const e=this.editor.model,n=e.document;e.change(i=>{const o=(t.selection||n.selection).getSelectedBlocks();for(const t of o)!t.is("paragraph")&&Lf(t,e.schema)&&i.rename(t,"paragraph")})}}function Lf(t,e){return e.checkChild(t.parent,"paragraph")&&!e.isObject(t)}class jf extends od{execute(t){const e=this.editor.model;let n=t.position;e.change(t=>{const i=t.createElement("paragraph");if(!e.schema.checkChild(n.parent,i)){const o=e.schema.findAllowedParent(n,i);if(!o)return;n=t.split(n,o).position}e.insertContent(i,n),t.setSelection(i,"in")})}}class Vf extends Zl{static get pluginName(){return"Paragraph"}init(){const t=this.editor,e=t.model,n=t.data;t.commands.add("paragraph",new Df(t)),t.commands.add("insertParagraph",new jf(t)),e.schema.register("paragraph",{inheritAllFrom:"$block"}),t.conversion.elementToElement({model:"paragraph",view:"p"}),t.conversion.for("upcast").elementToElement({model:(t,e)=>Vf.paragraphLikeElements.has(t.name)?t.isEmpty?null:e.createElement("paragraph"):null,converterPriority:"low"}),n.upcastDispatcher.on("element",(t,e,n)=>{n.consumable.test(e.viewItem,{name:e.viewItem.name})&&Bf(e.viewItem,e.modelCursor,n.schema)&&Object.assign(e,zf(e.viewItem,e.modelCursor,n))},{priority:"low"}),n.upcastDispatcher.on("text",(t,e,n)=>{e.modelRange||Bf(e.viewItem,e.modelCursor,n.schema)&&Object.assign(e,zf(e.viewItem,e.modelCursor,n))},{priority:"lowest"}),e.document.registerPostFixer(t=>this._autoparagraphEmptyRoots(t)),t.data.on("ready",()=>{e.enqueueChange("transparent",t=>this._autoparagraphEmptyRoots(t))},{priority:"lowest"})}_autoparagraphEmptyRoots(t){const e=this.editor.model;for(const n of e.document.getRootNames()){const i=e.document.getRoot(n);if(i.isEmpty&&"$graveyard"!=i.rootName&&e.schema.checkChild(i,"paragraph"))return t.insertElement("paragraph",i),!0}}}function zf(t,e,n){const i=n.writer.createElement("paragraph");return n.writer.insert(i,e),n.convertItem(t,n.writer.createPositionAt(i,0))}function Bf(t,e,n){const i=n.createContext(e);return!!n.checkChild(i,"paragraph")&&!!n.checkChild(i.push("paragraph"),t)}Vf.paragraphLikeElements=new Set(["blockquote","dd","div","dt","h1","h2","h3","h4","h5","h6","li","p","td"]);class Ff extends od{constructor(t,e){super(t),this.modelElements=e}refresh(){const t=wu(this.editor.model.document.selection.getSelectedBlocks());this.value=!!t&&this.modelElements.includes(t.name)&&t.name,this.isEnabled=!!t&&this.modelElements.some(e=>Uf(t,e,this.editor.model.schema))}execute(t){const e=this.editor.model,n=e.document,i=t.value;e.change(t=>{const o=Array.from(n.selection.getSelectedBlocks()).filter(t=>Uf(t,i,e.schema));for(const e of o)e.is(i)||t.rename(e,i)})}}function Uf(t,e,n){return n.checkChild(t.parent,e)&&!n.isObject(t)}class Hf extends Zl{static get pluginName(){return"HeadingEditing"}constructor(t){super(t),t.config.define("heading",{options:[{model:"paragraph",title:"Paragraph",class:"ck-heading_paragraph"},{model:"heading1",view:"h2",title:"Heading 1",class:"ck-heading_heading1"},{model:"heading2",view:"h3",title:"Heading 2",class:"ck-heading_heading2"},{model:"heading3",view:"h4",title:"Heading 3",class:"ck-heading_heading3"}]})}static get requires(){return[Vf]}init(){const t=this.editor,e=t.config.get("heading.options"),n=[];for(const i of e)"paragraph"!==i.model&&(t.model.schema.register(i.model,{inheritAllFrom:"$block"}),t.conversion.elementToElement(i),n.push(i.model));this._addDefaultH1Conversion(t),t.commands.add("heading",new Ff(t,n))}afterInit(){const t=this.editor,e=t.commands.get("enter"),n=t.config.get("heading.options");e&&this.listenTo(e,"afterExecute",(e,i)=>{const o=t.model.document.selection.getFirstPosition().parent;n.some(t=>o.is(t.model))&&!o.is("paragraph")&&0===o.childCount&&i.writer.rename(o,"paragraph")})}_addDefaultH1Conversion(t){t.conversion.for("upcast").elementToElement({model:"heading1",view:"h1",converterPriority:un.get("low")+1})}}class Wf{constructor(t,e){e&&ji(this,e),t&&this.set(t)}}xn(Wf,Ui);n(11);class qf extends Zl{init(){const t=this.editor,e=t.t,n=function(t){const e=t.t,n={Paragraph:e("Paragraph"),"Heading 1":e("Heading 1"),"Heading 2":e("Heading 2"),"Heading 3":e("Heading 3"),"Heading 4":e("Heading 4"),"Heading 5":e("Heading 5"),"Heading 6":e("Heading 6")};return t.config.get("heading.options").map(t=>{const e=n[t.title];return e&&e!=t.title&&(t.title=e),t})}(t),i=e("Choose heading"),o=e("Heading");t.ui.componentFactory.add("heading",e=>{const r={},s=new An,a=t.commands.get("heading"),c=t.commands.get("paragraph"),l=[a];for(const t of n){const e={type:"button",model:new Wf({label:t.title,class:t.class,withText:!0})};"paragraph"===t.model?(e.model.bind("isOn").to(c,"value"),e.model.set("commandName","paragraph"),l.push(c)):(e.model.bind("isOn").to(a,"value",e=>e===t.model),e.model.set({commandName:"heading",commandValue:t.model})),s.add(e),r[t.model]=t.title}const d=Wl(e);return ql(d,s),d.buttonView.set({isOn:!1,withText:!0,tooltip:o}),d.extendTemplate({attributes:{class:["ck-heading-dropdown"]}}),d.bind("isEnabled").toMany(l,"isEnabled",(...t)=>t.some(t=>t)),d.buttonView.bind("label").to(a,"value",c,"value",(t,e)=>{const n=t||e&&"paragraph";return r[n]?r[n]:i}),this.listenTo(d,"execute",e=>{t.execute(e.source.commandName,e.source.commandValue?{value:e.source.commandValue}:void 0),t.editing.view.focus()}),d})}}function Yf(t){for(const e of t.getChildren())if(e&&e.is("caption"))return e;return null}function Gf(t){const e=t.parent;return"figcaption"==t.name&&e&&"figure"==e.name&&e.hasClass("image")?{name:!0}:null}class $f extends Zl{static get pluginName(){return"ImageCaptionEditing"}init(){const t=this.editor,e=t.editing.view,n=t.model.schema,i=t.data,o=t.editing,r=t.t;n.register("caption",{allowIn:"image",allowContentOf:"$block",isLimit:!0}),t.model.document.registerPostFixer(t=>this._insertMissingModelCaptionElement(t)),t.conversion.for("upcast").elementToElement({view:Gf,model:"caption"});i.downcastDispatcher.on("insert:caption",Kf(t=>t.createContainerElement("figcaption"),!1));const s=function(t,e){return n=>{const i=n.createEditableElement("figcaption");return n.setCustomProperty("imageCaption",!0,i),Bc({view:t,element:i,text:e}),Hu(i,n)}}(e,r("Enter image caption"));o.downcastDispatcher.on("insert:caption",Kf(s)),o.downcastDispatcher.on("insert",this._fixCaptionVisibility(t=>t.item),{priority:"high"}),o.downcastDispatcher.on("remove",this._fixCaptionVisibility(t=>t.position.parent),{priority:"high"}),e.document.registerPostFixer(t=>this._updateCaptionVisibility(t))}_updateCaptionVisibility(t){const e=this.editor.editing.mapper,n=this._lastSelectedCaption;let i;const o=this.editor.model.document.selection,r=o.getSelectedElement();if(r&&r.is("image")){const t=Yf(r);i=e.toViewElement(t)}const s=Qf(o.getFirstPosition().parent);if(s&&(i=e.toViewElement(s)),i)return n?(n===i||(Jf(n,t),this._lastSelectedCaption=i),Zf(i,t)):(this._lastSelectedCaption=i,Zf(i,t));if(n){const e=Jf(n,t);return this._lastSelectedCaption=null,e}return!1}_fixCaptionVisibility(t){return(e,n,i)=>{const o=Qf(t(n)),r=this.editor.editing.mapper,s=i.writer;if(o){const t=r.toViewElement(o);t&&(o.childCount?s.removeClass("ck-hidden",t):s.addClass("ck-hidden",t))}}}_insertMissingModelCaptionElement(t){const e=this.editor.model,n=e.document.differ.getChanges(),i=[];for(const t of n)if("insert"==t.type&&"$text"!=t.name){const n=t.position.nodeAfter;if(n.is("image")&&!Yf(n)&&i.push(n),!n.is("image")&&n.childCount)for(const t of e.createRangeIn(n).getItems())t.is("image")&&!Yf(t)&&i.push(t)}for(const e of i)t.appendElement("caption",e);return!!i.length}}function Kf(t,e=!0){return(n,i,o)=>{const r=i.item;if((r.childCount||e)&&$u(r.parent)){if(!o.consumable.consume(i.item,"insert"))return;const e=o.mapper.toViewElement(i.range.start.parent),n=t(o.writer),s=o.writer;r.childCount||s.addClass("ck-hidden",n),function(t,e,n,i){const o=i.writer.createPositionAt(n,"end");i.writer.insert(o,t),i.mapper.bindElements(e,t)}(n,i.item,e,o)}}}function Qf(t){const e=t.getAncestors({includeSelf:!0}).find(t=>"caption"==t.name);return e&&e.parent&&"image"==e.parent.name?e:null}function Jf(t,e){return!t.childCount&&!t.hasClass("ck-hidden")&&(e.addClass("ck-hidden",t),!0)}function Zf(t,e){return!!t.hasClass("ck-hidden")&&(e.removeClass("ck-hidden",t),!0)}n(72);class Xf extends od{constructor(t,e){super(t),this.defaultStyle=!1,this.styles=e.reduce((t,e)=>(t[e.name]=e,e.isDefault&&(this.defaultStyle=e.name),t),{})}refresh(){const t=this.editor.model.document.selection.getSelectedElement();if(this.isEnabled=$u(t),t)if(t.hasAttribute("imageStyle")){const e=t.getAttribute("imageStyle");this.value=!!this.styles[e]&&e}else this.value=this.defaultStyle;else this.value=!1}execute(t){const e=t.value,n=this.editor.model,i=n.document.selection.getSelectedElement();n.change(t=>{this.styles[e].isDefault?t.removeAttribute("imageStyle",i):t.setAttribute("imageStyle",e,i)})}}function tg(t,e){for(const n of e)if(n.name===t)return n}var eg='<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 4.5V3h16v1.5zm2.5 3V12h11V7.5h-11zM4.061 6H15.94c.586 0 1.061.407 1.061.91v5.68c0 .503-.475.91-1.061.91H4.06c-.585 0-1.06-.407-1.06-.91V6.91C3 6.406 3.475 6 4.061 6zM2 16.5V15h16v1.5z"/></svg>',ng='<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" clip-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="1.414"><path d="M18 4.5V3H2v1.5h16zm0 3V6h-5.674v1.5H18zm0 3V9h-5.674v1.5H18zm0 3V12h-5.674v1.5H18zm-8.5-6V12h-6V7.5h6zm.818-1.5H2.682C2.305 6 2 6.407 2 6.91v5.68c0 .503.305.91.682.91h7.636c.377 0 .682-.407.682-.91V6.91c0-.503-.305-.91-.682-.91zM18 16.5V15H2v1.5h16z"/></svg>',ig='<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 4.5V3h16v1.5zm4.5 3V12h7V7.5h-7zM5.758 6h8.484c.419 0 .758.407.758.91v5.681c0 .502-.34.909-.758.909H5.758c-.419 0-.758-.407-.758-.91V6.91c0-.503.34-.91.758-.91zM2 16.5V15h16v1.5z"/></svg>',og='<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 4.5V3h16v1.5zm0 3V6h5.674v1.5zm0 3V9h5.674v1.5zm0 3V12h5.674v1.5zm8.5-6V12h6V7.5h-6zM9.682 6h7.636c.377 0 .682.407.682.91v5.68c0 .503-.305.91-.682.91H9.682c-.377 0-.682-.407-.682-.91V6.91c0-.503.305-.91.682-.91zM2 16.5V15h16v1.5z"/></svg>';const rg={full:{name:"full",title:"Full size image",icon:eg,isDefault:!0},side:{name:"side",title:"Side image",icon:og,className:"image-style-side"},alignLeft:{name:"alignLeft",title:"Left aligned image",icon:ng,className:"image-style-align-left"},alignCenter:{name:"alignCenter",title:"Centered image",icon:ig,className:"image-style-align-center"},alignRight:{name:"alignRight",title:"Right aligned image",icon:og,className:"image-style-align-right"}},sg={full:eg,left:ng,right:og,center:ig};function ag(t=[]){return t.map(cg)}function cg(t){if("string"==typeof t){const e=t;rg[e]?t=Object.assign({},rg[e]):(console.warn(Object(hn.a)("image-style-not-found: There is no such image style of given name."),{name:e}),t={name:e})}else if(rg[t.name]){const e=rg[t.name],n=Object.assign({},t);for(const i in e)Object.prototype.hasOwnProperty.call(t,i)||(n[i]=e[i]);t=n}return"string"==typeof t.icon&&sg[t.icon]&&(t.icon=sg[t.icon]),t}class lg extends Zl{static get pluginName(){return"ImageStyleEditing"}init(){const t=this.editor,e=t.model.schema,n=t.data,i=t.editing;t.config.define("image.styles",["full","side"]);const o=ag(t.config.get("image.styles"));e.extend("image",{allowAttributes:"imageStyle"});const r=function(t){return(e,n,i)=>{if(!i.consumable.consume(n.item,e.name))return;const o=tg(n.attributeNewValue,t),r=tg(n.attributeOldValue,t),s=i.mapper.toViewElement(n.item),a=i.writer;r&&a.removeClass(r.className,s),o&&a.addClass(o.className,s)}}(o);i.downcastDispatcher.on("attribute:imageStyle:image",r),n.downcastDispatcher.on("attribute:imageStyle:image",r),n.upcastDispatcher.on("element:figure",function(t){const e=t.filter(t=>!t.isDefault);return(t,n,i)=>{if(!n.modelRange)return;const o=n.viewItem,r=wu(n.modelRange.getItems());if(i.schema.checkAttribute(r,"imageStyle"))for(const t of e)i.consumable.consume(o,{classes:t.className})&&i.writer.setAttribute("imageStyle",t.name,r)}}(o),{priority:"low"}),t.commands.add("imageStyle",new Xf(t,o))}}n(74);class dg extends Zl{static get pluginName(){return"ImageStyleUI"}get localizedDefaultStylesTitles(){const t=this.editor.t;return{"Full size image":t("Full size image"),"Side image":t("Side image"),"Left aligned image":t("Left aligned image"),"Centered image":t("Centered image"),"Right aligned image":t("Right aligned image")}}init(){const t=function(t,e){for(const n of t)e[n.title]&&(n.title=e[n.title]);return t}(ag(this.editor.config.get("image.styles")),this.localizedDefaultStylesTitles);for(const e of t)this._createButton(e)}_createButton(t){const e=this.editor,n="imageStyle:"+t.name;e.ui.componentFactory.add(n,n=>{const i=e.commands.get("imageStyle"),o=new Ll(n);return o.set({label:t.title,icon:t.icon,tooltip:!0,isToggleable:!0}),o.bind("isEnabled").to(i,"isEnabled"),o.bind("isOn").to(i,"value",e=>e===t.name),this.listenTo(o,"execute",()=>{e.execute("imageStyle",{value:t.name}),e.editing.view.focus()}),o})}}class ug extends Zl{static get requires(){return[hf]}static get pluginName(){return"WidgetToolbarRepository"}init(){const t=this.editor;if(t.plugins.has("BalloonToolbar")){const e=t.plugins.get("BalloonToolbar");this.listenTo(e,"show",e=>{(function(t){const e=t.getSelectedElement();return!(!e||!zu(e))})(t.editing.view.document.selection)&&e.stop()},{priority:"high"})}this._toolbarDefinitions=new Map,this._balloon=this.editor.plugins.get("ContextualBalloon"),this.on("change:isEnabled",()=>{this._updateToolbarsVisibility()}),this.listenTo(t.ui,"update",()=>{this._updateToolbarsVisibility()}),this.listenTo(t.ui.focusTracker,"change:isFocused",()=>{this._updateToolbarsVisibility()},{priority:"low"})}destroy(){super.destroy();for(const t of this._toolbarDefinitions.values())t.view.destroy()}register(t,{ariaLabel:e,items:n,getRelatedElement:i,balloonClassName:o="ck-toolbar-container"}){if(!n.length)return void console.warn(Object(hn.a)("widget-toolbar-no-items: Trying to register a toolbar without items."),{toolbarId:t});const r=this.editor,s=r.t,a=new Yl(r.locale);if(a.ariaLabel=e||s("Widget toolbar"),this._toolbarDefinitions.has(t))throw new hn.b("widget-toolbar-duplicated: Toolbar with the given id was already added.",this,{toolbarId:t});a.fillFromConfig(n,r.ui.componentFactory),this._toolbarDefinitions.set(t,{view:a,getRelatedElement:i,balloonClassName:o})}_updateToolbarsVisibility(){let t=0,e=null,n=null;for(const i of this._toolbarDefinitions.values()){const o=i.getRelatedElement(this.editor.editing.view.document.selection);if(this.isEnabled&&o)if(this.editor.ui.focusTracker.isFocused){const r=o.getAncestors().length;r>t&&(t=r,e=o,n=i)}else this._isToolbarVisible(i)&&this._hideToolbar(i);else this._isToolbarInBalloon(i)&&this._hideToolbar(i)}n&&this._showToolbar(n,e)}_hideToolbar(t){this._balloon.remove(t.view),this.stopListening(this._balloon,"change:visibleView")}_showToolbar(t,e){this._isToolbarVisible(t)?hg(this.editor,e):this._isToolbarInBalloon(t)||(this._balloon.add({view:t.view,position:fg(this.editor,e),balloonClassName:t.balloonClassName}),this.listenTo(this._balloon,"change:visibleView",()=>{for(const t of this._toolbarDefinitions.values())if(this._isToolbarVisible(t)){const e=t.getRelatedElement(this.editor.editing.view.document.selection);hg(this.editor,e)}}))}_isToolbarVisible(t){return this._balloon.visibleView===t.view}_isToolbarInBalloon(t){return this._balloon.hasView(t.view)}}function hg(t,e){const n=t.plugins.get("ContextualBalloon"),i=fg(t,e);n.updatePosition(i)}function fg(t,e){const n=t.editing.view,i=Ou.defaultPositions;return{target:n.domConverter.mapViewToDom(e),positions:[i.northArrowSouth,i.northArrowSouthWest,i.northArrowSouthEast,i.southArrowNorth,i.southArrowNorthWest,i.southArrowNorthEast,qu]}}class gg extends od{constructor(t){super(t),this._childCommands=[]}refresh(){}execute(...t){this._getFirstEnabledCommand().execute(t)}registerChildCommand(t){this._childCommands.push(t),t.on("change:isEnabled",()=>this._checkEnabled()),this._checkEnabled()}_checkEnabled(){this.isEnabled=!!this._getFirstEnabledCommand()}_getFirstEnabledCommand(){return this._childCommands.find(t=>t.isEnabled)}}class mg extends Zl{static get pluginName(){return"IndentEditing"}init(){const t=this.editor;t.commands.add("indent",new gg(t)),t.commands.add("outdent",new gg(t))}}var pg='<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm5 6c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM2.75 16.5h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 1 0 0 1.5zM1.632 6.95L5.02 9.358a.4.4 0 0 1-.013.661l-3.39 2.207A.4.4 0 0 1 1 11.892V7.275a.4.4 0 0 1 .632-.326z"/></svg>',bg='<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm5 6c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM2.75 16.5h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 1 0 0 1.5zm1.618-9.55L.98 9.358a.4.4 0 0 0 .013.661l3.39 2.207A.4.4 0 0 0 5 11.892V7.275a.4.4 0 0 0-.632-.326z"/></svg>';class wg extends Zl{static get pluginName(){return"IndentUI"}init(){const t=this.editor,e=t.locale,n=t.t,i="ltr"==e.uiLanguageDirection?pg:bg,o="ltr"==e.uiLanguageDirection?bg:pg;this._defineButton("indent",n("Increase indent"),i),this._defineButton("outdent",n("Decrease indent"),o)}_defineButton(t,e,n){const i=this.editor;i.ui.componentFactory.add(t,o=>{const r=i.commands.get(t),s=new Ll(o);return s.set({label:e,icon:n,tooltip:!0}),s.bind("isOn","isEnabled").to(r,"value","isEnabled"),this.listenTo(s,"execute",()=>{i.execute(t),i.editing.view.focus()}),s})}}class kg extends Dr{constructor(t){super(t),this.domEventType="click"}onDomEvent(t){this.fire(t.type,t)}}n(76);class _g extends hl{constructor(t,e,n){super(t);const i=t.t;this.focusTracker=new jc,this.keystrokes=new Sc,this.urlInputView=this._createUrlInput(n),this.saveButtonView=this._createButton(i("Save"),cf,"ck-button-save"),this.saveButtonView.type="submit",this.cancelButtonView=this._createButton(i("Cancel"),lf,"ck-button-cancel","cancel"),this._manualDecoratorSwitches=this._createManualDecoratorSwitches(e),this.children=this._createFormChildren(e.manualDecorators),this._focusables=new Yc,this._focusCycler=new xl({focusables:this._focusables,focusTracker:this.focusTracker,keystrokeHandler:this.keystrokes,actions:{focusPrevious:"shift + tab",focusNext:"tab"}});const o=["ck","ck-link-form"];e.manualDecorators.length&&o.push("ck-link-form_layout-vertical"),this.setTemplate({tag:"form",attributes:{class:o,tabindex:"-1"},children:this.children})}getDecoratorSwitchesState(){return Array.from(this._manualDecoratorSwitches).reduce((t,e)=>(t[e.name]=e.isOn,t),{})}render(){super.render(),af({view:this});[this.urlInputView,...this._manualDecoratorSwitches,this.saveButtonView,this.cancelButtonView].forEach(t=>{this._focusables.add(t),this.focusTracker.add(t.element)}),this.keystrokes.listenTo(this.element)}focus(){this._focusCycler.focusFirst()}_createUrlInput(t="https://"){const e=this.locale.t,n=new of(this.locale,sf);return n.label=e("Link URL"),n.fieldView.placeholder=t+"example.com",n}_createButton(t,e,n,i){const o=new Ll(this.locale);return o.set({label:t,icon:e,tooltip:!0}),o.extendTemplate({attributes:{class:n}}),i&&o.delegate("execute").to(this,i),o}_createManualDecoratorSwitches(t){const e=this.createCollection();for(const n of t.manualDecorators){const i=new Ul(this.locale);i.set({name:n.id,label:n.label,withText:!0}),i.bind("isOn").toMany([n,t],"value",(t,e)=>void 0===e&&void 0===t?n.defaultValue:t),i.on("execute",()=>{n.set("value",!i.isOn)}),e.add(i)}return e}_createFormChildren(t){const e=this.createCollection();if(e.add(this.urlInputView),t.length){const t=new hl;t.setTemplate({tag:"ul",children:this._manualDecoratorSwitches.map(t=>({tag:"li",children:[t],attributes:{class:["ck","ck-list__item"]}})),attributes:{class:["ck","ck-reset","ck-list"]}}),e.add(t)}return e.add(this.saveButtonView),e.add(this.cancelButtonView),e}}n(78);class vg extends hl{constructor(t){super(t);const e=t.t;this.focusTracker=new jc,this.keystrokes=new Sc,this.previewButtonView=this._createPreviewButton(),this.unlinkButtonView=this._createButton(e("Unlink"),'<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.077 15l.991-1.416a.75.75 0 1 1 1.229.86l-1.148 1.64a.748.748 0 0 1-.217.206 5.251 5.251 0 0 1-8.503-5.955.741.741 0 0 1 .12-.274l1.147-1.639a.75.75 0 1 1 1.228.86L4.933 10.7l.006.003a3.75 3.75 0 0 0 6.132 4.294l.006.004zm5.494-5.335a.748.748 0 0 1-.12.274l-1.147 1.639a.75.75 0 1 1-1.228-.86l.86-1.23a3.75 3.75 0 0 0-6.144-4.301l-.86 1.229a.75.75 0 0 1-1.229-.86l1.148-1.64a.748.748 0 0 1 .217-.206 5.251 5.251 0 0 1 8.503 5.955zm-4.563-2.532a.75.75 0 0 1 .184 1.045l-3.155 4.505a.75.75 0 1 1-1.229-.86l3.155-4.506a.75.75 0 0 1 1.045-.184zm4.919 10.562l-1.414 1.414a.75.75 0 1 1-1.06-1.06l1.414-1.415-1.415-1.414a.75.75 0 0 1 1.061-1.06l1.414 1.414 1.414-1.415a.75.75 0 0 1 1.061 1.061l-1.414 1.414 1.414 1.415a.75.75 0 0 1-1.06 1.06l-1.415-1.414z"/></svg>',"unlink"),this.editButtonView=this._createButton(e("Edit link"),'<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7.3 17.37l-.061.088a1.518 1.518 0 0 1-.934.535l-4.178.663-.806-4.153a1.495 1.495 0 0 1 .187-1.058l.056-.086L8.77 2.639c.958-1.351 2.803-1.076 4.296-.03 1.497 1.047 2.387 2.693 1.433 4.055L7.3 17.37zM9.14 4.728l-5.545 8.346 3.277 2.294 5.544-8.346L9.14 4.728zM6.07 16.512l-3.276-2.295.53 2.73 2.746-.435zM9.994 3.506L13.271 5.8c.316-.452-.16-1.333-1.065-1.966-.905-.634-1.895-.78-2.212-.328zM8 18.5L9.375 17H19v1.5H8z"/></svg>',"edit"),this.set("href"),this._focusables=new Yc,this._focusCycler=new xl({focusables:this._focusables,focusTracker:this.focusTracker,keystrokeHandler:this.keystrokes,actions:{focusPrevious:"shift + tab",focusNext:"tab"}}),this.setTemplate({tag:"div",attributes:{class:["ck","ck-link-actions"],tabindex:"-1"},children:[this.previewButtonView,this.editButtonView,this.unlinkButtonView]})}render(){super.render();[this.previewButtonView,this.editButtonView,this.unlinkButtonView].forEach(t=>{this._focusables.add(t),this.focusTracker.add(t.element)}),this.keystrokes.listenTo(this.element)}focus(){this._focusCycler.focusFirst()}_createButton(t,e,n){const i=new Ll(this.locale);return i.set({label:t,icon:e,tooltip:!0}),i.delegate("execute").to(this,n),i}_createPreviewButton(){const t=new Ll(this.locale),e=this.bindTemplate,n=this.t;return t.set({withText:!0,tooltip:n("Open link in new tab")}),t.extendTemplate({attributes:{class:["ck","ck-link-actions__preview"],href:e.to("href",t=>t&&Dh(t)),target:"_blank",rel:"noopener noreferrer"}}),t.bind("label").to(this,"href",t=>t||n("This link has no URL")),t.bind("isEnabled").to(this,"href",t=>!!t),t.template.tag="a",t.template.eventListeners={},t}}const yg=/^((\w+:(\/{2,})?)|(\W))/i,xg=/[\w-]+@[\w-]+\.+[\w-]+/i;class Ag extends Zl{static get requires(){return[hf]}static get pluginName(){return"LinkUI"}init(){const t=this.editor;t.editing.view.addObserver(kg),this.actionsView=this._createActionsView(),this.formView=this._createFormView(),this._balloon=t.plugins.get(hf),this._createToolbarLinkButton(),this._enableUserBalloonInteractions(),t.conversion.for("downcast").markerToHighlight({model:"link-ui",view:{classes:["ck-fake-link-selection"]}}),t.conversion.for("downcast").markerToElement({model:"link-ui",view:{name:"span",classes:["ck-fake-link-selection","ck-fake-link-selection_collapsed"]}})}destroy(){super.destroy(),this.formView.destroy()}_createActionsView(){const t=this.editor,e=new vg(t.locale),n=t.commands.get("link"),i=t.commands.get("unlink");return e.bind("href").to(n,"value"),e.editButtonView.bind("isEnabled").to(n),e.unlinkButtonView.bind("isEnabled").to(i),this.listenTo(e,"edit",()=>{this._addFormView()}),this.listenTo(e,"unlink",()=>{t.execute("unlink"),this._hideUI()}),e.keystrokes.set("Esc",(t,e)=>{this._hideUI(),e()}),e.keystrokes.set("Ctrl+K",(t,e)=>{this._addFormView(),e()}),e}_createFormView(){const t=this.editor,e=t.commands.get("link"),n=t.config.get("link.defaultProtocol"),i=new _g(t.locale,e,n);return i.urlInputView.fieldView.bind("value").to(e,"value"),i.urlInputView.bind("isReadOnly").to(e,"isEnabled",t=>!t),i.saveButtonView.bind("isEnabled").to(e),this.listenTo(i,"submit",()=>{const{value:e}=i.urlInputView.fieldView.element,o=!!n&&!yg.test(e),r=xg.test(e),s=e&&o?(r?"mailto:":n)+e:e;t.execute("link",s,i.getDecoratorSwitchesState()),this._closeFormView()}),this.listenTo(i,"cancel",()=>{this._closeFormView()}),i.keystrokes.set("Esc",(t,e)=>{this._closeFormView(),e()}),i}_createToolbarLinkButton(){const t=this.editor,e=t.commands.get("link"),n=t.t;t.keystrokes.set("Ctrl+K",(t,e)=>{e(),this._showUI(!0)}),t.ui.componentFactory.add("link",t=>{const i=new Ll(t);return i.isEnabled=!0,i.label=n("Link"),i.icon='<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.077 15l.991-1.416a.75.75 0 1 1 1.229.86l-1.148 1.64a.748.748 0 0 1-.217.206 5.251 5.251 0 0 1-8.503-5.955.741.741 0 0 1 .12-.274l1.147-1.639a.75.75 0 1 1 1.228.86L4.933 10.7l.006.003a3.75 3.75 0 0 0 6.132 4.294l.006.004zm5.494-5.335a.748.748 0 0 1-.12.274l-1.147 1.639a.75.75 0 1 1-1.228-.86l.86-1.23a3.75 3.75 0 0 0-6.144-4.301l-.86 1.229a.75.75 0 0 1-1.229-.86l1.148-1.64a.748.748 0 0 1 .217-.206 5.251 5.251 0 0 1 8.503 5.955zm-4.563-2.532a.75.75 0 0 1 .184 1.045l-3.155 4.505a.75.75 0 1 1-1.229-.86l3.155-4.506a.75.75 0 0 1 1.045-.184z"/></svg>',i.keystroke="Ctrl+K",i.tooltip=!0,i.isToggleable=!0,i.bind("isEnabled").to(e,"isEnabled"),i.bind("isOn").to(e,"value",t=>!!t),this.listenTo(i,"execute",()=>this._showUI(!0)),i})}_enableUserBalloonInteractions(){const t=this.editor.editing.view.document;this.listenTo(t,"click",()=>{this._getSelectedLinkElement()&&this._showUI()}),this.editor.keystrokes.set("Tab",(t,e)=>{this._areActionsVisible&&!this.actionsView.focusTracker.isFocused&&(this.actionsView.focus(),e())},{priority:"high"}),this.editor.keystrokes.set("Esc",(t,e)=>{this._isUIVisible&&(this._hideUI(),e())}),Hl({emitter:this.formView,activator:()=>this._isUIInPanel,contextElements:[this._balloon.view.element],callback:()=>this._hideUI()})}_addActionsView(){this._areActionsInPanel||this._balloon.add({view:this.actionsView,position:this._getBalloonPositionData()})}_addFormView(){if(this._isFormInPanel)return;const t=this.editor.commands.get("link");this._balloon.add({view:this.formView,position:this._getBalloonPositionData()}),this._balloon.visibleView===this.formView&&this.formView.urlInputView.fieldView.select(),this.formView.urlInputView.fieldView.element.value=t.value||""}_closeFormView(){const t=this.editor.commands.get("link");t.restoreManualDecoratorStates(),void 0!==t.value?this._removeFormView():this._hideUI()}_removeFormView(){this._isFormInPanel&&(this.formView.saveButtonView.focus(),this._balloon.remove(this.formView),this.editor.editing.view.focus(),this._hideFakeVisualSelection())}_showUI(t=!1){this._getSelectedLinkElement()?(this._areActionsVisible?this._addFormView():this._addActionsView(),t&&this._balloon.showStack("main")):(this._addActionsView(),t&&this._balloon.showStack("main"),this._addFormView(),this._showFakeVisualSelection()),this._startUpdatingUI()}_hideUI(){if(!this._isUIInPanel)return;const t=this.editor;this.stopListening(t.ui,"update"),this.stopListening(this._balloon,"change:visibleView"),t.editing.view.focus(),this._removeFormView(),this._balloon.remove(this.actionsView),this._hideFakeVisualSelection()}_startUpdatingUI(){const t=this.editor,e=t.editing.view.document;let n=this._getSelectedLinkElement(),i=r();const o=()=>{const t=this._getSelectedLinkElement(),e=r();n&&!t||!n&&e!==i?this._hideUI():this._isUIVisible&&this._balloon.updatePosition(this._getBalloonPositionData()),n=t,i=e};function r(){return e.selection.focus.getAncestors().reverse().find(t=>t.is("element"))}this.listenTo(t.ui,"update",o),this.listenTo(this._balloon,"change:visibleView",o)}get _isFormInPanel(){return this._balloon.hasView(this.formView)}get _areActionsInPanel(){return this._balloon.hasView(this.actionsView)}get _areActionsVisible(){return this._balloon.visibleView===this.actionsView}get _isUIInPanel(){return this._isFormInPanel||this._areActionsInPanel}get _isUIVisible(){return this._balloon.visibleView==this.formView||this._areActionsVisible}_getBalloonPositionData(){const t=this.editor.editing.view,e=t.document,n=this._getSelectedLinkElement();return{target:n?t.domConverter.mapViewToDom(n):t.domConverter.viewRangeToDom(e.selection.getFirstRange())}}_getSelectedLinkElement(){const t=this.editor.editing.view,e=t.document.selection;if(e.isCollapsed)return Cg(e.getFirstPosition());{const n=e.getFirstRange().getTrimmed(),i=Cg(n.start),o=Cg(n.end);return i&&i==o&&t.createRangeIn(i).getTrimmed().isEqual(n)?i:null}}_showFakeVisualSelection(){const t=this.editor.model;t.change(e=>{t.markers.has("link-ui")?e.updateMarker("link-ui",{range:t.document.selection.getFirstRange()}):e.addMarker("link-ui",{usingOperation:!1,affectsData:!1,range:t.document.selection.getFirstRange()})})}_hideFakeVisualSelection(){const t=this.editor.model;t.markers.has("link-ui")&&t.change(t=>{t.removeMarker("link-ui")})}}function Cg(t){return t.getAncestors().find(t=>{return(e=t).is("attributeElement")&&!!e.getCustomProperty("link");var e})}class Tg extends od{constructor(t,e){super(t),this.type=e}refresh(){this.value=this._getValue(),this.isEnabled=this._checkEnabled()}execute(){const t=this.editor.model,e=t.document,n=Array.from(e.selection.getSelectedBlocks()).filter(e=>Sg(e,t.schema)),i=!0===this.value;t.change(t=>{if(i){let e=n[n.length-1].nextSibling,i=Number.POSITIVE_INFINITY,o=[];for(;e&&"listItem"==e.name&&0!==e.getAttribute("listIndent");){const t=e.getAttribute("listIndent");t<i&&(i=t);const n=t-i;o.push({element:e,listIndent:n}),e=e.nextSibling}o=o.reverse();for(const e of o)t.setAttribute("listIndent",e.listIndent,e.element)}if(!i){let t=Number.POSITIVE_INFINITY;for(const e of n)e.is("listItem")&&e.getAttribute("listIndent")<t&&(t=e.getAttribute("listIndent"));t=0===t?1:t,Pg(n,!0,t),Pg(n,!1,t)}for(const e of n.reverse())i&&"listItem"==e.name?t.rename(e,"paragraph"):i||"listItem"==e.name?i||"listItem"!=e.name||e.getAttribute("listType")==this.type||t.setAttribute("listType",this.type,e):(t.setAttributes({listType:this.type,listIndent:0},e),t.rename(e,"listItem"))})}_getValue(){const t=wu(this.editor.model.document.selection.getSelectedBlocks());return!!t&&t.is("listItem")&&t.getAttribute("listType")==this.type}_checkEnabled(){if(this.value)return!0;const t=this.editor.model.document.selection,e=this.editor.model.schema,n=wu(t.getSelectedBlocks());return!!n&&Sg(n,e)}}function Pg(t,e,n){const i=e?t[0]:t[t.length-1];if(i.is("listItem")){let o=i[e?"previousSibling":"nextSibling"],r=i.getAttribute("listIndent");for(;o&&o.is("listItem")&&o.getAttribute("listIndent")>=n;)r>o.getAttribute("listIndent")&&(r=o.getAttribute("listIndent")),o.getAttribute("listIndent")==r&&t[e?"unshift":"push"](o),o=o[e?"previousSibling":"nextSibling"]}}function Sg(t,e){return e.checkChild(t.parent,"listItem")&&!e.isObject(t)}class Eg extends od{constructor(t,e){super(t),this._indentBy="forward"==e?1:-1}refresh(){this.isEnabled=this._checkEnabled()}execute(){const t=this.editor.model,e=t.document;let n=Array.from(e.selection.getSelectedBlocks());t.change(t=>{const e=n[n.length-1];let i=e.nextSibling;for(;i&&"listItem"==i.name&&i.getAttribute("listIndent")>e.getAttribute("listIndent");)n.push(i),i=i.nextSibling;this._indentBy<0&&(n=n.reverse());for(const e of n){const n=e.getAttribute("listIndent")+this._indentBy;n<0?t.rename(e,"paragraph"):t.setAttribute("listIndent",n,e)}})}_checkEnabled(){const t=wu(this.editor.model.document.selection.getSelectedBlocks());if(!t||!t.is("listItem"))return!1;if(this._indentBy>0){const e=t.getAttribute("listIndent"),n=t.getAttribute("listType");let i=t.previousSibling;for(;i&&i.is("listItem")&&i.getAttribute("listIndent")>=e;){if(i.getAttribute("listIndent")==e)return i.getAttribute("listType")==n;i=i.previousSibling}return!1}return!0}}function Mg(t,e){const n=e.mapper,i=e.writer,o="numbered"==t.getAttribute("listType")?"ol":"ul",r=function(t){const e=t.createContainerElement("li");return e.getFillerOffset=Lg,e}(i),s=i.createContainerElement(o,null);return i.insert(i.createPositionAt(s,0),r),n.bindElements(t,r),r}function Ig(t,e,n,i){const o=e.parent,r=n.mapper,s=n.writer;let a=r.toViewPosition(i.createPositionBefore(t));const c=Rg(t.previousSibling,{sameIndent:!0,smallerIndent:!0,listIndent:t.getAttribute("listIndent")}),l=t.previousSibling;if(c&&c.getAttribute("listIndent")==t.getAttribute("listIndent")){const t=r.toViewElement(c);a=s.breakContainer(s.createPositionAfter(t))}else a=l&&"listItem"==l.name?r.toViewPosition(i.createPositionAt(l,"end")):r.toViewPosition(i.createPositionBefore(t));if(a=Og(a),s.insert(a,o),l&&"listItem"==l.name){const t=r.toViewElement(l),n=s.createRange(s.createPositionAt(t,0),a).getWalker({ignoreElementEnd:!0});for(const t of n)if(t.item.is("li")){const i=s.breakContainer(s.createPositionBefore(t.item)),o=t.item.parent,r=s.createPositionAt(e,"end");Ng(s,r.nodeBefore,r.nodeAfter),s.move(s.createRangeOn(o),r),n.position=i}}else{const n=o.nextSibling;if(n&&(n.is("ul")||n.is("ol"))){let i=null;for(const e of n.getChildren()){const n=r.toModelElement(e);if(!(n&&n.getAttribute("listIndent")>t.getAttribute("listIndent")))break;i=e}i&&(s.breakContainer(s.createPositionAfter(i)),s.move(s.createRangeOn(i.parent),s.createPositionAt(e,"end")))}}Ng(s,o,o.nextSibling),Ng(s,o.previousSibling,o)}function Ng(t,e,n){return!e||!n||"ul"!=e.name&&"ol"!=e.name||e.name!=n.name||e.getAttribute("class")!==n.getAttribute("class")?null:t.mergeContainers(t.createPositionAfter(e))}function Og(t){return t.getLastMatchingPosition(t=>t.item.is("uiElement"))}function Rg(t,e){const n=!!e.sameIndent,i=!!e.smallerIndent,o=e.listIndent;let r=t;for(;r&&"listItem"==r.name;){const t=r.getAttribute("listIndent");if(n&&o==t||i&&o>t)return r;r=r.previousSibling}return null}function Dg(t,e,n,i){t.ui.componentFactory.add(e,o=>{const r=t.commands.get(e),s=new Ll(o);return s.set({label:n,icon:i,tooltip:!0,isToggleable:!0}),s.bind("isOn","isEnabled").to(r,"value","isEnabled"),s.on("execute",()=>{t.execute(e),t.editing.view.focus()}),s})}function Lg(){const t=!this.isEmpty&&("ul"==this.getChild(0).name||"ol"==this.getChild(0).name);return this.isEmpty||t?0:Li.call(this)}function jg(t){return(e,n,i)=>{const o=i.consumable;if(!o.test(n.item,"insert")||!o.test(n.item,"attribute:listType")||!o.test(n.item,"attribute:listIndent"))return;o.consume(n.item,"insert"),o.consume(n.item,"attribute:listType"),o.consume(n.item,"attribute:listIndent");const r=n.item;Ig(r,Mg(r,i),i,t)}}function Vg(t,e,n){if(!n.consumable.consume(e.item,"attribute:listType"))return;const i=n.mapper.toViewElement(e.item),o=n.writer;o.breakContainer(o.createPositionBefore(i)),o.breakContainer(o.createPositionAfter(i));const r=i.parent,s="numbered"==e.attributeNewValue?"ol":"ul";o.rename(s,r)}function zg(t,e,n){const i=n.mapper.toViewElement(e.item).parent,o=n.writer;Ng(o,i,i.nextSibling),Ng(o,i.previousSibling,i);for(const t of e.item.getChildren())n.consumable.consume(t,"insert")}function Bg(t,e,n){if("listItem"!=e.item.name){let t=n.mapper.toViewPosition(e.range.start);const i=n.writer,o=[];for(;("ul"==t.parent.name||"ol"==t.parent.name)&&(t=i.breakContainer(t),"li"==t.parent.name);){const e=t,n=i.createPositionAt(t.parent,"end");if(!e.isEqual(n)){const t=i.remove(i.createRange(e,n));o.push(t)}t=i.createPositionAfter(t.parent)}if(o.length>0){for(let e=0;e<o.length;e++){const n=t.nodeBefore;if(t=i.insert(t,o[e]).end,e>0){const e=Ng(i,n,n.nextSibling);e&&e.parent==n&&t.offset--}}Ng(i,t.nodeBefore,t.nodeAfter)}}}function Fg(t,e,n){const i=n.mapper.toViewPosition(e.position),o=i.nodeBefore,r=i.nodeAfter;Ng(n.writer,o,r)}function Ug(t,e,n){if(n.consumable.consume(e.viewItem,{name:!0})){const t=n.writer,i=t.createElement("listItem"),o=function(t){let e=0,n=t.parent;for(;n;){if(n.is("li"))e++;else{const t=n.previousSibling;t&&t.is("li")&&e++}n=n.parent}return e}(e.viewItem);t.setAttribute("listIndent",o,i);const r=e.viewItem.parent&&"ol"==e.viewItem.parent.name?"numbered":"bulleted";t.setAttribute("listType",r,i);const s=n.splitToAllowedParent(i,e.modelCursor);if(!s)return;t.insert(i,s.position);const a=function(t,e,n){const{writer:i,schema:o}=n;let r=i.createPositionAfter(t);for(const s of e)if("ul"==s.name||"ol"==s.name)r=n.convertItem(s,r).modelCursor;else{const e=n.convertItem(s,i.createPositionAt(t,"end")),a=e.modelRange.start.nodeAfter;a&&a.is("element")&&!o.checkChild(t,a.name)&&(t=e.modelCursor.parent.is("listItem")?e.modelCursor.parent:Gg(e.modelCursor),r=i.createPositionAfter(t))}return r}(i,e.viewItem.getChildren(),n);e.modelRange=t.createRange(e.modelCursor,a),s.cursorParent?e.modelCursor=t.createPositionAt(s.cursorParent,0):e.modelCursor=e.modelRange.end}}function Hg(t,e,n){if(n.consumable.test(e.viewItem,{name:!0})){const t=Array.from(e.viewItem.getChildren());for(const e of t){!(e.is("li")||Kg(e))&&e._remove()}}}function Wg(t,e,n){if(n.consumable.test(e.viewItem,{name:!0})){if(0===e.viewItem.childCount)return;const t=[...e.viewItem.getChildren()];let n=!1,i=!0;for(const e of t)n&&!Kg(e)&&e._remove(),e.is("text")?(i&&(e._data=e.data.replace(/^\s+/,"")),e.nextSibling&&!Kg(e.nextSibling)||(e._data=e.data.replace(/\s+$/,""))):Kg(e)&&(n=!0),i=!1}}function qg(t){return(e,n)=>{if(n.isPhantom)return;const i=n.modelPosition.nodeBefore;if(i&&i.is("listItem")){const e=n.mapper.toViewElement(i),o=e.getAncestors().find(Kg),r=t.createPositionAt(e,0).getWalker();for(const t of r){if("elementStart"==t.type&&t.item.is("li")){n.viewPosition=t.previousPosition;break}if("elementEnd"==t.type&&t.item==o){n.viewPosition=t.nextPosition;break}}}}}function Yg(t,[e,n]){let i,o=e.is("documentFragment")?e.getChild(0):e;if(i=n?this.createSelection(n):this.document.selection,o&&o.is("listItem")){const t=i.getFirstPosition();let e=null;if(t.parent.is("listItem")?e=t.parent:t.nodeBefore&&t.nodeBefore.is("listItem")&&(e=t.nodeBefore),e){const t=e.getAttribute("listIndent");if(t>0)for(;o&&o.is("listItem");)o._setAttribute("listIndent",o.getAttribute("listIndent")+t),o=o.nextSibling}}}function Gg(t){const e=new _s({startPosition:t});let n;do{n=e.next()}while(!n.value.item.is("listItem"));return n.value.item}function $g(t,e,n,i,o,r){const s=Rg(e.nodeBefore,{sameIndent:!0,smallerIndent:!0,listIndent:t,foo:"b"}),a=o.mapper,c=o.writer,l=s?s.getAttribute("listIndent"):null;let d;if(s)if(l==t){const t=a.toViewElement(s).parent;d=c.createPositionAfter(t)}else{const t=r.createPositionAt(s,"end");d=a.toViewPosition(t)}else d=n;d=Og(d);for(const t of[...i.getChildren()])Kg(t)&&(d=c.move(c.createRangeOn(t),d).end,Ng(c,t,t.nextSibling),Ng(c,t.previousSibling,t))}function Kg(t){return t.is("ol")||t.is("ul")}class Qg extends Zl{static get pluginName(){return"ListEditing"}static get requires(){return[Vf]}init(){const t=this.editor;t.model.schema.register("listItem",{inheritAllFrom:"$block",allowAttributes:["listType","listIndent"]});const e=t.data,n=t.editing;var i;t.model.document.registerPostFixer(e=>function(t,e){const n=t.document.differ.getChanges(),i=new Map;let o=!1;for(const i of n)if("insert"==i.type&&"listItem"==i.name)r(i.position);else if("insert"==i.type&&"listItem"!=i.name){if("$text"!=i.name){const n=i.position.nodeAfter;n.hasAttribute("listIndent")&&(e.removeAttribute("listIndent",n),o=!0),n.hasAttribute("listType")&&(e.removeAttribute("listType",n),o=!0);for(const e of Array.from(t.createRangeIn(n)).filter(t=>t.item.is("listItem")))r(e.previousPosition)}r(i.position.getShiftedBy(i.length))}else"remove"==i.type&&"listItem"==i.name?r(i.position):("attribute"==i.type&&"listIndent"==i.attributeKey||"attribute"==i.type&&"listType"==i.attributeKey)&&r(i.range.start);for(const t of i.values())s(t),a(t);return o;function r(t){const e=t.nodeBefore;if(e&&e.is("listItem")){let t=e;if(i.has(t))return;for(let e=t.previousSibling;e&&e.is("listItem");e=t.previousSibling)if(t=e,i.has(t))return;i.set(e,t)}else{const e=t.nodeAfter;e&&e.is("listItem")&&i.set(e,e)}}function s(t){let n=0,i=null;for(;t&&t.is("listItem");){const r=t.getAttribute("listIndent");if(r>n){let s;null===i?(i=r-n,s=n):(i>r&&(i=r),s=r-i),e.setAttribute("listIndent",s,t),o=!0}else i=null,n=t.getAttribute("listIndent")+1;t=t.nextSibling}}function a(t){let n=[],i=null;for(;t&&t.is("listItem");){const r=t.getAttribute("listIndent");if(i&&i.getAttribute("listIndent")>r&&(n=n.slice(0,r+1)),0!=r)if(n[r]){const i=n[r];t.getAttribute("listType")!=i&&(e.setAttribute("listType",i,t),o=!0)}else n[r]=t.getAttribute("listType");i=t,t=t.nextSibling}}}(t.model,e)),n.mapper.registerViewToModelLength("li",Jg),e.mapper.registerViewToModelLength("li",Jg),n.mapper.on("modelToViewPosition",qg(n.view)),n.mapper.on("viewToModelPosition",(i=t.model,(t,e)=>{const n=e.viewPosition,o=n.parent,r=e.mapper;if("ul"==o.name||"ol"==o.name){if(n.isAtEnd){const t=r.toModelElement(n.nodeBefore),o=r.getModelLength(n.nodeBefore);e.modelPosition=i.createPositionBefore(t).getShiftedBy(o)}else{const t=r.toModelElement(n.nodeAfter);e.modelPosition=i.createPositionBefore(t)}t.stop()}else if("li"==o.name&&n.nodeBefore&&("ul"==n.nodeBefore.name||"ol"==n.nodeBefore.name)){const s=r.toModelElement(o);let a=1,c=n.nodeBefore;for(;c&&Kg(c);)a+=r.getModelLength(c),c=c.previousSibling;e.modelPosition=i.createPositionBefore(s).getShiftedBy(a),t.stop()}})),e.mapper.on("modelToViewPosition",qg(n.view)),t.conversion.for("editingDowncast").add(e=>{e.on("insert",Bg,{priority:"high"}),e.on("insert:listItem",jg(t.model)),e.on("attribute:listType:listItem",Vg,{priority:"high"}),e.on("attribute:listType:listItem",zg,{priority:"low"}),e.on("attribute:listIndent:listItem",function(t){return(e,n,i)=>{if(!i.consumable.consume(n.item,"attribute:listIndent"))return;const o=i.mapper.toViewElement(n.item),r=i.writer;r.breakContainer(r.createPositionBefore(o)),r.breakContainer(r.createPositionAfter(o));const s=o.parent,a=s.previousSibling,c=r.createRangeOn(s);r.remove(c),a&&a.nextSibling&&Ng(r,a,a.nextSibling),$g(n.attributeOldValue+1,n.range.start,c.start,o,i,t),Ig(n.item,o,i,t);for(const t of n.item.getChildren())i.consumable.consume(t,"insert")}}(t.model)),e.on("remove:listItem",function(t){return(e,n,i)=>{const o=i.mapper.toViewPosition(n.position).getLastMatchingPosition(t=>!t.item.is("li")).nodeAfter,r=i.writer;r.breakContainer(r.createPositionBefore(o)),r.breakContainer(r.createPositionAfter(o));const s=o.parent,a=s.previousSibling,c=r.createRangeOn(s),l=r.remove(c);a&&a.nextSibling&&Ng(r,a,a.nextSibling);$g(i.mapper.toModelElement(o).getAttribute("listIndent")+1,n.position,c.start,o,i,t);for(const t of r.createRangeIn(l).getItems())i.mapper.unbindViewElement(t);e.stop()}}(t.model)),e.on("remove",Fg,{priority:"low"})}),t.conversion.for("dataDowncast").add(e=>{e.on("insert",Bg,{priority:"high"}),e.on("insert:listItem",jg(t.model))}),t.conversion.for("upcast").add(t=>{t.on("element:ul",Hg,{priority:"high"}),t.on("element:ol",Hg,{priority:"high"}),t.on("element:li",Wg,{priority:"high"}),t.on("element:li",Ug)}),t.model.on("insertContent",Yg,{priority:"high"}),t.commands.add("numberedList",new Tg(t,"numbered")),t.commands.add("bulletedList",new Tg(t,"bulleted")),t.commands.add("indentList",new Eg(t,"forward")),t.commands.add("outdentList",new Eg(t,"backward"));const o=n.view.document;this.listenTo(o,"enter",(t,e)=>{const n=this.editor.model.document,i=n.selection.getLastPosition().parent;n.selection.isCollapsed&&"listItem"==i.name&&i.isEmpty&&(this.editor.execute("outdentList"),e.preventDefault(),t.stop())}),this.listenTo(o,"delete",(t,e)=>{if("backward"!==e.direction)return;const n=this.editor.model.document.selection;if(!n.isCollapsed)return;const i=n.getFirstPosition();if(!i.isAtStart)return;const o=i.parent;if("listItem"!==o.name)return;o.previousSibling&&"listItem"===o.previousSibling.name||(this.editor.execute("outdentList"),e.preventDefault(),t.stop())},{priority:"high"});const r=t=>(e,n)=>{this.editor.commands.get(t).isEnabled&&(this.editor.execute(t),n())};t.keystrokes.set("Tab",r("indentList")),t.keystrokes.set("Shift+Tab",r("outdentList"))}afterInit(){const t=this.editor.commands,e=t.get("indent"),n=t.get("outdent");e&&e.registerChildCommand(t.get("indentList")),n&&n.registerChildCommand(t.get("outdentList"))}}function Jg(t){let e=1;for(const n of t.getChildren())if("ul"==n.name||"ol"==n.name)for(const t of n.getChildren())e+=Jg(t);return e}class Zg extends Zl{init(){const t=this.editor.t;Dg(this.editor,"numberedList",t("Numbered List"),'<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7 5.75c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM3.5 3v5H2V3.7H1v-1h2.5V3zM.343 17.857l2.59-3.257H2.92a.6.6 0 1 0-1.04 0H.302a2 2 0 1 1 3.995 0h-.001c-.048.405-.16.734-.333.988-.175.254-.59.692-1.244 1.312H4.3v1h-4l.043-.043zM7 14.75a.75.75 0 0 1 .75-.75h9.5a.75.75 0 1 1 0 1.5h-9.5a.75.75 0 0 1-.75-.75z"/></svg>'),Dg(this.editor,"bulletedList",t("Bulleted List"),'<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7 5.75c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zm-6 0C1 4.784 1.777 4 2.75 4c.966 0 1.75.777 1.75 1.75 0 .966-.777 1.75-1.75 1.75C1.784 7.5 1 6.723 1 5.75zm6 9c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zm-6 0c0-.966.777-1.75 1.75-1.75.966 0 1.75.777 1.75 1.75 0 .966-.777 1.75-1.75 1.75-.966 0-1.75-.777-1.75-1.75z"/></svg>')}}function Xg(t,e){return t=>{t.on("attribute:url:media",n)};function n(n,i,o){if(!o.consumable.consume(i.item,n.name))return;const r=i.attributeNewValue,s=o.writer,a=o.mapper.toViewElement(i.item),c=[...a.getChildren()].find(t=>t.getCustomProperty("media-content"));s.remove(c);const l=t.getMediaViewElement(s,r,e);s.insert(s.createPositionAt(a,0),l)}}function tm(t,e,n,i){const o=t.createContainerElement("figure",{class:"media"});return o.getFillerOffset=im,t.insert(t.createPositionAt(o,0),e.getMediaViewElement(t,n,i)),o}function em(t){const e=t.getSelectedElement();return e&&e.is("media")?e:null}function nm(t,e,n){t.change(i=>{const o=i.createElement("media",{url:e});t.insertContent(o,n),i.setSelection(o,"on")})}function im(){return null}class om extends od{refresh(){const t=this.editor.model,e=t.document.selection,n=t.schema,i=e.getFirstPosition(),o=em(e);let r=i.parent;r!=r.root&&(r=r.parent),this.value=o?o.getAttribute("url"):null,this.isEnabled=n.checkChild(r,"media")}execute(t){const e=this.editor.model,n=e.document.selection,i=em(n);if(i)e.change(e=>{e.setAttribute("url",t,i)});else{const i=Wu(n,e);nm(e,t,i)}}}class rm{constructor(t,e){const n=e.providers,i=e.extraProviders||[],o=new Set(e.removeProviders),r=n.concat(i).filter(t=>{const e=t.name;return e?!o.has(e):(console.warn(Object(hn.a)("media-embed-no-provider-name: The configured media provider has no name and cannot be used."),{provider:t}),!1)});this.locale=t,this.providerDefinitions=r}hasMedia(t){return!!this._getMedia(t)}getMediaViewElement(t,e,n){return this._getMedia(e).getViewElement(t,n)}_getMedia(t){if(!t)return new sm(this.locale);t=t.trim();for(const e of this.providerDefinitions){const n=e.html;let i=e.url;Array.isArray(i)||(i=[i]);for(const e of i){const i=this._getUrlMatches(t,e);if(i)return new sm(this.locale,t,i,n)}}return null}_getUrlMatches(t,e){let n=t.match(e);if(n)return n;let i=t.replace(/^https?:\/\//,"");return n=i.match(e),n||(i=i.replace(/^www\./,""),n=i.match(e),n||null)}}class sm{constructor(t,e,n,i){this.url=this._getValidUrl(e),this._t=t.t,this._match=n,this._previewRenderer=i}getViewElement(t,e){const n={};let i;if(e.renderForEditingView||e.renderMediaPreview&&this.url&&this._previewRenderer){this.url&&(n["data-oembed-url"]=this.url),e.renderForEditingView&&(n.class="ck-media__wrapper");const o=this._getPreviewHtml(e);i=t.createUIElement("div",n,(function(t){const e=this.toDomElement(t);return e.innerHTML=o,e}))}else this.url&&(n.url=this.url),i=t.createEmptyElement("oembed",n);return t.setCustomProperty("media-content",!0,i),i}_getPreviewHtml(t){return this._previewRenderer?this._previewRenderer(this._match):this.url&&t.renderForEditingView?this._getPlaceholderHtml():""}_getPlaceholderHtml(){const t=new Dl,e=new Rl;t.text=this._t("Open media in new tab"),e.content='<svg viewBox="0 0 64 42" xmlns="http://www.w3.org/2000/svg"><path d="M47.426 17V3.713L63.102 0v19.389h-.001l.001.272c0 1.595-2.032 3.43-4.538 4.098-2.506.668-4.538-.083-4.538-1.678 0-1.594 2.032-3.43 4.538-4.098.914-.244 2.032-.565 2.888-.603V4.516L49.076 7.447v9.556A1.014 1.014 0 0 0 49 17h-1.574zM29.5 17h-8.343a7.073 7.073 0 1 0-4.657 4.06v3.781H3.3a2.803 2.803 0 0 1-2.8-2.804V8.63a2.803 2.803 0 0 1 2.8-2.805h4.082L8.58 2.768A1.994 1.994 0 0 1 10.435 1.5h8.985c.773 0 1.477.448 1.805 1.149l1.488 3.177H26.7c1.546 0 2.8 1.256 2.8 2.805V17zm-11.637 0H17.5a1 1 0 0 0-1 1v.05A4.244 4.244 0 1 1 17.863 17zm29.684 2c.97 0 .953-.048.953.889v20.743c0 .953.016.905-.953.905H19.453c-.97 0-.953.048-.953-.905V19.89c0-.937-.016-.889.97-.889h28.077zm-4.701 19.338V22.183H24.154v16.155h18.692zM20.6 21.375v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616V37.53H20.6zm24.233-16.155v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615V37.53h-1.615zM29.485 25.283a.4.4 0 0 1 .593-.35l9.05 4.977a.4.4 0 0 1 0 .701l-9.05 4.978a.4.4 0 0 1-.593-.35v-9.956z"/></svg>',e.viewBox="0 0 64 42";return new Gc({tag:"div",attributes:{class:"ck ck-reset_all ck-media__placeholder"},children:[{tag:"div",attributes:{class:"ck-media__placeholder__icon"},children:[e]},{tag:"a",attributes:{class:"ck-media__placeholder__url",target:"_blank",rel:"noopener noreferrer",href:this.url},children:[{tag:"span",attributes:{class:"ck-media__placeholder__url__text"},children:[this.url]},t]}]}).render().outerHTML}_getValidUrl(t){return t?t.match(/^https?/)?t:"https://"+t:null}}n(80);class am extends Zl{static get pluginName(){return"MediaEmbedEditing"}constructor(t){super(t),t.config.define("mediaEmbed",{providers:[{name:"dailymotion",url:/^dailymotion\.com\/video\/(\w+)/,html:t=>`<div style="position: relative; padding-bottom: 100%; height: 0; "><iframe src="https://www.dailymotion.com/embed/video/${t[1]}" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" frameborder="0" width="480" height="270" allowfullscreen allow="autoplay"></iframe></div>`},{name:"spotify",url:[/^open\.spotify\.com\/(artist\/\w+)/,/^open\.spotify\.com\/(album\/\w+)/,/^open\.spotify\.com\/(track\/\w+)/],html:t=>`<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 126%;"><iframe src="https://open.spotify.com/embed/${t[1]}" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" frameborder="0" allowtransparency="true" allow="encrypted-media"></iframe></div>`},{name:"youtube",url:[/^(?:m\.)?youtube\.com\/watch\?v=([\w-]+)/,/^(?:m\.)?youtube\.com\/v\/([\w-]+)/,/^youtube\.com\/embed\/([\w-]+)/,/^youtu\.be\/([\w-]+)/],html:t=>`<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;"><iframe src="https://www.youtube.com/embed/${t[1]}" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></div>`},{name:"vimeo",url:[/^vimeo\.com\/(\d+)/,/^vimeo\.com\/[^/]+\/[^/]+\/video\/(\d+)/,/^vimeo\.com\/album\/[^/]+\/video\/(\d+)/,/^vimeo\.com\/channels\/[^/]+\/(\d+)/,/^vimeo\.com\/groups\/[^/]+\/videos\/(\d+)/,/^vimeo\.com\/ondemand\/[^/]+\/(\d+)/,/^player\.vimeo\.com\/video\/(\d+)/],html:t=>`<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;"><iframe src="https://player.vimeo.com/video/${t[1]}" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div>`},{name:"instagram",url:/^instagram\.com\/p\/(\w+)/},{name:"twitter",url:/^twitter\.com/},{name:"googleMaps",url:/^google\.com\/maps/},{name:"flickr",url:/^flickr\.com/},{name:"facebook",url:/^facebook\.com/}]}),this.registry=new rm(t.locale,t.config.get("mediaEmbed"))}init(){const t=this.editor,e=t.model.schema,n=t.t,i=t.conversion,o=t.config.get("mediaEmbed.previewsInData"),r=this.registry;t.commands.add("mediaEmbed",new om(t)),e.register("media",{isObject:!0,isBlock:!0,allowWhere:"$block",allowAttributes:["url"]}),i.for("dataDowncast").elementToElement({model:"media",view:(t,e)=>{const n=t.getAttribute("url");return tm(e,r,n,{renderMediaPreview:n&&o})}}),i.for("dataDowncast").add(Xg(r,{renderMediaPreview:o})),i.for("editingDowncast").elementToElement({model:"media",view:(t,e)=>{const i=t.getAttribute("url"),o=tm(e,r,i,{renderForEditingView:!0});return s=o,a=e,c=n("media widget"),a.setCustomProperty("media",!0,s),Bu(s,a,{label:c});var s,a,c}}),i.for("editingDowncast").add(Xg(r,{renderForEditingView:!0})),i.for("upcast").elementToElement({view:{name:"oembed",attributes:{url:!0}},model:(t,e)=>{const n=t.getAttribute("url");if(r.hasMedia(n))return e.createElement("media",{url:n})}}).elementToElement({view:{name:"div",attributes:{"data-oembed-url":!0}},model:(t,e)=>{const n=t.getAttribute("data-oembed-url");if(r.hasMedia(n))return e.createElement("media",{url:n})}})}}const cm=/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=]+$/;class lm extends Zl{static get requires(){return[id,tu]}static get pluginName(){return"AutoMediaEmbed"}constructor(t){super(t),this._timeoutId=null,this._positionToInsert=null}init(){const t=this.editor,e=t.model.document;this.listenTo(t.plugins.get(id),"inputTransformation",()=>{const t=e.selection.getFirstRange(),n=dc.fromPosition(t.start);n.stickiness="toPrevious";const i=dc.fromPosition(t.end);i.stickiness="toNext",e.once("change:data",()=>{this._embedMediaBetweenPositions(n,i),n.detach(),i.detach()},{priority:"high"})}),t.commands.get("undo").on("execute",()=>{this._timeoutId&&(nr.window.clearTimeout(this._timeoutId),this._positionToInsert.detach(),this._timeoutId=null,this._positionToInsert=null)},{priority:"high"})}_embedMediaBetweenPositions(t,e){const n=this.editor,i=n.plugins.get(am).registry,o=new js(t,e),r=o.getWalker({ignoreElementEnd:!0});let s="";for(const t of r)t.item.is("textProxy")&&(s+=t.item.data);if(s=s.trim(),!s.match(cm))return void o.detach();if(!i.hasMedia(s))return void o.detach();n.commands.get("mediaEmbed").isEnabled?(this._positionToInsert=dc.fromPosition(t),this._timeoutId=nr.window.setTimeout(()=>{n.model.change(t=>{let e;this._timeoutId=null,t.remove(o),o.detach(),"$graveyard"!==this._positionToInsert.root.rootName&&(e=this._positionToInsert),nm(n.model,s,e),this._positionToInsert.detach(),this._positionToInsert=null})},100)):o.detach()}}n(82);class dm extends hl{constructor(t,e){super(e);const n=e.t;this.focusTracker=new jc,this.keystrokes=new Sc,this.urlInputView=this._createUrlInput(),this.saveButtonView=this._createButton(n("Save"),cf,"ck-button-save"),this.saveButtonView.type="submit",this.cancelButtonView=this._createButton(n("Cancel"),lf,"ck-button-cancel","cancel"),this._focusables=new Yc,this._focusCycler=new xl({focusables:this._focusables,focusTracker:this.focusTracker,keystrokeHandler:this.keystrokes,actions:{focusPrevious:"shift + tab",focusNext:"tab"}}),this._validators=t,this.setTemplate({tag:"form",attributes:{class:["ck","ck-media-form"],tabindex:"-1"},children:[this.urlInputView,this.saveButtonView,this.cancelButtonView]})}render(){super.render(),af({view:this});[this.urlInputView,this.saveButtonView,this.cancelButtonView].forEach(t=>{this._focusables.add(t),this.focusTracker.add(t.element)}),this.keystrokes.listenTo(this.element);const t=t=>t.stopPropagation();this.keystrokes.set("arrowright",t),this.keystrokes.set("arrowleft",t),this.keystrokes.set("arrowup",t),this.keystrokes.set("arrowdown",t),this.listenTo(this.urlInputView.element,"selectstart",(t,e)=>{e.stopPropagation()},{priority:"high"})}focus(){this._focusCycler.focusFirst()}get url(){return this.urlInputView.fieldView.element.value.trim()}set url(t){this.urlInputView.fieldView.element.value=t.trim()}isValid(){this.resetFormStatus();for(const t of this._validators){const e=t(this);if(e)return this.urlInputView.errorText=e,!1}return!0}resetFormStatus(){this.urlInputView.errorText=null,this.urlInputView.infoText=this._urlInputViewInfoDefault}_createUrlInput(){const t=this.locale.t,e=new of(this.locale,sf),n=e.fieldView;return this._urlInputViewInfoDefault=t("Paste the media URL in the input."),this._urlInputViewInfoTip=t("Tip: Paste the URL into the content to embed faster."),e.label=t("Media URL"),e.infoText=this._urlInputViewInfoDefault,n.placeholder="https://example.com",n.on("input",()=>{e.infoText=n.element.value?this._urlInputViewInfoTip:this._urlInputViewInfoDefault}),e}_createButton(t,e,n,i){const o=new Ll(this.locale);return o.set({label:t,icon:e,tooltip:!0}),o.extendTemplate({attributes:{class:n}}),i&&o.delegate("execute").to(this,i),o}}class um extends Zl{static get requires(){return[am]}static get pluginName(){return"MediaEmbedUI"}init(){const t=this.editor,e=t.commands.get("mediaEmbed"),n=t.plugins.get(am).registry;t.ui.componentFactory.add("mediaEmbed",i=>{const o=Wl(i),r=new dm(function(t,e){return[e=>{if(!e.url.length)return t("The URL must not be empty.")},n=>{if(!e.hasMedia(n.url))return t("This media URL is not supported.")}]}(t.t,n),t.locale);return this._setUpDropdown(o,r,e,t),this._setUpForm(o,r,e),o})}_setUpDropdown(t,e,n){const i=this.editor,o=i.t,r=t.buttonView;function s(){i.editing.view.focus(),t.isOpen=!1}t.bind("isEnabled").to(n),t.panelView.children.add(e),r.set({label:o("Insert media"),icon:'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M18.68 3.03c.6 0 .59-.03.59.55v12.84c0 .59.01.56-.59.56H1.29c-.6 0-.59.03-.59-.56V3.58c0-.58-.01-.55.6-.55h17.38zM15.77 15V5H4.2v10h11.57zM2 4v1h1V4H2zm0 2v1h1V6H2zm0 2v1h1V8H2zm0 2v1h1v-1H2zm0 2v1h1v-1H2zm0 2v1h1v-1H2zM17 4v1h1V4h-1zm0 2v1h1V6h-1zm0 2v1h1V8h-1zm0 2v1h1v-1h-1zm0 2v1h1v-1h-1zm0 2v1h1v-1h-1zM7.5 7.177a.4.4 0 01.593-.351l5.133 2.824a.4.4 0 010 .7l-5.133 2.824a.4.4 0 01-.593-.35V7.176v.001z"/></svg>\n',tooltip:!0}),r.on("open",()=>{e.url=n.value||"",e.urlInputView.fieldView.select(),e.focus()},{priority:"low"}),t.on("submit",()=>{e.isValid()&&(i.execute("mediaEmbed",e.url),s())}),t.on("change:isOpen",()=>e.resetFormStatus()),t.on("cancel",()=>s())}_setUpForm(t,e,n){e.delegate("submit","cancel").to(t),e.urlInputView.bind("value").to(n,"value"),e.urlInputView.bind("isReadOnly").to(n,"isEnabled",t=>!t),e.saveButtonView.bind("isEnabled").to(n)}}n(84);function hm(t,e){if(!t.childCount)return;const n=new Ef(t.document),i=function(t,e){const n=e.createRangeIn(t),i=new jn({name:/^p|h\d+$/,styles:{"mso-list":/.*/}}),o=[];for(const t of n)if("elementStart"===t.type&&i.match(t.item)){const e=gm(t.item);o.push({element:t.item,id:e.id,order:e.order,indent:e.indent})}return o}(t,n);if(!i.length)return;let o=null,r=1;i.forEach((t,s)=>{const a=function(t,e){if(!t)return!0;if(t.id!==e.id)return!0;const n=e.element.previousSibling;if(!n)return!0;return i=n,!(i.is("ol")||i.is("ul"));var i}(i[s-1],t),c=a?null:i[s-1],l=(u=t,(d=c)?u.indent-d.indent:u.indent-1);var d,u;if(a&&(o=null,r=1),!o||0!==l){const i=function(t,e){const n=new RegExp(`@list l${t.id}:level${t.indent}\\s*({[^}]*)`,"gi"),i=/mso-level-number-format:([^;]*);/gi,o=n.exec(e);let r="decimal";if(o&&o[1]){const t=i.exec(o[1]);t&&t[1]&&(r=t[1].trim())}return{type:"bullet"!==r&&"image"!==r?"ol":"ul",style:r}}(t,e);if(o){if(t.indent>r){const t=o.getChild(o.childCount-1),e=t.getChild(t.childCount-1);o=fm(i,e,n),r+=1}else if(t.indent<r){const e=r-t.indent;o=function(t,e){const n=t.getAncestors({parentFirst:!0});let i=null,o=0;for(const t of n)if("ul"!==t.name&&"ol"!==t.name||o++,o===e){i=t;break}return i}(o,e),r=parseInt(t.indent)}}else o=fm(i,t.element,n);t.indent<=r&&(o.is(i.type)||(o=n.rename(i.type,o)))}const h=function(t,e){return function(t,e){const n=new jn({name:"span",styles:{"mso-list":"Ignore"}}),i=e.createRangeIn(t);for(const t of i)"elementStart"===t.type&&n.match(t.item)&&e.remove(t.item)}(t,e),e.rename("li",t)}(t.element,n);n.appendChild(h,o)})}function fm(t,e,n){const i=e.parent,o=n.createElement(t.type),r=i.getChildIndex(e)+1;return n.insertChild(r,o,i),o}function gm(t){const e={},n=t.getStyle("mso-list");if(n){const t=n.match(/(^|\s+)l(\d+)/i),i=n.match(/\s*lfo(\d+)/i),o=n.match(/\s*level(\d+)/i);t&&i&&o&&(e.id=t[2],e.order=i[1],e.indent=o[1])}return e}const mm=/id=("|')docs-internal-guid-[-0-9a-f]+("|')/i;class pm{constructor(t){this.document=t}isActive(t){return mm.test(t)}execute(t){const e=new Ef(this.document);!function(t,e){for(const n of t.getChildren())if(n.is("b")&&"normal"===n.getStyle("font-weight")){const i=t.getChildIndex(n);e.remove(n),e.insertChild(i,n.getChildren(),t)}}(t.content,e),function(t,e){for(const n of e.createRangeIn(t)){const t=n.item;if(t.is("li")){const n=t.getChild(0);n.is("p")&&e.unwrapElement(n)}}}(t.content,e)}}function bm(t){return t.replace(/<span(?: class="Apple-converted-space"|)>(\s+)<\/span>/g,(t,e)=>1===e.length?" ":Array(e.length+1).join("  ").substr(0,e.length))}function wm(t,e){const n=new DOMParser,i=function(t){return bm(bm(t)).replace(/(<span\s+style=['"]mso-spacerun:yes['"]>[\s]*?)[\r\n]+(\s*<\/span>)/g,"$1$2").replace(/<span\s+style=['"]mso-spacerun:yes['"]><\/span>/g,"").replace(/ <\//g," </").replace(/ <o:p><\/o:p>/g," <o:p></o:p>").replace(/<o:p>(&nbsp;|\u00A0)<\/o:p>/g,"").replace(/>(\s*[\r\n]\s*)</g,"><")}(function(t){const e=t.match(/<\/body>(.*?)(<\/html>|$)/);e&&e[1]&&(t=t.slice(0,e.index)+t.slice(e.index).replace(e[1],""));return t}(t=t.replace(/<!--\[if gte vml 1]>/g,""))),o=n.parseFromString(i,"text/html");!function(t){t.querySelectorAll("span[style*=spacerun]").forEach(t=>{const e=t.innerText.length||0;t.innerHTML=Array(e+1).join("  ").substr(0,e)})}(o);const r=o.body.innerHTML,s=function(t,e){const n=new oo(e),i=new sr(n,{blockFillerMode:"nbsp"}),o=t.createDocumentFragment(),r=t.body.childNodes;for(;r.length>0;)o.appendChild(r[0]);return i.domToView(o)}(o,e),a=function(t){const e=[],n=[],i=Array.from(t.getElementsByTagName("style"));for(const t of i)t.sheet&&t.sheet.cssRules&&t.sheet.cssRules.length&&(e.push(t.sheet),n.push(t.innerHTML));return{styles:e,stylesString:n.join(" ")}}(o);return{body:s,bodyString:r,styles:a.styles,stylesString:a.stylesString}}function km(t,e){if(!t.childCount)return;const n=new Ef;!function(t,e,n){const i=n.createRangeIn(e),o=new jn({name:"img"}),r=[];for(const e of i)if(o.match(e.item)){const n=e.item,i=n.getAttribute("v:shapes")?n.getAttribute("v:shapes").split(" "):[];i.length&&i.every(e=>t.indexOf(e)>-1)?r.push(n):n.getAttribute("src")||r.push(n)}for(const t of r)n.remove(t)}(function(t,e){const n=e.createRangeIn(t),i=new jn({name:/v:(.+)/}),o=[];for(const t of n){const e=t.item,n=e.previousSibling&&e.previousSibling.name||null;i.match(e)&&e.getAttribute("o:gfxdata")&&"v:shapetype"!==n&&o.push(t.item.getAttribute("id"))}return o}(t,n),t,n),function(t,e){const n=e.createRangeIn(t),i=new jn({name:/v:(.+)/}),o=[];for(const t of n)i.match(t.item)&&o.push(t.item);for(const t of o)e.remove(t)}(t,n);const i=function(t,e){const n=e.createRangeIn(t),i=new jn({name:"img"}),o=[];for(const t of n)i.match(t.item)&&t.item.getAttribute("src").startsWith("file://")&&o.push(t.item);return o}(t,n);i.length&&function(t,e,n){if(t.length===e.length)for(let o=0;o<t.length;o++){const r=`data:${e[o].type};base64,${i=e[o].hex,btoa(i.match(/\w{2}/g).map(t=>String.fromCharCode(parseInt(t,16))).join(""))}`;n.setAttribute("src",r,t[o])}var i}(i,function(t){if(!t)return[];const e=/{\\pict[\s\S]+?\\bliptag-?\d+(\\blipupi-?\d+)?({\\\*\\blipuid\s?[\da-fA-F]+)?[\s}]*?/,n=new RegExp("(?:("+e.source+"))([\\da-fA-F\\s]+)\\}","g"),i=t.match(n),o=[];if(i)for(const t of i){let n=!1;t.includes("\\pngblip")?n="image/png":t.includes("\\jpegblip")&&(n="image/jpeg"),n&&o.push({hex:t.replace(e,"").replace(/[^\da-fA-F]/g,""),type:n})}return o}(e),n)}const _m=/<meta\s*name="?generator"?\s*content="?microsoft\s*word\s*\d+"?\/?>/i,vm=/xmlns:o="urn:schemas-microsoft-com/i;class ym{constructor(t){this.document=t}isActive(t){return _m.test(t)||vm.test(t)}execute(t){const{body:e,stylesString:n}=wm(t.dataTransfer.getData("text/html"),this.document.stylesProcessor);hm(e,n),km(e,t.dataTransfer.getData("text/rtf")),t.content=e}}function xm(t,e){let n=e.parent;for(;n;){if(n.name===t)return n;n=n.parent}}function Am(t,e,n,i,o=1){e>o?i.setAttribute(t,e,n):i.removeAttribute(t,n)}function Cm(t,e,n={}){const i=t.createElement("tableCell",n);t.insertElement("paragraph",i),t.insert(i,e)}function Tm(t,e){const n=e.parent.parent,i=parseInt(n.getAttribute("headingColumns")||0),{column:o}=t.getCellLocation(e);return!!i&&o<i}function Pm(){return t=>{t.on("element:table",(t,e,n)=>{const i=e.viewItem;if(!n.consumable.test(i,{name:!0}))return;const{rows:o,headingRows:r,headingColumns:s}=function(t){const e={headingRows:0,headingColumns:0},n=[],i=[];let o;for(const r of Array.from(t.getChildren()))if("tbody"===r.name||"thead"===r.name||"tfoot"===r.name){"thead"!==r.name||o||(o=r);const t=Array.from(r.getChildren()).filter(t=>t.is("element","tr"));for(const r of t)if("thead"===r.parent.name&&r.parent===o)e.headingRows++,n.push(r);else{i.push(r);const t=Em(r);t>e.headingColumns&&(e.headingColumns=t)}}return e.rows=[...n,...i],e}(i),a={};s&&(a.headingColumns=s),r&&(a.headingRows=r);const c=n.writer.createElement("table",a),l=n.splitToAllowedParent(c,e.modelCursor);if(l){if(n.writer.insert(c,l.position),n.consumable.consume(i,{name:!0}),o.forEach(t=>n.convertItem(t,n.writer.createPositionAt(c,"end"))),c.isEmpty){const t=n.writer.createElement("tableRow");n.writer.insert(t,n.writer.createPositionAt(c,"end")),Cm(n.writer,n.writer.createPositionAt(t,"end"))}e.modelRange=n.writer.createRange(n.writer.createPositionBefore(c),n.writer.createPositionAfter(c)),l.cursorParent?e.modelCursor=n.writer.createPositionAt(l.cursorParent,0):e.modelCursor=e.modelRange.end}})}}function Sm(t){return e=>{e.on("element:"+t,(t,e,n)=>{const i=e.viewItem;if(!n.consumable.test(i,{name:!0}))return;const o=n.writer.createElement("tableCell"),r=n.splitToAllowedParent(o,e.modelCursor);if(!r)return;n.writer.insert(o,r.position),n.consumable.consume(i,{name:!0});const s=n.writer.createPositionAt(o,0);n.convertChildren(i,s),o.childCount||n.writer.insertElement("paragraph",s),e.modelRange=n.writer.createRange(n.writer.createPositionBefore(o),n.writer.createPositionAfter(o)),e.modelCursor=e.modelRange.end})}}function Em(t){let e=0,n=0;const i=Array.from(t.getChildren()).filter(t=>"th"===t.name||"td"===t.name);for(;n<i.length&&"th"===i[n].name;){const t=i[n];e+=parseInt(t.getAttribute("colspan")||1),n++}return e}class Mm{constructor(t,e={}){this._table=t,this._startRow=void 0!==e.row?e.row:e.startRow||0,this._endRow=void 0!==e.row?e.row:e.endRow,this._startColumn=void 0!==e.column?e.column:e.startColumn||0,this._endColumn=void 0!==e.column?e.column:e.endColumn,this._includeAllSlots=!!e.includeAllSlots,this._skipRows=new Set,this._row=0,this._column=0,this._cellIndex=0,this._spannedCells=new Map,this._nextCellAtColumn=-1}[Symbol.iterator](){return this}next(){const t=this._table.getChild(this._row);if(!t||this._isOverEndRow())return{done:!0};if(this._isOverEndColumn())return this._advanceToNextRow();let e=null;const n=this._getSpanned();if(n)this._includeAllSlots&&!this._shouldSkipSlot()&&(e=this._formatOutValue(n.cell,n.row,n.column));else{const n=t.getChild(this._cellIndex);if(!n)return this._advanceToNextRow();const i=parseInt(n.getAttribute("colspan")||1),o=parseInt(n.getAttribute("rowspan")||1);(i>1||o>1)&&this._recordSpans(n,o,i),this._shouldSkipSlot()||(e=this._formatOutValue(n)),this._nextCellAtColumn=this._column+i}return this._column++,this._column==this._nextCellAtColumn&&this._cellIndex++,e||this.next()}skipRow(t){this._skipRows.add(t)}_advanceToNextRow(){return this._row++,this._column=0,this._cellIndex=0,this._nextCellAtColumn=-1,this.next()}_isOverEndRow(){return void 0!==this._endRow&&this._row>this._endRow}_isOverEndColumn(){return void 0!==this._endColumn&&this._column>this._endColumn}_formatOutValue(t,e=this._row,n=this._column){return{done:!1,value:new Im(this,t,e,n)}}_shouldSkipSlot(){const t=this._skipRows.has(this._row),e=this._row<this._startRow,n=this._column<this._startColumn,i=void 0!==this._endColumn&&this._column>this._endColumn;return t||e||n||i}_getSpanned(){const t=this._spannedCells.get(this._row);return t&&t.get(this._column)||null}_recordSpans(t,e,n){const i={cell:t,row:this._row,column:this._column};for(let t=this._row;t<this._row+e;t++)for(let e=this._column;e<this._column+n;e++)t==this._row&&e==this._column||this._markSpannedCell(t,e,i)}_markSpannedCell(t,e,n){this._spannedCells.has(t)||this._spannedCells.set(t,new Map);this._spannedCells.get(t).set(e,n)}}class Im{constructor(t,e,n,i){this.cell=e,this.row=t._row,this.column=t._column,this.cellAnchorRow=n,this.cellAnchorColumn=i,this._cellIndex=t._cellIndex,this._table=t._table}get isAnchor(){return this.row===this.cellAnchorRow&&this.column===this.cellAnchorColumn}get cellWidth(){return parseInt(this.cell.getAttribute("colspan")||1)}get cellHeight(){return parseInt(this.cell.getAttribute("rowspan")||1)}getPositionBefore(){return this._table.root.document.model.createPositionAt(this._table.getChild(this.row),this._cellIndex)}}function Nm(t={}){return e=>e.on("insert:table",(e,n,i)=>{const o=n.item;if(!i.consumable.consume(o,"insert"))return;i.consumable.consume(o,"attribute:headingRows:table"),i.consumable.consume(o,"attribute:headingColumns:table");const r=t&&t.asWidget,s=i.writer.createContainerElement("figure",{class:"table"}),a=i.writer.createContainerElement("table");let c;var l,d;i.writer.insert(i.writer.createPositionAt(s,0),a),r&&(l=s,(d=i.writer).setCustomProperty("table",!0,l),c=Bu(l,d,{hasSelectionHandle:!0}));const u=new Mm(o),h={headingRows:o.getAttribute("headingRows")||0,headingColumns:o.getAttribute("headingColumns")||0},f=new Map;for(const e of u){const{row:n,cell:r}=e,s=o.getChild(n),c=f.get(n)||Lm(a,s,n,h,i);f.set(n,c),i.consumable.consume(r,"insert");Dm(e,h,i.writer.createPositionAt(c,"end"),i,t)}for(const t of o.getChildren()){const e=t.index;f.has(e)||f.set(e,Lm(a,t,e,h,i))}const g=i.mapper.toViewPosition(n.range.start);i.mapper.bindElements(o,r?c:s),i.writer.insert(g,r?c:s)})}function Om(t,e,n){const i=n.writer,o=n.mapper.toViewElement(t);if(!o)return;const r=Hu(i.createEditableElement(e,o.getAttributes()),i);Fu(r,i,(t,e,n)=>n.addClass(Hm(e.classes),t),(t,e,n)=>n.removeClass(Hm(e.classes),t)),i.insert(i.createPositionAfter(o),r),i.move(i.createRangeIn(o),i.createPositionAt(r,0)),i.remove(i.createRangeOn(o)),n.mapper.unbindViewElement(o),n.mapper.bindElements(t,r)}function Rm(t,e,n){const{cell:i}=t,o=jm(t,e),r=n.mapper.toViewElement(i);r&&r.name!==o&&Om(i,o,n)}function Dm(t,e,n,i,o){const r=o&&o.asWidget,s=jm(t,e),a=r?Hu(i.writer.createEditableElement(s),i.writer):i.writer.createContainerElement(s);r&&Fu(a,i.writer,(t,e,n)=>n.addClass(Hm(e.classes),t),(t,e,n)=>n.removeClass(Hm(e.classes),t));const c=t.cell,l=c.getChild(0),d=1===c.childCount&&"paragraph"===l.name;if(i.writer.insert(n,a),d&&![...l.getAttributeKeys()].length){const t=c.getChild(0),e=i.writer.createPositionAt(a,"end");if(i.consumable.consume(t,"insert"),r){const n=i.writer.createContainerElement("span",{style:"display:inline-block"});i.mapper.bindElements(t,n),i.writer.insert(e,n),i.mapper.bindElements(c,a)}else i.mapper.bindElements(c,a),i.mapper.bindElements(t,a)}else i.mapper.bindElements(c,a)}function Lm(t,e,n,i,o){o.consumable.consume(e,"insert");const r=e.isEmpty?o.writer.createEmptyElement("tr"):o.writer.createContainerElement("tr");o.mapper.bindElements(e,r);const s=i.headingRows,a=Vm(function(t,e){return t<e.headingRows?"thead":"tbody"}(n,i),t,o),c=s>0&&n>=s?n-s:n,l=o.writer.createPositionAt(a,c);return o.writer.insert(l,r),r}function jm(t,e){const{row:n,column:i}=t,{headingColumns:o,headingRows:r}=e;if(r&&r>n)return"th";return o&&o>i?"th":"td"}function Vm(t,e,n){const i=zm(t,e);return i||function(t,e,n){const i=n.writer.createContainerElement(t),o=n.writer.createPositionAt(e,"tbody"==t?"end":0);return n.writer.insert(o,i),i}(t,e,n)}function zm(t,e){for(const n of e.getChildren())if(n.name==t)return n}function Bm(t,e,n){const i=zm(t,e);i&&0===i.childCount&&n.writer.remove(n.writer.createRangeOn(i))}function Fm(t,e,n,i){for(const o of t){const t=n.mapper.toViewElement(o);t&&n.writer.move(n.writer.createRangeOn(t),n.writer.createPositionAt(e,i))}}function Um(t){for(const e of t.getChildren())if("table"===e.name)return e}function Hm(t){return Array.isArray(t)?t:[t]}class Wm extends od{refresh(){const t=this.editor.model,e=t.document.selection,n=t.schema,i=function(t){const e=t.parent;return e===e.root?e:e.parent}(e.getFirstPosition());this.isEnabled=n.checkChild(i,"table")}execute(t={}){const e=this.editor.model,n=e.document.selection,i=this.editor.plugins.get("TableUtils"),o=parseInt(t.rows)||2,r=parseInt(t.columns)||2,s=Wu(n,e);e.change(t=>{const n=i.createTable(t,o,r);e.insertContent(n,s),t.setSelection(t.createPositionAt(n.getNodeByPath([0,0,0]),0))})}}function qm(t){const e=[];for(const i of(n=t.getRanges(),Array.from(n).sort(Zm))){const t=i.getContainedElement();t&&t.is("tableCell")&&e.push(t)}var n;return e}function Ym(t){const e=[];for(const n of t.getRanges()){const t=xm("tableCell",n.start);t&&e.push(t)}return e}function Gm(t){const e=qm(t);return e.length?e:Ym(t)}function $m(t){return Jm(t.map(t=>t.parent.index))}function Km(t){const e=xm("table",t[0]);return Jm([...new Mm(e)].filter(e=>t.includes(e.cell)).map(t=>t.column))}function Qm(t,e){if(t.length<2||!function(t){const e=xm("table",t[0]),n=$m(t),i=parseInt(e.getAttribute("headingRows")||0);if(!Xm(n,i))return!1;const o=parseInt(e.getAttribute("headingColumns")||0);return Xm(Km(t),o)}(t))return!1;const n=new Set,i=new Set;let o=0;for(const r of t){const{row:t,column:s}=e.getCellLocation(r),a=parseInt(r.getAttribute("rowspan")||1),c=parseInt(r.getAttribute("colspan")||1);n.add(t),i.add(s),a>1&&n.add(t+a-1),c>1&&i.add(s+c-1),o+=a*c}return function(t,e){const n=Array.from(t.values()),i=Array.from(e.values()),o=Math.max(...n),r=Math.min(...n),s=Math.max(...i),a=Math.min(...i);return(o-r+1)*(s-a+1)}(n,i)==o}function Jm(t){const e=t.sort((t,e)=>t-e);return{first:e[0],last:e[e.length-1]}}function Zm(t,e){const n=t.start,i=e.start;return n.isBefore(i)?-1:1}function Xm({first:t,last:e},n){return t<n===e<n}class tp extends od{constructor(t,e={}){super(t),this.order=e.order||"below"}refresh(){const t=xm("table",this.editor.model.document.selection.getFirstPosition());this.isEnabled=!!t}execute(){const t=this.editor,e=t.model.document.selection,n=t.plugins.get("TableUtils"),i="above"===this.order,o=Gm(e),r=$m(o),s=i?r.first:r.last,a=xm("table",o[0]);n.insertRows(a,{at:i?s:s+1,copyStructureFromAbove:!i})}}class ep extends od{constructor(t,e={}){super(t),this.order=e.order||"right"}refresh(){const t=xm("table",this.editor.model.document.selection.getFirstPosition());this.isEnabled=!!t}execute(){const t=this.editor,e=t.model.document.selection,n=t.plugins.get("TableUtils"),i="left"===this.order,o=Gm(e),r=Km(o),s=i?r.first:r.last,a=xm("table",o[0]);n.insertColumns(a,{columns:1,at:i?s:s+1})}}class np extends od{constructor(t,e={}){super(t),this.direction=e.direction||"horizontally"}refresh(){const t=Gm(this.editor.model.document.selection);this.isEnabled=1===t.length}execute(){const t=Gm(this.editor.model.document.selection)[0],e="horizontally"===this.direction,n=this.editor.plugins.get("TableUtils");e?n.splitCellHorizontally(t,2):n.splitCellVertically(t,2)}}function ip(t,e,n){const{startRow:i,startColumn:o,endRow:r,endColumn:s}=e,a=n.createElement("table"),c=r-i+1;for(let t=0;t<c;t++)n.insertElement("tableRow",a,"end");const l=[...new Mm(t,{startRow:i,endRow:r,startColumn:o,endColumn:s,includeAllSlots:!0})];for(const{row:t,column:e,cell:c,isAnchor:d,cellAnchorRow:u,cellAnchorColumn:h}of l){const l=t-i,f=a.getChild(l);if(d){const i=n.cloneElement(c);n.append(i,f),cp(i,t,e,r,s,n)}else(u<i||h<o)&&Cm(n,n.createPositionAt(f,"end"))}return function(t,e,n,i,o){const r=parseInt(e.getAttribute("headingRows")||0);if(r>0){Am("headingRows",r-n,t,o,0)}const s=parseInt(e.getAttribute("headingColumns")||0);if(s>0){Am("headingColumns",s-i,t,o,0)}}(a,t,i,o,n),a}function op(t,e,n=0){const i=[],o=new Mm(t,{startRow:n,endRow:e-1});for(const t of o){const{row:n,cellHeight:o}=t,r=n+o-1;n<e&&e<=r&&i.push(t)}return i}function rp(t,e,n){const i=t.parent,o=i.parent,r=i.index,s=e-r,a={},c=parseInt(t.getAttribute("rowspan"))-s;c>1&&(a.rowspan=c);const l=parseInt(t.getAttribute("colspan")||1);l>1&&(a.colspan=l);const d=r+s,u=[...new Mm(o,{startRow:r,endRow:d,includeAllSlots:!0})];let h;for(const e of u){const{row:i,column:o,cell:r}=e;r===t&&void 0===h&&(h=o),void 0!==h&&h===o&&i===d&&Cm(n,e.getPositionBefore(),a)}Am("rowspan",s,t,n)}function sp(t,e){const n=[],i=new Mm(t);for(const t of i){const{column:i,cellWidth:o}=t,r=i+o-1;i<e&&e<=r&&n.push(t)}return n}function ap(t,e,n,i){const o=n-e,r={},s=parseInt(t.getAttribute("colspan"))-o;s>1&&(r.colspan=s);const a=parseInt(t.getAttribute("rowspan")||1);a>1&&(r.rowspan=a),Cm(i,i.createPositionAfter(t),r),Am("colspan",o,t,i)}function cp(t,e,n,i,o,r){const s=parseInt(t.getAttribute("colspan")||1),a=parseInt(t.getAttribute("rowspan")||1);if(n+s-1>o){Am("colspan",o-n+1,t,r,1)}if(e+a-1>i){Am("rowspan",i-e+1,t,r,1)}}function lp(t,e){const n=e.getColumns(t),i=new Array(n).fill(0);for(const{column:e}of new Mm(t))i[e]++;const o=i.reduce((t,e,n)=>e?t:[...t,n],[]);return o.reverse().forEach(n=>{e.removeColumns(t,{at:n})}),o.length>0}function dp(t,e,n){const i=[];for(let e=0;e<t.childCount;e++){t.getChild(e).isEmpty&&i.push(e)}return i.reverse().forEach(i=>{e.removeRows(t,{at:i,batch:n})}),i.length>0}function up(t,e,n){lp(t,e)||dp(t,e,n)}function hp(t,e){const n=Array.from(new Mm(t,{startColumn:e.firstColumn,endColumn:e.lastColumn,row:e.lastRow}));if(n.every(({cellHeight:t})=>1===t))return e.lastRow;const i=n[0].cellHeight-1;return e.lastRow+i}function fp(t,e){const n=Array.from(new Mm(t,{startRow:e.firstRow,endRow:e.lastRow,column:e.lastColumn}));if(n.every(({cellWidth:t})=>1===t))return e.lastColumn;const i=n[0].cellWidth-1;return e.lastColumn+i}class gp extends od{constructor(t,e){super(t),this.direction=e.direction,this.isHorizontal="right"==this.direction||"left"==this.direction}refresh(){const t=this._getMergeableCell();this.value=t,this.isEnabled=!!t}execute(){const t=this.editor.model,e=Ym(t.document.selection)[0],n=this.value,i=this.direction;t.change(t=>{const o="right"==i||"down"==i,r=o?e:n,s=o?n:e,a=s.parent;!function(t,e,n){mp(t)||(mp(e)&&n.remove(n.createRangeIn(e)),n.move(n.createRangeIn(t),n.createPositionAt(e,"end")));n.remove(t)}(s,r,t);const c=this.isHorizontal?"colspan":"rowspan",l=parseInt(e.getAttribute(c)||1),d=parseInt(n.getAttribute(c)||1);t.setAttribute(c,l+d,r),t.setSelection(t.createRangeIn(r));const u=this.editor.plugins.get("TableUtils");up(xm("table",a),u,t.batch)})}_getMergeableCell(){const t=Ym(this.editor.model.document.selection)[0];if(!t)return;const e=this.editor.plugins.get("TableUtils"),n=this.isHorizontal?function(t,e,n){const i=t.parent.parent,o="right"==e?t.nextSibling:t.previousSibling,r=(i.getAttribute("headingColumns")||0)>0;if(!o)return;const s="right"==e?t:o,a="right"==e?o:t,{column:c}=n.getCellLocation(s),{column:l}=n.getCellLocation(a),d=parseInt(s.getAttribute("colspan")||1),u=Tm(n,s),h=Tm(n,a);if(r&&u!=h)return;return c+d===l?o:void 0}(t,this.direction,e):function(t,e){const n=t.parent,i=n.parent,o=i.getChildIndex(n);if("down"==e&&o===i.childCount-1||"up"==e&&0===o)return;const r=parseInt(t.getAttribute("rowspan")||1),s=i.getAttribute("headingRows")||0,a="down"==e&&o+r===s,c="up"==e&&o===s;if(s&&(a||c))return;const l=parseInt(t.getAttribute("rowspan")||1),d="down"==e?o+l:o,u=[...new Mm(i,{endRow:d})],h=u.find(e=>e.cell===t).column,f=u.find(({row:t,cellHeight:n,column:i})=>i===h&&("down"==e?t===d:d===t+n));return f&&f.cell}(t,this.direction);if(!n)return;const i=this.isHorizontal?"rowspan":"colspan",o=parseInt(t.getAttribute(i)||1);return parseInt(n.getAttribute(i)||1)===o?n:void 0}}function mp(t){return 1==t.childCount&&t.getChild(0).is("paragraph")&&t.getChild(0).isEmpty}class pp extends od{refresh(){const t=Gm(this.editor.model.document.selection),e=t[0];if(e){const n=xm("table",e),i=this.editor.plugins.get("TableUtils").getRows(n)-1,o=$m(t),r=0===o.first&&o.last===i;this.isEnabled=!r}else this.isEnabled=!1}execute(){const t=this.editor.model,e=Gm(t.document.selection),n=$m(e),i=e[0],o=xm("table",i),r=this.editor.plugins.get("TableUtils").getCellLocation(i).column,s=t.createBatch();t.enqueueChange(s,t=>{t.setSelection(t.createSelection(o,"on"));const e=n.last-n.first+1;this.editor.plugins.get("TableUtils").removeRows(o,{at:n.first,rows:e,batch:s})}),t.enqueueChange(s,t=>{const e=function(t,e,n){const i=t.getChild(e)||t.getChild(t.childCount-1);let o=i.getChild(0),r=0;for(const t of i.getChildren()){if(r>n)return o;o=t,r+=parseInt(t.getAttribute("colspan")||1)}return o}(o,n.first,r);t.setSelection(t.createPositionAt(e,0))})}}class bp extends od{refresh(){const t=Gm(this.editor.model.document.selection),e=t[0];if(e){const n=xm("table",e),i=this.editor.plugins.get("TableUtils").getColumns(n),{first:o,last:r}=Km(t);this.isEnabled=r-o<i-1}else this.isEnabled=!1}execute(){const[t,e]=function(t){const e=Gm(t),n=e[0],i=e.pop(),o=[n,i];return n.isBefore(i)?o:o.reverse()}(this.editor.model.document.selection),n=t.parent.parent,i=[...new Mm(n)],o={first:i.find(e=>e.cell===t).column,last:i.find(t=>t.cell===e).column},r=function(t,e,n,i){return parseInt(n.getAttribute("colspan")||1)>1?n:e.previousSibling||n.nextSibling?n.nextSibling||e.previousSibling:i.first?t.reverse().find(({column:t})=>t<i.first).cell:t.reverse().find(({column:t})=>t>i.last).cell}(i,t,e,o);this.editor.model.change(t=>{const e=o.last-o.first+1;this.editor.plugins.get("TableUtils").removeColumns(n,{at:o.first,columns:e}),t.setSelection(t.createPositionAt(r,0))})}}class wp extends od{refresh(){const t=Gm(this.editor.model.document.selection),e=t.length>0;this.isEnabled=e,this.value=e&&t.every(t=>this._isInHeading(t,t.parent.parent))}execute(t={}){if(t.forceValue===this.value)return;const e=this.editor.model,n=Gm(e.document.selection),i=xm("table",n[0]),{first:o,last:r}=$m(n),s=this.value?o:r+1,a=i.getAttribute("headingRows")||0;e.change(t=>{if(s){const e=op(i,s,s>a?a:0);for(const{cell:n}of e)rp(n,s,t)}Am("headingRows",s,i,t,0)})}_isInHeading(t,e){const n=parseInt(e.getAttribute("headingRows")||0);return!!n&&t.parent.index<n}}class kp extends od{refresh(){const t=Gm(this.editor.model.document.selection),e=this.editor.plugins.get("TableUtils"),n=t.length>0;this.isEnabled=n,this.value=n&&t.every(t=>Tm(e,t))}execute(t={}){if(t.forceValue===this.value)return;const e=this.editor.model,n=Gm(e.document.selection),i=xm("table",n[0]),{first:o,last:r}=Km(n),s=this.value?o:r+1;e.change(t=>{if(s){const e=sp(i,s);for(const{cell:n,column:i}of e)ap(n,i,s,t)}Am("headingColumns",s,i,t,0)})}}class _p extends Zl{static get pluginName(){return"TableUtils"}getCellLocation(t){const e=t.parent,n=e.parent,i=n.getChildIndex(e),o=new Mm(n,{row:i});for(const{cell:e,row:n,column:i}of o)if(e===t)return{row:n,column:i}}createTable(t,e,n){const i=t.createElement("table");return vp(t,i,0,e,n),i}insertRows(t,e={}){const n=this.editor.model,i=e.at||0,o=e.rows||1,r=void 0!==e.copyStructureFromAbove,s=e.copyStructureFromAbove?i-1:i,a=this.getRows(t),c=this.getColumns(t);n.change(e=>{const n=t.getAttribute("headingRows")||0;if(n>i&&e.setAttribute("headingRows",n+o,t),!r&&(0===i||i===a))return void vp(e,t,i,o,c);const l=r?Math.max(i,s):i,d=new Mm(t,{endRow:l}),u=new Array(c).fill(1);for(const{row:t,column:n,cellHeight:a,cellWidth:c,cell:l}of d){const d=t+a-1,h=t<=s&&s<=d;t<i&&i<=d?(e.setAttribute("rowspan",a+o,l),u[n]=-c):r&&h&&(u[n]=c)}for(let n=0;n<o;n++){const n=e.createElement("tableRow");e.insert(n,t,i);for(let t=0;t<u.length;t++){const i=u[t],o=e.createPositionAt(n,"end");i>0&&Cm(e,o,i>1?{colspan:i}:null),t+=Math.abs(i)-1}}})}insertColumns(t,e={}){const n=this.editor.model,i=e.at||0,o=e.columns||1;n.change(e=>{const n=t.getAttribute("headingColumns");i<n&&e.setAttribute("headingColumns",n+o,t);const r=this.getColumns(t);if(0===i||r===i){for(const n of t.getChildren())yp(o,e,e.createPositionAt(n,i?"end":0));return}const s=new Mm(t,{column:i,includeAllSlots:!0});for(const t of s){const{row:n,cell:r,cellAnchorColumn:a,cellAnchorRow:c,cellWidth:l,cellHeight:d}=t;if(a<i){e.setAttribute("colspan",l+o,r);const t=c+d-1;for(let e=n;e<=t;e++)s.skipRow(e)}else yp(o,e,t.getPositionBefore())}})}removeRows(t,e){const n=this.editor.model,i=e.rows||1,o=e.at,r=o+i-1,s=e.batch||"default";n.enqueueChange(s,e=>{const{cellsToMove:i,cellsToTrim:a}=function(t,e,n){const i=new Map,o=[];for(const{row:r,column:s,cellHeight:a,cell:c}of new Mm(t,{endRow:n})){const t=r+a-1;if(r>=e&&r<=n&&t>n){const t=a-(n-r+1);i.set(s,{cell:c,rowspan:t})}if(r<e&&t>=e){let i;i=t>=n?n-e+1:t-e+1,o.push({cell:c,rowspan:a-i})}}return{cellsToMove:i,cellsToTrim:o}}(t,o,r);if(i.size){!function(t,e,n,i){const o=[...new Mm(t,{includeAllSlots:!0,row:e})],r=t.getChild(e);let s;for(const{column:t,cell:e,isAnchor:a}of o)if(n.has(t)){const{cell:e,rowspan:o}=n.get(t),a=s?i.createPositionAfter(s):i.createPositionAt(r,0);i.move(i.createRangeOn(e),a),Am("rowspan",o,e,i),s=e}else a&&(s=e)}(t,r+1,i,e)}for(let n=r;n>=o;n--)e.remove(t.getChild(n));for(const{rowspan:t,cell:n}of a)Am("rowspan",t,n,e);lp(t,this),function(t,e,n,i,o){i.enqueueChange(o,i=>{const o=t.getAttribute("headingRows")||0;if(e<o){Am("headingRows",n<o?o-(n-e+1):e,t,i,0)}})}(t,o,r,n,s)})}removeColumns(t,e){const n=this.editor.model,i=e.at,o=e.columns||1,r=e.at+o-1;n.change(e=>{!function(t,e,n){const i=t.getAttribute("headingColumns")||0;if(i&&e.first<i){const o=Math.min(i-1,e.last)-e.first+1;n.setAttribute("headingColumns",i-o,t)}}(t,{first:i,last:r},e);for(let n=r;n>=i;n--)for(const{cell:i,column:o,cellWidth:r}of[...new Mm(t)])o<=n&&r>1&&o+r>n?Am("colspan",r-1,i,e):o===n&&e.remove(i);dp(t,this,e.batch)})}splitCellVertically(t,e=2){const n=this.editor.model,i=t.parent.parent,o=parseInt(t.getAttribute("rowspan")||1),r=parseInt(t.getAttribute("colspan")||1);n.change(n=>{if(r>1){const{newCellsSpan:i,updatedSpan:s}=xp(r,e);Am("colspan",s,t,n);const a={};i>1&&(a.colspan=i),o>1&&(a.rowspan=o);yp(r>e?e-1:r-1,n,n.createPositionAfter(t),a)}if(r<e){const s=e-r,a=[...new Mm(i)],{column:c}=a.find(({cell:e})=>e===t),l=a.filter(({cell:e,cellWidth:n,column:i})=>e!==t&&i===c||i<c&&i+n>c);for(const{cell:t,cellWidth:e}of l)n.setAttribute("colspan",e+s,t);const d={};o>1&&(d.rowspan=o),yp(s,n,n.createPositionAfter(t),d);const u=i.getAttribute("headingColumns")||0;u>c&&Am("headingColumns",u+s,i,n)}})}splitCellHorizontally(t,e=2){const n=this.editor.model,i=t.parent,o=i.parent,r=o.getChildIndex(i),s=parseInt(t.getAttribute("rowspan")||1),a=parseInt(t.getAttribute("colspan")||1);n.change(n=>{if(s>1){const i=[...new Mm(o,{startRow:r,endRow:r+s-1,includeAllSlots:!0})],{newCellsSpan:c,updatedSpan:l}=xp(s,e);Am("rowspan",l,t,n);const{column:d}=i.find(({cell:e})=>e===t),u={};c>1&&(u.rowspan=c),a>1&&(u.colspan=a);for(const t of i){const{column:e,row:i}=t,o=e===d,s=(i+r+l)%c==0;i>=r+l&&o&&s&&yp(1,n,t.getPositionBefore(),u)}}if(s<e){const i=e-s,c=[...new Mm(o,{startRow:0,endRow:r})];for(const{cell:e,cellHeight:o,row:s}of c)if(e!==t&&s+o>r){const t=o+i;n.setAttribute("rowspan",t,e)}const l={};a>1&&(l.colspan=a),vp(n,o,r+1,i,1,l);const d=o.getAttribute("headingRows")||0;d>r&&Am("headingRows",d+i,o,n)}})}getColumns(t){return[...t.getChild(0).getChildren()].reduce((t,e)=>t+parseInt(e.getAttribute("colspan")||1),0)}getRows(t){return t.childCount}}function vp(t,e,n,i,o,r={}){for(let s=0;s<i;s++){const i=t.createElement("tableRow");t.insert(i,e,n),yp(o,t,t.createPositionAt(i,"end"),r)}}function yp(t,e,n,i={}){for(let o=0;o<t;o++)Cm(e,n,i)}function xp(t,e){if(t<e)return{newCellsSpan:1,updatedSpan:1};const n=Math.floor(t/e);return{newCellsSpan:n,updatedSpan:t-n*e+n}}class Ap extends od{refresh(){const t=qm(this.editor.model.document.selection);this.isEnabled=Qm(t,this.editor.plugins.get(_p))}execute(){const t=this.editor.model,e=this.editor.plugins.get(_p);t.change(n=>{const i=qm(t.document.selection),o=i.shift();n.setSelection(o,0);const{mergeWidth:r,mergeHeight:s}=function(t,e,n){let i=0,o=0;for(const t of e){const{row:e,column:r}=n.getCellLocation(t);i=Pp(t,r,i,"colspan"),o=Pp(t,e,o,"rowspan")}const{row:r,column:s}=n.getCellLocation(t);return{mergeWidth:i-s,mergeHeight:o-r}}(o,i,e);Am("colspan",r,o,n),Am("rowspan",s,o,n);for(const t of i)Cp(t,o,n);up(xm("table",o),e,n.batch),n.setSelection(o,"in")})}}function Cp(t,e,n){Tp(t)||(Tp(e)&&n.remove(n.createRangeIn(e)),n.move(n.createRangeIn(t),n.createPositionAt(e,"end"))),n.remove(t)}function Tp(t){return 1==t.childCount&&t.getChild(0).is("paragraph")&&t.getChild(0).isEmpty}function Pp(t,e,n,i){const o=parseInt(t.getAttribute(i)||1);return Math.max(n,e+o)}class Sp extends od{refresh(){const t=Gm(this.editor.model.document.selection);this.isEnabled=t.length>0}execute(){const t=this.editor.model,e=Gm(t.document.selection),n=$m(e),i=xm("table",e[0]),o=[];for(let e=n.first;e<=n.last;e++)for(const n of i.getChild(e).getChildren())o.push(t.createRangeOn(n));t.change(t=>{t.setSelection(o)})}}class Ep extends od{refresh(){const t=Gm(this.editor.model.document.selection);this.isEnabled=t.length>0}execute(){const t=this.editor.model,e=Gm(t.document.selection),n=e[0],i=e.pop(),o=xm("table",n),r=this.editor.plugins.get("TableUtils"),s=r.getCellLocation(n),a=r.getCellLocation(i),c=Math.min(s.column,a.column),l=Math.max(s.column,a.column),d=[];for(const e of new Mm(o,{startColumn:c,endColumn:l}))d.push(t.createRangeOn(e.cell));t.change(t=>{t.setSelection(d)})}}function Mp(t){t.document.registerPostFixer(e=>function(t,e){const n=e.document.differ.getChanges();let i=!1;const o=new Set;for(const e of n){let n;"table"==e.name&&"insert"==e.type&&(n=e.position.nodeAfter),"tableRow"!=e.name&&"tableCell"!=e.name||(n=xm("table",e.position)),Op(e)&&(n=xm("table",e.range.start)),n&&!o.has(n)&&(i=Ip(n,t)||i,i=Np(n,t)||i,o.add(n))}return i}(e,t))}function Ip(t,e){let n=!1;const i=function(t){const e=parseInt(t.getAttribute("headingRows")||0),n=t.childCount,i=[];for(const{row:o,cell:r,cellHeight:s}of new Mm(t)){if(s<2)continue;const t=o<e?e:n;if(o+s>t){const e=t-o;i.push({cell:r,rowspan:e})}}return i}(t);if(i.length){n=!0;for(const t of i)Am("rowspan",t.rowspan,t.cell,e,1)}return n}function Np(t,e){let n=!1;const i=function(t){const e=new Array(t.childCount).fill(0);for(const{row:n}of new Mm(t,{includeAllSlots:!0}))e[n]++;return e}(t),o=[];for(const[t,e]of i.entries())e||o.push(t);if(o.length){n=!0;for(const n of o.reverse())e.remove(t.getChild(n)),i.splice(n,1)}const r=i[0];if(!i.every(t=>t===r)){const o=i.reduce((t,e)=>e>t?e:t,0);for(const[r,s]of i.entries()){const i=o-s;if(i){for(let n=0;n<i;n++)Cm(e,e.createPositionAt(t.getChild(r),"end"));n=!0}}}return n}function Op(t){const e="attribute"===t.type,n=t.attributeKey;return e&&("headingRows"===n||"colspan"===n||"rowspan"===n)}function Rp(t){t.document.registerPostFixer(e=>function(t,e){const n=e.document.differ.getChanges();let i=!1;for(const e of n)"insert"==e.type&&"table"==e.name&&(i=Dp(e.position.nodeAfter,t)||i),"insert"==e.type&&"tableRow"==e.name&&(i=Lp(e.position.nodeAfter,t)||i),"insert"==e.type&&"tableCell"==e.name&&(i=jp(e.position.nodeAfter,t)||i),Vp(e)&&(i=jp(e.position.parent,t)||i);return i}(e,t))}function Dp(t,e){let n=!1;for(const i of t.getChildren())n=Lp(i,e)||n;return n}function Lp(t,e){let n=!1;for(const i of t.getChildren())n=jp(i,e)||n;return n}function jp(t,e){if(0==t.childCount)return e.insertElement("paragraph",t),!0;const n=Array.from(t.getChildren()).filter(t=>t.is("text"));for(const t of n)e.wrap(e.createRangeOn(t),"paragraph");return!!n.length}function Vp(t){return!(!t.position||!t.position.parent.is("tableCell"))&&("insert"==t.type&&"$text"==t.name||"remove"==t.type)}function zp(t){t.document.registerPostFixer(()=>function(t){const e=t.document.differ,n=new Set;let i=0;for(const t of e.getChanges()){const e="insert"==t.type||"remove"==t.type?t.position.parent:t.range.start.parent;e.is("tableCell")&&("insert"==t.type&&i++,Bp(e,t.type,i)&&n.add(e))}if(n.size){for(const t of n.values())e.refreshItem(t);return!0}return!1}(t))}function Bp(t,e,n){if(!Array.from(t.getChildren()).some(t=>t.is("paragraph")))return!1;if("attribute"==e){const e=Array.from(t.getChild(0).getAttributeKeys()).length;return 1===t.childCount&&e<2}return t.childCount<=("insert"==e?n+1:1)}n(86);class Fp extends Zl{static get pluginName(){return"TableEditing"}init(){const t=this.editor,e=t.model,n=e.schema,i=t.conversion;n.register("table",{allowWhere:"$block",allowAttributes:["headingRows","headingColumns"],isLimit:!0,isObject:!0,isBlock:!0}),n.register("tableRow",{allowIn:"table",isLimit:!0}),n.register("tableCell",{allowIn:"tableRow",allowAttributes:["colspan","rowspan"],isObject:!0}),n.extend("$block",{allowIn:"tableCell"}),n.addChildCheck((t,e)=>{if("table"==e.name&&Array.from(t.getNames()).includes("table"))return!1}),i.for("upcast").add(Pm()),i.for("editingDowncast").add(Nm({asWidget:!0})),i.for("dataDowncast").add(Nm()),i.for("upcast").elementToElement({model:"tableRow",view:"tr"}),i.for("upcast").add(t=>{t.on("element:tr",(t,e)=>{e.viewItem.isEmpty&&0==e.modelCursor.index&&t.stop()},{priority:"high"})}),i.for("editingDowncast").add(t=>t.on("insert:tableRow",(t,e,n)=>{const i=e.item;if(!n.consumable.consume(i,"insert"))return;const o=i.parent,r=Um(n.mapper.toViewElement(o)),s=o.getChildIndex(i),a=new Mm(o,{row:s}),c={headingRows:o.getAttribute("headingRows")||0,headingColumns:o.getAttribute("headingColumns")||0},l=new Map;for(const t of a){const e=l.get(s)||Lm(r,i,s,c,n);l.set(s,e),n.consumable.consume(t.cell,"insert"),Dm(t,c,n.writer.createPositionAt(e,"end"),n,{asWidget:!0})}})),i.for("editingDowncast").add(t=>t.on("remove:tableRow",(t,e,n)=>{t.stop();const i=n.writer,o=n.mapper,r=o.toViewPosition(e.position).getLastMatchingPosition(t=>!t.item.is("tr")).nodeAfter,s=r.parent.parent,a=i.createRangeOn(r),c=i.remove(a);for(const t of i.createRangeIn(c).getItems())o.unbindViewElement(t);Bm("thead",s,n),Bm("tbody",s,n)},{priority:"higher"})),i.for("upcast").add(Sm("td")),i.for("upcast").add(Sm("th")),i.for("editingDowncast").add(t=>t.on("insert:tableCell",(t,e,n)=>{const i=e.item;if(!n.consumable.consume(i,"insert"))return;const o=i.parent,r=o.parent,s=r.getChildIndex(o),a=new Mm(r,{row:s}),c={headingRows:r.getAttribute("headingRows")||0,headingColumns:r.getAttribute("headingColumns")||0};for(const t of a)if(t.cell===i){const e=n.mapper.toViewElement(o);return void Dm(t,c,n.writer.createPositionAt(e,o.getChildIndex(i)),n,{asWidget:!0})}})),i.attributeToAttribute({model:"colspan",view:"colspan"}),i.attributeToAttribute({model:"rowspan",view:"rowspan"}),i.for("editingDowncast").add(t=>t.on("attribute:headingColumns:table",(t,e,n)=>{const i=e.item;if(!n.consumable.consume(e.item,t.name))return;const o={headingRows:i.getAttribute("headingRows")||0,headingColumns:i.getAttribute("headingColumns")||0},r=e.attributeOldValue,s=e.attributeNewValue,a=(r>s?r:s)-1;for(const t of new Mm(i,{endColumn:a}))Rm(t,o,n)})),i.for("editingDowncast").add(t=>t.on("attribute:headingRows:table",(t,e,n)=>{const i=e.item;if(!n.consumable.consume(e.item,t.name))return;const o=Um(n.mapper.toViewElement(i)),r=e.attributeOldValue,s=e.attributeNewValue;if(s>r){const t=Array.from(i.getChildren()).filter(({index:t})=>a(t,r-1,s));Fm(t,Vm("thead",o,n),n,"end");for(const e of t)for(const t of e.getChildren())Om(t,"th",n)}else{Fm(Array.from(i.getChildren()).filter(({index:t})=>a(t,s-1,r)).reverse(),Vm("tbody",o,n),n,0);const t=new Mm(i,{startRow:s?s-1:s,endRow:r-1}),e={headingRows:i.getAttribute("headingRows")||0,headingColumns:i.getAttribute("headingColumns")||0};for(const i of t)Rm(i,e,n)}function a(t,e,n){return t>e&&t<n}Bm("thead",o,n),Bm("tbody",o,n)})),t.commands.add("insertTable",new Wm(t)),t.commands.add("insertTableRowAbove",new tp(t,{order:"above"})),t.commands.add("insertTableRowBelow",new tp(t,{order:"below"})),t.commands.add("insertTableColumnLeft",new ep(t,{order:"left"})),t.commands.add("insertTableColumnRight",new ep(t,{order:"right"})),t.commands.add("removeTableRow",new pp(t)),t.commands.add("removeTableColumn",new bp(t)),t.commands.add("splitTableCellVertically",new np(t,{direction:"vertically"})),t.commands.add("splitTableCellHorizontally",new np(t,{direction:"horizontally"})),t.commands.add("mergeTableCells",new Ap(t)),t.commands.add("mergeTableCellRight",new gp(t,{direction:"right"})),t.commands.add("mergeTableCellLeft",new gp(t,{direction:"left"})),t.commands.add("mergeTableCellDown",new gp(t,{direction:"down"})),t.commands.add("mergeTableCellUp",new gp(t,{direction:"up"})),t.commands.add("setTableColumnHeader",new kp(t)),t.commands.add("setTableRowHeader",new wp(t)),t.commands.add("selectTableRow",new Sp(t)),t.commands.add("selectTableColumn",new Ep(t)),Mp(e),zp(e),Rp(e)}static get requires(){return[_p]}}n(88);class Up extends hl{constructor(t){super(t);const e=this.bindTemplate;this.set("icon"),this.set("isEnabled",!0),this.set("isOn",!1),this.set("isToggleable",!1),this.set("isVisible",!0),this.set("keystroke"),this.set("label"),this.set("tabindex",-1),this.set("tooltip"),this.set("tooltipPosition","s"),this.set("type","button"),this.set("withText",!1),this.children=this.createCollection(),this.actionView=this._createActionView(),this.arrowView=this._createArrowView(),this.keystrokes=new Sc,this.focusTracker=new jc,this.setTemplate({tag:"div",attributes:{class:["ck","ck-splitbutton",e.if("isVisible","ck-hidden",t=>!t),this.arrowView.bindTemplate.if("isOn","ck-splitbutton_open")]},children:this.children})}render(){super.render(),this.children.add(this.actionView),this.children.add(this.arrowView),this.focusTracker.add(this.actionView.element),this.focusTracker.add(this.arrowView.element),this.keystrokes.listenTo(this.element),this.keystrokes.set("arrowright",(t,e)=>{this.focusTracker.focusedElement===this.actionView.element&&(this.arrowView.focus(),e())}),this.keystrokes.set("arrowleft",(t,e)=>{this.focusTracker.focusedElement===this.arrowView.element&&(this.actionView.focus(),e())})}focus(){this.actionView.focus()}_createActionView(){const t=new Ll;return t.bind("icon","isEnabled","isOn","isToggleable","keystroke","label","tabindex","tooltip","tooltipPosition","type","withText").to(this),t.extendTemplate({attributes:{class:"ck-splitbutton__action"}}),t.delegate("execute").to(this),t}_createArrowView(){const t=new Ll,e=t.bindTemplate;return t.icon=jl,t.extendTemplate({attributes:{class:"ck-splitbutton__arrow","aria-haspopup":!0,"aria-expanded":e.to("isOn",t=>String(t))}}),t.bind("isEnabled").to(this),t.delegate("execute").to(this,"open"),t}}n(90);class Hp extends hl{constructor(t){super(t);const e=this.bindTemplate;this.items=this._createGridCollection(),this.set("rows",0),this.set("columns",0),this.bind("label").to(this,"columns",this,"rows",(t,e)=>`${e} × ${t}`),this.setTemplate({tag:"div",attributes:{class:["ck"]},children:[{tag:"div",attributes:{class:["ck-insert-table-dropdown__grid"]},on:{"mouseover@.ck-insert-table-dropdown-grid-box":e.to("boxover")},children:this.items},{tag:"div",attributes:{class:["ck-insert-table-dropdown__label"]},children:[{text:e.to("label")}]}],on:{mousedown:e.to(t=>{t.preventDefault()}),click:e.to(()=>{this.fire("execute")})}}),this.on("boxover",(t,e)=>{const{row:n,column:i}=e.target.dataset;this.set({rows:parseInt(n),columns:parseInt(i)})}),this.on("change:columns",()=>{this._highlightGridBoxes()}),this.on("change:rows",()=>{this._highlightGridBoxes()})}focus(){}focusLast(){}_highlightGridBoxes(){const t=this.rows,e=this.columns;this.items.map((n,i)=>{const o=Math.floor(i/10)<t&&i%10<e;n.set("isOn",o)})}_createGridCollection(){const t=[];for(let e=0;e<100;e++){const n=Math.floor(e/10),i=e%10;t.push(new Wp(this.locale,n+1,i+1))}return this.createCollection(t)}}class Wp extends hl{constructor(t,e,n){super(t);const i=this.bindTemplate;this.set("isOn",!1),this.setTemplate({tag:"div",attributes:{class:["ck-insert-table-dropdown-grid-box",i.if("isOn","ck-on")],"data-row":e,"data-column":n}})}}class qp extends Zl{init(){const t=this.editor,e=this.editor.t,n="ltr"===t.locale.contentLanguageDirection;t.ui.componentFactory.add("insertTable",n=>{const i=t.commands.get("insertTable"),o=Wl(n);let r;return o.bind("isEnabled").to(i),o.buttonView.set({icon:'<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 6v3h4V6H3zm0 4v3h4v-3H3zm0 4v3h4v-3H3zm5 3h4v-3H8v3zm5 0h4v-3h-4v3zm4-4v-3h-4v3h4zm0-4V6h-4v3h4zm1.5 8a1.5 1.5 0 0 1-1.5 1.5H3A1.5 1.5 0 0 1 1.5 17V4c.222-.863 1.068-1.5 2-1.5h13c.932 0 1.778.637 2 1.5v13zM12 13v-3H8v3h4zm0-4V6H8v3h4z"/></svg>',label:e("Insert table"),tooltip:!0}),o.on("change:isOpen",()=>{r||(r=new Hp(n),o.panelView.children.add(r),r.delegate("execute").to(o),o.buttonView.on("open",()=>{r.rows=0,r.columns=0}),o.on("execute",()=>{t.execute("insertTable",{rows:r.rows,columns:r.columns}),t.editing.view.focus()}))}),o}),t.ui.componentFactory.add("tableColumn",t=>{const i=[{type:"switchbutton",model:{commandName:"setTableColumnHeader",label:e("Header column"),bindIsOn:!0}},{type:"separator"},{type:"button",model:{commandName:n?"insertTableColumnLeft":"insertTableColumnRight",label:e("Insert column left")}},{type:"button",model:{commandName:n?"insertTableColumnRight":"insertTableColumnLeft",label:e("Insert column right")}},{type:"button",model:{commandName:"removeTableColumn",label:e("Delete column")}},{type:"button",model:{commandName:"selectTableColumn",label:e("Select column")}}];return this._prepareDropdown(e("Column"),'<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1zM2 2v16h16V2H2z" opacity=".6"/><path d="M18 7v1H2V7h16zm0 5v1H2v-1h16z" opacity=".6"/><path d="M14 1v18a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1zm-2 1H8v4h4V2zm0 6H8v4h4V8zm0 6H8v4h4v-4z"/></svg>',i,t)}),t.ui.componentFactory.add("tableRow",t=>{const n=[{type:"switchbutton",model:{commandName:"setTableRowHeader",label:e("Header row"),bindIsOn:!0}},{type:"separator"},{type:"button",model:{commandName:"insertTableRowAbove",label:e("Insert row above")}},{type:"button",model:{commandName:"insertTableRowBelow",label:e("Insert row below")}},{type:"button",model:{commandName:"removeTableRow",label:e("Delete row")}},{type:"button",model:{commandName:"selectTableRow",label:e("Select row")}}];return this._prepareDropdown(e("Row"),'<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1zM2 2v16h16V2H2z" opacity=".6"/><path d="M7 2h1v16H7V2zm5 0h1v16h-1V2z" opacity=".6"/><path d="M1 6h18a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1zm1 2v4h4V8H2zm6 0v4h4V8H8zm6 0v4h4V8h-4z"/></svg>',n,t)}),t.ui.componentFactory.add("mergeTableCells",t=>{const i=[{type:"button",model:{commandName:"mergeTableCellUp",label:e("Merge cell up")}},{type:"button",model:{commandName:n?"mergeTableCellRight":"mergeTableCellLeft",label:e("Merge cell right")}},{type:"button",model:{commandName:"mergeTableCellDown",label:e("Merge cell down")}},{type:"button",model:{commandName:n?"mergeTableCellLeft":"mergeTableCellRight",label:e("Merge cell left")}},{type:"separator"},{type:"button",model:{commandName:"splitTableCellVertically",label:e("Split cell vertically")}},{type:"button",model:{commandName:"splitTableCellHorizontally",label:e("Split cell horizontally")}}];return this._prepareMergeSplitButtonDropdown(e("Merge cells"),'<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1zM2 2v16h16V2H2z" opacity=".6"/><path d="M7 2h1v16H7V2zm5 0h1v7h-1V2zm6 5v1H2V7h16zM8 12v1H2v-1h6z" opacity=".6"/><path d="M7 7h12a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1zm1 2v9h10V9H8z"/></svg>',i,t)})}_prepareDropdown(t,e,n,i){const o=this.editor,r=Wl(i),s=this._fillDropdownWithListOptions(r,n);return r.buttonView.set({label:t,icon:e,tooltip:!0}),r.bind("isEnabled").toMany(s,"isEnabled",(...t)=>t.some(t=>t)),this.listenTo(r,"execute",t=>{o.execute(t.source.commandName),o.editing.view.focus()}),r}_prepareMergeSplitButtonDropdown(t,e,n,i){const o=this.editor,r=Wl(i,Up);return this._fillDropdownWithListOptions(r,n),r.buttonView.set({label:t,icon:e,tooltip:!0,isEnabled:!0}),this.listenTo(r.buttonView,"execute",()=>{o.execute("mergeTableCells"),o.editing.view.focus()}),this.listenTo(r,"execute",t=>{o.execute(t.source.commandName),o.editing.view.focus()}),r}_fillDropdownWithListOptions(t,e){const n=this.editor,i=[],o=new An;for(const t of e)Yp(t,n,i,o);return ql(t,o,n.ui.componentFactory),i}}function Yp(t,e,n,i){const o=t.model=new Wf(t.model),{commandName:r,bindIsOn:s}=t.model;if("button"===t.type||"switchbutton"===t.type){const t=e.commands.get(r);n.push(t),o.set({commandName:r}),o.bind("isEnabled").to(t),s&&o.bind("isOn").to(t,"value")}o.set({withText:!0}),i.add(t)}n(92);class Gp extends Zl{static get pluginName(){return"TableSelection"}static get requires(){return[_p]}init(){const t=this.editor.model;this.listenTo(t,"deleteContent",(t,e)=>this._handleDeleteContent(t,e),{priority:"high"}),this._defineSelectionConverter(),this._enablePluginDisabling()}getSelectedTableCells(){const t=qm(this.editor.model.document.selection);return 0==t.length?null:t}getSelectionAsFragment(){const t=this.getSelectedTableCells();return t?this.editor.model.change(e=>{const n=e.createDocumentFragment(),i=this.editor.plugins.get("TableUtils"),{first:o,last:r}=Km(t),{first:s,last:a}=$m(t),c=xm("table",t[0]);let l=a,d=r;if(Qm(t,i)){const t={firstColumn:o,lastColumn:r,firstRow:s,lastRow:a};l=hp(c,t),d=fp(c,t)}const u=ip(c,{startRow:s,startColumn:o,endRow:l,endColumn:d},e);return e.insert(u,n,0),n}):null}setCellSelection(t,e){const n=this._getCellsToSelect(t,e);this.editor.model.change(t=>{t.setSelection(n.cells.map(e=>t.createRangeOn(e)),{backward:n.backward})})}getFocusCell(){const t=[...this.editor.model.document.selection.getRanges()].pop().getContainedElement();return t&&t.is("tableCell")?t:null}getAnchorCell(){const t=wu(this.editor.model.document.selection.getRanges()).getContainedElement();return t&&t.is("tableCell")?t:null}_defineSelectionConverter(){const t=this.editor,e=new Set;t.conversion.for("editingDowncast").add(t=>t.on("selection",(t,n,i)=>{const o=i.writer;!function(t){for(const n of e)t.removeClass("ck-editor__editable_selected",n);e.clear()}(o);const r=this.getSelectedTableCells();if(!r)return;for(const t of r){const n=i.mapper.toViewElement(t);o.addClass("ck-editor__editable_selected",n),e.add(n)}const s=i.mapper.toViewElement(r[r.length-1]);o.setSelection(s,0)},{priority:"lowest"}))}_enablePluginDisabling(){const t=this.editor;this.on("change:isEnabled",()=>{if(!this.isEnabled){const e=this.getSelectedTableCells();if(!e)return;t.model.change(n=>{const i=n.createPositionAt(e[0],0),o=t.model.schema.getNearestSelectionRange(i);n.setSelection(o)})}})}_handleDeleteContent(t,e){const[n,i]=e,o=this.editor.model,r=!i||"backward"==i.direction,s=qm(n);s.length&&(t.stop(),o.change(t=>{const e=s[r?s.length-1:0];o.change(t=>{for(const e of s)o.deleteContent(t.createSelection(e,"in"))});const i=o.schema.getNearestSelectionRange(t.createPositionAt(e,0));n.is("documentSelection")?t.setSelection(i):n.setTo(i)}))}_getCellsToSelect(t,e){const n=this.editor.plugins.get("TableUtils"),i=n.getCellLocation(t),o=n.getCellLocation(e),r=Math.min(i.row,o.row),s=Math.max(i.row,o.row),a=Math.min(i.column,o.column),c=Math.max(i.column,o.column),l=new Array(s-r+1).fill(null).map(()=>[]),d={startRow:r,endRow:s,startColumn:a,endColumn:c};for(const{row:e,cell:n}of new Mm(xm("table",t),d))l[e-r].push(n);const u=o.row<i.row,h=o.column<i.column;return u&&l.reverse(),h&&l.forEach(t=>t.reverse()),{cells:l.flat(),backward:u||h}}}class $p extends Zl{static get pluginName(){return"TableClipboard"}static get requires(){return[Gp,_p]}init(){const t=this.editor,e=t.editing.view.document;this.listenTo(e,"copy",(t,e)=>this._onCopyCut(t,e)),this.listenTo(e,"cut",(t,e)=>this._onCopyCut(t,e)),this.listenTo(t.model,"insertContent",(t,e)=>this._onInsertContent(t,...e),{priority:"high"})}_onCopyCut(t,e){const n=this.editor.plugins.get(Gp);if(!n.getSelectedTableCells())return;if("cut"==t.name&&this.editor.isReadOnly)return;e.preventDefault(),t.stop();const i=this.editor.data,o=this.editor.editing.view.document,r=i.toView(n.getSelectionAsFragment());o.fire("clipboardOutput",{dataTransfer:e.dataTransfer,content:r,method:t.name})}_onInsertContent(t,e,n){if(n&&!n.is("documentSelection"))return;const i=this.editor.model,o=this.editor.plugins.get(_p);let r=function(t,e){if(!t.is("documentFragment")&&!t.is("element"))return null;if(t.is("table"))return t;if(1==t.childCount&&t.getChild(0).is("table"))return t.getChild(0);const n=e.createRangeIn(t);for(const t of n.getItems())if(t.is("table")){const i=e.createRange(n.start,e.createPositionBefore(t));if(e.hasContent(i,{ignoreWhitespaces:!0}))return null;const o=e.createRange(e.createPositionAfter(t),n.end);return e.hasContent(o,{ignoreWhitespaces:!0})?null:t}return null}(e,i);if(!r)return;const s=Gm(i.document.selection);s.length?(t.stop(),i.change(t=>{const e={width:o.getColumns(r),height:o.getRows(r)},n=function(t,e,n,i){const o=xm("table",t[0]),r=Km(t),s=$m(t),a={firstColumn:r.first,lastColumn:r.last,firstRow:s.first,lastRow:s.last},c=1===t.length;c&&(a.lastRow+=e.height-1,a.lastColumn+=e.width-1,function(t,e,n,i,o){const r=o.getColumns(t),s=o.getRows(t);n>r&&o.insertColumns(t,{batch:i.batch,at:r,columns:n-r});e>s&&o.insertRows(t,{batch:i.batch,at:s,rows:e-s})}(o,a.lastRow+1,a.lastColumn+1,n,i));c||!Qm(t,i)?function(t,e,n){const{firstRow:i,lastRow:o,firstColumn:r,lastColumn:s}=e,a={first:i,last:o},c={first:r,last:s};Qp(t,r,a,n),Qp(t,s+1,a,n),Kp(t,i,c,n),Kp(t,o+1,c,n,i)}(o,a,n):(a.lastRow=hp(o,a),a.lastColumn=fp(o,a));return a}(s,e,t,o),i=n.lastRow-n.firstRow+1,a=n.lastColumn-n.firstColumn+1,c={startRow:0,startColumn:0,endRow:Math.min(i,e.height)-1,endColumn:Math.min(a,e.width)-1};r=ip(r,c,t);const l=xm("table",s[0]);!function(t,e,n,i,o){const{width:r,height:s}=e,a=function(t,e,n){const i=new Array(n).fill(null).map(()=>new Array(e).fill(null));for(const{column:e,row:n,cell:o}of new Mm(t))i[n][e]=o;return i}(t,r,s),c=[...new Mm(n,{startRow:i.firstRow,endRow:i.lastRow,startColumn:i.firstColumn,endColumn:i.lastColumn,includeAllSlots:!0})],l=[];let d;for(const t of c){const{row:e,column:n,cell:c,isAnchor:u}=t;n===i.firstColumn&&(d=t.getPositionBefore()),u&&o.remove(c);const h=e-i.firstRow,f=n-i.firstColumn,g=a[h%s][f%r];if(!g)continue;const m=o.cloneElement(g);cp(m,e,n,i.lastRow,i.lastColumn,o),o.insert(m,d),l.push(m),d=o.createPositionAfter(m)}o.setSelection(l.map(t=>o.createRangeOn(t)))}(r,e,l,n,t)})):up(r,o)}}function Kp(t,e,n,i,o=0){if(e<1)return;const r=op(t,e,o).filter(({column:t,cellWidth:e})=>Jp(t,e,n));for(const{cell:t}of r)rp(t,e,i)}function Qp(t,e,n,i){if(e<1)return;const o=sp(t,e).filter(({row:t,cellHeight:e})=>Jp(t,e,n));for(const{cell:t,column:n}of o)ap(t,n,e,i)}function Jp(t,e,n){const i=t+e-1,{first:o,last:r}=n;return t>=o&&t<=r||t<o&&i>=o}class Zp extends Zl{static get pluginName(){return"TableKeyboard"}static get requires(){return[Gp]}init(){const t=this.editor.editing.view.document;this.editor.keystrokes.set("Tab",(...t)=>this._handleTabOnSelectedTable(...t),{priority:"low"}),this.editor.keystrokes.set("Tab",this._getTabHandler(!0),{priority:"low"}),this.editor.keystrokes.set("Shift+Tab",this._getTabHandler(!1),{priority:"low"}),this.listenTo(t,"keydown",(...t)=>this._onKeydown(...t),{priority:un.get("high")-10})}_handleTabOnSelectedTable(t,e){const n=this.editor,i=n.model.document.selection;if(!i.isCollapsed&&1===i.rangeCount&&i.getFirstRange().isFlat){const t=i.getSelectedElement();if(!t||!t.is("table"))return;e(),n.model.change(e=>{e.setSelection(e.createRangeIn(t.getChild(0).getChild(0)))})}}_getTabHandler(t){const e=this.editor;return(n,i)=>{const o=Ym(e.model.document.selection)[0];if(!o)return;i();const r=o.parent,s=r.parent,a=s.getChildIndex(r),c=r.getChildIndex(o),l=0===c;if(!t&&l&&0===a)return;const d=c===r.childCount-1,u=a===s.childCount-1;if(t&&u&&d&&(e.execute("insertTableRowBelow"),a===s.childCount-1))return;let h;if(t&&d){const t=s.getChild(a+1);h=t.getChild(0)}else if(!t&&l){const t=s.getChild(a-1);h=t.getChild(t.childCount-1)}else h=r.getChild(c+(t?1:-1));e.model.change(t=>{t.setSelection(t.createRangeIn(h))})}}_onKeydown(t,e){const n=this.editor,i=e.keyCode;if(!ko(i))return;const o=_o(i,n.locale.contentLanguageDirection);this._handleArrowKeys(o,e.shiftKey)&&(e.preventDefault(),e.stopPropagation(),t.stop())}_handleArrowKeys(t,e){const n=this.editor.model,i=n.document.selection,o=["right","down"].includes(t),r=qm(i);if(r.length){let n;return n=e?this.editor.plugins.get("TableSelection").getFocusCell():o?r[r.length-1]:r[0],this._navigateFromCellInDirection(n,t,e),!0}const s=xm("tableCell",i.focus);if(!s)return!1;const a=n.createRangeIn(s);if(this._isSelectionAtCellEdge(i,o))return this._navigateFromCellInDirection(s,t,e),!0;const c=this._findTextRangeFromSelection(a,i,o);return c?!["left","right"].includes(t)&&(this._isSingleLineRange(c,o)?(n.change(t=>{const r=o?a.end:a.start;if(e){const e=n.createSelection(i.anchor);e.setFocus(r),t.setSelection(e)}else t.setSelection(r)}),!0):void 0):(this._navigateFromCellInDirection(s,t,e),!0)}_isSelectionAtCellEdge(t,e){const n=this.editor.model,i=this.editor.model.schema,o=e?t.getLastPosition():t.getFirstPosition();if(!i.getLimitElement(o).is("tableCell"))return!1;const r=n.createSelection(o);return n.modifySelection(r,{direction:e?"forward":"backward"}),o.isEqual(r.focus)}_findTextRangeFromSelection(t,e,n){const i=this.editor.model;if(n){const n=e.getLastPosition(),o=this._getNearestVisibleTextPosition(t,"backward");return o&&n.isBefore(o)?i.createRange(n,o):null}{const n=e.getFirstPosition(),o=this._getNearestVisibleTextPosition(t,"forward");return o&&n.isAfter(o)?i.createRange(o,n):null}}_getNearestVisibleTextPosition(t,e){const n=this.editor.model.schema,i=this.editor.editing.mapper;for(const{nextPosition:o,item:r}of t.getWalker({direction:e}))if(n.checkChild(o,"$text")){const t=i.toViewElement(r);if(t&&!t.hasClass("ck-hidden"))return o}}_isSingleLineRange(t,e){const n=this.editor.model,i=this.editor.editing,o=i.view.domConverter;if(e){const e=n.createSelection(t.start);n.modifySelection(e),e.focus.isAtEnd||t.start.isEqual(e.focus)||(t=n.createRange(e.focus,t.end))}const r=i.mapper.toViewRange(t),s=o.viewRangeToDom(r),a=es.getDomRangeRects(s);let c;for(const t of a)if(void 0!==c){if(Math.round(t.top)>=c)return!1;c=Math.max(c,Math.round(t.bottom))}else c=Math.round(t.bottom);return!0}_navigateFromCellInDirection(t,e,n=!1){const i=this.editor.model,o=xm("table",t),r=[...new Mm(o,{includeAllSlots:!0})],{row:s,column:a}=r[r.length-1],c=r.find(({cell:e})=>e==t);let{row:l,column:d}=c;switch(e){case"left":d--;break;case"up":l--;break;case"right":d+=c.cellWidth;break;case"down":l+=c.cellHeight}if(l<0||l>s||d<0&&l<=0||d>a&&l>=s)return void i.change(t=>{t.setSelection(t.createRangeOn(o))});d<0?(d=n?0:a,l--):d>a&&(d=n?a:0,l++);const u=r.find(t=>t.row==l&&t.column==d).cell,h=["right","down"].includes(e),f=this.editor.plugins.get("TableSelection");if(n&&f.isEnabled){const e=f.getAnchorCell()||t;f.setCellSelection(e,u)}else{const t=i.createPositionAt(u,h?0:"end");i.change(e=>{e.setSelection(t)})}}}class Xp extends Dr{constructor(t){super(t),this.domEventType=["mousemove","mouseup","mouseleave"]}onDomEvent(t){this.fire(t.type,t)}}class tb extends Zl{static get pluginName(){return"TableMouse"}static get requires(){return[Gp]}init(){this.editor.editing.view.addObserver(Xp),this._enableShiftClickSelection(),this._enableMouseDragSelection()}_enableShiftClickSelection(){const t=this.editor;let e=!1;const n=t.plugins.get(Gp);this.listenTo(t.editing.view.document,"mousedown",(i,o)=>{if(!this.isEnabled||!n.isEnabled)return;if(!o.domEvent.shiftKey)return;const r=n.getAnchorCell()||Ym(t.model.document.selection)[0];if(!r)return;const s=this._getModelTableCellFromDomEvent(o);s&&eb(r,s)&&(e=!0,n.setCellSelection(r,s),o.preventDefault())}),this.listenTo(t.editing.view.document,"mouseup",()=>{e=!1}),this.listenTo(t.editing.view.document,"selectionChange",t=>{e&&t.stop()},{priority:"highest"})}_enableMouseDragSelection(){const t=this.editor;let e,n,i=!1,o=!1;const r=t.plugins.get(Gp);this.listenTo(t.editing.view.document,"mousedown",(t,n)=>{this.isEnabled&&r.isEnabled&&(n.domEvent.shiftKey||n.domEvent.ctrlKey||n.domEvent.altKey||(e=this._getModelTableCellFromDomEvent(n)))}),this.listenTo(t.editing.view.document,"mousemove",(t,s)=>{if(!s.domEvent.buttons)return;if(!e)return;const a=this._getModelTableCellFromDomEvent(s);a&&eb(e,a)&&(n=a,i||n==e||(i=!0)),i&&(o=!0,r.setCellSelection(e,n),s.preventDefault())}),this.listenTo(t.editing.view.document,"mouseup",()=>{i=!1,o=!1,e=null,n=null}),this.listenTo(t.editing.view.document,"selectionChange",t=>{o&&t.stop()},{priority:"highest"})}_getModelTableCellFromDomEvent(t){const e=t.target,n=this.editor.editing.view.createPositionAt(e,0),i=this.editor.editing.mapper.toModelPosition(n).parent;return i.is("tableCell")?i:xm("tableCell",i)}}function eb(t,e){return t.parent.parent==e.parent.parent}n(94);function nb(t){const e=t.getSelectedElement();return e&&ob(e)?e:null}function ib(t){const e=xm("table",t.getFirstPosition());return e&&ob(e.parent)?e.parent:null}function ob(t){return!!t.getCustomProperty("table")&&zu(t)}class rb{constructor(t,e){this.model=t,this.testCallback=e,this.hasMatch=!1,this.set("isEnabled",!0),this.on("change:isEnabled",()=>{this.isEnabled?this._startListening():(this.stopListening(t.document.selection),this.stopListening(t.document))}),this._startListening()}_startListening(){const t=this.model.document;this.listenTo(t.selection,"change:range",(e,{directChange:n})=>{n&&(t.selection.isCollapsed?this._evaluateTextBeforeSelection("selection"):this.hasMatch&&(this.fire("unmatched"),this.hasMatch=!1))}),this.listenTo(t,"change:data",(t,e)=>{"transparent"!=e.type&&this._evaluateTextBeforeSelection("data",{batch:e})})}_evaluateTextBeforeSelection(t,e={}){const n=this.model,i=n.document.selection,o=n.createRange(n.createPositionAt(i.focus.parent,0),i.focus),{text:r,range:s}=function(t,e){let n=t.start;return{text:Array.from(t.getItems()).reduce((t,i)=>i.is("text")||i.is("textProxy")?t+i.data:(n=e.createPositionAfter(i),""),""),range:e.createRange(n,t.end)}}(o,n),a=this.testCallback(r);if(!a&&this.hasMatch&&this.fire("unmatched"),this.hasMatch=!!a,a){const n=Object.assign(e,{text:r,range:s});"object"==typeof a&&Object.assign(n,a),this.fire("matched:"+t,n)}}}xn(rb,Ui);var sb=/[\\^$.*+?()[\]{}|]/g,ab=RegExp(sb.source);var cb=function(t){return(t=Zn(t))&&ab.test(t)?t.replace(sb,"\\$&"):t};const lb={copyright:{from:"(c)",to:"©"},registeredTrademark:{from:"(r)",to:"®"},trademark:{from:"(tm)",to:"™"},oneHalf:{from:"1/2",to:"½"},oneThird:{from:"1/3",to:"⅓"},twoThirds:{from:"2/3",to:"⅔"},oneForth:{from:"1/4",to:"¼"},threeQuarters:{from:"3/4",to:"¾"},lessThanOrEqual:{from:"<=",to:"≤"},greaterThanOrEqual:{from:">=",to:"≥"},notEqual:{from:"!=",to:"≠"},arrowLeft:{from:"<-",to:"←"},arrowRight:{from:"->",to:"→"},horizontalEllipsis:{from:"...",to:"…"},enDash:{from:/(^| )(--)( )$/,to:[null,"–",null]},emDash:{from:/(^| )(---)( )$/,to:[null,"—",null]},quotesPrimary:{from:mb('"'),to:[null,"“",null,"”"]},quotesSecondary:{from:mb("'"),to:[null,"‘",null,"’"]},quotesPrimaryEnGb:{from:mb("'"),to:[null,"‘",null,"’"]},quotesSecondaryEnGb:{from:mb('"'),to:[null,"“",null,"”"]},quotesPrimaryPl:{from:mb('"'),to:[null,"„",null,"”"]},quotesSecondaryPl:{from:mb("'"),to:[null,"‚",null,"’"]}},db={symbols:["copyright","registeredTrademark","trademark"],mathematical:["oneHalf","oneThird","twoThirds","oneForth","threeQuarters","lessThanOrEqual","greaterThanOrEqual","notEqual","arrowLeft","arrowRight"],typography:["horizontalEllipsis","enDash","emDash"],quotes:["quotesPrimary","quotesSecondary"]},ub=["symbols","mathematical","typography","quotes"];function hb(t){return"string"==typeof t?new RegExp(`(${cb(t)})$`):t}function fb(t){return"string"==typeof t?()=>[t]:t instanceof Array?()=>t:t}function gb(t){return(t.textNode?t.textNode:t.nodeAfter).getAttributes()}function mb(t){return new RegExp(`(^|\\s)(${t})([^${t}]*)(${t})$`)}class pb extends Jl{}pb.builtinPlugins=[class extends Zl{static get requires(){return[id,dd,_d,gd,Rd,tu]}static get pluginName(){return"Essentials"}},au,class extends Zl{static get pluginName(){return"Autoformat"}afterInit(){this._addListAutoformats(),this._addBasicStylesAutoformats(),this._addHeadingAutoformats(),this._addBlockQuoteAutoformats(),this._addCodeBlockAutoformats()}_addListAutoformats(){const t=this.editor.commands;t.get("bulletedList")&&lu(this.editor,this,/^[*-]\s$/,"bulletedList"),t.get("numberedList")&&lu(this.editor,this,/^1[.|)]\s$/,"numberedList")}_addBasicStylesAutoformats(){const t=this.editor.commands;if(t.get("bold")){const t=hu(this.editor,"bold");du(this.editor,this,/(\*\*)([^*]+)(\*\*)$/g,t),du(this.editor,this,/(__)([^_]+)(__)$/g,t)}if(t.get("italic")){const t=hu(this.editor,"italic");du(this.editor,this,/(?:^|[^*])(\*)([^*_]+)(\*)$/g,t),du(this.editor,this,/(?:^|[^_])(_)([^_]+)(_)$/g,t)}if(t.get("code")){const t=hu(this.editor,"code");du(this.editor,this,/(`)([^`]+)(`)$/g,t)}if(t.get("strikethrough")){const t=hu(this.editor,"strikethrough");du(this.editor,this,/(~~)([^~]+)(~~)$/g,t)}}_addHeadingAutoformats(){const t=this.editor.commands.get("heading");t&&t.modelElements.filter(t=>t.match(/^heading[1-6]$/)).forEach(e=>{const n=e[7],i=new RegExp(`^(#{${n}})\\s$`);lu(this.editor,this,i,()=>{if(!t.isEnabled)return!1;this.editor.execute("heading",{value:e})})})}_addBlockQuoteAutoformats(){this.editor.commands.get("blockQuote")&&lu(this.editor,this,/^>\s$/,"blockQuote")}_addCodeBlockAutoformats(){this.editor.commands.get("codeBlock")&&lu(this.editor,this,/^```$/,"codeBlock")}},class extends Zl{static get requires(){return[gu,mu]}static get pluginName(){return"Bold"}},class extends Zl{static get requires(){return[pu,bu]}static get pluginName(){return"Italic"}},class extends Zl{static get requires(){return[xu,Au]}static get pluginName(){return"BlockQuote"}},class extends Zl{static get pluginName(){return"CKFinder"}static get requires(){return[Fh,Cu,au]}},class extends Zl{static get requires(){return[$h,wf,Rf]}static get pluginName(){return"EasyImage"}},class extends Zl{static get requires(){return[Hf,qf]}static get pluginName(){return"Heading"}},wf,class extends Zl{static get requires(){return[$f]}static get pluginName(){return"ImageCaption"}},class extends Zl{static get requires(){return[lg,dg]}static get pluginName(){return"ImageStyle"}},class extends Zl{static get requires(){return[ug]}static get pluginName(){return"ImageToolbar"}afterInit(){const t=this.editor,e=t.t;t.plugins.get(ug).register("image",{ariaLabel:e("Image toolbar"),items:t.config.get("image.toolbar")||[],getRelatedElement:Gu})}},Rf,class extends Zl{static get pluginName(){return"Indent"}static get requires(){return[mg,wg]}},class extends Zl{static get requires(){return[jh,Ag]}static get pluginName(){return"Link"}},class extends Zl{static get requires(){return[Qg,Zg]}static get pluginName(){return"List"}},class extends Zl{static get requires(){return[am,um,lm,Xh]}static get pluginName(){return"MediaEmbed"}},Vf,class extends Zl{static get pluginName(){return"PasteFromOffice"}static get requires(){return[id]}init(){const t=this.editor,e=t.editing.view.document,n=[];n.push(new ym(e)),n.push(new pm(e)),t.plugins.get("Clipboard").on("inputTransformation",(t,e)=>{if(e.isTransformedWithPasteFromOffice)return;const i=e.dataTransfer.getData("text/html"),o=n.find(t=>t.isActive(i));o&&(o.execute(e),e.isTransformedWithPasteFromOffice=!0)},{priority:"high"})}},class extends Zl{static get requires(){return[Fp,qp,Gp,tb,Zp,$p,Xh]}static get pluginName(){return"Table"}},class extends Zl{static get requires(){return[ug]}static get pluginName(){return"TableToolbar"}afterInit(){const t=this.editor,e=t.t,n=t.plugins.get(ug),i=t.config.get("table.contentToolbar"),o=t.config.get("table.tableToolbar");i&&n.register("tableContent",{ariaLabel:e("Table toolbar"),items:i,getRelatedElement:ib}),o&&n.register("table",{ariaLabel:e("Table toolbar"),items:o,getRelatedElement:nb})}},class extends Zl{static get pluginName(){return"TextTransformation"}constructor(t){super(t),t.config.define("typing",{transformations:{include:ub}})}init(){const t=this.editor.model.document.selection;t.on("change:range",()=>{this.isEnabled=!t.anchor.parent.is("codeBlock")}),this._enableTransformationWatchers()}_enableTransformationWatchers(){const t=this.editor,e=t.model,n=t.plugins.get("Input"),i=function(t){const e=t.extra||[],n=t.remove||[],i=t=>!n.includes(t);return function(t){const e=new Set;for(const n of t)if(db[n])for(const t of db[n])e.add(t);else e.add(n);return Array.from(e)}(t.include.concat(e).filter(i)).filter(i).map(t=>lb[t]||t).map(t=>({from:hb(t.from),to:fb(t.to)}))}(t.config.get("typing.transformations")),o=new rb(t.model,t=>{for(const e of i){if(e.from.test(t))return{normalizedTransformation:e}}});o.on("matched:data",(t,i)=>{if(!n.isInput(i.batch))return;const{from:o,to:r}=i.normalizedTransformation,s=o.exec(i.text),a=r(s.slice(1)),c=i.range;let l=s.index;e.enqueueChange(t=>{for(let n=1;n<s.length;n++){const i=s[n],o=a[n-1];if(null==o){l+=i.length;continue}const r=c.start.getShiftedBy(l),d=e.createRange(r,r.getShiftedBy(i.length)),u=gb(r);e.insertContent(t.createText(o,u),d),l+=o.length}})}),o.bind("isEnabled").to(this)}}],pb.defaultConfig={toolbar:{items:["heading","|","bold","italic","link","bulletedList","numberedList","|","indent","outdent","|","imageUpload","blockQuote","insertTable","mediaEmbed","undo","redo"]},image:{toolbar:["imageStyle:full","imageStyle:side","|","imageTextAlternative"]},table:{contentToolbar:["tableColumn","tableRow","mergeTableCells"]},language:"en"}}]).default}));

},{}],2:[function(require,module,exports){
/*!
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md.
 */
!function(t,e){"object"==typeof exports&&"object"==typeof module?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.CKEditor=e():t.CKEditor=e()}(window,(function(){return function(t){var e={};function n(i){if(e[i])return e[i].exports;var r=e[i]={i:i,l:!1,exports:{}};return t[i].call(r.exports,r,r.exports,n),r.l=!0,r.exports}return n.m=t,n.c=e,n.d=function(t,e,i){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:i})},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var i=Object.create(null);if(n.r(i),Object.defineProperty(i,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var r in t)n.d(i,r,function(e){return t[e]}.bind(null,r));return i},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="",n(n.s=2)}([function(t,e,n){"use strict";(function(t){var n="object"==typeof t&&t&&t.Object===Object&&t;e.a=n}).call(this,n(1))},function(t,e){var n;n=function(){return this}();try{n=n||new Function("return this")()}catch(t){"object"==typeof window&&(n=window)}t.exports=n},function(t,e,n){"use strict";n.r(e);var i=function(t){var e=typeof t;return null!=t&&("object"==e||"function"==e)},r=n(0),o="object"==typeof self&&self&&self.Object===Object&&self,a=r.a||o||Function("return this")(),u=function(){return a.Date.now()},c=a.Symbol,s=Object.prototype,f=s.hasOwnProperty,l=s.toString,d=c?c.toStringTag:void 0;var p=function(t){var e=f.call(t,d),n=t[d];try{t[d]=void 0;var i=!0}catch(t){}var r=l.call(t);return i&&(e?t[d]=n:delete t[d]),r},v=Object.prototype.toString;var y=function(t){return v.call(t)},b=c?c.toStringTag:void 0;var h=function(t){return null==t?void 0===t?"[object Undefined]":"[object Null]":b&&b in Object(t)?p(t):y(t)};var m=function(t){return null!=t&&"object"==typeof t};var g=function(t){return"symbol"==typeof t||m(t)&&"[object Symbol]"==h(t)},j=/^\s+|\s+$/g,$=/^[-+]0x[0-9a-f]+$/i,O=/^0b[01]+$/i,_=/^0o[0-7]+$/i,w=parseInt;var x=function(t){if("number"==typeof t)return t;if(g(t))return NaN;if(i(t)){var e="function"==typeof t.valueOf?t.valueOf():t;t=i(e)?e+"":e}if("string"!=typeof t)return 0===t?t:+t;t=t.replace(j,"");var n=O.test(t);return n||_.test(t)?w(t.slice(2),n?2:8):$.test(t)?NaN:+t},S=Math.max,E=Math.min;var T=function(t,e,n){var r,o,a,c,s,f,l=0,d=!1,p=!1,v=!0;if("function"!=typeof t)throw new TypeError("Expected a function");function y(e){var n=r,i=o;return r=o=void 0,l=e,c=t.apply(i,n)}function b(t){return l=t,s=setTimeout(m,e),d?y(t):c}function h(t){var n=t-f;return void 0===f||n>=e||n<0||p&&t-l>=a}function m(){var t=u();if(h(t))return g(t);s=setTimeout(m,function(t){var n=e-(t-f);return p?E(n,a-(t-l)):n}(t))}function g(t){return s=void 0,v&&r?y(t):(r=o=void 0,c)}function j(){var t=u(),n=h(t);if(r=arguments,o=this,f=t,n){if(void 0===s)return b(f);if(p)return clearTimeout(s),s=setTimeout(m,e),y(f)}return void 0===s&&(s=setTimeout(m,e)),c}return e=x(e)||0,i(n)&&(d=!!n.leading,a=(p="maxWait"in n)?S(x(n.maxWait)||0,e):a,v="trailing"in n?!!n.trailing:v),j.cancel=function(){void 0!==s&&clearTimeout(s),l=0,r=f=o=s=void 0},j.flush=function(){return void 0===s?c:g(u())},j};var D={name:"ckeditor",render(t){return t(this.tagName)},props:{editor:{type:Function,default:null},value:{type:String,default:""},config:{type:Object,default:()=>({})},tagName:{type:String,default:"div"},disabled:{type:Boolean,default:!1}},data:()=>({$_instance:null,$_lastEditorData:{type:String,default:""}}),mounted(){const t=Object.assign({},this.config);this.value&&(t.initialData=this.value),this.editor.create(this.$el,t).then(t=>{this.$_instance=t,t.isReadOnly=this.disabled,this.$_setUpEditorEvents(),this.$emit("ready",t)}).catch(t=>{console.error(t)})},beforeDestroy(){this.$_instance&&(this.$_instance.destroy(),this.$_instance=null),this.$emit("destroy",this.$_instance)},watch:{value(t,e){t!==e&&t!==this.$_lastEditorData&&this.$_instance.setData(t)},disabled(t){this.$_instance.isReadOnly=t}},methods:{$_setUpEditorEvents(){const t=this.$_instance,e=T(e=>{const n=this.$_lastEditorData=t.getData();this.$emit("input",n,e,t)},300,{leading:!0});t.model.document.on("change:data",e),t.editing.view.document.on("focus",e=>{this.$emit("focus",e,t)}),t.editing.view.document.on("blur",e=>{this.$emit("blur",e,t)})}}};const N={install(t){t.component("ckeditor",D)},component:D};e.default=N}]).default}));

},{}],3:[function(require,module,exports){
/*!
FullCalendar v5.9.0
Docs & License: https://fullcalendar.io/
(c) 2021 Adam Shaw
*/
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

;
var tslib = require('tslib');
var vdom_cjs = require('./vdom.cjs');

// no public types yet. when there are, export from:
// import {} from './api-type-deps'
var EventSourceApi = /** @class */ (function () {
    function EventSourceApi(context, internalEventSource) {
        this.context = context;
        this.internalEventSource = internalEventSource;
    }
    EventSourceApi.prototype.remove = function () {
        this.context.dispatch({
            type: 'REMOVE_EVENT_SOURCE',
            sourceId: this.internalEventSource.sourceId,
        });
    };
    EventSourceApi.prototype.refetch = function () {
        this.context.dispatch({
            type: 'FETCH_EVENT_SOURCES',
            sourceIds: [this.internalEventSource.sourceId],
            isRefetch: true,
        });
    };
    Object.defineProperty(EventSourceApi.prototype, "id", {
        get: function () {
            return this.internalEventSource.publicId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventSourceApi.prototype, "url", {
        get: function () {
            return this.internalEventSource.meta.url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventSourceApi.prototype, "format", {
        get: function () {
            return this.internalEventSource.meta.format; // TODO: bad. not guaranteed
        },
        enumerable: false,
        configurable: true
    });
    return EventSourceApi;
}());

function removeElement(el) {
    if (el.parentNode) {
        el.parentNode.removeChild(el);
    }
}
// Querying
// ----------------------------------------------------------------------------------------------------------------
function elementClosest(el, selector) {
    if (el.closest) {
        return el.closest(selector);
        // really bad fallback for IE
        // from https://developer.mozilla.org/en-US/docs/Web/API/Element/closest
    }
    if (!document.documentElement.contains(el)) {
        return null;
    }
    do {
        if (elementMatches(el, selector)) {
            return el;
        }
        el = (el.parentElement || el.parentNode);
    } while (el !== null && el.nodeType === 1);
    return null;
}
function elementMatches(el, selector) {
    var method = el.matches || el.matchesSelector || el.msMatchesSelector;
    return method.call(el, selector);
}
// accepts multiple subject els
// returns a real array. good for methods like forEach
// TODO: accept the document
function findElements(container, selector) {
    var containers = container instanceof HTMLElement ? [container] : container;
    var allMatches = [];
    for (var i = 0; i < containers.length; i += 1) {
        var matches = containers[i].querySelectorAll(selector);
        for (var j = 0; j < matches.length; j += 1) {
            allMatches.push(matches[j]);
        }
    }
    return allMatches;
}
// accepts multiple subject els
// only queries direct child elements // TODO: rename to findDirectChildren!
function findDirectChildren(parent, selector) {
    var parents = parent instanceof HTMLElement ? [parent] : parent;
    var allMatches = [];
    for (var i = 0; i < parents.length; i += 1) {
        var childNodes = parents[i].children; // only ever elements
        for (var j = 0; j < childNodes.length; j += 1) {
            var childNode = childNodes[j];
            if (!selector || elementMatches(childNode, selector)) {
                allMatches.push(childNode);
            }
        }
    }
    return allMatches;
}
// Style
// ----------------------------------------------------------------------------------------------------------------
var PIXEL_PROP_RE = /(top|left|right|bottom|width|height)$/i;
function applyStyle(el, props) {
    for (var propName in props) {
        applyStyleProp(el, propName, props[propName]);
    }
}
function applyStyleProp(el, name, val) {
    if (val == null) {
        el.style[name] = '';
    }
    else if (typeof val === 'number' && PIXEL_PROP_RE.test(name)) {
        el.style[name] = val + "px";
    }
    else {
        el.style[name] = val;
    }
}
// Event Handling
// ----------------------------------------------------------------------------------------------------------------
// if intercepting bubbled events at the document/window/body level,
// and want to see originating element (the 'target'), use this util instead
// of `ev.target` because it goes within web-component boundaries.
function getEventTargetViaRoot(ev) {
    var _a, _b;
    return (_b = (_a = ev.composedPath) === null || _a === void 0 ? void 0 : _a.call(ev)[0]) !== null && _b !== void 0 ? _b : ev.target;
}
// Shadow DOM consuderations
// ----------------------------------------------------------------------------------------------------------------
function getElRoot(el) {
    return el.getRootNode ? el.getRootNode() : document;
}

// Stops a mouse/touch event from doing it's native browser action
function preventDefault(ev) {
    ev.preventDefault();
}
// Event Delegation
// ----------------------------------------------------------------------------------------------------------------
function buildDelegationHandler(selector, handler) {
    return function (ev) {
        var matchedChild = elementClosest(ev.target, selector);
        if (matchedChild) {
            handler.call(matchedChild, ev, matchedChild);
        }
    };
}
function listenBySelector(container, eventType, selector, handler) {
    var attachedHandler = buildDelegationHandler(selector, handler);
    container.addEventListener(eventType, attachedHandler);
    return function () {
        container.removeEventListener(eventType, attachedHandler);
    };
}
function listenToHoverBySelector(container, selector, onMouseEnter, onMouseLeave) {
    var currentMatchedChild;
    return listenBySelector(container, 'mouseover', selector, function (mouseOverEv, matchedChild) {
        if (matchedChild !== currentMatchedChild) {
            currentMatchedChild = matchedChild;
            onMouseEnter(mouseOverEv, matchedChild);
            var realOnMouseLeave_1 = function (mouseLeaveEv) {
                currentMatchedChild = null;
                onMouseLeave(mouseLeaveEv, matchedChild);
                matchedChild.removeEventListener('mouseleave', realOnMouseLeave_1);
            };
            // listen to the next mouseleave, and then unattach
            matchedChild.addEventListener('mouseleave', realOnMouseLeave_1);
        }
    });
}
// Animation
// ----------------------------------------------------------------------------------------------------------------
var transitionEventNames = [
    'webkitTransitionEnd',
    'otransitionend',
    'oTransitionEnd',
    'msTransitionEnd',
    'transitionend',
];
// triggered only when the next single subsequent transition finishes
function whenTransitionDone(el, callback) {
    var realCallback = function (ev) {
        callback(ev);
        transitionEventNames.forEach(function (eventName) {
            el.removeEventListener(eventName, realCallback);
        });
    };
    transitionEventNames.forEach(function (eventName) {
        el.addEventListener(eventName, realCallback); // cross-browser way to determine when the transition finishes
    });
}

var guidNumber = 0;
function guid() {
    guidNumber += 1;
    return String(guidNumber);
}
/* FullCalendar-specific DOM Utilities
----------------------------------------------------------------------------------------------------------------------*/
// Make the mouse cursor express that an event is not allowed in the current area
function disableCursor() {
    document.body.classList.add('fc-not-allowed');
}
// Returns the mouse cursor to its original look
function enableCursor() {
    document.body.classList.remove('fc-not-allowed');
}
/* Selection
----------------------------------------------------------------------------------------------------------------------*/
function preventSelection(el) {
    el.classList.add('fc-unselectable');
    el.addEventListener('selectstart', preventDefault);
}
function allowSelection(el) {
    el.classList.remove('fc-unselectable');
    el.removeEventListener('selectstart', preventDefault);
}
/* Context Menu
----------------------------------------------------------------------------------------------------------------------*/
function preventContextMenu(el) {
    el.addEventListener('contextmenu', preventDefault);
}
function allowContextMenu(el) {
    el.removeEventListener('contextmenu', preventDefault);
}
function parseFieldSpecs(input) {
    var specs = [];
    var tokens = [];
    var i;
    var token;
    if (typeof input === 'string') {
        tokens = input.split(/\s*,\s*/);
    }
    else if (typeof input === 'function') {
        tokens = [input];
    }
    else if (Array.isArray(input)) {
        tokens = input;
    }
    for (i = 0; i < tokens.length; i += 1) {
        token = tokens[i];
        if (typeof token === 'string') {
            specs.push(token.charAt(0) === '-' ?
                { field: token.substring(1), order: -1 } :
                { field: token, order: 1 });
        }
        else if (typeof token === 'function') {
            specs.push({ func: token });
        }
    }
    return specs;
}
function compareByFieldSpecs(obj0, obj1, fieldSpecs) {
    var i;
    var cmp;
    for (i = 0; i < fieldSpecs.length; i += 1) {
        cmp = compareByFieldSpec(obj0, obj1, fieldSpecs[i]);
        if (cmp) {
            return cmp;
        }
    }
    return 0;
}
function compareByFieldSpec(obj0, obj1, fieldSpec) {
    if (fieldSpec.func) {
        return fieldSpec.func(obj0, obj1);
    }
    return flexibleCompare(obj0[fieldSpec.field], obj1[fieldSpec.field])
        * (fieldSpec.order || 1);
}
function flexibleCompare(a, b) {
    if (!a && !b) {
        return 0;
    }
    if (b == null) {
        return -1;
    }
    if (a == null) {
        return 1;
    }
    if (typeof a === 'string' || typeof b === 'string') {
        return String(a).localeCompare(String(b));
    }
    return a - b;
}
/* String Utilities
----------------------------------------------------------------------------------------------------------------------*/
function padStart(val, len) {
    var s = String(val);
    return '000'.substr(0, len - s.length) + s;
}
/* Number Utilities
----------------------------------------------------------------------------------------------------------------------*/
function compareNumbers(a, b) {
    return a - b;
}
function isInt(n) {
    return n % 1 === 0;
}
/* FC-specific DOM dimension stuff
----------------------------------------------------------------------------------------------------------------------*/
function computeSmallestCellWidth(cellEl) {
    var allWidthEl = cellEl.querySelector('.fc-scrollgrid-shrink-frame');
    var contentWidthEl = cellEl.querySelector('.fc-scrollgrid-shrink-cushion');
    if (!allWidthEl) {
        throw new Error('needs fc-scrollgrid-shrink-frame className'); // TODO: use const
    }
    if (!contentWidthEl) {
        throw new Error('needs fc-scrollgrid-shrink-cushion className');
    }
    return cellEl.getBoundingClientRect().width - allWidthEl.getBoundingClientRect().width + // the cell padding+border
        contentWidthEl.getBoundingClientRect().width;
}

var DAY_IDS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
// Adding
function addWeeks(m, n) {
    var a = dateToUtcArray(m);
    a[2] += n * 7;
    return arrayToUtcDate(a);
}
function addDays(m, n) {
    var a = dateToUtcArray(m);
    a[2] += n;
    return arrayToUtcDate(a);
}
function addMs(m, n) {
    var a = dateToUtcArray(m);
    a[6] += n;
    return arrayToUtcDate(a);
}
// Diffing (all return floats)
// TODO: why not use ranges?
function diffWeeks(m0, m1) {
    return diffDays(m0, m1) / 7;
}
function diffDays(m0, m1) {
    return (m1.valueOf() - m0.valueOf()) / (1000 * 60 * 60 * 24);
}
function diffHours(m0, m1) {
    return (m1.valueOf() - m0.valueOf()) / (1000 * 60 * 60);
}
function diffMinutes(m0, m1) {
    return (m1.valueOf() - m0.valueOf()) / (1000 * 60);
}
function diffSeconds(m0, m1) {
    return (m1.valueOf() - m0.valueOf()) / 1000;
}
function diffDayAndTime(m0, m1) {
    var m0day = startOfDay(m0);
    var m1day = startOfDay(m1);
    return {
        years: 0,
        months: 0,
        days: Math.round(diffDays(m0day, m1day)),
        milliseconds: (m1.valueOf() - m1day.valueOf()) - (m0.valueOf() - m0day.valueOf()),
    };
}
// Diffing Whole Units
function diffWholeWeeks(m0, m1) {
    var d = diffWholeDays(m0, m1);
    if (d !== null && d % 7 === 0) {
        return d / 7;
    }
    return null;
}
function diffWholeDays(m0, m1) {
    if (timeAsMs(m0) === timeAsMs(m1)) {
        return Math.round(diffDays(m0, m1));
    }
    return null;
}
// Start-Of
function startOfDay(m) {
    return arrayToUtcDate([
        m.getUTCFullYear(),
        m.getUTCMonth(),
        m.getUTCDate(),
    ]);
}
function startOfHour(m) {
    return arrayToUtcDate([
        m.getUTCFullYear(),
        m.getUTCMonth(),
        m.getUTCDate(),
        m.getUTCHours(),
    ]);
}
function startOfMinute(m) {
    return arrayToUtcDate([
        m.getUTCFullYear(),
        m.getUTCMonth(),
        m.getUTCDate(),
        m.getUTCHours(),
        m.getUTCMinutes(),
    ]);
}
function startOfSecond(m) {
    return arrayToUtcDate([
        m.getUTCFullYear(),
        m.getUTCMonth(),
        m.getUTCDate(),
        m.getUTCHours(),
        m.getUTCMinutes(),
        m.getUTCSeconds(),
    ]);
}
// Week Computation
function weekOfYear(marker, dow, doy) {
    var y = marker.getUTCFullYear();
    var w = weekOfGivenYear(marker, y, dow, doy);
    if (w < 1) {
        return weekOfGivenYear(marker, y - 1, dow, doy);
    }
    var nextW = weekOfGivenYear(marker, y + 1, dow, doy);
    if (nextW >= 1) {
        return Math.min(w, nextW);
    }
    return w;
}
function weekOfGivenYear(marker, year, dow, doy) {
    var firstWeekStart = arrayToUtcDate([year, 0, 1 + firstWeekOffset(year, dow, doy)]);
    var dayStart = startOfDay(marker);
    var days = Math.round(diffDays(firstWeekStart, dayStart));
    return Math.floor(days / 7) + 1; // zero-indexed
}
// start-of-first-week - start-of-year
function firstWeekOffset(year, dow, doy) {
    // first-week day -- which january is always in the first week (4 for iso, 1 for other)
    var fwd = 7 + dow - doy;
    // first-week day local weekday -- which local weekday is fwd
    var fwdlw = (7 + arrayToUtcDate([year, 0, fwd]).getUTCDay() - dow) % 7;
    return -fwdlw + fwd - 1;
}
// Array Conversion
function dateToLocalArray(date) {
    return [
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds(),
        date.getMilliseconds(),
    ];
}
function arrayToLocalDate(a) {
    return new Date(a[0], a[1] || 0, a[2] == null ? 1 : a[2], // day of month
    a[3] || 0, a[4] || 0, a[5] || 0);
}
function dateToUtcArray(date) {
    return [
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        date.getUTCHours(),
        date.getUTCMinutes(),
        date.getUTCSeconds(),
        date.getUTCMilliseconds(),
    ];
}
function arrayToUtcDate(a) {
    // according to web standards (and Safari), a month index is required.
    // massage if only given a year.
    if (a.length === 1) {
        a = a.concat([0]);
    }
    return new Date(Date.UTC.apply(Date, a));
}
// Other Utils
function isValidDate(m) {
    return !isNaN(m.valueOf());
}
function timeAsMs(m) {
    return m.getUTCHours() * 1000 * 60 * 60 +
        m.getUTCMinutes() * 1000 * 60 +
        m.getUTCSeconds() * 1000 +
        m.getUTCMilliseconds();
}

function createEventInstance(defId, range, forcedStartTzo, forcedEndTzo) {
    return {
        instanceId: guid(),
        defId: defId,
        range: range,
        forcedStartTzo: forcedStartTzo == null ? null : forcedStartTzo,
        forcedEndTzo: forcedEndTzo == null ? null : forcedEndTzo,
    };
}

var hasOwnProperty = Object.prototype.hasOwnProperty;
// Merges an array of objects into a single object.
// The second argument allows for an array of property names who's object values will be merged together.
function mergeProps(propObjs, complexPropsMap) {
    var dest = {};
    if (complexPropsMap) {
        for (var name_1 in complexPropsMap) {
            var complexObjs = [];
            // collect the trailing object values, stopping when a non-object is discovered
            for (var i = propObjs.length - 1; i >= 0; i -= 1) {
                var val = propObjs[i][name_1];
                if (typeof val === 'object' && val) { // non-null object
                    complexObjs.unshift(val);
                }
                else if (val !== undefined) {
                    dest[name_1] = val; // if there were no objects, this value will be used
                    break;
                }
            }
            // if the trailing values were objects, use the merged value
            if (complexObjs.length) {
                dest[name_1] = mergeProps(complexObjs);
            }
        }
    }
    // copy values into the destination, going from last to first
    for (var i = propObjs.length - 1; i >= 0; i -= 1) {
        var props = propObjs[i];
        for (var name_2 in props) {
            if (!(name_2 in dest)) { // if already assigned by previous props or complex props, don't reassign
                dest[name_2] = props[name_2];
            }
        }
    }
    return dest;
}
function filterHash(hash, func) {
    var filtered = {};
    for (var key in hash) {
        if (func(hash[key], key)) {
            filtered[key] = hash[key];
        }
    }
    return filtered;
}
function mapHash(hash, func) {
    var newHash = {};
    for (var key in hash) {
        newHash[key] = func(hash[key], key);
    }
    return newHash;
}
function arrayToHash(a) {
    var hash = {};
    for (var _i = 0, a_1 = a; _i < a_1.length; _i++) {
        var item = a_1[_i];
        hash[item] = true;
    }
    return hash;
}
function buildHashFromArray(a, func) {
    var hash = {};
    for (var i = 0; i < a.length; i += 1) {
        var tuple = func(a[i], i);
        hash[tuple[0]] = tuple[1];
    }
    return hash;
}
function hashValuesToArray(obj) {
    var a = [];
    for (var key in obj) {
        a.push(obj[key]);
    }
    return a;
}
function isPropsEqual(obj0, obj1) {
    if (obj0 === obj1) {
        return true;
    }
    for (var key in obj0) {
        if (hasOwnProperty.call(obj0, key)) {
            if (!(key in obj1)) {
                return false;
            }
        }
    }
    for (var key in obj1) {
        if (hasOwnProperty.call(obj1, key)) {
            if (obj0[key] !== obj1[key]) {
                return false;
            }
        }
    }
    return true;
}
function getUnequalProps(obj0, obj1) {
    var keys = [];
    for (var key in obj0) {
        if (hasOwnProperty.call(obj0, key)) {
            if (!(key in obj1)) {
                keys.push(key);
            }
        }
    }
    for (var key in obj1) {
        if (hasOwnProperty.call(obj1, key)) {
            if (obj0[key] !== obj1[key]) {
                keys.push(key);
            }
        }
    }
    return keys;
}
function compareObjs(oldProps, newProps, equalityFuncs) {
    if (equalityFuncs === void 0) { equalityFuncs = {}; }
    if (oldProps === newProps) {
        return true;
    }
    for (var key in newProps) {
        if (key in oldProps && isObjValsEqual(oldProps[key], newProps[key], equalityFuncs[key])) ;
        else {
            return false;
        }
    }
    // check for props that were omitted in the new
    for (var key in oldProps) {
        if (!(key in newProps)) {
            return false;
        }
    }
    return true;
}
/*
assumed "true" equality for handler names like "onReceiveSomething"
*/
function isObjValsEqual(val0, val1, comparator) {
    if (val0 === val1 || comparator === true) {
        return true;
    }
    if (comparator) {
        return comparator(val0, val1);
    }
    return false;
}
function collectFromHash(hash, startIndex, endIndex, step) {
    if (startIndex === void 0) { startIndex = 0; }
    if (step === void 0) { step = 1; }
    var res = [];
    if (endIndex == null) {
        endIndex = Object.keys(hash).length;
    }
    for (var i = startIndex; i < endIndex; i += step) {
        var val = hash[i];
        if (val !== undefined) { // will disregard undefined for sparse arrays
            res.push(val);
        }
    }
    return res;
}

function parseRecurring(refined, defaultAllDay, dateEnv, recurringTypes) {
    for (var i = 0; i < recurringTypes.length; i += 1) {
        var parsed = recurringTypes[i].parse(refined, dateEnv);
        if (parsed) {
            var allDay = refined.allDay;
            if (allDay == null) {
                allDay = defaultAllDay;
                if (allDay == null) {
                    allDay = parsed.allDayGuess;
                    if (allDay == null) {
                        allDay = false;
                    }
                }
            }
            return {
                allDay: allDay,
                duration: parsed.duration,
                typeData: parsed.typeData,
                typeId: i,
            };
        }
    }
    return null;
}
function expandRecurring(eventStore, framingRange, context) {
    var dateEnv = context.dateEnv, pluginHooks = context.pluginHooks, options = context.options;
    var defs = eventStore.defs, instances = eventStore.instances;
    // remove existing recurring instances
    // TODO: bad. always expand events as a second step
    instances = filterHash(instances, function (instance) { return !defs[instance.defId].recurringDef; });
    for (var defId in defs) {
        var def = defs[defId];
        if (def.recurringDef) {
            var duration = def.recurringDef.duration;
            if (!duration) {
                duration = def.allDay ?
                    options.defaultAllDayEventDuration :
                    options.defaultTimedEventDuration;
            }
            var starts = expandRecurringRanges(def, duration, framingRange, dateEnv, pluginHooks.recurringTypes);
            for (var _i = 0, starts_1 = starts; _i < starts_1.length; _i++) {
                var start = starts_1[_i];
                var instance = createEventInstance(defId, {
                    start: start,
                    end: dateEnv.add(start, duration),
                });
                instances[instance.instanceId] = instance;
            }
        }
    }
    return { defs: defs, instances: instances };
}
/*
Event MUST have a recurringDef
*/
function expandRecurringRanges(eventDef, duration, framingRange, dateEnv, recurringTypes) {
    var typeDef = recurringTypes[eventDef.recurringDef.typeId];
    var markers = typeDef.expand(eventDef.recurringDef.typeData, {
        start: dateEnv.subtract(framingRange.start, duration),
        end: framingRange.end,
    }, dateEnv);
    // the recurrence plugins don't guarantee that all-day events are start-of-day, so we have to
    if (eventDef.allDay) {
        markers = markers.map(startOfDay);
    }
    return markers;
}

var INTERNAL_UNITS = ['years', 'months', 'days', 'milliseconds'];
var PARSE_RE = /^(-?)(?:(\d+)\.)?(\d+):(\d\d)(?::(\d\d)(?:\.(\d\d\d))?)?/;
// Parsing and Creation
function createDuration(input, unit) {
    var _a;
    if (typeof input === 'string') {
        return parseString(input);
    }
    if (typeof input === 'object' && input) { // non-null object
        return parseObject(input);
    }
    if (typeof input === 'number') {
        return parseObject((_a = {}, _a[unit || 'milliseconds'] = input, _a));
    }
    return null;
}
function parseString(s) {
    var m = PARSE_RE.exec(s);
    if (m) {
        var sign = m[1] ? -1 : 1;
        return {
            years: 0,
            months: 0,
            days: sign * (m[2] ? parseInt(m[2], 10) : 0),
            milliseconds: sign * ((m[3] ? parseInt(m[3], 10) : 0) * 60 * 60 * 1000 + // hours
                (m[4] ? parseInt(m[4], 10) : 0) * 60 * 1000 + // minutes
                (m[5] ? parseInt(m[5], 10) : 0) * 1000 + // seconds
                (m[6] ? parseInt(m[6], 10) : 0) // ms
            ),
        };
    }
    return null;
}
function parseObject(obj) {
    var duration = {
        years: obj.years || obj.year || 0,
        months: obj.months || obj.month || 0,
        days: obj.days || obj.day || 0,
        milliseconds: (obj.hours || obj.hour || 0) * 60 * 60 * 1000 + // hours
            (obj.minutes || obj.minute || 0) * 60 * 1000 + // minutes
            (obj.seconds || obj.second || 0) * 1000 + // seconds
            (obj.milliseconds || obj.millisecond || obj.ms || 0), // ms
    };
    var weeks = obj.weeks || obj.week;
    if (weeks) {
        duration.days += weeks * 7;
        duration.specifiedWeeks = true;
    }
    return duration;
}
// Equality
function durationsEqual(d0, d1) {
    return d0.years === d1.years &&
        d0.months === d1.months &&
        d0.days === d1.days &&
        d0.milliseconds === d1.milliseconds;
}
function asCleanDays(dur) {
    if (!dur.years && !dur.months && !dur.milliseconds) {
        return dur.days;
    }
    return 0;
}
// Simple Math
function addDurations(d0, d1) {
    return {
        years: d0.years + d1.years,
        months: d0.months + d1.months,
        days: d0.days + d1.days,
        milliseconds: d0.milliseconds + d1.milliseconds,
    };
}
function subtractDurations(d1, d0) {
    return {
        years: d1.years - d0.years,
        months: d1.months - d0.months,
        days: d1.days - d0.days,
        milliseconds: d1.milliseconds - d0.milliseconds,
    };
}
function multiplyDuration(d, n) {
    return {
        years: d.years * n,
        months: d.months * n,
        days: d.days * n,
        milliseconds: d.milliseconds * n,
    };
}
// Conversions
// "Rough" because they are based on average-case Gregorian months/years
function asRoughYears(dur) {
    return asRoughDays(dur) / 365;
}
function asRoughMonths(dur) {
    return asRoughDays(dur) / 30;
}
function asRoughDays(dur) {
    return asRoughMs(dur) / 864e5;
}
function asRoughMinutes(dur) {
    return asRoughMs(dur) / (1000 * 60);
}
function asRoughSeconds(dur) {
    return asRoughMs(dur) / 1000;
}
function asRoughMs(dur) {
    return dur.years * (365 * 864e5) +
        dur.months * (30 * 864e5) +
        dur.days * 864e5 +
        dur.milliseconds;
}
// Advanced Math
function wholeDivideDurations(numerator, denominator) {
    var res = null;
    for (var i = 0; i < INTERNAL_UNITS.length; i += 1) {
        var unit = INTERNAL_UNITS[i];
        if (denominator[unit]) {
            var localRes = numerator[unit] / denominator[unit];
            if (!isInt(localRes) || (res !== null && res !== localRes)) {
                return null;
            }
            res = localRes;
        }
        else if (numerator[unit]) {
            // needs to divide by something but can't!
            return null;
        }
    }
    return res;
}
function greatestDurationDenominator(dur) {
    var ms = dur.milliseconds;
    if (ms) {
        if (ms % 1000 !== 0) {
            return { unit: 'millisecond', value: ms };
        }
        if (ms % (1000 * 60) !== 0) {
            return { unit: 'second', value: ms / 1000 };
        }
        if (ms % (1000 * 60 * 60) !== 0) {
            return { unit: 'minute', value: ms / (1000 * 60) };
        }
        if (ms) {
            return { unit: 'hour', value: ms / (1000 * 60 * 60) };
        }
    }
    if (dur.days) {
        if (dur.specifiedWeeks && dur.days % 7 === 0) {
            return { unit: 'week', value: dur.days / 7 };
        }
        return { unit: 'day', value: dur.days };
    }
    if (dur.months) {
        return { unit: 'month', value: dur.months };
    }
    if (dur.years) {
        return { unit: 'year', value: dur.years };
    }
    return { unit: 'millisecond', value: 0 };
}

// timeZoneOffset is in minutes
function buildIsoString(marker, timeZoneOffset, stripZeroTime) {
    if (stripZeroTime === void 0) { stripZeroTime = false; }
    var s = marker.toISOString();
    s = s.replace('.000', '');
    if (stripZeroTime) {
        s = s.replace('T00:00:00Z', '');
    }
    if (s.length > 10) { // time part wasn't stripped, can add timezone info
        if (timeZoneOffset == null) {
            s = s.replace('Z', '');
        }
        else if (timeZoneOffset !== 0) {
            s = s.replace('Z', formatTimeZoneOffset(timeZoneOffset, true));
        }
        // otherwise, its UTC-0 and we want to keep the Z
    }
    return s;
}
// formats the date, but with no time part
// TODO: somehow merge with buildIsoString and stripZeroTime
// TODO: rename. omit "string"
function formatDayString(marker) {
    return marker.toISOString().replace(/T.*$/, '');
}
// TODO: use Date::toISOString and use everything after the T?
function formatIsoTimeString(marker) {
    return padStart(marker.getUTCHours(), 2) + ':' +
        padStart(marker.getUTCMinutes(), 2) + ':' +
        padStart(marker.getUTCSeconds(), 2);
}
function formatTimeZoneOffset(minutes, doIso) {
    if (doIso === void 0) { doIso = false; }
    var sign = minutes < 0 ? '-' : '+';
    var abs = Math.abs(minutes);
    var hours = Math.floor(abs / 60);
    var mins = Math.round(abs % 60);
    if (doIso) {
        return sign + padStart(hours, 2) + ":" + padStart(mins, 2);
    }
    return "GMT" + sign + hours + (mins ? ":" + padStart(mins, 2) : '');
}

// TODO: new util arrayify?
function removeExact(array, exactVal) {
    var removeCnt = 0;
    var i = 0;
    while (i < array.length) {
        if (array[i] === exactVal) {
            array.splice(i, 1);
            removeCnt += 1;
        }
        else {
            i += 1;
        }
    }
    return removeCnt;
}
function isArraysEqual(a0, a1, equalityFunc) {
    if (a0 === a1) {
        return true;
    }
    var len = a0.length;
    var i;
    if (len !== a1.length) { // not array? or not same length?
        return false;
    }
    for (i = 0; i < len; i += 1) {
        if (!(equalityFunc ? equalityFunc(a0[i], a1[i]) : a0[i] === a1[i])) {
            return false;
        }
    }
    return true;
}

function memoize(workerFunc, resEquality, teardownFunc) {
    var currentArgs;
    var currentRes;
    return function () {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (!currentArgs) {
            currentRes = workerFunc.apply(this, newArgs);
        }
        else if (!isArraysEqual(currentArgs, newArgs)) {
            if (teardownFunc) {
                teardownFunc(currentRes);
            }
            var res = workerFunc.apply(this, newArgs);
            if (!resEquality || !resEquality(res, currentRes)) {
                currentRes = res;
            }
        }
        currentArgs = newArgs;
        return currentRes;
    };
}
function memoizeObjArg(workerFunc, resEquality, teardownFunc) {
    var _this = this;
    var currentArg;
    var currentRes;
    return function (newArg) {
        if (!currentArg) {
            currentRes = workerFunc.call(_this, newArg);
        }
        else if (!isPropsEqual(currentArg, newArg)) {
            if (teardownFunc) {
                teardownFunc(currentRes);
            }
            var res = workerFunc.call(_this, newArg);
            if (!resEquality || !resEquality(res, currentRes)) {
                currentRes = res;
            }
        }
        currentArg = newArg;
        return currentRes;
    };
}
function memoizeArraylike(// used at all?
workerFunc, resEquality, teardownFunc) {
    var _this = this;
    var currentArgSets = [];
    var currentResults = [];
    return function (newArgSets) {
        var currentLen = currentArgSets.length;
        var newLen = newArgSets.length;
        var i = 0;
        for (; i < currentLen; i += 1) {
            if (!newArgSets[i]) { // one of the old sets no longer exists
                if (teardownFunc) {
                    teardownFunc(currentResults[i]);
                }
            }
            else if (!isArraysEqual(currentArgSets[i], newArgSets[i])) {
                if (teardownFunc) {
                    teardownFunc(currentResults[i]);
                }
                var res = workerFunc.apply(_this, newArgSets[i]);
                if (!resEquality || !resEquality(res, currentResults[i])) {
                    currentResults[i] = res;
                }
            }
        }
        for (; i < newLen; i += 1) {
            currentResults[i] = workerFunc.apply(_this, newArgSets[i]);
        }
        currentArgSets = newArgSets;
        currentResults.splice(newLen); // remove excess
        return currentResults;
    };
}
function memoizeHashlike(// used?
workerFunc, resEquality, teardownFunc) {
    var _this = this;
    var currentArgHash = {};
    var currentResHash = {};
    return function (newArgHash) {
        var newResHash = {};
        for (var key in newArgHash) {
            if (!currentResHash[key]) {
                newResHash[key] = workerFunc.apply(_this, newArgHash[key]);
            }
            else if (!isArraysEqual(currentArgHash[key], newArgHash[key])) {
                if (teardownFunc) {
                    teardownFunc(currentResHash[key]);
                }
                var res = workerFunc.apply(_this, newArgHash[key]);
                newResHash[key] = (resEquality && resEquality(res, currentResHash[key]))
                    ? currentResHash[key]
                    : res;
            }
            else {
                newResHash[key] = currentResHash[key];
            }
        }
        currentArgHash = newArgHash;
        currentResHash = newResHash;
        return newResHash;
    };
}

var EXTENDED_SETTINGS_AND_SEVERITIES = {
    week: 3,
    separator: 0,
    omitZeroMinute: 0,
    meridiem: 0,
    omitCommas: 0,
};
var STANDARD_DATE_PROP_SEVERITIES = {
    timeZoneName: 7,
    era: 6,
    year: 5,
    month: 4,
    day: 2,
    weekday: 2,
    hour: 1,
    minute: 1,
    second: 1,
};
var MERIDIEM_RE = /\s*([ap])\.?m\.?/i; // eats up leading spaces too
var COMMA_RE = /,/g; // we need re for globalness
var MULTI_SPACE_RE = /\s+/g;
var LTR_RE = /\u200e/g; // control character
var UTC_RE = /UTC|GMT/;
var NativeFormatter = /** @class */ (function () {
    function NativeFormatter(formatSettings) {
        var standardDateProps = {};
        var extendedSettings = {};
        var severity = 0;
        for (var name_1 in formatSettings) {
            if (name_1 in EXTENDED_SETTINGS_AND_SEVERITIES) {
                extendedSettings[name_1] = formatSettings[name_1];
                severity = Math.max(EXTENDED_SETTINGS_AND_SEVERITIES[name_1], severity);
            }
            else {
                standardDateProps[name_1] = formatSettings[name_1];
                if (name_1 in STANDARD_DATE_PROP_SEVERITIES) { // TODO: what about hour12? no severity
                    severity = Math.max(STANDARD_DATE_PROP_SEVERITIES[name_1], severity);
                }
            }
        }
        this.standardDateProps = standardDateProps;
        this.extendedSettings = extendedSettings;
        this.severity = severity;
        this.buildFormattingFunc = memoize(buildFormattingFunc);
    }
    NativeFormatter.prototype.format = function (date, context) {
        return this.buildFormattingFunc(this.standardDateProps, this.extendedSettings, context)(date);
    };
    NativeFormatter.prototype.formatRange = function (start, end, context, betterDefaultSeparator) {
        var _a = this, standardDateProps = _a.standardDateProps, extendedSettings = _a.extendedSettings;
        var diffSeverity = computeMarkerDiffSeverity(start.marker, end.marker, context.calendarSystem);
        if (!diffSeverity) {
            return this.format(start, context);
        }
        var biggestUnitForPartial = diffSeverity;
        if (biggestUnitForPartial > 1 && // the two dates are different in a way that's larger scale than time
            (standardDateProps.year === 'numeric' || standardDateProps.year === '2-digit') &&
            (standardDateProps.month === 'numeric' || standardDateProps.month === '2-digit') &&
            (standardDateProps.day === 'numeric' || standardDateProps.day === '2-digit')) {
            biggestUnitForPartial = 1; // make it look like the dates are only different in terms of time
        }
        var full0 = this.format(start, context);
        var full1 = this.format(end, context);
        if (full0 === full1) {
            return full0;
        }
        var partialDateProps = computePartialFormattingOptions(standardDateProps, biggestUnitForPartial);
        var partialFormattingFunc = buildFormattingFunc(partialDateProps, extendedSettings, context);
        var partial0 = partialFormattingFunc(start);
        var partial1 = partialFormattingFunc(end);
        var insertion = findCommonInsertion(full0, partial0, full1, partial1);
        var separator = extendedSettings.separator || betterDefaultSeparator || context.defaultSeparator || '';
        if (insertion) {
            return insertion.before + partial0 + separator + partial1 + insertion.after;
        }
        return full0 + separator + full1;
    };
    NativeFormatter.prototype.getLargestUnit = function () {
        switch (this.severity) {
            case 7:
            case 6:
            case 5:
                return 'year';
            case 4:
                return 'month';
            case 3:
                return 'week';
            case 2:
                return 'day';
            default:
                return 'time'; // really?
        }
    };
    return NativeFormatter;
}());
function buildFormattingFunc(standardDateProps, extendedSettings, context) {
    var standardDatePropCnt = Object.keys(standardDateProps).length;
    if (standardDatePropCnt === 1 && standardDateProps.timeZoneName === 'short') {
        return function (date) { return (formatTimeZoneOffset(date.timeZoneOffset)); };
    }
    if (standardDatePropCnt === 0 && extendedSettings.week) {
        return function (date) { return (formatWeekNumber(context.computeWeekNumber(date.marker), context.weekText, context.locale, extendedSettings.week)); };
    }
    return buildNativeFormattingFunc(standardDateProps, extendedSettings, context);
}
function buildNativeFormattingFunc(standardDateProps, extendedSettings, context) {
    standardDateProps = tslib.__assign({}, standardDateProps); // copy
    extendedSettings = tslib.__assign({}, extendedSettings); // copy
    sanitizeSettings(standardDateProps, extendedSettings);
    standardDateProps.timeZone = 'UTC'; // we leverage the only guaranteed timeZone for our UTC markers
    var normalFormat = new Intl.DateTimeFormat(context.locale.codes, standardDateProps);
    var zeroFormat; // needed?
    if (extendedSettings.omitZeroMinute) {
        var zeroProps = tslib.__assign({}, standardDateProps);
        delete zeroProps.minute; // seconds and ms were already considered in sanitizeSettings
        zeroFormat = new Intl.DateTimeFormat(context.locale.codes, zeroProps);
    }
    return function (date) {
        var marker = date.marker;
        var format;
        if (zeroFormat && !marker.getUTCMinutes()) {
            format = zeroFormat;
        }
        else {
            format = normalFormat;
        }
        var s = format.format(marker);
        return postProcess(s, date, standardDateProps, extendedSettings, context);
    };
}
function sanitizeSettings(standardDateProps, extendedSettings) {
    // deal with a browser inconsistency where formatting the timezone
    // requires that the hour/minute be present.
    if (standardDateProps.timeZoneName) {
        if (!standardDateProps.hour) {
            standardDateProps.hour = '2-digit';
        }
        if (!standardDateProps.minute) {
            standardDateProps.minute = '2-digit';
        }
    }
    // only support short timezone names
    if (standardDateProps.timeZoneName === 'long') {
        standardDateProps.timeZoneName = 'short';
    }
    // if requesting to display seconds, MUST display minutes
    if (extendedSettings.omitZeroMinute && (standardDateProps.second || standardDateProps.millisecond)) {
        delete extendedSettings.omitZeroMinute;
    }
}
function postProcess(s, date, standardDateProps, extendedSettings, context) {
    s = s.replace(LTR_RE, ''); // remove left-to-right control chars. do first. good for other regexes
    if (standardDateProps.timeZoneName === 'short') {
        s = injectTzoStr(s, (context.timeZone === 'UTC' || date.timeZoneOffset == null) ?
            'UTC' : // important to normalize for IE, which does "GMT"
            formatTimeZoneOffset(date.timeZoneOffset));
    }
    if (extendedSettings.omitCommas) {
        s = s.replace(COMMA_RE, '').trim();
    }
    if (extendedSettings.omitZeroMinute) {
        s = s.replace(':00', ''); // zeroFormat doesn't always achieve this
    }
    // ^ do anything that might create adjacent spaces before this point,
    // because MERIDIEM_RE likes to eat up loading spaces
    if (extendedSettings.meridiem === false) {
        s = s.replace(MERIDIEM_RE, '').trim();
    }
    else if (extendedSettings.meridiem === 'narrow') { // a/p
        s = s.replace(MERIDIEM_RE, function (m0, m1) { return m1.toLocaleLowerCase(); });
    }
    else if (extendedSettings.meridiem === 'short') { // am/pm
        s = s.replace(MERIDIEM_RE, function (m0, m1) { return m1.toLocaleLowerCase() + "m"; });
    }
    else if (extendedSettings.meridiem === 'lowercase') { // other meridiem transformers already converted to lowercase
        s = s.replace(MERIDIEM_RE, function (m0) { return m0.toLocaleLowerCase(); });
    }
    s = s.replace(MULTI_SPACE_RE, ' ');
    s = s.trim();
    return s;
}
function injectTzoStr(s, tzoStr) {
    var replaced = false;
    s = s.replace(UTC_RE, function () {
        replaced = true;
        return tzoStr;
    });
    // IE11 doesn't include UTC/GMT in the original string, so append to end
    if (!replaced) {
        s += " " + tzoStr;
    }
    return s;
}
function formatWeekNumber(num, weekText, locale, display) {
    var parts = [];
    if (display === 'narrow') {
        parts.push(weekText);
    }
    else if (display === 'short') {
        parts.push(weekText, ' ');
    }
    // otherwise, considered 'numeric'
    parts.push(locale.simpleNumberFormat.format(num));
    if (locale.options.direction === 'rtl') { // TODO: use control characters instead?
        parts.reverse();
    }
    return parts.join('');
}
// Range Formatting Utils
// 0 = exactly the same
// 1 = different by time
// and bigger
function computeMarkerDiffSeverity(d0, d1, ca) {
    if (ca.getMarkerYear(d0) !== ca.getMarkerYear(d1)) {
        return 5;
    }
    if (ca.getMarkerMonth(d0) !== ca.getMarkerMonth(d1)) {
        return 4;
    }
    if (ca.getMarkerDay(d0) !== ca.getMarkerDay(d1)) {
        return 2;
    }
    if (timeAsMs(d0) !== timeAsMs(d1)) {
        return 1;
    }
    return 0;
}
function computePartialFormattingOptions(options, biggestUnit) {
    var partialOptions = {};
    for (var name_2 in options) {
        if (!(name_2 in STANDARD_DATE_PROP_SEVERITIES) || // not a date part prop (like timeZone)
            STANDARD_DATE_PROP_SEVERITIES[name_2] <= biggestUnit) {
            partialOptions[name_2] = options[name_2];
        }
    }
    return partialOptions;
}
function findCommonInsertion(full0, partial0, full1, partial1) {
    var i0 = 0;
    while (i0 < full0.length) {
        var found0 = full0.indexOf(partial0, i0);
        if (found0 === -1) {
            break;
        }
        var before0 = full0.substr(0, found0);
        i0 = found0 + partial0.length;
        var after0 = full0.substr(i0);
        var i1 = 0;
        while (i1 < full1.length) {
            var found1 = full1.indexOf(partial1, i1);
            if (found1 === -1) {
                break;
            }
            var before1 = full1.substr(0, found1);
            i1 = found1 + partial1.length;
            var after1 = full1.substr(i1);
            if (before0 === before1 && after0 === after1) {
                return {
                    before: before0,
                    after: after0,
                };
            }
        }
    }
    return null;
}

function expandZonedMarker(dateInfo, calendarSystem) {
    var a = calendarSystem.markerToArray(dateInfo.marker);
    return {
        marker: dateInfo.marker,
        timeZoneOffset: dateInfo.timeZoneOffset,
        array: a,
        year: a[0],
        month: a[1],
        day: a[2],
        hour: a[3],
        minute: a[4],
        second: a[5],
        millisecond: a[6],
    };
}

function createVerboseFormattingArg(start, end, context, betterDefaultSeparator) {
    var startInfo = expandZonedMarker(start, context.calendarSystem);
    var endInfo = end ? expandZonedMarker(end, context.calendarSystem) : null;
    return {
        date: startInfo,
        start: startInfo,
        end: endInfo,
        timeZone: context.timeZone,
        localeCodes: context.locale.codes,
        defaultSeparator: betterDefaultSeparator || context.defaultSeparator,
    };
}

/*
TODO: fix the terminology of "formatter" vs "formatting func"
*/
/*
At the time of instantiation, this object does not know which cmd-formatting system it will use.
It receives this at the time of formatting, as a setting.
*/
var CmdFormatter = /** @class */ (function () {
    function CmdFormatter(cmdStr) {
        this.cmdStr = cmdStr;
    }
    CmdFormatter.prototype.format = function (date, context, betterDefaultSeparator) {
        return context.cmdFormatter(this.cmdStr, createVerboseFormattingArg(date, null, context, betterDefaultSeparator));
    };
    CmdFormatter.prototype.formatRange = function (start, end, context, betterDefaultSeparator) {
        return context.cmdFormatter(this.cmdStr, createVerboseFormattingArg(start, end, context, betterDefaultSeparator));
    };
    return CmdFormatter;
}());

var FuncFormatter = /** @class */ (function () {
    function FuncFormatter(func) {
        this.func = func;
    }
    FuncFormatter.prototype.format = function (date, context, betterDefaultSeparator) {
        return this.func(createVerboseFormattingArg(date, null, context, betterDefaultSeparator));
    };
    FuncFormatter.prototype.formatRange = function (start, end, context, betterDefaultSeparator) {
        return this.func(createVerboseFormattingArg(start, end, context, betterDefaultSeparator));
    };
    return FuncFormatter;
}());

function createFormatter(input) {
    if (typeof input === 'object' && input) { // non-null object
        return new NativeFormatter(input);
    }
    if (typeof input === 'string') {
        return new CmdFormatter(input);
    }
    if (typeof input === 'function') {
        return new FuncFormatter(input);
    }
    return null;
}

// base options
// ------------
var BASE_OPTION_REFINERS = {
    navLinkDayClick: identity,
    navLinkWeekClick: identity,
    duration: createDuration,
    bootstrapFontAwesome: identity,
    buttonIcons: identity,
    customButtons: identity,
    defaultAllDayEventDuration: createDuration,
    defaultTimedEventDuration: createDuration,
    nextDayThreshold: createDuration,
    scrollTime: createDuration,
    scrollTimeReset: Boolean,
    slotMinTime: createDuration,
    slotMaxTime: createDuration,
    dayPopoverFormat: createFormatter,
    slotDuration: createDuration,
    snapDuration: createDuration,
    headerToolbar: identity,
    footerToolbar: identity,
    defaultRangeSeparator: String,
    titleRangeSeparator: String,
    forceEventDuration: Boolean,
    dayHeaders: Boolean,
    dayHeaderFormat: createFormatter,
    dayHeaderClassNames: identity,
    dayHeaderContent: identity,
    dayHeaderDidMount: identity,
    dayHeaderWillUnmount: identity,
    dayCellClassNames: identity,
    dayCellContent: identity,
    dayCellDidMount: identity,
    dayCellWillUnmount: identity,
    initialView: String,
    aspectRatio: Number,
    weekends: Boolean,
    weekNumberCalculation: identity,
    weekNumbers: Boolean,
    weekNumberClassNames: identity,
    weekNumberContent: identity,
    weekNumberDidMount: identity,
    weekNumberWillUnmount: identity,
    editable: Boolean,
    viewClassNames: identity,
    viewDidMount: identity,
    viewWillUnmount: identity,
    nowIndicator: Boolean,
    nowIndicatorClassNames: identity,
    nowIndicatorContent: identity,
    nowIndicatorDidMount: identity,
    nowIndicatorWillUnmount: identity,
    showNonCurrentDates: Boolean,
    lazyFetching: Boolean,
    startParam: String,
    endParam: String,
    timeZoneParam: String,
    timeZone: String,
    locales: identity,
    locale: identity,
    themeSystem: String,
    dragRevertDuration: Number,
    dragScroll: Boolean,
    allDayMaintainDuration: Boolean,
    unselectAuto: Boolean,
    dropAccept: identity,
    eventOrder: parseFieldSpecs,
    eventOrderStrict: Boolean,
    handleWindowResize: Boolean,
    windowResizeDelay: Number,
    longPressDelay: Number,
    eventDragMinDistance: Number,
    expandRows: Boolean,
    height: identity,
    contentHeight: identity,
    direction: String,
    weekNumberFormat: createFormatter,
    eventResizableFromStart: Boolean,
    displayEventTime: Boolean,
    displayEventEnd: Boolean,
    weekText: String,
    progressiveEventRendering: Boolean,
    businessHours: identity,
    initialDate: identity,
    now: identity,
    eventDataTransform: identity,
    stickyHeaderDates: identity,
    stickyFooterScrollbar: identity,
    viewHeight: identity,
    defaultAllDay: Boolean,
    eventSourceFailure: identity,
    eventSourceSuccess: identity,
    eventDisplay: String,
    eventStartEditable: Boolean,
    eventDurationEditable: Boolean,
    eventOverlap: identity,
    eventConstraint: identity,
    eventAllow: identity,
    eventBackgroundColor: String,
    eventBorderColor: String,
    eventTextColor: String,
    eventColor: String,
    eventClassNames: identity,
    eventContent: identity,
    eventDidMount: identity,
    eventWillUnmount: identity,
    selectConstraint: identity,
    selectOverlap: identity,
    selectAllow: identity,
    droppable: Boolean,
    unselectCancel: String,
    slotLabelFormat: identity,
    slotLaneClassNames: identity,
    slotLaneContent: identity,
    slotLaneDidMount: identity,
    slotLaneWillUnmount: identity,
    slotLabelClassNames: identity,
    slotLabelContent: identity,
    slotLabelDidMount: identity,
    slotLabelWillUnmount: identity,
    dayMaxEvents: identity,
    dayMaxEventRows: identity,
    dayMinWidth: Number,
    slotLabelInterval: createDuration,
    allDayText: String,
    allDayClassNames: identity,
    allDayContent: identity,
    allDayDidMount: identity,
    allDayWillUnmount: identity,
    slotMinWidth: Number,
    navLinks: Boolean,
    eventTimeFormat: createFormatter,
    rerenderDelay: Number,
    moreLinkText: identity,
    selectMinDistance: Number,
    selectable: Boolean,
    selectLongPressDelay: Number,
    eventLongPressDelay: Number,
    selectMirror: Boolean,
    eventMaxStack: Number,
    eventMinHeight: Number,
    eventMinWidth: Number,
    eventShortHeight: Number,
    slotEventOverlap: Boolean,
    plugins: identity,
    firstDay: Number,
    dayCount: Number,
    dateAlignment: String,
    dateIncrement: createDuration,
    hiddenDays: identity,
    monthMode: Boolean,
    fixedWeekCount: Boolean,
    validRange: identity,
    visibleRange: identity,
    titleFormat: identity,
    // only used by list-view, but languages define the value, so we need it in base options
    noEventsText: String,
    moreLinkClick: identity,
    moreLinkClassNames: identity,
    moreLinkContent: identity,
    moreLinkDidMount: identity,
    moreLinkWillUnmount: identity,
};
// do NOT give a type here. need `typeof BASE_OPTION_DEFAULTS` to give real results.
// raw values.
var BASE_OPTION_DEFAULTS = {
    eventDisplay: 'auto',
    defaultRangeSeparator: ' - ',
    titleRangeSeparator: ' \u2013 ',
    defaultTimedEventDuration: '01:00:00',
    defaultAllDayEventDuration: { day: 1 },
    forceEventDuration: false,
    nextDayThreshold: '00:00:00',
    dayHeaders: true,
    initialView: '',
    aspectRatio: 1.35,
    headerToolbar: {
        start: 'title',
        center: '',
        end: 'today prev,next',
    },
    weekends: true,
    weekNumbers: false,
    weekNumberCalculation: 'local',
    editable: false,
    nowIndicator: false,
    scrollTime: '06:00:00',
    scrollTimeReset: true,
    slotMinTime: '00:00:00',
    slotMaxTime: '24:00:00',
    showNonCurrentDates: true,
    lazyFetching: true,
    startParam: 'start',
    endParam: 'end',
    timeZoneParam: 'timeZone',
    timeZone: 'local',
    locales: [],
    locale: '',
    themeSystem: 'standard',
    dragRevertDuration: 500,
    dragScroll: true,
    allDayMaintainDuration: false,
    unselectAuto: true,
    dropAccept: '*',
    eventOrder: 'start,-duration,allDay,title',
    dayPopoverFormat: { month: 'long', day: 'numeric', year: 'numeric' },
    handleWindowResize: true,
    windowResizeDelay: 100,
    longPressDelay: 1000,
    eventDragMinDistance: 5,
    expandRows: false,
    navLinks: false,
    selectable: false,
    eventMinHeight: 15,
    eventMinWidth: 30,
    eventShortHeight: 30,
};
// calendar listeners
// ------------------
var CALENDAR_LISTENER_REFINERS = {
    datesSet: identity,
    eventsSet: identity,
    eventAdd: identity,
    eventChange: identity,
    eventRemove: identity,
    windowResize: identity,
    eventClick: identity,
    eventMouseEnter: identity,
    eventMouseLeave: identity,
    select: identity,
    unselect: identity,
    loading: identity,
    // internal
    _unmount: identity,
    _beforeprint: identity,
    _afterprint: identity,
    _noEventDrop: identity,
    _noEventResize: identity,
    _resize: identity,
    _scrollRequest: identity,
};
// calendar-specific options
// -------------------------
var CALENDAR_OPTION_REFINERS = {
    buttonText: identity,
    views: identity,
    plugins: identity,
    initialEvents: identity,
    events: identity,
    eventSources: identity,
};
var COMPLEX_OPTION_COMPARATORS = {
    headerToolbar: isBoolComplexEqual,
    footerToolbar: isBoolComplexEqual,
    buttonText: isBoolComplexEqual,
    buttonIcons: isBoolComplexEqual,
};
function isBoolComplexEqual(a, b) {
    if (typeof a === 'object' && typeof b === 'object' && a && b) { // both non-null objects
        return isPropsEqual(a, b);
    }
    return a === b;
}
// view-specific options
// ---------------------
var VIEW_OPTION_REFINERS = {
    type: String,
    component: identity,
    buttonText: String,
    buttonTextKey: String,
    dateProfileGeneratorClass: identity,
    usesMinMaxTime: Boolean,
    classNames: identity,
    content: identity,
    didMount: identity,
    willUnmount: identity,
};
// util funcs
// ----------------------------------------------------------------------------------------------------
function mergeRawOptions(optionSets) {
    return mergeProps(optionSets, COMPLEX_OPTION_COMPARATORS);
}
function refineProps(input, refiners) {
    var refined = {};
    var extra = {};
    for (var propName in refiners) {
        if (propName in input) {
            refined[propName] = refiners[propName](input[propName]);
        }
    }
    for (var propName in input) {
        if (!(propName in refiners)) {
            extra[propName] = input[propName];
        }
    }
    return { refined: refined, extra: extra };
}
function identity(raw) {
    return raw;
}

function parseEvents(rawEvents, eventSource, context, allowOpenRange) {
    var eventStore = createEmptyEventStore();
    var eventRefiners = buildEventRefiners(context);
    for (var _i = 0, rawEvents_1 = rawEvents; _i < rawEvents_1.length; _i++) {
        var rawEvent = rawEvents_1[_i];
        var tuple = parseEvent(rawEvent, eventSource, context, allowOpenRange, eventRefiners);
        if (tuple) {
            eventTupleToStore(tuple, eventStore);
        }
    }
    return eventStore;
}
function eventTupleToStore(tuple, eventStore) {
    if (eventStore === void 0) { eventStore = createEmptyEventStore(); }
    eventStore.defs[tuple.def.defId] = tuple.def;
    if (tuple.instance) {
        eventStore.instances[tuple.instance.instanceId] = tuple.instance;
    }
    return eventStore;
}
// retrieves events that have the same groupId as the instance specified by `instanceId`
// or they are the same as the instance.
// why might instanceId not be in the store? an event from another calendar?
function getRelevantEvents(eventStore, instanceId) {
    var instance = eventStore.instances[instanceId];
    if (instance) {
        var def_1 = eventStore.defs[instance.defId];
        // get events/instances with same group
        var newStore = filterEventStoreDefs(eventStore, function (lookDef) { return isEventDefsGrouped(def_1, lookDef); });
        // add the original
        // TODO: wish we could use eventTupleToStore or something like it
        newStore.defs[def_1.defId] = def_1;
        newStore.instances[instance.instanceId] = instance;
        return newStore;
    }
    return createEmptyEventStore();
}
function isEventDefsGrouped(def0, def1) {
    return Boolean(def0.groupId && def0.groupId === def1.groupId);
}
function createEmptyEventStore() {
    return { defs: {}, instances: {} };
}
function mergeEventStores(store0, store1) {
    return {
        defs: tslib.__assign(tslib.__assign({}, store0.defs), store1.defs),
        instances: tslib.__assign(tslib.__assign({}, store0.instances), store1.instances),
    };
}
function filterEventStoreDefs(eventStore, filterFunc) {
    var defs = filterHash(eventStore.defs, filterFunc);
    var instances = filterHash(eventStore.instances, function (instance) { return (defs[instance.defId] // still exists?
    ); });
    return { defs: defs, instances: instances };
}
function excludeSubEventStore(master, sub) {
    var defs = master.defs, instances = master.instances;
    var filteredDefs = {};
    var filteredInstances = {};
    for (var defId in defs) {
        if (!sub.defs[defId]) { // not explicitly excluded
            filteredDefs[defId] = defs[defId];
        }
    }
    for (var instanceId in instances) {
        if (!sub.instances[instanceId] && // not explicitly excluded
            filteredDefs[instances[instanceId].defId] // def wasn't filtered away
        ) {
            filteredInstances[instanceId] = instances[instanceId];
        }
    }
    return {
        defs: filteredDefs,
        instances: filteredInstances,
    };
}

function normalizeConstraint(input, context) {
    if (Array.isArray(input)) {
        return parseEvents(input, null, context, true); // allowOpenRange=true
    }
    if (typeof input === 'object' && input) { // non-null object
        return parseEvents([input], null, context, true); // allowOpenRange=true
    }
    if (input != null) {
        return String(input);
    }
    return null;
}

function parseClassNames(raw) {
    if (Array.isArray(raw)) {
        return raw;
    }
    if (typeof raw === 'string') {
        return raw.split(/\s+/);
    }
    return [];
}

// TODO: better called "EventSettings" or "EventConfig"
// TODO: move this file into structs
// TODO: separate constraint/overlap/allow, because selection uses only that, not other props
var EVENT_UI_REFINERS = {
    display: String,
    editable: Boolean,
    startEditable: Boolean,
    durationEditable: Boolean,
    constraint: identity,
    overlap: identity,
    allow: identity,
    className: parseClassNames,
    classNames: parseClassNames,
    color: String,
    backgroundColor: String,
    borderColor: String,
    textColor: String,
};
var EMPTY_EVENT_UI = {
    display: null,
    startEditable: null,
    durationEditable: null,
    constraints: [],
    overlap: null,
    allows: [],
    backgroundColor: '',
    borderColor: '',
    textColor: '',
    classNames: [],
};
function createEventUi(refined, context) {
    var constraint = normalizeConstraint(refined.constraint, context);
    return {
        display: refined.display || null,
        startEditable: refined.startEditable != null ? refined.startEditable : refined.editable,
        durationEditable: refined.durationEditable != null ? refined.durationEditable : refined.editable,
        constraints: constraint != null ? [constraint] : [],
        overlap: refined.overlap != null ? refined.overlap : null,
        allows: refined.allow != null ? [refined.allow] : [],
        backgroundColor: refined.backgroundColor || refined.color || '',
        borderColor: refined.borderColor || refined.color || '',
        textColor: refined.textColor || '',
        classNames: (refined.className || []).concat(refined.classNames || []), // join singular and plural
    };
}
// TODO: prevent against problems with <2 args!
function combineEventUis(uis) {
    return uis.reduce(combineTwoEventUis, EMPTY_EVENT_UI);
}
function combineTwoEventUis(item0, item1) {
    return {
        display: item1.display != null ? item1.display : item0.display,
        startEditable: item1.startEditable != null ? item1.startEditable : item0.startEditable,
        durationEditable: item1.durationEditable != null ? item1.durationEditable : item0.durationEditable,
        constraints: item0.constraints.concat(item1.constraints),
        overlap: typeof item1.overlap === 'boolean' ? item1.overlap : item0.overlap,
        allows: item0.allows.concat(item1.allows),
        backgroundColor: item1.backgroundColor || item0.backgroundColor,
        borderColor: item1.borderColor || item0.borderColor,
        textColor: item1.textColor || item0.textColor,
        classNames: item0.classNames.concat(item1.classNames),
    };
}

var EVENT_NON_DATE_REFINERS = {
    id: String,
    groupId: String,
    title: String,
    url: String,
};
var EVENT_DATE_REFINERS = {
    start: identity,
    end: identity,
    date: identity,
    allDay: Boolean,
};
var EVENT_REFINERS = tslib.__assign(tslib.__assign(tslib.__assign({}, EVENT_NON_DATE_REFINERS), EVENT_DATE_REFINERS), { extendedProps: identity });
function parseEvent(raw, eventSource, context, allowOpenRange, refiners) {
    if (refiners === void 0) { refiners = buildEventRefiners(context); }
    var _a = refineEventDef(raw, context, refiners), refined = _a.refined, extra = _a.extra;
    var defaultAllDay = computeIsDefaultAllDay(eventSource, context);
    var recurringRes = parseRecurring(refined, defaultAllDay, context.dateEnv, context.pluginHooks.recurringTypes);
    if (recurringRes) {
        var def = parseEventDef(refined, extra, eventSource ? eventSource.sourceId : '', recurringRes.allDay, Boolean(recurringRes.duration), context);
        def.recurringDef = {
            typeId: recurringRes.typeId,
            typeData: recurringRes.typeData,
            duration: recurringRes.duration,
        };
        return { def: def, instance: null };
    }
    var singleRes = parseSingle(refined, defaultAllDay, context, allowOpenRange);
    if (singleRes) {
        var def = parseEventDef(refined, extra, eventSource ? eventSource.sourceId : '', singleRes.allDay, singleRes.hasEnd, context);
        var instance = createEventInstance(def.defId, singleRes.range, singleRes.forcedStartTzo, singleRes.forcedEndTzo);
        return { def: def, instance: instance };
    }
    return null;
}
function refineEventDef(raw, context, refiners) {
    if (refiners === void 0) { refiners = buildEventRefiners(context); }
    return refineProps(raw, refiners);
}
function buildEventRefiners(context) {
    return tslib.__assign(tslib.__assign(tslib.__assign({}, EVENT_UI_REFINERS), EVENT_REFINERS), context.pluginHooks.eventRefiners);
}
/*
Will NOT populate extendedProps with the leftover properties.
Will NOT populate date-related props.
*/
function parseEventDef(refined, extra, sourceId, allDay, hasEnd, context) {
    var def = {
        title: refined.title || '',
        groupId: refined.groupId || '',
        publicId: refined.id || '',
        url: refined.url || '',
        recurringDef: null,
        defId: guid(),
        sourceId: sourceId,
        allDay: allDay,
        hasEnd: hasEnd,
        ui: createEventUi(refined, context),
        extendedProps: tslib.__assign(tslib.__assign({}, (refined.extendedProps || {})), extra),
    };
    for (var _i = 0, _a = context.pluginHooks.eventDefMemberAdders; _i < _a.length; _i++) {
        var memberAdder = _a[_i];
        tslib.__assign(def, memberAdder(refined));
    }
    // help out EventApi from having user modify props
    Object.freeze(def.ui.classNames);
    Object.freeze(def.extendedProps);
    return def;
}
function parseSingle(refined, defaultAllDay, context, allowOpenRange) {
    var allDay = refined.allDay;
    var startMeta;
    var startMarker = null;
    var hasEnd = false;
    var endMeta;
    var endMarker = null;
    var startInput = refined.start != null ? refined.start : refined.date;
    startMeta = context.dateEnv.createMarkerMeta(startInput);
    if (startMeta) {
        startMarker = startMeta.marker;
    }
    else if (!allowOpenRange) {
        return null;
    }
    if (refined.end != null) {
        endMeta = context.dateEnv.createMarkerMeta(refined.end);
    }
    if (allDay == null) {
        if (defaultAllDay != null) {
            allDay = defaultAllDay;
        }
        else {
            // fall back to the date props LAST
            allDay = (!startMeta || startMeta.isTimeUnspecified) &&
                (!endMeta || endMeta.isTimeUnspecified);
        }
    }
    if (allDay && startMarker) {
        startMarker = startOfDay(startMarker);
    }
    if (endMeta) {
        endMarker = endMeta.marker;
        if (allDay) {
            endMarker = startOfDay(endMarker);
        }
        if (startMarker && endMarker <= startMarker) {
            endMarker = null;
        }
    }
    if (endMarker) {
        hasEnd = true;
    }
    else if (!allowOpenRange) {
        hasEnd = context.options.forceEventDuration || false;
        endMarker = context.dateEnv.add(startMarker, allDay ?
            context.options.defaultAllDayEventDuration :
            context.options.defaultTimedEventDuration);
    }
    return {
        allDay: allDay,
        hasEnd: hasEnd,
        range: { start: startMarker, end: endMarker },
        forcedStartTzo: startMeta ? startMeta.forcedTzo : null,
        forcedEndTzo: endMeta ? endMeta.forcedTzo : null,
    };
}
function computeIsDefaultAllDay(eventSource, context) {
    var res = null;
    if (eventSource) {
        res = eventSource.defaultAllDay;
    }
    if (res == null) {
        res = context.options.defaultAllDay;
    }
    return res;
}

/* Date stuff that doesn't belong in datelib core
----------------------------------------------------------------------------------------------------------------------*/
// given a timed range, computes an all-day range that has the same exact duration,
// but whose start time is aligned with the start of the day.
function computeAlignedDayRange(timedRange) {
    var dayCnt = Math.floor(diffDays(timedRange.start, timedRange.end)) || 1;
    var start = startOfDay(timedRange.start);
    var end = addDays(start, dayCnt);
    return { start: start, end: end };
}
// given a timed range, computes an all-day range based on how for the end date bleeds into the next day
// TODO: give nextDayThreshold a default arg
function computeVisibleDayRange(timedRange, nextDayThreshold) {
    if (nextDayThreshold === void 0) { nextDayThreshold = createDuration(0); }
    var startDay = null;
    var endDay = null;
    if (timedRange.end) {
        endDay = startOfDay(timedRange.end);
        var endTimeMS = timedRange.end.valueOf() - endDay.valueOf(); // # of milliseconds into `endDay`
        // If the end time is actually inclusively part of the next day and is equal to or
        // beyond the next day threshold, adjust the end to be the exclusive end of `endDay`.
        // Otherwise, leaving it as inclusive will cause it to exclude `endDay`.
        if (endTimeMS && endTimeMS >= asRoughMs(nextDayThreshold)) {
            endDay = addDays(endDay, 1);
        }
    }
    if (timedRange.start) {
        startDay = startOfDay(timedRange.start); // the beginning of the day the range starts
        // If end is within `startDay` but not past nextDayThreshold, assign the default duration of one day.
        if (endDay && endDay <= startDay) {
            endDay = addDays(startDay, 1);
        }
    }
    return { start: startDay, end: endDay };
}
// spans from one day into another?
function isMultiDayRange(range) {
    var visibleRange = computeVisibleDayRange(range);
    return diffDays(visibleRange.start, visibleRange.end) > 1;
}
function diffDates(date0, date1, dateEnv, largeUnit) {
    if (largeUnit === 'year') {
        return createDuration(dateEnv.diffWholeYears(date0, date1), 'year');
    }
    if (largeUnit === 'month') {
        return createDuration(dateEnv.diffWholeMonths(date0, date1), 'month');
    }
    return diffDayAndTime(date0, date1); // returns a duration
}

function parseRange(input, dateEnv) {
    var start = null;
    var end = null;
    if (input.start) {
        start = dateEnv.createMarker(input.start);
    }
    if (input.end) {
        end = dateEnv.createMarker(input.end);
    }
    if (!start && !end) {
        return null;
    }
    if (start && end && end < start) {
        return null;
    }
    return { start: start, end: end };
}
// SIDE-EFFECT: will mutate ranges.
// Will return a new array result.
function invertRanges(ranges, constraintRange) {
    var invertedRanges = [];
    var start = constraintRange.start; // the end of the previous range. the start of the new range
    var i;
    var dateRange;
    // ranges need to be in order. required for our date-walking algorithm
    ranges.sort(compareRanges);
    for (i = 0; i < ranges.length; i += 1) {
        dateRange = ranges[i];
        // add the span of time before the event (if there is any)
        if (dateRange.start > start) { // compare millisecond time (skip any ambig logic)
            invertedRanges.push({ start: start, end: dateRange.start });
        }
        if (dateRange.end > start) {
            start = dateRange.end;
        }
    }
    // add the span of time after the last event (if there is any)
    if (start < constraintRange.end) { // compare millisecond time (skip any ambig logic)
        invertedRanges.push({ start: start, end: constraintRange.end });
    }
    return invertedRanges;
}
function compareRanges(range0, range1) {
    return range0.start.valueOf() - range1.start.valueOf(); // earlier ranges go first
}
function intersectRanges(range0, range1) {
    var start = range0.start, end = range0.end;
    var newRange = null;
    if (range1.start !== null) {
        if (start === null) {
            start = range1.start;
        }
        else {
            start = new Date(Math.max(start.valueOf(), range1.start.valueOf()));
        }
    }
    if (range1.end != null) {
        if (end === null) {
            end = range1.end;
        }
        else {
            end = new Date(Math.min(end.valueOf(), range1.end.valueOf()));
        }
    }
    if (start === null || end === null || start < end) {
        newRange = { start: start, end: end };
    }
    return newRange;
}
function rangesEqual(range0, range1) {
    return (range0.start === null ? null : range0.start.valueOf()) === (range1.start === null ? null : range1.start.valueOf()) &&
        (range0.end === null ? null : range0.end.valueOf()) === (range1.end === null ? null : range1.end.valueOf());
}
function rangesIntersect(range0, range1) {
    return (range0.end === null || range1.start === null || range0.end > range1.start) &&
        (range0.start === null || range1.end === null || range0.start < range1.end);
}
function rangeContainsRange(outerRange, innerRange) {
    return (outerRange.start === null || (innerRange.start !== null && innerRange.start >= outerRange.start)) &&
        (outerRange.end === null || (innerRange.end !== null && innerRange.end <= outerRange.end));
}
function rangeContainsMarker(range, date) {
    return (range.start === null || date >= range.start) &&
        (range.end === null || date < range.end);
}
// If the given date is not within the given range, move it inside.
// (If it's past the end, make it one millisecond before the end).
function constrainMarkerToRange(date, range) {
    if (range.start != null && date < range.start) {
        return range.start;
    }
    if (range.end != null && date >= range.end) {
        return new Date(range.end.valueOf() - 1);
    }
    return date;
}

/*
Specifying nextDayThreshold signals that all-day ranges should be sliced.
*/
function sliceEventStore(eventStore, eventUiBases, framingRange, nextDayThreshold) {
    var inverseBgByGroupId = {};
    var inverseBgByDefId = {};
    var defByGroupId = {};
    var bgRanges = [];
    var fgRanges = [];
    var eventUis = compileEventUis(eventStore.defs, eventUiBases);
    for (var defId in eventStore.defs) {
        var def = eventStore.defs[defId];
        var ui = eventUis[def.defId];
        if (ui.display === 'inverse-background') {
            if (def.groupId) {
                inverseBgByGroupId[def.groupId] = [];
                if (!defByGroupId[def.groupId]) {
                    defByGroupId[def.groupId] = def;
                }
            }
            else {
                inverseBgByDefId[defId] = [];
            }
        }
    }
    for (var instanceId in eventStore.instances) {
        var instance = eventStore.instances[instanceId];
        var def = eventStore.defs[instance.defId];
        var ui = eventUis[def.defId];
        var origRange = instance.range;
        var normalRange = (!def.allDay && nextDayThreshold) ?
            computeVisibleDayRange(origRange, nextDayThreshold) :
            origRange;
        var slicedRange = intersectRanges(normalRange, framingRange);
        if (slicedRange) {
            if (ui.display === 'inverse-background') {
                if (def.groupId) {
                    inverseBgByGroupId[def.groupId].push(slicedRange);
                }
                else {
                    inverseBgByDefId[instance.defId].push(slicedRange);
                }
            }
            else if (ui.display !== 'none') {
                (ui.display === 'background' ? bgRanges : fgRanges).push({
                    def: def,
                    ui: ui,
                    instance: instance,
                    range: slicedRange,
                    isStart: normalRange.start && normalRange.start.valueOf() === slicedRange.start.valueOf(),
                    isEnd: normalRange.end && normalRange.end.valueOf() === slicedRange.end.valueOf(),
                });
            }
        }
    }
    for (var groupId in inverseBgByGroupId) { // BY GROUP
        var ranges = inverseBgByGroupId[groupId];
        var invertedRanges = invertRanges(ranges, framingRange);
        for (var _i = 0, invertedRanges_1 = invertedRanges; _i < invertedRanges_1.length; _i++) {
            var invertedRange = invertedRanges_1[_i];
            var def = defByGroupId[groupId];
            var ui = eventUis[def.defId];
            bgRanges.push({
                def: def,
                ui: ui,
                instance: null,
                range: invertedRange,
                isStart: false,
                isEnd: false,
            });
        }
    }
    for (var defId in inverseBgByDefId) {
        var ranges = inverseBgByDefId[defId];
        var invertedRanges = invertRanges(ranges, framingRange);
        for (var _a = 0, invertedRanges_2 = invertedRanges; _a < invertedRanges_2.length; _a++) {
            var invertedRange = invertedRanges_2[_a];
            bgRanges.push({
                def: eventStore.defs[defId],
                ui: eventUis[defId],
                instance: null,
                range: invertedRange,
                isStart: false,
                isEnd: false,
            });
        }
    }
    return { bg: bgRanges, fg: fgRanges };
}
function hasBgRendering(def) {
    return def.ui.display === 'background' || def.ui.display === 'inverse-background';
}
function setElSeg(el, seg) {
    el.fcSeg = seg;
}
function getElSeg(el) {
    return el.fcSeg ||
        el.parentNode.fcSeg || // for the harness
        null;
}
// event ui computation
function compileEventUis(eventDefs, eventUiBases) {
    return mapHash(eventDefs, function (eventDef) { return compileEventUi(eventDef, eventUiBases); });
}
function compileEventUi(eventDef, eventUiBases) {
    var uis = [];
    if (eventUiBases['']) {
        uis.push(eventUiBases['']);
    }
    if (eventUiBases[eventDef.defId]) {
        uis.push(eventUiBases[eventDef.defId]);
    }
    uis.push(eventDef.ui);
    return combineEventUis(uis);
}
function sortEventSegs(segs, eventOrderSpecs) {
    var objs = segs.map(buildSegCompareObj);
    objs.sort(function (obj0, obj1) { return compareByFieldSpecs(obj0, obj1, eventOrderSpecs); });
    return objs.map(function (c) { return c._seg; });
}
// returns a object with all primitive props that can be compared
function buildSegCompareObj(seg) {
    var eventRange = seg.eventRange;
    var eventDef = eventRange.def;
    var range = eventRange.instance ? eventRange.instance.range : eventRange.range;
    var start = range.start ? range.start.valueOf() : 0; // TODO: better support for open-range events
    var end = range.end ? range.end.valueOf() : 0; // "
    return tslib.__assign(tslib.__assign(tslib.__assign({}, eventDef.extendedProps), eventDef), { id: eventDef.publicId, start: start,
        end: end, duration: end - start, allDay: Number(eventDef.allDay), _seg: seg });
}
function computeSegDraggable(seg, context) {
    var pluginHooks = context.pluginHooks;
    var transformers = pluginHooks.isDraggableTransformers;
    var _a = seg.eventRange, def = _a.def, ui = _a.ui;
    var val = ui.startEditable;
    for (var _i = 0, transformers_1 = transformers; _i < transformers_1.length; _i++) {
        var transformer = transformers_1[_i];
        val = transformer(val, def, ui, context);
    }
    return val;
}
function computeSegStartResizable(seg, context) {
    return seg.isStart && seg.eventRange.ui.durationEditable && context.options.eventResizableFromStart;
}
function computeSegEndResizable(seg, context) {
    return seg.isEnd && seg.eventRange.ui.durationEditable;
}
function buildSegTimeText(seg, timeFormat, context, defaultDisplayEventTime, // defaults to true
defaultDisplayEventEnd, // defaults to true
startOverride, endOverride) {
    var dateEnv = context.dateEnv, options = context.options;
    var displayEventTime = options.displayEventTime, displayEventEnd = options.displayEventEnd;
    var eventDef = seg.eventRange.def;
    var eventInstance = seg.eventRange.instance;
    if (displayEventTime == null) {
        displayEventTime = defaultDisplayEventTime !== false;
    }
    if (displayEventEnd == null) {
        displayEventEnd = defaultDisplayEventEnd !== false;
    }
    var wholeEventStart = eventInstance.range.start;
    var wholeEventEnd = eventInstance.range.end;
    var segStart = startOverride || seg.start || seg.eventRange.range.start;
    var segEnd = endOverride || seg.end || seg.eventRange.range.end;
    var isStartDay = startOfDay(wholeEventStart).valueOf() === startOfDay(segStart).valueOf();
    var isEndDay = startOfDay(addMs(wholeEventEnd, -1)).valueOf() === startOfDay(addMs(segEnd, -1)).valueOf();
    if (displayEventTime && !eventDef.allDay && (isStartDay || isEndDay)) {
        segStart = isStartDay ? wholeEventStart : segStart;
        segEnd = isEndDay ? wholeEventEnd : segEnd;
        if (displayEventEnd && eventDef.hasEnd) {
            return dateEnv.formatRange(segStart, segEnd, timeFormat, {
                forcedStartTzo: startOverride ? null : eventInstance.forcedStartTzo,
                forcedEndTzo: endOverride ? null : eventInstance.forcedEndTzo,
            });
        }
        return dateEnv.format(segStart, timeFormat, {
            forcedTzo: startOverride ? null : eventInstance.forcedStartTzo, // nooooo, same
        });
    }
    return '';
}
function getSegMeta(seg, todayRange, nowDate) {
    var segRange = seg.eventRange.range;
    return {
        isPast: segRange.end < (nowDate || todayRange.start),
        isFuture: segRange.start >= (nowDate || todayRange.end),
        isToday: todayRange && rangeContainsMarker(todayRange, segRange.start),
    };
}
function getEventClassNames(props) {
    var classNames = ['fc-event'];
    if (props.isMirror) {
        classNames.push('fc-event-mirror');
    }
    if (props.isDraggable) {
        classNames.push('fc-event-draggable');
    }
    if (props.isStartResizable || props.isEndResizable) {
        classNames.push('fc-event-resizable');
    }
    if (props.isDragging) {
        classNames.push('fc-event-dragging');
    }
    if (props.isResizing) {
        classNames.push('fc-event-resizing');
    }
    if (props.isSelected) {
        classNames.push('fc-event-selected');
    }
    if (props.isStart) {
        classNames.push('fc-event-start');
    }
    if (props.isEnd) {
        classNames.push('fc-event-end');
    }
    if (props.isPast) {
        classNames.push('fc-event-past');
    }
    if (props.isToday) {
        classNames.push('fc-event-today');
    }
    if (props.isFuture) {
        classNames.push('fc-event-future');
    }
    return classNames;
}
function buildEventRangeKey(eventRange) {
    return eventRange.instance
        ? eventRange.instance.instanceId
        : eventRange.def.defId + ":" + eventRange.range.start.toISOString();
    // inverse-background events don't have specific instances. TODO: better solution
}

var STANDARD_PROPS = {
    start: identity,
    end: identity,
    allDay: Boolean,
};
function parseDateSpan(raw, dateEnv, defaultDuration) {
    var span = parseOpenDateSpan(raw, dateEnv);
    var range = span.range;
    if (!range.start) {
        return null;
    }
    if (!range.end) {
        if (defaultDuration == null) {
            return null;
        }
        range.end = dateEnv.add(range.start, defaultDuration);
    }
    return span;
}
/*
TODO: somehow combine with parseRange?
Will return null if the start/end props were present but parsed invalidly.
*/
function parseOpenDateSpan(raw, dateEnv) {
    var _a = refineProps(raw, STANDARD_PROPS), standardProps = _a.refined, extra = _a.extra;
    var startMeta = standardProps.start ? dateEnv.createMarkerMeta(standardProps.start) : null;
    var endMeta = standardProps.end ? dateEnv.createMarkerMeta(standardProps.end) : null;
    var allDay = standardProps.allDay;
    if (allDay == null) {
        allDay = (startMeta && startMeta.isTimeUnspecified) &&
            (!endMeta || endMeta.isTimeUnspecified);
    }
    return tslib.__assign({ range: {
            start: startMeta ? startMeta.marker : null,
            end: endMeta ? endMeta.marker : null,
        }, allDay: allDay }, extra);
}
function isDateSpansEqual(span0, span1) {
    return rangesEqual(span0.range, span1.range) &&
        span0.allDay === span1.allDay &&
        isSpanPropsEqual(span0, span1);
}
// the NON-DATE-RELATED props
function isSpanPropsEqual(span0, span1) {
    for (var propName in span1) {
        if (propName !== 'range' && propName !== 'allDay') {
            if (span0[propName] !== span1[propName]) {
                return false;
            }
        }
    }
    // are there any props that span0 has that span1 DOESN'T have?
    // both have range/allDay, so no need to special-case.
    for (var propName in span0) {
        if (!(propName in span1)) {
            return false;
        }
    }
    return true;
}
function buildDateSpanApi(span, dateEnv) {
    return tslib.__assign(tslib.__assign({}, buildRangeApi(span.range, dateEnv, span.allDay)), { allDay: span.allDay });
}
function buildRangeApiWithTimeZone(range, dateEnv, omitTime) {
    return tslib.__assign(tslib.__assign({}, buildRangeApi(range, dateEnv, omitTime)), { timeZone: dateEnv.timeZone });
}
function buildRangeApi(range, dateEnv, omitTime) {
    return {
        start: dateEnv.toDate(range.start),
        end: dateEnv.toDate(range.end),
        startStr: dateEnv.formatIso(range.start, { omitTime: omitTime }),
        endStr: dateEnv.formatIso(range.end, { omitTime: omitTime }),
    };
}
function fabricateEventRange(dateSpan, eventUiBases, context) {
    var res = refineEventDef({ editable: false }, context);
    var def = parseEventDef(res.refined, res.extra, '', // sourceId
    dateSpan.allDay, true, // hasEnd
    context);
    return {
        def: def,
        ui: compileEventUi(def, eventUiBases),
        instance: createEventInstance(def.defId, dateSpan.range),
        range: dateSpan.range,
        isStart: true,
        isEnd: true,
    };
}

function triggerDateSelect(selection, pev, context) {
    context.emitter.trigger('select', tslib.__assign(tslib.__assign({}, buildDateSpanApiWithContext(selection, context)), { jsEvent: pev ? pev.origEvent : null, view: context.viewApi || context.calendarApi.view }));
}
function triggerDateUnselect(pev, context) {
    context.emitter.trigger('unselect', {
        jsEvent: pev ? pev.origEvent : null,
        view: context.viewApi || context.calendarApi.view,
    });
}
function buildDateSpanApiWithContext(dateSpan, context) {
    var props = {};
    for (var _i = 0, _a = context.pluginHooks.dateSpanTransforms; _i < _a.length; _i++) {
        var transform = _a[_i];
        tslib.__assign(props, transform(dateSpan, context));
    }
    tslib.__assign(props, buildDateSpanApi(dateSpan, context.dateEnv));
    return props;
}
// Given an event's allDay status and start date, return what its fallback end date should be.
// TODO: rename to computeDefaultEventEnd
function getDefaultEventEnd(allDay, marker, context) {
    var dateEnv = context.dateEnv, options = context.options;
    var end = marker;
    if (allDay) {
        end = startOfDay(end);
        end = dateEnv.add(end, options.defaultAllDayEventDuration);
    }
    else {
        end = dateEnv.add(end, options.defaultTimedEventDuration);
    }
    return end;
}

// applies the mutation to ALL defs/instances within the event store
function applyMutationToEventStore(eventStore, eventConfigBase, mutation, context) {
    var eventConfigs = compileEventUis(eventStore.defs, eventConfigBase);
    var dest = createEmptyEventStore();
    for (var defId in eventStore.defs) {
        var def = eventStore.defs[defId];
        dest.defs[defId] = applyMutationToEventDef(def, eventConfigs[defId], mutation, context);
    }
    for (var instanceId in eventStore.instances) {
        var instance = eventStore.instances[instanceId];
        var def = dest.defs[instance.defId]; // important to grab the newly modified def
        dest.instances[instanceId] = applyMutationToEventInstance(instance, def, eventConfigs[instance.defId], mutation, context);
    }
    return dest;
}
function applyMutationToEventDef(eventDef, eventConfig, mutation, context) {
    var standardProps = mutation.standardProps || {};
    // if hasEnd has not been specified, guess a good value based on deltas.
    // if duration will change, there's no way the default duration will persist,
    // and thus, we need to mark the event as having a real end
    if (standardProps.hasEnd == null &&
        eventConfig.durationEditable &&
        (mutation.startDelta || mutation.endDelta)) {
        standardProps.hasEnd = true; // TODO: is this mutation okay?
    }
    var copy = tslib.__assign(tslib.__assign(tslib.__assign({}, eventDef), standardProps), { ui: tslib.__assign(tslib.__assign({}, eventDef.ui), standardProps.ui) });
    if (mutation.extendedProps) {
        copy.extendedProps = tslib.__assign(tslib.__assign({}, copy.extendedProps), mutation.extendedProps);
    }
    for (var _i = 0, _a = context.pluginHooks.eventDefMutationAppliers; _i < _a.length; _i++) {
        var applier = _a[_i];
        applier(copy, mutation, context);
    }
    if (!copy.hasEnd && context.options.forceEventDuration) {
        copy.hasEnd = true;
    }
    return copy;
}
function applyMutationToEventInstance(eventInstance, eventDef, // must first be modified by applyMutationToEventDef
eventConfig, mutation, context) {
    var dateEnv = context.dateEnv;
    var forceAllDay = mutation.standardProps && mutation.standardProps.allDay === true;
    var clearEnd = mutation.standardProps && mutation.standardProps.hasEnd === false;
    var copy = tslib.__assign({}, eventInstance);
    if (forceAllDay) {
        copy.range = computeAlignedDayRange(copy.range);
    }
    if (mutation.datesDelta && eventConfig.startEditable) {
        copy.range = {
            start: dateEnv.add(copy.range.start, mutation.datesDelta),
            end: dateEnv.add(copy.range.end, mutation.datesDelta),
        };
    }
    if (mutation.startDelta && eventConfig.durationEditable) {
        copy.range = {
            start: dateEnv.add(copy.range.start, mutation.startDelta),
            end: copy.range.end,
        };
    }
    if (mutation.endDelta && eventConfig.durationEditable) {
        copy.range = {
            start: copy.range.start,
            end: dateEnv.add(copy.range.end, mutation.endDelta),
        };
    }
    if (clearEnd) {
        copy.range = {
            start: copy.range.start,
            end: getDefaultEventEnd(eventDef.allDay, copy.range.start, context),
        };
    }
    // in case event was all-day but the supplied deltas were not
    // better util for this?
    if (eventDef.allDay) {
        copy.range = {
            start: startOfDay(copy.range.start),
            end: startOfDay(copy.range.end),
        };
    }
    // handle invalid durations
    if (copy.range.end < copy.range.start) {
        copy.range.end = getDefaultEventEnd(eventDef.allDay, copy.range.start, context);
    }
    return copy;
}

// no public types yet. when there are, export from:
// import {} from './api-type-deps'
var ViewApi = /** @class */ (function () {
    function ViewApi(type, getCurrentData, dateEnv) {
        this.type = type;
        this.getCurrentData = getCurrentData;
        this.dateEnv = dateEnv;
    }
    Object.defineProperty(ViewApi.prototype, "calendar", {
        get: function () {
            return this.getCurrentData().calendarApi;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ViewApi.prototype, "title", {
        get: function () {
            return this.getCurrentData().viewTitle;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ViewApi.prototype, "activeStart", {
        get: function () {
            return this.dateEnv.toDate(this.getCurrentData().dateProfile.activeRange.start);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ViewApi.prototype, "activeEnd", {
        get: function () {
            return this.dateEnv.toDate(this.getCurrentData().dateProfile.activeRange.end);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ViewApi.prototype, "currentStart", {
        get: function () {
            return this.dateEnv.toDate(this.getCurrentData().dateProfile.currentRange.start);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ViewApi.prototype, "currentEnd", {
        get: function () {
            return this.dateEnv.toDate(this.getCurrentData().dateProfile.currentRange.end);
        },
        enumerable: false,
        configurable: true
    });
    ViewApi.prototype.getOption = function (name) {
        return this.getCurrentData().options[name]; // are the view-specific options
    };
    return ViewApi;
}());

var EVENT_SOURCE_REFINERS = {
    id: String,
    defaultAllDay: Boolean,
    url: String,
    format: String,
    events: identity,
    eventDataTransform: identity,
    // for any network-related sources
    success: identity,
    failure: identity,
};
function parseEventSource(raw, context, refiners) {
    if (refiners === void 0) { refiners = buildEventSourceRefiners(context); }
    var rawObj;
    if (typeof raw === 'string') {
        rawObj = { url: raw };
    }
    else if (typeof raw === 'function' || Array.isArray(raw)) {
        rawObj = { events: raw };
    }
    else if (typeof raw === 'object' && raw) { // not null
        rawObj = raw;
    }
    if (rawObj) {
        var _a = refineProps(rawObj, refiners), refined = _a.refined, extra = _a.extra;
        var metaRes = buildEventSourceMeta(refined, context);
        if (metaRes) {
            return {
                _raw: raw,
                isFetching: false,
                latestFetchId: '',
                fetchRange: null,
                defaultAllDay: refined.defaultAllDay,
                eventDataTransform: refined.eventDataTransform,
                success: refined.success,
                failure: refined.failure,
                publicId: refined.id || '',
                sourceId: guid(),
                sourceDefId: metaRes.sourceDefId,
                meta: metaRes.meta,
                ui: createEventUi(refined, context),
                extendedProps: extra,
            };
        }
    }
    return null;
}
function buildEventSourceRefiners(context) {
    return tslib.__assign(tslib.__assign(tslib.__assign({}, EVENT_UI_REFINERS), EVENT_SOURCE_REFINERS), context.pluginHooks.eventSourceRefiners);
}
function buildEventSourceMeta(raw, context) {
    var defs = context.pluginHooks.eventSourceDefs;
    for (var i = defs.length - 1; i >= 0; i -= 1) { // later-added plugins take precedence
        var def = defs[i];
        var meta = def.parseMeta(raw);
        if (meta) {
            return { sourceDefId: i, meta: meta };
        }
    }
    return null;
}

function reduceCurrentDate(currentDate, action) {
    switch (action.type) {
        case 'CHANGE_DATE':
            return action.dateMarker;
        default:
            return currentDate;
    }
}
function getInitialDate(options, dateEnv) {
    var initialDateInput = options.initialDate;
    // compute the initial ambig-timezone date
    if (initialDateInput != null) {
        return dateEnv.createMarker(initialDateInput);
    }
    return getNow(options.now, dateEnv); // getNow already returns unzoned
}
function getNow(nowInput, dateEnv) {
    if (typeof nowInput === 'function') {
        nowInput = nowInput();
    }
    if (nowInput == null) {
        return dateEnv.createNowMarker();
    }
    return dateEnv.createMarker(nowInput);
}

var CalendarApi = /** @class */ (function () {
    function CalendarApi() {
    }
    CalendarApi.prototype.getCurrentData = function () {
        return this.currentDataManager.getCurrentData();
    };
    CalendarApi.prototype.dispatch = function (action) {
        return this.currentDataManager.dispatch(action);
    };
    Object.defineProperty(CalendarApi.prototype, "view", {
        get: function () { return this.getCurrentData().viewApi; } // for public API
        ,
        enumerable: false,
        configurable: true
    });
    CalendarApi.prototype.batchRendering = function (callback) {
        callback();
    };
    CalendarApi.prototype.updateSize = function () {
        this.trigger('_resize', true);
    };
    // Options
    // -----------------------------------------------------------------------------------------------------------------
    CalendarApi.prototype.setOption = function (name, val) {
        this.dispatch({
            type: 'SET_OPTION',
            optionName: name,
            rawOptionValue: val,
        });
    };
    CalendarApi.prototype.getOption = function (name) {
        return this.currentDataManager.currentCalendarOptionsInput[name];
    };
    CalendarApi.prototype.getAvailableLocaleCodes = function () {
        return Object.keys(this.getCurrentData().availableRawLocales);
    };
    // Trigger
    // -----------------------------------------------------------------------------------------------------------------
    CalendarApi.prototype.on = function (handlerName, handler) {
        var currentDataManager = this.currentDataManager;
        if (currentDataManager.currentCalendarOptionsRefiners[handlerName]) {
            currentDataManager.emitter.on(handlerName, handler);
        }
        else {
            console.warn("Unknown listener name '" + handlerName + "'");
        }
    };
    CalendarApi.prototype.off = function (handlerName, handler) {
        this.currentDataManager.emitter.off(handlerName, handler);
    };
    // not meant for public use
    CalendarApi.prototype.trigger = function (handlerName) {
        var _a;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        (_a = this.currentDataManager.emitter).trigger.apply(_a, tslib.__spreadArray([handlerName], args));
    };
    // View
    // -----------------------------------------------------------------------------------------------------------------
    CalendarApi.prototype.changeView = function (viewType, dateOrRange) {
        var _this = this;
        this.batchRendering(function () {
            _this.unselect();
            if (dateOrRange) {
                if (dateOrRange.start && dateOrRange.end) { // a range
                    _this.dispatch({
                        type: 'CHANGE_VIEW_TYPE',
                        viewType: viewType,
                    });
                    _this.dispatch({
                        type: 'SET_OPTION',
                        optionName: 'visibleRange',
                        rawOptionValue: dateOrRange,
                    });
                }
                else {
                    var dateEnv = _this.getCurrentData().dateEnv;
                    _this.dispatch({
                        type: 'CHANGE_VIEW_TYPE',
                        viewType: viewType,
                        dateMarker: dateEnv.createMarker(dateOrRange),
                    });
                }
            }
            else {
                _this.dispatch({
                    type: 'CHANGE_VIEW_TYPE',
                    viewType: viewType,
                });
            }
        });
    };
    // Forces navigation to a view for the given date.
    // `viewType` can be a specific view name or a generic one like "week" or "day".
    // needs to change
    CalendarApi.prototype.zoomTo = function (dateMarker, viewType) {
        var state = this.getCurrentData();
        var spec;
        viewType = viewType || 'day'; // day is default zoom
        spec = state.viewSpecs[viewType] || this.getUnitViewSpec(viewType);
        this.unselect();
        if (spec) {
            this.dispatch({
                type: 'CHANGE_VIEW_TYPE',
                viewType: spec.type,
                dateMarker: dateMarker,
            });
        }
        else {
            this.dispatch({
                type: 'CHANGE_DATE',
                dateMarker: dateMarker,
            });
        }
    };
    // Given a duration singular unit, like "week" or "day", finds a matching view spec.
    // Preference is given to views that have corresponding buttons.
    CalendarApi.prototype.getUnitViewSpec = function (unit) {
        var _a = this.getCurrentData(), viewSpecs = _a.viewSpecs, toolbarConfig = _a.toolbarConfig;
        var viewTypes = [].concat(toolbarConfig.viewsWithButtons);
        var i;
        var spec;
        for (var viewType in viewSpecs) {
            viewTypes.push(viewType);
        }
        for (i = 0; i < viewTypes.length; i += 1) {
            spec = viewSpecs[viewTypes[i]];
            if (spec) {
                if (spec.singleUnit === unit) {
                    return spec;
                }
            }
        }
        return null;
    };
    // Current Date
    // -----------------------------------------------------------------------------------------------------------------
    CalendarApi.prototype.prev = function () {
        this.unselect();
        this.dispatch({ type: 'PREV' });
    };
    CalendarApi.prototype.next = function () {
        this.unselect();
        this.dispatch({ type: 'NEXT' });
    };
    CalendarApi.prototype.prevYear = function () {
        var state = this.getCurrentData();
        this.unselect();
        this.dispatch({
            type: 'CHANGE_DATE',
            dateMarker: state.dateEnv.addYears(state.currentDate, -1),
        });
    };
    CalendarApi.prototype.nextYear = function () {
        var state = this.getCurrentData();
        this.unselect();
        this.dispatch({
            type: 'CHANGE_DATE',
            dateMarker: state.dateEnv.addYears(state.currentDate, 1),
        });
    };
    CalendarApi.prototype.today = function () {
        var state = this.getCurrentData();
        this.unselect();
        this.dispatch({
            type: 'CHANGE_DATE',
            dateMarker: getNow(state.calendarOptions.now, state.dateEnv),
        });
    };
    CalendarApi.prototype.gotoDate = function (zonedDateInput) {
        var state = this.getCurrentData();
        this.unselect();
        this.dispatch({
            type: 'CHANGE_DATE',
            dateMarker: state.dateEnv.createMarker(zonedDateInput),
        });
    };
    CalendarApi.prototype.incrementDate = function (deltaInput) {
        var state = this.getCurrentData();
        var delta = createDuration(deltaInput);
        if (delta) { // else, warn about invalid input?
            this.unselect();
            this.dispatch({
                type: 'CHANGE_DATE',
                dateMarker: state.dateEnv.add(state.currentDate, delta),
            });
        }
    };
    // for external API
    CalendarApi.prototype.getDate = function () {
        var state = this.getCurrentData();
        return state.dateEnv.toDate(state.currentDate);
    };
    // Date Formatting Utils
    // -----------------------------------------------------------------------------------------------------------------
    CalendarApi.prototype.formatDate = function (d, formatter) {
        var dateEnv = this.getCurrentData().dateEnv;
        return dateEnv.format(dateEnv.createMarker(d), createFormatter(formatter));
    };
    // `settings` is for formatter AND isEndExclusive
    CalendarApi.prototype.formatRange = function (d0, d1, settings) {
        var dateEnv = this.getCurrentData().dateEnv;
        return dateEnv.formatRange(dateEnv.createMarker(d0), dateEnv.createMarker(d1), createFormatter(settings), settings);
    };
    CalendarApi.prototype.formatIso = function (d, omitTime) {
        var dateEnv = this.getCurrentData().dateEnv;
        return dateEnv.formatIso(dateEnv.createMarker(d), { omitTime: omitTime });
    };
    // Date Selection / Event Selection / DayClick
    // -----------------------------------------------------------------------------------------------------------------
    // this public method receives start/end dates in any format, with any timezone
    // NOTE: args were changed from v3
    CalendarApi.prototype.select = function (dateOrObj, endDate) {
        var selectionInput;
        if (endDate == null) {
            if (dateOrObj.start != null) {
                selectionInput = dateOrObj;
            }
            else {
                selectionInput = {
                    start: dateOrObj,
                    end: null,
                };
            }
        }
        else {
            selectionInput = {
                start: dateOrObj,
                end: endDate,
            };
        }
        var state = this.getCurrentData();
        var selection = parseDateSpan(selectionInput, state.dateEnv, createDuration({ days: 1 }));
        if (selection) { // throw parse error otherwise?
            this.dispatch({ type: 'SELECT_DATES', selection: selection });
            triggerDateSelect(selection, null, state);
        }
    };
    // public method
    CalendarApi.prototype.unselect = function (pev) {
        var state = this.getCurrentData();
        if (state.dateSelection) {
            this.dispatch({ type: 'UNSELECT_DATES' });
            triggerDateUnselect(pev, state);
        }
    };
    // Public Events API
    // -----------------------------------------------------------------------------------------------------------------
    CalendarApi.prototype.addEvent = function (eventInput, sourceInput) {
        if (eventInput instanceof EventApi) {
            var def = eventInput._def;
            var instance = eventInput._instance;
            var currentData = this.getCurrentData();
            // not already present? don't want to add an old snapshot
            if (!currentData.eventStore.defs[def.defId]) {
                this.dispatch({
                    type: 'ADD_EVENTS',
                    eventStore: eventTupleToStore({ def: def, instance: instance }), // TODO: better util for two args?
                });
                this.triggerEventAdd(eventInput);
            }
            return eventInput;
        }
        var state = this.getCurrentData();
        var eventSource;
        if (sourceInput instanceof EventSourceApi) {
            eventSource = sourceInput.internalEventSource;
        }
        else if (typeof sourceInput === 'boolean') {
            if (sourceInput) { // true. part of the first event source
                eventSource = hashValuesToArray(state.eventSources)[0];
            }
        }
        else if (sourceInput != null) { // an ID. accepts a number too
            var sourceApi = this.getEventSourceById(sourceInput); // TODO: use an internal function
            if (!sourceApi) {
                console.warn("Could not find an event source with ID \"" + sourceInput + "\""); // TODO: test
                return null;
            }
            eventSource = sourceApi.internalEventSource;
        }
        var tuple = parseEvent(eventInput, eventSource, state, false);
        if (tuple) {
            var newEventApi = new EventApi(state, tuple.def, tuple.def.recurringDef ? null : tuple.instance);
            this.dispatch({
                type: 'ADD_EVENTS',
                eventStore: eventTupleToStore(tuple),
            });
            this.triggerEventAdd(newEventApi);
            return newEventApi;
        }
        return null;
    };
    CalendarApi.prototype.triggerEventAdd = function (eventApi) {
        var _this = this;
        var emitter = this.getCurrentData().emitter;
        emitter.trigger('eventAdd', {
            event: eventApi,
            relatedEvents: [],
            revert: function () {
                _this.dispatch({
                    type: 'REMOVE_EVENTS',
                    eventStore: eventApiToStore(eventApi),
                });
            },
        });
    };
    // TODO: optimize
    CalendarApi.prototype.getEventById = function (id) {
        var state = this.getCurrentData();
        var _a = state.eventStore, defs = _a.defs, instances = _a.instances;
        id = String(id);
        for (var defId in defs) {
            var def = defs[defId];
            if (def.publicId === id) {
                if (def.recurringDef) {
                    return new EventApi(state, def, null);
                }
                for (var instanceId in instances) {
                    var instance = instances[instanceId];
                    if (instance.defId === def.defId) {
                        return new EventApi(state, def, instance);
                    }
                }
            }
        }
        return null;
    };
    CalendarApi.prototype.getEvents = function () {
        var currentData = this.getCurrentData();
        return buildEventApis(currentData.eventStore, currentData);
    };
    CalendarApi.prototype.removeAllEvents = function () {
        this.dispatch({ type: 'REMOVE_ALL_EVENTS' });
    };
    // Public Event Sources API
    // -----------------------------------------------------------------------------------------------------------------
    CalendarApi.prototype.getEventSources = function () {
        var state = this.getCurrentData();
        var sourceHash = state.eventSources;
        var sourceApis = [];
        for (var internalId in sourceHash) {
            sourceApis.push(new EventSourceApi(state, sourceHash[internalId]));
        }
        return sourceApis;
    };
    CalendarApi.prototype.getEventSourceById = function (id) {
        var state = this.getCurrentData();
        var sourceHash = state.eventSources;
        id = String(id);
        for (var sourceId in sourceHash) {
            if (sourceHash[sourceId].publicId === id) {
                return new EventSourceApi(state, sourceHash[sourceId]);
            }
        }
        return null;
    };
    CalendarApi.prototype.addEventSource = function (sourceInput) {
        var state = this.getCurrentData();
        if (sourceInput instanceof EventSourceApi) {
            // not already present? don't want to add an old snapshot
            if (!state.eventSources[sourceInput.internalEventSource.sourceId]) {
                this.dispatch({
                    type: 'ADD_EVENT_SOURCES',
                    sources: [sourceInput.internalEventSource],
                });
            }
            return sourceInput;
        }
        var eventSource = parseEventSource(sourceInput, state);
        if (eventSource) { // TODO: error otherwise?
            this.dispatch({ type: 'ADD_EVENT_SOURCES', sources: [eventSource] });
            return new EventSourceApi(state, eventSource);
        }
        return null;
    };
    CalendarApi.prototype.removeAllEventSources = function () {
        this.dispatch({ type: 'REMOVE_ALL_EVENT_SOURCES' });
    };
    CalendarApi.prototype.refetchEvents = function () {
        this.dispatch({ type: 'FETCH_EVENT_SOURCES', isRefetch: true });
    };
    // Scroll
    // -----------------------------------------------------------------------------------------------------------------
    CalendarApi.prototype.scrollToTime = function (timeInput) {
        var time = createDuration(timeInput);
        if (time) {
            this.trigger('_scrollRequest', { time: time });
        }
    };
    return CalendarApi;
}());

var EventApi = /** @class */ (function () {
    // instance will be null if expressing a recurring event that has no current instances,
    // OR if trying to validate an incoming external event that has no dates assigned
    function EventApi(context, def, instance) {
        this._context = context;
        this._def = def;
        this._instance = instance || null;
    }
    /*
    TODO: make event struct more responsible for this
    */
    EventApi.prototype.setProp = function (name, val) {
        var _a, _b;
        if (name in EVENT_DATE_REFINERS) {
            console.warn('Could not set date-related prop \'name\'. Use one of the date-related methods instead.');
            // TODO: make proper aliasing system?
        }
        else if (name === 'id') {
            val = EVENT_NON_DATE_REFINERS[name](val);
            this.mutate({
                standardProps: { publicId: val }, // hardcoded internal name
            });
        }
        else if (name in EVENT_NON_DATE_REFINERS) {
            val = EVENT_NON_DATE_REFINERS[name](val);
            this.mutate({
                standardProps: (_a = {}, _a[name] = val, _a),
            });
        }
        else if (name in EVENT_UI_REFINERS) {
            var ui = EVENT_UI_REFINERS[name](val);
            if (name === 'color') {
                ui = { backgroundColor: val, borderColor: val };
            }
            else if (name === 'editable') {
                ui = { startEditable: val, durationEditable: val };
            }
            else {
                ui = (_b = {}, _b[name] = val, _b);
            }
            this.mutate({
                standardProps: { ui: ui },
            });
        }
        else {
            console.warn("Could not set prop '" + name + "'. Use setExtendedProp instead.");
        }
    };
    EventApi.prototype.setExtendedProp = function (name, val) {
        var _a;
        this.mutate({
            extendedProps: (_a = {}, _a[name] = val, _a),
        });
    };
    EventApi.prototype.setStart = function (startInput, options) {
        if (options === void 0) { options = {}; }
        var dateEnv = this._context.dateEnv;
        var start = dateEnv.createMarker(startInput);
        if (start && this._instance) { // TODO: warning if parsed bad
            var instanceRange = this._instance.range;
            var startDelta = diffDates(instanceRange.start, start, dateEnv, options.granularity); // what if parsed bad!?
            if (options.maintainDuration) {
                this.mutate({ datesDelta: startDelta });
            }
            else {
                this.mutate({ startDelta: startDelta });
            }
        }
    };
    EventApi.prototype.setEnd = function (endInput, options) {
        if (options === void 0) { options = {}; }
        var dateEnv = this._context.dateEnv;
        var end;
        if (endInput != null) {
            end = dateEnv.createMarker(endInput);
            if (!end) {
                return; // TODO: warning if parsed bad
            }
        }
        if (this._instance) {
            if (end) {
                var endDelta = diffDates(this._instance.range.end, end, dateEnv, options.granularity);
                this.mutate({ endDelta: endDelta });
            }
            else {
                this.mutate({ standardProps: { hasEnd: false } });
            }
        }
    };
    EventApi.prototype.setDates = function (startInput, endInput, options) {
        if (options === void 0) { options = {}; }
        var dateEnv = this._context.dateEnv;
        var standardProps = { allDay: options.allDay };
        var start = dateEnv.createMarker(startInput);
        var end;
        if (!start) {
            return; // TODO: warning if parsed bad
        }
        if (endInput != null) {
            end = dateEnv.createMarker(endInput);
            if (!end) { // TODO: warning if parsed bad
                return;
            }
        }
        if (this._instance) {
            var instanceRange = this._instance.range;
            // when computing the diff for an event being converted to all-day,
            // compute diff off of the all-day values the way event-mutation does.
            if (options.allDay === true) {
                instanceRange = computeAlignedDayRange(instanceRange);
            }
            var startDelta = diffDates(instanceRange.start, start, dateEnv, options.granularity);
            if (end) {
                var endDelta = diffDates(instanceRange.end, end, dateEnv, options.granularity);
                if (durationsEqual(startDelta, endDelta)) {
                    this.mutate({ datesDelta: startDelta, standardProps: standardProps });
                }
                else {
                    this.mutate({ startDelta: startDelta, endDelta: endDelta, standardProps: standardProps });
                }
            }
            else { // means "clear the end"
                standardProps.hasEnd = false;
                this.mutate({ datesDelta: startDelta, standardProps: standardProps });
            }
        }
    };
    EventApi.prototype.moveStart = function (deltaInput) {
        var delta = createDuration(deltaInput);
        if (delta) { // TODO: warning if parsed bad
            this.mutate({ startDelta: delta });
        }
    };
    EventApi.prototype.moveEnd = function (deltaInput) {
        var delta = createDuration(deltaInput);
        if (delta) { // TODO: warning if parsed bad
            this.mutate({ endDelta: delta });
        }
    };
    EventApi.prototype.moveDates = function (deltaInput) {
        var delta = createDuration(deltaInput);
        if (delta) { // TODO: warning if parsed bad
            this.mutate({ datesDelta: delta });
        }
    };
    EventApi.prototype.setAllDay = function (allDay, options) {
        if (options === void 0) { options = {}; }
        var standardProps = { allDay: allDay };
        var maintainDuration = options.maintainDuration;
        if (maintainDuration == null) {
            maintainDuration = this._context.options.allDayMaintainDuration;
        }
        if (this._def.allDay !== allDay) {
            standardProps.hasEnd = maintainDuration;
        }
        this.mutate({ standardProps: standardProps });
    };
    EventApi.prototype.formatRange = function (formatInput) {
        var dateEnv = this._context.dateEnv;
        var instance = this._instance;
        var formatter = createFormatter(formatInput);
        if (this._def.hasEnd) {
            return dateEnv.formatRange(instance.range.start, instance.range.end, formatter, {
                forcedStartTzo: instance.forcedStartTzo,
                forcedEndTzo: instance.forcedEndTzo,
            });
        }
        return dateEnv.format(instance.range.start, formatter, {
            forcedTzo: instance.forcedStartTzo,
        });
    };
    EventApi.prototype.mutate = function (mutation) {
        var instance = this._instance;
        if (instance) {
            var def = this._def;
            var context_1 = this._context;
            var eventStore_1 = context_1.getCurrentData().eventStore;
            var relevantEvents = getRelevantEvents(eventStore_1, instance.instanceId);
            var eventConfigBase = {
                '': {
                    display: '',
                    startEditable: true,
                    durationEditable: true,
                    constraints: [],
                    overlap: null,
                    allows: [],
                    backgroundColor: '',
                    borderColor: '',
                    textColor: '',
                    classNames: [],
                },
            };
            relevantEvents = applyMutationToEventStore(relevantEvents, eventConfigBase, mutation, context_1);
            var oldEvent = new EventApi(context_1, def, instance); // snapshot
            this._def = relevantEvents.defs[def.defId];
            this._instance = relevantEvents.instances[instance.instanceId];
            context_1.dispatch({
                type: 'MERGE_EVENTS',
                eventStore: relevantEvents,
            });
            context_1.emitter.trigger('eventChange', {
                oldEvent: oldEvent,
                event: this,
                relatedEvents: buildEventApis(relevantEvents, context_1, instance),
                revert: function () {
                    context_1.dispatch({
                        type: 'RESET_EVENTS',
                        eventStore: eventStore_1,
                    });
                },
            });
        }
    };
    EventApi.prototype.remove = function () {
        var context = this._context;
        var asStore = eventApiToStore(this);
        context.dispatch({
            type: 'REMOVE_EVENTS',
            eventStore: asStore,
        });
        context.emitter.trigger('eventRemove', {
            event: this,
            relatedEvents: [],
            revert: function () {
                context.dispatch({
                    type: 'MERGE_EVENTS',
                    eventStore: asStore,
                });
            },
        });
    };
    Object.defineProperty(EventApi.prototype, "source", {
        get: function () {
            var sourceId = this._def.sourceId;
            if (sourceId) {
                return new EventSourceApi(this._context, this._context.getCurrentData().eventSources[sourceId]);
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "start", {
        get: function () {
            return this._instance ?
                this._context.dateEnv.toDate(this._instance.range.start) :
                null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "end", {
        get: function () {
            return (this._instance && this._def.hasEnd) ?
                this._context.dateEnv.toDate(this._instance.range.end) :
                null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "startStr", {
        get: function () {
            var instance = this._instance;
            if (instance) {
                return this._context.dateEnv.formatIso(instance.range.start, {
                    omitTime: this._def.allDay,
                    forcedTzo: instance.forcedStartTzo,
                });
            }
            return '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "endStr", {
        get: function () {
            var instance = this._instance;
            if (instance && this._def.hasEnd) {
                return this._context.dateEnv.formatIso(instance.range.end, {
                    omitTime: this._def.allDay,
                    forcedTzo: instance.forcedEndTzo,
                });
            }
            return '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "id", {
        // computable props that all access the def
        // TODO: find a TypeScript-compatible way to do this at scale
        get: function () { return this._def.publicId; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "groupId", {
        get: function () { return this._def.groupId; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "allDay", {
        get: function () { return this._def.allDay; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "title", {
        get: function () { return this._def.title; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "url", {
        get: function () { return this._def.url; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "display", {
        get: function () { return this._def.ui.display || 'auto'; } // bad. just normalize the type earlier
        ,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "startEditable", {
        get: function () { return this._def.ui.startEditable; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "durationEditable", {
        get: function () { return this._def.ui.durationEditable; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "constraint", {
        get: function () { return this._def.ui.constraints[0] || null; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "overlap", {
        get: function () { return this._def.ui.overlap; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "allow", {
        get: function () { return this._def.ui.allows[0] || null; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "backgroundColor", {
        get: function () { return this._def.ui.backgroundColor; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "borderColor", {
        get: function () { return this._def.ui.borderColor; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "textColor", {
        get: function () { return this._def.ui.textColor; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "classNames", {
        // NOTE: user can't modify these because Object.freeze was called in event-def parsing
        get: function () { return this._def.ui.classNames; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "extendedProps", {
        get: function () { return this._def.extendedProps; },
        enumerable: false,
        configurable: true
    });
    EventApi.prototype.toPlainObject = function (settings) {
        if (settings === void 0) { settings = {}; }
        var def = this._def;
        var ui = def.ui;
        var _a = this, startStr = _a.startStr, endStr = _a.endStr;
        var res = {};
        if (def.title) {
            res.title = def.title;
        }
        if (startStr) {
            res.start = startStr;
        }
        if (endStr) {
            res.end = endStr;
        }
        if (def.publicId) {
            res.id = def.publicId;
        }
        if (def.groupId) {
            res.groupId = def.groupId;
        }
        if (def.url) {
            res.url = def.url;
        }
        if (ui.display && ui.display !== 'auto') {
            res.display = ui.display;
        }
        // TODO: what about recurring-event properties???
        // TODO: include startEditable/durationEditable/constraint/overlap/allow
        if (settings.collapseColor && ui.backgroundColor && ui.backgroundColor === ui.borderColor) {
            res.color = ui.backgroundColor;
        }
        else {
            if (ui.backgroundColor) {
                res.backgroundColor = ui.backgroundColor;
            }
            if (ui.borderColor) {
                res.borderColor = ui.borderColor;
            }
        }
        if (ui.textColor) {
            res.textColor = ui.textColor;
        }
        if (ui.classNames.length) {
            res.classNames = ui.classNames;
        }
        if (Object.keys(def.extendedProps).length) {
            if (settings.collapseExtendedProps) {
                tslib.__assign(res, def.extendedProps);
            }
            else {
                res.extendedProps = def.extendedProps;
            }
        }
        return res;
    };
    EventApi.prototype.toJSON = function () {
        return this.toPlainObject();
    };
    return EventApi;
}());
function eventApiToStore(eventApi) {
    var _a, _b;
    var def = eventApi._def;
    var instance = eventApi._instance;
    return {
        defs: (_a = {}, _a[def.defId] = def, _a),
        instances: instance
            ? (_b = {}, _b[instance.instanceId] = instance, _b) : {},
    };
}
function buildEventApis(eventStore, context, excludeInstance) {
    var defs = eventStore.defs, instances = eventStore.instances;
    var eventApis = [];
    var excludeInstanceId = excludeInstance ? excludeInstance.instanceId : '';
    for (var id in instances) {
        var instance = instances[id];
        var def = defs[instance.defId];
        if (instance.instanceId !== excludeInstanceId) {
            eventApis.push(new EventApi(context, def, instance));
        }
    }
    return eventApis;
}

var calendarSystemClassMap = {};
function registerCalendarSystem(name, theClass) {
    calendarSystemClassMap[name] = theClass;
}
function createCalendarSystem(name) {
    return new calendarSystemClassMap[name]();
}
var GregorianCalendarSystem = /** @class */ (function () {
    function GregorianCalendarSystem() {
    }
    GregorianCalendarSystem.prototype.getMarkerYear = function (d) {
        return d.getUTCFullYear();
    };
    GregorianCalendarSystem.prototype.getMarkerMonth = function (d) {
        return d.getUTCMonth();
    };
    GregorianCalendarSystem.prototype.getMarkerDay = function (d) {
        return d.getUTCDate();
    };
    GregorianCalendarSystem.prototype.arrayToMarker = function (arr) {
        return arrayToUtcDate(arr);
    };
    GregorianCalendarSystem.prototype.markerToArray = function (marker) {
        return dateToUtcArray(marker);
    };
    return GregorianCalendarSystem;
}());
registerCalendarSystem('gregory', GregorianCalendarSystem);

var ISO_RE = /^\s*(\d{4})(-?(\d{2})(-?(\d{2})([T ](\d{2}):?(\d{2})(:?(\d{2})(\.(\d+))?)?(Z|(([-+])(\d{2})(:?(\d{2}))?))?)?)?)?$/;
function parse(str) {
    var m = ISO_RE.exec(str);
    if (m) {
        var marker = new Date(Date.UTC(Number(m[1]), m[3] ? Number(m[3]) - 1 : 0, Number(m[5] || 1), Number(m[7] || 0), Number(m[8] || 0), Number(m[10] || 0), m[12] ? Number("0." + m[12]) * 1000 : 0));
        if (isValidDate(marker)) {
            var timeZoneOffset = null;
            if (m[13]) {
                timeZoneOffset = (m[15] === '-' ? -1 : 1) * (Number(m[16] || 0) * 60 +
                    Number(m[18] || 0));
            }
            return {
                marker: marker,
                isTimeUnspecified: !m[6],
                timeZoneOffset: timeZoneOffset,
            };
        }
    }
    return null;
}

var DateEnv = /** @class */ (function () {
    function DateEnv(settings) {
        var timeZone = this.timeZone = settings.timeZone;
        var isNamedTimeZone = timeZone !== 'local' && timeZone !== 'UTC';
        if (settings.namedTimeZoneImpl && isNamedTimeZone) {
            this.namedTimeZoneImpl = new settings.namedTimeZoneImpl(timeZone);
        }
        this.canComputeOffset = Boolean(!isNamedTimeZone || this.namedTimeZoneImpl);
        this.calendarSystem = createCalendarSystem(settings.calendarSystem);
        this.locale = settings.locale;
        this.weekDow = settings.locale.week.dow;
        this.weekDoy = settings.locale.week.doy;
        if (settings.weekNumberCalculation === 'ISO') {
            this.weekDow = 1;
            this.weekDoy = 4;
        }
        if (typeof settings.firstDay === 'number') {
            this.weekDow = settings.firstDay;
        }
        if (typeof settings.weekNumberCalculation === 'function') {
            this.weekNumberFunc = settings.weekNumberCalculation;
        }
        this.weekText = settings.weekText != null ? settings.weekText : settings.locale.options.weekText;
        this.cmdFormatter = settings.cmdFormatter;
        this.defaultSeparator = settings.defaultSeparator;
    }
    // Creating / Parsing
    DateEnv.prototype.createMarker = function (input) {
        var meta = this.createMarkerMeta(input);
        if (meta === null) {
            return null;
        }
        return meta.marker;
    };
    DateEnv.prototype.createNowMarker = function () {
        if (this.canComputeOffset) {
            return this.timestampToMarker(new Date().valueOf());
        }
        // if we can't compute the current date val for a timezone,
        // better to give the current local date vals than UTC
        return arrayToUtcDate(dateToLocalArray(new Date()));
    };
    DateEnv.prototype.createMarkerMeta = function (input) {
        if (typeof input === 'string') {
            return this.parse(input);
        }
        var marker = null;
        if (typeof input === 'number') {
            marker = this.timestampToMarker(input);
        }
        else if (input instanceof Date) {
            input = input.valueOf();
            if (!isNaN(input)) {
                marker = this.timestampToMarker(input);
            }
        }
        else if (Array.isArray(input)) {
            marker = arrayToUtcDate(input);
        }
        if (marker === null || !isValidDate(marker)) {
            return null;
        }
        return { marker: marker, isTimeUnspecified: false, forcedTzo: null };
    };
    DateEnv.prototype.parse = function (s) {
        var parts = parse(s);
        if (parts === null) {
            return null;
        }
        var marker = parts.marker;
        var forcedTzo = null;
        if (parts.timeZoneOffset !== null) {
            if (this.canComputeOffset) {
                marker = this.timestampToMarker(marker.valueOf() - parts.timeZoneOffset * 60 * 1000);
            }
            else {
                forcedTzo = parts.timeZoneOffset;
            }
        }
        return { marker: marker, isTimeUnspecified: parts.isTimeUnspecified, forcedTzo: forcedTzo };
    };
    // Accessors
    DateEnv.prototype.getYear = function (marker) {
        return this.calendarSystem.getMarkerYear(marker);
    };
    DateEnv.prototype.getMonth = function (marker) {
        return this.calendarSystem.getMarkerMonth(marker);
    };
    // Adding / Subtracting
    DateEnv.prototype.add = function (marker, dur) {
        var a = this.calendarSystem.markerToArray(marker);
        a[0] += dur.years;
        a[1] += dur.months;
        a[2] += dur.days;
        a[6] += dur.milliseconds;
        return this.calendarSystem.arrayToMarker(a);
    };
    DateEnv.prototype.subtract = function (marker, dur) {
        var a = this.calendarSystem.markerToArray(marker);
        a[0] -= dur.years;
        a[1] -= dur.months;
        a[2] -= dur.days;
        a[6] -= dur.milliseconds;
        return this.calendarSystem.arrayToMarker(a);
    };
    DateEnv.prototype.addYears = function (marker, n) {
        var a = this.calendarSystem.markerToArray(marker);
        a[0] += n;
        return this.calendarSystem.arrayToMarker(a);
    };
    DateEnv.prototype.addMonths = function (marker, n) {
        var a = this.calendarSystem.markerToArray(marker);
        a[1] += n;
        return this.calendarSystem.arrayToMarker(a);
    };
    // Diffing Whole Units
    DateEnv.prototype.diffWholeYears = function (m0, m1) {
        var calendarSystem = this.calendarSystem;
        if (timeAsMs(m0) === timeAsMs(m1) &&
            calendarSystem.getMarkerDay(m0) === calendarSystem.getMarkerDay(m1) &&
            calendarSystem.getMarkerMonth(m0) === calendarSystem.getMarkerMonth(m1)) {
            return calendarSystem.getMarkerYear(m1) - calendarSystem.getMarkerYear(m0);
        }
        return null;
    };
    DateEnv.prototype.diffWholeMonths = function (m0, m1) {
        var calendarSystem = this.calendarSystem;
        if (timeAsMs(m0) === timeAsMs(m1) &&
            calendarSystem.getMarkerDay(m0) === calendarSystem.getMarkerDay(m1)) {
            return (calendarSystem.getMarkerMonth(m1) - calendarSystem.getMarkerMonth(m0)) +
                (calendarSystem.getMarkerYear(m1) - calendarSystem.getMarkerYear(m0)) * 12;
        }
        return null;
    };
    // Range / Duration
    DateEnv.prototype.greatestWholeUnit = function (m0, m1) {
        var n = this.diffWholeYears(m0, m1);
        if (n !== null) {
            return { unit: 'year', value: n };
        }
        n = this.diffWholeMonths(m0, m1);
        if (n !== null) {
            return { unit: 'month', value: n };
        }
        n = diffWholeWeeks(m0, m1);
        if (n !== null) {
            return { unit: 'week', value: n };
        }
        n = diffWholeDays(m0, m1);
        if (n !== null) {
            return { unit: 'day', value: n };
        }
        n = diffHours(m0, m1);
        if (isInt(n)) {
            return { unit: 'hour', value: n };
        }
        n = diffMinutes(m0, m1);
        if (isInt(n)) {
            return { unit: 'minute', value: n };
        }
        n = diffSeconds(m0, m1);
        if (isInt(n)) {
            return { unit: 'second', value: n };
        }
        return { unit: 'millisecond', value: m1.valueOf() - m0.valueOf() };
    };
    DateEnv.prototype.countDurationsBetween = function (m0, m1, d) {
        // TODO: can use greatestWholeUnit
        var diff;
        if (d.years) {
            diff = this.diffWholeYears(m0, m1);
            if (diff !== null) {
                return diff / asRoughYears(d);
            }
        }
        if (d.months) {
            diff = this.diffWholeMonths(m0, m1);
            if (diff !== null) {
                return diff / asRoughMonths(d);
            }
        }
        if (d.days) {
            diff = diffWholeDays(m0, m1);
            if (diff !== null) {
                return diff / asRoughDays(d);
            }
        }
        return (m1.valueOf() - m0.valueOf()) / asRoughMs(d);
    };
    // Start-Of
    // these DON'T return zoned-dates. only UTC start-of dates
    DateEnv.prototype.startOf = function (m, unit) {
        if (unit === 'year') {
            return this.startOfYear(m);
        }
        if (unit === 'month') {
            return this.startOfMonth(m);
        }
        if (unit === 'week') {
            return this.startOfWeek(m);
        }
        if (unit === 'day') {
            return startOfDay(m);
        }
        if (unit === 'hour') {
            return startOfHour(m);
        }
        if (unit === 'minute') {
            return startOfMinute(m);
        }
        if (unit === 'second') {
            return startOfSecond(m);
        }
        return null;
    };
    DateEnv.prototype.startOfYear = function (m) {
        return this.calendarSystem.arrayToMarker([
            this.calendarSystem.getMarkerYear(m),
        ]);
    };
    DateEnv.prototype.startOfMonth = function (m) {
        return this.calendarSystem.arrayToMarker([
            this.calendarSystem.getMarkerYear(m),
            this.calendarSystem.getMarkerMonth(m),
        ]);
    };
    DateEnv.prototype.startOfWeek = function (m) {
        return this.calendarSystem.arrayToMarker([
            this.calendarSystem.getMarkerYear(m),
            this.calendarSystem.getMarkerMonth(m),
            m.getUTCDate() - ((m.getUTCDay() - this.weekDow + 7) % 7),
        ]);
    };
    // Week Number
    DateEnv.prototype.computeWeekNumber = function (marker) {
        if (this.weekNumberFunc) {
            return this.weekNumberFunc(this.toDate(marker));
        }
        return weekOfYear(marker, this.weekDow, this.weekDoy);
    };
    // TODO: choke on timeZoneName: long
    DateEnv.prototype.format = function (marker, formatter, dateOptions) {
        if (dateOptions === void 0) { dateOptions = {}; }
        return formatter.format({
            marker: marker,
            timeZoneOffset: dateOptions.forcedTzo != null ?
                dateOptions.forcedTzo :
                this.offsetForMarker(marker),
        }, this);
    };
    DateEnv.prototype.formatRange = function (start, end, formatter, dateOptions) {
        if (dateOptions === void 0) { dateOptions = {}; }
        if (dateOptions.isEndExclusive) {
            end = addMs(end, -1);
        }
        return formatter.formatRange({
            marker: start,
            timeZoneOffset: dateOptions.forcedStartTzo != null ?
                dateOptions.forcedStartTzo :
                this.offsetForMarker(start),
        }, {
            marker: end,
            timeZoneOffset: dateOptions.forcedEndTzo != null ?
                dateOptions.forcedEndTzo :
                this.offsetForMarker(end),
        }, this, dateOptions.defaultSeparator);
    };
    /*
    DUMB: the omitTime arg is dumb. if we omit the time, we want to omit the timezone offset. and if we do that,
    might as well use buildIsoString or some other util directly
    */
    DateEnv.prototype.formatIso = function (marker, extraOptions) {
        if (extraOptions === void 0) { extraOptions = {}; }
        var timeZoneOffset = null;
        if (!extraOptions.omitTimeZoneOffset) {
            if (extraOptions.forcedTzo != null) {
                timeZoneOffset = extraOptions.forcedTzo;
            }
            else {
                timeZoneOffset = this.offsetForMarker(marker);
            }
        }
        return buildIsoString(marker, timeZoneOffset, extraOptions.omitTime);
    };
    // TimeZone
    DateEnv.prototype.timestampToMarker = function (ms) {
        if (this.timeZone === 'local') {
            return arrayToUtcDate(dateToLocalArray(new Date(ms)));
        }
        if (this.timeZone === 'UTC' || !this.namedTimeZoneImpl) {
            return new Date(ms);
        }
        return arrayToUtcDate(this.namedTimeZoneImpl.timestampToArray(ms));
    };
    DateEnv.prototype.offsetForMarker = function (m) {
        if (this.timeZone === 'local') {
            return -arrayToLocalDate(dateToUtcArray(m)).getTimezoneOffset(); // convert "inverse" offset to "normal" offset
        }
        if (this.timeZone === 'UTC') {
            return 0;
        }
        if (this.namedTimeZoneImpl) {
            return this.namedTimeZoneImpl.offsetForArray(dateToUtcArray(m));
        }
        return null;
    };
    // Conversion
    DateEnv.prototype.toDate = function (m, forcedTzo) {
        if (this.timeZone === 'local') {
            return arrayToLocalDate(dateToUtcArray(m));
        }
        if (this.timeZone === 'UTC') {
            return new Date(m.valueOf()); // make sure it's a copy
        }
        if (!this.namedTimeZoneImpl) {
            return new Date(m.valueOf() - (forcedTzo || 0));
        }
        return new Date(m.valueOf() -
            this.namedTimeZoneImpl.offsetForArray(dateToUtcArray(m)) * 1000 * 60);
    };
    return DateEnv;
}());

var globalLocales = [];

var RAW_EN_LOCALE = {
    code: 'en',
    week: {
        dow: 0,
        doy: 4, // 4 days need to be within the year to be considered the first week
    },
    direction: 'ltr',
    buttonText: {
        prev: 'prev',
        next: 'next',
        prevYear: 'prev year',
        nextYear: 'next year',
        year: 'year',
        today: 'today',
        month: 'month',
        week: 'week',
        day: 'day',
        list: 'list',
    },
    weekText: 'W',
    allDayText: 'all-day',
    moreLinkText: 'more',
    noEventsText: 'No events to display',
};
function organizeRawLocales(explicitRawLocales) {
    var defaultCode = explicitRawLocales.length > 0 ? explicitRawLocales[0].code : 'en';
    var allRawLocales = globalLocales.concat(explicitRawLocales);
    var rawLocaleMap = {
        en: RAW_EN_LOCALE, // necessary?
    };
    for (var _i = 0, allRawLocales_1 = allRawLocales; _i < allRawLocales_1.length; _i++) {
        var rawLocale = allRawLocales_1[_i];
        rawLocaleMap[rawLocale.code] = rawLocale;
    }
    return {
        map: rawLocaleMap,
        defaultCode: defaultCode,
    };
}
function buildLocale(inputSingular, available) {
    if (typeof inputSingular === 'object' && !Array.isArray(inputSingular)) {
        return parseLocale(inputSingular.code, [inputSingular.code], inputSingular);
    }
    return queryLocale(inputSingular, available);
}
function queryLocale(codeArg, available) {
    var codes = [].concat(codeArg || []); // will convert to array
    var raw = queryRawLocale(codes, available) || RAW_EN_LOCALE;
    return parseLocale(codeArg, codes, raw);
}
function queryRawLocale(codes, available) {
    for (var i = 0; i < codes.length; i += 1) {
        var parts = codes[i].toLocaleLowerCase().split('-');
        for (var j = parts.length; j > 0; j -= 1) {
            var simpleId = parts.slice(0, j).join('-');
            if (available[simpleId]) {
                return available[simpleId];
            }
        }
    }
    return null;
}
function parseLocale(codeArg, codes, raw) {
    var merged = mergeProps([RAW_EN_LOCALE, raw], ['buttonText']);
    delete merged.code; // don't want this part of the options
    var week = merged.week;
    delete merged.week;
    return {
        codeArg: codeArg,
        codes: codes,
        week: week,
        simpleNumberFormat: new Intl.NumberFormat(codeArg),
        options: merged,
    };
}

function formatDate(dateInput, options) {
    if (options === void 0) { options = {}; }
    var dateEnv = buildDateEnv$1(options);
    var formatter = createFormatter(options);
    var dateMeta = dateEnv.createMarkerMeta(dateInput);
    if (!dateMeta) { // TODO: warning?
        return '';
    }
    return dateEnv.format(dateMeta.marker, formatter, {
        forcedTzo: dateMeta.forcedTzo,
    });
}
function formatRange(startInput, endInput, options) {
    var dateEnv = buildDateEnv$1(typeof options === 'object' && options ? options : {}); // pass in if non-null object
    var formatter = createFormatter(options);
    var startMeta = dateEnv.createMarkerMeta(startInput);
    var endMeta = dateEnv.createMarkerMeta(endInput);
    if (!startMeta || !endMeta) { // TODO: warning?
        return '';
    }
    return dateEnv.formatRange(startMeta.marker, endMeta.marker, formatter, {
        forcedStartTzo: startMeta.forcedTzo,
        forcedEndTzo: endMeta.forcedTzo,
        isEndExclusive: options.isEndExclusive,
        defaultSeparator: BASE_OPTION_DEFAULTS.defaultRangeSeparator,
    });
}
// TODO: more DRY and optimized
function buildDateEnv$1(settings) {
    var locale = buildLocale(settings.locale || 'en', organizeRawLocales([]).map); // TODO: don't hardcode 'en' everywhere
    return new DateEnv(tslib.__assign(tslib.__assign({ timeZone: BASE_OPTION_DEFAULTS.timeZone, calendarSystem: 'gregory' }, settings), { locale: locale }));
}

var DEF_DEFAULTS = {
    startTime: '09:00',
    endTime: '17:00',
    daysOfWeek: [1, 2, 3, 4, 5],
    display: 'inverse-background',
    classNames: 'fc-non-business',
    groupId: '_businessHours', // so multiple defs get grouped
};
/*
TODO: pass around as EventDefHash!!!
*/
function parseBusinessHours(input, context) {
    return parseEvents(refineInputs(input), null, context);
}
function refineInputs(input) {
    var rawDefs;
    if (input === true) {
        rawDefs = [{}]; // will get DEF_DEFAULTS verbatim
    }
    else if (Array.isArray(input)) {
        // if specifying an array, every sub-definition NEEDS a day-of-week
        rawDefs = input.filter(function (rawDef) { return rawDef.daysOfWeek; });
    }
    else if (typeof input === 'object' && input) { // non-null object
        rawDefs = [input];
    }
    else { // is probably false
        rawDefs = [];
    }
    rawDefs = rawDefs.map(function (rawDef) { return (tslib.__assign(tslib.__assign({}, DEF_DEFAULTS), rawDef)); });
    return rawDefs;
}

function pointInsideRect(point, rect) {
    return point.left >= rect.left &&
        point.left < rect.right &&
        point.top >= rect.top &&
        point.top < rect.bottom;
}
// Returns a new rectangle that is the intersection of the two rectangles. If they don't intersect, returns false
function intersectRects(rect1, rect2) {
    var res = {
        left: Math.max(rect1.left, rect2.left),
        right: Math.min(rect1.right, rect2.right),
        top: Math.max(rect1.top, rect2.top),
        bottom: Math.min(rect1.bottom, rect2.bottom),
    };
    if (res.left < res.right && res.top < res.bottom) {
        return res;
    }
    return false;
}
function translateRect(rect, deltaX, deltaY) {
    return {
        left: rect.left + deltaX,
        right: rect.right + deltaX,
        top: rect.top + deltaY,
        bottom: rect.bottom + deltaY,
    };
}
// Returns a new point that will have been moved to reside within the given rectangle
function constrainPoint(point, rect) {
    return {
        left: Math.min(Math.max(point.left, rect.left), rect.right),
        top: Math.min(Math.max(point.top, rect.top), rect.bottom),
    };
}
// Returns a point that is the center of the given rectangle
function getRectCenter(rect) {
    return {
        left: (rect.left + rect.right) / 2,
        top: (rect.top + rect.bottom) / 2,
    };
}
// Subtracts point2's coordinates from point1's coordinates, returning a delta
function diffPoints(point1, point2) {
    return {
        left: point1.left - point2.left,
        top: point1.top - point2.top,
    };
}

var canVGrowWithinCell;
function getCanVGrowWithinCell() {
    if (canVGrowWithinCell == null) {
        canVGrowWithinCell = computeCanVGrowWithinCell();
    }
    return canVGrowWithinCell;
}
function computeCanVGrowWithinCell() {
    // for SSR, because this function is call immediately at top-level
    // TODO: just make this logic execute top-level, immediately, instead of doing lazily
    if (typeof document === 'undefined') {
        return true;
    }
    var el = document.createElement('div');
    el.style.position = 'absolute';
    el.style.top = '0px';
    el.style.left = '0px';
    el.innerHTML = '<table><tr><td><div></div></td></tr></table>';
    el.querySelector('table').style.height = '100px';
    el.querySelector('div').style.height = '100%';
    document.body.appendChild(el);
    var div = el.querySelector('div');
    var possible = div.offsetHeight > 0;
    document.body.removeChild(el);
    return possible;
}

var EMPTY_EVENT_STORE = createEmptyEventStore(); // for purecomponents. TODO: keep elsewhere
var Splitter = /** @class */ (function () {
    function Splitter() {
        this.getKeysForEventDefs = memoize(this._getKeysForEventDefs);
        this.splitDateSelection = memoize(this._splitDateSpan);
        this.splitEventStore = memoize(this._splitEventStore);
        this.splitIndividualUi = memoize(this._splitIndividualUi);
        this.splitEventDrag = memoize(this._splitInteraction);
        this.splitEventResize = memoize(this._splitInteraction);
        this.eventUiBuilders = {}; // TODO: typescript protection
    }
    Splitter.prototype.splitProps = function (props) {
        var _this = this;
        var keyInfos = this.getKeyInfo(props);
        var defKeys = this.getKeysForEventDefs(props.eventStore);
        var dateSelections = this.splitDateSelection(props.dateSelection);
        var individualUi = this.splitIndividualUi(props.eventUiBases, defKeys); // the individual *bases*
        var eventStores = this.splitEventStore(props.eventStore, defKeys);
        var eventDrags = this.splitEventDrag(props.eventDrag);
        var eventResizes = this.splitEventResize(props.eventResize);
        var splitProps = {};
        this.eventUiBuilders = mapHash(keyInfos, function (info, key) { return _this.eventUiBuilders[key] || memoize(buildEventUiForKey); });
        for (var key in keyInfos) {
            var keyInfo = keyInfos[key];
            var eventStore = eventStores[key] || EMPTY_EVENT_STORE;
            var buildEventUi = this.eventUiBuilders[key];
            splitProps[key] = {
                businessHours: keyInfo.businessHours || props.businessHours,
                dateSelection: dateSelections[key] || null,
                eventStore: eventStore,
                eventUiBases: buildEventUi(props.eventUiBases[''], keyInfo.ui, individualUi[key]),
                eventSelection: eventStore.instances[props.eventSelection] ? props.eventSelection : '',
                eventDrag: eventDrags[key] || null,
                eventResize: eventResizes[key] || null,
            };
        }
        return splitProps;
    };
    Splitter.prototype._splitDateSpan = function (dateSpan) {
        var dateSpans = {};
        if (dateSpan) {
            var keys = this.getKeysForDateSpan(dateSpan);
            for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
                var key = keys_1[_i];
                dateSpans[key] = dateSpan;
            }
        }
        return dateSpans;
    };
    Splitter.prototype._getKeysForEventDefs = function (eventStore) {
        var _this = this;
        return mapHash(eventStore.defs, function (eventDef) { return _this.getKeysForEventDef(eventDef); });
    };
    Splitter.prototype._splitEventStore = function (eventStore, defKeys) {
        var defs = eventStore.defs, instances = eventStore.instances;
        var splitStores = {};
        for (var defId in defs) {
            for (var _i = 0, _a = defKeys[defId]; _i < _a.length; _i++) {
                var key = _a[_i];
                if (!splitStores[key]) {
                    splitStores[key] = createEmptyEventStore();
                }
                splitStores[key].defs[defId] = defs[defId];
            }
        }
        for (var instanceId in instances) {
            var instance = instances[instanceId];
            for (var _b = 0, _c = defKeys[instance.defId]; _b < _c.length; _b++) {
                var key = _c[_b];
                if (splitStores[key]) { // must have already been created
                    splitStores[key].instances[instanceId] = instance;
                }
            }
        }
        return splitStores;
    };
    Splitter.prototype._splitIndividualUi = function (eventUiBases, defKeys) {
        var splitHashes = {};
        for (var defId in eventUiBases) {
            if (defId) { // not the '' key
                for (var _i = 0, _a = defKeys[defId]; _i < _a.length; _i++) {
                    var key = _a[_i];
                    if (!splitHashes[key]) {
                        splitHashes[key] = {};
                    }
                    splitHashes[key][defId] = eventUiBases[defId];
                }
            }
        }
        return splitHashes;
    };
    Splitter.prototype._splitInteraction = function (interaction) {
        var splitStates = {};
        if (interaction) {
            var affectedStores_1 = this._splitEventStore(interaction.affectedEvents, this._getKeysForEventDefs(interaction.affectedEvents));
            // can't rely on defKeys because event data is mutated
            var mutatedKeysByDefId = this._getKeysForEventDefs(interaction.mutatedEvents);
            var mutatedStores_1 = this._splitEventStore(interaction.mutatedEvents, mutatedKeysByDefId);
            var populate = function (key) {
                if (!splitStates[key]) {
                    splitStates[key] = {
                        affectedEvents: affectedStores_1[key] || EMPTY_EVENT_STORE,
                        mutatedEvents: mutatedStores_1[key] || EMPTY_EVENT_STORE,
                        isEvent: interaction.isEvent,
                    };
                }
            };
            for (var key in affectedStores_1) {
                populate(key);
            }
            for (var key in mutatedStores_1) {
                populate(key);
            }
        }
        return splitStates;
    };
    return Splitter;
}());
function buildEventUiForKey(allUi, eventUiForKey, individualUi) {
    var baseParts = [];
    if (allUi) {
        baseParts.push(allUi);
    }
    if (eventUiForKey) {
        baseParts.push(eventUiForKey);
    }
    var stuff = {
        '': combineEventUis(baseParts),
    };
    if (individualUi) {
        tslib.__assign(stuff, individualUi);
    }
    return stuff;
}

function getDateMeta(date, todayRange, nowDate, dateProfile) {
    return {
        dow: date.getUTCDay(),
        isDisabled: Boolean(dateProfile && !rangeContainsMarker(dateProfile.activeRange, date)),
        isOther: Boolean(dateProfile && !rangeContainsMarker(dateProfile.currentRange, date)),
        isToday: Boolean(todayRange && rangeContainsMarker(todayRange, date)),
        isPast: Boolean(nowDate ? (date < nowDate) : todayRange ? (date < todayRange.start) : false),
        isFuture: Boolean(nowDate ? (date > nowDate) : todayRange ? (date >= todayRange.end) : false),
    };
}
function getDayClassNames(meta, theme) {
    var classNames = [
        'fc-day',
        "fc-day-" + DAY_IDS[meta.dow],
    ];
    if (meta.isDisabled) {
        classNames.push('fc-day-disabled');
    }
    else {
        if (meta.isToday) {
            classNames.push('fc-day-today');
            classNames.push(theme.getClass('today'));
        }
        if (meta.isPast) {
            classNames.push('fc-day-past');
        }
        if (meta.isFuture) {
            classNames.push('fc-day-future');
        }
        if (meta.isOther) {
            classNames.push('fc-day-other');
        }
    }
    return classNames;
}
function getSlotClassNames(meta, theme) {
    var classNames = [
        'fc-slot',
        "fc-slot-" + DAY_IDS[meta.dow],
    ];
    if (meta.isDisabled) {
        classNames.push('fc-slot-disabled');
    }
    else {
        if (meta.isToday) {
            classNames.push('fc-slot-today');
            classNames.push(theme.getClass('today'));
        }
        if (meta.isPast) {
            classNames.push('fc-slot-past');
        }
        if (meta.isFuture) {
            classNames.push('fc-slot-future');
        }
    }
    return classNames;
}

function buildNavLinkData(date, type) {
    if (type === void 0) { type = 'day'; }
    return JSON.stringify({
        date: formatDayString(date),
        type: type,
    });
}

var _isRtlScrollbarOnLeft = null;
function getIsRtlScrollbarOnLeft() {
    if (_isRtlScrollbarOnLeft === null) {
        _isRtlScrollbarOnLeft = computeIsRtlScrollbarOnLeft();
    }
    return _isRtlScrollbarOnLeft;
}
function computeIsRtlScrollbarOnLeft() {
    var outerEl = document.createElement('div');
    applyStyle(outerEl, {
        position: 'absolute',
        top: -1000,
        left: 0,
        border: 0,
        padding: 0,
        overflow: 'scroll',
        direction: 'rtl',
    });
    outerEl.innerHTML = '<div></div>';
    document.body.appendChild(outerEl);
    var innerEl = outerEl.firstChild;
    var res = innerEl.getBoundingClientRect().left > outerEl.getBoundingClientRect().left;
    removeElement(outerEl);
    return res;
}

var _scrollbarWidths;
function getScrollbarWidths() {
    if (!_scrollbarWidths) {
        _scrollbarWidths = computeScrollbarWidths();
    }
    return _scrollbarWidths;
}
function computeScrollbarWidths() {
    var el = document.createElement('div');
    el.style.overflow = 'scroll';
    el.style.position = 'absolute';
    el.style.top = '-9999px';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    var res = computeScrollbarWidthsForEl(el);
    document.body.removeChild(el);
    return res;
}
// WARNING: will include border
function computeScrollbarWidthsForEl(el) {
    return {
        x: el.offsetHeight - el.clientHeight,
        y: el.offsetWidth - el.clientWidth,
    };
}

function computeEdges(el, getPadding) {
    if (getPadding === void 0) { getPadding = false; }
    var computedStyle = window.getComputedStyle(el);
    var borderLeft = parseInt(computedStyle.borderLeftWidth, 10) || 0;
    var borderRight = parseInt(computedStyle.borderRightWidth, 10) || 0;
    var borderTop = parseInt(computedStyle.borderTopWidth, 10) || 0;
    var borderBottom = parseInt(computedStyle.borderBottomWidth, 10) || 0;
    var badScrollbarWidths = computeScrollbarWidthsForEl(el); // includes border!
    var scrollbarLeftRight = badScrollbarWidths.y - borderLeft - borderRight;
    var scrollbarBottom = badScrollbarWidths.x - borderTop - borderBottom;
    var res = {
        borderLeft: borderLeft,
        borderRight: borderRight,
        borderTop: borderTop,
        borderBottom: borderBottom,
        scrollbarBottom: scrollbarBottom,
        scrollbarLeft: 0,
        scrollbarRight: 0,
    };
    if (getIsRtlScrollbarOnLeft() && computedStyle.direction === 'rtl') { // is the scrollbar on the left side?
        res.scrollbarLeft = scrollbarLeftRight;
    }
    else {
        res.scrollbarRight = scrollbarLeftRight;
    }
    if (getPadding) {
        res.paddingLeft = parseInt(computedStyle.paddingLeft, 10) || 0;
        res.paddingRight = parseInt(computedStyle.paddingRight, 10) || 0;
        res.paddingTop = parseInt(computedStyle.paddingTop, 10) || 0;
        res.paddingBottom = parseInt(computedStyle.paddingBottom, 10) || 0;
    }
    return res;
}
function computeInnerRect(el, goWithinPadding, doFromWindowViewport) {
    if (goWithinPadding === void 0) { goWithinPadding = false; }
    var outerRect = doFromWindowViewport ? el.getBoundingClientRect() : computeRect(el);
    var edges = computeEdges(el, goWithinPadding);
    var res = {
        left: outerRect.left + edges.borderLeft + edges.scrollbarLeft,
        right: outerRect.right - edges.borderRight - edges.scrollbarRight,
        top: outerRect.top + edges.borderTop,
        bottom: outerRect.bottom - edges.borderBottom - edges.scrollbarBottom,
    };
    if (goWithinPadding) {
        res.left += edges.paddingLeft;
        res.right -= edges.paddingRight;
        res.top += edges.paddingTop;
        res.bottom -= edges.paddingBottom;
    }
    return res;
}
function computeRect(el) {
    var rect = el.getBoundingClientRect();
    return {
        left: rect.left + window.pageXOffset,
        top: rect.top + window.pageYOffset,
        right: rect.right + window.pageXOffset,
        bottom: rect.bottom + window.pageYOffset,
    };
}
function computeClippedClientRect(el) {
    var clippingParents = getClippingParents(el);
    var rect = el.getBoundingClientRect();
    for (var _i = 0, clippingParents_1 = clippingParents; _i < clippingParents_1.length; _i++) {
        var clippingParent = clippingParents_1[_i];
        var intersection = intersectRects(rect, clippingParent.getBoundingClientRect());
        if (intersection) {
            rect = intersection;
        }
        else {
            return null;
        }
    }
    return rect;
}
function computeHeightAndMargins(el) {
    return el.getBoundingClientRect().height + computeVMargins(el);
}
function computeVMargins(el) {
    var computed = window.getComputedStyle(el);
    return parseInt(computed.marginTop, 10) +
        parseInt(computed.marginBottom, 10);
}
// does not return window
function getClippingParents(el) {
    var parents = [];
    while (el instanceof HTMLElement) { // will stop when gets to document or null
        var computedStyle = window.getComputedStyle(el);
        if (computedStyle.position === 'fixed') {
            break;
        }
        if ((/(auto|scroll)/).test(computedStyle.overflow + computedStyle.overflowY + computedStyle.overflowX)) {
            parents.push(el);
        }
        el = el.parentNode;
    }
    return parents;
}

// given a function that resolves a result asynchronously.
// the function can either call passed-in success and failure callbacks,
// or it can return a promise.
// if you need to pass additional params to func, bind them first.
function unpromisify(func, success, failure) {
    // guard against success/failure callbacks being called more than once
    // and guard against a promise AND callback being used together.
    var isResolved = false;
    var wrappedSuccess = function () {
        if (!isResolved) {
            isResolved = true;
            success.apply(this, arguments); // eslint-disable-line prefer-rest-params
        }
    };
    var wrappedFailure = function () {
        if (!isResolved) {
            isResolved = true;
            if (failure) {
                failure.apply(this, arguments); // eslint-disable-line prefer-rest-params
            }
        }
    };
    var res = func(wrappedSuccess, wrappedFailure);
    if (res && typeof res.then === 'function') {
        res.then(wrappedSuccess, wrappedFailure);
    }
}

var Emitter = /** @class */ (function () {
    function Emitter() {
        this.handlers = {};
        this.thisContext = null;
    }
    Emitter.prototype.setThisContext = function (thisContext) {
        this.thisContext = thisContext;
    };
    Emitter.prototype.setOptions = function (options) {
        this.options = options;
    };
    Emitter.prototype.on = function (type, handler) {
        addToHash(this.handlers, type, handler);
    };
    Emitter.prototype.off = function (type, handler) {
        removeFromHash(this.handlers, type, handler);
    };
    Emitter.prototype.trigger = function (type) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var attachedHandlers = this.handlers[type] || [];
        var optionHandler = this.options && this.options[type];
        var handlers = [].concat(optionHandler || [], attachedHandlers);
        for (var _a = 0, handlers_1 = handlers; _a < handlers_1.length; _a++) {
            var handler = handlers_1[_a];
            handler.apply(this.thisContext, args);
        }
    };
    Emitter.prototype.hasHandlers = function (type) {
        return (this.handlers[type] && this.handlers[type].length) ||
            (this.options && this.options[type]);
    };
    return Emitter;
}());
function addToHash(hash, type, handler) {
    (hash[type] || (hash[type] = []))
        .push(handler);
}
function removeFromHash(hash, type, handler) {
    if (handler) {
        if (hash[type]) {
            hash[type] = hash[type].filter(function (func) { return func !== handler; });
        }
    }
    else {
        delete hash[type]; // remove all handler funcs for this type
    }
}

/*
Records offset information for a set of elements, relative to an origin element.
Can record the left/right OR the top/bottom OR both.
Provides methods for querying the cache by position.
*/
var PositionCache = /** @class */ (function () {
    function PositionCache(originEl, els, isHorizontal, isVertical) {
        this.els = els;
        var originClientRect = this.originClientRect = originEl.getBoundingClientRect(); // relative to viewport top-left
        if (isHorizontal) {
            this.buildElHorizontals(originClientRect.left);
        }
        if (isVertical) {
            this.buildElVerticals(originClientRect.top);
        }
    }
    // Populates the left/right internal coordinate arrays
    PositionCache.prototype.buildElHorizontals = function (originClientLeft) {
        var lefts = [];
        var rights = [];
        for (var _i = 0, _a = this.els; _i < _a.length; _i++) {
            var el = _a[_i];
            var rect = el.getBoundingClientRect();
            lefts.push(rect.left - originClientLeft);
            rights.push(rect.right - originClientLeft);
        }
        this.lefts = lefts;
        this.rights = rights;
    };
    // Populates the top/bottom internal coordinate arrays
    PositionCache.prototype.buildElVerticals = function (originClientTop) {
        var tops = [];
        var bottoms = [];
        for (var _i = 0, _a = this.els; _i < _a.length; _i++) {
            var el = _a[_i];
            var rect = el.getBoundingClientRect();
            tops.push(rect.top - originClientTop);
            bottoms.push(rect.bottom - originClientTop);
        }
        this.tops = tops;
        this.bottoms = bottoms;
    };
    // Given a left offset (from document left), returns the index of the el that it horizontally intersects.
    // If no intersection is made, returns undefined.
    PositionCache.prototype.leftToIndex = function (leftPosition) {
        var _a = this, lefts = _a.lefts, rights = _a.rights;
        var len = lefts.length;
        var i;
        for (i = 0; i < len; i += 1) {
            if (leftPosition >= lefts[i] && leftPosition < rights[i]) {
                return i;
            }
        }
        return undefined; // TODO: better
    };
    // Given a top offset (from document top), returns the index of the el that it vertically intersects.
    // If no intersection is made, returns undefined.
    PositionCache.prototype.topToIndex = function (topPosition) {
        var _a = this, tops = _a.tops, bottoms = _a.bottoms;
        var len = tops.length;
        var i;
        for (i = 0; i < len; i += 1) {
            if (topPosition >= tops[i] && topPosition < bottoms[i]) {
                return i;
            }
        }
        return undefined; // TODO: better
    };
    // Gets the width of the element at the given index
    PositionCache.prototype.getWidth = function (leftIndex) {
        return this.rights[leftIndex] - this.lefts[leftIndex];
    };
    // Gets the height of the element at the given index
    PositionCache.prototype.getHeight = function (topIndex) {
        return this.bottoms[topIndex] - this.tops[topIndex];
    };
    return PositionCache;
}());

/* eslint max-classes-per-file: "off" */
/*
An object for getting/setting scroll-related information for an element.
Internally, this is done very differently for window versus DOM element,
so this object serves as a common interface.
*/
var ScrollController = /** @class */ (function () {
    function ScrollController() {
    }
    ScrollController.prototype.getMaxScrollTop = function () {
        return this.getScrollHeight() - this.getClientHeight();
    };
    ScrollController.prototype.getMaxScrollLeft = function () {
        return this.getScrollWidth() - this.getClientWidth();
    };
    ScrollController.prototype.canScrollVertically = function () {
        return this.getMaxScrollTop() > 0;
    };
    ScrollController.prototype.canScrollHorizontally = function () {
        return this.getMaxScrollLeft() > 0;
    };
    ScrollController.prototype.canScrollUp = function () {
        return this.getScrollTop() > 0;
    };
    ScrollController.prototype.canScrollDown = function () {
        return this.getScrollTop() < this.getMaxScrollTop();
    };
    ScrollController.prototype.canScrollLeft = function () {
        return this.getScrollLeft() > 0;
    };
    ScrollController.prototype.canScrollRight = function () {
        return this.getScrollLeft() < this.getMaxScrollLeft();
    };
    return ScrollController;
}());
var ElementScrollController = /** @class */ (function (_super) {
    tslib.__extends(ElementScrollController, _super);
    function ElementScrollController(el) {
        var _this = _super.call(this) || this;
        _this.el = el;
        return _this;
    }
    ElementScrollController.prototype.getScrollTop = function () {
        return this.el.scrollTop;
    };
    ElementScrollController.prototype.getScrollLeft = function () {
        return this.el.scrollLeft;
    };
    ElementScrollController.prototype.setScrollTop = function (top) {
        this.el.scrollTop = top;
    };
    ElementScrollController.prototype.setScrollLeft = function (left) {
        this.el.scrollLeft = left;
    };
    ElementScrollController.prototype.getScrollWidth = function () {
        return this.el.scrollWidth;
    };
    ElementScrollController.prototype.getScrollHeight = function () {
        return this.el.scrollHeight;
    };
    ElementScrollController.prototype.getClientHeight = function () {
        return this.el.clientHeight;
    };
    ElementScrollController.prototype.getClientWidth = function () {
        return this.el.clientWidth;
    };
    return ElementScrollController;
}(ScrollController));
var WindowScrollController = /** @class */ (function (_super) {
    tslib.__extends(WindowScrollController, _super);
    function WindowScrollController() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WindowScrollController.prototype.getScrollTop = function () {
        return window.pageYOffset;
    };
    WindowScrollController.prototype.getScrollLeft = function () {
        return window.pageXOffset;
    };
    WindowScrollController.prototype.setScrollTop = function (n) {
        window.scroll(window.pageXOffset, n);
    };
    WindowScrollController.prototype.setScrollLeft = function (n) {
        window.scroll(n, window.pageYOffset);
    };
    WindowScrollController.prototype.getScrollWidth = function () {
        return document.documentElement.scrollWidth;
    };
    WindowScrollController.prototype.getScrollHeight = function () {
        return document.documentElement.scrollHeight;
    };
    WindowScrollController.prototype.getClientHeight = function () {
        return document.documentElement.clientHeight;
    };
    WindowScrollController.prototype.getClientWidth = function () {
        return document.documentElement.clientWidth;
    };
    return WindowScrollController;
}(ScrollController));

var Theme = /** @class */ (function () {
    function Theme(calendarOptions) {
        if (this.iconOverrideOption) {
            this.setIconOverride(calendarOptions[this.iconOverrideOption]);
        }
    }
    Theme.prototype.setIconOverride = function (iconOverrideHash) {
        var iconClassesCopy;
        var buttonName;
        if (typeof iconOverrideHash === 'object' && iconOverrideHash) { // non-null object
            iconClassesCopy = tslib.__assign({}, this.iconClasses);
            for (buttonName in iconOverrideHash) {
                iconClassesCopy[buttonName] = this.applyIconOverridePrefix(iconOverrideHash[buttonName]);
            }
            this.iconClasses = iconClassesCopy;
        }
        else if (iconOverrideHash === false) {
            this.iconClasses = {};
        }
    };
    Theme.prototype.applyIconOverridePrefix = function (className) {
        var prefix = this.iconOverridePrefix;
        if (prefix && className.indexOf(prefix) !== 0) { // if not already present
            className = prefix + className;
        }
        return className;
    };
    Theme.prototype.getClass = function (key) {
        return this.classes[key] || '';
    };
    Theme.prototype.getIconClass = function (buttonName, isRtl) {
        var className;
        if (isRtl && this.rtlIconClasses) {
            className = this.rtlIconClasses[buttonName] || this.iconClasses[buttonName];
        }
        else {
            className = this.iconClasses[buttonName];
        }
        if (className) {
            return this.baseIconClass + " " + className;
        }
        return '';
    };
    Theme.prototype.getCustomButtonIconClass = function (customButtonProps) {
        var className;
        if (this.iconOverrideCustomButtonOption) {
            className = customButtonProps[this.iconOverrideCustomButtonOption];
            if (className) {
                return this.baseIconClass + " " + this.applyIconOverridePrefix(className);
            }
        }
        return '';
    };
    return Theme;
}());
Theme.prototype.classes = {};
Theme.prototype.iconClasses = {};
Theme.prototype.baseIconClass = '';
Theme.prototype.iconOverridePrefix = '';

var ScrollResponder = /** @class */ (function () {
    function ScrollResponder(execFunc, emitter, scrollTime, scrollTimeReset) {
        var _this = this;
        this.execFunc = execFunc;
        this.emitter = emitter;
        this.scrollTime = scrollTime;
        this.scrollTimeReset = scrollTimeReset;
        this.handleScrollRequest = function (request) {
            _this.queuedRequest = tslib.__assign({}, _this.queuedRequest || {}, request);
            _this.drain();
        };
        emitter.on('_scrollRequest', this.handleScrollRequest);
        this.fireInitialScroll();
    }
    ScrollResponder.prototype.detach = function () {
        this.emitter.off('_scrollRequest', this.handleScrollRequest);
    };
    ScrollResponder.prototype.update = function (isDatesNew) {
        if (isDatesNew && this.scrollTimeReset) {
            this.fireInitialScroll(); // will drain
        }
        else {
            this.drain();
        }
    };
    ScrollResponder.prototype.fireInitialScroll = function () {
        this.handleScrollRequest({
            time: this.scrollTime,
        });
    };
    ScrollResponder.prototype.drain = function () {
        if (this.queuedRequest && this.execFunc(this.queuedRequest)) {
            this.queuedRequest = null;
        }
    };
    return ScrollResponder;
}());

var ViewContextType = vdom_cjs.createContext({}); // for Components
function buildViewContext(viewSpec, viewApi, viewOptions, dateProfileGenerator, dateEnv, theme, pluginHooks, dispatch, getCurrentData, emitter, calendarApi, registerInteractiveComponent, unregisterInteractiveComponent) {
    return {
        dateEnv: dateEnv,
        options: viewOptions,
        pluginHooks: pluginHooks,
        emitter: emitter,
        dispatch: dispatch,
        getCurrentData: getCurrentData,
        calendarApi: calendarApi,
        viewSpec: viewSpec,
        viewApi: viewApi,
        dateProfileGenerator: dateProfileGenerator,
        theme: theme,
        isRtl: viewOptions.direction === 'rtl',
        addResizeHandler: function (handler) {
            emitter.on('_resize', handler);
        },
        removeResizeHandler: function (handler) {
            emitter.off('_resize', handler);
        },
        createScrollResponder: function (execFunc) {
            return new ScrollResponder(execFunc, emitter, createDuration(viewOptions.scrollTime), viewOptions.scrollTimeReset);
        },
        registerInteractiveComponent: registerInteractiveComponent,
        unregisterInteractiveComponent: unregisterInteractiveComponent,
    };
}

/* eslint max-classes-per-file: off */
var PureComponent = /** @class */ (function (_super) {
    tslib.__extends(PureComponent, _super);
    function PureComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PureComponent.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        if (this.debug) {
            // eslint-disable-next-line no-console
            console.log(getUnequalProps(nextProps, this.props), getUnequalProps(nextState, this.state));
        }
        return !compareObjs(this.props, nextProps, this.propEquality) ||
            !compareObjs(this.state, nextState, this.stateEquality);
    };
    PureComponent.addPropsEquality = addPropsEquality;
    PureComponent.addStateEquality = addStateEquality;
    PureComponent.contextType = ViewContextType;
    return PureComponent;
}(vdom_cjs.Component));
PureComponent.prototype.propEquality = {};
PureComponent.prototype.stateEquality = {};
var BaseComponent = /** @class */ (function (_super) {
    tslib.__extends(BaseComponent, _super);
    function BaseComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BaseComponent.contextType = ViewContextType;
    return BaseComponent;
}(PureComponent));
function addPropsEquality(propEquality) {
    var hash = Object.create(this.prototype.propEquality);
    tslib.__assign(hash, propEquality);
    this.prototype.propEquality = hash;
}
function addStateEquality(stateEquality) {
    var hash = Object.create(this.prototype.stateEquality);
    tslib.__assign(hash, stateEquality);
    this.prototype.stateEquality = hash;
}
// use other one
function setRef(ref, current) {
    if (typeof ref === 'function') {
        ref(current);
    }
    else if (ref) {
        // see https://github.com/facebook/react/issues/13029
        ref.current = current;
    }
}

/*
an INTERACTABLE date component

PURPOSES:
- hook up to fg, fill, and mirror renderers
- interface for dragging and hits
*/
var DateComponent = /** @class */ (function (_super) {
    tslib.__extends(DateComponent, _super);
    function DateComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.uid = guid();
        return _this;
    }
    // Hit System
    // -----------------------------------------------------------------------------------------------------------------
    DateComponent.prototype.prepareHits = function () {
    };
    DateComponent.prototype.queryHit = function (positionLeft, positionTop, elWidth, elHeight) {
        return null; // this should be abstract
    };
    // Pointer Interaction Utils
    // -----------------------------------------------------------------------------------------------------------------
    DateComponent.prototype.isValidSegDownEl = function (el) {
        return !this.props.eventDrag && // HACK
            !this.props.eventResize && // HACK
            !elementClosest(el, '.fc-event-mirror');
    };
    DateComponent.prototype.isValidDateDownEl = function (el) {
        return !elementClosest(el, '.fc-event:not(.fc-bg-event)') &&
            !elementClosest(el, '.fc-more-link') && // a "more.." link
            !elementClosest(el, 'a[data-navlink]') && // a clickable nav link
            !elementClosest(el, '.fc-popover'); // hack
    };
    return DateComponent;
}(BaseComponent));

// TODO: easier way to add new hooks? need to update a million things
function createPlugin(input) {
    return {
        id: guid(),
        deps: input.deps || [],
        reducers: input.reducers || [],
        isLoadingFuncs: input.isLoadingFuncs || [],
        contextInit: [].concat(input.contextInit || []),
        eventRefiners: input.eventRefiners || {},
        eventDefMemberAdders: input.eventDefMemberAdders || [],
        eventSourceRefiners: input.eventSourceRefiners || {},
        isDraggableTransformers: input.isDraggableTransformers || [],
        eventDragMutationMassagers: input.eventDragMutationMassagers || [],
        eventDefMutationAppliers: input.eventDefMutationAppliers || [],
        dateSelectionTransformers: input.dateSelectionTransformers || [],
        datePointTransforms: input.datePointTransforms || [],
        dateSpanTransforms: input.dateSpanTransforms || [],
        views: input.views || {},
        viewPropsTransformers: input.viewPropsTransformers || [],
        isPropsValid: input.isPropsValid || null,
        externalDefTransforms: input.externalDefTransforms || [],
        viewContainerAppends: input.viewContainerAppends || [],
        eventDropTransformers: input.eventDropTransformers || [],
        componentInteractions: input.componentInteractions || [],
        calendarInteractions: input.calendarInteractions || [],
        themeClasses: input.themeClasses || {},
        eventSourceDefs: input.eventSourceDefs || [],
        cmdFormatter: input.cmdFormatter,
        recurringTypes: input.recurringTypes || [],
        namedTimeZonedImpl: input.namedTimeZonedImpl,
        initialView: input.initialView || '',
        elementDraggingImpl: input.elementDraggingImpl,
        optionChangeHandlers: input.optionChangeHandlers || {},
        scrollGridImpl: input.scrollGridImpl || null,
        contentTypeHandlers: input.contentTypeHandlers || {},
        listenerRefiners: input.listenerRefiners || {},
        optionRefiners: input.optionRefiners || {},
        propSetHandlers: input.propSetHandlers || {},
    };
}
function buildPluginHooks(pluginDefs, globalDefs) {
    var isAdded = {};
    var hooks = {
        reducers: [],
        isLoadingFuncs: [],
        contextInit: [],
        eventRefiners: {},
        eventDefMemberAdders: [],
        eventSourceRefiners: {},
        isDraggableTransformers: [],
        eventDragMutationMassagers: [],
        eventDefMutationAppliers: [],
        dateSelectionTransformers: [],
        datePointTransforms: [],
        dateSpanTransforms: [],
        views: {},
        viewPropsTransformers: [],
        isPropsValid: null,
        externalDefTransforms: [],
        viewContainerAppends: [],
        eventDropTransformers: [],
        componentInteractions: [],
        calendarInteractions: [],
        themeClasses: {},
        eventSourceDefs: [],
        cmdFormatter: null,
        recurringTypes: [],
        namedTimeZonedImpl: null,
        initialView: '',
        elementDraggingImpl: null,
        optionChangeHandlers: {},
        scrollGridImpl: null,
        contentTypeHandlers: {},
        listenerRefiners: {},
        optionRefiners: {},
        propSetHandlers: {},
    };
    function addDefs(defs) {
        for (var _i = 0, defs_1 = defs; _i < defs_1.length; _i++) {
            var def = defs_1[_i];
            if (!isAdded[def.id]) {
                isAdded[def.id] = true;
                addDefs(def.deps);
                hooks = combineHooks(hooks, def);
            }
        }
    }
    if (pluginDefs) {
        addDefs(pluginDefs);
    }
    addDefs(globalDefs);
    return hooks;
}
function buildBuildPluginHooks() {
    var currentOverrideDefs = [];
    var currentGlobalDefs = [];
    var currentHooks;
    return function (overrideDefs, globalDefs) {
        if (!currentHooks || !isArraysEqual(overrideDefs, currentOverrideDefs) || !isArraysEqual(globalDefs, currentGlobalDefs)) {
            currentHooks = buildPluginHooks(overrideDefs, globalDefs);
        }
        currentOverrideDefs = overrideDefs;
        currentGlobalDefs = globalDefs;
        return currentHooks;
    };
}
function combineHooks(hooks0, hooks1) {
    return {
        reducers: hooks0.reducers.concat(hooks1.reducers),
        isLoadingFuncs: hooks0.isLoadingFuncs.concat(hooks1.isLoadingFuncs),
        contextInit: hooks0.contextInit.concat(hooks1.contextInit),
        eventRefiners: tslib.__assign(tslib.__assign({}, hooks0.eventRefiners), hooks1.eventRefiners),
        eventDefMemberAdders: hooks0.eventDefMemberAdders.concat(hooks1.eventDefMemberAdders),
        eventSourceRefiners: tslib.__assign(tslib.__assign({}, hooks0.eventSourceRefiners), hooks1.eventSourceRefiners),
        isDraggableTransformers: hooks0.isDraggableTransformers.concat(hooks1.isDraggableTransformers),
        eventDragMutationMassagers: hooks0.eventDragMutationMassagers.concat(hooks1.eventDragMutationMassagers),
        eventDefMutationAppliers: hooks0.eventDefMutationAppliers.concat(hooks1.eventDefMutationAppliers),
        dateSelectionTransformers: hooks0.dateSelectionTransformers.concat(hooks1.dateSelectionTransformers),
        datePointTransforms: hooks0.datePointTransforms.concat(hooks1.datePointTransforms),
        dateSpanTransforms: hooks0.dateSpanTransforms.concat(hooks1.dateSpanTransforms),
        views: tslib.__assign(tslib.__assign({}, hooks0.views), hooks1.views),
        viewPropsTransformers: hooks0.viewPropsTransformers.concat(hooks1.viewPropsTransformers),
        isPropsValid: hooks1.isPropsValid || hooks0.isPropsValid,
        externalDefTransforms: hooks0.externalDefTransforms.concat(hooks1.externalDefTransforms),
        viewContainerAppends: hooks0.viewContainerAppends.concat(hooks1.viewContainerAppends),
        eventDropTransformers: hooks0.eventDropTransformers.concat(hooks1.eventDropTransformers),
        calendarInteractions: hooks0.calendarInteractions.concat(hooks1.calendarInteractions),
        componentInteractions: hooks0.componentInteractions.concat(hooks1.componentInteractions),
        themeClasses: tslib.__assign(tslib.__assign({}, hooks0.themeClasses), hooks1.themeClasses),
        eventSourceDefs: hooks0.eventSourceDefs.concat(hooks1.eventSourceDefs),
        cmdFormatter: hooks1.cmdFormatter || hooks0.cmdFormatter,
        recurringTypes: hooks0.recurringTypes.concat(hooks1.recurringTypes),
        namedTimeZonedImpl: hooks1.namedTimeZonedImpl || hooks0.namedTimeZonedImpl,
        initialView: hooks0.initialView || hooks1.initialView,
        elementDraggingImpl: hooks0.elementDraggingImpl || hooks1.elementDraggingImpl,
        optionChangeHandlers: tslib.__assign(tslib.__assign({}, hooks0.optionChangeHandlers), hooks1.optionChangeHandlers),
        scrollGridImpl: hooks1.scrollGridImpl || hooks0.scrollGridImpl,
        contentTypeHandlers: tslib.__assign(tslib.__assign({}, hooks0.contentTypeHandlers), hooks1.contentTypeHandlers),
        listenerRefiners: tslib.__assign(tslib.__assign({}, hooks0.listenerRefiners), hooks1.listenerRefiners),
        optionRefiners: tslib.__assign(tslib.__assign({}, hooks0.optionRefiners), hooks1.optionRefiners),
        propSetHandlers: tslib.__assign(tslib.__assign({}, hooks0.propSetHandlers), hooks1.propSetHandlers),
    };
}

var StandardTheme = /** @class */ (function (_super) {
    tslib.__extends(StandardTheme, _super);
    function StandardTheme() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return StandardTheme;
}(Theme));
StandardTheme.prototype.classes = {
    root: 'fc-theme-standard',
    tableCellShaded: 'fc-cell-shaded',
    buttonGroup: 'fc-button-group',
    button: 'fc-button fc-button-primary',
    buttonActive: 'fc-button-active',
};
StandardTheme.prototype.baseIconClass = 'fc-icon';
StandardTheme.prototype.iconClasses = {
    close: 'fc-icon-x',
    prev: 'fc-icon-chevron-left',
    next: 'fc-icon-chevron-right',
    prevYear: 'fc-icon-chevrons-left',
    nextYear: 'fc-icon-chevrons-right',
};
StandardTheme.prototype.rtlIconClasses = {
    prev: 'fc-icon-chevron-right',
    next: 'fc-icon-chevron-left',
    prevYear: 'fc-icon-chevrons-right',
    nextYear: 'fc-icon-chevrons-left',
};
StandardTheme.prototype.iconOverrideOption = 'buttonIcons'; // TODO: make TS-friendly
StandardTheme.prototype.iconOverrideCustomButtonOption = 'icon';
StandardTheme.prototype.iconOverridePrefix = 'fc-icon-';

function compileViewDefs(defaultConfigs, overrideConfigs) {
    var hash = {};
    var viewType;
    for (viewType in defaultConfigs) {
        ensureViewDef(viewType, hash, defaultConfigs, overrideConfigs);
    }
    for (viewType in overrideConfigs) {
        ensureViewDef(viewType, hash, defaultConfigs, overrideConfigs);
    }
    return hash;
}
function ensureViewDef(viewType, hash, defaultConfigs, overrideConfigs) {
    if (hash[viewType]) {
        return hash[viewType];
    }
    var viewDef = buildViewDef(viewType, hash, defaultConfigs, overrideConfigs);
    if (viewDef) {
        hash[viewType] = viewDef;
    }
    return viewDef;
}
function buildViewDef(viewType, hash, defaultConfigs, overrideConfigs) {
    var defaultConfig = defaultConfigs[viewType];
    var overrideConfig = overrideConfigs[viewType];
    var queryProp = function (name) { return ((defaultConfig && defaultConfig[name] !== null) ? defaultConfig[name] :
        ((overrideConfig && overrideConfig[name] !== null) ? overrideConfig[name] : null)); };
    var theComponent = queryProp('component');
    var superType = queryProp('superType');
    var superDef = null;
    if (superType) {
        if (superType === viewType) {
            throw new Error('Can\'t have a custom view type that references itself');
        }
        superDef = ensureViewDef(superType, hash, defaultConfigs, overrideConfigs);
    }
    if (!theComponent && superDef) {
        theComponent = superDef.component;
    }
    if (!theComponent) {
        return null; // don't throw a warning, might be settings for a single-unit view
    }
    return {
        type: viewType,
        component: theComponent,
        defaults: tslib.__assign(tslib.__assign({}, (superDef ? superDef.defaults : {})), (defaultConfig ? defaultConfig.rawOptions : {})),
        overrides: tslib.__assign(tslib.__assign({}, (superDef ? superDef.overrides : {})), (overrideConfig ? overrideConfig.rawOptions : {})),
    };
}

/* eslint max-classes-per-file: off */
// NOTE: in JSX, you should always use this class with <HookProps> arg. otherwise, will default to any???
var RenderHook = /** @class */ (function (_super) {
    tslib.__extends(RenderHook, _super);
    function RenderHook() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.rootElRef = vdom_cjs.createRef();
        _this.handleRootEl = function (el) {
            setRef(_this.rootElRef, el);
            if (_this.props.elRef) {
                setRef(_this.props.elRef, el);
            }
        };
        return _this;
    }
    RenderHook.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var hookProps = props.hookProps;
        return (vdom_cjs.createElement(MountHook, { hookProps: hookProps, didMount: props.didMount, willUnmount: props.willUnmount, elRef: this.handleRootEl }, function (rootElRef) { return (vdom_cjs.createElement(ContentHook, { hookProps: hookProps, content: props.content, defaultContent: props.defaultContent, backupElRef: _this.rootElRef }, function (innerElRef, innerContent) { return props.children(rootElRef, normalizeClassNames(props.classNames, hookProps), innerElRef, innerContent); })); }));
    };
    return RenderHook;
}(BaseComponent));
// TODO: rename to be about function, not default. use in above type
// for forcing rerender of components that use the ContentHook
var CustomContentRenderContext = vdom_cjs.createContext(0);
function ContentHook(props) {
    return (vdom_cjs.createElement(CustomContentRenderContext.Consumer, null, function (renderId) { return (vdom_cjs.createElement(ContentHookInner, tslib.__assign({ renderId: renderId }, props))); }));
}
var ContentHookInner = /** @class */ (function (_super) {
    tslib.__extends(ContentHookInner, _super);
    function ContentHookInner() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.innerElRef = vdom_cjs.createRef();
        return _this;
    }
    ContentHookInner.prototype.render = function () {
        return this.props.children(this.innerElRef, this.renderInnerContent());
    };
    ContentHookInner.prototype.componentDidMount = function () {
        this.updateCustomContent();
    };
    ContentHookInner.prototype.componentDidUpdate = function () {
        this.updateCustomContent();
    };
    ContentHookInner.prototype.componentWillUnmount = function () {
        if (this.customContentInfo && this.customContentInfo.destroy) {
            this.customContentInfo.destroy();
        }
    };
    ContentHookInner.prototype.renderInnerContent = function () {
        var customContentInfo = this.customContentInfo; // only populated if using non-[p]react node(s)
        var innerContent = this.getInnerContent();
        var meta = this.getContentMeta(innerContent);
        // initial run, or content-type changing? (from vue -> react for example)
        if (!customContentInfo || customContentInfo.contentKey !== meta.contentKey) {
            // clearing old value
            if (customContentInfo) {
                if (customContentInfo.destroy) {
                    customContentInfo.destroy();
                }
                customContentInfo = this.customContentInfo = null;
            }
            // assigning new value
            if (meta.contentKey) {
                customContentInfo = this.customContentInfo = tslib.__assign({ contentKey: meta.contentKey, contentVal: innerContent[meta.contentKey] }, meta.buildLifecycleFuncs());
            }
            // updating
        }
        else if (customContentInfo) {
            customContentInfo.contentVal = innerContent[meta.contentKey];
        }
        return customContentInfo
            ? [] // signal that something was specified
            : innerContent; // assume a [p]react vdom node. use it
    };
    ContentHookInner.prototype.getInnerContent = function () {
        var props = this.props;
        var innerContent = normalizeContent(props.content, props.hookProps);
        if (innerContent === undefined) { // use the default
            innerContent = normalizeContent(props.defaultContent, props.hookProps);
        }
        return innerContent == null ? null : innerContent; // convert undefined to null (better for React)
    };
    ContentHookInner.prototype.getContentMeta = function (innerContent) {
        var contentTypeHandlers = this.context.pluginHooks.contentTypeHandlers;
        var contentKey = '';
        var buildLifecycleFuncs = null;
        if (innerContent) { // allowed to be null, for convenience to caller
            for (var searchKey in contentTypeHandlers) {
                if (innerContent[searchKey] !== undefined) {
                    contentKey = searchKey;
                    buildLifecycleFuncs = contentTypeHandlers[searchKey];
                    break;
                }
            }
        }
        return { contentKey: contentKey, buildLifecycleFuncs: buildLifecycleFuncs };
    };
    ContentHookInner.prototype.updateCustomContent = function () {
        if (this.customContentInfo) { // for non-[p]react
            this.customContentInfo.render(this.innerElRef.current || this.props.backupElRef.current, // the element to render into
            this.customContentInfo.contentVal);
        }
    };
    return ContentHookInner;
}(BaseComponent));
var MountHook = /** @class */ (function (_super) {
    tslib.__extends(MountHook, _super);
    function MountHook() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleRootEl = function (rootEl) {
            _this.rootEl = rootEl;
            if (_this.props.elRef) {
                setRef(_this.props.elRef, rootEl);
            }
        };
        return _this;
    }
    MountHook.prototype.render = function () {
        return this.props.children(this.handleRootEl);
    };
    MountHook.prototype.componentDidMount = function () {
        var callback = this.props.didMount;
        if (callback) {
            callback(tslib.__assign(tslib.__assign({}, this.props.hookProps), { el: this.rootEl }));
        }
    };
    MountHook.prototype.componentWillUnmount = function () {
        var callback = this.props.willUnmount;
        if (callback) {
            callback(tslib.__assign(tslib.__assign({}, this.props.hookProps), { el: this.rootEl }));
        }
    };
    return MountHook;
}(BaseComponent));
function buildClassNameNormalizer() {
    var currentGenerator;
    var currentHookProps;
    var currentClassNames = [];
    return function (generator, hookProps) {
        if (!currentHookProps || !isPropsEqual(currentHookProps, hookProps) || generator !== currentGenerator) {
            currentGenerator = generator;
            currentHookProps = hookProps;
            currentClassNames = normalizeClassNames(generator, hookProps);
        }
        return currentClassNames;
    };
}
function normalizeClassNames(classNames, hookProps) {
    if (typeof classNames === 'function') {
        classNames = classNames(hookProps);
    }
    return parseClassNames(classNames);
}
function normalizeContent(input, hookProps) {
    if (typeof input === 'function') {
        return input(hookProps, vdom_cjs.createElement); // give the function the vdom-creation func
    }
    return input;
}

var ViewRoot = /** @class */ (function (_super) {
    tslib.__extends(ViewRoot, _super);
    function ViewRoot() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.normalizeClassNames = buildClassNameNormalizer();
        return _this;
    }
    ViewRoot.prototype.render = function () {
        var _a = this, props = _a.props, context = _a.context;
        var options = context.options;
        var hookProps = { view: context.viewApi };
        var customClassNames = this.normalizeClassNames(options.viewClassNames, hookProps);
        return (vdom_cjs.createElement(MountHook, { hookProps: hookProps, didMount: options.viewDidMount, willUnmount: options.viewWillUnmount, elRef: props.elRef }, function (rootElRef) { return props.children(rootElRef, ["fc-" + props.viewSpec.type + "-view", 'fc-view'].concat(customClassNames)); }));
    };
    return ViewRoot;
}(BaseComponent));

function parseViewConfigs(inputs) {
    return mapHash(inputs, parseViewConfig);
}
function parseViewConfig(input) {
    var rawOptions = typeof input === 'function' ?
        { component: input } :
        input;
    var component = rawOptions.component;
    if (rawOptions.content) {
        component = createViewHookComponent(rawOptions);
        // TODO: remove content/classNames/didMount/etc from options?
    }
    return {
        superType: rawOptions.type,
        component: component,
        rawOptions: rawOptions,
    };
}
function createViewHookComponent(options) {
    return function (viewProps) { return (vdom_cjs.createElement(ViewContextType.Consumer, null, function (context) { return (vdom_cjs.createElement(ViewRoot, { viewSpec: context.viewSpec }, function (viewElRef, viewClassNames) {
        var hookProps = tslib.__assign(tslib.__assign({}, viewProps), { nextDayThreshold: context.options.nextDayThreshold });
        return (vdom_cjs.createElement(RenderHook, { hookProps: hookProps, classNames: options.classNames, content: options.content, didMount: options.didMount, willUnmount: options.willUnmount, elRef: viewElRef }, function (rootElRef, customClassNames, innerElRef, innerContent) { return (vdom_cjs.createElement("div", { className: viewClassNames.concat(customClassNames).join(' '), ref: rootElRef }, innerContent)); }));
    })); })); };
}

function buildViewSpecs(defaultInputs, optionOverrides, dynamicOptionOverrides, localeDefaults) {
    var defaultConfigs = parseViewConfigs(defaultInputs);
    var overrideConfigs = parseViewConfigs(optionOverrides.views);
    var viewDefs = compileViewDefs(defaultConfigs, overrideConfigs);
    return mapHash(viewDefs, function (viewDef) { return buildViewSpec(viewDef, overrideConfigs, optionOverrides, dynamicOptionOverrides, localeDefaults); });
}
function buildViewSpec(viewDef, overrideConfigs, optionOverrides, dynamicOptionOverrides, localeDefaults) {
    var durationInput = viewDef.overrides.duration ||
        viewDef.defaults.duration ||
        dynamicOptionOverrides.duration ||
        optionOverrides.duration;
    var duration = null;
    var durationUnit = '';
    var singleUnit = '';
    var singleUnitOverrides = {};
    if (durationInput) {
        duration = createDurationCached(durationInput);
        if (duration) { // valid?
            var denom = greatestDurationDenominator(duration);
            durationUnit = denom.unit;
            if (denom.value === 1) {
                singleUnit = durationUnit;
                singleUnitOverrides = overrideConfigs[durationUnit] ? overrideConfigs[durationUnit].rawOptions : {};
            }
        }
    }
    var queryButtonText = function (optionsSubset) {
        var buttonTextMap = optionsSubset.buttonText || {};
        var buttonTextKey = viewDef.defaults.buttonTextKey;
        if (buttonTextKey != null && buttonTextMap[buttonTextKey] != null) {
            return buttonTextMap[buttonTextKey];
        }
        if (buttonTextMap[viewDef.type] != null) {
            return buttonTextMap[viewDef.type];
        }
        if (buttonTextMap[singleUnit] != null) {
            return buttonTextMap[singleUnit];
        }
        return null;
    };
    return {
        type: viewDef.type,
        component: viewDef.component,
        duration: duration,
        durationUnit: durationUnit,
        singleUnit: singleUnit,
        optionDefaults: viewDef.defaults,
        optionOverrides: tslib.__assign(tslib.__assign({}, singleUnitOverrides), viewDef.overrides),
        buttonTextOverride: queryButtonText(dynamicOptionOverrides) ||
            queryButtonText(optionOverrides) || // constructor-specified buttonText lookup hash takes precedence
            viewDef.overrides.buttonText,
        buttonTextDefault: queryButtonText(localeDefaults) ||
            viewDef.defaults.buttonText ||
            queryButtonText(BASE_OPTION_DEFAULTS) ||
            viewDef.type, // fall back to given view name
    };
}
// hack to get memoization working
var durationInputMap = {};
function createDurationCached(durationInput) {
    var json = JSON.stringify(durationInput);
    var res = durationInputMap[json];
    if (res === undefined) {
        res = createDuration(durationInput);
        durationInputMap[json] = res;
    }
    return res;
}

var DateProfileGenerator = /** @class */ (function () {
    function DateProfileGenerator(props) {
        this.props = props;
        this.nowDate = getNow(props.nowInput, props.dateEnv);
        this.initHiddenDays();
    }
    /* Date Range Computation
    ------------------------------------------------------------------------------------------------------------------*/
    // Builds a structure with info about what the dates/ranges will be for the "prev" view.
    DateProfileGenerator.prototype.buildPrev = function (currentDateProfile, currentDate, forceToValid) {
        var dateEnv = this.props.dateEnv;
        var prevDate = dateEnv.subtract(dateEnv.startOf(currentDate, currentDateProfile.currentRangeUnit), // important for start-of-month
        currentDateProfile.dateIncrement);
        return this.build(prevDate, -1, forceToValid);
    };
    // Builds a structure with info about what the dates/ranges will be for the "next" view.
    DateProfileGenerator.prototype.buildNext = function (currentDateProfile, currentDate, forceToValid) {
        var dateEnv = this.props.dateEnv;
        var nextDate = dateEnv.add(dateEnv.startOf(currentDate, currentDateProfile.currentRangeUnit), // important for start-of-month
        currentDateProfile.dateIncrement);
        return this.build(nextDate, 1, forceToValid);
    };
    // Builds a structure holding dates/ranges for rendering around the given date.
    // Optional direction param indicates whether the date is being incremented/decremented
    // from its previous value. decremented = -1, incremented = 1 (default).
    DateProfileGenerator.prototype.build = function (currentDate, direction, forceToValid) {
        if (forceToValid === void 0) { forceToValid = true; }
        var props = this.props;
        var validRange;
        var currentInfo;
        var isRangeAllDay;
        var renderRange;
        var activeRange;
        var isValid;
        validRange = this.buildValidRange();
        validRange = this.trimHiddenDays(validRange);
        if (forceToValid) {
            currentDate = constrainMarkerToRange(currentDate, validRange);
        }
        currentInfo = this.buildCurrentRangeInfo(currentDate, direction);
        isRangeAllDay = /^(year|month|week|day)$/.test(currentInfo.unit);
        renderRange = this.buildRenderRange(this.trimHiddenDays(currentInfo.range), currentInfo.unit, isRangeAllDay);
        renderRange = this.trimHiddenDays(renderRange);
        activeRange = renderRange;
        if (!props.showNonCurrentDates) {
            activeRange = intersectRanges(activeRange, currentInfo.range);
        }
        activeRange = this.adjustActiveRange(activeRange);
        activeRange = intersectRanges(activeRange, validRange); // might return null
        // it's invalid if the originally requested date is not contained,
        // or if the range is completely outside of the valid range.
        isValid = rangesIntersect(currentInfo.range, validRange);
        return {
            // constraint for where prev/next operations can go and where events can be dragged/resized to.
            // an object with optional start and end properties.
            validRange: validRange,
            // range the view is formally responsible for.
            // for example, a month view might have 1st-31st, excluding padded dates
            currentRange: currentInfo.range,
            // name of largest unit being displayed, like "month" or "week"
            currentRangeUnit: currentInfo.unit,
            isRangeAllDay: isRangeAllDay,
            // dates that display events and accept drag-n-drop
            // will be `null` if no dates accept events
            activeRange: activeRange,
            // date range with a rendered skeleton
            // includes not-active days that need some sort of DOM
            renderRange: renderRange,
            // Duration object that denotes the first visible time of any given day
            slotMinTime: props.slotMinTime,
            // Duration object that denotes the exclusive visible end time of any given day
            slotMaxTime: props.slotMaxTime,
            isValid: isValid,
            // how far the current date will move for a prev/next operation
            dateIncrement: this.buildDateIncrement(currentInfo.duration),
            // pass a fallback (might be null) ^
        };
    };
    // Builds an object with optional start/end properties.
    // Indicates the minimum/maximum dates to display.
    // not responsible for trimming hidden days.
    DateProfileGenerator.prototype.buildValidRange = function () {
        var input = this.props.validRangeInput;
        var simpleInput = typeof input === 'function'
            ? input.call(this.props.calendarApi, this.nowDate)
            : input;
        return this.refineRange(simpleInput) ||
            { start: null, end: null }; // completely open-ended
    };
    // Builds a structure with info about the "current" range, the range that is
    // highlighted as being the current month for example.
    // See build() for a description of `direction`.
    // Guaranteed to have `range` and `unit` properties. `duration` is optional.
    DateProfileGenerator.prototype.buildCurrentRangeInfo = function (date, direction) {
        var props = this.props;
        var duration = null;
        var unit = null;
        var range = null;
        var dayCount;
        if (props.duration) {
            duration = props.duration;
            unit = props.durationUnit;
            range = this.buildRangeFromDuration(date, direction, duration, unit);
        }
        else if ((dayCount = this.props.dayCount)) {
            unit = 'day';
            range = this.buildRangeFromDayCount(date, direction, dayCount);
        }
        else if ((range = this.buildCustomVisibleRange(date))) {
            unit = props.dateEnv.greatestWholeUnit(range.start, range.end).unit;
        }
        else {
            duration = this.getFallbackDuration();
            unit = greatestDurationDenominator(duration).unit;
            range = this.buildRangeFromDuration(date, direction, duration, unit);
        }
        return { duration: duration, unit: unit, range: range };
    };
    DateProfileGenerator.prototype.getFallbackDuration = function () {
        return createDuration({ day: 1 });
    };
    // Returns a new activeRange to have time values (un-ambiguate)
    // slotMinTime or slotMaxTime causes the range to expand.
    DateProfileGenerator.prototype.adjustActiveRange = function (range) {
        var _a = this.props, dateEnv = _a.dateEnv, usesMinMaxTime = _a.usesMinMaxTime, slotMinTime = _a.slotMinTime, slotMaxTime = _a.slotMaxTime;
        var start = range.start, end = range.end;
        if (usesMinMaxTime) {
            // expand active range if slotMinTime is negative (why not when positive?)
            if (asRoughDays(slotMinTime) < 0) {
                start = startOfDay(start); // necessary?
                start = dateEnv.add(start, slotMinTime);
            }
            // expand active range if slotMaxTime is beyond one day (why not when negative?)
            if (asRoughDays(slotMaxTime) > 1) {
                end = startOfDay(end); // necessary?
                end = addDays(end, -1);
                end = dateEnv.add(end, slotMaxTime);
            }
        }
        return { start: start, end: end };
    };
    // Builds the "current" range when it is specified as an explicit duration.
    // `unit` is the already-computed greatestDurationDenominator unit of duration.
    DateProfileGenerator.prototype.buildRangeFromDuration = function (date, direction, duration, unit) {
        var _a = this.props, dateEnv = _a.dateEnv, dateAlignment = _a.dateAlignment;
        var start;
        var end;
        var res;
        // compute what the alignment should be
        if (!dateAlignment) {
            var dateIncrement = this.props.dateIncrement;
            if (dateIncrement) {
                // use the smaller of the two units
                if (asRoughMs(dateIncrement) < asRoughMs(duration)) {
                    dateAlignment = greatestDurationDenominator(dateIncrement).unit;
                }
                else {
                    dateAlignment = unit;
                }
            }
            else {
                dateAlignment = unit;
            }
        }
        // if the view displays a single day or smaller
        if (asRoughDays(duration) <= 1) {
            if (this.isHiddenDay(start)) {
                start = this.skipHiddenDays(start, direction);
                start = startOfDay(start);
            }
        }
        function computeRes() {
            start = dateEnv.startOf(date, dateAlignment);
            end = dateEnv.add(start, duration);
            res = { start: start, end: end };
        }
        computeRes();
        // if range is completely enveloped by hidden days, go past the hidden days
        if (!this.trimHiddenDays(res)) {
            date = this.skipHiddenDays(date, direction);
            computeRes();
        }
        return res;
    };
    // Builds the "current" range when a dayCount is specified.
    DateProfileGenerator.prototype.buildRangeFromDayCount = function (date, direction, dayCount) {
        var _a = this.props, dateEnv = _a.dateEnv, dateAlignment = _a.dateAlignment;
        var runningCount = 0;
        var start = date;
        var end;
        if (dateAlignment) {
            start = dateEnv.startOf(start, dateAlignment);
        }
        start = startOfDay(start);
        start = this.skipHiddenDays(start, direction);
        end = start;
        do {
            end = addDays(end, 1);
            if (!this.isHiddenDay(end)) {
                runningCount += 1;
            }
        } while (runningCount < dayCount);
        return { start: start, end: end };
    };
    // Builds a normalized range object for the "visible" range,
    // which is a way to define the currentRange and activeRange at the same time.
    DateProfileGenerator.prototype.buildCustomVisibleRange = function (date) {
        var props = this.props;
        var input = props.visibleRangeInput;
        var simpleInput = typeof input === 'function'
            ? input.call(props.calendarApi, props.dateEnv.toDate(date))
            : input;
        var range = this.refineRange(simpleInput);
        if (range && (range.start == null || range.end == null)) {
            return null;
        }
        return range;
    };
    // Computes the range that will represent the element/cells for *rendering*,
    // but which may have voided days/times.
    // not responsible for trimming hidden days.
    DateProfileGenerator.prototype.buildRenderRange = function (currentRange, currentRangeUnit, isRangeAllDay) {
        return currentRange;
    };
    // Compute the duration value that should be added/substracted to the current date
    // when a prev/next operation happens.
    DateProfileGenerator.prototype.buildDateIncrement = function (fallback) {
        var dateIncrement = this.props.dateIncrement;
        var customAlignment;
        if (dateIncrement) {
            return dateIncrement;
        }
        if ((customAlignment = this.props.dateAlignment)) {
            return createDuration(1, customAlignment);
        }
        if (fallback) {
            return fallback;
        }
        return createDuration({ days: 1 });
    };
    DateProfileGenerator.prototype.refineRange = function (rangeInput) {
        if (rangeInput) {
            var range = parseRange(rangeInput, this.props.dateEnv);
            if (range) {
                range = computeVisibleDayRange(range);
            }
            return range;
        }
        return null;
    };
    /* Hidden Days
    ------------------------------------------------------------------------------------------------------------------*/
    // Initializes internal variables related to calculating hidden days-of-week
    DateProfileGenerator.prototype.initHiddenDays = function () {
        var hiddenDays = this.props.hiddenDays || []; // array of day-of-week indices that are hidden
        var isHiddenDayHash = []; // is the day-of-week hidden? (hash with day-of-week-index -> bool)
        var dayCnt = 0;
        var i;
        if (this.props.weekends === false) {
            hiddenDays.push(0, 6); // 0=sunday, 6=saturday
        }
        for (i = 0; i < 7; i += 1) {
            if (!(isHiddenDayHash[i] = hiddenDays.indexOf(i) !== -1)) {
                dayCnt += 1;
            }
        }
        if (!dayCnt) {
            throw new Error('invalid hiddenDays'); // all days were hidden? bad.
        }
        this.isHiddenDayHash = isHiddenDayHash;
    };
    // Remove days from the beginning and end of the range that are computed as hidden.
    // If the whole range is trimmed off, returns null
    DateProfileGenerator.prototype.trimHiddenDays = function (range) {
        var start = range.start, end = range.end;
        if (start) {
            start = this.skipHiddenDays(start);
        }
        if (end) {
            end = this.skipHiddenDays(end, -1, true);
        }
        if (start == null || end == null || start < end) {
            return { start: start, end: end };
        }
        return null;
    };
    // Is the current day hidden?
    // `day` is a day-of-week index (0-6), or a Date (used for UTC)
    DateProfileGenerator.prototype.isHiddenDay = function (day) {
        if (day instanceof Date) {
            day = day.getUTCDay();
        }
        return this.isHiddenDayHash[day];
    };
    // Incrementing the current day until it is no longer a hidden day, returning a copy.
    // DOES NOT CONSIDER validRange!
    // If the initial value of `date` is not a hidden day, don't do anything.
    // Pass `isExclusive` as `true` if you are dealing with an end date.
    // `inc` defaults to `1` (increment one day forward each time)
    DateProfileGenerator.prototype.skipHiddenDays = function (date, inc, isExclusive) {
        if (inc === void 0) { inc = 1; }
        if (isExclusive === void 0) { isExclusive = false; }
        while (this.isHiddenDayHash[(date.getUTCDay() + (isExclusive ? inc : 0) + 7) % 7]) {
            date = addDays(date, inc);
        }
        return date;
    };
    return DateProfileGenerator;
}());

function reduceViewType(viewType, action) {
    switch (action.type) {
        case 'CHANGE_VIEW_TYPE':
            viewType = action.viewType;
    }
    return viewType;
}

function reduceDynamicOptionOverrides(dynamicOptionOverrides, action) {
    var _a;
    switch (action.type) {
        case 'SET_OPTION':
            return tslib.__assign(tslib.__assign({}, dynamicOptionOverrides), (_a = {}, _a[action.optionName] = action.rawOptionValue, _a));
        default:
            return dynamicOptionOverrides;
    }
}

function reduceDateProfile(currentDateProfile, action, currentDate, dateProfileGenerator) {
    var dp;
    switch (action.type) {
        case 'CHANGE_VIEW_TYPE':
            return dateProfileGenerator.build(action.dateMarker || currentDate);
        case 'CHANGE_DATE':
            return dateProfileGenerator.build(action.dateMarker);
        case 'PREV':
            dp = dateProfileGenerator.buildPrev(currentDateProfile, currentDate);
            if (dp.isValid) {
                return dp;
            }
            break;
        case 'NEXT':
            dp = dateProfileGenerator.buildNext(currentDateProfile, currentDate);
            if (dp.isValid) {
                return dp;
            }
            break;
    }
    return currentDateProfile;
}

function initEventSources(calendarOptions, dateProfile, context) {
    var activeRange = dateProfile ? dateProfile.activeRange : null;
    return addSources({}, parseInitialSources(calendarOptions, context), activeRange, context);
}
function reduceEventSources(eventSources, action, dateProfile, context) {
    var activeRange = dateProfile ? dateProfile.activeRange : null; // need this check?
    switch (action.type) {
        case 'ADD_EVENT_SOURCES': // already parsed
            return addSources(eventSources, action.sources, activeRange, context);
        case 'REMOVE_EVENT_SOURCE':
            return removeSource(eventSources, action.sourceId);
        case 'PREV': // TODO: how do we track all actions that affect dateProfile :(
        case 'NEXT':
        case 'CHANGE_DATE':
        case 'CHANGE_VIEW_TYPE':
            if (dateProfile) {
                return fetchDirtySources(eventSources, activeRange, context);
            }
            return eventSources;
        case 'FETCH_EVENT_SOURCES':
            return fetchSourcesByIds(eventSources, action.sourceIds ? // why no type?
                arrayToHash(action.sourceIds) :
                excludeStaticSources(eventSources, context), activeRange, action.isRefetch || false, context);
        case 'RECEIVE_EVENTS':
        case 'RECEIVE_EVENT_ERROR':
            return receiveResponse(eventSources, action.sourceId, action.fetchId, action.fetchRange);
        case 'REMOVE_ALL_EVENT_SOURCES':
            return {};
        default:
            return eventSources;
    }
}
function reduceEventSourcesNewTimeZone(eventSources, dateProfile, context) {
    var activeRange = dateProfile ? dateProfile.activeRange : null; // need this check?
    return fetchSourcesByIds(eventSources, excludeStaticSources(eventSources, context), activeRange, true, context);
}
function computeEventSourcesLoading(eventSources) {
    for (var sourceId in eventSources) {
        if (eventSources[sourceId].isFetching) {
            return true;
        }
    }
    return false;
}
function addSources(eventSourceHash, sources, fetchRange, context) {
    var hash = {};
    for (var _i = 0, sources_1 = sources; _i < sources_1.length; _i++) {
        var source = sources_1[_i];
        hash[source.sourceId] = source;
    }
    if (fetchRange) {
        hash = fetchDirtySources(hash, fetchRange, context);
    }
    return tslib.__assign(tslib.__assign({}, eventSourceHash), hash);
}
function removeSource(eventSourceHash, sourceId) {
    return filterHash(eventSourceHash, function (eventSource) { return eventSource.sourceId !== sourceId; });
}
function fetchDirtySources(sourceHash, fetchRange, context) {
    return fetchSourcesByIds(sourceHash, filterHash(sourceHash, function (eventSource) { return isSourceDirty(eventSource, fetchRange, context); }), fetchRange, false, context);
}
function isSourceDirty(eventSource, fetchRange, context) {
    if (!doesSourceNeedRange(eventSource, context)) {
        return !eventSource.latestFetchId;
    }
    return !context.options.lazyFetching ||
        !eventSource.fetchRange ||
        eventSource.isFetching || // always cancel outdated in-progress fetches
        fetchRange.start < eventSource.fetchRange.start ||
        fetchRange.end > eventSource.fetchRange.end;
}
function fetchSourcesByIds(prevSources, sourceIdHash, fetchRange, isRefetch, context) {
    var nextSources = {};
    for (var sourceId in prevSources) {
        var source = prevSources[sourceId];
        if (sourceIdHash[sourceId]) {
            nextSources[sourceId] = fetchSource(source, fetchRange, isRefetch, context);
        }
        else {
            nextSources[sourceId] = source;
        }
    }
    return nextSources;
}
function fetchSource(eventSource, fetchRange, isRefetch, context) {
    var options = context.options, calendarApi = context.calendarApi;
    var sourceDef = context.pluginHooks.eventSourceDefs[eventSource.sourceDefId];
    var fetchId = guid();
    sourceDef.fetch({
        eventSource: eventSource,
        range: fetchRange,
        isRefetch: isRefetch,
        context: context,
    }, function (res) {
        var rawEvents = res.rawEvents;
        if (options.eventSourceSuccess) {
            rawEvents = options.eventSourceSuccess.call(calendarApi, rawEvents, res.xhr) || rawEvents;
        }
        if (eventSource.success) {
            rawEvents = eventSource.success.call(calendarApi, rawEvents, res.xhr) || rawEvents;
        }
        context.dispatch({
            type: 'RECEIVE_EVENTS',
            sourceId: eventSource.sourceId,
            fetchId: fetchId,
            fetchRange: fetchRange,
            rawEvents: rawEvents,
        });
    }, function (error) {
        console.warn(error.message, error);
        if (options.eventSourceFailure) {
            options.eventSourceFailure.call(calendarApi, error);
        }
        if (eventSource.failure) {
            eventSource.failure(error);
        }
        context.dispatch({
            type: 'RECEIVE_EVENT_ERROR',
            sourceId: eventSource.sourceId,
            fetchId: fetchId,
            fetchRange: fetchRange,
            error: error,
        });
    });
    return tslib.__assign(tslib.__assign({}, eventSource), { isFetching: true, latestFetchId: fetchId });
}
function receiveResponse(sourceHash, sourceId, fetchId, fetchRange) {
    var _a;
    var eventSource = sourceHash[sourceId];
    if (eventSource && // not already removed
        fetchId === eventSource.latestFetchId) {
        return tslib.__assign(tslib.__assign({}, sourceHash), (_a = {}, _a[sourceId] = tslib.__assign(tslib.__assign({}, eventSource), { isFetching: false, fetchRange: fetchRange }), _a));
    }
    return sourceHash;
}
function excludeStaticSources(eventSources, context) {
    return filterHash(eventSources, function (eventSource) { return doesSourceNeedRange(eventSource, context); });
}
function parseInitialSources(rawOptions, context) {
    var refiners = buildEventSourceRefiners(context);
    var rawSources = [].concat(rawOptions.eventSources || []);
    var sources = []; // parsed
    if (rawOptions.initialEvents) {
        rawSources.unshift(rawOptions.initialEvents);
    }
    if (rawOptions.events) {
        rawSources.unshift(rawOptions.events);
    }
    for (var _i = 0, rawSources_1 = rawSources; _i < rawSources_1.length; _i++) {
        var rawSource = rawSources_1[_i];
        var source = parseEventSource(rawSource, context, refiners);
        if (source) {
            sources.push(source);
        }
    }
    return sources;
}
function doesSourceNeedRange(eventSource, context) {
    var defs = context.pluginHooks.eventSourceDefs;
    return !defs[eventSource.sourceDefId].ignoreRange;
}

function reduceEventStore(eventStore, action, eventSources, dateProfile, context) {
    switch (action.type) {
        case 'RECEIVE_EVENTS': // raw
            return receiveRawEvents(eventStore, eventSources[action.sourceId], action.fetchId, action.fetchRange, action.rawEvents, context);
        case 'ADD_EVENTS': // already parsed, but not expanded
            return addEvent(eventStore, action.eventStore, // new ones
            dateProfile ? dateProfile.activeRange : null, context);
        case 'RESET_EVENTS':
            return action.eventStore;
        case 'MERGE_EVENTS': // already parsed and expanded
            return mergeEventStores(eventStore, action.eventStore);
        case 'PREV': // TODO: how do we track all actions that affect dateProfile :(
        case 'NEXT':
        case 'CHANGE_DATE':
        case 'CHANGE_VIEW_TYPE':
            if (dateProfile) {
                return expandRecurring(eventStore, dateProfile.activeRange, context);
            }
            return eventStore;
        case 'REMOVE_EVENTS':
            return excludeSubEventStore(eventStore, action.eventStore);
        case 'REMOVE_EVENT_SOURCE':
            return excludeEventsBySourceId(eventStore, action.sourceId);
        case 'REMOVE_ALL_EVENT_SOURCES':
            return filterEventStoreDefs(eventStore, function (eventDef) { return (!eventDef.sourceId // only keep events with no source id
            ); });
        case 'REMOVE_ALL_EVENTS':
            return createEmptyEventStore();
        default:
            return eventStore;
    }
}
function receiveRawEvents(eventStore, eventSource, fetchId, fetchRange, rawEvents, context) {
    if (eventSource && // not already removed
        fetchId === eventSource.latestFetchId // TODO: wish this logic was always in event-sources
    ) {
        var subset = parseEvents(transformRawEvents(rawEvents, eventSource, context), eventSource, context);
        if (fetchRange) {
            subset = expandRecurring(subset, fetchRange, context);
        }
        return mergeEventStores(excludeEventsBySourceId(eventStore, eventSource.sourceId), subset);
    }
    return eventStore;
}
function transformRawEvents(rawEvents, eventSource, context) {
    var calEachTransform = context.options.eventDataTransform;
    var sourceEachTransform = eventSource ? eventSource.eventDataTransform : null;
    if (sourceEachTransform) {
        rawEvents = transformEachRawEvent(rawEvents, sourceEachTransform);
    }
    if (calEachTransform) {
        rawEvents = transformEachRawEvent(rawEvents, calEachTransform);
    }
    return rawEvents;
}
function transformEachRawEvent(rawEvents, func) {
    var refinedEvents;
    if (!func) {
        refinedEvents = rawEvents;
    }
    else {
        refinedEvents = [];
        for (var _i = 0, rawEvents_1 = rawEvents; _i < rawEvents_1.length; _i++) {
            var rawEvent = rawEvents_1[_i];
            var refinedEvent = func(rawEvent);
            if (refinedEvent) {
                refinedEvents.push(refinedEvent);
            }
            else if (refinedEvent == null) {
                refinedEvents.push(rawEvent);
            } // if a different falsy value, do nothing
        }
    }
    return refinedEvents;
}
function addEvent(eventStore, subset, expandRange, context) {
    if (expandRange) {
        subset = expandRecurring(subset, expandRange, context);
    }
    return mergeEventStores(eventStore, subset);
}
function rezoneEventStoreDates(eventStore, oldDateEnv, newDateEnv) {
    var defs = eventStore.defs;
    var instances = mapHash(eventStore.instances, function (instance) {
        var def = defs[instance.defId];
        if (def.allDay || def.recurringDef) {
            return instance; // isn't dependent on timezone
        }
        return tslib.__assign(tslib.__assign({}, instance), { range: {
                start: newDateEnv.createMarker(oldDateEnv.toDate(instance.range.start, instance.forcedStartTzo)),
                end: newDateEnv.createMarker(oldDateEnv.toDate(instance.range.end, instance.forcedEndTzo)),
            }, forcedStartTzo: newDateEnv.canComputeOffset ? null : instance.forcedStartTzo, forcedEndTzo: newDateEnv.canComputeOffset ? null : instance.forcedEndTzo });
    });
    return { defs: defs, instances: instances };
}
function excludeEventsBySourceId(eventStore, sourceId) {
    return filterEventStoreDefs(eventStore, function (eventDef) { return eventDef.sourceId !== sourceId; });
}
// QUESTION: why not just return instances? do a general object-property-exclusion util
function excludeInstances(eventStore, removals) {
    return {
        defs: eventStore.defs,
        instances: filterHash(eventStore.instances, function (instance) { return !removals[instance.instanceId]; }),
    };
}

function reduceDateSelection(currentSelection, action) {
    switch (action.type) {
        case 'UNSELECT_DATES':
            return null;
        case 'SELECT_DATES':
            return action.selection;
        default:
            return currentSelection;
    }
}

function reduceSelectedEvent(currentInstanceId, action) {
    switch (action.type) {
        case 'UNSELECT_EVENT':
            return '';
        case 'SELECT_EVENT':
            return action.eventInstanceId;
        default:
            return currentInstanceId;
    }
}

function reduceEventDrag(currentDrag, action) {
    var newDrag;
    switch (action.type) {
        case 'UNSET_EVENT_DRAG':
            return null;
        case 'SET_EVENT_DRAG':
            newDrag = action.state;
            return {
                affectedEvents: newDrag.affectedEvents,
                mutatedEvents: newDrag.mutatedEvents,
                isEvent: newDrag.isEvent,
            };
        default:
            return currentDrag;
    }
}

function reduceEventResize(currentResize, action) {
    var newResize;
    switch (action.type) {
        case 'UNSET_EVENT_RESIZE':
            return null;
        case 'SET_EVENT_RESIZE':
            newResize = action.state;
            return {
                affectedEvents: newResize.affectedEvents,
                mutatedEvents: newResize.mutatedEvents,
                isEvent: newResize.isEvent,
            };
        default:
            return currentResize;
    }
}

function parseToolbars(calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) {
    var viewsWithButtons = [];
    var headerToolbar = calendarOptions.headerToolbar ? parseToolbar(calendarOptions.headerToolbar, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi, viewsWithButtons) : null;
    var footerToolbar = calendarOptions.footerToolbar ? parseToolbar(calendarOptions.footerToolbar, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi, viewsWithButtons) : null;
    return { headerToolbar: headerToolbar, footerToolbar: footerToolbar, viewsWithButtons: viewsWithButtons };
}
function parseToolbar(sectionStrHash, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi, viewsWithButtons) {
    return mapHash(sectionStrHash, function (sectionStr) { return parseSection(sectionStr, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi, viewsWithButtons); });
}
/*
BAD: querying icons and text here. should be done at render time
*/
function parseSection(sectionStr, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi, viewsWithButtons) {
    var isRtl = calendarOptions.direction === 'rtl';
    var calendarCustomButtons = calendarOptions.customButtons || {};
    var calendarButtonTextOverrides = calendarOptionOverrides.buttonText || {};
    var calendarButtonText = calendarOptions.buttonText || {};
    var sectionSubstrs = sectionStr ? sectionStr.split(' ') : [];
    return sectionSubstrs.map(function (buttonGroupStr) { return (buttonGroupStr.split(',').map(function (buttonName) {
        if (buttonName === 'title') {
            return { buttonName: buttonName };
        }
        var customButtonProps;
        var viewSpec;
        var buttonClick;
        var buttonIcon; // only one of these will be set
        var buttonText; // "
        if ((customButtonProps = calendarCustomButtons[buttonName])) {
            buttonClick = function (ev) {
                if (customButtonProps.click) {
                    customButtonProps.click.call(ev.target, ev, ev.target); // TODO: use Calendar this context?
                }
            };
            (buttonIcon = theme.getCustomButtonIconClass(customButtonProps)) ||
                (buttonIcon = theme.getIconClass(buttonName, isRtl)) ||
                (buttonText = customButtonProps.text);
        }
        else if ((viewSpec = viewSpecs[buttonName])) {
            viewsWithButtons.push(buttonName);
            buttonClick = function () {
                calendarApi.changeView(buttonName);
            };
            (buttonText = viewSpec.buttonTextOverride) ||
                (buttonIcon = theme.getIconClass(buttonName, isRtl)) ||
                (buttonText = viewSpec.buttonTextDefault);
        }
        else if (calendarApi[buttonName]) { // a calendarApi method
            buttonClick = function () {
                calendarApi[buttonName]();
            };
            (buttonText = calendarButtonTextOverrides[buttonName]) ||
                (buttonIcon = theme.getIconClass(buttonName, isRtl)) ||
                (buttonText = calendarButtonText[buttonName]);
            //            ^ everything else is considered default
        }
        return { buttonName: buttonName, buttonClick: buttonClick, buttonIcon: buttonIcon, buttonText: buttonText };
    })); });
}

var eventSourceDef$2 = {
    ignoreRange: true,
    parseMeta: function (refined) {
        if (Array.isArray(refined.events)) {
            return refined.events;
        }
        return null;
    },
    fetch: function (arg, success) {
        success({
            rawEvents: arg.eventSource.meta,
        });
    },
};
var arrayEventSourcePlugin = createPlugin({
    eventSourceDefs: [eventSourceDef$2],
});

var eventSourceDef$1 = {
    parseMeta: function (refined) {
        if (typeof refined.events === 'function') {
            return refined.events;
        }
        return null;
    },
    fetch: function (arg, success, failure) {
        var dateEnv = arg.context.dateEnv;
        var func = arg.eventSource.meta;
        unpromisify(func.bind(null, buildRangeApiWithTimeZone(arg.range, dateEnv)), function (rawEvents) {
            success({ rawEvents: rawEvents }); // needs an object response
        }, failure);
    },
};
var funcEventSourcePlugin = createPlugin({
    eventSourceDefs: [eventSourceDef$1],
});

function requestJson(method, url, params, successCallback, failureCallback) {
    method = method.toUpperCase();
    var body = null;
    if (method === 'GET') {
        url = injectQueryStringParams(url, params);
    }
    else {
        body = encodeParams(params);
    }
    var xhr = new XMLHttpRequest();
    xhr.open(method, url, true);
    if (method !== 'GET') {
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    }
    xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 400) {
            var parsed = false;
            var res = void 0;
            try {
                res = JSON.parse(xhr.responseText);
                parsed = true;
            }
            catch (err) {
                // will handle parsed=false
            }
            if (parsed) {
                successCallback(res, xhr);
            }
            else {
                failureCallback('Failure parsing JSON', xhr);
            }
        }
        else {
            failureCallback('Request failed', xhr);
        }
    };
    xhr.onerror = function () {
        failureCallback('Request failed', xhr);
    };
    xhr.send(body);
}
function injectQueryStringParams(url, params) {
    return url +
        (url.indexOf('?') === -1 ? '?' : '&') +
        encodeParams(params);
}
function encodeParams(params) {
    var parts = [];
    for (var key in params) {
        parts.push(encodeURIComponent(key) + "=" + encodeURIComponent(params[key]));
    }
    return parts.join('&');
}

var JSON_FEED_EVENT_SOURCE_REFINERS = {
    method: String,
    extraParams: identity,
    startParam: String,
    endParam: String,
    timeZoneParam: String,
};

var eventSourceDef = {
    parseMeta: function (refined) {
        if (refined.url && (refined.format === 'json' || !refined.format)) {
            return {
                url: refined.url,
                format: 'json',
                method: (refined.method || 'GET').toUpperCase(),
                extraParams: refined.extraParams,
                startParam: refined.startParam,
                endParam: refined.endParam,
                timeZoneParam: refined.timeZoneParam,
            };
        }
        return null;
    },
    fetch: function (arg, success, failure) {
        var meta = arg.eventSource.meta;
        var requestParams = buildRequestParams(meta, arg.range, arg.context);
        requestJson(meta.method, meta.url, requestParams, function (rawEvents, xhr) {
            success({ rawEvents: rawEvents, xhr: xhr });
        }, function (errorMessage, xhr) {
            failure({ message: errorMessage, xhr: xhr });
        });
    },
};
var jsonFeedEventSourcePlugin = createPlugin({
    eventSourceRefiners: JSON_FEED_EVENT_SOURCE_REFINERS,
    eventSourceDefs: [eventSourceDef],
});
function buildRequestParams(meta, range, context) {
    var dateEnv = context.dateEnv, options = context.options;
    var startParam;
    var endParam;
    var timeZoneParam;
    var customRequestParams;
    var params = {};
    startParam = meta.startParam;
    if (startParam == null) {
        startParam = options.startParam;
    }
    endParam = meta.endParam;
    if (endParam == null) {
        endParam = options.endParam;
    }
    timeZoneParam = meta.timeZoneParam;
    if (timeZoneParam == null) {
        timeZoneParam = options.timeZoneParam;
    }
    // retrieve any outbound GET/POST data from the options
    if (typeof meta.extraParams === 'function') {
        // supplied as a function that returns a key/value object
        customRequestParams = meta.extraParams();
    }
    else {
        // probably supplied as a straight key/value object
        customRequestParams = meta.extraParams || {};
    }
    tslib.__assign(params, customRequestParams);
    params[startParam] = dateEnv.formatIso(range.start);
    params[endParam] = dateEnv.formatIso(range.end);
    if (dateEnv.timeZone !== 'local') {
        params[timeZoneParam] = dateEnv.timeZone;
    }
    return params;
}

var SIMPLE_RECURRING_REFINERS = {
    daysOfWeek: identity,
    startTime: createDuration,
    endTime: createDuration,
    duration: createDuration,
    startRecur: identity,
    endRecur: identity,
};

var recurring = {
    parse: function (refined, dateEnv) {
        if (refined.daysOfWeek || refined.startTime || refined.endTime || refined.startRecur || refined.endRecur) {
            var recurringData = {
                daysOfWeek: refined.daysOfWeek || null,
                startTime: refined.startTime || null,
                endTime: refined.endTime || null,
                startRecur: refined.startRecur ? dateEnv.createMarker(refined.startRecur) : null,
                endRecur: refined.endRecur ? dateEnv.createMarker(refined.endRecur) : null,
            };
            var duration = void 0;
            if (refined.duration) {
                duration = refined.duration;
            }
            if (!duration && refined.startTime && refined.endTime) {
                duration = subtractDurations(refined.endTime, refined.startTime);
            }
            return {
                allDayGuess: Boolean(!refined.startTime && !refined.endTime),
                duration: duration,
                typeData: recurringData, // doesn't need endTime anymore but oh well
            };
        }
        return null;
    },
    expand: function (typeData, framingRange, dateEnv) {
        var clippedFramingRange = intersectRanges(framingRange, { start: typeData.startRecur, end: typeData.endRecur });
        if (clippedFramingRange) {
            return expandRanges(typeData.daysOfWeek, typeData.startTime, clippedFramingRange, dateEnv);
        }
        return [];
    },
};
var simpleRecurringEventsPlugin = createPlugin({
    recurringTypes: [recurring],
    eventRefiners: SIMPLE_RECURRING_REFINERS,
});
function expandRanges(daysOfWeek, startTime, framingRange, dateEnv) {
    var dowHash = daysOfWeek ? arrayToHash(daysOfWeek) : null;
    var dayMarker = startOfDay(framingRange.start);
    var endMarker = framingRange.end;
    var instanceStarts = [];
    while (dayMarker < endMarker) {
        var instanceStart 
        // if everyday, or this particular day-of-week
        = void 0;
        // if everyday, or this particular day-of-week
        if (!dowHash || dowHash[dayMarker.getUTCDay()]) {
            if (startTime) {
                instanceStart = dateEnv.add(dayMarker, startTime);
            }
            else {
                instanceStart = dayMarker;
            }
            instanceStarts.push(instanceStart);
        }
        dayMarker = addDays(dayMarker, 1);
    }
    return instanceStarts;
}

var changeHandlerPlugin = createPlugin({
    optionChangeHandlers: {
        events: function (events, context) {
            handleEventSources([events], context);
        },
        eventSources: handleEventSources,
    },
});
/*
BUG: if `event` was supplied, all previously-given `eventSources` will be wiped out
*/
function handleEventSources(inputs, context) {
    var unfoundSources = hashValuesToArray(context.getCurrentData().eventSources);
    var newInputs = [];
    for (var _i = 0, inputs_1 = inputs; _i < inputs_1.length; _i++) {
        var input = inputs_1[_i];
        var inputFound = false;
        for (var i = 0; i < unfoundSources.length; i += 1) {
            if (unfoundSources[i]._raw === input) {
                unfoundSources.splice(i, 1); // delete
                inputFound = true;
                break;
            }
        }
        if (!inputFound) {
            newInputs.push(input);
        }
    }
    for (var _a = 0, unfoundSources_1 = unfoundSources; _a < unfoundSources_1.length; _a++) {
        var unfoundSource = unfoundSources_1[_a];
        context.dispatch({
            type: 'REMOVE_EVENT_SOURCE',
            sourceId: unfoundSource.sourceId,
        });
    }
    for (var _b = 0, newInputs_1 = newInputs; _b < newInputs_1.length; _b++) {
        var newInput = newInputs_1[_b];
        context.calendarApi.addEventSource(newInput);
    }
}

function handleDateProfile(dateProfile, context) {
    context.emitter.trigger('datesSet', tslib.__assign(tslib.__assign({}, buildRangeApiWithTimeZone(dateProfile.activeRange, context.dateEnv)), { view: context.viewApi }));
}

function handleEventStore(eventStore, context) {
    var emitter = context.emitter;
    if (emitter.hasHandlers('eventsSet')) {
        emitter.trigger('eventsSet', buildEventApis(eventStore, context));
    }
}

/*
this array is exposed on the root namespace so that UMD plugins can add to it.
see the rollup-bundles script.
*/
var globalPlugins = [
    arrayEventSourcePlugin,
    funcEventSourcePlugin,
    jsonFeedEventSourcePlugin,
    simpleRecurringEventsPlugin,
    changeHandlerPlugin,
    createPlugin({
        isLoadingFuncs: [
            function (state) { return computeEventSourcesLoading(state.eventSources); },
        ],
        contentTypeHandlers: {
            html: function () { return ({ render: injectHtml }); },
            domNodes: function () { return ({ render: injectDomNodes }); },
        },
        propSetHandlers: {
            dateProfile: handleDateProfile,
            eventStore: handleEventStore,
        },
    }),
];
function injectHtml(el, html) {
    el.innerHTML = html;
}
function injectDomNodes(el, domNodes) {
    var oldNodes = Array.prototype.slice.call(el.childNodes); // TODO: use array util
    var newNodes = Array.prototype.slice.call(domNodes); // TODO: use array util
    if (!isArraysEqual(oldNodes, newNodes)) {
        for (var _i = 0, newNodes_1 = newNodes; _i < newNodes_1.length; _i++) {
            var newNode = newNodes_1[_i];
            el.appendChild(newNode);
        }
        oldNodes.forEach(removeElement);
    }
}

var DelayedRunner = /** @class */ (function () {
    function DelayedRunner(drainedOption) {
        this.drainedOption = drainedOption;
        this.isRunning = false;
        this.isDirty = false;
        this.pauseDepths = {};
        this.timeoutId = 0;
    }
    DelayedRunner.prototype.request = function (delay) {
        this.isDirty = true;
        if (!this.isPaused()) {
            this.clearTimeout();
            if (delay == null) {
                this.tryDrain();
            }
            else {
                this.timeoutId = setTimeout(// NOT OPTIMAL! TODO: look at debounce
                this.tryDrain.bind(this), delay);
            }
        }
    };
    DelayedRunner.prototype.pause = function (scope) {
        if (scope === void 0) { scope = ''; }
        var pauseDepths = this.pauseDepths;
        pauseDepths[scope] = (pauseDepths[scope] || 0) + 1;
        this.clearTimeout();
    };
    DelayedRunner.prototype.resume = function (scope, force) {
        if (scope === void 0) { scope = ''; }
        var pauseDepths = this.pauseDepths;
        if (scope in pauseDepths) {
            if (force) {
                delete pauseDepths[scope];
            }
            else {
                pauseDepths[scope] -= 1;
                var depth = pauseDepths[scope];
                if (depth <= 0) {
                    delete pauseDepths[scope];
                }
            }
            this.tryDrain();
        }
    };
    DelayedRunner.prototype.isPaused = function () {
        return Object.keys(this.pauseDepths).length;
    };
    DelayedRunner.prototype.tryDrain = function () {
        if (!this.isRunning && !this.isPaused()) {
            this.isRunning = true;
            while (this.isDirty) {
                this.isDirty = false;
                this.drained(); // might set isDirty to true again
            }
            this.isRunning = false;
        }
    };
    DelayedRunner.prototype.clear = function () {
        this.clearTimeout();
        this.isDirty = false;
        this.pauseDepths = {};
    };
    DelayedRunner.prototype.clearTimeout = function () {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
            this.timeoutId = 0;
        }
    };
    DelayedRunner.prototype.drained = function () {
        if (this.drainedOption) {
            this.drainedOption();
        }
    };
    return DelayedRunner;
}());

var TaskRunner = /** @class */ (function () {
    function TaskRunner(runTaskOption, drainedOption) {
        this.runTaskOption = runTaskOption;
        this.drainedOption = drainedOption;
        this.queue = [];
        this.delayedRunner = new DelayedRunner(this.drain.bind(this));
    }
    TaskRunner.prototype.request = function (task, delay) {
        this.queue.push(task);
        this.delayedRunner.request(delay);
    };
    TaskRunner.prototype.pause = function (scope) {
        this.delayedRunner.pause(scope);
    };
    TaskRunner.prototype.resume = function (scope, force) {
        this.delayedRunner.resume(scope, force);
    };
    TaskRunner.prototype.drain = function () {
        var queue = this.queue;
        while (queue.length) {
            var completedTasks = [];
            var task = void 0;
            while ((task = queue.shift())) {
                this.runTask(task);
                completedTasks.push(task);
            }
            this.drained(completedTasks);
        } // keep going, in case new tasks were added in the drained handler
    };
    TaskRunner.prototype.runTask = function (task) {
        if (this.runTaskOption) {
            this.runTaskOption(task);
        }
    };
    TaskRunner.prototype.drained = function (completedTasks) {
        if (this.drainedOption) {
            this.drainedOption(completedTasks);
        }
    };
    return TaskRunner;
}());

// Computes what the title at the top of the calendarApi should be for this view
function buildTitle(dateProfile, viewOptions, dateEnv) {
    var range;
    // for views that span a large unit of time, show the proper interval, ignoring stray days before and after
    if (/^(year|month)$/.test(dateProfile.currentRangeUnit)) {
        range = dateProfile.currentRange;
    }
    else { // for day units or smaller, use the actual day range
        range = dateProfile.activeRange;
    }
    return dateEnv.formatRange(range.start, range.end, createFormatter(viewOptions.titleFormat || buildTitleFormat(dateProfile)), {
        isEndExclusive: dateProfile.isRangeAllDay,
        defaultSeparator: viewOptions.titleRangeSeparator,
    });
}
// Generates the format string that should be used to generate the title for the current date range.
// Attempts to compute the most appropriate format if not explicitly specified with `titleFormat`.
function buildTitleFormat(dateProfile) {
    var currentRangeUnit = dateProfile.currentRangeUnit;
    if (currentRangeUnit === 'year') {
        return { year: 'numeric' };
    }
    if (currentRangeUnit === 'month') {
        return { year: 'numeric', month: 'long' }; // like "September 2014"
    }
    var days = diffWholeDays(dateProfile.currentRange.start, dateProfile.currentRange.end);
    if (days !== null && days > 1) {
        // multi-day range. shorter, like "Sep 9 - 10 2014"
        return { year: 'numeric', month: 'short', day: 'numeric' };
    }
    // one day. longer, like "September 9 2014"
    return { year: 'numeric', month: 'long', day: 'numeric' };
}

// in future refactor, do the redux-style function(state=initial) for initial-state
// also, whatever is happening in constructor, have it happen in action queue too
var CalendarDataManager = /** @class */ (function () {
    function CalendarDataManager(props) {
        var _this = this;
        this.computeOptionsData = memoize(this._computeOptionsData);
        this.computeCurrentViewData = memoize(this._computeCurrentViewData);
        this.organizeRawLocales = memoize(organizeRawLocales);
        this.buildLocale = memoize(buildLocale);
        this.buildPluginHooks = buildBuildPluginHooks();
        this.buildDateEnv = memoize(buildDateEnv);
        this.buildTheme = memoize(buildTheme);
        this.parseToolbars = memoize(parseToolbars);
        this.buildViewSpecs = memoize(buildViewSpecs);
        this.buildDateProfileGenerator = memoizeObjArg(buildDateProfileGenerator);
        this.buildViewApi = memoize(buildViewApi);
        this.buildViewUiProps = memoizeObjArg(buildViewUiProps);
        this.buildEventUiBySource = memoize(buildEventUiBySource, isPropsEqual);
        this.buildEventUiBases = memoize(buildEventUiBases);
        this.parseContextBusinessHours = memoizeObjArg(parseContextBusinessHours);
        this.buildTitle = memoize(buildTitle);
        this.emitter = new Emitter();
        this.actionRunner = new TaskRunner(this._handleAction.bind(this), this.updateData.bind(this));
        this.currentCalendarOptionsInput = {};
        this.currentCalendarOptionsRefined = {};
        this.currentViewOptionsInput = {};
        this.currentViewOptionsRefined = {};
        this.currentCalendarOptionsRefiners = {};
        this.getCurrentData = function () { return _this.data; };
        this.dispatch = function (action) {
            _this.actionRunner.request(action); // protects against recursive calls to _handleAction
        };
        this.props = props;
        this.actionRunner.pause();
        var dynamicOptionOverrides = {};
        var optionsData = this.computeOptionsData(props.optionOverrides, dynamicOptionOverrides, props.calendarApi);
        var currentViewType = optionsData.calendarOptions.initialView || optionsData.pluginHooks.initialView;
        var currentViewData = this.computeCurrentViewData(currentViewType, optionsData, props.optionOverrides, dynamicOptionOverrides);
        // wire things up
        // TODO: not DRY
        props.calendarApi.currentDataManager = this;
        this.emitter.setThisContext(props.calendarApi);
        this.emitter.setOptions(currentViewData.options);
        var currentDate = getInitialDate(optionsData.calendarOptions, optionsData.dateEnv);
        var dateProfile = currentViewData.dateProfileGenerator.build(currentDate);
        if (!rangeContainsMarker(dateProfile.activeRange, currentDate)) {
            currentDate = dateProfile.currentRange.start;
        }
        var calendarContext = {
            dateEnv: optionsData.dateEnv,
            options: optionsData.calendarOptions,
            pluginHooks: optionsData.pluginHooks,
            calendarApi: props.calendarApi,
            dispatch: this.dispatch,
            emitter: this.emitter,
            getCurrentData: this.getCurrentData,
        };
        // needs to be after setThisContext
        for (var _i = 0, _a = optionsData.pluginHooks.contextInit; _i < _a.length; _i++) {
            var callback = _a[_i];
            callback(calendarContext);
        }
        // NOT DRY
        var eventSources = initEventSources(optionsData.calendarOptions, dateProfile, calendarContext);
        var initialState = {
            dynamicOptionOverrides: dynamicOptionOverrides,
            currentViewType: currentViewType,
            currentDate: currentDate,
            dateProfile: dateProfile,
            businessHours: this.parseContextBusinessHours(calendarContext),
            eventSources: eventSources,
            eventUiBases: {},
            eventStore: createEmptyEventStore(),
            renderableEventStore: createEmptyEventStore(),
            dateSelection: null,
            eventSelection: '',
            eventDrag: null,
            eventResize: null,
            selectionConfig: this.buildViewUiProps(calendarContext).selectionConfig,
        };
        var contextAndState = tslib.__assign(tslib.__assign({}, calendarContext), initialState);
        for (var _b = 0, _c = optionsData.pluginHooks.reducers; _b < _c.length; _b++) {
            var reducer = _c[_b];
            tslib.__assign(initialState, reducer(null, null, contextAndState));
        }
        if (computeIsLoading(initialState, calendarContext)) {
            this.emitter.trigger('loading', true); // NOT DRY
        }
        this.state = initialState;
        this.updateData();
        this.actionRunner.resume();
    }
    CalendarDataManager.prototype.resetOptions = function (optionOverrides, append) {
        var props = this.props;
        props.optionOverrides = append
            ? tslib.__assign(tslib.__assign({}, props.optionOverrides), optionOverrides) : optionOverrides;
        this.actionRunner.request({
            type: 'NOTHING',
        });
    };
    CalendarDataManager.prototype._handleAction = function (action) {
        var _a = this, props = _a.props, state = _a.state, emitter = _a.emitter;
        var dynamicOptionOverrides = reduceDynamicOptionOverrides(state.dynamicOptionOverrides, action);
        var optionsData = this.computeOptionsData(props.optionOverrides, dynamicOptionOverrides, props.calendarApi);
        var currentViewType = reduceViewType(state.currentViewType, action);
        var currentViewData = this.computeCurrentViewData(currentViewType, optionsData, props.optionOverrides, dynamicOptionOverrides);
        // wire things up
        // TODO: not DRY
        props.calendarApi.currentDataManager = this;
        emitter.setThisContext(props.calendarApi);
        emitter.setOptions(currentViewData.options);
        var calendarContext = {
            dateEnv: optionsData.dateEnv,
            options: optionsData.calendarOptions,
            pluginHooks: optionsData.pluginHooks,
            calendarApi: props.calendarApi,
            dispatch: this.dispatch,
            emitter: emitter,
            getCurrentData: this.getCurrentData,
        };
        var currentDate = state.currentDate, dateProfile = state.dateProfile;
        if (this.data && this.data.dateProfileGenerator !== currentViewData.dateProfileGenerator) { // hack
            dateProfile = currentViewData.dateProfileGenerator.build(currentDate);
        }
        currentDate = reduceCurrentDate(currentDate, action);
        dateProfile = reduceDateProfile(dateProfile, action, currentDate, currentViewData.dateProfileGenerator);
        if (action.type === 'PREV' || // TODO: move this logic into DateProfileGenerator
            action.type === 'NEXT' || // "
            !rangeContainsMarker(dateProfile.currentRange, currentDate)) {
            currentDate = dateProfile.currentRange.start;
        }
        var eventSources = reduceEventSources(state.eventSources, action, dateProfile, calendarContext);
        var eventStore = reduceEventStore(state.eventStore, action, eventSources, dateProfile, calendarContext);
        var isEventsLoading = computeEventSourcesLoading(eventSources); // BAD. also called in this func in computeIsLoading
        var renderableEventStore = (isEventsLoading && !currentViewData.options.progressiveEventRendering) ?
            (state.renderableEventStore || eventStore) : // try from previous state
            eventStore;
        var _b = this.buildViewUiProps(calendarContext), eventUiSingleBase = _b.eventUiSingleBase, selectionConfig = _b.selectionConfig; // will memoize obj
        var eventUiBySource = this.buildEventUiBySource(eventSources);
        var eventUiBases = this.buildEventUiBases(renderableEventStore.defs, eventUiSingleBase, eventUiBySource);
        var newState = {
            dynamicOptionOverrides: dynamicOptionOverrides,
            currentViewType: currentViewType,
            currentDate: currentDate,
            dateProfile: dateProfile,
            eventSources: eventSources,
            eventStore: eventStore,
            renderableEventStore: renderableEventStore,
            selectionConfig: selectionConfig,
            eventUiBases: eventUiBases,
            businessHours: this.parseContextBusinessHours(calendarContext),
            dateSelection: reduceDateSelection(state.dateSelection, action),
            eventSelection: reduceSelectedEvent(state.eventSelection, action),
            eventDrag: reduceEventDrag(state.eventDrag, action),
            eventResize: reduceEventResize(state.eventResize, action),
        };
        var contextAndState = tslib.__assign(tslib.__assign({}, calendarContext), newState);
        for (var _i = 0, _c = optionsData.pluginHooks.reducers; _i < _c.length; _i++) {
            var reducer = _c[_i];
            tslib.__assign(newState, reducer(state, action, contextAndState)); // give the OLD state, for old value
        }
        var wasLoading = computeIsLoading(state, calendarContext);
        var isLoading = computeIsLoading(newState, calendarContext);
        // TODO: use propSetHandlers in plugin system
        if (!wasLoading && isLoading) {
            emitter.trigger('loading', true);
        }
        else if (wasLoading && !isLoading) {
            emitter.trigger('loading', false);
        }
        this.state = newState;
        if (props.onAction) {
            props.onAction(action);
        }
    };
    CalendarDataManager.prototype.updateData = function () {
        var _a = this, props = _a.props, state = _a.state;
        var oldData = this.data;
        var optionsData = this.computeOptionsData(props.optionOverrides, state.dynamicOptionOverrides, props.calendarApi);
        var currentViewData = this.computeCurrentViewData(state.currentViewType, optionsData, props.optionOverrides, state.dynamicOptionOverrides);
        var data = this.data = tslib.__assign(tslib.__assign(tslib.__assign({ viewTitle: this.buildTitle(state.dateProfile, currentViewData.options, optionsData.dateEnv), calendarApi: props.calendarApi, dispatch: this.dispatch, emitter: this.emitter, getCurrentData: this.getCurrentData }, optionsData), currentViewData), state);
        var changeHandlers = optionsData.pluginHooks.optionChangeHandlers;
        var oldCalendarOptions = oldData && oldData.calendarOptions;
        var newCalendarOptions = optionsData.calendarOptions;
        if (oldCalendarOptions && oldCalendarOptions !== newCalendarOptions) {
            if (oldCalendarOptions.timeZone !== newCalendarOptions.timeZone) {
                // hack
                state.eventSources = data.eventSources = reduceEventSourcesNewTimeZone(data.eventSources, state.dateProfile, data);
                state.eventStore = data.eventStore = rezoneEventStoreDates(data.eventStore, oldData.dateEnv, data.dateEnv);
            }
            for (var optionName in changeHandlers) {
                if (oldCalendarOptions[optionName] !== newCalendarOptions[optionName]) {
                    changeHandlers[optionName](newCalendarOptions[optionName], data);
                }
            }
        }
        if (props.onData) {
            props.onData(data);
        }
    };
    CalendarDataManager.prototype._computeOptionsData = function (optionOverrides, dynamicOptionOverrides, calendarApi) {
        // TODO: blacklist options that are handled by optionChangeHandlers
        var _a = this.processRawCalendarOptions(optionOverrides, dynamicOptionOverrides), refinedOptions = _a.refinedOptions, pluginHooks = _a.pluginHooks, localeDefaults = _a.localeDefaults, availableLocaleData = _a.availableLocaleData, extra = _a.extra;
        warnUnknownOptions(extra);
        var dateEnv = this.buildDateEnv(refinedOptions.timeZone, refinedOptions.locale, refinedOptions.weekNumberCalculation, refinedOptions.firstDay, refinedOptions.weekText, pluginHooks, availableLocaleData, refinedOptions.defaultRangeSeparator);
        var viewSpecs = this.buildViewSpecs(pluginHooks.views, optionOverrides, dynamicOptionOverrides, localeDefaults);
        var theme = this.buildTheme(refinedOptions, pluginHooks);
        var toolbarConfig = this.parseToolbars(refinedOptions, optionOverrides, theme, viewSpecs, calendarApi);
        return {
            calendarOptions: refinedOptions,
            pluginHooks: pluginHooks,
            dateEnv: dateEnv,
            viewSpecs: viewSpecs,
            theme: theme,
            toolbarConfig: toolbarConfig,
            localeDefaults: localeDefaults,
            availableRawLocales: availableLocaleData.map,
        };
    };
    // always called from behind a memoizer
    CalendarDataManager.prototype.processRawCalendarOptions = function (optionOverrides, dynamicOptionOverrides) {
        var _a = mergeRawOptions([
            BASE_OPTION_DEFAULTS,
            optionOverrides,
            dynamicOptionOverrides,
        ]), locales = _a.locales, locale = _a.locale;
        var availableLocaleData = this.organizeRawLocales(locales);
        var availableRawLocales = availableLocaleData.map;
        var localeDefaults = this.buildLocale(locale || availableLocaleData.defaultCode, availableRawLocales).options;
        var pluginHooks = this.buildPluginHooks(optionOverrides.plugins || [], globalPlugins);
        var refiners = this.currentCalendarOptionsRefiners = tslib.__assign(tslib.__assign(tslib.__assign(tslib.__assign(tslib.__assign({}, BASE_OPTION_REFINERS), CALENDAR_LISTENER_REFINERS), CALENDAR_OPTION_REFINERS), pluginHooks.listenerRefiners), pluginHooks.optionRefiners);
        var extra = {};
        var raw = mergeRawOptions([
            BASE_OPTION_DEFAULTS,
            localeDefaults,
            optionOverrides,
            dynamicOptionOverrides,
        ]);
        var refined = {};
        var currentRaw = this.currentCalendarOptionsInput;
        var currentRefined = this.currentCalendarOptionsRefined;
        var anyChanges = false;
        for (var optionName in raw) {
            if (optionName !== 'plugins') { // because plugins is special-cased
                if (raw[optionName] === currentRaw[optionName] ||
                    (COMPLEX_OPTION_COMPARATORS[optionName] &&
                        (optionName in currentRaw) &&
                        COMPLEX_OPTION_COMPARATORS[optionName](currentRaw[optionName], raw[optionName]))) {
                    refined[optionName] = currentRefined[optionName];
                }
                else if (refiners[optionName]) {
                    refined[optionName] = refiners[optionName](raw[optionName]);
                    anyChanges = true;
                }
                else {
                    extra[optionName] = currentRaw[optionName];
                }
            }
        }
        if (anyChanges) {
            this.currentCalendarOptionsInput = raw;
            this.currentCalendarOptionsRefined = refined;
        }
        return {
            rawOptions: this.currentCalendarOptionsInput,
            refinedOptions: this.currentCalendarOptionsRefined,
            pluginHooks: pluginHooks,
            availableLocaleData: availableLocaleData,
            localeDefaults: localeDefaults,
            extra: extra,
        };
    };
    CalendarDataManager.prototype._computeCurrentViewData = function (viewType, optionsData, optionOverrides, dynamicOptionOverrides) {
        var viewSpec = optionsData.viewSpecs[viewType];
        if (!viewSpec) {
            throw new Error("viewType \"" + viewType + "\" is not available. Please make sure you've loaded all neccessary plugins");
        }
        var _a = this.processRawViewOptions(viewSpec, optionsData.pluginHooks, optionsData.localeDefaults, optionOverrides, dynamicOptionOverrides), refinedOptions = _a.refinedOptions, extra = _a.extra;
        warnUnknownOptions(extra);
        var dateProfileGenerator = this.buildDateProfileGenerator({
            dateProfileGeneratorClass: viewSpec.optionDefaults.dateProfileGeneratorClass,
            duration: viewSpec.duration,
            durationUnit: viewSpec.durationUnit,
            usesMinMaxTime: viewSpec.optionDefaults.usesMinMaxTime,
            dateEnv: optionsData.dateEnv,
            calendarApi: this.props.calendarApi,
            slotMinTime: refinedOptions.slotMinTime,
            slotMaxTime: refinedOptions.slotMaxTime,
            showNonCurrentDates: refinedOptions.showNonCurrentDates,
            dayCount: refinedOptions.dayCount,
            dateAlignment: refinedOptions.dateAlignment,
            dateIncrement: refinedOptions.dateIncrement,
            hiddenDays: refinedOptions.hiddenDays,
            weekends: refinedOptions.weekends,
            nowInput: refinedOptions.now,
            validRangeInput: refinedOptions.validRange,
            visibleRangeInput: refinedOptions.visibleRange,
            monthMode: refinedOptions.monthMode,
            fixedWeekCount: refinedOptions.fixedWeekCount,
        });
        var viewApi = this.buildViewApi(viewType, this.getCurrentData, optionsData.dateEnv);
        return { viewSpec: viewSpec, options: refinedOptions, dateProfileGenerator: dateProfileGenerator, viewApi: viewApi };
    };
    CalendarDataManager.prototype.processRawViewOptions = function (viewSpec, pluginHooks, localeDefaults, optionOverrides, dynamicOptionOverrides) {
        var raw = mergeRawOptions([
            BASE_OPTION_DEFAULTS,
            viewSpec.optionDefaults,
            localeDefaults,
            optionOverrides,
            viewSpec.optionOverrides,
            dynamicOptionOverrides,
        ]);
        var refiners = tslib.__assign(tslib.__assign(tslib.__assign(tslib.__assign(tslib.__assign(tslib.__assign({}, BASE_OPTION_REFINERS), CALENDAR_LISTENER_REFINERS), CALENDAR_OPTION_REFINERS), VIEW_OPTION_REFINERS), pluginHooks.listenerRefiners), pluginHooks.optionRefiners);
        var refined = {};
        var currentRaw = this.currentViewOptionsInput;
        var currentRefined = this.currentViewOptionsRefined;
        var anyChanges = false;
        var extra = {};
        for (var optionName in raw) {
            if (raw[optionName] === currentRaw[optionName]) {
                refined[optionName] = currentRefined[optionName];
            }
            else {
                if (raw[optionName] === this.currentCalendarOptionsInput[optionName]) {
                    if (optionName in this.currentCalendarOptionsRefined) { // might be an "extra" prop
                        refined[optionName] = this.currentCalendarOptionsRefined[optionName];
                    }
                }
                else if (refiners[optionName]) {
                    refined[optionName] = refiners[optionName](raw[optionName]);
                }
                else {
                    extra[optionName] = raw[optionName];
                }
                anyChanges = true;
            }
        }
        if (anyChanges) {
            this.currentViewOptionsInput = raw;
            this.currentViewOptionsRefined = refined;
        }
        return {
            rawOptions: this.currentViewOptionsInput,
            refinedOptions: this.currentViewOptionsRefined,
            extra: extra,
        };
    };
    return CalendarDataManager;
}());
function buildDateEnv(timeZone, explicitLocale, weekNumberCalculation, firstDay, weekText, pluginHooks, availableLocaleData, defaultSeparator) {
    var locale = buildLocale(explicitLocale || availableLocaleData.defaultCode, availableLocaleData.map);
    return new DateEnv({
        calendarSystem: 'gregory',
        timeZone: timeZone,
        namedTimeZoneImpl: pluginHooks.namedTimeZonedImpl,
        locale: locale,
        weekNumberCalculation: weekNumberCalculation,
        firstDay: firstDay,
        weekText: weekText,
        cmdFormatter: pluginHooks.cmdFormatter,
        defaultSeparator: defaultSeparator,
    });
}
function buildTheme(options, pluginHooks) {
    var ThemeClass = pluginHooks.themeClasses[options.themeSystem] || StandardTheme;
    return new ThemeClass(options);
}
function buildDateProfileGenerator(props) {
    var DateProfileGeneratorClass = props.dateProfileGeneratorClass || DateProfileGenerator;
    return new DateProfileGeneratorClass(props);
}
function buildViewApi(type, getCurrentData, dateEnv) {
    return new ViewApi(type, getCurrentData, dateEnv);
}
function buildEventUiBySource(eventSources) {
    return mapHash(eventSources, function (eventSource) { return eventSource.ui; });
}
function buildEventUiBases(eventDefs, eventUiSingleBase, eventUiBySource) {
    var eventUiBases = { '': eventUiSingleBase };
    for (var defId in eventDefs) {
        var def = eventDefs[defId];
        if (def.sourceId && eventUiBySource[def.sourceId]) {
            eventUiBases[defId] = eventUiBySource[def.sourceId];
        }
    }
    return eventUiBases;
}
function buildViewUiProps(calendarContext) {
    var options = calendarContext.options;
    return {
        eventUiSingleBase: createEventUi({
            display: options.eventDisplay,
            editable: options.editable,
            startEditable: options.eventStartEditable,
            durationEditable: options.eventDurationEditable,
            constraint: options.eventConstraint,
            overlap: typeof options.eventOverlap === 'boolean' ? options.eventOverlap : undefined,
            allow: options.eventAllow,
            backgroundColor: options.eventBackgroundColor,
            borderColor: options.eventBorderColor,
            textColor: options.eventTextColor,
            color: options.eventColor,
            // classNames: options.eventClassNames // render hook will handle this
        }, calendarContext),
        selectionConfig: createEventUi({
            constraint: options.selectConstraint,
            overlap: typeof options.selectOverlap === 'boolean' ? options.selectOverlap : undefined,
            allow: options.selectAllow,
        }, calendarContext),
    };
}
function computeIsLoading(state, context) {
    for (var _i = 0, _a = context.pluginHooks.isLoadingFuncs; _i < _a.length; _i++) {
        var isLoadingFunc = _a[_i];
        if (isLoadingFunc(state)) {
            return true;
        }
    }
    return false;
}
function parseContextBusinessHours(calendarContext) {
    return parseBusinessHours(calendarContext.options.businessHours, calendarContext);
}
function warnUnknownOptions(options, viewName) {
    for (var optionName in options) {
        console.warn("Unknown option '" + optionName + "'" +
            (viewName ? " for view '" + viewName + "'" : ''));
    }
}

// TODO: move this to react plugin?
var CalendarDataProvider = /** @class */ (function (_super) {
    tslib.__extends(CalendarDataProvider, _super);
    function CalendarDataProvider(props) {
        var _this = _super.call(this, props) || this;
        _this.handleData = function (data) {
            if (!_this.dataManager) { // still within initial run, before assignment in constructor
                // eslint-disable-next-line react/no-direct-mutation-state
                _this.state = data; // can't use setState yet
            }
            else {
                _this.setState(data);
            }
        };
        _this.dataManager = new CalendarDataManager({
            optionOverrides: props.optionOverrides,
            calendarApi: props.calendarApi,
            onData: _this.handleData,
        });
        return _this;
    }
    CalendarDataProvider.prototype.render = function () {
        return this.props.children(this.state);
    };
    CalendarDataProvider.prototype.componentDidUpdate = function (prevProps) {
        var newOptionOverrides = this.props.optionOverrides;
        if (newOptionOverrides !== prevProps.optionOverrides) { // prevent recursive handleData
            this.dataManager.resetOptions(newOptionOverrides);
        }
    };
    return CalendarDataProvider;
}(vdom_cjs.Component));

// HELPERS
/*
if nextDayThreshold is specified, slicing is done in an all-day fashion.
you can get nextDayThreshold from context.nextDayThreshold
*/
function sliceEvents(props, allDay) {
    return sliceEventStore(props.eventStore, props.eventUiBases, props.dateProfile.activeRange, allDay ? props.nextDayThreshold : null).fg;
}

var NamedTimeZoneImpl = /** @class */ (function () {
    function NamedTimeZoneImpl(timeZoneName) {
        this.timeZoneName = timeZoneName;
    }
    return NamedTimeZoneImpl;
}());

var SegHierarchy = /** @class */ (function () {
    function SegHierarchy() {
        // settings
        this.strictOrder = false;
        this.allowReslicing = false;
        this.maxCoord = -1; // -1 means no max
        this.maxStackCnt = -1; // -1 means no max
        this.levelCoords = []; // ordered
        this.entriesByLevel = []; // parallel with levelCoords
        this.stackCnts = {}; // TODO: use better technique!?
    }
    SegHierarchy.prototype.addSegs = function (inputs) {
        var hiddenEntries = [];
        for (var _i = 0, inputs_1 = inputs; _i < inputs_1.length; _i++) {
            var input = inputs_1[_i];
            this.insertEntry(input, hiddenEntries);
        }
        return hiddenEntries;
    };
    SegHierarchy.prototype.insertEntry = function (entry, hiddenEntries) {
        var insertion = this.findInsertion(entry);
        if (this.isInsertionValid(insertion, entry)) {
            this.insertEntryAt(entry, insertion);
            return 1;
        }
        return this.handleInvalidInsertion(insertion, entry, hiddenEntries);
    };
    SegHierarchy.prototype.isInsertionValid = function (insertion, entry) {
        return (this.maxCoord === -1 || insertion.levelCoord + entry.thickness <= this.maxCoord) &&
            (this.maxStackCnt === -1 || insertion.stackCnt < this.maxStackCnt);
    };
    // returns number of new entries inserted
    SegHierarchy.prototype.handleInvalidInsertion = function (insertion, entry, hiddenEntries) {
        if (this.allowReslicing && insertion.touchingEntry) {
            return this.splitEntry(entry, insertion.touchingEntry, hiddenEntries);
        }
        hiddenEntries.push(entry);
        return 0;
    };
    SegHierarchy.prototype.splitEntry = function (entry, barrier, hiddenEntries) {
        var partCnt = 0;
        var splitHiddenEntries = [];
        var entrySpan = entry.span;
        var barrierSpan = barrier.span;
        if (entrySpan.start < barrierSpan.start) {
            partCnt += this.insertEntry({
                index: entry.index,
                thickness: entry.thickness,
                span: { start: entrySpan.start, end: barrierSpan.start },
            }, splitHiddenEntries);
        }
        if (entrySpan.end > barrierSpan.end) {
            partCnt += this.insertEntry({
                index: entry.index,
                thickness: entry.thickness,
                span: { start: barrierSpan.end, end: entrySpan.end },
            }, splitHiddenEntries);
        }
        if (partCnt) {
            hiddenEntries.push.apply(hiddenEntries, tslib.__spreadArray([{
                    index: entry.index,
                    thickness: entry.thickness,
                    span: intersectSpans(barrierSpan, entrySpan), // guaranteed to intersect
                }], splitHiddenEntries));
            return partCnt;
        }
        hiddenEntries.push(entry);
        return 0;
    };
    SegHierarchy.prototype.insertEntryAt = function (entry, insertion) {
        var _a = this, entriesByLevel = _a.entriesByLevel, levelCoords = _a.levelCoords;
        if (insertion.lateral === -1) {
            // create a new level
            insertAt(levelCoords, insertion.level, insertion.levelCoord);
            insertAt(entriesByLevel, insertion.level, [entry]);
        }
        else {
            // insert into existing level
            insertAt(entriesByLevel[insertion.level], insertion.lateral, entry);
        }
        this.stackCnts[buildEntryKey(entry)] = insertion.stackCnt;
    };
    SegHierarchy.prototype.findInsertion = function (newEntry) {
        var _a = this, levelCoords = _a.levelCoords, entriesByLevel = _a.entriesByLevel, strictOrder = _a.strictOrder, stackCnts = _a.stackCnts;
        var levelCnt = levelCoords.length;
        var candidateCoord = 0;
        var touchingLevel = -1;
        var touchingLateral = -1;
        var touchingEntry = null;
        var stackCnt = 0;
        for (var trackingLevel = 0; trackingLevel < levelCnt; trackingLevel += 1) {
            var trackingCoord = levelCoords[trackingLevel];
            // if the current level is past the placed entry, we have found a good empty space and can stop.
            // if strictOrder, keep finding more lateral intersections.
            if (!strictOrder && trackingCoord >= candidateCoord + newEntry.thickness) {
                break;
            }
            var trackingEntries = entriesByLevel[trackingLevel];
            var trackingEntry = void 0;
            var searchRes = binarySearch(trackingEntries, newEntry.span.start, getEntrySpanEnd); // find first entry after newEntry's end
            var lateralIndex = searchRes[0] + searchRes[1]; // if exact match (which doesn't collide), go to next one
            while ( // loop through entries that horizontally intersect
            (trackingEntry = trackingEntries[lateralIndex]) && // but not past the whole entry list
                trackingEntry.span.start < newEntry.span.end // and not entirely past newEntry
            ) {
                var trackingEntryBottom = trackingCoord + trackingEntry.thickness;
                // intersects into the top of the candidate?
                if (trackingEntryBottom > candidateCoord) {
                    candidateCoord = trackingEntryBottom;
                    touchingEntry = trackingEntry;
                    touchingLevel = trackingLevel;
                    touchingLateral = lateralIndex;
                }
                // butts up against top of candidate? (will happen if just intersected as well)
                if (trackingEntryBottom === candidateCoord) {
                    // accumulate the highest possible stackCnt of the trackingEntries that butt up
                    stackCnt = Math.max(stackCnt, stackCnts[buildEntryKey(trackingEntry)] + 1);
                }
                lateralIndex += 1;
            }
        }
        // the destination level will be after touchingEntry's level. find it
        var destLevel = 0;
        if (touchingEntry) {
            destLevel = touchingLevel + 1;
            while (destLevel < levelCnt && levelCoords[destLevel] < candidateCoord) {
                destLevel += 1;
            }
        }
        // if adding to an existing level, find where to insert
        var destLateral = -1;
        if (destLevel < levelCnt && levelCoords[destLevel] === candidateCoord) {
            destLateral = binarySearch(entriesByLevel[destLevel], newEntry.span.end, getEntrySpanEnd)[0];
        }
        return {
            touchingLevel: touchingLevel,
            touchingLateral: touchingLateral,
            touchingEntry: touchingEntry,
            stackCnt: stackCnt,
            levelCoord: candidateCoord,
            level: destLevel,
            lateral: destLateral,
        };
    };
    // sorted by levelCoord (lowest to highest)
    SegHierarchy.prototype.toRects = function () {
        var _a = this, entriesByLevel = _a.entriesByLevel, levelCoords = _a.levelCoords;
        var levelCnt = entriesByLevel.length;
        var rects = [];
        for (var level = 0; level < levelCnt; level += 1) {
            var entries = entriesByLevel[level];
            var levelCoord = levelCoords[level];
            for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
                var entry = entries_1[_i];
                rects.push(tslib.__assign(tslib.__assign({}, entry), { levelCoord: levelCoord }));
            }
        }
        return rects;
    };
    return SegHierarchy;
}());
function getEntrySpanEnd(entry) {
    return entry.span.end;
}
function buildEntryKey(entry) {
    return entry.index + ':' + entry.span.start;
}
// returns groups with entries sorted by input order
function groupIntersectingEntries(entries) {
    var merges = [];
    for (var _i = 0, entries_2 = entries; _i < entries_2.length; _i++) {
        var entry = entries_2[_i];
        var filteredMerges = [];
        var hungryMerge = {
            span: entry.span,
            entries: [entry],
        };
        for (var _a = 0, merges_1 = merges; _a < merges_1.length; _a++) {
            var merge = merges_1[_a];
            if (intersectSpans(merge.span, hungryMerge.span)) {
                hungryMerge = {
                    entries: merge.entries.concat(hungryMerge.entries),
                    span: joinSpans(merge.span, hungryMerge.span),
                };
            }
            else {
                filteredMerges.push(merge);
            }
        }
        filteredMerges.push(hungryMerge);
        merges = filteredMerges;
    }
    return merges;
}
function joinSpans(span0, span1) {
    return {
        start: Math.min(span0.start, span1.start),
        end: Math.max(span0.end, span1.end),
    };
}
function intersectSpans(span0, span1) {
    var start = Math.max(span0.start, span1.start);
    var end = Math.min(span0.end, span1.end);
    if (start < end) {
        return { start: start, end: end };
    }
    return null;
}
// general util
// ---------------------------------------------------------------------------------------------------------------------
function insertAt(arr, index, item) {
    arr.splice(index, 0, item);
}
function binarySearch(a, searchVal, getItemVal) {
    var startIndex = 0;
    var endIndex = a.length; // exclusive
    if (!endIndex || searchVal < getItemVal(a[startIndex])) { // no items OR before first item
        return [0, 0];
    }
    if (searchVal > getItemVal(a[endIndex - 1])) { // after last item
        return [endIndex, 0];
    }
    while (startIndex < endIndex) {
        var middleIndex = Math.floor(startIndex + (endIndex - startIndex) / 2);
        var middleVal = getItemVal(a[middleIndex]);
        if (searchVal < middleVal) {
            endIndex = middleIndex;
        }
        else if (searchVal > middleVal) {
            startIndex = middleIndex + 1;
        }
        else { // equal!
            return [middleIndex, 1];
        }
    }
    return [startIndex, 0];
}

var Interaction = /** @class */ (function () {
    function Interaction(settings) {
        this.component = settings.component;
        this.isHitComboAllowed = settings.isHitComboAllowed || null;
    }
    Interaction.prototype.destroy = function () {
    };
    return Interaction;
}());
function parseInteractionSettings(component, input) {
    return {
        component: component,
        el: input.el,
        useEventCenter: input.useEventCenter != null ? input.useEventCenter : true,
        isHitComboAllowed: input.isHitComboAllowed || null,
    };
}
function interactionSettingsToStore(settings) {
    var _a;
    return _a = {},
        _a[settings.component.uid] = settings,
        _a;
}
// global state
var interactionSettingsStore = {};

/*
An abstraction for a dragging interaction originating on an event.
Does higher-level things than PointerDragger, such as possibly:
- a "mirror" that moves with the pointer
- a minimum number of pixels or other criteria for a true drag to begin

subclasses must emit:
- pointerdown
- dragstart
- dragmove
- pointerup
- dragend
*/
var ElementDragging = /** @class */ (function () {
    function ElementDragging(el, selector) {
        this.emitter = new Emitter();
    }
    ElementDragging.prototype.destroy = function () {
    };
    ElementDragging.prototype.setMirrorIsVisible = function (bool) {
        // optional if subclass doesn't want to support a mirror
    };
    ElementDragging.prototype.setMirrorNeedsRevert = function (bool) {
        // optional if subclass doesn't want to support a mirror
    };
    ElementDragging.prototype.setAutoScrollEnabled = function (bool) {
        // optional
    };
    return ElementDragging;
}());

// TODO: get rid of this in favor of options system,
// tho it's really easy to access this globally rather than pass thru options.
var config = {};

/*
Information about what will happen when an external element is dragged-and-dropped
onto a calendar. Contains information for creating an event.
*/
var DRAG_META_REFINERS = {
    startTime: createDuration,
    duration: createDuration,
    create: Boolean,
    sourceId: String,
};
function parseDragMeta(raw) {
    var _a = refineProps(raw, DRAG_META_REFINERS), refined = _a.refined, extra = _a.extra;
    return {
        startTime: refined.startTime || null,
        duration: refined.duration || null,
        create: refined.create != null ? refined.create : true,
        sourceId: refined.sourceId,
        leftoverProps: extra,
    };
}

var ToolbarSection = /** @class */ (function (_super) {
    tslib.__extends(ToolbarSection, _super);
    function ToolbarSection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ToolbarSection.prototype.render = function () {
        var _this = this;
        var children = this.props.widgetGroups.map(function (widgetGroup) { return _this.renderWidgetGroup(widgetGroup); });
        return vdom_cjs.createElement.apply(void 0, tslib.__spreadArray(['div', { className: 'fc-toolbar-chunk' }], children));
    };
    ToolbarSection.prototype.renderWidgetGroup = function (widgetGroup) {
        var props = this.props;
        var theme = this.context.theme;
        var children = [];
        var isOnlyButtons = true;
        for (var _i = 0, widgetGroup_1 = widgetGroup; _i < widgetGroup_1.length; _i++) {
            var widget = widgetGroup_1[_i];
            var buttonName = widget.buttonName, buttonClick = widget.buttonClick, buttonText = widget.buttonText, buttonIcon = widget.buttonIcon;
            if (buttonName === 'title') {
                isOnlyButtons = false;
                children.push(vdom_cjs.createElement("h2", { className: "fc-toolbar-title" }, props.title));
            }
            else {
                var ariaAttrs = buttonIcon ? { 'aria-label': buttonName } : {};
                var buttonClasses = ["fc-" + buttonName + "-button", theme.getClass('button')];
                if (buttonName === props.activeButton) {
                    buttonClasses.push(theme.getClass('buttonActive'));
                }
                var isDisabled = (!props.isTodayEnabled && buttonName === 'today') ||
                    (!props.isPrevEnabled && buttonName === 'prev') ||
                    (!props.isNextEnabled && buttonName === 'next');
                children.push(vdom_cjs.createElement("button", tslib.__assign({ disabled: isDisabled, className: buttonClasses.join(' '), onClick: buttonClick, type: "button" }, ariaAttrs), buttonText || (buttonIcon ? vdom_cjs.createElement("span", { className: buttonIcon }) : '')));
            }
        }
        if (children.length > 1) {
            var groupClassName = (isOnlyButtons && theme.getClass('buttonGroup')) || '';
            return vdom_cjs.createElement.apply(void 0, tslib.__spreadArray(['div', { className: groupClassName }], children));
        }
        return children[0];
    };
    return ToolbarSection;
}(BaseComponent));

var Toolbar = /** @class */ (function (_super) {
    tslib.__extends(Toolbar, _super);
    function Toolbar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Toolbar.prototype.render = function () {
        var _a = this.props, model = _a.model, extraClassName = _a.extraClassName;
        var forceLtr = false;
        var startContent;
        var endContent;
        var centerContent = model.center;
        if (model.left) {
            forceLtr = true;
            startContent = model.left;
        }
        else {
            startContent = model.start;
        }
        if (model.right) {
            forceLtr = true;
            endContent = model.right;
        }
        else {
            endContent = model.end;
        }
        var classNames = [
            extraClassName || '',
            'fc-toolbar',
            forceLtr ? 'fc-toolbar-ltr' : '',
        ];
        return (vdom_cjs.createElement("div", { className: classNames.join(' ') },
            this.renderSection('start', startContent || []),
            this.renderSection('center', centerContent || []),
            this.renderSection('end', endContent || [])));
    };
    Toolbar.prototype.renderSection = function (key, widgetGroups) {
        var props = this.props;
        return (vdom_cjs.createElement(ToolbarSection, { key: key, widgetGroups: widgetGroups, title: props.title, activeButton: props.activeButton, isTodayEnabled: props.isTodayEnabled, isPrevEnabled: props.isPrevEnabled, isNextEnabled: props.isNextEnabled }));
    };
    return Toolbar;
}(BaseComponent));

// TODO: do function component?
var ViewContainer = /** @class */ (function (_super) {
    tslib.__extends(ViewContainer, _super);
    function ViewContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            availableWidth: null,
        };
        _this.handleEl = function (el) {
            _this.el = el;
            setRef(_this.props.elRef, el);
            _this.updateAvailableWidth();
        };
        _this.handleResize = function () {
            _this.updateAvailableWidth();
        };
        return _this;
    }
    ViewContainer.prototype.render = function () {
        var _a = this, props = _a.props, state = _a.state;
        var aspectRatio = props.aspectRatio;
        var classNames = [
            'fc-view-harness',
            (aspectRatio || props.liquid || props.height)
                ? 'fc-view-harness-active' // harness controls the height
                : 'fc-view-harness-passive', // let the view do the height
        ];
        var height = '';
        var paddingBottom = '';
        if (aspectRatio) {
            if (state.availableWidth !== null) {
                height = state.availableWidth / aspectRatio;
            }
            else {
                // while waiting to know availableWidth, we can't set height to *zero*
                // because will cause lots of unnecessary scrollbars within scrollgrid.
                // BETTER: don't start rendering ANYTHING yet until we know container width
                // NOTE: why not always use paddingBottom? Causes height oscillation (issue 5606)
                paddingBottom = (1 / aspectRatio) * 100 + "%";
            }
        }
        else {
            height = props.height || '';
        }
        return (vdom_cjs.createElement("div", { ref: this.handleEl, onClick: props.onClick, className: classNames.join(' '), style: { height: height, paddingBottom: paddingBottom } }, props.children));
    };
    ViewContainer.prototype.componentDidMount = function () {
        this.context.addResizeHandler(this.handleResize);
    };
    ViewContainer.prototype.componentWillUnmount = function () {
        this.context.removeResizeHandler(this.handleResize);
    };
    ViewContainer.prototype.updateAvailableWidth = function () {
        if (this.el && // needed. but why?
            this.props.aspectRatio // aspectRatio is the only height setting that needs availableWidth
        ) {
            this.setState({ availableWidth: this.el.offsetWidth });
        }
    };
    return ViewContainer;
}(BaseComponent));

/*
Detects when the user clicks on an event within a DateComponent
*/
var EventClicking = /** @class */ (function (_super) {
    tslib.__extends(EventClicking, _super);
    function EventClicking(settings) {
        var _this = _super.call(this, settings) || this;
        _this.handleSegClick = function (ev, segEl) {
            var component = _this.component;
            var context = component.context;
            var seg = getElSeg(segEl);
            if (seg && // might be the <div> surrounding the more link
                component.isValidSegDownEl(ev.target)) {
                // our way to simulate a link click for elements that can't be <a> tags
                // grab before trigger fired in case trigger trashes DOM thru rerendering
                var hasUrlContainer = elementClosest(ev.target, '.fc-event-forced-url');
                var url = hasUrlContainer ? hasUrlContainer.querySelector('a[href]').href : '';
                context.emitter.trigger('eventClick', {
                    el: segEl,
                    event: new EventApi(component.context, seg.eventRange.def, seg.eventRange.instance),
                    jsEvent: ev,
                    view: context.viewApi,
                });
                if (url && !ev.defaultPrevented) {
                    window.location.href = url;
                }
            }
        };
        _this.destroy = listenBySelector(settings.el, 'click', '.fc-event', // on both fg and bg events
        _this.handleSegClick);
        return _this;
    }
    return EventClicking;
}(Interaction));

/*
Triggers events and adds/removes core classNames when the user's pointer
enters/leaves event-elements of a component.
*/
var EventHovering = /** @class */ (function (_super) {
    tslib.__extends(EventHovering, _super);
    function EventHovering(settings) {
        var _this = _super.call(this, settings) || this;
        // for simulating an eventMouseLeave when the event el is destroyed while mouse is over it
        _this.handleEventElRemove = function (el) {
            if (el === _this.currentSegEl) {
                _this.handleSegLeave(null, _this.currentSegEl);
            }
        };
        _this.handleSegEnter = function (ev, segEl) {
            if (getElSeg(segEl)) { // TODO: better way to make sure not hovering over more+ link or its wrapper
                _this.currentSegEl = segEl;
                _this.triggerEvent('eventMouseEnter', ev, segEl);
            }
        };
        _this.handleSegLeave = function (ev, segEl) {
            if (_this.currentSegEl) {
                _this.currentSegEl = null;
                _this.triggerEvent('eventMouseLeave', ev, segEl);
            }
        };
        _this.removeHoverListeners = listenToHoverBySelector(settings.el, '.fc-event', // on both fg and bg events
        _this.handleSegEnter, _this.handleSegLeave);
        return _this;
    }
    EventHovering.prototype.destroy = function () {
        this.removeHoverListeners();
    };
    EventHovering.prototype.triggerEvent = function (publicEvName, ev, segEl) {
        var component = this.component;
        var context = component.context;
        var seg = getElSeg(segEl);
        if (!ev || component.isValidSegDownEl(ev.target)) {
            context.emitter.trigger(publicEvName, {
                el: segEl,
                event: new EventApi(context, seg.eventRange.def, seg.eventRange.instance),
                jsEvent: ev,
                view: context.viewApi,
            });
        }
    };
    return EventHovering;
}(Interaction));

var CalendarContent = /** @class */ (function (_super) {
    tslib.__extends(CalendarContent, _super);
    function CalendarContent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.buildViewContext = memoize(buildViewContext);
        _this.buildViewPropTransformers = memoize(buildViewPropTransformers);
        _this.buildToolbarProps = memoize(buildToolbarProps);
        _this.handleNavLinkClick = buildDelegationHandler('a[data-navlink]', _this._handleNavLinkClick.bind(_this));
        _this.headerRef = vdom_cjs.createRef();
        _this.footerRef = vdom_cjs.createRef();
        _this.interactionsStore = {};
        // Component Registration
        // -----------------------------------------------------------------------------------------------------------------
        _this.registerInteractiveComponent = function (component, settingsInput) {
            var settings = parseInteractionSettings(component, settingsInput);
            var DEFAULT_INTERACTIONS = [
                EventClicking,
                EventHovering,
            ];
            var interactionClasses = DEFAULT_INTERACTIONS.concat(_this.props.pluginHooks.componentInteractions);
            var interactions = interactionClasses.map(function (TheInteractionClass) { return new TheInteractionClass(settings); });
            _this.interactionsStore[component.uid] = interactions;
            interactionSettingsStore[component.uid] = settings;
        };
        _this.unregisterInteractiveComponent = function (component) {
            for (var _i = 0, _a = _this.interactionsStore[component.uid]; _i < _a.length; _i++) {
                var listener = _a[_i];
                listener.destroy();
            }
            delete _this.interactionsStore[component.uid];
            delete interactionSettingsStore[component.uid];
        };
        // Resizing
        // -----------------------------------------------------------------------------------------------------------------
        _this.resizeRunner = new DelayedRunner(function () {
            _this.props.emitter.trigger('_resize', true); // should window resizes be considered "forced" ?
            _this.props.emitter.trigger('windowResize', { view: _this.props.viewApi });
        });
        _this.handleWindowResize = function (ev) {
            var options = _this.props.options;
            if (options.handleWindowResize &&
                ev.target === window // avoid jqui events
            ) {
                _this.resizeRunner.request(options.windowResizeDelay);
            }
        };
        return _this;
    }
    /*
    renders INSIDE of an outer div
    */
    CalendarContent.prototype.render = function () {
        var props = this.props;
        var toolbarConfig = props.toolbarConfig, options = props.options;
        var toolbarProps = this.buildToolbarProps(props.viewSpec, props.dateProfile, props.dateProfileGenerator, props.currentDate, getNow(props.options.now, props.dateEnv), // TODO: use NowTimer????
        props.viewTitle);
        var viewVGrow = false;
        var viewHeight = '';
        var viewAspectRatio;
        if (props.isHeightAuto || props.forPrint) {
            viewHeight = '';
        }
        else if (options.height != null) {
            viewVGrow = true;
        }
        else if (options.contentHeight != null) {
            viewHeight = options.contentHeight;
        }
        else {
            viewAspectRatio = Math.max(options.aspectRatio, 0.5); // prevent from getting too tall
        }
        var viewContext = this.buildViewContext(props.viewSpec, props.viewApi, props.options, props.dateProfileGenerator, props.dateEnv, props.theme, props.pluginHooks, props.dispatch, props.getCurrentData, props.emitter, props.calendarApi, this.registerInteractiveComponent, this.unregisterInteractiveComponent);
        return (vdom_cjs.createElement(ViewContextType.Provider, { value: viewContext },
            toolbarConfig.headerToolbar && (vdom_cjs.createElement(Toolbar, tslib.__assign({ ref: this.headerRef, extraClassName: "fc-header-toolbar", model: toolbarConfig.headerToolbar }, toolbarProps))),
            vdom_cjs.createElement(ViewContainer, { liquid: viewVGrow, height: viewHeight, aspectRatio: viewAspectRatio, onClick: this.handleNavLinkClick },
                this.renderView(props),
                this.buildAppendContent()),
            toolbarConfig.footerToolbar && (vdom_cjs.createElement(Toolbar, tslib.__assign({ ref: this.footerRef, extraClassName: "fc-footer-toolbar", model: toolbarConfig.footerToolbar }, toolbarProps)))));
    };
    CalendarContent.prototype.componentDidMount = function () {
        var props = this.props;
        this.calendarInteractions = props.pluginHooks.calendarInteractions
            .map(function (CalendarInteractionClass) { return new CalendarInteractionClass(props); });
        window.addEventListener('resize', this.handleWindowResize);
        var propSetHandlers = props.pluginHooks.propSetHandlers;
        for (var propName in propSetHandlers) {
            propSetHandlers[propName](props[propName], props);
        }
    };
    CalendarContent.prototype.componentDidUpdate = function (prevProps) {
        var props = this.props;
        var propSetHandlers = props.pluginHooks.propSetHandlers;
        for (var propName in propSetHandlers) {
            if (props[propName] !== prevProps[propName]) {
                propSetHandlers[propName](props[propName], props);
            }
        }
    };
    CalendarContent.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.handleWindowResize);
        this.resizeRunner.clear();
        for (var _i = 0, _a = this.calendarInteractions; _i < _a.length; _i++) {
            var interaction = _a[_i];
            interaction.destroy();
        }
        this.props.emitter.trigger('_unmount');
    };
    CalendarContent.prototype._handleNavLinkClick = function (ev, anchorEl) {
        var _a = this.props, dateEnv = _a.dateEnv, options = _a.options, calendarApi = _a.calendarApi;
        var navLinkOptions = anchorEl.getAttribute('data-navlink');
        navLinkOptions = navLinkOptions ? JSON.parse(navLinkOptions) : {};
        var dateMarker = dateEnv.createMarker(navLinkOptions.date);
        var viewType = navLinkOptions.type;
        var customAction = viewType === 'day' ? options.navLinkDayClick :
            viewType === 'week' ? options.navLinkWeekClick : null;
        if (typeof customAction === 'function') {
            customAction.call(calendarApi, dateEnv.toDate(dateMarker), ev);
        }
        else {
            if (typeof customAction === 'string') {
                viewType = customAction;
            }
            calendarApi.zoomTo(dateMarker, viewType);
        }
    };
    CalendarContent.prototype.buildAppendContent = function () {
        var props = this.props;
        var children = props.pluginHooks.viewContainerAppends.map(function (buildAppendContent) { return buildAppendContent(props); });
        return vdom_cjs.createElement.apply(void 0, tslib.__spreadArray([vdom_cjs.Fragment, {}], children));
    };
    CalendarContent.prototype.renderView = function (props) {
        var pluginHooks = props.pluginHooks;
        var viewSpec = props.viewSpec;
        var viewProps = {
            dateProfile: props.dateProfile,
            businessHours: props.businessHours,
            eventStore: props.renderableEventStore,
            eventUiBases: props.eventUiBases,
            dateSelection: props.dateSelection,
            eventSelection: props.eventSelection,
            eventDrag: props.eventDrag,
            eventResize: props.eventResize,
            isHeightAuto: props.isHeightAuto,
            forPrint: props.forPrint,
        };
        var transformers = this.buildViewPropTransformers(pluginHooks.viewPropsTransformers);
        for (var _i = 0, transformers_1 = transformers; _i < transformers_1.length; _i++) {
            var transformer = transformers_1[_i];
            tslib.__assign(viewProps, transformer.transform(viewProps, props));
        }
        var ViewComponent = viewSpec.component;
        return (vdom_cjs.createElement(ViewComponent, tslib.__assign({}, viewProps)));
    };
    return CalendarContent;
}(PureComponent));
function buildToolbarProps(viewSpec, dateProfile, dateProfileGenerator, currentDate, now, title) {
    // don't force any date-profiles to valid date profiles (the `false`) so that we can tell if it's invalid
    var todayInfo = dateProfileGenerator.build(now, undefined, false); // TODO: need `undefined` or else INFINITE LOOP for some reason
    var prevInfo = dateProfileGenerator.buildPrev(dateProfile, currentDate, false);
    var nextInfo = dateProfileGenerator.buildNext(dateProfile, currentDate, false);
    return {
        title: title,
        activeButton: viewSpec.type,
        isTodayEnabled: todayInfo.isValid && !rangeContainsMarker(dateProfile.currentRange, now),
        isPrevEnabled: prevInfo.isValid,
        isNextEnabled: nextInfo.isValid,
    };
}
// Plugin
// -----------------------------------------------------------------------------------------------------------------
function buildViewPropTransformers(theClasses) {
    return theClasses.map(function (TheClass) { return new TheClass(); });
}

var CalendarRoot = /** @class */ (function (_super) {
    tslib.__extends(CalendarRoot, _super);
    function CalendarRoot() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            forPrint: false,
        };
        _this.handleBeforePrint = function () {
            _this.setState({ forPrint: true });
        };
        _this.handleAfterPrint = function () {
            _this.setState({ forPrint: false });
        };
        return _this;
    }
    CalendarRoot.prototype.render = function () {
        var props = this.props;
        var options = props.options;
        var forPrint = this.state.forPrint;
        var isHeightAuto = forPrint || options.height === 'auto' || options.contentHeight === 'auto';
        var height = (!isHeightAuto && options.height != null) ? options.height : '';
        var classNames = [
            'fc',
            forPrint ? 'fc-media-print' : 'fc-media-screen',
            "fc-direction-" + options.direction,
            props.theme.getClass('root'),
        ];
        if (!getCanVGrowWithinCell()) {
            classNames.push('fc-liquid-hack');
        }
        return props.children(classNames, height, isHeightAuto, forPrint);
    };
    CalendarRoot.prototype.componentDidMount = function () {
        var emitter = this.props.emitter;
        emitter.on('_beforeprint', this.handleBeforePrint);
        emitter.on('_afterprint', this.handleAfterPrint);
    };
    CalendarRoot.prototype.componentWillUnmount = function () {
        var emitter = this.props.emitter;
        emitter.off('_beforeprint', this.handleBeforePrint);
        emitter.off('_afterprint', this.handleAfterPrint);
    };
    return CalendarRoot;
}(BaseComponent));

// Computes a default column header formatting string if `colFormat` is not explicitly defined
function computeFallbackHeaderFormat(datesRepDistinctDays, dayCnt) {
    // if more than one week row, or if there are a lot of columns with not much space,
    // put just the day numbers will be in each cell
    if (!datesRepDistinctDays || dayCnt > 10) {
        return createFormatter({ weekday: 'short' }); // "Sat"
    }
    if (dayCnt > 1) {
        return createFormatter({ weekday: 'short', month: 'numeric', day: 'numeric', omitCommas: true }); // "Sat 11/12"
    }
    return createFormatter({ weekday: 'long' }); // "Saturday"
}

var CLASS_NAME = 'fc-col-header-cell'; // do the cushion too? no
function renderInner$1(hookProps) {
    return hookProps.text;
}

var TableDateCell = /** @class */ (function (_super) {
    tslib.__extends(TableDateCell, _super);
    function TableDateCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableDateCell.prototype.render = function () {
        var _a = this.context, dateEnv = _a.dateEnv, options = _a.options, theme = _a.theme, viewApi = _a.viewApi;
        var props = this.props;
        var date = props.date, dateProfile = props.dateProfile;
        var dayMeta = getDateMeta(date, props.todayRange, null, dateProfile);
        var classNames = [CLASS_NAME].concat(getDayClassNames(dayMeta, theme));
        var text = dateEnv.format(date, props.dayHeaderFormat);
        // if colCnt is 1, we are already in a day-view and don't need a navlink
        var navLinkAttrs = (options.navLinks && !dayMeta.isDisabled && props.colCnt > 1)
            ? { 'data-navlink': buildNavLinkData(date), tabIndex: 0 }
            : {};
        var hookProps = tslib.__assign(tslib.__assign(tslib.__assign({ date: dateEnv.toDate(date), view: viewApi }, props.extraHookProps), { text: text }), dayMeta);
        return (vdom_cjs.createElement(RenderHook, { hookProps: hookProps, classNames: options.dayHeaderClassNames, content: options.dayHeaderContent, defaultContent: renderInner$1, didMount: options.dayHeaderDidMount, willUnmount: options.dayHeaderWillUnmount }, function (rootElRef, customClassNames, innerElRef, innerContent) { return (vdom_cjs.createElement("th", tslib.__assign({ ref: rootElRef, className: classNames.concat(customClassNames).join(' '), "data-date": !dayMeta.isDisabled ? formatDayString(date) : undefined, colSpan: props.colSpan }, props.extraDataAttrs),
            vdom_cjs.createElement("div", { className: "fc-scrollgrid-sync-inner" }, !dayMeta.isDisabled && (vdom_cjs.createElement("a", tslib.__assign({ ref: innerElRef, className: [
                    'fc-col-header-cell-cushion',
                    props.isSticky ? 'fc-sticky' : '',
                ].join(' ') }, navLinkAttrs), innerContent))))); }));
    };
    return TableDateCell;
}(BaseComponent));

var TableDowCell = /** @class */ (function (_super) {
    tslib.__extends(TableDowCell, _super);
    function TableDowCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableDowCell.prototype.render = function () {
        var props = this.props;
        var _a = this.context, dateEnv = _a.dateEnv, theme = _a.theme, viewApi = _a.viewApi, options = _a.options;
        var date = addDays(new Date(259200000), props.dow); // start with Sun, 04 Jan 1970 00:00:00 GMT
        var dateMeta = {
            dow: props.dow,
            isDisabled: false,
            isFuture: false,
            isPast: false,
            isToday: false,
            isOther: false,
        };
        var classNames = [CLASS_NAME].concat(getDayClassNames(dateMeta, theme), props.extraClassNames || []);
        var text = dateEnv.format(date, props.dayHeaderFormat);
        var hookProps = tslib.__assign(tslib.__assign(tslib.__assign(tslib.__assign({ // TODO: make this public?
            date: date }, dateMeta), { view: viewApi }), props.extraHookProps), { text: text });
        return (vdom_cjs.createElement(RenderHook, { hookProps: hookProps, classNames: options.dayHeaderClassNames, content: options.dayHeaderContent, defaultContent: renderInner$1, didMount: options.dayHeaderDidMount, willUnmount: options.dayHeaderWillUnmount }, function (rootElRef, customClassNames, innerElRef, innerContent) { return (vdom_cjs.createElement("th", tslib.__assign({ ref: rootElRef, className: classNames.concat(customClassNames).join(' '), colSpan: props.colSpan }, props.extraDataAttrs),
            vdom_cjs.createElement("div", { className: "fc-scrollgrid-sync-inner" },
                vdom_cjs.createElement("a", { className: [
                        'fc-col-header-cell-cushion',
                        props.isSticky ? 'fc-sticky' : '',
                    ].join(' '), ref: innerElRef }, innerContent)))); }));
    };
    return TableDowCell;
}(BaseComponent));

var NowTimer = /** @class */ (function (_super) {
    tslib.__extends(NowTimer, _super);
    function NowTimer(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.initialNowDate = getNow(context.options.now, context.dateEnv);
        _this.initialNowQueriedMs = new Date().valueOf();
        _this.state = _this.computeTiming().currentState;
        return _this;
    }
    NowTimer.prototype.render = function () {
        var _a = this, props = _a.props, state = _a.state;
        return props.children(state.nowDate, state.todayRange);
    };
    NowTimer.prototype.componentDidMount = function () {
        this.setTimeout();
    };
    NowTimer.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.unit !== this.props.unit) {
            this.clearTimeout();
            this.setTimeout();
        }
    };
    NowTimer.prototype.componentWillUnmount = function () {
        this.clearTimeout();
    };
    NowTimer.prototype.computeTiming = function () {
        var _a = this, props = _a.props, context = _a.context;
        var unroundedNow = addMs(this.initialNowDate, new Date().valueOf() - this.initialNowQueriedMs);
        var currentUnitStart = context.dateEnv.startOf(unroundedNow, props.unit);
        var nextUnitStart = context.dateEnv.add(currentUnitStart, createDuration(1, props.unit));
        var waitMs = nextUnitStart.valueOf() - unroundedNow.valueOf();
        // there is a max setTimeout ms value (https://stackoverflow.com/a/3468650/96342)
        // ensure no longer than a day
        waitMs = Math.min(1000 * 60 * 60 * 24, waitMs);
        return {
            currentState: { nowDate: currentUnitStart, todayRange: buildDayRange(currentUnitStart) },
            nextState: { nowDate: nextUnitStart, todayRange: buildDayRange(nextUnitStart) },
            waitMs: waitMs,
        };
    };
    NowTimer.prototype.setTimeout = function () {
        var _this = this;
        var _a = this.computeTiming(), nextState = _a.nextState, waitMs = _a.waitMs;
        this.timeoutId = setTimeout(function () {
            _this.setState(nextState, function () {
                _this.setTimeout();
            });
        }, waitMs);
    };
    NowTimer.prototype.clearTimeout = function () {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }
    };
    NowTimer.contextType = ViewContextType;
    return NowTimer;
}(vdom_cjs.Component));
function buildDayRange(date) {
    var start = startOfDay(date);
    var end = addDays(start, 1);
    return { start: start, end: end };
}

var DayHeader = /** @class */ (function (_super) {
    tslib.__extends(DayHeader, _super);
    function DayHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.createDayHeaderFormatter = memoize(createDayHeaderFormatter);
        return _this;
    }
    DayHeader.prototype.render = function () {
        var context = this.context;
        var _a = this.props, dates = _a.dates, dateProfile = _a.dateProfile, datesRepDistinctDays = _a.datesRepDistinctDays, renderIntro = _a.renderIntro;
        var dayHeaderFormat = this.createDayHeaderFormatter(context.options.dayHeaderFormat, datesRepDistinctDays, dates.length);
        return (vdom_cjs.createElement(NowTimer, { unit: "day" }, function (nowDate, todayRange) { return (vdom_cjs.createElement("tr", null,
            renderIntro && renderIntro('day'),
            dates.map(function (date) { return (datesRepDistinctDays ? (vdom_cjs.createElement(TableDateCell, { key: date.toISOString(), date: date, dateProfile: dateProfile, todayRange: todayRange, colCnt: dates.length, dayHeaderFormat: dayHeaderFormat })) : (vdom_cjs.createElement(TableDowCell, { key: date.getUTCDay(), dow: date.getUTCDay(), dayHeaderFormat: dayHeaderFormat }))); }))); }));
    };
    return DayHeader;
}(BaseComponent));
function createDayHeaderFormatter(explicitFormat, datesRepDistinctDays, dateCnt) {
    return explicitFormat || computeFallbackHeaderFormat(datesRepDistinctDays, dateCnt);
}

var DaySeriesModel = /** @class */ (function () {
    function DaySeriesModel(range, dateProfileGenerator) {
        var date = range.start;
        var end = range.end;
        var indices = [];
        var dates = [];
        var dayIndex = -1;
        while (date < end) { // loop each day from start to end
            if (dateProfileGenerator.isHiddenDay(date)) {
                indices.push(dayIndex + 0.5); // mark that it's between indices
            }
            else {
                dayIndex += 1;
                indices.push(dayIndex);
                dates.push(date);
            }
            date = addDays(date, 1);
        }
        this.dates = dates;
        this.indices = indices;
        this.cnt = dates.length;
    }
    DaySeriesModel.prototype.sliceRange = function (range) {
        var firstIndex = this.getDateDayIndex(range.start); // inclusive first index
        var lastIndex = this.getDateDayIndex(addDays(range.end, -1)); // inclusive last index
        var clippedFirstIndex = Math.max(0, firstIndex);
        var clippedLastIndex = Math.min(this.cnt - 1, lastIndex);
        // deal with in-between indices
        clippedFirstIndex = Math.ceil(clippedFirstIndex); // in-between starts round to next cell
        clippedLastIndex = Math.floor(clippedLastIndex); // in-between ends round to prev cell
        if (clippedFirstIndex <= clippedLastIndex) {
            return {
                firstIndex: clippedFirstIndex,
                lastIndex: clippedLastIndex,
                isStart: firstIndex === clippedFirstIndex,
                isEnd: lastIndex === clippedLastIndex,
            };
        }
        return null;
    };
    // Given a date, returns its chronolocial cell-index from the first cell of the grid.
    // If the date lies between cells (because of hiddenDays), returns a floating-point value between offsets.
    // If before the first offset, returns a negative number.
    // If after the last offset, returns an offset past the last cell offset.
    // Only works for *start* dates of cells. Will not work for exclusive end dates for cells.
    DaySeriesModel.prototype.getDateDayIndex = function (date) {
        var indices = this.indices;
        var dayOffset = Math.floor(diffDays(this.dates[0], date));
        if (dayOffset < 0) {
            return indices[0] - 1;
        }
        if (dayOffset >= indices.length) {
            return indices[indices.length - 1] + 1;
        }
        return indices[dayOffset];
    };
    return DaySeriesModel;
}());

var DayTableModel = /** @class */ (function () {
    function DayTableModel(daySeries, breakOnWeeks) {
        var dates = daySeries.dates;
        var daysPerRow;
        var firstDay;
        var rowCnt;
        if (breakOnWeeks) {
            // count columns until the day-of-week repeats
            firstDay = dates[0].getUTCDay();
            for (daysPerRow = 1; daysPerRow < dates.length; daysPerRow += 1) {
                if (dates[daysPerRow].getUTCDay() === firstDay) {
                    break;
                }
            }
            rowCnt = Math.ceil(dates.length / daysPerRow);
        }
        else {
            rowCnt = 1;
            daysPerRow = dates.length;
        }
        this.rowCnt = rowCnt;
        this.colCnt = daysPerRow;
        this.daySeries = daySeries;
        this.cells = this.buildCells();
        this.headerDates = this.buildHeaderDates();
    }
    DayTableModel.prototype.buildCells = function () {
        var rows = [];
        for (var row = 0; row < this.rowCnt; row += 1) {
            var cells = [];
            for (var col = 0; col < this.colCnt; col += 1) {
                cells.push(this.buildCell(row, col));
            }
            rows.push(cells);
        }
        return rows;
    };
    DayTableModel.prototype.buildCell = function (row, col) {
        var date = this.daySeries.dates[row * this.colCnt + col];
        return {
            key: date.toISOString(),
            date: date,
        };
    };
    DayTableModel.prototype.buildHeaderDates = function () {
        var dates = [];
        for (var col = 0; col < this.colCnt; col += 1) {
            dates.push(this.cells[0][col].date);
        }
        return dates;
    };
    DayTableModel.prototype.sliceRange = function (range) {
        var colCnt = this.colCnt;
        var seriesSeg = this.daySeries.sliceRange(range);
        var segs = [];
        if (seriesSeg) {
            var firstIndex = seriesSeg.firstIndex, lastIndex = seriesSeg.lastIndex;
            var index = firstIndex;
            while (index <= lastIndex) {
                var row = Math.floor(index / colCnt);
                var nextIndex = Math.min((row + 1) * colCnt, lastIndex + 1);
                segs.push({
                    row: row,
                    firstCol: index % colCnt,
                    lastCol: (nextIndex - 1) % colCnt,
                    isStart: seriesSeg.isStart && index === firstIndex,
                    isEnd: seriesSeg.isEnd && (nextIndex - 1) === lastIndex,
                });
                index = nextIndex;
            }
        }
        return segs;
    };
    return DayTableModel;
}());

var Slicer = /** @class */ (function () {
    function Slicer() {
        this.sliceBusinessHours = memoize(this._sliceBusinessHours);
        this.sliceDateSelection = memoize(this._sliceDateSpan);
        this.sliceEventStore = memoize(this._sliceEventStore);
        this.sliceEventDrag = memoize(this._sliceInteraction);
        this.sliceEventResize = memoize(this._sliceInteraction);
        this.forceDayIfListItem = false; // hack
    }
    Slicer.prototype.sliceProps = function (props, dateProfile, nextDayThreshold, context) {
        var extraArgs = [];
        for (var _i = 4; _i < arguments.length; _i++) {
            extraArgs[_i - 4] = arguments[_i];
        }
        var eventUiBases = props.eventUiBases;
        var eventSegs = this.sliceEventStore.apply(this, tslib.__spreadArray([props.eventStore, eventUiBases, dateProfile, nextDayThreshold], extraArgs));
        return {
            dateSelectionSegs: this.sliceDateSelection.apply(this, tslib.__spreadArray([props.dateSelection, eventUiBases, context], extraArgs)),
            businessHourSegs: this.sliceBusinessHours.apply(this, tslib.__spreadArray([props.businessHours, dateProfile, nextDayThreshold, context], extraArgs)),
            fgEventSegs: eventSegs.fg,
            bgEventSegs: eventSegs.bg,
            eventDrag: this.sliceEventDrag.apply(this, tslib.__spreadArray([props.eventDrag, eventUiBases, dateProfile, nextDayThreshold], extraArgs)),
            eventResize: this.sliceEventResize.apply(this, tslib.__spreadArray([props.eventResize, eventUiBases, dateProfile, nextDayThreshold], extraArgs)),
            eventSelection: props.eventSelection,
        }; // TODO: give interactionSegs?
    };
    Slicer.prototype.sliceNowDate = function (// does not memoize
    date, context) {
        var extraArgs = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            extraArgs[_i - 2] = arguments[_i];
        }
        return this._sliceDateSpan.apply(this, tslib.__spreadArray([{ range: { start: date, end: addMs(date, 1) }, allDay: false },
            {},
            context], extraArgs));
    };
    Slicer.prototype._sliceBusinessHours = function (businessHours, dateProfile, nextDayThreshold, context) {
        var extraArgs = [];
        for (var _i = 4; _i < arguments.length; _i++) {
            extraArgs[_i - 4] = arguments[_i];
        }
        if (!businessHours) {
            return [];
        }
        return this._sliceEventStore.apply(this, tslib.__spreadArray([expandRecurring(businessHours, computeActiveRange(dateProfile, Boolean(nextDayThreshold)), context),
            {},
            dateProfile,
            nextDayThreshold], extraArgs)).bg;
    };
    Slicer.prototype._sliceEventStore = function (eventStore, eventUiBases, dateProfile, nextDayThreshold) {
        var extraArgs = [];
        for (var _i = 4; _i < arguments.length; _i++) {
            extraArgs[_i - 4] = arguments[_i];
        }
        if (eventStore) {
            var rangeRes = sliceEventStore(eventStore, eventUiBases, computeActiveRange(dateProfile, Boolean(nextDayThreshold)), nextDayThreshold);
            return {
                bg: this.sliceEventRanges(rangeRes.bg, extraArgs),
                fg: this.sliceEventRanges(rangeRes.fg, extraArgs),
            };
        }
        return { bg: [], fg: [] };
    };
    Slicer.prototype._sliceInteraction = function (interaction, eventUiBases, dateProfile, nextDayThreshold) {
        var extraArgs = [];
        for (var _i = 4; _i < arguments.length; _i++) {
            extraArgs[_i - 4] = arguments[_i];
        }
        if (!interaction) {
            return null;
        }
        var rangeRes = sliceEventStore(interaction.mutatedEvents, eventUiBases, computeActiveRange(dateProfile, Boolean(nextDayThreshold)), nextDayThreshold);
        return {
            segs: this.sliceEventRanges(rangeRes.fg, extraArgs),
            affectedInstances: interaction.affectedEvents.instances,
            isEvent: interaction.isEvent,
        };
    };
    Slicer.prototype._sliceDateSpan = function (dateSpan, eventUiBases, context) {
        var extraArgs = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            extraArgs[_i - 3] = arguments[_i];
        }
        if (!dateSpan) {
            return [];
        }
        var eventRange = fabricateEventRange(dateSpan, eventUiBases, context);
        var segs = this.sliceRange.apply(this, tslib.__spreadArray([dateSpan.range], extraArgs));
        for (var _a = 0, segs_1 = segs; _a < segs_1.length; _a++) {
            var seg = segs_1[_a];
            seg.eventRange = eventRange;
        }
        return segs;
    };
    /*
    "complete" seg means it has component and eventRange
    */
    Slicer.prototype.sliceEventRanges = function (eventRanges, extraArgs) {
        var segs = [];
        for (var _i = 0, eventRanges_1 = eventRanges; _i < eventRanges_1.length; _i++) {
            var eventRange = eventRanges_1[_i];
            segs.push.apply(segs, this.sliceEventRange(eventRange, extraArgs));
        }
        return segs;
    };
    /*
    "complete" seg means it has component and eventRange
    */
    Slicer.prototype.sliceEventRange = function (eventRange, extraArgs) {
        var dateRange = eventRange.range;
        // hack to make multi-day events that are being force-displayed as list-items to take up only one day
        if (this.forceDayIfListItem && eventRange.ui.display === 'list-item') {
            dateRange = {
                start: dateRange.start,
                end: addDays(dateRange.start, 1),
            };
        }
        var segs = this.sliceRange.apply(this, tslib.__spreadArray([dateRange], extraArgs));
        for (var _i = 0, segs_2 = segs; _i < segs_2.length; _i++) {
            var seg = segs_2[_i];
            seg.eventRange = eventRange;
            seg.isStart = eventRange.isStart && seg.isStart;
            seg.isEnd = eventRange.isEnd && seg.isEnd;
        }
        return segs;
    };
    return Slicer;
}());
/*
for incorporating slotMinTime/slotMaxTime if appropriate
TODO: should be part of DateProfile!
TimelineDateProfile already does this btw
*/
function computeActiveRange(dateProfile, isComponentAllDay) {
    var range = dateProfile.activeRange;
    if (isComponentAllDay) {
        return range;
    }
    return {
        start: addMs(range.start, dateProfile.slotMinTime.milliseconds),
        end: addMs(range.end, dateProfile.slotMaxTime.milliseconds - 864e5), // 864e5 = ms in a day
    };
}

// high-level segmenting-aware tester functions
// ------------------------------------------------------------------------------------------------------------------------
function isInteractionValid(interaction, dateProfile, context) {
    var instances = interaction.mutatedEvents.instances;
    for (var instanceId in instances) {
        if (!rangeContainsRange(dateProfile.validRange, instances[instanceId].range)) {
            return false;
        }
    }
    return isNewPropsValid({ eventDrag: interaction }, context); // HACK: the eventDrag props is used for ALL interactions
}
function isDateSelectionValid(dateSelection, dateProfile, context) {
    if (!rangeContainsRange(dateProfile.validRange, dateSelection.range)) {
        return false;
    }
    return isNewPropsValid({ dateSelection: dateSelection }, context);
}
function isNewPropsValid(newProps, context) {
    var calendarState = context.getCurrentData();
    var props = tslib.__assign({ businessHours: calendarState.businessHours, dateSelection: '', eventStore: calendarState.eventStore, eventUiBases: calendarState.eventUiBases, eventSelection: '', eventDrag: null, eventResize: null }, newProps);
    return (context.pluginHooks.isPropsValid || isPropsValid)(props, context);
}
function isPropsValid(state, context, dateSpanMeta, filterConfig) {
    if (dateSpanMeta === void 0) { dateSpanMeta = {}; }
    if (state.eventDrag && !isInteractionPropsValid(state, context, dateSpanMeta, filterConfig)) {
        return false;
    }
    if (state.dateSelection && !isDateSelectionPropsValid(state, context, dateSpanMeta, filterConfig)) {
        return false;
    }
    return true;
}
// Moving Event Validation
// ------------------------------------------------------------------------------------------------------------------------
function isInteractionPropsValid(state, context, dateSpanMeta, filterConfig) {
    var currentState = context.getCurrentData();
    var interaction = state.eventDrag; // HACK: the eventDrag props is used for ALL interactions
    var subjectEventStore = interaction.mutatedEvents;
    var subjectDefs = subjectEventStore.defs;
    var subjectInstances = subjectEventStore.instances;
    var subjectConfigs = compileEventUis(subjectDefs, interaction.isEvent ?
        state.eventUiBases :
        { '': currentState.selectionConfig });
    if (filterConfig) {
        subjectConfigs = mapHash(subjectConfigs, filterConfig);
    }
    // exclude the subject events. TODO: exclude defs too?
    var otherEventStore = excludeInstances(state.eventStore, interaction.affectedEvents.instances);
    var otherDefs = otherEventStore.defs;
    var otherInstances = otherEventStore.instances;
    var otherConfigs = compileEventUis(otherDefs, state.eventUiBases);
    for (var subjectInstanceId in subjectInstances) {
        var subjectInstance = subjectInstances[subjectInstanceId];
        var subjectRange = subjectInstance.range;
        var subjectConfig = subjectConfigs[subjectInstance.defId];
        var subjectDef = subjectDefs[subjectInstance.defId];
        // constraint
        if (!allConstraintsPass(subjectConfig.constraints, subjectRange, otherEventStore, state.businessHours, context)) {
            return false;
        }
        // overlap
        var eventOverlap = context.options.eventOverlap;
        var eventOverlapFunc = typeof eventOverlap === 'function' ? eventOverlap : null;
        for (var otherInstanceId in otherInstances) {
            var otherInstance = otherInstances[otherInstanceId];
            // intersect! evaluate
            if (rangesIntersect(subjectRange, otherInstance.range)) {
                var otherOverlap = otherConfigs[otherInstance.defId].overlap;
                // consider the other event's overlap. only do this if the subject event is a "real" event
                if (otherOverlap === false && interaction.isEvent) {
                    return false;
                }
                if (subjectConfig.overlap === false) {
                    return false;
                }
                if (eventOverlapFunc && !eventOverlapFunc(new EventApi(context, otherDefs[otherInstance.defId], otherInstance), // still event
                new EventApi(context, subjectDef, subjectInstance))) {
                    return false;
                }
            }
        }
        // allow (a function)
        var calendarEventStore = currentState.eventStore; // need global-to-calendar, not local to component (splittable)state
        for (var _i = 0, _a = subjectConfig.allows; _i < _a.length; _i++) {
            var subjectAllow = _a[_i];
            var subjectDateSpan = tslib.__assign(tslib.__assign({}, dateSpanMeta), { range: subjectInstance.range, allDay: subjectDef.allDay });
            var origDef = calendarEventStore.defs[subjectDef.defId];
            var origInstance = calendarEventStore.instances[subjectInstanceId];
            var eventApi = void 0;
            if (origDef) { // was previously in the calendar
                eventApi = new EventApi(context, origDef, origInstance);
            }
            else { // was an external event
                eventApi = new EventApi(context, subjectDef); // no instance, because had no dates
            }
            if (!subjectAllow(buildDateSpanApiWithContext(subjectDateSpan, context), eventApi)) {
                return false;
            }
        }
    }
    return true;
}
// Date Selection Validation
// ------------------------------------------------------------------------------------------------------------------------
function isDateSelectionPropsValid(state, context, dateSpanMeta, filterConfig) {
    var relevantEventStore = state.eventStore;
    var relevantDefs = relevantEventStore.defs;
    var relevantInstances = relevantEventStore.instances;
    var selection = state.dateSelection;
    var selectionRange = selection.range;
    var selectionConfig = context.getCurrentData().selectionConfig;
    if (filterConfig) {
        selectionConfig = filterConfig(selectionConfig);
    }
    // constraint
    if (!allConstraintsPass(selectionConfig.constraints, selectionRange, relevantEventStore, state.businessHours, context)) {
        return false;
    }
    // overlap
    var selectOverlap = context.options.selectOverlap;
    var selectOverlapFunc = typeof selectOverlap === 'function' ? selectOverlap : null;
    for (var relevantInstanceId in relevantInstances) {
        var relevantInstance = relevantInstances[relevantInstanceId];
        // intersect! evaluate
        if (rangesIntersect(selectionRange, relevantInstance.range)) {
            if (selectionConfig.overlap === false) {
                return false;
            }
            if (selectOverlapFunc && !selectOverlapFunc(new EventApi(context, relevantDefs[relevantInstance.defId], relevantInstance), null)) {
                return false;
            }
        }
    }
    // allow (a function)
    for (var _i = 0, _a = selectionConfig.allows; _i < _a.length; _i++) {
        var selectionAllow = _a[_i];
        var fullDateSpan = tslib.__assign(tslib.__assign({}, dateSpanMeta), selection);
        if (!selectionAllow(buildDateSpanApiWithContext(fullDateSpan, context), null)) {
            return false;
        }
    }
    return true;
}
// Constraint Utils
// ------------------------------------------------------------------------------------------------------------------------
function allConstraintsPass(constraints, subjectRange, otherEventStore, businessHoursUnexpanded, context) {
    for (var _i = 0, constraints_1 = constraints; _i < constraints_1.length; _i++) {
        var constraint = constraints_1[_i];
        if (!anyRangesContainRange(constraintToRanges(constraint, subjectRange, otherEventStore, businessHoursUnexpanded, context), subjectRange)) {
            return false;
        }
    }
    return true;
}
function constraintToRanges(constraint, subjectRange, // for expanding a recurring constraint, or expanding business hours
otherEventStore, // for if constraint is an even group ID
businessHoursUnexpanded, // for if constraint is 'businessHours'
context) {
    if (constraint === 'businessHours') {
        return eventStoreToRanges(expandRecurring(businessHoursUnexpanded, subjectRange, context));
    }
    if (typeof constraint === 'string') { // an group ID
        return eventStoreToRanges(filterEventStoreDefs(otherEventStore, function (eventDef) { return eventDef.groupId === constraint; }));
    }
    if (typeof constraint === 'object' && constraint) { // non-null object
        return eventStoreToRanges(expandRecurring(constraint, subjectRange, context));
    }
    return []; // if it's false
}
// TODO: move to event-store file?
function eventStoreToRanges(eventStore) {
    var instances = eventStore.instances;
    var ranges = [];
    for (var instanceId in instances) {
        ranges.push(instances[instanceId].range);
    }
    return ranges;
}
// TODO: move to geom file?
function anyRangesContainRange(outerRanges, innerRange) {
    for (var _i = 0, outerRanges_1 = outerRanges; _i < outerRanges_1.length; _i++) {
        var outerRange = outerRanges_1[_i];
        if (rangeContainsRange(outerRange, innerRange)) {
            return true;
        }
    }
    return false;
}

var VISIBLE_HIDDEN_RE = /^(visible|hidden)$/;
var Scroller = /** @class */ (function (_super) {
    tslib.__extends(Scroller, _super);
    function Scroller() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleEl = function (el) {
            _this.el = el;
            setRef(_this.props.elRef, el);
        };
        return _this;
    }
    Scroller.prototype.render = function () {
        var props = this.props;
        var liquid = props.liquid, liquidIsAbsolute = props.liquidIsAbsolute;
        var isAbsolute = liquid && liquidIsAbsolute;
        var className = ['fc-scroller'];
        if (liquid) {
            if (liquidIsAbsolute) {
                className.push('fc-scroller-liquid-absolute');
            }
            else {
                className.push('fc-scroller-liquid');
            }
        }
        return (vdom_cjs.createElement("div", { ref: this.handleEl, className: className.join(' '), style: {
                overflowX: props.overflowX,
                overflowY: props.overflowY,
                left: (isAbsolute && -(props.overcomeLeft || 0)) || '',
                right: (isAbsolute && -(props.overcomeRight || 0)) || '',
                bottom: (isAbsolute && -(props.overcomeBottom || 0)) || '',
                marginLeft: (!isAbsolute && -(props.overcomeLeft || 0)) || '',
                marginRight: (!isAbsolute && -(props.overcomeRight || 0)) || '',
                marginBottom: (!isAbsolute && -(props.overcomeBottom || 0)) || '',
                maxHeight: props.maxHeight || '',
            } }, props.children));
    };
    Scroller.prototype.needsXScrolling = function () {
        if (VISIBLE_HIDDEN_RE.test(this.props.overflowX)) {
            return false;
        }
        // testing scrollWidth>clientWidth is unreliable cross-browser when pixel heights aren't integers.
        // much more reliable to see if children are taller than the scroller, even tho doesn't account for
        // inner-child margins and absolute positioning
        var el = this.el;
        var realClientWidth = this.el.getBoundingClientRect().width - this.getYScrollbarWidth();
        var children = el.children;
        for (var i = 0; i < children.length; i += 1) {
            var childEl = children[i];
            if (childEl.getBoundingClientRect().width > realClientWidth) {
                return true;
            }
        }
        return false;
    };
    Scroller.prototype.needsYScrolling = function () {
        if (VISIBLE_HIDDEN_RE.test(this.props.overflowY)) {
            return false;
        }
        // testing scrollHeight>clientHeight is unreliable cross-browser when pixel heights aren't integers.
        // much more reliable to see if children are taller than the scroller, even tho doesn't account for
        // inner-child margins and absolute positioning
        var el = this.el;
        var realClientHeight = this.el.getBoundingClientRect().height - this.getXScrollbarWidth();
        var children = el.children;
        for (var i = 0; i < children.length; i += 1) {
            var childEl = children[i];
            if (childEl.getBoundingClientRect().height > realClientHeight) {
                return true;
            }
        }
        return false;
    };
    Scroller.prototype.getXScrollbarWidth = function () {
        if (VISIBLE_HIDDEN_RE.test(this.props.overflowX)) {
            return 0;
        }
        return this.el.offsetHeight - this.el.clientHeight; // only works because we guarantee no borders. TODO: add to CSS with important?
    };
    Scroller.prototype.getYScrollbarWidth = function () {
        if (VISIBLE_HIDDEN_RE.test(this.props.overflowY)) {
            return 0;
        }
        return this.el.offsetWidth - this.el.clientWidth; // only works because we guarantee no borders. TODO: add to CSS with important?
    };
    return Scroller;
}(BaseComponent));

/*
TODO: somehow infer OtherArgs from masterCallback?
TODO: infer RefType from masterCallback if provided
*/
var RefMap = /** @class */ (function () {
    function RefMap(masterCallback) {
        var _this = this;
        this.masterCallback = masterCallback;
        this.currentMap = {};
        this.depths = {};
        this.callbackMap = {};
        this.handleValue = function (val, key) {
            var _a = _this, depths = _a.depths, currentMap = _a.currentMap;
            var removed = false;
            var added = false;
            if (val !== null) {
                // for bug... ACTUALLY: can probably do away with this now that callers don't share numeric indices anymore
                removed = (key in currentMap);
                currentMap[key] = val;
                depths[key] = (depths[key] || 0) + 1;
                added = true;
            }
            else {
                depths[key] -= 1;
                if (!depths[key]) {
                    delete currentMap[key];
                    delete _this.callbackMap[key];
                    removed = true;
                }
            }
            if (_this.masterCallback) {
                if (removed) {
                    _this.masterCallback(null, String(key));
                }
                if (added) {
                    _this.masterCallback(val, String(key));
                }
            }
        };
    }
    RefMap.prototype.createRef = function (key) {
        var _this = this;
        var refCallback = this.callbackMap[key];
        if (!refCallback) {
            refCallback = this.callbackMap[key] = function (val) {
                _this.handleValue(val, String(key));
            };
        }
        return refCallback;
    };
    // TODO: check callers that don't care about order. should use getAll instead
    // NOTE: this method has become less valuable now that we are encouraged to map order by some other index
    // TODO: provide ONE array-export function, buildArray, which fails on non-numeric indexes. caller can manipulate and "collect"
    RefMap.prototype.collect = function (startIndex, endIndex, step) {
        return collectFromHash(this.currentMap, startIndex, endIndex, step);
    };
    RefMap.prototype.getAll = function () {
        return hashValuesToArray(this.currentMap);
    };
    return RefMap;
}());

function computeShrinkWidth(chunkEls) {
    var shrinkCells = findElements(chunkEls, '.fc-scrollgrid-shrink');
    var largestWidth = 0;
    for (var _i = 0, shrinkCells_1 = shrinkCells; _i < shrinkCells_1.length; _i++) {
        var shrinkCell = shrinkCells_1[_i];
        largestWidth = Math.max(largestWidth, computeSmallestCellWidth(shrinkCell));
    }
    return Math.ceil(largestWidth); // <table> elements work best with integers. round up to ensure contents fits
}
function getSectionHasLiquidHeight(props, sectionConfig) {
    return props.liquid && sectionConfig.liquid; // does the section do liquid-height? (need to have whole scrollgrid liquid-height as well)
}
function getAllowYScrolling(props, sectionConfig) {
    return sectionConfig.maxHeight != null || // if its possible for the height to max out, we might need scrollbars
        getSectionHasLiquidHeight(props, sectionConfig); // if the section is liquid height, it might condense enough to require scrollbars
}
// TODO: ONLY use `arg`. force out internal function to use same API
function renderChunkContent(sectionConfig, chunkConfig, arg) {
    var expandRows = arg.expandRows;
    var content = typeof chunkConfig.content === 'function' ?
        chunkConfig.content(arg) :
        vdom_cjs.createElement('table', {
            className: [
                chunkConfig.tableClassName,
                sectionConfig.syncRowHeights ? 'fc-scrollgrid-sync-table' : '',
            ].join(' '),
            style: {
                minWidth: arg.tableMinWidth,
                width: arg.clientWidth,
                height: expandRows ? arg.clientHeight : '', // css `height` on a <table> serves as a min-height
            },
        }, arg.tableColGroupNode, vdom_cjs.createElement('tbody', {}, typeof chunkConfig.rowContent === 'function' ? chunkConfig.rowContent(arg) : chunkConfig.rowContent));
    return content;
}
function isColPropsEqual(cols0, cols1) {
    return isArraysEqual(cols0, cols1, isPropsEqual);
}
function renderMicroColGroup(cols, shrinkWidth) {
    var colNodes = [];
    /*
    for ColProps with spans, it would have been great to make a single <col span="">
    HOWEVER, Chrome was getting messing up distributing the width to <td>/<th> elements with colspans.
    SOLUTION: making individual <col> elements makes Chrome behave.
    */
    for (var _i = 0, cols_1 = cols; _i < cols_1.length; _i++) {
        var colProps = cols_1[_i];
        var span = colProps.span || 1;
        for (var i = 0; i < span; i += 1) {
            colNodes.push(vdom_cjs.createElement("col", { style: {
                    width: colProps.width === 'shrink' ? sanitizeShrinkWidth(shrinkWidth) : (colProps.width || ''),
                    minWidth: colProps.minWidth || '',
                } }));
        }
    }
    return vdom_cjs.createElement.apply(void 0, tslib.__spreadArray(['colgroup', {}], colNodes));
}
function sanitizeShrinkWidth(shrinkWidth) {
    /* why 4? if we do 0, it will kill any border, which are needed for computeSmallestCellWidth
    4 accounts for 2 2-pixel borders. TODO: better solution? */
    return shrinkWidth == null ? 4 : shrinkWidth;
}
function hasShrinkWidth(cols) {
    for (var _i = 0, cols_2 = cols; _i < cols_2.length; _i++) {
        var col = cols_2[_i];
        if (col.width === 'shrink') {
            return true;
        }
    }
    return false;
}
function getScrollGridClassNames(liquid, context) {
    var classNames = [
        'fc-scrollgrid',
        context.theme.getClass('table'),
    ];
    if (liquid) {
        classNames.push('fc-scrollgrid-liquid');
    }
    return classNames;
}
function getSectionClassNames(sectionConfig, wholeTableVGrow) {
    var classNames = [
        'fc-scrollgrid-section',
        "fc-scrollgrid-section-" + sectionConfig.type,
        sectionConfig.className, // used?
    ];
    if (wholeTableVGrow && sectionConfig.liquid && sectionConfig.maxHeight == null) {
        classNames.push('fc-scrollgrid-section-liquid');
    }
    if (sectionConfig.isSticky) {
        classNames.push('fc-scrollgrid-section-sticky');
    }
    return classNames;
}
function renderScrollShim(arg) {
    return (vdom_cjs.createElement("div", { className: "fc-scrollgrid-sticky-shim", style: {
            width: arg.clientWidth,
            minWidth: arg.tableMinWidth,
        } }));
}
function getStickyHeaderDates(options) {
    var stickyHeaderDates = options.stickyHeaderDates;
    if (stickyHeaderDates == null || stickyHeaderDates === 'auto') {
        stickyHeaderDates = options.height === 'auto' || options.viewHeight === 'auto';
    }
    return stickyHeaderDates;
}
function getStickyFooterScrollbar(options) {
    var stickyFooterScrollbar = options.stickyFooterScrollbar;
    if (stickyFooterScrollbar == null || stickyFooterScrollbar === 'auto') {
        stickyFooterScrollbar = options.height === 'auto' || options.viewHeight === 'auto';
    }
    return stickyFooterScrollbar;
}

var SimpleScrollGrid = /** @class */ (function (_super) {
    tslib.__extends(SimpleScrollGrid, _super);
    function SimpleScrollGrid() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.processCols = memoize(function (a) { return a; }, isColPropsEqual); // so we get same `cols` props every time
        // yucky to memoize VNodes, but much more efficient for consumers
        _this.renderMicroColGroup = memoize(renderMicroColGroup);
        _this.scrollerRefs = new RefMap();
        _this.scrollerElRefs = new RefMap(_this._handleScrollerEl.bind(_this));
        _this.state = {
            shrinkWidth: null,
            forceYScrollbars: false,
            scrollerClientWidths: {},
            scrollerClientHeights: {},
        };
        // TODO: can do a really simple print-view. dont need to join rows
        _this.handleSizing = function () {
            _this.setState(tslib.__assign({ shrinkWidth: _this.computeShrinkWidth() }, _this.computeScrollerDims()));
        };
        return _this;
    }
    SimpleScrollGrid.prototype.render = function () {
        var _a = this, props = _a.props, state = _a.state, context = _a.context;
        var sectionConfigs = props.sections || [];
        var cols = this.processCols(props.cols);
        var microColGroupNode = this.renderMicroColGroup(cols, state.shrinkWidth);
        var classNames = getScrollGridClassNames(props.liquid, context);
        if (props.collapsibleWidth) {
            classNames.push('fc-scrollgrid-collapsible');
        }
        // TODO: make DRY
        var configCnt = sectionConfigs.length;
        var configI = 0;
        var currentConfig;
        var headSectionNodes = [];
        var bodySectionNodes = [];
        var footSectionNodes = [];
        while (configI < configCnt && (currentConfig = sectionConfigs[configI]).type === 'header') {
            headSectionNodes.push(this.renderSection(currentConfig, microColGroupNode));
            configI += 1;
        }
        while (configI < configCnt && (currentConfig = sectionConfigs[configI]).type === 'body') {
            bodySectionNodes.push(this.renderSection(currentConfig, microColGroupNode));
            configI += 1;
        }
        while (configI < configCnt && (currentConfig = sectionConfigs[configI]).type === 'footer') {
            footSectionNodes.push(this.renderSection(currentConfig, microColGroupNode));
            configI += 1;
        }
        // firefox bug: when setting height on table and there is a thead or tfoot,
        // the necessary height:100% on the liquid-height body section forces the *whole* table to be taller. (bug #5524)
        // use getCanVGrowWithinCell as a way to detect table-stupid firefox.
        // if so, use a simpler dom structure, jam everything into a lone tbody.
        var isBuggy = !getCanVGrowWithinCell();
        return vdom_cjs.createElement('table', {
            className: classNames.join(' '),
            style: { height: props.height },
        }, Boolean(!isBuggy && headSectionNodes.length) && vdom_cjs.createElement.apply(void 0, tslib.__spreadArray(['thead', {}], headSectionNodes)), Boolean(!isBuggy && bodySectionNodes.length) && vdom_cjs.createElement.apply(void 0, tslib.__spreadArray(['tbody', {}], bodySectionNodes)), Boolean(!isBuggy && footSectionNodes.length) && vdom_cjs.createElement.apply(void 0, tslib.__spreadArray(['tfoot', {}], footSectionNodes)), isBuggy && vdom_cjs.createElement.apply(void 0, tslib.__spreadArray(tslib.__spreadArray(tslib.__spreadArray(['tbody', {}], headSectionNodes), bodySectionNodes), footSectionNodes)));
    };
    SimpleScrollGrid.prototype.renderSection = function (sectionConfig, microColGroupNode) {
        if ('outerContent' in sectionConfig) {
            return (vdom_cjs.createElement(vdom_cjs.Fragment, { key: sectionConfig.key }, sectionConfig.outerContent));
        }
        return (vdom_cjs.createElement("tr", { key: sectionConfig.key, className: getSectionClassNames(sectionConfig, this.props.liquid).join(' ') }, this.renderChunkTd(sectionConfig, microColGroupNode, sectionConfig.chunk)));
    };
    SimpleScrollGrid.prototype.renderChunkTd = function (sectionConfig, microColGroupNode, chunkConfig) {
        if ('outerContent' in chunkConfig) {
            return chunkConfig.outerContent;
        }
        var props = this.props;
        var _a = this.state, forceYScrollbars = _a.forceYScrollbars, scrollerClientWidths = _a.scrollerClientWidths, scrollerClientHeights = _a.scrollerClientHeights;
        var needsYScrolling = getAllowYScrolling(props, sectionConfig); // TODO: do lazily. do in section config?
        var isLiquid = getSectionHasLiquidHeight(props, sectionConfig);
        // for `!props.liquid` - is WHOLE scrollgrid natural height?
        // TODO: do same thing in advanced scrollgrid? prolly not b/c always has horizontal scrollbars
        var overflowY = !props.liquid ? 'visible' :
            forceYScrollbars ? 'scroll' :
                !needsYScrolling ? 'hidden' :
                    'auto';
        var sectionKey = sectionConfig.key;
        var content = renderChunkContent(sectionConfig, chunkConfig, {
            tableColGroupNode: microColGroupNode,
            tableMinWidth: '',
            clientWidth: (!props.collapsibleWidth && scrollerClientWidths[sectionKey] !== undefined) ? scrollerClientWidths[sectionKey] : null,
            clientHeight: scrollerClientHeights[sectionKey] !== undefined ? scrollerClientHeights[sectionKey] : null,
            expandRows: sectionConfig.expandRows,
            syncRowHeights: false,
            rowSyncHeights: [],
            reportRowHeightChange: function () { },
        });
        return (vdom_cjs.createElement("td", { ref: chunkConfig.elRef },
            vdom_cjs.createElement("div", { className: "fc-scroller-harness" + (isLiquid ? ' fc-scroller-harness-liquid' : '') },
                vdom_cjs.createElement(Scroller, { ref: this.scrollerRefs.createRef(sectionKey), elRef: this.scrollerElRefs.createRef(sectionKey), overflowY: overflowY, overflowX: !props.liquid ? 'visible' : 'hidden' /* natural height? */, maxHeight: sectionConfig.maxHeight, liquid: isLiquid, liquidIsAbsolute // because its within a harness
                    : true }, content))));
    };
    SimpleScrollGrid.prototype._handleScrollerEl = function (scrollerEl, key) {
        var section = getSectionByKey(this.props.sections, key);
        if (section) {
            setRef(section.chunk.scrollerElRef, scrollerEl);
        }
    };
    SimpleScrollGrid.prototype.componentDidMount = function () {
        this.handleSizing();
        this.context.addResizeHandler(this.handleSizing);
    };
    SimpleScrollGrid.prototype.componentDidUpdate = function () {
        // TODO: need better solution when state contains non-sizing things
        this.handleSizing();
    };
    SimpleScrollGrid.prototype.componentWillUnmount = function () {
        this.context.removeResizeHandler(this.handleSizing);
    };
    SimpleScrollGrid.prototype.computeShrinkWidth = function () {
        return hasShrinkWidth(this.props.cols)
            ? computeShrinkWidth(this.scrollerElRefs.getAll())
            : 0;
    };
    SimpleScrollGrid.prototype.computeScrollerDims = function () {
        var scrollbarWidth = getScrollbarWidths();
        var _a = this, scrollerRefs = _a.scrollerRefs, scrollerElRefs = _a.scrollerElRefs;
        var forceYScrollbars = false;
        var scrollerClientWidths = {};
        var scrollerClientHeights = {};
        for (var sectionKey in scrollerRefs.currentMap) {
            var scroller = scrollerRefs.currentMap[sectionKey];
            if (scroller && scroller.needsYScrolling()) {
                forceYScrollbars = true;
                break;
            }
        }
        for (var _i = 0, _b = this.props.sections; _i < _b.length; _i++) {
            var section = _b[_i];
            var sectionKey = section.key;
            var scrollerEl = scrollerElRefs.currentMap[sectionKey];
            if (scrollerEl) {
                var harnessEl = scrollerEl.parentNode; // TODO: weird way to get this. need harness b/c doesn't include table borders
                scrollerClientWidths[sectionKey] = Math.floor(harnessEl.getBoundingClientRect().width - (forceYScrollbars
                    ? scrollbarWidth.y // use global because scroller might not have scrollbars yet but will need them in future
                    : 0));
                scrollerClientHeights[sectionKey] = Math.floor(harnessEl.getBoundingClientRect().height);
            }
        }
        return { forceYScrollbars: forceYScrollbars, scrollerClientWidths: scrollerClientWidths, scrollerClientHeights: scrollerClientHeights };
    };
    return SimpleScrollGrid;
}(BaseComponent));
SimpleScrollGrid.addStateEquality({
    scrollerClientWidths: isPropsEqual,
    scrollerClientHeights: isPropsEqual,
});
function getSectionByKey(sections, key) {
    for (var _i = 0, sections_1 = sections; _i < sections_1.length; _i++) {
        var section = sections_1[_i];
        if (section.key === key) {
            return section;
        }
    }
    return null;
}

var EventRoot = /** @class */ (function (_super) {
    tslib.__extends(EventRoot, _super);
    function EventRoot() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.elRef = vdom_cjs.createRef();
        return _this;
    }
    EventRoot.prototype.render = function () {
        var _a = this, props = _a.props, context = _a.context;
        var options = context.options;
        var seg = props.seg;
        var eventRange = seg.eventRange;
        var ui = eventRange.ui;
        var hookProps = {
            event: new EventApi(context, eventRange.def, eventRange.instance),
            view: context.viewApi,
            timeText: props.timeText,
            textColor: ui.textColor,
            backgroundColor: ui.backgroundColor,
            borderColor: ui.borderColor,
            isDraggable: !props.disableDragging && computeSegDraggable(seg, context),
            isStartResizable: !props.disableResizing && computeSegStartResizable(seg, context),
            isEndResizable: !props.disableResizing && computeSegEndResizable(seg),
            isMirror: Boolean(props.isDragging || props.isResizing || props.isDateSelecting),
            isStart: Boolean(seg.isStart),
            isEnd: Boolean(seg.isEnd),
            isPast: Boolean(props.isPast),
            isFuture: Boolean(props.isFuture),
            isToday: Boolean(props.isToday),
            isSelected: Boolean(props.isSelected),
            isDragging: Boolean(props.isDragging),
            isResizing: Boolean(props.isResizing),
        };
        var standardClassNames = getEventClassNames(hookProps).concat(ui.classNames);
        return (vdom_cjs.createElement(RenderHook, { hookProps: hookProps, classNames: options.eventClassNames, content: options.eventContent, defaultContent: props.defaultContent, didMount: options.eventDidMount, willUnmount: options.eventWillUnmount, elRef: this.elRef }, function (rootElRef, customClassNames, innerElRef, innerContent) { return props.children(rootElRef, standardClassNames.concat(customClassNames), innerElRef, innerContent, hookProps); }));
    };
    EventRoot.prototype.componentDidMount = function () {
        setElSeg(this.elRef.current, this.props.seg);
    };
    /*
    need to re-assign seg to the element if seg changes, even if the element is the same
    */
    EventRoot.prototype.componentDidUpdate = function (prevProps) {
        var seg = this.props.seg;
        if (seg !== prevProps.seg) {
            setElSeg(this.elRef.current, seg);
        }
    };
    return EventRoot;
}(BaseComponent));

// should not be a purecomponent
var StandardEvent = /** @class */ (function (_super) {
    tslib.__extends(StandardEvent, _super);
    function StandardEvent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StandardEvent.prototype.render = function () {
        var _a = this, props = _a.props, context = _a.context;
        var seg = props.seg;
        var timeFormat = context.options.eventTimeFormat || props.defaultTimeFormat;
        var timeText = buildSegTimeText(seg, timeFormat, context, props.defaultDisplayEventTime, props.defaultDisplayEventEnd);
        return (vdom_cjs.createElement(EventRoot, { seg: seg, timeText: timeText, disableDragging: props.disableDragging, disableResizing: props.disableResizing, defaultContent: props.defaultContent || renderInnerContent$1, isDragging: props.isDragging, isResizing: props.isResizing, isDateSelecting: props.isDateSelecting, isSelected: props.isSelected, isPast: props.isPast, isFuture: props.isFuture, isToday: props.isToday }, function (rootElRef, classNames, innerElRef, innerContent, hookProps) { return (vdom_cjs.createElement("a", tslib.__assign({ className: props.extraClassNames.concat(classNames).join(' '), style: {
                borderColor: hookProps.borderColor,
                backgroundColor: hookProps.backgroundColor,
            }, ref: rootElRef }, getSegAnchorAttrs(seg)),
            vdom_cjs.createElement("div", { className: "fc-event-main", ref: innerElRef, style: { color: hookProps.textColor } }, innerContent),
            hookProps.isStartResizable &&
                vdom_cjs.createElement("div", { className: "fc-event-resizer fc-event-resizer-start" }),
            hookProps.isEndResizable &&
                vdom_cjs.createElement("div", { className: "fc-event-resizer fc-event-resizer-end" }))); }));
    };
    return StandardEvent;
}(BaseComponent));
function renderInnerContent$1(innerProps) {
    return (vdom_cjs.createElement("div", { className: "fc-event-main-frame" },
        innerProps.timeText && (vdom_cjs.createElement("div", { className: "fc-event-time" }, innerProps.timeText)),
        vdom_cjs.createElement("div", { className: "fc-event-title-container" },
            vdom_cjs.createElement("div", { className: "fc-event-title fc-sticky" }, innerProps.event.title || vdom_cjs.createElement(vdom_cjs.Fragment, null, "\u00A0")))));
}
function getSegAnchorAttrs(seg) {
    var url = seg.eventRange.def.url;
    return url ? { href: url } : {};
}

var NowIndicatorRoot = function (props) { return (vdom_cjs.createElement(ViewContextType.Consumer, null, function (context) {
    var options = context.options;
    var hookProps = {
        isAxis: props.isAxis,
        date: context.dateEnv.toDate(props.date),
        view: context.viewApi,
    };
    return (vdom_cjs.createElement(RenderHook, { hookProps: hookProps, classNames: options.nowIndicatorClassNames, content: options.nowIndicatorContent, didMount: options.nowIndicatorDidMount, willUnmount: options.nowIndicatorWillUnmount }, props.children));
})); };

var DAY_NUM_FORMAT = createFormatter({ day: 'numeric' });
var DayCellContent = /** @class */ (function (_super) {
    tslib.__extends(DayCellContent, _super);
    function DayCellContent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DayCellContent.prototype.render = function () {
        var _a = this, props = _a.props, context = _a.context;
        var options = context.options;
        var hookProps = refineDayCellHookProps({
            date: props.date,
            dateProfile: props.dateProfile,
            todayRange: props.todayRange,
            showDayNumber: props.showDayNumber,
            extraProps: props.extraHookProps,
            viewApi: context.viewApi,
            dateEnv: context.dateEnv,
        });
        return (vdom_cjs.createElement(ContentHook, { hookProps: hookProps, content: options.dayCellContent, defaultContent: props.defaultContent }, props.children));
    };
    return DayCellContent;
}(BaseComponent));
function refineDayCellHookProps(raw) {
    var date = raw.date, dateEnv = raw.dateEnv;
    var dayMeta = getDateMeta(date, raw.todayRange, null, raw.dateProfile);
    return tslib.__assign(tslib.__assign(tslib.__assign({ date: dateEnv.toDate(date), view: raw.viewApi }, dayMeta), { dayNumberText: raw.showDayNumber ? dateEnv.format(date, DAY_NUM_FORMAT) : '' }), raw.extraProps);
}

var DayCellRoot = /** @class */ (function (_super) {
    tslib.__extends(DayCellRoot, _super);
    function DayCellRoot() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.refineHookProps = memoizeObjArg(refineDayCellHookProps);
        _this.normalizeClassNames = buildClassNameNormalizer();
        return _this;
    }
    DayCellRoot.prototype.render = function () {
        var _a = this, props = _a.props, context = _a.context;
        var options = context.options;
        var hookProps = this.refineHookProps({
            date: props.date,
            dateProfile: props.dateProfile,
            todayRange: props.todayRange,
            showDayNumber: props.showDayNumber,
            extraProps: props.extraHookProps,
            viewApi: context.viewApi,
            dateEnv: context.dateEnv,
        });
        var classNames = getDayClassNames(hookProps, context.theme).concat(hookProps.isDisabled
            ? [] // don't use custom classNames if disabled
            : this.normalizeClassNames(options.dayCellClassNames, hookProps));
        var dataAttrs = hookProps.isDisabled ? {} : {
            'data-date': formatDayString(props.date),
        };
        return (vdom_cjs.createElement(MountHook, { hookProps: hookProps, didMount: options.dayCellDidMount, willUnmount: options.dayCellWillUnmount, elRef: props.elRef }, function (rootElRef) { return props.children(rootElRef, classNames, dataAttrs, hookProps.isDisabled); }));
    };
    return DayCellRoot;
}(BaseComponent));

function renderFill(fillType) {
    return (vdom_cjs.createElement("div", { className: "fc-" + fillType }));
}
var BgEvent = function (props) { return (vdom_cjs.createElement(EventRoot, { defaultContent: renderInnerContent, seg: props.seg /* uselesss i think */, timeText: "", disableDragging: true, disableResizing: true, isDragging: false, isResizing: false, isDateSelecting: false, isSelected: false, isPast: props.isPast, isFuture: props.isFuture, isToday: props.isToday }, function (rootElRef, classNames, innerElRef, innerContent, hookProps) { return (vdom_cjs.createElement("div", { ref: rootElRef, className: ['fc-bg-event'].concat(classNames).join(' '), style: {
        backgroundColor: hookProps.backgroundColor,
    } }, innerContent)); })); };
function renderInnerContent(props) {
    var title = props.event.title;
    return title && (vdom_cjs.createElement("div", { className: "fc-event-title" }, props.event.title));
}

var WeekNumberRoot = function (props) { return (vdom_cjs.createElement(ViewContextType.Consumer, null, function (context) {
    var dateEnv = context.dateEnv, options = context.options;
    var date = props.date;
    var format = options.weekNumberFormat || props.defaultFormat;
    var num = dateEnv.computeWeekNumber(date); // TODO: somehow use for formatting as well?
    var text = dateEnv.format(date, format);
    var hookProps = { num: num, text: text, date: date };
    return (vdom_cjs.createElement(RenderHook, { hookProps: hookProps, classNames: options.weekNumberClassNames, content: options.weekNumberContent, defaultContent: renderInner, didMount: options.weekNumberDidMount, willUnmount: options.weekNumberWillUnmount }, props.children));
})); };
function renderInner(innerProps) {
    return innerProps.text;
}

var PADDING_FROM_VIEWPORT = 10;
var Popover = /** @class */ (function (_super) {
    tslib.__extends(Popover, _super);
    function Popover() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleRootEl = function (el) {
            _this.rootEl = el;
            if (_this.props.elRef) {
                setRef(_this.props.elRef, el);
            }
        };
        // Triggered when the user clicks *anywhere* in the document, for the autoHide feature
        _this.handleDocumentMousedown = function (ev) {
            // only hide the popover if the click happened outside the popover
            var target = getEventTargetViaRoot(ev);
            if (!_this.rootEl.contains(target)) {
                _this.handleCloseClick();
            }
        };
        _this.handleCloseClick = function () {
            var onClose = _this.props.onClose;
            if (onClose) {
                onClose();
            }
        };
        return _this;
    }
    Popover.prototype.render = function () {
        var theme = this.context.theme;
        var props = this.props;
        var classNames = [
            'fc-popover',
            theme.getClass('popover'),
        ].concat(props.extraClassNames || []);
        return vdom_cjs.createPortal(vdom_cjs.createElement("div", tslib.__assign({ className: classNames.join(' ') }, props.extraAttrs, { ref: this.handleRootEl }),
            vdom_cjs.createElement("div", { className: 'fc-popover-header ' + theme.getClass('popoverHeader') },
                vdom_cjs.createElement("span", { className: "fc-popover-title" }, props.title),
                vdom_cjs.createElement("span", { className: 'fc-popover-close ' + theme.getIconClass('close'), onClick: this.handleCloseClick })),
            vdom_cjs.createElement("div", { className: 'fc-popover-body ' + theme.getClass('popoverContent') }, props.children)), props.parentEl);
    };
    Popover.prototype.componentDidMount = function () {
        document.addEventListener('mousedown', this.handleDocumentMousedown);
        this.updateSize();
    };
    Popover.prototype.componentWillUnmount = function () {
        document.removeEventListener('mousedown', this.handleDocumentMousedown);
    };
    Popover.prototype.updateSize = function () {
        var isRtl = this.context.isRtl;
        var _a = this.props, alignmentEl = _a.alignmentEl, alignGridTop = _a.alignGridTop;
        var rootEl = this.rootEl;
        var alignmentRect = computeClippedClientRect(alignmentEl);
        if (alignmentRect) {
            var popoverDims = rootEl.getBoundingClientRect();
            // position relative to viewport
            var popoverTop = alignGridTop
                ? elementClosest(alignmentEl, '.fc-scrollgrid').getBoundingClientRect().top
                : alignmentRect.top;
            var popoverLeft = isRtl ? alignmentRect.right - popoverDims.width : alignmentRect.left;
            // constrain
            popoverTop = Math.max(popoverTop, PADDING_FROM_VIEWPORT);
            popoverLeft = Math.min(popoverLeft, document.documentElement.clientWidth - PADDING_FROM_VIEWPORT - popoverDims.width);
            popoverLeft = Math.max(popoverLeft, PADDING_FROM_VIEWPORT);
            var origin_1 = rootEl.offsetParent.getBoundingClientRect();
            applyStyle(rootEl, {
                top: popoverTop - origin_1.top,
                left: popoverLeft - origin_1.left,
            });
        }
    };
    return Popover;
}(BaseComponent));

var MorePopover = /** @class */ (function (_super) {
    tslib.__extends(MorePopover, _super);
    function MorePopover() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleRootEl = function (rootEl) {
            _this.rootEl = rootEl;
            if (rootEl) {
                _this.context.registerInteractiveComponent(_this, {
                    el: rootEl,
                    useEventCenter: false,
                });
            }
            else {
                _this.context.unregisterInteractiveComponent(_this);
            }
        };
        return _this;
    }
    MorePopover.prototype.render = function () {
        var _a = this.context, options = _a.options, dateEnv = _a.dateEnv;
        var props = this.props;
        var startDate = props.startDate, todayRange = props.todayRange, dateProfile = props.dateProfile;
        var title = dateEnv.format(startDate, options.dayPopoverFormat);
        return (vdom_cjs.createElement(DayCellRoot, { date: startDate, dateProfile: dateProfile, todayRange: todayRange, elRef: this.handleRootEl }, function (rootElRef, dayClassNames, dataAttrs) { return (vdom_cjs.createElement(Popover, { elRef: rootElRef, title: title, extraClassNames: ['fc-more-popover'].concat(dayClassNames), extraAttrs: dataAttrs /* TODO: make these time-based when not whole-day? */, parentEl: props.parentEl, alignmentEl: props.alignmentEl, alignGridTop: props.alignGridTop, onClose: props.onClose },
            vdom_cjs.createElement(DayCellContent, { date: startDate, dateProfile: dateProfile, todayRange: todayRange }, function (innerElRef, innerContent) { return (innerContent &&
                vdom_cjs.createElement("div", { className: "fc-more-popover-misc", ref: innerElRef }, innerContent)); }),
            props.children)); }));
    };
    MorePopover.prototype.queryHit = function (positionLeft, positionTop, elWidth, elHeight) {
        var _a = this, rootEl = _a.rootEl, props = _a.props;
        if (positionLeft >= 0 && positionLeft < elWidth &&
            positionTop >= 0 && positionTop < elHeight) {
            return {
                dateProfile: props.dateProfile,
                dateSpan: tslib.__assign({ allDay: true, range: {
                        start: props.startDate,
                        end: props.endDate,
                    } }, props.extraDateSpan),
                dayEl: rootEl,
                rect: {
                    left: 0,
                    top: 0,
                    right: elWidth,
                    bottom: elHeight,
                },
                layer: 1, // important when comparing with hits from other components
            };
        }
        return null;
    };
    return MorePopover;
}(DateComponent));

var MoreLinkRoot = /** @class */ (function (_super) {
    tslib.__extends(MoreLinkRoot, _super);
    function MoreLinkRoot() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.linkElRef = vdom_cjs.createRef();
        _this.state = {
            isPopoverOpen: false,
        };
        _this.handleClick = function (ev) {
            var _a = _this, props = _a.props, context = _a.context;
            var moreLinkClick = context.options.moreLinkClick;
            var date = computeRange(props).start;
            function buildPublicSeg(seg) {
                var _a = seg.eventRange, def = _a.def, instance = _a.instance, range = _a.range;
                return {
                    event: new EventApi(context, def, instance),
                    start: context.dateEnv.toDate(range.start),
                    end: context.dateEnv.toDate(range.end),
                    isStart: seg.isStart,
                    isEnd: seg.isEnd,
                };
            }
            if (typeof moreLinkClick === 'function') {
                moreLinkClick = moreLinkClick({
                    date: date,
                    allDay: Boolean(props.allDayDate),
                    allSegs: props.allSegs.map(buildPublicSeg),
                    hiddenSegs: props.hiddenSegs.map(buildPublicSeg),
                    jsEvent: ev,
                    view: context.viewApi,
                });
            }
            if (!moreLinkClick || moreLinkClick === 'popover') {
                _this.setState({ isPopoverOpen: true });
            }
            else if (typeof moreLinkClick === 'string') { // a view name
                context.calendarApi.zoomTo(date, moreLinkClick);
            }
        };
        _this.handlePopoverClose = function () {
            _this.setState({ isPopoverOpen: false });
        };
        return _this;
    }
    MoreLinkRoot.prototype.render = function () {
        var _this = this;
        var props = this.props;
        return (vdom_cjs.createElement(ViewContextType.Consumer, null, function (context) {
            var viewApi = context.viewApi, options = context.options, calendarApi = context.calendarApi;
            var moreLinkText = options.moreLinkText;
            var moreCnt = props.moreCnt;
            var range = computeRange(props);
            var hookProps = {
                num: moreCnt,
                shortText: "+" + moreCnt,
                text: typeof moreLinkText === 'function'
                    ? moreLinkText.call(calendarApi, moreCnt)
                    : "+" + moreCnt + " " + moreLinkText,
                view: viewApi,
            };
            return (vdom_cjs.createElement(vdom_cjs.Fragment, null,
                Boolean(props.moreCnt) && (vdom_cjs.createElement(RenderHook, { elRef: _this.linkElRef, hookProps: hookProps, classNames: options.moreLinkClassNames, content: options.moreLinkContent, defaultContent: props.defaultContent || renderMoreLinkInner, didMount: options.moreLinkDidMount, willUnmount: options.moreLinkWillUnmount }, function (rootElRef, customClassNames, innerElRef, innerContent) { return props.children(rootElRef, ['fc-more-link'].concat(customClassNames), innerElRef, innerContent, _this.handleClick); })),
                _this.state.isPopoverOpen && (vdom_cjs.createElement(MorePopover, { startDate: range.start, endDate: range.end, dateProfile: props.dateProfile, todayRange: props.todayRange, extraDateSpan: props.extraDateSpan, parentEl: _this.parentEl, alignmentEl: props.alignmentElRef.current, alignGridTop: props.alignGridTop, onClose: _this.handlePopoverClose }, props.popoverContent()))));
        }));
    };
    MoreLinkRoot.prototype.componentDidMount = function () {
        this.updateParentEl();
    };
    MoreLinkRoot.prototype.componentDidUpdate = function () {
        this.updateParentEl();
    };
    MoreLinkRoot.prototype.updateParentEl = function () {
        if (this.linkElRef.current) {
            this.parentEl = elementClosest(this.linkElRef.current, '.fc-view-harness');
        }
    };
    return MoreLinkRoot;
}(BaseComponent));
function renderMoreLinkInner(props) {
    return props.text;
}
function computeRange(props) {
    if (props.allDayDate) {
        return {
            start: props.allDayDate,
            end: addDays(props.allDayDate, 1),
        };
    }
    var hiddenSegs = props.hiddenSegs;
    return {
        start: computeEarliestSegStart(hiddenSegs),
        end: computeLatestSegEnd(hiddenSegs),
    };
}
function computeEarliestSegStart(segs) {
    return segs.reduce(pickEarliestStart).eventRange.range.start;
}
function pickEarliestStart(seg0, seg1) {
    return seg0.eventRange.range.start < seg1.eventRange.range.start ? seg0 : seg1;
}
function computeLatestSegEnd(segs) {
    return segs.reduce(pickLatestEnd).eventRange.range.end;
}
function pickLatestEnd(seg0, seg1) {
    return seg0.eventRange.range.end > seg1.eventRange.range.end ? seg0 : seg1;
}

// exports
// --------------------------------------------------------------------------------------------------
var version = '5.9.0'; // important to type it, so .d.ts has generic string

exports.BASE_OPTION_DEFAULTS = BASE_OPTION_DEFAULTS;
exports.BASE_OPTION_REFINERS = BASE_OPTION_REFINERS;
exports.BaseComponent = BaseComponent;
exports.BgEvent = BgEvent;
exports.CalendarApi = CalendarApi;
exports.CalendarContent = CalendarContent;
exports.CalendarDataManager = CalendarDataManager;
exports.CalendarDataProvider = CalendarDataProvider;
exports.CalendarRoot = CalendarRoot;
exports.ContentHook = ContentHook;
exports.CustomContentRenderContext = CustomContentRenderContext;
exports.DateComponent = DateComponent;
exports.DateEnv = DateEnv;
exports.DateProfileGenerator = DateProfileGenerator;
exports.DayCellContent = DayCellContent;
exports.DayCellRoot = DayCellRoot;
exports.DayHeader = DayHeader;
exports.DaySeriesModel = DaySeriesModel;
exports.DayTableModel = DayTableModel;
exports.DelayedRunner = DelayedRunner;
exports.ElementDragging = ElementDragging;
exports.ElementScrollController = ElementScrollController;
exports.Emitter = Emitter;
exports.EventApi = EventApi;
exports.EventRoot = EventRoot;
exports.EventSourceApi = EventSourceApi;
exports.Interaction = Interaction;
exports.MoreLinkRoot = MoreLinkRoot;
exports.MountHook = MountHook;
exports.NamedTimeZoneImpl = NamedTimeZoneImpl;
exports.NowIndicatorRoot = NowIndicatorRoot;
exports.NowTimer = NowTimer;
exports.PositionCache = PositionCache;
exports.RefMap = RefMap;
exports.RenderHook = RenderHook;
exports.ScrollController = ScrollController;
exports.ScrollResponder = ScrollResponder;
exports.Scroller = Scroller;
exports.SegHierarchy = SegHierarchy;
exports.SimpleScrollGrid = SimpleScrollGrid;
exports.Slicer = Slicer;
exports.Splitter = Splitter;
exports.StandardEvent = StandardEvent;
exports.TableDateCell = TableDateCell;
exports.TableDowCell = TableDowCell;
exports.Theme = Theme;
exports.ViewApi = ViewApi;
exports.ViewContextType = ViewContextType;
exports.ViewRoot = ViewRoot;
exports.WeekNumberRoot = WeekNumberRoot;
exports.WindowScrollController = WindowScrollController;
exports.addDays = addDays;
exports.addDurations = addDurations;
exports.addMs = addMs;
exports.addWeeks = addWeeks;
exports.allowContextMenu = allowContextMenu;
exports.allowSelection = allowSelection;
exports.applyMutationToEventStore = applyMutationToEventStore;
exports.applyStyle = applyStyle;
exports.applyStyleProp = applyStyleProp;
exports.asCleanDays = asCleanDays;
exports.asRoughMinutes = asRoughMinutes;
exports.asRoughMs = asRoughMs;
exports.asRoughSeconds = asRoughSeconds;
exports.binarySearch = binarySearch;
exports.buildClassNameNormalizer = buildClassNameNormalizer;
exports.buildEntryKey = buildEntryKey;
exports.buildEventApis = buildEventApis;
exports.buildEventRangeKey = buildEventRangeKey;
exports.buildHashFromArray = buildHashFromArray;
exports.buildIsoString = buildIsoString;
exports.buildNavLinkData = buildNavLinkData;
exports.buildSegCompareObj = buildSegCompareObj;
exports.buildSegTimeText = buildSegTimeText;
exports.collectFromHash = collectFromHash;
exports.combineEventUis = combineEventUis;
exports.compareByFieldSpec = compareByFieldSpec;
exports.compareByFieldSpecs = compareByFieldSpecs;
exports.compareNumbers = compareNumbers;
exports.compareObjs = compareObjs;
exports.computeEarliestSegStart = computeEarliestSegStart;
exports.computeEdges = computeEdges;
exports.computeFallbackHeaderFormat = computeFallbackHeaderFormat;
exports.computeHeightAndMargins = computeHeightAndMargins;
exports.computeInnerRect = computeInnerRect;
exports.computeRect = computeRect;
exports.computeSegDraggable = computeSegDraggable;
exports.computeSegEndResizable = computeSegEndResizable;
exports.computeSegStartResizable = computeSegStartResizable;
exports.computeShrinkWidth = computeShrinkWidth;
exports.computeSmallestCellWidth = computeSmallestCellWidth;
exports.computeVisibleDayRange = computeVisibleDayRange;
exports.config = config;
exports.constrainPoint = constrainPoint;
exports.createDuration = createDuration;
exports.createEmptyEventStore = createEmptyEventStore;
exports.createEventInstance = createEventInstance;
exports.createEventUi = createEventUi;
exports.createFormatter = createFormatter;
exports.createPlugin = createPlugin;
exports.diffDates = diffDates;
exports.diffDayAndTime = diffDayAndTime;
exports.diffDays = diffDays;
exports.diffPoints = diffPoints;
exports.diffWeeks = diffWeeks;
exports.diffWholeDays = diffWholeDays;
exports.diffWholeWeeks = diffWholeWeeks;
exports.disableCursor = disableCursor;
exports.elementClosest = elementClosest;
exports.elementMatches = elementMatches;
exports.enableCursor = enableCursor;
exports.eventTupleToStore = eventTupleToStore;
exports.filterEventStoreDefs = filterEventStoreDefs;
exports.filterHash = filterHash;
exports.findDirectChildren = findDirectChildren;
exports.findElements = findElements;
exports.flexibleCompare = flexibleCompare;
exports.formatDate = formatDate;
exports.formatDayString = formatDayString;
exports.formatIsoTimeString = formatIsoTimeString;
exports.formatRange = formatRange;
exports.getAllowYScrolling = getAllowYScrolling;
exports.getCanVGrowWithinCell = getCanVGrowWithinCell;
exports.getClippingParents = getClippingParents;
exports.getDateMeta = getDateMeta;
exports.getDayClassNames = getDayClassNames;
exports.getDefaultEventEnd = getDefaultEventEnd;
exports.getElRoot = getElRoot;
exports.getElSeg = getElSeg;
exports.getEntrySpanEnd = getEntrySpanEnd;
exports.getEventClassNames = getEventClassNames;
exports.getEventTargetViaRoot = getEventTargetViaRoot;
exports.getIsRtlScrollbarOnLeft = getIsRtlScrollbarOnLeft;
exports.getRectCenter = getRectCenter;
exports.getRelevantEvents = getRelevantEvents;
exports.getScrollGridClassNames = getScrollGridClassNames;
exports.getScrollbarWidths = getScrollbarWidths;
exports.getSectionClassNames = getSectionClassNames;
exports.getSectionHasLiquidHeight = getSectionHasLiquidHeight;
exports.getSegMeta = getSegMeta;
exports.getSlotClassNames = getSlotClassNames;
exports.getStickyFooterScrollbar = getStickyFooterScrollbar;
exports.getStickyHeaderDates = getStickyHeaderDates;
exports.getUnequalProps = getUnequalProps;
exports.globalLocales = globalLocales;
exports.globalPlugins = globalPlugins;
exports.greatestDurationDenominator = greatestDurationDenominator;
exports.groupIntersectingEntries = groupIntersectingEntries;
exports.guid = guid;
exports.hasBgRendering = hasBgRendering;
exports.hasShrinkWidth = hasShrinkWidth;
exports.identity = identity;
exports.interactionSettingsStore = interactionSettingsStore;
exports.interactionSettingsToStore = interactionSettingsToStore;
exports.intersectRanges = intersectRanges;
exports.intersectRects = intersectRects;
exports.intersectSpans = intersectSpans;
exports.isArraysEqual = isArraysEqual;
exports.isColPropsEqual = isColPropsEqual;
exports.isDateSelectionValid = isDateSelectionValid;
exports.isDateSpansEqual = isDateSpansEqual;
exports.isInt = isInt;
exports.isInteractionValid = isInteractionValid;
exports.isMultiDayRange = isMultiDayRange;
exports.isPropsEqual = isPropsEqual;
exports.isPropsValid = isPropsValid;
exports.isValidDate = isValidDate;
exports.joinSpans = joinSpans;
exports.listenBySelector = listenBySelector;
exports.mapHash = mapHash;
exports.memoize = memoize;
exports.memoizeArraylike = memoizeArraylike;
exports.memoizeHashlike = memoizeHashlike;
exports.memoizeObjArg = memoizeObjArg;
exports.mergeEventStores = mergeEventStores;
exports.multiplyDuration = multiplyDuration;
exports.padStart = padStart;
exports.parseBusinessHours = parseBusinessHours;
exports.parseClassNames = parseClassNames;
exports.parseDragMeta = parseDragMeta;
exports.parseEventDef = parseEventDef;
exports.parseFieldSpecs = parseFieldSpecs;
exports.parseMarker = parse;
exports.pointInsideRect = pointInsideRect;
exports.preventContextMenu = preventContextMenu;
exports.preventDefault = preventDefault;
exports.preventSelection = preventSelection;
exports.rangeContainsMarker = rangeContainsMarker;
exports.rangeContainsRange = rangeContainsRange;
exports.rangesEqual = rangesEqual;
exports.rangesIntersect = rangesIntersect;
exports.refineEventDef = refineEventDef;
exports.refineProps = refineProps;
exports.removeElement = removeElement;
exports.removeExact = removeExact;
exports.renderChunkContent = renderChunkContent;
exports.renderFill = renderFill;
exports.renderMicroColGroup = renderMicroColGroup;
exports.renderScrollShim = renderScrollShim;
exports.requestJson = requestJson;
exports.sanitizeShrinkWidth = sanitizeShrinkWidth;
exports.setElSeg = setElSeg;
exports.setRef = setRef;
exports.sliceEventStore = sliceEventStore;
exports.sliceEvents = sliceEvents;
exports.sortEventSegs = sortEventSegs;
exports.startOfDay = startOfDay;
exports.translateRect = translateRect;
exports.triggerDateSelect = triggerDateSelect;
exports.unpromisify = unpromisify;
exports.version = version;
exports.whenTransitionDone = whenTransitionDone;
exports.wholeDivideDurations = wholeDivideDurations;
Object.keys(vdom_cjs).forEach(function (k) {
    if (k !== 'default' && !exports.hasOwnProperty(k)) Object.defineProperty(exports, k, {
        enumerable: true,
        get: function () {
            return vdom_cjs[k];
        }
    });
});

},{"./vdom.cjs":4,"tslib":782}],4:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/// <reference types="@fullcalendar/core-preact" />
if (typeof FullCalendarVDom === 'undefined') {
    throw new Error('Please import the top-level fullcalendar lib before attempting to import a plugin.');
}
var Component = FullCalendarVDom.Component;
var createElement = FullCalendarVDom.createElement;
var render = FullCalendarVDom.render;
var createRef = FullCalendarVDom.createRef;
var Fragment = FullCalendarVDom.Fragment;
var createContext = FullCalendarVDom.createContext;
var createPortal = FullCalendarVDom.createPortal;
var flushToDom = FullCalendarVDom.flushToDom;
var unmountComponentAtNode = FullCalendarVDom.unmountComponentAtNode;
/* eslint-enable */

exports.Component = Component;
exports.Fragment = Fragment;
exports.createContext = createContext;
exports.createElement = createElement;
exports.createPortal = createPortal;
exports.createRef = createRef;
exports.flushToDom = flushToDom;
exports.render = render;
exports.unmountComponentAtNode = unmountComponentAtNode;

},{}],5:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var zhTw = {
  code: 'zh-tw',
  buttonText: {
    prev: '上月',
    next: '下月',
    today: '今天',
    month: '月',
    week: '週',
    day: '天',
    list: '活動列表',
  },
  weekText: '周',
  allDayText: '整天',
  moreLinkText: '顯示更多',
  noEventsText: '没有任何活動',
};

exports.default = zhTw;

},{}],6:[function(require,module,exports){
/*!
FullCalendar v5.9.0
Docs & License: https://fullcalendar.io/
(c) 2021 Adam Shaw
*/
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('./vdom.cjs');
var tslib = require('tslib');
var common = require('@fullcalendar/common');

var Calendar = /** @class */ (function (_super) {
    tslib.__extends(Calendar, _super);
    function Calendar(el, optionOverrides) {
        if (optionOverrides === void 0) { optionOverrides = {}; }
        var _this = _super.call(this) || this;
        _this.isRendering = false;
        _this.isRendered = false;
        _this.currentClassNames = [];
        _this.customContentRenderId = 0; // will affect custom generated classNames?
        _this.handleAction = function (action) {
            // actions we know we want to render immediately
            switch (action.type) {
                case 'SET_EVENT_DRAG':
                case 'SET_EVENT_RESIZE':
                    _this.renderRunner.tryDrain();
            }
        };
        _this.handleData = function (data) {
            _this.currentData = data;
            _this.renderRunner.request(data.calendarOptions.rerenderDelay);
        };
        _this.handleRenderRequest = function () {
            if (_this.isRendering) {
                _this.isRendered = true;
                var currentData_1 = _this.currentData;
                common.render(common.createElement(common.CalendarRoot, { options: currentData_1.calendarOptions, theme: currentData_1.theme, emitter: currentData_1.emitter }, function (classNames, height, isHeightAuto, forPrint) {
                    _this.setClassNames(classNames);
                    _this.setHeight(height);
                    return (common.createElement(common.CustomContentRenderContext.Provider, { value: _this.customContentRenderId },
                        common.createElement(common.CalendarContent, tslib.__assign({ isHeightAuto: isHeightAuto, forPrint: forPrint }, currentData_1))));
                }), _this.el);
            }
            else if (_this.isRendered) {
                _this.isRendered = false;
                common.unmountComponentAtNode(_this.el);
                _this.setClassNames([]);
                _this.setHeight('');
            }
            common.flushToDom();
        };
        _this.el = el;
        _this.renderRunner = new common.DelayedRunner(_this.handleRenderRequest);
        new common.CalendarDataManager({
            optionOverrides: optionOverrides,
            calendarApi: _this,
            onAction: _this.handleAction,
            onData: _this.handleData,
        });
        return _this;
    }
    Object.defineProperty(Calendar.prototype, "view", {
        get: function () { return this.currentData.viewApi; } // for public API
        ,
        enumerable: false,
        configurable: true
    });
    Calendar.prototype.render = function () {
        var wasRendering = this.isRendering;
        if (!wasRendering) {
            this.isRendering = true;
        }
        else {
            this.customContentRenderId += 1;
        }
        this.renderRunner.request();
        if (wasRendering) {
            this.updateSize();
        }
    };
    Calendar.prototype.destroy = function () {
        if (this.isRendering) {
            this.isRendering = false;
            this.renderRunner.request();
        }
    };
    Calendar.prototype.updateSize = function () {
        _super.prototype.updateSize.call(this);
        common.flushToDom();
    };
    Calendar.prototype.batchRendering = function (func) {
        this.renderRunner.pause('batchRendering');
        func();
        this.renderRunner.resume('batchRendering');
    };
    Calendar.prototype.pauseRendering = function () {
        this.renderRunner.pause('pauseRendering');
    };
    Calendar.prototype.resumeRendering = function () {
        this.renderRunner.resume('pauseRendering', true);
    };
    Calendar.prototype.resetOptions = function (optionOverrides, append) {
        this.currentDataManager.resetOptions(optionOverrides, append);
    };
    Calendar.prototype.setClassNames = function (classNames) {
        if (!common.isArraysEqual(classNames, this.currentClassNames)) {
            var classList = this.el.classList;
            for (var _i = 0, _a = this.currentClassNames; _i < _a.length; _i++) {
                var className = _a[_i];
                classList.remove(className);
            }
            for (var _b = 0, classNames_1 = classNames; _b < classNames_1.length; _b++) {
                var className = classNames_1[_b];
                classList.add(className);
            }
            this.currentClassNames = classNames;
        }
    };
    Calendar.prototype.setHeight = function (height) {
        common.applyStyleProp(this.el, 'height', height);
    };
    return Calendar;
}(common.CalendarApi));

exports.Calendar = Calendar;
Object.keys(common).forEach(function (k) {
    if (k !== 'default' && !exports.hasOwnProperty(k)) Object.defineProperty(exports, k, {
        enumerable: true,
        get: function () {
            return common[k];
        }
    });
});

},{"./vdom.cjs":7,"@fullcalendar/common":3,"tslib":782}],7:[function(require,module,exports){
'use strict';

var tslib = require('tslib');
var preact = require('preact');
var preactCompat = require('preact/compat');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () {
                        return e[k];
                    }
                });
            }
        });
    }
    n['default'] = e;
    return Object.freeze(n);
}

var preact__namespace = /*#__PURE__*/_interopNamespace(preact);
var preactCompat__namespace = /*#__PURE__*/_interopNamespace(preactCompat);

var globalObj = typeof globalThis !== 'undefined' ? globalThis : window; // // TODO: streamline when killing IE11 support
if (globalObj.FullCalendarVDom) {
    console.warn('FullCalendar VDOM already loaded');
}
else {
    globalObj.FullCalendarVDom = {
        Component: preact__namespace.Component,
        createElement: preact__namespace.createElement,
        render: preact__namespace.render,
        createRef: preact__namespace.createRef,
        Fragment: preact__namespace.Fragment,
        createContext: createContext,
        createPortal: preactCompat__namespace.createPortal,
        flushToDom: flushToDom,
        unmountComponentAtNode: unmountComponentAtNode,
    };
}
// HACKS...
// TODO: lock version
// TODO: link gh issues
function flushToDom() {
    var oldDebounceRendering = preact__namespace.options.debounceRendering; // orig
    var callbackQ = [];
    function execCallbackSync(callback) {
        callbackQ.push(callback);
    }
    preact__namespace.options.debounceRendering = execCallbackSync;
    preact__namespace.render(preact__namespace.createElement(FakeComponent, {}), document.createElement('div'));
    while (callbackQ.length) {
        callbackQ.shift()();
    }
    preact__namespace.options.debounceRendering = oldDebounceRendering;
}
var FakeComponent = /** @class */ (function (_super) {
    tslib.__extends(FakeComponent, _super);
    function FakeComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FakeComponent.prototype.render = function () { return preact__namespace.createElement('div', {}); };
    FakeComponent.prototype.componentDidMount = function () { this.setState({}); };
    return FakeComponent;
}(preact__namespace.Component));
function createContext(defaultValue) {
    var ContextType = preact__namespace.createContext(defaultValue);
    var origProvider = ContextType.Provider;
    ContextType.Provider = function () {
        var _this = this;
        var isNew = !this.getChildContext;
        var children = origProvider.apply(this, arguments); // eslint-disable-line prefer-rest-params
        if (isNew) {
            var subs_1 = [];
            this.shouldComponentUpdate = function (_props) {
                if (_this.props.value !== _props.value) {
                    subs_1.forEach(function (c) {
                        c.context = _props.value;
                        c.forceUpdate();
                    });
                }
            };
            this.sub = function (c) {
                subs_1.push(c);
                var old = c.componentWillUnmount;
                c.componentWillUnmount = function () {
                    subs_1.splice(subs_1.indexOf(c), 1);
                    old && old.call(c);
                };
            };
        }
        return children;
    };
    return ContextType;
}
function unmountComponentAtNode(node) {
    preact__namespace.render(null, node);
}

},{"preact":732,"preact/compat":731,"tslib":782}],8:[function(require,module,exports){
/*!
FullCalendar v5.9.0
Docs & License: https://fullcalendar.io/
(c) 2021 Adam Shaw
*/
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var common = require('@fullcalendar/common');
var tslib = require('tslib');
;

/* An abstract class for the daygrid views, as well as month view. Renders one or more rows of day cells.
----------------------------------------------------------------------------------------------------------------------*/
// It is a manager for a Table subcomponent, which does most of the heavy lifting.
// It is responsible for managing width/height.
var TableView = /** @class */ (function (_super) {
    tslib.__extends(TableView, _super);
    function TableView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.headerElRef = common.createRef();
        return _this;
    }
    TableView.prototype.renderSimpleLayout = function (headerRowContent, bodyContent) {
        var _a = this, props = _a.props, context = _a.context;
        var sections = [];
        var stickyHeaderDates = common.getStickyHeaderDates(context.options);
        if (headerRowContent) {
            sections.push({
                type: 'header',
                key: 'header',
                isSticky: stickyHeaderDates,
                chunk: {
                    elRef: this.headerElRef,
                    tableClassName: 'fc-col-header',
                    rowContent: headerRowContent,
                },
            });
        }
        sections.push({
            type: 'body',
            key: 'body',
            liquid: true,
            chunk: { content: bodyContent },
        });
        return (common.createElement(common.ViewRoot, { viewSpec: context.viewSpec }, function (rootElRef, classNames) { return (common.createElement("div", { ref: rootElRef, className: ['fc-daygrid'].concat(classNames).join(' ') },
            common.createElement(common.SimpleScrollGrid, { liquid: !props.isHeightAuto && !props.forPrint, collapsibleWidth: props.forPrint, cols: [] /* TODO: make optional? */, sections: sections }))); }));
    };
    TableView.prototype.renderHScrollLayout = function (headerRowContent, bodyContent, colCnt, dayMinWidth) {
        var ScrollGrid = this.context.pluginHooks.scrollGridImpl;
        if (!ScrollGrid) {
            throw new Error('No ScrollGrid implementation');
        }
        var _a = this, props = _a.props, context = _a.context;
        var stickyHeaderDates = !props.forPrint && common.getStickyHeaderDates(context.options);
        var stickyFooterScrollbar = !props.forPrint && common.getStickyFooterScrollbar(context.options);
        var sections = [];
        if (headerRowContent) {
            sections.push({
                type: 'header',
                key: 'header',
                isSticky: stickyHeaderDates,
                chunks: [{
                        key: 'main',
                        elRef: this.headerElRef,
                        tableClassName: 'fc-col-header',
                        rowContent: headerRowContent,
                    }],
            });
        }
        sections.push({
            type: 'body',
            key: 'body',
            liquid: true,
            chunks: [{
                    key: 'main',
                    content: bodyContent,
                }],
        });
        if (stickyFooterScrollbar) {
            sections.push({
                type: 'footer',
                key: 'footer',
                isSticky: true,
                chunks: [{
                        key: 'main',
                        content: common.renderScrollShim,
                    }],
            });
        }
        return (common.createElement(common.ViewRoot, { viewSpec: context.viewSpec }, function (rootElRef, classNames) { return (common.createElement("div", { ref: rootElRef, className: ['fc-daygrid'].concat(classNames).join(' ') },
            common.createElement(ScrollGrid, { liquid: !props.isHeightAuto && !props.forPrint, collapsibleWidth: props.forPrint, colGroups: [{ cols: [{ span: colCnt, minWidth: dayMinWidth }] }], sections: sections }))); }));
    };
    return TableView;
}(common.DateComponent));

function splitSegsByRow(segs, rowCnt) {
    var byRow = [];
    for (var i = 0; i < rowCnt; i += 1) {
        byRow[i] = [];
    }
    for (var _i = 0, segs_1 = segs; _i < segs_1.length; _i++) {
        var seg = segs_1[_i];
        byRow[seg.row].push(seg);
    }
    return byRow;
}
function splitSegsByFirstCol(segs, colCnt) {
    var byCol = [];
    for (var i = 0; i < colCnt; i += 1) {
        byCol[i] = [];
    }
    for (var _i = 0, segs_2 = segs; _i < segs_2.length; _i++) {
        var seg = segs_2[_i];
        byCol[seg.firstCol].push(seg);
    }
    return byCol;
}
function splitInteractionByRow(ui, rowCnt) {
    var byRow = [];
    if (!ui) {
        for (var i = 0; i < rowCnt; i += 1) {
            byRow[i] = null;
        }
    }
    else {
        for (var i = 0; i < rowCnt; i += 1) {
            byRow[i] = {
                affectedInstances: ui.affectedInstances,
                isEvent: ui.isEvent,
                segs: [],
            };
        }
        for (var _i = 0, _a = ui.segs; _i < _a.length; _i++) {
            var seg = _a[_i];
            byRow[seg.row].segs.push(seg);
        }
    }
    return byRow;
}

var TableCellTop = /** @class */ (function (_super) {
    tslib.__extends(TableCellTop, _super);
    function TableCellTop() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableCellTop.prototype.render = function () {
        var props = this.props;
        var navLinkAttrs = this.context.options.navLinks
            ? { 'data-navlink': common.buildNavLinkData(props.date), tabIndex: 0 }
            : {};
        return (common.createElement(common.DayCellContent, { date: props.date, dateProfile: props.dateProfile, todayRange: props.todayRange, showDayNumber: props.showDayNumber, extraHookProps: props.extraHookProps, defaultContent: renderTopInner }, function (innerElRef, innerContent) { return ((innerContent || props.forceDayTop) && (common.createElement("div", { className: "fc-daygrid-day-top", ref: innerElRef },
            common.createElement("a", tslib.__assign({ className: "fc-daygrid-day-number" }, navLinkAttrs), innerContent || common.createElement(common.Fragment, null, "\u00A0"))))); }));
    };
    return TableCellTop;
}(common.BaseComponent));
function renderTopInner(props) {
    return props.dayNumberText;
}

var DEFAULT_TABLE_EVENT_TIME_FORMAT = common.createFormatter({
    hour: 'numeric',
    minute: '2-digit',
    omitZeroMinute: true,
    meridiem: 'narrow',
});
function hasListItemDisplay(seg) {
    var display = seg.eventRange.ui.display;
    return display === 'list-item' || (display === 'auto' &&
        !seg.eventRange.def.allDay &&
        seg.firstCol === seg.lastCol && // can't be multi-day
        seg.isStart && // "
        seg.isEnd // "
    );
}

var TableBlockEvent = /** @class */ (function (_super) {
    tslib.__extends(TableBlockEvent, _super);
    function TableBlockEvent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableBlockEvent.prototype.render = function () {
        var props = this.props;
        return (common.createElement(common.StandardEvent, tslib.__assign({}, props, { extraClassNames: ['fc-daygrid-event', 'fc-daygrid-block-event', 'fc-h-event'], defaultTimeFormat: DEFAULT_TABLE_EVENT_TIME_FORMAT, defaultDisplayEventEnd: props.defaultDisplayEventEnd, disableResizing: !props.seg.eventRange.def.allDay })));
    };
    return TableBlockEvent;
}(common.BaseComponent));

var TableListItemEvent = /** @class */ (function (_super) {
    tslib.__extends(TableListItemEvent, _super);
    function TableListItemEvent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableListItemEvent.prototype.render = function () {
        var _a = this, props = _a.props, context = _a.context;
        var timeFormat = context.options.eventTimeFormat || DEFAULT_TABLE_EVENT_TIME_FORMAT;
        var timeText = common.buildSegTimeText(props.seg, timeFormat, context, true, props.defaultDisplayEventEnd);
        return (common.createElement(common.EventRoot, { seg: props.seg, timeText: timeText, defaultContent: renderInnerContent, isDragging: props.isDragging, isResizing: false, isDateSelecting: false, isSelected: props.isSelected, isPast: props.isPast, isFuture: props.isFuture, isToday: props.isToday }, function (rootElRef, classNames, innerElRef, innerContent) { return ( // we don't use styles!
        common.createElement("a", tslib.__assign({ className: ['fc-daygrid-event', 'fc-daygrid-dot-event'].concat(classNames).join(' '), ref: rootElRef }, getSegAnchorAttrs(props.seg)), innerContent)); }));
    };
    return TableListItemEvent;
}(common.BaseComponent));
function renderInnerContent(innerProps) {
    return (common.createElement(common.Fragment, null,
        common.createElement("div", { className: "fc-daygrid-event-dot", style: { borderColor: innerProps.borderColor || innerProps.backgroundColor } }),
        innerProps.timeText && (common.createElement("div", { className: "fc-event-time" }, innerProps.timeText)),
        common.createElement("div", { className: "fc-event-title" }, innerProps.event.title || common.createElement(common.Fragment, null, "\u00A0"))));
}
function getSegAnchorAttrs(seg) {
    var url = seg.eventRange.def.url;
    return url ? { href: url } : {};
}

var TableCellMoreLink = /** @class */ (function (_super) {
    tslib.__extends(TableCellMoreLink, _super);
    function TableCellMoreLink() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.compileSegs = common.memoize(compileSegs);
        return _this;
    }
    TableCellMoreLink.prototype.render = function () {
        var props = this.props;
        var _a = this.compileSegs(props.singlePlacements), allSegs = _a.allSegs, invisibleSegs = _a.invisibleSegs;
        return (common.createElement(common.MoreLinkRoot, { dateProfile: props.dateProfile, todayRange: props.todayRange, allDayDate: props.allDayDate, moreCnt: props.moreCnt, allSegs: allSegs, hiddenSegs: invisibleSegs, alignmentElRef: props.alignmentElRef, alignGridTop: props.alignGridTop, extraDateSpan: props.extraDateSpan, popoverContent: function () {
                var isForcedInvisible = (props.eventDrag ? props.eventDrag.affectedInstances : null) ||
                    (props.eventResize ? props.eventResize.affectedInstances : null) ||
                    {};
                return (common.createElement(common.Fragment, null, allSegs.map(function (seg) {
                    var instanceId = seg.eventRange.instance.instanceId;
                    return (common.createElement("div", { className: "fc-daygrid-event-harness", key: instanceId, style: {
                            visibility: isForcedInvisible[instanceId] ? 'hidden' : '',
                        } }, hasListItemDisplay(seg) ? (common.createElement(TableListItemEvent, tslib.__assign({ seg: seg, isDragging: false, isSelected: instanceId === props.eventSelection, defaultDisplayEventEnd: false }, common.getSegMeta(seg, props.todayRange)))) : (common.createElement(TableBlockEvent, tslib.__assign({ seg: seg, isDragging: false, isResizing: false, isDateSelecting: false, isSelected: instanceId === props.eventSelection, defaultDisplayEventEnd: false }, common.getSegMeta(seg, props.todayRange))))));
                })));
            } }, function (rootElRef, classNames, innerElRef, innerContent, handleClick) { return (common.createElement("a", { ref: rootElRef, className: ['fc-daygrid-more-link'].concat(classNames).join(' '), onClick: handleClick }, innerContent)); }));
    };
    return TableCellMoreLink;
}(common.BaseComponent));
function compileSegs(singlePlacements) {
    var allSegs = [];
    var invisibleSegs = [];
    for (var _i = 0, singlePlacements_1 = singlePlacements; _i < singlePlacements_1.length; _i++) {
        var placement = singlePlacements_1[_i];
        allSegs.push(placement.seg);
        if (!placement.isVisible) {
            invisibleSegs.push(placement.seg);
        }
    }
    return { allSegs: allSegs, invisibleSegs: invisibleSegs };
}

var DEFAULT_WEEK_NUM_FORMAT = common.createFormatter({ week: 'narrow' });
var TableCell = /** @class */ (function (_super) {
    tslib.__extends(TableCell, _super);
    function TableCell() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.rootElRef = common.createRef();
        _this.handleRootEl = function (el) {
            common.setRef(_this.rootElRef, el);
            common.setRef(_this.props.elRef, el);
        };
        return _this;
    }
    TableCell.prototype.render = function () {
        var _a = this, props = _a.props, context = _a.context, rootElRef = _a.rootElRef;
        var options = context.options;
        var date = props.date, dateProfile = props.dateProfile;
        var navLinkAttrs = options.navLinks
            ? { 'data-navlink': common.buildNavLinkData(date, 'week'), tabIndex: 0 }
            : {};
        return (common.createElement(common.DayCellRoot, { date: date, dateProfile: dateProfile, todayRange: props.todayRange, showDayNumber: props.showDayNumber, extraHookProps: props.extraHookProps, elRef: this.handleRootEl }, function (dayElRef, dayClassNames, rootDataAttrs, isDisabled) { return (common.createElement("td", tslib.__assign({ ref: dayElRef, className: ['fc-daygrid-day'].concat(dayClassNames, props.extraClassNames || []).join(' ') }, rootDataAttrs, props.extraDataAttrs),
            common.createElement("div", { className: "fc-daygrid-day-frame fc-scrollgrid-sync-inner", ref: props.innerElRef /* different from hook system! RENAME */ },
                props.showWeekNumber && (common.createElement(common.WeekNumberRoot, { date: date, defaultFormat: DEFAULT_WEEK_NUM_FORMAT }, function (weekElRef, weekClassNames, innerElRef, innerContent) { return (common.createElement("a", tslib.__assign({ ref: weekElRef, className: ['fc-daygrid-week-number'].concat(weekClassNames).join(' ') }, navLinkAttrs), innerContent)); })),
                !isDisabled && (common.createElement(TableCellTop, { date: date, dateProfile: dateProfile, showDayNumber: props.showDayNumber, forceDayTop: props.forceDayTop, todayRange: props.todayRange, extraHookProps: props.extraHookProps })),
                common.createElement("div", { className: "fc-daygrid-day-events", ref: props.fgContentElRef },
                    props.fgContent,
                    common.createElement("div", { className: "fc-daygrid-day-bottom", style: { marginTop: props.moreMarginTop } },
                        common.createElement(TableCellMoreLink, { allDayDate: date, singlePlacements: props.singlePlacements, moreCnt: props.moreCnt, alignmentElRef: rootElRef, alignGridTop: !props.showDayNumber, extraDateSpan: props.extraDateSpan, dateProfile: props.dateProfile, eventSelection: props.eventSelection, eventDrag: props.eventDrag, eventResize: props.eventResize, todayRange: props.todayRange }))),
                common.createElement("div", { className: "fc-daygrid-day-bg" }, props.bgContent)))); }));
    };
    return TableCell;
}(common.DateComponent));

function computeFgSegPlacement(segs, // assumed already sorted
dayMaxEvents, dayMaxEventRows, strictOrder, eventInstanceHeights, maxContentHeight, cells) {
    var hierarchy = new DayGridSegHierarchy();
    hierarchy.allowReslicing = true;
    hierarchy.strictOrder = strictOrder;
    if (dayMaxEvents === true || dayMaxEventRows === true) {
        hierarchy.maxCoord = maxContentHeight;
        hierarchy.hiddenConsumes = true;
    }
    else if (typeof dayMaxEvents === 'number') {
        hierarchy.maxStackCnt = dayMaxEvents;
    }
    else if (typeof dayMaxEventRows === 'number') {
        hierarchy.maxStackCnt = dayMaxEventRows;
        hierarchy.hiddenConsumes = true;
    }
    // create segInputs only for segs with known heights
    var segInputs = [];
    var unknownHeightSegs = [];
    for (var i = 0; i < segs.length; i += 1) {
        var seg = segs[i];
        var instanceId = seg.eventRange.instance.instanceId;
        var eventHeight = eventInstanceHeights[instanceId];
        if (eventHeight != null) {
            segInputs.push({
                index: i,
                thickness: eventHeight,
                span: {
                    start: seg.firstCol,
                    end: seg.lastCol + 1,
                },
            });
        }
        else {
            unknownHeightSegs.push(seg);
        }
    }
    var hiddenEntries = hierarchy.addSegs(segInputs);
    var segRects = hierarchy.toRects();
    var _a = placeRects(segRects, segs, cells), singleColPlacements = _a.singleColPlacements, multiColPlacements = _a.multiColPlacements, leftoverMargins = _a.leftoverMargins;
    var moreCnts = [];
    var moreMarginTops = [];
    // add segs with unknown heights
    for (var _i = 0, unknownHeightSegs_1 = unknownHeightSegs; _i < unknownHeightSegs_1.length; _i++) {
        var seg = unknownHeightSegs_1[_i];
        multiColPlacements[seg.firstCol].push({
            seg: seg,
            isVisible: false,
            isAbsolute: true,
            absoluteTop: 0,
            marginTop: 0,
        });
        for (var col = seg.firstCol; col <= seg.lastCol; col += 1) {
            singleColPlacements[col].push({
                seg: resliceSeg(seg, col, col + 1, cells),
                isVisible: false,
                isAbsolute: false,
                absoluteTop: 0,
                marginTop: 0,
            });
        }
    }
    // add the hidden entries
    for (var col = 0; col < cells.length; col += 1) {
        moreCnts.push(0);
    }
    for (var _b = 0, hiddenEntries_1 = hiddenEntries; _b < hiddenEntries_1.length; _b++) {
        var hiddenEntry = hiddenEntries_1[_b];
        var seg = segs[hiddenEntry.index];
        var hiddenSpan = hiddenEntry.span;
        multiColPlacements[hiddenSpan.start].push({
            seg: resliceSeg(seg, hiddenSpan.start, hiddenSpan.end, cells),
            isVisible: false,
            isAbsolute: true,
            absoluteTop: 0,
            marginTop: 0,
        });
        for (var col = hiddenSpan.start; col < hiddenSpan.end; col += 1) {
            moreCnts[col] += 1;
            singleColPlacements[col].push({
                seg: resliceSeg(seg, col, col + 1, cells),
                isVisible: false,
                isAbsolute: false,
                absoluteTop: 0,
                marginTop: 0,
            });
        }
    }
    // deal with leftover margins
    for (var col = 0; col < cells.length; col += 1) {
        moreMarginTops.push(leftoverMargins[col]);
    }
    return { singleColPlacements: singleColPlacements, multiColPlacements: multiColPlacements, moreCnts: moreCnts, moreMarginTops: moreMarginTops };
}
// rects ordered by top coord, then left
function placeRects(allRects, segs, cells) {
    var rectsByEachCol = groupRectsByEachCol(allRects, cells.length);
    var singleColPlacements = [];
    var multiColPlacements = [];
    var leftoverMargins = [];
    for (var col = 0; col < cells.length; col += 1) {
        var rects = rectsByEachCol[col];
        // compute all static segs in singlePlacements
        var singlePlacements = [];
        var currentHeight = 0;
        var currentMarginTop = 0;
        for (var _i = 0, rects_1 = rects; _i < rects_1.length; _i++) {
            var rect = rects_1[_i];
            var seg = segs[rect.index];
            singlePlacements.push({
                seg: resliceSeg(seg, col, col + 1, cells),
                isVisible: true,
                isAbsolute: false,
                absoluteTop: rect.levelCoord,
                marginTop: rect.levelCoord - currentHeight,
            });
            currentHeight = rect.levelCoord + rect.thickness;
        }
        // compute mixed static/absolute segs in multiPlacements
        var multiPlacements = [];
        currentHeight = 0;
        currentMarginTop = 0;
        for (var _a = 0, rects_2 = rects; _a < rects_2.length; _a++) {
            var rect = rects_2[_a];
            var seg = segs[rect.index];
            var isAbsolute = rect.span.end - rect.span.start > 1; // multi-column?
            var isFirstCol = rect.span.start === col;
            currentMarginTop += rect.levelCoord - currentHeight; // amount of space since bottom of previous seg
            currentHeight = rect.levelCoord + rect.thickness; // height will now be bottom of current seg
            if (isAbsolute) {
                currentMarginTop += rect.thickness;
                if (isFirstCol) {
                    multiPlacements.push({
                        seg: resliceSeg(seg, rect.span.start, rect.span.end, cells),
                        isVisible: true,
                        isAbsolute: true,
                        absoluteTop: rect.levelCoord,
                        marginTop: 0,
                    });
                }
            }
            else if (isFirstCol) {
                multiPlacements.push({
                    seg: resliceSeg(seg, rect.span.start, rect.span.end, cells),
                    isVisible: true,
                    isAbsolute: false,
                    absoluteTop: rect.levelCoord,
                    marginTop: currentMarginTop, // claim the margin
                });
                currentMarginTop = 0;
            }
        }
        singleColPlacements.push(singlePlacements);
        multiColPlacements.push(multiPlacements);
        leftoverMargins.push(currentMarginTop);
    }
    return { singleColPlacements: singleColPlacements, multiColPlacements: multiColPlacements, leftoverMargins: leftoverMargins };
}
function groupRectsByEachCol(rects, colCnt) {
    var rectsByEachCol = [];
    for (var col = 0; col < colCnt; col += 1) {
        rectsByEachCol.push([]);
    }
    for (var _i = 0, rects_3 = rects; _i < rects_3.length; _i++) {
        var rect = rects_3[_i];
        for (var col = rect.span.start; col < rect.span.end; col += 1) {
            rectsByEachCol[col].push(rect);
        }
    }
    return rectsByEachCol;
}
function resliceSeg(seg, spanStart, spanEnd, cells) {
    if (seg.firstCol === spanStart && seg.lastCol === spanEnd - 1) {
        return seg;
    }
    var eventRange = seg.eventRange;
    var origRange = eventRange.range;
    var slicedRange = common.intersectRanges(origRange, {
        start: cells[spanStart].date,
        end: common.addDays(cells[spanEnd - 1].date, 1),
    });
    return tslib.__assign(tslib.__assign({}, seg), { firstCol: spanStart, lastCol: spanEnd - 1, eventRange: {
            def: eventRange.def,
            ui: tslib.__assign(tslib.__assign({}, eventRange.ui), { durationEditable: false }),
            instance: eventRange.instance,
            range: slicedRange,
        }, isStart: seg.isStart && slicedRange.start.valueOf() === origRange.start.valueOf(), isEnd: seg.isEnd && slicedRange.end.valueOf() === origRange.end.valueOf() });
}
var DayGridSegHierarchy = /** @class */ (function (_super) {
    tslib.__extends(DayGridSegHierarchy, _super);
    function DayGridSegHierarchy() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // config
        _this.hiddenConsumes = false;
        // allows us to keep hidden entries in the hierarchy so they take up space
        _this.forceHidden = {};
        return _this;
    }
    DayGridSegHierarchy.prototype.addSegs = function (segInputs) {
        var _this = this;
        var hiddenSegs = _super.prototype.addSegs.call(this, segInputs);
        var entriesByLevel = this.entriesByLevel;
        var excludeHidden = function (entry) { return !_this.forceHidden[common.buildEntryKey(entry)]; };
        // remove the forced-hidden segs
        for (var level = 0; level < entriesByLevel.length; level += 1) {
            entriesByLevel[level] = entriesByLevel[level].filter(excludeHidden);
        }
        return hiddenSegs;
    };
    DayGridSegHierarchy.prototype.handleInvalidInsertion = function (insertion, entry, hiddenEntries) {
        var _a = this, entriesByLevel = _a.entriesByLevel, forceHidden = _a.forceHidden;
        var touchingEntry = insertion.touchingEntry, touchingLevel = insertion.touchingLevel, touchingLateral = insertion.touchingLateral;
        if (this.hiddenConsumes && touchingEntry) {
            var touchingEntryId = common.buildEntryKey(touchingEntry);
            // if not already hidden
            if (!forceHidden[touchingEntryId]) {
                if (this.allowReslicing) {
                    var placeholderEntry = tslib.__assign(tslib.__assign({}, touchingEntry), { span: common.intersectSpans(touchingEntry.span, entry.span) });
                    var placeholderEntryId = common.buildEntryKey(placeholderEntry);
                    forceHidden[placeholderEntryId] = true;
                    entriesByLevel[touchingLevel][touchingLateral] = placeholderEntry; // replace touchingEntry with our placeholder
                    this.splitEntry(touchingEntry, entry, hiddenEntries); // split up the touchingEntry, reinsert it
                }
                else {
                    forceHidden[touchingEntryId] = true;
                    hiddenEntries.push(touchingEntry);
                }
            }
        }
        return _super.prototype.handleInvalidInsertion.call(this, insertion, entry, hiddenEntries);
    };
    return DayGridSegHierarchy;
}(common.SegHierarchy));

var TableRow = /** @class */ (function (_super) {
    tslib.__extends(TableRow, _super);
    function TableRow() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cellElRefs = new common.RefMap(); // the <td>
        _this.frameElRefs = new common.RefMap(); // the fc-daygrid-day-frame
        _this.fgElRefs = new common.RefMap(); // the fc-daygrid-day-events
        _this.segHarnessRefs = new common.RefMap(); // indexed by "instanceId:firstCol"
        _this.rootElRef = common.createRef();
        _this.state = {
            framePositions: null,
            maxContentHeight: null,
            eventInstanceHeights: {},
        };
        return _this;
    }
    TableRow.prototype.render = function () {
        var _this = this;
        var _a = this, props = _a.props, state = _a.state, context = _a.context;
        var options = context.options;
        var colCnt = props.cells.length;
        var businessHoursByCol = splitSegsByFirstCol(props.businessHourSegs, colCnt);
        var bgEventSegsByCol = splitSegsByFirstCol(props.bgEventSegs, colCnt);
        var highlightSegsByCol = splitSegsByFirstCol(this.getHighlightSegs(), colCnt);
        var mirrorSegsByCol = splitSegsByFirstCol(this.getMirrorSegs(), colCnt);
        var _b = computeFgSegPlacement(common.sortEventSegs(props.fgEventSegs, options.eventOrder), props.dayMaxEvents, props.dayMaxEventRows, options.eventOrderStrict, state.eventInstanceHeights, state.maxContentHeight, props.cells), singleColPlacements = _b.singleColPlacements, multiColPlacements = _b.multiColPlacements, moreCnts = _b.moreCnts, moreMarginTops = _b.moreMarginTops;
        var isForcedInvisible = // TODO: messy way to compute this
         (props.eventDrag && props.eventDrag.affectedInstances) ||
            (props.eventResize && props.eventResize.affectedInstances) ||
            {};
        return (common.createElement("tr", { ref: this.rootElRef },
            props.renderIntro && props.renderIntro(),
            props.cells.map(function (cell, col) {
                var normalFgNodes = _this.renderFgSegs(col, props.forPrint ? singleColPlacements[col] : multiColPlacements[col], props.todayRange, isForcedInvisible);
                var mirrorFgNodes = _this.renderFgSegs(col, buildMirrorPlacements(mirrorSegsByCol[col], multiColPlacements), props.todayRange, {}, Boolean(props.eventDrag), Boolean(props.eventResize), false);
                return (common.createElement(TableCell, { key: cell.key, elRef: _this.cellElRefs.createRef(cell.key), innerElRef: _this.frameElRefs.createRef(cell.key) /* FF <td> problem, but okay to use for left/right. TODO: rename prop */, dateProfile: props.dateProfile, date: cell.date, showDayNumber: props.showDayNumbers, showWeekNumber: props.showWeekNumbers && col === 0, forceDayTop: props.showWeekNumbers /* even displaying weeknum for row, not necessarily day */, todayRange: props.todayRange, eventSelection: props.eventSelection, eventDrag: props.eventDrag, eventResize: props.eventResize, extraHookProps: cell.extraHookProps, extraDataAttrs: cell.extraDataAttrs, extraClassNames: cell.extraClassNames, extraDateSpan: cell.extraDateSpan, moreCnt: moreCnts[col], moreMarginTop: moreMarginTops[col], singlePlacements: singleColPlacements[col], fgContentElRef: _this.fgElRefs.createRef(cell.key), fgContent: ( // Fragment scopes the keys
                    common.createElement(common.Fragment, null,
                        common.createElement(common.Fragment, null, normalFgNodes),
                        common.createElement(common.Fragment, null, mirrorFgNodes))), bgContent: ( // Fragment scopes the keys
                    common.createElement(common.Fragment, null,
                        _this.renderFillSegs(highlightSegsByCol[col], 'highlight'),
                        _this.renderFillSegs(businessHoursByCol[col], 'non-business'),
                        _this.renderFillSegs(bgEventSegsByCol[col], 'bg-event'))) }));
            })));
    };
    TableRow.prototype.componentDidMount = function () {
        this.updateSizing(true);
    };
    TableRow.prototype.componentDidUpdate = function (prevProps, prevState) {
        var currentProps = this.props;
        this.updateSizing(!common.isPropsEqual(prevProps, currentProps));
    };
    TableRow.prototype.getHighlightSegs = function () {
        var props = this.props;
        if (props.eventDrag && props.eventDrag.segs.length) { // messy check
            return props.eventDrag.segs;
        }
        if (props.eventResize && props.eventResize.segs.length) { // messy check
            return props.eventResize.segs;
        }
        return props.dateSelectionSegs;
    };
    TableRow.prototype.getMirrorSegs = function () {
        var props = this.props;
        if (props.eventResize && props.eventResize.segs.length) { // messy check
            return props.eventResize.segs;
        }
        return [];
    };
    TableRow.prototype.renderFgSegs = function (col, segPlacements, todayRange, isForcedInvisible, isDragging, isResizing, isDateSelecting) {
        var context = this.context;
        var eventSelection = this.props.eventSelection;
        var framePositions = this.state.framePositions;
        var defaultDisplayEventEnd = this.props.cells.length === 1; // colCnt === 1
        var isMirror = isDragging || isResizing || isDateSelecting;
        var nodes = [];
        if (framePositions) {
            for (var _i = 0, segPlacements_1 = segPlacements; _i < segPlacements_1.length; _i++) {
                var placement = segPlacements_1[_i];
                var seg = placement.seg;
                var instanceId = seg.eventRange.instance.instanceId;
                var key = instanceId + ':' + col;
                var isVisible = placement.isVisible && !isForcedInvisible[instanceId];
                var isAbsolute = placement.isAbsolute;
                var left = '';
                var right = '';
                if (isAbsolute) {
                    if (context.isRtl) {
                        right = 0;
                        left = framePositions.lefts[seg.lastCol] - framePositions.lefts[seg.firstCol];
                    }
                    else {
                        left = 0;
                        right = framePositions.rights[seg.firstCol] - framePositions.rights[seg.lastCol];
                    }
                }
                /*
                known bug: events that are force to be list-item but span multiple days still take up space in later columns
                todo: in print view, for multi-day events, don't display title within non-start/end segs
                */
                nodes.push(common.createElement("div", { className: 'fc-daygrid-event-harness' + (isAbsolute ? ' fc-daygrid-event-harness-abs' : ''), key: key, ref: isMirror ? null : this.segHarnessRefs.createRef(key), style: {
                        visibility: isVisible ? '' : 'hidden',
                        marginTop: isAbsolute ? '' : placement.marginTop,
                        top: isAbsolute ? placement.absoluteTop : '',
                        left: left,
                        right: right,
                    } }, hasListItemDisplay(seg) ? (common.createElement(TableListItemEvent, tslib.__assign({ seg: seg, isDragging: isDragging, isSelected: instanceId === eventSelection, defaultDisplayEventEnd: defaultDisplayEventEnd }, common.getSegMeta(seg, todayRange)))) : (common.createElement(TableBlockEvent, tslib.__assign({ seg: seg, isDragging: isDragging, isResizing: isResizing, isDateSelecting: isDateSelecting, isSelected: instanceId === eventSelection, defaultDisplayEventEnd: defaultDisplayEventEnd }, common.getSegMeta(seg, todayRange))))));
            }
        }
        return nodes;
    };
    TableRow.prototype.renderFillSegs = function (segs, fillType) {
        var isRtl = this.context.isRtl;
        var todayRange = this.props.todayRange;
        var framePositions = this.state.framePositions;
        var nodes = [];
        if (framePositions) {
            for (var _i = 0, segs_1 = segs; _i < segs_1.length; _i++) {
                var seg = segs_1[_i];
                var leftRightCss = isRtl ? {
                    right: 0,
                    left: framePositions.lefts[seg.lastCol] - framePositions.lefts[seg.firstCol],
                } : {
                    left: 0,
                    right: framePositions.rights[seg.firstCol] - framePositions.rights[seg.lastCol],
                };
                nodes.push(common.createElement("div", { key: common.buildEventRangeKey(seg.eventRange), className: "fc-daygrid-bg-harness", style: leftRightCss }, fillType === 'bg-event' ?
                    common.createElement(common.BgEvent, tslib.__assign({ seg: seg }, common.getSegMeta(seg, todayRange))) :
                    common.renderFill(fillType)));
            }
        }
        return common.createElement.apply(void 0, tslib.__spreadArray([common.Fragment, {}], nodes));
    };
    TableRow.prototype.updateSizing = function (isExternalSizingChange) {
        var _a = this, props = _a.props, frameElRefs = _a.frameElRefs;
        if (!props.forPrint &&
            props.clientWidth !== null // positioning ready?
        ) {
            if (isExternalSizingChange) {
                var frameEls = props.cells.map(function (cell) { return frameElRefs.currentMap[cell.key]; });
                if (frameEls.length) {
                    var originEl = this.rootElRef.current;
                    this.setState({
                        framePositions: new common.PositionCache(originEl, frameEls, true, // isHorizontal
                        false),
                    });
                }
            }
            var limitByContentHeight = props.dayMaxEvents === true || props.dayMaxEventRows === true;
            this.setState({
                eventInstanceHeights: this.queryEventInstanceHeights(),
                maxContentHeight: limitByContentHeight ? this.computeMaxContentHeight() : null,
            });
        }
    };
    TableRow.prototype.queryEventInstanceHeights = function () {
        var segElMap = this.segHarnessRefs.currentMap;
        var eventInstanceHeights = {};
        // get the max height amongst instance segs
        for (var key in segElMap) {
            var height = Math.round(segElMap[key].getBoundingClientRect().height);
            var instanceId = key.split(':')[0]; // deconstruct how renderFgSegs makes the key
            eventInstanceHeights[instanceId] = Math.max(eventInstanceHeights[instanceId] || 0, height);
        }
        return eventInstanceHeights;
    };
    TableRow.prototype.computeMaxContentHeight = function () {
        var firstKey = this.props.cells[0].key;
        var cellEl = this.cellElRefs.currentMap[firstKey];
        var fcContainerEl = this.fgElRefs.currentMap[firstKey];
        return cellEl.getBoundingClientRect().bottom - fcContainerEl.getBoundingClientRect().top;
    };
    TableRow.prototype.getCellEls = function () {
        var elMap = this.cellElRefs.currentMap;
        return this.props.cells.map(function (cell) { return elMap[cell.key]; });
    };
    return TableRow;
}(common.DateComponent));
TableRow.addStateEquality({
    eventInstanceHeights: common.isPropsEqual,
});
function buildMirrorPlacements(mirrorSegs, colPlacements) {
    if (!mirrorSegs.length) {
        return [];
    }
    var topsByInstanceId = buildAbsoluteTopHash(colPlacements); // TODO: cache this at first render?
    return mirrorSegs.map(function (seg) { return ({
        seg: seg,
        isVisible: true,
        isAbsolute: true,
        absoluteTop: topsByInstanceId[seg.eventRange.instance.instanceId],
        marginTop: 0,
    }); });
}
function buildAbsoluteTopHash(colPlacements) {
    var topsByInstanceId = {};
    for (var _i = 0, colPlacements_1 = colPlacements; _i < colPlacements_1.length; _i++) {
        var placements = colPlacements_1[_i];
        for (var _a = 0, placements_1 = placements; _a < placements_1.length; _a++) {
            var placement = placements_1[_a];
            topsByInstanceId[placement.seg.eventRange.instance.instanceId] = placement.absoluteTop;
        }
    }
    return topsByInstanceId;
}

var Table = /** @class */ (function (_super) {
    tslib.__extends(Table, _super);
    function Table() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.splitBusinessHourSegs = common.memoize(splitSegsByRow);
        _this.splitBgEventSegs = common.memoize(splitSegsByRow);
        _this.splitFgEventSegs = common.memoize(splitSegsByRow);
        _this.splitDateSelectionSegs = common.memoize(splitSegsByRow);
        _this.splitEventDrag = common.memoize(splitInteractionByRow);
        _this.splitEventResize = common.memoize(splitInteractionByRow);
        _this.rowRefs = new common.RefMap();
        _this.handleRootEl = function (rootEl) {
            _this.rootEl = rootEl;
            if (rootEl) {
                _this.context.registerInteractiveComponent(_this, {
                    el: rootEl,
                    isHitComboAllowed: _this.props.isHitComboAllowed,
                });
            }
            else {
                _this.context.unregisterInteractiveComponent(_this);
            }
        };
        return _this;
    }
    Table.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var dateProfile = props.dateProfile, dayMaxEventRows = props.dayMaxEventRows, dayMaxEvents = props.dayMaxEvents, expandRows = props.expandRows;
        var rowCnt = props.cells.length;
        var businessHourSegsByRow = this.splitBusinessHourSegs(props.businessHourSegs, rowCnt);
        var bgEventSegsByRow = this.splitBgEventSegs(props.bgEventSegs, rowCnt);
        var fgEventSegsByRow = this.splitFgEventSegs(props.fgEventSegs, rowCnt);
        var dateSelectionSegsByRow = this.splitDateSelectionSegs(props.dateSelectionSegs, rowCnt);
        var eventDragByRow = this.splitEventDrag(props.eventDrag, rowCnt);
        var eventResizeByRow = this.splitEventResize(props.eventResize, rowCnt);
        var limitViaBalanced = dayMaxEvents === true || dayMaxEventRows === true;
        // if rows can't expand to fill fixed height, can't do balanced-height event limit
        // TODO: best place to normalize these options?
        if (limitViaBalanced && !expandRows) {
            limitViaBalanced = false;
            dayMaxEventRows = null;
            dayMaxEvents = null;
        }
        var classNames = [
            'fc-daygrid-body',
            limitViaBalanced ? 'fc-daygrid-body-balanced' : 'fc-daygrid-body-unbalanced',
            expandRows ? '' : 'fc-daygrid-body-natural', // will height of one row depend on the others?
        ];
        return (common.createElement("div", { className: classNames.join(' '), ref: this.handleRootEl, style: {
                // these props are important to give this wrapper correct dimensions for interactions
                // TODO: if we set it here, can we avoid giving to inner tables?
                width: props.clientWidth,
                minWidth: props.tableMinWidth,
            } },
            common.createElement(common.NowTimer, { unit: "day" }, function (nowDate, todayRange) { return (common.createElement(common.Fragment, null,
                common.createElement("table", { className: "fc-scrollgrid-sync-table", style: {
                        width: props.clientWidth,
                        minWidth: props.tableMinWidth,
                        height: expandRows ? props.clientHeight : '',
                    } },
                    props.colGroupNode,
                    common.createElement("tbody", null, props.cells.map(function (cells, row) { return (common.createElement(TableRow, { ref: _this.rowRefs.createRef(row), key: cells.length
                            ? cells[0].date.toISOString() /* best? or put key on cell? or use diff formatter? */
                            : row // in case there are no cells (like when resource view is loading)
                        , showDayNumbers: rowCnt > 1, showWeekNumbers: props.showWeekNumbers, todayRange: todayRange, dateProfile: dateProfile, cells: cells, renderIntro: props.renderRowIntro, businessHourSegs: businessHourSegsByRow[row], eventSelection: props.eventSelection, bgEventSegs: bgEventSegsByRow[row].filter(isSegAllDay) /* hack */, fgEventSegs: fgEventSegsByRow[row], dateSelectionSegs: dateSelectionSegsByRow[row], eventDrag: eventDragByRow[row], eventResize: eventResizeByRow[row], dayMaxEvents: dayMaxEvents, dayMaxEventRows: dayMaxEventRows, clientWidth: props.clientWidth, clientHeight: props.clientHeight, forPrint: props.forPrint })); }))))); })));
    };
    // Hit System
    // ----------------------------------------------------------------------------------------------------
    Table.prototype.prepareHits = function () {
        this.rowPositions = new common.PositionCache(this.rootEl, this.rowRefs.collect().map(function (rowObj) { return rowObj.getCellEls()[0]; }), // first cell el in each row. TODO: not optimal
        false, true);
        this.colPositions = new common.PositionCache(this.rootEl, this.rowRefs.currentMap[0].getCellEls(), // cell els in first row
        true, // horizontal
        false);
    };
    Table.prototype.queryHit = function (positionLeft, positionTop) {
        var _a = this, colPositions = _a.colPositions, rowPositions = _a.rowPositions;
        var col = colPositions.leftToIndex(positionLeft);
        var row = rowPositions.topToIndex(positionTop);
        if (row != null && col != null) {
            var cell = this.props.cells[row][col];
            return {
                dateProfile: this.props.dateProfile,
                dateSpan: tslib.__assign({ range: this.getCellRange(row, col), allDay: true }, cell.extraDateSpan),
                dayEl: this.getCellEl(row, col),
                rect: {
                    left: colPositions.lefts[col],
                    right: colPositions.rights[col],
                    top: rowPositions.tops[row],
                    bottom: rowPositions.bottoms[row],
                },
                layer: 0,
            };
        }
        return null;
    };
    Table.prototype.getCellEl = function (row, col) {
        return this.rowRefs.currentMap[row].getCellEls()[col]; // TODO: not optimal
    };
    Table.prototype.getCellRange = function (row, col) {
        var start = this.props.cells[row][col].date;
        var end = common.addDays(start, 1);
        return { start: start, end: end };
    };
    return Table;
}(common.DateComponent));
function isSegAllDay(seg) {
    return seg.eventRange.def.allDay;
}

var DayTableSlicer = /** @class */ (function (_super) {
    tslib.__extends(DayTableSlicer, _super);
    function DayTableSlicer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.forceDayIfListItem = true;
        return _this;
    }
    DayTableSlicer.prototype.sliceRange = function (dateRange, dayTableModel) {
        return dayTableModel.sliceRange(dateRange);
    };
    return DayTableSlicer;
}(common.Slicer));

var DayTable = /** @class */ (function (_super) {
    tslib.__extends(DayTable, _super);
    function DayTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.slicer = new DayTableSlicer();
        _this.tableRef = common.createRef();
        return _this;
    }
    DayTable.prototype.render = function () {
        var _a = this, props = _a.props, context = _a.context;
        return (common.createElement(Table, tslib.__assign({ ref: this.tableRef }, this.slicer.sliceProps(props, props.dateProfile, props.nextDayThreshold, context, props.dayTableModel), { dateProfile: props.dateProfile, cells: props.dayTableModel.cells, colGroupNode: props.colGroupNode, tableMinWidth: props.tableMinWidth, renderRowIntro: props.renderRowIntro, dayMaxEvents: props.dayMaxEvents, dayMaxEventRows: props.dayMaxEventRows, showWeekNumbers: props.showWeekNumbers, expandRows: props.expandRows, headerAlignElRef: props.headerAlignElRef, clientWidth: props.clientWidth, clientHeight: props.clientHeight, forPrint: props.forPrint })));
    };
    return DayTable;
}(common.DateComponent));

var DayTableView = /** @class */ (function (_super) {
    tslib.__extends(DayTableView, _super);
    function DayTableView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.buildDayTableModel = common.memoize(buildDayTableModel);
        _this.headerRef = common.createRef();
        _this.tableRef = common.createRef();
        return _this;
    }
    DayTableView.prototype.render = function () {
        var _this = this;
        var _a = this.context, options = _a.options, dateProfileGenerator = _a.dateProfileGenerator;
        var props = this.props;
        var dayTableModel = this.buildDayTableModel(props.dateProfile, dateProfileGenerator);
        var headerContent = options.dayHeaders && (common.createElement(common.DayHeader, { ref: this.headerRef, dateProfile: props.dateProfile, dates: dayTableModel.headerDates, datesRepDistinctDays: dayTableModel.rowCnt === 1 }));
        var bodyContent = function (contentArg) { return (common.createElement(DayTable, { ref: _this.tableRef, dateProfile: props.dateProfile, dayTableModel: dayTableModel, businessHours: props.businessHours, dateSelection: props.dateSelection, eventStore: props.eventStore, eventUiBases: props.eventUiBases, eventSelection: props.eventSelection, eventDrag: props.eventDrag, eventResize: props.eventResize, nextDayThreshold: options.nextDayThreshold, colGroupNode: contentArg.tableColGroupNode, tableMinWidth: contentArg.tableMinWidth, dayMaxEvents: options.dayMaxEvents, dayMaxEventRows: options.dayMaxEventRows, showWeekNumbers: options.weekNumbers, expandRows: !props.isHeightAuto, headerAlignElRef: _this.headerElRef, clientWidth: contentArg.clientWidth, clientHeight: contentArg.clientHeight, forPrint: props.forPrint })); };
        return options.dayMinWidth
            ? this.renderHScrollLayout(headerContent, bodyContent, dayTableModel.colCnt, options.dayMinWidth)
            : this.renderSimpleLayout(headerContent, bodyContent);
    };
    return DayTableView;
}(TableView));
function buildDayTableModel(dateProfile, dateProfileGenerator) {
    var daySeries = new common.DaySeriesModel(dateProfile.renderRange, dateProfileGenerator);
    return new common.DayTableModel(daySeries, /year|month|week/.test(dateProfile.currentRangeUnit));
}

var TableDateProfileGenerator = /** @class */ (function (_super) {
    tslib.__extends(TableDateProfileGenerator, _super);
    function TableDateProfileGenerator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // Computes the date range that will be rendered.
    TableDateProfileGenerator.prototype.buildRenderRange = function (currentRange, currentRangeUnit, isRangeAllDay) {
        var dateEnv = this.props.dateEnv;
        var renderRange = _super.prototype.buildRenderRange.call(this, currentRange, currentRangeUnit, isRangeAllDay);
        var start = renderRange.start;
        var end = renderRange.end;
        var endOfWeek;
        // year and month views should be aligned with weeks. this is already done for week
        if (/^(year|month)$/.test(currentRangeUnit)) {
            start = dateEnv.startOfWeek(start);
            // make end-of-week if not already
            endOfWeek = dateEnv.startOfWeek(end);
            if (endOfWeek.valueOf() !== end.valueOf()) {
                end = common.addWeeks(endOfWeek, 1);
            }
        }
        // ensure 6 weeks
        if (this.props.monthMode &&
            this.props.fixedWeekCount) {
            var rowCnt = Math.ceil(// could be partial weeks due to hiddenDays
            common.diffWeeks(start, end));
            end = common.addWeeks(end, 6 - rowCnt);
        }
        return { start: start, end: end };
    };
    return TableDateProfileGenerator;
}(common.DateProfileGenerator));

var main = common.createPlugin({
    initialView: 'dayGridMonth',
    views: {
        dayGrid: {
            component: DayTableView,
            dateProfileGeneratorClass: TableDateProfileGenerator,
        },
        dayGridDay: {
            type: 'dayGrid',
            duration: { days: 1 },
        },
        dayGridWeek: {
            type: 'dayGrid',
            duration: { weeks: 1 },
        },
        dayGridMonth: {
            type: 'dayGrid',
            duration: { months: 1 },
            monthMode: true,
            fixedWeekCount: true,
        },
    },
});

exports.DayGridView = DayTableView;
exports.DayTable = DayTable;
exports.DayTableSlicer = DayTableSlicer;
exports.Table = Table;
exports.TableView = TableView;
exports.buildDayTableModel = buildDayTableModel;
exports.default = main;

},{"@fullcalendar/common":3,"tslib":782}],9:[function(require,module,exports){
/*!
FullCalendar v5.9.0
Docs & License: https://fullcalendar.io/
(c) 2021 Adam Shaw
*/
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var common = require('@fullcalendar/common');
var tslib = require('tslib');

common.config.touchMouseIgnoreWait = 500;
var ignoreMouseDepth = 0;
var listenerCnt = 0;
var isWindowTouchMoveCancelled = false;
/*
Uses a "pointer" abstraction, which monitors UI events for both mouse and touch.
Tracks when the pointer "drags" on a certain element, meaning down+move+up.

Also, tracks if there was touch-scrolling.
Also, can prevent touch-scrolling from happening.
Also, can fire pointermove events when scrolling happens underneath, even when no real pointer movement.

emits:
- pointerdown
- pointermove
- pointerup
*/
var PointerDragging = /** @class */ (function () {
    function PointerDragging(containerEl) {
        var _this = this;
        this.subjectEl = null;
        // options that can be directly assigned by caller
        this.selector = ''; // will cause subjectEl in all emitted events to be this element
        this.handleSelector = '';
        this.shouldIgnoreMove = false;
        this.shouldWatchScroll = true; // for simulating pointermove on scroll
        // internal states
        this.isDragging = false;
        this.isTouchDragging = false;
        this.wasTouchScroll = false;
        // Mouse
        // ----------------------------------------------------------------------------------------------------
        this.handleMouseDown = function (ev) {
            if (!_this.shouldIgnoreMouse() &&
                isPrimaryMouseButton(ev) &&
                _this.tryStart(ev)) {
                var pev = _this.createEventFromMouse(ev, true);
                _this.emitter.trigger('pointerdown', pev);
                _this.initScrollWatch(pev);
                if (!_this.shouldIgnoreMove) {
                    document.addEventListener('mousemove', _this.handleMouseMove);
                }
                document.addEventListener('mouseup', _this.handleMouseUp);
            }
        };
        this.handleMouseMove = function (ev) {
            var pev = _this.createEventFromMouse(ev);
            _this.recordCoords(pev);
            _this.emitter.trigger('pointermove', pev);
        };
        this.handleMouseUp = function (ev) {
            document.removeEventListener('mousemove', _this.handleMouseMove);
            document.removeEventListener('mouseup', _this.handleMouseUp);
            _this.emitter.trigger('pointerup', _this.createEventFromMouse(ev));
            _this.cleanup(); // call last so that pointerup has access to props
        };
        // Touch
        // ----------------------------------------------------------------------------------------------------
        this.handleTouchStart = function (ev) {
            if (_this.tryStart(ev)) {
                _this.isTouchDragging = true;
                var pev = _this.createEventFromTouch(ev, true);
                _this.emitter.trigger('pointerdown', pev);
                _this.initScrollWatch(pev);
                // unlike mouse, need to attach to target, not document
                // https://stackoverflow.com/a/45760014
                var targetEl = ev.target;
                if (!_this.shouldIgnoreMove) {
                    targetEl.addEventListener('touchmove', _this.handleTouchMove);
                }
                targetEl.addEventListener('touchend', _this.handleTouchEnd);
                targetEl.addEventListener('touchcancel', _this.handleTouchEnd); // treat it as a touch end
                // attach a handler to get called when ANY scroll action happens on the page.
                // this was impossible to do with normal on/off because 'scroll' doesn't bubble.
                // http://stackoverflow.com/a/32954565/96342
                window.addEventListener('scroll', _this.handleTouchScroll, true);
            }
        };
        this.handleTouchMove = function (ev) {
            var pev = _this.createEventFromTouch(ev);
            _this.recordCoords(pev);
            _this.emitter.trigger('pointermove', pev);
        };
        this.handleTouchEnd = function (ev) {
            if (_this.isDragging) { // done to guard against touchend followed by touchcancel
                var targetEl = ev.target;
                targetEl.removeEventListener('touchmove', _this.handleTouchMove);
                targetEl.removeEventListener('touchend', _this.handleTouchEnd);
                targetEl.removeEventListener('touchcancel', _this.handleTouchEnd);
                window.removeEventListener('scroll', _this.handleTouchScroll, true); // useCaptured=true
                _this.emitter.trigger('pointerup', _this.createEventFromTouch(ev));
                _this.cleanup(); // call last so that pointerup has access to props
                _this.isTouchDragging = false;
                startIgnoringMouse();
            }
        };
        this.handleTouchScroll = function () {
            _this.wasTouchScroll = true;
        };
        this.handleScroll = function (ev) {
            if (!_this.shouldIgnoreMove) {
                var pageX = (window.pageXOffset - _this.prevScrollX) + _this.prevPageX;
                var pageY = (window.pageYOffset - _this.prevScrollY) + _this.prevPageY;
                _this.emitter.trigger('pointermove', {
                    origEvent: ev,
                    isTouch: _this.isTouchDragging,
                    subjectEl: _this.subjectEl,
                    pageX: pageX,
                    pageY: pageY,
                    deltaX: pageX - _this.origPageX,
                    deltaY: pageY - _this.origPageY,
                });
            }
        };
        this.containerEl = containerEl;
        this.emitter = new common.Emitter();
        containerEl.addEventListener('mousedown', this.handleMouseDown);
        containerEl.addEventListener('touchstart', this.handleTouchStart, { passive: true });
        listenerCreated();
    }
    PointerDragging.prototype.destroy = function () {
        this.containerEl.removeEventListener('mousedown', this.handleMouseDown);
        this.containerEl.removeEventListener('touchstart', this.handleTouchStart, { passive: true });
        listenerDestroyed();
    };
    PointerDragging.prototype.tryStart = function (ev) {
        var subjectEl = this.querySubjectEl(ev);
        var downEl = ev.target;
        if (subjectEl &&
            (!this.handleSelector || common.elementClosest(downEl, this.handleSelector))) {
            this.subjectEl = subjectEl;
            this.isDragging = true; // do this first so cancelTouchScroll will work
            this.wasTouchScroll = false;
            return true;
        }
        return false;
    };
    PointerDragging.prototype.cleanup = function () {
        isWindowTouchMoveCancelled = false;
        this.isDragging = false;
        this.subjectEl = null;
        // keep wasTouchScroll around for later access
        this.destroyScrollWatch();
    };
    PointerDragging.prototype.querySubjectEl = function (ev) {
        if (this.selector) {
            return common.elementClosest(ev.target, this.selector);
        }
        return this.containerEl;
    };
    PointerDragging.prototype.shouldIgnoreMouse = function () {
        return ignoreMouseDepth || this.isTouchDragging;
    };
    // can be called by user of this class, to cancel touch-based scrolling for the current drag
    PointerDragging.prototype.cancelTouchScroll = function () {
        if (this.isDragging) {
            isWindowTouchMoveCancelled = true;
        }
    };
    // Scrolling that simulates pointermoves
    // ----------------------------------------------------------------------------------------------------
    PointerDragging.prototype.initScrollWatch = function (ev) {
        if (this.shouldWatchScroll) {
            this.recordCoords(ev);
            window.addEventListener('scroll', this.handleScroll, true); // useCapture=true
        }
    };
    PointerDragging.prototype.recordCoords = function (ev) {
        if (this.shouldWatchScroll) {
            this.prevPageX = ev.pageX;
            this.prevPageY = ev.pageY;
            this.prevScrollX = window.pageXOffset;
            this.prevScrollY = window.pageYOffset;
        }
    };
    PointerDragging.prototype.destroyScrollWatch = function () {
        if (this.shouldWatchScroll) {
            window.removeEventListener('scroll', this.handleScroll, true); // useCaptured=true
        }
    };
    // Event Normalization
    // ----------------------------------------------------------------------------------------------------
    PointerDragging.prototype.createEventFromMouse = function (ev, isFirst) {
        var deltaX = 0;
        var deltaY = 0;
        // TODO: repeat code
        if (isFirst) {
            this.origPageX = ev.pageX;
            this.origPageY = ev.pageY;
        }
        else {
            deltaX = ev.pageX - this.origPageX;
            deltaY = ev.pageY - this.origPageY;
        }
        return {
            origEvent: ev,
            isTouch: false,
            subjectEl: this.subjectEl,
            pageX: ev.pageX,
            pageY: ev.pageY,
            deltaX: deltaX,
            deltaY: deltaY,
        };
    };
    PointerDragging.prototype.createEventFromTouch = function (ev, isFirst) {
        var touches = ev.touches;
        var pageX;
        var pageY;
        var deltaX = 0;
        var deltaY = 0;
        // if touch coords available, prefer,
        // because FF would give bad ev.pageX ev.pageY
        if (touches && touches.length) {
            pageX = touches[0].pageX;
            pageY = touches[0].pageY;
        }
        else {
            pageX = ev.pageX;
            pageY = ev.pageY;
        }
        // TODO: repeat code
        if (isFirst) {
            this.origPageX = pageX;
            this.origPageY = pageY;
        }
        else {
            deltaX = pageX - this.origPageX;
            deltaY = pageY - this.origPageY;
        }
        return {
            origEvent: ev,
            isTouch: true,
            subjectEl: this.subjectEl,
            pageX: pageX,
            pageY: pageY,
            deltaX: deltaX,
            deltaY: deltaY,
        };
    };
    return PointerDragging;
}());
// Returns a boolean whether this was a left mouse click and no ctrl key (which means right click on Mac)
function isPrimaryMouseButton(ev) {
    return ev.button === 0 && !ev.ctrlKey;
}
// Ignoring fake mouse events generated by touch
// ----------------------------------------------------------------------------------------------------
function startIgnoringMouse() {
    ignoreMouseDepth += 1;
    setTimeout(function () {
        ignoreMouseDepth -= 1;
    }, common.config.touchMouseIgnoreWait);
}
// We want to attach touchmove as early as possible for Safari
// ----------------------------------------------------------------------------------------------------
function listenerCreated() {
    listenerCnt += 1;
    if (listenerCnt === 1) {
        window.addEventListener('touchmove', onWindowTouchMove, { passive: false });
    }
}
function listenerDestroyed() {
    listenerCnt -= 1;
    if (!listenerCnt) {
        window.removeEventListener('touchmove', onWindowTouchMove, { passive: false });
    }
}
function onWindowTouchMove(ev) {
    if (isWindowTouchMoveCancelled) {
        ev.preventDefault();
    }
}

/*
An effect in which an element follows the movement of a pointer across the screen.
The moving element is a clone of some other element.
Must call start + handleMove + stop.
*/
var ElementMirror = /** @class */ (function () {
    function ElementMirror() {
        this.isVisible = false; // must be explicitly enabled
        this.sourceEl = null;
        this.mirrorEl = null;
        this.sourceElRect = null; // screen coords relative to viewport
        // options that can be set directly by caller
        this.parentNode = document.body; // HIGHLY SUGGESTED to set this to sidestep ShadowDOM issues
        this.zIndex = 9999;
        this.revertDuration = 0;
    }
    ElementMirror.prototype.start = function (sourceEl, pageX, pageY) {
        this.sourceEl = sourceEl;
        this.sourceElRect = this.sourceEl.getBoundingClientRect();
        this.origScreenX = pageX - window.pageXOffset;
        this.origScreenY = pageY - window.pageYOffset;
        this.deltaX = 0;
        this.deltaY = 0;
        this.updateElPosition();
    };
    ElementMirror.prototype.handleMove = function (pageX, pageY) {
        this.deltaX = (pageX - window.pageXOffset) - this.origScreenX;
        this.deltaY = (pageY - window.pageYOffset) - this.origScreenY;
        this.updateElPosition();
    };
    // can be called before start
    ElementMirror.prototype.setIsVisible = function (bool) {
        if (bool) {
            if (!this.isVisible) {
                if (this.mirrorEl) {
                    this.mirrorEl.style.display = '';
                }
                this.isVisible = bool; // needs to happen before updateElPosition
                this.updateElPosition(); // because was not updating the position while invisible
            }
        }
        else if (this.isVisible) {
            if (this.mirrorEl) {
                this.mirrorEl.style.display = 'none';
            }
            this.isVisible = bool;
        }
    };
    // always async
    ElementMirror.prototype.stop = function (needsRevertAnimation, callback) {
        var _this = this;
        var done = function () {
            _this.cleanup();
            callback();
        };
        if (needsRevertAnimation &&
            this.mirrorEl &&
            this.isVisible &&
            this.revertDuration && // if 0, transition won't work
            (this.deltaX || this.deltaY) // if same coords, transition won't work
        ) {
            this.doRevertAnimation(done, this.revertDuration);
        }
        else {
            setTimeout(done, 0);
        }
    };
    ElementMirror.prototype.doRevertAnimation = function (callback, revertDuration) {
        var mirrorEl = this.mirrorEl;
        var finalSourceElRect = this.sourceEl.getBoundingClientRect(); // because autoscrolling might have happened
        mirrorEl.style.transition =
            'top ' + revertDuration + 'ms,' +
                'left ' + revertDuration + 'ms';
        common.applyStyle(mirrorEl, {
            left: finalSourceElRect.left,
            top: finalSourceElRect.top,
        });
        common.whenTransitionDone(mirrorEl, function () {
            mirrorEl.style.transition = '';
            callback();
        });
    };
    ElementMirror.prototype.cleanup = function () {
        if (this.mirrorEl) {
            common.removeElement(this.mirrorEl);
            this.mirrorEl = null;
        }
        this.sourceEl = null;
    };
    ElementMirror.prototype.updateElPosition = function () {
        if (this.sourceEl && this.isVisible) {
            common.applyStyle(this.getMirrorEl(), {
                left: this.sourceElRect.left + this.deltaX,
                top: this.sourceElRect.top + this.deltaY,
            });
        }
    };
    ElementMirror.prototype.getMirrorEl = function () {
        var sourceElRect = this.sourceElRect;
        var mirrorEl = this.mirrorEl;
        if (!mirrorEl) {
            mirrorEl = this.mirrorEl = this.sourceEl.cloneNode(true); // cloneChildren=true
            // we don't want long taps or any mouse interaction causing selection/menus.
            // would use preventSelection(), but that prevents selectstart, causing problems.
            mirrorEl.classList.add('fc-unselectable');
            mirrorEl.classList.add('fc-event-dragging');
            common.applyStyle(mirrorEl, {
                position: 'fixed',
                zIndex: this.zIndex,
                visibility: '',
                boxSizing: 'border-box',
                width: sourceElRect.right - sourceElRect.left,
                height: sourceElRect.bottom - sourceElRect.top,
                right: 'auto',
                bottom: 'auto',
                margin: 0,
            });
            this.parentNode.appendChild(mirrorEl);
        }
        return mirrorEl;
    };
    return ElementMirror;
}());

/*
Is a cache for a given element's scroll information (all the info that ScrollController stores)
in addition the "client rectangle" of the element.. the area within the scrollbars.

The cache can be in one of two modes:
- doesListening:false - ignores when the container is scrolled by someone else
- doesListening:true - watch for scrolling and update the cache
*/
var ScrollGeomCache = /** @class */ (function (_super) {
    tslib.__extends(ScrollGeomCache, _super);
    function ScrollGeomCache(scrollController, doesListening) {
        var _this = _super.call(this) || this;
        _this.handleScroll = function () {
            _this.scrollTop = _this.scrollController.getScrollTop();
            _this.scrollLeft = _this.scrollController.getScrollLeft();
            _this.handleScrollChange();
        };
        _this.scrollController = scrollController;
        _this.doesListening = doesListening;
        _this.scrollTop = _this.origScrollTop = scrollController.getScrollTop();
        _this.scrollLeft = _this.origScrollLeft = scrollController.getScrollLeft();
        _this.scrollWidth = scrollController.getScrollWidth();
        _this.scrollHeight = scrollController.getScrollHeight();
        _this.clientWidth = scrollController.getClientWidth();
        _this.clientHeight = scrollController.getClientHeight();
        _this.clientRect = _this.computeClientRect(); // do last in case it needs cached values
        if (_this.doesListening) {
            _this.getEventTarget().addEventListener('scroll', _this.handleScroll);
        }
        return _this;
    }
    ScrollGeomCache.prototype.destroy = function () {
        if (this.doesListening) {
            this.getEventTarget().removeEventListener('scroll', this.handleScroll);
        }
    };
    ScrollGeomCache.prototype.getScrollTop = function () {
        return this.scrollTop;
    };
    ScrollGeomCache.prototype.getScrollLeft = function () {
        return this.scrollLeft;
    };
    ScrollGeomCache.prototype.setScrollTop = function (top) {
        this.scrollController.setScrollTop(top);
        if (!this.doesListening) {
            // we are not relying on the element to normalize out-of-bounds scroll values
            // so we need to sanitize ourselves
            this.scrollTop = Math.max(Math.min(top, this.getMaxScrollTop()), 0);
            this.handleScrollChange();
        }
    };
    ScrollGeomCache.prototype.setScrollLeft = function (top) {
        this.scrollController.setScrollLeft(top);
        if (!this.doesListening) {
            // we are not relying on the element to normalize out-of-bounds scroll values
            // so we need to sanitize ourselves
            this.scrollLeft = Math.max(Math.min(top, this.getMaxScrollLeft()), 0);
            this.handleScrollChange();
        }
    };
    ScrollGeomCache.prototype.getClientWidth = function () {
        return this.clientWidth;
    };
    ScrollGeomCache.prototype.getClientHeight = function () {
        return this.clientHeight;
    };
    ScrollGeomCache.prototype.getScrollWidth = function () {
        return this.scrollWidth;
    };
    ScrollGeomCache.prototype.getScrollHeight = function () {
        return this.scrollHeight;
    };
    ScrollGeomCache.prototype.handleScrollChange = function () {
    };
    return ScrollGeomCache;
}(common.ScrollController));

var ElementScrollGeomCache = /** @class */ (function (_super) {
    tslib.__extends(ElementScrollGeomCache, _super);
    function ElementScrollGeomCache(el, doesListening) {
        return _super.call(this, new common.ElementScrollController(el), doesListening) || this;
    }
    ElementScrollGeomCache.prototype.getEventTarget = function () {
        return this.scrollController.el;
    };
    ElementScrollGeomCache.prototype.computeClientRect = function () {
        return common.computeInnerRect(this.scrollController.el);
    };
    return ElementScrollGeomCache;
}(ScrollGeomCache));

var WindowScrollGeomCache = /** @class */ (function (_super) {
    tslib.__extends(WindowScrollGeomCache, _super);
    function WindowScrollGeomCache(doesListening) {
        return _super.call(this, new common.WindowScrollController(), doesListening) || this;
    }
    WindowScrollGeomCache.prototype.getEventTarget = function () {
        return window;
    };
    WindowScrollGeomCache.prototype.computeClientRect = function () {
        return {
            left: this.scrollLeft,
            right: this.scrollLeft + this.clientWidth,
            top: this.scrollTop,
            bottom: this.scrollTop + this.clientHeight,
        };
    };
    // the window is the only scroll object that changes it's rectangle relative
    // to the document's topleft as it scrolls
    WindowScrollGeomCache.prototype.handleScrollChange = function () {
        this.clientRect = this.computeClientRect();
    };
    return WindowScrollGeomCache;
}(ScrollGeomCache));

// If available we are using native "performance" API instead of "Date"
// Read more about it on MDN:
// https://developer.mozilla.org/en-US/docs/Web/API/Performance
var getTime = typeof performance === 'function' ? performance.now : Date.now;
/*
For a pointer interaction, automatically scrolls certain scroll containers when the pointer
approaches the edge.

The caller must call start + handleMove + stop.
*/
var AutoScroller = /** @class */ (function () {
    function AutoScroller() {
        var _this = this;
        // options that can be set by caller
        this.isEnabled = true;
        this.scrollQuery = [window, '.fc-scroller'];
        this.edgeThreshold = 50; // pixels
        this.maxVelocity = 300; // pixels per second
        // internal state
        this.pointerScreenX = null;
        this.pointerScreenY = null;
        this.isAnimating = false;
        this.scrollCaches = null;
        // protect against the initial pointerdown being too close to an edge and starting the scroll
        this.everMovedUp = false;
        this.everMovedDown = false;
        this.everMovedLeft = false;
        this.everMovedRight = false;
        this.animate = function () {
            if (_this.isAnimating) { // wasn't cancelled between animation calls
                var edge = _this.computeBestEdge(_this.pointerScreenX + window.pageXOffset, _this.pointerScreenY + window.pageYOffset);
                if (edge) {
                    var now = getTime();
                    _this.handleSide(edge, (now - _this.msSinceRequest) / 1000);
                    _this.requestAnimation(now);
                }
                else {
                    _this.isAnimating = false; // will stop animation
                }
            }
        };
    }
    AutoScroller.prototype.start = function (pageX, pageY, scrollStartEl) {
        if (this.isEnabled) {
            this.scrollCaches = this.buildCaches(scrollStartEl);
            this.pointerScreenX = null;
            this.pointerScreenY = null;
            this.everMovedUp = false;
            this.everMovedDown = false;
            this.everMovedLeft = false;
            this.everMovedRight = false;
            this.handleMove(pageX, pageY);
        }
    };
    AutoScroller.prototype.handleMove = function (pageX, pageY) {
        if (this.isEnabled) {
            var pointerScreenX = pageX - window.pageXOffset;
            var pointerScreenY = pageY - window.pageYOffset;
            var yDelta = this.pointerScreenY === null ? 0 : pointerScreenY - this.pointerScreenY;
            var xDelta = this.pointerScreenX === null ? 0 : pointerScreenX - this.pointerScreenX;
            if (yDelta < 0) {
                this.everMovedUp = true;
            }
            else if (yDelta > 0) {
                this.everMovedDown = true;
            }
            if (xDelta < 0) {
                this.everMovedLeft = true;
            }
            else if (xDelta > 0) {
                this.everMovedRight = true;
            }
            this.pointerScreenX = pointerScreenX;
            this.pointerScreenY = pointerScreenY;
            if (!this.isAnimating) {
                this.isAnimating = true;
                this.requestAnimation(getTime());
            }
        }
    };
    AutoScroller.prototype.stop = function () {
        if (this.isEnabled) {
            this.isAnimating = false; // will stop animation
            for (var _i = 0, _a = this.scrollCaches; _i < _a.length; _i++) {
                var scrollCache = _a[_i];
                scrollCache.destroy();
            }
            this.scrollCaches = null;
        }
    };
    AutoScroller.prototype.requestAnimation = function (now) {
        this.msSinceRequest = now;
        requestAnimationFrame(this.animate);
    };
    AutoScroller.prototype.handleSide = function (edge, seconds) {
        var scrollCache = edge.scrollCache;
        var edgeThreshold = this.edgeThreshold;
        var invDistance = edgeThreshold - edge.distance;
        var velocity = // the closer to the edge, the faster we scroll
         ((invDistance * invDistance) / (edgeThreshold * edgeThreshold)) * // quadratic
            this.maxVelocity * seconds;
        var sign = 1;
        switch (edge.name) {
            case 'left':
                sign = -1;
            // falls through
            case 'right':
                scrollCache.setScrollLeft(scrollCache.getScrollLeft() + velocity * sign);
                break;
            case 'top':
                sign = -1;
            // falls through
            case 'bottom':
                scrollCache.setScrollTop(scrollCache.getScrollTop() + velocity * sign);
                break;
        }
    };
    // left/top are relative to document topleft
    AutoScroller.prototype.computeBestEdge = function (left, top) {
        var edgeThreshold = this.edgeThreshold;
        var bestSide = null;
        for (var _i = 0, _a = this.scrollCaches; _i < _a.length; _i++) {
            var scrollCache = _a[_i];
            var rect = scrollCache.clientRect;
            var leftDist = left - rect.left;
            var rightDist = rect.right - left;
            var topDist = top - rect.top;
            var bottomDist = rect.bottom - top;
            // completely within the rect?
            if (leftDist >= 0 && rightDist >= 0 && topDist >= 0 && bottomDist >= 0) {
                if (topDist <= edgeThreshold && this.everMovedUp && scrollCache.canScrollUp() &&
                    (!bestSide || bestSide.distance > topDist)) {
                    bestSide = { scrollCache: scrollCache, name: 'top', distance: topDist };
                }
                if (bottomDist <= edgeThreshold && this.everMovedDown && scrollCache.canScrollDown() &&
                    (!bestSide || bestSide.distance > bottomDist)) {
                    bestSide = { scrollCache: scrollCache, name: 'bottom', distance: bottomDist };
                }
                if (leftDist <= edgeThreshold && this.everMovedLeft && scrollCache.canScrollLeft() &&
                    (!bestSide || bestSide.distance > leftDist)) {
                    bestSide = { scrollCache: scrollCache, name: 'left', distance: leftDist };
                }
                if (rightDist <= edgeThreshold && this.everMovedRight && scrollCache.canScrollRight() &&
                    (!bestSide || bestSide.distance > rightDist)) {
                    bestSide = { scrollCache: scrollCache, name: 'right', distance: rightDist };
                }
            }
        }
        return bestSide;
    };
    AutoScroller.prototype.buildCaches = function (scrollStartEl) {
        return this.queryScrollEls(scrollStartEl).map(function (el) {
            if (el === window) {
                return new WindowScrollGeomCache(false); // false = don't listen to user-generated scrolls
            }
            return new ElementScrollGeomCache(el, false); // false = don't listen to user-generated scrolls
        });
    };
    AutoScroller.prototype.queryScrollEls = function (scrollStartEl) {
        var els = [];
        for (var _i = 0, _a = this.scrollQuery; _i < _a.length; _i++) {
            var query = _a[_i];
            if (typeof query === 'object') {
                els.push(query);
            }
            else {
                els.push.apply(els, Array.prototype.slice.call(common.getElRoot(scrollStartEl).querySelectorAll(query)));
            }
        }
        return els;
    };
    return AutoScroller;
}());

/*
Monitors dragging on an element. Has a number of high-level features:
- minimum distance required before dragging
- minimum wait time ("delay") before dragging
- a mirror element that follows the pointer
*/
var FeaturefulElementDragging = /** @class */ (function (_super) {
    tslib.__extends(FeaturefulElementDragging, _super);
    function FeaturefulElementDragging(containerEl, selector) {
        var _this = _super.call(this, containerEl) || this;
        _this.containerEl = containerEl;
        // options that can be directly set by caller
        // the caller can also set the PointerDragging's options as well
        _this.delay = null;
        _this.minDistance = 0;
        _this.touchScrollAllowed = true; // prevents drag from starting and blocks scrolling during drag
        _this.mirrorNeedsRevert = false;
        _this.isInteracting = false; // is the user validly moving the pointer? lasts until pointerup
        _this.isDragging = false; // is it INTENTFULLY dragging? lasts until after revert animation
        _this.isDelayEnded = false;
        _this.isDistanceSurpassed = false;
        _this.delayTimeoutId = null;
        _this.onPointerDown = function (ev) {
            if (!_this.isDragging) { // so new drag doesn't happen while revert animation is going
                _this.isInteracting = true;
                _this.isDelayEnded = false;
                _this.isDistanceSurpassed = false;
                common.preventSelection(document.body);
                common.preventContextMenu(document.body);
                // prevent links from being visited if there's an eventual drag.
                // also prevents selection in older browsers (maybe?).
                // not necessary for touch, besides, browser would complain about passiveness.
                if (!ev.isTouch) {
                    ev.origEvent.preventDefault();
                }
                _this.emitter.trigger('pointerdown', ev);
                if (_this.isInteracting && // not destroyed via pointerdown handler
                    !_this.pointer.shouldIgnoreMove) {
                    // actions related to initiating dragstart+dragmove+dragend...
                    _this.mirror.setIsVisible(false); // reset. caller must set-visible
                    _this.mirror.start(ev.subjectEl, ev.pageX, ev.pageY); // must happen on first pointer down
                    _this.startDelay(ev);
                    if (!_this.minDistance) {
                        _this.handleDistanceSurpassed(ev);
                    }
                }
            }
        };
        _this.onPointerMove = function (ev) {
            if (_this.isInteracting) {
                _this.emitter.trigger('pointermove', ev);
                if (!_this.isDistanceSurpassed) {
                    var minDistance = _this.minDistance;
                    var distanceSq = void 0; // current distance from the origin, squared
                    var deltaX = ev.deltaX, deltaY = ev.deltaY;
                    distanceSq = deltaX * deltaX + deltaY * deltaY;
                    if (distanceSq >= minDistance * minDistance) { // use pythagorean theorem
                        _this.handleDistanceSurpassed(ev);
                    }
                }
                if (_this.isDragging) {
                    // a real pointer move? (not one simulated by scrolling)
                    if (ev.origEvent.type !== 'scroll') {
                        _this.mirror.handleMove(ev.pageX, ev.pageY);
                        _this.autoScroller.handleMove(ev.pageX, ev.pageY);
                    }
                    _this.emitter.trigger('dragmove', ev);
                }
            }
        };
        _this.onPointerUp = function (ev) {
            if (_this.isInteracting) {
                _this.isInteracting = false;
                common.allowSelection(document.body);
                common.allowContextMenu(document.body);
                _this.emitter.trigger('pointerup', ev); // can potentially set mirrorNeedsRevert
                if (_this.isDragging) {
                    _this.autoScroller.stop();
                    _this.tryStopDrag(ev); // which will stop the mirror
                }
                if (_this.delayTimeoutId) {
                    clearTimeout(_this.delayTimeoutId);
                    _this.delayTimeoutId = null;
                }
            }
        };
        var pointer = _this.pointer = new PointerDragging(containerEl);
        pointer.emitter.on('pointerdown', _this.onPointerDown);
        pointer.emitter.on('pointermove', _this.onPointerMove);
        pointer.emitter.on('pointerup', _this.onPointerUp);
        if (selector) {
            pointer.selector = selector;
        }
        _this.mirror = new ElementMirror();
        _this.autoScroller = new AutoScroller();
        return _this;
    }
    FeaturefulElementDragging.prototype.destroy = function () {
        this.pointer.destroy();
        // HACK: simulate a pointer-up to end the current drag
        // TODO: fire 'dragend' directly and stop interaction. discourage use of pointerup event (b/c might not fire)
        this.onPointerUp({});
    };
    FeaturefulElementDragging.prototype.startDelay = function (ev) {
        var _this = this;
        if (typeof this.delay === 'number') {
            this.delayTimeoutId = setTimeout(function () {
                _this.delayTimeoutId = null;
                _this.handleDelayEnd(ev);
            }, this.delay); // not assignable to number!
        }
        else {
            this.handleDelayEnd(ev);
        }
    };
    FeaturefulElementDragging.prototype.handleDelayEnd = function (ev) {
        this.isDelayEnded = true;
        this.tryStartDrag(ev);
    };
    FeaturefulElementDragging.prototype.handleDistanceSurpassed = function (ev) {
        this.isDistanceSurpassed = true;
        this.tryStartDrag(ev);
    };
    FeaturefulElementDragging.prototype.tryStartDrag = function (ev) {
        if (this.isDelayEnded && this.isDistanceSurpassed) {
            if (!this.pointer.wasTouchScroll || this.touchScrollAllowed) {
                this.isDragging = true;
                this.mirrorNeedsRevert = false;
                this.autoScroller.start(ev.pageX, ev.pageY, this.containerEl);
                this.emitter.trigger('dragstart', ev);
                if (this.touchScrollAllowed === false) {
                    this.pointer.cancelTouchScroll();
                }
            }
        }
    };
    FeaturefulElementDragging.prototype.tryStopDrag = function (ev) {
        // .stop() is ALWAYS asynchronous, which we NEED because we want all pointerup events
        // that come from the document to fire beforehand. much more convenient this way.
        this.mirror.stop(this.mirrorNeedsRevert, this.stopDrag.bind(this, ev));
    };
    FeaturefulElementDragging.prototype.stopDrag = function (ev) {
        this.isDragging = false;
        this.emitter.trigger('dragend', ev);
    };
    // fill in the implementations...
    FeaturefulElementDragging.prototype.setIgnoreMove = function (bool) {
        this.pointer.shouldIgnoreMove = bool;
    };
    FeaturefulElementDragging.prototype.setMirrorIsVisible = function (bool) {
        this.mirror.setIsVisible(bool);
    };
    FeaturefulElementDragging.prototype.setMirrorNeedsRevert = function (bool) {
        this.mirrorNeedsRevert = bool;
    };
    FeaturefulElementDragging.prototype.setAutoScrollEnabled = function (bool) {
        this.autoScroller.isEnabled = bool;
    };
    return FeaturefulElementDragging;
}(common.ElementDragging));

/*
When this class is instantiated, it records the offset of an element (relative to the document topleft),
and continues to monitor scrolling, updating the cached coordinates if it needs to.
Does not access the DOM after instantiation, so highly performant.

Also keeps track of all scrolling/overflow:hidden containers that are parents of the given element
and an determine if a given point is inside the combined clipping rectangle.
*/
var OffsetTracker = /** @class */ (function () {
    function OffsetTracker(el) {
        this.origRect = common.computeRect(el);
        // will work fine for divs that have overflow:hidden
        this.scrollCaches = common.getClippingParents(el).map(function (scrollEl) { return new ElementScrollGeomCache(scrollEl, true); });
    }
    OffsetTracker.prototype.destroy = function () {
        for (var _i = 0, _a = this.scrollCaches; _i < _a.length; _i++) {
            var scrollCache = _a[_i];
            scrollCache.destroy();
        }
    };
    OffsetTracker.prototype.computeLeft = function () {
        var left = this.origRect.left;
        for (var _i = 0, _a = this.scrollCaches; _i < _a.length; _i++) {
            var scrollCache = _a[_i];
            left += scrollCache.origScrollLeft - scrollCache.getScrollLeft();
        }
        return left;
    };
    OffsetTracker.prototype.computeTop = function () {
        var top = this.origRect.top;
        for (var _i = 0, _a = this.scrollCaches; _i < _a.length; _i++) {
            var scrollCache = _a[_i];
            top += scrollCache.origScrollTop - scrollCache.getScrollTop();
        }
        return top;
    };
    OffsetTracker.prototype.isWithinClipping = function (pageX, pageY) {
        var point = { left: pageX, top: pageY };
        for (var _i = 0, _a = this.scrollCaches; _i < _a.length; _i++) {
            var scrollCache = _a[_i];
            if (!isIgnoredClipping(scrollCache.getEventTarget()) &&
                !common.pointInsideRect(point, scrollCache.clientRect)) {
                return false;
            }
        }
        return true;
    };
    return OffsetTracker;
}());
// certain clipping containers should never constrain interactions, like <html> and <body>
// https://github.com/fullcalendar/fullcalendar/issues/3615
function isIgnoredClipping(node) {
    var tagName = node.tagName;
    return tagName === 'HTML' || tagName === 'BODY';
}

/*
Tracks movement over multiple droppable areas (aka "hits")
that exist in one or more DateComponents.
Relies on an existing draggable.

emits:
- pointerdown
- dragstart
- hitchange - fires initially, even if not over a hit
- pointerup
- (hitchange - again, to null, if ended over a hit)
- dragend
*/
var HitDragging = /** @class */ (function () {
    function HitDragging(dragging, droppableStore) {
        var _this = this;
        // options that can be set by caller
        this.useSubjectCenter = false;
        this.requireInitial = true; // if doesn't start out on a hit, won't emit any events
        this.initialHit = null;
        this.movingHit = null;
        this.finalHit = null; // won't ever be populated if shouldIgnoreMove
        this.handlePointerDown = function (ev) {
            var dragging = _this.dragging;
            _this.initialHit = null;
            _this.movingHit = null;
            _this.finalHit = null;
            _this.prepareHits();
            _this.processFirstCoord(ev);
            if (_this.initialHit || !_this.requireInitial) {
                dragging.setIgnoreMove(false);
                // TODO: fire this before computing processFirstCoord, so listeners can cancel. this gets fired by almost every handler :(
                _this.emitter.trigger('pointerdown', ev);
            }
            else {
                dragging.setIgnoreMove(true);
            }
        };
        this.handleDragStart = function (ev) {
            _this.emitter.trigger('dragstart', ev);
            _this.handleMove(ev, true); // force = fire even if initially null
        };
        this.handleDragMove = function (ev) {
            _this.emitter.trigger('dragmove', ev);
            _this.handleMove(ev);
        };
        this.handlePointerUp = function (ev) {
            _this.releaseHits();
            _this.emitter.trigger('pointerup', ev);
        };
        this.handleDragEnd = function (ev) {
            if (_this.movingHit) {
                _this.emitter.trigger('hitupdate', null, true, ev);
            }
            _this.finalHit = _this.movingHit;
            _this.movingHit = null;
            _this.emitter.trigger('dragend', ev);
        };
        this.droppableStore = droppableStore;
        dragging.emitter.on('pointerdown', this.handlePointerDown);
        dragging.emitter.on('dragstart', this.handleDragStart);
        dragging.emitter.on('dragmove', this.handleDragMove);
        dragging.emitter.on('pointerup', this.handlePointerUp);
        dragging.emitter.on('dragend', this.handleDragEnd);
        this.dragging = dragging;
        this.emitter = new common.Emitter();
    }
    // sets initialHit
    // sets coordAdjust
    HitDragging.prototype.processFirstCoord = function (ev) {
        var origPoint = { left: ev.pageX, top: ev.pageY };
        var adjustedPoint = origPoint;
        var subjectEl = ev.subjectEl;
        var subjectRect;
        if (subjectEl instanceof HTMLElement) { // i.e. not a Document/ShadowRoot
            subjectRect = common.computeRect(subjectEl);
            adjustedPoint = common.constrainPoint(adjustedPoint, subjectRect);
        }
        var initialHit = this.initialHit = this.queryHitForOffset(adjustedPoint.left, adjustedPoint.top);
        if (initialHit) {
            if (this.useSubjectCenter && subjectRect) {
                var slicedSubjectRect = common.intersectRects(subjectRect, initialHit.rect);
                if (slicedSubjectRect) {
                    adjustedPoint = common.getRectCenter(slicedSubjectRect);
                }
            }
            this.coordAdjust = common.diffPoints(adjustedPoint, origPoint);
        }
        else {
            this.coordAdjust = { left: 0, top: 0 };
        }
    };
    HitDragging.prototype.handleMove = function (ev, forceHandle) {
        var hit = this.queryHitForOffset(ev.pageX + this.coordAdjust.left, ev.pageY + this.coordAdjust.top);
        if (forceHandle || !isHitsEqual(this.movingHit, hit)) {
            this.movingHit = hit;
            this.emitter.trigger('hitupdate', hit, false, ev);
        }
    };
    HitDragging.prototype.prepareHits = function () {
        this.offsetTrackers = common.mapHash(this.droppableStore, function (interactionSettings) {
            interactionSettings.component.prepareHits();
            return new OffsetTracker(interactionSettings.el);
        });
    };
    HitDragging.prototype.releaseHits = function () {
        var offsetTrackers = this.offsetTrackers;
        for (var id in offsetTrackers) {
            offsetTrackers[id].destroy();
        }
        this.offsetTrackers = {};
    };
    HitDragging.prototype.queryHitForOffset = function (offsetLeft, offsetTop) {
        var _a = this, droppableStore = _a.droppableStore, offsetTrackers = _a.offsetTrackers;
        var bestHit = null;
        for (var id in droppableStore) {
            var component = droppableStore[id].component;
            var offsetTracker = offsetTrackers[id];
            if (offsetTracker && // wasn't destroyed mid-drag
                offsetTracker.isWithinClipping(offsetLeft, offsetTop)) {
                var originLeft = offsetTracker.computeLeft();
                var originTop = offsetTracker.computeTop();
                var positionLeft = offsetLeft - originLeft;
                var positionTop = offsetTop - originTop;
                var origRect = offsetTracker.origRect;
                var width = origRect.right - origRect.left;
                var height = origRect.bottom - origRect.top;
                if (
                // must be within the element's bounds
                positionLeft >= 0 && positionLeft < width &&
                    positionTop >= 0 && positionTop < height) {
                    var hit = component.queryHit(positionLeft, positionTop, width, height);
                    if (hit && (
                    // make sure the hit is within activeRange, meaning it's not a dead cell
                    common.rangeContainsRange(hit.dateProfile.activeRange, hit.dateSpan.range)) &&
                        (!bestHit || hit.layer > bestHit.layer)) {
                        hit.componentId = id;
                        hit.context = component.context;
                        // TODO: better way to re-orient rectangle
                        hit.rect.left += originLeft;
                        hit.rect.right += originLeft;
                        hit.rect.top += originTop;
                        hit.rect.bottom += originTop;
                        bestHit = hit;
                    }
                }
            }
        }
        return bestHit;
    };
    return HitDragging;
}());
function isHitsEqual(hit0, hit1) {
    if (!hit0 && !hit1) {
        return true;
    }
    if (Boolean(hit0) !== Boolean(hit1)) {
        return false;
    }
    return common.isDateSpansEqual(hit0.dateSpan, hit1.dateSpan);
}

function buildDatePointApiWithContext(dateSpan, context) {
    var props = {};
    for (var _i = 0, _a = context.pluginHooks.datePointTransforms; _i < _a.length; _i++) {
        var transform = _a[_i];
        tslib.__assign(props, transform(dateSpan, context));
    }
    tslib.__assign(props, buildDatePointApi(dateSpan, context.dateEnv));
    return props;
}
function buildDatePointApi(span, dateEnv) {
    return {
        date: dateEnv.toDate(span.range.start),
        dateStr: dateEnv.formatIso(span.range.start, { omitTime: span.allDay }),
        allDay: span.allDay,
    };
}

/*
Monitors when the user clicks on a specific date/time of a component.
A pointerdown+pointerup on the same "hit" constitutes a click.
*/
var DateClicking = /** @class */ (function (_super) {
    tslib.__extends(DateClicking, _super);
    function DateClicking(settings) {
        var _this = _super.call(this, settings) || this;
        _this.handlePointerDown = function (pev) {
            var dragging = _this.dragging;
            var downEl = pev.origEvent.target;
            // do this in pointerdown (not dragend) because DOM might be mutated by the time dragend is fired
            dragging.setIgnoreMove(!_this.component.isValidDateDownEl(downEl));
        };
        // won't even fire if moving was ignored
        _this.handleDragEnd = function (ev) {
            var component = _this.component;
            var pointer = _this.dragging.pointer;
            if (!pointer.wasTouchScroll) {
                var _a = _this.hitDragging, initialHit = _a.initialHit, finalHit = _a.finalHit;
                if (initialHit && finalHit && isHitsEqual(initialHit, finalHit)) {
                    var context = component.context;
                    var arg = tslib.__assign(tslib.__assign({}, buildDatePointApiWithContext(initialHit.dateSpan, context)), { dayEl: initialHit.dayEl, jsEvent: ev.origEvent, view: context.viewApi || context.calendarApi.view });
                    context.emitter.trigger('dateClick', arg);
                }
            }
        };
        // we DO want to watch pointer moves because otherwise finalHit won't get populated
        _this.dragging = new FeaturefulElementDragging(settings.el);
        _this.dragging.autoScroller.isEnabled = false;
        var hitDragging = _this.hitDragging = new HitDragging(_this.dragging, common.interactionSettingsToStore(settings));
        hitDragging.emitter.on('pointerdown', _this.handlePointerDown);
        hitDragging.emitter.on('dragend', _this.handleDragEnd);
        return _this;
    }
    DateClicking.prototype.destroy = function () {
        this.dragging.destroy();
    };
    return DateClicking;
}(common.Interaction));

/*
Tracks when the user selects a portion of time of a component,
constituted by a drag over date cells, with a possible delay at the beginning of the drag.
*/
var DateSelecting = /** @class */ (function (_super) {
    tslib.__extends(DateSelecting, _super);
    function DateSelecting(settings) {
        var _this = _super.call(this, settings) || this;
        _this.dragSelection = null;
        _this.handlePointerDown = function (ev) {
            var _a = _this, component = _a.component, dragging = _a.dragging;
            var options = component.context.options;
            var canSelect = options.selectable &&
                component.isValidDateDownEl(ev.origEvent.target);
            // don't bother to watch expensive moves if component won't do selection
            dragging.setIgnoreMove(!canSelect);
            // if touch, require user to hold down
            dragging.delay = ev.isTouch ? getComponentTouchDelay$1(component) : null;
        };
        _this.handleDragStart = function (ev) {
            _this.component.context.calendarApi.unselect(ev); // unselect previous selections
        };
        _this.handleHitUpdate = function (hit, isFinal) {
            var context = _this.component.context;
            var dragSelection = null;
            var isInvalid = false;
            if (hit) {
                var initialHit = _this.hitDragging.initialHit;
                var disallowed = hit.componentId === initialHit.componentId
                    && _this.isHitComboAllowed
                    && !_this.isHitComboAllowed(initialHit, hit);
                if (!disallowed) {
                    dragSelection = joinHitsIntoSelection(initialHit, hit, context.pluginHooks.dateSelectionTransformers);
                }
                if (!dragSelection || !common.isDateSelectionValid(dragSelection, hit.dateProfile, context)) {
                    isInvalid = true;
                    dragSelection = null;
                }
            }
            if (dragSelection) {
                context.dispatch({ type: 'SELECT_DATES', selection: dragSelection });
            }
            else if (!isFinal) { // only unselect if moved away while dragging
                context.dispatch({ type: 'UNSELECT_DATES' });
            }
            if (!isInvalid) {
                common.enableCursor();
            }
            else {
                common.disableCursor();
            }
            if (!isFinal) {
                _this.dragSelection = dragSelection; // only clear if moved away from all hits while dragging
            }
        };
        _this.handlePointerUp = function (pev) {
            if (_this.dragSelection) {
                // selection is already rendered, so just need to report selection
                common.triggerDateSelect(_this.dragSelection, pev, _this.component.context);
                _this.dragSelection = null;
            }
        };
        var component = settings.component;
        var options = component.context.options;
        var dragging = _this.dragging = new FeaturefulElementDragging(settings.el);
        dragging.touchScrollAllowed = false;
        dragging.minDistance = options.selectMinDistance || 0;
        dragging.autoScroller.isEnabled = options.dragScroll;
        var hitDragging = _this.hitDragging = new HitDragging(_this.dragging, common.interactionSettingsToStore(settings));
        hitDragging.emitter.on('pointerdown', _this.handlePointerDown);
        hitDragging.emitter.on('dragstart', _this.handleDragStart);
        hitDragging.emitter.on('hitupdate', _this.handleHitUpdate);
        hitDragging.emitter.on('pointerup', _this.handlePointerUp);
        return _this;
    }
    DateSelecting.prototype.destroy = function () {
        this.dragging.destroy();
    };
    return DateSelecting;
}(common.Interaction));
function getComponentTouchDelay$1(component) {
    var options = component.context.options;
    var delay = options.selectLongPressDelay;
    if (delay == null) {
        delay = options.longPressDelay;
    }
    return delay;
}
function joinHitsIntoSelection(hit0, hit1, dateSelectionTransformers) {
    var dateSpan0 = hit0.dateSpan;
    var dateSpan1 = hit1.dateSpan;
    var ms = [
        dateSpan0.range.start,
        dateSpan0.range.end,
        dateSpan1.range.start,
        dateSpan1.range.end,
    ];
    ms.sort(common.compareNumbers);
    var props = {};
    for (var _i = 0, dateSelectionTransformers_1 = dateSelectionTransformers; _i < dateSelectionTransformers_1.length; _i++) {
        var transformer = dateSelectionTransformers_1[_i];
        var res = transformer(hit0, hit1);
        if (res === false) {
            return null;
        }
        if (res) {
            tslib.__assign(props, res);
        }
    }
    props.range = { start: ms[0], end: ms[3] };
    props.allDay = dateSpan0.allDay;
    return props;
}

var EventDragging = /** @class */ (function (_super) {
    tslib.__extends(EventDragging, _super);
    function EventDragging(settings) {
        var _this = _super.call(this, settings) || this;
        // internal state
        _this.subjectEl = null;
        _this.subjectSeg = null; // the seg being selected/dragged
        _this.isDragging = false;
        _this.eventRange = null;
        _this.relevantEvents = null; // the events being dragged
        _this.receivingContext = null;
        _this.validMutation = null;
        _this.mutatedRelevantEvents = null;
        _this.handlePointerDown = function (ev) {
            var origTarget = ev.origEvent.target;
            var _a = _this, component = _a.component, dragging = _a.dragging;
            var mirror = dragging.mirror;
            var options = component.context.options;
            var initialContext = component.context;
            _this.subjectEl = ev.subjectEl;
            var subjectSeg = _this.subjectSeg = common.getElSeg(ev.subjectEl);
            var eventRange = _this.eventRange = subjectSeg.eventRange;
            var eventInstanceId = eventRange.instance.instanceId;
            _this.relevantEvents = common.getRelevantEvents(initialContext.getCurrentData().eventStore, eventInstanceId);
            dragging.minDistance = ev.isTouch ? 0 : options.eventDragMinDistance;
            dragging.delay =
                // only do a touch delay if touch and this event hasn't been selected yet
                (ev.isTouch && eventInstanceId !== component.props.eventSelection) ?
                    getComponentTouchDelay(component) :
                    null;
            if (options.fixedMirrorParent) {
                mirror.parentNode = options.fixedMirrorParent;
            }
            else {
                mirror.parentNode = common.elementClosest(origTarget, '.fc');
            }
            mirror.revertDuration = options.dragRevertDuration;
            var isValid = component.isValidSegDownEl(origTarget) &&
                !common.elementClosest(origTarget, '.fc-event-resizer'); // NOT on a resizer
            dragging.setIgnoreMove(!isValid);
            // disable dragging for elements that are resizable (ie, selectable)
            // but are not draggable
            _this.isDragging = isValid &&
                ev.subjectEl.classList.contains('fc-event-draggable');
        };
        _this.handleDragStart = function (ev) {
            var initialContext = _this.component.context;
            var eventRange = _this.eventRange;
            var eventInstanceId = eventRange.instance.instanceId;
            if (ev.isTouch) {
                // need to select a different event?
                if (eventInstanceId !== _this.component.props.eventSelection) {
                    initialContext.dispatch({ type: 'SELECT_EVENT', eventInstanceId: eventInstanceId });
                }
            }
            else {
                // if now using mouse, but was previous touch interaction, clear selected event
                initialContext.dispatch({ type: 'UNSELECT_EVENT' });
            }
            if (_this.isDragging) {
                initialContext.calendarApi.unselect(ev); // unselect *date* selection
                initialContext.emitter.trigger('eventDragStart', {
                    el: _this.subjectEl,
                    event: new common.EventApi(initialContext, eventRange.def, eventRange.instance),
                    jsEvent: ev.origEvent,
                    view: initialContext.viewApi,
                });
            }
        };
        _this.handleHitUpdate = function (hit, isFinal) {
            if (!_this.isDragging) {
                return;
            }
            var relevantEvents = _this.relevantEvents;
            var initialHit = _this.hitDragging.initialHit;
            var initialContext = _this.component.context;
            // states based on new hit
            var receivingContext = null;
            var mutation = null;
            var mutatedRelevantEvents = null;
            var isInvalid = false;
            var interaction = {
                affectedEvents: relevantEvents,
                mutatedEvents: common.createEmptyEventStore(),
                isEvent: true,
            };
            if (hit) {
                receivingContext = hit.context;
                var receivingOptions = receivingContext.options;
                if (initialContext === receivingContext ||
                    (receivingOptions.editable && receivingOptions.droppable)) {
                    mutation = computeEventMutation(initialHit, hit, receivingContext.getCurrentData().pluginHooks.eventDragMutationMassagers);
                    if (mutation) {
                        mutatedRelevantEvents = common.applyMutationToEventStore(relevantEvents, receivingContext.getCurrentData().eventUiBases, mutation, receivingContext);
                        interaction.mutatedEvents = mutatedRelevantEvents;
                        if (!common.isInteractionValid(interaction, hit.dateProfile, receivingContext)) {
                            isInvalid = true;
                            mutation = null;
                            mutatedRelevantEvents = null;
                            interaction.mutatedEvents = common.createEmptyEventStore();
                        }
                    }
                }
                else {
                    receivingContext = null;
                }
            }
            _this.displayDrag(receivingContext, interaction);
            if (!isInvalid) {
                common.enableCursor();
            }
            else {
                common.disableCursor();
            }
            if (!isFinal) {
                if (initialContext === receivingContext && // TODO: write test for this
                    isHitsEqual(initialHit, hit)) {
                    mutation = null;
                }
                _this.dragging.setMirrorNeedsRevert(!mutation);
                // render the mirror if no already-rendered mirror
                // TODO: wish we could somehow wait for dispatch to guarantee render
                _this.dragging.setMirrorIsVisible(!hit || !common.getElRoot(_this.subjectEl).querySelector('.fc-event-mirror'));
                // assign states based on new hit
                _this.receivingContext = receivingContext;
                _this.validMutation = mutation;
                _this.mutatedRelevantEvents = mutatedRelevantEvents;
            }
        };
        _this.handlePointerUp = function () {
            if (!_this.isDragging) {
                _this.cleanup(); // because handleDragEnd won't fire
            }
        };
        _this.handleDragEnd = function (ev) {
            if (_this.isDragging) {
                var initialContext_1 = _this.component.context;
                var initialView = initialContext_1.viewApi;
                var _a = _this, receivingContext_1 = _a.receivingContext, validMutation = _a.validMutation;
                var eventDef = _this.eventRange.def;
                var eventInstance = _this.eventRange.instance;
                var eventApi = new common.EventApi(initialContext_1, eventDef, eventInstance);
                var relevantEvents_1 = _this.relevantEvents;
                var mutatedRelevantEvents_1 = _this.mutatedRelevantEvents;
                var finalHit = _this.hitDragging.finalHit;
                _this.clearDrag(); // must happen after revert animation
                initialContext_1.emitter.trigger('eventDragStop', {
                    el: _this.subjectEl,
                    event: eventApi,
                    jsEvent: ev.origEvent,
                    view: initialView,
                });
                if (validMutation) {
                    // dropped within same calendar
                    if (receivingContext_1 === initialContext_1) {
                        var updatedEventApi = new common.EventApi(initialContext_1, mutatedRelevantEvents_1.defs[eventDef.defId], eventInstance ? mutatedRelevantEvents_1.instances[eventInstance.instanceId] : null);
                        initialContext_1.dispatch({
                            type: 'MERGE_EVENTS',
                            eventStore: mutatedRelevantEvents_1,
                        });
                        var eventChangeArg = {
                            oldEvent: eventApi,
                            event: updatedEventApi,
                            relatedEvents: common.buildEventApis(mutatedRelevantEvents_1, initialContext_1, eventInstance),
                            revert: function () {
                                initialContext_1.dispatch({
                                    type: 'MERGE_EVENTS',
                                    eventStore: relevantEvents_1, // the pre-change data
                                });
                            },
                        };
                        var transformed = {};
                        for (var _i = 0, _b = initialContext_1.getCurrentData().pluginHooks.eventDropTransformers; _i < _b.length; _i++) {
                            var transformer = _b[_i];
                            tslib.__assign(transformed, transformer(validMutation, initialContext_1));
                        }
                        initialContext_1.emitter.trigger('eventDrop', tslib.__assign(tslib.__assign(tslib.__assign({}, eventChangeArg), transformed), { el: ev.subjectEl, delta: validMutation.datesDelta, jsEvent: ev.origEvent, view: initialView }));
                        initialContext_1.emitter.trigger('eventChange', eventChangeArg);
                        // dropped in different calendar
                    }
                    else if (receivingContext_1) {
                        var eventRemoveArg = {
                            event: eventApi,
                            relatedEvents: common.buildEventApis(relevantEvents_1, initialContext_1, eventInstance),
                            revert: function () {
                                initialContext_1.dispatch({
                                    type: 'MERGE_EVENTS',
                                    eventStore: relevantEvents_1,
                                });
                            },
                        };
                        initialContext_1.emitter.trigger('eventLeave', tslib.__assign(tslib.__assign({}, eventRemoveArg), { draggedEl: ev.subjectEl, view: initialView }));
                        initialContext_1.dispatch({
                            type: 'REMOVE_EVENTS',
                            eventStore: relevantEvents_1,
                        });
                        initialContext_1.emitter.trigger('eventRemove', eventRemoveArg);
                        var addedEventDef = mutatedRelevantEvents_1.defs[eventDef.defId];
                        var addedEventInstance = mutatedRelevantEvents_1.instances[eventInstance.instanceId];
                        var addedEventApi = new common.EventApi(receivingContext_1, addedEventDef, addedEventInstance);
                        receivingContext_1.dispatch({
                            type: 'MERGE_EVENTS',
                            eventStore: mutatedRelevantEvents_1,
                        });
                        var eventAddArg = {
                            event: addedEventApi,
                            relatedEvents: common.buildEventApis(mutatedRelevantEvents_1, receivingContext_1, addedEventInstance),
                            revert: function () {
                                receivingContext_1.dispatch({
                                    type: 'REMOVE_EVENTS',
                                    eventStore: mutatedRelevantEvents_1,
                                });
                            },
                        };
                        receivingContext_1.emitter.trigger('eventAdd', eventAddArg);
                        if (ev.isTouch) {
                            receivingContext_1.dispatch({
                                type: 'SELECT_EVENT',
                                eventInstanceId: eventInstance.instanceId,
                            });
                        }
                        receivingContext_1.emitter.trigger('drop', tslib.__assign(tslib.__assign({}, buildDatePointApiWithContext(finalHit.dateSpan, receivingContext_1)), { draggedEl: ev.subjectEl, jsEvent: ev.origEvent, view: finalHit.context.viewApi }));
                        receivingContext_1.emitter.trigger('eventReceive', tslib.__assign(tslib.__assign({}, eventAddArg), { draggedEl: ev.subjectEl, view: finalHit.context.viewApi }));
                    }
                }
                else {
                    initialContext_1.emitter.trigger('_noEventDrop');
                }
            }
            _this.cleanup();
        };
        var component = _this.component;
        var options = component.context.options;
        var dragging = _this.dragging = new FeaturefulElementDragging(settings.el);
        dragging.pointer.selector = EventDragging.SELECTOR;
        dragging.touchScrollAllowed = false;
        dragging.autoScroller.isEnabled = options.dragScroll;
        var hitDragging = _this.hitDragging = new HitDragging(_this.dragging, common.interactionSettingsStore);
        hitDragging.useSubjectCenter = settings.useEventCenter;
        hitDragging.emitter.on('pointerdown', _this.handlePointerDown);
        hitDragging.emitter.on('dragstart', _this.handleDragStart);
        hitDragging.emitter.on('hitupdate', _this.handleHitUpdate);
        hitDragging.emitter.on('pointerup', _this.handlePointerUp);
        hitDragging.emitter.on('dragend', _this.handleDragEnd);
        return _this;
    }
    EventDragging.prototype.destroy = function () {
        this.dragging.destroy();
    };
    // render a drag state on the next receivingCalendar
    EventDragging.prototype.displayDrag = function (nextContext, state) {
        var initialContext = this.component.context;
        var prevContext = this.receivingContext;
        // does the previous calendar need to be cleared?
        if (prevContext && prevContext !== nextContext) {
            // does the initial calendar need to be cleared?
            // if so, don't clear all the way. we still need to to hide the affectedEvents
            if (prevContext === initialContext) {
                prevContext.dispatch({
                    type: 'SET_EVENT_DRAG',
                    state: {
                        affectedEvents: state.affectedEvents,
                        mutatedEvents: common.createEmptyEventStore(),
                        isEvent: true,
                    },
                });
                // completely clear the old calendar if it wasn't the initial
            }
            else {
                prevContext.dispatch({ type: 'UNSET_EVENT_DRAG' });
            }
        }
        if (nextContext) {
            nextContext.dispatch({ type: 'SET_EVENT_DRAG', state: state });
        }
    };
    EventDragging.prototype.clearDrag = function () {
        var initialCalendar = this.component.context;
        var receivingContext = this.receivingContext;
        if (receivingContext) {
            receivingContext.dispatch({ type: 'UNSET_EVENT_DRAG' });
        }
        // the initial calendar might have an dummy drag state from displayDrag
        if (initialCalendar !== receivingContext) {
            initialCalendar.dispatch({ type: 'UNSET_EVENT_DRAG' });
        }
    };
    EventDragging.prototype.cleanup = function () {
        this.subjectSeg = null;
        this.isDragging = false;
        this.eventRange = null;
        this.relevantEvents = null;
        this.receivingContext = null;
        this.validMutation = null;
        this.mutatedRelevantEvents = null;
    };
    // TODO: test this in IE11
    // QUESTION: why do we need it on the resizable???
    EventDragging.SELECTOR = '.fc-event-draggable, .fc-event-resizable';
    return EventDragging;
}(common.Interaction));
function computeEventMutation(hit0, hit1, massagers) {
    var dateSpan0 = hit0.dateSpan;
    var dateSpan1 = hit1.dateSpan;
    var date0 = dateSpan0.range.start;
    var date1 = dateSpan1.range.start;
    var standardProps = {};
    if (dateSpan0.allDay !== dateSpan1.allDay) {
        standardProps.allDay = dateSpan1.allDay;
        standardProps.hasEnd = hit1.context.options.allDayMaintainDuration;
        if (dateSpan1.allDay) {
            // means date1 is already start-of-day,
            // but date0 needs to be converted
            date0 = common.startOfDay(date0);
        }
    }
    var delta = common.diffDates(date0, date1, hit0.context.dateEnv, hit0.componentId === hit1.componentId ?
        hit0.largeUnit :
        null);
    if (delta.milliseconds) { // has hours/minutes/seconds
        standardProps.allDay = false;
    }
    var mutation = {
        datesDelta: delta,
        standardProps: standardProps,
    };
    for (var _i = 0, massagers_1 = massagers; _i < massagers_1.length; _i++) {
        var massager = massagers_1[_i];
        massager(mutation, hit0, hit1);
    }
    return mutation;
}
function getComponentTouchDelay(component) {
    var options = component.context.options;
    var delay = options.eventLongPressDelay;
    if (delay == null) {
        delay = options.longPressDelay;
    }
    return delay;
}

var EventResizing = /** @class */ (function (_super) {
    tslib.__extends(EventResizing, _super);
    function EventResizing(settings) {
        var _this = _super.call(this, settings) || this;
        // internal state
        _this.draggingSegEl = null;
        _this.draggingSeg = null; // TODO: rename to resizingSeg? subjectSeg?
        _this.eventRange = null;
        _this.relevantEvents = null;
        _this.validMutation = null;
        _this.mutatedRelevantEvents = null;
        _this.handlePointerDown = function (ev) {
            var component = _this.component;
            var segEl = _this.querySegEl(ev);
            var seg = common.getElSeg(segEl);
            var eventRange = _this.eventRange = seg.eventRange;
            _this.dragging.minDistance = component.context.options.eventDragMinDistance;
            // if touch, need to be working with a selected event
            _this.dragging.setIgnoreMove(!_this.component.isValidSegDownEl(ev.origEvent.target) ||
                (ev.isTouch && _this.component.props.eventSelection !== eventRange.instance.instanceId));
        };
        _this.handleDragStart = function (ev) {
            var context = _this.component.context;
            var eventRange = _this.eventRange;
            _this.relevantEvents = common.getRelevantEvents(context.getCurrentData().eventStore, _this.eventRange.instance.instanceId);
            var segEl = _this.querySegEl(ev);
            _this.draggingSegEl = segEl;
            _this.draggingSeg = common.getElSeg(segEl);
            context.calendarApi.unselect();
            context.emitter.trigger('eventResizeStart', {
                el: segEl,
                event: new common.EventApi(context, eventRange.def, eventRange.instance),
                jsEvent: ev.origEvent,
                view: context.viewApi,
            });
        };
        _this.handleHitUpdate = function (hit, isFinal, ev) {
            var context = _this.component.context;
            var relevantEvents = _this.relevantEvents;
            var initialHit = _this.hitDragging.initialHit;
            var eventInstance = _this.eventRange.instance;
            var mutation = null;
            var mutatedRelevantEvents = null;
            var isInvalid = false;
            var interaction = {
                affectedEvents: relevantEvents,
                mutatedEvents: common.createEmptyEventStore(),
                isEvent: true,
            };
            if (hit) {
                var disallowed = hit.componentId === initialHit.componentId
                    && _this.isHitComboAllowed
                    && !_this.isHitComboAllowed(initialHit, hit);
                if (!disallowed) {
                    mutation = computeMutation(initialHit, hit, ev.subjectEl.classList.contains('fc-event-resizer-start'), eventInstance.range);
                }
            }
            if (mutation) {
                mutatedRelevantEvents = common.applyMutationToEventStore(relevantEvents, context.getCurrentData().eventUiBases, mutation, context);
                interaction.mutatedEvents = mutatedRelevantEvents;
                if (!common.isInteractionValid(interaction, hit.dateProfile, context)) {
                    isInvalid = true;
                    mutation = null;
                    mutatedRelevantEvents = null;
                    interaction.mutatedEvents = null;
                }
            }
            if (mutatedRelevantEvents) {
                context.dispatch({
                    type: 'SET_EVENT_RESIZE',
                    state: interaction,
                });
            }
            else {
                context.dispatch({ type: 'UNSET_EVENT_RESIZE' });
            }
            if (!isInvalid) {
                common.enableCursor();
            }
            else {
                common.disableCursor();
            }
            if (!isFinal) {
                if (mutation && isHitsEqual(initialHit, hit)) {
                    mutation = null;
                }
                _this.validMutation = mutation;
                _this.mutatedRelevantEvents = mutatedRelevantEvents;
            }
        };
        _this.handleDragEnd = function (ev) {
            var context = _this.component.context;
            var eventDef = _this.eventRange.def;
            var eventInstance = _this.eventRange.instance;
            var eventApi = new common.EventApi(context, eventDef, eventInstance);
            var relevantEvents = _this.relevantEvents;
            var mutatedRelevantEvents = _this.mutatedRelevantEvents;
            context.emitter.trigger('eventResizeStop', {
                el: _this.draggingSegEl,
                event: eventApi,
                jsEvent: ev.origEvent,
                view: context.viewApi,
            });
            if (_this.validMutation) {
                var updatedEventApi = new common.EventApi(context, mutatedRelevantEvents.defs[eventDef.defId], eventInstance ? mutatedRelevantEvents.instances[eventInstance.instanceId] : null);
                context.dispatch({
                    type: 'MERGE_EVENTS',
                    eventStore: mutatedRelevantEvents,
                });
                var eventChangeArg = {
                    oldEvent: eventApi,
                    event: updatedEventApi,
                    relatedEvents: common.buildEventApis(mutatedRelevantEvents, context, eventInstance),
                    revert: function () {
                        context.dispatch({
                            type: 'MERGE_EVENTS',
                            eventStore: relevantEvents, // the pre-change events
                        });
                    },
                };
                context.emitter.trigger('eventResize', tslib.__assign(tslib.__assign({}, eventChangeArg), { el: _this.draggingSegEl, startDelta: _this.validMutation.startDelta || common.createDuration(0), endDelta: _this.validMutation.endDelta || common.createDuration(0), jsEvent: ev.origEvent, view: context.viewApi }));
                context.emitter.trigger('eventChange', eventChangeArg);
            }
            else {
                context.emitter.trigger('_noEventResize');
            }
            // reset all internal state
            _this.draggingSeg = null;
            _this.relevantEvents = null;
            _this.validMutation = null;
            // okay to keep eventInstance around. useful to set it in handlePointerDown
        };
        var component = settings.component;
        var dragging = _this.dragging = new FeaturefulElementDragging(settings.el);
        dragging.pointer.selector = '.fc-event-resizer';
        dragging.touchScrollAllowed = false;
        dragging.autoScroller.isEnabled = component.context.options.dragScroll;
        var hitDragging = _this.hitDragging = new HitDragging(_this.dragging, common.interactionSettingsToStore(settings));
        hitDragging.emitter.on('pointerdown', _this.handlePointerDown);
        hitDragging.emitter.on('dragstart', _this.handleDragStart);
        hitDragging.emitter.on('hitupdate', _this.handleHitUpdate);
        hitDragging.emitter.on('dragend', _this.handleDragEnd);
        return _this;
    }
    EventResizing.prototype.destroy = function () {
        this.dragging.destroy();
    };
    EventResizing.prototype.querySegEl = function (ev) {
        return common.elementClosest(ev.subjectEl, '.fc-event');
    };
    return EventResizing;
}(common.Interaction));
function computeMutation(hit0, hit1, isFromStart, instanceRange) {
    var dateEnv = hit0.context.dateEnv;
    var date0 = hit0.dateSpan.range.start;
    var date1 = hit1.dateSpan.range.start;
    var delta = common.diffDates(date0, date1, dateEnv, hit0.largeUnit);
    if (isFromStart) {
        if (dateEnv.add(instanceRange.start, delta) < instanceRange.end) {
            return { startDelta: delta };
        }
    }
    else if (dateEnv.add(instanceRange.end, delta) > instanceRange.start) {
        return { endDelta: delta };
    }
    return null;
}

var UnselectAuto = /** @class */ (function () {
    function UnselectAuto(context) {
        var _this = this;
        this.context = context;
        this.isRecentPointerDateSelect = false; // wish we could use a selector to detect date selection, but uses hit system
        this.matchesCancel = false;
        this.matchesEvent = false;
        this.onSelect = function (selectInfo) {
            if (selectInfo.jsEvent) {
                _this.isRecentPointerDateSelect = true;
            }
        };
        this.onDocumentPointerDown = function (pev) {
            var unselectCancel = _this.context.options.unselectCancel;
            var downEl = common.getEventTargetViaRoot(pev.origEvent);
            _this.matchesCancel = !!common.elementClosest(downEl, unselectCancel);
            _this.matchesEvent = !!common.elementClosest(downEl, EventDragging.SELECTOR); // interaction started on an event?
        };
        this.onDocumentPointerUp = function (pev) {
            var context = _this.context;
            var documentPointer = _this.documentPointer;
            var calendarState = context.getCurrentData();
            // touch-scrolling should never unfocus any type of selection
            if (!documentPointer.wasTouchScroll) {
                if (calendarState.dateSelection && // an existing date selection?
                    !_this.isRecentPointerDateSelect // a new pointer-initiated date selection since last onDocumentPointerUp?
                ) {
                    var unselectAuto = context.options.unselectAuto;
                    if (unselectAuto && (!unselectAuto || !_this.matchesCancel)) {
                        context.calendarApi.unselect(pev);
                    }
                }
                if (calendarState.eventSelection && // an existing event selected?
                    !_this.matchesEvent // interaction DIDN'T start on an event
                ) {
                    context.dispatch({ type: 'UNSELECT_EVENT' });
                }
            }
            _this.isRecentPointerDateSelect = false;
        };
        var documentPointer = this.documentPointer = new PointerDragging(document);
        documentPointer.shouldIgnoreMove = true;
        documentPointer.shouldWatchScroll = false;
        documentPointer.emitter.on('pointerdown', this.onDocumentPointerDown);
        documentPointer.emitter.on('pointerup', this.onDocumentPointerUp);
        /*
        TODO: better way to know about whether there was a selection with the pointer
        */
        context.emitter.on('select', this.onSelect);
    }
    UnselectAuto.prototype.destroy = function () {
        this.context.emitter.off('select', this.onSelect);
        this.documentPointer.destroy();
    };
    return UnselectAuto;
}());

var OPTION_REFINERS = {
    fixedMirrorParent: common.identity,
};
var LISTENER_REFINERS = {
    dateClick: common.identity,
    eventDragStart: common.identity,
    eventDragStop: common.identity,
    eventDrop: common.identity,
    eventResizeStart: common.identity,
    eventResizeStop: common.identity,
    eventResize: common.identity,
    drop: common.identity,
    eventReceive: common.identity,
    eventLeave: common.identity,
};

/*
Given an already instantiated draggable object for one-or-more elements,
Interprets any dragging as an attempt to drag an events that lives outside
of a calendar onto a calendar.
*/
var ExternalElementDragging = /** @class */ (function () {
    function ExternalElementDragging(dragging, suppliedDragMeta) {
        var _this = this;
        this.receivingContext = null;
        this.droppableEvent = null; // will exist for all drags, even if create:false
        this.suppliedDragMeta = null;
        this.dragMeta = null;
        this.handleDragStart = function (ev) {
            _this.dragMeta = _this.buildDragMeta(ev.subjectEl);
        };
        this.handleHitUpdate = function (hit, isFinal, ev) {
            var dragging = _this.hitDragging.dragging;
            var receivingContext = null;
            var droppableEvent = null;
            var isInvalid = false;
            var interaction = {
                affectedEvents: common.createEmptyEventStore(),
                mutatedEvents: common.createEmptyEventStore(),
                isEvent: _this.dragMeta.create,
            };
            if (hit) {
                receivingContext = hit.context;
                if (_this.canDropElOnCalendar(ev.subjectEl, receivingContext)) {
                    droppableEvent = computeEventForDateSpan(hit.dateSpan, _this.dragMeta, receivingContext);
                    interaction.mutatedEvents = common.eventTupleToStore(droppableEvent);
                    isInvalid = !common.isInteractionValid(interaction, hit.dateProfile, receivingContext);
                    if (isInvalid) {
                        interaction.mutatedEvents = common.createEmptyEventStore();
                        droppableEvent = null;
                    }
                }
            }
            _this.displayDrag(receivingContext, interaction);
            // show mirror if no already-rendered mirror element OR if we are shutting down the mirror (?)
            // TODO: wish we could somehow wait for dispatch to guarantee render
            dragging.setMirrorIsVisible(isFinal || !droppableEvent || !document.querySelector('.fc-event-mirror'));
            if (!isInvalid) {
                common.enableCursor();
            }
            else {
                common.disableCursor();
            }
            if (!isFinal) {
                dragging.setMirrorNeedsRevert(!droppableEvent);
                _this.receivingContext = receivingContext;
                _this.droppableEvent = droppableEvent;
            }
        };
        this.handleDragEnd = function (pev) {
            var _a = _this, receivingContext = _a.receivingContext, droppableEvent = _a.droppableEvent;
            _this.clearDrag();
            if (receivingContext && droppableEvent) {
                var finalHit = _this.hitDragging.finalHit;
                var finalView = finalHit.context.viewApi;
                var dragMeta = _this.dragMeta;
                receivingContext.emitter.trigger('drop', tslib.__assign(tslib.__assign({}, buildDatePointApiWithContext(finalHit.dateSpan, receivingContext)), { draggedEl: pev.subjectEl, jsEvent: pev.origEvent, view: finalView }));
                if (dragMeta.create) {
                    var addingEvents_1 = common.eventTupleToStore(droppableEvent);
                    receivingContext.dispatch({
                        type: 'MERGE_EVENTS',
                        eventStore: addingEvents_1,
                    });
                    if (pev.isTouch) {
                        receivingContext.dispatch({
                            type: 'SELECT_EVENT',
                            eventInstanceId: droppableEvent.instance.instanceId,
                        });
                    }
                    // signal that an external event landed
                    receivingContext.emitter.trigger('eventReceive', {
                        event: new common.EventApi(receivingContext, droppableEvent.def, droppableEvent.instance),
                        relatedEvents: [],
                        revert: function () {
                            receivingContext.dispatch({
                                type: 'REMOVE_EVENTS',
                                eventStore: addingEvents_1,
                            });
                        },
                        draggedEl: pev.subjectEl,
                        view: finalView,
                    });
                }
            }
            _this.receivingContext = null;
            _this.droppableEvent = null;
        };
        var hitDragging = this.hitDragging = new HitDragging(dragging, common.interactionSettingsStore);
        hitDragging.requireInitial = false; // will start outside of a component
        hitDragging.emitter.on('dragstart', this.handleDragStart);
        hitDragging.emitter.on('hitupdate', this.handleHitUpdate);
        hitDragging.emitter.on('dragend', this.handleDragEnd);
        this.suppliedDragMeta = suppliedDragMeta;
    }
    ExternalElementDragging.prototype.buildDragMeta = function (subjectEl) {
        if (typeof this.suppliedDragMeta === 'object') {
            return common.parseDragMeta(this.suppliedDragMeta);
        }
        if (typeof this.suppliedDragMeta === 'function') {
            return common.parseDragMeta(this.suppliedDragMeta(subjectEl));
        }
        return getDragMetaFromEl(subjectEl);
    };
    ExternalElementDragging.prototype.displayDrag = function (nextContext, state) {
        var prevContext = this.receivingContext;
        if (prevContext && prevContext !== nextContext) {
            prevContext.dispatch({ type: 'UNSET_EVENT_DRAG' });
        }
        if (nextContext) {
            nextContext.dispatch({ type: 'SET_EVENT_DRAG', state: state });
        }
    };
    ExternalElementDragging.prototype.clearDrag = function () {
        if (this.receivingContext) {
            this.receivingContext.dispatch({ type: 'UNSET_EVENT_DRAG' });
        }
    };
    ExternalElementDragging.prototype.canDropElOnCalendar = function (el, receivingContext) {
        var dropAccept = receivingContext.options.dropAccept;
        if (typeof dropAccept === 'function') {
            return dropAccept.call(receivingContext.calendarApi, el);
        }
        if (typeof dropAccept === 'string' && dropAccept) {
            return Boolean(common.elementMatches(el, dropAccept));
        }
        return true;
    };
    return ExternalElementDragging;
}());
// Utils for computing event store from the DragMeta
// ----------------------------------------------------------------------------------------------------
function computeEventForDateSpan(dateSpan, dragMeta, context) {
    var defProps = tslib.__assign({}, dragMeta.leftoverProps);
    for (var _i = 0, _a = context.pluginHooks.externalDefTransforms; _i < _a.length; _i++) {
        var transform = _a[_i];
        tslib.__assign(defProps, transform(dateSpan, dragMeta));
    }
    var _b = common.refineEventDef(defProps, context), refined = _b.refined, extra = _b.extra;
    var def = common.parseEventDef(refined, extra, dragMeta.sourceId, dateSpan.allDay, context.options.forceEventDuration || Boolean(dragMeta.duration), // hasEnd
    context);
    var start = dateSpan.range.start;
    // only rely on time info if drop zone is all-day,
    // otherwise, we already know the time
    if (dateSpan.allDay && dragMeta.startTime) {
        start = context.dateEnv.add(start, dragMeta.startTime);
    }
    var end = dragMeta.duration ?
        context.dateEnv.add(start, dragMeta.duration) :
        common.getDefaultEventEnd(dateSpan.allDay, start, context);
    var instance = common.createEventInstance(def.defId, { start: start, end: end });
    return { def: def, instance: instance };
}
// Utils for extracting data from element
// ----------------------------------------------------------------------------------------------------
function getDragMetaFromEl(el) {
    var str = getEmbeddedElData(el, 'event');
    var obj = str ?
        JSON.parse(str) :
        { create: false }; // if no embedded data, assume no event creation
    return common.parseDragMeta(obj);
}
common.config.dataAttrPrefix = '';
function getEmbeddedElData(el, name) {
    var prefix = common.config.dataAttrPrefix;
    var prefixedName = (prefix ? prefix + '-' : '') + name;
    return el.getAttribute('data-' + prefixedName) || '';
}

/*
Makes an element (that is *external* to any calendar) draggable.
Can pass in data that determines how an event will be created when dropped onto a calendar.
Leverages FullCalendar's internal drag-n-drop functionality WITHOUT a third-party drag system.
*/
var ExternalDraggable = /** @class */ (function () {
    function ExternalDraggable(el, settings) {
        var _this = this;
        if (settings === void 0) { settings = {}; }
        this.handlePointerDown = function (ev) {
            var dragging = _this.dragging;
            var _a = _this.settings, minDistance = _a.minDistance, longPressDelay = _a.longPressDelay;
            dragging.minDistance =
                minDistance != null ?
                    minDistance :
                    (ev.isTouch ? 0 : common.BASE_OPTION_DEFAULTS.eventDragMinDistance);
            dragging.delay =
                ev.isTouch ? // TODO: eventually read eventLongPressDelay instead vvv
                    (longPressDelay != null ? longPressDelay : common.BASE_OPTION_DEFAULTS.longPressDelay) :
                    0;
        };
        this.handleDragStart = function (ev) {
            if (ev.isTouch &&
                _this.dragging.delay &&
                ev.subjectEl.classList.contains('fc-event')) {
                _this.dragging.mirror.getMirrorEl().classList.add('fc-event-selected');
            }
        };
        this.settings = settings;
        var dragging = this.dragging = new FeaturefulElementDragging(el);
        dragging.touchScrollAllowed = false;
        if (settings.itemSelector != null) {
            dragging.pointer.selector = settings.itemSelector;
        }
        if (settings.appendTo != null) {
            dragging.mirror.parentNode = settings.appendTo; // TODO: write tests
        }
        dragging.emitter.on('pointerdown', this.handlePointerDown);
        dragging.emitter.on('dragstart', this.handleDragStart);
        new ExternalElementDragging(dragging, settings.eventData); // eslint-disable-line no-new
    }
    ExternalDraggable.prototype.destroy = function () {
        this.dragging.destroy();
    };
    return ExternalDraggable;
}());

/*
Detects when a *THIRD-PARTY* drag-n-drop system interacts with elements.
The third-party system is responsible for drawing the visuals effects of the drag.
This class simply monitors for pointer movements and fires events.
It also has the ability to hide the moving element (the "mirror") during the drag.
*/
var InferredElementDragging = /** @class */ (function (_super) {
    tslib.__extends(InferredElementDragging, _super);
    function InferredElementDragging(containerEl) {
        var _this = _super.call(this, containerEl) || this;
        _this.shouldIgnoreMove = false;
        _this.mirrorSelector = '';
        _this.currentMirrorEl = null;
        _this.handlePointerDown = function (ev) {
            _this.emitter.trigger('pointerdown', ev);
            if (!_this.shouldIgnoreMove) {
                // fire dragstart right away. does not support delay or min-distance
                _this.emitter.trigger('dragstart', ev);
            }
        };
        _this.handlePointerMove = function (ev) {
            if (!_this.shouldIgnoreMove) {
                _this.emitter.trigger('dragmove', ev);
            }
        };
        _this.handlePointerUp = function (ev) {
            _this.emitter.trigger('pointerup', ev);
            if (!_this.shouldIgnoreMove) {
                // fire dragend right away. does not support a revert animation
                _this.emitter.trigger('dragend', ev);
            }
        };
        var pointer = _this.pointer = new PointerDragging(containerEl);
        pointer.emitter.on('pointerdown', _this.handlePointerDown);
        pointer.emitter.on('pointermove', _this.handlePointerMove);
        pointer.emitter.on('pointerup', _this.handlePointerUp);
        return _this;
    }
    InferredElementDragging.prototype.destroy = function () {
        this.pointer.destroy();
    };
    InferredElementDragging.prototype.setIgnoreMove = function (bool) {
        this.shouldIgnoreMove = bool;
    };
    InferredElementDragging.prototype.setMirrorIsVisible = function (bool) {
        if (bool) {
            // restore a previously hidden element.
            // use the reference in case the selector class has already been removed.
            if (this.currentMirrorEl) {
                this.currentMirrorEl.style.visibility = '';
                this.currentMirrorEl = null;
            }
        }
        else {
            var mirrorEl = this.mirrorSelector
                // TODO: somehow query FullCalendars WITHIN shadow-roots
                ? document.querySelector(this.mirrorSelector)
                : null;
            if (mirrorEl) {
                this.currentMirrorEl = mirrorEl;
                mirrorEl.style.visibility = 'hidden';
            }
        }
    };
    return InferredElementDragging;
}(common.ElementDragging));

/*
Bridges third-party drag-n-drop systems with FullCalendar.
Must be instantiated and destroyed by caller.
*/
var ThirdPartyDraggable = /** @class */ (function () {
    function ThirdPartyDraggable(containerOrSettings, settings) {
        var containerEl = document;
        if (
        // wish we could just test instanceof EventTarget, but doesn't work in IE11
        containerOrSettings === document ||
            containerOrSettings instanceof Element) {
            containerEl = containerOrSettings;
            settings = settings || {};
        }
        else {
            settings = (containerOrSettings || {});
        }
        var dragging = this.dragging = new InferredElementDragging(containerEl);
        if (typeof settings.itemSelector === 'string') {
            dragging.pointer.selector = settings.itemSelector;
        }
        else if (containerEl === document) {
            dragging.pointer.selector = '[data-event]';
        }
        if (typeof settings.mirrorSelector === 'string') {
            dragging.mirrorSelector = settings.mirrorSelector;
        }
        new ExternalElementDragging(dragging, settings.eventData); // eslint-disable-line no-new
    }
    ThirdPartyDraggable.prototype.destroy = function () {
        this.dragging.destroy();
    };
    return ThirdPartyDraggable;
}());

var main = common.createPlugin({
    componentInteractions: [DateClicking, DateSelecting, EventDragging, EventResizing],
    calendarInteractions: [UnselectAuto],
    elementDraggingImpl: FeaturefulElementDragging,
    optionRefiners: OPTION_REFINERS,
    listenerRefiners: LISTENER_REFINERS,
});

exports.Draggable = ExternalDraggable;
exports.FeaturefulElementDragging = FeaturefulElementDragging;
exports.PointerDragging = PointerDragging;
exports.ThirdPartyDraggable = ThirdPartyDraggable;
exports.default = main;

},{"@fullcalendar/common":3,"tslib":782}],10:[function(require,module,exports){
/*!
FullCalendar Scheduler v5.9.0
Docs & License: https://fullcalendar.io/scheduler
(c) 2021 Adam Shaw
*/
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var common = require('@fullcalendar/common');

var RELEASE_DATE = '2021-07-28'; // for Scheduler
var UPGRADE_WINDOW = 365 + 7; // days. 1 week leeway, for tz shift reasons too
var INVALID_LICENSE_URL = 'http://fullcalendar.io/docs/schedulerLicenseKey#invalid';
var OUTDATED_LICENSE_URL = 'http://fullcalendar.io/docs/schedulerLicenseKey#outdated';
var PRESET_LICENSE_KEYS = [
    'GPL-My-Project-Is-Open-Source',
    'CC-Attribution-NonCommercial-NoDerivatives',
];
var CSS = {
    position: 'absolute',
    zIndex: 99999,
    bottom: '1px',
    left: '1px',
    background: '#eee',
    borderColor: '#ddd',
    borderStyle: 'solid',
    borderWidth: '1px 1px 0 0',
    padding: '2px 4px',
    fontSize: '12px',
    borderTopRightRadius: '3px',
};
function buildLicenseWarning(context) {
    var key = context.options.schedulerLicenseKey;
    var currentUrl = typeof window !== 'undefined' ? window.location.href : '';
    if (!isImmuneUrl(currentUrl)) {
        var status_1 = processLicenseKey(key);
        if (status_1 !== 'valid') {
            return (common.createElement("div", { className: "fc-license-message", style: CSS }, (status_1 === 'outdated') ? (common.createElement(common.Fragment, null,
                'Your license key is too old to work with this version. ',
                common.createElement("a", { href: OUTDATED_LICENSE_URL }, "More Info"))) : (common.createElement(common.Fragment, null,
                'Your license key is invalid. ',
                common.createElement("a", { href: INVALID_LICENSE_URL }, "More Info")))));
        }
    }
    return null;
}
/*
This decryption is not meant to be bulletproof. Just a way to remind about an upgrade.
*/
function processLicenseKey(key) {
    if (PRESET_LICENSE_KEYS.indexOf(key) !== -1) {
        return 'valid';
    }
    var parts = (key || '').match(/^(\d+)-fcs-(\d+)$/);
    if (parts && (parts[1].length === 10)) {
        var purchaseDate = new Date(parseInt(parts[2], 10) * 1000);
        var releaseDate = new Date(common.config.mockSchedulerReleaseDate || RELEASE_DATE);
        if (common.isValidDate(releaseDate)) { // token won't be replaced in dev mode
            var minPurchaseDate = common.addDays(releaseDate, -UPGRADE_WINDOW);
            if (minPurchaseDate < purchaseDate) {
                return 'valid';
            }
            return 'outdated';
        }
    }
    return 'invalid';
}
function isImmuneUrl(url) {
    return /\w+:\/\/fullcalendar\.io\/|\/examples\/[\w-]+\.html$/.test(url);
}

var OPTION_REFINERS = {
    schedulerLicenseKey: String,
};

var main = common.createPlugin({
    optionRefiners: OPTION_REFINERS,
    viewContainerAppends: [buildLicenseWarning],
});

exports.default = main;

},{"@fullcalendar/common":3}],11:[function(require,module,exports){
/*!
FullCalendar Scheduler v5.9.0
Docs & License: https://fullcalendar.io/scheduler
(c) 2021 Adam Shaw
*/
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var common = require('@fullcalendar/common');
var premiumCommonPlugin = require('@fullcalendar/premium-common');
var tslib = require('tslib');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var premiumCommonPlugin__default = /*#__PURE__*/_interopDefaultLegacy(premiumCommonPlugin);

function massageEventDragMutation(eventMutation, hit0, hit1) {
    var resource0 = hit0.dateSpan.resourceId;
    var resource1 = hit1.dateSpan.resourceId;
    if (resource0 && resource1 &&
        resource0 !== resource1) {
        eventMutation.resourceMutation = {
            matchResourceId: resource0,
            setResourceId: resource1,
        };
    }
}
/*
TODO: all this would be much easier if we were using a hash!
*/
function applyEventDefMutation(eventDef, mutation, context) {
    var resourceMutation = mutation.resourceMutation;
    if (resourceMutation && computeResourceEditable(eventDef, context)) {
        var index = eventDef.resourceIds.indexOf(resourceMutation.matchResourceId);
        if (index !== -1) {
            var resourceIds = eventDef.resourceIds.slice(); // copy
            resourceIds.splice(index, 1); // remove
            if (resourceIds.indexOf(resourceMutation.setResourceId) === -1) { // not already in there
                resourceIds.push(resourceMutation.setResourceId); // add
            }
            eventDef.resourceIds = resourceIds;
        }
    }
}
/*
HACK
TODO: use EventUi system instead of this
*/
function computeResourceEditable(eventDef, context) {
    var resourceEditable = eventDef.resourceEditable;
    if (resourceEditable == null) {
        var source = eventDef.sourceId && context.getCurrentData().eventSources[eventDef.sourceId];
        if (source) {
            resourceEditable = source.extendedProps.resourceEditable; // used the Source::extendedProps hack
        }
        if (resourceEditable == null) {
            resourceEditable = context.options.eventResourceEditable;
            if (resourceEditable == null) {
                resourceEditable = context.options.editable; // TODO: use defaults system instead
            }
        }
    }
    return resourceEditable;
}
function transformEventDrop(mutation, context) {
    var resourceMutation = mutation.resourceMutation;
    if (resourceMutation) {
        var calendarApi = context.calendarApi;
        return {
            oldResource: calendarApi.getResourceById(resourceMutation.matchResourceId),
            newResource: calendarApi.getResourceById(resourceMutation.setResourceId),
        };
    }
    return {
        oldResource: null,
        newResource: null,
    };
}

var ResourceDataAdder = /** @class */ (function () {
    function ResourceDataAdder() {
        this.filterResources = common.memoize(filterResources);
    }
    ResourceDataAdder.prototype.transform = function (viewProps, calendarProps) {
        if (calendarProps.viewSpec.optionDefaults.needsResourceData) {
            return {
                resourceStore: this.filterResources(calendarProps.resourceStore, calendarProps.options.filterResourcesWithEvents, calendarProps.eventStore, calendarProps.dateProfile.activeRange),
                resourceEntityExpansions: calendarProps.resourceEntityExpansions,
            };
        }
        return null;
    };
    return ResourceDataAdder;
}());
function filterResources(resourceStore, doFilterResourcesWithEvents, eventStore, activeRange) {
    if (doFilterResourcesWithEvents) {
        var instancesInRange = filterEventInstancesInRange(eventStore.instances, activeRange);
        var hasEvents_1 = computeHasEvents(instancesInRange, eventStore.defs);
        tslib.__assign(hasEvents_1, computeAncestorHasEvents(hasEvents_1, resourceStore));
        return common.filterHash(resourceStore, function (resource, resourceId) { return hasEvents_1[resourceId]; });
    }
    return resourceStore;
}
function filterEventInstancesInRange(eventInstances, activeRange) {
    return common.filterHash(eventInstances, function (eventInstance) { return common.rangesIntersect(eventInstance.range, activeRange); });
}
function computeHasEvents(eventInstances, eventDefs) {
    var hasEvents = {};
    for (var instanceId in eventInstances) {
        var instance = eventInstances[instanceId];
        for (var _i = 0, _a = eventDefs[instance.defId].resourceIds; _i < _a.length; _i++) {
            var resourceId = _a[_i];
            hasEvents[resourceId] = true;
        }
    }
    return hasEvents;
}
/*
mark resources as having events if any of their ancestors have them
NOTE: resourceStore might not have all the resources that hasEvents{} has keyed
*/
function computeAncestorHasEvents(hasEvents, resourceStore) {
    var res = {};
    for (var resourceId in hasEvents) {
        var resource = void 0;
        while ((resource = resourceStore[resourceId])) {
            resourceId = resource.parentId; // now functioning as the parentId
            if (resourceId) {
                res[resourceId] = true;
            }
            else {
                break;
            }
        }
    }
    return res;
}
/*
for making sure events that have editable resources are always draggable in resource views
*/
function transformIsDraggable(val, eventDef, eventUi, context) {
    if (!val) {
        var state = context.getCurrentData();
        var viewSpec = state.viewSpecs[state.currentViewType];
        if (viewSpec.optionDefaults.needsResourceData) {
            if (computeResourceEditable(eventDef, context)) {
                return true;
            }
        }
    }
    return val;
}

// for when non-resource view should be given EventUi info (for event coloring/constraints based off of resource data)
var ResourceEventConfigAdder = /** @class */ (function () {
    function ResourceEventConfigAdder() {
        this.buildResourceEventUis = common.memoize(buildResourceEventUis, common.isPropsEqual);
        this.injectResourceEventUis = common.memoize(injectResourceEventUis);
    }
    ResourceEventConfigAdder.prototype.transform = function (viewProps, calendarProps) {
        if (!calendarProps.viewSpec.optionDefaults.needsResourceData) {
            return {
                eventUiBases: this.injectResourceEventUis(viewProps.eventUiBases, viewProps.eventStore.defs, this.buildResourceEventUis(calendarProps.resourceStore)),
            };
        }
        return null;
    };
    return ResourceEventConfigAdder;
}());
function buildResourceEventUis(resourceStore) {
    return common.mapHash(resourceStore, function (resource) { return resource.ui; });
}
function injectResourceEventUis(eventUiBases, eventDefs, resourceEventUis) {
    return common.mapHash(eventUiBases, function (eventUi, defId) {
        if (defId) { // not the '' key
            return injectResourceEventUi(eventUi, eventDefs[defId], resourceEventUis);
        }
        return eventUi;
    });
}
function injectResourceEventUi(origEventUi, eventDef, resourceEventUis) {
    var parts = [];
    // first resource takes precedence, which fights with the ordering of combineEventUis, thus the unshifts
    for (var _i = 0, _a = eventDef.resourceIds; _i < _a.length; _i++) {
        var resourceId = _a[_i];
        if (resourceEventUis[resourceId]) {
            parts.unshift(resourceEventUis[resourceId]);
        }
    }
    parts.unshift(origEventUi);
    return common.combineEventUis(parts);
}

var defs = []; // TODO: use plugin system
function registerResourceSourceDef(def) {
    defs.push(def);
}
function getResourceSourceDef(id) {
    return defs[id];
}
function getResourceSourceDefs() {
    return defs;
}

// TODO: make this a plugin-able parser
// TODO: success/failure
var RESOURCE_SOURCE_REFINERS = {
    id: String,
    // for array. TODO: move to resource-array
    resources: common.identity,
    // for json feed. TODO: move to resource-json-feed
    url: String,
    method: String,
    startParam: String,
    endParam: String,
    timeZoneParam: String,
    extraParams: common.identity,
};
function parseResourceSource(input) {
    var inputObj;
    if (typeof input === 'string') {
        inputObj = { url: input };
    }
    else if (typeof input === 'function' || Array.isArray(input)) {
        inputObj = { resources: input };
    }
    else if (typeof input === 'object' && input) { // non-null object
        inputObj = input;
    }
    if (inputObj) {
        var _a = common.refineProps(inputObj, RESOURCE_SOURCE_REFINERS), refined = _a.refined, extra = _a.extra;
        warnUnknownProps(extra);
        var metaRes = buildResourceSourceMeta(refined);
        if (metaRes) {
            return {
                _raw: input,
                sourceId: common.guid(),
                sourceDefId: metaRes.sourceDefId,
                meta: metaRes.meta,
                publicId: refined.id || '',
                isFetching: false,
                latestFetchId: '',
                fetchRange: null,
            };
        }
    }
    return null;
}
function buildResourceSourceMeta(refined) {
    var defs = getResourceSourceDefs();
    for (var i = defs.length - 1; i >= 0; i -= 1) { // later-added plugins take precedence
        var def = defs[i];
        var meta = def.parseMeta(refined);
        if (meta) {
            return { meta: meta, sourceDefId: i };
        }
    }
    return null;
}
function warnUnknownProps(props) {
    for (var propName in props) {
        console.warn("Unknown resource prop '" + propName + "'");
    }
}

function reduceResourceSource(source, action, context) {
    var options = context.options, dateProfile = context.dateProfile;
    if (!source || !action) {
        return createSource(options.initialResources || options.resources, dateProfile.activeRange, options.refetchResourcesOnNavigate, context);
    }
    switch (action.type) {
        case 'RESET_RESOURCE_SOURCE':
            return createSource(action.resourceSourceInput, dateProfile.activeRange, options.refetchResourcesOnNavigate, context);
        case 'PREV': // TODO: how do we track all actions that affect dateProfile :(
        case 'NEXT':
        case 'CHANGE_DATE':
        case 'CHANGE_VIEW_TYPE':
            return handleRangeChange(source, dateProfile.activeRange, options.refetchResourcesOnNavigate, context);
        case 'RECEIVE_RESOURCES':
        case 'RECEIVE_RESOURCE_ERROR':
            return receiveResponse(source, action.fetchId, action.fetchRange);
        case 'REFETCH_RESOURCES':
            return fetchSource(source, dateProfile.activeRange, context);
        default:
            return source;
    }
}
function createSource(input, activeRange, refetchResourcesOnNavigate, context) {
    if (input) {
        var source = parseResourceSource(input);
        source = fetchSource(source, refetchResourcesOnNavigate ? activeRange : null, context);
        return source;
    }
    return null;
}
function handleRangeChange(source, activeRange, refetchResourcesOnNavigate, context) {
    if (refetchResourcesOnNavigate &&
        !doesSourceIgnoreRange(source) &&
        (!source.fetchRange || !common.rangesEqual(source.fetchRange, activeRange))) {
        return fetchSource(source, activeRange, context);
    }
    return source;
}
function doesSourceIgnoreRange(source) {
    return Boolean(getResourceSourceDef(source.sourceDefId).ignoreRange);
}
function fetchSource(source, fetchRange, context) {
    var sourceDef = getResourceSourceDef(source.sourceDefId);
    var fetchId = common.guid();
    sourceDef.fetch({
        resourceSource: source,
        range: fetchRange,
        context: context,
    }, function (res) {
        context.dispatch({
            type: 'RECEIVE_RESOURCES',
            fetchId: fetchId,
            fetchRange: fetchRange,
            rawResources: res.rawResources,
        });
    }, function (error) {
        context.dispatch({
            type: 'RECEIVE_RESOURCE_ERROR',
            fetchId: fetchId,
            fetchRange: fetchRange,
            error: error,
        });
    });
    return tslib.__assign(tslib.__assign({}, source), { isFetching: true, latestFetchId: fetchId });
}
function receiveResponse(source, fetchId, fetchRange) {
    if (fetchId === source.latestFetchId) {
        return tslib.__assign(tslib.__assign({}, source), { isFetching: false, fetchRange: fetchRange });
    }
    return source;
}

var PRIVATE_ID_PREFIX = '_fc:';
var RESOURCE_REFINERS = {
    id: String,
    parentId: String,
    children: common.identity,
    title: String,
    businessHours: common.identity,
    extendedProps: common.identity,
    // event-ui
    eventEditable: Boolean,
    eventStartEditable: Boolean,
    eventDurationEditable: Boolean,
    eventConstraint: common.identity,
    eventOverlap: Boolean,
    eventAllow: common.identity,
    eventClassNames: common.parseClassNames,
    eventBackgroundColor: String,
    eventBorderColor: String,
    eventTextColor: String,
    eventColor: String,
};
/*
needs a full store so that it can populate children too
*/
function parseResource(raw, parentId, store, context) {
    if (parentId === void 0) { parentId = ''; }
    var _a = common.refineProps(raw, RESOURCE_REFINERS), refined = _a.refined, extra = _a.extra;
    var resource = {
        id: refined.id || (PRIVATE_ID_PREFIX + common.guid()),
        parentId: refined.parentId || parentId,
        title: refined.title || '',
        businessHours: refined.businessHours ? common.parseBusinessHours(refined.businessHours, context) : null,
        ui: common.createEventUi({
            editable: refined.eventEditable,
            startEditable: refined.eventStartEditable,
            durationEditable: refined.eventDurationEditable,
            constraint: refined.eventConstraint,
            overlap: refined.eventOverlap,
            allow: refined.eventAllow,
            classNames: refined.eventClassNames,
            backgroundColor: refined.eventBackgroundColor,
            borderColor: refined.eventBorderColor,
            textColor: refined.eventTextColor,
            color: refined.eventColor,
        }, context),
        extendedProps: tslib.__assign(tslib.__assign({}, extra), refined.extendedProps),
    };
    // help out ResourceApi from having user modify props
    Object.freeze(resource.ui.classNames);
    Object.freeze(resource.extendedProps);
    if (store[resource.id]) ;
    else {
        store[resource.id] = resource;
        if (refined.children) {
            for (var _i = 0, _b = refined.children; _i < _b.length; _i++) {
                var childInput = _b[_i];
                parseResource(childInput, resource.id, store, context);
            }
        }
    }
    return resource;
}
/*
TODO: use this in more places
*/
function getPublicId(id) {
    if (id.indexOf(PRIVATE_ID_PREFIX) === 0) {
        return '';
    }
    return id;
}

function reduceResourceStore(store, action, source, context) {
    if (!store || !action) {
        return {};
    }
    switch (action.type) {
        case 'RECEIVE_RESOURCES':
            return receiveRawResources(store, action.rawResources, action.fetchId, source, context);
        case 'ADD_RESOURCE':
            return addResource(store, action.resourceHash);
        case 'REMOVE_RESOURCE':
            return removeResource(store, action.resourceId);
        case 'SET_RESOURCE_PROP':
            return setResourceProp(store, action.resourceId, action.propName, action.propValue);
        case 'SET_RESOURCE_EXTENDED_PROP':
            return setResourceExtendedProp(store, action.resourceId, action.propName, action.propValue);
        default:
            return store;
    }
}
function receiveRawResources(existingStore, inputs, fetchId, source, context) {
    if (source.latestFetchId === fetchId) {
        var nextStore = {};
        for (var _i = 0, inputs_1 = inputs; _i < inputs_1.length; _i++) {
            var input = inputs_1[_i];
            parseResource(input, '', nextStore, context);
        }
        return nextStore;
    }
    return existingStore;
}
function addResource(existingStore, additions) {
    // TODO: warn about duplicate IDs
    return tslib.__assign(tslib.__assign({}, existingStore), additions);
}
function removeResource(existingStore, resourceId) {
    var newStore = tslib.__assign({}, existingStore);
    delete newStore[resourceId];
    // promote children
    for (var childResourceId in newStore) { // a child, *maybe* but probably not
        if (newStore[childResourceId].parentId === resourceId) {
            newStore[childResourceId] = tslib.__assign(tslib.__assign({}, newStore[childResourceId]), { parentId: '' });
        }
    }
    return newStore;
}
function setResourceProp(existingStore, resourceId, name, value) {
    var _a, _b;
    var existingResource = existingStore[resourceId];
    // TODO: sanitization
    if (existingResource) {
        return tslib.__assign(tslib.__assign({}, existingStore), (_a = {}, _a[resourceId] = tslib.__assign(tslib.__assign({}, existingResource), (_b = {}, _b[name] = value, _b)), _a));
    }
    return existingStore;
}
function setResourceExtendedProp(existingStore, resourceId, name, value) {
    var _a, _b;
    var existingResource = existingStore[resourceId];
    if (existingResource) {
        return tslib.__assign(tslib.__assign({}, existingStore), (_a = {}, _a[resourceId] = tslib.__assign(tslib.__assign({}, existingResource), { extendedProps: tslib.__assign(tslib.__assign({}, existingResource.extendedProps), (_b = {}, _b[name] = value, _b)) }), _a));
    }
    return existingStore;
}

function reduceResourceEntityExpansions(expansions, action) {
    var _a;
    if (!expansions || !action) {
        return {};
    }
    switch (action.type) {
        case 'SET_RESOURCE_ENTITY_EXPANDED':
            return tslib.__assign(tslib.__assign({}, expansions), (_a = {}, _a[action.id] = action.isExpanded, _a));
        default:
            return expansions;
    }
}

function reduceResources(state, action, context) {
    var resourceSource = reduceResourceSource(state && state.resourceSource, action, context);
    var resourceStore = reduceResourceStore(state && state.resourceStore, action, resourceSource, context);
    var resourceEntityExpansions = reduceResourceEntityExpansions(state && state.resourceEntityExpansions, action);
    return {
        resourceSource: resourceSource,
        resourceStore: resourceStore,
        resourceEntityExpansions: resourceEntityExpansions,
    };
}

var EVENT_REFINERS = {
    resourceId: String,
    resourceIds: common.identity,
    resourceEditable: Boolean,
};
function generateEventDefResourceMembers(refined) {
    return {
        resourceIds: ensureStringArray(refined.resourceIds)
            .concat(refined.resourceId ? [refined.resourceId] : []),
        resourceEditable: refined.resourceEditable,
    };
}
function ensureStringArray(items) {
    return (items || []).map(function (item) { return String(item); });
}

function transformDateSelectionJoin(hit0, hit1) {
    var resourceId0 = hit0.dateSpan.resourceId;
    var resourceId1 = hit1.dateSpan.resourceId;
    if (resourceId0 && resourceId1) {
        return { resourceId: resourceId0 };
    }
    return null;
}

var ResourceApi = /** @class */ (function () {
    function ResourceApi(_context, _resource) {
        this._context = _context;
        this._resource = _resource;
    }
    ResourceApi.prototype.setProp = function (name, value) {
        var oldResource = this._resource;
        this._context.dispatch({
            type: 'SET_RESOURCE_PROP',
            resourceId: oldResource.id,
            propName: name,
            propValue: value,
        });
        this.sync(oldResource);
    };
    ResourceApi.prototype.setExtendedProp = function (name, value) {
        var oldResource = this._resource;
        this._context.dispatch({
            type: 'SET_RESOURCE_EXTENDED_PROP',
            resourceId: oldResource.id,
            propName: name,
            propValue: value,
        });
        this.sync(oldResource);
    };
    ResourceApi.prototype.sync = function (oldResource) {
        var context = this._context;
        var resourceId = oldResource.id;
        // TODO: what if dispatch didn't complete synchronously?
        this._resource = context.getCurrentData().resourceStore[resourceId];
        context.emitter.trigger('resourceChange', {
            oldResource: new ResourceApi(context, oldResource),
            resource: this,
            revert: function () {
                var _a;
                context.dispatch({
                    type: 'ADD_RESOURCE',
                    resourceHash: (_a = {},
                        _a[resourceId] = oldResource,
                        _a),
                });
            },
        });
    };
    ResourceApi.prototype.remove = function () {
        var context = this._context;
        var internalResource = this._resource;
        var resourceId = internalResource.id;
        context.dispatch({
            type: 'REMOVE_RESOURCE',
            resourceId: resourceId,
        });
        context.emitter.trigger('resourceRemove', {
            resource: this,
            revert: function () {
                var _a;
                context.dispatch({
                    type: 'ADD_RESOURCE',
                    resourceHash: (_a = {},
                        _a[resourceId] = internalResource,
                        _a),
                });
            },
        });
    };
    ResourceApi.prototype.getParent = function () {
        var context = this._context;
        var parentId = this._resource.parentId;
        if (parentId) {
            return new ResourceApi(context, context.getCurrentData().resourceSource[parentId]);
        }
        return null;
    };
    ResourceApi.prototype.getChildren = function () {
        var thisResourceId = this._resource.id;
        var context = this._context;
        var resourceStore = context.getCurrentData().resourceStore;
        var childApis = [];
        for (var resourceId in resourceStore) {
            if (resourceStore[resourceId].parentId === thisResourceId) {
                childApis.push(new ResourceApi(context, resourceStore[resourceId]));
            }
        }
        return childApis;
    };
    /*
    this is really inefficient!
    TODO: make EventApi::resourceIds a hash or keep an index in the Calendar's state
    */
    ResourceApi.prototype.getEvents = function () {
        var thisResourceId = this._resource.id;
        var context = this._context;
        var _a = context.getCurrentData().eventStore, defs = _a.defs, instances = _a.instances;
        var eventApis = [];
        for (var instanceId in instances) {
            var instance = instances[instanceId];
            var def = defs[instance.defId];
            if (def.resourceIds.indexOf(thisResourceId) !== -1) { // inefficient!!!
                eventApis.push(new common.EventApi(context, def, instance));
            }
        }
        return eventApis;
    };
    Object.defineProperty(ResourceApi.prototype, "id", {
        get: function () { return getPublicId(this._resource.id); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ResourceApi.prototype, "title", {
        get: function () { return this._resource.title; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ResourceApi.prototype, "eventConstraint", {
        get: function () { return this._resource.ui.constraints[0] || null; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ResourceApi.prototype, "eventOverlap", {
        get: function () { return this._resource.ui.overlap; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ResourceApi.prototype, "eventAllow", {
        get: function () { return this._resource.ui.allows[0] || null; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ResourceApi.prototype, "eventBackgroundColor", {
        get: function () { return this._resource.ui.backgroundColor; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ResourceApi.prototype, "eventBorderColor", {
        get: function () { return this._resource.ui.borderColor; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ResourceApi.prototype, "eventTextColor", {
        get: function () { return this._resource.ui.textColor; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ResourceApi.prototype, "eventClassNames", {
        // NOTE: user can't modify these because Object.freeze was called in event-def parsing
        get: function () { return this._resource.ui.classNames; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ResourceApi.prototype, "extendedProps", {
        get: function () { return this._resource.extendedProps; },
        enumerable: false,
        configurable: true
    });
    ResourceApi.prototype.toPlainObject = function (settings) {
        if (settings === void 0) { settings = {}; }
        var internal = this._resource;
        var ui = internal.ui;
        var publicId = this.id;
        var res = {};
        if (publicId) {
            res.id = publicId;
        }
        if (internal.title) {
            res.title = internal.title;
        }
        if (settings.collapseEventColor && ui.backgroundColor && ui.backgroundColor === ui.borderColor) {
            res.eventColor = ui.backgroundColor;
        }
        else {
            if (ui.backgroundColor) {
                res.eventBackgroundColor = ui.backgroundColor;
            }
            if (ui.borderColor) {
                res.eventBorderColor = ui.borderColor;
            }
        }
        if (ui.textColor) {
            res.eventTextColor = ui.textColor;
        }
        if (ui.classNames.length) {
            res.eventClassNames = ui.classNames;
        }
        if (Object.keys(internal.extendedProps).length) {
            if (settings.collapseExtendedProps) {
                tslib.__assign(res, internal.extendedProps);
            }
            else {
                res.extendedProps = internal.extendedProps;
            }
        }
        return res;
    };
    ResourceApi.prototype.toJSON = function () {
        return this.toPlainObject();
    };
    return ResourceApi;
}());
function buildResourceApis(resourceStore, context) {
    var resourceApis = [];
    for (var resourceId in resourceStore) {
        resourceApis.push(new ResourceApi(context, resourceStore[resourceId]));
    }
    return resourceApis;
}

common.CalendarApi.prototype.addResource = function (input, scrollTo) {
    var _a;
    var _this = this;
    if (scrollTo === void 0) { scrollTo = true; }
    var currentState = this.getCurrentData();
    var resourceHash;
    var resource;
    if (input instanceof ResourceApi) {
        resource = input._resource;
        resourceHash = (_a = {}, _a[resource.id] = resource, _a);
    }
    else {
        resourceHash = {};
        resource = parseResource(input, '', resourceHash, currentState);
    }
    this.dispatch({
        type: 'ADD_RESOURCE',
        resourceHash: resourceHash,
    });
    if (scrollTo) {
        // TODO: wait til dispatch completes somehow
        this.trigger('_scrollRequest', { resourceId: resource.id });
    }
    var resourceApi = new ResourceApi(currentState, resource);
    currentState.emitter.trigger('resourceAdd', {
        resource: resourceApi,
        revert: function () {
            _this.dispatch({
                type: 'REMOVE_RESOURCE',
                resourceId: resource.id,
            });
        },
    });
    return resourceApi;
};
common.CalendarApi.prototype.getResourceById = function (id) {
    id = String(id);
    var currentState = this.getCurrentData(); // eslint-disable-line react/no-this-in-sfc
    if (currentState.resourceStore) { // guard against calendar with no resource functionality
        var rawResource = currentState.resourceStore[id];
        if (rawResource) {
            return new ResourceApi(currentState, rawResource);
        }
    }
    return null;
};
common.CalendarApi.prototype.getResources = function () {
    var currentState = this.getCurrentData();
    var resourceStore = currentState.resourceStore;
    var resourceApis = [];
    if (resourceStore) { // guard against calendar with no resource functionality
        for (var resourceId in resourceStore) {
            resourceApis.push(new ResourceApi(currentState, resourceStore[resourceId]));
        }
    }
    return resourceApis;
};
common.CalendarApi.prototype.getTopLevelResources = function () {
    var currentState = this.getCurrentData();
    var resourceStore = currentState.resourceStore;
    var resourceApis = [];
    if (resourceStore) { // guard against calendar with no resource functionality
        for (var resourceId in resourceStore) {
            if (!resourceStore[resourceId].parentId) {
                resourceApis.push(new ResourceApi(currentState, resourceStore[resourceId]));
            }
        }
    }
    return resourceApis;
};
common.CalendarApi.prototype.refetchResources = function () {
    this.dispatch({
        type: 'REFETCH_RESOURCES',
    });
};
function transformDatePoint(dateSpan, context) {
    return dateSpan.resourceId ?
        { resource: context.calendarApi.getResourceById(dateSpan.resourceId) } :
        {};
}
function transformDateSpan(dateSpan, context) {
    return dateSpan.resourceId ?
        { resource: context.calendarApi.getResourceById(dateSpan.resourceId) } :
        {};
}

/*
splits things BASED OFF OF which resources they are associated with.
creates a '' entry which is when something has NO resource.
*/
var ResourceSplitter = /** @class */ (function (_super) {
    tslib.__extends(ResourceSplitter, _super);
    function ResourceSplitter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ResourceSplitter.prototype.getKeyInfo = function (props) {
        return tslib.__assign({ '': {} }, props.resourceStore);
    };
    ResourceSplitter.prototype.getKeysForDateSpan = function (dateSpan) {
        return [dateSpan.resourceId || ''];
    };
    ResourceSplitter.prototype.getKeysForEventDef = function (eventDef) {
        var resourceIds = eventDef.resourceIds;
        if (!resourceIds.length) {
            return [''];
        }
        return resourceIds;
    };
    return ResourceSplitter;
}(common.Splitter));

function isPropsValidWithResources(combinedProps, context) {
    var splitter = new ResourceSplitter();
    var sets = splitter.splitProps(tslib.__assign(tslib.__assign({}, combinedProps), { resourceStore: context.getCurrentData().resourceStore }));
    for (var resourceId in sets) {
        var props = sets[resourceId];
        // merge in event data from the non-resource segment
        if (resourceId && sets['']) { // current segment is not the non-resource one, and there IS a non-resource one
            props = tslib.__assign(tslib.__assign({}, props), { eventStore: common.mergeEventStores(sets[''].eventStore, props.eventStore), eventUiBases: tslib.__assign(tslib.__assign({}, sets[''].eventUiBases), props.eventUiBases) });
        }
        if (!common.isPropsValid(props, context, { resourceId: resourceId }, filterConfig.bind(null, resourceId))) {
            return false;
        }
    }
    return true;
}
function filterConfig(resourceId, config) {
    return tslib.__assign(tslib.__assign({}, config), { constraints: filterConstraints(resourceId, config.constraints) });
}
function filterConstraints(resourceId, constraints) {
    return constraints.map(function (constraint) {
        var defs = constraint.defs;
        if (defs) { // we are dealing with an EventStore
            // if any of the events define constraints to resources that are NOT this resource,
            // then this resource is unconditionally prohibited, which is what a `false` value does.
            for (var defId in defs) {
                var resourceIds = defs[defId].resourceIds;
                if (resourceIds.length && resourceIds.indexOf(resourceId) === -1) { // TODO: use a hash?!!! (for other reasons too)
                    return false;
                }
            }
        }
        return constraint;
    });
}

function transformExternalDef(dateSpan) {
    return dateSpan.resourceId ?
        { resourceId: dateSpan.resourceId } :
        {};
}

common.EventApi.prototype.getResources = function () {
    var calendarApi = this._context.calendarApi;
    return this._def.resourceIds.map(function (resourceId) { return calendarApi.getResourceById(resourceId); });
};
common.EventApi.prototype.setResources = function (resources) {
    var resourceIds = [];
    // massage resources -> resourceIds
    for (var _i = 0, resources_1 = resources; _i < resources_1.length; _i++) {
        var resource = resources_1[_i];
        var resourceId = null;
        if (typeof resource === 'string') {
            resourceId = resource;
        }
        else if (typeof resource === 'number') {
            resourceId = String(resource);
        }
        else if (resource instanceof ResourceApi) {
            resourceId = resource.id; // guaranteed to always have an ID. hmmm
        }
        else {
            console.warn('unknown resource type: ' + resource);
        }
        if (resourceId) {
            resourceIds.push(resourceId);
        }
    }
    this.mutate({
        standardProps: {
            resourceIds: resourceIds,
        },
    });
};

var optionChangeHandlers = {
    resources: handleResources,
};
function handleResources(newSourceInput, context) {
    var oldSourceInput = context.getCurrentData().resourceSource._raw;
    if (oldSourceInput !== newSourceInput) {
        context.dispatch({
            type: 'RESET_RESOURCE_SOURCE',
            resourceSourceInput: newSourceInput,
        });
    }
}

var DEFAULT_RESOURCE_ORDER = common.parseFieldSpecs('id,title');
function handleResourceStore(resourceStore, calendarData) {
    var emitter = calendarData.emitter;
    if (emitter.hasHandlers('resourcesSet')) {
        emitter.trigger('resourcesSet', buildResourceApis(resourceStore, calendarData));
    }
}

var OPTION_REFINERS = {
    initialResources: common.identity,
    resources: common.identity,
    eventResourceEditable: Boolean,
    refetchResourcesOnNavigate: Boolean,
    resourceOrder: common.parseFieldSpecs,
    filterResourcesWithEvents: Boolean,
    resourceGroupField: String,
    resourceAreaWidth: common.identity,
    resourceAreaColumns: common.identity,
    resourcesInitiallyExpanded: Boolean,
    datesAboveResources: Boolean,
    needsResourceData: Boolean,
    resourceAreaHeaderClassNames: common.identity,
    resourceAreaHeaderContent: common.identity,
    resourceAreaHeaderDidMount: common.identity,
    resourceAreaHeaderWillUnmount: common.identity,
    resourceGroupLabelClassNames: common.identity,
    resourceGroupLabelContent: common.identity,
    resourceGroupLabelDidMount: common.identity,
    resourceGroupLabelWillUnmount: common.identity,
    resourceLabelClassNames: common.identity,
    resourceLabelContent: common.identity,
    resourceLabelDidMount: common.identity,
    resourceLabelWillUnmount: common.identity,
    resourceLaneClassNames: common.identity,
    resourceLaneContent: common.identity,
    resourceLaneDidMount: common.identity,
    resourceLaneWillUnmount: common.identity,
    resourceGroupLaneClassNames: common.identity,
    resourceGroupLaneContent: common.identity,
    resourceGroupLaneDidMount: common.identity,
    resourceGroupLaneWillUnmount: common.identity,
};
var LISTENER_REFINERS = {
    resourcesSet: common.identity,
    resourceAdd: common.identity,
    resourceChange: common.identity,
    resourceRemove: common.identity,
};

registerResourceSourceDef({
    ignoreRange: true,
    parseMeta: function (refined) {
        if (Array.isArray(refined.resources)) {
            return refined.resources;
        }
        return null;
    },
    fetch: function (arg, successCallback) {
        successCallback({
            rawResources: arg.resourceSource.meta,
        });
    },
});

registerResourceSourceDef({
    parseMeta: function (refined) {
        if (typeof refined.resources === 'function') {
            return refined.resources;
        }
        return null;
    },
    fetch: function (arg, success, failure) {
        var dateEnv = arg.context.dateEnv;
        var func = arg.resourceSource.meta;
        var publicArg = arg.range ? {
            start: dateEnv.toDate(arg.range.start),
            end: dateEnv.toDate(arg.range.end),
            startStr: dateEnv.formatIso(arg.range.start),
            endStr: dateEnv.formatIso(arg.range.end),
            timeZone: dateEnv.timeZone,
        } : {};
        // TODO: make more dry with EventSourceFunc
        // TODO: accept a response?
        common.unpromisify(func.bind(null, publicArg), function (rawResources) {
            success({ rawResources: rawResources }); // needs an object response
        }, failure);
    },
});

registerResourceSourceDef({
    parseMeta: function (refined) {
        if (refined.url) {
            return {
                url: refined.url,
                method: (refined.method || 'GET').toUpperCase(),
                extraParams: refined.extraParams,
            };
        }
        return null;
    },
    fetch: function (arg, successCallback, failureCallback) {
        var meta = arg.resourceSource.meta;
        var requestParams = buildRequestParams(meta, arg.range, arg.context);
        common.requestJson(meta.method, meta.url, requestParams, function (rawResources, xhr) {
            successCallback({ rawResources: rawResources, xhr: xhr });
        }, function (message, xhr) {
            failureCallback({ message: message, xhr: xhr });
        });
    },
});
// TODO: somehow consolidate with event json feed
function buildRequestParams(meta, range, context) {
    var dateEnv = context.dateEnv, options = context.options;
    var startParam;
    var endParam;
    var timeZoneParam;
    var customRequestParams;
    var params = {};
    if (range) {
        startParam = meta.startParam;
        if (startParam == null) {
            startParam = options.startParam;
        }
        endParam = meta.endParam;
        if (endParam == null) {
            endParam = options.endParam;
        }
        timeZoneParam = meta.timeZoneParam;
        if (timeZoneParam == null) {
            timeZoneParam = options.timeZoneParam;
        }
        params[startParam] = dateEnv.formatIso(range.start);
        params[endParam] = dateEnv.formatIso(range.end);
        if (dateEnv.timeZone !== 'local') {
            params[timeZoneParam] = dateEnv.timeZone;
        }
    }
    // retrieve any outbound GET/POST data from the options
    if (typeof meta.extraParams === 'function') {
        // supplied as a function that returns a key/value object
        customRequestParams = meta.extraParams();
    }
    else {
        // probably supplied as a straight key/value object
        customRequestParams = meta.extraParams || {};
    }
    tslib.__assign(params, customRequestParams);
    return params;
}

// TODO: not used for Spreadsheet. START USING. difficult because of col-specific rendering props
function ResourceLabelRoot(props) {
    return (common.createElement(common.ViewContextType.Consumer, null, function (context) {
        var options = context.options;
        var hookProps = {
            resource: new ResourceApi(context, props.resource),
            date: props.date ? context.dateEnv.toDate(props.date) : null,
            view: context.viewApi,
        };
        var dataAttrs = {
            'data-resource-id': props.resource.id,
            'data-date': props.date ? common.formatDayString(props.date) : undefined,
        };
        return (common.createElement(common.RenderHook, { hookProps: hookProps, classNames: options.resourceLabelClassNames, content: options.resourceLabelContent, defaultContent: renderInnerContent, didMount: options.resourceLabelDidMount, willUnmount: options.resourceLabelWillUnmount }, function (rootElRef, classNames, innerElRef, innerContent) { return props.children(rootElRef, classNames, // TODO: pass in 'fc-resource' ?
        dataAttrs, innerElRef, innerContent); }));
    }));
}
function renderInnerContent(props) {
    return props.resource.title || props.resource.id;
}

var ResourceCell = /** @class */ (function (_super) {
    tslib.__extends(ResourceCell, _super);
    function ResourceCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ResourceCell.prototype.render = function () {
        var props = this.props;
        return (common.createElement(ResourceLabelRoot, { resource: props.resource, date: props.date }, function (elRef, customClassNames, dataAttrs, innerElRef, innerContent) { return (common.createElement("th", tslib.__assign({ ref: elRef, className: ['fc-col-header-cell', 'fc-resource'].concat(customClassNames).join(' '), colSpan: props.colSpan }, dataAttrs),
            common.createElement("div", { className: "fc-scrollgrid-sync-inner" },
                common.createElement("span", { className: [
                        'fc-col-header-cell-cushion',
                        props.isSticky ? 'fc-sticky' : '',
                    ].join(' '), ref: innerElRef }, innerContent)))); }));
    };
    return ResourceCell;
}(common.BaseComponent));

var ResourceDayHeader = /** @class */ (function (_super) {
    tslib.__extends(ResourceDayHeader, _super);
    function ResourceDayHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.buildDateFormat = common.memoize(buildDateFormat);
        return _this;
    }
    ResourceDayHeader.prototype.render = function () {
        var _this = this;
        var _a = this, props = _a.props, context = _a.context;
        var dateFormat = this.buildDateFormat(context.options.dayHeaderFormat, props.datesRepDistinctDays, props.dates.length);
        return (common.createElement(common.NowTimer, { unit: "day" }, function (nowDate, todayRange) {
            if (props.dates.length === 1) {
                return _this.renderResourceRow(props.resources, props.dates[0]);
            }
            if (context.options.datesAboveResources) {
                return _this.renderDayAndResourceRows(props.dates, dateFormat, todayRange, props.resources);
            }
            return _this.renderResourceAndDayRows(props.resources, props.dates, dateFormat, todayRange);
        }));
    };
    ResourceDayHeader.prototype.renderResourceRow = function (resources, date) {
        var resourceCells = resources.map(function (resource) { return (common.createElement(ResourceCell, { key: resource.id, resource: resource, colSpan: 1, date: date })); });
        return this.buildTr(resourceCells, 'resources');
    };
    ResourceDayHeader.prototype.renderDayAndResourceRows = function (dates, dateFormat, todayRange, resources) {
        var dateCells = [];
        var resourceCells = [];
        for (var _i = 0, dates_1 = dates; _i < dates_1.length; _i++) {
            var date = dates_1[_i];
            dateCells.push(this.renderDateCell(date, dateFormat, todayRange, resources.length, null, true));
            for (var _a = 0, resources_1 = resources; _a < resources_1.length; _a++) {
                var resource = resources_1[_a];
                resourceCells.push(common.createElement(ResourceCell, { key: resource.id + ':' + date.toISOString(), resource: resource, colSpan: 1, date: date }));
            }
        }
        return (common.createElement(common.Fragment, null,
            this.buildTr(dateCells, 'day'),
            this.buildTr(resourceCells, 'resources')));
    };
    ResourceDayHeader.prototype.renderResourceAndDayRows = function (resources, dates, dateFormat, todayRange) {
        var resourceCells = [];
        var dateCells = [];
        for (var _i = 0, resources_2 = resources; _i < resources_2.length; _i++) {
            var resource = resources_2[_i];
            resourceCells.push(common.createElement(ResourceCell, { key: resource.id, resource: resource, colSpan: dates.length, isSticky: true }));
            for (var _a = 0, dates_2 = dates; _a < dates_2.length; _a++) {
                var date = dates_2[_a];
                dateCells.push(this.renderDateCell(date, dateFormat, todayRange, 1, resource));
            }
        }
        return (common.createElement(common.Fragment, null,
            this.buildTr(resourceCells, 'resources'),
            this.buildTr(dateCells, 'day')));
    };
    // a cell with date text. might have a resource associated with it
    ResourceDayHeader.prototype.renderDateCell = function (date, dateFormat, todayRange, colSpan, resource, isSticky) {
        var props = this.props;
        var keyPostfix = resource ? ":" + resource.id : '';
        var extraHookProps = resource ? { resource: new ResourceApi(this.context, resource) } : {};
        var extraDataAttrs = resource ? { 'data-resource-id': resource.id } : {};
        return props.datesRepDistinctDays ? (common.createElement(common.TableDateCell, { key: date.toISOString() + keyPostfix, date: date, dateProfile: props.dateProfile, todayRange: todayRange, colCnt: props.dates.length * props.resources.length, dayHeaderFormat: dateFormat, colSpan: colSpan, isSticky: isSticky, extraHookProps: extraHookProps, extraDataAttrs: extraDataAttrs })) : (common.createElement(common.TableDowCell // we can't leverage the pure-componentness becausae the extra* props are new every time :(
        , { key: date.getUTCDay() + keyPostfix, dow: date.getUTCDay(), dayHeaderFormat: dateFormat, colSpan: colSpan, isSticky: isSticky, extraHookProps: extraHookProps, extraDataAttrs: extraDataAttrs }));
    };
    ResourceDayHeader.prototype.buildTr = function (cells, key) {
        var renderIntro = this.props.renderIntro;
        if (!cells.length) {
            cells = [common.createElement("td", { key: 0 }, "\u00A0")];
        }
        return (common.createElement("tr", { key: key },
            renderIntro && renderIntro(key),
            cells));
    };
    return ResourceDayHeader;
}(common.BaseComponent));
function buildDateFormat(dayHeaderFormat, datesRepDistinctDays, dayCnt) {
    return dayHeaderFormat || common.computeFallbackHeaderFormat(datesRepDistinctDays, dayCnt);
}

var ResourceIndex = /** @class */ (function () {
    function ResourceIndex(resources) {
        var indicesById = {};
        var ids = [];
        for (var i = 0; i < resources.length; i += 1) {
            var id = resources[i].id;
            ids.push(id);
            indicesById[id] = i;
        }
        this.ids = ids;
        this.indicesById = indicesById;
        this.length = resources.length;
    }
    return ResourceIndex;
}());

var AbstractResourceDayTableModel = /** @class */ (function () {
    function AbstractResourceDayTableModel(dayTableModel, resources, context) {
        this.dayTableModel = dayTableModel;
        this.resources = resources;
        this.context = context;
        this.resourceIndex = new ResourceIndex(resources);
        this.rowCnt = dayTableModel.rowCnt;
        this.colCnt = dayTableModel.colCnt * resources.length;
        this.cells = this.buildCells();
    }
    AbstractResourceDayTableModel.prototype.buildCells = function () {
        var _a = this, rowCnt = _a.rowCnt, dayTableModel = _a.dayTableModel, resources = _a.resources;
        var rows = [];
        for (var row = 0; row < rowCnt; row += 1) {
            var rowCells = [];
            for (var dateCol = 0; dateCol < dayTableModel.colCnt; dateCol += 1) {
                for (var resourceCol = 0; resourceCol < resources.length; resourceCol += 1) {
                    var resource = resources[resourceCol];
                    var extraHookProps = { resource: new ResourceApi(this.context, resource) };
                    var extraDataAttrs = { 'data-resource-id': resource.id };
                    var extraClassNames = ['fc-resource'];
                    var extraDateSpan = { resourceId: resource.id };
                    var date = dayTableModel.cells[row][dateCol].date;
                    rowCells[this.computeCol(dateCol, resourceCol)] = {
                        key: resource.id + ':' + date.toISOString(),
                        date: date,
                        extraHookProps: extraHookProps,
                        extraDataAttrs: extraDataAttrs,
                        extraClassNames: extraClassNames,
                        extraDateSpan: extraDateSpan,
                    };
                }
            }
            rows.push(rowCells);
        }
        return rows;
    };
    return AbstractResourceDayTableModel;
}());

/*
resources over dates
*/
var ResourceDayTableModel = /** @class */ (function (_super) {
    tslib.__extends(ResourceDayTableModel, _super);
    function ResourceDayTableModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ResourceDayTableModel.prototype.computeCol = function (dateI, resourceI) {
        return resourceI * this.dayTableModel.colCnt + dateI;
    };
    /*
    all date ranges are intact
    */
    ResourceDayTableModel.prototype.computeColRanges = function (dateStartI, dateEndI, resourceI) {
        return [
            {
                firstCol: this.computeCol(dateStartI, resourceI),
                lastCol: this.computeCol(dateEndI, resourceI),
                isStart: true,
                isEnd: true,
            },
        ];
    };
    return ResourceDayTableModel;
}(AbstractResourceDayTableModel));

/*
dates over resources
*/
var DayResourceTableModel = /** @class */ (function (_super) {
    tslib.__extends(DayResourceTableModel, _super);
    function DayResourceTableModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DayResourceTableModel.prototype.computeCol = function (dateI, resourceI) {
        return dateI * this.resources.length + resourceI;
    };
    /*
    every single day is broken up
    */
    DayResourceTableModel.prototype.computeColRanges = function (dateStartI, dateEndI, resourceI) {
        var segs = [];
        for (var i = dateStartI; i <= dateEndI; i += 1) {
            var col = this.computeCol(i, resourceI);
            segs.push({
                firstCol: col,
                lastCol: col,
                isStart: i === dateStartI,
                isEnd: i === dateEndI,
            });
        }
        return segs;
    };
    return DayResourceTableModel;
}(AbstractResourceDayTableModel));

var NO_SEGS = []; // for memoizing
var VResourceJoiner = /** @class */ (function () {
    function VResourceJoiner() {
        this.joinDateSelection = common.memoize(this.joinSegs);
        this.joinBusinessHours = common.memoize(this.joinSegs);
        this.joinFgEvents = common.memoize(this.joinSegs);
        this.joinBgEvents = common.memoize(this.joinSegs);
        this.joinEventDrags = common.memoize(this.joinInteractions);
        this.joinEventResizes = common.memoize(this.joinInteractions);
    }
    /*
    propSets also has a '' key for things with no resource
    */
    VResourceJoiner.prototype.joinProps = function (propSets, resourceDayTable) {
        var dateSelectionSets = [];
        var businessHoursSets = [];
        var fgEventSets = [];
        var bgEventSets = [];
        var eventDrags = [];
        var eventResizes = [];
        var eventSelection = '';
        var keys = resourceDayTable.resourceIndex.ids.concat(['']); // add in the all-resource key
        for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
            var key = keys_1[_i];
            var props = propSets[key];
            dateSelectionSets.push(props.dateSelectionSegs);
            businessHoursSets.push(key ? props.businessHourSegs : NO_SEGS); // don't include redundant all-resource businesshours
            fgEventSets.push(key ? props.fgEventSegs : NO_SEGS); // don't include fg all-resource segs
            bgEventSets.push(props.bgEventSegs);
            eventDrags.push(props.eventDrag);
            eventResizes.push(props.eventResize);
            eventSelection = eventSelection || props.eventSelection;
        }
        return {
            dateSelectionSegs: this.joinDateSelection.apply(this, tslib.__spreadArray([resourceDayTable], dateSelectionSets)),
            businessHourSegs: this.joinBusinessHours.apply(this, tslib.__spreadArray([resourceDayTable], businessHoursSets)),
            fgEventSegs: this.joinFgEvents.apply(this, tslib.__spreadArray([resourceDayTable], fgEventSets)),
            bgEventSegs: this.joinBgEvents.apply(this, tslib.__spreadArray([resourceDayTable], bgEventSets)),
            eventDrag: this.joinEventDrags.apply(this, tslib.__spreadArray([resourceDayTable], eventDrags)),
            eventResize: this.joinEventResizes.apply(this, tslib.__spreadArray([resourceDayTable], eventResizes)),
            eventSelection: eventSelection,
        };
    };
    VResourceJoiner.prototype.joinSegs = function (resourceDayTable) {
        var segGroups = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            segGroups[_i - 1] = arguments[_i];
        }
        var resourceCnt = resourceDayTable.resources.length;
        var transformedSegs = [];
        for (var i = 0; i < resourceCnt; i += 1) {
            for (var _a = 0, _b = segGroups[i]; _a < _b.length; _a++) {
                var seg = _b[_a];
                transformedSegs.push.apply(transformedSegs, this.transformSeg(seg, resourceDayTable, i));
            }
            for (var _c = 0, _d = segGroups[resourceCnt]; _c < _d.length; _c++) { // one beyond. the all-resource
                var seg = _d[_c];
                transformedSegs.push.apply(// one beyond. the all-resource
                transformedSegs, this.transformSeg(seg, resourceDayTable, i));
            }
        }
        return transformedSegs;
    };
    /*
    for expanding non-resource segs to all resources.
    only for public use.
    no memoizing.
    */
    VResourceJoiner.prototype.expandSegs = function (resourceDayTable, segs) {
        var resourceCnt = resourceDayTable.resources.length;
        var transformedSegs = [];
        for (var i = 0; i < resourceCnt; i += 1) {
            for (var _i = 0, segs_1 = segs; _i < segs_1.length; _i++) {
                var seg = segs_1[_i];
                transformedSegs.push.apply(transformedSegs, this.transformSeg(seg, resourceDayTable, i));
            }
        }
        return transformedSegs;
    };
    VResourceJoiner.prototype.joinInteractions = function (resourceDayTable) {
        var interactions = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            interactions[_i - 1] = arguments[_i];
        }
        var resourceCnt = resourceDayTable.resources.length;
        var affectedInstances = {};
        var transformedSegs = [];
        var anyInteractions = false;
        var isEvent = false;
        for (var i = 0; i < resourceCnt; i += 1) {
            var interaction = interactions[i];
            if (interaction) {
                anyInteractions = true;
                for (var _a = 0, _b = interaction.segs; _a < _b.length; _a++) {
                    var seg = _b[_a];
                    transformedSegs.push.apply(transformedSegs, this.transformSeg(seg, resourceDayTable, i));
                }
                tslib.__assign(affectedInstances, interaction.affectedInstances);
                isEvent = isEvent || interaction.isEvent;
            }
            if (interactions[resourceCnt]) { // one beyond. the all-resource
                for (var _c = 0, _d = interactions[resourceCnt].segs; _c < _d.length; _c++) {
                    var seg = _d[_c];
                    transformedSegs.push.apply(transformedSegs, this.transformSeg(seg, resourceDayTable, i));
                }
            }
        }
        if (anyInteractions) {
            return {
                affectedInstances: affectedInstances,
                segs: transformedSegs,
                isEvent: isEvent,
            };
        }
        return null;
    };
    return VResourceJoiner;
}());

/*
TODO: just use ResourceHash somehow? could then use the generic ResourceSplitter
*/
var VResourceSplitter = /** @class */ (function (_super) {
    tslib.__extends(VResourceSplitter, _super);
    function VResourceSplitter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VResourceSplitter.prototype.getKeyInfo = function (props) {
        var resourceDayTableModel = props.resourceDayTableModel;
        var hash = common.mapHash(resourceDayTableModel.resourceIndex.indicesById, function (i) { return resourceDayTableModel.resources[i]; }); // :(
        hash[''] = {};
        return hash;
    };
    VResourceSplitter.prototype.getKeysForDateSpan = function (dateSpan) {
        return [dateSpan.resourceId || ''];
    };
    VResourceSplitter.prototype.getKeysForEventDef = function (eventDef) {
        var resourceIds = eventDef.resourceIds;
        if (!resourceIds.length) {
            return [''];
        }
        return resourceIds;
    };
    return VResourceSplitter;
}(common.Splitter));

/*
doesn't accept grouping
*/
function flattenResources(resourceStore, orderSpecs) {
    return buildRowNodes(resourceStore, [], orderSpecs, false, {}, true)
        .map(function (node) { return node.resource; });
}
function buildRowNodes(resourceStore, groupSpecs, orderSpecs, isVGrouping, expansions, expansionDefault) {
    var complexNodes = buildHierarchy(resourceStore, isVGrouping ? -1 : 1, groupSpecs, orderSpecs);
    var flatNodes = [];
    flattenNodes(complexNodes, flatNodes, isVGrouping, [], 0, expansions, expansionDefault);
    return flatNodes;
}
function flattenNodes(complexNodes, res, isVGrouping, rowSpans, depth, expansions, expansionDefault) {
    for (var i = 0; i < complexNodes.length; i += 1) {
        var complexNode = complexNodes[i];
        var group = complexNode.group;
        if (group) {
            if (isVGrouping) {
                var firstRowIndex = res.length;
                var rowSpanIndex = rowSpans.length;
                flattenNodes(complexNode.children, res, isVGrouping, rowSpans.concat(0), depth, expansions, expansionDefault);
                if (firstRowIndex < res.length) {
                    var firstRow = res[firstRowIndex];
                    var firstRowSpans = firstRow.rowSpans = firstRow.rowSpans.slice();
                    firstRowSpans[rowSpanIndex] = res.length - firstRowIndex;
                }
            }
            else {
                var id = group.spec.field + ':' + group.value;
                var isExpanded = expansions[id] != null ? expansions[id] : expansionDefault;
                res.push({ id: id, group: group, isExpanded: isExpanded });
                if (isExpanded) {
                    flattenNodes(complexNode.children, res, isVGrouping, rowSpans, depth + 1, expansions, expansionDefault);
                }
            }
        }
        else if (complexNode.resource) {
            var id = complexNode.resource.id;
            var isExpanded = expansions[id] != null ? expansions[id] : expansionDefault;
            res.push({
                id: id,
                rowSpans: rowSpans,
                depth: depth,
                isExpanded: isExpanded,
                hasChildren: Boolean(complexNode.children.length),
                resource: complexNode.resource,
                resourceFields: complexNode.resourceFields,
            });
            if (isExpanded) {
                flattenNodes(complexNode.children, res, isVGrouping, rowSpans, depth + 1, expansions, expansionDefault);
            }
        }
    }
}
function buildHierarchy(resourceStore, maxDepth, groupSpecs, orderSpecs) {
    var resourceNodes = buildResourceNodes(resourceStore, orderSpecs);
    var builtNodes = [];
    for (var resourceId in resourceNodes) {
        var resourceNode = resourceNodes[resourceId];
        if (!resourceNode.resource.parentId) {
            insertResourceNode(resourceNode, builtNodes, groupSpecs, 0, maxDepth, orderSpecs);
        }
    }
    return builtNodes;
}
function buildResourceNodes(resourceStore, orderSpecs) {
    var nodeHash = {};
    for (var resourceId in resourceStore) {
        var resource = resourceStore[resourceId];
        nodeHash[resourceId] = {
            resource: resource,
            resourceFields: buildResourceFields(resource),
            children: [],
        };
    }
    for (var resourceId in resourceStore) {
        var resource = resourceStore[resourceId];
        if (resource.parentId) {
            var parentNode = nodeHash[resource.parentId];
            if (parentNode) {
                insertResourceNodeInSiblings(nodeHash[resourceId], parentNode.children, orderSpecs);
            }
        }
    }
    return nodeHash;
}
function insertResourceNode(resourceNode, nodes, groupSpecs, depth, maxDepth, orderSpecs) {
    if (groupSpecs.length && (maxDepth === -1 || depth <= maxDepth)) {
        var groupNode = ensureGroupNodes(resourceNode, nodes, groupSpecs[0]);
        insertResourceNode(resourceNode, groupNode.children, groupSpecs.slice(1), depth + 1, maxDepth, orderSpecs);
    }
    else {
        insertResourceNodeInSiblings(resourceNode, nodes, orderSpecs);
    }
}
function ensureGroupNodes(resourceNode, nodes, groupSpec) {
    var groupValue = resourceNode.resourceFields[groupSpec.field];
    var groupNode;
    var newGroupIndex;
    // find an existing group that matches, or determine the position for a new group
    if (groupSpec.order) {
        for (newGroupIndex = 0; newGroupIndex < nodes.length; newGroupIndex += 1) {
            var node = nodes[newGroupIndex];
            if (node.group) {
                var cmp = common.flexibleCompare(groupValue, node.group.value) * groupSpec.order;
                if (cmp === 0) {
                    groupNode = node;
                    break;
                }
                else if (cmp < 0) {
                    break;
                }
            }
        }
    }
    else { // the groups are unordered
        for (newGroupIndex = 0; newGroupIndex < nodes.length; newGroupIndex += 1) {
            var node = nodes[newGroupIndex];
            if (node.group && groupValue === node.group.value) {
                groupNode = node;
                break;
            }
        }
    }
    if (!groupNode) {
        groupNode = {
            group: {
                value: groupValue,
                spec: groupSpec,
            },
            children: [],
        };
        nodes.splice(newGroupIndex, 0, groupNode);
    }
    return groupNode;
}
function insertResourceNodeInSiblings(resourceNode, siblings, orderSpecs) {
    var i;
    for (i = 0; i < siblings.length; i += 1) {
        var cmp = common.compareByFieldSpecs(siblings[i].resourceFields, resourceNode.resourceFields, orderSpecs); // TODO: pass in ResourceApi?
        if (cmp > 0) { // went 1 past. insert at i
            break;
        }
    }
    siblings.splice(i, 0, resourceNode);
}
function buildResourceFields(resource) {
    var obj = tslib.__assign(tslib.__assign(tslib.__assign({}, resource.extendedProps), resource.ui), resource);
    delete obj.ui;
    delete obj.extendedProps;
    return obj;
}
function isGroupsEqual(group0, group1) {
    return group0.spec === group1.spec && group0.value === group1.value;
}

var main = common.createPlugin({
    deps: [
        premiumCommonPlugin__default['default'],
    ],
    reducers: [
        reduceResources,
    ],
    isLoadingFuncs: [
        function (state) { return state.resourceSource && state.resourceSource.isFetching; },
    ],
    eventRefiners: EVENT_REFINERS,
    eventDefMemberAdders: [generateEventDefResourceMembers],
    isDraggableTransformers: [transformIsDraggable],
    eventDragMutationMassagers: [massageEventDragMutation],
    eventDefMutationAppliers: [applyEventDefMutation],
    dateSelectionTransformers: [transformDateSelectionJoin],
    datePointTransforms: [transformDatePoint],
    dateSpanTransforms: [transformDateSpan],
    viewPropsTransformers: [ResourceDataAdder, ResourceEventConfigAdder],
    isPropsValid: isPropsValidWithResources,
    externalDefTransforms: [transformExternalDef],
    eventDropTransformers: [transformEventDrop],
    optionChangeHandlers: optionChangeHandlers,
    optionRefiners: OPTION_REFINERS,
    listenerRefiners: LISTENER_REFINERS,
    propSetHandlers: { resourceStore: handleResourceStore },
});

exports.AbstractResourceDayTableModel = AbstractResourceDayTableModel;
exports.DEFAULT_RESOURCE_ORDER = DEFAULT_RESOURCE_ORDER;
exports.DayResourceTableModel = DayResourceTableModel;
exports.ResourceApi = ResourceApi;
exports.ResourceDayHeader = ResourceDayHeader;
exports.ResourceDayTableModel = ResourceDayTableModel;
exports.ResourceLabelRoot = ResourceLabelRoot;
exports.ResourceSplitter = ResourceSplitter;
exports.VResourceJoiner = VResourceJoiner;
exports.VResourceSplitter = VResourceSplitter;
exports.buildResourceFields = buildResourceFields;
exports.buildRowNodes = buildRowNodes;
exports.default = main;
exports.flattenResources = flattenResources;
exports.getPublicId = getPublicId;
exports.isGroupsEqual = isGroupsEqual;

},{"@fullcalendar/common":3,"@fullcalendar/premium-common":10,"tslib":782}],12:[function(require,module,exports){
/*!
FullCalendar Scheduler v5.9.0
Docs & License: https://fullcalendar.io/scheduler
(c) 2021 Adam Shaw
*/
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var common = require('@fullcalendar/common');
var premiumCommonPlugin = require('@fullcalendar/premium-common');
var resourceCommonPlugin = require('@fullcalendar/resource-common');
var dayGridPlugin = require('@fullcalendar/daygrid');
var tslib = require('tslib');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var premiumCommonPlugin__default = /*#__PURE__*/_interopDefaultLegacy(premiumCommonPlugin);
var resourceCommonPlugin__default = /*#__PURE__*/_interopDefaultLegacy(resourceCommonPlugin);
var dayGridPlugin__default = /*#__PURE__*/_interopDefaultLegacy(dayGridPlugin);

var ResourceDayTableJoiner = /** @class */ (function (_super) {
    tslib.__extends(ResourceDayTableJoiner, _super);
    function ResourceDayTableJoiner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ResourceDayTableJoiner.prototype.transformSeg = function (seg, resourceDayTableModel, resourceI) {
        var colRanges = resourceDayTableModel.computeColRanges(seg.firstCol, seg.lastCol, resourceI);
        return colRanges.map(function (colRange) { return (tslib.__assign(tslib.__assign(tslib.__assign({}, seg), colRange), { isStart: seg.isStart && colRange.isStart, isEnd: seg.isEnd && colRange.isEnd })); });
    };
    return ResourceDayTableJoiner;
}(resourceCommonPlugin.VResourceJoiner));

var ResourceDayTable = /** @class */ (function (_super) {
    tslib.__extends(ResourceDayTable, _super);
    function ResourceDayTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.splitter = new resourceCommonPlugin.VResourceSplitter();
        _this.slicers = {};
        _this.joiner = new ResourceDayTableJoiner();
        _this.tableRef = common.createRef();
        _this.isHitComboAllowed = function (hit0, hit1) {
            var allowAcrossResources = _this.props.resourceDayTableModel.dayTableModel.colCnt === 1;
            return allowAcrossResources || hit0.dateSpan.resourceId === hit1.dateSpan.resourceId;
        };
        return _this;
    }
    ResourceDayTable.prototype.render = function () {
        var _this = this;
        var _a = this, props = _a.props, context = _a.context;
        var resourceDayTableModel = props.resourceDayTableModel, nextDayThreshold = props.nextDayThreshold, dateProfile = props.dateProfile;
        var splitProps = this.splitter.splitProps(props);
        this.slicers = common.mapHash(splitProps, function (split, resourceId) { return _this.slicers[resourceId] || new dayGridPlugin.DayTableSlicer(); });
        var slicedProps = common.mapHash(this.slicers, function (slicer, resourceId) { return slicer.sliceProps(splitProps[resourceId], dateProfile, nextDayThreshold, context, resourceDayTableModel.dayTableModel); });
        return (common.createElement(dayGridPlugin.Table, tslib.__assign({ forPrint: props.forPrint, ref: this.tableRef }, this.joiner.joinProps(slicedProps, resourceDayTableModel), { cells: resourceDayTableModel.cells, dateProfile: dateProfile, colGroupNode: props.colGroupNode, tableMinWidth: props.tableMinWidth, renderRowIntro: props.renderRowIntro, dayMaxEvents: props.dayMaxEvents, dayMaxEventRows: props.dayMaxEventRows, showWeekNumbers: props.showWeekNumbers, expandRows: props.expandRows, headerAlignElRef: props.headerAlignElRef, clientWidth: props.clientWidth, clientHeight: props.clientHeight, isHitComboAllowed: this.isHitComboAllowed })));
    };
    return ResourceDayTable;
}(common.DateComponent));

var ResourceDayTableView = /** @class */ (function (_super) {
    tslib.__extends(ResourceDayTableView, _super);
    function ResourceDayTableView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.flattenResources = common.memoize(resourceCommonPlugin.flattenResources);
        _this.buildResourceDayTableModel = common.memoize(buildResourceDayTableModel);
        _this.headerRef = common.createRef();
        _this.tableRef = common.createRef();
        return _this;
    }
    ResourceDayTableView.prototype.render = function () {
        var _this = this;
        var _a = this, props = _a.props, context = _a.context;
        var options = context.options;
        var resourceOrderSpecs = options.resourceOrder || resourceCommonPlugin.DEFAULT_RESOURCE_ORDER;
        var resources = this.flattenResources(props.resourceStore, resourceOrderSpecs);
        var resourceDayTableModel = this.buildResourceDayTableModel(props.dateProfile, context.dateProfileGenerator, resources, options.datesAboveResources, context);
        var headerContent = options.dayHeaders && (common.createElement(resourceCommonPlugin.ResourceDayHeader, { ref: this.headerRef, resources: resources, dateProfile: props.dateProfile, dates: resourceDayTableModel.dayTableModel.headerDates, datesRepDistinctDays: true }));
        var bodyContent = function (contentArg) { return (common.createElement(ResourceDayTable, { ref: _this.tableRef, dateProfile: props.dateProfile, resourceDayTableModel: resourceDayTableModel, businessHours: props.businessHours, eventStore: props.eventStore, eventUiBases: props.eventUiBases, dateSelection: props.dateSelection, eventSelection: props.eventSelection, eventDrag: props.eventDrag, eventResize: props.eventResize, nextDayThreshold: options.nextDayThreshold, tableMinWidth: contentArg.tableMinWidth, colGroupNode: contentArg.tableColGroupNode, dayMaxEvents: options.dayMaxEvents, dayMaxEventRows: options.dayMaxEventRows, showWeekNumbers: options.weekNumbers, expandRows: !props.isHeightAuto, headerAlignElRef: _this.headerElRef, clientWidth: contentArg.clientWidth, clientHeight: contentArg.clientHeight, forPrint: props.forPrint })); };
        return options.dayMinWidth
            ? this.renderHScrollLayout(headerContent, bodyContent, resourceDayTableModel.colCnt, options.dayMinWidth)
            : this.renderSimpleLayout(headerContent, bodyContent);
    };
    return ResourceDayTableView;
}(dayGridPlugin.TableView));
function buildResourceDayTableModel(dateProfile, dateProfileGenerator, resources, datesAboveResources, context) {
    var dayTable = dayGridPlugin.buildDayTableModel(dateProfile, dateProfileGenerator);
    return datesAboveResources ?
        new resourceCommonPlugin.DayResourceTableModel(dayTable, resources, context) :
        new resourceCommonPlugin.ResourceDayTableModel(dayTable, resources, context);
}

var main = common.createPlugin({
    deps: [
        premiumCommonPlugin__default['default'],
        resourceCommonPlugin__default['default'],
        dayGridPlugin__default['default'],
    ],
    initialView: 'resourceDayGridDay',
    views: {
        resourceDayGrid: {
            type: 'dayGrid',
            component: ResourceDayTableView,
            needsResourceData: true,
        },
        resourceDayGridDay: {
            type: 'resourceDayGrid',
            duration: { days: 1 },
        },
        resourceDayGridWeek: {
            type: 'resourceDayGrid',
            duration: { weeks: 1 },
        },
        resourceDayGridMonth: {
            type: 'resourceDayGrid',
            duration: { months: 1 },
            // TODO: wish we didn't have to C&P from dayGrid's file
            monthMode: true,
            fixedWeekCount: true,
        },
    },
});

exports.ResourceDayTable = ResourceDayTable;
exports.ResourceDayTableView = ResourceDayTableView;
exports.default = main;

},{"@fullcalendar/common":3,"@fullcalendar/daygrid":8,"@fullcalendar/premium-common":10,"@fullcalendar/resource-common":11,"tslib":782}],13:[function(require,module,exports){
/*!
FullCalendar Scheduler v5.9.0
Docs & License: https://fullcalendar.io/scheduler
(c) 2021 Adam Shaw
*/
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var common = require('@fullcalendar/common');
var premiumCommonPlugin = require('@fullcalendar/premium-common');
var resourceCommonPlugin = require('@fullcalendar/resource-common');
var timeGridPlugin = require('@fullcalendar/timegrid');
var tslib = require('tslib');
var resourceDaygrid = require('@fullcalendar/resource-daygrid');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var premiumCommonPlugin__default = /*#__PURE__*/_interopDefaultLegacy(premiumCommonPlugin);
var resourceCommonPlugin__default = /*#__PURE__*/_interopDefaultLegacy(resourceCommonPlugin);
var timeGridPlugin__default = /*#__PURE__*/_interopDefaultLegacy(timeGridPlugin);

var ResourceDayTimeColsJoiner = /** @class */ (function (_super) {
    tslib.__extends(ResourceDayTimeColsJoiner, _super);
    function ResourceDayTimeColsJoiner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ResourceDayTimeColsJoiner.prototype.transformSeg = function (seg, resourceDayTable, resourceI) {
        return [
            tslib.__assign(tslib.__assign({}, seg), { col: resourceDayTable.computeCol(seg.col, resourceI) }),
        ];
    };
    return ResourceDayTimeColsJoiner;
}(resourceCommonPlugin.VResourceJoiner));

var ResourceDayTimeCols = /** @class */ (function (_super) {
    tslib.__extends(ResourceDayTimeCols, _super);
    function ResourceDayTimeCols() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.buildDayRanges = common.memoize(timeGridPlugin.buildDayRanges);
        _this.splitter = new resourceCommonPlugin.VResourceSplitter();
        _this.slicers = {};
        _this.joiner = new ResourceDayTimeColsJoiner();
        _this.timeColsRef = common.createRef();
        _this.isHitComboAllowed = function (hit0, hit1) {
            var allowAcrossResources = _this.dayRanges.length === 1;
            return allowAcrossResources || hit0.dateSpan.resourceId === hit1.dateSpan.resourceId;
        };
        return _this;
    }
    ResourceDayTimeCols.prototype.render = function () {
        var _this = this;
        var _a = this, props = _a.props, context = _a.context;
        var dateEnv = context.dateEnv, options = context.options;
        var dateProfile = props.dateProfile, resourceDayTableModel = props.resourceDayTableModel;
        var dayRanges = this.dayRanges = this.buildDayRanges(resourceDayTableModel.dayTableModel, dateProfile, dateEnv);
        var splitProps = this.splitter.splitProps(props);
        this.slicers = common.mapHash(splitProps, function (split, resourceId) { return _this.slicers[resourceId] || new timeGridPlugin.DayTimeColsSlicer(); });
        var slicedProps = common.mapHash(this.slicers, function (slicer, resourceId) { return slicer.sliceProps(splitProps[resourceId], dateProfile, null, context, dayRanges); });
        return ( // TODO: would move this further down hierarchy, but sliceNowDate needs it
        common.createElement(common.NowTimer, { unit: options.nowIndicator ? 'minute' : 'day' }, function (nowDate, todayRange) { return (common.createElement(timeGridPlugin.TimeCols, tslib.__assign({ ref: _this.timeColsRef }, _this.joiner.joinProps(slicedProps, resourceDayTableModel), { dateProfile: dateProfile, axis: props.axis, slotDuration: props.slotDuration, slatMetas: props.slatMetas, cells: resourceDayTableModel.cells[0], tableColGroupNode: props.tableColGroupNode, tableMinWidth: props.tableMinWidth, clientWidth: props.clientWidth, clientHeight: props.clientHeight, expandRows: props.expandRows, nowDate: nowDate, nowIndicatorSegs: options.nowIndicator && _this.buildNowIndicatorSegs(nowDate), todayRange: todayRange, onScrollTopRequest: props.onScrollTopRequest, forPrint: props.forPrint, onSlatCoords: props.onSlatCoords, isHitComboAllowed: _this.isHitComboAllowed }))); }));
    };
    ResourceDayTimeCols.prototype.buildNowIndicatorSegs = function (date) {
        var nonResourceSegs = this.slicers[''].sliceNowDate(date, this.context, this.dayRanges);
        return this.joiner.expandSegs(this.props.resourceDayTableModel, nonResourceSegs);
    };
    return ResourceDayTimeCols;
}(common.DateComponent));

var ResourceDayTimeColsView = /** @class */ (function (_super) {
    tslib.__extends(ResourceDayTimeColsView, _super);
    function ResourceDayTimeColsView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.flattenResources = common.memoize(resourceCommonPlugin.flattenResources);
        _this.buildResourceTimeColsModel = common.memoize(buildResourceTimeColsModel);
        _this.buildSlatMetas = common.memoize(timeGridPlugin.buildSlatMetas);
        return _this;
    }
    ResourceDayTimeColsView.prototype.render = function () {
        var _this = this;
        var _a = this, props = _a.props, context = _a.context;
        var options = context.options, dateEnv = context.dateEnv;
        var dateProfile = props.dateProfile;
        var splitProps = this.allDaySplitter.splitProps(props);
        var resourceOrderSpecs = options.resourceOrder || resourceCommonPlugin.DEFAULT_RESOURCE_ORDER;
        var resources = this.flattenResources(props.resourceStore, resourceOrderSpecs);
        var resourceDayTableModel = this.buildResourceTimeColsModel(dateProfile, context.dateProfileGenerator, resources, options.datesAboveResources, context);
        var slatMetas = this.buildSlatMetas(dateProfile.slotMinTime, dateProfile.slotMaxTime, options.slotLabelInterval, options.slotDuration, dateEnv);
        var dayMinWidth = options.dayMinWidth;
        var hasAttachedAxis = !dayMinWidth;
        var hasDetachedAxis = dayMinWidth;
        var headerContent = options.dayHeaders && (common.createElement(resourceCommonPlugin.ResourceDayHeader, { resources: resources, dates: resourceDayTableModel.dayTableModel.headerDates, dateProfile: dateProfile, datesRepDistinctDays: true, renderIntro: hasAttachedAxis ? this.renderHeadAxis : null }));
        var allDayContent = (options.allDaySlot !== false) && (function (contentArg) { return (common.createElement(resourceDaygrid.ResourceDayTable, tslib.__assign({}, splitProps.allDay, { dateProfile: dateProfile, resourceDayTableModel: resourceDayTableModel, nextDayThreshold: options.nextDayThreshold, tableMinWidth: contentArg.tableMinWidth, colGroupNode: contentArg.tableColGroupNode, renderRowIntro: hasAttachedAxis ? _this.renderTableRowAxis : null, showWeekNumbers: false, expandRows: false, headerAlignElRef: _this.headerElRef, clientWidth: contentArg.clientWidth, clientHeight: contentArg.clientHeight, forPrint: props.forPrint }, _this.getAllDayMaxEventProps()))); });
        var timeGridContent = function (contentArg) { return (common.createElement(ResourceDayTimeCols, tslib.__assign({}, splitProps.timed, { dateProfile: dateProfile, axis: hasAttachedAxis, slotDuration: options.slotDuration, slatMetas: slatMetas, resourceDayTableModel: resourceDayTableModel, tableColGroupNode: contentArg.tableColGroupNode, tableMinWidth: contentArg.tableMinWidth, clientWidth: contentArg.clientWidth, clientHeight: contentArg.clientHeight, onSlatCoords: _this.handleSlatCoords, expandRows: contentArg.expandRows, forPrint: props.forPrint, onScrollTopRequest: _this.handleScrollTopRequest }))); };
        return hasDetachedAxis
            ? this.renderHScrollLayout(headerContent, allDayContent, timeGridContent, resourceDayTableModel.colCnt, dayMinWidth, slatMetas, this.state.slatCoords)
            : this.renderSimpleLayout(headerContent, allDayContent, timeGridContent);
    };
    return ResourceDayTimeColsView;
}(timeGridPlugin.TimeColsView));
function buildResourceTimeColsModel(dateProfile, dateProfileGenerator, resources, datesAboveResources, context) {
    var dayTable = timeGridPlugin.buildTimeColsModel(dateProfile, dateProfileGenerator);
    return datesAboveResources ?
        new resourceCommonPlugin.DayResourceTableModel(dayTable, resources, context) :
        new resourceCommonPlugin.ResourceDayTableModel(dayTable, resources, context);
}

var main = common.createPlugin({
    deps: [
        premiumCommonPlugin__default['default'],
        resourceCommonPlugin__default['default'],
        timeGridPlugin__default['default'],
    ],
    initialView: 'resourceTimeGridDay',
    views: {
        resourceTimeGrid: {
            type: 'timeGrid',
            component: ResourceDayTimeColsView,
            needsResourceData: true,
        },
        resourceTimeGridDay: {
            type: 'resourceTimeGrid',
            duration: { days: 1 },
        },
        resourceTimeGridWeek: {
            type: 'resourceTimeGrid',
            duration: { weeks: 1 },
        },
    },
});

exports.ResourceDayTimeCols = ResourceDayTimeCols;
exports.ResourceDayTimeColsView = ResourceDayTimeColsView;
exports.default = main;

},{"@fullcalendar/common":3,"@fullcalendar/premium-common":10,"@fullcalendar/resource-common":11,"@fullcalendar/resource-daygrid":12,"@fullcalendar/timegrid":14,"tslib":782}],14:[function(require,module,exports){
/*!
FullCalendar v5.9.0
Docs & License: https://fullcalendar.io/
(c) 2021 Adam Shaw
*/
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var common = require('@fullcalendar/common');
var tslib = require('tslib');
var daygrid = require('@fullcalendar/daygrid');
;

var AllDaySplitter = /** @class */ (function (_super) {
    tslib.__extends(AllDaySplitter, _super);
    function AllDaySplitter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AllDaySplitter.prototype.getKeyInfo = function () {
        return {
            allDay: {},
            timed: {},
        };
    };
    AllDaySplitter.prototype.getKeysForDateSpan = function (dateSpan) {
        if (dateSpan.allDay) {
            return ['allDay'];
        }
        return ['timed'];
    };
    AllDaySplitter.prototype.getKeysForEventDef = function (eventDef) {
        if (!eventDef.allDay) {
            return ['timed'];
        }
        if (common.hasBgRendering(eventDef)) {
            return ['timed', 'allDay'];
        }
        return ['allDay'];
    };
    return AllDaySplitter;
}(common.Splitter));

var DEFAULT_SLAT_LABEL_FORMAT = common.createFormatter({
    hour: 'numeric',
    minute: '2-digit',
    omitZeroMinute: true,
    meridiem: 'short',
});
function TimeColsAxisCell(props) {
    var classNames = [
        'fc-timegrid-slot',
        'fc-timegrid-slot-label',
        props.isLabeled ? 'fc-scrollgrid-shrink' : 'fc-timegrid-slot-minor',
    ];
    return (common.createElement(common.ViewContextType.Consumer, null, function (context) {
        if (!props.isLabeled) {
            return (common.createElement("td", { className: classNames.join(' '), "data-time": props.isoTimeStr }));
        }
        var dateEnv = context.dateEnv, options = context.options, viewApi = context.viewApi;
        var labelFormat = // TODO: fully pre-parse
         options.slotLabelFormat == null ? DEFAULT_SLAT_LABEL_FORMAT :
            Array.isArray(options.slotLabelFormat) ? common.createFormatter(options.slotLabelFormat[0]) :
                common.createFormatter(options.slotLabelFormat);
        var hookProps = {
            level: 0,
            time: props.time,
            date: dateEnv.toDate(props.date),
            view: viewApi,
            text: dateEnv.format(props.date, labelFormat),
        };
        return (common.createElement(common.RenderHook, { hookProps: hookProps, classNames: options.slotLabelClassNames, content: options.slotLabelContent, defaultContent: renderInnerContent, didMount: options.slotLabelDidMount, willUnmount: options.slotLabelWillUnmount }, function (rootElRef, customClassNames, innerElRef, innerContent) { return (common.createElement("td", { ref: rootElRef, className: classNames.concat(customClassNames).join(' '), "data-time": props.isoTimeStr },
            common.createElement("div", { className: "fc-timegrid-slot-label-frame fc-scrollgrid-shrink-frame" },
                common.createElement("div", { className: "fc-timegrid-slot-label-cushion fc-scrollgrid-shrink-cushion", ref: innerElRef }, innerContent)))); }));
    }));
}
function renderInnerContent(props) {
    return props.text;
}

var TimeBodyAxis = /** @class */ (function (_super) {
    tslib.__extends(TimeBodyAxis, _super);
    function TimeBodyAxis() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TimeBodyAxis.prototype.render = function () {
        return this.props.slatMetas.map(function (slatMeta) { return (common.createElement("tr", { key: slatMeta.key },
            common.createElement(TimeColsAxisCell, tslib.__assign({}, slatMeta)))); });
    };
    return TimeBodyAxis;
}(common.BaseComponent));

var DEFAULT_WEEK_NUM_FORMAT = common.createFormatter({ week: 'short' });
var AUTO_ALL_DAY_MAX_EVENT_ROWS = 5;
var TimeColsView = /** @class */ (function (_super) {
    tslib.__extends(TimeColsView, _super);
    function TimeColsView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.allDaySplitter = new AllDaySplitter(); // for use by subclasses
        _this.headerElRef = common.createRef();
        _this.rootElRef = common.createRef();
        _this.scrollerElRef = common.createRef();
        _this.state = {
            slatCoords: null,
        };
        _this.handleScrollTopRequest = function (scrollTop) {
            var scrollerEl = _this.scrollerElRef.current;
            if (scrollerEl) { // TODO: not sure how this could ever be null. weirdness with the reducer
                scrollerEl.scrollTop = scrollTop;
            }
        };
        /* Header Render Methods
        ------------------------------------------------------------------------------------------------------------------*/
        _this.renderHeadAxis = function (rowKey, frameHeight) {
            if (frameHeight === void 0) { frameHeight = ''; }
            var options = _this.context.options;
            var dateProfile = _this.props.dateProfile;
            var range = dateProfile.renderRange;
            var dayCnt = common.diffDays(range.start, range.end);
            var navLinkAttrs = (options.navLinks && dayCnt === 1) // only do in day views (to avoid doing in week views that dont need it)
                ? { 'data-navlink': common.buildNavLinkData(range.start, 'week'), tabIndex: 0 }
                : {};
            if (options.weekNumbers && rowKey === 'day') {
                return (common.createElement(common.WeekNumberRoot, { date: range.start, defaultFormat: DEFAULT_WEEK_NUM_FORMAT }, function (rootElRef, classNames, innerElRef, innerContent) { return (common.createElement("th", { ref: rootElRef, className: [
                        'fc-timegrid-axis',
                        'fc-scrollgrid-shrink',
                    ].concat(classNames).join(' ') },
                    common.createElement("div", { className: "fc-timegrid-axis-frame fc-scrollgrid-shrink-frame fc-timegrid-axis-frame-liquid", style: { height: frameHeight } },
                        common.createElement("a", tslib.__assign({ ref: innerElRef, className: "fc-timegrid-axis-cushion fc-scrollgrid-shrink-cushion fc-scrollgrid-sync-inner" }, navLinkAttrs), innerContent)))); }));
            }
            return (common.createElement("th", { className: "fc-timegrid-axis" },
                common.createElement("div", { className: "fc-timegrid-axis-frame", style: { height: frameHeight } })));
        };
        /* Table Component Render Methods
        ------------------------------------------------------------------------------------------------------------------*/
        // only a one-way height sync. we don't send the axis inner-content height to the DayGrid,
        // but DayGrid still needs to have classNames on inner elements in order to measure.
        _this.renderTableRowAxis = function (rowHeight) {
            var _a = _this.context, options = _a.options, viewApi = _a.viewApi;
            var hookProps = {
                text: options.allDayText,
                view: viewApi,
            };
            return (
            // TODO: make reusable hook. used in list view too
            common.createElement(common.RenderHook, { hookProps: hookProps, classNames: options.allDayClassNames, content: options.allDayContent, defaultContent: renderAllDayInner, didMount: options.allDayDidMount, willUnmount: options.allDayWillUnmount }, function (rootElRef, classNames, innerElRef, innerContent) { return (common.createElement("td", { ref: rootElRef, className: [
                    'fc-timegrid-axis',
                    'fc-scrollgrid-shrink',
                ].concat(classNames).join(' ') },
                common.createElement("div", { className: 'fc-timegrid-axis-frame fc-scrollgrid-shrink-frame' + (rowHeight == null ? ' fc-timegrid-axis-frame-liquid' : ''), style: { height: rowHeight } },
                    common.createElement("span", { className: "fc-timegrid-axis-cushion fc-scrollgrid-shrink-cushion fc-scrollgrid-sync-inner", ref: innerElRef }, innerContent)))); }));
        };
        _this.handleSlatCoords = function (slatCoords) {
            _this.setState({ slatCoords: slatCoords });
        };
        return _this;
    }
    // rendering
    // ----------------------------------------------------------------------------------------------------
    TimeColsView.prototype.renderSimpleLayout = function (headerRowContent, allDayContent, timeContent) {
        var _a = this, context = _a.context, props = _a.props;
        var sections = [];
        var stickyHeaderDates = common.getStickyHeaderDates(context.options);
        if (headerRowContent) {
            sections.push({
                type: 'header',
                key: 'header',
                isSticky: stickyHeaderDates,
                chunk: {
                    elRef: this.headerElRef,
                    tableClassName: 'fc-col-header',
                    rowContent: headerRowContent,
                },
            });
        }
        if (allDayContent) {
            sections.push({
                type: 'body',
                key: 'all-day',
                chunk: { content: allDayContent },
            });
            sections.push({
                type: 'body',
                key: 'all-day-divider',
                outerContent: ( // TODO: rename to cellContent so don't need to define <tr>?
                common.createElement("tr", { className: "fc-scrollgrid-section" },
                    common.createElement("td", { className: 'fc-timegrid-divider ' + context.theme.getClass('tableCellShaded') }))),
            });
        }
        sections.push({
            type: 'body',
            key: 'body',
            liquid: true,
            expandRows: Boolean(context.options.expandRows),
            chunk: {
                scrollerElRef: this.scrollerElRef,
                content: timeContent,
            },
        });
        return (common.createElement(common.ViewRoot, { viewSpec: context.viewSpec, elRef: this.rootElRef }, function (rootElRef, classNames) { return (common.createElement("div", { className: ['fc-timegrid'].concat(classNames).join(' '), ref: rootElRef },
            common.createElement(common.SimpleScrollGrid, { liquid: !props.isHeightAuto && !props.forPrint, collapsibleWidth: props.forPrint, cols: [{ width: 'shrink' }], sections: sections }))); }));
    };
    TimeColsView.prototype.renderHScrollLayout = function (headerRowContent, allDayContent, timeContent, colCnt, dayMinWidth, slatMetas, slatCoords) {
        var _this = this;
        var ScrollGrid = this.context.pluginHooks.scrollGridImpl;
        if (!ScrollGrid) {
            throw new Error('No ScrollGrid implementation');
        }
        var _a = this, context = _a.context, props = _a.props;
        var stickyHeaderDates = !props.forPrint && common.getStickyHeaderDates(context.options);
        var stickyFooterScrollbar = !props.forPrint && common.getStickyFooterScrollbar(context.options);
        var sections = [];
        if (headerRowContent) {
            sections.push({
                type: 'header',
                key: 'header',
                isSticky: stickyHeaderDates,
                syncRowHeights: true,
                chunks: [
                    {
                        key: 'axis',
                        rowContent: function (arg) { return (common.createElement("tr", null, _this.renderHeadAxis('day', arg.rowSyncHeights[0]))); },
                    },
                    {
                        key: 'cols',
                        elRef: this.headerElRef,
                        tableClassName: 'fc-col-header',
                        rowContent: headerRowContent,
                    },
                ],
            });
        }
        if (allDayContent) {
            sections.push({
                type: 'body',
                key: 'all-day',
                syncRowHeights: true,
                chunks: [
                    {
                        key: 'axis',
                        rowContent: function (contentArg) { return (common.createElement("tr", null, _this.renderTableRowAxis(contentArg.rowSyncHeights[0]))); },
                    },
                    {
                        key: 'cols',
                        content: allDayContent,
                    },
                ],
            });
            sections.push({
                key: 'all-day-divider',
                type: 'body',
                outerContent: ( // TODO: rename to cellContent so don't need to define <tr>?
                common.createElement("tr", { className: "fc-scrollgrid-section" },
                    common.createElement("td", { colSpan: 2, className: 'fc-timegrid-divider ' + context.theme.getClass('tableCellShaded') }))),
            });
        }
        var isNowIndicator = context.options.nowIndicator;
        sections.push({
            type: 'body',
            key: 'body',
            liquid: true,
            expandRows: Boolean(context.options.expandRows),
            chunks: [
                {
                    key: 'axis',
                    content: function (arg) { return (
                    // TODO: make this now-indicator arrow more DRY with TimeColsContent
                    common.createElement("div", { className: "fc-timegrid-axis-chunk" },
                        common.createElement("table", { style: { height: arg.expandRows ? arg.clientHeight : '' } },
                            arg.tableColGroupNode,
                            common.createElement("tbody", null,
                                common.createElement(TimeBodyAxis, { slatMetas: slatMetas }))),
                        common.createElement("div", { className: "fc-timegrid-now-indicator-container" },
                            common.createElement(common.NowTimer, { unit: isNowIndicator ? 'minute' : 'day' /* hacky */ }, function (nowDate) {
                                var nowIndicatorTop = isNowIndicator &&
                                    slatCoords &&
                                    slatCoords.safeComputeTop(nowDate); // might return void
                                if (typeof nowIndicatorTop === 'number') {
                                    return (common.createElement(common.NowIndicatorRoot, { isAxis: true, date: nowDate }, function (rootElRef, classNames, innerElRef, innerContent) { return (common.createElement("div", { ref: rootElRef, className: ['fc-timegrid-now-indicator-arrow'].concat(classNames).join(' '), style: { top: nowIndicatorTop } }, innerContent)); }));
                                }
                                return null;
                            })))); },
                },
                {
                    key: 'cols',
                    scrollerElRef: this.scrollerElRef,
                    content: timeContent,
                },
            ],
        });
        if (stickyFooterScrollbar) {
            sections.push({
                key: 'footer',
                type: 'footer',
                isSticky: true,
                chunks: [
                    {
                        key: 'axis',
                        content: common.renderScrollShim,
                    },
                    {
                        key: 'cols',
                        content: common.renderScrollShim,
                    },
                ],
            });
        }
        return (common.createElement(common.ViewRoot, { viewSpec: context.viewSpec, elRef: this.rootElRef }, function (rootElRef, classNames) { return (common.createElement("div", { className: ['fc-timegrid'].concat(classNames).join(' '), ref: rootElRef },
            common.createElement(ScrollGrid, { liquid: !props.isHeightAuto && !props.forPrint, collapsibleWidth: false, colGroups: [
                    { width: 'shrink', cols: [{ width: 'shrink' }] },
                    { cols: [{ span: colCnt, minWidth: dayMinWidth }] },
                ], sections: sections }))); }));
    };
    /* Dimensions
    ------------------------------------------------------------------------------------------------------------------*/
    TimeColsView.prototype.getAllDayMaxEventProps = function () {
        var _a = this.context.options, dayMaxEvents = _a.dayMaxEvents, dayMaxEventRows = _a.dayMaxEventRows;
        if (dayMaxEvents === true || dayMaxEventRows === true) { // is auto?
            dayMaxEvents = undefined;
            dayMaxEventRows = AUTO_ALL_DAY_MAX_EVENT_ROWS; // make sure "auto" goes to a real number
        }
        return { dayMaxEvents: dayMaxEvents, dayMaxEventRows: dayMaxEventRows };
    };
    return TimeColsView;
}(common.DateComponent));
function renderAllDayInner(hookProps) {
    return hookProps.text;
}

var TimeColsSlatsCoords = /** @class */ (function () {
    function TimeColsSlatsCoords(positions, dateProfile, slotDuration) {
        this.positions = positions;
        this.dateProfile = dateProfile;
        this.slotDuration = slotDuration;
    }
    TimeColsSlatsCoords.prototype.safeComputeTop = function (date) {
        var dateProfile = this.dateProfile;
        if (common.rangeContainsMarker(dateProfile.currentRange, date)) {
            var startOfDayDate = common.startOfDay(date);
            var timeMs = date.valueOf() - startOfDayDate.valueOf();
            if (timeMs >= common.asRoughMs(dateProfile.slotMinTime) &&
                timeMs < common.asRoughMs(dateProfile.slotMaxTime)) {
                return this.computeTimeTop(common.createDuration(timeMs));
            }
        }
        return null;
    };
    // Computes the top coordinate, relative to the bounds of the grid, of the given date.
    // A `startOfDayDate` must be given for avoiding ambiguity over how to treat midnight.
    TimeColsSlatsCoords.prototype.computeDateTop = function (when, startOfDayDate) {
        if (!startOfDayDate) {
            startOfDayDate = common.startOfDay(when);
        }
        return this.computeTimeTop(common.createDuration(when.valueOf() - startOfDayDate.valueOf()));
    };
    // Computes the top coordinate, relative to the bounds of the grid, of the given time (a Duration).
    // This is a makeshify way to compute the time-top. Assumes all slatMetas dates are uniform.
    // Eventually allow computation with arbirary slat dates.
    TimeColsSlatsCoords.prototype.computeTimeTop = function (duration) {
        var _a = this, positions = _a.positions, dateProfile = _a.dateProfile;
        var len = positions.els.length;
        // floating-point value of # of slots covered
        var slatCoverage = (duration.milliseconds - common.asRoughMs(dateProfile.slotMinTime)) / common.asRoughMs(this.slotDuration);
        var slatIndex;
        var slatRemainder;
        // compute a floating-point number for how many slats should be progressed through.
        // from 0 to number of slats (inclusive)
        // constrained because slotMinTime/slotMaxTime might be customized.
        slatCoverage = Math.max(0, slatCoverage);
        slatCoverage = Math.min(len, slatCoverage);
        // an integer index of the furthest whole slat
        // from 0 to number slats (*exclusive*, so len-1)
        slatIndex = Math.floor(slatCoverage);
        slatIndex = Math.min(slatIndex, len - 1);
        // how much further through the slatIndex slat (from 0.0-1.0) must be covered in addition.
        // could be 1.0 if slatCoverage is covering *all* the slots
        slatRemainder = slatCoverage - slatIndex;
        return positions.tops[slatIndex] +
            positions.getHeight(slatIndex) * slatRemainder;
    };
    return TimeColsSlatsCoords;
}());

var TimeColsSlatsBody = /** @class */ (function (_super) {
    tslib.__extends(TimeColsSlatsBody, _super);
    function TimeColsSlatsBody() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TimeColsSlatsBody.prototype.render = function () {
        var _a = this, props = _a.props, context = _a.context;
        var options = context.options;
        var slatElRefs = props.slatElRefs;
        return (common.createElement("tbody", null, props.slatMetas.map(function (slatMeta, i) {
            var hookProps = {
                time: slatMeta.time,
                date: context.dateEnv.toDate(slatMeta.date),
                view: context.viewApi,
            };
            var classNames = [
                'fc-timegrid-slot',
                'fc-timegrid-slot-lane',
                slatMeta.isLabeled ? '' : 'fc-timegrid-slot-minor',
            ];
            return (common.createElement("tr", { key: slatMeta.key, ref: slatElRefs.createRef(slatMeta.key) },
                props.axis && (common.createElement(TimeColsAxisCell, tslib.__assign({}, slatMeta))),
                common.createElement(common.RenderHook, { hookProps: hookProps, classNames: options.slotLaneClassNames, content: options.slotLaneContent, didMount: options.slotLaneDidMount, willUnmount: options.slotLaneWillUnmount }, function (rootElRef, customClassNames, innerElRef, innerContent) { return (common.createElement("td", { ref: rootElRef, className: classNames.concat(customClassNames).join(' '), "data-time": slatMeta.isoTimeStr }, innerContent)); })));
        })));
    };
    return TimeColsSlatsBody;
}(common.BaseComponent));

/*
for the horizontal "slats" that run width-wise. Has a time axis on a side. Depends on RTL.
*/
var TimeColsSlats = /** @class */ (function (_super) {
    tslib.__extends(TimeColsSlats, _super);
    function TimeColsSlats() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.rootElRef = common.createRef();
        _this.slatElRefs = new common.RefMap();
        return _this;
    }
    TimeColsSlats.prototype.render = function () {
        var _a = this, props = _a.props, context = _a.context;
        return (common.createElement("div", { className: "fc-timegrid-slots", ref: this.rootElRef },
            common.createElement("table", { className: context.theme.getClass('table'), style: {
                    minWidth: props.tableMinWidth,
                    width: props.clientWidth,
                    height: props.minHeight,
                } },
                props.tableColGroupNode /* relies on there only being a single <col> for the axis */,
                common.createElement(TimeColsSlatsBody, { slatElRefs: this.slatElRefs, axis: props.axis, slatMetas: props.slatMetas }))));
    };
    TimeColsSlats.prototype.componentDidMount = function () {
        this.updateSizing();
    };
    TimeColsSlats.prototype.componentDidUpdate = function () {
        this.updateSizing();
    };
    TimeColsSlats.prototype.componentWillUnmount = function () {
        if (this.props.onCoords) {
            this.props.onCoords(null);
        }
    };
    TimeColsSlats.prototype.updateSizing = function () {
        var _a = this, context = _a.context, props = _a.props;
        if (props.onCoords &&
            props.clientWidth !== null // means sizing has stabilized
        ) {
            var rootEl = this.rootElRef.current;
            if (rootEl.offsetHeight) { // not hidden by css
                props.onCoords(new TimeColsSlatsCoords(new common.PositionCache(this.rootElRef.current, collectSlatEls(this.slatElRefs.currentMap, props.slatMetas), false, true), this.props.dateProfile, context.options.slotDuration));
            }
        }
    };
    return TimeColsSlats;
}(common.BaseComponent));
function collectSlatEls(elMap, slatMetas) {
    return slatMetas.map(function (slatMeta) { return elMap[slatMeta.key]; });
}

function splitSegsByCol(segs, colCnt) {
    var segsByCol = [];
    var i;
    for (i = 0; i < colCnt; i += 1) {
        segsByCol.push([]);
    }
    if (segs) {
        for (i = 0; i < segs.length; i += 1) {
            segsByCol[segs[i].col].push(segs[i]);
        }
    }
    return segsByCol;
}
function splitInteractionByCol(ui, colCnt) {
    var byRow = [];
    if (!ui) {
        for (var i = 0; i < colCnt; i += 1) {
            byRow[i] = null;
        }
    }
    else {
        for (var i = 0; i < colCnt; i += 1) {
            byRow[i] = {
                affectedInstances: ui.affectedInstances,
                isEvent: ui.isEvent,
                segs: [],
            };
        }
        for (var _i = 0, _a = ui.segs; _i < _a.length; _i++) {
            var seg = _a[_i];
            byRow[seg.col].segs.push(seg);
        }
    }
    return byRow;
}

var TimeColMoreLink = /** @class */ (function (_super) {
    tslib.__extends(TimeColMoreLink, _super);
    function TimeColMoreLink() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.rootElRef = common.createRef();
        return _this;
    }
    TimeColMoreLink.prototype.render = function () {
        var _this = this;
        var props = this.props;
        return (common.createElement(common.MoreLinkRoot, { allDayDate: null, moreCnt: props.hiddenSegs.length, allSegs: props.hiddenSegs, hiddenSegs: props.hiddenSegs, alignmentElRef: this.rootElRef, defaultContent: renderMoreLinkInner, extraDateSpan: props.extraDateSpan, dateProfile: props.dateProfile, todayRange: props.todayRange, popoverContent: function () { return renderPlainFgSegs(props.hiddenSegs, props); } }, function (rootElRef, classNames, innerElRef, innerContent, handleClick) { return (common.createElement("a", { ref: function (el) {
                common.setRef(rootElRef, el);
                common.setRef(_this.rootElRef, el);
            }, className: ['fc-timegrid-more-link'].concat(classNames).join(' '), style: { top: props.top, bottom: props.bottom }, onClick: handleClick },
            common.createElement("div", { ref: innerElRef, className: "fc-timegrid-more-link-inner fc-sticky" }, innerContent))); }));
    };
    return TimeColMoreLink;
}(common.BaseComponent));
function renderMoreLinkInner(props) {
    return props.shortText;
}

// segInputs assumed sorted
function buildPositioning(segInputs, strictOrder, maxStackCnt) {
    var hierarchy = new common.SegHierarchy();
    if (strictOrder != null) {
        hierarchy.strictOrder = strictOrder;
    }
    if (maxStackCnt != null) {
        hierarchy.maxStackCnt = maxStackCnt;
    }
    var hiddenEntries = hierarchy.addSegs(segInputs);
    var hiddenGroups = common.groupIntersectingEntries(hiddenEntries);
    var web = buildWeb(hierarchy);
    web = stretchWeb(web, 1); // all levelCoords/thickness will have 0.0-1.0
    var segRects = webToRects(web);
    return { segRects: segRects, hiddenGroups: hiddenGroups };
}
function buildWeb(hierarchy) {
    var entriesByLevel = hierarchy.entriesByLevel;
    var buildNode = cacheable(function (level, lateral) { return level + ':' + lateral; }, function (level, lateral) {
        var siblingRange = findNextLevelSegs(hierarchy, level, lateral);
        var nextLevelRes = buildNodes(siblingRange, buildNode);
        var entry = entriesByLevel[level][lateral];
        return [
            tslib.__assign(tslib.__assign({}, entry), { nextLevelNodes: nextLevelRes[0] }),
            entry.thickness + nextLevelRes[1], // the pressure builds
        ];
    });
    return buildNodes(entriesByLevel.length
        ? { level: 0, lateralStart: 0, lateralEnd: entriesByLevel[0].length }
        : null, buildNode)[0];
}
function buildNodes(siblingRange, buildNode) {
    if (!siblingRange) {
        return [[], 0];
    }
    var level = siblingRange.level, lateralStart = siblingRange.lateralStart, lateralEnd = siblingRange.lateralEnd;
    var lateral = lateralStart;
    var pairs = [];
    while (lateral < lateralEnd) {
        pairs.push(buildNode(level, lateral));
        lateral += 1;
    }
    pairs.sort(cmpDescPressures);
    return [
        pairs.map(extractNode),
        pairs[0][1], // first item's pressure
    ];
}
function cmpDescPressures(a, b) {
    return b[1] - a[1];
}
function extractNode(a) {
    return a[0];
}
function findNextLevelSegs(hierarchy, subjectLevel, subjectLateral) {
    var levelCoords = hierarchy.levelCoords, entriesByLevel = hierarchy.entriesByLevel;
    var subjectEntry = entriesByLevel[subjectLevel][subjectLateral];
    var afterSubject = levelCoords[subjectLevel] + subjectEntry.thickness;
    var levelCnt = levelCoords.length;
    var level = subjectLevel;
    // skip past levels that are too high up
    for (; level < levelCnt && levelCoords[level] < afterSubject; level += 1)
        ; // do nothing
    for (; level < levelCnt; level += 1) {
        var entries = entriesByLevel[level];
        var entry = void 0;
        var searchIndex = common.binarySearch(entries, subjectEntry.span.start, common.getEntrySpanEnd);
        var lateralStart = searchIndex[0] + searchIndex[1]; // if exact match (which doesn't collide), go to next one
        var lateralEnd = lateralStart;
        while ( // loop through entries that horizontally intersect
        (entry = entries[lateralEnd]) && // but not past the whole seg list
            entry.span.start < subjectEntry.span.end) {
            lateralEnd += 1;
        }
        if (lateralStart < lateralEnd) {
            return { level: level, lateralStart: lateralStart, lateralEnd: lateralEnd };
        }
    }
    return null;
}
function stretchWeb(topLevelNodes, totalThickness) {
    var stretchNode = cacheable(function (node, startCoord, prevThickness) { return common.buildEntryKey(node); }, function (node, startCoord, prevThickness) {
        var nextLevelNodes = node.nextLevelNodes, thickness = node.thickness;
        var allThickness = thickness + prevThickness;
        var thicknessFraction = thickness / allThickness;
        var endCoord;
        var newChildren = [];
        if (!nextLevelNodes.length) {
            endCoord = totalThickness;
        }
        else {
            for (var _i = 0, nextLevelNodes_1 = nextLevelNodes; _i < nextLevelNodes_1.length; _i++) {
                var childNode = nextLevelNodes_1[_i];
                if (endCoord === undefined) {
                    var res = stretchNode(childNode, startCoord, allThickness);
                    endCoord = res[0];
                    newChildren.push(res[1]);
                }
                else {
                    var res = stretchNode(childNode, endCoord, 0);
                    newChildren.push(res[1]);
                }
            }
        }
        var newThickness = (endCoord - startCoord) * thicknessFraction;
        return [endCoord - newThickness, tslib.__assign(tslib.__assign({}, node), { thickness: newThickness, nextLevelNodes: newChildren })];
    });
    return topLevelNodes.map(function (node) { return stretchNode(node, 0, 0)[1]; });
}
// not sorted in any particular order
function webToRects(topLevelNodes) {
    var rects = [];
    var processNode = cacheable(function (node, levelCoord, stackDepth) { return common.buildEntryKey(node); }, function (node, levelCoord, stackDepth) {
        var rect = tslib.__assign(tslib.__assign({}, node), { levelCoord: levelCoord,
            stackDepth: stackDepth, stackForward: 0 });
        rects.push(rect);
        return (rect.stackForward = processNodes(node.nextLevelNodes, levelCoord + node.thickness, stackDepth + 1) + 1);
    });
    function processNodes(nodes, levelCoord, stackDepth) {
        var stackForward = 0;
        for (var _i = 0, nodes_1 = nodes; _i < nodes_1.length; _i++) {
            var node = nodes_1[_i];
            stackForward = Math.max(processNode(node, levelCoord, stackDepth), stackForward);
        }
        return stackForward;
    }
    processNodes(topLevelNodes, 0, 0);
    return rects; // TODO: sort rects by levelCoord to be consistent with toRects?
}
// TODO: move to general util
function cacheable(keyFunc, workFunc) {
    var cache = {};
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var key = keyFunc.apply(void 0, args);
        return (key in cache)
            ? cache[key]
            : (cache[key] = workFunc.apply(void 0, args));
    };
}

function computeSegVCoords(segs, colDate, slatCoords, eventMinHeight) {
    if (slatCoords === void 0) { slatCoords = null; }
    if (eventMinHeight === void 0) { eventMinHeight = 0; }
    var vcoords = [];
    if (slatCoords) {
        for (var i = 0; i < segs.length; i += 1) {
            var seg = segs[i];
            var spanStart = slatCoords.computeDateTop(seg.start, colDate);
            var spanEnd = Math.max(spanStart + (eventMinHeight || 0), // :(
            slatCoords.computeDateTop(seg.end, colDate));
            vcoords.push({
                start: Math.round(spanStart),
                end: Math.round(spanEnd), //
            });
        }
    }
    return vcoords;
}
function computeFgSegPlacements(segs, segVCoords, // might not have for every seg
eventOrderStrict, eventMaxStack) {
    var segInputs = [];
    var dumbSegs = []; // segs without coords
    for (var i = 0; i < segs.length; i += 1) {
        var vcoords = segVCoords[i];
        if (vcoords) {
            segInputs.push({
                index: i,
                thickness: 1,
                span: vcoords,
            });
        }
        else {
            dumbSegs.push(segs[i]);
        }
    }
    var _a = buildPositioning(segInputs, eventOrderStrict, eventMaxStack), segRects = _a.segRects, hiddenGroups = _a.hiddenGroups;
    var segPlacements = [];
    for (var _i = 0, segRects_1 = segRects; _i < segRects_1.length; _i++) {
        var segRect = segRects_1[_i];
        segPlacements.push({
            seg: segs[segRect.index],
            rect: segRect,
        });
    }
    for (var _b = 0, dumbSegs_1 = dumbSegs; _b < dumbSegs_1.length; _b++) {
        var dumbSeg = dumbSegs_1[_b];
        segPlacements.push({ seg: dumbSeg, rect: null });
    }
    return { segPlacements: segPlacements, hiddenGroups: hiddenGroups };
}

var DEFAULT_TIME_FORMAT = common.createFormatter({
    hour: 'numeric',
    minute: '2-digit',
    meridiem: false,
});
var TimeColEvent = /** @class */ (function (_super) {
    tslib.__extends(TimeColEvent, _super);
    function TimeColEvent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TimeColEvent.prototype.render = function () {
        var classNames = [
            'fc-timegrid-event',
            'fc-v-event',
        ];
        if (this.props.isShort) {
            classNames.push('fc-timegrid-event-short');
        }
        return (common.createElement(common.StandardEvent, tslib.__assign({}, this.props, { defaultTimeFormat: DEFAULT_TIME_FORMAT, extraClassNames: classNames })));
    };
    return TimeColEvent;
}(common.BaseComponent));

var TimeColMisc = /** @class */ (function (_super) {
    tslib.__extends(TimeColMisc, _super);
    function TimeColMisc() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TimeColMisc.prototype.render = function () {
        var props = this.props;
        return (common.createElement(common.DayCellContent, { date: props.date, dateProfile: props.dateProfile, todayRange: props.todayRange, extraHookProps: props.extraHookProps }, function (innerElRef, innerContent) { return (innerContent &&
            common.createElement("div", { className: "fc-timegrid-col-misc", ref: innerElRef }, innerContent)); }));
    };
    return TimeColMisc;
}(common.BaseComponent));

var TimeCol = /** @class */ (function (_super) {
    tslib.__extends(TimeCol, _super);
    function TimeCol() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.sortEventSegs = common.memoize(common.sortEventSegs);
        return _this;
    }
    // TODO: memoize event-placement?
    TimeCol.prototype.render = function () {
        var _this = this;
        var _a = this, props = _a.props, context = _a.context;
        var isSelectMirror = context.options.selectMirror;
        var mirrorSegs = (props.eventDrag && props.eventDrag.segs) ||
            (props.eventResize && props.eventResize.segs) ||
            (isSelectMirror && props.dateSelectionSegs) ||
            [];
        var interactionAffectedInstances = // TODO: messy way to compute this
         (props.eventDrag && props.eventDrag.affectedInstances) ||
            (props.eventResize && props.eventResize.affectedInstances) ||
            {};
        var sortedFgSegs = this.sortEventSegs(props.fgEventSegs, context.options.eventOrder);
        return (common.createElement(common.DayCellRoot, { elRef: props.elRef, date: props.date, dateProfile: props.dateProfile, todayRange: props.todayRange, extraHookProps: props.extraHookProps }, function (rootElRef, classNames, dataAttrs) { return (common.createElement("td", tslib.__assign({ ref: rootElRef, className: ['fc-timegrid-col'].concat(classNames, props.extraClassNames || []).join(' ') }, dataAttrs, props.extraDataAttrs),
            common.createElement("div", { className: "fc-timegrid-col-frame" },
                common.createElement("div", { className: "fc-timegrid-col-bg" },
                    _this.renderFillSegs(props.businessHourSegs, 'non-business'),
                    _this.renderFillSegs(props.bgEventSegs, 'bg-event'),
                    _this.renderFillSegs(props.dateSelectionSegs, 'highlight')),
                common.createElement("div", { className: "fc-timegrid-col-events" }, _this.renderFgSegs(sortedFgSegs, interactionAffectedInstances, false, false, false)),
                common.createElement("div", { className: "fc-timegrid-col-events" }, _this.renderFgSegs(mirrorSegs, {}, Boolean(props.eventDrag), Boolean(props.eventResize), Boolean(isSelectMirror))),
                common.createElement("div", { className: "fc-timegrid-now-indicator-container" }, _this.renderNowIndicator(props.nowIndicatorSegs)),
                common.createElement(TimeColMisc, { date: props.date, dateProfile: props.dateProfile, todayRange: props.todayRange, extraHookProps: props.extraHookProps })))); }));
    };
    TimeCol.prototype.renderFgSegs = function (sortedFgSegs, segIsInvisible, isDragging, isResizing, isDateSelecting) {
        var props = this.props;
        if (props.forPrint) {
            return renderPlainFgSegs(sortedFgSegs, props);
        }
        return this.renderPositionedFgSegs(sortedFgSegs, segIsInvisible, isDragging, isResizing, isDateSelecting);
    };
    TimeCol.prototype.renderPositionedFgSegs = function (segs, // if not mirror, needs to be sorted
    segIsInvisible, isDragging, isResizing, isDateSelecting) {
        var _this = this;
        var _a = this.context.options, eventMaxStack = _a.eventMaxStack, eventShortHeight = _a.eventShortHeight, eventOrderStrict = _a.eventOrderStrict, eventMinHeight = _a.eventMinHeight;
        var _b = this.props, date = _b.date, slatCoords = _b.slatCoords, eventSelection = _b.eventSelection, todayRange = _b.todayRange, nowDate = _b.nowDate;
        var isMirror = isDragging || isResizing || isDateSelecting;
        var segVCoords = computeSegVCoords(segs, date, slatCoords, eventMinHeight);
        var _c = computeFgSegPlacements(segs, segVCoords, eventOrderStrict, eventMaxStack), segPlacements = _c.segPlacements, hiddenGroups = _c.hiddenGroups;
        return (common.createElement(common.Fragment, null,
            this.renderHiddenGroups(hiddenGroups, segs),
            segPlacements.map(function (segPlacement) {
                var seg = segPlacement.seg, rect = segPlacement.rect;
                var instanceId = seg.eventRange.instance.instanceId;
                var isVisible = isMirror || Boolean(!segIsInvisible[instanceId] && rect);
                var vStyle = computeSegVStyle(rect && rect.span);
                var hStyle = (!isMirror && rect) ? _this.computeSegHStyle(rect) : { left: 0, right: 0 };
                var isInset = Boolean(rect) && rect.stackForward > 0;
                var isShort = Boolean(rect) && (rect.span.end - rect.span.start) < eventShortHeight; // look at other places for this problem
                return (common.createElement("div", { className: 'fc-timegrid-event-harness' +
                        (isInset ? ' fc-timegrid-event-harness-inset' : ''), key: instanceId, style: tslib.__assign(tslib.__assign({ visibility: isVisible ? '' : 'hidden' }, vStyle), hStyle) },
                    common.createElement(TimeColEvent, tslib.__assign({ seg: seg, isDragging: isDragging, isResizing: isResizing, isDateSelecting: isDateSelecting, isSelected: instanceId === eventSelection, isShort: isShort }, common.getSegMeta(seg, todayRange, nowDate)))));
            })));
    };
    // will already have eventMinHeight applied because segInputs already had it
    TimeCol.prototype.renderHiddenGroups = function (hiddenGroups, segs) {
        var _a = this.props, extraDateSpan = _a.extraDateSpan, dateProfile = _a.dateProfile, todayRange = _a.todayRange, nowDate = _a.nowDate, eventSelection = _a.eventSelection, eventDrag = _a.eventDrag, eventResize = _a.eventResize;
        return (common.createElement(common.Fragment, null, hiddenGroups.map(function (hiddenGroup) {
            var positionCss = computeSegVStyle(hiddenGroup.span);
            var hiddenSegs = compileSegsFromEntries(hiddenGroup.entries, segs);
            return (common.createElement(TimeColMoreLink, { key: common.buildIsoString(common.computeEarliestSegStart(hiddenSegs)), hiddenSegs: hiddenSegs, top: positionCss.top, bottom: positionCss.bottom, extraDateSpan: extraDateSpan, dateProfile: dateProfile, todayRange: todayRange, nowDate: nowDate, eventSelection: eventSelection, eventDrag: eventDrag, eventResize: eventResize }));
        })));
    };
    TimeCol.prototype.renderFillSegs = function (segs, fillType) {
        var _a = this, props = _a.props, context = _a.context;
        var segVCoords = computeSegVCoords(segs, props.date, props.slatCoords, context.options.eventMinHeight); // don't assume all populated
        var children = segVCoords.map(function (vcoords, i) {
            var seg = segs[i];
            return (common.createElement("div", { key: common.buildEventRangeKey(seg.eventRange), className: "fc-timegrid-bg-harness", style: computeSegVStyle(vcoords) }, fillType === 'bg-event' ?
                common.createElement(common.BgEvent, tslib.__assign({ seg: seg }, common.getSegMeta(seg, props.todayRange, props.nowDate))) :
                common.renderFill(fillType)));
        });
        return common.createElement(common.Fragment, null, children);
    };
    TimeCol.prototype.renderNowIndicator = function (segs) {
        var _a = this.props, slatCoords = _a.slatCoords, date = _a.date;
        if (!slatCoords) {
            return null;
        }
        return segs.map(function (seg, i) { return (common.createElement(common.NowIndicatorRoot, { isAxis: false, date: date, 
            // key doesn't matter. will only ever be one
            key: i }, function (rootElRef, classNames, innerElRef, innerContent) { return (common.createElement("div", { ref: rootElRef, className: ['fc-timegrid-now-indicator-line'].concat(classNames).join(' '), style: { top: slatCoords.computeDateTop(seg.start, date) } }, innerContent)); })); });
    };
    TimeCol.prototype.computeSegHStyle = function (segHCoords) {
        var _a = this.context, isRtl = _a.isRtl, options = _a.options;
        var shouldOverlap = options.slotEventOverlap;
        var nearCoord = segHCoords.levelCoord; // the left side if LTR. the right side if RTL. floating-point
        var farCoord = segHCoords.levelCoord + segHCoords.thickness; // the right side if LTR. the left side if RTL. floating-point
        var left; // amount of space from left edge, a fraction of the total width
        var right; // amount of space from right edge, a fraction of the total width
        if (shouldOverlap) {
            // double the width, but don't go beyond the maximum forward coordinate (1.0)
            farCoord = Math.min(1, nearCoord + (farCoord - nearCoord) * 2);
        }
        if (isRtl) {
            left = 1 - farCoord;
            right = nearCoord;
        }
        else {
            left = nearCoord;
            right = 1 - farCoord;
        }
        var props = {
            zIndex: segHCoords.stackDepth + 1,
            left: left * 100 + '%',
            right: right * 100 + '%',
        };
        if (shouldOverlap && !segHCoords.stackForward) {
            // add padding to the edge so that forward stacked events don't cover the resizer's icon
            props[isRtl ? 'marginLeft' : 'marginRight'] = 10 * 2; // 10 is a guesstimate of the icon's width
        }
        return props;
    };
    return TimeCol;
}(common.BaseComponent));
function renderPlainFgSegs(sortedFgSegs, _a) {
    var todayRange = _a.todayRange, nowDate = _a.nowDate, eventSelection = _a.eventSelection, eventDrag = _a.eventDrag, eventResize = _a.eventResize;
    var hiddenInstances = (eventDrag ? eventDrag.affectedInstances : null) ||
        (eventResize ? eventResize.affectedInstances : null) ||
        {};
    return (common.createElement(common.Fragment, null, sortedFgSegs.map(function (seg) {
        var instanceId = seg.eventRange.instance.instanceId;
        return (common.createElement("div", { key: instanceId, style: { visibility: hiddenInstances[instanceId] ? 'hidden' : '' } },
            common.createElement(TimeColEvent, tslib.__assign({ seg: seg, isDragging: false, isResizing: false, isDateSelecting: false, isSelected: instanceId === eventSelection, isShort: false }, common.getSegMeta(seg, todayRange, nowDate)))));
    })));
}
function computeSegVStyle(segVCoords) {
    if (!segVCoords) {
        return { top: '', bottom: '' };
    }
    return {
        top: segVCoords.start,
        bottom: -segVCoords.end,
    };
}
function compileSegsFromEntries(segEntries, allSegs) {
    return segEntries.map(function (segEntry) { return allSegs[segEntry.index]; });
}

var TimeColsContent = /** @class */ (function (_super) {
    tslib.__extends(TimeColsContent, _super);
    function TimeColsContent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.splitFgEventSegs = common.memoize(splitSegsByCol);
        _this.splitBgEventSegs = common.memoize(splitSegsByCol);
        _this.splitBusinessHourSegs = common.memoize(splitSegsByCol);
        _this.splitNowIndicatorSegs = common.memoize(splitSegsByCol);
        _this.splitDateSelectionSegs = common.memoize(splitSegsByCol);
        _this.splitEventDrag = common.memoize(splitInteractionByCol);
        _this.splitEventResize = common.memoize(splitInteractionByCol);
        _this.rootElRef = common.createRef();
        _this.cellElRefs = new common.RefMap();
        return _this;
    }
    TimeColsContent.prototype.render = function () {
        var _this = this;
        var _a = this, props = _a.props, context = _a.context;
        var nowIndicatorTop = context.options.nowIndicator &&
            props.slatCoords &&
            props.slatCoords.safeComputeTop(props.nowDate); // might return void
        var colCnt = props.cells.length;
        var fgEventSegsByRow = this.splitFgEventSegs(props.fgEventSegs, colCnt);
        var bgEventSegsByRow = this.splitBgEventSegs(props.bgEventSegs, colCnt);
        var businessHourSegsByRow = this.splitBusinessHourSegs(props.businessHourSegs, colCnt);
        var nowIndicatorSegsByRow = this.splitNowIndicatorSegs(props.nowIndicatorSegs, colCnt);
        var dateSelectionSegsByRow = this.splitDateSelectionSegs(props.dateSelectionSegs, colCnt);
        var eventDragByRow = this.splitEventDrag(props.eventDrag, colCnt);
        var eventResizeByRow = this.splitEventResize(props.eventResize, colCnt);
        return (common.createElement("div", { className: "fc-timegrid-cols", ref: this.rootElRef },
            common.createElement("table", { style: {
                    minWidth: props.tableMinWidth,
                    width: props.clientWidth,
                } },
                props.tableColGroupNode,
                common.createElement("tbody", null,
                    common.createElement("tr", null,
                        props.axis && (common.createElement("td", { className: "fc-timegrid-col fc-timegrid-axis" },
                            common.createElement("div", { className: "fc-timegrid-col-frame" },
                                common.createElement("div", { className: "fc-timegrid-now-indicator-container" }, typeof nowIndicatorTop === 'number' && (common.createElement(common.NowIndicatorRoot, { isAxis: true, date: props.nowDate }, function (rootElRef, classNames, innerElRef, innerContent) { return (common.createElement("div", { ref: rootElRef, className: ['fc-timegrid-now-indicator-arrow'].concat(classNames).join(' '), style: { top: nowIndicatorTop } }, innerContent)); })))))),
                        props.cells.map(function (cell, i) { return (common.createElement(TimeCol, { key: cell.key, elRef: _this.cellElRefs.createRef(cell.key), dateProfile: props.dateProfile, date: cell.date, nowDate: props.nowDate, todayRange: props.todayRange, extraHookProps: cell.extraHookProps, extraDataAttrs: cell.extraDataAttrs, extraClassNames: cell.extraClassNames, extraDateSpan: cell.extraDateSpan, fgEventSegs: fgEventSegsByRow[i], bgEventSegs: bgEventSegsByRow[i], businessHourSegs: businessHourSegsByRow[i], nowIndicatorSegs: nowIndicatorSegsByRow[i], dateSelectionSegs: dateSelectionSegsByRow[i], eventDrag: eventDragByRow[i], eventResize: eventResizeByRow[i], slatCoords: props.slatCoords, eventSelection: props.eventSelection, forPrint: props.forPrint })); }))))));
    };
    TimeColsContent.prototype.componentDidMount = function () {
        this.updateCoords();
    };
    TimeColsContent.prototype.componentDidUpdate = function () {
        this.updateCoords();
    };
    TimeColsContent.prototype.updateCoords = function () {
        var props = this.props;
        if (props.onColCoords &&
            props.clientWidth !== null // means sizing has stabilized
        ) {
            props.onColCoords(new common.PositionCache(this.rootElRef.current, collectCellEls(this.cellElRefs.currentMap, props.cells), true, // horizontal
            false));
        }
    };
    return TimeColsContent;
}(common.BaseComponent));
function collectCellEls(elMap, cells) {
    return cells.map(function (cell) { return elMap[cell.key]; });
}

/* A component that renders one or more columns of vertical time slots
----------------------------------------------------------------------------------------------------------------------*/
var TimeCols = /** @class */ (function (_super) {
    tslib.__extends(TimeCols, _super);
    function TimeCols() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.processSlotOptions = common.memoize(processSlotOptions);
        _this.state = {
            slatCoords: null,
        };
        _this.handleRootEl = function (el) {
            if (el) {
                _this.context.registerInteractiveComponent(_this, {
                    el: el,
                    isHitComboAllowed: _this.props.isHitComboAllowed,
                });
            }
            else {
                _this.context.unregisterInteractiveComponent(_this);
            }
        };
        _this.handleScrollRequest = function (request) {
            var onScrollTopRequest = _this.props.onScrollTopRequest;
            var slatCoords = _this.state.slatCoords;
            if (onScrollTopRequest && slatCoords) {
                if (request.time) {
                    var top_1 = slatCoords.computeTimeTop(request.time);
                    top_1 = Math.ceil(top_1); // zoom can give weird floating-point values. rather scroll a little bit further
                    if (top_1) {
                        top_1 += 1; // to overcome top border that slots beyond the first have. looks better
                    }
                    onScrollTopRequest(top_1);
                }
                return true;
            }
            return false;
        };
        _this.handleColCoords = function (colCoords) {
            _this.colCoords = colCoords;
        };
        _this.handleSlatCoords = function (slatCoords) {
            _this.setState({ slatCoords: slatCoords });
            if (_this.props.onSlatCoords) {
                _this.props.onSlatCoords(slatCoords);
            }
        };
        return _this;
    }
    TimeCols.prototype.render = function () {
        var _a = this, props = _a.props, state = _a.state;
        return (common.createElement("div", { className: "fc-timegrid-body", ref: this.handleRootEl, style: {
                // these props are important to give this wrapper correct dimensions for interactions
                // TODO: if we set it here, can we avoid giving to inner tables?
                width: props.clientWidth,
                minWidth: props.tableMinWidth,
            } },
            common.createElement(TimeColsSlats, { axis: props.axis, dateProfile: props.dateProfile, slatMetas: props.slatMetas, clientWidth: props.clientWidth, minHeight: props.expandRows ? props.clientHeight : '', tableMinWidth: props.tableMinWidth, tableColGroupNode: props.axis ? props.tableColGroupNode : null /* axis depends on the colgroup's shrinking */, onCoords: this.handleSlatCoords }),
            common.createElement(TimeColsContent, { cells: props.cells, axis: props.axis, dateProfile: props.dateProfile, businessHourSegs: props.businessHourSegs, bgEventSegs: props.bgEventSegs, fgEventSegs: props.fgEventSegs, dateSelectionSegs: props.dateSelectionSegs, eventSelection: props.eventSelection, eventDrag: props.eventDrag, eventResize: props.eventResize, todayRange: props.todayRange, nowDate: props.nowDate, nowIndicatorSegs: props.nowIndicatorSegs, clientWidth: props.clientWidth, tableMinWidth: props.tableMinWidth, tableColGroupNode: props.tableColGroupNode, slatCoords: state.slatCoords, onColCoords: this.handleColCoords, forPrint: props.forPrint })));
    };
    TimeCols.prototype.componentDidMount = function () {
        this.scrollResponder = this.context.createScrollResponder(this.handleScrollRequest);
    };
    TimeCols.prototype.componentDidUpdate = function (prevProps) {
        this.scrollResponder.update(prevProps.dateProfile !== this.props.dateProfile);
    };
    TimeCols.prototype.componentWillUnmount = function () {
        this.scrollResponder.detach();
    };
    TimeCols.prototype.queryHit = function (positionLeft, positionTop) {
        var _a = this.context, dateEnv = _a.dateEnv, options = _a.options;
        var colCoords = this.colCoords;
        var dateProfile = this.props.dateProfile;
        var slatCoords = this.state.slatCoords;
        var _b = this.processSlotOptions(this.props.slotDuration, options.snapDuration), snapDuration = _b.snapDuration, snapsPerSlot = _b.snapsPerSlot;
        var colIndex = colCoords.leftToIndex(positionLeft);
        var slatIndex = slatCoords.positions.topToIndex(positionTop);
        if (colIndex != null && slatIndex != null) {
            var cell = this.props.cells[colIndex];
            var slatTop = slatCoords.positions.tops[slatIndex];
            var slatHeight = slatCoords.positions.getHeight(slatIndex);
            var partial = (positionTop - slatTop) / slatHeight; // floating point number between 0 and 1
            var localSnapIndex = Math.floor(partial * snapsPerSlot); // the snap # relative to start of slat
            var snapIndex = slatIndex * snapsPerSlot + localSnapIndex;
            var dayDate = this.props.cells[colIndex].date;
            var time = common.addDurations(dateProfile.slotMinTime, common.multiplyDuration(snapDuration, snapIndex));
            var start = dateEnv.add(dayDate, time);
            var end = dateEnv.add(start, snapDuration);
            return {
                dateProfile: dateProfile,
                dateSpan: tslib.__assign({ range: { start: start, end: end }, allDay: false }, cell.extraDateSpan),
                dayEl: colCoords.els[colIndex],
                rect: {
                    left: colCoords.lefts[colIndex],
                    right: colCoords.rights[colIndex],
                    top: slatTop,
                    bottom: slatTop + slatHeight,
                },
                layer: 0,
            };
        }
        return null;
    };
    return TimeCols;
}(common.DateComponent));
function processSlotOptions(slotDuration, snapDurationOverride) {
    var snapDuration = snapDurationOverride || slotDuration;
    var snapsPerSlot = common.wholeDivideDurations(slotDuration, snapDuration);
    if (snapsPerSlot === null) {
        snapDuration = slotDuration;
        snapsPerSlot = 1;
        // TODO: say warning?
    }
    return { snapDuration: snapDuration, snapsPerSlot: snapsPerSlot };
}

var DayTimeColsSlicer = /** @class */ (function (_super) {
    tslib.__extends(DayTimeColsSlicer, _super);
    function DayTimeColsSlicer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DayTimeColsSlicer.prototype.sliceRange = function (range, dayRanges) {
        var segs = [];
        for (var col = 0; col < dayRanges.length; col += 1) {
            var segRange = common.intersectRanges(range, dayRanges[col]);
            if (segRange) {
                segs.push({
                    start: segRange.start,
                    end: segRange.end,
                    isStart: segRange.start.valueOf() === range.start.valueOf(),
                    isEnd: segRange.end.valueOf() === range.end.valueOf(),
                    col: col,
                });
            }
        }
        return segs;
    };
    return DayTimeColsSlicer;
}(common.Slicer));

var DayTimeCols = /** @class */ (function (_super) {
    tslib.__extends(DayTimeCols, _super);
    function DayTimeCols() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.buildDayRanges = common.memoize(buildDayRanges);
        _this.slicer = new DayTimeColsSlicer();
        _this.timeColsRef = common.createRef();
        return _this;
    }
    DayTimeCols.prototype.render = function () {
        var _this = this;
        var _a = this, props = _a.props, context = _a.context;
        var dateProfile = props.dateProfile, dayTableModel = props.dayTableModel;
        var isNowIndicator = context.options.nowIndicator;
        var dayRanges = this.buildDayRanges(dayTableModel, dateProfile, context.dateEnv);
        // give it the first row of cells
        // TODO: would move this further down hierarchy, but sliceNowDate needs it
        return (common.createElement(common.NowTimer, { unit: isNowIndicator ? 'minute' : 'day' }, function (nowDate, todayRange) { return (common.createElement(TimeCols, tslib.__assign({ ref: _this.timeColsRef }, _this.slicer.sliceProps(props, dateProfile, null, context, dayRanges), { forPrint: props.forPrint, axis: props.axis, dateProfile: dateProfile, slatMetas: props.slatMetas, slotDuration: props.slotDuration, cells: dayTableModel.cells[0], tableColGroupNode: props.tableColGroupNode, tableMinWidth: props.tableMinWidth, clientWidth: props.clientWidth, clientHeight: props.clientHeight, expandRows: props.expandRows, nowDate: nowDate, nowIndicatorSegs: isNowIndicator && _this.slicer.sliceNowDate(nowDate, context, dayRanges), todayRange: todayRange, onScrollTopRequest: props.onScrollTopRequest, onSlatCoords: props.onSlatCoords }))); }));
    };
    return DayTimeCols;
}(common.DateComponent));
function buildDayRanges(dayTableModel, dateProfile, dateEnv) {
    var ranges = [];
    for (var _i = 0, _a = dayTableModel.headerDates; _i < _a.length; _i++) {
        var date = _a[_i];
        ranges.push({
            start: dateEnv.add(date, dateProfile.slotMinTime),
            end: dateEnv.add(date, dateProfile.slotMaxTime),
        });
    }
    return ranges;
}

// potential nice values for the slot-duration and interval-duration
// from largest to smallest
var STOCK_SUB_DURATIONS = [
    { hours: 1 },
    { minutes: 30 },
    { minutes: 15 },
    { seconds: 30 },
    { seconds: 15 },
];
function buildSlatMetas(slotMinTime, slotMaxTime, explicitLabelInterval, slotDuration, dateEnv) {
    var dayStart = new Date(0);
    var slatTime = slotMinTime;
    var slatIterator = common.createDuration(0);
    var labelInterval = explicitLabelInterval || computeLabelInterval(slotDuration);
    var metas = [];
    while (common.asRoughMs(slatTime) < common.asRoughMs(slotMaxTime)) {
        var date = dateEnv.add(dayStart, slatTime);
        var isLabeled = common.wholeDivideDurations(slatIterator, labelInterval) !== null;
        metas.push({
            date: date,
            time: slatTime,
            key: date.toISOString(),
            isoTimeStr: common.formatIsoTimeString(date),
            isLabeled: isLabeled,
        });
        slatTime = common.addDurations(slatTime, slotDuration);
        slatIterator = common.addDurations(slatIterator, slotDuration);
    }
    return metas;
}
// Computes an automatic value for slotLabelInterval
function computeLabelInterval(slotDuration) {
    var i;
    var labelInterval;
    var slotsPerLabel;
    // find the smallest stock label interval that results in more than one slots-per-label
    for (i = STOCK_SUB_DURATIONS.length - 1; i >= 0; i -= 1) {
        labelInterval = common.createDuration(STOCK_SUB_DURATIONS[i]);
        slotsPerLabel = common.wholeDivideDurations(labelInterval, slotDuration);
        if (slotsPerLabel !== null && slotsPerLabel > 1) {
            return labelInterval;
        }
    }
    return slotDuration; // fall back
}

var DayTimeColsView = /** @class */ (function (_super) {
    tslib.__extends(DayTimeColsView, _super);
    function DayTimeColsView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.buildTimeColsModel = common.memoize(buildTimeColsModel);
        _this.buildSlatMetas = common.memoize(buildSlatMetas);
        return _this;
    }
    DayTimeColsView.prototype.render = function () {
        var _this = this;
        var _a = this.context, options = _a.options, dateEnv = _a.dateEnv, dateProfileGenerator = _a.dateProfileGenerator;
        var props = this.props;
        var dateProfile = props.dateProfile;
        var dayTableModel = this.buildTimeColsModel(dateProfile, dateProfileGenerator);
        var splitProps = this.allDaySplitter.splitProps(props);
        var slatMetas = this.buildSlatMetas(dateProfile.slotMinTime, dateProfile.slotMaxTime, options.slotLabelInterval, options.slotDuration, dateEnv);
        var dayMinWidth = options.dayMinWidth;
        var hasAttachedAxis = !dayMinWidth;
        var hasDetachedAxis = dayMinWidth;
        var headerContent = options.dayHeaders && (common.createElement(common.DayHeader, { dates: dayTableModel.headerDates, dateProfile: dateProfile, datesRepDistinctDays: true, renderIntro: hasAttachedAxis ? this.renderHeadAxis : null }));
        var allDayContent = (options.allDaySlot !== false) && (function (contentArg) { return (common.createElement(daygrid.DayTable, tslib.__assign({}, splitProps.allDay, { dateProfile: dateProfile, dayTableModel: dayTableModel, nextDayThreshold: options.nextDayThreshold, tableMinWidth: contentArg.tableMinWidth, colGroupNode: contentArg.tableColGroupNode, renderRowIntro: hasAttachedAxis ? _this.renderTableRowAxis : null, showWeekNumbers: false, expandRows: false, headerAlignElRef: _this.headerElRef, clientWidth: contentArg.clientWidth, clientHeight: contentArg.clientHeight, forPrint: props.forPrint }, _this.getAllDayMaxEventProps()))); });
        var timeGridContent = function (contentArg) { return (common.createElement(DayTimeCols, tslib.__assign({}, splitProps.timed, { dayTableModel: dayTableModel, dateProfile: dateProfile, axis: hasAttachedAxis, slotDuration: options.slotDuration, slatMetas: slatMetas, forPrint: props.forPrint, tableColGroupNode: contentArg.tableColGroupNode, tableMinWidth: contentArg.tableMinWidth, clientWidth: contentArg.clientWidth, clientHeight: contentArg.clientHeight, onSlatCoords: _this.handleSlatCoords, expandRows: contentArg.expandRows, onScrollTopRequest: _this.handleScrollTopRequest }))); };
        return hasDetachedAxis
            ? this.renderHScrollLayout(headerContent, allDayContent, timeGridContent, dayTableModel.colCnt, dayMinWidth, slatMetas, this.state.slatCoords)
            : this.renderSimpleLayout(headerContent, allDayContent, timeGridContent);
    };
    return DayTimeColsView;
}(TimeColsView));
function buildTimeColsModel(dateProfile, dateProfileGenerator) {
    var daySeries = new common.DaySeriesModel(dateProfile.renderRange, dateProfileGenerator);
    return new common.DayTableModel(daySeries, false);
}

var OPTION_REFINERS = {
    allDaySlot: Boolean,
};

var main = common.createPlugin({
    initialView: 'timeGridWeek',
    optionRefiners: OPTION_REFINERS,
    views: {
        timeGrid: {
            component: DayTimeColsView,
            usesMinMaxTime: true,
            allDaySlot: true,
            slotDuration: '00:30:00',
            slotEventOverlap: true, // a bad name. confused with overlap/constraint system
        },
        timeGridDay: {
            type: 'timeGrid',
            duration: { days: 1 },
        },
        timeGridWeek: {
            type: 'timeGrid',
            duration: { weeks: 1 },
        },
    },
});

exports.DayTimeCols = DayTimeCols;
exports.DayTimeColsSlicer = DayTimeColsSlicer;
exports.DayTimeColsView = DayTimeColsView;
exports.TimeCols = TimeCols;
exports.TimeColsSlatsCoords = TimeColsSlatsCoords;
exports.TimeColsView = TimeColsView;
exports.buildDayRanges = buildDayRanges;
exports.buildSlatMetas = buildSlatMetas;
exports.buildTimeColsModel = buildTimeColsModel;
exports.default = main;

},{"@fullcalendar/common":3,"@fullcalendar/daygrid":8,"tslib":782}],15:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var Vue = require('vue');
var core = require('@fullcalendar/core');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var Vue__default = /*#__PURE__*/_interopDefaultLegacy(Vue);

var OPTION_IS_COMPLEX = {
    headerToolbar: true,
    footerToolbar: true,
    events: true,
    eventSources: true,
    resources: true
};

// TODO: add types!
/*
works with objects and arrays
*/
function shallowCopy(val) {
    if (typeof val === 'object') {
        if (Array.isArray(val)) {
            val = Array.prototype.slice.call(val);
        }
        else if (val) { // non-null
            val = tslib.__assign({}, val);
        }
    }
    return val;
}
function mapHash(input, func) {
    var output = {};
    for (var key in input) {
        if (input.hasOwnProperty(key)) {
            output[key] = func(input[key], key);
        }
    }
    return output;
}

/*
wrap it in an object with a `vue` key, which the custom content-type handler system will look for
*/
function wrapVDomGenerator(vDomGenerator) {
    return function (props) {
        return { vue: vDomGenerator(props) };
    };
}
function createVueContentTypePlugin(parent) {
    return core.createPlugin({
        contentTypeHandlers: {
            vue: function () { return buildVDomHandler(parent); }, // looks for the `vue` key
        }
    });
}
function buildVDomHandler(parent) {
    var currentEl;
    var v; // the Vue instance
    function render(el, vDomContent) {
        if (currentEl !== el) {
            if (currentEl && v) { // if changing elements, recreate the vue
                v.$destroy();
            }
            currentEl = el;
        }
        if (!v) {
            v = initVue(vDomContent, parent);
            // vue's mount method *replaces* the given element. create an artificial inner el
            var innerEl = document.createElement('span');
            el.appendChild(innerEl);
            v.$mount(innerEl);
        }
        else {
            v.content = vDomContent;
        }
    }
    function destroy() {
        if (v) { // needed?
            v.$destroy();
        }
    }
    return { render: render, destroy: destroy };
}
function initVue(initialContent, parent) {
    return new Vue__default['default']({
        parent: parent,
        data: {
            content: initialContent,
        },
        render: function (h) {
            var content = this.content;
            // the slot result can be an array, but the returned value of a vue component's
            // render method must be a single node.
            if (content.length === 1) {
                return content[0];
            }
            else {
                return h('span', {}, content);
            }
        }
    });
}

var FullCalendar = Vue__default['default'].extend({
    props: {
        options: Object
    },
    data: initData,
    render: function (createElement) {
        return createElement('div', {
            // when renderId is changed, Vue will trigger a real-DOM async rerender, calling beforeUpdate/updated
            attrs: { 'data-fc-render-id': this.renderId }
        });
    },
    mounted: function () {
        var internal = this.$options;
        internal.scopedSlotOptions = mapHash(this.$scopedSlots, wrapVDomGenerator); // needed for buildOptions
        var calendar = new core.Calendar(this.$el, this.buildOptions(this.options, this));
        internal.calendar = calendar;
        calendar.render();
    },
    methods: {
        getApi: getApi,
        buildOptions: buildOptions,
    },
    beforeUpdate: function () {
        this.getApi().resumeRendering(); // the watcher handlers paused it
    },
    beforeDestroy: function () {
        this.getApi().destroy();
    },
    watch: buildWatchers()
});
function initData() {
    return {
        renderId: 0
    };
}
function buildOptions(suppliedOptions, parent) {
    var internal = this.$options;
    suppliedOptions = suppliedOptions || {};
    return tslib.__assign(tslib.__assign(tslib.__assign({}, internal.scopedSlotOptions), suppliedOptions), { plugins: (suppliedOptions.plugins || []).concat([
            createVueContentTypePlugin(parent)
        ]) });
}
function getApi() {
    var internal = this.$options;
    return internal.calendar;
}
function buildWatchers() {
    var watchers = {
        // watches changes of ALL options and their nested objects,
        // but this is only a means to be notified of top-level non-complex options changes.
        options: {
            deep: true,
            handler: function (options) {
                var calendar = this.getApi();
                calendar.pauseRendering();
                calendar.resetOptions(this.buildOptions(options, this));
                this.renderId++; // will queue a rerender
            }
        }
    };
    var _loop_1 = function (complexOptionName) {
        // handlers called when nested objects change
        watchers["options." + complexOptionName] = {
            deep: true,
            handler: function (val) {
                var _a;
                // unfortunately the handler is called with undefined if new props were set, but the complex one wasn't ever set
                if (val !== undefined) {
                    var calendar = this.getApi();
                    calendar.pauseRendering();
                    calendar.resetOptions((_a = {},
                        // the only reason we shallow-copy is to trick FC into knowing there's a nested change.
                        // TODO: future versions of FC will more gracefully handle event option-changes that are same-reference.
                        _a[complexOptionName] = shallowCopy(val),
                        _a), true);
                    this.renderId++; // will queue a rerender
                }
            }
        };
    };
    for (var complexOptionName in OPTION_IS_COMPLEX) {
        _loop_1(complexOptionName);
    }
    return watchers;
}

/*
Registers the component globally if appropriate.
This modules exposes the component AND an install function.

Derived from:
https://vuejs.org/v2/cookbook/packaging-sfc-for-npm.html
*/
var installed = false;
// declare install function executed by Vue.use()
function install(Vue) {
    if (!installed) {
        installed = true;
        Vue.component('FullCalendar', FullCalendar);
    }
}
// detect a globally availble version of Vue (eg. in browser via <script> tag)
var GlobalVue;
if (typeof globalThis !== 'undefined') {
    GlobalVue = globalThis.Vue;
}
else {
    GlobalVue = window.Vue;
}
// auto-install if possible
if (GlobalVue) {
    GlobalVue.use({
        install: install
    });
}

exports.default = FullCalendar;
exports.install = install;
Object.keys(core).forEach(function (k) {
    if (k !== 'default' && !exports.hasOwnProperty(k)) Object.defineProperty(exports, k, {
        enumerable: true,
        get: function () {
            return core[k];
        }
    });
});

},{"@fullcalendar/core":6,"tslib":782,"vue":795}],16:[function(require,module,exports){
(function (process){
/**
 * @popperjs/core v2.9.2 - MIT License
 */

'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function getBoundingClientRect(element) {
  var rect = element.getBoundingClientRect();
  return {
    width: rect.width,
    height: rect.height,
    top: rect.top,
    right: rect.right,
    bottom: rect.bottom,
    left: rect.left,
    x: rect.left,
    y: rect.top
  };
}

function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}

function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}

function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}

function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

// Composite means it takes into account transforms as well as layout.

function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement);
  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}

function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback

  );
}

function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent(getParentNode(node));
}

/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}

function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') !== -1;
  var isIE = navigator.userAgent.indexOf('Trident') !== -1;

  if (isIE && isHTMLElement(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = getParentNode(element);

  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}

var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}

function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}

function format(str) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return [].concat(args).reduce(function (p, c) {
    return p.replace(/%s/, c);
  }, str);
}

var INVALID_MODIFIER_ERROR = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s';
var MISSING_DEPENDENCY_ERROR = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available';
var VALID_PROPERTIES = ['name', 'enabled', 'phase', 'fn', 'effect', 'requires', 'options'];
function validateModifiers(modifiers) {
  modifiers.forEach(function (modifier) {
    Object.keys(modifier).forEach(function (key) {
      switch (key) {
        case 'name':
          if (typeof modifier.name !== 'string') {
            console.error(format(INVALID_MODIFIER_ERROR, String(modifier.name), '"name"', '"string"', "\"" + String(modifier.name) + "\""));
          }

          break;

        case 'enabled':
          if (typeof modifier.enabled !== 'boolean') {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"enabled"', '"boolean"', "\"" + String(modifier.enabled) + "\""));
          }

        case 'phase':
          if (modifierPhases.indexOf(modifier.phase) < 0) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"phase"', "either " + modifierPhases.join(', '), "\"" + String(modifier.phase) + "\""));
          }

          break;

        case 'fn':
          if (typeof modifier.fn !== 'function') {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"fn"', '"function"', "\"" + String(modifier.fn) + "\""));
          }

          break;

        case 'effect':
          if (typeof modifier.effect !== 'function') {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"effect"', '"function"', "\"" + String(modifier.fn) + "\""));
          }

          break;

        case 'requires':
          if (!Array.isArray(modifier.requires)) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requires"', '"array"', "\"" + String(modifier.requires) + "\""));
          }

          break;

        case 'requiresIfExists':
          if (!Array.isArray(modifier.requiresIfExists)) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requiresIfExists"', '"array"', "\"" + String(modifier.requiresIfExists) + "\""));
          }

          break;

        case 'options':
        case 'data':
          break;

        default:
          console.error("PopperJS: an invalid property has been provided to the \"" + modifier.name + "\" modifier, valid properties are " + VALID_PROPERTIES.map(function (s) {
            return "\"" + s + "\"";
          }).join(', ') + "; but \"" + key + "\" was provided.");
      }

      modifier.requires && modifier.requires.forEach(function (requirement) {
        if (modifiers.find(function (mod) {
          return mod.name === requirement;
        }) == null) {
          console.error(format(MISSING_DEPENDENCY_ERROR, String(modifier.name), requirement, requirement));
        }
      });
    });
  });
}

function uniqueBy(arr, fn) {
  var identifiers = new Set();
  return arr.filter(function (item) {
    var identifier = fn(item);

    if (!identifiers.has(identifier)) {
      identifiers.add(identifier);
      return true;
    }
  });
}

function getBasePlacement(placement) {
  return placement.split('-')[0];
}

function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}

function getViewportRect(element) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0; // NB: This isn't supported on iOS <= 12. If the keyboard is open, the popper
  // can be obscured underneath it.
  // Also, `html.clientHeight` adds the bottom bar height in Safari iOS, even
  // if it isn't open, so if this isn't available, the popper will be detected
  // to overflow the bottom of the screen too early.

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height; // Uses Layout Viewport (like Chrome; Safari does not currently)
    // In Chrome, it returns a value very close to 0 (+/-) but contains rounding
    // errors due to floating point numbers, so we need to check precision.
    // Safari returns a number <= 0, usually < -1 when pinch-zoomed
    // Feature detection fails in mobile emulation mode in Chrome.
    // Math.abs(win.innerWidth / visualViewport.scale - visualViewport.width) <
    // 0.001
    // Fallback here: "Not Safari" userAgent

    if (!/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}

var max = Math.max;
var min = Math.min;
var round = Math.round;

// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle(body || html).direction === 'rtl') {
    x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}

function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}

function getInnerBoundingClientRect(element) {
  var rect = getBoundingClientRect(element);
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element)) : isHTMLElement(clippingParent) ? getInnerBoundingClientRect(clippingParent) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;

  if (!isElement(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}

function getVariation(placement) {
  return placement.split('-')[1];
}

function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}

function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;
    }
  }

  return offsets;
}

function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}

function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var referenceElement = state.elements.reference;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary);
  var referenceClientRect = getBoundingClientRect(referenceElement);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}

var INVALID_ELEMENT_ERROR = 'Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.';
var INFINITE_LOOP_ERROR = 'Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.';
var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(options) {
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        }); // Validate the provided modifiers so that the consumer will get warned
        // if one of the modifiers is invalid for any reason

        if (process.env.NODE_ENV !== "production") {
          var modifiers = uniqueBy([].concat(orderedModifiers, state.options.modifiers), function (_ref) {
            var name = _ref.name;
            return name;
          });
          validateModifiers(modifiers);

          if (getBasePlacement(state.options.placement) === auto) {
            var flipModifier = state.orderedModifiers.find(function (_ref2) {
              var name = _ref2.name;
              return name === 'flip';
            });

            if (!flipModifier) {
              console.error(['Popper: "auto" placements require the "flip" modifier be', 'present and enabled to work.'].join(' '));
            }
          }

          var _getComputedStyle = getComputedStyle(popper),
              marginTop = _getComputedStyle.marginTop,
              marginRight = _getComputedStyle.marginRight,
              marginBottom = _getComputedStyle.marginBottom,
              marginLeft = _getComputedStyle.marginLeft; // We no longer take into account `margins` on the popper, and it can
          // cause bugs with positioning, so we'll warn the consumer


          if ([marginTop, marginRight, marginBottom, marginLeft].some(function (margin) {
            return parseFloat(margin);
          })) {
            console.warn(['Popper: CSS "margin" styles cannot be used to apply padding', 'between the popper and its reference element or boundary.', 'To replicate margin, use the `offset` modifier, as well as', 'the `padding` option in the `preventOverflow` and `flip`', 'modifiers.'].join(' '));
          }
        }

        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          if (process.env.NODE_ENV !== "production") {
            console.error(INVALID_ELEMENT_ERROR);
          }

          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        var __debug_loops__ = 0;

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (process.env.NODE_ENV !== "production") {
            __debug_loops__ += 1;

            if (__debug_loops__ > 100) {
              console.error(INFINITE_LOOP_ERROR);
              break;
            }
          }

          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      if (process.env.NODE_ENV !== "production") {
        console.error(INVALID_ELEMENT_ERROR);
      }

      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref3) {
        var name = _ref3.name,
            _ref3$options = _ref3.options,
            options = _ref3$options === void 0 ? {} : _ref3$options,
            effect = _ref3.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}

var passive = {
  passive: true
};

function effect$2(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


var eventListeners = {
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect$2,
  data: {}
};

function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var popperOffsets$1 = {
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
};

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref) {
  var x = _ref.x,
      y = _ref.y;
  var win = window;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(round(x * dpr) / dpr) || 0,
    y: round(round(y * dpr) / dpr) || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets;

  var _ref3 = roundOffsets === true ? roundOffsetsByDPR(offsets) : typeof roundOffsets === 'function' ? roundOffsets(offsets) : offsets,
      _ref3$x = _ref3.x,
      x = _ref3$x === void 0 ? 0 : _ref3$x,
      _ref3$y = _ref3.y,
      y = _ref3$y === void 0 ? 0 : _ref3$y;

  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = top;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);

      if (getComputedStyle(offsetParent).position !== 'static') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === top) {
      sideY = bottom; // $FlowFixMe[prop-missing]

      y -= offsetParent[heightProp] - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === left) {
      sideX = right; // $FlowFixMe[prop-missing]

      x -= offsetParent[widthProp] - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) < 2 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref4) {
  var state = _ref4.state,
      options = _ref4.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;

  if (process.env.NODE_ENV !== "production") {
    var transitionProperty = getComputedStyle(state.elements.popper).transitionProperty || '';

    if (adaptive && ['transform', 'top', 'right', 'bottom', 'left'].some(function (property) {
      return transitionProperty.indexOf(property) >= 0;
    })) {
      console.warn(['Popper: Detected CSS transitions on at least one of the following', 'CSS properties: "transform", "top", "right", "bottom", "left".', '\n\n', 'Disable the "computeStyles" modifier\'s `adaptive` option to allow', 'for smooth transitions, or remove these properties from the CSS', 'transition declaration on the popper element if only transitioning', 'opacity or background-color for example.', '\n\n', 'We recommend using the popper element as a wrapper around an inner', 'element that can have any CSS property transitioned for animations.'].join(' '));
    }
  }

  var commonStyles = {
    placement: getBasePlacement(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var computeStyles$1 = {
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
};

// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function effect$1(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


var applyStyles$1 = {
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: effect$1,
  requires: ['computeStyles']
};

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var offset$1 = {
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
};

var hash$1 = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash$1[matched];
  });
}

var hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return hash[matched];
  });
}

function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$1.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$1;

    if (process.env.NODE_ENV !== "production") {
      console.error(['Popper: The `allowedAutoPlacements` option did not allow any', 'placements. Ensure the `placement` option matches the variation', 'of the allowed placements.', 'For example, "auto" cannot be used to allow "bottom-start".', 'Use "auto-start" instead.'].join(' '));
    }
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = getBasePlacement(placement);

    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


var flip$1 = {
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
};

function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

function within(min$1, value, max$1) {
  return max(min$1, min(value, max$1));
}

function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis || checkAltAxis) {
    var mainSide = mainAxis === 'y' ? top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min$1 = popperOffsets[mainAxis] + overflow[mainSide];
    var max$1 = popperOffsets[mainAxis] - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - tetherOffsetValue : minLen - arrowLen - arrowPaddingMin - tetherOffsetValue;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + tetherOffsetValue : maxLen + arrowLen + arrowPaddingMax + tetherOffsetValue;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = state.modifiersData.offset ? state.modifiersData.offset[state.placement][mainAxis] : 0;
    var tetherMin = popperOffsets[mainAxis] + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = popperOffsets[mainAxis] + maxOffset - offsetModifierValue;

    if (checkMainAxis) {
      var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset, tether ? max(max$1, tetherMax) : max$1);
      popperOffsets[mainAxis] = preventedOffset;
      data[mainAxis] = preventedOffset - offset;
    }

    if (checkAltAxis) {
      var _mainSide = mainAxis === 'x' ? top : left;

      var _altSide = mainAxis === 'x' ? bottom : right;

      var _offset = popperOffsets[altAxis];

      var _min = _offset + overflow[_mainSide];

      var _max = _offset - overflow[_altSide];

      var _preventedOffset = within(tether ? min(_min, tetherMin) : _min, _offset, tether ? max(_max, tetherMax) : _max);

      popperOffsets[altAxis] = _preventedOffset;
      data[altAxis] = _preventedOffset - _offset;
    }
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var preventOverflow$1 = {
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
};

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function effect(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (process.env.NODE_ENV !== "production") {
    if (!isHTMLElement(arrowElement)) {
      console.error(['Popper: "arrow" element must be an HTMLElement (not an SVGElement).', 'To use an SVG arrow, wrap it in an HTMLElement that will be used as', 'the arrow.'].join(' '));
    }
  }

  if (!contains(state.elements.popper, arrowElement)) {
    if (process.env.NODE_ENV !== "production") {
      console.error(['Popper: "arrow" modifier\'s `element` must be a child of the popper', 'element.'].join(' '));
    }

    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


var arrow$1 = {
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: effect,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
};

function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


var hide$1 = {
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
};

var defaultModifiers$1 = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1];
var createPopper$1 = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers$1
}); // eslint-disable-next-line import/no-unused-modules

var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
var createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

exports.applyStyles = applyStyles$1;
exports.arrow = arrow$1;
exports.computeStyles = computeStyles$1;
exports.createPopper = createPopper;
exports.createPopperLite = createPopper$1;
exports.defaultModifiers = defaultModifiers;
exports.detectOverflow = detectOverflow;
exports.eventListeners = eventListeners;
exports.flip = flip$1;
exports.hide = hide$1;
exports.offset = offset$1;
exports.popperGenerator = popperGenerator;
exports.popperOffsets = popperOffsets$1;
exports.preventOverflow = preventOverflow$1;


}).call(this,require('_process'))
},{"_process":734}],17:[function(require,module,exports){
module.exports = after

function after(count, callback, err_cb) {
    var bail = false
    err_cb = err_cb || noop
    proxy.count = count

    return (count === 0) ? callback() : proxy

    function proxy(err, result) {
        if (proxy.count <= 0) {
            throw new Error('after called too many times')
        }
        --proxy.count

        // after first error, rest are passed to err_cb
        if (err) {
            bail = true
            callback(err)
            // future error callbacks will go to error handler
            callback = err_cb
        } else if (proxy.count === 0 && !bail) {
            callback(null, result)
        }
    }
}

function noop() {}

},{}],18:[function(require,module,exports){
/**
 * An abstraction for slicing an arraybuffer even when
 * ArrayBuffer.prototype.slice is not supported
 *
 * @api public
 */

module.exports = function(arraybuffer, start, end) {
  var bytes = arraybuffer.byteLength;
  start = start || 0;
  end = end || bytes;

  if (arraybuffer.slice) { return arraybuffer.slice(start, end); }

  if (start < 0) { start += bytes; }
  if (end < 0) { end += bytes; }
  if (end > bytes) { end = bytes; }

  if (start >= bytes || start >= end || bytes === 0) {
    return new ArrayBuffer(0);
  }

  var abv = new Uint8Array(arraybuffer);
  var result = new Uint8Array(end - start);
  for (var i = start, ii = 0; i < end; i++, ii++) {
    result[ii] = abv[i];
  }
  return result.buffer;
};

},{}],19:[function(require,module,exports){
module.exports = require('./lib/axios');
},{"./lib/axios":21}],20:[function(require,module,exports){
(function (process){
'use strict';

var utils = require('./../utils');
var settle = require('./../core/settle');
var buildURL = require('./../helpers/buildURL');
var parseHeaders = require('./../helpers/parseHeaders');
var isURLSameOrigin = require('./../helpers/isURLSameOrigin');
var createError = require('../core/createError');
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || require('./../helpers/btoa');

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if (process.env.NODE_ENV !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/mzabriskie/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED'));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = require('./../helpers/cookies');

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        if (request.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};

}).call(this,require('_process'))
},{"../core/createError":27,"./../core/settle":30,"./../helpers/btoa":34,"./../helpers/buildURL":35,"./../helpers/cookies":37,"./../helpers/isURLSameOrigin":39,"./../helpers/parseHeaders":41,"./../utils":43,"_process":734}],21:[function(require,module,exports){
'use strict';

var utils = require('./utils');
var bind = require('./helpers/bind');
var Axios = require('./core/Axios');
var defaults = require('./defaults');

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = require('./cancel/Cancel');
axios.CancelToken = require('./cancel/CancelToken');
axios.isCancel = require('./cancel/isCancel');

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = require('./helpers/spread');

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;

},{"./cancel/Cancel":22,"./cancel/CancelToken":23,"./cancel/isCancel":24,"./core/Axios":25,"./defaults":32,"./helpers/bind":33,"./helpers/spread":42,"./utils":43}],22:[function(require,module,exports){
'use strict';

/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;

},{}],23:[function(require,module,exports){
'use strict';

var Cancel = require('./Cancel');

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;

},{"./Cancel":22}],24:[function(require,module,exports){
'use strict';

module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

},{}],25:[function(require,module,exports){
'use strict';

var defaults = require('./../defaults');
var utils = require('./../utils');
var InterceptorManager = require('./InterceptorManager');
var dispatchRequest = require('./dispatchRequest');
var isAbsoluteURL = require('./../helpers/isAbsoluteURL');
var combineURLs = require('./../helpers/combineURLs');

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;

},{"./../defaults":32,"./../helpers/combineURLs":36,"./../helpers/isAbsoluteURL":38,"./../utils":43,"./InterceptorManager":26,"./dispatchRequest":28}],26:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;

},{"./../utils":43}],27:[function(require,module,exports){
'use strict';

var enhanceError = require('./enhanceError');

/**
 * Create an Error with the specified message, config, error code, and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 @ @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, response);
};

},{"./enhanceError":29}],28:[function(require,module,exports){
'use strict';

var utils = require('./../utils');
var transformData = require('./transformData');
var isCancel = require('../cancel/isCancel');
var defaults = require('../defaults');

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};

},{"../cancel/isCancel":24,"../defaults":32,"./../utils":43,"./transformData":31}],29:[function(require,module,exports){
'use strict';

/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 @ @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.response = response;
  return error;
};

},{}],30:[function(require,module,exports){
'use strict';

var createError = require('./createError');

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response
    ));
  }
};

},{"./createError":27}],31:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};

},{"./../utils":43}],32:[function(require,module,exports){
(function (process){
'use strict';

var utils = require('./utils');
var normalizeHeaderName = require('./helpers/normalizeHeaderName');

var PROTECTION_PREFIX = /^\)\]\}',?\n/;
var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = require('./adapters/xhr');
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = require('./adapters/http');
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      data = data.replace(PROTECTION_PREFIX, '');
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMehtodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

}).call(this,require('_process'))
},{"./adapters/http":20,"./adapters/xhr":20,"./helpers/normalizeHeaderName":40,"./utils":43,"_process":734}],33:[function(require,module,exports){
'use strict';

module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};

},{}],34:[function(require,module,exports){
'use strict';

// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;

},{}],35:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      }

      if (!utils.isArray(val)) {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};

},{"./../utils":43}],36:[function(require,module,exports){
'use strict';

/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '');
};

},{}],37:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);

},{"./../utils":43}],38:[function(require,module,exports){
'use strict';

/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

},{}],39:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);

},{"./../utils":43}],40:[function(require,module,exports){
'use strict';

var utils = require('../utils');

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

},{"../utils":43}],41:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
};

},{"./../utils":43}],42:[function(require,module,exports){
'use strict';

/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};

},{}],43:[function(require,module,exports){
'use strict';

var bind = require('./helpers/bind');

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  typeof document.createElement -> undefined
 */
function isStandardBrowserEnv() {
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined' &&
    typeof document.createElement === 'function'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object' && !isArray(obj)) {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};

},{"./helpers/bind":33}],44:[function(require,module,exports){
(function (global){
"use strict";

require("core-js/shim");

require("regenerator-runtime/runtime");

require("core-js/fn/regexp/escape");

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"core-js/fn/regexp/escape":86,"core-js/shim":525,"regenerator-runtime/runtime":764}],45:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/array/from"), __esModule: true };
},{"core-js/library/fn/array/from":87}],46:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/get-iterator"), __esModule: true };
},{"core-js/library/fn/get-iterator":88}],47:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/is-iterable"), __esModule: true };
},{"core-js/library/fn/is-iterable":89}],48:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/json/stringify"), __esModule: true };
},{"core-js/library/fn/json/stringify":90}],49:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/number/is-integer"), __esModule: true };
},{"core-js/library/fn/number/is-integer":91}],50:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };
},{"core-js/library/fn/object/assign":92}],51:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/create"), __esModule: true };
},{"core-js/library/fn/object/create":93}],52:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/define-properties"), __esModule: true };
},{"core-js/library/fn/object/define-properties":94}],53:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/define-property"), __esModule: true };
},{"core-js/library/fn/object/define-property":95}],54:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/entries"), __esModule: true };
},{"core-js/library/fn/object/entries":96}],55:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/get-prototype-of"), __esModule: true };
},{"core-js/library/fn/object/get-prototype-of":97}],56:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/keys"), __esModule: true };
},{"core-js/library/fn/object/keys":98}],57:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/set-prototype-of"), __esModule: true };
},{"core-js/library/fn/object/set-prototype-of":99}],58:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/values"), __esModule: true };
},{"core-js/library/fn/object/values":100}],59:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/promise"), __esModule: true };
},{"core-js/library/fn/promise":101}],60:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/symbol"), __esModule: true };
},{"core-js/library/fn/symbol":102}],61:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/symbol/iterator"), __esModule: true };
},{"core-js/library/fn/symbol/iterator":103}],62:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _promise = require("../core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};
},{"../core-js/promise":59}],63:[function(require,module,exports){
"use strict";

exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};
},{}],64:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _defineProperty = require("../core-js/object/define-property");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
},{"../core-js/object/define-property":53}],65:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _defineProperty = require("../core-js/object/define-property");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};
},{"../core-js/object/define-property":53}],66:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _assign = require("../core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};
},{"../core-js/object/assign":50}],67:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _setPrototypeOf = require("../core-js/object/set-prototype-of");

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = require("../core-js/object/create");

var _create2 = _interopRequireDefault(_create);

var _typeof2 = require("../helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};
},{"../core-js/object/create":51,"../core-js/object/set-prototype-of":57,"../helpers/typeof":72}],68:[function(require,module,exports){
"use strict";

exports.__esModule = true;

exports.default = function (obj) {
  if (obj == null) throw new TypeError("Cannot destructure undefined");
};
},{}],69:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _typeof2 = require("../helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};
},{"../helpers/typeof":72}],70:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _isIterable2 = require("../core-js/is-iterable");

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = require("../core-js/get-iterator");

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();
},{"../core-js/get-iterator":46,"../core-js/is-iterable":47}],71:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _from = require("../core-js/array/from");

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};
},{"../core-js/array/from":45}],72:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _iterator = require("../core-js/symbol/iterator");

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = require("../core-js/symbol");

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};
},{"../core-js/symbol":60,"../core-js/symbol/iterator":61}],73:[function(require,module,exports){
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = require("./runtime");

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}

},{"./runtime":74}],74:[function(require,module,exports){
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);

},{}],75:[function(require,module,exports){
module.exports = require("regenerator-runtime");

},{"regenerator-runtime":73}],76:[function(require,module,exports){

/**
 * Expose `Backoff`.
 */

module.exports = Backoff;

/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */

function Backoff(opts) {
  opts = opts || {};
  this.ms = opts.min || 100;
  this.max = opts.max || 10000;
  this.factor = opts.factor || 2;
  this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
  this.attempts = 0;
}

/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */

Backoff.prototype.duration = function(){
  var ms = this.ms * Math.pow(this.factor, this.attempts++);
  if (this.jitter) {
    var rand =  Math.random();
    var deviation = Math.floor(rand * this.jitter * ms);
    ms = (Math.floor(rand * 10) & 1) == 0  ? ms - deviation : ms + deviation;
  }
  return Math.min(ms, this.max) | 0;
};

/**
 * Reset the number of attempts.
 *
 * @api public
 */

Backoff.prototype.reset = function(){
  this.attempts = 0;
};

/**
 * Set the minimum duration
 *
 * @api public
 */

Backoff.prototype.setMin = function(min){
  this.ms = min;
};

/**
 * Set the maximum duration
 *
 * @api public
 */

Backoff.prototype.setMax = function(max){
  this.max = max;
};

/**
 * Set the jitter
 *
 * @api public
 */

Backoff.prototype.setJitter = function(jitter){
  this.jitter = jitter;
};


},{}],77:[function(require,module,exports){
/*
 * base64-arraybuffer
 * https://github.com/niklasvh/base64-arraybuffer
 *
 * Copyright (c) 2012 Niklas von Hertzen
 * Licensed under the MIT license.
 */
(function(){
  "use strict";

  var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";

  // Use a lookup table to find the index.
  var lookup = new Uint8Array(256);
  for (var i = 0; i < chars.length; i++) {
    lookup[chars.charCodeAt(i)] = i;
  }

  exports.encode = function(arraybuffer) {
    var bytes = new Uint8Array(arraybuffer),
    i, len = bytes.length, base64 = "";

    for (i = 0; i < len; i+=3) {
      base64 += chars[bytes[i] >> 2];
      base64 += chars[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)];
      base64 += chars[((bytes[i + 1] & 15) << 2) | (bytes[i + 2] >> 6)];
      base64 += chars[bytes[i + 2] & 63];
    }

    if ((len % 3) === 2) {
      base64 = base64.substring(0, base64.length - 1) + "=";
    } else if (len % 3 === 1) {
      base64 = base64.substring(0, base64.length - 2) + "==";
    }

    return base64;
  };

  exports.decode =  function(base64) {
    var bufferLength = base64.length * 0.75,
    len = base64.length, i, p = 0,
    encoded1, encoded2, encoded3, encoded4;

    if (base64[base64.length - 1] === "=") {
      bufferLength--;
      if (base64[base64.length - 2] === "=") {
        bufferLength--;
      }
    }

    var arraybuffer = new ArrayBuffer(bufferLength),
    bytes = new Uint8Array(arraybuffer);

    for (i = 0; i < len; i+=4) {
      encoded1 = lookup[base64.charCodeAt(i)];
      encoded2 = lookup[base64.charCodeAt(i+1)];
      encoded3 = lookup[base64.charCodeAt(i+2)];
      encoded4 = lookup[base64.charCodeAt(i+3)];

      bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
      bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
      bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
    }

    return arraybuffer;
  };
})();

},{}],78:[function(require,module,exports){
var lookup = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

;(function (exports) {
	'use strict';

  var Arr = (typeof Uint8Array !== 'undefined')
    ? Uint8Array
    : Array

	var PLUS   = '+'.charCodeAt(0)
	var SLASH  = '/'.charCodeAt(0)
	var NUMBER = '0'.charCodeAt(0)
	var LOWER  = 'a'.charCodeAt(0)
	var UPPER  = 'A'.charCodeAt(0)
	var PLUS_URL_SAFE = '-'.charCodeAt(0)
	var SLASH_URL_SAFE = '_'.charCodeAt(0)

	function decode (elt) {
		var code = elt.charCodeAt(0)
		if (code === PLUS ||
		    code === PLUS_URL_SAFE)
			return 62 // '+'
		if (code === SLASH ||
		    code === SLASH_URL_SAFE)
			return 63 // '/'
		if (code < NUMBER)
			return -1 //no match
		if (code < NUMBER + 10)
			return code - NUMBER + 26 + 26
		if (code < UPPER + 26)
			return code - UPPER
		if (code < LOWER + 26)
			return code - LOWER + 26
	}

	function b64ToByteArray (b64) {
		var i, j, l, tmp, placeHolders, arr

		if (b64.length % 4 > 0) {
			throw new Error('Invalid string. Length must be a multiple of 4')
		}

		// the number of equal signs (place holders)
		// if there are two placeholders, than the two characters before it
		// represent one byte
		// if there is only one, then the three characters before it represent 2 bytes
		// this is just a cheap hack to not do indexOf twice
		var len = b64.length
		placeHolders = '=' === b64.charAt(len - 2) ? 2 : '=' === b64.charAt(len - 1) ? 1 : 0

		// base64 is 4/3 + up to two characters of the original data
		arr = new Arr(b64.length * 3 / 4 - placeHolders)

		// if there are placeholders, only get up to the last complete 4 chars
		l = placeHolders > 0 ? b64.length - 4 : b64.length

		var L = 0

		function push (v) {
			arr[L++] = v
		}

		for (i = 0, j = 0; i < l; i += 4, j += 3) {
			tmp = (decode(b64.charAt(i)) << 18) | (decode(b64.charAt(i + 1)) << 12) | (decode(b64.charAt(i + 2)) << 6) | decode(b64.charAt(i + 3))
			push((tmp & 0xFF0000) >> 16)
			push((tmp & 0xFF00) >> 8)
			push(tmp & 0xFF)
		}

		if (placeHolders === 2) {
			tmp = (decode(b64.charAt(i)) << 2) | (decode(b64.charAt(i + 1)) >> 4)
			push(tmp & 0xFF)
		} else if (placeHolders === 1) {
			tmp = (decode(b64.charAt(i)) << 10) | (decode(b64.charAt(i + 1)) << 4) | (decode(b64.charAt(i + 2)) >> 2)
			push((tmp >> 8) & 0xFF)
			push(tmp & 0xFF)
		}

		return arr
	}

	function uint8ToBase64 (uint8) {
		var i,
			extraBytes = uint8.length % 3, // if we have 1 byte left, pad 2 bytes
			output = "",
			temp, length

		function encode (num) {
			return lookup.charAt(num)
		}

		function tripletToBase64 (num) {
			return encode(num >> 18 & 0x3F) + encode(num >> 12 & 0x3F) + encode(num >> 6 & 0x3F) + encode(num & 0x3F)
		}

		// go through the array every three bytes, we'll deal with trailing stuff later
		for (i = 0, length = uint8.length - extraBytes; i < length; i += 3) {
			temp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
			output += tripletToBase64(temp)
		}

		// pad the end with zeros, but make sure to not forget the extra bytes
		switch (extraBytes) {
			case 1:
				temp = uint8[uint8.length - 1]
				output += encode(temp >> 2)
				output += encode((temp << 4) & 0x3F)
				output += '=='
				break
			case 2:
				temp = (uint8[uint8.length - 2] << 8) + (uint8[uint8.length - 1])
				output += encode(temp >> 10)
				output += encode((temp >> 4) & 0x3F)
				output += encode((temp << 2) & 0x3F)
				output += '='
				break
		}

		return output
	}

	exports.toByteArray = b64ToByteArray
	exports.fromByteArray = uint8ToBase64
}(typeof exports === 'undefined' ? (this.base64js = {}) : exports))

},{}],79:[function(require,module,exports){
/**
 * Create a blob builder even when vendor prefixes exist
 */

var BlobBuilder = typeof BlobBuilder !== 'undefined' ? BlobBuilder :
  typeof WebKitBlobBuilder !== 'undefined' ? WebKitBlobBuilder :
  typeof MSBlobBuilder !== 'undefined' ? MSBlobBuilder :
  typeof MozBlobBuilder !== 'undefined' ? MozBlobBuilder : 
  false;

/**
 * Check if Blob constructor is supported
 */

var blobSupported = (function() {
  try {
    var a = new Blob(['hi']);
    return a.size === 2;
  } catch(e) {
    return false;
  }
})();

/**
 * Check if Blob constructor supports ArrayBufferViews
 * Fails in Safari 6, so we need to map to ArrayBuffers there.
 */

var blobSupportsArrayBufferView = blobSupported && (function() {
  try {
    var b = new Blob([new Uint8Array([1,2])]);
    return b.size === 2;
  } catch(e) {
    return false;
  }
})();

/**
 * Check if BlobBuilder is supported
 */

var blobBuilderSupported = BlobBuilder
  && BlobBuilder.prototype.append
  && BlobBuilder.prototype.getBlob;

/**
 * Helper function that maps ArrayBufferViews to ArrayBuffers
 * Used by BlobBuilder constructor and old browsers that didn't
 * support it in the Blob constructor.
 */

function mapArrayBufferViews(ary) {
  return ary.map(function(chunk) {
    if (chunk.buffer instanceof ArrayBuffer) {
      var buf = chunk.buffer;

      // if this is a subarray, make a copy so we only
      // include the subarray region from the underlying buffer
      if (chunk.byteLength !== buf.byteLength) {
        var copy = new Uint8Array(chunk.byteLength);
        copy.set(new Uint8Array(buf, chunk.byteOffset, chunk.byteLength));
        buf = copy.buffer;
      }

      return buf;
    }

    return chunk;
  });
}

function BlobBuilderConstructor(ary, options) {
  options = options || {};

  var bb = new BlobBuilder();
  mapArrayBufferViews(ary).forEach(function(part) {
    bb.append(part);
  });

  return (options.type) ? bb.getBlob(options.type) : bb.getBlob();
};

function BlobConstructor(ary, options) {
  return new Blob(mapArrayBufferViews(ary), options || {});
};

if (typeof Blob !== 'undefined') {
  BlobBuilderConstructor.prototype = Blob.prototype;
  BlobConstructor.prototype = Blob.prototype;
}

module.exports = (function() {
  if (blobSupported) {
    return blobSupportsArrayBufferView ? Blob : BlobConstructor;
  } else if (blobBuilderSupported) {
    return BlobBuilderConstructor;
  } else {
    return undefined;
  }
})();

},{}],80:[function(require,module,exports){

},{}],81:[function(require,module,exports){
(function (global){
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */

'use strict'

var base64 = require('base64-js')
var ieee754 = require('ieee754')
var isArray = require('isarray')

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50
Buffer.poolSize = 8192 // not used by this implementation

var rootParent = {}

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Safari 5-7 lacks support for changing the `Object.prototype.constructor` property
 *     on objects.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

function typedArraySupport () {
  function Bar () {}
  try {
    var arr = new Uint8Array(1)
    arr.foo = function () { return 42 }
    arr.constructor = Bar
    return arr.foo() === 42 && // typed array instances can be augmented
        arr.constructor === Bar && // constructor can be set
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

/**
 * Class: Buffer
 * =============
 *
 * The Buffer constructor returns instances of `Uint8Array` that are augmented
 * with function properties for all the node `Buffer` API functions. We use
 * `Uint8Array` so that square bracket notation works as expected -- it returns
 * a single octet.
 *
 * By augmenting the instances, we can avoid modifying the `Uint8Array`
 * prototype.
 */
function Buffer (arg) {
  if (!(this instanceof Buffer)) {
    // Avoid going through an ArgumentsAdaptorTrampoline in the common case.
    if (arguments.length > 1) return new Buffer(arg, arguments[1])
    return new Buffer(arg)
  }

  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    this.length = 0
    this.parent = undefined
  }

  // Common case.
  if (typeof arg === 'number') {
    return fromNumber(this, arg)
  }

  // Slightly less common case.
  if (typeof arg === 'string') {
    return fromString(this, arg, arguments.length > 1 ? arguments[1] : 'utf8')
  }

  // Unusual.
  return fromObject(this, arg)
}

function fromNumber (that, length) {
  that = allocate(that, length < 0 ? 0 : checked(length) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < length; i++) {
      that[i] = 0
    }
  }
  return that
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8'

  // Assumption: byteLength() return value is always < kMaxLength.
  var length = byteLength(string, encoding) | 0
  that = allocate(that, length)

  that.write(string, encoding)
  return that
}

function fromObject (that, object) {
  if (Buffer.isBuffer(object)) return fromBuffer(that, object)

  if (isArray(object)) return fromArray(that, object)

  if (object == null) {
    throw new TypeError('must start with number, buffer, array or string')
  }

  if (typeof ArrayBuffer !== 'undefined') {
    if (object.buffer instanceof ArrayBuffer) {
      return fromTypedArray(that, object)
    }
    if (object instanceof ArrayBuffer) {
      return fromArrayBuffer(that, object)
    }
  }

  if (object.length) return fromArrayLike(that, object)

  return fromJsonObject(that, object)
}

function fromBuffer (that, buffer) {
  var length = checked(buffer.length) | 0
  that = allocate(that, length)
  buffer.copy(that, 0, 0, length)
  return that
}

function fromArray (that, array) {
  var length = checked(array.length) | 0
  that = allocate(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

// Duplicate of fromArray() to keep fromArray() monomorphic.
function fromTypedArray (that, array) {
  var length = checked(array.length) | 0
  that = allocate(that, length)
  // Truncating the elements is probably not what people expect from typed
  // arrays with BYTES_PER_ELEMENT > 1 but it's compatible with the behavior
  // of the old Buffer constructor.
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array) {
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    array.byteLength
    that = Buffer._augment(new Uint8Array(array))
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromTypedArray(that, new Uint8Array(array))
  }
  return that
}

function fromArrayLike (that, array) {
  var length = checked(array.length) | 0
  that = allocate(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

// Deserialize { type: 'Buffer', data: [1,2,3,...] } into a Buffer object.
// Returns a zero-length buffer for inputs that don't conform to the spec.
function fromJsonObject (that, object) {
  var array
  var length = 0

  if (object.type === 'Buffer' && isArray(object.data)) {
    array = object.data
    length = checked(array.length) | 0
  }
  that = allocate(that, length)

  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
} else {
  // pre-set for values that may exist in the future
  Buffer.prototype.length = undefined
  Buffer.prototype.parent = undefined
}

function allocate (that, length) {
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = Buffer._augment(new Uint8Array(length))
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that.length = length
    that._isBuffer = true
  }

  var fromPool = length !== 0 && length <= Buffer.poolSize >>> 1
  if (fromPool) that.parent = rootParent

  return that
}

function checked (length) {
  // Note: cannot use `length < kMaxLength` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (subject, encoding) {
  if (!(this instanceof SlowBuffer)) return new SlowBuffer(subject, encoding)

  var buf = new Buffer(subject, encoding)
  delete buf.parent
  return buf
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  var i = 0
  var len = Math.min(x, y)
  while (i < len) {
    if (a[i] !== b[i]) break

    ++i
  }

  if (i !== len) {
    x = a[i]
    y = b[i]
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'binary':
    case 'base64':
    case 'raw':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) throw new TypeError('list argument must be an Array of Buffers.')

  if (list.length === 0) {
    return new Buffer(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; i++) {
      length += list[i].length
    }
  }

  var buf = new Buffer(length)
  var pos = 0
  for (i = 0; i < list.length; i++) {
    var item = list[i]
    item.copy(buf, pos)
    pos += item.length
  }
  return buf
}

function byteLength (string, encoding) {
  if (typeof string !== 'string') string = '' + string

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'binary':
      // Deprecated
      case 'raw':
      case 'raws':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  start = start | 0
  end = end === undefined || end === Infinity ? this.length : end | 0

  if (!encoding) encoding = 'utf8'
  if (start < 0) start = 0
  if (end > this.length) end = this.length
  if (end <= start) return ''

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'binary':
        return binarySlice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return 0
  return Buffer.compare(this, b)
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset) {
  if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff
  else if (byteOffset < -0x80000000) byteOffset = -0x80000000
  byteOffset >>= 0

  if (this.length === 0) return -1
  if (byteOffset >= this.length) return -1

  // Negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = Math.max(this.length + byteOffset, 0)

  if (typeof val === 'string') {
    if (val.length === 0) return -1 // special case: looking for empty string always fails
    return String.prototype.indexOf.call(this, val, byteOffset)
  }
  if (Buffer.isBuffer(val)) {
    return arrayIndexOf(this, val, byteOffset)
  }
  if (typeof val === 'number') {
    if (Buffer.TYPED_ARRAY_SUPPORT && Uint8Array.prototype.indexOf === 'function') {
      return Uint8Array.prototype.indexOf.call(this, val, byteOffset)
    }
    return arrayIndexOf(this, [ val ], byteOffset)
  }

  function arrayIndexOf (arr, val, byteOffset) {
    var foundIndex = -1
    for (var i = 0; byteOffset + i < arr.length; i++) {
      if (arr[byteOffset + i] === val[foundIndex === -1 ? 0 : i - foundIndex]) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === val.length) return byteOffset + foundIndex
      } else {
        foundIndex = -1
      }
    }
    return -1
  }

  throw new TypeError('val must be string, number or Buffer')
}

// `get` is deprecated
Buffer.prototype.get = function get (offset) {
  console.log('.get() is deprecated. Access using array indexes instead.')
  return this.readUInt8(offset)
}

// `set` is deprecated
Buffer.prototype.set = function set (v, offset) {
  console.log('.set() is deprecated. Access using array indexes instead.')
  return this.writeUInt8(v, offset)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new Error('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; i++) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) throw new Error('Invalid hex string')
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function binaryWrite (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    var swap = encoding
    encoding = offset
    offset = length | 0
    length = swap
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'binary':
        return binaryWrite(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; i++) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function binarySlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; i++) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; i++) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = Buffer._augment(this.subarray(start, end))
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; i++) {
      newBuf[i] = this[i + start]
    }
  }

  if (newBuf.length) newBuf.parent = this.parent || this

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('buffer must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('value is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkInt(this, value, offset, byteLength, Math.pow(2, 8 * byteLength), 0)

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkInt(this, value, offset, byteLength, Math.pow(2, 8 * byteLength), 0)

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; i++) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; i++) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = value < 0 ? 1 : 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = value < 0 ? 1 : 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (value > max || value < min) throw new RangeError('value is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('index out of range')
  if (offset < 0) throw new RangeError('index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; i--) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; i++) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    target._set(this.subarray(start, start + len), targetStart)
  }

  return len
}

// fill(value, start=0, end=buffer.length)
Buffer.prototype.fill = function fill (value, start, end) {
  if (!value) value = 0
  if (!start) start = 0
  if (!end) end = this.length

  if (end < start) throw new RangeError('end < start')

  // Fill 0 bytes; we're done
  if (end === start) return
  if (this.length === 0) return

  if (start < 0 || start >= this.length) throw new RangeError('start out of bounds')
  if (end < 0 || end > this.length) throw new RangeError('end out of bounds')

  var i
  if (typeof value === 'number') {
    for (i = start; i < end; i++) {
      this[i] = value
    }
  } else {
    var bytes = utf8ToBytes(value.toString())
    var len = bytes.length
    for (i = start; i < end; i++) {
      this[i] = bytes[i % len]
    }
  }

  return this
}

/**
 * Creates a new `ArrayBuffer` with the *copied* memory of the buffer instance.
 * Added in Node 0.12. Only available in browsers that support ArrayBuffer.
 */
Buffer.prototype.toArrayBuffer = function toArrayBuffer () {
  if (typeof Uint8Array !== 'undefined') {
    if (Buffer.TYPED_ARRAY_SUPPORT) {
      return (new Buffer(this)).buffer
    } else {
      var buf = new Uint8Array(this.length)
      for (var i = 0, len = buf.length; i < len; i += 1) {
        buf[i] = this[i]
      }
      return buf.buffer
    }
  } else {
    throw new TypeError('Buffer.toArrayBuffer not supported in this browser')
  }
}

// HELPER FUNCTIONS
// ================

var BP = Buffer.prototype

/**
 * Augment a Uint8Array *instance* (not the Uint8Array class!) with Buffer methods
 */
Buffer._augment = function _augment (arr) {
  arr.constructor = Buffer
  arr._isBuffer = true

  // save reference to original Uint8Array set method before overwriting
  arr._set = arr.set

  // deprecated
  arr.get = BP.get
  arr.set = BP.set

  arr.write = BP.write
  arr.toString = BP.toString
  arr.toLocaleString = BP.toString
  arr.toJSON = BP.toJSON
  arr.equals = BP.equals
  arr.compare = BP.compare
  arr.indexOf = BP.indexOf
  arr.copy = BP.copy
  arr.slice = BP.slice
  arr.readUIntLE = BP.readUIntLE
  arr.readUIntBE = BP.readUIntBE
  arr.readUInt8 = BP.readUInt8
  arr.readUInt16LE = BP.readUInt16LE
  arr.readUInt16BE = BP.readUInt16BE
  arr.readUInt32LE = BP.readUInt32LE
  arr.readUInt32BE = BP.readUInt32BE
  arr.readIntLE = BP.readIntLE
  arr.readIntBE = BP.readIntBE
  arr.readInt8 = BP.readInt8
  arr.readInt16LE = BP.readInt16LE
  arr.readInt16BE = BP.readInt16BE
  arr.readInt32LE = BP.readInt32LE
  arr.readInt32BE = BP.readInt32BE
  arr.readFloatLE = BP.readFloatLE
  arr.readFloatBE = BP.readFloatBE
  arr.readDoubleLE = BP.readDoubleLE
  arr.readDoubleBE = BP.readDoubleBE
  arr.writeUInt8 = BP.writeUInt8
  arr.writeUIntLE = BP.writeUIntLE
  arr.writeUIntBE = BP.writeUIntBE
  arr.writeUInt16LE = BP.writeUInt16LE
  arr.writeUInt16BE = BP.writeUInt16BE
  arr.writeUInt32LE = BP.writeUInt32LE
  arr.writeUInt32BE = BP.writeUInt32BE
  arr.writeIntLE = BP.writeIntLE
  arr.writeIntBE = BP.writeIntBE
  arr.writeInt8 = BP.writeInt8
  arr.writeInt16LE = BP.writeInt16LE
  arr.writeInt16BE = BP.writeInt16BE
  arr.writeInt32LE = BP.writeInt32LE
  arr.writeInt32BE = BP.writeInt32BE
  arr.writeFloatLE = BP.writeFloatLE
  arr.writeFloatBE = BP.writeFloatBE
  arr.writeDoubleLE = BP.writeDoubleLE
  arr.writeDoubleBE = BP.writeDoubleBE
  arr.fill = BP.fill
  arr.inspect = BP.inspect
  arr.toArrayBuffer = BP.toArrayBuffer

  return arr
}

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; i++) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; i++) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; i++) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; i++) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"base64-js":78,"ieee754":547,"isarray":549}],82:[function(require,module,exports){
/*!
 * Chart.js v2.9.4
 * https://www.chartjs.org
 * (c) 2020 Chart.js Contributors
 * Released under the MIT License
 */
(function (global, factory) {
typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(function() { try { return require('moment'); } catch(e) { } }()) :
typeof define === 'function' && define.amd ? define(['require'], function(require) { return factory(function() { try { return require('moment'); } catch(e) { } }()); }) :
(global = global || self, global.Chart = factory(global.moment));
}(this, (function (moment) { 'use strict';

moment = moment && moment.hasOwnProperty('default') ? moment['default'] : moment;

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

function getCjsExportFromNamespace (n) {
	return n && n['default'] || n;
}

var colorName = {
	"aliceblue": [240, 248, 255],
	"antiquewhite": [250, 235, 215],
	"aqua": [0, 255, 255],
	"aquamarine": [127, 255, 212],
	"azure": [240, 255, 255],
	"beige": [245, 245, 220],
	"bisque": [255, 228, 196],
	"black": [0, 0, 0],
	"blanchedalmond": [255, 235, 205],
	"blue": [0, 0, 255],
	"blueviolet": [138, 43, 226],
	"brown": [165, 42, 42],
	"burlywood": [222, 184, 135],
	"cadetblue": [95, 158, 160],
	"chartreuse": [127, 255, 0],
	"chocolate": [210, 105, 30],
	"coral": [255, 127, 80],
	"cornflowerblue": [100, 149, 237],
	"cornsilk": [255, 248, 220],
	"crimson": [220, 20, 60],
	"cyan": [0, 255, 255],
	"darkblue": [0, 0, 139],
	"darkcyan": [0, 139, 139],
	"darkgoldenrod": [184, 134, 11],
	"darkgray": [169, 169, 169],
	"darkgreen": [0, 100, 0],
	"darkgrey": [169, 169, 169],
	"darkkhaki": [189, 183, 107],
	"darkmagenta": [139, 0, 139],
	"darkolivegreen": [85, 107, 47],
	"darkorange": [255, 140, 0],
	"darkorchid": [153, 50, 204],
	"darkred": [139, 0, 0],
	"darksalmon": [233, 150, 122],
	"darkseagreen": [143, 188, 143],
	"darkslateblue": [72, 61, 139],
	"darkslategray": [47, 79, 79],
	"darkslategrey": [47, 79, 79],
	"darkturquoise": [0, 206, 209],
	"darkviolet": [148, 0, 211],
	"deeppink": [255, 20, 147],
	"deepskyblue": [0, 191, 255],
	"dimgray": [105, 105, 105],
	"dimgrey": [105, 105, 105],
	"dodgerblue": [30, 144, 255],
	"firebrick": [178, 34, 34],
	"floralwhite": [255, 250, 240],
	"forestgreen": [34, 139, 34],
	"fuchsia": [255, 0, 255],
	"gainsboro": [220, 220, 220],
	"ghostwhite": [248, 248, 255],
	"gold": [255, 215, 0],
	"goldenrod": [218, 165, 32],
	"gray": [128, 128, 128],
	"green": [0, 128, 0],
	"greenyellow": [173, 255, 47],
	"grey": [128, 128, 128],
	"honeydew": [240, 255, 240],
	"hotpink": [255, 105, 180],
	"indianred": [205, 92, 92],
	"indigo": [75, 0, 130],
	"ivory": [255, 255, 240],
	"khaki": [240, 230, 140],
	"lavender": [230, 230, 250],
	"lavenderblush": [255, 240, 245],
	"lawngreen": [124, 252, 0],
	"lemonchiffon": [255, 250, 205],
	"lightblue": [173, 216, 230],
	"lightcoral": [240, 128, 128],
	"lightcyan": [224, 255, 255],
	"lightgoldenrodyellow": [250, 250, 210],
	"lightgray": [211, 211, 211],
	"lightgreen": [144, 238, 144],
	"lightgrey": [211, 211, 211],
	"lightpink": [255, 182, 193],
	"lightsalmon": [255, 160, 122],
	"lightseagreen": [32, 178, 170],
	"lightskyblue": [135, 206, 250],
	"lightslategray": [119, 136, 153],
	"lightslategrey": [119, 136, 153],
	"lightsteelblue": [176, 196, 222],
	"lightyellow": [255, 255, 224],
	"lime": [0, 255, 0],
	"limegreen": [50, 205, 50],
	"linen": [250, 240, 230],
	"magenta": [255, 0, 255],
	"maroon": [128, 0, 0],
	"mediumaquamarine": [102, 205, 170],
	"mediumblue": [0, 0, 205],
	"mediumorchid": [186, 85, 211],
	"mediumpurple": [147, 112, 219],
	"mediumseagreen": [60, 179, 113],
	"mediumslateblue": [123, 104, 238],
	"mediumspringgreen": [0, 250, 154],
	"mediumturquoise": [72, 209, 204],
	"mediumvioletred": [199, 21, 133],
	"midnightblue": [25, 25, 112],
	"mintcream": [245, 255, 250],
	"mistyrose": [255, 228, 225],
	"moccasin": [255, 228, 181],
	"navajowhite": [255, 222, 173],
	"navy": [0, 0, 128],
	"oldlace": [253, 245, 230],
	"olive": [128, 128, 0],
	"olivedrab": [107, 142, 35],
	"orange": [255, 165, 0],
	"orangered": [255, 69, 0],
	"orchid": [218, 112, 214],
	"palegoldenrod": [238, 232, 170],
	"palegreen": [152, 251, 152],
	"paleturquoise": [175, 238, 238],
	"palevioletred": [219, 112, 147],
	"papayawhip": [255, 239, 213],
	"peachpuff": [255, 218, 185],
	"peru": [205, 133, 63],
	"pink": [255, 192, 203],
	"plum": [221, 160, 221],
	"powderblue": [176, 224, 230],
	"purple": [128, 0, 128],
	"rebeccapurple": [102, 51, 153],
	"red": [255, 0, 0],
	"rosybrown": [188, 143, 143],
	"royalblue": [65, 105, 225],
	"saddlebrown": [139, 69, 19],
	"salmon": [250, 128, 114],
	"sandybrown": [244, 164, 96],
	"seagreen": [46, 139, 87],
	"seashell": [255, 245, 238],
	"sienna": [160, 82, 45],
	"silver": [192, 192, 192],
	"skyblue": [135, 206, 235],
	"slateblue": [106, 90, 205],
	"slategray": [112, 128, 144],
	"slategrey": [112, 128, 144],
	"snow": [255, 250, 250],
	"springgreen": [0, 255, 127],
	"steelblue": [70, 130, 180],
	"tan": [210, 180, 140],
	"teal": [0, 128, 128],
	"thistle": [216, 191, 216],
	"tomato": [255, 99, 71],
	"turquoise": [64, 224, 208],
	"violet": [238, 130, 238],
	"wheat": [245, 222, 179],
	"white": [255, 255, 255],
	"whitesmoke": [245, 245, 245],
	"yellow": [255, 255, 0],
	"yellowgreen": [154, 205, 50]
};

var conversions = createCommonjsModule(function (module) {
/* MIT license */


// NOTE: conversions should only return primitive values (i.e. arrays, or
//       values that give correct `typeof` results).
//       do not use box values types (i.e. Number(), String(), etc.)

var reverseKeywords = {};
for (var key in colorName) {
	if (colorName.hasOwnProperty(key)) {
		reverseKeywords[colorName[key]] = key;
	}
}

var convert = module.exports = {
	rgb: {channels: 3, labels: 'rgb'},
	hsl: {channels: 3, labels: 'hsl'},
	hsv: {channels: 3, labels: 'hsv'},
	hwb: {channels: 3, labels: 'hwb'},
	cmyk: {channels: 4, labels: 'cmyk'},
	xyz: {channels: 3, labels: 'xyz'},
	lab: {channels: 3, labels: 'lab'},
	lch: {channels: 3, labels: 'lch'},
	hex: {channels: 1, labels: ['hex']},
	keyword: {channels: 1, labels: ['keyword']},
	ansi16: {channels: 1, labels: ['ansi16']},
	ansi256: {channels: 1, labels: ['ansi256']},
	hcg: {channels: 3, labels: ['h', 'c', 'g']},
	apple: {channels: 3, labels: ['r16', 'g16', 'b16']},
	gray: {channels: 1, labels: ['gray']}
};

// hide .channels and .labels properties
for (var model in convert) {
	if (convert.hasOwnProperty(model)) {
		if (!('channels' in convert[model])) {
			throw new Error('missing channels property: ' + model);
		}

		if (!('labels' in convert[model])) {
			throw new Error('missing channel labels property: ' + model);
		}

		if (convert[model].labels.length !== convert[model].channels) {
			throw new Error('channel and label counts mismatch: ' + model);
		}

		var channels = convert[model].channels;
		var labels = convert[model].labels;
		delete convert[model].channels;
		delete convert[model].labels;
		Object.defineProperty(convert[model], 'channels', {value: channels});
		Object.defineProperty(convert[model], 'labels', {value: labels});
	}
}

convert.rgb.hsl = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var min = Math.min(r, g, b);
	var max = Math.max(r, g, b);
	var delta = max - min;
	var h;
	var s;
	var l;

	if (max === min) {
		h = 0;
	} else if (r === max) {
		h = (g - b) / delta;
	} else if (g === max) {
		h = 2 + (b - r) / delta;
	} else if (b === max) {
		h = 4 + (r - g) / delta;
	}

	h = Math.min(h * 60, 360);

	if (h < 0) {
		h += 360;
	}

	l = (min + max) / 2;

	if (max === min) {
		s = 0;
	} else if (l <= 0.5) {
		s = delta / (max + min);
	} else {
		s = delta / (2 - max - min);
	}

	return [h, s * 100, l * 100];
};

convert.rgb.hsv = function (rgb) {
	var rdif;
	var gdif;
	var bdif;
	var h;
	var s;

	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var v = Math.max(r, g, b);
	var diff = v - Math.min(r, g, b);
	var diffc = function (c) {
		return (v - c) / 6 / diff + 1 / 2;
	};

	if (diff === 0) {
		h = s = 0;
	} else {
		s = diff / v;
		rdif = diffc(r);
		gdif = diffc(g);
		bdif = diffc(b);

		if (r === v) {
			h = bdif - gdif;
		} else if (g === v) {
			h = (1 / 3) + rdif - bdif;
		} else if (b === v) {
			h = (2 / 3) + gdif - rdif;
		}
		if (h < 0) {
			h += 1;
		} else if (h > 1) {
			h -= 1;
		}
	}

	return [
		h * 360,
		s * 100,
		v * 100
	];
};

convert.rgb.hwb = function (rgb) {
	var r = rgb[0];
	var g = rgb[1];
	var b = rgb[2];
	var h = convert.rgb.hsl(rgb)[0];
	var w = 1 / 255 * Math.min(r, Math.min(g, b));

	b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));

	return [h, w * 100, b * 100];
};

convert.rgb.cmyk = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var c;
	var m;
	var y;
	var k;

	k = Math.min(1 - r, 1 - g, 1 - b);
	c = (1 - r - k) / (1 - k) || 0;
	m = (1 - g - k) / (1 - k) || 0;
	y = (1 - b - k) / (1 - k) || 0;

	return [c * 100, m * 100, y * 100, k * 100];
};

/**
 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
 * */
function comparativeDistance(x, y) {
	return (
		Math.pow(x[0] - y[0], 2) +
		Math.pow(x[1] - y[1], 2) +
		Math.pow(x[2] - y[2], 2)
	);
}

convert.rgb.keyword = function (rgb) {
	var reversed = reverseKeywords[rgb];
	if (reversed) {
		return reversed;
	}

	var currentClosestDistance = Infinity;
	var currentClosestKeyword;

	for (var keyword in colorName) {
		if (colorName.hasOwnProperty(keyword)) {
			var value = colorName[keyword];

			// Compute comparative distance
			var distance = comparativeDistance(rgb, value);

			// Check if its less, if so set as closest
			if (distance < currentClosestDistance) {
				currentClosestDistance = distance;
				currentClosestKeyword = keyword;
			}
		}
	}

	return currentClosestKeyword;
};

convert.keyword.rgb = function (keyword) {
	return colorName[keyword];
};

convert.rgb.xyz = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;

	// assume sRGB
	r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
	g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
	b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);

	var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
	var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
	var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);

	return [x * 100, y * 100, z * 100];
};

convert.rgb.lab = function (rgb) {
	var xyz = convert.rgb.xyz(rgb);
	var x = xyz[0];
	var y = xyz[1];
	var z = xyz[2];
	var l;
	var a;
	var b;

	x /= 95.047;
	y /= 100;
	z /= 108.883;

	x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
	y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
	z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);

	l = (116 * y) - 16;
	a = 500 * (x - y);
	b = 200 * (y - z);

	return [l, a, b];
};

convert.hsl.rgb = function (hsl) {
	var h = hsl[0] / 360;
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var t1;
	var t2;
	var t3;
	var rgb;
	var val;

	if (s === 0) {
		val = l * 255;
		return [val, val, val];
	}

	if (l < 0.5) {
		t2 = l * (1 + s);
	} else {
		t2 = l + s - l * s;
	}

	t1 = 2 * l - t2;

	rgb = [0, 0, 0];
	for (var i = 0; i < 3; i++) {
		t3 = h + 1 / 3 * -(i - 1);
		if (t3 < 0) {
			t3++;
		}
		if (t3 > 1) {
			t3--;
		}

		if (6 * t3 < 1) {
			val = t1 + (t2 - t1) * 6 * t3;
		} else if (2 * t3 < 1) {
			val = t2;
		} else if (3 * t3 < 2) {
			val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
		} else {
			val = t1;
		}

		rgb[i] = val * 255;
	}

	return rgb;
};

convert.hsl.hsv = function (hsl) {
	var h = hsl[0];
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var smin = s;
	var lmin = Math.max(l, 0.01);
	var sv;
	var v;

	l *= 2;
	s *= (l <= 1) ? l : 2 - l;
	smin *= lmin <= 1 ? lmin : 2 - lmin;
	v = (l + s) / 2;
	sv = l === 0 ? (2 * smin) / (lmin + smin) : (2 * s) / (l + s);

	return [h, sv * 100, v * 100];
};

convert.hsv.rgb = function (hsv) {
	var h = hsv[0] / 60;
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;
	var hi = Math.floor(h) % 6;

	var f = h - Math.floor(h);
	var p = 255 * v * (1 - s);
	var q = 255 * v * (1 - (s * f));
	var t = 255 * v * (1 - (s * (1 - f)));
	v *= 255;

	switch (hi) {
		case 0:
			return [v, t, p];
		case 1:
			return [q, v, p];
		case 2:
			return [p, v, t];
		case 3:
			return [p, q, v];
		case 4:
			return [t, p, v];
		case 5:
			return [v, p, q];
	}
};

convert.hsv.hsl = function (hsv) {
	var h = hsv[0];
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;
	var vmin = Math.max(v, 0.01);
	var lmin;
	var sl;
	var l;

	l = (2 - s) * v;
	lmin = (2 - s) * vmin;
	sl = s * vmin;
	sl /= (lmin <= 1) ? lmin : 2 - lmin;
	sl = sl || 0;
	l /= 2;

	return [h, sl * 100, l * 100];
};

// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
convert.hwb.rgb = function (hwb) {
	var h = hwb[0] / 360;
	var wh = hwb[1] / 100;
	var bl = hwb[2] / 100;
	var ratio = wh + bl;
	var i;
	var v;
	var f;
	var n;

	// wh + bl cant be > 1
	if (ratio > 1) {
		wh /= ratio;
		bl /= ratio;
	}

	i = Math.floor(6 * h);
	v = 1 - bl;
	f = 6 * h - i;

	if ((i & 0x01) !== 0) {
		f = 1 - f;
	}

	n = wh + f * (v - wh); // linear interpolation

	var r;
	var g;
	var b;
	switch (i) {
		default:
		case 6:
		case 0: r = v; g = n; b = wh; break;
		case 1: r = n; g = v; b = wh; break;
		case 2: r = wh; g = v; b = n; break;
		case 3: r = wh; g = n; b = v; break;
		case 4: r = n; g = wh; b = v; break;
		case 5: r = v; g = wh; b = n; break;
	}

	return [r * 255, g * 255, b * 255];
};

convert.cmyk.rgb = function (cmyk) {
	var c = cmyk[0] / 100;
	var m = cmyk[1] / 100;
	var y = cmyk[2] / 100;
	var k = cmyk[3] / 100;
	var r;
	var g;
	var b;

	r = 1 - Math.min(1, c * (1 - k) + k);
	g = 1 - Math.min(1, m * (1 - k) + k);
	b = 1 - Math.min(1, y * (1 - k) + k);

	return [r * 255, g * 255, b * 255];
};

convert.xyz.rgb = function (xyz) {
	var x = xyz[0] / 100;
	var y = xyz[1] / 100;
	var z = xyz[2] / 100;
	var r;
	var g;
	var b;

	r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
	g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
	b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);

	// assume sRGB
	r = r > 0.0031308
		? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
		: r * 12.92;

	g = g > 0.0031308
		? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
		: g * 12.92;

	b = b > 0.0031308
		? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
		: b * 12.92;

	r = Math.min(Math.max(0, r), 1);
	g = Math.min(Math.max(0, g), 1);
	b = Math.min(Math.max(0, b), 1);

	return [r * 255, g * 255, b * 255];
};

convert.xyz.lab = function (xyz) {
	var x = xyz[0];
	var y = xyz[1];
	var z = xyz[2];
	var l;
	var a;
	var b;

	x /= 95.047;
	y /= 100;
	z /= 108.883;

	x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
	y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
	z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);

	l = (116 * y) - 16;
	a = 500 * (x - y);
	b = 200 * (y - z);

	return [l, a, b];
};

convert.lab.xyz = function (lab) {
	var l = lab[0];
	var a = lab[1];
	var b = lab[2];
	var x;
	var y;
	var z;

	y = (l + 16) / 116;
	x = a / 500 + y;
	z = y - b / 200;

	var y2 = Math.pow(y, 3);
	var x2 = Math.pow(x, 3);
	var z2 = Math.pow(z, 3);
	y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
	x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
	z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;

	x *= 95.047;
	y *= 100;
	z *= 108.883;

	return [x, y, z];
};

convert.lab.lch = function (lab) {
	var l = lab[0];
	var a = lab[1];
	var b = lab[2];
	var hr;
	var h;
	var c;

	hr = Math.atan2(b, a);
	h = hr * 360 / 2 / Math.PI;

	if (h < 0) {
		h += 360;
	}

	c = Math.sqrt(a * a + b * b);

	return [l, c, h];
};

convert.lch.lab = function (lch) {
	var l = lch[0];
	var c = lch[1];
	var h = lch[2];
	var a;
	var b;
	var hr;

	hr = h / 360 * 2 * Math.PI;
	a = c * Math.cos(hr);
	b = c * Math.sin(hr);

	return [l, a, b];
};

convert.rgb.ansi16 = function (args) {
	var r = args[0];
	var g = args[1];
	var b = args[2];
	var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization

	value = Math.round(value / 50);

	if (value === 0) {
		return 30;
	}

	var ansi = 30
		+ ((Math.round(b / 255) << 2)
		| (Math.round(g / 255) << 1)
		| Math.round(r / 255));

	if (value === 2) {
		ansi += 60;
	}

	return ansi;
};

convert.hsv.ansi16 = function (args) {
	// optimization here; we already know the value and don't need to get
	// it converted for us.
	return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
};

convert.rgb.ansi256 = function (args) {
	var r = args[0];
	var g = args[1];
	var b = args[2];

	// we use the extended greyscale palette here, with the exception of
	// black and white. normal palette only has 4 greyscale shades.
	if (r === g && g === b) {
		if (r < 8) {
			return 16;
		}

		if (r > 248) {
			return 231;
		}

		return Math.round(((r - 8) / 247) * 24) + 232;
	}

	var ansi = 16
		+ (36 * Math.round(r / 255 * 5))
		+ (6 * Math.round(g / 255 * 5))
		+ Math.round(b / 255 * 5);

	return ansi;
};

convert.ansi16.rgb = function (args) {
	var color = args % 10;

	// handle greyscale
	if (color === 0 || color === 7) {
		if (args > 50) {
			color += 3.5;
		}

		color = color / 10.5 * 255;

		return [color, color, color];
	}

	var mult = (~~(args > 50) + 1) * 0.5;
	var r = ((color & 1) * mult) * 255;
	var g = (((color >> 1) & 1) * mult) * 255;
	var b = (((color >> 2) & 1) * mult) * 255;

	return [r, g, b];
};

convert.ansi256.rgb = function (args) {
	// handle greyscale
	if (args >= 232) {
		var c = (args - 232) * 10 + 8;
		return [c, c, c];
	}

	args -= 16;

	var rem;
	var r = Math.floor(args / 36) / 5 * 255;
	var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
	var b = (rem % 6) / 5 * 255;

	return [r, g, b];
};

convert.rgb.hex = function (args) {
	var integer = ((Math.round(args[0]) & 0xFF) << 16)
		+ ((Math.round(args[1]) & 0xFF) << 8)
		+ (Math.round(args[2]) & 0xFF);

	var string = integer.toString(16).toUpperCase();
	return '000000'.substring(string.length) + string;
};

convert.hex.rgb = function (args) {
	var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
	if (!match) {
		return [0, 0, 0];
	}

	var colorString = match[0];

	if (match[0].length === 3) {
		colorString = colorString.split('').map(function (char) {
			return char + char;
		}).join('');
	}

	var integer = parseInt(colorString, 16);
	var r = (integer >> 16) & 0xFF;
	var g = (integer >> 8) & 0xFF;
	var b = integer & 0xFF;

	return [r, g, b];
};

convert.rgb.hcg = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var max = Math.max(Math.max(r, g), b);
	var min = Math.min(Math.min(r, g), b);
	var chroma = (max - min);
	var grayscale;
	var hue;

	if (chroma < 1) {
		grayscale = min / (1 - chroma);
	} else {
		grayscale = 0;
	}

	if (chroma <= 0) {
		hue = 0;
	} else
	if (max === r) {
		hue = ((g - b) / chroma) % 6;
	} else
	if (max === g) {
		hue = 2 + (b - r) / chroma;
	} else {
		hue = 4 + (r - g) / chroma + 4;
	}

	hue /= 6;
	hue %= 1;

	return [hue * 360, chroma * 100, grayscale * 100];
};

convert.hsl.hcg = function (hsl) {
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var c = 1;
	var f = 0;

	if (l < 0.5) {
		c = 2.0 * s * l;
	} else {
		c = 2.0 * s * (1.0 - l);
	}

	if (c < 1.0) {
		f = (l - 0.5 * c) / (1.0 - c);
	}

	return [hsl[0], c * 100, f * 100];
};

convert.hsv.hcg = function (hsv) {
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;

	var c = s * v;
	var f = 0;

	if (c < 1.0) {
		f = (v - c) / (1 - c);
	}

	return [hsv[0], c * 100, f * 100];
};

convert.hcg.rgb = function (hcg) {
	var h = hcg[0] / 360;
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	if (c === 0.0) {
		return [g * 255, g * 255, g * 255];
	}

	var pure = [0, 0, 0];
	var hi = (h % 1) * 6;
	var v = hi % 1;
	var w = 1 - v;
	var mg = 0;

	switch (Math.floor(hi)) {
		case 0:
			pure[0] = 1; pure[1] = v; pure[2] = 0; break;
		case 1:
			pure[0] = w; pure[1] = 1; pure[2] = 0; break;
		case 2:
			pure[0] = 0; pure[1] = 1; pure[2] = v; break;
		case 3:
			pure[0] = 0; pure[1] = w; pure[2] = 1; break;
		case 4:
			pure[0] = v; pure[1] = 0; pure[2] = 1; break;
		default:
			pure[0] = 1; pure[1] = 0; pure[2] = w;
	}

	mg = (1.0 - c) * g;

	return [
		(c * pure[0] + mg) * 255,
		(c * pure[1] + mg) * 255,
		(c * pure[2] + mg) * 255
	];
};

convert.hcg.hsv = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	var v = c + g * (1.0 - c);
	var f = 0;

	if (v > 0.0) {
		f = c / v;
	}

	return [hcg[0], f * 100, v * 100];
};

convert.hcg.hsl = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	var l = g * (1.0 - c) + 0.5 * c;
	var s = 0;

	if (l > 0.0 && l < 0.5) {
		s = c / (2 * l);
	} else
	if (l >= 0.5 && l < 1.0) {
		s = c / (2 * (1 - l));
	}

	return [hcg[0], s * 100, l * 100];
};

convert.hcg.hwb = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;
	var v = c + g * (1.0 - c);
	return [hcg[0], (v - c) * 100, (1 - v) * 100];
};

convert.hwb.hcg = function (hwb) {
	var w = hwb[1] / 100;
	var b = hwb[2] / 100;
	var v = 1 - b;
	var c = v - w;
	var g = 0;

	if (c < 1) {
		g = (v - c) / (1 - c);
	}

	return [hwb[0], c * 100, g * 100];
};

convert.apple.rgb = function (apple) {
	return [(apple[0] / 65535) * 255, (apple[1] / 65535) * 255, (apple[2] / 65535) * 255];
};

convert.rgb.apple = function (rgb) {
	return [(rgb[0] / 255) * 65535, (rgb[1] / 255) * 65535, (rgb[2] / 255) * 65535];
};

convert.gray.rgb = function (args) {
	return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
};

convert.gray.hsl = convert.gray.hsv = function (args) {
	return [0, 0, args[0]];
};

convert.gray.hwb = function (gray) {
	return [0, 100, gray[0]];
};

convert.gray.cmyk = function (gray) {
	return [0, 0, 0, gray[0]];
};

convert.gray.lab = function (gray) {
	return [gray[0], 0, 0];
};

convert.gray.hex = function (gray) {
	var val = Math.round(gray[0] / 100 * 255) & 0xFF;
	var integer = (val << 16) + (val << 8) + val;

	var string = integer.toString(16).toUpperCase();
	return '000000'.substring(string.length) + string;
};

convert.rgb.gray = function (rgb) {
	var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
	return [val / 255 * 100];
};
});
var conversions_1 = conversions.rgb;
var conversions_2 = conversions.hsl;
var conversions_3 = conversions.hsv;
var conversions_4 = conversions.hwb;
var conversions_5 = conversions.cmyk;
var conversions_6 = conversions.xyz;
var conversions_7 = conversions.lab;
var conversions_8 = conversions.lch;
var conversions_9 = conversions.hex;
var conversions_10 = conversions.keyword;
var conversions_11 = conversions.ansi16;
var conversions_12 = conversions.ansi256;
var conversions_13 = conversions.hcg;
var conversions_14 = conversions.apple;
var conversions_15 = conversions.gray;

/*
	this function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/

function buildGraph() {
	var graph = {};
	// https://jsperf.com/object-keys-vs-for-in-with-closure/3
	var models = Object.keys(conversions);

	for (var len = models.length, i = 0; i < len; i++) {
		graph[models[i]] = {
			// http://jsperf.com/1-vs-infinity
			// micro-opt, but this is simple.
			distance: -1,
			parent: null
		};
	}

	return graph;
}

// https://en.wikipedia.org/wiki/Breadth-first_search
function deriveBFS(fromModel) {
	var graph = buildGraph();
	var queue = [fromModel]; // unshift -> queue -> pop

	graph[fromModel].distance = 0;

	while (queue.length) {
		var current = queue.pop();
		var adjacents = Object.keys(conversions[current]);

		for (var len = adjacents.length, i = 0; i < len; i++) {
			var adjacent = adjacents[i];
			var node = graph[adjacent];

			if (node.distance === -1) {
				node.distance = graph[current].distance + 1;
				node.parent = current;
				queue.unshift(adjacent);
			}
		}
	}

	return graph;
}

function link(from, to) {
	return function (args) {
		return to(from(args));
	};
}

function wrapConversion(toModel, graph) {
	var path = [graph[toModel].parent, toModel];
	var fn = conversions[graph[toModel].parent][toModel];

	var cur = graph[toModel].parent;
	while (graph[cur].parent) {
		path.unshift(graph[cur].parent);
		fn = link(conversions[graph[cur].parent][cur], fn);
		cur = graph[cur].parent;
	}

	fn.conversion = path;
	return fn;
}

var route = function (fromModel) {
	var graph = deriveBFS(fromModel);
	var conversion = {};

	var models = Object.keys(graph);
	for (var len = models.length, i = 0; i < len; i++) {
		var toModel = models[i];
		var node = graph[toModel];

		if (node.parent === null) {
			// no possible conversion, or this node is the source model.
			continue;
		}

		conversion[toModel] = wrapConversion(toModel, graph);
	}

	return conversion;
};

var convert = {};

var models = Object.keys(conversions);

function wrapRaw(fn) {
	var wrappedFn = function (args) {
		if (args === undefined || args === null) {
			return args;
		}

		if (arguments.length > 1) {
			args = Array.prototype.slice.call(arguments);
		}

		return fn(args);
	};

	// preserve .conversion property if there is one
	if ('conversion' in fn) {
		wrappedFn.conversion = fn.conversion;
	}

	return wrappedFn;
}

function wrapRounded(fn) {
	var wrappedFn = function (args) {
		if (args === undefined || args === null) {
			return args;
		}

		if (arguments.length > 1) {
			args = Array.prototype.slice.call(arguments);
		}

		var result = fn(args);

		// we're assuming the result is an array here.
		// see notice in conversions.js; don't use box types
		// in conversion functions.
		if (typeof result === 'object') {
			for (var len = result.length, i = 0; i < len; i++) {
				result[i] = Math.round(result[i]);
			}
		}

		return result;
	};

	// preserve .conversion property if there is one
	if ('conversion' in fn) {
		wrappedFn.conversion = fn.conversion;
	}

	return wrappedFn;
}

models.forEach(function (fromModel) {
	convert[fromModel] = {};

	Object.defineProperty(convert[fromModel], 'channels', {value: conversions[fromModel].channels});
	Object.defineProperty(convert[fromModel], 'labels', {value: conversions[fromModel].labels});

	var routes = route(fromModel);
	var routeModels = Object.keys(routes);

	routeModels.forEach(function (toModel) {
		var fn = routes[toModel];

		convert[fromModel][toModel] = wrapRounded(fn);
		convert[fromModel][toModel].raw = wrapRaw(fn);
	});
});

var colorConvert = convert;

var colorName$1 = {
	"aliceblue": [240, 248, 255],
	"antiquewhite": [250, 235, 215],
	"aqua": [0, 255, 255],
	"aquamarine": [127, 255, 212],
	"azure": [240, 255, 255],
	"beige": [245, 245, 220],
	"bisque": [255, 228, 196],
	"black": [0, 0, 0],
	"blanchedalmond": [255, 235, 205],
	"blue": [0, 0, 255],
	"blueviolet": [138, 43, 226],
	"brown": [165, 42, 42],
	"burlywood": [222, 184, 135],
	"cadetblue": [95, 158, 160],
	"chartreuse": [127, 255, 0],
	"chocolate": [210, 105, 30],
	"coral": [255, 127, 80],
	"cornflowerblue": [100, 149, 237],
	"cornsilk": [255, 248, 220],
	"crimson": [220, 20, 60],
	"cyan": [0, 255, 255],
	"darkblue": [0, 0, 139],
	"darkcyan": [0, 139, 139],
	"darkgoldenrod": [184, 134, 11],
	"darkgray": [169, 169, 169],
	"darkgreen": [0, 100, 0],
	"darkgrey": [169, 169, 169],
	"darkkhaki": [189, 183, 107],
	"darkmagenta": [139, 0, 139],
	"darkolivegreen": [85, 107, 47],
	"darkorange": [255, 140, 0],
	"darkorchid": [153, 50, 204],
	"darkred": [139, 0, 0],
	"darksalmon": [233, 150, 122],
	"darkseagreen": [143, 188, 143],
	"darkslateblue": [72, 61, 139],
	"darkslategray": [47, 79, 79],
	"darkslategrey": [47, 79, 79],
	"darkturquoise": [0, 206, 209],
	"darkviolet": [148, 0, 211],
	"deeppink": [255, 20, 147],
	"deepskyblue": [0, 191, 255],
	"dimgray": [105, 105, 105],
	"dimgrey": [105, 105, 105],
	"dodgerblue": [30, 144, 255],
	"firebrick": [178, 34, 34],
	"floralwhite": [255, 250, 240],
	"forestgreen": [34, 139, 34],
	"fuchsia": [255, 0, 255],
	"gainsboro": [220, 220, 220],
	"ghostwhite": [248, 248, 255],
	"gold": [255, 215, 0],
	"goldenrod": [218, 165, 32],
	"gray": [128, 128, 128],
	"green": [0, 128, 0],
	"greenyellow": [173, 255, 47],
	"grey": [128, 128, 128],
	"honeydew": [240, 255, 240],
	"hotpink": [255, 105, 180],
	"indianred": [205, 92, 92],
	"indigo": [75, 0, 130],
	"ivory": [255, 255, 240],
	"khaki": [240, 230, 140],
	"lavender": [230, 230, 250],
	"lavenderblush": [255, 240, 245],
	"lawngreen": [124, 252, 0],
	"lemonchiffon": [255, 250, 205],
	"lightblue": [173, 216, 230],
	"lightcoral": [240, 128, 128],
	"lightcyan": [224, 255, 255],
	"lightgoldenrodyellow": [250, 250, 210],
	"lightgray": [211, 211, 211],
	"lightgreen": [144, 238, 144],
	"lightgrey": [211, 211, 211],
	"lightpink": [255, 182, 193],
	"lightsalmon": [255, 160, 122],
	"lightseagreen": [32, 178, 170],
	"lightskyblue": [135, 206, 250],
	"lightslategray": [119, 136, 153],
	"lightslategrey": [119, 136, 153],
	"lightsteelblue": [176, 196, 222],
	"lightyellow": [255, 255, 224],
	"lime": [0, 255, 0],
	"limegreen": [50, 205, 50],
	"linen": [250, 240, 230],
	"magenta": [255, 0, 255],
	"maroon": [128, 0, 0],
	"mediumaquamarine": [102, 205, 170],
	"mediumblue": [0, 0, 205],
	"mediumorchid": [186, 85, 211],
	"mediumpurple": [147, 112, 219],
	"mediumseagreen": [60, 179, 113],
	"mediumslateblue": [123, 104, 238],
	"mediumspringgreen": [0, 250, 154],
	"mediumturquoise": [72, 209, 204],
	"mediumvioletred": [199, 21, 133],
	"midnightblue": [25, 25, 112],
	"mintcream": [245, 255, 250],
	"mistyrose": [255, 228, 225],
	"moccasin": [255, 228, 181],
	"navajowhite": [255, 222, 173],
	"navy": [0, 0, 128],
	"oldlace": [253, 245, 230],
	"olive": [128, 128, 0],
	"olivedrab": [107, 142, 35],
	"orange": [255, 165, 0],
	"orangered": [255, 69, 0],
	"orchid": [218, 112, 214],
	"palegoldenrod": [238, 232, 170],
	"palegreen": [152, 251, 152],
	"paleturquoise": [175, 238, 238],
	"palevioletred": [219, 112, 147],
	"papayawhip": [255, 239, 213],
	"peachpuff": [255, 218, 185],
	"peru": [205, 133, 63],
	"pink": [255, 192, 203],
	"plum": [221, 160, 221],
	"powderblue": [176, 224, 230],
	"purple": [128, 0, 128],
	"rebeccapurple": [102, 51, 153],
	"red": [255, 0, 0],
	"rosybrown": [188, 143, 143],
	"royalblue": [65, 105, 225],
	"saddlebrown": [139, 69, 19],
	"salmon": [250, 128, 114],
	"sandybrown": [244, 164, 96],
	"seagreen": [46, 139, 87],
	"seashell": [255, 245, 238],
	"sienna": [160, 82, 45],
	"silver": [192, 192, 192],
	"skyblue": [135, 206, 235],
	"slateblue": [106, 90, 205],
	"slategray": [112, 128, 144],
	"slategrey": [112, 128, 144],
	"snow": [255, 250, 250],
	"springgreen": [0, 255, 127],
	"steelblue": [70, 130, 180],
	"tan": [210, 180, 140],
	"teal": [0, 128, 128],
	"thistle": [216, 191, 216],
	"tomato": [255, 99, 71],
	"turquoise": [64, 224, 208],
	"violet": [238, 130, 238],
	"wheat": [245, 222, 179],
	"white": [255, 255, 255],
	"whitesmoke": [245, 245, 245],
	"yellow": [255, 255, 0],
	"yellowgreen": [154, 205, 50]
};

/* MIT license */


var colorString = {
   getRgba: getRgba,
   getHsla: getHsla,
   getRgb: getRgb,
   getHsl: getHsl,
   getHwb: getHwb,
   getAlpha: getAlpha,

   hexString: hexString,
   rgbString: rgbString,
   rgbaString: rgbaString,
   percentString: percentString,
   percentaString: percentaString,
   hslString: hslString,
   hslaString: hslaString,
   hwbString: hwbString,
   keyword: keyword
};

function getRgba(string) {
   if (!string) {
      return;
   }
   var abbr =  /^#([a-fA-F0-9]{3,4})$/i,
       hex =  /^#([a-fA-F0-9]{6}([a-fA-F0-9]{2})?)$/i,
       rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
       per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
       keyword = /(\w+)/;

   var rgb = [0, 0, 0],
       a = 1,
       match = string.match(abbr),
       hexAlpha = "";
   if (match) {
      match = match[1];
      hexAlpha = match[3];
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match[i] + match[i], 16);
      }
      if (hexAlpha) {
         a = Math.round((parseInt(hexAlpha + hexAlpha, 16) / 255) * 100) / 100;
      }
   }
   else if (match = string.match(hex)) {
      hexAlpha = match[2];
      match = match[1];
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
      }
      if (hexAlpha) {
         a = Math.round((parseInt(hexAlpha, 16) / 255) * 100) / 100;
      }
   }
   else if (match = string.match(rgba)) {
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match[i + 1]);
      }
      a = parseFloat(match[4]);
   }
   else if (match = string.match(per)) {
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
      }
      a = parseFloat(match[4]);
   }
   else if (match = string.match(keyword)) {
      if (match[1] == "transparent") {
         return [0, 0, 0, 0];
      }
      rgb = colorName$1[match[1]];
      if (!rgb) {
         return;
      }
   }

   for (var i = 0; i < rgb.length; i++) {
      rgb[i] = scale(rgb[i], 0, 255);
   }
   if (!a && a != 0) {
      a = 1;
   }
   else {
      a = scale(a, 0, 1);
   }
   rgb[3] = a;
   return rgb;
}

function getHsla(string) {
   if (!string) {
      return;
   }
   var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
   var match = string.match(hsl);
   if (match) {
      var alpha = parseFloat(match[4]);
      var h = scale(parseInt(match[1]), 0, 360),
          s = scale(parseFloat(match[2]), 0, 100),
          l = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
      return [h, s, l, a];
   }
}

function getHwb(string) {
   if (!string) {
      return;
   }
   var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
   var match = string.match(hwb);
   if (match) {
    var alpha = parseFloat(match[4]);
      var h = scale(parseInt(match[1]), 0, 360),
          w = scale(parseFloat(match[2]), 0, 100),
          b = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
      return [h, w, b, a];
   }
}

function getRgb(string) {
   var rgba = getRgba(string);
   return rgba && rgba.slice(0, 3);
}

function getHsl(string) {
  var hsla = getHsla(string);
  return hsla && hsla.slice(0, 3);
}

function getAlpha(string) {
   var vals = getRgba(string);
   if (vals) {
      return vals[3];
   }
   else if (vals = getHsla(string)) {
      return vals[3];
   }
   else if (vals = getHwb(string)) {
      return vals[3];
   }
}

// generators
function hexString(rgba, a) {
   var a = (a !== undefined && rgba.length === 3) ? a : rgba[3];
   return "#" + hexDouble(rgba[0]) 
              + hexDouble(rgba[1])
              + hexDouble(rgba[2])
              + (
                 (a >= 0 && a < 1)
                 ? hexDouble(Math.round(a * 255))
                 : ""
              );
}

function rgbString(rgba, alpha) {
   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
      return rgbaString(rgba, alpha);
   }
   return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
}

function rgbaString(rgba, alpha) {
   if (alpha === undefined) {
      alpha = (rgba[3] !== undefined ? rgba[3] : 1);
   }
   return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2]
           + ", " + alpha + ")";
}

function percentString(rgba, alpha) {
   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
      return percentaString(rgba, alpha);
   }
   var r = Math.round(rgba[0]/255 * 100),
       g = Math.round(rgba[1]/255 * 100),
       b = Math.round(rgba[2]/255 * 100);

   return "rgb(" + r + "%, " + g + "%, " + b + "%)";
}

function percentaString(rgba, alpha) {
   var r = Math.round(rgba[0]/255 * 100),
       g = Math.round(rgba[1]/255 * 100),
       b = Math.round(rgba[2]/255 * 100);
   return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
}

function hslString(hsla, alpha) {
   if (alpha < 1 || (hsla[3] && hsla[3] < 1)) {
      return hslaString(hsla, alpha);
   }
   return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
}

function hslaString(hsla, alpha) {
   if (alpha === undefined) {
      alpha = (hsla[3] !== undefined ? hsla[3] : 1);
   }
   return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, "
           + alpha + ")";
}

// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
// (hwb have alpha optional & 1 is default value)
function hwbString(hwb, alpha) {
   if (alpha === undefined) {
      alpha = (hwb[3] !== undefined ? hwb[3] : 1);
   }
   return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%"
           + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
}

function keyword(rgb) {
  return reverseNames[rgb.slice(0, 3)];
}

// helpers
function scale(num, min, max) {
   return Math.min(Math.max(min, num), max);
}

function hexDouble(num) {
  var str = num.toString(16).toUpperCase();
  return (str.length < 2) ? "0" + str : str;
}


//create a list of reverse color names
var reverseNames = {};
for (var name in colorName$1) {
   reverseNames[colorName$1[name]] = name;
}

/* MIT license */



var Color = function (obj) {
	if (obj instanceof Color) {
		return obj;
	}
	if (!(this instanceof Color)) {
		return new Color(obj);
	}

	this.valid = false;
	this.values = {
		rgb: [0, 0, 0],
		hsl: [0, 0, 0],
		hsv: [0, 0, 0],
		hwb: [0, 0, 0],
		cmyk: [0, 0, 0, 0],
		alpha: 1
	};

	// parse Color() argument
	var vals;
	if (typeof obj === 'string') {
		vals = colorString.getRgba(obj);
		if (vals) {
			this.setValues('rgb', vals);
		} else if (vals = colorString.getHsla(obj)) {
			this.setValues('hsl', vals);
		} else if (vals = colorString.getHwb(obj)) {
			this.setValues('hwb', vals);
		}
	} else if (typeof obj === 'object') {
		vals = obj;
		if (vals.r !== undefined || vals.red !== undefined) {
			this.setValues('rgb', vals);
		} else if (vals.l !== undefined || vals.lightness !== undefined) {
			this.setValues('hsl', vals);
		} else if (vals.v !== undefined || vals.value !== undefined) {
			this.setValues('hsv', vals);
		} else if (vals.w !== undefined || vals.whiteness !== undefined) {
			this.setValues('hwb', vals);
		} else if (vals.c !== undefined || vals.cyan !== undefined) {
			this.setValues('cmyk', vals);
		}
	}
};

Color.prototype = {
	isValid: function () {
		return this.valid;
	},
	rgb: function () {
		return this.setSpace('rgb', arguments);
	},
	hsl: function () {
		return this.setSpace('hsl', arguments);
	},
	hsv: function () {
		return this.setSpace('hsv', arguments);
	},
	hwb: function () {
		return this.setSpace('hwb', arguments);
	},
	cmyk: function () {
		return this.setSpace('cmyk', arguments);
	},

	rgbArray: function () {
		return this.values.rgb;
	},
	hslArray: function () {
		return this.values.hsl;
	},
	hsvArray: function () {
		return this.values.hsv;
	},
	hwbArray: function () {
		var values = this.values;
		if (values.alpha !== 1) {
			return values.hwb.concat([values.alpha]);
		}
		return values.hwb;
	},
	cmykArray: function () {
		return this.values.cmyk;
	},
	rgbaArray: function () {
		var values = this.values;
		return values.rgb.concat([values.alpha]);
	},
	hslaArray: function () {
		var values = this.values;
		return values.hsl.concat([values.alpha]);
	},
	alpha: function (val) {
		if (val === undefined) {
			return this.values.alpha;
		}
		this.setValues('alpha', val);
		return this;
	},

	red: function (val) {
		return this.setChannel('rgb', 0, val);
	},
	green: function (val) {
		return this.setChannel('rgb', 1, val);
	},
	blue: function (val) {
		return this.setChannel('rgb', 2, val);
	},
	hue: function (val) {
		if (val) {
			val %= 360;
			val = val < 0 ? 360 + val : val;
		}
		return this.setChannel('hsl', 0, val);
	},
	saturation: function (val) {
		return this.setChannel('hsl', 1, val);
	},
	lightness: function (val) {
		return this.setChannel('hsl', 2, val);
	},
	saturationv: function (val) {
		return this.setChannel('hsv', 1, val);
	},
	whiteness: function (val) {
		return this.setChannel('hwb', 1, val);
	},
	blackness: function (val) {
		return this.setChannel('hwb', 2, val);
	},
	value: function (val) {
		return this.setChannel('hsv', 2, val);
	},
	cyan: function (val) {
		return this.setChannel('cmyk', 0, val);
	},
	magenta: function (val) {
		return this.setChannel('cmyk', 1, val);
	},
	yellow: function (val) {
		return this.setChannel('cmyk', 2, val);
	},
	black: function (val) {
		return this.setChannel('cmyk', 3, val);
	},

	hexString: function () {
		return colorString.hexString(this.values.rgb);
	},
	rgbString: function () {
		return colorString.rgbString(this.values.rgb, this.values.alpha);
	},
	rgbaString: function () {
		return colorString.rgbaString(this.values.rgb, this.values.alpha);
	},
	percentString: function () {
		return colorString.percentString(this.values.rgb, this.values.alpha);
	},
	hslString: function () {
		return colorString.hslString(this.values.hsl, this.values.alpha);
	},
	hslaString: function () {
		return colorString.hslaString(this.values.hsl, this.values.alpha);
	},
	hwbString: function () {
		return colorString.hwbString(this.values.hwb, this.values.alpha);
	},
	keyword: function () {
		return colorString.keyword(this.values.rgb, this.values.alpha);
	},

	rgbNumber: function () {
		var rgb = this.values.rgb;
		return (rgb[0] << 16) | (rgb[1] << 8) | rgb[2];
	},

	luminosity: function () {
		// http://www.w3.org/TR/WCAG20/#relativeluminancedef
		var rgb = this.values.rgb;
		var lum = [];
		for (var i = 0; i < rgb.length; i++) {
			var chan = rgb[i] / 255;
			lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
		}
		return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
	},

	contrast: function (color2) {
		// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
		var lum1 = this.luminosity();
		var lum2 = color2.luminosity();
		if (lum1 > lum2) {
			return (lum1 + 0.05) / (lum2 + 0.05);
		}
		return (lum2 + 0.05) / (lum1 + 0.05);
	},

	level: function (color2) {
		var contrastRatio = this.contrast(color2);
		if (contrastRatio >= 7.1) {
			return 'AAA';
		}

		return (contrastRatio >= 4.5) ? 'AA' : '';
	},

	dark: function () {
		// YIQ equation from http://24ways.org/2010/calculating-color-contrast
		var rgb = this.values.rgb;
		var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
		return yiq < 128;
	},

	light: function () {
		return !this.dark();
	},

	negate: function () {
		var rgb = [];
		for (var i = 0; i < 3; i++) {
			rgb[i] = 255 - this.values.rgb[i];
		}
		this.setValues('rgb', rgb);
		return this;
	},

	lighten: function (ratio) {
		var hsl = this.values.hsl;
		hsl[2] += hsl[2] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	darken: function (ratio) {
		var hsl = this.values.hsl;
		hsl[2] -= hsl[2] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	saturate: function (ratio) {
		var hsl = this.values.hsl;
		hsl[1] += hsl[1] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	desaturate: function (ratio) {
		var hsl = this.values.hsl;
		hsl[1] -= hsl[1] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	whiten: function (ratio) {
		var hwb = this.values.hwb;
		hwb[1] += hwb[1] * ratio;
		this.setValues('hwb', hwb);
		return this;
	},

	blacken: function (ratio) {
		var hwb = this.values.hwb;
		hwb[2] += hwb[2] * ratio;
		this.setValues('hwb', hwb);
		return this;
	},

	greyscale: function () {
		var rgb = this.values.rgb;
		// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
		var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
		this.setValues('rgb', [val, val, val]);
		return this;
	},

	clearer: function (ratio) {
		var alpha = this.values.alpha;
		this.setValues('alpha', alpha - (alpha * ratio));
		return this;
	},

	opaquer: function (ratio) {
		var alpha = this.values.alpha;
		this.setValues('alpha', alpha + (alpha * ratio));
		return this;
	},

	rotate: function (degrees) {
		var hsl = this.values.hsl;
		var hue = (hsl[0] + degrees) % 360;
		hsl[0] = hue < 0 ? 360 + hue : hue;
		this.setValues('hsl', hsl);
		return this;
	},

	/**
	 * Ported from sass implementation in C
	 * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
	 */
	mix: function (mixinColor, weight) {
		var color1 = this;
		var color2 = mixinColor;
		var p = weight === undefined ? 0.5 : weight;

		var w = 2 * p - 1;
		var a = color1.alpha() - color2.alpha();

		var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
		var w2 = 1 - w1;

		return this
			.rgb(
				w1 * color1.red() + w2 * color2.red(),
				w1 * color1.green() + w2 * color2.green(),
				w1 * color1.blue() + w2 * color2.blue()
			)
			.alpha(color1.alpha() * p + color2.alpha() * (1 - p));
	},

	toJSON: function () {
		return this.rgb();
	},

	clone: function () {
		// NOTE(SB): using node-clone creates a dependency to Buffer when using browserify,
		// making the final build way to big to embed in Chart.js. So let's do it manually,
		// assuming that values to clone are 1 dimension arrays containing only numbers,
		// except 'alpha' which is a number.
		var result = new Color();
		var source = this.values;
		var target = result.values;
		var value, type;

		for (var prop in source) {
			if (source.hasOwnProperty(prop)) {
				value = source[prop];
				type = ({}).toString.call(value);
				if (type === '[object Array]') {
					target[prop] = value.slice(0);
				} else if (type === '[object Number]') {
					target[prop] = value;
				} else {
					console.error('unexpected color value:', value);
				}
			}
		}

		return result;
	}
};

Color.prototype.spaces = {
	rgb: ['red', 'green', 'blue'],
	hsl: ['hue', 'saturation', 'lightness'],
	hsv: ['hue', 'saturation', 'value'],
	hwb: ['hue', 'whiteness', 'blackness'],
	cmyk: ['cyan', 'magenta', 'yellow', 'black']
};

Color.prototype.maxes = {
	rgb: [255, 255, 255],
	hsl: [360, 100, 100],
	hsv: [360, 100, 100],
	hwb: [360, 100, 100],
	cmyk: [100, 100, 100, 100]
};

Color.prototype.getValues = function (space) {
	var values = this.values;
	var vals = {};

	for (var i = 0; i < space.length; i++) {
		vals[space.charAt(i)] = values[space][i];
	}

	if (values.alpha !== 1) {
		vals.a = values.alpha;
	}

	// {r: 255, g: 255, b: 255, a: 0.4}
	return vals;
};

Color.prototype.setValues = function (space, vals) {
	var values = this.values;
	var spaces = this.spaces;
	var maxes = this.maxes;
	var alpha = 1;
	var i;

	this.valid = true;

	if (space === 'alpha') {
		alpha = vals;
	} else if (vals.length) {
		// [10, 10, 10]
		values[space] = vals.slice(0, space.length);
		alpha = vals[space.length];
	} else if (vals[space.charAt(0)] !== undefined) {
		// {r: 10, g: 10, b: 10}
		for (i = 0; i < space.length; i++) {
			values[space][i] = vals[space.charAt(i)];
		}

		alpha = vals.a;
	} else if (vals[spaces[space][0]] !== undefined) {
		// {red: 10, green: 10, blue: 10}
		var chans = spaces[space];

		for (i = 0; i < space.length; i++) {
			values[space][i] = vals[chans[i]];
		}

		alpha = vals.alpha;
	}

	values.alpha = Math.max(0, Math.min(1, (alpha === undefined ? values.alpha : alpha)));

	if (space === 'alpha') {
		return false;
	}

	var capped;

	// cap values of the space prior converting all values
	for (i = 0; i < space.length; i++) {
		capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
		values[space][i] = Math.round(capped);
	}

	// convert to all the other color spaces
	for (var sname in spaces) {
		if (sname !== space) {
			values[sname] = colorConvert[space][sname](values[space]);
		}
	}

	return true;
};

Color.prototype.setSpace = function (space, args) {
	var vals = args[0];

	if (vals === undefined) {
		// color.rgb()
		return this.getValues(space);
	}

	// color.rgb(10, 10, 10)
	if (typeof vals === 'number') {
		vals = Array.prototype.slice.call(args);
	}

	this.setValues(space, vals);
	return this;
};

Color.prototype.setChannel = function (space, index, val) {
	var svalues = this.values[space];
	if (val === undefined) {
		// color.red()
		return svalues[index];
	} else if (val === svalues[index]) {
		// color.red(color.red())
		return this;
	}

	// color.red(100)
	svalues[index] = val;
	this.setValues(space, svalues);

	return this;
};

if (typeof window !== 'undefined') {
	window.Color = Color;
}

var chartjsColor = Color;

function isValidKey(key) {
	return ['__proto__', 'prototype', 'constructor'].indexOf(key) === -1;
}

/**
 * @namespace Chart.helpers
 */
var helpers = {
	/**
	 * An empty function that can be used, for example, for optional callback.
	 */
	noop: function() {},

	/**
	 * Returns a unique id, sequentially generated from a global variable.
	 * @returns {number}
	 * @function
	 */
	uid: (function() {
		var id = 0;
		return function() {
			return id++;
		};
	}()),

	/**
	 * Returns true if `value` is neither null nor undefined, else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @since 2.7.0
	 */
	isNullOrUndef: function(value) {
		return value === null || typeof value === 'undefined';
	},

	/**
	 * Returns true if `value` is an array (including typed arrays), else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @function
	 */
	isArray: function(value) {
		if (Array.isArray && Array.isArray(value)) {
			return true;
		}
		var type = Object.prototype.toString.call(value);
		if (type.substr(0, 7) === '[object' && type.substr(-6) === 'Array]') {
			return true;
		}
		return false;
	},

	/**
	 * Returns true if `value` is an object (excluding null), else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @since 2.7.0
	 */
	isObject: function(value) {
		return value !== null && Object.prototype.toString.call(value) === '[object Object]';
	},

	/**
	 * Returns true if `value` is a finite number, else returns false
	 * @param {*} value  - The value to test.
	 * @returns {boolean}
	 */
	isFinite: function(value) {
		return (typeof value === 'number' || value instanceof Number) && isFinite(value);
	},

	/**
	 * Returns `value` if defined, else returns `defaultValue`.
	 * @param {*} value - The value to return if defined.
	 * @param {*} defaultValue - The value to return if `value` is undefined.
	 * @returns {*}
	 */
	valueOrDefault: function(value, defaultValue) {
		return typeof value === 'undefined' ? defaultValue : value;
	},

	/**
	 * Returns value at the given `index` in array if defined, else returns `defaultValue`.
	 * @param {Array} value - The array to lookup for value at `index`.
	 * @param {number} index - The index in `value` to lookup for value.
	 * @param {*} defaultValue - The value to return if `value[index]` is undefined.
	 * @returns {*}
	 */
	valueAtIndexOrDefault: function(value, index, defaultValue) {
		return helpers.valueOrDefault(helpers.isArray(value) ? value[index] : value, defaultValue);
	},

	/**
	 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
	 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
	 * @param {function} fn - The function to call.
	 * @param {Array|undefined|null} args - The arguments with which `fn` should be called.
	 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
	 * @returns {*}
	 */
	callback: function(fn, args, thisArg) {
		if (fn && typeof fn.call === 'function') {
			return fn.apply(thisArg, args);
		}
	},

	/**
	 * Note(SB) for performance sake, this method should only be used when loopable type
	 * is unknown or in none intensive code (not called often and small loopable). Else
	 * it's preferable to use a regular for() loop and save extra function calls.
	 * @param {object|Array} loopable - The object or array to be iterated.
	 * @param {function} fn - The function to call for each item.
	 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
	 * @param {boolean} [reverse] - If true, iterates backward on the loopable.
	 */
	each: function(loopable, fn, thisArg, reverse) {
		var i, len, keys;
		if (helpers.isArray(loopable)) {
			len = loopable.length;
			if (reverse) {
				for (i = len - 1; i >= 0; i--) {
					fn.call(thisArg, loopable[i], i);
				}
			} else {
				for (i = 0; i < len; i++) {
					fn.call(thisArg, loopable[i], i);
				}
			}
		} else if (helpers.isObject(loopable)) {
			keys = Object.keys(loopable);
			len = keys.length;
			for (i = 0; i < len; i++) {
				fn.call(thisArg, loopable[keys[i]], keys[i]);
			}
		}
	},

	/**
	 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
	 * @see https://stackoverflow.com/a/14853974
	 * @param {Array} a0 - The array to compare
	 * @param {Array} a1 - The array to compare
	 * @returns {boolean}
	 */
	arrayEquals: function(a0, a1) {
		var i, ilen, v0, v1;

		if (!a0 || !a1 || a0.length !== a1.length) {
			return false;
		}

		for (i = 0, ilen = a0.length; i < ilen; ++i) {
			v0 = a0[i];
			v1 = a1[i];

			if (v0 instanceof Array && v1 instanceof Array) {
				if (!helpers.arrayEquals(v0, v1)) {
					return false;
				}
			} else if (v0 !== v1) {
				// NOTE: two different object instances will never be equal: {x:20} != {x:20}
				return false;
			}
		}

		return true;
	},

	/**
	 * Returns a deep copy of `source` without keeping references on objects and arrays.
	 * @param {*} source - The value to clone.
	 * @returns {*}
	 */
	clone: function(source) {
		if (helpers.isArray(source)) {
			return source.map(helpers.clone);
		}

		if (helpers.isObject(source)) {
			var target = Object.create(source);
			var keys = Object.keys(source);
			var klen = keys.length;
			var k = 0;

			for (; k < klen; ++k) {
				target[keys[k]] = helpers.clone(source[keys[k]]);
			}

			return target;
		}

		return source;
	},

	/**
	 * The default merger when Chart.helpers.merge is called without merger option.
	 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
	 * @private
	 */
	_merger: function(key, target, source, options) {
		if (!isValidKey(key)) {
			// We want to ensure we do not copy prototypes over
			// as this can pollute global namespaces
			return;
		}

		var tval = target[key];
		var sval = source[key];

		if (helpers.isObject(tval) && helpers.isObject(sval)) {
			helpers.merge(tval, sval, options);
		} else {
			target[key] = helpers.clone(sval);
		}
	},

	/**
	 * Merges source[key] in target[key] only if target[key] is undefined.
	 * @private
	 */
	_mergerIf: function(key, target, source) {
		if (!isValidKey(key)) {
			// We want to ensure we do not copy prototypes over
			// as this can pollute global namespaces
			return;
		}

		var tval = target[key];
		var sval = source[key];

		if (helpers.isObject(tval) && helpers.isObject(sval)) {
			helpers.mergeIf(tval, sval);
		} else if (!target.hasOwnProperty(key)) {
			target[key] = helpers.clone(sval);
		}
	},

	/**
	 * Recursively deep copies `source` properties into `target` with the given `options`.
	 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
	 * @param {object} target - The target object in which all sources are merged into.
	 * @param {object|object[]} source - Object(s) to merge into `target`.
	 * @param {object} [options] - Merging options:
	 * @param {function} [options.merger] - The merge method (key, target, source, options)
	 * @returns {object} The `target` object.
	 */
	merge: function(target, source, options) {
		var sources = helpers.isArray(source) ? source : [source];
		var ilen = sources.length;
		var merge, i, keys, klen, k;

		if (!helpers.isObject(target)) {
			return target;
		}

		options = options || {};
		merge = options.merger || helpers._merger;

		for (i = 0; i < ilen; ++i) {
			source = sources[i];
			if (!helpers.isObject(source)) {
				continue;
			}

			keys = Object.keys(source);
			for (k = 0, klen = keys.length; k < klen; ++k) {
				merge(keys[k], target, source, options);
			}
		}

		return target;
	},

	/**
	 * Recursively deep copies `source` properties into `target` *only* if not defined in target.
	 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
	 * @param {object} target - The target object in which all sources are merged into.
	 * @param {object|object[]} source - Object(s) to merge into `target`.
	 * @returns {object} The `target` object.
	 */
	mergeIf: function(target, source) {
		return helpers.merge(target, source, {merger: helpers._mergerIf});
	},

	/**
	 * Applies the contents of two or more objects together into the first object.
	 * @param {object} target - The target object in which all objects are merged into.
	 * @param {object} arg1 - Object containing additional properties to merge in target.
	 * @param {object} argN - Additional objects containing properties to merge in target.
	 * @returns {object} The `target` object.
	 */
	extend: Object.assign || function(target) {
		return helpers.merge(target, [].slice.call(arguments, 1), {
			merger: function(key, dst, src) {
				dst[key] = src[key];
			}
		});
	},

	/**
	 * Basic javascript inheritance based on the model created in Backbone.js
	 */
	inherits: function(extensions) {
		var me = this;
		var ChartElement = (extensions && extensions.hasOwnProperty('constructor')) ? extensions.constructor : function() {
			return me.apply(this, arguments);
		};

		var Surrogate = function() {
			this.constructor = ChartElement;
		};

		Surrogate.prototype = me.prototype;
		ChartElement.prototype = new Surrogate();
		ChartElement.extend = helpers.inherits;

		if (extensions) {
			helpers.extend(ChartElement.prototype, extensions);
		}

		ChartElement.__super__ = me.prototype;
		return ChartElement;
	},

	_deprecated: function(scope, value, previous, current) {
		if (value !== undefined) {
			console.warn(scope + ': "' + previous +
				'" is deprecated. Please use "' + current + '" instead');
		}
	}
};

var helpers_core = helpers;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.callback instead.
 * @function Chart.helpers.callCallback
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 * @private
 */
helpers.callCallback = helpers.callback;

/**
 * Provided for backward compatibility, use Array.prototype.indexOf instead.
 * Array.prototype.indexOf compatibility: Chrome, Opera, Safari, FF1.5+, IE9+
 * @function Chart.helpers.indexOf
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.indexOf = function(array, item, fromIndex) {
	return Array.prototype.indexOf.call(array, item, fromIndex);
};

/**
 * Provided for backward compatibility, use Chart.helpers.valueOrDefault instead.
 * @function Chart.helpers.getValueOrDefault
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.getValueOrDefault = helpers.valueOrDefault;

/**
 * Provided for backward compatibility, use Chart.helpers.valueAtIndexOrDefault instead.
 * @function Chart.helpers.getValueAtIndexOrDefault
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.getValueAtIndexOrDefault = helpers.valueAtIndexOrDefault;

/**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easingEffects
 * @see http://www.robertpenner.com/easing/
 */
var effects = {
	linear: function(t) {
		return t;
	},

	easeInQuad: function(t) {
		return t * t;
	},

	easeOutQuad: function(t) {
		return -t * (t - 2);
	},

	easeInOutQuad: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t;
		}
		return -0.5 * ((--t) * (t - 2) - 1);
	},

	easeInCubic: function(t) {
		return t * t * t;
	},

	easeOutCubic: function(t) {
		return (t = t - 1) * t * t + 1;
	},

	easeInOutCubic: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t;
		}
		return 0.5 * ((t -= 2) * t * t + 2);
	},

	easeInQuart: function(t) {
		return t * t * t * t;
	},

	easeOutQuart: function(t) {
		return -((t = t - 1) * t * t * t - 1);
	},

	easeInOutQuart: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t * t;
		}
		return -0.5 * ((t -= 2) * t * t * t - 2);
	},

	easeInQuint: function(t) {
		return t * t * t * t * t;
	},

	easeOutQuint: function(t) {
		return (t = t - 1) * t * t * t * t + 1;
	},

	easeInOutQuint: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t * t * t;
		}
		return 0.5 * ((t -= 2) * t * t * t * t + 2);
	},

	easeInSine: function(t) {
		return -Math.cos(t * (Math.PI / 2)) + 1;
	},

	easeOutSine: function(t) {
		return Math.sin(t * (Math.PI / 2));
	},

	easeInOutSine: function(t) {
		return -0.5 * (Math.cos(Math.PI * t) - 1);
	},

	easeInExpo: function(t) {
		return (t === 0) ? 0 : Math.pow(2, 10 * (t - 1));
	},

	easeOutExpo: function(t) {
		return (t === 1) ? 1 : -Math.pow(2, -10 * t) + 1;
	},

	easeInOutExpo: function(t) {
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if ((t /= 0.5) < 1) {
			return 0.5 * Math.pow(2, 10 * (t - 1));
		}
		return 0.5 * (-Math.pow(2, -10 * --t) + 2);
	},

	easeInCirc: function(t) {
		if (t >= 1) {
			return t;
		}
		return -(Math.sqrt(1 - t * t) - 1);
	},

	easeOutCirc: function(t) {
		return Math.sqrt(1 - (t = t - 1) * t);
	},

	easeInOutCirc: function(t) {
		if ((t /= 0.5) < 1) {
			return -0.5 * (Math.sqrt(1 - t * t) - 1);
		}
		return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
	},

	easeInElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if (!p) {
			p = 0.3;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
	},

	easeOutElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if (!p) {
			p = 0.3;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		return a * Math.pow(2, -10 * t) * Math.sin((t - s) * (2 * Math.PI) / p) + 1;
	},

	easeInOutElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if ((t /= 0.5) === 2) {
			return 1;
		}
		if (!p) {
			p = 0.45;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		if (t < 1) {
			return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
		}
		return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p) * 0.5 + 1;
	},
	easeInBack: function(t) {
		var s = 1.70158;
		return t * t * ((s + 1) * t - s);
	},

	easeOutBack: function(t) {
		var s = 1.70158;
		return (t = t - 1) * t * ((s + 1) * t + s) + 1;
	},

	easeInOutBack: function(t) {
		var s = 1.70158;
		if ((t /= 0.5) < 1) {
			return 0.5 * (t * t * (((s *= (1.525)) + 1) * t - s));
		}
		return 0.5 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2);
	},

	easeInBounce: function(t) {
		return 1 - effects.easeOutBounce(1 - t);
	},

	easeOutBounce: function(t) {
		if (t < (1 / 2.75)) {
			return 7.5625 * t * t;
		}
		if (t < (2 / 2.75)) {
			return 7.5625 * (t -= (1.5 / 2.75)) * t + 0.75;
		}
		if (t < (2.5 / 2.75)) {
			return 7.5625 * (t -= (2.25 / 2.75)) * t + 0.9375;
		}
		return 7.5625 * (t -= (2.625 / 2.75)) * t + 0.984375;
	},

	easeInOutBounce: function(t) {
		if (t < 0.5) {
			return effects.easeInBounce(t * 2) * 0.5;
		}
		return effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
	}
};

var helpers_easing = {
	effects: effects
};

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.easing.effects instead.
 * @function Chart.helpers.easingEffects
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers_core.easingEffects = effects;

var PI = Math.PI;
var RAD_PER_DEG = PI / 180;
var DOUBLE_PI = PI * 2;
var HALF_PI = PI / 2;
var QUARTER_PI = PI / 4;
var TWO_THIRDS_PI = PI * 2 / 3;

/**
 * @namespace Chart.helpers.canvas
 */
var exports$1 = {
	/**
	 * Clears the entire canvas associated to the given `chart`.
	 * @param {Chart} chart - The chart for which to clear the canvas.
	 */
	clear: function(chart) {
		chart.ctx.clearRect(0, 0, chart.width, chart.height);
	},

	/**
	 * Creates a "path" for a rectangle with rounded corners at position (x, y) with a
	 * given size (width, height) and the same `radius` for all corners.
	 * @param {CanvasRenderingContext2D} ctx - The canvas 2D Context.
	 * @param {number} x - The x axis of the coordinate for the rectangle starting point.
	 * @param {number} y - The y axis of the coordinate for the rectangle starting point.
	 * @param {number} width - The rectangle's width.
	 * @param {number} height - The rectangle's height.
	 * @param {number} radius - The rounded amount (in pixels) for the four corners.
	 * @todo handle `radius` as top-left, top-right, bottom-right, bottom-left array/object?
	 */
	roundedRect: function(ctx, x, y, width, height, radius) {
		if (radius) {
			var r = Math.min(radius, height / 2, width / 2);
			var left = x + r;
			var top = y + r;
			var right = x + width - r;
			var bottom = y + height - r;

			ctx.moveTo(x, top);
			if (left < right && top < bottom) {
				ctx.arc(left, top, r, -PI, -HALF_PI);
				ctx.arc(right, top, r, -HALF_PI, 0);
				ctx.arc(right, bottom, r, 0, HALF_PI);
				ctx.arc(left, bottom, r, HALF_PI, PI);
			} else if (left < right) {
				ctx.moveTo(left, y);
				ctx.arc(right, top, r, -HALF_PI, HALF_PI);
				ctx.arc(left, top, r, HALF_PI, PI + HALF_PI);
			} else if (top < bottom) {
				ctx.arc(left, top, r, -PI, 0);
				ctx.arc(left, bottom, r, 0, PI);
			} else {
				ctx.arc(left, top, r, -PI, PI);
			}
			ctx.closePath();
			ctx.moveTo(x, y);
		} else {
			ctx.rect(x, y, width, height);
		}
	},

	drawPoint: function(ctx, style, radius, x, y, rotation) {
		var type, xOffset, yOffset, size, cornerRadius;
		var rad = (rotation || 0) * RAD_PER_DEG;

		if (style && typeof style === 'object') {
			type = style.toString();
			if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
				ctx.save();
				ctx.translate(x, y);
				ctx.rotate(rad);
				ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
				ctx.restore();
				return;
			}
		}

		if (isNaN(radius) || radius <= 0) {
			return;
		}

		ctx.beginPath();

		switch (style) {
		// Default includes circle
		default:
			ctx.arc(x, y, radius, 0, DOUBLE_PI);
			ctx.closePath();
			break;
		case 'triangle':
			ctx.moveTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
			rad += TWO_THIRDS_PI;
			ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
			rad += TWO_THIRDS_PI;
			ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
			ctx.closePath();
			break;
		case 'rectRounded':
			// NOTE: the rounded rect implementation changed to use `arc` instead of
			// `quadraticCurveTo` since it generates better results when rect is
			// almost a circle. 0.516 (instead of 0.5) produces results with visually
			// closer proportion to the previous impl and it is inscribed in the
			// circle with `radius`. For more details, see the following PRs:
			// https://github.com/chartjs/Chart.js/issues/5597
			// https://github.com/chartjs/Chart.js/issues/5858
			cornerRadius = radius * 0.516;
			size = radius - cornerRadius;
			xOffset = Math.cos(rad + QUARTER_PI) * size;
			yOffset = Math.sin(rad + QUARTER_PI) * size;
			ctx.arc(x - xOffset, y - yOffset, cornerRadius, rad - PI, rad - HALF_PI);
			ctx.arc(x + yOffset, y - xOffset, cornerRadius, rad - HALF_PI, rad);
			ctx.arc(x + xOffset, y + yOffset, cornerRadius, rad, rad + HALF_PI);
			ctx.arc(x - yOffset, y + xOffset, cornerRadius, rad + HALF_PI, rad + PI);
			ctx.closePath();
			break;
		case 'rect':
			if (!rotation) {
				size = Math.SQRT1_2 * radius;
				ctx.rect(x - size, y - size, 2 * size, 2 * size);
				break;
			}
			rad += QUARTER_PI;
			/* falls through */
		case 'rectRot':
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + yOffset, y - xOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.lineTo(x - yOffset, y + xOffset);
			ctx.closePath();
			break;
		case 'crossRot':
			rad += QUARTER_PI;
			/* falls through */
		case 'cross':
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.moveTo(x + yOffset, y - xOffset);
			ctx.lineTo(x - yOffset, y + xOffset);
			break;
		case 'star':
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.moveTo(x + yOffset, y - xOffset);
			ctx.lineTo(x - yOffset, y + xOffset);
			rad += QUARTER_PI;
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.moveTo(x + yOffset, y - xOffset);
			ctx.lineTo(x - yOffset, y + xOffset);
			break;
		case 'line':
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			break;
		case 'dash':
			ctx.moveTo(x, y);
			ctx.lineTo(x + Math.cos(rad) * radius, y + Math.sin(rad) * radius);
			break;
		}

		ctx.fill();
		ctx.stroke();
	},

	/**
	 * Returns true if the point is inside the rectangle
	 * @param {object} point - The point to test
	 * @param {object} area - The rectangle
	 * @returns {boolean}
	 * @private
	 */
	_isPointInArea: function(point, area) {
		var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.

		return point.x > area.left - epsilon && point.x < area.right + epsilon &&
			point.y > area.top - epsilon && point.y < area.bottom + epsilon;
	},

	clipArea: function(ctx, area) {
		ctx.save();
		ctx.beginPath();
		ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
		ctx.clip();
	},

	unclipArea: function(ctx) {
		ctx.restore();
	},

	lineTo: function(ctx, previous, target, flip) {
		var stepped = target.steppedLine;
		if (stepped) {
			if (stepped === 'middle') {
				var midpoint = (previous.x + target.x) / 2.0;
				ctx.lineTo(midpoint, flip ? target.y : previous.y);
				ctx.lineTo(midpoint, flip ? previous.y : target.y);
			} else if ((stepped === 'after' && !flip) || (stepped !== 'after' && flip)) {
				ctx.lineTo(previous.x, target.y);
			} else {
				ctx.lineTo(target.x, previous.y);
			}
			ctx.lineTo(target.x, target.y);
			return;
		}

		if (!target.tension) {
			ctx.lineTo(target.x, target.y);
			return;
		}

		ctx.bezierCurveTo(
			flip ? previous.controlPointPreviousX : previous.controlPointNextX,
			flip ? previous.controlPointPreviousY : previous.controlPointNextY,
			flip ? target.controlPointNextX : target.controlPointPreviousX,
			flip ? target.controlPointNextY : target.controlPointPreviousY,
			target.x,
			target.y);
	}
};

var helpers_canvas = exports$1;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.canvas.clear instead.
 * @namespace Chart.helpers.clear
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers_core.clear = exports$1.clear;

/**
 * Provided for backward compatibility, use Chart.helpers.canvas.roundedRect instead.
 * @namespace Chart.helpers.drawRoundedRectangle
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers_core.drawRoundedRectangle = function(ctx) {
	ctx.beginPath();
	exports$1.roundedRect.apply(exports$1, arguments);
};

var defaults = {
	/**
	 * @private
	 */
	_set: function(scope, values) {
		return helpers_core.merge(this[scope] || (this[scope] = {}), values);
	}
};

// TODO(v3): remove 'global' from namespace.  all default are global and
// there's inconsistency around which options are under 'global'
defaults._set('global', {
	defaultColor: 'rgba(0,0,0,0.1)',
	defaultFontColor: '#666',
	defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
	defaultFontSize: 12,
	defaultFontStyle: 'normal',
	defaultLineHeight: 1.2,
	showLines: true
});

var core_defaults = defaults;

var valueOrDefault = helpers_core.valueOrDefault;

/**
 * Converts the given font object into a CSS font string.
 * @param {object} font - A font object.
 * @return {string} The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
 * @private
 */
function toFontString(font) {
	if (!font || helpers_core.isNullOrUndef(font.size) || helpers_core.isNullOrUndef(font.family)) {
		return null;
	}

	return (font.style ? font.style + ' ' : '')
		+ (font.weight ? font.weight + ' ' : '')
		+ font.size + 'px '
		+ font.family;
}

/**
 * @alias Chart.helpers.options
 * @namespace
 */
var helpers_options = {
	/**
	 * Converts the given line height `value` in pixels for a specific font `size`.
	 * @param {number|string} value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
	 * @param {number} size - The font size (in pixels) used to resolve relative `value`.
	 * @returns {number} The effective line height in pixels (size * 1.2 if value is invalid).
	 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
	 * @since 2.7.0
	 */
	toLineHeight: function(value, size) {
		var matches = ('' + value).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
		if (!matches || matches[1] === 'normal') {
			return size * 1.2;
		}

		value = +matches[2];

		switch (matches[3]) {
		case 'px':
			return value;
		case '%':
			value /= 100;
			break;
		}

		return size * value;
	},

	/**
	 * Converts the given value into a padding object with pre-computed width/height.
	 * @param {number|object} value - If a number, set the value to all TRBL component,
	 *  else, if and object, use defined properties and sets undefined ones to 0.
	 * @returns {object} The padding values (top, right, bottom, left, width, height)
	 * @since 2.7.0
	 */
	toPadding: function(value) {
		var t, r, b, l;

		if (helpers_core.isObject(value)) {
			t = +value.top || 0;
			r = +value.right || 0;
			b = +value.bottom || 0;
			l = +value.left || 0;
		} else {
			t = r = b = l = +value || 0;
		}

		return {
			top: t,
			right: r,
			bottom: b,
			left: l,
			height: t + b,
			width: l + r
		};
	},

	/**
	 * Parses font options and returns the font object.
	 * @param {object} options - A object that contains font options to be parsed.
	 * @return {object} The font object.
	 * @todo Support font.* options and renamed to toFont().
	 * @private
	 */
	_parseFont: function(options) {
		var globalDefaults = core_defaults.global;
		var size = valueOrDefault(options.fontSize, globalDefaults.defaultFontSize);
		var font = {
			family: valueOrDefault(options.fontFamily, globalDefaults.defaultFontFamily),
			lineHeight: helpers_core.options.toLineHeight(valueOrDefault(options.lineHeight, globalDefaults.defaultLineHeight), size),
			size: size,
			style: valueOrDefault(options.fontStyle, globalDefaults.defaultFontStyle),
			weight: null,
			string: ''
		};

		font.string = toFontString(font);
		return font;
	},

	/**
	 * Evaluates the given `inputs` sequentially and returns the first defined value.
	 * @param {Array} inputs - An array of values, falling back to the last value.
	 * @param {object} [context] - If defined and the current value is a function, the value
	 * is called with `context` as first argument and the result becomes the new input.
	 * @param {number} [index] - If defined and the current value is an array, the value
	 * at `index` become the new input.
	 * @param {object} [info] - object to return information about resolution in
	 * @param {boolean} [info.cacheable] - Will be set to `false` if option is not cacheable.
	 * @since 2.7.0
	 */
	resolve: function(inputs, context, index, info) {
		var cacheable = true;
		var i, ilen, value;

		for (i = 0, ilen = inputs.length; i < ilen; ++i) {
			value = inputs[i];
			if (value === undefined) {
				continue;
			}
			if (context !== undefined && typeof value === 'function') {
				value = value(context);
				cacheable = false;
			}
			if (index !== undefined && helpers_core.isArray(value)) {
				value = value[index];
				cacheable = false;
			}
			if (value !== undefined) {
				if (info && !cacheable) {
					info.cacheable = false;
				}
				return value;
			}
		}
	}
};

/**
 * @alias Chart.helpers.math
 * @namespace
 */
var exports$2 = {
	/**
	 * Returns an array of factors sorted from 1 to sqrt(value)
	 * @private
	 */
	_factorize: function(value) {
		var result = [];
		var sqrt = Math.sqrt(value);
		var i;

		for (i = 1; i < sqrt; i++) {
			if (value % i === 0) {
				result.push(i);
				result.push(value / i);
			}
		}
		if (sqrt === (sqrt | 0)) { // if value is a square number
			result.push(sqrt);
		}

		result.sort(function(a, b) {
			return a - b;
		}).pop();
		return result;
	},

	log10: Math.log10 || function(x) {
		var exponent = Math.log(x) * Math.LOG10E; // Math.LOG10E = 1 / Math.LN10.
		// Check for whole powers of 10,
		// which due to floating point rounding error should be corrected.
		var powerOf10 = Math.round(exponent);
		var isPowerOf10 = x === Math.pow(10, powerOf10);

		return isPowerOf10 ? powerOf10 : exponent;
	}
};

var helpers_math = exports$2;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.math.log10 instead.
 * @namespace Chart.helpers.log10
 * @deprecated since version 2.9.0
 * @todo remove at version 3
 * @private
 */
helpers_core.log10 = exports$2.log10;

var getRtlAdapter = function(rectX, width) {
	return {
		x: function(x) {
			return rectX + rectX + width - x;
		},
		setWidth: function(w) {
			width = w;
		},
		textAlign: function(align) {
			if (align === 'center') {
				return align;
			}
			return align === 'right' ? 'left' : 'right';
		},
		xPlus: function(x, value) {
			return x - value;
		},
		leftForLtr: function(x, itemWidth) {
			return x - itemWidth;
		},
	};
};

var getLtrAdapter = function() {
	return {
		x: function(x) {
			return x;
		},
		setWidth: function(w) { // eslint-disable-line no-unused-vars
		},
		textAlign: function(align) {
			return align;
		},
		xPlus: function(x, value) {
			return x + value;
		},
		leftForLtr: function(x, _itemWidth) { // eslint-disable-line no-unused-vars
			return x;
		},
	};
};

var getAdapter = function(rtl, rectX, width) {
	return rtl ? getRtlAdapter(rectX, width) : getLtrAdapter();
};

var overrideTextDirection = function(ctx, direction) {
	var style, original;
	if (direction === 'ltr' || direction === 'rtl') {
		style = ctx.canvas.style;
		original = [
			style.getPropertyValue('direction'),
			style.getPropertyPriority('direction'),
		];

		style.setProperty('direction', direction, 'important');
		ctx.prevTextDirection = original;
	}
};

var restoreTextDirection = function(ctx) {
	var original = ctx.prevTextDirection;
	if (original !== undefined) {
		delete ctx.prevTextDirection;
		ctx.canvas.style.setProperty('direction', original[0], original[1]);
	}
};

var helpers_rtl = {
	getRtlAdapter: getAdapter,
	overrideTextDirection: overrideTextDirection,
	restoreTextDirection: restoreTextDirection,
};

var helpers$1 = helpers_core;
var easing = helpers_easing;
var canvas = helpers_canvas;
var options = helpers_options;
var math = helpers_math;
var rtl = helpers_rtl;
helpers$1.easing = easing;
helpers$1.canvas = canvas;
helpers$1.options = options;
helpers$1.math = math;
helpers$1.rtl = rtl;

function interpolate(start, view, model, ease) {
	var keys = Object.keys(model);
	var i, ilen, key, actual, origin, target, type, c0, c1;

	for (i = 0, ilen = keys.length; i < ilen; ++i) {
		key = keys[i];

		target = model[key];

		// if a value is added to the model after pivot() has been called, the view
		// doesn't contain it, so let's initialize the view to the target value.
		if (!view.hasOwnProperty(key)) {
			view[key] = target;
		}

		actual = view[key];

		if (actual === target || key[0] === '_') {
			continue;
		}

		if (!start.hasOwnProperty(key)) {
			start[key] = actual;
		}

		origin = start[key];

		type = typeof target;

		if (type === typeof origin) {
			if (type === 'string') {
				c0 = chartjsColor(origin);
				if (c0.valid) {
					c1 = chartjsColor(target);
					if (c1.valid) {
						view[key] = c1.mix(c0, ease).rgbString();
						continue;
					}
				}
			} else if (helpers$1.isFinite(origin) && helpers$1.isFinite(target)) {
				view[key] = origin + (target - origin) * ease;
				continue;
			}
		}

		view[key] = target;
	}
}

var Element = function(configuration) {
	helpers$1.extend(this, configuration);
	this.initialize.apply(this, arguments);
};

helpers$1.extend(Element.prototype, {
	_type: undefined,

	initialize: function() {
		this.hidden = false;
	},

	pivot: function() {
		var me = this;
		if (!me._view) {
			me._view = helpers$1.extend({}, me._model);
		}
		me._start = {};
		return me;
	},

	transition: function(ease) {
		var me = this;
		var model = me._model;
		var start = me._start;
		var view = me._view;

		// No animation -> No Transition
		if (!model || ease === 1) {
			me._view = helpers$1.extend({}, model);
			me._start = null;
			return me;
		}

		if (!view) {
			view = me._view = {};
		}

		if (!start) {
			start = me._start = {};
		}

		interpolate(start, view, model, ease);

		return me;
	},

	tooltipPosition: function() {
		return {
			x: this._model.x,
			y: this._model.y
		};
	},

	hasValue: function() {
		return helpers$1.isNumber(this._model.x) && helpers$1.isNumber(this._model.y);
	}
});

Element.extend = helpers$1.inherits;

var core_element = Element;

var exports$3 = core_element.extend({
	chart: null, // the animation associated chart instance
	currentStep: 0, // the current animation step
	numSteps: 60, // default number of steps
	easing: '', // the easing to use for this animation
	render: null, // render function used by the animation service

	onAnimationProgress: null, // user specified callback to fire on each step of the animation
	onAnimationComplete: null, // user specified callback to fire when the animation finishes
});

var core_animation = exports$3;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.Animation instead
 * @prop Chart.Animation#animationObject
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 */
Object.defineProperty(exports$3.prototype, 'animationObject', {
	get: function() {
		return this;
	}
});

/**
 * Provided for backward compatibility, use Chart.Animation#chart instead
 * @prop Chart.Animation#chartInstance
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 */
Object.defineProperty(exports$3.prototype, 'chartInstance', {
	get: function() {
		return this.chart;
	},
	set: function(value) {
		this.chart = value;
	}
});

core_defaults._set('global', {
	animation: {
		duration: 1000,
		easing: 'easeOutQuart',
		onProgress: helpers$1.noop,
		onComplete: helpers$1.noop
	}
});

var core_animations = {
	animations: [],
	request: null,

	/**
	 * @param {Chart} chart - The chart to animate.
	 * @param {Chart.Animation} animation - The animation that we will animate.
	 * @param {number} duration - The animation duration in ms.
	 * @param {boolean} lazy - if true, the chart is not marked as animating to enable more responsive interactions
	 */
	addAnimation: function(chart, animation, duration, lazy) {
		var animations = this.animations;
		var i, ilen;

		animation.chart = chart;
		animation.startTime = Date.now();
		animation.duration = duration;

		if (!lazy) {
			chart.animating = true;
		}

		for (i = 0, ilen = animations.length; i < ilen; ++i) {
			if (animations[i].chart === chart) {
				animations[i] = animation;
				return;
			}
		}

		animations.push(animation);

		// If there are no animations queued, manually kickstart a digest, for lack of a better word
		if (animations.length === 1) {
			this.requestAnimationFrame();
		}
	},

	cancelAnimation: function(chart) {
		var index = helpers$1.findIndex(this.animations, function(animation) {
			return animation.chart === chart;
		});

		if (index !== -1) {
			this.animations.splice(index, 1);
			chart.animating = false;
		}
	},

	requestAnimationFrame: function() {
		var me = this;
		if (me.request === null) {
			// Skip animation frame requests until the active one is executed.
			// This can happen when processing mouse events, e.g. 'mousemove'
			// and 'mouseout' events will trigger multiple renders.
			me.request = helpers$1.requestAnimFrame.call(window, function() {
				me.request = null;
				me.startDigest();
			});
		}
	},

	/**
	 * @private
	 */
	startDigest: function() {
		var me = this;

		me.advance();

		// Do we have more stuff to animate?
		if (me.animations.length > 0) {
			me.requestAnimationFrame();
		}
	},

	/**
	 * @private
	 */
	advance: function() {
		var animations = this.animations;
		var animation, chart, numSteps, nextStep;
		var i = 0;

		// 1 animation per chart, so we are looping charts here
		while (i < animations.length) {
			animation = animations[i];
			chart = animation.chart;
			numSteps = animation.numSteps;

			// Make sure that currentStep starts at 1
			// https://github.com/chartjs/Chart.js/issues/6104
			nextStep = Math.floor((Date.now() - animation.startTime) / animation.duration * numSteps) + 1;
			animation.currentStep = Math.min(nextStep, numSteps);

			helpers$1.callback(animation.render, [chart, animation], chart);
			helpers$1.callback(animation.onAnimationProgress, [animation], chart);

			if (animation.currentStep >= numSteps) {
				helpers$1.callback(animation.onAnimationComplete, [animation], chart);
				chart.animating = false;
				animations.splice(i, 1);
			} else {
				++i;
			}
		}
	}
};

var resolve = helpers$1.options.resolve;

var arrayEvents = ['push', 'pop', 'shift', 'splice', 'unshift'];

/**
 * Hooks the array methods that add or remove values ('push', pop', 'shift', 'splice',
 * 'unshift') and notify the listener AFTER the array has been altered. Listeners are
 * called on the 'onData*' callbacks (e.g. onDataPush, etc.) with same arguments.
 */
function listenArrayEvents(array, listener) {
	if (array._chartjs) {
		array._chartjs.listeners.push(listener);
		return;
	}

	Object.defineProperty(array, '_chartjs', {
		configurable: true,
		enumerable: false,
		value: {
			listeners: [listener]
		}
	});

	arrayEvents.forEach(function(key) {
		var method = 'onData' + key.charAt(0).toUpperCase() + key.slice(1);
		var base = array[key];

		Object.defineProperty(array, key, {
			configurable: true,
			enumerable: false,
			value: function() {
				var args = Array.prototype.slice.call(arguments);
				var res = base.apply(this, args);

				helpers$1.each(array._chartjs.listeners, function(object) {
					if (typeof object[method] === 'function') {
						object[method].apply(object, args);
					}
				});

				return res;
			}
		});
	});
}

/**
 * Removes the given array event listener and cleanup extra attached properties (such as
 * the _chartjs stub and overridden methods) if array doesn't have any more listeners.
 */
function unlistenArrayEvents(array, listener) {
	var stub = array._chartjs;
	if (!stub) {
		return;
	}

	var listeners = stub.listeners;
	var index = listeners.indexOf(listener);
	if (index !== -1) {
		listeners.splice(index, 1);
	}

	if (listeners.length > 0) {
		return;
	}

	arrayEvents.forEach(function(key) {
		delete array[key];
	});

	delete array._chartjs;
}

// Base class for all dataset controllers (line, bar, etc)
var DatasetController = function(chart, datasetIndex) {
	this.initialize(chart, datasetIndex);
};

helpers$1.extend(DatasetController.prototype, {

	/**
	 * Element type used to generate a meta dataset (e.g. Chart.element.Line).
	 * @type {Chart.core.element}
	 */
	datasetElementType: null,

	/**
	 * Element type used to generate a meta data (e.g. Chart.element.Point).
	 * @type {Chart.core.element}
	 */
	dataElementType: null,

	/**
	 * Dataset element option keys to be resolved in _resolveDatasetElementOptions.
	 * A derived controller may override this to resolve controller-specific options.
	 * The keys defined here are for backward compatibility for legend styles.
	 * @private
	 */
	_datasetElementOptions: [
		'backgroundColor',
		'borderCapStyle',
		'borderColor',
		'borderDash',
		'borderDashOffset',
		'borderJoinStyle',
		'borderWidth'
	],

	/**
	 * Data element option keys to be resolved in _resolveDataElementOptions.
	 * A derived controller may override this to resolve controller-specific options.
	 * The keys defined here are for backward compatibility for legend styles.
	 * @private
	 */
	_dataElementOptions: [
		'backgroundColor',
		'borderColor',
		'borderWidth',
		'pointStyle'
	],

	initialize: function(chart, datasetIndex) {
		var me = this;
		me.chart = chart;
		me.index = datasetIndex;
		me.linkScales();
		me.addElements();
		me._type = me.getMeta().type;
	},

	updateIndex: function(datasetIndex) {
		this.index = datasetIndex;
	},

	linkScales: function() {
		var me = this;
		var meta = me.getMeta();
		var chart = me.chart;
		var scales = chart.scales;
		var dataset = me.getDataset();
		var scalesOpts = chart.options.scales;

		if (meta.xAxisID === null || !(meta.xAxisID in scales) || dataset.xAxisID) {
			meta.xAxisID = dataset.xAxisID || scalesOpts.xAxes[0].id;
		}
		if (meta.yAxisID === null || !(meta.yAxisID in scales) || dataset.yAxisID) {
			meta.yAxisID = dataset.yAxisID || scalesOpts.yAxes[0].id;
		}
	},

	getDataset: function() {
		return this.chart.data.datasets[this.index];
	},

	getMeta: function() {
		return this.chart.getDatasetMeta(this.index);
	},

	getScaleForId: function(scaleID) {
		return this.chart.scales[scaleID];
	},

	/**
	 * @private
	 */
	_getValueScaleId: function() {
		return this.getMeta().yAxisID;
	},

	/**
	 * @private
	 */
	_getIndexScaleId: function() {
		return this.getMeta().xAxisID;
	},

	/**
	 * @private
	 */
	_getValueScale: function() {
		return this.getScaleForId(this._getValueScaleId());
	},

	/**
	 * @private
	 */
	_getIndexScale: function() {
		return this.getScaleForId(this._getIndexScaleId());
	},

	reset: function() {
		this._update(true);
	},

	/**
	 * @private
	 */
	destroy: function() {
		if (this._data) {
			unlistenArrayEvents(this._data, this);
		}
	},

	createMetaDataset: function() {
		var me = this;
		var type = me.datasetElementType;
		return type && new type({
			_chart: me.chart,
			_datasetIndex: me.index
		});
	},

	createMetaData: function(index) {
		var me = this;
		var type = me.dataElementType;
		return type && new type({
			_chart: me.chart,
			_datasetIndex: me.index,
			_index: index
		});
	},

	addElements: function() {
		var me = this;
		var meta = me.getMeta();
		var data = me.getDataset().data || [];
		var metaData = meta.data;
		var i, ilen;

		for (i = 0, ilen = data.length; i < ilen; ++i) {
			metaData[i] = metaData[i] || me.createMetaData(i);
		}

		meta.dataset = meta.dataset || me.createMetaDataset();
	},

	addElementAndReset: function(index) {
		var element = this.createMetaData(index);
		this.getMeta().data.splice(index, 0, element);
		this.updateElement(element, index, true);
	},

	buildOrUpdateElements: function() {
		var me = this;
		var dataset = me.getDataset();
		var data = dataset.data || (dataset.data = []);

		// In order to correctly handle data addition/deletion animation (an thus simulate
		// real-time charts), we need to monitor these data modifications and synchronize
		// the internal meta data accordingly.
		if (me._data !== data) {
			if (me._data) {
				// This case happens when the user replaced the data array instance.
				unlistenArrayEvents(me._data, me);
			}

			if (data && Object.isExtensible(data)) {
				listenArrayEvents(data, me);
			}
			me._data = data;
		}

		// Re-sync meta data in case the user replaced the data array or if we missed
		// any updates and so make sure that we handle number of datapoints changing.
		me.resyncElements();
	},

	/**
	 * Returns the merged user-supplied and default dataset-level options
	 * @private
	 */
	_configure: function() {
		var me = this;
		me._config = helpers$1.merge(Object.create(null), [
			me.chart.options.datasets[me._type],
			me.getDataset(),
		], {
			merger: function(key, target, source) {
				if (key !== '_meta' && key !== 'data') {
					helpers$1._merger(key, target, source);
				}
			}
		});
	},

	_update: function(reset) {
		var me = this;
		me._configure();
		me._cachedDataOpts = null;
		me.update(reset);
	},

	update: helpers$1.noop,

	transition: function(easingValue) {
		var meta = this.getMeta();
		var elements = meta.data || [];
		var ilen = elements.length;
		var i = 0;

		for (; i < ilen; ++i) {
			elements[i].transition(easingValue);
		}

		if (meta.dataset) {
			meta.dataset.transition(easingValue);
		}
	},

	draw: function() {
		var meta = this.getMeta();
		var elements = meta.data || [];
		var ilen = elements.length;
		var i = 0;

		if (meta.dataset) {
			meta.dataset.draw();
		}

		for (; i < ilen; ++i) {
			elements[i].draw();
		}
	},

	/**
	 * Returns a set of predefined style properties that should be used to represent the dataset
	 * or the data if the index is specified
	 * @param {number} index - data index
	 * @return {IStyleInterface} style object
	 */
	getStyle: function(index) {
		var me = this;
		var meta = me.getMeta();
		var dataset = meta.dataset;
		var style;

		me._configure();
		if (dataset && index === undefined) {
			style = me._resolveDatasetElementOptions(dataset || {});
		} else {
			index = index || 0;
			style = me._resolveDataElementOptions(meta.data[index] || {}, index);
		}

		if (style.fill === false || style.fill === null) {
			style.backgroundColor = style.borderColor;
		}

		return style;
	},

	/**
	 * @private
	 */
	_resolveDatasetElementOptions: function(element, hover) {
		var me = this;
		var chart = me.chart;
		var datasetOpts = me._config;
		var custom = element.custom || {};
		var options = chart.options.elements[me.datasetElementType.prototype._type] || {};
		var elementOptions = me._datasetElementOptions;
		var values = {};
		var i, ilen, key, readKey;

		// Scriptable options
		var context = {
			chart: chart,
			dataset: me.getDataset(),
			datasetIndex: me.index,
			hover: hover
		};

		for (i = 0, ilen = elementOptions.length; i < ilen; ++i) {
			key = elementOptions[i];
			readKey = hover ? 'hover' + key.charAt(0).toUpperCase() + key.slice(1) : key;
			values[key] = resolve([
				custom[readKey],
				datasetOpts[readKey],
				options[readKey]
			], context);
		}

		return values;
	},

	/**
	 * @private
	 */
	_resolveDataElementOptions: function(element, index) {
		var me = this;
		var custom = element && element.custom;
		var cached = me._cachedDataOpts;
		if (cached && !custom) {
			return cached;
		}
		var chart = me.chart;
		var datasetOpts = me._config;
		var options = chart.options.elements[me.dataElementType.prototype._type] || {};
		var elementOptions = me._dataElementOptions;
		var values = {};

		// Scriptable options
		var context = {
			chart: chart,
			dataIndex: index,
			dataset: me.getDataset(),
			datasetIndex: me.index
		};

		// `resolve` sets cacheable to `false` if any option is indexed or scripted
		var info = {cacheable: !custom};

		var keys, i, ilen, key;

		custom = custom || {};

		if (helpers$1.isArray(elementOptions)) {
			for (i = 0, ilen = elementOptions.length; i < ilen; ++i) {
				key = elementOptions[i];
				values[key] = resolve([
					custom[key],
					datasetOpts[key],
					options[key]
				], context, index, info);
			}
		} else {
			keys = Object.keys(elementOptions);
			for (i = 0, ilen = keys.length; i < ilen; ++i) {
				key = keys[i];
				values[key] = resolve([
					custom[key],
					datasetOpts[elementOptions[key]],
					datasetOpts[key],
					options[key]
				], context, index, info);
			}
		}

		if (info.cacheable) {
			me._cachedDataOpts = Object.freeze(values);
		}

		return values;
	},

	removeHoverStyle: function(element) {
		helpers$1.merge(element._model, element.$previousStyle || {});
		delete element.$previousStyle;
	},

	setHoverStyle: function(element) {
		var dataset = this.chart.data.datasets[element._datasetIndex];
		var index = element._index;
		var custom = element.custom || {};
		var model = element._model;
		var getHoverColor = helpers$1.getHoverColor;

		element.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth
		};

		model.backgroundColor = resolve([custom.hoverBackgroundColor, dataset.hoverBackgroundColor, getHoverColor(model.backgroundColor)], undefined, index);
		model.borderColor = resolve([custom.hoverBorderColor, dataset.hoverBorderColor, getHoverColor(model.borderColor)], undefined, index);
		model.borderWidth = resolve([custom.hoverBorderWidth, dataset.hoverBorderWidth, model.borderWidth], undefined, index);
	},

	/**
	 * @private
	 */
	_removeDatasetHoverStyle: function() {
		var element = this.getMeta().dataset;

		if (element) {
			this.removeHoverStyle(element);
		}
	},

	/**
	 * @private
	 */
	_setDatasetHoverStyle: function() {
		var element = this.getMeta().dataset;
		var prev = {};
		var i, ilen, key, keys, hoverOptions, model;

		if (!element) {
			return;
		}

		model = element._model;
		hoverOptions = this._resolveDatasetElementOptions(element, true);

		keys = Object.keys(hoverOptions);
		for (i = 0, ilen = keys.length; i < ilen; ++i) {
			key = keys[i];
			prev[key] = model[key];
			model[key] = hoverOptions[key];
		}

		element.$previousStyle = prev;
	},

	/**
	 * @private
	 */
	resyncElements: function() {
		var me = this;
		var meta = me.getMeta();
		var data = me.getDataset().data;
		var numMeta = meta.data.length;
		var numData = data.length;

		if (numData < numMeta) {
			meta.data.splice(numData, numMeta - numData);
		} else if (numData > numMeta) {
			me.insertElements(numMeta, numData - numMeta);
		}
	},

	/**
	 * @private
	 */
	insertElements: function(start, count) {
		for (var i = 0; i < count; ++i) {
			this.addElementAndReset(start + i);
		}
	},

	/**
	 * @private
	 */
	onDataPush: function() {
		var count = arguments.length;
		this.insertElements(this.getDataset().data.length - count, count);
	},

	/**
	 * @private
	 */
	onDataPop: function() {
		this.getMeta().data.pop();
	},

	/**
	 * @private
	 */
	onDataShift: function() {
		this.getMeta().data.shift();
	},

	/**
	 * @private
	 */
	onDataSplice: function(start, count) {
		this.getMeta().data.splice(start, count);
		this.insertElements(start, arguments.length - 2);
	},

	/**
	 * @private
	 */
	onDataUnshift: function() {
		this.insertElements(0, arguments.length);
	}
});

DatasetController.extend = helpers$1.inherits;

var core_datasetController = DatasetController;

var TAU = Math.PI * 2;

core_defaults._set('global', {
	elements: {
		arc: {
			backgroundColor: core_defaults.global.defaultColor,
			borderColor: '#fff',
			borderWidth: 2,
			borderAlign: 'center'
		}
	}
});

function clipArc(ctx, arc) {
	var startAngle = arc.startAngle;
	var endAngle = arc.endAngle;
	var pixelMargin = arc.pixelMargin;
	var angleMargin = pixelMargin / arc.outerRadius;
	var x = arc.x;
	var y = arc.y;

	// Draw an inner border by cliping the arc and drawing a double-width border
	// Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
	ctx.beginPath();
	ctx.arc(x, y, arc.outerRadius, startAngle - angleMargin, endAngle + angleMargin);
	if (arc.innerRadius > pixelMargin) {
		angleMargin = pixelMargin / arc.innerRadius;
		ctx.arc(x, y, arc.innerRadius - pixelMargin, endAngle + angleMargin, startAngle - angleMargin, true);
	} else {
		ctx.arc(x, y, pixelMargin, endAngle + Math.PI / 2, startAngle - Math.PI / 2);
	}
	ctx.closePath();
	ctx.clip();
}

function drawFullCircleBorders(ctx, vm, arc, inner) {
	var endAngle = arc.endAngle;
	var i;

	if (inner) {
		arc.endAngle = arc.startAngle + TAU;
		clipArc(ctx, arc);
		arc.endAngle = endAngle;
		if (arc.endAngle === arc.startAngle && arc.fullCircles) {
			arc.endAngle += TAU;
			arc.fullCircles--;
		}
	}

	ctx.beginPath();
	ctx.arc(arc.x, arc.y, arc.innerRadius, arc.startAngle + TAU, arc.startAngle, true);
	for (i = 0; i < arc.fullCircles; ++i) {
		ctx.stroke();
	}

	ctx.beginPath();
	ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.startAngle + TAU);
	for (i = 0; i < arc.fullCircles; ++i) {
		ctx.stroke();
	}
}

function drawBorder(ctx, vm, arc) {
	var inner = vm.borderAlign === 'inner';

	if (inner) {
		ctx.lineWidth = vm.borderWidth * 2;
		ctx.lineJoin = 'round';
	} else {
		ctx.lineWidth = vm.borderWidth;
		ctx.lineJoin = 'bevel';
	}

	if (arc.fullCircles) {
		drawFullCircleBorders(ctx, vm, arc, inner);
	}

	if (inner) {
		clipArc(ctx, arc);
	}

	ctx.beginPath();
	ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.endAngle);
	ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
	ctx.closePath();
	ctx.stroke();
}

var element_arc = core_element.extend({
	_type: 'arc',

	inLabelRange: function(mouseX) {
		var vm = this._view;

		if (vm) {
			return (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2));
		}
		return false;
	},

	inRange: function(chartX, chartY) {
		var vm = this._view;

		if (vm) {
			var pointRelativePosition = helpers$1.getAngleFromPoint(vm, {x: chartX, y: chartY});
			var angle = pointRelativePosition.angle;
			var distance = pointRelativePosition.distance;

			// Sanitise angle range
			var startAngle = vm.startAngle;
			var endAngle = vm.endAngle;
			while (endAngle < startAngle) {
				endAngle += TAU;
			}
			while (angle > endAngle) {
				angle -= TAU;
			}
			while (angle < startAngle) {
				angle += TAU;
			}

			// Check if within the range of the open/close angle
			var betweenAngles = (angle >= startAngle && angle <= endAngle);
			var withinRadius = (distance >= vm.innerRadius && distance <= vm.outerRadius);

			return (betweenAngles && withinRadius);
		}
		return false;
	},

	getCenterPoint: function() {
		var vm = this._view;
		var halfAngle = (vm.startAngle + vm.endAngle) / 2;
		var halfRadius = (vm.innerRadius + vm.outerRadius) / 2;
		return {
			x: vm.x + Math.cos(halfAngle) * halfRadius,
			y: vm.y + Math.sin(halfAngle) * halfRadius
		};
	},

	getArea: function() {
		var vm = this._view;
		return Math.PI * ((vm.endAngle - vm.startAngle) / (2 * Math.PI)) * (Math.pow(vm.outerRadius, 2) - Math.pow(vm.innerRadius, 2));
	},

	tooltipPosition: function() {
		var vm = this._view;
		var centreAngle = vm.startAngle + ((vm.endAngle - vm.startAngle) / 2);
		var rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;

		return {
			x: vm.x + (Math.cos(centreAngle) * rangeFromCentre),
			y: vm.y + (Math.sin(centreAngle) * rangeFromCentre)
		};
	},

	draw: function() {
		var ctx = this._chart.ctx;
		var vm = this._view;
		var pixelMargin = (vm.borderAlign === 'inner') ? 0.33 : 0;
		var arc = {
			x: vm.x,
			y: vm.y,
			innerRadius: vm.innerRadius,
			outerRadius: Math.max(vm.outerRadius - pixelMargin, 0),
			pixelMargin: pixelMargin,
			startAngle: vm.startAngle,
			endAngle: vm.endAngle,
			fullCircles: Math.floor(vm.circumference / TAU)
		};
		var i;

		ctx.save();

		ctx.fillStyle = vm.backgroundColor;
		ctx.strokeStyle = vm.borderColor;

		if (arc.fullCircles) {
			arc.endAngle = arc.startAngle + TAU;
			ctx.beginPath();
			ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
			ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
			ctx.closePath();
			for (i = 0; i < arc.fullCircles; ++i) {
				ctx.fill();
			}
			arc.endAngle = arc.startAngle + vm.circumference % TAU;
		}

		ctx.beginPath();
		ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
		ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
		ctx.closePath();
		ctx.fill();

		if (vm.borderWidth) {
			drawBorder(ctx, vm, arc);
		}

		ctx.restore();
	}
});

var valueOrDefault$1 = helpers$1.valueOrDefault;

var defaultColor = core_defaults.global.defaultColor;

core_defaults._set('global', {
	elements: {
		line: {
			tension: 0.4,
			backgroundColor: defaultColor,
			borderWidth: 3,
			borderColor: defaultColor,
			borderCapStyle: 'butt',
			borderDash: [],
			borderDashOffset: 0.0,
			borderJoinStyle: 'miter',
			capBezierPoints: true,
			fill: true, // do we fill in the area between the line and its base axis
		}
	}
});

var element_line = core_element.extend({
	_type: 'line',

	draw: function() {
		var me = this;
		var vm = me._view;
		var ctx = me._chart.ctx;
		var spanGaps = vm.spanGaps;
		var points = me._children.slice(); // clone array
		var globalDefaults = core_defaults.global;
		var globalOptionLineElements = globalDefaults.elements.line;
		var lastDrawnIndex = -1;
		var closePath = me._loop;
		var index, previous, currentVM;

		if (!points.length) {
			return;
		}

		if (me._loop) {
			for (index = 0; index < points.length; ++index) {
				previous = helpers$1.previousItem(points, index);
				// If the line has an open path, shift the point array
				if (!points[index]._view.skip && previous._view.skip) {
					points = points.slice(index).concat(points.slice(0, index));
					closePath = spanGaps;
					break;
				}
			}
			// If the line has a close path, add the first point again
			if (closePath) {
				points.push(points[0]);
			}
		}

		ctx.save();

		// Stroke Line Options
		ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;

		// IE 9 and 10 do not support line dash
		if (ctx.setLineDash) {
			ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
		}

		ctx.lineDashOffset = valueOrDefault$1(vm.borderDashOffset, globalOptionLineElements.borderDashOffset);
		ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
		ctx.lineWidth = valueOrDefault$1(vm.borderWidth, globalOptionLineElements.borderWidth);
		ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;

		// Stroke Line
		ctx.beginPath();

		// First point moves to it's starting position no matter what
		currentVM = points[0]._view;
		if (!currentVM.skip) {
			ctx.moveTo(currentVM.x, currentVM.y);
			lastDrawnIndex = 0;
		}

		for (index = 1; index < points.length; ++index) {
			currentVM = points[index]._view;
			previous = lastDrawnIndex === -1 ? helpers$1.previousItem(points, index) : points[lastDrawnIndex];

			if (!currentVM.skip) {
				if ((lastDrawnIndex !== (index - 1) && !spanGaps) || lastDrawnIndex === -1) {
					// There was a gap and this is the first point after the gap
					ctx.moveTo(currentVM.x, currentVM.y);
				} else {
					// Line to next point
					helpers$1.canvas.lineTo(ctx, previous._view, currentVM);
				}
				lastDrawnIndex = index;
			}
		}

		if (closePath) {
			ctx.closePath();
		}

		ctx.stroke();
		ctx.restore();
	}
});

var valueOrDefault$2 = helpers$1.valueOrDefault;

var defaultColor$1 = core_defaults.global.defaultColor;

core_defaults._set('global', {
	elements: {
		point: {
			radius: 3,
			pointStyle: 'circle',
			backgroundColor: defaultColor$1,
			borderColor: defaultColor$1,
			borderWidth: 1,
			// Hover
			hitRadius: 1,
			hoverRadius: 4,
			hoverBorderWidth: 1
		}
	}
});

function xRange(mouseX) {
	var vm = this._view;
	return vm ? (Math.abs(mouseX - vm.x) < vm.radius + vm.hitRadius) : false;
}

function yRange(mouseY) {
	var vm = this._view;
	return vm ? (Math.abs(mouseY - vm.y) < vm.radius + vm.hitRadius) : false;
}

var element_point = core_element.extend({
	_type: 'point',

	inRange: function(mouseX, mouseY) {
		var vm = this._view;
		return vm ? ((Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2)) < Math.pow(vm.hitRadius + vm.radius, 2)) : false;
	},

	inLabelRange: xRange,
	inXRange: xRange,
	inYRange: yRange,

	getCenterPoint: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y
		};
	},

	getArea: function() {
		return Math.PI * Math.pow(this._view.radius, 2);
	},

	tooltipPosition: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y,
			padding: vm.radius + vm.borderWidth
		};
	},

	draw: function(chartArea) {
		var vm = this._view;
		var ctx = this._chart.ctx;
		var pointStyle = vm.pointStyle;
		var rotation = vm.rotation;
		var radius = vm.radius;
		var x = vm.x;
		var y = vm.y;
		var globalDefaults = core_defaults.global;
		var defaultColor = globalDefaults.defaultColor; // eslint-disable-line no-shadow

		if (vm.skip) {
			return;
		}

		// Clipping for Points.
		if (chartArea === undefined || helpers$1.canvas._isPointInArea(vm, chartArea)) {
			ctx.strokeStyle = vm.borderColor || defaultColor;
			ctx.lineWidth = valueOrDefault$2(vm.borderWidth, globalDefaults.elements.point.borderWidth);
			ctx.fillStyle = vm.backgroundColor || defaultColor;
			helpers$1.canvas.drawPoint(ctx, pointStyle, radius, x, y, rotation);
		}
	}
});

var defaultColor$2 = core_defaults.global.defaultColor;

core_defaults._set('global', {
	elements: {
		rectangle: {
			backgroundColor: defaultColor$2,
			borderColor: defaultColor$2,
			borderSkipped: 'bottom',
			borderWidth: 0
		}
	}
});

function isVertical(vm) {
	return vm && vm.width !== undefined;
}

/**
 * Helper function to get the bounds of the bar regardless of the orientation
 * @param bar {Chart.Element.Rectangle} the bar
 * @return {Bounds} bounds of the bar
 * @private
 */
function getBarBounds(vm) {
	var x1, x2, y1, y2, half;

	if (isVertical(vm)) {
		half = vm.width / 2;
		x1 = vm.x - half;
		x2 = vm.x + half;
		y1 = Math.min(vm.y, vm.base);
		y2 = Math.max(vm.y, vm.base);
	} else {
		half = vm.height / 2;
		x1 = Math.min(vm.x, vm.base);
		x2 = Math.max(vm.x, vm.base);
		y1 = vm.y - half;
		y2 = vm.y + half;
	}

	return {
		left: x1,
		top: y1,
		right: x2,
		bottom: y2
	};
}

function swap(orig, v1, v2) {
	return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}

function parseBorderSkipped(vm) {
	var edge = vm.borderSkipped;
	var res = {};

	if (!edge) {
		return res;
	}

	if (vm.horizontal) {
		if (vm.base > vm.x) {
			edge = swap(edge, 'left', 'right');
		}
	} else if (vm.base < vm.y) {
		edge = swap(edge, 'bottom', 'top');
	}

	res[edge] = true;
	return res;
}

function parseBorderWidth(vm, maxW, maxH) {
	var value = vm.borderWidth;
	var skip = parseBorderSkipped(vm);
	var t, r, b, l;

	if (helpers$1.isObject(value)) {
		t = +value.top || 0;
		r = +value.right || 0;
		b = +value.bottom || 0;
		l = +value.left || 0;
	} else {
		t = r = b = l = +value || 0;
	}

	return {
		t: skip.top || (t < 0) ? 0 : t > maxH ? maxH : t,
		r: skip.right || (r < 0) ? 0 : r > maxW ? maxW : r,
		b: skip.bottom || (b < 0) ? 0 : b > maxH ? maxH : b,
		l: skip.left || (l < 0) ? 0 : l > maxW ? maxW : l
	};
}

function boundingRects(vm) {
	var bounds = getBarBounds(vm);
	var width = bounds.right - bounds.left;
	var height = bounds.bottom - bounds.top;
	var border = parseBorderWidth(vm, width / 2, height / 2);

	return {
		outer: {
			x: bounds.left,
			y: bounds.top,
			w: width,
			h: height
		},
		inner: {
			x: bounds.left + border.l,
			y: bounds.top + border.t,
			w: width - border.l - border.r,
			h: height - border.t - border.b
		}
	};
}

function inRange(vm, x, y) {
	var skipX = x === null;
	var skipY = y === null;
	var bounds = !vm || (skipX && skipY) ? false : getBarBounds(vm);

	return bounds
		&& (skipX || x >= bounds.left && x <= bounds.right)
		&& (skipY || y >= bounds.top && y <= bounds.bottom);
}

var element_rectangle = core_element.extend({
	_type: 'rectangle',

	draw: function() {
		var ctx = this._chart.ctx;
		var vm = this._view;
		var rects = boundingRects(vm);
		var outer = rects.outer;
		var inner = rects.inner;

		ctx.fillStyle = vm.backgroundColor;
		ctx.fillRect(outer.x, outer.y, outer.w, outer.h);

		if (outer.w === inner.w && outer.h === inner.h) {
			return;
		}

		ctx.save();
		ctx.beginPath();
		ctx.rect(outer.x, outer.y, outer.w, outer.h);
		ctx.clip();
		ctx.fillStyle = vm.borderColor;
		ctx.rect(inner.x, inner.y, inner.w, inner.h);
		ctx.fill('evenodd');
		ctx.restore();
	},

	height: function() {
		var vm = this._view;
		return vm.base - vm.y;
	},

	inRange: function(mouseX, mouseY) {
		return inRange(this._view, mouseX, mouseY);
	},

	inLabelRange: function(mouseX, mouseY) {
		var vm = this._view;
		return isVertical(vm)
			? inRange(vm, mouseX, null)
			: inRange(vm, null, mouseY);
	},

	inXRange: function(mouseX) {
		return inRange(this._view, mouseX, null);
	},

	inYRange: function(mouseY) {
		return inRange(this._view, null, mouseY);
	},

	getCenterPoint: function() {
		var vm = this._view;
		var x, y;
		if (isVertical(vm)) {
			x = vm.x;
			y = (vm.y + vm.base) / 2;
		} else {
			x = (vm.x + vm.base) / 2;
			y = vm.y;
		}

		return {x: x, y: y};
	},

	getArea: function() {
		var vm = this._view;

		return isVertical(vm)
			? vm.width * Math.abs(vm.y - vm.base)
			: vm.height * Math.abs(vm.x - vm.base);
	},

	tooltipPosition: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y
		};
	}
});

var elements = {};
var Arc = element_arc;
var Line = element_line;
var Point = element_point;
var Rectangle = element_rectangle;
elements.Arc = Arc;
elements.Line = Line;
elements.Point = Point;
elements.Rectangle = Rectangle;

var deprecated = helpers$1._deprecated;
var valueOrDefault$3 = helpers$1.valueOrDefault;

core_defaults._set('bar', {
	hover: {
		mode: 'label'
	},

	scales: {
		xAxes: [{
			type: 'category',
			offset: true,
			gridLines: {
				offsetGridLines: true
			}
		}],

		yAxes: [{
			type: 'linear'
		}]
	}
});

core_defaults._set('global', {
	datasets: {
		bar: {
			categoryPercentage: 0.8,
			barPercentage: 0.9
		}
	}
});

/**
 * Computes the "optimal" sample size to maintain bars equally sized while preventing overlap.
 * @private
 */
function computeMinSampleSize(scale, pixels) {
	var min = scale._length;
	var prev, curr, i, ilen;

	for (i = 1, ilen = pixels.length; i < ilen; ++i) {
		min = Math.min(min, Math.abs(pixels[i] - pixels[i - 1]));
	}

	for (i = 0, ilen = scale.getTicks().length; i < ilen; ++i) {
		curr = scale.getPixelForTick(i);
		min = i > 0 ? Math.min(min, Math.abs(curr - prev)) : min;
		prev = curr;
	}

	return min;
}

/**
 * Computes an "ideal" category based on the absolute bar thickness or, if undefined or null,
 * uses the smallest interval (see computeMinSampleSize) that prevents bar overlapping. This
 * mode currently always generates bars equally sized (until we introduce scriptable options?).
 * @private
 */
function computeFitCategoryTraits(index, ruler, options) {
	var thickness = options.barThickness;
	var count = ruler.stackCount;
	var curr = ruler.pixels[index];
	var min = helpers$1.isNullOrUndef(thickness)
		? computeMinSampleSize(ruler.scale, ruler.pixels)
		: -1;
	var size, ratio;

	if (helpers$1.isNullOrUndef(thickness)) {
		size = min * options.categoryPercentage;
		ratio = options.barPercentage;
	} else {
		// When bar thickness is enforced, category and bar percentages are ignored.
		// Note(SB): we could add support for relative bar thickness (e.g. barThickness: '50%')
		// and deprecate barPercentage since this value is ignored when thickness is absolute.
		size = thickness * count;
		ratio = 1;
	}

	return {
		chunk: size / count,
		ratio: ratio,
		start: curr - (size / 2)
	};
}

/**
 * Computes an "optimal" category that globally arranges bars side by side (no gap when
 * percentage options are 1), based on the previous and following categories. This mode
 * generates bars with different widths when data are not evenly spaced.
 * @private
 */
function computeFlexCategoryTraits(index, ruler, options) {
	var pixels = ruler.pixels;
	var curr = pixels[index];
	var prev = index > 0 ? pixels[index - 1] : null;
	var next = index < pixels.length - 1 ? pixels[index + 1] : null;
	var percent = options.categoryPercentage;
	var start, size;

	if (prev === null) {
		// first data: its size is double based on the next point or,
		// if it's also the last data, we use the scale size.
		prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
	}

	if (next === null) {
		// last data: its size is also double based on the previous point.
		next = curr + curr - prev;
	}

	start = curr - (curr - Math.min(prev, next)) / 2 * percent;
	size = Math.abs(next - prev) / 2 * percent;

	return {
		chunk: size / ruler.stackCount,
		ratio: options.barPercentage,
		start: start
	};
}

var controller_bar = core_datasetController.extend({

	dataElementType: elements.Rectangle,

	/**
	 * @private
	 */
	_dataElementOptions: [
		'backgroundColor',
		'borderColor',
		'borderSkipped',
		'borderWidth',
		'barPercentage',
		'barThickness',
		'categoryPercentage',
		'maxBarThickness',
		'minBarLength'
	],

	initialize: function() {
		var me = this;
		var meta, scaleOpts;

		core_datasetController.prototype.initialize.apply(me, arguments);

		meta = me.getMeta();
		meta.stack = me.getDataset().stack;
		meta.bar = true;

		scaleOpts = me._getIndexScale().options;
		deprecated('bar chart', scaleOpts.barPercentage, 'scales.[x/y]Axes.barPercentage', 'dataset.barPercentage');
		deprecated('bar chart', scaleOpts.barThickness, 'scales.[x/y]Axes.barThickness', 'dataset.barThickness');
		deprecated('bar chart', scaleOpts.categoryPercentage, 'scales.[x/y]Axes.categoryPercentage', 'dataset.categoryPercentage');
		deprecated('bar chart', me._getValueScale().options.minBarLength, 'scales.[x/y]Axes.minBarLength', 'dataset.minBarLength');
		deprecated('bar chart', scaleOpts.maxBarThickness, 'scales.[x/y]Axes.maxBarThickness', 'dataset.maxBarThickness');
	},

	update: function(reset) {
		var me = this;
		var rects = me.getMeta().data;
		var i, ilen;

		me._ruler = me.getRuler();

		for (i = 0, ilen = rects.length; i < ilen; ++i) {
			me.updateElement(rects[i], i, reset);
		}
	},

	updateElement: function(rectangle, index, reset) {
		var me = this;
		var meta = me.getMeta();
		var dataset = me.getDataset();
		var options = me._resolveDataElementOptions(rectangle, index);

		rectangle._xScale = me.getScaleForId(meta.xAxisID);
		rectangle._yScale = me.getScaleForId(meta.yAxisID);
		rectangle._datasetIndex = me.index;
		rectangle._index = index;
		rectangle._model = {
			backgroundColor: options.backgroundColor,
			borderColor: options.borderColor,
			borderSkipped: options.borderSkipped,
			borderWidth: options.borderWidth,
			datasetLabel: dataset.label,
			label: me.chart.data.labels[index]
		};

		if (helpers$1.isArray(dataset.data[index])) {
			rectangle._model.borderSkipped = null;
		}

		me._updateElementGeometry(rectangle, index, reset, options);

		rectangle.pivot();
	},

	/**
	 * @private
	 */
	_updateElementGeometry: function(rectangle, index, reset, options) {
		var me = this;
		var model = rectangle._model;
		var vscale = me._getValueScale();
		var base = vscale.getBasePixel();
		var horizontal = vscale.isHorizontal();
		var ruler = me._ruler || me.getRuler();
		var vpixels = me.calculateBarValuePixels(me.index, index, options);
		var ipixels = me.calculateBarIndexPixels(me.index, index, ruler, options);

		model.horizontal = horizontal;
		model.base = reset ? base : vpixels.base;
		model.x = horizontal ? reset ? base : vpixels.head : ipixels.center;
		model.y = horizontal ? ipixels.center : reset ? base : vpixels.head;
		model.height = horizontal ? ipixels.size : undefined;
		model.width = horizontal ? undefined : ipixels.size;
	},

	/**
	 * Returns the stacks based on groups and bar visibility.
	 * @param {number} [last] - The dataset index
	 * @returns {string[]} The list of stack IDs
	 * @private
	 */
	_getStacks: function(last) {
		var me = this;
		var scale = me._getIndexScale();
		var metasets = scale._getMatchingVisibleMetas(me._type);
		var stacked = scale.options.stacked;
		var ilen = metasets.length;
		var stacks = [];
		var i, meta;

		for (i = 0; i < ilen; ++i) {
			meta = metasets[i];
			// stacked   | meta.stack
			//           | found | not found | undefined
			// false     |   x   |     x     |     x
			// true      |       |     x     |
			// undefined |       |     x     |     x
			if (stacked === false || stacks.indexOf(meta.stack) === -1 ||
				(stacked === undefined && meta.stack === undefined)) {
				stacks.push(meta.stack);
			}
			if (meta.index === last) {
				break;
			}
		}

		return stacks;
	},

	/**
	 * Returns the effective number of stacks based on groups and bar visibility.
	 * @private
	 */
	getStackCount: function() {
		return this._getStacks().length;
	},

	/**
	 * Returns the stack index for the given dataset based on groups and bar visibility.
	 * @param {number} [datasetIndex] - The dataset index
	 * @param {string} [name] - The stack name to find
	 * @returns {number} The stack index
	 * @private
	 */
	getStackIndex: function(datasetIndex, name) {
		var stacks = this._getStacks(datasetIndex);
		var index = (name !== undefined)
			? stacks.indexOf(name)
			: -1; // indexOf returns -1 if element is not present

		return (index === -1)
			? stacks.length - 1
			: index;
	},

	/**
	 * @private
	 */
	getRuler: function() {
		var me = this;
		var scale = me._getIndexScale();
		var pixels = [];
		var i, ilen;

		for (i = 0, ilen = me.getMeta().data.length; i < ilen; ++i) {
			pixels.push(scale.getPixelForValue(null, i, me.index));
		}

		return {
			pixels: pixels,
			start: scale._startPixel,
			end: scale._endPixel,
			stackCount: me.getStackCount(),
			scale: scale
		};
	},

	/**
	 * Note: pixel values are not clamped to the scale area.
	 * @private
	 */
	calculateBarValuePixels: function(datasetIndex, index, options) {
		var me = this;
		var chart = me.chart;
		var scale = me._getValueScale();
		var isHorizontal = scale.isHorizontal();
		var datasets = chart.data.datasets;
		var metasets = scale._getMatchingVisibleMetas(me._type);
		var value = scale._parseValue(datasets[datasetIndex].data[index]);
		var minBarLength = options.minBarLength;
		var stacked = scale.options.stacked;
		var stack = me.getMeta().stack;
		var start = value.start === undefined ? 0 : value.max >= 0 && value.min >= 0 ? value.min : value.max;
		var length = value.start === undefined ? value.end : value.max >= 0 && value.min >= 0 ? value.max - value.min : value.min - value.max;
		var ilen = metasets.length;
		var i, imeta, ivalue, base, head, size, stackLength;

		if (stacked || (stacked === undefined && stack !== undefined)) {
			for (i = 0; i < ilen; ++i) {
				imeta = metasets[i];

				if (imeta.index === datasetIndex) {
					break;
				}

				if (imeta.stack === stack) {
					stackLength = scale._parseValue(datasets[imeta.index].data[index]);
					ivalue = stackLength.start === undefined ? stackLength.end : stackLength.min >= 0 && stackLength.max >= 0 ? stackLength.max : stackLength.min;

					if ((value.min < 0 && ivalue < 0) || (value.max >= 0 && ivalue > 0)) {
						start += ivalue;
					}
				}
			}
		}

		base = scale.getPixelForValue(start);
		head = scale.getPixelForValue(start + length);
		size = head - base;

		if (minBarLength !== undefined && Math.abs(size) < minBarLength) {
			size = minBarLength;
			if (length >= 0 && !isHorizontal || length < 0 && isHorizontal) {
				head = base - minBarLength;
			} else {
				head = base + minBarLength;
			}
		}

		return {
			size: size,
			base: base,
			head: head,
			center: head + size / 2
		};
	},

	/**
	 * @private
	 */
	calculateBarIndexPixels: function(datasetIndex, index, ruler, options) {
		var me = this;
		var range = options.barThickness === 'flex'
			? computeFlexCategoryTraits(index, ruler, options)
			: computeFitCategoryTraits(index, ruler, options);

		var stackIndex = me.getStackIndex(datasetIndex, me.getMeta().stack);
		var center = range.start + (range.chunk * stackIndex) + (range.chunk / 2);
		var size = Math.min(
			valueOrDefault$3(options.maxBarThickness, Infinity),
			range.chunk * range.ratio);

		return {
			base: center - size / 2,
			head: center + size / 2,
			center: center,
			size: size
		};
	},

	draw: function() {
		var me = this;
		var chart = me.chart;
		var scale = me._getValueScale();
		var rects = me.getMeta().data;
		var dataset = me.getDataset();
		var ilen = rects.length;
		var i = 0;

		helpers$1.canvas.clipArea(chart.ctx, chart.chartArea);

		for (; i < ilen; ++i) {
			var val = scale._parseValue(dataset.data[i]);
			if (!isNaN(val.min) && !isNaN(val.max)) {
				rects[i].draw();
			}
		}

		helpers$1.canvas.unclipArea(chart.ctx);
	},

	/**
	 * @private
	 */
	_resolveDataElementOptions: function() {
		var me = this;
		var values = helpers$1.extend({}, core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments));
		var indexOpts = me._getIndexScale().options;
		var valueOpts = me._getValueScale().options;

		values.barPercentage = valueOrDefault$3(indexOpts.barPercentage, values.barPercentage);
		values.barThickness = valueOrDefault$3(indexOpts.barThickness, values.barThickness);
		values.categoryPercentage = valueOrDefault$3(indexOpts.categoryPercentage, values.categoryPercentage);
		values.maxBarThickness = valueOrDefault$3(indexOpts.maxBarThickness, values.maxBarThickness);
		values.minBarLength = valueOrDefault$3(valueOpts.minBarLength, values.minBarLength);

		return values;
	}

});

var valueOrDefault$4 = helpers$1.valueOrDefault;
var resolve$1 = helpers$1.options.resolve;

core_defaults._set('bubble', {
	hover: {
		mode: 'single'
	},

	scales: {
		xAxes: [{
			type: 'linear', // bubble should probably use a linear scale by default
			position: 'bottom',
			id: 'x-axis-0' // need an ID so datasets can reference the scale
		}],
		yAxes: [{
			type: 'linear',
			position: 'left',
			id: 'y-axis-0'
		}]
	},

	tooltips: {
		callbacks: {
			title: function() {
				// Title doesn't make sense for scatter since we format the data as a point
				return '';
			},
			label: function(item, data) {
				var datasetLabel = data.datasets[item.datasetIndex].label || '';
				var dataPoint = data.datasets[item.datasetIndex].data[item.index];
				return datasetLabel + ': (' + item.xLabel + ', ' + item.yLabel + ', ' + dataPoint.r + ')';
			}
		}
	}
});

var controller_bubble = core_datasetController.extend({
	/**
	 * @protected
	 */
	dataElementType: elements.Point,

	/**
	 * @private
	 */
	_dataElementOptions: [
		'backgroundColor',
		'borderColor',
		'borderWidth',
		'hoverBackgroundColor',
		'hoverBorderColor',
		'hoverBorderWidth',
		'hoverRadius',
		'hitRadius',
		'pointStyle',
		'rotation'
	],

	/**
	 * @protected
	 */
	update: function(reset) {
		var me = this;
		var meta = me.getMeta();
		var points = meta.data;

		// Update Points
		helpers$1.each(points, function(point, index) {
			me.updateElement(point, index, reset);
		});
	},

	/**
	 * @protected
	 */
	updateElement: function(point, index, reset) {
		var me = this;
		var meta = me.getMeta();
		var custom = point.custom || {};
		var xScale = me.getScaleForId(meta.xAxisID);
		var yScale = me.getScaleForId(meta.yAxisID);
		var options = me._resolveDataElementOptions(point, index);
		var data = me.getDataset().data[index];
		var dsIndex = me.index;

		var x = reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(typeof data === 'object' ? data : NaN, index, dsIndex);
		var y = reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex);

		point._xScale = xScale;
		point._yScale = yScale;
		point._options = options;
		point._datasetIndex = dsIndex;
		point._index = index;
		point._model = {
			backgroundColor: options.backgroundColor,
			borderColor: options.borderColor,
			borderWidth: options.borderWidth,
			hitRadius: options.hitRadius,
			pointStyle: options.pointStyle,
			rotation: options.rotation,
			radius: reset ? 0 : options.radius,
			skip: custom.skip || isNaN(x) || isNaN(y),
			x: x,
			y: y,
		};

		point.pivot();
	},

	/**
	 * @protected
	 */
	setHoverStyle: function(point) {
		var model = point._model;
		var options = point._options;
		var getHoverColor = helpers$1.getHoverColor;

		point.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
			radius: model.radius
		};

		model.backgroundColor = valueOrDefault$4(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault$4(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault$4(options.hoverBorderWidth, options.borderWidth);
		model.radius = options.radius + options.hoverRadius;
	},

	/**
	 * @private
	 */
	_resolveDataElementOptions: function(point, index) {
		var me = this;
		var chart = me.chart;
		var dataset = me.getDataset();
		var custom = point.custom || {};
		var data = dataset.data[index] || {};
		var values = core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments);

		// Scriptable options
		var context = {
			chart: chart,
			dataIndex: index,
			dataset: dataset,
			datasetIndex: me.index
		};

		// In case values were cached (and thus frozen), we need to clone the values
		if (me._cachedDataOpts === values) {
			values = helpers$1.extend({}, values);
		}

		// Custom radius resolution
		values.radius = resolve$1([
			custom.radius,
			data.r,
			me._config.radius,
			chart.options.elements.point.radius
		], context, index);

		return values;
	}
});

var valueOrDefault$5 = helpers$1.valueOrDefault;

var PI$1 = Math.PI;
var DOUBLE_PI$1 = PI$1 * 2;
var HALF_PI$1 = PI$1 / 2;

core_defaults._set('doughnut', {
	animation: {
		// Boolean - Whether we animate the rotation of the Doughnut
		animateRotate: true,
		// Boolean - Whether we animate scaling the Doughnut from the centre
		animateScale: false
	},
	hover: {
		mode: 'single'
	},
	legendCallback: function(chart) {
		var list = document.createElement('ul');
		var data = chart.data;
		var datasets = data.datasets;
		var labels = data.labels;
		var i, ilen, listItem, listItemSpan;

		list.setAttribute('class', chart.id + '-legend');
		if (datasets.length) {
			for (i = 0, ilen = datasets[0].data.length; i < ilen; ++i) {
				listItem = list.appendChild(document.createElement('li'));
				listItemSpan = listItem.appendChild(document.createElement('span'));
				listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
				if (labels[i]) {
					listItem.appendChild(document.createTextNode(labels[i]));
				}
			}
		}

		return list.outerHTML;
	},
	legend: {
		labels: {
			generateLabels: function(chart) {
				var data = chart.data;
				if (data.labels.length && data.datasets.length) {
					return data.labels.map(function(label, i) {
						var meta = chart.getDatasetMeta(0);
						var style = meta.controller.getStyle(i);

						return {
							text: label,
							fillStyle: style.backgroundColor,
							strokeStyle: style.borderColor,
							lineWidth: style.borderWidth,
							hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,

							// Extra data used for toggling the correct item
							index: i
						};
					});
				}
				return [];
			}
		},

		onClick: function(e, legendItem) {
			var index = legendItem.index;
			var chart = this.chart;
			var i, ilen, meta;

			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				meta = chart.getDatasetMeta(i);
				// toggle visibility of index if exists
				if (meta.data[index]) {
					meta.data[index].hidden = !meta.data[index].hidden;
				}
			}

			chart.update();
		}
	},

	// The percentage of the chart that we cut out of the middle.
	cutoutPercentage: 50,

	// The rotation of the chart, where the first data arc begins.
	rotation: -HALF_PI$1,

	// The total circumference of the chart.
	circumference: DOUBLE_PI$1,

	// Need to override these to give a nice default
	tooltips: {
		callbacks: {
			title: function() {
				return '';
			},
			label: function(tooltipItem, data) {
				var dataLabel = data.labels[tooltipItem.index];
				var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];

				if (helpers$1.isArray(dataLabel)) {
					// show value on first line of multiline label
					// need to clone because we are changing the value
					dataLabel = dataLabel.slice();
					dataLabel[0] += value;
				} else {
					dataLabel += value;
				}

				return dataLabel;
			}
		}
	}
});

var controller_doughnut = core_datasetController.extend({

	dataElementType: elements.Arc,

	linkScales: helpers$1.noop,

	/**
	 * @private
	 */
	_dataElementOptions: [
		'backgroundColor',
		'borderColor',
		'borderWidth',
		'borderAlign',
		'hoverBackgroundColor',
		'hoverBorderColor',
		'hoverBorderWidth',
	],

	// Get index of the dataset in relation to the visible datasets. This allows determining the inner and outer radius correctly
	getRingIndex: function(datasetIndex) {
		var ringIndex = 0;

		for (var j = 0; j < datasetIndex; ++j) {
			if (this.chart.isDatasetVisible(j)) {
				++ringIndex;
			}
		}

		return ringIndex;
	},

	update: function(reset) {
		var me = this;
		var chart = me.chart;
		var chartArea = chart.chartArea;
		var opts = chart.options;
		var ratioX = 1;
		var ratioY = 1;
		var offsetX = 0;
		var offsetY = 0;
		var meta = me.getMeta();
		var arcs = meta.data;
		var cutout = opts.cutoutPercentage / 100 || 0;
		var circumference = opts.circumference;
		var chartWeight = me._getRingWeight(me.index);
		var maxWidth, maxHeight, i, ilen;

		// If the chart's circumference isn't a full circle, calculate size as a ratio of the width/height of the arc
		if (circumference < DOUBLE_PI$1) {
			var startAngle = opts.rotation % DOUBLE_PI$1;
			startAngle += startAngle >= PI$1 ? -DOUBLE_PI$1 : startAngle < -PI$1 ? DOUBLE_PI$1 : 0;
			var endAngle = startAngle + circumference;
			var startX = Math.cos(startAngle);
			var startY = Math.sin(startAngle);
			var endX = Math.cos(endAngle);
			var endY = Math.sin(endAngle);
			var contains0 = (startAngle <= 0 && endAngle >= 0) || endAngle >= DOUBLE_PI$1;
			var contains90 = (startAngle <= HALF_PI$1 && endAngle >= HALF_PI$1) || endAngle >= DOUBLE_PI$1 + HALF_PI$1;
			var contains180 = startAngle === -PI$1 || endAngle >= PI$1;
			var contains270 = (startAngle <= -HALF_PI$1 && endAngle >= -HALF_PI$1) || endAngle >= PI$1 + HALF_PI$1;
			var minX = contains180 ? -1 : Math.min(startX, startX * cutout, endX, endX * cutout);
			var minY = contains270 ? -1 : Math.min(startY, startY * cutout, endY, endY * cutout);
			var maxX = contains0 ? 1 : Math.max(startX, startX * cutout, endX, endX * cutout);
			var maxY = contains90 ? 1 : Math.max(startY, startY * cutout, endY, endY * cutout);
			ratioX = (maxX - minX) / 2;
			ratioY = (maxY - minY) / 2;
			offsetX = -(maxX + minX) / 2;
			offsetY = -(maxY + minY) / 2;
		}

		for (i = 0, ilen = arcs.length; i < ilen; ++i) {
			arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
		}

		chart.borderWidth = me.getMaxBorderWidth();
		maxWidth = (chartArea.right - chartArea.left - chart.borderWidth) / ratioX;
		maxHeight = (chartArea.bottom - chartArea.top - chart.borderWidth) / ratioY;
		chart.outerRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
		chart.innerRadius = Math.max(chart.outerRadius * cutout, 0);
		chart.radiusLength = (chart.outerRadius - chart.innerRadius) / (me._getVisibleDatasetWeightTotal() || 1);
		chart.offsetX = offsetX * chart.outerRadius;
		chart.offsetY = offsetY * chart.outerRadius;

		meta.total = me.calculateTotal();

		me.outerRadius = chart.outerRadius - chart.radiusLength * me._getRingWeightOffset(me.index);
		me.innerRadius = Math.max(me.outerRadius - chart.radiusLength * chartWeight, 0);

		for (i = 0, ilen = arcs.length; i < ilen; ++i) {
			me.updateElement(arcs[i], i, reset);
		}
	},

	updateElement: function(arc, index, reset) {
		var me = this;
		var chart = me.chart;
		var chartArea = chart.chartArea;
		var opts = chart.options;
		var animationOpts = opts.animation;
		var centerX = (chartArea.left + chartArea.right) / 2;
		var centerY = (chartArea.top + chartArea.bottom) / 2;
		var startAngle = opts.rotation; // non reset case handled later
		var endAngle = opts.rotation; // non reset case handled later
		var dataset = me.getDataset();
		var circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / DOUBLE_PI$1);
		var innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius;
		var outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius;
		var options = arc._options || {};

		helpers$1.extend(arc, {
			// Utility
			_datasetIndex: me.index,
			_index: index,

			// Desired view properties
			_model: {
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				borderAlign: options.borderAlign,
				x: centerX + chart.offsetX,
				y: centerY + chart.offsetY,
				startAngle: startAngle,
				endAngle: endAngle,
				circumference: circumference,
				outerRadius: outerRadius,
				innerRadius: innerRadius,
				label: helpers$1.valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
			}
		});

		var model = arc._model;

		// Set correct angles if not resetting
		if (!reset || !animationOpts.animateRotate) {
			if (index === 0) {
				model.startAngle = opts.rotation;
			} else {
				model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
			}

			model.endAngle = model.startAngle + model.circumference;
		}

		arc.pivot();
	},

	calculateTotal: function() {
		var dataset = this.getDataset();
		var meta = this.getMeta();
		var total = 0;
		var value;

		helpers$1.each(meta.data, function(element, index) {
			value = dataset.data[index];
			if (!isNaN(value) && !element.hidden) {
				total += Math.abs(value);
			}
		});

		/* if (total === 0) {
			total = NaN;
		}*/

		return total;
	},

	calculateCircumference: function(value) {
		var total = this.getMeta().total;
		if (total > 0 && !isNaN(value)) {
			return DOUBLE_PI$1 * (Math.abs(value) / total);
		}
		return 0;
	},

	// gets the max border or hover width to properly scale pie charts
	getMaxBorderWidth: function(arcs) {
		var me = this;
		var max = 0;
		var chart = me.chart;
		var i, ilen, meta, arc, controller, options, borderWidth, hoverWidth;

		if (!arcs) {
			// Find the outmost visible dataset
			for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
				if (chart.isDatasetVisible(i)) {
					meta = chart.getDatasetMeta(i);
					arcs = meta.data;
					if (i !== me.index) {
						controller = meta.controller;
					}
					break;
				}
			}
		}

		if (!arcs) {
			return 0;
		}

		for (i = 0, ilen = arcs.length; i < ilen; ++i) {
			arc = arcs[i];
			if (controller) {
				controller._configure();
				options = controller._resolveDataElementOptions(arc, i);
			} else {
				options = arc._options;
			}
			if (options.borderAlign !== 'inner') {
				borderWidth = options.borderWidth;
				hoverWidth = options.hoverBorderWidth;

				max = borderWidth > max ? borderWidth : max;
				max = hoverWidth > max ? hoverWidth : max;
			}
		}
		return max;
	},

	/**
	 * @protected
	 */
	setHoverStyle: function(arc) {
		var model = arc._model;
		var options = arc._options;
		var getHoverColor = helpers$1.getHoverColor;

		arc.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
		};

		model.backgroundColor = valueOrDefault$5(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault$5(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault$5(options.hoverBorderWidth, options.borderWidth);
	},

	/**
	 * Get radius length offset of the dataset in relation to the visible datasets weights. This allows determining the inner and outer radius correctly
	 * @private
	 */
	_getRingWeightOffset: function(datasetIndex) {
		var ringWeightOffset = 0;

		for (var i = 0; i < datasetIndex; ++i) {
			if (this.chart.isDatasetVisible(i)) {
				ringWeightOffset += this._getRingWeight(i);
			}
		}

		return ringWeightOffset;
	},

	/**
	 * @private
	 */
	_getRingWeight: function(dataSetIndex) {
		return Math.max(valueOrDefault$5(this.chart.data.datasets[dataSetIndex].weight, 1), 0);
	},

	/**
	 * Returns the sum of all visibile data set weights.  This value can be 0.
	 * @private
	 */
	_getVisibleDatasetWeightTotal: function() {
		return this._getRingWeightOffset(this.chart.data.datasets.length);
	}
});

core_defaults._set('horizontalBar', {
	hover: {
		mode: 'index',
		axis: 'y'
	},

	scales: {
		xAxes: [{
			type: 'linear',
			position: 'bottom'
		}],

		yAxes: [{
			type: 'category',
			position: 'left',
			offset: true,
			gridLines: {
				offsetGridLines: true
			}
		}]
	},

	elements: {
		rectangle: {
			borderSkipped: 'left'
		}
	},

	tooltips: {
		mode: 'index',
		axis: 'y'
	}
});

core_defaults._set('global', {
	datasets: {
		horizontalBar: {
			categoryPercentage: 0.8,
			barPercentage: 0.9
		}
	}
});

var controller_horizontalBar = controller_bar.extend({
	/**
	 * @private
	 */
	_getValueScaleId: function() {
		return this.getMeta().xAxisID;
	},

	/**
	 * @private
	 */
	_getIndexScaleId: function() {
		return this.getMeta().yAxisID;
	}
});

var valueOrDefault$6 = helpers$1.valueOrDefault;
var resolve$2 = helpers$1.options.resolve;
var isPointInArea = helpers$1.canvas._isPointInArea;

core_defaults._set('line', {
	showLines: true,
	spanGaps: false,

	hover: {
		mode: 'label'
	},

	scales: {
		xAxes: [{
			type: 'category',
			id: 'x-axis-0'
		}],
		yAxes: [{
			type: 'linear',
			id: 'y-axis-0'
		}]
	}
});

function scaleClip(scale, halfBorderWidth) {
	var tickOpts = scale && scale.options.ticks || {};
	var reverse = tickOpts.reverse;
	var min = tickOpts.min === undefined ? halfBorderWidth : 0;
	var max = tickOpts.max === undefined ? halfBorderWidth : 0;
	return {
		start: reverse ? max : min,
		end: reverse ? min : max
	};
}

function defaultClip(xScale, yScale, borderWidth) {
	var halfBorderWidth = borderWidth / 2;
	var x = scaleClip(xScale, halfBorderWidth);
	var y = scaleClip(yScale, halfBorderWidth);

	return {
		top: y.end,
		right: x.end,
		bottom: y.start,
		left: x.start
	};
}

function toClip(value) {
	var t, r, b, l;

	if (helpers$1.isObject(value)) {
		t = value.top;
		r = value.right;
		b = value.bottom;
		l = value.left;
	} else {
		t = r = b = l = value;
	}

	return {
		top: t,
		right: r,
		bottom: b,
		left: l
	};
}


var controller_line = core_datasetController.extend({

	datasetElementType: elements.Line,

	dataElementType: elements.Point,

	/**
	 * @private
	 */
	_datasetElementOptions: [
		'backgroundColor',
		'borderCapStyle',
		'borderColor',
		'borderDash',
		'borderDashOffset',
		'borderJoinStyle',
		'borderWidth',
		'cubicInterpolationMode',
		'fill'
	],

	/**
	 * @private
	 */
	_dataElementOptions: {
		backgroundColor: 'pointBackgroundColor',
		borderColor: 'pointBorderColor',
		borderWidth: 'pointBorderWidth',
		hitRadius: 'pointHitRadius',
		hoverBackgroundColor: 'pointHoverBackgroundColor',
		hoverBorderColor: 'pointHoverBorderColor',
		hoverBorderWidth: 'pointHoverBorderWidth',
		hoverRadius: 'pointHoverRadius',
		pointStyle: 'pointStyle',
		radius: 'pointRadius',
		rotation: 'pointRotation'
	},

	update: function(reset) {
		var me = this;
		var meta = me.getMeta();
		var line = meta.dataset;
		var points = meta.data || [];
		var options = me.chart.options;
		var config = me._config;
		var showLine = me._showLine = valueOrDefault$6(config.showLine, options.showLines);
		var i, ilen;

		me._xScale = me.getScaleForId(meta.xAxisID);
		me._yScale = me.getScaleForId(meta.yAxisID);

		// Update Line
		if (showLine) {
			// Compatibility: If the properties are defined with only the old name, use those values
			if (config.tension !== undefined && config.lineTension === undefined) {
				config.lineTension = config.tension;
			}

			// Utility
			line._scale = me._yScale;
			line._datasetIndex = me.index;
			// Data
			line._children = points;
			// Model
			line._model = me._resolveDatasetElementOptions(line);

			line.pivot();
		}

		// Update Points
		for (i = 0, ilen = points.length; i < ilen; ++i) {
			me.updateElement(points[i], i, reset);
		}

		if (showLine && line._model.tension !== 0) {
			me.updateBezierControlPoints();
		}

		// Now pivot the point for animation
		for (i = 0, ilen = points.length; i < ilen; ++i) {
			points[i].pivot();
		}
	},

	updateElement: function(point, index, reset) {
		var me = this;
		var meta = me.getMeta();
		var custom = point.custom || {};
		var dataset = me.getDataset();
		var datasetIndex = me.index;
		var value = dataset.data[index];
		var xScale = me._xScale;
		var yScale = me._yScale;
		var lineModel = meta.dataset._model;
		var x, y;

		var options = me._resolveDataElementOptions(point, index);

		x = xScale.getPixelForValue(typeof value === 'object' ? value : NaN, index, datasetIndex);
		y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);

		// Utility
		point._xScale = xScale;
		point._yScale = yScale;
		point._options = options;
		point._datasetIndex = datasetIndex;
		point._index = index;

		// Desired view properties
		point._model = {
			x: x,
			y: y,
			skip: custom.skip || isNaN(x) || isNaN(y),
			// Appearance
			radius: options.radius,
			pointStyle: options.pointStyle,
			rotation: options.rotation,
			backgroundColor: options.backgroundColor,
			borderColor: options.borderColor,
			borderWidth: options.borderWidth,
			tension: valueOrDefault$6(custom.tension, lineModel ? lineModel.tension : 0),
			steppedLine: lineModel ? lineModel.steppedLine : false,
			// Tooltip
			hitRadius: options.hitRadius
		};
	},

	/**
	 * @private
	 */
	_resolveDatasetElementOptions: function(element) {
		var me = this;
		var config = me._config;
		var custom = element.custom || {};
		var options = me.chart.options;
		var lineOptions = options.elements.line;
		var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);

		// The default behavior of lines is to break at null values, according
		// to https://github.com/chartjs/Chart.js/issues/2435#issuecomment-216718158
		// This option gives lines the ability to span gaps
		values.spanGaps = valueOrDefault$6(config.spanGaps, options.spanGaps);
		values.tension = valueOrDefault$6(config.lineTension, lineOptions.tension);
		values.steppedLine = resolve$2([custom.steppedLine, config.steppedLine, lineOptions.stepped]);
		values.clip = toClip(valueOrDefault$6(config.clip, defaultClip(me._xScale, me._yScale, values.borderWidth)));

		return values;
	},

	calculatePointY: function(value, index, datasetIndex) {
		var me = this;
		var chart = me.chart;
		var yScale = me._yScale;
		var sumPos = 0;
		var sumNeg = 0;
		var i, ds, dsMeta, stackedRightValue, rightValue, metasets, ilen;

		if (yScale.options.stacked) {
			rightValue = +yScale.getRightValue(value);
			metasets = chart._getSortedVisibleDatasetMetas();
			ilen = metasets.length;

			for (i = 0; i < ilen; ++i) {
				dsMeta = metasets[i];
				if (dsMeta.index === datasetIndex) {
					break;
				}

				ds = chart.data.datasets[dsMeta.index];
				if (dsMeta.type === 'line' && dsMeta.yAxisID === yScale.id) {
					stackedRightValue = +yScale.getRightValue(ds.data[index]);
					if (stackedRightValue < 0) {
						sumNeg += stackedRightValue || 0;
					} else {
						sumPos += stackedRightValue || 0;
					}
				}
			}

			if (rightValue < 0) {
				return yScale.getPixelForValue(sumNeg + rightValue);
			}
			return yScale.getPixelForValue(sumPos + rightValue);
		}
		return yScale.getPixelForValue(value);
	},

	updateBezierControlPoints: function() {
		var me = this;
		var chart = me.chart;
		var meta = me.getMeta();
		var lineModel = meta.dataset._model;
		var area = chart.chartArea;
		var points = meta.data || [];
		var i, ilen, model, controlPoints;

		// Only consider points that are drawn in case the spanGaps option is used
		if (lineModel.spanGaps) {
			points = points.filter(function(pt) {
				return !pt._model.skip;
			});
		}

		function capControlPoint(pt, min, max) {
			return Math.max(Math.min(pt, max), min);
		}

		if (lineModel.cubicInterpolationMode === 'monotone') {
			helpers$1.splineCurveMonotone(points);
		} else {
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				model = points[i]._model;
				controlPoints = helpers$1.splineCurve(
					helpers$1.previousItem(points, i)._model,
					model,
					helpers$1.nextItem(points, i)._model,
					lineModel.tension
				);
				model.controlPointPreviousX = controlPoints.previous.x;
				model.controlPointPreviousY = controlPoints.previous.y;
				model.controlPointNextX = controlPoints.next.x;
				model.controlPointNextY = controlPoints.next.y;
			}
		}

		if (chart.options.elements.line.capBezierPoints) {
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				model = points[i]._model;
				if (isPointInArea(model, area)) {
					if (i > 0 && isPointInArea(points[i - 1]._model, area)) {
						model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
						model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
					}
					if (i < points.length - 1 && isPointInArea(points[i + 1]._model, area)) {
						model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
						model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
					}
				}
			}
		}
	},

	draw: function() {
		var me = this;
		var chart = me.chart;
		var meta = me.getMeta();
		var points = meta.data || [];
		var area = chart.chartArea;
		var canvas = chart.canvas;
		var i = 0;
		var ilen = points.length;
		var clip;

		if (me._showLine) {
			clip = meta.dataset._model.clip;

			helpers$1.canvas.clipArea(chart.ctx, {
				left: clip.left === false ? 0 : area.left - clip.left,
				right: clip.right === false ? canvas.width : area.right + clip.right,
				top: clip.top === false ? 0 : area.top - clip.top,
				bottom: clip.bottom === false ? canvas.height : area.bottom + clip.bottom
			});

			meta.dataset.draw();

			helpers$1.canvas.unclipArea(chart.ctx);
		}

		// Draw the points
		for (; i < ilen; ++i) {
			points[i].draw(area);
		}
	},

	/**
	 * @protected
	 */
	setHoverStyle: function(point) {
		var model = point._model;
		var options = point._options;
		var getHoverColor = helpers$1.getHoverColor;

		point.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
			radius: model.radius
		};

		model.backgroundColor = valueOrDefault$6(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault$6(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault$6(options.hoverBorderWidth, options.borderWidth);
		model.radius = valueOrDefault$6(options.hoverRadius, options.radius);
	},
});

var resolve$3 = helpers$1.options.resolve;

core_defaults._set('polarArea', {
	scale: {
		type: 'radialLinear',
		angleLines: {
			display: false
		},
		gridLines: {
			circular: true
		},
		pointLabels: {
			display: false
		},
		ticks: {
			beginAtZero: true
		}
	},

	// Boolean - Whether to animate the rotation of the chart
	animation: {
		animateRotate: true,
		animateScale: true
	},

	startAngle: -0.5 * Math.PI,
	legendCallback: function(chart) {
		var list = document.createElement('ul');
		var data = chart.data;
		var datasets = data.datasets;
		var labels = data.labels;
		var i, ilen, listItem, listItemSpan;

		list.setAttribute('class', chart.id + '-legend');
		if (datasets.length) {
			for (i = 0, ilen = datasets[0].data.length; i < ilen; ++i) {
				listItem = list.appendChild(document.createElement('li'));
				listItemSpan = listItem.appendChild(document.createElement('span'));
				listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
				if (labels[i]) {
					listItem.appendChild(document.createTextNode(labels[i]));
				}
			}
		}

		return list.outerHTML;
	},
	legend: {
		labels: {
			generateLabels: function(chart) {
				var data = chart.data;
				if (data.labels.length && data.datasets.length) {
					return data.labels.map(function(label, i) {
						var meta = chart.getDatasetMeta(0);
						var style = meta.controller.getStyle(i);

						return {
							text: label,
							fillStyle: style.backgroundColor,
							strokeStyle: style.borderColor,
							lineWidth: style.borderWidth,
							hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,

							// Extra data used for toggling the correct item
							index: i
						};
					});
				}
				return [];
			}
		},

		onClick: function(e, legendItem) {
			var index = legendItem.index;
			var chart = this.chart;
			var i, ilen, meta;

			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				meta = chart.getDatasetMeta(i);
				meta.data[index].hidden = !meta.data[index].hidden;
			}

			chart.update();
		}
	},

	// Need to override these to give a nice default
	tooltips: {
		callbacks: {
			title: function() {
				return '';
			},
			label: function(item, data) {
				return data.labels[item.index] + ': ' + item.yLabel;
			}
		}
	}
});

var controller_polarArea = core_datasetController.extend({

	dataElementType: elements.Arc,

	linkScales: helpers$1.noop,

	/**
	 * @private
	 */
	_dataElementOptions: [
		'backgroundColor',
		'borderColor',
		'borderWidth',
		'borderAlign',
		'hoverBackgroundColor',
		'hoverBorderColor',
		'hoverBorderWidth',
	],

	/**
	 * @private
	 */
	_getIndexScaleId: function() {
		return this.chart.scale.id;
	},

	/**
	 * @private
	 */
	_getValueScaleId: function() {
		return this.chart.scale.id;
	},

	update: function(reset) {
		var me = this;
		var dataset = me.getDataset();
		var meta = me.getMeta();
		var start = me.chart.options.startAngle || 0;
		var starts = me._starts = [];
		var angles = me._angles = [];
		var arcs = meta.data;
		var i, ilen, angle;

		me._updateRadius();

		meta.count = me.countVisibleElements();

		for (i = 0, ilen = dataset.data.length; i < ilen; i++) {
			starts[i] = start;
			angle = me._computeAngle(i);
			angles[i] = angle;
			start += angle;
		}

		for (i = 0, ilen = arcs.length; i < ilen; ++i) {
			arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
			me.updateElement(arcs[i], i, reset);
		}
	},

	/**
	 * @private
	 */
	_updateRadius: function() {
		var me = this;
		var chart = me.chart;
		var chartArea = chart.chartArea;
		var opts = chart.options;
		var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);

		chart.outerRadius = Math.max(minSize / 2, 0);
		chart.innerRadius = Math.max(opts.cutoutPercentage ? (chart.outerRadius / 100) * (opts.cutoutPercentage) : 1, 0);
		chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();

		me.outerRadius = chart.outerRadius - (chart.radiusLength * me.index);
		me.innerRadius = me.outerRadius - chart.radiusLength;
	},

	updateElement: function(arc, index, reset) {
		var me = this;
		var chart = me.chart;
		var dataset = me.getDataset();
		var opts = chart.options;
		var animationOpts = opts.animation;
		var scale = chart.scale;
		var labels = chart.data.labels;

		var centerX = scale.xCenter;
		var centerY = scale.yCenter;

		// var negHalfPI = -0.5 * Math.PI;
		var datasetStartAngle = opts.startAngle;
		var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
		var startAngle = me._starts[index];
		var endAngle = startAngle + (arc.hidden ? 0 : me._angles[index]);

		var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
		var options = arc._options || {};

		helpers$1.extend(arc, {
			// Utility
			_datasetIndex: me.index,
			_index: index,
			_scale: scale,

			// Desired view properties
			_model: {
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				borderAlign: options.borderAlign,
				x: centerX,
				y: centerY,
				innerRadius: 0,
				outerRadius: reset ? resetRadius : distance,
				startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
				endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
				label: helpers$1.valueAtIndexOrDefault(labels, index, labels[index])
			}
		});

		arc.pivot();
	},

	countVisibleElements: function() {
		var dataset = this.getDataset();
		var meta = this.getMeta();
		var count = 0;

		helpers$1.each(meta.data, function(element, index) {
			if (!isNaN(dataset.data[index]) && !element.hidden) {
				count++;
			}
		});

		return count;
	},

	/**
	 * @protected
	 */
	setHoverStyle: function(arc) {
		var model = arc._model;
		var options = arc._options;
		var getHoverColor = helpers$1.getHoverColor;
		var valueOrDefault = helpers$1.valueOrDefault;

		arc.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
		};

		model.backgroundColor = valueOrDefault(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault(options.hoverBorderWidth, options.borderWidth);
	},

	/**
	 * @private
	 */
	_computeAngle: function(index) {
		var me = this;
		var count = this.getMeta().count;
		var dataset = me.getDataset();
		var meta = me.getMeta();

		if (isNaN(dataset.data[index]) || meta.data[index].hidden) {
			return 0;
		}

		// Scriptable options
		var context = {
			chart: me.chart,
			dataIndex: index,
			dataset: dataset,
			datasetIndex: me.index
		};

		return resolve$3([
			me.chart.options.elements.arc.angle,
			(2 * Math.PI) / count
		], context, index);
	}
});

core_defaults._set('pie', helpers$1.clone(core_defaults.doughnut));
core_defaults._set('pie', {
	cutoutPercentage: 0
});

// Pie charts are Doughnut chart with different defaults
var controller_pie = controller_doughnut;

var valueOrDefault$7 = helpers$1.valueOrDefault;

core_defaults._set('radar', {
	spanGaps: false,
	scale: {
		type: 'radialLinear'
	},
	elements: {
		line: {
			fill: 'start',
			tension: 0 // no bezier in radar
		}
	}
});

var controller_radar = core_datasetController.extend({
	datasetElementType: elements.Line,

	dataElementType: elements.Point,

	linkScales: helpers$1.noop,

	/**
	 * @private
	 */
	_datasetElementOptions: [
		'backgroundColor',
		'borderWidth',
		'borderColor',
		'borderCapStyle',
		'borderDash',
		'borderDashOffset',
		'borderJoinStyle',
		'fill'
	],

	/**
	 * @private
	 */
	_dataElementOptions: {
		backgroundColor: 'pointBackgroundColor',
		borderColor: 'pointBorderColor',
		borderWidth: 'pointBorderWidth',
		hitRadius: 'pointHitRadius',
		hoverBackgroundColor: 'pointHoverBackgroundColor',
		hoverBorderColor: 'pointHoverBorderColor',
		hoverBorderWidth: 'pointHoverBorderWidth',
		hoverRadius: 'pointHoverRadius',
		pointStyle: 'pointStyle',
		radius: 'pointRadius',
		rotation: 'pointRotation'
	},

	/**
	 * @private
	 */
	_getIndexScaleId: function() {
		return this.chart.scale.id;
	},

	/**
	 * @private
	 */
	_getValueScaleId: function() {
		return this.chart.scale.id;
	},

	update: function(reset) {
		var me = this;
		var meta = me.getMeta();
		var line = meta.dataset;
		var points = meta.data || [];
		var scale = me.chart.scale;
		var config = me._config;
		var i, ilen;

		// Compatibility: If the properties are defined with only the old name, use those values
		if (config.tension !== undefined && config.lineTension === undefined) {
			config.lineTension = config.tension;
		}

		// Utility
		line._scale = scale;
		line._datasetIndex = me.index;
		// Data
		line._children = points;
		line._loop = true;
		// Model
		line._model = me._resolveDatasetElementOptions(line);

		line.pivot();

		// Update Points
		for (i = 0, ilen = points.length; i < ilen; ++i) {
			me.updateElement(points[i], i, reset);
		}

		// Update bezier control points
		me.updateBezierControlPoints();

		// Now pivot the point for animation
		for (i = 0, ilen = points.length; i < ilen; ++i) {
			points[i].pivot();
		}
	},

	updateElement: function(point, index, reset) {
		var me = this;
		var custom = point.custom || {};
		var dataset = me.getDataset();
		var scale = me.chart.scale;
		var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);
		var options = me._resolveDataElementOptions(point, index);
		var lineModel = me.getMeta().dataset._model;
		var x = reset ? scale.xCenter : pointPosition.x;
		var y = reset ? scale.yCenter : pointPosition.y;

		// Utility
		point._scale = scale;
		point._options = options;
		point._datasetIndex = me.index;
		point._index = index;

		// Desired view properties
		point._model = {
			x: x, // value not used in dataset scale, but we want a consistent API between scales
			y: y,
			skip: custom.skip || isNaN(x) || isNaN(y),
			// Appearance
			radius: options.radius,
			pointStyle: options.pointStyle,
			rotation: options.rotation,
			backgroundColor: options.backgroundColor,
			borderColor: options.borderColor,
			borderWidth: options.borderWidth,
			tension: valueOrDefault$7(custom.tension, lineModel ? lineModel.tension : 0),

			// Tooltip
			hitRadius: options.hitRadius
		};
	},

	/**
	 * @private
	 */
	_resolveDatasetElementOptions: function() {
		var me = this;
		var config = me._config;
		var options = me.chart.options;
		var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);

		values.spanGaps = valueOrDefault$7(config.spanGaps, options.spanGaps);
		values.tension = valueOrDefault$7(config.lineTension, options.elements.line.tension);

		return values;
	},

	updateBezierControlPoints: function() {
		var me = this;
		var meta = me.getMeta();
		var area = me.chart.chartArea;
		var points = meta.data || [];
		var i, ilen, model, controlPoints;

		// Only consider points that are drawn in case the spanGaps option is used
		if (meta.dataset._model.spanGaps) {
			points = points.filter(function(pt) {
				return !pt._model.skip;
			});
		}

		function capControlPoint(pt, min, max) {
			return Math.max(Math.min(pt, max), min);
		}

		for (i = 0, ilen = points.length; i < ilen; ++i) {
			model = points[i]._model;
			controlPoints = helpers$1.splineCurve(
				helpers$1.previousItem(points, i, true)._model,
				model,
				helpers$1.nextItem(points, i, true)._model,
				model.tension
			);

			// Prevent the bezier going outside of the bounds of the graph
			model.controlPointPreviousX = capControlPoint(controlPoints.previous.x, area.left, area.right);
			model.controlPointPreviousY = capControlPoint(controlPoints.previous.y, area.top, area.bottom);
			model.controlPointNextX = capControlPoint(controlPoints.next.x, area.left, area.right);
			model.controlPointNextY = capControlPoint(controlPoints.next.y, area.top, area.bottom);
		}
	},

	setHoverStyle: function(point) {
		var model = point._model;
		var options = point._options;
		var getHoverColor = helpers$1.getHoverColor;

		point.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
			radius: model.radius
		};

		model.backgroundColor = valueOrDefault$7(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault$7(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault$7(options.hoverBorderWidth, options.borderWidth);
		model.radius = valueOrDefault$7(options.hoverRadius, options.radius);
	}
});

core_defaults._set('scatter', {
	hover: {
		mode: 'single'
	},

	scales: {
		xAxes: [{
			id: 'x-axis-1',    // need an ID so datasets can reference the scale
			type: 'linear',    // scatter should not use a category axis
			position: 'bottom'
		}],
		yAxes: [{
			id: 'y-axis-1',
			type: 'linear',
			position: 'left'
		}]
	},

	tooltips: {
		callbacks: {
			title: function() {
				return '';     // doesn't make sense for scatter since data are formatted as a point
			},
			label: function(item) {
				return '(' + item.xLabel + ', ' + item.yLabel + ')';
			}
		}
	}
});

core_defaults._set('global', {
	datasets: {
		scatter: {
			showLine: false
		}
	}
});

// Scatter charts use line controllers
var controller_scatter = controller_line;

// NOTE export a map in which the key represents the controller type, not
// the class, and so must be CamelCase in order to be correctly retrieved
// by the controller in core.controller.js (`controllers[meta.type]`).

var controllers = {
	bar: controller_bar,
	bubble: controller_bubble,
	doughnut: controller_doughnut,
	horizontalBar: controller_horizontalBar,
	line: controller_line,
	polarArea: controller_polarArea,
	pie: controller_pie,
	radar: controller_radar,
	scatter: controller_scatter
};

/**
 * Helper function to get relative position for an event
 * @param {Event|IEvent} event - The event to get the position for
 * @param {Chart} chart - The chart
 * @returns {object} the event position
 */
function getRelativePosition(e, chart) {
	if (e.native) {
		return {
			x: e.x,
			y: e.y
		};
	}

	return helpers$1.getRelativePosition(e, chart);
}

/**
 * Helper function to traverse all of the visible elements in the chart
 * @param {Chart} chart - the chart
 * @param {function} handler - the callback to execute for each visible item
 */
function parseVisibleItems(chart, handler) {
	var metasets = chart._getSortedVisibleDatasetMetas();
	var metadata, i, j, ilen, jlen, element;

	for (i = 0, ilen = metasets.length; i < ilen; ++i) {
		metadata = metasets[i].data;
		for (j = 0, jlen = metadata.length; j < jlen; ++j) {
			element = metadata[j];
			if (!element._view.skip) {
				handler(element);
			}
		}
	}
}

/**
 * Helper function to get the items that intersect the event position
 * @param {ChartElement[]} items - elements to filter
 * @param {object} position - the point to be nearest to
 * @return {ChartElement[]} the nearest items
 */
function getIntersectItems(chart, position) {
	var elements = [];

	parseVisibleItems(chart, function(element) {
		if (element.inRange(position.x, position.y)) {
			elements.push(element);
		}
	});

	return elements;
}

/**
 * Helper function to get the items nearest to the event position considering all visible items in teh chart
 * @param {Chart} chart - the chart to look at elements from
 * @param {object} position - the point to be nearest to
 * @param {boolean} intersect - if true, only consider items that intersect the position
 * @param {function} distanceMetric - function to provide the distance between points
 * @return {ChartElement[]} the nearest items
 */
function getNearestItems(chart, position, intersect, distanceMetric) {
	var minDistance = Number.POSITIVE_INFINITY;
	var nearestItems = [];

	parseVisibleItems(chart, function(element) {
		if (intersect && !element.inRange(position.x, position.y)) {
			return;
		}

		var center = element.getCenterPoint();
		var distance = distanceMetric(position, center);
		if (distance < minDistance) {
			nearestItems = [element];
			minDistance = distance;
		} else if (distance === minDistance) {
			// Can have multiple items at the same distance in which case we sort by size
			nearestItems.push(element);
		}
	});

	return nearestItems;
}

/**
 * Get a distance metric function for two points based on the
 * axis mode setting
 * @param {string} axis - the axis mode. x|y|xy
 */
function getDistanceMetricForAxis(axis) {
	var useX = axis.indexOf('x') !== -1;
	var useY = axis.indexOf('y') !== -1;

	return function(pt1, pt2) {
		var deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
		var deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
		return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
	};
}

function indexMode(chart, e, options) {
	var position = getRelativePosition(e, chart);
	// Default axis for index mode is 'x' to match old behaviour
	options.axis = options.axis || 'x';
	var distanceMetric = getDistanceMetricForAxis(options.axis);
	var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
	var elements = [];

	if (!items.length) {
		return [];
	}

	chart._getSortedVisibleDatasetMetas().forEach(function(meta) {
		var element = meta.data[items[0]._index];

		// don't count items that are skipped (null data)
		if (element && !element._view.skip) {
			elements.push(element);
		}
	});

	return elements;
}

/**
 * @interface IInteractionOptions
 */
/**
 * If true, only consider items that intersect the point
 * @name IInterfaceOptions#boolean
 * @type Boolean
 */

/**
 * Contains interaction related functions
 * @namespace Chart.Interaction
 */
var core_interaction = {
	// Helper function for different modes
	modes: {
		single: function(chart, e) {
			var position = getRelativePosition(e, chart);
			var elements = [];

			parseVisibleItems(chart, function(element) {
				if (element.inRange(position.x, position.y)) {
					elements.push(element);
					return elements;
				}
			});

			return elements.slice(0, 1);
		},

		/**
		 * @function Chart.Interaction.modes.label
		 * @deprecated since version 2.4.0
		 * @todo remove at version 3
		 * @private
		 */
		label: indexMode,

		/**
		 * Returns items at the same index. If the options.intersect parameter is true, we only return items if we intersect something
		 * If the options.intersect mode is false, we find the nearest item and return the items at the same index as that item
		 * @function Chart.Interaction.modes.index
		 * @since v2.4.0
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use during interaction
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		index: indexMode,

		/**
		 * Returns items in the same dataset. If the options.intersect parameter is true, we only return items if we intersect something
		 * If the options.intersect is false, we find the nearest item and return the items in that dataset
		 * @function Chart.Interaction.modes.dataset
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use during interaction
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		dataset: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			options.axis = options.axis || 'xy';
			var distanceMetric = getDistanceMetricForAxis(options.axis);
			var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);

			if (items.length > 0) {
				items = chart.getDatasetMeta(items[0]._datasetIndex).data;
			}

			return items;
		},

		/**
		 * @function Chart.Interaction.modes.x-axis
		 * @deprecated since version 2.4.0. Use index mode and intersect == true
		 * @todo remove at version 3
		 * @private
		 */
		'x-axis': function(chart, e) {
			return indexMode(chart, e, {intersect: false});
		},

		/**
		 * Point mode returns all elements that hit test based on the event position
		 * of the event
		 * @function Chart.Interaction.modes.intersect
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		point: function(chart, e) {
			var position = getRelativePosition(e, chart);
			return getIntersectItems(chart, position);
		},

		/**
		 * nearest mode returns the element closest to the point
		 * @function Chart.Interaction.modes.intersect
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		nearest: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			options.axis = options.axis || 'xy';
			var distanceMetric = getDistanceMetricForAxis(options.axis);
			return getNearestItems(chart, position, options.intersect, distanceMetric);
		},

		/**
		 * x mode returns the elements that hit-test at the current x coordinate
		 * @function Chart.Interaction.modes.x
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		x: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			var items = [];
			var intersectsItem = false;

			parseVisibleItems(chart, function(element) {
				if (element.inXRange(position.x)) {
					items.push(element);
				}

				if (element.inRange(position.x, position.y)) {
					intersectsItem = true;
				}
			});

			// If we want to trigger on an intersect and we don't have any items
			// that intersect the position, return nothing
			if (options.intersect && !intersectsItem) {
				items = [];
			}
			return items;
		},

		/**
		 * y mode returns the elements that hit-test at the current y coordinate
		 * @function Chart.Interaction.modes.y
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		y: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			var items = [];
			var intersectsItem = false;

			parseVisibleItems(chart, function(element) {
				if (element.inYRange(position.y)) {
					items.push(element);
				}

				if (element.inRange(position.x, position.y)) {
					intersectsItem = true;
				}
			});

			// If we want to trigger on an intersect and we don't have any items
			// that intersect the position, return nothing
			if (options.intersect && !intersectsItem) {
				items = [];
			}
			return items;
		}
	}
};

var extend = helpers$1.extend;

function filterByPosition(array, position) {
	return helpers$1.where(array, function(v) {
		return v.pos === position;
	});
}

function sortByWeight(array, reverse) {
	return array.sort(function(a, b) {
		var v0 = reverse ? b : a;
		var v1 = reverse ? a : b;
		return v0.weight === v1.weight ?
			v0.index - v1.index :
			v0.weight - v1.weight;
	});
}

function wrapBoxes(boxes) {
	var layoutBoxes = [];
	var i, ilen, box;

	for (i = 0, ilen = (boxes || []).length; i < ilen; ++i) {
		box = boxes[i];
		layoutBoxes.push({
			index: i,
			box: box,
			pos: box.position,
			horizontal: box.isHorizontal(),
			weight: box.weight
		});
	}
	return layoutBoxes;
}

function setLayoutDims(layouts, params) {
	var i, ilen, layout;
	for (i = 0, ilen = layouts.length; i < ilen; ++i) {
		layout = layouts[i];
		// store width used instead of chartArea.w in fitBoxes
		layout.width = layout.horizontal
			? layout.box.fullWidth && params.availableWidth
			: params.vBoxMaxWidth;
		// store height used instead of chartArea.h in fitBoxes
		layout.height = layout.horizontal && params.hBoxMaxHeight;
	}
}

function buildLayoutBoxes(boxes) {
	var layoutBoxes = wrapBoxes(boxes);
	var left = sortByWeight(filterByPosition(layoutBoxes, 'left'), true);
	var right = sortByWeight(filterByPosition(layoutBoxes, 'right'));
	var top = sortByWeight(filterByPosition(layoutBoxes, 'top'), true);
	var bottom = sortByWeight(filterByPosition(layoutBoxes, 'bottom'));

	return {
		leftAndTop: left.concat(top),
		rightAndBottom: right.concat(bottom),
		chartArea: filterByPosition(layoutBoxes, 'chartArea'),
		vertical: left.concat(right),
		horizontal: top.concat(bottom)
	};
}

function getCombinedMax(maxPadding, chartArea, a, b) {
	return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}

function updateDims(chartArea, params, layout) {
	var box = layout.box;
	var maxPadding = chartArea.maxPadding;
	var newWidth, newHeight;

	if (layout.size) {
		// this layout was already counted for, lets first reduce old size
		chartArea[layout.pos] -= layout.size;
	}
	layout.size = layout.horizontal ? box.height : box.width;
	chartArea[layout.pos] += layout.size;

	if (box.getPadding) {
		var boxPadding = box.getPadding();
		maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
		maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
		maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
		maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
	}

	newWidth = params.outerWidth - getCombinedMax(maxPadding, chartArea, 'left', 'right');
	newHeight = params.outerHeight - getCombinedMax(maxPadding, chartArea, 'top', 'bottom');

	if (newWidth !== chartArea.w || newHeight !== chartArea.h) {
		chartArea.w = newWidth;
		chartArea.h = newHeight;

		// return true if chart area changed in layout's direction
		var sizes = layout.horizontal ? [newWidth, chartArea.w] : [newHeight, chartArea.h];
		return sizes[0] !== sizes[1] && (!isNaN(sizes[0]) || !isNaN(sizes[1]));
	}
}

function handleMaxPadding(chartArea) {
	var maxPadding = chartArea.maxPadding;

	function updatePos(pos) {
		var change = Math.max(maxPadding[pos] - chartArea[pos], 0);
		chartArea[pos] += change;
		return change;
	}
	chartArea.y += updatePos('top');
	chartArea.x += updatePos('left');
	updatePos('right');
	updatePos('bottom');
}

function getMargins(horizontal, chartArea) {
	var maxPadding = chartArea.maxPadding;

	function marginForPositions(positions) {
		var margin = {left: 0, top: 0, right: 0, bottom: 0};
		positions.forEach(function(pos) {
			margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
		});
		return margin;
	}

	return horizontal
		? marginForPositions(['left', 'right'])
		: marginForPositions(['top', 'bottom']);
}

function fitBoxes(boxes, chartArea, params) {
	var refitBoxes = [];
	var i, ilen, layout, box, refit, changed;

	for (i = 0, ilen = boxes.length; i < ilen; ++i) {
		layout = boxes[i];
		box = layout.box;

		box.update(
			layout.width || chartArea.w,
			layout.height || chartArea.h,
			getMargins(layout.horizontal, chartArea)
		);
		if (updateDims(chartArea, params, layout)) {
			changed = true;
			if (refitBoxes.length) {
				// Dimensions changed and there were non full width boxes before this
				// -> we have to refit those
				refit = true;
			}
		}
		if (!box.fullWidth) { // fullWidth boxes don't need to be re-fitted in any case
			refitBoxes.push(layout);
		}
	}

	return refit ? fitBoxes(refitBoxes, chartArea, params) || changed : changed;
}

function placeBoxes(boxes, chartArea, params) {
	var userPadding = params.padding;
	var x = chartArea.x;
	var y = chartArea.y;
	var i, ilen, layout, box;

	for (i = 0, ilen = boxes.length; i < ilen; ++i) {
		layout = boxes[i];
		box = layout.box;
		if (layout.horizontal) {
			box.left = box.fullWidth ? userPadding.left : chartArea.left;
			box.right = box.fullWidth ? params.outerWidth - userPadding.right : chartArea.left + chartArea.w;
			box.top = y;
			box.bottom = y + box.height;
			box.width = box.right - box.left;
			y = box.bottom;
		} else {
			box.left = x;
			box.right = x + box.width;
			box.top = chartArea.top;
			box.bottom = chartArea.top + chartArea.h;
			box.height = box.bottom - box.top;
			x = box.right;
		}
	}

	chartArea.x = x;
	chartArea.y = y;
}

core_defaults._set('global', {
	layout: {
		padding: {
			top: 0,
			right: 0,
			bottom: 0,
			left: 0
		}
	}
});

/**
 * @interface ILayoutItem
 * @prop {string} position - The position of the item in the chart layout. Possible values are
 * 'left', 'top', 'right', 'bottom', and 'chartArea'
 * @prop {number} weight - The weight used to sort the item. Higher weights are further away from the chart area
 * @prop {boolean} fullWidth - if true, and the item is horizontal, then push vertical boxes down
 * @prop {function} isHorizontal - returns true if the layout item is horizontal (ie. top or bottom)
 * @prop {function} update - Takes two parameters: width and height. Returns size of item
 * @prop {function} getPadding -  Returns an object with padding on the edges
 * @prop {number} width - Width of item. Must be valid after update()
 * @prop {number} height - Height of item. Must be valid after update()
 * @prop {number} left - Left edge of the item. Set by layout system and cannot be used in update
 * @prop {number} top - Top edge of the item. Set by layout system and cannot be used in update
 * @prop {number} right - Right edge of the item. Set by layout system and cannot be used in update
 * @prop {number} bottom - Bottom edge of the item. Set by layout system and cannot be used in update
 */

// The layout service is very self explanatory.  It's responsible for the layout within a chart.
// Scales, Legends and Plugins all rely on the layout service and can easily register to be placed anywhere they need
// It is this service's responsibility of carrying out that layout.
var core_layouts = {
	defaults: {},

	/**
	 * Register a box to a chart.
	 * A box is simply a reference to an object that requires layout. eg. Scales, Legend, Title.
	 * @param {Chart} chart - the chart to use
	 * @param {ILayoutItem} item - the item to add to be layed out
	 */
	addBox: function(chart, item) {
		if (!chart.boxes) {
			chart.boxes = [];
		}

		// initialize item with default values
		item.fullWidth = item.fullWidth || false;
		item.position = item.position || 'top';
		item.weight = item.weight || 0;
		item._layers = item._layers || function() {
			return [{
				z: 0,
				draw: function() {
					item.draw.apply(item, arguments);
				}
			}];
		};

		chart.boxes.push(item);
	},

	/**
	 * Remove a layoutItem from a chart
	 * @param {Chart} chart - the chart to remove the box from
	 * @param {ILayoutItem} layoutItem - the item to remove from the layout
	 */
	removeBox: function(chart, layoutItem) {
		var index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
		if (index !== -1) {
			chart.boxes.splice(index, 1);
		}
	},

	/**
	 * Sets (or updates) options on the given `item`.
	 * @param {Chart} chart - the chart in which the item lives (or will be added to)
	 * @param {ILayoutItem} item - the item to configure with the given options
	 * @param {object} options - the new item options.
	 */
	configure: function(chart, item, options) {
		var props = ['fullWidth', 'position', 'weight'];
		var ilen = props.length;
		var i = 0;
		var prop;

		for (; i < ilen; ++i) {
			prop = props[i];
			if (options.hasOwnProperty(prop)) {
				item[prop] = options[prop];
			}
		}
	},

	/**
	 * Fits boxes of the given chart into the given size by having each box measure itself
	 * then running a fitting algorithm
	 * @param {Chart} chart - the chart
	 * @param {number} width - the width to fit into
	 * @param {number} height - the height to fit into
	 */
	update: function(chart, width, height) {
		if (!chart) {
			return;
		}

		var layoutOptions = chart.options.layout || {};
		var padding = helpers$1.options.toPadding(layoutOptions.padding);

		var availableWidth = width - padding.width;
		var availableHeight = height - padding.height;
		var boxes = buildLayoutBoxes(chart.boxes);
		var verticalBoxes = boxes.vertical;
		var horizontalBoxes = boxes.horizontal;

		// Essentially we now have any number of boxes on each of the 4 sides.
		// Our canvas looks like the following.
		// The areas L1 and L2 are the left axes. R1 is the right axis, T1 is the top axis and
		// B1 is the bottom axis
		// There are also 4 quadrant-like locations (left to right instead of clockwise) reserved for chart overlays
		// These locations are single-box locations only, when trying to register a chartArea location that is already taken,
		// an error will be thrown.
		//
		// |----------------------------------------------------|
		// |                  T1 (Full Width)                   |
		// |----------------------------------------------------|
		// |    |    |                 T2                  |    |
		// |    |----|-------------------------------------|----|
		// |    |    | C1 |                           | C2 |    |
		// |    |    |----|                           |----|    |
		// |    |    |                                     |    |
		// | L1 | L2 |           ChartArea (C0)            | R1 |
		// |    |    |                                     |    |
		// |    |    |----|                           |----|    |
		// |    |    | C3 |                           | C4 |    |
		// |    |----|-------------------------------------|----|
		// |    |    |                 B1                  |    |
		// |----------------------------------------------------|
		// |                  B2 (Full Width)                   |
		// |----------------------------------------------------|
		//

		var params = Object.freeze({
			outerWidth: width,
			outerHeight: height,
			padding: padding,
			availableWidth: availableWidth,
			vBoxMaxWidth: availableWidth / 2 / verticalBoxes.length,
			hBoxMaxHeight: availableHeight / 2
		});
		var chartArea = extend({
			maxPadding: extend({}, padding),
			w: availableWidth,
			h: availableHeight,
			x: padding.left,
			y: padding.top
		}, padding);

		setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);

		// First fit vertical boxes
		fitBoxes(verticalBoxes, chartArea, params);

		// Then fit horizontal boxes
		if (fitBoxes(horizontalBoxes, chartArea, params)) {
			// if the area changed, re-fit vertical boxes
			fitBoxes(verticalBoxes, chartArea, params);
		}

		handleMaxPadding(chartArea);

		// Finally place the boxes to correct coordinates
		placeBoxes(boxes.leftAndTop, chartArea, params);

		// Move to opposite side of chart
		chartArea.x += chartArea.w;
		chartArea.y += chartArea.h;

		placeBoxes(boxes.rightAndBottom, chartArea, params);

		chart.chartArea = {
			left: chartArea.left,
			top: chartArea.top,
			right: chartArea.left + chartArea.w,
			bottom: chartArea.top + chartArea.h
		};

		// Finally update boxes in chartArea (radial scale for example)
		helpers$1.each(boxes.chartArea, function(layout) {
			var box = layout.box;
			extend(box, chart.chartArea);
			box.update(chartArea.w, chartArea.h);
		});
	}
};

/**
 * Platform fallback implementation (minimal).
 * @see https://github.com/chartjs/Chart.js/pull/4591#issuecomment-319575939
 */

var platform_basic = {
	acquireContext: function(item) {
		if (item && item.canvas) {
			// Support for any object associated to a canvas (including a context2d)
			item = item.canvas;
		}

		return item && item.getContext('2d') || null;
	}
};

var platform_dom = "/*\r\n * DOM element rendering detection\r\n * https://davidwalsh.name/detect-node-insertion\r\n */\r\n@keyframes chartjs-render-animation {\r\n\tfrom { opacity: 0.99; }\r\n\tto { opacity: 1; }\r\n}\r\n\r\n.chartjs-render-monitor {\r\n\tanimation: chartjs-render-animation 0.001s;\r\n}\r\n\r\n/*\r\n * DOM element resizing detection\r\n * https://github.com/marcj/css-element-queries\r\n */\r\n.chartjs-size-monitor,\r\n.chartjs-size-monitor-expand,\r\n.chartjs-size-monitor-shrink {\r\n\tposition: absolute;\r\n\tdirection: ltr;\r\n\tleft: 0;\r\n\ttop: 0;\r\n\tright: 0;\r\n\tbottom: 0;\r\n\toverflow: hidden;\r\n\tpointer-events: none;\r\n\tvisibility: hidden;\r\n\tz-index: -1;\r\n}\r\n\r\n.chartjs-size-monitor-expand > div {\r\n\tposition: absolute;\r\n\twidth: 1000000px;\r\n\theight: 1000000px;\r\n\tleft: 0;\r\n\ttop: 0;\r\n}\r\n\r\n.chartjs-size-monitor-shrink > div {\r\n\tposition: absolute;\r\n\twidth: 200%;\r\n\theight: 200%;\r\n\tleft: 0;\r\n\ttop: 0;\r\n}\r\n";

var platform_dom$1 = /*#__PURE__*/Object.freeze({
__proto__: null,
'default': platform_dom
});

var stylesheet = getCjsExportFromNamespace(platform_dom$1);

var EXPANDO_KEY = '$chartjs';
var CSS_PREFIX = 'chartjs-';
var CSS_SIZE_MONITOR = CSS_PREFIX + 'size-monitor';
var CSS_RENDER_MONITOR = CSS_PREFIX + 'render-monitor';
var CSS_RENDER_ANIMATION = CSS_PREFIX + 'render-animation';
var ANIMATION_START_EVENTS = ['animationstart', 'webkitAnimationStart'];

/**
 * DOM event types -> Chart.js event types.
 * Note: only events with different types are mapped.
 * @see https://developer.mozilla.org/en-US/docs/Web/Events
 */
var EVENT_TYPES = {
	touchstart: 'mousedown',
	touchmove: 'mousemove',
	touchend: 'mouseup',
	pointerenter: 'mouseenter',
	pointerdown: 'mousedown',
	pointermove: 'mousemove',
	pointerup: 'mouseup',
	pointerleave: 'mouseout',
	pointerout: 'mouseout'
};

/**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns {number} Size in pixels or undefined if unknown.
 */
function readUsedSize(element, property) {
	var value = helpers$1.getStyle(element, property);
	var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
	return matches ? Number(matches[1]) : undefined;
}

/**
 * Initializes the canvas style and render size without modifying the canvas display size,
 * since responsiveness is handled by the controller.resize() method. The config is used
 * to determine the aspect ratio to apply in case no explicit height has been specified.
 */
function initCanvas(canvas, config) {
	var style = canvas.style;

	// NOTE(SB) canvas.getAttribute('width') !== canvas.width: in the first case it
	// returns null or '' if no explicit value has been set to the canvas attribute.
	var renderHeight = canvas.getAttribute('height');
	var renderWidth = canvas.getAttribute('width');

	// Chart.js modifies some canvas values that we want to restore on destroy
	canvas[EXPANDO_KEY] = {
		initial: {
			height: renderHeight,
			width: renderWidth,
			style: {
				display: style.display,
				height: style.height,
				width: style.width
			}
		}
	};

	// Force canvas to display as block to avoid extra space caused by inline
	// elements, which would interfere with the responsive resize process.
	// https://github.com/chartjs/Chart.js/issues/2538
	style.display = style.display || 'block';

	if (renderWidth === null || renderWidth === '') {
		var displayWidth = readUsedSize(canvas, 'width');
		if (displayWidth !== undefined) {
			canvas.width = displayWidth;
		}
	}

	if (renderHeight === null || renderHeight === '') {
		if (canvas.style.height === '') {
			// If no explicit render height and style height, let's apply the aspect ratio,
			// which one can be specified by the user but also by charts as default option
			// (i.e. options.aspectRatio). If not specified, use canvas aspect ratio of 2.
			canvas.height = canvas.width / (config.options.aspectRatio || 2);
		} else {
			var displayHeight = readUsedSize(canvas, 'height');
			if (displayWidth !== undefined) {
				canvas.height = displayHeight;
			}
		}
	}

	return canvas;
}

/**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */
var supportsEventListenerOptions = (function() {
	var supports = false;
	try {
		var options = Object.defineProperty({}, 'passive', {
			// eslint-disable-next-line getter-return
			get: function() {
				supports = true;
			}
		});
		window.addEventListener('e', null, options);
	} catch (e) {
		// continue regardless of error
	}
	return supports;
}());

// Default passive to true as expected by Chrome for 'touchstart' and 'touchend' events.
// https://github.com/chartjs/Chart.js/issues/4287
var eventListenerOptions = supportsEventListenerOptions ? {passive: true} : false;

function addListener(node, type, listener) {
	node.addEventListener(type, listener, eventListenerOptions);
}

function removeListener(node, type, listener) {
	node.removeEventListener(type, listener, eventListenerOptions);
}

function createEvent(type, chart, x, y, nativeEvent) {
	return {
		type: type,
		chart: chart,
		native: nativeEvent || null,
		x: x !== undefined ? x : null,
		y: y !== undefined ? y : null,
	};
}

function fromNativeEvent(event, chart) {
	var type = EVENT_TYPES[event.type] || event.type;
	var pos = helpers$1.getRelativePosition(event, chart);
	return createEvent(type, chart, pos.x, pos.y, event);
}

function throttled(fn, thisArg) {
	var ticking = false;
	var args = [];

	return function() {
		args = Array.prototype.slice.call(arguments);
		thisArg = thisArg || this;

		if (!ticking) {
			ticking = true;
			helpers$1.requestAnimFrame.call(window, function() {
				ticking = false;
				fn.apply(thisArg, args);
			});
		}
	};
}

function createDiv(cls) {
	var el = document.createElement('div');
	el.className = cls || '';
	return el;
}

// Implementation based on https://github.com/marcj/css-element-queries
function createResizer(handler) {
	var maxSize = 1000000;

	// NOTE(SB) Don't use innerHTML because it could be considered unsafe.
	// https://github.com/chartjs/Chart.js/issues/5902
	var resizer = createDiv(CSS_SIZE_MONITOR);
	var expand = createDiv(CSS_SIZE_MONITOR + '-expand');
	var shrink = createDiv(CSS_SIZE_MONITOR + '-shrink');

	expand.appendChild(createDiv());
	shrink.appendChild(createDiv());

	resizer.appendChild(expand);
	resizer.appendChild(shrink);
	resizer._reset = function() {
		expand.scrollLeft = maxSize;
		expand.scrollTop = maxSize;
		shrink.scrollLeft = maxSize;
		shrink.scrollTop = maxSize;
	};

	var onScroll = function() {
		resizer._reset();
		handler();
	};

	addListener(expand, 'scroll', onScroll.bind(expand, 'expand'));
	addListener(shrink, 'scroll', onScroll.bind(shrink, 'shrink'));

	return resizer;
}

// https://davidwalsh.name/detect-node-insertion
function watchForRender(node, handler) {
	var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
	var proxy = expando.renderProxy = function(e) {
		if (e.animationName === CSS_RENDER_ANIMATION) {
			handler();
		}
	};

	helpers$1.each(ANIMATION_START_EVENTS, function(type) {
		addListener(node, type, proxy);
	});

	// #4737: Chrome might skip the CSS animation when the CSS_RENDER_MONITOR class
	// is removed then added back immediately (same animation frame?). Accessing the
	// `offsetParent` property will force a reflow and re-evaluate the CSS animation.
	// https://gist.github.com/paulirish/5d52fb081b3570c81e3a#box-metrics
	// https://github.com/chartjs/Chart.js/issues/4737
	expando.reflow = !!node.offsetParent;

	node.classList.add(CSS_RENDER_MONITOR);
}

function unwatchForRender(node) {
	var expando = node[EXPANDO_KEY] || {};
	var proxy = expando.renderProxy;

	if (proxy) {
		helpers$1.each(ANIMATION_START_EVENTS, function(type) {
			removeListener(node, type, proxy);
		});

		delete expando.renderProxy;
	}

	node.classList.remove(CSS_RENDER_MONITOR);
}

function addResizeListener(node, listener, chart) {
	var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});

	// Let's keep track of this added resizer and thus avoid DOM query when removing it.
	var resizer = expando.resizer = createResizer(throttled(function() {
		if (expando.resizer) {
			var container = chart.options.maintainAspectRatio && node.parentNode;
			var w = container ? container.clientWidth : 0;
			listener(createEvent('resize', chart));
			if (container && container.clientWidth < w && chart.canvas) {
				// If the container size shrank during chart resize, let's assume
				// scrollbar appeared. So we resize again with the scrollbar visible -
				// effectively making chart smaller and the scrollbar hidden again.
				// Because we are inside `throttled`, and currently `ticking`, scroll
				// events are ignored during this whole 2 resize process.
				// If we assumed wrong and something else happened, we are resizing
				// twice in a frame (potential performance issue)
				listener(createEvent('resize', chart));
			}
		}
	}));

	// The resizer needs to be attached to the node parent, so we first need to be
	// sure that `node` is attached to the DOM before injecting the resizer element.
	watchForRender(node, function() {
		if (expando.resizer) {
			var container = node.parentNode;
			if (container && container !== resizer.parentNode) {
				container.insertBefore(resizer, container.firstChild);
			}

			// The container size might have changed, let's reset the resizer state.
			resizer._reset();
		}
	});
}

function removeResizeListener(node) {
	var expando = node[EXPANDO_KEY] || {};
	var resizer = expando.resizer;

	delete expando.resizer;
	unwatchForRender(node);

	if (resizer && resizer.parentNode) {
		resizer.parentNode.removeChild(resizer);
	}
}

/**
 * Injects CSS styles inline if the styles are not already present.
 * @param {HTMLDocument|ShadowRoot} rootNode - the node to contain the <style>.
 * @param {string} css - the CSS to be injected.
 */
function injectCSS(rootNode, css) {
	// https://stackoverflow.com/q/3922139
	var expando = rootNode[EXPANDO_KEY] || (rootNode[EXPANDO_KEY] = {});
	if (!expando.containsStyles) {
		expando.containsStyles = true;
		css = '/* Chart.js */\n' + css;
		var style = document.createElement('style');
		style.setAttribute('type', 'text/css');
		style.appendChild(document.createTextNode(css));
		rootNode.appendChild(style);
	}
}

var platform_dom$2 = {
	/**
	 * When `true`, prevents the automatic injection of the stylesheet required to
	 * correctly detect when the chart is added to the DOM and then resized. This
	 * switch has been added to allow external stylesheet (`dist/Chart(.min)?.js`)
	 * to be manually imported to make this library compatible with any CSP.
	 * See https://github.com/chartjs/Chart.js/issues/5208
	 */
	disableCSSInjection: false,

	/**
	 * This property holds whether this platform is enabled for the current environment.
	 * Currently used by platform.js to select the proper implementation.
	 * @private
	 */
	_enabled: typeof window !== 'undefined' && typeof document !== 'undefined',

	/**
	 * Initializes resources that depend on platform options.
	 * @param {HTMLCanvasElement} canvas - The Canvas element.
	 * @private
	 */
	_ensureLoaded: function(canvas) {
		if (!this.disableCSSInjection) {
			// If the canvas is in a shadow DOM, then the styles must also be inserted
			// into the same shadow DOM.
			// https://github.com/chartjs/Chart.js/issues/5763
			var root = canvas.getRootNode ? canvas.getRootNode() : document;
			var targetNode = root.host ? root : document.head;
			injectCSS(targetNode, stylesheet);
		}
	},

	acquireContext: function(item, config) {
		if (typeof item === 'string') {
			item = document.getElementById(item);
		} else if (item.length) {
			// Support for array based queries (such as jQuery)
			item = item[0];
		}

		if (item && item.canvas) {
			// Support for any object associated to a canvas (including a context2d)
			item = item.canvas;
		}

		// To prevent canvas fingerprinting, some add-ons undefine the getContext
		// method, for example: https://github.com/kkapsner/CanvasBlocker
		// https://github.com/chartjs/Chart.js/issues/2807
		var context = item && item.getContext && item.getContext('2d');

		// `instanceof HTMLCanvasElement/CanvasRenderingContext2D` fails when the item is
		// inside an iframe or when running in a protected environment. We could guess the
		// types from their toString() value but let's keep things flexible and assume it's
		// a sufficient condition if the item has a context2D which has item as `canvas`.
		// https://github.com/chartjs/Chart.js/issues/3887
		// https://github.com/chartjs/Chart.js/issues/4102
		// https://github.com/chartjs/Chart.js/issues/4152
		if (context && context.canvas === item) {
			// Load platform resources on first chart creation, to make it possible to
			// import the library before setting platform options.
			this._ensureLoaded(item);
			initCanvas(item, config);
			return context;
		}

		return null;
	},

	releaseContext: function(context) {
		var canvas = context.canvas;
		if (!canvas[EXPANDO_KEY]) {
			return;
		}

		var initial = canvas[EXPANDO_KEY].initial;
		['height', 'width'].forEach(function(prop) {
			var value = initial[prop];
			if (helpers$1.isNullOrUndef(value)) {
				canvas.removeAttribute(prop);
			} else {
				canvas.setAttribute(prop, value);
			}
		});

		helpers$1.each(initial.style || {}, function(value, key) {
			canvas.style[key] = value;
		});

		// The canvas render size might have been changed (and thus the state stack discarded),
		// we can't use save() and restore() to restore the initial state. So make sure that at
		// least the canvas context is reset to the default state by setting the canvas width.
		// https://www.w3.org/TR/2011/WD-html5-20110525/the-canvas-element.html
		// eslint-disable-next-line no-self-assign
		canvas.width = canvas.width;

		delete canvas[EXPANDO_KEY];
	},

	addEventListener: function(chart, type, listener) {
		var canvas = chart.canvas;
		if (type === 'resize') {
			// Note: the resize event is not supported on all browsers.
			addResizeListener(canvas, listener, chart);
			return;
		}

		var expando = listener[EXPANDO_KEY] || (listener[EXPANDO_KEY] = {});
		var proxies = expando.proxies || (expando.proxies = {});
		var proxy = proxies[chart.id + '_' + type] = function(event) {
			listener(fromNativeEvent(event, chart));
		};

		addListener(canvas, type, proxy);
	},

	removeEventListener: function(chart, type, listener) {
		var canvas = chart.canvas;
		if (type === 'resize') {
			// Note: the resize event is not supported on all browsers.
			removeResizeListener(canvas);
			return;
		}

		var expando = listener[EXPANDO_KEY] || {};
		var proxies = expando.proxies || {};
		var proxy = proxies[chart.id + '_' + type];
		if (!proxy) {
			return;
		}

		removeListener(canvas, type, proxy);
	}
};

// DEPRECATIONS

/**
 * Provided for backward compatibility, use EventTarget.addEventListener instead.
 * EventTarget.addEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
 * @function Chart.helpers.addEvent
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers$1.addEvent = addListener;

/**
 * Provided for backward compatibility, use EventTarget.removeEventListener instead.
 * EventTarget.removeEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/removeEventListener
 * @function Chart.helpers.removeEvent
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers$1.removeEvent = removeListener;

// @TODO Make possible to select another platform at build time.
var implementation = platform_dom$2._enabled ? platform_dom$2 : platform_basic;

/**
 * @namespace Chart.platform
 * @see https://chartjs.gitbooks.io/proposals/content/Platform.html
 * @since 2.4.0
 */
var platform = helpers$1.extend({
	/**
	 * @since 2.7.0
	 */
	initialize: function() {},

	/**
	 * Called at chart construction time, returns a context2d instance implementing
	 * the [W3C Canvas 2D Context API standard]{@link https://www.w3.org/TR/2dcontext/}.
	 * @param {*} item - The native item from which to acquire context (platform specific)
	 * @param {object} options - The chart options
	 * @returns {CanvasRenderingContext2D} context2d instance
	 */
	acquireContext: function() {},

	/**
	 * Called at chart destruction time, releases any resources associated to the context
	 * previously returned by the acquireContext() method.
	 * @param {CanvasRenderingContext2D} context - The context2d instance
	 * @returns {boolean} true if the method succeeded, else false
	 */
	releaseContext: function() {},

	/**
	 * Registers the specified listener on the given chart.
	 * @param {Chart} chart - Chart from which to listen for event
	 * @param {string} type - The ({@link IEvent}) type to listen for
	 * @param {function} listener - Receives a notification (an object that implements
	 * the {@link IEvent} interface) when an event of the specified type occurs.
	 */
	addEventListener: function() {},

	/**
	 * Removes the specified listener previously registered with addEventListener.
	 * @param {Chart} chart - Chart from which to remove the listener
	 * @param {string} type - The ({@link IEvent}) type to remove
	 * @param {function} listener - The listener function to remove from the event target.
	 */
	removeEventListener: function() {}

}, implementation);

core_defaults._set('global', {
	plugins: {}
});

/**
 * The plugin service singleton
 * @namespace Chart.plugins
 * @since 2.1.0
 */
var core_plugins = {
	/**
	 * Globally registered plugins.
	 * @private
	 */
	_plugins: [],

	/**
	 * This identifier is used to invalidate the descriptors cache attached to each chart
	 * when a global plugin is registered or unregistered. In this case, the cache ID is
	 * incremented and descriptors are regenerated during following API calls.
	 * @private
	 */
	_cacheId: 0,

	/**
	 * Registers the given plugin(s) if not already registered.
	 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
	 */
	register: function(plugins) {
		var p = this._plugins;
		([]).concat(plugins).forEach(function(plugin) {
			if (p.indexOf(plugin) === -1) {
				p.push(plugin);
			}
		});

		this._cacheId++;
	},

	/**
	 * Unregisters the given plugin(s) only if registered.
	 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
	 */
	unregister: function(plugins) {
		var p = this._plugins;
		([]).concat(plugins).forEach(function(plugin) {
			var idx = p.indexOf(plugin);
			if (idx !== -1) {
				p.splice(idx, 1);
			}
		});

		this._cacheId++;
	},

	/**
	 * Remove all registered plugins.
	 * @since 2.1.5
	 */
	clear: function() {
		this._plugins = [];
		this._cacheId++;
	},

	/**
	 * Returns the number of registered plugins?
	 * @returns {number}
	 * @since 2.1.5
	 */
	count: function() {
		return this._plugins.length;
	},

	/**
	 * Returns all registered plugin instances.
	 * @returns {IPlugin[]} array of plugin objects.
	 * @since 2.1.5
	 */
	getAll: function() {
		return this._plugins;
	},

	/**
	 * Calls enabled plugins for `chart` on the specified hook and with the given args.
	 * This method immediately returns as soon as a plugin explicitly returns false. The
	 * returned value can be used, for instance, to interrupt the current action.
	 * @param {Chart} chart - The chart instance for which plugins should be called.
	 * @param {string} hook - The name of the plugin method to call (e.g. 'beforeUpdate').
	 * @param {Array} [args] - Extra arguments to apply to the hook call.
	 * @returns {boolean} false if any of the plugins return false, else returns true.
	 */
	notify: function(chart, hook, args) {
		var descriptors = this.descriptors(chart);
		var ilen = descriptors.length;
		var i, descriptor, plugin, params, method;

		for (i = 0; i < ilen; ++i) {
			descriptor = descriptors[i];
			plugin = descriptor.plugin;
			method = plugin[hook];
			if (typeof method === 'function') {
				params = [chart].concat(args || []);
				params.push(descriptor.options);
				if (method.apply(plugin, params) === false) {
					return false;
				}
			}
		}

		return true;
	},

	/**
	 * Returns descriptors of enabled plugins for the given chart.
	 * @returns {object[]} [{ plugin, options }]
	 * @private
	 */
	descriptors: function(chart) {
		var cache = chart.$plugins || (chart.$plugins = {});
		if (cache.id === this._cacheId) {
			return cache.descriptors;
		}

		var plugins = [];
		var descriptors = [];
		var config = (chart && chart.config) || {};
		var options = (config.options && config.options.plugins) || {};

		this._plugins.concat(config.plugins || []).forEach(function(plugin) {
			var idx = plugins.indexOf(plugin);
			if (idx !== -1) {
				return;
			}

			var id = plugin.id;
			var opts = options[id];
			if (opts === false) {
				return;
			}

			if (opts === true) {
				opts = helpers$1.clone(core_defaults.global.plugins[id]);
			}

			plugins.push(plugin);
			descriptors.push({
				plugin: plugin,
				options: opts || {}
			});
		});

		cache.descriptors = descriptors;
		cache.id = this._cacheId;
		return descriptors;
	},

	/**
	 * Invalidates cache for the given chart: descriptors hold a reference on plugin option,
	 * but in some cases, this reference can be changed by the user when updating options.
	 * https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
	 * @private
	 */
	_invalidate: function(chart) {
		delete chart.$plugins;
	}
};

var core_scaleService = {
	// Scale registration object. Extensions can register new scale types (such as log or DB scales) and then
	// use the new chart options to grab the correct scale
	constructors: {},
	// Use a registration function so that we can move to an ES6 map when we no longer need to support
	// old browsers

	// Scale config defaults
	defaults: {},
	registerScaleType: function(type, scaleConstructor, scaleDefaults) {
		this.constructors[type] = scaleConstructor;
		this.defaults[type] = helpers$1.clone(scaleDefaults);
	},
	getScaleConstructor: function(type) {
		return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
	},
	getScaleDefaults: function(type) {
		// Return the scale defaults merged with the global settings so that we always use the latest ones
		return this.defaults.hasOwnProperty(type) ? helpers$1.merge(Object.create(null), [core_defaults.scale, this.defaults[type]]) : {};
	},
	updateScaleDefaults: function(type, additions) {
		var me = this;
		if (me.defaults.hasOwnProperty(type)) {
			me.defaults[type] = helpers$1.extend(me.defaults[type], additions);
		}
	},
	addScalesToLayout: function(chart) {
		// Adds each scale to the chart.boxes array to be sized accordingly
		helpers$1.each(chart.scales, function(scale) {
			// Set ILayoutItem parameters for backwards compatibility
			scale.fullWidth = scale.options.fullWidth;
			scale.position = scale.options.position;
			scale.weight = scale.options.weight;
			core_layouts.addBox(chart, scale);
		});
	}
};

var valueOrDefault$8 = helpers$1.valueOrDefault;
var getRtlHelper = helpers$1.rtl.getRtlAdapter;

core_defaults._set('global', {
	tooltips: {
		enabled: true,
		custom: null,
		mode: 'nearest',
		position: 'average',
		intersect: true,
		backgroundColor: 'rgba(0,0,0,0.8)',
		titleFontStyle: 'bold',
		titleSpacing: 2,
		titleMarginBottom: 6,
		titleFontColor: '#fff',
		titleAlign: 'left',
		bodySpacing: 2,
		bodyFontColor: '#fff',
		bodyAlign: 'left',
		footerFontStyle: 'bold',
		footerSpacing: 2,
		footerMarginTop: 6,
		footerFontColor: '#fff',
		footerAlign: 'left',
		yPadding: 6,
		xPadding: 6,
		caretPadding: 2,
		caretSize: 5,
		cornerRadius: 6,
		multiKeyBackground: '#fff',
		displayColors: true,
		borderColor: 'rgba(0,0,0,0)',
		borderWidth: 0,
		callbacks: {
			// Args are: (tooltipItems, data)
			beforeTitle: helpers$1.noop,
			title: function(tooltipItems, data) {
				var title = '';
				var labels = data.labels;
				var labelCount = labels ? labels.length : 0;

				if (tooltipItems.length > 0) {
					var item = tooltipItems[0];
					if (item.label) {
						title = item.label;
					} else if (item.xLabel) {
						title = item.xLabel;
					} else if (labelCount > 0 && item.index < labelCount) {
						title = labels[item.index];
					}
				}

				return title;
			},
			afterTitle: helpers$1.noop,

			// Args are: (tooltipItems, data)
			beforeBody: helpers$1.noop,

			// Args are: (tooltipItem, data)
			beforeLabel: helpers$1.noop,
			label: function(tooltipItem, data) {
				var label = data.datasets[tooltipItem.datasetIndex].label || '';

				if (label) {
					label += ': ';
				}
				if (!helpers$1.isNullOrUndef(tooltipItem.value)) {
					label += tooltipItem.value;
				} else {
					label += tooltipItem.yLabel;
				}
				return label;
			},
			labelColor: function(tooltipItem, chart) {
				var meta = chart.getDatasetMeta(tooltipItem.datasetIndex);
				var activeElement = meta.data[tooltipItem.index];
				var view = activeElement._view;
				return {
					borderColor: view.borderColor,
					backgroundColor: view.backgroundColor
				};
			},
			labelTextColor: function() {
				return this._options.bodyFontColor;
			},
			afterLabel: helpers$1.noop,

			// Args are: (tooltipItems, data)
			afterBody: helpers$1.noop,

			// Args are: (tooltipItems, data)
			beforeFooter: helpers$1.noop,
			footer: helpers$1.noop,
			afterFooter: helpers$1.noop
		}
	}
});

var positioners = {
	/**
	 * Average mode places the tooltip at the average position of the elements shown
	 * @function Chart.Tooltip.positioners.average
	 * @param elements {ChartElement[]} the elements being displayed in the tooltip
	 * @returns {object} tooltip position
	 */
	average: function(elements) {
		if (!elements.length) {
			return false;
		}

		var i, len;
		var x = 0;
		var y = 0;
		var count = 0;

		for (i = 0, len = elements.length; i < len; ++i) {
			var el = elements[i];
			if (el && el.hasValue()) {
				var pos = el.tooltipPosition();
				x += pos.x;
				y += pos.y;
				++count;
			}
		}

		return {
			x: x / count,
			y: y / count
		};
	},

	/**
	 * Gets the tooltip position nearest of the item nearest to the event position
	 * @function Chart.Tooltip.positioners.nearest
	 * @param elements {Chart.Element[]} the tooltip elements
	 * @param eventPosition {object} the position of the event in canvas coordinates
	 * @returns {object} the tooltip position
	 */
	nearest: function(elements, eventPosition) {
		var x = eventPosition.x;
		var y = eventPosition.y;
		var minDistance = Number.POSITIVE_INFINITY;
		var i, len, nearestElement;

		for (i = 0, len = elements.length; i < len; ++i) {
			var el = elements[i];
			if (el && el.hasValue()) {
				var center = el.getCenterPoint();
				var d = helpers$1.distanceBetweenPoints(eventPosition, center);

				if (d < minDistance) {
					minDistance = d;
					nearestElement = el;
				}
			}
		}

		if (nearestElement) {
			var tp = nearestElement.tooltipPosition();
			x = tp.x;
			y = tp.y;
		}

		return {
			x: x,
			y: y
		};
	}
};

// Helper to push or concat based on if the 2nd parameter is an array or not
function pushOrConcat(base, toPush) {
	if (toPush) {
		if (helpers$1.isArray(toPush)) {
			// base = base.concat(toPush);
			Array.prototype.push.apply(base, toPush);
		} else {
			base.push(toPush);
		}
	}

	return base;
}

/**
 * Returns array of strings split by newline
 * @param {string} value - The value to split by newline.
 * @returns {string[]} value if newline present - Returned from String split() method
 * @function
 */
function splitNewlines(str) {
	if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) {
		return str.split('\n');
	}
	return str;
}


/**
 * Private helper to create a tooltip item model
 * @param element - the chart element (point, arc, bar) to create the tooltip item for
 * @return new tooltip item
 */
function createTooltipItem(element) {
	var xScale = element._xScale;
	var yScale = element._yScale || element._scale; // handle radar || polarArea charts
	var index = element._index;
	var datasetIndex = element._datasetIndex;
	var controller = element._chart.getDatasetMeta(datasetIndex).controller;
	var indexScale = controller._getIndexScale();
	var valueScale = controller._getValueScale();

	return {
		xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : '',
		yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : '',
		label: indexScale ? '' + indexScale.getLabelForIndex(index, datasetIndex) : '',
		value: valueScale ? '' + valueScale.getLabelForIndex(index, datasetIndex) : '',
		index: index,
		datasetIndex: datasetIndex,
		x: element._model.x,
		y: element._model.y
	};
}

/**
 * Helper to get the reset model for the tooltip
 * @param tooltipOpts {object} the tooltip options
 */
function getBaseModel(tooltipOpts) {
	var globalDefaults = core_defaults.global;

	return {
		// Positioning
		xPadding: tooltipOpts.xPadding,
		yPadding: tooltipOpts.yPadding,
		xAlign: tooltipOpts.xAlign,
		yAlign: tooltipOpts.yAlign,

		// Drawing direction and text direction
		rtl: tooltipOpts.rtl,
		textDirection: tooltipOpts.textDirection,

		// Body
		bodyFontColor: tooltipOpts.bodyFontColor,
		_bodyFontFamily: valueOrDefault$8(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
		_bodyFontStyle: valueOrDefault$8(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
		_bodyAlign: tooltipOpts.bodyAlign,
		bodyFontSize: valueOrDefault$8(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
		bodySpacing: tooltipOpts.bodySpacing,

		// Title
		titleFontColor: tooltipOpts.titleFontColor,
		_titleFontFamily: valueOrDefault$8(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
		_titleFontStyle: valueOrDefault$8(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
		titleFontSize: valueOrDefault$8(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
		_titleAlign: tooltipOpts.titleAlign,
		titleSpacing: tooltipOpts.titleSpacing,
		titleMarginBottom: tooltipOpts.titleMarginBottom,

		// Footer
		footerFontColor: tooltipOpts.footerFontColor,
		_footerFontFamily: valueOrDefault$8(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
		_footerFontStyle: valueOrDefault$8(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
		footerFontSize: valueOrDefault$8(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
		_footerAlign: tooltipOpts.footerAlign,
		footerSpacing: tooltipOpts.footerSpacing,
		footerMarginTop: tooltipOpts.footerMarginTop,

		// Appearance
		caretSize: tooltipOpts.caretSize,
		cornerRadius: tooltipOpts.cornerRadius,
		backgroundColor: tooltipOpts.backgroundColor,
		opacity: 0,
		legendColorBackground: tooltipOpts.multiKeyBackground,
		displayColors: tooltipOpts.displayColors,
		borderColor: tooltipOpts.borderColor,
		borderWidth: tooltipOpts.borderWidth
	};
}

/**
 * Get the size of the tooltip
 */
function getTooltipSize(tooltip, model) {
	var ctx = tooltip._chart.ctx;

	var height = model.yPadding * 2; // Tooltip Padding
	var width = 0;

	// Count of all lines in the body
	var body = model.body;
	var combinedBodyLength = body.reduce(function(count, bodyItem) {
		return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
	}, 0);
	combinedBodyLength += model.beforeBody.length + model.afterBody.length;

	var titleLineCount = model.title.length;
	var footerLineCount = model.footer.length;
	var titleFontSize = model.titleFontSize;
	var bodyFontSize = model.bodyFontSize;
	var footerFontSize = model.footerFontSize;

	height += titleLineCount * titleFontSize; // Title Lines
	height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0; // Title Line Spacing
	height += titleLineCount ? model.titleMarginBottom : 0; // Title's bottom Margin
	height += combinedBodyLength * bodyFontSize; // Body Lines
	height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0; // Body Line Spacing
	height += footerLineCount ? model.footerMarginTop : 0; // Footer Margin
	height += footerLineCount * (footerFontSize); // Footer Lines
	height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0; // Footer Line Spacing

	// Title width
	var widthPadding = 0;
	var maxLineWidth = function(line) {
		width = Math.max(width, ctx.measureText(line).width + widthPadding);
	};

	ctx.font = helpers$1.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
	helpers$1.each(model.title, maxLineWidth);

	// Body width
	ctx.font = helpers$1.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
	helpers$1.each(model.beforeBody.concat(model.afterBody), maxLineWidth);

	// Body lines may include some extra width due to the color box
	widthPadding = model.displayColors ? (bodyFontSize + 2) : 0;
	helpers$1.each(body, function(bodyItem) {
		helpers$1.each(bodyItem.before, maxLineWidth);
		helpers$1.each(bodyItem.lines, maxLineWidth);
		helpers$1.each(bodyItem.after, maxLineWidth);
	});

	// Reset back to 0
	widthPadding = 0;

	// Footer width
	ctx.font = helpers$1.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
	helpers$1.each(model.footer, maxLineWidth);

	// Add padding
	width += 2 * model.xPadding;

	return {
		width: width,
		height: height
	};
}

/**
 * Helper to get the alignment of a tooltip given the size
 */
function determineAlignment(tooltip, size) {
	var model = tooltip._model;
	var chart = tooltip._chart;
	var chartArea = tooltip._chart.chartArea;
	var xAlign = 'center';
	var yAlign = 'center';

	if (model.y < size.height) {
		yAlign = 'top';
	} else if (model.y > (chart.height - size.height)) {
		yAlign = 'bottom';
	}

	var lf, rf; // functions to determine left, right alignment
	var olf, orf; // functions to determine if left/right alignment causes tooltip to go outside chart
	var yf; // function to get the y alignment if the tooltip goes outside of the left or right edges
	var midX = (chartArea.left + chartArea.right) / 2;
	var midY = (chartArea.top + chartArea.bottom) / 2;

	if (yAlign === 'center') {
		lf = function(x) {
			return x <= midX;
		};
		rf = function(x) {
			return x > midX;
		};
	} else {
		lf = function(x) {
			return x <= (size.width / 2);
		};
		rf = function(x) {
			return x >= (chart.width - (size.width / 2));
		};
	}

	olf = function(x) {
		return x + size.width + model.caretSize + model.caretPadding > chart.width;
	};
	orf = function(x) {
		return x - size.width - model.caretSize - model.caretPadding < 0;
	};
	yf = function(y) {
		return y <= midY ? 'top' : 'bottom';
	};

	if (lf(model.x)) {
		xAlign = 'left';

		// Is tooltip too wide and goes over the right side of the chart.?
		if (olf(model.x)) {
			xAlign = 'center';
			yAlign = yf(model.y);
		}
	} else if (rf(model.x)) {
		xAlign = 'right';

		// Is tooltip too wide and goes outside left edge of canvas?
		if (orf(model.x)) {
			xAlign = 'center';
			yAlign = yf(model.y);
		}
	}

	var opts = tooltip._options;
	return {
		xAlign: opts.xAlign ? opts.xAlign : xAlign,
		yAlign: opts.yAlign ? opts.yAlign : yAlign
	};
}

/**
 * Helper to get the location a tooltip needs to be placed at given the initial position (via the vm) and the size and alignment
 */
function getBackgroundPoint(vm, size, alignment, chart) {
	// Background Position
	var x = vm.x;
	var y = vm.y;

	var caretSize = vm.caretSize;
	var caretPadding = vm.caretPadding;
	var cornerRadius = vm.cornerRadius;
	var xAlign = alignment.xAlign;
	var yAlign = alignment.yAlign;
	var paddingAndSize = caretSize + caretPadding;
	var radiusAndPadding = cornerRadius + caretPadding;

	if (xAlign === 'right') {
		x -= size.width;
	} else if (xAlign === 'center') {
		x -= (size.width / 2);
		if (x + size.width > chart.width) {
			x = chart.width - size.width;
		}
		if (x < 0) {
			x = 0;
		}
	}

	if (yAlign === 'top') {
		y += paddingAndSize;
	} else if (yAlign === 'bottom') {
		y -= size.height + paddingAndSize;
	} else {
		y -= (size.height / 2);
	}

	if (yAlign === 'center') {
		if (xAlign === 'left') {
			x += paddingAndSize;
		} else if (xAlign === 'right') {
			x -= paddingAndSize;
		}
	} else if (xAlign === 'left') {
		x -= radiusAndPadding;
	} else if (xAlign === 'right') {
		x += radiusAndPadding;
	}

	return {
		x: x,
		y: y
	};
}

function getAlignedX(vm, align) {
	return align === 'center'
		? vm.x + vm.width / 2
		: align === 'right'
			? vm.x + vm.width - vm.xPadding
			: vm.x + vm.xPadding;
}

/**
 * Helper to build before and after body lines
 */
function getBeforeAfterBodyLines(callback) {
	return pushOrConcat([], splitNewlines(callback));
}

var exports$4 = core_element.extend({
	initialize: function() {
		this._model = getBaseModel(this._options);
		this._lastActive = [];
	},

	// Get the title
	// Args are: (tooltipItem, data)
	getTitle: function() {
		var me = this;
		var opts = me._options;
		var callbacks = opts.callbacks;

		var beforeTitle = callbacks.beforeTitle.apply(me, arguments);
		var title = callbacks.title.apply(me, arguments);
		var afterTitle = callbacks.afterTitle.apply(me, arguments);

		var lines = [];
		lines = pushOrConcat(lines, splitNewlines(beforeTitle));
		lines = pushOrConcat(lines, splitNewlines(title));
		lines = pushOrConcat(lines, splitNewlines(afterTitle));

		return lines;
	},

	// Args are: (tooltipItem, data)
	getBeforeBody: function() {
		return getBeforeAfterBodyLines(this._options.callbacks.beforeBody.apply(this, arguments));
	},

	// Args are: (tooltipItem, data)
	getBody: function(tooltipItems, data) {
		var me = this;
		var callbacks = me._options.callbacks;
		var bodyItems = [];

		helpers$1.each(tooltipItems, function(tooltipItem) {
			var bodyItem = {
				before: [],
				lines: [],
				after: []
			};
			pushOrConcat(bodyItem.before, splitNewlines(callbacks.beforeLabel.call(me, tooltipItem, data)));
			pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
			pushOrConcat(bodyItem.after, splitNewlines(callbacks.afterLabel.call(me, tooltipItem, data)));

			bodyItems.push(bodyItem);
		});

		return bodyItems;
	},

	// Args are: (tooltipItem, data)
	getAfterBody: function() {
		return getBeforeAfterBodyLines(this._options.callbacks.afterBody.apply(this, arguments));
	},

	// Get the footer and beforeFooter and afterFooter lines
	// Args are: (tooltipItem, data)
	getFooter: function() {
		var me = this;
		var callbacks = me._options.callbacks;

		var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
		var footer = callbacks.footer.apply(me, arguments);
		var afterFooter = callbacks.afterFooter.apply(me, arguments);

		var lines = [];
		lines = pushOrConcat(lines, splitNewlines(beforeFooter));
		lines = pushOrConcat(lines, splitNewlines(footer));
		lines = pushOrConcat(lines, splitNewlines(afterFooter));

		return lines;
	},

	update: function(changed) {
		var me = this;
		var opts = me._options;

		// Need to regenerate the model because its faster than using extend and it is necessary due to the optimization in Chart.Element.transition
		// that does _view = _model if ease === 1. This causes the 2nd tooltip update to set properties in both the view and model at the same time
		// which breaks any animations.
		var existingModel = me._model;
		var model = me._model = getBaseModel(opts);
		var active = me._active;

		var data = me._data;

		// In the case where active.length === 0 we need to keep these at existing values for good animations
		var alignment = {
			xAlign: existingModel.xAlign,
			yAlign: existingModel.yAlign
		};
		var backgroundPoint = {
			x: existingModel.x,
			y: existingModel.y
		};
		var tooltipSize = {
			width: existingModel.width,
			height: existingModel.height
		};
		var tooltipPosition = {
			x: existingModel.caretX,
			y: existingModel.caretY
		};

		var i, len;

		if (active.length) {
			model.opacity = 1;

			var labelColors = [];
			var labelTextColors = [];
			tooltipPosition = positioners[opts.position].call(me, active, me._eventPosition);

			var tooltipItems = [];
			for (i = 0, len = active.length; i < len; ++i) {
				tooltipItems.push(createTooltipItem(active[i]));
			}

			// If the user provided a filter function, use it to modify the tooltip items
			if (opts.filter) {
				tooltipItems = tooltipItems.filter(function(a) {
					return opts.filter(a, data);
				});
			}

			// If the user provided a sorting function, use it to modify the tooltip items
			if (opts.itemSort) {
				tooltipItems = tooltipItems.sort(function(a, b) {
					return opts.itemSort(a, b, data);
				});
			}

			// Determine colors for boxes
			helpers$1.each(tooltipItems, function(tooltipItem) {
				labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, me._chart));
				labelTextColors.push(opts.callbacks.labelTextColor.call(me, tooltipItem, me._chart));
			});


			// Build the Text Lines
			model.title = me.getTitle(tooltipItems, data);
			model.beforeBody = me.getBeforeBody(tooltipItems, data);
			model.body = me.getBody(tooltipItems, data);
			model.afterBody = me.getAfterBody(tooltipItems, data);
			model.footer = me.getFooter(tooltipItems, data);

			// Initial positioning and colors
			model.x = tooltipPosition.x;
			model.y = tooltipPosition.y;
			model.caretPadding = opts.caretPadding;
			model.labelColors = labelColors;
			model.labelTextColors = labelTextColors;

			// data points
			model.dataPoints = tooltipItems;

			// We need to determine alignment of the tooltip
			tooltipSize = getTooltipSize(this, model);
			alignment = determineAlignment(this, tooltipSize);
			// Final Size and Position
			backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment, me._chart);
		} else {
			model.opacity = 0;
		}

		model.xAlign = alignment.xAlign;
		model.yAlign = alignment.yAlign;
		model.x = backgroundPoint.x;
		model.y = backgroundPoint.y;
		model.width = tooltipSize.width;
		model.height = tooltipSize.height;

		// Point where the caret on the tooltip points to
		model.caretX = tooltipPosition.x;
		model.caretY = tooltipPosition.y;

		me._model = model;

		if (changed && opts.custom) {
			opts.custom.call(me, model);
		}

		return me;
	},

	drawCaret: function(tooltipPoint, size) {
		var ctx = this._chart.ctx;
		var vm = this._view;
		var caretPosition = this.getCaretPosition(tooltipPoint, size, vm);

		ctx.lineTo(caretPosition.x1, caretPosition.y1);
		ctx.lineTo(caretPosition.x2, caretPosition.y2);
		ctx.lineTo(caretPosition.x3, caretPosition.y3);
	},
	getCaretPosition: function(tooltipPoint, size, vm) {
		var x1, x2, x3, y1, y2, y3;
		var caretSize = vm.caretSize;
		var cornerRadius = vm.cornerRadius;
		var xAlign = vm.xAlign;
		var yAlign = vm.yAlign;
		var ptX = tooltipPoint.x;
		var ptY = tooltipPoint.y;
		var width = size.width;
		var height = size.height;

		if (yAlign === 'center') {
			y2 = ptY + (height / 2);

			if (xAlign === 'left') {
				x1 = ptX;
				x2 = x1 - caretSize;
				x3 = x1;

				y1 = y2 + caretSize;
				y3 = y2 - caretSize;
			} else {
				x1 = ptX + width;
				x2 = x1 + caretSize;
				x3 = x1;

				y1 = y2 - caretSize;
				y3 = y2 + caretSize;
			}
		} else {
			if (xAlign === 'left') {
				x2 = ptX + cornerRadius + (caretSize);
				x1 = x2 - caretSize;
				x3 = x2 + caretSize;
			} else if (xAlign === 'right') {
				x2 = ptX + width - cornerRadius - caretSize;
				x1 = x2 - caretSize;
				x3 = x2 + caretSize;
			} else {
				x2 = vm.caretX;
				x1 = x2 - caretSize;
				x3 = x2 + caretSize;
			}
			if (yAlign === 'top') {
				y1 = ptY;
				y2 = y1 - caretSize;
				y3 = y1;
			} else {
				y1 = ptY + height;
				y2 = y1 + caretSize;
				y3 = y1;
				// invert drawing order
				var tmp = x3;
				x3 = x1;
				x1 = tmp;
			}
		}
		return {x1: x1, x2: x2, x3: x3, y1: y1, y2: y2, y3: y3};
	},

	drawTitle: function(pt, vm, ctx) {
		var title = vm.title;
		var length = title.length;
		var titleFontSize, titleSpacing, i;

		if (length) {
			var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);

			pt.x = getAlignedX(vm, vm._titleAlign);

			ctx.textAlign = rtlHelper.textAlign(vm._titleAlign);
			ctx.textBaseline = 'middle';

			titleFontSize = vm.titleFontSize;
			titleSpacing = vm.titleSpacing;

			ctx.fillStyle = vm.titleFontColor;
			ctx.font = helpers$1.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);

			for (i = 0; i < length; ++i) {
				ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFontSize / 2);
				pt.y += titleFontSize + titleSpacing; // Line Height and spacing

				if (i + 1 === length) {
					pt.y += vm.titleMarginBottom - titleSpacing; // If Last, add margin, remove spacing
				}
			}
		}
	},

	drawBody: function(pt, vm, ctx) {
		var bodyFontSize = vm.bodyFontSize;
		var bodySpacing = vm.bodySpacing;
		var bodyAlign = vm._bodyAlign;
		var body = vm.body;
		var drawColorBoxes = vm.displayColors;
		var xLinePadding = 0;
		var colorX = drawColorBoxes ? getAlignedX(vm, 'left') : 0;

		var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);

		var fillLineOfText = function(line) {
			ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyFontSize / 2);
			pt.y += bodyFontSize + bodySpacing;
		};

		var bodyItem, textColor, labelColors, lines, i, j, ilen, jlen;
		var bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);

		ctx.textAlign = bodyAlign;
		ctx.textBaseline = 'middle';
		ctx.font = helpers$1.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);

		pt.x = getAlignedX(vm, bodyAlignForCalculation);

		// Before body lines
		ctx.fillStyle = vm.bodyFontColor;
		helpers$1.each(vm.beforeBody, fillLineOfText);

		xLinePadding = drawColorBoxes && bodyAlignForCalculation !== 'right'
			? bodyAlign === 'center' ? (bodyFontSize / 2 + 1) : (bodyFontSize + 2)
			: 0;

		// Draw body lines now
		for (i = 0, ilen = body.length; i < ilen; ++i) {
			bodyItem = body[i];
			textColor = vm.labelTextColors[i];
			labelColors = vm.labelColors[i];

			ctx.fillStyle = textColor;
			helpers$1.each(bodyItem.before, fillLineOfText);

			lines = bodyItem.lines;
			for (j = 0, jlen = lines.length; j < jlen; ++j) {
				// Draw Legend-like boxes if needed
				if (drawColorBoxes) {
					var rtlColorX = rtlHelper.x(colorX);

					// Fill a white rect so that colours merge nicely if the opacity is < 1
					ctx.fillStyle = vm.legendColorBackground;
					ctx.fillRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);

					// Border
					ctx.lineWidth = 1;
					ctx.strokeStyle = labelColors.borderColor;
					ctx.strokeRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);

					// Inner square
					ctx.fillStyle = labelColors.backgroundColor;
					ctx.fillRect(rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), bodyFontSize - 2), pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
					ctx.fillStyle = textColor;
				}

				fillLineOfText(lines[j]);
			}

			helpers$1.each(bodyItem.after, fillLineOfText);
		}

		// Reset back to 0 for after body
		xLinePadding = 0;

		// After body lines
		helpers$1.each(vm.afterBody, fillLineOfText);
		pt.y -= bodySpacing; // Remove last body spacing
	},

	drawFooter: function(pt, vm, ctx) {
		var footer = vm.footer;
		var length = footer.length;
		var footerFontSize, i;

		if (length) {
			var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);

			pt.x = getAlignedX(vm, vm._footerAlign);
			pt.y += vm.footerMarginTop;

			ctx.textAlign = rtlHelper.textAlign(vm._footerAlign);
			ctx.textBaseline = 'middle';

			footerFontSize = vm.footerFontSize;

			ctx.fillStyle = vm.footerFontColor;
			ctx.font = helpers$1.fontString(footerFontSize, vm._footerFontStyle, vm._footerFontFamily);

			for (i = 0; i < length; ++i) {
				ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFontSize / 2);
				pt.y += footerFontSize + vm.footerSpacing;
			}
		}
	},

	drawBackground: function(pt, vm, ctx, tooltipSize) {
		ctx.fillStyle = vm.backgroundColor;
		ctx.strokeStyle = vm.borderColor;
		ctx.lineWidth = vm.borderWidth;
		var xAlign = vm.xAlign;
		var yAlign = vm.yAlign;
		var x = pt.x;
		var y = pt.y;
		var width = tooltipSize.width;
		var height = tooltipSize.height;
		var radius = vm.cornerRadius;

		ctx.beginPath();
		ctx.moveTo(x + radius, y);
		if (yAlign === 'top') {
			this.drawCaret(pt, tooltipSize);
		}
		ctx.lineTo(x + width - radius, y);
		ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
		if (yAlign === 'center' && xAlign === 'right') {
			this.drawCaret(pt, tooltipSize);
		}
		ctx.lineTo(x + width, y + height - radius);
		ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
		if (yAlign === 'bottom') {
			this.drawCaret(pt, tooltipSize);
		}
		ctx.lineTo(x + radius, y + height);
		ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
		if (yAlign === 'center' && xAlign === 'left') {
			this.drawCaret(pt, tooltipSize);
		}
		ctx.lineTo(x, y + radius);
		ctx.quadraticCurveTo(x, y, x + radius, y);
		ctx.closePath();

		ctx.fill();

		if (vm.borderWidth > 0) {
			ctx.stroke();
		}
	},

	draw: function() {
		var ctx = this._chart.ctx;
		var vm = this._view;

		if (vm.opacity === 0) {
			return;
		}

		var tooltipSize = {
			width: vm.width,
			height: vm.height
		};
		var pt = {
			x: vm.x,
			y: vm.y
		};

		// IE11/Edge does not like very small opacities, so snap to 0
		var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;

		// Truthy/falsey value for empty tooltip
		var hasTooltipContent = vm.title.length || vm.beforeBody.length || vm.body.length || vm.afterBody.length || vm.footer.length;

		if (this._options.enabled && hasTooltipContent) {
			ctx.save();
			ctx.globalAlpha = opacity;

			// Draw Background
			this.drawBackground(pt, vm, ctx, tooltipSize);

			// Draw Title, Body, and Footer
			pt.y += vm.yPadding;

			helpers$1.rtl.overrideTextDirection(ctx, vm.textDirection);

			// Titles
			this.drawTitle(pt, vm, ctx);

			// Body
			this.drawBody(pt, vm, ctx);

			// Footer
			this.drawFooter(pt, vm, ctx);

			helpers$1.rtl.restoreTextDirection(ctx, vm.textDirection);

			ctx.restore();
		}
	},

	/**
	 * Handle an event
	 * @private
	 * @param {IEvent} event - The event to handle
	 * @returns {boolean} true if the tooltip changed
	 */
	handleEvent: function(e) {
		var me = this;
		var options = me._options;
		var changed = false;

		me._lastActive = me._lastActive || [];

		// Find Active Elements for tooltips
		if (e.type === 'mouseout') {
			me._active = [];
		} else {
			me._active = me._chart.getElementsAtEventForMode(e, options.mode, options);
			if (options.reverse) {
				me._active.reverse();
			}
		}

		// Remember Last Actives
		changed = !helpers$1.arrayEquals(me._active, me._lastActive);

		// Only handle target event on tooltip change
		if (changed) {
			me._lastActive = me._active;

			if (options.enabled || options.custom) {
				me._eventPosition = {
					x: e.x,
					y: e.y
				};

				me.update(true);
				me.pivot();
			}
		}

		return changed;
	}
});

/**
 * @namespace Chart.Tooltip.positioners
 */
var positioners_1 = positioners;

var core_tooltip = exports$4;
core_tooltip.positioners = positioners_1;

var valueOrDefault$9 = helpers$1.valueOrDefault;

core_defaults._set('global', {
	elements: {},
	events: [
		'mousemove',
		'mouseout',
		'click',
		'touchstart',
		'touchmove'
	],
	hover: {
		onHover: null,
		mode: 'nearest',
		intersect: true,
		animationDuration: 400
	},
	onClick: null,
	maintainAspectRatio: true,
	responsive: true,
	responsiveAnimationDuration: 0
});

/**
 * Recursively merge the given config objects representing the `scales` option
 * by incorporating scale defaults in `xAxes` and `yAxes` array items, then
 * returns a deep copy of the result, thus doesn't alter inputs.
 */
function mergeScaleConfig(/* config objects ... */) {
	return helpers$1.merge(Object.create(null), [].slice.call(arguments), {
		merger: function(key, target, source, options) {
			if (key === 'xAxes' || key === 'yAxes') {
				var slen = source[key].length;
				var i, type, scale;

				if (!target[key]) {
					target[key] = [];
				}

				for (i = 0; i < slen; ++i) {
					scale = source[key][i];
					type = valueOrDefault$9(scale.type, key === 'xAxes' ? 'category' : 'linear');

					if (i >= target[key].length) {
						target[key].push({});
					}

					if (!target[key][i].type || (scale.type && scale.type !== target[key][i].type)) {
						// new/untyped scale or type changed: let's apply the new defaults
						// then merge source scale to correctly overwrite the defaults.
						helpers$1.merge(target[key][i], [core_scaleService.getScaleDefaults(type), scale]);
					} else {
						// scales type are the same
						helpers$1.merge(target[key][i], scale);
					}
				}
			} else {
				helpers$1._merger(key, target, source, options);
			}
		}
	});
}

/**
 * Recursively merge the given config objects as the root options by handling
 * default scale options for the `scales` and `scale` properties, then returns
 * a deep copy of the result, thus doesn't alter inputs.
 */
function mergeConfig(/* config objects ... */) {
	return helpers$1.merge(Object.create(null), [].slice.call(arguments), {
		merger: function(key, target, source, options) {
			var tval = target[key] || Object.create(null);
			var sval = source[key];

			if (key === 'scales') {
				// scale config merging is complex. Add our own function here for that
				target[key] = mergeScaleConfig(tval, sval);
			} else if (key === 'scale') {
				// used in polar area & radar charts since there is only one scale
				target[key] = helpers$1.merge(tval, [core_scaleService.getScaleDefaults(sval.type), sval]);
			} else {
				helpers$1._merger(key, target, source, options);
			}
		}
	});
}

function initConfig(config) {
	config = config || Object.create(null);

	// Do NOT use mergeConfig for the data object because this method merges arrays
	// and so would change references to labels and datasets, preventing data updates.
	var data = config.data = config.data || {};
	data.datasets = data.datasets || [];
	data.labels = data.labels || [];

	config.options = mergeConfig(
		core_defaults.global,
		core_defaults[config.type],
		config.options || {});

	return config;
}

function updateConfig(chart) {
	var newOptions = chart.options;

	helpers$1.each(chart.scales, function(scale) {
		core_layouts.removeBox(chart, scale);
	});

	newOptions = mergeConfig(
		core_defaults.global,
		core_defaults[chart.config.type],
		newOptions);

	chart.options = chart.config.options = newOptions;
	chart.ensureScalesHaveIDs();
	chart.buildOrUpdateScales();

	// Tooltip
	chart.tooltip._options = newOptions.tooltips;
	chart.tooltip.initialize();
}

function nextAvailableScaleId(axesOpts, prefix, index) {
	var id;
	var hasId = function(obj) {
		return obj.id === id;
	};

	do {
		id = prefix + index++;
	} while (helpers$1.findIndex(axesOpts, hasId) >= 0);

	return id;
}

function positionIsHorizontal(position) {
	return position === 'top' || position === 'bottom';
}

function compare2Level(l1, l2) {
	return function(a, b) {
		return a[l1] === b[l1]
			? a[l2] - b[l2]
			: a[l1] - b[l1];
	};
}

var Chart = function(item, config) {
	this.construct(item, config);
	return this;
};

helpers$1.extend(Chart.prototype, /** @lends Chart */ {
	/**
	 * @private
	 */
	construct: function(item, config) {
		var me = this;

		config = initConfig(config);

		var context = platform.acquireContext(item, config);
		var canvas = context && context.canvas;
		var height = canvas && canvas.height;
		var width = canvas && canvas.width;

		me.id = helpers$1.uid();
		me.ctx = context;
		me.canvas = canvas;
		me.config = config;
		me.width = width;
		me.height = height;
		me.aspectRatio = height ? width / height : null;
		me.options = config.options;
		me._bufferedRender = false;
		me._layers = [];

		/**
		 * Provided for backward compatibility, Chart and Chart.Controller have been merged,
		 * the "instance" still need to be defined since it might be called from plugins.
		 * @prop Chart#chart
		 * @deprecated since version 2.6.0
		 * @todo remove at version 3
		 * @private
		 */
		me.chart = me;
		me.controller = me; // chart.chart.controller #inception

		// Add the chart instance to the global namespace
		Chart.instances[me.id] = me;

		// Define alias to the config data: `chart.data === chart.config.data`
		Object.defineProperty(me, 'data', {
			get: function() {
				return me.config.data;
			},
			set: function(value) {
				me.config.data = value;
			}
		});

		if (!context || !canvas) {
			// The given item is not a compatible context2d element, let's return before finalizing
			// the chart initialization but after setting basic chart / controller properties that
			// can help to figure out that the chart is not valid (e.g chart.canvas !== null);
			// https://github.com/chartjs/Chart.js/issues/2807
			console.error("Failed to create chart: can't acquire context from the given item");
			return;
		}

		me.initialize();
		me.update();
	},

	/**
	 * @private
	 */
	initialize: function() {
		var me = this;

		// Before init plugin notification
		core_plugins.notify(me, 'beforeInit');

		helpers$1.retinaScale(me, me.options.devicePixelRatio);

		me.bindEvents();

		if (me.options.responsive) {
			// Initial resize before chart draws (must be silent to preserve initial animations).
			me.resize(true);
		}

		me.initToolTip();

		// After init plugin notification
		core_plugins.notify(me, 'afterInit');

		return me;
	},

	clear: function() {
		helpers$1.canvas.clear(this);
		return this;
	},

	stop: function() {
		// Stops any current animation loop occurring
		core_animations.cancelAnimation(this);
		return this;
	},

	resize: function(silent) {
		var me = this;
		var options = me.options;
		var canvas = me.canvas;
		var aspectRatio = (options.maintainAspectRatio && me.aspectRatio) || null;

		// the canvas render width and height will be casted to integers so make sure that
		// the canvas display style uses the same integer values to avoid blurring effect.

		// Set to 0 instead of canvas.size because the size defaults to 300x150 if the element is collapsed
		var newWidth = Math.max(0, Math.floor(helpers$1.getMaximumWidth(canvas)));
		var newHeight = Math.max(0, Math.floor(aspectRatio ? newWidth / aspectRatio : helpers$1.getMaximumHeight(canvas)));

		if (me.width === newWidth && me.height === newHeight) {
			return;
		}

		canvas.width = me.width = newWidth;
		canvas.height = me.height = newHeight;
		canvas.style.width = newWidth + 'px';
		canvas.style.height = newHeight + 'px';

		helpers$1.retinaScale(me, options.devicePixelRatio);

		if (!silent) {
			// Notify any plugins about the resize
			var newSize = {width: newWidth, height: newHeight};
			core_plugins.notify(me, 'resize', [newSize]);

			// Notify of resize
			if (options.onResize) {
				options.onResize(me, newSize);
			}

			me.stop();
			me.update({
				duration: options.responsiveAnimationDuration
			});
		}
	},

	ensureScalesHaveIDs: function() {
		var options = this.options;
		var scalesOptions = options.scales || {};
		var scaleOptions = options.scale;

		helpers$1.each(scalesOptions.xAxes, function(xAxisOptions, index) {
			if (!xAxisOptions.id) {
				xAxisOptions.id = nextAvailableScaleId(scalesOptions.xAxes, 'x-axis-', index);
			}
		});

		helpers$1.each(scalesOptions.yAxes, function(yAxisOptions, index) {
			if (!yAxisOptions.id) {
				yAxisOptions.id = nextAvailableScaleId(scalesOptions.yAxes, 'y-axis-', index);
			}
		});

		if (scaleOptions) {
			scaleOptions.id = scaleOptions.id || 'scale';
		}
	},

	/**
	 * Builds a map of scale ID to scale object for future lookup.
	 */
	buildOrUpdateScales: function() {
		var me = this;
		var options = me.options;
		var scales = me.scales || {};
		var items = [];
		var updated = Object.keys(scales).reduce(function(obj, id) {
			obj[id] = false;
			return obj;
		}, {});

		if (options.scales) {
			items = items.concat(
				(options.scales.xAxes || []).map(function(xAxisOptions) {
					return {options: xAxisOptions, dtype: 'category', dposition: 'bottom'};
				}),
				(options.scales.yAxes || []).map(function(yAxisOptions) {
					return {options: yAxisOptions, dtype: 'linear', dposition: 'left'};
				})
			);
		}

		if (options.scale) {
			items.push({
				options: options.scale,
				dtype: 'radialLinear',
				isDefault: true,
				dposition: 'chartArea'
			});
		}

		helpers$1.each(items, function(item) {
			var scaleOptions = item.options;
			var id = scaleOptions.id;
			var scaleType = valueOrDefault$9(scaleOptions.type, item.dtype);

			if (positionIsHorizontal(scaleOptions.position) !== positionIsHorizontal(item.dposition)) {
				scaleOptions.position = item.dposition;
			}

			updated[id] = true;
			var scale = null;
			if (id in scales && scales[id].type === scaleType) {
				scale = scales[id];
				scale.options = scaleOptions;
				scale.ctx = me.ctx;
				scale.chart = me;
			} else {
				var scaleClass = core_scaleService.getScaleConstructor(scaleType);
				if (!scaleClass) {
					return;
				}
				scale = new scaleClass({
					id: id,
					type: scaleType,
					options: scaleOptions,
					ctx: me.ctx,
					chart: me
				});
				scales[scale.id] = scale;
			}

			scale.mergeTicksOptions();

			// TODO(SB): I think we should be able to remove this custom case (options.scale)
			// and consider it as a regular scale part of the "scales"" map only! This would
			// make the logic easier and remove some useless? custom code.
			if (item.isDefault) {
				me.scale = scale;
			}
		});
		// clear up discarded scales
		helpers$1.each(updated, function(hasUpdated, id) {
			if (!hasUpdated) {
				delete scales[id];
			}
		});

		me.scales = scales;

		core_scaleService.addScalesToLayout(this);
	},

	buildOrUpdateControllers: function() {
		var me = this;
		var newControllers = [];
		var datasets = me.data.datasets;
		var i, ilen;

		for (i = 0, ilen = datasets.length; i < ilen; i++) {
			var dataset = datasets[i];
			var meta = me.getDatasetMeta(i);
			var type = dataset.type || me.config.type;

			if (meta.type && meta.type !== type) {
				me.destroyDatasetMeta(i);
				meta = me.getDatasetMeta(i);
			}
			meta.type = type;
			meta.order = dataset.order || 0;
			meta.index = i;

			if (meta.controller) {
				meta.controller.updateIndex(i);
				meta.controller.linkScales();
			} else {
				var ControllerClass = controllers[meta.type];
				if (ControllerClass === undefined) {
					throw new Error('"' + meta.type + '" is not a chart type.');
				}

				meta.controller = new ControllerClass(me, i);
				newControllers.push(meta.controller);
			}
		}

		return newControllers;
	},

	/**
	 * Reset the elements of all datasets
	 * @private
	 */
	resetElements: function() {
		var me = this;
		helpers$1.each(me.data.datasets, function(dataset, datasetIndex) {
			me.getDatasetMeta(datasetIndex).controller.reset();
		}, me);
	},

	/**
	* Resets the chart back to it's state before the initial animation
	*/
	reset: function() {
		this.resetElements();
		this.tooltip.initialize();
	},

	update: function(config) {
		var me = this;
		var i, ilen;

		if (!config || typeof config !== 'object') {
			// backwards compatibility
			config = {
				duration: config,
				lazy: arguments[1]
			};
		}

		updateConfig(me);

		// plugins options references might have change, let's invalidate the cache
		// https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
		core_plugins._invalidate(me);

		if (core_plugins.notify(me, 'beforeUpdate') === false) {
			return;
		}

		// In case the entire data object changed
		me.tooltip._data = me.data;

		// Make sure dataset controllers are updated and new controllers are reset
		var newControllers = me.buildOrUpdateControllers();

		// Make sure all dataset controllers have correct meta data counts
		for (i = 0, ilen = me.data.datasets.length; i < ilen; i++) {
			me.getDatasetMeta(i).controller.buildOrUpdateElements();
		}

		me.updateLayout();

		// Can only reset the new controllers after the scales have been updated
		if (me.options.animation && me.options.animation.duration) {
			helpers$1.each(newControllers, function(controller) {
				controller.reset();
			});
		}

		me.updateDatasets();

		// Need to reset tooltip in case it is displayed with elements that are removed
		// after update.
		me.tooltip.initialize();

		// Last active contains items that were previously in the tooltip.
		// When we reset the tooltip, we need to clear it
		me.lastActive = [];

		// Do this before render so that any plugins that need final scale updates can use it
		core_plugins.notify(me, 'afterUpdate');

		me._layers.sort(compare2Level('z', '_idx'));

		if (me._bufferedRender) {
			me._bufferedRequest = {
				duration: config.duration,
				easing: config.easing,
				lazy: config.lazy
			};
		} else {
			me.render(config);
		}
	},

	/**
	 * Updates the chart layout unless a plugin returns `false` to the `beforeLayout`
	 * hook, in which case, plugins will not be called on `afterLayout`.
	 * @private
	 */
	updateLayout: function() {
		var me = this;

		if (core_plugins.notify(me, 'beforeLayout') === false) {
			return;
		}

		core_layouts.update(this, this.width, this.height);

		me._layers = [];
		helpers$1.each(me.boxes, function(box) {
			// _configure is called twice, once in core.scale.update and once here.
			// Here the boxes are fully updated and at their final positions.
			if (box._configure) {
				box._configure();
			}
			me._layers.push.apply(me._layers, box._layers());
		}, me);

		me._layers.forEach(function(item, index) {
			item._idx = index;
		});

		/**
		 * Provided for backward compatibility, use `afterLayout` instead.
		 * @method IPlugin#afterScaleUpdate
		 * @deprecated since version 2.5.0
		 * @todo remove at version 3
		 * @private
		 */
		core_plugins.notify(me, 'afterScaleUpdate');
		core_plugins.notify(me, 'afterLayout');
	},

	/**
	 * Updates all datasets unless a plugin returns `false` to the `beforeDatasetsUpdate`
	 * hook, in which case, plugins will not be called on `afterDatasetsUpdate`.
	 * @private
	 */
	updateDatasets: function() {
		var me = this;

		if (core_plugins.notify(me, 'beforeDatasetsUpdate') === false) {
			return;
		}

		for (var i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
			me.updateDataset(i);
		}

		core_plugins.notify(me, 'afterDatasetsUpdate');
	},

	/**
	 * Updates dataset at index unless a plugin returns `false` to the `beforeDatasetUpdate`
	 * hook, in which case, plugins will not be called on `afterDatasetUpdate`.
	 * @private
	 */
	updateDataset: function(index) {
		var me = this;
		var meta = me.getDatasetMeta(index);
		var args = {
			meta: meta,
			index: index
		};

		if (core_plugins.notify(me, 'beforeDatasetUpdate', [args]) === false) {
			return;
		}

		meta.controller._update();

		core_plugins.notify(me, 'afterDatasetUpdate', [args]);
	},

	render: function(config) {
		var me = this;

		if (!config || typeof config !== 'object') {
			// backwards compatibility
			config = {
				duration: config,
				lazy: arguments[1]
			};
		}

		var animationOptions = me.options.animation;
		var duration = valueOrDefault$9(config.duration, animationOptions && animationOptions.duration);
		var lazy = config.lazy;

		if (core_plugins.notify(me, 'beforeRender') === false) {
			return;
		}

		var onComplete = function(animation) {
			core_plugins.notify(me, 'afterRender');
			helpers$1.callback(animationOptions && animationOptions.onComplete, [animation], me);
		};

		if (animationOptions && duration) {
			var animation = new core_animation({
				numSteps: duration / 16.66, // 60 fps
				easing: config.easing || animationOptions.easing,

				render: function(chart, animationObject) {
					var easingFunction = helpers$1.easing.effects[animationObject.easing];
					var currentStep = animationObject.currentStep;
					var stepDecimal = currentStep / animationObject.numSteps;

					chart.draw(easingFunction(stepDecimal), stepDecimal, currentStep);
				},

				onAnimationProgress: animationOptions.onProgress,
				onAnimationComplete: onComplete
			});

			core_animations.addAnimation(me, animation, duration, lazy);
		} else {
			me.draw();

			// See https://github.com/chartjs/Chart.js/issues/3781
			onComplete(new core_animation({numSteps: 0, chart: me}));
		}

		return me;
	},

	draw: function(easingValue) {
		var me = this;
		var i, layers;

		me.clear();

		if (helpers$1.isNullOrUndef(easingValue)) {
			easingValue = 1;
		}

		me.transition(easingValue);

		if (me.width <= 0 || me.height <= 0) {
			return;
		}

		if (core_plugins.notify(me, 'beforeDraw', [easingValue]) === false) {
			return;
		}

		// Because of plugin hooks (before/afterDatasetsDraw), datasets can't
		// currently be part of layers. Instead, we draw
		// layers <= 0 before(default, backward compat), and the rest after
		layers = me._layers;
		for (i = 0; i < layers.length && layers[i].z <= 0; ++i) {
			layers[i].draw(me.chartArea);
		}

		me.drawDatasets(easingValue);

		// Rest of layers
		for (; i < layers.length; ++i) {
			layers[i].draw(me.chartArea);
		}

		me._drawTooltip(easingValue);

		core_plugins.notify(me, 'afterDraw', [easingValue]);
	},

	/**
	 * @private
	 */
	transition: function(easingValue) {
		var me = this;

		for (var i = 0, ilen = (me.data.datasets || []).length; i < ilen; ++i) {
			if (me.isDatasetVisible(i)) {
				me.getDatasetMeta(i).controller.transition(easingValue);
			}
		}

		me.tooltip.transition(easingValue);
	},

	/**
	 * @private
	 */
	_getSortedDatasetMetas: function(filterVisible) {
		var me = this;
		var datasets = me.data.datasets || [];
		var result = [];
		var i, ilen;

		for (i = 0, ilen = datasets.length; i < ilen; ++i) {
			if (!filterVisible || me.isDatasetVisible(i)) {
				result.push(me.getDatasetMeta(i));
			}
		}

		result.sort(compare2Level('order', 'index'));

		return result;
	},

	/**
	 * @private
	 */
	_getSortedVisibleDatasetMetas: function() {
		return this._getSortedDatasetMetas(true);
	},

	/**
	 * Draws all datasets unless a plugin returns `false` to the `beforeDatasetsDraw`
	 * hook, in which case, plugins will not be called on `afterDatasetsDraw`.
	 * @private
	 */
	drawDatasets: function(easingValue) {
		var me = this;
		var metasets, i;

		if (core_plugins.notify(me, 'beforeDatasetsDraw', [easingValue]) === false) {
			return;
		}

		metasets = me._getSortedVisibleDatasetMetas();
		for (i = metasets.length - 1; i >= 0; --i) {
			me.drawDataset(metasets[i], easingValue);
		}

		core_plugins.notify(me, 'afterDatasetsDraw', [easingValue]);
	},

	/**
	 * Draws dataset at index unless a plugin returns `false` to the `beforeDatasetDraw`
	 * hook, in which case, plugins will not be called on `afterDatasetDraw`.
	 * @private
	 */
	drawDataset: function(meta, easingValue) {
		var me = this;
		var args = {
			meta: meta,
			index: meta.index,
			easingValue: easingValue
		};

		if (core_plugins.notify(me, 'beforeDatasetDraw', [args]) === false) {
			return;
		}

		meta.controller.draw(easingValue);

		core_plugins.notify(me, 'afterDatasetDraw', [args]);
	},

	/**
	 * Draws tooltip unless a plugin returns `false` to the `beforeTooltipDraw`
	 * hook, in which case, plugins will not be called on `afterTooltipDraw`.
	 * @private
	 */
	_drawTooltip: function(easingValue) {
		var me = this;
		var tooltip = me.tooltip;
		var args = {
			tooltip: tooltip,
			easingValue: easingValue
		};

		if (core_plugins.notify(me, 'beforeTooltipDraw', [args]) === false) {
			return;
		}

		tooltip.draw();

		core_plugins.notify(me, 'afterTooltipDraw', [args]);
	},

	/**
	 * Get the single element that was clicked on
	 * @return An object containing the dataset index and element index of the matching element. Also contains the rectangle that was draw
	 */
	getElementAtEvent: function(e) {
		return core_interaction.modes.single(this, e);
	},

	getElementsAtEvent: function(e) {
		return core_interaction.modes.label(this, e, {intersect: true});
	},

	getElementsAtXAxis: function(e) {
		return core_interaction.modes['x-axis'](this, e, {intersect: true});
	},

	getElementsAtEventForMode: function(e, mode, options) {
		var method = core_interaction.modes[mode];
		if (typeof method === 'function') {
			return method(this, e, options);
		}

		return [];
	},

	getDatasetAtEvent: function(e) {
		return core_interaction.modes.dataset(this, e, {intersect: true});
	},

	getDatasetMeta: function(datasetIndex) {
		var me = this;
		var dataset = me.data.datasets[datasetIndex];
		if (!dataset._meta) {
			dataset._meta = {};
		}

		var meta = dataset._meta[me.id];
		if (!meta) {
			meta = dataset._meta[me.id] = {
				type: null,
				data: [],
				dataset: null,
				controller: null,
				hidden: null,			// See isDatasetVisible() comment
				xAxisID: null,
				yAxisID: null,
				order: dataset.order || 0,
				index: datasetIndex
			};
		}

		return meta;
	},

	getVisibleDatasetCount: function() {
		var count = 0;
		for (var i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
			if (this.isDatasetVisible(i)) {
				count++;
			}
		}
		return count;
	},

	isDatasetVisible: function(datasetIndex) {
		var meta = this.getDatasetMeta(datasetIndex);

		// meta.hidden is a per chart dataset hidden flag override with 3 states: if true or false,
		// the dataset.hidden value is ignored, else if null, the dataset hidden state is returned.
		return typeof meta.hidden === 'boolean' ? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
	},

	generateLegend: function() {
		return this.options.legendCallback(this);
	},

	/**
	 * @private
	 */
	destroyDatasetMeta: function(datasetIndex) {
		var id = this.id;
		var dataset = this.data.datasets[datasetIndex];
		var meta = dataset._meta && dataset._meta[id];

		if (meta) {
			meta.controller.destroy();
			delete dataset._meta[id];
		}
	},

	destroy: function() {
		var me = this;
		var canvas = me.canvas;
		var i, ilen;

		me.stop();

		// dataset controllers need to cleanup associated data
		for (i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
			me.destroyDatasetMeta(i);
		}

		if (canvas) {
			me.unbindEvents();
			helpers$1.canvas.clear(me);
			platform.releaseContext(me.ctx);
			me.canvas = null;
			me.ctx = null;
		}

		core_plugins.notify(me, 'destroy');

		delete Chart.instances[me.id];
	},

	toBase64Image: function() {
		return this.canvas.toDataURL.apply(this.canvas, arguments);
	},

	initToolTip: function() {
		var me = this;
		me.tooltip = new core_tooltip({
			_chart: me,
			_chartInstance: me, // deprecated, backward compatibility
			_data: me.data,
			_options: me.options.tooltips
		}, me);
	},

	/**
	 * @private
	 */
	bindEvents: function() {
		var me = this;
		var listeners = me._listeners = {};
		var listener = function() {
			me.eventHandler.apply(me, arguments);
		};

		helpers$1.each(me.options.events, function(type) {
			platform.addEventListener(me, type, listener);
			listeners[type] = listener;
		});

		// Elements used to detect size change should not be injected for non responsive charts.
		// See https://github.com/chartjs/Chart.js/issues/2210
		if (me.options.responsive) {
			listener = function() {
				me.resize();
			};

			platform.addEventListener(me, 'resize', listener);
			listeners.resize = listener;
		}
	},

	/**
	 * @private
	 */
	unbindEvents: function() {
		var me = this;
		var listeners = me._listeners;
		if (!listeners) {
			return;
		}

		delete me._listeners;
		helpers$1.each(listeners, function(listener, type) {
			platform.removeEventListener(me, type, listener);
		});
	},

	updateHoverStyle: function(elements, mode, enabled) {
		var prefix = enabled ? 'set' : 'remove';
		var element, i, ilen;

		for (i = 0, ilen = elements.length; i < ilen; ++i) {
			element = elements[i];
			if (element) {
				this.getDatasetMeta(element._datasetIndex).controller[prefix + 'HoverStyle'](element);
			}
		}

		if (mode === 'dataset') {
			this.getDatasetMeta(elements[0]._datasetIndex).controller['_' + prefix + 'DatasetHoverStyle']();
		}
	},

	/**
	 * @private
	 */
	eventHandler: function(e) {
		var me = this;
		var tooltip = me.tooltip;

		if (core_plugins.notify(me, 'beforeEvent', [e]) === false) {
			return;
		}

		// Buffer any update calls so that renders do not occur
		me._bufferedRender = true;
		me._bufferedRequest = null;

		var changed = me.handleEvent(e);
		// for smooth tooltip animations issue #4989
		// the tooltip should be the source of change
		// Animation check workaround:
		// tooltip._start will be null when tooltip isn't animating
		if (tooltip) {
			changed = tooltip._start
				? tooltip.handleEvent(e)
				: changed | tooltip.handleEvent(e);
		}

		core_plugins.notify(me, 'afterEvent', [e]);

		var bufferedRequest = me._bufferedRequest;
		if (bufferedRequest) {
			// If we have an update that was triggered, we need to do a normal render
			me.render(bufferedRequest);
		} else if (changed && !me.animating) {
			// If entering, leaving, or changing elements, animate the change via pivot
			me.stop();

			// We only need to render at this point. Updating will cause scales to be
			// recomputed generating flicker & using more memory than necessary.
			me.render({
				duration: me.options.hover.animationDuration,
				lazy: true
			});
		}

		me._bufferedRender = false;
		me._bufferedRequest = null;

		return me;
	},

	/**
	 * Handle an event
	 * @private
	 * @param {IEvent} event the event to handle
	 * @return {boolean} true if the chart needs to re-render
	 */
	handleEvent: function(e) {
		var me = this;
		var options = me.options || {};
		var hoverOptions = options.hover;
		var changed = false;

		me.lastActive = me.lastActive || [];

		// Find Active Elements for hover and tooltips
		if (e.type === 'mouseout') {
			me.active = [];
		} else {
			me.active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions);
		}

		// Invoke onHover hook
		// Need to call with native event here to not break backwards compatibility
		helpers$1.callback(options.onHover || options.hover.onHover, [e.native, me.active], me);

		if (e.type === 'mouseup' || e.type === 'click') {
			if (options.onClick) {
				// Use e.native here for backwards compatibility
				options.onClick.call(me, e.native, me.active);
			}
		}

		// Remove styling for last active (even if it may still be active)
		if (me.lastActive.length) {
			me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
		}

		// Built in hover styling
		if (me.active.length && hoverOptions.mode) {
			me.updateHoverStyle(me.active, hoverOptions.mode, true);
		}

		changed = !helpers$1.arrayEquals(me.active, me.lastActive);

		// Remember Last Actives
		me.lastActive = me.active;

		return changed;
	}
});

/**
 * NOTE(SB) We actually don't use this container anymore but we need to keep it
 * for backward compatibility. Though, it can still be useful for plugins that
 * would need to work on multiple charts?!
 */
Chart.instances = {};

var core_controller = Chart;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart instead.
 * @class Chart.Controller
 * @deprecated since version 2.6
 * @todo remove at version 3
 * @private
 */
Chart.Controller = Chart;

/**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart
 * @deprecated since version 2.8
 * @todo remove at version 3
 * @private
 */
Chart.types = {};

/**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.helpers.configMerge
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */
helpers$1.configMerge = mergeConfig;

/**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.helpers.scaleMerge
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */
helpers$1.scaleMerge = mergeScaleConfig;

var core_helpers = function() {

	// -- Basic js utility methods

	helpers$1.where = function(collection, filterCallback) {
		if (helpers$1.isArray(collection) && Array.prototype.filter) {
			return collection.filter(filterCallback);
		}
		var filtered = [];

		helpers$1.each(collection, function(item) {
			if (filterCallback(item)) {
				filtered.push(item);
			}
		});

		return filtered;
	};
	helpers$1.findIndex = Array.prototype.findIndex ?
		function(array, callback, scope) {
			return array.findIndex(callback, scope);
		} :
		function(array, callback, scope) {
			scope = scope === undefined ? array : scope;
			for (var i = 0, ilen = array.length; i < ilen; ++i) {
				if (callback.call(scope, array[i], i, array)) {
					return i;
				}
			}
			return -1;
		};
	helpers$1.findNextWhere = function(arrayToSearch, filterCallback, startIndex) {
		// Default to start of the array
		if (helpers$1.isNullOrUndef(startIndex)) {
			startIndex = -1;
		}
		for (var i = startIndex + 1; i < arrayToSearch.length; i++) {
			var currentItem = arrayToSearch[i];
			if (filterCallback(currentItem)) {
				return currentItem;
			}
		}
	};
	helpers$1.findPreviousWhere = function(arrayToSearch, filterCallback, startIndex) {
		// Default to end of the array
		if (helpers$1.isNullOrUndef(startIndex)) {
			startIndex = arrayToSearch.length;
		}
		for (var i = startIndex - 1; i >= 0; i--) {
			var currentItem = arrayToSearch[i];
			if (filterCallback(currentItem)) {
				return currentItem;
			}
		}
	};

	// -- Math methods
	helpers$1.isNumber = function(n) {
		return !isNaN(parseFloat(n)) && isFinite(n);
	};
	helpers$1.almostEquals = function(x, y, epsilon) {
		return Math.abs(x - y) < epsilon;
	};
	helpers$1.almostWhole = function(x, epsilon) {
		var rounded = Math.round(x);
		return ((rounded - epsilon) <= x) && ((rounded + epsilon) >= x);
	};
	helpers$1.max = function(array) {
		return array.reduce(function(max, value) {
			if (!isNaN(value)) {
				return Math.max(max, value);
			}
			return max;
		}, Number.NEGATIVE_INFINITY);
	};
	helpers$1.min = function(array) {
		return array.reduce(function(min, value) {
			if (!isNaN(value)) {
				return Math.min(min, value);
			}
			return min;
		}, Number.POSITIVE_INFINITY);
	};
	helpers$1.sign = Math.sign ?
		function(x) {
			return Math.sign(x);
		} :
		function(x) {
			x = +x; // convert to a number
			if (x === 0 || isNaN(x)) {
				return x;
			}
			return x > 0 ? 1 : -1;
		};
	helpers$1.toRadians = function(degrees) {
		return degrees * (Math.PI / 180);
	};
	helpers$1.toDegrees = function(radians) {
		return radians * (180 / Math.PI);
	};

	/**
	 * Returns the number of decimal places
	 * i.e. the number of digits after the decimal point, of the value of this Number.
	 * @param {number} x - A number.
	 * @returns {number} The number of decimal places.
	 * @private
	 */
	helpers$1._decimalPlaces = function(x) {
		if (!helpers$1.isFinite(x)) {
			return;
		}
		var e = 1;
		var p = 0;
		while (Math.round(x * e) / e !== x) {
			e *= 10;
			p++;
		}
		return p;
	};

	// Gets the angle from vertical upright to the point about a centre.
	helpers$1.getAngleFromPoint = function(centrePoint, anglePoint) {
		var distanceFromXCenter = anglePoint.x - centrePoint.x;
		var distanceFromYCenter = anglePoint.y - centrePoint.y;
		var radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);

		var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);

		if (angle < (-0.5 * Math.PI)) {
			angle += 2.0 * Math.PI; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
		}

		return {
			angle: angle,
			distance: radialDistanceFromCenter
		};
	};
	helpers$1.distanceBetweenPoints = function(pt1, pt2) {
		return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
	};

	/**
	 * Provided for backward compatibility, not available anymore
	 * @function Chart.helpers.aliasPixel
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 */
	helpers$1.aliasPixel = function(pixelWidth) {
		return (pixelWidth % 2 === 0) ? 0 : 0.5;
	};

	/**
	 * Returns the aligned pixel value to avoid anti-aliasing blur
	 * @param {Chart} chart - The chart instance.
	 * @param {number} pixel - A pixel value.
	 * @param {number} width - The width of the element.
	 * @returns {number} The aligned pixel value.
	 * @private
	 */
	helpers$1._alignPixel = function(chart, pixel, width) {
		var devicePixelRatio = chart.currentDevicePixelRatio;
		var halfWidth = width / 2;
		return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
	};

	helpers$1.splineCurve = function(firstPoint, middlePoint, afterPoint, t) {
		// Props to Rob Spencer at scaled innovation for his post on splining between points
		// http://scaledinnovation.com/analytics/splines/aboutSplines.html

		// This function must also respect "skipped" points

		var previous = firstPoint.skip ? middlePoint : firstPoint;
		var current = middlePoint;
		var next = afterPoint.skip ? middlePoint : afterPoint;

		var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
		var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));

		var s01 = d01 / (d01 + d12);
		var s12 = d12 / (d01 + d12);

		// If all points are the same, s01 & s02 will be inf
		s01 = isNaN(s01) ? 0 : s01;
		s12 = isNaN(s12) ? 0 : s12;

		var fa = t * s01; // scaling factor for triangle Ta
		var fb = t * s12;

		return {
			previous: {
				x: current.x - fa * (next.x - previous.x),
				y: current.y - fa * (next.y - previous.y)
			},
			next: {
				x: current.x + fb * (next.x - previous.x),
				y: current.y + fb * (next.y - previous.y)
			}
		};
	};
	helpers$1.EPSILON = Number.EPSILON || 1e-14;
	helpers$1.splineCurveMonotone = function(points) {
		// This function calculates Bézier control points in a similar way than |splineCurve|,
		// but preserves monotonicity of the provided data and ensures no local extremums are added
		// between the dataset discrete points due to the interpolation.
		// See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation

		var pointsWithTangents = (points || []).map(function(point) {
			return {
				model: point._model,
				deltaK: 0,
				mK: 0
			};
		});

		// Calculate slopes (deltaK) and initialize tangents (mK)
		var pointsLen = pointsWithTangents.length;
		var i, pointBefore, pointCurrent, pointAfter;
		for (i = 0; i < pointsLen; ++i) {
			pointCurrent = pointsWithTangents[i];
			if (pointCurrent.model.skip) {
				continue;
			}

			pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
			pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
			if (pointAfter && !pointAfter.model.skip) {
				var slopeDeltaX = (pointAfter.model.x - pointCurrent.model.x);

				// In the case of two points that appear at the same x pixel, slopeDeltaX is 0
				pointCurrent.deltaK = slopeDeltaX !== 0 ? (pointAfter.model.y - pointCurrent.model.y) / slopeDeltaX : 0;
			}

			if (!pointBefore || pointBefore.model.skip) {
				pointCurrent.mK = pointCurrent.deltaK;
			} else if (!pointAfter || pointAfter.model.skip) {
				pointCurrent.mK = pointBefore.deltaK;
			} else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) {
				pointCurrent.mK = 0;
			} else {
				pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
			}
		}

		// Adjust tangents to ensure monotonic properties
		var alphaK, betaK, tauK, squaredMagnitude;
		for (i = 0; i < pointsLen - 1; ++i) {
			pointCurrent = pointsWithTangents[i];
			pointAfter = pointsWithTangents[i + 1];
			if (pointCurrent.model.skip || pointAfter.model.skip) {
				continue;
			}

			if (helpers$1.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
				pointCurrent.mK = pointAfter.mK = 0;
				continue;
			}

			alphaK = pointCurrent.mK / pointCurrent.deltaK;
			betaK = pointAfter.mK / pointCurrent.deltaK;
			squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
			if (squaredMagnitude <= 9) {
				continue;
			}

			tauK = 3 / Math.sqrt(squaredMagnitude);
			pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
			pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
		}

		// Compute control points
		var deltaX;
		for (i = 0; i < pointsLen; ++i) {
			pointCurrent = pointsWithTangents[i];
			if (pointCurrent.model.skip) {
				continue;
			}

			pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
			pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
			if (pointBefore && !pointBefore.model.skip) {
				deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
				pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
				pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
			}
			if (pointAfter && !pointAfter.model.skip) {
				deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
				pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
				pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
			}
		}
	};
	helpers$1.nextItem = function(collection, index, loop) {
		if (loop) {
			return index >= collection.length - 1 ? collection[0] : collection[index + 1];
		}
		return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
	};
	helpers$1.previousItem = function(collection, index, loop) {
		if (loop) {
			return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
		}
		return index <= 0 ? collection[0] : collection[index - 1];
	};
	// Implementation of the nice number algorithm used in determining where axis labels will go
	helpers$1.niceNum = function(range, round) {
		var exponent = Math.floor(helpers$1.log10(range));
		var fraction = range / Math.pow(10, exponent);
		var niceFraction;

		if (round) {
			if (fraction < 1.5) {
				niceFraction = 1;
			} else if (fraction < 3) {
				niceFraction = 2;
			} else if (fraction < 7) {
				niceFraction = 5;
			} else {
				niceFraction = 10;
			}
		} else if (fraction <= 1.0) {
			niceFraction = 1;
		} else if (fraction <= 2) {
			niceFraction = 2;
		} else if (fraction <= 5) {
			niceFraction = 5;
		} else {
			niceFraction = 10;
		}

		return niceFraction * Math.pow(10, exponent);
	};
	// Request animation polyfill - https://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
	helpers$1.requestAnimFrame = (function() {
		if (typeof window === 'undefined') {
			return function(callback) {
				callback();
			};
		}
		return window.requestAnimationFrame ||
			window.webkitRequestAnimationFrame ||
			window.mozRequestAnimationFrame ||
			window.oRequestAnimationFrame ||
			window.msRequestAnimationFrame ||
			function(callback) {
				return window.setTimeout(callback, 1000 / 60);
			};
	}());
	// -- DOM methods
	helpers$1.getRelativePosition = function(evt, chart) {
		var mouseX, mouseY;
		var e = evt.originalEvent || evt;
		var canvas = evt.target || evt.srcElement;
		var boundingRect = canvas.getBoundingClientRect();

		var touches = e.touches;
		if (touches && touches.length > 0) {
			mouseX = touches[0].clientX;
			mouseY = touches[0].clientY;

		} else {
			mouseX = e.clientX;
			mouseY = e.clientY;
		}

		// Scale mouse coordinates into canvas coordinates
		// by following the pattern laid out by 'jerryj' in the comments of
		// https://www.html5canvastutorials.com/advanced/html5-canvas-mouse-coordinates/
		var paddingLeft = parseFloat(helpers$1.getStyle(canvas, 'padding-left'));
		var paddingTop = parseFloat(helpers$1.getStyle(canvas, 'padding-top'));
		var paddingRight = parseFloat(helpers$1.getStyle(canvas, 'padding-right'));
		var paddingBottom = parseFloat(helpers$1.getStyle(canvas, 'padding-bottom'));
		var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
		var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;

		// We divide by the current device pixel ratio, because the canvas is scaled up by that amount in each direction. However
		// the backend model is in unscaled coordinates. Since we are going to deal with our model coordinates, we go back here
		mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / (width) * canvas.width / chart.currentDevicePixelRatio);
		mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / (height) * canvas.height / chart.currentDevicePixelRatio);

		return {
			x: mouseX,
			y: mouseY
		};

	};

	// Private helper function to convert max-width/max-height values that may be percentages into a number
	function parseMaxStyle(styleValue, node, parentProperty) {
		var valueInPixels;
		if (typeof styleValue === 'string') {
			valueInPixels = parseInt(styleValue, 10);

			if (styleValue.indexOf('%') !== -1) {
				// percentage * size in dimension
				valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
			}
		} else {
			valueInPixels = styleValue;
		}

		return valueInPixels;
	}

	/**
	 * Returns if the given value contains an effective constraint.
	 * @private
	 */
	function isConstrainedValue(value) {
		return value !== undefined && value !== null && value !== 'none';
	}

	/**
	 * Returns the max width or height of the given DOM node in a cross-browser compatible fashion
	 * @param {HTMLElement} domNode - the node to check the constraint on
	 * @param {string} maxStyle - the style that defines the maximum for the direction we are using ('max-width' / 'max-height')
	 * @param {string} percentageProperty - property of parent to use when calculating width as a percentage
	 * @see {@link https://www.nathanaeljones.com/blog/2013/reading-max-width-cross-browser}
	 */
	function getConstraintDimension(domNode, maxStyle, percentageProperty) {
		var view = document.defaultView;
		var parentNode = helpers$1._getParentNode(domNode);
		var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
		var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
		var hasCNode = isConstrainedValue(constrainedNode);
		var hasCContainer = isConstrainedValue(constrainedContainer);
		var infinity = Number.POSITIVE_INFINITY;

		if (hasCNode || hasCContainer) {
			return Math.min(
				hasCNode ? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity,
				hasCContainer ? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
		}

		return 'none';
	}
	// returns Number or undefined if no constraint
	helpers$1.getConstraintWidth = function(domNode) {
		return getConstraintDimension(domNode, 'max-width', 'clientWidth');
	};
	// returns Number or undefined if no constraint
	helpers$1.getConstraintHeight = function(domNode) {
		return getConstraintDimension(domNode, 'max-height', 'clientHeight');
	};
	/**
	 * @private
 	 */
	helpers$1._calculatePadding = function(container, padding, parentDimension) {
		padding = helpers$1.getStyle(container, padding);

		return padding.indexOf('%') > -1 ? parentDimension * parseInt(padding, 10) / 100 : parseInt(padding, 10);
	};
	/**
	 * @private
	 */
	helpers$1._getParentNode = function(domNode) {
		var parent = domNode.parentNode;
		if (parent && parent.toString() === '[object ShadowRoot]') {
			parent = parent.host;
		}
		return parent;
	};
	helpers$1.getMaximumWidth = function(domNode) {
		var container = helpers$1._getParentNode(domNode);
		if (!container) {
			return domNode.clientWidth;
		}

		var clientWidth = container.clientWidth;
		var paddingLeft = helpers$1._calculatePadding(container, 'padding-left', clientWidth);
		var paddingRight = helpers$1._calculatePadding(container, 'padding-right', clientWidth);

		var w = clientWidth - paddingLeft - paddingRight;
		var cw = helpers$1.getConstraintWidth(domNode);
		return isNaN(cw) ? w : Math.min(w, cw);
	};
	helpers$1.getMaximumHeight = function(domNode) {
		var container = helpers$1._getParentNode(domNode);
		if (!container) {
			return domNode.clientHeight;
		}

		var clientHeight = container.clientHeight;
		var paddingTop = helpers$1._calculatePadding(container, 'padding-top', clientHeight);
		var paddingBottom = helpers$1._calculatePadding(container, 'padding-bottom', clientHeight);

		var h = clientHeight - paddingTop - paddingBottom;
		var ch = helpers$1.getConstraintHeight(domNode);
		return isNaN(ch) ? h : Math.min(h, ch);
	};
	helpers$1.getStyle = function(el, property) {
		return el.currentStyle ?
			el.currentStyle[property] :
			document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
	};
	helpers$1.retinaScale = function(chart, forceRatio) {
		var pixelRatio = chart.currentDevicePixelRatio = forceRatio || (typeof window !== 'undefined' && window.devicePixelRatio) || 1;
		if (pixelRatio === 1) {
			return;
		}

		var canvas = chart.canvas;
		var height = chart.height;
		var width = chart.width;

		canvas.height = height * pixelRatio;
		canvas.width = width * pixelRatio;
		chart.ctx.scale(pixelRatio, pixelRatio);

		// If no style has been set on the canvas, the render size is used as display size,
		// making the chart visually bigger, so let's enforce it to the "correct" values.
		// See https://github.com/chartjs/Chart.js/issues/3575
		if (!canvas.style.height && !canvas.style.width) {
			canvas.style.height = height + 'px';
			canvas.style.width = width + 'px';
		}
	};
	// -- Canvas methods
	helpers$1.fontString = function(pixelSize, fontStyle, fontFamily) {
		return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
	};
	helpers$1.longestText = function(ctx, font, arrayOfThings, cache) {
		cache = cache || {};
		var data = cache.data = cache.data || {};
		var gc = cache.garbageCollect = cache.garbageCollect || [];

		if (cache.font !== font) {
			data = cache.data = {};
			gc = cache.garbageCollect = [];
			cache.font = font;
		}

		ctx.font = font;
		var longest = 0;
		var ilen = arrayOfThings.length;
		var i, j, jlen, thing, nestedThing;
		for (i = 0; i < ilen; i++) {
			thing = arrayOfThings[i];

			// Undefined strings and arrays should not be measured
			if (thing !== undefined && thing !== null && helpers$1.isArray(thing) !== true) {
				longest = helpers$1.measureText(ctx, data, gc, longest, thing);
			} else if (helpers$1.isArray(thing)) {
				// if it is an array lets measure each element
				// to do maybe simplify this function a bit so we can do this more recursively?
				for (j = 0, jlen = thing.length; j < jlen; j++) {
					nestedThing = thing[j];
					// Undefined strings and arrays should not be measured
					if (nestedThing !== undefined && nestedThing !== null && !helpers$1.isArray(nestedThing)) {
						longest = helpers$1.measureText(ctx, data, gc, longest, nestedThing);
					}
				}
			}
		}

		var gcLen = gc.length / 2;
		if (gcLen > arrayOfThings.length) {
			for (i = 0; i < gcLen; i++) {
				delete data[gc[i]];
			}
			gc.splice(0, gcLen);
		}
		return longest;
	};
	helpers$1.measureText = function(ctx, data, gc, longest, string) {
		var textWidth = data[string];
		if (!textWidth) {
			textWidth = data[string] = ctx.measureText(string).width;
			gc.push(string);
		}
		if (textWidth > longest) {
			longest = textWidth;
		}
		return longest;
	};

	/**
	 * @deprecated
	 */
	helpers$1.numberOfLabelLines = function(arrayOfThings) {
		var numberOfLines = 1;
		helpers$1.each(arrayOfThings, function(thing) {
			if (helpers$1.isArray(thing)) {
				if (thing.length > numberOfLines) {
					numberOfLines = thing.length;
				}
			}
		});
		return numberOfLines;
	};

	helpers$1.color = !chartjsColor ?
		function(value) {
			console.error('Color.js not found!');
			return value;
		} :
		function(value) {
			/* global CanvasGradient */
			if (value instanceof CanvasGradient) {
				value = core_defaults.global.defaultColor;
			}

			return chartjsColor(value);
		};

	helpers$1.getHoverColor = function(colorValue) {
		/* global CanvasPattern */
		return (colorValue instanceof CanvasPattern || colorValue instanceof CanvasGradient) ?
			colorValue :
			helpers$1.color(colorValue).saturate(0.5).darken(0.1).rgbString();
	};
};

function abstract() {
	throw new Error(
		'This method is not implemented: either no adapter can ' +
		'be found or an incomplete integration was provided.'
	);
}

/**
 * Date adapter (current used by the time scale)
 * @namespace Chart._adapters._date
 * @memberof Chart._adapters
 * @private
 */

/**
 * Currently supported unit string values.
 * @typedef {('millisecond'|'second'|'minute'|'hour'|'day'|'week'|'month'|'quarter'|'year')}
 * @memberof Chart._adapters._date
 * @name Unit
 */

/**
 * @class
 */
function DateAdapter(options) {
	this.options = options || {};
}

helpers$1.extend(DateAdapter.prototype, /** @lends DateAdapter */ {
	/**
	 * Returns a map of time formats for the supported formatting units defined
	 * in Unit as well as 'datetime' representing a detailed date/time string.
	 * @returns {{string: string}}
	 */
	formats: abstract,

	/**
	 * Parses the given `value` and return the associated timestamp.
	 * @param {any} value - the value to parse (usually comes from the data)
	 * @param {string} [format] - the expected data format
	 * @returns {(number|null)}
	 * @function
	 */
	parse: abstract,

	/**
	 * Returns the formatted date in the specified `format` for a given `timestamp`.
	 * @param {number} timestamp - the timestamp to format
	 * @param {string} format - the date/time token
	 * @return {string}
	 * @function
	 */
	format: abstract,

	/**
	 * Adds the specified `amount` of `unit` to the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {number} amount - the amount to add
	 * @param {Unit} unit - the unit as string
	 * @return {number}
	 * @function
	 */
	add: abstract,

	/**
	 * Returns the number of `unit` between the given timestamps.
	 * @param {number} max - the input timestamp (reference)
	 * @param {number} min - the timestamp to substract
	 * @param {Unit} unit - the unit as string
	 * @return {number}
	 * @function
	 */
	diff: abstract,

	/**
	 * Returns start of `unit` for the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {Unit} unit - the unit as string
	 * @param {number} [weekday] - the ISO day of the week with 1 being Monday
	 * and 7 being Sunday (only needed if param *unit* is `isoWeek`).
	 * @function
	 */
	startOf: abstract,

	/**
	 * Returns end of `unit` for the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {Unit} unit - the unit as string
	 * @function
	 */
	endOf: abstract,

	// DEPRECATIONS

	/**
	 * Provided for backward compatibility for scale.getValueForPixel(),
	 * this method should be overridden only by the moment adapter.
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */
	_create: function(value) {
		return value;
	}
});

DateAdapter.override = function(members) {
	helpers$1.extend(DateAdapter.prototype, members);
};

var _date = DateAdapter;

var core_adapters = {
	_date: _date
};

/**
 * Namespace to hold static tick generation functions
 * @namespace Chart.Ticks
 */
var core_ticks = {
	/**
	 * Namespace to hold formatters for different types of ticks
	 * @namespace Chart.Ticks.formatters
	 */
	formatters: {
		/**
		 * Formatter for value labels
		 * @method Chart.Ticks.formatters.values
		 * @param value the value to display
		 * @return {string|string[]} the label to display
		 */
		values: function(value) {
			return helpers$1.isArray(value) ? value : '' + value;
		},

		/**
		 * Formatter for linear numeric ticks
		 * @method Chart.Ticks.formatters.linear
		 * @param tickValue {number} the value to be formatted
		 * @param index {number} the position of the tickValue parameter in the ticks array
		 * @param ticks {number[]} the list of ticks being converted
		 * @return {string} string representation of the tickValue parameter
		 */
		linear: function(tickValue, index, ticks) {
			// If we have lots of ticks, don't use the ones
			var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];

			// If we have a number like 2.5 as the delta, figure out how many decimal places we need
			if (Math.abs(delta) > 1) {
				if (tickValue !== Math.floor(tickValue)) {
					// not an integer
					delta = tickValue - Math.floor(tickValue);
				}
			}

			var logDelta = helpers$1.log10(Math.abs(delta));
			var tickString = '';

			if (tickValue !== 0) {
				var maxTick = Math.max(Math.abs(ticks[0]), Math.abs(ticks[ticks.length - 1]));
				if (maxTick < 1e-4) { // all ticks are small numbers; use scientific notation
					var logTick = helpers$1.log10(Math.abs(tickValue));
					var numExponential = Math.floor(logTick) - Math.floor(logDelta);
					numExponential = Math.max(Math.min(numExponential, 20), 0);
					tickString = tickValue.toExponential(numExponential);
				} else {
					var numDecimal = -1 * Math.floor(logDelta);
					numDecimal = Math.max(Math.min(numDecimal, 20), 0); // toFixed has a max of 20 decimal places
					tickString = tickValue.toFixed(numDecimal);
				}
			} else {
				tickString = '0'; // never show decimal places for 0
			}

			return tickString;
		},

		logarithmic: function(tickValue, index, ticks) {
			var remain = tickValue / (Math.pow(10, Math.floor(helpers$1.log10(tickValue))));

			if (tickValue === 0) {
				return '0';
			} else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) {
				return tickValue.toExponential();
			}
			return '';
		}
	}
};

var isArray = helpers$1.isArray;
var isNullOrUndef = helpers$1.isNullOrUndef;
var valueOrDefault$a = helpers$1.valueOrDefault;
var valueAtIndexOrDefault = helpers$1.valueAtIndexOrDefault;

core_defaults._set('scale', {
	display: true,
	position: 'left',
	offset: false,

	// grid line settings
	gridLines: {
		display: true,
		color: 'rgba(0,0,0,0.1)',
		lineWidth: 1,
		drawBorder: true,
		drawOnChartArea: true,
		drawTicks: true,
		tickMarkLength: 10,
		zeroLineWidth: 1,
		zeroLineColor: 'rgba(0,0,0,0.25)',
		zeroLineBorderDash: [],
		zeroLineBorderDashOffset: 0.0,
		offsetGridLines: false,
		borderDash: [],
		borderDashOffset: 0.0
	},

	// scale label
	scaleLabel: {
		// display property
		display: false,

		// actual label
		labelString: '',

		// top/bottom padding
		padding: {
			top: 4,
			bottom: 4
		}
	},

	// label settings
	ticks: {
		beginAtZero: false,
		minRotation: 0,
		maxRotation: 50,
		mirror: false,
		padding: 0,
		reverse: false,
		display: true,
		autoSkip: true,
		autoSkipPadding: 0,
		labelOffset: 0,
		// We pass through arrays to be rendered as multiline labels, we convert Others to strings here.
		callback: core_ticks.formatters.values,
		minor: {},
		major: {}
	}
});

/** Returns a new array containing numItems from arr */
function sample(arr, numItems) {
	var result = [];
	var increment = arr.length / numItems;
	var i = 0;
	var len = arr.length;

	for (; i < len; i += increment) {
		result.push(arr[Math.floor(i)]);
	}
	return result;
}

function getPixelForGridLine(scale, index, offsetGridLines) {
	var length = scale.getTicks().length;
	var validIndex = Math.min(index, length - 1);
	var lineValue = scale.getPixelForTick(validIndex);
	var start = scale._startPixel;
	var end = scale._endPixel;
	var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.
	var offset;

	if (offsetGridLines) {
		if (length === 1) {
			offset = Math.max(lineValue - start, end - lineValue);
		} else if (index === 0) {
			offset = (scale.getPixelForTick(1) - lineValue) / 2;
		} else {
			offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
		}
		lineValue += validIndex < index ? offset : -offset;

		// Return undefined if the pixel is out of the range
		if (lineValue < start - epsilon || lineValue > end + epsilon) {
			return;
		}
	}
	return lineValue;
}

function garbageCollect(caches, length) {
	helpers$1.each(caches, function(cache) {
		var gc = cache.gc;
		var gcLen = gc.length / 2;
		var i;
		if (gcLen > length) {
			for (i = 0; i < gcLen; ++i) {
				delete cache.data[gc[i]];
			}
			gc.splice(0, gcLen);
		}
	});
}

/**
 * Returns {width, height, offset} objects for the first, last, widest, highest tick
 * labels where offset indicates the anchor point offset from the top in pixels.
 */
function computeLabelSizes(ctx, tickFonts, ticks, caches) {
	var length = ticks.length;
	var widths = [];
	var heights = [];
	var offsets = [];
	var widestLabelSize = 0;
	var highestLabelSize = 0;
	var i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel, widest, highest;

	for (i = 0; i < length; ++i) {
		label = ticks[i].label;
		tickFont = ticks[i].major ? tickFonts.major : tickFonts.minor;
		ctx.font = fontString = tickFont.string;
		cache = caches[fontString] = caches[fontString] || {data: {}, gc: []};
		lineHeight = tickFont.lineHeight;
		width = height = 0;
		// Undefined labels and arrays should not be measured
		if (!isNullOrUndef(label) && !isArray(label)) {
			width = helpers$1.measureText(ctx, cache.data, cache.gc, width, label);
			height = lineHeight;
		} else if (isArray(label)) {
			// if it is an array let's measure each element
			for (j = 0, jlen = label.length; j < jlen; ++j) {
				nestedLabel = label[j];
				// Undefined labels and arrays should not be measured
				if (!isNullOrUndef(nestedLabel) && !isArray(nestedLabel)) {
					width = helpers$1.measureText(ctx, cache.data, cache.gc, width, nestedLabel);
					height += lineHeight;
				}
			}
		}
		widths.push(width);
		heights.push(height);
		offsets.push(lineHeight / 2);
		widestLabelSize = Math.max(width, widestLabelSize);
		highestLabelSize = Math.max(height, highestLabelSize);
	}
	garbageCollect(caches, length);

	widest = widths.indexOf(widestLabelSize);
	highest = heights.indexOf(highestLabelSize);

	function valueAt(idx) {
		return {
			width: widths[idx] || 0,
			height: heights[idx] || 0,
			offset: offsets[idx] || 0
		};
	}

	return {
		first: valueAt(0),
		last: valueAt(length - 1),
		widest: valueAt(widest),
		highest: valueAt(highest)
	};
}

function getTickMarkLength(options) {
	return options.drawTicks ? options.tickMarkLength : 0;
}

function getScaleLabelHeight(options) {
	var font, padding;

	if (!options.display) {
		return 0;
	}

	font = helpers$1.options._parseFont(options);
	padding = helpers$1.options.toPadding(options.padding);

	return font.lineHeight + padding.height;
}

function parseFontOptions(options, nestedOpts) {
	return helpers$1.extend(helpers$1.options._parseFont({
		fontFamily: valueOrDefault$a(nestedOpts.fontFamily, options.fontFamily),
		fontSize: valueOrDefault$a(nestedOpts.fontSize, options.fontSize),
		fontStyle: valueOrDefault$a(nestedOpts.fontStyle, options.fontStyle),
		lineHeight: valueOrDefault$a(nestedOpts.lineHeight, options.lineHeight)
	}), {
		color: helpers$1.options.resolve([nestedOpts.fontColor, options.fontColor, core_defaults.global.defaultFontColor])
	});
}

function parseTickFontOptions(options) {
	var minor = parseFontOptions(options, options.minor);
	var major = options.major.enabled ? parseFontOptions(options, options.major) : minor;

	return {minor: minor, major: major};
}

function nonSkipped(ticksToFilter) {
	var filtered = [];
	var item, index, len;
	for (index = 0, len = ticksToFilter.length; index < len; ++index) {
		item = ticksToFilter[index];
		if (typeof item._index !== 'undefined') {
			filtered.push(item);
		}
	}
	return filtered;
}

function getEvenSpacing(arr) {
	var len = arr.length;
	var i, diff;

	if (len < 2) {
		return false;
	}

	for (diff = arr[0], i = 1; i < len; ++i) {
		if (arr[i] - arr[i - 1] !== diff) {
			return false;
		}
	}
	return diff;
}

function calculateSpacing(majorIndices, ticks, axisLength, ticksLimit) {
	var evenMajorSpacing = getEvenSpacing(majorIndices);
	var spacing = (ticks.length - 1) / ticksLimit;
	var factors, factor, i, ilen;

	// If the major ticks are evenly spaced apart, place the minor ticks
	// so that they divide the major ticks into even chunks
	if (!evenMajorSpacing) {
		return Math.max(spacing, 1);
	}

	factors = helpers$1.math._factorize(evenMajorSpacing);
	for (i = 0, ilen = factors.length - 1; i < ilen; i++) {
		factor = factors[i];
		if (factor > spacing) {
			return factor;
		}
	}
	return Math.max(spacing, 1);
}

function getMajorIndices(ticks) {
	var result = [];
	var i, ilen;
	for (i = 0, ilen = ticks.length; i < ilen; i++) {
		if (ticks[i].major) {
			result.push(i);
		}
	}
	return result;
}

function skipMajors(ticks, majorIndices, spacing) {
	var count = 0;
	var next = majorIndices[0];
	var i, tick;

	spacing = Math.ceil(spacing);
	for (i = 0; i < ticks.length; i++) {
		tick = ticks[i];
		if (i === next) {
			tick._index = i;
			count++;
			next = majorIndices[count * spacing];
		} else {
			delete tick.label;
		}
	}
}

function skip(ticks, spacing, majorStart, majorEnd) {
	var start = valueOrDefault$a(majorStart, 0);
	var end = Math.min(valueOrDefault$a(majorEnd, ticks.length), ticks.length);
	var count = 0;
	var length, i, tick, next;

	spacing = Math.ceil(spacing);
	if (majorEnd) {
		length = majorEnd - majorStart;
		spacing = length / Math.floor(length / spacing);
	}

	next = start;

	while (next < 0) {
		count++;
		next = Math.round(start + count * spacing);
	}

	for (i = Math.max(start, 0); i < end; i++) {
		tick = ticks[i];
		if (i === next) {
			tick._index = i;
			count++;
			next = Math.round(start + count * spacing);
		} else {
			delete tick.label;
		}
	}
}

var Scale = core_element.extend({

	zeroLineIndex: 0,

	/**
	 * Get the padding needed for the scale
	 * @method getPadding
	 * @private
	 * @returns {Padding} the necessary padding
	 */
	getPadding: function() {
		var me = this;
		return {
			left: me.paddingLeft || 0,
			top: me.paddingTop || 0,
			right: me.paddingRight || 0,
			bottom: me.paddingBottom || 0
		};
	},

	/**
	 * Returns the scale tick objects ({label, major})
	 * @since 2.7
	 */
	getTicks: function() {
		return this._ticks;
	},

	/**
	* @private
	*/
	_getLabels: function() {
		var data = this.chart.data;
		return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
	},

	// These methods are ordered by lifecyle. Utilities then follow.
	// Any function defined here is inherited by all scale types.
	// Any function can be extended by the scale type

	/**
	 * Provided for backward compatibility, not available anymore
	 * @function Chart.Scale.mergeTicksOptions
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 */
	mergeTicksOptions: function() {
		// noop
	},

	beforeUpdate: function() {
		helpers$1.callback(this.options.beforeUpdate, [this]);
	},

	/**
	 * @param {number} maxWidth - the max width in pixels
	 * @param {number} maxHeight - the max height in pixels
	 * @param {object} margins - the space between the edge of the other scales and edge of the chart
	 *   This space comes from two sources:
	 *     - padding - space that's required to show the labels at the edges of the scale
	 *     - thickness of scales or legends in another orientation
	 */
	update: function(maxWidth, maxHeight, margins) {
		var me = this;
		var tickOpts = me.options.ticks;
		var sampleSize = tickOpts.sampleSize;
		var i, ilen, labels, ticks, samplingEnabled;

		// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
		me.beforeUpdate();

		// Absorb the master measurements
		me.maxWidth = maxWidth;
		me.maxHeight = maxHeight;
		me.margins = helpers$1.extend({
			left: 0,
			right: 0,
			top: 0,
			bottom: 0
		}, margins);

		me._ticks = null;
		me.ticks = null;
		me._labelSizes = null;
		me._maxLabelLines = 0;
		me.longestLabelWidth = 0;
		me.longestTextCache = me.longestTextCache || {};
		me._gridLineItems = null;
		me._labelItems = null;

		// Dimensions
		me.beforeSetDimensions();
		me.setDimensions();
		me.afterSetDimensions();

		// Data min/max
		me.beforeDataLimits();
		me.determineDataLimits();
		me.afterDataLimits();

		// Ticks - `this.ticks` is now DEPRECATED!
		// Internal ticks are now stored as objects in the PRIVATE `this._ticks` member
		// and must not be accessed directly from outside this class. `this.ticks` being
		// around for long time and not marked as private, we can't change its structure
		// without unexpected breaking changes. If you need to access the scale ticks,
		// use scale.getTicks() instead.

		me.beforeBuildTicks();

		// New implementations should return an array of objects but for BACKWARD COMPAT,
		// we still support no return (`this.ticks` internally set by calling this method).
		ticks = me.buildTicks() || [];

		// Allow modification of ticks in callback.
		ticks = me.afterBuildTicks(ticks) || ticks;

		// Ensure ticks contains ticks in new tick format
		if ((!ticks || !ticks.length) && me.ticks) {
			ticks = [];
			for (i = 0, ilen = me.ticks.length; i < ilen; ++i) {
				ticks.push({
					value: me.ticks[i],
					major: false
				});
			}
		}

		me._ticks = ticks;

		// Compute tick rotation and fit using a sampled subset of labels
		// We generally don't need to compute the size of every single label for determining scale size
		samplingEnabled = sampleSize < ticks.length;
		labels = me._convertTicksToLabels(samplingEnabled ? sample(ticks, sampleSize) : ticks);

		// _configure is called twice, once here, once from core.controller.updateLayout.
		// Here we haven't been positioned yet, but dimensions are correct.
		// Variables set in _configure are needed for calculateTickRotation, and
		// it's ok that coordinates are not correct there, only dimensions matter.
		me._configure();

		// Tick Rotation
		me.beforeCalculateTickRotation();
		me.calculateTickRotation();
		me.afterCalculateTickRotation();

		me.beforeFit();
		me.fit();
		me.afterFit();

		// Auto-skip
		me._ticksToDraw = tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto') ? me._autoSkip(ticks) : ticks;

		if (samplingEnabled) {
			// Generate labels using all non-skipped ticks
			labels = me._convertTicksToLabels(me._ticksToDraw);
		}

		me.ticks = labels;   // BACKWARD COMPATIBILITY

		// IMPORTANT: after this point, we consider that `this.ticks` will NEVER change!

		me.afterUpdate();

		// TODO(v3): remove minSize as a public property and return value from all layout boxes. It is unused
		// make maxWidth and maxHeight private
		return me.minSize;
	},

	/**
	 * @private
	 */
	_configure: function() {
		var me = this;
		var reversePixels = me.options.ticks.reverse;
		var startPixel, endPixel;

		if (me.isHorizontal()) {
			startPixel = me.left;
			endPixel = me.right;
		} else {
			startPixel = me.top;
			endPixel = me.bottom;
			// by default vertical scales are from bottom to top, so pixels are reversed
			reversePixels = !reversePixels;
		}
		me._startPixel = startPixel;
		me._endPixel = endPixel;
		me._reversePixels = reversePixels;
		me._length = endPixel - startPixel;
	},

	afterUpdate: function() {
		helpers$1.callback(this.options.afterUpdate, [this]);
	},

	//

	beforeSetDimensions: function() {
		helpers$1.callback(this.options.beforeSetDimensions, [this]);
	},
	setDimensions: function() {
		var me = this;
		// Set the unconstrained dimension before label rotation
		if (me.isHorizontal()) {
			// Reset position before calculating rotation
			me.width = me.maxWidth;
			me.left = 0;
			me.right = me.width;
		} else {
			me.height = me.maxHeight;

			// Reset position before calculating rotation
			me.top = 0;
			me.bottom = me.height;
		}

		// Reset padding
		me.paddingLeft = 0;
		me.paddingTop = 0;
		me.paddingRight = 0;
		me.paddingBottom = 0;
	},
	afterSetDimensions: function() {
		helpers$1.callback(this.options.afterSetDimensions, [this]);
	},

	// Data limits
	beforeDataLimits: function() {
		helpers$1.callback(this.options.beforeDataLimits, [this]);
	},
	determineDataLimits: helpers$1.noop,
	afterDataLimits: function() {
		helpers$1.callback(this.options.afterDataLimits, [this]);
	},

	//
	beforeBuildTicks: function() {
		helpers$1.callback(this.options.beforeBuildTicks, [this]);
	},
	buildTicks: helpers$1.noop,
	afterBuildTicks: function(ticks) {
		var me = this;
		// ticks is empty for old axis implementations here
		if (isArray(ticks) && ticks.length) {
			return helpers$1.callback(me.options.afterBuildTicks, [me, ticks]);
		}
		// Support old implementations (that modified `this.ticks` directly in buildTicks)
		me.ticks = helpers$1.callback(me.options.afterBuildTicks, [me, me.ticks]) || me.ticks;
		return ticks;
	},

	beforeTickToLabelConversion: function() {
		helpers$1.callback(this.options.beforeTickToLabelConversion, [this]);
	},
	convertTicksToLabels: function() {
		var me = this;
		// Convert ticks to strings
		var tickOpts = me.options.ticks;
		me.ticks = me.ticks.map(tickOpts.userCallback || tickOpts.callback, this);
	},
	afterTickToLabelConversion: function() {
		helpers$1.callback(this.options.afterTickToLabelConversion, [this]);
	},

	//

	beforeCalculateTickRotation: function() {
		helpers$1.callback(this.options.beforeCalculateTickRotation, [this]);
	},
	calculateTickRotation: function() {
		var me = this;
		var options = me.options;
		var tickOpts = options.ticks;
		var numTicks = me.getTicks().length;
		var minRotation = tickOpts.minRotation || 0;
		var maxRotation = tickOpts.maxRotation;
		var labelRotation = minRotation;
		var labelSizes, maxLabelWidth, maxLabelHeight, maxWidth, tickWidth, maxHeight, maxLabelDiagonal;

		if (!me._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !me.isHorizontal()) {
			me.labelRotation = minRotation;
			return;
		}

		labelSizes = me._getLabelSizes();
		maxLabelWidth = labelSizes.widest.width;
		maxLabelHeight = labelSizes.highest.height - labelSizes.highest.offset;

		// Estimate the width of each grid based on the canvas width, the maximum
		// label width and the number of tick intervals
		maxWidth = Math.min(me.maxWidth, me.chart.width - maxLabelWidth);
		tickWidth = options.offset ? me.maxWidth / numTicks : maxWidth / (numTicks - 1);

		// Allow 3 pixels x2 padding either side for label readability
		if (maxLabelWidth + 6 > tickWidth) {
			tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
			maxHeight = me.maxHeight - getTickMarkLength(options.gridLines)
				- tickOpts.padding - getScaleLabelHeight(options.scaleLabel);
			maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
			labelRotation = helpers$1.toDegrees(Math.min(
				Math.asin(Math.min((labelSizes.highest.height + 6) / tickWidth, 1)),
				Math.asin(Math.min(maxHeight / maxLabelDiagonal, 1)) - Math.asin(maxLabelHeight / maxLabelDiagonal)
			));
			labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
		}

		me.labelRotation = labelRotation;
	},
	afterCalculateTickRotation: function() {
		helpers$1.callback(this.options.afterCalculateTickRotation, [this]);
	},

	//

	beforeFit: function() {
		helpers$1.callback(this.options.beforeFit, [this]);
	},
	fit: function() {
		var me = this;
		// Reset
		var minSize = me.minSize = {
			width: 0,
			height: 0
		};

		var chart = me.chart;
		var opts = me.options;
		var tickOpts = opts.ticks;
		var scaleLabelOpts = opts.scaleLabel;
		var gridLineOpts = opts.gridLines;
		var display = me._isVisible();
		var isBottom = opts.position === 'bottom';
		var isHorizontal = me.isHorizontal();

		// Width
		if (isHorizontal) {
			minSize.width = me.maxWidth;
		} else if (display) {
			minSize.width = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
		}

		// height
		if (!isHorizontal) {
			minSize.height = me.maxHeight; // fill all the height
		} else if (display) {
			minSize.height = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
		}

		// Don't bother fitting the ticks if we are not showing the labels
		if (tickOpts.display && display) {
			var tickFonts = parseTickFontOptions(tickOpts);
			var labelSizes = me._getLabelSizes();
			var firstLabelSize = labelSizes.first;
			var lastLabelSize = labelSizes.last;
			var widestLabelSize = labelSizes.widest;
			var highestLabelSize = labelSizes.highest;
			var lineSpace = tickFonts.minor.lineHeight * 0.4;
			var tickPadding = tickOpts.padding;

			if (isHorizontal) {
				// A horizontal axis is more constrained by the height.
				var isRotated = me.labelRotation !== 0;
				var angleRadians = helpers$1.toRadians(me.labelRotation);
				var cosRotation = Math.cos(angleRadians);
				var sinRotation = Math.sin(angleRadians);

				var labelHeight = sinRotation * widestLabelSize.width
					+ cosRotation * (highestLabelSize.height - (isRotated ? highestLabelSize.offset : 0))
					+ (isRotated ? 0 : lineSpace); // padding

				minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight + tickPadding);

				var offsetLeft = me.getPixelForTick(0) - me.left;
				var offsetRight = me.right - me.getPixelForTick(me.getTicks().length - 1);
				var paddingLeft, paddingRight;

				// Ensure that our ticks are always inside the canvas. When rotated, ticks are right aligned
				// which means that the right padding is dominated by the font height
				if (isRotated) {
					paddingLeft = isBottom ?
						cosRotation * firstLabelSize.width + sinRotation * firstLabelSize.offset :
						sinRotation * (firstLabelSize.height - firstLabelSize.offset);
					paddingRight = isBottom ?
						sinRotation * (lastLabelSize.height - lastLabelSize.offset) :
						cosRotation * lastLabelSize.width + sinRotation * lastLabelSize.offset;
				} else {
					paddingLeft = firstLabelSize.width / 2;
					paddingRight = lastLabelSize.width / 2;
				}

				// Adjust padding taking into account changes in offsets
				// and add 3 px to move away from canvas edges
				me.paddingLeft = Math.max((paddingLeft - offsetLeft) * me.width / (me.width - offsetLeft), 0) + 3;
				me.paddingRight = Math.max((paddingRight - offsetRight) * me.width / (me.width - offsetRight), 0) + 3;
			} else {
				// A vertical axis is more constrained by the width. Labels are the
				// dominant factor here, so get that length first and account for padding
				var labelWidth = tickOpts.mirror ? 0 :
					// use lineSpace for consistency with horizontal axis
					// tickPadding is not implemented for horizontal
					widestLabelSize.width + tickPadding + lineSpace;

				minSize.width = Math.min(me.maxWidth, minSize.width + labelWidth);

				me.paddingTop = firstLabelSize.height / 2;
				me.paddingBottom = lastLabelSize.height / 2;
			}
		}

		me.handleMargins();

		if (isHorizontal) {
			me.width = me._length = chart.width - me.margins.left - me.margins.right;
			me.height = minSize.height;
		} else {
			me.width = minSize.width;
			me.height = me._length = chart.height - me.margins.top - me.margins.bottom;
		}
	},

	/**
	 * Handle margins and padding interactions
	 * @private
	 */
	handleMargins: function() {
		var me = this;
		if (me.margins) {
			me.margins.left = Math.max(me.paddingLeft, me.margins.left);
			me.margins.top = Math.max(me.paddingTop, me.margins.top);
			me.margins.right = Math.max(me.paddingRight, me.margins.right);
			me.margins.bottom = Math.max(me.paddingBottom, me.margins.bottom);
		}
	},

	afterFit: function() {
		helpers$1.callback(this.options.afterFit, [this]);
	},

	// Shared Methods
	isHorizontal: function() {
		var pos = this.options.position;
		return pos === 'top' || pos === 'bottom';
	},
	isFullWidth: function() {
		return this.options.fullWidth;
	},

	// Get the correct value. NaN bad inputs, If the value type is object get the x or y based on whether we are horizontal or not
	getRightValue: function(rawValue) {
		// Null and undefined values first
		if (isNullOrUndef(rawValue)) {
			return NaN;
		}
		// isNaN(object) returns true, so make sure NaN is checking for a number; Discard Infinite values
		if ((typeof rawValue === 'number' || rawValue instanceof Number) && !isFinite(rawValue)) {
			return NaN;
		}

		// If it is in fact an object, dive in one more level
		if (rawValue) {
			if (this.isHorizontal()) {
				if (rawValue.x !== undefined) {
					return this.getRightValue(rawValue.x);
				}
			} else if (rawValue.y !== undefined) {
				return this.getRightValue(rawValue.y);
			}
		}

		// Value is good, return it
		return rawValue;
	},

	_convertTicksToLabels: function(ticks) {
		var me = this;
		var labels, i, ilen;

		me.ticks = ticks.map(function(tick) {
			return tick.value;
		});

		me.beforeTickToLabelConversion();

		// New implementations should return the formatted tick labels but for BACKWARD
		// COMPAT, we still support no return (`this.ticks` internally changed by calling
		// this method and supposed to contain only string values).
		labels = me.convertTicksToLabels(ticks) || me.ticks;

		me.afterTickToLabelConversion();

		// BACKWARD COMPAT: synchronize `_ticks` with labels (so potentially `this.ticks`)
		for (i = 0, ilen = ticks.length; i < ilen; ++i) {
			ticks[i].label = labels[i];
		}

		return labels;
	},

	/**
	 * @private
	 */
	_getLabelSizes: function() {
		var me = this;
		var labelSizes = me._labelSizes;

		if (!labelSizes) {
			me._labelSizes = labelSizes = computeLabelSizes(me.ctx, parseTickFontOptions(me.options.ticks), me.getTicks(), me.longestTextCache);
			me.longestLabelWidth = labelSizes.widest.width;
		}

		return labelSizes;
	},

	/**
	 * @private
	 */
	_parseValue: function(value) {
		var start, end, min, max;

		if (isArray(value)) {
			start = +this.getRightValue(value[0]);
			end = +this.getRightValue(value[1]);
			min = Math.min(start, end);
			max = Math.max(start, end);
		} else {
			value = +this.getRightValue(value);
			start = undefined;
			end = value;
			min = value;
			max = value;
		}

		return {
			min: min,
			max: max,
			start: start,
			end: end
		};
	},

	/**
	* @private
	*/
	_getScaleLabel: function(rawValue) {
		var v = this._parseValue(rawValue);
		if (v.start !== undefined) {
			return '[' + v.start + ', ' + v.end + ']';
		}

		return +this.getRightValue(rawValue);
	},

	/**
	 * Used to get the value to display in the tooltip for the data at the given index
	 * @param index
	 * @param datasetIndex
	 */
	getLabelForIndex: helpers$1.noop,

	/**
	 * Returns the location of the given data point. Value can either be an index or a numerical value
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 * @param value
	 * @param index
	 * @param datasetIndex
	 */
	getPixelForValue: helpers$1.noop,

	/**
	 * Used to get the data value from a given pixel. This is the inverse of getPixelForValue
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 * @param pixel
	 */
	getValueForPixel: helpers$1.noop,

	/**
	 * Returns the location of the tick at the given index
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */
	getPixelForTick: function(index) {
		var me = this;
		var offset = me.options.offset;
		var numTicks = me._ticks.length;
		var tickWidth = 1 / Math.max(numTicks - (offset ? 0 : 1), 1);

		return index < 0 || index > numTicks - 1
			? null
			: me.getPixelForDecimal(index * tickWidth + (offset ? tickWidth / 2 : 0));
	},

	/**
	 * Utility for getting the pixel location of a percentage of scale
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */
	getPixelForDecimal: function(decimal) {
		var me = this;

		if (me._reversePixels) {
			decimal = 1 - decimal;
		}

		return me._startPixel + decimal * me._length;
	},

	getDecimalForPixel: function(pixel) {
		var decimal = (pixel - this._startPixel) / this._length;
		return this._reversePixels ? 1 - decimal : decimal;
	},

	/**
	 * Returns the pixel for the minimum chart value
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */
	getBasePixel: function() {
		return this.getPixelForValue(this.getBaseValue());
	},

	getBaseValue: function() {
		var me = this;
		var min = me.min;
		var max = me.max;

		return me.beginAtZero ? 0 :
			min < 0 && max < 0 ? max :
			min > 0 && max > 0 ? min :
			0;
	},

	/**
	 * Returns a subset of ticks to be plotted to avoid overlapping labels.
	 * @private
	 */
	_autoSkip: function(ticks) {
		var me = this;
		var tickOpts = me.options.ticks;
		var axisLength = me._length;
		var ticksLimit = tickOpts.maxTicksLimit || axisLength / me._tickSize() + 1;
		var majorIndices = tickOpts.major.enabled ? getMajorIndices(ticks) : [];
		var numMajorIndices = majorIndices.length;
		var first = majorIndices[0];
		var last = majorIndices[numMajorIndices - 1];
		var i, ilen, spacing, avgMajorSpacing;

		// If there are too many major ticks to display them all
		if (numMajorIndices > ticksLimit) {
			skipMajors(ticks, majorIndices, numMajorIndices / ticksLimit);
			return nonSkipped(ticks);
		}

		spacing = calculateSpacing(majorIndices, ticks, axisLength, ticksLimit);

		if (numMajorIndices > 0) {
			for (i = 0, ilen = numMajorIndices - 1; i < ilen; i++) {
				skip(ticks, spacing, majorIndices[i], majorIndices[i + 1]);
			}
			avgMajorSpacing = numMajorIndices > 1 ? (last - first) / (numMajorIndices - 1) : null;
			skip(ticks, spacing, helpers$1.isNullOrUndef(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
			skip(ticks, spacing, last, helpers$1.isNullOrUndef(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
			return nonSkipped(ticks);
		}
		skip(ticks, spacing);
		return nonSkipped(ticks);
	},

	/**
	 * @private
	 */
	_tickSize: function() {
		var me = this;
		var optionTicks = me.options.ticks;

		// Calculate space needed by label in axis direction.
		var rot = helpers$1.toRadians(me.labelRotation);
		var cos = Math.abs(Math.cos(rot));
		var sin = Math.abs(Math.sin(rot));

		var labelSizes = me._getLabelSizes();
		var padding = optionTicks.autoSkipPadding || 0;
		var w = labelSizes ? labelSizes.widest.width + padding : 0;
		var h = labelSizes ? labelSizes.highest.height + padding : 0;

		// Calculate space needed for 1 tick in axis direction.
		return me.isHorizontal()
			? h * cos > w * sin ? w / cos : h / sin
			: h * sin < w * cos ? h / cos : w / sin;
	},

	/**
	 * @private
	 */
	_isVisible: function() {
		var me = this;
		var chart = me.chart;
		var display = me.options.display;
		var i, ilen, meta;

		if (display !== 'auto') {
			return !!display;
		}

		// When 'auto', the scale is visible if at least one associated dataset is visible.
		for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
			if (chart.isDatasetVisible(i)) {
				meta = chart.getDatasetMeta(i);
				if (meta.xAxisID === me.id || meta.yAxisID === me.id) {
					return true;
				}
			}
		}

		return false;
	},

	/**
	 * @private
	 */
	_computeGridLineItems: function(chartArea) {
		var me = this;
		var chart = me.chart;
		var options = me.options;
		var gridLines = options.gridLines;
		var position = options.position;
		var offsetGridLines = gridLines.offsetGridLines;
		var isHorizontal = me.isHorizontal();
		var ticks = me._ticksToDraw;
		var ticksLength = ticks.length + (offsetGridLines ? 1 : 0);

		var tl = getTickMarkLength(gridLines);
		var items = [];
		var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
		var axisHalfWidth = axisWidth / 2;
		var alignPixel = helpers$1._alignPixel;
		var alignBorderValue = function(pixel) {
			return alignPixel(chart, pixel, axisWidth);
		};
		var borderValue, i, tick, lineValue, alignedLineValue;
		var tx1, ty1, tx2, ty2, x1, y1, x2, y2, lineWidth, lineColor, borderDash, borderDashOffset;

		if (position === 'top') {
			borderValue = alignBorderValue(me.bottom);
			ty1 = me.bottom - tl;
			ty2 = borderValue - axisHalfWidth;
			y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
			y2 = chartArea.bottom;
		} else if (position === 'bottom') {
			borderValue = alignBorderValue(me.top);
			y1 = chartArea.top;
			y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
			ty1 = borderValue + axisHalfWidth;
			ty2 = me.top + tl;
		} else if (position === 'left') {
			borderValue = alignBorderValue(me.right);
			tx1 = me.right - tl;
			tx2 = borderValue - axisHalfWidth;
			x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
			x2 = chartArea.right;
		} else {
			borderValue = alignBorderValue(me.left);
			x1 = chartArea.left;
			x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
			tx1 = borderValue + axisHalfWidth;
			tx2 = me.left + tl;
		}

		for (i = 0; i < ticksLength; ++i) {
			tick = ticks[i] || {};

			// autoskipper skipped this tick (#4635)
			if (isNullOrUndef(tick.label) && i < ticks.length) {
				continue;
			}

			if (i === me.zeroLineIndex && options.offset === offsetGridLines) {
				// Draw the first index specially
				lineWidth = gridLines.zeroLineWidth;
				lineColor = gridLines.zeroLineColor;
				borderDash = gridLines.zeroLineBorderDash || [];
				borderDashOffset = gridLines.zeroLineBorderDashOffset || 0.0;
			} else {
				lineWidth = valueAtIndexOrDefault(gridLines.lineWidth, i, 1);
				lineColor = valueAtIndexOrDefault(gridLines.color, i, 'rgba(0,0,0,0.1)');
				borderDash = gridLines.borderDash || [];
				borderDashOffset = gridLines.borderDashOffset || 0.0;
			}

			lineValue = getPixelForGridLine(me, tick._index || i, offsetGridLines);

			// Skip if the pixel is out of the range
			if (lineValue === undefined) {
				continue;
			}

			alignedLineValue = alignPixel(chart, lineValue, lineWidth);

			if (isHorizontal) {
				tx1 = tx2 = x1 = x2 = alignedLineValue;
			} else {
				ty1 = ty2 = y1 = y2 = alignedLineValue;
			}

			items.push({
				tx1: tx1,
				ty1: ty1,
				tx2: tx2,
				ty2: ty2,
				x1: x1,
				y1: y1,
				x2: x2,
				y2: y2,
				width: lineWidth,
				color: lineColor,
				borderDash: borderDash,
				borderDashOffset: borderDashOffset,
			});
		}

		items.ticksLength = ticksLength;
		items.borderValue = borderValue;

		return items;
	},

	/**
	 * @private
	 */
	_computeLabelItems: function() {
		var me = this;
		var options = me.options;
		var optionTicks = options.ticks;
		var position = options.position;
		var isMirrored = optionTicks.mirror;
		var isHorizontal = me.isHorizontal();
		var ticks = me._ticksToDraw;
		var fonts = parseTickFontOptions(optionTicks);
		var tickPadding = optionTicks.padding;
		var tl = getTickMarkLength(options.gridLines);
		var rotation = -helpers$1.toRadians(me.labelRotation);
		var items = [];
		var i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;

		if (position === 'top') {
			y = me.bottom - tl - tickPadding;
			textAlign = !rotation ? 'center' : 'left';
		} else if (position === 'bottom') {
			y = me.top + tl + tickPadding;
			textAlign = !rotation ? 'center' : 'right';
		} else if (position === 'left') {
			x = me.right - (isMirrored ? 0 : tl) - tickPadding;
			textAlign = isMirrored ? 'left' : 'right';
		} else {
			x = me.left + (isMirrored ? 0 : tl) + tickPadding;
			textAlign = isMirrored ? 'right' : 'left';
		}

		for (i = 0, ilen = ticks.length; i < ilen; ++i) {
			tick = ticks[i];
			label = tick.label;

			// autoskipper skipped this tick (#4635)
			if (isNullOrUndef(label)) {
				continue;
			}

			pixel = me.getPixelForTick(tick._index || i) + optionTicks.labelOffset;
			font = tick.major ? fonts.major : fonts.minor;
			lineHeight = font.lineHeight;
			lineCount = isArray(label) ? label.length : 1;

			if (isHorizontal) {
				x = pixel;
				textOffset = position === 'top'
					? ((!rotation ? 0.5 : 1) - lineCount) * lineHeight
					: (!rotation ? 0.5 : 0) * lineHeight;
			} else {
				y = pixel;
				textOffset = (1 - lineCount) * lineHeight / 2;
			}

			items.push({
				x: x,
				y: y,
				rotation: rotation,
				label: label,
				font: font,
				textOffset: textOffset,
				textAlign: textAlign
			});
		}

		return items;
	},

	/**
	 * @private
	 */
	_drawGrid: function(chartArea) {
		var me = this;
		var gridLines = me.options.gridLines;

		if (!gridLines.display) {
			return;
		}

		var ctx = me.ctx;
		var chart = me.chart;
		var alignPixel = helpers$1._alignPixel;
		var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
		var items = me._gridLineItems || (me._gridLineItems = me._computeGridLineItems(chartArea));
		var width, color, i, ilen, item;

		for (i = 0, ilen = items.length; i < ilen; ++i) {
			item = items[i];
			width = item.width;
			color = item.color;

			if (width && color) {
				ctx.save();
				ctx.lineWidth = width;
				ctx.strokeStyle = color;
				if (ctx.setLineDash) {
					ctx.setLineDash(item.borderDash);
					ctx.lineDashOffset = item.borderDashOffset;
				}

				ctx.beginPath();

				if (gridLines.drawTicks) {
					ctx.moveTo(item.tx1, item.ty1);
					ctx.lineTo(item.tx2, item.ty2);
				}

				if (gridLines.drawOnChartArea) {
					ctx.moveTo(item.x1, item.y1);
					ctx.lineTo(item.x2, item.y2);
				}

				ctx.stroke();
				ctx.restore();
			}
		}

		if (axisWidth) {
			// Draw the line at the edge of the axis
			var firstLineWidth = axisWidth;
			var lastLineWidth = valueAtIndexOrDefault(gridLines.lineWidth, items.ticksLength - 1, 1);
			var borderValue = items.borderValue;
			var x1, x2, y1, y2;

			if (me.isHorizontal()) {
				x1 = alignPixel(chart, me.left, firstLineWidth) - firstLineWidth / 2;
				x2 = alignPixel(chart, me.right, lastLineWidth) + lastLineWidth / 2;
				y1 = y2 = borderValue;
			} else {
				y1 = alignPixel(chart, me.top, firstLineWidth) - firstLineWidth / 2;
				y2 = alignPixel(chart, me.bottom, lastLineWidth) + lastLineWidth / 2;
				x1 = x2 = borderValue;
			}

			ctx.lineWidth = axisWidth;
			ctx.strokeStyle = valueAtIndexOrDefault(gridLines.color, 0);
			ctx.beginPath();
			ctx.moveTo(x1, y1);
			ctx.lineTo(x2, y2);
			ctx.stroke();
		}
	},

	/**
	 * @private
	 */
	_drawLabels: function() {
		var me = this;
		var optionTicks = me.options.ticks;

		if (!optionTicks.display) {
			return;
		}

		var ctx = me.ctx;
		var items = me._labelItems || (me._labelItems = me._computeLabelItems());
		var i, j, ilen, jlen, item, tickFont, label, y;

		for (i = 0, ilen = items.length; i < ilen; ++i) {
			item = items[i];
			tickFont = item.font;

			// Make sure we draw text in the correct color and font
			ctx.save();
			ctx.translate(item.x, item.y);
			ctx.rotate(item.rotation);
			ctx.font = tickFont.string;
			ctx.fillStyle = tickFont.color;
			ctx.textBaseline = 'middle';
			ctx.textAlign = item.textAlign;

			label = item.label;
			y = item.textOffset;
			if (isArray(label)) {
				for (j = 0, jlen = label.length; j < jlen; ++j) {
					// We just make sure the multiline element is a string here..
					ctx.fillText('' + label[j], 0, y);
					y += tickFont.lineHeight;
				}
			} else {
				ctx.fillText(label, 0, y);
			}
			ctx.restore();
		}
	},

	/**
	 * @private
	 */
	_drawTitle: function() {
		var me = this;
		var ctx = me.ctx;
		var options = me.options;
		var scaleLabel = options.scaleLabel;

		if (!scaleLabel.display) {
			return;
		}

		var scaleLabelFontColor = valueOrDefault$a(scaleLabel.fontColor, core_defaults.global.defaultFontColor);
		var scaleLabelFont = helpers$1.options._parseFont(scaleLabel);
		var scaleLabelPadding = helpers$1.options.toPadding(scaleLabel.padding);
		var halfLineHeight = scaleLabelFont.lineHeight / 2;
		var position = options.position;
		var rotation = 0;
		var scaleLabelX, scaleLabelY;

		if (me.isHorizontal()) {
			scaleLabelX = me.left + me.width / 2; // midpoint of the width
			scaleLabelY = position === 'bottom'
				? me.bottom - halfLineHeight - scaleLabelPadding.bottom
				: me.top + halfLineHeight + scaleLabelPadding.top;
		} else {
			var isLeft = position === 'left';
			scaleLabelX = isLeft
				? me.left + halfLineHeight + scaleLabelPadding.top
				: me.right - halfLineHeight - scaleLabelPadding.top;
			scaleLabelY = me.top + me.height / 2;
			rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
		}

		ctx.save();
		ctx.translate(scaleLabelX, scaleLabelY);
		ctx.rotate(rotation);
		ctx.textAlign = 'center';
		ctx.textBaseline = 'middle';
		ctx.fillStyle = scaleLabelFontColor; // render in correct colour
		ctx.font = scaleLabelFont.string;
		ctx.fillText(scaleLabel.labelString, 0, 0);
		ctx.restore();
	},

	draw: function(chartArea) {
		var me = this;

		if (!me._isVisible()) {
			return;
		}

		me._drawGrid(chartArea);
		me._drawTitle();
		me._drawLabels();
	},

	/**
	 * @private
	 */
	_layers: function() {
		var me = this;
		var opts = me.options;
		var tz = opts.ticks && opts.ticks.z || 0;
		var gz = opts.gridLines && opts.gridLines.z || 0;

		if (!me._isVisible() || tz === gz || me.draw !== me._draw) {
			// backward compatibility: draw has been overridden by custom scale
			return [{
				z: tz,
				draw: function() {
					me.draw.apply(me, arguments);
				}
			}];
		}

		return [{
			z: gz,
			draw: function() {
				me._drawGrid.apply(me, arguments);
				me._drawTitle.apply(me, arguments);
			}
		}, {
			z: tz,
			draw: function() {
				me._drawLabels.apply(me, arguments);
			}
		}];
	},

	/**
	 * @private
	 */
	_getMatchingVisibleMetas: function(type) {
		var me = this;
		var isHorizontal = me.isHorizontal();
		return me.chart._getSortedVisibleDatasetMetas()
			.filter(function(meta) {
				return (!type || meta.type === type)
					&& (isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id);
			});
	}
});

Scale.prototype._draw = Scale.prototype.draw;

var core_scale = Scale;

var isNullOrUndef$1 = helpers$1.isNullOrUndef;

var defaultConfig = {
	position: 'bottom'
};

var scale_category = core_scale.extend({
	determineDataLimits: function() {
		var me = this;
		var labels = me._getLabels();
		var ticksOpts = me.options.ticks;
		var min = ticksOpts.min;
		var max = ticksOpts.max;
		var minIndex = 0;
		var maxIndex = labels.length - 1;
		var findIndex;

		if (min !== undefined) {
			// user specified min value
			findIndex = labels.indexOf(min);
			if (findIndex >= 0) {
				minIndex = findIndex;
			}
		}

		if (max !== undefined) {
			// user specified max value
			findIndex = labels.indexOf(max);
			if (findIndex >= 0) {
				maxIndex = findIndex;
			}
		}

		me.minIndex = minIndex;
		me.maxIndex = maxIndex;
		me.min = labels[minIndex];
		me.max = labels[maxIndex];
	},

	buildTicks: function() {
		var me = this;
		var labels = me._getLabels();
		var minIndex = me.minIndex;
		var maxIndex = me.maxIndex;

		// If we are viewing some subset of labels, slice the original array
		me.ticks = (minIndex === 0 && maxIndex === labels.length - 1) ? labels : labels.slice(minIndex, maxIndex + 1);
	},

	getLabelForIndex: function(index, datasetIndex) {
		var me = this;
		var chart = me.chart;

		if (chart.getDatasetMeta(datasetIndex).controller._getValueScaleId() === me.id) {
			return me.getRightValue(chart.data.datasets[datasetIndex].data[index]);
		}

		return me._getLabels()[index];
	},

	_configure: function() {
		var me = this;
		var offset = me.options.offset;
		var ticks = me.ticks;

		core_scale.prototype._configure.call(me);

		if (!me.isHorizontal()) {
			// For backward compatibility, vertical category scale reverse is inverted.
			me._reversePixels = !me._reversePixels;
		}

		if (!ticks) {
			return;
		}

		me._startValue = me.minIndex - (offset ? 0.5 : 0);
		me._valueRange = Math.max(ticks.length - (offset ? 0 : 1), 1);
	},

	// Used to get data value locations.  Value can either be an index or a numerical value
	getPixelForValue: function(value, index, datasetIndex) {
		var me = this;
		var valueCategory, labels, idx;

		if (!isNullOrUndef$1(index) && !isNullOrUndef$1(datasetIndex)) {
			value = me.chart.data.datasets[datasetIndex].data[index];
		}

		// If value is a data object, then index is the index in the data array,
		// not the index of the scale. We need to change that.
		if (!isNullOrUndef$1(value)) {
			valueCategory = me.isHorizontal() ? value.x : value.y;
		}
		if (valueCategory !== undefined || (value !== undefined && isNaN(index))) {
			labels = me._getLabels();
			value = helpers$1.valueOrDefault(valueCategory, value);
			idx = labels.indexOf(value);
			index = idx !== -1 ? idx : index;
			if (isNaN(index)) {
				index = value;
			}
		}
		return me.getPixelForDecimal((index - me._startValue) / me._valueRange);
	},

	getPixelForTick: function(index) {
		var ticks = this.ticks;
		return index < 0 || index > ticks.length - 1
			? null
			: this.getPixelForValue(ticks[index], index + this.minIndex);
	},

	getValueForPixel: function(pixel) {
		var me = this;
		var value = Math.round(me._startValue + me.getDecimalForPixel(pixel) * me._valueRange);
		return Math.min(Math.max(value, 0), me.ticks.length - 1);
	},

	getBasePixel: function() {
		return this.bottom;
	}
});

// INTERNAL: static default options, registered in src/index.js
var _defaults = defaultConfig;
scale_category._defaults = _defaults;

var noop = helpers$1.noop;
var isNullOrUndef$2 = helpers$1.isNullOrUndef;

/**
 * Generate a set of linear ticks
 * @param generationOptions the options used to generate the ticks
 * @param dataRange the range of the data
 * @returns {number[]} array of tick values
 */
function generateTicks(generationOptions, dataRange) {
	var ticks = [];
	// To get a "nice" value for the tick spacing, we will use the appropriately named
	// "nice number" algorithm. See https://stackoverflow.com/questions/8506881/nice-label-algorithm-for-charts-with-minimum-ticks
	// for details.

	var MIN_SPACING = 1e-14;
	var stepSize = generationOptions.stepSize;
	var unit = stepSize || 1;
	var maxNumSpaces = generationOptions.maxTicks - 1;
	var min = generationOptions.min;
	var max = generationOptions.max;
	var precision = generationOptions.precision;
	var rmin = dataRange.min;
	var rmax = dataRange.max;
	var spacing = helpers$1.niceNum((rmax - rmin) / maxNumSpaces / unit) * unit;
	var factor, niceMin, niceMax, numSpaces;

	// Beyond MIN_SPACING floating point numbers being to lose precision
	// such that we can't do the math necessary to generate ticks
	if (spacing < MIN_SPACING && isNullOrUndef$2(min) && isNullOrUndef$2(max)) {
		return [rmin, rmax];
	}

	numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
	if (numSpaces > maxNumSpaces) {
		// If the calculated num of spaces exceeds maxNumSpaces, recalculate it
		spacing = helpers$1.niceNum(numSpaces * spacing / maxNumSpaces / unit) * unit;
	}

	if (stepSize || isNullOrUndef$2(precision)) {
		// If a precision is not specified, calculate factor based on spacing
		factor = Math.pow(10, helpers$1._decimalPlaces(spacing));
	} else {
		// If the user specified a precision, round to that number of decimal places
		factor = Math.pow(10, precision);
		spacing = Math.ceil(spacing * factor) / factor;
	}

	niceMin = Math.floor(rmin / spacing) * spacing;
	niceMax = Math.ceil(rmax / spacing) * spacing;

	// If min, max and stepSize is set and they make an evenly spaced scale use it.
	if (stepSize) {
		// If very close to our whole number, use it.
		if (!isNullOrUndef$2(min) && helpers$1.almostWhole(min / spacing, spacing / 1000)) {
			niceMin = min;
		}
		if (!isNullOrUndef$2(max) && helpers$1.almostWhole(max / spacing, spacing / 1000)) {
			niceMax = max;
		}
	}

	numSpaces = (niceMax - niceMin) / spacing;
	// If very close to our rounded value, use it.
	if (helpers$1.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
		numSpaces = Math.round(numSpaces);
	} else {
		numSpaces = Math.ceil(numSpaces);
	}

	niceMin = Math.round(niceMin * factor) / factor;
	niceMax = Math.round(niceMax * factor) / factor;
	ticks.push(isNullOrUndef$2(min) ? niceMin : min);
	for (var j = 1; j < numSpaces; ++j) {
		ticks.push(Math.round((niceMin + j * spacing) * factor) / factor);
	}
	ticks.push(isNullOrUndef$2(max) ? niceMax : max);

	return ticks;
}

var scale_linearbase = core_scale.extend({
	getRightValue: function(value) {
		if (typeof value === 'string') {
			return +value;
		}
		return core_scale.prototype.getRightValue.call(this, value);
	},

	handleTickRangeOptions: function() {
		var me = this;
		var opts = me.options;
		var tickOpts = opts.ticks;

		// If we are forcing it to begin at 0, but 0 will already be rendered on the chart,
		// do nothing since that would make the chart weird. If the user really wants a weird chart
		// axis, they can manually override it
		if (tickOpts.beginAtZero) {
			var minSign = helpers$1.sign(me.min);
			var maxSign = helpers$1.sign(me.max);

			if (minSign < 0 && maxSign < 0) {
				// move the top up to 0
				me.max = 0;
			} else if (minSign > 0 && maxSign > 0) {
				// move the bottom down to 0
				me.min = 0;
			}
		}

		var setMin = tickOpts.min !== undefined || tickOpts.suggestedMin !== undefined;
		var setMax = tickOpts.max !== undefined || tickOpts.suggestedMax !== undefined;

		if (tickOpts.min !== undefined) {
			me.min = tickOpts.min;
		} else if (tickOpts.suggestedMin !== undefined) {
			if (me.min === null) {
				me.min = tickOpts.suggestedMin;
			} else {
				me.min = Math.min(me.min, tickOpts.suggestedMin);
			}
		}

		if (tickOpts.max !== undefined) {
			me.max = tickOpts.max;
		} else if (tickOpts.suggestedMax !== undefined) {
			if (me.max === null) {
				me.max = tickOpts.suggestedMax;
			} else {
				me.max = Math.max(me.max, tickOpts.suggestedMax);
			}
		}

		if (setMin !== setMax) {
			// We set the min or the max but not both.
			// So ensure that our range is good
			// Inverted or 0 length range can happen when
			// ticks.min is set, and no datasets are visible
			if (me.min >= me.max) {
				if (setMin) {
					me.max = me.min + 1;
				} else {
					me.min = me.max - 1;
				}
			}
		}

		if (me.min === me.max) {
			me.max++;

			if (!tickOpts.beginAtZero) {
				me.min--;
			}
		}
	},

	getTickLimit: function() {
		var me = this;
		var tickOpts = me.options.ticks;
		var stepSize = tickOpts.stepSize;
		var maxTicksLimit = tickOpts.maxTicksLimit;
		var maxTicks;

		if (stepSize) {
			maxTicks = Math.ceil(me.max / stepSize) - Math.floor(me.min / stepSize) + 1;
		} else {
			maxTicks = me._computeTickLimit();
			maxTicksLimit = maxTicksLimit || 11;
		}

		if (maxTicksLimit) {
			maxTicks = Math.min(maxTicksLimit, maxTicks);
		}

		return maxTicks;
	},

	_computeTickLimit: function() {
		return Number.POSITIVE_INFINITY;
	},

	handleDirectionalChanges: noop,

	buildTicks: function() {
		var me = this;
		var opts = me.options;
		var tickOpts = opts.ticks;

		// Figure out what the max number of ticks we can support it is based on the size of
		// the axis area. For now, we say that the minimum tick spacing in pixels must be 40
		// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
		// the graph. Make sure we always have at least 2 ticks
		var maxTicks = me.getTickLimit();
		maxTicks = Math.max(2, maxTicks);

		var numericGeneratorOptions = {
			maxTicks: maxTicks,
			min: tickOpts.min,
			max: tickOpts.max,
			precision: tickOpts.precision,
			stepSize: helpers$1.valueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize)
		};
		var ticks = me.ticks = generateTicks(numericGeneratorOptions, me);

		me.handleDirectionalChanges();

		// At this point, we need to update our max and min given the tick values since we have expanded the
		// range of the scale
		me.max = helpers$1.max(ticks);
		me.min = helpers$1.min(ticks);

		if (tickOpts.reverse) {
			ticks.reverse();

			me.start = me.max;
			me.end = me.min;
		} else {
			me.start = me.min;
			me.end = me.max;
		}
	},

	convertTicksToLabels: function() {
		var me = this;
		me.ticksAsNumbers = me.ticks.slice();
		me.zeroLineIndex = me.ticks.indexOf(0);

		core_scale.prototype.convertTicksToLabels.call(me);
	},

	_configure: function() {
		var me = this;
		var ticks = me.getTicks();
		var start = me.min;
		var end = me.max;
		var offset;

		core_scale.prototype._configure.call(me);

		if (me.options.offset && ticks.length) {
			offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
			start -= offset;
			end += offset;
		}
		me._startValue = start;
		me._endValue = end;
		me._valueRange = end - start;
	}
});

var defaultConfig$1 = {
	position: 'left',
	ticks: {
		callback: core_ticks.formatters.linear
	}
};

var DEFAULT_MIN = 0;
var DEFAULT_MAX = 1;

function getOrCreateStack(stacks, stacked, meta) {
	var key = [
		meta.type,
		// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
		stacked === undefined && meta.stack === undefined ? meta.index : '',
		meta.stack
	].join('.');

	if (stacks[key] === undefined) {
		stacks[key] = {
			pos: [],
			neg: []
		};
	}

	return stacks[key];
}

function stackData(scale, stacks, meta, data) {
	var opts = scale.options;
	var stacked = opts.stacked;
	var stack = getOrCreateStack(stacks, stacked, meta);
	var pos = stack.pos;
	var neg = stack.neg;
	var ilen = data.length;
	var i, value;

	for (i = 0; i < ilen; ++i) {
		value = scale._parseValue(data[i]);
		if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) {
			continue;
		}

		pos[i] = pos[i] || 0;
		neg[i] = neg[i] || 0;

		if (opts.relativePoints) {
			pos[i] = 100;
		} else if (value.min < 0 || value.max < 0) {
			neg[i] += value.min;
		} else {
			pos[i] += value.max;
		}
	}
}

function updateMinMax(scale, meta, data) {
	var ilen = data.length;
	var i, value;

	for (i = 0; i < ilen; ++i) {
		value = scale._parseValue(data[i]);
		if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) {
			continue;
		}

		scale.min = Math.min(scale.min, value.min);
		scale.max = Math.max(scale.max, value.max);
	}
}

var scale_linear = scale_linearbase.extend({
	determineDataLimits: function() {
		var me = this;
		var opts = me.options;
		var chart = me.chart;
		var datasets = chart.data.datasets;
		var metasets = me._getMatchingVisibleMetas();
		var hasStacks = opts.stacked;
		var stacks = {};
		var ilen = metasets.length;
		var i, meta, data, values;

		me.min = Number.POSITIVE_INFINITY;
		me.max = Number.NEGATIVE_INFINITY;

		if (hasStacks === undefined) {
			for (i = 0; !hasStacks && i < ilen; ++i) {
				meta = metasets[i];
				hasStacks = meta.stack !== undefined;
			}
		}

		for (i = 0; i < ilen; ++i) {
			meta = metasets[i];
			data = datasets[meta.index].data;
			if (hasStacks) {
				stackData(me, stacks, meta, data);
			} else {
				updateMinMax(me, meta, data);
			}
		}

		helpers$1.each(stacks, function(stackValues) {
			values = stackValues.pos.concat(stackValues.neg);
			me.min = Math.min(me.min, helpers$1.min(values));
			me.max = Math.max(me.max, helpers$1.max(values));
		});

		me.min = helpers$1.isFinite(me.min) && !isNaN(me.min) ? me.min : DEFAULT_MIN;
		me.max = helpers$1.isFinite(me.max) && !isNaN(me.max) ? me.max : DEFAULT_MAX;

		// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
		me.handleTickRangeOptions();
	},

	// Returns the maximum number of ticks based on the scale dimension
	_computeTickLimit: function() {
		var me = this;
		var tickFont;

		if (me.isHorizontal()) {
			return Math.ceil(me.width / 40);
		}
		tickFont = helpers$1.options._parseFont(me.options.ticks);
		return Math.ceil(me.height / tickFont.lineHeight);
	},

	// Called after the ticks are built. We need
	handleDirectionalChanges: function() {
		if (!this.isHorizontal()) {
			// We are in a vertical orientation. The top value is the highest. So reverse the array
			this.ticks.reverse();
		}
	},

	getLabelForIndex: function(index, datasetIndex) {
		return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
	},

	// Utils
	getPixelForValue: function(value) {
		var me = this;
		return me.getPixelForDecimal((+me.getRightValue(value) - me._startValue) / me._valueRange);
	},

	getValueForPixel: function(pixel) {
		return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
	},

	getPixelForTick: function(index) {
		var ticks = this.ticksAsNumbers;
		if (index < 0 || index > ticks.length - 1) {
			return null;
		}
		return this.getPixelForValue(ticks[index]);
	}
});

// INTERNAL: static default options, registered in src/index.js
var _defaults$1 = defaultConfig$1;
scale_linear._defaults = _defaults$1;

var valueOrDefault$b = helpers$1.valueOrDefault;
var log10 = helpers$1.math.log10;

/**
 * Generate a set of logarithmic ticks
 * @param generationOptions the options used to generate the ticks
 * @param dataRange the range of the data
 * @returns {number[]} array of tick values
 */
function generateTicks$1(generationOptions, dataRange) {
	var ticks = [];

	var tickVal = valueOrDefault$b(generationOptions.min, Math.pow(10, Math.floor(log10(dataRange.min))));

	var endExp = Math.floor(log10(dataRange.max));
	var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
	var exp, significand;

	if (tickVal === 0) {
		exp = Math.floor(log10(dataRange.minNotZero));
		significand = Math.floor(dataRange.minNotZero / Math.pow(10, exp));

		ticks.push(tickVal);
		tickVal = significand * Math.pow(10, exp);
	} else {
		exp = Math.floor(log10(tickVal));
		significand = Math.floor(tickVal / Math.pow(10, exp));
	}
	var precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;

	do {
		ticks.push(tickVal);

		++significand;
		if (significand === 10) {
			significand = 1;
			++exp;
			precision = exp >= 0 ? 1 : precision;
		}

		tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
	} while (exp < endExp || (exp === endExp && significand < endSignificand));

	var lastTick = valueOrDefault$b(generationOptions.max, tickVal);
	ticks.push(lastTick);

	return ticks;
}

var defaultConfig$2 = {
	position: 'left',

	// label settings
	ticks: {
		callback: core_ticks.formatters.logarithmic
	}
};

// TODO(v3): change this to positiveOrDefault
function nonNegativeOrDefault(value, defaultValue) {
	return helpers$1.isFinite(value) && value >= 0 ? value : defaultValue;
}

var scale_logarithmic = core_scale.extend({
	determineDataLimits: function() {
		var me = this;
		var opts = me.options;
		var chart = me.chart;
		var datasets = chart.data.datasets;
		var isHorizontal = me.isHorizontal();
		function IDMatches(meta) {
			return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
		}
		var datasetIndex, meta, value, data, i, ilen;

		// Calculate Range
		me.min = Number.POSITIVE_INFINITY;
		me.max = Number.NEGATIVE_INFINITY;
		me.minNotZero = Number.POSITIVE_INFINITY;

		var hasStacks = opts.stacked;
		if (hasStacks === undefined) {
			for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
				meta = chart.getDatasetMeta(datasetIndex);
				if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
					meta.stack !== undefined) {
					hasStacks = true;
					break;
				}
			}
		}

		if (opts.stacked || hasStacks) {
			var valuesPerStack = {};

			for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
				meta = chart.getDatasetMeta(datasetIndex);
				var key = [
					meta.type,
					// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
					((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
					meta.stack
				].join('.');

				if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
					if (valuesPerStack[key] === undefined) {
						valuesPerStack[key] = [];
					}

					data = datasets[datasetIndex].data;
					for (i = 0, ilen = data.length; i < ilen; i++) {
						var values = valuesPerStack[key];
						value = me._parseValue(data[i]);
						// invalid, hidden and negative values are ignored
						if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) {
							continue;
						}
						values[i] = values[i] || 0;
						values[i] += value.max;
					}
				}
			}

			helpers$1.each(valuesPerStack, function(valuesForType) {
				if (valuesForType.length > 0) {
					var minVal = helpers$1.min(valuesForType);
					var maxVal = helpers$1.max(valuesForType);
					me.min = Math.min(me.min, minVal);
					me.max = Math.max(me.max, maxVal);
				}
			});

		} else {
			for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
				meta = chart.getDatasetMeta(datasetIndex);
				if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
					data = datasets[datasetIndex].data;
					for (i = 0, ilen = data.length; i < ilen; i++) {
						value = me._parseValue(data[i]);
						// invalid, hidden and negative values are ignored
						if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) {
							continue;
						}

						me.min = Math.min(value.min, me.min);
						me.max = Math.max(value.max, me.max);

						if (value.min !== 0) {
							me.minNotZero = Math.min(value.min, me.minNotZero);
						}
					}
				}
			}
		}

		me.min = helpers$1.isFinite(me.min) ? me.min : null;
		me.max = helpers$1.isFinite(me.max) ? me.max : null;
		me.minNotZero = helpers$1.isFinite(me.minNotZero) ? me.minNotZero : null;

		// Common base implementation to handle ticks.min, ticks.max
		this.handleTickRangeOptions();
	},

	handleTickRangeOptions: function() {
		var me = this;
		var tickOpts = me.options.ticks;
		var DEFAULT_MIN = 1;
		var DEFAULT_MAX = 10;

		me.min = nonNegativeOrDefault(tickOpts.min, me.min);
		me.max = nonNegativeOrDefault(tickOpts.max, me.max);

		if (me.min === me.max) {
			if (me.min !== 0 && me.min !== null) {
				me.min = Math.pow(10, Math.floor(log10(me.min)) - 1);
				me.max = Math.pow(10, Math.floor(log10(me.max)) + 1);
			} else {
				me.min = DEFAULT_MIN;
				me.max = DEFAULT_MAX;
			}
		}
		if (me.min === null) {
			me.min = Math.pow(10, Math.floor(log10(me.max)) - 1);
		}
		if (me.max === null) {
			me.max = me.min !== 0
				? Math.pow(10, Math.floor(log10(me.min)) + 1)
				: DEFAULT_MAX;
		}
		if (me.minNotZero === null) {
			if (me.min > 0) {
				me.minNotZero = me.min;
			} else if (me.max < 1) {
				me.minNotZero = Math.pow(10, Math.floor(log10(me.max)));
			} else {
				me.minNotZero = DEFAULT_MIN;
			}
		}
	},

	buildTicks: function() {
		var me = this;
		var tickOpts = me.options.ticks;
		var reverse = !me.isHorizontal();

		var generationOptions = {
			min: nonNegativeOrDefault(tickOpts.min),
			max: nonNegativeOrDefault(tickOpts.max)
		};
		var ticks = me.ticks = generateTicks$1(generationOptions, me);

		// At this point, we need to update our max and min given the tick values since we have expanded the
		// range of the scale
		me.max = helpers$1.max(ticks);
		me.min = helpers$1.min(ticks);

		if (tickOpts.reverse) {
			reverse = !reverse;
			me.start = me.max;
			me.end = me.min;
		} else {
			me.start = me.min;
			me.end = me.max;
		}
		if (reverse) {
			ticks.reverse();
		}
	},

	convertTicksToLabels: function() {
		this.tickValues = this.ticks.slice();

		core_scale.prototype.convertTicksToLabels.call(this);
	},

	// Get the correct tooltip label
	getLabelForIndex: function(index, datasetIndex) {
		return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
	},

	getPixelForTick: function(index) {
		var ticks = this.tickValues;
		if (index < 0 || index > ticks.length - 1) {
			return null;
		}
		return this.getPixelForValue(ticks[index]);
	},

	/**
	 * Returns the value of the first tick.
	 * @param {number} value - The minimum not zero value.
	 * @return {number} The first tick value.
	 * @private
	 */
	_getFirstTickValue: function(value) {
		var exp = Math.floor(log10(value));
		var significand = Math.floor(value / Math.pow(10, exp));

		return significand * Math.pow(10, exp);
	},

	_configure: function() {
		var me = this;
		var start = me.min;
		var offset = 0;

		core_scale.prototype._configure.call(me);

		if (start === 0) {
			start = me._getFirstTickValue(me.minNotZero);
			offset = valueOrDefault$b(me.options.ticks.fontSize, core_defaults.global.defaultFontSize) / me._length;
		}

		me._startValue = log10(start);
		me._valueOffset = offset;
		me._valueRange = (log10(me.max) - log10(start)) / (1 - offset);
	},

	getPixelForValue: function(value) {
		var me = this;
		var decimal = 0;

		value = +me.getRightValue(value);

		if (value > me.min && value > 0) {
			decimal = (log10(value) - me._startValue) / me._valueRange + me._valueOffset;
		}
		return me.getPixelForDecimal(decimal);
	},

	getValueForPixel: function(pixel) {
		var me = this;
		var decimal = me.getDecimalForPixel(pixel);
		return decimal === 0 && me.min === 0
			? 0
			: Math.pow(10, me._startValue + (decimal - me._valueOffset) * me._valueRange);
	}
});

// INTERNAL: static default options, registered in src/index.js
var _defaults$2 = defaultConfig$2;
scale_logarithmic._defaults = _defaults$2;

var valueOrDefault$c = helpers$1.valueOrDefault;
var valueAtIndexOrDefault$1 = helpers$1.valueAtIndexOrDefault;
var resolve$4 = helpers$1.options.resolve;

var defaultConfig$3 = {
	display: true,

	// Boolean - Whether to animate scaling the chart from the centre
	animate: true,
	position: 'chartArea',

	angleLines: {
		display: true,
		color: 'rgba(0,0,0,0.1)',
		lineWidth: 1,
		borderDash: [],
		borderDashOffset: 0.0
	},

	gridLines: {
		circular: false
	},

	// label settings
	ticks: {
		// Boolean - Show a backdrop to the scale label
		showLabelBackdrop: true,

		// String - The colour of the label backdrop
		backdropColor: 'rgba(255,255,255,0.75)',

		// Number - The backdrop padding above & below the label in pixels
		backdropPaddingY: 2,

		// Number - The backdrop padding to the side of the label in pixels
		backdropPaddingX: 2,

		callback: core_ticks.formatters.linear
	},

	pointLabels: {
		// Boolean - if true, show point labels
		display: true,

		// Number - Point label font size in pixels
		fontSize: 10,

		// Function - Used to convert point labels
		callback: function(label) {
			return label;
		}
	}
};

function getTickBackdropHeight(opts) {
	var tickOpts = opts.ticks;

	if (tickOpts.display && opts.display) {
		return valueOrDefault$c(tickOpts.fontSize, core_defaults.global.defaultFontSize) + tickOpts.backdropPaddingY * 2;
	}
	return 0;
}

function measureLabelSize(ctx, lineHeight, label) {
	if (helpers$1.isArray(label)) {
		return {
			w: helpers$1.longestText(ctx, ctx.font, label),
			h: label.length * lineHeight
		};
	}

	return {
		w: ctx.measureText(label).width,
		h: lineHeight
	};
}

function determineLimits(angle, pos, size, min, max) {
	if (angle === min || angle === max) {
		return {
			start: pos - (size / 2),
			end: pos + (size / 2)
		};
	} else if (angle < min || angle > max) {
		return {
			start: pos - size,
			end: pos
		};
	}

	return {
		start: pos,
		end: pos + size
	};
}

/**
 * Helper function to fit a radial linear scale with point labels
 */
function fitWithPointLabels(scale) {

	// Right, this is really confusing and there is a lot of maths going on here
	// The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
	//
	// Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
	//
	// Solution:
	//
	// We assume the radius of the polygon is half the size of the canvas at first
	// at each index we check if the text overlaps.
	//
	// Where it does, we store that angle and that index.
	//
	// After finding the largest index and angle we calculate how much we need to remove
	// from the shape radius to move the point inwards by that x.
	//
	// We average the left and right distances to get the maximum shape radius that can fit in the box
	// along with labels.
	//
	// Once we have that, we can find the centre point for the chart, by taking the x text protrusion
	// on each side, removing that from the size, halving it and adding the left x protrusion width.
	//
	// This will mean we have a shape fitted to the canvas, as large as it can be with the labels
	// and position it in the most space efficient manner
	//
	// https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif

	var plFont = helpers$1.options._parseFont(scale.options.pointLabels);

	// Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
	// Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
	var furthestLimits = {
		l: 0,
		r: scale.width,
		t: 0,
		b: scale.height - scale.paddingTop
	};
	var furthestAngles = {};
	var i, textSize, pointPosition;

	scale.ctx.font = plFont.string;
	scale._pointLabelSizes = [];

	var valueCount = scale.chart.data.labels.length;
	for (i = 0; i < valueCount; i++) {
		pointPosition = scale.getPointPosition(i, scale.drawingArea + 5);
		textSize = measureLabelSize(scale.ctx, plFont.lineHeight, scale.pointLabels[i]);
		scale._pointLabelSizes[i] = textSize;

		// Add quarter circle to make degree 0 mean top of circle
		var angleRadians = scale.getIndexAngle(i);
		var angle = helpers$1.toDegrees(angleRadians) % 360;
		var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
		var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);

		if (hLimits.start < furthestLimits.l) {
			furthestLimits.l = hLimits.start;
			furthestAngles.l = angleRadians;
		}

		if (hLimits.end > furthestLimits.r) {
			furthestLimits.r = hLimits.end;
			furthestAngles.r = angleRadians;
		}

		if (vLimits.start < furthestLimits.t) {
			furthestLimits.t = vLimits.start;
			furthestAngles.t = angleRadians;
		}

		if (vLimits.end > furthestLimits.b) {
			furthestLimits.b = vLimits.end;
			furthestAngles.b = angleRadians;
		}
	}

	scale.setReductions(scale.drawingArea, furthestLimits, furthestAngles);
}

function getTextAlignForAngle(angle) {
	if (angle === 0 || angle === 180) {
		return 'center';
	} else if (angle < 180) {
		return 'left';
	}

	return 'right';
}

function fillText(ctx, text, position, lineHeight) {
	var y = position.y + lineHeight / 2;
	var i, ilen;

	if (helpers$1.isArray(text)) {
		for (i = 0, ilen = text.length; i < ilen; ++i) {
			ctx.fillText(text[i], position.x, y);
			y += lineHeight;
		}
	} else {
		ctx.fillText(text, position.x, y);
	}
}

function adjustPointPositionForLabelHeight(angle, textSize, position) {
	if (angle === 90 || angle === 270) {
		position.y -= (textSize.h / 2);
	} else if (angle > 270 || angle < 90) {
		position.y -= textSize.h;
	}
}

function drawPointLabels(scale) {
	var ctx = scale.ctx;
	var opts = scale.options;
	var pointLabelOpts = opts.pointLabels;
	var tickBackdropHeight = getTickBackdropHeight(opts);
	var outerDistance = scale.getDistanceFromCenterForValue(opts.ticks.reverse ? scale.min : scale.max);
	var plFont = helpers$1.options._parseFont(pointLabelOpts);

	ctx.save();

	ctx.font = plFont.string;
	ctx.textBaseline = 'middle';

	for (var i = scale.chart.data.labels.length - 1; i >= 0; i--) {
		// Extra pixels out for some label spacing
		var extra = (i === 0 ? tickBackdropHeight / 2 : 0);
		var pointLabelPosition = scale.getPointPosition(i, outerDistance + extra + 5);

		// Keep this in loop since we may support array properties here
		var pointLabelFontColor = valueAtIndexOrDefault$1(pointLabelOpts.fontColor, i, core_defaults.global.defaultFontColor);
		ctx.fillStyle = pointLabelFontColor;

		var angleRadians = scale.getIndexAngle(i);
		var angle = helpers$1.toDegrees(angleRadians);
		ctx.textAlign = getTextAlignForAngle(angle);
		adjustPointPositionForLabelHeight(angle, scale._pointLabelSizes[i], pointLabelPosition);
		fillText(ctx, scale.pointLabels[i], pointLabelPosition, plFont.lineHeight);
	}
	ctx.restore();
}

function drawRadiusLine(scale, gridLineOpts, radius, index) {
	var ctx = scale.ctx;
	var circular = gridLineOpts.circular;
	var valueCount = scale.chart.data.labels.length;
	var lineColor = valueAtIndexOrDefault$1(gridLineOpts.color, index - 1);
	var lineWidth = valueAtIndexOrDefault$1(gridLineOpts.lineWidth, index - 1);
	var pointPosition;

	if ((!circular && !valueCount) || !lineColor || !lineWidth) {
		return;
	}

	ctx.save();
	ctx.strokeStyle = lineColor;
	ctx.lineWidth = lineWidth;
	if (ctx.setLineDash) {
		ctx.setLineDash(gridLineOpts.borderDash || []);
		ctx.lineDashOffset = gridLineOpts.borderDashOffset || 0.0;
	}

	ctx.beginPath();
	if (circular) {
		// Draw circular arcs between the points
		ctx.arc(scale.xCenter, scale.yCenter, radius, 0, Math.PI * 2);
	} else {
		// Draw straight lines connecting each index
		pointPosition = scale.getPointPosition(0, radius);
		ctx.moveTo(pointPosition.x, pointPosition.y);

		for (var i = 1; i < valueCount; i++) {
			pointPosition = scale.getPointPosition(i, radius);
			ctx.lineTo(pointPosition.x, pointPosition.y);
		}
	}
	ctx.closePath();
	ctx.stroke();
	ctx.restore();
}

function numberOrZero(param) {
	return helpers$1.isNumber(param) ? param : 0;
}

var scale_radialLinear = scale_linearbase.extend({
	setDimensions: function() {
		var me = this;

		// Set the unconstrained dimension before label rotation
		me.width = me.maxWidth;
		me.height = me.maxHeight;
		me.paddingTop = getTickBackdropHeight(me.options) / 2;
		me.xCenter = Math.floor(me.width / 2);
		me.yCenter = Math.floor((me.height - me.paddingTop) / 2);
		me.drawingArea = Math.min(me.height - me.paddingTop, me.width) / 2;
	},

	determineDataLimits: function() {
		var me = this;
		var chart = me.chart;
		var min = Number.POSITIVE_INFINITY;
		var max = Number.NEGATIVE_INFINITY;

		helpers$1.each(chart.data.datasets, function(dataset, datasetIndex) {
			if (chart.isDatasetVisible(datasetIndex)) {
				var meta = chart.getDatasetMeta(datasetIndex);

				helpers$1.each(dataset.data, function(rawValue, index) {
					var value = +me.getRightValue(rawValue);
					if (isNaN(value) || meta.data[index].hidden) {
						return;
					}

					min = Math.min(value, min);
					max = Math.max(value, max);
				});
			}
		});

		me.min = (min === Number.POSITIVE_INFINITY ? 0 : min);
		me.max = (max === Number.NEGATIVE_INFINITY ? 0 : max);

		// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
		me.handleTickRangeOptions();
	},

	// Returns the maximum number of ticks based on the scale dimension
	_computeTickLimit: function() {
		return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
	},

	convertTicksToLabels: function() {
		var me = this;

		scale_linearbase.prototype.convertTicksToLabels.call(me);

		// Point labels
		me.pointLabels = me.chart.data.labels.map(function() {
			var label = helpers$1.callback(me.options.pointLabels.callback, arguments, me);
			return label || label === 0 ? label : '';
		});
	},

	getLabelForIndex: function(index, datasetIndex) {
		return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
	},

	fit: function() {
		var me = this;
		var opts = me.options;

		if (opts.display && opts.pointLabels.display) {
			fitWithPointLabels(me);
		} else {
			me.setCenterPoint(0, 0, 0, 0);
		}
	},

	/**
	 * Set radius reductions and determine new radius and center point
	 * @private
	 */
	setReductions: function(largestPossibleRadius, furthestLimits, furthestAngles) {
		var me = this;
		var radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
		var radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
		var radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
		var radiusReductionBottom = -Math.max(furthestLimits.b - (me.height - me.paddingTop), 0) / Math.cos(furthestAngles.b);

		radiusReductionLeft = numberOrZero(radiusReductionLeft);
		radiusReductionRight = numberOrZero(radiusReductionRight);
		radiusReductionTop = numberOrZero(radiusReductionTop);
		radiusReductionBottom = numberOrZero(radiusReductionBottom);

		me.drawingArea = Math.min(
			Math.floor(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2),
			Math.floor(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2));
		me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
	},

	setCenterPoint: function(leftMovement, rightMovement, topMovement, bottomMovement) {
		var me = this;
		var maxRight = me.width - rightMovement - me.drawingArea;
		var maxLeft = leftMovement + me.drawingArea;
		var maxTop = topMovement + me.drawingArea;
		var maxBottom = (me.height - me.paddingTop) - bottomMovement - me.drawingArea;

		me.xCenter = Math.floor(((maxLeft + maxRight) / 2) + me.left);
		me.yCenter = Math.floor(((maxTop + maxBottom) / 2) + me.top + me.paddingTop);
	},

	getIndexAngle: function(index) {
		var chart = this.chart;
		var angleMultiplier = 360 / chart.data.labels.length;
		var options = chart.options || {};
		var startAngle = options.startAngle || 0;

		// Start from the top instead of right, so remove a quarter of the circle
		var angle = (index * angleMultiplier + startAngle) % 360;

		return (angle < 0 ? angle + 360 : angle) * Math.PI * 2 / 360;
	},

	getDistanceFromCenterForValue: function(value) {
		var me = this;

		if (helpers$1.isNullOrUndef(value)) {
			return NaN;
		}

		// Take into account half font size + the yPadding of the top value
		var scalingFactor = me.drawingArea / (me.max - me.min);
		if (me.options.ticks.reverse) {
			return (me.max - value) * scalingFactor;
		}
		return (value - me.min) * scalingFactor;
	},

	getPointPosition: function(index, distanceFromCenter) {
		var me = this;
		var thisAngle = me.getIndexAngle(index) - (Math.PI / 2);
		return {
			x: Math.cos(thisAngle) * distanceFromCenter + me.xCenter,
			y: Math.sin(thisAngle) * distanceFromCenter + me.yCenter
		};
	},

	getPointPositionForValue: function(index, value) {
		return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
	},

	getBasePosition: function(index) {
		var me = this;
		var min = me.min;
		var max = me.max;

		return me.getPointPositionForValue(index || 0,
			me.beginAtZero ? 0 :
			min < 0 && max < 0 ? max :
			min > 0 && max > 0 ? min :
			0);
	},

	/**
	 * @private
	 */
	_drawGrid: function() {
		var me = this;
		var ctx = me.ctx;
		var opts = me.options;
		var gridLineOpts = opts.gridLines;
		var angleLineOpts = opts.angleLines;
		var lineWidth = valueOrDefault$c(angleLineOpts.lineWidth, gridLineOpts.lineWidth);
		var lineColor = valueOrDefault$c(angleLineOpts.color, gridLineOpts.color);
		var i, offset, position;

		if (opts.pointLabels.display) {
			drawPointLabels(me);
		}

		if (gridLineOpts.display) {
			helpers$1.each(me.ticks, function(label, index) {
				if (index !== 0) {
					offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
					drawRadiusLine(me, gridLineOpts, offset, index);
				}
			});
		}

		if (angleLineOpts.display && lineWidth && lineColor) {
			ctx.save();
			ctx.lineWidth = lineWidth;
			ctx.strokeStyle = lineColor;
			if (ctx.setLineDash) {
				ctx.setLineDash(resolve$4([angleLineOpts.borderDash, gridLineOpts.borderDash, []]));
				ctx.lineDashOffset = resolve$4([angleLineOpts.borderDashOffset, gridLineOpts.borderDashOffset, 0.0]);
			}

			for (i = me.chart.data.labels.length - 1; i >= 0; i--) {
				offset = me.getDistanceFromCenterForValue(opts.ticks.reverse ? me.min : me.max);
				position = me.getPointPosition(i, offset);
				ctx.beginPath();
				ctx.moveTo(me.xCenter, me.yCenter);
				ctx.lineTo(position.x, position.y);
				ctx.stroke();
			}

			ctx.restore();
		}
	},

	/**
	 * @private
	 */
	_drawLabels: function() {
		var me = this;
		var ctx = me.ctx;
		var opts = me.options;
		var tickOpts = opts.ticks;

		if (!tickOpts.display) {
			return;
		}

		var startAngle = me.getIndexAngle(0);
		var tickFont = helpers$1.options._parseFont(tickOpts);
		var tickFontColor = valueOrDefault$c(tickOpts.fontColor, core_defaults.global.defaultFontColor);
		var offset, width;

		ctx.save();
		ctx.font = tickFont.string;
		ctx.translate(me.xCenter, me.yCenter);
		ctx.rotate(startAngle);
		ctx.textAlign = 'center';
		ctx.textBaseline = 'middle';

		helpers$1.each(me.ticks, function(label, index) {
			if (index === 0 && !tickOpts.reverse) {
				return;
			}

			offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);

			if (tickOpts.showLabelBackdrop) {
				width = ctx.measureText(label).width;
				ctx.fillStyle = tickOpts.backdropColor;

				ctx.fillRect(
					-width / 2 - tickOpts.backdropPaddingX,
					-offset - tickFont.size / 2 - tickOpts.backdropPaddingY,
					width + tickOpts.backdropPaddingX * 2,
					tickFont.size + tickOpts.backdropPaddingY * 2
				);
			}

			ctx.fillStyle = tickFontColor;
			ctx.fillText(label, 0, -offset);
		});

		ctx.restore();
	},

	/**
	 * @private
	 */
	_drawTitle: helpers$1.noop
});

// INTERNAL: static default options, registered in src/index.js
var _defaults$3 = defaultConfig$3;
scale_radialLinear._defaults = _defaults$3;

var deprecated$1 = helpers$1._deprecated;
var resolve$5 = helpers$1.options.resolve;
var valueOrDefault$d = helpers$1.valueOrDefault;

// Integer constants are from the ES6 spec.
var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;
var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

var INTERVALS = {
	millisecond: {
		common: true,
		size: 1,
		steps: 1000
	},
	second: {
		common: true,
		size: 1000,
		steps: 60
	},
	minute: {
		common: true,
		size: 60000,
		steps: 60
	},
	hour: {
		common: true,
		size: 3600000,
		steps: 24
	},
	day: {
		common: true,
		size: 86400000,
		steps: 30
	},
	week: {
		common: false,
		size: 604800000,
		steps: 4
	},
	month: {
		common: true,
		size: 2.628e9,
		steps: 12
	},
	quarter: {
		common: false,
		size: 7.884e9,
		steps: 4
	},
	year: {
		common: true,
		size: 3.154e10
	}
};

var UNITS = Object.keys(INTERVALS);

function sorter(a, b) {
	return a - b;
}

function arrayUnique(items) {
	var hash = {};
	var out = [];
	var i, ilen, item;

	for (i = 0, ilen = items.length; i < ilen; ++i) {
		item = items[i];
		if (!hash[item]) {
			hash[item] = true;
			out.push(item);
		}
	}

	return out;
}

function getMin(options) {
	return helpers$1.valueOrDefault(options.time.min, options.ticks.min);
}

function getMax(options) {
	return helpers$1.valueOrDefault(options.time.max, options.ticks.max);
}

/**
 * Returns an array of {time, pos} objects used to interpolate a specific `time` or position
 * (`pos`) on the scale, by searching entries before and after the requested value. `pos` is
 * a decimal between 0 and 1: 0 being the start of the scale (left or top) and 1 the other
 * extremity (left + width or top + height). Note that it would be more optimized to directly
 * store pre-computed pixels, but the scale dimensions are not guaranteed at the time we need
 * to create the lookup table. The table ALWAYS contains at least two items: min and max.
 *
 * @param {number[]} timestamps - timestamps sorted from lowest to highest.
 * @param {string} distribution - If 'linear', timestamps will be spread linearly along the min
 * and max range, so basically, the table will contains only two items: {min, 0} and {max, 1}.
 * If 'series', timestamps will be positioned at the same distance from each other. In this
 * case, only timestamps that break the time linearity are registered, meaning that in the
 * best case, all timestamps are linear, the table contains only min and max.
 */
function buildLookupTable(timestamps, min, max, distribution) {
	if (distribution === 'linear' || !timestamps.length) {
		return [
			{time: min, pos: 0},
			{time: max, pos: 1}
		];
	}

	var table = [];
	var items = [min];
	var i, ilen, prev, curr, next;

	for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
		curr = timestamps[i];
		if (curr > min && curr < max) {
			items.push(curr);
		}
	}

	items.push(max);

	for (i = 0, ilen = items.length; i < ilen; ++i) {
		next = items[i + 1];
		prev = items[i - 1];
		curr = items[i];

		// only add points that breaks the scale linearity
		if (prev === undefined || next === undefined || Math.round((next + prev) / 2) !== curr) {
			table.push({time: curr, pos: i / (ilen - 1)});
		}
	}

	return table;
}

// @see adapted from https://www.anujgakhar.com/2014/03/01/binary-search-in-javascript/
function lookup(table, key, value) {
	var lo = 0;
	var hi = table.length - 1;
	var mid, i0, i1;

	while (lo >= 0 && lo <= hi) {
		mid = (lo + hi) >> 1;
		i0 = table[mid - 1] || null;
		i1 = table[mid];

		if (!i0) {
			// given value is outside table (before first item)
			return {lo: null, hi: i1};
		} else if (i1[key] < value) {
			lo = mid + 1;
		} else if (i0[key] > value) {
			hi = mid - 1;
		} else {
			return {lo: i0, hi: i1};
		}
	}

	// given value is outside table (after last item)
	return {lo: i1, hi: null};
}

/**
 * Linearly interpolates the given source `value` using the table items `skey` values and
 * returns the associated `tkey` value. For example, interpolate(table, 'time', 42, 'pos')
 * returns the position for a timestamp equal to 42. If value is out of bounds, values at
 * index [0, 1] or [n - 1, n] are used for the interpolation.
 */
function interpolate$1(table, skey, sval, tkey) {
	var range = lookup(table, skey, sval);

	// Note: the lookup table ALWAYS contains at least 2 items (min and max)
	var prev = !range.lo ? table[0] : !range.hi ? table[table.length - 2] : range.lo;
	var next = !range.lo ? table[1] : !range.hi ? table[table.length - 1] : range.hi;

	var span = next[skey] - prev[skey];
	var ratio = span ? (sval - prev[skey]) / span : 0;
	var offset = (next[tkey] - prev[tkey]) * ratio;

	return prev[tkey] + offset;
}

function toTimestamp(scale, input) {
	var adapter = scale._adapter;
	var options = scale.options.time;
	var parser = options.parser;
	var format = parser || options.format;
	var value = input;

	if (typeof parser === 'function') {
		value = parser(value);
	}

	// Only parse if its not a timestamp already
	if (!helpers$1.isFinite(value)) {
		value = typeof format === 'string'
			? adapter.parse(value, format)
			: adapter.parse(value);
	}

	if (value !== null) {
		return +value;
	}

	// Labels are in an incompatible format and no `parser` has been provided.
	// The user might still use the deprecated `format` option for parsing.
	if (!parser && typeof format === 'function') {
		value = format(input);

		// `format` could return something else than a timestamp, if so, parse it
		if (!helpers$1.isFinite(value)) {
			value = adapter.parse(value);
		}
	}

	return value;
}

function parse(scale, input) {
	if (helpers$1.isNullOrUndef(input)) {
		return null;
	}

	var options = scale.options.time;
	var value = toTimestamp(scale, scale.getRightValue(input));
	if (value === null) {
		return value;
	}

	if (options.round) {
		value = +scale._adapter.startOf(value, options.round);
	}

	return value;
}

/**
 * Figures out what unit results in an appropriate number of auto-generated ticks
 */
function determineUnitForAutoTicks(minUnit, min, max, capacity) {
	var ilen = UNITS.length;
	var i, interval, factor;

	for (i = UNITS.indexOf(minUnit); i < ilen - 1; ++i) {
		interval = INTERVALS[UNITS[i]];
		factor = interval.steps ? interval.steps : MAX_INTEGER;

		if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) {
			return UNITS[i];
		}
	}

	return UNITS[ilen - 1];
}

/**
 * Figures out what unit to format a set of ticks with
 */
function determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
	var i, unit;

	for (i = UNITS.length - 1; i >= UNITS.indexOf(minUnit); i--) {
		unit = UNITS[i];
		if (INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) {
			return unit;
		}
	}

	return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
}

function determineMajorUnit(unit) {
	for (var i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i) {
		if (INTERVALS[UNITS[i]].common) {
			return UNITS[i];
		}
	}
}

/**
 * Generates a maximum of `capacity` timestamps between min and max, rounded to the
 * `minor` unit using the given scale time `options`.
 * Important: this method can return ticks outside the min and max range, it's the
 * responsibility of the calling code to clamp values if needed.
 */
function generate(scale, min, max, capacity) {
	var adapter = scale._adapter;
	var options = scale.options;
	var timeOpts = options.time;
	var minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, capacity);
	var stepSize = resolve$5([timeOpts.stepSize, timeOpts.unitStepSize, 1]);
	var weekday = minor === 'week' ? timeOpts.isoWeekday : false;
	var first = min;
	var ticks = [];
	var time;

	// For 'week' unit, handle the first day of week option
	if (weekday) {
		first = +adapter.startOf(first, 'isoWeek', weekday);
	}

	// Align first ticks on unit
	first = +adapter.startOf(first, weekday ? 'day' : minor);

	// Prevent browser from freezing in case user options request millions of milliseconds
	if (adapter.diff(max, min, minor) > 100000 * stepSize) {
		throw min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor;
	}

	for (time = first; time < max; time = +adapter.add(time, stepSize, minor)) {
		ticks.push(time);
	}

	if (time === max || options.bounds === 'ticks') {
		ticks.push(time);
	}

	return ticks;
}

/**
 * Returns the start and end offsets from edges in the form of {start, end}
 * where each value is a relative width to the scale and ranges between 0 and 1.
 * They add extra margins on the both sides by scaling down the original scale.
 * Offsets are added when the `offset` option is true.
 */
function computeOffsets(table, ticks, min, max, options) {
	var start = 0;
	var end = 0;
	var first, last;

	if (options.offset && ticks.length) {
		first = interpolate$1(table, 'time', ticks[0], 'pos');
		if (ticks.length === 1) {
			start = 1 - first;
		} else {
			start = (interpolate$1(table, 'time', ticks[1], 'pos') - first) / 2;
		}
		last = interpolate$1(table, 'time', ticks[ticks.length - 1], 'pos');
		if (ticks.length === 1) {
			end = last;
		} else {
			end = (last - interpolate$1(table, 'time', ticks[ticks.length - 2], 'pos')) / 2;
		}
	}

	return {start: start, end: end, factor: 1 / (start + 1 + end)};
}

function setMajorTicks(scale, ticks, map, majorUnit) {
	var adapter = scale._adapter;
	var first = +adapter.startOf(ticks[0].value, majorUnit);
	var last = ticks[ticks.length - 1].value;
	var major, index;

	for (major = first; major <= last; major = +adapter.add(major, 1, majorUnit)) {
		index = map[major];
		if (index >= 0) {
			ticks[index].major = true;
		}
	}
	return ticks;
}

function ticksFromTimestamps(scale, values, majorUnit) {
	var ticks = [];
	var map = {};
	var ilen = values.length;
	var i, value;

	for (i = 0; i < ilen; ++i) {
		value = values[i];
		map[value] = i;

		ticks.push({
			value: value,
			major: false
		});
	}

	// We set the major ticks separately from the above loop because calling startOf for every tick
	// is expensive when there is a large number of ticks
	return (ilen === 0 || !majorUnit) ? ticks : setMajorTicks(scale, ticks, map, majorUnit);
}

var defaultConfig$4 = {
	position: 'bottom',

	/**
	 * Data distribution along the scale:
	 * - 'linear': data are spread according to their time (distances can vary),
	 * - 'series': data are spread at the same distance from each other.
	 * @see https://github.com/chartjs/Chart.js/pull/4507
	 * @since 2.7.0
	 */
	distribution: 'linear',

	/**
	 * Scale boundary strategy (bypassed by min/max time options)
	 * - `data`: make sure data are fully visible, ticks outside are removed
	 * - `ticks`: make sure ticks are fully visible, data outside are truncated
	 * @see https://github.com/chartjs/Chart.js/pull/4556
	 * @since 2.7.0
	 */
	bounds: 'data',

	adapters: {},
	time: {
		parser: false, // false == a pattern string from https://momentjs.com/docs/#/parsing/string-format/ or a custom callback that converts its argument to a moment
		unit: false, // false == automatic or override with week, month, year, etc.
		round: false, // none, or override with week, month, year, etc.
		displayFormat: false, // DEPRECATED
		isoWeekday: false, // override week start day - see https://momentjs.com/docs/#/get-set/iso-weekday/
		minUnit: 'millisecond',
		displayFormats: {}
	},
	ticks: {
		autoSkip: false,

		/**
		 * Ticks generation input values:
		 * - 'auto': generates "optimal" ticks based on scale size and time options.
		 * - 'data': generates ticks from data (including labels from data {t|x|y} objects).
		 * - 'labels': generates ticks from user given `data.labels` values ONLY.
		 * @see https://github.com/chartjs/Chart.js/pull/4507
		 * @since 2.7.0
		 */
		source: 'auto',

		major: {
			enabled: false
		}
	}
};

var scale_time = core_scale.extend({
	initialize: function() {
		this.mergeTicksOptions();
		core_scale.prototype.initialize.call(this);
	},

	update: function() {
		var me = this;
		var options = me.options;
		var time = options.time || (options.time = {});
		var adapter = me._adapter = new core_adapters._date(options.adapters.date);

		// DEPRECATIONS: output a message only one time per update
		deprecated$1('time scale', time.format, 'time.format', 'time.parser');
		deprecated$1('time scale', time.min, 'time.min', 'ticks.min');
		deprecated$1('time scale', time.max, 'time.max', 'ticks.max');

		// Backward compatibility: before introducing adapter, `displayFormats` was
		// supposed to contain *all* unit/string pairs but this can't be resolved
		// when loading the scale (adapters are loaded afterward), so let's populate
		// missing formats on update
		helpers$1.mergeIf(time.displayFormats, adapter.formats());

		return core_scale.prototype.update.apply(me, arguments);
	},

	/**
	 * Allows data to be referenced via 't' attribute
	 */
	getRightValue: function(rawValue) {
		if (rawValue && rawValue.t !== undefined) {
			rawValue = rawValue.t;
		}
		return core_scale.prototype.getRightValue.call(this, rawValue);
	},

	determineDataLimits: function() {
		var me = this;
		var chart = me.chart;
		var adapter = me._adapter;
		var options = me.options;
		var unit = options.time.unit || 'day';
		var min = MAX_INTEGER;
		var max = MIN_INTEGER;
		var timestamps = [];
		var datasets = [];
		var labels = [];
		var i, j, ilen, jlen, data, timestamp, labelsAdded;
		var dataLabels = me._getLabels();

		for (i = 0, ilen = dataLabels.length; i < ilen; ++i) {
			labels.push(parse(me, dataLabels[i]));
		}

		for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
			if (chart.isDatasetVisible(i)) {
				data = chart.data.datasets[i].data;

				// Let's consider that all data have the same format.
				if (helpers$1.isObject(data[0])) {
					datasets[i] = [];

					for (j = 0, jlen = data.length; j < jlen; ++j) {
						timestamp = parse(me, data[j]);
						timestamps.push(timestamp);
						datasets[i][j] = timestamp;
					}
				} else {
					datasets[i] = labels.slice(0);
					if (!labelsAdded) {
						timestamps = timestamps.concat(labels);
						labelsAdded = true;
					}
				}
			} else {
				datasets[i] = [];
			}
		}

		if (labels.length) {
			min = Math.min(min, labels[0]);
			max = Math.max(max, labels[labels.length - 1]);
		}

		if (timestamps.length) {
			timestamps = ilen > 1 ? arrayUnique(timestamps).sort(sorter) : timestamps.sort(sorter);
			min = Math.min(min, timestamps[0]);
			max = Math.max(max, timestamps[timestamps.length - 1]);
		}

		min = parse(me, getMin(options)) || min;
		max = parse(me, getMax(options)) || max;

		// In case there is no valid min/max, set limits based on unit time option
		min = min === MAX_INTEGER ? +adapter.startOf(Date.now(), unit) : min;
		max = max === MIN_INTEGER ? +adapter.endOf(Date.now(), unit) + 1 : max;

		// Make sure that max is strictly higher than min (required by the lookup table)
		me.min = Math.min(min, max);
		me.max = Math.max(min + 1, max);

		// PRIVATE
		me._table = [];
		me._timestamps = {
			data: timestamps,
			datasets: datasets,
			labels: labels
		};
	},

	buildTicks: function() {
		var me = this;
		var min = me.min;
		var max = me.max;
		var options = me.options;
		var tickOpts = options.ticks;
		var timeOpts = options.time;
		var timestamps = me._timestamps;
		var ticks = [];
		var capacity = me.getLabelCapacity(min);
		var source = tickOpts.source;
		var distribution = options.distribution;
		var i, ilen, timestamp;

		if (source === 'data' || (source === 'auto' && distribution === 'series')) {
			timestamps = timestamps.data;
		} else if (source === 'labels') {
			timestamps = timestamps.labels;
		} else {
			timestamps = generate(me, min, max, capacity);
		}

		if (options.bounds === 'ticks' && timestamps.length) {
			min = timestamps[0];
			max = timestamps[timestamps.length - 1];
		}

		// Enforce limits with user min/max options
		min = parse(me, getMin(options)) || min;
		max = parse(me, getMax(options)) || max;

		// Remove ticks outside the min/max range
		for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
			timestamp = timestamps[i];
			if (timestamp >= min && timestamp <= max) {
				ticks.push(timestamp);
			}
		}

		me.min = min;
		me.max = max;

		// PRIVATE
		// determineUnitForFormatting relies on the number of ticks so we don't use it when
		// autoSkip is enabled because we don't yet know what the final number of ticks will be
		me._unit = timeOpts.unit || (tickOpts.autoSkip
			? determineUnitForAutoTicks(timeOpts.minUnit, me.min, me.max, capacity)
			: determineUnitForFormatting(me, ticks.length, timeOpts.minUnit, me.min, me.max));
		me._majorUnit = !tickOpts.major.enabled || me._unit === 'year' ? undefined
			: determineMajorUnit(me._unit);
		me._table = buildLookupTable(me._timestamps.data, min, max, distribution);
		me._offsets = computeOffsets(me._table, ticks, min, max, options);

		if (tickOpts.reverse) {
			ticks.reverse();
		}

		return ticksFromTimestamps(me, ticks, me._majorUnit);
	},

	getLabelForIndex: function(index, datasetIndex) {
		var me = this;
		var adapter = me._adapter;
		var data = me.chart.data;
		var timeOpts = me.options.time;
		var label = data.labels && index < data.labels.length ? data.labels[index] : '';
		var value = data.datasets[datasetIndex].data[index];

		if (helpers$1.isObject(value)) {
			label = me.getRightValue(value);
		}
		if (timeOpts.tooltipFormat) {
			return adapter.format(toTimestamp(me, label), timeOpts.tooltipFormat);
		}
		if (typeof label === 'string') {
			return label;
		}
		return adapter.format(toTimestamp(me, label), timeOpts.displayFormats.datetime);
	},

	/**
	 * Function to format an individual tick mark
	 * @private
	 */
	tickFormatFunction: function(time, index, ticks, format) {
		var me = this;
		var adapter = me._adapter;
		var options = me.options;
		var formats = options.time.displayFormats;
		var minorFormat = formats[me._unit];
		var majorUnit = me._majorUnit;
		var majorFormat = formats[majorUnit];
		var tick = ticks[index];
		var tickOpts = options.ticks;
		var major = majorUnit && majorFormat && tick && tick.major;
		var label = adapter.format(time, format ? format : major ? majorFormat : minorFormat);
		var nestedTickOpts = major ? tickOpts.major : tickOpts.minor;
		var formatter = resolve$5([
			nestedTickOpts.callback,
			nestedTickOpts.userCallback,
			tickOpts.callback,
			tickOpts.userCallback
		]);

		return formatter ? formatter(label, index, ticks) : label;
	},

	convertTicksToLabels: function(ticks) {
		var labels = [];
		var i, ilen;

		for (i = 0, ilen = ticks.length; i < ilen; ++i) {
			labels.push(this.tickFormatFunction(ticks[i].value, i, ticks));
		}

		return labels;
	},

	/**
	 * @private
	 */
	getPixelForOffset: function(time) {
		var me = this;
		var offsets = me._offsets;
		var pos = interpolate$1(me._table, 'time', time, 'pos');
		return me.getPixelForDecimal((offsets.start + pos) * offsets.factor);
	},

	getPixelForValue: function(value, index, datasetIndex) {
		var me = this;
		var time = null;

		if (index !== undefined && datasetIndex !== undefined) {
			time = me._timestamps.datasets[datasetIndex][index];
		}

		if (time === null) {
			time = parse(me, value);
		}

		if (time !== null) {
			return me.getPixelForOffset(time);
		}
	},

	getPixelForTick: function(index) {
		var ticks = this.getTicks();
		return index >= 0 && index < ticks.length ?
			this.getPixelForOffset(ticks[index].value) :
			null;
	},

	getValueForPixel: function(pixel) {
		var me = this;
		var offsets = me._offsets;
		var pos = me.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
		var time = interpolate$1(me._table, 'pos', pos, 'time');

		// DEPRECATION, we should return time directly
		return me._adapter._create(time);
	},

	/**
	 * @private
	 */
	_getLabelSize: function(label) {
		var me = this;
		var ticksOpts = me.options.ticks;
		var tickLabelWidth = me.ctx.measureText(label).width;
		var angle = helpers$1.toRadians(me.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
		var cosRotation = Math.cos(angle);
		var sinRotation = Math.sin(angle);
		var tickFontSize = valueOrDefault$d(ticksOpts.fontSize, core_defaults.global.defaultFontSize);

		return {
			w: (tickLabelWidth * cosRotation) + (tickFontSize * sinRotation),
			h: (tickLabelWidth * sinRotation) + (tickFontSize * cosRotation)
		};
	},

	/**
	 * Crude approximation of what the label width might be
	 * @private
	 */
	getLabelWidth: function(label) {
		return this._getLabelSize(label).w;
	},

	/**
	 * @private
	 */
	getLabelCapacity: function(exampleTime) {
		var me = this;
		var timeOpts = me.options.time;
		var displayFormats = timeOpts.displayFormats;

		// pick the longest format (milliseconds) for guestimation
		var format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
		var exampleLabel = me.tickFormatFunction(exampleTime, 0, ticksFromTimestamps(me, [exampleTime], me._majorUnit), format);
		var size = me._getLabelSize(exampleLabel);
		var capacity = Math.floor(me.isHorizontal() ? me.width / size.w : me.height / size.h);

		if (me.options.offset) {
			capacity--;
		}

		return capacity > 0 ? capacity : 1;
	}
});

// INTERNAL: static default options, registered in src/index.js
var _defaults$4 = defaultConfig$4;
scale_time._defaults = _defaults$4;

var scales = {
	category: scale_category,
	linear: scale_linear,
	logarithmic: scale_logarithmic,
	radialLinear: scale_radialLinear,
	time: scale_time
};

var FORMATS = {
	datetime: 'MMM D, YYYY, h:mm:ss a',
	millisecond: 'h:mm:ss.SSS a',
	second: 'h:mm:ss a',
	minute: 'h:mm a',
	hour: 'hA',
	day: 'MMM D',
	week: 'll',
	month: 'MMM YYYY',
	quarter: '[Q]Q - YYYY',
	year: 'YYYY'
};

core_adapters._date.override(typeof moment === 'function' ? {
	_id: 'moment', // DEBUG ONLY

	formats: function() {
		return FORMATS;
	},

	parse: function(value, format) {
		if (typeof value === 'string' && typeof format === 'string') {
			value = moment(value, format);
		} else if (!(value instanceof moment)) {
			value = moment(value);
		}
		return value.isValid() ? value.valueOf() : null;
	},

	format: function(time, format) {
		return moment(time).format(format);
	},

	add: function(time, amount, unit) {
		return moment(time).add(amount, unit).valueOf();
	},

	diff: function(max, min, unit) {
		return moment(max).diff(moment(min), unit);
	},

	startOf: function(time, unit, weekday) {
		time = moment(time);
		if (unit === 'isoWeek') {
			return time.isoWeekday(weekday).valueOf();
		}
		return time.startOf(unit).valueOf();
	},

	endOf: function(time, unit) {
		return moment(time).endOf(unit).valueOf();
	},

	// DEPRECATIONS

	/**
	 * Provided for backward compatibility with scale.getValueForPixel().
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */
	_create: function(time) {
		return moment(time);
	},
} : {});

core_defaults._set('global', {
	plugins: {
		filler: {
			propagate: true
		}
	}
});

var mappers = {
	dataset: function(source) {
		var index = source.fill;
		var chart = source.chart;
		var meta = chart.getDatasetMeta(index);
		var visible = meta && chart.isDatasetVisible(index);
		var points = (visible && meta.dataset._children) || [];
		var length = points.length || 0;

		return !length ? null : function(point, i) {
			return (i < length && points[i]._view) || null;
		};
	},

	boundary: function(source) {
		var boundary = source.boundary;
		var x = boundary ? boundary.x : null;
		var y = boundary ? boundary.y : null;

		if (helpers$1.isArray(boundary)) {
			return function(point, i) {
				return boundary[i];
			};
		}

		return function(point) {
			return {
				x: x === null ? point.x : x,
				y: y === null ? point.y : y,
			};
		};
	}
};

// @todo if (fill[0] === '#')
function decodeFill(el, index, count) {
	var model = el._model || {};
	var fill = model.fill;
	var target;

	if (fill === undefined) {
		fill = !!model.backgroundColor;
	}

	if (fill === false || fill === null) {
		return false;
	}

	if (fill === true) {
		return 'origin';
	}

	target = parseFloat(fill, 10);
	if (isFinite(target) && Math.floor(target) === target) {
		if (fill[0] === '-' || fill[0] === '+') {
			target = index + target;
		}

		if (target === index || target < 0 || target >= count) {
			return false;
		}

		return target;
	}

	switch (fill) {
	// compatibility
	case 'bottom':
		return 'start';
	case 'top':
		return 'end';
	case 'zero':
		return 'origin';
	// supported boundaries
	case 'origin':
	case 'start':
	case 'end':
		return fill;
	// invalid fill values
	default:
		return false;
	}
}

function computeLinearBoundary(source) {
	var model = source.el._model || {};
	var scale = source.el._scale || {};
	var fill = source.fill;
	var target = null;
	var horizontal;

	if (isFinite(fill)) {
		return null;
	}

	// Backward compatibility: until v3, we still need to support boundary values set on
	// the model (scaleTop, scaleBottom and scaleZero) because some external plugins and
	// controllers might still use it (e.g. the Smith chart).

	if (fill === 'start') {
		target = model.scaleBottom === undefined ? scale.bottom : model.scaleBottom;
	} else if (fill === 'end') {
		target = model.scaleTop === undefined ? scale.top : model.scaleTop;
	} else if (model.scaleZero !== undefined) {
		target = model.scaleZero;
	} else if (scale.getBasePixel) {
		target = scale.getBasePixel();
	}

	if (target !== undefined && target !== null) {
		if (target.x !== undefined && target.y !== undefined) {
			return target;
		}

		if (helpers$1.isFinite(target)) {
			horizontal = scale.isHorizontal();
			return {
				x: horizontal ? target : null,
				y: horizontal ? null : target
			};
		}
	}

	return null;
}

function computeCircularBoundary(source) {
	var scale = source.el._scale;
	var options = scale.options;
	var length = scale.chart.data.labels.length;
	var fill = source.fill;
	var target = [];
	var start, end, center, i, point;

	if (!length) {
		return null;
	}

	start = options.ticks.reverse ? scale.max : scale.min;
	end = options.ticks.reverse ? scale.min : scale.max;
	center = scale.getPointPositionForValue(0, start);
	for (i = 0; i < length; ++i) {
		point = fill === 'start' || fill === 'end'
			? scale.getPointPositionForValue(i, fill === 'start' ? start : end)
			: scale.getBasePosition(i);
		if (options.gridLines.circular) {
			point.cx = center.x;
			point.cy = center.y;
			point.angle = scale.getIndexAngle(i) - Math.PI / 2;
		}
		target.push(point);
	}
	return target;
}

function computeBoundary(source) {
	var scale = source.el._scale || {};

	if (scale.getPointPositionForValue) {
		return computeCircularBoundary(source);
	}
	return computeLinearBoundary(source);
}

function resolveTarget(sources, index, propagate) {
	var source = sources[index];
	var fill = source.fill;
	var visited = [index];
	var target;

	if (!propagate) {
		return fill;
	}

	while (fill !== false && visited.indexOf(fill) === -1) {
		if (!isFinite(fill)) {
			return fill;
		}

		target = sources[fill];
		if (!target) {
			return false;
		}

		if (target.visible) {
			return fill;
		}

		visited.push(fill);
		fill = target.fill;
	}

	return false;
}

function createMapper(source) {
	var fill = source.fill;
	var type = 'dataset';

	if (fill === false) {
		return null;
	}

	if (!isFinite(fill)) {
		type = 'boundary';
	}

	return mappers[type](source);
}

function isDrawable(point) {
	return point && !point.skip;
}

function drawArea(ctx, curve0, curve1, len0, len1) {
	var i, cx, cy, r;

	if (!len0 || !len1) {
		return;
	}

	// building first area curve (normal)
	ctx.moveTo(curve0[0].x, curve0[0].y);
	for (i = 1; i < len0; ++i) {
		helpers$1.canvas.lineTo(ctx, curve0[i - 1], curve0[i]);
	}

	if (curve1[0].angle !== undefined) {
		cx = curve1[0].cx;
		cy = curve1[0].cy;
		r = Math.sqrt(Math.pow(curve1[0].x - cx, 2) + Math.pow(curve1[0].y - cy, 2));
		for (i = len1 - 1; i > 0; --i) {
			ctx.arc(cx, cy, r, curve1[i].angle, curve1[i - 1].angle, true);
		}
		return;
	}

	// joining the two area curves
	ctx.lineTo(curve1[len1 - 1].x, curve1[len1 - 1].y);

	// building opposite area curve (reverse)
	for (i = len1 - 1; i > 0; --i) {
		helpers$1.canvas.lineTo(ctx, curve1[i], curve1[i - 1], true);
	}
}

function doFill(ctx, points, mapper, view, color, loop) {
	var count = points.length;
	var span = view.spanGaps;
	var curve0 = [];
	var curve1 = [];
	var len0 = 0;
	var len1 = 0;
	var i, ilen, index, p0, p1, d0, d1, loopOffset;

	ctx.beginPath();

	for (i = 0, ilen = count; i < ilen; ++i) {
		index = i % count;
		p0 = points[index]._view;
		p1 = mapper(p0, index, view);
		d0 = isDrawable(p0);
		d1 = isDrawable(p1);

		if (loop && loopOffset === undefined && d0) {
			loopOffset = i + 1;
			ilen = count + loopOffset;
		}

		if (d0 && d1) {
			len0 = curve0.push(p0);
			len1 = curve1.push(p1);
		} else if (len0 && len1) {
			if (!span) {
				drawArea(ctx, curve0, curve1, len0, len1);
				len0 = len1 = 0;
				curve0 = [];
				curve1 = [];
			} else {
				if (d0) {
					curve0.push(p0);
				}
				if (d1) {
					curve1.push(p1);
				}
			}
		}
	}

	drawArea(ctx, curve0, curve1, len0, len1);

	ctx.closePath();
	ctx.fillStyle = color;
	ctx.fill();
}

var plugin_filler = {
	id: 'filler',

	afterDatasetsUpdate: function(chart, options) {
		var count = (chart.data.datasets || []).length;
		var propagate = options.propagate;
		var sources = [];
		var meta, i, el, source;

		for (i = 0; i < count; ++i) {
			meta = chart.getDatasetMeta(i);
			el = meta.dataset;
			source = null;

			if (el && el._model && el instanceof elements.Line) {
				source = {
					visible: chart.isDatasetVisible(i),
					fill: decodeFill(el, i, count),
					chart: chart,
					el: el
				};
			}

			meta.$filler = source;
			sources.push(source);
		}

		for (i = 0; i < count; ++i) {
			source = sources[i];
			if (!source) {
				continue;
			}

			source.fill = resolveTarget(sources, i, propagate);
			source.boundary = computeBoundary(source);
			source.mapper = createMapper(source);
		}
	},

	beforeDatasetsDraw: function(chart) {
		var metasets = chart._getSortedVisibleDatasetMetas();
		var ctx = chart.ctx;
		var meta, i, el, view, points, mapper, color;

		for (i = metasets.length - 1; i >= 0; --i) {
			meta = metasets[i].$filler;

			if (!meta || !meta.visible) {
				continue;
			}

			el = meta.el;
			view = el._view;
			points = el._children || [];
			mapper = meta.mapper;
			color = view.backgroundColor || core_defaults.global.defaultColor;

			if (mapper && color && points.length) {
				helpers$1.canvas.clipArea(ctx, chart.chartArea);
				doFill(ctx, points, mapper, view, color, el._loop);
				helpers$1.canvas.unclipArea(ctx);
			}
		}
	}
};

var getRtlHelper$1 = helpers$1.rtl.getRtlAdapter;
var noop$1 = helpers$1.noop;
var valueOrDefault$e = helpers$1.valueOrDefault;

core_defaults._set('global', {
	legend: {
		display: true,
		position: 'top',
		align: 'center',
		fullWidth: true,
		reverse: false,
		weight: 1000,

		// a callback that will handle
		onClick: function(e, legendItem) {
			var index = legendItem.datasetIndex;
			var ci = this.chart;
			var meta = ci.getDatasetMeta(index);

			// See controller.isDatasetVisible comment
			meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;

			// We hid a dataset ... rerender the chart
			ci.update();
		},

		onHover: null,
		onLeave: null,

		labels: {
			boxWidth: 40,
			padding: 10,
			// Generates labels shown in the legend
			// Valid properties to return:
			// text : text to display
			// fillStyle : fill of coloured box
			// strokeStyle: stroke of coloured box
			// hidden : if this legend item refers to a hidden item
			// lineCap : cap style for line
			// lineDash
			// lineDashOffset :
			// lineJoin :
			// lineWidth :
			generateLabels: function(chart) {
				var datasets = chart.data.datasets;
				var options = chart.options.legend || {};
				var usePointStyle = options.labels && options.labels.usePointStyle;

				return chart._getSortedDatasetMetas().map(function(meta) {
					var style = meta.controller.getStyle(usePointStyle ? 0 : undefined);

					return {
						text: datasets[meta.index].label,
						fillStyle: style.backgroundColor,
						hidden: !chart.isDatasetVisible(meta.index),
						lineCap: style.borderCapStyle,
						lineDash: style.borderDash,
						lineDashOffset: style.borderDashOffset,
						lineJoin: style.borderJoinStyle,
						lineWidth: style.borderWidth,
						strokeStyle: style.borderColor,
						pointStyle: style.pointStyle,
						rotation: style.rotation,

						// Below is extra data used for toggling the datasets
						datasetIndex: meta.index
					};
				}, this);
			}
		}
	},

	legendCallback: function(chart) {
		var list = document.createElement('ul');
		var datasets = chart.data.datasets;
		var i, ilen, listItem, listItemSpan;

		list.setAttribute('class', chart.id + '-legend');

		for (i = 0, ilen = datasets.length; i < ilen; i++) {
			listItem = list.appendChild(document.createElement('li'));
			listItemSpan = listItem.appendChild(document.createElement('span'));
			listItemSpan.style.backgroundColor = datasets[i].backgroundColor;
			if (datasets[i].label) {
				listItem.appendChild(document.createTextNode(datasets[i].label));
			}
		}

		return list.outerHTML;
	}
});

/**
 * Helper function to get the box width based on the usePointStyle option
 * @param {object} labelopts - the label options on the legend
 * @param {number} fontSize - the label font size
 * @return {number} width of the color box area
 */
function getBoxWidth(labelOpts, fontSize) {
	return labelOpts.usePointStyle && labelOpts.boxWidth > fontSize ?
		fontSize :
		labelOpts.boxWidth;
}

/**
 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
 */
var Legend = core_element.extend({

	initialize: function(config) {
		var me = this;
		helpers$1.extend(me, config);

		// Contains hit boxes for each dataset (in dataset order)
		me.legendHitBoxes = [];

		/**
 		 * @private
 		 */
		me._hoveredItem = null;

		// Are we in doughnut mode which has a different data type
		me.doughnutMode = false;
	},

	// These methods are ordered by lifecycle. Utilities then follow.
	// Any function defined here is inherited by all legend types.
	// Any function can be extended by the legend type

	beforeUpdate: noop$1,
	update: function(maxWidth, maxHeight, margins) {
		var me = this;

		// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
		me.beforeUpdate();

		// Absorb the master measurements
		me.maxWidth = maxWidth;
		me.maxHeight = maxHeight;
		me.margins = margins;

		// Dimensions
		me.beforeSetDimensions();
		me.setDimensions();
		me.afterSetDimensions();
		// Labels
		me.beforeBuildLabels();
		me.buildLabels();
		me.afterBuildLabels();

		// Fit
		me.beforeFit();
		me.fit();
		me.afterFit();
		//
		me.afterUpdate();

		return me.minSize;
	},
	afterUpdate: noop$1,

	//

	beforeSetDimensions: noop$1,
	setDimensions: function() {
		var me = this;
		// Set the unconstrained dimension before label rotation
		if (me.isHorizontal()) {
			// Reset position before calculating rotation
			me.width = me.maxWidth;
			me.left = 0;
			me.right = me.width;
		} else {
			me.height = me.maxHeight;

			// Reset position before calculating rotation
			me.top = 0;
			me.bottom = me.height;
		}

		// Reset padding
		me.paddingLeft = 0;
		me.paddingTop = 0;
		me.paddingRight = 0;
		me.paddingBottom = 0;

		// Reset minSize
		me.minSize = {
			width: 0,
			height: 0
		};
	},
	afterSetDimensions: noop$1,

	//

	beforeBuildLabels: noop$1,
	buildLabels: function() {
		var me = this;
		var labelOpts = me.options.labels || {};
		var legendItems = helpers$1.callback(labelOpts.generateLabels, [me.chart], me) || [];

		if (labelOpts.filter) {
			legendItems = legendItems.filter(function(item) {
				return labelOpts.filter(item, me.chart.data);
			});
		}

		if (me.options.reverse) {
			legendItems.reverse();
		}

		me.legendItems = legendItems;
	},
	afterBuildLabels: noop$1,

	//

	beforeFit: noop$1,
	fit: function() {
		var me = this;
		var opts = me.options;
		var labelOpts = opts.labels;
		var display = opts.display;

		var ctx = me.ctx;

		var labelFont = helpers$1.options._parseFont(labelOpts);
		var fontSize = labelFont.size;

		// Reset hit boxes
		var hitboxes = me.legendHitBoxes = [];

		var minSize = me.minSize;
		var isHorizontal = me.isHorizontal();

		if (isHorizontal) {
			minSize.width = me.maxWidth; // fill all the width
			minSize.height = display ? 10 : 0;
		} else {
			minSize.width = display ? 10 : 0;
			minSize.height = me.maxHeight; // fill all the height
		}

		// Increase sizes here
		if (!display) {
			me.width = minSize.width = me.height = minSize.height = 0;
			return;
		}
		ctx.font = labelFont.string;

		if (isHorizontal) {
			// Labels

			// Width of each line of legend boxes. Labels wrap onto multiple lines when there are too many to fit on one
			var lineWidths = me.lineWidths = [0];
			var totalHeight = 0;

			ctx.textAlign = 'left';
			ctx.textBaseline = 'middle';

			helpers$1.each(me.legendItems, function(legendItem, i) {
				var boxWidth = getBoxWidth(labelOpts, fontSize);
				var width = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;

				if (i === 0 || lineWidths[lineWidths.length - 1] + width + 2 * labelOpts.padding > minSize.width) {
					totalHeight += fontSize + labelOpts.padding;
					lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
				}

				// Store the hitbox width and height here. Final position will be updated in `draw`
				hitboxes[i] = {
					left: 0,
					top: 0,
					width: width,
					height: fontSize
				};

				lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
			});

			minSize.height += totalHeight;

		} else {
			var vPadding = labelOpts.padding;
			var columnWidths = me.columnWidths = [];
			var columnHeights = me.columnHeights = [];
			var totalWidth = labelOpts.padding;
			var currentColWidth = 0;
			var currentColHeight = 0;

			helpers$1.each(me.legendItems, function(legendItem, i) {
				var boxWidth = getBoxWidth(labelOpts, fontSize);
				var itemWidth = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;

				// If too tall, go to new column
				if (i > 0 && currentColHeight + fontSize + 2 * vPadding > minSize.height) {
					totalWidth += currentColWidth + labelOpts.padding;
					columnWidths.push(currentColWidth); // previous column width
					columnHeights.push(currentColHeight);
					currentColWidth = 0;
					currentColHeight = 0;
				}

				// Get max width
				currentColWidth = Math.max(currentColWidth, itemWidth);
				currentColHeight += fontSize + vPadding;

				// Store the hitbox width and height here. Final position will be updated in `draw`
				hitboxes[i] = {
					left: 0,
					top: 0,
					width: itemWidth,
					height: fontSize
				};
			});

			totalWidth += currentColWidth;
			columnWidths.push(currentColWidth);
			columnHeights.push(currentColHeight);
			minSize.width += totalWidth;
		}

		me.width = minSize.width;
		me.height = minSize.height;
	},
	afterFit: noop$1,

	// Shared Methods
	isHorizontal: function() {
		return this.options.position === 'top' || this.options.position === 'bottom';
	},

	// Actually draw the legend on the canvas
	draw: function() {
		var me = this;
		var opts = me.options;
		var labelOpts = opts.labels;
		var globalDefaults = core_defaults.global;
		var defaultColor = globalDefaults.defaultColor;
		var lineDefault = globalDefaults.elements.line;
		var legendHeight = me.height;
		var columnHeights = me.columnHeights;
		var legendWidth = me.width;
		var lineWidths = me.lineWidths;

		if (!opts.display) {
			return;
		}

		var rtlHelper = getRtlHelper$1(opts.rtl, me.left, me.minSize.width);
		var ctx = me.ctx;
		var fontColor = valueOrDefault$e(labelOpts.fontColor, globalDefaults.defaultFontColor);
		var labelFont = helpers$1.options._parseFont(labelOpts);
		var fontSize = labelFont.size;
		var cursor;

		// Canvas setup
		ctx.textAlign = rtlHelper.textAlign('left');
		ctx.textBaseline = 'middle';
		ctx.lineWidth = 0.5;
		ctx.strokeStyle = fontColor; // for strikethrough effect
		ctx.fillStyle = fontColor; // render in correct colour
		ctx.font = labelFont.string;

		var boxWidth = getBoxWidth(labelOpts, fontSize);
		var hitboxes = me.legendHitBoxes;

		// current position
		var drawLegendBox = function(x, y, legendItem) {
			if (isNaN(boxWidth) || boxWidth <= 0) {
				return;
			}

			// Set the ctx for the box
			ctx.save();

			var lineWidth = valueOrDefault$e(legendItem.lineWidth, lineDefault.borderWidth);
			ctx.fillStyle = valueOrDefault$e(legendItem.fillStyle, defaultColor);
			ctx.lineCap = valueOrDefault$e(legendItem.lineCap, lineDefault.borderCapStyle);
			ctx.lineDashOffset = valueOrDefault$e(legendItem.lineDashOffset, lineDefault.borderDashOffset);
			ctx.lineJoin = valueOrDefault$e(legendItem.lineJoin, lineDefault.borderJoinStyle);
			ctx.lineWidth = lineWidth;
			ctx.strokeStyle = valueOrDefault$e(legendItem.strokeStyle, defaultColor);

			if (ctx.setLineDash) {
				// IE 9 and 10 do not support line dash
				ctx.setLineDash(valueOrDefault$e(legendItem.lineDash, lineDefault.borderDash));
			}

			if (labelOpts && labelOpts.usePointStyle) {
				// Recalculate x and y for drawPoint() because its expecting
				// x and y to be center of figure (instead of top left)
				var radius = boxWidth * Math.SQRT2 / 2;
				var centerX = rtlHelper.xPlus(x, boxWidth / 2);
				var centerY = y + fontSize / 2;

				// Draw pointStyle as legend symbol
				helpers$1.canvas.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY, legendItem.rotation);
			} else {
				// Draw box as legend symbol
				ctx.fillRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
				if (lineWidth !== 0) {
					ctx.strokeRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
				}
			}

			ctx.restore();
		};

		var fillText = function(x, y, legendItem, textWidth) {
			var halfFontSize = fontSize / 2;
			var xLeft = rtlHelper.xPlus(x, boxWidth + halfFontSize);
			var yMiddle = y + halfFontSize;

			ctx.fillText(legendItem.text, xLeft, yMiddle);

			if (legendItem.hidden) {
				// Strikethrough the text if hidden
				ctx.beginPath();
				ctx.lineWidth = 2;
				ctx.moveTo(xLeft, yMiddle);
				ctx.lineTo(rtlHelper.xPlus(xLeft, textWidth), yMiddle);
				ctx.stroke();
			}
		};

		var alignmentOffset = function(dimension, blockSize) {
			switch (opts.align) {
			case 'start':
				return labelOpts.padding;
			case 'end':
				return dimension - blockSize;
			default: // center
				return (dimension - blockSize + labelOpts.padding) / 2;
			}
		};

		// Horizontal
		var isHorizontal = me.isHorizontal();
		if (isHorizontal) {
			cursor = {
				x: me.left + alignmentOffset(legendWidth, lineWidths[0]),
				y: me.top + labelOpts.padding,
				line: 0
			};
		} else {
			cursor = {
				x: me.left + labelOpts.padding,
				y: me.top + alignmentOffset(legendHeight, columnHeights[0]),
				line: 0
			};
		}

		helpers$1.rtl.overrideTextDirection(me.ctx, opts.textDirection);

		var itemHeight = fontSize + labelOpts.padding;
		helpers$1.each(me.legendItems, function(legendItem, i) {
			var textWidth = ctx.measureText(legendItem.text).width;
			var width = boxWidth + (fontSize / 2) + textWidth;
			var x = cursor.x;
			var y = cursor.y;

			rtlHelper.setWidth(me.minSize.width);

			// Use (me.left + me.minSize.width) and (me.top + me.minSize.height)
			// instead of me.right and me.bottom because me.width and me.height
			// may have been changed since me.minSize was calculated
			if (isHorizontal) {
				if (i > 0 && x + width + labelOpts.padding > me.left + me.minSize.width) {
					y = cursor.y += itemHeight;
					cursor.line++;
					x = cursor.x = me.left + alignmentOffset(legendWidth, lineWidths[cursor.line]);
				}
			} else if (i > 0 && y + itemHeight > me.top + me.minSize.height) {
				x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
				cursor.line++;
				y = cursor.y = me.top + alignmentOffset(legendHeight, columnHeights[cursor.line]);
			}

			var realX = rtlHelper.x(x);

			drawLegendBox(realX, y, legendItem);

			hitboxes[i].left = rtlHelper.leftForLtr(realX, hitboxes[i].width);
			hitboxes[i].top = y;

			// Fill the actual label
			fillText(realX, y, legendItem, textWidth);

			if (isHorizontal) {
				cursor.x += width + labelOpts.padding;
			} else {
				cursor.y += itemHeight;
			}
		});

		helpers$1.rtl.restoreTextDirection(me.ctx, opts.textDirection);
	},

	/**
	 * @private
	 */
	_getLegendItemAt: function(x, y) {
		var me = this;
		var i, hitBox, lh;

		if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
			// See if we are touching one of the dataset boxes
			lh = me.legendHitBoxes;
			for (i = 0; i < lh.length; ++i) {
				hitBox = lh[i];

				if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) {
					// Touching an element
					return me.legendItems[i];
				}
			}
		}

		return null;
	},

	/**
	 * Handle an event
	 * @private
	 * @param {IEvent} event - The event to handle
	 */
	handleEvent: function(e) {
		var me = this;
		var opts = me.options;
		var type = e.type === 'mouseup' ? 'click' : e.type;
		var hoveredItem;

		if (type === 'mousemove') {
			if (!opts.onHover && !opts.onLeave) {
				return;
			}
		} else if (type === 'click') {
			if (!opts.onClick) {
				return;
			}
		} else {
			return;
		}

		// Chart event already has relative position in it
		hoveredItem = me._getLegendItemAt(e.x, e.y);

		if (type === 'click') {
			if (hoveredItem && opts.onClick) {
				// use e.native for backwards compatibility
				opts.onClick.call(me, e.native, hoveredItem);
			}
		} else {
			if (opts.onLeave && hoveredItem !== me._hoveredItem) {
				if (me._hoveredItem) {
					opts.onLeave.call(me, e.native, me._hoveredItem);
				}
				me._hoveredItem = hoveredItem;
			}

			if (opts.onHover && hoveredItem) {
				// use e.native for backwards compatibility
				opts.onHover.call(me, e.native, hoveredItem);
			}
		}
	}
});

function createNewLegendAndAttach(chart, legendOpts) {
	var legend = new Legend({
		ctx: chart.ctx,
		options: legendOpts,
		chart: chart
	});

	core_layouts.configure(chart, legend, legendOpts);
	core_layouts.addBox(chart, legend);
	chart.legend = legend;
}

var plugin_legend = {
	id: 'legend',

	/**
	 * Backward compatibility: since 2.1.5, the legend is registered as a plugin, making
	 * Chart.Legend obsolete. To avoid a breaking change, we export the Legend as part of
	 * the plugin, which one will be re-exposed in the chart.js file.
	 * https://github.com/chartjs/Chart.js/pull/2640
	 * @private
	 */
	_element: Legend,

	beforeInit: function(chart) {
		var legendOpts = chart.options.legend;

		if (legendOpts) {
			createNewLegendAndAttach(chart, legendOpts);
		}
	},

	beforeUpdate: function(chart) {
		var legendOpts = chart.options.legend;
		var legend = chart.legend;

		if (legendOpts) {
			helpers$1.mergeIf(legendOpts, core_defaults.global.legend);

			if (legend) {
				core_layouts.configure(chart, legend, legendOpts);
				legend.options = legendOpts;
			} else {
				createNewLegendAndAttach(chart, legendOpts);
			}
		} else if (legend) {
			core_layouts.removeBox(chart, legend);
			delete chart.legend;
		}
	},

	afterEvent: function(chart, e) {
		var legend = chart.legend;
		if (legend) {
			legend.handleEvent(e);
		}
	}
};

var noop$2 = helpers$1.noop;

core_defaults._set('global', {
	title: {
		display: false,
		fontStyle: 'bold',
		fullWidth: true,
		padding: 10,
		position: 'top',
		text: '',
		weight: 2000         // by default greater than legend (1000) to be above
	}
});

/**
 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
 */
var Title = core_element.extend({
	initialize: function(config) {
		var me = this;
		helpers$1.extend(me, config);

		// Contains hit boxes for each dataset (in dataset order)
		me.legendHitBoxes = [];
	},

	// These methods are ordered by lifecycle. Utilities then follow.

	beforeUpdate: noop$2,
	update: function(maxWidth, maxHeight, margins) {
		var me = this;

		// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
		me.beforeUpdate();

		// Absorb the master measurements
		me.maxWidth = maxWidth;
		me.maxHeight = maxHeight;
		me.margins = margins;

		// Dimensions
		me.beforeSetDimensions();
		me.setDimensions();
		me.afterSetDimensions();
		// Labels
		me.beforeBuildLabels();
		me.buildLabels();
		me.afterBuildLabels();

		// Fit
		me.beforeFit();
		me.fit();
		me.afterFit();
		//
		me.afterUpdate();

		return me.minSize;

	},
	afterUpdate: noop$2,

	//

	beforeSetDimensions: noop$2,
	setDimensions: function() {
		var me = this;
		// Set the unconstrained dimension before label rotation
		if (me.isHorizontal()) {
			// Reset position before calculating rotation
			me.width = me.maxWidth;
			me.left = 0;
			me.right = me.width;
		} else {
			me.height = me.maxHeight;

			// Reset position before calculating rotation
			me.top = 0;
			me.bottom = me.height;
		}

		// Reset padding
		me.paddingLeft = 0;
		me.paddingTop = 0;
		me.paddingRight = 0;
		me.paddingBottom = 0;

		// Reset minSize
		me.minSize = {
			width: 0,
			height: 0
		};
	},
	afterSetDimensions: noop$2,

	//

	beforeBuildLabels: noop$2,
	buildLabels: noop$2,
	afterBuildLabels: noop$2,

	//

	beforeFit: noop$2,
	fit: function() {
		var me = this;
		var opts = me.options;
		var minSize = me.minSize = {};
		var isHorizontal = me.isHorizontal();
		var lineCount, textSize;

		if (!opts.display) {
			me.width = minSize.width = me.height = minSize.height = 0;
			return;
		}

		lineCount = helpers$1.isArray(opts.text) ? opts.text.length : 1;
		textSize = lineCount * helpers$1.options._parseFont(opts).lineHeight + opts.padding * 2;

		me.width = minSize.width = isHorizontal ? me.maxWidth : textSize;
		me.height = minSize.height = isHorizontal ? textSize : me.maxHeight;
	},
	afterFit: noop$2,

	// Shared Methods
	isHorizontal: function() {
		var pos = this.options.position;
		return pos === 'top' || pos === 'bottom';
	},

	// Actually draw the title block on the canvas
	draw: function() {
		var me = this;
		var ctx = me.ctx;
		var opts = me.options;

		if (!opts.display) {
			return;
		}

		var fontOpts = helpers$1.options._parseFont(opts);
		var lineHeight = fontOpts.lineHeight;
		var offset = lineHeight / 2 + opts.padding;
		var rotation = 0;
		var top = me.top;
		var left = me.left;
		var bottom = me.bottom;
		var right = me.right;
		var maxWidth, titleX, titleY;

		ctx.fillStyle = helpers$1.valueOrDefault(opts.fontColor, core_defaults.global.defaultFontColor); // render in correct colour
		ctx.font = fontOpts.string;

		// Horizontal
		if (me.isHorizontal()) {
			titleX = left + ((right - left) / 2); // midpoint of the width
			titleY = top + offset;
			maxWidth = right - left;
		} else {
			titleX = opts.position === 'left' ? left + offset : right - offset;
			titleY = top + ((bottom - top) / 2);
			maxWidth = bottom - top;
			rotation = Math.PI * (opts.position === 'left' ? -0.5 : 0.5);
		}

		ctx.save();
		ctx.translate(titleX, titleY);
		ctx.rotate(rotation);
		ctx.textAlign = 'center';
		ctx.textBaseline = 'middle';

		var text = opts.text;
		if (helpers$1.isArray(text)) {
			var y = 0;
			for (var i = 0; i < text.length; ++i) {
				ctx.fillText(text[i], 0, y, maxWidth);
				y += lineHeight;
			}
		} else {
			ctx.fillText(text, 0, 0, maxWidth);
		}

		ctx.restore();
	}
});

function createNewTitleBlockAndAttach(chart, titleOpts) {
	var title = new Title({
		ctx: chart.ctx,
		options: titleOpts,
		chart: chart
	});

	core_layouts.configure(chart, title, titleOpts);
	core_layouts.addBox(chart, title);
	chart.titleBlock = title;
}

var plugin_title = {
	id: 'title',

	/**
	 * Backward compatibility: since 2.1.5, the title is registered as a plugin, making
	 * Chart.Title obsolete. To avoid a breaking change, we export the Title as part of
	 * the plugin, which one will be re-exposed in the chart.js file.
	 * https://github.com/chartjs/Chart.js/pull/2640
	 * @private
	 */
	_element: Title,

	beforeInit: function(chart) {
		var titleOpts = chart.options.title;

		if (titleOpts) {
			createNewTitleBlockAndAttach(chart, titleOpts);
		}
	},

	beforeUpdate: function(chart) {
		var titleOpts = chart.options.title;
		var titleBlock = chart.titleBlock;

		if (titleOpts) {
			helpers$1.mergeIf(titleOpts, core_defaults.global.title);

			if (titleBlock) {
				core_layouts.configure(chart, titleBlock, titleOpts);
				titleBlock.options = titleOpts;
			} else {
				createNewTitleBlockAndAttach(chart, titleOpts);
			}
		} else if (titleBlock) {
			core_layouts.removeBox(chart, titleBlock);
			delete chart.titleBlock;
		}
	}
};

var plugins = {};
var filler = plugin_filler;
var legend = plugin_legend;
var title = plugin_title;
plugins.filler = filler;
plugins.legend = legend;
plugins.title = title;

/**
 * @namespace Chart
 */


core_controller.helpers = helpers$1;

// @todo dispatch these helpers into appropriated helpers/helpers.* file and write unit tests!
core_helpers();

core_controller._adapters = core_adapters;
core_controller.Animation = core_animation;
core_controller.animationService = core_animations;
core_controller.controllers = controllers;
core_controller.DatasetController = core_datasetController;
core_controller.defaults = core_defaults;
core_controller.Element = core_element;
core_controller.elements = elements;
core_controller.Interaction = core_interaction;
core_controller.layouts = core_layouts;
core_controller.platform = platform;
core_controller.plugins = core_plugins;
core_controller.Scale = core_scale;
core_controller.scaleService = core_scaleService;
core_controller.Ticks = core_ticks;
core_controller.Tooltip = core_tooltip;

// Register built-in scales

core_controller.helpers.each(scales, function(scale, type) {
	core_controller.scaleService.registerScaleType(type, scale, scale._defaults);
});

// Load to register built-in adapters (as side effects)


// Loading built-in plugins

for (var k in plugins) {
	if (plugins.hasOwnProperty(k)) {
		core_controller.plugins.register(plugins[k]);
	}
}

core_controller.platform.initialize();

var src = core_controller;
if (typeof window !== 'undefined') {
	window.Chart = core_controller;
}

// DEPRECATIONS

/**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Chart
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */
core_controller.Chart = core_controller;

/**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Legend
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */
core_controller.Legend = plugins.legend._element;

/**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Title
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */
core_controller.Title = plugins.title._element;

/**
 * Provided for backward compatibility, use Chart.plugins instead
 * @namespace Chart.pluginService
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */
core_controller.pluginService = core_controller.plugins;

/**
 * Provided for backward compatibility, inheriting from Chart.PlugingBase has no
 * effect, instead simply create/register plugins via plain JavaScript objects.
 * @interface Chart.PluginBase
 * @deprecated since version 2.5.0
 * @todo remove at version 3
 * @private
 */
core_controller.PluginBase = core_controller.Element.extend({});

/**
 * Provided for backward compatibility, use Chart.helpers.canvas instead.
 * @namespace Chart.canvasHelpers
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 * @private
 */
core_controller.canvasHelpers = core_controller.helpers.canvas;

/**
 * Provided for backward compatibility, use Chart.layouts instead.
 * @namespace Chart.layoutService
 * @deprecated since version 2.7.3
 * @todo remove at version 3
 * @private
 */
core_controller.layoutService = core_controller.layouts;

/**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.LinearScaleBase
 * @deprecated since version 2.8
 * @todo remove at version 3
 * @private
 */
core_controller.LinearScaleBase = scale_linearbase;

/**
 * Provided for backward compatibility, instead we should create a new Chart
 * by setting the type in the config (`new Chart(id, {type: '{chart-type}'}`).
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 */
core_controller.helpers.each(
	[
		'Bar',
		'Bubble',
		'Doughnut',
		'Line',
		'PolarArea',
		'Radar',
		'Scatter'
	],
	function(klass) {
		core_controller[klass] = function(ctx, cfg) {
			return new core_controller(ctx, core_controller.helpers.merge(cfg || {}, {
				type: klass.charAt(0).toLowerCase() + klass.slice(1)
			}));
		};
	}
);

return src;

})));

},{"moment":727}],83:[function(require,module,exports){
/**
 * Slice reference.
 */

var slice = [].slice;

/**
 * Bind `obj` to `fn`.
 *
 * @param {Object} obj
 * @param {Function|String} fn or string
 * @return {Function}
 * @api public
 */

module.exports = function(obj, fn){
  if ('string' == typeof fn) fn = obj[fn];
  if ('function' != typeof fn) throw new Error('bind() requires a function');
  var args = slice.call(arguments, 2);
  return function(){
    return fn.apply(obj, args.concat(slice.call(arguments)));
  }
};

},{}],84:[function(require,module,exports){

/**
 * Expose `Emitter`.
 */

if (typeof module !== 'undefined') {
  module.exports = Emitter;
}

/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
};

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on =
Emitter.prototype.addEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};
  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
    .push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function(event, fn){
  function on() {
    this.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off =
Emitter.prototype.removeListener =
Emitter.prototype.removeAllListeners =
Emitter.prototype.removeEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks['$' + event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks['$' + event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }
  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function(event){
  this._callbacks = this._callbacks || {};
  var args = [].slice.call(arguments, 1)
    , callbacks = this._callbacks['$' + event];

  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function(event){
  this._callbacks = this._callbacks || {};
  return this._callbacks['$' + event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function(event){
  return !! this.listeners(event).length;
};

},{}],85:[function(require,module,exports){

module.exports = function(a, b){
  var fn = function(){};
  fn.prototype = b.prototype;
  a.prototype = new fn;
  a.prototype.constructor = a;
};
},{}],86:[function(require,module,exports){
require('../../modules/core.regexp.escape');
module.exports = require('../../modules/_core').RegExp.escape;

},{"../../modules/_core":224,"../../modules/core.regexp.escape":328}],87:[function(require,module,exports){
require('../../modules/es6.string.iterator');
require('../../modules/es6.array.from');
module.exports = require('../../modules/_core').Array.from;

},{"../../modules/_core":111,"../../modules/es6.array.from":183,"../../modules/es6.string.iterator":195}],88:[function(require,module,exports){
require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.get-iterator');

},{"../modules/core.get-iterator":181,"../modules/es6.string.iterator":195,"../modules/web.dom.iterable":203}],89:[function(require,module,exports){
require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.is-iterable');

},{"../modules/core.is-iterable":182,"../modules/es6.string.iterator":195,"../modules/web.dom.iterable":203}],90:[function(require,module,exports){
var core = require('../../modules/_core');
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};

},{"../../modules/_core":111}],91:[function(require,module,exports){
require('../../modules/es6.number.is-integer');
module.exports = require('../../modules/_core').Number.isInteger;

},{"../../modules/_core":111,"../../modules/es6.number.is-integer":185}],92:[function(require,module,exports){
require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;

},{"../../modules/_core":111,"../../modules/es6.object.assign":186}],93:[function(require,module,exports){
require('../../modules/es6.object.create');
var $Object = require('../../modules/_core').Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};

},{"../../modules/_core":111,"../../modules/es6.object.create":187}],94:[function(require,module,exports){
require('../../modules/es6.object.define-properties');
var $Object = require('../../modules/_core').Object;
module.exports = function defineProperties(T, D) {
  return $Object.defineProperties(T, D);
};

},{"../../modules/_core":111,"../../modules/es6.object.define-properties":188}],95:[function(require,module,exports){
require('../../modules/es6.object.define-property');
var $Object = require('../../modules/_core').Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};

},{"../../modules/_core":111,"../../modules/es6.object.define-property":189}],96:[function(require,module,exports){
require('../../modules/es7.object.entries');
module.exports = require('../../modules/_core').Object.entries;

},{"../../modules/_core":111,"../../modules/es7.object.entries":197}],97:[function(require,module,exports){
require('../../modules/es6.object.get-prototype-of');
module.exports = require('../../modules/_core').Object.getPrototypeOf;

},{"../../modules/_core":111,"../../modules/es6.object.get-prototype-of":190}],98:[function(require,module,exports){
require('../../modules/es6.object.keys');
module.exports = require('../../modules/_core').Object.keys;

},{"../../modules/_core":111,"../../modules/es6.object.keys":191}],99:[function(require,module,exports){
require('../../modules/es6.object.set-prototype-of');
module.exports = require('../../modules/_core').Object.setPrototypeOf;

},{"../../modules/_core":111,"../../modules/es6.object.set-prototype-of":192}],100:[function(require,module,exports){
require('../../modules/es7.object.values');
module.exports = require('../../modules/_core').Object.values;

},{"../../modules/_core":111,"../../modules/es7.object.values":198}],101:[function(require,module,exports){
require('../modules/es6.object.to-string');
require('../modules/es6.string.iterator');
require('../modules/web.dom.iterable');
require('../modules/es6.promise');
require('../modules/es7.promise.finally');
require('../modules/es7.promise.try');
module.exports = require('../modules/_core').Promise;

},{"../modules/_core":111,"../modules/es6.object.to-string":193,"../modules/es6.promise":194,"../modules/es6.string.iterator":195,"../modules/es7.promise.finally":199,"../modules/es7.promise.try":200,"../modules/web.dom.iterable":203}],102:[function(require,module,exports){
require('../../modules/es6.symbol');
require('../../modules/es6.object.to-string');
require('../../modules/es7.symbol.async-iterator');
require('../../modules/es7.symbol.observable');
module.exports = require('../../modules/_core').Symbol;

},{"../../modules/_core":111,"../../modules/es6.object.to-string":193,"../../modules/es6.symbol":196,"../../modules/es7.symbol.async-iterator":201,"../../modules/es7.symbol.observable":202}],103:[function(require,module,exports){
require('../../modules/es6.string.iterator');
require('../../modules/web.dom.iterable');
module.exports = require('../../modules/_wks-ext').f('iterator');

},{"../../modules/_wks-ext":178,"../../modules/es6.string.iterator":195,"../../modules/web.dom.iterable":203}],104:[function(require,module,exports){
module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

},{}],105:[function(require,module,exports){
module.exports = function () { /* empty */ };

},{}],106:[function(require,module,exports){
module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};

},{}],107:[function(require,module,exports){
var isObject = require('./_is-object');
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

},{"./_is-object":132}],108:[function(require,module,exports){
// false -> Array#indexOf
// true  -> Array#includes
var toIObject = require('./_to-iobject');
var toLength = require('./_to-length');
var toAbsoluteIndex = require('./_to-absolute-index');
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

},{"./_to-absolute-index":170,"./_to-iobject":172,"./_to-length":173}],109:[function(require,module,exports){
// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = require('./_cof');
var TAG = require('./_wks')('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

},{"./_cof":110,"./_wks":179}],110:[function(require,module,exports){
var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};

},{}],111:[function(require,module,exports){
var core = module.exports = { version: '2.5.1' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

},{}],112:[function(require,module,exports){
'use strict';
var $defineProperty = require('./_object-dp');
var createDesc = require('./_property-desc');

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};

},{"./_object-dp":145,"./_property-desc":159}],113:[function(require,module,exports){
// optional / simple context binding
var aFunction = require('./_a-function');
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

},{"./_a-function":104}],114:[function(require,module,exports){
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

},{}],115:[function(require,module,exports){
// Thank's IE8 for his funny defineProperty
module.exports = !require('./_fails')(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});

},{"./_fails":120}],116:[function(require,module,exports){
var isObject = require('./_is-object');
var document = require('./_global').document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};

},{"./_global":122,"./_is-object":132}],117:[function(require,module,exports){
// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

},{}],118:[function(require,module,exports){
// all enumerable object keys, includes symbols
var getKeys = require('./_object-keys');
var gOPS = require('./_object-gops');
var pIE = require('./_object-pie');
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};

},{"./_object-gops":150,"./_object-keys":153,"./_object-pie":154}],119:[function(require,module,exports){
var global = require('./_global');
var core = require('./_core');
var ctx = require('./_ctx');
var hide = require('./_hide');
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && key in exports) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;

},{"./_core":111,"./_ctx":113,"./_global":122,"./_hide":124}],120:[function(require,module,exports){
module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

},{}],121:[function(require,module,exports){
var ctx = require('./_ctx');
var call = require('./_iter-call');
var isArrayIter = require('./_is-array-iter');
var anObject = require('./_an-object');
var toLength = require('./_to-length');
var getIterFn = require('./core.get-iterator-method');
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;

},{"./_an-object":107,"./_ctx":113,"./_is-array-iter":129,"./_iter-call":133,"./_to-length":173,"./core.get-iterator-method":180}],122:[function(require,module,exports){
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

},{}],123:[function(require,module,exports){
var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};

},{}],124:[function(require,module,exports){
var dP = require('./_object-dp');
var createDesc = require('./_property-desc');
module.exports = require('./_descriptors') ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

},{"./_descriptors":115,"./_object-dp":145,"./_property-desc":159}],125:[function(require,module,exports){
var document = require('./_global').document;
module.exports = document && document.documentElement;

},{"./_global":122}],126:[function(require,module,exports){
module.exports = !require('./_descriptors') && !require('./_fails')(function () {
  return Object.defineProperty(require('./_dom-create')('div'), 'a', { get: function () { return 7; } }).a != 7;
});

},{"./_descriptors":115,"./_dom-create":116,"./_fails":120}],127:[function(require,module,exports){
// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};

},{}],128:[function(require,module,exports){
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = require('./_cof');
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};

},{"./_cof":110}],129:[function(require,module,exports){
// check on default Array iterator
var Iterators = require('./_iterators');
var ITERATOR = require('./_wks')('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

},{"./_iterators":138,"./_wks":179}],130:[function(require,module,exports){
// 7.2.2 IsArray(argument)
var cof = require('./_cof');
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};

},{"./_cof":110}],131:[function(require,module,exports){
// 20.1.2.3 Number.isInteger(number)
var isObject = require('./_is-object');
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};

},{"./_is-object":132}],132:[function(require,module,exports){
module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

},{}],133:[function(require,module,exports){
// call something on iterator step with safe closing on error
var anObject = require('./_an-object');
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};

},{"./_an-object":107}],134:[function(require,module,exports){
'use strict';
var create = require('./_object-create');
var descriptor = require('./_property-desc');
var setToStringTag = require('./_set-to-string-tag');
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
require('./_hide')(IteratorPrototype, require('./_wks')('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};

},{"./_hide":124,"./_object-create":144,"./_property-desc":159,"./_set-to-string-tag":164,"./_wks":179}],135:[function(require,module,exports){
'use strict';
var LIBRARY = require('./_library');
var $export = require('./_export');
var redefine = require('./_redefine');
var hide = require('./_hide');
var has = require('./_has');
var Iterators = require('./_iterators');
var $iterCreate = require('./_iter-create');
var setToStringTag = require('./_set-to-string-tag');
var getPrototypeOf = require('./_object-gpo');
var ITERATOR = require('./_wks')('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

},{"./_export":119,"./_has":123,"./_hide":124,"./_iter-create":134,"./_iterators":138,"./_library":139,"./_object-gpo":151,"./_redefine":161,"./_set-to-string-tag":164,"./_wks":179}],136:[function(require,module,exports){
var ITERATOR = require('./_wks')('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};

},{"./_wks":179}],137:[function(require,module,exports){
module.exports = function (done, value) {
  return { value: value, done: !!done };
};

},{}],138:[function(require,module,exports){
module.exports = {};

},{}],139:[function(require,module,exports){
module.exports = true;

},{}],140:[function(require,module,exports){
var META = require('./_uid')('meta');
var isObject = require('./_is-object');
var has = require('./_has');
var setDesc = require('./_object-dp').f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !require('./_fails')(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};

},{"./_fails":120,"./_has":123,"./_is-object":132,"./_object-dp":145,"./_uid":176}],141:[function(require,module,exports){
var global = require('./_global');
var macrotask = require('./_task').set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = require('./_cof')(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver
  } else if (Observer) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    var promise = Promise.resolve();
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};

},{"./_cof":110,"./_global":122,"./_task":169}],142:[function(require,module,exports){
'use strict';
// 25.4.1.5 NewPromiseCapability(C)
var aFunction = require('./_a-function');

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};

},{"./_a-function":104}],143:[function(require,module,exports){
'use strict';
// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = require('./_object-keys');
var gOPS = require('./_object-gops');
var pIE = require('./_object-pie');
var toObject = require('./_to-object');
var IObject = require('./_iobject');
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || require('./_fails')(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;

},{"./_fails":120,"./_iobject":128,"./_object-gops":150,"./_object-keys":153,"./_object-pie":154,"./_to-object":174}],144:[function(require,module,exports){
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = require('./_an-object');
var dPs = require('./_object-dps');
var enumBugKeys = require('./_enum-bug-keys');
var IE_PROTO = require('./_shared-key')('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = require('./_dom-create')('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  require('./_html').appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};

},{"./_an-object":107,"./_dom-create":116,"./_enum-bug-keys":117,"./_html":125,"./_object-dps":146,"./_shared-key":165}],145:[function(require,module,exports){
var anObject = require('./_an-object');
var IE8_DOM_DEFINE = require('./_ie8-dom-define');
var toPrimitive = require('./_to-primitive');
var dP = Object.defineProperty;

exports.f = require('./_descriptors') ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

},{"./_an-object":107,"./_descriptors":115,"./_ie8-dom-define":126,"./_to-primitive":175}],146:[function(require,module,exports){
var dP = require('./_object-dp');
var anObject = require('./_an-object');
var getKeys = require('./_object-keys');

module.exports = require('./_descriptors') ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};

},{"./_an-object":107,"./_descriptors":115,"./_object-dp":145,"./_object-keys":153}],147:[function(require,module,exports){
var pIE = require('./_object-pie');
var createDesc = require('./_property-desc');
var toIObject = require('./_to-iobject');
var toPrimitive = require('./_to-primitive');
var has = require('./_has');
var IE8_DOM_DEFINE = require('./_ie8-dom-define');
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = require('./_descriptors') ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};

},{"./_descriptors":115,"./_has":123,"./_ie8-dom-define":126,"./_object-pie":154,"./_property-desc":159,"./_to-iobject":172,"./_to-primitive":175}],148:[function(require,module,exports){
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = require('./_to-iobject');
var gOPN = require('./_object-gopn').f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};

},{"./_object-gopn":149,"./_to-iobject":172}],149:[function(require,module,exports){
// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = require('./_object-keys-internal');
var hiddenKeys = require('./_enum-bug-keys').concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};

},{"./_enum-bug-keys":117,"./_object-keys-internal":152}],150:[function(require,module,exports){
exports.f = Object.getOwnPropertySymbols;

},{}],151:[function(require,module,exports){
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = require('./_has');
var toObject = require('./_to-object');
var IE_PROTO = require('./_shared-key')('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

},{"./_has":123,"./_shared-key":165,"./_to-object":174}],152:[function(require,module,exports){
var has = require('./_has');
var toIObject = require('./_to-iobject');
var arrayIndexOf = require('./_array-includes')(false);
var IE_PROTO = require('./_shared-key')('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

},{"./_array-includes":108,"./_has":123,"./_shared-key":165,"./_to-iobject":172}],153:[function(require,module,exports){
// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = require('./_object-keys-internal');
var enumBugKeys = require('./_enum-bug-keys');

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};

},{"./_enum-bug-keys":117,"./_object-keys-internal":152}],154:[function(require,module,exports){
exports.f = {}.propertyIsEnumerable;

},{}],155:[function(require,module,exports){
// most Object methods by ES6 should accept primitives
var $export = require('./_export');
var core = require('./_core');
var fails = require('./_fails');
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};

},{"./_core":111,"./_export":119,"./_fails":120}],156:[function(require,module,exports){
var getKeys = require('./_object-keys');
var toIObject = require('./_to-iobject');
var isEnum = require('./_object-pie').f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};

},{"./_object-keys":153,"./_object-pie":154,"./_to-iobject":172}],157:[function(require,module,exports){
module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};

},{}],158:[function(require,module,exports){
var anObject = require('./_an-object');
var isObject = require('./_is-object');
var newPromiseCapability = require('./_new-promise-capability');

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

},{"./_an-object":107,"./_is-object":132,"./_new-promise-capability":142}],159:[function(require,module,exports){
module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

},{}],160:[function(require,module,exports){
var hide = require('./_hide');
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};

},{"./_hide":124}],161:[function(require,module,exports){
module.exports = require('./_hide');

},{"./_hide":124}],162:[function(require,module,exports){
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = require('./_is-object');
var anObject = require('./_an-object');
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = require('./_ctx')(Function.call, require('./_object-gopd').f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};

},{"./_an-object":107,"./_ctx":113,"./_is-object":132,"./_object-gopd":147}],163:[function(require,module,exports){
'use strict';
var global = require('./_global');
var core = require('./_core');
var dP = require('./_object-dp');
var DESCRIPTORS = require('./_descriptors');
var SPECIES = require('./_wks')('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};

},{"./_core":111,"./_descriptors":115,"./_global":122,"./_object-dp":145,"./_wks":179}],164:[function(require,module,exports){
var def = require('./_object-dp').f;
var has = require('./_has');
var TAG = require('./_wks')('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};

},{"./_has":123,"./_object-dp":145,"./_wks":179}],165:[function(require,module,exports){
var shared = require('./_shared')('keys');
var uid = require('./_uid');
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};

},{"./_shared":166,"./_uid":176}],166:[function(require,module,exports){
var global = require('./_global');
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};

},{"./_global":122}],167:[function(require,module,exports){
// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = require('./_an-object');
var aFunction = require('./_a-function');
var SPECIES = require('./_wks')('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};

},{"./_a-function":104,"./_an-object":107,"./_wks":179}],168:[function(require,module,exports){
var toInteger = require('./_to-integer');
var defined = require('./_defined');
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

},{"./_defined":114,"./_to-integer":171}],169:[function(require,module,exports){
var ctx = require('./_ctx');
var invoke = require('./_invoke');
var html = require('./_html');
var cel = require('./_dom-create');
var global = require('./_global');
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (require('./_cof')(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};

},{"./_cof":110,"./_ctx":113,"./_dom-create":116,"./_global":122,"./_html":125,"./_invoke":127}],170:[function(require,module,exports){
var toInteger = require('./_to-integer');
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

},{"./_to-integer":171}],171:[function(require,module,exports){
// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

},{}],172:[function(require,module,exports){
// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = require('./_iobject');
var defined = require('./_defined');
module.exports = function (it) {
  return IObject(defined(it));
};

},{"./_defined":114,"./_iobject":128}],173:[function(require,module,exports){
// 7.1.15 ToLength
var toInteger = require('./_to-integer');
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

},{"./_to-integer":171}],174:[function(require,module,exports){
// 7.1.13 ToObject(argument)
var defined = require('./_defined');
module.exports = function (it) {
  return Object(defined(it));
};

},{"./_defined":114}],175:[function(require,module,exports){
// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = require('./_is-object');
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

},{"./_is-object":132}],176:[function(require,module,exports){
var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

},{}],177:[function(require,module,exports){
var global = require('./_global');
var core = require('./_core');
var LIBRARY = require('./_library');
var wksExt = require('./_wks-ext');
var defineProperty = require('./_object-dp').f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};

},{"./_core":111,"./_global":122,"./_library":139,"./_object-dp":145,"./_wks-ext":178}],178:[function(require,module,exports){
exports.f = require('./_wks');

},{"./_wks":179}],179:[function(require,module,exports){
var store = require('./_shared')('wks');
var uid = require('./_uid');
var Symbol = require('./_global').Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

},{"./_global":122,"./_shared":166,"./_uid":176}],180:[function(require,module,exports){
var classof = require('./_classof');
var ITERATOR = require('./_wks')('iterator');
var Iterators = require('./_iterators');
module.exports = require('./_core').getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};

},{"./_classof":109,"./_core":111,"./_iterators":138,"./_wks":179}],181:[function(require,module,exports){
var anObject = require('./_an-object');
var get = require('./core.get-iterator-method');
module.exports = require('./_core').getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};

},{"./_an-object":107,"./_core":111,"./core.get-iterator-method":180}],182:[function(require,module,exports){
var classof = require('./_classof');
var ITERATOR = require('./_wks')('iterator');
var Iterators = require('./_iterators');
module.exports = require('./_core').isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};

},{"./_classof":109,"./_core":111,"./_iterators":138,"./_wks":179}],183:[function(require,module,exports){
'use strict';
var ctx = require('./_ctx');
var $export = require('./_export');
var toObject = require('./_to-object');
var call = require('./_iter-call');
var isArrayIter = require('./_is-array-iter');
var toLength = require('./_to-length');
var createProperty = require('./_create-property');
var getIterFn = require('./core.get-iterator-method');

$export($export.S + $export.F * !require('./_iter-detect')(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});

},{"./_create-property":112,"./_ctx":113,"./_export":119,"./_is-array-iter":129,"./_iter-call":133,"./_iter-detect":136,"./_to-length":173,"./_to-object":174,"./core.get-iterator-method":180}],184:[function(require,module,exports){
'use strict';
var addToUnscopables = require('./_add-to-unscopables');
var step = require('./_iter-step');
var Iterators = require('./_iterators');
var toIObject = require('./_to-iobject');

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = require('./_iter-define')(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

},{"./_add-to-unscopables":105,"./_iter-define":135,"./_iter-step":137,"./_iterators":138,"./_to-iobject":172}],185:[function(require,module,exports){
// 20.1.2.3 Number.isInteger(number)
var $export = require('./_export');

$export($export.S, 'Number', { isInteger: require('./_is-integer') });

},{"./_export":119,"./_is-integer":131}],186:[function(require,module,exports){
// 19.1.3.1 Object.assign(target, source)
var $export = require('./_export');

$export($export.S + $export.F, 'Object', { assign: require('./_object-assign') });

},{"./_export":119,"./_object-assign":143}],187:[function(require,module,exports){
var $export = require('./_export');
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: require('./_object-create') });

},{"./_export":119,"./_object-create":144}],188:[function(require,module,exports){
var $export = require('./_export');
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !require('./_descriptors'), 'Object', { defineProperties: require('./_object-dps') });

},{"./_descriptors":115,"./_export":119,"./_object-dps":146}],189:[function(require,module,exports){
var $export = require('./_export');
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !require('./_descriptors'), 'Object', { defineProperty: require('./_object-dp').f });

},{"./_descriptors":115,"./_export":119,"./_object-dp":145}],190:[function(require,module,exports){
// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = require('./_to-object');
var $getPrototypeOf = require('./_object-gpo');

require('./_object-sap')('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});

},{"./_object-gpo":151,"./_object-sap":155,"./_to-object":174}],191:[function(require,module,exports){
// 19.1.2.14 Object.keys(O)
var toObject = require('./_to-object');
var $keys = require('./_object-keys');

require('./_object-sap')('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});

},{"./_object-keys":153,"./_object-sap":155,"./_to-object":174}],192:[function(require,module,exports){
// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = require('./_export');
$export($export.S, 'Object', { setPrototypeOf: require('./_set-proto').set });

},{"./_export":119,"./_set-proto":162}],193:[function(require,module,exports){
arguments[4][80][0].apply(exports,arguments)
},{"dup":80}],194:[function(require,module,exports){
'use strict';
var LIBRARY = require('./_library');
var global = require('./_global');
var ctx = require('./_ctx');
var classof = require('./_classof');
var $export = require('./_export');
var isObject = require('./_is-object');
var aFunction = require('./_a-function');
var anInstance = require('./_an-instance');
var forOf = require('./_for-of');
var speciesConstructor = require('./_species-constructor');
var task = require('./_task').set;
var microtask = require('./_microtask')();
var newPromiseCapabilityModule = require('./_new-promise-capability');
var perform = require('./_perform');
var promiseResolve = require('./_promise-resolve');
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[require('./_wks')('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value);
            if (domain) domain.exit();
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  if (promise._h == 1) return false;
  var chain = promise._a || promise._c;
  var i = 0;
  var reaction;
  while (chain.length > i) {
    reaction = chain[i++];
    if (reaction.fail || !isUnhandled(reaction.promise)) return false;
  } return true;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = require('./_redefine-all')($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
require('./_set-to-string-tag')($Promise, PROMISE);
require('./_set-species')(PROMISE);
Wrapper = require('./_core')[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && require('./_iter-detect')(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});

},{"./_a-function":104,"./_an-instance":106,"./_classof":109,"./_core":111,"./_ctx":113,"./_export":119,"./_for-of":121,"./_global":122,"./_is-object":132,"./_iter-detect":136,"./_library":139,"./_microtask":141,"./_new-promise-capability":142,"./_perform":157,"./_promise-resolve":158,"./_redefine-all":160,"./_set-species":163,"./_set-to-string-tag":164,"./_species-constructor":167,"./_task":169,"./_wks":179}],195:[function(require,module,exports){
'use strict';
var $at = require('./_string-at')(true);

// 21.1.3.27 String.prototype[@@iterator]()
require('./_iter-define')(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});

},{"./_iter-define":135,"./_string-at":168}],196:[function(require,module,exports){
'use strict';
// ECMAScript 6 symbols shim
var global = require('./_global');
var has = require('./_has');
var DESCRIPTORS = require('./_descriptors');
var $export = require('./_export');
var redefine = require('./_redefine');
var META = require('./_meta').KEY;
var $fails = require('./_fails');
var shared = require('./_shared');
var setToStringTag = require('./_set-to-string-tag');
var uid = require('./_uid');
var wks = require('./_wks');
var wksExt = require('./_wks-ext');
var wksDefine = require('./_wks-define');
var enumKeys = require('./_enum-keys');
var isArray = require('./_is-array');
var anObject = require('./_an-object');
var toIObject = require('./_to-iobject');
var toPrimitive = require('./_to-primitive');
var createDesc = require('./_property-desc');
var _create = require('./_object-create');
var gOPNExt = require('./_object-gopn-ext');
var $GOPD = require('./_object-gopd');
var $DP = require('./_object-dp');
var $keys = require('./_object-keys');
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  require('./_object-gopn').f = gOPNExt.f = $getOwnPropertyNames;
  require('./_object-pie').f = $propertyIsEnumerable;
  require('./_object-gops').f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !require('./_library')) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    replacer = args[1];
    if (typeof replacer == 'function') $replacer = replacer;
    if ($replacer || !isArray(replacer)) replacer = function (key, value) {
      if ($replacer) value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || require('./_hide')($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

},{"./_an-object":107,"./_descriptors":115,"./_enum-keys":118,"./_export":119,"./_fails":120,"./_global":122,"./_has":123,"./_hide":124,"./_is-array":130,"./_library":139,"./_meta":140,"./_object-create":144,"./_object-dp":145,"./_object-gopd":147,"./_object-gopn":149,"./_object-gopn-ext":148,"./_object-gops":150,"./_object-keys":153,"./_object-pie":154,"./_property-desc":159,"./_redefine":161,"./_set-to-string-tag":164,"./_shared":166,"./_to-iobject":172,"./_to-primitive":175,"./_uid":176,"./_wks":179,"./_wks-define":177,"./_wks-ext":178}],197:[function(require,module,exports){
// https://github.com/tc39/proposal-object-values-entries
var $export = require('./_export');
var $entries = require('./_object-to-array')(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});

},{"./_export":119,"./_object-to-array":156}],198:[function(require,module,exports){
// https://github.com/tc39/proposal-object-values-entries
var $export = require('./_export');
var $values = require('./_object-to-array')(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});

},{"./_export":119,"./_object-to-array":156}],199:[function(require,module,exports){
// https://github.com/tc39/proposal-promise-finally
'use strict';
var $export = require('./_export');
var core = require('./_core');
var global = require('./_global');
var speciesConstructor = require('./_species-constructor');
var promiseResolve = require('./_promise-resolve');

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });

},{"./_core":111,"./_export":119,"./_global":122,"./_promise-resolve":158,"./_species-constructor":167}],200:[function(require,module,exports){
'use strict';
// https://github.com/tc39/proposal-promise-try
var $export = require('./_export');
var newPromiseCapability = require('./_new-promise-capability');
var perform = require('./_perform');

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });

},{"./_export":119,"./_new-promise-capability":142,"./_perform":157}],201:[function(require,module,exports){
require('./_wks-define')('asyncIterator');

},{"./_wks-define":177}],202:[function(require,module,exports){
require('./_wks-define')('observable');

},{"./_wks-define":177}],203:[function(require,module,exports){
require('./es6.array.iterator');
var global = require('./_global');
var hide = require('./_hide');
var Iterators = require('./_iterators');
var TO_STRING_TAG = require('./_wks')('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}

},{"./_global":122,"./_hide":124,"./_iterators":138,"./_wks":179,"./es6.array.iterator":184}],204:[function(require,module,exports){
arguments[4][104][0].apply(exports,arguments)
},{"dup":104}],205:[function(require,module,exports){
var cof = require('./_cof');
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};

},{"./_cof":219}],206:[function(require,module,exports){
// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = require('./_wks')('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) require('./_hide')(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};

},{"./_hide":243,"./_wks":326}],207:[function(require,module,exports){
arguments[4][106][0].apply(exports,arguments)
},{"dup":106}],208:[function(require,module,exports){
arguments[4][107][0].apply(exports,arguments)
},{"./_is-object":252,"dup":107}],209:[function(require,module,exports){
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
'use strict';
var toObject = require('./_to-object');
var toAbsoluteIndex = require('./_to-absolute-index');
var toLength = require('./_to-length');

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};

},{"./_to-absolute-index":312,"./_to-length":316,"./_to-object":317}],210:[function(require,module,exports){
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
'use strict';
var toObject = require('./_to-object');
var toAbsoluteIndex = require('./_to-absolute-index');
var toLength = require('./_to-length');
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};

},{"./_to-absolute-index":312,"./_to-length":316,"./_to-object":317}],211:[function(require,module,exports){
var forOf = require('./_for-of');

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};

},{"./_for-of":240}],212:[function(require,module,exports){
arguments[4][108][0].apply(exports,arguments)
},{"./_to-absolute-index":312,"./_to-iobject":315,"./_to-length":316,"dup":108}],213:[function(require,module,exports){
// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = require('./_ctx');
var IObject = require('./_iobject');
var toObject = require('./_to-object');
var toLength = require('./_to-length');
var asc = require('./_array-species-create');
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};

},{"./_array-species-create":216,"./_ctx":226,"./_iobject":248,"./_to-length":316,"./_to-object":317}],214:[function(require,module,exports){
var aFunction = require('./_a-function');
var toObject = require('./_to-object');
var IObject = require('./_iobject');
var toLength = require('./_to-length');

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};

},{"./_a-function":204,"./_iobject":248,"./_to-length":316,"./_to-object":317}],215:[function(require,module,exports){
var isObject = require('./_is-object');
var isArray = require('./_is-array');
var SPECIES = require('./_wks')('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};

},{"./_is-array":250,"./_is-object":252,"./_wks":326}],216:[function(require,module,exports){
// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = require('./_array-species-constructor');

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};

},{"./_array-species-constructor":215}],217:[function(require,module,exports){
'use strict';
var aFunction = require('./_a-function');
var isObject = require('./_is-object');
var invoke = require('./_invoke');
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};

},{"./_a-function":204,"./_invoke":247,"./_is-object":252}],218:[function(require,module,exports){
arguments[4][109][0].apply(exports,arguments)
},{"./_cof":219,"./_wks":326,"dup":109}],219:[function(require,module,exports){
arguments[4][110][0].apply(exports,arguments)
},{"dup":110}],220:[function(require,module,exports){
'use strict';
var dP = require('./_object-dp').f;
var create = require('./_object-create');
var redefineAll = require('./_redefine-all');
var ctx = require('./_ctx');
var anInstance = require('./_an-instance');
var forOf = require('./_for-of');
var $iterDefine = require('./_iter-define');
var step = require('./_iter-step');
var setSpecies = require('./_set-species');
var DESCRIPTORS = require('./_descriptors');
var fastKey = require('./_meta').fastKey;
var validate = require('./_validate-collection');
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};

},{"./_an-instance":207,"./_ctx":226,"./_descriptors":230,"./_for-of":240,"./_iter-define":256,"./_iter-step":258,"./_meta":266,"./_object-create":271,"./_object-dp":272,"./_redefine-all":291,"./_set-species":298,"./_validate-collection":323}],221:[function(require,module,exports){
// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = require('./_classof');
var from = require('./_array-from-iterable');
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};

},{"./_array-from-iterable":211,"./_classof":218}],222:[function(require,module,exports){
'use strict';
var redefineAll = require('./_redefine-all');
var getWeak = require('./_meta').getWeak;
var anObject = require('./_an-object');
var isObject = require('./_is-object');
var anInstance = require('./_an-instance');
var forOf = require('./_for-of');
var createArrayMethod = require('./_array-methods');
var $has = require('./_has');
var validate = require('./_validate-collection');
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};

},{"./_an-instance":207,"./_an-object":208,"./_array-methods":213,"./_for-of":240,"./_has":242,"./_is-object":252,"./_meta":266,"./_redefine-all":291,"./_validate-collection":323}],223:[function(require,module,exports){
'use strict';
var global = require('./_global');
var $export = require('./_export');
var redefine = require('./_redefine');
var redefineAll = require('./_redefine-all');
var meta = require('./_meta');
var forOf = require('./_for-of');
var anInstance = require('./_an-instance');
var isObject = require('./_is-object');
var fails = require('./_fails');
var $iterDetect = require('./_iter-detect');
var setToStringTag = require('./_set-to-string-tag');
var inheritIfRequired = require('./_inherit-if-required');

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};

},{"./_an-instance":207,"./_export":234,"./_fails":236,"./_for-of":240,"./_global":241,"./_inherit-if-required":246,"./_is-object":252,"./_iter-detect":257,"./_meta":266,"./_redefine":292,"./_redefine-all":291,"./_set-to-string-tag":299}],224:[function(require,module,exports){
arguments[4][111][0].apply(exports,arguments)
},{"dup":111}],225:[function(require,module,exports){
arguments[4][112][0].apply(exports,arguments)
},{"./_object-dp":272,"./_property-desc":290,"dup":112}],226:[function(require,module,exports){
arguments[4][113][0].apply(exports,arguments)
},{"./_a-function":204,"dup":113}],227:[function(require,module,exports){
'use strict';
// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = require('./_fails');
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;

},{"./_fails":236}],228:[function(require,module,exports){
'use strict';
var anObject = require('./_an-object');
var toPrimitive = require('./_to-primitive');
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};

},{"./_an-object":208,"./_to-primitive":318}],229:[function(require,module,exports){
arguments[4][114][0].apply(exports,arguments)
},{"dup":114}],230:[function(require,module,exports){
arguments[4][115][0].apply(exports,arguments)
},{"./_fails":236,"dup":115}],231:[function(require,module,exports){
arguments[4][116][0].apply(exports,arguments)
},{"./_global":241,"./_is-object":252,"dup":116}],232:[function(require,module,exports){
arguments[4][117][0].apply(exports,arguments)
},{"dup":117}],233:[function(require,module,exports){
arguments[4][118][0].apply(exports,arguments)
},{"./_object-gops":278,"./_object-keys":281,"./_object-pie":282,"dup":118}],234:[function(require,module,exports){
var global = require('./_global');
var core = require('./_core');
var hide = require('./_hide');
var redefine = require('./_redefine');
var ctx = require('./_ctx');
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;

},{"./_core":224,"./_ctx":226,"./_global":241,"./_hide":243,"./_redefine":292}],235:[function(require,module,exports){
var MATCH = require('./_wks')('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};

},{"./_wks":326}],236:[function(require,module,exports){
arguments[4][120][0].apply(exports,arguments)
},{"dup":120}],237:[function(require,module,exports){
'use strict';
var hide = require('./_hide');
var redefine = require('./_redefine');
var fails = require('./_fails');
var defined = require('./_defined');
var wks = require('./_wks');

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);
  var fns = exec(defined, SYMBOL, ''[KEY]);
  var strfn = fns[0];
  var rxfn = fns[1];
  if (fails(function () {
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  })) {
    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};

},{"./_defined":229,"./_fails":236,"./_hide":243,"./_redefine":292,"./_wks":326}],238:[function(require,module,exports){
'use strict';
// 21.2.5.3 get RegExp.prototype.flags
var anObject = require('./_an-object');
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};

},{"./_an-object":208}],239:[function(require,module,exports){
'use strict';
// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = require('./_is-array');
var isObject = require('./_is-object');
var toLength = require('./_to-length');
var ctx = require('./_ctx');
var IS_CONCAT_SPREADABLE = require('./_wks')('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;

},{"./_ctx":226,"./_is-array":250,"./_is-object":252,"./_to-length":316,"./_wks":326}],240:[function(require,module,exports){
arguments[4][121][0].apply(exports,arguments)
},{"./_an-object":208,"./_ctx":226,"./_is-array-iter":249,"./_iter-call":254,"./_to-length":316,"./core.get-iterator-method":327,"dup":121}],241:[function(require,module,exports){
arguments[4][122][0].apply(exports,arguments)
},{"dup":122}],242:[function(require,module,exports){
arguments[4][123][0].apply(exports,arguments)
},{"dup":123}],243:[function(require,module,exports){
arguments[4][124][0].apply(exports,arguments)
},{"./_descriptors":230,"./_object-dp":272,"./_property-desc":290,"dup":124}],244:[function(require,module,exports){
arguments[4][125][0].apply(exports,arguments)
},{"./_global":241,"dup":125}],245:[function(require,module,exports){
arguments[4][126][0].apply(exports,arguments)
},{"./_descriptors":230,"./_dom-create":231,"./_fails":236,"dup":126}],246:[function(require,module,exports){
var isObject = require('./_is-object');
var setPrototypeOf = require('./_set-proto').set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};

},{"./_is-object":252,"./_set-proto":297}],247:[function(require,module,exports){
arguments[4][127][0].apply(exports,arguments)
},{"dup":127}],248:[function(require,module,exports){
arguments[4][128][0].apply(exports,arguments)
},{"./_cof":219,"dup":128}],249:[function(require,module,exports){
arguments[4][129][0].apply(exports,arguments)
},{"./_iterators":259,"./_wks":326,"dup":129}],250:[function(require,module,exports){
arguments[4][130][0].apply(exports,arguments)
},{"./_cof":219,"dup":130}],251:[function(require,module,exports){
arguments[4][131][0].apply(exports,arguments)
},{"./_is-object":252,"dup":131}],252:[function(require,module,exports){
arguments[4][132][0].apply(exports,arguments)
},{"dup":132}],253:[function(require,module,exports){
// 7.2.8 IsRegExp(argument)
var isObject = require('./_is-object');
var cof = require('./_cof');
var MATCH = require('./_wks')('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};

},{"./_cof":219,"./_is-object":252,"./_wks":326}],254:[function(require,module,exports){
arguments[4][133][0].apply(exports,arguments)
},{"./_an-object":208,"dup":133}],255:[function(require,module,exports){
arguments[4][134][0].apply(exports,arguments)
},{"./_hide":243,"./_object-create":271,"./_property-desc":290,"./_set-to-string-tag":299,"./_wks":326,"dup":134}],256:[function(require,module,exports){
arguments[4][135][0].apply(exports,arguments)
},{"./_export":234,"./_has":242,"./_hide":243,"./_iter-create":255,"./_iterators":259,"./_library":260,"./_object-gpo":279,"./_redefine":292,"./_set-to-string-tag":299,"./_wks":326,"dup":135}],257:[function(require,module,exports){
arguments[4][136][0].apply(exports,arguments)
},{"./_wks":326,"dup":136}],258:[function(require,module,exports){
arguments[4][137][0].apply(exports,arguments)
},{"dup":137}],259:[function(require,module,exports){
arguments[4][138][0].apply(exports,arguments)
},{"dup":138}],260:[function(require,module,exports){
module.exports = false;

},{}],261:[function(require,module,exports){
// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;

},{}],262:[function(require,module,exports){
// 20.2.2.16 Math.fround(x)
var sign = require('./_math-sign');
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};

},{"./_math-sign":265}],263:[function(require,module,exports){
// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};

},{}],264:[function(require,module,exports){
// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};

},{}],265:[function(require,module,exports){
// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};

},{}],266:[function(require,module,exports){
arguments[4][140][0].apply(exports,arguments)
},{"./_fails":236,"./_has":242,"./_is-object":252,"./_object-dp":272,"./_uid":322,"dup":140}],267:[function(require,module,exports){
var Map = require('./es6.map');
var $export = require('./_export');
var shared = require('./_shared')('metadata');
var store = shared.store || (shared.store = new (require('./es6.weak-map'))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};

},{"./_export":234,"./_shared":301,"./es6.map":358,"./es6.weak-map":464}],268:[function(require,module,exports){
arguments[4][141][0].apply(exports,arguments)
},{"./_cof":219,"./_global":241,"./_task":311,"dup":141}],269:[function(require,module,exports){
arguments[4][142][0].apply(exports,arguments)
},{"./_a-function":204,"dup":142}],270:[function(require,module,exports){
arguments[4][143][0].apply(exports,arguments)
},{"./_fails":236,"./_iobject":248,"./_object-gops":278,"./_object-keys":281,"./_object-pie":282,"./_to-object":317,"dup":143}],271:[function(require,module,exports){
arguments[4][144][0].apply(exports,arguments)
},{"./_an-object":208,"./_dom-create":231,"./_enum-bug-keys":232,"./_html":244,"./_object-dps":273,"./_shared-key":300,"dup":144}],272:[function(require,module,exports){
arguments[4][145][0].apply(exports,arguments)
},{"./_an-object":208,"./_descriptors":230,"./_ie8-dom-define":245,"./_to-primitive":318,"dup":145}],273:[function(require,module,exports){
arguments[4][146][0].apply(exports,arguments)
},{"./_an-object":208,"./_descriptors":230,"./_object-dp":272,"./_object-keys":281,"dup":146}],274:[function(require,module,exports){
'use strict';
// Forced replacement prototype accessors methods
module.exports = require('./_library') || !require('./_fails')(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete require('./_global')[K];
});

},{"./_fails":236,"./_global":241,"./_library":260}],275:[function(require,module,exports){
arguments[4][147][0].apply(exports,arguments)
},{"./_descriptors":230,"./_has":242,"./_ie8-dom-define":245,"./_object-pie":282,"./_property-desc":290,"./_to-iobject":315,"./_to-primitive":318,"dup":147}],276:[function(require,module,exports){
arguments[4][148][0].apply(exports,arguments)
},{"./_object-gopn":277,"./_to-iobject":315,"dup":148}],277:[function(require,module,exports){
arguments[4][149][0].apply(exports,arguments)
},{"./_enum-bug-keys":232,"./_object-keys-internal":280,"dup":149}],278:[function(require,module,exports){
arguments[4][150][0].apply(exports,arguments)
},{"dup":150}],279:[function(require,module,exports){
arguments[4][151][0].apply(exports,arguments)
},{"./_has":242,"./_shared-key":300,"./_to-object":317,"dup":151}],280:[function(require,module,exports){
arguments[4][152][0].apply(exports,arguments)
},{"./_array-includes":212,"./_has":242,"./_shared-key":300,"./_to-iobject":315,"dup":152}],281:[function(require,module,exports){
arguments[4][153][0].apply(exports,arguments)
},{"./_enum-bug-keys":232,"./_object-keys-internal":280,"dup":153}],282:[function(require,module,exports){
arguments[4][154][0].apply(exports,arguments)
},{"dup":154}],283:[function(require,module,exports){
arguments[4][155][0].apply(exports,arguments)
},{"./_core":224,"./_export":234,"./_fails":236,"dup":155}],284:[function(require,module,exports){
arguments[4][156][0].apply(exports,arguments)
},{"./_object-keys":281,"./_object-pie":282,"./_to-iobject":315,"dup":156}],285:[function(require,module,exports){
// all object keys, includes non-enumerable and symbols
var gOPN = require('./_object-gopn');
var gOPS = require('./_object-gops');
var anObject = require('./_an-object');
var Reflect = require('./_global').Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};

},{"./_an-object":208,"./_global":241,"./_object-gopn":277,"./_object-gops":278}],286:[function(require,module,exports){
var $parseFloat = require('./_global').parseFloat;
var $trim = require('./_string-trim').trim;

module.exports = 1 / $parseFloat(require('./_string-ws') + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;

},{"./_global":241,"./_string-trim":309,"./_string-ws":310}],287:[function(require,module,exports){
var $parseInt = require('./_global').parseInt;
var $trim = require('./_string-trim').trim;
var ws = require('./_string-ws');
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;

},{"./_global":241,"./_string-trim":309,"./_string-ws":310}],288:[function(require,module,exports){
arguments[4][157][0].apply(exports,arguments)
},{"dup":157}],289:[function(require,module,exports){
arguments[4][158][0].apply(exports,arguments)
},{"./_an-object":208,"./_is-object":252,"./_new-promise-capability":269,"dup":158}],290:[function(require,module,exports){
arguments[4][159][0].apply(exports,arguments)
},{"dup":159}],291:[function(require,module,exports){
var redefine = require('./_redefine');
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};

},{"./_redefine":292}],292:[function(require,module,exports){
var global = require('./_global');
var hide = require('./_hide');
var has = require('./_has');
var SRC = require('./_uid')('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

require('./_core').inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});

},{"./_core":224,"./_global":241,"./_has":242,"./_hide":243,"./_uid":322}],293:[function(require,module,exports){
module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};

},{}],294:[function(require,module,exports){
// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};

},{}],295:[function(require,module,exports){
'use strict';
// https://tc39.github.io/proposal-setmap-offrom/
var $export = require('./_export');
var aFunction = require('./_a-function');
var ctx = require('./_ctx');
var forOf = require('./_for-of');

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};

},{"./_a-function":204,"./_ctx":226,"./_export":234,"./_for-of":240}],296:[function(require,module,exports){
'use strict';
// https://tc39.github.io/proposal-setmap-offrom/
var $export = require('./_export');

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};

},{"./_export":234}],297:[function(require,module,exports){
arguments[4][162][0].apply(exports,arguments)
},{"./_an-object":208,"./_ctx":226,"./_is-object":252,"./_object-gopd":275,"dup":162}],298:[function(require,module,exports){
'use strict';
var global = require('./_global');
var dP = require('./_object-dp');
var DESCRIPTORS = require('./_descriptors');
var SPECIES = require('./_wks')('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};

},{"./_descriptors":230,"./_global":241,"./_object-dp":272,"./_wks":326}],299:[function(require,module,exports){
arguments[4][164][0].apply(exports,arguments)
},{"./_has":242,"./_object-dp":272,"./_wks":326,"dup":164}],300:[function(require,module,exports){
arguments[4][165][0].apply(exports,arguments)
},{"./_shared":301,"./_uid":322,"dup":165}],301:[function(require,module,exports){
arguments[4][166][0].apply(exports,arguments)
},{"./_global":241,"dup":166}],302:[function(require,module,exports){
arguments[4][167][0].apply(exports,arguments)
},{"./_a-function":204,"./_an-object":208,"./_wks":326,"dup":167}],303:[function(require,module,exports){
'use strict';
var fails = require('./_fails');

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};

},{"./_fails":236}],304:[function(require,module,exports){
arguments[4][168][0].apply(exports,arguments)
},{"./_defined":229,"./_to-integer":314,"dup":168}],305:[function(require,module,exports){
// helper for String#{startsWith, endsWith, includes}
var isRegExp = require('./_is-regexp');
var defined = require('./_defined');

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};

},{"./_defined":229,"./_is-regexp":253}],306:[function(require,module,exports){
var $export = require('./_export');
var fails = require('./_fails');
var defined = require('./_defined');
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};

},{"./_defined":229,"./_export":234,"./_fails":236}],307:[function(require,module,exports){
// https://github.com/tc39/proposal-string-pad-start-end
var toLength = require('./_to-length');
var repeat = require('./_string-repeat');
var defined = require('./_defined');

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};

},{"./_defined":229,"./_string-repeat":308,"./_to-length":316}],308:[function(require,module,exports){
'use strict';
var toInteger = require('./_to-integer');
var defined = require('./_defined');

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};

},{"./_defined":229,"./_to-integer":314}],309:[function(require,module,exports){
var $export = require('./_export');
var defined = require('./_defined');
var fails = require('./_fails');
var spaces = require('./_string-ws');
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;

},{"./_defined":229,"./_export":234,"./_fails":236,"./_string-ws":310}],310:[function(require,module,exports){
module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

},{}],311:[function(require,module,exports){
arguments[4][169][0].apply(exports,arguments)
},{"./_cof":219,"./_ctx":226,"./_dom-create":231,"./_global":241,"./_html":244,"./_invoke":247,"dup":169}],312:[function(require,module,exports){
arguments[4][170][0].apply(exports,arguments)
},{"./_to-integer":314,"dup":170}],313:[function(require,module,exports){
// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = require('./_to-integer');
var toLength = require('./_to-length');
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};

},{"./_to-integer":314,"./_to-length":316}],314:[function(require,module,exports){
arguments[4][171][0].apply(exports,arguments)
},{"dup":171}],315:[function(require,module,exports){
arguments[4][172][0].apply(exports,arguments)
},{"./_defined":229,"./_iobject":248,"dup":172}],316:[function(require,module,exports){
arguments[4][173][0].apply(exports,arguments)
},{"./_to-integer":314,"dup":173}],317:[function(require,module,exports){
arguments[4][174][0].apply(exports,arguments)
},{"./_defined":229,"dup":174}],318:[function(require,module,exports){
arguments[4][175][0].apply(exports,arguments)
},{"./_is-object":252,"dup":175}],319:[function(require,module,exports){
'use strict';
if (require('./_descriptors')) {
  var LIBRARY = require('./_library');
  var global = require('./_global');
  var fails = require('./_fails');
  var $export = require('./_export');
  var $typed = require('./_typed');
  var $buffer = require('./_typed-buffer');
  var ctx = require('./_ctx');
  var anInstance = require('./_an-instance');
  var propertyDesc = require('./_property-desc');
  var hide = require('./_hide');
  var redefineAll = require('./_redefine-all');
  var toInteger = require('./_to-integer');
  var toLength = require('./_to-length');
  var toIndex = require('./_to-index');
  var toAbsoluteIndex = require('./_to-absolute-index');
  var toPrimitive = require('./_to-primitive');
  var has = require('./_has');
  var classof = require('./_classof');
  var isObject = require('./_is-object');
  var toObject = require('./_to-object');
  var isArrayIter = require('./_is-array-iter');
  var create = require('./_object-create');
  var getPrototypeOf = require('./_object-gpo');
  var gOPN = require('./_object-gopn').f;
  var getIterFn = require('./core.get-iterator-method');
  var uid = require('./_uid');
  var wks = require('./_wks');
  var createArrayMethod = require('./_array-methods');
  var createArrayIncludes = require('./_array-includes');
  var speciesConstructor = require('./_species-constructor');
  var ArrayIterators = require('./es6.array.iterator');
  var Iterators = require('./_iterators');
  var $iterDetect = require('./_iter-detect');
  var setSpecies = require('./_set-species');
  var arrayFill = require('./_array-fill');
  var arrayCopyWithin = require('./_array-copy-within');
  var $DP = require('./_object-dp');
  var $GOPD = require('./_object-gopd');
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };

},{"./_an-instance":207,"./_array-copy-within":209,"./_array-fill":210,"./_array-includes":212,"./_array-methods":213,"./_classof":218,"./_ctx":226,"./_descriptors":230,"./_export":234,"./_fails":236,"./_global":241,"./_has":242,"./_hide":243,"./_is-array-iter":249,"./_is-object":252,"./_iter-detect":257,"./_iterators":259,"./_library":260,"./_object-create":271,"./_object-dp":272,"./_object-gopd":275,"./_object-gopn":277,"./_object-gpo":279,"./_property-desc":290,"./_redefine-all":291,"./_set-species":298,"./_species-constructor":302,"./_to-absolute-index":312,"./_to-index":313,"./_to-integer":314,"./_to-length":316,"./_to-object":317,"./_to-primitive":318,"./_typed":321,"./_typed-buffer":320,"./_uid":322,"./_wks":326,"./core.get-iterator-method":327,"./es6.array.iterator":339}],320:[function(require,module,exports){
'use strict';
var global = require('./_global');
var DESCRIPTORS = require('./_descriptors');
var LIBRARY = require('./_library');
var $typed = require('./_typed');
var hide = require('./_hide');
var redefineAll = require('./_redefine-all');
var fails = require('./_fails');
var anInstance = require('./_an-instance');
var toInteger = require('./_to-integer');
var toLength = require('./_to-length');
var toIndex = require('./_to-index');
var gOPN = require('./_object-gopn').f;
var dP = require('./_object-dp').f;
var arrayFill = require('./_array-fill');
var setToStringTag = require('./_set-to-string-tag');
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;

},{"./_an-instance":207,"./_array-fill":210,"./_descriptors":230,"./_fails":236,"./_global":241,"./_hide":243,"./_library":260,"./_object-dp":272,"./_object-gopn":277,"./_redefine-all":291,"./_set-to-string-tag":299,"./_to-index":313,"./_to-integer":314,"./_to-length":316,"./_typed":321}],321:[function(require,module,exports){
var global = require('./_global');
var hide = require('./_hide');
var uid = require('./_uid');
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};

},{"./_global":241,"./_hide":243,"./_uid":322}],322:[function(require,module,exports){
arguments[4][176][0].apply(exports,arguments)
},{"dup":176}],323:[function(require,module,exports){
var isObject = require('./_is-object');
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};

},{"./_is-object":252}],324:[function(require,module,exports){
arguments[4][177][0].apply(exports,arguments)
},{"./_core":224,"./_global":241,"./_library":260,"./_object-dp":272,"./_wks-ext":325,"dup":177}],325:[function(require,module,exports){
arguments[4][178][0].apply(exports,arguments)
},{"./_wks":326,"dup":178}],326:[function(require,module,exports){
arguments[4][179][0].apply(exports,arguments)
},{"./_global":241,"./_shared":301,"./_uid":322,"dup":179}],327:[function(require,module,exports){
arguments[4][180][0].apply(exports,arguments)
},{"./_classof":218,"./_core":224,"./_iterators":259,"./_wks":326,"dup":180}],328:[function(require,module,exports){
// https://github.com/benjamingr/RexExp.escape
var $export = require('./_export');
var $re = require('./_replacer')(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });

},{"./_export":234,"./_replacer":293}],329:[function(require,module,exports){
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = require('./_export');

$export($export.P, 'Array', { copyWithin: require('./_array-copy-within') });

require('./_add-to-unscopables')('copyWithin');

},{"./_add-to-unscopables":206,"./_array-copy-within":209,"./_export":234}],330:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $every = require('./_array-methods')(4);

$export($export.P + $export.F * !require('./_strict-method')([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});

},{"./_array-methods":213,"./_export":234,"./_strict-method":303}],331:[function(require,module,exports){
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = require('./_export');

$export($export.P, 'Array', { fill: require('./_array-fill') });

require('./_add-to-unscopables')('fill');

},{"./_add-to-unscopables":206,"./_array-fill":210,"./_export":234}],332:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $filter = require('./_array-methods')(2);

$export($export.P + $export.F * !require('./_strict-method')([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});

},{"./_array-methods":213,"./_export":234,"./_strict-method":303}],333:[function(require,module,exports){
'use strict';
// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = require('./_export');
var $find = require('./_array-methods')(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
require('./_add-to-unscopables')(KEY);

},{"./_add-to-unscopables":206,"./_array-methods":213,"./_export":234}],334:[function(require,module,exports){
'use strict';
// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = require('./_export');
var $find = require('./_array-methods')(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
require('./_add-to-unscopables')(KEY);

},{"./_add-to-unscopables":206,"./_array-methods":213,"./_export":234}],335:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $forEach = require('./_array-methods')(0);
var STRICT = require('./_strict-method')([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});

},{"./_array-methods":213,"./_export":234,"./_strict-method":303}],336:[function(require,module,exports){
arguments[4][183][0].apply(exports,arguments)
},{"./_create-property":225,"./_ctx":226,"./_export":234,"./_is-array-iter":249,"./_iter-call":254,"./_iter-detect":257,"./_to-length":316,"./_to-object":317,"./core.get-iterator-method":327,"dup":183}],337:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $indexOf = require('./_array-includes')(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !require('./_strict-method')($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});

},{"./_array-includes":212,"./_export":234,"./_strict-method":303}],338:[function(require,module,exports){
// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = require('./_export');

$export($export.S, 'Array', { isArray: require('./_is-array') });

},{"./_export":234,"./_is-array":250}],339:[function(require,module,exports){
arguments[4][184][0].apply(exports,arguments)
},{"./_add-to-unscopables":206,"./_iter-define":256,"./_iter-step":258,"./_iterators":259,"./_to-iobject":315,"dup":184}],340:[function(require,module,exports){
'use strict';
// 22.1.3.13 Array.prototype.join(separator)
var $export = require('./_export');
var toIObject = require('./_to-iobject');
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (require('./_iobject') != Object || !require('./_strict-method')(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});

},{"./_export":234,"./_iobject":248,"./_strict-method":303,"./_to-iobject":315}],341:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var toIObject = require('./_to-iobject');
var toInteger = require('./_to-integer');
var toLength = require('./_to-length');
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !require('./_strict-method')($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});

},{"./_export":234,"./_strict-method":303,"./_to-integer":314,"./_to-iobject":315,"./_to-length":316}],342:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $map = require('./_array-methods')(1);

$export($export.P + $export.F * !require('./_strict-method')([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});

},{"./_array-methods":213,"./_export":234,"./_strict-method":303}],343:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var createProperty = require('./_create-property');

// WebKit Array.of isn't generic
$export($export.S + $export.F * require('./_fails')(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});

},{"./_create-property":225,"./_export":234,"./_fails":236}],344:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $reduce = require('./_array-reduce');

$export($export.P + $export.F * !require('./_strict-method')([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});

},{"./_array-reduce":214,"./_export":234,"./_strict-method":303}],345:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $reduce = require('./_array-reduce');

$export($export.P + $export.F * !require('./_strict-method')([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});

},{"./_array-reduce":214,"./_export":234,"./_strict-method":303}],346:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var html = require('./_html');
var cof = require('./_cof');
var toAbsoluteIndex = require('./_to-absolute-index');
var toLength = require('./_to-length');
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * require('./_fails')(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});

},{"./_cof":219,"./_export":234,"./_fails":236,"./_html":244,"./_to-absolute-index":312,"./_to-length":316}],347:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $some = require('./_array-methods')(3);

$export($export.P + $export.F * !require('./_strict-method')([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});

},{"./_array-methods":213,"./_export":234,"./_strict-method":303}],348:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var aFunction = require('./_a-function');
var toObject = require('./_to-object');
var fails = require('./_fails');
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !require('./_strict-method')($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});

},{"./_a-function":204,"./_export":234,"./_fails":236,"./_strict-method":303,"./_to-object":317}],349:[function(require,module,exports){
require('./_set-species')('Array');

},{"./_set-species":298}],350:[function(require,module,exports){
// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = require('./_export');

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });

},{"./_export":234}],351:[function(require,module,exports){
// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = require('./_export');
var toISOString = require('./_date-to-iso-string');

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});

},{"./_date-to-iso-string":227,"./_export":234}],352:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var toObject = require('./_to-object');
var toPrimitive = require('./_to-primitive');

$export($export.P + $export.F * require('./_fails')(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});

},{"./_export":234,"./_fails":236,"./_to-object":317,"./_to-primitive":318}],353:[function(require,module,exports){
var TO_PRIMITIVE = require('./_wks')('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) require('./_hide')(proto, TO_PRIMITIVE, require('./_date-to-primitive'));

},{"./_date-to-primitive":228,"./_hide":243,"./_wks":326}],354:[function(require,module,exports){
var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  require('./_redefine')(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}

},{"./_redefine":292}],355:[function(require,module,exports){
// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = require('./_export');

$export($export.P, 'Function', { bind: require('./_bind') });

},{"./_bind":217,"./_export":234}],356:[function(require,module,exports){
'use strict';
var isObject = require('./_is-object');
var getPrototypeOf = require('./_object-gpo');
var HAS_INSTANCE = require('./_wks')('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) require('./_object-dp').f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });

},{"./_is-object":252,"./_object-dp":272,"./_object-gpo":279,"./_wks":326}],357:[function(require,module,exports){
var dP = require('./_object-dp').f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || require('./_descriptors') && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});

},{"./_descriptors":230,"./_object-dp":272}],358:[function(require,module,exports){
'use strict';
var strong = require('./_collection-strong');
var validate = require('./_validate-collection');
var MAP = 'Map';

// 23.1 Map Objects
module.exports = require('./_collection')(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);

},{"./_collection":223,"./_collection-strong":220,"./_validate-collection":323}],359:[function(require,module,exports){
// 20.2.2.3 Math.acosh(x)
var $export = require('./_export');
var log1p = require('./_math-log1p');
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});

},{"./_export":234,"./_math-log1p":263}],360:[function(require,module,exports){
// 20.2.2.5 Math.asinh(x)
var $export = require('./_export');
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });

},{"./_export":234}],361:[function(require,module,exports){
// 20.2.2.7 Math.atanh(x)
var $export = require('./_export');
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});

},{"./_export":234}],362:[function(require,module,exports){
// 20.2.2.9 Math.cbrt(x)
var $export = require('./_export');
var sign = require('./_math-sign');

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});

},{"./_export":234,"./_math-sign":265}],363:[function(require,module,exports){
// 20.2.2.11 Math.clz32(x)
var $export = require('./_export');

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});

},{"./_export":234}],364:[function(require,module,exports){
// 20.2.2.12 Math.cosh(x)
var $export = require('./_export');
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});

},{"./_export":234}],365:[function(require,module,exports){
// 20.2.2.14 Math.expm1(x)
var $export = require('./_export');
var $expm1 = require('./_math-expm1');

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });

},{"./_export":234,"./_math-expm1":261}],366:[function(require,module,exports){
// 20.2.2.16 Math.fround(x)
var $export = require('./_export');

$export($export.S, 'Math', { fround: require('./_math-fround') });

},{"./_export":234,"./_math-fround":262}],367:[function(require,module,exports){
// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = require('./_export');
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});

},{"./_export":234}],368:[function(require,module,exports){
// 20.2.2.18 Math.imul(x, y)
var $export = require('./_export');
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * require('./_fails')(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});

},{"./_export":234,"./_fails":236}],369:[function(require,module,exports){
// 20.2.2.21 Math.log10(x)
var $export = require('./_export');

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});

},{"./_export":234}],370:[function(require,module,exports){
// 20.2.2.20 Math.log1p(x)
var $export = require('./_export');

$export($export.S, 'Math', { log1p: require('./_math-log1p') });

},{"./_export":234,"./_math-log1p":263}],371:[function(require,module,exports){
// 20.2.2.22 Math.log2(x)
var $export = require('./_export');

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});

},{"./_export":234}],372:[function(require,module,exports){
// 20.2.2.28 Math.sign(x)
var $export = require('./_export');

$export($export.S, 'Math', { sign: require('./_math-sign') });

},{"./_export":234,"./_math-sign":265}],373:[function(require,module,exports){
// 20.2.2.30 Math.sinh(x)
var $export = require('./_export');
var expm1 = require('./_math-expm1');
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * require('./_fails')(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});

},{"./_export":234,"./_fails":236,"./_math-expm1":261}],374:[function(require,module,exports){
// 20.2.2.33 Math.tanh(x)
var $export = require('./_export');
var expm1 = require('./_math-expm1');
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});

},{"./_export":234,"./_math-expm1":261}],375:[function(require,module,exports){
// 20.2.2.34 Math.trunc(x)
var $export = require('./_export');

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});

},{"./_export":234}],376:[function(require,module,exports){
'use strict';
var global = require('./_global');
var has = require('./_has');
var cof = require('./_cof');
var inheritIfRequired = require('./_inherit-if-required');
var toPrimitive = require('./_to-primitive');
var fails = require('./_fails');
var gOPN = require('./_object-gopn').f;
var gOPD = require('./_object-gopd').f;
var dP = require('./_object-dp').f;
var $trim = require('./_string-trim').trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(require('./_object-create')(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = require('./_descriptors') ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  require('./_redefine')(global, NUMBER, $Number);
}

},{"./_cof":219,"./_descriptors":230,"./_fails":236,"./_global":241,"./_has":242,"./_inherit-if-required":246,"./_object-create":271,"./_object-dp":272,"./_object-gopd":275,"./_object-gopn":277,"./_redefine":292,"./_string-trim":309,"./_to-primitive":318}],377:[function(require,module,exports){
// 20.1.2.1 Number.EPSILON
var $export = require('./_export');

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });

},{"./_export":234}],378:[function(require,module,exports){
// 20.1.2.2 Number.isFinite(number)
var $export = require('./_export');
var _isFinite = require('./_global').isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});

},{"./_export":234,"./_global":241}],379:[function(require,module,exports){
arguments[4][185][0].apply(exports,arguments)
},{"./_export":234,"./_is-integer":251,"dup":185}],380:[function(require,module,exports){
// 20.1.2.4 Number.isNaN(number)
var $export = require('./_export');

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});

},{"./_export":234}],381:[function(require,module,exports){
// 20.1.2.5 Number.isSafeInteger(number)
var $export = require('./_export');
var isInteger = require('./_is-integer');
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});

},{"./_export":234,"./_is-integer":251}],382:[function(require,module,exports){
// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = require('./_export');

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });

},{"./_export":234}],383:[function(require,module,exports){
// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = require('./_export');

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });

},{"./_export":234}],384:[function(require,module,exports){
var $export = require('./_export');
var $parseFloat = require('./_parse-float');
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });

},{"./_export":234,"./_parse-float":286}],385:[function(require,module,exports){
var $export = require('./_export');
var $parseInt = require('./_parse-int');
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });

},{"./_export":234,"./_parse-int":287}],386:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var toInteger = require('./_to-integer');
var aNumberValue = require('./_a-number-value');
var repeat = require('./_string-repeat');
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !require('./_fails')(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});

},{"./_a-number-value":205,"./_export":234,"./_fails":236,"./_string-repeat":308,"./_to-integer":314}],387:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $fails = require('./_fails');
var aNumberValue = require('./_a-number-value');
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});

},{"./_a-number-value":205,"./_export":234,"./_fails":236}],388:[function(require,module,exports){
arguments[4][186][0].apply(exports,arguments)
},{"./_export":234,"./_object-assign":270,"dup":186}],389:[function(require,module,exports){
arguments[4][187][0].apply(exports,arguments)
},{"./_export":234,"./_object-create":271,"dup":187}],390:[function(require,module,exports){
arguments[4][188][0].apply(exports,arguments)
},{"./_descriptors":230,"./_export":234,"./_object-dps":273,"dup":188}],391:[function(require,module,exports){
arguments[4][189][0].apply(exports,arguments)
},{"./_descriptors":230,"./_export":234,"./_object-dp":272,"dup":189}],392:[function(require,module,exports){
// 19.1.2.5 Object.freeze(O)
var isObject = require('./_is-object');
var meta = require('./_meta').onFreeze;

require('./_object-sap')('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});

},{"./_is-object":252,"./_meta":266,"./_object-sap":283}],393:[function(require,module,exports){
// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = require('./_to-iobject');
var $getOwnPropertyDescriptor = require('./_object-gopd').f;

require('./_object-sap')('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});

},{"./_object-gopd":275,"./_object-sap":283,"./_to-iobject":315}],394:[function(require,module,exports){
// 19.1.2.7 Object.getOwnPropertyNames(O)
require('./_object-sap')('getOwnPropertyNames', function () {
  return require('./_object-gopn-ext').f;
});

},{"./_object-gopn-ext":276,"./_object-sap":283}],395:[function(require,module,exports){
arguments[4][190][0].apply(exports,arguments)
},{"./_object-gpo":279,"./_object-sap":283,"./_to-object":317,"dup":190}],396:[function(require,module,exports){
// 19.1.2.11 Object.isExtensible(O)
var isObject = require('./_is-object');

require('./_object-sap')('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});

},{"./_is-object":252,"./_object-sap":283}],397:[function(require,module,exports){
// 19.1.2.12 Object.isFrozen(O)
var isObject = require('./_is-object');

require('./_object-sap')('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});

},{"./_is-object":252,"./_object-sap":283}],398:[function(require,module,exports){
// 19.1.2.13 Object.isSealed(O)
var isObject = require('./_is-object');

require('./_object-sap')('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});

},{"./_is-object":252,"./_object-sap":283}],399:[function(require,module,exports){
// 19.1.3.10 Object.is(value1, value2)
var $export = require('./_export');
$export($export.S, 'Object', { is: require('./_same-value') });

},{"./_export":234,"./_same-value":294}],400:[function(require,module,exports){
arguments[4][191][0].apply(exports,arguments)
},{"./_object-keys":281,"./_object-sap":283,"./_to-object":317,"dup":191}],401:[function(require,module,exports){
// 19.1.2.15 Object.preventExtensions(O)
var isObject = require('./_is-object');
var meta = require('./_meta').onFreeze;

require('./_object-sap')('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});

},{"./_is-object":252,"./_meta":266,"./_object-sap":283}],402:[function(require,module,exports){
// 19.1.2.17 Object.seal(O)
var isObject = require('./_is-object');
var meta = require('./_meta').onFreeze;

require('./_object-sap')('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});

},{"./_is-object":252,"./_meta":266,"./_object-sap":283}],403:[function(require,module,exports){
arguments[4][192][0].apply(exports,arguments)
},{"./_export":234,"./_set-proto":297,"dup":192}],404:[function(require,module,exports){
'use strict';
// 19.1.3.6 Object.prototype.toString()
var classof = require('./_classof');
var test = {};
test[require('./_wks')('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  require('./_redefine')(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}

},{"./_classof":218,"./_redefine":292,"./_wks":326}],405:[function(require,module,exports){
var $export = require('./_export');
var $parseFloat = require('./_parse-float');
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });

},{"./_export":234,"./_parse-float":286}],406:[function(require,module,exports){
var $export = require('./_export');
var $parseInt = require('./_parse-int');
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });

},{"./_export":234,"./_parse-int":287}],407:[function(require,module,exports){
arguments[4][194][0].apply(exports,arguments)
},{"./_a-function":204,"./_an-instance":207,"./_classof":218,"./_core":224,"./_ctx":226,"./_export":234,"./_for-of":240,"./_global":241,"./_is-object":252,"./_iter-detect":257,"./_library":260,"./_microtask":268,"./_new-promise-capability":269,"./_perform":288,"./_promise-resolve":289,"./_redefine-all":291,"./_set-species":298,"./_set-to-string-tag":299,"./_species-constructor":302,"./_task":311,"./_wks":326,"dup":194}],408:[function(require,module,exports){
// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = require('./_export');
var aFunction = require('./_a-function');
var anObject = require('./_an-object');
var rApply = (require('./_global').Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !require('./_fails')(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});

},{"./_a-function":204,"./_an-object":208,"./_export":234,"./_fails":236,"./_global":241}],409:[function(require,module,exports){
// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = require('./_export');
var create = require('./_object-create');
var aFunction = require('./_a-function');
var anObject = require('./_an-object');
var isObject = require('./_is-object');
var fails = require('./_fails');
var bind = require('./_bind');
var rConstruct = (require('./_global').Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});

},{"./_a-function":204,"./_an-object":208,"./_bind":217,"./_export":234,"./_fails":236,"./_global":241,"./_is-object":252,"./_object-create":271}],410:[function(require,module,exports){
// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = require('./_object-dp');
var $export = require('./_export');
var anObject = require('./_an-object');
var toPrimitive = require('./_to-primitive');

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * require('./_fails')(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});

},{"./_an-object":208,"./_export":234,"./_fails":236,"./_object-dp":272,"./_to-primitive":318}],411:[function(require,module,exports){
// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = require('./_export');
var gOPD = require('./_object-gopd').f;
var anObject = require('./_an-object');

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});

},{"./_an-object":208,"./_export":234,"./_object-gopd":275}],412:[function(require,module,exports){
'use strict';
// 26.1.5 Reflect.enumerate(target)
var $export = require('./_export');
var anObject = require('./_an-object');
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
require('./_iter-create')(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});

},{"./_an-object":208,"./_export":234,"./_iter-create":255}],413:[function(require,module,exports){
// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = require('./_object-gopd');
var $export = require('./_export');
var anObject = require('./_an-object');

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});

},{"./_an-object":208,"./_export":234,"./_object-gopd":275}],414:[function(require,module,exports){
// 26.1.8 Reflect.getPrototypeOf(target)
var $export = require('./_export');
var getProto = require('./_object-gpo');
var anObject = require('./_an-object');

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});

},{"./_an-object":208,"./_export":234,"./_object-gpo":279}],415:[function(require,module,exports){
// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = require('./_object-gopd');
var getPrototypeOf = require('./_object-gpo');
var has = require('./_has');
var $export = require('./_export');
var isObject = require('./_is-object');
var anObject = require('./_an-object');

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });

},{"./_an-object":208,"./_export":234,"./_has":242,"./_is-object":252,"./_object-gopd":275,"./_object-gpo":279}],416:[function(require,module,exports){
// 26.1.9 Reflect.has(target, propertyKey)
var $export = require('./_export');

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});

},{"./_export":234}],417:[function(require,module,exports){
// 26.1.10 Reflect.isExtensible(target)
var $export = require('./_export');
var anObject = require('./_an-object');
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});

},{"./_an-object":208,"./_export":234}],418:[function(require,module,exports){
// 26.1.11 Reflect.ownKeys(target)
var $export = require('./_export');

$export($export.S, 'Reflect', { ownKeys: require('./_own-keys') });

},{"./_export":234,"./_own-keys":285}],419:[function(require,module,exports){
// 26.1.12 Reflect.preventExtensions(target)
var $export = require('./_export');
var anObject = require('./_an-object');
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});

},{"./_an-object":208,"./_export":234}],420:[function(require,module,exports){
// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = require('./_export');
var setProto = require('./_set-proto');

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});

},{"./_export":234,"./_set-proto":297}],421:[function(require,module,exports){
// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = require('./_object-dp');
var gOPD = require('./_object-gopd');
var getPrototypeOf = require('./_object-gpo');
var has = require('./_has');
var $export = require('./_export');
var createDesc = require('./_property-desc');
var anObject = require('./_an-object');
var isObject = require('./_is-object');

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
    existingDescriptor.value = V;
    dP.f(receiver, propertyKey, existingDescriptor);
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });

},{"./_an-object":208,"./_export":234,"./_has":242,"./_is-object":252,"./_object-dp":272,"./_object-gopd":275,"./_object-gpo":279,"./_property-desc":290}],422:[function(require,module,exports){
var global = require('./_global');
var inheritIfRequired = require('./_inherit-if-required');
var dP = require('./_object-dp').f;
var gOPN = require('./_object-gopn').f;
var isRegExp = require('./_is-regexp');
var $flags = require('./_flags');
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (require('./_descriptors') && (!CORRECT_NEW || require('./_fails')(function () {
  re2[require('./_wks')('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  require('./_redefine')(global, 'RegExp', $RegExp);
}

require('./_set-species')('RegExp');

},{"./_descriptors":230,"./_fails":236,"./_flags":238,"./_global":241,"./_inherit-if-required":246,"./_is-regexp":253,"./_object-dp":272,"./_object-gopn":277,"./_redefine":292,"./_set-species":298,"./_wks":326}],423:[function(require,module,exports){
// 21.2.5.3 get RegExp.prototype.flags()
if (require('./_descriptors') && /./g.flags != 'g') require('./_object-dp').f(RegExp.prototype, 'flags', {
  configurable: true,
  get: require('./_flags')
});

},{"./_descriptors":230,"./_flags":238,"./_object-dp":272}],424:[function(require,module,exports){
// @@match logic
require('./_fix-re-wks')('match', 1, function (defined, MATCH, $match) {
  // 21.1.3.11 String.prototype.match(regexp)
  return [function match(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[MATCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
  }, $match];
});

},{"./_fix-re-wks":237}],425:[function(require,module,exports){
// @@replace logic
require('./_fix-re-wks')('replace', 2, function (defined, REPLACE, $replace) {
  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
  return [function replace(searchValue, replaceValue) {
    'use strict';
    var O = defined(this);
    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
    return fn !== undefined
      ? fn.call(searchValue, O, replaceValue)
      : $replace.call(String(O), searchValue, replaceValue);
  }, $replace];
});

},{"./_fix-re-wks":237}],426:[function(require,module,exports){
// @@search logic
require('./_fix-re-wks')('search', 1, function (defined, SEARCH, $search) {
  // 21.1.3.15 String.prototype.search(regexp)
  return [function search(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[SEARCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
  }, $search];
});

},{"./_fix-re-wks":237}],427:[function(require,module,exports){
// @@split logic
require('./_fix-re-wks')('split', 2, function (defined, SPLIT, $split) {
  'use strict';
  var isRegExp = require('./_is-regexp');
  var _split = $split;
  var $push = [].push;
  var $SPLIT = 'split';
  var LENGTH = 'length';
  var LAST_INDEX = 'lastIndex';
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
    // based on es5-shim implementation, need to rework it
    $split = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return _split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var separator2, match, lastIndex, lastLength, i;
      // Doesn't need flags gy, but they don't hurt
      if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
      while (match = separatorCopy.exec(string)) {
        // `separatorCopy.lastIndex` is not reliable cross-browser
        lastIndex = match.index + match[0][LENGTH];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
          // eslint-disable-next-line no-loop-func
          if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
            for (i = 1; i < arguments[LENGTH] - 2; i++) if (arguments[i] === undefined) match[i] = undefined;
          });
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    $split = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
    };
  }
  // 21.1.3.17 String.prototype.split(separator, limit)
  return [function split(separator, limit) {
    var O = defined(this);
    var fn = separator == undefined ? undefined : separator[SPLIT];
    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
  }, $split];
});

},{"./_fix-re-wks":237,"./_is-regexp":253}],428:[function(require,module,exports){
'use strict';
require('./es6.regexp.flags');
var anObject = require('./_an-object');
var $flags = require('./_flags');
var DESCRIPTORS = require('./_descriptors');
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  require('./_redefine')(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (require('./_fails')(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}

},{"./_an-object":208,"./_descriptors":230,"./_fails":236,"./_flags":238,"./_redefine":292,"./es6.regexp.flags":423}],429:[function(require,module,exports){
'use strict';
var strong = require('./_collection-strong');
var validate = require('./_validate-collection');
var SET = 'Set';

// 23.2 Set Objects
module.exports = require('./_collection')(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);

},{"./_collection":223,"./_collection-strong":220,"./_validate-collection":323}],430:[function(require,module,exports){
'use strict';
// B.2.3.2 String.prototype.anchor(name)
require('./_string-html')('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});

},{"./_string-html":306}],431:[function(require,module,exports){
'use strict';
// B.2.3.3 String.prototype.big()
require('./_string-html')('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});

},{"./_string-html":306}],432:[function(require,module,exports){
'use strict';
// B.2.3.4 String.prototype.blink()
require('./_string-html')('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});

},{"./_string-html":306}],433:[function(require,module,exports){
'use strict';
// B.2.3.5 String.prototype.bold()
require('./_string-html')('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});

},{"./_string-html":306}],434:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $at = require('./_string-at')(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});

},{"./_export":234,"./_string-at":304}],435:[function(require,module,exports){
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
'use strict';
var $export = require('./_export');
var toLength = require('./_to-length');
var context = require('./_string-context');
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * require('./_fails-is-regexp')(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});

},{"./_export":234,"./_fails-is-regexp":235,"./_string-context":305,"./_to-length":316}],436:[function(require,module,exports){
'use strict';
// B.2.3.6 String.prototype.fixed()
require('./_string-html')('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});

},{"./_string-html":306}],437:[function(require,module,exports){
'use strict';
// B.2.3.7 String.prototype.fontcolor(color)
require('./_string-html')('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});

},{"./_string-html":306}],438:[function(require,module,exports){
'use strict';
// B.2.3.8 String.prototype.fontsize(size)
require('./_string-html')('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});

},{"./_string-html":306}],439:[function(require,module,exports){
var $export = require('./_export');
var toAbsoluteIndex = require('./_to-absolute-index');
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});

},{"./_export":234,"./_to-absolute-index":312}],440:[function(require,module,exports){
// 21.1.3.7 String.prototype.includes(searchString, position = 0)
'use strict';
var $export = require('./_export');
var context = require('./_string-context');
var INCLUDES = 'includes';

$export($export.P + $export.F * require('./_fails-is-regexp')(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});

},{"./_export":234,"./_fails-is-regexp":235,"./_string-context":305}],441:[function(require,module,exports){
'use strict';
// B.2.3.9 String.prototype.italics()
require('./_string-html')('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});

},{"./_string-html":306}],442:[function(require,module,exports){
arguments[4][195][0].apply(exports,arguments)
},{"./_iter-define":256,"./_string-at":304,"dup":195}],443:[function(require,module,exports){
'use strict';
// B.2.3.10 String.prototype.link(url)
require('./_string-html')('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});

},{"./_string-html":306}],444:[function(require,module,exports){
var $export = require('./_export');
var toIObject = require('./_to-iobject');
var toLength = require('./_to-length');

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});

},{"./_export":234,"./_to-iobject":315,"./_to-length":316}],445:[function(require,module,exports){
var $export = require('./_export');

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: require('./_string-repeat')
});

},{"./_export":234,"./_string-repeat":308}],446:[function(require,module,exports){
'use strict';
// B.2.3.11 String.prototype.small()
require('./_string-html')('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});

},{"./_string-html":306}],447:[function(require,module,exports){
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
'use strict';
var $export = require('./_export');
var toLength = require('./_to-length');
var context = require('./_string-context');
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * require('./_fails-is-regexp')(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});

},{"./_export":234,"./_fails-is-regexp":235,"./_string-context":305,"./_to-length":316}],448:[function(require,module,exports){
'use strict';
// B.2.3.12 String.prototype.strike()
require('./_string-html')('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});

},{"./_string-html":306}],449:[function(require,module,exports){
'use strict';
// B.2.3.13 String.prototype.sub()
require('./_string-html')('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});

},{"./_string-html":306}],450:[function(require,module,exports){
'use strict';
// B.2.3.14 String.prototype.sup()
require('./_string-html')('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});

},{"./_string-html":306}],451:[function(require,module,exports){
'use strict';
// 21.1.3.25 String.prototype.trim()
require('./_string-trim')('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});

},{"./_string-trim":309}],452:[function(require,module,exports){
arguments[4][196][0].apply(exports,arguments)
},{"./_an-object":208,"./_descriptors":230,"./_enum-keys":233,"./_export":234,"./_fails":236,"./_global":241,"./_has":242,"./_hide":243,"./_is-array":250,"./_library":260,"./_meta":266,"./_object-create":271,"./_object-dp":272,"./_object-gopd":275,"./_object-gopn":277,"./_object-gopn-ext":276,"./_object-gops":278,"./_object-keys":281,"./_object-pie":282,"./_property-desc":290,"./_redefine":292,"./_set-to-string-tag":299,"./_shared":301,"./_to-iobject":315,"./_to-primitive":318,"./_uid":322,"./_wks":326,"./_wks-define":324,"./_wks-ext":325,"dup":196}],453:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $typed = require('./_typed');
var buffer = require('./_typed-buffer');
var anObject = require('./_an-object');
var toAbsoluteIndex = require('./_to-absolute-index');
var toLength = require('./_to-length');
var isObject = require('./_is-object');
var ArrayBuffer = require('./_global').ArrayBuffer;
var speciesConstructor = require('./_species-constructor');
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * require('./_fails')(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var final = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < final) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

require('./_set-species')(ARRAY_BUFFER);

},{"./_an-object":208,"./_export":234,"./_fails":236,"./_global":241,"./_is-object":252,"./_set-species":298,"./_species-constructor":302,"./_to-absolute-index":312,"./_to-length":316,"./_typed":321,"./_typed-buffer":320}],454:[function(require,module,exports){
var $export = require('./_export');
$export($export.G + $export.W + $export.F * !require('./_typed').ABV, {
  DataView: require('./_typed-buffer').DataView
});

},{"./_export":234,"./_typed":321,"./_typed-buffer":320}],455:[function(require,module,exports){
require('./_typed-array')('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"./_typed-array":319}],456:[function(require,module,exports){
require('./_typed-array')('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"./_typed-array":319}],457:[function(require,module,exports){
require('./_typed-array')('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"./_typed-array":319}],458:[function(require,module,exports){
require('./_typed-array')('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"./_typed-array":319}],459:[function(require,module,exports){
require('./_typed-array')('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"./_typed-array":319}],460:[function(require,module,exports){
require('./_typed-array')('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"./_typed-array":319}],461:[function(require,module,exports){
require('./_typed-array')('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"./_typed-array":319}],462:[function(require,module,exports){
require('./_typed-array')('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"./_typed-array":319}],463:[function(require,module,exports){
require('./_typed-array')('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);

},{"./_typed-array":319}],464:[function(require,module,exports){
'use strict';
var each = require('./_array-methods')(0);
var redefine = require('./_redefine');
var meta = require('./_meta');
var assign = require('./_object-assign');
var weak = require('./_collection-weak');
var isObject = require('./_is-object');
var fails = require('./_fails');
var validate = require('./_validate-collection');
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var tmp = {};
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = require('./_collection')(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}

},{"./_array-methods":213,"./_collection":223,"./_collection-weak":222,"./_fails":236,"./_is-object":252,"./_meta":266,"./_object-assign":270,"./_redefine":292,"./_validate-collection":323}],465:[function(require,module,exports){
'use strict';
var weak = require('./_collection-weak');
var validate = require('./_validate-collection');
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
require('./_collection')(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);

},{"./_collection":223,"./_collection-weak":222,"./_validate-collection":323}],466:[function(require,module,exports){
'use strict';
// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = require('./_export');
var flattenIntoArray = require('./_flatten-into-array');
var toObject = require('./_to-object');
var toLength = require('./_to-length');
var aFunction = require('./_a-function');
var arraySpeciesCreate = require('./_array-species-create');

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

require('./_add-to-unscopables')('flatMap');

},{"./_a-function":204,"./_add-to-unscopables":206,"./_array-species-create":216,"./_export":234,"./_flatten-into-array":239,"./_to-length":316,"./_to-object":317}],467:[function(require,module,exports){
'use strict';
// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = require('./_export');
var flattenIntoArray = require('./_flatten-into-array');
var toObject = require('./_to-object');
var toLength = require('./_to-length');
var toInteger = require('./_to-integer');
var arraySpeciesCreate = require('./_array-species-create');

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

require('./_add-to-unscopables')('flatten');

},{"./_add-to-unscopables":206,"./_array-species-create":216,"./_export":234,"./_flatten-into-array":239,"./_to-integer":314,"./_to-length":316,"./_to-object":317}],468:[function(require,module,exports){
'use strict';
// https://github.com/tc39/Array.prototype.includes
var $export = require('./_export');
var $includes = require('./_array-includes')(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

require('./_add-to-unscopables')('includes');

},{"./_add-to-unscopables":206,"./_array-includes":212,"./_export":234}],469:[function(require,module,exports){
// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = require('./_export');
var microtask = require('./_microtask')();
var process = require('./_global').process;
var isNode = require('./_cof')(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});

},{"./_cof":219,"./_export":234,"./_global":241,"./_microtask":268}],470:[function(require,module,exports){
// https://github.com/ljharb/proposal-is-error
var $export = require('./_export');
var cof = require('./_cof');

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});

},{"./_cof":219,"./_export":234}],471:[function(require,module,exports){
// https://github.com/tc39/proposal-global
var $export = require('./_export');

$export($export.G, { global: require('./_global') });

},{"./_export":234,"./_global":241}],472:[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
require('./_set-collection-from')('Map');

},{"./_set-collection-from":295}],473:[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
require('./_set-collection-of')('Map');

},{"./_set-collection-of":296}],474:[function(require,module,exports){
// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = require('./_export');

$export($export.P + $export.R, 'Map', { toJSON: require('./_collection-to-json')('Map') });

},{"./_collection-to-json":221,"./_export":234}],475:[function(require,module,exports){
// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});

},{"./_export":234}],476:[function(require,module,exports){
// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });

},{"./_export":234}],477:[function(require,module,exports){
// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});

},{"./_export":234}],478:[function(require,module,exports){
// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');
var scale = require('./_math-scale');
var fround = require('./_math-fround');

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});

},{"./_export":234,"./_math-fround":262,"./_math-scale":264}],479:[function(require,module,exports){
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = require('./_export');

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});

},{"./_export":234}],480:[function(require,module,exports){
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = require('./_export');

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});

},{"./_export":234}],481:[function(require,module,exports){
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = require('./_export');

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});

},{"./_export":234}],482:[function(require,module,exports){
// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });

},{"./_export":234}],483:[function(require,module,exports){
// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});

},{"./_export":234}],484:[function(require,module,exports){
// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');

$export($export.S, 'Math', { scale: require('./_math-scale') });

},{"./_export":234,"./_math-scale":264}],485:[function(require,module,exports){
// http://jfbastien.github.io/papers/Math.signbit.html
var $export = require('./_export');

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });

},{"./_export":234}],486:[function(require,module,exports){
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = require('./_export');

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});

},{"./_export":234}],487:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var toObject = require('./_to-object');
var aFunction = require('./_a-function');
var $defineProperty = require('./_object-dp');

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
require('./_descriptors') && $export($export.P + require('./_object-forced-pam'), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});

},{"./_a-function":204,"./_descriptors":230,"./_export":234,"./_object-dp":272,"./_object-forced-pam":274,"./_to-object":317}],488:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var toObject = require('./_to-object');
var aFunction = require('./_a-function');
var $defineProperty = require('./_object-dp');

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
require('./_descriptors') && $export($export.P + require('./_object-forced-pam'), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});

},{"./_a-function":204,"./_descriptors":230,"./_export":234,"./_object-dp":272,"./_object-forced-pam":274,"./_to-object":317}],489:[function(require,module,exports){
arguments[4][197][0].apply(exports,arguments)
},{"./_export":234,"./_object-to-array":284,"dup":197}],490:[function(require,module,exports){
// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = require('./_export');
var ownKeys = require('./_own-keys');
var toIObject = require('./_to-iobject');
var gOPD = require('./_object-gopd');
var createProperty = require('./_create-property');

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});

},{"./_create-property":225,"./_export":234,"./_object-gopd":275,"./_own-keys":285,"./_to-iobject":315}],491:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var toObject = require('./_to-object');
var toPrimitive = require('./_to-primitive');
var getPrototypeOf = require('./_object-gpo');
var getOwnPropertyDescriptor = require('./_object-gopd').f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
require('./_descriptors') && $export($export.P + require('./_object-forced-pam'), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});

},{"./_descriptors":230,"./_export":234,"./_object-forced-pam":274,"./_object-gopd":275,"./_object-gpo":279,"./_to-object":317,"./_to-primitive":318}],492:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var toObject = require('./_to-object');
var toPrimitive = require('./_to-primitive');
var getPrototypeOf = require('./_object-gpo');
var getOwnPropertyDescriptor = require('./_object-gopd').f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
require('./_descriptors') && $export($export.P + require('./_object-forced-pam'), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});

},{"./_descriptors":230,"./_export":234,"./_object-forced-pam":274,"./_object-gopd":275,"./_object-gpo":279,"./_to-object":317,"./_to-primitive":318}],493:[function(require,module,exports){
arguments[4][198][0].apply(exports,arguments)
},{"./_export":234,"./_object-to-array":284,"dup":198}],494:[function(require,module,exports){
'use strict';
// https://github.com/zenparsing/es-observable
var $export = require('./_export');
var global = require('./_global');
var core = require('./_core');
var microtask = require('./_microtask')();
var OBSERVABLE = require('./_wks')('observable');
var aFunction = require('./_a-function');
var anObject = require('./_an-object');
var anInstance = require('./_an-instance');
var redefineAll = require('./_redefine-all');
var hide = require('./_hide');
var forOf = require('./_for-of');
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

require('./_set-species')('Observable');

},{"./_a-function":204,"./_an-instance":207,"./_an-object":208,"./_core":224,"./_export":234,"./_for-of":240,"./_global":241,"./_hide":243,"./_microtask":268,"./_redefine-all":291,"./_set-species":298,"./_wks":326}],495:[function(require,module,exports){
arguments[4][199][0].apply(exports,arguments)
},{"./_core":224,"./_export":234,"./_global":241,"./_promise-resolve":289,"./_species-constructor":302,"dup":199}],496:[function(require,module,exports){
arguments[4][200][0].apply(exports,arguments)
},{"./_export":234,"./_new-promise-capability":269,"./_perform":288,"dup":200}],497:[function(require,module,exports){
var metadata = require('./_metadata');
var anObject = require('./_an-object');
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });

},{"./_an-object":208,"./_metadata":267}],498:[function(require,module,exports){
var metadata = require('./_metadata');
var anObject = require('./_an-object');
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });

},{"./_an-object":208,"./_metadata":267}],499:[function(require,module,exports){
var Set = require('./es6.set');
var from = require('./_array-from-iterable');
var metadata = require('./_metadata');
var anObject = require('./_an-object');
var getPrototypeOf = require('./_object-gpo');
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });

},{"./_an-object":208,"./_array-from-iterable":211,"./_metadata":267,"./_object-gpo":279,"./es6.set":429}],500:[function(require,module,exports){
var metadata = require('./_metadata');
var anObject = require('./_an-object');
var getPrototypeOf = require('./_object-gpo');
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });

},{"./_an-object":208,"./_metadata":267,"./_object-gpo":279}],501:[function(require,module,exports){
var metadata = require('./_metadata');
var anObject = require('./_an-object');
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });

},{"./_an-object":208,"./_metadata":267}],502:[function(require,module,exports){
var metadata = require('./_metadata');
var anObject = require('./_an-object');
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });

},{"./_an-object":208,"./_metadata":267}],503:[function(require,module,exports){
var metadata = require('./_metadata');
var anObject = require('./_an-object');
var getPrototypeOf = require('./_object-gpo');
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });

},{"./_an-object":208,"./_metadata":267,"./_object-gpo":279}],504:[function(require,module,exports){
var metadata = require('./_metadata');
var anObject = require('./_an-object');
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });

},{"./_an-object":208,"./_metadata":267}],505:[function(require,module,exports){
var $metadata = require('./_metadata');
var anObject = require('./_an-object');
var aFunction = require('./_a-function');
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });

},{"./_a-function":204,"./_an-object":208,"./_metadata":267}],506:[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
require('./_set-collection-from')('Set');

},{"./_set-collection-from":295}],507:[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
require('./_set-collection-of')('Set');

},{"./_set-collection-of":296}],508:[function(require,module,exports){
// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = require('./_export');

$export($export.P + $export.R, 'Set', { toJSON: require('./_collection-to-json')('Set') });

},{"./_collection-to-json":221,"./_export":234}],509:[function(require,module,exports){
'use strict';
// https://github.com/mathiasbynens/String.prototype.at
var $export = require('./_export');
var $at = require('./_string-at')(true);

$export($export.P, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});

},{"./_export":234,"./_string-at":304}],510:[function(require,module,exports){
'use strict';
// https://tc39.github.io/String.prototype.matchAll/
var $export = require('./_export');
var defined = require('./_defined');
var toLength = require('./_to-length');
var isRegExp = require('./_is-regexp');
var getFlags = require('./_flags');
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

require('./_iter-create')($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});

},{"./_defined":229,"./_export":234,"./_flags":238,"./_is-regexp":253,"./_iter-create":255,"./_to-length":316}],511:[function(require,module,exports){
'use strict';
// https://github.com/tc39/proposal-string-pad-start-end
var $export = require('./_export');
var $pad = require('./_string-pad');

$export($export.P, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});

},{"./_export":234,"./_string-pad":307}],512:[function(require,module,exports){
'use strict';
// https://github.com/tc39/proposal-string-pad-start-end
var $export = require('./_export');
var $pad = require('./_string-pad');

$export($export.P, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});

},{"./_export":234,"./_string-pad":307}],513:[function(require,module,exports){
'use strict';
// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
require('./_string-trim')('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');

},{"./_string-trim":309}],514:[function(require,module,exports){
'use strict';
// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
require('./_string-trim')('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');

},{"./_string-trim":309}],515:[function(require,module,exports){
arguments[4][201][0].apply(exports,arguments)
},{"./_wks-define":324,"dup":201}],516:[function(require,module,exports){
arguments[4][202][0].apply(exports,arguments)
},{"./_wks-define":324,"dup":202}],517:[function(require,module,exports){
// https://github.com/tc39/proposal-global
var $export = require('./_export');

$export($export.S, 'System', { global: require('./_global') });

},{"./_export":234,"./_global":241}],518:[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
require('./_set-collection-from')('WeakMap');

},{"./_set-collection-from":295}],519:[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
require('./_set-collection-of')('WeakMap');

},{"./_set-collection-of":296}],520:[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
require('./_set-collection-from')('WeakSet');

},{"./_set-collection-from":295}],521:[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
require('./_set-collection-of')('WeakSet');

},{"./_set-collection-of":296}],522:[function(require,module,exports){
var $iterators = require('./es6.array.iterator');
var getKeys = require('./_object-keys');
var redefine = require('./_redefine');
var global = require('./_global');
var hide = require('./_hide');
var Iterators = require('./_iterators');
var wks = require('./_wks');
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}

},{"./_global":241,"./_hide":243,"./_iterators":259,"./_object-keys":281,"./_redefine":292,"./_wks":326,"./es6.array.iterator":339}],523:[function(require,module,exports){
var $export = require('./_export');
var $task = require('./_task');
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});

},{"./_export":234,"./_task":311}],524:[function(require,module,exports){
// ie9- setTimeout & setInterval additional parameters fix
var global = require('./_global');
var $export = require('./_export');
var navigator = global.navigator;
var slice = [].slice;
var MSIE = !!navigator && /MSIE .\./.test(navigator.userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});

},{"./_export":234,"./_global":241}],525:[function(require,module,exports){
require('./modules/es6.symbol');
require('./modules/es6.object.create');
require('./modules/es6.object.define-property');
require('./modules/es6.object.define-properties');
require('./modules/es6.object.get-own-property-descriptor');
require('./modules/es6.object.get-prototype-of');
require('./modules/es6.object.keys');
require('./modules/es6.object.get-own-property-names');
require('./modules/es6.object.freeze');
require('./modules/es6.object.seal');
require('./modules/es6.object.prevent-extensions');
require('./modules/es6.object.is-frozen');
require('./modules/es6.object.is-sealed');
require('./modules/es6.object.is-extensible');
require('./modules/es6.object.assign');
require('./modules/es6.object.is');
require('./modules/es6.object.set-prototype-of');
require('./modules/es6.object.to-string');
require('./modules/es6.function.bind');
require('./modules/es6.function.name');
require('./modules/es6.function.has-instance');
require('./modules/es6.parse-int');
require('./modules/es6.parse-float');
require('./modules/es6.number.constructor');
require('./modules/es6.number.to-fixed');
require('./modules/es6.number.to-precision');
require('./modules/es6.number.epsilon');
require('./modules/es6.number.is-finite');
require('./modules/es6.number.is-integer');
require('./modules/es6.number.is-nan');
require('./modules/es6.number.is-safe-integer');
require('./modules/es6.number.max-safe-integer');
require('./modules/es6.number.min-safe-integer');
require('./modules/es6.number.parse-float');
require('./modules/es6.number.parse-int');
require('./modules/es6.math.acosh');
require('./modules/es6.math.asinh');
require('./modules/es6.math.atanh');
require('./modules/es6.math.cbrt');
require('./modules/es6.math.clz32');
require('./modules/es6.math.cosh');
require('./modules/es6.math.expm1');
require('./modules/es6.math.fround');
require('./modules/es6.math.hypot');
require('./modules/es6.math.imul');
require('./modules/es6.math.log10');
require('./modules/es6.math.log1p');
require('./modules/es6.math.log2');
require('./modules/es6.math.sign');
require('./modules/es6.math.sinh');
require('./modules/es6.math.tanh');
require('./modules/es6.math.trunc');
require('./modules/es6.string.from-code-point');
require('./modules/es6.string.raw');
require('./modules/es6.string.trim');
require('./modules/es6.string.iterator');
require('./modules/es6.string.code-point-at');
require('./modules/es6.string.ends-with');
require('./modules/es6.string.includes');
require('./modules/es6.string.repeat');
require('./modules/es6.string.starts-with');
require('./modules/es6.string.anchor');
require('./modules/es6.string.big');
require('./modules/es6.string.blink');
require('./modules/es6.string.bold');
require('./modules/es6.string.fixed');
require('./modules/es6.string.fontcolor');
require('./modules/es6.string.fontsize');
require('./modules/es6.string.italics');
require('./modules/es6.string.link');
require('./modules/es6.string.small');
require('./modules/es6.string.strike');
require('./modules/es6.string.sub');
require('./modules/es6.string.sup');
require('./modules/es6.date.now');
require('./modules/es6.date.to-json');
require('./modules/es6.date.to-iso-string');
require('./modules/es6.date.to-string');
require('./modules/es6.date.to-primitive');
require('./modules/es6.array.is-array');
require('./modules/es6.array.from');
require('./modules/es6.array.of');
require('./modules/es6.array.join');
require('./modules/es6.array.slice');
require('./modules/es6.array.sort');
require('./modules/es6.array.for-each');
require('./modules/es6.array.map');
require('./modules/es6.array.filter');
require('./modules/es6.array.some');
require('./modules/es6.array.every');
require('./modules/es6.array.reduce');
require('./modules/es6.array.reduce-right');
require('./modules/es6.array.index-of');
require('./modules/es6.array.last-index-of');
require('./modules/es6.array.copy-within');
require('./modules/es6.array.fill');
require('./modules/es6.array.find');
require('./modules/es6.array.find-index');
require('./modules/es6.array.species');
require('./modules/es6.array.iterator');
require('./modules/es6.regexp.constructor');
require('./modules/es6.regexp.to-string');
require('./modules/es6.regexp.flags');
require('./modules/es6.regexp.match');
require('./modules/es6.regexp.replace');
require('./modules/es6.regexp.search');
require('./modules/es6.regexp.split');
require('./modules/es6.promise');
require('./modules/es6.map');
require('./modules/es6.set');
require('./modules/es6.weak-map');
require('./modules/es6.weak-set');
require('./modules/es6.typed.array-buffer');
require('./modules/es6.typed.data-view');
require('./modules/es6.typed.int8-array');
require('./modules/es6.typed.uint8-array');
require('./modules/es6.typed.uint8-clamped-array');
require('./modules/es6.typed.int16-array');
require('./modules/es6.typed.uint16-array');
require('./modules/es6.typed.int32-array');
require('./modules/es6.typed.uint32-array');
require('./modules/es6.typed.float32-array');
require('./modules/es6.typed.float64-array');
require('./modules/es6.reflect.apply');
require('./modules/es6.reflect.construct');
require('./modules/es6.reflect.define-property');
require('./modules/es6.reflect.delete-property');
require('./modules/es6.reflect.enumerate');
require('./modules/es6.reflect.get');
require('./modules/es6.reflect.get-own-property-descriptor');
require('./modules/es6.reflect.get-prototype-of');
require('./modules/es6.reflect.has');
require('./modules/es6.reflect.is-extensible');
require('./modules/es6.reflect.own-keys');
require('./modules/es6.reflect.prevent-extensions');
require('./modules/es6.reflect.set');
require('./modules/es6.reflect.set-prototype-of');
require('./modules/es7.array.includes');
require('./modules/es7.array.flat-map');
require('./modules/es7.array.flatten');
require('./modules/es7.string.at');
require('./modules/es7.string.pad-start');
require('./modules/es7.string.pad-end');
require('./modules/es7.string.trim-left');
require('./modules/es7.string.trim-right');
require('./modules/es7.string.match-all');
require('./modules/es7.symbol.async-iterator');
require('./modules/es7.symbol.observable');
require('./modules/es7.object.get-own-property-descriptors');
require('./modules/es7.object.values');
require('./modules/es7.object.entries');
require('./modules/es7.object.define-getter');
require('./modules/es7.object.define-setter');
require('./modules/es7.object.lookup-getter');
require('./modules/es7.object.lookup-setter');
require('./modules/es7.map.to-json');
require('./modules/es7.set.to-json');
require('./modules/es7.map.of');
require('./modules/es7.set.of');
require('./modules/es7.weak-map.of');
require('./modules/es7.weak-set.of');
require('./modules/es7.map.from');
require('./modules/es7.set.from');
require('./modules/es7.weak-map.from');
require('./modules/es7.weak-set.from');
require('./modules/es7.global');
require('./modules/es7.system.global');
require('./modules/es7.error.is-error');
require('./modules/es7.math.clamp');
require('./modules/es7.math.deg-per-rad');
require('./modules/es7.math.degrees');
require('./modules/es7.math.fscale');
require('./modules/es7.math.iaddh');
require('./modules/es7.math.isubh');
require('./modules/es7.math.imulh');
require('./modules/es7.math.rad-per-deg');
require('./modules/es7.math.radians');
require('./modules/es7.math.scale');
require('./modules/es7.math.umulh');
require('./modules/es7.math.signbit');
require('./modules/es7.promise.finally');
require('./modules/es7.promise.try');
require('./modules/es7.reflect.define-metadata');
require('./modules/es7.reflect.delete-metadata');
require('./modules/es7.reflect.get-metadata');
require('./modules/es7.reflect.get-metadata-keys');
require('./modules/es7.reflect.get-own-metadata');
require('./modules/es7.reflect.get-own-metadata-keys');
require('./modules/es7.reflect.has-metadata');
require('./modules/es7.reflect.has-own-metadata');
require('./modules/es7.reflect.metadata');
require('./modules/es7.asap');
require('./modules/es7.observable');
require('./modules/web.timers');
require('./modules/web.immediate');
require('./modules/web.dom.iterable');
module.exports = require('./modules/_core');

},{"./modules/_core":224,"./modules/es6.array.copy-within":329,"./modules/es6.array.every":330,"./modules/es6.array.fill":331,"./modules/es6.array.filter":332,"./modules/es6.array.find":334,"./modules/es6.array.find-index":333,"./modules/es6.array.for-each":335,"./modules/es6.array.from":336,"./modules/es6.array.index-of":337,"./modules/es6.array.is-array":338,"./modules/es6.array.iterator":339,"./modules/es6.array.join":340,"./modules/es6.array.last-index-of":341,"./modules/es6.array.map":342,"./modules/es6.array.of":343,"./modules/es6.array.reduce":345,"./modules/es6.array.reduce-right":344,"./modules/es6.array.slice":346,"./modules/es6.array.some":347,"./modules/es6.array.sort":348,"./modules/es6.array.species":349,"./modules/es6.date.now":350,"./modules/es6.date.to-iso-string":351,"./modules/es6.date.to-json":352,"./modules/es6.date.to-primitive":353,"./modules/es6.date.to-string":354,"./modules/es6.function.bind":355,"./modules/es6.function.has-instance":356,"./modules/es6.function.name":357,"./modules/es6.map":358,"./modules/es6.math.acosh":359,"./modules/es6.math.asinh":360,"./modules/es6.math.atanh":361,"./modules/es6.math.cbrt":362,"./modules/es6.math.clz32":363,"./modules/es6.math.cosh":364,"./modules/es6.math.expm1":365,"./modules/es6.math.fround":366,"./modules/es6.math.hypot":367,"./modules/es6.math.imul":368,"./modules/es6.math.log10":369,"./modules/es6.math.log1p":370,"./modules/es6.math.log2":371,"./modules/es6.math.sign":372,"./modules/es6.math.sinh":373,"./modules/es6.math.tanh":374,"./modules/es6.math.trunc":375,"./modules/es6.number.constructor":376,"./modules/es6.number.epsilon":377,"./modules/es6.number.is-finite":378,"./modules/es6.number.is-integer":379,"./modules/es6.number.is-nan":380,"./modules/es6.number.is-safe-integer":381,"./modules/es6.number.max-safe-integer":382,"./modules/es6.number.min-safe-integer":383,"./modules/es6.number.parse-float":384,"./modules/es6.number.parse-int":385,"./modules/es6.number.to-fixed":386,"./modules/es6.number.to-precision":387,"./modules/es6.object.assign":388,"./modules/es6.object.create":389,"./modules/es6.object.define-properties":390,"./modules/es6.object.define-property":391,"./modules/es6.object.freeze":392,"./modules/es6.object.get-own-property-descriptor":393,"./modules/es6.object.get-own-property-names":394,"./modules/es6.object.get-prototype-of":395,"./modules/es6.object.is":399,"./modules/es6.object.is-extensible":396,"./modules/es6.object.is-frozen":397,"./modules/es6.object.is-sealed":398,"./modules/es6.object.keys":400,"./modules/es6.object.prevent-extensions":401,"./modules/es6.object.seal":402,"./modules/es6.object.set-prototype-of":403,"./modules/es6.object.to-string":404,"./modules/es6.parse-float":405,"./modules/es6.parse-int":406,"./modules/es6.promise":407,"./modules/es6.reflect.apply":408,"./modules/es6.reflect.construct":409,"./modules/es6.reflect.define-property":410,"./modules/es6.reflect.delete-property":411,"./modules/es6.reflect.enumerate":412,"./modules/es6.reflect.get":415,"./modules/es6.reflect.get-own-property-descriptor":413,"./modules/es6.reflect.get-prototype-of":414,"./modules/es6.reflect.has":416,"./modules/es6.reflect.is-extensible":417,"./modules/es6.reflect.own-keys":418,"./modules/es6.reflect.prevent-extensions":419,"./modules/es6.reflect.set":421,"./modules/es6.reflect.set-prototype-of":420,"./modules/es6.regexp.constructor":422,"./modules/es6.regexp.flags":423,"./modules/es6.regexp.match":424,"./modules/es6.regexp.replace":425,"./modules/es6.regexp.search":426,"./modules/es6.regexp.split":427,"./modules/es6.regexp.to-string":428,"./modules/es6.set":429,"./modules/es6.string.anchor":430,"./modules/es6.string.big":431,"./modules/es6.string.blink":432,"./modules/es6.string.bold":433,"./modules/es6.string.code-point-at":434,"./modules/es6.string.ends-with":435,"./modules/es6.string.fixed":436,"./modules/es6.string.fontcolor":437,"./modules/es6.string.fontsize":438,"./modules/es6.string.from-code-point":439,"./modules/es6.string.includes":440,"./modules/es6.string.italics":441,"./modules/es6.string.iterator":442,"./modules/es6.string.link":443,"./modules/es6.string.raw":444,"./modules/es6.string.repeat":445,"./modules/es6.string.small":446,"./modules/es6.string.starts-with":447,"./modules/es6.string.strike":448,"./modules/es6.string.sub":449,"./modules/es6.string.sup":450,"./modules/es6.string.trim":451,"./modules/es6.symbol":452,"./modules/es6.typed.array-buffer":453,"./modules/es6.typed.data-view":454,"./modules/es6.typed.float32-array":455,"./modules/es6.typed.float64-array":456,"./modules/es6.typed.int16-array":457,"./modules/es6.typed.int32-array":458,"./modules/es6.typed.int8-array":459,"./modules/es6.typed.uint16-array":460,"./modules/es6.typed.uint32-array":461,"./modules/es6.typed.uint8-array":462,"./modules/es6.typed.uint8-clamped-array":463,"./modules/es6.weak-map":464,"./modules/es6.weak-set":465,"./modules/es7.array.flat-map":466,"./modules/es7.array.flatten":467,"./modules/es7.array.includes":468,"./modules/es7.asap":469,"./modules/es7.error.is-error":470,"./modules/es7.global":471,"./modules/es7.map.from":472,"./modules/es7.map.of":473,"./modules/es7.map.to-json":474,"./modules/es7.math.clamp":475,"./modules/es7.math.deg-per-rad":476,"./modules/es7.math.degrees":477,"./modules/es7.math.fscale":478,"./modules/es7.math.iaddh":479,"./modules/es7.math.imulh":480,"./modules/es7.math.isubh":481,"./modules/es7.math.rad-per-deg":482,"./modules/es7.math.radians":483,"./modules/es7.math.scale":484,"./modules/es7.math.signbit":485,"./modules/es7.math.umulh":486,"./modules/es7.object.define-getter":487,"./modules/es7.object.define-setter":488,"./modules/es7.object.entries":489,"./modules/es7.object.get-own-property-descriptors":490,"./modules/es7.object.lookup-getter":491,"./modules/es7.object.lookup-setter":492,"./modules/es7.object.values":493,"./modules/es7.observable":494,"./modules/es7.promise.finally":495,"./modules/es7.promise.try":496,"./modules/es7.reflect.define-metadata":497,"./modules/es7.reflect.delete-metadata":498,"./modules/es7.reflect.get-metadata":500,"./modules/es7.reflect.get-metadata-keys":499,"./modules/es7.reflect.get-own-metadata":502,"./modules/es7.reflect.get-own-metadata-keys":501,"./modules/es7.reflect.has-metadata":503,"./modules/es7.reflect.has-own-metadata":504,"./modules/es7.reflect.metadata":505,"./modules/es7.set.from":506,"./modules/es7.set.of":507,"./modules/es7.set.to-json":508,"./modules/es7.string.at":509,"./modules/es7.string.match-all":510,"./modules/es7.string.pad-end":511,"./modules/es7.string.pad-start":512,"./modules/es7.string.trim-left":513,"./modules/es7.string.trim-right":514,"./modules/es7.symbol.async-iterator":515,"./modules/es7.symbol.observable":516,"./modules/es7.system.global":517,"./modules/es7.weak-map.from":518,"./modules/es7.weak-map.of":519,"./modules/es7.weak-set.from":520,"./modules/es7.weak-set.of":521,"./modules/web.dom.iterable":522,"./modules/web.immediate":523,"./modules/web.timers":524}],526:[function(require,module,exports){
'use strict';

/******************************************************************************
 * Created 2008-08-19.
 *
 * Dijkstra path-finding functions. Adapted from the Dijkstar Python project.
 *
 * Copyright (C) 2008
 *   Wyatt Baldwin <self@wyattbaldwin.com>
 *   All rights reserved
 *
 * Licensed under the MIT license.
 *
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *****************************************************************************/
var dijkstra = {
  single_source_shortest_paths: function(graph, s, d) {
    // Predecessor map for each node that has been encountered.
    // node ID => predecessor node ID
    var predecessors = {};

    // Costs of shortest paths from s to all nodes encountered.
    // node ID => cost
    var costs = {};
    costs[s] = 0;

    // Costs of shortest paths from s to all nodes encountered; differs from
    // `costs` in that it provides easy access to the node that currently has
    // the known shortest path from s.
    // XXX: Do we actually need both `costs` and `open`?
    var open = dijkstra.PriorityQueue.make();
    open.push(s, 0);

    var closest,
        u, v,
        cost_of_s_to_u,
        adjacent_nodes,
        cost_of_e,
        cost_of_s_to_u_plus_cost_of_e,
        cost_of_s_to_v,
        first_visit;
    while (!open.empty()) {
      // In the nodes remaining in graph that have a known cost from s,
      // find the node, u, that currently has the shortest path from s.
      closest = open.pop();
      u = closest.value;
      cost_of_s_to_u = closest.cost;

      // Get nodes adjacent to u...
      adjacent_nodes = graph[u] || {};

      // ...and explore the edges that connect u to those nodes, updating
      // the cost of the shortest paths to any or all of those nodes as
      // necessary. v is the node across the current edge from u.
      for (v in adjacent_nodes) {
        if (adjacent_nodes.hasOwnProperty(v)) {
          // Get the cost of the edge running from u to v.
          cost_of_e = adjacent_nodes[v];

          // Cost of s to u plus the cost of u to v across e--this is *a*
          // cost from s to v that may or may not be less than the current
          // known cost to v.
          cost_of_s_to_u_plus_cost_of_e = cost_of_s_to_u + cost_of_e;

          // If we haven't visited v yet OR if the current known cost from s to
          // v is greater than the new cost we just found (cost of s to u plus
          // cost of u to v across e), update v's cost in the cost list and
          // update v's predecessor in the predecessor list (it's now u).
          cost_of_s_to_v = costs[v];
          first_visit = (typeof costs[v] === 'undefined');
          if (first_visit || cost_of_s_to_v > cost_of_s_to_u_plus_cost_of_e) {
            costs[v] = cost_of_s_to_u_plus_cost_of_e;
            open.push(v, cost_of_s_to_u_plus_cost_of_e);
            predecessors[v] = u;
          }
        }
      }
    }

    if (typeof d !== 'undefined' && typeof costs[d] === 'undefined') {
      var msg = ['Could not find a path from ', s, ' to ', d, '.'].join('');
      throw new Error(msg);
    }

    return predecessors;
  },

  extract_shortest_path_from_predecessor_list: function(predecessors, d) {
    var nodes = [];
    var u = d;
    var predecessor;
    while (u) {
      nodes.push(u);
      predecessor = predecessors[u];
      u = predecessors[u];
    }
    nodes.reverse();
    return nodes;
  },

  find_path: function(graph, s, d) {
    var predecessors = dijkstra.single_source_shortest_paths(graph, s, d);
    return dijkstra.extract_shortest_path_from_predecessor_list(
      predecessors, d);
  },

  /**
   * A very naive priority queue implementation.
   */
  PriorityQueue: {
    make: function (opts) {
      var T = dijkstra.PriorityQueue,
          t = {},
          key;
      opts = opts || {};
      for (key in T) {
        if (T.hasOwnProperty(key)) {
          t[key] = T[key];
        }
      }
      t.queue = [];
      t.sorter = opts.sorter || T.default_sorter;
      return t;
    },

    default_sorter: function (a, b) {
      return a.cost - b.cost;
    },

    /**
     * Add a new item to the queue and ensure the highest priority element
     * is at the front of the queue.
     */
    push: function (value, cost) {
      var item = {value: value, cost: cost};
      this.queue.push(item);
      this.queue.sort(this.sorter);
    },

    /**
     * Return the highest priority element in the queue.
     */
    pop: function () {
      return this.queue.shift();
    },

    empty: function () {
      return this.queue.length === 0;
    }
  }
};


// node.js module exports
if (typeof module !== 'undefined') {
  module.exports = dijkstra;
}

},{}],527:[function(require,module,exports){
module.exports = (function () {
  if (typeof self !== 'undefined') {
    return self;
  } else if (typeof window !== 'undefined') {
    return window;
  } else {
    return Function('return this')(); // eslint-disable-line no-new-func
  }
})();

},{}],528:[function(require,module,exports){

module.exports = require('./socket');

/**
 * Exports parser
 *
 * @api public
 *
 */
module.exports.parser = require('engine.io-parser');

},{"./socket":529,"engine.io-parser":541}],529:[function(require,module,exports){
/**
 * Module dependencies.
 */

var transports = require('./transports/index');
var Emitter = require('component-emitter');
var debug = require('debug')('engine.io-client:socket');
var index = require('indexof');
var parser = require('engine.io-parser');
var parseuri = require('parseuri');
var parseqs = require('parseqs');

/**
 * Module exports.
 */

module.exports = Socket;

/**
 * Socket constructor.
 *
 * @param {String|Object} uri or options
 * @param {Object} options
 * @api public
 */

function Socket (uri, opts) {
  if (!(this instanceof Socket)) return new Socket(uri, opts);

  opts = opts || {};

  if (uri && 'object' === typeof uri) {
    opts = uri;
    uri = null;
  }

  if (uri) {
    uri = parseuri(uri);
    opts.hostname = uri.host;
    opts.secure = uri.protocol === 'https' || uri.protocol === 'wss';
    opts.port = uri.port;
    if (uri.query) opts.query = uri.query;
  } else if (opts.host) {
    opts.hostname = parseuri(opts.host).host;
  }

  this.secure = null != opts.secure ? opts.secure
    : (typeof location !== 'undefined' && 'https:' === location.protocol);

  if (opts.hostname && !opts.port) {
    // if no port is specified manually, use the protocol default
    opts.port = this.secure ? '443' : '80';
  }

  this.agent = opts.agent || false;
  this.hostname = opts.hostname ||
    (typeof location !== 'undefined' ? location.hostname : 'localhost');
  this.port = opts.port || (typeof location !== 'undefined' && location.port
      ? location.port
      : (this.secure ? 443 : 80));
  this.query = opts.query || {};
  if ('string' === typeof this.query) this.query = parseqs.decode(this.query);
  this.upgrade = false !== opts.upgrade;
  this.path = (opts.path || '/engine.io').replace(/\/$/, '') + '/';
  this.forceJSONP = !!opts.forceJSONP;
  this.jsonp = false !== opts.jsonp;
  this.forceBase64 = !!opts.forceBase64;
  this.enablesXDR = !!opts.enablesXDR;
  this.withCredentials = false !== opts.withCredentials;
  this.timestampParam = opts.timestampParam || 't';
  this.timestampRequests = opts.timestampRequests;
  this.transports = opts.transports || ['polling', 'websocket'];
  this.transportOptions = opts.transportOptions || {};
  this.readyState = '';
  this.writeBuffer = [];
  this.prevBufferLen = 0;
  this.policyPort = opts.policyPort || 843;
  this.rememberUpgrade = opts.rememberUpgrade || false;
  this.binaryType = null;
  this.onlyBinaryUpgrades = opts.onlyBinaryUpgrades;
  this.perMessageDeflate = false !== opts.perMessageDeflate ? (opts.perMessageDeflate || {}) : false;

  if (true === this.perMessageDeflate) this.perMessageDeflate = {};
  if (this.perMessageDeflate && null == this.perMessageDeflate.threshold) {
    this.perMessageDeflate.threshold = 1024;
  }

  // SSL options for Node.js client
  this.pfx = opts.pfx || null;
  this.key = opts.key || null;
  this.passphrase = opts.passphrase || null;
  this.cert = opts.cert || null;
  this.ca = opts.ca || null;
  this.ciphers = opts.ciphers || null;
  this.rejectUnauthorized = opts.rejectUnauthorized === undefined ? true : opts.rejectUnauthorized;
  this.forceNode = !!opts.forceNode;

  // detect ReactNative environment
  this.isReactNative = (typeof navigator !== 'undefined' && typeof navigator.product === 'string' && navigator.product.toLowerCase() === 'reactnative');

  // other options for Node.js or ReactNative client
  if (typeof self === 'undefined' || this.isReactNative) {
    if (opts.extraHeaders && Object.keys(opts.extraHeaders).length > 0) {
      this.extraHeaders = opts.extraHeaders;
    }

    if (opts.localAddress) {
      this.localAddress = opts.localAddress;
    }
  }

  // set on handshake
  this.id = null;
  this.upgrades = null;
  this.pingInterval = null;
  this.pingTimeout = null;

  // set on heartbeat
  this.pingIntervalTimer = null;
  this.pingTimeoutTimer = null;

  this.open();
}

Socket.priorWebsocketSuccess = false;

/**
 * Mix in `Emitter`.
 */

Emitter(Socket.prototype);

/**
 * Protocol version.
 *
 * @api public
 */

Socket.protocol = parser.protocol; // this is an int

/**
 * Expose deps for legacy compatibility
 * and standalone browser access.
 */

Socket.Socket = Socket;
Socket.Transport = require('./transport');
Socket.transports = require('./transports/index');
Socket.parser = require('engine.io-parser');

/**
 * Creates transport of the given type.
 *
 * @param {String} transport name
 * @return {Transport}
 * @api private
 */

Socket.prototype.createTransport = function (name) {
  debug('creating transport "%s"', name);
  var query = clone(this.query);

  // append engine.io protocol identifier
  query.EIO = parser.protocol;

  // transport name
  query.transport = name;

  // per-transport options
  var options = this.transportOptions[name] || {};

  // session id if we already have one
  if (this.id) query.sid = this.id;

  var transport = new transports[name]({
    query: query,
    socket: this,
    agent: options.agent || this.agent,
    hostname: options.hostname || this.hostname,
    port: options.port || this.port,
    secure: options.secure || this.secure,
    path: options.path || this.path,
    forceJSONP: options.forceJSONP || this.forceJSONP,
    jsonp: options.jsonp || this.jsonp,
    forceBase64: options.forceBase64 || this.forceBase64,
    enablesXDR: options.enablesXDR || this.enablesXDR,
    withCredentials: options.withCredentials || this.withCredentials,
    timestampRequests: options.timestampRequests || this.timestampRequests,
    timestampParam: options.timestampParam || this.timestampParam,
    policyPort: options.policyPort || this.policyPort,
    pfx: options.pfx || this.pfx,
    key: options.key || this.key,
    passphrase: options.passphrase || this.passphrase,
    cert: options.cert || this.cert,
    ca: options.ca || this.ca,
    ciphers: options.ciphers || this.ciphers,
    rejectUnauthorized: options.rejectUnauthorized || this.rejectUnauthorized,
    perMessageDeflate: options.perMessageDeflate || this.perMessageDeflate,
    extraHeaders: options.extraHeaders || this.extraHeaders,
    forceNode: options.forceNode || this.forceNode,
    localAddress: options.localAddress || this.localAddress,
    requestTimeout: options.requestTimeout || this.requestTimeout,
    protocols: options.protocols || void (0),
    isReactNative: this.isReactNative
  });

  return transport;
};

function clone (obj) {
  var o = {};
  for (var i in obj) {
    if (obj.hasOwnProperty(i)) {
      o[i] = obj[i];
    }
  }
  return o;
}

/**
 * Initializes transport to use and starts probe.
 *
 * @api private
 */
Socket.prototype.open = function () {
  var transport;
  if (this.rememberUpgrade && Socket.priorWebsocketSuccess && this.transports.indexOf('websocket') !== -1) {
    transport = 'websocket';
  } else if (0 === this.transports.length) {
    // Emit error on next tick so it can be listened to
    var self = this;
    setTimeout(function () {
      self.emit('error', 'No transports available');
    }, 0);
    return;
  } else {
    transport = this.transports[0];
  }
  this.readyState = 'opening';

  // Retry with the next transport if the transport is disabled (jsonp: false)
  try {
    transport = this.createTransport(transport);
  } catch (e) {
    this.transports.shift();
    this.open();
    return;
  }

  transport.open();
  this.setTransport(transport);
};

/**
 * Sets the current transport. Disables the existing one (if any).
 *
 * @api private
 */

Socket.prototype.setTransport = function (transport) {
  debug('setting transport %s', transport.name);
  var self = this;

  if (this.transport) {
    debug('clearing existing transport %s', this.transport.name);
    this.transport.removeAllListeners();
  }

  // set up transport
  this.transport = transport;

  // set up transport listeners
  transport
  .on('drain', function () {
    self.onDrain();
  })
  .on('packet', function (packet) {
    self.onPacket(packet);
  })
  .on('error', function (e) {
    self.onError(e);
  })
  .on('close', function () {
    self.onClose('transport close');
  });
};

/**
 * Probes a transport.
 *
 * @param {String} transport name
 * @api private
 */

Socket.prototype.probe = function (name) {
  debug('probing transport "%s"', name);
  var transport = this.createTransport(name, { probe: 1 });
  var failed = false;
  var self = this;

  Socket.priorWebsocketSuccess = false;

  function onTransportOpen () {
    if (self.onlyBinaryUpgrades) {
      var upgradeLosesBinary = !this.supportsBinary && self.transport.supportsBinary;
      failed = failed || upgradeLosesBinary;
    }
    if (failed) return;

    debug('probe transport "%s" opened', name);
    transport.send([{ type: 'ping', data: 'probe' }]);
    transport.once('packet', function (msg) {
      if (failed) return;
      if ('pong' === msg.type && 'probe' === msg.data) {
        debug('probe transport "%s" pong', name);
        self.upgrading = true;
        self.emit('upgrading', transport);
        if (!transport) return;
        Socket.priorWebsocketSuccess = 'websocket' === transport.name;

        debug('pausing current transport "%s"', self.transport.name);
        self.transport.pause(function () {
          if (failed) return;
          if ('closed' === self.readyState) return;
          debug('changing transport and sending upgrade packet');

          cleanup();

          self.setTransport(transport);
          transport.send([{ type: 'upgrade' }]);
          self.emit('upgrade', transport);
          transport = null;
          self.upgrading = false;
          self.flush();
        });
      } else {
        debug('probe transport "%s" failed', name);
        var err = new Error('probe error');
        err.transport = transport.name;
        self.emit('upgradeError', err);
      }
    });
  }

  function freezeTransport () {
    if (failed) return;

    // Any callback called by transport should be ignored since now
    failed = true;

    cleanup();

    transport.close();
    transport = null;
  }

  // Handle any error that happens while probing
  function onerror (err) {
    var error = new Error('probe error: ' + err);
    error.transport = transport.name;

    freezeTransport();

    debug('probe transport "%s" failed because of error: %s', name, err);

    self.emit('upgradeError', error);
  }

  function onTransportClose () {
    onerror('transport closed');
  }

  // When the socket is closed while we're probing
  function onclose () {
    onerror('socket closed');
  }

  // When the socket is upgraded while we're probing
  function onupgrade (to) {
    if (transport && to.name !== transport.name) {
      debug('"%s" works - aborting "%s"', to.name, transport.name);
      freezeTransport();
    }
  }

  // Remove all listeners on the transport and on self
  function cleanup () {
    transport.removeListener('open', onTransportOpen);
    transport.removeListener('error', onerror);
    transport.removeListener('close', onTransportClose);
    self.removeListener('close', onclose);
    self.removeListener('upgrading', onupgrade);
  }

  transport.once('open', onTransportOpen);
  transport.once('error', onerror);
  transport.once('close', onTransportClose);

  this.once('close', onclose);
  this.once('upgrading', onupgrade);

  transport.open();
};

/**
 * Called when connection is deemed open.
 *
 * @api public
 */

Socket.prototype.onOpen = function () {
  debug('socket open');
  this.readyState = 'open';
  Socket.priorWebsocketSuccess = 'websocket' === this.transport.name;
  this.emit('open');
  this.flush();

  // we check for `readyState` in case an `open`
  // listener already closed the socket
  if ('open' === this.readyState && this.upgrade && this.transport.pause) {
    debug('starting upgrade probes');
    for (var i = 0, l = this.upgrades.length; i < l; i++) {
      this.probe(this.upgrades[i]);
    }
  }
};

/**
 * Handles a packet.
 *
 * @api private
 */

Socket.prototype.onPacket = function (packet) {
  if ('opening' === this.readyState || 'open' === this.readyState ||
      'closing' === this.readyState) {
    debug('socket receive: type "%s", data "%s"', packet.type, packet.data);

    this.emit('packet', packet);

    // Socket is live - any packet counts
    this.emit('heartbeat');

    switch (packet.type) {
      case 'open':
        this.onHandshake(JSON.parse(packet.data));
        break;

      case 'pong':
        this.setPing();
        this.emit('pong');
        break;

      case 'error':
        var err = new Error('server error');
        err.code = packet.data;
        this.onError(err);
        break;

      case 'message':
        this.emit('data', packet.data);
        this.emit('message', packet.data);
        break;
    }
  } else {
    debug('packet received with socket readyState "%s"', this.readyState);
  }
};

/**
 * Called upon handshake completion.
 *
 * @param {Object} handshake obj
 * @api private
 */

Socket.prototype.onHandshake = function (data) {
  this.emit('handshake', data);
  this.id = data.sid;
  this.transport.query.sid = data.sid;
  this.upgrades = this.filterUpgrades(data.upgrades);
  this.pingInterval = data.pingInterval;
  this.pingTimeout = data.pingTimeout;
  this.onOpen();
  // In case open handler closes socket
  if ('closed' === this.readyState) return;
  this.setPing();

  // Prolong liveness of socket on heartbeat
  this.removeListener('heartbeat', this.onHeartbeat);
  this.on('heartbeat', this.onHeartbeat);
};

/**
 * Resets ping timeout.
 *
 * @api private
 */

Socket.prototype.onHeartbeat = function (timeout) {
  clearTimeout(this.pingTimeoutTimer);
  var self = this;
  self.pingTimeoutTimer = setTimeout(function () {
    if ('closed' === self.readyState) return;
    self.onClose('ping timeout');
  }, timeout || (self.pingInterval + self.pingTimeout));
};

/**
 * Pings server every `this.pingInterval` and expects response
 * within `this.pingTimeout` or closes connection.
 *
 * @api private
 */

Socket.prototype.setPing = function () {
  var self = this;
  clearTimeout(self.pingIntervalTimer);
  self.pingIntervalTimer = setTimeout(function () {
    debug('writing ping packet - expecting pong within %sms', self.pingTimeout);
    self.ping();
    self.onHeartbeat(self.pingTimeout);
  }, self.pingInterval);
};

/**
* Sends a ping packet.
*
* @api private
*/

Socket.prototype.ping = function () {
  var self = this;
  this.sendPacket('ping', function () {
    self.emit('ping');
  });
};

/**
 * Called on `drain` event
 *
 * @api private
 */

Socket.prototype.onDrain = function () {
  this.writeBuffer.splice(0, this.prevBufferLen);

  // setting prevBufferLen = 0 is very important
  // for example, when upgrading, upgrade packet is sent over,
  // and a nonzero prevBufferLen could cause problems on `drain`
  this.prevBufferLen = 0;

  if (0 === this.writeBuffer.length) {
    this.emit('drain');
  } else {
    this.flush();
  }
};

/**
 * Flush write buffers.
 *
 * @api private
 */

Socket.prototype.flush = function () {
  if ('closed' !== this.readyState && this.transport.writable &&
    !this.upgrading && this.writeBuffer.length) {
    debug('flushing %d packets in socket', this.writeBuffer.length);
    this.transport.send(this.writeBuffer);
    // keep track of current length of writeBuffer
    // splice writeBuffer and callbackBuffer on `drain`
    this.prevBufferLen = this.writeBuffer.length;
    this.emit('flush');
  }
};

/**
 * Sends a message.
 *
 * @param {String} message.
 * @param {Function} callback function.
 * @param {Object} options.
 * @return {Socket} for chaining.
 * @api public
 */

Socket.prototype.write =
Socket.prototype.send = function (msg, options, fn) {
  this.sendPacket('message', msg, options, fn);
  return this;
};

/**
 * Sends a packet.
 *
 * @param {String} packet type.
 * @param {String} data.
 * @param {Object} options.
 * @param {Function} callback function.
 * @api private
 */

Socket.prototype.sendPacket = function (type, data, options, fn) {
  if ('function' === typeof data) {
    fn = data;
    data = undefined;
  }

  if ('function' === typeof options) {
    fn = options;
    options = null;
  }

  if ('closing' === this.readyState || 'closed' === this.readyState) {
    return;
  }

  options = options || {};
  options.compress = false !== options.compress;

  var packet = {
    type: type,
    data: data,
    options: options
  };
  this.emit('packetCreate', packet);
  this.writeBuffer.push(packet);
  if (fn) this.once('flush', fn);
  this.flush();
};

/**
 * Closes the connection.
 *
 * @api private
 */

Socket.prototype.close = function () {
  if ('opening' === this.readyState || 'open' === this.readyState) {
    this.readyState = 'closing';

    var self = this;

    if (this.writeBuffer.length) {
      this.once('drain', function () {
        if (this.upgrading) {
          waitForUpgrade();
        } else {
          close();
        }
      });
    } else if (this.upgrading) {
      waitForUpgrade();
    } else {
      close();
    }
  }

  function close () {
    self.onClose('forced close');
    debug('socket closing - telling transport to close');
    self.transport.close();
  }

  function cleanupAndClose () {
    self.removeListener('upgrade', cleanupAndClose);
    self.removeListener('upgradeError', cleanupAndClose);
    close();
  }

  function waitForUpgrade () {
    // wait for upgrade to finish since we can't send packets while pausing a transport
    self.once('upgrade', cleanupAndClose);
    self.once('upgradeError', cleanupAndClose);
  }

  return this;
};

/**
 * Called upon transport error
 *
 * @api private
 */

Socket.prototype.onError = function (err) {
  debug('socket error %j', err);
  Socket.priorWebsocketSuccess = false;
  this.emit('error', err);
  this.onClose('transport error', err);
};

/**
 * Called upon transport close.
 *
 * @api private
 */

Socket.prototype.onClose = function (reason, desc) {
  if ('opening' === this.readyState || 'open' === this.readyState || 'closing' === this.readyState) {
    debug('socket close with reason: "%s"', reason);
    var self = this;

    // clear timers
    clearTimeout(this.pingIntervalTimer);
    clearTimeout(this.pingTimeoutTimer);

    // stop event from firing again for transport
    this.transport.removeAllListeners('close');

    // ensure transport won't stay open
    this.transport.close();

    // ignore further transport communication
    this.transport.removeAllListeners();

    // set ready state
    this.readyState = 'closed';

    // clear session id
    this.id = null;

    // emit close event
    this.emit('close', reason, desc);

    // clean buffers after, so users can still
    // grab the buffers on `close` event
    self.writeBuffer = [];
    self.prevBufferLen = 0;
  }
};

/**
 * Filters upgrades, returning only those matching client transports.
 *
 * @param {Array} server upgrades
 * @api private
 *
 */

Socket.prototype.filterUpgrades = function (upgrades) {
  var filteredUpgrades = [];
  for (var i = 0, j = upgrades.length; i < j; i++) {
    if (~index(this.transports, upgrades[i])) filteredUpgrades.push(upgrades[i]);
  }
  return filteredUpgrades;
};

},{"./transport":530,"./transports/index":531,"component-emitter":537,"debug":538,"engine.io-parser":541,"indexof":548,"parseqs":729,"parseuri":730}],530:[function(require,module,exports){
/**
 * Module dependencies.
 */

var parser = require('engine.io-parser');
var Emitter = require('component-emitter');

/**
 * Module exports.
 */

module.exports = Transport;

/**
 * Transport abstract constructor.
 *
 * @param {Object} options.
 * @api private
 */

function Transport (opts) {
  this.path = opts.path;
  this.hostname = opts.hostname;
  this.port = opts.port;
  this.secure = opts.secure;
  this.query = opts.query;
  this.timestampParam = opts.timestampParam;
  this.timestampRequests = opts.timestampRequests;
  this.readyState = '';
  this.agent = opts.agent || false;
  this.socket = opts.socket;
  this.enablesXDR = opts.enablesXDR;
  this.withCredentials = opts.withCredentials;

  // SSL options for Node.js client
  this.pfx = opts.pfx;
  this.key = opts.key;
  this.passphrase = opts.passphrase;
  this.cert = opts.cert;
  this.ca = opts.ca;
  this.ciphers = opts.ciphers;
  this.rejectUnauthorized = opts.rejectUnauthorized;
  this.forceNode = opts.forceNode;

  // results of ReactNative environment detection
  this.isReactNative = opts.isReactNative;

  // other options for Node.js client
  this.extraHeaders = opts.extraHeaders;
  this.localAddress = opts.localAddress;
}

/**
 * Mix in `Emitter`.
 */

Emitter(Transport.prototype);

/**
 * Emits an error.
 *
 * @param {String} str
 * @return {Transport} for chaining
 * @api public
 */

Transport.prototype.onError = function (msg, desc) {
  var err = new Error(msg);
  err.type = 'TransportError';
  err.description = desc;
  this.emit('error', err);
  return this;
};

/**
 * Opens the transport.
 *
 * @api public
 */

Transport.prototype.open = function () {
  if ('closed' === this.readyState || '' === this.readyState) {
    this.readyState = 'opening';
    this.doOpen();
  }

  return this;
};

/**
 * Closes the transport.
 *
 * @api private
 */

Transport.prototype.close = function () {
  if ('opening' === this.readyState || 'open' === this.readyState) {
    this.doClose();
    this.onClose();
  }

  return this;
};

/**
 * Sends multiple packets.
 *
 * @param {Array} packets
 * @api private
 */

Transport.prototype.send = function (packets) {
  if ('open' === this.readyState) {
    this.write(packets);
  } else {
    throw new Error('Transport not open');
  }
};

/**
 * Called upon open
 *
 * @api private
 */

Transport.prototype.onOpen = function () {
  this.readyState = 'open';
  this.writable = true;
  this.emit('open');
};

/**
 * Called with data.
 *
 * @param {String} data
 * @api private
 */

Transport.prototype.onData = function (data) {
  var packet = parser.decodePacket(data, this.socket.binaryType);
  this.onPacket(packet);
};

/**
 * Called with a decoded packet.
 */

Transport.prototype.onPacket = function (packet) {
  this.emit('packet', packet);
};

/**
 * Called upon close.
 *
 * @api private
 */

Transport.prototype.onClose = function () {
  this.readyState = 'closed';
  this.emit('close');
};

},{"component-emitter":537,"engine.io-parser":541}],531:[function(require,module,exports){
/**
 * Module dependencies
 */

var XMLHttpRequest = require('xmlhttprequest-ssl');
var XHR = require('./polling-xhr');
var JSONP = require('./polling-jsonp');
var websocket = require('./websocket');

/**
 * Export transports.
 */

exports.polling = polling;
exports.websocket = websocket;

/**
 * Polling transport polymorphic constructor.
 * Decides on xhr vs jsonp based on feature detection.
 *
 * @api private
 */

function polling (opts) {
  var xhr;
  var xd = false;
  var xs = false;
  var jsonp = false !== opts.jsonp;

  if (typeof location !== 'undefined') {
    var isSSL = 'https:' === location.protocol;
    var port = location.port;

    // some user agents have empty `location.port`
    if (!port) {
      port = isSSL ? 443 : 80;
    }

    xd = opts.hostname !== location.hostname || port !== opts.port;
    xs = opts.secure !== isSSL;
  }

  opts.xdomain = xd;
  opts.xscheme = xs;
  xhr = new XMLHttpRequest(opts);

  if ('open' in xhr && !opts.forceJSONP) {
    return new XHR(opts);
  } else {
    if (!jsonp) throw new Error('JSONP disabled');
    return new JSONP(opts);
  }
}

},{"./polling-jsonp":532,"./polling-xhr":533,"./websocket":535,"xmlhttprequest-ssl":536}],532:[function(require,module,exports){
/**
 * Module requirements.
 */

var Polling = require('./polling');
var inherit = require('component-inherit');
var globalThis = require('../globalThis');

/**
 * Module exports.
 */

module.exports = JSONPPolling;

/**
 * Cached regular expressions.
 */

var rNewline = /\n/g;
var rEscapedNewline = /\\n/g;

/**
 * Global JSONP callbacks.
 */

var callbacks;

/**
 * Noop.
 */

function empty () { }

/**
 * JSONP Polling constructor.
 *
 * @param {Object} opts.
 * @api public
 */

function JSONPPolling (opts) {
  Polling.call(this, opts);

  this.query = this.query || {};

  // define global callbacks array if not present
  // we do this here (lazily) to avoid unneeded global pollution
  if (!callbacks) {
    // we need to consider multiple engines in the same page
    callbacks = globalThis.___eio = (globalThis.___eio || []);
  }

  // callback identifier
  this.index = callbacks.length;

  // add callback to jsonp global
  var self = this;
  callbacks.push(function (msg) {
    self.onData(msg);
  });

  // append to query string
  this.query.j = this.index;

  // prevent spurious errors from being emitted when the window is unloaded
  if (typeof addEventListener === 'function') {
    addEventListener('beforeunload', function () {
      if (self.script) self.script.onerror = empty;
    }, false);
  }
}

/**
 * Inherits from Polling.
 */

inherit(JSONPPolling, Polling);

/*
 * JSONP only supports binary as base64 encoded strings
 */

JSONPPolling.prototype.supportsBinary = false;

/**
 * Closes the socket.
 *
 * @api private
 */

JSONPPolling.prototype.doClose = function () {
  if (this.script) {
    this.script.parentNode.removeChild(this.script);
    this.script = null;
  }

  if (this.form) {
    this.form.parentNode.removeChild(this.form);
    this.form = null;
    this.iframe = null;
  }

  Polling.prototype.doClose.call(this);
};

/**
 * Starts a poll cycle.
 *
 * @api private
 */

JSONPPolling.prototype.doPoll = function () {
  var self = this;
  var script = document.createElement('script');

  if (this.script) {
    this.script.parentNode.removeChild(this.script);
    this.script = null;
  }

  script.async = true;
  script.src = this.uri();
  script.onerror = function (e) {
    self.onError('jsonp poll error', e);
  };

  var insertAt = document.getElementsByTagName('script')[0];
  if (insertAt) {
    insertAt.parentNode.insertBefore(script, insertAt);
  } else {
    (document.head || document.body).appendChild(script);
  }
  this.script = script;

  var isUAgecko = 'undefined' !== typeof navigator && /gecko/i.test(navigator.userAgent);

  if (isUAgecko) {
    setTimeout(function () {
      var iframe = document.createElement('iframe');
      document.body.appendChild(iframe);
      document.body.removeChild(iframe);
    }, 100);
  }
};

/**
 * Writes with a hidden iframe.
 *
 * @param {String} data to send
 * @param {Function} called upon flush.
 * @api private
 */

JSONPPolling.prototype.doWrite = function (data, fn) {
  var self = this;

  if (!this.form) {
    var form = document.createElement('form');
    var area = document.createElement('textarea');
    var id = this.iframeId = 'eio_iframe_' + this.index;
    var iframe;

    form.className = 'socketio';
    form.style.position = 'absolute';
    form.style.top = '-1000px';
    form.style.left = '-1000px';
    form.target = id;
    form.method = 'POST';
    form.setAttribute('accept-charset', 'utf-8');
    area.name = 'd';
    form.appendChild(area);
    document.body.appendChild(form);

    this.form = form;
    this.area = area;
  }

  this.form.action = this.uri();

  function complete () {
    initIframe();
    fn();
  }

  function initIframe () {
    if (self.iframe) {
      try {
        self.form.removeChild(self.iframe);
      } catch (e) {
        self.onError('jsonp polling iframe removal error', e);
      }
    }

    try {
      // ie6 dynamic iframes with target="" support (thanks Chris Lambacher)
      var html = '<iframe src="javascript:0" name="' + self.iframeId + '">';
      iframe = document.createElement(html);
    } catch (e) {
      iframe = document.createElement('iframe');
      iframe.name = self.iframeId;
      iframe.src = 'javascript:0';
    }

    iframe.id = self.iframeId;

    self.form.appendChild(iframe);
    self.iframe = iframe;
  }

  initIframe();

  // escape \n to prevent it from being converted into \r\n by some UAs
  // double escaping is required for escaped new lines because unescaping of new lines can be done safely on server-side
  data = data.replace(rEscapedNewline, '\\\n');
  this.area.value = data.replace(rNewline, '\\n');

  try {
    this.form.submit();
  } catch (e) {}

  if (this.iframe.attachEvent) {
    this.iframe.onreadystatechange = function () {
      if (self.iframe.readyState === 'complete') {
        complete();
      }
    };
  } else {
    this.iframe.onload = complete;
  }
};

},{"../globalThis":527,"./polling":534,"component-inherit":85}],533:[function(require,module,exports){
/* global attachEvent */

/**
 * Module requirements.
 */

var XMLHttpRequest = require('xmlhttprequest-ssl');
var Polling = require('./polling');
var Emitter = require('component-emitter');
var inherit = require('component-inherit');
var debug = require('debug')('engine.io-client:polling-xhr');
var globalThis = require('../globalThis');

/**
 * Module exports.
 */

module.exports = XHR;
module.exports.Request = Request;

/**
 * Empty function
 */

function empty () {}

/**
 * XHR Polling constructor.
 *
 * @param {Object} opts
 * @api public
 */

function XHR (opts) {
  Polling.call(this, opts);
  this.requestTimeout = opts.requestTimeout;
  this.extraHeaders = opts.extraHeaders;

  if (typeof location !== 'undefined') {
    var isSSL = 'https:' === location.protocol;
    var port = location.port;

    // some user agents have empty `location.port`
    if (!port) {
      port = isSSL ? 443 : 80;
    }

    this.xd = (typeof location !== 'undefined' && opts.hostname !== location.hostname) ||
      port !== opts.port;
    this.xs = opts.secure !== isSSL;
  }
}

/**
 * Inherits from Polling.
 */

inherit(XHR, Polling);

/**
 * XHR supports binary
 */

XHR.prototype.supportsBinary = true;

/**
 * Creates a request.
 *
 * @param {String} method
 * @api private
 */

XHR.prototype.request = function (opts) {
  opts = opts || {};
  opts.uri = this.uri();
  opts.xd = this.xd;
  opts.xs = this.xs;
  opts.agent = this.agent || false;
  opts.supportsBinary = this.supportsBinary;
  opts.enablesXDR = this.enablesXDR;
  opts.withCredentials = this.withCredentials;

  // SSL options for Node.js client
  opts.pfx = this.pfx;
  opts.key = this.key;
  opts.passphrase = this.passphrase;
  opts.cert = this.cert;
  opts.ca = this.ca;
  opts.ciphers = this.ciphers;
  opts.rejectUnauthorized = this.rejectUnauthorized;
  opts.requestTimeout = this.requestTimeout;

  // other options for Node.js client
  opts.extraHeaders = this.extraHeaders;

  return new Request(opts);
};

/**
 * Sends data.
 *
 * @param {String} data to send.
 * @param {Function} called upon flush.
 * @api private
 */

XHR.prototype.doWrite = function (data, fn) {
  var isBinary = typeof data !== 'string' && data !== undefined;
  var req = this.request({ method: 'POST', data: data, isBinary: isBinary });
  var self = this;
  req.on('success', fn);
  req.on('error', function (err) {
    self.onError('xhr post error', err);
  });
  this.sendXhr = req;
};

/**
 * Starts a poll cycle.
 *
 * @api private
 */

XHR.prototype.doPoll = function () {
  debug('xhr poll');
  var req = this.request();
  var self = this;
  req.on('data', function (data) {
    self.onData(data);
  });
  req.on('error', function (err) {
    self.onError('xhr poll error', err);
  });
  this.pollXhr = req;
};

/**
 * Request constructor
 *
 * @param {Object} options
 * @api public
 */

function Request (opts) {
  this.method = opts.method || 'GET';
  this.uri = opts.uri;
  this.xd = !!opts.xd;
  this.xs = !!opts.xs;
  this.async = false !== opts.async;
  this.data = undefined !== opts.data ? opts.data : null;
  this.agent = opts.agent;
  this.isBinary = opts.isBinary;
  this.supportsBinary = opts.supportsBinary;
  this.enablesXDR = opts.enablesXDR;
  this.withCredentials = opts.withCredentials;
  this.requestTimeout = opts.requestTimeout;

  // SSL options for Node.js client
  this.pfx = opts.pfx;
  this.key = opts.key;
  this.passphrase = opts.passphrase;
  this.cert = opts.cert;
  this.ca = opts.ca;
  this.ciphers = opts.ciphers;
  this.rejectUnauthorized = opts.rejectUnauthorized;

  // other options for Node.js client
  this.extraHeaders = opts.extraHeaders;

  this.create();
}

/**
 * Mix in `Emitter`.
 */

Emitter(Request.prototype);

/**
 * Creates the XHR object and sends the request.
 *
 * @api private
 */

Request.prototype.create = function () {
  var opts = { agent: this.agent, xdomain: this.xd, xscheme: this.xs, enablesXDR: this.enablesXDR };

  // SSL options for Node.js client
  opts.pfx = this.pfx;
  opts.key = this.key;
  opts.passphrase = this.passphrase;
  opts.cert = this.cert;
  opts.ca = this.ca;
  opts.ciphers = this.ciphers;
  opts.rejectUnauthorized = this.rejectUnauthorized;

  var xhr = this.xhr = new XMLHttpRequest(opts);
  var self = this;

  try {
    debug('xhr open %s: %s', this.method, this.uri);
    xhr.open(this.method, this.uri, this.async);
    try {
      if (this.extraHeaders) {
        xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
        for (var i in this.extraHeaders) {
          if (this.extraHeaders.hasOwnProperty(i)) {
            xhr.setRequestHeader(i, this.extraHeaders[i]);
          }
        }
      }
    } catch (e) {}

    if ('POST' === this.method) {
      try {
        if (this.isBinary) {
          xhr.setRequestHeader('Content-type', 'application/octet-stream');
        } else {
          xhr.setRequestHeader('Content-type', 'text/plain;charset=UTF-8');
        }
      } catch (e) {}
    }

    try {
      xhr.setRequestHeader('Accept', '*/*');
    } catch (e) {}

    // ie6 check
    if ('withCredentials' in xhr) {
      xhr.withCredentials = this.withCredentials;
    }

    if (this.requestTimeout) {
      xhr.timeout = this.requestTimeout;
    }

    if (this.hasXDR()) {
      xhr.onload = function () {
        self.onLoad();
      };
      xhr.onerror = function () {
        self.onError(xhr.responseText);
      };
    } else {
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 2) {
          try {
            var contentType = xhr.getResponseHeader('Content-Type');
            if (self.supportsBinary && contentType === 'application/octet-stream' || contentType === 'application/octet-stream; charset=UTF-8') {
              xhr.responseType = 'arraybuffer';
            }
          } catch (e) {}
        }
        if (4 !== xhr.readyState) return;
        if (200 === xhr.status || 1223 === xhr.status) {
          self.onLoad();
        } else {
          // make sure the `error` event handler that's user-set
          // does not throw in the same tick and gets caught here
          setTimeout(function () {
            self.onError(typeof xhr.status === 'number' ? xhr.status : 0);
          }, 0);
        }
      };
    }

    debug('xhr data %s', this.data);
    xhr.send(this.data);
  } catch (e) {
    // Need to defer since .create() is called directly fhrom the constructor
    // and thus the 'error' event can only be only bound *after* this exception
    // occurs.  Therefore, also, we cannot throw here at all.
    setTimeout(function () {
      self.onError(e);
    }, 0);
    return;
  }

  if (typeof document !== 'undefined') {
    this.index = Request.requestsCount++;
    Request.requests[this.index] = this;
  }
};

/**
 * Called upon successful response.
 *
 * @api private
 */

Request.prototype.onSuccess = function () {
  this.emit('success');
  this.cleanup();
};

/**
 * Called if we have data.
 *
 * @api private
 */

Request.prototype.onData = function (data) {
  this.emit('data', data);
  this.onSuccess();
};

/**
 * Called upon error.
 *
 * @api private
 */

Request.prototype.onError = function (err) {
  this.emit('error', err);
  this.cleanup(true);
};

/**
 * Cleans up house.
 *
 * @api private
 */

Request.prototype.cleanup = function (fromError) {
  if ('undefined' === typeof this.xhr || null === this.xhr) {
    return;
  }
  // xmlhttprequest
  if (this.hasXDR()) {
    this.xhr.onload = this.xhr.onerror = empty;
  } else {
    this.xhr.onreadystatechange = empty;
  }

  if (fromError) {
    try {
      this.xhr.abort();
    } catch (e) {}
  }

  if (typeof document !== 'undefined') {
    delete Request.requests[this.index];
  }

  this.xhr = null;
};

/**
 * Called upon load.
 *
 * @api private
 */

Request.prototype.onLoad = function () {
  var data;
  try {
    var contentType;
    try {
      contentType = this.xhr.getResponseHeader('Content-Type');
    } catch (e) {}
    if (contentType === 'application/octet-stream' || contentType === 'application/octet-stream; charset=UTF-8') {
      data = this.xhr.response || this.xhr.responseText;
    } else {
      data = this.xhr.responseText;
    }
  } catch (e) {
    this.onError(e);
  }
  if (null != data) {
    this.onData(data);
  }
};

/**
 * Check if it has XDomainRequest.
 *
 * @api private
 */

Request.prototype.hasXDR = function () {
  return typeof XDomainRequest !== 'undefined' && !this.xs && this.enablesXDR;
};

/**
 * Aborts the request.
 *
 * @api public
 */

Request.prototype.abort = function () {
  this.cleanup();
};

/**
 * Aborts pending requests when unloading the window. This is needed to prevent
 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
 * emitted.
 */

Request.requestsCount = 0;
Request.requests = {};

if (typeof document !== 'undefined') {
  if (typeof attachEvent === 'function') {
    attachEvent('onunload', unloadHandler);
  } else if (typeof addEventListener === 'function') {
    var terminationEvent = 'onpagehide' in globalThis ? 'pagehide' : 'unload';
    addEventListener(terminationEvent, unloadHandler, false);
  }
}

function unloadHandler () {
  for (var i in Request.requests) {
    if (Request.requests.hasOwnProperty(i)) {
      Request.requests[i].abort();
    }
  }
}

},{"../globalThis":527,"./polling":534,"component-emitter":537,"component-inherit":85,"debug":538,"xmlhttprequest-ssl":536}],534:[function(require,module,exports){
/**
 * Module dependencies.
 */

var Transport = require('../transport');
var parseqs = require('parseqs');
var parser = require('engine.io-parser');
var inherit = require('component-inherit');
var yeast = require('yeast');
var debug = require('debug')('engine.io-client:polling');

/**
 * Module exports.
 */

module.exports = Polling;

/**
 * Is XHR2 supported?
 */

var hasXHR2 = (function () {
  var XMLHttpRequest = require('xmlhttprequest-ssl');
  var xhr = new XMLHttpRequest({ xdomain: false });
  return null != xhr.responseType;
})();

/**
 * Polling interface.
 *
 * @param {Object} opts
 * @api private
 */

function Polling (opts) {
  var forceBase64 = (opts && opts.forceBase64);
  if (!hasXHR2 || forceBase64) {
    this.supportsBinary = false;
  }
  Transport.call(this, opts);
}

/**
 * Inherits from Transport.
 */

inherit(Polling, Transport);

/**
 * Transport name.
 */

Polling.prototype.name = 'polling';

/**
 * Opens the socket (triggers polling). We write a PING message to determine
 * when the transport is open.
 *
 * @api private
 */

Polling.prototype.doOpen = function () {
  this.poll();
};

/**
 * Pauses polling.
 *
 * @param {Function} callback upon buffers are flushed and transport is paused
 * @api private
 */

Polling.prototype.pause = function (onPause) {
  var self = this;

  this.readyState = 'pausing';

  function pause () {
    debug('paused');
    self.readyState = 'paused';
    onPause();
  }

  if (this.polling || !this.writable) {
    var total = 0;

    if (this.polling) {
      debug('we are currently polling - waiting to pause');
      total++;
      this.once('pollComplete', function () {
        debug('pre-pause polling complete');
        --total || pause();
      });
    }

    if (!this.writable) {
      debug('we are currently writing - waiting to pause');
      total++;
      this.once('drain', function () {
        debug('pre-pause writing complete');
        --total || pause();
      });
    }
  } else {
    pause();
  }
};

/**
 * Starts polling cycle.
 *
 * @api public
 */

Polling.prototype.poll = function () {
  debug('polling');
  this.polling = true;
  this.doPoll();
  this.emit('poll');
};

/**
 * Overloads onData to detect payloads.
 *
 * @api private
 */

Polling.prototype.onData = function (data) {
  var self = this;
  debug('polling got data %s', data);
  var callback = function (packet, index, total) {
    // if its the first message we consider the transport open
    if ('opening' === self.readyState) {
      self.onOpen();
    }

    // if its a close packet, we close the ongoing requests
    if ('close' === packet.type) {
      self.onClose();
      return false;
    }

    // otherwise bypass onData and handle the message
    self.onPacket(packet);
  };

  // decode payload
  parser.decodePayload(data, this.socket.binaryType, callback);

  // if an event did not trigger closing
  if ('closed' !== this.readyState) {
    // if we got data we're not polling
    this.polling = false;
    this.emit('pollComplete');

    if ('open' === this.readyState) {
      this.poll();
    } else {
      debug('ignoring poll - transport state "%s"', this.readyState);
    }
  }
};

/**
 * For polling, send a close packet.
 *
 * @api private
 */

Polling.prototype.doClose = function () {
  var self = this;

  function close () {
    debug('writing close packet');
    self.write([{ type: 'close' }]);
  }

  if ('open' === this.readyState) {
    debug('transport open - closing');
    close();
  } else {
    // in case we're trying to close while
    // handshaking is in progress (GH-164)
    debug('transport not open - deferring close');
    this.once('open', close);
  }
};

/**
 * Writes a packets payload.
 *
 * @param {Array} data packets
 * @param {Function} drain callback
 * @api private
 */

Polling.prototype.write = function (packets) {
  var self = this;
  this.writable = false;
  var callbackfn = function () {
    self.writable = true;
    self.emit('drain');
  };

  parser.encodePayload(packets, this.supportsBinary, function (data) {
    self.doWrite(data, callbackfn);
  });
};

/**
 * Generates uri for connection.
 *
 * @api private
 */

Polling.prototype.uri = function () {
  var query = this.query || {};
  var schema = this.secure ? 'https' : 'http';
  var port = '';

  // cache busting is forced
  if (false !== this.timestampRequests) {
    query[this.timestampParam] = yeast();
  }

  if (!this.supportsBinary && !query.sid) {
    query.b64 = 1;
  }

  query = parseqs.encode(query);

  // avoid port if default for schema
  if (this.port && (('https' === schema && Number(this.port) !== 443) ||
     ('http' === schema && Number(this.port) !== 80))) {
    port = ':' + this.port;
  }

  // prepend ? to query
  if (query.length) {
    query = '?' + query;
  }

  var ipv6 = this.hostname.indexOf(':') !== -1;
  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
};

},{"../transport":530,"component-inherit":85,"debug":538,"engine.io-parser":541,"parseqs":729,"xmlhttprequest-ssl":536,"yeast":804}],535:[function(require,module,exports){
(function (Buffer){
/**
 * Module dependencies.
 */

var Transport = require('../transport');
var parser = require('engine.io-parser');
var parseqs = require('parseqs');
var inherit = require('component-inherit');
var yeast = require('yeast');
var debug = require('debug')('engine.io-client:websocket');

var BrowserWebSocket, NodeWebSocket;

if (typeof WebSocket !== 'undefined') {
  BrowserWebSocket = WebSocket;
} else if (typeof self !== 'undefined') {
  BrowserWebSocket = self.WebSocket || self.MozWebSocket;
}

if (typeof window === 'undefined') {
  try {
    NodeWebSocket = require('ws');
  } catch (e) { }
}

/**
 * Get either the `WebSocket` or `MozWebSocket` globals
 * in the browser or try to resolve WebSocket-compatible
 * interface exposed by `ws` for Node-like environment.
 */

var WebSocketImpl = BrowserWebSocket || NodeWebSocket;

/**
 * Module exports.
 */

module.exports = WS;

/**
 * WebSocket transport constructor.
 *
 * @api {Object} connection options
 * @api public
 */

function WS (opts) {
  var forceBase64 = (opts && opts.forceBase64);
  if (forceBase64) {
    this.supportsBinary = false;
  }
  this.perMessageDeflate = opts.perMessageDeflate;
  this.usingBrowserWebSocket = BrowserWebSocket && !opts.forceNode;
  this.protocols = opts.protocols;
  if (!this.usingBrowserWebSocket) {
    WebSocketImpl = NodeWebSocket;
  }
  Transport.call(this, opts);
}

/**
 * Inherits from Transport.
 */

inherit(WS, Transport);

/**
 * Transport name.
 *
 * @api public
 */

WS.prototype.name = 'websocket';

/*
 * WebSockets support binary
 */

WS.prototype.supportsBinary = true;

/**
 * Opens socket.
 *
 * @api private
 */

WS.prototype.doOpen = function () {
  if (!this.check()) {
    // let probe timeout
    return;
  }

  var uri = this.uri();
  var protocols = this.protocols;

  var opts = {};

  if (!this.isReactNative) {
    opts.agent = this.agent;
    opts.perMessageDeflate = this.perMessageDeflate;

    // SSL options for Node.js client
    opts.pfx = this.pfx;
    opts.key = this.key;
    opts.passphrase = this.passphrase;
    opts.cert = this.cert;
    opts.ca = this.ca;
    opts.ciphers = this.ciphers;
    opts.rejectUnauthorized = this.rejectUnauthorized;
  }

  if (this.extraHeaders) {
    opts.headers = this.extraHeaders;
  }
  if (this.localAddress) {
    opts.localAddress = this.localAddress;
  }

  try {
    this.ws =
      this.usingBrowserWebSocket && !this.isReactNative
        ? protocols
          ? new WebSocketImpl(uri, protocols)
          : new WebSocketImpl(uri)
        : new WebSocketImpl(uri, protocols, opts);
  } catch (err) {
    return this.emit('error', err);
  }

  if (this.ws.binaryType === undefined) {
    this.supportsBinary = false;
  }

  if (this.ws.supports && this.ws.supports.binary) {
    this.supportsBinary = true;
    this.ws.binaryType = 'nodebuffer';
  } else {
    this.ws.binaryType = 'arraybuffer';
  }

  this.addEventListeners();
};

/**
 * Adds event listeners to the socket
 *
 * @api private
 */

WS.prototype.addEventListeners = function () {
  var self = this;

  this.ws.onopen = function () {
    self.onOpen();
  };
  this.ws.onclose = function () {
    self.onClose();
  };
  this.ws.onmessage = function (ev) {
    self.onData(ev.data);
  };
  this.ws.onerror = function (e) {
    self.onError('websocket error', e);
  };
};

/**
 * Writes data to socket.
 *
 * @param {Array} array of packets.
 * @api private
 */

WS.prototype.write = function (packets) {
  var self = this;
  this.writable = false;

  // encodePacket efficient as it uses WS framing
  // no need for encodePayload
  var total = packets.length;
  for (var i = 0, l = total; i < l; i++) {
    (function (packet) {
      parser.encodePacket(packet, self.supportsBinary, function (data) {
        if (!self.usingBrowserWebSocket) {
          // always create a new object (GH-437)
          var opts = {};
          if (packet.options) {
            opts.compress = packet.options.compress;
          }

          if (self.perMessageDeflate) {
            var len = 'string' === typeof data ? Buffer.byteLength(data) : data.length;
            if (len < self.perMessageDeflate.threshold) {
              opts.compress = false;
            }
          }
        }

        // Sometimes the websocket has already been closed but the browser didn't
        // have a chance of informing us about it yet, in that case send will
        // throw an error
        try {
          if (self.usingBrowserWebSocket) {
            // TypeError is thrown when passing the second argument on Safari
            self.ws.send(data);
          } else {
            self.ws.send(data, opts);
          }
        } catch (e) {
          debug('websocket closed before onclose event');
        }

        --total || done();
      });
    })(packets[i]);
  }

  function done () {
    self.emit('flush');

    // fake drain
    // defer to next tick to allow Socket to clear writeBuffer
    setTimeout(function () {
      self.writable = true;
      self.emit('drain');
    }, 0);
  }
};

/**
 * Called upon close
 *
 * @api private
 */

WS.prototype.onClose = function () {
  Transport.prototype.onClose.call(this);
};

/**
 * Closes socket.
 *
 * @api private
 */

WS.prototype.doClose = function () {
  if (typeof this.ws !== 'undefined') {
    this.ws.close();
  }
};

/**
 * Generates uri for connection.
 *
 * @api private
 */

WS.prototype.uri = function () {
  var query = this.query || {};
  var schema = this.secure ? 'wss' : 'ws';
  var port = '';

  // avoid port if default for schema
  if (this.port && (('wss' === schema && Number(this.port) !== 443) ||
    ('ws' === schema && Number(this.port) !== 80))) {
    port = ':' + this.port;
  }

  // append timestamp to URI
  if (this.timestampRequests) {
    query[this.timestampParam] = yeast();
  }

  // communicate binary support capabilities
  if (!this.supportsBinary) {
    query.b64 = 1;
  }

  query = parseqs.encode(query);

  // prepend ? to query
  if (query.length) {
    query = '?' + query;
  }

  var ipv6 = this.hostname.indexOf(':') !== -1;
  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
};

/**
 * Feature detection for WebSocket.
 *
 * @return {Boolean} whether this transport is available.
 * @api public
 */

WS.prototype.check = function () {
  return !!WebSocketImpl && !('__initialize' in WebSocketImpl && this.name === WS.prototype.name);
};

}).call(this,require("buffer").Buffer)
},{"../transport":530,"buffer":81,"component-inherit":85,"debug":538,"engine.io-parser":541,"parseqs":729,"ws":80,"yeast":804}],536:[function(require,module,exports){
// browser shim for xmlhttprequest module

var hasCORS = require('has-cors');
var globalThis = require('./globalThis');

module.exports = function (opts) {
  var xdomain = opts.xdomain;

  // scheme must be same when usign XDomainRequest
  // http://blogs.msdn.com/b/ieinternals/archive/2010/05/13/xdomainrequest-restrictions-limitations-and-workarounds.aspx
  var xscheme = opts.xscheme;

  // XDomainRequest has a flow of not sending cookie, therefore it should be disabled as a default.
  // https://github.com/Automattic/engine.io-client/pull/217
  var enablesXDR = opts.enablesXDR;

  // XMLHttpRequest can be disabled on IE
  try {
    if ('undefined' !== typeof XMLHttpRequest && (!xdomain || hasCORS)) {
      return new XMLHttpRequest();
    }
  } catch (e) { }

  // Use XDomainRequest for IE8 if enablesXDR is true
  // because loading bar keeps flashing when using jsonp-polling
  // https://github.com/yujiosaka/socke.io-ie8-loading-example
  try {
    if ('undefined' !== typeof XDomainRequest && !xscheme && enablesXDR) {
      return new XDomainRequest();
    }
  } catch (e) { }

  if (!xdomain) {
    try {
      return new globalThis[['Active'].concat('Object').join('X')]('Microsoft.XMLHTTP');
    } catch (e) { }
  }
};

},{"./globalThis":527,"has-cors":546}],537:[function(require,module,exports){

/**
 * Expose `Emitter`.
 */

if (typeof module !== 'undefined') {
  module.exports = Emitter;
}

/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
};

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on =
Emitter.prototype.addEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};
  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
    .push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function(event, fn){
  function on() {
    this.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off =
Emitter.prototype.removeListener =
Emitter.prototype.removeAllListeners =
Emitter.prototype.removeEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks['$' + event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks['$' + event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }

  // Remove event specific arrays for event types that no
  // one is subscribed for to avoid memory leak.
  if (callbacks.length === 0) {
    delete this._callbacks['$' + event];
  }

  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function(event){
  this._callbacks = this._callbacks || {};

  var args = new Array(arguments.length - 1)
    , callbacks = this._callbacks['$' + event];

  for (var i = 1; i < arguments.length; i++) {
    args[i - 1] = arguments[i];
  }

  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function(event){
  this._callbacks = this._callbacks || {};
  return this._callbacks['$' + event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function(event){
  return !! this.listeners(event).length;
};

},{}],538:[function(require,module,exports){
(function (process){
/* eslint-env browser */

/**
 * This is the web browser implementation of `debug()`.
 */

exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = localstorage();

/**
 * Colors.
 */

exports.colors = [
	'#0000CC',
	'#0000FF',
	'#0033CC',
	'#0033FF',
	'#0066CC',
	'#0066FF',
	'#0099CC',
	'#0099FF',
	'#00CC00',
	'#00CC33',
	'#00CC66',
	'#00CC99',
	'#00CCCC',
	'#00CCFF',
	'#3300CC',
	'#3300FF',
	'#3333CC',
	'#3333FF',
	'#3366CC',
	'#3366FF',
	'#3399CC',
	'#3399FF',
	'#33CC00',
	'#33CC33',
	'#33CC66',
	'#33CC99',
	'#33CCCC',
	'#33CCFF',
	'#6600CC',
	'#6600FF',
	'#6633CC',
	'#6633FF',
	'#66CC00',
	'#66CC33',
	'#9900CC',
	'#9900FF',
	'#9933CC',
	'#9933FF',
	'#99CC00',
	'#99CC33',
	'#CC0000',
	'#CC0033',
	'#CC0066',
	'#CC0099',
	'#CC00CC',
	'#CC00FF',
	'#CC3300',
	'#CC3333',
	'#CC3366',
	'#CC3399',
	'#CC33CC',
	'#CC33FF',
	'#CC6600',
	'#CC6633',
	'#CC9900',
	'#CC9933',
	'#CCCC00',
	'#CCCC33',
	'#FF0000',
	'#FF0033',
	'#FF0066',
	'#FF0099',
	'#FF00CC',
	'#FF00FF',
	'#FF3300',
	'#FF3333',
	'#FF3366',
	'#FF3399',
	'#FF33CC',
	'#FF33FF',
	'#FF6600',
	'#FF6633',
	'#FF9900',
	'#FF9933',
	'#FFCC00',
	'#FFCC33'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

// eslint-disable-next-line complexity
function useColors() {
	// NB: In an Electron preload script, document will be defined but not fully
	// initialized. Since we know we're in Chrome, we'll just detect this case
	// explicitly
	if (typeof window !== 'undefined' && window.process && (window.process.type === 'renderer' || window.process.__nwjs)) {
		return true;
	}

	// Internet Explorer and Edge do not support colors.
	if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
		return false;
	}

	// Is webkit? http://stackoverflow.com/a/16459606/376773
	// document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
		// Is firebug? http://stackoverflow.com/a/398120/376773
		(typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
		// Is firefox >= v31?
		// https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
		(typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
		// Double check webkit in userAgent just in case we are in a worker
		(typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
	args[0] = (this.useColors ? '%c' : '') +
		this.namespace +
		(this.useColors ? ' %c' : ' ') +
		args[0] +
		(this.useColors ? '%c ' : ' ') +
		'+' + module.exports.humanize(this.diff);

	if (!this.useColors) {
		return;
	}

	const c = 'color: ' + this.color;
	args.splice(1, 0, c, 'color: inherit');

	// The final "%c" is somewhat tricky, because there could be other
	// arguments passed either before or after the %c, so we need to
	// figure out the correct index to insert the CSS into
	let index = 0;
	let lastC = 0;
	args[0].replace(/%[a-zA-Z%]/g, match => {
		if (match === '%%') {
			return;
		}
		index++;
		if (match === '%c') {
			// We only are interested in the *last* %c
			// (the user may have provided their own)
			lastC = index;
		}
	});

	args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */
function log(...args) {
	// This hackery is required for IE8/9, where
	// the `console.log` function doesn't have 'apply'
	return typeof console === 'object' &&
		console.log &&
		console.log(...args);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */
function save(namespaces) {
	try {
		if (namespaces) {
			exports.storage.setItem('debug', namespaces);
		} else {
			exports.storage.removeItem('debug');
		}
	} catch (error) {
		// Swallow
		// XXX (@Qix-) should we be logging these?
	}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */
function load() {
	let r;
	try {
		r = exports.storage.getItem('debug');
	} catch (error) {
		// Swallow
		// XXX (@Qix-) should we be logging these?
	}

	// If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	if (!r && typeof process !== 'undefined' && 'env' in process) {
		r = process.env.DEBUG;
	}

	return r;
}

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
	try {
		// TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
		// The Browser also has localStorage in the global context.
		return localStorage;
	} catch (error) {
		// Swallow
		// XXX (@Qix-) should we be logging these?
	}
}

module.exports = require('./common')(exports);

const {formatters} = module.exports;

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

formatters.j = function (v) {
	try {
		return JSON.stringify(v);
	} catch (error) {
		return '[UnexpectedJSONParseError]: ' + error.message;
	}
};

}).call(this,require('_process'))
},{"./common":539,"_process":734}],539:[function(require,module,exports){

/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 */

function setup(env) {
	createDebug.debug = createDebug;
	createDebug.default = createDebug;
	createDebug.coerce = coerce;
	createDebug.disable = disable;
	createDebug.enable = enable;
	createDebug.enabled = enabled;
	createDebug.humanize = require('ms');

	Object.keys(env).forEach(key => {
		createDebug[key] = env[key];
	});

	/**
	* Active `debug` instances.
	*/
	createDebug.instances = [];

	/**
	* The currently active debug mode names, and names to skip.
	*/

	createDebug.names = [];
	createDebug.skips = [];

	/**
	* Map of special "%n" handling functions, for the debug "format" argument.
	*
	* Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	*/
	createDebug.formatters = {};

	/**
	* Selects a color for a debug namespace
	* @param {String} namespace The namespace string for the for the debug instance to be colored
	* @return {Number|String} An ANSI color code for the given namespace
	* @api private
	*/
	function selectColor(namespace) {
		let hash = 0;

		for (let i = 0; i < namespace.length; i++) {
			hash = ((hash << 5) - hash) + namespace.charCodeAt(i);
			hash |= 0; // Convert to 32bit integer
		}

		return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
	}
	createDebug.selectColor = selectColor;

	/**
	* Create a debugger with the given `namespace`.
	*
	* @param {String} namespace
	* @return {Function}
	* @api public
	*/
	function createDebug(namespace) {
		let prevTime;

		function debug(...args) {
			// Disabled?
			if (!debug.enabled) {
				return;
			}

			const self = debug;

			// Set `diff` timestamp
			const curr = Number(new Date());
			const ms = curr - (prevTime || curr);
			self.diff = ms;
			self.prev = prevTime;
			self.curr = curr;
			prevTime = curr;

			args[0] = createDebug.coerce(args[0]);

			if (typeof args[0] !== 'string') {
				// Anything else let's inspect with %O
				args.unshift('%O');
			}

			// Apply any `formatters` transformations
			let index = 0;
			args[0] = args[0].replace(/%([a-zA-Z%])/g, (match, format) => {
				// If we encounter an escaped % then don't increase the array index
				if (match === '%%') {
					return match;
				}
				index++;
				const formatter = createDebug.formatters[format];
				if (typeof formatter === 'function') {
					const val = args[index];
					match = formatter.call(self, val);

					// Now we need to remove `args[index]` since it's inlined in the `format`
					args.splice(index, 1);
					index--;
				}
				return match;
			});

			// Apply env-specific formatting (colors, etc.)
			createDebug.formatArgs.call(self, args);

			const logFn = self.log || createDebug.log;
			logFn.apply(self, args);
		}

		debug.namespace = namespace;
		debug.enabled = createDebug.enabled(namespace);
		debug.useColors = createDebug.useColors();
		debug.color = selectColor(namespace);
		debug.destroy = destroy;
		debug.extend = extend;
		// Debug.formatArgs = formatArgs;
		// debug.rawLog = rawLog;

		// env-specific initialization logic for debug instances
		if (typeof createDebug.init === 'function') {
			createDebug.init(debug);
		}

		createDebug.instances.push(debug);

		return debug;
	}

	function destroy() {
		const index = createDebug.instances.indexOf(this);
		if (index !== -1) {
			createDebug.instances.splice(index, 1);
			return true;
		}
		return false;
	}

	function extend(namespace, delimiter) {
		const newDebug = createDebug(this.namespace + (typeof delimiter === 'undefined' ? ':' : delimiter) + namespace);
		newDebug.log = this.log;
		return newDebug;
	}

	/**
	* Enables a debug mode by namespaces. This can include modes
	* separated by a colon and wildcards.
	*
	* @param {String} namespaces
	* @api public
	*/
	function enable(namespaces) {
		createDebug.save(namespaces);

		createDebug.names = [];
		createDebug.skips = [];

		let i;
		const split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
		const len = split.length;

		for (i = 0; i < len; i++) {
			if (!split[i]) {
				// ignore empty strings
				continue;
			}

			namespaces = split[i].replace(/\*/g, '.*?');

			if (namespaces[0] === '-') {
				createDebug.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
			} else {
				createDebug.names.push(new RegExp('^' + namespaces + '$'));
			}
		}

		for (i = 0; i < createDebug.instances.length; i++) {
			const instance = createDebug.instances[i];
			instance.enabled = createDebug.enabled(instance.namespace);
		}
	}

	/**
	* Disable debug output.
	*
	* @return {String} namespaces
	* @api public
	*/
	function disable() {
		const namespaces = [
			...createDebug.names.map(toNamespace),
			...createDebug.skips.map(toNamespace).map(namespace => '-' + namespace)
		].join(',');
		createDebug.enable('');
		return namespaces;
	}

	/**
	* Returns true if the given mode name is enabled, false otherwise.
	*
	* @param {String} name
	* @return {Boolean}
	* @api public
	*/
	function enabled(name) {
		if (name[name.length - 1] === '*') {
			return true;
		}

		let i;
		let len;

		for (i = 0, len = createDebug.skips.length; i < len; i++) {
			if (createDebug.skips[i].test(name)) {
				return false;
			}
		}

		for (i = 0, len = createDebug.names.length; i < len; i++) {
			if (createDebug.names[i].test(name)) {
				return true;
			}
		}

		return false;
	}

	/**
	* Convert regexp to namespace
	*
	* @param {RegExp} regxep
	* @return {String} namespace
	* @api private
	*/
	function toNamespace(regexp) {
		return regexp.toString()
			.substring(2, regexp.toString().length - 2)
			.replace(/\.\*\?$/, '*');
	}

	/**
	* Coerce `val`.
	*
	* @param {Mixed} val
	* @return {Mixed}
	* @api private
	*/
	function coerce(val) {
		if (val instanceof Error) {
			return val.stack || val.message;
		}
		return val;
	}

	createDebug.enable(createDebug.load());

	return createDebug;
}

module.exports = setup;

},{"ms":540}],540:[function(require,module,exports){
/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var w = d * 7;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isFinite(val)) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'weeks':
    case 'week':
    case 'w':
      return n * w;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  var msAbs = Math.abs(ms);
  if (msAbs >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (msAbs >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (msAbs >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (msAbs >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  var msAbs = Math.abs(ms);
  if (msAbs >= d) {
    return plural(ms, msAbs, d, 'day');
  }
  if (msAbs >= h) {
    return plural(ms, msAbs, h, 'hour');
  }
  if (msAbs >= m) {
    return plural(ms, msAbs, m, 'minute');
  }
  if (msAbs >= s) {
    return plural(ms, msAbs, s, 'second');
  }
  return ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, msAbs, n, name) {
  var isPlural = msAbs >= n * 1.5;
  return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
}

},{}],541:[function(require,module,exports){
/**
 * Module dependencies.
 */

var keys = require('./keys');
var hasBinary = require('has-binary2');
var sliceBuffer = require('arraybuffer.slice');
var after = require('after');
var utf8 = require('./utf8');

var base64encoder;
if (typeof ArrayBuffer !== 'undefined') {
  base64encoder = require('base64-arraybuffer');
}

/**
 * Check if we are running an android browser. That requires us to use
 * ArrayBuffer with polling transports...
 *
 * http://ghinda.net/jpeg-blob-ajax-android/
 */

var isAndroid = typeof navigator !== 'undefined' && /Android/i.test(navigator.userAgent);

/**
 * Check if we are running in PhantomJS.
 * Uploading a Blob with PhantomJS does not work correctly, as reported here:
 * https://github.com/ariya/phantomjs/issues/11395
 * @type boolean
 */
var isPhantomJS = typeof navigator !== 'undefined' && /PhantomJS/i.test(navigator.userAgent);

/**
 * When true, avoids using Blobs to encode payloads.
 * @type boolean
 */
var dontSendBlobs = isAndroid || isPhantomJS;

/**
 * Current protocol version.
 */

exports.protocol = 3;

/**
 * Packet types.
 */

var packets = exports.packets = {
    open:     0    // non-ws
  , close:    1    // non-ws
  , ping:     2
  , pong:     3
  , message:  4
  , upgrade:  5
  , noop:     6
};

var packetslist = keys(packets);

/**
 * Premade error packet.
 */

var err = { type: 'error', data: 'parser error' };

/**
 * Create a blob api even for blob builder when vendor prefixes exist
 */

var Blob = require('blob');

/**
 * Encodes a packet.
 *
 *     <packet type id> [ <data> ]
 *
 * Example:
 *
 *     5hello world
 *     3
 *     4
 *
 * Binary is encoded in an identical principle
 *
 * @api private
 */

exports.encodePacket = function (packet, supportsBinary, utf8encode, callback) {
  if (typeof supportsBinary === 'function') {
    callback = supportsBinary;
    supportsBinary = false;
  }

  if (typeof utf8encode === 'function') {
    callback = utf8encode;
    utf8encode = null;
  }

  var data = (packet.data === undefined)
    ? undefined
    : packet.data.buffer || packet.data;

  if (typeof ArrayBuffer !== 'undefined' && data instanceof ArrayBuffer) {
    return encodeArrayBuffer(packet, supportsBinary, callback);
  } else if (typeof Blob !== 'undefined' && data instanceof Blob) {
    return encodeBlob(packet, supportsBinary, callback);
  }

  // might be an object with { base64: true, data: dataAsBase64String }
  if (data && data.base64) {
    return encodeBase64Object(packet, callback);
  }

  // Sending data as a utf-8 string
  var encoded = packets[packet.type];

  // data fragment is optional
  if (undefined !== packet.data) {
    encoded += utf8encode ? utf8.encode(String(packet.data), { strict: false }) : String(packet.data);
  }

  return callback('' + encoded);

};

function encodeBase64Object(packet, callback) {
  // packet data is an object { base64: true, data: dataAsBase64String }
  var message = 'b' + exports.packets[packet.type] + packet.data.data;
  return callback(message);
}

/**
 * Encode packet helpers for binary types
 */

function encodeArrayBuffer(packet, supportsBinary, callback) {
  if (!supportsBinary) {
    return exports.encodeBase64Packet(packet, callback);
  }

  var data = packet.data;
  var contentArray = new Uint8Array(data);
  var resultBuffer = new Uint8Array(1 + data.byteLength);

  resultBuffer[0] = packets[packet.type];
  for (var i = 0; i < contentArray.length; i++) {
    resultBuffer[i+1] = contentArray[i];
  }

  return callback(resultBuffer.buffer);
}

function encodeBlobAsArrayBuffer(packet, supportsBinary, callback) {
  if (!supportsBinary) {
    return exports.encodeBase64Packet(packet, callback);
  }

  var fr = new FileReader();
  fr.onload = function() {
    exports.encodePacket({ type: packet.type, data: fr.result }, supportsBinary, true, callback);
  };
  return fr.readAsArrayBuffer(packet.data);
}

function encodeBlob(packet, supportsBinary, callback) {
  if (!supportsBinary) {
    return exports.encodeBase64Packet(packet, callback);
  }

  if (dontSendBlobs) {
    return encodeBlobAsArrayBuffer(packet, supportsBinary, callback);
  }

  var length = new Uint8Array(1);
  length[0] = packets[packet.type];
  var blob = new Blob([length.buffer, packet.data]);

  return callback(blob);
}

/**
 * Encodes a packet with binary data in a base64 string
 *
 * @param {Object} packet, has `type` and `data`
 * @return {String} base64 encoded message
 */

exports.encodeBase64Packet = function(packet, callback) {
  var message = 'b' + exports.packets[packet.type];
  if (typeof Blob !== 'undefined' && packet.data instanceof Blob) {
    var fr = new FileReader();
    fr.onload = function() {
      var b64 = fr.result.split(',')[1];
      callback(message + b64);
    };
    return fr.readAsDataURL(packet.data);
  }

  var b64data;
  try {
    b64data = String.fromCharCode.apply(null, new Uint8Array(packet.data));
  } catch (e) {
    // iPhone Safari doesn't let you apply with typed arrays
    var typed = new Uint8Array(packet.data);
    var basic = new Array(typed.length);
    for (var i = 0; i < typed.length; i++) {
      basic[i] = typed[i];
    }
    b64data = String.fromCharCode.apply(null, basic);
  }
  message += btoa(b64data);
  return callback(message);
};

/**
 * Decodes a packet. Changes format to Blob if requested.
 *
 * @return {Object} with `type` and `data` (if any)
 * @api private
 */

exports.decodePacket = function (data, binaryType, utf8decode) {
  if (data === undefined) {
    return err;
  }
  // String data
  if (typeof data === 'string') {
    if (data.charAt(0) === 'b') {
      return exports.decodeBase64Packet(data.substr(1), binaryType);
    }

    if (utf8decode) {
      data = tryDecode(data);
      if (data === false) {
        return err;
      }
    }
    var type = data.charAt(0);

    if (Number(type) != type || !packetslist[type]) {
      return err;
    }

    if (data.length > 1) {
      return { type: packetslist[type], data: data.substring(1) };
    } else {
      return { type: packetslist[type] };
    }
  }

  var asArray = new Uint8Array(data);
  var type = asArray[0];
  var rest = sliceBuffer(data, 1);
  if (Blob && binaryType === 'blob') {
    rest = new Blob([rest]);
  }
  return { type: packetslist[type], data: rest };
};

function tryDecode(data) {
  try {
    data = utf8.decode(data, { strict: false });
  } catch (e) {
    return false;
  }
  return data;
}

/**
 * Decodes a packet encoded in a base64 string
 *
 * @param {String} base64 encoded message
 * @return {Object} with `type` and `data` (if any)
 */

exports.decodeBase64Packet = function(msg, binaryType) {
  var type = packetslist[msg.charAt(0)];
  if (!base64encoder) {
    return { type: type, data: { base64: true, data: msg.substr(1) } };
  }

  var data = base64encoder.decode(msg.substr(1));

  if (binaryType === 'blob' && Blob) {
    data = new Blob([data]);
  }

  return { type: type, data: data };
};

/**
 * Encodes multiple messages (payload).
 *
 *     <length>:data
 *
 * Example:
 *
 *     11:hello world2:hi
 *
 * If any contents are binary, they will be encoded as base64 strings. Base64
 * encoded strings are marked with a b before the length specifier
 *
 * @param {Array} packets
 * @api private
 */

exports.encodePayload = function (packets, supportsBinary, callback) {
  if (typeof supportsBinary === 'function') {
    callback = supportsBinary;
    supportsBinary = null;
  }

  var isBinary = hasBinary(packets);

  if (supportsBinary && isBinary) {
    if (Blob && !dontSendBlobs) {
      return exports.encodePayloadAsBlob(packets, callback);
    }

    return exports.encodePayloadAsArrayBuffer(packets, callback);
  }

  if (!packets.length) {
    return callback('0:');
  }

  function setLengthHeader(message) {
    return message.length + ':' + message;
  }

  function encodeOne(packet, doneCallback) {
    exports.encodePacket(packet, !isBinary ? false : supportsBinary, false, function(message) {
      doneCallback(null, setLengthHeader(message));
    });
  }

  map(packets, encodeOne, function(err, results) {
    return callback(results.join(''));
  });
};

/**
 * Async array map using after
 */

function map(ary, each, done) {
  var result = new Array(ary.length);
  var next = after(ary.length, done);

  var eachWithIndex = function(i, el, cb) {
    each(el, function(error, msg) {
      result[i] = msg;
      cb(error, result);
    });
  };

  for (var i = 0; i < ary.length; i++) {
    eachWithIndex(i, ary[i], next);
  }
}

/*
 * Decodes data when a payload is maybe expected. Possible binary contents are
 * decoded from their base64 representation
 *
 * @param {String} data, callback method
 * @api public
 */

exports.decodePayload = function (data, binaryType, callback) {
  if (typeof data !== 'string') {
    return exports.decodePayloadAsBinary(data, binaryType, callback);
  }

  if (typeof binaryType === 'function') {
    callback = binaryType;
    binaryType = null;
  }

  var packet;
  if (data === '') {
    // parser error - ignoring payload
    return callback(err, 0, 1);
  }

  var length = '', n, msg;

  for (var i = 0, l = data.length; i < l; i++) {
    var chr = data.charAt(i);

    if (chr !== ':') {
      length += chr;
      continue;
    }

    if (length === '' || (length != (n = Number(length)))) {
      // parser error - ignoring payload
      return callback(err, 0, 1);
    }

    msg = data.substr(i + 1, n);

    if (length != msg.length) {
      // parser error - ignoring payload
      return callback(err, 0, 1);
    }

    if (msg.length) {
      packet = exports.decodePacket(msg, binaryType, false);

      if (err.type === packet.type && err.data === packet.data) {
        // parser error in individual packet - ignoring payload
        return callback(err, 0, 1);
      }

      var ret = callback(packet, i + n, l);
      if (false === ret) return;
    }

    // advance cursor
    i += n;
    length = '';
  }

  if (length !== '') {
    // parser error - ignoring payload
    return callback(err, 0, 1);
  }

};

/**
 * Encodes multiple messages (payload) as binary.
 *
 * <1 = binary, 0 = string><number from 0-9><number from 0-9>[...]<number
 * 255><data>
 *
 * Example:
 * 1 3 255 1 2 3, if the binary contents are interpreted as 8 bit integers
 *
 * @param {Array} packets
 * @return {ArrayBuffer} encoded payload
 * @api private
 */

exports.encodePayloadAsArrayBuffer = function(packets, callback) {
  if (!packets.length) {
    return callback(new ArrayBuffer(0));
  }

  function encodeOne(packet, doneCallback) {
    exports.encodePacket(packet, true, true, function(data) {
      return doneCallback(null, data);
    });
  }

  map(packets, encodeOne, function(err, encodedPackets) {
    var totalLength = encodedPackets.reduce(function(acc, p) {
      var len;
      if (typeof p === 'string'){
        len = p.length;
      } else {
        len = p.byteLength;
      }
      return acc + len.toString().length + len + 2; // string/binary identifier + separator = 2
    }, 0);

    var resultArray = new Uint8Array(totalLength);

    var bufferIndex = 0;
    encodedPackets.forEach(function(p) {
      var isString = typeof p === 'string';
      var ab = p;
      if (isString) {
        var view = new Uint8Array(p.length);
        for (var i = 0; i < p.length; i++) {
          view[i] = p.charCodeAt(i);
        }
        ab = view.buffer;
      }

      if (isString) { // not true binary
        resultArray[bufferIndex++] = 0;
      } else { // true binary
        resultArray[bufferIndex++] = 1;
      }

      var lenStr = ab.byteLength.toString();
      for (var i = 0; i < lenStr.length; i++) {
        resultArray[bufferIndex++] = parseInt(lenStr[i]);
      }
      resultArray[bufferIndex++] = 255;

      var view = new Uint8Array(ab);
      for (var i = 0; i < view.length; i++) {
        resultArray[bufferIndex++] = view[i];
      }
    });

    return callback(resultArray.buffer);
  });
};

/**
 * Encode as Blob
 */

exports.encodePayloadAsBlob = function(packets, callback) {
  function encodeOne(packet, doneCallback) {
    exports.encodePacket(packet, true, true, function(encoded) {
      var binaryIdentifier = new Uint8Array(1);
      binaryIdentifier[0] = 1;
      if (typeof encoded === 'string') {
        var view = new Uint8Array(encoded.length);
        for (var i = 0; i < encoded.length; i++) {
          view[i] = encoded.charCodeAt(i);
        }
        encoded = view.buffer;
        binaryIdentifier[0] = 0;
      }

      var len = (encoded instanceof ArrayBuffer)
        ? encoded.byteLength
        : encoded.size;

      var lenStr = len.toString();
      var lengthAry = new Uint8Array(lenStr.length + 1);
      for (var i = 0; i < lenStr.length; i++) {
        lengthAry[i] = parseInt(lenStr[i]);
      }
      lengthAry[lenStr.length] = 255;

      if (Blob) {
        var blob = new Blob([binaryIdentifier.buffer, lengthAry.buffer, encoded]);
        doneCallback(null, blob);
      }
    });
  }

  map(packets, encodeOne, function(err, results) {
    return callback(new Blob(results));
  });
};

/*
 * Decodes data when a payload is maybe expected. Strings are decoded by
 * interpreting each byte as a key code for entries marked to start with 0. See
 * description of encodePayloadAsBinary
 *
 * @param {ArrayBuffer} data, callback method
 * @api public
 */

exports.decodePayloadAsBinary = function (data, binaryType, callback) {
  if (typeof binaryType === 'function') {
    callback = binaryType;
    binaryType = null;
  }

  var bufferTail = data;
  var buffers = [];

  while (bufferTail.byteLength > 0) {
    var tailArray = new Uint8Array(bufferTail);
    var isString = tailArray[0] === 0;
    var msgLength = '';

    for (var i = 1; ; i++) {
      if (tailArray[i] === 255) break;

      // 310 = char length of Number.MAX_VALUE
      if (msgLength.length > 310) {
        return callback(err, 0, 1);
      }

      msgLength += tailArray[i];
    }

    bufferTail = sliceBuffer(bufferTail, 2 + msgLength.length);
    msgLength = parseInt(msgLength);

    var msg = sliceBuffer(bufferTail, 0, msgLength);
    if (isString) {
      try {
        msg = String.fromCharCode.apply(null, new Uint8Array(msg));
      } catch (e) {
        // iPhone Safari doesn't let you apply to typed arrays
        var typed = new Uint8Array(msg);
        msg = '';
        for (var i = 0; i < typed.length; i++) {
          msg += String.fromCharCode(typed[i]);
        }
      }
    }

    buffers.push(msg);
    bufferTail = sliceBuffer(bufferTail, msgLength);
  }

  var total = buffers.length;
  buffers.forEach(function(buffer, i) {
    callback(exports.decodePacket(buffer, binaryType, true), i, total);
  });
};

},{"./keys":542,"./utf8":543,"after":17,"arraybuffer.slice":18,"base64-arraybuffer":77,"blob":79,"has-binary2":544}],542:[function(require,module,exports){

/**
 * Gets the keys for an object.
 *
 * @return {Array} keys
 * @api private
 */

module.exports = Object.keys || function keys (obj){
  var arr = [];
  var has = Object.prototype.hasOwnProperty;

  for (var i in obj) {
    if (has.call(obj, i)) {
      arr.push(i);
    }
  }
  return arr;
};

},{}],543:[function(require,module,exports){
/*! https://mths.be/utf8js v2.1.2 by @mathias */

var stringFromCharCode = String.fromCharCode;

// Taken from https://mths.be/punycode
function ucs2decode(string) {
	var output = [];
	var counter = 0;
	var length = string.length;
	var value;
	var extra;
	while (counter < length) {
		value = string.charCodeAt(counter++);
		if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
			// high surrogate, and there is a next character
			extra = string.charCodeAt(counter++);
			if ((extra & 0xFC00) == 0xDC00) { // low surrogate
				output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
			} else {
				// unmatched surrogate; only append this code unit, in case the next
				// code unit is the high surrogate of a surrogate pair
				output.push(value);
				counter--;
			}
		} else {
			output.push(value);
		}
	}
	return output;
}

// Taken from https://mths.be/punycode
function ucs2encode(array) {
	var length = array.length;
	var index = -1;
	var value;
	var output = '';
	while (++index < length) {
		value = array[index];
		if (value > 0xFFFF) {
			value -= 0x10000;
			output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
			value = 0xDC00 | value & 0x3FF;
		}
		output += stringFromCharCode(value);
	}
	return output;
}

function checkScalarValue(codePoint, strict) {
	if (codePoint >= 0xD800 && codePoint <= 0xDFFF) {
		if (strict) {
			throw Error(
				'Lone surrogate U+' + codePoint.toString(16).toUpperCase() +
				' is not a scalar value'
			);
		}
		return false;
	}
	return true;
}
/*--------------------------------------------------------------------------*/

function createByte(codePoint, shift) {
	return stringFromCharCode(((codePoint >> shift) & 0x3F) | 0x80);
}

function encodeCodePoint(codePoint, strict) {
	if ((codePoint & 0xFFFFFF80) == 0) { // 1-byte sequence
		return stringFromCharCode(codePoint);
	}
	var symbol = '';
	if ((codePoint & 0xFFFFF800) == 0) { // 2-byte sequence
		symbol = stringFromCharCode(((codePoint >> 6) & 0x1F) | 0xC0);
	}
	else if ((codePoint & 0xFFFF0000) == 0) { // 3-byte sequence
		if (!checkScalarValue(codePoint, strict)) {
			codePoint = 0xFFFD;
		}
		symbol = stringFromCharCode(((codePoint >> 12) & 0x0F) | 0xE0);
		symbol += createByte(codePoint, 6);
	}
	else if ((codePoint & 0xFFE00000) == 0) { // 4-byte sequence
		symbol = stringFromCharCode(((codePoint >> 18) & 0x07) | 0xF0);
		symbol += createByte(codePoint, 12);
		symbol += createByte(codePoint, 6);
	}
	symbol += stringFromCharCode((codePoint & 0x3F) | 0x80);
	return symbol;
}

function utf8encode(string, opts) {
	opts = opts || {};
	var strict = false !== opts.strict;

	var codePoints = ucs2decode(string);
	var length = codePoints.length;
	var index = -1;
	var codePoint;
	var byteString = '';
	while (++index < length) {
		codePoint = codePoints[index];
		byteString += encodeCodePoint(codePoint, strict);
	}
	return byteString;
}

/*--------------------------------------------------------------------------*/

function readContinuationByte() {
	if (byteIndex >= byteCount) {
		throw Error('Invalid byte index');
	}

	var continuationByte = byteArray[byteIndex] & 0xFF;
	byteIndex++;

	if ((continuationByte & 0xC0) == 0x80) {
		return continuationByte & 0x3F;
	}

	// If we end up here, it’s not a continuation byte
	throw Error('Invalid continuation byte');
}

function decodeSymbol(strict) {
	var byte1;
	var byte2;
	var byte3;
	var byte4;
	var codePoint;

	if (byteIndex > byteCount) {
		throw Error('Invalid byte index');
	}

	if (byteIndex == byteCount) {
		return false;
	}

	// Read first byte
	byte1 = byteArray[byteIndex] & 0xFF;
	byteIndex++;

	// 1-byte sequence (no continuation bytes)
	if ((byte1 & 0x80) == 0) {
		return byte1;
	}

	// 2-byte sequence
	if ((byte1 & 0xE0) == 0xC0) {
		byte2 = readContinuationByte();
		codePoint = ((byte1 & 0x1F) << 6) | byte2;
		if (codePoint >= 0x80) {
			return codePoint;
		} else {
			throw Error('Invalid continuation byte');
		}
	}

	// 3-byte sequence (may include unpaired surrogates)
	if ((byte1 & 0xF0) == 0xE0) {
		byte2 = readContinuationByte();
		byte3 = readContinuationByte();
		codePoint = ((byte1 & 0x0F) << 12) | (byte2 << 6) | byte3;
		if (codePoint >= 0x0800) {
			return checkScalarValue(codePoint, strict) ? codePoint : 0xFFFD;
		} else {
			throw Error('Invalid continuation byte');
		}
	}

	// 4-byte sequence
	if ((byte1 & 0xF8) == 0xF0) {
		byte2 = readContinuationByte();
		byte3 = readContinuationByte();
		byte4 = readContinuationByte();
		codePoint = ((byte1 & 0x07) << 0x12) | (byte2 << 0x0C) |
			(byte3 << 0x06) | byte4;
		if (codePoint >= 0x010000 && codePoint <= 0x10FFFF) {
			return codePoint;
		}
	}

	throw Error('Invalid UTF-8 detected');
}

var byteArray;
var byteCount;
var byteIndex;
function utf8decode(byteString, opts) {
	opts = opts || {};
	var strict = false !== opts.strict;

	byteArray = ucs2decode(byteString);
	byteCount = byteArray.length;
	byteIndex = 0;
	var codePoints = [];
	var tmp;
	while ((tmp = decodeSymbol(strict)) !== false) {
		codePoints.push(tmp);
	}
	return ucs2encode(codePoints);
}

module.exports = {
	version: '2.1.2',
	encode: utf8encode,
	decode: utf8decode
};

},{}],544:[function(require,module,exports){
(function (Buffer){
/* global Blob File */

/*
 * Module requirements.
 */

var isArray = require('isarray');

var toString = Object.prototype.toString;
var withNativeBlob = typeof Blob === 'function' ||
                        typeof Blob !== 'undefined' && toString.call(Blob) === '[object BlobConstructor]';
var withNativeFile = typeof File === 'function' ||
                        typeof File !== 'undefined' && toString.call(File) === '[object FileConstructor]';

/**
 * Module exports.
 */

module.exports = hasBinary;

/**
 * Checks for binary data.
 *
 * Supports Buffer, ArrayBuffer, Blob and File.
 *
 * @param {Object} anything
 * @api public
 */

function hasBinary (obj) {
  if (!obj || typeof obj !== 'object') {
    return false;
  }

  if (isArray(obj)) {
    for (var i = 0, l = obj.length; i < l; i++) {
      if (hasBinary(obj[i])) {
        return true;
      }
    }
    return false;
  }

  if ((typeof Buffer === 'function' && Buffer.isBuffer && Buffer.isBuffer(obj)) ||
    (typeof ArrayBuffer === 'function' && obj instanceof ArrayBuffer) ||
    (withNativeBlob && obj instanceof Blob) ||
    (withNativeFile && obj instanceof File)
  ) {
    return true;
  }

  // see: https://github.com/Automattic/has-binary/pull/4
  if (obj.toJSON && typeof obj.toJSON === 'function' && arguments.length === 1) {
    return hasBinary(obj.toJSON(), true);
  }

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key) && hasBinary(obj[key])) {
      return true;
    }
  }

  return false;
}

}).call(this,require("buffer").Buffer)
},{"buffer":81,"isarray":545}],545:[function(require,module,exports){
var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};

},{}],546:[function(require,module,exports){

/**
 * Module exports.
 *
 * Logic borrowed from Modernizr:
 *
 *   - https://github.com/Modernizr/Modernizr/blob/master/feature-detects/cors.js
 */

try {
  module.exports = typeof XMLHttpRequest !== 'undefined' &&
    'withCredentials' in new XMLHttpRequest();
} catch (err) {
  // if XMLHttp support is disabled in IE then it will throw
  // when trying to create
  module.exports = false;
}

},{}],547:[function(require,module,exports){
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}

},{}],548:[function(require,module,exports){

var indexOf = [].indexOf;

module.exports = function(arr, obj){
  if (indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};
},{}],549:[function(require,module,exports){
arguments[4][545][0].apply(exports,arguments)
},{"dup":545}],550:[function(require,module,exports){
var getNative = require('./_getNative'),
    root = require('./_root');

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;

},{"./_getNative":634,"./_root":678}],551:[function(require,module,exports){
var hashClear = require('./_hashClear'),
    hashDelete = require('./_hashDelete'),
    hashGet = require('./_hashGet'),
    hashHas = require('./_hashHas'),
    hashSet = require('./_hashSet');

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;

},{"./_hashClear":642,"./_hashDelete":643,"./_hashGet":644,"./_hashHas":645,"./_hashSet":646}],552:[function(require,module,exports){
var listCacheClear = require('./_listCacheClear'),
    listCacheDelete = require('./_listCacheDelete'),
    listCacheGet = require('./_listCacheGet'),
    listCacheHas = require('./_listCacheHas'),
    listCacheSet = require('./_listCacheSet');

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;

},{"./_listCacheClear":657,"./_listCacheDelete":658,"./_listCacheGet":659,"./_listCacheHas":660,"./_listCacheSet":661}],553:[function(require,module,exports){
var getNative = require('./_getNative'),
    root = require('./_root');

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;

},{"./_getNative":634,"./_root":678}],554:[function(require,module,exports){
var mapCacheClear = require('./_mapCacheClear'),
    mapCacheDelete = require('./_mapCacheDelete'),
    mapCacheGet = require('./_mapCacheGet'),
    mapCacheHas = require('./_mapCacheHas'),
    mapCacheSet = require('./_mapCacheSet');

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;

},{"./_mapCacheClear":662,"./_mapCacheDelete":663,"./_mapCacheGet":664,"./_mapCacheHas":665,"./_mapCacheSet":666}],555:[function(require,module,exports){
var getNative = require('./_getNative'),
    root = require('./_root');

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;

},{"./_getNative":634,"./_root":678}],556:[function(require,module,exports){
var getNative = require('./_getNative'),
    root = require('./_root');

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;

},{"./_getNative":634,"./_root":678}],557:[function(require,module,exports){
var MapCache = require('./_MapCache'),
    setCacheAdd = require('./_setCacheAdd'),
    setCacheHas = require('./_setCacheHas');

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;

},{"./_MapCache":554,"./_setCacheAdd":679,"./_setCacheHas":680}],558:[function(require,module,exports){
var ListCache = require('./_ListCache'),
    stackClear = require('./_stackClear'),
    stackDelete = require('./_stackDelete'),
    stackGet = require('./_stackGet'),
    stackHas = require('./_stackHas'),
    stackSet = require('./_stackSet');

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;

},{"./_ListCache":552,"./_stackClear":684,"./_stackDelete":685,"./_stackGet":686,"./_stackHas":687,"./_stackSet":688}],559:[function(require,module,exports){
var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;

},{"./_root":678}],560:[function(require,module,exports){
var root = require('./_root');

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;

},{"./_root":678}],561:[function(require,module,exports){
var getNative = require('./_getNative'),
    root = require('./_root');

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;

},{"./_getNative":634,"./_root":678}],562:[function(require,module,exports){
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;

},{}],563:[function(require,module,exports){
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;

},{}],564:[function(require,module,exports){
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;

},{}],565:[function(require,module,exports){
var baseTimes = require('./_baseTimes'),
    isArguments = require('./isArguments'),
    isArray = require('./isArray'),
    isBuffer = require('./isBuffer'),
    isIndex = require('./_isIndex'),
    isTypedArray = require('./isTypedArray');

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;

},{"./_baseTimes":603,"./_isIndex":651,"./isArguments":701,"./isArray":702,"./isBuffer":704,"./isTypedArray":713}],566:[function(require,module,exports){
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;

},{}],567:[function(require,module,exports){
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;

},{}],568:[function(require,module,exports){
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;

},{}],569:[function(require,module,exports){
var baseAssignValue = require('./_baseAssignValue'),
    eq = require('./eq');

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;

},{"./_baseAssignValue":573,"./eq":694}],570:[function(require,module,exports){
var eq = require('./eq');

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;

},{"./eq":694}],571:[function(require,module,exports){
var copyObject = require('./_copyObject'),
    keys = require('./keys');

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;

},{"./_copyObject":617,"./keys":714}],572:[function(require,module,exports){
var copyObject = require('./_copyObject'),
    keysIn = require('./keysIn');

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;

},{"./_copyObject":617,"./keysIn":715}],573:[function(require,module,exports){
var defineProperty = require('./_defineProperty');

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;

},{"./_defineProperty":624}],574:[function(require,module,exports){
var Stack = require('./_Stack'),
    arrayEach = require('./_arrayEach'),
    assignValue = require('./_assignValue'),
    baseAssign = require('./_baseAssign'),
    baseAssignIn = require('./_baseAssignIn'),
    cloneBuffer = require('./_cloneBuffer'),
    copyArray = require('./_copyArray'),
    copySymbols = require('./_copySymbols'),
    copySymbolsIn = require('./_copySymbolsIn'),
    getAllKeys = require('./_getAllKeys'),
    getAllKeysIn = require('./_getAllKeysIn'),
    getTag = require('./_getTag'),
    initCloneArray = require('./_initCloneArray'),
    initCloneByTag = require('./_initCloneByTag'),
    initCloneObject = require('./_initCloneObject'),
    isArray = require('./isArray'),
    isBuffer = require('./isBuffer'),
    isMap = require('./isMap'),
    isObject = require('./isObject'),
    isSet = require('./isSet'),
    keys = require('./keys');

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;

},{"./_Stack":558,"./_arrayEach":563,"./_assignValue":569,"./_baseAssign":571,"./_baseAssignIn":572,"./_cloneBuffer":611,"./_copyArray":616,"./_copySymbols":618,"./_copySymbolsIn":619,"./_getAllKeys":630,"./_getAllKeysIn":631,"./_getTag":639,"./_initCloneArray":647,"./_initCloneByTag":648,"./_initCloneObject":649,"./isArray":702,"./isBuffer":704,"./isMap":707,"./isObject":708,"./isSet":711,"./keys":714}],575:[function(require,module,exports){
var isObject = require('./isObject');

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;

},{"./isObject":708}],576:[function(require,module,exports){
var baseForOwn = require('./_baseForOwn'),
    createBaseEach = require('./_createBaseEach');

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;

},{"./_baseForOwn":579,"./_createBaseEach":621}],577:[function(require,module,exports){
var arrayPush = require('./_arrayPush'),
    isFlattenable = require('./_isFlattenable');

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;

},{"./_arrayPush":567,"./_isFlattenable":650}],578:[function(require,module,exports){
var createBaseFor = require('./_createBaseFor');

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;

},{"./_createBaseFor":622}],579:[function(require,module,exports){
var baseFor = require('./_baseFor'),
    keys = require('./keys');

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;

},{"./_baseFor":578,"./keys":714}],580:[function(require,module,exports){
var castPath = require('./_castPath'),
    toKey = require('./_toKey');

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;

},{"./_castPath":609,"./_toKey":690}],581:[function(require,module,exports){
var arrayPush = require('./_arrayPush'),
    isArray = require('./isArray');

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;

},{"./_arrayPush":567,"./isArray":702}],582:[function(require,module,exports){
var Symbol = require('./_Symbol'),
    getRawTag = require('./_getRawTag'),
    objectToString = require('./_objectToString');

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;

},{"./_Symbol":559,"./_getRawTag":636,"./_objectToString":674}],583:[function(require,module,exports){
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;

},{}],584:[function(require,module,exports){
var baseGetTag = require('./_baseGetTag'),
    isObjectLike = require('./isObjectLike');

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;

},{"./_baseGetTag":582,"./isObjectLike":709}],585:[function(require,module,exports){
var baseIsEqualDeep = require('./_baseIsEqualDeep'),
    isObjectLike = require('./isObjectLike');

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;

},{"./_baseIsEqualDeep":586,"./isObjectLike":709}],586:[function(require,module,exports){
var Stack = require('./_Stack'),
    equalArrays = require('./_equalArrays'),
    equalByTag = require('./_equalByTag'),
    equalObjects = require('./_equalObjects'),
    getTag = require('./_getTag'),
    isArray = require('./isArray'),
    isBuffer = require('./isBuffer'),
    isTypedArray = require('./isTypedArray');

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;

},{"./_Stack":558,"./_equalArrays":625,"./_equalByTag":626,"./_equalObjects":627,"./_getTag":639,"./isArray":702,"./isBuffer":704,"./isTypedArray":713}],587:[function(require,module,exports){
var getTag = require('./_getTag'),
    isObjectLike = require('./isObjectLike');

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;

},{"./_getTag":639,"./isObjectLike":709}],588:[function(require,module,exports){
var Stack = require('./_Stack'),
    baseIsEqual = require('./_baseIsEqual');

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;

},{"./_Stack":558,"./_baseIsEqual":585}],589:[function(require,module,exports){
var isFunction = require('./isFunction'),
    isMasked = require('./_isMasked'),
    isObject = require('./isObject'),
    toSource = require('./_toSource');

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;

},{"./_isMasked":654,"./_toSource":691,"./isFunction":705,"./isObject":708}],590:[function(require,module,exports){
var getTag = require('./_getTag'),
    isObjectLike = require('./isObjectLike');

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;

},{"./_getTag":639,"./isObjectLike":709}],591:[function(require,module,exports){
var baseGetTag = require('./_baseGetTag'),
    isLength = require('./isLength'),
    isObjectLike = require('./isObjectLike');

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;

},{"./_baseGetTag":582,"./isLength":706,"./isObjectLike":709}],592:[function(require,module,exports){
var baseMatches = require('./_baseMatches'),
    baseMatchesProperty = require('./_baseMatchesProperty'),
    identity = require('./identity'),
    isArray = require('./isArray'),
    property = require('./property');

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;

},{"./_baseMatches":595,"./_baseMatchesProperty":596,"./identity":700,"./isArray":702,"./property":722}],593:[function(require,module,exports){
var isPrototype = require('./_isPrototype'),
    nativeKeys = require('./_nativeKeys');

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;

},{"./_isPrototype":655,"./_nativeKeys":671}],594:[function(require,module,exports){
var isObject = require('./isObject'),
    isPrototype = require('./_isPrototype'),
    nativeKeysIn = require('./_nativeKeysIn');

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;

},{"./_isPrototype":655,"./_nativeKeysIn":672,"./isObject":708}],595:[function(require,module,exports){
var baseIsMatch = require('./_baseIsMatch'),
    getMatchData = require('./_getMatchData'),
    matchesStrictComparable = require('./_matchesStrictComparable');

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;

},{"./_baseIsMatch":588,"./_getMatchData":633,"./_matchesStrictComparable":668}],596:[function(require,module,exports){
var baseIsEqual = require('./_baseIsEqual'),
    get = require('./get'),
    hasIn = require('./hasIn'),
    isKey = require('./_isKey'),
    isStrictComparable = require('./_isStrictComparable'),
    matchesStrictComparable = require('./_matchesStrictComparable'),
    toKey = require('./_toKey');

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;

},{"./_baseIsEqual":585,"./_isKey":652,"./_isStrictComparable":656,"./_matchesStrictComparable":668,"./_toKey":690,"./get":698,"./hasIn":699}],597:[function(require,module,exports){
var baseGet = require('./_baseGet'),
    baseSet = require('./_baseSet'),
    castPath = require('./_castPath');

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet(object, path);

    if (predicate(value, path)) {
      baseSet(result, castPath(path, object), value);
    }
  }
  return result;
}

module.exports = basePickBy;

},{"./_baseGet":580,"./_baseSet":600,"./_castPath":609}],598:[function(require,module,exports){
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;

},{}],599:[function(require,module,exports){
var baseGet = require('./_baseGet');

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;

},{"./_baseGet":580}],600:[function(require,module,exports){
var assignValue = require('./_assignValue'),
    castPath = require('./_castPath'),
    isIndex = require('./_isIndex'),
    isObject = require('./isObject'),
    toKey = require('./_toKey');

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;

},{"./_assignValue":569,"./_castPath":609,"./_isIndex":651,"./_toKey":690,"./isObject":708}],601:[function(require,module,exports){
var constant = require('./constant'),
    defineProperty = require('./_defineProperty'),
    identity = require('./identity');

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;

},{"./_defineProperty":624,"./constant":693,"./identity":700}],602:[function(require,module,exports){
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;

},{}],603:[function(require,module,exports){
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;

},{}],604:[function(require,module,exports){
var Symbol = require('./_Symbol'),
    arrayMap = require('./_arrayMap'),
    isArray = require('./isArray'),
    isSymbol = require('./isSymbol');

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;

},{"./_Symbol":559,"./_arrayMap":566,"./isArray":702,"./isSymbol":712}],605:[function(require,module,exports){
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;

},{}],606:[function(require,module,exports){
var castPath = require('./_castPath'),
    last = require('./last'),
    parent = require('./_parent'),
    toKey = require('./_toKey');

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;

},{"./_castPath":609,"./_parent":677,"./_toKey":690,"./last":716}],607:[function(require,module,exports){
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;

},{}],608:[function(require,module,exports){
var identity = require('./identity');

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;

},{"./identity":700}],609:[function(require,module,exports){
var isArray = require('./isArray'),
    isKey = require('./_isKey'),
    stringToPath = require('./_stringToPath'),
    toString = require('./toString');

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;

},{"./_isKey":652,"./_stringToPath":689,"./isArray":702,"./toString":725}],610:[function(require,module,exports){
var Uint8Array = require('./_Uint8Array');

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;

},{"./_Uint8Array":560}],611:[function(require,module,exports){
var root = require('./_root');

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

},{"./_root":678}],612:[function(require,module,exports){
var cloneArrayBuffer = require('./_cloneArrayBuffer');

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;

},{"./_cloneArrayBuffer":610}],613:[function(require,module,exports){
/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;

},{}],614:[function(require,module,exports){
var Symbol = require('./_Symbol');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;

},{"./_Symbol":559}],615:[function(require,module,exports){
var cloneArrayBuffer = require('./_cloneArrayBuffer');

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;

},{"./_cloneArrayBuffer":610}],616:[function(require,module,exports){
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;

},{}],617:[function(require,module,exports){
var assignValue = require('./_assignValue'),
    baseAssignValue = require('./_baseAssignValue');

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;

},{"./_assignValue":569,"./_baseAssignValue":573}],618:[function(require,module,exports){
var copyObject = require('./_copyObject'),
    getSymbols = require('./_getSymbols');

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;

},{"./_copyObject":617,"./_getSymbols":637}],619:[function(require,module,exports){
var copyObject = require('./_copyObject'),
    getSymbolsIn = require('./_getSymbolsIn');

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;

},{"./_copyObject":617,"./_getSymbolsIn":638}],620:[function(require,module,exports){
var root = require('./_root');

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;

},{"./_root":678}],621:[function(require,module,exports){
var isArrayLike = require('./isArrayLike');

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;

},{"./isArrayLike":703}],622:[function(require,module,exports){
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;

},{}],623:[function(require,module,exports){
var isPlainObject = require('./isPlainObject');

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;

},{"./isPlainObject":710}],624:[function(require,module,exports){
var getNative = require('./_getNative');

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;

},{"./_getNative":634}],625:[function(require,module,exports){
var SetCache = require('./_SetCache'),
    arraySome = require('./_arraySome'),
    cacheHas = require('./_cacheHas');

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;

},{"./_SetCache":557,"./_arraySome":568,"./_cacheHas":607}],626:[function(require,module,exports){
var Symbol = require('./_Symbol'),
    Uint8Array = require('./_Uint8Array'),
    eq = require('./eq'),
    equalArrays = require('./_equalArrays'),
    mapToArray = require('./_mapToArray'),
    setToArray = require('./_setToArray');

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;

},{"./_Symbol":559,"./_Uint8Array":560,"./_equalArrays":625,"./_mapToArray":667,"./_setToArray":681,"./eq":694}],627:[function(require,module,exports){
var getAllKeys = require('./_getAllKeys');

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;

},{"./_getAllKeys":630}],628:[function(require,module,exports){
var flatten = require('./flatten'),
    overRest = require('./_overRest'),
    setToString = require('./_setToString');

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;

},{"./_overRest":676,"./_setToString":682,"./flatten":695}],629:[function(require,module,exports){
(function (global){
/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],630:[function(require,module,exports){
var baseGetAllKeys = require('./_baseGetAllKeys'),
    getSymbols = require('./_getSymbols'),
    keys = require('./keys');

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;

},{"./_baseGetAllKeys":581,"./_getSymbols":637,"./keys":714}],631:[function(require,module,exports){
var baseGetAllKeys = require('./_baseGetAllKeys'),
    getSymbolsIn = require('./_getSymbolsIn'),
    keysIn = require('./keysIn');

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;

},{"./_baseGetAllKeys":581,"./_getSymbolsIn":638,"./keysIn":715}],632:[function(require,module,exports){
var isKeyable = require('./_isKeyable');

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;

},{"./_isKeyable":653}],633:[function(require,module,exports){
var isStrictComparable = require('./_isStrictComparable'),
    keys = require('./keys');

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;

},{"./_isStrictComparable":656,"./keys":714}],634:[function(require,module,exports){
var baseIsNative = require('./_baseIsNative'),
    getValue = require('./_getValue');

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;

},{"./_baseIsNative":589,"./_getValue":640}],635:[function(require,module,exports){
var overArg = require('./_overArg');

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;

},{"./_overArg":675}],636:[function(require,module,exports){
var Symbol = require('./_Symbol');

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;

},{"./_Symbol":559}],637:[function(require,module,exports){
var arrayFilter = require('./_arrayFilter'),
    stubArray = require('./stubArray');

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;

},{"./_arrayFilter":564,"./stubArray":723}],638:[function(require,module,exports){
var arrayPush = require('./_arrayPush'),
    getPrototype = require('./_getPrototype'),
    getSymbols = require('./_getSymbols'),
    stubArray = require('./stubArray');

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;

},{"./_arrayPush":567,"./_getPrototype":635,"./_getSymbols":637,"./stubArray":723}],639:[function(require,module,exports){
var DataView = require('./_DataView'),
    Map = require('./_Map'),
    Promise = require('./_Promise'),
    Set = require('./_Set'),
    WeakMap = require('./_WeakMap'),
    baseGetTag = require('./_baseGetTag'),
    toSource = require('./_toSource');

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;

},{"./_DataView":550,"./_Map":553,"./_Promise":555,"./_Set":556,"./_WeakMap":561,"./_baseGetTag":582,"./_toSource":691}],640:[function(require,module,exports){
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;

},{}],641:[function(require,module,exports){
var castPath = require('./_castPath'),
    isArguments = require('./isArguments'),
    isArray = require('./isArray'),
    isIndex = require('./_isIndex'),
    isLength = require('./isLength'),
    toKey = require('./_toKey');

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;

},{"./_castPath":609,"./_isIndex":651,"./_toKey":690,"./isArguments":701,"./isArray":702,"./isLength":706}],642:[function(require,module,exports){
var nativeCreate = require('./_nativeCreate');

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;

},{"./_nativeCreate":670}],643:[function(require,module,exports){
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;

},{}],644:[function(require,module,exports){
var nativeCreate = require('./_nativeCreate');

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;

},{"./_nativeCreate":670}],645:[function(require,module,exports){
var nativeCreate = require('./_nativeCreate');

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;

},{"./_nativeCreate":670}],646:[function(require,module,exports){
var nativeCreate = require('./_nativeCreate');

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;

},{"./_nativeCreate":670}],647:[function(require,module,exports){
/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;

},{}],648:[function(require,module,exports){
var cloneArrayBuffer = require('./_cloneArrayBuffer'),
    cloneDataView = require('./_cloneDataView'),
    cloneRegExp = require('./_cloneRegExp'),
    cloneSymbol = require('./_cloneSymbol'),
    cloneTypedArray = require('./_cloneTypedArray');

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;

},{"./_cloneArrayBuffer":610,"./_cloneDataView":612,"./_cloneRegExp":613,"./_cloneSymbol":614,"./_cloneTypedArray":615}],649:[function(require,module,exports){
var baseCreate = require('./_baseCreate'),
    getPrototype = require('./_getPrototype'),
    isPrototype = require('./_isPrototype');

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;

},{"./_baseCreate":575,"./_getPrototype":635,"./_isPrototype":655}],650:[function(require,module,exports){
var Symbol = require('./_Symbol'),
    isArguments = require('./isArguments'),
    isArray = require('./isArray');

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;

},{"./_Symbol":559,"./isArguments":701,"./isArray":702}],651:[function(require,module,exports){
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;

},{}],652:[function(require,module,exports){
var isArray = require('./isArray'),
    isSymbol = require('./isSymbol');

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;

},{"./isArray":702,"./isSymbol":712}],653:[function(require,module,exports){
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;

},{}],654:[function(require,module,exports){
var coreJsData = require('./_coreJsData');

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;

},{"./_coreJsData":620}],655:[function(require,module,exports){
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;

},{}],656:[function(require,module,exports){
var isObject = require('./isObject');

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;

},{"./isObject":708}],657:[function(require,module,exports){
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;

},{}],658:[function(require,module,exports){
var assocIndexOf = require('./_assocIndexOf');

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;

},{"./_assocIndexOf":570}],659:[function(require,module,exports){
var assocIndexOf = require('./_assocIndexOf');

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;

},{"./_assocIndexOf":570}],660:[function(require,module,exports){
var assocIndexOf = require('./_assocIndexOf');

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;

},{"./_assocIndexOf":570}],661:[function(require,module,exports){
var assocIndexOf = require('./_assocIndexOf');

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;

},{"./_assocIndexOf":570}],662:[function(require,module,exports){
var Hash = require('./_Hash'),
    ListCache = require('./_ListCache'),
    Map = require('./_Map');

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;

},{"./_Hash":551,"./_ListCache":552,"./_Map":553}],663:[function(require,module,exports){
var getMapData = require('./_getMapData');

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;

},{"./_getMapData":632}],664:[function(require,module,exports){
var getMapData = require('./_getMapData');

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;

},{"./_getMapData":632}],665:[function(require,module,exports){
var getMapData = require('./_getMapData');

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;

},{"./_getMapData":632}],666:[function(require,module,exports){
var getMapData = require('./_getMapData');

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;

},{"./_getMapData":632}],667:[function(require,module,exports){
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;

},{}],668:[function(require,module,exports){
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;

},{}],669:[function(require,module,exports){
var memoize = require('./memoize');

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;

},{"./memoize":719}],670:[function(require,module,exports){
var getNative = require('./_getNative');

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;

},{"./_getNative":634}],671:[function(require,module,exports){
var overArg = require('./_overArg');

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;

},{"./_overArg":675}],672:[function(require,module,exports){
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;

},{}],673:[function(require,module,exports){
var freeGlobal = require('./_freeGlobal');

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

},{"./_freeGlobal":629}],674:[function(require,module,exports){
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;

},{}],675:[function(require,module,exports){
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;

},{}],676:[function(require,module,exports){
var apply = require('./_apply');

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;

},{"./_apply":562}],677:[function(require,module,exports){
var baseGet = require('./_baseGet'),
    baseSlice = require('./_baseSlice');

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;

},{"./_baseGet":580,"./_baseSlice":602}],678:[function(require,module,exports){
var freeGlobal = require('./_freeGlobal');

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;

},{"./_freeGlobal":629}],679:[function(require,module,exports){
/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;

},{}],680:[function(require,module,exports){
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;

},{}],681:[function(require,module,exports){
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;

},{}],682:[function(require,module,exports){
var baseSetToString = require('./_baseSetToString'),
    shortOut = require('./_shortOut');

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;

},{"./_baseSetToString":601,"./_shortOut":683}],683:[function(require,module,exports){
/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;

},{}],684:[function(require,module,exports){
var ListCache = require('./_ListCache');

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;

},{"./_ListCache":552}],685:[function(require,module,exports){
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;

},{}],686:[function(require,module,exports){
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;

},{}],687:[function(require,module,exports){
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;

},{}],688:[function(require,module,exports){
var ListCache = require('./_ListCache'),
    Map = require('./_Map'),
    MapCache = require('./_MapCache');

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;

},{"./_ListCache":552,"./_Map":553,"./_MapCache":554}],689:[function(require,module,exports){
var memoizeCapped = require('./_memoizeCapped');

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;

},{"./_memoizeCapped":669}],690:[function(require,module,exports){
var isSymbol = require('./isSymbol');

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;

},{"./isSymbol":712}],691:[function(require,module,exports){
/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;

},{}],692:[function(require,module,exports){
var baseClone = require('./_baseClone');

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG);
}

module.exports = clone;

},{"./_baseClone":574}],693:[function(require,module,exports){
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;

},{}],694:[function(require,module,exports){
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;

},{}],695:[function(require,module,exports){
var baseFlatten = require('./_baseFlatten');

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;

},{"./_baseFlatten":577}],696:[function(require,module,exports){
var arrayEach = require('./_arrayEach'),
    baseEach = require('./_baseEach'),
    castFunction = require('./_castFunction'),
    isArray = require('./isArray');

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;

},{"./_arrayEach":563,"./_baseEach":576,"./_castFunction":608,"./isArray":702}],697:[function(require,module,exports){
var baseFor = require('./_baseFor'),
    castFunction = require('./_castFunction'),
    keysIn = require('./keysIn');

/**
 * Iterates over own and inherited enumerable string keyed properties of an
 * object and invokes `iteratee` for each property. The iteratee is invoked
 * with three arguments: (value, key, object). Iteratee functions may exit
 * iteration early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forInRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forIn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
 */
function forIn(object, iteratee) {
  return object == null
    ? object
    : baseFor(object, castFunction(iteratee), keysIn);
}

module.exports = forIn;

},{"./_baseFor":578,"./_castFunction":608,"./keysIn":715}],698:[function(require,module,exports){
var baseGet = require('./_baseGet');

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;

},{"./_baseGet":580}],699:[function(require,module,exports){
var baseHasIn = require('./_baseHasIn'),
    hasPath = require('./_hasPath');

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;

},{"./_baseHasIn":583,"./_hasPath":641}],700:[function(require,module,exports){
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;

},{}],701:[function(require,module,exports){
var baseIsArguments = require('./_baseIsArguments'),
    isObjectLike = require('./isObjectLike');

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;

},{"./_baseIsArguments":584,"./isObjectLike":709}],702:[function(require,module,exports){
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;

},{}],703:[function(require,module,exports){
var isFunction = require('./isFunction'),
    isLength = require('./isLength');

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;

},{"./isFunction":705,"./isLength":706}],704:[function(require,module,exports){
var root = require('./_root'),
    stubFalse = require('./stubFalse');

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

},{"./_root":678,"./stubFalse":724}],705:[function(require,module,exports){
var baseGetTag = require('./_baseGetTag'),
    isObject = require('./isObject');

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;

},{"./_baseGetTag":582,"./isObject":708}],706:[function(require,module,exports){
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;

},{}],707:[function(require,module,exports){
var baseIsMap = require('./_baseIsMap'),
    baseUnary = require('./_baseUnary'),
    nodeUtil = require('./_nodeUtil');

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;

},{"./_baseIsMap":587,"./_baseUnary":605,"./_nodeUtil":673}],708:[function(require,module,exports){
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;

},{}],709:[function(require,module,exports){
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;

},{}],710:[function(require,module,exports){
var baseGetTag = require('./_baseGetTag'),
    getPrototype = require('./_getPrototype'),
    isObjectLike = require('./isObjectLike');

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;

},{"./_baseGetTag":582,"./_getPrototype":635,"./isObjectLike":709}],711:[function(require,module,exports){
var baseIsSet = require('./_baseIsSet'),
    baseUnary = require('./_baseUnary'),
    nodeUtil = require('./_nodeUtil');

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;

},{"./_baseIsSet":590,"./_baseUnary":605,"./_nodeUtil":673}],712:[function(require,module,exports){
var baseGetTag = require('./_baseGetTag'),
    isObjectLike = require('./isObjectLike');

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;

},{"./_baseGetTag":582,"./isObjectLike":709}],713:[function(require,module,exports){
var baseIsTypedArray = require('./_baseIsTypedArray'),
    baseUnary = require('./_baseUnary'),
    nodeUtil = require('./_nodeUtil');

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;

},{"./_baseIsTypedArray":591,"./_baseUnary":605,"./_nodeUtil":673}],714:[function(require,module,exports){
var arrayLikeKeys = require('./_arrayLikeKeys'),
    baseKeys = require('./_baseKeys'),
    isArrayLike = require('./isArrayLike');

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;

},{"./_arrayLikeKeys":565,"./_baseKeys":593,"./isArrayLike":703}],715:[function(require,module,exports){
var arrayLikeKeys = require('./_arrayLikeKeys'),
    baseKeysIn = require('./_baseKeysIn'),
    isArrayLike = require('./isArrayLike');

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;

},{"./_arrayLikeKeys":565,"./_baseKeysIn":594,"./isArrayLike":703}],716:[function(require,module,exports){
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;

},{}],717:[function(require,module,exports){
(function (global){
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.19';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(users, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(users, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    define(function() {
      return _;
    });
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],718:[function(require,module,exports){
var baseAssignValue = require('./_baseAssignValue'),
    baseForOwn = require('./_baseForOwn'),
    baseIteratee = require('./_baseIteratee');

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, key, iteratee(value, key, object));
  });
  return result;
}

module.exports = mapValues;

},{"./_baseAssignValue":573,"./_baseForOwn":579,"./_baseIteratee":592}],719:[function(require,module,exports){
var MapCache = require('./_MapCache');

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;

},{"./_MapCache":554}],720:[function(require,module,exports){
var arrayMap = require('./_arrayMap'),
    baseClone = require('./_baseClone'),
    baseUnset = require('./_baseUnset'),
    castPath = require('./_castPath'),
    copyObject = require('./_copyObject'),
    customOmitClone = require('./_customOmitClone'),
    flatRest = require('./_flatRest'),
    getAllKeysIn = require('./_getAllKeysIn');

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;

},{"./_arrayMap":566,"./_baseClone":574,"./_baseUnset":606,"./_castPath":609,"./_copyObject":617,"./_customOmitClone":623,"./_flatRest":628,"./_getAllKeysIn":631}],721:[function(require,module,exports){
var arrayMap = require('./_arrayMap'),
    baseIteratee = require('./_baseIteratee'),
    basePickBy = require('./_basePickBy'),
    getAllKeysIn = require('./_getAllKeysIn');

/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */
function pickBy(object, predicate) {
  if (object == null) {
    return {};
  }
  var props = arrayMap(getAllKeysIn(object), function(prop) {
    return [prop];
  });
  predicate = baseIteratee(predicate);
  return basePickBy(object, props, function(value, path) {
    return predicate(value, path[0]);
  });
}

module.exports = pickBy;

},{"./_arrayMap":566,"./_baseIteratee":592,"./_basePickBy":597,"./_getAllKeysIn":631}],722:[function(require,module,exports){
var baseProperty = require('./_baseProperty'),
    basePropertyDeep = require('./_basePropertyDeep'),
    isKey = require('./_isKey'),
    toKey = require('./_toKey');

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;

},{"./_baseProperty":598,"./_basePropertyDeep":599,"./_isKey":652,"./_toKey":690}],723:[function(require,module,exports){
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;

},{}],724:[function(require,module,exports){
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;

},{}],725:[function(require,module,exports){
var baseToString = require('./_baseToString');

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;

},{"./_baseToString":604}],726:[function(require,module,exports){
/**
 * @name MarkerClustererPlus for Google Maps V3
 * @version 2.1.2 [May 28, 2014]
 * @author Gary Little
 * @fileoverview
 * The library creates and manages per-zoom-level clusters for large amounts of markers.
 * <p>
 * This is an enhanced V3 implementation of the
 * <a href="http://gmaps-utility-library-dev.googlecode.com/svn/tags/markerclusterer/"
 * >V2 MarkerClusterer</a> by Xiaoxi Wu. It is based on the
 * <a href="http://google-maps-utility-library-v3.googlecode.com/svn/tags/markerclusterer/"
 * >V3 MarkerClusterer</a> port by Luke Mahe. MarkerClustererPlus was created by Gary Little.
 * <p>
 * v2.0 release: MarkerClustererPlus v2.0 is backward compatible with MarkerClusterer v1.0. It
 *  adds support for the <code>ignoreHidden</code>, <code>title</code>, <code>batchSizeIE</code>,
 *  and <code>calculator</code> properties as well as support for four more events. It also allows
 *  greater control over the styling of the text that appears on the cluster marker. The
 *  documentation has been significantly improved and the overall code has been simplified and
 *  polished. Very large numbers of markers can now be managed without causing Javascript timeout
 *  errors on Internet Explorer. Note that the name of the <code>clusterclick</code> event has been
 *  deprecated. The new name is <code>click</code>, so please change your application code now.
 */

/**
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


/**
 * @name ClusterIconStyle
 * @class This class represents the object for values in the <code>styles</code> array passed
 *  to the {@link MarkerClusterer} constructor. The element in this array that is used to
 *  style the cluster icon is determined by calling the <code>calculator</code> function.
 *
 * @property {string} url The URL of the cluster icon image file. Required.
 * @property {number} height The display height (in pixels) of the cluster icon. Required.
 * @property {number} width The display width (in pixels) of the cluster icon. Required.
 * @property {Array} [anchorText] The position (in pixels) from the center of the cluster icon to
 *  where the text label is to be centered and drawn. The format is <code>[yoffset, xoffset]</code>
 *  where <code>yoffset</code> increases as you go down from center and <code>xoffset</code>
 *  increases to the right of center. The default is <code>[0, 0]</code>.
 * @property {Array} [anchorIcon] The anchor position (in pixels) of the cluster icon. This is the
 *  spot on the cluster icon that is to be aligned with the cluster position. The format is
 *  <code>[yoffset, xoffset]</code> where <code>yoffset</code> increases as you go down and
 *  <code>xoffset</code> increases to the right of the top-left corner of the icon. The default
 *  anchor position is the center of the cluster icon.
 * @property {string} [textColor="black"] The color of the label text shown on the
 *  cluster icon.
 * @property {number} [textSize=11] The size (in pixels) of the label text shown on the
 *  cluster icon.
 * @property {string} [textDecoration="none"] The value of the CSS <code>text-decoration</code>
 *  property for the label text shown on the cluster icon.
 * @property {string} [fontWeight="bold"] The value of the CSS <code>font-weight</code>
 *  property for the label text shown on the cluster icon.
 * @property {string} [fontStyle="normal"] The value of the CSS <code>font-style</code>
 *  property for the label text shown on the cluster icon.
 * @property {string} [fontFamily="Arial,sans-serif"] The value of the CSS <code>font-family</code>
 *  property for the label text shown on the cluster icon.
 * @property {string} [backgroundPosition="0 0"] The position of the cluster icon image
 *  within the image defined by <code>url</code>. The format is <code>"xpos ypos"</code>
 *  (the same format as for the CSS <code>background-position</code> property). You must set
 *  this property appropriately when the image defined by <code>url</code> represents a sprite
 *  containing multiple images. Note that the position <i>must</i> be specified in px units.
 */
/**
 * @name ClusterIconInfo
 * @class This class is an object containing general information about a cluster icon. This is
 *  the object that a <code>calculator</code> function returns.
 *
 * @property {string} text The text of the label to be shown on the cluster icon.
 * @property {number} index The index plus 1 of the element in the <code>styles</code>
 *  array to be used to style the cluster icon.
 * @property {string} title The tooltip to display when the mouse moves over the cluster icon.
 *  If this value is <code>undefined</code> or <code>""</code>, <code>title</code> is set to the
 *  value of the <code>title</code> property passed to the MarkerClusterer.
 */
/**
 * A cluster icon.
 *
 * @constructor
 * @extends google.maps.OverlayView
 * @param {Cluster} cluster The cluster with which the icon is to be associated.
 * @param {Array} [styles] An array of {@link ClusterIconStyle} defining the cluster icons
 *  to use for various cluster sizes.
 * @private
 */
function ClusterIcon(cluster, styles) {
  cluster.getMarkerClusterer().extend(ClusterIcon, google.maps.OverlayView);

  this.cluster_ = cluster;
  this.className_ = cluster.getMarkerClusterer().getClusterClass();
  this.styles_ = styles;
  this.center_ = null;
  this.div_ = null;
  this.sums_ = null;
  this.visible_ = false;

  this.setMap(cluster.getMap()); // Note: this causes onAdd to be called
}


/**
 * Adds the icon to the DOM.
 */
ClusterIcon.prototype.onAdd = function () {
  var cClusterIcon = this;
  var cMouseDownInCluster;
  var cDraggingMapByCluster;

  this.div_ = document.createElement("div");
  this.div_.className = this.className_;
  if (this.visible_) {
    this.show();
  }

  this.getPanes().overlayMouseTarget.appendChild(this.div_);

  // Fix for Issue 157
  this.boundsChangedListener_ = google.maps.event.addListener(this.getMap(), "bounds_changed", function () {
    cDraggingMapByCluster = cMouseDownInCluster;
  });

  google.maps.event.addDomListener(this.div_, "mousedown", function () {
    cMouseDownInCluster = true;
    cDraggingMapByCluster = false;
  });

  google.maps.event.addDomListener(this.div_, "click", function (e) {
    cMouseDownInCluster = false;
    if (!cDraggingMapByCluster) {
      var theBounds;
      var mz;
      var mc = cClusterIcon.cluster_.getMarkerClusterer();
      /**
       * This event is fired when a cluster marker is clicked.
       * @name MarkerClusterer#click
       * @param {Cluster} c The cluster that was clicked.
       * @event
       */
      google.maps.event.trigger(mc, "click", cClusterIcon.cluster_);
      google.maps.event.trigger(mc, "clusterclick", cClusterIcon.cluster_); // deprecated name

      // The default click handler follows. Disable it by setting
      // the zoomOnClick property to false.
      if (mc.getZoomOnClick()) {
        // Zoom into the cluster.
        mz = mc.getMaxZoom();
        theBounds = cClusterIcon.cluster_.getBounds();
        mc.getMap().fitBounds(theBounds);
        // There is a fix for Issue 170 here:
        setTimeout(function () {
          mc.getMap().fitBounds(theBounds);
          // Don't zoom beyond the max zoom level
          if (mz !== null && (mc.getMap().getZoom() > mz)) {
            mc.getMap().setZoom(mz + 1);
          }
        }, 100);
      }

      // Prevent event propagation to the map:
      e.cancelBubble = true;
      if (e.stopPropagation) {
        e.stopPropagation();
      }
    }
  });

  google.maps.event.addDomListener(this.div_, "mouseover", function () {
    var mc = cClusterIcon.cluster_.getMarkerClusterer();
    /**
     * This event is fired when the mouse moves over a cluster marker.
     * @name MarkerClusterer#mouseover
     * @param {Cluster} c The cluster that the mouse moved over.
     * @event
     */
    google.maps.event.trigger(mc, "mouseover", cClusterIcon.cluster_);
  });

  google.maps.event.addDomListener(this.div_, "mouseout", function () {
    var mc = cClusterIcon.cluster_.getMarkerClusterer();
    /**
     * This event is fired when the mouse moves out of a cluster marker.
     * @name MarkerClusterer#mouseout
     * @param {Cluster} c The cluster that the mouse moved out of.
     * @event
     */
    google.maps.event.trigger(mc, "mouseout", cClusterIcon.cluster_);
  });
};


/**
 * Removes the icon from the DOM.
 */
ClusterIcon.prototype.onRemove = function () {
  if (this.div_ && this.div_.parentNode) {
    this.hide();
    google.maps.event.removeListener(this.boundsChangedListener_);
    google.maps.event.clearInstanceListeners(this.div_);
    this.div_.parentNode.removeChild(this.div_);
    this.div_ = null;
  }
};


/**
 * Draws the icon.
 */
ClusterIcon.prototype.draw = function () {
  if (this.visible_) {
    var pos = this.getPosFromLatLng_(this.center_);
    this.div_.style.top = pos.y + "px";
    this.div_.style.left = pos.x + "px";
  }
};


/**
 * Hides the icon.
 */
ClusterIcon.prototype.hide = function () {
  if (this.div_) {
    this.div_.style.display = "none";
  }
  this.visible_ = false;
};


/**
 * Positions and shows the icon.
 */
ClusterIcon.prototype.show = function () {
  if (this.div_) {
    var img = "";
    // NOTE: values must be specified in px units
    var bp = this.backgroundPosition_.split(" ");
    var spriteH = parseInt(bp[0].replace(/^\s+|\s+$/g, ""), 10);
    var spriteV = parseInt(bp[1].replace(/^\s+|\s+$/g, ""), 10);
    var pos = this.getPosFromLatLng_(this.center_);
    this.div_.style.cssText = this.createCss(pos);
    img = "<img src='" + this.url_ + "' style='position: absolute; top: " + spriteV + "px; left: " + spriteH + "px; ";
    if (!this.cluster_.getMarkerClusterer().enableRetinaIcons_) {
      img += "clip: rect(" + (-1 * spriteV) + "px, " + ((-1 * spriteH) + this.width_) + "px, " +
          ((-1 * spriteV) + this.height_) + "px, " + (-1 * spriteH) + "px);";
    }
    img += "'>";
    this.div_.innerHTML = img + "<div style='" +
        "position: absolute;" +
        "top: " + this.anchorText_[0] + "px;" +
        "left: " + this.anchorText_[1] + "px;" +
        "color: " + this.textColor_ + ";" +
        "font-size: " + this.textSize_ + "px;" +
        "font-family: " + this.fontFamily_ + ";" +
        "font-weight: " + this.fontWeight_ + ";" +
        "font-style: " + this.fontStyle_ + ";" +
        "text-decoration: " + this.textDecoration_ + ";" +
        "text-align: center;" +
        "width: " + this.width_ + "px;" +
        "line-height:" + this.height_ + "px;" +
        "'>" + this.sums_.text + "</div>";
    if (typeof this.sums_.title === "undefined" || this.sums_.title === "") {
      this.div_.title = this.cluster_.getMarkerClusterer().getTitle();
    } else {
      this.div_.title = this.sums_.title;
    }
    this.div_.style.display = "";
  }
  this.visible_ = true;
};


/**
 * Sets the icon styles to the appropriate element in the styles array.
 *
 * @param {ClusterIconInfo} sums The icon label text and styles index.
 */
ClusterIcon.prototype.useStyle = function (sums) {
  this.sums_ = sums;
  var index = Math.max(0, sums.index - 1);
  index = Math.min(this.styles_.length - 1, index);
  var style = this.styles_[index];
  this.url_ = style.url;
  this.height_ = style.height;
  this.width_ = style.width;
  this.anchorText_ = style.anchorText || [0, 0];
  this.anchorIcon_ = style.anchorIcon || [parseInt(this.height_ / 2, 10), parseInt(this.width_ / 2, 10)];
  this.textColor_ = style.textColor || "black";
  this.textSize_ = style.textSize || 11;
  this.textDecoration_ = style.textDecoration || "none";
  this.fontWeight_ = style.fontWeight || "bold";
  this.fontStyle_ = style.fontStyle || "normal";
  this.fontFamily_ = style.fontFamily || "Arial,sans-serif";
  this.backgroundPosition_ = style.backgroundPosition || "0 0";
};


/**
 * Sets the position at which to center the icon.
 *
 * @param {google.maps.LatLng} center The latlng to set as the center.
 */
ClusterIcon.prototype.setCenter = function (center) {
  this.center_ = center;
};


/**
 * Creates the cssText style parameter based on the position of the icon.
 *
 * @param {google.maps.Point} pos The position of the icon.
 * @return {string} The CSS style text.
 */
ClusterIcon.prototype.createCss = function (pos) {
  var style = [];
  style.push("cursor: pointer;");
  style.push("position: absolute; top: " + pos.y + "px; left: " + pos.x + "px;");
  style.push("width: " + this.width_ + "px; height: " + this.height_ + "px;");
  return style.join("");
};


/**
 * Returns the position at which to place the DIV depending on the latlng.
 *
 * @param {google.maps.LatLng} latlng The position in latlng.
 * @return {google.maps.Point} The position in pixels.
 */
ClusterIcon.prototype.getPosFromLatLng_ = function (latlng) {
  var pos = this.getProjection().fromLatLngToDivPixel(latlng);
  pos.x -= this.anchorIcon_[1];
  pos.y -= this.anchorIcon_[0];
  pos.x = parseInt(pos.x, 10);
  pos.y = parseInt(pos.y, 10);
  return pos;
};


/**
 * Creates a single cluster that manages a group of proximate markers.
 *  Used internally, do not call this constructor directly.
 * @constructor
 * @param {MarkerClusterer} mc The <code>MarkerClusterer</code> object with which this
 *  cluster is associated.
 */
function Cluster(mc) {
  this.markerClusterer_ = mc;
  this.map_ = mc.getMap();
  this.gridSize_ = mc.getGridSize();
  this.minClusterSize_ = mc.getMinimumClusterSize();
  this.averageCenter_ = mc.getAverageCenter();
  this.markers_ = [];
  this.center_ = null;
  this.bounds_ = null;
  this.clusterIcon_ = new ClusterIcon(this, mc.getStyles());
}


/**
 * Returns the number of markers managed by the cluster. You can call this from
 * a <code>click</code>, <code>mouseover</code>, or <code>mouseout</code> event handler
 * for the <code>MarkerClusterer</code> object.
 *
 * @return {number} The number of markers in the cluster.
 */
Cluster.prototype.getSize = function () {
  return this.markers_.length;
};


/**
 * Returns the array of markers managed by the cluster. You can call this from
 * a <code>click</code>, <code>mouseover</code>, or <code>mouseout</code> event handler
 * for the <code>MarkerClusterer</code> object.
 *
 * @return {Array} The array of markers in the cluster.
 */
Cluster.prototype.getMarkers = function () {
  return this.markers_;
};


/**
 * Returns the center of the cluster. You can call this from
 * a <code>click</code>, <code>mouseover</code>, or <code>mouseout</code> event handler
 * for the <code>MarkerClusterer</code> object.
 *
 * @return {google.maps.LatLng} The center of the cluster.
 */
Cluster.prototype.getCenter = function () {
  return this.center_;
};


/**
 * Returns the map with which the cluster is associated.
 *
 * @return {google.maps.Map} The map.
 * @ignore
 */
Cluster.prototype.getMap = function () {
  return this.map_;
};


/**
 * Returns the <code>MarkerClusterer</code> object with which the cluster is associated.
 *
 * @return {MarkerClusterer} The associated marker clusterer.
 * @ignore
 */
Cluster.prototype.getMarkerClusterer = function () {
  return this.markerClusterer_;
};


/**
 * Returns the bounds of the cluster.
 *
 * @return {google.maps.LatLngBounds} the cluster bounds.
 * @ignore
 */
Cluster.prototype.getBounds = function () {
  var i;
  var bounds = new google.maps.LatLngBounds(this.center_, this.center_);
  var markers = this.getMarkers();
  for (i = 0; i < markers.length; i++) {
    bounds.extend(markers[i].getPosition());
  }
  return bounds;
};


/**
 * Removes the cluster from the map.
 *
 * @ignore
 */
Cluster.prototype.remove = function () {
  this.clusterIcon_.setMap(null);
  this.markers_ = [];
  delete this.markers_;
};


/**
 * Adds a marker to the cluster.
 *
 * @param {google.maps.Marker} marker The marker to be added.
 * @return {boolean} True if the marker was added.
 * @ignore
 */
Cluster.prototype.addMarker = function (marker) {
  var i;
  var mCount;
  var mz;

  if (this.isMarkerAlreadyAdded_(marker)) {
    return false;
  }

  if (!this.center_) {
    this.center_ = marker.getPosition();
    this.calculateBounds_();
  } else {
    if (this.averageCenter_) {
      var l = this.markers_.length + 1;
      var lat = (this.center_.lat() * (l - 1) + marker.getPosition().lat()) / l;
      var lng = (this.center_.lng() * (l - 1) + marker.getPosition().lng()) / l;
      this.center_ = new google.maps.LatLng(lat, lng);
      this.calculateBounds_();
    }
  }

  marker.isAdded = true;
  this.markers_.push(marker);

  mCount = this.markers_.length;
  mz = this.markerClusterer_.getMaxZoom();
  if (mz !== null && this.map_.getZoom() > mz) {
    // Zoomed in past max zoom, so show the marker.
    if (marker.getMap() !== this.map_) {
      marker.setMap(this.map_);
    }
  } else if (mCount < this.minClusterSize_) {
    // Min cluster size not reached so show the marker.
    if (marker.getMap() !== this.map_) {
      marker.setMap(this.map_);
    }
  } else if (mCount === this.minClusterSize_) {
    // Hide the markers that were showing.
    for (i = 0; i < mCount; i++) {
      this.markers_[i].setMap(null);
    }
  } else {
    marker.setMap(null);
  }

  this.updateIcon_();
  return true;
};


/**
 * Determines if a marker lies within the cluster's bounds.
 *
 * @param {google.maps.Marker} marker The marker to check.
 * @return {boolean} True if the marker lies in the bounds.
 * @ignore
 */
Cluster.prototype.isMarkerInClusterBounds = function (marker) {
  return this.bounds_.contains(marker.getPosition());
};


/**
 * Calculates the extended bounds of the cluster with the grid.
 */
Cluster.prototype.calculateBounds_ = function () {
  var bounds = new google.maps.LatLngBounds(this.center_, this.center_);
  this.bounds_ = this.markerClusterer_.getExtendedBounds(bounds);
};


/**
 * Updates the cluster icon.
 */
Cluster.prototype.updateIcon_ = function () {
  var mCount = this.markers_.length;
  var mz = this.markerClusterer_.getMaxZoom();

  if (mz !== null && this.map_.getZoom() > mz) {
    this.clusterIcon_.hide();
    return;
  }

  if (mCount < this.minClusterSize_) {
    // Min cluster size not yet reached.
    this.clusterIcon_.hide();
    return;
  }

  var numStyles = this.markerClusterer_.getStyles().length;
  var sums = this.markerClusterer_.getCalculator()(this.markers_, numStyles);
  this.clusterIcon_.setCenter(this.center_);
  this.clusterIcon_.useStyle(sums);
  this.clusterIcon_.show();
};


/**
 * Determines if a marker has already been added to the cluster.
 *
 * @param {google.maps.Marker} marker The marker to check.
 * @return {boolean} True if the marker has already been added.
 */
Cluster.prototype.isMarkerAlreadyAdded_ = function (marker) {
  var i;
  if (this.markers_.indexOf) {
    return this.markers_.indexOf(marker) !== -1;
  } else {
    for (i = 0; i < this.markers_.length; i++) {
      if (marker === this.markers_[i]) {
        return true;
      }
    }
  }
  return false;
};


/**
 * @name MarkerClustererOptions
 * @class This class represents the optional parameter passed to
 *  the {@link MarkerClusterer} constructor.
 * @property {number} [gridSize=60] The grid size of a cluster in pixels. The grid is a square.
 * @property {number} [maxZoom=null] The maximum zoom level at which clustering is enabled or
 *  <code>null</code> if clustering is to be enabled at all zoom levels.
 * @property {boolean} [zoomOnClick=true] Whether to zoom the map when a cluster marker is
 *  clicked. You may want to set this to <code>false</code> if you have installed a handler
 *  for the <code>click</code> event and it deals with zooming on its own.
 * @property {boolean} [averageCenter=false] Whether the position of a cluster marker should be
 *  the average position of all markers in the cluster. If set to <code>false</code>, the
 *  cluster marker is positioned at the location of the first marker added to the cluster.
 * @property {number} [minimumClusterSize=2] The minimum number of markers needed in a cluster
 *  before the markers are hidden and a cluster marker appears.
 * @property {boolean} [ignoreHidden=false] Whether to ignore hidden markers in clusters. You
 *  may want to set this to <code>true</code> to ensure that hidden markers are not included
 *  in the marker count that appears on a cluster marker (this count is the value of the
 *  <code>text</code> property of the result returned by the default <code>calculator</code>).
 *  If set to <code>true</code> and you change the visibility of a marker being clustered, be
 *  sure to also call <code>MarkerClusterer.repaint()</code>.
 * @property {string} [title=""] The tooltip to display when the mouse moves over a cluster
 *  marker. (Alternatively, you can use a custom <code>calculator</code> function to specify a
 *  different tooltip for each cluster marker.)
 * @property {function} [calculator=MarkerClusterer.CALCULATOR] The function used to determine
 *  the text to be displayed on a cluster marker and the index indicating which style to use
 *  for the cluster marker. The input parameters for the function are (1) the array of markers
 *  represented by a cluster marker and (2) the number of cluster icon styles. It returns a
 *  {@link ClusterIconInfo} object. The default <code>calculator</code> returns a
 *  <code>text</code> property which is the number of markers in the cluster and an
 *  <code>index</code> property which is one higher than the lowest integer such that
 *  <code>10^i</code> exceeds the number of markers in the cluster, or the size of the styles
 *  array, whichever is less. The <code>styles</code> array element used has an index of
 *  <code>index</code> minus 1. For example, the default <code>calculator</code> returns a
 *  <code>text</code> value of <code>"125"</code> and an <code>index</code> of <code>3</code>
 *  for a cluster icon representing 125 markers so the element used in the <code>styles</code>
 *  array is <code>2</code>. A <code>calculator</code> may also return a <code>title</code>
 *  property that contains the text of the tooltip to be used for the cluster marker. If
 *   <code>title</code> is not defined, the tooltip is set to the value of the <code>title</code>
 *   property for the MarkerClusterer.
 * @property {string} [clusterClass="cluster"] The name of the CSS class defining general styles
 *  for the cluster markers. Use this class to define CSS styles that are not set up by the code
 *  that processes the <code>styles</code> array.
 * @property {Array} [styles] An array of {@link ClusterIconStyle} elements defining the styles
 *  of the cluster markers to be used. The element to be used to style a given cluster marker
 *  is determined by the function defined by the <code>calculator</code> property.
 *  The default is an array of {@link ClusterIconStyle} elements whose properties are derived
 *  from the values for <code>imagePath</code>, <code>imageExtension</code>, and
 *  <code>imageSizes</code>.
 * @property {boolean} [enableRetinaIcons=false] Whether to allow the use of cluster icons that
 * have sizes that are some multiple (typically double) of their actual display size. Icons such
 * as these look better when viewed on high-resolution monitors such as Apple's Retina displays.
 * Note: if this property is <code>true</code>, sprites cannot be used as cluster icons.
 * @property {number} [batchSize=MarkerClusterer.BATCH_SIZE] Set this property to the
 *  number of markers to be processed in a single batch when using a browser other than
 *  Internet Explorer (for Internet Explorer, use the batchSizeIE property instead).
 * @property {number} [batchSizeIE=MarkerClusterer.BATCH_SIZE_IE] When Internet Explorer is
 *  being used, markers are processed in several batches with a small delay inserted between
 *  each batch in an attempt to avoid Javascript timeout errors. Set this property to the
 *  number of markers to be processed in a single batch; select as high a number as you can
 *  without causing a timeout error in the browser. This number might need to be as low as 100
 *  if 15,000 markers are being managed, for example.
 * @property {string} [imagePath=MarkerClusterer.IMAGE_PATH]
 *  The full URL of the root name of the group of image files to use for cluster icons.
 *  The complete file name is of the form <code>imagePath</code>n.<code>imageExtension</code>
 *  where n is the image file number (1, 2, etc.).
 * @property {string} [imageExtension=MarkerClusterer.IMAGE_EXTENSION]
 *  The extension name for the cluster icon image files (e.g., <code>"png"</code> or
 *  <code>"jpg"</code>).
 * @property {Array} [imageSizes=MarkerClusterer.IMAGE_SIZES]
 *  An array of numbers containing the widths of the group of
 *  <code>imagePath</code>n.<code>imageExtension</code> image files.
 *  (The images are assumed to be square.)
 */
/**
 * Creates a MarkerClusterer object with the options specified in {@link MarkerClustererOptions}.
 * @constructor
 * @extends google.maps.OverlayView
 * @param {google.maps.Map} map The Google map to attach to.
 * @param {Array.<google.maps.Marker>} [opt_markers] The markers to be added to the cluster.
 * @param {MarkerClustererOptions} [opt_options] The optional parameters.
 */
function MarkerClusterer(map, opt_markers, opt_options) {
  // MarkerClusterer implements google.maps.OverlayView interface. We use the
  // extend function to extend MarkerClusterer with google.maps.OverlayView
  // because it might not always be available when the code is defined so we
  // look for it at the last possible moment. If it doesn't exist now then
  // there is no point going ahead :)
  this.extend(MarkerClusterer, google.maps.OverlayView);

  opt_markers = opt_markers || [];
  opt_options = opt_options || {};

  this.markers_ = [];
  this.clusters_ = [];
  this.listeners_ = [];
  this.activeMap_ = null;
  this.ready_ = false;

  this.gridSize_ = opt_options.gridSize || 60;
  this.minClusterSize_ = opt_options.minimumClusterSize || 2;
  this.maxZoom_ = opt_options.maxZoom || null;
  this.styles_ = opt_options.styles || [];
  this.title_ = opt_options.title || "";
  this.zoomOnClick_ = true;
  if (opt_options.zoomOnClick !== undefined) {
    this.zoomOnClick_ = opt_options.zoomOnClick;
  }
  this.averageCenter_ = false;
  if (opt_options.averageCenter !== undefined) {
    this.averageCenter_ = opt_options.averageCenter;
  }
  this.ignoreHidden_ = false;
  if (opt_options.ignoreHidden !== undefined) {
    this.ignoreHidden_ = opt_options.ignoreHidden;
  }
  this.enableRetinaIcons_ = false;
  if (opt_options.enableRetinaIcons !== undefined) {
    this.enableRetinaIcons_ = opt_options.enableRetinaIcons;
  }
  this.imagePath_ = opt_options.imagePath || MarkerClusterer.IMAGE_PATH;
  this.imageExtension_ = opt_options.imageExtension || MarkerClusterer.IMAGE_EXTENSION;
  this.imageSizes_ = opt_options.imageSizes || MarkerClusterer.IMAGE_SIZES;
  this.calculator_ = opt_options.calculator || MarkerClusterer.CALCULATOR;
  this.batchSize_ = opt_options.batchSize || MarkerClusterer.BATCH_SIZE;
  this.batchSizeIE_ = opt_options.batchSizeIE || MarkerClusterer.BATCH_SIZE_IE;
  this.clusterClass_ = opt_options.clusterClass || "cluster";

  if (navigator.userAgent.toLowerCase().indexOf("msie") !== -1) {
    // Try to avoid IE timeout when processing a huge number of markers:
    this.batchSize_ = this.batchSizeIE_;
  }

  this.setupStyles_();

  this.addMarkers(opt_markers, true);
  this.setMap(map); // Note: this causes onAdd to be called
}


/**
 * Implementation of the onAdd interface method.
 * @ignore
 */
MarkerClusterer.prototype.onAdd = function () {
  var cMarkerClusterer = this;

  this.activeMap_ = this.getMap();
  this.ready_ = true;

  this.repaint();

  // Add the map event listeners
  this.listeners_ = [
    google.maps.event.addListener(this.getMap(), "zoom_changed", function () {
      cMarkerClusterer.resetViewport_(false);
      // Workaround for this Google bug: when map is at level 0 and "-" of
      // zoom slider is clicked, a "zoom_changed" event is fired even though
      // the map doesn't zoom out any further. In this situation, no "idle"
      // event is triggered so the cluster markers that have been removed
      // do not get redrawn. Same goes for a zoom in at maxZoom.
      if (this.getZoom() === (this.get("minZoom") || 0) || this.getZoom() === this.get("maxZoom")) {
        google.maps.event.trigger(this, "idle");
      }
    }),
    google.maps.event.addListener(this.getMap(), "idle", function () {
      cMarkerClusterer.redraw_();
    })
  ];
};


/**
 * Implementation of the onRemove interface method.
 * Removes map event listeners and all cluster icons from the DOM.
 * All managed markers are also put back on the map.
 * @ignore
 */
MarkerClusterer.prototype.onRemove = function () {
  var i;

  // Put all the managed markers back on the map:
  for (i = 0; i < this.markers_.length; i++) {
    if (this.markers_[i].getMap() !== this.activeMap_) {
      this.markers_[i].setMap(this.activeMap_);
    }
  }

  // Remove all clusters:
  for (i = 0; i < this.clusters_.length; i++) {
    this.clusters_[i].remove();
  }
  this.clusters_ = [];

  // Remove map event listeners:
  for (i = 0; i < this.listeners_.length; i++) {
    google.maps.event.removeListener(this.listeners_[i]);
  }
  this.listeners_ = [];

  this.activeMap_ = null;
  this.ready_ = false;
};


/**
 * Implementation of the draw interface method.
 * @ignore
 */
MarkerClusterer.prototype.draw = function () {};


/**
 * Sets up the styles object.
 */
MarkerClusterer.prototype.setupStyles_ = function () {
  var i, size;
  if (this.styles_.length > 0) {
    return;
  }

  for (i = 0; i < this.imageSizes_.length; i++) {
    size = this.imageSizes_[i];
    this.styles_.push({
      url: this.imagePath_ + (i + 1) + "." + this.imageExtension_,
      height: size,
      width: size
    });
  }
};


/**
 *  Fits the map to the bounds of the markers managed by the clusterer.
 */
MarkerClusterer.prototype.fitMapToMarkers = function () {
  var i;
  var markers = this.getMarkers();
  var bounds = new google.maps.LatLngBounds();
  for (i = 0; i < markers.length; i++) {
    bounds.extend(markers[i].getPosition());
  }

  this.getMap().fitBounds(bounds);
};


/**
 * Returns the value of the <code>gridSize</code> property.
 *
 * @return {number} The grid size.
 */
MarkerClusterer.prototype.getGridSize = function () {
  return this.gridSize_;
};


/**
 * Sets the value of the <code>gridSize</code> property.
 *
 * @param {number} gridSize The grid size.
 */
MarkerClusterer.prototype.setGridSize = function (gridSize) {
  this.gridSize_ = gridSize;
};


/**
 * Returns the value of the <code>minimumClusterSize</code> property.
 *
 * @return {number} The minimum cluster size.
 */
MarkerClusterer.prototype.getMinimumClusterSize = function () {
  return this.minClusterSize_;
};

/**
 * Sets the value of the <code>minimumClusterSize</code> property.
 *
 * @param {number} minimumClusterSize The minimum cluster size.
 */
MarkerClusterer.prototype.setMinimumClusterSize = function (minimumClusterSize) {
  this.minClusterSize_ = minimumClusterSize;
};


/**
 *  Returns the value of the <code>maxZoom</code> property.
 *
 *  @return {number} The maximum zoom level.
 */
MarkerClusterer.prototype.getMaxZoom = function () {
  return this.maxZoom_;
};


/**
 *  Sets the value of the <code>maxZoom</code> property.
 *
 *  @param {number} maxZoom The maximum zoom level.
 */
MarkerClusterer.prototype.setMaxZoom = function (maxZoom) {
  this.maxZoom_ = maxZoom;
};


/**
 *  Returns the value of the <code>styles</code> property.
 *
 *  @return {Array} The array of styles defining the cluster markers to be used.
 */
MarkerClusterer.prototype.getStyles = function () {
  return this.styles_;
};


/**
 *  Sets the value of the <code>styles</code> property.
 *
 *  @param {Array.<ClusterIconStyle>} styles The array of styles to use.
 */
MarkerClusterer.prototype.setStyles = function (styles) {
  this.styles_ = styles;
};


/**
 * Returns the value of the <code>title</code> property.
 *
 * @return {string} The content of the title text.
 */
MarkerClusterer.prototype.getTitle = function () {
  return this.title_;
};


/**
 *  Sets the value of the <code>title</code> property.
 *
 *  @param {string} title The value of the title property.
 */
MarkerClusterer.prototype.setTitle = function (title) {
  this.title_ = title;
};


/**
 * Returns the value of the <code>zoomOnClick</code> property.
 *
 * @return {boolean} True if zoomOnClick property is set.
 */
MarkerClusterer.prototype.getZoomOnClick = function () {
  return this.zoomOnClick_;
};


/**
 *  Sets the value of the <code>zoomOnClick</code> property.
 *
 *  @param {boolean} zoomOnClick The value of the zoomOnClick property.
 */
MarkerClusterer.prototype.setZoomOnClick = function (zoomOnClick) {
  this.zoomOnClick_ = zoomOnClick;
};


/**
 * Returns the value of the <code>averageCenter</code> property.
 *
 * @return {boolean} True if averageCenter property is set.
 */
MarkerClusterer.prototype.getAverageCenter = function () {
  return this.averageCenter_;
};


/**
 *  Sets the value of the <code>averageCenter</code> property.
 *
 *  @param {boolean} averageCenter The value of the averageCenter property.
 */
MarkerClusterer.prototype.setAverageCenter = function (averageCenter) {
  this.averageCenter_ = averageCenter;
};


/**
 * Returns the value of the <code>ignoreHidden</code> property.
 *
 * @return {boolean} True if ignoreHidden property is set.
 */
MarkerClusterer.prototype.getIgnoreHidden = function () {
  return this.ignoreHidden_;
};


/**
 *  Sets the value of the <code>ignoreHidden</code> property.
 *
 *  @param {boolean} ignoreHidden The value of the ignoreHidden property.
 */
MarkerClusterer.prototype.setIgnoreHidden = function (ignoreHidden) {
  this.ignoreHidden_ = ignoreHidden;
};


/**
 * Returns the value of the <code>enableRetinaIcons</code> property.
 *
 * @return {boolean} True if enableRetinaIcons property is set.
 */
MarkerClusterer.prototype.getEnableRetinaIcons = function () {
  return this.enableRetinaIcons_;
};


/**
 *  Sets the value of the <code>enableRetinaIcons</code> property.
 *
 *  @param {boolean} enableRetinaIcons The value of the enableRetinaIcons property.
 */
MarkerClusterer.prototype.setEnableRetinaIcons = function (enableRetinaIcons) {
  this.enableRetinaIcons_ = enableRetinaIcons;
};


/**
 * Returns the value of the <code>imageExtension</code> property.
 *
 * @return {string} The value of the imageExtension property.
 */
MarkerClusterer.prototype.getImageExtension = function () {
  return this.imageExtension_;
};


/**
 *  Sets the value of the <code>imageExtension</code> property.
 *
 *  @param {string} imageExtension The value of the imageExtension property.
 */
MarkerClusterer.prototype.setImageExtension = function (imageExtension) {
  this.imageExtension_ = imageExtension;
};


/**
 * Returns the value of the <code>imagePath</code> property.
 *
 * @return {string} The value of the imagePath property.
 */
MarkerClusterer.prototype.getImagePath = function () {
  return this.imagePath_;
};


/**
 *  Sets the value of the <code>imagePath</code> property.
 *
 *  @param {string} imagePath The value of the imagePath property.
 */
MarkerClusterer.prototype.setImagePath = function (imagePath) {
  this.imagePath_ = imagePath;
};


/**
 * Returns the value of the <code>imageSizes</code> property.
 *
 * @return {Array} The value of the imageSizes property.
 */
MarkerClusterer.prototype.getImageSizes = function () {
  return this.imageSizes_;
};


/**
 *  Sets the value of the <code>imageSizes</code> property.
 *
 *  @param {Array} imageSizes The value of the imageSizes property.
 */
MarkerClusterer.prototype.setImageSizes = function (imageSizes) {
  this.imageSizes_ = imageSizes;
};


/**
 * Returns the value of the <code>calculator</code> property.
 *
 * @return {function} the value of the calculator property.
 */
MarkerClusterer.prototype.getCalculator = function () {
  return this.calculator_;
};


/**
 * Sets the value of the <code>calculator</code> property.
 *
 * @param {function(Array.<google.maps.Marker>, number)} calculator The value
 *  of the calculator property.
 */
MarkerClusterer.prototype.setCalculator = function (calculator) {
  this.calculator_ = calculator;
};


/**
 * Returns the value of the <code>batchSizeIE</code> property.
 *
 * @return {number} the value of the batchSizeIE property.
 */
MarkerClusterer.prototype.getBatchSizeIE = function () {
  return this.batchSizeIE_;
};


/**
 * Sets the value of the <code>batchSizeIE</code> property.
 *
 *  @param {number} batchSizeIE The value of the batchSizeIE property.
 */
MarkerClusterer.prototype.setBatchSizeIE = function (batchSizeIE) {
  this.batchSizeIE_ = batchSizeIE;
};


/**
 * Returns the value of the <code>clusterClass</code> property.
 *
 * @return {string} the value of the clusterClass property.
 */
MarkerClusterer.prototype.getClusterClass = function () {
  return this.clusterClass_;
};


/**
 * Sets the value of the <code>clusterClass</code> property.
 *
 *  @param {string} clusterClass The value of the clusterClass property.
 */
MarkerClusterer.prototype.setClusterClass = function (clusterClass) {
  this.clusterClass_ = clusterClass;
};


/**
 *  Returns the array of markers managed by the clusterer.
 *
 *  @return {Array} The array of markers managed by the clusterer.
 */
MarkerClusterer.prototype.getMarkers = function () {
  return this.markers_;
};


/**
 *  Returns the number of markers managed by the clusterer.
 *
 *  @return {number} The number of markers.
 */
MarkerClusterer.prototype.getTotalMarkers = function () {
  return this.markers_.length;
};


/**
 * Returns the current array of clusters formed by the clusterer.
 *
 * @return {Array} The array of clusters formed by the clusterer.
 */
MarkerClusterer.prototype.getClusters = function () {
  return this.clusters_;
};


/**
 * Returns the number of clusters formed by the clusterer.
 *
 * @return {number} The number of clusters formed by the clusterer.
 */
MarkerClusterer.prototype.getTotalClusters = function () {
  return this.clusters_.length;
};


/**
 * Adds a marker to the clusterer. The clusters are redrawn unless
 *  <code>opt_nodraw</code> is set to <code>true</code>.
 *
 * @param {google.maps.Marker} marker The marker to add.
 * @param {boolean} [opt_nodraw] Set to <code>true</code> to prevent redrawing.
 */
MarkerClusterer.prototype.addMarker = function (marker, opt_nodraw) {
  this.pushMarkerTo_(marker);
  if (!opt_nodraw) {
    this.redraw_();
  }
};


/**
 * Adds an array of markers to the clusterer. The clusters are redrawn unless
 *  <code>opt_nodraw</code> is set to <code>true</code>.
 *
 * @param {Array.<google.maps.Marker>} markers The markers to add.
 * @param {boolean} [opt_nodraw] Set to <code>true</code> to prevent redrawing.
 */
MarkerClusterer.prototype.addMarkers = function (markers, opt_nodraw) {
  var key;
  for (key in markers) {
    if (markers.hasOwnProperty(key)) {
      this.pushMarkerTo_(markers[key]);
    }
  }  
  if (!opt_nodraw) {
    this.redraw_();
  }
};


/**
 * Pushes a marker to the clusterer.
 *
 * @param {google.maps.Marker} marker The marker to add.
 */
MarkerClusterer.prototype.pushMarkerTo_ = function (marker) {
  // If the marker is draggable add a listener so we can update the clusters on the dragend:
  if (marker.getDraggable()) {
    var cMarkerClusterer = this;
    google.maps.event.addListener(marker, "dragend", function () {
      if (cMarkerClusterer.ready_) {
        this.isAdded = false;
        cMarkerClusterer.repaint();
      }
    });
  }
  marker.isAdded = false;
  this.markers_.push(marker);
};


/**
 * Removes a marker from the cluster.  The clusters are redrawn unless
 *  <code>opt_nodraw</code> is set to <code>true</code>. Returns <code>true</code> if the
 *  marker was removed from the clusterer.
 *
 * @param {google.maps.Marker} marker The marker to remove.
 * @param {boolean} [opt_nodraw] Set to <code>true</code> to prevent redrawing.
 * @return {boolean} True if the marker was removed from the clusterer.
 */
MarkerClusterer.prototype.removeMarker = function (marker, opt_nodraw) {
  var removed = this.removeMarker_(marker);

  if (!opt_nodraw && removed) {
    this.repaint();
  }

  return removed;
};


/**
 * Removes an array of markers from the cluster. The clusters are redrawn unless
 *  <code>opt_nodraw</code> is set to <code>true</code>. Returns <code>true</code> if markers
 *  were removed from the clusterer.
 *
 * @param {Array.<google.maps.Marker>} markers The markers to remove.
 * @param {boolean} [opt_nodraw] Set to <code>true</code> to prevent redrawing.
 * @return {boolean} True if markers were removed from the clusterer.
 */
MarkerClusterer.prototype.removeMarkers = function (markers, opt_nodraw) {
  var i, r;
  var removed = false;

  for (i = 0; i < markers.length; i++) {
    r = this.removeMarker_(markers[i]);
    removed = removed || r;
  }

  if (!opt_nodraw && removed) {
    this.repaint();
  }

  return removed;
};


/**
 * Removes a marker and returns true if removed, false if not.
 *
 * @param {google.maps.Marker} marker The marker to remove
 * @return {boolean} Whether the marker was removed or not
 */
MarkerClusterer.prototype.removeMarker_ = function (marker) {
  var i;
  var index = -1;
  if (this.markers_.indexOf) {
    index = this.markers_.indexOf(marker);
  } else {
    for (i = 0; i < this.markers_.length; i++) {
      if (marker === this.markers_[i]) {
        index = i;
        break;
      }
    }
  }

  if (index === -1) {
    // Marker is not in our list of markers, so do nothing:
    return false;
  }

  marker.setMap(null);
  this.markers_.splice(index, 1); // Remove the marker from the list of managed markers
  return true;
};


/**
 * Removes all clusters and markers from the map and also removes all markers
 *  managed by the clusterer.
 */
MarkerClusterer.prototype.clearMarkers = function () {
  this.resetViewport_(true);
  this.markers_ = [];
};


/**
 * Recalculates and redraws all the marker clusters from scratch.
 *  Call this after changing any properties.
 */
MarkerClusterer.prototype.repaint = function () {
  var oldClusters = this.clusters_.slice();
  this.clusters_ = [];
  this.resetViewport_(false);
  this.redraw_();

  // Remove the old clusters.
  // Do it in a timeout to prevent blinking effect.
  setTimeout(function () {
    var i;
    for (i = 0; i < oldClusters.length; i++) {
      oldClusters[i].remove();
    }
  }, 0);
};


/**
 * Returns the current bounds extended by the grid size.
 *
 * @param {google.maps.LatLngBounds} bounds The bounds to extend.
 * @return {google.maps.LatLngBounds} The extended bounds.
 * @ignore
 */
MarkerClusterer.prototype.getExtendedBounds = function (bounds) {
  var projection = this.getProjection();

  // Turn the bounds into latlng.
  var tr = new google.maps.LatLng(bounds.getNorthEast().lat(),
      bounds.getNorthEast().lng());
  var bl = new google.maps.LatLng(bounds.getSouthWest().lat(),
      bounds.getSouthWest().lng());

  // Convert the points to pixels and the extend out by the grid size.
  var trPix = projection.fromLatLngToDivPixel(tr);
  trPix.x += this.gridSize_;
  trPix.y -= this.gridSize_;

  var blPix = projection.fromLatLngToDivPixel(bl);
  blPix.x -= this.gridSize_;
  blPix.y += this.gridSize_;

  // Convert the pixel points back to LatLng
  var ne = projection.fromDivPixelToLatLng(trPix);
  var sw = projection.fromDivPixelToLatLng(blPix);

  // Extend the bounds to contain the new bounds.
  bounds.extend(ne);
  bounds.extend(sw);

  return bounds;
};


/**
 * Redraws all the clusters.
 */
MarkerClusterer.prototype.redraw_ = function () {
  this.createClusters_(0);
};


/**
 * Removes all clusters from the map. The markers are also removed from the map
 *  if <code>opt_hide</code> is set to <code>true</code>.
 *
 * @param {boolean} [opt_hide] Set to <code>true</code> to also remove the markers
 *  from the map.
 */
MarkerClusterer.prototype.resetViewport_ = function (opt_hide) {
  var i, marker;
  // Remove all the clusters
  for (i = 0; i < this.clusters_.length; i++) {
    this.clusters_[i].remove();
  }
  this.clusters_ = [];

  // Reset the markers to not be added and to be removed from the map.
  for (i = 0; i < this.markers_.length; i++) {
    marker = this.markers_[i];
    marker.isAdded = false;
    if (opt_hide) {
      marker.setMap(null);
    }
  }
};


/**
 * Calculates the distance between two latlng locations in km.
 *
 * @param {google.maps.LatLng} p1 The first lat lng point.
 * @param {google.maps.LatLng} p2 The second lat lng point.
 * @return {number} The distance between the two points in km.
 * @see http://www.movable-type.co.uk/scripts/latlong.html
*/
MarkerClusterer.prototype.distanceBetweenPoints_ = function (p1, p2) {
  var R = 6371; // Radius of the Earth in km
  var dLat = (p2.lat() - p1.lat()) * Math.PI / 180;
  var dLon = (p2.lng() - p1.lng()) * Math.PI / 180;
  var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(p1.lat() * Math.PI / 180) * Math.cos(p2.lat() * Math.PI / 180) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c;
  return d;
};


/**
 * Determines if a marker is contained in a bounds.
 *
 * @param {google.maps.Marker} marker The marker to check.
 * @param {google.maps.LatLngBounds} bounds The bounds to check against.
 * @return {boolean} True if the marker is in the bounds.
 */
MarkerClusterer.prototype.isMarkerInBounds_ = function (marker, bounds) {
  return bounds.contains(marker.getPosition());
};


/**
 * Adds a marker to a cluster, or creates a new cluster.
 *
 * @param {google.maps.Marker} marker The marker to add.
 */
MarkerClusterer.prototype.addToClosestCluster_ = function (marker) {
  var i, d, cluster, center;
  var distance = 40000; // Some large number
  var clusterToAddTo = null;
  for (i = 0; i < this.clusters_.length; i++) {
    cluster = this.clusters_[i];
    center = cluster.getCenter();
    if (center) {
      d = this.distanceBetweenPoints_(center, marker.getPosition());
      if (d < distance) {
        distance = d;
        clusterToAddTo = cluster;
      }
    }
  }

  if (clusterToAddTo && clusterToAddTo.isMarkerInClusterBounds(marker)) {
    clusterToAddTo.addMarker(marker);
  } else {
    cluster = new Cluster(this);
    cluster.addMarker(marker);
    this.clusters_.push(cluster);
  }
};


/**
 * Creates the clusters. This is done in batches to avoid timeout errors
 *  in some browsers when there is a huge number of markers.
 *
 * @param {number} iFirst The index of the first marker in the batch of
 *  markers to be added to clusters.
 */
MarkerClusterer.prototype.createClusters_ = function (iFirst) {
  var i, marker;
  var mapBounds;
  var cMarkerClusterer = this;
  if (!this.ready_) {
    return;
  }

  // Cancel previous batch processing if we're working on the first batch:
  if (iFirst === 0) {
    /**
     * This event is fired when the <code>MarkerClusterer</code> begins
     *  clustering markers.
     * @name MarkerClusterer#clusteringbegin
     * @param {MarkerClusterer} mc The MarkerClusterer whose markers are being clustered.
     * @event
     */
    google.maps.event.trigger(this, "clusteringbegin", this);

    if (typeof this.timerRefStatic !== "undefined") {
      clearTimeout(this.timerRefStatic);
      delete this.timerRefStatic;
    }
  }

  // Get our current map view bounds.
  // Create a new bounds object so we don't affect the map.
  //
  // See Comments 9 & 11 on Issue 3651 relating to this workaround for a Google Maps bug:
  if (this.getMap().getZoom() > 3) {
    mapBounds = new google.maps.LatLngBounds(this.getMap().getBounds().getSouthWest(),
      this.getMap().getBounds().getNorthEast());
  } else {
    mapBounds = new google.maps.LatLngBounds(new google.maps.LatLng(85.02070771743472, -178.48388434375), new google.maps.LatLng(-85.08136444384544, 178.00048865625));
  }
  var bounds = this.getExtendedBounds(mapBounds);

  var iLast = Math.min(iFirst + this.batchSize_, this.markers_.length);

  for (i = iFirst; i < iLast; i++) {
    marker = this.markers_[i];
    if (!marker.isAdded && this.isMarkerInBounds_(marker, bounds)) {
      if (!this.ignoreHidden_ || (this.ignoreHidden_ && marker.getVisible())) {
        this.addToClosestCluster_(marker);
      }
    }
  }

  if (iLast < this.markers_.length) {
    this.timerRefStatic = setTimeout(function () {
      cMarkerClusterer.createClusters_(iLast);
    }, 0);
  } else {
    delete this.timerRefStatic;

    /**
     * This event is fired when the <code>MarkerClusterer</code> stops
     *  clustering markers.
     * @name MarkerClusterer#clusteringend
     * @param {MarkerClusterer} mc The MarkerClusterer whose markers are being clustered.
     * @event
     */
    google.maps.event.trigger(this, "clusteringend", this);
  }
};


/**
 * Extends an object's prototype by another's.
 *
 * @param {Object} obj1 The object to be extended.
 * @param {Object} obj2 The object to extend with.
 * @return {Object} The new extended object.
 * @ignore
 */
MarkerClusterer.prototype.extend = function (obj1, obj2) {
  return (function (object) {
    var property;
    for (property in object.prototype) {
      this.prototype[property] = object.prototype[property];
    }
    return this;
  }).apply(obj1, [obj2]);
};


/**
 * The default function for determining the label text and style
 * for a cluster icon.
 *
 * @param {Array.<google.maps.Marker>} markers The array of markers represented by the cluster.
 * @param {number} numStyles The number of marker styles available.
 * @return {ClusterIconInfo} The information resource for the cluster.
 * @constant
 * @ignore
 */
MarkerClusterer.CALCULATOR = function (markers, numStyles) {
  var index = 0;
  var title = "";
  var count = markers.length.toString();

  var dv = count;
  while (dv !== 0) {
    dv = parseInt(dv / 10, 10);
    index++;
  }

  index = Math.min(index, numStyles);
  return {
    text: count,
    index: index,
    title: title
  };
};


/**
 * The number of markers to process in one batch.
 *
 * @type {number}
 * @constant
 */
MarkerClusterer.BATCH_SIZE = 2000;


/**
 * The number of markers to process in one batch (IE only).
 *
 * @type {number}
 * @constant
 */
MarkerClusterer.BATCH_SIZE_IE = 500;


/**
 * The default root name for the marker cluster images.
 *
 * @type {string}
 * @constant
 */
MarkerClusterer.IMAGE_PATH = "https://raw.githubusercontent.com/googlemaps/v3-utility-library/master/markerclustererplus/images/m";


/**
 * The default extension name for the marker cluster images.
 *
 * @type {string}
 * @constant
 */
MarkerClusterer.IMAGE_EXTENSION = "png";


/**
 * The default array of sizes for the marker cluster images.
 *
 * @type {Array.<number>}
 * @constant
 */
MarkerClusterer.IMAGE_SIZES = [53, 56, 66, 78, 90];

module.exports = MarkerClusterer

},{}],727:[function(require,module,exports){
//! moment.js
//! version : 2.27.0
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key;
                for (i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i;
            for (i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (
                    matched,
                    p1,
                    p2,
                    p3,
                    p4
                ) {
                    return p1 || p2 || p3 || p4;
                })
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split(
            '_'
        ),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            typeof module !== 'undefined' &&
            module &&
            module.exports
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                aliasedRequire('./locale/' + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^)]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged and will be removed in an upcoming major release. Please refer to ' +
            'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (
        input,
        array,
        config,
        token
    ) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) {
            getParsingFlags(config).era = era;
        } else {
            getParsingFlags(config).invalidEra = input;
        }
    });

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.27.0';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));

},{}],728:[function(require,module,exports){
/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}

},{}],729:[function(require,module,exports){
/**
 * Compiles a querystring
 * Returns string representation of the object
 *
 * @param {Object}
 * @api private
 */

exports.encode = function (obj) {
  var str = '';

  for (var i in obj) {
    if (obj.hasOwnProperty(i)) {
      if (str.length) str += '&';
      str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
    }
  }

  return str;
};

/**
 * Parses a simple querystring into an object
 *
 * @param {String} qs
 * @api private
 */

exports.decode = function(qs){
  var qry = {};
  var pairs = qs.split('&');
  for (var i = 0, l = pairs.length; i < l; i++) {
    var pair = pairs[i].split('=');
    qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
  }
  return qry;
};

},{}],730:[function(require,module,exports){
/**
 * Parses an URI
 *
 * @author Steven Levithan <stevenlevithan.com> (MIT license)
 * @api private
 */

var re = /^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;

var parts = [
    'source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'
];

module.exports = function parseuri(str) {
    var src = str,
        b = str.indexOf('['),
        e = str.indexOf(']');

    if (b != -1 && e != -1) {
        str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
    }

    var m = re.exec(str || ''),
        uri = {},
        i = 14;

    while (i--) {
        uri[parts[i]] = m[i] || '';
    }

    if (b != -1 && e != -1) {
        uri.source = src;
        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
        uri.ipv6uri = true;
    }

    return uri;
};

},{}],731:[function(require,module,exports){
var n=require("preact/hooks"),t=require("preact");function e(n,t){for(var e in t)n[e]=t[e];return n}function r(n,t){for(var e in n)if("__source"!==e&&!(e in t))return!0;for(var r in t)if("__source"!==r&&n[r]!==t[r])return!0;return!1}function u(n){this.props=n}function o(n,e){function u(n){var t=this.props.ref,u=t==n.ref;return!u&&t&&(t.call?t(null):t.current=null),e?!e(this.props,n)||!u:r(this.props,n)}function o(e){return this.shouldComponentUpdate=u,t.createElement(n,e)}return o.displayName="Memo("+(n.displayName||n.name)+")",o.prototype.isReactComponent=!0,o.__f=!0,o}(u.prototype=new t.Component).isPureReactComponent=!0,u.prototype.shouldComponentUpdate=function(n,t){return r(this.props,n)||r(this.state,t)};var i=t.options.__b;t.options.__b=function(n){n.type&&n.type.__f&&n.ref&&(n.props.ref=n.ref,n.ref=null),i&&i(n)};var l="undefined"!=typeof Symbol&&Symbol.for&&Symbol.for("react.forward_ref")||3911;function c(n){function t(t,r){var u=e({},t);return delete u.ref,n(u,(r=t.ref||r)&&("object"!=typeof r||"current"in r)?r:null)}return t.$$typeof=l,t.render=t,t.prototype.isReactComponent=t.__f=!0,t.displayName="ForwardRef("+(n.displayName||n.name)+")",t}var f=function(n,e){return null==n?null:t.toChildArray(t.toChildArray(n).map(e))},a={map:f,forEach:f,count:function(n){return n?t.toChildArray(n).length:0},only:function(n){var e=t.toChildArray(n);if(1!==e.length)throw"Children.only";return e[0]},toArray:t.toChildArray},s=t.options.__e;t.options.__e=function(n,t,e){if(n.then)for(var r,u=t;u=u.__;)if((r=u.__c)&&r.__c)return null==t.__e&&(t.__e=e.__e,t.__k=e.__k),r.__c(n,t);s(n,t,e)};var p=t.options.unmount;function h(){this.__u=0,this.t=null,this.__b=null}function v(n){var t=n.__.__c;return t&&t.__e&&t.__e(n)}function d(n){var e,r,u;function o(o){if(e||(e=n()).then(function(n){r=n.default||n},function(n){u=n}),u)throw u;if(!r)throw e;return t.createElement(r,o)}return o.displayName="Lazy",o.__f=!0,o}function x(){this.u=null,this.o=null}t.options.unmount=function(n){var t=n.__c;t&&t.__R&&t.__R(),t&&!0===n.__h&&(n.type=null),p&&p(n)},(h.prototype=new t.Component).__c=function(n,t){var e=t.__c,r=this;null==r.t&&(r.t=[]),r.t.push(e);var u=v(r.__v),o=!1,i=function(){o||(o=!0,e.__R=null,u?u(l):l())};e.__R=i;var l=function(){if(!--r.__u){if(r.state.__e){var n=r.state.__e;r.__v.__k[0]=function n(t,e,r){return t&&(t.__v=null,t.__k=t.__k&&t.__k.map(function(t){return n(t,e,r)}),t.__c&&t.__c.__P===e&&(t.__e&&r.insertBefore(t.__e,t.__d),t.__c.__e=!0,t.__c.__P=r)),t}(n,n.__c.__P,n.__c.__O)}var t;for(r.setState({__e:r.__b=null});t=r.t.pop();)t.forceUpdate()}},c=!0===t.__h;r.__u++||c||r.setState({__e:r.__b=r.__v.__k[0]}),n.then(i,i)},h.prototype.componentWillUnmount=function(){this.t=[]},h.prototype.render=function(n,r){if(this.__b){if(this.__v.__k){var u=document.createElement("div"),o=this.__v.__k[0].__c;this.__v.__k[0]=function n(t,r,u){return t&&(t.__c&&t.__c.__H&&(t.__c.__H.__.forEach(function(n){"function"==typeof n.__c&&n.__c()}),t.__c.__H=null),null!=(t=e({},t)).__c&&(t.__c.__P===u&&(t.__c.__P=r),t.__c=null),t.__k=t.__k&&t.__k.map(function(t){return n(t,r,u)})),t}(this.__b,u,o.__O=o.__P)}this.__b=null}var i=r.__e&&t.createElement(t.Fragment,null,n.fallback);return i&&(i.__h=null),[t.createElement(t.Fragment,null,r.__e?null:n.children),i]};var m=function(n,t,e){if(++e[1]===e[0]&&n.o.delete(t),n.props.revealOrder&&("t"!==n.props.revealOrder[0]||!n.o.size))for(e=n.u;e;){for(;e.length>3;)e.pop()();if(e[1]<e[0])break;n.u=e=e[2]}};function y(n){return this.getChildContext=function(){return n.context},n.children}function b(n){var e=this,r=n.i;e.componentWillUnmount=function(){t.render(null,e.l),e.l=null,e.i=null},e.i&&e.i!==r&&e.componentWillUnmount(),n.__v?(e.l||(e.i=r,e.l={nodeType:1,parentNode:r,childNodes:[],appendChild:function(n){this.childNodes.push(n),e.i.appendChild(n)},insertBefore:function(n,t){this.childNodes.push(n),e.i.appendChild(n)},removeChild:function(n){this.childNodes.splice(this.childNodes.indexOf(n)>>>1,1),e.i.removeChild(n)}}),t.render(t.createElement(y,{context:e.context},n.__v),e.l)):e.l&&e.componentWillUnmount()}function _(n,e){return t.createElement(b,{__v:n,i:e})}(x.prototype=new t.Component).__e=function(n){var t=this,e=v(t.__v),r=t.o.get(n);return r[0]++,function(u){var o=function(){t.props.revealOrder?(r.push(u),m(t,n,r)):u()};e?e(o):o()}},x.prototype.render=function(n){this.u=null,this.o=new Map;var e=t.toChildArray(n.children);n.revealOrder&&"b"===n.revealOrder[0]&&e.reverse();for(var r=e.length;r--;)this.o.set(e[r],this.u=[1,0,this.u]);return n.children},x.prototype.componentDidUpdate=x.prototype.componentDidMount=function(){var n=this;this.o.forEach(function(t,e){m(n,e,t)})};var S="undefined"!=typeof Symbol&&Symbol.for&&Symbol.for("react.element")||60103,w=/^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|fill|flood|font|glyph(?!R)|horiz|marker(?!H|W|U)|overline|paint|stop|strikethrough|stroke|text(?!L)|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/,C=function(n){return("undefined"!=typeof Symbol&&"symbol"==typeof Symbol()?/fil|che|rad/i:/fil|che|ra/i).test(n)};function g(n,e,r){return null==e.__k&&(e.textContent=""),t.render(n,e),"function"==typeof r&&r(),n?n.__c:null}function E(n,e,r){return t.hydrate(n,e),"function"==typeof r&&r(),n?n.__c:null}t.Component.prototype.isReactComponent={},["componentWillMount","componentWillReceiveProps","componentWillUpdate"].forEach(function(n){Object.defineProperty(t.Component.prototype,n,{configurable:!0,get:function(){return this["UNSAFE_"+n]},set:function(t){Object.defineProperty(this,n,{configurable:!0,writable:!0,value:t})}})});var R=t.options.event;function N(){}function O(){return this.cancelBubble}function k(){return this.defaultPrevented}t.options.event=function(n){return R&&(n=R(n)),n.persist=N,n.isPropagationStopped=O,n.isDefaultPrevented=k,n.nativeEvent=n};var A,L={configurable:!0,get:function(){return this.class}},U=t.options.vnode;t.options.vnode=function(n){var e=n.type,r=n.props,u=r;if("string"==typeof e){for(var o in u={},r){var i=r[o];"value"===o&&"defaultValue"in r&&null==i||("defaultValue"===o&&"value"in r&&null==r.value?o="value":"download"===o&&!0===i?i="":/ondoubleclick/i.test(o)?o="ondblclick":/^onchange(textarea|input)/i.test(o+e)&&!C(r.type)?o="oninput":/^on(Ani|Tra|Tou|BeforeInp)/.test(o)?o=o.toLowerCase():w.test(o)?o=o.replace(/[A-Z0-9]/,"-$&").toLowerCase():null===i&&(i=void 0),u[o]=i)}"select"==e&&u.multiple&&Array.isArray(u.value)&&(u.value=t.toChildArray(r.children).forEach(function(n){n.props.selected=-1!=u.value.indexOf(n.props.value)})),"select"==e&&null!=u.defaultValue&&(u.value=t.toChildArray(r.children).forEach(function(n){n.props.selected=u.multiple?-1!=u.defaultValue.indexOf(n.props.value):u.defaultValue==n.props.value})),n.props=u}e&&r.class!=r.className&&(L.enumerable="className"in r,null!=r.className&&(u.class=r.className),Object.defineProperty(u,"className",L)),n.$$typeof=S,U&&U(n)};var M=t.options.__r;t.options.__r=function(n){M&&M(n),A=n.__c};var T={ReactCurrentDispatcher:{current:{readContext:function(n){return A.__n[n.__c].props.value}}}};function j(n){return t.createElement.bind(null,n)}function D(n){return!!n&&n.$$typeof===S}function F(n){return D(n)?t.cloneElement.apply(null,arguments):n}function I(n){return!!n.__k&&(t.render(null,n),!0)}function W(n){return n&&(n.base||1===n.nodeType&&n)||null}var P=function(n,t){return n(t)},V=function(n,t){return n(t)},z=t.Fragment,B={useState:n.useState,useReducer:n.useReducer,useEffect:n.useEffect,useLayoutEffect:n.useLayoutEffect,useRef:n.useRef,useImperativeHandle:n.useImperativeHandle,useMemo:n.useMemo,useCallback:n.useCallback,useContext:n.useContext,useDebugValue:n.useDebugValue,version:"17.0.2",Children:a,render:g,hydrate:E,unmountComponentAtNode:I,createPortal:_,createElement:t.createElement,createContext:t.createContext,createFactory:j,cloneElement:F,createRef:t.createRef,Fragment:t.Fragment,isValidElement:D,findDOMNode:W,Component:t.Component,PureComponent:u,memo:o,forwardRef:c,flushSync:V,unstable_batchedUpdates:P,StrictMode:z,Suspense:h,SuspenseList:x,lazy:d,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:T};Object.keys(n).forEach(function(t){exports[t]=n[t]}),exports.createElement=t.createElement,exports.createContext=t.createContext,exports.createRef=t.createRef,exports.Fragment=t.Fragment,exports.Component=t.Component,exports.version="17.0.2",exports.Children=a,exports.render=g,exports.hydrate=E,exports.unmountComponentAtNode=I,exports.createPortal=_,exports.createFactory=j,exports.cloneElement=F,exports.isValidElement=D,exports.findDOMNode=W,exports.PureComponent=u,exports.memo=o,exports.forwardRef=c,exports.flushSync=V,exports.unstable_batchedUpdates=P,exports.StrictMode=z,exports.Suspense=h,exports.SuspenseList=x,exports.lazy=d,exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=T,exports.default=B;


},{"preact":732,"preact/hooks":733}],732:[function(require,module,exports){
var n,l,u,t,i,o,r,f,e={},c=[],s=/acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;function a(n,l){for(var u in l)n[u]=l[u];return n}function p(n){var l=n.parentNode;l&&l.removeChild(n)}function v(l,u,t){var i,o,r,f={};for(r in u)"key"==r?i=u[r]:"ref"==r?o=u[r]:f[r]=u[r];if(arguments.length>2&&(f.children=arguments.length>3?n.call(arguments,2):t),"function"==typeof l&&null!=l.defaultProps)for(r in l.defaultProps)void 0===f[r]&&(f[r]=l.defaultProps[r]);return h(l,f,i,o,null)}function h(n,t,i,o,r){var f={type:n,props:t,key:i,ref:o,__k:null,__:null,__b:0,__e:null,__d:void 0,__c:null,__h:null,constructor:void 0,__v:null==r?++u:r};return null!=l.vnode&&l.vnode(f),f}function y(n){return n.children}function d(n,l){this.props=n,this.context=l}function _(n,l){if(null==l)return n.__?_(n.__,n.__.__k.indexOf(n)+1):null;for(var u;l<n.__k.length;l++)if(null!=(u=n.__k[l])&&null!=u.__e)return u.__e;return"function"==typeof n.type?_(n):null}function k(n){var l,u;if(null!=(n=n.__)&&null!=n.__c){for(n.__e=n.__c.base=null,l=0;l<n.__k.length;l++)if(null!=(u=n.__k[l])&&null!=u.__e){n.__e=n.__c.base=u.__e;break}return k(n)}}function x(n){(!n.__d&&(n.__d=!0)&&i.push(n)&&!b.__r++||r!==l.debounceRendering)&&((r=l.debounceRendering)||o)(b)}function b(){for(var n;b.__r=i.length;)n=i.sort(function(n,l){return n.__v.__b-l.__v.__b}),i=[],n.some(function(n){var l,u,t,i,o,r;n.__d&&(o=(i=(l=n).__v).__e,(r=l.__P)&&(u=[],(t=a({},i)).__v=i.__v+1,I(r,i,t,l.__n,void 0!==r.ownerSVGElement,null!=i.__h?[o]:null,u,null==o?_(i):o,i.__h),T(u,i),i.__e!=o&&k(i)))})}function m(n,l,u,t,i,o,r,f,s,a){var p,v,d,k,x,b,m,A=t&&t.__k||c,P=A.length;for(u.__k=[],p=0;p<l.length;p++)if(null!=(k=u.__k[p]=null==(k=l[p])||"boolean"==typeof k?null:"string"==typeof k||"number"==typeof k||"bigint"==typeof k?h(null,k,null,null,k):Array.isArray(k)?h(y,{children:k},null,null,null):k.__b>0?h(k.type,k.props,k.key,null,k.__v):k)){if(k.__=u,k.__b=u.__b+1,null===(d=A[p])||d&&k.key==d.key&&k.type===d.type)A[p]=void 0;else for(v=0;v<P;v++){if((d=A[v])&&k.key==d.key&&k.type===d.type){A[v]=void 0;break}d=null}I(n,k,d=d||e,i,o,r,f,s,a),x=k.__e,(v=k.ref)&&d.ref!=v&&(m||(m=[]),d.ref&&m.push(d.ref,null,k),m.push(v,k.__c||x,k)),null!=x?(null==b&&(b=x),"function"==typeof k.type&&null!=k.__k&&k.__k===d.__k?k.__d=s=g(k,s,n):s=w(n,k,d,A,x,s),a||"option"!==u.type?"function"==typeof u.type&&(u.__d=s):n.value=""):s&&d.__e==s&&s.parentNode!=n&&(s=_(d))}for(u.__e=b,p=P;p--;)null!=A[p]&&("function"==typeof u.type&&null!=A[p].__e&&A[p].__e==u.__d&&(u.__d=_(t,p+1)),L(A[p],A[p]));if(m)for(p=0;p<m.length;p++)z(m[p],m[++p],m[++p])}function g(n,l,u){var t,i;for(t=0;t<n.__k.length;t++)(i=n.__k[t])&&(i.__=n,l="function"==typeof i.type?g(i,l,u):w(u,i,i,n.__k,i.__e,l));return l}function w(n,l,u,t,i,o){var r,f,e;if(void 0!==l.__d)r=l.__d,l.__d=void 0;else if(null==u||i!=o||null==i.parentNode)n:if(null==o||o.parentNode!==n)n.appendChild(i),r=null;else{for(f=o,e=0;(f=f.nextSibling)&&e<t.length;e+=2)if(f==i)break n;n.insertBefore(i,o),r=o}return void 0!==r?r:i.nextSibling}function A(n,l,u,t,i){var o;for(o in u)"children"===o||"key"===o||o in l||C(n,o,null,u[o],t);for(o in l)i&&"function"!=typeof l[o]||"children"===o||"key"===o||"value"===o||"checked"===o||u[o]===l[o]||C(n,o,l[o],u[o],t)}function P(n,l,u){"-"===l[0]?n.setProperty(l,u):n[l]=null==u?"":"number"!=typeof u||s.test(l)?u:u+"px"}function C(n,l,u,t,i){var o;n:if("style"===l)if("string"==typeof u)n.style.cssText=u;else{if("string"==typeof t&&(n.style.cssText=t=""),t)for(l in t)u&&l in u||P(n.style,l,"");if(u)for(l in u)t&&u[l]===t[l]||P(n.style,l,u[l])}else if("o"===l[0]&&"n"===l[1])o=l!==(l=l.replace(/Capture$/,"")),l=l.toLowerCase()in n?l.toLowerCase().slice(2):l.slice(2),n.l||(n.l={}),n.l[l+o]=u,u?t||n.addEventListener(l,o?H:$,o):n.removeEventListener(l,o?H:$,o);else if("dangerouslySetInnerHTML"!==l){if(i)l=l.replace(/xlink[H:h]/,"h").replace(/sName$/,"s");else if("href"!==l&&"list"!==l&&"form"!==l&&"tabIndex"!==l&&"download"!==l&&l in n)try{n[l]=null==u?"":u;break n}catch(n){}"function"==typeof u||(null!=u&&(!1!==u||"a"===l[0]&&"r"===l[1])?n.setAttribute(l,u):n.removeAttribute(l))}}function $(n){this.l[n.type+!1](l.event?l.event(n):n)}function H(n){this.l[n.type+!0](l.event?l.event(n):n)}function I(n,u,t,i,o,r,f,e,c){var s,p,v,h,_,k,x,b,g,w,A,P=u.type;if(void 0!==u.constructor)return null;null!=t.__h&&(c=t.__h,e=u.__e=t.__e,u.__h=null,r=[e]),(s=l.__b)&&s(u);try{n:if("function"==typeof P){if(b=u.props,g=(s=P.contextType)&&i[s.__c],w=s?g?g.props.value:s.__:i,t.__c?x=(p=u.__c=t.__c).__=p.__E:("prototype"in P&&P.prototype.render?u.__c=p=new P(b,w):(u.__c=p=new d(b,w),p.constructor=P,p.render=M),g&&g.sub(p),p.props=b,p.state||(p.state={}),p.context=w,p.__n=i,v=p.__d=!0,p.__h=[]),null==p.__s&&(p.__s=p.state),null!=P.getDerivedStateFromProps&&(p.__s==p.state&&(p.__s=a({},p.__s)),a(p.__s,P.getDerivedStateFromProps(b,p.__s))),h=p.props,_=p.state,v)null==P.getDerivedStateFromProps&&null!=p.componentWillMount&&p.componentWillMount(),null!=p.componentDidMount&&p.__h.push(p.componentDidMount);else{if(null==P.getDerivedStateFromProps&&b!==h&&null!=p.componentWillReceiveProps&&p.componentWillReceiveProps(b,w),!p.__e&&null!=p.shouldComponentUpdate&&!1===p.shouldComponentUpdate(b,p.__s,w)||u.__v===t.__v){p.props=b,p.state=p.__s,u.__v!==t.__v&&(p.__d=!1),p.__v=u,u.__e=t.__e,u.__k=t.__k,u.__k.forEach(function(n){n&&(n.__=u)}),p.__h.length&&f.push(p);break n}null!=p.componentWillUpdate&&p.componentWillUpdate(b,p.__s,w),null!=p.componentDidUpdate&&p.__h.push(function(){p.componentDidUpdate(h,_,k)})}p.context=w,p.props=b,p.state=p.__s,(s=l.__r)&&s(u),p.__d=!1,p.__v=u,p.__P=n,s=p.render(p.props,p.state,p.context),p.state=p.__s,null!=p.getChildContext&&(i=a(a({},i),p.getChildContext())),v||null==p.getSnapshotBeforeUpdate||(k=p.getSnapshotBeforeUpdate(h,_)),A=null!=s&&s.type===y&&null==s.key?s.props.children:s,m(n,Array.isArray(A)?A:[A],u,t,i,o,r,f,e,c),p.base=u.__e,u.__h=null,p.__h.length&&f.push(p),x&&(p.__E=p.__=null),p.__e=!1}else null==r&&u.__v===t.__v?(u.__k=t.__k,u.__e=t.__e):u.__e=j(t.__e,u,t,i,o,r,f,c);(s=l.diffed)&&s(u)}catch(n){u.__v=null,(c||null!=r)&&(u.__e=e,u.__h=!!c,r[r.indexOf(e)]=null),l.__e(n,u,t)}}function T(n,u){l.__c&&l.__c(u,n),n.some(function(u){try{n=u.__h,u.__h=[],n.some(function(n){n.call(u)})}catch(n){l.__e(n,u.__v)}})}function j(l,u,t,i,o,r,f,c){var s,a,v,h=t.props,y=u.props,d=u.type,k=0;if("svg"===d&&(o=!0),null!=r)for(;k<r.length;k++)if((s=r[k])&&(s===l||(d?s.localName==d:3==s.nodeType))){l=s,r[k]=null;break}if(null==l){if(null===d)return document.createTextNode(y);l=o?document.createElementNS("http://www.w3.org/2000/svg",d):document.createElement(d,y.is&&y),r=null,c=!1}if(null===d)h===y||c&&l.data===y||(l.data=y);else{if(r=r&&n.call(l.childNodes),a=(h=t.props||e).dangerouslySetInnerHTML,v=y.dangerouslySetInnerHTML,!c){if(null!=r)for(h={},k=0;k<l.attributes.length;k++)h[l.attributes[k].name]=l.attributes[k].value;(v||a)&&(v&&(a&&v.__html==a.__html||v.__html===l.innerHTML)||(l.innerHTML=v&&v.__html||""))}if(A(l,y,h,o,c),v)u.__k=[];else if(k=u.props.children,m(l,Array.isArray(k)?k:[k],u,t,i,o&&"foreignObject"!==d,r,f,r?r[0]:t.__k&&_(t,0),c),null!=r)for(k=r.length;k--;)null!=r[k]&&p(r[k]);c||("value"in y&&void 0!==(k=y.value)&&(k!==l.value||"progress"===d&&!k)&&C(l,"value",k,h.value,!1),"checked"in y&&void 0!==(k=y.checked)&&k!==l.checked&&C(l,"checked",k,h.checked,!1))}return l}function z(n,u,t){try{"function"==typeof n?n(u):n.current=u}catch(n){l.__e(n,t)}}function L(n,u,t){var i,o;if(l.unmount&&l.unmount(n),(i=n.ref)&&(i.current&&i.current!==n.__e||z(i,null,u)),null!=(i=n.__c)){if(i.componentWillUnmount)try{i.componentWillUnmount()}catch(n){l.__e(n,u)}i.base=i.__P=null}if(i=n.__k)for(o=0;o<i.length;o++)i[o]&&L(i[o],u,"function"!=typeof n.type);t||null==n.__e||p(n.__e),n.__e=n.__d=void 0}function M(n,l,u){return this.constructor(n,u)}function N(u,t,i){var o,r,f;l.__&&l.__(u,t),r=(o="function"==typeof i)?null:i&&i.__k||t.__k,f=[],I(t,u=(!o&&i||t).__k=v(y,null,[u]),r||e,e,void 0!==t.ownerSVGElement,!o&&i?[i]:r?null:t.firstChild?n.call(t.childNodes):null,f,!o&&i?i:r?r.__e:t.firstChild,o),T(f,u)}n=c.slice,l={__e:function(n,l){for(var u,t,i;l=l.__;)if((u=l.__c)&&!u.__)try{if((t=u.constructor)&&null!=t.getDerivedStateFromError&&(u.setState(t.getDerivedStateFromError(n)),i=u.__d),null!=u.componentDidCatch&&(u.componentDidCatch(n),i=u.__d),i)return u.__E=u}catch(l){n=l}throw n}},u=0,t=function(n){return null!=n&&void 0===n.constructor},d.prototype.setState=function(n,l){var u;u=null!=this.__s&&this.__s!==this.state?this.__s:this.__s=a({},this.state),"function"==typeof n&&(n=n(a({},u),this.props)),n&&a(u,n),null!=n&&this.__v&&(l&&this.__h.push(l),x(this))},d.prototype.forceUpdate=function(n){this.__v&&(this.__e=!0,n&&this.__h.push(n),x(this))},d.prototype.render=y,i=[],o="function"==typeof Promise?Promise.prototype.then.bind(Promise.resolve()):setTimeout,b.__r=0,f=0,exports.render=N,exports.hydrate=function n(l,u){N(l,u,n)},exports.createElement=v,exports.h=v,exports.Fragment=y,exports.createRef=function(){return{current:null}},exports.isValidElement=t,exports.Component=d,exports.cloneElement=function(l,u,t){var i,o,r,f=a({},l.props);for(r in u)"key"==r?i=u[r]:"ref"==r?o=u[r]:f[r]=u[r];return arguments.length>2&&(f.children=arguments.length>3?n.call(arguments,2):t),h(l.type,f,i||l.key,o||l.ref,null)},exports.createContext=function(n,l){var u={__c:l="__cC"+f++,__:n,Consumer:function(n,l){return n.children(l)},Provider:function(n){var u,t;return this.getChildContext||(u=[],(t={})[l]=this,this.getChildContext=function(){return t},this.shouldComponentUpdate=function(n){this.props.value!==n.value&&u.some(x)},this.sub=function(n){u.push(n);var l=n.componentWillUnmount;n.componentWillUnmount=function(){u.splice(u.indexOf(n),1),l&&l.call(n)}}),n.children}};return u.Provider.__=u.Consumer.contextType=u},exports.toChildArray=function n(l,u){return u=u||[],null==l||"boolean"==typeof l||(Array.isArray(l)?l.some(function(l){n(l,u)}):u.push(l)),u},exports.options=l;


},{}],733:[function(require,module,exports){
var n,t,r,o=require("preact"),u=0,i=[],c=o.options.__b,e=o.options.__r,f=o.options.diffed,a=o.options.__c,v=o.options.unmount;function p(n,r){o.options.__h&&o.options.__h(t,n,u||r),u=0;var i=t.__H||(t.__H={__:[],__h:[]});return n>=i.__.length&&i.__.push({}),i.__[n]}function s(n){return u=1,x(A,n)}function x(r,o,u){var i=p(n++,2);return i.t=r,i.__c||(i.__=[u?u(o):A(void 0,o),function(n){var t=i.t(i.__[0],n);i.__[0]!==t&&(i.__=[t,i.__[1]],i.__c.setState({}))}],i.__c=t),i.__}function m(r,u){var i=p(n++,4);!o.options.__s&&q(i.__H,u)&&(i.__=r,i.__H=u,t.__h.push(i))}function l(t,r){var o=p(n++,7);return q(o.__H,r)&&(o.__=t(),o.__H=r,o.__h=t),o.__}function y(){i.forEach(function(n){if(n.__P)try{n.__H.__h.forEach(_),n.__H.__h.forEach(d),n.__H.__h=[]}catch(t){n.__H.__h=[],o.options.__e(t,n.__v)}}),i=[]}o.options.__b=function(n){t=null,c&&c(n)},o.options.__r=function(r){e&&e(r),n=0;var o=(t=r.__c).__H;o&&(o.__h.forEach(_),o.__h.forEach(d),o.__h=[])},o.options.diffed=function(n){f&&f(n);var u=n.__c;u&&u.__H&&u.__H.__h.length&&(1!==i.push(u)&&r===o.options.requestAnimationFrame||((r=o.options.requestAnimationFrame)||function(n){var t,r=function(){clearTimeout(o),h&&cancelAnimationFrame(t),setTimeout(n)},o=setTimeout(r,100);h&&(t=requestAnimationFrame(r))})(y)),t=void 0},o.options.__c=function(n,t){t.some(function(n){try{n.__h.forEach(_),n.__h=n.__h.filter(function(n){return!n.__||d(n)})}catch(r){t.some(function(n){n.__h&&(n.__h=[])}),t=[],o.options.__e(r,n.__v)}}),a&&a(n,t)},o.options.unmount=function(n){v&&v(n);var t=n.__c;if(t&&t.__H)try{t.__H.__.forEach(_)}catch(n){o.options.__e(n,t.__v)}};var h="function"==typeof requestAnimationFrame;function _(n){var r=t;"function"==typeof n.__c&&n.__c(),t=r}function d(n){var r=t;n.__c=n.__(),t=r}function q(n,t){return!n||n.length!==t.length||t.some(function(t,r){return t!==n[r]})}function A(n,t){return"function"==typeof t?t(n):t}exports.useState=s,exports.useReducer=x,exports.useEffect=function(r,u){var i=p(n++,3);!o.options.__s&&q(i.__H,u)&&(i.__=r,i.__H=u,t.__H.__h.push(i))},exports.useLayoutEffect=m,exports.useRef=function(n){return u=5,l(function(){return{current:n}},[])},exports.useImperativeHandle=function(n,t,r){u=6,m(function(){"function"==typeof n?n(t()):n&&(n.current=t())},null==r?r:r.concat(n))},exports.useMemo=l,exports.useCallback=function(n,t){return u=8,l(function(){return n},t)},exports.useContext=function(r){var o=t.context[r.__c],u=p(n++,9);return u.c=r,o?(null==u.__&&(u.__=!0,o.sub(t)),o.props.value):r.__},exports.useDebugValue=function(n,t){o.options.useDebugValue&&o.options.useDebugValue(t?t(n):n)},exports.useErrorBoundary=function(r){var o=p(n++,10),u=s();return o.__=r,t.componentDidCatch||(t.componentDidCatch=function(n){o.__&&o.__(n),u[1](n)}),[u[0],function(){u[1](void 0)}]};


},{"preact":732}],734:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],735:[function(require,module,exports){

var canPromise = require('./can-promise')

var QRCode = require('./core/qrcode')
var CanvasRenderer = require('./renderer/canvas')
var SvgRenderer = require('./renderer/svg-tag.js')

function renderCanvas (renderFunc, canvas, text, opts, cb) {
  var args = [].slice.call(arguments, 1)
  var argsNum = args.length
  var isLastArgCb = typeof args[argsNum - 1] === 'function'

  if (!isLastArgCb && !canPromise()) {
    throw new Error('Callback required as last argument')
  }

  if (isLastArgCb) {
    if (argsNum < 2) {
      throw new Error('Too few arguments provided')
    }

    if (argsNum === 2) {
      cb = text
      text = canvas
      canvas = opts = undefined
    } else if (argsNum === 3) {
      if (canvas.getContext && typeof cb === 'undefined') {
        cb = opts
        opts = undefined
      } else {
        cb = opts
        opts = text
        text = canvas
        canvas = undefined
      }
    }
  } else {
    if (argsNum < 1) {
      throw new Error('Too few arguments provided')
    }

    if (argsNum === 1) {
      text = canvas
      canvas = opts = undefined
    } else if (argsNum === 2 && !canvas.getContext) {
      opts = text
      text = canvas
      canvas = undefined
    }

    return new Promise(function (resolve, reject) {
      try {
        var data = QRCode.create(text, opts)
        resolve(renderFunc(data, canvas, opts))
      } catch (e) {
        reject(e)
      }
    })
  }

  try {
    var data = QRCode.create(text, opts)
    cb(null, renderFunc(data, canvas, opts))
  } catch (e) {
    cb(e)
  }
}

exports.create = QRCode.create
exports.toCanvas = renderCanvas.bind(null, CanvasRenderer.render)
exports.toDataURL = renderCanvas.bind(null, CanvasRenderer.renderToDataURL)

// only svg for now.
exports.toString = renderCanvas.bind(null, function (data, _, opts) {
  return SvgRenderer.render(data, opts)
})

},{"./can-promise":736,"./core/qrcode":752,"./renderer/canvas":759,"./renderer/svg-tag.js":760}],736:[function(require,module,exports){
// can-promise has a crash in some versions of react native that dont have
// standard global objects
// https://github.com/soldair/node-qrcode/issues/157

module.exports = function () {
  return typeof Promise === 'function' && Promise.prototype && Promise.prototype.then
}

},{}],737:[function(require,module,exports){
/**
 * Alignment pattern are fixed reference pattern in defined positions
 * in a matrix symbology, which enables the decode software to re-synchronise
 * the coordinate mapping of the image modules in the event of moderate amounts
 * of distortion of the image.
 *
 * Alignment patterns are present only in QR Code symbols of version 2 or larger
 * and their number depends on the symbol version.
 */

var getSymbolSize = require('./utils').getSymbolSize

/**
 * Calculate the row/column coordinates of the center module of each alignment pattern
 * for the specified QR Code version.
 *
 * The alignment patterns are positioned symmetrically on either side of the diagonal
 * running from the top left corner of the symbol to the bottom right corner.
 *
 * Since positions are simmetrical only half of the coordinates are returned.
 * Each item of the array will represent in turn the x and y coordinate.
 * @see {@link getPositions}
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinate
 */
exports.getRowColCoords = function getRowColCoords (version) {
  if (version === 1) return []

  var posCount = Math.floor(version / 7) + 2
  var size = getSymbolSize(version)
  var intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2
  var positions = [size - 7] // Last coord is always (size - 7)

  for (var i = 1; i < posCount - 1; i++) {
    positions[i] = positions[i - 1] - intervals
  }

  positions.push(6) // First coord is always 6

  return positions.reverse()
}

/**
 * Returns an array containing the positions of each alignment pattern.
 * Each array's element represent the center point of the pattern as (x, y) coordinates
 *
 * Coordinates are calculated expanding the row/column coordinates returned by {@link getRowColCoords}
 * and filtering out the items that overlaps with finder pattern
 *
 * @example
 * For a Version 7 symbol {@link getRowColCoords} returns values 6, 22 and 38.
 * The alignment patterns, therefore, are to be centered on (row, column)
 * positions (6,22), (22,6), (22,22), (22,38), (38,22), (38,38).
 * Note that the coordinates (6,6), (6,38), (38,6) are occupied by finder patterns
 * and are not therefore used for alignment patterns.
 *
 * var pos = getPositions(7)
 * // [[6,22], [22,6], [22,22], [22,38], [38,22], [38,38]]
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */
exports.getPositions = function getPositions (version) {
  var coords = []
  var pos = exports.getRowColCoords(version)
  var posLength = pos.length

  for (var i = 0; i < posLength; i++) {
    for (var j = 0; j < posLength; j++) {
      // Skip if position is occupied by finder patterns
      if ((i === 0 && j === 0) ||             // top-left
          (i === 0 && j === posLength - 1) || // bottom-left
          (i === posLength - 1 && j === 0)) { // top-right
        continue
      }

      coords.push([pos[i], pos[j]])
    }
  }

  return coords
}

},{"./utils":756}],738:[function(require,module,exports){
var Mode = require('./mode')

/**
 * Array of characters available in alphanumeric mode
 *
 * As per QR Code specification, to each character
 * is assigned a value from 0 to 44 which in this case coincides
 * with the array index
 *
 * @type {Array}
 */
var ALPHA_NUM_CHARS = [
  '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
  'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M',
  'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z',
  ' ', '$', '%', '*', '+', '-', '.', '/', ':'
]

function AlphanumericData (data) {
  this.mode = Mode.ALPHANUMERIC
  this.data = data
}

AlphanumericData.getBitsLength = function getBitsLength (length) {
  return 11 * Math.floor(length / 2) + 6 * (length % 2)
}

AlphanumericData.prototype.getLength = function getLength () {
  return this.data.length
}

AlphanumericData.prototype.getBitsLength = function getBitsLength () {
  return AlphanumericData.getBitsLength(this.data.length)
}

AlphanumericData.prototype.write = function write (bitBuffer) {
  var i

  // Input data characters are divided into groups of two characters
  // and encoded as 11-bit binary codes.
  for (i = 0; i + 2 <= this.data.length; i += 2) {
    // The character value of the first character is multiplied by 45
    var value = ALPHA_NUM_CHARS.indexOf(this.data[i]) * 45

    // The character value of the second digit is added to the product
    value += ALPHA_NUM_CHARS.indexOf(this.data[i + 1])

    // The sum is then stored as 11-bit binary number
    bitBuffer.put(value, 11)
  }

  // If the number of input data characters is not a multiple of two,
  // the character value of the final character is encoded as a 6-bit binary number.
  if (this.data.length % 2) {
    bitBuffer.put(ALPHA_NUM_CHARS.indexOf(this.data[i]), 6)
  }
}

module.exports = AlphanumericData

},{"./mode":749}],739:[function(require,module,exports){
function BitBuffer () {
  this.buffer = []
  this.length = 0
}

BitBuffer.prototype = {

  get: function (index) {
    var bufIndex = Math.floor(index / 8)
    return ((this.buffer[bufIndex] >>> (7 - index % 8)) & 1) === 1
  },

  put: function (num, length) {
    for (var i = 0; i < length; i++) {
      this.putBit(((num >>> (length - i - 1)) & 1) === 1)
    }
  },

  getLengthInBits: function () {
    return this.length
  },

  putBit: function (bit) {
    var bufIndex = Math.floor(this.length / 8)
    if (this.buffer.length <= bufIndex) {
      this.buffer.push(0)
    }

    if (bit) {
      this.buffer[bufIndex] |= (0x80 >>> (this.length % 8))
    }

    this.length++
  }
}

module.exports = BitBuffer

},{}],740:[function(require,module,exports){
var BufferUtil = require('../utils/buffer')

/**
 * Helper class to handle QR Code symbol modules
 *
 * @param {Number} size Symbol size
 */
function BitMatrix (size) {
  if (!size || size < 1) {
    throw new Error('BitMatrix size must be defined and greater than 0')
  }

  this.size = size
  this.data = BufferUtil.alloc(size * size)
  this.reservedBit = BufferUtil.alloc(size * size)
}

/**
 * Set bit value at specified location
 * If reserved flag is set, this bit will be ignored during masking process
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 * @param {Boolean} reserved
 */
BitMatrix.prototype.set = function (row, col, value, reserved) {
  var index = row * this.size + col
  this.data[index] = value
  if (reserved) this.reservedBit[index] = true
}

/**
 * Returns bit value at specified location
 *
 * @param  {Number}  row
 * @param  {Number}  col
 * @return {Boolean}
 */
BitMatrix.prototype.get = function (row, col) {
  return this.data[row * this.size + col]
}

/**
 * Applies xor operator at specified location
 * (used during masking process)
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 */
BitMatrix.prototype.xor = function (row, col, value) {
  this.data[row * this.size + col] ^= value
}

/**
 * Check if bit at specified location is reserved
 *
 * @param {Number}   row
 * @param {Number}   col
 * @return {Boolean}
 */
BitMatrix.prototype.isReserved = function (row, col) {
  return this.reservedBit[row * this.size + col]
}

module.exports = BitMatrix

},{"../utils/buffer":762}],741:[function(require,module,exports){
var BufferUtil = require('../utils/buffer')
var Mode = require('./mode')

function ByteData (data) {
  this.mode = Mode.BYTE
  this.data = BufferUtil.from(data)
}

ByteData.getBitsLength = function getBitsLength (length) {
  return length * 8
}

ByteData.prototype.getLength = function getLength () {
  return this.data.length
}

ByteData.prototype.getBitsLength = function getBitsLength () {
  return ByteData.getBitsLength(this.data.length)
}

ByteData.prototype.write = function (bitBuffer) {
  for (var i = 0, l = this.data.length; i < l; i++) {
    bitBuffer.put(this.data[i], 8)
  }
}

module.exports = ByteData

},{"../utils/buffer":762,"./mode":749}],742:[function(require,module,exports){
var ECLevel = require('./error-correction-level')

var EC_BLOCKS_TABLE = [
// L  M  Q  H
  1, 1, 1, 1,
  1, 1, 1, 1,
  1, 1, 2, 2,
  1, 2, 2, 4,
  1, 2, 4, 4,
  2, 4, 4, 4,
  2, 4, 6, 5,
  2, 4, 6, 6,
  2, 5, 8, 8,
  4, 5, 8, 8,
  4, 5, 8, 11,
  4, 8, 10, 11,
  4, 9, 12, 16,
  4, 9, 16, 16,
  6, 10, 12, 18,
  6, 10, 17, 16,
  6, 11, 16, 19,
  6, 13, 18, 21,
  7, 14, 21, 25,
  8, 16, 20, 25,
  8, 17, 23, 25,
  9, 17, 23, 34,
  9, 18, 25, 30,
  10, 20, 27, 32,
  12, 21, 29, 35,
  12, 23, 34, 37,
  12, 25, 34, 40,
  13, 26, 35, 42,
  14, 28, 38, 45,
  15, 29, 40, 48,
  16, 31, 43, 51,
  17, 33, 45, 54,
  18, 35, 48, 57,
  19, 37, 51, 60,
  19, 38, 53, 63,
  20, 40, 56, 66,
  21, 43, 59, 70,
  22, 45, 62, 74,
  24, 47, 65, 77,
  25, 49, 68, 81
]

var EC_CODEWORDS_TABLE = [
// L  M  Q  H
  7, 10, 13, 17,
  10, 16, 22, 28,
  15, 26, 36, 44,
  20, 36, 52, 64,
  26, 48, 72, 88,
  36, 64, 96, 112,
  40, 72, 108, 130,
  48, 88, 132, 156,
  60, 110, 160, 192,
  72, 130, 192, 224,
  80, 150, 224, 264,
  96, 176, 260, 308,
  104, 198, 288, 352,
  120, 216, 320, 384,
  132, 240, 360, 432,
  144, 280, 408, 480,
  168, 308, 448, 532,
  180, 338, 504, 588,
  196, 364, 546, 650,
  224, 416, 600, 700,
  224, 442, 644, 750,
  252, 476, 690, 816,
  270, 504, 750, 900,
  300, 560, 810, 960,
  312, 588, 870, 1050,
  336, 644, 952, 1110,
  360, 700, 1020, 1200,
  390, 728, 1050, 1260,
  420, 784, 1140, 1350,
  450, 812, 1200, 1440,
  480, 868, 1290, 1530,
  510, 924, 1350, 1620,
  540, 980, 1440, 1710,
  570, 1036, 1530, 1800,
  570, 1064, 1590, 1890,
  600, 1120, 1680, 1980,
  630, 1204, 1770, 2100,
  660, 1260, 1860, 2220,
  720, 1316, 1950, 2310,
  750, 1372, 2040, 2430
]

/**
 * Returns the number of error correction block that the QR Code should contain
 * for the specified version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction blocks
 */
exports.getBlocksCount = function getBlocksCount (version, errorCorrectionLevel) {
  switch (errorCorrectionLevel) {
    case ECLevel.L:
      return EC_BLOCKS_TABLE[(version - 1) * 4 + 0]
    case ECLevel.M:
      return EC_BLOCKS_TABLE[(version - 1) * 4 + 1]
    case ECLevel.Q:
      return EC_BLOCKS_TABLE[(version - 1) * 4 + 2]
    case ECLevel.H:
      return EC_BLOCKS_TABLE[(version - 1) * 4 + 3]
    default:
      return undefined
  }
}

/**
 * Returns the number of error correction codewords to use for the specified
 * version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction codewords
 */
exports.getTotalCodewordsCount = function getTotalCodewordsCount (version, errorCorrectionLevel) {
  switch (errorCorrectionLevel) {
    case ECLevel.L:
      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 0]
    case ECLevel.M:
      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 1]
    case ECLevel.Q:
      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 2]
    case ECLevel.H:
      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 3]
    default:
      return undefined
  }
}

},{"./error-correction-level":743}],743:[function(require,module,exports){
exports.L = { bit: 1 }
exports.M = { bit: 0 }
exports.Q = { bit: 3 }
exports.H = { bit: 2 }

function fromString (string) {
  if (typeof string !== 'string') {
    throw new Error('Param is not a string')
  }

  var lcStr = string.toLowerCase()

  switch (lcStr) {
    case 'l':
    case 'low':
      return exports.L

    case 'm':
    case 'medium':
      return exports.M

    case 'q':
    case 'quartile':
      return exports.Q

    case 'h':
    case 'high':
      return exports.H

    default:
      throw new Error('Unknown EC Level: ' + string)
  }
}

exports.isValid = function isValid (level) {
  return level && typeof level.bit !== 'undefined' &&
    level.bit >= 0 && level.bit < 4
}

exports.from = function from (value, defaultValue) {
  if (exports.isValid(value)) {
    return value
  }

  try {
    return fromString(value)
  } catch (e) {
    return defaultValue
  }
}

},{}],744:[function(require,module,exports){
var getSymbolSize = require('./utils').getSymbolSize
var FINDER_PATTERN_SIZE = 7

/**
 * Returns an array containing the positions of each finder pattern.
 * Each array's element represent the top-left point of the pattern as (x, y) coordinates
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */
exports.getPositions = function getPositions (version) {
  var size = getSymbolSize(version)

  return [
    // top-left
    [0, 0],
    // top-right
    [size - FINDER_PATTERN_SIZE, 0],
    // bottom-left
    [0, size - FINDER_PATTERN_SIZE]
  ]
}

},{"./utils":756}],745:[function(require,module,exports){
var Utils = require('./utils')

var G15 = (1 << 10) | (1 << 8) | (1 << 5) | (1 << 4) | (1 << 2) | (1 << 1) | (1 << 0)
var G15_MASK = (1 << 14) | (1 << 12) | (1 << 10) | (1 << 4) | (1 << 1)
var G15_BCH = Utils.getBCHDigit(G15)

/**
 * Returns format information with relative error correction bits
 *
 * The format information is a 15-bit sequence containing 5 data bits,
 * with 10 error correction bits calculated using the (15, 5) BCH code.
 *
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Number} mask                 Mask pattern
 * @return {Number}                      Encoded format information bits
 */
exports.getEncodedBits = function getEncodedBits (errorCorrectionLevel, mask) {
  var data = ((errorCorrectionLevel.bit << 3) | mask)
  var d = data << 10

  while (Utils.getBCHDigit(d) - G15_BCH >= 0) {
    d ^= (G15 << (Utils.getBCHDigit(d) - G15_BCH))
  }

  // xor final data with mask pattern in order to ensure that
  // no combination of Error Correction Level and data mask pattern
  // will result in an all-zero data string
  return ((data << 10) | d) ^ G15_MASK
}

},{"./utils":756}],746:[function(require,module,exports){
var BufferUtil = require('../utils/buffer')

var EXP_TABLE = BufferUtil.alloc(512)
var LOG_TABLE = BufferUtil.alloc(256)
/**
 * Precompute the log and anti-log tables for faster computation later
 *
 * For each possible value in the galois field 2^8, we will pre-compute
 * the logarithm and anti-logarithm (exponential) of this value
 *
 * ref {@link https://en.wikiversity.org/wiki/Reed%E2%80%93Solomon_codes_for_coders#Introduction_to_mathematical_fields}
 */
;(function initTables () {
  var x = 1
  for (var i = 0; i < 255; i++) {
    EXP_TABLE[i] = x
    LOG_TABLE[x] = i

    x <<= 1 // multiply by 2

    // The QR code specification says to use byte-wise modulo 100011101 arithmetic.
    // This means that when a number is 256 or larger, it should be XORed with 0x11D.
    if (x & 0x100) { // similar to x >= 256, but a lot faster (because 0x100 == 256)
      x ^= 0x11D
    }
  }

  // Optimization: double the size of the anti-log table so that we don't need to mod 255 to
  // stay inside the bounds (because we will mainly use this table for the multiplication of
  // two GF numbers, no more).
  // @see {@link mul}
  for (i = 255; i < 512; i++) {
    EXP_TABLE[i] = EXP_TABLE[i - 255]
  }
}())

/**
 * Returns log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */
exports.log = function log (n) {
  if (n < 1) throw new Error('log(' + n + ')')
  return LOG_TABLE[n]
}

/**
 * Returns anti-log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */
exports.exp = function exp (n) {
  return EXP_TABLE[n]
}

/**
 * Multiplies two number inside Galois Field
 *
 * @param  {Number} x
 * @param  {Number} y
 * @return {Number}
 */
exports.mul = function mul (x, y) {
  if (x === 0 || y === 0) return 0

  // should be EXP_TABLE[(LOG_TABLE[x] + LOG_TABLE[y]) % 255] if EXP_TABLE wasn't oversized
  // @see {@link initTables}
  return EXP_TABLE[LOG_TABLE[x] + LOG_TABLE[y]]
}

},{"../utils/buffer":762}],747:[function(require,module,exports){
var Mode = require('./mode')
var Utils = require('./utils')

function KanjiData (data) {
  this.mode = Mode.KANJI
  this.data = data
}

KanjiData.getBitsLength = function getBitsLength (length) {
  return length * 13
}

KanjiData.prototype.getLength = function getLength () {
  return this.data.length
}

KanjiData.prototype.getBitsLength = function getBitsLength () {
  return KanjiData.getBitsLength(this.data.length)
}

KanjiData.prototype.write = function (bitBuffer) {
  var i

  // In the Shift JIS system, Kanji characters are represented by a two byte combination.
  // These byte values are shifted from the JIS X 0208 values.
  // JIS X 0208 gives details of the shift coded representation.
  for (i = 0; i < this.data.length; i++) {
    var value = Utils.toSJIS(this.data[i])

    // For characters with Shift JIS values from 0x8140 to 0x9FFC:
    if (value >= 0x8140 && value <= 0x9FFC) {
      // Subtract 0x8140 from Shift JIS value
      value -= 0x8140

    // For characters with Shift JIS values from 0xE040 to 0xEBBF
    } else if (value >= 0xE040 && value <= 0xEBBF) {
      // Subtract 0xC140 from Shift JIS value
      value -= 0xC140
    } else {
      throw new Error(
        'Invalid SJIS character: ' + this.data[i] + '\n' +
        'Make sure your charset is UTF-8')
    }

    // Multiply most significant byte of result by 0xC0
    // and add least significant byte to product
    value = (((value >>> 8) & 0xff) * 0xC0) + (value & 0xff)

    // Convert result to a 13-bit binary string
    bitBuffer.put(value, 13)
  }
}

module.exports = KanjiData

},{"./mode":749,"./utils":756}],748:[function(require,module,exports){
/**
 * Data mask pattern reference
 * @type {Object}
 */
exports.Patterns = {
  PATTERN000: 0,
  PATTERN001: 1,
  PATTERN010: 2,
  PATTERN011: 3,
  PATTERN100: 4,
  PATTERN101: 5,
  PATTERN110: 6,
  PATTERN111: 7
}

/**
 * Weighted penalty scores for the undesirable features
 * @type {Object}
 */
var PenaltyScores = {
  N1: 3,
  N2: 3,
  N3: 40,
  N4: 10
}

/**
 * Check if mask pattern value is valid
 *
 * @param  {Number}  mask    Mask pattern
 * @return {Boolean}         true if valid, false otherwise
 */
exports.isValid = function isValid (mask) {
  return mask != null && mask !== '' && !isNaN(mask) && mask >= 0 && mask <= 7
}

/**
 * Returns mask pattern from a value.
 * If value is not valid, returns undefined
 *
 * @param  {Number|String} value        Mask pattern value
 * @return {Number}                     Valid mask pattern or undefined
 */
exports.from = function from (value) {
  return exports.isValid(value) ? parseInt(value, 10) : undefined
}

/**
* Find adjacent modules in row/column with the same color
* and assign a penalty value.
*
* Points: N1 + i
* i is the amount by which the number of adjacent modules of the same color exceeds 5
*/
exports.getPenaltyN1 = function getPenaltyN1 (data) {
  var size = data.size
  var points = 0
  var sameCountCol = 0
  var sameCountRow = 0
  var lastCol = null
  var lastRow = null

  for (var row = 0; row < size; row++) {
    sameCountCol = sameCountRow = 0
    lastCol = lastRow = null

    for (var col = 0; col < size; col++) {
      var module = data.get(row, col)
      if (module === lastCol) {
        sameCountCol++
      } else {
        if (sameCountCol >= 5) points += PenaltyScores.N1 + (sameCountCol - 5)
        lastCol = module
        sameCountCol = 1
      }

      module = data.get(col, row)
      if (module === lastRow) {
        sameCountRow++
      } else {
        if (sameCountRow >= 5) points += PenaltyScores.N1 + (sameCountRow - 5)
        lastRow = module
        sameCountRow = 1
      }
    }

    if (sameCountCol >= 5) points += PenaltyScores.N1 + (sameCountCol - 5)
    if (sameCountRow >= 5) points += PenaltyScores.N1 + (sameCountRow - 5)
  }

  return points
}

/**
 * Find 2x2 blocks with the same color and assign a penalty value
 *
 * Points: N2 * (m - 1) * (n - 1)
 */
exports.getPenaltyN2 = function getPenaltyN2 (data) {
  var size = data.size
  var points = 0

  for (var row = 0; row < size - 1; row++) {
    for (var col = 0; col < size - 1; col++) {
      var last = data.get(row, col) +
        data.get(row, col + 1) +
        data.get(row + 1, col) +
        data.get(row + 1, col + 1)

      if (last === 4 || last === 0) points++
    }
  }

  return points * PenaltyScores.N2
}

/**
 * Find 1:1:3:1:1 ratio (dark:light:dark:light:dark) pattern in row/column,
 * preceded or followed by light area 4 modules wide
 *
 * Points: N3 * number of pattern found
 */
exports.getPenaltyN3 = function getPenaltyN3 (data) {
  var size = data.size
  var points = 0
  var bitsCol = 0
  var bitsRow = 0

  for (var row = 0; row < size; row++) {
    bitsCol = bitsRow = 0
    for (var col = 0; col < size; col++) {
      bitsCol = ((bitsCol << 1) & 0x7FF) | data.get(row, col)
      if (col >= 10 && (bitsCol === 0x5D0 || bitsCol === 0x05D)) points++

      bitsRow = ((bitsRow << 1) & 0x7FF) | data.get(col, row)
      if (col >= 10 && (bitsRow === 0x5D0 || bitsRow === 0x05D)) points++
    }
  }

  return points * PenaltyScores.N3
}

/**
 * Calculate proportion of dark modules in entire symbol
 *
 * Points: N4 * k
 *
 * k is the rating of the deviation of the proportion of dark modules
 * in the symbol from 50% in steps of 5%
 */
exports.getPenaltyN4 = function getPenaltyN4 (data) {
  var darkCount = 0
  var modulesCount = data.data.length

  for (var i = 0; i < modulesCount; i++) darkCount += data.data[i]

  var k = Math.abs(Math.ceil((darkCount * 100 / modulesCount) / 5) - 10)

  return k * PenaltyScores.N4
}

/**
 * Return mask value at given position
 *
 * @param  {Number} maskPattern Pattern reference value
 * @param  {Number} i           Row
 * @param  {Number} j           Column
 * @return {Boolean}            Mask value
 */
function getMaskAt (maskPattern, i, j) {
  switch (maskPattern) {
    case exports.Patterns.PATTERN000: return (i + j) % 2 === 0
    case exports.Patterns.PATTERN001: return i % 2 === 0
    case exports.Patterns.PATTERN010: return j % 3 === 0
    case exports.Patterns.PATTERN011: return (i + j) % 3 === 0
    case exports.Patterns.PATTERN100: return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 === 0
    case exports.Patterns.PATTERN101: return (i * j) % 2 + (i * j) % 3 === 0
    case exports.Patterns.PATTERN110: return ((i * j) % 2 + (i * j) % 3) % 2 === 0
    case exports.Patterns.PATTERN111: return ((i * j) % 3 + (i + j) % 2) % 2 === 0

    default: throw new Error('bad maskPattern:' + maskPattern)
  }
}

/**
 * Apply a mask pattern to a BitMatrix
 *
 * @param  {Number}    pattern Pattern reference number
 * @param  {BitMatrix} data    BitMatrix data
 */
exports.applyMask = function applyMask (pattern, data) {
  var size = data.size

  for (var col = 0; col < size; col++) {
    for (var row = 0; row < size; row++) {
      if (data.isReserved(row, col)) continue
      data.xor(row, col, getMaskAt(pattern, row, col))
    }
  }
}

/**
 * Returns the best mask pattern for data
 *
 * @param  {BitMatrix} data
 * @return {Number} Mask pattern reference number
 */
exports.getBestMask = function getBestMask (data, setupFormatFunc) {
  var numPatterns = Object.keys(exports.Patterns).length
  var bestPattern = 0
  var lowerPenalty = Infinity

  for (var p = 0; p < numPatterns; p++) {
    setupFormatFunc(p)
    exports.applyMask(p, data)

    // Calculate penalty
    var penalty =
      exports.getPenaltyN1(data) +
      exports.getPenaltyN2(data) +
      exports.getPenaltyN3(data) +
      exports.getPenaltyN4(data)

    // Undo previously applied mask
    exports.applyMask(p, data)

    if (penalty < lowerPenalty) {
      lowerPenalty = penalty
      bestPattern = p
    }
  }

  return bestPattern
}

},{}],749:[function(require,module,exports){
var VersionCheck = require('./version-check')
var Regex = require('./regex')

/**
 * Numeric mode encodes data from the decimal digit set (0 - 9)
 * (byte values 30HEX to 39HEX).
 * Normally, 3 data characters are represented by 10 bits.
 *
 * @type {Object}
 */
exports.NUMERIC = {
  id: 'Numeric',
  bit: 1 << 0,
  ccBits: [10, 12, 14]
}

/**
 * Alphanumeric mode encodes data from a set of 45 characters,
 * i.e. 10 numeric digits (0 - 9),
 *      26 alphabetic characters (A - Z),
 *   and 9 symbols (SP, $, %, *, +, -, ., /, :).
 * Normally, two input characters are represented by 11 bits.
 *
 * @type {Object}
 */
exports.ALPHANUMERIC = {
  id: 'Alphanumeric',
  bit: 1 << 1,
  ccBits: [9, 11, 13]
}

/**
 * In byte mode, data is encoded at 8 bits per character.
 *
 * @type {Object}
 */
exports.BYTE = {
  id: 'Byte',
  bit: 1 << 2,
  ccBits: [8, 16, 16]
}

/**
 * The Kanji mode efficiently encodes Kanji characters in accordance with
 * the Shift JIS system based on JIS X 0208.
 * The Shift JIS values are shifted from the JIS X 0208 values.
 * JIS X 0208 gives details of the shift coded representation.
 * Each two-byte character value is compacted to a 13-bit binary codeword.
 *
 * @type {Object}
 */
exports.KANJI = {
  id: 'Kanji',
  bit: 1 << 3,
  ccBits: [8, 10, 12]
}

/**
 * Mixed mode will contain a sequences of data in a combination of any of
 * the modes described above
 *
 * @type {Object}
 */
exports.MIXED = {
  bit: -1
}

/**
 * Returns the number of bits needed to store the data length
 * according to QR Code specifications.
 *
 * @param  {Mode}   mode    Data mode
 * @param  {Number} version QR Code version
 * @return {Number}         Number of bits
 */
exports.getCharCountIndicator = function getCharCountIndicator (mode, version) {
  if (!mode.ccBits) throw new Error('Invalid mode: ' + mode)

  if (!VersionCheck.isValid(version)) {
    throw new Error('Invalid version: ' + version)
  }

  if (version >= 1 && version < 10) return mode.ccBits[0]
  else if (version < 27) return mode.ccBits[1]
  return mode.ccBits[2]
}

/**
 * Returns the most efficient mode to store the specified data
 *
 * @param  {String} dataStr Input data string
 * @return {Mode}           Best mode
 */
exports.getBestModeForData = function getBestModeForData (dataStr) {
  if (Regex.testNumeric(dataStr)) return exports.NUMERIC
  else if (Regex.testAlphanumeric(dataStr)) return exports.ALPHANUMERIC
  else if (Regex.testKanji(dataStr)) return exports.KANJI
  else return exports.BYTE
}

/**
 * Return mode name as string
 *
 * @param {Mode} mode Mode object
 * @returns {String}  Mode name
 */
exports.toString = function toString (mode) {
  if (mode && mode.id) return mode.id
  throw new Error('Invalid mode')
}

/**
 * Check if input param is a valid mode object
 *
 * @param   {Mode}    mode Mode object
 * @returns {Boolean} True if valid mode, false otherwise
 */
exports.isValid = function isValid (mode) {
  return mode && mode.bit && mode.ccBits
}

/**
 * Get mode object from its name
 *
 * @param   {String} string Mode name
 * @returns {Mode}          Mode object
 */
function fromString (string) {
  if (typeof string !== 'string') {
    throw new Error('Param is not a string')
  }

  var lcStr = string.toLowerCase()

  switch (lcStr) {
    case 'numeric':
      return exports.NUMERIC
    case 'alphanumeric':
      return exports.ALPHANUMERIC
    case 'kanji':
      return exports.KANJI
    case 'byte':
      return exports.BYTE
    default:
      throw new Error('Unknown mode: ' + string)
  }
}

/**
 * Returns mode from a value.
 * If value is not a valid mode, returns defaultValue
 *
 * @param  {Mode|String} value        Encoding mode
 * @param  {Mode}        defaultValue Fallback value
 * @return {Mode}                     Encoding mode
 */
exports.from = function from (value, defaultValue) {
  if (exports.isValid(value)) {
    return value
  }

  try {
    return fromString(value)
  } catch (e) {
    return defaultValue
  }
}

},{"./regex":754,"./version-check":757}],750:[function(require,module,exports){
var Mode = require('./mode')

function NumericData (data) {
  this.mode = Mode.NUMERIC
  this.data = data.toString()
}

NumericData.getBitsLength = function getBitsLength (length) {
  return 10 * Math.floor(length / 3) + ((length % 3) ? ((length % 3) * 3 + 1) : 0)
}

NumericData.prototype.getLength = function getLength () {
  return this.data.length
}

NumericData.prototype.getBitsLength = function getBitsLength () {
  return NumericData.getBitsLength(this.data.length)
}

NumericData.prototype.write = function write (bitBuffer) {
  var i, group, value

  // The input data string is divided into groups of three digits,
  // and each group is converted to its 10-bit binary equivalent.
  for (i = 0; i + 3 <= this.data.length; i += 3) {
    group = this.data.substr(i, 3)
    value = parseInt(group, 10)

    bitBuffer.put(value, 10)
  }

  // If the number of input digits is not an exact multiple of three,
  // the final one or two digits are converted to 4 or 7 bits respectively.
  var remainingNum = this.data.length - i
  if (remainingNum > 0) {
    group = this.data.substr(i)
    value = parseInt(group, 10)

    bitBuffer.put(value, remainingNum * 3 + 1)
  }
}

module.exports = NumericData

},{"./mode":749}],751:[function(require,module,exports){
var BufferUtil = require('../utils/buffer')
var GF = require('./galois-field')

/**
 * Multiplies two polynomials inside Galois Field
 *
 * @param  {Buffer} p1 Polynomial
 * @param  {Buffer} p2 Polynomial
 * @return {Buffer}    Product of p1 and p2
 */
exports.mul = function mul (p1, p2) {
  var coeff = BufferUtil.alloc(p1.length + p2.length - 1)

  for (var i = 0; i < p1.length; i++) {
    for (var j = 0; j < p2.length; j++) {
      coeff[i + j] ^= GF.mul(p1[i], p2[j])
    }
  }

  return coeff
}

/**
 * Calculate the remainder of polynomials division
 *
 * @param  {Buffer} divident Polynomial
 * @param  {Buffer} divisor  Polynomial
 * @return {Buffer}          Remainder
 */
exports.mod = function mod (divident, divisor) {
  var result = BufferUtil.from(divident)

  while ((result.length - divisor.length) >= 0) {
    var coeff = result[0]

    for (var i = 0; i < divisor.length; i++) {
      result[i] ^= GF.mul(divisor[i], coeff)
    }

    // remove all zeros from buffer head
    var offset = 0
    while (offset < result.length && result[offset] === 0) offset++
    result = result.slice(offset)
  }

  return result
}

/**
 * Generate an irreducible generator polynomial of specified degree
 * (used by Reed-Solomon encoder)
 *
 * @param  {Number} degree Degree of the generator polynomial
 * @return {Buffer}        Buffer containing polynomial coefficients
 */
exports.generateECPolynomial = function generateECPolynomial (degree) {
  var poly = BufferUtil.from([1])
  for (var i = 0; i < degree; i++) {
    poly = exports.mul(poly, [1, GF.exp(i)])
  }

  return poly
}

},{"../utils/buffer":762,"./galois-field":746}],752:[function(require,module,exports){
var BufferUtil = require('../utils/buffer')
var Utils = require('./utils')
var ECLevel = require('./error-correction-level')
var BitBuffer = require('./bit-buffer')
var BitMatrix = require('./bit-matrix')
var AlignmentPattern = require('./alignment-pattern')
var FinderPattern = require('./finder-pattern')
var MaskPattern = require('./mask-pattern')
var ECCode = require('./error-correction-code')
var ReedSolomonEncoder = require('./reed-solomon-encoder')
var Version = require('./version')
var FormatInfo = require('./format-info')
var Mode = require('./mode')
var Segments = require('./segments')
var isArray = require('isarray')

/**
 * QRCode for JavaScript
 *
 * modified by Ryan Day for nodejs support
 * Copyright (c) 2011 Ryan Day
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
//---------------------------------------------------------------------
// QRCode for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//   http://www.opensource.org/licenses/mit-license.php
//
// The word "QR Code" is registered trademark of
// DENSO WAVE INCORPORATED
//   http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
*/

/**
 * Add finder patterns bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */
function setupFinderPattern (matrix, version) {
  var size = matrix.size
  var pos = FinderPattern.getPositions(version)

  for (var i = 0; i < pos.length; i++) {
    var row = pos[i][0]
    var col = pos[i][1]

    for (var r = -1; r <= 7; r++) {
      if (row + r <= -1 || size <= row + r) continue

      for (var c = -1; c <= 7; c++) {
        if (col + c <= -1 || size <= col + c) continue

        if ((r >= 0 && r <= 6 && (c === 0 || c === 6)) ||
          (c >= 0 && c <= 6 && (r === 0 || r === 6)) ||
          (r >= 2 && r <= 4 && c >= 2 && c <= 4)) {
          matrix.set(row + r, col + c, true, true)
        } else {
          matrix.set(row + r, col + c, false, true)
        }
      }
    }
  }
}

/**
 * Add timing pattern bits to matrix
 *
 * Note: this function must be called before {@link setupAlignmentPattern}
 *
 * @param  {BitMatrix} matrix Modules matrix
 */
function setupTimingPattern (matrix) {
  var size = matrix.size

  for (var r = 8; r < size - 8; r++) {
    var value = r % 2 === 0
    matrix.set(r, 6, value, true)
    matrix.set(6, r, value, true)
  }
}

/**
 * Add alignment patterns bits to matrix
 *
 * Note: this function must be called after {@link setupTimingPattern}
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */
function setupAlignmentPattern (matrix, version) {
  var pos = AlignmentPattern.getPositions(version)

  for (var i = 0; i < pos.length; i++) {
    var row = pos[i][0]
    var col = pos[i][1]

    for (var r = -2; r <= 2; r++) {
      for (var c = -2; c <= 2; c++) {
        if (r === -2 || r === 2 || c === -2 || c === 2 ||
          (r === 0 && c === 0)) {
          matrix.set(row + r, col + c, true, true)
        } else {
          matrix.set(row + r, col + c, false, true)
        }
      }
    }
  }
}

/**
 * Add version info bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */
function setupVersionInfo (matrix, version) {
  var size = matrix.size
  var bits = Version.getEncodedBits(version)
  var row, col, mod

  for (var i = 0; i < 18; i++) {
    row = Math.floor(i / 3)
    col = i % 3 + size - 8 - 3
    mod = ((bits >> i) & 1) === 1

    matrix.set(row, col, mod, true)
    matrix.set(col, row, mod, true)
  }
}

/**
 * Add format info bits to matrix
 *
 * @param  {BitMatrix} matrix               Modules matrix
 * @param  {ErrorCorrectionLevel}    errorCorrectionLevel Error correction level
 * @param  {Number}    maskPattern          Mask pattern reference value
 */
function setupFormatInfo (matrix, errorCorrectionLevel, maskPattern) {
  var size = matrix.size
  var bits = FormatInfo.getEncodedBits(errorCorrectionLevel, maskPattern)
  var i, mod

  for (i = 0; i < 15; i++) {
    mod = ((bits >> i) & 1) === 1

    // vertical
    if (i < 6) {
      matrix.set(i, 8, mod, true)
    } else if (i < 8) {
      matrix.set(i + 1, 8, mod, true)
    } else {
      matrix.set(size - 15 + i, 8, mod, true)
    }

    // horizontal
    if (i < 8) {
      matrix.set(8, size - i - 1, mod, true)
    } else if (i < 9) {
      matrix.set(8, 15 - i - 1 + 1, mod, true)
    } else {
      matrix.set(8, 15 - i - 1, mod, true)
    }
  }

  // fixed module
  matrix.set(size - 8, 8, 1, true)
}

/**
 * Add encoded data bits to matrix
 *
 * @param  {BitMatrix} matrix Modules matrix
 * @param  {Buffer}    data   Data codewords
 */
function setupData (matrix, data) {
  var size = matrix.size
  var inc = -1
  var row = size - 1
  var bitIndex = 7
  var byteIndex = 0

  for (var col = size - 1; col > 0; col -= 2) {
    if (col === 6) col--

    while (true) {
      for (var c = 0; c < 2; c++) {
        if (!matrix.isReserved(row, col - c)) {
          var dark = false

          if (byteIndex < data.length) {
            dark = (((data[byteIndex] >>> bitIndex) & 1) === 1)
          }

          matrix.set(row, col - c, dark)
          bitIndex--

          if (bitIndex === -1) {
            byteIndex++
            bitIndex = 7
          }
        }
      }

      row += inc

      if (row < 0 || size <= row) {
        row -= inc
        inc = -inc
        break
      }
    }
  }
}

/**
 * Create encoded codewords from data input
 *
 * @param  {Number}   version              QR Code version
 * @param  {ErrorCorrectionLevel}   errorCorrectionLevel Error correction level
 * @param  {ByteData} data                 Data input
 * @return {Buffer}                        Buffer containing encoded codewords
 */
function createData (version, errorCorrectionLevel, segments) {
  // Prepare data buffer
  var buffer = new BitBuffer()

  segments.forEach(function (data) {
    // prefix data with mode indicator (4 bits)
    buffer.put(data.mode.bit, 4)

    // Prefix data with character count indicator.
    // The character count indicator is a string of bits that represents the
    // number of characters that are being encoded.
    // The character count indicator must be placed after the mode indicator
    // and must be a certain number of bits long, depending on the QR version
    // and data mode
    // @see {@link Mode.getCharCountIndicator}.
    buffer.put(data.getLength(), Mode.getCharCountIndicator(data.mode, version))

    // add binary data sequence to buffer
    data.write(buffer)
  })

  // Calculate required number of bits
  var totalCodewords = Utils.getSymbolTotalCodewords(version)
  var ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel)
  var dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8

  // Add a terminator.
  // If the bit string is shorter than the total number of required bits,
  // a terminator of up to four 0s must be added to the right side of the string.
  // If the bit string is more than four bits shorter than the required number of bits,
  // add four 0s to the end.
  if (buffer.getLengthInBits() + 4 <= dataTotalCodewordsBits) {
    buffer.put(0, 4)
  }

  // If the bit string is fewer than four bits shorter, add only the number of 0s that
  // are needed to reach the required number of bits.

  // After adding the terminator, if the number of bits in the string is not a multiple of 8,
  // pad the string on the right with 0s to make the string's length a multiple of 8.
  while (buffer.getLengthInBits() % 8 !== 0) {
    buffer.putBit(0)
  }

  // Add pad bytes if the string is still shorter than the total number of required bits.
  // Extend the buffer to fill the data capacity of the symbol corresponding to
  // the Version and Error Correction Level by adding the Pad Codewords 11101100 (0xEC)
  // and 00010001 (0x11) alternately.
  var remainingByte = (dataTotalCodewordsBits - buffer.getLengthInBits()) / 8
  for (var i = 0; i < remainingByte; i++) {
    buffer.put(i % 2 ? 0x11 : 0xEC, 8)
  }

  return createCodewords(buffer, version, errorCorrectionLevel)
}

/**
 * Encode input data with Reed-Solomon and return codewords with
 * relative error correction bits
 *
 * @param  {BitBuffer} bitBuffer            Data to encode
 * @param  {Number}    version              QR Code version
 * @param  {ErrorCorrectionLevel} errorCorrectionLevel Error correction level
 * @return {Buffer}                         Buffer containing encoded codewords
 */
function createCodewords (bitBuffer, version, errorCorrectionLevel) {
  // Total codewords for this QR code version (Data + Error correction)
  var totalCodewords = Utils.getSymbolTotalCodewords(version)

  // Total number of error correction codewords
  var ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel)

  // Total number of data codewords
  var dataTotalCodewords = totalCodewords - ecTotalCodewords

  // Total number of blocks
  var ecTotalBlocks = ECCode.getBlocksCount(version, errorCorrectionLevel)

  // Calculate how many blocks each group should contain
  var blocksInGroup2 = totalCodewords % ecTotalBlocks
  var blocksInGroup1 = ecTotalBlocks - blocksInGroup2

  var totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks)

  var dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks)
  var dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1

  // Number of EC codewords is the same for both groups
  var ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1

  // Initialize a Reed-Solomon encoder with a generator polynomial of degree ecCount
  var rs = new ReedSolomonEncoder(ecCount)

  var offset = 0
  var dcData = new Array(ecTotalBlocks)
  var ecData = new Array(ecTotalBlocks)
  var maxDataSize = 0
  var buffer = BufferUtil.from(bitBuffer.buffer)

  // Divide the buffer into the required number of blocks
  for (var b = 0; b < ecTotalBlocks; b++) {
    var dataSize = b < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2

    // extract a block of data from buffer
    dcData[b] = buffer.slice(offset, offset + dataSize)

    // Calculate EC codewords for this data block
    ecData[b] = rs.encode(dcData[b])

    offset += dataSize
    maxDataSize = Math.max(maxDataSize, dataSize)
  }

  // Create final data
  // Interleave the data and error correction codewords from each block
  var data = BufferUtil.alloc(totalCodewords)
  var index = 0
  var i, r

  // Add data codewords
  for (i = 0; i < maxDataSize; i++) {
    for (r = 0; r < ecTotalBlocks; r++) {
      if (i < dcData[r].length) {
        data[index++] = dcData[r][i]
      }
    }
  }

  // Apped EC codewords
  for (i = 0; i < ecCount; i++) {
    for (r = 0; r < ecTotalBlocks; r++) {
      data[index++] = ecData[r][i]
    }
  }

  return data
}

/**
 * Build QR Code symbol
 *
 * @param  {String} data                 Input string
 * @param  {Number} version              QR Code version
 * @param  {ErrorCorretionLevel} errorCorrectionLevel Error level
 * @param  {MaskPattern} maskPattern     Mask pattern
 * @return {Object}                      Object containing symbol data
 */
function createSymbol (data, version, errorCorrectionLevel, maskPattern) {
  var segments

  if (isArray(data)) {
    segments = Segments.fromArray(data)
  } else if (typeof data === 'string') {
    var estimatedVersion = version

    if (!estimatedVersion) {
      var rawSegments = Segments.rawSplit(data)

      // Estimate best version that can contain raw splitted segments
      estimatedVersion = Version.getBestVersionForData(rawSegments,
        errorCorrectionLevel)
    }

    // Build optimized segments
    // If estimated version is undefined, try with the highest version
    segments = Segments.fromString(data, estimatedVersion || 40)
  } else {
    throw new Error('Invalid data')
  }

  // Get the min version that can contain data
  var bestVersion = Version.getBestVersionForData(segments,
      errorCorrectionLevel)

  // If no version is found, data cannot be stored
  if (!bestVersion) {
    throw new Error('The amount of data is too big to be stored in a QR Code')
  }

  // If not specified, use min version as default
  if (!version) {
    version = bestVersion

  // Check if the specified version can contain the data
  } else if (version < bestVersion) {
    throw new Error('\n' +
      'The chosen QR Code version cannot contain this amount of data.\n' +
      'Minimum version required to store current data is: ' + bestVersion + '.\n'
    )
  }

  var dataBits = createData(version, errorCorrectionLevel, segments)

  // Allocate matrix buffer
  var moduleCount = Utils.getSymbolSize(version)
  var modules = new BitMatrix(moduleCount)

  // Add function modules
  setupFinderPattern(modules, version)
  setupTimingPattern(modules)
  setupAlignmentPattern(modules, version)

  // Add temporary dummy bits for format info just to set them as reserved.
  // This is needed to prevent these bits from being masked by {@link MaskPattern.applyMask}
  // since the masking operation must be performed only on the encoding region.
  // These blocks will be replaced with correct values later in code.
  setupFormatInfo(modules, errorCorrectionLevel, 0)

  if (version >= 7) {
    setupVersionInfo(modules, version)
  }

  // Add data codewords
  setupData(modules, dataBits)

  if (isNaN(maskPattern)) {
    // Find best mask pattern
    maskPattern = MaskPattern.getBestMask(modules,
      setupFormatInfo.bind(null, modules, errorCorrectionLevel))
  }

  // Apply mask pattern
  MaskPattern.applyMask(maskPattern, modules)

  // Replace format info bits with correct values
  setupFormatInfo(modules, errorCorrectionLevel, maskPattern)

  return {
    modules: modules,
    version: version,
    errorCorrectionLevel: errorCorrectionLevel,
    maskPattern: maskPattern,
    segments: segments
  }
}

/**
 * QR Code
 *
 * @param {String | Array} data                 Input data
 * @param {Object} options                      Optional configurations
 * @param {Number} options.version              QR Code version
 * @param {String} options.errorCorrectionLevel Error correction level
 * @param {Function} options.toSJISFunc         Helper func to convert utf8 to sjis
 */
exports.create = function create (data, options) {
  if (typeof data === 'undefined' || data === '') {
    throw new Error('No input text')
  }

  var errorCorrectionLevel = ECLevel.M
  var version
  var mask

  if (typeof options !== 'undefined') {
    // Use higher error correction level as default
    errorCorrectionLevel = ECLevel.from(options.errorCorrectionLevel, ECLevel.M)
    version = Version.from(options.version)
    mask = MaskPattern.from(options.maskPattern)

    if (options.toSJISFunc) {
      Utils.setToSJISFunction(options.toSJISFunc)
    }
  }

  return createSymbol(data, version, errorCorrectionLevel, mask)
}

},{"../utils/buffer":762,"./alignment-pattern":737,"./bit-buffer":739,"./bit-matrix":740,"./error-correction-code":742,"./error-correction-level":743,"./finder-pattern":744,"./format-info":745,"./mask-pattern":748,"./mode":749,"./reed-solomon-encoder":753,"./segments":755,"./utils":756,"./version":758,"isarray":763}],753:[function(require,module,exports){
var BufferUtil = require('../utils/buffer')
var Polynomial = require('./polynomial')
var Buffer = require('buffer').Buffer

function ReedSolomonEncoder (degree) {
  this.genPoly = undefined
  this.degree = degree

  if (this.degree) this.initialize(this.degree)
}

/**
 * Initialize the encoder.
 * The input param should correspond to the number of error correction codewords.
 *
 * @param  {Number} degree
 */
ReedSolomonEncoder.prototype.initialize = function initialize (degree) {
  // create an irreducible generator polynomial
  this.degree = degree
  this.genPoly = Polynomial.generateECPolynomial(this.degree)
}

/**
 * Encodes a chunk of data
 *
 * @param  {Buffer} data Buffer containing input data
 * @return {Buffer}      Buffer containing encoded data
 */
ReedSolomonEncoder.prototype.encode = function encode (data) {
  if (!this.genPoly) {
    throw new Error('Encoder not initialized')
  }

  // Calculate EC for this data block
  // extends data size to data+genPoly size
  var pad = BufferUtil.alloc(this.degree)
  var paddedData = Buffer.concat([data, pad], data.length + this.degree)

  // The error correction codewords are the remainder after dividing the data codewords
  // by a generator polynomial
  var remainder = Polynomial.mod(paddedData, this.genPoly)

  // return EC data blocks (last n byte, where n is the degree of genPoly)
  // If coefficients number in remainder are less than genPoly degree,
  // pad with 0s to the left to reach the needed number of coefficients
  var start = this.degree - remainder.length
  if (start > 0) {
    var buff = BufferUtil.alloc(this.degree)
    remainder.copy(buff, start)

    return buff
  }

  return remainder
}

module.exports = ReedSolomonEncoder

},{"../utils/buffer":762,"./polynomial":751,"buffer":81}],754:[function(require,module,exports){
var numeric = '[0-9]+'
var alphanumeric = '[A-Z $%*+\\-./:]+'
var kanji = '(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|' +
  '[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|' +
  '[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|' +
  '[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+'
kanji = kanji.replace(/u/g, '\\u')

var byte = '(?:(?![A-Z0-9 $%*+\\-./:]|' + kanji + ')(?:.|[\r\n]))+'

exports.KANJI = new RegExp(kanji, 'g')
exports.BYTE_KANJI = new RegExp('[^A-Z0-9 $%*+\\-./:]+', 'g')
exports.BYTE = new RegExp(byte, 'g')
exports.NUMERIC = new RegExp(numeric, 'g')
exports.ALPHANUMERIC = new RegExp(alphanumeric, 'g')

var TEST_KANJI = new RegExp('^' + kanji + '$')
var TEST_NUMERIC = new RegExp('^' + numeric + '$')
var TEST_ALPHANUMERIC = new RegExp('^[A-Z0-9 $%*+\\-./:]+$')

exports.testKanji = function testKanji (str) {
  return TEST_KANJI.test(str)
}

exports.testNumeric = function testNumeric (str) {
  return TEST_NUMERIC.test(str)
}

exports.testAlphanumeric = function testAlphanumeric (str) {
  return TEST_ALPHANUMERIC.test(str)
}

},{}],755:[function(require,module,exports){
var Mode = require('./mode')
var NumericData = require('./numeric-data')
var AlphanumericData = require('./alphanumeric-data')
var ByteData = require('./byte-data')
var KanjiData = require('./kanji-data')
var Regex = require('./regex')
var Utils = require('./utils')
var dijkstra = require('dijkstrajs')

/**
 * Returns UTF8 byte length
 *
 * @param  {String} str Input string
 * @return {Number}     Number of byte
 */
function getStringByteLength (str) {
  return unescape(encodeURIComponent(str)).length
}

/**
 * Get a list of segments of the specified mode
 * from a string
 *
 * @param  {Mode}   mode Segment mode
 * @param  {String} str  String to process
 * @return {Array}       Array of object with segments data
 */
function getSegments (regex, mode, str) {
  var segments = []
  var result

  while ((result = regex.exec(str)) !== null) {
    segments.push({
      data: result[0],
      index: result.index,
      mode: mode,
      length: result[0].length
    })
  }

  return segments
}

/**
 * Extracts a series of segments with the appropriate
 * modes from a string
 *
 * @param  {String} dataStr Input string
 * @return {Array}          Array of object with segments data
 */
function getSegmentsFromString (dataStr) {
  var numSegs = getSegments(Regex.NUMERIC, Mode.NUMERIC, dataStr)
  var alphaNumSegs = getSegments(Regex.ALPHANUMERIC, Mode.ALPHANUMERIC, dataStr)
  var byteSegs
  var kanjiSegs

  if (Utils.isKanjiModeEnabled()) {
    byteSegs = getSegments(Regex.BYTE, Mode.BYTE, dataStr)
    kanjiSegs = getSegments(Regex.KANJI, Mode.KANJI, dataStr)
  } else {
    byteSegs = getSegments(Regex.BYTE_KANJI, Mode.BYTE, dataStr)
    kanjiSegs = []
  }

  var segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs)

  return segs
    .sort(function (s1, s2) {
      return s1.index - s2.index
    })
    .map(function (obj) {
      return {
        data: obj.data,
        mode: obj.mode,
        length: obj.length
      }
    })
}

/**
 * Returns how many bits are needed to encode a string of
 * specified length with the specified mode
 *
 * @param  {Number} length String length
 * @param  {Mode} mode     Segment mode
 * @return {Number}        Bit length
 */
function getSegmentBitsLength (length, mode) {
  switch (mode) {
    case Mode.NUMERIC:
      return NumericData.getBitsLength(length)
    case Mode.ALPHANUMERIC:
      return AlphanumericData.getBitsLength(length)
    case Mode.KANJI:
      return KanjiData.getBitsLength(length)
    case Mode.BYTE:
      return ByteData.getBitsLength(length)
  }
}

/**
 * Merges adjacent segments which have the same mode
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */
function mergeSegments (segs) {
  return segs.reduce(function (acc, curr) {
    var prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null
    if (prevSeg && prevSeg.mode === curr.mode) {
      acc[acc.length - 1].data += curr.data
      return acc
    }

    acc.push(curr)
    return acc
  }, [])
}

/**
 * Generates a list of all possible nodes combination which
 * will be used to build a segments graph.
 *
 * Nodes are divided by groups. Each group will contain a list of all the modes
 * in which is possible to encode the given text.
 *
 * For example the text '12345' can be encoded as Numeric, Alphanumeric or Byte.
 * The group for '12345' will contain then 3 objects, one for each
 * possible encoding mode.
 *
 * Each node represents a possible segment.
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */
function buildNodes (segs) {
  var nodes = []
  for (var i = 0; i < segs.length; i++) {
    var seg = segs[i]

    switch (seg.mode) {
      case Mode.NUMERIC:
        nodes.push([seg,
          { data: seg.data, mode: Mode.ALPHANUMERIC, length: seg.length },
          { data: seg.data, mode: Mode.BYTE, length: seg.length }
        ])
        break
      case Mode.ALPHANUMERIC:
        nodes.push([seg,
          { data: seg.data, mode: Mode.BYTE, length: seg.length }
        ])
        break
      case Mode.KANJI:
        nodes.push([seg,
          { data: seg.data, mode: Mode.BYTE, length: getStringByteLength(seg.data) }
        ])
        break
      case Mode.BYTE:
        nodes.push([
          { data: seg.data, mode: Mode.BYTE, length: getStringByteLength(seg.data) }
        ])
    }
  }

  return nodes
}

/**
 * Builds a graph from a list of nodes.
 * All segments in each node group will be connected with all the segments of
 * the next group and so on.
 *
 * At each connection will be assigned a weight depending on the
 * segment's byte length.
 *
 * @param  {Array} nodes    Array of object with segments data
 * @param  {Number} version QR Code version
 * @return {Object}         Graph of all possible segments
 */
function buildGraph (nodes, version) {
  var table = {}
  var graph = {'start': {}}
  var prevNodeIds = ['start']

  for (var i = 0; i < nodes.length; i++) {
    var nodeGroup = nodes[i]
    var currentNodeIds = []

    for (var j = 0; j < nodeGroup.length; j++) {
      var node = nodeGroup[j]
      var key = '' + i + j

      currentNodeIds.push(key)
      table[key] = { node: node, lastCount: 0 }
      graph[key] = {}

      for (var n = 0; n < prevNodeIds.length; n++) {
        var prevNodeId = prevNodeIds[n]

        if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
          graph[prevNodeId][key] =
            getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) -
            getSegmentBitsLength(table[prevNodeId].lastCount, node.mode)

          table[prevNodeId].lastCount += node.length
        } else {
          if (table[prevNodeId]) table[prevNodeId].lastCount = node.length

          graph[prevNodeId][key] = getSegmentBitsLength(node.length, node.mode) +
            4 + Mode.getCharCountIndicator(node.mode, version) // switch cost
        }
      }
    }

    prevNodeIds = currentNodeIds
  }

  for (n = 0; n < prevNodeIds.length; n++) {
    graph[prevNodeIds[n]]['end'] = 0
  }

  return { map: graph, table: table }
}

/**
 * Builds a segment from a specified data and mode.
 * If a mode is not specified, the more suitable will be used.
 *
 * @param  {String} data             Input data
 * @param  {Mode | String} modesHint Data mode
 * @return {Segment}                 Segment
 */
function buildSingleSegment (data, modesHint) {
  var mode
  var bestMode = Mode.getBestModeForData(data)

  mode = Mode.from(modesHint, bestMode)

  // Make sure data can be encoded
  if (mode !== Mode.BYTE && mode.bit < bestMode.bit) {
    throw new Error('"' + data + '"' +
      ' cannot be encoded with mode ' + Mode.toString(mode) +
      '.\n Suggested mode is: ' + Mode.toString(bestMode))
  }

  // Use Mode.BYTE if Kanji support is disabled
  if (mode === Mode.KANJI && !Utils.isKanjiModeEnabled()) {
    mode = Mode.BYTE
  }

  switch (mode) {
    case Mode.NUMERIC:
      return new NumericData(data)

    case Mode.ALPHANUMERIC:
      return new AlphanumericData(data)

    case Mode.KANJI:
      return new KanjiData(data)

    case Mode.BYTE:
      return new ByteData(data)
  }
}

/**
 * Builds a list of segments from an array.
 * Array can contain Strings or Objects with segment's info.
 *
 * For each item which is a string, will be generated a segment with the given
 * string and the more appropriate encoding mode.
 *
 * For each item which is an object, will be generated a segment with the given
 * data and mode.
 * Objects must contain at least the property "data".
 * If property "mode" is not present, the more suitable mode will be used.
 *
 * @param  {Array} array Array of objects with segments data
 * @return {Array}       Array of Segments
 */
exports.fromArray = function fromArray (array) {
  return array.reduce(function (acc, seg) {
    if (typeof seg === 'string') {
      acc.push(buildSingleSegment(seg, null))
    } else if (seg.data) {
      acc.push(buildSingleSegment(seg.data, seg.mode))
    }

    return acc
  }, [])
}

/**
 * Builds an optimized sequence of segments from a string,
 * which will produce the shortest possible bitstream.
 *
 * @param  {String} data    Input string
 * @param  {Number} version QR Code version
 * @return {Array}          Array of segments
 */
exports.fromString = function fromString (data, version) {
  var segs = getSegmentsFromString(data, Utils.isKanjiModeEnabled())

  var nodes = buildNodes(segs)
  var graph = buildGraph(nodes, version)
  var path = dijkstra.find_path(graph.map, 'start', 'end')

  var optimizedSegs = []
  for (var i = 1; i < path.length - 1; i++) {
    optimizedSegs.push(graph.table[path[i]].node)
  }

  return exports.fromArray(mergeSegments(optimizedSegs))
}

/**
 * Splits a string in various segments with the modes which
 * best represent their content.
 * The produced segments are far from being optimized.
 * The output of this function is only used to estimate a QR Code version
 * which may contain the data.
 *
 * @param  {string} data Input string
 * @return {Array}       Array of segments
 */
exports.rawSplit = function rawSplit (data) {
  return exports.fromArray(
    getSegmentsFromString(data, Utils.isKanjiModeEnabled())
  )
}

},{"./alphanumeric-data":738,"./byte-data":741,"./kanji-data":747,"./mode":749,"./numeric-data":750,"./regex":754,"./utils":756,"dijkstrajs":526}],756:[function(require,module,exports){
var toSJISFunction
var CODEWORDS_COUNT = [
  0, // Not used
  26, 44, 70, 100, 134, 172, 196, 242, 292, 346,
  404, 466, 532, 581, 655, 733, 815, 901, 991, 1085,
  1156, 1258, 1364, 1474, 1588, 1706, 1828, 1921, 2051, 2185,
  2323, 2465, 2611, 2761, 2876, 3034, 3196, 3362, 3532, 3706
]

/**
 * Returns the QR Code size for the specified version
 *
 * @param  {Number} version QR Code version
 * @return {Number}         size of QR code
 */
exports.getSymbolSize = function getSymbolSize (version) {
  if (!version) throw new Error('"version" cannot be null or undefined')
  if (version < 1 || version > 40) throw new Error('"version" should be in range from 1 to 40')
  return version * 4 + 17
}

/**
 * Returns the total number of codewords used to store data and EC information.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Data length in bits
 */
exports.getSymbolTotalCodewords = function getSymbolTotalCodewords (version) {
  return CODEWORDS_COUNT[version]
}

/**
 * Encode data with Bose-Chaudhuri-Hocquenghem
 *
 * @param  {Number} data Value to encode
 * @return {Number}      Encoded value
 */
exports.getBCHDigit = function (data) {
  var digit = 0

  while (data !== 0) {
    digit++
    data >>>= 1
  }

  return digit
}

exports.setToSJISFunction = function setToSJISFunction (f) {
  if (typeof f !== 'function') {
    throw new Error('"toSJISFunc" is not a valid function.')
  }

  toSJISFunction = f
}

exports.isKanjiModeEnabled = function () {
  return typeof toSJISFunction !== 'undefined'
}

exports.toSJIS = function toSJIS (kanji) {
  return toSJISFunction(kanji)
}

},{}],757:[function(require,module,exports){
/**
 * Check if QR Code version is valid
 *
 * @param  {Number}  version QR Code version
 * @return {Boolean}         true if valid version, false otherwise
 */
exports.isValid = function isValid (version) {
  return !isNaN(version) && version >= 1 && version <= 40
}

},{}],758:[function(require,module,exports){
var Utils = require('./utils')
var ECCode = require('./error-correction-code')
var ECLevel = require('./error-correction-level')
var Mode = require('./mode')
var VersionCheck = require('./version-check')
var isArray = require('isarray')

// Generator polynomial used to encode version information
var G18 = (1 << 12) | (1 << 11) | (1 << 10) | (1 << 9) | (1 << 8) | (1 << 5) | (1 << 2) | (1 << 0)
var G18_BCH = Utils.getBCHDigit(G18)

function getBestVersionForDataLength (mode, length, errorCorrectionLevel) {
  for (var currentVersion = 1; currentVersion <= 40; currentVersion++) {
    if (length <= exports.getCapacity(currentVersion, errorCorrectionLevel, mode)) {
      return currentVersion
    }
  }

  return undefined
}

function getReservedBitsCount (mode, version) {
  // Character count indicator + mode indicator bits
  return Mode.getCharCountIndicator(mode, version) + 4
}

function getTotalBitsFromDataArray (segments, version) {
  var totalBits = 0

  segments.forEach(function (data) {
    var reservedBits = getReservedBitsCount(data.mode, version)
    totalBits += reservedBits + data.getBitsLength()
  })

  return totalBits
}

function getBestVersionForMixedData (segments, errorCorrectionLevel) {
  for (var currentVersion = 1; currentVersion <= 40; currentVersion++) {
    var length = getTotalBitsFromDataArray(segments, currentVersion)
    if (length <= exports.getCapacity(currentVersion, errorCorrectionLevel, Mode.MIXED)) {
      return currentVersion
    }
  }

  return undefined
}

/**
 * Returns version number from a value.
 * If value is not a valid version, returns defaultValue
 *
 * @param  {Number|String} value        QR Code version
 * @param  {Number}        defaultValue Fallback value
 * @return {Number}                     QR Code version number
 */
exports.from = function from (value, defaultValue) {
  if (VersionCheck.isValid(value)) {
    return parseInt(value, 10)
  }

  return defaultValue
}

/**
 * Returns how much data can be stored with the specified QR code version
 * and error correction level
 *
 * @param  {Number} version              QR Code version (1-40)
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Mode}   mode                 Data mode
 * @return {Number}                      Quantity of storable data
 */
exports.getCapacity = function getCapacity (version, errorCorrectionLevel, mode) {
  if (!VersionCheck.isValid(version)) {
    throw new Error('Invalid QR Code version')
  }

  // Use Byte mode as default
  if (typeof mode === 'undefined') mode = Mode.BYTE

  // Total codewords for this QR code version (Data + Error correction)
  var totalCodewords = Utils.getSymbolTotalCodewords(version)

  // Total number of error correction codewords
  var ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel)

  // Total number of data codewords
  var dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8

  if (mode === Mode.MIXED) return dataTotalCodewordsBits

  var usableBits = dataTotalCodewordsBits - getReservedBitsCount(mode, version)

  // Return max number of storable codewords
  switch (mode) {
    case Mode.NUMERIC:
      return Math.floor((usableBits / 10) * 3)

    case Mode.ALPHANUMERIC:
      return Math.floor((usableBits / 11) * 2)

    case Mode.KANJI:
      return Math.floor(usableBits / 13)

    case Mode.BYTE:
    default:
      return Math.floor(usableBits / 8)
  }
}

/**
 * Returns the minimum version needed to contain the amount of data
 *
 * @param  {Segment} data                    Segment of data
 * @param  {Number} [errorCorrectionLevel=H] Error correction level
 * @param  {Mode} mode                       Data mode
 * @return {Number}                          QR Code version
 */
exports.getBestVersionForData = function getBestVersionForData (data, errorCorrectionLevel) {
  var seg

  var ecl = ECLevel.from(errorCorrectionLevel, ECLevel.M)

  if (isArray(data)) {
    if (data.length > 1) {
      return getBestVersionForMixedData(data, ecl)
    }

    if (data.length === 0) {
      return 1
    }

    seg = data[0]
  } else {
    seg = data
  }

  return getBestVersionForDataLength(seg.mode, seg.getLength(), ecl)
}

/**
 * Returns version information with relative error correction bits
 *
 * The version information is included in QR Code symbols of version 7 or larger.
 * It consists of an 18-bit sequence containing 6 data bits,
 * with 12 error correction bits calculated using the (18, 6) Golay code.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Encoded version info bits
 */
exports.getEncodedBits = function getEncodedBits (version) {
  if (!VersionCheck.isValid(version) || version < 7) {
    throw new Error('Invalid QR Code version')
  }

  var d = version << 12

  while (Utils.getBCHDigit(d) - G18_BCH >= 0) {
    d ^= (G18 << (Utils.getBCHDigit(d) - G18_BCH))
  }

  return (version << 12) | d
}

},{"./error-correction-code":742,"./error-correction-level":743,"./mode":749,"./utils":756,"./version-check":757,"isarray":763}],759:[function(require,module,exports){
var Utils = require('./utils')

function clearCanvas (ctx, canvas, size) {
  ctx.clearRect(0, 0, canvas.width, canvas.height)

  if (!canvas.style) canvas.style = {}
  canvas.height = size
  canvas.width = size
  canvas.style.height = size + 'px'
  canvas.style.width = size + 'px'
}

function getCanvasElement () {
  try {
    return document.createElement('canvas')
  } catch (e) {
    throw new Error('You need to specify a canvas element')
  }
}

exports.render = function render (qrData, canvas, options) {
  var opts = options
  var canvasEl = canvas

  if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
    opts = canvas
    canvas = undefined
  }

  if (!canvas) {
    canvasEl = getCanvasElement()
  }

  opts = Utils.getOptions(opts)
  var size = Utils.getImageWidth(qrData.modules.size, opts)

  var ctx = canvasEl.getContext('2d')
  var image = ctx.createImageData(size, size)
  Utils.qrToImageData(image.data, qrData, opts)

  clearCanvas(ctx, canvasEl, size)
  ctx.putImageData(image, 0, 0)

  return canvasEl
}

exports.renderToDataURL = function renderToDataURL (qrData, canvas, options) {
  var opts = options

  if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
    opts = canvas
    canvas = undefined
  }

  if (!opts) opts = {}

  var canvasEl = exports.render(qrData, canvas, opts)

  var type = opts.type || 'image/png'
  var rendererOpts = opts.rendererOpts || {}

  return canvasEl.toDataURL(type, rendererOpts.quality)
}

},{"./utils":761}],760:[function(require,module,exports){
var Utils = require('./utils')

function getColorAttrib (color, attrib) {
  var alpha = color.a / 255
  var str = attrib + '="' + color.hex + '"'

  return alpha < 1
    ? str + ' ' + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"'
    : str
}

function svgCmd (cmd, x, y) {
  var str = cmd + x
  if (typeof y !== 'undefined') str += ' ' + y

  return str
}

function qrToPath (data, size, margin) {
  var path = ''
  var moveBy = 0
  var newRow = false
  var lineLength = 0

  for (var i = 0; i < data.length; i++) {
    var col = Math.floor(i % size)
    var row = Math.floor(i / size)

    if (!col && !newRow) newRow = true

    if (data[i]) {
      lineLength++

      if (!(i > 0 && col > 0 && data[i - 1])) {
        path += newRow
          ? svgCmd('M', col + margin, 0.5 + row + margin)
          : svgCmd('m', moveBy, 0)

        moveBy = 0
        newRow = false
      }

      if (!(col + 1 < size && data[i + 1])) {
        path += svgCmd('h', lineLength)
        lineLength = 0
      }
    } else {
      moveBy++
    }
  }

  return path
}

exports.render = function render (qrData, options, cb) {
  var opts = Utils.getOptions(options)
  var size = qrData.modules.size
  var data = qrData.modules.data
  var qrcodesize = size + opts.margin * 2

  var bg = !opts.color.light.a
    ? ''
    : '<path ' + getColorAttrib(opts.color.light, 'fill') +
      ' d="M0 0h' + qrcodesize + 'v' + qrcodesize + 'H0z"/>'

  var path =
    '<path ' + getColorAttrib(opts.color.dark, 'stroke') +
    ' d="' + qrToPath(data, size, opts.margin) + '"/>'

  var viewBox = 'viewBox="' + '0 0 ' + qrcodesize + ' ' + qrcodesize + '"'

  var width = !opts.width ? '' : 'width="' + opts.width + '" height="' + opts.width + '" '

  var svgTag = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path + '</svg>\n'

  if (typeof cb === 'function') {
    cb(null, svgTag)
  }

  return svgTag
}

},{"./utils":761}],761:[function(require,module,exports){
function hex2rgba (hex) {
  if (typeof hex === 'number') {
    hex = hex.toString()
  }

  if (typeof hex !== 'string') {
    throw new Error('Color should be defined as hex string')
  }

  var hexCode = hex.slice().replace('#', '').split('')
  if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) {
    throw new Error('Invalid hex color: ' + hex)
  }

  // Convert from short to long form (fff -> ffffff)
  if (hexCode.length === 3 || hexCode.length === 4) {
    hexCode = Array.prototype.concat.apply([], hexCode.map(function (c) {
      return [c, c]
    }))
  }

  // Add default alpha value
  if (hexCode.length === 6) hexCode.push('F', 'F')

  var hexValue = parseInt(hexCode.join(''), 16)

  return {
    r: (hexValue >> 24) & 255,
    g: (hexValue >> 16) & 255,
    b: (hexValue >> 8) & 255,
    a: hexValue & 255,
    hex: '#' + hexCode.slice(0, 6).join('')
  }
}

exports.getOptions = function getOptions (options) {
  if (!options) options = {}
  if (!options.color) options.color = {}

  var margin = typeof options.margin === 'undefined' ||
    options.margin === null ||
    options.margin < 0 ? 4 : options.margin

  var width = options.width && options.width >= 21 ? options.width : undefined
  var scale = options.scale || 4

  return {
    width: width,
    scale: width ? 4 : scale,
    margin: margin,
    color: {
      dark: hex2rgba(options.color.dark || '#000000ff'),
      light: hex2rgba(options.color.light || '#ffffffff')
    },
    type: options.type,
    rendererOpts: options.rendererOpts || {}
  }
}

exports.getScale = function getScale (qrSize, opts) {
  return opts.width && opts.width >= qrSize + opts.margin * 2
    ? opts.width / (qrSize + opts.margin * 2)
    : opts.scale
}

exports.getImageWidth = function getImageWidth (qrSize, opts) {
  var scale = exports.getScale(qrSize, opts)
  return Math.floor((qrSize + opts.margin * 2) * scale)
}

exports.qrToImageData = function qrToImageData (imgData, qr, opts) {
  var size = qr.modules.size
  var data = qr.modules.data
  var scale = exports.getScale(size, opts)
  var symbolSize = Math.floor((size + opts.margin * 2) * scale)
  var scaledMargin = opts.margin * scale
  var palette = [opts.color.light, opts.color.dark]

  for (var i = 0; i < symbolSize; i++) {
    for (var j = 0; j < symbolSize; j++) {
      var posDst = (i * symbolSize + j) * 4
      var pxColor = opts.color.light

      if (i >= scaledMargin && j >= scaledMargin &&
        i < symbolSize - scaledMargin && j < symbolSize - scaledMargin) {
        var iSrc = Math.floor((i - scaledMargin) / scale)
        var jSrc = Math.floor((j - scaledMargin) / scale)
        pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0]
      }

      imgData[posDst++] = pxColor.r
      imgData[posDst++] = pxColor.g
      imgData[posDst++] = pxColor.b
      imgData[posDst] = pxColor.a
    }
  }
}

},{}],762:[function(require,module,exports){
/**
 * Implementation of a subset of node.js Buffer methods for the browser.
 * Based on https://github.com/feross/buffer
 */

/* eslint-disable no-proto */

'use strict'

var isArray = require('isarray')

function typedArraySupport () {
  // Can typed array instances be augmented?
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

var K_MAX_LENGTH = Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff

function Buffer (arg, offset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, offset, length)
  }

  if (typeof arg === 'number') {
    return allocUnsafe(this, arg)
  }

  return from(this, arg, offset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array

  // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true,
      enumerable: false,
      writable: false
    })
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

function createBuffer (that, length) {
  var buf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    buf = new Uint8Array(length)
    buf.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    buf = that
    if (buf === null) {
      buf = new Buffer(length)
    }
    buf.length = length
  }

  return buf
}

function allocUnsafe (that, size) {
  var buf = createBuffer(that, size < 0 ? 0 : checked(size) | 0)

  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      buf[i] = 0
    }
  }

  return buf
}

function fromString (that, string) {
  var length = byteLength(string) | 0
  var buf = createBuffer(that, length)

  var actual = buf.write(string)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  var buf = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayBuffer (that, array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  var buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    buf.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    buf = fromArrayLike(that, buf)
  }

  return buf
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    var buf = createBuffer(that, len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function byteLength (string) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  return utf8ToBytes(string).length
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function from (that, value, offset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, offset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, offset)
  }

  return fromObject(that, value)
}

Buffer.prototype.write = function write (string, offset, length) {
  // Buffer#write(string)
  if (offset === undefined) {
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
    } else {
      length = undefined
    }
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  return utf8Write(this, string, offset, length)
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    // Return an augmented `Uint8Array` instance
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

Buffer.prototype.fill = function fill (val, start, end) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : new Buffer(val)
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return createBuffer(null, 0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = allocUnsafe(null, length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

Buffer.byteLength = byteLength

Buffer.prototype._isBuffer = true
Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

module.exports.alloc = function (size) {
  var buffer = new Buffer(size)
  buffer.fill(0)
  return buffer
}

module.exports.from = function (data) {
  return new Buffer(data)
}

},{"isarray":763}],763:[function(require,module,exports){
arguments[4][545][0].apply(exports,arguments)
},{"dup":545}],764:[function(require,module,exports){
(function (global){
/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],765:[function(require,module,exports){

/**
 * Module dependencies.
 */

var url = require('./url');
var parser = require('socket.io-parser');
var Manager = require('./manager');
var debug = require('debug')('socket.io-client');

/**
 * Module exports.
 */

module.exports = exports = lookup;

/**
 * Managers cache.
 */

var cache = exports.managers = {};

/**
 * Looks up an existing `Manager` for multiplexing.
 * If the user summons:
 *
 *   `io('http://localhost/a');`
 *   `io('http://localhost/b');`
 *
 * We reuse the existing instance based on same scheme/port/host,
 * and we initialize sockets for each namespace.
 *
 * @api public
 */

function lookup (uri, opts) {
  if (typeof uri === 'object') {
    opts = uri;
    uri = undefined;
  }

  opts = opts || {};

  var parsed = url(uri);
  var source = parsed.source;
  var id = parsed.id;
  var path = parsed.path;
  var sameNamespace = cache[id] && path in cache[id].nsps;
  var newConnection = opts.forceNew || opts['force new connection'] ||
                      false === opts.multiplex || sameNamespace;

  var io;

  if (newConnection) {
    debug('ignoring socket cache for %s', source);
    io = Manager(source, opts);
  } else {
    if (!cache[id]) {
      debug('new io instance for %s', source);
      cache[id] = Manager(source, opts);
    }
    io = cache[id];
  }
  if (parsed.query && !opts.query) {
    opts.query = parsed.query;
  }
  return io.socket(parsed.path, opts);
}

/**
 * Protocol version.
 *
 * @api public
 */

exports.protocol = parser.protocol;

/**
 * `connect`.
 *
 * @param {String} uri
 * @api public
 */

exports.connect = lookup;

/**
 * Expose constructors for standalone build.
 *
 * @api public
 */

exports.Manager = require('./manager');
exports.Socket = require('./socket');

},{"./manager":766,"./socket":768,"./url":769,"debug":770,"socket.io-parser":774}],766:[function(require,module,exports){

/**
 * Module dependencies.
 */

var eio = require('engine.io-client');
var Socket = require('./socket');
var Emitter = require('component-emitter');
var parser = require('socket.io-parser');
var on = require('./on');
var bind = require('component-bind');
var debug = require('debug')('socket.io-client:manager');
var indexOf = require('indexof');
var Backoff = require('backo2');

/**
 * IE6+ hasOwnProperty
 */

var has = Object.prototype.hasOwnProperty;

/**
 * Module exports
 */

module.exports = Manager;

/**
 * `Manager` constructor.
 *
 * @param {String} engine instance or engine uri/opts
 * @param {Object} options
 * @api public
 */

function Manager (uri, opts) {
  if (!(this instanceof Manager)) return new Manager(uri, opts);
  if (uri && ('object' === typeof uri)) {
    opts = uri;
    uri = undefined;
  }
  opts = opts || {};

  opts.path = opts.path || '/socket.io';
  this.nsps = {};
  this.subs = [];
  this.opts = opts;
  this.reconnection(opts.reconnection !== false);
  this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
  this.reconnectionDelay(opts.reconnectionDelay || 1000);
  this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
  this.randomizationFactor(opts.randomizationFactor || 0.5);
  this.backoff = new Backoff({
    min: this.reconnectionDelay(),
    max: this.reconnectionDelayMax(),
    jitter: this.randomizationFactor()
  });
  this.timeout(null == opts.timeout ? 20000 : opts.timeout);
  this.readyState = 'closed';
  this.uri = uri;
  this.connecting = [];
  this.lastPing = null;
  this.encoding = false;
  this.packetBuffer = [];
  var _parser = opts.parser || parser;
  this.encoder = new _parser.Encoder();
  this.decoder = new _parser.Decoder();
  this.autoConnect = opts.autoConnect !== false;
  if (this.autoConnect) this.open();
}

/**
 * Propagate given event to sockets and emit on `this`
 *
 * @api private
 */

Manager.prototype.emitAll = function () {
  this.emit.apply(this, arguments);
  for (var nsp in this.nsps) {
    if (has.call(this.nsps, nsp)) {
      this.nsps[nsp].emit.apply(this.nsps[nsp], arguments);
    }
  }
};

/**
 * Update `socket.id` of all sockets
 *
 * @api private
 */

Manager.prototype.updateSocketIds = function () {
  for (var nsp in this.nsps) {
    if (has.call(this.nsps, nsp)) {
      this.nsps[nsp].id = this.generateId(nsp);
    }
  }
};

/**
 * generate `socket.id` for the given `nsp`
 *
 * @param {String} nsp
 * @return {String}
 * @api private
 */

Manager.prototype.generateId = function (nsp) {
  return (nsp === '/' ? '' : (nsp + '#')) + this.engine.id;
};

/**
 * Mix in `Emitter`.
 */

Emitter(Manager.prototype);

/**
 * Sets the `reconnection` config.
 *
 * @param {Boolean} true/false if it should automatically reconnect
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.reconnection = function (v) {
  if (!arguments.length) return this._reconnection;
  this._reconnection = !!v;
  return this;
};

/**
 * Sets the reconnection attempts config.
 *
 * @param {Number} max reconnection attempts before giving up
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.reconnectionAttempts = function (v) {
  if (!arguments.length) return this._reconnectionAttempts;
  this._reconnectionAttempts = v;
  return this;
};

/**
 * Sets the delay between reconnections.
 *
 * @param {Number} delay
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.reconnectionDelay = function (v) {
  if (!arguments.length) return this._reconnectionDelay;
  this._reconnectionDelay = v;
  this.backoff && this.backoff.setMin(v);
  return this;
};

Manager.prototype.randomizationFactor = function (v) {
  if (!arguments.length) return this._randomizationFactor;
  this._randomizationFactor = v;
  this.backoff && this.backoff.setJitter(v);
  return this;
};

/**
 * Sets the maximum delay between reconnections.
 *
 * @param {Number} delay
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.reconnectionDelayMax = function (v) {
  if (!arguments.length) return this._reconnectionDelayMax;
  this._reconnectionDelayMax = v;
  this.backoff && this.backoff.setMax(v);
  return this;
};

/**
 * Sets the connection timeout. `false` to disable
 *
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.timeout = function (v) {
  if (!arguments.length) return this._timeout;
  this._timeout = v;
  return this;
};

/**
 * Starts trying to reconnect if reconnection is enabled and we have not
 * started reconnecting yet
 *
 * @api private
 */

Manager.prototype.maybeReconnectOnOpen = function () {
  // Only try to reconnect if it's the first time we're connecting
  if (!this.reconnecting && this._reconnection && this.backoff.attempts === 0) {
    // keeps reconnection from firing twice for the same reconnection loop
    this.reconnect();
  }
};

/**
 * Sets the current transport `socket`.
 *
 * @param {Function} optional, callback
 * @return {Manager} self
 * @api public
 */

Manager.prototype.open =
Manager.prototype.connect = function (fn, opts) {
  debug('readyState %s', this.readyState);
  if (~this.readyState.indexOf('open')) return this;

  debug('opening %s', this.uri);
  this.engine = eio(this.uri, this.opts);
  var socket = this.engine;
  var self = this;
  this.readyState = 'opening';
  this.skipReconnect = false;

  // emit `open`
  var openSub = on(socket, 'open', function () {
    self.onopen();
    fn && fn();
  });

  // emit `connect_error`
  var errorSub = on(socket, 'error', function (data) {
    debug('connect_error');
    self.cleanup();
    self.readyState = 'closed';
    self.emitAll('connect_error', data);
    if (fn) {
      var err = new Error('Connection error');
      err.data = data;
      fn(err);
    } else {
      // Only do this if there is no fn to handle the error
      self.maybeReconnectOnOpen();
    }
  });

  // emit `connect_timeout`
  if (false !== this._timeout) {
    var timeout = this._timeout;
    debug('connect attempt will timeout after %d', timeout);

    // set timer
    var timer = setTimeout(function () {
      debug('connect attempt timed out after %d', timeout);
      openSub.destroy();
      socket.close();
      socket.emit('error', 'timeout');
      self.emitAll('connect_timeout', timeout);
    }, timeout);

    this.subs.push({
      destroy: function () {
        clearTimeout(timer);
      }
    });
  }

  this.subs.push(openSub);
  this.subs.push(errorSub);

  return this;
};

/**
 * Called upon transport open.
 *
 * @api private
 */

Manager.prototype.onopen = function () {
  debug('open');

  // clear old subs
  this.cleanup();

  // mark as open
  this.readyState = 'open';
  this.emit('open');

  // add new subs
  var socket = this.engine;
  this.subs.push(on(socket, 'data', bind(this, 'ondata')));
  this.subs.push(on(socket, 'ping', bind(this, 'onping')));
  this.subs.push(on(socket, 'pong', bind(this, 'onpong')));
  this.subs.push(on(socket, 'error', bind(this, 'onerror')));
  this.subs.push(on(socket, 'close', bind(this, 'onclose')));
  this.subs.push(on(this.decoder, 'decoded', bind(this, 'ondecoded')));
};

/**
 * Called upon a ping.
 *
 * @api private
 */

Manager.prototype.onping = function () {
  this.lastPing = new Date();
  this.emitAll('ping');
};

/**
 * Called upon a packet.
 *
 * @api private
 */

Manager.prototype.onpong = function () {
  this.emitAll('pong', new Date() - this.lastPing);
};

/**
 * Called with data.
 *
 * @api private
 */

Manager.prototype.ondata = function (data) {
  this.decoder.add(data);
};

/**
 * Called when parser fully decodes a packet.
 *
 * @api private
 */

Manager.prototype.ondecoded = function (packet) {
  this.emit('packet', packet);
};

/**
 * Called upon socket error.
 *
 * @api private
 */

Manager.prototype.onerror = function (err) {
  debug('error', err);
  this.emitAll('error', err);
};

/**
 * Creates a new socket for the given `nsp`.
 *
 * @return {Socket}
 * @api public
 */

Manager.prototype.socket = function (nsp, opts) {
  var socket = this.nsps[nsp];
  if (!socket) {
    socket = new Socket(this, nsp, opts);
    this.nsps[nsp] = socket;
    var self = this;
    socket.on('connecting', onConnecting);
    socket.on('connect', function () {
      socket.id = self.generateId(nsp);
    });

    if (this.autoConnect) {
      // manually call here since connecting event is fired before listening
      onConnecting();
    }
  }

  function onConnecting () {
    if (!~indexOf(self.connecting, socket)) {
      self.connecting.push(socket);
    }
  }

  return socket;
};

/**
 * Called upon a socket close.
 *
 * @param {Socket} socket
 */

Manager.prototype.destroy = function (socket) {
  var index = indexOf(this.connecting, socket);
  if (~index) this.connecting.splice(index, 1);
  if (this.connecting.length) return;

  this.close();
};

/**
 * Writes a packet.
 *
 * @param {Object} packet
 * @api private
 */

Manager.prototype.packet = function (packet) {
  debug('writing packet %j', packet);
  var self = this;
  if (packet.query && packet.type === 0) packet.nsp += '?' + packet.query;

  if (!self.encoding) {
    // encode, then write to engine with result
    self.encoding = true;
    this.encoder.encode(packet, function (encodedPackets) {
      for (var i = 0; i < encodedPackets.length; i++) {
        self.engine.write(encodedPackets[i], packet.options);
      }
      self.encoding = false;
      self.processPacketQueue();
    });
  } else { // add packet to the queue
    self.packetBuffer.push(packet);
  }
};

/**
 * If packet buffer is non-empty, begins encoding the
 * next packet in line.
 *
 * @api private
 */

Manager.prototype.processPacketQueue = function () {
  if (this.packetBuffer.length > 0 && !this.encoding) {
    var pack = this.packetBuffer.shift();
    this.packet(pack);
  }
};

/**
 * Clean up transport subscriptions and packet buffer.
 *
 * @api private
 */

Manager.prototype.cleanup = function () {
  debug('cleanup');

  var subsLength = this.subs.length;
  for (var i = 0; i < subsLength; i++) {
    var sub = this.subs.shift();
    sub.destroy();
  }

  this.packetBuffer = [];
  this.encoding = false;
  this.lastPing = null;

  this.decoder.destroy();
};

/**
 * Close the current socket.
 *
 * @api private
 */

Manager.prototype.close =
Manager.prototype.disconnect = function () {
  debug('disconnect');
  this.skipReconnect = true;
  this.reconnecting = false;
  if ('opening' === this.readyState) {
    // `onclose` will not fire because
    // an open event never happened
    this.cleanup();
  }
  this.backoff.reset();
  this.readyState = 'closed';
  if (this.engine) this.engine.close();
};

/**
 * Called upon engine close.
 *
 * @api private
 */

Manager.prototype.onclose = function (reason) {
  debug('onclose');

  this.cleanup();
  this.backoff.reset();
  this.readyState = 'closed';
  this.emit('close', reason);

  if (this._reconnection && !this.skipReconnect) {
    this.reconnect();
  }
};

/**
 * Attempt a reconnection.
 *
 * @api private
 */

Manager.prototype.reconnect = function () {
  if (this.reconnecting || this.skipReconnect) return this;

  var self = this;

  if (this.backoff.attempts >= this._reconnectionAttempts) {
    debug('reconnect failed');
    this.backoff.reset();
    this.emitAll('reconnect_failed');
    this.reconnecting = false;
  } else {
    var delay = this.backoff.duration();
    debug('will wait %dms before reconnect attempt', delay);

    this.reconnecting = true;
    var timer = setTimeout(function () {
      if (self.skipReconnect) return;

      debug('attempting reconnect');
      self.emitAll('reconnect_attempt', self.backoff.attempts);
      self.emitAll('reconnecting', self.backoff.attempts);

      // check again for the case socket closed in above events
      if (self.skipReconnect) return;

      self.open(function (err) {
        if (err) {
          debug('reconnect attempt error');
          self.reconnecting = false;
          self.reconnect();
          self.emitAll('reconnect_error', err.data);
        } else {
          debug('reconnect success');
          self.onreconnect();
        }
      });
    }, delay);

    this.subs.push({
      destroy: function () {
        clearTimeout(timer);
      }
    });
  }
};

/**
 * Called upon successful reconnect.
 *
 * @api private
 */

Manager.prototype.onreconnect = function () {
  var attempt = this.backoff.attempts;
  this.reconnecting = false;
  this.backoff.reset();
  this.updateSocketIds();
  this.emitAll('reconnect', attempt);
};

},{"./on":767,"./socket":768,"backo2":76,"component-bind":83,"component-emitter":84,"debug":770,"engine.io-client":528,"indexof":548,"socket.io-parser":774}],767:[function(require,module,exports){

/**
 * Module exports.
 */

module.exports = on;

/**
 * Helper for subscriptions.
 *
 * @param {Object|EventEmitter} obj with `Emitter` mixin or `EventEmitter`
 * @param {String} event name
 * @param {Function} callback
 * @api public
 */

function on (obj, ev, fn) {
  obj.on(ev, fn);
  return {
    destroy: function () {
      obj.removeListener(ev, fn);
    }
  };
}

},{}],768:[function(require,module,exports){

/**
 * Module dependencies.
 */

var parser = require('socket.io-parser');
var Emitter = require('component-emitter');
var toArray = require('to-array');
var on = require('./on');
var bind = require('component-bind');
var debug = require('debug')('socket.io-client:socket');
var parseqs = require('parseqs');
var hasBin = require('has-binary2');

/**
 * Module exports.
 */

module.exports = exports = Socket;

/**
 * Internal events (blacklisted).
 * These events can't be emitted by the user.
 *
 * @api private
 */

var events = {
  connect: 1,
  connect_error: 1,
  connect_timeout: 1,
  connecting: 1,
  disconnect: 1,
  error: 1,
  reconnect: 1,
  reconnect_attempt: 1,
  reconnect_failed: 1,
  reconnect_error: 1,
  reconnecting: 1,
  ping: 1,
  pong: 1
};

/**
 * Shortcut to `Emitter#emit`.
 */

var emit = Emitter.prototype.emit;

/**
 * `Socket` constructor.
 *
 * @api public
 */

function Socket (io, nsp, opts) {
  this.io = io;
  this.nsp = nsp;
  this.json = this; // compat
  this.ids = 0;
  this.acks = {};
  this.receiveBuffer = [];
  this.sendBuffer = [];
  this.connected = false;
  this.disconnected = true;
  this.flags = {};
  if (opts && opts.query) {
    this.query = opts.query;
  }
  if (this.io.autoConnect) this.open();
}

/**
 * Mix in `Emitter`.
 */

Emitter(Socket.prototype);

/**
 * Subscribe to open, close and packet events
 *
 * @api private
 */

Socket.prototype.subEvents = function () {
  if (this.subs) return;

  var io = this.io;
  this.subs = [
    on(io, 'open', bind(this, 'onopen')),
    on(io, 'packet', bind(this, 'onpacket')),
    on(io, 'close', bind(this, 'onclose'))
  ];
};

/**
 * "Opens" the socket.
 *
 * @api public
 */

Socket.prototype.open =
Socket.prototype.connect = function () {
  if (this.connected) return this;

  this.subEvents();
  this.io.open(); // ensure open
  if ('open' === this.io.readyState) this.onopen();
  this.emit('connecting');
  return this;
};

/**
 * Sends a `message` event.
 *
 * @return {Socket} self
 * @api public
 */

Socket.prototype.send = function () {
  var args = toArray(arguments);
  args.unshift('message');
  this.emit.apply(this, args);
  return this;
};

/**
 * Override `emit`.
 * If the event is in `events`, it's emitted normally.
 *
 * @param {String} event name
 * @return {Socket} self
 * @api public
 */

Socket.prototype.emit = function (ev) {
  if (events.hasOwnProperty(ev)) {
    emit.apply(this, arguments);
    return this;
  }

  var args = toArray(arguments);
  var packet = {
    type: (this.flags.binary !== undefined ? this.flags.binary : hasBin(args)) ? parser.BINARY_EVENT : parser.EVENT,
    data: args
  };

  packet.options = {};
  packet.options.compress = !this.flags || false !== this.flags.compress;

  // event ack callback
  if ('function' === typeof args[args.length - 1]) {
    debug('emitting packet with ack id %d', this.ids);
    this.acks[this.ids] = args.pop();
    packet.id = this.ids++;
  }

  if (this.connected) {
    this.packet(packet);
  } else {
    this.sendBuffer.push(packet);
  }

  this.flags = {};

  return this;
};

/**
 * Sends a packet.
 *
 * @param {Object} packet
 * @api private
 */

Socket.prototype.packet = function (packet) {
  packet.nsp = this.nsp;
  this.io.packet(packet);
};

/**
 * Called upon engine `open`.
 *
 * @api private
 */

Socket.prototype.onopen = function () {
  debug('transport is open - connecting');

  // write connect packet if necessary
  if ('/' !== this.nsp) {
    if (this.query) {
      var query = typeof this.query === 'object' ? parseqs.encode(this.query) : this.query;
      debug('sending connect packet with query %s', query);
      this.packet({type: parser.CONNECT, query: query});
    } else {
      this.packet({type: parser.CONNECT});
    }
  }
};

/**
 * Called upon engine `close`.
 *
 * @param {String} reason
 * @api private
 */

Socket.prototype.onclose = function (reason) {
  debug('close (%s)', reason);
  this.connected = false;
  this.disconnected = true;
  delete this.id;
  this.emit('disconnect', reason);
};

/**
 * Called with socket packet.
 *
 * @param {Object} packet
 * @api private
 */

Socket.prototype.onpacket = function (packet) {
  var sameNamespace = packet.nsp === this.nsp;
  var rootNamespaceError = packet.type === parser.ERROR && packet.nsp === '/';

  if (!sameNamespace && !rootNamespaceError) return;

  switch (packet.type) {
    case parser.CONNECT:
      this.onconnect();
      break;

    case parser.EVENT:
      this.onevent(packet);
      break;

    case parser.BINARY_EVENT:
      this.onevent(packet);
      break;

    case parser.ACK:
      this.onack(packet);
      break;

    case parser.BINARY_ACK:
      this.onack(packet);
      break;

    case parser.DISCONNECT:
      this.ondisconnect();
      break;

    case parser.ERROR:
      this.emit('error', packet.data);
      break;
  }
};

/**
 * Called upon a server event.
 *
 * @param {Object} packet
 * @api private
 */

Socket.prototype.onevent = function (packet) {
  var args = packet.data || [];
  debug('emitting event %j', args);

  if (null != packet.id) {
    debug('attaching ack callback to event');
    args.push(this.ack(packet.id));
  }

  if (this.connected) {
    emit.apply(this, args);
  } else {
    this.receiveBuffer.push(args);
  }
};

/**
 * Produces an ack callback to emit with an event.
 *
 * @api private
 */

Socket.prototype.ack = function (id) {
  var self = this;
  var sent = false;
  return function () {
    // prevent double callbacks
    if (sent) return;
    sent = true;
    var args = toArray(arguments);
    debug('sending ack %j', args);

    self.packet({
      type: hasBin(args) ? parser.BINARY_ACK : parser.ACK,
      id: id,
      data: args
    });
  };
};

/**
 * Called upon a server acknowlegement.
 *
 * @param {Object} packet
 * @api private
 */

Socket.prototype.onack = function (packet) {
  var ack = this.acks[packet.id];
  if ('function' === typeof ack) {
    debug('calling ack %s with %j', packet.id, packet.data);
    ack.apply(this, packet.data);
    delete this.acks[packet.id];
  } else {
    debug('bad ack %s', packet.id);
  }
};

/**
 * Called upon server connect.
 *
 * @api private
 */

Socket.prototype.onconnect = function () {
  this.connected = true;
  this.disconnected = false;
  this.emit('connect');
  this.emitBuffered();
};

/**
 * Emit buffered events (received and emitted).
 *
 * @api private
 */

Socket.prototype.emitBuffered = function () {
  var i;
  for (i = 0; i < this.receiveBuffer.length; i++) {
    emit.apply(this, this.receiveBuffer[i]);
  }
  this.receiveBuffer = [];

  for (i = 0; i < this.sendBuffer.length; i++) {
    this.packet(this.sendBuffer[i]);
  }
  this.sendBuffer = [];
};

/**
 * Called upon server disconnect.
 *
 * @api private
 */

Socket.prototype.ondisconnect = function () {
  debug('server disconnect (%s)', this.nsp);
  this.destroy();
  this.onclose('io server disconnect');
};

/**
 * Called upon forced client/server side disconnections,
 * this method ensures the manager stops tracking us and
 * that reconnections don't get triggered for this.
 *
 * @api private.
 */

Socket.prototype.destroy = function () {
  if (this.subs) {
    // clean subscriptions to avoid reconnections
    for (var i = 0; i < this.subs.length; i++) {
      this.subs[i].destroy();
    }
    this.subs = null;
  }

  this.io.destroy(this);
};

/**
 * Disconnects the socket manually.
 *
 * @return {Socket} self
 * @api public
 */

Socket.prototype.close =
Socket.prototype.disconnect = function () {
  if (this.connected) {
    debug('performing disconnect (%s)', this.nsp);
    this.packet({ type: parser.DISCONNECT });
  }

  // remove socket from pool
  this.destroy();

  if (this.connected) {
    // fire events
    this.onclose('io client disconnect');
  }
  return this;
};

/**
 * Sets the compress flag.
 *
 * @param {Boolean} if `true`, compresses the sending data
 * @return {Socket} self
 * @api public
 */

Socket.prototype.compress = function (compress) {
  this.flags.compress = compress;
  return this;
};

/**
 * Sets the binary flag
 *
 * @param {Boolean} whether the emitted data contains binary
 * @return {Socket} self
 * @api public
 */

Socket.prototype.binary = function (binary) {
  this.flags.binary = binary;
  return this;
};

},{"./on":767,"component-bind":83,"component-emitter":84,"debug":770,"has-binary2":544,"parseqs":729,"socket.io-parser":774,"to-array":781}],769:[function(require,module,exports){

/**
 * Module dependencies.
 */

var parseuri = require('parseuri');
var debug = require('debug')('socket.io-client:url');

/**
 * Module exports.
 */

module.exports = url;

/**
 * URL parser.
 *
 * @param {String} url
 * @param {Object} An object meant to mimic window.location.
 *                 Defaults to window.location.
 * @api public
 */

function url (uri, loc) {
  var obj = uri;

  // default to window.location
  loc = loc || (typeof location !== 'undefined' && location);
  if (null == uri) uri = loc.protocol + '//' + loc.host;

  // relative path support
  if ('string' === typeof uri) {
    if ('/' === uri.charAt(0)) {
      if ('/' === uri.charAt(1)) {
        uri = loc.protocol + uri;
      } else {
        uri = loc.host + uri;
      }
    }

    if (!/^(https?|wss?):\/\//.test(uri)) {
      debug('protocol-less url %s', uri);
      if ('undefined' !== typeof loc) {
        uri = loc.protocol + '//' + uri;
      } else {
        uri = 'https://' + uri;
      }
    }

    // parse
    debug('parse %s', uri);
    obj = parseuri(uri);
  }

  // make sure we treat `localhost:80` and `localhost` equally
  if (!obj.port) {
    if (/^(http|ws)$/.test(obj.protocol)) {
      obj.port = '80';
    } else if (/^(http|ws)s$/.test(obj.protocol)) {
      obj.port = '443';
    }
  }

  obj.path = obj.path || '/';

  var ipv6 = obj.host.indexOf(':') !== -1;
  var host = ipv6 ? '[' + obj.host + ']' : obj.host;

  // define unique id
  obj.id = obj.protocol + '://' + host + ':' + obj.port;
  // define href
  obj.href = obj.protocol + '://' + host + (loc && loc.port === obj.port ? '' : (':' + obj.port));

  return obj;
}

},{"debug":770,"parseuri":730}],770:[function(require,module,exports){
arguments[4][538][0].apply(exports,arguments)
},{"./common":771,"_process":734,"dup":538}],771:[function(require,module,exports){
arguments[4][539][0].apply(exports,arguments)
},{"dup":539,"ms":772}],772:[function(require,module,exports){
arguments[4][540][0].apply(exports,arguments)
},{"dup":540}],773:[function(require,module,exports){
/*global Blob,File*/

/**
 * Module requirements
 */

var isArray = require('isarray');
var isBuf = require('./is-buffer');
var toString = Object.prototype.toString;
var withNativeBlob = typeof Blob === 'function' || (typeof Blob !== 'undefined' && toString.call(Blob) === '[object BlobConstructor]');
var withNativeFile = typeof File === 'function' || (typeof File !== 'undefined' && toString.call(File) === '[object FileConstructor]');

/**
 * Replaces every Buffer | ArrayBuffer in packet with a numbered placeholder.
 * Anything with blobs or files should be fed through removeBlobs before coming
 * here.
 *
 * @param {Object} packet - socket.io event packet
 * @return {Object} with deconstructed packet and list of buffers
 * @api public
 */

exports.deconstructPacket = function(packet) {
  var buffers = [];
  var packetData = packet.data;
  var pack = packet;
  pack.data = _deconstructPacket(packetData, buffers);
  pack.attachments = buffers.length; // number of binary 'attachments'
  return {packet: pack, buffers: buffers};
};

function _deconstructPacket(data, buffers) {
  if (!data) return data;

  if (isBuf(data)) {
    var placeholder = { _placeholder: true, num: buffers.length };
    buffers.push(data);
    return placeholder;
  } else if (isArray(data)) {
    var newData = new Array(data.length);
    for (var i = 0; i < data.length; i++) {
      newData[i] = _deconstructPacket(data[i], buffers);
    }
    return newData;
  } else if (typeof data === 'object' && !(data instanceof Date)) {
    var newData = {};
    for (var key in data) {
      newData[key] = _deconstructPacket(data[key], buffers);
    }
    return newData;
  }
  return data;
}

/**
 * Reconstructs a binary packet from its placeholder packet and buffers
 *
 * @param {Object} packet - event packet with placeholders
 * @param {Array} buffers - binary buffers to put in placeholder positions
 * @return {Object} reconstructed packet
 * @api public
 */

exports.reconstructPacket = function(packet, buffers) {
  packet.data = _reconstructPacket(packet.data, buffers);
  packet.attachments = undefined; // no longer useful
  return packet;
};

function _reconstructPacket(data, buffers) {
  if (!data) return data;

  if (data && data._placeholder) {
    return buffers[data.num]; // appropriate buffer (should be natural order anyway)
  } else if (isArray(data)) {
    for (var i = 0; i < data.length; i++) {
      data[i] = _reconstructPacket(data[i], buffers);
    }
  } else if (typeof data === 'object') {
    for (var key in data) {
      data[key] = _reconstructPacket(data[key], buffers);
    }
  }

  return data;
}

/**
 * Asynchronously removes Blobs or Files from data via
 * FileReader's readAsArrayBuffer method. Used before encoding
 * data as msgpack. Calls callback with the blobless data.
 *
 * @param {Object} data
 * @param {Function} callback
 * @api private
 */

exports.removeBlobs = function(data, callback) {
  function _removeBlobs(obj, curKey, containingObject) {
    if (!obj) return obj;

    // convert any blob
    if ((withNativeBlob && obj instanceof Blob) ||
        (withNativeFile && obj instanceof File)) {
      pendingBlobs++;

      // async filereader
      var fileReader = new FileReader();
      fileReader.onload = function() { // this.result == arraybuffer
        if (containingObject) {
          containingObject[curKey] = this.result;
        }
        else {
          bloblessData = this.result;
        }

        // if nothing pending its callback time
        if(! --pendingBlobs) {
          callback(bloblessData);
        }
      };

      fileReader.readAsArrayBuffer(obj); // blob -> arraybuffer
    } else if (isArray(obj)) { // handle array
      for (var i = 0; i < obj.length; i++) {
        _removeBlobs(obj[i], i, obj);
      }
    } else if (typeof obj === 'object' && !isBuf(obj)) { // and object
      for (var key in obj) {
        _removeBlobs(obj[key], key, obj);
      }
    }
  }

  var pendingBlobs = 0;
  var bloblessData = data;
  _removeBlobs(bloblessData);
  if (!pendingBlobs) {
    callback(bloblessData);
  }
};

},{"./is-buffer":775,"isarray":778}],774:[function(require,module,exports){

/**
 * Module dependencies.
 */

var debug = require('debug')('socket.io-parser');
var Emitter = require('component-emitter');
var binary = require('./binary');
var isArray = require('isarray');
var isBuf = require('./is-buffer');

/**
 * Protocol version.
 *
 * @api public
 */

exports.protocol = 4;

/**
 * Packet types.
 *
 * @api public
 */

exports.types = [
  'CONNECT',
  'DISCONNECT',
  'EVENT',
  'ACK',
  'ERROR',
  'BINARY_EVENT',
  'BINARY_ACK'
];

/**
 * Packet type `connect`.
 *
 * @api public
 */

exports.CONNECT = 0;

/**
 * Packet type `disconnect`.
 *
 * @api public
 */

exports.DISCONNECT = 1;

/**
 * Packet type `event`.
 *
 * @api public
 */

exports.EVENT = 2;

/**
 * Packet type `ack`.
 *
 * @api public
 */

exports.ACK = 3;

/**
 * Packet type `error`.
 *
 * @api public
 */

exports.ERROR = 4;

/**
 * Packet type 'binary event'
 *
 * @api public
 */

exports.BINARY_EVENT = 5;

/**
 * Packet type `binary ack`. For acks with binary arguments.
 *
 * @api public
 */

exports.BINARY_ACK = 6;

/**
 * Encoder constructor.
 *
 * @api public
 */

exports.Encoder = Encoder;

/**
 * Decoder constructor.
 *
 * @api public
 */

exports.Decoder = Decoder;

/**
 * A socket.io Encoder instance
 *
 * @api public
 */

function Encoder() {}

var ERROR_PACKET = exports.ERROR + '"encode error"';

/**
 * Encode a packet as a single string if non-binary, or as a
 * buffer sequence, depending on packet type.
 *
 * @param {Object} obj - packet object
 * @param {Function} callback - function to handle encodings (likely engine.write)
 * @return Calls callback with Array of encodings
 * @api public
 */

Encoder.prototype.encode = function(obj, callback){
  debug('encoding packet %j', obj);

  if (exports.BINARY_EVENT === obj.type || exports.BINARY_ACK === obj.type) {
    encodeAsBinary(obj, callback);
  } else {
    var encoding = encodeAsString(obj);
    callback([encoding]);
  }
};

/**
 * Encode packet as string.
 *
 * @param {Object} packet
 * @return {String} encoded
 * @api private
 */

function encodeAsString(obj) {

  // first is type
  var str = '' + obj.type;

  // attachments if we have them
  if (exports.BINARY_EVENT === obj.type || exports.BINARY_ACK === obj.type) {
    str += obj.attachments + '-';
  }

  // if we have a namespace other than `/`
  // we append it followed by a comma `,`
  if (obj.nsp && '/' !== obj.nsp) {
    str += obj.nsp + ',';
  }

  // immediately followed by the id
  if (null != obj.id) {
    str += obj.id;
  }

  // json data
  if (null != obj.data) {
    var payload = tryStringify(obj.data);
    if (payload !== false) {
      str += payload;
    } else {
      return ERROR_PACKET;
    }
  }

  debug('encoded %j as %s', obj, str);
  return str;
}

function tryStringify(str) {
  try {
    return JSON.stringify(str);
  } catch(e){
    return false;
  }
}

/**
 * Encode packet as 'buffer sequence' by removing blobs, and
 * deconstructing packet into object with placeholders and
 * a list of buffers.
 *
 * @param {Object} packet
 * @return {Buffer} encoded
 * @api private
 */

function encodeAsBinary(obj, callback) {

  function writeEncoding(bloblessData) {
    var deconstruction = binary.deconstructPacket(bloblessData);
    var pack = encodeAsString(deconstruction.packet);
    var buffers = deconstruction.buffers;

    buffers.unshift(pack); // add packet info to beginning of data list
    callback(buffers); // write all the buffers
  }

  binary.removeBlobs(obj, writeEncoding);
}

/**
 * A socket.io Decoder instance
 *
 * @return {Object} decoder
 * @api public
 */

function Decoder() {
  this.reconstructor = null;
}

/**
 * Mix in `Emitter` with Decoder.
 */

Emitter(Decoder.prototype);

/**
 * Decodes an encoded packet string into packet JSON.
 *
 * @param {String} obj - encoded packet
 * @return {Object} packet
 * @api public
 */

Decoder.prototype.add = function(obj) {
  var packet;
  if (typeof obj === 'string') {
    packet = decodeString(obj);
    if (exports.BINARY_EVENT === packet.type || exports.BINARY_ACK === packet.type) { // binary packet's json
      this.reconstructor = new BinaryReconstructor(packet);

      // no attachments, labeled binary but no binary data to follow
      if (this.reconstructor.reconPack.attachments === 0) {
        this.emit('decoded', packet);
      }
    } else { // non-binary full packet
      this.emit('decoded', packet);
    }
  } else if (isBuf(obj) || obj.base64) { // raw binary data
    if (!this.reconstructor) {
      throw new Error('got binary data when not reconstructing a packet');
    } else {
      packet = this.reconstructor.takeBinaryData(obj);
      if (packet) { // received final buffer
        this.reconstructor = null;
        this.emit('decoded', packet);
      }
    }
  } else {
    throw new Error('Unknown type: ' + obj);
  }
};

/**
 * Decode a packet String (JSON data)
 *
 * @param {String} str
 * @return {Object} packet
 * @api private
 */

function decodeString(str) {
  var i = 0;
  // look up type
  var p = {
    type: Number(str.charAt(0))
  };

  if (null == exports.types[p.type]) {
    return error('unknown packet type ' + p.type);
  }

  // look up attachments if type binary
  if (exports.BINARY_EVENT === p.type || exports.BINARY_ACK === p.type) {
    var buf = '';
    while (str.charAt(++i) !== '-') {
      buf += str.charAt(i);
      if (i == str.length) break;
    }
    if (buf != Number(buf) || str.charAt(i) !== '-') {
      throw new Error('Illegal attachments');
    }
    p.attachments = Number(buf);
  }

  // look up namespace (if any)
  if ('/' === str.charAt(i + 1)) {
    p.nsp = '';
    while (++i) {
      var c = str.charAt(i);
      if (',' === c) break;
      p.nsp += c;
      if (i === str.length) break;
    }
  } else {
    p.nsp = '/';
  }

  // look up id
  var next = str.charAt(i + 1);
  if ('' !== next && Number(next) == next) {
    p.id = '';
    while (++i) {
      var c = str.charAt(i);
      if (null == c || Number(c) != c) {
        --i;
        break;
      }
      p.id += str.charAt(i);
      if (i === str.length) break;
    }
    p.id = Number(p.id);
  }

  // look up json data
  if (str.charAt(++i)) {
    var payload = tryParse(str.substr(i));
    var isPayloadValid = payload !== false && (p.type === exports.ERROR || isArray(payload));
    if (isPayloadValid) {
      p.data = payload;
    } else {
      return error('invalid payload');
    }
  }

  debug('decoded %s as %j', str, p);
  return p;
}

function tryParse(str) {
  try {
    return JSON.parse(str);
  } catch(e){
    return false;
  }
}

/**
 * Deallocates a parser's resources
 *
 * @api public
 */

Decoder.prototype.destroy = function() {
  if (this.reconstructor) {
    this.reconstructor.finishedReconstruction();
  }
};

/**
 * A manager of a binary event's 'buffer sequence'. Should
 * be constructed whenever a packet of type BINARY_EVENT is
 * decoded.
 *
 * @param {Object} packet
 * @return {BinaryReconstructor} initialized reconstructor
 * @api private
 */

function BinaryReconstructor(packet) {
  this.reconPack = packet;
  this.buffers = [];
}

/**
 * Method to be called when binary data received from connection
 * after a BINARY_EVENT packet.
 *
 * @param {Buffer | ArrayBuffer} binData - the raw binary data received
 * @return {null | Object} returns null if more binary data is expected or
 *   a reconstructed packet object if all buffers have been received.
 * @api private
 */

BinaryReconstructor.prototype.takeBinaryData = function(binData) {
  this.buffers.push(binData);
  if (this.buffers.length === this.reconPack.attachments) { // done with buffer list
    var packet = binary.reconstructPacket(this.reconPack, this.buffers);
    this.finishedReconstruction();
    return packet;
  }
  return null;
};

/**
 * Cleans up binary packet reconstruction variables.
 *
 * @api private
 */

BinaryReconstructor.prototype.finishedReconstruction = function() {
  this.reconPack = null;
  this.buffers = [];
};

function error(msg) {
  return {
    type: exports.ERROR,
    data: 'parser error: ' + msg
  };
}

},{"./binary":773,"./is-buffer":775,"component-emitter":84,"debug":776,"isarray":778}],775:[function(require,module,exports){
(function (Buffer){

module.exports = isBuf;

var withNativeBuffer = typeof Buffer === 'function' && typeof Buffer.isBuffer === 'function';
var withNativeArrayBuffer = typeof ArrayBuffer === 'function';

var isView = function (obj) {
  return typeof ArrayBuffer.isView === 'function' ? ArrayBuffer.isView(obj) : (obj.buffer instanceof ArrayBuffer);
};

/**
 * Returns true if obj is a buffer or an arraybuffer.
 *
 * @api private
 */

function isBuf(obj) {
  return (withNativeBuffer && Buffer.isBuffer(obj)) ||
          (withNativeArrayBuffer && (obj instanceof ArrayBuffer || isView(obj)));
}

}).call(this,require("buffer").Buffer)
},{"buffer":81}],776:[function(require,module,exports){
(function (process){
/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = require('./debug');
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  '#0000CC', '#0000FF', '#0033CC', '#0033FF', '#0066CC', '#0066FF', '#0099CC',
  '#0099FF', '#00CC00', '#00CC33', '#00CC66', '#00CC99', '#00CCCC', '#00CCFF',
  '#3300CC', '#3300FF', '#3333CC', '#3333FF', '#3366CC', '#3366FF', '#3399CC',
  '#3399FF', '#33CC00', '#33CC33', '#33CC66', '#33CC99', '#33CCCC', '#33CCFF',
  '#6600CC', '#6600FF', '#6633CC', '#6633FF', '#66CC00', '#66CC33', '#9900CC',
  '#9900FF', '#9933CC', '#9933FF', '#99CC00', '#99CC33', '#CC0000', '#CC0033',
  '#CC0066', '#CC0099', '#CC00CC', '#CC00FF', '#CC3300', '#CC3333', '#CC3366',
  '#CC3399', '#CC33CC', '#CC33FF', '#CC6600', '#CC6633', '#CC9900', '#CC9933',
  '#CCCC00', '#CCCC33', '#FF0000', '#FF0033', '#FF0066', '#FF0099', '#FF00CC',
  '#FF00FF', '#FF3300', '#FF3333', '#FF3366', '#FF3399', '#FF33CC', '#FF33FF',
  '#FF6600', '#FF6633', '#FF9900', '#FF9933', '#FFCC00', '#FFCC33'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // Internet Explorer and Edge do not support colors.
  if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
    return false;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = process.env.DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}

}).call(this,require('_process'))
},{"./debug":777,"_process":734}],777:[function(require,module,exports){

/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = require('ms');

/**
 * Active `debug` instances.
 */
exports.instances = [];

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  var prevTime;

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);
  debug.destroy = destroy;

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  exports.instances.push(debug);

  return debug;
}

function destroy () {
  var index = exports.instances.indexOf(this);
  if (index !== -1) {
    exports.instances.splice(index, 1);
    return true;
  } else {
    return false;
  }
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var i;
  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }

  for (i = 0; i < exports.instances.length; i++) {
    var instance = exports.instances[i];
    instance.enabled = exports.enabled(instance.namespace);
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  if (name[name.length - 1] === '*') {
    return true;
  }
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}

},{"ms":728}],778:[function(require,module,exports){
arguments[4][545][0].apply(exports,arguments)
},{"dup":545}],779:[function(require,module,exports){
/**
 * Swiper 4.5.1
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://www.idangero.us/swiper/
 *
 * Copyright 2014-2019 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: September 13, 2019
 */

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = global || self, global.Swiper = factory());
}(this, function () { 'use strict';

  /**
   * SSR Window 1.0.1
   * Better handling for window object in SSR environment
   * https://github.com/nolimits4web/ssr-window
   *
   * Copyright 2018, Vladimir Kharlampidi
   *
   * Licensed under MIT
   *
   * Released on: July 18, 2018
   */
  var doc = (typeof document === 'undefined') ? {
    body: {},
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {},
    activeElement: {
      blur: function blur() {},
      nodeName: '',
    },
    querySelector: function querySelector() {
      return null;
    },
    querySelectorAll: function querySelectorAll() {
      return [];
    },
    getElementById: function getElementById() {
      return null;
    },
    createEvent: function createEvent() {
      return {
        initEvent: function initEvent() {},
      };
    },
    createElement: function createElement() {
      return {
        children: [],
        childNodes: [],
        style: {},
        setAttribute: function setAttribute() {},
        getElementsByTagName: function getElementsByTagName() {
          return [];
        },
      };
    },
    location: { hash: '' },
  } : document; // eslint-disable-line

  var win = (typeof window === 'undefined') ? {
    document: doc,
    navigator: {
      userAgent: '',
    },
    location: {},
    history: {},
    CustomEvent: function CustomEvent() {
      return this;
    },
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {},
    getComputedStyle: function getComputedStyle() {
      return {
        getPropertyValue: function getPropertyValue() {
          return '';
        },
      };
    },
    Image: function Image() {},
    Date: function Date() {},
    screen: {},
    setTimeout: function setTimeout() {},
    clearTimeout: function clearTimeout() {},
  } : window; // eslint-disable-line

  /**
   * Dom7 2.1.3
   * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
   * http://framework7.io/docs/dom.html
   *
   * Copyright 2019, Vladimir Kharlampidi
   * The iDangero.us
   * http://www.idangero.us/
   *
   * Licensed under MIT
   *
   * Released on: February 11, 2019
   */

  var Dom7 = function Dom7(arr) {
    var self = this;
    // Create array-like object
    for (var i = 0; i < arr.length; i += 1) {
      self[i] = arr[i];
    }
    self.length = arr.length;
    // Return collection with methods
    return this;
  };

  function $(selector, context) {
    var arr = [];
    var i = 0;
    if (selector && !context) {
      if (selector instanceof Dom7) {
        return selector;
      }
    }
    if (selector) {
        // String
      if (typeof selector === 'string') {
        var els;
        var tempParent;
        var html = selector.trim();
        if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
          var toCreate = 'div';
          if (html.indexOf('<li') === 0) { toCreate = 'ul'; }
          if (html.indexOf('<tr') === 0) { toCreate = 'tbody'; }
          if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) { toCreate = 'tr'; }
          if (html.indexOf('<tbody') === 0) { toCreate = 'table'; }
          if (html.indexOf('<option') === 0) { toCreate = 'select'; }
          tempParent = doc.createElement(toCreate);
          tempParent.innerHTML = html;
          for (i = 0; i < tempParent.childNodes.length; i += 1) {
            arr.push(tempParent.childNodes[i]);
          }
        } else {
          if (!context && selector[0] === '#' && !selector.match(/[ .<>:~]/)) {
            // Pure ID selector
            els = [doc.getElementById(selector.trim().split('#')[1])];
          } else {
            // Other selectors
            els = (context || doc).querySelectorAll(selector.trim());
          }
          for (i = 0; i < els.length; i += 1) {
            if (els[i]) { arr.push(els[i]); }
          }
        }
      } else if (selector.nodeType || selector === win || selector === doc) {
        // Node/element
        arr.push(selector);
      } else if (selector.length > 0 && selector[0].nodeType) {
        // Array of elements or instance of Dom
        for (i = 0; i < selector.length; i += 1) {
          arr.push(selector[i]);
        }
      }
    }
    return new Dom7(arr);
  }

  $.fn = Dom7.prototype;
  $.Class = Dom7;
  $.Dom7 = Dom7;

  function unique(arr) {
    var uniqueArray = [];
    for (var i = 0; i < arr.length; i += 1) {
      if (uniqueArray.indexOf(arr[i]) === -1) { uniqueArray.push(arr[i]); }
    }
    return uniqueArray;
  }

  // Classes and attributes
  function addClass(className) {
    if (typeof className === 'undefined') {
      return this;
    }
    var classes = className.split(' ');
    for (var i = 0; i < classes.length; i += 1) {
      for (var j = 0; j < this.length; j += 1) {
        if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') { this[j].classList.add(classes[i]); }
      }
    }
    return this;
  }
  function removeClass(className) {
    var classes = className.split(' ');
    for (var i = 0; i < classes.length; i += 1) {
      for (var j = 0; j < this.length; j += 1) {
        if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') { this[j].classList.remove(classes[i]); }
      }
    }
    return this;
  }
  function hasClass(className) {
    if (!this[0]) { return false; }
    return this[0].classList.contains(className);
  }
  function toggleClass(className) {
    var classes = className.split(' ');
    for (var i = 0; i < classes.length; i += 1) {
      for (var j = 0; j < this.length; j += 1) {
        if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') { this[j].classList.toggle(classes[i]); }
      }
    }
    return this;
  }
  function attr(attrs, value) {
    var arguments$1 = arguments;

    if (arguments.length === 1 && typeof attrs === 'string') {
      // Get attr
      if (this[0]) { return this[0].getAttribute(attrs); }
      return undefined;
    }

    // Set attrs
    for (var i = 0; i < this.length; i += 1) {
      if (arguments$1.length === 2) {
        // String
        this[i].setAttribute(attrs, value);
      } else {
        // Object
        // eslint-disable-next-line
        for (var attrName in attrs) {
          this[i][attrName] = attrs[attrName];
          this[i].setAttribute(attrName, attrs[attrName]);
        }
      }
    }
    return this;
  }
  // eslint-disable-next-line
  function removeAttr(attr) {
    for (var i = 0; i < this.length; i += 1) {
      this[i].removeAttribute(attr);
    }
    return this;
  }
  function data(key, value) {
    var el;
    if (typeof value === 'undefined') {
      el = this[0];
      // Get value
      if (el) {
        if (el.dom7ElementDataStorage && (key in el.dom7ElementDataStorage)) {
          return el.dom7ElementDataStorage[key];
        }

        var dataKey = el.getAttribute(("data-" + key));
        if (dataKey) {
          return dataKey;
        }
        return undefined;
      }
      return undefined;
    }

    // Set value
    for (var i = 0; i < this.length; i += 1) {
      el = this[i];
      if (!el.dom7ElementDataStorage) { el.dom7ElementDataStorage = {}; }
      el.dom7ElementDataStorage[key] = value;
    }
    return this;
  }
  // Transforms
  // eslint-disable-next-line
  function transform(transform) {
    for (var i = 0; i < this.length; i += 1) {
      var elStyle = this[i].style;
      elStyle.webkitTransform = transform;
      elStyle.transform = transform;
    }
    return this;
  }
  function transition(duration) {
    if (typeof duration !== 'string') {
      duration = duration + "ms"; // eslint-disable-line
    }
    for (var i = 0; i < this.length; i += 1) {
      var elStyle = this[i].style;
      elStyle.webkitTransitionDuration = duration;
      elStyle.transitionDuration = duration;
    }
    return this;
  }
  // Events
  function on() {
    var assign;

    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];
    var eventType = args[0];
    var targetSelector = args[1];
    var listener = args[2];
    var capture = args[3];
    if (typeof args[1] === 'function') {
      (assign = args, eventType = assign[0], listener = assign[1], capture = assign[2]);
      targetSelector = undefined;
    }
    if (!capture) { capture = false; }

    function handleLiveEvent(e) {
      var target = e.target;
      if (!target) { return; }
      var eventData = e.target.dom7EventData || [];
      if (eventData.indexOf(e) < 0) {
        eventData.unshift(e);
      }
      if ($(target).is(targetSelector)) { listener.apply(target, eventData); }
      else {
        var parents = $(target).parents(); // eslint-disable-line
        for (var k = 0; k < parents.length; k += 1) {
          if ($(parents[k]).is(targetSelector)) { listener.apply(parents[k], eventData); }
        }
      }
    }
    function handleEvent(e) {
      var eventData = e && e.target ? e.target.dom7EventData || [] : [];
      if (eventData.indexOf(e) < 0) {
        eventData.unshift(e);
      }
      listener.apply(this, eventData);
    }
    var events = eventType.split(' ');
    var j;
    for (var i = 0; i < this.length; i += 1) {
      var el = this[i];
      if (!targetSelector) {
        for (j = 0; j < events.length; j += 1) {
          var event = events[j];
          if (!el.dom7Listeners) { el.dom7Listeners = {}; }
          if (!el.dom7Listeners[event]) { el.dom7Listeners[event] = []; }
          el.dom7Listeners[event].push({
            listener: listener,
            proxyListener: handleEvent,
          });
          el.addEventListener(event, handleEvent, capture);
        }
      } else {
        // Live events
        for (j = 0; j < events.length; j += 1) {
          var event$1 = events[j];
          if (!el.dom7LiveListeners) { el.dom7LiveListeners = {}; }
          if (!el.dom7LiveListeners[event$1]) { el.dom7LiveListeners[event$1] = []; }
          el.dom7LiveListeners[event$1].push({
            listener: listener,
            proxyListener: handleLiveEvent,
          });
          el.addEventListener(event$1, handleLiveEvent, capture);
        }
      }
    }
    return this;
  }
  function off() {
    var assign;

    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];
    var eventType = args[0];
    var targetSelector = args[1];
    var listener = args[2];
    var capture = args[3];
    if (typeof args[1] === 'function') {
      (assign = args, eventType = assign[0], listener = assign[1], capture = assign[2]);
      targetSelector = undefined;
    }
    if (!capture) { capture = false; }

    var events = eventType.split(' ');
    for (var i = 0; i < events.length; i += 1) {
      var event = events[i];
      for (var j = 0; j < this.length; j += 1) {
        var el = this[j];
        var handlers = (void 0);
        if (!targetSelector && el.dom7Listeners) {
          handlers = el.dom7Listeners[event];
        } else if (targetSelector && el.dom7LiveListeners) {
          handlers = el.dom7LiveListeners[event];
        }
        if (handlers && handlers.length) {
          for (var k = handlers.length - 1; k >= 0; k -= 1) {
            var handler = handlers[k];
            if (listener && handler.listener === listener) {
              el.removeEventListener(event, handler.proxyListener, capture);
              handlers.splice(k, 1);
            } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
              el.removeEventListener(event, handler.proxyListener, capture);
              handlers.splice(k, 1);
            } else if (!listener) {
              el.removeEventListener(event, handler.proxyListener, capture);
              handlers.splice(k, 1);
            }
          }
        }
      }
    }
    return this;
  }
  function trigger() {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var events = args[0].split(' ');
    var eventData = args[1];
    for (var i = 0; i < events.length; i += 1) {
      var event = events[i];
      for (var j = 0; j < this.length; j += 1) {
        var el = this[j];
        var evt = (void 0);
        try {
          evt = new win.CustomEvent(event, {
            detail: eventData,
            bubbles: true,
            cancelable: true,
          });
        } catch (e) {
          evt = doc.createEvent('Event');
          evt.initEvent(event, true, true);
          evt.detail = eventData;
        }
        // eslint-disable-next-line
        el.dom7EventData = args.filter(function (data, dataIndex) { return dataIndex > 0; });
        el.dispatchEvent(evt);
        el.dom7EventData = [];
        delete el.dom7EventData;
      }
    }
    return this;
  }
  function transitionEnd(callback) {
    var events = ['webkitTransitionEnd', 'transitionend'];
    var dom = this;
    var i;
    function fireCallBack(e) {
      /* jshint validthis:true */
      if (e.target !== this) { return; }
      callback.call(this, e);
      for (i = 0; i < events.length; i += 1) {
        dom.off(events[i], fireCallBack);
      }
    }
    if (callback) {
      for (i = 0; i < events.length; i += 1) {
        dom.on(events[i], fireCallBack);
      }
    }
    return this;
  }
  function outerWidth(includeMargins) {
    if (this.length > 0) {
      if (includeMargins) {
        // eslint-disable-next-line
        var styles = this.styles();
        return this[0].offsetWidth + parseFloat(styles.getPropertyValue('margin-right')) + parseFloat(styles.getPropertyValue('margin-left'));
      }
      return this[0].offsetWidth;
    }
    return null;
  }
  function outerHeight(includeMargins) {
    if (this.length > 0) {
      if (includeMargins) {
        // eslint-disable-next-line
        var styles = this.styles();
        return this[0].offsetHeight + parseFloat(styles.getPropertyValue('margin-top')) + parseFloat(styles.getPropertyValue('margin-bottom'));
      }
      return this[0].offsetHeight;
    }
    return null;
  }
  function offset() {
    if (this.length > 0) {
      var el = this[0];
      var box = el.getBoundingClientRect();
      var body = doc.body;
      var clientTop = el.clientTop || body.clientTop || 0;
      var clientLeft = el.clientLeft || body.clientLeft || 0;
      var scrollTop = el === win ? win.scrollY : el.scrollTop;
      var scrollLeft = el === win ? win.scrollX : el.scrollLeft;
      return {
        top: (box.top + scrollTop) - clientTop,
        left: (box.left + scrollLeft) - clientLeft,
      };
    }

    return null;
  }
  function styles() {
    if (this[0]) { return win.getComputedStyle(this[0], null); }
    return {};
  }
  function css(props, value) {
    var i;
    if (arguments.length === 1) {
      if (typeof props === 'string') {
        if (this[0]) { return win.getComputedStyle(this[0], null).getPropertyValue(props); }
      } else {
        for (i = 0; i < this.length; i += 1) {
          // eslint-disable-next-line
          for (var prop in props) {
            this[i].style[prop] = props[prop];
          }
        }
        return this;
      }
    }
    if (arguments.length === 2 && typeof props === 'string') {
      for (i = 0; i < this.length; i += 1) {
        this[i].style[props] = value;
      }
      return this;
    }
    return this;
  }
  // Iterate over the collection passing elements to `callback`
  function each(callback) {
    // Don't bother continuing without a callback
    if (!callback) { return this; }
    // Iterate over the current collection
    for (var i = 0; i < this.length; i += 1) {
      // If the callback returns false
      if (callback.call(this[i], i, this[i]) === false) {
        // End the loop early
        return this;
      }
    }
    // Return `this` to allow chained DOM operations
    return this;
  }
  // eslint-disable-next-line
  function html(html) {
    if (typeof html === 'undefined') {
      return this[0] ? this[0].innerHTML : undefined;
    }

    for (var i = 0; i < this.length; i += 1) {
      this[i].innerHTML = html;
    }
    return this;
  }
  // eslint-disable-next-line
  function text(text) {
    if (typeof text === 'undefined') {
      if (this[0]) {
        return this[0].textContent.trim();
      }
      return null;
    }

    for (var i = 0; i < this.length; i += 1) {
      this[i].textContent = text;
    }
    return this;
  }
  function is(selector) {
    var el = this[0];
    var compareWith;
    var i;
    if (!el || typeof selector === 'undefined') { return false; }
    if (typeof selector === 'string') {
      if (el.matches) { return el.matches(selector); }
      else if (el.webkitMatchesSelector) { return el.webkitMatchesSelector(selector); }
      else if (el.msMatchesSelector) { return el.msMatchesSelector(selector); }

      compareWith = $(selector);
      for (i = 0; i < compareWith.length; i += 1) {
        if (compareWith[i] === el) { return true; }
      }
      return false;
    } else if (selector === doc) { return el === doc; }
    else if (selector === win) { return el === win; }

    if (selector.nodeType || selector instanceof Dom7) {
      compareWith = selector.nodeType ? [selector] : selector;
      for (i = 0; i < compareWith.length; i += 1) {
        if (compareWith[i] === el) { return true; }
      }
      return false;
    }
    return false;
  }
  function index() {
    var child = this[0];
    var i;
    if (child) {
      i = 0;
      // eslint-disable-next-line
      while ((child = child.previousSibling) !== null) {
        if (child.nodeType === 1) { i += 1; }
      }
      return i;
    }
    return undefined;
  }
  // eslint-disable-next-line
  function eq(index) {
    if (typeof index === 'undefined') { return this; }
    var length = this.length;
    var returnIndex;
    if (index > length - 1) {
      return new Dom7([]);
    }
    if (index < 0) {
      returnIndex = length + index;
      if (returnIndex < 0) { return new Dom7([]); }
      return new Dom7([this[returnIndex]]);
    }
    return new Dom7([this[index]]);
  }
  function append() {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var newChild;

    for (var k = 0; k < args.length; k += 1) {
      newChild = args[k];
      for (var i = 0; i < this.length; i += 1) {
        if (typeof newChild === 'string') {
          var tempDiv = doc.createElement('div');
          tempDiv.innerHTML = newChild;
          while (tempDiv.firstChild) {
            this[i].appendChild(tempDiv.firstChild);
          }
        } else if (newChild instanceof Dom7) {
          for (var j = 0; j < newChild.length; j += 1) {
            this[i].appendChild(newChild[j]);
          }
        } else {
          this[i].appendChild(newChild);
        }
      }
    }

    return this;
  }
  function prepend(newChild) {
    var i;
    var j;
    for (i = 0; i < this.length; i += 1) {
      if (typeof newChild === 'string') {
        var tempDiv = doc.createElement('div');
        tempDiv.innerHTML = newChild;
        for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
          this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
        }
      } else if (newChild instanceof Dom7) {
        for (j = 0; j < newChild.length; j += 1) {
          this[i].insertBefore(newChild[j], this[i].childNodes[0]);
        }
      } else {
        this[i].insertBefore(newChild, this[i].childNodes[0]);
      }
    }
    return this;
  }
  function next(selector) {
    if (this.length > 0) {
      if (selector) {
        if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) {
          return new Dom7([this[0].nextElementSibling]);
        }
        return new Dom7([]);
      }

      if (this[0].nextElementSibling) { return new Dom7([this[0].nextElementSibling]); }
      return new Dom7([]);
    }
    return new Dom7([]);
  }
  function nextAll(selector) {
    var nextEls = [];
    var el = this[0];
    if (!el) { return new Dom7([]); }
    while (el.nextElementSibling) {
      var next = el.nextElementSibling; // eslint-disable-line
      if (selector) {
        if ($(next).is(selector)) { nextEls.push(next); }
      } else { nextEls.push(next); }
      el = next;
    }
    return new Dom7(nextEls);
  }
  function prev(selector) {
    if (this.length > 0) {
      var el = this[0];
      if (selector) {
        if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) {
          return new Dom7([el.previousElementSibling]);
        }
        return new Dom7([]);
      }

      if (el.previousElementSibling) { return new Dom7([el.previousElementSibling]); }
      return new Dom7([]);
    }
    return new Dom7([]);
  }
  function prevAll(selector) {
    var prevEls = [];
    var el = this[0];
    if (!el) { return new Dom7([]); }
    while (el.previousElementSibling) {
      var prev = el.previousElementSibling; // eslint-disable-line
      if (selector) {
        if ($(prev).is(selector)) { prevEls.push(prev); }
      } else { prevEls.push(prev); }
      el = prev;
    }
    return new Dom7(prevEls);
  }
  function parent(selector) {
    var parents = []; // eslint-disable-line
    for (var i = 0; i < this.length; i += 1) {
      if (this[i].parentNode !== null) {
        if (selector) {
          if ($(this[i].parentNode).is(selector)) { parents.push(this[i].parentNode); }
        } else {
          parents.push(this[i].parentNode);
        }
      }
    }
    return $(unique(parents));
  }
  function parents(selector) {
    var parents = []; // eslint-disable-line
    for (var i = 0; i < this.length; i += 1) {
      var parent = this[i].parentNode; // eslint-disable-line
      while (parent) {
        if (selector) {
          if ($(parent).is(selector)) { parents.push(parent); }
        } else {
          parents.push(parent);
        }
        parent = parent.parentNode;
      }
    }
    return $(unique(parents));
  }
  function closest(selector) {
    var closest = this; // eslint-disable-line
    if (typeof selector === 'undefined') {
      return new Dom7([]);
    }
    if (!closest.is(selector)) {
      closest = closest.parents(selector).eq(0);
    }
    return closest;
  }
  function find(selector) {
    var foundElements = [];
    for (var i = 0; i < this.length; i += 1) {
      var found = this[i].querySelectorAll(selector);
      for (var j = 0; j < found.length; j += 1) {
        foundElements.push(found[j]);
      }
    }
    return new Dom7(foundElements);
  }
  function children(selector) {
    var children = []; // eslint-disable-line
    for (var i = 0; i < this.length; i += 1) {
      var childNodes = this[i].childNodes;

      for (var j = 0; j < childNodes.length; j += 1) {
        if (!selector) {
          if (childNodes[j].nodeType === 1) { children.push(childNodes[j]); }
        } else if (childNodes[j].nodeType === 1 && $(childNodes[j]).is(selector)) {
          children.push(childNodes[j]);
        }
      }
    }
    return new Dom7(unique(children));
  }
  function remove() {
    for (var i = 0; i < this.length; i += 1) {
      if (this[i].parentNode) { this[i].parentNode.removeChild(this[i]); }
    }
    return this;
  }
  function add() {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var dom = this;
    var i;
    var j;
    for (i = 0; i < args.length; i += 1) {
      var toAdd = $(args[i]);
      for (j = 0; j < toAdd.length; j += 1) {
        dom[dom.length] = toAdd[j];
        dom.length += 1;
      }
    }
    return dom;
  }

  var Methods = {
    addClass: addClass,
    removeClass: removeClass,
    hasClass: hasClass,
    toggleClass: toggleClass,
    attr: attr,
    removeAttr: removeAttr,
    data: data,
    transform: transform,
    transition: transition,
    on: on,
    off: off,
    trigger: trigger,
    transitionEnd: transitionEnd,
    outerWidth: outerWidth,
    outerHeight: outerHeight,
    offset: offset,
    css: css,
    each: each,
    html: html,
    text: text,
    is: is,
    index: index,
    eq: eq,
    append: append,
    prepend: prepend,
    next: next,
    nextAll: nextAll,
    prev: prev,
    prevAll: prevAll,
    parent: parent,
    parents: parents,
    closest: closest,
    find: find,
    children: children,
    remove: remove,
    add: add,
    styles: styles,
  };

  Object.keys(Methods).forEach(function (methodName) {
    $.fn[methodName] = $.fn[methodName] || Methods[methodName];
  });

  var Utils = {
    deleteProps: function deleteProps(obj) {
      var object = obj;
      Object.keys(object).forEach(function (key) {
        try {
          object[key] = null;
        } catch (e) {
          // no getter for object
        }
        try {
          delete object[key];
        } catch (e) {
          // something got wrong
        }
      });
    },
    nextTick: function nextTick(callback, delay) {
      if ( delay === void 0 ) delay = 0;

      return setTimeout(callback, delay);
    },
    now: function now() {
      return Date.now();
    },
    getTranslate: function getTranslate(el, axis) {
      if ( axis === void 0 ) axis = 'x';

      var matrix;
      var curTransform;
      var transformMatrix;

      var curStyle = win.getComputedStyle(el, null);

      if (win.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(',').length > 6) {
          curTransform = curTransform.split(', ').map(function (a) { return a.replace(',', '.'); }).join(', ');
        }
        // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new win.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
      } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
        matrix = transformMatrix.toString().split(',');
      }

      if (axis === 'x') {
        // Latest Chrome and webkits Fix
        if (win.WebKitCSSMatrix) { curTransform = transformMatrix.m41; }
        // Crazy IE10 Matrix
        else if (matrix.length === 16) { curTransform = parseFloat(matrix[12]); }
        // Normal Browsers
        else { curTransform = parseFloat(matrix[4]); }
      }
      if (axis === 'y') {
        // Latest Chrome and webkits Fix
        if (win.WebKitCSSMatrix) { curTransform = transformMatrix.m42; }
        // Crazy IE10 Matrix
        else if (matrix.length === 16) { curTransform = parseFloat(matrix[13]); }
        // Normal Browsers
        else { curTransform = parseFloat(matrix[5]); }
      }
      return curTransform || 0;
    },
    parseUrlQuery: function parseUrlQuery(url) {
      var query = {};
      var urlToParse = url || win.location.href;
      var i;
      var params;
      var param;
      var length;
      if (typeof urlToParse === 'string' && urlToParse.length) {
        urlToParse = urlToParse.indexOf('?') > -1 ? urlToParse.replace(/\S*\?/, '') : '';
        params = urlToParse.split('&').filter(function (paramsPart) { return paramsPart !== ''; });
        length = params.length;

        for (i = 0; i < length; i += 1) {
          param = params[i].replace(/#\S+/g, '').split('=');
          query[decodeURIComponent(param[0])] = typeof param[1] === 'undefined' ? undefined : decodeURIComponent(param[1]) || '';
        }
      }
      return query;
    },
    isObject: function isObject(o) {
      return typeof o === 'object' && o !== null && o.constructor && o.constructor === Object;
    },
    extend: function extend() {
      var args = [], len$1 = arguments.length;
      while ( len$1-- ) args[ len$1 ] = arguments[ len$1 ];

      var to = Object(args[0]);
      for (var i = 1; i < args.length; i += 1) {
        var nextSource = args[i];
        if (nextSource !== undefined && nextSource !== null) {
          var keysArray = Object.keys(Object(nextSource));
          for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
            var nextKey = keysArray[nextIndex];
            var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
            if (desc !== undefined && desc.enumerable) {
              if (Utils.isObject(to[nextKey]) && Utils.isObject(nextSource[nextKey])) {
                Utils.extend(to[nextKey], nextSource[nextKey]);
              } else if (!Utils.isObject(to[nextKey]) && Utils.isObject(nextSource[nextKey])) {
                to[nextKey] = {};
                Utils.extend(to[nextKey], nextSource[nextKey]);
              } else {
                to[nextKey] = nextSource[nextKey];
              }
            }
          }
        }
      }
      return to;
    },
  };

  var Support = (function Support() {
    var testDiv = doc.createElement('div');
    return {
      touch: (win.Modernizr && win.Modernizr.touch === true) || (function checkTouch() {
        return !!((win.navigator.maxTouchPoints > 0) || ('ontouchstart' in win) || (win.DocumentTouch && doc instanceof win.DocumentTouch));
      }()),

      pointerEvents: !!(win.navigator.pointerEnabled || win.PointerEvent || ('maxTouchPoints' in win.navigator && win.navigator.maxTouchPoints > 0)),
      prefixedPointerEvents: !!win.navigator.msPointerEnabled,

      transition: (function checkTransition() {
        var style = testDiv.style;
        return ('transition' in style || 'webkitTransition' in style || 'MozTransition' in style);
      }()),
      transforms3d: (win.Modernizr && win.Modernizr.csstransforms3d === true) || (function checkTransforms3d() {
        var style = testDiv.style;
        return ('webkitPerspective' in style || 'MozPerspective' in style || 'OPerspective' in style || 'MsPerspective' in style || 'perspective' in style);
      }()),

      flexbox: (function checkFlexbox() {
        var style = testDiv.style;
        var styles = ('alignItems webkitAlignItems webkitBoxAlign msFlexAlign mozBoxAlign webkitFlexDirection msFlexDirection mozBoxDirection mozBoxOrient webkitBoxDirection webkitBoxOrient').split(' ');
        for (var i = 0; i < styles.length; i += 1) {
          if (styles[i] in style) { return true; }
        }
        return false;
      }()),

      observer: (function checkObserver() {
        return ('MutationObserver' in win || 'WebkitMutationObserver' in win);
      }()),

      passiveListener: (function checkPassiveListener() {
        var supportsPassive = false;
        try {
          var opts = Object.defineProperty({}, 'passive', {
            // eslint-disable-next-line
            get: function get() {
              supportsPassive = true;
            },
          });
          win.addEventListener('testPassiveListener', null, opts);
        } catch (e) {
          // No support
        }
        return supportsPassive;
      }()),

      gestures: (function checkGestures() {
        return 'ongesturestart' in win;
      }()),
    };
  }());

  var Browser = (function Browser() {
    function isSafari() {
      var ua = win.navigator.userAgent.toLowerCase();
      return (ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0);
    }
    return {
      isIE: !!win.navigator.userAgent.match(/Trident/g) || !!win.navigator.userAgent.match(/MSIE/g),
      isEdge: !!win.navigator.userAgent.match(/Edge/g),
      isSafari: isSafari(),
      isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(win.navigator.userAgent),
    };
  }());

  var SwiperClass = function SwiperClass(params) {
    if ( params === void 0 ) params = {};

    var self = this;
    self.params = params;

    // Events
    self.eventsListeners = {};

    if (self.params && self.params.on) {
      Object.keys(self.params.on).forEach(function (eventName) {
        self.on(eventName, self.params.on[eventName]);
      });
    }
  };

  var staticAccessors = { components: { configurable: true } };

  SwiperClass.prototype.on = function on (events, handler, priority) {
    var self = this;
    if (typeof handler !== 'function') { return self; }
    var method = priority ? 'unshift' : 'push';
    events.split(' ').forEach(function (event) {
      if (!self.eventsListeners[event]) { self.eventsListeners[event] = []; }
      self.eventsListeners[event][method](handler);
    });
    return self;
  };

  SwiperClass.prototype.once = function once (events, handler, priority) {
    var self = this;
    if (typeof handler !== 'function') { return self; }
    function onceHandler() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

      handler.apply(self, args);
      self.off(events, onceHandler);
      if (onceHandler.f7proxy) {
        delete onceHandler.f7proxy;
      }
    }
    onceHandler.f7proxy = handler;
    return self.on(events, onceHandler, priority);
  };

  SwiperClass.prototype.off = function off (events, handler) {
    var self = this;
    if (!self.eventsListeners) { return self; }
    events.split(' ').forEach(function (event) {
      if (typeof handler === 'undefined') {
        self.eventsListeners[event] = [];
      } else if (self.eventsListeners[event] && self.eventsListeners[event].length) {
        self.eventsListeners[event].forEach(function (eventHandler, index) {
          if (eventHandler === handler || (eventHandler.f7proxy && eventHandler.f7proxy === handler)) {
            self.eventsListeners[event].splice(index, 1);
          }
        });
      }
    });
    return self;
  };

  SwiperClass.prototype.emit = function emit () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

    var self = this;
    if (!self.eventsListeners) { return self; }
    var events;
    var data;
    var context;
    if (typeof args[0] === 'string' || Array.isArray(args[0])) {
      events = args[0];
      data = args.slice(1, args.length);
      context = self;
    } else {
      events = args[0].events;
      data = args[0].data;
      context = args[0].context || self;
    }
    var eventsArray = Array.isArray(events) ? events : events.split(' ');
    eventsArray.forEach(function (event) {
      if (self.eventsListeners && self.eventsListeners[event]) {
        var handlers = [];
        self.eventsListeners[event].forEach(function (eventHandler) {
          handlers.push(eventHandler);
        });
        handlers.forEach(function (eventHandler) {
          eventHandler.apply(context, data);
        });
      }
    });
    return self;
  };

  SwiperClass.prototype.useModulesParams = function useModulesParams (instanceParams) {
    var instance = this;
    if (!instance.modules) { return; }
    Object.keys(instance.modules).forEach(function (moduleName) {
      var module = instance.modules[moduleName];
      // Extend params
      if (module.params) {
        Utils.extend(instanceParams, module.params);
      }
    });
  };

  SwiperClass.prototype.useModules = function useModules (modulesParams) {
      if ( modulesParams === void 0 ) modulesParams = {};

    var instance = this;
    if (!instance.modules) { return; }
    Object.keys(instance.modules).forEach(function (moduleName) {
      var module = instance.modules[moduleName];
      var moduleParams = modulesParams[moduleName] || {};
      // Extend instance methods and props
      if (module.instance) {
        Object.keys(module.instance).forEach(function (modulePropName) {
          var moduleProp = module.instance[modulePropName];
          if (typeof moduleProp === 'function') {
            instance[modulePropName] = moduleProp.bind(instance);
          } else {
            instance[modulePropName] = moduleProp;
          }
        });
      }
      // Add event listeners
      if (module.on && instance.on) {
        Object.keys(module.on).forEach(function (moduleEventName) {
          instance.on(moduleEventName, module.on[moduleEventName]);
        });
      }

      // Module create callback
      if (module.create) {
        module.create.bind(instance)(moduleParams);
      }
    });
  };

  staticAccessors.components.set = function (components) {
    var Class = this;
    if (!Class.use) { return; }
    Class.use(components);
  };

  SwiperClass.installModule = function installModule (module) {
      var params = [], len = arguments.length - 1;
      while ( len-- > 0 ) params[ len ] = arguments[ len + 1 ];

    var Class = this;
    if (!Class.prototype.modules) { Class.prototype.modules = {}; }
    var name = module.name || (((Object.keys(Class.prototype.modules).length) + "_" + (Utils.now())));
    Class.prototype.modules[name] = module;
    // Prototype
    if (module.proto) {
      Object.keys(module.proto).forEach(function (key) {
        Class.prototype[key] = module.proto[key];
      });
    }
    // Class
    if (module.static) {
      Object.keys(module.static).forEach(function (key) {
        Class[key] = module.static[key];
      });
    }
    // Callback
    if (module.install) {
      module.install.apply(Class, params);
    }
    return Class;
  };

  SwiperClass.use = function use (module) {
      var params = [], len = arguments.length - 1;
      while ( len-- > 0 ) params[ len ] = arguments[ len + 1 ];

    var Class = this;
    if (Array.isArray(module)) {
      module.forEach(function (m) { return Class.installModule(m); });
      return Class;
    }
    return Class.installModule.apply(Class, [ module ].concat( params ));
  };

  Object.defineProperties( SwiperClass, staticAccessors );

  function updateSize () {
    var swiper = this;
    var width;
    var height;
    var $el = swiper.$el;
    if (typeof swiper.params.width !== 'undefined') {
      width = swiper.params.width;
    } else {
      width = $el[0].clientWidth;
    }
    if (typeof swiper.params.height !== 'undefined') {
      height = swiper.params.height;
    } else {
      height = $el[0].clientHeight;
    }
    if ((width === 0 && swiper.isHorizontal()) || (height === 0 && swiper.isVertical())) {
      return;
    }

    // Subtract paddings
    width = width - parseInt($el.css('padding-left'), 10) - parseInt($el.css('padding-right'), 10);
    height = height - parseInt($el.css('padding-top'), 10) - parseInt($el.css('padding-bottom'), 10);

    Utils.extend(swiper, {
      width: width,
      height: height,
      size: swiper.isHorizontal() ? width : height,
    });
  }

  function updateSlides () {
    var swiper = this;
    var params = swiper.params;

    var $wrapperEl = swiper.$wrapperEl;
    var swiperSize = swiper.size;
    var rtl = swiper.rtlTranslate;
    var wrongRTL = swiper.wrongRTL;
    var isVirtual = swiper.virtual && params.virtual.enabled;
    var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    var slides = $wrapperEl.children(("." + (swiper.params.slideClass)));
    var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    var snapGrid = [];
    var slidesGrid = [];
    var slidesSizesGrid = [];

    var offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === 'function') {
      offsetBefore = params.slidesOffsetBefore.call(swiper);
    }

    var offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === 'function') {
      offsetAfter = params.slidesOffsetAfter.call(swiper);
    }

    var previousSnapGridLength = swiper.snapGrid.length;
    var previousSlidesGridLength = swiper.snapGrid.length;

    var spaceBetween = params.spaceBetween;
    var slidePosition = -offsetBefore;
    var prevSlideSize = 0;
    var index = 0;
    if (typeof swiperSize === 'undefined') {
      return;
    }
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
      spaceBetween = (parseFloat(spaceBetween.replace('%', '')) / 100) * swiperSize;
    }

    swiper.virtualSize = -spaceBetween;

    // reset margins
    if (rtl) { slides.css({ marginLeft: '', marginTop: '' }); }
    else { slides.css({ marginRight: '', marginBottom: '' }); }

    var slidesNumberEvenToRows;
    if (params.slidesPerColumn > 1) {
      if (Math.floor(slidesLength / params.slidesPerColumn) === slidesLength / swiper.params.slidesPerColumn) {
        slidesNumberEvenToRows = slidesLength;
      } else {
        slidesNumberEvenToRows = Math.ceil(slidesLength / params.slidesPerColumn) * params.slidesPerColumn;
      }
      if (params.slidesPerView !== 'auto' && params.slidesPerColumnFill === 'row') {
        slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, params.slidesPerView * params.slidesPerColumn);
      }
    }

    // Calc slides
    var slideSize;
    var slidesPerColumn = params.slidesPerColumn;
    var slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
    var numFullColumns = Math.floor(slidesLength / params.slidesPerColumn);
    for (var i = 0; i < slidesLength; i += 1) {
      slideSize = 0;
      var slide = slides.eq(i);
      if (params.slidesPerColumn > 1) {
        // Set slides order
        var newSlideOrderIndex = (void 0);
        var column = (void 0);
        var row = (void 0);
        if (
          (params.slidesPerColumnFill === 'column')
          || (params.slidesPerColumnFill === 'row' && params.slidesPerGroup > 1)
        ) {
          if (params.slidesPerColumnFill === 'column') {
            column = Math.floor(i / slidesPerColumn);
            row = i - (column * slidesPerColumn);
            if (column > numFullColumns || (column === numFullColumns && row === slidesPerColumn - 1)) {
              row += 1;
              if (row >= slidesPerColumn) {
                row = 0;
                column += 1;
              }
            }
          } else {
            var groupIndex = Math.floor(i / params.slidesPerGroup);
            row = Math.floor(i / params.slidesPerView) - groupIndex * params.slidesPerColumn;
            column = i - row * params.slidesPerView - groupIndex * params.slidesPerView;
          }
          newSlideOrderIndex = column + ((row * slidesNumberEvenToRows) / slidesPerColumn);
          slide
            .css({
              '-webkit-box-ordinal-group': newSlideOrderIndex,
              '-moz-box-ordinal-group': newSlideOrderIndex,
              '-ms-flex-order': newSlideOrderIndex,
              '-webkit-order': newSlideOrderIndex,
              order: newSlideOrderIndex,
            });
        } else {
          row = Math.floor(i / slidesPerRow);
          column = i - (row * slidesPerRow);
        }
        slide
          .css(
            ("margin-" + (swiper.isHorizontal() ? 'top' : 'left')),
            (row !== 0 && params.spaceBetween) && (((params.spaceBetween) + "px"))
          )
          .attr('data-swiper-column', column)
          .attr('data-swiper-row', row);
      }
      if (slide.css('display') === 'none') { continue; } // eslint-disable-line

      if (params.slidesPerView === 'auto') {
        var slideStyles = win.getComputedStyle(slide[0], null);
        var currentTransform = slide[0].style.transform;
        var currentWebKitTransform = slide[0].style.webkitTransform;
        if (currentTransform) {
          slide[0].style.transform = 'none';
        }
        if (currentWebKitTransform) {
          slide[0].style.webkitTransform = 'none';
        }
        if (params.roundLengths) {
          slideSize = swiper.isHorizontal()
            ? slide.outerWidth(true)
            : slide.outerHeight(true);
        } else {
          // eslint-disable-next-line
          if (swiper.isHorizontal()) {
            var width = parseFloat(slideStyles.getPropertyValue('width'));
            var paddingLeft = parseFloat(slideStyles.getPropertyValue('padding-left'));
            var paddingRight = parseFloat(slideStyles.getPropertyValue('padding-right'));
            var marginLeft = parseFloat(slideStyles.getPropertyValue('margin-left'));
            var marginRight = parseFloat(slideStyles.getPropertyValue('margin-right'));
            var boxSizing = slideStyles.getPropertyValue('box-sizing');
            if (boxSizing && boxSizing === 'border-box' && !Browser.isIE) {
              slideSize = width + marginLeft + marginRight;
            } else {
              slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight;
            }
          } else {
            var height = parseFloat(slideStyles.getPropertyValue('height'));
            var paddingTop = parseFloat(slideStyles.getPropertyValue('padding-top'));
            var paddingBottom = parseFloat(slideStyles.getPropertyValue('padding-bottom'));
            var marginTop = parseFloat(slideStyles.getPropertyValue('margin-top'));
            var marginBottom = parseFloat(slideStyles.getPropertyValue('margin-bottom'));
            var boxSizing$1 = slideStyles.getPropertyValue('box-sizing');
            if (boxSizing$1 && boxSizing$1 === 'border-box' && !Browser.isIE) {
              slideSize = height + marginTop + marginBottom;
            } else {
              slideSize = height + paddingTop + paddingBottom + marginTop + marginBottom;
            }
          }
        }
        if (currentTransform) {
          slide[0].style.transform = currentTransform;
        }
        if (currentWebKitTransform) {
          slide[0].style.webkitTransform = currentWebKitTransform;
        }
        if (params.roundLengths) { slideSize = Math.floor(slideSize); }
      } else {
        slideSize = (swiperSize - ((params.slidesPerView - 1) * spaceBetween)) / params.slidesPerView;
        if (params.roundLengths) { slideSize = Math.floor(slideSize); }

        if (slides[i]) {
          if (swiper.isHorizontal()) {
            slides[i].style.width = slideSize + "px";
          } else {
            slides[i].style.height = slideSize + "px";
          }
        }
      }
      if (slides[i]) {
        slides[i].swiperSlideSize = slideSize;
      }
      slidesSizesGrid.push(slideSize);


      if (params.centeredSlides) {
        slidePosition = slidePosition + (slideSize / 2) + (prevSlideSize / 2) + spaceBetween;
        if (prevSlideSize === 0 && i !== 0) { slidePosition = slidePosition - (swiperSize / 2) - spaceBetween; }
        if (i === 0) { slidePosition = slidePosition - (swiperSize / 2) - spaceBetween; }
        if (Math.abs(slidePosition) < 1 / 1000) { slidePosition = 0; }
        if (params.roundLengths) { slidePosition = Math.floor(slidePosition); }
        if ((index) % params.slidesPerGroup === 0) { snapGrid.push(slidePosition); }
        slidesGrid.push(slidePosition);
      } else {
        if (params.roundLengths) { slidePosition = Math.floor(slidePosition); }
        if ((index) % params.slidesPerGroup === 0) { snapGrid.push(slidePosition); }
        slidesGrid.push(slidePosition);
        slidePosition = slidePosition + slideSize + spaceBetween;
      }

      swiper.virtualSize += slideSize + spaceBetween;

      prevSlideSize = slideSize;

      index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    var newSlidesGrid;

    if (
      rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
      $wrapperEl.css({ width: ((swiper.virtualSize + params.spaceBetween) + "px") });
    }
    if (!Support.flexbox || params.setWrapperSize) {
      if (swiper.isHorizontal()) { $wrapperEl.css({ width: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
      else { $wrapperEl.css({ height: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
    }

    if (params.slidesPerColumn > 1) {
      swiper.virtualSize = (slideSize + params.spaceBetween) * slidesNumberEvenToRows;
      swiper.virtualSize = Math.ceil(swiper.virtualSize / params.slidesPerColumn) - params.spaceBetween;
      if (swiper.isHorizontal()) { $wrapperEl.css({ width: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
      else { $wrapperEl.css({ height: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
      if (params.centeredSlides) {
        newSlidesGrid = [];
        for (var i$1 = 0; i$1 < snapGrid.length; i$1 += 1) {
          var slidesGridItem = snapGrid[i$1];
          if (params.roundLengths) { slidesGridItem = Math.floor(slidesGridItem); }
          if (snapGrid[i$1] < swiper.virtualSize + snapGrid[0]) { newSlidesGrid.push(slidesGridItem); }
        }
        snapGrid = newSlidesGrid;
      }
    }

    // Remove last grid elements depending on width
    if (!params.centeredSlides) {
      newSlidesGrid = [];
      for (var i$2 = 0; i$2 < snapGrid.length; i$2 += 1) {
        var slidesGridItem$1 = snapGrid[i$2];
        if (params.roundLengths) { slidesGridItem$1 = Math.floor(slidesGridItem$1); }
        if (snapGrid[i$2] <= swiper.virtualSize - swiperSize) {
          newSlidesGrid.push(slidesGridItem$1);
        }
      }
      snapGrid = newSlidesGrid;
      if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
        snapGrid.push(swiper.virtualSize - swiperSize);
      }
    }
    if (snapGrid.length === 0) { snapGrid = [0]; }

    if (params.spaceBetween !== 0) {
      if (swiper.isHorizontal()) {
        if (rtl) { slides.css({ marginLeft: (spaceBetween + "px") }); }
        else { slides.css({ marginRight: (spaceBetween + "px") }); }
      } else { slides.css({ marginBottom: (spaceBetween + "px") }); }
    }

    if (params.centerInsufficientSlides) {
      var allSlidesSize = 0;
      slidesSizesGrid.forEach(function (slideSizeValue) {
        allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
      });
      allSlidesSize -= params.spaceBetween;
      if (allSlidesSize < swiperSize) {
        var allSlidesOffset = (swiperSize - allSlidesSize) / 2;
        snapGrid.forEach(function (snap, snapIndex) {
          snapGrid[snapIndex] = snap - allSlidesOffset;
        });
        slidesGrid.forEach(function (snap, snapIndex) {
          slidesGrid[snapIndex] = snap + allSlidesOffset;
        });
      }
    }

    Utils.extend(swiper, {
      slides: slides,
      snapGrid: snapGrid,
      slidesGrid: slidesGrid,
      slidesSizesGrid: slidesSizesGrid,
    });

    if (slidesLength !== previousSlidesLength) {
      swiper.emit('slidesLengthChange');
    }
    if (snapGrid.length !== previousSnapGridLength) {
      if (swiper.params.watchOverflow) { swiper.checkOverflow(); }
      swiper.emit('snapGridLengthChange');
    }
    if (slidesGrid.length !== previousSlidesGridLength) {
      swiper.emit('slidesGridLengthChange');
    }

    if (params.watchSlidesProgress || params.watchSlidesVisibility) {
      swiper.updateSlidesOffset();
    }
  }

  function updateAutoHeight (speed) {
    var swiper = this;
    var activeSlides = [];
    var newHeight = 0;
    var i;
    if (typeof speed === 'number') {
      swiper.setTransition(speed);
    } else if (speed === true) {
      swiper.setTransition(swiper.params.speed);
    }
    // Find slides currently in view
    if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
      for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
        var index = swiper.activeIndex + i;
        if (index > swiper.slides.length) { break; }
        activeSlides.push(swiper.slides.eq(index)[0]);
      }
    } else {
      activeSlides.push(swiper.slides.eq(swiper.activeIndex)[0]);
    }

    // Find new height from highest slide in view
    for (i = 0; i < activeSlides.length; i += 1) {
      if (typeof activeSlides[i] !== 'undefined') {
        var height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
      }
    }

    // Update Height
    if (newHeight) { swiper.$wrapperEl.css('height', (newHeight + "px")); }
  }

  function updateSlidesOffset () {
    var swiper = this;
    var slides = swiper.slides;
    for (var i = 0; i < slides.length; i += 1) {
      slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
    }
  }

  function updateSlidesProgress (translate) {
    if ( translate === void 0 ) translate = (this && this.translate) || 0;

    var swiper = this;
    var params = swiper.params;

    var slides = swiper.slides;
    var rtl = swiper.rtlTranslate;

    if (slides.length === 0) { return; }
    if (typeof slides[0].swiperSlideOffset === 'undefined') { swiper.updateSlidesOffset(); }

    var offsetCenter = -translate;
    if (rtl) { offsetCenter = translate; }

    // Visible Slides
    slides.removeClass(params.slideVisibleClass);

    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];

    for (var i = 0; i < slides.length; i += 1) {
      var slide = slides[i];
      var slideProgress = (
        (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0)) - slide.swiperSlideOffset
      ) / (slide.swiperSlideSize + params.spaceBetween);
      if (params.watchSlidesVisibility) {
        var slideBefore = -(offsetCenter - slide.swiperSlideOffset);
        var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        var isVisible = (slideBefore >= 0 && slideBefore < swiper.size - 1)
                  || (slideAfter > 1 && slideAfter <= swiper.size)
                  || (slideBefore <= 0 && slideAfter >= swiper.size);
        if (isVisible) {
          swiper.visibleSlides.push(slide);
          swiper.visibleSlidesIndexes.push(i);
          slides.eq(i).addClass(params.slideVisibleClass);
        }
      }
      slide.progress = rtl ? -slideProgress : slideProgress;
    }
    swiper.visibleSlides = $(swiper.visibleSlides);
  }

  function updateProgress (translate) {
    if ( translate === void 0 ) translate = (this && this.translate) || 0;

    var swiper = this;
    var params = swiper.params;

    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    var progress = swiper.progress;
    var isBeginning = swiper.isBeginning;
    var isEnd = swiper.isEnd;
    var wasBeginning = isBeginning;
    var wasEnd = isEnd;
    if (translatesDiff === 0) {
      progress = 0;
      isBeginning = true;
      isEnd = true;
    } else {
      progress = (translate - swiper.minTranslate()) / (translatesDiff);
      isBeginning = progress <= 0;
      isEnd = progress >= 1;
    }
    Utils.extend(swiper, {
      progress: progress,
      isBeginning: isBeginning,
      isEnd: isEnd,
    });

    if (params.watchSlidesProgress || params.watchSlidesVisibility) { swiper.updateSlidesProgress(translate); }

    if (isBeginning && !wasBeginning) {
      swiper.emit('reachBeginning toEdge');
    }
    if (isEnd && !wasEnd) {
      swiper.emit('reachEnd toEdge');
    }
    if ((wasBeginning && !isBeginning) || (wasEnd && !isEnd)) {
      swiper.emit('fromEdge');
    }

    swiper.emit('progress', progress);
  }

  function updateSlidesClasses () {
    var swiper = this;

    var slides = swiper.slides;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl;
    var activeIndex = swiper.activeIndex;
    var realIndex = swiper.realIndex;
    var isVirtual = swiper.virtual && params.virtual.enabled;

    slides.removeClass(((params.slideActiveClass) + " " + (params.slideNextClass) + " " + (params.slidePrevClass) + " " + (params.slideDuplicateActiveClass) + " " + (params.slideDuplicateNextClass) + " " + (params.slideDuplicatePrevClass)));

    var activeSlide;
    if (isVirtual) {
      activeSlide = swiper.$wrapperEl.find(("." + (params.slideClass) + "[data-swiper-slide-index=\"" + activeIndex + "\"]"));
    } else {
      activeSlide = slides.eq(activeIndex);
    }

    // Active classes
    activeSlide.addClass(params.slideActiveClass);

    if (params.loop) {
      // Duplicate to all looped slides
      if (activeSlide.hasClass(params.slideDuplicateClass)) {
        $wrapperEl
          .children(("." + (params.slideClass) + ":not(." + (params.slideDuplicateClass) + ")[data-swiper-slide-index=\"" + realIndex + "\"]"))
          .addClass(params.slideDuplicateActiveClass);
      } else {
        $wrapperEl
          .children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + realIndex + "\"]"))
          .addClass(params.slideDuplicateActiveClass);
      }
    }
    // Next Slide
    var nextSlide = activeSlide.nextAll(("." + (params.slideClass))).eq(0).addClass(params.slideNextClass);
    if (params.loop && nextSlide.length === 0) {
      nextSlide = slides.eq(0);
      nextSlide.addClass(params.slideNextClass);
    }
    // Prev Slide
    var prevSlide = activeSlide.prevAll(("." + (params.slideClass))).eq(0).addClass(params.slidePrevClass);
    if (params.loop && prevSlide.length === 0) {
      prevSlide = slides.eq(-1);
      prevSlide.addClass(params.slidePrevClass);
    }
    if (params.loop) {
      // Duplicate to all looped slides
      if (nextSlide.hasClass(params.slideDuplicateClass)) {
        $wrapperEl
          .children(("." + (params.slideClass) + ":not(." + (params.slideDuplicateClass) + ")[data-swiper-slide-index=\"" + (nextSlide.attr('data-swiper-slide-index')) + "\"]"))
          .addClass(params.slideDuplicateNextClass);
      } else {
        $wrapperEl
          .children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + (nextSlide.attr('data-swiper-slide-index')) + "\"]"))
          .addClass(params.slideDuplicateNextClass);
      }
      if (prevSlide.hasClass(params.slideDuplicateClass)) {
        $wrapperEl
          .children(("." + (params.slideClass) + ":not(." + (params.slideDuplicateClass) + ")[data-swiper-slide-index=\"" + (prevSlide.attr('data-swiper-slide-index')) + "\"]"))
          .addClass(params.slideDuplicatePrevClass);
      } else {
        $wrapperEl
          .children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + (prevSlide.attr('data-swiper-slide-index')) + "\"]"))
          .addClass(params.slideDuplicatePrevClass);
      }
    }
  }

  function updateActiveIndex (newActiveIndex) {
    var swiper = this;
    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    var slidesGrid = swiper.slidesGrid;
    var snapGrid = swiper.snapGrid;
    var params = swiper.params;
    var previousIndex = swiper.activeIndex;
    var previousRealIndex = swiper.realIndex;
    var previousSnapIndex = swiper.snapIndex;
    var activeIndex = newActiveIndex;
    var snapIndex;
    if (typeof activeIndex === 'undefined') {
      for (var i = 0; i < slidesGrid.length; i += 1) {
        if (typeof slidesGrid[i + 1] !== 'undefined') {
          if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - ((slidesGrid[i + 1] - slidesGrid[i]) / 2)) {
            activeIndex = i;
          } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
            activeIndex = i + 1;
          }
        } else if (translate >= slidesGrid[i]) {
          activeIndex = i;
        }
      }
      // Normalize slideIndex
      if (params.normalizeSlideIndex) {
        if (activeIndex < 0 || typeof activeIndex === 'undefined') { activeIndex = 0; }
      }
    }
    if (snapGrid.indexOf(translate) >= 0) {
      snapIndex = snapGrid.indexOf(translate);
    } else {
      snapIndex = Math.floor(activeIndex / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) { snapIndex = snapGrid.length - 1; }
    if (activeIndex === previousIndex) {
      if (snapIndex !== previousSnapIndex) {
        swiper.snapIndex = snapIndex;
        swiper.emit('snapIndexChange');
      }
      return;
    }

    // Get real index
    var realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);

    Utils.extend(swiper, {
      snapIndex: snapIndex,
      realIndex: realIndex,
      previousIndex: previousIndex,
      activeIndex: activeIndex,
    });
    swiper.emit('activeIndexChange');
    swiper.emit('snapIndexChange');
    if (previousRealIndex !== realIndex) {
      swiper.emit('realIndexChange');
    }
    if (swiper.initialized || swiper.runCallbacksOnInit) {
      swiper.emit('slideChange');
    }
  }

  function updateClickedSlide (e) {
    var swiper = this;
    var params = swiper.params;
    var slide = $(e.target).closest(("." + (params.slideClass)))[0];
    var slideFound = false;
    if (slide) {
      for (var i = 0; i < swiper.slides.length; i += 1) {
        if (swiper.slides[i] === slide) { slideFound = true; }
      }
    }

    if (slide && slideFound) {
      swiper.clickedSlide = slide;
      if (swiper.virtual && swiper.params.virtual.enabled) {
        swiper.clickedIndex = parseInt($(slide).attr('data-swiper-slide-index'), 10);
      } else {
        swiper.clickedIndex = $(slide).index();
      }
    } else {
      swiper.clickedSlide = undefined;
      swiper.clickedIndex = undefined;
      return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
      swiper.slideToClickedSlide();
    }
  }

  var update = {
    updateSize: updateSize,
    updateSlides: updateSlides,
    updateAutoHeight: updateAutoHeight,
    updateSlidesOffset: updateSlidesOffset,
    updateSlidesProgress: updateSlidesProgress,
    updateProgress: updateProgress,
    updateSlidesClasses: updateSlidesClasses,
    updateActiveIndex: updateActiveIndex,
    updateClickedSlide: updateClickedSlide,
  };

  function getTranslate (axis) {
    if ( axis === void 0 ) axis = this.isHorizontal() ? 'x' : 'y';

    var swiper = this;

    var params = swiper.params;
    var rtl = swiper.rtlTranslate;
    var translate = swiper.translate;
    var $wrapperEl = swiper.$wrapperEl;

    if (params.virtualTranslate) {
      return rtl ? -translate : translate;
    }

    var currentTranslate = Utils.getTranslate($wrapperEl[0], axis);
    if (rtl) { currentTranslate = -currentTranslate; }

    return currentTranslate || 0;
  }

  function setTranslate (translate, byController) {
    var swiper = this;
    var rtl = swiper.rtlTranslate;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl;
    var progress = swiper.progress;
    var x = 0;
    var y = 0;
    var z = 0;

    if (swiper.isHorizontal()) {
      x = rtl ? -translate : translate;
    } else {
      y = translate;
    }

    if (params.roundLengths) {
      x = Math.floor(x);
      y = Math.floor(y);
    }

    if (!params.virtualTranslate) {
      if (Support.transforms3d) { $wrapperEl.transform(("translate3d(" + x + "px, " + y + "px, " + z + "px)")); }
      else { $wrapperEl.transform(("translate(" + x + "px, " + y + "px)")); }
    }
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y;

    // Check if we need to update progress
    var newProgress;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) {
      newProgress = 0;
    } else {
      newProgress = (translate - swiper.minTranslate()) / (translatesDiff);
    }
    if (newProgress !== progress) {
      swiper.updateProgress(translate);
    }

    swiper.emit('setTranslate', swiper.translate, byController);
  }

  function minTranslate () {
    return (-this.snapGrid[0]);
  }

  function maxTranslate () {
    return (-this.snapGrid[this.snapGrid.length - 1]);
  }

  var translate = {
    getTranslate: getTranslate,
    setTranslate: setTranslate,
    minTranslate: minTranslate,
    maxTranslate: maxTranslate,
  };

  function setTransition (duration, byController) {
    var swiper = this;

    swiper.$wrapperEl.transition(duration);

    swiper.emit('setTransition', duration, byController);
  }

  function transitionStart (runCallbacks, direction) {
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    var activeIndex = swiper.activeIndex;
    var params = swiper.params;
    var previousIndex = swiper.previousIndex;
    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }

    var dir = direction;
    if (!dir) {
      if (activeIndex > previousIndex) { dir = 'next'; }
      else if (activeIndex < previousIndex) { dir = 'prev'; }
      else { dir = 'reset'; }
    }

    swiper.emit('transitionStart');

    if (runCallbacks && activeIndex !== previousIndex) {
      if (dir === 'reset') {
        swiper.emit('slideResetTransitionStart');
        return;
      }
      swiper.emit('slideChangeTransitionStart');
      if (dir === 'next') {
        swiper.emit('slideNextTransitionStart');
      } else {
        swiper.emit('slidePrevTransitionStart');
      }
    }
  }

  function transitionEnd$1 (runCallbacks, direction) {
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    var activeIndex = swiper.activeIndex;
    var previousIndex = swiper.previousIndex;
    swiper.animating = false;
    swiper.setTransition(0);

    var dir = direction;
    if (!dir) {
      if (activeIndex > previousIndex) { dir = 'next'; }
      else if (activeIndex < previousIndex) { dir = 'prev'; }
      else { dir = 'reset'; }
    }

    swiper.emit('transitionEnd');

    if (runCallbacks && activeIndex !== previousIndex) {
      if (dir === 'reset') {
        swiper.emit('slideResetTransitionEnd');
        return;
      }
      swiper.emit('slideChangeTransitionEnd');
      if (dir === 'next') {
        swiper.emit('slideNextTransitionEnd');
      } else {
        swiper.emit('slidePrevTransitionEnd');
      }
    }
  }

  var transition$1 = {
    setTransition: setTransition,
    transitionStart: transitionStart,
    transitionEnd: transitionEnd$1,
  };

  function slideTo (index, speed, runCallbacks, internal) {
    if ( index === void 0 ) index = 0;
    if ( speed === void 0 ) speed = this.params.speed;
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    var slideIndex = index;
    if (slideIndex < 0) { slideIndex = 0; }

    var params = swiper.params;
    var snapGrid = swiper.snapGrid;
    var slidesGrid = swiper.slidesGrid;
    var previousIndex = swiper.previousIndex;
    var activeIndex = swiper.activeIndex;
    var rtl = swiper.rtlTranslate;
    if (swiper.animating && params.preventInteractionOnTransition) {
      return false;
    }

    var snapIndex = Math.floor(slideIndex / params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) { snapIndex = snapGrid.length - 1; }

    if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) {
      swiper.emit('beforeSlideChangeStart');
    }

    var translate = -snapGrid[snapIndex];

    // Update progress
    swiper.updateProgress(translate);

    // Normalize slideIndex
    if (params.normalizeSlideIndex) {
      for (var i = 0; i < slidesGrid.length; i += 1) {
        if (-Math.floor(translate * 100) >= Math.floor(slidesGrid[i] * 100)) {
          slideIndex = i;
        }
      }
    }
    // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
      if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
        return false;
      }
      if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
        if ((activeIndex || 0) !== slideIndex) { return false; }
      }
    }

    var direction;
    if (slideIndex > activeIndex) { direction = 'next'; }
    else if (slideIndex < activeIndex) { direction = 'prev'; }
    else { direction = 'reset'; }


    // Update Index
    if ((rtl && -translate === swiper.translate) || (!rtl && translate === swiper.translate)) {
      swiper.updateActiveIndex(slideIndex);
      // Update Height
      if (params.autoHeight) {
        swiper.updateAutoHeight();
      }
      swiper.updateSlidesClasses();
      if (params.effect !== 'slide') {
        swiper.setTranslate(translate);
      }
      if (direction !== 'reset') {
        swiper.transitionStart(runCallbacks, direction);
        swiper.transitionEnd(runCallbacks, direction);
      }
      return false;
    }

    if (speed === 0 || !Support.transition) {
      swiper.setTransition(0);
      swiper.setTranslate(translate);
      swiper.updateActiveIndex(slideIndex);
      swiper.updateSlidesClasses();
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.transitionStart(runCallbacks, direction);
      swiper.transitionEnd(runCallbacks, direction);
    } else {
      swiper.setTransition(speed);
      swiper.setTranslate(translate);
      swiper.updateActiveIndex(slideIndex);
      swiper.updateSlidesClasses();
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.transitionStart(runCallbacks, direction);
      if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) {
          swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) { return; }
            if (e.target !== this) { return; }
            swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
            swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
          };
        }
        swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
        swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
      }
    }

    return true;
  }

  function slideToLoop (index, speed, runCallbacks, internal) {
    if ( index === void 0 ) index = 0;
    if ( speed === void 0 ) speed = this.params.speed;
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    var newIndex = index;
    if (swiper.params.loop) {
      newIndex += swiper.loopedSlides;
    }

    return swiper.slideTo(newIndex, speed, runCallbacks, internal);
  }

  /* eslint no-unused-vars: "off" */
  function slideNext (speed, runCallbacks, internal) {
    if ( speed === void 0 ) speed = this.params.speed;
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    var params = swiper.params;
    var animating = swiper.animating;
    if (params.loop) {
      if (animating) { return false; }
      swiper.loopFix();
      // eslint-disable-next-line
      swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
      return swiper.slideTo(swiper.activeIndex + params.slidesPerGroup, speed, runCallbacks, internal);
    }
    return swiper.slideTo(swiper.activeIndex + params.slidesPerGroup, speed, runCallbacks, internal);
  }

  /* eslint no-unused-vars: "off" */
  function slidePrev (speed, runCallbacks, internal) {
    if ( speed === void 0 ) speed = this.params.speed;
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    var params = swiper.params;
    var animating = swiper.animating;
    var snapGrid = swiper.snapGrid;
    var slidesGrid = swiper.slidesGrid;
    var rtlTranslate = swiper.rtlTranslate;

    if (params.loop) {
      if (animating) { return false; }
      swiper.loopFix();
      // eslint-disable-next-line
      swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }
    var translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
      if (val < 0) { return -Math.floor(Math.abs(val)); }
      return Math.floor(val);
    }
    var normalizedTranslate = normalize(translate);
    var normalizedSnapGrid = snapGrid.map(function (val) { return normalize(val); });
    var normalizedSlidesGrid = slidesGrid.map(function (val) { return normalize(val); });

    var currentSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate)];
    var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    var prevIndex;
    if (typeof prevSnap !== 'undefined') {
      prevIndex = slidesGrid.indexOf(prevSnap);
      if (prevIndex < 0) { prevIndex = swiper.activeIndex - 1; }
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
  }

  /* eslint no-unused-vars: "off" */
  function slideReset (speed, runCallbacks, internal) {
    if ( speed === void 0 ) speed = this.params.speed;
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
  }

  /* eslint no-unused-vars: "off" */
  function slideToClosest (speed, runCallbacks, internal) {
    if ( speed === void 0 ) speed = this.params.speed;
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    var index = swiper.activeIndex;
    var snapIndex = Math.floor(index / swiper.params.slidesPerGroup);

    if (snapIndex < swiper.snapGrid.length - 1) {
      var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;

      var currentSnap = swiper.snapGrid[snapIndex];
      var nextSnap = swiper.snapGrid[snapIndex + 1];

      if ((translate - currentSnap) > (nextSnap - currentSnap) / 2) {
        index = swiper.params.slidesPerGroup;
      }
    }

    return swiper.slideTo(index, speed, runCallbacks, internal);
  }

  function slideToClickedSlide () {
    var swiper = this;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl;

    var slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    var slideToIndex = swiper.clickedIndex;
    var realIndex;
    if (params.loop) {
      if (swiper.animating) { return; }
      realIndex = parseInt($(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);
      if (params.centeredSlides) {
        if (
          (slideToIndex < swiper.loopedSlides - (slidesPerView / 2))
          || (slideToIndex > (swiper.slides.length - swiper.loopedSlides) + (slidesPerView / 2))
        ) {
          swiper.loopFix();
          slideToIndex = $wrapperEl
            .children(("." + (params.slideClass) + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + (params.slideDuplicateClass) + ")"))
            .eq(0)
            .index();

          Utils.nextTick(function () {
            swiper.slideTo(slideToIndex);
          });
        } else {
          swiper.slideTo(slideToIndex);
        }
      } else if (slideToIndex > swiper.slides.length - slidesPerView) {
        swiper.loopFix();
        slideToIndex = $wrapperEl
          .children(("." + (params.slideClass) + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + (params.slideDuplicateClass) + ")"))
          .eq(0)
          .index();

        Utils.nextTick(function () {
          swiper.slideTo(slideToIndex);
        });
      } else {
        swiper.slideTo(slideToIndex);
      }
    } else {
      swiper.slideTo(slideToIndex);
    }
  }

  var slide = {
    slideTo: slideTo,
    slideToLoop: slideToLoop,
    slideNext: slideNext,
    slidePrev: slidePrev,
    slideReset: slideReset,
    slideToClosest: slideToClosest,
    slideToClickedSlide: slideToClickedSlide,
  };

  function loopCreate () {
    var swiper = this;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl;
    // Remove duplicated slides
    $wrapperEl.children(("." + (params.slideClass) + "." + (params.slideDuplicateClass))).remove();

    var slides = $wrapperEl.children(("." + (params.slideClass)));

    if (params.loopFillGroupWithBlank) {
      var blankSlidesNum = params.slidesPerGroup - (slides.length % params.slidesPerGroup);
      if (blankSlidesNum !== params.slidesPerGroup) {
        for (var i = 0; i < blankSlidesNum; i += 1) {
          var blankNode = $(doc.createElement('div')).addClass(((params.slideClass) + " " + (params.slideBlankClass)));
          $wrapperEl.append(blankNode);
        }
        slides = $wrapperEl.children(("." + (params.slideClass)));
      }
    }

    if (params.slidesPerView === 'auto' && !params.loopedSlides) { params.loopedSlides = slides.length; }

    swiper.loopedSlides = parseInt(params.loopedSlides || params.slidesPerView, 10);
    swiper.loopedSlides += params.loopAdditionalSlides;
    if (swiper.loopedSlides > slides.length) {
      swiper.loopedSlides = slides.length;
    }

    var prependSlides = [];
    var appendSlides = [];
    slides.each(function (index, el) {
      var slide = $(el);
      if (index < swiper.loopedSlides) { appendSlides.push(el); }
      if (index < slides.length && index >= slides.length - swiper.loopedSlides) { prependSlides.push(el); }
      slide.attr('data-swiper-slide-index', index);
    });
    for (var i$1 = 0; i$1 < appendSlides.length; i$1 += 1) {
      $wrapperEl.append($(appendSlides[i$1].cloneNode(true)).addClass(params.slideDuplicateClass));
    }
    for (var i$2 = prependSlides.length - 1; i$2 >= 0; i$2 -= 1) {
      $wrapperEl.prepend($(prependSlides[i$2].cloneNode(true)).addClass(params.slideDuplicateClass));
    }
  }

  function loopFix () {
    var swiper = this;
    var params = swiper.params;
    var activeIndex = swiper.activeIndex;
    var slides = swiper.slides;
    var loopedSlides = swiper.loopedSlides;
    var allowSlidePrev = swiper.allowSlidePrev;
    var allowSlideNext = swiper.allowSlideNext;
    var snapGrid = swiper.snapGrid;
    var rtl = swiper.rtlTranslate;
    var newIndex;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;

    var snapTranslate = -snapGrid[activeIndex];
    var diff = snapTranslate - swiper.getTranslate();


    // Fix For Negative Oversliding
    if (activeIndex < loopedSlides) {
      newIndex = (slides.length - (loopedSlides * 3)) + activeIndex;
      newIndex += loopedSlides;
      var slideChanged = swiper.slideTo(newIndex, 0, false, true);
      if (slideChanged && diff !== 0) {
        swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
      }
    } else if ((params.slidesPerView === 'auto' && activeIndex >= loopedSlides * 2) || (activeIndex >= slides.length - loopedSlides)) {
      // Fix For Positive Oversliding
      newIndex = -slides.length + activeIndex + loopedSlides;
      newIndex += loopedSlides;
      var slideChanged$1 = swiper.slideTo(newIndex, 0, false, true);
      if (slideChanged$1 && diff !== 0) {
        swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
      }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
  }

  function loopDestroy () {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl;
    var params = swiper.params;
    var slides = swiper.slides;
    $wrapperEl.children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + ",." + (params.slideClass) + "." + (params.slideBlankClass))).remove();
    slides.removeAttr('data-swiper-slide-index');
  }

  var loop = {
    loopCreate: loopCreate,
    loopFix: loopFix,
    loopDestroy: loopDestroy,
  };

  function setGrabCursor (moving) {
    var swiper = this;
    if (Support.touch || !swiper.params.simulateTouch || (swiper.params.watchOverflow && swiper.isLocked)) { return; }
    var el = swiper.el;
    el.style.cursor = 'move';
    el.style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
    el.style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
    el.style.cursor = moving ? 'grabbing' : 'grab';
  }

  function unsetGrabCursor () {
    var swiper = this;
    if (Support.touch || (swiper.params.watchOverflow && swiper.isLocked)) { return; }
    swiper.el.style.cursor = '';
  }

  var grabCursor = {
    setGrabCursor: setGrabCursor,
    unsetGrabCursor: unsetGrabCursor,
  };

  function appendSlide (slides) {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl;
    var params = swiper.params;
    if (params.loop) {
      swiper.loopDestroy();
    }
    if (typeof slides === 'object' && 'length' in slides) {
      for (var i = 0; i < slides.length; i += 1) {
        if (slides[i]) { $wrapperEl.append(slides[i]); }
      }
    } else {
      $wrapperEl.append(slides);
    }
    if (params.loop) {
      swiper.loopCreate();
    }
    if (!(params.observer && Support.observer)) {
      swiper.update();
    }
  }

  function prependSlide (slides) {
    var swiper = this;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl;
    var activeIndex = swiper.activeIndex;

    if (params.loop) {
      swiper.loopDestroy();
    }
    var newActiveIndex = activeIndex + 1;
    if (typeof slides === 'object' && 'length' in slides) {
      for (var i = 0; i < slides.length; i += 1) {
        if (slides[i]) { $wrapperEl.prepend(slides[i]); }
      }
      newActiveIndex = activeIndex + slides.length;
    } else {
      $wrapperEl.prepend(slides);
    }
    if (params.loop) {
      swiper.loopCreate();
    }
    if (!(params.observer && Support.observer)) {
      swiper.update();
    }
    swiper.slideTo(newActiveIndex, 0, false);
  }

  function addSlide (index, slides) {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl;
    var params = swiper.params;
    var activeIndex = swiper.activeIndex;
    var activeIndexBuffer = activeIndex;
    if (params.loop) {
      activeIndexBuffer -= swiper.loopedSlides;
      swiper.loopDestroy();
      swiper.slides = $wrapperEl.children(("." + (params.slideClass)));
    }
    var baseLength = swiper.slides.length;
    if (index <= 0) {
      swiper.prependSlide(slides);
      return;
    }
    if (index >= baseLength) {
      swiper.appendSlide(slides);
      return;
    }
    var newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;

    var slidesBuffer = [];
    for (var i = baseLength - 1; i >= index; i -= 1) {
      var currentSlide = swiper.slides.eq(i);
      currentSlide.remove();
      slidesBuffer.unshift(currentSlide);
    }

    if (typeof slides === 'object' && 'length' in slides) {
      for (var i$1 = 0; i$1 < slides.length; i$1 += 1) {
        if (slides[i$1]) { $wrapperEl.append(slides[i$1]); }
      }
      newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else {
      $wrapperEl.append(slides);
    }

    for (var i$2 = 0; i$2 < slidesBuffer.length; i$2 += 1) {
      $wrapperEl.append(slidesBuffer[i$2]);
    }

    if (params.loop) {
      swiper.loopCreate();
    }
    if (!(params.observer && Support.observer)) {
      swiper.update();
    }
    if (params.loop) {
      swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    } else {
      swiper.slideTo(newActiveIndex, 0, false);
    }
  }

  function removeSlide (slidesIndexes) {
    var swiper = this;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl;
    var activeIndex = swiper.activeIndex;

    var activeIndexBuffer = activeIndex;
    if (params.loop) {
      activeIndexBuffer -= swiper.loopedSlides;
      swiper.loopDestroy();
      swiper.slides = $wrapperEl.children(("." + (params.slideClass)));
    }
    var newActiveIndex = activeIndexBuffer;
    var indexToRemove;

    if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
      for (var i = 0; i < slidesIndexes.length; i += 1) {
        indexToRemove = slidesIndexes[i];
        if (swiper.slides[indexToRemove]) { swiper.slides.eq(indexToRemove).remove(); }
        if (indexToRemove < newActiveIndex) { newActiveIndex -= 1; }
      }
      newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
      indexToRemove = slidesIndexes;
      if (swiper.slides[indexToRemove]) { swiper.slides.eq(indexToRemove).remove(); }
      if (indexToRemove < newActiveIndex) { newActiveIndex -= 1; }
      newActiveIndex = Math.max(newActiveIndex, 0);
    }

    if (params.loop) {
      swiper.loopCreate();
    }

    if (!(params.observer && Support.observer)) {
      swiper.update();
    }
    if (params.loop) {
      swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    } else {
      swiper.slideTo(newActiveIndex, 0, false);
    }
  }

  function removeAllSlides () {
    var swiper = this;

    var slidesIndexes = [];
    for (var i = 0; i < swiper.slides.length; i += 1) {
      slidesIndexes.push(i);
    }
    swiper.removeSlide(slidesIndexes);
  }

  var manipulation = {
    appendSlide: appendSlide,
    prependSlide: prependSlide,
    addSlide: addSlide,
    removeSlide: removeSlide,
    removeAllSlides: removeAllSlides,
  };

  var Device = (function Device() {
    var ua = win.navigator.userAgent;

    var device = {
      ios: false,
      android: false,
      androidChrome: false,
      desktop: false,
      windows: false,
      iphone: false,
      ipod: false,
      ipad: false,
      cordova: win.cordova || win.phonegap,
      phonegap: win.cordova || win.phonegap,
    };

    var windows = ua.match(/(Windows Phone);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);


    // Windows
    if (windows) {
      device.os = 'windows';
      device.osVersion = windows[2];
      device.windows = true;
    }
    // Android
    if (android && !windows) {
      device.os = 'android';
      device.osVersion = android[2];
      device.android = true;
      device.androidChrome = ua.toLowerCase().indexOf('chrome') >= 0;
    }
    if (ipad || iphone || ipod) {
      device.os = 'ios';
      device.ios = true;
    }
    // iOS
    if (iphone && !ipod) {
      device.osVersion = iphone[2].replace(/_/g, '.');
      device.iphone = true;
    }
    if (ipad) {
      device.osVersion = ipad[2].replace(/_/g, '.');
      device.ipad = true;
    }
    if (ipod) {
      device.osVersion = ipod[3] ? ipod[3].replace(/_/g, '.') : null;
      device.iphone = true;
    }
    // iOS 8+ changed UA
    if (device.ios && device.osVersion && ua.indexOf('Version/') >= 0) {
      if (device.osVersion.split('.')[0] === '10') {
        device.osVersion = ua.toLowerCase().split('version/')[1].split(' ')[0];
      }
    }

    // Desktop
    device.desktop = !(device.os || device.android || device.webView);

    // Webview
    device.webView = (iphone || ipad || ipod) && ua.match(/.*AppleWebKit(?!.*Safari)/i);

    // Minimal UI
    if (device.os && device.os === 'ios') {
      var osVersionArr = device.osVersion.split('.');
      var metaViewport = doc.querySelector('meta[name="viewport"]');
      device.minimalUi = !device.webView
        && (ipod || iphone)
        && (osVersionArr[0] * 1 === 7 ? osVersionArr[1] * 1 >= 1 : osVersionArr[0] * 1 > 7)
        && metaViewport && metaViewport.getAttribute('content').indexOf('minimal-ui') >= 0;
    }

    // Pixel Ratio
    device.pixelRatio = win.devicePixelRatio || 1;

    // Export object
    return device;
  }());

  function onTouchStart (event) {
    var swiper = this;
    var data = swiper.touchEventsData;
    var params = swiper.params;
    var touches = swiper.touches;
    if (swiper.animating && params.preventInteractionOnTransition) {
      return;
    }
    var e = event;
    if (e.originalEvent) { e = e.originalEvent; }
    data.isTouchEvent = e.type === 'touchstart';
    if (!data.isTouchEvent && 'which' in e && e.which === 3) { return; }
    if (!data.isTouchEvent && 'button' in e && e.button > 0) { return; }
    if (data.isTouched && data.isMoved) { return; }
    if (params.noSwiping && $(e.target).closest(params.noSwipingSelector ? params.noSwipingSelector : ("." + (params.noSwipingClass)))[0]) {
      swiper.allowClick = true;
      return;
    }
    if (params.swipeHandler) {
      if (!$(e).closest(params.swipeHandler)[0]) { return; }
    }

    touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
    touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
    var startX = touches.currentX;
    var startY = touches.currentY;

    // Do NOT start if iOS edge swipe is detected. Otherwise iOS app (UIWebView) cannot swipe-to-go-back anymore

    var edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
    var edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
    if (
      edgeSwipeDetection
      && ((startX <= edgeSwipeThreshold)
      || (startX >= win.screen.width - edgeSwipeThreshold))
    ) {
      return;
    }

    Utils.extend(data, {
      isTouched: true,
      isMoved: false,
      allowTouchCallbacks: true,
      isScrolling: undefined,
      startMoving: undefined,
    });

    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = Utils.now();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) { data.allowThresholdMove = false; }
    if (e.type !== 'touchstart') {
      var preventDefault = true;
      if ($(e.target).is(data.formElements)) { preventDefault = false; }
      if (
        doc.activeElement
        && $(doc.activeElement).is(data.formElements)
        && doc.activeElement !== e.target
      ) {
        doc.activeElement.blur();
      }

      var shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
      if (params.touchStartForcePreventDefault || shouldPreventDefault) {
        e.preventDefault();
      }
    }
    swiper.emit('touchStart', e);
  }

  function onTouchMove (event) {
    var swiper = this;
    var data = swiper.touchEventsData;
    var params = swiper.params;
    var touches = swiper.touches;
    var rtl = swiper.rtlTranslate;
    var e = event;
    if (e.originalEvent) { e = e.originalEvent; }
    if (!data.isTouched) {
      if (data.startMoving && data.isScrolling) {
        swiper.emit('touchMoveOpposite', e);
      }
      return;
    }
    if (data.isTouchEvent && e.type === 'mousemove') { return; }
    var pageX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
    var pageY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
    if (e.preventedByNestedSwiper) {
      touches.startX = pageX;
      touches.startY = pageY;
      return;
    }
    if (!swiper.allowTouchMove) {
      // isMoved = true;
      swiper.allowClick = false;
      if (data.isTouched) {
        Utils.extend(touches, {
          startX: pageX,
          startY: pageY,
          currentX: pageX,
          currentY: pageY,
        });
        data.touchStartTime = Utils.now();
      }
      return;
    }
    if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
      if (swiper.isVertical()) {
        // Vertical
        if (
          (pageY < touches.startY && swiper.translate <= swiper.maxTranslate())
          || (pageY > touches.startY && swiper.translate >= swiper.minTranslate())
        ) {
          data.isTouched = false;
          data.isMoved = false;
          return;
        }
      } else if (
        (pageX < touches.startX && swiper.translate <= swiper.maxTranslate())
        || (pageX > touches.startX && swiper.translate >= swiper.minTranslate())
      ) {
        return;
      }
    }
    if (data.isTouchEvent && doc.activeElement) {
      if (e.target === doc.activeElement && $(e.target).is(data.formElements)) {
        data.isMoved = true;
        swiper.allowClick = false;
        return;
      }
    }
    if (data.allowTouchCallbacks) {
      swiper.emit('touchMove', e);
    }
    if (e.targetTouches && e.targetTouches.length > 1) { return; }

    touches.currentX = pageX;
    touches.currentY = pageY;

    var diffX = touches.currentX - touches.startX;
    var diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt((Math.pow( diffX, 2 )) + (Math.pow( diffY, 2 ))) < swiper.params.threshold) { return; }

    if (typeof data.isScrolling === 'undefined') {
      var touchAngle;
      if ((swiper.isHorizontal() && touches.currentY === touches.startY) || (swiper.isVertical() && touches.currentX === touches.startX)) {
        data.isScrolling = false;
      } else {
        // eslint-disable-next-line
        if ((diffX * diffX) + (diffY * diffY) >= 25) {
          touchAngle = (Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180) / Math.PI;
          data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : (90 - touchAngle > params.touchAngle);
        }
      }
    }
    if (data.isScrolling) {
      swiper.emit('touchMoveOpposite', e);
    }
    if (typeof data.startMoving === 'undefined') {
      if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
        data.startMoving = true;
      }
    }
    if (data.isScrolling) {
      data.isTouched = false;
      return;
    }
    if (!data.startMoving) {
      return;
    }
    swiper.allowClick = false;
    e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) {
      e.stopPropagation();
    }

    if (!data.isMoved) {
      if (params.loop) {
        swiper.loopFix();
      }
      data.startTranslate = swiper.getTranslate();
      swiper.setTransition(0);
      if (swiper.animating) {
        swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
      }
      data.allowMomentumBounce = false;
      // Grab Cursor
      if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
        swiper.setGrabCursor(true);
      }
      swiper.emit('sliderFirstMove', e);
    }
    swiper.emit('sliderMove', e);
    data.isMoved = true;

    var diff = swiper.isHorizontal() ? diffX : diffY;
    touches.diff = diff;

    diff *= params.touchRatio;
    if (rtl) { diff = -diff; }

    swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
    data.currentTranslate = diff + data.startTranslate;

    var disableParentSwiper = true;
    var resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) {
      resistanceRatio = 0;
    }
    if ((diff > 0 && data.currentTranslate > swiper.minTranslate())) {
      disableParentSwiper = false;
      if (params.resistance) { data.currentTranslate = (swiper.minTranslate() - 1) + (Math.pow( (-swiper.minTranslate() + data.startTranslate + diff), resistanceRatio )); }
    } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
      disableParentSwiper = false;
      if (params.resistance) { data.currentTranslate = (swiper.maxTranslate() + 1) - (Math.pow( (swiper.maxTranslate() - data.startTranslate - diff), resistanceRatio )); }
    }

    if (disableParentSwiper) {
      e.preventedByNestedSwiper = true;
    }

    // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
      data.currentTranslate = data.startTranslate;
    }
    if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
      data.currentTranslate = data.startTranslate;
    }


    // Threshold
    if (params.threshold > 0) {
      if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
        if (!data.allowThresholdMove) {
          data.allowThresholdMove = true;
          touches.startX = touches.currentX;
          touches.startY = touches.currentY;
          data.currentTranslate = data.startTranslate;
          touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
          return;
        }
      } else {
        data.currentTranslate = data.startTranslate;
        return;
      }
    }

    if (!params.followFinger) { return; }

    // Update active index in free mode
    if (params.freeMode || params.watchSlidesProgress || params.watchSlidesVisibility) {
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }
    if (params.freeMode) {
      // Velocity
      if (data.velocities.length === 0) {
        data.velocities.push({
          position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
          time: data.touchStartTime,
        });
      }
      data.velocities.push({
        position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
        time: Utils.now(),
      });
    }
    // Update progress
    swiper.updateProgress(data.currentTranslate);
    // Update translate
    swiper.setTranslate(data.currentTranslate);
  }

  function onTouchEnd (event) {
    var swiper = this;
    var data = swiper.touchEventsData;

    var params = swiper.params;
    var touches = swiper.touches;
    var rtl = swiper.rtlTranslate;
    var $wrapperEl = swiper.$wrapperEl;
    var slidesGrid = swiper.slidesGrid;
    var snapGrid = swiper.snapGrid;
    var e = event;
    if (e.originalEvent) { e = e.originalEvent; }
    if (data.allowTouchCallbacks) {
      swiper.emit('touchEnd', e);
    }
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
      if (data.isMoved && params.grabCursor) {
        swiper.setGrabCursor(false);
      }
      data.isMoved = false;
      data.startMoving = false;
      return;
    }
    // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
      swiper.setGrabCursor(false);
    }

    // Time diff
    var touchEndTime = Utils.now();
    var timeDiff = touchEndTime - data.touchStartTime;

    // Tap, doubleTap, Click
    if (swiper.allowClick) {
      swiper.updateClickedSlide(e);
      swiper.emit('tap', e);
      if (timeDiff < 300 && (touchEndTime - data.lastClickTime) > 300) {
        if (data.clickTimeout) { clearTimeout(data.clickTimeout); }
        data.clickTimeout = Utils.nextTick(function () {
          if (!swiper || swiper.destroyed) { return; }
          swiper.emit('click', e);
        }, 300);
      }
      if (timeDiff < 300 && (touchEndTime - data.lastClickTime) < 300) {
        if (data.clickTimeout) { clearTimeout(data.clickTimeout); }
        swiper.emit('doubleTap', e);
      }
    }

    data.lastClickTime = Utils.now();
    Utils.nextTick(function () {
      if (!swiper.destroyed) { swiper.allowClick = true; }
    });

    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
      data.isTouched = false;
      data.isMoved = false;
      data.startMoving = false;
      return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;

    var currentPos;
    if (params.followFinger) {
      currentPos = rtl ? swiper.translate : -swiper.translate;
    } else {
      currentPos = -data.currentTranslate;
    }

    if (params.freeMode) {
      if (currentPos < -swiper.minTranslate()) {
        swiper.slideTo(swiper.activeIndex);
        return;
      }
      if (currentPos > -swiper.maxTranslate()) {
        if (swiper.slides.length < snapGrid.length) {
          swiper.slideTo(snapGrid.length - 1);
        } else {
          swiper.slideTo(swiper.slides.length - 1);
        }
        return;
      }

      if (params.freeModeMomentum) {
        if (data.velocities.length > 1) {
          var lastMoveEvent = data.velocities.pop();
          var velocityEvent = data.velocities.pop();

          var distance = lastMoveEvent.position - velocityEvent.position;
          var time = lastMoveEvent.time - velocityEvent.time;
          swiper.velocity = distance / time;
          swiper.velocity /= 2;
          if (Math.abs(swiper.velocity) < params.freeModeMinimumVelocity) {
            swiper.velocity = 0;
          }
          // this implies that the user stopped moving a finger then released.
          // There would be no events with distance zero, so the last event is stale.
          if (time > 150 || (Utils.now() - lastMoveEvent.time) > 300) {
            swiper.velocity = 0;
          }
        } else {
          swiper.velocity = 0;
        }
        swiper.velocity *= params.freeModeMomentumVelocityRatio;

        data.velocities.length = 0;
        var momentumDuration = 1000 * params.freeModeMomentumRatio;
        var momentumDistance = swiper.velocity * momentumDuration;

        var newPosition = swiper.translate + momentumDistance;
        if (rtl) { newPosition = -newPosition; }

        var doBounce = false;
        var afterBouncePosition;
        var bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeModeMomentumBounceRatio;
        var needsLoopFix;
        if (newPosition < swiper.maxTranslate()) {
          if (params.freeModeMomentumBounce) {
            if (newPosition + swiper.maxTranslate() < -bounceAmount) {
              newPosition = swiper.maxTranslate() - bounceAmount;
            }
            afterBouncePosition = swiper.maxTranslate();
            doBounce = true;
            data.allowMomentumBounce = true;
          } else {
            newPosition = swiper.maxTranslate();
          }
          if (params.loop && params.centeredSlides) { needsLoopFix = true; }
        } else if (newPosition > swiper.minTranslate()) {
          if (params.freeModeMomentumBounce) {
            if (newPosition - swiper.minTranslate() > bounceAmount) {
              newPosition = swiper.minTranslate() + bounceAmount;
            }
            afterBouncePosition = swiper.minTranslate();
            doBounce = true;
            data.allowMomentumBounce = true;
          } else {
            newPosition = swiper.minTranslate();
          }
          if (params.loop && params.centeredSlides) { needsLoopFix = true; }
        } else if (params.freeModeSticky) {
          var nextSlide;
          for (var j = 0; j < snapGrid.length; j += 1) {
            if (snapGrid[j] > -newPosition) {
              nextSlide = j;
              break;
            }
          }

          if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
            newPosition = snapGrid[nextSlide];
          } else {
            newPosition = snapGrid[nextSlide - 1];
          }
          newPosition = -newPosition;
        }
        if (needsLoopFix) {
          swiper.once('transitionEnd', function () {
            swiper.loopFix();
          });
        }
        // Fix duration
        if (swiper.velocity !== 0) {
          if (rtl) {
            momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
          } else {
            momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
          }
        } else if (params.freeModeSticky) {
          swiper.slideToClosest();
          return;
        }

        if (params.freeModeMomentumBounce && doBounce) {
          swiper.updateProgress(afterBouncePosition);
          swiper.setTransition(momentumDuration);
          swiper.setTranslate(newPosition);
          swiper.transitionStart(true, swiper.swipeDirection);
          swiper.animating = true;
          $wrapperEl.transitionEnd(function () {
            if (!swiper || swiper.destroyed || !data.allowMomentumBounce) { return; }
            swiper.emit('momentumBounce');

            swiper.setTransition(params.speed);
            swiper.setTranslate(afterBouncePosition);
            $wrapperEl.transitionEnd(function () {
              if (!swiper || swiper.destroyed) { return; }
              swiper.transitionEnd();
            });
          });
        } else if (swiper.velocity) {
          swiper.updateProgress(newPosition);
          swiper.setTransition(momentumDuration);
          swiper.setTranslate(newPosition);
          swiper.transitionStart(true, swiper.swipeDirection);
          if (!swiper.animating) {
            swiper.animating = true;
            $wrapperEl.transitionEnd(function () {
              if (!swiper || swiper.destroyed) { return; }
              swiper.transitionEnd();
            });
          }
        } else {
          swiper.updateProgress(newPosition);
        }

        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      } else if (params.freeModeSticky) {
        swiper.slideToClosest();
        return;
      }

      if (!params.freeModeMomentum || timeDiff >= params.longSwipesMs) {
        swiper.updateProgress();
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      }
      return;
    }

    // Find current slide
    var stopIndex = 0;
    var groupSize = swiper.slidesSizesGrid[0];
    for (var i = 0; i < slidesGrid.length; i += params.slidesPerGroup) {
      if (typeof slidesGrid[i + params.slidesPerGroup] !== 'undefined') {
        if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + params.slidesPerGroup]) {
          stopIndex = i;
          groupSize = slidesGrid[i + params.slidesPerGroup] - slidesGrid[i];
        }
      } else if (currentPos >= slidesGrid[i]) {
        stopIndex = i;
        groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
      }
    }

    // Find current slide size
    var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;

    if (timeDiff > params.longSwipesMs) {
      // Long touches
      if (!params.longSwipes) {
        swiper.slideTo(swiper.activeIndex);
        return;
      }
      if (swiper.swipeDirection === 'next') {
        if (ratio >= params.longSwipesRatio) { swiper.slideTo(stopIndex + params.slidesPerGroup); }
        else { swiper.slideTo(stopIndex); }
      }
      if (swiper.swipeDirection === 'prev') {
        if (ratio > (1 - params.longSwipesRatio)) { swiper.slideTo(stopIndex + params.slidesPerGroup); }
        else { swiper.slideTo(stopIndex); }
      }
    } else {
      // Short swipes
      if (!params.shortSwipes) {
        swiper.slideTo(swiper.activeIndex);
        return;
      }
      if (swiper.swipeDirection === 'next') {
        swiper.slideTo(stopIndex + params.slidesPerGroup);
      }
      if (swiper.swipeDirection === 'prev') {
        swiper.slideTo(stopIndex);
      }
    }
  }

  function onResize () {
    var swiper = this;

    var params = swiper.params;
    var el = swiper.el;

    if (el && el.offsetWidth === 0) { return; }

    // Breakpoints
    if (params.breakpoints) {
      swiper.setBreakpoint();
    }

    // Save locks
    var allowSlideNext = swiper.allowSlideNext;
    var allowSlidePrev = swiper.allowSlidePrev;
    var snapGrid = swiper.snapGrid;

    // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;

    swiper.updateSize();
    swiper.updateSlides();

    if (params.freeMode) {
      var newTranslate = Math.min(Math.max(swiper.translate, swiper.maxTranslate()), swiper.minTranslate());
      swiper.setTranslate(newTranslate);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();

      if (params.autoHeight) {
        swiper.updateAutoHeight();
      }
    } else {
      swiper.updateSlidesClasses();
      if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
        swiper.slideTo(swiper.slides.length - 1, 0, false, true);
      } else {
        swiper.slideTo(swiper.activeIndex, 0, false, true);
      }
    }
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
      swiper.autoplay.run();
    }
    // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;

    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
      swiper.checkOverflow();
    }
  }

  function onClick (e) {
    var swiper = this;
    if (!swiper.allowClick) {
      if (swiper.params.preventClicks) { e.preventDefault(); }
      if (swiper.params.preventClicksPropagation && swiper.animating) {
        e.stopPropagation();
        e.stopImmediatePropagation();
      }
    }
  }

  function attachEvents() {
    var swiper = this;
    var params = swiper.params;
    var touchEvents = swiper.touchEvents;
    var el = swiper.el;
    var wrapperEl = swiper.wrapperEl;

    {
      swiper.onTouchStart = onTouchStart.bind(swiper);
      swiper.onTouchMove = onTouchMove.bind(swiper);
      swiper.onTouchEnd = onTouchEnd.bind(swiper);
    }

    swiper.onClick = onClick.bind(swiper);

    var target = params.touchEventsTarget === 'container' ? el : wrapperEl;
    var capture = !!params.nested;

    // Touch Events
    {
      if (!Support.touch && (Support.pointerEvents || Support.prefixedPointerEvents)) {
        target.addEventListener(touchEvents.start, swiper.onTouchStart, false);
        doc.addEventListener(touchEvents.move, swiper.onTouchMove, capture);
        doc.addEventListener(touchEvents.end, swiper.onTouchEnd, false);
      } else {
        if (Support.touch) {
          var passiveListener = touchEvents.start === 'touchstart' && Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
          target.addEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
          target.addEventListener(touchEvents.move, swiper.onTouchMove, Support.passiveListener ? { passive: false, capture: capture } : capture);
          target.addEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
        }
        if ((params.simulateTouch && !Device.ios && !Device.android) || (params.simulateTouch && !Support.touch && Device.ios)) {
          target.addEventListener('mousedown', swiper.onTouchStart, false);
          doc.addEventListener('mousemove', swiper.onTouchMove, capture);
          doc.addEventListener('mouseup', swiper.onTouchEnd, false);
        }
      }
      // Prevent Links Clicks
      if (params.preventClicks || params.preventClicksPropagation) {
        target.addEventListener('click', swiper.onClick, true);
      }
    }

    // Resize handler
    swiper.on((Device.ios || Device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate'), onResize, true);
  }

  function detachEvents() {
    var swiper = this;

    var params = swiper.params;
    var touchEvents = swiper.touchEvents;
    var el = swiper.el;
    var wrapperEl = swiper.wrapperEl;

    var target = params.touchEventsTarget === 'container' ? el : wrapperEl;
    var capture = !!params.nested;

    // Touch Events
    {
      if (!Support.touch && (Support.pointerEvents || Support.prefixedPointerEvents)) {
        target.removeEventListener(touchEvents.start, swiper.onTouchStart, false);
        doc.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
        doc.removeEventListener(touchEvents.end, swiper.onTouchEnd, false);
      } else {
        if (Support.touch) {
          var passiveListener = touchEvents.start === 'onTouchStart' && Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
          target.removeEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
          target.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
          target.removeEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
        }
        if ((params.simulateTouch && !Device.ios && !Device.android) || (params.simulateTouch && !Support.touch && Device.ios)) {
          target.removeEventListener('mousedown', swiper.onTouchStart, false);
          doc.removeEventListener('mousemove', swiper.onTouchMove, capture);
          doc.removeEventListener('mouseup', swiper.onTouchEnd, false);
        }
      }
      // Prevent Links Clicks
      if (params.preventClicks || params.preventClicksPropagation) {
        target.removeEventListener('click', swiper.onClick, true);
      }
    }

    // Resize handler
    swiper.off((Device.ios || Device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate'), onResize);
  }

  var events = {
    attachEvents: attachEvents,
    detachEvents: detachEvents,
  };

  function setBreakpoint () {
    var swiper = this;
    var activeIndex = swiper.activeIndex;
    var initialized = swiper.initialized;
    var loopedSlides = swiper.loopedSlides; if ( loopedSlides === void 0 ) loopedSlides = 0;
    var params = swiper.params;
    var breakpoints = params.breakpoints;
    if (!breakpoints || (breakpoints && Object.keys(breakpoints).length === 0)) { return; }

    // Set breakpoint for window width and update parameters
    var breakpoint = swiper.getBreakpoint(breakpoints);

    if (breakpoint && swiper.currentBreakpoint !== breakpoint) {
      var breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
      if (breakpointOnlyParams) {
        ['slidesPerView', 'spaceBetween', 'slidesPerGroup'].forEach(function (param) {
          var paramValue = breakpointOnlyParams[param];
          if (typeof paramValue === 'undefined') { return; }
          if (param === 'slidesPerView' && (paramValue === 'AUTO' || paramValue === 'auto')) {
            breakpointOnlyParams[param] = 'auto';
          } else if (param === 'slidesPerView') {
            breakpointOnlyParams[param] = parseFloat(paramValue);
          } else {
            breakpointOnlyParams[param] = parseInt(paramValue, 10);
          }
        });
      }

      var breakpointParams = breakpointOnlyParams || swiper.originalParams;
      var directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
      var needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);

      if (directionChanged && initialized) {
        swiper.changeDirection();
      }

      Utils.extend(swiper.params, breakpointParams);

      Utils.extend(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev,
      });

      swiper.currentBreakpoint = breakpoint;

      if (needsReLoop && initialized) {
        swiper.loopDestroy();
        swiper.loopCreate();
        swiper.updateSlides();
        swiper.slideTo((activeIndex - loopedSlides) + swiper.loopedSlides, 0, false);
      }

      swiper.emit('breakpoint', breakpointParams);
    }
  }

  function getBreakpoint (breakpoints) {
    var swiper = this;
    // Get breakpoint for window width
    if (!breakpoints) { return undefined; }
    var breakpoint = false;
    var points = [];
    Object.keys(breakpoints).forEach(function (point) {
      points.push(point);
    });
    points.sort(function (a, b) { return parseInt(a, 10) - parseInt(b, 10); });
    for (var i = 0; i < points.length; i += 1) {
      var point = points[i];
      if (swiper.params.breakpointsInverse) {
        if (point <= win.innerWidth) {
          breakpoint = point;
        }
      } else if (point >= win.innerWidth && !breakpoint) {
        breakpoint = point;
      }
    }
    return breakpoint || 'max';
  }

  var breakpoints = { setBreakpoint: setBreakpoint, getBreakpoint: getBreakpoint };

  function addClasses () {
    var swiper = this;
    var classNames = swiper.classNames;
    var params = swiper.params;
    var rtl = swiper.rtl;
    var $el = swiper.$el;
    var suffixes = [];

    suffixes.push('initialized');
    suffixes.push(params.direction);

    if (params.freeMode) {
      suffixes.push('free-mode');
    }
    if (!Support.flexbox) {
      suffixes.push('no-flexbox');
    }
    if (params.autoHeight) {
      suffixes.push('autoheight');
    }
    if (rtl) {
      suffixes.push('rtl');
    }
    if (params.slidesPerColumn > 1) {
      suffixes.push('multirow');
    }
    if (Device.android) {
      suffixes.push('android');
    }
    if (Device.ios) {
      suffixes.push('ios');
    }
    // WP8 Touch Events Fix
    if ((Browser.isIE || Browser.isEdge) && (Support.pointerEvents || Support.prefixedPointerEvents)) {
      suffixes.push(("wp8-" + (params.direction)));
    }

    suffixes.forEach(function (suffix) {
      classNames.push(params.containerModifierClass + suffix);
    });

    $el.addClass(classNames.join(' '));
  }

  function removeClasses () {
    var swiper = this;
    var $el = swiper.$el;
    var classNames = swiper.classNames;

    $el.removeClass(classNames.join(' '));
  }

  var classes = { addClasses: addClasses, removeClasses: removeClasses };

  function loadImage (imageEl, src, srcset, sizes, checkForComplete, callback) {
    var image;
    function onReady() {
      if (callback) { callback(); }
    }
    if (!imageEl.complete || !checkForComplete) {
      if (src) {
        image = new win.Image();
        image.onload = onReady;
        image.onerror = onReady;
        if (sizes) {
          image.sizes = sizes;
        }
        if (srcset) {
          image.srcset = srcset;
        }
        if (src) {
          image.src = src;
        }
      } else {
        onReady();
      }
    } else {
      // image already loaded...
      onReady();
    }
  }

  function preloadImages () {
    var swiper = this;
    swiper.imagesToLoad = swiper.$el.find('img');
    function onReady() {
      if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) { return; }
      if (swiper.imagesLoaded !== undefined) { swiper.imagesLoaded += 1; }
      if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
        if (swiper.params.updateOnImagesReady) { swiper.update(); }
        swiper.emit('imagesReady');
      }
    }
    for (var i = 0; i < swiper.imagesToLoad.length; i += 1) {
      var imageEl = swiper.imagesToLoad[i];
      swiper.loadImage(
        imageEl,
        imageEl.currentSrc || imageEl.getAttribute('src'),
        imageEl.srcset || imageEl.getAttribute('srcset'),
        imageEl.sizes || imageEl.getAttribute('sizes'),
        true,
        onReady
      );
    }
  }

  var images = {
    loadImage: loadImage,
    preloadImages: preloadImages,
  };

  function checkOverflow() {
    var swiper = this;
    var wasLocked = swiper.isLocked;

    swiper.isLocked = swiper.snapGrid.length === 1;
    swiper.allowSlideNext = !swiper.isLocked;
    swiper.allowSlidePrev = !swiper.isLocked;

    // events
    if (wasLocked !== swiper.isLocked) { swiper.emit(swiper.isLocked ? 'lock' : 'unlock'); }

    if (wasLocked && wasLocked !== swiper.isLocked) {
      swiper.isEnd = false;
      swiper.navigation.update();
    }
  }

  var checkOverflow$1 = { checkOverflow: checkOverflow };

  var defaults = {
    init: true,
    direction: 'horizontal',
    touchEventsTarget: 'container',
    initialSlide: 0,
    speed: 300,
    //
    preventInteractionOnTransition: false,

    // To support iOS's swipe-to-go-back gesture (when being used in-app, with UIWebView).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,

    // Free mode
    freeMode: false,
    freeModeMomentum: true,
    freeModeMomentumRatio: 1,
    freeModeMomentumBounce: true,
    freeModeMomentumBounceRatio: 1,
    freeModeMomentumVelocityRatio: 1,
    freeModeSticky: false,
    freeModeMinimumVelocity: 0.02,

    // Autoheight
    autoHeight: false,

    // Set wrapper width
    setWrapperSize: false,

    // Virtual Translate
    virtualTranslate: false,

    // Effects
    effect: 'slide', // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'

    // Breakpoints
    breakpoints: undefined,
    breakpointsInverse: false,

    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerColumn: 1,
    slidesPerColumnFill: 'column',
    slidesPerGroup: 1,
    centeredSlides: false,
    slidesOffsetBefore: 0, // in px
    slidesOffsetAfter: 0, // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,

    // Disable swiper and hide navigation when container not overflow
    watchOverflow: false,

    // Round length
    roundLengths: false,

    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 0,
    touchMoveStopPropagation: true,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,

    // Unique Navigation Elements
    uniqueNavElements: true,

    // Resistance
    resistance: true,
    resistanceRatio: 0.85,

    // Progress
    watchSlidesProgress: false,
    watchSlidesVisibility: false,

    // Cursor
    grabCursor: false,

    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,

    // Images
    preloadImages: true,
    updateOnImagesReady: true,

    // loop
    loop: false,
    loopAdditionalSlides: 0,
    loopedSlides: null,
    loopFillGroupWithBlank: false,

    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null, // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: 'swiper-no-swiping',
    noSwipingSelector: null,

    // Passive Listeners
    passiveListeners: true,

    // NS
    containerModifierClass: 'swiper-container-', // NEW
    slideClass: 'swiper-slide',
    slideBlankClass: 'swiper-slide-invisible-blank',
    slideActiveClass: 'swiper-slide-active',
    slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
    slideVisibleClass: 'swiper-slide-visible',
    slideDuplicateClass: 'swiper-slide-duplicate',
    slideNextClass: 'swiper-slide-next',
    slideDuplicateNextClass: 'swiper-slide-duplicate-next',
    slidePrevClass: 'swiper-slide-prev',
    slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
    wrapperClass: 'swiper-wrapper',

    // Callbacks
    runCallbacksOnInit: true,
  };

  /* eslint no-param-reassign: "off" */

  var prototypes = {
    update: update,
    translate: translate,
    transition: transition$1,
    slide: slide,
    loop: loop,
    grabCursor: grabCursor,
    manipulation: manipulation,
    events: events,
    breakpoints: breakpoints,
    checkOverflow: checkOverflow$1,
    classes: classes,
    images: images,
  };

  var extendedDefaults = {};

  var Swiper = /*@__PURE__*/(function (SwiperClass) {
    function Swiper() {
      var assign;

      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];
      var el;
      var params;
      if (args.length === 1 && args[0].constructor && args[0].constructor === Object) {
        params = args[0];
      } else {
        (assign = args, el = assign[0], params = assign[1]);
      }
      if (!params) { params = {}; }

      params = Utils.extend({}, params);
      if (el && !params.el) { params.el = el; }

      SwiperClass.call(this, params);

      Object.keys(prototypes).forEach(function (prototypeGroup) {
        Object.keys(prototypes[prototypeGroup]).forEach(function (protoMethod) {
          if (!Swiper.prototype[protoMethod]) {
            Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
          }
        });
      });

      // Swiper Instance
      var swiper = this;
      if (typeof swiper.modules === 'undefined') {
        swiper.modules = {};
      }
      Object.keys(swiper.modules).forEach(function (moduleName) {
        var module = swiper.modules[moduleName];
        if (module.params) {
          var moduleParamName = Object.keys(module.params)[0];
          var moduleParams = module.params[moduleParamName];
          if (typeof moduleParams !== 'object' || moduleParams === null) { return; }
          if (!(moduleParamName in params && 'enabled' in moduleParams)) { return; }
          if (params[moduleParamName] === true) {
            params[moduleParamName] = { enabled: true };
          }
          if (
            typeof params[moduleParamName] === 'object'
            && !('enabled' in params[moduleParamName])
          ) {
            params[moduleParamName].enabled = true;
          }
          if (!params[moduleParamName]) { params[moduleParamName] = { enabled: false }; }
        }
      });

      // Extend defaults with modules params
      var swiperParams = Utils.extend({}, defaults);
      swiper.useModulesParams(swiperParams);

      // Extend defaults with passed params
      swiper.params = Utils.extend({}, swiperParams, extendedDefaults, params);
      swiper.originalParams = Utils.extend({}, swiper.params);
      swiper.passedParams = Utils.extend({}, params);

      // Save Dom lib
      swiper.$ = $;

      // Find el
      var $el = $(swiper.params.el);
      el = $el[0];

      if (!el) {
        return undefined;
      }

      if ($el.length > 1) {
        var swipers = [];
        $el.each(function (index, containerEl) {
          var newParams = Utils.extend({}, params, { el: containerEl });
          swipers.push(new Swiper(newParams));
        });
        return swipers;
      }

      el.swiper = swiper;
      $el.data('swiper', swiper);

      // Find Wrapper
      var $wrapperEl = $el.children(("." + (swiper.params.wrapperClass)));

      // Extend Swiper
      Utils.extend(swiper, {
        $el: $el,
        el: el,
        $wrapperEl: $wrapperEl,
        wrapperEl: $wrapperEl[0],

        // Classes
        classNames: [],

        // Slides
        slides: $(),
        slidesGrid: [],
        snapGrid: [],
        slidesSizesGrid: [],

        // isDirection
        isHorizontal: function isHorizontal() {
          return swiper.params.direction === 'horizontal';
        },
        isVertical: function isVertical() {
          return swiper.params.direction === 'vertical';
        },
        // RTL
        rtl: (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
        rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
        wrongRTL: $wrapperEl.css('display') === '-webkit-box',

        // Indexes
        activeIndex: 0,
        realIndex: 0,

        //
        isBeginning: true,
        isEnd: false,

        // Props
        translate: 0,
        previousTranslate: 0,
        progress: 0,
        velocity: 0,
        animating: false,

        // Locks
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev,

        // Touch Events
        touchEvents: (function touchEvents() {
          var touch = ['touchstart', 'touchmove', 'touchend'];
          var desktop = ['mousedown', 'mousemove', 'mouseup'];
          if (Support.pointerEvents) {
            desktop = ['pointerdown', 'pointermove', 'pointerup'];
          } else if (Support.prefixedPointerEvents) {
            desktop = ['MSPointerDown', 'MSPointerMove', 'MSPointerUp'];
          }
          swiper.touchEventsTouch = {
            start: touch[0],
            move: touch[1],
            end: touch[2],
          };
          swiper.touchEventsDesktop = {
            start: desktop[0],
            move: desktop[1],
            end: desktop[2],
          };
          return Support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
        }()),
        touchEventsData: {
          isTouched: undefined,
          isMoved: undefined,
          allowTouchCallbacks: undefined,
          touchStartTime: undefined,
          isScrolling: undefined,
          currentTranslate: undefined,
          startTranslate: undefined,
          allowThresholdMove: undefined,
          // Form elements to match
          formElements: 'input, select, option, textarea, button, video',
          // Last click time
          lastClickTime: Utils.now(),
          clickTimeout: undefined,
          // Velocities
          velocities: [],
          allowMomentumBounce: undefined,
          isTouchEvent: undefined,
          startMoving: undefined,
        },

        // Clicks
        allowClick: true,

        // Touches
        allowTouchMove: swiper.params.allowTouchMove,

        touches: {
          startX: 0,
          startY: 0,
          currentX: 0,
          currentY: 0,
          diff: 0,
        },

        // Images
        imagesToLoad: [],
        imagesLoaded: 0,

      });

      // Install Modules
      swiper.useModules();

      // Init
      if (swiper.params.init) {
        swiper.init();
      }

      // Return app instance
      return swiper;
    }

    if ( SwiperClass ) Swiper.__proto__ = SwiperClass;
    Swiper.prototype = Object.create( SwiperClass && SwiperClass.prototype );
    Swiper.prototype.constructor = Swiper;

    var staticAccessors = { extendedDefaults: { configurable: true },defaults: { configurable: true },Class: { configurable: true },$: { configurable: true } };

    Swiper.prototype.slidesPerViewDynamic = function slidesPerViewDynamic () {
      var swiper = this;
      var params = swiper.params;
      var slides = swiper.slides;
      var slidesGrid = swiper.slidesGrid;
      var swiperSize = swiper.size;
      var activeIndex = swiper.activeIndex;
      var spv = 1;
      if (params.centeredSlides) {
        var slideSize = slides[activeIndex].swiperSlideSize;
        var breakLoop;
        for (var i = activeIndex + 1; i < slides.length; i += 1) {
          if (slides[i] && !breakLoop) {
            slideSize += slides[i].swiperSlideSize;
            spv += 1;
            if (slideSize > swiperSize) { breakLoop = true; }
          }
        }
        for (var i$1 = activeIndex - 1; i$1 >= 0; i$1 -= 1) {
          if (slides[i$1] && !breakLoop) {
            slideSize += slides[i$1].swiperSlideSize;
            spv += 1;
            if (slideSize > swiperSize) { breakLoop = true; }
          }
        }
      } else {
        for (var i$2 = activeIndex + 1; i$2 < slides.length; i$2 += 1) {
          if (slidesGrid[i$2] - slidesGrid[activeIndex] < swiperSize) {
            spv += 1;
          }
        }
      }
      return spv;
    };

    Swiper.prototype.update = function update () {
      var swiper = this;
      if (!swiper || swiper.destroyed) { return; }
      var snapGrid = swiper.snapGrid;
      var params = swiper.params;
      // Breakpoints
      if (params.breakpoints) {
        swiper.setBreakpoint();
      }
      swiper.updateSize();
      swiper.updateSlides();
      swiper.updateProgress();
      swiper.updateSlidesClasses();

      function setTranslate() {
        var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
        var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
        swiper.setTranslate(newTranslate);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      }
      var translated;
      if (swiper.params.freeMode) {
        setTranslate();
        if (swiper.params.autoHeight) {
          swiper.updateAutoHeight();
        }
      } else {
        if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
          translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
        } else {
          translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
        }
        if (!translated) {
          setTranslate();
        }
      }
      if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
        swiper.checkOverflow();
      }
      swiper.emit('update');
    };

    Swiper.prototype.changeDirection = function changeDirection (newDirection, needUpdate) {
      if ( needUpdate === void 0 ) needUpdate = true;

      var swiper = this;
      var currentDirection = swiper.params.direction;
      if (!newDirection) {
        // eslint-disable-next-line
        newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
      }
      if ((newDirection === currentDirection) || (newDirection !== 'horizontal' && newDirection !== 'vertical')) {
        return swiper;
      }

      swiper.$el
        .removeClass(("" + (swiper.params.containerModifierClass) + currentDirection + " wp8-" + currentDirection))
        .addClass(("" + (swiper.params.containerModifierClass) + newDirection));

      if ((Browser.isIE || Browser.isEdge) && (Support.pointerEvents || Support.prefixedPointerEvents)) {
        swiper.$el.addClass(((swiper.params.containerModifierClass) + "wp8-" + newDirection));
      }

      swiper.params.direction = newDirection;

      swiper.slides.each(function (slideIndex, slideEl) {
        if (newDirection === 'vertical') {
          slideEl.style.width = '';
        } else {
          slideEl.style.height = '';
        }
      });

      swiper.emit('changeDirection');
      if (needUpdate) { swiper.update(); }

      return swiper;
    };

    Swiper.prototype.init = function init () {
      var swiper = this;
      if (swiper.initialized) { return; }

      swiper.emit('beforeInit');

      // Set breakpoint
      if (swiper.params.breakpoints) {
        swiper.setBreakpoint();
      }

      // Add Classes
      swiper.addClasses();

      // Create loop
      if (swiper.params.loop) {
        swiper.loopCreate();
      }

      // Update size
      swiper.updateSize();

      // Update slides
      swiper.updateSlides();

      if (swiper.params.watchOverflow) {
        swiper.checkOverflow();
      }

      // Set Grab Cursor
      if (swiper.params.grabCursor) {
        swiper.setGrabCursor();
      }

      if (swiper.params.preloadImages) {
        swiper.preloadImages();
      }

      // Slide To Initial Slide
      if (swiper.params.loop) {
        swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit);
      } else {
        swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit);
      }

      // Attach events
      swiper.attachEvents();

      // Init Flag
      swiper.initialized = true;

      // Emit
      swiper.emit('init');
    };

    Swiper.prototype.destroy = function destroy (deleteInstance, cleanStyles) {
      if ( deleteInstance === void 0 ) deleteInstance = true;
      if ( cleanStyles === void 0 ) cleanStyles = true;

      var swiper = this;
      var params = swiper.params;
      var $el = swiper.$el;
      var $wrapperEl = swiper.$wrapperEl;
      var slides = swiper.slides;

      if (typeof swiper.params === 'undefined' || swiper.destroyed) {
        return null;
      }

      swiper.emit('beforeDestroy');

      // Init Flag
      swiper.initialized = false;

      // Detach events
      swiper.detachEvents();

      // Destroy loop
      if (params.loop) {
        swiper.loopDestroy();
      }

      // Cleanup styles
      if (cleanStyles) {
        swiper.removeClasses();
        $el.removeAttr('style');
        $wrapperEl.removeAttr('style');
        if (slides && slides.length) {
          slides
            .removeClass([
              params.slideVisibleClass,
              params.slideActiveClass,
              params.slideNextClass,
              params.slidePrevClass ].join(' '))
            .removeAttr('style')
            .removeAttr('data-swiper-slide-index')
            .removeAttr('data-swiper-column')
            .removeAttr('data-swiper-row');
        }
      }

      swiper.emit('destroy');

      // Detach emitter events
      Object.keys(swiper.eventsListeners).forEach(function (eventName) {
        swiper.off(eventName);
      });

      if (deleteInstance !== false) {
        swiper.$el[0].swiper = null;
        swiper.$el.data('swiper', null);
        Utils.deleteProps(swiper);
      }
      swiper.destroyed = true;

      return null;
    };

    Swiper.extendDefaults = function extendDefaults (newDefaults) {
      Utils.extend(extendedDefaults, newDefaults);
    };

    staticAccessors.extendedDefaults.get = function () {
      return extendedDefaults;
    };

    staticAccessors.defaults.get = function () {
      return defaults;
    };

    staticAccessors.Class.get = function () {
      return SwiperClass;
    };

    staticAccessors.$.get = function () {
      return $;
    };

    Object.defineProperties( Swiper, staticAccessors );

    return Swiper;
  }(SwiperClass));

  var Device$1 = {
    name: 'device',
    proto: {
      device: Device,
    },
    static: {
      device: Device,
    },
  };

  var Support$1 = {
    name: 'support',
    proto: {
      support: Support,
    },
    static: {
      support: Support,
    },
  };

  var Browser$1 = {
    name: 'browser',
    proto: {
      browser: Browser,
    },
    static: {
      browser: Browser,
    },
  };

  var Resize = {
    name: 'resize',
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        resize: {
          resizeHandler: function resizeHandler() {
            if (!swiper || swiper.destroyed || !swiper.initialized) { return; }
            swiper.emit('beforeResize');
            swiper.emit('resize');
          },
          orientationChangeHandler: function orientationChangeHandler() {
            if (!swiper || swiper.destroyed || !swiper.initialized) { return; }
            swiper.emit('orientationchange');
          },
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        // Emit resize
        win.addEventListener('resize', swiper.resize.resizeHandler);

        // Emit orientationchange
        win.addEventListener('orientationchange', swiper.resize.orientationChangeHandler);
      },
      destroy: function destroy() {
        var swiper = this;
        win.removeEventListener('resize', swiper.resize.resizeHandler);
        win.removeEventListener('orientationchange', swiper.resize.orientationChangeHandler);
      },
    },
  };

  var Observer = {
    func: win.MutationObserver || win.WebkitMutationObserver,
    attach: function attach(target, options) {
      if ( options === void 0 ) options = {};

      var swiper = this;

      var ObserverFunc = Observer.func;
      var observer = new ObserverFunc(function (mutations) {
        // The observerUpdate event should only be triggered
        // once despite the number of mutations.  Additional
        // triggers are redundant and are very costly
        if (mutations.length === 1) {
          swiper.emit('observerUpdate', mutations[0]);
          return;
        }
        var observerUpdate = function observerUpdate() {
          swiper.emit('observerUpdate', mutations[0]);
        };

        if (win.requestAnimationFrame) {
          win.requestAnimationFrame(observerUpdate);
        } else {
          win.setTimeout(observerUpdate, 0);
        }
      });

      observer.observe(target, {
        attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
        childList: typeof options.childList === 'undefined' ? true : options.childList,
        characterData: typeof options.characterData === 'undefined' ? true : options.characterData,
      });

      swiper.observer.observers.push(observer);
    },
    init: function init() {
      var swiper = this;
      if (!Support.observer || !swiper.params.observer) { return; }
      if (swiper.params.observeParents) {
        var containerParents = swiper.$el.parents();
        for (var i = 0; i < containerParents.length; i += 1) {
          swiper.observer.attach(containerParents[i]);
        }
      }
      // Observe container
      swiper.observer.attach(swiper.$el[0], { childList: swiper.params.observeSlideChildren });

      // Observe wrapper
      swiper.observer.attach(swiper.$wrapperEl[0], { attributes: false });
    },
    destroy: function destroy() {
      var swiper = this;
      swiper.observer.observers.forEach(function (observer) {
        observer.disconnect();
      });
      swiper.observer.observers = [];
    },
  };

  var Observer$1 = {
    name: 'observer',
    params: {
      observer: false,
      observeParents: false,
      observeSlideChildren: false,
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        observer: {
          init: Observer.init.bind(swiper),
          attach: Observer.attach.bind(swiper),
          destroy: Observer.destroy.bind(swiper),
          observers: [],
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        swiper.observer.init();
      },
      destroy: function destroy() {
        var swiper = this;
        swiper.observer.destroy();
      },
    },
  };

  var Virtual = {
    update: function update(force) {
      var swiper = this;
      var ref = swiper.params;
      var slidesPerView = ref.slidesPerView;
      var slidesPerGroup = ref.slidesPerGroup;
      var centeredSlides = ref.centeredSlides;
      var ref$1 = swiper.params.virtual;
      var addSlidesBefore = ref$1.addSlidesBefore;
      var addSlidesAfter = ref$1.addSlidesAfter;
      var ref$2 = swiper.virtual;
      var previousFrom = ref$2.from;
      var previousTo = ref$2.to;
      var slides = ref$2.slides;
      var previousSlidesGrid = ref$2.slidesGrid;
      var renderSlide = ref$2.renderSlide;
      var previousOffset = ref$2.offset;
      swiper.updateActiveIndex();
      var activeIndex = swiper.activeIndex || 0;

      var offsetProp;
      if (swiper.rtlTranslate) { offsetProp = 'right'; }
      else { offsetProp = swiper.isHorizontal() ? 'left' : 'top'; }

      var slidesAfter;
      var slidesBefore;
      if (centeredSlides) {
        slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
        slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
      } else {
        slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesBefore;
        slidesBefore = slidesPerGroup + addSlidesAfter;
      }
      var from = Math.max((activeIndex || 0) - slidesBefore, 0);
      var to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
      var offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);

      Utils.extend(swiper.virtual, {
        from: from,
        to: to,
        offset: offset,
        slidesGrid: swiper.slidesGrid,
      });

      function onRendered() {
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        if (swiper.lazy && swiper.params.lazy.enabled) {
          swiper.lazy.load();
        }
      }

      if (previousFrom === from && previousTo === to && !force) {
        if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) {
          swiper.slides.css(offsetProp, (offset + "px"));
        }
        swiper.updateProgress();
        return;
      }
      if (swiper.params.virtual.renderExternal) {
        swiper.params.virtual.renderExternal.call(swiper, {
          offset: offset,
          from: from,
          to: to,
          slides: (function getSlides() {
            var slidesToRender = [];
            for (var i = from; i <= to; i += 1) {
              slidesToRender.push(slides[i]);
            }
            return slidesToRender;
          }()),
        });
        onRendered();
        return;
      }
      var prependIndexes = [];
      var appendIndexes = [];
      if (force) {
        swiper.$wrapperEl.find(("." + (swiper.params.slideClass))).remove();
      } else {
        for (var i = previousFrom; i <= previousTo; i += 1) {
          if (i < from || i > to) {
            swiper.$wrapperEl.find(("." + (swiper.params.slideClass) + "[data-swiper-slide-index=\"" + i + "\"]")).remove();
          }
        }
      }
      for (var i$1 = 0; i$1 < slides.length; i$1 += 1) {
        if (i$1 >= from && i$1 <= to) {
          if (typeof previousTo === 'undefined' || force) {
            appendIndexes.push(i$1);
          } else {
            if (i$1 > previousTo) { appendIndexes.push(i$1); }
            if (i$1 < previousFrom) { prependIndexes.push(i$1); }
          }
        }
      }
      appendIndexes.forEach(function (index) {
        swiper.$wrapperEl.append(renderSlide(slides[index], index));
      });
      prependIndexes.sort(function (a, b) { return b - a; }).forEach(function (index) {
        swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
      });
      swiper.$wrapperEl.children('.swiper-slide').css(offsetProp, (offset + "px"));
      onRendered();
    },
    renderSlide: function renderSlide(slide, index) {
      var swiper = this;
      var params = swiper.params.virtual;
      if (params.cache && swiper.virtual.cache[index]) {
        return swiper.virtual.cache[index];
      }
      var $slideEl = params.renderSlide
        ? $(params.renderSlide.call(swiper, slide, index))
        : $(("<div class=\"" + (swiper.params.slideClass) + "\" data-swiper-slide-index=\"" + index + "\">" + slide + "</div>"));
      if (!$slideEl.attr('data-swiper-slide-index')) { $slideEl.attr('data-swiper-slide-index', index); }
      if (params.cache) { swiper.virtual.cache[index] = $slideEl; }
      return $slideEl;
    },
    appendSlide: function appendSlide(slides) {
      var swiper = this;
      if (typeof slides === 'object' && 'length' in slides) {
        for (var i = 0; i < slides.length; i += 1) {
          if (slides[i]) { swiper.virtual.slides.push(slides[i]); }
        }
      } else {
        swiper.virtual.slides.push(slides);
      }
      swiper.virtual.update(true);
    },
    prependSlide: function prependSlide(slides) {
      var swiper = this;
      var activeIndex = swiper.activeIndex;
      var newActiveIndex = activeIndex + 1;
      var numberOfNewSlides = 1;

      if (Array.isArray(slides)) {
        for (var i = 0; i < slides.length; i += 1) {
          if (slides[i]) { swiper.virtual.slides.unshift(slides[i]); }
        }
        newActiveIndex = activeIndex + slides.length;
        numberOfNewSlides = slides.length;
      } else {
        swiper.virtual.slides.unshift(slides);
      }
      if (swiper.params.virtual.cache) {
        var cache = swiper.virtual.cache;
        var newCache = {};
        Object.keys(cache).forEach(function (cachedIndex) {
          newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = cache[cachedIndex];
        });
        swiper.virtual.cache = newCache;
      }
      swiper.virtual.update(true);
      swiper.slideTo(newActiveIndex, 0);
    },
    removeSlide: function removeSlide(slidesIndexes) {
      var swiper = this;
      if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) { return; }
      var activeIndex = swiper.activeIndex;
      if (Array.isArray(slidesIndexes)) {
        for (var i = slidesIndexes.length - 1; i >= 0; i -= 1) {
          swiper.virtual.slides.splice(slidesIndexes[i], 1);
          if (swiper.params.virtual.cache) {
            delete swiper.virtual.cache[slidesIndexes[i]];
          }
          if (slidesIndexes[i] < activeIndex) { activeIndex -= 1; }
          activeIndex = Math.max(activeIndex, 0);
        }
      } else {
        swiper.virtual.slides.splice(slidesIndexes, 1);
        if (swiper.params.virtual.cache) {
          delete swiper.virtual.cache[slidesIndexes];
        }
        if (slidesIndexes < activeIndex) { activeIndex -= 1; }
        activeIndex = Math.max(activeIndex, 0);
      }
      swiper.virtual.update(true);
      swiper.slideTo(activeIndex, 0);
    },
    removeAllSlides: function removeAllSlides() {
      var swiper = this;
      swiper.virtual.slides = [];
      if (swiper.params.virtual.cache) {
        swiper.virtual.cache = {};
      }
      swiper.virtual.update(true);
      swiper.slideTo(0, 0);
    },
  };

  var Virtual$1 = {
    name: 'virtual',
    params: {
      virtual: {
        enabled: false,
        slides: [],
        cache: true,
        renderSlide: null,
        renderExternal: null,
        addSlidesBefore: 0,
        addSlidesAfter: 0,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        virtual: {
          update: Virtual.update.bind(swiper),
          appendSlide: Virtual.appendSlide.bind(swiper),
          prependSlide: Virtual.prependSlide.bind(swiper),
          removeSlide: Virtual.removeSlide.bind(swiper),
          removeAllSlides: Virtual.removeAllSlides.bind(swiper),
          renderSlide: Virtual.renderSlide.bind(swiper),
          slides: swiper.params.virtual.slides,
          cache: {},
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (!swiper.params.virtual.enabled) { return; }
        swiper.classNames.push(((swiper.params.containerModifierClass) + "virtual"));
        var overwriteParams = {
          watchSlidesProgress: true,
        };
        Utils.extend(swiper.params, overwriteParams);
        Utils.extend(swiper.originalParams, overwriteParams);

        if (!swiper.params.initialSlide) {
          swiper.virtual.update();
        }
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (!swiper.params.virtual.enabled) { return; }
        swiper.virtual.update();
      },
    },
  };

  var Keyboard = {
    handle: function handle(event) {
      var swiper = this;
      var rtl = swiper.rtlTranslate;
      var e = event;
      if (e.originalEvent) { e = e.originalEvent; } // jquery fix
      var kc = e.keyCode || e.charCode;
      // Directions locks
      if (!swiper.allowSlideNext && ((swiper.isHorizontal() && kc === 39) || (swiper.isVertical() && kc === 40) || kc === 34)) {
        return false;
      }
      if (!swiper.allowSlidePrev && ((swiper.isHorizontal() && kc === 37) || (swiper.isVertical() && kc === 38) || kc === 33)) {
        return false;
      }
      if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
        return undefined;
      }
      if (doc.activeElement && doc.activeElement.nodeName && (doc.activeElement.nodeName.toLowerCase() === 'input' || doc.activeElement.nodeName.toLowerCase() === 'textarea')) {
        return undefined;
      }
      if (swiper.params.keyboard.onlyInViewport && (kc === 33 || kc === 34 || kc === 37 || kc === 39 || kc === 38 || kc === 40)) {
        var inView = false;
        // Check that swiper should be inside of visible area of window
        if (swiper.$el.parents(("." + (swiper.params.slideClass))).length > 0 && swiper.$el.parents(("." + (swiper.params.slideActiveClass))).length === 0) {
          return undefined;
        }
        var windowWidth = win.innerWidth;
        var windowHeight = win.innerHeight;
        var swiperOffset = swiper.$el.offset();
        if (rtl) { swiperOffset.left -= swiper.$el[0].scrollLeft; }
        var swiperCoord = [
          [swiperOffset.left, swiperOffset.top],
          [swiperOffset.left + swiper.width, swiperOffset.top],
          [swiperOffset.left, swiperOffset.top + swiper.height],
          [swiperOffset.left + swiper.width, swiperOffset.top + swiper.height] ];
        for (var i = 0; i < swiperCoord.length; i += 1) {
          var point = swiperCoord[i];
          if (
            point[0] >= 0 && point[0] <= windowWidth
            && point[1] >= 0 && point[1] <= windowHeight
          ) {
            inView = true;
          }
        }
        if (!inView) { return undefined; }
      }
      if (swiper.isHorizontal()) {
        if (kc === 33 || kc === 34 || kc === 37 || kc === 39) {
          if (e.preventDefault) { e.preventDefault(); }
          else { e.returnValue = false; }
        }
        if (((kc === 34 || kc === 39) && !rtl) || ((kc === 33 || kc === 37) && rtl)) { swiper.slideNext(); }
        if (((kc === 33 || kc === 37) && !rtl) || ((kc === 34 || kc === 39) && rtl)) { swiper.slidePrev(); }
      } else {
        if (kc === 33 || kc === 34 || kc === 38 || kc === 40) {
          if (e.preventDefault) { e.preventDefault(); }
          else { e.returnValue = false; }
        }
        if (kc === 34 || kc === 40) { swiper.slideNext(); }
        if (kc === 33 || kc === 38) { swiper.slidePrev(); }
      }
      swiper.emit('keyPress', kc);
      return undefined;
    },
    enable: function enable() {
      var swiper = this;
      if (swiper.keyboard.enabled) { return; }
      $(doc).on('keydown', swiper.keyboard.handle);
      swiper.keyboard.enabled = true;
    },
    disable: function disable() {
      var swiper = this;
      if (!swiper.keyboard.enabled) { return; }
      $(doc).off('keydown', swiper.keyboard.handle);
      swiper.keyboard.enabled = false;
    },
  };

  var Keyboard$1 = {
    name: 'keyboard',
    params: {
      keyboard: {
        enabled: false,
        onlyInViewport: true,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        keyboard: {
          enabled: false,
          enable: Keyboard.enable.bind(swiper),
          disable: Keyboard.disable.bind(swiper),
          handle: Keyboard.handle.bind(swiper),
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (swiper.params.keyboard.enabled) {
          swiper.keyboard.enable();
        }
      },
      destroy: function destroy() {
        var swiper = this;
        if (swiper.keyboard.enabled) {
          swiper.keyboard.disable();
        }
      },
    },
  };

  function isEventSupported() {
    var eventName = 'onwheel';
    var isSupported = eventName in doc;

    if (!isSupported) {
      var element = doc.createElement('div');
      element.setAttribute(eventName, 'return;');
      isSupported = typeof element[eventName] === 'function';
    }

    if (!isSupported
      && doc.implementation
      && doc.implementation.hasFeature
      // always returns true in newer browsers as per the standard.
      // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
      && doc.implementation.hasFeature('', '') !== true
    ) {
      // This is the only way to test support for the `wheel` event in IE9+.
      isSupported = doc.implementation.hasFeature('Events.wheel', '3.0');
    }

    return isSupported;
  }
  var Mousewheel = {
    lastScrollTime: Utils.now(),
    event: (function getEvent() {
      if (win.navigator.userAgent.indexOf('firefox') > -1) { return 'DOMMouseScroll'; }
      return isEventSupported() ? 'wheel' : 'mousewheel';
    }()),
    normalize: function normalize(e) {
      // Reasonable defaults
      var PIXEL_STEP = 10;
      var LINE_HEIGHT = 40;
      var PAGE_HEIGHT = 800;

      var sX = 0;
      var sY = 0; // spinX, spinY
      var pX = 0;
      var pY = 0; // pixelX, pixelY

      // Legacy
      if ('detail' in e) {
        sY = e.detail;
      }
      if ('wheelDelta' in e) {
        sY = -e.wheelDelta / 120;
      }
      if ('wheelDeltaY' in e) {
        sY = -e.wheelDeltaY / 120;
      }
      if ('wheelDeltaX' in e) {
        sX = -e.wheelDeltaX / 120;
      }

      // side scrolling on FF with DOMMouseScroll
      if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
        sX = sY;
        sY = 0;
      }

      pX = sX * PIXEL_STEP;
      pY = sY * PIXEL_STEP;

      if ('deltaY' in e) {
        pY = e.deltaY;
      }
      if ('deltaX' in e) {
        pX = e.deltaX;
      }

      if ((pX || pY) && e.deltaMode) {
        if (e.deltaMode === 1) { // delta in LINE units
          pX *= LINE_HEIGHT;
          pY *= LINE_HEIGHT;
        } else { // delta in PAGE units
          pX *= PAGE_HEIGHT;
          pY *= PAGE_HEIGHT;
        }
      }

      // Fall-back if spin cannot be determined
      if (pX && !sX) {
        sX = (pX < 1) ? -1 : 1;
      }
      if (pY && !sY) {
        sY = (pY < 1) ? -1 : 1;
      }

      return {
        spinX: sX,
        spinY: sY,
        pixelX: pX,
        pixelY: pY,
      };
    },
    handleMouseEnter: function handleMouseEnter() {
      var swiper = this;
      swiper.mouseEntered = true;
    },
    handleMouseLeave: function handleMouseLeave() {
      var swiper = this;
      swiper.mouseEntered = false;
    },
    handle: function handle(event) {
      var e = event;
      var swiper = this;
      var params = swiper.params.mousewheel;

      if (!swiper.mouseEntered && !params.releaseOnEdges) { return true; }

      if (e.originalEvent) { e = e.originalEvent; } // jquery fix
      var delta = 0;
      var rtlFactor = swiper.rtlTranslate ? -1 : 1;

      var data = Mousewheel.normalize(e);

      if (params.forceToAxis) {
        if (swiper.isHorizontal()) {
          if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) { delta = data.pixelX * rtlFactor; }
          else { return true; }
        } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) { delta = data.pixelY; }
        else { return true; }
      } else {
        delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
      }

      if (delta === 0) { return true; }

      if (params.invert) { delta = -delta; }

      if (!swiper.params.freeMode) {
        if (Utils.now() - swiper.mousewheel.lastScrollTime > 60) {
          if (delta < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
              swiper.slideNext();
              swiper.emit('scroll', e);
            } else if (params.releaseOnEdges) { return true; }
          } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            swiper.emit('scroll', e);
          } else if (params.releaseOnEdges) { return true; }
        }
        swiper.mousewheel.lastScrollTime = (new win.Date()).getTime();
      } else {
        // Freemode or scrollContainer:
        if (swiper.params.loop) {
          swiper.loopFix();
        }
        var position = swiper.getTranslate() + (delta * params.sensitivity);
        var wasBeginning = swiper.isBeginning;
        var wasEnd = swiper.isEnd;

        if (position >= swiper.minTranslate()) { position = swiper.minTranslate(); }
        if (position <= swiper.maxTranslate()) { position = swiper.maxTranslate(); }

        swiper.setTransition(0);
        swiper.setTranslate(position);
        swiper.updateProgress();
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();

        if ((!wasBeginning && swiper.isBeginning) || (!wasEnd && swiper.isEnd)) {
          swiper.updateSlidesClasses();
        }

        if (swiper.params.freeModeSticky) {
          clearTimeout(swiper.mousewheel.timeout);
          swiper.mousewheel.timeout = Utils.nextTick(function () {
            swiper.slideToClosest();
          }, 300);
        }
        // Emit event
        swiper.emit('scroll', e);

        // Stop autoplay
        if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) { swiper.autoplay.stop(); }
        // Return page scroll on edge positions
        if (position === swiper.minTranslate() || position === swiper.maxTranslate()) { return true; }
      }

      if (e.preventDefault) { e.preventDefault(); }
      else { e.returnValue = false; }
      return false;
    },
    enable: function enable() {
      var swiper = this;
      if (!Mousewheel.event) { return false; }
      if (swiper.mousewheel.enabled) { return false; }
      var target = swiper.$el;
      if (swiper.params.mousewheel.eventsTarged !== 'container') {
        target = $(swiper.params.mousewheel.eventsTarged);
      }
      target.on('mouseenter', swiper.mousewheel.handleMouseEnter);
      target.on('mouseleave', swiper.mousewheel.handleMouseLeave);
      target.on(Mousewheel.event, swiper.mousewheel.handle);
      swiper.mousewheel.enabled = true;
      return true;
    },
    disable: function disable() {
      var swiper = this;
      if (!Mousewheel.event) { return false; }
      if (!swiper.mousewheel.enabled) { return false; }
      var target = swiper.$el;
      if (swiper.params.mousewheel.eventsTarged !== 'container') {
        target = $(swiper.params.mousewheel.eventsTarged);
      }
      target.off(Mousewheel.event, swiper.mousewheel.handle);
      swiper.mousewheel.enabled = false;
      return true;
    },
  };

  var Mousewheel$1 = {
    name: 'mousewheel',
    params: {
      mousewheel: {
        enabled: false,
        releaseOnEdges: false,
        invert: false,
        forceToAxis: false,
        sensitivity: 1,
        eventsTarged: 'container',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        mousewheel: {
          enabled: false,
          enable: Mousewheel.enable.bind(swiper),
          disable: Mousewheel.disable.bind(swiper),
          handle: Mousewheel.handle.bind(swiper),
          handleMouseEnter: Mousewheel.handleMouseEnter.bind(swiper),
          handleMouseLeave: Mousewheel.handleMouseLeave.bind(swiper),
          lastScrollTime: Utils.now(),
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (swiper.params.mousewheel.enabled) { swiper.mousewheel.enable(); }
      },
      destroy: function destroy() {
        var swiper = this;
        if (swiper.mousewheel.enabled) { swiper.mousewheel.disable(); }
      },
    },
  };

  var Navigation = {
    update: function update() {
      // Update Navigation Buttons
      var swiper = this;
      var params = swiper.params.navigation;

      if (swiper.params.loop) { return; }
      var ref = swiper.navigation;
      var $nextEl = ref.$nextEl;
      var $prevEl = ref.$prevEl;

      if ($prevEl && $prevEl.length > 0) {
        if (swiper.isBeginning) {
          $prevEl.addClass(params.disabledClass);
        } else {
          $prevEl.removeClass(params.disabledClass);
        }
        $prevEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
      }
      if ($nextEl && $nextEl.length > 0) {
        if (swiper.isEnd) {
          $nextEl.addClass(params.disabledClass);
        } else {
          $nextEl.removeClass(params.disabledClass);
        }
        $nextEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
      }
    },
    onPrevClick: function onPrevClick(e) {
      var swiper = this;
      e.preventDefault();
      if (swiper.isBeginning && !swiper.params.loop) { return; }
      swiper.slidePrev();
    },
    onNextClick: function onNextClick(e) {
      var swiper = this;
      e.preventDefault();
      if (swiper.isEnd && !swiper.params.loop) { return; }
      swiper.slideNext();
    },
    init: function init() {
      var swiper = this;
      var params = swiper.params.navigation;
      if (!(params.nextEl || params.prevEl)) { return; }

      var $nextEl;
      var $prevEl;
      if (params.nextEl) {
        $nextEl = $(params.nextEl);
        if (
          swiper.params.uniqueNavElements
          && typeof params.nextEl === 'string'
          && $nextEl.length > 1
          && swiper.$el.find(params.nextEl).length === 1
        ) {
          $nextEl = swiper.$el.find(params.nextEl);
        }
      }
      if (params.prevEl) {
        $prevEl = $(params.prevEl);
        if (
          swiper.params.uniqueNavElements
          && typeof params.prevEl === 'string'
          && $prevEl.length > 1
          && swiper.$el.find(params.prevEl).length === 1
        ) {
          $prevEl = swiper.$el.find(params.prevEl);
        }
      }

      if ($nextEl && $nextEl.length > 0) {
        $nextEl.on('click', swiper.navigation.onNextClick);
      }
      if ($prevEl && $prevEl.length > 0) {
        $prevEl.on('click', swiper.navigation.onPrevClick);
      }

      Utils.extend(swiper.navigation, {
        $nextEl: $nextEl,
        nextEl: $nextEl && $nextEl[0],
        $prevEl: $prevEl,
        prevEl: $prevEl && $prevEl[0],
      });
    },
    destroy: function destroy() {
      var swiper = this;
      var ref = swiper.navigation;
      var $nextEl = ref.$nextEl;
      var $prevEl = ref.$prevEl;
      if ($nextEl && $nextEl.length) {
        $nextEl.off('click', swiper.navigation.onNextClick);
        $nextEl.removeClass(swiper.params.navigation.disabledClass);
      }
      if ($prevEl && $prevEl.length) {
        $prevEl.off('click', swiper.navigation.onPrevClick);
        $prevEl.removeClass(swiper.params.navigation.disabledClass);
      }
    },
  };

  var Navigation$1 = {
    name: 'navigation',
    params: {
      navigation: {
        nextEl: null,
        prevEl: null,

        hideOnClick: false,
        disabledClass: 'swiper-button-disabled',
        hiddenClass: 'swiper-button-hidden',
        lockClass: 'swiper-button-lock',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        navigation: {
          init: Navigation.init.bind(swiper),
          update: Navigation.update.bind(swiper),
          destroy: Navigation.destroy.bind(swiper),
          onNextClick: Navigation.onNextClick.bind(swiper),
          onPrevClick: Navigation.onPrevClick.bind(swiper),
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        swiper.navigation.init();
        swiper.navigation.update();
      },
      toEdge: function toEdge() {
        var swiper = this;
        swiper.navigation.update();
      },
      fromEdge: function fromEdge() {
        var swiper = this;
        swiper.navigation.update();
      },
      destroy: function destroy() {
        var swiper = this;
        swiper.navigation.destroy();
      },
      click: function click(e) {
        var swiper = this;
        var ref = swiper.navigation;
        var $nextEl = ref.$nextEl;
        var $prevEl = ref.$prevEl;
        if (
          swiper.params.navigation.hideOnClick
          && !$(e.target).is($prevEl)
          && !$(e.target).is($nextEl)
        ) {
          var isHidden;
          if ($nextEl) {
            isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
          } else if ($prevEl) {
            isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
          }
          if (isHidden === true) {
            swiper.emit('navigationShow', swiper);
          } else {
            swiper.emit('navigationHide', swiper);
          }
          if ($nextEl) {
            $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
          }
          if ($prevEl) {
            $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
          }
        }
      },
    },
  };

  var Pagination = {
    update: function update() {
      // Render || Update Pagination bullets/items
      var swiper = this;
      var rtl = swiper.rtl;
      var params = swiper.params.pagination;
      if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) { return; }
      var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
      var $el = swiper.pagination.$el;
      // Current/Total
      var current;
      var total = swiper.params.loop ? Math.ceil((slidesLength - (swiper.loopedSlides * 2)) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
      if (swiper.params.loop) {
        current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);
        if (current > slidesLength - 1 - (swiper.loopedSlides * 2)) {
          current -= (slidesLength - (swiper.loopedSlides * 2));
        }
        if (current > total - 1) { current -= total; }
        if (current < 0 && swiper.params.paginationType !== 'bullets') { current = total + current; }
      } else if (typeof swiper.snapIndex !== 'undefined') {
        current = swiper.snapIndex;
      } else {
        current = swiper.activeIndex || 0;
      }
      // Types
      if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
        var bullets = swiper.pagination.bullets;
        var firstIndex;
        var lastIndex;
        var midIndex;
        if (params.dynamicBullets) {
          swiper.pagination.bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
          $el.css(swiper.isHorizontal() ? 'width' : 'height', ((swiper.pagination.bulletSize * (params.dynamicMainBullets + 4)) + "px"));
          if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
            swiper.pagination.dynamicBulletIndex += (current - swiper.previousIndex);
            if (swiper.pagination.dynamicBulletIndex > (params.dynamicMainBullets - 1)) {
              swiper.pagination.dynamicBulletIndex = params.dynamicMainBullets - 1;
            } else if (swiper.pagination.dynamicBulletIndex < 0) {
              swiper.pagination.dynamicBulletIndex = 0;
            }
          }
          firstIndex = current - swiper.pagination.dynamicBulletIndex;
          lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
          midIndex = (lastIndex + firstIndex) / 2;
        }
        bullets.removeClass(((params.bulletActiveClass) + " " + (params.bulletActiveClass) + "-next " + (params.bulletActiveClass) + "-next-next " + (params.bulletActiveClass) + "-prev " + (params.bulletActiveClass) + "-prev-prev " + (params.bulletActiveClass) + "-main"));
        if ($el.length > 1) {
          bullets.each(function (index, bullet) {
            var $bullet = $(bullet);
            var bulletIndex = $bullet.index();
            if (bulletIndex === current) {
              $bullet.addClass(params.bulletActiveClass);
            }
            if (params.dynamicBullets) {
              if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
                $bullet.addClass(((params.bulletActiveClass) + "-main"));
              }
              if (bulletIndex === firstIndex) {
                $bullet
                  .prev()
                  .addClass(((params.bulletActiveClass) + "-prev"))
                  .prev()
                  .addClass(((params.bulletActiveClass) + "-prev-prev"));
              }
              if (bulletIndex === lastIndex) {
                $bullet
                  .next()
                  .addClass(((params.bulletActiveClass) + "-next"))
                  .next()
                  .addClass(((params.bulletActiveClass) + "-next-next"));
              }
            }
          });
        } else {
          var $bullet = bullets.eq(current);
          $bullet.addClass(params.bulletActiveClass);
          if (params.dynamicBullets) {
            var $firstDisplayedBullet = bullets.eq(firstIndex);
            var $lastDisplayedBullet = bullets.eq(lastIndex);
            for (var i = firstIndex; i <= lastIndex; i += 1) {
              bullets.eq(i).addClass(((params.bulletActiveClass) + "-main"));
            }
            $firstDisplayedBullet
              .prev()
              .addClass(((params.bulletActiveClass) + "-prev"))
              .prev()
              .addClass(((params.bulletActiveClass) + "-prev-prev"));
            $lastDisplayedBullet
              .next()
              .addClass(((params.bulletActiveClass) + "-next"))
              .next()
              .addClass(((params.bulletActiveClass) + "-next-next"));
          }
        }
        if (params.dynamicBullets) {
          var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
          var bulletsOffset = (((swiper.pagination.bulletSize * dynamicBulletsLength) - (swiper.pagination.bulletSize)) / 2) - (midIndex * swiper.pagination.bulletSize);
          var offsetProp = rtl ? 'right' : 'left';
          bullets.css(swiper.isHorizontal() ? offsetProp : 'top', (bulletsOffset + "px"));
        }
      }
      if (params.type === 'fraction') {
        $el.find(("." + (params.currentClass))).text(params.formatFractionCurrent(current + 1));
        $el.find(("." + (params.totalClass))).text(params.formatFractionTotal(total));
      }
      if (params.type === 'progressbar') {
        var progressbarDirection;
        if (params.progressbarOpposite) {
          progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
        } else {
          progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
        }
        var scale = (current + 1) / total;
        var scaleX = 1;
        var scaleY = 1;
        if (progressbarDirection === 'horizontal') {
          scaleX = scale;
        } else {
          scaleY = scale;
        }
        $el.find(("." + (params.progressbarFillClass))).transform(("translate3d(0,0,0) scaleX(" + scaleX + ") scaleY(" + scaleY + ")")).transition(swiper.params.speed);
      }
      if (params.type === 'custom' && params.renderCustom) {
        $el.html(params.renderCustom(swiper, current + 1, total));
        swiper.emit('paginationRender', swiper, $el[0]);
      } else {
        swiper.emit('paginationUpdate', swiper, $el[0]);
      }
      $el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
    },
    render: function render() {
      // Render Container
      var swiper = this;
      var params = swiper.params.pagination;
      if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) { return; }
      var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;

      var $el = swiper.pagination.$el;
      var paginationHTML = '';
      if (params.type === 'bullets') {
        var numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - (swiper.loopedSlides * 2)) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        for (var i = 0; i < numberOfBullets; i += 1) {
          if (params.renderBullet) {
            paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
          } else {
            paginationHTML += "<" + (params.bulletElement) + " class=\"" + (params.bulletClass) + "\"></" + (params.bulletElement) + ">";
          }
        }
        $el.html(paginationHTML);
        swiper.pagination.bullets = $el.find(("." + (params.bulletClass)));
      }
      if (params.type === 'fraction') {
        if (params.renderFraction) {
          paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
        } else {
          paginationHTML = "<span class=\"" + (params.currentClass) + "\"></span>"
          + ' / '
          + "<span class=\"" + (params.totalClass) + "\"></span>";
        }
        $el.html(paginationHTML);
      }
      if (params.type === 'progressbar') {
        if (params.renderProgressbar) {
          paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
        } else {
          paginationHTML = "<span class=\"" + (params.progressbarFillClass) + "\"></span>";
        }
        $el.html(paginationHTML);
      }
      if (params.type !== 'custom') {
        swiper.emit('paginationRender', swiper.pagination.$el[0]);
      }
    },
    init: function init() {
      var swiper = this;
      var params = swiper.params.pagination;
      if (!params.el) { return; }

      var $el = $(params.el);
      if ($el.length === 0) { return; }

      if (
        swiper.params.uniqueNavElements
        && typeof params.el === 'string'
        && $el.length > 1
        && swiper.$el.find(params.el).length === 1
      ) {
        $el = swiper.$el.find(params.el);
      }

      if (params.type === 'bullets' && params.clickable) {
        $el.addClass(params.clickableClass);
      }

      $el.addClass(params.modifierClass + params.type);

      if (params.type === 'bullets' && params.dynamicBullets) {
        $el.addClass(("" + (params.modifierClass) + (params.type) + "-dynamic"));
        swiper.pagination.dynamicBulletIndex = 0;
        if (params.dynamicMainBullets < 1) {
          params.dynamicMainBullets = 1;
        }
      }
      if (params.type === 'progressbar' && params.progressbarOpposite) {
        $el.addClass(params.progressbarOppositeClass);
      }

      if (params.clickable) {
        $el.on('click', ("." + (params.bulletClass)), function onClick(e) {
          e.preventDefault();
          var index = $(this).index() * swiper.params.slidesPerGroup;
          if (swiper.params.loop) { index += swiper.loopedSlides; }
          swiper.slideTo(index);
        });
      }

      Utils.extend(swiper.pagination, {
        $el: $el,
        el: $el[0],
      });
    },
    destroy: function destroy() {
      var swiper = this;
      var params = swiper.params.pagination;
      if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) { return; }
      var $el = swiper.pagination.$el;

      $el.removeClass(params.hiddenClass);
      $el.removeClass(params.modifierClass + params.type);
      if (swiper.pagination.bullets) { swiper.pagination.bullets.removeClass(params.bulletActiveClass); }
      if (params.clickable) {
        $el.off('click', ("." + (params.bulletClass)));
      }
    },
  };

  var Pagination$1 = {
    name: 'pagination',
    params: {
      pagination: {
        el: null,
        bulletElement: 'span',
        clickable: false,
        hideOnClick: false,
        renderBullet: null,
        renderProgressbar: null,
        renderFraction: null,
        renderCustom: null,
        progressbarOpposite: false,
        type: 'bullets', // 'bullets' or 'progressbar' or 'fraction' or 'custom'
        dynamicBullets: false,
        dynamicMainBullets: 1,
        formatFractionCurrent: function (number) { return number; },
        formatFractionTotal: function (number) { return number; },
        bulletClass: 'swiper-pagination-bullet',
        bulletActiveClass: 'swiper-pagination-bullet-active',
        modifierClass: 'swiper-pagination-', // NEW
        currentClass: 'swiper-pagination-current',
        totalClass: 'swiper-pagination-total',
        hiddenClass: 'swiper-pagination-hidden',
        progressbarFillClass: 'swiper-pagination-progressbar-fill',
        progressbarOppositeClass: 'swiper-pagination-progressbar-opposite',
        clickableClass: 'swiper-pagination-clickable', // NEW
        lockClass: 'swiper-pagination-lock',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        pagination: {
          init: Pagination.init.bind(swiper),
          render: Pagination.render.bind(swiper),
          update: Pagination.update.bind(swiper),
          destroy: Pagination.destroy.bind(swiper),
          dynamicBulletIndex: 0,
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        swiper.pagination.init();
        swiper.pagination.render();
        swiper.pagination.update();
      },
      activeIndexChange: function activeIndexChange() {
        var swiper = this;
        if (swiper.params.loop) {
          swiper.pagination.update();
        } else if (typeof swiper.snapIndex === 'undefined') {
          swiper.pagination.update();
        }
      },
      snapIndexChange: function snapIndexChange() {
        var swiper = this;
        if (!swiper.params.loop) {
          swiper.pagination.update();
        }
      },
      slidesLengthChange: function slidesLengthChange() {
        var swiper = this;
        if (swiper.params.loop) {
          swiper.pagination.render();
          swiper.pagination.update();
        }
      },
      snapGridLengthChange: function snapGridLengthChange() {
        var swiper = this;
        if (!swiper.params.loop) {
          swiper.pagination.render();
          swiper.pagination.update();
        }
      },
      destroy: function destroy() {
        var swiper = this;
        swiper.pagination.destroy();
      },
      click: function click(e) {
        var swiper = this;
        if (
          swiper.params.pagination.el
          && swiper.params.pagination.hideOnClick
          && swiper.pagination.$el.length > 0
          && !$(e.target).hasClass(swiper.params.pagination.bulletClass)
        ) {
          var isHidden = swiper.pagination.$el.hasClass(swiper.params.pagination.hiddenClass);
          if (isHidden === true) {
            swiper.emit('paginationShow', swiper);
          } else {
            swiper.emit('paginationHide', swiper);
          }
          swiper.pagination.$el.toggleClass(swiper.params.pagination.hiddenClass);
        }
      },
    },
  };

  var Scrollbar = {
    setTranslate: function setTranslate() {
      var swiper = this;
      if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) { return; }
      var scrollbar = swiper.scrollbar;
      var rtl = swiper.rtlTranslate;
      var progress = swiper.progress;
      var dragSize = scrollbar.dragSize;
      var trackSize = scrollbar.trackSize;
      var $dragEl = scrollbar.$dragEl;
      var $el = scrollbar.$el;
      var params = swiper.params.scrollbar;

      var newSize = dragSize;
      var newPos = (trackSize - dragSize) * progress;
      if (rtl) {
        newPos = -newPos;
        if (newPos > 0) {
          newSize = dragSize - newPos;
          newPos = 0;
        } else if (-newPos + dragSize > trackSize) {
          newSize = trackSize + newPos;
        }
      } else if (newPos < 0) {
        newSize = dragSize + newPos;
        newPos = 0;
      } else if (newPos + dragSize > trackSize) {
        newSize = trackSize - newPos;
      }
      if (swiper.isHorizontal()) {
        if (Support.transforms3d) {
          $dragEl.transform(("translate3d(" + newPos + "px, 0, 0)"));
        } else {
          $dragEl.transform(("translateX(" + newPos + "px)"));
        }
        $dragEl[0].style.width = newSize + "px";
      } else {
        if (Support.transforms3d) {
          $dragEl.transform(("translate3d(0px, " + newPos + "px, 0)"));
        } else {
          $dragEl.transform(("translateY(" + newPos + "px)"));
        }
        $dragEl[0].style.height = newSize + "px";
      }
      if (params.hide) {
        clearTimeout(swiper.scrollbar.timeout);
        $el[0].style.opacity = 1;
        swiper.scrollbar.timeout = setTimeout(function () {
          $el[0].style.opacity = 0;
          $el.transition(400);
        }, 1000);
      }
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) { return; }
      swiper.scrollbar.$dragEl.transition(duration);
    },
    updateSize: function updateSize() {
      var swiper = this;
      if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) { return; }

      var scrollbar = swiper.scrollbar;
      var $dragEl = scrollbar.$dragEl;
      var $el = scrollbar.$el;

      $dragEl[0].style.width = '';
      $dragEl[0].style.height = '';
      var trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;

      var divider = swiper.size / swiper.virtualSize;
      var moveDivider = divider * (trackSize / swiper.size);
      var dragSize;
      if (swiper.params.scrollbar.dragSize === 'auto') {
        dragSize = trackSize * divider;
      } else {
        dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
      }

      if (swiper.isHorizontal()) {
        $dragEl[0].style.width = dragSize + "px";
      } else {
        $dragEl[0].style.height = dragSize + "px";
      }

      if (divider >= 1) {
        $el[0].style.display = 'none';
      } else {
        $el[0].style.display = '';
      }
      if (swiper.params.scrollbar.hide) {
        $el[0].style.opacity = 0;
      }
      Utils.extend(scrollbar, {
        trackSize: trackSize,
        divider: divider,
        moveDivider: moveDivider,
        dragSize: dragSize,
      });
      scrollbar.$el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](swiper.params.scrollbar.lockClass);
    },
    getPointerPosition: function getPointerPosition(e) {
      var swiper = this;
      if (swiper.isHorizontal()) {
        return ((e.type === 'touchstart' || e.type === 'touchmove') ? e.targetTouches[0].pageX : e.pageX || e.clientX);
      }
      return ((e.type === 'touchstart' || e.type === 'touchmove') ? e.targetTouches[0].pageY : e.pageY || e.clientY);
    },
    setDragPosition: function setDragPosition(e) {
      var swiper = this;
      var scrollbar = swiper.scrollbar;
      var rtl = swiper.rtlTranslate;
      var $el = scrollbar.$el;
      var dragSize = scrollbar.dragSize;
      var trackSize = scrollbar.trackSize;
      var dragStartPos = scrollbar.dragStartPos;

      var positionRatio;
      positionRatio = ((scrollbar.getPointerPosition(e)) - $el.offset()[swiper.isHorizontal() ? 'left' : 'top']
        - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
      positionRatio = Math.max(Math.min(positionRatio, 1), 0);
      if (rtl) {
        positionRatio = 1 - positionRatio;
      }

      var position = swiper.minTranslate() + ((swiper.maxTranslate() - swiper.minTranslate()) * positionRatio);

      swiper.updateProgress(position);
      swiper.setTranslate(position);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    },
    onDragStart: function onDragStart(e) {
      var swiper = this;
      var params = swiper.params.scrollbar;
      var scrollbar = swiper.scrollbar;
      var $wrapperEl = swiper.$wrapperEl;
      var $el = scrollbar.$el;
      var $dragEl = scrollbar.$dragEl;
      swiper.scrollbar.isTouched = true;
      swiper.scrollbar.dragStartPos = (e.target === $dragEl[0] || e.target === $dragEl)
        ? scrollbar.getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
      e.preventDefault();
      e.stopPropagation();

      $wrapperEl.transition(100);
      $dragEl.transition(100);
      scrollbar.setDragPosition(e);

      clearTimeout(swiper.scrollbar.dragTimeout);

      $el.transition(0);
      if (params.hide) {
        $el.css('opacity', 1);
      }
      swiper.emit('scrollbarDragStart', e);
    },
    onDragMove: function onDragMove(e) {
      var swiper = this;
      var scrollbar = swiper.scrollbar;
      var $wrapperEl = swiper.$wrapperEl;
      var $el = scrollbar.$el;
      var $dragEl = scrollbar.$dragEl;

      if (!swiper.scrollbar.isTouched) { return; }
      if (e.preventDefault) { e.preventDefault(); }
      else { e.returnValue = false; }
      scrollbar.setDragPosition(e);
      $wrapperEl.transition(0);
      $el.transition(0);
      $dragEl.transition(0);
      swiper.emit('scrollbarDragMove', e);
    },
    onDragEnd: function onDragEnd(e) {
      var swiper = this;

      var params = swiper.params.scrollbar;
      var scrollbar = swiper.scrollbar;
      var $el = scrollbar.$el;

      if (!swiper.scrollbar.isTouched) { return; }
      swiper.scrollbar.isTouched = false;
      if (params.hide) {
        clearTimeout(swiper.scrollbar.dragTimeout);
        swiper.scrollbar.dragTimeout = Utils.nextTick(function () {
          $el.css('opacity', 0);
          $el.transition(400);
        }, 1000);
      }
      swiper.emit('scrollbarDragEnd', e);
      if (params.snapOnRelease) {
        swiper.slideToClosest();
      }
    },
    enableDraggable: function enableDraggable() {
      var swiper = this;
      if (!swiper.params.scrollbar.el) { return; }
      var scrollbar = swiper.scrollbar;
      var touchEventsTouch = swiper.touchEventsTouch;
      var touchEventsDesktop = swiper.touchEventsDesktop;
      var params = swiper.params;
      var $el = scrollbar.$el;
      var target = $el[0];
      var activeListener = Support.passiveListener && params.passiveListeners ? { passive: false, capture: false } : false;
      var passiveListener = Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
      if (!Support.touch) {
        target.addEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
        doc.addEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
        doc.addEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
      } else {
        target.addEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
        target.addEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
        target.addEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
      }
    },
    disableDraggable: function disableDraggable() {
      var swiper = this;
      if (!swiper.params.scrollbar.el) { return; }
      var scrollbar = swiper.scrollbar;
      var touchEventsTouch = swiper.touchEventsTouch;
      var touchEventsDesktop = swiper.touchEventsDesktop;
      var params = swiper.params;
      var $el = scrollbar.$el;
      var target = $el[0];
      var activeListener = Support.passiveListener && params.passiveListeners ? { passive: false, capture: false } : false;
      var passiveListener = Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
      if (!Support.touch) {
        target.removeEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
        doc.removeEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
        doc.removeEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
      } else {
        target.removeEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
        target.removeEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
        target.removeEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
      }
    },
    init: function init() {
      var swiper = this;
      if (!swiper.params.scrollbar.el) { return; }
      var scrollbar = swiper.scrollbar;
      var $swiperEl = swiper.$el;
      var params = swiper.params.scrollbar;

      var $el = $(params.el);
      if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && $swiperEl.find(params.el).length === 1) {
        $el = $swiperEl.find(params.el);
      }

      var $dragEl = $el.find(("." + (swiper.params.scrollbar.dragClass)));
      if ($dragEl.length === 0) {
        $dragEl = $(("<div class=\"" + (swiper.params.scrollbar.dragClass) + "\"></div>"));
        $el.append($dragEl);
      }

      Utils.extend(scrollbar, {
        $el: $el,
        el: $el[0],
        $dragEl: $dragEl,
        dragEl: $dragEl[0],
      });

      if (params.draggable) {
        scrollbar.enableDraggable();
      }
    },
    destroy: function destroy() {
      var swiper = this;
      swiper.scrollbar.disableDraggable();
    },
  };

  var Scrollbar$1 = {
    name: 'scrollbar',
    params: {
      scrollbar: {
        el: null,
        dragSize: 'auto',
        hide: false,
        draggable: false,
        snapOnRelease: true,
        lockClass: 'swiper-scrollbar-lock',
        dragClass: 'swiper-scrollbar-drag',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        scrollbar: {
          init: Scrollbar.init.bind(swiper),
          destroy: Scrollbar.destroy.bind(swiper),
          updateSize: Scrollbar.updateSize.bind(swiper),
          setTranslate: Scrollbar.setTranslate.bind(swiper),
          setTransition: Scrollbar.setTransition.bind(swiper),
          enableDraggable: Scrollbar.enableDraggable.bind(swiper),
          disableDraggable: Scrollbar.disableDraggable.bind(swiper),
          setDragPosition: Scrollbar.setDragPosition.bind(swiper),
          getPointerPosition: Scrollbar.getPointerPosition.bind(swiper),
          onDragStart: Scrollbar.onDragStart.bind(swiper),
          onDragMove: Scrollbar.onDragMove.bind(swiper),
          onDragEnd: Scrollbar.onDragEnd.bind(swiper),
          isTouched: false,
          timeout: null,
          dragTimeout: null,
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        swiper.scrollbar.init();
        swiper.scrollbar.updateSize();
        swiper.scrollbar.setTranslate();
      },
      update: function update() {
        var swiper = this;
        swiper.scrollbar.updateSize();
      },
      resize: function resize() {
        var swiper = this;
        swiper.scrollbar.updateSize();
      },
      observerUpdate: function observerUpdate() {
        var swiper = this;
        swiper.scrollbar.updateSize();
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        swiper.scrollbar.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        swiper.scrollbar.setTransition(duration);
      },
      destroy: function destroy() {
        var swiper = this;
        swiper.scrollbar.destroy();
      },
    },
  };

  var Parallax = {
    setTransform: function setTransform(el, progress) {
      var swiper = this;
      var rtl = swiper.rtl;

      var $el = $(el);
      var rtlFactor = rtl ? -1 : 1;

      var p = $el.attr('data-swiper-parallax') || '0';
      var x = $el.attr('data-swiper-parallax-x');
      var y = $el.attr('data-swiper-parallax-y');
      var scale = $el.attr('data-swiper-parallax-scale');
      var opacity = $el.attr('data-swiper-parallax-opacity');

      if (x || y) {
        x = x || '0';
        y = y || '0';
      } else if (swiper.isHorizontal()) {
        x = p;
        y = '0';
      } else {
        y = p;
        x = '0';
      }

      if ((x).indexOf('%') >= 0) {
        x = (parseInt(x, 10) * progress * rtlFactor) + "%";
      } else {
        x = (x * progress * rtlFactor) + "px";
      }
      if ((y).indexOf('%') >= 0) {
        y = (parseInt(y, 10) * progress) + "%";
      } else {
        y = (y * progress) + "px";
      }

      if (typeof opacity !== 'undefined' && opacity !== null) {
        var currentOpacity = opacity - ((opacity - 1) * (1 - Math.abs(progress)));
        $el[0].style.opacity = currentOpacity;
      }
      if (typeof scale === 'undefined' || scale === null) {
        $el.transform(("translate3d(" + x + ", " + y + ", 0px)"));
      } else {
        var currentScale = scale - ((scale - 1) * (1 - Math.abs(progress)));
        $el.transform(("translate3d(" + x + ", " + y + ", 0px) scale(" + currentScale + ")"));
      }
    },
    setTranslate: function setTranslate() {
      var swiper = this;
      var $el = swiper.$el;
      var slides = swiper.slides;
      var progress = swiper.progress;
      var snapGrid = swiper.snapGrid;
      $el.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]')
        .each(function (index, el) {
          swiper.parallax.setTransform(el, progress);
        });
      slides.each(function (slideIndex, slideEl) {
        var slideProgress = slideEl.progress;
        if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') {
          slideProgress += Math.ceil(slideIndex / 2) - (progress * (snapGrid.length - 1));
        }
        slideProgress = Math.min(Math.max(slideProgress, -1), 1);
        $(slideEl).find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]')
          .each(function (index, el) {
            swiper.parallax.setTransform(el, slideProgress);
          });
      });
    },
    setTransition: function setTransition(duration) {
      if ( duration === void 0 ) duration = this.params.speed;

      var swiper = this;
      var $el = swiper.$el;
      $el.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]')
        .each(function (index, parallaxEl) {
          var $parallaxEl = $(parallaxEl);
          var parallaxDuration = parseInt($parallaxEl.attr('data-swiper-parallax-duration'), 10) || duration;
          if (duration === 0) { parallaxDuration = 0; }
          $parallaxEl.transition(parallaxDuration);
        });
    },
  };

  var Parallax$1 = {
    name: 'parallax',
    params: {
      parallax: {
        enabled: false,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        parallax: {
          setTransform: Parallax.setTransform.bind(swiper),
          setTranslate: Parallax.setTranslate.bind(swiper),
          setTransition: Parallax.setTransition.bind(swiper),
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (!swiper.params.parallax.enabled) { return; }
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
      },
      init: function init() {
        var swiper = this;
        if (!swiper.params.parallax.enabled) { return; }
        swiper.parallax.setTranslate();
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (!swiper.params.parallax.enabled) { return; }
        swiper.parallax.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        if (!swiper.params.parallax.enabled) { return; }
        swiper.parallax.setTransition(duration);
      },
    },
  };

  var Zoom = {
    // Calc Scale From Multi-touches
    getDistanceBetweenTouches: function getDistanceBetweenTouches(e) {
      if (e.targetTouches.length < 2) { return 1; }
      var x1 = e.targetTouches[0].pageX;
      var y1 = e.targetTouches[0].pageY;
      var x2 = e.targetTouches[1].pageX;
      var y2 = e.targetTouches[1].pageY;
      var distance = Math.sqrt((Math.pow( (x2 - x1), 2 )) + (Math.pow( (y2 - y1), 2 )));
      return distance;
    },
    // Events
    onGestureStart: function onGestureStart(e) {
      var swiper = this;
      var params = swiper.params.zoom;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      zoom.fakeGestureTouched = false;
      zoom.fakeGestureMoved = false;
      if (!Support.gestures) {
        if (e.type !== 'touchstart' || (e.type === 'touchstart' && e.targetTouches.length < 2)) {
          return;
        }
        zoom.fakeGestureTouched = true;
        gesture.scaleStart = Zoom.getDistanceBetweenTouches(e);
      }
      if (!gesture.$slideEl || !gesture.$slideEl.length) {
        gesture.$slideEl = $(e.target).closest('.swiper-slide');
        if (gesture.$slideEl.length === 0) { gesture.$slideEl = swiper.slides.eq(swiper.activeIndex); }
        gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
        gesture.$imageWrapEl = gesture.$imageEl.parent(("." + (params.containerClass)));
        gesture.maxRatio = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
        if (gesture.$imageWrapEl.length === 0) {
          gesture.$imageEl = undefined;
          return;
        }
      }
      gesture.$imageEl.transition(0);
      swiper.zoom.isScaling = true;
    },
    onGestureChange: function onGestureChange(e) {
      var swiper = this;
      var params = swiper.params.zoom;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      if (!Support.gestures) {
        if (e.type !== 'touchmove' || (e.type === 'touchmove' && e.targetTouches.length < 2)) {
          return;
        }
        zoom.fakeGestureMoved = true;
        gesture.scaleMove = Zoom.getDistanceBetweenTouches(e);
      }
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
      if (Support.gestures) {
        zoom.scale = e.scale * zoom.currentScale;
      } else {
        zoom.scale = (gesture.scaleMove / gesture.scaleStart) * zoom.currentScale;
      }
      if (zoom.scale > gesture.maxRatio) {
        zoom.scale = (gesture.maxRatio - 1) + (Math.pow( ((zoom.scale - gesture.maxRatio) + 1), 0.5 ));
      }
      if (zoom.scale < params.minRatio) {
        zoom.scale = (params.minRatio + 1) - (Math.pow( ((params.minRatio - zoom.scale) + 1), 0.5 ));
      }
      gesture.$imageEl.transform(("translate3d(0,0,0) scale(" + (zoom.scale) + ")"));
    },
    onGestureEnd: function onGestureEnd(e) {
      var swiper = this;
      var params = swiper.params.zoom;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      if (!Support.gestures) {
        if (!zoom.fakeGestureTouched || !zoom.fakeGestureMoved) {
          return;
        }
        if (e.type !== 'touchend' || (e.type === 'touchend' && e.changedTouches.length < 2 && !Device.android)) {
          return;
        }
        zoom.fakeGestureTouched = false;
        zoom.fakeGestureMoved = false;
      }
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
      zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
      gesture.$imageEl.transition(swiper.params.speed).transform(("translate3d(0,0,0) scale(" + (zoom.scale) + ")"));
      zoom.currentScale = zoom.scale;
      zoom.isScaling = false;
      if (zoom.scale === 1) { gesture.$slideEl = undefined; }
    },
    onTouchStart: function onTouchStart(e) {
      var swiper = this;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      var image = zoom.image;
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
      if (image.isTouched) { return; }
      if (Device.android) { e.preventDefault(); }
      image.isTouched = true;
      image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
      image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
    },
    onTouchMove: function onTouchMove(e) {
      var swiper = this;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      var image = zoom.image;
      var velocity = zoom.velocity;
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
      swiper.allowClick = false;
      if (!image.isTouched || !gesture.$slideEl) { return; }

      if (!image.isMoved) {
        image.width = gesture.$imageEl[0].offsetWidth;
        image.height = gesture.$imageEl[0].offsetHeight;
        image.startX = Utils.getTranslate(gesture.$imageWrapEl[0], 'x') || 0;
        image.startY = Utils.getTranslate(gesture.$imageWrapEl[0], 'y') || 0;
        gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
        gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
        gesture.$imageWrapEl.transition(0);
        if (swiper.rtl) {
          image.startX = -image.startX;
          image.startY = -image.startY;
        }
      }
      // Define if we need image drag
      var scaledWidth = image.width * zoom.scale;
      var scaledHeight = image.height * zoom.scale;

      if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) { return; }

      image.minX = Math.min(((gesture.slideWidth / 2) - (scaledWidth / 2)), 0);
      image.maxX = -image.minX;
      image.minY = Math.min(((gesture.slideHeight / 2) - (scaledHeight / 2)), 0);
      image.maxY = -image.minY;

      image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
      image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;

      if (!image.isMoved && !zoom.isScaling) {
        if (
          swiper.isHorizontal()
          && (
            (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x)
            || (Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)
          )
        ) {
          image.isTouched = false;
          return;
        } if (
          !swiper.isHorizontal()
          && (
            (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y)
            || (Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)
          )
        ) {
          image.isTouched = false;
          return;
        }
      }
      e.preventDefault();
      e.stopPropagation();

      image.isMoved = true;
      image.currentX = (image.touchesCurrent.x - image.touchesStart.x) + image.startX;
      image.currentY = (image.touchesCurrent.y - image.touchesStart.y) + image.startY;

      if (image.currentX < image.minX) {
        image.currentX = (image.minX + 1) - (Math.pow( ((image.minX - image.currentX) + 1), 0.8 ));
      }
      if (image.currentX > image.maxX) {
        image.currentX = (image.maxX - 1) + (Math.pow( ((image.currentX - image.maxX) + 1), 0.8 ));
      }

      if (image.currentY < image.minY) {
        image.currentY = (image.minY + 1) - (Math.pow( ((image.minY - image.currentY) + 1), 0.8 ));
      }
      if (image.currentY > image.maxY) {
        image.currentY = (image.maxY - 1) + (Math.pow( ((image.currentY - image.maxY) + 1), 0.8 ));
      }

      // Velocity
      if (!velocity.prevPositionX) { velocity.prevPositionX = image.touchesCurrent.x; }
      if (!velocity.prevPositionY) { velocity.prevPositionY = image.touchesCurrent.y; }
      if (!velocity.prevTime) { velocity.prevTime = Date.now(); }
      velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
      velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
      if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) { velocity.x = 0; }
      if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) { velocity.y = 0; }
      velocity.prevPositionX = image.touchesCurrent.x;
      velocity.prevPositionY = image.touchesCurrent.y;
      velocity.prevTime = Date.now();

      gesture.$imageWrapEl.transform(("translate3d(" + (image.currentX) + "px, " + (image.currentY) + "px,0)"));
    },
    onTouchEnd: function onTouchEnd() {
      var swiper = this;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      var image = zoom.image;
      var velocity = zoom.velocity;
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
      if (!image.isTouched || !image.isMoved) {
        image.isTouched = false;
        image.isMoved = false;
        return;
      }
      image.isTouched = false;
      image.isMoved = false;
      var momentumDurationX = 300;
      var momentumDurationY = 300;
      var momentumDistanceX = velocity.x * momentumDurationX;
      var newPositionX = image.currentX + momentumDistanceX;
      var momentumDistanceY = velocity.y * momentumDurationY;
      var newPositionY = image.currentY + momentumDistanceY;

      // Fix duration
      if (velocity.x !== 0) { momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x); }
      if (velocity.y !== 0) { momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y); }
      var momentumDuration = Math.max(momentumDurationX, momentumDurationY);

      image.currentX = newPositionX;
      image.currentY = newPositionY;

      // Define if we need image drag
      var scaledWidth = image.width * zoom.scale;
      var scaledHeight = image.height * zoom.scale;
      image.minX = Math.min(((gesture.slideWidth / 2) - (scaledWidth / 2)), 0);
      image.maxX = -image.minX;
      image.minY = Math.min(((gesture.slideHeight / 2) - (scaledHeight / 2)), 0);
      image.maxY = -image.minY;
      image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
      image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);

      gesture.$imageWrapEl.transition(momentumDuration).transform(("translate3d(" + (image.currentX) + "px, " + (image.currentY) + "px,0)"));
    },
    onTransitionEnd: function onTransitionEnd() {
      var swiper = this;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
        gesture.$imageEl.transform('translate3d(0,0,0) scale(1)');
        gesture.$imageWrapEl.transform('translate3d(0,0,0)');

        zoom.scale = 1;
        zoom.currentScale = 1;

        gesture.$slideEl = undefined;
        gesture.$imageEl = undefined;
        gesture.$imageWrapEl = undefined;
      }
    },
    // Toggle Zoom
    toggle: function toggle(e) {
      var swiper = this;
      var zoom = swiper.zoom;

      if (zoom.scale && zoom.scale !== 1) {
        // Zoom Out
        zoom.out();
      } else {
        // Zoom In
        zoom.in(e);
      }
    },
    in: function in$1(e) {
      var swiper = this;

      var zoom = swiper.zoom;
      var params = swiper.params.zoom;
      var gesture = zoom.gesture;
      var image = zoom.image;

      if (!gesture.$slideEl) {
        gesture.$slideEl = swiper.clickedSlide ? $(swiper.clickedSlide) : swiper.slides.eq(swiper.activeIndex);
        gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
        gesture.$imageWrapEl = gesture.$imageEl.parent(("." + (params.containerClass)));
      }
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }

      gesture.$slideEl.addClass(("" + (params.zoomedSlideClass)));

      var touchX;
      var touchY;
      var offsetX;
      var offsetY;
      var diffX;
      var diffY;
      var translateX;
      var translateY;
      var imageWidth;
      var imageHeight;
      var scaledWidth;
      var scaledHeight;
      var translateMinX;
      var translateMinY;
      var translateMaxX;
      var translateMaxY;
      var slideWidth;
      var slideHeight;

      if (typeof image.touchesStart.x === 'undefined' && e) {
        touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
        touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
      } else {
        touchX = image.touchesStart.x;
        touchY = image.touchesStart.y;
      }

      zoom.scale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
      zoom.currentScale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
      if (e) {
        slideWidth = gesture.$slideEl[0].offsetWidth;
        slideHeight = gesture.$slideEl[0].offsetHeight;
        offsetX = gesture.$slideEl.offset().left;
        offsetY = gesture.$slideEl.offset().top;
        diffX = (offsetX + (slideWidth / 2)) - touchX;
        diffY = (offsetY + (slideHeight / 2)) - touchY;

        imageWidth = gesture.$imageEl[0].offsetWidth;
        imageHeight = gesture.$imageEl[0].offsetHeight;
        scaledWidth = imageWidth * zoom.scale;
        scaledHeight = imageHeight * zoom.scale;

        translateMinX = Math.min(((slideWidth / 2) - (scaledWidth / 2)), 0);
        translateMinY = Math.min(((slideHeight / 2) - (scaledHeight / 2)), 0);
        translateMaxX = -translateMinX;
        translateMaxY = -translateMinY;

        translateX = diffX * zoom.scale;
        translateY = diffY * zoom.scale;

        if (translateX < translateMinX) {
          translateX = translateMinX;
        }
        if (translateX > translateMaxX) {
          translateX = translateMaxX;
        }

        if (translateY < translateMinY) {
          translateY = translateMinY;
        }
        if (translateY > translateMaxY) {
          translateY = translateMaxY;
        }
      } else {
        translateX = 0;
        translateY = 0;
      }
      gesture.$imageWrapEl.transition(300).transform(("translate3d(" + translateX + "px, " + translateY + "px,0)"));
      gesture.$imageEl.transition(300).transform(("translate3d(0,0,0) scale(" + (zoom.scale) + ")"));
    },
    out: function out() {
      var swiper = this;

      var zoom = swiper.zoom;
      var params = swiper.params.zoom;
      var gesture = zoom.gesture;

      if (!gesture.$slideEl) {
        gesture.$slideEl = swiper.clickedSlide ? $(swiper.clickedSlide) : swiper.slides.eq(swiper.activeIndex);
        gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
        gesture.$imageWrapEl = gesture.$imageEl.parent(("." + (params.containerClass)));
      }
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }

      zoom.scale = 1;
      zoom.currentScale = 1;
      gesture.$imageWrapEl.transition(300).transform('translate3d(0,0,0)');
      gesture.$imageEl.transition(300).transform('translate3d(0,0,0) scale(1)');
      gesture.$slideEl.removeClass(("" + (params.zoomedSlideClass)));
      gesture.$slideEl = undefined;
    },
    // Attach/Detach Events
    enable: function enable() {
      var swiper = this;
      var zoom = swiper.zoom;
      if (zoom.enabled) { return; }
      zoom.enabled = true;

      var passiveListener = swiper.touchEvents.start === 'touchstart' && Support.passiveListener && swiper.params.passiveListeners ? { passive: true, capture: false } : false;

      // Scale image
      if (Support.gestures) {
        swiper.$wrapperEl.on('gesturestart', '.swiper-slide', zoom.onGestureStart, passiveListener);
        swiper.$wrapperEl.on('gesturechange', '.swiper-slide', zoom.onGestureChange, passiveListener);
        swiper.$wrapperEl.on('gestureend', '.swiper-slide', zoom.onGestureEnd, passiveListener);
      } else if (swiper.touchEvents.start === 'touchstart') {
        swiper.$wrapperEl.on(swiper.touchEvents.start, '.swiper-slide', zoom.onGestureStart, passiveListener);
        swiper.$wrapperEl.on(swiper.touchEvents.move, '.swiper-slide', zoom.onGestureChange, passiveListener);
        swiper.$wrapperEl.on(swiper.touchEvents.end, '.swiper-slide', zoom.onGestureEnd, passiveListener);
      }

      // Move image
      swiper.$wrapperEl.on(swiper.touchEvents.move, ("." + (swiper.params.zoom.containerClass)), zoom.onTouchMove);
    },
    disable: function disable() {
      var swiper = this;
      var zoom = swiper.zoom;
      if (!zoom.enabled) { return; }

      swiper.zoom.enabled = false;

      var passiveListener = swiper.touchEvents.start === 'touchstart' && Support.passiveListener && swiper.params.passiveListeners ? { passive: true, capture: false } : false;

      // Scale image
      if (Support.gestures) {
        swiper.$wrapperEl.off('gesturestart', '.swiper-slide', zoom.onGestureStart, passiveListener);
        swiper.$wrapperEl.off('gesturechange', '.swiper-slide', zoom.onGestureChange, passiveListener);
        swiper.$wrapperEl.off('gestureend', '.swiper-slide', zoom.onGestureEnd, passiveListener);
      } else if (swiper.touchEvents.start === 'touchstart') {
        swiper.$wrapperEl.off(swiper.touchEvents.start, '.swiper-slide', zoom.onGestureStart, passiveListener);
        swiper.$wrapperEl.off(swiper.touchEvents.move, '.swiper-slide', zoom.onGestureChange, passiveListener);
        swiper.$wrapperEl.off(swiper.touchEvents.end, '.swiper-slide', zoom.onGestureEnd, passiveListener);
      }

      // Move image
      swiper.$wrapperEl.off(swiper.touchEvents.move, ("." + (swiper.params.zoom.containerClass)), zoom.onTouchMove);
    },
  };

  var Zoom$1 = {
    name: 'zoom',
    params: {
      zoom: {
        enabled: false,
        maxRatio: 3,
        minRatio: 1,
        toggle: true,
        containerClass: 'swiper-zoom-container',
        zoomedSlideClass: 'swiper-slide-zoomed',
      },
    },
    create: function create() {
      var swiper = this;
      var zoom = {
        enabled: false,
        scale: 1,
        currentScale: 1,
        isScaling: false,
        gesture: {
          $slideEl: undefined,
          slideWidth: undefined,
          slideHeight: undefined,
          $imageEl: undefined,
          $imageWrapEl: undefined,
          maxRatio: 3,
        },
        image: {
          isTouched: undefined,
          isMoved: undefined,
          currentX: undefined,
          currentY: undefined,
          minX: undefined,
          minY: undefined,
          maxX: undefined,
          maxY: undefined,
          width: undefined,
          height: undefined,
          startX: undefined,
          startY: undefined,
          touchesStart: {},
          touchesCurrent: {},
        },
        velocity: {
          x: undefined,
          y: undefined,
          prevPositionX: undefined,
          prevPositionY: undefined,
          prevTime: undefined,
        },
      };

      ('onGestureStart onGestureChange onGestureEnd onTouchStart onTouchMove onTouchEnd onTransitionEnd toggle enable disable in out').split(' ').forEach(function (methodName) {
        zoom[methodName] = Zoom[methodName].bind(swiper);
      });
      Utils.extend(swiper, {
        zoom: zoom,
      });

      var scale = 1;
      Object.defineProperty(swiper.zoom, 'scale', {
        get: function get() {
          return scale;
        },
        set: function set(value) {
          if (scale !== value) {
            var imageEl = swiper.zoom.gesture.$imageEl ? swiper.zoom.gesture.$imageEl[0] : undefined;
            var slideEl = swiper.zoom.gesture.$slideEl ? swiper.zoom.gesture.$slideEl[0] : undefined;
            swiper.emit('zoomChange', value, imageEl, slideEl);
          }
          scale = value;
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (swiper.params.zoom.enabled) {
          swiper.zoom.enable();
        }
      },
      destroy: function destroy() {
        var swiper = this;
        swiper.zoom.disable();
      },
      touchStart: function touchStart(e) {
        var swiper = this;
        if (!swiper.zoom.enabled) { return; }
        swiper.zoom.onTouchStart(e);
      },
      touchEnd: function touchEnd(e) {
        var swiper = this;
        if (!swiper.zoom.enabled) { return; }
        swiper.zoom.onTouchEnd(e);
      },
      doubleTap: function doubleTap(e) {
        var swiper = this;
        if (swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) {
          swiper.zoom.toggle(e);
        }
      },
      transitionEnd: function transitionEnd() {
        var swiper = this;
        if (swiper.zoom.enabled && swiper.params.zoom.enabled) {
          swiper.zoom.onTransitionEnd();
        }
      },
    },
  };

  var Lazy = {
    loadInSlide: function loadInSlide(index, loadInDuplicate) {
      if ( loadInDuplicate === void 0 ) loadInDuplicate = true;

      var swiper = this;
      var params = swiper.params.lazy;
      if (typeof index === 'undefined') { return; }
      if (swiper.slides.length === 0) { return; }
      var isVirtual = swiper.virtual && swiper.params.virtual.enabled;

      var $slideEl = isVirtual
        ? swiper.$wrapperEl.children(("." + (swiper.params.slideClass) + "[data-swiper-slide-index=\"" + index + "\"]"))
        : swiper.slides.eq(index);

      var $images = $slideEl.find(("." + (params.elementClass) + ":not(." + (params.loadedClass) + "):not(." + (params.loadingClass) + ")"));
      if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) {
        $images = $images.add($slideEl[0]);
      }
      if ($images.length === 0) { return; }

      $images.each(function (imageIndex, imageEl) {
        var $imageEl = $(imageEl);
        $imageEl.addClass(params.loadingClass);

        var background = $imageEl.attr('data-background');
        var src = $imageEl.attr('data-src');
        var srcset = $imageEl.attr('data-srcset');
        var sizes = $imageEl.attr('data-sizes');

        swiper.loadImage($imageEl[0], (src || background), srcset, sizes, false, function () {
          if (typeof swiper === 'undefined' || swiper === null || !swiper || (swiper && !swiper.params) || swiper.destroyed) { return; }
          if (background) {
            $imageEl.css('background-image', ("url(\"" + background + "\")"));
            $imageEl.removeAttr('data-background');
          } else {
            if (srcset) {
              $imageEl.attr('srcset', srcset);
              $imageEl.removeAttr('data-srcset');
            }
            if (sizes) {
              $imageEl.attr('sizes', sizes);
              $imageEl.removeAttr('data-sizes');
            }
            if (src) {
              $imageEl.attr('src', src);
              $imageEl.removeAttr('data-src');
            }
          }

          $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
          $slideEl.find(("." + (params.preloaderClass))).remove();
          if (swiper.params.loop && loadInDuplicate) {
            var slideOriginalIndex = $slideEl.attr('data-swiper-slide-index');
            if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
              var originalSlide = swiper.$wrapperEl.children(("[data-swiper-slide-index=\"" + slideOriginalIndex + "\"]:not(." + (swiper.params.slideDuplicateClass) + ")"));
              swiper.lazy.loadInSlide(originalSlide.index(), false);
            } else {
              var duplicatedSlide = swiper.$wrapperEl.children(("." + (swiper.params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + slideOriginalIndex + "\"]"));
              swiper.lazy.loadInSlide(duplicatedSlide.index(), false);
            }
          }
          swiper.emit('lazyImageReady', $slideEl[0], $imageEl[0]);
        });

        swiper.emit('lazyImageLoad', $slideEl[0], $imageEl[0]);
      });
    },
    load: function load() {
      var swiper = this;
      var $wrapperEl = swiper.$wrapperEl;
      var swiperParams = swiper.params;
      var slides = swiper.slides;
      var activeIndex = swiper.activeIndex;
      var isVirtual = swiper.virtual && swiperParams.virtual.enabled;
      var params = swiperParams.lazy;

      var slidesPerView = swiperParams.slidesPerView;
      if (slidesPerView === 'auto') {
        slidesPerView = 0;
      }

      function slideExist(index) {
        if (isVirtual) {
          if ($wrapperEl.children(("." + (swiperParams.slideClass) + "[data-swiper-slide-index=\"" + index + "\"]")).length) {
            return true;
          }
        } else if (slides[index]) { return true; }
        return false;
      }
      function slideIndex(slideEl) {
        if (isVirtual) {
          return $(slideEl).attr('data-swiper-slide-index');
        }
        return $(slideEl).index();
      }

      if (!swiper.lazy.initialImageLoaded) { swiper.lazy.initialImageLoaded = true; }
      if (swiper.params.watchSlidesVisibility) {
        $wrapperEl.children(("." + (swiperParams.slideVisibleClass))).each(function (elIndex, slideEl) {
          var index = isVirtual ? $(slideEl).attr('data-swiper-slide-index') : $(slideEl).index();
          swiper.lazy.loadInSlide(index);
        });
      } else if (slidesPerView > 1) {
        for (var i = activeIndex; i < activeIndex + slidesPerView; i += 1) {
          if (slideExist(i)) { swiper.lazy.loadInSlide(i); }
        }
      } else {
        swiper.lazy.loadInSlide(activeIndex);
      }
      if (params.loadPrevNext) {
        if (slidesPerView > 1 || (params.loadPrevNextAmount && params.loadPrevNextAmount > 1)) {
          var amount = params.loadPrevNextAmount;
          var spv = slidesPerView;
          var maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
          var minIndex = Math.max(activeIndex - Math.max(spv, amount), 0);
          // Next Slides
          for (var i$1 = activeIndex + slidesPerView; i$1 < maxIndex; i$1 += 1) {
            if (slideExist(i$1)) { swiper.lazy.loadInSlide(i$1); }
          }
          // Prev Slides
          for (var i$2 = minIndex; i$2 < activeIndex; i$2 += 1) {
            if (slideExist(i$2)) { swiper.lazy.loadInSlide(i$2); }
          }
        } else {
          var nextSlide = $wrapperEl.children(("." + (swiperParams.slideNextClass)));
          if (nextSlide.length > 0) { swiper.lazy.loadInSlide(slideIndex(nextSlide)); }

          var prevSlide = $wrapperEl.children(("." + (swiperParams.slidePrevClass)));
          if (prevSlide.length > 0) { swiper.lazy.loadInSlide(slideIndex(prevSlide)); }
        }
      }
    },
  };

  var Lazy$1 = {
    name: 'lazy',
    params: {
      lazy: {
        enabled: false,
        loadPrevNext: false,
        loadPrevNextAmount: 1,
        loadOnTransitionStart: false,

        elementClass: 'swiper-lazy',
        loadingClass: 'swiper-lazy-loading',
        loadedClass: 'swiper-lazy-loaded',
        preloaderClass: 'swiper-lazy-preloader',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        lazy: {
          initialImageLoaded: false,
          load: Lazy.load.bind(swiper),
          loadInSlide: Lazy.loadInSlide.bind(swiper),
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (swiper.params.lazy.enabled && swiper.params.preloadImages) {
          swiper.params.preloadImages = false;
        }
      },
      init: function init() {
        var swiper = this;
        if (swiper.params.lazy.enabled && !swiper.params.loop && swiper.params.initialSlide === 0) {
          swiper.lazy.load();
        }
      },
      scroll: function scroll() {
        var swiper = this;
        if (swiper.params.freeMode && !swiper.params.freeModeSticky) {
          swiper.lazy.load();
        }
      },
      resize: function resize() {
        var swiper = this;
        if (swiper.params.lazy.enabled) {
          swiper.lazy.load();
        }
      },
      scrollbarDragMove: function scrollbarDragMove() {
        var swiper = this;
        if (swiper.params.lazy.enabled) {
          swiper.lazy.load();
        }
      },
      transitionStart: function transitionStart() {
        var swiper = this;
        if (swiper.params.lazy.enabled) {
          if (swiper.params.lazy.loadOnTransitionStart || (!swiper.params.lazy.loadOnTransitionStart && !swiper.lazy.initialImageLoaded)) {
            swiper.lazy.load();
          }
        }
      },
      transitionEnd: function transitionEnd() {
        var swiper = this;
        if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
          swiper.lazy.load();
        }
      },
    },
  };

  /* eslint no-bitwise: ["error", { "allow": [">>"] }] */

  var Controller = {
    LinearSpline: function LinearSpline(x, y) {
      var binarySearch = (function search() {
        var maxIndex;
        var minIndex;
        var guess;
        return function (array, val) {
          minIndex = -1;
          maxIndex = array.length;
          while (maxIndex - minIndex > 1) {
            guess = maxIndex + minIndex >> 1;
            if (array[guess] <= val) {
              minIndex = guess;
            } else {
              maxIndex = guess;
            }
          }
          return maxIndex;
        };
      }());
      this.x = x;
      this.y = y;
      this.lastIndex = x.length - 1;
      // Given an x value (x2), return the expected y2 value:
      // (x1,y1) is the known point before given value,
      // (x3,y3) is the known point after given value.
      var i1;
      var i3;

      this.interpolate = function interpolate(x2) {
        if (!x2) { return 0; }

        // Get the indexes of x1 and x3 (the array indexes before and after given x2):
        i3 = binarySearch(this.x, x2);
        i1 = i3 - 1;

        // We have our indexes i1 & i3, so we can calculate already:
        // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
        return (((x2 - this.x[i1]) * (this.y[i3] - this.y[i1])) / (this.x[i3] - this.x[i1])) + this.y[i1];
      };
      return this;
    },
    // xxx: for now i will just save one spline function to to
    getInterpolateFunction: function getInterpolateFunction(c) {
      var swiper = this;
      if (!swiper.controller.spline) {
        swiper.controller.spline = swiper.params.loop
          ? new Controller.LinearSpline(swiper.slidesGrid, c.slidesGrid)
          : new Controller.LinearSpline(swiper.snapGrid, c.snapGrid);
      }
    },
    setTranslate: function setTranslate(setTranslate$1, byController) {
      var swiper = this;
      var controlled = swiper.controller.control;
      var multiplier;
      var controlledTranslate;
      function setControlledTranslate(c) {
        // this will create an Interpolate function based on the snapGrids
        // x is the Grid of the scrolled scroller and y will be the controlled scroller
        // it makes sense to create this only once and recall it for the interpolation
        // the function does a lot of value caching for performance
        var translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
        if (swiper.params.controller.by === 'slide') {
          swiper.controller.getInterpolateFunction(c);
          // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
          // but it did not work out
          controlledTranslate = -swiper.controller.spline.interpolate(-translate);
        }

        if (!controlledTranslate || swiper.params.controller.by === 'container') {
          multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
          controlledTranslate = ((translate - swiper.minTranslate()) * multiplier) + c.minTranslate();
        }

        if (swiper.params.controller.inverse) {
          controlledTranslate = c.maxTranslate() - controlledTranslate;
        }
        c.updateProgress(controlledTranslate);
        c.setTranslate(controlledTranslate, swiper);
        c.updateActiveIndex();
        c.updateSlidesClasses();
      }
      if (Array.isArray(controlled)) {
        for (var i = 0; i < controlled.length; i += 1) {
          if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
            setControlledTranslate(controlled[i]);
          }
        }
      } else if (controlled instanceof Swiper && byController !== controlled) {
        setControlledTranslate(controlled);
      }
    },
    setTransition: function setTransition(duration, byController) {
      var swiper = this;
      var controlled = swiper.controller.control;
      var i;
      function setControlledTransition(c) {
        c.setTransition(duration, swiper);
        if (duration !== 0) {
          c.transitionStart();
          if (c.params.autoHeight) {
            Utils.nextTick(function () {
              c.updateAutoHeight();
            });
          }
          c.$wrapperEl.transitionEnd(function () {
            if (!controlled) { return; }
            if (c.params.loop && swiper.params.controller.by === 'slide') {
              c.loopFix();
            }
            c.transitionEnd();
          });
        }
      }
      if (Array.isArray(controlled)) {
        for (i = 0; i < controlled.length; i += 1) {
          if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
            setControlledTransition(controlled[i]);
          }
        }
      } else if (controlled instanceof Swiper && byController !== controlled) {
        setControlledTransition(controlled);
      }
    },
  };
  var Controller$1 = {
    name: 'controller',
    params: {
      controller: {
        control: undefined,
        inverse: false,
        by: 'slide', // or 'container'
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        controller: {
          control: swiper.params.controller.control,
          getInterpolateFunction: Controller.getInterpolateFunction.bind(swiper),
          setTranslate: Controller.setTranslate.bind(swiper),
          setTransition: Controller.setTransition.bind(swiper),
        },
      });
    },
    on: {
      update: function update() {
        var swiper = this;
        if (!swiper.controller.control) { return; }
        if (swiper.controller.spline) {
          swiper.controller.spline = undefined;
          delete swiper.controller.spline;
        }
      },
      resize: function resize() {
        var swiper = this;
        if (!swiper.controller.control) { return; }
        if (swiper.controller.spline) {
          swiper.controller.spline = undefined;
          delete swiper.controller.spline;
        }
      },
      observerUpdate: function observerUpdate() {
        var swiper = this;
        if (!swiper.controller.control) { return; }
        if (swiper.controller.spline) {
          swiper.controller.spline = undefined;
          delete swiper.controller.spline;
        }
      },
      setTranslate: function setTranslate(translate, byController) {
        var swiper = this;
        if (!swiper.controller.control) { return; }
        swiper.controller.setTranslate(translate, byController);
      },
      setTransition: function setTransition(duration, byController) {
        var swiper = this;
        if (!swiper.controller.control) { return; }
        swiper.controller.setTransition(duration, byController);
      },
    },
  };

  var a11y = {
    makeElFocusable: function makeElFocusable($el) {
      $el.attr('tabIndex', '0');
      return $el;
    },
    addElRole: function addElRole($el, role) {
      $el.attr('role', role);
      return $el;
    },
    addElLabel: function addElLabel($el, label) {
      $el.attr('aria-label', label);
      return $el;
    },
    disableEl: function disableEl($el) {
      $el.attr('aria-disabled', true);
      return $el;
    },
    enableEl: function enableEl($el) {
      $el.attr('aria-disabled', false);
      return $el;
    },
    onEnterKey: function onEnterKey(e) {
      var swiper = this;
      var params = swiper.params.a11y;
      if (e.keyCode !== 13) { return; }
      var $targetEl = $(e.target);
      if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
        if (!(swiper.isEnd && !swiper.params.loop)) {
          swiper.slideNext();
        }
        if (swiper.isEnd) {
          swiper.a11y.notify(params.lastSlideMessage);
        } else {
          swiper.a11y.notify(params.nextSlideMessage);
        }
      }
      if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
        if (!(swiper.isBeginning && !swiper.params.loop)) {
          swiper.slidePrev();
        }
        if (swiper.isBeginning) {
          swiper.a11y.notify(params.firstSlideMessage);
        } else {
          swiper.a11y.notify(params.prevSlideMessage);
        }
      }
      if (swiper.pagination && $targetEl.is(("." + (swiper.params.pagination.bulletClass)))) {
        $targetEl[0].click();
      }
    },
    notify: function notify(message) {
      var swiper = this;
      var notification = swiper.a11y.liveRegion;
      if (notification.length === 0) { return; }
      notification.html('');
      notification.html(message);
    },
    updateNavigation: function updateNavigation() {
      var swiper = this;

      if (swiper.params.loop) { return; }
      var ref = swiper.navigation;
      var $nextEl = ref.$nextEl;
      var $prevEl = ref.$prevEl;

      if ($prevEl && $prevEl.length > 0) {
        if (swiper.isBeginning) {
          swiper.a11y.disableEl($prevEl);
        } else {
          swiper.a11y.enableEl($prevEl);
        }
      }
      if ($nextEl && $nextEl.length > 0) {
        if (swiper.isEnd) {
          swiper.a11y.disableEl($nextEl);
        } else {
          swiper.a11y.enableEl($nextEl);
        }
      }
    },
    updatePagination: function updatePagination() {
      var swiper = this;
      var params = swiper.params.a11y;
      if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
        swiper.pagination.bullets.each(function (bulletIndex, bulletEl) {
          var $bulletEl = $(bulletEl);
          swiper.a11y.makeElFocusable($bulletEl);
          swiper.a11y.addElRole($bulletEl, 'button');
          swiper.a11y.addElLabel($bulletEl, params.paginationBulletMessage.replace(/{{index}}/, $bulletEl.index() + 1));
        });
      }
    },
    init: function init() {
      var swiper = this;

      swiper.$el.append(swiper.a11y.liveRegion);

      // Navigation
      var params = swiper.params.a11y;
      var $nextEl;
      var $prevEl;
      if (swiper.navigation && swiper.navigation.$nextEl) {
        $nextEl = swiper.navigation.$nextEl;
      }
      if (swiper.navigation && swiper.navigation.$prevEl) {
        $prevEl = swiper.navigation.$prevEl;
      }
      if ($nextEl) {
        swiper.a11y.makeElFocusable($nextEl);
        swiper.a11y.addElRole($nextEl, 'button');
        swiper.a11y.addElLabel($nextEl, params.nextSlideMessage);
        $nextEl.on('keydown', swiper.a11y.onEnterKey);
      }
      if ($prevEl) {
        swiper.a11y.makeElFocusable($prevEl);
        swiper.a11y.addElRole($prevEl, 'button');
        swiper.a11y.addElLabel($prevEl, params.prevSlideMessage);
        $prevEl.on('keydown', swiper.a11y.onEnterKey);
      }

      // Pagination
      if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
        swiper.pagination.$el.on('keydown', ("." + (swiper.params.pagination.bulletClass)), swiper.a11y.onEnterKey);
      }
    },
    destroy: function destroy() {
      var swiper = this;
      if (swiper.a11y.liveRegion && swiper.a11y.liveRegion.length > 0) { swiper.a11y.liveRegion.remove(); }

      var $nextEl;
      var $prevEl;
      if (swiper.navigation && swiper.navigation.$nextEl) {
        $nextEl = swiper.navigation.$nextEl;
      }
      if (swiper.navigation && swiper.navigation.$prevEl) {
        $prevEl = swiper.navigation.$prevEl;
      }
      if ($nextEl) {
        $nextEl.off('keydown', swiper.a11y.onEnterKey);
      }
      if ($prevEl) {
        $prevEl.off('keydown', swiper.a11y.onEnterKey);
      }

      // Pagination
      if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
        swiper.pagination.$el.off('keydown', ("." + (swiper.params.pagination.bulletClass)), swiper.a11y.onEnterKey);
      }
    },
  };
  var A11y = {
    name: 'a11y',
    params: {
      a11y: {
        enabled: true,
        notificationClass: 'swiper-notification',
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
        firstSlideMessage: 'This is the first slide',
        lastSlideMessage: 'This is the last slide',
        paginationBulletMessage: 'Go to slide {{index}}',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        a11y: {
          liveRegion: $(("<span class=\"" + (swiper.params.a11y.notificationClass) + "\" aria-live=\"assertive\" aria-atomic=\"true\"></span>")),
        },
      });
      Object.keys(a11y).forEach(function (methodName) {
        swiper.a11y[methodName] = a11y[methodName].bind(swiper);
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (!swiper.params.a11y.enabled) { return; }
        swiper.a11y.init();
        swiper.a11y.updateNavigation();
      },
      toEdge: function toEdge() {
        var swiper = this;
        if (!swiper.params.a11y.enabled) { return; }
        swiper.a11y.updateNavigation();
      },
      fromEdge: function fromEdge() {
        var swiper = this;
        if (!swiper.params.a11y.enabled) { return; }
        swiper.a11y.updateNavigation();
      },
      paginationUpdate: function paginationUpdate() {
        var swiper = this;
        if (!swiper.params.a11y.enabled) { return; }
        swiper.a11y.updatePagination();
      },
      destroy: function destroy() {
        var swiper = this;
        if (!swiper.params.a11y.enabled) { return; }
        swiper.a11y.destroy();
      },
    },
  };

  var History = {
    init: function init() {
      var swiper = this;
      if (!swiper.params.history) { return; }
      if (!win.history || !win.history.pushState) {
        swiper.params.history.enabled = false;
        swiper.params.hashNavigation.enabled = true;
        return;
      }
      var history = swiper.history;
      history.initialized = true;
      history.paths = History.getPathValues();
      if (!history.paths.key && !history.paths.value) { return; }
      history.scrollToSlide(0, history.paths.value, swiper.params.runCallbacksOnInit);
      if (!swiper.params.history.replaceState) {
        win.addEventListener('popstate', swiper.history.setHistoryPopState);
      }
    },
    destroy: function destroy() {
      var swiper = this;
      if (!swiper.params.history.replaceState) {
        win.removeEventListener('popstate', swiper.history.setHistoryPopState);
      }
    },
    setHistoryPopState: function setHistoryPopState() {
      var swiper = this;
      swiper.history.paths = History.getPathValues();
      swiper.history.scrollToSlide(swiper.params.speed, swiper.history.paths.value, false);
    },
    getPathValues: function getPathValues() {
      var pathArray = win.location.pathname.slice(1).split('/').filter(function (part) { return part !== ''; });
      var total = pathArray.length;
      var key = pathArray[total - 2];
      var value = pathArray[total - 1];
      return { key: key, value: value };
    },
    setHistory: function setHistory(key, index) {
      var swiper = this;
      if (!swiper.history.initialized || !swiper.params.history.enabled) { return; }
      var slide = swiper.slides.eq(index);
      var value = History.slugify(slide.attr('data-history'));
      if (!win.location.pathname.includes(key)) {
        value = key + "/" + value;
      }
      var currentState = win.history.state;
      if (currentState && currentState.value === value) {
        return;
      }
      if (swiper.params.history.replaceState) {
        win.history.replaceState({ value: value }, null, value);
      } else {
        win.history.pushState({ value: value }, null, value);
      }
    },
    slugify: function slugify(text) {
      return text.toString()
        .replace(/\s+/g, '-')
        .replace(/[^\w-]+/g, '')
        .replace(/--+/g, '-')
        .replace(/^-+/, '')
        .replace(/-+$/, '');
    },
    scrollToSlide: function scrollToSlide(speed, value, runCallbacks) {
      var swiper = this;
      if (value) {
        for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
          var slide = swiper.slides.eq(i);
          var slideHistory = History.slugify(slide.attr('data-history'));
          if (slideHistory === value && !slide.hasClass(swiper.params.slideDuplicateClass)) {
            var index = slide.index();
            swiper.slideTo(index, speed, runCallbacks);
          }
        }
      } else {
        swiper.slideTo(0, speed, runCallbacks);
      }
    },
  };

  var History$1 = {
    name: 'history',
    params: {
      history: {
        enabled: false,
        replaceState: false,
        key: 'slides',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        history: {
          init: History.init.bind(swiper),
          setHistory: History.setHistory.bind(swiper),
          setHistoryPopState: History.setHistoryPopState.bind(swiper),
          scrollToSlide: History.scrollToSlide.bind(swiper),
          destroy: History.destroy.bind(swiper),
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (swiper.params.history.enabled) {
          swiper.history.init();
        }
      },
      destroy: function destroy() {
        var swiper = this;
        if (swiper.params.history.enabled) {
          swiper.history.destroy();
        }
      },
      transitionEnd: function transitionEnd() {
        var swiper = this;
        if (swiper.history.initialized) {
          swiper.history.setHistory(swiper.params.history.key, swiper.activeIndex);
        }
      },
    },
  };

  var HashNavigation = {
    onHashCange: function onHashCange() {
      var swiper = this;
      var newHash = doc.location.hash.replace('#', '');
      var activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr('data-hash');
      if (newHash !== activeSlideHash) {
        var newIndex = swiper.$wrapperEl.children(("." + (swiper.params.slideClass) + "[data-hash=\"" + newHash + "\"]")).index();
        if (typeof newIndex === 'undefined') { return; }
        swiper.slideTo(newIndex);
      }
    },
    setHash: function setHash() {
      var swiper = this;
      if (!swiper.hashNavigation.initialized || !swiper.params.hashNavigation.enabled) { return; }
      if (swiper.params.hashNavigation.replaceState && win.history && win.history.replaceState) {
        win.history.replaceState(null, null, (("#" + (swiper.slides.eq(swiper.activeIndex).attr('data-hash'))) || ''));
      } else {
        var slide = swiper.slides.eq(swiper.activeIndex);
        var hash = slide.attr('data-hash') || slide.attr('data-history');
        doc.location.hash = hash || '';
      }
    },
    init: function init() {
      var swiper = this;
      if (!swiper.params.hashNavigation.enabled || (swiper.params.history && swiper.params.history.enabled)) { return; }
      swiper.hashNavigation.initialized = true;
      var hash = doc.location.hash.replace('#', '');
      if (hash) {
        var speed = 0;
        for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
          var slide = swiper.slides.eq(i);
          var slideHash = slide.attr('data-hash') || slide.attr('data-history');
          if (slideHash === hash && !slide.hasClass(swiper.params.slideDuplicateClass)) {
            var index = slide.index();
            swiper.slideTo(index, speed, swiper.params.runCallbacksOnInit, true);
          }
        }
      }
      if (swiper.params.hashNavigation.watchState) {
        $(win).on('hashchange', swiper.hashNavigation.onHashCange);
      }
    },
    destroy: function destroy() {
      var swiper = this;
      if (swiper.params.hashNavigation.watchState) {
        $(win).off('hashchange', swiper.hashNavigation.onHashCange);
      }
    },
  };
  var HashNavigation$1 = {
    name: 'hash-navigation',
    params: {
      hashNavigation: {
        enabled: false,
        replaceState: false,
        watchState: false,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        hashNavigation: {
          initialized: false,
          init: HashNavigation.init.bind(swiper),
          destroy: HashNavigation.destroy.bind(swiper),
          setHash: HashNavigation.setHash.bind(swiper),
          onHashCange: HashNavigation.onHashCange.bind(swiper),
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (swiper.params.hashNavigation.enabled) {
          swiper.hashNavigation.init();
        }
      },
      destroy: function destroy() {
        var swiper = this;
        if (swiper.params.hashNavigation.enabled) {
          swiper.hashNavigation.destroy();
        }
      },
      transitionEnd: function transitionEnd() {
        var swiper = this;
        if (swiper.hashNavigation.initialized) {
          swiper.hashNavigation.setHash();
        }
      },
    },
  };

  /* eslint no-underscore-dangle: "off" */

  var Autoplay = {
    run: function run() {
      var swiper = this;
      var $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
      var delay = swiper.params.autoplay.delay;
      if ($activeSlideEl.attr('data-swiper-autoplay')) {
        delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
      }
      clearTimeout(swiper.autoplay.timeout);
      swiper.autoplay.timeout = Utils.nextTick(function () {
        if (swiper.params.autoplay.reverseDirection) {
          if (swiper.params.loop) {
            swiper.loopFix();
            swiper.slidePrev(swiper.params.speed, true, true);
            swiper.emit('autoplay');
          } else if (!swiper.isBeginning) {
            swiper.slidePrev(swiper.params.speed, true, true);
            swiper.emit('autoplay');
          } else if (!swiper.params.autoplay.stopOnLastSlide) {
            swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
            swiper.emit('autoplay');
          } else {
            swiper.autoplay.stop();
          }
        } else if (swiper.params.loop) {
          swiper.loopFix();
          swiper.slideNext(swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else if (!swiper.isEnd) {
          swiper.slideNext(swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else if (!swiper.params.autoplay.stopOnLastSlide) {
          swiper.slideTo(0, swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else {
          swiper.autoplay.stop();
        }
      }, delay);
    },
    start: function start() {
      var swiper = this;
      if (typeof swiper.autoplay.timeout !== 'undefined') { return false; }
      if (swiper.autoplay.running) { return false; }
      swiper.autoplay.running = true;
      swiper.emit('autoplayStart');
      swiper.autoplay.run();
      return true;
    },
    stop: function stop() {
      var swiper = this;
      if (!swiper.autoplay.running) { return false; }
      if (typeof swiper.autoplay.timeout === 'undefined') { return false; }

      if (swiper.autoplay.timeout) {
        clearTimeout(swiper.autoplay.timeout);
        swiper.autoplay.timeout = undefined;
      }
      swiper.autoplay.running = false;
      swiper.emit('autoplayStop');
      return true;
    },
    pause: function pause(speed) {
      var swiper = this;
      if (!swiper.autoplay.running) { return; }
      if (swiper.autoplay.paused) { return; }
      if (swiper.autoplay.timeout) { clearTimeout(swiper.autoplay.timeout); }
      swiper.autoplay.paused = true;
      if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
        swiper.autoplay.paused = false;
        swiper.autoplay.run();
      } else {
        swiper.$wrapperEl[0].addEventListener('transitionend', swiper.autoplay.onTransitionEnd);
        swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.autoplay.onTransitionEnd);
      }
    },
  };

  var Autoplay$1 = {
    name: 'autoplay',
    params: {
      autoplay: {
        enabled: false,
        delay: 3000,
        waitForTransition: true,
        disableOnInteraction: true,
        stopOnLastSlide: false,
        reverseDirection: false,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        autoplay: {
          running: false,
          paused: false,
          run: Autoplay.run.bind(swiper),
          start: Autoplay.start.bind(swiper),
          stop: Autoplay.stop.bind(swiper),
          pause: Autoplay.pause.bind(swiper),
          onTransitionEnd: function onTransitionEnd(e) {
            if (!swiper || swiper.destroyed || !swiper.$wrapperEl) { return; }
            if (e.target !== this) { return; }
            swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.autoplay.onTransitionEnd);
            swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.autoplay.onTransitionEnd);
            swiper.autoplay.paused = false;
            if (!swiper.autoplay.running) {
              swiper.autoplay.stop();
            } else {
              swiper.autoplay.run();
            }
          },
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (swiper.params.autoplay.enabled) {
          swiper.autoplay.start();
        }
      },
      beforeTransitionStart: function beforeTransitionStart(speed, internal) {
        var swiper = this;
        if (swiper.autoplay.running) {
          if (internal || !swiper.params.autoplay.disableOnInteraction) {
            swiper.autoplay.pause(speed);
          } else {
            swiper.autoplay.stop();
          }
        }
      },
      sliderFirstMove: function sliderFirstMove() {
        var swiper = this;
        if (swiper.autoplay.running) {
          if (swiper.params.autoplay.disableOnInteraction) {
            swiper.autoplay.stop();
          } else {
            swiper.autoplay.pause();
          }
        }
      },
      destroy: function destroy() {
        var swiper = this;
        if (swiper.autoplay.running) {
          swiper.autoplay.stop();
        }
      },
    },
  };

  var Fade = {
    setTranslate: function setTranslate() {
      var swiper = this;
      var slides = swiper.slides;
      for (var i = 0; i < slides.length; i += 1) {
        var $slideEl = swiper.slides.eq(i);
        var offset = $slideEl[0].swiperSlideOffset;
        var tx = -offset;
        if (!swiper.params.virtualTranslate) { tx -= swiper.translate; }
        var ty = 0;
        if (!swiper.isHorizontal()) {
          ty = tx;
          tx = 0;
        }
        var slideOpacity = swiper.params.fadeEffect.crossFade
          ? Math.max(1 - Math.abs($slideEl[0].progress), 0)
          : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
        $slideEl
          .css({
            opacity: slideOpacity,
          })
          .transform(("translate3d(" + tx + "px, " + ty + "px, 0px)"));
      }
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      var slides = swiper.slides;
      var $wrapperEl = swiper.$wrapperEl;
      slides.transition(duration);
      if (swiper.params.virtualTranslate && duration !== 0) {
        var eventTriggered = false;
        slides.transitionEnd(function () {
          if (eventTriggered) { return; }
          if (!swiper || swiper.destroyed) { return; }
          eventTriggered = true;
          swiper.animating = false;
          var triggerEvents = ['webkitTransitionEnd', 'transitionend'];
          for (var i = 0; i < triggerEvents.length; i += 1) {
            $wrapperEl.trigger(triggerEvents[i]);
          }
        });
      }
    },
  };

  var EffectFade = {
    name: 'effect-fade',
    params: {
      fadeEffect: {
        crossFade: false,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        fadeEffect: {
          setTranslate: Fade.setTranslate.bind(swiper),
          setTransition: Fade.setTransition.bind(swiper),
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (swiper.params.effect !== 'fade') { return; }
        swiper.classNames.push(((swiper.params.containerModifierClass) + "fade"));
        var overwriteParams = {
          slidesPerView: 1,
          slidesPerColumn: 1,
          slidesPerGroup: 1,
          watchSlidesProgress: true,
          spaceBetween: 0,
          virtualTranslate: true,
        };
        Utils.extend(swiper.params, overwriteParams);
        Utils.extend(swiper.originalParams, overwriteParams);
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (swiper.params.effect !== 'fade') { return; }
        swiper.fadeEffect.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        if (swiper.params.effect !== 'fade') { return; }
        swiper.fadeEffect.setTransition(duration);
      },
    },
  };

  var Cube = {
    setTranslate: function setTranslate() {
      var swiper = this;
      var $el = swiper.$el;
      var $wrapperEl = swiper.$wrapperEl;
      var slides = swiper.slides;
      var swiperWidth = swiper.width;
      var swiperHeight = swiper.height;
      var rtl = swiper.rtlTranslate;
      var swiperSize = swiper.size;
      var params = swiper.params.cubeEffect;
      var isHorizontal = swiper.isHorizontal();
      var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
      var wrapperRotate = 0;
      var $cubeShadowEl;
      if (params.shadow) {
        if (isHorizontal) {
          $cubeShadowEl = $wrapperEl.find('.swiper-cube-shadow');
          if ($cubeShadowEl.length === 0) {
            $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
            $wrapperEl.append($cubeShadowEl);
          }
          $cubeShadowEl.css({ height: (swiperWidth + "px") });
        } else {
          $cubeShadowEl = $el.find('.swiper-cube-shadow');
          if ($cubeShadowEl.length === 0) {
            $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
            $el.append($cubeShadowEl);
          }
        }
      }
      for (var i = 0; i < slides.length; i += 1) {
        var $slideEl = slides.eq(i);
        var slideIndex = i;
        if (isVirtual) {
          slideIndex = parseInt($slideEl.attr('data-swiper-slide-index'), 10);
        }
        var slideAngle = slideIndex * 90;
        var round = Math.floor(slideAngle / 360);
        if (rtl) {
          slideAngle = -slideAngle;
          round = Math.floor(-slideAngle / 360);
        }
        var progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
        var tx = 0;
        var ty = 0;
        var tz = 0;
        if (slideIndex % 4 === 0) {
          tx = -round * 4 * swiperSize;
          tz = 0;
        } else if ((slideIndex - 1) % 4 === 0) {
          tx = 0;
          tz = -round * 4 * swiperSize;
        } else if ((slideIndex - 2) % 4 === 0) {
          tx = swiperSize + (round * 4 * swiperSize);
          tz = swiperSize;
        } else if ((slideIndex - 3) % 4 === 0) {
          tx = -swiperSize;
          tz = (3 * swiperSize) + (swiperSize * 4 * round);
        }
        if (rtl) {
          tx = -tx;
        }

        if (!isHorizontal) {
          ty = tx;
          tx = 0;
        }

        var transform = "rotateX(" + (isHorizontal ? 0 : -slideAngle) + "deg) rotateY(" + (isHorizontal ? slideAngle : 0) + "deg) translate3d(" + tx + "px, " + ty + "px, " + tz + "px)";
        if (progress <= 1 && progress > -1) {
          wrapperRotate = (slideIndex * 90) + (progress * 90);
          if (rtl) { wrapperRotate = (-slideIndex * 90) - (progress * 90); }
        }
        $slideEl.transform(transform);
        if (params.slideShadows) {
          // Set shadows
          var shadowBefore = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
          var shadowAfter = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
          if (shadowBefore.length === 0) {
            shadowBefore = $(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'left' : 'top') + "\"></div>"));
            $slideEl.append(shadowBefore);
          }
          if (shadowAfter.length === 0) {
            shadowAfter = $(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'right' : 'bottom') + "\"></div>"));
            $slideEl.append(shadowAfter);
          }
          if (shadowBefore.length) { shadowBefore[0].style.opacity = Math.max(-progress, 0); }
          if (shadowAfter.length) { shadowAfter[0].style.opacity = Math.max(progress, 0); }
        }
      }
      $wrapperEl.css({
        '-webkit-transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
        '-moz-transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
        '-ms-transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
        'transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
      });

      if (params.shadow) {
        if (isHorizontal) {
          $cubeShadowEl.transform(("translate3d(0px, " + ((swiperWidth / 2) + params.shadowOffset) + "px, " + (-swiperWidth / 2) + "px) rotateX(90deg) rotateZ(0deg) scale(" + (params.shadowScale) + ")"));
        } else {
          var shadowAngle = Math.abs(wrapperRotate) - (Math.floor(Math.abs(wrapperRotate) / 90) * 90);
          var multiplier = 1.5 - (
            (Math.sin((shadowAngle * 2 * Math.PI) / 360) / 2)
            + (Math.cos((shadowAngle * 2 * Math.PI) / 360) / 2)
          );
          var scale1 = params.shadowScale;
          var scale2 = params.shadowScale / multiplier;
          var offset = params.shadowOffset;
          $cubeShadowEl.transform(("scale3d(" + scale1 + ", 1, " + scale2 + ") translate3d(0px, " + ((swiperHeight / 2) + offset) + "px, " + (-swiperHeight / 2 / scale2) + "px) rotateX(-90deg)"));
        }
      }
      var zFactor = (Browser.isSafari || Browser.isUiWebView) ? (-swiperSize / 2) : 0;
      $wrapperEl
        .transform(("translate3d(0px,0," + zFactor + "px) rotateX(" + (swiper.isHorizontal() ? 0 : wrapperRotate) + "deg) rotateY(" + (swiper.isHorizontal() ? -wrapperRotate : 0) + "deg)"));
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      var $el = swiper.$el;
      var slides = swiper.slides;
      slides
        .transition(duration)
        .find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
        .transition(duration);
      if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
        $el.find('.swiper-cube-shadow').transition(duration);
      }
    },
  };

  var EffectCube = {
    name: 'effect-cube',
    params: {
      cubeEffect: {
        slideShadows: true,
        shadow: true,
        shadowOffset: 20,
        shadowScale: 0.94,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        cubeEffect: {
          setTranslate: Cube.setTranslate.bind(swiper),
          setTransition: Cube.setTransition.bind(swiper),
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (swiper.params.effect !== 'cube') { return; }
        swiper.classNames.push(((swiper.params.containerModifierClass) + "cube"));
        swiper.classNames.push(((swiper.params.containerModifierClass) + "3d"));
        var overwriteParams = {
          slidesPerView: 1,
          slidesPerColumn: 1,
          slidesPerGroup: 1,
          watchSlidesProgress: true,
          resistanceRatio: 0,
          spaceBetween: 0,
          centeredSlides: false,
          virtualTranslate: true,
        };
        Utils.extend(swiper.params, overwriteParams);
        Utils.extend(swiper.originalParams, overwriteParams);
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (swiper.params.effect !== 'cube') { return; }
        swiper.cubeEffect.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        if (swiper.params.effect !== 'cube') { return; }
        swiper.cubeEffect.setTransition(duration);
      },
    },
  };

  var Flip = {
    setTranslate: function setTranslate() {
      var swiper = this;
      var slides = swiper.slides;
      var rtl = swiper.rtlTranslate;
      for (var i = 0; i < slides.length; i += 1) {
        var $slideEl = slides.eq(i);
        var progress = $slideEl[0].progress;
        if (swiper.params.flipEffect.limitRotation) {
          progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
        }
        var offset = $slideEl[0].swiperSlideOffset;
        var rotate = -180 * progress;
        var rotateY = rotate;
        var rotateX = 0;
        var tx = -offset;
        var ty = 0;
        if (!swiper.isHorizontal()) {
          ty = tx;
          tx = 0;
          rotateX = -rotateY;
          rotateY = 0;
        } else if (rtl) {
          rotateY = -rotateY;
        }

        $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;

        if (swiper.params.flipEffect.slideShadows) {
          // Set shadows
          var shadowBefore = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
          var shadowAfter = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
          if (shadowBefore.length === 0) {
            shadowBefore = $(("<div class=\"swiper-slide-shadow-" + (swiper.isHorizontal() ? 'left' : 'top') + "\"></div>"));
            $slideEl.append(shadowBefore);
          }
          if (shadowAfter.length === 0) {
            shadowAfter = $(("<div class=\"swiper-slide-shadow-" + (swiper.isHorizontal() ? 'right' : 'bottom') + "\"></div>"));
            $slideEl.append(shadowAfter);
          }
          if (shadowBefore.length) { shadowBefore[0].style.opacity = Math.max(-progress, 0); }
          if (shadowAfter.length) { shadowAfter[0].style.opacity = Math.max(progress, 0); }
        }
        $slideEl
          .transform(("translate3d(" + tx + "px, " + ty + "px, 0px) rotateX(" + rotateX + "deg) rotateY(" + rotateY + "deg)"));
      }
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      var slides = swiper.slides;
      var activeIndex = swiper.activeIndex;
      var $wrapperEl = swiper.$wrapperEl;
      slides
        .transition(duration)
        .find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
        .transition(duration);
      if (swiper.params.virtualTranslate && duration !== 0) {
        var eventTriggered = false;
        // eslint-disable-next-line
        slides.eq(activeIndex).transitionEnd(function onTransitionEnd() {
          if (eventTriggered) { return; }
          if (!swiper || swiper.destroyed) { return; }
          // if (!$(this).hasClass(swiper.params.slideActiveClass)) return;
          eventTriggered = true;
          swiper.animating = false;
          var triggerEvents = ['webkitTransitionEnd', 'transitionend'];
          for (var i = 0; i < triggerEvents.length; i += 1) {
            $wrapperEl.trigger(triggerEvents[i]);
          }
        });
      }
    },
  };

  var EffectFlip = {
    name: 'effect-flip',
    params: {
      flipEffect: {
        slideShadows: true,
        limitRotation: true,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        flipEffect: {
          setTranslate: Flip.setTranslate.bind(swiper),
          setTransition: Flip.setTransition.bind(swiper),
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (swiper.params.effect !== 'flip') { return; }
        swiper.classNames.push(((swiper.params.containerModifierClass) + "flip"));
        swiper.classNames.push(((swiper.params.containerModifierClass) + "3d"));
        var overwriteParams = {
          slidesPerView: 1,
          slidesPerColumn: 1,
          slidesPerGroup: 1,
          watchSlidesProgress: true,
          spaceBetween: 0,
          virtualTranslate: true,
        };
        Utils.extend(swiper.params, overwriteParams);
        Utils.extend(swiper.originalParams, overwriteParams);
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (swiper.params.effect !== 'flip') { return; }
        swiper.flipEffect.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        if (swiper.params.effect !== 'flip') { return; }
        swiper.flipEffect.setTransition(duration);
      },
    },
  };

  var Coverflow = {
    setTranslate: function setTranslate() {
      var swiper = this;
      var swiperWidth = swiper.width;
      var swiperHeight = swiper.height;
      var slides = swiper.slides;
      var $wrapperEl = swiper.$wrapperEl;
      var slidesSizesGrid = swiper.slidesSizesGrid;
      var params = swiper.params.coverflowEffect;
      var isHorizontal = swiper.isHorizontal();
      var transform = swiper.translate;
      var center = isHorizontal ? -transform + (swiperWidth / 2) : -transform + (swiperHeight / 2);
      var rotate = isHorizontal ? params.rotate : -params.rotate;
      var translate = params.depth;
      // Each slide offset from center
      for (var i = 0, length = slides.length; i < length; i += 1) {
        var $slideEl = slides.eq(i);
        var slideSize = slidesSizesGrid[i];
        var slideOffset = $slideEl[0].swiperSlideOffset;
        var offsetMultiplier = ((center - slideOffset - (slideSize / 2)) / slideSize) * params.modifier;

        var rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
        var rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
        // var rotateZ = 0
        var translateZ = -translate * Math.abs(offsetMultiplier);

        var translateY = isHorizontal ? 0 : params.stretch * (offsetMultiplier);
        var translateX = isHorizontal ? params.stretch * (offsetMultiplier) : 0;

        // Fix for ultra small values
        if (Math.abs(translateX) < 0.001) { translateX = 0; }
        if (Math.abs(translateY) < 0.001) { translateY = 0; }
        if (Math.abs(translateZ) < 0.001) { translateZ = 0; }
        if (Math.abs(rotateY) < 0.001) { rotateY = 0; }
        if (Math.abs(rotateX) < 0.001) { rotateX = 0; }

        var slideTransform = "translate3d(" + translateX + "px," + translateY + "px," + translateZ + "px)  rotateX(" + rotateX + "deg) rotateY(" + rotateY + "deg)";

        $slideEl.transform(slideTransform);
        $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
        if (params.slideShadows) {
          // Set shadows
          var $shadowBeforeEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
          var $shadowAfterEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
          if ($shadowBeforeEl.length === 0) {
            $shadowBeforeEl = $(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'left' : 'top') + "\"></div>"));
            $slideEl.append($shadowBeforeEl);
          }
          if ($shadowAfterEl.length === 0) {
            $shadowAfterEl = $(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'right' : 'bottom') + "\"></div>"));
            $slideEl.append($shadowAfterEl);
          }
          if ($shadowBeforeEl.length) { $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0; }
          if ($shadowAfterEl.length) { $shadowAfterEl[0].style.opacity = (-offsetMultiplier) > 0 ? -offsetMultiplier : 0; }
        }
      }

      // Set correct perspective for IE10
      if (Support.pointerEvents || Support.prefixedPointerEvents) {
        var ws = $wrapperEl[0].style;
        ws.perspectiveOrigin = center + "px 50%";
      }
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      swiper.slides
        .transition(duration)
        .find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
        .transition(duration);
    },
  };

  var EffectCoverflow = {
    name: 'effect-coverflow',
    params: {
      coverflowEffect: {
        rotate: 50,
        stretch: 0,
        depth: 100,
        modifier: 1,
        slideShadows: true,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        coverflowEffect: {
          setTranslate: Coverflow.setTranslate.bind(swiper),
          setTransition: Coverflow.setTransition.bind(swiper),
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (swiper.params.effect !== 'coverflow') { return; }

        swiper.classNames.push(((swiper.params.containerModifierClass) + "coverflow"));
        swiper.classNames.push(((swiper.params.containerModifierClass) + "3d"));

        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (swiper.params.effect !== 'coverflow') { return; }
        swiper.coverflowEffect.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        if (swiper.params.effect !== 'coverflow') { return; }
        swiper.coverflowEffect.setTransition(duration);
      },
    },
  };

  var Thumbs = {
    init: function init() {
      var swiper = this;
      var ref = swiper.params;
      var thumbsParams = ref.thumbs;
      var SwiperClass = swiper.constructor;
      if (thumbsParams.swiper instanceof SwiperClass) {
        swiper.thumbs.swiper = thumbsParams.swiper;
        Utils.extend(swiper.thumbs.swiper.originalParams, {
          watchSlidesProgress: true,
          slideToClickedSlide: false,
        });
        Utils.extend(swiper.thumbs.swiper.params, {
          watchSlidesProgress: true,
          slideToClickedSlide: false,
        });
      } else if (Utils.isObject(thumbsParams.swiper)) {
        swiper.thumbs.swiper = new SwiperClass(Utils.extend({}, thumbsParams.swiper, {
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          slideToClickedSlide: false,
        }));
        swiper.thumbs.swiperCreated = true;
      }
      swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
      swiper.thumbs.swiper.on('tap', swiper.thumbs.onThumbClick);
    },
    onThumbClick: function onThumbClick() {
      var swiper = this;
      var thumbsSwiper = swiper.thumbs.swiper;
      if (!thumbsSwiper) { return; }
      var clickedIndex = thumbsSwiper.clickedIndex;
      var clickedSlide = thumbsSwiper.clickedSlide;
      if (clickedSlide && $(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) { return; }
      if (typeof clickedIndex === 'undefined' || clickedIndex === null) { return; }
      var slideToIndex;
      if (thumbsSwiper.params.loop) {
        slideToIndex = parseInt($(thumbsSwiper.clickedSlide).attr('data-swiper-slide-index'), 10);
      } else {
        slideToIndex = clickedIndex;
      }
      if (swiper.params.loop) {
        var currentIndex = swiper.activeIndex;
        if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
          swiper.loopFix();
          // eslint-disable-next-line
          swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
          currentIndex = swiper.activeIndex;
        }
        var prevIndex = swiper.slides.eq(currentIndex).prevAll(("[data-swiper-slide-index=\"" + slideToIndex + "\"]")).eq(0).index();
        var nextIndex = swiper.slides.eq(currentIndex).nextAll(("[data-swiper-slide-index=\"" + slideToIndex + "\"]")).eq(0).index();
        if (typeof prevIndex === 'undefined') { slideToIndex = nextIndex; }
        else if (typeof nextIndex === 'undefined') { slideToIndex = prevIndex; }
        else if (nextIndex - currentIndex < currentIndex - prevIndex) { slideToIndex = nextIndex; }
        else { slideToIndex = prevIndex; }
      }
      swiper.slideTo(slideToIndex);
    },
    update: function update(initial) {
      var swiper = this;
      var thumbsSwiper = swiper.thumbs.swiper;
      if (!thumbsSwiper) { return; }

      var slidesPerView = thumbsSwiper.params.slidesPerView === 'auto'
        ? thumbsSwiper.slidesPerViewDynamic()
        : thumbsSwiper.params.slidesPerView;

      if (swiper.realIndex !== thumbsSwiper.realIndex) {
        var currentThumbsIndex = thumbsSwiper.activeIndex;
        var newThumbsIndex;
        if (thumbsSwiper.params.loop) {
          if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
            thumbsSwiper.loopFix();
            // eslint-disable-next-line
            thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
            currentThumbsIndex = thumbsSwiper.activeIndex;
          }
          // Find actual thumbs index to slide to
          var prevThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).prevAll(("[data-swiper-slide-index=\"" + (swiper.realIndex) + "\"]")).eq(0).index();
          var nextThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).nextAll(("[data-swiper-slide-index=\"" + (swiper.realIndex) + "\"]")).eq(0).index();
          if (typeof prevThumbsIndex === 'undefined') { newThumbsIndex = nextThumbsIndex; }
          else if (typeof nextThumbsIndex === 'undefined') { newThumbsIndex = prevThumbsIndex; }
          else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) { newThumbsIndex = currentThumbsIndex; }
          else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) { newThumbsIndex = nextThumbsIndex; }
          else { newThumbsIndex = prevThumbsIndex; }
        } else {
          newThumbsIndex = swiper.realIndex;
        }
        if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
          if (thumbsSwiper.params.centeredSlides) {
            if (newThumbsIndex > currentThumbsIndex) {
              newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
            } else {
              newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
            }
          } else if (newThumbsIndex > currentThumbsIndex) {
            newThumbsIndex = newThumbsIndex - slidesPerView + 1;
          }
          thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
        }
      }

      // Activate thumbs
      var thumbsToActivate = 1;
      var thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;

      if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) {
        thumbsToActivate = swiper.params.slidesPerView;
      }

      thumbsSwiper.slides.removeClass(thumbActiveClass);
      if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual) {
        for (var i = 0; i < thumbsToActivate; i += 1) {
          thumbsSwiper.$wrapperEl.children(("[data-swiper-slide-index=\"" + (swiper.realIndex + i) + "\"]")).addClass(thumbActiveClass);
        }
      } else {
        for (var i$1 = 0; i$1 < thumbsToActivate; i$1 += 1) {
          thumbsSwiper.slides.eq(swiper.realIndex + i$1).addClass(thumbActiveClass);
        }
      }
    },
  };
  var Thumbs$1 = {
    name: 'thumbs',
    params: {
      thumbs: {
        swiper: null,
        slideThumbActiveClass: 'swiper-slide-thumb-active',
        thumbsContainerClass: 'swiper-container-thumbs',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        thumbs: {
          swiper: null,
          init: Thumbs.init.bind(swiper),
          update: Thumbs.update.bind(swiper),
          onThumbClick: Thumbs.onThumbClick.bind(swiper),
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        var ref = swiper.params;
        var thumbs = ref.thumbs;
        if (!thumbs || !thumbs.swiper) { return; }
        swiper.thumbs.init();
        swiper.thumbs.update(true);
      },
      slideChange: function slideChange() {
        var swiper = this;
        if (!swiper.thumbs.swiper) { return; }
        swiper.thumbs.update();
      },
      update: function update() {
        var swiper = this;
        if (!swiper.thumbs.swiper) { return; }
        swiper.thumbs.update();
      },
      resize: function resize() {
        var swiper = this;
        if (!swiper.thumbs.swiper) { return; }
        swiper.thumbs.update();
      },
      observerUpdate: function observerUpdate() {
        var swiper = this;
        if (!swiper.thumbs.swiper) { return; }
        swiper.thumbs.update();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper) { return; }
        thumbsSwiper.setTransition(duration);
      },
      beforeDestroy: function beforeDestroy() {
        var swiper = this;
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper) { return; }
        if (swiper.thumbs.swiperCreated && thumbsSwiper) {
          thumbsSwiper.destroy();
        }
      },
    },
  };

  // Swiper Class

  var components = [
    Device$1,
    Support$1,
    Browser$1,
    Resize,
    Observer$1,
    Virtual$1,
    Keyboard$1,
    Mousewheel$1,
    Navigation$1,
    Pagination$1,
    Scrollbar$1,
    Parallax$1,
    Zoom$1,
    Lazy$1,
    Controller$1,
    A11y,
    History$1,
    HashNavigation$1,
    Autoplay$1,
    EffectFade,
    EffectCube,
    EffectFlip,
    EffectCoverflow,
    Thumbs$1
  ];

  if (typeof Swiper.use === 'undefined') {
    Swiper.use = Swiper.Class.use;
    Swiper.installModule = Swiper.Class.installModule;
  }

  Swiper.use(components);

  return Swiper;

}));

},{}],780:[function(require,module,exports){
(function (process){
/**!
* tippy.js v6.3.1
* (c) 2017-2021 atomiks
* MIT License
*/
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var core = require('@popperjs/core');

var ROUND_ARROW = '<svg width="16" height="6" xmlns="http://www.w3.org/2000/svg"><path d="M0 6s1.796-.013 4.67-3.615C5.851.9 6.93.006 8 0c1.07-.006 2.148.887 3.343 2.385C14.233 6.005 16 6 16 6H0z"></svg>';
var BOX_CLASS = "tippy-box";
var CONTENT_CLASS = "tippy-content";
var BACKDROP_CLASS = "tippy-backdrop";
var ARROW_CLASS = "tippy-arrow";
var SVG_ARROW_CLASS = "tippy-svg-arrow";
var TOUCH_OPTIONS = {
  passive: true,
  capture: true
};

function hasOwnProperty(obj, key) {
  return {}.hasOwnProperty.call(obj, key);
}
function getValueAtIndexOrReturn(value, index, defaultValue) {
  if (Array.isArray(value)) {
    var v = value[index];
    return v == null ? Array.isArray(defaultValue) ? defaultValue[index] : defaultValue : v;
  }

  return value;
}
function isType(value, type) {
  var str = {}.toString.call(value);
  return str.indexOf('[object') === 0 && str.indexOf(type + "]") > -1;
}
function invokeWithArgsOrReturn(value, args) {
  return typeof value === 'function' ? value.apply(void 0, args) : value;
}
function debounce(fn, ms) {
  // Avoid wrapping in `setTimeout` if ms is 0 anyway
  if (ms === 0) {
    return fn;
  }

  var timeout;
  return function (arg) {
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      fn(arg);
    }, ms);
  };
}
function removeProperties(obj, keys) {
  var clone = Object.assign({}, obj);
  keys.forEach(function (key) {
    delete clone[key];
  });
  return clone;
}
function splitBySpaces(value) {
  return value.split(/\s+/).filter(Boolean);
}
function normalizeToArray(value) {
  return [].concat(value);
}
function pushIfUnique(arr, value) {
  if (arr.indexOf(value) === -1) {
    arr.push(value);
  }
}
function unique(arr) {
  return arr.filter(function (item, index) {
    return arr.indexOf(item) === index;
  });
}
function getBasePlacement(placement) {
  return placement.split('-')[0];
}
function arrayFrom(value) {
  return [].slice.call(value);
}
function removeUndefinedProps(obj) {
  return Object.keys(obj).reduce(function (acc, key) {
    if (obj[key] !== undefined) {
      acc[key] = obj[key];
    }

    return acc;
  }, {});
}

function div() {
  return document.createElement('div');
}
function isElement(value) {
  return ['Element', 'Fragment'].some(function (type) {
    return isType(value, type);
  });
}
function isNodeList(value) {
  return isType(value, 'NodeList');
}
function isMouseEvent(value) {
  return isType(value, 'MouseEvent');
}
function isReferenceElement(value) {
  return !!(value && value._tippy && value._tippy.reference === value);
}
function getArrayOfElements(value) {
  if (isElement(value)) {
    return [value];
  }

  if (isNodeList(value)) {
    return arrayFrom(value);
  }

  if (Array.isArray(value)) {
    return value;
  }

  return arrayFrom(document.querySelectorAll(value));
}
function setTransitionDuration(els, value) {
  els.forEach(function (el) {
    if (el) {
      el.style.transitionDuration = value + "ms";
    }
  });
}
function setVisibilityState(els, state) {
  els.forEach(function (el) {
    if (el) {
      el.setAttribute('data-state', state);
    }
  });
}
function getOwnerDocument(elementOrElements) {
  var _element$ownerDocumen;

  var _normalizeToArray = normalizeToArray(elementOrElements),
      element = _normalizeToArray[0]; // Elements created via a <template> have an ownerDocument with no reference to the body


  return (element == null ? void 0 : (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body) ? element.ownerDocument : document;
}
function isCursorOutsideInteractiveBorder(popperTreeData, event) {
  var clientX = event.clientX,
      clientY = event.clientY;
  return popperTreeData.every(function (_ref) {
    var popperRect = _ref.popperRect,
        popperState = _ref.popperState,
        props = _ref.props;
    var interactiveBorder = props.interactiveBorder;
    var basePlacement = getBasePlacement(popperState.placement);
    var offsetData = popperState.modifiersData.offset;

    if (!offsetData) {
      return true;
    }

    var topDistance = basePlacement === 'bottom' ? offsetData.top.y : 0;
    var bottomDistance = basePlacement === 'top' ? offsetData.bottom.y : 0;
    var leftDistance = basePlacement === 'right' ? offsetData.left.x : 0;
    var rightDistance = basePlacement === 'left' ? offsetData.right.x : 0;
    var exceedsTop = popperRect.top - clientY + topDistance > interactiveBorder;
    var exceedsBottom = clientY - popperRect.bottom - bottomDistance > interactiveBorder;
    var exceedsLeft = popperRect.left - clientX + leftDistance > interactiveBorder;
    var exceedsRight = clientX - popperRect.right - rightDistance > interactiveBorder;
    return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
  });
}
function updateTransitionEndListener(box, action, listener) {
  var method = action + "EventListener"; // some browsers apparently support `transition` (unprefixed) but only fire
  // `webkitTransitionEnd`...

  ['transitionend', 'webkitTransitionEnd'].forEach(function (event) {
    box[method](event, listener);
  });
}

var currentInput = {
  isTouch: false
};
var lastMouseMoveTime = 0;
/**
 * When a `touchstart` event is fired, it's assumed the user is using touch
 * input. We'll bind a `mousemove` event listener to listen for mouse input in
 * the future. This way, the `isTouch` property is fully dynamic and will handle
 * hybrid devices that use a mix of touch + mouse input.
 */

function onDocumentTouchStart() {
  if (currentInput.isTouch) {
    return;
  }

  currentInput.isTouch = true;

  if (window.performance) {
    document.addEventListener('mousemove', onDocumentMouseMove);
  }
}
/**
 * When two `mousemove` event are fired consecutively within 20ms, it's assumed
 * the user is using mouse input again. `mousemove` can fire on touch devices as
 * well, but very rarely that quickly.
 */

function onDocumentMouseMove() {
  var now = performance.now();

  if (now - lastMouseMoveTime < 20) {
    currentInput.isTouch = false;
    document.removeEventListener('mousemove', onDocumentMouseMove);
  }

  lastMouseMoveTime = now;
}
/**
 * When an element is in focus and has a tippy, leaving the tab/window and
 * returning causes it to show again. For mouse users this is unexpected, but
 * for keyboard use it makes sense.
 * TODO: find a better technique to solve this problem
 */

function onWindowBlur() {
  var activeElement = document.activeElement;

  if (isReferenceElement(activeElement)) {
    var instance = activeElement._tippy;

    if (activeElement.blur && !instance.state.isVisible) {
      activeElement.blur();
    }
  }
}
function bindGlobalEventListeners() {
  document.addEventListener('touchstart', onDocumentTouchStart, TOUCH_OPTIONS);
  window.addEventListener('blur', onWindowBlur);
}

var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
var ua = isBrowser ? navigator.userAgent : '';
var isIE = /MSIE |Trident\//.test(ua);

function createMemoryLeakWarning(method) {
  var txt = method === 'destroy' ? 'n already-' : ' ';
  return [method + "() was called on a" + txt + "destroyed instance. This is a no-op but", 'indicates a potential memory leak.'].join(' ');
}
function clean(value) {
  var spacesAndTabs = /[ \t]{2,}/g;
  var lineStartWithSpaces = /^[ \t]*/gm;
  return value.replace(spacesAndTabs, ' ').replace(lineStartWithSpaces, '').trim();
}

function getDevMessage(message) {
  return clean("\n  %ctippy.js\n\n  %c" + clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development-only message. It will be removed in production.\n  ");
}

function getFormattedMessage(message) {
  return [getDevMessage(message), // title
  'color: #00C584; font-size: 1.3em; font-weight: bold;', // message
  'line-height: 1.5', // footer
  'color: #a6a095;'];
} // Assume warnings and errors never have the same message

var visitedMessages;

if (process.env.NODE_ENV !== "production") {
  resetVisitedMessages();
}

function resetVisitedMessages() {
  visitedMessages = new Set();
}
function warnWhen(condition, message) {
  if (condition && !visitedMessages.has(message)) {
    var _console;

    visitedMessages.add(message);

    (_console = console).warn.apply(_console, getFormattedMessage(message));
  }
}
function errorWhen(condition, message) {
  if (condition && !visitedMessages.has(message)) {
    var _console2;

    visitedMessages.add(message);

    (_console2 = console).error.apply(_console2, getFormattedMessage(message));
  }
}
function validateTargets(targets) {
  var didPassFalsyValue = !targets;
  var didPassPlainObject = Object.prototype.toString.call(targets) === '[object Object]' && !targets.addEventListener;
  errorWhen(didPassFalsyValue, ['tippy() was passed', '`' + String(targets) + '`', 'as its targets (first) argument. Valid types are: String, Element,', 'Element[], or NodeList.'].join(' '));
  errorWhen(didPassPlainObject, ['tippy() was passed a plain object which is not supported as an argument', 'for virtual positioning. Use props.getReferenceClientRect instead.'].join(' '));
}

var pluginProps = {
  animateFill: false,
  followCursor: false,
  inlinePositioning: false,
  sticky: false
};
var renderProps = {
  allowHTML: false,
  animation: 'fade',
  arrow: true,
  content: '',
  inertia: false,
  maxWidth: 350,
  role: 'tooltip',
  theme: '',
  zIndex: 9999
};
var defaultProps = Object.assign({
  appendTo: function appendTo() {
    return document.body;
  },
  aria: {
    content: 'auto',
    expanded: 'auto'
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: true,
  ignoreAttributes: false,
  interactive: false,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: '',
  offset: [0, 10],
  onAfterUpdate: function onAfterUpdate() {},
  onBeforeUpdate: function onBeforeUpdate() {},
  onCreate: function onCreate() {},
  onDestroy: function onDestroy() {},
  onHidden: function onHidden() {},
  onHide: function onHide() {},
  onMount: function onMount() {},
  onShow: function onShow() {},
  onShown: function onShown() {},
  onTrigger: function onTrigger() {},
  onUntrigger: function onUntrigger() {},
  onClickOutside: function onClickOutside() {},
  placement: 'top',
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: false,
  touch: true,
  trigger: 'mouseenter focus',
  triggerTarget: null
}, pluginProps, {}, renderProps);
var defaultKeys = Object.keys(defaultProps);
var setDefaultProps = function setDefaultProps(partialProps) {
  /* istanbul ignore else */
  if (process.env.NODE_ENV !== "production") {
    validateProps(partialProps, []);
  }

  var keys = Object.keys(partialProps);
  keys.forEach(function (key) {
    defaultProps[key] = partialProps[key];
  });
};
function getExtendedPassedProps(passedProps) {
  var plugins = passedProps.plugins || [];
  var pluginProps = plugins.reduce(function (acc, plugin) {
    var name = plugin.name,
        defaultValue = plugin.defaultValue;

    if (name) {
      acc[name] = passedProps[name] !== undefined ? passedProps[name] : defaultValue;
    }

    return acc;
  }, {});
  return Object.assign({}, passedProps, {}, pluginProps);
}
function getDataAttributeProps(reference, plugins) {
  var propKeys = plugins ? Object.keys(getExtendedPassedProps(Object.assign({}, defaultProps, {
    plugins: plugins
  }))) : defaultKeys;
  var props = propKeys.reduce(function (acc, key) {
    var valueAsString = (reference.getAttribute("data-tippy-" + key) || '').trim();

    if (!valueAsString) {
      return acc;
    }

    if (key === 'content') {
      acc[key] = valueAsString;
    } else {
      try {
        acc[key] = JSON.parse(valueAsString);
      } catch (e) {
        acc[key] = valueAsString;
      }
    }

    return acc;
  }, {});
  return props;
}
function evaluateProps(reference, props) {
  var out = Object.assign({}, props, {
    content: invokeWithArgsOrReturn(props.content, [reference])
  }, props.ignoreAttributes ? {} : getDataAttributeProps(reference, props.plugins));
  out.aria = Object.assign({}, defaultProps.aria, {}, out.aria);
  out.aria = {
    expanded: out.aria.expanded === 'auto' ? props.interactive : out.aria.expanded,
    content: out.aria.content === 'auto' ? props.interactive ? null : 'describedby' : out.aria.content
  };
  return out;
}
function validateProps(partialProps, plugins) {
  if (partialProps === void 0) {
    partialProps = {};
  }

  if (plugins === void 0) {
    plugins = [];
  }

  var keys = Object.keys(partialProps);
  keys.forEach(function (prop) {
    var nonPluginProps = removeProperties(defaultProps, Object.keys(pluginProps));
    var didPassUnknownProp = !hasOwnProperty(nonPluginProps, prop); // Check if the prop exists in `plugins`

    if (didPassUnknownProp) {
      didPassUnknownProp = plugins.filter(function (plugin) {
        return plugin.name === prop;
      }).length === 0;
    }

    warnWhen(didPassUnknownProp, ["`" + prop + "`", "is not a valid prop. You may have spelled it incorrectly, or if it's", 'a plugin, forgot to pass it in an array as props.plugins.', '\n\n', 'All props: https://atomiks.github.io/tippyjs/v6/all-props/\n', 'Plugins: https://atomiks.github.io/tippyjs/v6/plugins/'].join(' '));
  });
}

var innerHTML = function innerHTML() {
  return 'innerHTML';
};

function dangerouslySetInnerHTML(element, html) {
  element[innerHTML()] = html;
}

function createArrowElement(value) {
  var arrow = div();

  if (value === true) {
    arrow.className = ARROW_CLASS;
  } else {
    arrow.className = SVG_ARROW_CLASS;

    if (isElement(value)) {
      arrow.appendChild(value);
    } else {
      dangerouslySetInnerHTML(arrow, value);
    }
  }

  return arrow;
}

function setContent(content, props) {
  if (isElement(props.content)) {
    dangerouslySetInnerHTML(content, '');
    content.appendChild(props.content);
  } else if (typeof props.content !== 'function') {
    if (props.allowHTML) {
      dangerouslySetInnerHTML(content, props.content);
    } else {
      content.textContent = props.content;
    }
  }
}
function getChildren(popper) {
  var box = popper.firstElementChild;
  var boxChildren = arrayFrom(box.children);
  return {
    box: box,
    content: boxChildren.find(function (node) {
      return node.classList.contains(CONTENT_CLASS);
    }),
    arrow: boxChildren.find(function (node) {
      return node.classList.contains(ARROW_CLASS) || node.classList.contains(SVG_ARROW_CLASS);
    }),
    backdrop: boxChildren.find(function (node) {
      return node.classList.contains(BACKDROP_CLASS);
    })
  };
}
function render(instance) {
  var popper = div();
  var box = div();
  box.className = BOX_CLASS;
  box.setAttribute('data-state', 'hidden');
  box.setAttribute('tabindex', '-1');
  var content = div();
  content.className = CONTENT_CLASS;
  content.setAttribute('data-state', 'hidden');
  setContent(content, instance.props);
  popper.appendChild(box);
  box.appendChild(content);
  onUpdate(instance.props, instance.props);

  function onUpdate(prevProps, nextProps) {
    var _getChildren = getChildren(popper),
        box = _getChildren.box,
        content = _getChildren.content,
        arrow = _getChildren.arrow;

    if (nextProps.theme) {
      box.setAttribute('data-theme', nextProps.theme);
    } else {
      box.removeAttribute('data-theme');
    }

    if (typeof nextProps.animation === 'string') {
      box.setAttribute('data-animation', nextProps.animation);
    } else {
      box.removeAttribute('data-animation');
    }

    if (nextProps.inertia) {
      box.setAttribute('data-inertia', '');
    } else {
      box.removeAttribute('data-inertia');
    }

    box.style.maxWidth = typeof nextProps.maxWidth === 'number' ? nextProps.maxWidth + "px" : nextProps.maxWidth;

    if (nextProps.role) {
      box.setAttribute('role', nextProps.role);
    } else {
      box.removeAttribute('role');
    }

    if (prevProps.content !== nextProps.content || prevProps.allowHTML !== nextProps.allowHTML) {
      setContent(content, instance.props);
    }

    if (nextProps.arrow) {
      if (!arrow) {
        box.appendChild(createArrowElement(nextProps.arrow));
      } else if (prevProps.arrow !== nextProps.arrow) {
        box.removeChild(arrow);
        box.appendChild(createArrowElement(nextProps.arrow));
      }
    } else if (arrow) {
      box.removeChild(arrow);
    }
  }

  return {
    popper: popper,
    onUpdate: onUpdate
  };
} // Runtime check to identify if the render function is the default one; this
// way we can apply default CSS transitions logic and it can be tree-shaken away

render.$$tippy = true;

var idCounter = 1;
var mouseMoveListeners = []; // Used by `hideAll()`

var mountedInstances = [];
function createTippy(reference, passedProps) {
  var props = evaluateProps(reference, Object.assign({}, defaultProps, {}, getExtendedPassedProps(removeUndefinedProps(passedProps)))); // ===========================================================================
  // 🔒 Private members
  // ===========================================================================

  var showTimeout;
  var hideTimeout;
  var scheduleHideAnimationFrame;
  var isVisibleFromClick = false;
  var didHideDueToDocumentMouseDown = false;
  var didTouchMove = false;
  var ignoreOnFirstUpdate = false;
  var lastTriggerEvent;
  var currentTransitionEndListener;
  var onFirstUpdate;
  var listeners = [];
  var debouncedOnMouseMove = debounce(onMouseMove, props.interactiveDebounce);
  var currentTarget; // ===========================================================================
  // 🔑 Public members
  // ===========================================================================

  var id = idCounter++;
  var popperInstance = null;
  var plugins = unique(props.plugins);
  var state = {
    // Is the instance currently enabled?
    isEnabled: true,
    // Is the tippy currently showing and not transitioning out?
    isVisible: false,
    // Has the instance been destroyed?
    isDestroyed: false,
    // Is the tippy currently mounted to the DOM?
    isMounted: false,
    // Has the tippy finished transitioning in?
    isShown: false
  };
  var instance = {
    // properties
    id: id,
    reference: reference,
    popper: div(),
    popperInstance: popperInstance,
    props: props,
    state: state,
    plugins: plugins,
    // methods
    clearDelayTimeouts: clearDelayTimeouts,
    setProps: setProps,
    setContent: setContent,
    show: show,
    hide: hide,
    hideWithInteractivity: hideWithInteractivity,
    enable: enable,
    disable: disable,
    unmount: unmount,
    destroy: destroy
  }; // TODO: Investigate why this early return causes a TDZ error in the tests —
  // it doesn't seem to happen in the browser

  /* istanbul ignore if */

  if (!props.render) {
    if (process.env.NODE_ENV !== "production") {
      errorWhen(true, 'render() function has not been supplied.');
    }

    return instance;
  } // ===========================================================================
  // Initial mutations
  // ===========================================================================


  var _props$render = props.render(instance),
      popper = _props$render.popper,
      onUpdate = _props$render.onUpdate;

  popper.setAttribute('data-tippy-root', '');
  popper.id = "tippy-" + instance.id;
  instance.popper = popper;
  reference._tippy = instance;
  popper._tippy = instance;
  var pluginsHooks = plugins.map(function (plugin) {
    return plugin.fn(instance);
  });
  var hasAriaExpanded = reference.hasAttribute('aria-expanded');
  addListeners();
  handleAriaExpandedAttribute();
  handleStyles();
  invokeHook('onCreate', [instance]);

  if (props.showOnCreate) {
    scheduleShow();
  } // Prevent a tippy with a delay from hiding if the cursor left then returned
  // before it started hiding


  popper.addEventListener('mouseenter', function () {
    if (instance.props.interactive && instance.state.isVisible) {
      instance.clearDelayTimeouts();
    }
  });
  popper.addEventListener('mouseleave', function (event) {
    if (instance.props.interactive && instance.props.trigger.indexOf('mouseenter') >= 0) {
      getDocument().addEventListener('mousemove', debouncedOnMouseMove);
      debouncedOnMouseMove(event);
    }
  });
  return instance; // ===========================================================================
  // 🔒 Private methods
  // ===========================================================================

  function getNormalizedTouchSettings() {
    var touch = instance.props.touch;
    return Array.isArray(touch) ? touch : [touch, 0];
  }

  function getIsCustomTouchBehavior() {
    return getNormalizedTouchSettings()[0] === 'hold';
  }

  function getIsDefaultRenderFn() {
    var _instance$props$rende;

    // @ts-ignore
    return !!((_instance$props$rende = instance.props.render) == null ? void 0 : _instance$props$rende.$$tippy);
  }

  function getCurrentTarget() {
    return currentTarget || reference;
  }

  function getDocument() {
    var parent = getCurrentTarget().parentNode;
    return parent ? getOwnerDocument(parent) : document;
  }

  function getDefaultTemplateChildren() {
    return getChildren(popper);
  }

  function getDelay(isShow) {
    // For touch or keyboard input, force `0` delay for UX reasons
    // Also if the instance is mounted but not visible (transitioning out),
    // ignore delay
    if (instance.state.isMounted && !instance.state.isVisible || currentInput.isTouch || lastTriggerEvent && lastTriggerEvent.type === 'focus') {
      return 0;
    }

    return getValueAtIndexOrReturn(instance.props.delay, isShow ? 0 : 1, defaultProps.delay);
  }

  function handleStyles() {
    popper.style.pointerEvents = instance.props.interactive && instance.state.isVisible ? '' : 'none';
    popper.style.zIndex = "" + instance.props.zIndex;
  }

  function invokeHook(hook, args, shouldInvokePropsHook) {
    if (shouldInvokePropsHook === void 0) {
      shouldInvokePropsHook = true;
    }

    pluginsHooks.forEach(function (pluginHooks) {
      if (pluginHooks[hook]) {
        pluginHooks[hook].apply(void 0, args);
      }
    });

    if (shouldInvokePropsHook) {
      var _instance$props;

      (_instance$props = instance.props)[hook].apply(_instance$props, args);
    }
  }

  function handleAriaContentAttribute() {
    var aria = instance.props.aria;

    if (!aria.content) {
      return;
    }

    var attr = "aria-" + aria.content;
    var id = popper.id;
    var nodes = normalizeToArray(instance.props.triggerTarget || reference);
    nodes.forEach(function (node) {
      var currentValue = node.getAttribute(attr);

      if (instance.state.isVisible) {
        node.setAttribute(attr, currentValue ? currentValue + " " + id : id);
      } else {
        var nextValue = currentValue && currentValue.replace(id, '').trim();

        if (nextValue) {
          node.setAttribute(attr, nextValue);
        } else {
          node.removeAttribute(attr);
        }
      }
    });
  }

  function handleAriaExpandedAttribute() {
    if (hasAriaExpanded || !instance.props.aria.expanded) {
      return;
    }

    var nodes = normalizeToArray(instance.props.triggerTarget || reference);
    nodes.forEach(function (node) {
      if (instance.props.interactive) {
        node.setAttribute('aria-expanded', instance.state.isVisible && node === getCurrentTarget() ? 'true' : 'false');
      } else {
        node.removeAttribute('aria-expanded');
      }
    });
  }

  function cleanupInteractiveMouseListeners() {
    getDocument().removeEventListener('mousemove', debouncedOnMouseMove);
    mouseMoveListeners = mouseMoveListeners.filter(function (listener) {
      return listener !== debouncedOnMouseMove;
    });
  }

  function onDocumentPress(event) {
    // Moved finger to scroll instead of an intentional tap outside
    if (currentInput.isTouch) {
      if (didTouchMove || event.type === 'mousedown') {
        return;
      }
    } // Clicked on interactive popper


    if (instance.props.interactive && popper.contains(event.target)) {
      return;
    } // Clicked on the event listeners target


    if (getCurrentTarget().contains(event.target)) {
      if (currentInput.isTouch) {
        return;
      }

      if (instance.state.isVisible && instance.props.trigger.indexOf('click') >= 0) {
        return;
      }
    } else {
      invokeHook('onClickOutside', [instance, event]);
    }

    if (instance.props.hideOnClick === true) {
      instance.clearDelayTimeouts();
      instance.hide(); // `mousedown` event is fired right before `focus` if pressing the
      // currentTarget. This lets a tippy with `focus` trigger know that it
      // should not show

      didHideDueToDocumentMouseDown = true;
      setTimeout(function () {
        didHideDueToDocumentMouseDown = false;
      }); // The listener gets added in `scheduleShow()`, but this may be hiding it
      // before it shows, and hide()'s early bail-out behavior can prevent it
      // from being cleaned up

      if (!instance.state.isMounted) {
        removeDocumentPress();
      }
    }
  }

  function onTouchMove() {
    didTouchMove = true;
  }

  function onTouchStart() {
    didTouchMove = false;
  }

  function addDocumentPress() {
    var doc = getDocument();
    doc.addEventListener('mousedown', onDocumentPress, true);
    doc.addEventListener('touchend', onDocumentPress, TOUCH_OPTIONS);
    doc.addEventListener('touchstart', onTouchStart, TOUCH_OPTIONS);
    doc.addEventListener('touchmove', onTouchMove, TOUCH_OPTIONS);
  }

  function removeDocumentPress() {
    var doc = getDocument();
    doc.removeEventListener('mousedown', onDocumentPress, true);
    doc.removeEventListener('touchend', onDocumentPress, TOUCH_OPTIONS);
    doc.removeEventListener('touchstart', onTouchStart, TOUCH_OPTIONS);
    doc.removeEventListener('touchmove', onTouchMove, TOUCH_OPTIONS);
  }

  function onTransitionedOut(duration, callback) {
    onTransitionEnd(duration, function () {
      if (!instance.state.isVisible && popper.parentNode && popper.parentNode.contains(popper)) {
        callback();
      }
    });
  }

  function onTransitionedIn(duration, callback) {
    onTransitionEnd(duration, callback);
  }

  function onTransitionEnd(duration, callback) {
    var box = getDefaultTemplateChildren().box;

    function listener(event) {
      if (event.target === box) {
        updateTransitionEndListener(box, 'remove', listener);
        callback();
      }
    } // Make callback synchronous if duration is 0
    // `transitionend` won't fire otherwise


    if (duration === 0) {
      return callback();
    }

    updateTransitionEndListener(box, 'remove', currentTransitionEndListener);
    updateTransitionEndListener(box, 'add', listener);
    currentTransitionEndListener = listener;
  }

  function on(eventType, handler, options) {
    if (options === void 0) {
      options = false;
    }

    var nodes = normalizeToArray(instance.props.triggerTarget || reference);
    nodes.forEach(function (node) {
      node.addEventListener(eventType, handler, options);
      listeners.push({
        node: node,
        eventType: eventType,
        handler: handler,
        options: options
      });
    });
  }

  function addListeners() {
    if (getIsCustomTouchBehavior()) {
      on('touchstart', onTrigger, {
        passive: true
      });
      on('touchend', onMouseLeave, {
        passive: true
      });
    }

    splitBySpaces(instance.props.trigger).forEach(function (eventType) {
      if (eventType === 'manual') {
        return;
      }

      on(eventType, onTrigger);

      switch (eventType) {
        case 'mouseenter':
          on('mouseleave', onMouseLeave);
          break;

        case 'focus':
          on(isIE ? 'focusout' : 'blur', onBlurOrFocusOut);
          break;

        case 'focusin':
          on('focusout', onBlurOrFocusOut);
          break;
      }
    });
  }

  function removeListeners() {
    listeners.forEach(function (_ref) {
      var node = _ref.node,
          eventType = _ref.eventType,
          handler = _ref.handler,
          options = _ref.options;
      node.removeEventListener(eventType, handler, options);
    });
    listeners = [];
  }

  function onTrigger(event) {
    var _lastTriggerEvent;

    var shouldScheduleClickHide = false;

    if (!instance.state.isEnabled || isEventListenerStopped(event) || didHideDueToDocumentMouseDown) {
      return;
    }

    var wasFocused = ((_lastTriggerEvent = lastTriggerEvent) == null ? void 0 : _lastTriggerEvent.type) === 'focus';
    lastTriggerEvent = event;
    currentTarget = event.currentTarget;
    handleAriaExpandedAttribute();

    if (!instance.state.isVisible && isMouseEvent(event)) {
      // If scrolling, `mouseenter` events can be fired if the cursor lands
      // over a new target, but `mousemove` events don't get fired. This
      // causes interactive tooltips to get stuck open until the cursor is
      // moved
      mouseMoveListeners.forEach(function (listener) {
        return listener(event);
      });
    } // Toggle show/hide when clicking click-triggered tooltips


    if (event.type === 'click' && (instance.props.trigger.indexOf('mouseenter') < 0 || isVisibleFromClick) && instance.props.hideOnClick !== false && instance.state.isVisible) {
      shouldScheduleClickHide = true;
    } else {
      scheduleShow(event);
    }

    if (event.type === 'click') {
      isVisibleFromClick = !shouldScheduleClickHide;
    }

    if (shouldScheduleClickHide && !wasFocused) {
      scheduleHide(event);
    }
  }

  function onMouseMove(event) {
    var target = event.target;
    var isCursorOverReferenceOrPopper = getCurrentTarget().contains(target) || popper.contains(target);

    if (event.type === 'mousemove' && isCursorOverReferenceOrPopper) {
      return;
    }

    var popperTreeData = getNestedPopperTree().concat(popper).map(function (popper) {
      var _instance$popperInsta;

      var instance = popper._tippy;
      var state = (_instance$popperInsta = instance.popperInstance) == null ? void 0 : _instance$popperInsta.state;

      if (state) {
        return {
          popperRect: popper.getBoundingClientRect(),
          popperState: state,
          props: props
        };
      }

      return null;
    }).filter(Boolean);

    if (isCursorOutsideInteractiveBorder(popperTreeData, event)) {
      cleanupInteractiveMouseListeners();
      scheduleHide(event);
    }
  }

  function onMouseLeave(event) {
    var shouldBail = isEventListenerStopped(event) || instance.props.trigger.indexOf('click') >= 0 && isVisibleFromClick;

    if (shouldBail) {
      return;
    }

    if (instance.props.interactive) {
      instance.hideWithInteractivity(event);
      return;
    }

    scheduleHide(event);
  }

  function onBlurOrFocusOut(event) {
    if (instance.props.trigger.indexOf('focusin') < 0 && event.target !== getCurrentTarget()) {
      return;
    } // If focus was moved to within the popper


    if (instance.props.interactive && event.relatedTarget && popper.contains(event.relatedTarget)) {
      return;
    }

    scheduleHide(event);
  }

  function isEventListenerStopped(event) {
    return currentInput.isTouch ? getIsCustomTouchBehavior() !== event.type.indexOf('touch') >= 0 : false;
  }

  function createPopperInstance() {
    destroyPopperInstance();
    var _instance$props2 = instance.props,
        popperOptions = _instance$props2.popperOptions,
        placement = _instance$props2.placement,
        offset = _instance$props2.offset,
        getReferenceClientRect = _instance$props2.getReferenceClientRect,
        moveTransition = _instance$props2.moveTransition;
    var arrow = getIsDefaultRenderFn() ? getChildren(popper).arrow : null;
    var computedReference = getReferenceClientRect ? {
      getBoundingClientRect: getReferenceClientRect,
      contextElement: getReferenceClientRect.contextElement || getCurrentTarget()
    } : reference;
    var tippyModifier = {
      name: '$$tippy',
      enabled: true,
      phase: 'beforeWrite',
      requires: ['computeStyles'],
      fn: function fn(_ref2) {
        var state = _ref2.state;

        if (getIsDefaultRenderFn()) {
          var _getDefaultTemplateCh = getDefaultTemplateChildren(),
              box = _getDefaultTemplateCh.box;

          ['placement', 'reference-hidden', 'escaped'].forEach(function (attr) {
            if (attr === 'placement') {
              box.setAttribute('data-placement', state.placement);
            } else {
              if (state.attributes.popper["data-popper-" + attr]) {
                box.setAttribute("data-" + attr, '');
              } else {
                box.removeAttribute("data-" + attr);
              }
            }
          });
          state.attributes.popper = {};
        }
      }
    };
    var modifiers = [{
      name: 'offset',
      options: {
        offset: offset
      }
    }, {
      name: 'preventOverflow',
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: 'flip',
      options: {
        padding: 5
      }
    }, {
      name: 'computeStyles',
      options: {
        adaptive: !moveTransition
      }
    }, tippyModifier];

    if (getIsDefaultRenderFn() && arrow) {
      modifiers.push({
        name: 'arrow',
        options: {
          element: arrow,
          padding: 3
        }
      });
    }

    modifiers.push.apply(modifiers, (popperOptions == null ? void 0 : popperOptions.modifiers) || []);
    instance.popperInstance = core.createPopper(computedReference, popper, Object.assign({}, popperOptions, {
      placement: placement,
      onFirstUpdate: onFirstUpdate,
      modifiers: modifiers
    }));
  }

  function destroyPopperInstance() {
    if (instance.popperInstance) {
      instance.popperInstance.destroy();
      instance.popperInstance = null;
    }
  }

  function mount() {
    var appendTo = instance.props.appendTo;
    var parentNode; // By default, we'll append the popper to the triggerTargets's parentNode so
    // it's directly after the reference element so the elements inside the
    // tippy can be tabbed to
    // If there are clipping issues, the user can specify a different appendTo
    // and ensure focus management is handled correctly manually

    var node = getCurrentTarget();

    if (instance.props.interactive && appendTo === defaultProps.appendTo || appendTo === 'parent') {
      parentNode = node.parentNode;
    } else {
      parentNode = invokeWithArgsOrReturn(appendTo, [node]);
    } // The popper element needs to exist on the DOM before its position can be
    // updated as Popper needs to read its dimensions


    if (!parentNode.contains(popper)) {
      parentNode.appendChild(popper);
    }

    createPopperInstance();
    /* istanbul ignore else */

    if (process.env.NODE_ENV !== "production") {
      // Accessibility check
      warnWhen(instance.props.interactive && appendTo === defaultProps.appendTo && node.nextElementSibling !== popper, ['Interactive tippy element may not be accessible via keyboard', 'navigation because it is not directly after the reference element', 'in the DOM source order.', '\n\n', 'Using a wrapper <div> or <span> tag around the reference element', 'solves this by creating a new parentNode context.', '\n\n', 'Specifying `appendTo: document.body` silences this warning, but it', 'assumes you are using a focus management solution to handle', 'keyboard navigation.', '\n\n', 'See: https://atomiks.github.io/tippyjs/v6/accessibility/#interactivity'].join(' '));
    }
  }

  function getNestedPopperTree() {
    return arrayFrom(popper.querySelectorAll('[data-tippy-root]'));
  }

  function scheduleShow(event) {
    instance.clearDelayTimeouts();

    if (event) {
      invokeHook('onTrigger', [instance, event]);
    }

    addDocumentPress();
    var delay = getDelay(true);

    var _getNormalizedTouchSe = getNormalizedTouchSettings(),
        touchValue = _getNormalizedTouchSe[0],
        touchDelay = _getNormalizedTouchSe[1];

    if (currentInput.isTouch && touchValue === 'hold' && touchDelay) {
      delay = touchDelay;
    }

    if (delay) {
      showTimeout = setTimeout(function () {
        instance.show();
      }, delay);
    } else {
      instance.show();
    }
  }

  function scheduleHide(event) {
    instance.clearDelayTimeouts();
    invokeHook('onUntrigger', [instance, event]);

    if (!instance.state.isVisible) {
      removeDocumentPress();
      return;
    } // For interactive tippies, scheduleHide is added to a document.body handler
    // from onMouseLeave so must intercept scheduled hides from mousemove/leave
    // events when trigger contains mouseenter and click, and the tip is
    // currently shown as a result of a click.


    if (instance.props.trigger.indexOf('mouseenter') >= 0 && instance.props.trigger.indexOf('click') >= 0 && ['mouseleave', 'mousemove'].indexOf(event.type) >= 0 && isVisibleFromClick) {
      return;
    }

    var delay = getDelay(false);

    if (delay) {
      hideTimeout = setTimeout(function () {
        if (instance.state.isVisible) {
          instance.hide();
        }
      }, delay);
    } else {
      // Fixes a `transitionend` problem when it fires 1 frame too
      // late sometimes, we don't want hide() to be called.
      scheduleHideAnimationFrame = requestAnimationFrame(function () {
        instance.hide();
      });
    }
  } // ===========================================================================
  // 🔑 Public methods
  // ===========================================================================


  function enable() {
    instance.state.isEnabled = true;
  }

  function disable() {
    // Disabling the instance should also hide it
    // https://github.com/atomiks/tippy.js-react/issues/106
    instance.hide();
    instance.state.isEnabled = false;
  }

  function clearDelayTimeouts() {
    clearTimeout(showTimeout);
    clearTimeout(hideTimeout);
    cancelAnimationFrame(scheduleHideAnimationFrame);
  }

  function setProps(partialProps) {
    /* istanbul ignore else */
    if (process.env.NODE_ENV !== "production") {
      warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('setProps'));
    }

    if (instance.state.isDestroyed) {
      return;
    }

    invokeHook('onBeforeUpdate', [instance, partialProps]);
    removeListeners();
    var prevProps = instance.props;
    var nextProps = evaluateProps(reference, Object.assign({}, instance.props, {}, partialProps, {
      ignoreAttributes: true
    }));
    instance.props = nextProps;
    addListeners();

    if (prevProps.interactiveDebounce !== nextProps.interactiveDebounce) {
      cleanupInteractiveMouseListeners();
      debouncedOnMouseMove = debounce(onMouseMove, nextProps.interactiveDebounce);
    } // Ensure stale aria-expanded attributes are removed


    if (prevProps.triggerTarget && !nextProps.triggerTarget) {
      normalizeToArray(prevProps.triggerTarget).forEach(function (node) {
        node.removeAttribute('aria-expanded');
      });
    } else if (nextProps.triggerTarget) {
      reference.removeAttribute('aria-expanded');
    }

    handleAriaExpandedAttribute();
    handleStyles();

    if (onUpdate) {
      onUpdate(prevProps, nextProps);
    }

    if (instance.popperInstance) {
      createPopperInstance(); // Fixes an issue with nested tippies if they are all getting re-rendered,
      // and the nested ones get re-rendered first.
      // https://github.com/atomiks/tippyjs-react/issues/177
      // TODO: find a cleaner / more efficient solution(!)

      getNestedPopperTree().forEach(function (nestedPopper) {
        // React (and other UI libs likely) requires a rAF wrapper as it flushes
        // its work in one
        requestAnimationFrame(nestedPopper._tippy.popperInstance.forceUpdate);
      });
    }

    invokeHook('onAfterUpdate', [instance, partialProps]);
  }

  function setContent(content) {
    instance.setProps({
      content: content
    });
  }

  function show() {
    /* istanbul ignore else */
    if (process.env.NODE_ENV !== "production") {
      warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('show'));
    } // Early bail-out


    var isAlreadyVisible = instance.state.isVisible;
    var isDestroyed = instance.state.isDestroyed;
    var isDisabled = !instance.state.isEnabled;
    var isTouchAndTouchDisabled = currentInput.isTouch && !instance.props.touch;
    var duration = getValueAtIndexOrReturn(instance.props.duration, 0, defaultProps.duration);

    if (isAlreadyVisible || isDestroyed || isDisabled || isTouchAndTouchDisabled) {
      return;
    } // Normalize `disabled` behavior across browsers.
    // Firefox allows events on disabled elements, but Chrome doesn't.
    // Using a wrapper element (i.e. <span>) is recommended.


    if (getCurrentTarget().hasAttribute('disabled')) {
      return;
    }

    invokeHook('onShow', [instance], false);

    if (instance.props.onShow(instance) === false) {
      return;
    }

    instance.state.isVisible = true;

    if (getIsDefaultRenderFn()) {
      popper.style.visibility = 'visible';
    }

    handleStyles();
    addDocumentPress();

    if (!instance.state.isMounted) {
      popper.style.transition = 'none';
    } // If flipping to the opposite side after hiding at least once, the
    // animation will use the wrong placement without resetting the duration


    if (getIsDefaultRenderFn()) {
      var _getDefaultTemplateCh2 = getDefaultTemplateChildren(),
          box = _getDefaultTemplateCh2.box,
          content = _getDefaultTemplateCh2.content;

      setTransitionDuration([box, content], 0);
    }

    onFirstUpdate = function onFirstUpdate() {
      var _instance$popperInsta2;

      if (!instance.state.isVisible || ignoreOnFirstUpdate) {
        return;
      }

      ignoreOnFirstUpdate = true; // reflow

      void popper.offsetHeight;
      popper.style.transition = instance.props.moveTransition;

      if (getIsDefaultRenderFn() && instance.props.animation) {
        var _getDefaultTemplateCh3 = getDefaultTemplateChildren(),
            _box = _getDefaultTemplateCh3.box,
            _content = _getDefaultTemplateCh3.content;

        setTransitionDuration([_box, _content], duration);
        setVisibilityState([_box, _content], 'visible');
      }

      handleAriaContentAttribute();
      handleAriaExpandedAttribute();
      pushIfUnique(mountedInstances, instance); // certain modifiers (e.g. `maxSize`) require a second update after the
      // popper has been positioned for the first time

      (_instance$popperInsta2 = instance.popperInstance) == null ? void 0 : _instance$popperInsta2.forceUpdate();
      instance.state.isMounted = true;
      invokeHook('onMount', [instance]);

      if (instance.props.animation && getIsDefaultRenderFn()) {
        onTransitionedIn(duration, function () {
          instance.state.isShown = true;
          invokeHook('onShown', [instance]);
        });
      }
    };

    mount();
  }

  function hide() {
    /* istanbul ignore else */
    if (process.env.NODE_ENV !== "production") {
      warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('hide'));
    } // Early bail-out


    var isAlreadyHidden = !instance.state.isVisible;
    var isDestroyed = instance.state.isDestroyed;
    var isDisabled = !instance.state.isEnabled;
    var duration = getValueAtIndexOrReturn(instance.props.duration, 1, defaultProps.duration);

    if (isAlreadyHidden || isDestroyed || isDisabled) {
      return;
    }

    invokeHook('onHide', [instance], false);

    if (instance.props.onHide(instance) === false) {
      return;
    }

    instance.state.isVisible = false;
    instance.state.isShown = false;
    ignoreOnFirstUpdate = false;
    isVisibleFromClick = false;

    if (getIsDefaultRenderFn()) {
      popper.style.visibility = 'hidden';
    }

    cleanupInteractiveMouseListeners();
    removeDocumentPress();
    handleStyles();

    if (getIsDefaultRenderFn()) {
      var _getDefaultTemplateCh4 = getDefaultTemplateChildren(),
          box = _getDefaultTemplateCh4.box,
          content = _getDefaultTemplateCh4.content;

      if (instance.props.animation) {
        setTransitionDuration([box, content], duration);
        setVisibilityState([box, content], 'hidden');
      }
    }

    handleAriaContentAttribute();
    handleAriaExpandedAttribute();

    if (instance.props.animation) {
      if (getIsDefaultRenderFn()) {
        onTransitionedOut(duration, instance.unmount);
      }
    } else {
      instance.unmount();
    }
  }

  function hideWithInteractivity(event) {
    /* istanbul ignore else */
    if (process.env.NODE_ENV !== "production") {
      warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('hideWithInteractivity'));
    }

    getDocument().addEventListener('mousemove', debouncedOnMouseMove);
    pushIfUnique(mouseMoveListeners, debouncedOnMouseMove);
    debouncedOnMouseMove(event);
  }

  function unmount() {
    /* istanbul ignore else */
    if (process.env.NODE_ENV !== "production") {
      warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('unmount'));
    }

    if (instance.state.isVisible) {
      instance.hide();
    }

    if (!instance.state.isMounted) {
      return;
    }

    destroyPopperInstance(); // If a popper is not interactive, it will be appended outside the popper
    // tree by default. This seems mainly for interactive tippies, but we should
    // find a workaround if possible

    getNestedPopperTree().forEach(function (nestedPopper) {
      nestedPopper._tippy.unmount();
    });

    if (popper.parentNode) {
      popper.parentNode.removeChild(popper);
    }

    mountedInstances = mountedInstances.filter(function (i) {
      return i !== instance;
    });
    instance.state.isMounted = false;
    invokeHook('onHidden', [instance]);
  }

  function destroy() {
    /* istanbul ignore else */
    if (process.env.NODE_ENV !== "production") {
      warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('destroy'));
    }

    if (instance.state.isDestroyed) {
      return;
    }

    instance.clearDelayTimeouts();
    instance.unmount();
    removeListeners();
    delete reference._tippy;
    instance.state.isDestroyed = true;
    invokeHook('onDestroy', [instance]);
  }
}

function tippy(targets, optionalProps) {
  if (optionalProps === void 0) {
    optionalProps = {};
  }

  var plugins = defaultProps.plugins.concat(optionalProps.plugins || []);
  /* istanbul ignore else */

  if (process.env.NODE_ENV !== "production") {
    validateTargets(targets);
    validateProps(optionalProps, plugins);
  }

  bindGlobalEventListeners();
  var passedProps = Object.assign({}, optionalProps, {
    plugins: plugins
  });
  var elements = getArrayOfElements(targets);
  /* istanbul ignore else */

  if (process.env.NODE_ENV !== "production") {
    var isSingleContentElement = isElement(passedProps.content);
    var isMoreThanOneReferenceElement = elements.length > 1;
    warnWhen(isSingleContentElement && isMoreThanOneReferenceElement, ['tippy() was passed an Element as the `content` prop, but more than', 'one tippy instance was created by this invocation. This means the', 'content element will only be appended to the last tippy instance.', '\n\n', 'Instead, pass the .innerHTML of the element, or use a function that', 'returns a cloned version of the element instead.', '\n\n', '1) content: element.innerHTML\n', '2) content: () => element.cloneNode(true)'].join(' '));
  }

  var instances = elements.reduce(function (acc, reference) {
    var instance = reference && createTippy(reference, passedProps);

    if (instance) {
      acc.push(instance);
    }

    return acc;
  }, []);
  return isElement(targets) ? instances[0] : instances;
}

tippy.defaultProps = defaultProps;
tippy.setDefaultProps = setDefaultProps;
tippy.currentInput = currentInput;
var hideAll = function hideAll(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      excludedReferenceOrInstance = _ref.exclude,
      duration = _ref.duration;

  mountedInstances.forEach(function (instance) {
    var isExcluded = false;

    if (excludedReferenceOrInstance) {
      isExcluded = isReferenceElement(excludedReferenceOrInstance) ? instance.reference === excludedReferenceOrInstance : instance.popper === excludedReferenceOrInstance.popper;
    }

    if (!isExcluded) {
      var originalDuration = instance.props.duration;
      instance.setProps({
        duration: duration
      });
      instance.hide();

      if (!instance.state.isDestroyed) {
        instance.setProps({
          duration: originalDuration
        });
      }
    }
  });
};

// every time the popper is destroyed (i.e. a new target), removing the styles
// and causing transitions to break for singletons when the console is open, but
// most notably for non-transform styles being used, `gpuAcceleration: false`.

var applyStylesModifier = Object.assign({}, core.applyStyles, {
  effect: function effect(_ref) {
    var state = _ref.state;
    var initialStyles = {
      popper: {
        position: state.options.strategy,
        left: '0',
        top: '0',
        margin: '0'
      },
      arrow: {
        position: 'absolute'
      },
      reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;

    if (state.elements.arrow) {
      Object.assign(state.elements.arrow.style, initialStyles.arrow);
    } // intentionally return no cleanup function
    // return () => { ... }

  }
});

var createSingleton = function createSingleton(tippyInstances, optionalProps) {
  var _optionalProps$popper;

  if (optionalProps === void 0) {
    optionalProps = {};
  }

  /* istanbul ignore else */
  if (process.env.NODE_ENV !== "production") {
    errorWhen(!Array.isArray(tippyInstances), ['The first argument passed to createSingleton() must be an array of', 'tippy instances. The passed value was', String(tippyInstances)].join(' '));
  }

  var individualInstances = tippyInstances;
  var references = [];
  var currentTarget;
  var overrides = optionalProps.overrides;
  var interceptSetPropsCleanups = [];
  var shownOnCreate = false;

  function setReferences() {
    references = individualInstances.map(function (instance) {
      return instance.reference;
    });
  }

  function enableInstances(isEnabled) {
    individualInstances.forEach(function (instance) {
      if (isEnabled) {
        instance.enable();
      } else {
        instance.disable();
      }
    });
  }

  function interceptSetProps(singleton) {
    return individualInstances.map(function (instance) {
      var originalSetProps = instance.setProps;

      instance.setProps = function (props) {
        originalSetProps(props);

        if (instance.reference === currentTarget) {
          singleton.setProps(props);
        }
      };

      return function () {
        instance.setProps = originalSetProps;
      };
    });
  } // have to pass singleton, as it maybe undefined on first call


  function prepareInstance(singleton, target) {
    var index = references.indexOf(target); // bail-out

    if (target === currentTarget) {
      return;
    }

    currentTarget = target;
    var overrideProps = (overrides || []).concat('content').reduce(function (acc, prop) {
      acc[prop] = individualInstances[index].props[prop];
      return acc;
    }, {});
    singleton.setProps(Object.assign({}, overrideProps, {
      getReferenceClientRect: typeof overrideProps.getReferenceClientRect === 'function' ? overrideProps.getReferenceClientRect : function () {
        return target.getBoundingClientRect();
      }
    }));
  }

  enableInstances(false);
  setReferences();
  var plugin = {
    fn: function fn() {
      return {
        onDestroy: function onDestroy() {
          enableInstances(true);
        },
        onHidden: function onHidden() {
          currentTarget = null;
        },
        onClickOutside: function onClickOutside(instance) {
          if (instance.props.showOnCreate && !shownOnCreate) {
            shownOnCreate = true;
            currentTarget = null;
          }
        },
        onShow: function onShow(instance) {
          if (instance.props.showOnCreate && !shownOnCreate) {
            shownOnCreate = true;
            prepareInstance(instance, references[0]);
          }
        },
        onTrigger: function onTrigger(instance, event) {
          prepareInstance(instance, event.currentTarget);
        }
      };
    }
  };
  var singleton = tippy(div(), Object.assign({}, removeProperties(optionalProps, ['overrides']), {
    plugins: [plugin].concat(optionalProps.plugins || []),
    triggerTarget: references,
    popperOptions: Object.assign({}, optionalProps.popperOptions, {
      modifiers: [].concat(((_optionalProps$popper = optionalProps.popperOptions) == null ? void 0 : _optionalProps$popper.modifiers) || [], [applyStylesModifier])
    })
  }));
  var originalShow = singleton.show;

  singleton.show = function (target) {
    originalShow(); // first time, showOnCreate or programmatic call with no params
    // default to showing first instance

    if (!currentTarget && target == null) {
      return prepareInstance(singleton, references[0]);
    } // triggered from event (do nothing as prepareInstance already called by onTrigger)
    // programmatic call with no params when already visible (do nothing again)


    if (currentTarget && target == null) {
      return;
    } // target is index of instance


    if (typeof target === 'number') {
      return references[target] && prepareInstance(singleton, references[target]);
    } // target is a child tippy instance


    if (individualInstances.includes(target)) {
      var ref = target.reference;
      return prepareInstance(singleton, ref);
    } // target is a ReferenceElement


    if (references.includes(target)) {
      return prepareInstance(singleton, target);
    }
  };

  singleton.showNext = function () {
    var first = references[0];

    if (!currentTarget) {
      return singleton.show(0);
    }

    var index = references.indexOf(currentTarget);
    singleton.show(references[index + 1] || first);
  };

  singleton.showPrevious = function () {
    var last = references[references.length - 1];

    if (!currentTarget) {
      return singleton.show(last);
    }

    var index = references.indexOf(currentTarget);
    var target = references[index - 1] || last;
    singleton.show(target);
  };

  var originalSetProps = singleton.setProps;

  singleton.setProps = function (props) {
    overrides = props.overrides || overrides;
    originalSetProps(props);
  };

  singleton.setInstances = function (nextInstances) {
    enableInstances(true);
    interceptSetPropsCleanups.forEach(function (fn) {
      return fn();
    });
    individualInstances = nextInstances;
    enableInstances(false);
    setReferences();
    interceptSetProps(singleton);
    singleton.setProps({
      triggerTarget: references
    });
  };

  interceptSetPropsCleanups = interceptSetProps(singleton);
  return singleton;
};

var BUBBLING_EVENTS_MAP = {
  mouseover: 'mouseenter',
  focusin: 'focus',
  click: 'click'
};
/**
 * Creates a delegate instance that controls the creation of tippy instances
 * for child elements (`target` CSS selector).
 */

function delegate(targets, props) {
  /* istanbul ignore else */
  if (process.env.NODE_ENV !== "production") {
    errorWhen(!(props && props.target), ['You must specity a `target` prop indicating a CSS selector string matching', 'the target elements that should receive a tippy.'].join(' '));
  }

  var listeners = [];
  var childTippyInstances = [];
  var disabled = false;
  var target = props.target;
  var nativeProps = removeProperties(props, ['target']);
  var parentProps = Object.assign({}, nativeProps, {
    trigger: 'manual',
    touch: false
  });
  var childProps = Object.assign({}, nativeProps, {
    showOnCreate: true
  });
  var returnValue = tippy(targets, parentProps);
  var normalizedReturnValue = normalizeToArray(returnValue);

  function onTrigger(event) {
    if (!event.target || disabled) {
      return;
    }

    var targetNode = event.target.closest(target);

    if (!targetNode) {
      return;
    } // Get relevant trigger with fallbacks:
    // 1. Check `data-tippy-trigger` attribute on target node
    // 2. Fallback to `trigger` passed to `delegate()`
    // 3. Fallback to `defaultProps.trigger`


    var trigger = targetNode.getAttribute('data-tippy-trigger') || props.trigger || defaultProps.trigger; // @ts-ignore

    if (targetNode._tippy) {
      return;
    }

    if (event.type === 'touchstart' && typeof childProps.touch === 'boolean') {
      return;
    }

    if (event.type !== 'touchstart' && trigger.indexOf(BUBBLING_EVENTS_MAP[event.type]) < 0) {
      return;
    }

    var instance = tippy(targetNode, childProps);

    if (instance) {
      childTippyInstances = childTippyInstances.concat(instance);
    }
  }

  function on(node, eventType, handler, options) {
    if (options === void 0) {
      options = false;
    }

    node.addEventListener(eventType, handler, options);
    listeners.push({
      node: node,
      eventType: eventType,
      handler: handler,
      options: options
    });
  }

  function addEventListeners(instance) {
    var reference = instance.reference;
    on(reference, 'touchstart', onTrigger, TOUCH_OPTIONS);
    on(reference, 'mouseover', onTrigger);
    on(reference, 'focusin', onTrigger);
    on(reference, 'click', onTrigger);
  }

  function removeEventListeners() {
    listeners.forEach(function (_ref) {
      var node = _ref.node,
          eventType = _ref.eventType,
          handler = _ref.handler,
          options = _ref.options;
      node.removeEventListener(eventType, handler, options);
    });
    listeners = [];
  }

  function applyMutations(instance) {
    var originalDestroy = instance.destroy;
    var originalEnable = instance.enable;
    var originalDisable = instance.disable;

    instance.destroy = function (shouldDestroyChildInstances) {
      if (shouldDestroyChildInstances === void 0) {
        shouldDestroyChildInstances = true;
      }

      if (shouldDestroyChildInstances) {
        childTippyInstances.forEach(function (instance) {
          instance.destroy();
        });
      }

      childTippyInstances = [];
      removeEventListeners();
      originalDestroy();
    };

    instance.enable = function () {
      originalEnable();
      childTippyInstances.forEach(function (instance) {
        return instance.enable();
      });
      disabled = false;
    };

    instance.disable = function () {
      originalDisable();
      childTippyInstances.forEach(function (instance) {
        return instance.disable();
      });
      disabled = true;
    };

    addEventListeners(instance);
  }

  normalizedReturnValue.forEach(applyMutations);
  return returnValue;
}

var animateFill = {
  name: 'animateFill',
  defaultValue: false,
  fn: function fn(instance) {
    var _instance$props$rende;

    // @ts-ignore
    if (!((_instance$props$rende = instance.props.render) == null ? void 0 : _instance$props$rende.$$tippy)) {
      if (process.env.NODE_ENV !== "production") {
        errorWhen(instance.props.animateFill, 'The `animateFill` plugin requires the default render function.');
      }

      return {};
    }

    var _getChildren = getChildren(instance.popper),
        box = _getChildren.box,
        content = _getChildren.content;

    var backdrop = instance.props.animateFill ? createBackdropElement() : null;
    return {
      onCreate: function onCreate() {
        if (backdrop) {
          box.insertBefore(backdrop, box.firstElementChild);
          box.setAttribute('data-animatefill', '');
          box.style.overflow = 'hidden';
          instance.setProps({
            arrow: false,
            animation: 'shift-away'
          });
        }
      },
      onMount: function onMount() {
        if (backdrop) {
          var transitionDuration = box.style.transitionDuration;
          var duration = Number(transitionDuration.replace('ms', '')); // The content should fade in after the backdrop has mostly filled the
          // tooltip element. `clip-path` is the other alternative but is not
          // well-supported and is buggy on some devices.

          content.style.transitionDelay = Math.round(duration / 10) + "ms";
          backdrop.style.transitionDuration = transitionDuration;
          setVisibilityState([backdrop], 'visible');
        }
      },
      onShow: function onShow() {
        if (backdrop) {
          backdrop.style.transitionDuration = '0ms';
        }
      },
      onHide: function onHide() {
        if (backdrop) {
          setVisibilityState([backdrop], 'hidden');
        }
      }
    };
  }
};

function createBackdropElement() {
  var backdrop = div();
  backdrop.className = BACKDROP_CLASS;
  setVisibilityState([backdrop], 'hidden');
  return backdrop;
}

var mouseCoords = {
  clientX: 0,
  clientY: 0
};
var activeInstances = [];

function storeMouseCoords(_ref) {
  var clientX = _ref.clientX,
      clientY = _ref.clientY;
  mouseCoords = {
    clientX: clientX,
    clientY: clientY
  };
}

function addMouseCoordsListener(doc) {
  doc.addEventListener('mousemove', storeMouseCoords);
}

function removeMouseCoordsListener(doc) {
  doc.removeEventListener('mousemove', storeMouseCoords);
}

var followCursor = {
  name: 'followCursor',
  defaultValue: false,
  fn: function fn(instance) {
    var reference = instance.reference;
    var doc = getOwnerDocument(instance.props.triggerTarget || reference);
    var isInternalUpdate = false;
    var wasFocusEvent = false;
    var isUnmounted = true;
    var prevProps = instance.props;

    function getIsInitialBehavior() {
      return instance.props.followCursor === 'initial' && instance.state.isVisible;
    }

    function addListener() {
      doc.addEventListener('mousemove', onMouseMove);
    }

    function removeListener() {
      doc.removeEventListener('mousemove', onMouseMove);
    }

    function unsetGetReferenceClientRect() {
      isInternalUpdate = true;
      instance.setProps({
        getReferenceClientRect: null
      });
      isInternalUpdate = false;
    }

    function onMouseMove(event) {
      // If the instance is interactive, avoid updating the position unless it's
      // over the reference element
      var isCursorOverReference = event.target ? reference.contains(event.target) : true;
      var followCursor = instance.props.followCursor;
      var clientX = event.clientX,
          clientY = event.clientY;
      var rect = reference.getBoundingClientRect();
      var relativeX = clientX - rect.left;
      var relativeY = clientY - rect.top;

      if (isCursorOverReference || !instance.props.interactive) {
        instance.setProps({
          getReferenceClientRect: function getReferenceClientRect() {
            var rect = reference.getBoundingClientRect();
            var x = clientX;
            var y = clientY;

            if (followCursor === 'initial') {
              x = rect.left + relativeX;
              y = rect.top + relativeY;
            }

            var top = followCursor === 'horizontal' ? rect.top : y;
            var right = followCursor === 'vertical' ? rect.right : x;
            var bottom = followCursor === 'horizontal' ? rect.bottom : y;
            var left = followCursor === 'vertical' ? rect.left : x;
            return {
              width: right - left,
              height: bottom - top,
              top: top,
              right: right,
              bottom: bottom,
              left: left
            };
          }
        });
      }
    }

    function create() {
      if (instance.props.followCursor) {
        activeInstances.push({
          instance: instance,
          doc: doc
        });
        addMouseCoordsListener(doc);
      }
    }

    function destroy() {
      activeInstances = activeInstances.filter(function (data) {
        return data.instance !== instance;
      });

      if (activeInstances.filter(function (data) {
        return data.doc === doc;
      }).length === 0) {
        removeMouseCoordsListener(doc);
      }
    }

    return {
      onCreate: create,
      onDestroy: destroy,
      onBeforeUpdate: function onBeforeUpdate() {
        prevProps = instance.props;
      },
      onAfterUpdate: function onAfterUpdate(_, _ref2) {
        var followCursor = _ref2.followCursor;

        if (isInternalUpdate) {
          return;
        }

        if (followCursor !== undefined && prevProps.followCursor !== followCursor) {
          destroy();

          if (followCursor) {
            create();

            if (instance.state.isMounted && !wasFocusEvent && !getIsInitialBehavior()) {
              addListener();
            }
          } else {
            removeListener();
            unsetGetReferenceClientRect();
          }
        }
      },
      onMount: function onMount() {
        if (instance.props.followCursor && !wasFocusEvent) {
          if (isUnmounted) {
            onMouseMove(mouseCoords);
            isUnmounted = false;
          }

          if (!getIsInitialBehavior()) {
            addListener();
          }
        }
      },
      onTrigger: function onTrigger(_, event) {
        if (isMouseEvent(event)) {
          mouseCoords = {
            clientX: event.clientX,
            clientY: event.clientY
          };
        }

        wasFocusEvent = event.type === 'focus';
      },
      onHidden: function onHidden() {
        if (instance.props.followCursor) {
          unsetGetReferenceClientRect();
          removeListener();
          isUnmounted = true;
        }
      }
    };
  }
};

function getProps(props, modifier) {
  var _props$popperOptions;

  return {
    popperOptions: Object.assign({}, props.popperOptions, {
      modifiers: [].concat((((_props$popperOptions = props.popperOptions) == null ? void 0 : _props$popperOptions.modifiers) || []).filter(function (_ref) {
        var name = _ref.name;
        return name !== modifier.name;
      }), [modifier])
    })
  };
}

var inlinePositioning = {
  name: 'inlinePositioning',
  defaultValue: false,
  fn: function fn(instance) {
    var reference = instance.reference;

    function isEnabled() {
      return !!instance.props.inlinePositioning;
    }

    var placement;
    var cursorRectIndex = -1;
    var isInternalUpdate = false;
    var modifier = {
      name: 'tippyInlinePositioning',
      enabled: true,
      phase: 'afterWrite',
      fn: function fn(_ref2) {
        var state = _ref2.state;

        if (isEnabled()) {
          if (placement !== state.placement) {
            instance.setProps({
              getReferenceClientRect: function getReferenceClientRect() {
                return _getReferenceClientRect(state.placement);
              }
            });
          }

          placement = state.placement;
        }
      }
    };

    function _getReferenceClientRect(placement) {
      return getInlineBoundingClientRect(getBasePlacement(placement), reference.getBoundingClientRect(), arrayFrom(reference.getClientRects()), cursorRectIndex);
    }

    function setInternalProps(partialProps) {
      isInternalUpdate = true;
      instance.setProps(partialProps);
      isInternalUpdate = false;
    }

    function addModifier() {
      if (!isInternalUpdate) {
        setInternalProps(getProps(instance.props, modifier));
      }
    }

    return {
      onCreate: addModifier,
      onAfterUpdate: addModifier,
      onTrigger: function onTrigger(_, event) {
        if (isMouseEvent(event)) {
          var rects = arrayFrom(instance.reference.getClientRects());
          var cursorRect = rects.find(function (rect) {
            return rect.left - 2 <= event.clientX && rect.right + 2 >= event.clientX && rect.top - 2 <= event.clientY && rect.bottom + 2 >= event.clientY;
          });
          cursorRectIndex = rects.indexOf(cursorRect);
        }
      },
      onUntrigger: function onUntrigger() {
        cursorRectIndex = -1;
      }
    };
  }
};
function getInlineBoundingClientRect(currentBasePlacement, boundingRect, clientRects, cursorRectIndex) {
  // Not an inline element, or placement is not yet known
  if (clientRects.length < 2 || currentBasePlacement === null) {
    return boundingRect;
  } // There are two rects and they are disjoined


  if (clientRects.length === 2 && cursorRectIndex >= 0 && clientRects[0].left > clientRects[1].right) {
    return clientRects[cursorRectIndex] || boundingRect;
  }

  switch (currentBasePlacement) {
    case 'top':
    case 'bottom':
      {
        var firstRect = clientRects[0];
        var lastRect = clientRects[clientRects.length - 1];
        var isTop = currentBasePlacement === 'top';
        var top = firstRect.top;
        var bottom = lastRect.bottom;
        var left = isTop ? firstRect.left : lastRect.left;
        var right = isTop ? firstRect.right : lastRect.right;
        var width = right - left;
        var height = bottom - top;
        return {
          top: top,
          bottom: bottom,
          left: left,
          right: right,
          width: width,
          height: height
        };
      }

    case 'left':
    case 'right':
      {
        var minLeft = Math.min.apply(Math, clientRects.map(function (rects) {
          return rects.left;
        }));
        var maxRight = Math.max.apply(Math, clientRects.map(function (rects) {
          return rects.right;
        }));
        var measureRects = clientRects.filter(function (rect) {
          return currentBasePlacement === 'left' ? rect.left === minLeft : rect.right === maxRight;
        });
        var _top = measureRects[0].top;
        var _bottom = measureRects[measureRects.length - 1].bottom;
        var _left = minLeft;
        var _right = maxRight;

        var _width = _right - _left;

        var _height = _bottom - _top;

        return {
          top: _top,
          bottom: _bottom,
          left: _left,
          right: _right,
          width: _width,
          height: _height
        };
      }

    default:
      {
        return boundingRect;
      }
  }
}

var sticky = {
  name: 'sticky',
  defaultValue: false,
  fn: function fn(instance) {
    var reference = instance.reference,
        popper = instance.popper;

    function getReference() {
      return instance.popperInstance ? instance.popperInstance.state.elements.reference : reference;
    }

    function shouldCheck(value) {
      return instance.props.sticky === true || instance.props.sticky === value;
    }

    var prevRefRect = null;
    var prevPopRect = null;

    function updatePosition() {
      var currentRefRect = shouldCheck('reference') ? getReference().getBoundingClientRect() : null;
      var currentPopRect = shouldCheck('popper') ? popper.getBoundingClientRect() : null;

      if (currentRefRect && areRectsDifferent(prevRefRect, currentRefRect) || currentPopRect && areRectsDifferent(prevPopRect, currentPopRect)) {
        if (instance.popperInstance) {
          instance.popperInstance.update();
        }
      }

      prevRefRect = currentRefRect;
      prevPopRect = currentPopRect;

      if (instance.state.isMounted) {
        requestAnimationFrame(updatePosition);
      }
    }

    return {
      onMount: function onMount() {
        if (instance.props.sticky) {
          updatePosition();
        }
      }
    };
  }
};

function areRectsDifferent(rectA, rectB) {
  if (rectA && rectB) {
    return rectA.top !== rectB.top || rectA.right !== rectB.right || rectA.bottom !== rectB.bottom || rectA.left !== rectB.left;
  }

  return true;
}

tippy.setDefaultProps({
  render: render
});

exports.animateFill = animateFill;
exports.createSingleton = createSingleton;
exports.default = tippy;
exports.delegate = delegate;
exports.followCursor = followCursor;
exports.hideAll = hideAll;
exports.inlinePositioning = inlinePositioning;
exports.roundArrow = ROUND_ARROW;
exports.sticky = sticky;


}).call(this,require('_process'))
},{"@popperjs/core":16,"_process":734}],781:[function(require,module,exports){
module.exports = toArray

function toArray(list, index) {
    var array = []

    index = index || 0

    for (var i = index || 0; i < list.length; i++) {
        array[i - index] = list[i]
    }

    return array
}

},{}],782:[function(require,module,exports){
(function (global){
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global global, define, System, Reflect, Promise */
var __extends;
var __assign;
var __rest;
var __decorate;
var __param;
var __metadata;
var __awaiter;
var __generator;
var __exportStar;
var __values;
var __read;
var __spread;
var __spreadArrays;
var __spreadArray;
var __await;
var __asyncGenerator;
var __asyncDelegator;
var __asyncValues;
var __makeTemplateObject;
var __importStar;
var __importDefault;
var __classPrivateFieldGet;
var __classPrivateFieldSet;
var __createBinding;
(function (factory) {
    var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
    if (typeof define === "function" && define.amd) {
        define("tslib", ["exports"], function (exports) { factory(createExporter(root, createExporter(exports))); });
    }
    else if (typeof module === "object" && typeof module.exports === "object") {
        factory(createExporter(root, createExporter(module.exports)));
    }
    else {
        factory(createExporter(root));
    }
    function createExporter(exports, previous) {
        if (exports !== root) {
            if (typeof Object.create === "function") {
                Object.defineProperty(exports, "__esModule", { value: true });
            }
            else {
                exports.__esModule = true;
            }
        }
        return function (id, v) { return exports[id] = previous ? previous(id, v) : v; };
    }
})
(function (exporter) {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };

    __extends = function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };

    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };

    __rest = function (s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                    t[p[i]] = s[p[i]];
            }
        return t;
    };

    __decorate = function (decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };

    __param = function (paramIndex, decorator) {
        return function (target, key) { decorator(target, key, paramIndex); }
    };

    __metadata = function (metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
    };

    __awaiter = function (thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    };

    __generator = function (thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    };

    __exportStar = function(m, o) {
        for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
    };

    __createBinding = Object.create ? (function(o, m, k, k2) {
        if (k2 === undefined) k2 = k;
        Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
    }) : (function(o, m, k, k2) {
        if (k2 === undefined) k2 = k;
        o[k2] = m[k];
    });

    __values = function (o) {
        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === "number") return {
            next: function () {
                if (o && i >= o.length) o = void 0;
                return { value: o && o[i++], done: !o };
            }
        };
        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
    };

    __read = function (o, n) {
        var m = typeof Symbol === "function" && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o), r, ar = [], e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        }
        catch (error) { e = { error: error }; }
        finally {
            try {
                if (r && !r.done && (m = i["return"])) m.call(i);
            }
            finally { if (e) throw e.error; }
        }
        return ar;
    };

    /** @deprecated */
    __spread = function () {
        for (var ar = [], i = 0; i < arguments.length; i++)
            ar = ar.concat(__read(arguments[i]));
        return ar;
    };

    /** @deprecated */
    __spreadArrays = function () {
        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
        for (var r = Array(s), k = 0, i = 0; i < il; i++)
            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
                r[k] = a[j];
        return r;
    };

    __spreadArray = function (to, from, pack) {
        if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
            if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || Array.prototype.slice.call(from));
    };

    __await = function (v) {
        return this instanceof __await ? (this.v = v, this) : new __await(v);
    };

    __asyncGenerator = function (thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var g = generator.apply(thisArg, _arguments || []), i, q = [];
        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);  }
        function fulfill(value) { resume("next", value); }
        function reject(value) { resume("throw", value); }
        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
    };

    __asyncDelegator = function (o) {
        var i, p;
        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
    };

    __asyncValues = function (o) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var m = o[Symbol.asyncIterator], i;
        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
    };

    __makeTemplateObject = function (cooked, raw) {
        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
        return cooked;
    };

    var __setModuleDefault = Object.create ? (function(o, v) {
        Object.defineProperty(o, "default", { enumerable: true, value: v });
    }) : function(o, v) {
        o["default"] = v;
    };

    __importStar = function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
        __setModuleDefault(result, mod);
        return result;
    };

    __importDefault = function (mod) {
        return (mod && mod.__esModule) ? mod : { "default": mod };
    };

    __classPrivateFieldGet = function (receiver, state, kind, f) {
        if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
        if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
        return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
    };

    __classPrivateFieldSet = function (receiver, state, value, kind, f) {
        if (kind === "m") throw new TypeError("Private method is not writable");
        if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
        if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
        return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
    };

    exporter("__extends", __extends);
    exporter("__assign", __assign);
    exporter("__rest", __rest);
    exporter("__decorate", __decorate);
    exporter("__param", __param);
    exporter("__metadata", __metadata);
    exporter("__awaiter", __awaiter);
    exporter("__generator", __generator);
    exporter("__exportStar", __exportStar);
    exporter("__createBinding", __createBinding);
    exporter("__values", __values);
    exporter("__read", __read);
    exporter("__spread", __spread);
    exporter("__spreadArrays", __spreadArrays);
    exporter("__spreadArray", __spreadArray);
    exporter("__await", __await);
    exporter("__asyncGenerator", __asyncGenerator);
    exporter("__asyncDelegator", __asyncDelegator);
    exporter("__asyncValues", __asyncValues);
    exporter("__makeTemplateObject", __makeTemplateObject);
    exporter("__importStar", __importStar);
    exporter("__importDefault", __importDefault);
    exporter("__classPrivateFieldGet", __classPrivateFieldGet);
    exporter("__classPrivateFieldSet", __classPrivateFieldSet);
});

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],783:[function(require,module,exports){
!function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t(require("swiper/dist/js/swiper.js")):"function"==typeof define&&define.amd?define("VueAwesomeSwiper",["swiper"],t):"object"==typeof exports?exports.VueAwesomeSwiper=t(require("swiper/dist/js/swiper.js")):e.VueAwesomeSwiper=t(e.Swiper)}(this,function(e){return function(e){function t(i){if(n[i])return n[i].exports;var s=n[i]={i:i,l:!1,exports:{}};return e[i].call(s.exports,s,s.exports,t),s.l=!0,s.exports}var n={};return t.m=e,t.c=n,t.i=function(e){return e},t.d=function(e,n,i){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:i})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="/",t(t.s=4)}([function(t,n){t.exports=e},function(e,t){e.exports=function(e,t,n,i,s,r){var o,a=e=e||{},u=typeof e.default;"object"!==u&&"function"!==u||(o=e,a=e.default);var p="function"==typeof a?a.options:a;t&&(p.render=t.render,p.staticRenderFns=t.staticRenderFns,p._compiled=!0),n&&(p.functional=!0),s&&(p._scopeId=s);var l;if(r?(l=function(e){e=e||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext,e||"undefined"==typeof __VUE_SSR_CONTEXT__||(e=__VUE_SSR_CONTEXT__),i&&i.call(this,e),e&&e._registeredComponents&&e._registeredComponents.add(r)},p._ssrRegister=l):i&&(l=i),l){var c=p.functional,d=c?p.render:p.beforeCreate;c?(p._injectStyles=l,p.render=function(e,t){return l.call(t),d(e,t)}):p.beforeCreate=d?[].concat(d,l):[l]}return{esModule:o,exports:a,options:p}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=n(5),s=n.n(i),r=n(8),o=n(1),a=o(s.a,r.a,!1,null,null,null);t.default=a.exports},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=n(6),s=n.n(i),r=n(7),o=n(1),a=o(s.a,r.a,!1,null,null,null);t.default=a.exports},function(e,t,n){"use strict";function i(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.install=t.swiperSlide=t.swiper=t.Swiper=void 0;var s=n(0),r=i(s),o=n(2),a=i(o),u=n(3),p=i(u),l=window.Swiper||r.default,c=p.default,d=a.default,f=function(e,t){t&&(p.default.props.globalOptions.default=function(){return t}),e.component(p.default.name,p.default),e.component(a.default.name,a.default)},h={Swiper:l,swiper:c,swiperSlide:d,install:f};t.default=h,t.Swiper=l,t.swiper=c,t.swiperSlide=d,t.install=f},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default={name:"swiper-slide",data:function(){return{slideClass:"swiper-slide"}},ready:function(){this.update()},mounted:function(){this.update(),this.$parent&&this.$parent.options&&this.$parent.options.slideClass&&(this.slideClass=this.$parent.options.slideClass)},updated:function(){this.update()},attached:function(){this.update()},methods:{update:function(){this.$parent&&this.$parent.swiper&&this.$parent.update()}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=n(0),s=function(e){return e&&e.__esModule?e:{default:e}}(i),r=window.Swiper||s.default;"function"!=typeof Object.assign&&Object.defineProperty(Object,"assign",{value:function(e,t){if(null==e)throw new TypeError("Cannot convert undefined or null to object");for(var n=Object(e),i=1;i<arguments.length;i++){var s=arguments[i];if(null!=s)for(var r in s)Object.prototype.hasOwnProperty.call(s,r)&&(n[r]=s[r])}return n},writable:!0,configurable:!0});var o=["beforeDestroy","slideChange","slideChangeTransitionStart","slideChangeTransitionEnd","slideNextTransitionStart","slideNextTransitionEnd","slidePrevTransitionStart","slidePrevTransitionEnd","transitionStart","transitionEnd","touchStart","touchMove","touchMoveOpposite","sliderMove","touchEnd","click","tap","doubleTap","imagesReady","progress","reachBeginning","reachEnd","fromEdge","setTranslate","setTransition","resize"];t.default={name:"swiper",props:{options:{type:Object,default:function(){return{}}},globalOptions:{type:Object,required:!1,default:function(){return{}}}},data:function(){return{swiper:null,classes:{wrapperClass:"swiper-wrapper"}}},ready:function(){this.swiper||this.mountInstance()},mounted:function(){if(!this.swiper){var e=!1;for(var t in this.classes)this.classes.hasOwnProperty(t)&&this.options[t]&&(e=!0,this.classes[t]=this.options[t]);e?this.$nextTick(this.mountInstance):this.mountInstance()}},activated:function(){this.update()},updated:function(){this.update()},beforeDestroy:function(){this.$nextTick(function(){this.swiper&&(this.swiper.destroy&&this.swiper.destroy(),delete this.swiper)})},methods:{update:function(){this.swiper&&(this.swiper.update&&this.swiper.update(),this.swiper.navigation&&this.swiper.navigation.update(),this.swiper.pagination&&this.swiper.pagination.render(),this.swiper.pagination&&this.swiper.pagination.update())},mountInstance:function(){var e=Object.assign({},this.globalOptions,this.options);this.swiper=new r(this.$el,e),this.bindEvents(),this.$emit("ready",this.swiper)},bindEvents:function(){var e=this,t=this;o.forEach(function(n){e.swiper.on(n,function(){t.$emit.apply(t,[n].concat(Array.prototype.slice.call(arguments))),t.$emit.apply(t,[n.replace(/([A-Z])/g,"-$1").toLowerCase()].concat(Array.prototype.slice.call(arguments)))})})}}}},function(e,t,n){"use strict";var i=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"swiper-container"},[e._t("parallax-bg"),e._v(" "),n("div",{class:e.classes.wrapperClass},[e._t("default")],2),e._v(" "),e._t("pagination"),e._v(" "),e._t("button-prev"),e._v(" "),e._t("button-next"),e._v(" "),e._t("scrollbar")],2)},s=[],r={render:i,staticRenderFns:s};t.a=r},function(e,t,n){"use strict";var i=function(){var e=this,t=e.$createElement;return(e._self._c||t)("div",{class:e.slideClass},[e._t("default")],2)},s=[],r={render:i,staticRenderFns:s};t.a=r}])});
},{"swiper/dist/js/swiper.js":779}],784:[function(require,module,exports){
'use strict';

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _defineProperty = require('babel-runtime/core-js/object/define-property');

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function webpackUniversalModuleDefinition(root, factory) {
  if ((typeof exports === 'undefined' ? 'undefined' : (0, _typeof3.default)(exports)) === 'object' && (typeof module === 'undefined' ? 'undefined' : (0, _typeof3.default)(module)) === 'object') module.exports = factory(require("chart.js"));else if (typeof define === 'function' && define.amd) define("VueChartJs", ["chart.js"], factory);else if ((typeof exports === 'undefined' ? 'undefined' : (0, _typeof3.default)(exports)) === 'object') exports["VueChartJs"] = factory(require("chart.js"));else root["VueChartJs"] = factory(root["Chart"]);
})(typeof self !== 'undefined' ? self : undefined, function (__WEBPACK_EXTERNAL_MODULE_3__) {
  return (/******/function (modules) {
      // webpackBootstrap
      /******/ // The module cache
      /******/var installedModules = {};
      /******/
      /******/ // The require function
      /******/function __webpack_require__(moduleId) {
        /******/
        /******/ // Check if module is in cache
        /******/if (installedModules[moduleId]) {
          /******/return installedModules[moduleId].exports;
          /******/
        }
        /******/ // Create a new module (and put it into the cache)
        /******/var module = installedModules[moduleId] = {
          /******/i: moduleId,
          /******/l: false,
          /******/exports: {}
          /******/ };
        /******/
        /******/ // Execute the module function
        /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/
        /******/ // Flag the module as loaded
        /******/module.l = true;
        /******/
        /******/ // Return the exports of the module
        /******/return module.exports;
        /******/
      }
      /******/
      /******/
      /******/ // expose the modules object (__webpack_modules__)
      /******/__webpack_require__.m = modules;
      /******/
      /******/ // expose the module cache
      /******/__webpack_require__.c = installedModules;
      /******/
      /******/ // define getter function for harmony exports
      /******/__webpack_require__.d = function (exports, name, getter) {
        /******/if (!__webpack_require__.o(exports, name)) {
          /******/(0, _defineProperty2.default)(exports, name, {
            /******/configurable: false,
            /******/enumerable: true,
            /******/get: getter
            /******/ });
          /******/
        }
        /******/
      };
      /******/
      /******/ // getDefaultExport function for compatibility with non-harmony modules
      /******/__webpack_require__.n = function (module) {
        /******/var getter = module && module.__esModule ?
        /******/function getDefault() {
          return module['default'];
        } :
        /******/function getModuleExports() {
          return module;
        };
        /******/__webpack_require__.d(getter, 'a', getter);
        /******/return getter;
        /******/
      };
      /******/
      /******/ // Object.prototype.hasOwnProperty.call
      /******/__webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };
      /******/
      /******/ // __webpack_public_path__
      /******/__webpack_require__.p = "";
      /******/
      /******/ // Load entry module and return exports
      /******/return __webpack_require__(__webpack_require__.s = 0);
      /******/
    }(
    /************************************************************************/
    /******/[
    /* 0 */
    /***/function (module, __webpack_exports__, __webpack_require__) {

      "use strict";

      Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
      /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "VueCharts", function () {
        return VueCharts;
      });
      /* harmony import */var __WEBPACK_IMPORTED_MODULE_0__mixins_index_js__ = __webpack_require__(1);
      /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__BaseCharts__ = __webpack_require__(2);
      /* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "Bar", function () {
        return __WEBPACK_IMPORTED_MODULE_1__BaseCharts__["a"];
      });
      /* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "HorizontalBar", function () {
        return __WEBPACK_IMPORTED_MODULE_1__BaseCharts__["d"];
      });
      /* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "Doughnut", function () {
        return __WEBPACK_IMPORTED_MODULE_1__BaseCharts__["c"];
      });
      /* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "Line", function () {
        return __WEBPACK_IMPORTED_MODULE_1__BaseCharts__["e"];
      });
      /* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "Pie", function () {
        return __WEBPACK_IMPORTED_MODULE_1__BaseCharts__["f"];
      });
      /* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "PolarArea", function () {
        return __WEBPACK_IMPORTED_MODULE_1__BaseCharts__["g"];
      });
      /* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "Radar", function () {
        return __WEBPACK_IMPORTED_MODULE_1__BaseCharts__["h"];
      });
      /* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "Bubble", function () {
        return __WEBPACK_IMPORTED_MODULE_1__BaseCharts__["b"];
      });
      /* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "Scatter", function () {
        return __WEBPACK_IMPORTED_MODULE_1__BaseCharts__["i"];
      });
      /* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "mixins", function () {
        return __WEBPACK_IMPORTED_MODULE_0__mixins_index_js__["a"];
      });
      /* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "generateChart", function () {
        return __WEBPACK_IMPORTED_MODULE_1__BaseCharts__["j"];
      });

      var VueCharts = {
        Bar: __WEBPACK_IMPORTED_MODULE_1__BaseCharts__["a" /* Bar */],
        HorizontalBar: __WEBPACK_IMPORTED_MODULE_1__BaseCharts__["d" /* HorizontalBar */],
        Doughnut: __WEBPACK_IMPORTED_MODULE_1__BaseCharts__["c" /* Doughnut */],
        Line: __WEBPACK_IMPORTED_MODULE_1__BaseCharts__["e" /* Line */],
        Pie: __WEBPACK_IMPORTED_MODULE_1__BaseCharts__["f" /* Pie */],
        PolarArea: __WEBPACK_IMPORTED_MODULE_1__BaseCharts__["g" /* PolarArea */],
        Radar: __WEBPACK_IMPORTED_MODULE_1__BaseCharts__["h" /* Radar */],
        Bubble: __WEBPACK_IMPORTED_MODULE_1__BaseCharts__["b" /* Bubble */],
        Scatter: __WEBPACK_IMPORTED_MODULE_1__BaseCharts__["i" /* Scatter */],
        mixins: __WEBPACK_IMPORTED_MODULE_0__mixins_index_js__["a" /* default */],
        generateChart: __WEBPACK_IMPORTED_MODULE_1__BaseCharts__["j" /* generateChart */],
        render: function render() {
          return console.error('[vue-chartjs]: This is not a vue component. It is the whole object containing all vue components. Please import the named export or access the components over the dot notation. For more info visit https://vue-chartjs.org/#/home?id=quick-start');
        }
      };
      /* harmony default export */__webpack_exports__["default"] = VueCharts;

      /***/
    },
    /* 1 */
    /***/function (module, __webpack_exports__, __webpack_require__) {

      "use strict";
      /* unused harmony export reactiveData */
      /* unused harmony export reactiveProp */

      function dataHandler(newData, oldData) {
        if (oldData) {
          var chart = this.$data._chart;
          var newDatasetLabels = newData.datasets.map(function (dataset) {
            return dataset.label;
          });
          var oldDatasetLabels = oldData.datasets.map(function (dataset) {
            return dataset.label;
          });
          var oldLabels = (0, _stringify2.default)(oldDatasetLabels);
          var newLabels = (0, _stringify2.default)(newDatasetLabels);

          if (newLabels === oldLabels && oldData.datasets.length === newData.datasets.length) {
            newData.datasets.forEach(function (dataset, i) {
              var oldDatasetKeys = (0, _keys2.default)(oldData.datasets[i]);
              var newDatasetKeys = (0, _keys2.default)(dataset);
              var deletionKeys = oldDatasetKeys.filter(function (key) {
                return key !== '_meta' && newDatasetKeys.indexOf(key) === -1;
              });
              deletionKeys.forEach(function (deletionKey) {
                delete chart.data.datasets[i][deletionKey];
              });

              for (var attribute in dataset) {
                if (dataset.hasOwnProperty(attribute)) {
                  chart.data.datasets[i][attribute] = dataset[attribute];
                }
              }
            });

            if (newData.hasOwnProperty('labels')) {
              chart.data.labels = newData.labels;
              this.$emit('labels:update');
            }

            if (newData.hasOwnProperty('xLabels')) {
              chart.data.xLabels = newData.xLabels;
              this.$emit('xlabels:update');
            }

            if (newData.hasOwnProperty('yLabels')) {
              chart.data.yLabels = newData.yLabels;
              this.$emit('ylabels:update');
            }

            chart.update();
            this.$emit('chart:update');
          } else {
            if (chart) {
              chart.destroy();
              this.$emit('chart:destroy');
            }

            this.renderChart(this.chartData, this.options);
            this.$emit('chart:render');
          }
        } else {
          if (this.$data._chart) {
            this.$data._chart.destroy();

            this.$emit('chart:destroy');
          }

          this.renderChart(this.chartData, this.options);
          this.$emit('chart:render');
        }
      }

      var reactiveData = {
        data: function data() {
          return {
            chartData: null
          };
        },
        watch: {
          'chartData': dataHandler
        }
      };
      var reactiveProp = {
        props: {
          chartData: {
            type: Object,
            required: true,
            default: function _default() {}
          }
        },
        watch: {
          'chartData': dataHandler
        }
      };
      /* harmony default export */__webpack_exports__["a"] = {
        reactiveData: reactiveData,
        reactiveProp: reactiveProp
      };

      /***/
    },
    /* 2 */
    /***/function (module, __webpack_exports__, __webpack_require__) {

      "use strict";
      /* harmony export (immutable) */
      __webpack_exports__["j"] = generateChart;
      /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "a", function () {
        return Bar;
      });
      /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "d", function () {
        return HorizontalBar;
      });
      /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "c", function () {
        return Doughnut;
      });
      /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "e", function () {
        return Line;
      });
      /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "f", function () {
        return Pie;
      });
      /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "g", function () {
        return PolarArea;
      });
      /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "h", function () {
        return Radar;
      });
      /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "b", function () {
        return Bubble;
      });
      /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "i", function () {
        return Scatter;
      });
      /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_chart_js__ = __webpack_require__(3);
      /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chart_js__);

      function generateChart(chartId, chartType) {
        return {
          render: function render(createElement) {
            return createElement('div', {
              style: this.styles,
              class: this.cssClasses
            }, [createElement('canvas', {
              attrs: {
                id: this.chartId,
                width: this.width,
                height: this.height
              },
              ref: 'canvas'
            })]);
          },
          props: {
            chartId: {
              default: chartId,
              type: String
            },
            width: {
              default: 400,
              type: Number
            },
            height: {
              default: 400,
              type: Number
            },
            cssClasses: {
              type: String,
              default: ''
            },
            styles: {
              type: Object
            },
            plugins: {
              type: Array,
              default: function _default() {
                return [];
              }
            }
          },
          data: function data() {
            return {
              _chart: null,
              _plugins: this.plugins
            };
          },
          methods: {
            addPlugin: function addPlugin(plugin) {
              this.$data._plugins.push(plugin);
            },
            generateLegend: function generateLegend() {
              if (this.$data._chart) {
                return this.$data._chart.generateLegend();
              }
            },
            renderChart: function renderChart(data, options) {
              if (this.$data._chart) this.$data._chart.destroy();
              if (!this.$refs.canvas) throw new Error('Please remove the <template></template> tags from your chart component. See https://vue-chartjs.org/guide/#vue-single-file-components');
              this.$data._chart = new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(this.$refs.canvas.getContext('2d'), {
                type: chartType,
                data: data,
                options: options,
                plugins: this.$data._plugins
              });
            }
          },
          beforeDestroy: function beforeDestroy() {
            if (this.$data._chart) {
              this.$data._chart.destroy();
            }
          }
        };
      }
      var Bar = generateChart('bar-chart', 'bar');
      var HorizontalBar = generateChart('horizontalbar-chart', 'horizontalBar');
      var Doughnut = generateChart('doughnut-chart', 'doughnut');
      var Line = generateChart('line-chart', 'line');
      var Pie = generateChart('pie-chart', 'pie');
      var PolarArea = generateChart('polar-chart', 'polarArea');
      var Radar = generateChart('radar-chart', 'radar');
      var Bubble = generateChart('bubble-chart', 'bubble');
      var Scatter = generateChart('scatter-chart', 'scatter');
      /* unused harmony default export */var _unused_webpack_default_export = {
        Bar: Bar,
        HorizontalBar: HorizontalBar,
        Doughnut: Doughnut,
        Line: Line,
        Pie: Pie,
        PolarArea: PolarArea,
        Radar: Radar,
        Bubble: Bubble,
        Scatter: Scatter
      };

      /***/
    },
    /* 3 */
    /***/function (module, exports) {

      module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

      /***/
    }]
    /******/)
  );
});


},{"babel-runtime/core-js/json/stringify":48,"babel-runtime/core-js/object/define-property":53,"babel-runtime/core-js/object/keys":56,"babel-runtime/helpers/typeof":72,"chart.js":82}],785:[function(require,module,exports){
var Vue // late bind
var map = Object.create(null)
var shimmed = false
var isBrowserify = false

/**
 * Determine compatibility and apply patch.
 *
 * @param {Function} vue
 * @param {Boolean} browserify
 */

exports.install = function (vue, browserify) {
  if (shimmed) return
  shimmed = true

  Vue = vue
  isBrowserify = browserify

  exports.compatible = !!Vue.internalDirectives
  if (!exports.compatible) {
    console.warn(
      '[HMR] vue-loader hot reload is only compatible with ' +
      'Vue.js 1.0.0+.'
    )
    return
  }

  // patch view directive
  patchView(Vue.internalDirectives.component)
  console.log('[HMR] Vue component hot reload shim applied.')
  // shim router-view if present
  var routerView = Vue.elementDirective('router-view')
  if (routerView) {
    patchView(routerView)
    console.log('[HMR] vue-router <router-view> hot reload shim applied.')
  }
}

/**
 * Shim the view directive (component or router-view).
 *
 * @param {Object} View
 */

function patchView (View) {
  var unbuild = View.unbuild
  View.unbuild = function (defer) {
    if (!this.hotUpdating) {
      var prevComponent = this.childVM && this.childVM.constructor
      removeView(prevComponent, this)
      // defer = true means we are transitioning to a new
      // Component. Register this new component to the list.
      if (defer) {
        addView(this.Component, this)
      }
    }
    // call original
    return unbuild.call(this, defer)
  }
}

/**
 * Add a component view to a Component's hot list
 *
 * @param {Function} Component
 * @param {Directive} view - view directive instance
 */

function addView (Component, view) {
  var id = Component && Component.options.hotID
  if (id) {
    if (!map[id]) {
      map[id] = {
        Component: Component,
        views: [],
        instances: []
      }
    }
    map[id].views.push(view)
  }
}

/**
 * Remove a component view from a Component's hot list
 *
 * @param {Function} Component
 * @param {Directive} view - view directive instance
 */

function removeView (Component, view) {
  var id = Component && Component.options.hotID
  if (id) {
    map[id].views.$remove(view)
  }
}

/**
 * Create a record for a hot module, which keeps track of its construcotr,
 * instnaces and views (component directives or router-views).
 *
 * @param {String} id
 * @param {Object} options
 */

exports.createRecord = function (id, options) {
  if (typeof options === 'function') {
    options = options.options
  }
  if (typeof options.el !== 'string' && typeof options.data !== 'object') {
    makeOptionsHot(id, options)
    map[id] = {
      Component: null,
      views: [],
      instances: []
    }
  }
}

/**
 * Make a Component options object hot.
 *
 * @param {String} id
 * @param {Object} options
 */

function makeOptionsHot (id, options) {
  options.hotID = id
  injectHook(options, 'created', function () {
    var record = map[id]
    if (!record.Component) {
      record.Component = this.constructor
    }
    record.instances.push(this)
  })
  injectHook(options, 'beforeDestroy', function () {
    map[id].instances.$remove(this)
  })
}

/**
 * Inject a hook to a hot reloadable component so that
 * we can keep track of it.
 *
 * @param {Object} options
 * @param {String} name
 * @param {Function} hook
 */

function injectHook (options, name, hook) {
  var existing = options[name]
  options[name] = existing
    ? Array.isArray(existing)
      ? existing.concat(hook)
      : [existing, hook]
    : [hook]
}

/**
 * Update a hot component.
 *
 * @param {String} id
 * @param {Object|null} newOptions
 * @param {String|null} newTemplate
 */

exports.update = function (id, newOptions, newTemplate) {
  var record = map[id]
  // force full-reload if an instance of the component is active but is not
  // managed by a view
  if (!record || (record.instances.length && !record.views.length)) {
    console.log('[HMR] Root or manually-mounted instance modified. Full reload may be required.')
    if (!isBrowserify) {
      window.location.reload()
    } else {
      // browserify-hmr somehow sends incomplete bundle if we reload here
      return
    }
  }
  if (!isBrowserify) {
    // browserify-hmr already logs this
    console.log('[HMR] Updating component: ' + format(id))
  }
  var Component = record.Component
  // update constructor
  if (newOptions) {
    // in case the user exports a constructor
    Component = record.Component = typeof newOptions === 'function'
      ? newOptions
      : Vue.extend(newOptions)
    makeOptionsHot(id, Component.options)
  }
  if (newTemplate) {
    Component.options.template = newTemplate
  }
  // handle recursive lookup
  if (Component.options.name) {
    Component.options.components[Component.options.name] = Component
  }
  // reset constructor cached linker
  Component.linker = null
  // reload all views
  record.views.forEach(function (view) {
    updateView(view, Component)
  })
  // flush devtools
  if (window.__VUE_DEVTOOLS_GLOBAL_HOOK__) {
    window.__VUE_DEVTOOLS_GLOBAL_HOOK__.emit('flush')
  }
}

/**
 * Update a component view instance
 *
 * @param {Directive} view
 * @param {Function} Component
 */

function updateView (view, Component) {
  if (!view._bound) {
    return
  }
  view.Component = Component
  view.hotUpdating = true
  // disable transitions
  view.vm._isCompiled = false
  // save state
  var state = extractState(view.childVM)
  // remount, make sure to disable keep-alive
  var keepAlive = view.keepAlive
  view.keepAlive = false
  view.mountComponent()
  view.keepAlive = keepAlive
  // restore state
  restoreState(view.childVM, state, true)
  // re-eanble transitions
  view.vm._isCompiled = true
  view.hotUpdating = false
}

/**
 * Extract state from a Vue instance.
 *
 * @param {Vue} vm
 * @return {Object}
 */

function extractState (vm) {
  return {
    cid: vm.constructor.cid,
    data: vm.$data,
    children: vm.$children.map(extractState)
  }
}

/**
 * Restore state to a reloaded Vue instance.
 *
 * @param {Vue} vm
 * @param {Object} state
 */

function restoreState (vm, state, isRoot) {
  var oldAsyncConfig
  if (isRoot) {
    // set Vue into sync mode during state rehydration
    oldAsyncConfig = Vue.config.async
    Vue.config.async = false
  }
  // actual restore
  if (isRoot || !vm._props) {
    vm.$data = state.data
  } else {
    Object.keys(state.data).forEach(function (key) {
      if (!vm._props[key]) {
        // for non-root, only restore non-props fields
        vm.$data[key] = state.data[key]
      }
    })
  }
  // verify child consistency
  var hasSameChildren = vm.$children.every(function (c, i) {
    return state.children[i] && state.children[i].cid === c.constructor.cid
  })
  if (hasSameChildren) {
    // rehydrate children
    vm.$children.forEach(function (c, i) {
      restoreState(c, state.children[i])
    })
  }
  if (isRoot) {
    Vue.config.async = oldAsyncConfig
  }
}

function format (id) {
  var match = id.match(/[^\/]+\.vue$/)
  return match ? match[0] : id
}

},{}],786:[function(require,module,exports){
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["vue-js-toggle-button"] = factory();
	else
		root["vue-js-toggle-button"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(8)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(1),
  /* template */
  __webpack_require__(7),
  /* scopeId */
  "data-v-25adc6c0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(3);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var DEFAULT_COLOR_CHECKED = '#75c791';
var DEFAULT_COLOR_UNCHECKED = '#bfcbd9';
var DEFAULT_LABEL_CHECKED = 'on';
var DEFAULT_LABEL_UNCHECKED = 'off';
var DEFAULT_SWITCH_COLOR = '#fff';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ToggleButton',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    name: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tag: {
      type: String
    },
    sync: {
      type: Boolean,
      default: false
    },
    speed: {
      type: Number,
      default: 300
    },
    color: {
      type: [String, Object],
      validator: function validator(value) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* isString */])(value) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* has */])(value, 'checked') || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* has */])(value, 'unchecked') || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* has */])(value, 'disabled');
      }
    },
    switchColor: {
      type: [String, Object],
      validator: function validator(value) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* isString */])(value) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* has */])(value, 'checked') || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* has */])(value, 'unchecked');
      }
    },
    cssColors: {
      type: Boolean,
      default: false
    },
    labels: {
      type: [Boolean, Object],
      default: false,
      validator: function validator(value) {
        return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' ? value.checked || value.unchecked : typeof value === 'boolean';
      }
    },
    height: {
      type: Number,
      default: 22
    },
    width: {
      type: Number,
      default: 50
    },
    margin: {
      type: Number,
      default: 3
    },
    fontSize: {
      type: Number
    }
  },
  computed: {
    className: function className() {
      var toggled = this.toggled,
          disabled = this.disabled;


      return ['vue-js-switch', {
        toggled: toggled,
        disabled: disabled
      }];
    },
    coreStyle: function coreStyle() {
      return {
        width: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* px */])(this.width),
        height: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* px */])(this.height),
        backgroundColor: this.cssColors ? null : this.disabled ? this.colorDisabled : this.colorCurrent,
        borderRadius: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* px */])(Math.round(this.height / 2))
      };
    },
    buttonRadius: function buttonRadius() {
      return this.height - this.margin * 2;
    },
    distance: function distance() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* px */])(this.width - this.height + this.margin);
    },
    buttonStyle: function buttonStyle() {
      var transition = 'transform ' + this.speed + 'ms';
      var margin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* px */])(this.margin);

      var transform = this.toggled ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* translate3d */])(this.distance, margin) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* translate3d */])(margin, margin);

      var background = this.switchColor ? this.switchColorCurrent : null;

      return {
        width: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* px */])(this.buttonRadius),
        height: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* px */])(this.buttonRadius),
        transition: transition,
        transform: transform,
        background: background
      };
    },
    labelStyle: function labelStyle() {
      return {
        lineHeight: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* px */])(this.height),
        fontSize: this.fontSize ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* px */])(this.fontSize) : null
      };
    },
    colorChecked: function colorChecked() {
      var color = this.color;


      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["e" /* isObject */])(color)) {
        return color || DEFAULT_COLOR_CHECKED;
      }

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["f" /* get */])(color, 'checked', DEFAULT_COLOR_CHECKED);
    },
    colorUnchecked: function colorUnchecked() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["f" /* get */])(this.color, 'unchecked', DEFAULT_COLOR_UNCHECKED);
    },
    colorDisabled: function colorDisabled() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["f" /* get */])(this.color, 'disabled', this.colorCurrent);
    },
    colorCurrent: function colorCurrent() {
      return this.toggled ? this.colorChecked : this.colorUnchecked;
    },
    labelChecked: function labelChecked() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["f" /* get */])(this.labels, 'checked', DEFAULT_LABEL_CHECKED);
    },
    labelUnchecked: function labelUnchecked() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["f" /* get */])(this.labels, 'unchecked', DEFAULT_LABEL_UNCHECKED);
    },
    switchColorChecked: function switchColorChecked() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["f" /* get */])(this.switchColor, 'checked', DEFAULT_SWITCH_COLOR);
    },
    switchColorUnchecked: function switchColorUnchecked() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["f" /* get */])(this.switchColor, 'unchecked', DEFAULT_SWITCH_COLOR);
    },
    switchColorCurrent: function switchColorCurrent() {
      var switchColor = this.switchColor;


      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["e" /* isObject */])(this.switchColor)) {
        return this.switchColor || DEFAULT_SWITCH_COLOR;
      }

      return this.toggled ? this.switchColorChecked : this.switchColorUnchecked;
    }
  },
  watch: {
    value: function value(_value) {
      if (this.sync) {
        this.toggled = !!_value;
      }
    }
  },
  data: function data() {
    return {
      toggled: !!this.value
    };
  },

  methods: {
    toggle: function toggle(event) {
      var toggled = !this.toggled;

      if (!this.sync) {
        this.toggled = toggled;
      }

      this.$emit('input', toggled);
      this.$emit('change', {
        value: toggled,
        tag: this.tag,
        srcEvent: event
      });
    }
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Button_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Button_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Button_vue__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ToggleButton", function() { return __WEBPACK_IMPORTED_MODULE_0__Button_vue___default.a; });


var installed = false;

/* harmony default export */ __webpack_exports__["default"] = ({
  install: function install(Vue) {
    if (installed) {
      return;
    }

    Vue.component('ToggleButton', __WEBPACK_IMPORTED_MODULE_0__Button_vue___default.a);
    installed = true;
  }
});



/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isString; });
/* unused harmony export isBoolean */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return has; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return get; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return px; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return translate3d; });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isString = function isString(value) {
  return typeof value === 'string';
};

var isBoolean = function isBoolean(value) {
  return typeof value === 'boolean';
};

var isObject = function isObject(value) {
  return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object';
};

var has = function has(object, key) {
  return isObject(object) && object.hasOwnProperty(key);
};

var get = function get(object, key, defaultValue) {
  return has(object, key) ? object[key] : defaultValue;
};

var px = function px(value) {
  return value + 'px';
};

var translate3d = function translate3d(x, y) {
  var z = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '0px';

  return 'translate3d(' + x + ', ' + y + ', ' + z + ')';
};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, ".vue-js-switch[data-v-25adc6c0]{display:inline-block;position:relative;vertical-align:middle;user-select:none;font-size:10px;cursor:pointer}.vue-js-switch .v-switch-input[data-v-25adc6c0]{opacity:0;position:absolute;width:1px;height:1px}.vue-js-switch .v-switch-label[data-v-25adc6c0]{position:absolute;top:0;font-weight:600;color:#fff;z-index:1}.vue-js-switch .v-switch-label.v-left[data-v-25adc6c0]{left:10px}.vue-js-switch .v-switch-label.v-right[data-v-25adc6c0]{right:10px}.vue-js-switch .v-switch-core[data-v-25adc6c0]{display:block;position:relative;box-sizing:border-box;outline:0;margin:0;transition:border-color .3s,background-color .3s;user-select:none}.vue-js-switch .v-switch-core .v-switch-button[data-v-25adc6c0]{display:block;position:absolute;overflow:hidden;top:0;left:0;border-radius:100%;background-color:#fff;z-index:2}.vue-js-switch.disabled[data-v-25adc6c0]{pointer-events:none;opacity:.6}", ""]);

// exports


/***/ }),
/* 5 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function() {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};


/***/ }),
/* 6 */
/***/ (function(module, exports) {

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  scopeId,
  cssModules
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  // inject cssModules
  if (cssModules) {
    var computed = Object.create(options.computed || null)
    Object.keys(cssModules).forEach(function (key) {
      var module = cssModules[key]
      computed[key] = function () { return module }
    })
    options.computed = computed
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    class: _vm.className
  }, [_c('input', {
    staticClass: "v-switch-input",
    attrs: {
      "type": "checkbox",
      "name": _vm.name,
      "disabled": _vm.disabled
    },
    domProps: {
      "checked": _vm.value
    },
    on: {
      "change": function($event) {
        $event.stopPropagation();
        return _vm.toggle($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "v-switch-core",
    style: (_vm.coreStyle)
  }, [_c('div', {
    staticClass: "v-switch-button",
    style: (_vm.buttonStyle)
  })]), _vm._v(" "), (_vm.labels) ? [(_vm.toggled) ? _c('span', {
    staticClass: "v-switch-label v-left",
    style: (_vm.labelStyle)
  }, [_vm._t("checked", [
    [_vm._v(_vm._s(_vm.labelChecked))]
  ])], 2) : _c('span', {
    staticClass: "v-switch-label v-right",
    style: (_vm.labelStyle)
  }, [_vm._t("unchecked", [
    [_vm._v(_vm._s(_vm.labelUnchecked))]
  ])], 2)] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("2283861f", content, true);

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(10)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction) {
  isProduction = _isProduction

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[data-vue-ssr-id~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 10 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ })
/******/ ]);
});

},{}],787:[function(require,module,exports){
!function(t,e){"object"==typeof exports&&"object"==typeof module?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.VueMultiselect=e():t.VueMultiselect=e()}(this,function(){return function(t){function e(i){if(n[i])return n[i].exports;var r=n[i]={i:i,l:!1,exports:{}};return t[i].call(r.exports,r,r.exports,e),r.l=!0,r.exports}var n={};return e.m=t,e.c=n,e.i=function(t){return t},e.d=function(t,n,i){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:i})},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="/",e(e.s=60)}([function(t,e){var n=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=n)},function(t,e,n){var i=n(49)("wks"),r=n(30),o=n(0).Symbol,s="function"==typeof o;(t.exports=function(t){return i[t]||(i[t]=s&&o[t]||(s?o:r)("Symbol."+t))}).store=i},function(t,e,n){var i=n(5);t.exports=function(t){if(!i(t))throw TypeError(t+" is not an object!");return t}},function(t,e,n){var i=n(0),r=n(10),o=n(8),s=n(6),u=n(11),a=function(t,e,n){var l,c,f,p,h=t&a.F,d=t&a.G,v=t&a.S,g=t&a.P,y=t&a.B,m=d?i:v?i[e]||(i[e]={}):(i[e]||{}).prototype,b=d?r:r[e]||(r[e]={}),_=b.prototype||(b.prototype={});d&&(n=e);for(l in n)c=!h&&m&&void 0!==m[l],f=(c?m:n)[l],p=y&&c?u(f,i):g&&"function"==typeof f?u(Function.call,f):f,m&&s(m,l,f,t&a.U),b[l]!=f&&o(b,l,p),g&&_[l]!=f&&(_[l]=f)};i.core=r,a.F=1,a.G=2,a.S=4,a.P=8,a.B=16,a.W=32,a.U=64,a.R=128,t.exports=a},function(t,e,n){t.exports=!n(7)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,e){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,e,n){var i=n(0),r=n(8),o=n(12),s=n(30)("src"),u=Function.toString,a=(""+u).split("toString");n(10).inspectSource=function(t){return u.call(t)},(t.exports=function(t,e,n,u){var l="function"==typeof n;l&&(o(n,"name")||r(n,"name",e)),t[e]!==n&&(l&&(o(n,s)||r(n,s,t[e]?""+t[e]:a.join(String(e)))),t===i?t[e]=n:u?t[e]?t[e]=n:r(t,e,n):(delete t[e],r(t,e,n)))})(Function.prototype,"toString",function(){return"function"==typeof this&&this[s]||u.call(this)})},function(t,e){t.exports=function(t){try{return!!t()}catch(t){return!0}}},function(t,e,n){var i=n(13),r=n(25);t.exports=n(4)?function(t,e,n){return i.f(t,e,r(1,n))}:function(t,e,n){return t[e]=n,t}},function(t,e){var n={}.toString;t.exports=function(t){return n.call(t).slice(8,-1)}},function(t,e){var n=t.exports={version:"2.5.7"};"number"==typeof __e&&(__e=n)},function(t,e,n){var i=n(14);t.exports=function(t,e,n){if(i(t),void 0===e)return t;switch(n){case 1:return function(n){return t.call(e,n)};case 2:return function(n,i){return t.call(e,n,i)};case 3:return function(n,i,r){return t.call(e,n,i,r)}}return function(){return t.apply(e,arguments)}}},function(t,e){var n={}.hasOwnProperty;t.exports=function(t,e){return n.call(t,e)}},function(t,e,n){var i=n(2),r=n(41),o=n(29),s=Object.defineProperty;e.f=n(4)?Object.defineProperty:function(t,e,n){if(i(t),e=o(e,!0),i(n),r)try{return s(t,e,n)}catch(t){}if("get"in n||"set"in n)throw TypeError("Accessors not supported!");return"value"in n&&(t[e]=n.value),t}},function(t,e){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,e){t.exports={}},function(t,e){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,e,n){"use strict";var i=n(7);t.exports=function(t,e){return!!t&&i(function(){e?t.call(null,function(){},1):t.call(null)})}},function(t,e,n){var i=n(23),r=n(16);t.exports=function(t){return i(r(t))}},function(t,e,n){var i=n(53),r=Math.min;t.exports=function(t){return t>0?r(i(t),9007199254740991):0}},function(t,e,n){var i=n(11),r=n(23),o=n(28),s=n(19),u=n(64);t.exports=function(t,e){var n=1==t,a=2==t,l=3==t,c=4==t,f=6==t,p=5==t||f,h=e||u;return function(e,u,d){for(var v,g,y=o(e),m=r(y),b=i(u,d,3),_=s(m.length),x=0,w=n?h(e,_):a?h(e,0):void 0;_>x;x++)if((p||x in m)&&(v=m[x],g=b(v,x,y),t))if(n)w[x]=g;else if(g)switch(t){case 3:return!0;case 5:return v;case 6:return x;case 2:w.push(v)}else if(c)return!1;return f?-1:l||c?c:w}}},function(t,e,n){var i=n(5),r=n(0).document,o=i(r)&&i(r.createElement);t.exports=function(t){return o?r.createElement(t):{}}},function(t,e){t.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")},function(t,e,n){var i=n(9);t.exports=Object("z").propertyIsEnumerable(0)?Object:function(t){return"String"==i(t)?t.split(""):Object(t)}},function(t,e){t.exports=!1},function(t,e){t.exports=function(t,e){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}}},function(t,e,n){var i=n(13).f,r=n(12),o=n(1)("toStringTag");t.exports=function(t,e,n){t&&!r(t=n?t:t.prototype,o)&&i(t,o,{configurable:!0,value:e})}},function(t,e,n){var i=n(49)("keys"),r=n(30);t.exports=function(t){return i[t]||(i[t]=r(t))}},function(t,e,n){var i=n(16);t.exports=function(t){return Object(i(t))}},function(t,e,n){var i=n(5);t.exports=function(t,e){if(!i(t))return t;var n,r;if(e&&"function"==typeof(n=t.toString)&&!i(r=n.call(t)))return r;if("function"==typeof(n=t.valueOf)&&!i(r=n.call(t)))return r;if(!e&&"function"==typeof(n=t.toString)&&!i(r=n.call(t)))return r;throw TypeError("Can't convert object to primitive value")}},function(t,e){var n=0,i=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++n+i).toString(36))}},function(t,e,n){"use strict";var i=n(0),r=n(12),o=n(9),s=n(67),u=n(29),a=n(7),l=n(77).f,c=n(45).f,f=n(13).f,p=n(51).trim,h=i.Number,d=h,v=h.prototype,g="Number"==o(n(44)(v)),y="trim"in String.prototype,m=function(t){var e=u(t,!1);if("string"==typeof e&&e.length>2){e=y?e.trim():p(e,3);var n,i,r,o=e.charCodeAt(0);if(43===o||45===o){if(88===(n=e.charCodeAt(2))||120===n)return NaN}else if(48===o){switch(e.charCodeAt(1)){case 66:case 98:i=2,r=49;break;case 79:case 111:i=8,r=55;break;default:return+e}for(var s,a=e.slice(2),l=0,c=a.length;l<c;l++)if((s=a.charCodeAt(l))<48||s>r)return NaN;return parseInt(a,i)}}return+e};if(!h(" 0o1")||!h("0b1")||h("+0x1")){h=function(t){var e=arguments.length<1?0:t,n=this;return n instanceof h&&(g?a(function(){v.valueOf.call(n)}):"Number"!=o(n))?s(new d(m(e)),n,h):m(e)};for(var b,_=n(4)?l(d):"MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(","),x=0;_.length>x;x++)r(d,b=_[x])&&!r(h,b)&&f(h,b,c(d,b));h.prototype=v,v.constructor=h,n(6)(i,"Number",h)}},function(t,e,n){"use strict";function i(t){return 0!==t&&(!(!Array.isArray(t)||0!==t.length)||!t)}function r(t){return function(){return!t.apply(void 0,arguments)}}function o(t,e){return void 0===t&&(t="undefined"),null===t&&(t="null"),!1===t&&(t="false"),-1!==t.toString().toLowerCase().indexOf(e.trim())}function s(t,e,n,i){return t.filter(function(t){return o(i(t,n),e)})}function u(t){return t.filter(function(t){return!t.$isLabel})}function a(t,e){return function(n){return n.reduce(function(n,i){return i[t]&&i[t].length?(n.push({$groupLabel:i[e],$isLabel:!0}),n.concat(i[t])):n},[])}}function l(t,e,i,r,o){return function(u){return u.map(function(u){var a;if(!u[i])return console.warn("Options passed to vue-multiselect do not contain groups, despite the config."),[];var l=s(u[i],t,e,o);return l.length?(a={},n.i(d.a)(a,r,u[r]),n.i(d.a)(a,i,l),a):[]})}}var c=n(59),f=n(54),p=(n.n(f),n(95)),h=(n.n(p),n(31)),d=(n.n(h),n(58)),v=n(91),g=(n.n(v),n(98)),y=(n.n(g),n(92)),m=(n.n(y),n(88)),b=(n.n(m),n(97)),_=(n.n(b),n(89)),x=(n.n(_),n(96)),w=(n.n(x),n(93)),S=(n.n(w),n(90)),O=(n.n(S),function(){for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return function(t){return e.reduce(function(t,e){return e(t)},t)}});e.a={data:function(){return{search:"",isOpen:!1,preferredOpenDirection:"below",optimizedHeight:this.maxHeight}},props:{internalSearch:{type:Boolean,default:!0},options:{type:Array,required:!0},multiple:{type:Boolean,default:!1},value:{type:null,default:function(){return[]}},trackBy:{type:String},label:{type:String},searchable:{type:Boolean,default:!0},clearOnSelect:{type:Boolean,default:!0},hideSelected:{type:Boolean,default:!1},placeholder:{type:String,default:"Select option"},allowEmpty:{type:Boolean,default:!0},resetAfter:{type:Boolean,default:!1},closeOnSelect:{type:Boolean,default:!0},customLabel:{type:Function,default:function(t,e){return i(t)?"":e?t[e]:t}},taggable:{type:Boolean,default:!1},tagPlaceholder:{type:String,default:"Press enter to create a tag"},tagPosition:{type:String,default:"top"},max:{type:[Number,Boolean],default:!1},id:{default:null},optionsLimit:{type:Number,default:1e3},groupValues:{type:String},groupLabel:{type:String},groupSelect:{type:Boolean,default:!1},blockKeys:{type:Array,default:function(){return[]}},preserveSearch:{type:Boolean,default:!1},preselectFirst:{type:Boolean,default:!1}},mounted:function(){!this.multiple&&this.max&&console.warn("[Vue-Multiselect warn]: Max prop should not be used when prop Multiple equals false."),this.preselectFirst&&!this.internalValue.length&&this.options.length&&this.select(this.filteredOptions[0])},computed:{internalValue:function(){return this.value||0===this.value?Array.isArray(this.value)?this.value:[this.value]:[]},filteredOptions:function(){var t=this.search||"",e=t.toLowerCase().trim(),n=this.options.concat();return n=this.internalSearch?this.groupValues?this.filterAndFlat(n,e,this.label):s(n,e,this.label,this.customLabel):this.groupValues?a(this.groupValues,this.groupLabel)(n):n,n=this.hideSelected?n.filter(r(this.isSelected)):n,this.taggable&&e.length&&!this.isExistingOption(e)&&("bottom"===this.tagPosition?n.push({isTag:!0,label:t}):n.unshift({isTag:!0,label:t})),n.slice(0,this.optionsLimit)},valueKeys:function(){var t=this;return this.trackBy?this.internalValue.map(function(e){return e[t.trackBy]}):this.internalValue},optionKeys:function(){var t=this;return(this.groupValues?this.flatAndStrip(this.options):this.options).map(function(e){return t.customLabel(e,t.label).toString().toLowerCase()})},currentOptionLabel:function(){return this.multiple?this.searchable?"":this.placeholder:this.internalValue.length?this.getOptionLabel(this.internalValue[0]):this.searchable?"":this.placeholder}},watch:{internalValue:function(){this.resetAfter&&this.internalValue.length&&(this.search="",this.$emit("input",this.multiple?[]:null))},search:function(){this.$emit("search-change",this.search,this.id)}},methods:{getValue:function(){return this.multiple?this.internalValue:0===this.internalValue.length?null:this.internalValue[0]},filterAndFlat:function(t,e,n){return O(l(e,n,this.groupValues,this.groupLabel,this.customLabel),a(this.groupValues,this.groupLabel))(t)},flatAndStrip:function(t){return O(a(this.groupValues,this.groupLabel),u)(t)},updateSearch:function(t){this.search=t},isExistingOption:function(t){return!!this.options&&this.optionKeys.indexOf(t)>-1},isSelected:function(t){var e=this.trackBy?t[this.trackBy]:t;return this.valueKeys.indexOf(e)>-1},isOptionDisabled:function(t){return!!t.$isDisabled},getOptionLabel:function(t){if(i(t))return"";if(t.isTag)return t.label;if(t.$isLabel)return t.$groupLabel;var e=this.customLabel(t,this.label);return i(e)?"":e},select:function(t,e){if(t.$isLabel&&this.groupSelect)return void this.selectGroup(t);if(!(-1!==this.blockKeys.indexOf(e)||this.disabled||t.$isDisabled||t.$isLabel)&&(!this.max||!this.multiple||this.internalValue.length!==this.max)&&("Tab"!==e||this.pointerDirty)){if(t.isTag)this.$emit("tag",t.label,this.id),this.search="",this.closeOnSelect&&!this.multiple&&this.deactivate();else{if(this.isSelected(t))return void("Tab"!==e&&this.removeElement(t));this.$emit("select",t,this.id),this.multiple?this.$emit("input",this.internalValue.concat([t]),this.id):this.$emit("input",t,this.id),this.clearOnSelect&&(this.search="")}this.closeOnSelect&&this.deactivate()}},selectGroup:function(t){var e=this,n=this.options.find(function(n){return n[e.groupLabel]===t.$groupLabel});if(n)if(this.wholeGroupSelected(n)){this.$emit("remove",n[this.groupValues],this.id);var i=this.internalValue.filter(function(t){return-1===n[e.groupValues].indexOf(t)});this.$emit("input",i,this.id)}else{var r=n[this.groupValues].filter(function(t){return!(e.isOptionDisabled(t)||e.isSelected(t))});this.$emit("select",r,this.id),this.$emit("input",this.internalValue.concat(r),this.id)}},wholeGroupSelected:function(t){var e=this;return t[this.groupValues].every(function(t){return e.isSelected(t)||e.isOptionDisabled(t)})},wholeGroupDisabled:function(t){return t[this.groupValues].every(this.isOptionDisabled)},removeElement:function(t){var e=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];if(!this.disabled&&!t.$isDisabled){if(!this.allowEmpty&&this.internalValue.length<=1)return void this.deactivate();var i="object"===n.i(c.a)(t)?this.valueKeys.indexOf(t[this.trackBy]):this.valueKeys.indexOf(t);if(this.$emit("remove",t,this.id),this.multiple){var r=this.internalValue.slice(0,i).concat(this.internalValue.slice(i+1));this.$emit("input",r,this.id)}else this.$emit("input",null,this.id);this.closeOnSelect&&e&&this.deactivate()}},removeLastElement:function(){-1===this.blockKeys.indexOf("Delete")&&0===this.search.length&&Array.isArray(this.internalValue)&&this.internalValue.length&&this.removeElement(this.internalValue[this.internalValue.length-1],!1)},activate:function(){var t=this;this.isOpen||this.disabled||(this.adjustPosition(),this.groupValues&&0===this.pointer&&this.filteredOptions.length&&(this.pointer=1),this.isOpen=!0,this.searchable?(this.preserveSearch||(this.search=""),this.$nextTick(function(){return t.$refs.search.focus()})):this.$el.focus(),this.$emit("open",this.id))},deactivate:function(){this.isOpen&&(this.isOpen=!1,this.searchable?this.$refs.search.blur():this.$el.blur(),this.preserveSearch||(this.search=""),this.$emit("close",this.getValue(),this.id))},toggle:function(){this.isOpen?this.deactivate():this.activate()},adjustPosition:function(){if("undefined"!=typeof window){var t=this.$el.getBoundingClientRect().top,e=window.innerHeight-this.$el.getBoundingClientRect().bottom;e>this.maxHeight||e>t||"below"===this.openDirection||"bottom"===this.openDirection?(this.preferredOpenDirection="below",this.optimizedHeight=Math.min(e-40,this.maxHeight)):(this.preferredOpenDirection="above",this.optimizedHeight=Math.min(t-40,this.maxHeight))}}}}},function(t,e,n){"use strict";var i=n(54),r=(n.n(i),n(31));n.n(r);e.a={data:function(){return{pointer:0,pointerDirty:!1}},props:{showPointer:{type:Boolean,default:!0},optionHeight:{type:Number,default:40}},computed:{pointerPosition:function(){return this.pointer*this.optionHeight},visibleElements:function(){return this.optimizedHeight/this.optionHeight}},watch:{filteredOptions:function(){this.pointerAdjust()},isOpen:function(){this.pointerDirty=!1}},methods:{optionHighlight:function(t,e){return{"multiselect__option--highlight":t===this.pointer&&this.showPointer,"multiselect__option--selected":this.isSelected(e)}},groupHighlight:function(t,e){var n=this;if(!this.groupSelect)return["multiselect__option--group","multiselect__option--disabled"];var i=this.options.find(function(t){return t[n.groupLabel]===e.$groupLabel});return i&&!this.wholeGroupDisabled(i)?["multiselect__option--group",{"multiselect__option--highlight":t===this.pointer&&this.showPointer},{"multiselect__option--group-selected":this.wholeGroupSelected(i)}]:"multiselect__option--disabled"},addPointerElement:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"Enter",e=t.key;this.filteredOptions.length>0&&this.select(this.filteredOptions[this.pointer],e),this.pointerReset()},pointerForward:function(){this.pointer<this.filteredOptions.length-1&&(this.pointer++,this.$refs.list.scrollTop<=this.pointerPosition-(this.visibleElements-1)*this.optionHeight&&(this.$refs.list.scrollTop=this.pointerPosition-(this.visibleElements-1)*this.optionHeight),this.filteredOptions[this.pointer]&&this.filteredOptions[this.pointer].$isLabel&&!this.groupSelect&&this.pointerForward()),this.pointerDirty=!0},pointerBackward:function(){this.pointer>0?(this.pointer--,this.$refs.list.scrollTop>=this.pointerPosition&&(this.$refs.list.scrollTop=this.pointerPosition),this.filteredOptions[this.pointer]&&this.filteredOptions[this.pointer].$isLabel&&!this.groupSelect&&this.pointerBackward()):this.filteredOptions[this.pointer]&&this.filteredOptions[0].$isLabel&&!this.groupSelect&&this.pointerForward(),this.pointerDirty=!0},pointerReset:function(){this.closeOnSelect&&(this.pointer=0,this.$refs.list&&(this.$refs.list.scrollTop=0))},pointerAdjust:function(){this.pointer>=this.filteredOptions.length-1&&(this.pointer=this.filteredOptions.length?this.filteredOptions.length-1:0),this.filteredOptions.length>0&&this.filteredOptions[this.pointer].$isLabel&&!this.groupSelect&&this.pointerForward()},pointerSet:function(t){this.pointer=t,this.pointerDirty=!0}}}},function(t,e,n){"use strict";var i=n(36),r=n(74),o=n(15),s=n(18);t.exports=n(72)(Array,"Array",function(t,e){this._t=s(t),this._i=0,this._k=e},function(){var t=this._t,e=this._k,n=this._i++;return!t||n>=t.length?(this._t=void 0,r(1)):"keys"==e?r(0,n):"values"==e?r(0,t[n]):r(0,[n,t[n]])},"values"),o.Arguments=o.Array,i("keys"),i("values"),i("entries")},function(t,e,n){"use strict";var i=n(31),r=(n.n(i),n(32)),o=n(33);e.a={name:"vue-multiselect",mixins:[r.a,o.a],props:{name:{type:String,default:""},selectLabel:{type:String,default:"Press enter to select"},selectGroupLabel:{type:String,default:"Press enter to select group"},selectedLabel:{type:String,default:"Selected"},deselectLabel:{type:String,default:"Press enter to remove"},deselectGroupLabel:{type:String,default:"Press enter to deselect group"},showLabels:{type:Boolean,default:!0},limit:{type:Number,default:99999},maxHeight:{type:Number,default:300},limitText:{type:Function,default:function(t){return"and ".concat(t," more")}},loading:{type:Boolean,default:!1},disabled:{type:Boolean,default:!1},openDirection:{type:String,default:""},showNoOptions:{type:Boolean,default:!0},showNoResults:{type:Boolean,default:!0},tabindex:{type:Number,default:0}},computed:{isSingleLabelVisible:function(){return(this.singleValue||0===this.singleValue)&&(!this.isOpen||!this.searchable)&&!this.visibleValues.length},isPlaceholderVisible:function(){return!(this.internalValue.length||this.searchable&&this.isOpen)},visibleValues:function(){return this.multiple?this.internalValue.slice(0,this.limit):[]},singleValue:function(){return this.internalValue[0]},deselectLabelText:function(){return this.showLabels?this.deselectLabel:""},deselectGroupLabelText:function(){return this.showLabels?this.deselectGroupLabel:""},selectLabelText:function(){return this.showLabels?this.selectLabel:""},selectGroupLabelText:function(){return this.showLabels?this.selectGroupLabel:""},selectedLabelText:function(){return this.showLabels?this.selectedLabel:""},inputStyle:function(){if(this.searchable||this.multiple&&this.value&&this.value.length)return this.isOpen?{width:"100%"}:{width:"0",position:"absolute",padding:"0"}},contentStyle:function(){return this.options.length?{display:"inline-block"}:{display:"block"}},isAbove:function(){return"above"===this.openDirection||"top"===this.openDirection||"below"!==this.openDirection&&"bottom"!==this.openDirection&&"above"===this.preferredOpenDirection},showSearchInput:function(){return this.searchable&&(!this.hasSingleSelectedSlot||!this.visibleSingleValue&&0!==this.visibleSingleValue||this.isOpen)}}}},function(t,e,n){var i=n(1)("unscopables"),r=Array.prototype;void 0==r[i]&&n(8)(r,i,{}),t.exports=function(t){r[i][t]=!0}},function(t,e,n){var i=n(18),r=n(19),o=n(85);t.exports=function(t){return function(e,n,s){var u,a=i(e),l=r(a.length),c=o(s,l);if(t&&n!=n){for(;l>c;)if((u=a[c++])!=u)return!0}else for(;l>c;c++)if((t||c in a)&&a[c]===n)return t||c||0;return!t&&-1}}},function(t,e,n){var i=n(9),r=n(1)("toStringTag"),o="Arguments"==i(function(){return arguments}()),s=function(t,e){try{return t[e]}catch(t){}};t.exports=function(t){var e,n,u;return void 0===t?"Undefined":null===t?"Null":"string"==typeof(n=s(e=Object(t),r))?n:o?i(e):"Object"==(u=i(e))&&"function"==typeof e.callee?"Arguments":u}},function(t,e,n){"use strict";var i=n(2);t.exports=function(){var t=i(this),e="";return t.global&&(e+="g"),t.ignoreCase&&(e+="i"),t.multiline&&(e+="m"),t.unicode&&(e+="u"),t.sticky&&(e+="y"),e}},function(t,e,n){var i=n(0).document;t.exports=i&&i.documentElement},function(t,e,n){t.exports=!n(4)&&!n(7)(function(){return 7!=Object.defineProperty(n(21)("div"),"a",{get:function(){return 7}}).a})},function(t,e,n){var i=n(9);t.exports=Array.isArray||function(t){return"Array"==i(t)}},function(t,e,n){"use strict";function i(t){var e,n;this.promise=new t(function(t,i){if(void 0!==e||void 0!==n)throw TypeError("Bad Promise constructor");e=t,n=i}),this.resolve=r(e),this.reject=r(n)}var r=n(14);t.exports.f=function(t){return new i(t)}},function(t,e,n){var i=n(2),r=n(76),o=n(22),s=n(27)("IE_PROTO"),u=function(){},a=function(){var t,e=n(21)("iframe"),i=o.length;for(e.style.display="none",n(40).appendChild(e),e.src="javascript:",t=e.contentWindow.document,t.open(),t.write("<script>document.F=Object<\/script>"),t.close(),a=t.F;i--;)delete a.prototype[o[i]];return a()};t.exports=Object.create||function(t,e){var n;return null!==t?(u.prototype=i(t),n=new u,u.prototype=null,n[s]=t):n=a(),void 0===e?n:r(n,e)}},function(t,e,n){var i=n(79),r=n(25),o=n(18),s=n(29),u=n(12),a=n(41),l=Object.getOwnPropertyDescriptor;e.f=n(4)?l:function(t,e){if(t=o(t),e=s(e,!0),a)try{return l(t,e)}catch(t){}if(u(t,e))return r(!i.f.call(t,e),t[e])}},function(t,e,n){var i=n(12),r=n(18),o=n(37)(!1),s=n(27)("IE_PROTO");t.exports=function(t,e){var n,u=r(t),a=0,l=[];for(n in u)n!=s&&i(u,n)&&l.push(n);for(;e.length>a;)i(u,n=e[a++])&&(~o(l,n)||l.push(n));return l}},function(t,e,n){var i=n(46),r=n(22);t.exports=Object.keys||function(t){return i(t,r)}},function(t,e,n){var i=n(2),r=n(5),o=n(43);t.exports=function(t,e){if(i(t),r(e)&&e.constructor===t)return e;var n=o.f(t);return(0,n.resolve)(e),n.promise}},function(t,e,n){var i=n(10),r=n(0),o=r["__core-js_shared__"]||(r["__core-js_shared__"]={});(t.exports=function(t,e){return o[t]||(o[t]=void 0!==e?e:{})})("versions",[]).push({version:i.version,mode:n(24)?"pure":"global",copyright:"© 2018 Denis Pushkarev (zloirock.ru)"})},function(t,e,n){var i=n(2),r=n(14),o=n(1)("species");t.exports=function(t,e){var n,s=i(t).constructor;return void 0===s||void 0==(n=i(s)[o])?e:r(n)}},function(t,e,n){var i=n(3),r=n(16),o=n(7),s=n(84),u="["+s+"]",a="​",l=RegExp("^"+u+u+"*"),c=RegExp(u+u+"*$"),f=function(t,e,n){var r={},u=o(function(){return!!s[t]()||a[t]()!=a}),l=r[t]=u?e(p):s[t];n&&(r[n]=l),i(i.P+i.F*u,"String",r)},p=f.trim=function(t,e){return t=String(r(t)),1&e&&(t=t.replace(l,"")),2&e&&(t=t.replace(c,"")),t};t.exports=f},function(t,e,n){var i,r,o,s=n(11),u=n(68),a=n(40),l=n(21),c=n(0),f=c.process,p=c.setImmediate,h=c.clearImmediate,d=c.MessageChannel,v=c.Dispatch,g=0,y={},m=function(){var t=+this;if(y.hasOwnProperty(t)){var e=y[t];delete y[t],e()}},b=function(t){m.call(t.data)};p&&h||(p=function(t){for(var e=[],n=1;arguments.length>n;)e.push(arguments[n++]);return y[++g]=function(){u("function"==typeof t?t:Function(t),e)},i(g),g},h=function(t){delete y[t]},"process"==n(9)(f)?i=function(t){f.nextTick(s(m,t,1))}:v&&v.now?i=function(t){v.now(s(m,t,1))}:d?(r=new d,o=r.port2,r.port1.onmessage=b,i=s(o.postMessage,o,1)):c.addEventListener&&"function"==typeof postMessage&&!c.importScripts?(i=function(t){c.postMessage(t+"","*")},c.addEventListener("message",b,!1)):i="onreadystatechange"in l("script")?function(t){a.appendChild(l("script")).onreadystatechange=function(){a.removeChild(this),m.call(t)}}:function(t){setTimeout(s(m,t,1),0)}),t.exports={set:p,clear:h}},function(t,e){var n=Math.ceil,i=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?i:n)(t)}},function(t,e,n){"use strict";var i=n(3),r=n(20)(5),o=!0;"find"in[]&&Array(1).find(function(){o=!1}),i(i.P+i.F*o,"Array",{find:function(t){return r(this,t,arguments.length>1?arguments[1]:void 0)}}),n(36)("find")},function(t,e,n){"use strict";var i,r,o,s,u=n(24),a=n(0),l=n(11),c=n(38),f=n(3),p=n(5),h=n(14),d=n(61),v=n(66),g=n(50),y=n(52).set,m=n(75)(),b=n(43),_=n(80),x=n(86),w=n(48),S=a.TypeError,O=a.process,L=O&&O.versions,k=L&&L.v8||"",P=a.Promise,T="process"==c(O),V=function(){},E=r=b.f,A=!!function(){try{var t=P.resolve(1),e=(t.constructor={})[n(1)("species")]=function(t){t(V,V)};return(T||"function"==typeof PromiseRejectionEvent)&&t.then(V)instanceof e&&0!==k.indexOf("6.6")&&-1===x.indexOf("Chrome/66")}catch(t){}}(),C=function(t){var e;return!(!p(t)||"function"!=typeof(e=t.then))&&e},D=function(t,e){if(!t._n){t._n=!0;var n=t._c;m(function(){for(var i=t._v,r=1==t._s,o=0;n.length>o;)!function(e){var n,o,s,u=r?e.ok:e.fail,a=e.resolve,l=e.reject,c=e.domain;try{u?(r||(2==t._h&&$(t),t._h=1),!0===u?n=i:(c&&c.enter(),n=u(i),c&&(c.exit(),s=!0)),n===e.promise?l(S("Promise-chain cycle")):(o=C(n))?o.call(n,a,l):a(n)):l(i)}catch(t){c&&!s&&c.exit(),l(t)}}(n[o++]);t._c=[],t._n=!1,e&&!t._h&&j(t)})}},j=function(t){y.call(a,function(){var e,n,i,r=t._v,o=N(t);if(o&&(e=_(function(){T?O.emit("unhandledRejection",r,t):(n=a.onunhandledrejection)?n({promise:t,reason:r}):(i=a.console)&&i.error&&i.error("Unhandled promise rejection",r)}),t._h=T||N(t)?2:1),t._a=void 0,o&&e.e)throw e.v})},N=function(t){return 1!==t._h&&0===(t._a||t._c).length},$=function(t){y.call(a,function(){var e;T?O.emit("rejectionHandled",t):(e=a.onrejectionhandled)&&e({promise:t,reason:t._v})})},F=function(t){var e=this;e._d||(e._d=!0,e=e._w||e,e._v=t,e._s=2,e._a||(e._a=e._c.slice()),D(e,!0))},M=function(t){var e,n=this;if(!n._d){n._d=!0,n=n._w||n;try{if(n===t)throw S("Promise can't be resolved itself");(e=C(t))?m(function(){var i={_w:n,_d:!1};try{e.call(t,l(M,i,1),l(F,i,1))}catch(t){F.call(i,t)}}):(n._v=t,n._s=1,D(n,!1))}catch(t){F.call({_w:n,_d:!1},t)}}};A||(P=function(t){d(this,P,"Promise","_h"),h(t),i.call(this);try{t(l(M,this,1),l(F,this,1))}catch(t){F.call(this,t)}},i=function(t){this._c=[],this._a=void 0,this._s=0,this._d=!1,this._v=void 0,this._h=0,this._n=!1},i.prototype=n(81)(P.prototype,{then:function(t,e){var n=E(g(this,P));return n.ok="function"!=typeof t||t,n.fail="function"==typeof e&&e,n.domain=T?O.domain:void 0,this._c.push(n),this._a&&this._a.push(n),this._s&&D(this,!1),n.promise},catch:function(t){return this.then(void 0,t)}}),o=function(){var t=new i;this.promise=t,this.resolve=l(M,t,1),this.reject=l(F,t,1)},b.f=E=function(t){return t===P||t===s?new o(t):r(t)}),f(f.G+f.W+f.F*!A,{Promise:P}),n(26)(P,"Promise"),n(83)("Promise"),s=n(10).Promise,f(f.S+f.F*!A,"Promise",{reject:function(t){var e=E(this);return(0,e.reject)(t),e.promise}}),f(f.S+f.F*(u||!A),"Promise",{resolve:function(t){return w(u&&this===s?P:this,t)}}),f(f.S+f.F*!(A&&n(73)(function(t){P.all(t).catch(V)})),"Promise",{all:function(t){var e=this,n=E(e),i=n.resolve,r=n.reject,o=_(function(){var n=[],o=0,s=1;v(t,!1,function(t){var u=o++,a=!1;n.push(void 0),s++,e.resolve(t).then(function(t){a||(a=!0,n[u]=t,--s||i(n))},r)}),--s||i(n)});return o.e&&r(o.v),n.promise},race:function(t){var e=this,n=E(e),i=n.reject,r=_(function(){v(t,!1,function(t){e.resolve(t).then(n.resolve,i)})});return r.e&&i(r.v),n.promise}})},function(t,e,n){"use strict";var i=n(3),r=n(10),o=n(0),s=n(50),u=n(48);i(i.P+i.R,"Promise",{finally:function(t){var e=s(this,r.Promise||o.Promise),n="function"==typeof t;return this.then(n?function(n){return u(e,t()).then(function(){return n})}:t,n?function(n){return u(e,t()).then(function(){throw n})}:t)}})},function(t,e,n){"use strict";function i(t){n(99)}var r=n(35),o=n(101),s=n(100),u=i,a=s(r.a,o.a,!1,u,null,null);e.a=a.exports},function(t,e,n){"use strict";function i(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}e.a=i},function(t,e,n){"use strict";function i(t){return(i="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function r(t){return(r="function"==typeof Symbol&&"symbol"===i(Symbol.iterator)?function(t){return i(t)}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":i(t)})(t)}e.a=r},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var i=n(34),r=(n.n(i),n(55)),o=(n.n(r),n(56)),s=(n.n(o),n(57)),u=n(32),a=n(33);n.d(e,"Multiselect",function(){return s.a}),n.d(e,"multiselectMixin",function(){return u.a}),n.d(e,"pointerMixin",function(){return a.a}),e.default=s.a},function(t,e){t.exports=function(t,e,n,i){if(!(t instanceof e)||void 0!==i&&i in t)throw TypeError(n+": incorrect invocation!");return t}},function(t,e,n){var i=n(14),r=n(28),o=n(23),s=n(19);t.exports=function(t,e,n,u,a){i(e);var l=r(t),c=o(l),f=s(l.length),p=a?f-1:0,h=a?-1:1;if(n<2)for(;;){if(p in c){u=c[p],p+=h;break}if(p+=h,a?p<0:f<=p)throw TypeError("Reduce of empty array with no initial value")}for(;a?p>=0:f>p;p+=h)p in c&&(u=e(u,c[p],p,l));return u}},function(t,e,n){var i=n(5),r=n(42),o=n(1)("species");t.exports=function(t){var e;return r(t)&&(e=t.constructor,"function"!=typeof e||e!==Array&&!r(e.prototype)||(e=void 0),i(e)&&null===(e=e[o])&&(e=void 0)),void 0===e?Array:e}},function(t,e,n){var i=n(63);t.exports=function(t,e){return new(i(t))(e)}},function(t,e,n){"use strict";var i=n(8),r=n(6),o=n(7),s=n(16),u=n(1);t.exports=function(t,e,n){var a=u(t),l=n(s,a,""[t]),c=l[0],f=l[1];o(function(){var e={};return e[a]=function(){return 7},7!=""[t](e)})&&(r(String.prototype,t,c),i(RegExp.prototype,a,2==e?function(t,e){return f.call(t,this,e)}:function(t){return f.call(t,this)}))}},function(t,e,n){var i=n(11),r=n(70),o=n(69),s=n(2),u=n(19),a=n(87),l={},c={},e=t.exports=function(t,e,n,f,p){var h,d,v,g,y=p?function(){return t}:a(t),m=i(n,f,e?2:1),b=0;if("function"!=typeof y)throw TypeError(t+" is not iterable!");if(o(y)){for(h=u(t.length);h>b;b++)if((g=e?m(s(d=t[b])[0],d[1]):m(t[b]))===l||g===c)return g}else for(v=y.call(t);!(d=v.next()).done;)if((g=r(v,m,d.value,e))===l||g===c)return g};e.BREAK=l,e.RETURN=c},function(t,e,n){var i=n(5),r=n(82).set;t.exports=function(t,e,n){var o,s=e.constructor;return s!==n&&"function"==typeof s&&(o=s.prototype)!==n.prototype&&i(o)&&r&&r(t,o),t}},function(t,e){t.exports=function(t,e,n){var i=void 0===n;switch(e.length){case 0:return i?t():t.call(n);case 1:return i?t(e[0]):t.call(n,e[0]);case 2:return i?t(e[0],e[1]):t.call(n,e[0],e[1]);case 3:return i?t(e[0],e[1],e[2]):t.call(n,e[0],e[1],e[2]);case 4:return i?t(e[0],e[1],e[2],e[3]):t.call(n,e[0],e[1],e[2],e[3])}return t.apply(n,e)}},function(t,e,n){var i=n(15),r=n(1)("iterator"),o=Array.prototype;t.exports=function(t){return void 0!==t&&(i.Array===t||o[r]===t)}},function(t,e,n){var i=n(2);t.exports=function(t,e,n,r){try{return r?e(i(n)[0],n[1]):e(n)}catch(e){var o=t.return;throw void 0!==o&&i(o.call(t)),e}}},function(t,e,n){"use strict";var i=n(44),r=n(25),o=n(26),s={};n(8)(s,n(1)("iterator"),function(){return this}),t.exports=function(t,e,n){t.prototype=i(s,{next:r(1,n)}),o(t,e+" Iterator")}},function(t,e,n){"use strict";var i=n(24),r=n(3),o=n(6),s=n(8),u=n(15),a=n(71),l=n(26),c=n(78),f=n(1)("iterator"),p=!([].keys&&"next"in[].keys()),h=function(){return this};t.exports=function(t,e,n,d,v,g,y){a(n,e,d);var m,b,_,x=function(t){if(!p&&t in L)return L[t];switch(t){case"keys":case"values":return function(){return new n(this,t)}}return function(){return new n(this,t)}},w=e+" Iterator",S="values"==v,O=!1,L=t.prototype,k=L[f]||L["@@iterator"]||v&&L[v],P=k||x(v),T=v?S?x("entries"):P:void 0,V="Array"==e?L.entries||k:k;if(V&&(_=c(V.call(new t)))!==Object.prototype&&_.next&&(l(_,w,!0),i||"function"==typeof _[f]||s(_,f,h)),S&&k&&"values"!==k.name&&(O=!0,P=function(){return k.call(this)}),i&&!y||!p&&!O&&L[f]||s(L,f,P),u[e]=P,u[w]=h,v)if(m={values:S?P:x("values"),keys:g?P:x("keys"),entries:T},y)for(b in m)b in L||o(L,b,m[b]);else r(r.P+r.F*(p||O),e,m);return m}},function(t,e,n){var i=n(1)("iterator"),r=!1;try{var o=[7][i]();o.return=function(){r=!0},Array.from(o,function(){throw 2})}catch(t){}t.exports=function(t,e){if(!e&&!r)return!1;var n=!1;try{var o=[7],s=o[i]();s.next=function(){return{done:n=!0}},o[i]=function(){return s},t(o)}catch(t){}return n}},function(t,e){t.exports=function(t,e){return{value:e,done:!!t}}},function(t,e,n){var i=n(0),r=n(52).set,o=i.MutationObserver||i.WebKitMutationObserver,s=i.process,u=i.Promise,a="process"==n(9)(s);t.exports=function(){var t,e,n,l=function(){var i,r;for(a&&(i=s.domain)&&i.exit();t;){r=t.fn,t=t.next;try{r()}catch(i){throw t?n():e=void 0,i}}e=void 0,i&&i.enter()};if(a)n=function(){s.nextTick(l)};else if(!o||i.navigator&&i.navigator.standalone)if(u&&u.resolve){var c=u.resolve(void 0);n=function(){c.then(l)}}else n=function(){r.call(i,l)};else{var f=!0,p=document.createTextNode("");new o(l).observe(p,{characterData:!0}),n=function(){p.data=f=!f}}return function(i){var r={fn:i,next:void 0};e&&(e.next=r),t||(t=r,n()),e=r}}},function(t,e,n){var i=n(13),r=n(2),o=n(47);t.exports=n(4)?Object.defineProperties:function(t,e){r(t);for(var n,s=o(e),u=s.length,a=0;u>a;)i.f(t,n=s[a++],e[n]);return t}},function(t,e,n){var i=n(46),r=n(22).concat("length","prototype");e.f=Object.getOwnPropertyNames||function(t){return i(t,r)}},function(t,e,n){var i=n(12),r=n(28),o=n(27)("IE_PROTO"),s=Object.prototype;t.exports=Object.getPrototypeOf||function(t){return t=r(t),i(t,o)?t[o]:"function"==typeof t.constructor&&t instanceof t.constructor?t.constructor.prototype:t instanceof Object?s:null}},function(t,e){e.f={}.propertyIsEnumerable},function(t,e){t.exports=function(t){try{return{e:!1,v:t()}}catch(t){return{e:!0,v:t}}}},function(t,e,n){var i=n(6);t.exports=function(t,e,n){for(var r in e)i(t,r,e[r],n);return t}},function(t,e,n){var i=n(5),r=n(2),o=function(t,e){if(r(t),!i(e)&&null!==e)throw TypeError(e+": can't set as prototype!")};t.exports={set:Object.setPrototypeOf||("__proto__"in{}?function(t,e,i){try{i=n(11)(Function.call,n(45).f(Object.prototype,"__proto__").set,2),i(t,[]),e=!(t instanceof Array)}catch(t){e=!0}return function(t,n){return o(t,n),e?t.__proto__=n:i(t,n),t}}({},!1):void 0),check:o}},function(t,e,n){"use strict";var i=n(0),r=n(13),o=n(4),s=n(1)("species");t.exports=function(t){var e=i[t];o&&e&&!e[s]&&r.f(e,s,{configurable:!0,get:function(){return this}})}},function(t,e){t.exports="\t\n\v\f\r   ᠎             　\u2028\u2029\ufeff"},function(t,e,n){var i=n(53),r=Math.max,o=Math.min;t.exports=function(t,e){return t=i(t),t<0?r(t+e,0):o(t,e)}},function(t,e,n){var i=n(0),r=i.navigator;t.exports=r&&r.userAgent||""},function(t,e,n){var i=n(38),r=n(1)("iterator"),o=n(15);t.exports=n(10).getIteratorMethod=function(t){if(void 0!=t)return t[r]||t["@@iterator"]||o[i(t)]}},function(t,e,n){"use strict";var i=n(3),r=n(20)(2);i(i.P+i.F*!n(17)([].filter,!0),"Array",{filter:function(t){return r(this,t,arguments[1])}})},function(t,e,n){"use strict";var i=n(3),r=n(37)(!1),o=[].indexOf,s=!!o&&1/[1].indexOf(1,-0)<0;i(i.P+i.F*(s||!n(17)(o)),"Array",{indexOf:function(t){return s?o.apply(this,arguments)||0:r(this,t,arguments[1])}})},function(t,e,n){var i=n(3);i(i.S,"Array",{isArray:n(42)})},function(t,e,n){"use strict";var i=n(3),r=n(20)(1);i(i.P+i.F*!n(17)([].map,!0),"Array",{map:function(t){return r(this,t,arguments[1])}})},function(t,e,n){"use strict";var i=n(3),r=n(62);i(i.P+i.F*!n(17)([].reduce,!0),"Array",{reduce:function(t){return r(this,t,arguments.length,arguments[1],!1)}})},function(t,e,n){var i=Date.prototype,r=i.toString,o=i.getTime;new Date(NaN)+""!="Invalid Date"&&n(6)(i,"toString",function(){var t=o.call(this);return t===t?r.call(this):"Invalid Date"})},function(t,e,n){n(4)&&"g"!=/./g.flags&&n(13).f(RegExp.prototype,"flags",{configurable:!0,get:n(39)})},function(t,e,n){n(65)("search",1,function(t,e,n){return[function(n){"use strict";var i=t(this),r=void 0==n?void 0:n[e];return void 0!==r?r.call(n,i):new RegExp(n)[e](String(i))},n]})},function(t,e,n){"use strict";n(94);var i=n(2),r=n(39),o=n(4),s=/./.toString,u=function(t){n(6)(RegExp.prototype,"toString",t,!0)};n(7)(function(){return"/a/b"!=s.call({source:"a",flags:"b"})})?u(function(){var t=i(this);return"/".concat(t.source,"/","flags"in t?t.flags:!o&&t instanceof RegExp?r.call(t):void 0)}):"toString"!=s.name&&u(function(){return s.call(this)})},function(t,e,n){"use strict";n(51)("trim",function(t){return function(){return t(this,3)}})},function(t,e,n){for(var i=n(34),r=n(47),o=n(6),s=n(0),u=n(8),a=n(15),l=n(1),c=l("iterator"),f=l("toStringTag"),p=a.Array,h={CSSRuleList:!0,CSSStyleDeclaration:!1,CSSValueList:!1,ClientRectList:!1,DOMRectList:!1,DOMStringList:!1,DOMTokenList:!0,DataTransferItemList:!1,FileList:!1,HTMLAllCollection:!1,HTMLCollection:!1,HTMLFormElement:!1,HTMLSelectElement:!1,MediaList:!0,MimeTypeArray:!1,NamedNodeMap:!1,NodeList:!0,PaintRequestList:!1,Plugin:!1,PluginArray:!1,SVGLengthList:!1,SVGNumberList:!1,SVGPathSegList:!1,SVGPointList:!1,SVGStringList:!1,SVGTransformList:!1,SourceBufferList:!1,StyleSheetList:!0,TextTrackCueList:!1,TextTrackList:!1,TouchList:!1},d=r(h),v=0;v<d.length;v++){var g,y=d[v],m=h[y],b=s[y],_=b&&b.prototype;if(_&&(_[c]||u(_,c,p),_[f]||u(_,f,y),a[y]=p,m))for(g in i)_[g]||o(_,g,i[g],!0)}},function(t,e){},function(t,e){t.exports=function(t,e,n,i,r,o){var s,u=t=t||{},a=typeof t.default;"object"!==a&&"function"!==a||(s=t,u=t.default);var l="function"==typeof u?u.options:u;e&&(l.render=e.render,l.staticRenderFns=e.staticRenderFns,l._compiled=!0),n&&(l.functional=!0),r&&(l._scopeId=r);var c;if(o?(c=function(t){t=t||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext,t||"undefined"==typeof __VUE_SSR_CONTEXT__||(t=__VUE_SSR_CONTEXT__),i&&i.call(this,t),t&&t._registeredComponents&&t._registeredComponents.add(o)},l._ssrRegister=c):i&&(c=i),c){var f=l.functional,p=f?l.render:l.beforeCreate;f?(l._injectStyles=c,l.render=function(t,e){return c.call(e),p(t,e)}):l.beforeCreate=p?[].concat(p,c):[c]}return{esModule:s,exports:u,options:l}}},function(t,e,n){"use strict";var i=function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"multiselect",class:{"multiselect--active":t.isOpen,"multiselect--disabled":t.disabled,"multiselect--above":t.isAbove},attrs:{tabindex:t.searchable?-1:t.tabindex},on:{focus:function(e){t.activate()},blur:function(e){!t.searchable&&t.deactivate()},keydown:[function(e){return"button"in e||!t._k(e.keyCode,"down",40,e.key,["Down","ArrowDown"])?e.target!==e.currentTarget?null:(e.preventDefault(),void t.pointerForward()):null},function(e){return"button"in e||!t._k(e.keyCode,"up",38,e.key,["Up","ArrowUp"])?e.target!==e.currentTarget?null:(e.preventDefault(),void t.pointerBackward()):null}],keypress:function(e){return"button"in e||!t._k(e.keyCode,"enter",13,e.key,"Enter")||!t._k(e.keyCode,"tab",9,e.key,"Tab")?(e.stopPropagation(),e.target!==e.currentTarget?null:void t.addPointerElement(e)):null},keyup:function(e){if(!("button"in e)&&t._k(e.keyCode,"esc",27,e.key,"Escape"))return null;t.deactivate()}}},[t._t("caret",[n("div",{staticClass:"multiselect__select",on:{mousedown:function(e){e.preventDefault(),e.stopPropagation(),t.toggle()}}})],{toggle:t.toggle}),t._v(" "),t._t("clear",null,{search:t.search}),t._v(" "),n("div",{ref:"tags",staticClass:"multiselect__tags"},[t._t("selection",[n("div",{directives:[{name:"show",rawName:"v-show",value:t.visibleValues.length>0,expression:"visibleValues.length > 0"}],staticClass:"multiselect__tags-wrap"},[t._l(t.visibleValues,function(e,i){return[t._t("tag",[n("span",{key:i,staticClass:"multiselect__tag"},[n("span",{domProps:{textContent:t._s(t.getOptionLabel(e))}}),t._v(" "),n("i",{staticClass:"multiselect__tag-icon",attrs:{"aria-hidden":"true",tabindex:"1"},on:{keypress:function(n){if(!("button"in n)&&t._k(n.keyCode,"enter",13,n.key,"Enter"))return null;n.preventDefault(),t.removeElement(e)},mousedown:function(n){n.preventDefault(),t.removeElement(e)}}})])],{option:e,search:t.search,remove:t.removeElement})]})],2),t._v(" "),t.internalValue&&t.internalValue.length>t.limit?[t._t("limit",[n("strong",{staticClass:"multiselect__strong",domProps:{textContent:t._s(t.limitText(t.internalValue.length-t.limit))}})])]:t._e()],{search:t.search,remove:t.removeElement,values:t.visibleValues,isOpen:t.isOpen}),t._v(" "),n("transition",{attrs:{name:"multiselect__loading"}},[t._t("loading",[n("div",{directives:[{name:"show",rawName:"v-show",value:t.loading,expression:"loading"}],staticClass:"multiselect__spinner"})])],2),t._v(" "),t.searchable?n("input",{ref:"search",staticClass:"multiselect__input",style:t.inputStyle,attrs:{name:t.name,id:t.id,type:"text",autocomplete:"nope",placeholder:t.placeholder,disabled:t.disabled,tabindex:t.tabindex},domProps:{value:t.search},on:{input:function(e){t.updateSearch(e.target.value)},focus:function(e){e.preventDefault(),t.activate()},blur:function(e){e.preventDefault(),t.deactivate()},keyup:function(e){if(!("button"in e)&&t._k(e.keyCode,"esc",27,e.key,"Escape"))return null;t.deactivate()},keydown:[function(e){if(!("button"in e)&&t._k(e.keyCode,"down",40,e.key,["Down","ArrowDown"]))return null;e.preventDefault(),t.pointerForward()},function(e){if(!("button"in e)&&t._k(e.keyCode,"up",38,e.key,["Up","ArrowUp"]))return null;e.preventDefault(),t.pointerBackward()},function(e){if(!("button"in e)&&t._k(e.keyCode,"delete",[8,46],e.key,["Backspace","Delete"]))return null;e.stopPropagation(),t.removeLastElement()}],keypress:function(e){return"button"in e||!t._k(e.keyCode,"enter",13,e.key,"Enter")?(e.preventDefault(),e.stopPropagation(),e.target!==e.currentTarget?null:void t.addPointerElement(e)):null}}}):t._e(),t._v(" "),t.isSingleLabelVisible?n("span",{staticClass:"multiselect__single",on:{mousedown:function(e){return e.preventDefault(),t.toggle(e)}}},[t._t("singleLabel",[[t._v(t._s(t.currentOptionLabel))]],{option:t.singleValue})],2):t._e(),t._v(" "),t.isPlaceholderVisible?n("span",{staticClass:"multiselect__placeholder",on:{mousedown:function(e){return e.preventDefault(),t.toggle(e)}}},[t._t("placeholder",[t._v("\n          "+t._s(t.placeholder)+"\n        ")])],2):t._e()],2),t._v(" "),n("transition",{attrs:{name:"multiselect"}},[n("div",{directives:[{name:"show",rawName:"v-show",value:t.isOpen,expression:"isOpen"}],ref:"list",staticClass:"multiselect__content-wrapper",style:{maxHeight:t.optimizedHeight+"px"},attrs:{tabindex:"-1"},on:{focus:t.activate,mousedown:function(t){t.preventDefault()}}},[n("ul",{staticClass:"multiselect__content",style:t.contentStyle},[t._t("beforeList"),t._v(" "),t.multiple&&t.max===t.internalValue.length?n("li",[n("span",{staticClass:"multiselect__option"},[t._t("maxElements",[t._v("Maximum of "+t._s(t.max)+" options selected. First remove a selected option to select another.")])],2)]):t._e(),t._v(" "),!t.max||t.internalValue.length<t.max?t._l(t.filteredOptions,function(e,i){return n("li",{key:i,staticClass:"multiselect__element"},[e&&(e.$isLabel||e.$isDisabled)?t._e():n("span",{staticClass:"multiselect__option",class:t.optionHighlight(i,e),attrs:{"data-select":e&&e.isTag?t.tagPlaceholder:t.selectLabelText,"data-selected":t.selectedLabelText,"data-deselect":t.deselectLabelText},on:{click:function(n){n.stopPropagation(),t.select(e)},mouseenter:function(e){if(e.target!==e.currentTarget)return null;t.pointerSet(i)}}},[t._t("option",[n("span",[t._v(t._s(t.getOptionLabel(e)))])],{option:e,search:t.search})],2),t._v(" "),e&&(e.$isLabel||e.$isDisabled)?n("span",{staticClass:"multiselect__option",class:t.groupHighlight(i,e),attrs:{"data-select":t.groupSelect&&t.selectGroupLabelText,"data-deselect":t.groupSelect&&t.deselectGroupLabelText},on:{mouseenter:function(e){if(e.target!==e.currentTarget)return null;t.groupSelect&&t.pointerSet(i)},mousedown:function(n){n.preventDefault(),t.selectGroup(e)}}},[t._t("option",[n("span",[t._v(t._s(t.getOptionLabel(e)))])],{option:e,search:t.search})],2):t._e()])}):t._e(),t._v(" "),n("li",{directives:[{name:"show",rawName:"v-show",value:t.showNoResults&&0===t.filteredOptions.length&&t.search&&!t.loading,expression:"showNoResults && (filteredOptions.length === 0 && search && !loading)"}]},[n("span",{staticClass:"multiselect__option"},[t._t("noResult",[t._v("No elements found. Consider changing the search query.")],{search:t.search})],2)]),t._v(" "),n("li",{directives:[{name:"show",rawName:"v-show",value:t.showNoOptions&&0===t.options.length&&!t.search&&!t.loading,expression:"showNoOptions && (options.length === 0 && !search && !loading)"}]},[n("span",{staticClass:"multiselect__option"},[t._t("noOptions",[t._v("List is empty.")])],2)]),t._v(" "),t._t("afterList")],2)])])],2)},r=[],o={render:i,staticRenderFns:r};e.a=o}])});
},{}],788:[function(require,module,exports){
/*!
 * vue-resource v1.5.1
 * https://github.com/pagekit/vue-resource
 * Released under the MIT License.
 */

'use strict';

/**
 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
 */

var RESOLVED = 0;
var REJECTED = 1;
var PENDING = 2;

function Promise$1(executor) {

    this.state = PENDING;
    this.value = undefined;
    this.deferred = [];

    var promise = this;

    try {
        executor(function (x) {
            promise.resolve(x);
        }, function (r) {
            promise.reject(r);
        });
    } catch (e) {
        promise.reject(e);
    }
}

Promise$1.reject = function (r) {
    return new Promise$1(function (resolve, reject) {
        reject(r);
    });
};

Promise$1.resolve = function (x) {
    return new Promise$1(function (resolve, reject) {
        resolve(x);
    });
};

Promise$1.all = function all(iterable) {
    return new Promise$1(function (resolve, reject) {
        var count = 0, result = [];

        if (iterable.length === 0) {
            resolve(result);
        }

        function resolver(i) {
            return function (x) {
                result[i] = x;
                count += 1;

                if (count === iterable.length) {
                    resolve(result);
                }
            };
        }

        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
        }
    });
};

Promise$1.race = function race(iterable) {
    return new Promise$1(function (resolve, reject) {
        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolve, reject);
        }
    });
};

var p = Promise$1.prototype;

p.resolve = function resolve(x) {
    var promise = this;

    if (promise.state === PENDING) {
        if (x === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        var called = false;

        try {
            var then = x && x['then'];

            if (x !== null && typeof x === 'object' && typeof then === 'function') {
                then.call(x, function (x) {
                    if (!called) {
                        promise.resolve(x);
                    }
                    called = true;

                }, function (r) {
                    if (!called) {
                        promise.reject(r);
                    }
                    called = true;
                });
                return;
            }
        } catch (e) {
            if (!called) {
                promise.reject(e);
            }
            return;
        }

        promise.state = RESOLVED;
        promise.value = x;
        promise.notify();
    }
};

p.reject = function reject(reason) {
    var promise = this;

    if (promise.state === PENDING) {
        if (reason === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        promise.state = REJECTED;
        promise.value = reason;
        promise.notify();
    }
};

p.notify = function notify() {
    var promise = this;

    nextTick(function () {
        if (promise.state !== PENDING) {
            while (promise.deferred.length) {
                var deferred = promise.deferred.shift(),
                    onResolved = deferred[0],
                    onRejected = deferred[1],
                    resolve = deferred[2],
                    reject = deferred[3];

                try {
                    if (promise.state === RESOLVED) {
                        if (typeof onResolved === 'function') {
                            resolve(onResolved.call(undefined, promise.value));
                        } else {
                            resolve(promise.value);
                        }
                    } else if (promise.state === REJECTED) {
                        if (typeof onRejected === 'function') {
                            resolve(onRejected.call(undefined, promise.value));
                        } else {
                            reject(promise.value);
                        }
                    }
                } catch (e) {
                    reject(e);
                }
            }
        }
    });
};

p.then = function then(onResolved, onRejected) {
    var promise = this;

    return new Promise$1(function (resolve, reject) {
        promise.deferred.push([onResolved, onRejected, resolve, reject]);
        promise.notify();
    });
};

p.catch = function (onRejected) {
    return this.then(undefined, onRejected);
};

/**
 * Promise adapter.
 */

if (typeof Promise === 'undefined') {
    window.Promise = Promise$1;
}

function PromiseObj(executor, context) {

    if (executor instanceof Promise) {
        this.promise = executor;
    } else {
        this.promise = new Promise(executor.bind(context));
    }

    this.context = context;
}

PromiseObj.all = function (iterable, context) {
    return new PromiseObj(Promise.all(iterable), context);
};

PromiseObj.resolve = function (value, context) {
    return new PromiseObj(Promise.resolve(value), context);
};

PromiseObj.reject = function (reason, context) {
    return new PromiseObj(Promise.reject(reason), context);
};

PromiseObj.race = function (iterable, context) {
    return new PromiseObj(Promise.race(iterable), context);
};

var p$1 = PromiseObj.prototype;

p$1.bind = function (context) {
    this.context = context;
    return this;
};

p$1.then = function (fulfilled, rejected) {

    if (fulfilled && fulfilled.bind && this.context) {
        fulfilled = fulfilled.bind(this.context);
    }

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
};

p$1.catch = function (rejected) {

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.catch(rejected), this.context);
};

p$1.finally = function (callback) {

    return this.then(function (value) {
        callback.call(this);
        return value;
    }, function (reason) {
        callback.call(this);
        return Promise.reject(reason);
    }
    );
};

/**
 * Utility functions.
 */

var ref = {};
var hasOwnProperty = ref.hasOwnProperty;
var ref$1 = [];
var slice = ref$1.slice;
var debug = false, ntick;

var inBrowser = typeof window !== 'undefined';

function Util (ref) {
    var config = ref.config;
    var nextTick = ref.nextTick;

    ntick = nextTick;
    debug = config.debug || !config.silent;
}

function warn(msg) {
    if (typeof console !== 'undefined' && debug) {
        console.warn('[VueResource warn]: ' + msg);
    }
}

function error(msg) {
    if (typeof console !== 'undefined') {
        console.error(msg);
    }
}

function nextTick(cb, ctx) {
    return ntick(cb, ctx);
}

function trim(str) {
    return str ? str.replace(/^\s*|\s*$/g, '') : '';
}

function trimEnd(str, chars) {

    if (str && chars === undefined) {
        return str.replace(/\s+$/, '');
    }

    if (!str || !chars) {
        return str;
    }

    return str.replace(new RegExp(("[" + chars + "]+$")), '');
}

function toLower(str) {
    return str ? str.toLowerCase() : '';
}

function toUpper(str) {
    return str ? str.toUpperCase() : '';
}

var isArray = Array.isArray;

function isString(val) {
    return typeof val === 'string';
}

function isFunction(val) {
    return typeof val === 'function';
}

function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}

function isPlainObject(obj) {
    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
}

function isBlob(obj) {
    return typeof Blob !== 'undefined' && obj instanceof Blob;
}

function isFormData(obj) {
    return typeof FormData !== 'undefined' && obj instanceof FormData;
}

function when(value, fulfilled, rejected) {

    var promise = PromiseObj.resolve(value);

    if (arguments.length < 2) {
        return promise;
    }

    return promise.then(fulfilled, rejected);
}

function options(fn, obj, opts) {

    opts = opts || {};

    if (isFunction(opts)) {
        opts = opts.call(obj);
    }

    return merge(fn.bind({$vm: obj, $options: opts}), fn, {$options: opts});
}

function each(obj, iterator) {

    var i, key;

    if (isArray(obj)) {
        for (i = 0; i < obj.length; i++) {
            iterator.call(obj[i], obj[i], i);
        }
    } else if (isObject(obj)) {
        for (key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                iterator.call(obj[key], obj[key], key);
            }
        }
    }

    return obj;
}

var assign = Object.assign || _assign;

function merge(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source, true);
    });

    return target;
}

function defaults(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {

        for (var key in source) {
            if (target[key] === undefined) {
                target[key] = source[key];
            }
        }

    });

    return target;
}

function _assign(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source);
    });

    return target;
}

function _merge(target, source, deep) {
    for (var key in source) {
        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
                target[key] = {};
            }
            if (isArray(source[key]) && !isArray(target[key])) {
                target[key] = [];
            }
            _merge(target[key], source[key], deep);
        } else if (source[key] !== undefined) {
            target[key] = source[key];
        }
    }
}

/**
 * Root Prefix Transform.
 */

function root (options$$1, next) {

    var url = next(options$$1);

    if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
        url = trimEnd(options$$1.root, '/') + '/' + url;
    }

    return url;
}

/**
 * Query Parameter Transform.
 */

function query (options$$1, next) {

    var urlParams = Object.keys(Url.options.params), query = {}, url = next(options$$1);

    each(options$$1.params, function (value, key) {
        if (urlParams.indexOf(key) === -1) {
            query[key] = value;
        }
    });

    query = Url.params(query);

    if (query) {
        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
    }

    return url;
}

/**
 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
 */

function expand(url, params, variables) {

    var tmpl = parse(url), expanded = tmpl.expand(params);

    if (variables) {
        variables.push.apply(variables, tmpl.vars);
    }

    return expanded;
}

function parse(template) {

    var operators = ['+', '#', '.', '/', ';', '?', '&'], variables = [];

    return {
        vars: variables,
        expand: function expand(context) {
            return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
                if (expression) {

                    var operator = null, values = [];

                    if (operators.indexOf(expression.charAt(0)) !== -1) {
                        operator = expression.charAt(0);
                        expression = expression.substr(1);
                    }

                    expression.split(/,/g).forEach(function (variable) {
                        var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        variables.push(tmp[1]);
                    });

                    if (operator && operator !== '+') {

                        var separator = ',';

                        if (operator === '?') {
                            separator = '&';
                        } else if (operator !== '#') {
                            separator = operator;
                        }

                        return (values.length !== 0 ? operator : '') + values.join(separator);
                    } else {
                        return values.join(',');
                    }

                } else {
                    return encodeReserved(literal);
                }
            });
        }
    };
}

function getValues(context, operator, key, modifier) {

    var value = context[key], result = [];

    if (isDefined(value) && value !== '') {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            value = value.toString();

            if (modifier && modifier !== '*') {
                value = value.substring(0, parseInt(modifier, 10));
            }

            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
        } else {
            if (modifier === '*') {
                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            result.push(encodeValue(operator, value[k], k));
                        }
                    });
                }
            } else {
                var tmp = [];

                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        tmp.push(encodeValue(operator, value));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            tmp.push(encodeURIComponent(k));
                            tmp.push(encodeValue(operator, value[k].toString()));
                        }
                    });
                }

                if (isKeyOperator(operator)) {
                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
                } else if (tmp.length !== 0) {
                    result.push(tmp.join(','));
                }
            }
        }
    } else {
        if (operator === ';') {
            result.push(encodeURIComponent(key));
        } else if (value === '' && (operator === '&' || operator === '?')) {
            result.push(encodeURIComponent(key) + '=');
        } else if (value === '') {
            result.push('');
        }
    }

    return result;
}

function isDefined(value) {
    return value !== undefined && value !== null;
}

function isKeyOperator(operator) {
    return operator === ';' || operator === '&' || operator === '?';
}

function encodeValue(operator, value, key) {

    value = (operator === '+' || operator === '#') ? encodeReserved(value) : encodeURIComponent(value);

    if (key) {
        return encodeURIComponent(key) + '=' + value;
    } else {
        return value;
    }
}

function encodeReserved(str) {
    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
        if (!/%[0-9A-Fa-f]/.test(part)) {
            part = encodeURI(part);
        }
        return part;
    }).join('');
}

/**
 * URL Template (RFC 6570) Transform.
 */

function template (options) {

    var variables = [], url = expand(options.url, options.params, variables);

    variables.forEach(function (key) {
        delete options.params[key];
    });

    return url;
}

/**
 * Service for URL templating.
 */

function Url(url, params) {

    var self = this || {}, options$$1 = url, transform;

    if (isString(url)) {
        options$$1 = {url: url, params: params};
    }

    options$$1 = merge({}, Url.options, self.$options, options$$1);

    Url.transforms.forEach(function (handler) {

        if (isString(handler)) {
            handler = Url.transform[handler];
        }

        if (isFunction(handler)) {
            transform = factory(handler, transform, self.$vm);
        }

    });

    return transform(options$$1);
}

/**
 * Url options.
 */

Url.options = {
    url: '',
    root: null,
    params: {}
};

/**
 * Url transforms.
 */

Url.transform = {template: template, query: query, root: root};
Url.transforms = ['template', 'query', 'root'];

/**
 * Encodes a Url parameter string.
 *
 * @param {Object} obj
 */

Url.params = function (obj) {

    var params = [], escape = encodeURIComponent;

    params.add = function (key, value) {

        if (isFunction(value)) {
            value = value();
        }

        if (value === null) {
            value = '';
        }

        this.push(escape(key) + '=' + escape(value));
    };

    serialize(params, obj);

    return params.join('&').replace(/%20/g, '+');
};

/**
 * Parse a URL and return its components.
 *
 * @param {String} url
 */

Url.parse = function (url) {

    var el = document.createElement('a');

    if (document.documentMode) {
        el.href = url;
        url = el.href;
    }

    el.href = url;

    return {
        href: el.href,
        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
        port: el.port,
        host: el.host,
        hostname: el.hostname,
        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
        search: el.search ? el.search.replace(/^\?/, '') : '',
        hash: el.hash ? el.hash.replace(/^#/, '') : ''
    };
};

function factory(handler, next, vm) {
    return function (options$$1) {
        return handler.call(vm, options$$1, next);
    };
}

function serialize(params, obj, scope) {

    var array = isArray(obj), plain = isPlainObject(obj), hash;

    each(obj, function (value, key) {

        hash = isObject(value) || isArray(value);

        if (scope) {
            key = scope + '[' + (plain || hash ? key : '') + ']';
        }

        if (!scope && array) {
            params.add(value.name, value.value);
        } else if (hash) {
            serialize(params, value, key);
        } else {
            params.add(key, value);
        }
    });
}

/**
 * XDomain client (Internet Explorer).
 */

function xdrClient (request) {
    return new PromiseObj(function (resolve) {

        var xdr = new XDomainRequest(), handler = function (ref) {
                var type = ref.type;


                var status = 0;

                if (type === 'load') {
                    status = 200;
                } else if (type === 'error') {
                    status = 500;
                }

                resolve(request.respondWith(xdr.responseText, {status: status}));
            };

        request.abort = function () { return xdr.abort(); };

        xdr.open(request.method, request.getUrl());

        if (request.timeout) {
            xdr.timeout = request.timeout;
        }

        xdr.onload = handler;
        xdr.onabort = handler;
        xdr.onerror = handler;
        xdr.ontimeout = handler;
        xdr.onprogress = function () {};
        xdr.send(request.getBody());
    });
}

/**
 * CORS Interceptor.
 */

var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();

function cors (request) {

    if (inBrowser) {

        var orgUrl = Url.parse(location.href);
        var reqUrl = Url.parse(request.getUrl());

        if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {

            request.crossOrigin = true;
            request.emulateHTTP = false;

            if (!SUPPORTS_CORS) {
                request.client = xdrClient;
            }
        }
    }

}

/**
 * Form data Interceptor.
 */

function form (request) {

    if (isFormData(request.body)) {
        request.headers.delete('Content-Type');
    } else if (isObject(request.body) && request.emulateJSON) {
        request.body = Url.params(request.body);
        request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    }

}

/**
 * JSON Interceptor.
 */

function json (request) {

    var type = request.headers.get('Content-Type') || '';

    if (isObject(request.body) && type.indexOf('application/json') === 0) {
        request.body = JSON.stringify(request.body);
    }

    return function (response) {

        return response.bodyText ? when(response.text(), function (text) {

            var type = response.headers.get('Content-Type') || '';

            if (type.indexOf('application/json') === 0 || isJson(text)) {

                try {
                    response.body = JSON.parse(text);
                } catch (e) {
                    response.body = null;
                }

            } else {
                response.body = text;
            }

            return response;

        }) : response;

    };
}

function isJson(str) {

    var start = str.match(/^\s*(\[|\{)/);
    var end = {'[': /]\s*$/, '{': /}\s*$/};

    return start && end[start[1]].test(str);
}

/**
 * JSONP client (Browser).
 */

function jsonpClient (request) {
    return new PromiseObj(function (resolve) {

        var name = request.jsonp || 'callback', callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2), body = null, handler, script;

        handler = function (ref) {
            var type = ref.type;


            var status = 0;

            if (type === 'load' && body !== null) {
                status = 200;
            } else if (type === 'error') {
                status = 500;
            }

            if (status && window[callback]) {
                delete window[callback];
                document.body.removeChild(script);
            }

            resolve(request.respondWith(body, {status: status}));
        };

        window[callback] = function (result) {
            body = JSON.stringify(result);
        };

        request.abort = function () {
            handler({type: 'abort'});
        };

        request.params[name] = callback;

        if (request.timeout) {
            setTimeout(request.abort, request.timeout);
        }

        script = document.createElement('script');
        script.src = request.getUrl();
        script.type = 'text/javascript';
        script.async = true;
        script.onload = handler;
        script.onerror = handler;

        document.body.appendChild(script);
    });
}

/**
 * JSONP Interceptor.
 */

function jsonp (request) {

    if (request.method == 'JSONP') {
        request.client = jsonpClient;
    }

}

/**
 * Before Interceptor.
 */

function before (request) {

    if (isFunction(request.before)) {
        request.before.call(this, request);
    }

}

/**
 * HTTP method override Interceptor.
 */

function method (request) {

    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
        request.headers.set('X-HTTP-Method-Override', request.method);
        request.method = 'POST';
    }

}

/**
 * Header Interceptor.
 */

function header (request) {

    var headers = assign({}, Http.headers.common,
        !request.crossOrigin ? Http.headers.custom : {},
        Http.headers[toLower(request.method)]
    );

    each(headers, function (value, name) {
        if (!request.headers.has(name)) {
            request.headers.set(name, value);
        }
    });

}

/**
 * XMLHttp client (Browser).
 */

function xhrClient (request) {
    return new PromiseObj(function (resolve) {

        var xhr = new XMLHttpRequest(), handler = function (event) {

                var response = request.respondWith(
                'response' in xhr ? xhr.response : xhr.responseText, {
                    status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
                    statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
                });

                each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
                    response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
                });

                resolve(response);
            };

        request.abort = function () { return xhr.abort(); };

        xhr.open(request.method, request.getUrl(), true);

        if (request.timeout) {
            xhr.timeout = request.timeout;
        }

        if (request.responseType && 'responseType' in xhr) {
            xhr.responseType = request.responseType;
        }

        if (request.withCredentials || request.credentials) {
            xhr.withCredentials = true;
        }

        if (!request.crossOrigin) {
            request.headers.set('X-Requested-With', 'XMLHttpRequest');
        }

        // deprecated use downloadProgress
        if (isFunction(request.progress) && request.method === 'GET') {
            xhr.addEventListener('progress', request.progress);
        }

        if (isFunction(request.downloadProgress)) {
            xhr.addEventListener('progress', request.downloadProgress);
        }

        // deprecated use uploadProgress
        if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
            xhr.upload.addEventListener('progress', request.progress);
        }

        if (isFunction(request.uploadProgress) && xhr.upload) {
            xhr.upload.addEventListener('progress', request.uploadProgress);
        }

        request.headers.forEach(function (value, name) {
            xhr.setRequestHeader(name, value);
        });

        xhr.onload = handler;
        xhr.onabort = handler;
        xhr.onerror = handler;
        xhr.ontimeout = handler;
        xhr.send(request.getBody());
    });
}

/**
 * Http client (Node).
 */

function nodeClient (request) {

    var client = require('got');

    return new PromiseObj(function (resolve) {

        var url = request.getUrl();
        var body = request.getBody();
        var method = request.method;
        var headers = {}, handler;

        request.headers.forEach(function (value, name) {
            headers[name] = value;
        });

        client(url, {body: body, method: method, headers: headers}).then(handler = function (resp) {

            var response = request.respondWith(resp.body, {
                status: resp.statusCode,
                statusText: trim(resp.statusMessage)
            });

            each(resp.headers, function (value, name) {
                response.headers.set(name, value);
            });

            resolve(response);

        }, function (error$$1) { return handler(error$$1.response); });
    });
}

/**
 * Base client.
 */

function Client (context) {

    var reqHandlers = [sendRequest], resHandlers = [];

    if (!isObject(context)) {
        context = null;
    }

    function Client(request) {
        while (reqHandlers.length) {

            var handler = reqHandlers.pop();

            if (isFunction(handler)) {

                var response = (void 0), next = (void 0);

                response = handler.call(context, request, function (val) { return next = val; }) || next;

                if (isObject(response)) {
                    return new PromiseObj(function (resolve, reject) {

                        resHandlers.forEach(function (handler) {
                            response = when(response, function (response) {
                                return handler.call(context, response) || response;
                            }, reject);
                        });

                        when(response, resolve, reject);

                    }, context);
                }

                if (isFunction(response)) {
                    resHandlers.unshift(response);
                }

            } else {
                warn(("Invalid interceptor of type " + (typeof handler) + ", must be a function"));
            }
        }
    }

    Client.use = function (handler) {
        reqHandlers.push(handler);
    };

    return Client;
}

function sendRequest(request) {

    var client = request.client || (inBrowser ? xhrClient : nodeClient);

    return client(request);
}

/**
 * HTTP Headers.
 */

var Headers = function Headers(headers) {
    var this$1 = this;


    this.map = {};

    each(headers, function (value, name) { return this$1.append(name, value); });
};

Headers.prototype.has = function has (name) {
    return getName(this.map, name) !== null;
};

Headers.prototype.get = function get (name) {

    var list = this.map[getName(this.map, name)];

    return list ? list.join() : null;
};

Headers.prototype.getAll = function getAll (name) {
    return this.map[getName(this.map, name)] || [];
};

Headers.prototype.set = function set (name, value) {
    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
};

Headers.prototype.append = function append (name, value) {

    var list = this.map[getName(this.map, name)];

    if (list) {
        list.push(trim(value));
    } else {
        this.set(name, value);
    }
};

Headers.prototype.delete = function delete$1 (name) {
    delete this.map[getName(this.map, name)];
};

Headers.prototype.deleteAll = function deleteAll () {
    this.map = {};
};

Headers.prototype.forEach = function forEach (callback, thisArg) {
        var this$1 = this;

    each(this.map, function (list, name) {
        each(list, function (value) { return callback.call(thisArg, value, name, this$1); });
    });
};

function getName(map, name) {
    return Object.keys(map).reduce(function (prev, curr) {
        return toLower(name) === toLower(curr) ? curr : prev;
    }, null);
}

function normalizeName(name) {

    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
        throw new TypeError('Invalid character in header field name');
    }

    return trim(name);
}

/**
 * HTTP Response.
 */

var Response = function Response(body, ref) {
    var url = ref.url;
    var headers = ref.headers;
    var status = ref.status;
    var statusText = ref.statusText;


    this.url = url;
    this.ok = status >= 200 && status < 300;
    this.status = status || 0;
    this.statusText = statusText || '';
    this.headers = new Headers(headers);
    this.body = body;

    if (isString(body)) {

        this.bodyText = body;

    } else if (isBlob(body)) {

        this.bodyBlob = body;

        if (isBlobText(body)) {
            this.bodyText = blobText(body);
        }
    }
};

Response.prototype.blob = function blob () {
    return when(this.bodyBlob);
};

Response.prototype.text = function text () {
    return when(this.bodyText);
};

Response.prototype.json = function json () {
    return when(this.text(), function (text) { return JSON.parse(text); });
};

Object.defineProperty(Response.prototype, 'data', {

    get: function get() {
        return this.body;
    },

    set: function set(body) {
        this.body = body;
    }

});

function blobText(body) {
    return new PromiseObj(function (resolve) {

        var reader = new FileReader();

        reader.readAsText(body);
        reader.onload = function () {
            resolve(reader.result);
        };

    });
}

function isBlobText(body) {
    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
}

/**
 * HTTP Request.
 */

var Request = function Request(options$$1) {

    this.body = null;
    this.params = {};

    assign(this, options$$1, {
        method: toUpper(options$$1.method || 'GET')
    });

    if (!(this.headers instanceof Headers)) {
        this.headers = new Headers(this.headers);
    }
};

Request.prototype.getUrl = function getUrl () {
    return Url(this);
};

Request.prototype.getBody = function getBody () {
    return this.body;
};

Request.prototype.respondWith = function respondWith (body, options$$1) {
    return new Response(body, assign(options$$1 || {}, {url: this.getUrl()}));
};

/**
 * Service for sending network requests.
 */

var COMMON_HEADERS = {'Accept': 'application/json, text/plain, */*'};
var JSON_CONTENT_TYPE = {'Content-Type': 'application/json;charset=utf-8'};

function Http(options$$1) {

    var self = this || {}, client = Client(self.$vm);

    defaults(options$$1 || {}, self.$options, Http.options);

    Http.interceptors.forEach(function (handler) {

        if (isString(handler)) {
            handler = Http.interceptor[handler];
        }

        if (isFunction(handler)) {
            client.use(handler);
        }

    });

    return client(new Request(options$$1)).then(function (response) {

        return response.ok ? response : PromiseObj.reject(response);

    }, function (response) {

        if (response instanceof Error) {
            error(response);
        }

        return PromiseObj.reject(response);
    });
}

Http.options = {};

Http.headers = {
    put: JSON_CONTENT_TYPE,
    post: JSON_CONTENT_TYPE,
    patch: JSON_CONTENT_TYPE,
    delete: JSON_CONTENT_TYPE,
    common: COMMON_HEADERS,
    custom: {}
};

Http.interceptor = {before: before, method: method, jsonp: jsonp, json: json, form: form, header: header, cors: cors};
Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];

['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {

    Http[method$$1] = function (url, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1}));
    };

});

['post', 'put', 'patch'].forEach(function (method$$1) {

    Http[method$$1] = function (url, body, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1, body: body}));
    };

});

/**
 * Service for interacting with RESTful services.
 */

function Resource(url, params, actions, options$$1) {

    var self = this || {}, resource = {};

    actions = assign({},
        Resource.actions,
        actions
    );

    each(actions, function (action, name) {

        action = merge({url: url, params: assign({}, params)}, options$$1, action);

        resource[name] = function () {
            return (self.$http || Http)(opts(action, arguments));
        };
    });

    return resource;
}

function opts(action, args) {

    var options$$1 = assign({}, action), params = {}, body;

    switch (args.length) {

        case 2:

            params = args[0];
            body = args[1];

            break;

        case 1:

            if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
                body = args[0];
            } else {
                params = args[0];
            }

            break;

        case 0:

            break;

        default:

            throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
    }

    options$$1.body = body;
    options$$1.params = assign({}, options$$1.params, params);

    return options$$1;
}

Resource.actions = {

    get: {method: 'GET'},
    save: {method: 'POST'},
    query: {method: 'GET'},
    update: {method: 'PUT'},
    remove: {method: 'DELETE'},
    delete: {method: 'DELETE'}

};

/**
 * Install plugin.
 */

function plugin(Vue) {

    if (plugin.installed) {
        return;
    }

    Util(Vue);

    Vue.url = Url;
    Vue.http = Http;
    Vue.resource = Resource;
    Vue.Promise = PromiseObj;

    Object.defineProperties(Vue.prototype, {

        $url: {
            get: function get() {
                return options(Vue.url, this, this.$options.url);
            }
        },

        $http: {
            get: function get() {
                return options(Vue.http, this, this.$options.http);
            }
        },

        $resource: {
            get: function get() {
                return Vue.resource.bind(this);
            }
        },

        $promise: {
            get: function get() {
                var this$1 = this;

                return function (executor) { return new Vue.Promise(executor, this$1); };
            }
        }

    });
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

module.exports = plugin;

},{"got":80}],789:[function(require,module,exports){
(function (process){
/**
  * vue-router v2.8.1
  * (c) 2017 Evan You
  * @license MIT
  */
'use strict';

/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (process.env.NODE_ENV !== 'production' && !condition) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (process.env.NODE_ENV !== 'production') {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    process.env.NODE_ENV !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (process.env.NODE_ENV !== 'production') {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (process.env.NODE_ENV !== 'production') {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (process.env.NODE_ENV !== 'production') {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (process.env.NODE_ENV !== 'production' && !matchAs) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (process.env.NODE_ENV !== 'production') {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (process.env.NODE_ENV !== 'production') {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (process.env.NODE_ENV !== 'production') {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (process.env.NODE_ENV !== 'production') {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (process.env.NODE_ENV !== 'production') {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (process.env.NODE_ENV !== 'production') {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (process.env.NODE_ENV !== 'production') {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (process.env.NODE_ENV !== 'production') {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          process.env.NODE_ENV !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (process.env.NODE_ENV !== 'production') {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  process.env.NODE_ENV !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '2.8.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

module.exports = VueRouter;

}).call(this,require('_process'))
},{"_process":734}],790:[function(require,module,exports){
(function(t,e){"object"===typeof exports&&"object"===typeof module?module.exports=e():"function"===typeof define&&define.amd?define([],e):"object"===typeof exports?exports["vue-swatches"]=e():t["vue-swatches"]=e()})("undefined"!==typeof self?self:this,(function(){return function(t){var e={};function n(r){if(e[r])return e[r].exports;var i=e[r]={i:r,l:!1,exports:{}};return t[r].call(i.exports,i,i.exports,n),i.l=!0,i.exports}return n.m=t,n.c=e,n.d=function(t,e,r){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:r})},n.r=function(t){"undefined"!==typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"===typeof t&&t&&t.__esModule)return t;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var i in t)n.d(r,i,function(e){return t[e]}.bind(null,i));return r},n.n=function(t){var e=t&&t.__esModule?function(){return t["default"]}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="",n(n.s="fb15")}({"0ca3":function(t,e,n){"use strict";var r=n("c6aa"),i=n.n(r);i.a},7937:function(t,e,n){},"7fca":function(t,e,n){"use strict";var r=n("c10a"),i=n.n(r);i.a},8875:function(t,e,n){var r,i,o;(function(n,c){i=[],r=c,o="function"===typeof r?r.apply(e,i):r,void 0===o||(t.exports=o)})("undefined"!==typeof self&&self,(function(){function t(){if(document.currentScript)return document.currentScript;try{throw new Error}catch(h){var t,e,n,r=/.*at [^(]*\((.*):(.+):(.+)\)$/gi,i=/@([^@]*):(\d+):(\d+)\s*$/gi,o=r.exec(h.stack)||i.exec(h.stack),c=o&&o[1]||!1,s=o&&o[2]||!1,a=document.location.href.replace(document.location.hash,""),l=document.getElementsByTagName("script");c===a&&(t=document.documentElement.outerHTML,e=new RegExp("(?:[^\\n]+?\\n){0,"+(s-2)+"}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*","i"),n=t.replace(e,"$1").trim());for(var u=0;u<l.length;u++){if("interactive"===l[u].readyState)return l[u];if(l[u].src===c)return l[u];if(c===a&&l[u].innerHTML&&l[u].innerHTML.trim()===n)return l[u]}return null}}return t}))},9334:function(t,e,n){"use strict";var r=n("7937"),i=n.n(r);i.a},c10a:function(t,e,n){},c6aa:function(t,e,n){},fb15:function(t,e,n){"use strict";if(n.r(e),n.d(e,"DEFAULT_BACKGROUND_COLOR",(function(){return E})),n.d(e,"DEFAULT_BORDER_RADIUS",(function(){return R})),n.d(e,"DEFAULT_ROW_LENGTH",(function(){return F})),n.d(e,"DEFAULT_TRIGGER_CONTAINER_SPACE",(function(){return P})),n.d(e,"DEFAULT_SWATCH_SIZE",(function(){return D})),n.d(e,"DEFAULT_SHOW_BORDER",(function(){return A})),n.d(e,"extractPropertyFromPreset",(function(){return T})),"undefined"!==typeof window){var r=window.document.currentScript,i=n("8875");r=i(),"currentScript"in document||Object.defineProperty(document,"currentScript",{get:i});var o=r&&r.src.match(/(.+\/)[^/]+\.js(\?.*)?$/);o&&(n.p=o[1])}var c=function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"vue-swatches",attrs:{tabindex:"-1"},on:{blur:function(e){return t.onBlur(e.relatedTarget)}}},[t.inline?t._e():n("div",{ref:"triggerWrapper",staticClass:"vue-swatches__trigger__wrapper",on:{click:t.togglePopover}},[t._t("trigger",[n("div",{staticClass:"vue-swatches__trigger",class:{"vue-swatches--is-empty":!t.value,"vue-swatches--is-disabled":t.disabled},style:t.triggerStyles},[n("div",{directives:[{name:"show",rawName:"v-show",value:t.isNoColor,expression:"isNoColor"}],staticClass:"vue-swatches__diagonal__wrapper vue-swatches--has-children-centered"},[n("div",{staticClass:"vue-swatches__diagonal"})])])])],2),n("transition",{attrs:{name:"vue-swatches-show-hide"}},[n("div",{directives:[{name:"show",rawName:"v-show",value:t.inline||t.isOpen,expression:"inline || isOpen"}],ref:"containerWrapper",staticClass:"vue-swatches__container",class:{"vue-swatches--inline":t.inline},style:t.containerStyles},[n("div",{staticClass:"vue-swatches__wrapper",style:t.wrapperStyles},[t.isNested?t._l(t.computedSwatches,(function(e,r){return n("div",{key:r,staticClass:"vue-swatches__row"},t._l(e,(function(i,o){return n("v-swatch",{key:o,attrs:{"is-last":r===t.computedSwatches.length-1&&o===e.length,"row-length-setted":null!==t.rowLength||null!==t.presetRowLength,"border-radius":t.computedBorderRadius,disabled:t.getSwatchDisabled(i),inline:t.inline,selected:t.checkEquality(t.getSwatchColor(i),t.value),"swatch-size":t.computedSwatchSize,"spacing-size":t.computedSpacingSize,"show-border":t.getSwatchShowBorder(i),"show-checkbox":t.showCheckbox,"show-labels":t.showLabels,"swatch-color":t.getSwatchColor(i),"swatch-label":t.getSwatchLabel(i),"swatch-alt":t.getSwatchAlt(i),"swatch-style":t.swatchStyle},on:{blur:function(e){return t.onBlur(e)},click:function(e){return t.updateSwatch(i)}},nativeOn:{click:function(e){return t.updateSwatch(i)}}})})),1)})):t._l(t.computedSwatches,(function(e,r){return n("v-swatch",{key:r,attrs:{"is-last":r===t.computedSwatches.length-1,"row-length-setted":null!==t.rowLength||null!==t.presetRowLength,"border-radius":t.computedBorderRadius,disabled:t.getSwatchDisabled(e),inline:t.inline,selected:t.checkEquality(t.getSwatchColor(e),t.value),"swatch-size":t.computedSwatchSize,"spacing-size":t.computedSpacingSize,"show-border":t.getSwatchShowBorder(e),"show-checkbox":t.showCheckbox,"show-labels":t.showLabels,"swatch-color":t.getSwatchColor(e),"swatch-label":t.getSwatchLabel(e),"swatch-alt":t.getSwatchAlt(e),"swatch-style":t.swatchStyle},on:{blur:function(e){return t.onBlur(e)},click:function(n){return t.updateSwatch(e)}},nativeOn:{click:function(n){return t.updateSwatch(e)}}})}))],2),t.showFallback?n("div",{staticClass:"vue-swatches__fallback__wrapper",style:t.computedFallbackWrapperStyles},[n("span",{staticClass:"vue-swatches__fallback__input--wrapper"},[n("input",{ref:"fallbackInput",staticClass:"vue-swatches__fallback__input",class:t.fallbackInputClass,attrs:{type:t.fallbackInputType},domProps:{value:t.internalValue},on:{input:function(e){return t.updateSwatch(e.target.value,{fromFallbackInput:!0})}}})]),t.showFallbackOk?n("button",{staticClass:"vue-swatches__fallback__button",class:t.fallbackOkClass,on:{click:function(e){return e.preventDefault(),t.onFallbackButtonClick(e)}}},[t._v(" "+t._s(t.fallbackOkText)+" ")]):t._e()]):t._e()])])],1)},s=[],a={colors:["#1FBC9C","#1CA085","#2ECC70","#27AF60","#3398DB","#2980B9","#A463BF","#8E43AD","#3D556E","#222F3D","#F2C511","#F39C19","#E84B3C","#C0382B","#DDE6E8","#BDC3C8"],rowLength:4},l={colors:["#CC0001","#E36101","#FFCC00","#009900","#0066CB","#000000","#FFFFFF"],showBorder:!0},u={colors:[["#000000","#434343","#666666","#999999","#b7b7b7","#cccccc","#d9d9d9","#efefef","#f3f3f3","#ffffff"],["#980000","#ff0000","#ff9900","#ffff00","#00ff00","#00ffff","#4a86e8","#0000ff","#9900ff","#ff00ff"],["#e6b8af","#f4cccc","#fce5cd","#fff2cc","#d9ead3","#d0e0e3","#c9daf8","#cfe2f3","#d9d2e9","#ead1dc"],["#dd7e6b","#ea9999","#f9cb9c","#ffe599","#b6d7a8","#a2c4c9","#a4c2f4","#9fc5e8","#b4a7d6","#d5a6bd"],["#cc4125","#e06666","#f6b26b","#ffd966","#93c47d","#76a5af","#6d9eeb","#6fa8dc","#8e7cc3","#c27ba0"],["#a61c00","#cc0000","#e69138","#f1c232","#6aa84f","#45818e","#3c78d8","#3d85c6","#674ea7","#a64d79"],["#85200c","#990000","#b45f06","#bf9000","#38761d","#134f5c","#1155cc","#0b5394","#351c75","#741b47"],["#5b0f00","#660000","#783f04","#7f6000","#274e13","#0c343d","#1c4587","#073763","#20124d","#4c1130"]],borderRadius:"0",rowLength:10,swatchSize:24,spacingSize:0},h=function(){var t=this,e=this,n=e.$createElement,r=e._self._c||n;return r("div",{staticClass:"vue-swatches__swatch",class:{"vue-swatches__swatch--border":e.showBorder,"vue-swatches__swatch--selected":e.selected,"vue-swatches__swatch--is-disabled":e.disabled},style:e.swatchStyles,attrs:{"aria-label":e.swatchAlt,role:"button",tabindex:"0"},on:{keyup:function(t){return!t.type.indexOf("key")&&e._k(t.keyCode,"enter",13,t.key,"Enter")?null:e.$emit("click",e.swatchColor)},blur:function(e){return t.$emit("blur",e.relatedTarget)}}},[""===e.swatchColor?r("div",{staticClass:"vue-swatches__diagonal__wrapper vue-swatches--has-children-centered"},[r("div",{staticClass:"vue-swatches__diagonal"})]):e._e(),r("v-check",{directives:[{name:"show",rawName:"v-show",value:e.showCheckbox&&e.selected,expression:"showCheckbox && selected"}]}),e.showLabels?r("div",{staticClass:"vue-swatches__swatch__label",style:e.labelStyles},[e._v(" "+e._s(e.swatchLabel)+" ")]):e._e()],1)},p=[],d=function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"vue-swatches__check__wrapper vue-swatches--has-children-centered"},[n("div",{staticClass:"vue-swatches__check__circle vue-swatches--has-children-centered"},[n("svg",{staticClass:"check",attrs:{version:"1.1",role:"presentation",width:"12",height:"12",viewBox:"0 0 1792 1792"}},[n("path",{staticClass:"vue-swatches__check__path",attrs:{d:"M1671 566q0 40-28 68l-724 724-136 136q-28 28-68 28t-68-28l-136-136-362-362q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 295 656-657q28-28 68-28t68 28l136 136q28 28 28 68z"}})])])])},f=[],w={name:"v-check",data:function(){return{}}},b=w;n("7fca");function S(t,e,n,r,i,o,c,s){var a,l="function"===typeof t?t.options:t;if(e&&(l.render=e,l.staticRenderFns=n,l._compiled=!0),r&&(l.functional=!0),o&&(l._scopeId="data-v-"+o),c?(a=function(t){t=t||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext,t||"undefined"===typeof __VUE_SSR_CONTEXT__||(t=__VUE_SSR_CONTEXT__),i&&i.call(this,t),t&&t._registeredComponents&&t._registeredComponents.add(c)},l._ssrRegister=a):i&&(a=s?function(){i.call(this,this.$root.$options.shadowRoot)}:i),a)if(l.functional){l._injectStyles=a;var u=l.render;l.render=function(t,e){return a.call(e),u(t,e)}}else{var h=l.beforeCreate;l.beforeCreate=h?[].concat(h,a):[a]}return{exports:t,options:l}}var g=S(b,d,f,!1,null,null,null),y=g.exports;function v(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function m(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?v(Object(n),!0).forEach((function(e){_(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):v(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}function _(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}var O={name:"v-swatch",components:{VCheck:y},props:{borderRadius:{type:String},isLast:{type:Boolean,default:!1},rowLengthSetted:{type:Boolean,default:!1},disabled:{type:Boolean},inline:{type:Boolean},selected:{type:Boolean,default:!1},showCheckbox:{type:Boolean},showBorder:{type:Boolean},showLabels:{type:Boolean},spacingSize:{type:Number},swatchColor:{type:String,default:""},swatchLabel:{type:String},swatchAlt:{type:String},swatchSize:{type:Number},swatchStyle:{type:Object}},data:function(){return{}},computed:{computedLabelStyle:function(){var t=8+3*Math.floor(this.spacingSize/5);return{bottom:"-".concat(t,"px")}},computedSwatchStyle:function(){var t={width:"".concat(this.swatchSize,"px"),height:"".concat(this.swatchSize,"px"),borderRadius:this.borderRadius,backgroundColor:""!==this.swatchColor?this.swatchColor:"#FFFFFF",cursor:this.cursorStyle};return this.inline&&this.isLast||(t.marginRight="".concat(this.spacingSize,"px")),this.inline&&!this.rowLengthSetted?t:m({},t,{marginBottom:"".concat(this.spacingSize,"px")})},cursorStyle:function(){return this.disabled?"not-allowed":"pointer"},labelStyles:function(){return[this.computedLabelStyle]},swatchStyles:function(){return[this.computedSwatchStyle,this.swatchStyle]}}},C=O,k=(n("0ca3"),S(C,h,p,!1,null,null,null)),x=k.exports;function B(t){return B="function"===typeof Symbol&&"symbol"===typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"===typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},B(t)}function j(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function L(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?j(Object(n),!0).forEach((function(e){z(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):j(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}function z(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}var E="#ffffff",R="10px",F=4,P=5,D=42,A=!1,T=function(t,e,n){return"string"!==typeof t?null:"text-basic"===t?void 0===l[e]?null:l[e]:"text-advanced"===t?void 0===u[e]?null:u[e]:"basic"===t||n?void 0===a[e]?null:a[e]:null},$={name:"v-swatches",components:{VSwatch:x},props:{backgroundColor:{type:String,default:E},closeOnSelect:{type:Boolean,default:!0},swatches:{type:[Array,String],default:function(){return"basic"}},disabled:{type:Boolean,default:!1},fallbackInputClass:{type:[Array,Object,String],default:null},fallbackInputType:{type:String,default:function(){return"text"},validator:function(t){return-1!==["text","color"].indexOf(t)}},fallbackOkClass:{type:[Array,Object,String],default:null},fallbackOkText:{type:String,default:"Ok"},inline:{type:Boolean,default:!1},shapes:{type:String,default:"squares"},popoverX:{type:String,default:"right"},popoverY:{type:String,default:"bottom"},rowLength:{type:[Number,String],default:null},showBorder:{type:Boolean,default:null},showFallback:{type:Boolean,default:!1},showCheckbox:{type:Boolean,default:!0},showLabels:{type:Boolean,default:!1},spacingSize:{type:Number,default:null},swatchSize:{type:[Number,String],default:null},swatchStyle:{type:[Object,Array],default:function(){}},triggerStyle:{type:[Object,Array],default:function(){}},wrapperStyle:{type:[Object,Array],default:function(){}},value:{type:String,default:null}},data:function(){return{alwaysOnScreenStyle:{},componentMounted:!1,internalValue:this.value,internalIsOpen:!1}},computed:{isNested:function(){return!!(this.computedSwatches&&this.computedSwatches.length&&this.computedSwatches[0]instanceof Array)},isOpen:function(){return!this.inline&&this.internalIsOpen},isNoColor:function(){return this.checkEquality("",this.value)},presetBorderRadius:function(){return T(this.swatches,"borderRadius")},presetRowLength:function(){return T(this.swatches,"rowLength")},presetShowBorder:function(){return T(this.swatches,"showBorder")},presetSwatchSize:function(){return T(this.swatches,"swatchSize")},presetSpacingSize:function(){return T(this.swatches,"spacingSize")},computedSwatches:function(){return this.swatches instanceof Array?this.swatches:"string"===typeof this.swatches?T(this.swatches,"colors",!0):[]},computedBorderRadius:function(){return null!==this.presetBorderRadius?this.presetBorderRadius:this.borderRadius},computedRowLength:function(){return null!==this.rowLength?Number(this.rowLength):null!==this.presetRowLength?this.presetRowLength:this.computedSwatches.length<F&&!this.isNested?this.computedSwatches.length:F},computedSwatchSize:function(){return null!==this.swatchSize?Number(this.swatchSize):null!==this.presetSwatchSize?this.presetSwatchSize:D},computedSpacingSize:function(){return null!==this.spacingSize?this.spacingSize:null!==this.presetSpacingSize?this.presetSpacingSize:Math.round(.25*this.computedSwatchSize)},computedShowBorder:function(){return null!==this.showBorder?this.showBorder:null!==this.presetShowBorder?this.presetShowBorder:A},showFallbackOk:function(){return!this.inline},borderRadius:function(){return"squares"===this.shapes?"".concat(Math.round(.25*this.computedSwatchSize),"px"):"circles"===this.shapes?"50%":""},wrapperWidth:function(){return this.computedRowLength*(this.computedSwatchSize+this.computedSpacingSize)},computedtriggerStyle:function(){return{width:"42px",height:"42px",backgroundColor:this.value?this.value:"#ffffff",borderRadius:"circles"===this.shapes?"50%":R}},triggerStyles:function(){return[this.computedtriggerStyle,this.triggerStyle]},containerStyles:function(){var t=[{backgroundColor:this.backgroundColor},this.alwaysOnScreenStyle];return this.inline?t:[].concat(t,[{padding:"5px",marginBottom:"5px"}])},computedWrapperStyle:function(){return this.inline?{}:{paddingTop:"".concat(this.computedSpacingSize,"px"),paddingLeft:"".concat(this.computedSpacingSize,"px"),width:"".concat(this.wrapperWidth,"px")}},wrapperStyles:function(){return[this.computedWrapperStyle,this.wrapperStyle]},computedFallbackWrapperStyle:function(){var t={marginLeft:"".concat(this.computedSpacingSize,"px"),paddingBottom:"".concat(this.computedSpacingSize,"px")};return this.inline?t:L({},t,{width:"".concat(this.wrapperWidth-this.computedSpacingSize,"px")})},computedFallbackWrapperStyles:function(){return[this.computedFallbackWrapperStyle]}},watch:{value:function(t){this.internalValue=t}},mounted:function(){this.componentMounted=!0},methods:{checkEquality:function(t,e){return!(!t&&""!==t||!e&&""!==e)&&t.toUpperCase()===e.toUpperCase()},hidePopover:function(){this.internalIsOpen=!1,this.$el.blur(),this.$emit("close",this.internalValue)},getAlwaysOnScreenStyle:function(){var t={},e=this.$refs.triggerWrapper,n=this.$refs.containerWrapper;if(!this.componentMounted||this.inline||!e||!window||!document)return t;var r=e.getBoundingClientRect(),i=5,o=(document.documentElement.clientWidth||window.innerWidth)-5,c=5,s=(document.documentElement.clientHeight||window.innerHeight)-5;n.style.visibility="hidden",n.style.display="block";var a=n.getBoundingClientRect();return n.style.display="none",n.style.visibility="visible","top"===this.popoverY?r.top-a.height<c?(t.top="".concat(r.height+P,"px"),t.bottom="auto"):(t.bottom="".concat(r.height+P,"px"),t.top="auto"):"bottom"===this.popoverY&&(r.bottom+a.height>s?(t.bottom="".concat(r.height+P,"px"),t.top="auto"):(t.top="".concat(r.height+P,"px"),t.bottom="auto")),"left"===this.popoverX?r.right-a.width<i?(t.left=0,t.right="auto"):(t.right=0,t.left="auto"):"right"===this.popoverX&&(r.left+a.width>o?(t.right=0,t.left="auto"):(t.left=0,t.right="auto")),t},getSwatchShowBorder:function(t){return"string"===typeof t?this.computedShowBorder:"object"===B(t)?void 0!==t.showBorder?t.showBorder:this.computedShowBorder:void 0},getSwatchColor:function(t){return"string"===typeof t?t:"object"===B(t)?t.color:void 0},getSwatchDisabled:function(t){return"string"===typeof t?this.disabled:"object"===B(t)?void 0!==t.disabled?t.disabled:this.disabled:void 0},getSwatchLabel:function(t){return"string"===typeof t?t:"object"===B(t)?t.label||t.color:void 0},getSwatchAlt:function(t){return"string"===typeof t?t:"object"===B(t)?t.alt||this.getSwatchLabel(t):void 0},onBlur:function(t){this.isOpen&&(null!==t&&this.$el.contains(t)||(this.internalIsOpen=!1,this.$emit("close",this.internalValue)))},onFallbackButtonClick:function(){this.hidePopover()},showPopover:function(){this.isOpen||this.inline||this.disabled||(this.alwaysOnScreenStyle=this.getAlwaysOnScreenStyle(),this.internalIsOpen=!0,this.$el.focus(),this.$emit("open"))},togglePopover:function(){this.isOpen?this.hidePopover():this.showPopover()},updateSwatch:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=e.fromFallbackInput;if(!this.getSwatchDisabled(t)){var r=this.getSwatchColor(t);this.internalValue=r,this.$emit("input",r),!this.closeOnSelect||this.inline||n||this.hidePopover()}}}},N=$,W=(n("9334"),S(N,c,s,!1,null,null,null)),I=W.exports;e["default"]=I}})["default"]}));

},{}],791:[function(require,module,exports){
(function (global){
/*!
 * Vue.js v2.6.11
 * (c) 2014-2019 Evan You
 * Released under the MIT License.
 */
'use strict';

/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "development" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "development" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

{
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (!config.async) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (customSetter) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (isUndef(target) || isPrimitive(target)
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (isUndef(target) || isPrimitive(target)
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
{
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "development" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (warnMissing && !res) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (isObject(def)) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

{
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

{
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (!isObject(bindObject)) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (key !== '' && key !== null) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (isDef(data) && isDef(data.key) && !isPrimitive(data.key)
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (isDef(data) && isDef(data.nativeOn)) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (vm.$options.renderError) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (Array.isArray(vnode)) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                "timeout (" + (res.timeout) + "ms)"
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (config.performance && mark) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (has[id] != null) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (!config.async) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression = expOrFn.toString();
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (getter == null) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (sharedPropertyDefinition.set === noop) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (config.performance && mark) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    {
      initProxy(vm);
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (config.performance && mark) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (!(this instanceof Vue)
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (name) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (type === 'component') {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.11';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (data && data.pre) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (typeof console !== 'undefined' &&
                !hydrationBailed
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (typeof console !== 'undefined' &&
                !hydrationBailed
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    warn &&
    modifiers.prevent && modifiers.passive
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecesarry `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (explicitEnterDuration != null) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (isDef(explicitLeaveDuration)) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (children.length > 1) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (mode && mode !== 'in-out' && mode !== 'out-in'
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (config.productionTip !== false &&
      typeof console !== 'undefined'
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (staticClass) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (!stack.length && options.warn) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (options.outputSourceRange) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (i > pos || !tagName &&
          options.warn
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (options.outputSourceRange) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (options.outputSourceRange) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anyting as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (options.outputSourceRange) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (children[i].text !== ' ') {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (slotScope) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (el.attrsMap['v-for']) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (el.key) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          value.trim().length === 0
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (name === 'model') {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      map[attrs[i].name] && !isIE && !isEdge
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (dir.modifiers) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (state.maybeComponent(el) &&
    el.tag !== 'slot' &&
    el.tag !== 'template' &&
    !el.key
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (el.children.length !== 1 || ast.type !== 1) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (options.outputSourceRange) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (!template) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (config.performance && mark) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "development" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (config.performance && mark) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

module.exports = Vue;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],792:[function(require,module,exports){
(function (process){
if (process.env.NODE_ENV === 'production') {
  module.exports = require('./vue.common.prod.js')
} else {
  module.exports = require('./vue.common.dev.js')
}

}).call(this,require('_process'))
},{"./vue.common.dev.js":791,"./vue.common.prod.js":793,"_process":734}],793:[function(require,module,exports){
(function (global){
/*!
 * Vue.js v2.6.11
 * (c) 2014-2019 Evan You
 * Released under the MIT License.
 */
"use strict";var e=Object.freeze({});function t(e){return null==e}function n(e){return null!=e}function r(e){return!0===e}function i(e){return"string"==typeof e||"number"==typeof e||"symbol"==typeof e||"boolean"==typeof e}function o(e){return null!==e&&"object"==typeof e}var a=Object.prototype.toString;function s(e){return"[object Object]"===a.call(e)}function c(e){var t=parseFloat(String(e));return t>=0&&Math.floor(t)===t&&isFinite(e)}function u(e){return n(e)&&"function"==typeof e.then&&"function"==typeof e.catch}function l(e){return null==e?"":Array.isArray(e)||s(e)&&e.toString===a?JSON.stringify(e,null,2):String(e)}function f(e){var t=parseFloat(e);return isNaN(t)?e:t}function p(e,t){for(var n=Object.create(null),r=e.split(","),i=0;i<r.length;i++)n[r[i]]=!0;return t?function(e){return n[e.toLowerCase()]}:function(e){return n[e]}}var d=p("slot,component",!0),v=p("key,ref,slot,slot-scope,is");function h(e,t){if(e.length){var n=e.indexOf(t);if(n>-1)return e.splice(n,1)}}var m=Object.prototype.hasOwnProperty;function y(e,t){return m.call(e,t)}function g(e){var t=Object.create(null);return function(n){return t[n]||(t[n]=e(n))}}var _=/-(\w)/g,b=g(function(e){return e.replace(_,function(e,t){return t?t.toUpperCase():""})}),$=g(function(e){return e.charAt(0).toUpperCase()+e.slice(1)}),w=/\B([A-Z])/g,C=g(function(e){return e.replace(w,"-$1").toLowerCase()});var x=Function.prototype.bind?function(e,t){return e.bind(t)}:function(e,t){function n(n){var r=arguments.length;return r?r>1?e.apply(t,arguments):e.call(t,n):e.call(t)}return n._length=e.length,n};function k(e,t){t=t||0;for(var n=e.length-t,r=new Array(n);n--;)r[n]=e[n+t];return r}function A(e,t){for(var n in t)e[n]=t[n];return e}function O(e){for(var t={},n=0;n<e.length;n++)e[n]&&A(t,e[n]);return t}function S(e,t,n){}var T=function(e,t,n){return!1},E=function(e){return e};function N(e,t){if(e===t)return!0;var n=o(e),r=o(t);if(!n||!r)return!n&&!r&&String(e)===String(t);try{var i=Array.isArray(e),a=Array.isArray(t);if(i&&a)return e.length===t.length&&e.every(function(e,n){return N(e,t[n])});if(e instanceof Date&&t instanceof Date)return e.getTime()===t.getTime();if(i||a)return!1;var s=Object.keys(e),c=Object.keys(t);return s.length===c.length&&s.every(function(n){return N(e[n],t[n])})}catch(e){return!1}}function j(e,t){for(var n=0;n<e.length;n++)if(N(e[n],t))return n;return-1}function D(e){var t=!1;return function(){t||(t=!0,e.apply(this,arguments))}}var L="data-server-rendered",M=["component","directive","filter"],I=["beforeCreate","created","beforeMount","mounted","beforeUpdate","updated","beforeDestroy","destroyed","activated","deactivated","errorCaptured","serverPrefetch"],F={optionMergeStrategies:Object.create(null),silent:!1,productionTip:!1,devtools:!1,performance:!1,errorHandler:null,warnHandler:null,ignoredElements:[],keyCodes:Object.create(null),isReservedTag:T,isReservedAttr:T,isUnknownElement:T,getTagNamespace:S,parsePlatformTagName:E,mustUseProp:T,async:!0,_lifecycleHooks:I},P=/a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;function R(e,t,n,r){Object.defineProperty(e,t,{value:n,enumerable:!!r,writable:!0,configurable:!0})}var H=new RegExp("[^"+P.source+".$_\\d]");var B,U="__proto__"in{},z="undefined"!=typeof window,V="undefined"!=typeof WXEnvironment&&!!WXEnvironment.platform,K=V&&WXEnvironment.platform.toLowerCase(),J=z&&window.navigator.userAgent.toLowerCase(),q=J&&/msie|trident/.test(J),W=J&&J.indexOf("msie 9.0")>0,Z=J&&J.indexOf("edge/")>0,G=(J&&J.indexOf("android"),J&&/iphone|ipad|ipod|ios/.test(J)||"ios"===K),X=(J&&/chrome\/\d+/.test(J),J&&/phantomjs/.test(J),J&&J.match(/firefox\/(\d+)/)),Y={}.watch,Q=!1;if(z)try{var ee={};Object.defineProperty(ee,"passive",{get:function(){Q=!0}}),window.addEventListener("test-passive",null,ee)}catch(e){}var te=function(){return void 0===B&&(B=!z&&!V&&"undefined"!=typeof global&&(global.process&&"server"===global.process.env.VUE_ENV)),B},ne=z&&window.__VUE_DEVTOOLS_GLOBAL_HOOK__;function re(e){return"function"==typeof e&&/native code/.test(e.toString())}var ie,oe="undefined"!=typeof Symbol&&re(Symbol)&&"undefined"!=typeof Reflect&&re(Reflect.ownKeys);ie="undefined"!=typeof Set&&re(Set)?Set:function(){function e(){this.set=Object.create(null)}return e.prototype.has=function(e){return!0===this.set[e]},e.prototype.add=function(e){this.set[e]=!0},e.prototype.clear=function(){this.set=Object.create(null)},e}();var ae=S,se=0,ce=function(){this.id=se++,this.subs=[]};ce.prototype.addSub=function(e){this.subs.push(e)},ce.prototype.removeSub=function(e){h(this.subs,e)},ce.prototype.depend=function(){ce.target&&ce.target.addDep(this)},ce.prototype.notify=function(){for(var e=this.subs.slice(),t=0,n=e.length;t<n;t++)e[t].update()},ce.target=null;var ue=[];function le(e){ue.push(e),ce.target=e}function fe(){ue.pop(),ce.target=ue[ue.length-1]}var pe=function(e,t,n,r,i,o,a,s){this.tag=e,this.data=t,this.children=n,this.text=r,this.elm=i,this.ns=void 0,this.context=o,this.fnContext=void 0,this.fnOptions=void 0,this.fnScopeId=void 0,this.key=t&&t.key,this.componentOptions=a,this.componentInstance=void 0,this.parent=void 0,this.raw=!1,this.isStatic=!1,this.isRootInsert=!0,this.isComment=!1,this.isCloned=!1,this.isOnce=!1,this.asyncFactory=s,this.asyncMeta=void 0,this.isAsyncPlaceholder=!1},de={child:{configurable:!0}};de.child.get=function(){return this.componentInstance},Object.defineProperties(pe.prototype,de);var ve=function(e){void 0===e&&(e="");var t=new pe;return t.text=e,t.isComment=!0,t};function he(e){return new pe(void 0,void 0,void 0,String(e))}function me(e){var t=new pe(e.tag,e.data,e.children&&e.children.slice(),e.text,e.elm,e.context,e.componentOptions,e.asyncFactory);return t.ns=e.ns,t.isStatic=e.isStatic,t.key=e.key,t.isComment=e.isComment,t.fnContext=e.fnContext,t.fnOptions=e.fnOptions,t.fnScopeId=e.fnScopeId,t.asyncMeta=e.asyncMeta,t.isCloned=!0,t}var ye=Array.prototype,ge=Object.create(ye);["push","pop","shift","unshift","splice","sort","reverse"].forEach(function(e){var t=ye[e];R(ge,e,function(){for(var n=[],r=arguments.length;r--;)n[r]=arguments[r];var i,o=t.apply(this,n),a=this.__ob__;switch(e){case"push":case"unshift":i=n;break;case"splice":i=n.slice(2)}return i&&a.observeArray(i),a.dep.notify(),o})});var _e=Object.getOwnPropertyNames(ge),be=!0;function $e(e){be=e}var we=function(e){var t;this.value=e,this.dep=new ce,this.vmCount=0,R(e,"__ob__",this),Array.isArray(e)?(U?(t=ge,e.__proto__=t):function(e,t,n){for(var r=0,i=n.length;r<i;r++){var o=n[r];R(e,o,t[o])}}(e,ge,_e),this.observeArray(e)):this.walk(e)};function Ce(e,t){var n;if(o(e)&&!(e instanceof pe))return y(e,"__ob__")&&e.__ob__ instanceof we?n=e.__ob__:be&&!te()&&(Array.isArray(e)||s(e))&&Object.isExtensible(e)&&!e._isVue&&(n=new we(e)),t&&n&&n.vmCount++,n}function xe(e,t,n,r,i){var o=new ce,a=Object.getOwnPropertyDescriptor(e,t);if(!a||!1!==a.configurable){var s=a&&a.get,c=a&&a.set;s&&!c||2!==arguments.length||(n=e[t]);var u=!i&&Ce(n);Object.defineProperty(e,t,{enumerable:!0,configurable:!0,get:function(){var t=s?s.call(e):n;return ce.target&&(o.depend(),u&&(u.dep.depend(),Array.isArray(t)&&function e(t){for(var n=void 0,r=0,i=t.length;r<i;r++)(n=t[r])&&n.__ob__&&n.__ob__.dep.depend(),Array.isArray(n)&&e(n)}(t))),t},set:function(t){var r=s?s.call(e):n;t===r||t!=t&&r!=r||s&&!c||(c?c.call(e,t):n=t,u=!i&&Ce(t),o.notify())}})}}function ke(e,t,n){if(Array.isArray(e)&&c(t))return e.length=Math.max(e.length,t),e.splice(t,1,n),n;if(t in e&&!(t in Object.prototype))return e[t]=n,n;var r=e.__ob__;return e._isVue||r&&r.vmCount?n:r?(xe(r.value,t,n),r.dep.notify(),n):(e[t]=n,n)}function Ae(e,t){if(Array.isArray(e)&&c(t))e.splice(t,1);else{var n=e.__ob__;e._isVue||n&&n.vmCount||y(e,t)&&(delete e[t],n&&n.dep.notify())}}we.prototype.walk=function(e){for(var t=Object.keys(e),n=0;n<t.length;n++)xe(e,t[n])},we.prototype.observeArray=function(e){for(var t=0,n=e.length;t<n;t++)Ce(e[t])};var Oe=F.optionMergeStrategies;function Se(e,t){if(!t)return e;for(var n,r,i,o=oe?Reflect.ownKeys(t):Object.keys(t),a=0;a<o.length;a++)"__ob__"!==(n=o[a])&&(r=e[n],i=t[n],y(e,n)?r!==i&&s(r)&&s(i)&&Se(r,i):ke(e,n,i));return e}function Te(e,t,n){return n?function(){var r="function"==typeof t?t.call(n,n):t,i="function"==typeof e?e.call(n,n):e;return r?Se(r,i):i}:t?e?function(){return Se("function"==typeof t?t.call(this,this):t,"function"==typeof e?e.call(this,this):e)}:t:e}function Ee(e,t){var n=t?e?e.concat(t):Array.isArray(t)?t:[t]:e;return n?function(e){for(var t=[],n=0;n<e.length;n++)-1===t.indexOf(e[n])&&t.push(e[n]);return t}(n):n}function Ne(e,t,n,r){var i=Object.create(e||null);return t?A(i,t):i}Oe.data=function(e,t,n){return n?Te(e,t,n):t&&"function"!=typeof t?e:Te(e,t)},I.forEach(function(e){Oe[e]=Ee}),M.forEach(function(e){Oe[e+"s"]=Ne}),Oe.watch=function(e,t,n,r){if(e===Y&&(e=void 0),t===Y&&(t=void 0),!t)return Object.create(e||null);if(!e)return t;var i={};for(var o in A(i,e),t){var a=i[o],s=t[o];a&&!Array.isArray(a)&&(a=[a]),i[o]=a?a.concat(s):Array.isArray(s)?s:[s]}return i},Oe.props=Oe.methods=Oe.inject=Oe.computed=function(e,t,n,r){if(!e)return t;var i=Object.create(null);return A(i,e),t&&A(i,t),i},Oe.provide=Te;var je=function(e,t){return void 0===t?e:t};function De(e,t,n){if("function"==typeof t&&(t=t.options),function(e,t){var n=e.props;if(n){var r,i,o={};if(Array.isArray(n))for(r=n.length;r--;)"string"==typeof(i=n[r])&&(o[b(i)]={type:null});else if(s(n))for(var a in n)i=n[a],o[b(a)]=s(i)?i:{type:i};e.props=o}}(t),function(e,t){var n=e.inject;if(n){var r=e.inject={};if(Array.isArray(n))for(var i=0;i<n.length;i++)r[n[i]]={from:n[i]};else if(s(n))for(var o in n){var a=n[o];r[o]=s(a)?A({from:o},a):{from:a}}}}(t),function(e){var t=e.directives;if(t)for(var n in t){var r=t[n];"function"==typeof r&&(t[n]={bind:r,update:r})}}(t),!t._base&&(t.extends&&(e=De(e,t.extends,n)),t.mixins))for(var r=0,i=t.mixins.length;r<i;r++)e=De(e,t.mixins[r],n);var o,a={};for(o in e)c(o);for(o in t)y(e,o)||c(o);function c(r){var i=Oe[r]||je;a[r]=i(e[r],t[r],n,r)}return a}function Le(e,t,n,r){if("string"==typeof n){var i=e[t];if(y(i,n))return i[n];var o=b(n);if(y(i,o))return i[o];var a=$(o);return y(i,a)?i[a]:i[n]||i[o]||i[a]}}function Me(e,t,n,r){var i=t[e],o=!y(n,e),a=n[e],s=Pe(Boolean,i.type);if(s>-1)if(o&&!y(i,"default"))a=!1;else if(""===a||a===C(e)){var c=Pe(String,i.type);(c<0||s<c)&&(a=!0)}if(void 0===a){a=function(e,t,n){if(!y(t,"default"))return;var r=t.default;if(e&&e.$options.propsData&&void 0===e.$options.propsData[n]&&void 0!==e._props[n])return e._props[n];return"function"==typeof r&&"Function"!==Ie(t.type)?r.call(e):r}(r,i,e);var u=be;$e(!0),Ce(a),$e(u)}return a}function Ie(e){var t=e&&e.toString().match(/^\s*function (\w+)/);return t?t[1]:""}function Fe(e,t){return Ie(e)===Ie(t)}function Pe(e,t){if(!Array.isArray(t))return Fe(t,e)?0:-1;for(var n=0,r=t.length;n<r;n++)if(Fe(t[n],e))return n;return-1}function Re(e,t,n){le();try{if(t)for(var r=t;r=r.$parent;){var i=r.$options.errorCaptured;if(i)for(var o=0;o<i.length;o++)try{if(!1===i[o].call(r,e,t,n))return}catch(e){Be(e,r,"errorCaptured hook")}}Be(e,t,n)}finally{fe()}}function He(e,t,n,r,i){var o;try{(o=n?e.apply(t,n):e.call(t))&&!o._isVue&&u(o)&&!o._handled&&(o.catch(function(e){return Re(e,r,i+" (Promise/async)")}),o._handled=!0)}catch(e){Re(e,r,i)}return o}function Be(e,t,n){if(F.errorHandler)try{return F.errorHandler.call(null,e,t,n)}catch(t){t!==e&&Ue(t,null,"config.errorHandler")}Ue(e,t,n)}function Ue(e,t,n){if(!z&&!V||"undefined"==typeof console)throw e;console.error(e)}var ze,Ve=!1,Ke=[],Je=!1;function qe(){Je=!1;var e=Ke.slice(0);Ke.length=0;for(var t=0;t<e.length;t++)e[t]()}if("undefined"!=typeof Promise&&re(Promise)){var We=Promise.resolve();ze=function(){We.then(qe),G&&setTimeout(S)},Ve=!0}else if(q||"undefined"==typeof MutationObserver||!re(MutationObserver)&&"[object MutationObserverConstructor]"!==MutationObserver.toString())ze="undefined"!=typeof setImmediate&&re(setImmediate)?function(){setImmediate(qe)}:function(){setTimeout(qe,0)};else{var Ze=1,Ge=new MutationObserver(qe),Xe=document.createTextNode(String(Ze));Ge.observe(Xe,{characterData:!0}),ze=function(){Ze=(Ze+1)%2,Xe.data=String(Ze)},Ve=!0}function Ye(e,t){var n;if(Ke.push(function(){if(e)try{e.call(t)}catch(e){Re(e,t,"nextTick")}else n&&n(t)}),Je||(Je=!0,ze()),!e&&"undefined"!=typeof Promise)return new Promise(function(e){n=e})}var Qe=new ie;function et(e){!function e(t,n){var r,i;var a=Array.isArray(t);if(!a&&!o(t)||Object.isFrozen(t)||t instanceof pe)return;if(t.__ob__){var s=t.__ob__.dep.id;if(n.has(s))return;n.add(s)}if(a)for(r=t.length;r--;)e(t[r],n);else for(i=Object.keys(t),r=i.length;r--;)e(t[i[r]],n)}(e,Qe),Qe.clear()}var tt=g(function(e){var t="&"===e.charAt(0),n="~"===(e=t?e.slice(1):e).charAt(0),r="!"===(e=n?e.slice(1):e).charAt(0);return{name:e=r?e.slice(1):e,once:n,capture:r,passive:t}});function nt(e,t){function n(){var e=arguments,r=n.fns;if(!Array.isArray(r))return He(r,null,arguments,t,"v-on handler");for(var i=r.slice(),o=0;o<i.length;o++)He(i[o],null,e,t,"v-on handler")}return n.fns=e,n}function rt(e,n,i,o,a,s){var c,u,l,f;for(c in e)u=e[c],l=n[c],f=tt(c),t(u)||(t(l)?(t(u.fns)&&(u=e[c]=nt(u,s)),r(f.once)&&(u=e[c]=a(f.name,u,f.capture)),i(f.name,u,f.capture,f.passive,f.params)):u!==l&&(l.fns=u,e[c]=l));for(c in n)t(e[c])&&o((f=tt(c)).name,n[c],f.capture)}function it(e,i,o){var a;e instanceof pe&&(e=e.data.hook||(e.data.hook={}));var s=e[i];function c(){o.apply(this,arguments),h(a.fns,c)}t(s)?a=nt([c]):n(s.fns)&&r(s.merged)?(a=s).fns.push(c):a=nt([s,c]),a.merged=!0,e[i]=a}function ot(e,t,r,i,o){if(n(t)){if(y(t,r))return e[r]=t[r],o||delete t[r],!0;if(y(t,i))return e[r]=t[i],o||delete t[i],!0}return!1}function at(e){return i(e)?[he(e)]:Array.isArray(e)?function e(o,a){var s=[];var c,u,l,f;for(c=0;c<o.length;c++)t(u=o[c])||"boolean"==typeof u||(l=s.length-1,f=s[l],Array.isArray(u)?u.length>0&&(st((u=e(u,(a||"")+"_"+c))[0])&&st(f)&&(s[l]=he(f.text+u[0].text),u.shift()),s.push.apply(s,u)):i(u)?st(f)?s[l]=he(f.text+u):""!==u&&s.push(he(u)):st(u)&&st(f)?s[l]=he(f.text+u.text):(r(o._isVList)&&n(u.tag)&&t(u.key)&&n(a)&&(u.key="__vlist"+a+"_"+c+"__"),s.push(u)));return s}(e):void 0}function st(e){return n(e)&&n(e.text)&&!1===e.isComment}function ct(e,t){if(e){for(var n=Object.create(null),r=oe?Reflect.ownKeys(e):Object.keys(e),i=0;i<r.length;i++){var o=r[i];if("__ob__"!==o){for(var a=e[o].from,s=t;s;){if(s._provided&&y(s._provided,a)){n[o]=s._provided[a];break}s=s.$parent}if(!s&&"default"in e[o]){var c=e[o].default;n[o]="function"==typeof c?c.call(t):c}}}return n}}function ut(e,t){if(!e||!e.length)return{};for(var n={},r=0,i=e.length;r<i;r++){var o=e[r],a=o.data;if(a&&a.attrs&&a.attrs.slot&&delete a.attrs.slot,o.context!==t&&o.fnContext!==t||!a||null==a.slot)(n.default||(n.default=[])).push(o);else{var s=a.slot,c=n[s]||(n[s]=[]);"template"===o.tag?c.push.apply(c,o.children||[]):c.push(o)}}for(var u in n)n[u].every(lt)&&delete n[u];return n}function lt(e){return e.isComment&&!e.asyncFactory||" "===e.text}function ft(t,n,r){var i,o=Object.keys(n).length>0,a=t?!!t.$stable:!o,s=t&&t.$key;if(t){if(t._normalized)return t._normalized;if(a&&r&&r!==e&&s===r.$key&&!o&&!r.$hasNormal)return r;for(var c in i={},t)t[c]&&"$"!==c[0]&&(i[c]=pt(n,c,t[c]))}else i={};for(var u in n)u in i||(i[u]=dt(n,u));return t&&Object.isExtensible(t)&&(t._normalized=i),R(i,"$stable",a),R(i,"$key",s),R(i,"$hasNormal",o),i}function pt(e,t,n){var r=function(){var e=arguments.length?n.apply(null,arguments):n({});return(e=e&&"object"==typeof e&&!Array.isArray(e)?[e]:at(e))&&(0===e.length||1===e.length&&e[0].isComment)?void 0:e};return n.proxy&&Object.defineProperty(e,t,{get:r,enumerable:!0,configurable:!0}),r}function dt(e,t){return function(){return e[t]}}function vt(e,t){var r,i,a,s,c;if(Array.isArray(e)||"string"==typeof e)for(r=new Array(e.length),i=0,a=e.length;i<a;i++)r[i]=t(e[i],i);else if("number"==typeof e)for(r=new Array(e),i=0;i<e;i++)r[i]=t(i+1,i);else if(o(e))if(oe&&e[Symbol.iterator]){r=[];for(var u=e[Symbol.iterator](),l=u.next();!l.done;)r.push(t(l.value,r.length)),l=u.next()}else for(s=Object.keys(e),r=new Array(s.length),i=0,a=s.length;i<a;i++)c=s[i],r[i]=t(e[c],c,i);return n(r)||(r=[]),r._isVList=!0,r}function ht(e,t,n,r){var i,o=this.$scopedSlots[e];o?(n=n||{},r&&(n=A(A({},r),n)),i=o(n)||t):i=this.$slots[e]||t;var a=n&&n.slot;return a?this.$createElement("template",{slot:a},i):i}function mt(e){return Le(this.$options,"filters",e)||E}function yt(e,t){return Array.isArray(e)?-1===e.indexOf(t):e!==t}function gt(e,t,n,r,i){var o=F.keyCodes[t]||n;return i&&r&&!F.keyCodes[t]?yt(i,r):o?yt(o,e):r?C(r)!==t:void 0}function _t(e,t,n,r,i){if(n)if(o(n)){var a;Array.isArray(n)&&(n=O(n));var s=function(o){if("class"===o||"style"===o||v(o))a=e;else{var s=e.attrs&&e.attrs.type;a=r||F.mustUseProp(t,s,o)?e.domProps||(e.domProps={}):e.attrs||(e.attrs={})}var c=b(o),u=C(o);c in a||u in a||(a[o]=n[o],i&&((e.on||(e.on={}))["update:"+o]=function(e){n[o]=e}))};for(var c in n)s(c)}else;return e}function bt(e,t){var n=this._staticTrees||(this._staticTrees=[]),r=n[e];return r&&!t?r:(wt(r=n[e]=this.$options.staticRenderFns[e].call(this._renderProxy,null,this),"__static__"+e,!1),r)}function $t(e,t,n){return wt(e,"__once__"+t+(n?"_"+n:""),!0),e}function wt(e,t,n){if(Array.isArray(e))for(var r=0;r<e.length;r++)e[r]&&"string"!=typeof e[r]&&Ct(e[r],t+"_"+r,n);else Ct(e,t,n)}function Ct(e,t,n){e.isStatic=!0,e.key=t,e.isOnce=n}function xt(e,t){if(t)if(s(t)){var n=e.on=e.on?A({},e.on):{};for(var r in t){var i=n[r],o=t[r];n[r]=i?[].concat(i,o):o}}else;return e}function kt(e,t,n,r){t=t||{$stable:!n};for(var i=0;i<e.length;i++){var o=e[i];Array.isArray(o)?kt(o,t,n):o&&(o.proxy&&(o.fn.proxy=!0),t[o.key]=o.fn)}return r&&(t.$key=r),t}function At(e,t){for(var n=0;n<t.length;n+=2){var r=t[n];"string"==typeof r&&r&&(e[t[n]]=t[n+1])}return e}function Ot(e,t){return"string"==typeof e?t+e:e}function St(e){e._o=$t,e._n=f,e._s=l,e._l=vt,e._t=ht,e._q=N,e._i=j,e._m=bt,e._f=mt,e._k=gt,e._b=_t,e._v=he,e._e=ve,e._u=kt,e._g=xt,e._d=At,e._p=Ot}function Tt(t,n,i,o,a){var s,c=this,u=a.options;y(o,"_uid")?(s=Object.create(o))._original=o:(s=o,o=o._original);var l=r(u._compiled),f=!l;this.data=t,this.props=n,this.children=i,this.parent=o,this.listeners=t.on||e,this.injections=ct(u.inject,o),this.slots=function(){return c.$slots||ft(t.scopedSlots,c.$slots=ut(i,o)),c.$slots},Object.defineProperty(this,"scopedSlots",{enumerable:!0,get:function(){return ft(t.scopedSlots,this.slots())}}),l&&(this.$options=u,this.$slots=this.slots(),this.$scopedSlots=ft(t.scopedSlots,this.$slots)),u._scopeId?this._c=function(e,t,n,r){var i=Pt(s,e,t,n,r,f);return i&&!Array.isArray(i)&&(i.fnScopeId=u._scopeId,i.fnContext=o),i}:this._c=function(e,t,n,r){return Pt(s,e,t,n,r,f)}}function Et(e,t,n,r,i){var o=me(e);return o.fnContext=n,o.fnOptions=r,t.slot&&((o.data||(o.data={})).slot=t.slot),o}function Nt(e,t){for(var n in t)e[b(n)]=t[n]}St(Tt.prototype);var jt={init:function(e,t){if(e.componentInstance&&!e.componentInstance._isDestroyed&&e.data.keepAlive){var r=e;jt.prepatch(r,r)}else{(e.componentInstance=function(e,t){var r={_isComponent:!0,_parentVnode:e,parent:t},i=e.data.inlineTemplate;n(i)&&(r.render=i.render,r.staticRenderFns=i.staticRenderFns);return new e.componentOptions.Ctor(r)}(e,Wt)).$mount(t?e.elm:void 0,t)}},prepatch:function(t,n){var r=n.componentOptions;!function(t,n,r,i,o){var a=i.data.scopedSlots,s=t.$scopedSlots,c=!!(a&&!a.$stable||s!==e&&!s.$stable||a&&t.$scopedSlots.$key!==a.$key),u=!!(o||t.$options._renderChildren||c);t.$options._parentVnode=i,t.$vnode=i,t._vnode&&(t._vnode.parent=i);if(t.$options._renderChildren=o,t.$attrs=i.data.attrs||e,t.$listeners=r||e,n&&t.$options.props){$e(!1);for(var l=t._props,f=t.$options._propKeys||[],p=0;p<f.length;p++){var d=f[p],v=t.$options.props;l[d]=Me(d,v,n,t)}$e(!0),t.$options.propsData=n}r=r||e;var h=t.$options._parentListeners;t.$options._parentListeners=r,qt(t,r,h),u&&(t.$slots=ut(o,i.context),t.$forceUpdate())}(n.componentInstance=t.componentInstance,r.propsData,r.listeners,n,r.children)},insert:function(e){var t,n=e.context,r=e.componentInstance;r._isMounted||(r._isMounted=!0,Yt(r,"mounted")),e.data.keepAlive&&(n._isMounted?((t=r)._inactive=!1,en.push(t)):Xt(r,!0))},destroy:function(e){var t=e.componentInstance;t._isDestroyed||(e.data.keepAlive?function e(t,n){if(n&&(t._directInactive=!0,Gt(t)))return;if(!t._inactive){t._inactive=!0;for(var r=0;r<t.$children.length;r++)e(t.$children[r]);Yt(t,"deactivated")}}(t,!0):t.$destroy())}},Dt=Object.keys(jt);function Lt(i,a,s,c,l){if(!t(i)){var f=s.$options._base;if(o(i)&&(i=f.extend(i)),"function"==typeof i){var p;if(t(i.cid)&&void 0===(i=function(e,i){if(r(e.error)&&n(e.errorComp))return e.errorComp;if(n(e.resolved))return e.resolved;var a=Ht;a&&n(e.owners)&&-1===e.owners.indexOf(a)&&e.owners.push(a);if(r(e.loading)&&n(e.loadingComp))return e.loadingComp;if(a&&!n(e.owners)){var s=e.owners=[a],c=!0,l=null,f=null;a.$on("hook:destroyed",function(){return h(s,a)});var p=function(e){for(var t=0,n=s.length;t<n;t++)s[t].$forceUpdate();e&&(s.length=0,null!==l&&(clearTimeout(l),l=null),null!==f&&(clearTimeout(f),f=null))},d=D(function(t){e.resolved=Bt(t,i),c?s.length=0:p(!0)}),v=D(function(t){n(e.errorComp)&&(e.error=!0,p(!0))}),m=e(d,v);return o(m)&&(u(m)?t(e.resolved)&&m.then(d,v):u(m.component)&&(m.component.then(d,v),n(m.error)&&(e.errorComp=Bt(m.error,i)),n(m.loading)&&(e.loadingComp=Bt(m.loading,i),0===m.delay?e.loading=!0:l=setTimeout(function(){l=null,t(e.resolved)&&t(e.error)&&(e.loading=!0,p(!1))},m.delay||200)),n(m.timeout)&&(f=setTimeout(function(){f=null,t(e.resolved)&&v(null)},m.timeout)))),c=!1,e.loading?e.loadingComp:e.resolved}}(p=i,f)))return function(e,t,n,r,i){var o=ve();return o.asyncFactory=e,o.asyncMeta={data:t,context:n,children:r,tag:i},o}(p,a,s,c,l);a=a||{},$n(i),n(a.model)&&function(e,t){var r=e.model&&e.model.prop||"value",i=e.model&&e.model.event||"input";(t.attrs||(t.attrs={}))[r]=t.model.value;var o=t.on||(t.on={}),a=o[i],s=t.model.callback;n(a)?(Array.isArray(a)?-1===a.indexOf(s):a!==s)&&(o[i]=[s].concat(a)):o[i]=s}(i.options,a);var d=function(e,r,i){var o=r.options.props;if(!t(o)){var a={},s=e.attrs,c=e.props;if(n(s)||n(c))for(var u in o){var l=C(u);ot(a,c,u,l,!0)||ot(a,s,u,l,!1)}return a}}(a,i);if(r(i.options.functional))return function(t,r,i,o,a){var s=t.options,c={},u=s.props;if(n(u))for(var l in u)c[l]=Me(l,u,r||e);else n(i.attrs)&&Nt(c,i.attrs),n(i.props)&&Nt(c,i.props);var f=new Tt(i,c,a,o,t),p=s.render.call(null,f._c,f);if(p instanceof pe)return Et(p,i,f.parent,s);if(Array.isArray(p)){for(var d=at(p)||[],v=new Array(d.length),h=0;h<d.length;h++)v[h]=Et(d[h],i,f.parent,s);return v}}(i,d,a,s,c);var v=a.on;if(a.on=a.nativeOn,r(i.options.abstract)){var m=a.slot;a={},m&&(a.slot=m)}!function(e){for(var t=e.hook||(e.hook={}),n=0;n<Dt.length;n++){var r=Dt[n],i=t[r],o=jt[r];i===o||i&&i._merged||(t[r]=i?Mt(o,i):o)}}(a);var y=i.options.name||l;return new pe("vue-component-"+i.cid+(y?"-"+y:""),a,void 0,void 0,void 0,s,{Ctor:i,propsData:d,listeners:v,tag:l,children:c},p)}}}function Mt(e,t){var n=function(n,r){e(n,r),t(n,r)};return n._merged=!0,n}var It=1,Ft=2;function Pt(e,a,s,c,u,l){return(Array.isArray(s)||i(s))&&(u=c,c=s,s=void 0),r(l)&&(u=Ft),function(e,i,a,s,c){if(n(a)&&n(a.__ob__))return ve();n(a)&&n(a.is)&&(i=a.is);if(!i)return ve();Array.isArray(s)&&"function"==typeof s[0]&&((a=a||{}).scopedSlots={default:s[0]},s.length=0);c===Ft?s=at(s):c===It&&(s=function(e){for(var t=0;t<e.length;t++)if(Array.isArray(e[t]))return Array.prototype.concat.apply([],e);return e}(s));var u,l;if("string"==typeof i){var f;l=e.$vnode&&e.$vnode.ns||F.getTagNamespace(i),u=F.isReservedTag(i)?new pe(F.parsePlatformTagName(i),a,s,void 0,void 0,e):a&&a.pre||!n(f=Le(e.$options,"components",i))?new pe(i,a,s,void 0,void 0,e):Lt(f,a,e,s,i)}else u=Lt(i,a,e,s);return Array.isArray(u)?u:n(u)?(n(l)&&function e(i,o,a){i.ns=o;"foreignObject"===i.tag&&(o=void 0,a=!0);if(n(i.children))for(var s=0,c=i.children.length;s<c;s++){var u=i.children[s];n(u.tag)&&(t(u.ns)||r(a)&&"svg"!==u.tag)&&e(u,o,a)}}(u,l),n(a)&&function(e){o(e.style)&&et(e.style);o(e.class)&&et(e.class)}(a),u):ve()}(e,a,s,c,u)}var Rt,Ht=null;function Bt(e,t){return(e.__esModule||oe&&"Module"===e[Symbol.toStringTag])&&(e=e.default),o(e)?t.extend(e):e}function Ut(e){return e.isComment&&e.asyncFactory}function zt(e){if(Array.isArray(e))for(var t=0;t<e.length;t++){var r=e[t];if(n(r)&&(n(r.componentOptions)||Ut(r)))return r}}function Vt(e,t){Rt.$on(e,t)}function Kt(e,t){Rt.$off(e,t)}function Jt(e,t){var n=Rt;return function r(){null!==t.apply(null,arguments)&&n.$off(e,r)}}function qt(e,t,n){Rt=e,rt(t,n||{},Vt,Kt,Jt,e),Rt=void 0}var Wt=null;function Zt(e){var t=Wt;return Wt=e,function(){Wt=t}}function Gt(e){for(;e&&(e=e.$parent);)if(e._inactive)return!0;return!1}function Xt(e,t){if(t){if(e._directInactive=!1,Gt(e))return}else if(e._directInactive)return;if(e._inactive||null===e._inactive){e._inactive=!1;for(var n=0;n<e.$children.length;n++)Xt(e.$children[n]);Yt(e,"activated")}}function Yt(e,t){le();var n=e.$options[t],r=t+" hook";if(n)for(var i=0,o=n.length;i<o;i++)He(n[i],e,null,e,r);e._hasHookEvent&&e.$emit("hook:"+t),fe()}var Qt=[],en=[],tn={},nn=!1,rn=!1,on=0;var an=0,sn=Date.now;if(z&&!q){var cn=window.performance;cn&&"function"==typeof cn.now&&sn()>document.createEvent("Event").timeStamp&&(sn=function(){return cn.now()})}function un(){var e,t;for(an=sn(),rn=!0,Qt.sort(function(e,t){return e.id-t.id}),on=0;on<Qt.length;on++)(e=Qt[on]).before&&e.before(),t=e.id,tn[t]=null,e.run();var n=en.slice(),r=Qt.slice();on=Qt.length=en.length=0,tn={},nn=rn=!1,function(e){for(var t=0;t<e.length;t++)e[t]._inactive=!0,Xt(e[t],!0)}(n),function(e){var t=e.length;for(;t--;){var n=e[t],r=n.vm;r._watcher===n&&r._isMounted&&!r._isDestroyed&&Yt(r,"updated")}}(r),ne&&F.devtools&&ne.emit("flush")}var ln=0,fn=function(e,t,n,r,i){this.vm=e,i&&(e._watcher=this),e._watchers.push(this),r?(this.deep=!!r.deep,this.user=!!r.user,this.lazy=!!r.lazy,this.sync=!!r.sync,this.before=r.before):this.deep=this.user=this.lazy=this.sync=!1,this.cb=n,this.id=++ln,this.active=!0,this.dirty=this.lazy,this.deps=[],this.newDeps=[],this.depIds=new ie,this.newDepIds=new ie,this.expression="","function"==typeof t?this.getter=t:(this.getter=function(e){if(!H.test(e)){var t=e.split(".");return function(e){for(var n=0;n<t.length;n++){if(!e)return;e=e[t[n]]}return e}}}(t),this.getter||(this.getter=S)),this.value=this.lazy?void 0:this.get()};fn.prototype.get=function(){var e;le(this);var t=this.vm;try{e=this.getter.call(t,t)}catch(e){if(!this.user)throw e;Re(e,t,'getter for watcher "'+this.expression+'"')}finally{this.deep&&et(e),fe(),this.cleanupDeps()}return e},fn.prototype.addDep=function(e){var t=e.id;this.newDepIds.has(t)||(this.newDepIds.add(t),this.newDeps.push(e),this.depIds.has(t)||e.addSub(this))},fn.prototype.cleanupDeps=function(){for(var e=this.deps.length;e--;){var t=this.deps[e];this.newDepIds.has(t.id)||t.removeSub(this)}var n=this.depIds;this.depIds=this.newDepIds,this.newDepIds=n,this.newDepIds.clear(),n=this.deps,this.deps=this.newDeps,this.newDeps=n,this.newDeps.length=0},fn.prototype.update=function(){this.lazy?this.dirty=!0:this.sync?this.run():function(e){var t=e.id;if(null==tn[t]){if(tn[t]=!0,rn){for(var n=Qt.length-1;n>on&&Qt[n].id>e.id;)n--;Qt.splice(n+1,0,e)}else Qt.push(e);nn||(nn=!0,Ye(un))}}(this)},fn.prototype.run=function(){if(this.active){var e=this.get();if(e!==this.value||o(e)||this.deep){var t=this.value;if(this.value=e,this.user)try{this.cb.call(this.vm,e,t)}catch(e){Re(e,this.vm,'callback for watcher "'+this.expression+'"')}else this.cb.call(this.vm,e,t)}}},fn.prototype.evaluate=function(){this.value=this.get(),this.dirty=!1},fn.prototype.depend=function(){for(var e=this.deps.length;e--;)this.deps[e].depend()},fn.prototype.teardown=function(){if(this.active){this.vm._isBeingDestroyed||h(this.vm._watchers,this);for(var e=this.deps.length;e--;)this.deps[e].removeSub(this);this.active=!1}};var pn={enumerable:!0,configurable:!0,get:S,set:S};function dn(e,t,n){pn.get=function(){return this[t][n]},pn.set=function(e){this[t][n]=e},Object.defineProperty(e,n,pn)}function vn(e){e._watchers=[];var t=e.$options;t.props&&function(e,t){var n=e.$options.propsData||{},r=e._props={},i=e.$options._propKeys=[];e.$parent&&$e(!1);var o=function(o){i.push(o);var a=Me(o,t,n,e);xe(r,o,a),o in e||dn(e,"_props",o)};for(var a in t)o(a);$e(!0)}(e,t.props),t.methods&&function(e,t){e.$options.props;for(var n in t)e[n]="function"!=typeof t[n]?S:x(t[n],e)}(e,t.methods),t.data?function(e){var t=e.$options.data;s(t=e._data="function"==typeof t?function(e,t){le();try{return e.call(t,t)}catch(e){return Re(e,t,"data()"),{}}finally{fe()}}(t,e):t||{})||(t={});var n=Object.keys(t),r=e.$options.props,i=(e.$options.methods,n.length);for(;i--;){var o=n[i];r&&y(r,o)||(a=void 0,36!==(a=(o+"").charCodeAt(0))&&95!==a&&dn(e,"_data",o))}var a;Ce(t,!0)}(e):Ce(e._data={},!0),t.computed&&function(e,t){var n=e._computedWatchers=Object.create(null),r=te();for(var i in t){var o=t[i],a="function"==typeof o?o:o.get;r||(n[i]=new fn(e,a||S,S,hn)),i in e||mn(e,i,o)}}(e,t.computed),t.watch&&t.watch!==Y&&function(e,t){for(var n in t){var r=t[n];if(Array.isArray(r))for(var i=0;i<r.length;i++)_n(e,n,r[i]);else _n(e,n,r)}}(e,t.watch)}var hn={lazy:!0};function mn(e,t,n){var r=!te();"function"==typeof n?(pn.get=r?yn(t):gn(n),pn.set=S):(pn.get=n.get?r&&!1!==n.cache?yn(t):gn(n.get):S,pn.set=n.set||S),Object.defineProperty(e,t,pn)}function yn(e){return function(){var t=this._computedWatchers&&this._computedWatchers[e];if(t)return t.dirty&&t.evaluate(),ce.target&&t.depend(),t.value}}function gn(e){return function(){return e.call(this,this)}}function _n(e,t,n,r){return s(n)&&(r=n,n=n.handler),"string"==typeof n&&(n=e[n]),e.$watch(t,n,r)}var bn=0;function $n(e){var t=e.options;if(e.super){var n=$n(e.super);if(n!==e.superOptions){e.superOptions=n;var r=function(e){var t,n=e.options,r=e.sealedOptions;for(var i in n)n[i]!==r[i]&&(t||(t={}),t[i]=n[i]);return t}(e);r&&A(e.extendOptions,r),(t=e.options=De(n,e.extendOptions)).name&&(t.components[t.name]=e)}}return t}function wn(e){this._init(e)}function Cn(e){e.cid=0;var t=1;e.extend=function(e){e=e||{};var n=this,r=n.cid,i=e._Ctor||(e._Ctor={});if(i[r])return i[r];var o=e.name||n.options.name,a=function(e){this._init(e)};return(a.prototype=Object.create(n.prototype)).constructor=a,a.cid=t++,a.options=De(n.options,e),a.super=n,a.options.props&&function(e){var t=e.options.props;for(var n in t)dn(e.prototype,"_props",n)}(a),a.options.computed&&function(e){var t=e.options.computed;for(var n in t)mn(e.prototype,n,t[n])}(a),a.extend=n.extend,a.mixin=n.mixin,a.use=n.use,M.forEach(function(e){a[e]=n[e]}),o&&(a.options.components[o]=a),a.superOptions=n.options,a.extendOptions=e,a.sealedOptions=A({},a.options),i[r]=a,a}}function xn(e){return e&&(e.Ctor.options.name||e.tag)}function kn(e,t){return Array.isArray(e)?e.indexOf(t)>-1:"string"==typeof e?e.split(",").indexOf(t)>-1:(n=e,"[object RegExp]"===a.call(n)&&e.test(t));var n}function An(e,t){var n=e.cache,r=e.keys,i=e._vnode;for(var o in n){var a=n[o];if(a){var s=xn(a.componentOptions);s&&!t(s)&&On(n,o,r,i)}}}function On(e,t,n,r){var i=e[t];!i||r&&i.tag===r.tag||i.componentInstance.$destroy(),e[t]=null,h(n,t)}!function(t){t.prototype._init=function(t){var n=this;n._uid=bn++,n._isVue=!0,t&&t._isComponent?function(e,t){var n=e.$options=Object.create(e.constructor.options),r=t._parentVnode;n.parent=t.parent,n._parentVnode=r;var i=r.componentOptions;n.propsData=i.propsData,n._parentListeners=i.listeners,n._renderChildren=i.children,n._componentTag=i.tag,t.render&&(n.render=t.render,n.staticRenderFns=t.staticRenderFns)}(n,t):n.$options=De($n(n.constructor),t||{},n),n._renderProxy=n,n._self=n,function(e){var t=e.$options,n=t.parent;if(n&&!t.abstract){for(;n.$options.abstract&&n.$parent;)n=n.$parent;n.$children.push(e)}e.$parent=n,e.$root=n?n.$root:e,e.$children=[],e.$refs={},e._watcher=null,e._inactive=null,e._directInactive=!1,e._isMounted=!1,e._isDestroyed=!1,e._isBeingDestroyed=!1}(n),function(e){e._events=Object.create(null),e._hasHookEvent=!1;var t=e.$options._parentListeners;t&&qt(e,t)}(n),function(t){t._vnode=null,t._staticTrees=null;var n=t.$options,r=t.$vnode=n._parentVnode,i=r&&r.context;t.$slots=ut(n._renderChildren,i),t.$scopedSlots=e,t._c=function(e,n,r,i){return Pt(t,e,n,r,i,!1)},t.$createElement=function(e,n,r,i){return Pt(t,e,n,r,i,!0)};var o=r&&r.data;xe(t,"$attrs",o&&o.attrs||e,null,!0),xe(t,"$listeners",n._parentListeners||e,null,!0)}(n),Yt(n,"beforeCreate"),function(e){var t=ct(e.$options.inject,e);t&&($e(!1),Object.keys(t).forEach(function(n){xe(e,n,t[n])}),$e(!0))}(n),vn(n),function(e){var t=e.$options.provide;t&&(e._provided="function"==typeof t?t.call(e):t)}(n),Yt(n,"created"),n.$options.el&&n.$mount(n.$options.el)}}(wn),function(e){var t={get:function(){return this._data}},n={get:function(){return this._props}};Object.defineProperty(e.prototype,"$data",t),Object.defineProperty(e.prototype,"$props",n),e.prototype.$set=ke,e.prototype.$delete=Ae,e.prototype.$watch=function(e,t,n){if(s(t))return _n(this,e,t,n);(n=n||{}).user=!0;var r=new fn(this,e,t,n);if(n.immediate)try{t.call(this,r.value)}catch(e){Re(e,this,'callback for immediate watcher "'+r.expression+'"')}return function(){r.teardown()}}}(wn),function(e){var t=/^hook:/;e.prototype.$on=function(e,n){var r=this;if(Array.isArray(e))for(var i=0,o=e.length;i<o;i++)r.$on(e[i],n);else(r._events[e]||(r._events[e]=[])).push(n),t.test(e)&&(r._hasHookEvent=!0);return r},e.prototype.$once=function(e,t){var n=this;function r(){n.$off(e,r),t.apply(n,arguments)}return r.fn=t,n.$on(e,r),n},e.prototype.$off=function(e,t){var n=this;if(!arguments.length)return n._events=Object.create(null),n;if(Array.isArray(e)){for(var r=0,i=e.length;r<i;r++)n.$off(e[r],t);return n}var o,a=n._events[e];if(!a)return n;if(!t)return n._events[e]=null,n;for(var s=a.length;s--;)if((o=a[s])===t||o.fn===t){a.splice(s,1);break}return n},e.prototype.$emit=function(e){var t=this._events[e];if(t){t=t.length>1?k(t):t;for(var n=k(arguments,1),r='event handler for "'+e+'"',i=0,o=t.length;i<o;i++)He(t[i],this,n,this,r)}return this}}(wn),function(e){e.prototype._update=function(e,t){var n=this,r=n.$el,i=n._vnode,o=Zt(n);n._vnode=e,n.$el=i?n.__patch__(i,e):n.__patch__(n.$el,e,t,!1),o(),r&&(r.__vue__=null),n.$el&&(n.$el.__vue__=n),n.$vnode&&n.$parent&&n.$vnode===n.$parent._vnode&&(n.$parent.$el=n.$el)},e.prototype.$forceUpdate=function(){this._watcher&&this._watcher.update()},e.prototype.$destroy=function(){var e=this;if(!e._isBeingDestroyed){Yt(e,"beforeDestroy"),e._isBeingDestroyed=!0;var t=e.$parent;!t||t._isBeingDestroyed||e.$options.abstract||h(t.$children,e),e._watcher&&e._watcher.teardown();for(var n=e._watchers.length;n--;)e._watchers[n].teardown();e._data.__ob__&&e._data.__ob__.vmCount--,e._isDestroyed=!0,e.__patch__(e._vnode,null),Yt(e,"destroyed"),e.$off(),e.$el&&(e.$el.__vue__=null),e.$vnode&&(e.$vnode.parent=null)}}}(wn),function(e){St(e.prototype),e.prototype.$nextTick=function(e){return Ye(e,this)},e.prototype._render=function(){var e,t=this,n=t.$options,r=n.render,i=n._parentVnode;i&&(t.$scopedSlots=ft(i.data.scopedSlots,t.$slots,t.$scopedSlots)),t.$vnode=i;try{Ht=t,e=r.call(t._renderProxy,t.$createElement)}catch(n){Re(n,t,"render"),e=t._vnode}finally{Ht=null}return Array.isArray(e)&&1===e.length&&(e=e[0]),e instanceof pe||(e=ve()),e.parent=i,e}}(wn);var Sn=[String,RegExp,Array],Tn={KeepAlive:{name:"keep-alive",abstract:!0,props:{include:Sn,exclude:Sn,max:[String,Number]},created:function(){this.cache=Object.create(null),this.keys=[]},destroyed:function(){for(var e in this.cache)On(this.cache,e,this.keys)},mounted:function(){var e=this;this.$watch("include",function(t){An(e,function(e){return kn(t,e)})}),this.$watch("exclude",function(t){An(e,function(e){return!kn(t,e)})})},render:function(){var e=this.$slots.default,t=zt(e),n=t&&t.componentOptions;if(n){var r=xn(n),i=this.include,o=this.exclude;if(i&&(!r||!kn(i,r))||o&&r&&kn(o,r))return t;var a=this.cache,s=this.keys,c=null==t.key?n.Ctor.cid+(n.tag?"::"+n.tag:""):t.key;a[c]?(t.componentInstance=a[c].componentInstance,h(s,c),s.push(c)):(a[c]=t,s.push(c),this.max&&s.length>parseInt(this.max)&&On(a,s[0],s,this._vnode)),t.data.keepAlive=!0}return t||e&&e[0]}}};!function(e){var t={get:function(){return F}};Object.defineProperty(e,"config",t),e.util={warn:ae,extend:A,mergeOptions:De,defineReactive:xe},e.set=ke,e.delete=Ae,e.nextTick=Ye,e.observable=function(e){return Ce(e),e},e.options=Object.create(null),M.forEach(function(t){e.options[t+"s"]=Object.create(null)}),e.options._base=e,A(e.options.components,Tn),function(e){e.use=function(e){var t=this._installedPlugins||(this._installedPlugins=[]);if(t.indexOf(e)>-1)return this;var n=k(arguments,1);return n.unshift(this),"function"==typeof e.install?e.install.apply(e,n):"function"==typeof e&&e.apply(null,n),t.push(e),this}}(e),function(e){e.mixin=function(e){return this.options=De(this.options,e),this}}(e),Cn(e),function(e){M.forEach(function(t){e[t]=function(e,n){return n?("component"===t&&s(n)&&(n.name=n.name||e,n=this.options._base.extend(n)),"directive"===t&&"function"==typeof n&&(n={bind:n,update:n}),this.options[t+"s"][e]=n,n):this.options[t+"s"][e]}})}(e)}(wn),Object.defineProperty(wn.prototype,"$isServer",{get:te}),Object.defineProperty(wn.prototype,"$ssrContext",{get:function(){return this.$vnode&&this.$vnode.ssrContext}}),Object.defineProperty(wn,"FunctionalRenderContext",{value:Tt}),wn.version="2.6.11";var En=p("style,class"),Nn=p("input,textarea,option,select,progress"),jn=function(e,t,n){return"value"===n&&Nn(e)&&"button"!==t||"selected"===n&&"option"===e||"checked"===n&&"input"===e||"muted"===n&&"video"===e},Dn=p("contenteditable,draggable,spellcheck"),Ln=p("events,caret,typing,plaintext-only"),Mn=function(e,t){return Hn(t)||"false"===t?"false":"contenteditable"===e&&Ln(t)?t:"true"},In=p("allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,default,defaultchecked,defaultmuted,defaultselected,defer,disabled,enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,required,reversed,scoped,seamless,selected,sortable,translate,truespeed,typemustmatch,visible"),Fn="http://www.w3.org/1999/xlink",Pn=function(e){return":"===e.charAt(5)&&"xlink"===e.slice(0,5)},Rn=function(e){return Pn(e)?e.slice(6,e.length):""},Hn=function(e){return null==e||!1===e};function Bn(e){for(var t=e.data,r=e,i=e;n(i.componentInstance);)(i=i.componentInstance._vnode)&&i.data&&(t=Un(i.data,t));for(;n(r=r.parent);)r&&r.data&&(t=Un(t,r.data));return function(e,t){if(n(e)||n(t))return zn(e,Vn(t));return""}(t.staticClass,t.class)}function Un(e,t){return{staticClass:zn(e.staticClass,t.staticClass),class:n(e.class)?[e.class,t.class]:t.class}}function zn(e,t){return e?t?e+" "+t:e:t||""}function Vn(e){return Array.isArray(e)?function(e){for(var t,r="",i=0,o=e.length;i<o;i++)n(t=Vn(e[i]))&&""!==t&&(r&&(r+=" "),r+=t);return r}(e):o(e)?function(e){var t="";for(var n in e)e[n]&&(t&&(t+=" "),t+=n);return t}(e):"string"==typeof e?e:""}var Kn={svg:"http://www.w3.org/2000/svg",math:"http://www.w3.org/1998/Math/MathML"},Jn=p("html,body,base,head,link,meta,style,title,address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,menuitem,summary,content,element,shadow,template,blockquote,iframe,tfoot"),qn=p("svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view",!0),Wn=function(e){return Jn(e)||qn(e)};function Zn(e){return qn(e)?"svg":"math"===e?"math":void 0}var Gn=Object.create(null);var Xn=p("text,number,password,search,email,tel,url");function Yn(e){if("string"==typeof e){var t=document.querySelector(e);return t||document.createElement("div")}return e}var Qn=Object.freeze({createElement:function(e,t){var n=document.createElement(e);return"select"!==e?n:(t.data&&t.data.attrs&&void 0!==t.data.attrs.multiple&&n.setAttribute("multiple","multiple"),n)},createElementNS:function(e,t){return document.createElementNS(Kn[e],t)},createTextNode:function(e){return document.createTextNode(e)},createComment:function(e){return document.createComment(e)},insertBefore:function(e,t,n){e.insertBefore(t,n)},removeChild:function(e,t){e.removeChild(t)},appendChild:function(e,t){e.appendChild(t)},parentNode:function(e){return e.parentNode},nextSibling:function(e){return e.nextSibling},tagName:function(e){return e.tagName},setTextContent:function(e,t){e.textContent=t},setStyleScope:function(e,t){e.setAttribute(t,"")}}),er={create:function(e,t){tr(t)},update:function(e,t){e.data.ref!==t.data.ref&&(tr(e,!0),tr(t))},destroy:function(e){tr(e,!0)}};function tr(e,t){var r=e.data.ref;if(n(r)){var i=e.context,o=e.componentInstance||e.elm,a=i.$refs;t?Array.isArray(a[r])?h(a[r],o):a[r]===o&&(a[r]=void 0):e.data.refInFor?Array.isArray(a[r])?a[r].indexOf(o)<0&&a[r].push(o):a[r]=[o]:a[r]=o}}var nr=new pe("",{},[]),rr=["create","activate","update","remove","destroy"];function ir(e,i){return e.key===i.key&&(e.tag===i.tag&&e.isComment===i.isComment&&n(e.data)===n(i.data)&&function(e,t){if("input"!==e.tag)return!0;var r,i=n(r=e.data)&&n(r=r.attrs)&&r.type,o=n(r=t.data)&&n(r=r.attrs)&&r.type;return i===o||Xn(i)&&Xn(o)}(e,i)||r(e.isAsyncPlaceholder)&&e.asyncFactory===i.asyncFactory&&t(i.asyncFactory.error))}function or(e,t,r){var i,o,a={};for(i=t;i<=r;++i)n(o=e[i].key)&&(a[o]=i);return a}var ar={create:sr,update:sr,destroy:function(e){sr(e,nr)}};function sr(e,t){(e.data.directives||t.data.directives)&&function(e,t){var n,r,i,o=e===nr,a=t===nr,s=ur(e.data.directives,e.context),c=ur(t.data.directives,t.context),u=[],l=[];for(n in c)r=s[n],i=c[n],r?(i.oldValue=r.value,i.oldArg=r.arg,fr(i,"update",t,e),i.def&&i.def.componentUpdated&&l.push(i)):(fr(i,"bind",t,e),i.def&&i.def.inserted&&u.push(i));if(u.length){var f=function(){for(var n=0;n<u.length;n++)fr(u[n],"inserted",t,e)};o?it(t,"insert",f):f()}l.length&&it(t,"postpatch",function(){for(var n=0;n<l.length;n++)fr(l[n],"componentUpdated",t,e)});if(!o)for(n in s)c[n]||fr(s[n],"unbind",e,e,a)}(e,t)}var cr=Object.create(null);function ur(e,t){var n,r,i=Object.create(null);if(!e)return i;for(n=0;n<e.length;n++)(r=e[n]).modifiers||(r.modifiers=cr),i[lr(r)]=r,r.def=Le(t.$options,"directives",r.name);return i}function lr(e){return e.rawName||e.name+"."+Object.keys(e.modifiers||{}).join(".")}function fr(e,t,n,r,i){var o=e.def&&e.def[t];if(o)try{o(n.elm,e,n,r,i)}catch(r){Re(r,n.context,"directive "+e.name+" "+t+" hook")}}var pr=[er,ar];function dr(e,r){var i=r.componentOptions;if(!(n(i)&&!1===i.Ctor.options.inheritAttrs||t(e.data.attrs)&&t(r.data.attrs))){var o,a,s=r.elm,c=e.data.attrs||{},u=r.data.attrs||{};for(o in n(u.__ob__)&&(u=r.data.attrs=A({},u)),u)a=u[o],c[o]!==a&&vr(s,o,a);for(o in(q||Z)&&u.value!==c.value&&vr(s,"value",u.value),c)t(u[o])&&(Pn(o)?s.removeAttributeNS(Fn,Rn(o)):Dn(o)||s.removeAttribute(o))}}function vr(e,t,n){e.tagName.indexOf("-")>-1?hr(e,t,n):In(t)?Hn(n)?e.removeAttribute(t):(n="allowfullscreen"===t&&"EMBED"===e.tagName?"true":t,e.setAttribute(t,n)):Dn(t)?e.setAttribute(t,Mn(t,n)):Pn(t)?Hn(n)?e.removeAttributeNS(Fn,Rn(t)):e.setAttributeNS(Fn,t,n):hr(e,t,n)}function hr(e,t,n){if(Hn(n))e.removeAttribute(t);else{if(q&&!W&&"TEXTAREA"===e.tagName&&"placeholder"===t&&""!==n&&!e.__ieph){var r=function(t){t.stopImmediatePropagation(),e.removeEventListener("input",r)};e.addEventListener("input",r),e.__ieph=!0}e.setAttribute(t,n)}}var mr={create:dr,update:dr};function yr(e,r){var i=r.elm,o=r.data,a=e.data;if(!(t(o.staticClass)&&t(o.class)&&(t(a)||t(a.staticClass)&&t(a.class)))){var s=Bn(r),c=i._transitionClasses;n(c)&&(s=zn(s,Vn(c))),s!==i._prevClass&&(i.setAttribute("class",s),i._prevClass=s)}}var gr,_r,br,$r,wr,Cr,xr={create:yr,update:yr},kr=/[\w).+\-_$\]]/;function Ar(e){var t,n,r,i,o,a=!1,s=!1,c=!1,u=!1,l=0,f=0,p=0,d=0;for(r=0;r<e.length;r++)if(n=t,t=e.charCodeAt(r),a)39===t&&92!==n&&(a=!1);else if(s)34===t&&92!==n&&(s=!1);else if(c)96===t&&92!==n&&(c=!1);else if(u)47===t&&92!==n&&(u=!1);else if(124!==t||124===e.charCodeAt(r+1)||124===e.charCodeAt(r-1)||l||f||p){switch(t){case 34:s=!0;break;case 39:a=!0;break;case 96:c=!0;break;case 40:p++;break;case 41:p--;break;case 91:f++;break;case 93:f--;break;case 123:l++;break;case 125:l--}if(47===t){for(var v=r-1,h=void 0;v>=0&&" "===(h=e.charAt(v));v--);h&&kr.test(h)||(u=!0)}}else void 0===i?(d=r+1,i=e.slice(0,r).trim()):m();function m(){(o||(o=[])).push(e.slice(d,r).trim()),d=r+1}if(void 0===i?i=e.slice(0,r).trim():0!==d&&m(),o)for(r=0;r<o.length;r++)i=Or(i,o[r]);return i}function Or(e,t){var n=t.indexOf("(");if(n<0)return'_f("'+t+'")('+e+")";var r=t.slice(0,n),i=t.slice(n+1);return'_f("'+r+'")('+e+(")"!==i?","+i:i)}function Sr(e,t){console.error("[Vue compiler]: "+e)}function Tr(e,t){return e?e.map(function(e){return e[t]}).filter(function(e){return e}):[]}function Er(e,t,n,r,i){(e.props||(e.props=[])).push(Rr({name:t,value:n,dynamic:i},r)),e.plain=!1}function Nr(e,t,n,r,i){(i?e.dynamicAttrs||(e.dynamicAttrs=[]):e.attrs||(e.attrs=[])).push(Rr({name:t,value:n,dynamic:i},r)),e.plain=!1}function jr(e,t,n,r){e.attrsMap[t]=n,e.attrsList.push(Rr({name:t,value:n},r))}function Dr(e,t,n,r,i,o,a,s){(e.directives||(e.directives=[])).push(Rr({name:t,rawName:n,value:r,arg:i,isDynamicArg:o,modifiers:a},s)),e.plain=!1}function Lr(e,t,n){return n?"_p("+t+',"'+e+'")':e+t}function Mr(t,n,r,i,o,a,s,c){var u;(i=i||e).right?c?n="("+n+")==='click'?'contextmenu':("+n+")":"click"===n&&(n="contextmenu",delete i.right):i.middle&&(c?n="("+n+")==='click'?'mouseup':("+n+")":"click"===n&&(n="mouseup")),i.capture&&(delete i.capture,n=Lr("!",n,c)),i.once&&(delete i.once,n=Lr("~",n,c)),i.passive&&(delete i.passive,n=Lr("&",n,c)),i.native?(delete i.native,u=t.nativeEvents||(t.nativeEvents={})):u=t.events||(t.events={});var l=Rr({value:r.trim(),dynamic:c},s);i!==e&&(l.modifiers=i);var f=u[n];Array.isArray(f)?o?f.unshift(l):f.push(l):u[n]=f?o?[l,f]:[f,l]:l,t.plain=!1}function Ir(e,t,n){var r=Fr(e,":"+t)||Fr(e,"v-bind:"+t);if(null!=r)return Ar(r);if(!1!==n){var i=Fr(e,t);if(null!=i)return JSON.stringify(i)}}function Fr(e,t,n){var r;if(null!=(r=e.attrsMap[t]))for(var i=e.attrsList,o=0,a=i.length;o<a;o++)if(i[o].name===t){i.splice(o,1);break}return n&&delete e.attrsMap[t],r}function Pr(e,t){for(var n=e.attrsList,r=0,i=n.length;r<i;r++){var o=n[r];if(t.test(o.name))return n.splice(r,1),o}}function Rr(e,t){return t&&(null!=t.start&&(e.start=t.start),null!=t.end&&(e.end=t.end)),e}function Hr(e,t,n){var r=n||{},i=r.number,o="$$v";r.trim&&(o="(typeof $$v === 'string'? $$v.trim(): $$v)"),i&&(o="_n("+o+")");var a=Br(t,o);e.model={value:"("+t+")",expression:JSON.stringify(t),callback:"function ($$v) {"+a+"}"}}function Br(e,t){var n=function(e){if(e=e.trim(),gr=e.length,e.indexOf("[")<0||e.lastIndexOf("]")<gr-1)return($r=e.lastIndexOf("."))>-1?{exp:e.slice(0,$r),key:'"'+e.slice($r+1)+'"'}:{exp:e,key:null};_r=e,$r=wr=Cr=0;for(;!zr();)Vr(br=Ur())?Jr(br):91===br&&Kr(br);return{exp:e.slice(0,wr),key:e.slice(wr+1,Cr)}}(e);return null===n.key?e+"="+t:"$set("+n.exp+", "+n.key+", "+t+")"}function Ur(){return _r.charCodeAt(++$r)}function zr(){return $r>=gr}function Vr(e){return 34===e||39===e}function Kr(e){var t=1;for(wr=$r;!zr();)if(Vr(e=Ur()))Jr(e);else if(91===e&&t++,93===e&&t--,0===t){Cr=$r;break}}function Jr(e){for(var t=e;!zr()&&(e=Ur())!==t;);}var qr,Wr="__r",Zr="__c";function Gr(e,t,n){var r=qr;return function i(){null!==t.apply(null,arguments)&&Qr(e,i,n,r)}}var Xr=Ve&&!(X&&Number(X[1])<=53);function Yr(e,t,n,r){if(Xr){var i=an,o=t;t=o._wrapper=function(e){if(e.target===e.currentTarget||e.timeStamp>=i||e.timeStamp<=0||e.target.ownerDocument!==document)return o.apply(this,arguments)}}qr.addEventListener(e,t,Q?{capture:n,passive:r}:n)}function Qr(e,t,n,r){(r||qr).removeEventListener(e,t._wrapper||t,n)}function ei(e,r){if(!t(e.data.on)||!t(r.data.on)){var i=r.data.on||{},o=e.data.on||{};qr=r.elm,function(e){if(n(e[Wr])){var t=q?"change":"input";e[t]=[].concat(e[Wr],e[t]||[]),delete e[Wr]}n(e[Zr])&&(e.change=[].concat(e[Zr],e.change||[]),delete e[Zr])}(i),rt(i,o,Yr,Qr,Gr,r.context),qr=void 0}}var ti,ni={create:ei,update:ei};function ri(e,r){if(!t(e.data.domProps)||!t(r.data.domProps)){var i,o,a=r.elm,s=e.data.domProps||{},c=r.data.domProps||{};for(i in n(c.__ob__)&&(c=r.data.domProps=A({},c)),s)i in c||(a[i]="");for(i in c){if(o=c[i],"textContent"===i||"innerHTML"===i){if(r.children&&(r.children.length=0),o===s[i])continue;1===a.childNodes.length&&a.removeChild(a.childNodes[0])}if("value"===i&&"PROGRESS"!==a.tagName){a._value=o;var u=t(o)?"":String(o);ii(a,u)&&(a.value=u)}else if("innerHTML"===i&&qn(a.tagName)&&t(a.innerHTML)){(ti=ti||document.createElement("div")).innerHTML="<svg>"+o+"</svg>";for(var l=ti.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;l.firstChild;)a.appendChild(l.firstChild)}else if(o!==s[i])try{a[i]=o}catch(e){}}}}function ii(e,t){return!e.composing&&("OPTION"===e.tagName||function(e,t){var n=!0;try{n=document.activeElement!==e}catch(e){}return n&&e.value!==t}(e,t)||function(e,t){var r=e.value,i=e._vModifiers;if(n(i)){if(i.number)return f(r)!==f(t);if(i.trim)return r.trim()!==t.trim()}return r!==t}(e,t))}var oi={create:ri,update:ri},ai=g(function(e){var t={},n=/:(.+)/;return e.split(/;(?![^(]*\))/g).forEach(function(e){if(e){var r=e.split(n);r.length>1&&(t[r[0].trim()]=r[1].trim())}}),t});function si(e){var t=ci(e.style);return e.staticStyle?A(e.staticStyle,t):t}function ci(e){return Array.isArray(e)?O(e):"string"==typeof e?ai(e):e}var ui,li=/^--/,fi=/\s*!important$/,pi=function(e,t,n){if(li.test(t))e.style.setProperty(t,n);else if(fi.test(n))e.style.setProperty(C(t),n.replace(fi,""),"important");else{var r=vi(t);if(Array.isArray(n))for(var i=0,o=n.length;i<o;i++)e.style[r]=n[i];else e.style[r]=n}},di=["Webkit","Moz","ms"],vi=g(function(e){if(ui=ui||document.createElement("div").style,"filter"!==(e=b(e))&&e in ui)return e;for(var t=e.charAt(0).toUpperCase()+e.slice(1),n=0;n<di.length;n++){var r=di[n]+t;if(r in ui)return r}});function hi(e,r){var i=r.data,o=e.data;if(!(t(i.staticStyle)&&t(i.style)&&t(o.staticStyle)&&t(o.style))){var a,s,c=r.elm,u=o.staticStyle,l=o.normalizedStyle||o.style||{},f=u||l,p=ci(r.data.style)||{};r.data.normalizedStyle=n(p.__ob__)?A({},p):p;var d=function(e,t){var n,r={};if(t)for(var i=e;i.componentInstance;)(i=i.componentInstance._vnode)&&i.data&&(n=si(i.data))&&A(r,n);(n=si(e.data))&&A(r,n);for(var o=e;o=o.parent;)o.data&&(n=si(o.data))&&A(r,n);return r}(r,!0);for(s in f)t(d[s])&&pi(c,s,"");for(s in d)(a=d[s])!==f[s]&&pi(c,s,null==a?"":a)}}var mi={create:hi,update:hi},yi=/\s+/;function gi(e,t){if(t&&(t=t.trim()))if(e.classList)t.indexOf(" ")>-1?t.split(yi).forEach(function(t){return e.classList.add(t)}):e.classList.add(t);else{var n=" "+(e.getAttribute("class")||"")+" ";n.indexOf(" "+t+" ")<0&&e.setAttribute("class",(n+t).trim())}}function _i(e,t){if(t&&(t=t.trim()))if(e.classList)t.indexOf(" ")>-1?t.split(yi).forEach(function(t){return e.classList.remove(t)}):e.classList.remove(t),e.classList.length||e.removeAttribute("class");else{for(var n=" "+(e.getAttribute("class")||"")+" ",r=" "+t+" ";n.indexOf(r)>=0;)n=n.replace(r," ");(n=n.trim())?e.setAttribute("class",n):e.removeAttribute("class")}}function bi(e){if(e){if("object"==typeof e){var t={};return!1!==e.css&&A(t,$i(e.name||"v")),A(t,e),t}return"string"==typeof e?$i(e):void 0}}var $i=g(function(e){return{enterClass:e+"-enter",enterToClass:e+"-enter-to",enterActiveClass:e+"-enter-active",leaveClass:e+"-leave",leaveToClass:e+"-leave-to",leaveActiveClass:e+"-leave-active"}}),wi=z&&!W,Ci="transition",xi="animation",ki="transition",Ai="transitionend",Oi="animation",Si="animationend";wi&&(void 0===window.ontransitionend&&void 0!==window.onwebkittransitionend&&(ki="WebkitTransition",Ai="webkitTransitionEnd"),void 0===window.onanimationend&&void 0!==window.onwebkitanimationend&&(Oi="WebkitAnimation",Si="webkitAnimationEnd"));var Ti=z?window.requestAnimationFrame?window.requestAnimationFrame.bind(window):setTimeout:function(e){return e()};function Ei(e){Ti(function(){Ti(e)})}function Ni(e,t){var n=e._transitionClasses||(e._transitionClasses=[]);n.indexOf(t)<0&&(n.push(t),gi(e,t))}function ji(e,t){e._transitionClasses&&h(e._transitionClasses,t),_i(e,t)}function Di(e,t,n){var r=Mi(e,t),i=r.type,o=r.timeout,a=r.propCount;if(!i)return n();var s=i===Ci?Ai:Si,c=0,u=function(){e.removeEventListener(s,l),n()},l=function(t){t.target===e&&++c>=a&&u()};setTimeout(function(){c<a&&u()},o+1),e.addEventListener(s,l)}var Li=/\b(transform|all)(,|$)/;function Mi(e,t){var n,r=window.getComputedStyle(e),i=(r[ki+"Delay"]||"").split(", "),o=(r[ki+"Duration"]||"").split(", "),a=Ii(i,o),s=(r[Oi+"Delay"]||"").split(", "),c=(r[Oi+"Duration"]||"").split(", "),u=Ii(s,c),l=0,f=0;return t===Ci?a>0&&(n=Ci,l=a,f=o.length):t===xi?u>0&&(n=xi,l=u,f=c.length):f=(n=(l=Math.max(a,u))>0?a>u?Ci:xi:null)?n===Ci?o.length:c.length:0,{type:n,timeout:l,propCount:f,hasTransform:n===Ci&&Li.test(r[ki+"Property"])}}function Ii(e,t){for(;e.length<t.length;)e=e.concat(e);return Math.max.apply(null,t.map(function(t,n){return Fi(t)+Fi(e[n])}))}function Fi(e){return 1e3*Number(e.slice(0,-1).replace(",","."))}function Pi(e,r){var i=e.elm;n(i._leaveCb)&&(i._leaveCb.cancelled=!0,i._leaveCb());var a=bi(e.data.transition);if(!t(a)&&!n(i._enterCb)&&1===i.nodeType){for(var s=a.css,c=a.type,u=a.enterClass,l=a.enterToClass,p=a.enterActiveClass,d=a.appearClass,v=a.appearToClass,h=a.appearActiveClass,m=a.beforeEnter,y=a.enter,g=a.afterEnter,_=a.enterCancelled,b=a.beforeAppear,$=a.appear,w=a.afterAppear,C=a.appearCancelled,x=a.duration,k=Wt,A=Wt.$vnode;A&&A.parent;)k=A.context,A=A.parent;var O=!k._isMounted||!e.isRootInsert;if(!O||$||""===$){var S=O&&d?d:u,T=O&&h?h:p,E=O&&v?v:l,N=O&&b||m,j=O&&"function"==typeof $?$:y,L=O&&w||g,M=O&&C||_,I=f(o(x)?x.enter:x),F=!1!==s&&!W,P=Bi(j),R=i._enterCb=D(function(){F&&(ji(i,E),ji(i,T)),R.cancelled?(F&&ji(i,S),M&&M(i)):L&&L(i),i._enterCb=null});e.data.show||it(e,"insert",function(){var t=i.parentNode,n=t&&t._pending&&t._pending[e.key];n&&n.tag===e.tag&&n.elm._leaveCb&&n.elm._leaveCb(),j&&j(i,R)}),N&&N(i),F&&(Ni(i,S),Ni(i,T),Ei(function(){ji(i,S),R.cancelled||(Ni(i,E),P||(Hi(I)?setTimeout(R,I):Di(i,c,R)))})),e.data.show&&(r&&r(),j&&j(i,R)),F||P||R()}}}function Ri(e,r){var i=e.elm;n(i._enterCb)&&(i._enterCb.cancelled=!0,i._enterCb());var a=bi(e.data.transition);if(t(a)||1!==i.nodeType)return r();if(!n(i._leaveCb)){var s=a.css,c=a.type,u=a.leaveClass,l=a.leaveToClass,p=a.leaveActiveClass,d=a.beforeLeave,v=a.leave,h=a.afterLeave,m=a.leaveCancelled,y=a.delayLeave,g=a.duration,_=!1!==s&&!W,b=Bi(v),$=f(o(g)?g.leave:g),w=i._leaveCb=D(function(){i.parentNode&&i.parentNode._pending&&(i.parentNode._pending[e.key]=null),_&&(ji(i,l),ji(i,p)),w.cancelled?(_&&ji(i,u),m&&m(i)):(r(),h&&h(i)),i._leaveCb=null});y?y(C):C()}function C(){w.cancelled||(!e.data.show&&i.parentNode&&((i.parentNode._pending||(i.parentNode._pending={}))[e.key]=e),d&&d(i),_&&(Ni(i,u),Ni(i,p),Ei(function(){ji(i,u),w.cancelled||(Ni(i,l),b||(Hi($)?setTimeout(w,$):Di(i,c,w)))})),v&&v(i,w),_||b||w())}}function Hi(e){return"number"==typeof e&&!isNaN(e)}function Bi(e){if(t(e))return!1;var r=e.fns;return n(r)?Bi(Array.isArray(r)?r[0]:r):(e._length||e.length)>1}function Ui(e,t){!0!==t.data.show&&Pi(t)}var zi=function(e){var o,a,s={},c=e.modules,u=e.nodeOps;for(o=0;o<rr.length;++o)for(s[rr[o]]=[],a=0;a<c.length;++a)n(c[a][rr[o]])&&s[rr[o]].push(c[a][rr[o]]);function l(e){var t=u.parentNode(e);n(t)&&u.removeChild(t,e)}function f(e,t,i,o,a,c,l){if(n(e.elm)&&n(c)&&(e=c[l]=me(e)),e.isRootInsert=!a,!function(e,t,i,o){var a=e.data;if(n(a)){var c=n(e.componentInstance)&&a.keepAlive;if(n(a=a.hook)&&n(a=a.init)&&a(e,!1),n(e.componentInstance))return d(e,t),v(i,e.elm,o),r(c)&&function(e,t,r,i){for(var o,a=e;a.componentInstance;)if(a=a.componentInstance._vnode,n(o=a.data)&&n(o=o.transition)){for(o=0;o<s.activate.length;++o)s.activate[o](nr,a);t.push(a);break}v(r,e.elm,i)}(e,t,i,o),!0}}(e,t,i,o)){var f=e.data,p=e.children,m=e.tag;n(m)?(e.elm=e.ns?u.createElementNS(e.ns,m):u.createElement(m,e),g(e),h(e,p,t),n(f)&&y(e,t),v(i,e.elm,o)):r(e.isComment)?(e.elm=u.createComment(e.text),v(i,e.elm,o)):(e.elm=u.createTextNode(e.text),v(i,e.elm,o))}}function d(e,t){n(e.data.pendingInsert)&&(t.push.apply(t,e.data.pendingInsert),e.data.pendingInsert=null),e.elm=e.componentInstance.$el,m(e)?(y(e,t),g(e)):(tr(e),t.push(e))}function v(e,t,r){n(e)&&(n(r)?u.parentNode(r)===e&&u.insertBefore(e,t,r):u.appendChild(e,t))}function h(e,t,n){if(Array.isArray(t))for(var r=0;r<t.length;++r)f(t[r],n,e.elm,null,!0,t,r);else i(e.text)&&u.appendChild(e.elm,u.createTextNode(String(e.text)))}function m(e){for(;e.componentInstance;)e=e.componentInstance._vnode;return n(e.tag)}function y(e,t){for(var r=0;r<s.create.length;++r)s.create[r](nr,e);n(o=e.data.hook)&&(n(o.create)&&o.create(nr,e),n(o.insert)&&t.push(e))}function g(e){var t;if(n(t=e.fnScopeId))u.setStyleScope(e.elm,t);else for(var r=e;r;)n(t=r.context)&&n(t=t.$options._scopeId)&&u.setStyleScope(e.elm,t),r=r.parent;n(t=Wt)&&t!==e.context&&t!==e.fnContext&&n(t=t.$options._scopeId)&&u.setStyleScope(e.elm,t)}function _(e,t,n,r,i,o){for(;r<=i;++r)f(n[r],o,e,t,!1,n,r)}function b(e){var t,r,i=e.data;if(n(i))for(n(t=i.hook)&&n(t=t.destroy)&&t(e),t=0;t<s.destroy.length;++t)s.destroy[t](e);if(n(t=e.children))for(r=0;r<e.children.length;++r)b(e.children[r])}function $(e,t,r){for(;t<=r;++t){var i=e[t];n(i)&&(n(i.tag)?(w(i),b(i)):l(i.elm))}}function w(e,t){if(n(t)||n(e.data)){var r,i=s.remove.length+1;for(n(t)?t.listeners+=i:t=function(e,t){function n(){0==--n.listeners&&l(e)}return n.listeners=t,n}(e.elm,i),n(r=e.componentInstance)&&n(r=r._vnode)&&n(r.data)&&w(r,t),r=0;r<s.remove.length;++r)s.remove[r](e,t);n(r=e.data.hook)&&n(r=r.remove)?r(e,t):t()}else l(e.elm)}function C(e,t,r,i){for(var o=r;o<i;o++){var a=t[o];if(n(a)&&ir(e,a))return o}}function x(e,i,o,a,c,l){if(e!==i){n(i.elm)&&n(a)&&(i=a[c]=me(i));var p=i.elm=e.elm;if(r(e.isAsyncPlaceholder))n(i.asyncFactory.resolved)?O(e.elm,i,o):i.isAsyncPlaceholder=!0;else if(r(i.isStatic)&&r(e.isStatic)&&i.key===e.key&&(r(i.isCloned)||r(i.isOnce)))i.componentInstance=e.componentInstance;else{var d,v=i.data;n(v)&&n(d=v.hook)&&n(d=d.prepatch)&&d(e,i);var h=e.children,y=i.children;if(n(v)&&m(i)){for(d=0;d<s.update.length;++d)s.update[d](e,i);n(d=v.hook)&&n(d=d.update)&&d(e,i)}t(i.text)?n(h)&&n(y)?h!==y&&function(e,r,i,o,a){for(var s,c,l,p=0,d=0,v=r.length-1,h=r[0],m=r[v],y=i.length-1,g=i[0],b=i[y],w=!a;p<=v&&d<=y;)t(h)?h=r[++p]:t(m)?m=r[--v]:ir(h,g)?(x(h,g,o,i,d),h=r[++p],g=i[++d]):ir(m,b)?(x(m,b,o,i,y),m=r[--v],b=i[--y]):ir(h,b)?(x(h,b,o,i,y),w&&u.insertBefore(e,h.elm,u.nextSibling(m.elm)),h=r[++p],b=i[--y]):ir(m,g)?(x(m,g,o,i,d),w&&u.insertBefore(e,m.elm,h.elm),m=r[--v],g=i[++d]):(t(s)&&(s=or(r,p,v)),t(c=n(g.key)?s[g.key]:C(g,r,p,v))?f(g,o,e,h.elm,!1,i,d):ir(l=r[c],g)?(x(l,g,o,i,d),r[c]=void 0,w&&u.insertBefore(e,l.elm,h.elm)):f(g,o,e,h.elm,!1,i,d),g=i[++d]);p>v?_(e,t(i[y+1])?null:i[y+1].elm,i,d,y,o):d>y&&$(r,p,v)}(p,h,y,o,l):n(y)?(n(e.text)&&u.setTextContent(p,""),_(p,null,y,0,y.length-1,o)):n(h)?$(h,0,h.length-1):n(e.text)&&u.setTextContent(p,""):e.text!==i.text&&u.setTextContent(p,i.text),n(v)&&n(d=v.hook)&&n(d=d.postpatch)&&d(e,i)}}}function k(e,t,i){if(r(i)&&n(e.parent))e.parent.data.pendingInsert=t;else for(var o=0;o<t.length;++o)t[o].data.hook.insert(t[o])}var A=p("attrs,class,staticClass,staticStyle,key");function O(e,t,i,o){var a,s=t.tag,c=t.data,u=t.children;if(o=o||c&&c.pre,t.elm=e,r(t.isComment)&&n(t.asyncFactory))return t.isAsyncPlaceholder=!0,!0;if(n(c)&&(n(a=c.hook)&&n(a=a.init)&&a(t,!0),n(a=t.componentInstance)))return d(t,i),!0;if(n(s)){if(n(u))if(e.hasChildNodes())if(n(a=c)&&n(a=a.domProps)&&n(a=a.innerHTML)){if(a!==e.innerHTML)return!1}else{for(var l=!0,f=e.firstChild,p=0;p<u.length;p++){if(!f||!O(f,u[p],i,o)){l=!1;break}f=f.nextSibling}if(!l||f)return!1}else h(t,u,i);if(n(c)){var v=!1;for(var m in c)if(!A(m)){v=!0,y(t,i);break}!v&&c.class&&et(c.class)}}else e.data!==t.text&&(e.data=t.text);return!0}return function(e,i,o,a){if(!t(i)){var c,l=!1,p=[];if(t(e))l=!0,f(i,p);else{var d=n(e.nodeType);if(!d&&ir(e,i))x(e,i,p,null,null,a);else{if(d){if(1===e.nodeType&&e.hasAttribute(L)&&(e.removeAttribute(L),o=!0),r(o)&&O(e,i,p))return k(i,p,!0),e;c=e,e=new pe(u.tagName(c).toLowerCase(),{},[],void 0,c)}var v=e.elm,h=u.parentNode(v);if(f(i,p,v._leaveCb?null:h,u.nextSibling(v)),n(i.parent))for(var y=i.parent,g=m(i);y;){for(var _=0;_<s.destroy.length;++_)s.destroy[_](y);if(y.elm=i.elm,g){for(var w=0;w<s.create.length;++w)s.create[w](nr,y);var C=y.data.hook.insert;if(C.merged)for(var A=1;A<C.fns.length;A++)C.fns[A]()}else tr(y);y=y.parent}n(h)?$([e],0,0):n(e.tag)&&b(e)}}return k(i,p,l),i.elm}n(e)&&b(e)}}({nodeOps:Qn,modules:[mr,xr,ni,oi,mi,z?{create:Ui,activate:Ui,remove:function(e,t){!0!==e.data.show?Ri(e,t):t()}}:{}].concat(pr)});W&&document.addEventListener("selectionchange",function(){var e=document.activeElement;e&&e.vmodel&&Xi(e,"input")});var Vi={inserted:function(e,t,n,r){"select"===n.tag?(r.elm&&!r.elm._vOptions?it(n,"postpatch",function(){Vi.componentUpdated(e,t,n)}):Ki(e,t,n.context),e._vOptions=[].map.call(e.options,Wi)):("textarea"===n.tag||Xn(e.type))&&(e._vModifiers=t.modifiers,t.modifiers.lazy||(e.addEventListener("compositionstart",Zi),e.addEventListener("compositionend",Gi),e.addEventListener("change",Gi),W&&(e.vmodel=!0)))},componentUpdated:function(e,t,n){if("select"===n.tag){Ki(e,t,n.context);var r=e._vOptions,i=e._vOptions=[].map.call(e.options,Wi);if(i.some(function(e,t){return!N(e,r[t])}))(e.multiple?t.value.some(function(e){return qi(e,i)}):t.value!==t.oldValue&&qi(t.value,i))&&Xi(e,"change")}}};function Ki(e,t,n){Ji(e,t,n),(q||Z)&&setTimeout(function(){Ji(e,t,n)},0)}function Ji(e,t,n){var r=t.value,i=e.multiple;if(!i||Array.isArray(r)){for(var o,a,s=0,c=e.options.length;s<c;s++)if(a=e.options[s],i)o=j(r,Wi(a))>-1,a.selected!==o&&(a.selected=o);else if(N(Wi(a),r))return void(e.selectedIndex!==s&&(e.selectedIndex=s));i||(e.selectedIndex=-1)}}function qi(e,t){return t.every(function(t){return!N(t,e)})}function Wi(e){return"_value"in e?e._value:e.value}function Zi(e){e.target.composing=!0}function Gi(e){e.target.composing&&(e.target.composing=!1,Xi(e.target,"input"))}function Xi(e,t){var n=document.createEvent("HTMLEvents");n.initEvent(t,!0,!0),e.dispatchEvent(n)}function Yi(e){return!e.componentInstance||e.data&&e.data.transition?e:Yi(e.componentInstance._vnode)}var Qi={model:Vi,show:{bind:function(e,t,n){var r=t.value,i=(n=Yi(n)).data&&n.data.transition,o=e.__vOriginalDisplay="none"===e.style.display?"":e.style.display;r&&i?(n.data.show=!0,Pi(n,function(){e.style.display=o})):e.style.display=r?o:"none"},update:function(e,t,n){var r=t.value;!r!=!t.oldValue&&((n=Yi(n)).data&&n.data.transition?(n.data.show=!0,r?Pi(n,function(){e.style.display=e.__vOriginalDisplay}):Ri(n,function(){e.style.display="none"})):e.style.display=r?e.__vOriginalDisplay:"none")},unbind:function(e,t,n,r,i){i||(e.style.display=e.__vOriginalDisplay)}}},eo={name:String,appear:Boolean,css:Boolean,mode:String,type:String,enterClass:String,leaveClass:String,enterToClass:String,leaveToClass:String,enterActiveClass:String,leaveActiveClass:String,appearClass:String,appearActiveClass:String,appearToClass:String,duration:[Number,String,Object]};function to(e){var t=e&&e.componentOptions;return t&&t.Ctor.options.abstract?to(zt(t.children)):e}function no(e){var t={},n=e.$options;for(var r in n.propsData)t[r]=e[r];var i=n._parentListeners;for(var o in i)t[b(o)]=i[o];return t}function ro(e,t){if(/\d-keep-alive$/.test(t.tag))return e("keep-alive",{props:t.componentOptions.propsData})}var io=function(e){return e.tag||Ut(e)},oo=function(e){return"show"===e.name},ao={name:"transition",props:eo,abstract:!0,render:function(e){var t=this,n=this.$slots.default;if(n&&(n=n.filter(io)).length){var r=this.mode,o=n[0];if(function(e){for(;e=e.parent;)if(e.data.transition)return!0}(this.$vnode))return o;var a=to(o);if(!a)return o;if(this._leaving)return ro(e,o);var s="__transition-"+this._uid+"-";a.key=null==a.key?a.isComment?s+"comment":s+a.tag:i(a.key)?0===String(a.key).indexOf(s)?a.key:s+a.key:a.key;var c=(a.data||(a.data={})).transition=no(this),u=this._vnode,l=to(u);if(a.data.directives&&a.data.directives.some(oo)&&(a.data.show=!0),l&&l.data&&!function(e,t){return t.key===e.key&&t.tag===e.tag}(a,l)&&!Ut(l)&&(!l.componentInstance||!l.componentInstance._vnode.isComment)){var f=l.data.transition=A({},c);if("out-in"===r)return this._leaving=!0,it(f,"afterLeave",function(){t._leaving=!1,t.$forceUpdate()}),ro(e,o);if("in-out"===r){if(Ut(a))return u;var p,d=function(){p()};it(c,"afterEnter",d),it(c,"enterCancelled",d),it(f,"delayLeave",function(e){p=e})}}return o}}},so=A({tag:String,moveClass:String},eo);function co(e){e.elm._moveCb&&e.elm._moveCb(),e.elm._enterCb&&e.elm._enterCb()}function uo(e){e.data.newPos=e.elm.getBoundingClientRect()}function lo(e){var t=e.data.pos,n=e.data.newPos,r=t.left-n.left,i=t.top-n.top;if(r||i){e.data.moved=!0;var o=e.elm.style;o.transform=o.WebkitTransform="translate("+r+"px,"+i+"px)",o.transitionDuration="0s"}}delete so.mode;var fo={Transition:ao,TransitionGroup:{props:so,beforeMount:function(){var e=this,t=this._update;this._update=function(n,r){var i=Zt(e);e.__patch__(e._vnode,e.kept,!1,!0),e._vnode=e.kept,i(),t.call(e,n,r)}},render:function(e){for(var t=this.tag||this.$vnode.data.tag||"span",n=Object.create(null),r=this.prevChildren=this.children,i=this.$slots.default||[],o=this.children=[],a=no(this),s=0;s<i.length;s++){var c=i[s];c.tag&&null!=c.key&&0!==String(c.key).indexOf("__vlist")&&(o.push(c),n[c.key]=c,(c.data||(c.data={})).transition=a)}if(r){for(var u=[],l=[],f=0;f<r.length;f++){var p=r[f];p.data.transition=a,p.data.pos=p.elm.getBoundingClientRect(),n[p.key]?u.push(p):l.push(p)}this.kept=e(t,null,u),this.removed=l}return e(t,null,o)},updated:function(){var e=this.prevChildren,t=this.moveClass||(this.name||"v")+"-move";e.length&&this.hasMove(e[0].elm,t)&&(e.forEach(co),e.forEach(uo),e.forEach(lo),this._reflow=document.body.offsetHeight,e.forEach(function(e){if(e.data.moved){var n=e.elm,r=n.style;Ni(n,t),r.transform=r.WebkitTransform=r.transitionDuration="",n.addEventListener(Ai,n._moveCb=function e(r){r&&r.target!==n||r&&!/transform$/.test(r.propertyName)||(n.removeEventListener(Ai,e),n._moveCb=null,ji(n,t))})}}))},methods:{hasMove:function(e,t){if(!wi)return!1;if(this._hasMove)return this._hasMove;var n=e.cloneNode();e._transitionClasses&&e._transitionClasses.forEach(function(e){_i(n,e)}),gi(n,t),n.style.display="none",this.$el.appendChild(n);var r=Mi(n);return this.$el.removeChild(n),this._hasMove=r.hasTransform}}}};wn.config.mustUseProp=jn,wn.config.isReservedTag=Wn,wn.config.isReservedAttr=En,wn.config.getTagNamespace=Zn,wn.config.isUnknownElement=function(e){if(!z)return!0;if(Wn(e))return!1;if(e=e.toLowerCase(),null!=Gn[e])return Gn[e];var t=document.createElement(e);return e.indexOf("-")>-1?Gn[e]=t.constructor===window.HTMLUnknownElement||t.constructor===window.HTMLElement:Gn[e]=/HTMLUnknownElement/.test(t.toString())},A(wn.options.directives,Qi),A(wn.options.components,fo),wn.prototype.__patch__=z?zi:S,wn.prototype.$mount=function(e,t){return function(e,t,n){var r;return e.$el=t,e.$options.render||(e.$options.render=ve),Yt(e,"beforeMount"),r=function(){e._update(e._render(),n)},new fn(e,r,S,{before:function(){e._isMounted&&!e._isDestroyed&&Yt(e,"beforeUpdate")}},!0),n=!1,null==e.$vnode&&(e._isMounted=!0,Yt(e,"mounted")),e}(this,e=e&&z?Yn(e):void 0,t)},z&&setTimeout(function(){F.devtools&&ne&&ne.emit("init",wn)},0);var po=/\{\{((?:.|\r?\n)+?)\}\}/g,vo=/[-.*+?^${}()|[\]\/\\]/g,ho=g(function(e){var t=e[0].replace(vo,"\\$&"),n=e[1].replace(vo,"\\$&");return new RegExp(t+"((?:.|\\n)+?)"+n,"g")});var mo={staticKeys:["staticClass"],transformNode:function(e,t){t.warn;var n=Fr(e,"class");n&&(e.staticClass=JSON.stringify(n));var r=Ir(e,"class",!1);r&&(e.classBinding=r)},genData:function(e){var t="";return e.staticClass&&(t+="staticClass:"+e.staticClass+","),e.classBinding&&(t+="class:"+e.classBinding+","),t}};var yo,go={staticKeys:["staticStyle"],transformNode:function(e,t){t.warn;var n=Fr(e,"style");n&&(e.staticStyle=JSON.stringify(ai(n)));var r=Ir(e,"style",!1);r&&(e.styleBinding=r)},genData:function(e){var t="";return e.staticStyle&&(t+="staticStyle:"+e.staticStyle+","),e.styleBinding&&(t+="style:("+e.styleBinding+"),"),t}},_o=function(e){return(yo=yo||document.createElement("div")).innerHTML=e,yo.textContent},bo=p("area,base,br,col,embed,frame,hr,img,input,isindex,keygen,link,meta,param,source,track,wbr"),$o=p("colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source"),wo=p("address,article,aside,base,blockquote,body,caption,col,colgroup,dd,details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,title,tr,track"),Co=/^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/,xo=/^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/,ko="[a-zA-Z_][\\-\\.0-9_a-zA-Z"+P.source+"]*",Ao="((?:"+ko+"\\:)?"+ko+")",Oo=new RegExp("^<"+Ao),So=/^\s*(\/?)>/,To=new RegExp("^<\\/"+Ao+"[^>]*>"),Eo=/^<!DOCTYPE [^>]+>/i,No=/^<!\--/,jo=/^<!\[/,Do=p("script,style,textarea",!0),Lo={},Mo={"&lt;":"<","&gt;":">","&quot;":'"',"&amp;":"&","&#10;":"\n","&#9;":"\t","&#39;":"'"},Io=/&(?:lt|gt|quot|amp|#39);/g,Fo=/&(?:lt|gt|quot|amp|#39|#10|#9);/g,Po=p("pre,textarea",!0),Ro=function(e,t){return e&&Po(e)&&"\n"===t[0]};function Ho(e,t){var n=t?Fo:Io;return e.replace(n,function(e){return Mo[e]})}var Bo,Uo,zo,Vo,Ko,Jo,qo,Wo,Zo=/^@|^v-on:/,Go=/^v-|^@|^:|^#/,Xo=/([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/,Yo=/,([^,\}\]]*)(?:,([^,\}\]]*))?$/,Qo=/^\(|\)$/g,ea=/^\[.*\]$/,ta=/:(.*)$/,na=/^:|^\.|^v-bind:/,ra=/\.[^.\]]+(?=[^\]]*$)/g,ia=/^v-slot(:|$)|^#/,oa=/[\r\n]/,aa=/\s+/g,sa=g(_o),ca="_empty_";function ua(e,t,n){return{type:1,tag:e,attrsList:t,attrsMap:ma(t),rawAttrsMap:{},parent:n,children:[]}}function la(e,t){Bo=t.warn||Sr,Jo=t.isPreTag||T,qo=t.mustUseProp||T,Wo=t.getTagNamespace||T;t.isReservedTag;zo=Tr(t.modules,"transformNode"),Vo=Tr(t.modules,"preTransformNode"),Ko=Tr(t.modules,"postTransformNode"),Uo=t.delimiters;var n,r,i=[],o=!1!==t.preserveWhitespace,a=t.whitespace,s=!1,c=!1;function u(e){if(l(e),s||e.processed||(e=fa(e,t)),i.length||e===n||n.if&&(e.elseif||e.else)&&da(n,{exp:e.elseif,block:e}),r&&!e.forbidden)if(e.elseif||e.else)a=e,(u=function(e){var t=e.length;for(;t--;){if(1===e[t].type)return e[t];e.pop()}}(r.children))&&u.if&&da(u,{exp:a.elseif,block:a});else{if(e.slotScope){var o=e.slotTarget||'"default"';(r.scopedSlots||(r.scopedSlots={}))[o]=e}r.children.push(e),e.parent=r}var a,u;e.children=e.children.filter(function(e){return!e.slotScope}),l(e),e.pre&&(s=!1),Jo(e.tag)&&(c=!1);for(var f=0;f<Ko.length;f++)Ko[f](e,t)}function l(e){if(!c)for(var t;(t=e.children[e.children.length-1])&&3===t.type&&" "===t.text;)e.children.pop()}return function(e,t){for(var n,r,i=[],o=t.expectHTML,a=t.isUnaryTag||T,s=t.canBeLeftOpenTag||T,c=0;e;){if(n=e,r&&Do(r)){var u=0,l=r.toLowerCase(),f=Lo[l]||(Lo[l]=new RegExp("([\\s\\S]*?)(</"+l+"[^>]*>)","i")),p=e.replace(f,function(e,n,r){return u=r.length,Do(l)||"noscript"===l||(n=n.replace(/<!\--([\s\S]*?)-->/g,"$1").replace(/<!\[CDATA\[([\s\S]*?)]]>/g,"$1")),Ro(l,n)&&(n=n.slice(1)),t.chars&&t.chars(n),""});c+=e.length-p.length,e=p,A(l,c-u,c)}else{var d=e.indexOf("<");if(0===d){if(No.test(e)){var v=e.indexOf("--\x3e");if(v>=0){t.shouldKeepComment&&t.comment(e.substring(4,v),c,c+v+3),C(v+3);continue}}if(jo.test(e)){var h=e.indexOf("]>");if(h>=0){C(h+2);continue}}var m=e.match(Eo);if(m){C(m[0].length);continue}var y=e.match(To);if(y){var g=c;C(y[0].length),A(y[1],g,c);continue}var _=x();if(_){k(_),Ro(_.tagName,e)&&C(1);continue}}var b=void 0,$=void 0,w=void 0;if(d>=0){for($=e.slice(d);!(To.test($)||Oo.test($)||No.test($)||jo.test($)||(w=$.indexOf("<",1))<0);)d+=w,$=e.slice(d);b=e.substring(0,d)}d<0&&(b=e),b&&C(b.length),t.chars&&b&&t.chars(b,c-b.length,c)}if(e===n){t.chars&&t.chars(e);break}}function C(t){c+=t,e=e.substring(t)}function x(){var t=e.match(Oo);if(t){var n,r,i={tagName:t[1],attrs:[],start:c};for(C(t[0].length);!(n=e.match(So))&&(r=e.match(xo)||e.match(Co));)r.start=c,C(r[0].length),r.end=c,i.attrs.push(r);if(n)return i.unarySlash=n[1],C(n[0].length),i.end=c,i}}function k(e){var n=e.tagName,c=e.unarySlash;o&&("p"===r&&wo(n)&&A(r),s(n)&&r===n&&A(n));for(var u=a(n)||!!c,l=e.attrs.length,f=new Array(l),p=0;p<l;p++){var d=e.attrs[p],v=d[3]||d[4]||d[5]||"",h="a"===n&&"href"===d[1]?t.shouldDecodeNewlinesForHref:t.shouldDecodeNewlines;f[p]={name:d[1],value:Ho(v,h)}}u||(i.push({tag:n,lowerCasedTag:n.toLowerCase(),attrs:f,start:e.start,end:e.end}),r=n),t.start&&t.start(n,f,u,e.start,e.end)}function A(e,n,o){var a,s;if(null==n&&(n=c),null==o&&(o=c),e)for(s=e.toLowerCase(),a=i.length-1;a>=0&&i[a].lowerCasedTag!==s;a--);else a=0;if(a>=0){for(var u=i.length-1;u>=a;u--)t.end&&t.end(i[u].tag,n,o);i.length=a,r=a&&i[a-1].tag}else"br"===s?t.start&&t.start(e,[],!0,n,o):"p"===s&&(t.start&&t.start(e,[],!1,n,o),t.end&&t.end(e,n,o))}A()}(e,{warn:Bo,expectHTML:t.expectHTML,isUnaryTag:t.isUnaryTag,canBeLeftOpenTag:t.canBeLeftOpenTag,shouldDecodeNewlines:t.shouldDecodeNewlines,shouldDecodeNewlinesForHref:t.shouldDecodeNewlinesForHref,shouldKeepComment:t.comments,outputSourceRange:t.outputSourceRange,start:function(e,o,a,l,f){var p=r&&r.ns||Wo(e);q&&"svg"===p&&(o=function(e){for(var t=[],n=0;n<e.length;n++){var r=e[n];ya.test(r.name)||(r.name=r.name.replace(ga,""),t.push(r))}return t}(o));var d,v=ua(e,o,r);p&&(v.ns=p),"style"!==(d=v).tag&&("script"!==d.tag||d.attrsMap.type&&"text/javascript"!==d.attrsMap.type)||te()||(v.forbidden=!0);for(var h=0;h<Vo.length;h++)v=Vo[h](v,t)||v;s||(!function(e){null!=Fr(e,"v-pre")&&(e.pre=!0)}(v),v.pre&&(s=!0)),Jo(v.tag)&&(c=!0),s?function(e){var t=e.attrsList,n=t.length;if(n)for(var r=e.attrs=new Array(n),i=0;i<n;i++)r[i]={name:t[i].name,value:JSON.stringify(t[i].value)},null!=t[i].start&&(r[i].start=t[i].start,r[i].end=t[i].end);else e.pre||(e.plain=!0)}(v):v.processed||(pa(v),function(e){var t=Fr(e,"v-if");if(t)e.if=t,da(e,{exp:t,block:e});else{null!=Fr(e,"v-else")&&(e.else=!0);var n=Fr(e,"v-else-if");n&&(e.elseif=n)}}(v),function(e){null!=Fr(e,"v-once")&&(e.once=!0)}(v)),n||(n=v),a?u(v):(r=v,i.push(v))},end:function(e,t,n){var o=i[i.length-1];i.length-=1,r=i[i.length-1],u(o)},chars:function(e,t,n){if(r&&(!q||"textarea"!==r.tag||r.attrsMap.placeholder!==e)){var i,u,l,f=r.children;if(e=c||e.trim()?"script"===(i=r).tag||"style"===i.tag?e:sa(e):f.length?a?"condense"===a&&oa.test(e)?"":" ":o?" ":"":"")c||"condense"!==a||(e=e.replace(aa," ")),!s&&" "!==e&&(u=function(e,t){var n=t?ho(t):po;if(n.test(e)){for(var r,i,o,a=[],s=[],c=n.lastIndex=0;r=n.exec(e);){(i=r.index)>c&&(s.push(o=e.slice(c,i)),a.push(JSON.stringify(o)));var u=Ar(r[1].trim());a.push("_s("+u+")"),s.push({"@binding":u}),c=i+r[0].length}return c<e.length&&(s.push(o=e.slice(c)),a.push(JSON.stringify(o))),{expression:a.join("+"),tokens:s}}}(e,Uo))?l={type:2,expression:u.expression,tokens:u.tokens,text:e}:" "===e&&f.length&&" "===f[f.length-1].text||(l={type:3,text:e}),l&&f.push(l)}},comment:function(e,t,n){if(r){var i={type:3,text:e,isComment:!0};r.children.push(i)}}}),n}function fa(e,t){var n,r;(r=Ir(n=e,"key"))&&(n.key=r),e.plain=!e.key&&!e.scopedSlots&&!e.attrsList.length,function(e){var t=Ir(e,"ref");t&&(e.ref=t,e.refInFor=function(e){var t=e;for(;t;){if(void 0!==t.for)return!0;t=t.parent}return!1}(e))}(e),function(e){var t;"template"===e.tag?(t=Fr(e,"scope"),e.slotScope=t||Fr(e,"slot-scope")):(t=Fr(e,"slot-scope"))&&(e.slotScope=t);var n=Ir(e,"slot");n&&(e.slotTarget='""'===n?'"default"':n,e.slotTargetDynamic=!(!e.attrsMap[":slot"]&&!e.attrsMap["v-bind:slot"]),"template"===e.tag||e.slotScope||Nr(e,"slot",n,function(e,t){return e.rawAttrsMap[":"+t]||e.rawAttrsMap["v-bind:"+t]||e.rawAttrsMap[t]}(e,"slot")));if("template"===e.tag){var r=Pr(e,ia);if(r){var i=va(r),o=i.name,a=i.dynamic;e.slotTarget=o,e.slotTargetDynamic=a,e.slotScope=r.value||ca}}else{var s=Pr(e,ia);if(s){var c=e.scopedSlots||(e.scopedSlots={}),u=va(s),l=u.name,f=u.dynamic,p=c[l]=ua("template",[],e);p.slotTarget=l,p.slotTargetDynamic=f,p.children=e.children.filter(function(e){if(!e.slotScope)return e.parent=p,!0}),p.slotScope=s.value||ca,e.children=[],e.plain=!1}}}(e),function(e){"slot"===e.tag&&(e.slotName=Ir(e,"name"))}(e),function(e){var t;(t=Ir(e,"is"))&&(e.component=t);null!=Fr(e,"inline-template")&&(e.inlineTemplate=!0)}(e);for(var i=0;i<zo.length;i++)e=zo[i](e,t)||e;return function(e){var t,n,r,i,o,a,s,c,u=e.attrsList;for(t=0,n=u.length;t<n;t++)if(r=i=u[t].name,o=u[t].value,Go.test(r))if(e.hasBindings=!0,(a=ha(r.replace(Go,"")))&&(r=r.replace(ra,"")),na.test(r))r=r.replace(na,""),o=Ar(o),(c=ea.test(r))&&(r=r.slice(1,-1)),a&&(a.prop&&!c&&"innerHtml"===(r=b(r))&&(r="innerHTML"),a.camel&&!c&&(r=b(r)),a.sync&&(s=Br(o,"$event"),c?Mr(e,'"update:"+('+r+")",s,null,!1,0,u[t],!0):(Mr(e,"update:"+b(r),s,null,!1,0,u[t]),C(r)!==b(r)&&Mr(e,"update:"+C(r),s,null,!1,0,u[t])))),a&&a.prop||!e.component&&qo(e.tag,e.attrsMap.type,r)?Er(e,r,o,u[t],c):Nr(e,r,o,u[t],c);else if(Zo.test(r))r=r.replace(Zo,""),(c=ea.test(r))&&(r=r.slice(1,-1)),Mr(e,r,o,a,!1,0,u[t],c);else{var l=(r=r.replace(Go,"")).match(ta),f=l&&l[1];c=!1,f&&(r=r.slice(0,-(f.length+1)),ea.test(f)&&(f=f.slice(1,-1),c=!0)),Dr(e,r,i,o,f,c,a,u[t])}else Nr(e,r,JSON.stringify(o),u[t]),!e.component&&"muted"===r&&qo(e.tag,e.attrsMap.type,r)&&Er(e,r,"true",u[t])}(e),e}function pa(e){var t;if(t=Fr(e,"v-for")){var n=function(e){var t=e.match(Xo);if(!t)return;var n={};n.for=t[2].trim();var r=t[1].trim().replace(Qo,""),i=r.match(Yo);i?(n.alias=r.replace(Yo,"").trim(),n.iterator1=i[1].trim(),i[2]&&(n.iterator2=i[2].trim())):n.alias=r;return n}(t);n&&A(e,n)}}function da(e,t){e.ifConditions||(e.ifConditions=[]),e.ifConditions.push(t)}function va(e){var t=e.name.replace(ia,"");return t||"#"!==e.name[0]&&(t="default"),ea.test(t)?{name:t.slice(1,-1),dynamic:!0}:{name:'"'+t+'"',dynamic:!1}}function ha(e){var t=e.match(ra);if(t){var n={};return t.forEach(function(e){n[e.slice(1)]=!0}),n}}function ma(e){for(var t={},n=0,r=e.length;n<r;n++)t[e[n].name]=e[n].value;return t}var ya=/^xmlns:NS\d+/,ga=/^NS\d+:/;function _a(e){return ua(e.tag,e.attrsList.slice(),e.parent)}var ba=[mo,go,{preTransformNode:function(e,t){if("input"===e.tag){var n,r=e.attrsMap;if(!r["v-model"])return;if((r[":type"]||r["v-bind:type"])&&(n=Ir(e,"type")),r.type||n||!r["v-bind"]||(n="("+r["v-bind"]+").type"),n){var i=Fr(e,"v-if",!0),o=i?"&&("+i+")":"",a=null!=Fr(e,"v-else",!0),s=Fr(e,"v-else-if",!0),c=_a(e);pa(c),jr(c,"type","checkbox"),fa(c,t),c.processed=!0,c.if="("+n+")==='checkbox'"+o,da(c,{exp:c.if,block:c});var u=_a(e);Fr(u,"v-for",!0),jr(u,"type","radio"),fa(u,t),da(c,{exp:"("+n+")==='radio'"+o,block:u});var l=_a(e);return Fr(l,"v-for",!0),jr(l,":type",n),fa(l,t),da(c,{exp:i,block:l}),a?c.else=!0:s&&(c.elseif=s),c}}}}];var $a,wa,Ca={expectHTML:!0,modules:ba,directives:{model:function(e,t,n){var r=t.value,i=t.modifiers,o=e.tag,a=e.attrsMap.type;if(e.component)return Hr(e,r,i),!1;if("select"===o)!function(e,t,n){var r='var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return '+(n&&n.number?"_n(val)":"val")+"});";r=r+" "+Br(t,"$event.target.multiple ? $$selectedVal : $$selectedVal[0]"),Mr(e,"change",r,null,!0)}(e,r,i);else if("input"===o&&"checkbox"===a)!function(e,t,n){var r=n&&n.number,i=Ir(e,"value")||"null",o=Ir(e,"true-value")||"true",a=Ir(e,"false-value")||"false";Er(e,"checked","Array.isArray("+t+")?_i("+t+","+i+")>-1"+("true"===o?":("+t+")":":_q("+t+","+o+")")),Mr(e,"change","var $$a="+t+",$$el=$event.target,$$c=$$el.checked?("+o+"):("+a+");if(Array.isArray($$a)){var $$v="+(r?"_n("+i+")":i)+",$$i=_i($$a,$$v);if($$el.checked){$$i<0&&("+Br(t,"$$a.concat([$$v])")+")}else{$$i>-1&&("+Br(t,"$$a.slice(0,$$i).concat($$a.slice($$i+1))")+")}}else{"+Br(t,"$$c")+"}",null,!0)}(e,r,i);else if("input"===o&&"radio"===a)!function(e,t,n){var r=n&&n.number,i=Ir(e,"value")||"null";Er(e,"checked","_q("+t+","+(i=r?"_n("+i+")":i)+")"),Mr(e,"change",Br(t,i),null,!0)}(e,r,i);else if("input"===o||"textarea"===o)!function(e,t,n){var r=e.attrsMap.type,i=n||{},o=i.lazy,a=i.number,s=i.trim,c=!o&&"range"!==r,u=o?"change":"range"===r?Wr:"input",l="$event.target.value";s&&(l="$event.target.value.trim()"),a&&(l="_n("+l+")");var f=Br(t,l);c&&(f="if($event.target.composing)return;"+f),Er(e,"value","("+t+")"),Mr(e,u,f,null,!0),(s||a)&&Mr(e,"blur","$forceUpdate()")}(e,r,i);else if(!F.isReservedTag(o))return Hr(e,r,i),!1;return!0},text:function(e,t){t.value&&Er(e,"textContent","_s("+t.value+")",t)},html:function(e,t){t.value&&Er(e,"innerHTML","_s("+t.value+")",t)}},isPreTag:function(e){return"pre"===e},isUnaryTag:bo,mustUseProp:jn,canBeLeftOpenTag:$o,isReservedTag:Wn,getTagNamespace:Zn,staticKeys:function(e){return e.reduce(function(e,t){return e.concat(t.staticKeys||[])},[]).join(",")}(ba)},xa=g(function(e){return p("type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap"+(e?","+e:""))});function ka(e,t){e&&($a=xa(t.staticKeys||""),wa=t.isReservedTag||T,function e(t){t.static=function(e){if(2===e.type)return!1;if(3===e.type)return!0;return!(!e.pre&&(e.hasBindings||e.if||e.for||d(e.tag)||!wa(e.tag)||function(e){for(;e.parent;){if("template"!==(e=e.parent).tag)return!1;if(e.for)return!0}return!1}(e)||!Object.keys(e).every($a)))}(t);if(1===t.type){if(!wa(t.tag)&&"slot"!==t.tag&&null==t.attrsMap["inline-template"])return;for(var n=0,r=t.children.length;n<r;n++){var i=t.children[n];e(i),i.static||(t.static=!1)}if(t.ifConditions)for(var o=1,a=t.ifConditions.length;o<a;o++){var s=t.ifConditions[o].block;e(s),s.static||(t.static=!1)}}}(e),function e(t,n){if(1===t.type){if((t.static||t.once)&&(t.staticInFor=n),t.static&&t.children.length&&(1!==t.children.length||3!==t.children[0].type))return void(t.staticRoot=!0);if(t.staticRoot=!1,t.children)for(var r=0,i=t.children.length;r<i;r++)e(t.children[r],n||!!t.for);if(t.ifConditions)for(var o=1,a=t.ifConditions.length;o<a;o++)e(t.ifConditions[o].block,n)}}(e,!1))}var Aa=/^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/,Oa=/\([^)]*?\);*$/,Sa=/^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/,Ta={esc:27,tab:9,enter:13,space:32,up:38,left:37,right:39,down:40,delete:[8,46]},Ea={esc:["Esc","Escape"],tab:"Tab",enter:"Enter",space:[" ","Spacebar"],up:["Up","ArrowUp"],left:["Left","ArrowLeft"],right:["Right","ArrowRight"],down:["Down","ArrowDown"],delete:["Backspace","Delete","Del"]},Na=function(e){return"if("+e+")return null;"},ja={stop:"$event.stopPropagation();",prevent:"$event.preventDefault();",self:Na("$event.target !== $event.currentTarget"),ctrl:Na("!$event.ctrlKey"),shift:Na("!$event.shiftKey"),alt:Na("!$event.altKey"),meta:Na("!$event.metaKey"),left:Na("'button' in $event && $event.button !== 0"),middle:Na("'button' in $event && $event.button !== 1"),right:Na("'button' in $event && $event.button !== 2")};function Da(e,t){var n=t?"nativeOn:":"on:",r="",i="";for(var o in e){var a=La(e[o]);e[o]&&e[o].dynamic?i+=o+","+a+",":r+='"'+o+'":'+a+","}return r="{"+r.slice(0,-1)+"}",i?n+"_d("+r+",["+i.slice(0,-1)+"])":n+r}function La(e){if(!e)return"function(){}";if(Array.isArray(e))return"["+e.map(function(e){return La(e)}).join(",")+"]";var t=Sa.test(e.value),n=Aa.test(e.value),r=Sa.test(e.value.replace(Oa,""));if(e.modifiers){var i="",o="",a=[];for(var s in e.modifiers)if(ja[s])o+=ja[s],Ta[s]&&a.push(s);else if("exact"===s){var c=e.modifiers;o+=Na(["ctrl","shift","alt","meta"].filter(function(e){return!c[e]}).map(function(e){return"$event."+e+"Key"}).join("||"))}else a.push(s);return a.length&&(i+=function(e){return"if(!$event.type.indexOf('key')&&"+e.map(Ma).join("&&")+")return null;"}(a)),o&&(i+=o),"function($event){"+i+(t?"return "+e.value+"($event)":n?"return ("+e.value+")($event)":r?"return "+e.value:e.value)+"}"}return t||n?e.value:"function($event){"+(r?"return "+e.value:e.value)+"}"}function Ma(e){var t=parseInt(e,10);if(t)return"$event.keyCode!=="+t;var n=Ta[e],r=Ea[e];return"_k($event.keyCode,"+JSON.stringify(e)+","+JSON.stringify(n)+",$event.key,"+JSON.stringify(r)+")"}var Ia={on:function(e,t){e.wrapListeners=function(e){return"_g("+e+","+t.value+")"}},bind:function(e,t){e.wrapData=function(n){return"_b("+n+",'"+e.tag+"',"+t.value+","+(t.modifiers&&t.modifiers.prop?"true":"false")+(t.modifiers&&t.modifiers.sync?",true":"")+")"}},cloak:S},Fa=function(e){this.options=e,this.warn=e.warn||Sr,this.transforms=Tr(e.modules,"transformCode"),this.dataGenFns=Tr(e.modules,"genData"),this.directives=A(A({},Ia),e.directives);var t=e.isReservedTag||T;this.maybeComponent=function(e){return!!e.component||!t(e.tag)},this.onceId=0,this.staticRenderFns=[],this.pre=!1};function Pa(e,t){var n=new Fa(t);return{render:"with(this){return "+(e?Ra(e,n):'_c("div")')+"}",staticRenderFns:n.staticRenderFns}}function Ra(e,t){if(e.parent&&(e.pre=e.pre||e.parent.pre),e.staticRoot&&!e.staticProcessed)return Ha(e,t);if(e.once&&!e.onceProcessed)return Ba(e,t);if(e.for&&!e.forProcessed)return za(e,t);if(e.if&&!e.ifProcessed)return Ua(e,t);if("template"!==e.tag||e.slotTarget||t.pre){if("slot"===e.tag)return function(e,t){var n=e.slotName||'"default"',r=qa(e,t),i="_t("+n+(r?","+r:""),o=e.attrs||e.dynamicAttrs?Ga((e.attrs||[]).concat(e.dynamicAttrs||[]).map(function(e){return{name:b(e.name),value:e.value,dynamic:e.dynamic}})):null,a=e.attrsMap["v-bind"];!o&&!a||r||(i+=",null");o&&(i+=","+o);a&&(i+=(o?"":",null")+","+a);return i+")"}(e,t);var n;if(e.component)n=function(e,t,n){var r=t.inlineTemplate?null:qa(t,n,!0);return"_c("+e+","+Va(t,n)+(r?","+r:"")+")"}(e.component,e,t);else{var r;(!e.plain||e.pre&&t.maybeComponent(e))&&(r=Va(e,t));var i=e.inlineTemplate?null:qa(e,t,!0);n="_c('"+e.tag+"'"+(r?","+r:"")+(i?","+i:"")+")"}for(var o=0;o<t.transforms.length;o++)n=t.transforms[o](e,n);return n}return qa(e,t)||"void 0"}function Ha(e,t){e.staticProcessed=!0;var n=t.pre;return e.pre&&(t.pre=e.pre),t.staticRenderFns.push("with(this){return "+Ra(e,t)+"}"),t.pre=n,"_m("+(t.staticRenderFns.length-1)+(e.staticInFor?",true":"")+")"}function Ba(e,t){if(e.onceProcessed=!0,e.if&&!e.ifProcessed)return Ua(e,t);if(e.staticInFor){for(var n="",r=e.parent;r;){if(r.for){n=r.key;break}r=r.parent}return n?"_o("+Ra(e,t)+","+t.onceId+++","+n+")":Ra(e,t)}return Ha(e,t)}function Ua(e,t,n,r){return e.ifProcessed=!0,function e(t,n,r,i){if(!t.length)return i||"_e()";var o=t.shift();return o.exp?"("+o.exp+")?"+a(o.block)+":"+e(t,n,r,i):""+a(o.block);function a(e){return r?r(e,n):e.once?Ba(e,n):Ra(e,n)}}(e.ifConditions.slice(),t,n,r)}function za(e,t,n,r){var i=e.for,o=e.alias,a=e.iterator1?","+e.iterator1:"",s=e.iterator2?","+e.iterator2:"";return e.forProcessed=!0,(r||"_l")+"(("+i+"),function("+o+a+s+"){return "+(n||Ra)(e,t)+"})"}function Va(e,t){var n="{",r=function(e,t){var n=e.directives;if(!n)return;var r,i,o,a,s="directives:[",c=!1;for(r=0,i=n.length;r<i;r++){o=n[r],a=!0;var u=t.directives[o.name];u&&(a=!!u(e,o,t.warn)),a&&(c=!0,s+='{name:"'+o.name+'",rawName:"'+o.rawName+'"'+(o.value?",value:("+o.value+"),expression:"+JSON.stringify(o.value):"")+(o.arg?",arg:"+(o.isDynamicArg?o.arg:'"'+o.arg+'"'):"")+(o.modifiers?",modifiers:"+JSON.stringify(o.modifiers):"")+"},")}if(c)return s.slice(0,-1)+"]"}(e,t);r&&(n+=r+","),e.key&&(n+="key:"+e.key+","),e.ref&&(n+="ref:"+e.ref+","),e.refInFor&&(n+="refInFor:true,"),e.pre&&(n+="pre:true,"),e.component&&(n+='tag:"'+e.tag+'",');for(var i=0;i<t.dataGenFns.length;i++)n+=t.dataGenFns[i](e);if(e.attrs&&(n+="attrs:"+Ga(e.attrs)+","),e.props&&(n+="domProps:"+Ga(e.props)+","),e.events&&(n+=Da(e.events,!1)+","),e.nativeEvents&&(n+=Da(e.nativeEvents,!0)+","),e.slotTarget&&!e.slotScope&&(n+="slot:"+e.slotTarget+","),e.scopedSlots&&(n+=function(e,t,n){var r=e.for||Object.keys(t).some(function(e){var n=t[e];return n.slotTargetDynamic||n.if||n.for||Ka(n)}),i=!!e.if;if(!r)for(var o=e.parent;o;){if(o.slotScope&&o.slotScope!==ca||o.for){r=!0;break}o.if&&(i=!0),o=o.parent}var a=Object.keys(t).map(function(e){return Ja(t[e],n)}).join(",");return"scopedSlots:_u(["+a+"]"+(r?",null,true":"")+(!r&&i?",null,false,"+function(e){var t=5381,n=e.length;for(;n;)t=33*t^e.charCodeAt(--n);return t>>>0}(a):"")+")"}(e,e.scopedSlots,t)+","),e.model&&(n+="model:{value:"+e.model.value+",callback:"+e.model.callback+",expression:"+e.model.expression+"},"),e.inlineTemplate){var o=function(e,t){var n=e.children[0];if(n&&1===n.type){var r=Pa(n,t.options);return"inlineTemplate:{render:function(){"+r.render+"},staticRenderFns:["+r.staticRenderFns.map(function(e){return"function(){"+e+"}"}).join(",")+"]}"}}(e,t);o&&(n+=o+",")}return n=n.replace(/,$/,"")+"}",e.dynamicAttrs&&(n="_b("+n+',"'+e.tag+'",'+Ga(e.dynamicAttrs)+")"),e.wrapData&&(n=e.wrapData(n)),e.wrapListeners&&(n=e.wrapListeners(n)),n}function Ka(e){return 1===e.type&&("slot"===e.tag||e.children.some(Ka))}function Ja(e,t){var n=e.attrsMap["slot-scope"];if(e.if&&!e.ifProcessed&&!n)return Ua(e,t,Ja,"null");if(e.for&&!e.forProcessed)return za(e,t,Ja);var r=e.slotScope===ca?"":String(e.slotScope),i="function("+r+"){return "+("template"===e.tag?e.if&&n?"("+e.if+")?"+(qa(e,t)||"undefined")+":undefined":qa(e,t)||"undefined":Ra(e,t))+"}",o=r?"":",proxy:true";return"{key:"+(e.slotTarget||'"default"')+",fn:"+i+o+"}"}function qa(e,t,n,r,i){var o=e.children;if(o.length){var a=o[0];if(1===o.length&&a.for&&"template"!==a.tag&&"slot"!==a.tag){var s=n?t.maybeComponent(a)?",1":",0":"";return""+(r||Ra)(a,t)+s}var c=n?function(e,t){for(var n=0,r=0;r<e.length;r++){var i=e[r];if(1===i.type){if(Wa(i)||i.ifConditions&&i.ifConditions.some(function(e){return Wa(e.block)})){n=2;break}(t(i)||i.ifConditions&&i.ifConditions.some(function(e){return t(e.block)}))&&(n=1)}}return n}(o,t.maybeComponent):0,u=i||Za;return"["+o.map(function(e){return u(e,t)}).join(",")+"]"+(c?","+c:"")}}function Wa(e){return void 0!==e.for||"template"===e.tag||"slot"===e.tag}function Za(e,t){return 1===e.type?Ra(e,t):3===e.type&&e.isComment?(r=e,"_e("+JSON.stringify(r.text)+")"):"_v("+(2===(n=e).type?n.expression:Xa(JSON.stringify(n.text)))+")";var n,r}function Ga(e){for(var t="",n="",r=0;r<e.length;r++){var i=e[r],o=Xa(i.value);i.dynamic?n+=i.name+","+o+",":t+='"'+i.name+'":'+o+","}return t="{"+t.slice(0,-1)+"}",n?"_d("+t+",["+n.slice(0,-1)+"])":t}function Xa(e){return e.replace(/\u2028/g,"\\u2028").replace(/\u2029/g,"\\u2029")}new RegExp("\\b"+"do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,super,throw,while,yield,delete,export,import,return,switch,default,extends,finally,continue,debugger,function,arguments".split(",").join("\\b|\\b")+"\\b");function Ya(e,t){try{return new Function(e)}catch(n){return t.push({err:n,code:e}),S}}function Qa(e){var t=Object.create(null);return function(n,r,i){(r=A({},r)).warn;delete r.warn;var o=r.delimiters?String(r.delimiters)+n:n;if(t[o])return t[o];var a=e(n,r),s={},c=[];return s.render=Ya(a.render,c),s.staticRenderFns=a.staticRenderFns.map(function(e){return Ya(e,c)}),t[o]=s}}var es,ts,ns=(es=function(e,t){var n=la(e.trim(),t);!1!==t.optimize&&ka(n,t);var r=Pa(n,t);return{ast:n,render:r.render,staticRenderFns:r.staticRenderFns}},function(e){function t(t,n){var r=Object.create(e),i=[],o=[];if(n)for(var a in n.modules&&(r.modules=(e.modules||[]).concat(n.modules)),n.directives&&(r.directives=A(Object.create(e.directives||null),n.directives)),n)"modules"!==a&&"directives"!==a&&(r[a]=n[a]);r.warn=function(e,t,n){(n?o:i).push(e)};var s=es(t.trim(),r);return s.errors=i,s.tips=o,s}return{compile:t,compileToFunctions:Qa(t)}})(Ca),rs=(ns.compile,ns.compileToFunctions);function is(e){return(ts=ts||document.createElement("div")).innerHTML=e?'<a href="\n"/>':'<div a="\n"/>',ts.innerHTML.indexOf("&#10;")>0}var os=!!z&&is(!1),as=!!z&&is(!0),ss=g(function(e){var t=Yn(e);return t&&t.innerHTML}),cs=wn.prototype.$mount;wn.prototype.$mount=function(e,t){if((e=e&&Yn(e))===document.body||e===document.documentElement)return this;var n=this.$options;if(!n.render){var r=n.template;if(r)if("string"==typeof r)"#"===r.charAt(0)&&(r=ss(r));else{if(!r.nodeType)return this;r=r.innerHTML}else e&&(r=function(e){if(e.outerHTML)return e.outerHTML;var t=document.createElement("div");return t.appendChild(e.cloneNode(!0)),t.innerHTML}(e));if(r){var i=rs(r,{outputSourceRange:!1,shouldDecodeNewlines:os,shouldDecodeNewlinesForHref:as,delimiters:n.delimiters,comments:n.comments},this),o=i.render,a=i.staticRenderFns;n.render=o,n.staticRenderFns=a}}return cs.call(this,e,t)},wn.compile=rs,module.exports=wn;
}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],794:[function(require,module,exports){
(function (global){
/*!
 * Vue.js v2.6.11
 * (c) 2014-2019 Evan You
 * Released under the MIT License.
 */
'use strict';

/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "development" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "development" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

{
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (!config.async) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (customSetter) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (isUndef(target) || isPrimitive(target)
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (isUndef(target) || isPrimitive(target)
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
{
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "development" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (warnMissing && !res) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (isObject(def)) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

{
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

var mark;
var measure;

{
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (!isObject(bindObject)) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (key !== '' && key !== null) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (isDef(data) && isDef(data.key) && !isPrimitive(data.key)
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (isDef(data) && isDef(data.nativeOn)) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (vm.$options.renderError) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (Array.isArray(vnode)) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                "timeout (" + (res.timeout) + "ms)"
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (config.performance && mark) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (has[id] != null) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (!config.async) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression = expOrFn.toString();
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (getter == null) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (sharedPropertyDefinition.set === noop) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (config.performance && mark) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    {
      initProxy(vm);
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (config.performance && mark) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (!(this instanceof Vue)
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (name) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (type === 'component') {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.11';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (data && data.pre) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (typeof console !== 'undefined' &&
                !hydrationBailed
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (typeof console !== 'undefined' &&
                !hydrationBailed
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

/*  */

/*  */

/*  */

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecesarry `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (explicitEnterDuration != null) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (isDef(explicitLeaveDuration)) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (children.length > 1) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (mode && mode !== 'in-out' && mode !== 'out-in'
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (config.productionTip !== false &&
      typeof console !== 'undefined'
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

module.exports = Vue;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],795:[function(require,module,exports){
(function (process){
if (process.env.NODE_ENV === 'production') {
  module.exports = require('./vue.runtime.common.prod.js')
} else {
  module.exports = require('./vue.runtime.common.dev.js')
}

}).call(this,require('_process'))
},{"./vue.runtime.common.dev.js":794,"./vue.runtime.common.prod.js":796,"_process":734}],796:[function(require,module,exports){
(function (global){
/*!
 * Vue.js v2.6.11
 * (c) 2014-2019 Evan You
 * Released under the MIT License.
 */
"use strict";var t=Object.freeze({});function e(t){return null==t}function n(t){return null!=t}function r(t){return!0===t}function o(t){return"string"==typeof t||"number"==typeof t||"symbol"==typeof t||"boolean"==typeof t}function i(t){return null!==t&&"object"==typeof t}var a=Object.prototype.toString;function s(t){return"[object Object]"===a.call(t)}function c(t){var e=parseFloat(String(t));return e>=0&&Math.floor(e)===e&&isFinite(t)}function u(t){return n(t)&&"function"==typeof t.then&&"function"==typeof t.catch}function l(t){return null==t?"":Array.isArray(t)||s(t)&&t.toString===a?JSON.stringify(t,null,2):String(t)}function f(t){var e=parseFloat(t);return isNaN(e)?t:e}function p(t,e){for(var n=Object.create(null),r=t.split(","),o=0;o<r.length;o++)n[r[o]]=!0;return e?function(t){return n[t.toLowerCase()]}:function(t){return n[t]}}var d=p("key,ref,slot,slot-scope,is");function v(t,e){if(t.length){var n=t.indexOf(e);if(n>-1)return t.splice(n,1)}}var h=Object.prototype.hasOwnProperty;function m(t,e){return h.call(t,e)}function y(t){var e=Object.create(null);return function(n){return e[n]||(e[n]=t(n))}}var g=/-(\w)/g,_=y(function(t){return t.replace(g,function(t,e){return e?e.toUpperCase():""})}),b=y(function(t){return t.charAt(0).toUpperCase()+t.slice(1)}),C=/\B([A-Z])/g,$=y(function(t){return t.replace(C,"-$1").toLowerCase()});var w=Function.prototype.bind?function(t,e){return t.bind(e)}:function(t,e){function n(n){var r=arguments.length;return r?r>1?t.apply(e,arguments):t.call(e,n):t.call(e)}return n._length=t.length,n};function A(t,e){e=e||0;for(var n=t.length-e,r=new Array(n);n--;)r[n]=t[n+e];return r}function x(t,e){for(var n in e)t[n]=e[n];return t}function O(t){for(var e={},n=0;n<t.length;n++)t[n]&&x(e,t[n]);return e}function k(t,e,n){}var S=function(t,e,n){return!1},E=function(t){return t};function j(t,e){if(t===e)return!0;var n=i(t),r=i(e);if(!n||!r)return!n&&!r&&String(t)===String(e);try{var o=Array.isArray(t),a=Array.isArray(e);if(o&&a)return t.length===e.length&&t.every(function(t,n){return j(t,e[n])});if(t instanceof Date&&e instanceof Date)return t.getTime()===e.getTime();if(o||a)return!1;var s=Object.keys(t),c=Object.keys(e);return s.length===c.length&&s.every(function(n){return j(t[n],e[n])})}catch(t){return!1}}function T(t,e){for(var n=0;n<t.length;n++)if(j(t[n],e))return n;return-1}function I(t){var e=!1;return function(){e||(e=!0,t.apply(this,arguments))}}var D="data-server-rendered",N=["component","directive","filter"],P=["beforeCreate","created","beforeMount","mounted","beforeUpdate","updated","beforeDestroy","destroyed","activated","deactivated","errorCaptured","serverPrefetch"],L={optionMergeStrategies:Object.create(null),silent:!1,productionTip:!1,devtools:!1,performance:!1,errorHandler:null,warnHandler:null,ignoredElements:[],keyCodes:Object.create(null),isReservedTag:S,isReservedAttr:S,isUnknownElement:S,getTagNamespace:k,parsePlatformTagName:E,mustUseProp:S,async:!0,_lifecycleHooks:P};function M(t,e,n,r){Object.defineProperty(t,e,{value:n,enumerable:!!r,writable:!0,configurable:!0})}var F=new RegExp("[^"+/a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/.source+".$_\\d]");var R,U="__proto__"in{},H="undefined"!=typeof window,B="undefined"!=typeof WXEnvironment&&!!WXEnvironment.platform,V=B&&WXEnvironment.platform.toLowerCase(),z=H&&window.navigator.userAgent.toLowerCase(),W=z&&/msie|trident/.test(z),q=z&&z.indexOf("msie 9.0")>0,K=z&&z.indexOf("edge/")>0,X=(z&&z.indexOf("android"),z&&/iphone|ipad|ipod|ios/.test(z)||"ios"===V),G=(z&&/chrome\/\d+/.test(z),z&&/phantomjs/.test(z),z&&z.match(/firefox\/(\d+)/)),Z={}.watch,J=!1;if(H)try{var Q={};Object.defineProperty(Q,"passive",{get:function(){J=!0}}),window.addEventListener("test-passive",null,Q)}catch(t){}var Y=function(){return void 0===R&&(R=!H&&!B&&"undefined"!=typeof global&&(global.process&&"server"===global.process.env.VUE_ENV)),R},tt=H&&window.__VUE_DEVTOOLS_GLOBAL_HOOK__;function et(t){return"function"==typeof t&&/native code/.test(t.toString())}var nt,rt="undefined"!=typeof Symbol&&et(Symbol)&&"undefined"!=typeof Reflect&&et(Reflect.ownKeys);nt="undefined"!=typeof Set&&et(Set)?Set:function(){function t(){this.set=Object.create(null)}return t.prototype.has=function(t){return!0===this.set[t]},t.prototype.add=function(t){this.set[t]=!0},t.prototype.clear=function(){this.set=Object.create(null)},t}();var ot=k,it=0,at=function(){this.id=it++,this.subs=[]};at.prototype.addSub=function(t){this.subs.push(t)},at.prototype.removeSub=function(t){v(this.subs,t)},at.prototype.depend=function(){at.target&&at.target.addDep(this)},at.prototype.notify=function(){for(var t=this.subs.slice(),e=0,n=t.length;e<n;e++)t[e].update()},at.target=null;var st=[];function ct(t){st.push(t),at.target=t}function ut(){st.pop(),at.target=st[st.length-1]}var lt=function(t,e,n,r,o,i,a,s){this.tag=t,this.data=e,this.children=n,this.text=r,this.elm=o,this.ns=void 0,this.context=i,this.fnContext=void 0,this.fnOptions=void 0,this.fnScopeId=void 0,this.key=e&&e.key,this.componentOptions=a,this.componentInstance=void 0,this.parent=void 0,this.raw=!1,this.isStatic=!1,this.isRootInsert=!0,this.isComment=!1,this.isCloned=!1,this.isOnce=!1,this.asyncFactory=s,this.asyncMeta=void 0,this.isAsyncPlaceholder=!1},ft={child:{configurable:!0}};ft.child.get=function(){return this.componentInstance},Object.defineProperties(lt.prototype,ft);var pt=function(t){void 0===t&&(t="");var e=new lt;return e.text=t,e.isComment=!0,e};function dt(t){return new lt(void 0,void 0,void 0,String(t))}function vt(t){var e=new lt(t.tag,t.data,t.children&&t.children.slice(),t.text,t.elm,t.context,t.componentOptions,t.asyncFactory);return e.ns=t.ns,e.isStatic=t.isStatic,e.key=t.key,e.isComment=t.isComment,e.fnContext=t.fnContext,e.fnOptions=t.fnOptions,e.fnScopeId=t.fnScopeId,e.asyncMeta=t.asyncMeta,e.isCloned=!0,e}var ht=Array.prototype,mt=Object.create(ht);["push","pop","shift","unshift","splice","sort","reverse"].forEach(function(t){var e=ht[t];M(mt,t,function(){for(var n=[],r=arguments.length;r--;)n[r]=arguments[r];var o,i=e.apply(this,n),a=this.__ob__;switch(t){case"push":case"unshift":o=n;break;case"splice":o=n.slice(2)}return o&&a.observeArray(o),a.dep.notify(),i})});var yt=Object.getOwnPropertyNames(mt),gt=!0;function _t(t){gt=t}var bt=function(t){var e;this.value=t,this.dep=new at,this.vmCount=0,M(t,"__ob__",this),Array.isArray(t)?(U?(e=mt,t.__proto__=e):function(t,e,n){for(var r=0,o=n.length;r<o;r++){var i=n[r];M(t,i,e[i])}}(t,mt,yt),this.observeArray(t)):this.walk(t)};function Ct(t,e){var n;if(i(t)&&!(t instanceof lt))return m(t,"__ob__")&&t.__ob__ instanceof bt?n=t.__ob__:gt&&!Y()&&(Array.isArray(t)||s(t))&&Object.isExtensible(t)&&!t._isVue&&(n=new bt(t)),e&&n&&n.vmCount++,n}function $t(t,e,n,r,o){var i=new at,a=Object.getOwnPropertyDescriptor(t,e);if(!a||!1!==a.configurable){var s=a&&a.get,c=a&&a.set;s&&!c||2!==arguments.length||(n=t[e]);var u=!o&&Ct(n);Object.defineProperty(t,e,{enumerable:!0,configurable:!0,get:function(){var e=s?s.call(t):n;return at.target&&(i.depend(),u&&(u.dep.depend(),Array.isArray(e)&&function t(e){for(var n=void 0,r=0,o=e.length;r<o;r++)(n=e[r])&&n.__ob__&&n.__ob__.dep.depend(),Array.isArray(n)&&t(n)}(e))),e},set:function(e){var r=s?s.call(t):n;e===r||e!=e&&r!=r||s&&!c||(c?c.call(t,e):n=e,u=!o&&Ct(e),i.notify())}})}}function wt(t,e,n){if(Array.isArray(t)&&c(e))return t.length=Math.max(t.length,e),t.splice(e,1,n),n;if(e in t&&!(e in Object.prototype))return t[e]=n,n;var r=t.__ob__;return t._isVue||r&&r.vmCount?n:r?($t(r.value,e,n),r.dep.notify(),n):(t[e]=n,n)}function At(t,e){if(Array.isArray(t)&&c(e))t.splice(e,1);else{var n=t.__ob__;t._isVue||n&&n.vmCount||m(t,e)&&(delete t[e],n&&n.dep.notify())}}bt.prototype.walk=function(t){for(var e=Object.keys(t),n=0;n<e.length;n++)$t(t,e[n])},bt.prototype.observeArray=function(t){for(var e=0,n=t.length;e<n;e++)Ct(t[e])};var xt=L.optionMergeStrategies;function Ot(t,e){if(!e)return t;for(var n,r,o,i=rt?Reflect.ownKeys(e):Object.keys(e),a=0;a<i.length;a++)"__ob__"!==(n=i[a])&&(r=t[n],o=e[n],m(t,n)?r!==o&&s(r)&&s(o)&&Ot(r,o):wt(t,n,o));return t}function kt(t,e,n){return n?function(){var r="function"==typeof e?e.call(n,n):e,o="function"==typeof t?t.call(n,n):t;return r?Ot(r,o):o}:e?t?function(){return Ot("function"==typeof e?e.call(this,this):e,"function"==typeof t?t.call(this,this):t)}:e:t}function St(t,e){var n=e?t?t.concat(e):Array.isArray(e)?e:[e]:t;return n?function(t){for(var e=[],n=0;n<t.length;n++)-1===e.indexOf(t[n])&&e.push(t[n]);return e}(n):n}function Et(t,e,n,r){var o=Object.create(t||null);return e?x(o,e):o}xt.data=function(t,e,n){return n?kt(t,e,n):e&&"function"!=typeof e?t:kt(t,e)},P.forEach(function(t){xt[t]=St}),N.forEach(function(t){xt[t+"s"]=Et}),xt.watch=function(t,e,n,r){if(t===Z&&(t=void 0),e===Z&&(e=void 0),!e)return Object.create(t||null);if(!t)return e;var o={};for(var i in x(o,t),e){var a=o[i],s=e[i];a&&!Array.isArray(a)&&(a=[a]),o[i]=a?a.concat(s):Array.isArray(s)?s:[s]}return o},xt.props=xt.methods=xt.inject=xt.computed=function(t,e,n,r){if(!t)return e;var o=Object.create(null);return x(o,t),e&&x(o,e),o},xt.provide=kt;var jt=function(t,e){return void 0===e?t:e};function Tt(t,e,n){if("function"==typeof e&&(e=e.options),function(t,e){var n=t.props;if(n){var r,o,i={};if(Array.isArray(n))for(r=n.length;r--;)"string"==typeof(o=n[r])&&(i[_(o)]={type:null});else if(s(n))for(var a in n)o=n[a],i[_(a)]=s(o)?o:{type:o};t.props=i}}(e),function(t,e){var n=t.inject;if(n){var r=t.inject={};if(Array.isArray(n))for(var o=0;o<n.length;o++)r[n[o]]={from:n[o]};else if(s(n))for(var i in n){var a=n[i];r[i]=s(a)?x({from:i},a):{from:a}}}}(e),function(t){var e=t.directives;if(e)for(var n in e){var r=e[n];"function"==typeof r&&(e[n]={bind:r,update:r})}}(e),!e._base&&(e.extends&&(t=Tt(t,e.extends,n)),e.mixins))for(var r=0,o=e.mixins.length;r<o;r++)t=Tt(t,e.mixins[r],n);var i,a={};for(i in t)c(i);for(i in e)m(t,i)||c(i);function c(r){var o=xt[r]||jt;a[r]=o(t[r],e[r],n,r)}return a}function It(t,e,n,r){if("string"==typeof n){var o=t[e];if(m(o,n))return o[n];var i=_(n);if(m(o,i))return o[i];var a=b(i);return m(o,a)?o[a]:o[n]||o[i]||o[a]}}function Dt(t,e,n,r){var o=e[t],i=!m(n,t),a=n[t],s=Lt(Boolean,o.type);if(s>-1)if(i&&!m(o,"default"))a=!1;else if(""===a||a===$(t)){var c=Lt(String,o.type);(c<0||s<c)&&(a=!0)}if(void 0===a){a=function(t,e,n){if(!m(e,"default"))return;var r=e.default;if(t&&t.$options.propsData&&void 0===t.$options.propsData[n]&&void 0!==t._props[n])return t._props[n];return"function"==typeof r&&"Function"!==Nt(e.type)?r.call(t):r}(r,o,t);var u=gt;_t(!0),Ct(a),_t(u)}return a}function Nt(t){var e=t&&t.toString().match(/^\s*function (\w+)/);return e?e[1]:""}function Pt(t,e){return Nt(t)===Nt(e)}function Lt(t,e){if(!Array.isArray(e))return Pt(e,t)?0:-1;for(var n=0,r=e.length;n<r;n++)if(Pt(e[n],t))return n;return-1}function Mt(t,e,n){ct();try{if(e)for(var r=e;r=r.$parent;){var o=r.$options.errorCaptured;if(o)for(var i=0;i<o.length;i++)try{if(!1===o[i].call(r,t,e,n))return}catch(t){Rt(t,r,"errorCaptured hook")}}Rt(t,e,n)}finally{ut()}}function Ft(t,e,n,r,o){var i;try{(i=n?t.apply(e,n):t.call(e))&&!i._isVue&&u(i)&&!i._handled&&(i.catch(function(t){return Mt(t,r,o+" (Promise/async)")}),i._handled=!0)}catch(t){Mt(t,r,o)}return i}function Rt(t,e,n){if(L.errorHandler)try{return L.errorHandler.call(null,t,e,n)}catch(e){e!==t&&Ut(e,null,"config.errorHandler")}Ut(t,e,n)}function Ut(t,e,n){if(!H&&!B||"undefined"==typeof console)throw t;console.error(t)}var Ht,Bt=!1,Vt=[],zt=!1;function Wt(){zt=!1;var t=Vt.slice(0);Vt.length=0;for(var e=0;e<t.length;e++)t[e]()}if("undefined"!=typeof Promise&&et(Promise)){var qt=Promise.resolve();Ht=function(){qt.then(Wt),X&&setTimeout(k)},Bt=!0}else if(W||"undefined"==typeof MutationObserver||!et(MutationObserver)&&"[object MutationObserverConstructor]"!==MutationObserver.toString())Ht="undefined"!=typeof setImmediate&&et(setImmediate)?function(){setImmediate(Wt)}:function(){setTimeout(Wt,0)};else{var Kt=1,Xt=new MutationObserver(Wt),Gt=document.createTextNode(String(Kt));Xt.observe(Gt,{characterData:!0}),Ht=function(){Kt=(Kt+1)%2,Gt.data=String(Kt)},Bt=!0}function Zt(t,e){var n;if(Vt.push(function(){if(t)try{t.call(e)}catch(t){Mt(t,e,"nextTick")}else n&&n(e)}),zt||(zt=!0,Ht()),!t&&"undefined"!=typeof Promise)return new Promise(function(t){n=t})}var Jt=new nt;function Qt(t){!function t(e,n){var r,o;var a=Array.isArray(e);if(!a&&!i(e)||Object.isFrozen(e)||e instanceof lt)return;if(e.__ob__){var s=e.__ob__.dep.id;if(n.has(s))return;n.add(s)}if(a)for(r=e.length;r--;)t(e[r],n);else for(o=Object.keys(e),r=o.length;r--;)t(e[o[r]],n)}(t,Jt),Jt.clear()}var Yt=y(function(t){var e="&"===t.charAt(0),n="~"===(t=e?t.slice(1):t).charAt(0),r="!"===(t=n?t.slice(1):t).charAt(0);return{name:t=r?t.slice(1):t,once:n,capture:r,passive:e}});function te(t,e){function n(){var t=arguments,r=n.fns;if(!Array.isArray(r))return Ft(r,null,arguments,e,"v-on handler");for(var o=r.slice(),i=0;i<o.length;i++)Ft(o[i],null,t,e,"v-on handler")}return n.fns=t,n}function ee(t,n,o,i,a,s){var c,u,l,f;for(c in t)u=t[c],l=n[c],f=Yt(c),e(u)||(e(l)?(e(u.fns)&&(u=t[c]=te(u,s)),r(f.once)&&(u=t[c]=a(f.name,u,f.capture)),o(f.name,u,f.capture,f.passive,f.params)):u!==l&&(l.fns=u,t[c]=l));for(c in n)e(t[c])&&i((f=Yt(c)).name,n[c],f.capture)}function ne(t,o,i){var a;t instanceof lt&&(t=t.data.hook||(t.data.hook={}));var s=t[o];function c(){i.apply(this,arguments),v(a.fns,c)}e(s)?a=te([c]):n(s.fns)&&r(s.merged)?(a=s).fns.push(c):a=te([s,c]),a.merged=!0,t[o]=a}function re(t,e,r,o,i){if(n(e)){if(m(e,r))return t[r]=e[r],i||delete e[r],!0;if(m(e,o))return t[r]=e[o],i||delete e[o],!0}return!1}function oe(t){return o(t)?[dt(t)]:Array.isArray(t)?function t(i,a){var s=[];var c,u,l,f;for(c=0;c<i.length;c++)e(u=i[c])||"boolean"==typeof u||(l=s.length-1,f=s[l],Array.isArray(u)?u.length>0&&(ie((u=t(u,(a||"")+"_"+c))[0])&&ie(f)&&(s[l]=dt(f.text+u[0].text),u.shift()),s.push.apply(s,u)):o(u)?ie(f)?s[l]=dt(f.text+u):""!==u&&s.push(dt(u)):ie(u)&&ie(f)?s[l]=dt(f.text+u.text):(r(i._isVList)&&n(u.tag)&&e(u.key)&&n(a)&&(u.key="__vlist"+a+"_"+c+"__"),s.push(u)));return s}(t):void 0}function ie(t){return n(t)&&n(t.text)&&!1===t.isComment}function ae(t,e){if(t){for(var n=Object.create(null),r=rt?Reflect.ownKeys(t):Object.keys(t),o=0;o<r.length;o++){var i=r[o];if("__ob__"!==i){for(var a=t[i].from,s=e;s;){if(s._provided&&m(s._provided,a)){n[i]=s._provided[a];break}s=s.$parent}if(!s&&"default"in t[i]){var c=t[i].default;n[i]="function"==typeof c?c.call(e):c}}}return n}}function se(t,e){if(!t||!t.length)return{};for(var n={},r=0,o=t.length;r<o;r++){var i=t[r],a=i.data;if(a&&a.attrs&&a.attrs.slot&&delete a.attrs.slot,i.context!==e&&i.fnContext!==e||!a||null==a.slot)(n.default||(n.default=[])).push(i);else{var s=a.slot,c=n[s]||(n[s]=[]);"template"===i.tag?c.push.apply(c,i.children||[]):c.push(i)}}for(var u in n)n[u].every(ce)&&delete n[u];return n}function ce(t){return t.isComment&&!t.asyncFactory||" "===t.text}function ue(e,n,r){var o,i=Object.keys(n).length>0,a=e?!!e.$stable:!i,s=e&&e.$key;if(e){if(e._normalized)return e._normalized;if(a&&r&&r!==t&&s===r.$key&&!i&&!r.$hasNormal)return r;for(var c in o={},e)e[c]&&"$"!==c[0]&&(o[c]=le(n,c,e[c]))}else o={};for(var u in n)u in o||(o[u]=fe(n,u));return e&&Object.isExtensible(e)&&(e._normalized=o),M(o,"$stable",a),M(o,"$key",s),M(o,"$hasNormal",i),o}function le(t,e,n){var r=function(){var t=arguments.length?n.apply(null,arguments):n({});return(t=t&&"object"==typeof t&&!Array.isArray(t)?[t]:oe(t))&&(0===t.length||1===t.length&&t[0].isComment)?void 0:t};return n.proxy&&Object.defineProperty(t,e,{get:r,enumerable:!0,configurable:!0}),r}function fe(t,e){return function(){return t[e]}}function pe(t,e){var r,o,a,s,c;if(Array.isArray(t)||"string"==typeof t)for(r=new Array(t.length),o=0,a=t.length;o<a;o++)r[o]=e(t[o],o);else if("number"==typeof t)for(r=new Array(t),o=0;o<t;o++)r[o]=e(o+1,o);else if(i(t))if(rt&&t[Symbol.iterator]){r=[];for(var u=t[Symbol.iterator](),l=u.next();!l.done;)r.push(e(l.value,r.length)),l=u.next()}else for(s=Object.keys(t),r=new Array(s.length),o=0,a=s.length;o<a;o++)c=s[o],r[o]=e(t[c],c,o);return n(r)||(r=[]),r._isVList=!0,r}function de(t,e,n,r){var o,i=this.$scopedSlots[t];i?(n=n||{},r&&(n=x(x({},r),n)),o=i(n)||e):o=this.$slots[t]||e;var a=n&&n.slot;return a?this.$createElement("template",{slot:a},o):o}function ve(t){return It(this.$options,"filters",t)||E}function he(t,e){return Array.isArray(t)?-1===t.indexOf(e):t!==e}function me(t,e,n,r,o){var i=L.keyCodes[e]||n;return o&&r&&!L.keyCodes[e]?he(o,r):i?he(i,t):r?$(r)!==e:void 0}function ye(t,e,n,r,o){if(n)if(i(n)){var a;Array.isArray(n)&&(n=O(n));var s=function(i){if("class"===i||"style"===i||d(i))a=t;else{var s=t.attrs&&t.attrs.type;a=r||L.mustUseProp(e,s,i)?t.domProps||(t.domProps={}):t.attrs||(t.attrs={})}var c=_(i),u=$(i);c in a||u in a||(a[i]=n[i],o&&((t.on||(t.on={}))["update:"+i]=function(t){n[i]=t}))};for(var c in n)s(c)}else;return t}function ge(t,e){var n=this._staticTrees||(this._staticTrees=[]),r=n[t];return r&&!e?r:(be(r=n[t]=this.$options.staticRenderFns[t].call(this._renderProxy,null,this),"__static__"+t,!1),r)}function _e(t,e,n){return be(t,"__once__"+e+(n?"_"+n:""),!0),t}function be(t,e,n){if(Array.isArray(t))for(var r=0;r<t.length;r++)t[r]&&"string"!=typeof t[r]&&Ce(t[r],e+"_"+r,n);else Ce(t,e,n)}function Ce(t,e,n){t.isStatic=!0,t.key=e,t.isOnce=n}function $e(t,e){if(e)if(s(e)){var n=t.on=t.on?x({},t.on):{};for(var r in e){var o=n[r],i=e[r];n[r]=o?[].concat(o,i):i}}else;return t}function we(t,e,n,r){e=e||{$stable:!n};for(var o=0;o<t.length;o++){var i=t[o];Array.isArray(i)?we(i,e,n):i&&(i.proxy&&(i.fn.proxy=!0),e[i.key]=i.fn)}return r&&(e.$key=r),e}function Ae(t,e){for(var n=0;n<e.length;n+=2){var r=e[n];"string"==typeof r&&r&&(t[e[n]]=e[n+1])}return t}function xe(t,e){return"string"==typeof t?e+t:t}function Oe(t){t._o=_e,t._n=f,t._s=l,t._l=pe,t._t=de,t._q=j,t._i=T,t._m=ge,t._f=ve,t._k=me,t._b=ye,t._v=dt,t._e=pt,t._u=we,t._g=$e,t._d=Ae,t._p=xe}function ke(e,n,o,i,a){var s,c=this,u=a.options;m(i,"_uid")?(s=Object.create(i))._original=i:(s=i,i=i._original);var l=r(u._compiled),f=!l;this.data=e,this.props=n,this.children=o,this.parent=i,this.listeners=e.on||t,this.injections=ae(u.inject,i),this.slots=function(){return c.$slots||ue(e.scopedSlots,c.$slots=se(o,i)),c.$slots},Object.defineProperty(this,"scopedSlots",{enumerable:!0,get:function(){return ue(e.scopedSlots,this.slots())}}),l&&(this.$options=u,this.$slots=this.slots(),this.$scopedSlots=ue(e.scopedSlots,this.$slots)),u._scopeId?this._c=function(t,e,n,r){var o=Le(s,t,e,n,r,f);return o&&!Array.isArray(o)&&(o.fnScopeId=u._scopeId,o.fnContext=i),o}:this._c=function(t,e,n,r){return Le(s,t,e,n,r,f)}}function Se(t,e,n,r,o){var i=vt(t);return i.fnContext=n,i.fnOptions=r,e.slot&&((i.data||(i.data={})).slot=e.slot),i}function Ee(t,e){for(var n in e)t[_(n)]=e[n]}Oe(ke.prototype);var je={init:function(t,e){if(t.componentInstance&&!t.componentInstance._isDestroyed&&t.data.keepAlive){var r=t;je.prepatch(r,r)}else{(t.componentInstance=function(t,e){var r={_isComponent:!0,_parentVnode:t,parent:e},o=t.data.inlineTemplate;n(o)&&(r.render=o.render,r.staticRenderFns=o.staticRenderFns);return new t.componentOptions.Ctor(r)}(t,qe)).$mount(e?t.elm:void 0,e)}},prepatch:function(e,n){var r=n.componentOptions;!function(e,n,r,o,i){var a=o.data.scopedSlots,s=e.$scopedSlots,c=!!(a&&!a.$stable||s!==t&&!s.$stable||a&&e.$scopedSlots.$key!==a.$key),u=!!(i||e.$options._renderChildren||c);e.$options._parentVnode=o,e.$vnode=o,e._vnode&&(e._vnode.parent=o);if(e.$options._renderChildren=i,e.$attrs=o.data.attrs||t,e.$listeners=r||t,n&&e.$options.props){_t(!1);for(var l=e._props,f=e.$options._propKeys||[],p=0;p<f.length;p++){var d=f[p],v=e.$options.props;l[d]=Dt(d,v,n,e)}_t(!0),e.$options.propsData=n}r=r||t;var h=e.$options._parentListeners;e.$options._parentListeners=r,We(e,r,h),u&&(e.$slots=se(i,o.context),e.$forceUpdate())}(n.componentInstance=e.componentInstance,r.propsData,r.listeners,n,r.children)},insert:function(t){var e,n=t.context,r=t.componentInstance;r._isMounted||(r._isMounted=!0,Ze(r,"mounted")),t.data.keepAlive&&(n._isMounted?((e=r)._inactive=!1,Qe.push(e)):Ge(r,!0))},destroy:function(t){var e=t.componentInstance;e._isDestroyed||(t.data.keepAlive?function t(e,n){if(n&&(e._directInactive=!0,Xe(e)))return;if(!e._inactive){e._inactive=!0;for(var r=0;r<e.$children.length;r++)t(e.$children[r]);Ze(e,"deactivated")}}(e,!0):e.$destroy())}},Te=Object.keys(je);function Ie(o,a,s,c,l){if(!e(o)){var f=s.$options._base;if(i(o)&&(o=f.extend(o)),"function"==typeof o){var p;if(e(o.cid)&&void 0===(o=function(t,o){if(r(t.error)&&n(t.errorComp))return t.errorComp;if(n(t.resolved))return t.resolved;var a=Fe;a&&n(t.owners)&&-1===t.owners.indexOf(a)&&t.owners.push(a);if(r(t.loading)&&n(t.loadingComp))return t.loadingComp;if(a&&!n(t.owners)){var s=t.owners=[a],c=!0,l=null,f=null;a.$on("hook:destroyed",function(){return v(s,a)});var p=function(t){for(var e=0,n=s.length;e<n;e++)s[e].$forceUpdate();t&&(s.length=0,null!==l&&(clearTimeout(l),l=null),null!==f&&(clearTimeout(f),f=null))},d=I(function(e){t.resolved=Re(e,o),c?s.length=0:p(!0)}),h=I(function(e){n(t.errorComp)&&(t.error=!0,p(!0))}),m=t(d,h);return i(m)&&(u(m)?e(t.resolved)&&m.then(d,h):u(m.component)&&(m.component.then(d,h),n(m.error)&&(t.errorComp=Re(m.error,o)),n(m.loading)&&(t.loadingComp=Re(m.loading,o),0===m.delay?t.loading=!0:l=setTimeout(function(){l=null,e(t.resolved)&&e(t.error)&&(t.loading=!0,p(!1))},m.delay||200)),n(m.timeout)&&(f=setTimeout(function(){f=null,e(t.resolved)&&h(null)},m.timeout)))),c=!1,t.loading?t.loadingComp:t.resolved}}(p=o,f)))return function(t,e,n,r,o){var i=pt();return i.asyncFactory=t,i.asyncMeta={data:e,context:n,children:r,tag:o},i}(p,a,s,c,l);a=a||{},_n(o),n(a.model)&&function(t,e){var r=t.model&&t.model.prop||"value",o=t.model&&t.model.event||"input";(e.attrs||(e.attrs={}))[r]=e.model.value;var i=e.on||(e.on={}),a=i[o],s=e.model.callback;n(a)?(Array.isArray(a)?-1===a.indexOf(s):a!==s)&&(i[o]=[s].concat(a)):i[o]=s}(o.options,a);var d=function(t,r,o){var i=r.options.props;if(!e(i)){var a={},s=t.attrs,c=t.props;if(n(s)||n(c))for(var u in i){var l=$(u);re(a,c,u,l,!0)||re(a,s,u,l,!1)}return a}}(a,o);if(r(o.options.functional))return function(e,r,o,i,a){var s=e.options,c={},u=s.props;if(n(u))for(var l in u)c[l]=Dt(l,u,r||t);else n(o.attrs)&&Ee(c,o.attrs),n(o.props)&&Ee(c,o.props);var f=new ke(o,c,a,i,e),p=s.render.call(null,f._c,f);if(p instanceof lt)return Se(p,o,f.parent,s);if(Array.isArray(p)){for(var d=oe(p)||[],v=new Array(d.length),h=0;h<d.length;h++)v[h]=Se(d[h],o,f.parent,s);return v}}(o,d,a,s,c);var h=a.on;if(a.on=a.nativeOn,r(o.options.abstract)){var m=a.slot;a={},m&&(a.slot=m)}!function(t){for(var e=t.hook||(t.hook={}),n=0;n<Te.length;n++){var r=Te[n],o=e[r],i=je[r];o===i||o&&o._merged||(e[r]=o?De(i,o):i)}}(a);var y=o.options.name||l;return new lt("vue-component-"+o.cid+(y?"-"+y:""),a,void 0,void 0,void 0,s,{Ctor:o,propsData:d,listeners:h,tag:l,children:c},p)}}}function De(t,e){var n=function(n,r){t(n,r),e(n,r)};return n._merged=!0,n}var Ne=1,Pe=2;function Le(t,a,s,c,u,l){return(Array.isArray(s)||o(s))&&(u=c,c=s,s=void 0),r(l)&&(u=Pe),function(t,o,a,s,c){if(n(a)&&n(a.__ob__))return pt();n(a)&&n(a.is)&&(o=a.is);if(!o)return pt();Array.isArray(s)&&"function"==typeof s[0]&&((a=a||{}).scopedSlots={default:s[0]},s.length=0);c===Pe?s=oe(s):c===Ne&&(s=function(t){for(var e=0;e<t.length;e++)if(Array.isArray(t[e]))return Array.prototype.concat.apply([],t);return t}(s));var u,l;if("string"==typeof o){var f;l=t.$vnode&&t.$vnode.ns||L.getTagNamespace(o),u=L.isReservedTag(o)?new lt(L.parsePlatformTagName(o),a,s,void 0,void 0,t):a&&a.pre||!n(f=It(t.$options,"components",o))?new lt(o,a,s,void 0,void 0,t):Ie(f,a,t,s,o)}else u=Ie(o,a,t,s);return Array.isArray(u)?u:n(u)?(n(l)&&function t(o,i,a){o.ns=i;"foreignObject"===o.tag&&(i=void 0,a=!0);if(n(o.children))for(var s=0,c=o.children.length;s<c;s++){var u=o.children[s];n(u.tag)&&(e(u.ns)||r(a)&&"svg"!==u.tag)&&t(u,i,a)}}(u,l),n(a)&&function(t){i(t.style)&&Qt(t.style);i(t.class)&&Qt(t.class)}(a),u):pt()}(t,a,s,c,u)}var Me,Fe=null;function Re(t,e){return(t.__esModule||rt&&"Module"===t[Symbol.toStringTag])&&(t=t.default),i(t)?e.extend(t):t}function Ue(t){return t.isComment&&t.asyncFactory}function He(t){if(Array.isArray(t))for(var e=0;e<t.length;e++){var r=t[e];if(n(r)&&(n(r.componentOptions)||Ue(r)))return r}}function Be(t,e){Me.$on(t,e)}function Ve(t,e){Me.$off(t,e)}function ze(t,e){var n=Me;return function r(){null!==e.apply(null,arguments)&&n.$off(t,r)}}function We(t,e,n){Me=t,ee(e,n||{},Be,Ve,ze,t),Me=void 0}var qe=null;function Ke(t){var e=qe;return qe=t,function(){qe=e}}function Xe(t){for(;t&&(t=t.$parent);)if(t._inactive)return!0;return!1}function Ge(t,e){if(e){if(t._directInactive=!1,Xe(t))return}else if(t._directInactive)return;if(t._inactive||null===t._inactive){t._inactive=!1;for(var n=0;n<t.$children.length;n++)Ge(t.$children[n]);Ze(t,"activated")}}function Ze(t,e){ct();var n=t.$options[e],r=e+" hook";if(n)for(var o=0,i=n.length;o<i;o++)Ft(n[o],t,null,t,r);t._hasHookEvent&&t.$emit("hook:"+e),ut()}var Je=[],Qe=[],Ye={},tn=!1,en=!1,nn=0;var rn=0,on=Date.now;if(H&&!W){var an=window.performance;an&&"function"==typeof an.now&&on()>document.createEvent("Event").timeStamp&&(on=function(){return an.now()})}function sn(){var t,e;for(rn=on(),en=!0,Je.sort(function(t,e){return t.id-e.id}),nn=0;nn<Je.length;nn++)(t=Je[nn]).before&&t.before(),e=t.id,Ye[e]=null,t.run();var n=Qe.slice(),r=Je.slice();nn=Je.length=Qe.length=0,Ye={},tn=en=!1,function(t){for(var e=0;e<t.length;e++)t[e]._inactive=!0,Ge(t[e],!0)}(n),function(t){var e=t.length;for(;e--;){var n=t[e],r=n.vm;r._watcher===n&&r._isMounted&&!r._isDestroyed&&Ze(r,"updated")}}(r),tt&&L.devtools&&tt.emit("flush")}var cn=0,un=function(t,e,n,r,o){this.vm=t,o&&(t._watcher=this),t._watchers.push(this),r?(this.deep=!!r.deep,this.user=!!r.user,this.lazy=!!r.lazy,this.sync=!!r.sync,this.before=r.before):this.deep=this.user=this.lazy=this.sync=!1,this.cb=n,this.id=++cn,this.active=!0,this.dirty=this.lazy,this.deps=[],this.newDeps=[],this.depIds=new nt,this.newDepIds=new nt,this.expression="","function"==typeof e?this.getter=e:(this.getter=function(t){if(!F.test(t)){var e=t.split(".");return function(t){for(var n=0;n<e.length;n++){if(!t)return;t=t[e[n]]}return t}}}(e),this.getter||(this.getter=k)),this.value=this.lazy?void 0:this.get()};un.prototype.get=function(){var t;ct(this);var e=this.vm;try{t=this.getter.call(e,e)}catch(t){if(!this.user)throw t;Mt(t,e,'getter for watcher "'+this.expression+'"')}finally{this.deep&&Qt(t),ut(),this.cleanupDeps()}return t},un.prototype.addDep=function(t){var e=t.id;this.newDepIds.has(e)||(this.newDepIds.add(e),this.newDeps.push(t),this.depIds.has(e)||t.addSub(this))},un.prototype.cleanupDeps=function(){for(var t=this.deps.length;t--;){var e=this.deps[t];this.newDepIds.has(e.id)||e.removeSub(this)}var n=this.depIds;this.depIds=this.newDepIds,this.newDepIds=n,this.newDepIds.clear(),n=this.deps,this.deps=this.newDeps,this.newDeps=n,this.newDeps.length=0},un.prototype.update=function(){this.lazy?this.dirty=!0:this.sync?this.run():function(t){var e=t.id;if(null==Ye[e]){if(Ye[e]=!0,en){for(var n=Je.length-1;n>nn&&Je[n].id>t.id;)n--;Je.splice(n+1,0,t)}else Je.push(t);tn||(tn=!0,Zt(sn))}}(this)},un.prototype.run=function(){if(this.active){var t=this.get();if(t!==this.value||i(t)||this.deep){var e=this.value;if(this.value=t,this.user)try{this.cb.call(this.vm,t,e)}catch(t){Mt(t,this.vm,'callback for watcher "'+this.expression+'"')}else this.cb.call(this.vm,t,e)}}},un.prototype.evaluate=function(){this.value=this.get(),this.dirty=!1},un.prototype.depend=function(){for(var t=this.deps.length;t--;)this.deps[t].depend()},un.prototype.teardown=function(){if(this.active){this.vm._isBeingDestroyed||v(this.vm._watchers,this);for(var t=this.deps.length;t--;)this.deps[t].removeSub(this);this.active=!1}};var ln={enumerable:!0,configurable:!0,get:k,set:k};function fn(t,e,n){ln.get=function(){return this[e][n]},ln.set=function(t){this[e][n]=t},Object.defineProperty(t,n,ln)}function pn(t){t._watchers=[];var e=t.$options;e.props&&function(t,e){var n=t.$options.propsData||{},r=t._props={},o=t.$options._propKeys=[];t.$parent&&_t(!1);var i=function(i){o.push(i);var a=Dt(i,e,n,t);$t(r,i,a),i in t||fn(t,"_props",i)};for(var a in e)i(a);_t(!0)}(t,e.props),e.methods&&function(t,e){t.$options.props;for(var n in e)t[n]="function"!=typeof e[n]?k:w(e[n],t)}(t,e.methods),e.data?function(t){var e=t.$options.data;s(e=t._data="function"==typeof e?function(t,e){ct();try{return t.call(e,e)}catch(t){return Mt(t,e,"data()"),{}}finally{ut()}}(e,t):e||{})||(e={});var n=Object.keys(e),r=t.$options.props,o=(t.$options.methods,n.length);for(;o--;){var i=n[o];r&&m(r,i)||(a=void 0,36!==(a=(i+"").charCodeAt(0))&&95!==a&&fn(t,"_data",i))}var a;Ct(e,!0)}(t):Ct(t._data={},!0),e.computed&&function(t,e){var n=t._computedWatchers=Object.create(null),r=Y();for(var o in e){var i=e[o],a="function"==typeof i?i:i.get;r||(n[o]=new un(t,a||k,k,dn)),o in t||vn(t,o,i)}}(t,e.computed),e.watch&&e.watch!==Z&&function(t,e){for(var n in e){var r=e[n];if(Array.isArray(r))for(var o=0;o<r.length;o++)yn(t,n,r[o]);else yn(t,n,r)}}(t,e.watch)}var dn={lazy:!0};function vn(t,e,n){var r=!Y();"function"==typeof n?(ln.get=r?hn(e):mn(n),ln.set=k):(ln.get=n.get?r&&!1!==n.cache?hn(e):mn(n.get):k,ln.set=n.set||k),Object.defineProperty(t,e,ln)}function hn(t){return function(){var e=this._computedWatchers&&this._computedWatchers[t];if(e)return e.dirty&&e.evaluate(),at.target&&e.depend(),e.value}}function mn(t){return function(){return t.call(this,this)}}function yn(t,e,n,r){return s(n)&&(r=n,n=n.handler),"string"==typeof n&&(n=t[n]),t.$watch(e,n,r)}var gn=0;function _n(t){var e=t.options;if(t.super){var n=_n(t.super);if(n!==t.superOptions){t.superOptions=n;var r=function(t){var e,n=t.options,r=t.sealedOptions;for(var o in n)n[o]!==r[o]&&(e||(e={}),e[o]=n[o]);return e}(t);r&&x(t.extendOptions,r),(e=t.options=Tt(n,t.extendOptions)).name&&(e.components[e.name]=t)}}return e}function bn(t){this._init(t)}function Cn(t){t.cid=0;var e=1;t.extend=function(t){t=t||{};var n=this,r=n.cid,o=t._Ctor||(t._Ctor={});if(o[r])return o[r];var i=t.name||n.options.name,a=function(t){this._init(t)};return(a.prototype=Object.create(n.prototype)).constructor=a,a.cid=e++,a.options=Tt(n.options,t),a.super=n,a.options.props&&function(t){var e=t.options.props;for(var n in e)fn(t.prototype,"_props",n)}(a),a.options.computed&&function(t){var e=t.options.computed;for(var n in e)vn(t.prototype,n,e[n])}(a),a.extend=n.extend,a.mixin=n.mixin,a.use=n.use,N.forEach(function(t){a[t]=n[t]}),i&&(a.options.components[i]=a),a.superOptions=n.options,a.extendOptions=t,a.sealedOptions=x({},a.options),o[r]=a,a}}function $n(t){return t&&(t.Ctor.options.name||t.tag)}function wn(t,e){return Array.isArray(t)?t.indexOf(e)>-1:"string"==typeof t?t.split(",").indexOf(e)>-1:(n=t,"[object RegExp]"===a.call(n)&&t.test(e));var n}function An(t,e){var n=t.cache,r=t.keys,o=t._vnode;for(var i in n){var a=n[i];if(a){var s=$n(a.componentOptions);s&&!e(s)&&xn(n,i,r,o)}}}function xn(t,e,n,r){var o=t[e];!o||r&&o.tag===r.tag||o.componentInstance.$destroy(),t[e]=null,v(n,e)}!function(e){e.prototype._init=function(e){var n=this;n._uid=gn++,n._isVue=!0,e&&e._isComponent?function(t,e){var n=t.$options=Object.create(t.constructor.options),r=e._parentVnode;n.parent=e.parent,n._parentVnode=r;var o=r.componentOptions;n.propsData=o.propsData,n._parentListeners=o.listeners,n._renderChildren=o.children,n._componentTag=o.tag,e.render&&(n.render=e.render,n.staticRenderFns=e.staticRenderFns)}(n,e):n.$options=Tt(_n(n.constructor),e||{},n),n._renderProxy=n,n._self=n,function(t){var e=t.$options,n=e.parent;if(n&&!e.abstract){for(;n.$options.abstract&&n.$parent;)n=n.$parent;n.$children.push(t)}t.$parent=n,t.$root=n?n.$root:t,t.$children=[],t.$refs={},t._watcher=null,t._inactive=null,t._directInactive=!1,t._isMounted=!1,t._isDestroyed=!1,t._isBeingDestroyed=!1}(n),function(t){t._events=Object.create(null),t._hasHookEvent=!1;var e=t.$options._parentListeners;e&&We(t,e)}(n),function(e){e._vnode=null,e._staticTrees=null;var n=e.$options,r=e.$vnode=n._parentVnode,o=r&&r.context;e.$slots=se(n._renderChildren,o),e.$scopedSlots=t,e._c=function(t,n,r,o){return Le(e,t,n,r,o,!1)},e.$createElement=function(t,n,r,o){return Le(e,t,n,r,o,!0)};var i=r&&r.data;$t(e,"$attrs",i&&i.attrs||t,null,!0),$t(e,"$listeners",n._parentListeners||t,null,!0)}(n),Ze(n,"beforeCreate"),function(t){var e=ae(t.$options.inject,t);e&&(_t(!1),Object.keys(e).forEach(function(n){$t(t,n,e[n])}),_t(!0))}(n),pn(n),function(t){var e=t.$options.provide;e&&(t._provided="function"==typeof e?e.call(t):e)}(n),Ze(n,"created"),n.$options.el&&n.$mount(n.$options.el)}}(bn),function(t){var e={get:function(){return this._data}},n={get:function(){return this._props}};Object.defineProperty(t.prototype,"$data",e),Object.defineProperty(t.prototype,"$props",n),t.prototype.$set=wt,t.prototype.$delete=At,t.prototype.$watch=function(t,e,n){if(s(e))return yn(this,t,e,n);(n=n||{}).user=!0;var r=new un(this,t,e,n);if(n.immediate)try{e.call(this,r.value)}catch(t){Mt(t,this,'callback for immediate watcher "'+r.expression+'"')}return function(){r.teardown()}}}(bn),function(t){var e=/^hook:/;t.prototype.$on=function(t,n){var r=this;if(Array.isArray(t))for(var o=0,i=t.length;o<i;o++)r.$on(t[o],n);else(r._events[t]||(r._events[t]=[])).push(n),e.test(t)&&(r._hasHookEvent=!0);return r},t.prototype.$once=function(t,e){var n=this;function r(){n.$off(t,r),e.apply(n,arguments)}return r.fn=e,n.$on(t,r),n},t.prototype.$off=function(t,e){var n=this;if(!arguments.length)return n._events=Object.create(null),n;if(Array.isArray(t)){for(var r=0,o=t.length;r<o;r++)n.$off(t[r],e);return n}var i,a=n._events[t];if(!a)return n;if(!e)return n._events[t]=null,n;for(var s=a.length;s--;)if((i=a[s])===e||i.fn===e){a.splice(s,1);break}return n},t.prototype.$emit=function(t){var e=this._events[t];if(e){e=e.length>1?A(e):e;for(var n=A(arguments,1),r='event handler for "'+t+'"',o=0,i=e.length;o<i;o++)Ft(e[o],this,n,this,r)}return this}}(bn),function(t){t.prototype._update=function(t,e){var n=this,r=n.$el,o=n._vnode,i=Ke(n);n._vnode=t,n.$el=o?n.__patch__(o,t):n.__patch__(n.$el,t,e,!1),i(),r&&(r.__vue__=null),n.$el&&(n.$el.__vue__=n),n.$vnode&&n.$parent&&n.$vnode===n.$parent._vnode&&(n.$parent.$el=n.$el)},t.prototype.$forceUpdate=function(){this._watcher&&this._watcher.update()},t.prototype.$destroy=function(){var t=this;if(!t._isBeingDestroyed){Ze(t,"beforeDestroy"),t._isBeingDestroyed=!0;var e=t.$parent;!e||e._isBeingDestroyed||t.$options.abstract||v(e.$children,t),t._watcher&&t._watcher.teardown();for(var n=t._watchers.length;n--;)t._watchers[n].teardown();t._data.__ob__&&t._data.__ob__.vmCount--,t._isDestroyed=!0,t.__patch__(t._vnode,null),Ze(t,"destroyed"),t.$off(),t.$el&&(t.$el.__vue__=null),t.$vnode&&(t.$vnode.parent=null)}}}(bn),function(t){Oe(t.prototype),t.prototype.$nextTick=function(t){return Zt(t,this)},t.prototype._render=function(){var t,e=this,n=e.$options,r=n.render,o=n._parentVnode;o&&(e.$scopedSlots=ue(o.data.scopedSlots,e.$slots,e.$scopedSlots)),e.$vnode=o;try{Fe=e,t=r.call(e._renderProxy,e.$createElement)}catch(n){Mt(n,e,"render"),t=e._vnode}finally{Fe=null}return Array.isArray(t)&&1===t.length&&(t=t[0]),t instanceof lt||(t=pt()),t.parent=o,t}}(bn);var On=[String,RegExp,Array],kn={KeepAlive:{name:"keep-alive",abstract:!0,props:{include:On,exclude:On,max:[String,Number]},created:function(){this.cache=Object.create(null),this.keys=[]},destroyed:function(){for(var t in this.cache)xn(this.cache,t,this.keys)},mounted:function(){var t=this;this.$watch("include",function(e){An(t,function(t){return wn(e,t)})}),this.$watch("exclude",function(e){An(t,function(t){return!wn(e,t)})})},render:function(){var t=this.$slots.default,e=He(t),n=e&&e.componentOptions;if(n){var r=$n(n),o=this.include,i=this.exclude;if(o&&(!r||!wn(o,r))||i&&r&&wn(i,r))return e;var a=this.cache,s=this.keys,c=null==e.key?n.Ctor.cid+(n.tag?"::"+n.tag:""):e.key;a[c]?(e.componentInstance=a[c].componentInstance,v(s,c),s.push(c)):(a[c]=e,s.push(c),this.max&&s.length>parseInt(this.max)&&xn(a,s[0],s,this._vnode)),e.data.keepAlive=!0}return e||t&&t[0]}}};!function(t){var e={get:function(){return L}};Object.defineProperty(t,"config",e),t.util={warn:ot,extend:x,mergeOptions:Tt,defineReactive:$t},t.set=wt,t.delete=At,t.nextTick=Zt,t.observable=function(t){return Ct(t),t},t.options=Object.create(null),N.forEach(function(e){t.options[e+"s"]=Object.create(null)}),t.options._base=t,x(t.options.components,kn),function(t){t.use=function(t){var e=this._installedPlugins||(this._installedPlugins=[]);if(e.indexOf(t)>-1)return this;var n=A(arguments,1);return n.unshift(this),"function"==typeof t.install?t.install.apply(t,n):"function"==typeof t&&t.apply(null,n),e.push(t),this}}(t),function(t){t.mixin=function(t){return this.options=Tt(this.options,t),this}}(t),Cn(t),function(t){N.forEach(function(e){t[e]=function(t,n){return n?("component"===e&&s(n)&&(n.name=n.name||t,n=this.options._base.extend(n)),"directive"===e&&"function"==typeof n&&(n={bind:n,update:n}),this.options[e+"s"][t]=n,n):this.options[e+"s"][t]}})}(t)}(bn),Object.defineProperty(bn.prototype,"$isServer",{get:Y}),Object.defineProperty(bn.prototype,"$ssrContext",{get:function(){return this.$vnode&&this.$vnode.ssrContext}}),Object.defineProperty(bn,"FunctionalRenderContext",{value:ke}),bn.version="2.6.11";var Sn=p("style,class"),En=p("input,textarea,option,select,progress"),jn=p("contenteditable,draggable,spellcheck"),Tn=p("events,caret,typing,plaintext-only"),In=function(t,e){return Mn(e)||"false"===e?"false":"contenteditable"===t&&Tn(e)?e:"true"},Dn=p("allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,default,defaultchecked,defaultmuted,defaultselected,defer,disabled,enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,required,reversed,scoped,seamless,selected,sortable,translate,truespeed,typemustmatch,visible"),Nn="http://www.w3.org/1999/xlink",Pn=function(t){return":"===t.charAt(5)&&"xlink"===t.slice(0,5)},Ln=function(t){return Pn(t)?t.slice(6,t.length):""},Mn=function(t){return null==t||!1===t};function Fn(t){for(var e=t.data,r=t,o=t;n(o.componentInstance);)(o=o.componentInstance._vnode)&&o.data&&(e=Rn(o.data,e));for(;n(r=r.parent);)r&&r.data&&(e=Rn(e,r.data));return function(t,e){if(n(t)||n(e))return Un(t,Hn(e));return""}(e.staticClass,e.class)}function Rn(t,e){return{staticClass:Un(t.staticClass,e.staticClass),class:n(t.class)?[t.class,e.class]:e.class}}function Un(t,e){return t?e?t+" "+e:t:e||""}function Hn(t){return Array.isArray(t)?function(t){for(var e,r="",o=0,i=t.length;o<i;o++)n(e=Hn(t[o]))&&""!==e&&(r&&(r+=" "),r+=e);return r}(t):i(t)?function(t){var e="";for(var n in t)t[n]&&(e&&(e+=" "),e+=n);return e}(t):"string"==typeof t?t:""}var Bn={svg:"http://www.w3.org/2000/svg",math:"http://www.w3.org/1998/Math/MathML"},Vn=p("html,body,base,head,link,meta,style,title,address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,menuitem,summary,content,element,shadow,template,blockquote,iframe,tfoot"),zn=p("svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view",!0),Wn=function(t){return Vn(t)||zn(t)};var qn=Object.create(null);var Kn=p("text,number,password,search,email,tel,url");var Xn=Object.freeze({createElement:function(t,e){var n=document.createElement(t);return"select"!==t?n:(e.data&&e.data.attrs&&void 0!==e.data.attrs.multiple&&n.setAttribute("multiple","multiple"),n)},createElementNS:function(t,e){return document.createElementNS(Bn[t],e)},createTextNode:function(t){return document.createTextNode(t)},createComment:function(t){return document.createComment(t)},insertBefore:function(t,e,n){t.insertBefore(e,n)},removeChild:function(t,e){t.removeChild(e)},appendChild:function(t,e){t.appendChild(e)},parentNode:function(t){return t.parentNode},nextSibling:function(t){return t.nextSibling},tagName:function(t){return t.tagName},setTextContent:function(t,e){t.textContent=e},setStyleScope:function(t,e){t.setAttribute(e,"")}}),Gn={create:function(t,e){Zn(e)},update:function(t,e){t.data.ref!==e.data.ref&&(Zn(t,!0),Zn(e))},destroy:function(t){Zn(t,!0)}};function Zn(t,e){var r=t.data.ref;if(n(r)){var o=t.context,i=t.componentInstance||t.elm,a=o.$refs;e?Array.isArray(a[r])?v(a[r],i):a[r]===i&&(a[r]=void 0):t.data.refInFor?Array.isArray(a[r])?a[r].indexOf(i)<0&&a[r].push(i):a[r]=[i]:a[r]=i}}var Jn=new lt("",{},[]),Qn=["create","activate","update","remove","destroy"];function Yn(t,o){return t.key===o.key&&(t.tag===o.tag&&t.isComment===o.isComment&&n(t.data)===n(o.data)&&function(t,e){if("input"!==t.tag)return!0;var r,o=n(r=t.data)&&n(r=r.attrs)&&r.type,i=n(r=e.data)&&n(r=r.attrs)&&r.type;return o===i||Kn(o)&&Kn(i)}(t,o)||r(t.isAsyncPlaceholder)&&t.asyncFactory===o.asyncFactory&&e(o.asyncFactory.error))}function tr(t,e,r){var o,i,a={};for(o=e;o<=r;++o)n(i=t[o].key)&&(a[i]=o);return a}var er={create:nr,update:nr,destroy:function(t){nr(t,Jn)}};function nr(t,e){(t.data.directives||e.data.directives)&&function(t,e){var n,r,o,i=t===Jn,a=e===Jn,s=or(t.data.directives,t.context),c=or(e.data.directives,e.context),u=[],l=[];for(n in c)r=s[n],o=c[n],r?(o.oldValue=r.value,o.oldArg=r.arg,ar(o,"update",e,t),o.def&&o.def.componentUpdated&&l.push(o)):(ar(o,"bind",e,t),o.def&&o.def.inserted&&u.push(o));if(u.length){var f=function(){for(var n=0;n<u.length;n++)ar(u[n],"inserted",e,t)};i?ne(e,"insert",f):f()}l.length&&ne(e,"postpatch",function(){for(var n=0;n<l.length;n++)ar(l[n],"componentUpdated",e,t)});if(!i)for(n in s)c[n]||ar(s[n],"unbind",t,t,a)}(t,e)}var rr=Object.create(null);function or(t,e){var n,r,o=Object.create(null);if(!t)return o;for(n=0;n<t.length;n++)(r=t[n]).modifiers||(r.modifiers=rr),o[ir(r)]=r,r.def=It(e.$options,"directives",r.name);return o}function ir(t){return t.rawName||t.name+"."+Object.keys(t.modifiers||{}).join(".")}function ar(t,e,n,r,o){var i=t.def&&t.def[e];if(i)try{i(n.elm,t,n,r,o)}catch(r){Mt(r,n.context,"directive "+t.name+" "+e+" hook")}}var sr=[Gn,er];function cr(t,r){var o=r.componentOptions;if(!(n(o)&&!1===o.Ctor.options.inheritAttrs||e(t.data.attrs)&&e(r.data.attrs))){var i,a,s=r.elm,c=t.data.attrs||{},u=r.data.attrs||{};for(i in n(u.__ob__)&&(u=r.data.attrs=x({},u)),u)a=u[i],c[i]!==a&&ur(s,i,a);for(i in(W||K)&&u.value!==c.value&&ur(s,"value",u.value),c)e(u[i])&&(Pn(i)?s.removeAttributeNS(Nn,Ln(i)):jn(i)||s.removeAttribute(i))}}function ur(t,e,n){t.tagName.indexOf("-")>-1?lr(t,e,n):Dn(e)?Mn(n)?t.removeAttribute(e):(n="allowfullscreen"===e&&"EMBED"===t.tagName?"true":e,t.setAttribute(e,n)):jn(e)?t.setAttribute(e,In(e,n)):Pn(e)?Mn(n)?t.removeAttributeNS(Nn,Ln(e)):t.setAttributeNS(Nn,e,n):lr(t,e,n)}function lr(t,e,n){if(Mn(n))t.removeAttribute(e);else{if(W&&!q&&"TEXTAREA"===t.tagName&&"placeholder"===e&&""!==n&&!t.__ieph){var r=function(e){e.stopImmediatePropagation(),t.removeEventListener("input",r)};t.addEventListener("input",r),t.__ieph=!0}t.setAttribute(e,n)}}var fr={create:cr,update:cr};function pr(t,r){var o=r.elm,i=r.data,a=t.data;if(!(e(i.staticClass)&&e(i.class)&&(e(a)||e(a.staticClass)&&e(a.class)))){var s=Fn(r),c=o._transitionClasses;n(c)&&(s=Un(s,Hn(c))),s!==o._prevClass&&(o.setAttribute("class",s),o._prevClass=s)}}var dr,vr={create:pr,update:pr},hr="__r",mr="__c";function yr(t,e,n){var r=dr;return function o(){null!==e.apply(null,arguments)&&br(t,o,n,r)}}var gr=Bt&&!(G&&Number(G[1])<=53);function _r(t,e,n,r){if(gr){var o=rn,i=e;e=i._wrapper=function(t){if(t.target===t.currentTarget||t.timeStamp>=o||t.timeStamp<=0||t.target.ownerDocument!==document)return i.apply(this,arguments)}}dr.addEventListener(t,e,J?{capture:n,passive:r}:n)}function br(t,e,n,r){(r||dr).removeEventListener(t,e._wrapper||e,n)}function Cr(t,r){if(!e(t.data.on)||!e(r.data.on)){var o=r.data.on||{},i=t.data.on||{};dr=r.elm,function(t){if(n(t[hr])){var e=W?"change":"input";t[e]=[].concat(t[hr],t[e]||[]),delete t[hr]}n(t[mr])&&(t.change=[].concat(t[mr],t.change||[]),delete t[mr])}(o),ee(o,i,_r,br,yr,r.context),dr=void 0}}var $r,wr={create:Cr,update:Cr};function Ar(t,r){if(!e(t.data.domProps)||!e(r.data.domProps)){var o,i,a=r.elm,s=t.data.domProps||{},c=r.data.domProps||{};for(o in n(c.__ob__)&&(c=r.data.domProps=x({},c)),s)o in c||(a[o]="");for(o in c){if(i=c[o],"textContent"===o||"innerHTML"===o){if(r.children&&(r.children.length=0),i===s[o])continue;1===a.childNodes.length&&a.removeChild(a.childNodes[0])}if("value"===o&&"PROGRESS"!==a.tagName){a._value=i;var u=e(i)?"":String(i);xr(a,u)&&(a.value=u)}else if("innerHTML"===o&&zn(a.tagName)&&e(a.innerHTML)){($r=$r||document.createElement("div")).innerHTML="<svg>"+i+"</svg>";for(var l=$r.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;l.firstChild;)a.appendChild(l.firstChild)}else if(i!==s[o])try{a[o]=i}catch(t){}}}}function xr(t,e){return!t.composing&&("OPTION"===t.tagName||function(t,e){var n=!0;try{n=document.activeElement!==t}catch(t){}return n&&t.value!==e}(t,e)||function(t,e){var r=t.value,o=t._vModifiers;if(n(o)){if(o.number)return f(r)!==f(e);if(o.trim)return r.trim()!==e.trim()}return r!==e}(t,e))}var Or={create:Ar,update:Ar},kr=y(function(t){var e={},n=/:(.+)/;return t.split(/;(?![^(]*\))/g).forEach(function(t){if(t){var r=t.split(n);r.length>1&&(e[r[0].trim()]=r[1].trim())}}),e});function Sr(t){var e=Er(t.style);return t.staticStyle?x(t.staticStyle,e):e}function Er(t){return Array.isArray(t)?O(t):"string"==typeof t?kr(t):t}var jr,Tr=/^--/,Ir=/\s*!important$/,Dr=function(t,e,n){if(Tr.test(e))t.style.setProperty(e,n);else if(Ir.test(n))t.style.setProperty($(e),n.replace(Ir,""),"important");else{var r=Pr(e);if(Array.isArray(n))for(var o=0,i=n.length;o<i;o++)t.style[r]=n[o];else t.style[r]=n}},Nr=["Webkit","Moz","ms"],Pr=y(function(t){if(jr=jr||document.createElement("div").style,"filter"!==(t=_(t))&&t in jr)return t;for(var e=t.charAt(0).toUpperCase()+t.slice(1),n=0;n<Nr.length;n++){var r=Nr[n]+e;if(r in jr)return r}});function Lr(t,r){var o=r.data,i=t.data;if(!(e(o.staticStyle)&&e(o.style)&&e(i.staticStyle)&&e(i.style))){var a,s,c=r.elm,u=i.staticStyle,l=i.normalizedStyle||i.style||{},f=u||l,p=Er(r.data.style)||{};r.data.normalizedStyle=n(p.__ob__)?x({},p):p;var d=function(t,e){var n,r={};if(e)for(var o=t;o.componentInstance;)(o=o.componentInstance._vnode)&&o.data&&(n=Sr(o.data))&&x(r,n);(n=Sr(t.data))&&x(r,n);for(var i=t;i=i.parent;)i.data&&(n=Sr(i.data))&&x(r,n);return r}(r,!0);for(s in f)e(d[s])&&Dr(c,s,"");for(s in d)(a=d[s])!==f[s]&&Dr(c,s,null==a?"":a)}}var Mr={create:Lr,update:Lr},Fr=/\s+/;function Rr(t,e){if(e&&(e=e.trim()))if(t.classList)e.indexOf(" ")>-1?e.split(Fr).forEach(function(e){return t.classList.add(e)}):t.classList.add(e);else{var n=" "+(t.getAttribute("class")||"")+" ";n.indexOf(" "+e+" ")<0&&t.setAttribute("class",(n+e).trim())}}function Ur(t,e){if(e&&(e=e.trim()))if(t.classList)e.indexOf(" ")>-1?e.split(Fr).forEach(function(e){return t.classList.remove(e)}):t.classList.remove(e),t.classList.length||t.removeAttribute("class");else{for(var n=" "+(t.getAttribute("class")||"")+" ",r=" "+e+" ";n.indexOf(r)>=0;)n=n.replace(r," ");(n=n.trim())?t.setAttribute("class",n):t.removeAttribute("class")}}function Hr(t){if(t){if("object"==typeof t){var e={};return!1!==t.css&&x(e,Br(t.name||"v")),x(e,t),e}return"string"==typeof t?Br(t):void 0}}var Br=y(function(t){return{enterClass:t+"-enter",enterToClass:t+"-enter-to",enterActiveClass:t+"-enter-active",leaveClass:t+"-leave",leaveToClass:t+"-leave-to",leaveActiveClass:t+"-leave-active"}}),Vr=H&&!q,zr="transition",Wr="animation",qr="transition",Kr="transitionend",Xr="animation",Gr="animationend";Vr&&(void 0===window.ontransitionend&&void 0!==window.onwebkittransitionend&&(qr="WebkitTransition",Kr="webkitTransitionEnd"),void 0===window.onanimationend&&void 0!==window.onwebkitanimationend&&(Xr="WebkitAnimation",Gr="webkitAnimationEnd"));var Zr=H?window.requestAnimationFrame?window.requestAnimationFrame.bind(window):setTimeout:function(t){return t()};function Jr(t){Zr(function(){Zr(t)})}function Qr(t,e){var n=t._transitionClasses||(t._transitionClasses=[]);n.indexOf(e)<0&&(n.push(e),Rr(t,e))}function Yr(t,e){t._transitionClasses&&v(t._transitionClasses,e),Ur(t,e)}function to(t,e,n){var r=no(t,e),o=r.type,i=r.timeout,a=r.propCount;if(!o)return n();var s=o===zr?Kr:Gr,c=0,u=function(){t.removeEventListener(s,l),n()},l=function(e){e.target===t&&++c>=a&&u()};setTimeout(function(){c<a&&u()},i+1),t.addEventListener(s,l)}var eo=/\b(transform|all)(,|$)/;function no(t,e){var n,r=window.getComputedStyle(t),o=(r[qr+"Delay"]||"").split(", "),i=(r[qr+"Duration"]||"").split(", "),a=ro(o,i),s=(r[Xr+"Delay"]||"").split(", "),c=(r[Xr+"Duration"]||"").split(", "),u=ro(s,c),l=0,f=0;return e===zr?a>0&&(n=zr,l=a,f=i.length):e===Wr?u>0&&(n=Wr,l=u,f=c.length):f=(n=(l=Math.max(a,u))>0?a>u?zr:Wr:null)?n===zr?i.length:c.length:0,{type:n,timeout:l,propCount:f,hasTransform:n===zr&&eo.test(r[qr+"Property"])}}function ro(t,e){for(;t.length<e.length;)t=t.concat(t);return Math.max.apply(null,e.map(function(e,n){return oo(e)+oo(t[n])}))}function oo(t){return 1e3*Number(t.slice(0,-1).replace(",","."))}function io(t,r){var o=t.elm;n(o._leaveCb)&&(o._leaveCb.cancelled=!0,o._leaveCb());var a=Hr(t.data.transition);if(!e(a)&&!n(o._enterCb)&&1===o.nodeType){for(var s=a.css,c=a.type,u=a.enterClass,l=a.enterToClass,p=a.enterActiveClass,d=a.appearClass,v=a.appearToClass,h=a.appearActiveClass,m=a.beforeEnter,y=a.enter,g=a.afterEnter,_=a.enterCancelled,b=a.beforeAppear,C=a.appear,$=a.afterAppear,w=a.appearCancelled,A=a.duration,x=qe,O=qe.$vnode;O&&O.parent;)x=O.context,O=O.parent;var k=!x._isMounted||!t.isRootInsert;if(!k||C||""===C){var S=k&&d?d:u,E=k&&h?h:p,j=k&&v?v:l,T=k&&b||m,D=k&&"function"==typeof C?C:y,N=k&&$||g,P=k&&w||_,L=f(i(A)?A.enter:A),M=!1!==s&&!q,F=co(D),R=o._enterCb=I(function(){M&&(Yr(o,j),Yr(o,E)),R.cancelled?(M&&Yr(o,S),P&&P(o)):N&&N(o),o._enterCb=null});t.data.show||ne(t,"insert",function(){var e=o.parentNode,n=e&&e._pending&&e._pending[t.key];n&&n.tag===t.tag&&n.elm._leaveCb&&n.elm._leaveCb(),D&&D(o,R)}),T&&T(o),M&&(Qr(o,S),Qr(o,E),Jr(function(){Yr(o,S),R.cancelled||(Qr(o,j),F||(so(L)?setTimeout(R,L):to(o,c,R)))})),t.data.show&&(r&&r(),D&&D(o,R)),M||F||R()}}}function ao(t,r){var o=t.elm;n(o._enterCb)&&(o._enterCb.cancelled=!0,o._enterCb());var a=Hr(t.data.transition);if(e(a)||1!==o.nodeType)return r();if(!n(o._leaveCb)){var s=a.css,c=a.type,u=a.leaveClass,l=a.leaveToClass,p=a.leaveActiveClass,d=a.beforeLeave,v=a.leave,h=a.afterLeave,m=a.leaveCancelled,y=a.delayLeave,g=a.duration,_=!1!==s&&!q,b=co(v),C=f(i(g)?g.leave:g),$=o._leaveCb=I(function(){o.parentNode&&o.parentNode._pending&&(o.parentNode._pending[t.key]=null),_&&(Yr(o,l),Yr(o,p)),$.cancelled?(_&&Yr(o,u),m&&m(o)):(r(),h&&h(o)),o._leaveCb=null});y?y(w):w()}function w(){$.cancelled||(!t.data.show&&o.parentNode&&((o.parentNode._pending||(o.parentNode._pending={}))[t.key]=t),d&&d(o),_&&(Qr(o,u),Qr(o,p),Jr(function(){Yr(o,u),$.cancelled||(Qr(o,l),b||(so(C)?setTimeout($,C):to(o,c,$)))})),v&&v(o,$),_||b||$())}}function so(t){return"number"==typeof t&&!isNaN(t)}function co(t){if(e(t))return!1;var r=t.fns;return n(r)?co(Array.isArray(r)?r[0]:r):(t._length||t.length)>1}function uo(t,e){!0!==e.data.show&&io(e)}var lo=function(t){var i,a,s={},c=t.modules,u=t.nodeOps;for(i=0;i<Qn.length;++i)for(s[Qn[i]]=[],a=0;a<c.length;++a)n(c[a][Qn[i]])&&s[Qn[i]].push(c[a][Qn[i]]);function l(t){var e=u.parentNode(t);n(e)&&u.removeChild(e,t)}function f(t,e,o,i,a,c,l){if(n(t.elm)&&n(c)&&(t=c[l]=vt(t)),t.isRootInsert=!a,!function(t,e,o,i){var a=t.data;if(n(a)){var c=n(t.componentInstance)&&a.keepAlive;if(n(a=a.hook)&&n(a=a.init)&&a(t,!1),n(t.componentInstance))return d(t,e),v(o,t.elm,i),r(c)&&function(t,e,r,o){for(var i,a=t;a.componentInstance;)if(a=a.componentInstance._vnode,n(i=a.data)&&n(i=i.transition)){for(i=0;i<s.activate.length;++i)s.activate[i](Jn,a);e.push(a);break}v(r,t.elm,o)}(t,e,o,i),!0}}(t,e,o,i)){var f=t.data,p=t.children,m=t.tag;n(m)?(t.elm=t.ns?u.createElementNS(t.ns,m):u.createElement(m,t),g(t),h(t,p,e),n(f)&&y(t,e),v(o,t.elm,i)):r(t.isComment)?(t.elm=u.createComment(t.text),v(o,t.elm,i)):(t.elm=u.createTextNode(t.text),v(o,t.elm,i))}}function d(t,e){n(t.data.pendingInsert)&&(e.push.apply(e,t.data.pendingInsert),t.data.pendingInsert=null),t.elm=t.componentInstance.$el,m(t)?(y(t,e),g(t)):(Zn(t),e.push(t))}function v(t,e,r){n(t)&&(n(r)?u.parentNode(r)===t&&u.insertBefore(t,e,r):u.appendChild(t,e))}function h(t,e,n){if(Array.isArray(e))for(var r=0;r<e.length;++r)f(e[r],n,t.elm,null,!0,e,r);else o(t.text)&&u.appendChild(t.elm,u.createTextNode(String(t.text)))}function m(t){for(;t.componentInstance;)t=t.componentInstance._vnode;return n(t.tag)}function y(t,e){for(var r=0;r<s.create.length;++r)s.create[r](Jn,t);n(i=t.data.hook)&&(n(i.create)&&i.create(Jn,t),n(i.insert)&&e.push(t))}function g(t){var e;if(n(e=t.fnScopeId))u.setStyleScope(t.elm,e);else for(var r=t;r;)n(e=r.context)&&n(e=e.$options._scopeId)&&u.setStyleScope(t.elm,e),r=r.parent;n(e=qe)&&e!==t.context&&e!==t.fnContext&&n(e=e.$options._scopeId)&&u.setStyleScope(t.elm,e)}function _(t,e,n,r,o,i){for(;r<=o;++r)f(n[r],i,t,e,!1,n,r)}function b(t){var e,r,o=t.data;if(n(o))for(n(e=o.hook)&&n(e=e.destroy)&&e(t),e=0;e<s.destroy.length;++e)s.destroy[e](t);if(n(e=t.children))for(r=0;r<t.children.length;++r)b(t.children[r])}function C(t,e,r){for(;e<=r;++e){var o=t[e];n(o)&&(n(o.tag)?($(o),b(o)):l(o.elm))}}function $(t,e){if(n(e)||n(t.data)){var r,o=s.remove.length+1;for(n(e)?e.listeners+=o:e=function(t,e){function n(){0==--n.listeners&&l(t)}return n.listeners=e,n}(t.elm,o),n(r=t.componentInstance)&&n(r=r._vnode)&&n(r.data)&&$(r,e),r=0;r<s.remove.length;++r)s.remove[r](t,e);n(r=t.data.hook)&&n(r=r.remove)?r(t,e):e()}else l(t.elm)}function w(t,e,r,o){for(var i=r;i<o;i++){var a=e[i];if(n(a)&&Yn(t,a))return i}}function A(t,o,i,a,c,l){if(t!==o){n(o.elm)&&n(a)&&(o=a[c]=vt(o));var p=o.elm=t.elm;if(r(t.isAsyncPlaceholder))n(o.asyncFactory.resolved)?k(t.elm,o,i):o.isAsyncPlaceholder=!0;else if(r(o.isStatic)&&r(t.isStatic)&&o.key===t.key&&(r(o.isCloned)||r(o.isOnce)))o.componentInstance=t.componentInstance;else{var d,v=o.data;n(v)&&n(d=v.hook)&&n(d=d.prepatch)&&d(t,o);var h=t.children,y=o.children;if(n(v)&&m(o)){for(d=0;d<s.update.length;++d)s.update[d](t,o);n(d=v.hook)&&n(d=d.update)&&d(t,o)}e(o.text)?n(h)&&n(y)?h!==y&&function(t,r,o,i,a){for(var s,c,l,p=0,d=0,v=r.length-1,h=r[0],m=r[v],y=o.length-1,g=o[0],b=o[y],$=!a;p<=v&&d<=y;)e(h)?h=r[++p]:e(m)?m=r[--v]:Yn(h,g)?(A(h,g,i,o,d),h=r[++p],g=o[++d]):Yn(m,b)?(A(m,b,i,o,y),m=r[--v],b=o[--y]):Yn(h,b)?(A(h,b,i,o,y),$&&u.insertBefore(t,h.elm,u.nextSibling(m.elm)),h=r[++p],b=o[--y]):Yn(m,g)?(A(m,g,i,o,d),$&&u.insertBefore(t,m.elm,h.elm),m=r[--v],g=o[++d]):(e(s)&&(s=tr(r,p,v)),e(c=n(g.key)?s[g.key]:w(g,r,p,v))?f(g,i,t,h.elm,!1,o,d):Yn(l=r[c],g)?(A(l,g,i,o,d),r[c]=void 0,$&&u.insertBefore(t,l.elm,h.elm)):f(g,i,t,h.elm,!1,o,d),g=o[++d]);p>v?_(t,e(o[y+1])?null:o[y+1].elm,o,d,y,i):d>y&&C(r,p,v)}(p,h,y,i,l):n(y)?(n(t.text)&&u.setTextContent(p,""),_(p,null,y,0,y.length-1,i)):n(h)?C(h,0,h.length-1):n(t.text)&&u.setTextContent(p,""):t.text!==o.text&&u.setTextContent(p,o.text),n(v)&&n(d=v.hook)&&n(d=d.postpatch)&&d(t,o)}}}function x(t,e,o){if(r(o)&&n(t.parent))t.parent.data.pendingInsert=e;else for(var i=0;i<e.length;++i)e[i].data.hook.insert(e[i])}var O=p("attrs,class,staticClass,staticStyle,key");function k(t,e,o,i){var a,s=e.tag,c=e.data,u=e.children;if(i=i||c&&c.pre,e.elm=t,r(e.isComment)&&n(e.asyncFactory))return e.isAsyncPlaceholder=!0,!0;if(n(c)&&(n(a=c.hook)&&n(a=a.init)&&a(e,!0),n(a=e.componentInstance)))return d(e,o),!0;if(n(s)){if(n(u))if(t.hasChildNodes())if(n(a=c)&&n(a=a.domProps)&&n(a=a.innerHTML)){if(a!==t.innerHTML)return!1}else{for(var l=!0,f=t.firstChild,p=0;p<u.length;p++){if(!f||!k(f,u[p],o,i)){l=!1;break}f=f.nextSibling}if(!l||f)return!1}else h(e,u,o);if(n(c)){var v=!1;for(var m in c)if(!O(m)){v=!0,y(e,o);break}!v&&c.class&&Qt(c.class)}}else t.data!==e.text&&(t.data=e.text);return!0}return function(t,o,i,a){if(!e(o)){var c,l=!1,p=[];if(e(t))l=!0,f(o,p);else{var d=n(t.nodeType);if(!d&&Yn(t,o))A(t,o,p,null,null,a);else{if(d){if(1===t.nodeType&&t.hasAttribute(D)&&(t.removeAttribute(D),i=!0),r(i)&&k(t,o,p))return x(o,p,!0),t;c=t,t=new lt(u.tagName(c).toLowerCase(),{},[],void 0,c)}var v=t.elm,h=u.parentNode(v);if(f(o,p,v._leaveCb?null:h,u.nextSibling(v)),n(o.parent))for(var y=o.parent,g=m(o);y;){for(var _=0;_<s.destroy.length;++_)s.destroy[_](y);if(y.elm=o.elm,g){for(var $=0;$<s.create.length;++$)s.create[$](Jn,y);var w=y.data.hook.insert;if(w.merged)for(var O=1;O<w.fns.length;O++)w.fns[O]()}else Zn(y);y=y.parent}n(h)?C([t],0,0):n(t.tag)&&b(t)}}return x(o,p,l),o.elm}n(t)&&b(t)}}({nodeOps:Xn,modules:[fr,vr,wr,Or,Mr,H?{create:uo,activate:uo,remove:function(t,e){!0!==t.data.show?ao(t,e):e()}}:{}].concat(sr)});q&&document.addEventListener("selectionchange",function(){var t=document.activeElement;t&&t.vmodel&&_o(t,"input")});var fo={inserted:function(t,e,n,r){"select"===n.tag?(r.elm&&!r.elm._vOptions?ne(n,"postpatch",function(){fo.componentUpdated(t,e,n)}):po(t,e,n.context),t._vOptions=[].map.call(t.options,mo)):("textarea"===n.tag||Kn(t.type))&&(t._vModifiers=e.modifiers,e.modifiers.lazy||(t.addEventListener("compositionstart",yo),t.addEventListener("compositionend",go),t.addEventListener("change",go),q&&(t.vmodel=!0)))},componentUpdated:function(t,e,n){if("select"===n.tag){po(t,e,n.context);var r=t._vOptions,o=t._vOptions=[].map.call(t.options,mo);if(o.some(function(t,e){return!j(t,r[e])}))(t.multiple?e.value.some(function(t){return ho(t,o)}):e.value!==e.oldValue&&ho(e.value,o))&&_o(t,"change")}}};function po(t,e,n){vo(t,e,n),(W||K)&&setTimeout(function(){vo(t,e,n)},0)}function vo(t,e,n){var r=e.value,o=t.multiple;if(!o||Array.isArray(r)){for(var i,a,s=0,c=t.options.length;s<c;s++)if(a=t.options[s],o)i=T(r,mo(a))>-1,a.selected!==i&&(a.selected=i);else if(j(mo(a),r))return void(t.selectedIndex!==s&&(t.selectedIndex=s));o||(t.selectedIndex=-1)}}function ho(t,e){return e.every(function(e){return!j(e,t)})}function mo(t){return"_value"in t?t._value:t.value}function yo(t){t.target.composing=!0}function go(t){t.target.composing&&(t.target.composing=!1,_o(t.target,"input"))}function _o(t,e){var n=document.createEvent("HTMLEvents");n.initEvent(e,!0,!0),t.dispatchEvent(n)}function bo(t){return!t.componentInstance||t.data&&t.data.transition?t:bo(t.componentInstance._vnode)}var Co={model:fo,show:{bind:function(t,e,n){var r=e.value,o=(n=bo(n)).data&&n.data.transition,i=t.__vOriginalDisplay="none"===t.style.display?"":t.style.display;r&&o?(n.data.show=!0,io(n,function(){t.style.display=i})):t.style.display=r?i:"none"},update:function(t,e,n){var r=e.value;!r!=!e.oldValue&&((n=bo(n)).data&&n.data.transition?(n.data.show=!0,r?io(n,function(){t.style.display=t.__vOriginalDisplay}):ao(n,function(){t.style.display="none"})):t.style.display=r?t.__vOriginalDisplay:"none")},unbind:function(t,e,n,r,o){o||(t.style.display=t.__vOriginalDisplay)}}},$o={name:String,appear:Boolean,css:Boolean,mode:String,type:String,enterClass:String,leaveClass:String,enterToClass:String,leaveToClass:String,enterActiveClass:String,leaveActiveClass:String,appearClass:String,appearActiveClass:String,appearToClass:String,duration:[Number,String,Object]};function wo(t){var e=t&&t.componentOptions;return e&&e.Ctor.options.abstract?wo(He(e.children)):t}function Ao(t){var e={},n=t.$options;for(var r in n.propsData)e[r]=t[r];var o=n._parentListeners;for(var i in o)e[_(i)]=o[i];return e}function xo(t,e){if(/\d-keep-alive$/.test(e.tag))return t("keep-alive",{props:e.componentOptions.propsData})}var Oo=function(t){return t.tag||Ue(t)},ko=function(t){return"show"===t.name},So={name:"transition",props:$o,abstract:!0,render:function(t){var e=this,n=this.$slots.default;if(n&&(n=n.filter(Oo)).length){var r=this.mode,i=n[0];if(function(t){for(;t=t.parent;)if(t.data.transition)return!0}(this.$vnode))return i;var a=wo(i);if(!a)return i;if(this._leaving)return xo(t,i);var s="__transition-"+this._uid+"-";a.key=null==a.key?a.isComment?s+"comment":s+a.tag:o(a.key)?0===String(a.key).indexOf(s)?a.key:s+a.key:a.key;var c=(a.data||(a.data={})).transition=Ao(this),u=this._vnode,l=wo(u);if(a.data.directives&&a.data.directives.some(ko)&&(a.data.show=!0),l&&l.data&&!function(t,e){return e.key===t.key&&e.tag===t.tag}(a,l)&&!Ue(l)&&(!l.componentInstance||!l.componentInstance._vnode.isComment)){var f=l.data.transition=x({},c);if("out-in"===r)return this._leaving=!0,ne(f,"afterLeave",function(){e._leaving=!1,e.$forceUpdate()}),xo(t,i);if("in-out"===r){if(Ue(a))return u;var p,d=function(){p()};ne(c,"afterEnter",d),ne(c,"enterCancelled",d),ne(f,"delayLeave",function(t){p=t})}}return i}}},Eo=x({tag:String,moveClass:String},$o);function jo(t){t.elm._moveCb&&t.elm._moveCb(),t.elm._enterCb&&t.elm._enterCb()}function To(t){t.data.newPos=t.elm.getBoundingClientRect()}function Io(t){var e=t.data.pos,n=t.data.newPos,r=e.left-n.left,o=e.top-n.top;if(r||o){t.data.moved=!0;var i=t.elm.style;i.transform=i.WebkitTransform="translate("+r+"px,"+o+"px)",i.transitionDuration="0s"}}delete Eo.mode;var Do={Transition:So,TransitionGroup:{props:Eo,beforeMount:function(){var t=this,e=this._update;this._update=function(n,r){var o=Ke(t);t.__patch__(t._vnode,t.kept,!1,!0),t._vnode=t.kept,o(),e.call(t,n,r)}},render:function(t){for(var e=this.tag||this.$vnode.data.tag||"span",n=Object.create(null),r=this.prevChildren=this.children,o=this.$slots.default||[],i=this.children=[],a=Ao(this),s=0;s<o.length;s++){var c=o[s];c.tag&&null!=c.key&&0!==String(c.key).indexOf("__vlist")&&(i.push(c),n[c.key]=c,(c.data||(c.data={})).transition=a)}if(r){for(var u=[],l=[],f=0;f<r.length;f++){var p=r[f];p.data.transition=a,p.data.pos=p.elm.getBoundingClientRect(),n[p.key]?u.push(p):l.push(p)}this.kept=t(e,null,u),this.removed=l}return t(e,null,i)},updated:function(){var t=this.prevChildren,e=this.moveClass||(this.name||"v")+"-move";t.length&&this.hasMove(t[0].elm,e)&&(t.forEach(jo),t.forEach(To),t.forEach(Io),this._reflow=document.body.offsetHeight,t.forEach(function(t){if(t.data.moved){var n=t.elm,r=n.style;Qr(n,e),r.transform=r.WebkitTransform=r.transitionDuration="",n.addEventListener(Kr,n._moveCb=function t(r){r&&r.target!==n||r&&!/transform$/.test(r.propertyName)||(n.removeEventListener(Kr,t),n._moveCb=null,Yr(n,e))})}}))},methods:{hasMove:function(t,e){if(!Vr)return!1;if(this._hasMove)return this._hasMove;var n=t.cloneNode();t._transitionClasses&&t._transitionClasses.forEach(function(t){Ur(n,t)}),Rr(n,e),n.style.display="none",this.$el.appendChild(n);var r=no(n);return this.$el.removeChild(n),this._hasMove=r.hasTransform}}}};bn.config.mustUseProp=function(t,e,n){return"value"===n&&En(t)&&"button"!==e||"selected"===n&&"option"===t||"checked"===n&&"input"===t||"muted"===n&&"video"===t},bn.config.isReservedTag=Wn,bn.config.isReservedAttr=Sn,bn.config.getTagNamespace=function(t){return zn(t)?"svg":"math"===t?"math":void 0},bn.config.isUnknownElement=function(t){if(!H)return!0;if(Wn(t))return!1;if(t=t.toLowerCase(),null!=qn[t])return qn[t];var e=document.createElement(t);return t.indexOf("-")>-1?qn[t]=e.constructor===window.HTMLUnknownElement||e.constructor===window.HTMLElement:qn[t]=/HTMLUnknownElement/.test(e.toString())},x(bn.options.directives,Co),x(bn.options.components,Do),bn.prototype.__patch__=H?lo:k,bn.prototype.$mount=function(t,e){return function(t,e,n){var r;return t.$el=e,t.$options.render||(t.$options.render=pt),Ze(t,"beforeMount"),r=function(){t._update(t._render(),n)},new un(t,r,k,{before:function(){t._isMounted&&!t._isDestroyed&&Ze(t,"beforeUpdate")}},!0),n=!1,null==t.$vnode&&(t._isMounted=!0,Ze(t,"mounted")),t}(this,t=t&&H?function(t){if("string"==typeof t){var e=document.querySelector(t);return e||document.createElement("div")}return t}(t):void 0,e)},H&&setTimeout(function(){L.devtools&&tt&&tt.emit("init",bn)},0),module.exports=bn;
}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],797:[function(require,module,exports){
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = global || self, global.DatePicker = factory());
}(this, (function () { 'use strict';

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof = function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};

    var target = _objectWithoutPropertiesLoose(source, excluded);

    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
  }

  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }

  function _iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

    return arr2;
  }

  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  function _extends$1() {
    return _extends$1 = Object.assign || function (a) {
      for (var b, c = 1; c < arguments.length; c++) {
        for (var d in b = arguments[c], b) {
          Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
        }
      }

      return a;
    }, _extends$1.apply(this, arguments);
  }

  var normalMerge = ["attrs", "props", "domProps"],
      toArrayMerge = ["class", "style", "directives"],
      functionalMerge = ["on", "nativeOn"],
      mergeJsxProps = function mergeJsxProps(a) {
    return a.reduce(function (c, a) {
      for (var b in a) {
        if (!c[b]) c[b] = a[b];else if (-1 !== normalMerge.indexOf(b)) c[b] = _extends$1({}, c[b], a[b]);else if (-1 !== toArrayMerge.indexOf(b)) {
          var d = c[b] instanceof Array ? c[b] : [c[b]],
              e = a[b] instanceof Array ? a[b] : [a[b]];
          c[b] = d.concat(e);
        } else if (-1 !== functionalMerge.indexOf(b)) {
          for (var f in a[b]) {
            if (c[b][f]) {
              var g = c[b][f] instanceof Array ? c[b][f] : [c[b][f]],
                  h = a[b][f] instanceof Array ? a[b][f] : [a[b][f]];
              c[b][f] = g.concat(h);
            } else c[b][f] = a[b][f];
          }
        } else if ("hook" == b) for (var i in a[b]) {
          c[b][i] = c[b][i] ? mergeFn(c[b][i], a[b][i]) : a[b][i];
        } else c[b] = a[b];
      }

      return c;
    }, {});
  },
      mergeFn = function mergeFn(a, b) {
    return function () {
      a && a.apply(this, arguments), b && b.apply(this, arguments);
    };
  };

  var helper = mergeJsxProps;

  function isDate(value) {
    return value instanceof Date || Object.prototype.toString.call(value) === '[object Date]';
  }
  function toDate(value) {
    if (isDate(value)) {
      return new Date(value.getTime());
    }

    if (value == null) {
      return new Date(NaN);
    }

    return new Date(value);
  }
  function isValidDate(value) {
    return isDate(value) && !isNaN(value.getTime());
  }
  function startOfWeek(value) {
    var firstDayOfWeek = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    if (!(firstDayOfWeek >= 0 && firstDayOfWeek <= 6)) {
      throw new RangeError('weekStartsOn must be between 0 and 6');
    }

    var date = toDate(value);
    var day = date.getDay();
    var diff = (day + 7 - firstDayOfWeek) % 7;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
  }
  function startOfWeekYear(value) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$firstDayOfWeek = _ref.firstDayOfWeek,
        firstDayOfWeek = _ref$firstDayOfWeek === void 0 ? 0 : _ref$firstDayOfWeek,
        _ref$firstWeekContain = _ref.firstWeekContainsDate,
        firstWeekContainsDate = _ref$firstWeekContain === void 0 ? 1 : _ref$firstWeekContain;

    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
      throw new RangeError('firstWeekContainsDate must be between 1 and 7');
    }

    var date = toDate(value);
    var year = date.getFullYear();
    var firstDateOfFirstWeek = new Date(0);

    for (var i = year + 1; i >= year - 1; i--) {
      firstDateOfFirstWeek.setFullYear(i, 0, firstWeekContainsDate);
      firstDateOfFirstWeek.setHours(0, 0, 0, 0);
      firstDateOfFirstWeek = startOfWeek(firstDateOfFirstWeek, firstDayOfWeek);

      if (date.getTime() >= firstDateOfFirstWeek.getTime()) {
        break;
      }
    }

    return firstDateOfFirstWeek;
  }
  function getWeek(value) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref2$firstDayOfWeek = _ref2.firstDayOfWeek,
        firstDayOfWeek = _ref2$firstDayOfWeek === void 0 ? 0 : _ref2$firstDayOfWeek,
        _ref2$firstWeekContai = _ref2.firstWeekContainsDate,
        firstWeekContainsDate = _ref2$firstWeekContai === void 0 ? 1 : _ref2$firstWeekContai;

    var date = toDate(value);
    var firstDateOfThisWeek = startOfWeek(date, firstDayOfWeek);
    var firstDateOfFirstWeek = startOfWeekYear(date, {
      firstDayOfWeek: firstDayOfWeek,
      firstWeekContainsDate: firstWeekContainsDate
    });
    var diff = firstDateOfThisWeek.getTime() - firstDateOfFirstWeek.getTime();
    return Math.round(diff / (7 * 24 * 3600 * 1000)) + 1;
  }

  var locale = {
    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    weekdaysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    firstDayOfWeek: 0,
    firstWeekContainsDate: 1
  };

  var REGEX_FORMAT = /\[([^\]]+)]|YYYY|YY?|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|m{1,2}|s{1,2}|Z{1,2}|S{1,3}|w{1,2}|x|X|a|A/g;

  function pad(val) {
    var len = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    var output = "".concat(Math.abs(val));
    var sign = val < 0 ? '-' : '';

    while (output.length < len) {
      output = "0".concat(output);
    }

    return sign + output;
  }

  function getOffset(date) {
    return Math.round(date.getTimezoneOffset() / 15) * 15;
  }

  function formatTimezone(offset) {
    var delimeter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    return sign + pad(hours, 2) + delimeter + pad(minutes, 2);
  }

  var meridiem = function meridiem(h, _, isLowercase) {
    var word = h < 12 ? 'AM' : 'PM';
    return isLowercase ? word.toLocaleLowerCase() : word;
  };

  var formatFlags = {
    Y: function Y(date) {
      var y = date.getFullYear();
      return y <= 9999 ? "".concat(y) : "+".concat(y);
    },
    // Year: 00, 01, ..., 99
    YY: function YY(date) {
      return pad(date.getFullYear(), 4).substr(2);
    },
    // Year: 1900, 1901, ..., 2099
    YYYY: function YYYY(date) {
      return pad(date.getFullYear(), 4);
    },
    // Month: 1, 2, ..., 12
    M: function M(date) {
      return date.getMonth() + 1;
    },
    // Month: 01, 02, ..., 12
    MM: function MM(date) {
      return pad(date.getMonth() + 1, 2);
    },
    MMM: function MMM(date, locale) {
      return locale.monthsShort[date.getMonth()];
    },
    MMMM: function MMMM(date, locale) {
      return locale.months[date.getMonth()];
    },
    // Day of month: 1, 2, ..., 31
    D: function D(date) {
      return date.getDate();
    },
    // Day of month: 01, 02, ..., 31
    DD: function DD(date) {
      return pad(date.getDate(), 2);
    },
    // Hour: 0, 1, ... 23
    H: function H(date) {
      return date.getHours();
    },
    // Hour: 00, 01, ..., 23
    HH: function HH(date) {
      return pad(date.getHours(), 2);
    },
    // Hour: 1, 2, ..., 12
    h: function h(date) {
      var hours = date.getHours();

      if (hours === 0) {
        return 12;
      }

      if (hours > 12) {
        return hours % 12;
      }

      return hours;
    },
    // Hour: 01, 02, ..., 12
    hh: function hh() {
      var hours = formatFlags.h.apply(formatFlags, arguments);
      return pad(hours, 2);
    },
    // Minute: 0, 1, ..., 59
    m: function m(date) {
      return date.getMinutes();
    },
    // Minute: 00, 01, ..., 59
    mm: function mm(date) {
      return pad(date.getMinutes(), 2);
    },
    // Second: 0, 1, ..., 59
    s: function s(date) {
      return date.getSeconds();
    },
    // Second: 00, 01, ..., 59
    ss: function ss(date) {
      return pad(date.getSeconds(), 2);
    },
    // 1/10 of second: 0, 1, ..., 9
    S: function S(date) {
      return Math.floor(date.getMilliseconds() / 100);
    },
    // 1/100 of second: 00, 01, ..., 99
    SS: function SS(date) {
      return pad(Math.floor(date.getMilliseconds() / 10), 2);
    },
    // Millisecond: 000, 001, ..., 999
    SSS: function SSS(date) {
      return pad(date.getMilliseconds(), 3);
    },
    // Day of week: 0, 1, ..., 6
    d: function d(date) {
      return date.getDay();
    },
    // Day of week: 'Su', 'Mo', ..., 'Sa'
    dd: function dd(date, locale) {
      return locale.weekdaysMin[date.getDay()];
    },
    // Day of week: 'Sun', 'Mon',..., 'Sat'
    ddd: function ddd(date, locale) {
      return locale.weekdaysShort[date.getDay()];
    },
    // Day of week: 'Sunday', 'Monday', ...,'Saturday'
    dddd: function dddd(date, locale) {
      return locale.weekdays[date.getDay()];
    },
    // AM, PM
    A: function A(date, locale) {
      var meridiemFunc = locale.meridiem || meridiem;
      return meridiemFunc(date.getHours(), date.getMinutes(), false);
    },
    // am, pm
    a: function a(date, locale) {
      var meridiemFunc = locale.meridiem || meridiem;
      return meridiemFunc(date.getHours(), date.getMinutes(), true);
    },
    // Timezone: -01:00, +00:00, ... +12:00
    Z: function Z(date) {
      return formatTimezone(getOffset(date), ':');
    },
    // Timezone: -0100, +0000, ... +1200
    ZZ: function ZZ(date) {
      return formatTimezone(getOffset(date));
    },
    // Seconds timestamp: 512969520
    X: function X(date) {
      return Math.floor(date.getTime() / 1000);
    },
    // Milliseconds timestamp: 512969520900
    x: function x(date) {
      return date.getTime();
    },
    w: function w(date, locale) {
      return getWeek(date, {
        firstDayOfWeek: locale.firstDayOfWeek,
        firstWeekContainsDate: locale.firstWeekContainsDate
      });
    },
    ww: function ww(date, locale) {
      return pad(formatFlags.w(date, locale), 2);
    }
  };
  function format(val, str) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var formatStr = str ? String(str) : 'YYYY-MM-DDTHH:mm:ss.SSSZ';
    var date = toDate(val);

    if (!isValidDate(date)) {
      return 'Invalid Date';
    }

    var locale$1 = options.locale || locale;
    return formatStr.replace(REGEX_FORMAT, function (match, p1) {
      if (p1) {
        return p1;
      }

      if (typeof formatFlags[match] === 'function') {
        return "".concat(formatFlags[match](date, locale$1));
      }

      return match;
    });
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
  }

  function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }

      return arr2;
    }
  }

  function ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys$1(source, true).forEach(function (key) {
          _defineProperty$1(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys$1(source).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _slicedToArray$1(arr, i) {
    return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _nonIterableRest$1();
  }

  function _nonIterableRest$1() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }

  function _iterableToArrayLimit$1(arr, i) {
    if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
      return;
    }

    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  function _arrayWithHoles$1(arr) {
    if (Array.isArray(arr)) return arr;
  }

  function _defineProperty$1(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }
  var formattingTokens = /(\[[^\[]*\])|(MM?M?M?|Do|DD?|ddd?d?|w[o|w]?|YYYY|YY|a|A|hh?|HH?|mm?|ss?|S{1,3}|x|X|ZZ?|.)/g;
  var match1 = /\d/; // 0 - 9

  var match2 = /\d\d/; // 00 - 99

  var match3 = /\d{3}/; // 000 - 999

  var match4 = /\d{4}/; // 0000 - 9999

  var match1to2 = /\d\d?/; // 0 - 99

  var matchShortOffset = /[+-]\d\d:?\d\d/; // +00:00 -00:00 +0000 or -0000

  var matchSigned = /[+-]?\d+/; // -inf - inf

  var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
  // const matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i; // Word

  var YEAR = 'year';
  var MONTH = 'month';
  var DAY = 'day';
  var HOUR = 'hour';
  var MINUTE = 'minute';
  var SECOND = 'second';
  var MILLISECOND = 'millisecond';
  var parseFlags = {};

  var addParseFlag = function addParseFlag(token, regex, callback) {
    var tokens = Array.isArray(token) ? token : [token];
    var func;

    if (typeof callback === 'string') {
      func = function func(input) {
        var value = parseInt(input, 10);
        return _defineProperty$1({}, callback, value);
      };
    } else {
      func = callback;
    }

    tokens.forEach(function (key) {
      parseFlags[key] = [regex, func];
    });
  };

  var escapeStringRegExp = function escapeStringRegExp(str) {
    return str.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
  };

  var matchWordRegExp = function matchWordRegExp(localeKey) {
    return function (locale) {
      var array = locale[localeKey];

      if (!Array.isArray(array)) {
        throw new Error("Locale[".concat(localeKey, "] need an array"));
      }

      return new RegExp(array.map(escapeStringRegExp).join('|'));
    };
  };

  var matchWordCallback = function matchWordCallback(localeKey, key) {
    return function (input, locale) {
      var array = locale[localeKey];

      if (!Array.isArray(array)) {
        throw new Error("Locale[".concat(localeKey, "] need an array"));
      }

      var index = array.indexOf(input);

      if (index < 0) {
        throw new Error('Invalid Word');
      }

      return _defineProperty$1({}, key, index);
    };
  };

  addParseFlag('Y', matchSigned, YEAR);
  addParseFlag('YY', match2, function (input) {
    var year = new Date().getFullYear();
    var cent = Math.floor(year / 100);
    var value = parseInt(input, 10);
    value = (value > 68 ? cent - 1 : cent) * 100 + value;
    return _defineProperty$1({}, YEAR, value);
  });
  addParseFlag('YYYY', match4, YEAR);
  addParseFlag('M', match1to2, function (input) {
    return _defineProperty$1({}, MONTH, parseInt(input, 10) - 1);
  });
  addParseFlag('MM', match2, function (input) {
    return _defineProperty$1({}, MONTH, parseInt(input, 10) - 1);
  });
  addParseFlag('MMM', matchWordRegExp('monthsShort'), matchWordCallback('monthsShort', MONTH));
  addParseFlag('MMMM', matchWordRegExp('months'), matchWordCallback('months', MONTH));
  addParseFlag('D', match1to2, DAY);
  addParseFlag('DD', match2, DAY);
  addParseFlag(['H', 'h'], match1to2, HOUR);
  addParseFlag(['HH', 'hh'], match2, HOUR);
  addParseFlag('m', match1to2, MINUTE);
  addParseFlag('mm', match2, MINUTE);
  addParseFlag('s', match1to2, SECOND);
  addParseFlag('ss', match2, SECOND);
  addParseFlag('S', match1, function (input) {
    return _defineProperty$1({}, MILLISECOND, parseInt(input, 10) * 100);
  });
  addParseFlag('SS', match2, function (input) {
    return _defineProperty$1({}, MILLISECOND, parseInt(input, 10) * 10);
  });
  addParseFlag('SSS', match3, MILLISECOND);

  function matchMeridiem(locale) {
    return locale.meridiemParse || /[ap]\.?m?\.?/i;
  }

  function defaultIsPM(input) {
    return "".concat(input).toLowerCase().charAt(0) === 'p';
  }

  addParseFlag(['A', 'a'], matchMeridiem, function (input, locale) {
    var isPM = typeof locale.isPM === 'function' ? locale.isPM(input) : defaultIsPM(input);
    return {
      isPM: isPM
    };
  });

  function offsetFromString(str) {
    var _ref8 = str.match(/([+-]|\d\d)/g) || ['-', '0', '0'],
        _ref9 = _slicedToArray$1(_ref8, 3),
        symbol = _ref9[0],
        hour = _ref9[1],
        minute = _ref9[2];

    var minutes = parseInt(hour, 10) * 60 + parseInt(minute, 10);

    if (minutes === 0) {
      return 0;
    }

    return symbol === '+' ? -minutes : +minutes;
  }

  addParseFlag(['Z', 'ZZ'], matchShortOffset, function (input) {
    return {
      offset: offsetFromString(input)
    };
  });
  addParseFlag('x', matchSigned, function (input) {
    return {
      date: new Date(parseInt(input, 10))
    };
  });
  addParseFlag('X', matchTimestamp, function (input) {
    return {
      date: new Date(parseFloat(input) * 1000)
    };
  });
  addParseFlag('d', match1, 'weekday');
  addParseFlag('dd', matchWordRegExp('weekdaysMin'), matchWordCallback('weekdaysMin', 'weekday'));
  addParseFlag('ddd', matchWordRegExp('weekdaysShort'), matchWordCallback('weekdaysShort', 'weekday'));
  addParseFlag('dddd', matchWordRegExp('weekdays'), matchWordCallback('weekdays', 'weekday'));
  addParseFlag('w', match1to2, 'week');
  addParseFlag('ww', match2, 'week');

  function to24hour(hour, isPM) {
    if (hour !== undefined && isPM !== undefined) {
      if (isPM) {
        if (hour < 12) {
          return hour + 12;
        }
      } else if (hour === 12) {
        return 0;
      }
    }

    return hour;
  }

  function getFullInputArray(input) {
    var backupDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
    var result = [0, 0, 1, 0, 0, 0, 0];
    var backupArr = [backupDate.getFullYear(), backupDate.getMonth(), backupDate.getDate(), backupDate.getHours(), backupDate.getMinutes(), backupDate.getSeconds(), backupDate.getMilliseconds()];
    var useBackup = true;

    for (var i = 0; i < 7; i++) {
      if (input[i] === undefined) {
        result[i] = useBackup ? backupArr[i] : result[i];
      } else {
        result[i] = input[i];
        useBackup = false;
      }
    }

    return result;
  }

  function createDate(y, m, d, h, M, s, ms) {
    var date;

    if (y < 100 && y >= 0) {
      date = new Date(y + 400, m, d, h, M, s, ms);

      if (isFinite(date.getFullYear())) {
        date.setFullYear(y);
      }
    } else {
      date = new Date(y, m, d, h, M, s, ms);
    }

    return date;
  }

  function createUTCDate() {
    var date;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var y = args[0];

    if (y < 100 && y >= 0) {
      args[0] += 400;
      date = new Date(Date.UTC.apply(Date, args)); // eslint-disable-next-line no-restricted-globals

      if (isFinite(date.getUTCFullYear())) {
        date.setUTCFullYear(y);
      }
    } else {
      date = new Date(Date.UTC.apply(Date, args));
    }

    return date;
  }

  function makeParser(dateString, format, locale) {
    var tokens = format.match(formattingTokens);

    if (!tokens) {
      throw new Error();
    }

    var length = tokens.length;
    var mark = {};

    for (var i = 0; i < length; i += 1) {
      var token = tokens[i];
      var parseTo = parseFlags[token];

      if (!parseTo) {
        var word = token.replace(/^\[|\]$/g, '');

        if (dateString.indexOf(word) === 0) {
          dateString = dateString.substr(word.length);
        } else {
          throw new Error('not match');
        }
      } else {
        var regex = typeof parseTo[0] === 'function' ? parseTo[0](locale) : parseTo[0];
        var parser = parseTo[1];
        var value = (regex.exec(dateString) || [])[0];
        var obj = parser(value, locale);
        mark = _objectSpread({}, mark, {}, obj);
        dateString = dateString.replace(value, '');
      }
    }

    return mark;
  }

  function parse(str, format) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    try {
      var _options$locale = options.locale,
          _locale = _options$locale === void 0 ? locale : _options$locale,
          _options$backupDate = options.backupDate,
          backupDate = _options$backupDate === void 0 ? new Date() : _options$backupDate;

      var parseResult = makeParser(str, format, _locale);
      var year = parseResult.year,
          month = parseResult.month,
          day = parseResult.day,
          hour = parseResult.hour,
          minute = parseResult.minute,
          second = parseResult.second,
          millisecond = parseResult.millisecond,
          isPM = parseResult.isPM,
          date = parseResult.date,
          offset = parseResult.offset,
          weekday = parseResult.weekday,
          week = parseResult.week;

      if (date) {
        return date;
      }

      var inputArray = [year, month, day, hour, minute, second, millisecond];
      inputArray[3] = to24hour(inputArray[3], isPM); // check week

      if (week !== undefined && month === undefined && day === undefined) {
        // new Date(year, 3) make sure in current year
        var firstDate = startOfWeekYear(year === undefined ? backupDate : new Date(year, 3), {
          firstDayOfWeek: _locale.firstDayOfWeek,
          firstWeekContainsDate: _locale.firstWeekContainsDate
        });
        return new Date(firstDate.getTime() + (week - 1) * 7 * 24 * 3600 * 1000);
      }

      var parsedDate;
      var result = getFullInputArray(inputArray, backupDate);

      if (offset !== undefined) {
        result[6] += offset * 60 * 1000;
        parsedDate = createUTCDate.apply(void 0, _toConsumableArray(result));
      } else {
        parsedDate = createDate.apply(void 0, _toConsumableArray(result));
      } // check weekday


      if (weekday !== undefined && parsedDate.getDay() !== weekday) {
        return new Date(NaN);
      }

      return parsedDate;
    } catch (e) {
      return new Date(NaN);
    }
  }

  // new Date(10, 0, 1) The year from 0 to 99 will be incremented by 1900 automatically.
  function createDate$1(y) {
    var M = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var d = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var h = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var m = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    var s = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    var ms = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
    var date = new Date(y, M, d, h, m, s, ms);

    if (y < 100 && y >= 0) {
      date.setFullYear(y);
    }

    return date;
  }
  function isValidDate$1(date) {
    return date instanceof Date && !isNaN(date);
  }
  function isValidRangeDate(date) {
    return Array.isArray(date) && date.length === 2 && date.every(isValidDate$1) && date[0] <= date[1];
  }
  function isValidDates(dates) {
    return Array.isArray(dates) && dates.every(isValidDate$1);
  }
  function getValidDate(value) {
    var date = new Date(value);

    if (isValidDate$1(date)) {
      return date;
    }

    for (var _len = arguments.length, backup = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      backup[_key - 1] = arguments[_key];
    }

    if (backup.length) {
      return getValidDate.apply(void 0, backup);
    }

    return new Date();
  }
  function startOfYear(value) {
    var date = new Date(value);
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
  function startOfMonth(value) {
    var date = new Date(value);
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
  function startOfDay(value) {
    var date = new Date(value);
    date.setHours(0, 0, 0, 0);
    return date;
  }
  function getCalendar(_ref) {
    var firstDayOfWeek = _ref.firstDayOfWeek,
        year = _ref.year,
        month = _ref.month;
    var arr = []; // change to the last day of the last month

    var calendar = createDate$1(year, month, 0);
    var lastDayInLastMonth = calendar.getDate(); // getDay() 0 is Sunday, 1 is Monday

    var firstDayInLastMonth = lastDayInLastMonth - (calendar.getDay() + 7 - firstDayOfWeek) % 7;

    for (var i = firstDayInLastMonth; i <= lastDayInLastMonth; i++) {
      arr.push(createDate$1(year, month, i - lastDayInLastMonth));
    } // change to the last day of the current month


    calendar.setMonth(month + 1, 0);
    var lastDayInCurrentMonth = calendar.getDate();

    for (var _i = 1; _i <= lastDayInCurrentMonth; _i++) {
      arr.push(createDate$1(year, month, _i));
    }

    var lastMonthLength = lastDayInLastMonth - firstDayInLastMonth + 1;
    var nextMonthLength = 6 * 7 - lastMonthLength - lastDayInCurrentMonth;

    for (var _i2 = 1; _i2 <= nextMonthLength; _i2++) {
      arr.push(createDate$1(year, month, lastDayInCurrentMonth + _i2));
    }

    return arr;
  }
  function setMonth(dirtyDate, dirtyMonth) {
    var date = new Date(dirtyDate);
    var month = Number(dirtyMonth);
    var year = date.getFullYear();
    var daysInMonth = createDate$1(year, month + 1, 0).getDate();
    var day = date.getDate();
    date.setMonth(month, Math.min(day, daysInMonth));
    return date;
  }
  function assignTime(target, source) {
    var date = new Date(target);
    var time = new Date(source);
    date.setHours(time.getHours(), time.getMinutes(), time.getSeconds());
    return date;
  }

  /**
   * chunk the array
   * @param {Array} arr
   * @param {Number} size
   */
  function chunk(arr, size) {
    if (!Array.isArray(arr)) {
      return [];
    }

    var result = [];
    var len = arr.length;
    var i = 0;
    size = size || len;

    while (i < len) {
      result.push(arr.slice(i, i += size));
    }

    return result;
  }
  /**
   * isObject
   * @param {*} obj
   * @returns {Boolean}
   */

  function isObject(obj) {
    return Object.prototype.toString.call(obj) === '[object Object]';
  }
  /**
   * pick object
   * @param {Object} obj
   * @param {Array|String} props
   */

  function pick(obj, props) {
    if (!isObject(obj)) return {};

    if (!Array.isArray(props)) {
      props = [props];
    }

    var res = {};
    props.forEach(function (prop) {
      if (prop in obj) {
        res[prop] = obj[prop];
      }
    });
    return res;
  }
  /**
   * deep merge two object without merging array
   * @param {object} target
   * @param {object} source
   */

  function mergeDeep(target, source) {
    if (!isObject(target)) {
      return {};
    }

    var result = target;

    if (isObject(source)) {
      Object.keys(source).forEach(function (key) {
        var value = source[key];

        if (isObject(value) && isObject(target[key])) {
          value = mergeDeep(target[key], value);
        }

        result = _objectSpread2({}, result, _defineProperty({}, key, value));
      });
    }

    return result;
  }

  function unwrapExports (x) {
  	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
  }

  function createCommonjsModule(fn, module) {
  	return module = { exports: {} }, fn(module, module.exports), module.exports;
  }

  var en = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;
  var locale = {
    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    weekdaysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    firstDayOfWeek: 0,
    firstWeekContainsDate: 1
  };
  var _default = locale;
  exports["default"] = _default;
  module.exports = exports.default;
  });

  var en$1 = unwrapExports(en);

  var lang = {
    formatLocale: en$1,
    yearFormat: 'YYYY',
    monthFormat: 'MMM',
    monthBeforeYear: true
  };

  var defaultLocale = 'en';
  var locales = {};
  locales[defaultLocale] = lang;
  function locale$1(name, object, isLocal) {
    if (typeof name !== 'string') return locales[defaultLocale];
    var l = defaultLocale;

    if (locales[name]) {
      l = name;
    }

    if (object) {
      locales[name] = object;
      l = name;
    }

    if (!isLocal) {
      defaultLocale = l;
    }

    return locales[name] || locales[defaultLocale];
  }
  /**
   * get locale object
   * @param {string} name lang
   */

  function getLocale(name) {
    return locale$1(name, null, true);
  }

  /* istanbul ignore file */
  function rafThrottle(fn) {
    var isRunning = false;
    return function fnBinfRaf() {
      var _this = this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (isRunning) return;
      isRunning = true;
      requestAnimationFrame(function () {
        isRunning = false;
        fn.apply(_this, args);
      });
    };
  }

  /**
   * get the hidden element width, height
   * @param {HTMLElement} element dom
   */
  function getPopupElementSize(element) {
    var originalDisplay = element.style.display;
    var originalVisibility = element.style.visibility;
    element.style.display = 'block';
    element.style.visibility = 'hidden';
    var styles = window.getComputedStyle(element);
    var width = element.offsetWidth + parseInt(styles.marginLeft, 10) + parseInt(styles.marginRight, 10);
    var height = element.offsetHeight + parseInt(styles.marginTop, 10) + parseInt(styles.marginBottom, 10);
    element.style.display = originalDisplay;
    element.style.visibility = originalVisibility;
    return {
      width: width,
      height: height
    };
  }
  /**
   * get the popup position
   * @param {HTMLElement} el relative element
   * @param {Number} targetWidth target element's width
   * @param {Number} targetHeight target element's height
   * @param {Boolean} fixed
   */

  function getRelativePosition(el, targetWidth, targetHeight, fixed) {
    var left = 0;
    var top = 0;
    var offsetX = 0;
    var offsetY = 0;
    var relativeRect = el.getBoundingClientRect();
    var dw = document.documentElement.clientWidth;
    var dh = document.documentElement.clientHeight;

    if (fixed) {
      offsetX = window.pageXOffset + relativeRect.left;
      offsetY = window.pageYOffset + relativeRect.top;
    }

    if (dw - relativeRect.left < targetWidth && relativeRect.right < targetWidth) {
      left = offsetX - relativeRect.left + 1;
    } else if (relativeRect.left + relativeRect.width / 2 <= dw / 2) {
      left = offsetX;
    } else {
      left = offsetX + relativeRect.width - targetWidth;
    }

    if (relativeRect.top <= targetHeight && dh - relativeRect.bottom <= targetHeight) {
      top = offsetY + dh - relativeRect.top - targetHeight;
    } else if (relativeRect.top + relativeRect.height / 2 <= dh / 2) {
      top = offsetY + relativeRect.height;
    } else {
      top = offsetY - targetHeight;
    }

    return {
      left: "".concat(left, "px"),
      top: "".concat(top, "px")
    };
  }
  function getScrollParent(node) {
    var until = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.body;

    if (!node || node === until) {
      return null;
    }

    var style = function style(value, prop) {
      return getComputedStyle(value, null).getPropertyValue(prop);
    };

    var regex = /(auto|scroll)/;
    var scroll = regex.test(style(node, 'overflow') + style(node, 'overflow-y') + style(node, 'overflow-x'));
    return scroll ? node : getScrollParent(node.parentNode, until);
  }

  //
  var script = {
    name: 'Popup',
    inject: {
      prefixClass: {
        default: 'mx'
      }
    },
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      appendToBody: {
        type: Boolean,
        default: true
      }
    },
    data: function data() {
      return {
        top: '',
        left: ''
      };
    },
    watch: {
      visible: {
        immediate: true,
        handler: function handler(val) {
          var _this = this;

          this.$nextTick(function () {
            if (val) {
              _this.displayPopup();
            }
          });
        }
      }
    },
    mounted: function mounted() {
      var _this2 = this;

      if (this.appendToBody) {
        document.body.appendChild(this.$el);
      }

      this._clickoutEvent = 'ontouchend' in document ? 'touchstart' : 'mousedown';
      document.addEventListener(this._clickoutEvent, this.handleClickOutside); // change the popup position when resize or scroll

      var relativeElement = this.$parent.$el;
      this._displayPopup = rafThrottle(function () {
        return _this2.displayPopup();
      });
      this._scrollParent = getScrollParent(relativeElement) || window;

      this._scrollParent.addEventListener('scroll', this._displayPopup);

      window.addEventListener('resize', this._displayPopup);
    },
    beforeDestroy: function beforeDestroy() {
      if (this.appendToBody && this.$el.parentNode) {
        this.$el.parentNode.removeChild(this.$el);
      }

      document.removeEventListener(this._clickoutEvent, this.handleClickOutside);

      this._scrollParent.removeEventListener('scroll', this._displayPopup);

      window.removeEventListener('resize', this._displayPopup);
    },
    methods: {
      handleClickOutside: function handleClickOutside(evt) {
        if (!this.visible) return;
        var target = evt.target;
        var el = this.$el;

        if (el && !el.contains(target)) {
          this.$emit('clickoutside', evt);
        }
      },
      displayPopup: function displayPopup() {
        if (!this.visible) return;
        var popup = this.$el;
        var relativeElement = this.$parent.$el;
        var appendToBody = this.appendToBody;

        if (!this._popupRect) {
          this._popupRect = getPopupElementSize(popup);
        }

        var _this$_popupRect = this._popupRect,
            width = _this$_popupRect.width,
            height = _this$_popupRect.height;

        var _getRelativePosition = getRelativePosition(relativeElement, width, height, appendToBody),
            left = _getRelativePosition.left,
            top = _getRelativePosition.top;

        this.left = left;
        this.top = top;
      }
    }
  };

  function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
  /* server only */
  , shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
      createInjectorSSR = createInjector;
      createInjector = shadowMode;
      shadowMode = false;
    } // Vue.extend constructor export interop.


    var options = typeof script === 'function' ? script.options : script; // render functions

    if (template && template.render) {
      options.render = template.render;
      options.staticRenderFns = template.staticRenderFns;
      options._compiled = true; // functional template

      if (isFunctionalTemplate) {
        options.functional = true;
      }
    } // scopedId


    if (scopeId) {
      options._scopeId = scopeId;
    }

    var hook;

    if (moduleIdentifier) {
      // server build
      hook = function hook(context) {
        // 2.3 injection
        context = context || // cached call
        this.$vnode && this.$vnode.ssrContext || // stateful
        this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
        // 2.2 with runInNewContext: true

        if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
          context = __VUE_SSR_CONTEXT__;
        } // inject component styles


        if (style) {
          style.call(this, createInjectorSSR(context));
        } // register component module identifier for async chunk inference


        if (context && context._registeredComponents) {
          context._registeredComponents.add(moduleIdentifier);
        }
      }; // used by ssr in case component is cached and beforeCreate
      // never gets called


      options._ssrRegister = hook;
    } else if (style) {
      hook = shadowMode ? function (context) {
        style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
      } : function (context) {
        style.call(this, createInjector(context));
      };
    }

    if (hook) {
      if (options.functional) {
        // register for functional component in vue file
        var originalRender = options.render;

        options.render = function renderWithStyleInjection(h, context) {
          hook.call(context);
          return originalRender(h, context);
        };
      } else {
        // inject component registration as beforeCreate hook
        var existing = options.beforeCreate;
        options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
      }
    }

    return script;
  }

  /* script */
  var __vue_script__ = script;
  /* template */

  var __vue_render__ = function __vue_render__() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('transition', {
      attrs: {
        "name": _vm.prefixClass + "-zoom-in-down"
      }
    }, [_vm.visible ? _c('div', {
      class: _vm.prefixClass + "-datepicker-main " + _vm.prefixClass + "-datepicker-popup",
      style: {
        top: _vm.top,
        left: _vm.left,
        position: 'absolute'
      }
    }, [_vm._t("default")], 2) : _vm._e()]);
  };

  var __vue_staticRenderFns__ = [];
  /* style */

  var __vue_inject_styles__ = undefined;
  /* scoped */

  var __vue_scope_id__ = undefined;
  /* module identifier */

  var __vue_module_identifier__ = undefined;
  /* functional template */

  var __vue_is_functional_template__ = false;
  /* style inject */

  /* style inject SSR */

  /* style inject shadow dom */

  var __vue_component__ = normalizeComponent({
    render: __vue_render__,
    staticRenderFns: __vue_staticRenderFns__
  }, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

  /* script */

  /* template */
  var __vue_render__$1 = function __vue_render__() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('svg', {
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 1024 1024",
        "width": "1em",
        "height": "1em"
      }
    }, [_c('path', {
      attrs: {
        "d": "M940.218182 107.054545h-209.454546V46.545455h-65.163636v60.50909H363.054545V46.545455H297.890909v60.50909H83.781818c-18.618182 0-32.581818 13.963636-32.581818 32.581819v805.236363c0 18.618182 13.963636 32.581818 32.581818 32.581818h861.090909c18.618182 0 32.581818-13.963636 32.581818-32.581818V139.636364c-4.654545-18.618182-18.618182-32.581818-37.236363-32.581819zM297.890909 172.218182V232.727273h65.163636V172.218182h307.2V232.727273h65.163637V172.218182h176.872727v204.8H116.363636V172.218182h181.527273zM116.363636 912.290909V442.181818h795.927273v470.109091H116.363636z"
      }
    })]);
  };

  var __vue_staticRenderFns__$1 = [];
  /* style */

  var __vue_inject_styles__$1 = undefined;
  /* scoped */

  var __vue_scope_id__$1 = undefined;
  /* module identifier */

  var __vue_module_identifier__$1 = undefined;
  /* functional template */

  var __vue_is_functional_template__$1 = false;
  /* style inject */

  /* style inject SSR */

  /* style inject shadow dom */

  var __vue_component__$1 = normalizeComponent({
    render: __vue_render__$1,
    staticRenderFns: __vue_staticRenderFns__$1
  }, __vue_inject_styles__$1, {}, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, undefined, undefined, undefined);

  /* script */

  /* template */
  var __vue_render__$2 = function __vue_render__() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('svg', {
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 24 24",
        "width": "1em",
        "height": "1em"
      }
    }, [_c('path', {
      attrs: {
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
      }
    })]);
  };

  var __vue_staticRenderFns__$2 = [];
  /* style */

  var __vue_inject_styles__$2 = undefined;
  /* scoped */

  var __vue_scope_id__$2 = undefined;
  /* module identifier */

  var __vue_module_identifier__$2 = undefined;
  /* functional template */

  var __vue_is_functional_template__$2 = false;
  /* style inject */

  /* style inject SSR */

  /* style inject shadow dom */

  var __vue_component__$2 = normalizeComponent({
    render: __vue_render__$2,
    staticRenderFns: __vue_staticRenderFns__$2
  }, __vue_inject_styles__$2, {}, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, false, undefined, undefined, undefined);

  /* script */

  /* template */
  var __vue_render__$3 = function __vue_render__() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('svg', {
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 1024 1024",
        "width": "1em",
        "height": "1em"
      }
    }, [_c('path', {
      attrs: {
        "d": "M810.005333 274.005333l-237.994667 237.994667 237.994667 237.994667-60.010667 60.010667-237.994667-237.994667-237.994667 237.994667-60.010667-60.010667 237.994667-237.994667-237.994667-237.994667 60.010667-60.010667 237.994667 237.994667 237.994667-237.994667z"
      }
    })]);
  };

  var __vue_staticRenderFns__$3 = [];
  /* style */

  var __vue_inject_styles__$3 = undefined;
  /* scoped */

  var __vue_scope_id__$3 = undefined;
  /* module identifier */

  var __vue_module_identifier__$3 = undefined;
  /* functional template */

  var __vue_is_functional_template__$3 = false;
  /* style inject */

  /* style inject SSR */

  /* style inject shadow dom */

  var __vue_component__$3 = normalizeComponent({
    render: __vue_render__$3,
    staticRenderFns: __vue_staticRenderFns__$3
  }, __vue_inject_styles__$3, {}, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, false, undefined, undefined, undefined);

  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  var script$1 = {
    props: {
      type: String
    },
    inject: {
      prefixClass: {
        default: 'mx'
      }
    }
  };

  /* script */
  var __vue_script__$1 = script$1;
  /* template */

  var __vue_render__$4 = function __vue_render__() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('button', _vm._g({
      class: _vm.prefixClass + "-btn " + _vm.prefixClass + "-btn-text " + _vm.prefixClass + "-btn-icon-" + _vm.type,
      attrs: {
        "type": "button"
      }
    }, _vm.$listeners), [_c('i', {
      class: _vm.prefixClass + "-icon-" + _vm.type
    })]);
  };

  var __vue_staticRenderFns__$4 = [];
  /* style */

  var __vue_inject_styles__$4 = undefined;
  /* scoped */

  var __vue_scope_id__$4 = undefined;
  /* module identifier */

  var __vue_module_identifier__$4 = undefined;
  /* functional template */

  var __vue_is_functional_template__$4 = false;
  /* style inject */

  /* style inject SSR */

  /* style inject shadow dom */

  var __vue_component__$4 = normalizeComponent({
    render: __vue_render__$4,
    staticRenderFns: __vue_staticRenderFns__$4
  }, __vue_inject_styles__$4, __vue_script__$1, __vue_scope_id__$4, __vue_is_functional_template__$4, __vue_module_identifier__$4, false, undefined, undefined, undefined);

  var script$2 = {
    name: 'TableDate',
    components: {
      IconButton: __vue_component__$4
    },
    inject: {
      getLocale: {
        default: function _default() {
          return getLocale;
        }
      },
      getWeek: {
        default: function _default() {
          return getWeek;
        }
      },
      prefixClass: {
        default: 'mx'
      },
      onDateMouseEnter: {
        default: undefined
      },
      onDateMouseLeave: {
        default: undefined
      }
    },
    props: {
      calendar: {
        type: Date,
        default: function _default() {
          return new Date();
        }
      },
      showWeekNumber: {
        type: Boolean,
        default: false
      },
      titleFormat: {
        type: String,
        default: 'YYYY-MM-DD'
      },
      getRowClasses: {
        type: Function,
        default: function _default() {
          return [];
        }
      },
      getCellClasses: {
        type: Function,
        default: function _default() {
          return [];
        }
      }
    },
    computed: {
      firstDayOfWeek: function firstDayOfWeek() {
        return this.getLocale().formatLocale.firstDayOfWeek || 0;
      },
      yearMonth: function yearMonth() {
        var _this$getLocale = this.getLocale(),
            yearFormat = _this$getLocale.yearFormat,
            monthBeforeYear = _this$getLocale.monthBeforeYear,
            _this$getLocale$month = _this$getLocale.monthFormat,
            monthFormat = _this$getLocale$month === void 0 ? 'MMM' : _this$getLocale$month;

        var yearLabel = {
          panel: 'year',
          label: this.formatDate(this.calendar, yearFormat)
        };
        var monthLabel = {
          panel: 'month',
          label: this.formatDate(this.calendar, monthFormat)
        };
        return monthBeforeYear ? [monthLabel, yearLabel] : [yearLabel, monthLabel];
      },
      days: function days() {
        var locale = this.getLocale();
        var days = locale.days || locale.formatLocale.weekdaysMin;
        return days.concat(days).slice(this.firstDayOfWeek, this.firstDayOfWeek + 7);
      },
      dates: function dates() {
        var year = this.calendar.getFullYear();
        var month = this.calendar.getMonth();
        var arr = getCalendar({
          firstDayOfWeek: this.firstDayOfWeek,
          year: year,
          month: month
        });
        return chunk(arr, 7);
      }
    },
    methods: {
      getNextCalendar: function getNextCalendar(diffMonth) {
        var year = this.calendar.getFullYear();
        var month = this.calendar.getMonth();
        return createDate$1(year, month + diffMonth);
      },
      handleIconLeftClick: function handleIconLeftClick() {
        this.$emit('changecalendar', this.getNextCalendar(-1), 'last-month');
      },
      handleIconRightClick: function handleIconRightClick() {
        this.$emit('changecalendar', this.getNextCalendar(1), 'next-month');
      },
      handleIconDoubleLeftClick: function handleIconDoubleLeftClick() {
        this.$emit('changecalendar', this.getNextCalendar(-12), 'last-year');
      },
      handleIconDoubleRightClick: function handleIconDoubleRightClick() {
        this.$emit('changecalendar', this.getNextCalendar(12), 'next-year');
      },
      handlePanelChange: function handlePanelChange(panel) {
        this.$emit('changepanel', panel);
      },
      handleMouseEnter: function handleMouseEnter(cell) {
        if (typeof this.onDateMouseEnter === 'function') {
          this.onDateMouseEnter(cell);
        }
      },
      handleMouseLeave: function handleMouseLeave(cell) {
        if (typeof this.onDateMouseLeave === 'function') {
          this.onDateMouseLeave(cell);
        }
      },
      handleCellClick: function handleCellClick(evt) {
        var target = evt.target;

        if (target.tagName.toUpperCase() === 'DIV') {
          target = target.parentNode;
        }

        var index = target.getAttribute('data-row-col');

        if (index) {
          var _index$split$map = index.split(',').map(function (v) {
            return parseInt(v, 10);
          }),
              _index$split$map2 = _slicedToArray(_index$split$map, 2),
              row = _index$split$map2[0],
              col = _index$split$map2[1];

          var date = this.dates[row][col];
          this.$emit('select', new Date(date));
        }
      },
      formatDate: function formatDate(date, fmt) {
        return format(date, fmt, {
          locale: this.getLocale().formatLocale
        });
      },
      getCellTitle: function getCellTitle(date) {
        var fmt = this.titleFormat;
        return this.formatDate(date, fmt);
      },
      getWeekNumber: function getWeekNumber(date) {
        return this.getWeek(date, this.getLocale().formatLocale);
      }
    }
  };

  /* script */
  var __vue_script__$2 = script$2;
  /* template */

  var __vue_render__$5 = function __vue_render__() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('div', {
      class: _vm.prefixClass + "-calendar " + _vm.prefixClass + "-calendar-panel-date"
    }, [_c('div', {
      class: _vm.prefixClass + "-calendar-header"
    }, [_c('icon-button', {
      attrs: {
        "type": "double-left"
      },
      on: {
        "click": _vm.handleIconDoubleLeftClick
      }
    }), _vm._v(" "), _c('icon-button', {
      attrs: {
        "type": "left"
      },
      on: {
        "click": _vm.handleIconLeftClick
      }
    }), _vm._v(" "), _c('icon-button', {
      attrs: {
        "type": "double-right"
      },
      on: {
        "click": _vm.handleIconDoubleRightClick
      }
    }), _vm._v(" "), _c('icon-button', {
      attrs: {
        "type": "right"
      },
      on: {
        "click": _vm.handleIconRightClick
      }
    }), _vm._v(" "), _c('span', {
      class: _vm.prefixClass + "-calendar-header-label"
    }, _vm._l(_vm.yearMonth, function (item) {
      return _c('button', {
        key: item.panel,
        class: _vm.prefixClass + "-btn " + _vm.prefixClass + "-btn-text " + _vm.prefixClass + "-btn-current-" + item.panel,
        attrs: {
          "type": "button"
        },
        on: {
          "click": function click($event) {
            return _vm.handlePanelChange(item.panel);
          }
        }
      }, [_vm._v("\n        " + _vm._s(item.label) + "\n      ")]);
    }), 0)], 1), _vm._v(" "), _c('div', {
      class: _vm.prefixClass + "-calendar-content"
    }, [_c('table', {
      class: _vm.prefixClass + "-table " + _vm.prefixClass + "-table-date"
    }, [_c('thead', [_c('tr', [_vm.showWeekNumber ? _c('th', {
      class: _vm.prefixClass + "-week-number-header"
    }) : _vm._e(), _vm._v(" "), _vm._l(_vm.days, function (day) {
      return _c('th', {
        key: day
      }, [_vm._v(_vm._s(day))]);
    })], 2)]), _vm._v(" "), _c('tbody', {
      on: {
        "click": _vm.handleCellClick
      }
    }, _vm._l(_vm.dates, function (row, i) {
      return _c('tr', {
        key: i,
        class: [_vm.prefixClass + "-date-row", _vm.getRowClasses(row)]
      }, [_vm.showWeekNumber ? _c('td', {
        class: _vm.prefixClass + "-week-number",
        attrs: {
          "data-row-col": i + ",0"
        }
      }, [_vm._v("\n            " + _vm._s(_vm.getWeekNumber(row[0])) + "\n          ")]) : _vm._e(), _vm._v(" "), _vm._l(row, function (cell, j) {
        return _c('td', {
          key: j,
          staticClass: "cell",
          class: _vm.getCellClasses(cell),
          attrs: {
            "data-row-col": i + "," + j,
            "title": _vm.getCellTitle(cell)
          },
          on: {
            "mouseenter": function mouseenter($event) {
              return _vm.handleMouseEnter(cell);
            },
            "mouseleave": function mouseleave($event) {
              return _vm.handleMouseLeave(cell);
            }
          }
        }, [_c('div', [_vm._v(_vm._s(cell.getDate()))])]);
      })], 2);
    }), 0)])])]);
  };

  var __vue_staticRenderFns__$5 = [];
  /* style */

  var __vue_inject_styles__$5 = undefined;
  /* scoped */

  var __vue_scope_id__$5 = undefined;
  /* module identifier */

  var __vue_module_identifier__$5 = undefined;
  /* functional template */

  var __vue_is_functional_template__$5 = false;
  /* style inject */

  /* style inject SSR */

  /* style inject shadow dom */

  var __vue_component__$5 = normalizeComponent({
    render: __vue_render__$5,
    staticRenderFns: __vue_staticRenderFns__$5
  }, __vue_inject_styles__$5, __vue_script__$2, __vue_scope_id__$5, __vue_is_functional_template__$5, __vue_module_identifier__$5, false, undefined, undefined, undefined);

  //
  var script$3 = {
    name: 'TableMonth',
    components: {
      IconButton: __vue_component__$4
    },
    inject: {
      getLocale: {
        default: function _default() {
          return getLocale;
        }
      },
      prefixClass: {
        default: 'mx'
      }
    },
    props: {
      calendar: {
        type: Date,
        default: function _default() {
          return new Date();
        }
      },
      getCellClasses: {
        type: Function,
        default: function _default() {
          return [];
        }
      }
    },
    computed: {
      calendarYear: function calendarYear() {
        return this.calendar.getFullYear();
      },
      months: function months() {
        var locale = this.getLocale();
        var monthsLocale = locale.months || locale.formatLocale.monthsShort;
        var months = monthsLocale.map(function (text, month) {
          return {
            text: text,
            month: month
          };
        });
        return chunk(months, 3);
      }
    },
    methods: {
      getNextCalendar: function getNextCalendar(diffYear) {
        var year = this.calendar.getFullYear();
        var month = this.calendar.getMonth();
        return createDate$1(year + diffYear, month);
      },
      handleIconDoubleLeftClick: function handleIconDoubleLeftClick() {
        this.$emit('changecalendar', this.getNextCalendar(-1), 'last-year');
      },
      handleIconDoubleRightClick: function handleIconDoubleRightClick() {
        this.$emit('changecalendar', this.getNextCalendar(1), 'next-year');
      },
      handlePanelChange: function handlePanelChange() {
        this.$emit('changepanel', 'year');
      },
      handleClick: function handleClick(evt) {
        var target = evt.target;

        if (target.tagName.toUpperCase() === 'DIV') {
          target = target.parentNode;
        }

        var month = target.getAttribute('data-month');

        if (month) {
          this.$emit('select', parseInt(month, 10));
        }
      }
    }
  };

  /* script */
  var __vue_script__$3 = script$3;
  /* template */

  var __vue_render__$6 = function __vue_render__() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('div', {
      class: _vm.prefixClass + "-calendar " + _vm.prefixClass + "-calendar-panel-month"
    }, [_c('div', {
      class: _vm.prefixClass + "-calendar-header"
    }, [_c('icon-button', {
      attrs: {
        "type": "double-left"
      },
      on: {
        "click": _vm.handleIconDoubleLeftClick
      }
    }), _vm._v(" "), _c('icon-button', {
      attrs: {
        "type": "double-right"
      },
      on: {
        "click": _vm.handleIconDoubleRightClick
      }
    }), _vm._v(" "), _c('span', {
      class: _vm.prefixClass + "-calendar-header-label"
    }, [_c('button', {
      class: _vm.prefixClass + "-btn " + _vm.prefixClass + "-btn-text",
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.handlePanelChange
      }
    }, [_vm._v("\n        " + _vm._s(_vm.calendarYear) + "\n      ")])])], 1), _vm._v(" "), _c('div', {
      class: _vm.prefixClass + "-calendar-content"
    }, [_c('table', {
      class: _vm.prefixClass + "-table " + _vm.prefixClass + "-table-month",
      on: {
        "click": _vm.handleClick
      }
    }, _vm._l(_vm.months, function (row, i) {
      return _c('tr', {
        key: i
      }, _vm._l(row, function (cell, j) {
        return _c('td', {
          key: j,
          staticClass: "cell",
          class: _vm.getCellClasses(cell.month),
          attrs: {
            "data-month": cell.month
          }
        }, [_c('div', [_vm._v(_vm._s(cell.text))])]);
      }), 0);
    }), 0)])]);
  };

  var __vue_staticRenderFns__$6 = [];
  /* style */

  var __vue_inject_styles__$6 = undefined;
  /* scoped */

  var __vue_scope_id__$6 = undefined;
  /* module identifier */

  var __vue_module_identifier__$6 = undefined;
  /* functional template */

  var __vue_is_functional_template__$6 = false;
  /* style inject */

  /* style inject SSR */

  /* style inject shadow dom */

  var __vue_component__$6 = normalizeComponent({
    render: __vue_render__$6,
    staticRenderFns: __vue_staticRenderFns__$6
  }, __vue_inject_styles__$6, __vue_script__$3, __vue_scope_id__$6, __vue_is_functional_template__$6, __vue_module_identifier__$6, false, undefined, undefined, undefined);

  //
  var script$4 = {
    name: 'TableYear',
    components: {
      IconButton: __vue_component__$4
    },
    inject: {
      prefixClass: {
        default: 'mx'
      }
    },
    props: {
      calendar: {
        type: Date,
        default: function _default() {
          return new Date();
        }
      },
      getCellClasses: {
        type: Function,
        default: function _default() {
          return [];
        }
      },
      getYearPanel: {
        type: Function
      }
    },
    computed: {
      years: function years() {
        var calendar = new Date(this.calendar);

        if (typeof this.getYearPanel === 'function') {
          return this.getYearPanel(calendar);
        }

        return this.getYears(calendar);
      },
      firstYear: function firstYear() {
        return this.years[0][0];
      },
      lastYear: function lastYear() {
        var last = function last(arr) {
          return arr[arr.length - 1];
        };

        return last(last(this.years));
      }
    },
    methods: {
      getYears: function getYears(calendar) {
        var firstYear = Math.floor(calendar.getFullYear() / 10) * 10;
        var years = [];

        for (var i = 0; i < 10; i++) {
          years.push(firstYear + i);
        }

        return chunk(years, 2);
      },
      getNextCalendar: function getNextCalendar(diffYear) {
        var year = this.calendar.getFullYear();
        var month = this.calendar.getMonth();
        return createDate$1(year + diffYear, month);
      },
      handleIconDoubleLeftClick: function handleIconDoubleLeftClick() {
        this.$emit('changecalendar', this.getNextCalendar(-10), 'last-decade');
      },
      handleIconDoubleRightClick: function handleIconDoubleRightClick() {
        this.$emit('changecalendar', this.getNextCalendar(10), 'next-decade');
      },
      handleClick: function handleClick(evt) {
        var target = evt.target;

        if (target.tagName.toUpperCase() === 'DIV') {
          target = target.parentNode;
        }

        var year = target.getAttribute('data-year');

        if (year) {
          this.$emit('select', parseInt(year, 10));
        }
      }
    }
  };

  /* script */
  var __vue_script__$4 = script$4;
  /* template */

  var __vue_render__$7 = function __vue_render__() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('div', {
      class: _vm.prefixClass + "-calendar " + _vm.prefixClass + "-calendar-panel-year"
    }, [_c('div', {
      class: _vm.prefixClass + "-calendar-header"
    }, [_c('icon-button', {
      attrs: {
        "type": "double-left"
      },
      on: {
        "click": _vm.handleIconDoubleLeftClick
      }
    }), _vm._v(" "), _c('icon-button', {
      attrs: {
        "type": "double-right"
      },
      on: {
        "click": _vm.handleIconDoubleRightClick
      }
    }), _vm._v(" "), _c('span', {
      class: _vm.prefixClass + "-calendar-header-label"
    }, [_c('span', [_vm._v(_vm._s(_vm.firstYear))]), _vm._v(" "), _c('span', {
      class: _vm.prefixClass + "-calendar-decade-separator"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lastYear))])])], 1), _vm._v(" "), _c('div', {
      class: _vm.prefixClass + "-calendar-content"
    }, [_c('table', {
      class: _vm.prefixClass + "-table " + _vm.prefixClass + "-table-year",
      on: {
        "click": _vm.handleClick
      }
    }, _vm._l(_vm.years, function (row, i) {
      return _c('tr', {
        key: i
      }, _vm._l(row, function (cell, j) {
        return _c('td', {
          key: j,
          staticClass: "cell",
          class: _vm.getCellClasses(cell),
          attrs: {
            "data-year": cell
          }
        }, [_c('div', [_vm._v(_vm._s(cell))])]);
      }), 0);
    }), 0)])]);
  };

  var __vue_staticRenderFns__$7 = [];
  /* style */

  var __vue_inject_styles__$7 = undefined;
  /* scoped */

  var __vue_scope_id__$7 = undefined;
  /* module identifier */

  var __vue_module_identifier__$7 = undefined;
  /* functional template */

  var __vue_is_functional_template__$7 = false;
  /* style inject */

  /* style inject SSR */

  /* style inject shadow dom */

  var __vue_component__$7 = normalizeComponent({
    render: __vue_render__$7,
    staticRenderFns: __vue_staticRenderFns__$7
  }, __vue_inject_styles__$7, __vue_script__$4, __vue_scope_id__$7, __vue_is_functional_template__$7, __vue_module_identifier__$7, false, undefined, undefined, undefined);

  var CalendarPanel = {
    name: 'CalendarPanel',
    inject: {
      prefixClass: {
        default: 'mx'
      },
      dispatchDatePicker: {
        default: function _default() {
          return function () {};
        }
      }
    },
    props: {
      value: {},
      defaultValue: {
        default: function _default() {
          var date = new Date();
          date.setHours(0, 0, 0, 0);
          return date;
        }
      },
      defaultPanel: {
        type: String
      },
      disabledDate: {
        type: Function,
        default: function _default() {
          return false;
        }
      },
      type: {
        type: String,
        default: 'date'
      },
      getClasses: {
        type: Function,
        default: function _default() {
          return [];
        }
      },
      showWeekNumber: {
        type: Boolean,
        default: undefined
      },
      getYearPanel: {
        type: Function
      },
      titleFormat: {
        type: String,
        default: 'YYYY-MM-DD'
      },
      calendar: Date,
      // update date when select year or month
      partialUpdate: {
        type: Boolean,
        default: false
      }
    },
    data: function data() {
      var panels = ['date', 'month', 'year'];
      var index = Math.max(panels.indexOf(this.type), panels.indexOf(this.defaultPanel));
      var panel = index !== -1 ? panels[index] : 'date';
      return {
        panel: panel,
        innerCalendar: new Date()
      };
    },
    computed: {
      innerValue: function innerValue() {
        var value = Array.isArray(this.value) ? this.value : [this.value];
        var map = {
          year: startOfYear,
          month: startOfMonth,
          date: startOfDay
        };
        var start = map[this.type] || map.date;
        return value.filter(isValidDate$1).map(function (v) {
          return start(v);
        });
      },
      calendarYear: function calendarYear() {
        return this.innerCalendar.getFullYear();
      },
      calendarMonth: function calendarMonth() {
        return this.innerCalendar.getMonth();
      }
    },
    watch: {
      value: {
        immediate: true,
        handler: 'initCalendar'
      },
      calendar: {
        handler: 'initCalendar'
      },
      defaultValue: {
        handler: 'initCalendar'
      }
    },
    methods: {
      initCalendar: function initCalendar() {
        var calendarDate = this.calendar;

        if (!isValidDate$1(calendarDate)) {
          var length = this.innerValue.length;
          calendarDate = getValidDate(length > 0 ? this.innerValue[length - 1] : this.defaultValue);
        }

        this.innerCalendar = startOfMonth(calendarDate);
      },
      isDisabled: function isDisabled(date) {
        return this.disabledDate(new Date(date), this.innerValue);
      },
      emitDate: function emitDate(date, type) {
        if (!this.isDisabled(date)) {
          this.$emit('select', date, type, this.innerValue); // someone need get the first selected date to set range value. (#429)

          this.dispatchDatePicker('pick', date, type);
        }
      },
      handleCalendarChange: function handleCalendarChange(calendar, type) {
        var oldCalendar = new Date(this.innerCalendar);
        this.innerCalendar = calendar;
        this.$emit('update:calendar', calendar);
        this.dispatchDatePicker('calendar-change', calendar, oldCalendar, type);
      },
      handelPanelChange: function handelPanelChange(panel) {
        var oldPanel = this.panel;
        this.panel = panel;
        this.dispatchDatePicker('panel-change', panel, oldPanel);
      },
      handleSelectYear: function handleSelectYear(year) {
        if (this.type === 'year') {
          var date = this.getYearCellDate(year);
          this.emitDate(date, 'year');
        } else {
          this.handleCalendarChange(createDate$1(year, this.calendarMonth), 'year');
          this.handelPanelChange('month');

          if (this.partialUpdate && this.innerValue.length === 1) {
            var _date = new Date(this.innerValue[0]);

            _date.setFullYear(year);

            this.emitDate(_date, 'year');
          }
        }
      },
      handleSelectMonth: function handleSelectMonth(month) {
        if (this.type === 'month') {
          var date = this.getMonthCellDate(month);
          this.emitDate(date, 'month');
        } else {
          this.handleCalendarChange(createDate$1(this.calendarYear, month), 'month');
          this.handelPanelChange('date');

          if (this.partialUpdate && this.innerValue.length === 1) {
            var _date2 = new Date(this.innerValue[0]);

            _date2.setFullYear(this.calendarYear);

            this.emitDate(setMonth(_date2, month), 'month');
          }
        }
      },
      handleSelectDate: function handleSelectDate(date) {
        this.emitDate(date, this.type === 'week' ? 'week' : 'date');
      },
      getMonthCellDate: function getMonthCellDate(month) {
        return createDate$1(this.calendarYear, month);
      },
      getYearCellDate: function getYearCellDate(year) {
        return createDate$1(year, 0);
      },
      getDateClasses: function getDateClasses(cellDate) {
        var notCurrentMonth = cellDate.getMonth() !== this.calendarMonth;
        var classes = [];

        if (cellDate.getTime() === new Date().setHours(0, 0, 0, 0)) {
          classes.push('today');
        }

        if (notCurrentMonth) {
          classes.push('not-current-month');
        }

        var state = this.getStateClass(cellDate);

        if (!(state === 'active' && notCurrentMonth)) {
          classes.push(state);
        }

        return classes.concat(this.getClasses(cellDate, this.innerValue, classes.join(' ')));
      },
      getMonthClasses: function getMonthClasses(month) {
        if (this.type !== 'month') {
          return this.calendarMonth === month ? 'active' : '';
        }

        var classes = [];
        var cellDate = this.getMonthCellDate(month);
        classes.push(this.getStateClass(cellDate));
        return classes.concat(this.getClasses(cellDate, this.innerValue, classes.join(' ')));
      },
      getYearClasses: function getYearClasses(year) {
        if (this.type !== 'year') {
          return this.calendarYear === year ? 'active' : '';
        }

        var classes = [];
        var cellDate = this.getYearCellDate(year);
        classes.push(this.getStateClass(cellDate));
        return classes.concat(this.getClasses(cellDate, this.innerValue, classes.join(' ')));
      },
      getStateClass: function getStateClass(cellDate) {
        if (this.isDisabled(cellDate)) {
          return 'disabled';
        }

        if (this.innerValue.some(function (v) {
          return v.getTime() === cellDate.getTime();
        })) {
          return 'active';
        }

        return '';
      },
      getWeekState: function getWeekState(row) {
        if (this.type !== 'week') return '';
        var start = row[0].getTime();
        var end = row[6].getTime();
        var active = this.innerValue.some(function (v) {
          var time = v.getTime();
          return time >= start && time <= end;
        });
        return active ? "".concat(this.prefixClass, "-active-week") : '';
      }
    },
    render: function render() {
      var h = arguments[0];
      var panel = this.panel,
          innerCalendar = this.innerCalendar;

      if (panel === 'year') {
        return h(__vue_component__$7, {
          "attrs": {
            "calendar": innerCalendar,
            "getCellClasses": this.getYearClasses,
            "getYearPanel": this.getYearPanel
          },
          "on": {
            "select": this.handleSelectYear,
            "changecalendar": this.handleCalendarChange
          }
        });
      }

      if (panel === 'month') {
        return h(__vue_component__$6, {
          "attrs": {
            "calendar": innerCalendar,
            "getCellClasses": this.getMonthClasses
          },
          "on": {
            "select": this.handleSelectMonth,
            "changepanel": this.handelPanelChange,
            "changecalendar": this.handleCalendarChange
          }
        });
      }

      return h(__vue_component__$5, {
        "class": _defineProperty({}, "".concat(this.prefixClass, "-calendar-week-mode"), this.type === 'week'),
        "attrs": {
          "calendar": innerCalendar,
          "getCellClasses": this.getDateClasses,
          "getRowClasses": this.getWeekState,
          "titleFormat": this.titleFormat,
          "showWeekNumber": typeof this.showWeekNumber === 'boolean' ? this.showWeekNumber : this.type === 'week'
        },
        "on": {
          "select": this.handleSelectDate,
          "changepanel": this.handelPanelChange,
          "changecalendar": this.handleCalendarChange
        }
      });
    }
  };

  var CalendarRange = {
    name: 'CalendarRange',
    components: {
      CalendarPanel: CalendarPanel
    },
    provide: function provide() {
      return {
        onDateMouseEnter: this.onDateMouseEnter,
        onDateMouseLeave: this.onDateMouseLeave
      };
    },
    inject: {
      prefixClass: {
        default: 'mx'
      }
    },
    props: _objectSpread2({}, CalendarPanel.props),
    data: function data() {
      return {
        innerValue: [],
        calendars: [],
        hoveredValue: null
      };
    },
    computed: {
      // Minimum difference between start and end calendars
      calendarMinDiff: function calendarMinDiff() {
        var map = {
          date: 1,
          // type:date  min 1 month
          month: 1 * 12,
          // type:month min 1 year
          year: 10 * 12 // type:year  min 10 year

        };
        return map[this.type] || map.date;
      },
      calendarMaxDiff: function calendarMaxDiff() {
        return Infinity;
      },
      defaultValues: function defaultValues() {
        return Array.isArray(this.defaultValue) ? this.defaultValue : [this.defaultValue, this.defaultValue];
      }
    },
    watch: {
      value: {
        immediate: true,
        handler: function handler() {
          var _this = this;

          this.innerValue = isValidRangeDate(this.value) ? this.value : [new Date(NaN), new Date(NaN)];
          var calendars = this.innerValue.map(function (v, i) {
            return startOfMonth(getValidDate(v, _this.defaultValues[i]));
          });
          this.updateCalendars(calendars);
        }
      }
    },
    methods: {
      handleSelect: function handleSelect(date, type) {
        var _this$innerValue = _slicedToArray(this.innerValue, 2),
            startValue = _this$innerValue[0],
            endValue = _this$innerValue[1];

        if (isValidDate$1(startValue) && !isValidDate$1(endValue)) {
          if (startValue.getTime() > date.getTime()) {
            this.innerValue = [date, startValue];
          } else {
            this.innerValue = [startValue, date];
          }

          this.emitDate(this.innerValue, type);
        } else {
          this.innerValue = [date, new Date(NaN)];
        }
      },
      onDateMouseEnter: function onDateMouseEnter(cell) {
        this.hoveredValue = cell;
      },
      onDateMouseLeave: function onDateMouseLeave() {
        this.hoveredValue = null;
      },
      emitDate: function emitDate(dates, type) {
        this.$emit('select', dates, type);
      },
      updateStartCalendar: function updateStartCalendar(value) {
        this.updateCalendars([value, this.calendars[1]], 1);
      },
      updateEndCalendar: function updateEndCalendar(value) {
        this.updateCalendars([this.calendars[0], value], 0);
      },
      updateCalendars: function updateCalendars(calendars) {
        var adjustIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        var gap = this.getCalendarGap(calendars);

        if (gap) {
          var calendar = new Date(calendars[adjustIndex]);
          calendar.setMonth(calendar.getMonth() + (adjustIndex === 0 ? -gap : gap));
          calendars[adjustIndex] = calendar;
        }

        this.calendars = calendars;
      },
      getCalendarGap: function getCalendarGap(calendars) {
        var _calendars = _slicedToArray(calendars, 2),
            calendarLeft = _calendars[0],
            calendarRight = _calendars[1];

        var yearDiff = calendarRight.getFullYear() - calendarLeft.getFullYear();
        var monthDiff = calendarRight.getMonth() - calendarLeft.getMonth();
        var diff = yearDiff * 12 + monthDiff;
        var min = this.calendarMinDiff;
        var max = this.calendarMaxDiff;

        if (diff < min) {
          return min - diff;
        }

        if (diff > max) {
          return max - diff;
        }

        return 0;
      },
      getRangeClasses: function getRangeClasses(cellDate, currentDates, classnames) {
        var classes = [].concat(this.getClasses(cellDate, currentDates, classnames));
        if (/disabled|active/.test(classnames)) return classes;

        var inRange = function inRange(data, range) {
          var fn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (v) {
            return v.getTime();
          };
          var value = fn(data);

          var _range$map = range.map(fn),
              _range$map2 = _slicedToArray(_range$map, 2),
              min = _range$map2[0],
              max = _range$map2[1];

          if (min > max) {
            var _ref = [max, min];
            min = _ref[0];
            max = _ref[1];
          }

          return value > min && value < max;
        };

        if (currentDates.length === 2 && inRange(cellDate, currentDates)) {
          return classes.concat('in-range');
        }

        if (currentDates.length === 1 && this.hoveredValue && inRange(cellDate, [currentDates[0], this.hoveredValue])) {
          return classes.concat('hover-in-range');
        }

        return classes;
      }
    },
    render: function render() {
      var _this2 = this;

      var h = arguments[0];
      var calendarRange = this.calendars.map(function (calendar, index) {
        var props = _objectSpread2({}, _this2.$props, {
          calendar: calendar,
          value: _this2.innerValue,
          defaultValue: _this2.defaultValues[index],
          getClasses: _this2.getRangeClasses,
          // don't update when range is true
          partialUpdate: false
        });

        var on = {
          select: _this2.handleSelect,
          'update:calendar': index === 0 ? _this2.updateStartCalendar : _this2.updateEndCalendar
        };
        return h("calendar-panel", {
          "props": _objectSpread2({}, props),
          "on": _objectSpread2({}, on)
        });
      });
      var prefixClass = this.prefixClass;
      return h("div", {
        "class": "".concat(prefixClass, "-range-wrapper")
      }, [calendarRange]);
    }
  };

  var scrollBarWidth;
  function getScrollbarWidth () {
    if (typeof window === 'undefined') return 0;
    if (scrollBarWidth !== undefined) return scrollBarWidth;
    var outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll';
    outer.style.width = '100px';
    outer.style.position = 'absolute';
    outer.style.top = '-9999px';
    document.body.appendChild(outer);
    var inner = document.createElement('div');
    inner.style.width = '100%';
    outer.appendChild(inner);
    scrollBarWidth = outer.offsetWidth - inner.offsetWidth;
    outer.parentNode.removeChild(outer);
    return scrollBarWidth;
  }

  //
  var script$5 = {
    inject: {
      prefixClass: {
        default: 'mx'
      }
    },
    data: function data() {
      return {
        scrollbarWidth: 0,
        thumbTop: '',
        thumbHeight: ''
      };
    },
    created: function created() {
      this.scrollbarWidth = getScrollbarWidth();
      document.addEventListener('mouseup', this.handleDragend);
    },
    beforeDestroy: function beforeDestroy() {
      document.addEventListener('mouseup', this.handleDragend);
    },
    mounted: function mounted() {
      this.$nextTick(this.getThumbSize);
    },
    methods: {
      getThumbSize: function getThumbSize() {
        var wrap = this.$refs.wrap;
        if (!wrap) return;
        var heightPercentage = wrap.clientHeight * 100 / wrap.scrollHeight;
        this.thumbHeight = heightPercentage < 100 ? "".concat(heightPercentage, "%") : '';
      },
      handleScroll: function handleScroll(evt) {
        var el = evt.currentTarget;
        var scrollHeight = el.scrollHeight,
            scrollTop = el.scrollTop;
        this.thumbTop = "".concat(scrollTop * 100 / scrollHeight, "%");
      },
      handleDragstart: function handleDragstart(evt) {
        evt.stopImmediatePropagation();
        this._draggable = true;
        var offsetTop = this.$refs.thumb.offsetTop;
        this._prevY = evt.clientY - offsetTop;
        document.addEventListener('mousemove', this.handleDraging);
      },
      handleDraging: function handleDraging(evt) {
        if (!this._draggable) return;
        var clientY = evt.clientY;
        var wrap = this.$refs.wrap;
        var scrollHeight = wrap.scrollHeight,
            clientHeight = wrap.clientHeight;
        var offsetY = clientY - this._prevY;
        var top = offsetY * scrollHeight / clientHeight;
        wrap.scrollTop = top;
      },
      handleDragend: function handleDragend() {
        if (this._draggable) {
          this._draggable = false;
          document.removeEventListener('mousemove', this.handleDraging);
        }
      }
    }
  };

  /* script */
  var __vue_script__$5 = script$5;
  /* template */

  var __vue_render__$8 = function __vue_render__() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('div', {
      class: _vm.prefixClass + "-scrollbar",
      style: {
        position: 'relative',
        overflow: 'hidden'
      }
    }, [_c('div', {
      ref: "wrap",
      class: _vm.prefixClass + "-scrollbar-wrap",
      style: {
        marginRight: "-" + _vm.scrollbarWidth + "px"
      },
      on: {
        "scroll": _vm.handleScroll
      }
    }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
      class: _vm.prefixClass + "-scrollbar-track"
    }, [_c('div', {
      ref: "thumb",
      class: _vm.prefixClass + "-scrollbar-thumb",
      style: {
        height: _vm.thumbHeight,
        top: _vm.thumbTop
      },
      on: {
        "mousedown": _vm.handleDragstart
      }
    })])]);
  };

  var __vue_staticRenderFns__$8 = [];
  /* style */

  var __vue_inject_styles__$8 = undefined;
  /* scoped */

  var __vue_scope_id__$8 = undefined;
  /* module identifier */

  var __vue_module_identifier__$8 = undefined;
  /* functional template */

  var __vue_is_functional_template__$8 = false;
  /* style inject */

  /* style inject SSR */

  /* style inject shadow dom */

  var __vue_component__$8 = normalizeComponent({
    render: __vue_render__$8,
    staticRenderFns: __vue_staticRenderFns__$8
  }, __vue_inject_styles__$8, __vue_script__$5, __vue_scope_id__$8, __vue_is_functional_template__$8, __vue_module_identifier__$8, false, undefined, undefined, undefined);

  //

  var padNumber = function padNumber(value) {
    value = parseInt(value, 10);
    return value < 10 ? "0".concat(value) : "".concat(value);
  };

  var generateOptions = function generateOptions(length, step, options) {
    if (Array.isArray(options)) {
      return options.filter(function (v) {
        return v >= 0 && v < length;
      });
    }

    if (step <= 0) {
      step = 1;
    }

    var arr = [];

    for (var i = 0; i < length; i += step) {
      arr.push(i);
    }

    return arr;
  };

  var scrollTo = function scrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    // jump to target if duration zero
    if (duration <= 0) {
      requestAnimationFrame(function () {
        element.scrollTop = to;
      });
      return;
    }

    var difference = to - element.scrollTop;
    var tick = difference / duration * 10;
    requestAnimationFrame(function () {
      var scrollTop = element.scrollTop + tick;

      if (scrollTop >= to) {
        element.scrollTop = to;
        return;
      }

      element.scrollTop = scrollTop;
      scrollTo(element, to, duration - 10);
    });
  };

  var script$6 = {
    name: 'ListColumns',
    components: {
      ScrollbarVertical: __vue_component__$8
    },
    inject: {
      prefixClass: {
        default: 'mx'
      }
    },
    props: {
      date: Date,
      scrollDuration: {
        type: Number,
        default: 100
      },
      getClasses: {
        type: Function,
        default: function _default() {
          return [];
        }
      },
      hourOptions: Array,
      minuteOptions: Array,
      secondOptions: Array,
      showHour: {
        type: Boolean,
        default: true
      },
      showMinute: {
        type: Boolean,
        default: true
      },
      showSecond: {
        type: Boolean,
        default: true
      },
      hourStep: {
        type: Number,
        default: 1
      },
      minuteStep: {
        type: Number,
        default: 1
      },
      secondStep: {
        type: Number,
        default: 1
      },
      use12h: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      columns: function columns() {
        var cols = [];
        if (this.showHour) cols.push({
          type: 'hour',
          list: this.getHoursList()
        });
        if (this.showMinute) cols.push({
          type: 'minute',
          list: this.getMinutesList()
        });
        if (this.showSecond) cols.push({
          type: 'second',
          list: this.getSecondsList()
        });
        if (this.use12h) cols.push({
          type: 'ampm',
          list: this.getAMPMList()
        });
        return cols.filter(function (v) {
          return v.list.length > 0;
        });
      }
    },
    watch: {
      date: {
        handler: function handler() {
          var _this = this;

          this.$nextTick(function () {
            _this.scrollToSelected(_this.scrollDuration);
          });
        }
      }
    },
    mounted: function mounted() {
      this.scrollToSelected(0);
    },
    methods: {
      getHoursList: function getHoursList() {
        var _this2 = this;

        return generateOptions(this.use12h ? 12 : 24, this.hourStep, this.hourOptions).map(function (num) {
          var date = new Date(_this2.date);
          var text = padNumber(num);

          if (_this2.use12h) {
            if (num === 0) {
              text = '12';
            }

            if (date.getHours() >= 12) {
              num += 12;
            }
          }

          var value = date.setHours(num);
          return {
            value: value,
            text: text
          };
        });
      },
      getMinutesList: function getMinutesList() {
        var _this3 = this;

        return generateOptions(60, this.minuteStep, this.minuteOptions).map(function (num) {
          var value = new Date(_this3.date).setMinutes(num);
          return {
            value: value,
            text: padNumber(num)
          };
        });
      },
      getSecondsList: function getSecondsList() {
        var _this4 = this;

        return generateOptions(60, this.secondStep, this.secondOptions).map(function (num) {
          var value = new Date(_this4.date).setSeconds(num);
          return {
            value: value,
            text: padNumber(num)
          };
        });
      },
      getAMPMList: function getAMPMList() {
        var _this5 = this;

        return ['AM', 'PM'].map(function (text, i) {
          var date = new Date(_this5.date);
          var value = date.setHours(date.getHours() % 12 + i * 12);
          return {
            text: text,
            value: value
          };
        });
      },
      scrollToSelected: function scrollToSelected(duration) {
        var elements = this.$el.querySelectorAll('.active');

        for (var i = 0; i < elements.length; i++) {
          var element = elements[i];
          var scrollElement = getScrollParent(element, this.$el);

          if (scrollElement) {
            var to = element.offsetTop;
            scrollTo(scrollElement, to, duration);
          }
        }
      },
      handleSelect: function handleSelect(evt) {
        var target = evt.target,
            currentTarget = evt.currentTarget;
        if (target.tagName.toUpperCase() !== 'LI') return;
        var type = currentTarget.getAttribute('data-type');
        var colIndex = parseInt(currentTarget.getAttribute('data-index'), 10);
        var cellIndex = parseInt(target.getAttribute('data-index'), 10);
        var value = this.columns[colIndex].list[cellIndex].value;
        this.$emit('select', value, type);
      }
    }
  };

  /* script */
  var __vue_script__$6 = script$6;
  /* template */

  var __vue_render__$9 = function __vue_render__() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('div', {
      class: _vm.prefixClass + "-time-columns"
    }, _vm._l(_vm.columns, function (col, i) {
      return _c('scrollbar-vertical', {
        key: i,
        class: _vm.prefixClass + "-time-column"
      }, [_c('ul', {
        class: _vm.prefixClass + "-time-list",
        attrs: {
          "data-type": col.type,
          "data-index": i
        },
        on: {
          "click": _vm.handleSelect
        }
      }, _vm._l(col.list, function (item, j) {
        return _c('li', {
          key: item.value,
          class: [_vm.prefixClass + "-time-item", _vm.getClasses(item.value, col.type)],
          attrs: {
            "data-index": j
          }
        }, [_vm._v("\n        " + _vm._s(item.text) + "\n      ")]);
      }), 0)]);
    }), 1);
  };

  var __vue_staticRenderFns__$9 = [];
  /* style */

  var __vue_inject_styles__$9 = undefined;
  /* scoped */

  var __vue_scope_id__$9 = undefined;
  /* module identifier */

  var __vue_module_identifier__$9 = undefined;
  /* functional template */

  var __vue_is_functional_template__$9 = false;
  /* style inject */

  /* style inject SSR */

  /* style inject shadow dom */

  var __vue_component__$9 = normalizeComponent({
    render: __vue_render__$9,
    staticRenderFns: __vue_staticRenderFns__$9
  }, __vue_inject_styles__$9, __vue_script__$6, __vue_scope_id__$9, __vue_is_functional_template__$9, __vue_module_identifier__$9, false, undefined, undefined, undefined);

  //

  function parseOption() {
    var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var values = time.split(':');

    if (values.length >= 2) {
      var hours = parseInt(values[0], 10);
      var minutes = parseInt(values[1], 10);
      return {
        hours: hours,
        minutes: minutes
      };
    }

    return null;
  }

  var scrollTo$1 = function scrollTo(element, to) {
    if (element) {
      element.scrollTop = to;
    }
  };

  var script$7 = {
    name: 'ListOptions',
    components: {
      ScrollbarVertical: __vue_component__$8
    },
    inject: {
      getLocale: {
        default: function _default() {
          return getLocale;
        }
      },
      prefixClass: {
        default: 'mx'
      }
    },
    props: {
      date: Date,
      options: {
        type: [Object, Function],
        default: function _default() {
          return [];
        }
      },
      format: {
        type: String,
        default: 'HH:mm:ss'
      },
      getClasses: {
        type: Function,
        default: function _default() {
          return [];
        }
      }
    },
    computed: {
      list: function list() {
        var result = [];
        var options = this.options;

        if (typeof options === 'function') {
          return options() || [];
        }

        var start = parseOption(options.start);
        var end = parseOption(options.end);
        var step = parseOption(options.step);
        var fmt = options.format || this.format;

        if (start && end && step) {
          var startMinutes = start.minutes + start.hours * 60;
          var endMinutes = end.minutes + end.hours * 60;
          var stepMinutes = step.minutes + step.hours * 60;
          var len = Math.floor((endMinutes - startMinutes) / stepMinutes);

          for (var i = 0; i <= len; i++) {
            var timeMinutes = startMinutes + i * stepMinutes;
            var hours = Math.floor(timeMinutes / 60);
            var minutes = timeMinutes % 60;
            var value = new Date(this.date).setHours(hours, minutes, 0);
            result.push({
              value: value,
              text: this.formatDate(value, fmt)
            });
          }
        }

        return result;
      }
    },
    mounted: function mounted() {
      this.scrollToSelected();
    },
    methods: {
      formatDate: function formatDate(date, fmt) {
        return format(date, fmt, {
          locale: this.getLocale().formatLocale
        });
      },
      scrollToSelected: function scrollToSelected() {
        var element = this.$el.querySelector('.active');
        if (!element) return;
        var scrollElement = getScrollParent(element, this.$el);
        if (!scrollElement) return;
        var to = element.offsetTop;
        scrollTo$1(scrollElement, to);
      },
      handleSelect: function handleSelect(value) {
        this.$emit('select', value, 'time');
      }
    }
  };

  /* script */
  var __vue_script__$7 = script$7;
  /* template */

  var __vue_render__$a = function __vue_render__() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('scrollbar-vertical', _vm._l(_vm.list, function (item) {
      return _c('div', {
        key: item.value,
        class: [_vm.prefixClass + "-time-option", _vm.getClasses(item.value)],
        on: {
          "click": function click($event) {
            return _vm.handleSelect(item.value);
          }
        }
      }, [_vm._v("\n    " + _vm._s(item.text) + "\n  ")]);
    }), 0);
  };

  var __vue_staticRenderFns__$a = [];
  /* style */

  var __vue_inject_styles__$a = undefined;
  /* scoped */

  var __vue_scope_id__$a = undefined;
  /* module identifier */

  var __vue_module_identifier__$a = undefined;
  /* functional template */

  var __vue_is_functional_template__$a = false;
  /* style inject */

  /* style inject SSR */

  /* style inject shadow dom */

  var __vue_component__$a = normalizeComponent({
    render: __vue_render__$a,
    staticRenderFns: __vue_staticRenderFns__$a
  }, __vue_inject_styles__$a, __vue_script__$7, __vue_scope_id__$a, __vue_is_functional_template__$a, __vue_module_identifier__$a, false, undefined, undefined, undefined);

  //
  var script$8 = {
    name: 'TimePanel',
    components: {
      ListColumns: __vue_component__$9,
      ListOptions: __vue_component__$a
    },
    inject: {
      getLocale: {
        default: function _default() {
          return getLocale;
        }
      },
      prefixClass: {
        default: 'mx'
      }
    },
    props: {
      value: {},
      defaultValue: {
        default: function _default() {
          var date = new Date();
          date.setHours(0, 0, 0, 0);
          return date;
        }
      },
      format: {
        default: 'HH:mm:ss'
      },
      timeTitleFormat: {
        type: String,
        default: 'YYYY-MM-DD'
      },
      showTimeHeader: {
        type: Boolean,
        default: false
      },
      disabledTime: {
        type: Function,
        default: function _default() {
          return false;
        }
      },
      timePickerOptions: {
        type: [Object, Function],
        default: function _default() {
          return null;
        }
      },
      hourOptions: Array,
      minuteOptions: Array,
      secondOptions: Array,
      hourStep: {
        type: Number,
        default: 1
      },
      minuteStep: {
        type: Number,
        default: 1
      },
      secondStep: {
        type: Number,
        default: 1
      },
      showHour: {
        type: Boolean,
        default: undefined
      },
      showMinute: {
        type: Boolean,
        default: undefined
      },
      showSecond: {
        type: Boolean,
        default: undefined
      },
      use12h: {
        type: Boolean,
        default: undefined
      },
      scrollDuration: {
        type: Number,
        default: 100
      }
    },
    data: function data() {
      return {
        innerValue: getValidDate(this.value, this.defaultValue)
      };
    },
    computed: {
      title: function title() {
        var titleFormat = this.timeTitleFormat;
        var date = new Date(this.innerValue);
        return this.formatDate(date, titleFormat);
      },
      innerForamt: function innerForamt() {
        return typeof this.format === 'string' ? this.format : 'HH:mm:ss';
      },
      ShowHourMinuteSecondAMPM: function ShowHourMinuteSecondAMPM() {
        var _this = this;

        var fmt = this.innerForamt;
        var defaultProps = {
          showHour: /[HhKk]/.test(fmt),
          showMinute: /m/.test(fmt),
          showSecond: /s/.test(fmt),
          use12h: /a/i.test(fmt)
        };
        var obj = {};
        Object.keys(defaultProps).forEach(function (key) {
          obj[key] = typeof _this[key] === 'boolean' ? _this[key] : defaultProps[key];
        });
        return obj;
      }
    },
    watch: {
      value: {
        immediate: true,
        handler: function handler() {
          this.innerValue = getValidDate(this.value, this.defaultValue);
        }
      }
    },
    methods: {
      formatDate: function formatDate(date, fmt) {
        return format(date, fmt, {
          locale: this.getLocale().formatLocale
        });
      },
      isDisabledTime: function isDisabledTime(value) {
        return this.disabledTime(new Date(value));
      },
      isDisabledHour: function isDisabledHour(date) {
        var value = new Date(date);
        return this.isDisabledTime(value) && this.isDisabledTime(value.setMinutes(0, 0, 0)) && this.isDisabledTime(value.setMinutes(59, 59, 999));
      },
      isDisabledMinute: function isDisabledMinute(date) {
        var value = new Date(date);
        return this.isDisabledTime(value) && this.isDisabledTime(value.setSeconds(0, 0)) && this.isDisabledTime(value.setSeconds(59, 999));
      },
      isDisabled: function isDisabled(date, type) {
        if (type === 'hour') {
          return this.isDisabledHour(date);
        }

        if (type === 'minute') {
          return this.isDisabledMinute(date);
        }

        return this.isDisabledTime(date);
      },
      handleSelect: function handleSelect(value, type) {
        var date = new Date(value);

        if (!this.isDisabled(value, type)) {
          this.innerValue = date;

          if (!this.isDisabledTime(date)) {
            this.$emit('select', date, type);
          }
        }
      },
      handleClickTitle: function handleClickTitle() {
        this.$emit('clicktitle');
      },
      getClasses: function getClasses(value, type) {
        var cellDate = new Date(value);

        if (this.isDisabled(value, type)) {
          return 'disabled';
        }

        if (cellDate.getTime() === this.innerValue.getTime()) {
          return 'active';
        }

        return '';
      }
    }
  };

  /* script */
  var __vue_script__$8 = script$8;
  /* template */

  var __vue_render__$b = function __vue_render__() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('div', {
      class: _vm.prefixClass + "-time"
    }, [_vm.showTimeHeader ? _c('div', {
      class: _vm.prefixClass + "-time-header"
    }, [_c('button', {
      class: _vm.prefixClass + "-btn " + _vm.prefixClass + "-btn-text " + _vm.prefixClass + "-time-header-title",
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.handleClickTitle
      }
    }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
      class: _vm.prefixClass + "-time-content"
    }, [_vm.timePickerOptions ? _c('list-options', {
      attrs: {
        "date": _vm.innerValue,
        "get-classes": _vm.getClasses,
        "options": _vm.timePickerOptions,
        "format": _vm.innerForamt
      },
      on: {
        "select": _vm.handleSelect
      }
    }) : _c('list-columns', _vm._b({
      attrs: {
        "date": _vm.innerValue,
        "get-classes": _vm.getClasses,
        "hour-options": _vm.hourOptions,
        "minute-options": _vm.minuteOptions,
        "second-options": _vm.secondOptions,
        "hour-step": _vm.hourStep,
        "minute-step": _vm.minuteStep,
        "second-step": _vm.secondStep,
        "scroll-duration": _vm.scrollDuration
      },
      on: {
        "select": _vm.handleSelect
      }
    }, 'list-columns', _vm.ShowHourMinuteSecondAMPM, false))], 1)]);
  };

  var __vue_staticRenderFns__$b = [];
  /* style */

  var __vue_inject_styles__$b = undefined;
  /* scoped */

  var __vue_scope_id__$b = undefined;
  /* module identifier */

  var __vue_module_identifier__$b = undefined;
  /* functional template */

  var __vue_is_functional_template__$b = false;
  /* style inject */

  /* style inject SSR */

  /* style inject shadow dom */

  var __vue_component__$b = normalizeComponent({
    render: __vue_render__$b,
    staticRenderFns: __vue_staticRenderFns__$b
  }, __vue_inject_styles__$b, __vue_script__$8, __vue_scope_id__$b, __vue_is_functional_template__$b, __vue_module_identifier__$b, false, undefined, undefined, undefined);

  var TimeRange = {
    name: 'TimeRange',
    inject: {
      prefixClass: {
        default: 'mx'
      }
    },
    props: _objectSpread2({}, __vue_component__$b.props),
    data: function data() {
      return {
        startValue: new Date(NaN),
        endValue: new Date(NaN)
      };
    },
    watch: {
      value: {
        immediate: true,
        handler: function handler() {
          if (isValidRangeDate(this.value)) {
            var _this$value = _slicedToArray(this.value, 2),
                startValue = _this$value[0],
                endValue = _this$value[1];

            this.startValue = startValue;
            this.endValue = endValue;
          } else {
            this.startValue = new Date(NaN);
            this.endValue = new Date(NaN);
          }
        }
      }
    },
    methods: {
      emitChange: function emitChange(type, index) {
        var date = [this.startValue, this.endValue];
        this.$emit('select', date, type === 'time' ? 'time-range' : type, index);
      },
      handleSelectStart: function handleSelectStart(date, type) {
        this.startValue = date; // check the NaN

        if (!(this.endValue.getTime() >= date.getTime())) {
          this.endValue = date;
        }

        this.emitChange(type, 0);
      },
      handleSelectEnd: function handleSelectEnd(date, type) {
        // check the NaN
        this.endValue = date;

        if (!(this.startValue.getTime() <= date.getTime())) {
          this.startValue = date;
        }

        this.emitChange(type, 1);
      },
      disabledStartTime: function disabledStartTime(date) {
        return this.disabledTime(date, 0);
      },
      disabledEndTime: function disabledEndTime(date) {
        return date.getTime() < this.startValue.getTime() || this.disabledTime(date, 1);
      }
    },
    render: function render() {
      var h = arguments[0];
      var defaultValues = Array.isArray(this.defaultValue) ? this.defaultValue : [this.defaultValue, this.defaultValue];
      var prefixClass = this.prefixClass;
      return h("div", {
        "class": "".concat(prefixClass, "-range-wrapper")
      }, [h(__vue_component__$b, {
        "props": _objectSpread2({}, _objectSpread2({}, this.$props, {
          value: this.startValue,
          defaultValue: defaultValues[0],
          disabledTime: this.disabledStartTime
        })),
        "on": _objectSpread2({}, _objectSpread2({}, this.$listeners, {
          select: this.handleSelectStart
        }))
      }), h(__vue_component__$b, {
        "props": _objectSpread2({}, _objectSpread2({}, this.$props, {
          value: this.endValue,
          defaultValue: defaultValues[1],
          disabledTime: this.disabledEndTime
        })),
        "on": _objectSpread2({}, _objectSpread2({}, this.$listeners, {
          select: this.handleSelectEnd
        }))
      })]);
    }
  };

  var DatetimePanel = {
    name: 'DatetimePanel',
    inject: {
      prefixClass: {
        default: 'mx'
      }
    },
    emits: ['select', 'update:show-time-panel'],
    props: _objectSpread2({}, CalendarPanel.props, {}, __vue_component__$b.props, {
      showTimePanel: {
        type: Boolean,
        default: undefined
      }
    }),
    data: function data() {
      return {
        defaultTimeVisible: false,
        currentValue: this.value
      };
    },
    computed: {
      timeVisible: function timeVisible() {
        return typeof this.showTimePanel === 'boolean' ? this.showTimePanel : this.defaultTimeVisible;
      }
    },
    watch: {
      value: function value(val) {
        this.currentValue = val;
      }
    },
    methods: {
      closeTimePanel: function closeTimePanel() {
        this.defaultTimeVisible = false;
        this.$emit('update:show-time-panel', false);
      },
      openTimePanel: function openTimePanel() {
        this.defaultTimeVisible = true;
        this.$emit('update:show-time-panel', true);
      },
      emitDate: function emitDate(date, type) {
        this.$emit('select', date, type);
      },
      handleSelect: function handleSelect(date, type) {
        if (type === 'date') {
          this.openTimePanel();
        }

        var datetime = assignTime(date, getValidDate(this.value, this.defaultValue));

        if (this.disabledTime(new Date(datetime))) {
          // set the time of defalutValue;
          datetime = assignTime(date, this.defaultValue);

          if (this.disabledTime(new Date(datetime))) {
            // if disabled don't emit date
            this.currentValue = datetime;
            return;
          }
        }

        this.emitDate(datetime, type);
      }
    },
    render: function render() {
      var h = arguments[0];
      var calendarProps = {
        props: _objectSpread2({}, pick(this.$props, Object.keys(CalendarPanel.props)), {
          type: 'date',
          value: this.currentValue
        }),
        on: {
          select: this.handleSelect
        }
      };
      var timeProps = {
        props: _objectSpread2({}, pick(this.$props, Object.keys(__vue_component__$b.props)), {
          showTimeHeader: true,
          value: this.currentValue
        }),
        on: {
          select: this.emitDate,
          clicktitle: this.closeTimePanel
        }
      };
      var prefixClass = this.prefixClass;
      return h("div", [h(CalendarPanel, helper([{}, calendarProps])), this.timeVisible && h(__vue_component__$b, helper([{
        "class": "".concat(prefixClass, "-calendar-time")
      }, timeProps]))]);
    }
  };

  var DatetimeRange = {
    name: 'DatetimeRange',
    inject: {
      prefixClass: {
        default: 'mx'
      }
    },
    emits: ['select', 'update:show-time-panel'],
    props: _objectSpread2({}, CalendarRange.props, {}, TimeRange.props, {
      showTimePanel: {
        type: Boolean,
        default: undefined
      }
    }),
    data: function data() {
      return {
        defaultTimeVisible: false,
        currentValue: this.value
      };
    },
    computed: {
      timeVisible: function timeVisible() {
        return typeof this.showTimePanel === 'boolean' ? this.showTimePanel : this.defaultTimeVisible;
      }
    },
    watch: {
      value: function value(val) {
        this.currentValue = val;
      }
    },
    methods: {
      closeTimePanel: function closeTimePanel() {
        this.defaultTimeVisible = false;
        this.$emit('update:show-time-panel', false);
      },
      openTimePanel: function openTimePanel() {
        this.defaultTimeVisible = true;
        this.$emit('update:show-time-panel', true);
      },
      emitDate: function emitDate(dates, type) {
        this.$emit('select', dates, type);
      },
      handleSelect: function handleSelect(dates, type) {
        var _this = this;

        if (type === 'date') {
          this.openTimePanel();
        }

        var defaultValues = Array.isArray(this.defaultValue) ? this.defaultValue : [this.defaultValue, this.defaultValue];
        var datetimes = dates.map(function (date, i) {
          var time = isValidRangeDate(_this.value) ? _this.value[i] : defaultValues[i];
          return assignTime(date, time);
        });

        if (datetimes[1].getTime() < datetimes[0].getTime()) {
          datetimes = [datetimes[0], datetimes[0]];
        }

        if (datetimes.some(this.disabledTime)) {
          datetimes = dates.map(function (date, i) {
            return assignTime(date, defaultValues[i]);
          });

          if (datetimes.some(this.disabledTime)) {
            this.currentValue = datetimes;
            return;
          }
        }

        this.emitDate(datetimes, type);
      }
    },
    render: function render() {
      var h = arguments[0];
      var calendarProps = {
        props: _objectSpread2({}, pick(this.$props, Object.keys(CalendarRange.props)), {
          type: 'date',
          value: this.currentValue
        }),
        on: {
          select: this.handleSelect
        }
      };
      var timeProps = {
        props: _objectSpread2({}, pick(this.$props, Object.keys(TimeRange.props)), {
          value: this.currentValue,
          showTimeHeader: true
        }),
        on: {
          select: this.emitDate,
          clicktitle: this.closeTimePanel
        }
      };
      var prefixClass = this.prefixClass;
      return h("div", [h(CalendarRange, helper([{}, calendarProps])), this.timeVisible && h(TimeRange, helper([{
        "class": "".concat(prefixClass, "-calendar-time")
      }, timeProps]))]);
    }
  };

  var componentMap = {
    default: CalendarPanel,
    time: __vue_component__$b,
    datetime: DatetimePanel
  };
  var componentRangeMap = {
    default: CalendarRange,
    time: TimeRange,
    datetime: DatetimeRange
  };
  var DatePicker = {
    name: 'DatePicker',
    provide: function provide() {
      var _this = this;

      return {
        // make locale reactive
        getLocale: function getLocale() {
          return _this.locale;
        },
        getWeek: this.getWeek,
        prefixClass: this.prefixClass,
        dispatchDatePicker: this.$emit.bind(this)
      };
    },
    props: _objectSpread2({}, DatetimePanel.props, {
      value: {},
      valueType: {
        type: String,
        default: 'date' // date, format, timestamp, or token like 'YYYY-MM-DD'

      },
      type: {
        type: String,
        // ['date', 'datetime', 'time', 'year', 'month', 'week']
        default: 'date'
      },
      format: {
        type: String
      },
      formatter: {
        type: Object
      },
      range: {
        type: Boolean,
        default: false
      },
      multiple: {
        type: Boolean,
        default: false
      },
      rangeSeparator: {
        type: String
      },
      lang: {
        type: [String, Object]
      },
      placeholder: {
        type: String,
        default: ''
      },
      editable: {
        type: Boolean,
        default: true
      },
      disabled: {
        type: Boolean,
        default: false
      },
      clearable: {
        type: Boolean,
        default: true
      },
      prefixClass: {
        type: String,
        default: 'mx'
      },
      inputClass: {},
      inputAttr: {
        type: Object,
        default: function _default() {
          return {};
        }
      },
      appendToBody: {
        type: Boolean,
        default: true
      },
      open: {
        type: Boolean,
        default: undefined
      },
      popupClass: {},
      popupStyle: {
        type: Object,
        default: function _default() {
          return {};
        }
      },
      inline: {
        type: Boolean,
        default: false
      },
      confirm: {
        type: Boolean,
        default: false
      },
      confirmText: {
        type: String,
        default: 'OK'
      },
      renderInputText: {
        type: Function
      },
      shortcuts: {
        type: Array,
        validator: function validator(value) {
          return Array.isArray(value) && value.every(function (v) {
            return isObject(v) && typeof v.text === 'string' && typeof v.onClick === 'function';
          });
        },
        default: function _default() {
          return [];
        }
      }
    }),
    data: function data() {
      return {
        // cache the innervalue, wait to confirm
        currentValue: null,
        userInput: null,
        defaultOpen: false
      };
    },
    computed: {
      popupVisible: function popupVisible() {
        return !this.disabled && (typeof this.open === 'boolean' ? this.open : this.defaultOpen);
      },
      innerRangeSeparator: function innerRangeSeparator() {
        return this.rangeSeparator || (this.multiple ? ',' : ' ~ ');
      },
      innerFormat: function innerFormat() {
        var map = {
          date: 'YYYY-MM-DD',
          datetime: 'YYYY-MM-DD HH:mm:ss',
          year: 'YYYY',
          month: 'YYYY-MM',
          time: 'HH:mm:ss',
          week: 'w'
        };
        return this.format || map[this.type] || map.date;
      },
      innerValue: function innerValue() {
        var value = this.value;

        if (this.validMultipleType) {
          value = Array.isArray(value) ? value : [];
          return value.map(this.value2date);
        }

        if (this.range) {
          value = Array.isArray(value) ? value.slice(0, 2) : [null, null];
          return value.map(this.value2date);
        }

        return this.value2date(value);
      },
      text: function text() {
        var _this2 = this;

        if (this.userInput !== null) {
          return this.userInput;
        }

        if (typeof this.renderInputText === 'function') {
          return this.renderInputText(this.innerValue);
        }

        if (!this.isValidValue(this.innerValue)) {
          return '';
        }

        if (Array.isArray(this.innerValue)) {
          return this.innerValue.map(function (v) {
            return _this2.formatDate(v);
          }).join(this.innerRangeSeparator);
        }

        return this.formatDate(this.innerValue);
      },
      showClearIcon: function showClearIcon() {
        return !this.disabled && this.clearable && this.text;
      },
      locale: function locale() {
        if (isObject(this.lang)) {
          return mergeDeep(getLocale(), this.lang);
        }

        return getLocale(this.lang);
      },
      validMultipleType: function validMultipleType() {
        var types = ['date', 'month', 'year'];
        return this.multiple && !this.range && types.indexOf(this.type) !== -1;
      }
    },
    watch: {
      innerValue: {
        immediate: true,
        handler: function handler(val) {
          this.currentValue = val;
        }
      }
    },
    created: function created() {
      if (_typeof(this.format) === 'object') {
        console.warn("[vue2-datepicker]: The prop `format` don't support Object any more. You can use the new prop `formatter` to replace it");
      }
    },
    methods: {
      handleClickOutSide: function handleClickOutSide(evt) {
        var target = evt.target;

        if (!this.$el.contains(target)) {
          this.closePopup();
        }
      },
      getFormatter: function getFormatter(key) {
        return isObject(this.formatter) && this.formatter[key] || isObject(this.format) && this.format[key];
      },
      getWeek: function getWeek$1(date, options) {
        if (typeof this.getFormatter('getWeek') === 'function') {
          return this.getFormatter('getWeek')(date, options);
        }

        return getWeek(date, options);
      },
      parseDate: function parseDate(value, fmt) {
        fmt = fmt || this.innerFormat;

        if (typeof this.getFormatter('parse') === 'function') {
          return this.getFormatter('parse')(value, fmt);
        }

        var backupDate = new Date();
        return parse(value, fmt, {
          locale: this.locale.formatLocale,
          backupDate: backupDate
        });
      },
      formatDate: function formatDate(date, fmt) {
        fmt = fmt || this.innerFormat;

        if (typeof this.getFormatter('stringify') === 'function') {
          return this.getFormatter('stringify')(date, fmt);
        }

        return format(date, fmt, {
          locale: this.locale.formatLocale
        });
      },
      // transform the outer value to inner date
      value2date: function value2date(value) {
        switch (this.valueType) {
          case 'date':
            return value instanceof Date ? new Date(value.getTime()) : new Date(NaN);

          case 'timestamp':
            return typeof value === 'number' ? new Date(value) : new Date(NaN);

          case 'format':
            return typeof value === 'string' ? this.parseDate(value) : new Date(NaN);

          default:
            return typeof value === 'string' ? this.parseDate(value, this.valueType) : new Date(NaN);
        }
      },
      // transform the inner date to outer value
      date2value: function date2value(date) {
        if (!isValidDate$1(date)) return null;

        switch (this.valueType) {
          case 'date':
            return date;

          case 'timestamp':
            return date.getTime();

          case 'format':
            return this.formatDate(date);

          default:
            return this.formatDate(date, this.valueType);
        }
      },
      emitValue: function emitValue(date, type) {
        // fix IE11/10 trigger input event when input is focused. (placeholder !== '')
        this.userInput = null;
        var value = Array.isArray(date) ? date.map(this.date2value) : this.date2value(date);
        this.$emit('input', value);
        this.$emit('change', value, type);
        this.afterEmitValue(type);
        return value;
      },
      afterEmitValue: function afterEmitValue(type) {
        // this.type === 'datetime', click the time should close popup
        if (!type || type === this.type || type === 'time') {
          this.closePopup();
        }
      },
      isValidValue: function isValidValue(value) {
        if (this.validMultipleType) {
          return isValidDates(value);
        }

        if (this.range) {
          return isValidRangeDate(value);
        }

        return isValidDate$1(value);
      },
      isValidValueAndNotDisabled: function isValidValueAndNotDisabled(value) {
        if (!this.isValidValue(value)) {
          return false;
        }

        var disabledDate = typeof this.disabledDate === 'function' ? this.disabledDate : function () {
          return false;
        };
        var disabledTime = typeof this.disabledTime === 'function' ? this.disabledTime : function () {
          return false;
        };

        if (!Array.isArray(value)) {
          value = [value];
        }

        return value.every(function (v) {
          return !disabledDate(v) && !disabledTime(v);
        });
      },
      handleMultipleDates: function handleMultipleDates(date, dates) {
        if (this.validMultipleType && dates) {
          var nextDates = dates.filter(function (v) {
            return v.getTime() !== date.getTime();
          });

          if (nextDates.length === dates.length) {
            nextDates.push(date);
          }

          return nextDates;
        }

        return date;
      },
      handleSelectDate: function handleSelectDate(val, type, dates) {
        val = this.handleMultipleDates(val, dates);

        if (this.confirm) {
          this.currentValue = val;
        } else {
          this.emitValue(val, this.validMultipleType ? "multiple-".concat(type) : type);
        }
      },
      clear: function clear() {
        this.emitValue(this.range ? [null, null] : null);
        this.$emit('clear');
      },
      handleClear: function handleClear(evt) {
        evt.stopPropagation();
        this.clear();
      },
      handleConfirmDate: function handleConfirmDate() {
        var value = this.emitValue(this.currentValue);
        this.$emit('confirm', value);
      },
      handleSelectShortcut: function handleSelectShortcut(evt) {
        var index = evt.currentTarget.getAttribute('data-index');
        var item = this.shortcuts[parseInt(index, 10)];

        if (isObject(item) && typeof item.onClick === 'function') {
          var date = item.onClick(this);

          if (date) {
            this.emitValue(date);
          }
        }
      },
      openPopup: function openPopup(evt) {
        if (this.popupVisible || this.disabled) return;
        this.defaultOpen = true;
        this.$emit('open', evt);
        this.$emit('update:open', true);
      },
      closePopup: function closePopup() {
        if (!this.popupVisible) return;
        this.defaultOpen = false;
        this.$emit('close');
        this.$emit('update:open', false);
      },
      blur: function blur() {
        // when use slot input
        if (this.$refs.input) {
          this.$refs.input.blur();
        }
      },
      focus: function focus() {
        if (this.$refs.input) {
          this.$refs.input.focus();
        }
      },
      handleInputChange: function handleInputChange() {
        var _this3 = this;

        if (!this.editable || this.userInput === null) return;
        var text = this.userInput.trim();
        this.userInput = null;

        if (text === '') {
          this.clear();
          return;
        }

        var date;

        if (this.validMultipleType) {
          date = text.split(this.innerRangeSeparator).map(function (v) {
            return _this3.parseDate(v.trim());
          });
        } else if (this.range) {
          var arr = text.split(this.innerRangeSeparator);

          if (arr.length !== 2) {
            // Maybe the separator during the day is the same as the separator for the date
            // eg: 2019-10-09-2020-01-02
            arr = text.split(this.innerRangeSeparator.trim());
          }

          date = arr.map(function (v) {
            return _this3.parseDate(v.trim());
          });
        } else {
          date = this.parseDate(text);
        }

        if (this.isValidValueAndNotDisabled(date)) {
          this.emitValue(date);
          this.blur();
        } else {
          this.$emit('input-error', text);
        }
      },
      handleInputInput: function handleInputInput(evt) {
        // slot input v-model
        this.userInput = typeof evt === 'string' ? evt : evt.target.value;
      },
      handleInputKeydown: function handleInputKeydown(evt) {
        var keyCode = evt.keyCode; // Tab 9 or Enter 13

        if (keyCode === 9) {
          this.closePopup();
        } else if (keyCode === 13) {
          this.handleInputChange();
        }
      },
      handleInputBlur: function handleInputBlur(evt) {
        // tab close
        this.$emit('blur', evt);
      },
      handleInputFocus: function handleInputFocus(evt) {
        this.openPopup(evt);
        this.$emit('focus', evt);
      },
      hasSlot: function hasSlot(name) {
        return !!(this.$slots[name] || this.$scopedSlots[name]);
      },
      renderSlot: function renderSlot(name, fallback, props) {
        var slotFn = this.$scopedSlots[name];

        if (slotFn) {
          return slotFn(props) || fallback;
        }

        return this.$slots[name] || fallback;
      },
      renderInput: function renderInput() {
        var h = this.$createElement;
        var prefixClass = this.prefixClass;

        var props = _objectSpread2({
          name: 'date',
          type: 'text',
          autocomplete: 'off',
          value: this.text,
          class: this.inputClass || "".concat(this.prefixClass, "-input"),
          readonly: !this.editable,
          disabled: this.disabled,
          placeholder: this.placeholder
        }, this.inputAttr);

        var value = props.value,
            className = props.class,
            attrs = _objectWithoutProperties(props, ["value", "class"]);

        var events = {
          keydown: this.handleInputKeydown,
          focus: this.handleInputFocus,
          blur: this.handleInputBlur,
          input: this.handleInputInput,
          change: this.handleInputChange
        };
        var input = this.renderSlot('input', h("input", {
          "domProps": {
            "value": value
          },
          "class": className,
          "attrs": _objectSpread2({}, attrs),
          "on": _objectSpread2({}, events),
          "ref": "input"
        }), {
          props: props,
          events: events
        });
        var calendarIcon = this.type === 'time' ? h(__vue_component__$2) : h(__vue_component__$1);
        return h("div", {
          "class": "".concat(prefixClass, "-input-wrapper"),
          "on": {
            "mousedown": this.openPopup
          }
        }, [input, this.showClearIcon ? h("i", {
          "class": "".concat(prefixClass, "-icon-clear"),
          "on": {
            "mousedown": this.handleClear
          }
        }, [this.renderSlot('icon-clear', h(__vue_component__$3))]) : null, h("i", {
          "class": "".concat(prefixClass, "-icon-calendar")
        }, [this.renderSlot('icon-calendar', calendarIcon)])]);
      },
      renderContent: function renderContent() {
        var h = this.$createElement;
        var map = this.range ? componentRangeMap : componentMap;
        var Component = map[this.type] || map.default;

        var props = _objectSpread2({}, pick(this.$props, Object.keys(Component.props)), {
          value: this.currentValue
        });

        var on = _objectSpread2({}, pick(this.$listeners, Component.emits || []), {
          select: this.handleSelectDate
        });

        var content = h(Component, helper([{}, {
          props: props,
          on: on,
          ref: 'picker'
        }]));
        return h("div", {
          "class": "".concat(this.prefixClass, "-datepicker-body")
        }, [this.renderSlot('content', content, {
          value: this.currentValue,
          emit: this.handleSelectDate
        })]);
      },
      renderSidebar: function renderSidebar() {
        var _this4 = this;

        var h = this.$createElement;
        var prefixClass = this.prefixClass;
        return h("div", {
          "class": "".concat(prefixClass, "-datepicker-sidebar")
        }, [this.renderSlot('sidebar', null, {
          value: this.currentValue,
          emit: this.handleSelectDate
        }), this.shortcuts.map(function (v, i) {
          return h("button", {
            "key": i,
            "attrs": {
              "data-index": i,
              "type": "button"
            },
            "class": "".concat(prefixClass, "-btn ").concat(prefixClass, "-btn-text ").concat(prefixClass, "-btn-shortcut"),
            "on": {
              "click": _this4.handleSelectShortcut
            }
          }, [v.text]);
        })]);
      },
      renderHeader: function renderHeader() {
        var h = this.$createElement;
        return h("div", {
          "class": "".concat(this.prefixClass, "-datepicker-header")
        }, [this.renderSlot('header', null, {
          value: this.currentValue,
          emit: this.handleSelectDate
        })]);
      },
      renderFooter: function renderFooter() {
        var h = this.$createElement;
        var prefixClass = this.prefixClass;
        return h("div", {
          "class": "".concat(prefixClass, "-datepicker-footer")
        }, [this.renderSlot('footer', null, {
          value: this.currentValue,
          emit: this.handleSelectDate
        }), this.confirm ? h("button", {
          "attrs": {
            "type": "button"
          },
          "class": "".concat(prefixClass, "-btn ").concat(prefixClass, "-datepicker-btn-confirm"),
          "on": {
            "click": this.handleConfirmDate
          }
        }, [this.confirmText]) : null]);
      }
    },
    render: function render() {
      var _class;

      var h = arguments[0];
      var prefixClass = this.prefixClass,
          inline = this.inline,
          disabled = this.disabled;
      var sidedar = this.hasSlot('sidebar') || this.shortcuts.length ? this.renderSidebar() : null;
      var content = h("div", {
        "class": "".concat(prefixClass, "-datepicker-content")
      }, [this.hasSlot('header') ? this.renderHeader() : null, this.renderContent(), this.hasSlot('footer') || this.confirm ? this.renderFooter() : null]);
      return h("div", {
        "class": (_class = {}, _defineProperty(_class, "".concat(prefixClass, "-datepicker"), true), _defineProperty(_class, "".concat(prefixClass, "-datepicker-range"), this.range), _defineProperty(_class, "".concat(prefixClass, "-datepicker-inline"), inline), _defineProperty(_class, "disabled", disabled), _class)
      }, [!inline ? this.renderInput() : null, !inline ? h(__vue_component__, {
        "ref": "popup",
        "class": this.popupClass,
        "style": this.popupStyle,
        "attrs": {
          "visible": this.popupVisible,
          "appendToBody": this.appendToBody
        },
        "on": {
          "clickoutside": this.handleClickOutSide
        }
      }, [sidedar, content]) : h("div", {
        "class": "".concat(prefixClass, "-datepicker-main")
      }, [sidedar, content])]);
    }
  };

  DatePicker.locale = locale$1;

  DatePicker.install = function install(Vue) {
    Vue.component(DatePicker.name, DatePicker);
  };

  if (typeof window !== 'undefined' && window.Vue) {
    DatePicker.install(window.Vue);
  }

  _extends(DatePicker, {
    CalendarPanel: CalendarPanel,
    CalendarRange: CalendarRange,
    TimePanel: __vue_component__$b,
    TimeRange: TimeRange,
    DatetimePanel: DatetimePanel,
    DatetimeRange: DatetimeRange
  });

  return DatePicker;

})));


},{}],798:[function(require,module,exports){
(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('vue2-datepicker')) :
	typeof define === 'function' && define.amd ? define(['vue2-datepicker'], factory) :
	(global = global || self, (global.DatePicker = global.DatePicker || {}, global.DatePicker.lang = global.DatePicker.lang || {}, global.DatePicker.lang.zhCN = factory(global.DatePicker)));
}(this, (function (DatePicker) { 'use strict';

	DatePicker = DatePicker && DatePicker.hasOwnProperty('default') ? DatePicker['default'] : DatePicker;

	function unwrapExports (x) {
		return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
	}

	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}

	var zhCn = createCommonjsModule(function (module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var locale = {
	  months: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
	  monthsShort: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
	  weekdays: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
	  weekdaysShort: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
	  weekdaysMin: ['日', '一', '二', '三', '四', '五', '六'],
	  firstDayOfWeek: 1,
	  firstWeekContainsDate: 4,
	  meridiemParse: /上午|下午/,
	  meridiem: function meridiem(hour) {
	    if (hour < 12) {
	      return '上午';
	    }

	    return '下午';
	  },
	  isPM: function isPM(input) {
	    return input === '下午';
	  }
	};
	var _default = locale;
	exports["default"] = _default;
	module.exports = exports.default;
	});

	var zhCN = unwrapExports(zhCn);

	var lang = {
	  formatLocale: zhCN,
	  yearFormat: 'YYYY年',
	  monthFormat: 'MMM',
	  monthBeforeYear: false
	};
	DatePicker.locale('zh-cn', lang);

	return lang;

})));

},{"vue2-datepicker":797}],799:[function(require,module,exports){
var inserted = exports.cache = {}

exports.insert = function (css) {
  if (inserted[css]) return
  inserted[css] = true

  var elem = document.createElement('style')
  elem.setAttribute('type', 'text/css')

  if ('textContent' in elem) {
    elem.textContent = css
  } else {
    elem.styleSheet.cssText = css
  }

  document.getElementsByTagName('head')[0].appendChild(elem)
  return elem
}

},{}],800:[function(require,module,exports){
!function(e,r){"object"==typeof exports&&"undefined"!=typeof module?r(exports):"function"==typeof define&&define.amd?define(["exports"],r):r((e=e||self).vdp_translation_index={})}(this,function(e){"use strict";function r(e,r){for(var a=0;a<r.length;a++){var n=r[a];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}var a=function(){function e(r,a,n,u){!function(e,r){if(!(e instanceof r))throw new TypeError("Cannot call a class as a function")}(this,e),this.language=r,this.months=a,this.monthsAbbr=n,this.days=u,this.rtl=!1,this.ymd=!1,this.yearSuffix=""}var a,n,u;return a=e,(n=[{key:"language",get:function(){return this._language},set:function(e){if("string"!=typeof e)throw new TypeError("Language must be a string");this._language=e}},{key:"months",get:function(){return this._months},set:function(e){if(12!==e.length)throw new RangeError("There must be 12 months for ".concat(this.language," language"));this._months=e}},{key:"monthsAbbr",get:function(){return this._monthsAbbr},set:function(e){if(12!==e.length)throw new RangeError("There must be 12 abbreviated months for ".concat(this.language," language"));this._monthsAbbr=e}},{key:"days",get:function(){return this._days},set:function(e){if(7!==e.length)throw new RangeError("There must be 7 days for ".concat(this.language," language"));this._days=e}}])&&r(a.prototype,n),u&&r(a,u),e}(),n=new a("Afrikaans",["Januarie","Februarie","Maart","April","Mei","Junie","Julie","Augustus","September","Oktober","November","Desember"],["Jan","Feb","Mrt","Apr","Mei","Jun","Jul","Aug","Sep","Okt","Nov","Des"],["So.","Ma.","Di.","Wo.","Do.","Vr.","Sa."]),u=new a("Arabic",["يناير","فبراير","مارس","أبريل","مايو","يونيو","يوليو","أغسطس","سبتمبر","أكتوبر","نوڤمبر","ديسمبر"],["يناير","فبراير","مارس","أبريل","مايو","يونيو","يوليو","أغسطس","سبتمبر","أكتوبر","نوڤمبر","ديسمبر"],["أحد","إثنين","ثلاثاء","أربعاء","خميس","جمعة","سبت"]);u.rtl=!0;var i=new a("Bulgarian",["Януари","Февруари","Март","Април","Май","Юни","Юли","Август","Септември","Октомври","Ноември","Декември"],["Ян","Фев","Мар","Апр","Май","Юни","Юли","Авг","Сеп","Окт","Ное","Дек"],["Нд","Пн","Вт","Ср","Чт","Пт","Сб"]),t=new a("Bosnian",["Januar","Februar","Mart","April","Maj","Juni","Juli","Avgust","Septembar","Oktobar","Novembar","Decembar"],["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Avg","Sep","Okt","Nov","Dec"],["Ned","Pon","Uto","Sri","Čet","Pet","Sub"]),o=new a("Catalan",["Gener","Febrer","Març","Abril","Maig","Juny","Juliol","Agost","Setembre","Octubre","Novembre","Desembre"],["Gen","Feb","Mar","Abr","Mai","Jun","Jul","Ago","Set","Oct","Nov","Des"],["Diu","Dil","Dmr","Dmc","Dij","Div","Dis"]),s=new a("Czech",["leden","únor","březen","duben","květen","červen","červenec","srpen","září","říjen","listopad","prosinec"],["led","úno","bře","dub","kvě","čer","čec","srp","zář","říj","lis","pro"],["ne","po","út","st","čt","pá","so"]),b=new a("Danish",["Januar","Februar","Marts","April","Maj","Juni","Juli","August","September","Oktober","November","December"],["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Aug","Sep","Okt","Nov","Dec"],["Sø","Ma","Ti","On","To","Fr","Lø"]),l=new a("German",["Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"],["Jan","Feb","Mär","Apr","Mai","Jun","Jul","Aug","Sep","Okt","Nov","Dez"],["So.","Mo.","Di.","Mi.","Do.","Fr.","Sa."]),m=new a("Estonian",["Jaanuar","Veebruar","Märts","Aprill","Mai","Juuni","Juuli","August","September","Oktoober","November","Detsember"],["Jaan","Veebr","Märts","Apr","Mai","Juuni","Juuli","Aug","Sept","Okt","Nov","Dets"],["P","E","T","K","N","R","L"]),M=new a("Greek",["Ιανουάριος","Φεβρουάριος","Μάρτιος","Απρίλιος","Μάϊος","Ιούνιος","Ιούλιος","Αύγουστος","Σεπτέμβριος","Οκτώβριος","Νοέμβριος","Δεκέμβριος"],["Ιαν","Φεβ","Μαρ","Απρ","Μαι","Ιουν","Ιουλ","Αυγ","Σεπ","Οκτ","Νοε","Δεκ"],["Κυρ","Δευ","Τρι","Τετ","Πεμ","Παρ","Σαβ"]),p=new a("English",["January","February","March","April","May","June","July","August","September","October","November","December"],["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],["Sun","Mon","Tue","Wed","Thu","Fri","Sat"]),J=new a("Spanish",["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"],["Ene","Feb","Mar","Abr","May","Jun","Jul","Ago","Sep","Oct","Nov","Dic"],["Dom","Lun","Mar","Mié","Jue","Vie","Sáb"]),g=new a("Persian",["فروردین","اردیبهشت","خرداد","تیر","مرداد","شهریور","مهر","آبان","آذر","دی","بهمن","اسفند"],["فرو","ارد","خرد","تیر","مرد","شهر","مهر","آبا","آذر","دی","بهم","اسف"],["یکشنبه","دوشنبه","سه‌شنبه","چهارشنبه","پنجشنبه","جمعه","شنبه"]),S=new a("Finnish",["tammikuu","helmikuu","maaliskuu","huhtikuu","toukokuu","kesäkuu","heinäkuu","elokuu","syyskuu","lokakuu","marraskuu","joulukuu"],["tammi","helmi","maalis","huhti","touko","kesä","heinä","elo","syys","loka","marras","joulu"],["su","ma","ti","ke","to","pe","la"]),c=new a("Faroese",["Januar","Februar","Mars","Apríl","Mai","Juni","Juli","August","Septembur","Oktobur","Novembur","Desembur"],["Jan","Feb","Mar","Apr","Mai","Jun","Jul","Aug","Sep","Okt","Nov","Des"],["Sun","Mán","Týs","Mik","Hós","Frí","Ley"]),A=new a("French",["Janvier","Février","Mars","Avril","Mai","Juin","Juillet","Août","Septembre","Octobre","Novembre","Décembre"],["Jan","Fév","Mar","Avr","Mai","Juin","Juil","Août","Sep","Oct","Nov","Déc"],["Dim","Lun","Mar","Mer","Jeu","Ven","Sam"]),v=new a("Georgia",["იანვარი","თებერვალი","მარტი","აპრილი","მაისი","ივნისი","ივლისი","აგვისტო","სექტემბერი","ოქტომბერი","ნოემბერი","დეკემბერი"],["იან","თებ","მარ","აპრ","მაი","ივნ","ივლ","აგვ","სექ","ოქტ","ნოე","დეკ"],["კვი","ორშ","სამ","ოთხ","ხუთ","პარ","შაბ"]),h=new a("Galician",["Xaneiro","Febreiro","Marzo","Abril","Maio","Xuño","Xullo","Agosto","Setembro","Outubro","Novembro","Decembro"],["Xan","Feb","Mar","Abr","Mai","Xuñ","Xul","Ago","Set","Out","Nov","Dec"],["Dom","Lun","Mar","Mér","Xov","Ven","Sáb"]),k=new a("Hebrew",["ינואר","פברואר","מרץ","אפריל","מאי","יוני","יולי","אוגוסט","ספטמבר","אוקטובר","נובמבר","דצמבר"],["ינו","פבר","מרץ","אפר","מאי","יונ","יול","אוג","ספט","אוק","נוב","דצמ"],["א","ב","ג","ד","ה","ו","ש"]);k.rtl=!0;var w=new a("Croatian",["Siječanj","Veljača","Ožujak","Travanj","Svibanj","Lipanj","Srpanj","Kolovoz","Rujan","Listopad","Studeni","Prosinac"],["Sij","Velj","Ožu","Tra","Svi","Lip","Srp","Kol","Ruj","Lis","Stu","Pro"],["Ned","Pon","Uto","Sri","Čet","Pet","Sub"]),D=new a("Hungarian",["Január","Február","Március","Április","Május","Június","Július","Augusztus","Szeptember","Október","November","December"],["Jan","Febr","Márc","Ápr","Máj","Jún","Júl","Aug","Szept","Okt","Nov","Dec"],["Vas","Hét","Ke","Sze","Csü","Pén","Szo"]),f=new a("Indonesian",["Januari","Februari","Maret","April","Mei","Juni","Juli","Agustus","September","Oktober","November","Desember"],["Jan","Feb","Mar","Apr","Mei","Jun","Jul","Agu","Sep","Okt","Nov","Des"],["Min","Sen","Sel","Rab","Kam","Jum","Sab"]),N=new a("Icelandic",["Janúar","Febrúar","Mars","Apríl","Maí","Júní","Júlí","Ágúst","September","Október","Nóvember","Desember"],["Jan","Feb","Mars","Apr","Maí","Jún","Júl","Ágú","Sep","Okt","Nóv","Des"],["Sun","Mán","Þri","Mið","Fim","Fös","Lau"]),O=new a("Italian",["Gennaio","Febbraio","Marzo","Aprile","Maggio","Giugno","Luglio","Agosto","Settembre","Ottobre","Novembre","Dicembre"],["Gen","Feb","Mar","Apr","Mag","Giu","Lug","Ago","Set","Ott","Nov","Dic"],["Dom","Lun","Mar","Mer","Gio","Ven","Sab"]),j=new a("Japanese",["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"],["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"],["日","月","火","水","木","金","土"]);j.yearSuffix="年",j.ymd=!0;var F=new a("Kazakh",["Қаңтар","Ақпан","Наурыз","Сәуір","Мамыр","Маусым","Шілде","Тамыз","Қыркүйек","Қазан","Қараша","Желтоқсан"],["Қаң","Ақп","Нау","Сәу","Мам","Мау","Шіл","Там","Қыр","Қаз","Қар","Жел"],["Жк","Дй","Сй","Ср","Бй","Жм","Сн"]),d=new a("Korean",["1월","2월","3월","4월","5월","6월","7월","8월","9월","10월","11월","12월"],["1월","2월","3월","4월","5월","6월","7월","8월","9월","10월","11월","12월"],["일","월","화","수","목","금","토"]);d.yearSuffix="년",d.ymd=!0;var T=new a("Luxembourgish",["Januar","Februar","Mäerz","Abrëll","Mee","Juni","Juli","August","September","Oktober","November","Dezember"],["Jan","Feb","Mäe","Abr","Mee","Jun","Jul","Aug","Sep","Okt","Nov","Dez"],["So.","Mé.","Dë.","Më.","Do.","Fr.","Sa."]),y=new a("Lithuanian",["Sausis","Vasaris","Kovas","Balandis","Gegužė","Birželis","Liepa","Rugpjūtis","Rugsėjis","Spalis","Lapkritis","Gruodis"],["Sau","Vas","Kov","Bal","Geg","Bir","Lie","Rugp","Rugs","Spa","Lap","Gru"],["Sek","Pir","Ant","Tre","Ket","Pen","Šeš"]);y.ymd=!0;var z=new a("Latvian",["Janvāris","Februāris","Marts","Aprīlis","Maijs","Jūnijs","Jūlijs","Augusts","Septembris","Oktobris","Novembris","Decembris"],["Jan","Feb","Mar","Apr","Mai","Jūn","Jūl","Aug","Sep","Okt","Nov","Dec"],["Sv","Pr","Ot","Tr","Ce","Pk","Se"]),L=new a("Macedonian",["Јануари","Февруари","Март","Април","Мај","Јуни","Јули","Август","Септември","Октомври","Ноември","Декември"],["Јан","Фев","Мар","Апр","Мај","Јун","Јул","Авг","Сеп","Окт","Ное","Дек"],["Нед","Пон","Вто","Сре","Чет","Пет","Саб"]),P=new a("Mongolia",["1 дүгээр сар","2 дугаар сар","3 дугаар сар","4 дүгээр сар","5 дугаар сар","6 дугаар сар","7 дугаар сар","8 дугаар сар","9 дүгээр сар","10 дугаар сар","11 дүгээр сар","12 дугаар сар"],["1-р сар","2-р сар","3-р сар","4-р сар","5-р сар","6-р сар","7-р сар","8-р сар","9-р сар","10-р сар","11-р сар","12-р сар"],["Ня","Да","Мя","Лх","Пү","Ба","Бя"]);P.ymd=!0;var G=new a("Norwegian Bokmål",["Januar","Februar","Mars","April","Mai","Juni","Juli","August","September","Oktober","November","Desember"],["Jan","Feb","Mar","Apr","Mai","Jun","Jul","Aug","Sep","Okt","Nov","Des"],["Sø","Ma","Ti","On","To","Fr","Lø"]),C=new a("Dutch",["januari","februari","maart","april","mei","juni","juli","augustus","september","oktober","november","december"],["jan","feb","mrt","apr","mei","jun","jul","aug","sep","okt","nov","dec"],["zo","ma","di","wo","do","vr","za"]),K=new a("Polish",["Styczeń","Luty","Marzec","Kwiecień","Maj","Czerwiec","Lipiec","Sierpień","Wrzesień","Październik","Listopad","Grudzień"],["Sty","Lut","Mar","Kwi","Maj","Cze","Lip","Sie","Wrz","Paź","Lis","Gru"],["Nd","Pn","Wt","Śr","Czw","Pt","Sob"]),R=new a("Brazilian",["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"],["Jan","Fev","Mar","Abr","Mai","Jun","Jul","Ago","Set","Out","Nov","Dez"],["Dom","Seg","Ter","Qua","Qui","Sex","Sab"]),E=new a("Romanian",["Ianuarie","Februarie","Martie","Aprilie","Mai","Iunie","Iulie","August","Septembrie","Octombrie","Noiembrie","Decembrie"],["Ian","Feb","Mar","Apr","Mai","Iun","Iul","Aug","Sep","Oct","Noi","Dec"],["D","L","Ma","Mi","J","V","S"]),V=new a("Russian",["Январь","Февраль","Март","Апрель","Май","Июнь","Июль","Август","Сентябрь","Октябрь","Ноябрь","Декабрь"],["Янв","Февр","Март","Апр","Май","Июнь","Июль","Авг","Сент","Окт","Нояб","Дек"],["Вс","Пн","Вт","Ср","Чт","Пт","Сб"]),_=new a("Slovakian",["január","február","marec","apríl","máj","jún","júl","august","september","október","november","december"],["jan","feb","mar","apr","máj","jún","júl","aug","sep","okt","nov","dec"],["ne","po","ut","st","št","pi","so"]),x=new a("Sloveian",["Januar","Februar","Marec","April","Maj","Junij","Julij","Avgust","September","Oktober","November","December"],["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Avg","Sep","Okt","Nov","Dec"],["Ned","Pon","Tor","Sre","Čet","Pet","Sob"]),I=new a("Serbian in Cyrillic script",["Јануар","Фебруар","Март","Април","Мај","Јун","Јул","Август","Септембар","Октобар","Новембар","Децембар"],["Јан","Феб","Мар","Апр","Мај","Јун","Јул","Авг","Сеп","Окт","Нов","Дец"],["Нед","Пон","Уто","Сре","Чет","Пет","Суб"]),B=new a("Serbian",["Januar","Februar","Mart","April","Maj","Jun","Jul","Avgust","Septembar","Oktobar","Novembar","Decembar"],["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Avg","Sep","Okt","Nov","Dec"],["Ned","Pon","Uto","Sre","Čet","Pet","Sub"]),H=new a("Swedish",["Januari","Februari","Mars","April","Maj","Juni","Juli","Augusti","September","Oktober","November","December"],["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Aug","Sep","Okt","Nov","Dec"],["Sön","Mån","Tis","Ons","Tor","Fre","Lör"]),X=new a("Thai",["มกราคม","กุมภาพันธ์","มีนาคม","เมษายน","พฤษภาคม","มิถุนายน","กรกฎาคม","สิงหาคม","กันยายน","ตุลาคม","พฤศจิกายน","ธันวาคม"],["ม.ค.","ก.พ.","มี.ค.","เม.ย.","พ.ค.","มิ.ย.","ก.ค.","ส.ค.","ก.ย.","ต.ค.","พ.ย.","ธ.ค."],["อา","จ","อ","พ","พฤ","ศ","ส"]),U=new a("Turkish",["Ocak","Şubat","Mart","Nisan","Mayıs","Haziran","Temmuz","Ağustos","Eylül","Ekim","Kasım","Aralık"],["Oca","Şub","Mar","Nis","May","Haz","Tem","Ağu","Eyl","Eki","Kas","Ara"],["Paz","Pzt","Sal","Çar","Per","Cum","Cmt"]),W=new a("Ukraine",["Січень","Лютий","Березень","Квітень","Травень","Червень","Липень","Серпень","Вересень","Жовтень","Листопад","Грудень"],["Січ","Лют","Бер","Квіт","Трав","Чер","Лип","Серп","Вер","Жовт","Лист","Груд"],["Нд","Пн","Вт","Ср","Чт","Пт","Сб"]),Q=new a("Urdu",["جنوری","فروری","مارچ","اپریل","مئی","جون","جولائی","اگست","سپتمبر","اکتوبر","نومبر","دسمبر"],["جنوری","فروری","مارچ","اپریل","مئی","جون","جولائی","اگست","سپتمبر","اکتوبر","نومبر","دسمبر"],["اتوار","پیر","منگل","بدھ","جمعرات","جمعہ","ہفتہ"]);Q.rtl=!0;var Y=new a("Vietnamese",["Tháng 1","Tháng 2","Tháng 3","Tháng 4","Tháng 5","Tháng 6","Tháng 7","Tháng 8","Tháng 9","Tháng 10","Tháng 11","Tháng 12"],["T 01","T 02","T 03","T 04","T 05","T 06","T 07","T 08","T 09","T 10","T 11","T 12"],["CN","Thứ 2","Thứ 3","Thứ 4","Thứ 5","Thứ 6","Thứ 7"]),q=new a("Chinese",["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"],["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"],["日","一","二","三","四","五","六"]);q.yearSuffix="年";var Z=new a("Chinese_HK",["壹月","贰月","叁月","肆月","伍月","陆月","柒月","捌月","玖月","拾月","拾壹月","拾贰月"],["壹月","贰月","叁月","肆月","伍月","陆月","柒月","捌月","玖月","拾月","拾壹月","拾贰月"],["日","壹","贰","叁","肆","伍","陆"]);Z.yearSuffix="年",e.af=n,e.ar=u,e.bg=i,e.bs=t,e.ca=o,e.cs=s,e.da=b,e.de=l,e.ee=m,e.el=M,e.en=p,e.es=J,e.fa=g,e.fi=S,e.fo=c,e.fr=A,e.ge=v,e.gl=h,e.he=k,e.hr=w,e.hu=D,e.id=f,e.is=N,e.it=O,e.ja=j,e.kk=F,e.ko=d,e.lb=T,e.lt=y,e.lv=z,e.mk=L,e.mn=P,e.nbNO=G,e.nl=C,e.pl=K,e.ptBR=R,e.ro=E,e.ru=V,e.sk=_,e.slSI=x,e.sr=B,e.srCYRL=I,e.sv=H,e.th=X,e.tr=U,e.uk=W,e.ur=Q,e.vi=Y,e.zh=q,e.zhHK=Z,Object.defineProperty(e,"__esModule",{value:!0})});

},{}],801:[function(require,module,exports){
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = global || self, global.vuejsDatepicker = factory());
}(this, function () { 'use strict';

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof = function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    }

    return target;
  }

  var Language =
  /*#__PURE__*/
  function () {
    function Language(language, months, monthsAbbr, days) {
      _classCallCheck(this, Language);

      this.language = language;
      this.months = months;
      this.monthsAbbr = monthsAbbr;
      this.days = days;
      this.rtl = false;
      this.ymd = false;
      this.yearSuffix = '';
    }

    _createClass(Language, [{
      key: "language",
      get: function get() {
        return this._language;
      },
      set: function set(language) {
        if (typeof language !== 'string') {
          throw new TypeError('Language must be a string');
        }

        this._language = language;
      }
    }, {
      key: "months",
      get: function get() {
        return this._months;
      },
      set: function set(months) {
        if (months.length !== 12) {
          throw new RangeError("There must be 12 months for ".concat(this.language, " language"));
        }

        this._months = months;
      }
    }, {
      key: "monthsAbbr",
      get: function get() {
        return this._monthsAbbr;
      },
      set: function set(monthsAbbr) {
        if (monthsAbbr.length !== 12) {
          throw new RangeError("There must be 12 abbreviated months for ".concat(this.language, " language"));
        }

        this._monthsAbbr = monthsAbbr;
      }
    }, {
      key: "days",
      get: function get() {
        return this._days;
      },
      set: function set(days) {
        if (days.length !== 7) {
          throw new RangeError("There must be 7 days for ".concat(this.language, " language"));
        }

        this._days = days;
      }
    }]);

    return Language;
  }(); // eslint-disable-next-line

  var en = new Language('English', ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'], ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'], ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']) // eslint-disable-next-line
  ;

  var utils = {
    /**
     * @type {Boolean}
     */
    useUtc: false,

    /**
     * Returns the full year, using UTC or not
     * @param {Date} date
     */
    getFullYear: function getFullYear(date) {
      return this.useUtc ? date.getUTCFullYear() : date.getFullYear();
    },

    /**
     * Returns the month, using UTC or not
     * @param {Date} date
     */
    getMonth: function getMonth(date) {
      return this.useUtc ? date.getUTCMonth() : date.getMonth();
    },

    /**
     * Returns the date, using UTC or not
     * @param {Date} date
     */
    getDate: function getDate(date) {
      return this.useUtc ? date.getUTCDate() : date.getDate();
    },

    /**
     * Returns the day, using UTC or not
     * @param {Date} date
     */
    getDay: function getDay(date) {
      return this.useUtc ? date.getUTCDay() : date.getDay();
    },

    /**
     * Returns the hours, using UTC or not
     * @param {Date} date
     */
    getHours: function getHours(date) {
      return this.useUtc ? date.getUTCHours() : date.getHours();
    },

    /**
     * Returns the minutes, using UTC or not
     * @param {Date} date
     */
    getMinutes: function getMinutes(date) {
      return this.useUtc ? date.getUTCMinutes() : date.getMinutes();
    },

    /**
     * Sets the full year, using UTC or not
     * @param {Date} date
     */
    setFullYear: function setFullYear(date, value, useUtc) {
      return this.useUtc ? date.setUTCFullYear(value) : date.setFullYear(value);
    },

    /**
     * Sets the month, using UTC or not
     * @param {Date} date
     */
    setMonth: function setMonth(date, value, useUtc) {
      return this.useUtc ? date.setUTCMonth(value) : date.setMonth(value);
    },

    /**
     * Sets the date, using UTC or not
     * @param {Date} date
     * @param {Number} value
     */
    setDate: function setDate(date, value, useUtc) {
      return this.useUtc ? date.setUTCDate(value) : date.setDate(value);
    },

    /**
     * Check if date1 is equivalent to date2, without comparing the time
     * @see https://stackoverflow.com/a/6202196/4455925
     * @param {Date} date1
     * @param {Date} date2
     */
    compareDates: function compareDates(date1, date2) {
      var d1 = new Date(date1.getTime());
      var d2 = new Date(date2.getTime());

      if (this.useUtc) {
        d1.setUTCHours(0, 0, 0, 0);
        d2.setUTCHours(0, 0, 0, 0);
      } else {
        d1.setHours(0, 0, 0, 0);
        d2.setHours(0, 0, 0, 0);
      }

      return d1.getTime() === d2.getTime();
    },

    /**
     * Validates a date object
     * @param {Date} date - an object instantiated with the new Date constructor
     * @return {Boolean}
     */
    isValidDate: function isValidDate(date) {
      if (Object.prototype.toString.call(date) !== '[object Date]') {
        return false;
      }

      return !isNaN(date.getTime());
    },

    /**
     * Return abbreviated week day name
     * @param {Date}
     * @param {Array}
     * @return {String}
     */
    getDayNameAbbr: function getDayNameAbbr(date, days) {
      if (_typeof(date) !== 'object') {
        throw TypeError('Invalid Type');
      }

      return days[this.getDay(date)];
    },

    /**
     * Return name of the month
     * @param {Number|Date}
     * @param {Array}
     * @return {String}
     */
    getMonthName: function getMonthName(month, months) {
      if (!months) {
        throw Error('missing 2nd parameter Months array');
      }

      if (_typeof(month) === 'object') {
        return months[this.getMonth(month)];
      }

      if (typeof month === 'number') {
        return months[month];
      }

      throw TypeError('Invalid type');
    },

    /**
     * Return an abbreviated version of the month
     * @param {Number|Date}
     * @return {String}
     */
    getMonthNameAbbr: function getMonthNameAbbr(month, monthsAbbr) {
      if (!monthsAbbr) {
        throw Error('missing 2nd paramter Months array');
      }

      if (_typeof(month) === 'object') {
        return monthsAbbr[this.getMonth(month)];
      }

      if (typeof month === 'number') {
        return monthsAbbr[month];
      }

      throw TypeError('Invalid type');
    },

    /**
     * Alternative get total number of days in month
     * @param {Number} year
     * @param {Number} m
     * @return {Number}
     */
    daysInMonth: function daysInMonth(year, month) {
      return /8|3|5|10/.test(month) ? 30 : month === 1 ? !(year % 4) && year % 100 || !(year % 400) ? 29 : 28 : 31;
    },

    /**
     * Get nth suffix for date
     * @param {Number} day
     * @return {String}
     */
    getNthSuffix: function getNthSuffix(day) {
      switch (day) {
        case 1:
        case 21:
        case 31:
          return 'st';

        case 2:
        case 22:
          return 'nd';

        case 3:
        case 23:
          return 'rd';

        default:
          return 'th';
      }
    },

    /**
     * Formats date object
     * @param {Date}
     * @param {String}
     * @param {Object}
     * @return {String}
     */
    formatDate: function formatDate(date, format, translation) {
      translation = !translation ? en : translation;
      var year = this.getFullYear(date);
      var month = this.getMonth(date) + 1;
      var day = this.getDate(date);
      var str = format.replace(/dd/, ('0' + day).slice(-2)).replace(/d/, day).replace(/yyyy/, year).replace(/yy/, String(year).slice(2)).replace(/MMMM/, this.getMonthName(this.getMonth(date), translation.months)).replace(/MMM/, this.getMonthNameAbbr(this.getMonth(date), translation.monthsAbbr)).replace(/MM/, ('0' + month).slice(-2)).replace(/M(?!a|ä|e)/, month).replace(/su/, this.getNthSuffix(this.getDate(date))).replace(/D(?!e|é|i)/, this.getDayNameAbbr(date, translation.days));
      return str;
    },

    /**
     * Creates an array of dates for each day in between two dates.
     * @param {Date} start
     * @param {Date} end
     * @return {Array}
     */
    createDateArray: function createDateArray(start, end) {
      var dates = [];

      while (start <= end) {
        dates.push(new Date(start));
        start = this.setDate(new Date(start), this.getDate(new Date(start)) + 1);
      }

      return dates;
    },

    /**
     * method used as a prop validator for input values
     * @param {*} val
     * @return {Boolean}
     */
    validateDateInput: function validateDateInput(val) {
      return val === null || val instanceof Date || typeof val === 'string' || typeof val === 'number';
    }
  };
  var makeDateUtils = function makeDateUtils(useUtc) {
    return _objectSpread({}, utils, {
      useUtc: useUtc
    });
  };
  var utils$1 = _objectSpread({}, utils) // eslint-disable-next-line
  ;

  var script = {
    props: {
      selectedDate: Date,
      resetTypedDate: [Date],
      format: [String, Function],
      translation: Object,
      inline: Boolean,
      id: String,
      name: String,
      refName: String,
      openDate: Date,
      placeholder: String,
      inputClass: [String, Object, Array],
      clearButton: Boolean,
      clearButtonIcon: String,
      calendarButton: Boolean,
      calendarButtonIcon: String,
      calendarButtonIconContent: String,
      disabled: Boolean,
      required: Boolean,
      typeable: Boolean,
      bootstrapStyling: Boolean,
      useUtc: Boolean
    },
    data: function data() {
      var constructedDateUtils = makeDateUtils(this.useUtc);
      return {
        input: null,
        typedDate: false,
        utils: constructedDateUtils
      };
    },
    computed: {
      formattedValue: function formattedValue() {
        if (!this.selectedDate) {
          return null;
        }

        if (this.typedDate) {
          return this.typedDate;
        }

        return typeof this.format === 'function' ? this.format(this.selectedDate) : this.utils.formatDate(new Date(this.selectedDate), this.format, this.translation);
      },
      computedInputClass: function computedInputClass() {
        if (this.bootstrapStyling) {
          if (typeof this.inputClass === 'string') {
            return [this.inputClass, 'form-control'].join(' ');
          }

          return _objectSpread({
            'form-control': true
          }, this.inputClass);
        }

        return this.inputClass;
      }
    },
    watch: {
      resetTypedDate: function resetTypedDate() {
        this.typedDate = false;
      }
    },
    methods: {
      showCalendar: function showCalendar() {
        this.$emit('showCalendar');
      },

      /**
       * Attempt to parse a typed date
       * @param {Event} event
       */
      parseTypedDate: function parseTypedDate(event) {
        // close calendar if escape or enter are pressed
        if ([27, // escape
        13 // enter
        ].includes(event.keyCode)) {
          this.input.blur();
        }

        if (this.typeable) {
          var typedDate = Date.parse(this.input.value);

          if (!isNaN(typedDate)) {
            this.typedDate = this.input.value;
            this.$emit('typedDate', new Date(this.typedDate));
          }
        }
      },

      /**
       * nullify the typed date to defer to regular formatting
       * called once the input is blurred
       */
      inputBlurred: function inputBlurred() {
        if (this.typeable && isNaN(Date.parse(this.input.value))) {
          this.clearDate();
          this.input.value = null;
          this.typedDate = null;
        }

        this.$emit('closeCalendar');
      },

      /**
       * emit a clearDate event
       */
      clearDate: function clearDate() {
        this.$emit('clearDate');
      }
    },
    mounted: function mounted() {
      this.input = this.$el.querySelector('input');
    }
  } // eslint-disable-next-line
  ;

  function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
  /* server only */
  , shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
      createInjectorSSR = createInjector;
      createInjector = shadowMode;
      shadowMode = false;
    } // Vue.extend constructor export interop.


    var options = typeof script === 'function' ? script.options : script; // render functions

    if (template && template.render) {
      options.render = template.render;
      options.staticRenderFns = template.staticRenderFns;
      options._compiled = true; // functional template

      if (isFunctionalTemplate) {
        options.functional = true;
      }
    } // scopedId


    if (scopeId) {
      options._scopeId = scopeId;
    }

    var hook;

    if (moduleIdentifier) {
      // server build
      hook = function hook(context) {
        // 2.3 injection
        context = context || // cached call
        this.$vnode && this.$vnode.ssrContext || // stateful
        this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
        // 2.2 with runInNewContext: true

        if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
          context = __VUE_SSR_CONTEXT__;
        } // inject component styles


        if (style) {
          style.call(this, createInjectorSSR(context));
        } // register component module identifier for async chunk inference


        if (context && context._registeredComponents) {
          context._registeredComponents.add(moduleIdentifier);
        }
      }; // used by ssr in case component is cached and beforeCreate
      // never gets called


      options._ssrRegister = hook;
    } else if (style) {
      hook = shadowMode ? function () {
        style.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
      } : function (context) {
        style.call(this, createInjector(context));
      };
    }

    if (hook) {
      if (options.functional) {
        // register for functional component in vue file
        var originalRender = options.render;

        options.render = function renderWithStyleInjection(h, context) {
          hook.call(context);
          return originalRender(h, context);
        };
      } else {
        // inject component registration as beforeCreate hook
        var existing = options.beforeCreate;
        options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
      }
    }

    return script;
  }

  var normalizeComponent_1 = normalizeComponent;

  /* script */
  const __vue_script__ = script;

  /* template */
  var __vue_render__ = function() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "div",
      { class: { "input-group": _vm.bootstrapStyling } },
      [
        _vm.calendarButton
          ? _c(
              "span",
              {
                staticClass: "vdp-datepicker__calendar-button",
                class: { "input-group-prepend": _vm.bootstrapStyling },
                style: { "cursor:not-allowed;": _vm.disabled },
                on: { click: _vm.showCalendar }
              },
              [
                _c(
                  "span",
                  { class: { "input-group-text": _vm.bootstrapStyling } },
                  [
                    _c("i", { class: _vm.calendarButtonIcon }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.calendarButtonIconContent) +
                          "\n        "
                      ),
                      !_vm.calendarButtonIcon
                        ? _c("span", [_vm._v("…")])
                        : _vm._e()
                    ])
                  ]
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("input", {
          ref: _vm.refName,
          class: _vm.computedInputClass,
          attrs: {
            type: _vm.inline ? "hidden" : "text",
            name: _vm.name,
            id: _vm.id,
            "open-date": _vm.openDate,
            placeholder: _vm.placeholder,
            "clear-button": _vm.clearButton,
            disabled: _vm.disabled,
            required: _vm.required,
            readonly: !_vm.typeable,
            autocomplete: "off"
          },
          domProps: { value: _vm.formattedValue },
          on: {
            click: _vm.showCalendar,
            keyup: _vm.parseTypedDate,
            blur: _vm.inputBlurred
          }
        }),
        _vm._v(" "),
        _vm.clearButton && _vm.selectedDate
          ? _c(
              "span",
              {
                staticClass: "vdp-datepicker__clear-button",
                class: { "input-group-append": _vm.bootstrapStyling },
                on: {
                  click: function($event) {
                    return _vm.clearDate()
                  }
                }
              },
              [
                _c(
                  "span",
                  { class: { "input-group-text": _vm.bootstrapStyling } },
                  [
                    _c("i", { class: _vm.clearButtonIcon }, [
                      !_vm.clearButtonIcon ? _c("span", [_vm._v("×")]) : _vm._e()
                    ])
                  ]
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm._t("afterDateInput")
      ],
      2
    )
  };
  var __vue_staticRenderFns__ = [];
  __vue_render__._withStripped = true;

    /* style */
    const __vue_inject_styles__ = undefined;
    /* scoped */
    const __vue_scope_id__ = undefined;
    /* module identifier */
    const __vue_module_identifier__ = undefined;
    /* functional template */
    const __vue_is_functional_template__ = false;
    /* style inject */
    
    /* style inject SSR */
    

    
    var DateInput = normalizeComponent_1(
      { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
      __vue_inject_styles__,
      __vue_script__,
      __vue_scope_id__,
      __vue_is_functional_template__,
      __vue_module_identifier__,
      undefined,
      undefined
    );

  //
  var script$1 = {
    props: {
      showDayView: Boolean,
      selectedDate: Date,
      pageDate: Date,
      pageTimestamp: Number,
      fullMonthName: Boolean,
      allowedToShowView: Function,
      dayCellContent: {
        type: Function,
        "default": function _default(day) {
          return day.date;
        }
      },
      disabledDates: Object,
      highlighted: Object,
      calendarClass: [String, Object, Array],
      calendarStyle: Object,
      translation: Object,
      isRtl: Boolean,
      mondayFirst: Boolean,
      useUtc: Boolean
    },
    data: function data() {
      var constructedDateUtils = makeDateUtils(this.useUtc);
      return {
        utils: constructedDateUtils
      };
    },
    computed: {
      /**
       * Returns an array of day names
       * @return {String[]}
       */
      daysOfWeek: function daysOfWeek() {
        if (this.mondayFirst) {
          var tempDays = this.translation.days.slice();
          tempDays.push(tempDays.shift());
          return tempDays;
        }

        return this.translation.days;
      },

      /**
       * Returns the day number of the week less one for the first of the current month
       * Used to show amount of empty cells before the first in the day calendar layout
       * @return {Number}
       */
      blankDays: function blankDays() {
        var d = this.pageDate;
        var dObj = this.useUtc ? new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), 1)) : new Date(d.getFullYear(), d.getMonth(), 1, d.getHours(), d.getMinutes());

        if (this.mondayFirst) {
          return this.utils.getDay(dObj) > 0 ? this.utils.getDay(dObj) - 1 : 6;
        }

        return this.utils.getDay(dObj);
      },

      /**
       * @return {Object[]}
       */
      days: function days() {
        var d = this.pageDate;
        var days = []; // set up a new date object to the beginning of the current 'page'

        var dObj = this.useUtc ? new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), 1)) : new Date(d.getFullYear(), d.getMonth(), 1, d.getHours(), d.getMinutes());
        var daysInMonth = this.utils.daysInMonth(this.utils.getFullYear(dObj), this.utils.getMonth(dObj));

        for (var i = 0; i < daysInMonth; i++) {
          days.push({
            date: this.utils.getDate(dObj),
            timestamp: dObj.getTime(),
            isSelected: this.isSelectedDate(dObj),
            isDisabled: this.isDisabledDate(dObj),
            isHighlighted: this.isHighlightedDate(dObj),
            isHighlightStart: this.isHighlightStart(dObj),
            isHighlightEnd: this.isHighlightEnd(dObj),
            isToday: this.utils.compareDates(dObj, new Date()),
            isWeekend: this.utils.getDay(dObj) === 0 || this.utils.getDay(dObj) === 6,
            isSaturday: this.utils.getDay(dObj) === 6,
            isSunday: this.utils.getDay(dObj) === 0
          });
          this.utils.setDate(dObj, this.utils.getDate(dObj) + 1);
        }

        return days;
      },

      /**
       * Gets the name of the month the current page is on
       * @return {String}
       */
      currMonthName: function currMonthName() {
        var monthName = this.fullMonthName ? this.translation.months : this.translation.monthsAbbr;
        return this.utils.getMonthNameAbbr(this.utils.getMonth(this.pageDate), monthName);
      },

      /**
       * Gets the name of the year that current page is on
       * @return {Number}
       */
      currYearName: function currYearName() {
        var yearSuffix = this.translation.yearSuffix;
        return "".concat(this.utils.getFullYear(this.pageDate)).concat(yearSuffix);
      },

      /**
       * Is this translation using year/month/day format?
       * @return {Boolean}
       */
      isYmd: function isYmd() {
        return this.translation.ymd && this.translation.ymd === true;
      },

      /**
       * Is the left hand navigation button disabled?
       * @return {Boolean}
       */
      isLeftNavDisabled: function isLeftNavDisabled() {
        return this.isRtl ? this.isNextMonthDisabled(this.pageTimestamp) : this.isPreviousMonthDisabled(this.pageTimestamp);
      },

      /**
       * Is the right hand navigation button disabled?
       * @return {Boolean}
       */
      isRightNavDisabled: function isRightNavDisabled() {
        return this.isRtl ? this.isPreviousMonthDisabled(this.pageTimestamp) : this.isNextMonthDisabled(this.pageTimestamp);
      }
    },
    methods: {
      selectDate: function selectDate(date) {
        if (date.isDisabled) {
          this.$emit('selectedDisabled', date);
          return false;
        }

        this.$emit('selectDate', date);
      },

      /**
       * @return {Number}
       */
      getPageMonth: function getPageMonth() {
        return this.utils.getMonth(this.pageDate);
      },

      /**
       * Emit an event to show the month picker
       */
      showMonthCalendar: function showMonthCalendar() {
        this.$emit('showMonthCalendar');
      },

      /**
       * Change the page month
       * @param {Number} incrementBy
       */
      changeMonth: function changeMonth(incrementBy) {
        var date = this.pageDate;
        this.utils.setMonth(date, this.utils.getMonth(date) + incrementBy);
        this.$emit('changedMonth', date);
      },

      /**
       * Decrement the page month
       */
      previousMonth: function previousMonth() {
        if (!this.isPreviousMonthDisabled()) {
          this.changeMonth(-1);
        }
      },

      /**
       * Is the previous month disabled?
       * @return {Boolean}
       */
      isPreviousMonthDisabled: function isPreviousMonthDisabled() {
        if (!this.disabledDates || !this.disabledDates.to) {
          return false;
        }

        var d = this.pageDate;
        return this.utils.getMonth(this.disabledDates.to) >= this.utils.getMonth(d) && this.utils.getFullYear(this.disabledDates.to) >= this.utils.getFullYear(d);
      },

      /**
       * Increment the current page month
       */
      nextMonth: function nextMonth() {
        if (!this.isNextMonthDisabled()) {
          this.changeMonth(+1);
        }
      },

      /**
       * Is the next month disabled?
       * @return {Boolean}
       */
      isNextMonthDisabled: function isNextMonthDisabled() {
        if (!this.disabledDates || !this.disabledDates.from) {
          return false;
        }

        var d = this.pageDate;
        return this.utils.getMonth(this.disabledDates.from) <= this.utils.getMonth(d) && this.utils.getFullYear(this.disabledDates.from) <= this.utils.getFullYear(d);
      },

      /**
       * Whether a day is selected
       * @param {Date}
       * @return {Boolean}
       */
      isSelectedDate: function isSelectedDate(dObj) {
        return this.selectedDate && this.utils.compareDates(this.selectedDate, dObj);
      },

      /**
       * Whether a day is disabled
       * @param {Date}
       * @return {Boolean}
       */
      isDisabledDate: function isDisabledDate(date) {
        var _this = this;

        var disabledDates = false;

        if (typeof this.disabledDates === 'undefined') {
          return false;
        }

        if (typeof this.disabledDates.dates !== 'undefined') {
          this.disabledDates.dates.forEach(function (d) {
            if (_this.utils.compareDates(date, d)) {
              disabledDates = true;
              return true;
            }
          });
        }

        if (typeof this.disabledDates.to !== 'undefined' && this.disabledDates.to && date < this.disabledDates.to) {
          disabledDates = true;
        }

        if (typeof this.disabledDates.from !== 'undefined' && this.disabledDates.from && date > this.disabledDates.from) {
          disabledDates = true;
        }

        if (typeof this.disabledDates.ranges !== 'undefined') {
          this.disabledDates.ranges.forEach(function (range) {
            if (typeof range.from !== 'undefined' && range.from && typeof range.to !== 'undefined' && range.to) {
              if (date < range.to && date > range.from) {
                disabledDates = true;
                return true;
              }
            }
          });
        }

        if (typeof this.disabledDates.days !== 'undefined' && this.disabledDates.days.indexOf(this.utils.getDay(date)) !== -1) {
          disabledDates = true;
        }

        if (typeof this.disabledDates.daysOfMonth !== 'undefined' && this.disabledDates.daysOfMonth.indexOf(this.utils.getDate(date)) !== -1) {
          disabledDates = true;
        }

        if (typeof this.disabledDates.customPredictor === 'function' && this.disabledDates.customPredictor(date)) {
          disabledDates = true;
        }

        return disabledDates;
      },

      /**
       * Whether a day is highlighted (only if it is not disabled already except when highlighted.includeDisabled is true)
       * @param {Date}
       * @return {Boolean}
       */
      isHighlightedDate: function isHighlightedDate(date) {
        var _this2 = this;

        if (!(this.highlighted && this.highlighted.includeDisabled) && this.isDisabledDate(date)) {
          return false;
        }

        var highlighted = false;

        if (typeof this.highlighted === 'undefined') {
          return false;
        }

        if (typeof this.highlighted.dates !== 'undefined') {
          this.highlighted.dates.forEach(function (d) {
            if (_this2.utils.compareDates(date, d)) {
              highlighted = true;
              return true;
            }
          });
        }

        if (this.isDefined(this.highlighted.from) && this.isDefined(this.highlighted.to)) {
          highlighted = date >= this.highlighted.from && date <= this.highlighted.to;
        }

        if (typeof this.highlighted.days !== 'undefined' && this.highlighted.days.indexOf(this.utils.getDay(date)) !== -1) {
          highlighted = true;
        }

        if (typeof this.highlighted.daysOfMonth !== 'undefined' && this.highlighted.daysOfMonth.indexOf(this.utils.getDate(date)) !== -1) {
          highlighted = true;
        }

        if (typeof this.highlighted.customPredictor === 'function' && this.highlighted.customPredictor(date)) {
          highlighted = true;
        }

        return highlighted;
      },
      dayClasses: function dayClasses(day) {
        return {
          'selected': day.isSelected,
          'disabled': day.isDisabled,
          'highlighted': day.isHighlighted,
          'today': day.isToday,
          'weekend': day.isWeekend,
          'sat': day.isSaturday,
          'sun': day.isSunday,
          'highlight-start': day.isHighlightStart,
          'highlight-end': day.isHighlightEnd
        };
      },

      /**
       * Whether a day is highlighted and it is the first date
       * in the highlighted range of dates
       * @param {Date}
       * @return {Boolean}
       */
      isHighlightStart: function isHighlightStart(date) {
        return this.isHighlightedDate(date) && this.highlighted.from instanceof Date && this.utils.getFullYear(this.highlighted.from) === this.utils.getFullYear(date) && this.utils.getMonth(this.highlighted.from) === this.utils.getMonth(date) && this.utils.getDate(this.highlighted.from) === this.utils.getDate(date);
      },

      /**
       * Whether a day is highlighted and it is the first date
       * in the highlighted range of dates
       * @param {Date}
       * @return {Boolean}
       */
      isHighlightEnd: function isHighlightEnd(date) {
        return this.isHighlightedDate(date) && this.highlighted.to instanceof Date && this.utils.getFullYear(this.highlighted.to) === this.utils.getFullYear(date) && this.utils.getMonth(this.highlighted.to) === this.utils.getMonth(date) && this.utils.getDate(this.highlighted.to) === this.utils.getDate(date);
      },

      /**
       * Helper
       * @param  {mixed}  prop
       * @return {Boolean}
       */
      isDefined: function isDefined(prop) {
        return typeof prop !== 'undefined' && prop;
      }
    } // eslint-disable-next-line

  };

  /* script */
  const __vue_script__$1 = script$1;

  /* template */
  var __vue_render__$1 = function() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showDayView,
            expression: "showDayView"
          }
        ],
        class: [_vm.calendarClass, "vdp-datepicker__calendar"],
        style: _vm.calendarStyle,
        on: {
          mousedown: function($event) {
            $event.preventDefault();
          }
        }
      },
      [
        _vm._t("beforeCalendarHeader"),
        _vm._v(" "),
        _c("header", [
          _c(
            "span",
            {
              staticClass: "prev",
              class: { disabled: _vm.isLeftNavDisabled },
              on: {
                click: function($event) {
                  _vm.isRtl ? _vm.nextMonth() : _vm.previousMonth();
                }
              }
            },
            [_vm._v("<")]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "day__month_btn",
              class: _vm.allowedToShowView("month") ? "up" : "",
              on: { click: _vm.showMonthCalendar }
            },
            [
              _vm._v(
                _vm._s(_vm.isYmd ? _vm.currYearName : _vm.currMonthName) +
                  " " +
                  _vm._s(_vm.isYmd ? _vm.currMonthName : _vm.currYearName)
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "next",
              class: { disabled: _vm.isRightNavDisabled },
              on: {
                click: function($event) {
                  _vm.isRtl ? _vm.previousMonth() : _vm.nextMonth();
                }
              }
            },
            [_vm._v(">")]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { class: _vm.isRtl ? "flex-rtl" : "" },
          [
            _vm._l(_vm.daysOfWeek, function(d) {
              return _c(
                "span",
                { key: d.timestamp, staticClass: "cell day-header" },
                [_vm._v(_vm._s(d))]
              )
            }),
            _vm._v(" "),
            _vm.blankDays > 0
              ? _vm._l(_vm.blankDays, function(d) {
                  return _c("span", {
                    key: d.timestamp,
                    staticClass: "cell day blank"
                  })
                })
              : _vm._e(),
            _vm._l(_vm.days, function(day) {
              return _c("span", {
                key: day.timestamp,
                staticClass: "cell day",
                class: _vm.dayClasses(day),
                domProps: { innerHTML: _vm._s(_vm.dayCellContent(day)) },
                on: {
                  click: function($event) {
                    return _vm.selectDate(day)
                  }
                }
              })
            })
          ],
          2
        )
      ],
      2
    )
  };
  var __vue_staticRenderFns__$1 = [];
  __vue_render__$1._withStripped = true;

    /* style */
    const __vue_inject_styles__$1 = undefined;
    /* scoped */
    const __vue_scope_id__$1 = undefined;
    /* module identifier */
    const __vue_module_identifier__$1 = undefined;
    /* functional template */
    const __vue_is_functional_template__$1 = false;
    /* style inject */
    
    /* style inject SSR */
    

    
    var PickerDay = normalizeComponent_1(
      { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
      __vue_inject_styles__$1,
      __vue_script__$1,
      __vue_scope_id__$1,
      __vue_is_functional_template__$1,
      __vue_module_identifier__$1,
      undefined,
      undefined
    );

  //
  var script$2 = {
    props: {
      showMonthView: Boolean,
      selectedDate: Date,
      pageDate: Date,
      pageTimestamp: Number,
      disabledDates: Object,
      calendarClass: [String, Object, Array],
      calendarStyle: Object,
      translation: Object,
      isRtl: Boolean,
      allowedToShowView: Function,
      useUtc: Boolean
    },
    data: function data() {
      var constructedDateUtils = makeDateUtils(this.useUtc);
      return {
        utils: constructedDateUtils
      };
    },
    computed: {
      months: function months() {
        var d = this.pageDate;
        var months = []; // set up a new date object to the beginning of the current 'page'

        var dObj = this.useUtc ? new Date(Date.UTC(d.getUTCFullYear(), 0, d.getUTCDate())) : new Date(d.getFullYear(), 0, d.getDate(), d.getHours(), d.getMinutes());

        for (var i = 0; i < 12; i++) {
          months.push({
            month: this.utils.getMonthName(i, this.translation.months),
            timestamp: dObj.getTime(),
            isSelected: this.isSelectedMonth(dObj),
            isDisabled: this.isDisabledMonth(dObj)
          });
          this.utils.setMonth(dObj, this.utils.getMonth(dObj) + 1);
        }

        return months;
      },

      /**
       * Get year name on current page.
       * @return {String}
       */
      pageYearName: function pageYearName() {
        var yearSuffix = this.translation.yearSuffix;
        return "".concat(this.utils.getFullYear(this.pageDate)).concat(yearSuffix);
      },

      /**
       * Is the left hand navigation disabled
       * @return {Boolean}
       */
      isLeftNavDisabled: function isLeftNavDisabled() {
        return this.isRtl ? this.isNextYearDisabled(this.pageTimestamp) : this.isPreviousYearDisabled(this.pageTimestamp);
      },

      /**
       * Is the right hand navigation disabled
       * @return {Boolean}
       */
      isRightNavDisabled: function isRightNavDisabled() {
        return this.isRtl ? this.isPreviousYearDisabled(this.pageTimestamp) : this.isNextYearDisabled(this.pageTimestamp);
      }
    },
    methods: {
      /**
       * Emits a selectMonth event
       * @param {Object} month
       */
      selectMonth: function selectMonth(month) {
        if (month.isDisabled) {
          return false;
        }

        this.$emit('selectMonth', month);
      },

      /**
       * Changes the year up or down
       * @param {Number} incrementBy
       */
      changeYear: function changeYear(incrementBy) {
        var date = this.pageDate;
        this.utils.setFullYear(date, this.utils.getFullYear(date) + incrementBy);
        this.$emit('changedYear', date);
      },

      /**
       * Decrements the year
       */
      previousYear: function previousYear() {
        if (!this.isPreviousYearDisabled()) {
          this.changeYear(-1);
        }
      },

      /**
       * Checks if the previous year is disabled or not
       * @return {Boolean}
       */
      isPreviousYearDisabled: function isPreviousYearDisabled() {
        if (!this.disabledDates || !this.disabledDates.to) {
          return false;
        }

        return this.utils.getFullYear(this.disabledDates.to) >= this.utils.getFullYear(this.pageDate);
      },

      /**
       * Increments the year
       */
      nextYear: function nextYear() {
        if (!this.isNextYearDisabled()) {
          this.changeYear(1);
        }
      },

      /**
       * Checks if the next year is disabled or not
       * @return {Boolean}
       */
      isNextYearDisabled: function isNextYearDisabled() {
        if (!this.disabledDates || !this.disabledDates.from) {
          return false;
        }

        return this.utils.getFullYear(this.disabledDates.from) <= this.utils.getFullYear(this.pageDate);
      },

      /**
       * Emits an event that shows the year calendar
       */
      showYearCalendar: function showYearCalendar() {
        this.$emit('showYearCalendar');
      },

      /**
       * Whether the selected date is in this month
       * @param {Date}
       * @return {Boolean}
       */
      isSelectedMonth: function isSelectedMonth(date) {
        return this.selectedDate && this.utils.getFullYear(this.selectedDate) === this.utils.getFullYear(date) && this.utils.getMonth(this.selectedDate) === this.utils.getMonth(date);
      },

      /**
       * Whether a month is disabled
       * @param {Date}
       * @return {Boolean}
       */
      isDisabledMonth: function isDisabledMonth(date) {
        var disabledDates = false;

        if (typeof this.disabledDates === 'undefined') {
          return false;
        }

        if (typeof this.disabledDates.to !== 'undefined' && this.disabledDates.to) {
          if (this.utils.getMonth(date) < this.utils.getMonth(this.disabledDates.to) && this.utils.getFullYear(date) <= this.utils.getFullYear(this.disabledDates.to) || this.utils.getFullYear(date) < this.utils.getFullYear(this.disabledDates.to)) {
            disabledDates = true;
          }
        }

        if (typeof this.disabledDates.from !== 'undefined' && this.disabledDates.from) {
          if (this.utils.getMonth(date) > this.utils.getMonth(this.disabledDates.from) && this.utils.getFullYear(date) >= this.utils.getFullYear(this.disabledDates.from) || this.utils.getFullYear(date) > this.utils.getFullYear(this.disabledDates.from)) {
            disabledDates = true;
          }
        }

        if (typeof this.disabledDates.customPredictor === 'function' && this.disabledDates.customPredictor(date)) {
          disabledDates = true;
        }

        return disabledDates;
      }
    } // eslint-disable-next-line

  };

  /* script */
  const __vue_script__$2 = script$2;

  /* template */
  var __vue_render__$2 = function() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showMonthView,
            expression: "showMonthView"
          }
        ],
        class: [_vm.calendarClass, "vdp-datepicker__calendar"],
        style: _vm.calendarStyle,
        on: {
          mousedown: function($event) {
            $event.preventDefault();
          }
        }
      },
      [
        _vm._t("beforeCalendarHeader"),
        _vm._v(" "),
        _c("header", [
          _c(
            "span",
            {
              staticClass: "prev",
              class: { disabled: _vm.isLeftNavDisabled },
              on: {
                click: function($event) {
                  _vm.isRtl ? _vm.nextYear() : _vm.previousYear();
                }
              }
            },
            [_vm._v("<")]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "month__year_btn",
              class: _vm.allowedToShowView("year") ? "up" : "",
              on: { click: _vm.showYearCalendar }
            },
            [_vm._v(_vm._s(_vm.pageYearName))]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "next",
              class: { disabled: _vm.isRightNavDisabled },
              on: {
                click: function($event) {
                  _vm.isRtl ? _vm.previousYear() : _vm.nextYear();
                }
              }
            },
            [_vm._v(">")]
          )
        ]),
        _vm._v(" "),
        _vm._l(_vm.months, function(month) {
          return _c(
            "span",
            {
              key: month.timestamp,
              staticClass: "cell month",
              class: { selected: month.isSelected, disabled: month.isDisabled },
              on: {
                click: function($event) {
                  $event.stopPropagation();
                  return _vm.selectMonth(month)
                }
              }
            },
            [_vm._v(_vm._s(month.month))]
          )
        })
      ],
      2
    )
  };
  var __vue_staticRenderFns__$2 = [];
  __vue_render__$2._withStripped = true;

    /* style */
    const __vue_inject_styles__$2 = undefined;
    /* scoped */
    const __vue_scope_id__$2 = undefined;
    /* module identifier */
    const __vue_module_identifier__$2 = undefined;
    /* functional template */
    const __vue_is_functional_template__$2 = false;
    /* style inject */
    
    /* style inject SSR */
    

    
    var PickerMonth = normalizeComponent_1(
      { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
      __vue_inject_styles__$2,
      __vue_script__$2,
      __vue_scope_id__$2,
      __vue_is_functional_template__$2,
      __vue_module_identifier__$2,
      undefined,
      undefined
    );

  //
  var script$3 = {
    props: {
      showYearView: Boolean,
      selectedDate: Date,
      pageDate: Date,
      pageTimestamp: Number,
      disabledDates: Object,
      highlighted: Object,
      calendarClass: [String, Object, Array],
      calendarStyle: Object,
      translation: Object,
      isRtl: Boolean,
      allowedToShowView: Function,
      useUtc: Boolean
    },
    computed: {
      years: function years() {
        var d = this.pageDate;
        var years = []; // set up a new date object to the beginning of the current 'page'7

        var dObj = this.useUtc ? new Date(Date.UTC(Math.floor(d.getUTCFullYear() / 10) * 10, d.getUTCMonth(), d.getUTCDate())) : new Date(Math.floor(d.getFullYear() / 10) * 10, d.getMonth(), d.getDate(), d.getHours(), d.getMinutes());

        for (var i = 0; i < 10; i++) {
          years.push({
            year: this.utils.getFullYear(dObj),
            timestamp: dObj.getTime(),
            isSelected: this.isSelectedYear(dObj),
            isDisabled: this.isDisabledYear(dObj)
          });
          this.utils.setFullYear(dObj, this.utils.getFullYear(dObj) + 1);
        }

        return years;
      },

      /**
       * @return {String}
       */
      getPageDecade: function getPageDecade() {
        var decadeStart = Math.floor(this.utils.getFullYear(this.pageDate) / 10) * 10;
        var decadeEnd = decadeStart + 9;
        var yearSuffix = this.translation.yearSuffix;
        return "".concat(decadeStart, " - ").concat(decadeEnd).concat(yearSuffix);
      },

      /**
       * Is the left hand navigation button disabled?
       * @return {Boolean}
       */
      isLeftNavDisabled: function isLeftNavDisabled() {
        return this.isRtl ? this.isNextDecadeDisabled(this.pageTimestamp) : this.isPreviousDecadeDisabled(this.pageTimestamp);
      },

      /**
       * Is the right hand navigation button disabled?
       * @return {Boolean}
       */
      isRightNavDisabled: function isRightNavDisabled() {
        return this.isRtl ? this.isPreviousDecadeDisabled(this.pageTimestamp) : this.isNextDecadeDisabled(this.pageTimestamp);
      }
    },
    data: function data() {
      var constructedDateUtils = makeDateUtils(this.useUtc);
      return {
        utils: constructedDateUtils
      };
    },
    methods: {
      selectYear: function selectYear(year) {
        if (year.isDisabled) {
          return false;
        }

        this.$emit('selectYear', year);
      },
      changeYear: function changeYear(incrementBy) {
        var date = this.pageDate;
        this.utils.setFullYear(date, this.utils.getFullYear(date) + incrementBy);
        this.$emit('changedDecade', date);
      },
      previousDecade: function previousDecade() {
        if (this.isPreviousDecadeDisabled()) {
          return false;
        }

        this.changeYear(-10);
      },
      isPreviousDecadeDisabled: function isPreviousDecadeDisabled() {
        if (!this.disabledDates || !this.disabledDates.to) {
          return false;
        }

        var disabledYear = this.utils.getFullYear(this.disabledDates.to);
        var lastYearInPreviousPage = Math.floor(this.utils.getFullYear(this.pageDate) / 10) * 10 - 1;
        return disabledYear > lastYearInPreviousPage;
      },
      nextDecade: function nextDecade() {
        if (this.isNextDecadeDisabled()) {
          return false;
        }

        this.changeYear(10);
      },
      isNextDecadeDisabled: function isNextDecadeDisabled() {
        if (!this.disabledDates || !this.disabledDates.from) {
          return false;
        }

        var disabledYear = this.utils.getFullYear(this.disabledDates.from);
        var firstYearInNextPage = Math.ceil(this.utils.getFullYear(this.pageDate) / 10) * 10;
        return disabledYear < firstYearInNextPage;
      },

      /**
       * Whether the selected date is in this year
       * @param {Date}
       * @return {Boolean}
       */
      isSelectedYear: function isSelectedYear(date) {
        return this.selectedDate && this.utils.getFullYear(this.selectedDate) === this.utils.getFullYear(date);
      },

      /**
       * Whether a year is disabled
       * @param {Date}
       * @return {Boolean}
       */
      isDisabledYear: function isDisabledYear(date) {
        var disabledDates = false;

        if (typeof this.disabledDates === 'undefined' || !this.disabledDates) {
          return false;
        }

        if (typeof this.disabledDates.to !== 'undefined' && this.disabledDates.to) {
          if (this.utils.getFullYear(date) < this.utils.getFullYear(this.disabledDates.to)) {
            disabledDates = true;
          }
        }

        if (typeof this.disabledDates.from !== 'undefined' && this.disabledDates.from) {
          if (this.utils.getFullYear(date) > this.utils.getFullYear(this.disabledDates.from)) {
            disabledDates = true;
          }
        }

        if (typeof this.disabledDates.customPredictor === 'function' && this.disabledDates.customPredictor(date)) {
          disabledDates = true;
        }

        return disabledDates;
      }
    } // eslint-disable-next-line

  };

  /* script */
  const __vue_script__$3 = script$3;

  /* template */
  var __vue_render__$3 = function() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showYearView,
            expression: "showYearView"
          }
        ],
        class: [_vm.calendarClass, "vdp-datepicker__calendar"],
        style: _vm.calendarStyle,
        on: {
          mousedown: function($event) {
            $event.preventDefault();
          }
        }
      },
      [
        _vm._t("beforeCalendarHeader"),
        _vm._v(" "),
        _c("header", [
          _c(
            "span",
            {
              staticClass: "prev",
              class: { disabled: _vm.isLeftNavDisabled },
              on: {
                click: function($event) {
                  _vm.isRtl ? _vm.nextDecade() : _vm.previousDecade();
                }
              }
            },
            [_vm._v("<")]
          ),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.getPageDecade))]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "next",
              class: { disabled: _vm.isRightNavDisabled },
              on: {
                click: function($event) {
                  _vm.isRtl ? _vm.previousDecade() : _vm.nextDecade();
                }
              }
            },
            [_vm._v(">")]
          )
        ]),
        _vm._v(" "),
        _vm._l(_vm.years, function(year) {
          return _c(
            "span",
            {
              key: year.timestamp,
              staticClass: "cell year",
              class: { selected: year.isSelected, disabled: year.isDisabled },
              on: {
                click: function($event) {
                  $event.stopPropagation();
                  return _vm.selectYear(year)
                }
              }
            },
            [_vm._v(_vm._s(year.year))]
          )
        })
      ],
      2
    )
  };
  var __vue_staticRenderFns__$3 = [];
  __vue_render__$3._withStripped = true;

    /* style */
    const __vue_inject_styles__$3 = undefined;
    /* scoped */
    const __vue_scope_id__$3 = undefined;
    /* module identifier */
    const __vue_module_identifier__$3 = undefined;
    /* functional template */
    const __vue_is_functional_template__$3 = false;
    /* style inject */
    
    /* style inject SSR */
    

    
    var PickerYear = normalizeComponent_1(
      { render: __vue_render__$3, staticRenderFns: __vue_staticRenderFns__$3 },
      __vue_inject_styles__$3,
      __vue_script__$3,
      __vue_scope_id__$3,
      __vue_is_functional_template__$3,
      __vue_module_identifier__$3,
      undefined,
      undefined
    );

  //
  var script$4 = {
    components: {
      DateInput: DateInput,
      PickerDay: PickerDay,
      PickerMonth: PickerMonth,
      PickerYear: PickerYear
    },
    props: {
      value: {
        validator: function validator(val) {
          return utils$1.validateDateInput(val);
        }
      },
      name: String,
      refName: String,
      id: String,
      format: {
        type: [String, Function],
        "default": 'dd MMM yyyy'
      },
      language: {
        type: Object,
        "default": function _default() {
          return en;
        }
      },
      openDate: {
        validator: function validator(val) {
          return utils$1.validateDateInput(val);
        }
      },
      dayCellContent: Function,
      fullMonthName: Boolean,
      disabledDates: Object,
      highlighted: Object,
      placeholder: String,
      inline: Boolean,
      calendarClass: [String, Object, Array],
      inputClass: [String, Object, Array],
      wrapperClass: [String, Object, Array],
      mondayFirst: Boolean,
      clearButton: Boolean,
      clearButtonIcon: String,
      calendarButton: Boolean,
      calendarButtonIcon: String,
      calendarButtonIconContent: String,
      bootstrapStyling: Boolean,
      initialView: String,
      disabled: Boolean,
      required: Boolean,
      typeable: Boolean,
      useUtc: Boolean,
      minimumView: {
        type: String,
        "default": 'day'
      },
      maximumView: {
        type: String,
        "default": 'year'
      }
    },
    data: function data() {
      var startDate = this.openDate ? new Date(this.openDate) : new Date();
      var constructedDateUtils = makeDateUtils(this.useUtc);
      var pageTimestamp = constructedDateUtils.setDate(startDate, 1);
      return {
        /*
         * Vue cannot observe changes to a Date Object so date must be stored as a timestamp
         * This represents the first day of the current viewing month
         * {Number}
         */
        pageTimestamp: pageTimestamp,

        /*
         * Selected Date
         * {Date}
         */
        selectedDate: null,

        /*
         * Flags to show calendar views
         * {Boolean}
         */
        showDayView: false,
        showMonthView: false,
        showYearView: false,

        /*
         * Positioning
         */
        calendarHeight: 0,
        resetTypedDate: new Date(),
        utils: constructedDateUtils
      };
    },
    watch: {
      value: function value(_value) {
        this.setValue(_value);
      },
      openDate: function openDate() {
        this.setPageDate();
      },
      initialView: function initialView() {
        this.setInitialView();
      }
    },
    computed: {
      computedInitialView: function computedInitialView() {
        if (!this.initialView) {
          return this.minimumView;
        }

        return this.initialView;
      },
      pageDate: function pageDate() {
        return new Date(this.pageTimestamp);
      },
      translation: function translation() {
        return this.language;
      },
      calendarStyle: function calendarStyle() {
        return {
          position: this.isInline ? 'static' : undefined
        };
      },
      isOpen: function isOpen() {
        return this.showDayView || this.showMonthView || this.showYearView;
      },
      isInline: function isInline() {
        return !!this.inline;
      },
      isRtl: function isRtl() {
        return this.translation.rtl === true;
      }
    },
    methods: {
      /**
       * Called in the event that the user navigates to date pages and
       * closes the picker without selecting a date.
       */
      resetDefaultPageDate: function resetDefaultPageDate() {
        if (this.selectedDate === null) {
          this.setPageDate();
          return;
        }

        this.setPageDate(this.selectedDate);
      },

      /**
       * Effectively a toggle to show/hide the calendar
       * @return {mixed}
       */
      showCalendar: function showCalendar() {
        if (this.disabled || this.isInline) {
          return false;
        }

        if (this.isOpen) {
          return this.close(true);
        }

        this.setInitialView();
      },

      /**
       * Sets the initial picker page view: day, month or year
       */
      setInitialView: function setInitialView() {
        var initialView = this.computedInitialView;

        if (!this.allowedToShowView(initialView)) {
          throw new Error("initialView '".concat(this.initialView, "' cannot be rendered based on minimum '").concat(this.minimumView, "' and maximum '").concat(this.maximumView, "'"));
        }

        switch (initialView) {
          case 'year':
            this.showYearCalendar();
            break;

          case 'month':
            this.showMonthCalendar();
            break;

          default:
            this.showDayCalendar();
            break;
        }
      },

      /**
       * Are we allowed to show a specific picker view?
       * @param {String} view
       * @return {Boolean}
       */
      allowedToShowView: function allowedToShowView(view) {
        var views = ['day', 'month', 'year'];
        var minimumViewIndex = views.indexOf(this.minimumView);
        var maximumViewIndex = views.indexOf(this.maximumView);
        var viewIndex = views.indexOf(view);
        return viewIndex >= minimumViewIndex && viewIndex <= maximumViewIndex;
      },

      /**
       * Show the day picker
       * @return {Boolean}
       */
      showDayCalendar: function showDayCalendar() {
        if (!this.allowedToShowView('day')) {
          return false;
        }

        this.close();
        this.showDayView = true;
        return true;
      },

      /**
       * Show the month picker
       * @return {Boolean}
       */
      showMonthCalendar: function showMonthCalendar() {
        if (!this.allowedToShowView('month')) {
          return false;
        }

        this.close();
        this.showMonthView = true;
        return true;
      },

      /**
       * Show the year picker
       * @return {Boolean}
       */
      showYearCalendar: function showYearCalendar() {
        if (!this.allowedToShowView('year')) {
          return false;
        }

        this.close();
        this.showYearView = true;
        return true;
      },

      /**
       * Set the selected date
       * @param {Number} timestamp
       */
      setDate: function setDate(timestamp) {
        var date = new Date(timestamp);
        this.selectedDate = date;
        this.setPageDate(date);
        this.$emit('selected', date);
        this.$emit('input', date);
      },

      /**
       * Clear the selected date
       */
      clearDate: function clearDate() {
        this.selectedDate = null;
        this.setPageDate();
        this.$emit('selected', null);
        this.$emit('input', null);
        this.$emit('cleared');
      },

      /**
       * @param {Object} date
       */
      selectDate: function selectDate(date) {
        this.setDate(date.timestamp);

        if (!this.isInline) {
          this.close(true);
        }

        this.resetTypedDate = new Date();
      },

      /**
       * @param {Object} date
       */
      selectDisabledDate: function selectDisabledDate(date) {
        this.$emit('selectedDisabled', date);
      },

      /**
       * @param {Object} month
       */
      selectMonth: function selectMonth(month) {
        var date = new Date(month.timestamp);

        if (this.allowedToShowView('day')) {
          this.setPageDate(date);
          this.$emit('changedMonth', month);
          this.showDayCalendar();
        } else {
          this.selectDate(month);
        }
      },

      /**
       * @param {Object} year
       */
      selectYear: function selectYear(year) {
        var date = new Date(year.timestamp);

        if (this.allowedToShowView('month')) {
          this.setPageDate(date);
          this.$emit('changedYear', year);
          this.showMonthCalendar();
        } else {
          this.selectDate(year);
        }
      },

      /**
       * Set the datepicker value
       * @param {Date|String|Number|null} date
       */
      setValue: function setValue(date) {
        if (typeof date === 'string' || typeof date === 'number') {
          var parsed = new Date(date);
          date = isNaN(parsed.valueOf()) ? null : parsed;
        }

        if (!date) {
          this.setPageDate();
          this.selectedDate = null;
          return;
        }

        this.selectedDate = date;
        this.setPageDate(date);
      },

      /**
       * Sets the date that the calendar should open on
       */
      setPageDate: function setPageDate(date) {
        if (!date) {
          if (this.openDate) {
            date = new Date(this.openDate);
          } else {
            date = new Date();
          }
        }

        this.pageTimestamp = this.utils.setDate(new Date(date), 1);
      },

      /**
       * Handles a month change from the day picker
       */
      handleChangedMonthFromDayPicker: function handleChangedMonthFromDayPicker(date) {
        this.setPageDate(date);
        this.$emit('changedMonth', date);
      },

      /**
       * Set the date from a typedDate event
       */
      setTypedDate: function setTypedDate(date) {
        this.setDate(date.getTime());
      },

      /**
       * Close all calendar layers
       * @param {Boolean} emitEvent - emit close event
       */
      close: function close(emitEvent) {
        this.showDayView = this.showMonthView = this.showYearView = false;

        if (!this.isInline) {
          if (emitEvent) {
            this.$emit('closed');
          }

          document.removeEventListener('click', this.clickOutside, false);
        }
      },

      /**
       * Initiate the component
       */
      init: function init() {
        if (this.value) {
          this.setValue(this.value);
        }

        if (this.isInline) {
          this.setInitialView();
        }
      }
    },
    mounted: function mounted() {
      this.init();
    }
  } // eslint-disable-next-line
  ;

  var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
  function createInjector(context) {
    return function (id, style) {
      return addStyle(id, style);
    };
  }
  var HEAD = document.head || document.getElementsByTagName('head')[0];
  var styles = {};

  function addStyle(id, css) {
    var group = isOldIE ? css.media || 'default' : id;
    var style = styles[group] || (styles[group] = {
      ids: new Set(),
      styles: []
    });

    if (!style.ids.has(id)) {
      style.ids.add(id);
      var code = css.source;

      if (css.map) {
        // https://developer.chrome.com/devtools/docs/javascript-debugging
        // this makes source maps inside style tags work properly in Chrome
        code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'; // http://stackoverflow.com/a/26603875

        code += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) + ' */';
      }

      if (!style.element) {
        style.element = document.createElement('style');
        style.element.type = 'text/css';
        if (css.media) style.element.setAttribute('media', css.media);
        HEAD.appendChild(style.element);
      }

      if ('styleSheet' in style.element) {
        style.styles.push(code);
        style.element.styleSheet.cssText = style.styles.filter(Boolean).join('\n');
      } else {
        var index = style.ids.size - 1;
        var textNode = document.createTextNode(code);
        var nodes = style.element.childNodes;
        if (nodes[index]) style.element.removeChild(nodes[index]);
        if (nodes.length) style.element.insertBefore(textNode, nodes[index]);else style.element.appendChild(textNode);
      }
    }
  }

  var browser = createInjector;

  /* script */
  const __vue_script__$4 = script$4;

  /* template */
  var __vue_render__$4 = function() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "div",
      {
        staticClass: "vdp-datepicker",
        class: [_vm.wrapperClass, _vm.isRtl ? "rtl" : ""]
      },
      [
        _c(
          "date-input",
          {
            attrs: {
              selectedDate: _vm.selectedDate,
              resetTypedDate: _vm.resetTypedDate,
              format: _vm.format,
              translation: _vm.translation,
              inline: _vm.inline,
              id: _vm.id,
              name: _vm.name,
              refName: _vm.refName,
              openDate: _vm.openDate,
              placeholder: _vm.placeholder,
              inputClass: _vm.inputClass,
              typeable: _vm.typeable,
              clearButton: _vm.clearButton,
              clearButtonIcon: _vm.clearButtonIcon,
              calendarButton: _vm.calendarButton,
              calendarButtonIcon: _vm.calendarButtonIcon,
              calendarButtonIconContent: _vm.calendarButtonIconContent,
              disabled: _vm.disabled,
              required: _vm.required,
              bootstrapStyling: _vm.bootstrapStyling,
              "use-utc": _vm.useUtc
            },
            on: {
              showCalendar: _vm.showCalendar,
              closeCalendar: _vm.close,
              typedDate: _vm.setTypedDate,
              clearDate: _vm.clearDate
            }
          },
          [_vm._t("afterDateInput", null, { slot: "afterDateInput" })],
          2
        ),
        _vm._v(" "),
        _vm.allowedToShowView("day")
          ? _c(
              "picker-day",
              {
                attrs: {
                  pageDate: _vm.pageDate,
                  selectedDate: _vm.selectedDate,
                  showDayView: _vm.showDayView,
                  fullMonthName: _vm.fullMonthName,
                  allowedToShowView: _vm.allowedToShowView,
                  disabledDates: _vm.disabledDates,
                  highlighted: _vm.highlighted,
                  calendarClass: _vm.calendarClass,
                  calendarStyle: _vm.calendarStyle,
                  translation: _vm.translation,
                  pageTimestamp: _vm.pageTimestamp,
                  isRtl: _vm.isRtl,
                  mondayFirst: _vm.mondayFirst,
                  dayCellContent: _vm.dayCellContent,
                  "use-utc": _vm.useUtc
                },
                on: {
                  changedMonth: _vm.handleChangedMonthFromDayPicker,
                  selectDate: _vm.selectDate,
                  showMonthCalendar: _vm.showMonthCalendar,
                  selectedDisabled: _vm.selectDisabledDate
                }
              },
              [
                _vm._t("beforeCalendarHeader", null, {
                  slot: "beforeCalendarHeader"
                })
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.allowedToShowView("month")
          ? _c(
              "picker-month",
              {
                attrs: {
                  pageDate: _vm.pageDate,
                  selectedDate: _vm.selectedDate,
                  showMonthView: _vm.showMonthView,
                  allowedToShowView: _vm.allowedToShowView,
                  disabledDates: _vm.disabledDates,
                  calendarClass: _vm.calendarClass,
                  calendarStyle: _vm.calendarStyle,
                  translation: _vm.translation,
                  isRtl: _vm.isRtl,
                  "use-utc": _vm.useUtc
                },
                on: {
                  selectMonth: _vm.selectMonth,
                  showYearCalendar: _vm.showYearCalendar,
                  changedYear: _vm.setPageDate
                }
              },
              [
                _vm._t("beforeCalendarHeader", null, {
                  slot: "beforeCalendarHeader"
                })
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.allowedToShowView("year")
          ? _c(
              "picker-year",
              {
                attrs: {
                  pageDate: _vm.pageDate,
                  selectedDate: _vm.selectedDate,
                  showYearView: _vm.showYearView,
                  allowedToShowView: _vm.allowedToShowView,
                  disabledDates: _vm.disabledDates,
                  calendarClass: _vm.calendarClass,
                  calendarStyle: _vm.calendarStyle,
                  translation: _vm.translation,
                  isRtl: _vm.isRtl,
                  "use-utc": _vm.useUtc
                },
                on: { selectYear: _vm.selectYear, changedDecade: _vm.setPageDate }
              },
              [
                _vm._t("beforeCalendarHeader", null, {
                  slot: "beforeCalendarHeader"
                })
              ],
              2
            )
          : _vm._e()
      ],
      1
    )
  };
  var __vue_staticRenderFns__$4 = [];
  __vue_render__$4._withStripped = true;

    /* style */
    const __vue_inject_styles__$4 = function (inject) {
      if (!inject) return
      inject("data-v-64ca2bb5_0", { source: ".rtl {\n  direction: rtl;\n}\n.vdp-datepicker {\n  position: relative;\n  text-align: left;\n}\n.vdp-datepicker * {\n  box-sizing: border-box;\n}\n.vdp-datepicker__calendar {\n  position: absolute;\n  z-index: 100;\n  background: #fff;\n  width: 300px;\n  border: 1px solid #ccc;\n}\n.vdp-datepicker__calendar header {\n  display: block;\n  line-height: 40px;\n}\n.vdp-datepicker__calendar header span {\n  display: inline-block;\n  text-align: center;\n  width: 71.42857142857143%;\n  float: left;\n}\n.vdp-datepicker__calendar header .prev,\n.vdp-datepicker__calendar header .next {\n  width: 14.285714285714286%;\n  float: left;\n  text-indent: -10000px;\n  position: relative;\n}\n.vdp-datepicker__calendar header .prev:after,\n.vdp-datepicker__calendar header .next:after {\n  content: '';\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translateX(-50%) translateY(-50%);\n  border: 6px solid transparent;\n}\n.vdp-datepicker__calendar header .prev:after {\n  border-right: 10px solid #000;\n  margin-left: -5px;\n}\n.vdp-datepicker__calendar header .prev.disabled:after {\n  border-right: 10px solid #ddd;\n}\n.vdp-datepicker__calendar header .next:after {\n  border-left: 10px solid #000;\n  margin-left: 5px;\n}\n.vdp-datepicker__calendar header .next.disabled:after {\n  border-left: 10px solid #ddd;\n}\n.vdp-datepicker__calendar header .prev:not(.disabled),\n.vdp-datepicker__calendar header .next:not(.disabled),\n.vdp-datepicker__calendar header .up:not(.disabled) {\n  cursor: pointer;\n}\n.vdp-datepicker__calendar header .prev:not(.disabled):hover,\n.vdp-datepicker__calendar header .next:not(.disabled):hover,\n.vdp-datepicker__calendar header .up:not(.disabled):hover {\n  background: #eee;\n}\n.vdp-datepicker__calendar .disabled {\n  color: #ddd;\n  cursor: default;\n}\n.vdp-datepicker__calendar .flex-rtl {\n  display: flex;\n  width: inherit;\n  flex-wrap: wrap;\n}\n.vdp-datepicker__calendar .cell {\n  display: inline-block;\n  padding: 0 5px;\n  width: 14.285714285714286%;\n  height: 40px;\n  line-height: 40px;\n  text-align: center;\n  vertical-align: middle;\n  border: 1px solid transparent;\n}\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year {\n  cursor: pointer;\n}\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {\n  border: 1px solid #4bd;\n}\n.vdp-datepicker__calendar .cell.selected {\n  background: #4bd;\n}\n.vdp-datepicker__calendar .cell.selected:hover {\n  background: #4bd;\n}\n.vdp-datepicker__calendar .cell.selected.highlighted {\n  background: #4bd;\n}\n.vdp-datepicker__calendar .cell.highlighted {\n  background: #cae5ed;\n}\n.vdp-datepicker__calendar .cell.highlighted.disabled {\n  color: #a3a3a3;\n}\n.vdp-datepicker__calendar .cell.grey {\n  color: #888;\n}\n.vdp-datepicker__calendar .cell.grey:hover {\n  background: inherit;\n}\n.vdp-datepicker__calendar .cell.day-header {\n  font-size: 75%;\n  white-space: nowrap;\n  cursor: inherit;\n}\n.vdp-datepicker__calendar .cell.day-header:hover {\n  background: inherit;\n}\n.vdp-datepicker__calendar .month,\n.vdp-datepicker__calendar .year {\n  width: 33.333%;\n}\n.vdp-datepicker__clear-button,\n.vdp-datepicker__calendar-button {\n  cursor: pointer;\n  font-style: normal;\n}\n.vdp-datepicker__clear-button.disabled,\n.vdp-datepicker__calendar-button.disabled {\n  color: #999;\n  cursor: default;\n}\n", map: {"version":3,"sources":["Datepicker.vue"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;AACb;AACA;;EAEE,0BAA0B;EAC1B,WAAW;EACX,qBAAqB;EACrB,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,4CAA4C;EAC5C,6BAA6B;AAC/B;AACA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,4BAA4B;AAC9B;AACA;;;EAGE,eAAe;AACjB;AACA;;;EAGE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,aAAa;EACb,cAAc;EACd,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,0BAA0B;EAC1B,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,6BAA6B;AAC/B;AACA;;;EAGE,eAAe;AACjB;AACA;;;EAGE,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,eAAe;EACf,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,eAAe;AACjB","file":"Datepicker.vue","sourcesContent":[".rtl {\n  direction: rtl;\n}\n.vdp-datepicker {\n  position: relative;\n  text-align: left;\n}\n.vdp-datepicker * {\n  box-sizing: border-box;\n}\n.vdp-datepicker__calendar {\n  position: absolute;\n  z-index: 100;\n  background: #fff;\n  width: 300px;\n  border: 1px solid #ccc;\n}\n.vdp-datepicker__calendar header {\n  display: block;\n  line-height: 40px;\n}\n.vdp-datepicker__calendar header span {\n  display: inline-block;\n  text-align: center;\n  width: 71.42857142857143%;\n  float: left;\n}\n.vdp-datepicker__calendar header .prev,\n.vdp-datepicker__calendar header .next {\n  width: 14.285714285714286%;\n  float: left;\n  text-indent: -10000px;\n  position: relative;\n}\n.vdp-datepicker__calendar header .prev:after,\n.vdp-datepicker__calendar header .next:after {\n  content: '';\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translateX(-50%) translateY(-50%);\n  border: 6px solid transparent;\n}\n.vdp-datepicker__calendar header .prev:after {\n  border-right: 10px solid #000;\n  margin-left: -5px;\n}\n.vdp-datepicker__calendar header .prev.disabled:after {\n  border-right: 10px solid #ddd;\n}\n.vdp-datepicker__calendar header .next:after {\n  border-left: 10px solid #000;\n  margin-left: 5px;\n}\n.vdp-datepicker__calendar header .next.disabled:after {\n  border-left: 10px solid #ddd;\n}\n.vdp-datepicker__calendar header .prev:not(.disabled),\n.vdp-datepicker__calendar header .next:not(.disabled),\n.vdp-datepicker__calendar header .up:not(.disabled) {\n  cursor: pointer;\n}\n.vdp-datepicker__calendar header .prev:not(.disabled):hover,\n.vdp-datepicker__calendar header .next:not(.disabled):hover,\n.vdp-datepicker__calendar header .up:not(.disabled):hover {\n  background: #eee;\n}\n.vdp-datepicker__calendar .disabled {\n  color: #ddd;\n  cursor: default;\n}\n.vdp-datepicker__calendar .flex-rtl {\n  display: flex;\n  width: inherit;\n  flex-wrap: wrap;\n}\n.vdp-datepicker__calendar .cell {\n  display: inline-block;\n  padding: 0 5px;\n  width: 14.285714285714286%;\n  height: 40px;\n  line-height: 40px;\n  text-align: center;\n  vertical-align: middle;\n  border: 1px solid transparent;\n}\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year {\n  cursor: pointer;\n}\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {\n  border: 1px solid #4bd;\n}\n.vdp-datepicker__calendar .cell.selected {\n  background: #4bd;\n}\n.vdp-datepicker__calendar .cell.selected:hover {\n  background: #4bd;\n}\n.vdp-datepicker__calendar .cell.selected.highlighted {\n  background: #4bd;\n}\n.vdp-datepicker__calendar .cell.highlighted {\n  background: #cae5ed;\n}\n.vdp-datepicker__calendar .cell.highlighted.disabled {\n  color: #a3a3a3;\n}\n.vdp-datepicker__calendar .cell.grey {\n  color: #888;\n}\n.vdp-datepicker__calendar .cell.grey:hover {\n  background: inherit;\n}\n.vdp-datepicker__calendar .cell.day-header {\n  font-size: 75%;\n  white-space: nowrap;\n  cursor: inherit;\n}\n.vdp-datepicker__calendar .cell.day-header:hover {\n  background: inherit;\n}\n.vdp-datepicker__calendar .month,\n.vdp-datepicker__calendar .year {\n  width: 33.333%;\n}\n.vdp-datepicker__clear-button,\n.vdp-datepicker__calendar-button {\n  cursor: pointer;\n  font-style: normal;\n}\n.vdp-datepicker__clear-button.disabled,\n.vdp-datepicker__calendar-button.disabled {\n  color: #999;\n  cursor: default;\n}\n"]}, media: undefined });

    };
    /* scoped */
    const __vue_scope_id__$4 = undefined;
    /* module identifier */
    const __vue_module_identifier__$4 = undefined;
    /* functional template */
    const __vue_is_functional_template__$4 = false;
    /* style inject SSR */
    

    
    var Datepicker = normalizeComponent_1(
      { render: __vue_render__$4, staticRenderFns: __vue_staticRenderFns__$4 },
      __vue_inject_styles__$4,
      __vue_script__$4,
      __vue_scope_id__$4,
      __vue_is_functional_template__$4,
      __vue_module_identifier__$4,
      browser,
      undefined
    );

  return Datepicker;

}));

},{}],802:[function(require,module,exports){
!function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.VuejsPaginate=t():e.VuejsPaginate=t()}(this,function(){return function(e){function t(s){if(n[s])return n[s].exports;var a=n[s]={exports:{},id:s,loaded:!1};return e[s].call(a.exports,a,a.exports,t),a.loaded=!0,a.exports}var n={};return t.m=e,t.c=n,t.p="",t(0)}([function(e,t,n){"use strict";function s(e){return e&&e.__esModule?e:{default:e}}var a=n(1),i=s(a);e.exports=i.default},function(e,t,n){n(2);var s=n(6)(n(7),n(8),"data-v-82963a40",null);e.exports=s.exports},function(e,t,n){var s=n(3);"string"==typeof s&&(s=[[e.id,s,""]]);n(5)(s,{});s.locals&&(e.exports=s.locals)},function(e,t,n){t=e.exports=n(4)(),t.push([e.id,"a[data-v-82963a40]{cursor:pointer}",""])},function(e,t){e.exports=function(){var e=[];return e.toString=function(){for(var e=[],t=0;t<this.length;t++){var n=this[t];n[2]?e.push("@media "+n[2]+"{"+n[1]+"}"):e.push(n[1])}return e.join("")},e.i=function(t,n){"string"==typeof t&&(t=[[null,t,""]]);for(var s={},a=0;a<this.length;a++){var i=this[a][0];"number"==typeof i&&(s[i]=!0)}for(a=0;a<t.length;a++){var r=t[a];"number"==typeof r[0]&&s[r[0]]||(n&&!r[2]?r[2]=n:n&&(r[2]="("+r[2]+") and ("+n+")"),e.push(r))}},e}},function(e,t,n){function s(e,t){for(var n=0;n<e.length;n++){var s=e[n],a=c[s.id];if(a){a.refs++;for(var i=0;i<a.parts.length;i++)a.parts[i](s.parts[i]);for(;i<s.parts.length;i++)a.parts.push(l(s.parts[i],t))}else{for(var r=[],i=0;i<s.parts.length;i++)r.push(l(s.parts[i],t));c[s.id]={id:s.id,refs:1,parts:r}}}}function a(e){for(var t=[],n={},s=0;s<e.length;s++){var a=e[s],i=a[0],r=a[1],o=a[2],l=a[3],u={css:r,media:o,sourceMap:l};n[i]?n[i].parts.push(u):t.push(n[i]={id:i,parts:[u]})}return t}function i(e,t){var n=g(),s=C[C.length-1];if("top"===e.insertAt)s?s.nextSibling?n.insertBefore(t,s.nextSibling):n.appendChild(t):n.insertBefore(t,n.firstChild),C.push(t);else{if("bottom"!==e.insertAt)throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");n.appendChild(t)}}function r(e){e.parentNode.removeChild(e);var t=C.indexOf(e);t>=0&&C.splice(t,1)}function o(e){var t=document.createElement("style");return t.type="text/css",i(e,t),t}function l(e,t){var n,s,a;if(t.singleton){var i=v++;n=h||(h=o(t)),s=u.bind(null,n,i,!1),a=u.bind(null,n,i,!0)}else n=o(t),s=d.bind(null,n),a=function(){r(n)};return s(e),function(t){if(t){if(t.css===e.css&&t.media===e.media&&t.sourceMap===e.sourceMap)return;s(e=t)}else a()}}function u(e,t,n,s){var a=n?"":s.css;if(e.styleSheet)e.styleSheet.cssText=b(t,a);else{var i=document.createTextNode(a),r=e.childNodes;r[t]&&e.removeChild(r[t]),r.length?e.insertBefore(i,r[t]):e.appendChild(i)}}function d(e,t){var n=t.css,s=t.media,a=t.sourceMap;if(s&&e.setAttribute("media",s),a&&(n+="\n/*# sourceURL="+a.sources[0]+" */",n+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(a))))+" */"),e.styleSheet)e.styleSheet.cssText=n;else{for(;e.firstChild;)e.removeChild(e.firstChild);e.appendChild(document.createTextNode(n))}}var c={},p=function(e){var t;return function(){return"undefined"==typeof t&&(t=e.apply(this,arguments)),t}},f=p(function(){return/msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase())}),g=p(function(){return document.head||document.getElementsByTagName("head")[0]}),h=null,v=0,C=[];e.exports=function(e,t){t=t||{},"undefined"==typeof t.singleton&&(t.singleton=f()),"undefined"==typeof t.insertAt&&(t.insertAt="bottom");var n=a(e);return s(n,t),function(e){for(var i=[],r=0;r<n.length;r++){var o=n[r],l=c[o.id];l.refs--,i.push(l)}if(e){var u=a(e);s(u,t)}for(var r=0;r<i.length;r++){var l=i[r];if(0===l.refs){for(var d=0;d<l.parts.length;d++)l.parts[d]();delete c[l.id]}}}};var b=function(){var e=[];return function(t,n){return e[t]=n,e.filter(Boolean).join("\n")}}()},function(e,t){e.exports=function(e,t,n,s){var a,i=e=e||{},r=typeof e.default;"object"!==r&&"function"!==r||(a=e,i=e.default);var o="function"==typeof i?i.options:i;if(t&&(o.render=t.render,o.staticRenderFns=t.staticRenderFns),n&&(o._scopeId=n),s){var l=o.computed||(o.computed={});Object.keys(s).forEach(function(e){var t=s[e];l[e]=function(){return t}})}return{esModule:a,exports:i,options:o}}},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default={props:{value:{type:Number},pageCount:{type:Number,required:!0},forcePage:{type:Number},clickHandler:{type:Function,default:function(){}},pageRange:{type:Number,default:3},marginPages:{type:Number,default:1},prevText:{type:String,default:"Prev"},nextText:{type:String,default:"Next"},breakViewText:{type:String,default:"…"},containerClass:{type:String},pageClass:{type:String},pageLinkClass:{type:String},prevClass:{type:String},prevLinkClass:{type:String},nextClass:{type:String},nextLinkClass:{type:String},breakViewClass:{type:String},breakViewLinkClass:{type:String},activeClass:{type:String,default:"active"},disabledClass:{type:String,default:"disabled"},noLiSurround:{type:Boolean,default:!1},firstLastButton:{type:Boolean,default:!1},firstButtonText:{type:String,default:"First"},lastButtonText:{type:String,default:"Last"},hidePrevNext:{type:Boolean,default:!1}},beforeUpdate:function(){void 0!==this.forcePage&&this.forcePage!==this.selected&&(this.selected=this.forcePage)},computed:{selected:{get:function(){return this.value||this.innerValue},set:function(e){this.innerValue=e}},pages:function(){var e=this,t={};if(this.pageCount<=this.pageRange)for(var n=0;n<this.pageCount;n++){var s={index:n,content:n+1,selected:n===this.selected-1};t[n]=s}else{for(var a=Math.floor(this.pageRange/2),i=function(n){var s={index:n,content:n+1,selected:n===e.selected-1};t[n]=s},r=function(e){var n={disabled:!0,breakView:!0};t[e]=n},o=0;o<this.marginPages;o++)i(o);var l=0;this.selected-a>0&&(l=this.selected-1-a);var u=l+this.pageRange-1;u>=this.pageCount&&(u=this.pageCount-1,l=u-this.pageRange+1);for(var d=l;d<=u&&d<=this.pageCount-1;d++)i(d);l>this.marginPages&&r(l-1),u+1<this.pageCount-this.marginPages&&r(u+1);for(var c=this.pageCount-1;c>=this.pageCount-this.marginPages;c--)i(c)}return t}},data:function(){return{innerValue:1}},methods:{handlePageSelected:function(e){this.selected!==e&&(this.innerValue=e,this.$emit("input",e),this.clickHandler(e))},prevPage:function(){this.selected<=1||this.handlePageSelected(this.selected-1)},nextPage:function(){this.selected>=this.pageCount||this.handlePageSelected(this.selected+1)},firstPageSelected:function(){return 1===this.selected},lastPageSelected:function(){return this.selected===this.pageCount||0===this.pageCount},selectFirstPage:function(){this.selected<=1||this.handlePageSelected(1)},selectLastPage:function(){this.selected>=this.pageCount||this.handlePageSelected(this.pageCount)}}}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return e.noLiSurround?n("div",{class:e.containerClass},[e.firstLastButton?n("a",{class:[e.pageLinkClass,e.firstPageSelected()?e.disabledClass:""],attrs:{tabindex:"0"},domProps:{innerHTML:e._s(e.firstButtonText)},on:{click:function(t){e.selectFirstPage()},keyup:function(t){return"button"in t||!e._k(t.keyCode,"enter",13)?void e.selectFirstPage():null}}}):e._e(),e._v(" "),e.firstPageSelected()&&e.hidePrevNext?e._e():n("a",{class:[e.prevLinkClass,e.firstPageSelected()?e.disabledClass:""],attrs:{tabindex:"0"},domProps:{innerHTML:e._s(e.prevText)},on:{click:function(t){e.prevPage()},keyup:function(t){return"button"in t||!e._k(t.keyCode,"enter",13)?void e.prevPage():null}}}),e._v(" "),e._l(e.pages,function(t){return[t.breakView?n("a",{class:[e.pageLinkClass,e.breakViewLinkClass,t.disabled?e.disabledClass:""],attrs:{tabindex:"0"}},[e._t("breakViewContent",[e._v(e._s(e.breakViewText))])],2):t.disabled?n("a",{class:[e.pageLinkClass,t.selected?e.activeClass:"",e.disabledClass],attrs:{tabindex:"0"}},[e._v(e._s(t.content))]):n("a",{class:[e.pageLinkClass,t.selected?e.activeClass:""],attrs:{tabindex:"0"},on:{click:function(n){e.handlePageSelected(t.index+1)},keyup:function(n){return"button"in n||!e._k(n.keyCode,"enter",13)?void e.handlePageSelected(t.index+1):null}}},[e._v(e._s(t.content))])]}),e._v(" "),e.lastPageSelected()&&e.hidePrevNext?e._e():n("a",{class:[e.nextLinkClass,e.lastPageSelected()?e.disabledClass:""],attrs:{tabindex:"0"},domProps:{innerHTML:e._s(e.nextText)},on:{click:function(t){e.nextPage()},keyup:function(t){return"button"in t||!e._k(t.keyCode,"enter",13)?void e.nextPage():null}}}),e._v(" "),e.firstLastButton?n("a",{class:[e.pageLinkClass,e.lastPageSelected()?e.disabledClass:""],attrs:{tabindex:"0"},domProps:{innerHTML:e._s(e.lastButtonText)},on:{click:function(t){e.selectLastPage()},keyup:function(t){return"button"in t||!e._k(t.keyCode,"enter",13)?void e.selectLastPage():null}}}):e._e()],2):n("ul",{class:e.containerClass},[e.firstLastButton?n("li",{class:[e.pageClass,e.firstPageSelected()?e.disabledClass:""]},[n("a",{class:e.pageLinkClass,attrs:{tabindex:e.firstPageSelected()?-1:0},domProps:{innerHTML:e._s(e.firstButtonText)},on:{click:function(t){e.selectFirstPage()},keyup:function(t){return"button"in t||!e._k(t.keyCode,"enter",13)?void e.selectFirstPage():null}}})]):e._e(),e._v(" "),e.firstPageSelected()&&e.hidePrevNext?e._e():n("li",{class:[e.prevClass,e.firstPageSelected()?e.disabledClass:""]},[n("a",{class:e.prevLinkClass,attrs:{tabindex:e.firstPageSelected()?-1:0},domProps:{innerHTML:e._s(e.prevText)},on:{click:function(t){e.prevPage()},keyup:function(t){return"button"in t||!e._k(t.keyCode,"enter",13)?void e.prevPage():null}}})]),e._v(" "),e._l(e.pages,function(t){return n("li",{class:[e.pageClass,t.selected?e.activeClass:"",t.disabled?e.disabledClass:"",t.breakView?e.breakViewClass:""]},[t.breakView?n("a",{class:[e.pageLinkClass,e.breakViewLinkClass],attrs:{tabindex:"0"}},[e._t("breakViewContent",[e._v(e._s(e.breakViewText))])],2):t.disabled?n("a",{class:e.pageLinkClass,attrs:{tabindex:"0"}},[e._v(e._s(t.content))]):n("a",{class:e.pageLinkClass,attrs:{tabindex:"0"},on:{click:function(n){e.handlePageSelected(t.index+1)},keyup:function(n){return"button"in n||!e._k(n.keyCode,"enter",13)?void e.handlePageSelected(t.index+1):null}}},[e._v(e._s(t.content))])])}),e._v(" "),e.lastPageSelected()&&e.hidePrevNext?e._e():n("li",{class:[e.nextClass,e.lastPageSelected()?e.disabledClass:""]},[n("a",{class:e.nextLinkClass,attrs:{tabindex:e.lastPageSelected()?-1:0},domProps:{innerHTML:e._s(e.nextText)},on:{click:function(t){e.nextPage()},keyup:function(t){return"button"in t||!e._k(t.keyCode,"enter",13)?void e.nextPage():null}}})]),e._v(" "),e.firstLastButton?n("li",{class:[e.pageClass,e.lastPageSelected()?e.disabledClass:""]},[n("a",{class:e.pageLinkClass,attrs:{tabindex:e.lastPageSelected()?-1:0},domProps:{innerHTML:e._s(e.lastButtonText)},on:{click:function(t){e.selectLastPage()},keyup:function(t){return"button"in t||!e._k(t.keyCode,"enter",13)?void e.selectLastPage():null}}})]):e._e()],2)},staticRenderFns:[]}}])});
},{}],803:[function(require,module,exports){
(function (process){
/**
 * vuex v2.5.0
 * (c) 2017 Evan You
 * @license MIT
 */
'use strict';

var applyMixin = function (Vue) {
  var version = Number(Vue.version.split('.')[0]);

  if (version >= 2) {
    Vue.mixin({ beforeCreate: vuexInit });
  } else {
    // override init and inject vuex init procedure
    // for 1.x backwards compatibility.
    var _init = Vue.prototype._init;
    Vue.prototype._init = function (options) {
      if ( options === void 0 ) options = {};

      options.init = options.init
        ? [vuexInit].concat(options.init)
        : vuexInit;
      _init.call(this, options);
    };
  }

  /**
   * Vuex init hook, injected into each instances init hooks list.
   */

  function vuexInit () {
    var options = this.$options;
    // store injection
    if (options.store) {
      this.$store = typeof options.store === 'function'
        ? options.store()
        : options.store;
    } else if (options.parent && options.parent.$store) {
      this.$store = options.parent.$store;
    }
  }
};

var devtoolHook =
  typeof window !== 'undefined' &&
  window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

function devtoolPlugin (store) {
  if (!devtoolHook) { return }

  store._devtoolHook = devtoolHook;

  devtoolHook.emit('vuex:init', store);

  devtoolHook.on('vuex:travel-to-state', function (targetState) {
    store.replaceState(targetState);
  });

  store.subscribe(function (mutation, state) {
    devtoolHook.emit('vuex:mutation', mutation, state);
  });
}

/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */
/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */


/**
 * forEach for object
 */
function forEachValue (obj, fn) {
  Object.keys(obj).forEach(function (key) { return fn(obj[key], key); });
}

function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

function isPromise (val) {
  return val && typeof val.then === 'function'
}

function assert (condition, msg) {
  if (!condition) { throw new Error(("[vuex] " + msg)) }
}

var Module = function Module (rawModule, runtime) {
  this.runtime = runtime;
  this._children = Object.create(null);
  this._rawModule = rawModule;
  var rawState = rawModule.state;
  this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
};

var prototypeAccessors$1 = { namespaced: { configurable: true } };

prototypeAccessors$1.namespaced.get = function () {
  return !!this._rawModule.namespaced
};

Module.prototype.addChild = function addChild (key, module) {
  this._children[key] = module;
};

Module.prototype.removeChild = function removeChild (key) {
  delete this._children[key];
};

Module.prototype.getChild = function getChild (key) {
  return this._children[key]
};

Module.prototype.update = function update (rawModule) {
  this._rawModule.namespaced = rawModule.namespaced;
  if (rawModule.actions) {
    this._rawModule.actions = rawModule.actions;
  }
  if (rawModule.mutations) {
    this._rawModule.mutations = rawModule.mutations;
  }
  if (rawModule.getters) {
    this._rawModule.getters = rawModule.getters;
  }
};

Module.prototype.forEachChild = function forEachChild (fn) {
  forEachValue(this._children, fn);
};

Module.prototype.forEachGetter = function forEachGetter (fn) {
  if (this._rawModule.getters) {
    forEachValue(this._rawModule.getters, fn);
  }
};

Module.prototype.forEachAction = function forEachAction (fn) {
  if (this._rawModule.actions) {
    forEachValue(this._rawModule.actions, fn);
  }
};

Module.prototype.forEachMutation = function forEachMutation (fn) {
  if (this._rawModule.mutations) {
    forEachValue(this._rawModule.mutations, fn);
  }
};

Object.defineProperties( Module.prototype, prototypeAccessors$1 );

var ModuleCollection = function ModuleCollection (rawRootModule) {
  // register root module (Vuex.Store options)
  this.register([], rawRootModule, false);
};

ModuleCollection.prototype.get = function get (path) {
  return path.reduce(function (module, key) {
    return module.getChild(key)
  }, this.root)
};

ModuleCollection.prototype.getNamespace = function getNamespace (path) {
  var module = this.root;
  return path.reduce(function (namespace, key) {
    module = module.getChild(key);
    return namespace + (module.namespaced ? key + '/' : '')
  }, '')
};

ModuleCollection.prototype.update = function update$1 (rawRootModule) {
  update([], this.root, rawRootModule);
};

ModuleCollection.prototype.register = function register (path, rawModule, runtime) {
    var this$1 = this;
    if ( runtime === void 0 ) runtime = true;

  if (process.env.NODE_ENV !== 'production') {
    assertRawModule(path, rawModule);
  }

  var newModule = new Module(rawModule, runtime);
  if (path.length === 0) {
    this.root = newModule;
  } else {
    var parent = this.get(path.slice(0, -1));
    parent.addChild(path[path.length - 1], newModule);
  }

  // register nested modules
  if (rawModule.modules) {
    forEachValue(rawModule.modules, function (rawChildModule, key) {
      this$1.register(path.concat(key), rawChildModule, runtime);
    });
  }
};

ModuleCollection.prototype.unregister = function unregister (path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];
  if (!parent.getChild(key).runtime) { return }

  parent.removeChild(key);
};

function update (path, targetModule, newModule) {
  if (process.env.NODE_ENV !== 'production') {
    assertRawModule(path, newModule);
  }

  // update target module
  targetModule.update(newModule);

  // update nested modules
  if (newModule.modules) {
    for (var key in newModule.modules) {
      if (!targetModule.getChild(key)) {
        if (process.env.NODE_ENV !== 'production') {
          console.warn(
            "[vuex] trying to add a new module '" + key + "' on hot reloading, " +
            'manual reload is needed'
          );
        }
        return
      }
      update(
        path.concat(key),
        targetModule.getChild(key),
        newModule.modules[key]
      );
    }
  }
}

var functionAssert = {
  assert: function (value) { return typeof value === 'function'; },
  expected: 'function'
};

var objectAssert = {
  assert: function (value) { return typeof value === 'function' ||
    (typeof value === 'object' && typeof value.handler === 'function'); },
  expected: 'function or object with "handler" function'
};

var assertTypes = {
  getters: functionAssert,
  mutations: functionAssert,
  actions: objectAssert
};

function assertRawModule (path, rawModule) {
  Object.keys(assertTypes).forEach(function (key) {
    if (!rawModule[key]) { return }

    var assertOptions = assertTypes[key];

    forEachValue(rawModule[key], function (value, type) {
      assert(
        assertOptions.assert(value),
        makeAssertionMessage(path, key, type, value, assertOptions.expected)
      );
    });
  });
}

function makeAssertionMessage (path, key, type, value, expected) {
  var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";
  if (path.length > 0) {
    buf += " in module \"" + (path.join('.')) + "\"";
  }
  buf += " is " + (JSON.stringify(value)) + ".";
  return buf
}

var Vue; // bind on install

var Store = function Store (options) {
  var this$1 = this;
  if ( options === void 0 ) options = {};

  // Auto install if it is not done yet and `window` has `Vue`.
  // To allow users to avoid auto-installation in some cases,
  // this code should be placed here. See #731
  if (!Vue && typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
  }

  if (process.env.NODE_ENV !== 'production') {
    assert(Vue, "must call Vue.use(Vuex) before creating a store instance.");
    assert(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.");
    assert(this instanceof Store, "Store must be called with the new operator.");
  }

  var plugins = options.plugins; if ( plugins === void 0 ) plugins = [];
  var strict = options.strict; if ( strict === void 0 ) strict = false;

  var state = options.state; if ( state === void 0 ) state = {};
  if (typeof state === 'function') {
    state = state() || {};
  }

  // store internal state
  this._committing = false;
  this._actions = Object.create(null);
  this._actionSubscribers = [];
  this._mutations = Object.create(null);
  this._wrappedGetters = Object.create(null);
  this._modules = new ModuleCollection(options);
  this._modulesNamespaceMap = Object.create(null);
  this._subscribers = [];
  this._watcherVM = new Vue();

  // bind commit and dispatch to self
  var store = this;
  var ref = this;
  var dispatch = ref.dispatch;
  var commit = ref.commit;
  this.dispatch = function boundDispatch (type, payload) {
    return dispatch.call(store, type, payload)
  };
  this.commit = function boundCommit (type, payload, options) {
    return commit.call(store, type, payload, options)
  };

  // strict mode
  this.strict = strict;

  // init root module.
  // this also recursively registers all sub-modules
  // and collects all module getters inside this._wrappedGetters
  installModule(this, state, [], this._modules.root);

  // initialize the store vm, which is responsible for the reactivity
  // (also registers _wrappedGetters as computed properties)
  resetStoreVM(this, state);

  // apply plugins
  plugins.forEach(function (plugin) { return plugin(this$1); });

  if (Vue.config.devtools) {
    devtoolPlugin(this);
  }
};

var prototypeAccessors = { state: { configurable: true } };

prototypeAccessors.state.get = function () {
  return this._vm._data.$$state
};

prototypeAccessors.state.set = function (v) {
  if (process.env.NODE_ENV !== 'production') {
    assert(false, "Use store.replaceState() to explicit replace store state.");
  }
};

Store.prototype.commit = function commit (_type, _payload, _options) {
    var this$1 = this;

  // check object-style commit
  var ref = unifyObjectStyle(_type, _payload, _options);
    var type = ref.type;
    var payload = ref.payload;
    var options = ref.options;

  var mutation = { type: type, payload: payload };
  var entry = this._mutations[type];
  if (!entry) {
    if (process.env.NODE_ENV !== 'production') {
      console.error(("[vuex] unknown mutation type: " + type));
    }
    return
  }
  this._withCommit(function () {
    entry.forEach(function commitIterator (handler) {
      handler(payload);
    });
  });
  this._subscribers.forEach(function (sub) { return sub(mutation, this$1.state); });

  if (
    process.env.NODE_ENV !== 'production' &&
    options && options.silent
  ) {
    console.warn(
      "[vuex] mutation type: " + type + ". Silent option has been removed. " +
      'Use the filter functionality in the vue-devtools'
    );
  }
};

Store.prototype.dispatch = function dispatch (_type, _payload) {
    var this$1 = this;

  // check object-style dispatch
  var ref = unifyObjectStyle(_type, _payload);
    var type = ref.type;
    var payload = ref.payload;

  var action = { type: type, payload: payload };
  var entry = this._actions[type];
  if (!entry) {
    if (process.env.NODE_ENV !== 'production') {
      console.error(("[vuex] unknown action type: " + type));
    }
    return
  }

  this._actionSubscribers.forEach(function (sub) { return sub(action, this$1.state); });

  return entry.length > 1
    ? Promise.all(entry.map(function (handler) { return handler(payload); }))
    : entry[0](payload)
};

Store.prototype.subscribe = function subscribe (fn) {
  return genericSubscribe(fn, this._subscribers)
};

Store.prototype.subscribeAction = function subscribeAction (fn) {
  return genericSubscribe(fn, this._actionSubscribers)
};

Store.prototype.watch = function watch (getter, cb, options) {
    var this$1 = this;

  if (process.env.NODE_ENV !== 'production') {
    assert(typeof getter === 'function', "store.watch only accepts a function.");
  }
  return this._watcherVM.$watch(function () { return getter(this$1.state, this$1.getters); }, cb, options)
};

Store.prototype.replaceState = function replaceState (state) {
    var this$1 = this;

  this._withCommit(function () {
    this$1._vm._data.$$state = state;
  });
};

Store.prototype.registerModule = function registerModule (path, rawModule, options) {
    if ( options === void 0 ) options = {};

  if (typeof path === 'string') { path = [path]; }

  if (process.env.NODE_ENV !== 'production') {
    assert(Array.isArray(path), "module path must be a string or an Array.");
    assert(path.length > 0, 'cannot register the root module by using registerModule.');
  }

  this._modules.register(path, rawModule);
  installModule(this, this.state, path, this._modules.get(path), options.preserveState);
  // reset store to update getters...
  resetStoreVM(this, this.state);
};

Store.prototype.unregisterModule = function unregisterModule (path) {
    var this$1 = this;

  if (typeof path === 'string') { path = [path]; }

  if (process.env.NODE_ENV !== 'production') {
    assert(Array.isArray(path), "module path must be a string or an Array.");
  }

  this._modules.unregister(path);
  this._withCommit(function () {
    var parentState = getNestedState(this$1.state, path.slice(0, -1));
    Vue.delete(parentState, path[path.length - 1]);
  });
  resetStore(this);
};

Store.prototype.hotUpdate = function hotUpdate (newOptions) {
  this._modules.update(newOptions);
  resetStore(this, true);
};

Store.prototype._withCommit = function _withCommit (fn) {
  var committing = this._committing;
  this._committing = true;
  fn();
  this._committing = committing;
};

Object.defineProperties( Store.prototype, prototypeAccessors );

function genericSubscribe (fn, subs) {
  if (subs.indexOf(fn) < 0) {
    subs.push(fn);
  }
  return function () {
    var i = subs.indexOf(fn);
    if (i > -1) {
      subs.splice(i, 1);
    }
  }
}

function resetStore (store, hot) {
  store._actions = Object.create(null);
  store._mutations = Object.create(null);
  store._wrappedGetters = Object.create(null);
  store._modulesNamespaceMap = Object.create(null);
  var state = store.state;
  // init all modules
  installModule(store, state, [], store._modules.root, true);
  // reset vm
  resetStoreVM(store, state, hot);
}

function resetStoreVM (store, state, hot) {
  var oldVm = store._vm;

  // bind store public getters
  store.getters = {};
  var wrappedGetters = store._wrappedGetters;
  var computed = {};
  forEachValue(wrappedGetters, function (fn, key) {
    // use computed to leverage its lazy-caching mechanism
    computed[key] = function () { return fn(store); };
    Object.defineProperty(store.getters, key, {
      get: function () { return store._vm[key]; },
      enumerable: true // for local getters
    });
  });

  // use a Vue instance to store the state tree
  // suppress warnings just in case the user has added
  // some funky global mixins
  var silent = Vue.config.silent;
  Vue.config.silent = true;
  store._vm = new Vue({
    data: {
      $$state: state
    },
    computed: computed
  });
  Vue.config.silent = silent;

  // enable strict mode for new vm
  if (store.strict) {
    enableStrictMode(store);
  }

  if (oldVm) {
    if (hot) {
      // dispatch changes in all subscribed watchers
      // to force getter re-evaluation for hot reloading.
      store._withCommit(function () {
        oldVm._data.$$state = null;
      });
    }
    Vue.nextTick(function () { return oldVm.$destroy(); });
  }
}

function installModule (store, rootState, path, module, hot) {
  var isRoot = !path.length;
  var namespace = store._modules.getNamespace(path);

  // register in namespace map
  if (module.namespaced) {
    store._modulesNamespaceMap[namespace] = module;
  }

  // set state
  if (!isRoot && !hot) {
    var parentState = getNestedState(rootState, path.slice(0, -1));
    var moduleName = path[path.length - 1];
    store._withCommit(function () {
      Vue.set(parentState, moduleName, module.state);
    });
  }

  var local = module.context = makeLocalContext(store, namespace, path);

  module.forEachMutation(function (mutation, key) {
    var namespacedType = namespace + key;
    registerMutation(store, namespacedType, mutation, local);
  });

  module.forEachAction(function (action, key) {
    var type = action.root ? key : namespace + key;
    var handler = action.handler || action;
    registerAction(store, type, handler, local);
  });

  module.forEachGetter(function (getter, key) {
    var namespacedType = namespace + key;
    registerGetter(store, namespacedType, getter, local);
  });

  module.forEachChild(function (child, key) {
    installModule(store, rootState, path.concat(key), child, hot);
  });
}

/**
 * make localized dispatch, commit, getters and state
 * if there is no namespace, just use root ones
 */
function makeLocalContext (store, namespace, path) {
  var noNamespace = namespace === '';

  var local = {
    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (process.env.NODE_ENV !== 'production' && !store._actions[type]) {
          console.error(("[vuex] unknown local action type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      return store.dispatch(type, payload)
    },

    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (process.env.NODE_ENV !== 'production' && !store._mutations[type]) {
          console.error(("[vuex] unknown local mutation type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      store.commit(type, payload, options);
    }
  };

  // getters and state object must be gotten lazily
  // because they will be changed by vm update
  Object.defineProperties(local, {
    getters: {
      get: noNamespace
        ? function () { return store.getters; }
        : function () { return makeLocalGetters(store, namespace); }
    },
    state: {
      get: function () { return getNestedState(store.state, path); }
    }
  });

  return local
}

function makeLocalGetters (store, namespace) {
  var gettersProxy = {};

  var splitPos = namespace.length;
  Object.keys(store.getters).forEach(function (type) {
    // skip if the target getter is not match this namespace
    if (type.slice(0, splitPos) !== namespace) { return }

    // extract local getter type
    var localType = type.slice(splitPos);

    // Add a port to the getters proxy.
    // Define as getter property because
    // we do not want to evaluate the getters in this time.
    Object.defineProperty(gettersProxy, localType, {
      get: function () { return store.getters[type]; },
      enumerable: true
    });
  });

  return gettersProxy
}

function registerMutation (store, type, handler, local) {
  var entry = store._mutations[type] || (store._mutations[type] = []);
  entry.push(function wrappedMutationHandler (payload) {
    handler.call(store, local.state, payload);
  });
}

function registerAction (store, type, handler, local) {
  var entry = store._actions[type] || (store._actions[type] = []);
  entry.push(function wrappedActionHandler (payload, cb) {
    var res = handler.call(store, {
      dispatch: local.dispatch,
      commit: local.commit,
      getters: local.getters,
      state: local.state,
      rootGetters: store.getters,
      rootState: store.state
    }, payload, cb);
    if (!isPromise(res)) {
      res = Promise.resolve(res);
    }
    if (store._devtoolHook) {
      return res.catch(function (err) {
        store._devtoolHook.emit('vuex:error', err);
        throw err
      })
    } else {
      return res
    }
  });
}

function registerGetter (store, type, rawGetter, local) {
  if (store._wrappedGetters[type]) {
    if (process.env.NODE_ENV !== 'production') {
      console.error(("[vuex] duplicate getter key: " + type));
    }
    return
  }
  store._wrappedGetters[type] = function wrappedGetter (store) {
    return rawGetter(
      local.state, // local state
      local.getters, // local getters
      store.state, // root state
      store.getters // root getters
    )
  };
}

function enableStrictMode (store) {
  store._vm.$watch(function () { return this._data.$$state }, function () {
    if (process.env.NODE_ENV !== 'production') {
      assert(store._committing, "Do not mutate vuex store state outside mutation handlers.");
    }
  }, { deep: true, sync: true });
}

function getNestedState (state, path) {
  return path.length
    ? path.reduce(function (state, key) { return state[key]; }, state)
    : state
}

function unifyObjectStyle (type, payload, options) {
  if (isObject(type) && type.type) {
    options = payload;
    payload = type;
    type = type.type;
  }

  if (process.env.NODE_ENV !== 'production') {
    assert(typeof type === 'string', ("Expects string as the type, but found " + (typeof type) + "."));
  }

  return { type: type, payload: payload, options: options }
}

function install (_Vue) {
  if (Vue && _Vue === Vue) {
    if (process.env.NODE_ENV !== 'production') {
      console.error(
        '[vuex] already installed. Vue.use(Vuex) should be called only once.'
      );
    }
    return
  }
  Vue = _Vue;
  applyMixin(Vue);
}

var mapState = normalizeNamespace(function (namespace, states) {
  var res = {};
  normalizeMap(states).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedState () {
      var state = this.$store.state;
      var getters = this.$store.getters;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapState', namespace);
        if (!module) {
          return
        }
        state = module.context.state;
        getters = module.context.getters;
      }
      return typeof val === 'function'
        ? val.call(this, state, getters)
        : state[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

var mapMutations = normalizeNamespace(function (namespace, mutations) {
  var res = {};
  normalizeMap(mutations).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedMutation () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      var commit = this.$store.commit;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);
        if (!module) {
          return
        }
        commit = module.context.commit;
      }
      return typeof val === 'function'
        ? val.apply(this, [commit].concat(args))
        : commit.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

var mapGetters = normalizeNamespace(function (namespace, getters) {
  var res = {};
  normalizeMap(getters).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    val = namespace + val;
    res[key] = function mappedGetter () {
      if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
        return
      }
      if (process.env.NODE_ENV !== 'production' && !(val in this.$store.getters)) {
        console.error(("[vuex] unknown getter: " + val));
        return
      }
      return this.$store.getters[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

var mapActions = normalizeNamespace(function (namespace, actions) {
  var res = {};
  normalizeMap(actions).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedAction () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      var dispatch = this.$store.dispatch;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapActions', namespace);
        if (!module) {
          return
        }
        dispatch = module.context.dispatch;
      }
      return typeof val === 'function'
        ? val.apply(this, [dispatch].concat(args))
        : dispatch.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

var createNamespacedHelpers = function (namespace) { return ({
  mapState: mapState.bind(null, namespace),
  mapGetters: mapGetters.bind(null, namespace),
  mapMutations: mapMutations.bind(null, namespace),
  mapActions: mapActions.bind(null, namespace)
}); };

function normalizeMap (map) {
  return Array.isArray(map)
    ? map.map(function (key) { return ({ key: key, val: key }); })
    : Object.keys(map).map(function (key) { return ({ key: key, val: map[key] }); })
}

function normalizeNamespace (fn) {
  return function (namespace, map) {
    if (typeof namespace !== 'string') {
      map = namespace;
      namespace = '';
    } else if (namespace.charAt(namespace.length - 1) !== '/') {
      namespace += '/';
    }
    return fn(namespace, map)
  }
}

function getModuleByNamespace (store, helper, namespace) {
  var module = store._modulesNamespaceMap[namespace];
  if (process.env.NODE_ENV !== 'production' && !module) {
    console.error(("[vuex] module namespace not found in " + helper + "(): " + namespace));
  }
  return module
}

var index = {
  Store: Store,
  install: install,
  version: '2.5.0',
  mapState: mapState,
  mapMutations: mapMutations,
  mapGetters: mapGetters,
  mapActions: mapActions,
  createNamespacedHelpers: createNamespacedHelpers
};

module.exports = index;

}).call(this,require('_process'))
},{"_process":734}],804:[function(require,module,exports){
'use strict';

var alphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_'.split('')
  , length = 64
  , map = {}
  , seed = 0
  , i = 0
  , prev;

/**
 * Return a string representing the specified number.
 *
 * @param {Number} num The number to convert.
 * @returns {String} The string representation of the number.
 * @api public
 */
function encode(num) {
  var encoded = '';

  do {
    encoded = alphabet[num % length] + encoded;
    num = Math.floor(num / length);
  } while (num > 0);

  return encoded;
}

/**
 * Return the integer value specified by the given string.
 *
 * @param {String} str The string to convert.
 * @returns {Number} The integer value represented by the string.
 * @api public
 */
function decode(str) {
  var decoded = 0;

  for (i = 0; i < str.length; i++) {
    decoded = decoded * length + map[str.charAt(i)];
  }

  return decoded;
}

/**
 * Yeast: A tiny growing id generator.
 *
 * @returns {String} A unique id.
 * @api public
 */
function yeast() {
  var now = encode(+new Date());

  if (now !== prev) return seed = 0, prev = now;
  return now +'.'+ encode(seed++);
}

//
// Map each character to its index.
//
for (; i < length; i++) map[alphabet[i]] = i;

//
// Expose the `yeast`, `encode` and `decode` functions.
//
yeast.encode = encode;
yeast.decode = decode;
module.exports = yeast;

},{}],805:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _socialite = require("./socialite");

var _socialite2 = _interopRequireDefault(_socialite);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Default socialite class.
 */
var Default = function (_Socialite) {
  (0, _inherits3.default)(Default, _Socialite);

  function Default() {
    (0, _classCallCheck3.default)(this, Default);
    return (0, _possibleConstructorReturn3.default)(this, (Default.__proto__ || (0, _getPrototypeOf2.default)(Default)).apply(this, arguments));
  }

  (0, _createClass3.default)(Default, [{
    key: "getConfigKey",

    /**
     * Get config key-name.
     * @return {string}
     */
    value: function getConfigKey() {
      return "Default";
    }

    /**
     * Check application agent is valid.
     * @param next Vue router next-routing tool
     */

  }, {
    key: "checkAgent",
    value: function checkAgent(obj) {
      // nothing to do.
      return this;
    }

    /**
     * Init socialite.
     * @param next Vue router next-routing tool
     */

  }, {
    key: "init",
    value: function init(next) {
      // nothing to do.
      return this;
    }

    /**
     * Pre-inject login data.
     * @param context Vue component instance
     * @returns {{userId: *, token: *}}
     */

  }, {
    key: "loginData",
    value: function loginData(context) {
      return {};
    }

    /* Override for block login actions */
    /**
     * Login by the social platform
     * @param context Vue component instance
     */

  }, {
    key: "login",
    value: function login(context) {
      throw "無法進行登入";
    }

    /**
     * Get login hook.
     * @param params Login params
     * @returns {*}
     */

  }, {
    key: "loginHook",
    value: function loginHook(params) {
      throw "無法進行登入";
    }

    /** Open external window with URL
     * @param url
    */

  }, {
    key: "newWindow",
    value: function newWindow(url) {
      window.open(url, '_blank');
    }
  }]);
  return Default;
}(_socialite2.default);

exports.default = new Default();

},{"./socialite":809,"babel-runtime/core-js/object/get-prototype-of":55,"babel-runtime/helpers/classCallCheck":63,"babel-runtime/helpers/createClass":64,"babel-runtime/helpers/inherits":67,"babel-runtime/helpers/possibleConstructorReturn":69}],806:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _socialite = require('./socialite');

var _socialite2 = _interopRequireDefault(_socialite);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Default socialite class.
 */
var Facebook = function (_Socialite) {
    (0, _inherits3.default)(Facebook, _Socialite);

    function Facebook() {
        (0, _classCallCheck3.default)(this, Facebook);
        return (0, _possibleConstructorReturn3.default)(this, (Facebook.__proto__ || (0, _getPrototypeOf2.default)(Facebook)).apply(this, arguments));
    }

    (0, _createClass3.default)(Facebook, [{
        key: 'getConfigKey',

        /**
         * Get config key-name.
         * @return {string}
         */
        value: function getConfigKey() {
            return "Facebook";
        }

        /**
         * Check application agent is valid.
         * @param next Vue router next-routing tool
         */

    }, {
        key: 'checkAgent',
        value: function checkAgent(obj) {
            if (Configs.APP_ENV === 'production') {
                var userAgent = navigator.userAgent || navigator.vendor || window.opera;
                var isMessanerAgent = userAgent.indexOf("FBAN") !== -1 || userAgent.indexOf("FBAV") !== -1;

                if (!isMessanerAgent) {
                    this.wrongAgent(obj.next);
                } else {
                    obj.next();
                }
            } else {
                obj.next();
            }

            return this;
        }

        /**
         * Init socialite.
         * @param next Vue router next-routing tool
         */

    }, {
        key: 'init',
        value: function init(next) {
            return this;
        }

        /**
         * Pre-inject login data.
         * @param context Vue component instance
         * @returns {{userId: *, token: *}}
         */

    }, {
        key: 'loginData',
        value: function loginData(context) {
            return {};
        }
    }]);
    return Facebook;
}(_socialite2.default);

exports.default = new Facebook();

},{"./socialite":809,"babel-runtime/core-js/object/get-prototype-of":55,"babel-runtime/helpers/classCallCheck":63,"babel-runtime/helpers/createClass":64,"babel-runtime/helpers/inherits":67,"babel-runtime/helpers/possibleConstructorReturn":69}],807:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _fb = require('./fb');

var _fb2 = _interopRequireDefault(_fb);

var _default = require('./default');

var _default2 = _interopRequireDefault(_default);

var _seventeenFit = require('./seventeen-fit');

var _seventeenFit2 = _interopRequireDefault(_seventeenFit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var factory = {
    /**
     * Get platform list.
     * @returns {{default: Default, fb: Facebook, seventeenFit: SeventeenFit}}
     */
    getPlatforms: function getPlatforms() {
        return {
            "fb": _fb2.default,
            "default": _default2.default,
            "seventeen-fit": _seventeenFit2.default
        };
    },

    /**
     * Get platform instance.
     * @param type
     * @returns {*}
     */
    platform: function platform(type) {
        var platforms = this.getPlatforms();
        if (platforms[type]) {
            return platforms[type];
        } else {
            throw '\u4E0D\u652F\u63F4\u6B64\u7A2E\u793E\u7FA4\u5E73\u53F0 [' + type + ']';
        }
    }
};

exports.default = factory;

},{"./default":805,"./fb":806,"./seventeen-fit":808}],808:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _socialite = require("./socialite");

var _socialite2 = _interopRequireDefault(_socialite);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Default socialite class.
 */
var SeventeenFit = function (_Socialite) {
  (0, _inherits3.default)(SeventeenFit, _Socialite);

  function SeventeenFit() {
    (0, _classCallCheck3.default)(this, SeventeenFit);
    return (0, _possibleConstructorReturn3.default)(this, (SeventeenFit.__proto__ || (0, _getPrototypeOf2.default)(SeventeenFit)).apply(this, arguments));
  }

  (0, _createClass3.default)(SeventeenFit, [{
    key: "getConfigKey",

    /**
     * Get config key-name.
     * @return {string}
     */
    value: function getConfigKey() {
      return "seventeen-fit";
    }

    /**
     * Check application agent is valid.
     * @param next Vue router next-routing tool
     */

  }, {
    key: "checkAgent",
    value: function checkAgent(obj) {
      obj.next();

      return this;
    }

    /**
     * Init socialite.
     * @param next Vue router next-routing tool
     */

  }, {
    key: "init",
    value: function init(next) {
      return this;
    }

    /**
     * Pre-inject login data.
     * @param context Vue component instance
     * @returns {{userId: *, token: *}}
     */

  }, {
    key: "loginData",
    value: function loginData(context) {
      return {};
    }
  }]);
  return SeventeenFit;
}(_socialite2.default);

exports.default = new SeventeenFit();

},{"./socialite":809,"babel-runtime/core-js/object/get-prototype-of":55,"babel-runtime/helpers/classCallCheck":63,"babel-runtime/helpers/createClass":64,"babel-runtime/helpers/inherits":67,"babel-runtime/helpers/possibleConstructorReturn":69}],809:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Soicalite class.
 */
var Socialite = function () {
    function Socialite() {
        (0, _classCallCheck3.default)(this, Socialite);
    }

    (0, _createClass3.default)(Socialite, [{
        key: "getConfigKey",


        /**
         * Get config key-name.
         * @return {string}
         */
        value: function getConfigKey() {
            var msg = "Not implement error.";
            throw Error(msg);
        }

        /**
         * Get static configs for socialite.
         * @return {object}
         */

    }, {
        key: "getConfig",
        value: function getConfig() {
            if (!globalThis.Configs) {
                var msg = "Connot find default config from global variable [Configs] error.";
                throw Error(msg);
            }

            var key = this.getConfigKey();
            if (!globalThis.Configs[key]) {
                var _msg = "Connot find config [" + key + "] from global variable [Configs] error.";
                throw Error(_msg);
            }

            return globalThis.Configs[key];
        }

        /**
         * Redirect by current socialite url.
         * @param next {object} Vue route
         * @param args {object}
         */

    }, {
        key: "redirect",
        value: function redirect(next, args) {
            args.params = args.params || {};
            // args.params.platform = this.getConfig().urlPlatform;
            next(args);
        }

        /**
         * Redirect to wrong agent page.
         * @param next {object} Vue route
         */

    }, {
        key: "wrongAgent",
        value: function wrongAgent(next) {}
        // this.redirect(next, { name: 'WrongAgent' });


        /**
         * Login by the social platform
         * @param context Vue component instance
         */

    }, {
        key: "login",
        value: function login(context) {
            context.$refs.submitLogin.submit();
        }

        /**
         * Get login hook.
         * @param params Login params
         * @returns {*}
         */

    }, {
        key: "loginHook",
        value: function loginHook(params) {
            params = {
                urlPlatform: params.platform,
                destUrl: params.destUrl,
                errorUrl: params.errorUrl
            };

            return {
                'mainWeb.login': {
                    loginUrl: '/login',
                    destUrl: params.destUrl,
                    errorUrl: params.errorUrl
                }
            };
        }

        /* Method define for implements */

        /**
         * Check application agent is valid.
         * @param next Vue router next-routing tool
         */

    }, {
        key: "checkAgent",
        value: function checkAgent(obj) {
            throw Error("Not implement error.");
        }

        /**
         * Init socialite.
         * @param next Vue router next-routing tool
         */

    }, {
        key: "init",
        value: function init(next) {
            throw Error("Not implement error.");
        }

        /**
         * Pre-inject login data.
         * @param context Vue component instance
         * @returns {{userId: *, token: *}}
         */

    }, {
        key: "loginData",
        value: function loginData(context) {
            throw Error("Not implement error.");
        }
    }]);
    return Socialite;
}();

exports.default = Socialite;

},{"babel-runtime/helpers/classCallCheck":63,"babel-runtime/helpers/createClass":64}],810:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n.datepicker-overlay[_v-3748b198] {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  z-index: 998;\n  top: 0;\n  left: 0;\n  overflow: hidden;\n  -webkit-animation: fadein 0.5s;\n  /* Safari, Chrome and Opera > 12.1 */\n  -moz-animation: fadein 0.5s;\n  /* Firefox < 16 */\n  -ms-animation: fadein 0.5s;\n  /* Internet Explorer */\n  -o-animation: fadein 0.5s;\n  /* Opera < 12.1 */\n  animation: fadein 0.5s;\n}\n@keyframes fadein {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n/* Firefox < 16 */\n@-moz-keyframes fadein {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n/* Safari, Chrome and Opera > 12.1 */\n@-webkit-keyframes fadein {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n/* Internet Explorer */\n@-ms-keyframes fadein {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n/* Opera < 12.1 */\n@-o-keyframes fadein {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n.cov-date-body[_v-3748b198] {\n  display: inline-block;\n  background: #3F51B5;\n  overflow: hidden;\n  position: relative;\n  font-size: 16px;\n  font-family: 'Roboto';\n  font-weight: 400;\n  position: fixed;\n  display: block;\n  width: 400px;\n  max-width: 100%;\n  z-index: 999;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);\n}\n.cov-picker-box[_v-3748b198] {\n  background: #fff;\n  width: 100%;\n  display: inline-block;\n  padding: 25px;\n  box-sizing: border-box !important;\n  -moz-box-sizing: border-box !important;\n  -webkit-box-sizing: border-box !important;\n  -ms-box-sizing: border-box !important;\n  width: 400px;\n  max-width: 100%;\n  height: 280px;\n  text-align: start!important;\n}\n.cov-picker-box td[_v-3748b198] {\n  height: 34px;\n  width: 34px;\n  padding: 0;\n  line-height: 34px;\n  color: #000;\n  background: #fff;\n  text-align: center;\n  cursor: pointer;\n}\n.cov-picker-box td[_v-3748b198]:hover {\n  background: #E6E6E6;\n}\ntable[_v-3748b198] {\n  border-collapse: collapse;\n  border-spacing: 0;\n  width: 100%;\n}\n.day[_v-3748b198] {\n  width: 14.2857143%;\n  display: inline-block;\n  text-align: center;\n  cursor: pointer;\n  height: 34px;\n  padding: 0;\n  line-height: 34px;\n  color: #000;\n  background: #fff;\n  vertical-align: middle;\n}\n.week ul[_v-3748b198] {\n  margin: 0 0 8px;\n  padding: 0;\n  list-style: none;\n}\n.week ul li[_v-3748b198] {\n  width: 14.2%;\n  display: inline-block;\n  text-align: center;\n  background: transparent;\n  color: #000;\n  font-weight: bold;\n}\n.passive-day[_v-3748b198] {\n  color: #bbb;\n}\n.checked[_v-3748b198] {\n  background: #F50057;\n  color: #FFF !important;\n  border-radius: 3px;\n}\n.unavailable[_v-3748b198] {\n  color: #ccc;\n  cursor: not-allowed;\n}\n.cov-date-monthly[_v-3748b198] {\n  height: 150px;\n}\n.cov-date-monthly > div[_v-3748b198] {\n  display: inline-block;\n  padding: 0;\n  margin: 0;\n  vertical-align: middle;\n  color: #fff;\n  height: 150px;\n  float: left;\n  text-align: center;\n  cursor: pointer;\n}\n.cov-date-previous[_v-3748b198],\n.cov-date-next[_v-3748b198] {\n  position: relative;\n  width: 20% !important;\n  text-indent: -300px;\n  overflow: hidden;\n  color: #fff;\n}\n.cov-date-caption[_v-3748b198] {\n  width: 60%;\n  padding: 50px 0!important;\n  box-sizing: border-box;\n  font-size: 24px;\n}\n.cov-date-caption span[_v-3748b198]:hover {\n  color: rgba(255, 255, 255, 0.7);\n}\n.cov-date-previous[_v-3748b198]:hover,\n.cov-date-next[_v-3748b198]:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n.day[_v-3748b198]:hover {\n  background: #EAEAEA;\n}\n.unavailable[_v-3748b198]:hover {\n  background: none;\n}\n.checked[_v-3748b198]:hover {\n  background: #FF4F8E;\n}\n.cov-date-next[_v-3748b198]::before,\n.cov-date-previous[_v-3748b198]::before {\n  width: 20px;\n  height: 2px;\n  text-align: center;\n  position: absolute;\n  background: #fff;\n  top: 50%;\n  margin-top: -7px;\n  margin-left: -7px;\n  left: 50%;\n  line-height: 0;\n  content: '';\n  -webkit-transform: rotate(45deg);\n  -moz-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n.cov-date-next[_v-3748b198]::after,\n.cov-date-previous[_v-3748b198]::after {\n  width: 20px;\n  height: 2px;\n  text-align: center;\n  position: absolute;\n  background: #fff;\n  margin-top: 6px;\n  margin-left: -7px;\n  top: 50%;\n  left: 50%;\n  line-height: 0;\n  content: '';\n  -webkit-transform: rotate(-45deg);\n  -moz-transform: rotate(-45deg);\n  transform: rotate(-45deg);\n}\n.cov-date-previous[_v-3748b198]::after {\n  -webkit-transform: rotate(45deg);\n  -moz-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n.cov-date-previous[_v-3748b198]::before {\n  -webkit-transform: rotate(-45deg);\n  -moz-transform: rotate(-45deg);\n  transform: rotate(-45deg);\n}\n.date-item[_v-3748b198] {\n  text-align: center;\n  font-size: 20px;\n  padding: 10px 0;\n  cursor: pointer;\n}\n.date-item[_v-3748b198]:hover {\n  background: #e0e0e0;\n}\n.date-list[_v-3748b198] {\n  overflow: auto;\n  vertical-align: top;\n  padding: 0;\n}\n.cov-vue-date[_v-3748b198] {\n  display: inline-block;\n  color: #5D5D5D;\n}\n.button-box[_v-3748b198] {\n  background: #fff;\n  vertical-align: top;\n  height: 50px;\n  line-height: 50px;\n  text-align: right;\n  padding-right: 20px;\n}\n.button-box span[_v-3748b198] {\n  cursor: pointer;\n  padding: 10px 20px;\n}\n.watch-box[_v-3748b198] {\n  height: 100%;\n  overflow: hidden;\n}\n.hour-box[_v-3748b198],\n.min-box[_v-3748b198] {\n  display: inline-block;\n  width: 50%;\n  text-align: center;\n  height: 100%;\n  overflow: auto;\n  float: left;\n}\n.hour-box ul[_v-3748b198],\n.min-box ul[_v-3748b198] {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.hour-item[_v-3748b198],\n.min-item[_v-3748b198] {\n  padding: 10px;\n  font-size: 36px;\n  cursor: pointer;\n}\n.hour-item[_v-3748b198]:hover,\n.min-item[_v-3748b198]:hover {\n  background: #E3E3E3;\n}\n.disabled[_v-3748b198] {\n  background-color: #E3E3E3;\n}\n.hour-box .active[_v-3748b198],\n.min-box .active[_v-3748b198] {\n  background: #F50057;\n  color: #FFF !important;\n}\n[_v-3748b198]::-webkit-scrollbar {\n  width: 2px;\n}\n[_v-3748b198]::-webkit-scrollbar-track {\n  background: #E3E3E3;\n}\n[_v-3748b198]::-webkit-scrollbar-thumb {\n  background: #C1C1C1;\n  border-radius: 2px;\n}\n")


'use strict';

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault2(_stringify);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault2(_getIterator2);

function _interopRequireDefault2(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = {
  props: {
    required: false,
    disabled: false,
    date: {
      type: Object,
      required: true
    },
    option: {
      type: Object,
      default: function _default() {
        return {
          type: 'day',
          SundayFirst: false,
          week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
          month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
          format: 'YYYY-MM-DD',
          color: {
            checked: '#F50057',
            header: '#3f51b5',
            headerText: '#fff'
          },
          inputStyle: {
            'display': 'inline-block',
            'padding': '6px',
            'line-height': '22px',
            'font-size': '16px',
            'border': '2px solid #fff',
            'box-shadow': '0 1px 3px 0 rgba(0, 0, 0, 0.2)',
            'border-radius': '2px',
            'color': '#5F5F5F'
          },
          placeholder: 'when?',
          buttons: {
            ok: 'OK',
            cancel: 'Cancel'
          },
          overlayOpacity: 0.5,
          dismissible: true
        };
      }
    },
    limit: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    function hours() {
      var list = [];
      var hour = 24;
      while (hour > 0) {
        hour--;
        list.push({
          checked: false,
          value: hour < 10 ? '0' + hour : hour
        });
      }
      return list;
    }
    function mins() {
      var list = [];
      var min = 60;
      while (min > 0) {
        min--;
        list.push({
          checked: false,
          value: min < 10 ? '0' + min : min
        });
      }
      return list;
    }
    return {
      hours: hours(),
      mins: mins(),
      showInfo: {
        hour: false,
        day: false,
        month: false,
        year: false,
        check: false
      },
      displayInfo: {
        month: ''
      },
      library: {
        week: this.option.week,
        month: this.option.month,
        year: []
      },
      checked: {
        oldtime: '',
        currentMoment: null,
        year: '',
        month: '',
        day: '',
        hour: '00',
        min: '00'
      },
      dayList: [],
      selectedDays: []
    };
  },

  methods: {
    pad: function pad(n) {
      n = Math.floor(n);
      return n < 10 ? '0' + n : n;
    },
    nextMonth: function nextMonth(type) {
      var next = null;
      type === 'next' ? next = (0, _moment2.default)(this.checked.currentMoment).add(1, 'M') : next = (0, _moment2.default)(this.checked.currentMoment).add(-1, 'M');
      this.showDay(next);
    },
    showDay: function showDay(time) {
      if (time === undefined || !Date.parse(time)) {
        this.checked.currentMoment = (0, _moment2.default)();
      } else {
        this.checked.currentMoment = (0, _moment2.default)(time, this.option.format);
      }
      this.showOne('day');
      this.checked.year = (0, _moment2.default)(this.checked.currentMoment).format('YYYY');
      this.checked.month = (0, _moment2.default)(this.checked.currentMoment).format('MM');
      this.checked.day = (0, _moment2.default)(this.checked.currentMoment).format('DD');
      this.displayInfo.month = this.library.month[(0, _moment2.default)(this.checked.currentMoment).month()];
      var days = [];
      var currentMoment = this.checked.currentMoment;
      var firstDay = (0, _moment2.default)(currentMoment).date(1).day();
      // gettting previous and next month
      // let currentMonth = moment(currentMoment)
      var previousMonth = (0, _moment2.default)(currentMoment);
      var nextMonth = (0, _moment2.default)(currentMoment);
      nextMonth.add(1, 'months');
      previousMonth.subtract(1, 'months');
      var monthDays = (0, _moment2.default)(currentMoment).daysInMonth();
      var oldtime = this.checked.oldtime;
      for (var i = 1; i <= monthDays; ++i) {
        days.push({
          value: i,
          inMonth: true,
          unavailable: false,
          checked: false,
          moment: (0, _moment2.default)(currentMoment).date(i)
        });
        if (i === Math.ceil((0, _moment2.default)(currentMoment).format('D')) && (0, _moment2.default)(oldtime, this.option.format).year() === (0, _moment2.default)(currentMoment).year() && (0, _moment2.default)(oldtime, this.option.format).month() === (0, _moment2.default)(currentMoment).month()) {
          days[i - 1].checked = true;
        }
        this.checkBySelectDays(i, days);
      }
      if (firstDay === 0) firstDay = 7;
      for (var _i = 0; _i < firstDay - (this.option.SundayFirst ? 0 : 1); _i++) {
        var passiveDay = {
          value: previousMonth.daysInMonth() - _i,
          inMonth: false,
          action: 'previous',
          unavailable: false,
          checked: false,
          moment: (0, _moment2.default)(currentMoment).date(1).subtract(_i + 1, 'days')
        };
        days.unshift(passiveDay);
      }
      if (this.limit.length > 0) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = (0, _getIterator3.default)(this.limit), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var li = _step.value;

            switch (li.type) {
              case 'fromto':
                days = this.limitFromTo(li, days);
                break;
              case 'weekday':
                days = this.limitWeekDay(li, days);
                break;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      var passiveDaysAtFinal = 42 - days.length;
      for (var _i2 = 1; _i2 <= passiveDaysAtFinal; _i2++) {
        var _passiveDay = {
          value: _i2,
          inMonth: false,
          action: 'next',
          unavailable: false,
          checked: false,
          moment: (0, _moment2.default)(currentMoment).add(1, 'months').date(_i2)
        };
        days.push(_passiveDay);
      }
      this.dayList = days;
    },
    checkBySelectDays: function checkBySelectDays(d, days) {
      var _this = this;

      this.selectedDays.forEach(function (day) {
        if (_this.checked.year === (0, _moment2.default)(day).format('YYYY') && _this.checked.month === (0, _moment2.default)(day).format('MM') && d === Math.ceil((0, _moment2.default)(day).format('D'))) {
          days[d - 1].checked = true;
        }
      });
    },
    limitWeekDay: function limitWeekDay(limit, days) {
      days.map(function (day) {
        if (limit.available.indexOf(Math.floor(day.moment.format('d'))) === -1) {
          day.unavailable = true;
        }
      });
      return days;
    },
    limitFromTo: function limitFromTo(limit, days) {
      var _this2 = this;

      if (limit.from || limit.to) {
        days.map(function (day) {
          if (_this2.getLimitCondition(limit, day)) {
            day.unavailable = true;
          }
        });
      }
      return days;
    },
    getLimitCondition: function getLimitCondition(limit, day) {
      var tmpMoment = (0, _moment2.default)(this.checked.year + '-' + this.pad(this.checked.month) + '-' + this.pad(day.value));
      if (limit.from && !limit.to) {
        return !tmpMoment.isAfter(limit.from);
      } else if (!limit.from && limit.to) {
        return !tmpMoment.isBefore(limit.to);
      } else {
        return !tmpMoment.isBetween(limit.from, limit.to);
      }
    },
    checkDay: function checkDay(obj) {
      if (obj.unavailable || obj.value === '') {
        return false;
      }
      if (!obj.inMonth) {
        this.nextMonth(obj.action);
      }
      if (this.option.type === 'day' || this.option.type === 'min') {
        this.dayList.forEach(function (x) {
          x.checked = false;
        });
        this.checked.day = this.pad(obj.value);
        obj.checked = true;
      } else {
        var day = this.pad(obj.value);
        var ctime = this.checked.year + '-' + this.checked.month + '-' + day;
        if (obj.checked === true) {
          obj.checked = false;
          this.selectedDays.$remove(ctime);
        } else {
          this.selectedDays.push(ctime);
          obj.checked = true;
        }
      }
      switch (this.option.type) {
        case 'day':
          this.picked();
          break;
        case 'min':
          this.showOne('hour');
          // shift activated time items to visible position.
          this.shiftActTime();
          break;
      }
    },
    showYear: function showYear() {
      var _this3 = this;

      var year = (0, _moment2.default)(this.checked.currentMoment).year();
      this.library.year = [];
      var yearTmp = [];
      for (var i = year - 100; i < year + 5; ++i) {
        yearTmp.push(i);
      }
      this.library.year = yearTmp;
      this.showOne('year');
      this.$nextTick(function () {
        var listDom = document.getElementById('yearList');
        listDom.scrollTop = listDom.scrollHeight - 100;
        _this3.addYear();
      });
    },
    showOne: function showOne(type) {
      switch (type) {
        case 'year':
          this.showInfo.hour = false;
          this.showInfo.day = false;
          this.showInfo.year = true;
          this.showInfo.month = false;
          break;
        case 'month':
          this.showInfo.hour = false;
          this.showInfo.day = false;
          this.showInfo.year = false;
          this.showInfo.month = true;
          break;
        case 'day':
          this.showInfo.hour = false;
          this.showInfo.day = true;
          this.showInfo.year = false;
          this.showInfo.month = false;
          break;
        case 'hour':
          this.showInfo.hour = true;
          this.showInfo.day = false;
          this.showInfo.year = false;
          this.showInfo.month = false;
          break;
        default:
          this.showInfo.day = true;
          this.showInfo.year = false;
          this.showInfo.month = false;
          this.showInfo.hour = false;
      }
    },
    showMonth: function showMonth() {
      this.showOne('month');
    },
    addYear: function addYear() {
      var _this4 = this;

      var listDom = document.getElementById('yearList');
      listDom.addEventListener('scroll', function (e) {
        if (listDom.scrollTop < listDom.scrollHeight - 100) {
          var len = _this4.library.year.length;
          var lastYear = _this4.library.year[len - 1];
          _this4.library.year.push(lastYear + 1);
        }
      }, false);
    },
    setYear: function setYear(year) {
      this.checked.currentMoment = (0, _moment2.default)(year + '-' + this.checked.month + '-' + this.checked.day);
      this.showDay(this.checked.currentMoment);
    },
    setMonth: function setMonth(month) {
      var mo = this.library.month.indexOf(month) + 1;
      if (mo < 10) {
        mo = '0' + '' + mo;
      }
      this.checked.currentMoment = (0, _moment2.default)(this.checked.year + '-' + mo + '-' + this.checked.day);
      this.showDay(this.checked.currentMoment);
    },
    showCheck: function showCheck() {
      if (this.date.time === '') {
        this.showDay();
      } else {
        if (this.option.type === 'day' || this.option.type === 'min') {
          this.checked.oldtime = this.date.time;
          this.showDay(this.date.time);
        } else {
          this.selectedDays = JSON.parse(this.date.time);
          if (this.selectedDays.length) {
            this.checked.oldtime = this.selectedDays[0];
            this.showDay(this.selectedDays[0]);
          } else {
            this.showDay();
          }
        }
      }
      this.showInfo.check = true;
    },
    setTime: function setTime(type, obj, list) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = (0, _getIterator3.default)(list), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var item = _step2.value;

          item.checked = false;
          if (item.value === obj.value) {
            item.checked = true;
            this.checked[type] = item.value;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    picked: function picked() {
      if (this.option.type === 'day' || this.option.type === 'min') {
        var ctime = this.checked.year + '-' + this.checked.month + '-' + this.checked.day + ' ' + this.checked.hour + ':' + this.checked.min;
        this.checked.currentMoment = (0, _moment2.default)(ctime, 'YYYY-MM-DD HH:mm');
        this.date.time = (0, _moment2.default)(this.checked.currentMoment).format(this.option.format);
      } else {
        this.date.time = (0, _stringify2.default)(this.selectedDays);
      }
      this.showInfo.check = false;
      this.$emit('change', this.date.time);
    },
    dismiss: function dismiss(evt) {
      if (evt.target.className === 'datepicker-overlay') {
        if (this.option.dismissible === undefined || this.option.dismissible) {
          this.showInfo.check = false;
          this.$emit('cancel');
        }
      }
    },
    shiftActTime: function shiftActTime() {
      // shift activated time items to visible position.
      this.$nextTick(function () {
        if (!document.querySelector('.hour-item.active')) {
          return false;
        }
        document.querySelector('.hour-box').scrollTop = (document.querySelector('.hour-item.active').offsetTop || 0) - 250;
        document.querySelector('.min-box').scrollTop = (document.querySelector('.min-item.active').offsetTop || 0) - 250;
      });
    }
  }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"cov-vue-date\" _v-3748b198=\"\">\n  <div class=\"datepickbox\" _v-3748b198=\"\">\n    <input type=\"text\" :disabled=\"disabled\" :class=\"disabled === true ? 'disabled' : ''\" title=\"input date\" class=\"cov-datepicker\" readonly=\"readonly\" :placeholder=\"option.placeholder\" v-model=\"date.time\" :required=\"required\" @click=\"showCheck\" @foucus=\"showCheck\" :style=\"option.inputStyle ? option.inputStyle : {}\" _v-3748b198=\"\">\n  </div>\n  <div class=\"datepicker-overlay\" v-if=\"showInfo.check\" @click=\"dismiss($event)\" v-bind:style=\"{'background' : option.overlayOpacity? 'rgba(0,0,0,'+option.overlayOpacity+')' : 'rgba(0,0,0,0.5)'}\" _v-3748b198=\"\">\n    <div class=\"cov-date-body\" :style=\"{'background-color': option.color ? option.color.header : '#3f51b5'}\" _v-3748b198=\"\">\n      <div class=\"cov-date-monthly\" _v-3748b198=\"\">\n        <div class=\"cov-date-previous\" @click=\"nextMonth('pre')\" _v-3748b198=\"\">«</div>\n        <div class=\"cov-date-caption\" :style=\"{'color': option.color ? option.color.headerText : '#fff'}\" _v-3748b198=\"\">\n          <span @click=\"showYear\" _v-3748b198=\"\"><small _v-3748b198=\"\">{{checked.year}}</small></span>\n          <br _v-3748b198=\"\">\n          <span @click=\"showMonth\" _v-3748b198=\"\">{{displayInfo.month}}</span>\n        </div>\n        <div class=\"cov-date-next\" @click=\"nextMonth('next')\" _v-3748b198=\"\">»</div>\n      </div>\n      <div class=\"cov-date-box\" v-if=\"showInfo.day\" _v-3748b198=\"\">\n        <div class=\"cov-picker-box\" _v-3748b198=\"\">\n          <div class=\"week\" _v-3748b198=\"\">\n            <ul _v-3748b198=\"\">\n              <li v-for=\"weekie in library.week\" _v-3748b198=\"\">{{weekie}}</li>\n            </ul>\n          </div>\n          <div class=\"day\" v-for=\"day in dayList\" track-by=\"$index\" @click=\"checkDay(day)\" :class=\"{'checked':day.checked,'unavailable':day.unavailable,'passive-day': !(day.inMonth)}\" :style=\"day.checked ? (option.color &amp;&amp; option.color.checkedDay ? { background: option.color.checkedDay } : { background: '#F50057' }) : {}\" _v-3748b198=\"\">{{day.value}}</div>\n        </div>\n      </div>\n      <div class=\"cov-date-box list-box\" v-if=\"showInfo.year\" _v-3748b198=\"\">\n        <div class=\"cov-picker-box date-list\" id=\"yearList\" _v-3748b198=\"\">\n          <div class=\"date-item\" v-for=\"yearItem in library.year\" track-by=\"$index\" @click=\"setYear(yearItem)\" _v-3748b198=\"\">{{yearItem}}</div>\n        </div>\n      </div>\n      <div class=\"cov-date-box list-box\" v-if=\"showInfo.month\" _v-3748b198=\"\">\n        <div class=\"cov-picker-box date-list\" _v-3748b198=\"\">\n          <div class=\"date-item\" v-for=\"monthItem in library.month\" track-by=\"$index\" @click=\"setMonth(monthItem)\" _v-3748b198=\"\">{{monthItem}}</div>\n        </div>\n      </div>\n      <div class=\"cov-date-box list-box\" v-if=\"showInfo.hour\" _v-3748b198=\"\">\n        <div class=\"cov-picker-box date-list\" _v-3748b198=\"\">\n          <div class=\"watch-box\" _v-3748b198=\"\">\n            <div class=\"hour-box\" _v-3748b198=\"\">\n              <div class=\"mui-pciker-rule mui-pciker-rule-ft\" _v-3748b198=\"\"></div>\n              <ul _v-3748b198=\"\">\n                <li class=\"hour-item\" v-for=\"hitem in hours\" @click=\"setTime('hour', hitem, hours)\" :class=\"{'active':hitem.checked}\" _v-3748b198=\"\">{{hitem.value}}</li>\n              </ul>\n            </div>\n            <div class=\"min-box\" _v-3748b198=\"\">\n              <div class=\"mui-pciker-rule mui-pciker-rule-ft\" _v-3748b198=\"\"></div>\n              <div class=\"min-item\" v-for=\"mitem in mins\" @click=\"setTime('min',mitem, mins)\" :class=\"{'active':mitem.checked}\" _v-3748b198=\"\">{{mitem.value}}</div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class=\"button-box\" _v-3748b198=\"\">\n        <span @click=\"showInfo.check=false\" _v-3748b198=\"\">{{option.buttons? option.buttons.cancel : 'Cancel' }}</span>\n        <span @click=\"picked\" _v-3748b198=\"\">{{option.buttons? option.buttons.ok : 'Ok'}}</span>\n      </div>\n    </div>\n  </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n.datepicker-overlay[_v-3748b198] {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  z-index: 998;\n  top: 0;\n  left: 0;\n  overflow: hidden;\n  -webkit-animation: fadein 0.5s;\n  /* Safari, Chrome and Opera > 12.1 */\n  -moz-animation: fadein 0.5s;\n  /* Firefox < 16 */\n  -ms-animation: fadein 0.5s;\n  /* Internet Explorer */\n  -o-animation: fadein 0.5s;\n  /* Opera < 12.1 */\n  animation: fadein 0.5s;\n}\n@keyframes fadein {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n/* Firefox < 16 */\n@-moz-keyframes fadein {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n/* Safari, Chrome and Opera > 12.1 */\n@-webkit-keyframes fadein {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n/* Internet Explorer */\n@-ms-keyframes fadein {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n/* Opera < 12.1 */\n@-o-keyframes fadein {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n.cov-date-body[_v-3748b198] {\n  display: inline-block;\n  background: #3F51B5;\n  overflow: hidden;\n  position: relative;\n  font-size: 16px;\n  font-family: 'Roboto';\n  font-weight: 400;\n  position: fixed;\n  display: block;\n  width: 400px;\n  max-width: 100%;\n  z-index: 999;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);\n}\n.cov-picker-box[_v-3748b198] {\n  background: #fff;\n  width: 100%;\n  display: inline-block;\n  padding: 25px;\n  box-sizing: border-box !important;\n  -moz-box-sizing: border-box !important;\n  -webkit-box-sizing: border-box !important;\n  -ms-box-sizing: border-box !important;\n  width: 400px;\n  max-width: 100%;\n  height: 280px;\n  text-align: start!important;\n}\n.cov-picker-box td[_v-3748b198] {\n  height: 34px;\n  width: 34px;\n  padding: 0;\n  line-height: 34px;\n  color: #000;\n  background: #fff;\n  text-align: center;\n  cursor: pointer;\n}\n.cov-picker-box td[_v-3748b198]:hover {\n  background: #E6E6E6;\n}\ntable[_v-3748b198] {\n  border-collapse: collapse;\n  border-spacing: 0;\n  width: 100%;\n}\n.day[_v-3748b198] {\n  width: 14.2857143%;\n  display: inline-block;\n  text-align: center;\n  cursor: pointer;\n  height: 34px;\n  padding: 0;\n  line-height: 34px;\n  color: #000;\n  background: #fff;\n  vertical-align: middle;\n}\n.week ul[_v-3748b198] {\n  margin: 0 0 8px;\n  padding: 0;\n  list-style: none;\n}\n.week ul li[_v-3748b198] {\n  width: 14.2%;\n  display: inline-block;\n  text-align: center;\n  background: transparent;\n  color: #000;\n  font-weight: bold;\n}\n.passive-day[_v-3748b198] {\n  color: #bbb;\n}\n.checked[_v-3748b198] {\n  background: #F50057;\n  color: #FFF !important;\n  border-radius: 3px;\n}\n.unavailable[_v-3748b198] {\n  color: #ccc;\n  cursor: not-allowed;\n}\n.cov-date-monthly[_v-3748b198] {\n  height: 150px;\n}\n.cov-date-monthly > div[_v-3748b198] {\n  display: inline-block;\n  padding: 0;\n  margin: 0;\n  vertical-align: middle;\n  color: #fff;\n  height: 150px;\n  float: left;\n  text-align: center;\n  cursor: pointer;\n}\n.cov-date-previous[_v-3748b198],\n.cov-date-next[_v-3748b198] {\n  position: relative;\n  width: 20% !important;\n  text-indent: -300px;\n  overflow: hidden;\n  color: #fff;\n}\n.cov-date-caption[_v-3748b198] {\n  width: 60%;\n  padding: 50px 0!important;\n  box-sizing: border-box;\n  font-size: 24px;\n}\n.cov-date-caption span[_v-3748b198]:hover {\n  color: rgba(255, 255, 255, 0.7);\n}\n.cov-date-previous[_v-3748b198]:hover,\n.cov-date-next[_v-3748b198]:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n.day[_v-3748b198]:hover {\n  background: #EAEAEA;\n}\n.unavailable[_v-3748b198]:hover {\n  background: none;\n}\n.checked[_v-3748b198]:hover {\n  background: #FF4F8E;\n}\n.cov-date-next[_v-3748b198]::before,\n.cov-date-previous[_v-3748b198]::before {\n  width: 20px;\n  height: 2px;\n  text-align: center;\n  position: absolute;\n  background: #fff;\n  top: 50%;\n  margin-top: -7px;\n  margin-left: -7px;\n  left: 50%;\n  line-height: 0;\n  content: '';\n  -webkit-transform: rotate(45deg);\n  -moz-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n.cov-date-next[_v-3748b198]::after,\n.cov-date-previous[_v-3748b198]::after {\n  width: 20px;\n  height: 2px;\n  text-align: center;\n  position: absolute;\n  background: #fff;\n  margin-top: 6px;\n  margin-left: -7px;\n  top: 50%;\n  left: 50%;\n  line-height: 0;\n  content: '';\n  -webkit-transform: rotate(-45deg);\n  -moz-transform: rotate(-45deg);\n  transform: rotate(-45deg);\n}\n.cov-date-previous[_v-3748b198]::after {\n  -webkit-transform: rotate(45deg);\n  -moz-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n.cov-date-previous[_v-3748b198]::before {\n  -webkit-transform: rotate(-45deg);\n  -moz-transform: rotate(-45deg);\n  transform: rotate(-45deg);\n}\n.date-item[_v-3748b198] {\n  text-align: center;\n  font-size: 20px;\n  padding: 10px 0;\n  cursor: pointer;\n}\n.date-item[_v-3748b198]:hover {\n  background: #e0e0e0;\n}\n.date-list[_v-3748b198] {\n  overflow: auto;\n  vertical-align: top;\n  padding: 0;\n}\n.cov-vue-date[_v-3748b198] {\n  display: inline-block;\n  color: #5D5D5D;\n}\n.button-box[_v-3748b198] {\n  background: #fff;\n  vertical-align: top;\n  height: 50px;\n  line-height: 50px;\n  text-align: right;\n  padding-right: 20px;\n}\n.button-box span[_v-3748b198] {\n  cursor: pointer;\n  padding: 10px 20px;\n}\n.watch-box[_v-3748b198] {\n  height: 100%;\n  overflow: hidden;\n}\n.hour-box[_v-3748b198],\n.min-box[_v-3748b198] {\n  display: inline-block;\n  width: 50%;\n  text-align: center;\n  height: 100%;\n  overflow: auto;\n  float: left;\n}\n.hour-box ul[_v-3748b198],\n.min-box ul[_v-3748b198] {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.hour-item[_v-3748b198],\n.min-item[_v-3748b198] {\n  padding: 10px;\n  font-size: 36px;\n  cursor: pointer;\n}\n.hour-item[_v-3748b198]:hover,\n.min-item[_v-3748b198]:hover {\n  background: #E3E3E3;\n}\n.disabled[_v-3748b198] {\n  background-color: #E3E3E3;\n}\n.hour-box .active[_v-3748b198],\n.min-box .active[_v-3748b198] {\n  background: #F50057;\n  color: #FFF !important;\n}\n[_v-3748b198]::-webkit-scrollbar {\n  width: 2px;\n}\n[_v-3748b198]::-webkit-scrollbar-track {\n  background: #E3E3E3;\n}\n[_v-3748b198]::-webkit-scrollbar-thumb {\n  background: #C1C1C1;\n  border-radius: 2px;\n}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-3748b198", module.exports)
  } else {
    hotAPI.update("_v-3748b198", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/get-iterator":46,"babel-runtime/core-js/json/stringify":48,"moment":727,"vue":795,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],811:[function(require,module,exports){
'use strict';

var _defineProperties = require('babel-runtime/core-js/object/define-properties');

var _defineProperties2 = _interopRequireDefault(_defineProperties);

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*!
 * vue-i18n v7.4.2 
 * (c) 2018 kazuya kawaguchi
 * Released under the MIT License.
 */
(function (global, factory) {
  (typeof exports === 'undefined' ? 'undefined' : (0, _typeof3.default)(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() : typeof define === 'function' && define.amd ? define(factory) : global.VueI18n = factory();
})(undefined, function () {
  'use strict';

  /*  */

  /**
   * utilites
   */

  function warn(msg, err) {
    if (typeof console !== 'undefined') {
      console.warn('[vue-i18n] ' + msg);
      /* istanbul ignore if */
      if (err) {
        console.warn(err.stack);
      }
    }
  }

  function isObject(obj) {
    return obj !== null && (typeof obj === 'undefined' ? 'undefined' : (0, _typeof3.default)(obj)) === 'object';
  }

  var toString = Object.prototype.toString;
  var OBJECT_STRING = '[object Object]';
  function isPlainObject(obj) {
    return toString.call(obj) === OBJECT_STRING;
  }

  function isNull(val) {
    return val === null || val === undefined;
  }

  function parseArgs() {
    var args = [],
        len = arguments.length;
    while (len--) {
      args[len] = arguments[len];
    }var locale = null;
    var params = null;
    if (args.length === 1) {
      if (isObject(args[0]) || Array.isArray(args[0])) {
        params = args[0];
      } else if (typeof args[0] === 'string') {
        locale = args[0];
      }
    } else if (args.length === 2) {
      if (typeof args[0] === 'string') {
        locale = args[0];
      }
      /* istanbul ignore if */
      if (isObject(args[1]) || Array.isArray(args[1])) {
        params = args[1];
      }
    }

    return { locale: locale, params: params };
  }

  function getOldChoiceIndexFixed(choice) {
    return choice ? choice > 1 ? 1 : 0 : 1;
  }

  function getChoiceIndex(choice, choicesLength) {
    choice = Math.abs(choice);

    if (choicesLength === 2) {
      return getOldChoiceIndexFixed(choice);
    }

    return choice ? Math.min(choice, 2) : 0;
  }

  function fetchChoice(message, choice) {
    /* istanbul ignore if */
    if (!message && typeof message !== 'string') {
      return null;
    }
    var choices = message.split('|');

    choice = getChoiceIndex(choice, choices.length);
    if (!choices[choice]) {
      return message;
    }
    return choices[choice].trim();
  }

  function looseClone(obj) {
    return JSON.parse((0, _stringify2.default)(obj));
  }

  function remove(arr, item) {
    if (arr.length) {
      var index = arr.indexOf(item);
      if (index > -1) {
        return arr.splice(index, 1);
      }
    }
  }

  var hasOwnProperty = Object.prototype.hasOwnProperty;
  function hasOwn(obj, key) {
    return hasOwnProperty.call(obj, key);
  }

  function merge(target) {
    var arguments$1 = arguments;

    var output = Object(target);
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments$1[i];
      if (source !== undefined && source !== null) {
        var key = void 0;
        for (key in source) {
          if (hasOwn(source, key)) {
            if (isObject(source[key])) {
              output[key] = merge(output[key], source[key]);
            } else {
              output[key] = source[key];
            }
          }
        }
      }
    }
    return output;
  }

  function looseEqual(a, b) {
    if (a === b) {
      return true;
    }
    var isObjectA = isObject(a);
    var isObjectB = isObject(b);
    if (isObjectA && isObjectB) {
      try {
        var isArrayA = Array.isArray(a);
        var isArrayB = Array.isArray(b);
        if (isArrayA && isArrayB) {
          return a.length === b.length && a.every(function (e, i) {
            return looseEqual(e, b[i]);
          });
        } else if (!isArrayA && !isArrayB) {
          var keysA = (0, _keys2.default)(a);
          var keysB = (0, _keys2.default)(b);
          return keysA.length === keysB.length && keysA.every(function (key) {
            return looseEqual(a[key], b[key]);
          });
        } else {
          /* istanbul ignore next */
          return false;
        }
      } catch (e) {
        /* istanbul ignore next */
        return false;
      }
    } else if (!isObjectA && !isObjectB) {
      return String(a) === String(b);
    } else {
      return false;
    }
  }

  var canUseDateTimeFormat = typeof Intl !== 'undefined' && typeof Intl.DateTimeFormat !== 'undefined';

  var canUseNumberFormat = typeof Intl !== 'undefined' && typeof Intl.NumberFormat !== 'undefined';

  /*  */

  function extend(Vue) {
    // $FlowFixMe
    Object.defineProperty(Vue.prototype, '$t', {
      get: function get() {
        var this$1 = this;

        return function (key) {
          var values = [],
              len = arguments.length - 1;
          while (len-- > 0) {
            values[len] = arguments[len + 1];
          }var i18n = this$1.$i18n;
          return i18n._t.apply(i18n, [key, i18n.locale, i18n._getMessages(), this$1].concat(values));
        };
      }
    });
    // $FlowFixMe
    Object.defineProperty(Vue.prototype, '$tc', {
      get: function get$1() {
        var this$1 = this;

        return function (key, choice) {
          var values = [],
              len = arguments.length - 2;
          while (len-- > 0) {
            values[len] = arguments[len + 2];
          }var i18n = this$1.$i18n;
          return i18n._tc.apply(i18n, [key, i18n.locale, i18n._getMessages(), this$1, choice].concat(values));
        };
      }
    });
    // $FlowFixMe
    Object.defineProperty(Vue.prototype, '$te', {
      get: function get$2() {
        var this$1 = this;

        return function (key, locale) {
          var i18n = this$1.$i18n;
          return i18n._te(key, i18n.locale, i18n._getMessages(), locale);
        };
      }
    });
    // $FlowFixMe
    Object.defineProperty(Vue.prototype, '$d', {
      get: function get$3() {
        var this$1 = this;

        return function (value) {
          var args = [],
              len = arguments.length - 1;
          while (len-- > 0) {
            args[len] = arguments[len + 1];
          }return (ref = this$1.$i18n).d.apply(ref, [value].concat(args));
          var ref;
        };
      }
    });
    // $FlowFixMe
    Object.defineProperty(Vue.prototype, '$n', {
      get: function get$4() {
        var this$1 = this;

        return function (value) {
          var args = [],
              len = arguments.length - 1;
          while (len-- > 0) {
            args[len] = arguments[len + 1];
          }return (ref = this$1.$i18n).n.apply(ref, [value].concat(args));
          var ref;
        };
      }
    });
  }

  /*  */

  var mixin = {
    beforeCreate: function beforeCreate() {
      var options = this.$options;
      options.i18n = options.i18n || (options.__i18n ? {} : null);

      if (options.i18n) {
        if (options.i18n instanceof VueI18n) {
          // init locale messages via custom blocks
          if (options.__i18n) {
            try {
              var localeMessages = {};
              options.__i18n.forEach(function (resource) {
                localeMessages = merge(localeMessages, JSON.parse(resource));
              });
              (0, _keys2.default)(localeMessages).forEach(function (locale) {
                options.i18n.mergeLocaleMessage(locale, localeMessages[locale]);
              });
            } catch (e) {
              {
                warn("Cannot parse locale messages via custom blocks.", e);
              }
            }
          }
          this._i18n = options.i18n;
          this._i18nWatcher = this._i18n.watchI18nData();
          this._i18n.subscribeDataChanging(this);
          this._subscribing = true;
        } else if (isPlainObject(options.i18n)) {
          // component local i18n
          if (this.$root && this.$root.$i18n && this.$root.$i18n instanceof VueI18n) {
            options.i18n.root = this.$root.$i18n;
            options.i18n.formatter = this.$root.$i18n.formatter;
            options.i18n.fallbackLocale = this.$root.$i18n.fallbackLocale;
            options.i18n.silentTranslationWarn = this.$root.$i18n.silentTranslationWarn;
          }

          // init locale messages via custom blocks
          if (options.__i18n) {
            try {
              var localeMessages$1 = {};
              options.__i18n.forEach(function (resource) {
                localeMessages$1 = merge(localeMessages$1, JSON.parse(resource));
              });
              options.i18n.messages = localeMessages$1;
            } catch (e) {
              {
                warn("Cannot parse locale messages via custom blocks.", e);
              }
            }
          }

          this._i18n = new VueI18n(options.i18n);
          this._i18nWatcher = this._i18n.watchI18nData();
          this._i18n.subscribeDataChanging(this);
          this._subscribing = true;

          if (options.i18n.sync === undefined || !!options.i18n.sync) {
            this._localeWatcher = this.$i18n.watchLocale();
          }
        } else {
          {
            warn("Cannot be interpreted 'i18n' option.");
          }
        }
      } else if (this.$root && this.$root.$i18n && this.$root.$i18n instanceof VueI18n) {
        // root i18n
        this._i18n = this.$root.$i18n;
        this._i18n.subscribeDataChanging(this);
        this._subscribing = true;
      } else if (options.parent && options.parent.$i18n && options.parent.$i18n instanceof VueI18n) {
        // parent i18n
        this._i18n = options.parent.$i18n;
        this._i18n.subscribeDataChanging(this);
        this._subscribing = true;
      }
    },

    beforeDestroy: function beforeDestroy() {
      if (!this._i18n) {
        return;
      }

      if (this._subscribing) {
        this._i18n.unsubscribeDataChanging(this);
        delete this._subscribing;
      }

      if (this._i18nWatcher) {
        this._i18nWatcher();
        delete this._i18nWatcher;
      }

      if (this._localeWatcher) {
        this._localeWatcher();
        delete this._localeWatcher;
      }

      this._i18n = null;
    }
  };

  /*  */

  var component = {
    name: 'i18n',
    functional: true,
    props: {
      tag: {
        type: String,
        default: 'span'
      },
      path: {
        type: String,
        required: true
      },
      locale: {
        type: String
      },
      places: {
        type: [Array, Object]
      }
    },
    render: function render(h, ref) {
      var props = ref.props;
      var data = ref.data;
      var children = ref.children;
      var parent = ref.parent;

      var i18n = parent.$i18n;

      children = (children || []).filter(function (child) {
        return child.tag || (child.text = child.text.trim());
      });

      if (!i18n) {
        {
          warn('Cannot find VueI18n instance!');
        }
        return children;
      }

      var path = props.path;
      var locale = props.locale;

      var params = {};
      var places = props.places || {};

      var hasPlaces = Array.isArray(places) ? places.length > 0 : (0, _keys2.default)(places).length > 0;

      var everyPlace = children.every(function (child) {
        if (child.data && child.data.attrs) {
          var place = child.data.attrs.place;
          return typeof place !== 'undefined' && place !== '';
        }
      });

      if (hasPlaces && children.length > 0 && !everyPlace) {
        warn('If places prop is set, all child elements must have place prop set.');
      }

      if (Array.isArray(places)) {
        places.forEach(function (el, i) {
          params[i] = el;
        });
      } else {
        (0, _keys2.default)(places).forEach(function (key) {
          params[key] = places[key];
        });
      }

      children.forEach(function (child, i) {
        var key = everyPlace ? "" + child.data.attrs.place : "" + i;
        params[key] = child;
      });

      return h(props.tag, data, i18n.i(path, locale, params));
    }
  };

  /*  */

  function bind(el, binding, vnode) {
    if (!assert(el, vnode)) {
      return;
    }

    t$1(el, binding, vnode);
  }

  function update(el, binding, vnode, oldVNode) {
    if (!assert(el, vnode)) {
      return;
    }

    if (localeEqual(el, vnode) && looseEqual(binding.value, binding.oldValue)) {
      return;
    }

    t$1(el, binding, vnode);
  }

  function assert(el, vnode) {
    var vm = vnode.context;
    if (!vm) {
      warn('not exist Vue instance in VNode context');
      return false;
    }

    if (!vm.$i18n) {
      warn('not exist VueI18n instance in Vue instance');
      return false;
    }

    return true;
  }

  function localeEqual(el, vnode) {
    var vm = vnode.context;
    return el._locale === vm.$i18n.locale;
  }

  function t$1(el, binding, vnode) {
    var value = binding.value;

    var ref = parseValue(value);
    var path = ref.path;
    var locale = ref.locale;
    var args = ref.args;
    if (!path && !locale && !args) {
      warn('not support value type');
      return;
    }

    if (!path) {
      warn('required `path` in v-t directive');
      return;
    }

    var vm = vnode.context;
    el._vt = el.textContent = (ref$1 = vm.$i18n).t.apply(ref$1, [path].concat(makeParams(locale, args)));
    el._locale = vm.$i18n.locale;
    var ref$1;
  }

  function parseValue(value) {
    var path;
    var locale;
    var args;

    if (typeof value === 'string') {
      path = value;
    } else if (isPlainObject(value)) {
      path = value.path;
      locale = value.locale;
      args = value.args;
    }

    return { path: path, locale: locale, args: args };
  }

  function makeParams(locale, args) {
    var params = [];

    locale && params.push(locale);
    if (args && (Array.isArray(args) || isPlainObject(args))) {
      params.push(args);
    }

    return params;
  }

  var Vue;

  function install(_Vue) {
    Vue = _Vue;

    var version = Vue.version && Number(Vue.version.split('.')[0]) || -1;
    /* istanbul ignore if */
    if ("development" !== 'production' && install.installed) {
      warn('already installed.');
      return;
    }
    install.installed = true;

    /* istanbul ignore if */
    if ("development" !== 'production' && version < 2) {
      warn("vue-i18n (" + install.version + ") need to use Vue 2.0 or later (Vue: " + Vue.version + ").");
      return;
    }

    Object.defineProperty(Vue.prototype, '$i18n', {
      get: function get() {
        return this._i18n;
      }
    });

    extend(Vue);
    Vue.mixin(mixin);
    Vue.directive('t', { bind: bind, update: update });
    Vue.component(component.name, component);

    // use object-based merge strategy
    var strats = Vue.config.optionMergeStrategies;
    strats.i18n = strats.methods;
  }

  /*  */

  var BaseFormatter = function BaseFormatter() {
    this._caches = (0, _create2.default)(null);
  };

  BaseFormatter.prototype.interpolate = function interpolate(message, values) {
    if (!values) {
      return [message];
    }
    var tokens = this._caches[message];
    if (!tokens) {
      tokens = parse(message);
      this._caches[message] = tokens;
    }
    return compile(tokens, values);
  };

  var RE_TOKEN_LIST_VALUE = /^(\d)+/;
  var RE_TOKEN_NAMED_VALUE = /^(\w)+/;

  function parse(format) {
    var tokens = [];
    var position = 0;

    var text = '';
    while (position < format.length) {
      var char = format[position++];
      if (char === '{') {
        if (text) {
          tokens.push({ type: 'text', value: text });
        }

        text = '';
        var sub = '';
        char = format[position++];
        while (char !== '}') {
          sub += char;
          char = format[position++];
        }

        var type = RE_TOKEN_LIST_VALUE.test(sub) ? 'list' : RE_TOKEN_NAMED_VALUE.test(sub) ? 'named' : 'unknown';
        tokens.push({ value: sub, type: type });
      } else if (char === '%') {
        // when found rails i18n syntax, skip text capture
        if (format[position] !== '{') {
          text += char;
        }
      } else {
        text += char;
      }
    }

    text && tokens.push({ type: 'text', value: text });

    return tokens;
  }

  function compile(tokens, values) {
    var compiled = [];
    var index = 0;

    var mode = Array.isArray(values) ? 'list' : isObject(values) ? 'named' : 'unknown';
    if (mode === 'unknown') {
      return compiled;
    }

    while (index < tokens.length) {
      var token = tokens[index];
      switch (token.type) {
        case 'text':
          compiled.push(token.value);
          break;
        case 'list':
          compiled.push(values[parseInt(token.value, 10)]);
          break;
        case 'named':
          if (mode === 'named') {
            compiled.push(values[token.value]);
          } else {
            {
              warn("Type of token '" + token.type + "' and format of value '" + mode + "' don't match!");
            }
          }
          break;
        case 'unknown':
          {
            warn("Detect 'unknown' type of token!");
          }
          break;
      }
      index++;
    }

    return compiled;
  }

  /*  */

  /**
   *  Path paerser
   *  - Inspired:
   *    Vue.js Path parser
   */

  // actions
  var APPEND = 0;
  var PUSH = 1;
  var INC_SUB_PATH_DEPTH = 2;
  var PUSH_SUB_PATH = 3;

  // states
  var BEFORE_PATH = 0;
  var IN_PATH = 1;
  var BEFORE_IDENT = 2;
  var IN_IDENT = 3;
  var IN_SUB_PATH = 4;
  var IN_SINGLE_QUOTE = 5;
  var IN_DOUBLE_QUOTE = 6;
  var AFTER_PATH = 7;
  var ERROR = 8;

  var pathStateMachine = [];

  pathStateMachine[BEFORE_PATH] = {
    'ws': [BEFORE_PATH],
    'ident': [IN_IDENT, APPEND],
    '[': [IN_SUB_PATH],
    'eof': [AFTER_PATH]
  };

  pathStateMachine[IN_PATH] = {
    'ws': [IN_PATH],
    '.': [BEFORE_IDENT],
    '[': [IN_SUB_PATH],
    'eof': [AFTER_PATH]
  };

  pathStateMachine[BEFORE_IDENT] = {
    'ws': [BEFORE_IDENT],
    'ident': [IN_IDENT, APPEND],
    '0': [IN_IDENT, APPEND],
    'number': [IN_IDENT, APPEND]
  };

  pathStateMachine[IN_IDENT] = {
    'ident': [IN_IDENT, APPEND],
    '0': [IN_IDENT, APPEND],
    'number': [IN_IDENT, APPEND],
    'ws': [IN_PATH, PUSH],
    '.': [BEFORE_IDENT, PUSH],
    '[': [IN_SUB_PATH, PUSH],
    'eof': [AFTER_PATH, PUSH]
  };

  pathStateMachine[IN_SUB_PATH] = {
    "'": [IN_SINGLE_QUOTE, APPEND],
    '"': [IN_DOUBLE_QUOTE, APPEND],
    '[': [IN_SUB_PATH, INC_SUB_PATH_DEPTH],
    ']': [IN_PATH, PUSH_SUB_PATH],
    'eof': ERROR,
    'else': [IN_SUB_PATH, APPEND]
  };

  pathStateMachine[IN_SINGLE_QUOTE] = {
    "'": [IN_SUB_PATH, APPEND],
    'eof': ERROR,
    'else': [IN_SINGLE_QUOTE, APPEND]
  };

  pathStateMachine[IN_DOUBLE_QUOTE] = {
    '"': [IN_SUB_PATH, APPEND],
    'eof': ERROR,
    'else': [IN_DOUBLE_QUOTE, APPEND]
  };

  /**
   * Check if an expression is a literal value.
   */

  var literalValueRE = /^\s?(true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
  function isLiteral(exp) {
    return literalValueRE.test(exp);
  }

  /**
   * Strip quotes from a string
   */

  function stripQuotes(str) {
    var a = str.charCodeAt(0);
    var b = str.charCodeAt(str.length - 1);
    return a === b && (a === 0x22 || a === 0x27) ? str.slice(1, -1) : str;
  }

  /**
   * Determine the type of a character in a keypath.
   */

  function getPathCharType(ch) {
    if (ch === undefined || ch === null) {
      return 'eof';
    }

    var code = ch.charCodeAt(0);

    switch (code) {
      case 0x5B: // [
      case 0x5D: // ]
      case 0x2E: // .
      case 0x22: // "
      case 0x27: // '
      case 0x30:
        // 0
        return ch;

      case 0x5F: // _
      case 0x24: // $
      case 0x2D:
        // -
        return 'ident';

      case 0x20: // Space
      case 0x09: // Tab
      case 0x0A: // Newline
      case 0x0D: // Return
      case 0xA0: // No-break space
      case 0xFEFF: // Byte Order Mark
      case 0x2028: // Line Separator
      case 0x2029:
        // Paragraph Separator
        return 'ws';
    }

    // a-z, A-Z
    if (code >= 0x61 && code <= 0x7A || code >= 0x41 && code <= 0x5A) {
      return 'ident';
    }

    // 1-9
    if (code >= 0x31 && code <= 0x39) {
      return 'number';
    }

    return 'else';
  }

  /**
   * Format a subPath, return its plain form if it is
   * a literal string or number. Otherwise prepend the
   * dynamic indicator (*).
   */

  function formatSubPath(path) {
    var trimmed = path.trim();
    // invalid leading 0
    if (path.charAt(0) === '0' && isNaN(path)) {
      return false;
    }

    return isLiteral(trimmed) ? stripQuotes(trimmed) : '*' + trimmed;
  }

  /**
   * Parse a string path into an array of segments
   */

  function parse$1(path) {
    var keys = [];
    var index = -1;
    var mode = BEFORE_PATH;
    var subPathDepth = 0;
    var c;
    var key;
    var newChar;
    var type;
    var transition;
    var action;
    var typeMap;
    var actions = [];

    actions[PUSH] = function () {
      if (key !== undefined) {
        keys.push(key);
        key = undefined;
      }
    };

    actions[APPEND] = function () {
      if (key === undefined) {
        key = newChar;
      } else {
        key += newChar;
      }
    };

    actions[INC_SUB_PATH_DEPTH] = function () {
      actions[APPEND]();
      subPathDepth++;
    };

    actions[PUSH_SUB_PATH] = function () {
      if (subPathDepth > 0) {
        subPathDepth--;
        mode = IN_SUB_PATH;
        actions[APPEND]();
      } else {
        subPathDepth = 0;
        key = formatSubPath(key);
        if (key === false) {
          return false;
        } else {
          actions[PUSH]();
        }
      }
    };

    function maybeUnescapeQuote() {
      var nextChar = path[index + 1];
      if (mode === IN_SINGLE_QUOTE && nextChar === "'" || mode === IN_DOUBLE_QUOTE && nextChar === '"') {
        index++;
        newChar = '\\' + nextChar;
        actions[APPEND]();
        return true;
      }
    }

    while (mode !== null) {
      index++;
      c = path[index];

      if (c === '\\' && maybeUnescapeQuote()) {
        continue;
      }

      type = getPathCharType(c);
      typeMap = pathStateMachine[mode];
      transition = typeMap[type] || typeMap['else'] || ERROR;

      if (transition === ERROR) {
        return; // parse error
      }

      mode = transition[0];
      action = actions[transition[1]];
      if (action) {
        newChar = transition[2];
        newChar = newChar === undefined ? c : newChar;
        if (action() === false) {
          return;
        }
      }

      if (mode === AFTER_PATH) {
        return keys;
      }
    }
  }

  function empty(target) {
    /* istanbul ignore else */
    if (Array.isArray(target)) {
      return target.length === 0;
    } else {
      return false;
    }
  }

  var I18nPath = function I18nPath() {
    this._cache = (0, _create2.default)(null);
  };

  /**
   * External parse that check for a cache hit first
   */
  I18nPath.prototype.parsePath = function parsePath(path) {
    var hit = this._cache[path];
    if (!hit) {
      hit = parse$1(path);
      if (hit) {
        this._cache[path] = hit;
      }
    }
    return hit || [];
  };

  /**
   * Get path value from path string
   */
  I18nPath.prototype.getPathValue = function getPathValue(obj, path) {
    if (!isObject(obj)) {
      return null;
    }

    var paths = this.parsePath(path);
    if (empty(paths)) {
      return null;
    } else {
      var length = paths.length;
      var ret = null;
      var last = obj;
      var i = 0;
      while (i < length) {
        var value = last[paths[i]];
        if (value === undefined) {
          last = null;
          break;
        }
        last = value;
        i++;
      }

      ret = last;
      return ret;
    }
  };

  /*  */

  var VueI18n = function VueI18n(options) {
    var this$1 = this;
    if (options === void 0) options = {};

    // Auto install if it is not done yet and `window` has `Vue`.
    // To allow users to avoid auto-installation in some cases,
    // this code should be placed here. See #290
    /* istanbul ignore if */
    if (!Vue && typeof window !== 'undefined' && window.Vue) {
      install(window.Vue);
    }

    var locale = options.locale || 'en-US';
    var fallbackLocale = options.fallbackLocale || 'en-US';
    var messages = options.messages || {};
    var dateTimeFormats = options.dateTimeFormats || {};
    var numberFormats = options.numberFormats || {};

    this._vm = null;
    this._formatter = options.formatter || new BaseFormatter();
    this._missing = options.missing || null;
    this._root = options.root || null;
    this._sync = options.sync === undefined ? true : !!options.sync;
    this._fallbackRoot = options.fallbackRoot === undefined ? true : !!options.fallbackRoot;
    this._silentTranslationWarn = options.silentTranslationWarn === undefined ? false : !!options.silentTranslationWarn;
    this._dateTimeFormatters = {};
    this._numberFormatters = {};
    this._path = new I18nPath();
    this._dataListeners = [];

    this._exist = function (message, key) {
      if (!message || !key) {
        return false;
      }
      return !isNull(this$1._path.getPathValue(message, key));
    };

    this._initVM({
      locale: locale,
      fallbackLocale: fallbackLocale,
      messages: messages,
      dateTimeFormats: dateTimeFormats,
      numberFormats: numberFormats
    });
  };

  var prototypeAccessors = { vm: {}, messages: {}, dateTimeFormats: {}, numberFormats: {}, locale: {}, fallbackLocale: {}, missing: {}, formatter: {}, silentTranslationWarn: {} };

  VueI18n.prototype._initVM = function _initVM(data) {
    var silent = Vue.config.silent;
    Vue.config.silent = true;
    this._vm = new Vue({ data: data });
    Vue.config.silent = silent;
  };

  VueI18n.prototype.subscribeDataChanging = function subscribeDataChanging(vm) {
    this._dataListeners.push(vm);
  };

  VueI18n.prototype.unsubscribeDataChanging = function unsubscribeDataChanging(vm) {
    remove(this._dataListeners, vm);
  };

  VueI18n.prototype.watchI18nData = function watchI18nData() {
    var self = this;
    return this._vm.$watch('$data', function () {
      var i = self._dataListeners.length;
      while (i--) {
        Vue.nextTick(function () {
          self._dataListeners[i] && self._dataListeners[i].$forceUpdate();
        });
      }
    }, { deep: true });
  };

  VueI18n.prototype.watchLocale = function watchLocale() {
    /* istanbul ignore if */
    if (!this._sync || !this._root) {
      return null;
    }
    var target = this._vm;
    return this._root.vm.$watch('locale', function (val) {
      target.$set(target, 'locale', val);
      target.$forceUpdate();
    }, { immediate: true });
  };

  prototypeAccessors.vm.get = function () {
    return this._vm;
  };

  prototypeAccessors.messages.get = function () {
    return looseClone(this._getMessages());
  };
  prototypeAccessors.dateTimeFormats.get = function () {
    return looseClone(this._getDateTimeFormats());
  };
  prototypeAccessors.numberFormats.get = function () {
    return looseClone(this._getNumberFormats());
  };

  prototypeAccessors.locale.get = function () {
    return this._vm.locale;
  };
  prototypeAccessors.locale.set = function (locale) {
    this._vm.$set(this._vm, 'locale', locale);
  };

  prototypeAccessors.fallbackLocale.get = function () {
    return this._vm.fallbackLocale;
  };
  prototypeAccessors.fallbackLocale.set = function (locale) {
    this._vm.$set(this._vm, 'fallbackLocale', locale);
  };

  prototypeAccessors.missing.get = function () {
    return this._missing;
  };
  prototypeAccessors.missing.set = function (handler) {
    this._missing = handler;
  };

  prototypeAccessors.formatter.get = function () {
    return this._formatter;
  };
  prototypeAccessors.formatter.set = function (formatter) {
    this._formatter = formatter;
  };

  prototypeAccessors.silentTranslationWarn.get = function () {
    return this._silentTranslationWarn;
  };
  prototypeAccessors.silentTranslationWarn.set = function (silent) {
    this._silentTranslationWarn = silent;
  };

  VueI18n.prototype._getMessages = function _getMessages() {
    return this._vm.messages;
  };
  VueI18n.prototype._getDateTimeFormats = function _getDateTimeFormats() {
    return this._vm.dateTimeFormats;
  };
  VueI18n.prototype._getNumberFormats = function _getNumberFormats() {
    return this._vm.numberFormats;
  };

  VueI18n.prototype._warnDefault = function _warnDefault(locale, key, result, vm) {
    if (!isNull(result)) {
      return result;
    }
    if (this._missing) {
      this._missing.apply(null, [locale, key, vm]);
    } else {
      if ("development" !== 'production' && !this._silentTranslationWarn) {
        warn("Cannot translate the value of keypath '" + key + "'. " + 'Use the value of keypath as default.');
      }
    }
    return key;
  };

  VueI18n.prototype._isFallbackRoot = function _isFallbackRoot(val) {
    return !val && !isNull(this._root) && this._fallbackRoot;
  };

  VueI18n.prototype._interpolate = function _interpolate(locale, message, key, host, interpolateMode, values) {
    if (!message) {
      return null;
    }

    var pathRet = this._path.getPathValue(message, key);
    if (Array.isArray(pathRet)) {
      return pathRet;
    }

    var ret;
    if (isNull(pathRet)) {
      /* istanbul ignore else */
      if (isPlainObject(message)) {
        ret = message[key];
        if (typeof ret !== 'string') {
          if ("development" !== 'production' && !this._silentTranslationWarn) {
            warn("Value of key '" + key + "' is not a string!");
          }
          return null;
        }
      } else {
        return null;
      }
    } else {
      /* istanbul ignore else */
      if (typeof pathRet === 'string') {
        ret = pathRet;
      } else {
        if ("development" !== 'production' && !this._silentTranslationWarn) {
          warn("Value of key '" + key + "' is not a string!");
        }
        return null;
      }
    }

    // Check for the existance of links within the translated string
    if (ret.indexOf('@:') >= 0) {
      ret = this._link(locale, message, ret, host, interpolateMode, values);
    }

    return this._render(ret, interpolateMode, values);
  };

  VueI18n.prototype._link = function _link(locale, message, str, host, interpolateMode, values) {
    var this$1 = this;

    var ret = str;

    // Match all the links within the local
    // We are going to replace each of
    // them with its translation
    var matches = ret.match(/(@:[\w\-_|.]+)/g);
    for (var idx in matches) {
      // ie compatible: filter custom array
      // prototype method
      if (!matches.hasOwnProperty(idx)) {
        continue;
      }
      var link = matches[idx];
      // Remove the leading @:
      var linkPlaceholder = link.substr(2);
      // Translate the link
      var translated = this$1._interpolate(locale, message, linkPlaceholder, host, interpolateMode === 'raw' ? 'string' : interpolateMode, interpolateMode === 'raw' ? undefined : values);

      if (this$1._isFallbackRoot(translated)) {
        if ("development" !== 'production' && !this$1._silentTranslationWarn) {
          warn("Fall back to translate the link placeholder '" + linkPlaceholder + "' with root locale.");
        }
        /* istanbul ignore if */
        if (!this$1._root) {
          throw Error('unexpected error');
        }
        var root = this$1._root;
        translated = root._translate(root._getMessages(), root.locale, root.fallbackLocale, linkPlaceholder, host, interpolateMode, values);
      }
      translated = this$1._warnDefault(locale, linkPlaceholder, translated, host);

      // Replace the link with the translated
      ret = !translated ? ret : ret.replace(link, translated);
    }

    return ret;
  };

  VueI18n.prototype._render = function _render(message, interpolateMode, values) {
    var ret = this._formatter.interpolate(message, values);
    // if interpolateMode is **not** 'string' ('row'),
    // return the compiled data (e.g. ['foo', VNode, 'bar']) with formatter
    return interpolateMode === 'string' ? ret.join('') : ret;
  };

  VueI18n.prototype._translate = function _translate(messages, locale, fallback, key, host, interpolateMode, args) {
    var res = this._interpolate(locale, messages[locale], key, host, interpolateMode, args);
    if (!isNull(res)) {
      return res;
    }

    res = this._interpolate(fallback, messages[fallback], key, host, interpolateMode, args);
    if (!isNull(res)) {
      if ("development" !== 'production' && !this._silentTranslationWarn) {
        warn("Fall back to translate the keypath '" + key + "' with '" + fallback + "' locale.");
      }
      return res;
    } else {
      return null;
    }
  };

  VueI18n.prototype._t = function _t(key, _locale, messages, host) {
    var values = [],
        len = arguments.length - 4;
    while (len-- > 0) {
      values[len] = arguments[len + 4];
    }if (!key) {
      return '';
    }

    var parsedArgs = parseArgs.apply(void 0, values);
    var locale = parsedArgs.locale || _locale;

    var ret = this._translate(messages, locale, this.fallbackLocale, key, host, 'string', parsedArgs.params);
    if (this._isFallbackRoot(ret)) {
      if ("development" !== 'production' && !this._silentTranslationWarn) {
        warn("Fall back to translate the keypath '" + key + "' with root locale.");
      }
      /* istanbul ignore if */
      if (!this._root) {
        throw Error('unexpected error');
      }
      return (ref = this._root).t.apply(ref, [key].concat(values));
    } else {
      return this._warnDefault(locale, key, ret, host);
    }
    var ref;
  };

  VueI18n.prototype.t = function t(key) {
    var values = [],
        len = arguments.length - 1;
    while (len-- > 0) {
      values[len] = arguments[len + 1];
    }return (ref = this)._t.apply(ref, [key, this.locale, this._getMessages(), null].concat(values));
    var ref;
  };

  VueI18n.prototype._i = function _i(key, locale, messages, host, values) {
    var ret = this._translate(messages, locale, this.fallbackLocale, key, host, 'raw', values);
    if (this._isFallbackRoot(ret)) {
      if ("development" !== 'production' && !this._silentTranslationWarn) {
        warn("Fall back to interpolate the keypath '" + key + "' with root locale.");
      }
      if (!this._root) {
        throw Error('unexpected error');
      }
      return this._root.i(key, locale, values);
    } else {
      return this._warnDefault(locale, key, ret, host);
    }
  };

  VueI18n.prototype.i = function i(key, locale, values) {
    /* istanbul ignore if */
    if (!key) {
      return '';
    }

    if (typeof locale !== 'string') {
      locale = this.locale;
    }

    return this._i(key, locale, this._getMessages(), null, values);
  };

  VueI18n.prototype._tc = function _tc(key, _locale, messages, host, choice) {
    var values = [],
        len = arguments.length - 5;
    while (len-- > 0) {
      values[len] = arguments[len + 5];
    }if (!key) {
      return '';
    }
    if (choice === undefined) {
      choice = 1;
    }
    return fetchChoice((ref = this)._t.apply(ref, [key, _locale, messages, host].concat(values)), choice);
    var ref;
  };

  VueI18n.prototype.tc = function tc(key, choice) {
    var values = [],
        len = arguments.length - 2;
    while (len-- > 0) {
      values[len] = arguments[len + 2];
    }return (ref = this)._tc.apply(ref, [key, this.locale, this._getMessages(), null, choice].concat(values));
    var ref;
  };

  VueI18n.prototype._te = function _te(key, locale, messages) {
    var args = [],
        len = arguments.length - 3;
    while (len-- > 0) {
      args[len] = arguments[len + 3];
    }var _locale = parseArgs.apply(void 0, args).locale || locale;
    return this._exist(messages[_locale], key);
  };

  VueI18n.prototype.te = function te(key, locale) {
    return this._te(key, this.locale, this._getMessages(), locale);
  };

  VueI18n.prototype.getLocaleMessage = function getLocaleMessage(locale) {
    return looseClone(this._vm.messages[locale] || {});
  };

  VueI18n.prototype.setLocaleMessage = function setLocaleMessage(locale, message) {
    this._vm.messages[locale] = message;
  };

  VueI18n.prototype.mergeLocaleMessage = function mergeLocaleMessage(locale, message) {
    this._vm.$set(this._vm.messages, locale, Vue.util.extend(this._vm.messages[locale] || {}, message));
  };

  VueI18n.prototype.getDateTimeFormat = function getDateTimeFormat(locale) {
    return looseClone(this._vm.dateTimeFormats[locale] || {});
  };

  VueI18n.prototype.setDateTimeFormat = function setDateTimeFormat(locale, format) {
    this._vm.dateTimeFormats[locale] = format;
  };

  VueI18n.prototype.mergeDateTimeFormat = function mergeDateTimeFormat(locale, format) {
    this._vm.$set(this._vm.dateTimeFormats, locale, Vue.util.extend(this._vm.dateTimeFormats[locale] || {}, format));
  };

  VueI18n.prototype._localizeDateTime = function _localizeDateTime(value, locale, fallback, dateTimeFormats, key) {
    var _locale = locale;
    var formats = dateTimeFormats[_locale];

    // fallback locale
    if (isNull(formats) || isNull(formats[key])) {
      {
        warn("Fall back to '" + fallback + "' datetime formats from '" + locale + " datetime formats.");
      }
      _locale = fallback;
      formats = dateTimeFormats[_locale];
    }

    if (isNull(formats) || isNull(formats[key])) {
      return null;
    } else {
      var format = formats[key];
      var id = _locale + "__" + key;
      var formatter = this._dateTimeFormatters[id];
      if (!formatter) {
        formatter = this._dateTimeFormatters[id] = new Intl.DateTimeFormat(_locale, format);
      }
      return formatter.format(value);
    }
  };

  VueI18n.prototype._d = function _d(value, locale, key) {
    /* istanbul ignore if */
    if ("development" !== 'production' && !VueI18n.availabilities.dateTimeFormat) {
      warn('Cannot format a Date value due to not support Intl.DateTimeFormat.');
      return '';
    }

    if (!key) {
      return new Intl.DateTimeFormat(locale).format(value);
    }

    var ret = this._localizeDateTime(value, locale, this.fallbackLocale, this._getDateTimeFormats(), key);
    if (this._isFallbackRoot(ret)) {
      {
        warn("Fall back to datetime localization of root: key '" + key + "' .");
      }
      /* istanbul ignore if */
      if (!this._root) {
        throw Error('unexpected error');
      }
      return this._root.d(value, key, locale);
    } else {
      return ret || '';
    }
  };

  VueI18n.prototype.d = function d(value) {
    var args = [],
        len = arguments.length - 1;
    while (len-- > 0) {
      args[len] = arguments[len + 1];
    }var locale = this.locale;
    var key = null;

    if (args.length === 1) {
      if (typeof args[0] === 'string') {
        key = args[0];
      } else if (isObject(args[0])) {
        if (args[0].locale) {
          locale = args[0].locale;
        }
        if (args[0].key) {
          key = args[0].key;
        }
      }
    } else if (args.length === 2) {
      if (typeof args[0] === 'string') {
        key = args[0];
      }
      if (typeof args[1] === 'string') {
        locale = args[1];
      }
    }

    return this._d(value, locale, key);
  };

  VueI18n.prototype.getNumberFormat = function getNumberFormat(locale) {
    return looseClone(this._vm.numberFormats[locale] || {});
  };

  VueI18n.prototype.setNumberFormat = function setNumberFormat(locale, format) {
    this._vm.numberFormats[locale] = format;
  };

  VueI18n.prototype.mergeNumberFormat = function mergeNumberFormat(locale, format) {
    this._vm.$set(this._vm.numberFormats, locale, Vue.util.extend(this._vm.numberFormats[locale] || {}, format));
  };

  VueI18n.prototype._localizeNumber = function _localizeNumber(value, locale, fallback, numberFormats, key) {
    var _locale = locale;
    var formats = numberFormats[_locale];

    // fallback locale
    if (isNull(formats) || isNull(formats[key])) {
      {
        warn("Fall back to '" + fallback + "' number formats from '" + locale + " number formats.");
      }
      _locale = fallback;
      formats = numberFormats[_locale];
    }

    if (isNull(formats) || isNull(formats[key])) {
      return null;
    } else {
      var format = formats[key];
      var id = _locale + "__" + key;
      var formatter = this._numberFormatters[id];
      if (!formatter) {
        formatter = this._numberFormatters[id] = new Intl.NumberFormat(_locale, format);
      }
      return formatter.format(value);
    }
  };

  VueI18n.prototype._n = function _n(value, locale, key) {
    /* istanbul ignore if */
    if ("development" !== 'production' && !VueI18n.availabilities.numberFormat) {
      warn('Cannot format a Date value due to not support Intl.NumberFormat.');
      return '';
    }

    if (!key) {
      return new Intl.NumberFormat(locale).format(value);
    }

    var ret = this._localizeNumber(value, locale, this.fallbackLocale, this._getNumberFormats(), key);
    if (this._isFallbackRoot(ret)) {
      {
        warn("Fall back to number localization of root: key '" + key + "' .");
      }
      /* istanbul ignore if */
      if (!this._root) {
        throw Error('unexpected error');
      }
      return this._root.n(value, key, locale);
    } else {
      return ret || '';
    }
  };

  VueI18n.prototype.n = function n(value) {
    var args = [],
        len = arguments.length - 1;
    while (len-- > 0) {
      args[len] = arguments[len + 1];
    }var locale = this.locale;
    var key = null;

    if (args.length === 1) {
      if (typeof args[0] === 'string') {
        key = args[0];
      } else if (isObject(args[0])) {
        if (args[0].locale) {
          locale = args[0].locale;
        }
        if (args[0].key) {
          key = args[0].key;
        }
      }
    } else if (args.length === 2) {
      if (typeof args[0] === 'string') {
        key = args[0];
      }
      if (typeof args[1] === 'string') {
        locale = args[1];
      }
    }

    return this._n(value, locale, key);
  };

  (0, _defineProperties2.default)(VueI18n.prototype, prototypeAccessors);

  VueI18n.availabilities = {
    dateTimeFormat: canUseDateTimeFormat,
    numberFormat: canUseNumberFormat
  };
  VueI18n.install = install;
  VueI18n.version = '7.4.2';

  return VueI18n;
});

},{"babel-runtime/core-js/json/stringify":48,"babel-runtime/core-js/object/create":51,"babel-runtime/core-js/object/define-properties":52,"babel-runtime/core-js/object/keys":56,"babel-runtime/helpers/typeof":72}],812:[function(require,module,exports){
"use strict";

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = require("babel-runtime/helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * vue-paginate v3.6.0
 * (c) 2018 Taha Shashtari
 * @license MIT
 */
!function (t, e) {
  "object" == (typeof exports === "undefined" ? "undefined" : (0, _typeof3.default)(exports)) && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : t.VuePaginate = e();
}(undefined, function () {
  "use strict";
  function t(t, e) {
    var n = t.showStepLinks ? [t.stepLinks.prev].concat(t.listOfPages, [t.stepLinks.next]) : t.listOfPages;return n.map(function (n) {
      var i = { on: { click: function click(e) {
            e.preventDefault(), t.currentPage = a(n, t.limit, t.currentPage, t.listOfPages, t.stepLinks);
          } } },
          s = r(n, t.currentPage, t.listOfPages.length - 1, t.stepLinks),
          u = n === t.stepLinks.next || n === t.stepLinks.prev ? n : n + 1;return e("li", { class: s }, [e("a", i, u)]);
    });
  }function e(t, e) {
    var n = new P(t.listOfPages, t.currentPage, t.limit, t.stepLinks).generate();n = t.showStepLinks ? [t.stepLinks.prev].concat(n, [t.stepLinks.next]) : n;var i = u(n);return n.map(function (n, s) {
      var u = { on: { click: function click(e) {
            e.preventDefault(), t.currentPage = a(n, t.limit, t.currentPage, t.listOfPages, t.stepLinks, i[s]);
          } } },
          o = r(n, t.currentPage, t.listOfPages.length - 1, t.stepLinks),
          p = n === parseInt(n, 10) ? n + 1 : n;return e("li", { class: o }, [e("a", u, p)]);
    });
  }function n(t, e) {
    var n = t.listOfPages.length - 1,
        i = { on: { click: function click(e) {
          e.preventDefault(), t.currentPage > 0 && (t.currentPage -= 1);
        } } },
        s = { on: { click: function click(e) {
          e.preventDefault(), t.currentPage < n && (t.currentPage += 1);
        } } },
        r = { class: ["next", t.currentPage >= n ? "disabled" : ""] },
        a = { class: ["prev", t.currentPage <= 0 ? "disabled" : ""] },
        u = e("li", a, [e("a", i, t.simple.prev)]),
        o = e("li", r, [e("a", s, t.simple.next)]);return [u, o];
  }function i(t, e) {
    return t.filter(function (t) {
      return "paginate" === t.$vnode.componentOptions.tag;
    }).find(function (t) {
      return t.name === e;
    });
  }function s(t) {
    return Array.apply(null, { length: t }).map(function (t, e) {
      return e;
    });
  }function r(t, e, n, i) {
    var s = i.prev,
        r = i.next,
        a = [];return t === s ? a.push("left-arrow") : t === r ? a.push("right-arrow") : t === v ? a.push("ellipses") : a.push("number"), t === e && a.push("active"), t === s && e <= 0 ? a.push("disabled") : t === r && e >= n && a.push("disabled"), a;
  }function a(t, e, n, i, s, r) {
    var a = s.prev,
        u = s.next;void 0 === r && (r = null);var o = Math.floor(n / e);if (t === a) return n - 1 < 0 ? 0 : n - 1;if (t === u) return n + 1 > i.length - 1 ? i.length - 1 : n + 1;if (r && "right-ellipses" === r) return (o + 1) * e;if (r && "left-ellipses" === r) {
      var p = i.slice(o * e, o * e + e),
          l = n === i.length - 1;return l && 1 === p.length && o--, (o - 1) * e + e - 1;
    }return t;
  }function u(t) {
    return t.map(function (e, n) {
      return e === v && 0 === t[n - 1] ? "left-ellipses" : e === v && 0 !== t[n - 1] ? "right-ellipses" : e;
    });
  }function o(t, e) {
    (0, _keys2.default)(e).forEach(function (n) {
      if ("ul" === n) {
        var i = e.ul;Array.isArray(i) ? i.forEach(function (e) {
          return t.classList.add(e);
        }) : t.classList.add(i);
      }t.querySelectorAll(n).forEach(function (t) {
        var i = e[n];Array.isArray(i) ? i.forEach(function (e) {
          return t.classList.add(e);
        }) : t.classList.add(i);
      });
    });
  }function p(t) {
    return void 0 === t && (t = []), t.reduce(function (t, e) {
      return t[e] = { list: [], page: 0 }, t;
    }, {});
  }var l,
      h = function h() {},
      c = "undefined" != typeof console;h = function h(t, e, n) {
    void 0 === n && (n = "error"), c && console[n]("[vue-paginate]: " + t + " " + (e ? f(l(e)) : ""));
  }, l = function l(t) {
    if (t.$root === t) return "root instance";var e = t._isVue ? t.$options.name || t.$options._componentTag : t.name;return (e ? "component <" + e + ">" : "anonymous component") + (t._isVue && t.$options.__file ? " at " + t.$options.__file : "");
  };var f = function f(t) {
    return "anonymous component" === t && (t += ' - use the "name" option for better debugging messages.'), "\n(found in " + t + ")";
  },
      g = { name: "paginate", props: { name: { type: String, required: !0 }, list: { type: Array, required: !0 }, per: { type: Number, default: 3, validator: function validator(t) {
          return t > 0;
        } }, tag: { type: String, default: "ul" }, container: { type: Object, default: null } }, data: function data() {
      return { initialListSize: this.list.length };
    }, computed: { parent: function parent() {
        return this.container ? this.container : this.$parent;
      }, currentPage: { get: function get() {
          if (this.parent.paginate[this.name]) return this.parent.paginate[this.name].page;
        }, set: function set(t) {
          this.parent.paginate[this.name].page = t;
        } }, pageItemsCount: function pageItemsCount() {
        var t = this.list.length,
            e = this.currentPage * this.per + 1,
            n = Math.min(this.currentPage * this.per + this.per, t);return e + "-" + n + " of " + t;
      }, lastPage: function lastPage() {
        return Math.ceil(this.list.length / this.per);
      } }, mounted: function mounted() {
      return this.per <= 0 && h('<paginate name="' + this.name + "\"> 'per' prop can't be 0 or less.", this.parent), this.parent.paginate[this.name] ? void this.paginateList() : void h("'" + this.name + "' is not registered in 'paginate' array.", this.parent);
    }, watch: { currentPage: function currentPage() {
        this.paginateList();
      }, list: function list() {
        this.currentPage >= this.lastPage && (this.currentPage = this.lastPage - 1), this.paginateList();
      }, per: function per() {
        this.currentPage = 0, this.paginateList();
      } }, methods: { paginateList: function paginateList() {
        var t = this.currentPage * this.per,
            e = this.list.slice(t, t + this.per);this.parent.paginate[this.name].list = e;
      }, goToPage: function goToPage(t) {
        var e = Math.ceil(this.list.length / this.per);return t > e ? void h("You cannot go to page " + t + ". The last page is " + e + ".", this.parent) : void (this.currentPage = t - 1);
      } }, render: function render(t) {
      return t(this.tag, {}, this.$slots.default);
    } },
      d = "«",
      m = "»",
      v = "…",
      P = function P(t, e, n) {
    this.listOfPages = t, this.lastPage = t.length - 1, this.currentPage = e === this.lastPage ? this.lastPage - 1 : e, this.limit = n;
  };P.prototype.generate = function () {
    var t = this._buildFirstHalf(),
        e = this._buildSecondHalf();return t.concat(e);
  }, P.prototype._buildFirstHalf = function () {
    var t = this._allPagesButLast().slice(this._currentChunkIndex(), this._currentChunkIndex() + this.limit);return this.currentPage >= this.limit && (t.unshift(v), t.unshift(0)), this.lastPage - this.limit > this._currentChunkIndex() && t.push(v), t;
  }, P.prototype._buildSecondHalf = function () {
    var t = [this.lastPage];return t;
  }, P.prototype._currentChunkIndex = function () {
    var t = Math.floor(this.currentPage / this.limit);return t * this.limit;
  }, P.prototype._allPagesButLast = function () {
    var t = this;return this.listOfPages.filter(function (e) {
      return e !== t.lastPage;
    });
  };var y = { name: "paginate-links", props: { for: { type: String, required: !0 }, limit: { type: Number, default: 0 }, simple: { type: Object, default: null, validator: function validator(t) {
          return t.prev && t.next;
        } }, stepLinks: { type: Object, default: function _default() {
          return { prev: d, next: m };
        }, validator: function validator(t) {
          return t.prev && t.next;
        } }, showStepLinks: { type: Boolean }, hideSinglePage: { type: Boolean }, classes: { type: Object, default: null }, async: { type: Boolean, default: !1 }, container: { type: Object, default: null } }, data: function data() {
      return { listOfPages: [], numberOfPages: 0, target: null };
    }, computed: { parent: function parent() {
        return this.container ? this.container.el : this.$parent;
      }, state: function state() {
        return this.container ? this.container.state : this.$parent.paginate[this.for];
      }, currentPage: { get: function get() {
          if (this.state) return this.state.page;
        }, set: function set(t) {
          this.state.page = t;
        } } }, mounted: function mounted() {
      var t = this;this.simple && this.limit && h('<paginate-links for="' + this.for + "\"> 'simple' and 'limit' props can't be used at the same time. In this case, 'simple' will take precedence, and 'limit' will be ignored.", this.parent, "warn"), this.simple && !this.simple.next && h('<paginate-links for="' + this.for + "\"> 'simple' prop doesn't contain 'next' value.", this.parent), this.simple && !this.simple.prev && h('<paginate-links for="' + this.for + "\"> 'simple' prop doesn't contain 'prev' value.", this.parent), this.stepLinks && !this.stepLinks.next && h('<paginate-links for="' + this.for + "\"> 'step-links' prop doesn't contain 'next' value.", this.parent), this.stepLinks && !this.stepLinks.prev && h('<paginate-links for="' + this.for + "\"> 'step-links' prop doesn't contain 'prev' value.", this.parent), this.$nextTick(function () {
        t.updateListOfPages();
      });
    }, watch: { state: { handler: function handler() {
          this.updateListOfPages();
        }, deep: !0 }, currentPage: function currentPage(t, e) {
        this.$emit("change", t + 1, e + 1);
      } }, methods: { updateListOfPages: function updateListOfPages() {
        if (this.target = i(this.parent.$children, this.for), !this.target) {
          if (this.async) return;return h('<paginate-links for="' + this.for + '"> can\'t be used without its companion <paginate name="' + this.for + '">', this.parent), void h('To fix that issue you may need to use :async="true" on <paginate-links> component to allow for asyncronous rendering', this.parent, "warn");
        }this.numberOfPages = Math.ceil(this.target.list.length / this.target.per), this.listOfPages = s(this.numberOfPages);
      } }, render: function render(i) {
      var s = this;if (!this.target && this.async) return null;var r = this.simple ? n(this, i) : this.limit > 1 ? e(this, i) : t(this, i);if (this.hideSinglePage && this.numberOfPages <= 1) return null;var a = i("ul", { class: ["paginate-links", this.for] }, r);return this.classes && this.$nextTick(function () {
        o(a.elm, s.classes);
      }), a;
    } },
      k = {};return k.install = function (t) {
    t.mixin({ created: function created() {
        "undefined" !== this.paginate && this.paginate instanceof Array && (this.paginate = p(this.paginate));
      }, methods: { paginated: function paginated(t) {
          return this.paginate && this.paginate[t] ? this.paginate[t].list : void h("'" + t + "' is not registered in 'paginate' array.", this);
        } } }), t.component("paginate", g), t.component("paginate-links", y);
  }, "undefined" != typeof window && window.Vue && window.Vue.use(k), k;
});

},{"babel-runtime/core-js/object/keys":56,"babel-runtime/helpers/typeof":72}],813:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _clone = require('lodash/clone');

var _clone2 = _interopRequireDefault(_clone);

var _pickBy = require('lodash/pickBy');

var _pickBy2 = _interopRequireDefault(_pickBy);

var _omit = require('lodash/omit');

var _omit2 = _interopRequireDefault(_omit);

var _propsBinder = require('../utils/propsBinder.js');

var _propsBinder2 = _interopRequireDefault(_propsBinder);

var _simulateArrowDown = require('../utils/simulateArrowDown.js');

var _simulateArrowDown2 = _interopRequireDefault(_simulateArrowDown);

var _getPropsValuesMixin = require('../utils/getPropsValuesMixin.js');

var _getPropsValuesMixin2 = _interopRequireDefault(_getPropsValuesMixin);

var _manager = require('../manager.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  bounds: {
    type: Object
  },
  componentRestrictions: {
    type: Object
  },
  types: {
    type: Array,
    default: function _default() {
      return [];
    }
  },
  placeholder: {
    required: false,
    type: String
  },
  selectFirstOnEnter: {
    require: false,
    type: Boolean,
    default: false
  },
  value: {
    type: String,
    default: ''
  },
  options: {
    type: Object
  }
};

exports.default = {
  mixins: [_getPropsValuesMixin2.default],

  mounted: function mounted() {
    var _this = this;

    _manager.loaded.then(function () {
      var options = (0, _clone2.default)(_this.getPropsValues());
      if (_this.selectFirstOnEnter) {
        (0, _simulateArrowDown2.default)(_this.$refs.input);
      }

      if (typeof google.maps.places.Autocomplete !== 'function') {
        throw new Error('google.maps.places.Autocomplete is undefined. Did you add \'places\' to libraries when loading Google Maps?');
      }

      /* eslint-disable no-unused-vars */
      var finalOptions = (0, _pickBy2.default)((0, _assign2.default)({}, (0, _omit2.default)(options, ['options', 'selectFirstOnEnter', 'value', 'place', 'placeholder']), options.options), function (v, k) {
        return v !== undefined;
      });

      // Component restrictions is rather particular. Undefined not allowed
      _this.$watch('componentRestrictions', function (v) {
        if (v !== undefined) {
          _this.$autocomplete.setComponentRestrictions(v);
        }
      });

      _this.$autocomplete = new google.maps.places.Autocomplete(_this.$refs.input, finalOptions);
      (0, _propsBinder2.default)(_this, _this.$autocomplete, (0, _omit2.default)(props, ['placeholder', 'place', 'selectFirstOnEnter', 'value', 'componentRestrictions']));

      _this.$autocomplete.addListener('place_changed', function () {
        _this.$emit('place_changed', _this.$autocomplete.getPlace());
      });
    });
  },

  props: props
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<input type=\"text\" :placeholder=\"placeholder\" ref=\"input\" :value=\"value\">\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-18f49cbb", module.exports)
  } else {
    hotAPI.update("_v-18f49cbb", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"../manager.js":826,"../utils/getPropsValuesMixin.js":830,"../utils/propsBinder.js":832,"../utils/simulateArrowDown.js":833,"babel-runtime/core-js/object/assign":50,"lodash/clone":692,"lodash/omit":720,"lodash/pickBy":721,"vue":792,"vue-hot-reload-api":785}],814:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _clone = require('lodash/clone');

var _clone2 = _interopRequireDefault(_clone);

var _eventsBinder = require('../utils/eventsBinder.js');

var _eventsBinder2 = _interopRequireDefault(_eventsBinder);

var _propsBinder = require('../utils/propsBinder.js');

var _propsBinder2 = _interopRequireDefault(_propsBinder);

var _mapElementMixin = require('./mapElementMixin');

var _mapElementMixin2 = _interopRequireDefault(_mapElementMixin);

var _getPropsValuesMixin = require('../utils/getPropsValuesMixin.js');

var _getPropsValuesMixin2 = _interopRequireDefault(_getPropsValuesMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  center: {
    type: Object,
    twoWay: true,
    required: true
  },
  radius: {
    type: Number,
    default: 1000,
    twoWay: true
  },
  draggable: {
    type: Boolean,
    default: false
  },
  editable: {
    type: Boolean,
    default: false
  },
  options: {
    type: Object,
    twoWay: false
  }
};

var events = ['click', 'dblclick', 'drag', 'dragend', 'dragstart', 'mousedown', 'mousemove', 'mouseout', 'mouseover', 'mouseup', 'rightclick'];

exports.default = {
  mixins: [_mapElementMixin2.default, _getPropsValuesMixin2.default],
  props: props,
  version: 2,

  render: function render() {
    return '';
  },
  deferredReady: function deferredReady() {
    var options = (0, _clone2.default)(this.getPropsValues());
    options.map = this.$map;
    delete options.bounds;
    this.createCircle(options);
  },


  methods: {
    createCircle: function createCircle(options) {
      var _this = this;

      this.$circleObject = new google.maps.Circle(options);
      // we cant bind bounds because there is no `setBounds` method
      // on the Circle object
      var boundProps = (0, _clone2.default)(props);
      delete boundProps.bounds;
      (0, _propsBinder2.default)(this, this.$circleObject, boundProps);
      (0, _eventsBinder2.default)(this, this.$circleObject, events);

      var updateBounds = function updateBounds() {
        _this.$emit('bounds_changed', _this.$circleObject.getBounds());
      };

      this.$on('radius_changed', updateBounds);
      this.$on('center_changed', updateBounds);
    }
  },

  destroyed: function destroyed() {
    if (this.$circleObject) {
      this.$circleObject.setMap(null);
    }
  }
};

},{"../utils/eventsBinder.js":829,"../utils/getPropsValuesMixin.js":830,"../utils/propsBinder.js":832,"./mapElementMixin":818,"lodash/clone":692}],815:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _clone = require('lodash/clone');

var _clone2 = _interopRequireDefault(_clone);

var _eventsBinder = require('../utils/eventsBinder.js');

var _eventsBinder2 = _interopRequireDefault(_eventsBinder);

var _propsBinder = require('../utils/propsBinder.js');

var _propsBinder2 = _interopRequireDefault(_propsBinder);

var _mapElementMixin = require('./mapElementMixin');

var _mapElementMixin2 = _interopRequireDefault(_mapElementMixin);

var _getPropsValuesMixin = require('../utils/getPropsValuesMixin.js');

var _getPropsValuesMixin2 = _interopRequireDefault(_getPropsValuesMixin);

var _markerClustererPlus = require('marker-clusterer-plus');

var _markerClustererPlus2 = _interopRequireDefault(_markerClustererPlus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* vim: set softtabstop=2 shiftwidth=2 expandtab : */

/**
  * @class Cluster
  * @prop $clusterObject -- Exposes the marker clusterer to
        descendent Marker classes. Override this if you area
        extending the class
**/

var props = {
  maxZoom: {
    type: Number,
    twoWay: false
  },
  calculator: {
    type: Function,
    twoWay: false
  },
  gridSize: {
    type: Number,
    twoWay: false
  },
  styles: {
    type: Array,
    twoWay: false
  }
};

var events = ['click', 'rightclick', 'dblclick', 'drag', 'dragstart', 'dragend', 'mouseup', 'mousedown', 'mouseover', 'mouseout'];

exports.default = {
  mixins: [_mapElementMixin2.default, _getPropsValuesMixin2.default],
  props: props,

  render: function render(h) {
    // <div><slot></slot></div>
    return h('div', this.$slots.default);
  },
  deferredReady: function deferredReady() {
    var _this = this;

    var options = (0, _clone2.default)(this.getPropsValues());

    if (typeof _markerClustererPlus2.default === 'undefined') {
      /* eslint-disable no-console */
      console.error('MarkerClusterer is not installed! require() it or include it from https://cdnjs.cloudflare.com/ajax/libs/js-marker-clusterer/1.0.0/markerclusterer.js');
      throw new Error('MarkerClusterer is not installed! require() it or include it from https://cdnjs.cloudflare.com/ajax/libs/js-marker-clusterer/1.0.0/markerclusterer.js');
    }

    this.$clusterObject = new _markerClustererPlus2.default(this.$map, [], options);

    (0, _propsBinder2.default)(this, this.$clusterObject, props, {
      afterModelChanged: function afterModelChanged(a, v) {
        // eslint-disable-line no-unused-vars
        var oldMarkers = _this.$clusterObject.getMarkers();
        _this.$clusterObject.clearMarkers();
        _this.$clusterObject.addMarkers(oldMarkers);
      }
    });
    (0, _eventsBinder2.default)(this, this.$clusterObject, events);
  },
  beforeDestroy: function beforeDestroy() {
    var _this2 = this;

    /* Performance optimization when destroying a large number of markers */
    this.$children.forEach(function (marker) {
      if (marker.$clusterObject === _this2.$clusterObject) {
        marker.$clusterObject = null;
      }
    });
    if (this.$clusterObject) {
      this.$clusterObject.clearMarkers();
    }
  }
};

},{"../utils/eventsBinder.js":829,"../utils/getPropsValuesMixin.js":830,"../utils/propsBinder.js":832,"./mapElementMixin":818,"lodash/clone":692,"marker-clusterer-plus":726}],816:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _omit = require('lodash/omit');

var _omit2 = _interopRequireDefault(_omit);

var _clone = require('lodash/clone');

var _clone2 = _interopRequireDefault(_clone);

var _propsBinder = require('../utils/propsBinder.js');

var _propsBinder2 = _interopRequireDefault(_propsBinder);

var _eventsBinder = require('../utils/eventsBinder.js');

var _eventsBinder2 = _interopRequireDefault(_eventsBinder);

var _mapElementMixin = require('./mapElementMixin');

var _mapElementMixin2 = _interopRequireDefault(_mapElementMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  options: {
    type: Object,
    required: false,
    default: function _default() {
      return {};
    }
  },
  opened: {
    type: Boolean,
    default: true
  },
  position: {
    type: Object,
    twoWay: true
  },
  zIndex: {
    type: Number,
    twoWay: true
  }
};

var events = ['domready', 'closeclick', 'content_changed'];

exports.default = {
  mixins: [_mapElementMixin2.default],
  replace: false,
  props: props,

  mounted: function mounted() {
    var el = this.$refs.flyaway;
    el.parentNode.removeChild(el);
  },
  deferredReady: function deferredReady() {
    this.$markerObject = null;
    this.$markerComponent = this.$findAncestor(function (ans) {
      return ans.$markerObject;
    });

    if (this.$markerComponent) {
      this.$markerObject = this.$markerComponent.$markerObject;
    }
    this.createInfoWindow();
  },
  destroyed: function destroyed() {
    if (this.disconnect) {
      this.disconnect();
    }
    if (this.$infoWindow) {
      this.$infoWindow.setMap(null);
    }
  },


  methods: {
    openInfoWindow: function openInfoWindow() {
      if (this.opened) {
        if (this.$markerObject !== null) {
          this.$infoWindow.open(this.$map, this.$markerObject);
        } else {
          this.$infoWindow.open(this.$map);
        }
      } else {
        this.$infoWindow.close();
      }
    },
    createInfoWindow: function createInfoWindow() {
      var _this = this;

      // setting options
      var options = (0, _clone2.default)(this.options);
      options.content = this.$refs.flyaway;

      // only set the position if the info window is not bound to a marker
      if (this.$markerComponent === null) {
        options.position = this.position;
      }

      this.$infoWindow = new google.maps.InfoWindow(options);

      // Binding
      (0, _propsBinder2.default)(this, this.$infoWindow, (0, _omit2.default)(props, ['opened']));
      (0, _eventsBinder2.default)(this, this.$infoWindow, events);

      this.openInfoWindow();
      this.$watch('opened', function () {
        _this.openInfoWindow();
      });
    }
  }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div>\n  <div ref=\"flyaway\"> <!-- so named because it will fly away to another component -->\n    <slot>\n    </slot>\n  </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-839d525e", module.exports)
  } else {
    hotAPI.update("_v-839d525e", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"../utils/eventsBinder.js":829,"../utils/propsBinder.js":832,"./mapElementMixin":818,"lodash/clone":692,"lodash/omit":720,"vue":792,"vue-hot-reload-api":785}],817:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n.vue-map-container {\n  position: relative;\n}\n\n.vue-map-container .vue-map {\n  left: 0; right: 0; top: 0; bottom: 0;\n  position: absolute;\n}\n.vue-map-hidden {\n  display: none;\n}\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _omit = require('lodash/omit');

var _omit2 = _interopRequireDefault(_omit);

var _clone = require('lodash/clone');

var _clone2 = _interopRequireDefault(_clone);

var _manager = require('../manager.js');

var _deferredReady = require('../utils/deferredReady.js');

var _eventsBinder = require('../utils/eventsBinder.js');

var _eventsBinder2 = _interopRequireDefault(_eventsBinder);

var _propsBinder = require('../utils/propsBinder.js');

var _propsBinder2 = _interopRequireDefault(_propsBinder);

var _getPropsValuesMixin = require('../utils/getPropsValuesMixin.js');

var _getPropsValuesMixin2 = _interopRequireDefault(_getPropsValuesMixin);

var _mountableMixin = require('../utils/mountableMixin.js');

var _mountableMixin2 = _interopRequireDefault(_mountableMixin);

var _TwoWayBindingWrapper = require('../utils/TwoWayBindingWrapper.js');

var _TwoWayBindingWrapper2 = _interopRequireDefault(_TwoWayBindingWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  center: {
    required: true,
    twoWay: true,
    type: Object
  },
  zoom: {
    required: false,
    twoWay: true,
    type: Number
  },
  heading: {
    type: Number,
    twoWay: true
  },
  mapTypeId: {
    twoWay: true,
    type: String
  },
  bounds: {
    twoWay: true,
    type: Object
  },
  tilt: {
    twoWay: true,
    type: Number
  },
  options: {
    type: Object,
    default: function _default() {
      return {};
    }
  }
};

var events = ['click', 'dblclick', 'drag', 'dragend', 'dragstart', 'idle', 'mousemove', 'mouseout', 'mouseover', 'resize', 'rightclick', 'tilesloaded'];

// Plain Google Maps methods exposed here for convenience
var linkedMethods = ['panBy', 'panTo', 'panToBounds', 'fitBounds'].reduce(function (all, methodName) {
  all[methodName] = function () {
    if (this.$mapObject) {
      this.$mapObject[methodName].apply(this.$mapObject, arguments);
    }
  };
  return all;
}, {});

// Other convenience methods exposed by Vue Google Maps
var customMethods = {
  resize: function resize() {
    if (this.$mapObject) {
      google.maps.event.trigger(this.$mapObject, 'resize');
    }
  },
  resizePreserveCenter: function resizePreserveCenter() {
    if (!this.$mapObject) {
      return;
    }

    var oldCenter = this.$mapObject.getCenter();
    google.maps.event.trigger(this.$mapObject, 'resize');
    this.$mapObject.setCenter(oldCenter);
  },


  /// Override mountableMixin::_resizeCallback
  /// because resizePreserveCenter is usually the
  /// expected behaviour
  _resizeCallback: function _resizeCallback() {
    this.resizePreserveCenter();
  }
};

// Methods is a combination of customMethods and linkedMethods
var methods = (0, _assign2.default)({}, customMethods, linkedMethods);

exports.default = {
  mixins: [_getPropsValuesMixin2.default, _deferredReady.DeferredReadyMixin, _mountableMixin2.default],
  props: props,
  replace: false, // necessary for css styles

  created: function created() {
    var _this = this;

    this.$mapCreated = new _promise2.default(function (resolve, reject) {
      _this.$mapCreatedDeferred = { resolve: resolve, reject: reject };
    });
  },


  computed: {
    finalLat: function finalLat() {
      return this.center && typeof this.center.lat === 'function' ? this.center.lat() : this.center.lat;
    },
    finalLng: function finalLng() {
      return this.center && typeof this.center.lng === 'function' ? this.center.lng() : this.center.lng;
    },
    finalLatLng: function finalLatLng() {
      return { lat: this.finalLat, lng: this.finalLng };
    }
  },

  watch: {
    zoom: function zoom(_zoom) {
      if (this.$mapObject) {
        this.$mapObject.setZoom(_zoom);
      }
    }
  },

  deferredReady: function deferredReady() {
    var _this2 = this;

    return _manager.loaded.then(function () {
      // getting the DOM element where to create the map
      var element = _this2.$refs['vue-map'];

      // creating the map
      var copiedData = (0, _clone2.default)(_this2.getPropsValues());
      delete copiedData.options;
      var options = (0, _clone2.default)(_this2.options);
      (0, _assign2.default)(options, copiedData);
      _this2.$mapObject = new google.maps.Map(element, options);

      // binding properties (two and one way)
      (0, _propsBinder2.default)(_this2, _this2.$mapObject, (0, _omit2.default)(props, ['center', 'zoom', 'bounds']));

      // manually trigger center and zoom
      (0, _TwoWayBindingWrapper2.default)(function (increment, decrement, shouldUpdate) {
        _this2.$mapObject.addListener('center_changed', function () {
          if (shouldUpdate()) {
            _this2.$emit('center_changed', _this2.$mapObject.getCenter());
          }
          decrement();
        });

        var updateCenter = function updateCenter() {
          increment();
          _this2.$mapObject.setCenter(_this2.finalLatLng);
        };
        _this2.$watch('finalLatLng', updateCenter);
      });
      _this2.$mapObject.addListener('zoom_changed', function () {
        _this2.$emit('zoom_changed', _this2.$mapObject.getZoom());
      });
      _this2.$mapObject.addListener('bounds_changed', function () {
        _this2.$emit('bounds_changed', _this2.$mapObject.getBounds());
      });

      // binding events
      (0, _eventsBinder2.default)(_this2, _this2.$mapObject, events);

      _this2.$mapCreatedDeferred.resolve(_this2.$mapObject);

      return _this2.$mapCreated;
    }).catch(function (error) {
      throw error;
    });
  },

  methods: methods
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"vue-map-container\">\n  <div ref=\"vue-map\" class=\"vue-map\"></div>\n  <div class=\"vue-map-hidden\">\n    <slot></slot>\n  </div>\n  <slot name=\"visible\"></slot>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n.vue-map-container {\n  position: relative;\n}\n\n.vue-map-container .vue-map {\n  left: 0; right: 0; top: 0; bottom: 0;\n  position: absolute;\n}\n.vue-map-hidden {\n  display: none;\n}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-15eb1d59", module.exports)
  } else {
    hotAPI.update("_v-15eb1d59", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"../manager.js":826,"../utils/TwoWayBindingWrapper.js":827,"../utils/deferredReady.js":828,"../utils/eventsBinder.js":829,"../utils/getPropsValuesMixin.js":830,"../utils/mountableMixin.js":831,"../utils/propsBinder.js":832,"babel-runtime/core-js/object/assign":50,"babel-runtime/core-js/promise":59,"lodash/clone":692,"lodash/omit":720,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],818:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _deferredReady = require('../utils/deferredReady');

/**
 * @class MapElementMixin @mixins DeferredReadyMixin
 *
 * Extends components to include the following fields:
 *
 * @property $map        The Google map (valid only after the promise returns)
 *
 *
 * */
exports.default = {

  mixins: [_deferredReady.DeferredReadyMixin],

  created: function created() {
    var _this = this;

    /* Search for the Map component in the parent */
    var search = this.$findAncestor(function (ans) {
      return ans.$mapCreated;
    });

    if (!search) {
      throw new Error(this.constructor.name + ' component must be used within a <Map>');
    }

    this.$mapPromise = search.$mapCreated.then(function (map) {
      _this.$map = map;
    });
    // FIXME: This is a hack to ensure correct loading
    // when the map has already be instantiated.
    if (search.$mapObject) {
      this.$map = search.$mapObject;
    }
    this.$MapElementMixin = search;
    this.$map = null;
  },
  beforeDeferredReady: function beforeDeferredReady() {
    return this.$mapPromise;
  },


  methods: {
    $findAncestor: function $findAncestor(condition) {
      var search = this.$parent;

      while (search) {
        if (condition(search)) {
          return search;
        }
        search = search.$parent;
      }
      return null;
    }
  }

}; /* vim: set softtabstop=2 shiftwidth=2 expandtab : */

},{"../utils/deferredReady":828}],819:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mapValues = require('lodash/mapValues');

var _mapValues2 = _interopRequireDefault(_mapValues);

var _eventsBinder = require('../utils/eventsBinder.js');

var _eventsBinder2 = _interopRequireDefault(_eventsBinder);

var _propsBinder = require('../utils/propsBinder.js');

var _propsBinder2 = _interopRequireDefault(_propsBinder);

var _getPropsValuesMixin = require('../utils/getPropsValuesMixin.js');

var _getPropsValuesMixin2 = _interopRequireDefault(_getPropsValuesMixin);

var _mapElementMixin = require('./mapElementMixin');

var _mapElementMixin2 = _interopRequireDefault(_mapElementMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  animation: {
    twoWay: true,
    type: Number
  },
  attribution: {
    type: Object
  },
  clickable: {
    type: Boolean,
    twoWay: true,
    default: true
  },
  cursor: {
    type: String,
    twoWay: true
  },
  draggable: {
    type: Boolean,
    twoWay: true,
    default: false
  },
  icon: {
    twoWay: true
  },
  label: {},
  opacity: {
    type: Number,
    default: 1
  },
  options: {
    type: Object
  },
  place: {
    type: Object
  },
  position: {
    type: Object,
    twoWay: true
  },
  shape: {
    type: Object,
    twoWay: true
  },
  title: {
    type: String,
    twoWay: true
  },
  zIndex: {
    type: Number,
    twoWay: true
  },
  visible: {
    twoWay: true,
    default: true
  }
};

var events = ['click', 'rightclick', 'dblclick', 'drag', 'dragstart', 'dragend', 'mouseup', 'mousedown', 'mouseover', 'mouseout'];

/**
 * @class Marker
 *
 * Marker class with extra support for
 *
 * - Embedded info windows
 * - Clustered markers
 *
 * Support for clustered markers is for backward-compatability
 * reasons. Otherwise we should use a cluster-marker mixin or
 * subclass.
 */
exports.default = {
  mixins: [_mapElementMixin2.default, _getPropsValuesMixin2.default],
  props: props,

  render: function render(h) {
    if (!this.$slots.default || this.$slots.default.length === 0) {
      return '';
    } else if (this.$slots.default.length === 1) {
      // So that infowindows can have a marker parent
      return this.$slots.default[0];
    } else {
      return h('div', this.$slots.default);
    }
  },
  destroyed: function destroyed() {
    if (!this.$markerObject) {
      return;
    }

    if (this.$clusterObject) {
      this.$clusterObject.removeMarker(this.$markerObject);
    } else {
      this.$markerObject.setMap(null);
    }
  },
  deferredReady: function deferredReady() {
    var _this = this;

    var options = (0, _mapValues2.default)(props, function (value, prop) {
      return _this[prop];
    });
    options.map = this.$map;
    delete options.options;
    Object.assign(options, this.options);

    // search ancestors for cluster object
    var search = this.$findAncestor(function (ans) {
      return ans.$clusterObject;
    });

    this.$clusterObject = search ? search.$clusterObject : null;
    this.createMarker(options);
  },


  methods: {
    createMarker: function createMarker(options) {
      this.$markerObject = new google.maps.Marker(options);
      (0, _propsBinder2.default)(this, this.$markerObject, props);
      (0, _eventsBinder2.default)(this, this.$markerObject, events);

      if (this.$clusterObject) {
        this.$clusterObject.addMarker(this.$markerObject);
      }
    }
  }
};

},{"../utils/eventsBinder.js":829,"../utils/getPropsValuesMixin.js":830,"../utils/propsBinder.js":832,"./mapElementMixin":818,"lodash/mapValues":718}],820:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _omit = require('lodash/omit');

var _omit2 = _interopRequireDefault(_omit);

var _clone = require('lodash/clone');

var _clone2 = _interopRequireDefault(_clone);

var _propsBinder = require('../utils/propsBinder.js');

var _propsBinder2 = _interopRequireDefault(_propsBinder);

var _simulateArrowDown = require('../utils/simulateArrowDown.js');

var _simulateArrowDown2 = _interopRequireDefault(_simulateArrowDown);

var _getPropsValuesMixin = require('../utils/getPropsValuesMixin.js');

var _getPropsValuesMixin2 = _interopRequireDefault(_getPropsValuesMixin);

var _manager = require('../manager.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  bounds: {
    type: Object
  },
  defaultPlace: {
    type: String,
    default: ''
  },
  componentRestrictions: {
    type: Object,
    default: null
  },
  types: {
    type: Array,
    default: function _default() {
      return [];
    }
  },
  placeholder: {
    required: false,
    type: String
  },
  className: {
    required: false,
    type: String
  },
  label: {
    required: false,
    type: String,
    default: null
  },
  selectFirstOnEnter: {
    require: false,
    type: Boolean,
    default: false
  }
};

exports.default = {
  mixins: [_getPropsValuesMixin2.default],

  mounted: function mounted() {
    var _this = this;

    var input = this.$refs.input;

    // Allow default place to be set
    input.value = this.defaultPlace;
    this.$watch('defaultPlace', function () {
      input.value = _this.defaultPlace;
    });

    _manager.loaded.then(function () {
      var options = (0, _clone2.default)(_this.getPropsValues());
      if (_this.selectFirstOnEnter) {
        (0, _simulateArrowDown2.default)(_this.$refs.input);
      }

      if (typeof google.maps.places.Autocomplete !== 'function') {
        throw new Error('google.maps.places.Autocomplete is undefined. Did you add \'places\' to libraries when loading Google Maps?');
      }

      _this.autoCompleter = new google.maps.places.Autocomplete(_this.$refs.input, options);
      (0, _propsBinder2.default)(_this, _this.autoCompleter, (0, _omit2.default)(props, ['placeholder', 'place', 'selectFirstOnEnter', 'defaultPlace', 'className', 'label']));

      _this.autoCompleter.addListener('place_changed', function () {
        _this.$emit('place_changed', _this.autoCompleter.getPlace());
      });
    });
  },
  created: function created() {
    console.warn('The PlaceInput class is deprecated! Please consider using the Autocomplete input instead'); // eslint-disable-line no-console
  },

  props: props
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<label>\n    <span v-text=\"label\"></span>\n    <input type=\"text\" :placeholder=\"placeholder\" :class=\"className\" ref=\"input\">\n</label>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-455f1516", module.exports)
  } else {
    hotAPI.update("_v-455f1516", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"../manager.js":826,"../utils/getPropsValuesMixin.js":830,"../utils/propsBinder.js":832,"../utils/simulateArrowDown.js":833,"lodash/clone":692,"lodash/omit":720,"vue":792,"vue-hot-reload-api":785}],821:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _omit = require('lodash/omit');

var _omit2 = _interopRequireDefault(_omit);

var _clone = require('lodash/clone');

var _clone2 = _interopRequireDefault(_clone);

var _eventsBinder = require('../utils/eventsBinder.js');

var _eventsBinder2 = _interopRequireDefault(_eventsBinder);

var _propsBinder = require('../utils/propsBinder.js');

var _propsBinder2 = _interopRequireDefault(_propsBinder);

var _mapElementMixin = require('./mapElementMixin');

var _mapElementMixin2 = _interopRequireDefault(_mapElementMixin);

var _getPropsValuesMixin = require('../utils/getPropsValuesMixin.js');

var _getPropsValuesMixin2 = _interopRequireDefault(_getPropsValuesMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  draggable: {
    type: Boolean
  },
  editable: {
    type: Boolean
  },
  options: {
    type: Object
  },
  path: {
    type: Array,
    twoWay: true
  },
  paths: {
    type: Array,
    twoWay: true
  },
  deepWatch: {
    type: Boolean,
    default: false
  }
};

var events = ['click', 'dblclick', 'drag', 'dragend', 'dragstart', 'mousedown', 'mousemove', 'mouseout', 'mouseover', 'mouseup', 'rightclick'];

exports.default = {
  mixins: [_mapElementMixin2.default, _getPropsValuesMixin2.default],
  props: props,

  render: function render() {
    return '';
  },
  destroyed: function destroyed() {
    if (this.$polygonObject) {
      this.$polygonObject.setMap(null);
    }
  },
  deferredReady: function deferredReady() {
    var _this = this;

    var options = (0, _clone2.default)(this.getPropsValues());
    delete options.options;
    Object.assign(options, this.options);
    if (!options.path) {
      delete options.path;
    }
    if (!options.paths) {
      delete options.paths;
    }
    this.$polygonObject = new google.maps.Polygon(options);

    (0, _propsBinder2.default)(this, this.$polygonObject, (0, _omit2.default)(props, ['path', 'paths', 'deepWatch']));
    (0, _eventsBinder2.default)(this, this.$polygonObject, events);

    var clearEvents = function clearEvents() {};

    // Watch paths, on our own, because we do not want to set either when it is
    // empty
    this.$watch('paths', function (paths) {
      if (paths) {
        clearEvents();

        _this.$polygonObject.setPaths(paths);

        var updatePaths = function updatePaths() {
          _this.$emit('paths_changed', _this.$polygonObject.getPaths());
        };
        var eventListeners = [];

        var mvcArray = _this.$polygonObject.getPaths();
        for (var i = 0; i < mvcArray.getLength(); i++) {
          var mvcPath = mvcArray.getAt(i);
          eventListeners.push([mvcPath, mvcPath.addListener('insert_at', updatePaths)]);
          eventListeners.push([mvcPath, mvcPath.addListener('remove_at', updatePaths)]);
          eventListeners.push([mvcPath, mvcPath.addListener('set_at', updatePaths)]);
        }
        eventListeners.push([mvcArray, mvcArray.addListener('insert_at', updatePaths)]);
        eventListeners.push([mvcArray, mvcArray.addListener('remove_at', updatePaths)]);
        eventListeners.push([mvcArray, mvcArray.addListener('set_at', updatePaths)]);

        clearEvents = function clearEvents() {
          eventListeners.map(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                obj = _ref2[0],
                listenerHandle = _ref2[1];

            return (// eslint-disable-line no-unused-vars
              google.maps.event.removeListener(listenerHandle)
            );
          });
        };
      }
    }, {
      deep: this.deepWatch,
      immediate: true
    });

    this.$watch('path', function (path) {
      if (path) {
        clearEvents();

        _this.$polygonObject.setPaths(path);

        var mvcPath = _this.$polygonObject.getPath();
        var eventListeners = [];

        var updatePaths = function updatePaths() {
          _this.$emit('path_changed', _this.$polygonObject.getPath());
        };

        eventListeners.push([mvcPath, mvcPath.addListener('insert_at', updatePaths)]);
        eventListeners.push([mvcPath, mvcPath.addListener('remove_at', updatePaths)]);
        eventListeners.push([mvcPath, mvcPath.addListener('set_at', updatePaths)]);

        clearEvents = function clearEvents() {
          eventListeners.map(function (_ref3) {
            var _ref4 = _slicedToArray(_ref3, 2),
                obj = _ref4[0],
                listenerHandle = _ref4[1];

            return (// eslint-disable-line no-unused-vars
              google.maps.event.removeListener(listenerHandle)
            );
          });
        };
      }
    }, {
      deep: this.deepWatch,
      immediate: true
    });

    // Display the map
    this.$polygonObject.setMap(this.$map);
  }
};

},{"../utils/eventsBinder.js":829,"../utils/getPropsValuesMixin.js":830,"../utils/propsBinder.js":832,"./mapElementMixin":818,"lodash/clone":692,"lodash/omit":720}],822:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _omit = require('lodash/omit');

var _omit2 = _interopRequireDefault(_omit);

var _clone = require('lodash/clone');

var _clone2 = _interopRequireDefault(_clone);

var _eventsBinder = require('../utils/eventsBinder.js');

var _eventsBinder2 = _interopRequireDefault(_eventsBinder);

var _propsBinder = require('../utils/propsBinder.js');

var _propsBinder2 = _interopRequireDefault(_propsBinder);

var _mapElementMixin = require('./mapElementMixin');

var _mapElementMixin2 = _interopRequireDefault(_mapElementMixin);

var _getPropsValuesMixin = require('../utils/getPropsValuesMixin.js');

var _getPropsValuesMixin2 = _interopRequireDefault(_getPropsValuesMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  draggable: {
    type: Boolean
  },
  editable: {
    type: Boolean
  },
  options: {
    twoWay: false,
    type: Object
  },
  path: {
    type: Array,
    twoWay: true
  },
  deepWatch: {
    type: Boolean,
    default: false
  }
};

var events = ['click', 'dblclick', 'drag', 'dragend', 'dragstart', 'mousedown', 'mousemove', 'mouseout', 'mouseover', 'mouseup', 'rightclick'];

exports.default = {
  mixins: [_mapElementMixin2.default, _getPropsValuesMixin2.default],
  props: props,

  render: function render() {
    return '';
  },
  destroyed: function destroyed() {
    if (this.$polylineObject) {
      this.$polylineObject.setMap(null);
    }
  },
  deferredReady: function deferredReady() {
    var _this = this;

    var options = (0, _clone2.default)(this.getPropsValues());
    delete options.options;
    Object.assign(options, this.options);
    this.$polylineObject = new google.maps.Polyline(options);
    this.$polylineObject.setMap(this.$map);

    (0, _propsBinder2.default)(this, this.$polylineObject, (0, _omit2.default)(props, ['deepWatch', 'path']));
    (0, _eventsBinder2.default)(this, this.$polylineObject, events);

    var clearEvents = function clearEvents() {};

    this.$watch('path', function (path) {
      if (path) {
        clearEvents();

        _this.$polylineObject.setPath(path);

        var mvcPath = _this.$polylineObject.getPath();
        var eventListeners = [];

        var updatePaths = function updatePaths() {
          _this.$emit('path_changed', _this.$polylineObject.getPath());
        };

        eventListeners.push([mvcPath, mvcPath.addListener('insert_at', updatePaths)]);
        eventListeners.push([mvcPath, mvcPath.addListener('remove_at', updatePaths)]);
        eventListeners.push([mvcPath, mvcPath.addListener('set_at', updatePaths)]);

        clearEvents = function clearEvents() {
          eventListeners.map(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                obj = _ref2[0],
                listenerHandle = _ref2[1];

            return (// eslint-disable-line no-unused-vars
              google.maps.event.removeListener(listenerHandle)
            );
          });
        };
      }
    }, {
      deep: this.deepWatch
    });

    // Display the map
    this.$polylineObject.setMap(this.$map);
  }
};

},{"../utils/eventsBinder.js":829,"../utils/getPropsValuesMixin.js":830,"../utils/propsBinder.js":832,"./mapElementMixin":818,"lodash/clone":692,"lodash/omit":720}],823:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _clone = require('lodash/clone');

var _clone2 = _interopRequireDefault(_clone);

var _eventsBinder = require('../utils/eventsBinder.js');

var _eventsBinder2 = _interopRequireDefault(_eventsBinder);

var _propsBinder = require('../utils/propsBinder.js');

var _propsBinder2 = _interopRequireDefault(_propsBinder);

var _mapElementMixin = require('./mapElementMixin');

var _mapElementMixin2 = _interopRequireDefault(_mapElementMixin);

var _getPropsValuesMixin = require('../utils/getPropsValuesMixin.js');

var _getPropsValuesMixin2 = _interopRequireDefault(_getPropsValuesMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  bounds: {
    type: Object,
    twoWay: true
  },
  draggable: {
    type: Boolean,
    default: false
  },
  editable: {
    type: Boolean,
    default: false
  },
  options: {
    type: Object,
    twoWay: false
  }
};

var events = ['click', 'dblclick', 'drag', 'dragend', 'dragstart', 'mousedown', 'mousemove', 'mouseout', 'mouseover', 'mouseup', 'rightclick'];

exports.default = {
  mixins: [_mapElementMixin2.default, _getPropsValuesMixin2.default],
  props: props,

  render: function render() {
    return '';
  },
  deferredReady: function deferredReady() {
    var options = (0, _clone2.default)(this.getPropsValues());
    options.map = this.$map;
    this.createRectangle(options);
  },


  methods: {
    createRectangle: function createRectangle(options) {
      this.$rectangleObject = new google.maps.Rectangle(options);
      (0, _propsBinder2.default)(this, this.$rectangleObject, props);
      (0, _eventsBinder2.default)(this, this.$rectangleObject, events);
    }
  },

  destroyed: function destroyed() {
    if (this.$rectangleObject) {
      this.$rectangleObject.setMap(null);
    }
  }
};

},{"../utils/eventsBinder.js":829,"../utils/getPropsValuesMixin.js":830,"../utils/propsBinder.js":832,"./mapElementMixin":818,"lodash/clone":692}],824:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n.vue-street-view-pano-container {\n  position: relative;\n}\n\n.vue-street-view-pano-container .vue-street-view-pano {\n  left: 0; right: 0; top: 0; bottom: 0;\n  position: absolute;\n}\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _omit = require('lodash/omit');

var _omit2 = _interopRequireDefault(_omit);

var _manager = require('../manager.js');

var _deferredReady = require('../utils/deferredReady.js');

var _eventsBinder = require('../utils/eventsBinder.js');

var _eventsBinder2 = _interopRequireDefault(_eventsBinder);

var _propsBinder = require('../utils/propsBinder.js');

var _propsBinder2 = _interopRequireDefault(_propsBinder);

var _getPropsValuesMixin = require('../utils/getPropsValuesMixin.js');

var _getPropsValuesMixin2 = _interopRequireDefault(_getPropsValuesMixin);

var _mountableMixin = require('../utils/mountableMixin.js');

var _mountableMixin2 = _interopRequireDefault(_mountableMixin);

var _TwoWayBindingWrapper = require('../utils/TwoWayBindingWrapper.js');

var _TwoWayBindingWrapper2 = _interopRequireDefault(_TwoWayBindingWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  zoom: {
    twoWay: true,
    type: Number
  },
  pov: {
    twoWay: true,
    type: Object,
    trackProperties: ['pitch', 'heading']
  },
  position: {
    twoWay: true,
    type: Object
  },
  pano: {
    twoWay: true,
    type: String
  },
  motionTracking: {
    twoWay: false,
    type: Boolean
  },
  visible: {
    twoWay: true,
    type: Boolean,
    default: true
  },
  options: {
    twoWay: false,
    type: Object,
    default: function _default() {
      return {};
    }
  }
};

var events = ['closeclick', 'status_changed'];

// Other convenience methods exposed by Vue Google Maps
var customMethods = {
  resize: function resize() {
    if (this.$panoObject) {
      google.maps.event.trigger(this.$panoObject, 'resize');
    }
  }
};

// Methods is a combination of customMethods and linkedMethods
var methods = (0, _assign2.default)({}, customMethods);

exports.default = {
  mixins: [_getPropsValuesMixin2.default, _deferredReady.DeferredReadyMixin, _mountableMixin2.default],
  props: props,
  replace: false, // necessary for css styles
  methods: methods,

  created: function created() {
    var _this = this;

    this.$panoCreated = new _promise2.default(function (resolve, reject) {
      _this.$panoCreatedDeferred = { resolve: resolve, reject: reject };
    });

    var updateCenter = function updateCenter() {
      if (!_this.panoObject) return;

      _this.$panoObject.setPosition({
        lat: _this.finalLat,
        lng: _this.finalLng
      });
    };
    this.$watch('finalLat', updateCenter);
    this.$watch('finalLng', updateCenter);
  },


  computed: {
    finalLat: function finalLat() {
      return this.position && typeof this.position.lat === 'function' ? this.position.lat() : this.position.lat;
    },
    finalLng: function finalLng() {
      return this.position && typeof this.position.lng === 'function' ? this.position.lng() : this.position.lng;
    },
    finalLatLng: function finalLatLng() {
      return {
        lat: this.finalLat,
        lng: this.finalLng
      };
    }
  },

  watch: {
    zoom: function zoom(_zoom) {
      if (this.$panoObject) {
        this.$panoObject.setZoom(_zoom);
      }
    }
  },

  deferredReady: function deferredReady() {
    var _this2 = this;

    return _manager.loaded.then(function () {
      // getting the DOM element where to create the map
      var element = _this2.$refs['vue-street-view-pano'];

      // creating the map
      var options = (0, _assign2.default)({}, _this2.options, (0, _omit2.default)(_this2.getPropsValues(), ['options']));

      _this2.$panoObject = new google.maps.StreetViewPanorama(element, options);

      // binding properties (two and one way)
      (0, _propsBinder2.default)(_this2, _this2.$panoObject, (0, _omit2.default)(props, ['position']));

      // manually trigger position
      (0, _TwoWayBindingWrapper2.default)(function (increment, decrement, shouldUpdate) {
        // Panos take a while to load
        increment();

        _this2.$panoObject.addListener('position_changed', function () {
          if (shouldUpdate()) {
            _this2.$emit('position_changed', _this2.$panoObject.getPosition());
          }
          decrement();
        });

        _this2.$watch('finalLatLng', function () {
          increment();
          _this2.$panoObject.setPosition(_this2.finalLatLng);
        });
      });

      // binding events
      (0, _eventsBinder2.default)(_this2, _this2.$panoObject, events);

      _this2.$panoCreatedDeferred.resolve(_this2.$panoObject);

      return _this2.$panoCreated;
    }).catch(function (error) {
      throw error;
    });
  }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"vue-street-view-pano-container\">\n  <div ref=\"vue-street-view-pano\" class=\"vue-street-view-pano\"></div>\n  <slot></slot>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n.vue-street-view-pano-container {\n  position: relative;\n}\n\n.vue-street-view-pano-container .vue-street-view-pano {\n  left: 0; right: 0; top: 0; bottom: 0;\n  position: absolute;\n}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-5ec059f0", module.exports)
  } else {
    hotAPI.update("_v-5ec059f0", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"../manager.js":826,"../utils/TwoWayBindingWrapper.js":827,"../utils/deferredReady.js":828,"../utils/eventsBinder.js":829,"../utils/getPropsValuesMixin.js":830,"../utils/mountableMixin.js":831,"../utils/propsBinder.js":832,"babel-runtime/core-js/object/assign":50,"babel-runtime/core-js/promise":59,"lodash/omit":720,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],825:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MountableMixin = exports.Autocomplete = exports.MapElementMixin = exports.PlaceInput = exports.Map = exports.InfoWindow = exports.Rectangle = exports.Circle = exports.Polygon = exports.Polyline = exports.Cluster = exports.Marker = exports.loaded = exports.load = undefined;
exports.install = install;

var _manager = require('./manager.js');

var _marker = require('./components/marker');

var _marker2 = _interopRequireDefault(_marker);

var _cluster = require('./components/cluster');

var _cluster2 = _interopRequireDefault(_cluster);

var _polyline = require('./components/polyline');

var _polyline2 = _interopRequireDefault(_polyline);

var _polygon = require('./components/polygon');

var _polygon2 = _interopRequireDefault(_polygon);

var _circle = require('./components/circle');

var _circle2 = _interopRequireDefault(_circle);

var _rectangle = require('./components/rectangle');

var _rectangle2 = _interopRequireDefault(_rectangle);

var _infoWindow = require('./components/infoWindow.vue');

var _infoWindow2 = _interopRequireDefault(_infoWindow);

var _map = require('./components/map.vue');

var _map2 = _interopRequireDefault(_map);

var _streetViewPanorama = require('./components/streetViewPanorama.vue');

var _streetViewPanorama2 = _interopRequireDefault(_streetViewPanorama);

var _placeInput = require('./components/placeInput.vue');

var _placeInput2 = _interopRequireDefault(_placeInput);

var _autocomplete = require('./components/autocomplete.vue');

var _autocomplete2 = _interopRequireDefault(_autocomplete);

var _mapElementMixin = require('./components/mapElementMixin');

var _mapElementMixin2 = _interopRequireDefault(_mapElementMixin);

var _mountableMixin = require('./utils/mountableMixin');

var _mountableMixin2 = _interopRequireDefault(_mountableMixin);

var _deferredReady = require('./utils/deferredReady');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// export everything


// Vue component imports
exports.load = _manager.load;
exports.loaded = _manager.loaded;
exports.Marker = _marker2.default;
exports.Cluster = _cluster2.default;
exports.Polyline = _polyline2.default;
exports.Polygon = _polygon2.default;
exports.Circle = _circle2.default;
exports.Rectangle = _rectangle2.default;
exports.InfoWindow = _infoWindow2.default;
exports.Map = _map2.default;
exports.PlaceInput = _placeInput2.default;
exports.MapElementMixin = _mapElementMixin2.default;
exports.Autocomplete = _autocomplete2.default;
exports.MountableMixin = _mountableMixin2.default;
function install(Vue, options) {
  options = Object.assign({}, {
    installComponents: true
  }, options);

  Vue.use(_deferredReady.DeferredReady);

  var defaultResizeBus = new Vue();
  Vue.$gmapDefaultResizeBus = defaultResizeBus;
  Vue.mixin({
    created: function created() {
      this.$gmapDefaultResizeBus = defaultResizeBus;
    }
  });

  if (options.load) {
    (0, _manager.load)(options.load);
  }

  if (options.installComponents) {
    Vue.component('GmapMap', _map2.default);
    Vue.component('GmapMarker', _marker2.default);
    Vue.component('GmapCluster', _cluster2.default);
    Vue.component('GmapInfoWindow', _infoWindow2.default);
    Vue.component('GmapPolyline', _polyline2.default);
    Vue.component('GmapPolygon', _polygon2.default);
    Vue.component('GmapCircle', _circle2.default);
    Vue.component('GmapRectangle', _rectangle2.default);
    Vue.component('GmapAutocomplete', _autocomplete2.default);
    Vue.component('GmapPlaceInput', _placeInput2.default);
    Vue.component('GmapStreetViewPanorama', _streetViewPanorama2.default);
  }
}

},{"./components/autocomplete.vue":813,"./components/circle":814,"./components/cluster":815,"./components/infoWindow.vue":816,"./components/map.vue":817,"./components/mapElementMixin":818,"./components/marker":819,"./components/placeInput.vue":820,"./components/polygon":821,"./components/polyline":822,"./components/rectangle":823,"./components/streetViewPanorama.vue":824,"./manager.js":826,"./utils/deferredReady":828,"./utils/mountableMixin":831}],826:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* vim: set softtabstop=2 shiftwidth=2 expandtab : */

var setUp = false;

var loaded = exports.loaded = new Promise(function (resolve, reject) {
  // eslint-disable-line no-unused-vars
  if (typeof window === 'undefined') {
    // Do nothing if run from server-side
    return;
  }
  window['vueGoogleMapsInit'] = resolve;
});

/**
 * @param apiKey    API Key, or object with the URL parameters. For example
 *                  to use Google Maps Premium API, pass
 *                    `{ client: <YOUR-CLIENT-ID> }`.
 *                  You may pass the libraries and/or version (as `v`) parameter into
 *                  this parameter and skip the next two parameters
 * @param version   Google for Maps version
 * @param libraries Libraries to load (@see
 *                  https://developers.google.com/maps/documentation/javascript/libraries)
 * @param loadCn    Boolean. If set to true, the map will be loaded form goole maps China
 *                  (@see https://developers.google.com/maps/documentation/javascript/basics#GoogleMapsChina)
 *
 * Example:
 * ```
 *      import {load} from 'vue-google-maps'
 *
 *      load(<YOUR-API-KEY>)
 *
 *      load({
 *              key: <YOUR-API-KEY>,
 *      })
 *
 *      load({
 *              client: <YOUR-CLIENT-ID>,
 *              channel: <YOUR CHANNEL>
 *      })
 * ```
 */
var load = exports.load = function load(apiKey, version, libraries, loadCn) {
  if (typeof document === 'undefined') {
    // Do nothing if run from server-side
    return;
  }
  if (!setUp) {
    var googleMapScript = document.createElement('SCRIPT');

    // Allow apiKey to be an object.
    // This is to support more esoteric means of loading Google Maps,
    // such as Google for business
    // https://developers.google.com/maps/documentation/javascript/get-api-key#premium-auth
    var options = {};
    if (typeof apiKey === 'string') {
      options.key = apiKey;
    } else if ((typeof apiKey === 'undefined' ? 'undefined' : _typeof(apiKey)) === 'object') {
      for (var k in apiKey) {
        // transfer values in apiKey to options
        options[k] = apiKey[k];
      }
    } else {
      throw new Error('apiKey should either be a string or an object');
    }

    // libraries
    var librariesPath = '';
    if (libraries && libraries.length > 0) {
      librariesPath = libraries.join(',');
      options['libraries'] = librariesPath;
    } else if (Array.prototype.isPrototypeOf(options.libraries)) {
      options.libraries = options.libraries.join(',');
    }
    options['callback'] = 'vueGoogleMapsInit';

    var baseUrl = 'https://maps.googleapis.com/';

    if (typeof loadCn === 'boolean' && loadCn === true) {
      baseUrl = 'http://maps.google.cn/';
    }

    var url = baseUrl + 'maps/api/js?' + Object.keys(options).map(function (key) {
      return encodeURIComponent(key) + '=' + encodeURIComponent(options[key]);
    }).join('&');

    if (version) {
      url = url + '&v=' + version;
    }

    googleMapScript.setAttribute('src', url);
    googleMapScript.setAttribute('async', '');
    googleMapScript.setAttribute('defer', '');
    document.body.appendChild(googleMapScript);
  } else {
    throw new Error('You already started the loading of google maps');
  }
};

},{}],827:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TwoWayBindingWrapper;
/**
 * When you have two-way bindings, but the actual bound value will not equal
 * the value you initially passed in, then to avoid an infinite loop you
 * need to increment a counter every time you pass in a value, decrement the
 * same counter every time the bound value changed, but only bubble up
 * the event when the counter is zero.
 *
Example:

Let's say DrawingRecognitionCanvas is a deep-learning backed canvas
that, when given the name of an object (e.g. 'dog'), draws a dog.
But whenever the drawing on it changes, it also sends back its interpretation
of the image by way of the @newObjectRecognized event.

<input
  type="text"
  placeholder="an object, e.g. Dog, Cat, Frog"
  v-model="identifiedObject" />
<DrawingRecognitionCanvas
  :object="identifiedObject"
  @newObjectRecognized="identifiedObject = $event"
  />

new TwoWayBindingWrapper((increment, decrement, shouldUpdate) => {
  this.$watch('identifiedObject', () => {
    // new object passed in
    increment()
  })
  this.$deepLearningBackend.on('drawingChanged', () => {
    recognizeObject(this.$deepLearningBackend)
      .then((object) => {
        decrement()
        if (shouldUpdate()) {
          this.$emit('newObjectRecognized', object.name)
        }
      })
  })
})
 */
function TwoWayBindingWrapper(fn) {
  var counter = 0;

  fn(function () {
    counter += 1;
  }, function () {
    counter = Math.max(0, counter - 1);
  }, function () {
    return counter === 0;
  });
}

},{}],828:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * 1. Create a DeferredReady plugin.
 *
 * a. Updates options.configMergeStrategies to handle our new hook correctly (using Promise.all!)
 *
 * 2. VueGoogleMaps uses a DeferredReady mixin.
 *
 *     a. Each component checks for ancestors that are also DeferredReady (via dispatch/emit)
 *     b. If no, then run DeferredReady after ready.
 *     c. If yes, then run DeferredReady after parent's deferredReady.
 *
 *
 * Say we have the following inheritance:
 *
 * --> == 'child of'
 *
 * A --> B --> C
 *
 * ready is called in the following order:
 *
 * A.ready, B.ready, C.ready
 *
 * C.ready -- no further ancestors supporting mixin, so in ready() we run+
 *
   **/

var DeferredReady = exports.DeferredReady = {
  install: function install(Vue, options) {
    // eslint-disable-line no-unused-vars
    // Use the same merge strategy as regular hooks
    Vue.config.optionMergeStrategies.deferredReady = Vue.config.optionMergeStrategies.created;
    Vue.config.optionMergeStrategies.beforeDeferredReady = Vue.config.optionMergeStrategies.beforeDeferredReady;
  }
};

function runHooks(vm) {
  var hooks = vm.$options.deferredReady || [];

  // Run the beforeDeferredReady methods first
  var beforePromise = vm.beforeDeferredReady ? typeof vm.beforeDeferredReady.then === 'function' ? vm.beforeDeferredReady : Promise.all(vm.beforeDeferredReady) : Promise.resolve(null);

  beforePromise.then(function () {
    if (typeof hooks === 'function') {
      hooks = [hooks];
    }
    return Promise.all(hooks.map(function (x) {
      try {
        return x.apply(vm);
      } catch (err) {
        console.error(err.stack); // eslint-disable-line no-console
      }
    }));
    // execute all handlers, expecting them to return promises
    // wait for the promises to complete, before allowing child to execute
  }).then(function () {
    vm.$deferredReadyPromiseResolve();
  });
}

var DeferredReadyMixin = exports.DeferredReadyMixin = {
  /* Resolved after the deferredReady has been called
    and the (optional) promise it returns has been
    resolved */
  $deferredReadyPromise: false,
  $deferredReadyPromiseResolve: false,
  $deferredReadyAncestor: false,

  created: function created() {
    var _this = this;

    this.$deferredReadyPromise = new Promise(function (resolve, reject) {
      // eslint-disable-line no-unused-vars
      _this.$deferredReadyPromiseResolve = resolve;
    });

    var search = this.$parent;
    while (search) {
      if (search.$deferredReadyPromise) {
        this.$deferredReadyAncestor = search;
        break;
      }
      search = search.$parent;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    // Execute the hooks only if this is the first
    // ancestor that is a DeferredReady
    // this.$deferredReadyMountedPromiseResolve();

    if (!this.$deferredReadyAncestor) {
      runHooks(this);
    } else {
      this.$deferredReadyAncestor.$deferredReadyPromise.then(function () {
        runHooks(_this2);
      });
    }
  }
};

},{}],829:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _forEach = require('lodash/forEach');

var _forEach2 = _interopRequireDefault(_forEach);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (vueElement, googleMapObject, events) {
  (0, _forEach2.default)(events, function (eventName) {
    var exposedName = eventName;
    googleMapObject.addListener(eventName, function (ev) {
      vueElement.$emit(exposedName, ev);
    });
  });
}; /* vim: set softtabstop=2 shiftwidth=2 expandtab : */

},{"lodash/forEach":696}],830:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mapValues = require('lodash/mapValues');

var _mapValues2 = _interopRequireDefault(_mapValues);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  methods: {
    getPropsValues: function getPropsValues() {
      var _this = this;

      return (0, _mapValues2.default)(this.$options.props, function (v, k) {
        return _this[k];
      });
    }
  }
};

},{"lodash/mapValues":718}],831:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
Mixin for objects that are mounted by Google Maps
Javascript API.

These are objects that are sensitive to element resize
operations so it exposes a property which accepts a bus

*/

exports.default = {
  props: ['resizeBus'],

  data: function data() {
    return {
      _actualResizeBus: null
    };
  },
  created: function created() {
    if (typeof this.resizeBus === 'undefined') {
      this.$data._actualResizeBus = this.$gmapDefaultResizeBus;
    } else {
      this.$data._actualResizeBus = this.resizeBus;
    }
  },


  methods: {
    _resizeCallback: function _resizeCallback() {
      this.resize();
    },
    _delayedResizeCallback: function _delayedResizeCallback() {
      var _this = this;

      this.$nextTick(function () {
        return _this._resizeCallback();
      });
    }
  },

  watch: {
    resizeBus: function resizeBus(newVal, oldVal) {
      // eslint-disable-line no-unused-vars
      this.$data._actualResizeBus = newVal;
    },
    '$data._actualResizeBus': function $data_actualResizeBus(newVal, oldVal) {
      if (oldVal) {
        oldVal.$off('resize', this._delayedResizeCallback);
      }
      if (newVal) {
        newVal.$on('resize', this._delayedResizeCallback);
      }
    }
  },

  destroyed: function destroyed() {
    if (this.$data._actualResizeBus) {
      this.$data._actualResizeBus.$off('resize', this._delayedResizeCallback);
    }
  }
};

},{}],832:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _forIn = require('lodash/forIn');

var _forIn2 = _interopRequireDefault(_forIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
} /* vim: set softtabstop=2 shiftwidth=2 expandtab : */

exports.default = function (vueElement, googleMapsElement, props, options) {
  options = options || {};
  var _options = options,
      afterModelChanged = _options.afterModelChanged;

  (0, _forIn2.default)(props, function (_ref, attribute) {
    var twoWay = _ref.twoWay,
        type = _ref.type,
        trackProperties = _ref.trackProperties;

    var setMethodName = 'set' + capitalizeFirstLetter(attribute);
    var getMethodName = 'get' + capitalizeFirstLetter(attribute);
    var eventName = attribute.toLowerCase() + '_changed';
    var initialValue = vueElement[attribute];

    if (typeof googleMapsElement[setMethodName] === 'undefined') {
      throw new Error(setMethodName + ' is not a method of (the Maps object corresponding to) ' + vueElement.$options._componentTag);
    }

    // We need to avoid an endless
    // propChanged -> event emitted -> propChanged -> event emitted loop
    // although this may really be the user's responsibility
    var timesSet = 0;
    if (type !== Object || !trackProperties) {
      // Track the object deeply
      vueElement.$watch(attribute, function () {
        var attributeValue = vueElement[attribute];

        timesSet++;
        googleMapsElement[setMethodName](attributeValue);
        if (afterModelChanged) {
          afterModelChanged(attribute, attributeValue);
        }
      }, {
        immediate: typeof initialValue !== 'undefined',
        deep: type === Object
      });
    } else {
      // I can watch multiple properties, but the danger is that each of
      // them triggers the event handler multiple times
      // This ensures that the event handler will only be fired once
      var tick = 0;
      var expectedTick = 0;

      var raiseExpectation = function raiseExpectation() {
        expectedTick += 1;
      };

      var updateTick = function updateTick() {
        tick = Math.max(expectedTick, tick + 1);
      };

      var respondToChange = function respondToChange() {
        if (tick < expectedTick) {
          googleMapsElement[setMethodName](vueElement[attribute]);

          if (afterModelChanged) {
            afterModelChanged(attribute, vueElement[attribute]);
          }

          updateTick();
        }
      };

      trackProperties.forEach(function (propName) {
        // When any props change -- assume they change on the same tick
        vueElement.$watch(attribute + '.' + propName, function () {
          raiseExpectation();
          vueElement.$nextTick(respondToChange);
        }, {
          immediate: typeof initialValue !== 'undefined'
        });
      });
    }

    if (twoWay) {
      googleMapsElement.addListener(eventName, function (ev) {
        // eslint-disable-line no-unused-vars
        /* Check for type === Object because we're quite happy
          when primitive types change -- the change detection is cheap
        */
        if (type === Object && timesSet > 0) {
          timesSet--;
        } else {
          vueElement.$emit(eventName, googleMapsElement[getMethodName]());
        }
      });
    }
  });
};

},{"lodash/forIn":697}],833:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

// This piece of code was orignally written by amirnissim and can be seen here
// http://stackoverflow.com/a/11703018/2694653
// This has been ported to Vanilla.js by GuillaumeLeclerc
exports.default = function (input) {
  var _addEventListener = input.addEventListener ? input.addEventListener : input.attachEvent;

  function addEventListenerWrapper(type, listener) {
    // Simulate a 'down arrow' keypress on hitting 'return' when no pac suggestion is selected,
    // and then trigger the original listener.
    if (type === 'keydown') {
      var origListener = listener;
      listener = function listener(event) {
        var suggestionSelected = document.getElementsByClassName('pac-item-selected').length > 0;
        if (event.which === 13 && !suggestionSelected) {
          var simulatedEvent = document.createEvent('Event');
          simulatedEvent.keyCode = 40;
          simulatedEvent.which = 40;
          origListener.apply(input, [simulatedEvent]);
        }
        origListener.apply(input, [event]);
      };
    }
    _addEventListener.apply(input, [type, listener]);
  }

  input.addEventListener = addEventListenerWrapper;
  input.attachEvent = addEventListenerWrapper;
};

},{}],834:[function(require,module,exports){
module.exports={
    "general": {
        "ok": "OK",
        "cancel": "Cancel",
        "reUpload": "Reset",
        "details": "Details",
        "date": "Date",
        "reason": "Reason",
        "name": "Name",
        "status": "Status",
        "update": "Change",
        "submit": "Submit",
        "create": "Create",
        "modify": "Modify",
        "delete": "Delete",
        "branch": "Branch",
        "studio": "Studio",
        "description": "Description",
        "inactive": "下架",
        "active": "上架",
        "disable": "停用",
        "enable": "啟用",
        "monday": "Mon",
        "tuesday": "Tue",
        "wednesday": "Wed",
        "thursday": "Thu",
        "friday": "Fri",
        "saturday": "Sat",
        "sunday": "Sun",
        "minutes": "mins",
        "hours": "hours",
        "morning": "am",
        "afternoon": "pm",
        "close": "Close",
        "OK": "OK",
        "none": "None",
        "unknown_error": "Something Wrong.",
        "unknown_error_try_again": "Something Wrong. Please try again.",
        "created_successfully": "Created Successfully",
        "updated_successfully": "Updated Successfully",
        "deleted_successfully": "Deleted Successfully",
        "return": "Back",
        "change": "change",
        "show_result": "Show result",
        "reset": "Reset",
        "filter_by": "Filter by",
        "class": "Class",
        "service": "Service",
        "contract": "Pass",
        "subscription_contract": "Subscription plan",
        "staff": "Staff",
        "rating": "Rating",
        "info": "More Info",
        "appointment": "Book",
        "check": "Check",
        "category": "Category",
        "price": "Price",
        "helper_info": "More Info",
        "supported_by_17fit": "Supported by 17FIT"
    },
    "unit": {
        "day": "day",
        "days": "days"
    },
    "filter": {
        "sort_recommend": "Sort by: Recommend",
        "no_pick_up": "Selection required"
    },
    "location": {
        "title": "location setting",
        "add": "add",
        "modify": "modify",
        "location": "location",
        "name": "name",
        "address": "address",
        "please_type": "please type",
        "submit": "submit",
        "delete": "delete",
        "close": "close",
        "require_message": "Column required",
        "wrong_address_message": "Unable to identify address. Please enter again.",
        "used": "Location in use. Can not be deleted",
        "got_it": "Got it"
    },
    "rating": {
        "reallysuck": "very awful",
        "awful": "awful",
        "unsatisfied": "unsatisfied",
        "needimprove": "need improve",
        "normal": "normal",
        "itsok": "ok",
        "notbad": "not bad",
        "good": "good",
        "verygood": "very good!",
        "perfect": "perfect!",
        "comments": "comments",
        "more": "Read More",
        "have_no_any_comment": "No comments"
    },
    "payment": {
        "not_allow_online_payment": "Online payment is not enabled, please contact the business.",
        "card_number": "Credit card number",
        "card_mm": "MM",
        "card_yy": "YY",
        "card_cvv": "CVV",
        "unavailable_payment": "Not yet activated",
        "order_confirmation": "Order created",
        "payment_time_remind_first": "Please complete ATM payment before ",
        "payment_expire_note": "Incomplete order will be automatically canceled after 48 hours.",
        "forward_to_payment": "Continue to payment",
        "forward_to_myaccount": "Back to account",
        "latest_unpaid_order_alert": "You have a pending payment. Please complete the payment before {expire_time}, or otherwise the order will be cancelled.",
        "forward_check_up": "more...",
        "neweb_credit_card": "Credit Card",
        "neweb_bank_transfer": "Bank Transfer",
        "back_to_myaccount": "Back to account"
    },
    "promotion": {
        "discount": "Discount",
        "invalid_promotion": "Invalid Promotion Code",
        "promotion_code": "Promotion Code",
        "submit": "Submit",
        "total": "Total Amount"
    },
    "invoice": {
        "lottery": "Uniform invoice",
        "person": "B2C",
        "company": "B2B",
        "donate": "Donate",
        "person_data": {
            "carry_pay2_go": "Paperless",
            "print_code": "Ask for a print out",
            "ubn_num": "Tax ID number",
            "ubn_title": "Company name",
            "write_ubn_num": "Input tax ID",
            "write_ubn_title": "Input company name",
            "info": "You'll receive an email notification from ezpay."
        },
        "paramater_error": "Error , please check again if all fields are filled out correctly.",
        "select_invoice_type": "Select Receipt Type",
        "winning_alert": "You'll receive an email notification from ezpay.",
        "get_print_code": "Ask for a print out"
    },
    "class":{
        "closed": "Closed",
        "fully_booked": "Fully booked",
        "unavailable": "Unavailable",
        "only_booking_by_contract": "Pass required",
        "have_contract": "Pass",
        "have_no_any_class": "No service available",
        "already_display_recently_classes": "All recent results have been showed",
        "show_more": "Show more",
        "booking_rate_limit_exceeded_message": "Sorry, there are too many users right now. Please try again later.",
        "toward_more_class": "Browse other courses"
    },
    "service": {
        "description": "More Info",
        "only_booking_by_contract": "Pass required",
        "have_contract": "Pass",
        "have_no_any_service": "No service available"
    },
    "pass": {
        "info": "More Info",
        "buy": "Buy",
        "sold_out": "Sold out",
        "item_with_pass": "Pass(with this item)",
        "expire_time": "Expiration date",
        "class_can_go": "Class available",
        "service_can_go": "Service available",
        "point": "point",
        "close": "Close",
        "next": "Next",
        "payment_method": "Payment method",
        "previous": "Previous",
        "buy_success": "Success!",
        "class_to_reserved": "Booked!",
        "unknow_error_to_service": "Unknow error, please contact services",
        "thirdparty_credit_card": "third party payment",
        "validate_card_success": "Credit card validated",
        "click_button": "Click",
        "contract_used_member": "User",
        "cancel_all_bookings": "Cancel All Bookings",
        "confirm_cancel_all_bookings": "Confirm Cancel",
        "cancel_success": "Cancel Success",
        "contract_used_member": "User",
        "appointment_note": "Appointment note",
        "enter_note": "Please Enter Note ...",
        "trail_plan": "Trial Plan",
        "have_no_any_contract": "No pricing option available",
        "buy_contract": "Plans",
        "buy_subscription_contract": "Buy subscription plan",
        "approval_term": "I have read and accept the ",
        "first_period_payment": "首期支付",
        "payment_each_term": "每期支付",
        "contract_rights_each_term": "每期方案權益",
        "effective_days": "有效期間",
        "subscription_direction": "訂閱說明"
    },
    "staff": {
        "album": "Photos",
        "no_further_info": "No further information"
    },
    "messages": {
        "my_message": "My Message",
        "show_all": "Show all message in recent 30 days"
    },
    "webadmin": {
        "general": {
            "delete_this_image": "Confirm to delete this image?"
        },
        "event": {
            "event": " Event",
            "event_name": "Event Name",
            "action_button": "Action Button",
            "pics": "Pictures",
            "buy_now": "Buy Now",
            "new_page": "Open A New Page",
            "chose_contract": "Chose A Pass",
            "delete_this_event": "Confirm to delete this event?"
        }
    }
}
},{}],835:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _enUs = require('./en-us.json');

var _enUs2 = _interopRequireDefault(_enUs);

var _error = require('./error.json');

var _error2 = _interopRequireDefault(_error);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _extends3.default)({
    error: _error2.default
}, _enUs2.default);

},{"./en-us.json":834,"./error.json":836,"babel-runtime/helpers/extends":66}],836:[function(require,module,exports){
module.exports={
    "msg": {
        "1R001": "Rate limit exceeded. Please try again later.",
        "1R002": "Operation could not be completed due to abnormal rate limit. Please try again later.",
        "1R003": "Operation could not be completed due to abnormal rate limit. Please try again later.",
        "1R004": "Operation could not be completed due to abnormal rate limit. Please try again later.",
        "1R005": "Operation could not be completed due to abnormal rate limit. Please try again later.",
        "1R006": "Operation could not be completed due to abnormal rate limit. Please try again later.",
        "M1000": "An error occurred, please try again later.",
        "M1001": "The account does not exist or the password is incorrect.",
        "M1002": "This account has been suspended, please contact customer service.",
        "M1003": "This country code does not exist.",
        "M1004": "Please enter the user account.",
        "M1005": "Please enter your phone number.",
        "M1006": "Please enter your email address.",
        "M1007": "This username has already been taken. Please try a different combination of characters.",
        "M1008": "This phone number has already been used.",
        "M1009": "This email address has already been used.",
        "M1010": "Please enter the password.",
        "M1011": "Incorrect password format.",
        "M1012": "This account is already linked to another 17FIT account.",
        "M1013": "This account already exists under this brand.",
        "M1014": "Token decode error.",
        "M1015": "Token encode error.",
        "M1016": "This member is already linked to a 17FIT account."
    }
}
},{}],837:[function(require,module,exports){
module.exports={
    "msg": {
        "1R001": "目前流量已達上限，請稍候再試。",
        "1R002": "因流量管制異常，無法完成操作，請稍後再試。",
        "1R003": "因流量管制異常，無法完成操作，請稍後再試。",
        "1R004": "因流量管制異常，無法完成操作，請稍後再試。",
        "1R005": "因流量管制異常，無法完成操作，請稍後再試。",
        "1R006": "因流量管制異常，無法完成操作，請稍後再試。",
        "M1000": "發生錯誤，請稍候再試。",
        "M1001": "該帳戶不存在或密碼錯誤。",
        "M1002": "此帳戶已停權，請聯繫客服人員。",
        "M1003": "此國碼不存在。",
        "M1004": "請輸入使用者帳號。",
        "M1005": "請輸入手機號碼。",
        "M1006": "請輸入電子信箱。",
        "M1007": "此使用者帳號已被使用。",
        "M1008": "此手機號碼已被使用。",
        "M1009": "此信箱已被使用。",
        "M1010": "請輸入密碼。",
        "M1011": "密碼格式錯誤。",
        "M1012": "此帳戶已與其他17FIT帳戶綁定。",
        "M1013": "此帳戶的會員資料已存在於該品牌。",
        "M1014": "金鑰解密失敗。",
        "M1015": "金鑰加密失敗。",
        "M1016": "此會員已有綁定的17FIT帳戶。"
    }
}
},{}],838:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _zhTw = require('./zh-tw.json');

var _zhTw2 = _interopRequireDefault(_zhTw);

var _error = require('./error.json');

var _error2 = _interopRequireDefault(_error);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _extends3.default)({
    error: _error2.default
}, _zhTw2.default);

},{"./error.json":837,"./zh-tw.json":839,"babel-runtime/helpers/extends":66}],839:[function(require,module,exports){
module.exports={
    "general": {
        "ok": "確定",
        "cancel": "取消",
        "reUpload": "重新上傳",
        "details": "詳細資料",
        "date": "日期",
        "reason": "原因",
        "name": "名稱",
        "status": "狀態",
        "update": "異動",
        "submit": "送出",
        "create": "新增",
        "modify": "修改",
        "delete": "刪除",
        "branch": "場館",
        "studio": "品牌",
        "description": "說明",
        "inactive": "下架",
        "active": "上架",
        "disable": "停用",
        "enable": "啟用",
        "monday": "一",
        "tuesday": "二",
        "wednesday": "三",
        "thursday": "四",
        "friday": "五",
        "saturday": "六",
        "sunday": "日",
        "minutes": "分鐘",
        "hours": "小時",
        "morning": "上午",
        "afternoon": "下午",
        "close": "關閉",
        "OK": "OK",
        "none": "無",
        "unknown_error": "發生錯誤",
        "unknown_error_try_again": "發生錯誤，請重新操作",
        "created_successfully": "新增成功",
        "updated_successfully": "更新成功",
        "deleted_successfully": "刪除成功",
        "return": "返回",
        "change": "變更",
        "refresh": "重新整理",
        "show_result": "顯示結果",
        "reset": "重置",
        "filter_by": "篩選項目",
        "class": "課程",
        "service": "服務",
        "contract": "方案",
        "subscription_contract": "訂閱制方案",
        "staff": "人員",
        "rating": "評價",
        "info": "更多資訊",
        "appointment": "預約",
        "check": "查看",
        "category": "類型",
        "price": "價格",
        "helper_info": "了解詳情",
        "supported_by_17fit": "由 17FIT 提供支援"
    },
    "unit": {
        "day": "天",
        "days": "天"
    },
    "filter": {
        "sort_recommend": "排序：推薦",
        "no_pick_up": "無任何選擇"
    },
    "location": {
        "title": "地點設定",
        "add": "新增",
        "modify": "修改",
        "location": "地點",
        "name": "名稱",
        "address": "地址",
        "please_type": "請輸入",
        "submit": "送出",
        "delete": "刪除",
        "close": "關閉",
        "require_message": "尚有必填欄位未填",
        "wrong_address_message": "無法解析您的地址，請重新輸入",
        "used": "此地點仍被使用中，無法刪除",
        "got_it": "我知道了"
    },
    "rating": {
        "reallysuck": "糟透了",
        "awful": "非常糟",
        "unsatisfied": "不滿意",
        "needimprove": "有待改進",
        "normal": "普通",
        "itsok": "還可以",
        "notbad": "不錯",
        "good": "好",
        "verygood": "非常好！",
        "perfect": "完美！",
        "comments": "則評價",
        "more": "看更多",
        "have_no_any_comment": "目前尚無評論"
    },
    "payment": {
        "not_allow_online_payment": "線上交易功能尚未啟用，請聯繫場館",
        "card_number": "信用卡號碼",
        "card_mm": "MM(月)",
        "card_yy": "YY(年)",
        "card_cvv": "簽名處末三碼",
        "unavailable_payment": "尚未啟用",
        "order_confirmation": "訂單已建立",
        "payment_time_remind_first": "請記得於期限前完成付款 ",
        "payment_expire_note": "未付款訂單將會於 48 小時後自動取消",
        "forward_to_payment": "前往付款",
        "back_to_myaccount": "返回帳戶",
        "latest_unpaid_order_alert": "您有未付款訂單，請記得於 {expire_time} 前完成訂單付款，若未完成則自動取消",
        "forward_check_up": "前往查看",
        "neweb_credit_card": "線上刷卡",
        "neweb_bank_transfer": "銀行轉帳"
    },
    "promotion": {
        "discount": "促銷活動",
        "invalid_promotion": "無效的優惠券",
        "promotion_code": "輸入優惠券",
        "submit": "使用",
        "total": "本次結帳金額"
    },
    "invoice": {
        "lottery": "電子發票",
        "person": "二聯式 (個人)",
        "company": "三聯式 (公司)",
        "donate": "捐贈",
        "person_data": {
            "carry_pay2_go": "無實體",
            "print_code": "索取紙本",
            "ubn_num": "統一編號",
            "ubn_title": "公司行號抬頭",
            "write_ubn_num": "填寫統一編號",
            "write_ubn_title": "填寫公司行號抬頭",
            "info": "結帳後，您將會收到 ezpay 電子發票開立通知信。若您的發票中獎，場館將主動通知您。"
        },
        "paramater_error": "電子發票檢查錯誤，請檢查所有欄位皆有填寫或選擇。",
        "select_invoice_type": "請選擇發票類型",
        "winning_alert": "中獎時會收到通知",
        "get_print_code": "索取紙本"
    },
    "class":{
        "closed": "已截止",
        "fully_booked": "已額滿",
        "unavailable": "尚未開放",
        "only_booking_by_contract": "方案限定",
        "have_contract": "已有方案",
        "have_no_any_class": "目前尚無課程",
        "already_display_recently_classes": "已經顯示近期的所有開課結果",
        "show_more": "查看更多課程",
        "booking_rate_limit_exceeded_message": "目前使用人數過多，請重新嘗試",
        "toward_more_class": "瀏覽其他課程"
    },
    "service": {
        "description": "服務說明",
        "only_booking_by_contract": "方案限定",
        "have_contract": "已有方案",
        "have_no_any_service": "目前尚無服務"
    },
    "pass": {
        "info": "方案說明",
        "buy": "購買",
        "sold_out": "售完",
        "item_with_pass": "包含此項目的方案",
        "expire_time": "有效期間",
        "class_can_go": "可進行的課程",
        "service_can_go": "可進行的服務",
        "point": "點",
        "close": "關閉",
        "next": "下一步",
        "payment_method": "付款方式",
        "previous": "上一步",
        "buy_success": "購買成功！",
        "class_to_reserved": "已將此課程加入您的預約！",
        "unknow_error_to_service": "系統發生不明錯誤，請洽客服人員！",
        "thirdparty_credit_card": "第三方刷卡",
        "validate_card_success": "驗證信用卡成功",
        "click_button": "按鍵點擊",
        "contract_used_member": "使用人",
        "cancel_all_bookings": "取消資格",
        "confirm_cancel_all_bookings": "確認取消資格",
        "cancel_success": "已取消資格",
        "appointment_note": "預約備註",
        "enter_note": "請輸入備註...",
        "trail_plan": "體驗方案",
        "have_no_any_contract": "目前尚無方案",
        "description": "方案說明",
        "buy_contract": "購買方案",
        "buy_subscription_contract": "購買訂閱制方案",
        "approval_term": "我同意以下條款",
        "first_period_payment": "首期支付",
        "payment_each_term": "每期支付",
        "contract_rights_each_term": "每期方案權益",
        "effective_days": "有效期間",
        "subscription_direction": "訂閱說明"
    },
    "staff": {
        "album": "相簿",
        "no_further_info": "目前無該人員的介紹 ..."
    },
    "messages": {
        "my_message": "我的訊息",
        "show_all": "顯示近 30 天的全部通知"
    },
    "webadmin": {
        "general": {
            "delete_this_image": "確認刪除此圖片？"
        },
        "error": {
            "cant_get_studio_members": "取得客戶資料，發生錯誤"
        },
        "event": {
            "event": "活動",
            "event_name": "活動名稱",
            "action_button": "動作",
            "pics": "特色圖",
            "buy_now": "立即購買",
            "new_page": "打開網頁",
            "chose_contract": "請選擇方案",
            "delete_this_event": "確認刪除此活動？"
        }
    }
}
},{}],840:[function(require,module,exports){
arguments[4][836][0].apply(exports,arguments)
},{"dup":836}],841:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _error = require('./error.json');

var _error2 = _interopRequireDefault(_error);

var _message = require('./message.json');

var _message2 = _interopRequireDefault(_message);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// webadmin 暫無英語系，先建立但無用
exports.default = (0, _extends3.default)({
    error: _error2.default
}, _message2.default);

},{"./error.json":840,"./message.json":842,"babel-runtime/helpers/extends":66}],842:[function(require,module,exports){
module.exports={
    "general": {
        "ok": "OK",
        "cancel": "Cancel",
        "reUpload": "Reset",
        "details": "Details",
        "date": "Date",
        "reason": "Reason",
        "name": "Name",
        "status": "Status",
        "update": "Change",
        "submit": "Submit",
        "create": "Create",
        "modify": "Modify",
        "delete": "Delete",
        "branch": "Branch",
        "studio": "Studio",
        "description": "Description",
        "inactive": "下架",
        "active": "上架",
        "disable": "停用",
        "enable": "啟用",
        "monday": "Mon",
        "tuesday": "Tue",
        "wednesday": "Wed",
        "thursday": "Thu",
        "friday": "Fri",
        "saturday": "Sat",
        "sunday": "Sun",
        "minutes": "mins",
        "hours": "hours",
        "morning": "am",
        "afternoon": "pm",
        "close": "Close",
        "OK": "OK",
        "none": "None",
        "unknown_error": "Something Wrong.",
        "unknown_error_try_again": "Something Wrong. Please try again.",
        "created_successfully": "Created Successfully",
        "updated_successfully": "Updated Successfully",
        "deleted_successfully": "Deleted Successfully",
        "return ": "Return",
        "change": "change",
        "show_result": "Show result",
        "reset": "Reset",
        "filter_by": "Filter by",
        "class": "Class",
        "service": "Service",
        "contract": "Pass",
        "staff": "Staff",
        "rating": "Rating",
        "info": "More Info",
        "appointment": "Book",
        "check": "Check",
        "category": "Category",
        "price": "Price",
        "days": "days"
    },
    "filter": {
        "sort_recommend": "Sort by: Recommend",
        "no_pick_up": "Selection required"
    },
    "location": {
        "title": "location setting",
        "add": "add",
        "modify": "modify",
        "location": "location",
        "name": "name",
        "address": "address",
        "please_type": "please type",
        "submit": "submit",
        "delete": "delete",
        "close": "close",
        "require_message": "Column required",
        "wrong_address_message": "Unable to identify address. Please enter again.",
        "used": "Location in use. Can not be deleted",
        "got_it": "Got it"
    },
    "rating": {
        "reallysuck": "very awful",
        "awful": "awful",
        "unsatisfied": "unsatisfied",
        "needimprove": "need improve",
        "normal": "normal",
        "itsok": "ok",
        "notbad": "not bad",
        "good": "good",
        "verygood": "very good!",
        "perfect": "perfect!",
        "comments": "comments",
        "more": "Read More",
        "have_no_any_comment": "No comments"
    },
    "payment": {
        "not_allow_online_payment": "Online payment is not enabled, please contact the business.",
        "card_number": "Credit card number",
        "card_mm": "MM",
        "card_yy": "YY",
        "card_cvv": "CVV"
    },
    "promotion": {
        "discount": "Discount",
        "invalid_promotion": "Invalid Promotion Code",
        "promotion_code": "Promotion Code",
        "submit": "Submit",
        "total": "Total Amount"
    },
    "invoice": {
        "lottery": "Uniform invoice",
        "person": "B2C",
        "company": "B2B",
        "donate": "Donate",
        "person_data": {
            "carry_pay2_go": "Paperless",
            "print_code": "Ask for a print out",
            "ubn_num": "Tax ID number",
            "ubn_title": "Company name",
            "write_ubn_num": "Input tax ID",
            "write_ubn_title": "Input company name",
            "info": "You'll receive an email notification from ezpay."
        },
        "paramater_error": "Error , please check again if all fields are filled out correctly.",
        "select_invoice_type": "Select Receipt Type",
        "winning_alert": "You'll receive an email notification from ezpay.",
        "get_print_code": "Ask for a print out"
    },
    "class":{
        "closed": "Closed",
        "fully_booked": "Fully booked",
        "unavailable": "Unavailable",
        "only_booking_by_contract": "Pass required",
        "have_contract": "Pass",
        "have_no_any_class": "No service available",
        "already_display_recently_classes": "All recent results have been showed",
        "show_more": "Show more"
    },
    "service": {
        "description": "More Info",
        "only_booking_by_contract": "Pass required",
        "have_contract": "Pass",
        "have_no_any_service": "No service available"
    },
    "pass": {
        "info": "More Info",
        "buy": "Buy",
        "sold_out": "Sold out",
        "item_with_pass": "Pass(with this item)",
        "expire_time": "Expiration date",
        "class_can_go": "Class available",
        "service_can_go": "Service available",
        "point": "point",
        "close": "Close",
        "next": "Next",
        "payment_method": "Payment method",
        "previous": "Previous",
        "buy_success": "Success!",
        "class_to_reserved": "Booked!",
        "unknow_error_to_service": "Unknow error, please contact services",
        "thirdparty_credit_card": "third party payment",
        "validate_card_success": "Credit card validated",
        "click_button": "Click",
        "contract_used_member": "User",
        "cancel_all_bookings": "Cancel All Bookings",
        "confirm_cancel_all_bookings": "Confirm Cancel",
        "cancel_success": "Cancel Success",
        "contract_used_member": "User",
        "appointment_note": "Appointment note",
        "enter_note": "Please Enter Note ...",
        "trail_plan": "Trial Plan",
        "have_no_any_contract": "No pricing option available",
        "approval_term": "我同意以下條款",
        "first_period_payment": "首期支付",
        "payment_each_term": "每期支付",
        "contract_rights_each_term": "每期方案權益",
        "effective_days": "有效期間",
        "subscription_direction": "訂閱說明"
    },
    "staff": {
        "album": "Photos",
        "no_further_info": "No further information"
    },
    "messages": {
        "my_message": "My Message",
        "show_all": "Show all message in recent 30 days"
    },
    "webadmin": {
        "general": {
            "delete_this_image": "Confirm to delete this image?"
        },
        "event": {
            "event": " Event",
            "event_name": "Event Name",
            "action_button": "Action Button",
            "pics": "Pictures",
            "buy_now": "Buy Now",
            "new_page": "Open A New Page",
            "chose_contract": "Chose A Pass",
            "delete_this_event": "Confirm to delete this event?"
        }
    }
}
},{}],843:[function(require,module,exports){
arguments[4][837][0].apply(exports,arguments)
},{"dup":837}],844:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _error = require('./error.json');

var _error2 = _interopRequireDefault(_error);

var _message = require('./message.json');

var _message2 = _interopRequireDefault(_message);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _extends3.default)({
    error: _error2.default
}, _message2.default);

},{"./error.json":843,"./message.json":845,"babel-runtime/helpers/extends":66}],845:[function(require,module,exports){
module.exports={
    "general": {
        "ok": "確定",
        "cancel": "取消",
        "reUpload": "重新上傳",
        "details": "詳細資料",
        "date": "日期",
        "reason": "原因",
        "name": "名稱",
        "status": "狀態",
        "update": "異動",
        "submit": "送出",
        "create": "新增",
        "modify": "修改",
        "delete": "刪除",
        "branch": "場館",
        "studio": "品牌",
        "description": "說明",
        "inactive": "下架",
        "active": "上架",
        "disable": "停用",
        "enable": "啟用",
        "monday": "一",
        "tuesday": "二",
        "wednesday": "三",
        "thursday": "四",
        "friday": "五",
        "saturday": "六",
        "sunday": "日",
        "minutes": "分鐘",
        "hours": "小時",
        "morning": "上午",
        "afternoon": "下午",
        "close": "關閉",
        "OK": "OK",
        "none": "無",
        "unknown_error": "發生錯誤",
        "unknown_error_try_again": "發生錯誤，請重新操作",
        "created_successfully": "新增成功",
        "updated_successfully": "更新成功",
        "deleted_successfully": "刪除成功",
        "return ": "返回",
        "change": "變更",
        "refresh": "重新整理",
        "show_result": "顯示結果",
        "reset": "重置",
        "filter_by": "篩選項目",
        "class": "課程",
        "service": "服務",
        "contract": "方案",
        "staff": "人員",
        "rating": "評價",
        "info": "更多資訊",
        "appointment": "預約",
        "check": "查看",
        "category": "類型",
        "price": "價格",
        "days": "天"
    },
    "filter": {
        "sort_recommend": "排序：推薦",
        "no_pick_up": "無任何選擇"
    },
    "location": {
        "title": "地點設定",
        "add": "新增",
        "modify": "修改",
        "location": "地點",
        "name": "名稱",
        "address": "地址",
        "please_type": "請輸入",
        "submit": "送出",
        "delete": "刪除",
        "close": "關閉",
        "require_message": "尚有必填欄位未填",
        "wrong_address_message": "無法解析您的地址，請重新輸入",
        "used": "此地點仍被使用中，無法刪除",
        "got_it": "我知道了"
    },
    "rating": {
        "reallysuck": "糟透了",
        "awful": "非常糟",
        "unsatisfied": "不滿意",
        "needimprove": "有待改進",
        "normal": "普通",
        "itsok": "還可以",
        "notbad": "不錯",
        "good": "好",
        "verygood": "非常好！",
        "perfect": "完美！",
        "comments": "則評價",
        "more": "看更多",
        "have_no_any_comment": "目前尚無評論"
    },
    "payment": {
        "not_allow_online_payment": "線上交易功能尚未啟用，請聯繫場館",
        "card_number": "信用卡卡號",
        "card_mm": "MM(月)",
        "card_yy": "YY(年)",
        "card_cvv": "簽名處末三碼"
    },
    "promotion": {
        "discount": "促銷活動",
        "invalid_promotion": "無效的優惠券",
        "promotion_code": "輸入優惠券",
        "submit": "使用",
        "total": "本次結帳金額"
    },
    "invoice": {
        "lottery": "電子發票",
        "person": "二聯式 (個人)",
        "company": "三聯式 (公司)",
        "donate": "捐贈",
        "person_data": {
            "carry_pay2_go": "無實體",
            "print_code": "索取紙本",
            "ubn_num": "統一編號",
            "ubn_title": "公司行號抬頭",
            "write_ubn_num": "填寫統一編號",
            "write_ubn_title": "填寫公司行號抬頭",
            "info": "結帳後，您將會收到 ezpay 電子發票開立通知信。若您的發票中獎，場館將主動通知您。"
        },
        "paramater_error": "電子發票檢查錯誤，請檢查所有欄位皆有填寫或選擇。",
        "select_invoice_type": "請選擇發票類型",
        "winning_alert": "中獎時會收到通知",
        "get_print_code": "索取紙本"
    },
    "class":{
        "closed": "已截止",
        "fully_booked": "已額滿",
        "unavailable": "尚未開放",
        "only_booking_by_contract": "方案限定",
        "have_contract": "已有方案",
        "have_no_any_class": "目前尚無課程",
        "already_display_recently_classes": "已經顯示近期的所有開課結果",
        "show_more": "查看更多課程"
    },
    "service": {
        "description": "服務說明",
        "only_booking_by_contract": "方案限定",
        "have_contract": "已有方案",
        "have_no_any_service": "目前尚無服務"
    },
    "pass": {
        "info": "方案說明",
        "buy": "購買",
        "sold_out": "售完",
        "item_with_pass": "包含此項目的方案",
        "expire_time": "有效期間",
        "class_can_go": "可進行的課程",
        "service_can_go": "可進行的服務",
        "point": "點",
        "close": "關閉",
        "next": "下一步",
        "payment_method": "付款方式",
        "previous": "上一步",
        "buy_success": "購買成功！",
        "class_to_reserved": "已將此課程加入您的預約！",
        "unknow_error_to_service": "系統發生不明錯誤，請洽客服人員！",
        "thirdparty_credit_card": "第三方刷卡",
        "validate_card_success": "驗證信用卡成功",
        "click_button": "按鍵點擊",
        "contract_used_member": "使用人",
        "cancel_all_bookings": "取消資格",
        "confirm_cancel_all_bookings": "確認取消資格",
        "cancel_success": "已取消資格",
        "appointment_note": "預約備註",
        "enter_note": "請輸入備註...",
        "trail_plan": "體驗方案",
        "have_no_any_contract": "目前尚無方案",
        "description": "方案說明",
        "approval_term": "我同意以下條款",
        "first_period_payment": "首期支付",
        "payment_each_term": "每期支付",
        "contract_rights_each_term": "每期方案權益",
        "effective_days": "有效期間",
        "subscription_direction": "訂閱說明"
    },
    "staff": {
        "album": "相簿",
        "no_further_info": "目前無該人員的介紹 ..."
    },
    "messages": {
        "my_message": "我的訊息",
        "show_all": "顯示近 30 天的全部通知"
    },
    "webadmin": {
        "general": {
            "delete_this_image": "確認刪除此圖片？"
        },
        "event": {
            "event": "活動",
            "event_name": "活動名稱",
            "action_button": "動作",
            "pics": "特色圖",
            "buy_now": "立即購買",
            "new_page": "打開網頁",
            "chose_contract": "請選擇方案",
            "delete_this_event": "確認刪除此活動？"
        }
    }
}
},{}],846:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (cfg) {
    var targetDiv = $(cfg.el);
    var dayStart = getDay(cfg.dayStart);
    var dayEnd = getEndDay();
    var selectedDayString = getSelectedDayString(cfg.selectedDay);
    var currentWidth = getOutsideWidth();

    var dateListBoxDiv = $('<div></div>');
    var dateListDiv = $('<div></div>');
    var dayToWeekdayStringList = [i18n.t('general.sunday'), i18n.t('general.monday'), i18n.t('general.tuesday'), i18n.t('general.wednesday'), i18n.t('general.thursday'), i18n.t('general.friday'), i18n.t('general.saturday')];
    var itemPerPage = 7;
    var flag = {
        ajaxing: false
    };
    var disableDateClick = cfg.hasOwnProperty(disableDateClick) ? cfg.disableDateClick : false;

    var selectedItemCount;
    var centerItemCount;
    var maxItemCount;

    targetDiv.append(dateListBoxDiv);
    dateListBoxDiv.append(dateListDiv);

    appendBtn();
    appendDayList();
    appendDisabledDay();

    setCSS();
    styleSelectedDay();
    bindClick();
    // bindDraggable();
    loadWhenReady();

    $(window).resize(resizeFunction);
    resizeFunction();

    function getOutsideWidth() {
        var widthRef = cfg.widthRef ? $(cfg.widthRef) : targetDiv;
        return parseInt(widthRef.css('width'));
    }

    function loadWhenReady() {
        if (cfg.loadWhenReady && cfg.trigger) {
            cfg.trigger(selectedDayString, flag);
        }
    }

    function bindDraggable() {
        var pre = 0;
        var now = 0;
        var direction;
        function getCenterCount(ui) {
            var pageWidth = parseInt(dateListBoxDiv.css('width'));
            var fullWidth = pageWidth / itemPerPage;
            var left = -ui.position.left;
            var pageCount = Math.floor(left / pageWidth) * itemPerPage;
            var widthCount = Math.floor(left % pageWidth / fullWidth);
            var offset = 4;
            if (itemPerPage == 5) offset = 3;
            if (itemPerPage == 3) offset = 2;
            var count = pageCount + widthCount + offset + direction;

            if (count < 4) count = 4;
            if (count > maxItemCount) count = maxItemCount;
            return count;
        }

        dateListDiv.draggable({
            axis: "x",
            start: function start(event, ui) {
                pre = ui.position.left;
                now = ui.position.left;
            },
            drag: function drag(event, ui) {
                pre = now;
                now = ui.position.left;
                if (pre > now) direction = 1;
                if (now > pre) direction = 0;
            },
            stop: function stop(event, ui) {
                centerItemCount = getCenterCount(ui);
                animatePage();
            }
        });
    }

    function bindClick() {
        targetDiv.find('.btn-left').click(pageBtnClick.bind(this, -1));
        targetDiv.find('.btn-right').click(pageBtnClick.bind(this, 1));
        targetDiv.find('.date-selector-day:not(".disabled")').click(dateBtnClick);
    }

    function dateBtnClick(e) {
        var target = $(e.target);
        if (!target.data('item')) target = target.parent();

        var targetItem = parseInt(target.data('item'));

        if (flag.ajaxing || selectedItemCount == targetItem || disableDateClick) {
            return false;
        }
        flag.ajaxing = true;
        var dateString = target.data('date');
        selectedItemCount = targetItem;
        centerItemCount = targetItem;
        styleSelectedDay();
        animatePage();
        if (cfg.trigger) {
            cfg.trigger(dateString, flag);
        }
    }

    function pageBtnClick(next) {
        centerItemCount += next * itemPerPage;
        if (centerItemCount < 4) centerItemCount = 4;
        if (centerItemCount > maxItemCount) centerItemCount = maxItemCount;

        animatePage();
    }

    function animatePage() {
        var moveLeft = getLeft();
        dateListDiv.stop().animate({ left: moveLeft });
    }

    function directMovePage() {
        var moveLeft = getLeft();
        dateListDiv.stop().css({ 'left': moveLeft });
    }

    function getLeft() {
        var offset = 4;
        if (itemPerPage == 5) offset = 3;
        if (itemPerPage == 3) offset = 2;
        var position = centerItemCount - offset;
        var fullWidth = 100 / itemPerPage;
        var page = Math.floor(position / itemPerPage);
        var item = position % itemPerPage;
        var left = -(page * 100 + item * fullWidth) + '%';
        return left;
    }

    function styleSelectedDay() {
        var preSelected = dateListDiv.find('.selected');
        preSelected.removeClass('selected').css({
            'color': '#808080',
            'cursor': 'pointer'
        });
        var selected = dateListDiv.find('[data-item="' + selectedItemCount + '"]');
        selected.addClass('selected').css({
            'color': '#38b0e3',
            'cursor': 'initial'
        });
        if (currentWidth < 700) {
            preSelected.find('span').css({ 'display': 'none' });
            selected.find('span').css({ 'display': 'inline-block' });
        }
    }

    function getDay(date) {
        return typeof date == "string" ? new Date(date) : date;
    }

    function getDayString(date) {
        var dw = getDayWord(date);
        return dw.y + '/' + dw.m + '/' + dw.d;
    }

    function appendDayList() {
        var item = 4;
        for (var iteratorDay = new Date(dayStart.getTime()); iteratorDay <= dayEnd; iteratorDay.setDate(iteratorDay.getDate() + 1)) {
            maxItemCount = item;
            var dw = getDayWord(iteratorDay);
            var dateString = dw.y + '/' + dw.m + '/' + dw.d;
            if (dateString == selectedDayString) {
                selectedItemCount = item;
                centerItemCount = item;
            }
            var dayOfWeek = '<span class="p-left-2">(' + dayToWeekdayStringList[iteratorDay.getDay()] + ')</span>';
            dateListDiv.append('<div class="date-selector-day" data-date="' + dateString + '" data-item="' + item + '">' + dw.m + '/' + dw.d + dayOfWeek + '</div>');
            item++;
        }
    }
    function appendBtn() {
        targetDiv.append('<i class="material-icons btn-left page-btn">arrow_back_ios</i>');
        targetDiv.append('<i class="material-icons btn-right page-btn">arrow_forward_ios</i>');
    }

    function appendDisabledDay() {
        var iteratorStar = new Date(dayStart.getTime());
        var iteratorEnd = new Date(dayEnd.getTime());

        for (var i = 1; i < 4; i++) {
            iteratorStar.setDate(iteratorStar.getDate() - 1);
            iteratorEnd.setDate(iteratorEnd.getDate() + 1);

            var dw = getDayWord(iteratorStar);
            var dateString = dw.y + '/' + dw.m + '/' + dw.d;
            var dayOfWeek = '<span class="p-left-2">(' + dayToWeekdayStringList[iteratorStar.getDay()] + ')</span>';

            dateListDiv.prepend('<div class="date-selector-day disabled" data-item="' + (4 - i) + '" data-date="' + dateString + '">' + dw.m + '/' + dw.d + dayOfWeek + '</div>');

            dw = getDayWord(iteratorEnd);
            dateString = dw.y + '/' + dw.m + '/' + dw.d;
            dayOfWeek = '<span class="p-left-2">(' + dayToWeekdayStringList[iteratorEnd.getDay()] + ')</span>';

            dateListDiv.append('<div class="date-selector-day disabled" data-item="' + (maxItemCount + i) + '" data-date="' + dateString + '">' + dw.m + '/' + dw.d + dayOfWeek + '</div>');
        }
    }

    function getDayWord(date) {
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        var d = date.getDate();
        m < 10 && (m = '0' + m);
        d < 10 && (d = '0' + d);
        return { 'y': y, 'm': m, 'd': d };
    }

    function getEndDay() {
        var endDay = new Date(dayStart);
        cfg.type == 'm' && endDay.setMonth(endDay.getMonth() + cfg.count);
        cfg.type == 'd' && endDay.setDate(endDay.getDate() + cfg.count);
        return endDay;
    }

    function resizeFunction() {
        currentWidth = getOutsideWidth();
        checkWeekdayWord();
        checkItemPerPage();
        setItemLeft();
        directMovePage();
    }

    function checkWeekdayWord() {
        var display = currentWidth < 700 ? 'none' : 'inline-block';
        $('.date-selector-day:not(.selected) span').css({ 'display': display });
    };

    function checkItemPerPage() {
        var item = 7;
        if (currentWidth < 640) item = 5;
        if (currentWidth < 480) item = 3;
        itemPerPage = item;
    }

    function setItemLeft() {
        var fullWidth = 100 / itemPerPage;
        var halfWidth = fullWidth / 2;
        var dateListBoxDivWidth = parseInt(dateListBoxDiv.css('width'));
        dateListBoxDiv.find('.date-selector-day').each(function () {
            var divWidth = parseInt($(this).css('width')) * 50 / dateListBoxDivWidth;
            var position = $(this).data('item');
            var page = Math.floor(position / itemPerPage);
            var pageCount = position % itemPerPage;
            var left = (page * 100 + pageCount * fullWidth - halfWidth - divWidth) / 100 * dateListBoxDivWidth + 'px';
            $(this).css({ 'left': left });
        });
    }

    function getSelectedDayString(date) {
        if (!date) date = dayStart;
        var dw = getDayWord(getDay(date));
        return dw.y + '/' + dw.m + '/' + dw.d;
    }

    function setCSS() {
        targetDiv.css({
            'padding': '0px 35px',
            'position': 'relative'
        });

        targetDiv.find('.page-btn').css({
            'color': '#6ac4ea',
            'position': 'absolute',
            'font-size': '20px',
            'cursor': 'pointer',
            'top': '15px'
        });
        targetDiv.find('.page-btn.btn-left').css({
            'left': '15px'
        });
        targetDiv.find('.page-btn.btn-right').css({
            'right': '15px'
        });

        dateListBoxDiv.css({
            'overflow': 'hidden'
        });

        dateListDiv.css({
            'position': 'relative',
            'height': '50px',
            'width': '99999px'
        });

        dateListDiv.find('.date-selector-day').css({
            'position': 'absolute',
            'white-space': 'nowrap',
            'padding': '15px',
            'cursor': 'pointer',
            'text-align': 'center',
            'color': '#808080'
        });

        dateListDiv.find('.date-selector-day.disabled').css({
            'color': '#000',
            'cursor': 'initial',
            'opacity': '.1'
        });
    }
};

},{}],847:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.GetUrl = GetUrl;


function GetUrl(path) {
    var urlEnum = {
        'LOGIN': '/login',
        'WEBADMIN_SCHEDULE': '/webadmin/schedule'
    };
    return urlEnum[path];
}

},{}],848:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (data) {

    error(data);

    function error(data) {
        if (data.status == 422) {
            for (var p in data.responseJSON) {
                $.notify(data.responseJSON[p][0], {
                    position: "top center",
                    className: "error"
                });
                break;
            }
            return false;
        }
        swal({
            title: "操作失敗, 請再試一次",
            type: "error",
            showConfirmButton: true,
            closeOnConfirm: true,
            confirmButtonText: "確定"
        });
        setTimeout(function () {
            location.reload();
        }, 1000);
    }
};

},{}],849:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (_ref) {
    var url = _ref.url,
        params = _ref.params;

    var form = document.createElement("form");
    form.setAttribute("method", "post");
    form.setAttribute("action", url);
    for (var key in params) {
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
    }
    document.body.appendChild(form);
    form.submit();
};

},{}],850:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (_ref) {
    var image = _ref.image,
        inputId = _ref.inputId,
        width = _ref.width,
        height = _ref.height,
        cropBtnClass = _ref.cropBtnClass,
        reUploadBtnClass = _ref.reUploadBtnClass,
        showCropCircle = _ref.showCropCircle,
        callback = _ref.callback;

    var reader = new FileReader();
    appendCropModal(inputId, cropBtnClass, reUploadBtnClass, showCropCircle);
    reader.addEventListener("load", function () {
        return openCropModal(inputId, reader.result, width, height, callback);
    }, false);
    reader.readAsDataURL(image);
};

function appendCropModal(inputId, cropBtnClass, reUploadBtnClass, showCropCircle) {
    var modalId = inputId + '-modal',
        cropBoxCircle = showCropCircle ? 'crop-circle' : '';
    $('body').append('<div class="modal fade crop-modal" id="' + modalId + '" data-backdrop="static" data-keyboard="false" role="dialog">\n' + '      <div class="modal-dialog" role="document">\n' + '        <div class="modal-content">\n' + '          <div class="modal-header">\n' + '            <button type="button" class="close">\n' + '              <span aria-hidden="true">&times;</span>\n' + '            </button>\n' + '          </div>\n' + '          <div class="modal-body">\n' + '            <div class="img-container ' + cropBoxCircle + '">\n' + '              <img class="crop-image" src="" alt="upload">\n' + '            </div>\n' + '            <div class="cropping-functions m-top-20">\n' + '               <div class="btn-group">\n' + '                   <button class="btn btn-primary" type="button" data-method="zoom" data-option="0.1"><i class="fa fa-search-plus"></i></button>\n' + '                   <button class="btn btn-primary" type="button" data-method="zoom" data-option="-0.1"><i class="fa fa-search-minus"></i></button>\n' + '               </div>\n' + '               <div class="btn-group m-left-10">\n' + '                   <button class="btn btn-primary" type="button" data-method="rotate" data-option="-90"><i class="fa fa-rotate-left"></i></button>\n' + '                   <button class="btn btn-primary" type="button" data-method="rotate" data-option="90"><i class="fa fa-rotate-right"></i></button>\n' + '               </div>\n' + '            </div>\n' + '          </div>\n' + '          <div class="modal-footer">\n' + '            <button type="button" class="pull-left btn-reupload ' + reUploadBtnClass + '">' + i18n.t('general.reUpload') + '</button>\n' + '            <button type="button" class="btn-cropping ' + cropBtnClass + '" data-dismiss="modal">' + i18n.t('general.ok') + '</button>\n' + '          </div>\n' + '        </div>\n' + '      </div>\n' + '    </div>\n' + '  </div>');
}

function openCropModal(inputId, uploadSrc, width, height, callback) {
    var cropper,
        $input = $('#' + inputId),
        $modal = $('#' + inputId + '-modal'),
        $cropImage = $modal.find('.crop-image'),
        $btnCropping = $modal.find('.btn-cropping');
    $cropImage.attr('src', uploadSrc);
    $modal.on('shown.bs.modal', function () {
        cropper = new Cropper($cropImage[0], {
            toggleDragModeOnDblclick: false,
            aspectRatio: width / height,
            dragMode: 'move',
            viewMode: 1,
            minContainerWidth: 300,
            minContainerHeight: 300
        });
    }).on('hidden.bs.modal', function () {
        cropper.destroy();
        $modal.remove();
    });
    $modal.modal('show');

    //確定crop, callback base64
    $btnCropping.on('click', function () {
        var canvas;
        if (cropper) {
            canvas = cropper.getCroppedCanvas({
                width: width,
                height: height
            });
            callback(canvas.toDataURL());
        }
    });

    //crop功能鍵
    $('.cropping-functions').on('click', '[data-method]', function () {
        var method = $(this).data('method');
        var option = $(this).data('option');
        cropper[method](option);
    });

    //重新上傳圖片
    $('.btn-reupload').on('click', function () {
        $modal.modal('hide');
        $input.trigger('click');
    });

    //if close modal without edit, callback fail
    $modal.find('button.close').on('click', function () {
        $modal.modal('hide');
        callback('fail crop');
    });
}

},{}],851:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (_ref) {
    var image = _ref.image,
        width = _ref.width,
        height = _ref.height,
        callback = _ref.callback;

    var reader = new FileReader();
    reader.addEventListener("load", function () {
        return canvasCrop({ width: width, height: height, callback: callback, image: reader.result });
    }, false);
    reader.readAsDataURL(image);
};

function canvasCrop(_ref2) {
    var image = _ref2.image,
        width = _ref2.width,
        height = _ref2.height,
        callback = _ref2.callback;

    var canvas = document.createElement('canvas');
    canvas.height = height;
    canvas.width = width;
    var context = canvas.getContext('2d');
    var imageObj = new Image();
    imageObj.onload = function () {
        var _caculatePosition = caculatePosition({
            originalHeight: imageObj.height,
            originalWidth: imageObj.width,
            width: width,
            height: height
        }),
            sourceX = _caculatePosition.sourceX,
            sourceY = _caculatePosition.sourceY,
            sourceWidth = _caculatePosition.sourceWidth,
            sourceHeight = _caculatePosition.sourceHeight;

        context.drawImage(imageObj, sourceX, sourceY, sourceWidth, sourceHeight, 0, 0, width, height);
        callback(canvas.toDataURL('image/jpeg'));
    };
    imageObj.src = image;
}

function caculatePosition(_ref3) {
    var originalHeight = _ref3.originalHeight,
        originalWidth = _ref3.originalWidth,
        width = _ref3.width,
        height = _ref3.height;

    return originalHeight / originalWidth > height / width ? cutHeight({ originalHeight: originalHeight, originalWidth: originalWidth, width: width, height: height }) : cutWidth({ originalHeight: originalHeight, originalWidth: originalWidth, width: width, height: height });
}

function cutHeight(_ref4) {
    var originalHeight = _ref4.originalHeight,
        originalWidth = _ref4.originalWidth,
        width = _ref4.width,
        height = _ref4.height;

    var sourceHeight = originalWidth * height / width;
    var sourceWidth = originalWidth;
    var sourceX = 0;
    var sourceY = (originalHeight - sourceHeight) / 2;
    return { sourceX: sourceX, sourceY: sourceY, sourceWidth: sourceWidth, sourceHeight: sourceHeight };
}

function cutWidth(_ref5) {
    var originalHeight = _ref5.originalHeight,
        originalWidth = _ref5.originalWidth,
        width = _ref5.width,
        height = _ref5.height;

    var sourceHeight = originalHeight;
    var sourceWidth = originalHeight * width / height;
    var sourceX = (originalWidth - sourceWidth) / 2;
    var sourceY = 0;
    return { sourceX: sourceX, sourceY: sourceY, sourceWidth: sourceWidth, sourceHeight: sourceHeight };
}

},{}],852:[function(require,module,exports){
'use strict';

var _imageCropToString = require('./imageCropToString');

var _imageCropToString2 = _interopRequireDefault(_imageCropToString);

var _imageToString = require('./imageToString');

var _imageToString2 = _interopRequireDefault(_imageToString);

var _timeSpanBtn = require('./timeSpanBtn');

var _timeSpanBtn2 = _interopRequireDefault(_timeSpanBtn);

var _newCreditCardFrom = require('./newCreditCardFrom');

var _newCreditCardFrom2 = _interopRequireDefault(_newCreditCardFrom);

var _daySelector = require('./daySelector');

var _daySelector2 = _interopRequireDefault(_daySelector);

var _formPost = require('./formPost');

var _formPost2 = _interopRequireDefault(_formPost);

var _swal = require('./swal');

var _errorCallback = require('./errorCallback');

var _errorCallback2 = _interopRequireDefault(_errorCallback);

var _smallTools = require('./small-tools');

var _enum = require('./enum');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.$17 = {
    imageCropToString: _imageCropToString2.default,
    imageToString: _imageToString2.default,
    newCreditCardFrom: _newCreditCardFrom2.default,
    timeSpanBtn: _timeSpanBtn2.default,
    daySelector: _daySelector2.default,
    formPost: _formPost2.default,
    swal: _swal.swal,
    formatErrorAlert: _swal.formatErrorAlert,
    clone: _smallTools.clone,
    moneyFormat: _smallTools.moneyFormat,
    addDate: _smallTools.addDate,
    dateToString: _smallTools.dateToString,
    responseErrorMessage: _smallTools.responseErrorMessage,
    getChineseWeekday: _smallTools.getChineseWeekday,
    arrayObjectIndexOf: _smallTools.arrayObjectIndexOf,
    thousandthFormat: _smallTools.thousandthFormat,
    addDays: _smallTools.addDays,
    nl2br: _smallTools.nl2br,
    getUrlQueryStrings: _smallTools.getUrlQueryStrings,
    queryStringBuilder: _smallTools.queryStringBuilder,
    getTimePicker: _smallTools.getTimePicker,
    validURL: _smallTools.validURL,
    isValidColor: _smallTools.isValidColor,
    updateUrlQueryString: _smallTools.updateUrlQueryString,
    removeSelectedUrlPara: _smallTools.removeSelectedUrlPara,
    isMobile: _smallTools.isMobile,
    GetUrl: _enum.GetUrl,
    formateDisplayDate: _smallTools.formateDisplayDate,
    toggleWebadminTopTabsByQuery: _smallTools.toggleWebadminTopTabsByQuery,
    callbacks: {
        error: _errorCallback2.default
    }
};

$(function () {
    var token = $('meta[name="csrf_token"]').attr('content');
    $(document).ajaxSend(function (e, xhr, options) {
        xhr.setRequestHeader('X-CSRF-Token', token);
    });

    $(document).ajaxComplete(function (event, xhr, settings) {
        // console.log(xhr);
        if (xhr.status == '401') {
            location.reload();
        }
    });
});

},{"./daySelector":846,"./enum":847,"./errorCallback":848,"./formPost":849,"./imageCropToString":850,"./imageToString":851,"./newCreditCardFrom":853,"./small-tools":854,"./swal":855,"./timeSpanBtn":856}],853:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (cfg) {
    var target = $(cfg.el);
    var submitText = cfg.submitText ? cfg.submitText : i18n.t('general.submit');
    var canSkip = cfg.canSkip;
    var skipCallback = cfg.skipCallback ? cfg.skipCallback : function () {};
    var callback = cfg.callback ? cfg.callback : function () {};
    var description = cfg.description;
    var items = cfg.items ? cfg.items : [];

    setTarget();
    appendForm();
    bindEvent();

    function setTarget() {
        target.addClass('container-fluid');
    }

    function appendForm() {
        appendErrorAlert();
        appendDescription();
        appendItems();
        appendCardNum();
        appendMonthAndYear();
        appendAuthCode();
        appendSubmit();
    }

    function appendErrorAlert() {
        target.append('<div class="errorAlert"></div>');
    }

    function appendDescription() {
        if (!description) return;
        target.append('\
            <div style="border: 1px solid #bbb;border-left: 5px solid #bbb;padding: 20px">\
                ' + description + '\
            </div>\
        ');
    }

    function appendItems() {
        if (!items) return;
        for (var i = 0; i < items.length; i++) {
            target.append('\
                <hr>\
                    ' + '<h4>' + items[i].name + '<span class="pull-right">$' + items[i].price + '</span></h4>' + '\
                <hr>\
            ');
        }
    }

    function appendSubmit() {
        if (!canSkip) {
            return target.append('<button type="button" class="btn btn-primary btn-block submit" style="margin-top: 20px;">' + submitText + '</button>');
        }
        target.append('\
            <div class="row">\
                <div class="col-xs-12 col-sm-10">\
                    <button type="button" class="btn btn-primary btn-block submit" style="margin-top: 20px;">' + submitText + '</button>\
                </div>\
                <div class="col-xs-12 col-sm-2">\
                    <button type="button" class="skip-btn" style="background-color:#50bfd0;color:#fff;margin-top: 20px;width:100%;border:none;line-height:14px;font-size:14px;border-radius:5px;padding:8.75px;">略過 》</button>\
                </div>\
            </div>\
        ');
    }

    function appendAuthCode() {
        var authCodeRow = $('\
            <div class="row" style="padding-top:20px;">\
                <div class="col-xs-6">\
                    <input type="text" style="margin:0px;" maxlength="3" class="card_group_reset_string form-control authCode" placeholder="***">\
                </div>\
                <div class="col-xs-6">\
                    <label for="authCode" style="font-size:12px;line-height:34px;">\
                        ' + i18n.t('payment.card_cvv') + '\
                    </label>\
                </div>\
            </div>\
        ');
        target.append(authCodeRow);
    }

    function appendMonthAndYear() {
        var monthYearRow = $('<div class="row" style="padding-top:20px;"></div>');
        target.append(monthYearRow);
        var monthSelect = $('<select class="form-control month card_group_reset_select primary-business-color-input-border-hover primary-business-color-input-border-focus"><option value="" selected>' + i18n.t('payment.card_mm') + '</option></select>');
        ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'].forEach(function (item) {
            monthSelect.append('<option value="' + item + '">' + item + '</option>');
        });
        monthYearRow.append($('<div class="col-xs-6"></div>').append(monthSelect));

        var yearSelect = $('<select class="form-control year card_group_reset_select  primary-business-color-input-border-hover primary-business-color-input-border-focus"><option value="" selected>' + i18n.t('payment.card_yy') + '</option></select>');
        for (var i = 0, start = new Date().getFullYear(); i < 20; i++) {
            var year = start + i;
            yearSelect.append('<option value="' + year + '">' + year + '</option>');
        }
        monthYearRow.append($('<div class="col-xs-6"></div>').append(yearSelect));
    }

    function appendCardNum() {
        target.append('\
            <div class="row" style="padding-top:20px;">\
                <label for="card_1" class="col-xs-12 control-label" style="font-size:12px;text-align:inherit;font-weight:inherit;">\
                    ' + i18n.t('payment.card_number') + '\
                </label>\
            </div> \
        ');
        var cardRow = $('<div class="row" style="padding:0px 15px;white-space: nowrap;"></div>');
        target.append(cardRow);
        [1, 2, 3, 4].forEach(function (count) {
            cardRow.append('\
                <div style="width:25%;display:inline-block;padding-left:1%;padding-right:1%;vertical-align: top;">\
                    <input type="text" maxlength="4" style="margin:0px;"\
                             class="card_group_reset_string form-control card_' + count + '"\
                    ></input>\
                </div>\
            ');
        });
    }

    function bindEvent() {
        [1, 2, 3, 4].forEach(function (count) {
            var current = target.find('.card_' + count);
            current.keyup(lengthCheck.bind(null, 'card_' + count, 4));
            current.blur(blurCheck.bind(null, 'card_' + count, 4));
        });

        ['month', 'year'].forEach(function (item) {
            target.find('.' + item).change(focusNextCheck.bind(null, item));
            target.find('.' + item).blur(errorCheck.bind(null, item));
        });

        target.find('.authCode').keyup(lengthCheck.bind(null, 'authCode', 3));
        target.find('.authCode').blur(blurCheck.bind(null, 'authCode', 3));

        target.find('.submit').click(submitForm);
        target.find('.skip-btn').click(skipForm);
    }

    function skipForm() {
        skipCallback();
    }

    function submitForm() {
        target.find('.error-msg').remove();
        [1, 2, 3, 4].forEach(function (count) {
            lengthCheck('card_' + count, 4);
            blurCheck('card_' + count, 4);
        });

        ['month', 'year'].forEach(function (item) {
            focusNextCheck(item);
            errorCheck(item);
        });

        lengthCheck('authCode', 3);
        blurCheck('authCode', 3);

        if (target.find('.error-msg').length > 0) return false;

        target.find('.submit').html('傳送中...').prop('disabled', true);

        var card = '';

        [1, 2, 3, 4].forEach(function (count) {
            card += getVal('card_' + count);
        });

        callback({
            card: {
                card: card,
                authCode: getVal('authCode'),
                month: getVal('month'),
                year: getVal('year')
            },
            fails: fails
        });
    }
    function fails(errorMsg) {
        if (errorMsg) {
            target.find('.errorAlert').html('\
                <div class="alert alert-danger alert-dismissible fade in" role="alert">\
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close">\
                        <span aria-hidden="true">×</span>\
                    </button>\
                    <strong>' + errorMsg + '</strong>\
                </div>\
            ');
        }
        target.find('.submit').html(submitText).prop('disabled', false);
    }

    function getVal(item) {
        return target.find('.' + item).val().trim();
    }

    function lengthCheck(item, length, e) {
        var current = target.find('.' + item);
        current.parent().find('.error-msg').remove();
        var currentString = removeNonNumeric(current.val());
        current.val(currentString);
        if (e) {
            if (focusBack()) return;
            if (focusNextCheck()) return;
        }
        function focusBack() {
            if (currentString || item.indexOf('card_') < 0 || [8, 46].indexOf(e.keyCode) < 0) return false;
            focusPre(item);
            return true;
        }
        function focusNextCheck() {
            if (currentString.length < length) return false;
            focusNext(item);
            return true;
        }
    }

    function blurCheck(item, length) {
        var current = target.find('.' + item);
        current.parent().find('.error-msg').remove();
        var currentString = current.val();
        if (empty()) return;
        if (tooShort()) return;

        function empty() {
            if (currentString) return false;
            emptyError(item);
            return true;
        }
        function tooShort() {
            if (currentString.length == length) return false;
            current.parent().append(errorSpan('該項需填' + length + '碼數字！'));
            return true;
        }
    }

    function focusNextCheck(key) {
        !!target.find('.' + key).val() && focusNext(key);
    }

    function errorCheck(key) {
        $('.' + key).parent().find('.error-msg').remove();
        !target.find('.' + key).val() && emptyError(key);
    }

    function emptyError(key) {
        $('.' + key).parent().find('.error-msg').remove();
        $('.' + key).parent().append(errorSpan('該項為必填！'));
    }

    function focusNext(key) {
        var sort = ['card_1', 'card_2', 'card_3', 'card_4', 'month', 'year', 'authCode'];
        var next = sort[sort.indexOf(key) + 1];
        if (['card_1', 'card_2', 'card_3', 'card_4', 'authCode'].indexOf(next) > -1) {
            return target.find('.' + next).select();
        }
        target.find('.' + next).focus();
    }

    function focusPre(key) {
        var sort = ['card_1', 'card_2', 'card_3', 'card_4'];
        var pre = sort.indexOf(key) - 1;
        if (pre < 0) return false;
        target.find('.' + sort[pre]).focus();
    }

    function removeNonNumeric(string) {
        return string.replace(/\D/g, '');
    }

    function errorSpan(string) {
        return $('<span class="error-msg" style="color: #d9534f;font-size: .8em;">' + string + '</span>');
    }

    return function resetForm() {
        $('.error-msg').remove();
        $('.errorAlert').html('');
        $('.card_group_reset_string').val('');
        $('.card_group_reset_select').val(-1);
    };
};

},{}],854:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toggleWebadminTopTabsByQuery = exports.formateDisplayDate = exports.isMobile = exports.removeSelectedUrlPara = exports.updateUrlQueryString = exports.isValidColor = exports.validURL = exports.getTimePicker = exports.queryStringBuilder = exports.getUrlQueryStrings = exports.nl2br = exports.addDays = exports.thousandthFormat = exports.arrayObjectIndexOf = exports.getChineseWeekday = exports.responseErrorMessage = exports.dateToString = exports.addDate = exports.moneyFormat = exports.clone = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.clone = clone;
exports.moneyFormat = moneyFormat;
exports.addDate = addDate;
exports.dateToString = dateToString;
exports.responseErrorMessage = responseErrorMessage;
exports.getChineseWeekday = getChineseWeekday;
exports.arrayObjectIndexOf = arrayObjectIndexOf;
exports.thousandthFormat = thousandthFormat;
exports.addDays = addDays;
exports.nl2br = nl2br;
exports.getUrlQueryStrings = getUrlQueryStrings;
exports.queryStringBuilder = queryStringBuilder;
exports.getTimePicker = getTimePicker;
exports.validURL = validURL;
exports.isValidColor = isValidColor;
exports.updateUrlQueryString = updateUrlQueryString;
exports.removeSelectedUrlPara = removeSelectedUrlPara;
exports.isMobile = isMobile;
exports.formateDisplayDate = formateDisplayDate;
exports.toggleWebadminTopTabsByQuery = toggleWebadminTopTabsByQuery;


function clone(obj) {
    return JSON.parse((0, _stringify2.default)(obj));
}

function moneyFormat(money) {
    return (money < 0 ? '-' : '') + '$' + Math.abs(money).toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
}

function thousandthFormat(money) {
    return '' + (money < 0 ? '-' : '') + Math.abs(money).toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
}

function addDate(date, day) {
    var newDate = new Date(date);
    newDate.setDate(date.getDate() + day);
    return newDate;
}

function dateToString(date) {
    var mm = date.getMonth() + 1;
    var dd = date.getDate();
    if (mm < 10) mm = '0' + mm;
    if (dd < 10) dd = '0' + dd;
    return date.getFullYear() + '/' + mm + '/' + dd;
}

function responseErrorMessage(response) {
    if (response.data && response.data.message) {
        $17.swal({
            type: 'warning',
            showCancelButton: false,
            text: response.data.message
        });
    }
}

function getChineseWeekday(weekDay) {
    switch (weekDay) {
        case 1:
            return '一';
            break;
        case 2:
            return '二';
            break;
        case 3:
            return '三';
            break;
        case 4:
            return '四';
            break;
        case 5:
            return '五';
            break;
        case 6:
            return '六';
            break;
        default:
            return '日';
            break;
    }
}

function formateDisplayDate(date) {
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD';
    var isShowWeekDay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var weekDayStr = '';
    var dateFormat = moment(date).format(format);
    if (isShowWeekDay) {
        var weekDay = moment(date).weekday();
        switch (weekDay) {
            case 1:
                weekDayStr = i18n.t('general.monday');
                break;
            case 2:
                weekDayStr = i18n.t('general.tuesday');
                break;
            case 3:
                weekDayStr = i18n.t('general.wednesday');
                break;
            case 4:
                weekDayStr = i18n.t('general.thursday');
                break;
            case 5:
                weekDayStr = i18n.t('general.friday');
                break;
            case 6:
                weekDayStr = i18n.t('general.saturday');
                break;
            case 0:
                weekDayStr = i18n.t('general.sunday');
                break;
        }
        return dateFormat + ' (' + weekDayStr + ')';
    }
    return dateFormat;
}

function arrayObjectIndexOf(arr, searchTerm, property) {
    for (var i = 0; i < arr.length; i++) {
        if (arr[i][property] === searchTerm) return i;
    }
    return -1;
}

function addDays(date, days) {
    var thisDate = new Date();
    thisDate.setDate(thisDate.getDate() + days);
    return thisDate;
}

function nl2br(str) {
    return str.replace(/([^>])\n/g, '$1<br/>\n');
}

function getUrlQueryStrings(url) {
    // get query string from url (optional) or window
    var queryString = url ? url.split('?')[1] : window.location.search.slice(1);
    queryString = decodeURIComponent(queryString);

    // we'll store the parameters here
    var obj = {};

    // if query string exists
    if (queryString) {

        // stuff after # is not part of query string, so get rid of it
        queryString = queryString.split('#')[0];

        // split our query string into its component parts
        var arr = queryString.split('&');

        for (var i = 0; i < arr.length; i++) {
            // separate the keys and the values
            var a = arr[i].split('=');

            // in case params look like: list[]=thing1&list[]=thing2
            var paramNum = undefined;
            var paramName = a[0].replace(/\[\d*\]/, function (v) {
                paramNum = v.slice(1, -1);
                return '';
            });

            // set parameter value (use 'true' if empty)
            var paramValue = typeof a[1] === 'undefined' ? true : a[1];

            // (optional) keep case consistent
            paramName = paramName.toLowerCase();
            paramValue = paramValue.toLowerCase();

            // if parameter name already exists
            if (obj[paramName]) {
                // convert value to array (if still string)
                if (typeof obj[paramName] === 'string') {
                    obj[paramName] = [obj[paramName]];
                }
                // if no array index number specified...
                if (typeof paramNum === 'undefined') {
                    // put the value on the end of the array
                    obj[paramName].push(paramValue);
                }
                // if array index number specified...
                else {
                        // put the value at that index number
                        obj[paramName][paramNum] = paramValue;
                    }
            }
            // if param name doesn't exist yet, set it
            else {
                    obj[paramName] = paramValue;
                }
        }
    }
    return obj;
}

function queryStringBuilder(objParams) {
    var esc = encodeURIComponent;
    var query = (0, _keys2.default)(objParams).map(function (k) {
        return esc(k) + '=' + esc(objParams[k]);
    }).join('&');
    return query;
}

function updateUrlQueryString(objParams) {
    var isReplaced = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var currentQuery = getUrlQueryStrings();
    var data = {};
    if (isReplaced) {
        data = objParams;
    } else {
        data = (0, _extends3.default)({}, currentQuery, objParams);
    }
    var newQuery = queryStringBuilder(data);
    history.replaceState({}, null, '?' + newQuery);
    return newQuery;
}

function getTimePicker(step) {
    var timeObj = { '00:00': '00:00' };
    for (var hr = 0; hr <= 23; hr++) {
        var max_min = 60;
        for (var min = 0; min < max_min; min += step) {
            if (hr === 0 && min === 0) {} else {
                var showHr = hr.toString().padStart(2, '0');
                var showMin = min.toString().padStart(2, '0');
                var time = showHr + ':' + showMin;
                timeObj[time] = time;
            }
        }
    }
    return timeObj;
}

function validURL(str) {
    var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
    '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
    if (!!!pattern.test(str)) {
        $17.swal({
            title: '請檢查網址',
            text: "",
            type: 'error',
            showCancelButton: false
        });
        return false;
    }
    return true;
}

function isValidColor(str) {
    return str.match(/(^#[0-9A-Fa-f]{6}$)|(^#[0-9A-Fa-f]{3}$)/i) !== null;
}

function removeSelectedUrlPara(name) {
    var url = new URL(document.URL);
    var params = new URLSearchParams(url.search);
    params.delete(name);
    url.search = params;
    window.history.replaceState(null, null, url);
}

function isMobile() {
    var check = false;

    if (navigator.userAgentData) {
        check = navigator.userAgentData.mobile;
    }

    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        check = true;
    }

    return check;
}

function toggleWebadminTopTabsByQuery() {
    var query = getUrlQueryStrings();
    var isHide = query.tab_hidden || false;
    if (isHide == 'true') {
        $('.tabs.nav.top-tabs').hide();
    } else {
        $('.tabs.nav.top-tabs').show();
    }
}

},{"babel-runtime/core-js/json/stringify":48,"babel-runtime/core-js/object/keys":56,"babel-runtime/helpers/extends":66}],855:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
function swal(_ref) {
    var _ref$text = _ref.text,
        text = _ref$text === undefined ? '' : _ref$text,
        _ref$title = _ref.title,
        title = _ref$title === undefined ? '' : _ref$title,
        _ref$html = _ref.html,
        html = _ref$html === undefined ? '' : _ref$html,
        _ref$type = _ref.type,
        type = _ref$type === undefined ? null : _ref$type,
        _ref$confirmButtonCol = _ref.confirmButtonColor,
        confirmButtonColor = _ref$confirmButtonCol === undefined ? null : _ref$confirmButtonCol,
        _ref$cancelButtonColo = _ref.cancelButtonColor,
        cancelButtonColor = _ref$cancelButtonColo === undefined ? '#bbb' : _ref$cancelButtonColo,
        _ref$showCloseButton = _ref.showCloseButton,
        showCloseButton = _ref$showCloseButton === undefined ? true : _ref$showCloseButton,
        _ref$showCancelButton = _ref.showCancelButton,
        showCancelButton = _ref$showCancelButton === undefined ? true : _ref$showCancelButton,
        _ref$showConfirmButto = _ref.showConfirmButton,
        showConfirmButton = _ref$showConfirmButto === undefined ? true : _ref$showConfirmButto,
        _ref$confirmButtonTex = _ref.confirmButtonText,
        confirmButtonText = _ref$confirmButtonTex === undefined ? i18n.t('general.ok') : _ref$confirmButtonTex,
        _ref$cancelButtonText = _ref.cancelButtonText,
        cancelButtonText = _ref$cancelButtonText === undefined ? i18n.t('general.cancel') : _ref$cancelButtonText;
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

    text = '' + text;
    confirmButtonColor = confirmButtonColor || (type == 'warning' ? "#DD6B55" : '#38b0e3');
    showCloseButton = showCloseButton ? closeButton() : '';
    window.swal({ confirmButtonColor: confirmButtonColor, cancelButtonColor: cancelButtonColor, showCancelButton: showCancelButton, confirmButtonText: confirmButtonText, cancelButtonText: cancelButtonText, text: text, title: title, html: html, type: type, showConfirmButton: showConfirmButton, showCloseButton: showCloseButton }, callback);
}

function formatErrorAlert(text, callback) {
    swal({
        text: text,
        title: '您輸入的格式有錯誤',
        type: 'warning',
        showCancelButton: false
    }, callback);
}

function closeButton() {
    if (!document.querySelector('.sweet-close')) {
        var _closeButton = document.createElement('button');
        _closeButton.className = 'sweet-close';
        _closeButton.onclick = function () {
            swal.close();
        };
        _closeButton.textContent = '×';
        var modal = document.querySelector('.sweet-alert');
        modal.appendChild(_closeButton);
    }
}

exports.swal = swal;
exports.formatErrorAlert = formatErrorAlert;

},{}],856:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (_ref) {
    var el = _ref.el,
        minDate = _ref.minDate,
        maxDate = _ref.maxDate,
        startCallback = _ref.startCallback,
        endCallback = _ref.endCallback;

    el = $(el);
    prepareBody();
    var startDayField = el.find('.start_day_field');
    var endDayField = el.find('.end_day_field');
    setFormat();
    bindEvent();

    function prepareBody() {
        el.css({ 'display': 'flex' });
        el.html('\n            <div style="flex:1;position:relative;"><input type="text" class="start_day_field form-control" placeholder="\u958B\u59CB\u65E5\u671F"></div>\n            <div style="max-width:20px;"></div>\n            <div style="flex:1;position:relative;"><input type="text" class="end_day_field form-control" placeholder="\u7D50\u675F\u65E5\u671F"></div>\n        ');
    }
    function setFormat() {
        [startDayField, endDayField].forEach(function (item) {
            var cfg = { format: 'YYYY/MM/DD' };
            if (minDate) cfg.minDate = minDate;
            if (maxDate) cfg.maxDate = maxDate;
            item.datetimepicker(cfg);
        });
    }
    function bindEvent() {
        startDayField.on('dp.change', function (_ref2) {
            var date = _ref2.date,
                oldDate = _ref2.oldDate;

            if (startCallback) startCallback(dateToString(new Date(date)));
            if (Date.parse(endDayField.val()) < date) {
                endDayField.val(dateToString(new Date(date)));
            }
        });
        endDayField.on('dp.change', function (_ref3) {
            var date = _ref3.date,
                oldDate = _ref3.oldDate;

            if (endCallback) endCallback(dateToString(new Date(date)));
            if (date < Date.parse(startDayField.val())) {
                startDayField.val(dateToString(new Date(date)));
            }
        });
    }
    function dateToString(date) {
        var mm = date.getMonth() + 1;
        var dd = date.getDate();
        if (mm < 10) mm = '0' + mm;
        if (dd < 10) dd = '0' + dd;
        return date.getFullYear() + '/' + mm + '/' + dd;
    }
};

},{}],857:[function(require,module,exports){
'use strict';

require('./vue');
require('./$17');

},{"./$17":852,"./vue":1587}],858:[function(require,module,exports){
'use strict';

require('./old-page/webadmin');
require('./old-utilities');
require('./third-party');
require('./utilities');
require('./pages');

},{"./old-page/webadmin":860,"./old-utilities":864,"./pages":999,"./third-party":1474,"./utilities":1495}],859:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['studio_id', 'saveClicked'],
    data: function data() {
        return {
            id: null,
            url: {
                create: webadmin_base_url + '/custom_fields/creating',
                update: webadmin_base_url + '/custom_fields/update/',
                delete: webadmin_base_url + '/custom_fields/delete/'
            },
            types: [{ text: '單行輸入', value: 1 }, { text: '多行輸入', value: 2 }, { text: '單選', value: 3 }, { text: '複選', value: 4 }, { text: '日期', value: 5 }],
            showTypes: true,
            typeTxt: '',
            is_ref: false,
            type: 1,
            name: '',
            order_num: 1,
            is_unique: 0,
            items: [],
            ajaxing: false
        };
    },
    created: function created() {
        var _this = this;

        this.$nextTick(function () {
            $(_this.$el).on('hide.bs.modal', function () {
                _this.resetForm();
            });
        });
        window.Event.$on('create', function (data) {
            _this.id = null;
            _this.eventShowCreateModal();
        }).$on('update', function (data) {
            _this.id = data.id;
            _this.eventShowEditModal();
        });
    },

    computed: {
        showAddNewItemBtn: function showAddNewItemBtn() {
            return this.type == 3 || this.type == 4;
        },
        showUniqueOption: function showUniqueOption() {
            return this.type == 1;
        },
        isCreatedMode: function isCreatedMode() {
            return this.id == null;
        },
        showRemoveBtn: function showRemoveBtn() {
            return this.id != null;
        }
    },
    methods: {
        store: function store() {
            if (this.isCreatedMode) this.create();else this.update();
        },
        getData: function getData() {
            var _this2 = this;

            var formData = this.getFormData();
            this.$http.get(this.url.update + this.id, formData).then(function (response) {
                _this2.ajaxing = true;
                _this2.name = response.body.name;
                _this2.type = response.body.type;
                _this2.is_unique = response.body.is_unique;
                _this2.typeTxt = _this2.types[$17.arrayObjectIndexOf(_this2.types, response.body.type, 'value')].text;
                _this2.is_ref = response.body.ref_field !== '' ? true : false;
                _this2.order_num = response.body.order_num - 7;
                _this2.items = response.body.items.map(function (obj, i) {
                    return _this2.toItemObj('item[' + obj.id + ']', obj.name);
                });
                _this2.showModal();
            }).catch($17.responseErrorMessage);
        },
        create: function create() {
            var _this3 = this;

            this.ajaxing = false;
            var formData = this.getFormData();
            formData.push({ name: 'studio_id', value: this.studio_id });
            this.$http.post(this.url.create, formData).then(function (response) {
                _this3.successResponse();
            }).catch($17.responseErrorMessage);
        },
        update: function update() {
            var _this4 = this;

            this.ajaxing = false;
            var formData = this.getFormData();
            formData.push({ name: 'name', value: this.name });
            this.$http.put(this.url.update + this.id, formData).then(function (response) {
                _this4.successResponse();
            }).catch($17.responseErrorMessage);
        },
        addItem: function addItem(name, value) {
            this.items.push(this.toItemObj(name, value));
        },
        toItemObj: function toItemObj(n, v) {
            return { name: n, value: v };
        },
        remove: function remove(e) {
            var _this5 = this;

            $17.swal({
                title: '確認刪除?',
                text: "資料將消失, 這項操作無法返回！",
                type: 'warning'
            }, function () {
                _this5.$http.get(_this5.url.delete + _this5.id).then(function (response) {
                    _this5.successResponse();
                    _this5.hideModal();
                }).catch($17.responseErrorMessage);
            });
        },
        successResponse: function successResponse() {
            this.hideModal();
            this.saveClicked();
        },
        removeItem: function removeItem(index) {
            this.items.splice(index, 1);
        },
        toggleModal: function toggleModal(o) {
            $(this.$el).modal(o);
        },
        showModal: function showModal() {
            this.toggleModal('show');
        },
        hideModal: function hideModal() {
            this.toggleModal('hide');
        },
        resetForm: function resetForm() {
            this.id = null;
            this.name = '';
            this.typeTxt = '';
            this.type = 1;
            this.is_unique = 0;
            this.items = [];
            this.order_num = 1;
        },
        getFormData: function getFormData() {
            return $(this.$el).find('form').serializeArray();
        },
        eventShowCreateModal: function eventShowCreateModal() {
            this.showTypes = true;
            this.showModal();
        },
        eventShowEditModal: function eventShowEditModal() {
            this.showTypes = false;
            this.getData();
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal :save-clicked=\"store\" :remove-clicked=\"remove\" :remove-btn-show=\"showRemoveBtn&amp;&amp;!is_ref\">\n    <span slot=\"title\">自訂欄位</span>\n    <template slot=\"body\">\n        <form class=\"form-horizontal\" @submit.prevent=\"store\">\n            <div class=\"form-group\" v-show=\"!is_ref\">\n                <label class=\"col-sm-2\">匯入ＩＤ</label>\n                <div class=\"col-sm-5\">\n                    <label>{{ id }}</label>\n                </div>\n            </div>\n            <div class=\"form-group\">\n                <label for=\"name\" class=\"col-sm-2\">欄位名稱</label>\n                <div class=\"col-sm-5\">\n                  <input type=\"text\" id=\"name\" name=\"name\" v-model=\"name\" class=\"form-control\" placeholder=\"欄位名稱\" :disabled=\"is_ref\">\n                </div>\n            </div>\n            <div class=\"form-group\" v-show=\"!is_ref\">\n                <label for=\"type\" class=\"col-sm-2\">類型</label>\n                <div class=\"col-sm-5\" v-show=\"showTypes\">\n                    <select id=\"type\" name=\"type\" class=\"form-control\" v-model=\"type\">\n                        <option v-for=\"t in types\" v-bind:value=\"t.value\">\n                            {{ t.text }}\n                        </option>\n                    </select>\n                </div>\n                <label for=\"type\" class=\"col-sm-5\" v-if=\"showTypes == false\">{{ typeTxt }}</label>\n            </div>\n            <div class=\"form-group\">\n                <label for=\"name\" class=\"col-sm-2\">排序</label>\n                <div class=\"col-sm-5\">\n                    <input type=\"text\" id=\"order_num\" name=\"order_num\" v-model=\"order_num\" class=\"form-control\" placeholder=\"排序\">\n                </div>\n            </div>\n            <div v-show=\"showAddNewItemBtn\">\n                <div class=\"form-group\" v-for=\"(it, index) in items\">\n                    <label class=\"col-sm-2 hidden-xs\"></label>\n                    <div class=\"col-sm-5 col-xs-9\">\n                        <input type=\"text\" class=\"form-control\" v-bind:name=\"it.name\" v-model=\"it.value\" placeholder=\"請輸入選項內容\">\n                    </div>\n                    <div class=\"col-sm-2 col-xs-2\">\n                        <button type=\"button\" @click.prevent=\"removeItem(index)\" class=\"btn btn-danger\">\n                            <span class=\"glyphicon glyphicon-remove\" aria-hidden=\"true\"></span>\n                        </button>\n                    </div>\n                </div>\n            </div>\n            <div class=\"form-group\" v-if=\"showUniqueOption &amp;&amp; !is_ref\">\n                <label class=\"col-sm-2\"></label>\n                <div class=\"col-sm-5\">\n                    <input id=\"is_unique\" name=\"is_unique\" type=\"checkbox\" value=\"1\" v-model=\"is_unique\">\n                    <label for=\"is_unique\">不允許重複</label>\n                    <a href=\"javascript:void(0)\"><i class=\"fa fa-question-circle\" help=\"這項設定可以防止相同客戶被重複註冊\"></i></a>\n                </div>\n            </div>\n            <div class=\"form-group\" v-show=\"showAddNewItemBtn &amp;&amp; !is_ref\">\n                <label class=\"col-sm-2\"></label>\n                <div class=\"col-sm-5\">\n                    <p v-show=\"ajaxing\"><a href=\"javascript:void(0)\" @click.prevent=\"addItem('new_item[]', '')\">+ 新增選項</a></p>\n                </div>\n            </div>\n        </form>\n    </template>\n</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-32e310f9", module.exports)
  } else {
    hotAPI.update("_v-32e310f9", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],860:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _payment_list = require('./studio_payment_method/payment_list.vue');

var _payment_list2 = _interopRequireDefault(_payment_list);

var _order_list = require('./studio_plan/order_list.vue');

var _order_list2 = _interopRequireDefault(_order_list);

var _point_record_list = require('./studio/point_record_list.vue');

var _point_record_list2 = _interopRequireDefault(_point_record_list);

var _formModal = require('./custom_field/form-modal.vue');

var _formModal2 = _interopRequireDefault(_formModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('payment-list', _payment_list2.default);
// Vue.component('order-list', OrderList);

// import OrderList from './pos/order_list.vue';
_vue2.default.component('studio-plan-order-list', _order_list2.default);
_vue2.default.component('studio-point-record-list', _point_record_list2.default);
_vue2.default.component('custom-field-form-modal', _formModal2.default);

},{"./custom_field/form-modal.vue":859,"./studio/point_record_list.vue":861,"./studio_payment_method/payment_list.vue":862,"./studio_plan/order_list.vue":863,"vue":792}],861:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
        value: true
});
exports.default = {
        props: ['records']
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<table class=\"table\">\n    <thead>\n        <tr>\n            <th>日期</th>\n            <th>點數</th>\n            <th>備註</th>\n        </tr>\n    </thead>\n    <tbody>\n        <tr v-bind:class=\"r.value > 0 ? {}: {'text-danger': true}\" v-for=\"r in records\">\n            <td>{{ r.created_at }}</td>\n            <td>{{ r.value }}</td>\n            <td>{{ r.note }}</td>\n        </tr>\n    </tbody>\n</table>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-2e7e957c", module.exports)
  } else {
    hotAPI.update("_v-2e7e957c", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],862:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.row[_v-1f5ee1a1]::after {\n  content: '';\n  height: 1px;\n  color: #ccc; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['payment_methods'],
    methods: {}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"payment-list\" _v-1f5ee1a1=\"\">\n    <div class=\"row\" _v-1f5ee1a1=\"\">\n        <div class=\"col-xs-6\" _v-1f5ee1a1=\"\">\n            <input type=\"radio\" name=\"method\" value=\"0\" _v-1f5ee1a1=\"\">現場\n            <input type=\"radio\" name=\"method\" value=\"1\" _v-1f5ee1a1=\"\">線上\n        </div>\n        <div class=\"col-xs-6\" _v-1f5ee1a1=\"\"></div>\n    </div>\n    <div v-for=\"payment_method in payment_methods\" _v-1f5ee1a1=\"\">\n        <div class=\"row\" _v-1f5ee1a1=\"\">\n            <div class=\"col-xs-6\" _v-1f5ee1a1=\"\">{{payment_method.name}}</div>\n            <div class=\"col-xs-6\" _v-1f5ee1a1=\"\">{{payment_method.is_active}}</div>\n        </div>\n    </div>\n\n    <row _v-1f5ee1a1=\"\">\n        <div class=\"col-xs-12\" _v-1f5ee1a1=\"\">\n            <div class=\"btn btn-primary\" _v-1f5ee1a1=\"\">新增</div>\n        </div>\n    </row>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.row[_v-1f5ee1a1]::after {\n  content: '';\n  height: 1px;\n  color: #ccc; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-1f5ee1a1", module.exports)
  } else {
    hotAPI.update("_v-1f5ee1a1", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],863:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.order-history > tbody > tr > td[_v-39206c4a] {\n  vertical-align: initial; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['order_histories'],
    methods: {
        byItemAmount: function byItemAmount(details) {
            $result = '';
            for (var i = 0; i < details.length; i++) {
                if (details[i].num > 0) $result += details[i].name + ' x ' + details[i].num + '<br>';else $result += details[i].name + '<br>';
            }
            return $result;
        },
        byItemPrice: function byItemPrice(details) {
            $result = '';
            for (var i = 0; i < details.length; i++) {
                if (details[i].price >= 0) $result += '$' + details[i].price + '<br>';else $result += '-$' + -details[i].price + '<br>';
            }
            return $result;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<table class=\"order-history table\" _v-39206c4a=\"\">\n    <thead _v-39206c4a=\"\">\n        <tr _v-39206c4a=\"\">\n            <th _v-39206c4a=\"\">日期</th>\n            <th _v-39206c4a=\"\">支付方式</th>\n            <th _v-39206c4a=\"\">備註</th>\n            <th _v-39206c4a=\"\">金額</th>\n        </tr>\n    </thead>\n    <tbody _v-39206c4a=\"\">\n        <tr v-for=\"oh in order_histories\" _v-39206c4a=\"\">\n            <td _v-39206c4a=\"\">{{ oh.buy_date }}</td>\n            <td _v-39206c4a=\"\">{{ oh.payment_method }}</td>\n            <td v-html=\"byItemAmount(oh.details)\" _v-39206c4a=\"\"></td>\n            <td v-html=\"byItemPrice(oh.details)\" _v-39206c4a=\"\"></td>\n        </tr>\n    </tbody>\n</table>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.order-history > tbody > tr > td[_v-39206c4a] {\n  vertical-align: initial; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-39206c4a", module.exports)
  } else {
    hotAPI.update("_v-39206c4a", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],864:[function(require,module,exports){
'use strict';

require('./webadmin');

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _vModal = require('./v-modal.vue');

var _vModal2 = _interopRequireDefault(_vModal);

var _vAjaxIng = require('./v-ajax-ing.vue');

var _vAjaxIng2 = _interopRequireDefault(_vAjaxIng);

var _vNewCardForm = require('./v-new-card-form.vue');

var _vNewCardForm2 = _interopRequireDefault(_vNewCardForm);

var _vMainAccountModal = require('./v-main-account-modal.vue');

var _vMainAccountModal2 = _interopRequireDefault(_vMainAccountModal);

var _vSwitch = require('./v-switch.vue');

var _vSwitch2 = _interopRequireDefault(_vSwitch);

var _vDashboardTabs = require('./v-dashboard-tabs.vue');

var _vDashboardTabs2 = _interopRequireDefault(_vDashboardTabs);

var _vGridList = require('./v-grid-list.vue');

var _vGridList2 = _interopRequireDefault(_vGridList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('v-modal', _vModal2.default);
_vue2.default.component('v-ajax-ing', _vAjaxIng2.default);
_vue2.default.component('v-new-card-form', _vNewCardForm2.default);
_vue2.default.component('v-main-account-modal', _vMainAccountModal2.default);
_vue2.default.component('v-switch', _vSwitch2.default);
_vue2.default.component('v-dashboard-tabs', _vDashboardTabs2.default);
_vue2.default.component('v-grid-list', _vGridList2.default);

},{"./v-ajax-ing.vue":865,"./v-dashboard-tabs.vue":866,"./v-grid-list.vue":867,"./v-main-account-modal.vue":868,"./v-modal.vue":869,"./v-new-card-form.vue":870,"./v-switch.vue":871,"./webadmin":872,"vue":792}],865:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.box[_v-143b705b] {\n  padding: 30px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center; }\n")
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "<!-- TODO REMOVE: old component 由v-spinner取代-->\n   <div class=\"box\" _v-143b705b=\"\">\n       <div class=\"spinner\" _v-143b705b=\"\">\n         <div class=\"rect1\" _v-143b705b=\"\"></div>\n         <div class=\"rect2\" _v-143b705b=\"\"></div>\n         <div class=\"rect3\" _v-143b705b=\"\"></div>\n         <div class=\"rect4\" _v-143b705b=\"\"></div>\n         <div class=\"rect5\" _v-143b705b=\"\"></div>\n       </div>\n   </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.box[_v-143b705b] {\n  padding: 30px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-143b705b", module.exports)
  } else {
    hotAPI.update("_v-143b705b", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],866:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['tab'],
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        isStudio: function isStudio(state) {
            return state.webadmin.configure.isStudio;
        },
        isBranch: function isBranch(state) {
            return state.webadmin.configure.isBranch;
        },
        isSeventeen: function isSeventeen(state) {
            return state.webadmin.configure.isSeventeen;
        },
        canAdmission: function canAdmission(state) {
            return state.webadmin.configure.webFunctions.WebadminCustomerAdmission;
        },
        canDashboard: function canDashboard(state) {
            return state.webadmin.configure.webFunctions.WebadminDashboardIndex;
        }
    }), {
        showTeachingTab: function showTeachingTab() {
            return this.isStudio || this.isBranch;
        },
        showAdmissionTab: function showAdmissionTab() {
            return this.isBranch && this.canAdmission;
        }
    }),
    methods: {
        getUrl: function getUrl(key) {
            return $17.GetUrl(key);
        },

        bindTabActive: function bindTabActive(t) {
            return this.tab === t ? { active: true } : {};
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div>\n    <ul class=\"nav nav-tabs\">\n        <li role=\"presentation\" v-bind:class=\"bindTabActive('schedule')\"><a :href=\"getUrl('WEBADMIN_SCHEDULE')\">日程</a></li>\n        <li v-show=\"canDashboard\" role=\"presentation\" v-bind:class=\"bindTabActive('dashboard')\"><a href=\"/webadmin/dashboard\">營運總覽</a></li>\n        <li v-show=\"showAdmissionTab\" role=\"presentation\" v-bind:class=\"bindTabActive('admission')\"><a href=\"/webadmin/admission\">入場</a></li>\n        <li v-show=\"canDashboard &amp;&amp; isSeventeen\" role=\"presentation\" v-bind:class=\"bindTabActive('dashboard-view')\"><a href=\"/webadmin/dashboard/view\">營運總覽17FIT</a></li>\n    </ul>\n    <div style=\"padding-top: 10px\"></div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-07f7c53d", module.exports)
  } else {
    hotAPI.update("_v-07f7c53d", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vuex":803}],867:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.action_row[_v-2092eb0f] {\n  margin: 0em 1em; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['fields', 'list', 'actions', 'para'],
    data: function data() {
        return {
            filter_filed: {}
        };
    },


    methods: {
        showTiele: function showTiele(field) {
            return field.show_word;
        },
        checkFilter: function checkFilter(key, data) {
            // const reg = new RegExp(key.split('').join('.*'));
            var reg = new RegExp(key + '.*');
            return reg.test(data);
        }

    },
    filter: {
        timeBetween: function timeBetween(datetime, start_datetime, end_datetime) {
            return start_datetime < datetime && end_datetime > datetime;
        }
    },
    computed: {
        showData: function showData() {
            var _this = this;

            return this.list.filter(function (row) {
                for (prop in row) {

                    if (typeof _this.para.datetime_filter_field !== 'undefined' && prop == _this.para.datetime_filter_field && (_this.para.time_start != '' && _this.para.time_start + ' 00:00:00' > row[prop] || (_this.para.time_end != '' && _this.para.time_end + ' 23:59:59') < row[prop])) {
                        return false;
                    }
                    if (typeof _this.filter_filed[prop] === 'undefined' || _this.filter_filed[prop] === '') {
                        continue;
                    }

                    var key = _this.filter_filed[prop];
                    var data = row[prop];
                    if (!_this.checkFilter(key, data)) return false;
                }
                return true;
            });
        }
    },
    watch: {
        fields: function fields() {
            this.filter_filed = this.fields.reduce(function (carry, next) {
                carry[next.field_name] = "";
                return carry;
            }, {});
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<table _v-2092eb0f=\"\">\n    <tbody _v-2092eb0f=\"\"><tr class=\"grid_title\" _v-2092eb0f=\"\">\n        <td v-for=\"field in fields\" _v-2092eb0f=\"\">\n            <p _v-2092eb0f=\"\">{{showTiele(field)}}</p>\n        </td>\n        <td _v-2092eb0f=\"\">動作</td>\n    </tr>\n    <tr class=\"action_row\" _v-2092eb0f=\"\">\n        \n            <td v-for=\"field in fields\" _v-2092eb0f=\"\">\n                <input v-bind:name=\"filter_filed[field.field_name]\" v-model=\"filter_filed[field.field_name]\" type=\"text\" class=\"form-control\" _v-2092eb0f=\"\">\n            </td>\n\n            <td _v-2092eb0f=\"\"></td>   \n        \n    </tr>\n    <tr v-for=\"row in showData\" _v-2092eb0f=\"\">\n        <td v-for=\"field in fields\" _v-2092eb0f=\"\">\n            <p _v-2092eb0f=\"\">{{row[field.field_name]}}</p>\n        </td>\n    </tr>\n</tbody></table>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.action_row[_v-2092eb0f] {\n  margin: 0em 1em; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-2092eb0f", module.exports)
  } else {
    hotAPI.update("_v-2092eb0f", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],868:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    data: function data() {
        return {
            member: {},
            ajaxIng: false
        };
    },
    created: function created() {
        var _this = this;

        window.Event.$on('fetch17AccountInfo', function (data) {
            _this.fetchAccountInfo(data.id);
            $(_this.$el).modal('show');
        });
    },

    methods: {
        fetchAccountInfo: function fetchAccountInfo(id) {
            var _this2 = this;

            if (this.ajaxIng) return;
            this.ajaxIng = true;
            this.$http.get('/api/member/get_main/' + id).then(function (response) {
                _this2.ajaxIng = false;
                _this2.member = response.data;
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal no-footer=\"\">\n    <div slot=\"title\">17FIT帳戶資料</div>\n    <div slot=\"body\">\n        <v-member-info :picture=\"member.picture_path\" :name=\"member.name\" :phone=\"member.phone\" :email=\"member.email\" :account=\"member.account\">\n        </v-member-info>\n    </div>\n</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-15c9681f", module.exports)
  } else {
    hotAPI.update("_v-15c9681f", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],869:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 4, stdin */\n.btn[_v-6fd39012] {\n  color: white;\n  border: none; }\n\n/* line 8, stdin */\n.btn-primary[_v-6fd39012] {\n  padding-left: 2em;\n  padding-right: 2em;\n  background-color: #38b0e3; }\n  /* line 12, stdin */\n  .btn-primary[_v-6fd39012]:hover {\n    background-color: #1d97cb; }\n\n/* line 16, stdin */\n.btn-cancel[_v-6fd39012] {\n  background-color: #ccc; }\n  /* line 18, stdin */\n  .btn-cancel[_v-6fd39012]:hover {\n    background-color: #b3b3b3; }\n\n/* line 22, stdin */\n.modal-content[_v-6fd39012] {\n  overflow-x: hidden;\n  border-radius: var(--modal-border-radius); }\n\n/* line 26, stdin */\n.modal-content.no-border-radius[_v-6fd39012] {\n  border-radius: 0; }\n\n/* line 29, stdin */\n.times-icon[_v-6fd39012] {\n  font-size: 1.5em; }\n\n/* line 2, stdin */\nbody:not(.modal-open) {\n  padding-right: 0px !important; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        id: {},
        bodyClass: {},
        bus: {
            default: false
        },
        locked: false, //已經無法使用
        removeBtnShow: {
            default: false
        },
        removeBtnText: {
            default: '刪除'
        },
        removeBtnIcon: {
            default: 'fa fa-trash'
        },
        confirmBtnText: {
            default: '確定'
        },
        closeBtnText: {
            default: '關閉'
        },
        closeClicked: {},
        saveClicked: {},
        removeClicked: {},
        openSize: {
            default: 'modal-md'
        },
        closeModalEvent: {},
        blockHideWithoutClose: false,
        popAjaxing: false,
        borderRadiusLevel: {
            default: '6px'
        },
        parallelModal: {
            type: Boolean,
            default: false,
            description: 'If true, the modal auto relocate under #backend-vue-app and parallel to other modal'
        },
        keepAlive: {
            type: Boolean,
            default: true,
            description: 'If true, the modal will not auto remove duplicate modal element'
        }
    },
    data: function data() {
        return {
            hasHeader: false,
            hasFooter: false,
            hasNoBorderRadius: false,
            hasCancel: false,
            ajaxing: false
        };
    },

    methods: {
        checkNotShow: function checkNotShow(tag) {
            return !this.$el.attributes.getNamedItem(tag);
        },
        closeModal: function closeModal() {
            if (this.locked) return;
            // this.closeModalEvent&&this.closeModalEvent();//重複執行
            $(this.$el).modal('hide');
        },

        saveBtnClicked: function () {
            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                this.ajaxing = true;
                                _context.next = 3;
                                return this.saveClicked();

                            case 3:
                                this.ajaxing = false;

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function saveBtnClicked() {
                return _ref.apply(this, arguments);
            }

            return saveBtnClicked;
        }(),
        removeBtnClicked: function () {
            var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                this.ajaxing = true;
                                _context2.next = 3;
                                return this.removeClicked();

                            case 3:
                                this.ajaxing = false;

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function removeBtnClicked() {
                return _ref2.apply(this, arguments);
            }

            return removeBtnClicked;
        }(),
        initStyle: function initStyle() {
            this.hasFooter = this.checkNotShow('no-footer');
            this.hasHeader = this.checkNotShow('no-header');
            this.hasCancel = this.checkNotShow('no-cancel');
            this.hasNoBorderRadius = !this.checkNotShow('no-border-radius');
        },
        moveElementToMain: function moveElementToMain(vueElement) {
            var main = document.querySelector('#backend-vue-app');
            main.appendChild(vueElement.$el);
        },
        cleanNoneAliveModal: function cleanNoneAliveModal() {
            if (!this.keepAlive) {
                document.querySelector('#backend-vue-app').querySelector("#" + this.id).remove();
            }
        }
    },
    computed: {
        modalContentClass: function modalContentClass() {
            return {
                'no-border-radius': this.hasNoBorderRadius
            };
        },
        backdrop: function backdrop() {
            return this.locked | this.blockHideWithoutClose ? 'static' : 'true';
        },
        keyboard: function keyboard() {
            return this.locked | this.blockHideWithoutClose ? 'false' : 'true';
        }
    },
    mounted: function mounted() {
        this.initStyle();
        var vm = this;
        $(this.$el).on('show.bs.modal', function () {
            if (vm.parallelModal) {
                vm.moveElementToMain(vm);
            }
        });

        this.$nextTick(function () {
            var browserWidth = $(window).innerWidth();
            $(this.$el).on('shown.bs.modal', function (event) {
                var zIndex = 1050 + 10 * $('.modal:visible').length;

                if ($('.float-widget').attr('class')) {
                    // TODO Remove when v-modal refactoried
                    var fwzIndex = $('.float-widget').attr('class').includes('isOpen') ? zIndex + 1 : zIndex;
                    $(this).css('z-index', fwzIndex);
                } else {
                    $(this).css('z-index', zIndex);
                }
                $('.modal-backdrop').not('.modal-stack').css('z-index', zIndex - 1).addClass('modal-stack');
                $('.modal:visible').css("background-color", 'rgba(0,0,0,0.6)');
                $(this).css("background-color", '');
                if ($('.modal:visible').length) //check if any modal is open
                    {
                        $('body').addClass('modal-open'); //add class to body
                    }
                event.stopPropagation();
            });

            $(this.$el).on('hidden.bs.modal', function (event) {
                if ($('.modal:visible').length) //check if any modal is open
                    {
                        $('body').addClass('modal-open'); //add class to body
                    } else {
                    $('#launcher').css({ 'display': '' });
                }
                vm.closeModalEvent && vm.closeModalEvent(event);
                vm.cleanNoneAliveModal();
                event.stopPropagation();
            });
        });
    },
    created: function created() {
        var _this = this;

        if (this.bus !== false) {
            this.bus.$on('v-model-lock', function () {
                _this.locked = true;
                var modal = $(_this.$el).data('bs.modal');
                if (!modal) return;
                modal.options.backdrop = 'static';
                modal.options.keyboard = false;
            });
            this.bus.$on('v-model-unlock', function () {
                _this.locked = false;
                var modal = $(_this.$el).data('bs.modal');
                if (!modal) return;
                modal.options.backdrop = true;
                modal.options.keyboard = true;
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"modal fade\" role=\"dialog\" :id=\"id\" :data-backdrop=\"backdrop\" :data-keyboard=\"keyboard\" _v-6fd39012=\"\">\n    <div class=\"modal-dialog \" :class=\"openSize\" role=\"document\" _v-6fd39012=\"\">\n        <div class=\"modal-content\" :class=\"modalContentClass\" :style=\"{ '--modal-border-radius': borderRadiusLevel }\" _v-6fd39012=\"\">\n            <div class=\"modal-header\" v-show=\"hasHeader\" _v-6fd39012=\"\">\n                <button type=\"button\" class=\"close\" aria-label=\"Close\" @click=\"closeModal\" _v-6fd39012=\"\"><span aria-hidden=\"true\" class=\"times-icon\" _v-6fd39012=\"\">×</span></button>\n                <h4 class=\"modal-title\" _v-6fd39012=\"\"><slot name=\"title\" _v-6fd39012=\"\"></slot></h4>\n            </div>\n            <div class=\"modal-body\" :class=\"[bodyClass]\" _v-6fd39012=\"\">\n                <slot name=\"body\" _v-6fd39012=\"\"></slot>\n            </div>\n            <div class=\"modal-footer\" v-show=\"hasFooter\" _v-6fd39012=\"\">\n                <slot name=\"footer\" _v-6fd39012=\"\">\n                    <div v-show=\"!ajaxing &amp;&amp; !popAjaxing\" _v-6fd39012=\"\">\n                        <button type=\"button\" class=\"btn btn-danger pull-left\" v-show=\"removeBtnShow\" @click=\"removeBtnClicked\" _v-6fd39012=\"\">\n                            <i :class=\"removeBtnIcon\" _v-6fd39012=\"\"></i> {{removeBtnText}}\n                        </button>\n                        <button type=\"button\" class=\"btn btn-cancel\" v-show=\"hasCancel\" @click=\"closeModal\" _v-6fd39012=\"\">{{ closeBtnText }}</button>\n                        <button type=\"button\" class=\"btn btn-primary\" @click=\"saveBtnClicked\" _v-6fd39012=\"\">{{ confirmBtnText }}</button>\n                    </div>\n                    <v-spinner-button :ajaxing=\"ajaxing\" fa-size=\"fa-3x\" _v-6fd39012=\"\"></v-spinner-button>\n                </slot>\n            </div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 4, stdin */\n.btn[_v-6fd39012] {\n  color: white;\n  border: none; }\n\n/* line 8, stdin */\n.btn-primary[_v-6fd39012] {\n  padding-left: 2em;\n  padding-right: 2em;\n  background-color: #38b0e3; }\n  /* line 12, stdin */\n  .btn-primary[_v-6fd39012]:hover {\n    background-color: #1d97cb; }\n\n/* line 16, stdin */\n.btn-cancel[_v-6fd39012] {\n  background-color: #ccc; }\n  /* line 18, stdin */\n  .btn-cancel[_v-6fd39012]:hover {\n    background-color: #b3b3b3; }\n\n/* line 22, stdin */\n.modal-content[_v-6fd39012] {\n  overflow-x: hidden;\n  border-radius: var(--modal-border-radius); }\n\n/* line 26, stdin */\n.modal-content.no-border-radius[_v-6fd39012] {\n  border-radius: 0; }\n\n/* line 29, stdin */\n.times-icon[_v-6fd39012] {\n  font-size: 1.5em; }\n\n/* line 2, stdin */\nbody:not(.modal-open) {\n  padding-right: 0px !important; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-6fd39012", module.exports)
  } else {
    hotAPI.update("_v-6fd39012", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],870:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n*[_v-b49d5d84] {\n  font-size: 12px; }\n\n/* line 5, stdin */\n.form-control[_v-b49d5d84] {\n  margin-bottom: 0; }\n\n/* line 8, stdin */\n.group[_v-b49d5d84] {\n  padding: 5px 0; }\n\n/* line 11, stdin */\n.flex[_v-b49d5d84] {\n  display: -ms-flexbox;\n  display: flex; }\n\n/* line 14, stdin */\n.flex-div > div[_v-b49d5d84] {\n  padding: 0 .2em;\n  -ms-flex: 1;\n      flex: 1; }\n  /* line 17, stdin */\n  .flex-div > div[_v-b49d5d84]:first-child {\n    padding-left: 0; }\n  /* line 20, stdin */\n  .flex-div > div[_v-b49d5d84]:last-child {\n    padding-right: 0; }\n\n/* line 24, stdin */\n.al-c[_v-b49d5d84] {\n  line-height: 34px; }\n\n/* line 27, stdin */\n.p-tb-5[_v-b49d5d84] {\n  padding: 5px 0; }\n\n/* line 30, stdin */\n.error-msg[_v-b49d5d84] {\n  height: 20px;\n  color: #e07c7a; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['bus'],
    data: function data() {
        return {
            card1: '',
            card2: '',
            card3: '',
            card4: '',
            cvc: '',
            year: -1,
            month: -1,
            order: ['card1', 'card2', 'card3', 'card4', 'month', 'year', 'cvc'],
            error: {
                card1: '',
                card2: '',
                card3: '',
                card4: '',
                month: '',
                year: '',
                cvc: ''
            }
        };
    },

    computed: {
        card: function card() {
            return this.card1 + this.card2 + this.card3 + this.card4;
        },
        years: function years() {
            var currentYear = new Date().getFullYear();
            return _lodash2.default.range(currentYear, currentYear + 20);
        },
        months: function months() {
            return _lodash2.default.range(1, 13).map(function (v) {
                return v > 9 ? v : '0' + v;
            });
        }
    },
    methods: {
        validateNewCardForm: function validateNewCardForm() {
            if (!this.formOk()) return false;
            this.bus.$emit('new-card-validated', {
                card: this.card,
                authCode: this.cvc,
                month: this.month,
                year: this.year
            });
        },
        formOk: function formOk() {
            this.blurTextCheck('card1', 4);
            this.blurTextCheck('card2', 4);
            this.blurTextCheck('card3', 4);
            this.blurTextCheck('card4', 4);
            this.blurTextCheck('cvc', 3);
            this.blurSelectCheck('month');
            this.blurSelectCheck('year');
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)((0, _keys2.default)(this.error)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var p = _step.value;

                    if (this.error[p]) return false;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return true;
        },
        onlyNumber: function onlyNumber(s) {
            return s.replace(/[^0-9]+/g, "");
        },
        cardCheck: function cardCheck(index, n, o) {
            var sanitize = this.onlyNumber(n).substring(0, 4);
            if (sanitize != n) {
                $('.v-new-card-card' + index).val(sanitize);
                this['card' + index] = sanitize;
            }
            if (this['card' + index].length == 4) {
                if (index < 4) return $('.v-new-card-card' + (index + 1)).focus();
                return $('.v-new-card-month').focus();
            }
            if (this['card' + index].length == 0 && index > 1) $('.v-new-card-card' + (index - 1)).focus();
        },
        blurTextCheck: function blurTextCheck(field, length) {
            if (!this[field]) return this.error[field] = '該項為必填!';
            if (this[field].length < length) return this.error[field] = '\u8A72\u9805\u9700\u586B' + length + '\u78BC\u6578\u5B57\uFF01';
        },
        blurSelectCheck: function blurSelectCheck(field) {
            if (this[field] == -1) return this.error[field] = '該項為必填!';
        }
    },
    watch: {
        'card1': function card1(n, o) {
            this.cardCheck(1, n, o);
        },
        'card2': function card2(n, o) {
            this.cardCheck(2, n, o);
        },
        'card3': function card3(n, o) {
            this.cardCheck(3, n, o);
        },
        'card4': function card4(n, o) {
            this.cardCheck(4, n, o);
        },
        'month': function month(n, o) {
            if (n) $('.v-new-card-year').focus();
        },
        'year': function year(n, o) {
            if (n) $('.v-new-card-cvc').focus();
        },
        'cvc': function cvc(n, o) {
            var sanitize = this.onlyNumber(n).substring(0, 3);
            if (sanitize != n) {
                $('.v-new-card-cvc').val(sanitize);
                this.cvc = sanitize;
            }
        }
    },
    created: function created() {
        var _this = this;

        this.bus.$on('reset-new-card-form', function () {
            _this.card1 = '';
            _this.card2 = '';
            _this.card3 = '';
            _this.card4 = '';
            _this.cvc = '';
            _this.year = -1;
            _this.month = -1;
            _this.error = {
                card1: '', card2: '', card3: '', card4: '', month: '', year: '', cvc: ''
            };
        });
        this.bus.$on('validate-new-card', function () {
            _this.validateNewCardForm();
        });
    },

    mounted: function mounted() {
        this.$nextTick(function () {
            var _this2 = this;

            $(this.$el).find('.v-new-card-card1').blur(function () {
                return _this2.blurTextCheck('card1', 4);
            });
            $(this.$el).find('.v-new-card-card2').blur(function () {
                return _this2.blurTextCheck('card2', 4);
            });
            $(this.$el).find('.v-new-card-card3').blur(function () {
                return _this2.blurTextCheck('card3', 4);
            });
            $(this.$el).find('.v-new-card-card4').blur(function () {
                return _this2.blurTextCheck('card4', 4);
            });
            $(this.$el).find('.v-new-card-cvc').blur(function () {
                return _this2.blurTextCheck('cvc', 3);
            });
            $(this.$el).find('.v-new-card-month').blur(function () {
                return _this2.blurSelectCheck('month');
            });
            $(this.$el).find('.v-new-card-year').blur(function () {
                return _this2.blurSelectCheck('year');
            });

            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                var _loop = function _loop() {
                    var p = _step2.value;

                    $(_this2.$el).find('.v-new-card-' + p).focus(function () {
                        return _this2.error[p] = '';
                    });
                };

                for (var _iterator2 = (0, _getIterator3.default)(this.order), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    _loop();
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        });
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-b49d5d84=\"\">\n    <div class=\"group\" _v-b49d5d84=\"\">\n        <div class=\"p-tb-5\" _v-b49d5d84=\"\">{{ i18n.t('payment.card_number') }}</div>\n        <div class=\"flex card-number flex-div\" _v-b49d5d84=\"\">\n            <div _v-b49d5d84=\"\">\n                <div _v-b49d5d84=\"\"><input class=\"form-control v-new-card-card1\" type=\"text\" v-model=\"card1\" _v-b49d5d84=\"\"></div>\n                <div class=\"error-msg\" _v-b49d5d84=\"\">\n                    <span _v-b49d5d84=\"\">{{ error.card1 }}</span>\n                </div>\n            </div>\n            <div _v-b49d5d84=\"\">\n                <div _v-b49d5d84=\"\"><input class=\"form-control v-new-card-card2\" type=\"text\" v-model=\"card2\" _v-b49d5d84=\"\"></div>\n                <div class=\"error-msg\" _v-b49d5d84=\"\">\n                    <span _v-b49d5d84=\"\">{{ error.card2 }}</span>\n                </div>\n            </div>\n            <div _v-b49d5d84=\"\">\n                <div _v-b49d5d84=\"\"><input class=\"form-control v-new-card-card3\" type=\"text\" v-model=\"card3\" _v-b49d5d84=\"\"></div>\n                <div class=\"error-msg\" _v-b49d5d84=\"\">\n                    <span _v-b49d5d84=\"\">{{ error.card3 }}</span>\n                </div>\n            </div>\n            <div _v-b49d5d84=\"\">\n                <div _v-b49d5d84=\"\"><input class=\"form-control v-new-card-card4\" type=\"text\" v-model=\"card4\" _v-b49d5d84=\"\"></div>\n                <div class=\"error-msg\" _v-b49d5d84=\"\">\n                    <span _v-b49d5d84=\"\">{{ error.card4 }}</span>\n                </div>\n            </div>\n        </div>    \n    </div>\n    <div class=\"group flex flex-div\" _v-b49d5d84=\"\">\n        <div _v-b49d5d84=\"\">\n            <div _v-b49d5d84=\"\">\n                <select class=\"form-control v-new-card-month primary-business-color-input-border-hover primary-business-color-input-border-focus\" v-model=\"month\" _v-b49d5d84=\"\">\n                    <option value=\"-1\" selected=\"\" _v-b49d5d84=\"\">{{ i18n.t('payment.card_mm') }}</option>\n                    <option v-for=\"m in months\" :value=\"m\" _v-b49d5d84=\"\">{{ m }}</option>\n                </select>\n            </div>\n            <div class=\"error-msg\" _v-b49d5d84=\"\">\n                <span _v-b49d5d84=\"\">{{ error.month }}</span>\n            </div>\n        </div>\n        <div _v-b49d5d84=\"\">\n            <div _v-b49d5d84=\"\">\n                <select class=\"form-control v-new-card-year primary-business-color-input-border-hover primary-business-color-input-border-focus\" v-model=\"year\" _v-b49d5d84=\"\">\n                    <option value=\"-1\" selected=\"\" _v-b49d5d84=\"\">{{ i18n.t('payment.card_yy') }}</option>    \n                    <option v-for=\"y in years\" :value=\"y\" _v-b49d5d84=\"\">{{ y }}</option>\n                </select>\n            </div>\n            <div class=\"error-msg\" _v-b49d5d84=\"\">\n                <span _v-b49d5d84=\"\">{{ error.year }}</span>\n            </div>\n        </div>\n    </div>\n    <div class=\"group flex flex-div\" _v-b49d5d84=\"\">\n        <div _v-b49d5d84=\"\">\n            <div _v-b49d5d84=\"\"><input class=\"form-control v-new-card-cvc\" type=\"text\" v-model=\"cvc\" _v-b49d5d84=\"\"></div>\n            <div class=\"error-msg\" _v-b49d5d84=\"\">\n                <span _v-b49d5d84=\"\">{{ error.cvc }}</span>\n            </div>\n        </div>\n        <div class=\"al-c\" _v-b49d5d84=\"\">{{ i18n.t('payment.card_cvv') }}</div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n*[_v-b49d5d84] {\n  font-size: 12px; }\n\n/* line 5, stdin */\n.form-control[_v-b49d5d84] {\n  margin-bottom: 0; }\n\n/* line 8, stdin */\n.group[_v-b49d5d84] {\n  padding: 5px 0; }\n\n/* line 11, stdin */\n.flex[_v-b49d5d84] {\n  display: -ms-flexbox;\n  display: flex; }\n\n/* line 14, stdin */\n.flex-div > div[_v-b49d5d84] {\n  padding: 0 .2em;\n  -ms-flex: 1;\n      flex: 1; }\n  /* line 17, stdin */\n  .flex-div > div[_v-b49d5d84]:first-child {\n    padding-left: 0; }\n  /* line 20, stdin */\n  .flex-div > div[_v-b49d5d84]:last-child {\n    padding-right: 0; }\n\n/* line 24, stdin */\n.al-c[_v-b49d5d84] {\n  line-height: 34px; }\n\n/* line 27, stdin */\n.p-tb-5[_v-b49d5d84] {\n  padding: 5px 0; }\n\n/* line 30, stdin */\n.error-msg[_v-b49d5d84] {\n  height: 20px;\n  color: #e07c7a; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-b49d5d84", module.exports)
  } else {
    hotAPI.update("_v-b49d5d84", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/get-iterator":46,"babel-runtime/core-js/object/keys":56,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],871:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['state', 'onText', 'offText'],
    data: function data() {
        return {
            switch_status: this.state //①创建props属性result的副本--myResult
        };
    },
    watch: {
        state: function state(newVal) {
            this.switch_status = newVal;
        },
        switch_status: function switch_status(newVal) {
            $(this.$el).find('input').prop('checked', newVal).change();
            this.$emit("on-switch-change", newVal);
        }
    },
    mounted: function mounted() {
        this.$nextTick(function () {
            var _this = this;

            $.fn.bootstrapSwitch.defaults.onColor = 'info';
            $(this.$el).find('input').bootstrapSwitch({
                onText: this.onText || '開啟',
                offText: this.offText || '關閉'
            });
            $(this.$el).find('input').on('switchChange.bootstrapSwitch', function (event, state) {
                return _this.switch_status = state;
            });
        });
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div>\n    <input type=\"checkbox\" v-model=\"switch_status\">\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-7ebe2cda", module.exports)
  } else {
    hotAPI.update("_v-7ebe2cda", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],872:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _vSortable = require('./v-sortable.vue');

var _vSortable2 = _interopRequireDefault(_vSortable);

var _vScheduleGroup = require('./v-schedule-group.vue');

var _vScheduleGroup2 = _interopRequireDefault(_vScheduleGroup);

var _vPaymentSettingBtn = require('./v-payment-setting-btn.vue');

var _vPaymentSettingBtn2 = _interopRequireDefault(_vPaymentSettingBtn);

var _vBindingStudioAccountsBtn = require('./v-binding-studio-accounts-btn.vue');

var _vBindingStudioAccountsBtn2 = _interopRequireDefault(_vBindingStudioAccountsBtn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('v-sortable', _vSortable2.default);
_vue2.default.component('v-schedule-group', _vScheduleGroup2.default);
_vue2.default.component('v-payment-setting-btn', _vPaymentSettingBtn2.default);
_vue2.default.component('v-binding-studio-accounts-btn', _vBindingStudioAccountsBtn2.default);

},{"./v-binding-studio-accounts-btn.vue":873,"./v-payment-setting-btn.vue":874,"./v-schedule-group.vue":875,"./v-sortable.vue":876,"vue":792}],873:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['memberid'],
    data: function data() {
        return {
            name: '',
            bindings: []
        };
    },

    methods: {
        showMemberBindings: function showMemberBindings() {
            var _this = this;

            this.$http.get('/adminapi/members/studio_account_bindings/' + this.memberid).then(function (response) {
                _this.name = response.data.name;
                _this.bindings = response.data.bindings;
                $(_this.$el).find('div.modal').modal('show');
            });
        },
        deleteItem: function deleteItem(binding) {
            if (confirm('請確定是否解除綁定？') == false) {
                return false;
            }
            this.$http.delete('/adminapi/members/studio_account_bindings/delete/' + binding.id).then(function (response) {
                location.reload();
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div style=\"display:inline\">\n  <a href=\"javascript:void(0)\" @click.prevent=\"showMemberBindings(memberid)\" help=\"綁定的場館會員\" class=\"btn btn-info btn-xs\"><i class=\"fa fa-link\" help=\"綁定的場館會員\"></i></a>\n  <div class=\"modal fade\" role=\"dialog\">\n    <div class=\"modal-dialog\">\n      <div class=\"modal-content\">\n        <div class=\"modal-header\">\n          <button type=\"button\" class=\"close\" data-dismiss=\"modal\">×</button>\n          <h4 class=\"modal-title\">{{ name }} 的綁定資料</h4>\n        </div>\n        <div class=\"modal-body\">\n          <div class=\"row\">\n            <table class=\"table\">\n              <thead>\n                <tr>\n                    <th></th>\n                    <th>客戶ID</th>\n                    <th>姓名</th>\n                    <th>品牌</th>\n                    <th>綁定時間</th>\n                  </tr>\n              </thead>\n              <tbody>\n                  <tr v-for=\"b in bindings\">\n                      <th scope=\"row\"><a @click.prevent=\"deleteItem(b)\" help=\"解除綁定\" class=\"btn btn-danger btn-xs\"><i class=\"fa fa-unlink\" help=\"解除綁定\"></i></a></th>\n                      <td>{{ b.member_id }}</td>\n                      <td>{{ b.name }}</td>\n                      <td>{{ b.brand_name }}</td>\n                      <td>{{ b.binding_at }}</td>\n                  </tr>\n              </tbody>\n            </table>\n          </div>\n        </div>\n        <div class=\"modal-footer\">\n          <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">關閉</button>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-62dfb9f0", module.exports)
  } else {
    hotAPI.update("_v-62dfb9f0", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],874:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['memberid'],
    data: function data() {
        return {
            name: '',
            payment_settings: []
        };
    },

    methods: {
        showCreditCards: function showCreditCards() {
            var _this = this;

            this.$http.get('/adminapi/members/payment_settings/' + this.memberid).then(function (response) {
                _this.name = response.data.name;
                _this.payment_settings = response.data.payment_settings;
                $(_this.$el).find('div.modal').modal('show');
            });
        },
        deleteItem: function deleteItem(card) {
            if (confirm('請確定是否刪除卡號「' + card.name + '」？') == false) {
                return false;
            }
            this.$http.delete('/adminapi/members/payment_settings/delete/' + card.id).then(function (response) {
                location.reload();
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div style=\"display:inline\">\n    <a href=\"javascript:void(0)\" @click.prevent=\"showCreditCards(memberid)\" help=\"付款設定\" class=\"btn btn-info btn-xs\"><i class=\"fa fa-credit-card\" help=\"付款設定\"></i></a>\n    <div class=\"modal fade\" role=\"dialog\">\n        <div class=\"modal-dialog\">\n            <div class=\"modal-content\">\n                <div class=\"modal-header\">\n                    <button type=\"button\" class=\"close\" data-dismiss=\"modal\">×</button>\n                    <h4 class=\"modal-title\">{{ name }} 的付款設定</h4>\n                </div>\n                <div class=\"modal-body\">\n                    <table class=\"table\">\n                       <thead>\n                          <tr>\n                             <th></th>\n                             <th>卡號</th>\n                             <th>綁定時間</th>\n                          </tr>\n                       </thead>\n                       <tbody>\n                          <tr v-for=\"ps in payment_settings\">\n                             <th scope=\"row\"><a @click.prevent=\"deleteItem(ps)\" help=\"刪除\" class=\"btn btn-danger btn-xs\"><i class=\"fa fa-trash-o\" help=\"刪除\"></i></a></th>\n                             <td>{{ ps.name }}</td>\n                             <td>{{ ps.binding_at }}</td>\n                          </tr>\n                       </tbody>\n                    </table>\n                </div>\n                <div class=\"modal-footer\">\n                    <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">關閉</button>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-26872448", module.exports)
  } else {
    hotAPI.update("_v-26872448", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],875:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.panel[_v-3298b196] {\n  margin-right: 10px;\n  margin-left: 10px;\n  box-shadow: none; }\n\n/* line 7, stdin */\n.panel-heading[_v-3298b196] {\n  font-size: 20px;\n  font-weight: 500; }\n  /* line 10, stdin */\n  .panel-heading span[_v-3298b196] {\n    font-size: 14px;\n    color: #767676;\n    margin: auto 10px; }\n\n/* line 16, stdin */\n.row[_v-3298b196] {\n  margin: 0;\n  padding-top: 11px;\n  padding-bottom: 11px; }\n  /* line 20, stdin */\n  .row.schedule-head[_v-3298b196] {\n    font-size: 16px;\n    font-weight: 500;\n    background: #86959f;\n    color: #ffffff; }\n  /* line 26, stdin */\n  .row.schedule-content[_v-3298b196] {\n    font-size: 15px;\n    margin-bottom: 2px;\n    cursor: pointer;\n    background: #fafafa;\n    border-bottom: dashed 1px #e5e5e5;\n    border-left: solid 5px #5eb95d; }\n    /* line 33, stdin */\n    .row.schedule-content.isClass[_v-3298b196] {\n      border-left: solid 5px #38afe3; }\n    /* line 36, stdin */\n    .row.schedule-content.isGreen[_v-3298b196] {\n      background: #e5eae5;\n      color: #0fb124; }\n    /* line 40, stdin */\n    .row.schedule-content .schedule-title[_v-3298b196] {\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis; }\n    /* line 45, stdin */\n    .row.schedule-content .isRed[_v-3298b196] {\n      color: #ff2600; }\n    /* line 48, stdin */\n    .row.schedule-content .fa-video-camera[_v-3298b196] {\n      color: #38afe3; }\n\n/* line 53, stdin */\n.flex-display[_v-3298b196] {\n  display: -ms-flexbox;\n  display: flex; }\n  /* line 55, stdin */\n  .flex-display .item[_v-3298b196] {\n    width: 50%;\n    margin-top: 0; }\n\n@media (max-width: 480px) {\n  /* line 61, stdin */\n  .panel[_v-3298b196] {\n    margin-left: 20px;\n    margin-right: 20px; }\n  /* line 65, stdin */\n  .panel-heading[_v-3298b196] {\n    padding: 10px 15px 10px 0; }\n  /* line 68, stdin */\n  .row[_v-3298b196] {\n    display: -ms-grid;\n    display: grid;\n    grid-gap: 5px;\n    -ms-grid-rows: 1fr 1fr 1fr;\n        grid-template-rows: 1fr 1fr 1fr;\n    -ms-grid-columns: 1fr 1fr;\n        grid-template-columns: 1fr 1fr;\n    grid-template-areas: \"date status\" \"title title\" \"provider attendee\"; }\n    /* line 69, stdin */\n    .row.schedule-head[_v-3298b196] {\n      display: none; }\n    /* line 81, stdin */\n    .row.schedule-content.isGreen[_v-3298b196] {\n      color: black; }\n    /* line 84, stdin */\n    .row.schedule-content div[_v-3298b196] {\n      width: 100%; }\n    /* line 87, stdin */\n    .row.schedule-content .schedule-time[_v-3298b196] {\n      grid-area: date; }\n    /* line 90, stdin */\n    .row.schedule-content .schedule-title[_v-3298b196] {\n      grid-area: title;\n      white-space: wrap; }\n    /* line 94, stdin */\n    .row.schedule-content .schedule-provider[_v-3298b196] {\n      grid-area: provider;\n      color: #606060; }\n    /* line 98, stdin */\n    .row.schedule-content .schedule-status[_v-3298b196] {\n      grid-area: status;\n      text-align: right; }\n      /* line 101, stdin */\n      .row.schedule-content .schedule-status span[_v-3298b196] {\n        color: #515151;\n        font-size: 10px;\n        word-break: keep-all; }\n        /* line 105, stdin */\n        .row.schedule-content .schedule-status span.isRed[_v-3298b196] {\n          color: #ff2600; }\n        /* line 108, stdin */\n        .row.schedule-content .schedule-status span.isGreen[_v-3298b196] {\n          color: #0fb124; }\n    /* line 113, stdin */\n    .row.schedule-content .schedule-attendee[_v-3298b196] {\n      grid-area: attendee;\n      text-align: right; }\n  /* line 119, stdin */\n  .flex-display[_v-3298b196] {\n    -ms-flex-direction: row-reverse;\n        flex-direction: row-reverse; } }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['groupname', 'group', 'statusListStyle'],
    data: function data() {
        return {
            labelConfig: {
                labelComponent: {
                    class_stop_booking: {
                        componentName: 'single-label',
                        params: {
                            background: "#696974",
                            color: "#fff",
                            labelText: '終止訂課',
                            tooltip: '終止訂課'
                        }
                    },
                    class_suspend: {
                        componentName: 'single-label',
                        params: {
                            background: "#696974",
                            color: "#fff",
                            labelText: '停課',
                            tooltip: '停課'
                        }
                    }
                },
                maxItemCount: 3
            }
        };
    },

    computed: {
        isShow: function isShow() {
            return this.group.length > 0;
        },
        groupName: function groupName() {
            var weekDay = $17.getChineseWeekday(moment(this.groupname).weekday());
            weekDay = ' 星期' + weekDay;
            return this.groupname + ' ' + weekDay;
        },
        suffixHeading: function suffixHeading() {
            if (moment().format('YYYY-MM-DD') === this.groupname) {
                return '(今天)';
            } else if (moment().add(1, 'days').format('YYYY-MM-DD') === this.groupname) {
                return '(明天)';
            } else {
                return '';
            };
        },
        classStyle: function classStyle() {
            if (!this.statusListStyle) return;
            return this.statusListStyle.find(function (item) {
                return item.id == 'class';
            }).status;
        },
        serviceStyle: function serviceStyle() {
            if (!this.statusListStyle) return;
            return this.statusListStyle.find(function (item) {
                return item.id == 'service_booking';
            }).status;
        }
    },
    mounted: function mounted() {},
    destroyed: function destroyed() {},

    methods: {
        manipulate: function manipulate(item) {
            var vm = this;
            if (item.url == null) {
                $.notify('權限不足', { className: 'error', globalPosition: 'top center', clickToHide: true });
                return;
            }

            if (item.qty) {
                window.Event.$emit('FloatWidget.Show', {
                    widget: 'checkstudio.page',
                    widget_config_width: 'default',
                    widget_schedule_id: item.id
                });
                return false;
            }

            this.$emit('click-schedule', item.booking_id);
        },
        timeToMoment: function timeToMoment(inputTime) {
            var time = inputTime.split(':');
            return moment(this.groupname).set('hour', time[0]).set('minute', time[1]);
        },
        formatTime: function formatTime(item) {
            return this.timeToMoment(item.start_time).format('HH:mm') + '-' + this.timeToMoment(item.end_time).format('HH:mm');
        },
        memberLightbox: function (_memberLightbox) {
            function memberLightbox(_x) {
                return _memberLightbox.apply(this, arguments);
            }

            memberLightbox.toString = function () {
                return _memberLightbox.toString();
            };

            return memberLightbox;
        }(function (customer_id) {
            memberLightbox(customer_id);
        }),
        isClass: function isClass(schedule) {
            return schedule.qty ? true : false;
        },
        checkStyle: function checkStyle(it) {
            var serviceStatusArr = ['unstart', 'unstart', 'finish', 'unstart', 'absence', 'cancel', 'cancellate', 'finish', 'finish'];
            if (this.isClass(it)) {
                var statusStyle = this.classStyle.find(function (item) {
                    return item.id == it.status.value;
                }).style;
                return statusStyle + ' isClass';
            } else {
                var serviceStatus = serviceStatusArr[it.status.value];
                return this.serviceStyle.find(function (item) {
                    return item.id == serviceStatus;
                }).style;
            }
        },
        isLiveClass: function isLiveClass(it) {
            return it.hasOwnProperty('is_live') ? it.is_live : false;
        },
        hoverOnName: function hoverOnName(event) {
            window.Event.$emit('MemberCard.Show', event.target);
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div v-if=\"isShow\" class=\"panel\" _v-3298b196=\"\">\n    <div class=\"panel-heading\" _v-3298b196=\"\">{{ groupName }}<span _v-3298b196=\"\">{{ suffixHeading }}</span></div>\n    <div class=\"row schedule-head\" _v-3298b196=\"\">\n        <div class=\"col-sm-2 col-xs-2\" _v-3298b196=\"\">時間</div>\n        <div class=\"col-sm-3 col-xs-3\" _v-3298b196=\"\">名稱</div>\n        <div class=\"col-sm-2 col-xs-2\" _v-3298b196=\"\">人員</div>\n        <div class=\"col-sm-4 col-xs-4\" _v-3298b196=\"\">狀態</div>\n        <div class=\"col-sm-1 col-xs-1\" _v-3298b196=\"\"></div>\n    </div>\n    <div class=\"row schedule-content\" :class=\"checkStyle(it)\" v-for=\"(it, idx) in group\" @click=\"manipulate(it)\" _v-3298b196=\"\">\n        <div class=\"col-sm-2 col-xs-2 schedule-time\" _v-3298b196=\"\">{{ formatTime(it) }}</div>\n        <div class=\"col-sm-3 col-xs-3 schedule-title\" _v-3298b196=\"\">\n            <i class=\"fa fa-video-camera m-right-5\" v-show=\"isLiveClass(it)\" _v-3298b196=\"\"></i>\n            {{ it.title }}\n        </div>\n        <div class=\"col-sm-2 col-xs-2 schedule-provider\" _v-3298b196=\"\">{{ it.service_provider.name }}</div>\n        <div class=\"col-sm-4 col-xs-4 schedule-status\" _v-3298b196=\"\">\n            <div class=\"flex-display\" _v-3298b196=\"\">\n                <span class=\"item\" :class=\"checkStyle(it)\" _v-3298b196=\"\">{{it.status.text}}</span>\n                <div class=\"item\" v-if=\"it.info_labels\" _v-3298b196=\"\">\n                    <label-group :label-config=\"labelConfig\" :label-items=\"it.info_labels\" _v-3298b196=\"\"></label-group>\n                </div>\n            </div>\n        </div>\n        <div class=\"col-sm-1 col-xs-1 schedule-attendee\" _v-3298b196=\"\">\n            <span v-if=\"it.qty\" _v-3298b196=\"\">{{ it.qty.booking_qty }} / {{ it.qty.total }}</span>\n            <span v-else=\"\" _v-3298b196=\"\">\n                <a class=\"modal-link\" _v-3298b196=\"\">\n                    <img src=\"/images/default.png\" width=\"22\" heigh=\"22\" style=\"border-radius: 50px;\" alt=\"member\" _v-3298b196=\"\">\n                    <span :data-member-id=\"it.customer.id\" @mouseover.prevent=\"hoverOnName\" _v-3298b196=\"\">{{ it.customer.name }}</span>\n                </a>\n            </span>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.panel[_v-3298b196] {\n  margin-right: 10px;\n  margin-left: 10px;\n  box-shadow: none; }\n\n/* line 7, stdin */\n.panel-heading[_v-3298b196] {\n  font-size: 20px;\n  font-weight: 500; }\n  /* line 10, stdin */\n  .panel-heading span[_v-3298b196] {\n    font-size: 14px;\n    color: #767676;\n    margin: auto 10px; }\n\n/* line 16, stdin */\n.row[_v-3298b196] {\n  margin: 0;\n  padding-top: 11px;\n  padding-bottom: 11px; }\n  /* line 20, stdin */\n  .row.schedule-head[_v-3298b196] {\n    font-size: 16px;\n    font-weight: 500;\n    background: #86959f;\n    color: #ffffff; }\n  /* line 26, stdin */\n  .row.schedule-content[_v-3298b196] {\n    font-size: 15px;\n    margin-bottom: 2px;\n    cursor: pointer;\n    background: #fafafa;\n    border-bottom: dashed 1px #e5e5e5;\n    border-left: solid 5px #5eb95d; }\n    /* line 33, stdin */\n    .row.schedule-content.isClass[_v-3298b196] {\n      border-left: solid 5px #38afe3; }\n    /* line 36, stdin */\n    .row.schedule-content.isGreen[_v-3298b196] {\n      background: #e5eae5;\n      color: #0fb124; }\n    /* line 40, stdin */\n    .row.schedule-content .schedule-title[_v-3298b196] {\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis; }\n    /* line 45, stdin */\n    .row.schedule-content .isRed[_v-3298b196] {\n      color: #ff2600; }\n    /* line 48, stdin */\n    .row.schedule-content .fa-video-camera[_v-3298b196] {\n      color: #38afe3; }\n\n/* line 53, stdin */\n.flex-display[_v-3298b196] {\n  display: -ms-flexbox;\n  display: flex; }\n  /* line 55, stdin */\n  .flex-display .item[_v-3298b196] {\n    width: 50%;\n    margin-top: 0; }\n\n@media (max-width: 480px) {\n  /* line 61, stdin */\n  .panel[_v-3298b196] {\n    margin-left: 20px;\n    margin-right: 20px; }\n  /* line 65, stdin */\n  .panel-heading[_v-3298b196] {\n    padding: 10px 15px 10px 0; }\n  /* line 68, stdin */\n  .row[_v-3298b196] {\n    display: -ms-grid;\n    display: grid;\n    grid-gap: 5px;\n    -ms-grid-rows: 1fr 1fr 1fr;\n        grid-template-rows: 1fr 1fr 1fr;\n    -ms-grid-columns: 1fr 1fr;\n        grid-template-columns: 1fr 1fr;\n    grid-template-areas: \"date status\" \"title title\" \"provider attendee\"; }\n    /* line 69, stdin */\n    .row.schedule-head[_v-3298b196] {\n      display: none; }\n    /* line 81, stdin */\n    .row.schedule-content.isGreen[_v-3298b196] {\n      color: black; }\n    /* line 84, stdin */\n    .row.schedule-content div[_v-3298b196] {\n      width: 100%; }\n    /* line 87, stdin */\n    .row.schedule-content .schedule-time[_v-3298b196] {\n      grid-area: date; }\n    /* line 90, stdin */\n    .row.schedule-content .schedule-title[_v-3298b196] {\n      grid-area: title;\n      white-space: wrap; }\n    /* line 94, stdin */\n    .row.schedule-content .schedule-provider[_v-3298b196] {\n      grid-area: provider;\n      color: #606060; }\n    /* line 98, stdin */\n    .row.schedule-content .schedule-status[_v-3298b196] {\n      grid-area: status;\n      text-align: right; }\n      /* line 101, stdin */\n      .row.schedule-content .schedule-status span[_v-3298b196] {\n        color: #515151;\n        font-size: 10px;\n        word-break: keep-all; }\n        /* line 105, stdin */\n        .row.schedule-content .schedule-status span.isRed[_v-3298b196] {\n          color: #ff2600; }\n        /* line 108, stdin */\n        .row.schedule-content .schedule-status span.isGreen[_v-3298b196] {\n          color: #0fb124; }\n    /* line 113, stdin */\n    .row.schedule-content .schedule-attendee[_v-3298b196] {\n      grid-area: attendee;\n      text-align: right; }\n  /* line 119, stdin */\n  .flex-display[_v-3298b196] {\n    -ms-flex-direction: row-reverse;\n        flex-direction: row-reverse; } }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-3298b196", module.exports)
  } else {
    hotAPI.update("_v-3298b196", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],876:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 3, stdin */\n.group-act-btn[_v-2ea9fa38] {\n  color: #38b0e3;\n  font-size: 14px; }\n\n/* line 7, stdin */\n.icon-arrow[_v-2ea9fa38] {\n  color: #38b0e3; }\n\n/* line 10, stdin */\n.inner-div[_v-2ea9fa38] {\n  overflow: auto;\n  overflow-y: hidden;\n  border-collapse: collapse;\n  width: 100%; }\n\n/* line 16, stdin */\n.item-div[_v-2ea9fa38] {\n  margin-bottom: 12px;\n  border: 1px solid #D8D8D8;\n  border-left: 6px solid #01A9DB;\n  background-color: white;\n  width: 100%;\n  overflow: hidden;\n  font-size: 1.0em;\n  padding: 9px; }\n\n/* line 26, stdin */\n.inactive[_v-2ea9fa38] {\n  border-left-color: #D8D8D8;\n  color: #D8D8D8; }\n  /* line 29, stdin */\n  .inactive a[_v-2ea9fa38] {\n    color: #D8D8D8; }\n\n/* line 33, stdin */\n.group-div[_v-2ea9fa38] {\n  margin-top: 2px;\n  margin-bottom: 2px;\n  padding: 5px 10px 5px 10px; }\n\n/* line 38, stdin */\n.group-name[_v-2ea9fa38] {\n  font-size: 18px;\n  color: #111; }\n\n/* line 42, stdin */\n.maxHeight[_v-2ea9fa38] {\n  max-height: 100px;\n  overflow-y: hidden; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    // groups: [
    //     {
    //       id: 1,
    //       name: 'group1',
    //       items: [{id: 1, field1: '1', field2: '2', field3: '3', active: true},]
    //     }
    // ],
    props: {
        groups: Array,
        groupClick: Function,
        groupRemoveClick: Function,
        groupOrderChange: Function,
        itemCreateClick: Function,
        itemClick: Function,
        itemOrderChange: Function,
        createAllow: {
            default: 0
        },
        editAllow: {
            default: 0
        },
        removeAllow: {
            default: 0
        },
        editTitle: {
            default: 1
        },
        groupTxt: {
            type: String,
            default: '群組'
        },
        itemTxt: {
            type: String,
            default: '項目'
        },
        showFirstId: {
            default: -1
        }
    },
    data: function data() {
        return {
            id: null,
            position: null,
            displayFirst: true
        };
    },

    computed: {
        delGroupHelpTxt: function delGroupHelpTxt() {
            return '刪除此' + this.groupTxt;
        }
    },
    methods: {
        generateCollapseId: function generateCollapseId(group) {
            if (group.items.length == 0) {
                return '';
            }
            return 'collapse-' + group.id;
        },
        isExpanded: function isExpanded(index, group) {
            return index == 0 && group.items.length > 0;
        },
        generateGroupName: function generateGroupName(group) {
            return group.name + ' (' + group.items.length + ')';
        },
        setIdAndPositionAndChangeHeight: function setIdAndPositionAndChangeHeight(event, ui) {
            var $target = $(ui.item);
            $sortableDiv = $target.closest('.sortable');
            $sortableDiv.find('> div').addClass('maxHeight');
            $target.closest('.sortable').sortable('refreshPositions');
        },
        selfGroupOrderChange: function selfGroupOrderChange(event, ui) {
            var $target = $(ui.item);
            $sortableDiv = $target.closest('.sortable');
            $sortableDiv.find('> div').removeClass('maxHeight');
            var gids = $(this.$el).find('div.group').map(function (i, e) {
                return $(e).data('group-id');
            });
            this.groupOrderChange(gids.toArray());
        },
        selfItemOrderChange: function selfItemOrderChange(event, ui) {
            var $target = $(ui.item);
            var iids = $(this.$el).find('#collapse-' + $target.data('group-id') + ' div.item-div').map(function (i, e) {
                return $(e).data('item-id');
            });
            this.itemOrderChange($target.data('group-id'), iids.toArray());
        },
        bindSortable: function bindSortable() {
            var _this = this;

            var outerInterval = setInterval(function () {
                if ($(".sortable.outer-div").length > 0) {
                    clearInterval(outerInterval);
                    $(".sortable.outer-div").sortable({
                        placeholder: "sortable-outer-highlight",
                        start: _this.setIdAndPositionAndChangeHeight.bind(_this),
                        stop: _this.selfGroupOrderChange.bind(_this),
                        cursor: "move",
                        cancel: "a,button",
                        scroll: false,
                        axis: "y",
                        distance: 1
                    }).disableSelection();
                }
            }, 100);
            var innerInterval = setInterval(function () {
                if ($(".sortable.inner-div").length > 0) {
                    clearInterval(innerInterval);
                    $(".sortable.inner-div").sortable({
                        placeholder: "sortable-inner-highlight",
                        start: _this.setIdAndPositionAndChangeHeight.bind(_this),
                        stop: _this.selfItemOrderChange.bind(_this),
                        cursor: "move",
                        cancel: "a,button",
                        scroll: false,
                        axis: "y",
                        distance: 1
                    }).disableSelection();
                }
            }, 100);
        },
        bindAccordion: function bindAccordion() {
            $('.collapsible-group').on('hide.bs.collapse', function (e) {
                $(e.target).prev().find('i.icon-arrow').removeClass('fa-angle-down').addClass('fa-angle-right');
            }).on('show.bs.collapse', function (e) {
                $(e.target).prev().find('i.icon-arrow').removeClass('fa-angle-right').addClass('fa-angle-down');
            });
        },
        showFirst: function showFirst() {
            if (!this.displayFirst || this.groups.length <= 0) return;
            var id = this.generateCollapseId(this.groups[0]);
            if (id === '') return;
            $('#' + id).collapse('show');
            this.displayFirst = false;
        }
    },
    watch: {
        showFirstId: function showFirstId() {
            this.displayFirst = true;
        },
        groups: function groups() {
            var _this2 = this;

            if (this.editAllow) {
                this.bindSortable();
            }
            this.bindAccordion();
            this.$nextTick(function () {
                _this2.showFirst();
            });
        }
    },
    mounted: function mounted() {
        this.$nextTick(function () {
            if (this.editAllow) {
                this.bindSortable();
            }
        });
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div v-show=\"groups.length\" _v-2ea9fa38=\"\">\n    <div class=\"collapsible-group panel-group outer-div sortable\" role=\"tablist\" aria-multiselectable=\"true\" _v-2ea9fa38=\"\">\n        <div v-for=\"(g, i) in groups\" :data-group-id=\"g.id\" :key=\"g.id\" class=\"group panel panel-default\" _v-2ea9fa38=\"\">\n            <div class=\"panel-heading\" role=\"tab\" data-toggle=\"collapse\" :href=\"'#' + generateCollapseId(g)\" aria-controls=\"generateCollapseId(g)\" _v-2ea9fa38=\"\">\n                <h4 class=\"panel-title\" _v-2ea9fa38=\"\">\n                    <i class=\"icon-arrow fa fa-lg fa-angle-right\" aria-hidden=\"true\" _v-2ea9fa38=\"\"></i>&nbsp; <a class=\"group-name\" v-text=\"generateGroupName(g)\" _v-2ea9fa38=\"\">\n                    </a>\n                    <button class=\"btn btn-xs btn-info edit-btn\" v-if=\"editAllow &amp;&amp; editTitle\" @click.prevent.stop=\"groupClick(g)\" _v-2ea9fa38=\"\">\n                        <small style=\"color:#fff\" _v-2ea9fa38=\"\">編輯</small>\n                    </button>\n                    <button class=\"btn btn-xs btn-danger pull-right\" :help=\"delGroupHelpTxt\" @click=\"groupRemoveClick(g)\" v-if=\"removeAllow\" _v-2ea9fa38=\"\">\n                        <i class=\"fa fa-trash\" _v-2ea9fa38=\"\"></i>\n                    </button>\n                    <a class=\"pull-right group-act-btn\" @click.prevent.stop=\"itemCreateClick(g)\" v-if=\"createAllow\" _v-2ea9fa38=\"\">\n                        + 新增{{ itemTxt }}\n                    </a>\n                </h4>\n            </div>\n            <div :id=\"generateCollapseId(g)\" class=\"panel-collapse collapse\" role=\"tabpanel\" _v-2ea9fa38=\"\">\n                <div class=\"panel-body inner-div sortable\" _v-2ea9fa38=\"\">\n                    <div v-for=\"i in g.items\" :key=\"i.id\" class=\"item-div\" :class=\"{inactive: !i.active}\" :data-item-id=\"i.id\" :data-group-id=\"g.id\" _v-2ea9fa38=\"\">\n                        <div class=\"col-sm-3\" style=\"cursor: pointer;\" @click=\"itemClick(i)\" _v-2ea9fa38=\"\">\n                           <a v-if=\"editAllow\" v-html=\"i.field1\" _v-2ea9fa38=\"\"></a>\n                           <a v-else=\"\" v-html=\"i.field1\" _v-2ea9fa38=\"\"></a>\n                        </div>\n                        <div class=\"col-sm-2 col-sm-offset-2\" v-html=\"i.field2\" _v-2ea9fa38=\"\"></div>\n                        <div class=\"col-sm-2\" v-html=\"i.field3\" _v-2ea9fa38=\"\"></div>\n                        <div v-if=\"i.field4\" class=\"col-sm-2\" v-html=\"i.field4\" _v-2ea9fa38=\"\"></div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 3, stdin */\n.group-act-btn[_v-2ea9fa38] {\n  color: #38b0e3;\n  font-size: 14px; }\n\n/* line 7, stdin */\n.icon-arrow[_v-2ea9fa38] {\n  color: #38b0e3; }\n\n/* line 10, stdin */\n.inner-div[_v-2ea9fa38] {\n  overflow: auto;\n  overflow-y: hidden;\n  border-collapse: collapse;\n  width: 100%; }\n\n/* line 16, stdin */\n.item-div[_v-2ea9fa38] {\n  margin-bottom: 12px;\n  border: 1px solid #D8D8D8;\n  border-left: 6px solid #01A9DB;\n  background-color: white;\n  width: 100%;\n  overflow: hidden;\n  font-size: 1.0em;\n  padding: 9px; }\n\n/* line 26, stdin */\n.inactive[_v-2ea9fa38] {\n  border-left-color: #D8D8D8;\n  color: #D8D8D8; }\n  /* line 29, stdin */\n  .inactive a[_v-2ea9fa38] {\n    color: #D8D8D8; }\n\n/* line 33, stdin */\n.group-div[_v-2ea9fa38] {\n  margin-top: 2px;\n  margin-bottom: 2px;\n  padding: 5px 10px 5px 10px; }\n\n/* line 38, stdin */\n.group-name[_v-2ea9fa38] {\n  font-size: 18px;\n  color: #111; }\n\n/* line 42, stdin */\n.maxHeight[_v-2ea9fa38] {\n  max-height: 100px;\n  overflow-y: hidden; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-2ea9fa38", module.exports)
  } else {
    hotAPI.update("_v-2ea9fa38", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],877:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _serviceLayout = require('../partials/service-layout.vue');

var _serviceLayout2 = _interopRequireDefault(_serviceLayout);

var _bannerAlert = require('../partials/banner-alert.vue');

var _bannerAlert2 = _interopRequireDefault(_bannerAlert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        'service-layout': _serviceLayout2.default,
        'banner-alert': _bannerAlert2.default
    },
    data: function data() {
        return {
            showFB: false,
            ajaxingFB: false,
            urlDestUrl: '',
            errorMessage: '',
            successUrl: ''
        };
    },
    mounted: function mounted() {
        var urlParams = new URLSearchParams(window.location.search);
        this.showFB = urlParams.get('show_fb') ? Number(urlParams.get('show_fb')) : 0;
        if (urlParams.get('error_message')) {
            this.errorMessage = urlParams.get('error_message');
            $17.removeSelectedUrlPara('error_message');
        }
        if (urlParams.get('dest_url')) {
            this.urlDestUrl = urlParams.get('dest_url');
            $17.removeSelectedUrlPara('dest_url');
        } else if (urlParams.get('cancel_url')) {
            this.urlDestUrl = urlParams.get('cancel_url');
        }
    },

    methods: {
        login: function login() {
            window.open('/account/login' + window.location.search, '_self');
        },
        register: function register() {
            window.open('/account/register' + window.location.search, '_self');
        },
        loginByFb: function loginByFb() {
            try {
                this.ajaxingFB = true;
                this.$refs.loginFormFB.login();
            } catch (error) {
                this.ajaxingFB = false;
            }
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div>\n    <v-spinner :ajaxing=\"ajaxingFB\"></v-spinner>\n    <service-layout v-show=\"!ajaxingFB\" title=\"帳戶服務\">\n        <div class=\"st-space-y-7 st-pt-7\">\n            <banner-alert v-if=\"errorMessage\" :message=\"errorMessage\"></banner-alert>\n            <div class=\"st-text-20 st-text-black st-font-medium\">請先登入 17FIT 帳戶</div>\n            <div>\n                <st-button primary=\"\" full=\"\" filled=\"\" text=\"登入\" @click=\"login\"></st-button>\n            </div>\n            <div class=\"st-flex st-items-center\">\n                <div class=\"st-w-full st-h-px st-bg-gray-40\"></div>\n                <div class=\"st-mx-3 st-text-16 st-text-gray-90\">或</div>\n                <div class=\"st-w-full st-h-px st-bg-gray-40\"></div>\n            </div>\n            <div>\n                <st-button neutral=\"\" full=\"\" outline=\"\" text=\"註冊\" @click=\"register\"></st-button>\n            </div>\n            <div v-if=\"showFB\">\n                <st-button neutral=\"\" full=\"\" outline=\"\" @click=\"loginByFb\">\n                    <div class=\"st-flex st-items-center\">\n                        <img src=\"/images/facebook.svg\" class=\"st-mr-2\">\n                        使用 Facebook 帳號繼續\n                    </div>\n                </st-button>\n            </div>\n            <div class=\"st-text-16 st-text-gray-90 st-font-regular\">\n                登入後即代表您已同意本系統之\n                <a class=\"st-text-info hover:st-text-info\" href=\"/studio-terms-of-use\" target=\"_blank\">《使用者條款》</a>\n                及\n                <a class=\"st-text-info hover:st-text-info\" href=\"/studio-privacy-policy\" target=\"_blank\">《隱私權條款》</a>。\n            </div>\n        </div>\n    </service-layout>\n    <socialite-login-hidden-form ref=\"loginFormFB\" platform-define=\"fb\" :dest-url=\"urlDestUrl\"></socialite-login-hidden-form>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-2016b32a", module.exports)
  } else {
    hotAPI.update("_v-2016b32a", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"../partials/banner-alert.vue":884,"../partials/service-layout.vue":887,"vue":792,"vue-hot-reload-api":785}],878:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _serviceLayout = require('../partials/service-layout.vue');

var _serviceLayout2 = _interopRequireDefault(_serviceLayout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        'service-layout': _serviceLayout2.default
    },
    props: {
        member: {
            type: Object,
            required: true
        },
        continueUrl: {
            type: String,
            required: true
        }
    },
    data: function data() {
        return {
            ajaxing: false
        };
    },
    mounted: function mounted() {},

    methods: {
        toContinue: function toContinue() {
            window.open(this.continueUrl, '_self');
        },
        logout: function logout() {
            var _this = this;

            this.ajaxing = true;
            this.$http.post('/webapi/account/logout').then(function (response) {
                window.open('/account' + window.location.search, '_self');
            }, function (error) {
                _this.ajaxing = false;
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div>\n    <v-spinner :ajaxing=\"ajaxing\"></v-spinner>\n    <service-layout v-show=\"!ajaxing\" title=\"帳戶服務\">\n        <div class=\"st-space-y-7 st-pt-7\">\n            <template v-if=\"Object.keys(member).length\">\n                <div class=\"st-flex st-items-center st-space-x-2\">\n                    <span class=\"st-text-20 st-text-black st-font-medium\">你已登入 17FIT</span>\n                </div>\n\n                <div class=\"st-flex st-justify-center st-items-center st-flex-col\">\n                    <div class=\"st-flex st-justify-center st-items-center st-flex-col\">\n                        <img v-if=\"member.picture_path\" :src=\"member.picture_path\" class=\"st-border st-border-gray-40 st-border-solid\" style=\"border-radius: 50%\" width=\"84\" height=\"84\" alt=\"avatar\">\n                        <div class=\"st-mt-3 st-text-18 st-text-black\">{{ member.name }}</div>\n                        <div class=\"st-mt-2 st-text-16\">{{ member.account }}</div>\n                    </div>\n                </div>\n\n                <div class=\"st-flex st-justify-center\">\n                    <div class=\"st-text-18 st-text-black st-font-medium\">使用此帳號繼續？</div>\n                </div>\n\n                <div class=\"st-space-y-4\">\n                    <st-button primary=\"\" full=\"\" filled=\"\" text=\"繼續\" @click=\"toContinue\"></st-button>\n                    <st-button danger=\"\" full=\"\" outline=\"\" text=\"登出此帳號\" @click=\"logout\"></st-button>\n                </div>\n            </template>\n        </div>\n    </service-layout>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-78be3bc8", module.exports)
  } else {
    hotAPI.update("_v-78be3bc8", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"../partials/service-layout.vue":887,"vue":792,"vue-hot-reload-api":785}],879:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _index = require('./index.vue');

var _index2 = _interopRequireDefault(_index);

var _register = require('./register.vue');

var _register2 = _interopRequireDefault(_register);

var _login = require('./login.vue');

var _login2 = _interopRequireDefault(_login);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('account-service-index', _index2.default);
_vue2.default.component('account-service-register', _register2.default);
_vue2.default.component('account-service-login', _login2.default);

},{"./index.vue":880,"./login.vue":881,"./register.vue":888,"vue":792}],880:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _init = require('./entrance/init.vue');

var _init2 = _interopRequireDefault(_init);

var _logged = require('./entrance/logged.vue');

var _logged2 = _interopRequireDefault(_logged);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        'init-page': _init2.default,
        'logged-page': _logged2.default
    },
    data: function data() {
        return {
            ajaxing: true,
            component: 'init-page',
            member: {},
            continueUrl: ''
        };
    },
    mounted: function mounted() {
        this.checkAuth();
    },

    methods: {
        checkAuth: function checkAuth() {
            var _this = this;

            this.ajaxing = true;
            this.$http.get('/webapi/account/login-token').then(function () {
                var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(response) {
                    var token, urlParams, successUrl, successUrlObj;
                    return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _this.member = response.data.data.member;

                                    token = response.data.data.token;
                                    urlParams = new URLSearchParams(window.location.search);
                                    _context.t0 = urlParams.get('success_url');

                                    if (_context.t0) {
                                        _context.next = 8;
                                        break;
                                    }

                                    _context.next = 7;
                                    return _this.defaultAuthorizationJwtPath();

                                case 7:
                                    _context.t0 = _context.sent;

                                case 8:
                                    successUrl = _context.t0;
                                    successUrlObj = new URL(successUrl);

                                    successUrlObj.searchParams.set('token', token);
                                    _this.continueUrl = successUrlObj.href;
                                    _this.component = 'logged-page';

                                    _this.$nextTick(function () {
                                        _this.ajaxing = false;
                                    });

                                case 14:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this);
                }));

                return function (_x) {
                    return _ref.apply(this, arguments);
                };
            }(), function (error) {
                _this.ajaxing = false;
            });
        },
        defaultAuthorizationJwtPath: function defaultAuthorizationJwtPath() {
            var domain = location.protocol + '//' + location.host;
            var authRedirectPath = domain + '/authorization/jwt?';
            return authRedirectPath += 'success_url=' + domain + '&fail_url=' + domain;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div>\n    <v-spinner :ajaxing=\"ajaxing\"></v-spinner>\n    <component v-show=\"!ajaxing\" :is=\"component\" :member=\"member\" :continue-url=\"continueUrl\"></component>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-7d229bb3", module.exports)
  } else {
    hotAPI.update("_v-7d229bb3", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"./entrance/init.vue":877,"./entrance/logged.vue":878,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785}],881:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _serviceLayout = require('./partials/service-layout.vue');

var _serviceLayout2 = _interopRequireDefault(_serviceLayout);

var _account = require('./login/account.vue');

var _account2 = _interopRequireDefault(_account);

var _password = require('./login/password.vue');

var _password2 = _interopRequireDefault(_password);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        'service-layout': _serviceLayout2.default,
        'login-account': _account2.default,
        'login-password': _password2.default
    },
    data: function data() {
        return {
            currentStep: 1,
            config: {
                step1: 'login-account',
                step2: 'login-password'
            },
            style: {
                subtitle: 'st-text-black st-text-16 st-font-medium',
                content: 'st-text-gray-90 st-text-16 st-font-regular'
            },
            formData: {
                location: 'TW'
            }
        };
    },

    methods: {
        confirm: function confirm(params) {
            if (this.currentStep < 2) {
                this.next(params);
            }
        },
        next: function next(params) {
            (0, _assign2.default)(this.formData, params);
            this.currentStep += 1;
        },
        register: function register() {
            window.open('/account' + window.location.search, '_self');
        },
        forgotPassword: function forgotPassword() {
            window.open('/forgot-password', '_self');
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div>\n    <service-layout title=\"帳戶服務\">\n        <div class=\"st-space-y-7 st-pt-7\">\n            <div class=\"st-flex st-items-center st-space-x-2\">\n                <span class=\"st-text-20 st-text-black st-font-medium\">登入</span>\n            </div>\n            <keep-alive>\n                <component :is=\"config['step'+currentStep]\" :form-data=\"formData\" :form-style=\"style\" @confirm=\"confirm\"></component>\n            </keep-alive>\n            <div class=\"st-text-info st-text-16 st-flex st-justify-between\">\n                <div class=\"st-text-info st-text-16 st-cursor-pointer\" @click=\"register\">註冊新帳號</div>\n                <div class=\"st-text-info st-text-16 st-cursor-pointer\" @click=\"forgotPassword\">忘記密碼</div>\n            </div>\n        </div>\n    </service-layout>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-46ca3eca", module.exports)
  } else {
    hotAPI.update("_v-46ca3eca", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"./login/account.vue":882,"./login/password.vue":883,"./partials/service-layout.vue":887,"babel-runtime/core-js/object/assign":50,"vue":792,"vue-hot-reload-api":785}],882:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        formStyle: {
            type: Object
        },
        formData: {
            type: Object
        }
    },
    data: function data() {
        return {
            form: {
                account: '',
                remember_me: true
            },
            validate: {
                length: {
                    message: '輸入的字數已超過上限 200 字',
                    value: 200
                },
                required: {
                    message: '',
                    value: true
                }
            },
            isValid: true,
            formError: {}
        };
    },

    watch: {
        'form.account': {
            handler: function handler(newVal) {
                this.isValid = this.checkValidation(newVal);
            }
        }
    },
    methods: {
        confirm: function confirm() {
            var _this = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this.checkValidation(_this.form.account);

                            case 2:
                                _this.isValid = _context.sent;

                                if (_this.isValid) {
                                    _this.$emit('confirm', _this.form);
                                }

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        checkValidation: function checkValidation(account) {
            var accountRegex = /^[a-zA-Z0-9\.\-_@]+$/;
            if (!account) {
                this.formError = this.validate.required;
                return false;
            }
            if (!accountRegex.test(account)) {
                this.formError = {};
                return false;
            }
            if (account.length > this.validate.length.value) {
                this.formError = this.validate.length;
                return false;
            }
            this.formError = {};
            return true;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"st-space-y-7\">\n    <div>\n        <st-input label=\"信箱/手機/使用者帳號\" :error=\"!isValid\" :error-text=\"formError.message\" v-model=\"form.account\" @keyup.enter=\"confirm\"></st-input>\n    </div>\n    <div>\n        <st-checkbox name=\"remember_me\" label=\"保持登入\" :input-class=\"['st-appearance-auto']\" :model.sync=\"form.remember_me\"></st-checkbox>\n    </div>        \n    <div>\n        <st-button primary=\"\" filled=\"\" full=\"\" text=\"下一步\" right-icon=\"arrow_forward\" :disabled=\"!isValid\" @click=\"confirm\"></st-button>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-3a1c1630", module.exports)
  } else {
    hotAPI.update("_v-3a1c1630", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785}],883:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _bannerAlert = require('../partials/banner-alert.vue');

var _bannerAlert2 = _interopRequireDefault(_bannerAlert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        'banner-alert': _bannerAlert2.default
    },
    props: {
        formStyle: {
            type: Object
        },
        formData: {
            type: Object
        }
    },
    data: function data() {
        return {
            form: {
                password: '',
                remember_me: true
            },
            visible: false,
            isValid: true,
            formError: {},
            ajaxing: false,
            ajaxingError: {}
        };
    },

    watch: {
        'form.password': {
            handler: function handler(newVal) {
                this.isValid = this.checkValidation(newVal);
            }
        }
    },
    methods: {
        checkerStyle: function checkerStyle(bool) {
            var style = 'st-flex st-items-center st-text-14 st-font-regular';
            if (bool) {
                return 'st-text-success ' + style;
            } else {
                return 'st-text-gray-90 ' + style;
            }
        },
        confirm: function confirm() {
            var _this = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return _this.checkValidation(_this.form.password);

                            case 2:
                                _this.isValid = _context2.sent;

                                if (_this.isValid) {
                                    _this.ajaxing = true;
                                    _this.ajaxingError = {};
                                    _this.$http.post('/webapi/account/login', (0, _extends3.default)({}, _this.formData, _this.form)).then(function () {
                                        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(response) {
                                            var token, urlParams, successUrl, successUrlObj;
                                            return _regenerator2.default.wrap(function _callee$(_context) {
                                                while (1) {
                                                    switch (_context.prev = _context.next) {
                                                        case 0:
                                                            token = response.data.data.token;
                                                            urlParams = new URLSearchParams(window.location.search);
                                                            _context.t0 = urlParams.get('success_url');

                                                            if (_context.t0) {
                                                                _context.next = 7;
                                                                break;
                                                            }

                                                            _context.next = 6;
                                                            return _this.defaultAuthorizationJwtPath();

                                                        case 6:
                                                            _context.t0 = _context.sent;

                                                        case 7:
                                                            successUrl = _context.t0;
                                                            successUrlObj = new URL(successUrl);

                                                            successUrlObj.searchParams.set('token', token);
                                                            window.open(successUrlObj.href, '_self');

                                                        case 11:
                                                        case 'end':
                                                            return _context.stop();
                                                    }
                                                }
                                            }, _callee, _this);
                                        }));

                                        return function (_x) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }(), function (error) {
                                        _this.ajaxingError = error.data;
                                        _this.isValid = false;
                                        _this.ajaxing = false;
                                    });
                                }

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this);
            }))();
        },
        checkValidation: function checkValidation(password) {
            return password.length > 0 && password.length <= 30;
        },
        toggleVisible: function toggleVisible() {
            this.visible = !this.visible;
        },
        defaultAuthorizationJwtPath: function defaultAuthorizationJwtPath() {
            var domain = location.protocol + '//' + location.host;
            var authRedirectPath = domain + '/authorization/jwt?';
            return authRedirectPath += 'success_url=' + domain + '&fail_url=' + domain;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"st-space-y-7\">\n    <banner-alert v-show=\"ajaxingError.code\" :message=\"ajaxingError.message\" :ajaxing-error=\"ajaxingError\"></banner-alert>\n    <div>\n        <st-input label=\"密碼\" :type=\"visible ? 'text':'password'\" :error=\"!isValid\" :error-text=\"formError.message\" :disabled=\"ajaxing\" v-model=\"form.password\" @keyup.enter=\"confirm\">\n            <span slot=\"icon\" class=\"st-text-primary st-cursor-pointer\" @click=\"toggleVisible\">\n                <span class=\"material-icons\" v-if=\"visible\">visibility</span>\n                <span class=\"material-icons\" v-else=\"\">visibility_off</span>\n            </span>\n        </st-input>\n    </div>\n    <div>\n        <st-checkbox name=\"remember_me\" label=\"保持登入\" :input-class=\"['st-appearance-auto']\" :model.sync=\"form.remember_me\"></st-checkbox>\n    </div>\n    <div>\n        <st-button primary=\"\" filled=\"\" full=\"\" text=\"登入\" :disabled=\"!isValid || ajaxing\" :loading=\"ajaxing\" @click=\"confirm\"></st-button>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-5eabe570", module.exports)
  } else {
    hotAPI.update("_v-5eabe570", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"../partials/banner-alert.vue":884,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785}],884:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        message: String,
        ajaxingError: {
            type: Object,
            default: function _default() {
                return {
                    code: "none",
                    message: ""
                };
            }
        }
    },
    data: function data() {
        return {
            text: false
        };
    },

    watch: {
        'ajaxingError.code': {
            handler: function handler(newVal) {
                var errCode = newVal;
                if (errCode && this.$errorIdentifiable.includes(errCode)) {
                    this.text = i18n.t("error.msg." + errCode);
                } else if (this.message) {
                    this.text = this.message;
                } else {
                    this.text = '發生錯誤，請重新嘗試';
                }
            }
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"st-bg-red/20 st-border st-border-red st-border-solid st-p-3 st-rounded-4 st-text-danger st-w-full\">\n    <div class=\"st-flex st-items-center st-justify-between\">\n        <div class=\"st-flex st-items-center\">\n            <span class=\"material-icons st-mr-2\">error</span>\n            <span class=\"st-text-16\">{{ text }}</span>\n        </div>\n        <div>\n            <slot name=\"action\"></slot>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-a41b1d8e", module.exports)
  } else {
    hotAPI.update("_v-a41b1d8e", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],885:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        pageName: {
            type: String,
            default: ''
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"st-flex st-justify-center st-my-4\">\n    <div v-if=\"pageName\" class=\"st-flex st-items-center\">\n        <img src=\"/images/17fit-auth.png\" class=\"st-w-5 st-h-5\">\n        <span class=\"st-text-14 st-text-gray-90\">{{ pageName }}</span>\n    </div>\n    <div v-if=\"pageName\" class=\"st-h-5 st-w-px st-bg-gray-40 st-mx-3\"></div>\n    <div class=\"st-flex st-items-center\">\n        <span class=\"material-icons st-pr-1 st-text-20\">language</span>\n        繁體中文 (TW)\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-5b8fe646", module.exports)
  } else {
    hotAPI.update("_v-5b8fe646", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],886:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        modalId: {
            default: 'general-alert-modal'
        },
        modalSize: {
            default: 'modal-md'
        },
        title: {
            default: ''
        },
        hiddenFooter: Boolean
    },
    methods: {
        show: function show() {
            $('#' + this.modalId).modal('show');
        },
        close: function close() {
            $('#' + this.modalId).modal('hide');
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"modal fade\" role=\"dialog\" :id=\"modalId\" :data-backdrop=\"true\" :data-keyboard=\"true\">\n    <div class=\"modal-dialog \" :class=\"modalSize\" role=\"document\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header st-border-b-0\">\n                <span class=\"material-icons close st-pt-1\" aria-label=\"Close\" @click=\"close\">close</span>\n                <slot name=\"title\">\n                    <div class=\"st-text-black st-text-20 st-font-medium\">{{ title }}</div>\n                </slot>\n            </div>\n            <div class=\"modal-body\">\n                <slot name=\"body\"></slot>\n            </div>\n            <div class=\"modal-footer\" v-if=\"!hiddenFooter\">\n                <slot name=\"footer\"></slot>\n            </div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-1c4f74df", module.exports)
  } else {
    hotAPI.update("_v-1c4f74df", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],887:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _languageSwitchFooter = require('./language-switch-footer.vue');

var _languageSwitchFooter2 = _interopRequireDefault(_languageSwitchFooter);

var _modal = require('./modal.vue');

var _modal2 = _interopRequireDefault(_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        'language-switch-footer': _languageSwitchFooter2.default,
        'alert-modal': _modal2.default
    },
    props: {
        title: {
            type: String,
            default: ''
        }
    },
    data: function data() {
        return {
            style: {
                responsiveContent: 'st-mx-auto st-max-w-sm st-w-full st-px-3.5'
            }
        };
    },
    mounted: function mounted() {},

    methods: {
        cancel: function cancel() {
            this.$refs.alert_modal.show();
        },
        backEdit: function backEdit() {
            this.$refs.alert_modal.close();
        },
        confirmSkip: function confirmSkip() {
            var urlParams = new URLSearchParams(window.location.search);
            var cancelUrl = location.origin + '/account';
            if (urlParams.get('cancel_url')) {
                cancelUrl = urlParams.get('cancel_url');
            }
            window.open(cancelUrl, '_self');
            this.$refs.alert_modal.close();
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"st-h-screen st-flex st-flex-col\">\n    <div class=\"st-w-full st-h-2 st-bg-brand-light\"></div>\n    <div :class=\"[style.responsiveContent]\">\n        <div class=\"st-flex st-items-center st-justify-between st-py-3.5\">\n            <div class=\"st-font-medium st-text-24 st-text-brand-light\">{{ title }}</div>\n            <slot name=\"action\">\n                <div class=\"st-cursor-pointer st-text-14 st-underline st-text-gray-90\" @click=\"cancel\">取消\n                </div>\n            </slot>\n        </div>\n    </div>\n    <div class=\"st-w-full st-h-px st-bg-gray-40\"></div>\n    <div :class=\"[style.responsiveContent, 'st-overflow-auto', 'st-flex-grow']\">\n        <slot></slot>\n    </div>\n    <div :class=\"[style.responsiveContent]\">\n        <language-switch-footer page-name=\"17FIT 帳戶服務\"></language-switch-footer>\n    </div>\n    <alert-modal ref=\"alert_modal\" modal-id=\"AccountManagementCancel\" :hidden-footer=\"true\" modal-size=\"modal-sm\" title=\"是否取消帳戶服務？\">\n        <div slot=\"body\">\n            <div class=\"st-flex st-justify-end\">\n                <st-button ghost=\"\" text=\"關閉\" @click=\"backEdit\"></st-button>\n                <st-button primary=\"\" filled=\"\" normal=\"\" text=\"確認\" @click=\"confirmSkip\"></st-button>\n            </div>\n        </div>\n    </alert-modal>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-d56b9c00", module.exports)
  } else {
    hotAPI.update("_v-d56b9c00", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"./language-switch-footer.vue":885,"./modal.vue":886,"vue":792,"vue-hot-reload-api":785}],888:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _serviceLayout = require('./partials/service-layout.vue');

var _serviceLayout2 = _interopRequireDefault(_serviceLayout);

var _name = require('./register/name.vue');

var _name2 = _interopRequireDefault(_name);

var _email = require('./register/email.vue');

var _email2 = _interopRequireDefault(_email);

var _telephone = require('./register/telephone.vue');

var _telephone2 = _interopRequireDefault(_telephone);

var _userAccount = require('./register/user-account.vue');

var _userAccount2 = _interopRequireDefault(_userAccount);

var _password = require('./register/password.vue');

var _password2 = _interopRequireDefault(_password);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        'service-layout': _serviceLayout2.default,
        'register-name': _name2.default,
        'register-email': _email2.default,
        'register-telephone': _telephone2.default,
        'register-user-account': _userAccount2.default,
        'register-password': _password2.default
    },
    data: function data() {
        return {
            currentStep: 1,
            config: {
                step1: 'register-name',
                step2: 'register-email',
                step3: 'register-telephone',
                step4: 'register-user-account',
                step5: 'register-password'
            },
            style: {
                subtitle: 'st-text-black st-text-16 st-font-medium',
                content: 'st-text-gray-90 st-text-16 st-font-regular'
            },
            formData: {},
            showFB: false
        };
    },
    mounted: function mounted() {
        // FB 佔沿用舊畫面
        // const urlParams = new URLSearchParams(window.location.search);
        // this.showFB = urlParams.get('show_fb') ? Number(urlParams.get('show_fb')) : 0;
    },

    methods: {
        confirm: function confirm(params) {
            if (this.currentStep < 5) {
                this.next(params);
            }
        },
        next: function next(params) {
            (0, _assign2.default)(this.formData, params);
            this.currentStep += 1;
        },
        skip: function skip() {
            var _this = this;

            var paramsArr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

            paramsArr.forEach(function (item) {
                if (_this.formData.hasOwnProperty(item)) {
                    delete _this.formData[item];
                }
            });
            this.currentStep += 1;
        },
        preStep: function preStep() {
            this.currentStep -= 1;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div>\n    <service-layout title=\"帳戶服務\">\n        <div class=\"st-space-y-7 st-pt-7\">\n            <div>\n                <div class=\"st-flex st-items-center st-space-x-2\">\n                    <span v-if=\"currentStep>1\" class=\"material-icons st-cursor-pointer\" @click=\"preStep\">arrow_back</span>\n                    <span class=\"st-bg-brand-light st-px-2 st-py-0.5 st-rounded-16 st-text-14 st-text-white\">{{ currentStep }}/5</span>\n                    <span v-if=\"!showFB\" class=\"st-text-20 st-text-black st-font-medium\">註冊</span>\n                </div>       \n                <div v-if=\"showFB\" class=\"st-mt-2 st-text-20 st-text-black st-font-medium st-flex st-items-center\">\n                    <img src=\"/images/facebook.svg\" class=\"st-mr-2\">\n                    使用 Facebook 進行註冊\n                </div>\n            </div>\n            <keep-alive>\n                <component :is=\"config['step'+currentStep]\" :form-data=\"formData\" :form-style=\"style\" @skip=\"skip\" @confirm=\"confirm\"></component>                \n            </keep-alive>\n        </div>\n    </service-layout>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-b05c245c", module.exports)
  } else {
    hotAPI.update("_v-b05c245c", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"./partials/service-layout.vue":887,"./register/email.vue":889,"./register/name.vue":890,"./register/password.vue":891,"./register/telephone.vue":892,"./register/user-account.vue":893,"babel-runtime/core-js/object/assign":50,"vue":792,"vue-hot-reload-api":785}],889:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _bannerAlert = require('../partials/banner-alert.vue');

var _bannerAlert2 = _interopRequireDefault(_bannerAlert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        'banner-alert': _bannerAlert2.default
    },
    props: {
        formStyle: {
            type: Object
        },
        formData: {
            type: Object
        }
    },
    data: function data() {
        return {
            form: {
                email: ''
            },
            validate: {
                length: {
                    message: '輸入的字數已超過上限 50 字',
                    value: 50
                }
            },
            isValid: true,
            formError: {},
            ajaxing: false,
            ajaxingError: {}
        };
    },

    watch: {
        'form.email': {
            handler: function handler(newVal) {
                this.isValid = this.checkValidation(newVal);
            }
        }
    },
    methods: {
        reset: function reset() {
            this.formError = {};
            this.form.email = '';
            this.isValid = true;
        },
        confirm: function confirm() {
            var _this = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this.checkValidation(_this.form.email);

                            case 2:
                                _this.isValid = _context.sent;

                                if (_this.isValid) {
                                    _this.ajaxing = true;
                                    _this.ajaxingError = {};
                                    _this.$http.post('/webapi/account/email/register-available', _this.form).then(function (response) {
                                        _this.$emit('confirm', {
                                            email: _this.form.email,
                                            account: _this.form.email
                                        });
                                        _this.ajaxing = false;
                                    }, function (error) {
                                        _this.ajaxingError = error.data;
                                        _this.isValid = false;
                                        _this.ajaxing = false;
                                    });
                                }

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        checkValidation: function checkValidation(email) {
            var emailRegex = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/;
            var forbiddenDomain = '17fit.anonymous';
            var emailDomain = email.split('@')[1];
            if (!emailRegex.test(email)) {
                this.formError = {};
                return false;
            }
            if (emailDomain == forbiddenDomain) {
                this.formError = {};
                return false;
            }
            if (email.length > this.validate.length.value) {
                this.formError = this.validate.length;
                return false;
            }
            this.formError = {};
            return true;
        },
        skip: function skip() {
            this.reset();
            this.$emit('skip', ['email']);
        },
        forwardAccount: function forwardAccount() {
            window.open('/account' + window.location.search, '_self');
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"st-space-y-7\">\n    <banner-alert v-show=\"ajaxingError.code\" :message=\"ajaxingError.message\" :ajaxing-error=\"ajaxingError\">\n        <div slot=\"action\">\n            <st-button danger=\"\" outline=\"\" small=\"\" @click=\"forwardAccount\" text=\"前往登入\" :btn-class=\"['st-border-0 st-text-12']\"></st-button>\n        </div>\n    </banner-alert>\n    <div>\n        <div :class=\"formStyle.subtitle\">請輸入電子信箱</div>\n        <div :class=\"formStyle.content\">可用來登入 17FIT APP、忘記密碼，並作為接收重要通知。</div>\n    </div>\n    <div>\n        <st-input label=\"電子信箱\" :error=\"!isValid\" :error-text=\"formError.message\" :disabled=\"ajaxing\" v-model=\"form.email\" @keyup.enter=\"confirm\"></st-input>\n    </div>\n    <div class=\"st-flex st-justify-between st-items-center\">\n        <div class=\"st-text-gray-90 st-text-16 st-cursor-pointer\" @click=\"skip\">略過</div>\n        <st-button primary=\"\" filled=\"\" normal=\"\" text=\"下一步\" right-icon=\"arrow_forward\" :disabled=\"!isValid || ajaxing\" :loading=\"ajaxing\" @click=\"confirm\"></st-button>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-1319fc9f", module.exports)
  } else {
    hotAPI.update("_v-1319fc9f", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"../partials/banner-alert.vue":884,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785}],890:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        formStyle: {
            type: Object
        },
        formData: {
            type: Object
        }
    },
    data: function data() {
        return {
            form: {
                name: ''
            },
            validate: {
                length: {
                    message: '輸入的字數已超過上限 20 字',
                    value: 20
                },
                required: {
                    message: '',
                    value: true
                },
                regex: {
                    message: '第一個字元不能空白'
                }
            },
            isValid: true,
            formError: {}
        };
    },

    watch: {
        'form.name': {
            handler: function handler(newVal) {
                this.isValid = this.checkValidation(newVal);
            }
        }
    },
    methods: {
        confirm: function confirm() {
            var _this = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this.checkValidation(_this.form.name);

                            case 2:
                                _this.isValid = _context.sent;

                                if (_this.isValid) {
                                    _this.$emit('confirm', _this.form);
                                }

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        checkValidation: function checkValidation(name) {
            var nameRegex = /^\S.*/;
            if (!name) {
                this.formError = this.validate.required;
                return false;
            }
            if (!nameRegex.test(name)) {
                this.formError = this.validate.regex;
                return false;
            }
            if (name.length > this.validate.length.value) {
                this.formError = this.validate.length;
                return false;
            }
            this.formError = {};
            return true;
        },
        login: function login() {
            window.open('/account' + window.location.search, '_self');
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"st-space-y-7\">\n    <div :class=\"formStyle.subtitle\">請輸入您的真實姓名</div>\n    <div>\n        <st-input label=\"姓名\" required=\"\" :error=\"!isValid\" :error-text=\"formError.message\" v-model=\"form.name\" @keyup.enter=\"confirm\"></st-input>\n    </div>\n    <div>\n        <st-button primary=\"\" filled=\"\" full=\"\" text=\"下一步\" right-icon=\"arrow_forward\" :disabled=\"!isValid\" @click=\"confirm\"></st-button>\n    </div>\n    <div>\n        <div class=\"st-text-info st-text-16 st-cursor-pointer\" @click=\"login\">已經有帳號？登入</div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-a781ec50", module.exports)
  } else {
    hotAPI.update("_v-a781ec50", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785}],891:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _bannerAlert = require('../partials/banner-alert.vue');

var _bannerAlert2 = _interopRequireDefault(_bannerAlert);

var _modal = require('../partials/modal.vue');

var _modal2 = _interopRequireDefault(_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        'banner-alert': _bannerAlert2.default,
        'alert-modal': _modal2.default
    },
    props: {
        formStyle: {
            type: Object
        },
        formData: {
            type: Object
        }
    },
    data: function data() {
        return {
            form: {
                password: ''
            },
            passwordCheck: {
                length: false,
                letters: false,
                symbols: false
            },
            visible: false,
            isValid: true,
            formError: {},
            ajaxing: false,
            failMessage: '',
            ajaxingError: {}
        };
    },

    watch: {
        'form.password': {
            handler: function handler(newVal) {
                this.isValid = this.checkValidation(newVal);
            }
        }
    },
    methods: {
        checkerStyle: function checkerStyle(bool) {
            var style = 'st-flex st-items-center st-text-14 st-font-regular';
            if (bool) {
                return 'st-text-success ' + style;
            } else {
                return 'st-text-gray-90 ' + style;
            }
        },
        confirm: function confirm() {
            var _this = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return _this.checkValidation(_this.form.password);

                            case 2:
                                _this.isValid = _context2.sent;

                                if (_this.isValid) {
                                    _this.ajaxing = true;
                                    _this.failMessage = '';
                                    _this.ajaxingError = {};
                                    _this.$http.post('/webapi/account/register', (0, _extends3.default)({}, _this.formData, _this.form)).then(function () {
                                        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(response) {
                                            var token, urlParams, successUrl, successUrlObj;
                                            return _regenerator2.default.wrap(function _callee$(_context) {
                                                while (1) {
                                                    switch (_context.prev = _context.next) {
                                                        case 0:
                                                            token = response.data.data.token;
                                                            urlParams = new URLSearchParams(window.location.search);
                                                            _context.t0 = urlParams.get('success_url');

                                                            if (_context.t0) {
                                                                _context.next = 7;
                                                                break;
                                                            }

                                                            _context.next = 6;
                                                            return _this.defaultAuthorizationJwtPath();

                                                        case 6:
                                                            _context.t0 = _context.sent;

                                                        case 7:
                                                            successUrl = _context.t0;
                                                            successUrlObj = new URL(successUrl);

                                                            successUrlObj.searchParams.set('token', token);
                                                            window.open(successUrlObj.href, '_self');

                                                        case 11:
                                                        case 'end':
                                                            return _context.stop();
                                                    }
                                                }
                                            }, _callee, _this);
                                        }));

                                        return function (_x) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }(), function (error) {
                                        _this.ajaxingError = error.data;
                                        var errCode = _this.ajaxingError.code;
                                        _this.failMessage = errCode && _this.$errorIdentifiable.includes(errCode) ? i18n.t('error.msg.' + errCode) : '發生錯誤，請重新嘗試';
                                        _this.isValid = false;
                                        _this.ajaxing = false;
                                        _this.$refs.alert_modal.show();
                                    });
                                }

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this);
            }))();
        },
        checkValidation: function checkValidation(password) {
            var letters = /^(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9\-_.@]+$/;
            var symbols = /^(?=.*[0-9\-_.@])[a-zA-Z0-9\-_.@]+$/;
            this.passwordCheck.length = password.length >= 8 && password.length <= 30;
            this.passwordCheck.letters = letters.test(password);
            this.passwordCheck.symbols = symbols.test(password);
            return this.passwordCheck.length && this.passwordCheck.letters && this.passwordCheck.symbols;
        },
        toggleVisible: function toggleVisible() {
            this.visible = !this.visible;
        },
        confirmSkip: function confirmSkip() {
            this.$refs.alert_modal.close();
        },
        defaultAuthorizationJwtPath: function defaultAuthorizationJwtPath() {
            var domain = location.protocol + '//' + location.host;
            var authRedirectPath = domain + '/authorization/jwt?';
            return authRedirectPath += 'success_url=' + domain + '&fail_url=' + domain;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"st-space-y-7\">\n    <div>\n        <div :class=\"formStyle.subtitle\">請輸入密碼</div>\n    </div>\n    <div>\n        <st-input label=\"密碼\" required=\"\" :type=\"visible ? 'text':'password'\" :error=\"!isValid\" :error-text=\"formError.message\" :disabled=\"ajaxing\" v-model=\"form.password\" @keyup.enter=\"confirm\">\n            <span slot=\"icon\" class=\"st-text-primary st-cursor-pointer\" @click=\"toggleVisible\">\n                <span class=\"material-icons\" v-if=\"visible\">visibility</span>\n                <span class=\"material-icons\" v-else=\"\">visibility_off</span>\n            </span>\n        </st-input>\n        <div class=\"st-space-y-1 st-mt-2\">\n            <div :class=\"checkerStyle(passwordCheck.length)\">\n                <span class=\"material-icons st-text-16\">check_circle</span>\n                必須超過 8 個字元\n            </div>\n            <div :class=\"checkerStyle(passwordCheck.letters)\">\n                <span class=\"material-icons st-text-16\">check_circle</span>\n                必須包含大寫 (A-Z) 及小寫英文字母 (a-z)\n            </div>\n            <div :class=\"checkerStyle(passwordCheck.symbols)\">\n                <span class=\"material-icons st-text-16\">check_circle</span>\n                必須包含數字 (0-9) 或特殊符號 (-_@.)\n            </div>                \n        </div>\n\n    </div>\n    <div>\n        <st-button primary=\"\" filled=\"\" full=\"\" text=\"完成註冊\" :disabled=\"!isValid || ajaxing\" :loading=\"ajaxing\" @click=\"confirm\"></st-button>\n    </div>\n    <alert-modal ref=\"alert_modal\" modal-id=\"AlertRegisterFail\" title=\"註冊失敗\">\n        <div slot=\"body\" class=\"st-text-16 st-text-gray-90 st-font-regular\">\n            <div>{{ failMessage }}</div>\n        </div>\n        <div slot=\"footer\">\n            <div class=\"st-flex st-justify-end\">\n                <st-button primary=\"\" filled=\"\" normal=\"\" text=\"確認\" @click=\"confirmSkip\"></st-button>\n            </div>\n        </div>\n    </alert-modal>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-0c249f68", module.exports)
  } else {
    hotAPI.update("_v-0c249f68", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"../partials/banner-alert.vue":884,"../partials/modal.vue":886,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785}],892:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _bannerAlert = require('../partials/banner-alert.vue');

var _bannerAlert2 = _interopRequireDefault(_bannerAlert);

var _modal = require('../partials/modal.vue');

var _modal2 = _interopRequireDefault(_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        'banner-alert': _bannerAlert2.default,
        'alert-modal': _modal2.default
    },
    props: {
        formStyle: {
            type: Object
        },
        formData: {
            type: Object
        }
    },
    data: function data() {
        return {
            form: {
                country_code: 886,
                phone: ''
            },
            validate: {
                length: {
                    message: '輸入的字數已超過上限 16 字',
                    value: 16
                }
            },
            isValid: true,
            formError: {},
            ajaxing: false,
            ajaxingError: {},
            codes: [{ text: '+886', prefix: 'TW', value: '886', selected: true }, { text: '+852', prefix: 'HK', value: '852', selected: false }, { text: '+65', prefix: 'SG', value: '65', selected: false }, { text: '+60', prefix: 'MY', value: '60', selected: false }]
        };
    },

    watch: {
        'form.phone': {
            handler: function handler(newVal) {
                this.isValid = this.checkValidation(newVal);
            }
        }
    },
    methods: {
        reset: function reset() {
            this.formError = {};
            this.form.country_code = 886;
            this.form.phone = '';
            this.isValid = true;
        },
        confirm: function confirm() {
            var _this = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this.checkValidation(_this.form.phone);

                            case 2:
                                _this.isValid = _context.sent;

                                if (_this.isValid) {
                                    _this.ajaxing = true;
                                    _this.ajaxingError = {};
                                    _this.$http.post('/webapi/account/phone/register-available', _this.form).then(function (response) {
                                        _this.$emit('confirm', _this.form);
                                        _this.ajaxing = false;
                                    }, function (error) {
                                        _this.ajaxingError = error.data;
                                        _this.isValid = false;
                                        _this.ajaxing = false;
                                    });
                                }

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        checkValidation: function checkValidation(phone) {
            var phoneRegex = /^\d{10}$/;
            if (!phoneRegex.test(phone)) {
                this.formError = {};
                return false;
            }
            if (phone.length > this.validate.length.value) {
                this.formError = this.validate.length;
                return false;
            }
            this.formError = {};
            return true;
        },
        getCountryCode: function getCountryCode(value) {
            this.form.country_code = value;
        },
        skip: function skip() {
            if (!this.formData.email && !this.form.phone) {
                this.$refs.alert_modal.show();
            } else {
                this.confirmSkip();
            }
        },
        backEdit: function backEdit() {
            this.$refs.alert_modal.close();
        },
        confirmSkip: function confirmSkip() {
            this.$refs.alert_modal.close();
            this.reset();
            this.$emit('skip', ['phone', 'country_code']);
        },
        forwardAccount: function forwardAccount() {
            window.open('/account' + window.location.search, '_self');
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"st-space-y-7\">\n    <banner-alert v-show=\"ajaxingError.code\" :message=\"ajaxingError.message\" :ajaxing-error=\"ajaxingError\">\n        <div slot=\"action\">\n            <st-button danger=\"\" outline=\"\" small=\"\" @click=\"forwardAccount\" text=\"前往登入\" :btn-class=\"['st-border-0 st-text-12']\"></st-button>\n        </div>\n    </banner-alert>\n    <div>\n        <div :class=\"formStyle.subtitle\">請輸入手機號碼</div>\n        <div :class=\"formStyle.content\">可用來登入 APP、忘記密碼，並作為接收重要通知。</div>\n    </div>\n    <div class=\"st-flex\">\n        <div class=\"st-w-24 st-mr-2\">\n            <st-single-select label=\"國碼\" empty-text=\"請選擇\" :options=\"codes\" @change=\"getCountryCode\"></st-single-select>                \n        </div>\n        <st-input label=\"手機號碼\" :error=\"!isValid\" :error-text=\"formError.message\" :disabled=\"ajaxing\" v-model=\"form.phone\" @keyup.enter=\"confirm\"></st-input>\n    </div>\n    <div class=\"st-flex st-justify-between st-items-center\">\n        <div class=\"st-text-gray-90 st-text-16 st-cursor-pointer\" @click=\"skip\">略過</div>\n        <st-button primary=\"\" filled=\"\" normal=\"\" text=\"下一步\" right-icon=\"arrow_forward\" :disabled=\"!isValid || ajaxing || !form.country_code\" :loading=\"ajaxing\" @click=\"confirm\"></st-button>\n    </div>\n    <alert-modal ref=\"alert_modal\" modal-id=\"AlertEmptyEmailPhone\" title=\"尚未填寫電子信箱或手機號碼\">\n        <div slot=\"body\" class=\"st-text-16 st-text-gray-90 st-font-regular\">\n            <div>建議您提供電子郵件信箱或手機號碼以使用忘記密碼功能。</div>\n            <br>\n            <div>您可以在個人資料中隨時新增此資訊。</div>\n        </div>\n        <div slot=\"footer\">\n            <div class=\"st-flex st-justify-end\">\n                <st-button ghost=\"\" text=\"返回編輯\" @click=\"backEdit\"></st-button>\n                <st-button primary=\"\" filled=\"\" normal=\"\" text=\"確認略過\" @click=\"confirmSkip\"></st-button>\n            </div>\n        </div>\n    </alert-modal>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-7339c387", module.exports)
  } else {
    hotAPI.update("_v-7339c387", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"../partials/banner-alert.vue":884,"../partials/modal.vue":886,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785}],893:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _bannerAlert = require('../partials/banner-alert.vue');

var _bannerAlert2 = _interopRequireDefault(_bannerAlert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        'banner-alert': _bannerAlert2.default
    },
    props: {
        formStyle: {
            type: Object
        },
        formData: {
            type: Object
        }
    },
    data: function data() {
        return {
            init: false,
            form: {
                account: ''
            },
            validate: {
                length: {
                    message: '輸入的字數已超過上限 50 字',
                    value: 50
                },
                required: {
                    message: '',
                    value: true
                }
            },
            isDefault: true,
            isValid: true,
            formError: {},
            ajaxing: false,
            ajaxingError: {}
        };
    },
    mounted: function mounted() {
        this.form.account = this.formData.account || '';
        this.isDefault = this.formData.account ? true : false;
        window.addEventListener('keyup', this.handleKeyup);
    },

    watch: {
        'form.account': {
            handler: function handler(newVal) {
                if (!this.init) {
                    this.init = true;
                } else {
                    this.isDefault = false;
                }
                this.isValid = this.checkValidation(newVal);
            }
        }
    },
    methods: {
        handleKeyup: function handleKeyup(event) {
            if (event.key === 'Enter' && this.form.account) {
                this.confirm();
            }
        },
        confirm: function confirm() {
            var _this = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this.checkValidation(_this.form.account);

                            case 2:
                                _this.isValid = _context.sent;

                                if (_this.isValid) {
                                    _this.ajaxing = true;
                                    _this.ajaxingError = {};
                                    _this.$http.post('/webapi/account/account/register-available', _this.form).then(function (response) {
                                        _this.$emit('confirm', _this.form);
                                        _this.ajaxing = false;
                                    }, function (error) {
                                        _this.ajaxingError = error.data;
                                        _this.isValid = false;
                                        _this.ajaxing = false;
                                    });
                                }

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        checkValidation: function checkValidation(account) {
            var accountRegex = /^[a-zA-Z0-9\.\-_@]+$/;
            if (!account) {
                this.formError = this.validate.required;
                return false;
            }
            if (!accountRegex.test(account)) {
                this.formError = {};
                return false;
            }
            if (account.length > this.validate.length.value) {
                this.formError = this.validate.length;
                return false;
            }
            this.formError = {};
            return true;
        }
    },
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener('keyup', this.handleKeyup);
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"st-space-y-7\">\n    <banner-alert v-show=\"ajaxingError.code\" :message=\"ajaxingError.message\" :ajaxing-error=\"ajaxingError\"></banner-alert>\n    <div>\n        <div :class=\"formStyle.subtitle\">請輸入使用者帳號</div>\n        <div :class=\"formStyle.content\">可用來登入 17FIT 服務。</div>\n    </div>\n    <div>\n        <st-input label=\"使用者帳號\" required=\"\" :error=\"!isValid\" :error-text=\"formError.message\" :disabled=\"ajaxing\" v-model=\"form.account\" @keyup.enter=\"confirm\">\n            <div slot=\"infoBlock\">\n                <div v-if=\"isDefault\" class=\"st-text-info st-text-14 st-font-regular st-flex st-items-center\">\n                    <span class=\"material-icons st-text-16 st-mr-1\">auto_awesome</span>\n                    <span>根據您的信箱自動建議</span>\n                </div>\n                <div v-else=\"\" class=\"st-text-gray-90 st-text-14 st-font-regular\">\n                    僅允許半形英數字 (A-Z、0-9)、特殊符號 (-_@.)\n                </div>\n            </div>\n        </st-input>\n    </div>\n    <div>\n        <st-button primary=\"\" filled=\"\" full=\"\" text=\"下一步\" right-icon=\"arrow_forward\" :disabled=\"!isValid || ajaxing\" :loading=\"ajaxing\" @click=\"confirm\"></st-button>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-6eea1878", module.exports)
  } else {
    hotAPI.update("_v-6eea1878", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"../partials/banner-alert.vue":884,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785}],894:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _single = require('./single.vue');

var _single2 = _interopRequireDefault(_single);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('approval-term-single', _single2.default);

},{"./single.vue":895,"vue":792}],895:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    data: function data() {
        return {
            approveTermList: []
        };
    },
    mounted: function mounted() {
        this.fetchApprovalTermData();
    },

    watch: {},
    computed: {},
    methods: {
        fetchApprovalTermData: function fetchApprovalTermData() {
            var _this = this;

            var query = $17.getUrlQueryStrings();
            var studio_id = query.studio_id;
            this.$http.get('/webapi/approval-term/studio?studio_id=' + studio_id).then(function (response) {
                response = response.body;
                if (response.is_show_in_client_side == 0) {
                    $17.swal({
                        type: 'warning',
                        title: '發生了錯誤',
                        showCancelButton: false
                    }, function () {
                        window.close();
                    });
                }
                _this.approveTermList = response;
            }).catch(function (error) {
                $17.swal({
                    type: 'error',
                    title: '取得資料錯誤',
                    showCancelButton: false
                }, function () {
                    window.close();
                });
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"st-m-8 st-text-black\">\n    <div class=\"st-text-28\">{{approveTermList.name}}</div>\n    <div class=\"st-text-16\" v-html=\"approveTermList.content\"></div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-1fd06244", module.exports)
  } else {
    hotAPI.update("_v-1fd06244", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],896:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        destUrl: {
            type: String,
            default: null
        },
        errorUrl: {
            type: String,
            default: null
        },
        platformDefine: {
            type: String,
            required: true
        },
        showFb: {
            type: Number,
            default: 0
        },
        destUrlType: {
            type: String,
            default: 'referrer'
        }
    },
    data: function data() {
        return {
            seventeenUrl: '',
            sourceDomainUrl: ''
        };
    },
    mounted: function mounted() {
        this.seventeenDomainUrl();
        this.sourceDomainUrl = location.protocol + '//' + location.host;
    },

    computed: {
        destFinalUrl: function destFinalUrl() {
            return this.getDesUrl();
        },
        errorFinalUrl: function errorFinalUrl() {
            return this.errorUrl == null ? '/error' : this.errorUrl;
        },
        hooks: function hooks() {
            return {
                destUrl: this.destFinalUrl,
                errorUrl: this.errorFinalUrl
            };
        }
    },
    methods: {
        seventeenDomainUrl: function seventeenDomainUrl() {
            var _this = this;

            this.$http.get('/webapi/init/data').then(function (response) {
                var isWebStudio = response.data.is_in_webstudio;
                if (isWebStudio) {
                    _this.seventeenUrl = location.protocol + '//' + location.host.replace(/^[^.]*\./, '');
                } else {
                    _this.seventeenUrl = location.protocol + '//' + location.host;
                }
            });
        },
        login: function login() {
            var _this2 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                var loginPath;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (_this2.seventeenUrl) {
                                    _context.next = 3;
                                    break;
                                }

                                _context.next = 3;
                                return _this2.seventeenDomainUrl();

                            case 3:
                                loginPath = _this2.seventeenUrl + '/account?';

                                loginPath += 'show_fb=' + (_this2.showFb ? 1 : 0) + '&success_url=' + _this2.successUrl() + '&cancel_url=' + location.href;
                                window.open(loginPath, '_self');

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        successUrl: function successUrl() {
            var url = this.sourceDomainUrl + '/authorization/jwt?';
            url += 'success_url=' + this.hooks.destUrl + '&fail_url=' + this.hooks.destUrl;
            return url;
        },
        getDesUrl: function getDesUrl() {
            if (this.destUrl != null) {
                return this.destUrl;
            }
            switch (this.destUrlType) {
                case 'referrer':
                    return document.referrer;
                    break;
                case 'current':
                    return document.URL;
                    break;

                default:
                    return '/';
                    break;
            }
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-1615e73f", module.exports)
  } else {
    hotAPI.update("_v-1615e73f", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785}],897:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _userLoginForm = require('./user-login-form.vue');

var _userLoginForm2 = _interopRequireDefault(_userLoginForm);

var _userRegisterForm = require('./user-register-form.vue');

var _userRegisterForm2 = _interopRequireDefault(_userRegisterForm);

var _userLoginHiddenForm = require('./user-login-hidden-form.vue');

var _userLoginHiddenForm2 = _interopRequireDefault(_userLoginHiddenForm);

var _accountLoginService = require('./account-login-service.vue');

var _accountLoginService2 = _interopRequireDefault(_accountLoginService);

var _userRegisterHiddenForm = require('./user-register-hidden-form.vue');

var _userRegisterHiddenForm2 = _interopRequireDefault(_userRegisterHiddenForm);

var _oauthLoginForm = require('./oauth-login-form.vue');

var _oauthLoginForm2 = _interopRequireDefault(_oauthLoginForm);

var _oauthRegisterForm = require('./oauth-register-form.vue');

var _oauthRegisterForm2 = _interopRequireDefault(_oauthRegisterForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// OLD: socialite login form
_vue2.default.component('web-user-login-form', _userLoginForm2.default); // NEW: account login service

_vue2.default.component('web-user-register-form', _userRegisterForm2.default);
_vue2.default.component('socialite-login-hidden-form', _userLoginHiddenForm2.default); // OLD: 僅應用在續用 FB 登入
_vue2.default.component('web-user-login-hidden-form', _accountLoginService2.default); // NEW: 沿用舊的 component name
_vue2.default.component('web-user-register-hidden-form', _userRegisterHiddenForm2.default);
_vue2.default.component('web-oauth-login-form', _oauthLoginForm2.default);
_vue2.default.component('web-oauth-register-form', _oauthRegisterForm2.default);

},{"./account-login-service.vue":896,"./oauth-login-form.vue":898,"./oauth-register-form.vue":899,"./user-login-form.vue":900,"./user-login-hidden-form.vue":901,"./user-register-form.vue":902,"./user-register-hidden-form.vue":903,"vue":792}],898:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.input-radio[_v-5e883700] {\n  display: none; }\n\n/* line 5, stdin */\n.fp-checkbox.checked[_v-5e883700], .fp-radio.checked[_v-5e883700] {\n  text-align: center;\n  color: #fefffa;\n  font-family: \"formplate\";\n  border: 1px solid #3498db;\n  background-color: #3498db; }\n\n/* line 13, stdin */\n.fp-radio[_v-5e883700] {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  margin-right: 6px;\n  margin-bottom: 5px;\n  margin-top: 0px;\n  margin-bottom: 2px;\n  width: 22px;\n  height: 22px;\n  line-height: 22px;\n  line-height: 1.375rem;\n  font-size: 10px;\n  font-size: 0.625rem;\n  vertical-align: middle;\n  border: 1px solid #d1d1d1;\n  border-radius: 50%;\n  background-clip: padding-box;\n  background-clip: border-box; }\n\n/* line 33, stdin */\n.fp-checkbox[_v-5e883700] {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  margin-right: 6px;\n  margin-bottom: 5px;\n  margin-top: 0px;\n  margin-bottom: 2px;\n  width: 22px;\n  height: 22px;\n  line-height: 22px;\n  line-height: 1.375rem;\n  font-size: 10px;\n  font-size: 0.625rem;\n  vertical-align: middle;\n  border: 1px solid #d1d1d1;\n  border-radius: 2px;\n  background-clip: padding-box;\n  background-clip: border-box; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            countries: [],
            showFaceBook: false,
            errorMessage: '',
            form: {
                login_way: "phone",
                phone: '',
                country_code: 886,
                email: '',
                remember_me: "1",
                password: ""
            },
            validation: {
                login_way: "",
                phone: '',
                country_code: '',
                email: '',
                password: ""
            },
            ajaxing: {
                loading: false,
                check: false,
                fb: false
            },
            urlDestUrl: document.referrer
        };
    },
    mounted: function mounted() {
        this.getFromBaseData();
        var query = $17.getUrlQueryStrings();
        this.showFaceBook = query.hasOwnProperty('show_fb') ? Number(query['show_fb']) : 0;
        if (query.hasOwnProperty('error_message')) {
            this.errorMessage = query['error_message'];
            $17.removeSelectedUrlPara('error_message');
        }
        if (query.hasOwnProperty('dest_url')) {
            this.urlDestUrl = query['dest_url'];
            $17.removeSelectedUrlPara('dest_url');
        }
    },

    computed: {
        showPhone: function showPhone() {
            return this.form.login_way == 'phone';
        },
        showEmail: function showEmail() {
            return this.form.login_way == 'email';
        },
        registerHref: function registerHref() {
            return '/oauth/register' + window.location.search + '&dest_url=' + document.referrer;
        },
        loginHref: function loginHref() {
            return '/oauth/login' + window.location.search;
        }
    },
    methods: {
        register: function register() {
            this.$refs.registerForm.login();
            return;
        },
        login: function login() {
            try {
                this.ajaxing.fb = true;
                this.$refs.loginFormFB.login();
            } catch (error) {
                this.ajaxing.fb = false;
            }
        },
        getValidationResult: function getValidationResult(e) {
            var _this = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                var form, res;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.ajaxing.check = true;
                                form = _this.form;


                                if (_this.showPhone) {
                                    form.email = '';
                                }
                                if (_this.showEmail) {
                                    form.phone = '';
                                }
                                _context.next = 6;
                                return _this.$http.post('/oauth/login-check', form).then(function (response) {
                                    _this.$refs.form.submit();
                                }).catch(function (response) {
                                    _this.validation = {
                                        phone: '',
                                        email: '',
                                        password: "",
                                        confirmpassword: ""
                                    };
                                    var data = response.data;
                                    var _iteratorNormalCompletion = true;
                                    var _didIteratorError = false;
                                    var _iteratorError = undefined;

                                    try {
                                        for (var _iterator = (0, _getIterator3.default)((0, _entries2.default)(data)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                            var _step$value = (0, _slicedToArray3.default)(_step.value, 2),
                                                key = _step$value[0],
                                                value = _step$value[1];

                                            _this.validation[key] = value.toString();
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally {
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return) {
                                                _iterator.return();
                                            }
                                        } finally {
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }

                                    _this.ajaxing.check = false;
                                });

                            case 6:
                                res = _context.sent;

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        getFromBaseData: function getFromBaseData() {
            var _this2 = this;

            this.ajaxing.loading = true;
            this.$http.get('/webapi/member/auth-from-data').then(function (response) {
                _this2.ajaxing.loading = false;
                _this2.countries = response.data.countries;
                // this.showFaceBook = response.data.showFaceBook;
            }, function (error) {
                _this2.ajaxing.loading = false;
                return false;
            });
        },
        toggleRememberMe: function toggleRememberMe() {
            this.form.remember_me = this.form.remember_me ? 0 : 1;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"login-box login-page\" _v-5e883700=\"\">\n    <socialite-login-hidden-form ref=\"loginFormFB\" platform-define=\"fb\" :dest-url=\"urlDestUrl\" _v-5e883700=\"\"></socialite-login-hidden-form>\n    <web-user-register-hidden-form ref=\"registerForm\" platform-define=\"seventeen-fit\" :show-fb=\"showFaceBook\" :dest-url=\"urlDestUrl\" dest-url-type=\"current\" _v-5e883700=\"\"></web-user-register-hidden-form>\n    <v-dismissible-alert-bootstrap dismissible-style=\"alert alert-danger\" :allow-close=\"true\" :text=\"errorMessage\" _v-5e883700=\"\"></v-dismissible-alert-bootstrap>\n    <div class=\"login-header\" _v-5e883700=\"\">\n        <h2 _v-5e883700=\"\">請先登入 17FIT 帳戶</h2>\n    </div>  \n    <v-spinner :ajaxing=\"ajaxing.loading\" _v-5e883700=\"\"></v-spinner>\n    <form method=\"post\" :action=\"loginHref\" v-show=\"!ajaxing.loading\" ref=\"form\" _v-5e883700=\"\">\n        <div v-if=\"showFaceBook\" _v-5e883700=\"\">\n            <a class=\"btn btn--login btn--facebook\" @click.stop.prevent=\"login\" :class=\"{'disabled':ajaxing.fb}\" _v-5e883700=\"\">FACEBOOK 登入</a>   \n            <p class=\"or\" _v-5e883700=\"\"><span class=\"or-btn\" _v-5e883700=\"\">或</span></p>\n        </div>\n        <div class=\"login-form clearfix\" _v-5e883700=\"\">\n            <div class=\"m-bottom-15 m-top-10\" _v-5e883700=\"\">\n                <label class=\"pull-left\" _v-5e883700=\"\">\n                    <span class=\"fp-radio\" :class=\"{checked:showPhone}\" _v-5e883700=\"\">\n                        <i class=\"fa fa-check\" v-show=\"showPhone\" _v-5e883700=\"\"></i>\n                        <input type=\"radio\" name=\"login_way\" v-model=\"form.login_way\" class=\"input-radio\" value=\"phone\" _v-5e883700=\"\">\n                    </span>手機號碼登入\n                </label>\n                <label class=\"m-left-30 pull-left\" _v-5e883700=\"\">\n                    <span class=\"fp-radio\" :class=\"{checked:showEmail}\" _v-5e883700=\"\">\n                        <i class=\"fa fa-check\" v-show=\"showEmail\" _v-5e883700=\"\"></i>\n                        <input type=\"radio\" name=\"login_way\" v-model=\"form.login_way\" class=\"input-radio\" value=\"email\" _v-5e883700=\"\">\n                    </span>Email 登入\n                </label>\n                <div class=\"clearfix\" _v-5e883700=\"\"></div>\n                <div id=\"error--message\" _v-5e883700=\"\">{{validation.login_way}}</div>\n            </div>\n\n            <div class=\"login-phone login-area\" v-if=\"showPhone\" _v-5e883700=\"\">\n                <label for=\"phone\" class=\"srt\" _v-5e883700=\"\">輸入手機號碼</label>\n                <ul class=\"phone-area\" _v-5e883700=\"\">\n                    <li class=\"col-sm-3 col-xs-4 no-padding\" _v-5e883700=\"\">\n                        <span class=\"fp-select\" _v-5e883700=\"\">\n                            <select name=\"country_code\" v-model=\"form.country_code\" _v-5e883700=\"\">\n                                <option :value=\"country.country_code\" v-for=\"country in countries\" _v-5e883700=\"\">\n                                    {{country.iso_code}}&nbsp;&nbsp;+{{country.country_code}}\n                                </option> \n                            </select>\n                        </span>\n                    </li>\n                    <li class=\"col-sm-9 col-xs-8 no-padding\" _v-5e883700=\"\">\n                        <input placeholder=\"輸入手機號碼\" name=\"phone\" type=\"number\" v-model=\"form.phone\" _v-5e883700=\"\">\n                    </li>\n                </ul>\n                <div class=\"clearfix\" _v-5e883700=\"\"></div>\n                <div id=\"error--message\" _v-5e883700=\"\">{{validation.phone}}</div>\n            </div>\n\n            <div class=\"login-email login-area\" v-if=\"showEmail\" _v-5e883700=\"\">\n                <label for=\"email\" class=\"srt\" _v-5e883700=\"\">Email</label>\n                <input placeholder=\"輸入電子郵件\" name=\"email\" type=\"email\" v-model=\"form.email\" _v-5e883700=\"\">\n            </div>\n            <div id=\"error--message\" _v-5e883700=\"\">{{validation.email}}</div>\n\n            <label for=\"password\" class=\"srt\" _v-5e883700=\"\">輸入密碼</label>\n            <input placeholder=\"輸入密碼\" name=\"password\" type=\"password\" value=\"\" id=\"password\" v-model=\"form.password\" _v-5e883700=\"\">\n            <div id=\"error--message\" _v-5e883700=\"\">{{validation.password}}</div>\n\n            <span class=\"fp-checkbox\" :class=\"{checked:form.remember_me}\" @click=\"toggleRememberMe\" _v-5e883700=\"\">\n                <i class=\"fa fa-check\" v-show=\"form.remember_me\" _v-5e883700=\"\"></i>\n                <input v-model=\"form.remember_me\" name=\"remember_me\" type=\"checkbox\" :true-value=\"1\" :false-value=\"0\" class=\"input-radio\" id=\"remember_me\" _v-5e883700=\"\"></span>\n            <label for=\"remember_me\" _v-5e883700=\"\">保持登入</label>\n            <input type=\"button\" value=\"登入\" class=\"btn btn--login\" @click=\"getValidationResult\" :disabled=\"ajaxing.check\" _v-5e883700=\"\">\n        </div>\n    </form>\n    <div class=\"login-links\" _v-5e883700=\"\">\n        <div class=\"col-xs-6\" _v-5e883700=\"\">\n            <a @click=\"register()\" class=\"btn btn--login btn--blank\" _v-5e883700=\"\">\n                註冊\n            </a>\n        </div>\n        <div class=\"col-xs-6\" _v-5e883700=\"\">\n            <a href=\"/forgot-password\" class=\"btn btn--login btn--blank\" _v-5e883700=\"\">忘記密碼？</a>\n        </div> \n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.input-radio[_v-5e883700] {\n  display: none; }\n\n/* line 5, stdin */\n.fp-checkbox.checked[_v-5e883700], .fp-radio.checked[_v-5e883700] {\n  text-align: center;\n  color: #fefffa;\n  font-family: \"formplate\";\n  border: 1px solid #3498db;\n  background-color: #3498db; }\n\n/* line 13, stdin */\n.fp-radio[_v-5e883700] {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  margin-right: 6px;\n  margin-bottom: 5px;\n  margin-top: 0px;\n  margin-bottom: 2px;\n  width: 22px;\n  height: 22px;\n  line-height: 22px;\n  line-height: 1.375rem;\n  font-size: 10px;\n  font-size: 0.625rem;\n  vertical-align: middle;\n  border: 1px solid #d1d1d1;\n  border-radius: 50%;\n  background-clip: padding-box;\n  background-clip: border-box; }\n\n/* line 33, stdin */\n.fp-checkbox[_v-5e883700] {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  margin-right: 6px;\n  margin-bottom: 5px;\n  margin-top: 0px;\n  margin-bottom: 2px;\n  width: 22px;\n  height: 22px;\n  line-height: 22px;\n  line-height: 1.375rem;\n  font-size: 10px;\n  font-size: 0.625rem;\n  vertical-align: middle;\n  border: 1px solid #d1d1d1;\n  border-radius: 2px;\n  background-clip: padding-box;\n  background-clip: border-box; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-5e883700", module.exports)
  } else {
    hotAPI.update("_v-5e883700", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/get-iterator":46,"babel-runtime/core-js/object/entries":54,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/slicedToArray":70,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],899:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            countries: [],
            showFaceBook: false,
            errorMessage: '',
            form: {
                phone: '',
                country_code: 886,
                email: '',
                password: "",
                confirmpassword: ""
            },
            validation: {
                phone: '',
                email: '',
                password: "",
                confirmpassword: ""
            },
            ajaxing: {
                loading: false,
                check: false,
                fb: false
            },
            urlDestUrl: null
        };
    },
    mounted: function mounted() {
        this.getFromBaseData();
        var query = $17.getUrlQueryStrings();
        this.showFaceBook = query.hasOwnProperty('show_fb') ? Number(query['show_fb']) : 0;
        if (query.hasOwnProperty('error_message')) {
            this.errorMessage = query['error_message'];
            $17.removeSelectedUrlPara('error_message');
        }
        if (query.hasOwnProperty('dest_url')) {
            var urlParams = new URLSearchParams(window.location.search);
            this.urlDestUrl = urlParams.get('dest_url');
            $17.removeSelectedUrlPara('dest_url');
        }
    },

    computed: {
        loginHref: function loginHref() {
            return '/oauth/login' + window.location.search + '&dest_url=' + document.referrer;
        },
        registerHref: function registerHref() {
            return '/oauth/register' + window.location.search;
        }
    },
    methods: {
        login: function login() {
            try {
                this.ajaxing.fb = true;
                this.$refs.loginFormFB.login();
            } catch (error) {
                this.ajaxing.fb = false;
            }
        },
        getValidationResult: function getValidationResult(e) {
            var _this = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                var res;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.ajaxing.check = true;
                                _context.next = 3;
                                return _this.$http.post('/oauth/register-check', _this.form).then(function (response) {
                                    _this.$refs.form.submit();
                                }).catch(function (response) {
                                    var data = response.data;
                                    _this.validation = {
                                        phone: '',
                                        email: '',
                                        password: "",
                                        confirmpassword: ""
                                    };
                                    var _iteratorNormalCompletion = true;
                                    var _didIteratorError = false;
                                    var _iteratorError = undefined;

                                    try {
                                        for (var _iterator = (0, _getIterator3.default)((0, _entries2.default)(data)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                            var _step$value = (0, _slicedToArray3.default)(_step.value, 2),
                                                key = _step$value[0],
                                                value = _step$value[1];

                                            _this.validation[key] = value.toString();
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally {
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return) {
                                                _iterator.return();
                                            }
                                        } finally {
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }

                                    _this.ajaxing.check = false;
                                });

                            case 3:
                                res = _context.sent;

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        getFromBaseData: function getFromBaseData() {
            var _this2 = this;

            this.ajaxing.loading = true;
            this.$http.get('/webapi/member/auth-from-data').then(function (response) {
                _this2.ajaxing.loading = false;
                _this2.countries = response.data.countries;
                // this.showFaceBook = response.data.showFaceBook;
            }, function (error) {
                _this2.ajaxing.loading = false;
                return false;
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"login-box\">\n    <socialite-login-hidden-form ref=\"loginFormFB\" platform-define=\"fb\" :dest-url=\"urlDestUrl\"></socialite-login-hidden-form>\n    <v-dismissible-alert-bootstrap dismissible-style=\"alert alert-danger\" :allow-close=\"true\" :text=\"errorMessage\"></v-dismissible-alert-bootstrap>\n    <div class=\"login-header\">\n        <h2>註冊</h2>\n    </div> \n    <v-spinner :ajaxing=\"ajaxing.loading\"></v-spinner>\n    <form method=\"post\" :action=\"registerHref\" v-show=\"!ajaxing.loading\" ref=\"form\">\n        <div v-if=\"showFaceBook\">\n            <a class=\"btn btn--login btn--facebook\" @click.stop.prevent=\"login\" :class=\"{'disabled':ajaxing.fb}\">FACEBOOK 登入</a>\n            <p class=\"or\"><span class=\"or-btn\">或</span></p>\n        </div>\n        <div class=\"login-form clearfix\">\n            <label for=\"phone\" class=\"srt\">輸入手機號碼</label>\n            <ul class=\"phone-area\">\n                <li class=\"col-sm-3 col-xs-4 no-padding\">\n                    <span class=\"fp-select\">\n                        <select name=\"country_code\" v-model=\"form.country_code\">\n                            <option :value=\"country.country_code\" v-for=\"country in countries\">\n                                {{country.iso_code}}&nbsp;&nbsp;+{{country.country_code}}\n                            </option> \n                        </select>\n                    </span>\n                </li>\n                <li class=\"col-sm-9 col-xs-8 no-padding\">\n                    <input placeholder=\"輸入手機號碼\" name=\"phone\" type=\"number\" v-model=\"form.phone\">\n                </li>\n            </ul>\n            <div class=\"clearfix\"></div>\n            <div id=\"error--message\">{{validation.phone}}</div>\n           \n            <label for=\"name\" class=\"srt\">name</label>\n            <input placeholder=\"真實姓名\" name=\"name\" type=\"name\" v-model=\"form.name\">\n            <div id=\"error--message\">{{validation.name}}</div>\n            <label for=\"email\" class=\"srt\">Email</label>\n            <input placeholder=\"輸入電子郵件\" name=\"email\" type=\"email\" v-model=\"form.email\">\n            <div id=\"error--message\">{{validation.email}}</div>\n            <label for=\"password\" class=\"srt\">輸入密碼</label>\n            <input placeholder=\"輸入密碼\" name=\"password\" type=\"password\" value=\"\" id=\"password\" v-model=\"form.password\">\n            <div id=\"error--message\">{{validation.password}}</div>\n            <label for=\"password\" class=\"srt\">確認密碼</label>\n            <input placeholder=\"確認密碼\" name=\"confirmpassword\" type=\"password\" value=\"\" id=\"confirmpassword\" v-model=\"form.confirmpassword\">\n            <div id=\"error--message\">{{validation.confirmpassword}}</div>\n            <input type=\"button\" value=\"註冊\" class=\"btn btn--login\" @click=\"getValidationResult\" :disabled=\"ajaxing.check\">\n        </div>\n    </form>\n    <div class=\"login-links\">\n            <a :href=\"loginHref\" class=\"btn btn--login btn--blank\">\n                登入\n            </a>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-e3e7bcf4", module.exports)
  } else {
    hotAPI.update("_v-e3e7bcf4", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/get-iterator":46,"babel-runtime/core-js/object/entries":54,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/slicedToArray":70,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785}],900:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.input-radio[_v-7632b310] {\n  display: none; }\n\n/* line 5, stdin */\n.fp-checkbox.checked[_v-7632b310], .fp-radio.checked[_v-7632b310] {\n  text-align: center;\n  color: #fefffa;\n  font-family: \"formplate\";\n  border: 1px solid #3498db;\n  background-color: #3498db; }\n\n/* line 13, stdin */\n.fp-radio[_v-7632b310] {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  margin-right: 6px;\n  margin-bottom: 5px;\n  margin-top: 0px;\n  margin-bottom: 2px;\n  width: 22px;\n  height: 22px;\n  line-height: 22px;\n  line-height: 1.375rem;\n  font-size: 10px;\n  font-size: 0.625rem;\n  vertical-align: middle;\n  border: 1px solid #d1d1d1;\n  border-radius: 50%;\n  background-clip: padding-box;\n  background-clip: border-box; }\n\n/* line 33, stdin */\n.fp-checkbox[_v-7632b310] {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  margin-right: 6px;\n  margin-bottom: 5px;\n  margin-top: 0px;\n  margin-bottom: 2px;\n  width: 22px;\n  height: 22px;\n  line-height: 22px;\n  line-height: 1.375rem;\n  font-size: 10px;\n  font-size: 0.625rem;\n  vertical-align: middle;\n  border: 1px solid #d1d1d1;\n  border-radius: 2px;\n  background-clip: padding-box;\n  background-clip: border-box; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            countries: [],
            errorMessage: '',
            form: {
                login_way: "phone",
                phone: '',
                country_code: 886,
                email: '',
                remember_me: "1",
                password: ""
            },
            validation: {
                login_way: "",
                phone: '',
                country_code: '',
                email: '',
                password: ""
            },
            ajaxing: {
                loading: false,
                check: false
            }
        };
    },
    mounted: function mounted() {
        this.getFromBaseData();
        var query = $17.getUrlQueryStrings();
        if (query.hasOwnProperty('error_message')) {
            this.errorMessage = query['error_message'];
            $17.removeSelectedUrlPara('error_message');
        }
    },

    computed: {
        showPhone: function showPhone() {
            return this.form.login_way == 'phone';
        },
        showEmail: function showEmail() {
            return this.form.login_way == 'email';
        },
        registerHref: function registerHref() {
            return '/register' + window.location.search;
        },
        loginHref: function loginHref() {
            return '/login' + window.location.search;
        }
    },
    methods: {
        getValidationResult: function getValidationResult(e) {
            var _this = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                var form, res;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.ajaxing.check = true;
                                form = _this.form;

                                if (_this.showPhone) {
                                    form.email = '';
                                }
                                if (_this.showEmail) {
                                    form.phone = '';
                                }

                                _context.next = 6;
                                return _this.$http.post('/login-check', form).then(function (response) {
                                    _this.$refs.form.submit();
                                }).catch(function (response) {
                                    _this.validation = {
                                        phone: '',
                                        email: '',
                                        password: "",
                                        confirmpassword: ""
                                    };
                                    var data = response.data;
                                    var _iteratorNormalCompletion = true;
                                    var _didIteratorError = false;
                                    var _iteratorError = undefined;

                                    try {
                                        for (var _iterator = (0, _getIterator3.default)((0, _entries2.default)(data)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                            var _step$value = (0, _slicedToArray3.default)(_step.value, 2),
                                                key = _step$value[0],
                                                value = _step$value[1];

                                            _this.validation[key] = value.toString();
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally {
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return) {
                                                _iterator.return();
                                            }
                                        } finally {
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }

                                    _this.ajaxing.check = false;
                                });

                            case 6:
                                res = _context.sent;

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        getFromBaseData: function getFromBaseData() {
            var _this2 = this;

            this.ajaxing.loading = true;
            this.$http.get('/webapi/member/auth-from-data').then(function (response) {
                _this2.ajaxing.loading = false;
                _this2.countries = response.data.countries;
            }, function (error) {
                _this2.ajaxing.loading = false;
                return false;
            });
        },
        toggleRememberMe: function toggleRememberMe() {
            this.form.remember_me = this.form.remember_me ? 0 : 1;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"login-box login-page\" _v-7632b310=\"\">\n    <v-dismissible-alert-bootstrap dismissible-style=\"alert alert-danger\" :allow-close=\"true\" :text=\"errorMessage\" _v-7632b310=\"\"></v-dismissible-alert-bootstrap>\n    <div class=\"login-header\" _v-7632b310=\"\">\n        <h2 _v-7632b310=\"\">請先登入17FIT帳戶</h2>\n    </div> \n    <form method=\"post\" :action=\"loginHref\" ref=\"form\" _v-7632b310=\"\">\n        <v-spinner :ajaxing=\"ajaxing.loading\" _v-7632b310=\"\"></v-spinner>\n        <div class=\"login-form clearfix\" v-show=\"!ajaxing.loading\" _v-7632b310=\"\">\n            <div class=\"m-bottom-15 m-top-10\" _v-7632b310=\"\">\n                <label class=\"pull-left\" _v-7632b310=\"\">\n                    <span class=\"fp-radio\" :class=\"{checked:showPhone}\" _v-7632b310=\"\">\n                        <i class=\"fa fa-check\" v-show=\"showPhone\" _v-7632b310=\"\"></i>\n                        <input type=\"radio\" name=\"login_way\" v-model=\"form.login_way\" class=\"input-radio\" value=\"phone\" _v-7632b310=\"\">\n                    </span>手機號碼登入\n                </label>\n                <label class=\"m-left-30 pull-left\" _v-7632b310=\"\">\n                    <span class=\"fp-radio\" :class=\"{checked:showEmail}\" _v-7632b310=\"\">\n                        <i class=\"fa fa-check\" v-show=\"showEmail\" _v-7632b310=\"\"></i>\n                        <input type=\"radio\" name=\"login_way\" v-model=\"form.login_way\" class=\"input-radio\" value=\"email\" _v-7632b310=\"\">\n                    </span>Email登入\n                </label>\n                <div class=\"clearfix\" _v-7632b310=\"\"></div>\n            </div>\n            <div id=\"error--message\" _v-7632b310=\"\">{{validation.login_way}}</div>\n\n            <div class=\"login-phone login-area\" v-if=\"showPhone\" _v-7632b310=\"\">\n                <label for=\"phone\" class=\"srt\" _v-7632b310=\"\">輸入手機號碼</label>\n                <ul class=\"phone-area\" _v-7632b310=\"\">\n                    <li class=\"col-sm-3 col-xs-4 no-padding\" _v-7632b310=\"\">\n                        <span class=\"fp-select\" _v-7632b310=\"\">\n                            <select name=\"country_code\" v-model=\"form.country_code\" _v-7632b310=\"\">\n                                <option :value=\"country.country_code\" v-for=\"country in countries\" _v-7632b310=\"\">\n                                    {{country.iso_code}}&nbsp;&nbsp;+{{country.country_code}}\n                                </option> \n                            </select>\n                        </span>\n                    </li>\n                    <li class=\"col-sm-9 col-xs-8 no-padding\" _v-7632b310=\"\">\n                        <input placeholder=\"輸入手機號碼\" name=\"phone\" type=\"number\" v-model=\"form.phone\" _v-7632b310=\"\">\n                    </li>\n                </ul>\n                <div class=\"clearfix\" _v-7632b310=\"\"></div>\n            </div>\n            <div id=\"error--message\" _v-7632b310=\"\">{{validation.phone}}</div>\n\n            <div class=\"login-email login-area\" v-if=\"showEmail\" _v-7632b310=\"\">\n                <label for=\"email\" class=\"srt\" _v-7632b310=\"\">Email</label>\n                <input placeholder=\"輸入電子郵件\" name=\"email\" type=\"email\" v-model=\"form.email\" _v-7632b310=\"\">\n            </div>\n            <div id=\"error--message\" _v-7632b310=\"\">{{validation.email}}</div>\n\n            <label for=\"password\" class=\"srt\" _v-7632b310=\"\">輸入密碼</label>\n            <input placeholder=\"輸入密碼\" name=\"password\" type=\"password\" value=\"\" id=\"password\" v-model=\"form.password\" _v-7632b310=\"\">\n            <div id=\"error--message\" _v-7632b310=\"\">{{validation.password}}</div>\n\n            <span class=\"fp-checkbox\" :class=\"{checked:form.remember_me}\" @click=\"toggleRememberMe\" _v-7632b310=\"\">\n                <i class=\"fa fa-check\" v-show=\"form.remember_me\" _v-7632b310=\"\"></i>\n                <input v-model=\"form.remember_me\" name=\"remember_me\" type=\"checkbox\" :true-value=\"1\" :false-value=\"0\" class=\"input-radio\" id=\"remember_me\" _v-7632b310=\"\"></span>\n            <label for=\"remember_me\" _v-7632b310=\"\">保持登入</label>\n            <input type=\"button\" value=\"登入\" class=\"btn btn--login\" @click=\"getValidationResult\" :disabled=\"ajaxing.check\" _v-7632b310=\"\">\n        </div>\n    </form>\n    <div class=\"login-links\" _v-7632b310=\"\">\n        <div class=\"col-xs-6\" _v-7632b310=\"\">\n            <a :href=\"registerHref\" class=\"btn btn--login btn--blank\" _v-7632b310=\"\">\n                註冊\n            </a>\n        </div>\n        <div class=\"col-xs-6\" _v-7632b310=\"\">\n            <a href=\"/forgot-password\" class=\"btn btn--login btn--blank\" _v-7632b310=\"\">忘記密碼?</a>\n        </div> \n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.input-radio[_v-7632b310] {\n  display: none; }\n\n/* line 5, stdin */\n.fp-checkbox.checked[_v-7632b310], .fp-radio.checked[_v-7632b310] {\n  text-align: center;\n  color: #fefffa;\n  font-family: \"formplate\";\n  border: 1px solid #3498db;\n  background-color: #3498db; }\n\n/* line 13, stdin */\n.fp-radio[_v-7632b310] {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  margin-right: 6px;\n  margin-bottom: 5px;\n  margin-top: 0px;\n  margin-bottom: 2px;\n  width: 22px;\n  height: 22px;\n  line-height: 22px;\n  line-height: 1.375rem;\n  font-size: 10px;\n  font-size: 0.625rem;\n  vertical-align: middle;\n  border: 1px solid #d1d1d1;\n  border-radius: 50%;\n  background-clip: padding-box;\n  background-clip: border-box; }\n\n/* line 33, stdin */\n.fp-checkbox[_v-7632b310] {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  margin-right: 6px;\n  margin-bottom: 5px;\n  margin-top: 0px;\n  margin-bottom: 2px;\n  width: 22px;\n  height: 22px;\n  line-height: 22px;\n  line-height: 1.375rem;\n  font-size: 10px;\n  font-size: 0.625rem;\n  vertical-align: middle;\n  border: 1px solid #d1d1d1;\n  border-radius: 2px;\n  background-clip: padding-box;\n  background-clip: border-box; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-7632b310", module.exports)
  } else {
    hotAPI.update("_v-7632b310", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/get-iterator":46,"babel-runtime/core-js/object/entries":54,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/slicedToArray":70,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],901:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n#login-form {\n  display: none !important; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    data: function data() {
        var action = '/socialite/' + this.platformDefine + '/login';
        platform = this.$socialite.platform(this.platformDefine);

        return {
            auth: platform.loginData(this),
            platform: platform,
            action: action
        };
    },

    props: {
        destUrl: {
            type: String,
            default: null
        },
        errorUrl: {
            type: String,
            default: null
        },
        platformDefine: {
            type: String,
            required: true
        },
        showFb: {
            type: Number,
            default: 0
        },
        destUrlType: {
            type: String,
            default: 'referrer'
        }
    },
    mounted: function mounted() {},

    computed: {
        destFinalUrl: function destFinalUrl() {
            return this.getDesUrl();
        },
        errorFinalUrl: function errorFinalUrl() {
            return this.errorUrl == null ? '/error' : this.errorUrl;
        },
        hooks: function hooks() {
            var params = {
                destUrl: this.destFinalUrl,
                errorUrl: this.errorFinalUrl
            };
            return this.platform.loginHook(params);
        }
    },
    methods: {
        checkMemberLogin: function checkMemberLogin() {
            var platformName = this.platform.name();
            this.member.id = 'self';
            this.member.setContext(platformName).get({ config: {
                    params: { branch_id: this.branch_id }
                }
            });
        },
        login: function login() {
            this.platform.login(this);
        },
        afterMemberGetOk: function afterMemberGetOk() {
            this.$emit('after-member-get-ok-callback');
        },
        getDesUrl: function getDesUrl() {
            if (this.destUrl != null) {
                return this.destUrl;
            }
            switch (this.destUrlType) {
                case 'referrer':
                    return document.referrer;
                    break;
                case 'current':
                    return document.URL;
                    break;

                default:
                    return '/';
                    break;
            }
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div id=\"login-form\">\n    <form ref=\"submitLogin\" :action=\"action\" method=\"post\" enctype=\"application/json\">\n        <div v-for=\"(hook, hookName) in hooks\">\n            <div v-for=\"(param, paramName) in hook\">\n                <input type=\"hidden\" :name=\"'hooks[' + hookName + '][' + paramName + ']'\" :value=\"param\">\n            </div>\n        </div>\n\n        <div v-for=\"(param, paramName) in auth\">\n            <input type=\"hidden\" :name=\"'auth[' + paramName + ']'\" :value=\"param\">\n        </div>\n        <!--第一個special case to do refract -->\n        <input type=\"hidden\" name=\"seventeen-fit[facebook-show]\" :value=\"showFb\">\n        <button type=\"submit\">送出</button>\n    </form>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n#login-form {\n  display: none !important; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-bdf37cfa", module.exports)
  } else {
    hotAPI.update("_v-bdf37cfa", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],902:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            countries: [],
            errorMessage: '',
            form: {
                phone: '',
                country_code: 886,
                email: '',
                password: "",
                confirmpassword: ""
            },
            validation: {
                phone: '',
                email: '',
                password: "",
                confirmpassword: ""
            },
            ajaxing: {
                loading: false,
                check: false
            }
        };
    },
    mounted: function mounted() {
        this.getFromBaseData();
        var query = $17.getUrlQueryStrings();
        if (query.hasOwnProperty('error_message')) {
            this.errorMessage = query['error_message'];
            $17.removeSelectedUrlPara('error_message');
        }
    },

    computed: {
        loginHref: function loginHref() {
            return '/login' + window.location.search;
        },
        registerHref: function registerHref() {
            return '/register' + window.location.search;
        }
    },
    methods: {
        login: function login() {
            this.$refs.loginForm.login();
        },
        getValidationResult: function getValidationResult(e) {
            var _this = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                var res;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.ajaxing.check = true;
                                _context.next = 3;
                                return _this.$http.post('/register-check', _this.form).then(function (response) {
                                    _this.$refs.form.submit();
                                }).catch(function (response) {
                                    _this.validation = {
                                        phone: '',
                                        email: '',
                                        password: "",
                                        confirmpassword: ""
                                    };
                                    var data = response.data;
                                    var _iteratorNormalCompletion = true;
                                    var _didIteratorError = false;
                                    var _iteratorError = undefined;

                                    try {
                                        for (var _iterator = (0, _getIterator3.default)((0, _entries2.default)(data)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                            var _step$value = (0, _slicedToArray3.default)(_step.value, 2),
                                                key = _step$value[0],
                                                value = _step$value[1];

                                            _this.validation[key] = value.toString();
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally {
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return) {
                                                _iterator.return();
                                            }
                                        } finally {
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }

                                    _this.ajaxing.check = false;
                                });

                            case 3:
                                res = _context.sent;

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        getFromBaseData: function getFromBaseData() {
            var _this2 = this;

            this.ajaxing.loading = true;
            this.$http.get('/webapi/member/auth-from-data').then(function (response) {
                _this2.ajaxing.loading = false;
                _this2.countries = response.data.countries;
            }, function (error) {
                _this2.ajaxing.loading = false;
                return false;
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"login-box\">\n    <div class=\"login-header\">\n        <h2>註冊</h2>\n    </div> \n    <v-spinner :ajaxing=\"ajaxing.loading\"></v-spinner>\n    <form method=\"post\" :action=\"registerHref\" v-show=\"!ajaxing.loading\" ref=\"form\">\n        <div class=\"login-form clearfix\">\n            <label for=\"phone\" class=\"srt\">輸入手機號碼</label>\n            <ul class=\"phone-area\">\n                <li class=\"col-sm-3 col-xs-4 no-padding\">\n                    <span class=\"fp-select\">\n                        <select name=\"country_code\" v-model=\"form.country_code\">\n                            <option :value=\"country.country_code\" v-for=\"country in countries\">\n                                {{country.iso_code}}&nbsp;&nbsp;+{{country.country_code}}\n                            </option> \n                        </select>\n                    </span>\n                </li>\n                <li class=\"col-sm-9 col-xs-8 no-padding\">\n                    <input placeholder=\"輸入手機號碼\" name=\"phone\" type=\"number\" v-model=\"form.phone\">\n                </li>\n            </ul>\n            <div class=\"clearfix\"></div>\n            <div id=\"error--message\">{{validation.phone}}</div>\n           \n            <label for=\"name\" class=\"srt\">name</label>\n            <input placeholder=\"真實姓名\" name=\"name\" type=\"name\" v-model=\"form.name\">\n            <div id=\"error--message\">{{validation.name}}</div>\n\n            <label for=\"email\" class=\"srt\">Email</label>\n            <input placeholder=\"輸入電子郵件\" name=\"email\" type=\"email\" v-model=\"form.email\">\n            <div id=\"error--message\">{{validation.email}}</div>\n\n            <label for=\"password\" class=\"srt\">輸入密碼</label>\n            <input placeholder=\"輸入密碼\" name=\"password\" type=\"password\" value=\"\" id=\"password\" v-model=\"form.password\">\n            <div id=\"error--message\">{{validation.password}}</div>\n\n            <label for=\"password\" class=\"srt\">確認密碼</label>\n            <input placeholder=\"確認密碼\" name=\"confirmpassword\" type=\"password\" value=\"\" id=\"confirmpassword\" v-model=\"form.confirmpassword\">\n            <div id=\"error--message\">{{validation.confirmpassword}}</div>\n\n            <input type=\"button\" value=\"註冊\" class=\"btn btn--login\" @click=\"getValidationResult\" :disabled=\"ajaxing.check\">\n        </div>\n    </form>\n    <div class=\"login-links\">\n        <div class=\"col-xs-12\">\n            <a :href=\"loginHref\" class=\"btn btn--login btn--blank\">\n                登入\n            </a>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-5599df0e", module.exports)
  } else {
    hotAPI.update("_v-5599df0e", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/get-iterator":46,"babel-runtime/core-js/object/entries":54,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/slicedToArray":70,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785}],903:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n#login-form {\n  display: none !important; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    data: function data() {
        var action = '/socialite/' + this.platformDefine + '/register';
        platform = this.$socialite.platform(this.platformDefine);

        return {
            auth: platform.loginData(this),
            platform: platform,
            action: action
        };
    },

    props: {
        destUrl: {
            type: String,
            default: null
        },
        errorUrl: {
            type: String,
            default: null
        },
        platformDefine: {
            type: String,
            required: true
        },
        showFb: {
            type: Number,
            default: 0
        },
        destUrlType: {
            type: String,
            default: 'referrer'
        }
    },
    mounted: function mounted() {},

    computed: {
        destFinalUrl: function destFinalUrl() {
            var url = new URL(this.getDesUrl());
            var params = new URLSearchParams(url.search);
            params.set('promote_event', 'register_success');
            url.search = params.toString();
            return url.href;
        },
        errorFinalUrl: function errorFinalUrl() {
            return this.errorUrl == null ? '/error' : this.errorUrl;
        },
        hooks: function hooks() {
            var params = {
                destUrl: this.destFinalUrl,
                errorUrl: this.errorFinalUrl
            };
            return this.platform.loginHook(params);
        }
    },
    methods: {
        checkMemberLogin: function checkMemberLogin() {
            var platformName = this.platform.name();
            this.member.id = 'self';
            this.member.setContext(platformName).get({ config: {
                    params: { branch_id: this.branch_id }
                }
            });
        },
        login: function login() {
            this.platform.login(this);
        },
        afterMemberGetOk: function afterMemberGetOk() {
            this.$emit('after-member-get-ok-callback');
        },
        getDesUrl: function getDesUrl() {
            if (this.destUrl != null) {
                return this.destUrl;
            }
            switch (this.destUrlType) {
                case 'referrer':
                    return document.referrer;
                    break;
                case 'current':
                    return document.URL;
                    break;

                default:
                    return '/';
                    break;
            }
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div id=\"login-form\">\n    <form ref=\"submitLogin\" :action=\"action\" method=\"post\" enctype=\"application/json\">\n        <div v-for=\"(hook, hookName) in hooks\">\n            <div v-for=\"(param, paramName) in hook\">\n                <input type=\"hidden\" :name=\"'hooks[' + hookName + '][' + paramName + ']'\" :value=\"param\">\n            </div>\n        </div>\n\n        <div v-for=\"(param, paramName) in auth\">\n            <input type=\"hidden\" :name=\"'auth[' + paramName + ']'\" :value=\"param\">\n        </div>\n        <!--第一個special case to do refract -->\n        <input type=\"hidden\" name=\"seventeen-fit[facebook-show]\" :value=\"showFb\">\n        <input type=\"hidden\" name=\"destUrl\" :value=\"destUrl\">\n        <button type=\"submit\">送出</button>\n    </form>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n#login-form {\n  display: none !important; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-de9757a6", module.exports)
  } else {
    hotAPI.update("_v-de9757a6", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],904:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['currentBranch'],
    computed: {
        tags: function tags() {
            if (this.currentBranch.classsort) {
                return this.currentBranch.classsort.split(',');
            }
            return [];
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div id=\"info\" class=\"sbig-hidden tabContent-list _info branch_data\" style=\"margin: 0 16px;\">\n    <p class=\"regular\">{{ currentBranch.introduction }}</p>\n    <div class=\"m-top-25\">\n        <span class=\"label label-info primary-business-color-background m-right-5\" v-for=\"type in tags\">{{ type }}</span>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-719665e9", module.exports)
  } else {
    hotAPI.update("_v-719665e9", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],905:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['branchUrl', 'studioUrl', 'isWebstudio', 'filterOption', 'categories', 'branchId'],
    data: function data() {
        return {
            ajaxing: false,
            config: {
                recently_days: 21,
                far_future_days: 90
            },
            showBtn: false,
            allowChangeShowBtn: true,
            pageMeta: {},
            scheduleGroup: [],
            isAllowFetchNext: false
        };
    },

    computed: {
        noData: function noData() {
            return this.scheduleGroup.length <= 0;
        }
    },
    watch: {
        filterOption: function filterOption(newVal) {
            if (newVal) {
                this.reset();
                this.fetchData();
            }
        }
    },
    mounted: function mounted() {
        this.fetchData();
    },

    methods: {
        reset: function reset() {
            this.showBtn = false;
            this.allowChangeShowBtn = true;
            this.pageMeta = {};
            this.scheduleGroup = [];
            this.isAllowFetchNext = false;
        },
        loadMore: function loadMore() {
            this.showBtn = false;
            this.allowChangeShowBtn = false;
            this.fetchData(true, true);
        },
        formatShowDate: function formatShowDate(date) {
            return $17.formateDisplayDate(date, 'MM/DD', true);
        },
        fetchData: function fetchData() {
            var _this = this;

            var isFetchNext = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            var loadOverRecently = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            if (this.ajaxing) return;
            this.ajaxing = true;
            var page = isFetchNext ? this.pageMeta.currentPage + 1 : 1;
            if (loadOverRecently && Number(this.pageMeta.total) < this.config.recently_days) {
                page = this.pageMeta.currentPage;
            }
            var categoryName = _lodash2.default.find(this.categories, function (name, id) {
                return id > 0 ? id === _this.filterOption.category : '';
            });
            this.$http.get('/webapi/branch-class-schedule/' + this.branchId, {
                'params': {
                    date: moment().format('YYYY-MM-DD'),
                    today_class_service_provider_id: this.filterOption.staff > 0 ? '[' + this.filterOption.staff + ']' : '',
                    keyword: categoryName,
                    view_type: 'agenda',
                    page: page,
                    only_recently: this.allowChangeShowBtn ? 1 : 0,
                    load_over_recently: loadOverRecently ? 1 : 0
                }
            }).then(function (response) {
                _this.config = response.data.config;
                _this.prepareShowDate(response);
                _this.ajaxing = false;
            }, function (error) {
                var type = error.data.hasOwnProperty('msg') && error.data.msg === 'ThrottleRequestsException' ? 'warning' : 'error';
                var err = error.data.hasOwnProperty('message') ? error.data.message : "讀取資料發生錯誤，請重新嘗試";
                $17.swal({
                    type: type,
                    title: err,
                    showCancelButton: false
                });
                _this.ajaxing = false;
            });
        },
        fetchNext: function fetchNext() {
            if (this.isAllowFetchNext) {
                this.fetchData(true);
            }
        },
        removeDuplicate: function removeDuplicate(pageData) {
            var _this2 = this;

            return pageData.reduce(function (carry, item) {
                var found = _this2.scheduleGroup.find(function (element) {
                    return element.date === item.date;
                });
                if (!found) carry.push(item);
                return carry;
            }, []);
        },
        prepareShowDate: function prepareShowDate(response) {
            if (!response.data.pageData || !response.data.pageMeta) return;
            this.pageMeta = response.data.pageMeta;
            if (this.scheduleGroup.length) {
                this.scheduleGroup = this.scheduleGroup.concat(this.removeDuplicate(response.data.pageData));
            } else {
                this.scheduleGroup = response.data.pageData;
            }

            var isNextAvailable = this.pageMeta.hasOwnProperty('currentPage') && this.pageMeta.hasOwnProperty('lastPage') && this.pageMeta.currentPage != this.pageMeta.lastPage;
            this.isAllowFetchNext = isNextAvailable;
            if (this.allowChangeShowBtn) {
                this.showBtn = !isNextAvailable;
            }
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div>\n    <section id=\"site-content\" class=\"search-result\">\n        <div class=\"results\">\n            <div v-if=\"!noData\">\n                <div v-for=\"(group,idx) in scheduleGroup\">\n                    <v-class-table :head-css-class=\"{'m-t-24':idx>0}\" :schedules=\"group.schedules\" :show-custom-head=\"true\" :lazy-loading=\"true\" :is-webstudio=\"isWebstudio\" :fetch-next=\"fetchNext\">\n                        <div slot=\"table-head\">\n                            <span>{{ formatShowDate(group.date) }}</span>\n                        </div>\n                    </v-class-table>\n                </div>\n            </div>\n            <div v-if=\"noData&amp;&amp;!ajaxing\" style=\"text-align: center; padding: 25px 0;\">\n                <img src=\"/images/noData.svg\" width=\"105\" height=\"60\">\n                <div style=\"color: #6c6c6c;\" class=\"m-top-10\">{{ i18n.t('class.have_no_any_class') }}</div>\n            </div>\n            <div v-if=\"!ajaxing &amp;&amp; showBtn\" class=\"st-text-center st-mt-7\">\n                <div class=\"st-mb-3 st-text-16\">{{ i18n.t('class.already_display_recently_classes') }}</div>\n                <st-button neutral=\"\" @click=\"loadMore\" class=\"st-m-auto st-px-20 !st-px-20\">{{ i18n.t('class.show_more') }}</st-button>\n            </div>\n            <v-spinner :ajaxing=\"ajaxing\"></v-spinner>\n        </div>\n    </section>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-a5b7dd12", module.exports)
  } else {
    hotAPI.update("_v-a5b7dd12", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"lodash":717,"vue":792,"vue-hot-reload-api":785}],906:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 3, stdin */\n.search-section.modal-search[_v-77f61a2c] {\n  max-width: 500px;\n  margin: 60px auto;\n  padding: 0 20px;\n  text-align: center; }\n\n/* line 9, stdin */\n.search-section .btn[_v-77f61a2c] {\n  padding: 8px 16px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['serviceProviders', 'categories', 'filterOption', 'updateQuery'],
    data: function data() {
        return {
            staff: '',
            category: ''
        };
    },

    methods: {
        showModal: function showModal() {
            this.staff = this.filterOption.staff;
            this.category = this.filterOption.category;
            $('#class-filter-modal').modal('show');
        },
        resetAll: function resetAll() {
            this.staff = '';
            this.category = '';
        },
        showResult: function showResult() {
            this.updateQuery({
                staff: this.staff,
                category: this.category
            });
            $('#class-filter-modal').modal('hide');
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-77f61a2c=\"\">\n    <v-modal id=\"class-filter-modal\" border-radius-level=\"20px\" no-footer=\"\" _v-77f61a2c=\"\">\n        <div slot=\"title\" _v-77f61a2c=\"\">\n            <font class=\"title-5 grey--100\" _v-77f61a2c=\"\">{{ i18n.t('general.filter_by') }}</font>\n        </div>\n        <div slot=\"body\" _v-77f61a2c=\"\">\n            <div id=\"branch-class-tab\" class=\"search-section modal-search\" _v-77f61a2c=\"\">\n                <div class=\"m-bottom-15\" _v-77f61a2c=\"\">\n                    <div class=\"select dropdown-select\" _v-77f61a2c=\"\">\n                        <span class=\"fp-select\" _v-77f61a2c=\"\">\n                            <select class=\"grey--100\" name=\"service_provider\" v-model=\"staff\" _v-77f61a2c=\"\">\n                                <option v-for=\"(item, key) in serviceProviders\" :value=\"key\" _v-77f61a2c=\"\">{{item}}</option>\n                            </select>\n                        </span>\n                    </div>\n                </div>\n                <div class=\"m-bottom-15\" _v-77f61a2c=\"\">\n                    <div class=\"select dropdown-select\" _v-77f61a2c=\"\">\n                        <span class=\"fp-select\" _v-77f61a2c=\"\">\n                            <select class=\"grey--100\" name=\"service_category\" v-model=\"category\" _v-77f61a2c=\"\">\n                                <option v-for=\"(item, key) in categories\" :value=\"key\" _v-77f61a2c=\"\">{{item}}</option>\n                            </select>\n                        </span>\n                    </div>\n                </div>\n                <div style=\"margin-top: 40px;\" _v-77f61a2c=\"\">\n                    <a class=\"btn btn-primary--label m-top-10\" @click.prevent=\"showResult\" _v-77f61a2c=\"\">{{ i18n.t('general.show_result') }}</a>\n                    <a class=\"btn btn-default--label m-top-10\" @click.prevent=\"resetAll\" _v-77f61a2c=\"\">{{ i18n.t('general.reset') }}</a>                    \n                </div>\n            </div>\n        </div>\n    </v-modal>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 3, stdin */\n.search-section.modal-search[_v-77f61a2c] {\n  max-width: 500px;\n  margin: 60px auto;\n  padding: 0 20px;\n  text-align: center; }\n\n/* line 9, stdin */\n.search-section .btn[_v-77f61a2c] {\n  padding: 8px 16px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-77f61a2c", module.exports)
  } else {
    hotAPI.update("_v-77f61a2c", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],907:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 3, stdin */\n.v-booking-btn .tippy-content {\n  background-color: #555;\n  color: #fff;\n  border-radius: 6px;\n  border-width: 5px;\n  border-style: solid;\n  border-color: #555 transparent transparent transparent; }\n\n/* line 11, stdin */\n.v-booking-btn .tippy-box[data-placement^=top] > .tippy-arrow:before {\n  border-top-color: #555; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _tippy = require('tippy.js');

var _tippy2 = _interopRequireDefault(_tippy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['schedule'],
    computed: {
        buttonState: function buttonState() {
            var state = this.schedule.btn_attributes.class;
            if (state.includes("bookingNormal")) {
                return 'avaliable';
            } else if (state.includes("bookingInverse")) {
                return 'waiting';
            } else {
                return 'disable';
            }
        }
    },
    mounted: function mounted() {
        var disableBtn = $(this.$el).find('.bookingDisalbed')[0];
        if (disableBtn) {
            var tooltip = (0, _tippy2.default)(disableBtn, {
                content: this.schedule.message || '',
                duration: 0,
                arrow: true,
                placement: 'top',
                interactive: true
            });
        }
    },

    methods: {
        booking: function booking() {
            return window.location.href = this.schedule.btn_link_url;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"v-booking-btn\">\n    <span v-if=\"buttonState == 'avaliable'\" @click=\"booking\">\n        <a class=\"bookingNormal primary-business-color-background-hover\">{{ schedule.btn_title }}</a>\n    </span>\n    <span v-if=\"buttonState == 'waiting'\" @click=\"booking\">\n        <a class=\"bookingInverse\">{{ schedule.btn_title }}</a>\n    </span>\n    <span v-if=\"buttonState == 'disable'\">\n        <a class=\"bookingDisalbed\">{{ schedule.btn_title }}</a>\n    </span>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 3, stdin */\n.v-booking-btn .tippy-content {\n  background-color: #555;\n  color: #fff;\n  border-radius: 6px;\n  border-width: 5px;\n  border-style: solid;\n  border-color: #555 transparent transparent transparent; }\n\n/* line 11, stdin */\n.v-booking-btn .tippy-box[data-placement^=top] > .tippy-arrow:before {\n  border-top-color: #555; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-09ef0ba0", module.exports)
  } else {
    hotAPI.update("_v-09ef0ba0", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"tippy.js":780,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],908:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.m-t-24[_v-399a4f78] {\n  margin-top: 24px; }\n\n/* line 6, stdin */\n.classes-table[_v-399a4f78] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  width: 100%; }\n  /* line 12, stdin */\n  .classes-table .classes-container[_v-399a4f78] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n    -ms-flex-pack: justify;\n        justify-content: space-between;\n    padding: 15px 5px;\n    border-bottom: 1px solid #D5D5D5; }\n    /* line 19, stdin */\n    .classes-table .classes-container .ellipsis[_v-399a4f78] {\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis; }\n    /* line 26, stdin */\n    .classes-table .classes-container .class-detail .first[_v-399a4f78] {\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-pack: start;\n          justify-content: start;\n      -ms-flex-align: center;\n          align-items: center; }\n      /* line 31, stdin */\n      .classes-table .classes-container .class-detail .first span[_v-399a4f78] {\n        padding-right: 10px; }\n        /* line 34, stdin */\n        .classes-table .classes-container .class-detail .first span [_v-399a4f78]:not(:last-child) {\n          padding-right: 10px; }\n      /* line 39, stdin */\n      .classes-table .classes-container .class-detail .first span + span[_v-399a4f78] {\n        padding-left: 10px;\n        border-left: 1px solid #D5D5D5; }\n    /* line 46, stdin */\n    .classes-table .classes-container .class-detail .second .badge + .badge[_v-399a4f78] {\n      margin-left: 3px; }\n    /* line 51, stdin */\n    .classes-table .classes-container .class-detail .staff-img[_v-399a4f78] {\n      width: 24px;\n      height: 24px;\n      border-radius: 50%;\n      margin-right: 6px; }\n    /* line 58, stdin */\n    .classes-table .classes-container .class-detail .badge[_v-399a4f78] {\n      margin-top: 10px;\n      padding: 7px 8px;\n      border-radius: 32px;\n      font-weight: normal; }\n    /* line 67, stdin */\n    .classes-table .classes-container .class-btn .btn[_v-399a4f78] {\n      background-color: #171725;\n      color: white;\n      display: block;\n      width: 74px;\n      height: 36px;\n      font-size: 15px;\n      border-radius: 4px; }\n      /* line 76, stdin */\n      .classes-table .classes-container .class-btn .btn[_v-399a4f78]:hover {\n        background: linear-gradient(0deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.08)), #171725; }\n      /* line 80, stdin */\n      .classes-table .classes-container .class-btn .btn.check-btn[_v-399a4f78] {\n        background-color: white;\n        color: #171725;\n        border: 1px solid #171725; }\n        /* line 85, stdin */\n        .classes-table .classes-container .class-btn .btn.check-btn[_v-399a4f78]:hover {\n          background: rgba(0, 0, 0, 0.04); }\n  /* line 93, stdin */\n  .classes-table .table-row[_v-399a4f78] {\n    height: 2em;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: row;\n        flex-direction: row;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    -ms-flex-pack: left;\n        justify-content: left;\n    -ms-flex-align: center;\n        align-items: center;\n    min-height: 40px;\n    height: auto; }\n    /* line 102, stdin */\n    .classes-table .table-row.table-head[_v-399a4f78] {\n      background-color: #E2E2EA;\n      border-radius: 100px;\n      padding: 0 16px;\n      font-size: 16px; }\n    /* line 108, stdin */\n    .classes-table .table-row.custom-sticky-head[_v-399a4f78] {\n      position: -webkit-sticky;\n      position: sticky;\n      top: 104px;\n      background: white;\n      z-index: 1; }\n      /* line 113, stdin */\n      .classes-table .table-row.custom-sticky-head .table-head[_v-399a4f78] {\n        background-color: #E2E2EA;\n        border-radius: 100px;\n        padding: 8px 16px;\n        font-size: 16px;\n        width: 100%; }\n    /* line 121, stdin */\n    .classes-table .table-row.table-body[_v-399a4f78]:nth-child(odd) {\n      border-bottom: 1px solid #EEEEEE; }\n    /* line 124, stdin */\n    .classes-table .table-row.table-body[_v-399a4f78]:last-child {\n      border-bottom: none; }\n    /* line 127, stdin */\n    .classes-table .table-row .header[_v-399a4f78] {\n      font-size: 16px; }\n    /* line 130, stdin */\n    .classes-table .table-row .align-center[_v-399a4f78] {\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-align: center;\n          align-items: center; }\n  /* line 135, stdin */\n  .classes-table .w-40[_v-399a4f78] {\n    width: 40%; }\n  /* line 136, stdin */\n  .classes-table .w-20[_v-399a4f78] {\n    width: 20%; }\n  /* line 137, stdin */\n  .classes-table .business-color[_v-399a4f78] {\n    color: #38B0E3; }\n\n@media (max-width: 1000px) {\n  /* line 142, stdin */\n  span.ellipsis[_v-399a4f78] {\n    max-width: 160px; }\n  /* line 145, stdin */\n  .classes-table[_v-399a4f78] {\n    padding: 0 8px; }\n    /* line 148, stdin */\n    .classes-table .table-row.custom-sticky-head[_v-399a4f78] {\n      top: 88px;\n      padding-top: 5px; }\n  /* line 154, stdin */\n  .results[_v-399a4f78] {\n    margin: 0 16px; } }\n\n@media (max-width: 768px) {\n  /* line 159, stdin */\n  span.ellipsis[_v-399a4f78] {\n    max-width: 160px; }\n  /* line 164, stdin */\n  .classes-table .table-row.custom-sticky-head[_v-399a4f78] {\n    top: 142px;\n    padding-top: 5px; }\n  /* line 169, stdin */\n  .classes-table .w-40[_v-399a4f78] {\n    width: 60%; } }\n\n@media (max-width: 576px) {\n  /* line 175, stdin */\n  span.ellipsis.staff[_v-399a4f78] {\n    max-width: 96px; }\n  /* line 178, stdin */\n  span.ellipsis.category[_v-399a4f78] {\n    max-width: 64px; }\n  /* line 182, stdin */\n  .classes-table .w-40[_v-399a4f78] {\n    width: 100%; }\n  /* line 183, stdin */\n  .classes-table .w-20[_v-399a4f78] {\n    width: auto;\n    margin-bottom: 8px; } }\n")
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        schedules: {
            type: [Array, Object, String]
        },
        lazyLoading: {
            type: Boolean,
            default: true
        },
        showCustomHead: {
            type: Boolean,
            default: false,
            description: "搭配 slot=table-head 使用"
        },
        headCssClass: {
            type: [String, Object],
            default: ''
        },
        fetchNext: {},
        isWebstudio: {
            type: [Boolean, Number],
            default: false
        }
    },
    mounted: function mounted() {
        document.addEventListener("scroll", this.handleScroll);
    },

    methods: {
        allowAppointment: function allowAppointment(schedule) {
            var showExpired = this.showExpired(schedule);
            var showUnavailable = this.showUnavailable(schedule);
            var showFull = this.showFull(schedule);
            return !(showExpired || showUnavailable || showFull);
        },
        showFull: function showFull(schedule) {
            return Number(schedule.empty_seats) < 1;
        },
        showExpired: function showExpired(schedule) {
            var close = (0, _moment2.default)(schedule.booking_window_close_at, ['YYYY-MM-DD HH:mm:ss']);
            return (0, _moment2.default)().isAfter(close);
        },
        showUnavailable: function showUnavailable(schedule) {
            var open = (0, _moment2.default)(schedule.booking_window_open_at, ['YYYY-MM-DD HH:mm:ss']);
            return (0, _moment2.default)().isBefore(open);
        },
        book: function book(schedule) {
            window.location.href = window.location.origin + '/myclass-confirm/' + schedule.id;
        },
        handleScroll: function handleScroll() {
            if (!this.lazyLoading) return;
            var rootElement = document.documentElement;
            var scrollTotal = rootElement.scrollHeight - rootElement.clientHeight;
            var ratio = rootElement.scrollTop / scrollTotal;
            if (ratio > 0.8) {
                this.fetchNext && this.fetchNext();
            }
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"classes-table\" _v-399a4f78=\"\">\n    <div class=\"table-row custom-sticky-head m-top-5\" :class=\"headCssClass\" v-if=\"showCustomHead\" _v-399a4f78=\"\">\n        <div class=\"table-head\" _v-399a4f78=\"\">\n            <slot name=\"table-head\" _v-399a4f78=\"\"></slot>\n        </div>\n    </div>\n    <template v-for=\"schedule in schedules\">\n        <div class=\"classes-container\" _v-399a4f78=\"\">\n            <div class=\"class-info\" _v-399a4f78=\"\">\n                <div class=\"class-name st-flex st-items-center\" _v-399a4f78=\"\">\n                    <img v-if=\"schedule.is_livestream\" class=\"m-right-5\" :alt=\"schedule.name\" src=\"/images/live-stream.png\" width=\"30px\" _v-399a4f78=\"\">\n                    <font class=\"title-5 grey--100\" _v-399a4f78=\"\">{{schedule.name}}</font>\n                </div>\n                <div class=\"class-detail m-top-10 grey--90\" _v-399a4f78=\"\">\n                    <div class=\"first\" _v-399a4f78=\"\">\n                        <span _v-399a4f78=\"\">{{schedule.service_start_time}} ~ {{schedule.service_end_time}}</span>\n                        <span v-if=\"schedule.service_provider_name\" class=\"staff ellipsis\" _v-399a4f78=\"\">\n                            <img class=\"staff-img st-border st-border-solid st-border-gray-40\" :alt=\"schedule.service_provider_name\" :src=\"schedule.service_provider_profile_small_photo\" _v-399a4f78=\"\">\n                            {{ schedule.service_provider_name }}\n                        </span>\n                        <span class=\"category ellipsis\" _v-399a4f78=\"\">{{schedule.category_name}}</span>\n                    </div>\n                    <div class=\"second\" _v-399a4f78=\"\">\n                        <span class=\"badge badge-primary\" v-if=\"showExpired(schedule)\" _v-399a4f78=\"\">{{ i18n.t('class.closed') }}</span>\n                        <span class=\"badge badge-primary\" v-else-if=\"showUnavailable(schedule)\" _v-399a4f78=\"\">{{ i18n.t('class.unavailable') }}</span>\n                        <span class=\"badge background-grey--10 grey--80 border-grey--80\" v-else-if=\"showFull(schedule)\" _v-399a4f78=\"\">{{ i18n.t('class.fully_booked') }}</span>\n                    </div>\n                </div>\n            </div>\n            <div class=\"class-btn text-center\" _v-399a4f78=\"\">\n                <button v-if=\"allowAppointment(schedule)\" class=\"btn\" @click=\"book(schedule)\" _v-399a4f78=\"\">{{ i18n.t('general.appointment') }}</button>\n                <button v-else=\"\" class=\"btn check-btn\" @click=\"book(schedule)\" _v-399a4f78=\"\">{{ i18n.t('general.check') }}</button>\n                <div class=\"m-top-5\" v-if=\"isWebstudio &amp;&amp; schedule.seat_info_style\" _v-399a4f78=\"\">{{schedule.seat_info_style}}</div>\n            </div>\n        </div>\n    </template>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.m-t-24[_v-399a4f78] {\n  margin-top: 24px; }\n\n/* line 6, stdin */\n.classes-table[_v-399a4f78] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  width: 100%; }\n  /* line 12, stdin */\n  .classes-table .classes-container[_v-399a4f78] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n    -ms-flex-pack: justify;\n        justify-content: space-between;\n    padding: 15px 5px;\n    border-bottom: 1px solid #D5D5D5; }\n    /* line 19, stdin */\n    .classes-table .classes-container .ellipsis[_v-399a4f78] {\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis; }\n    /* line 26, stdin */\n    .classes-table .classes-container .class-detail .first[_v-399a4f78] {\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-pack: start;\n          justify-content: start;\n      -ms-flex-align: center;\n          align-items: center; }\n      /* line 31, stdin */\n      .classes-table .classes-container .class-detail .first span[_v-399a4f78] {\n        padding-right: 10px; }\n        /* line 34, stdin */\n        .classes-table .classes-container .class-detail .first span [_v-399a4f78]:not(:last-child) {\n          padding-right: 10px; }\n      /* line 39, stdin */\n      .classes-table .classes-container .class-detail .first span + span[_v-399a4f78] {\n        padding-left: 10px;\n        border-left: 1px solid #D5D5D5; }\n    /* line 46, stdin */\n    .classes-table .classes-container .class-detail .second .badge + .badge[_v-399a4f78] {\n      margin-left: 3px; }\n    /* line 51, stdin */\n    .classes-table .classes-container .class-detail .staff-img[_v-399a4f78] {\n      width: 24px;\n      height: 24px;\n      border-radius: 50%;\n      margin-right: 6px; }\n    /* line 58, stdin */\n    .classes-table .classes-container .class-detail .badge[_v-399a4f78] {\n      margin-top: 10px;\n      padding: 7px 8px;\n      border-radius: 32px;\n      font-weight: normal; }\n    /* line 67, stdin */\n    .classes-table .classes-container .class-btn .btn[_v-399a4f78] {\n      background-color: #171725;\n      color: white;\n      display: block;\n      width: 74px;\n      height: 36px;\n      font-size: 15px;\n      border-radius: 4px; }\n      /* line 76, stdin */\n      .classes-table .classes-container .class-btn .btn[_v-399a4f78]:hover {\n        background: linear-gradient(0deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.08)), #171725; }\n      /* line 80, stdin */\n      .classes-table .classes-container .class-btn .btn.check-btn[_v-399a4f78] {\n        background-color: white;\n        color: #171725;\n        border: 1px solid #171725; }\n        /* line 85, stdin */\n        .classes-table .classes-container .class-btn .btn.check-btn[_v-399a4f78]:hover {\n          background: rgba(0, 0, 0, 0.04); }\n  /* line 93, stdin */\n  .classes-table .table-row[_v-399a4f78] {\n    height: 2em;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: row;\n        flex-direction: row;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    -ms-flex-pack: left;\n        justify-content: left;\n    -ms-flex-align: center;\n        align-items: center;\n    min-height: 40px;\n    height: auto; }\n    /* line 102, stdin */\n    .classes-table .table-row.table-head[_v-399a4f78] {\n      background-color: #E2E2EA;\n      border-radius: 100px;\n      padding: 0 16px;\n      font-size: 16px; }\n    /* line 108, stdin */\n    .classes-table .table-row.custom-sticky-head[_v-399a4f78] {\n      position: -webkit-sticky;\n      position: sticky;\n      top: 104px;\n      background: white;\n      z-index: 1; }\n      /* line 113, stdin */\n      .classes-table .table-row.custom-sticky-head .table-head[_v-399a4f78] {\n        background-color: #E2E2EA;\n        border-radius: 100px;\n        padding: 8px 16px;\n        font-size: 16px;\n        width: 100%; }\n    /* line 121, stdin */\n    .classes-table .table-row.table-body[_v-399a4f78]:nth-child(odd) {\n      border-bottom: 1px solid #EEEEEE; }\n    /* line 124, stdin */\n    .classes-table .table-row.table-body[_v-399a4f78]:last-child {\n      border-bottom: none; }\n    /* line 127, stdin */\n    .classes-table .table-row .header[_v-399a4f78] {\n      font-size: 16px; }\n    /* line 130, stdin */\n    .classes-table .table-row .align-center[_v-399a4f78] {\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-align: center;\n          align-items: center; }\n  /* line 135, stdin */\n  .classes-table .w-40[_v-399a4f78] {\n    width: 40%; }\n  /* line 136, stdin */\n  .classes-table .w-20[_v-399a4f78] {\n    width: 20%; }\n  /* line 137, stdin */\n  .classes-table .business-color[_v-399a4f78] {\n    color: #38B0E3; }\n\n@media (max-width: 1000px) {\n  /* line 142, stdin */\n  span.ellipsis[_v-399a4f78] {\n    max-width: 160px; }\n  /* line 145, stdin */\n  .classes-table[_v-399a4f78] {\n    padding: 0 8px; }\n    /* line 148, stdin */\n    .classes-table .table-row.custom-sticky-head[_v-399a4f78] {\n      top: 88px;\n      padding-top: 5px; }\n  /* line 154, stdin */\n  .results[_v-399a4f78] {\n    margin: 0 16px; } }\n\n@media (max-width: 768px) {\n  /* line 159, stdin */\n  span.ellipsis[_v-399a4f78] {\n    max-width: 160px; }\n  /* line 164, stdin */\n  .classes-table .table-row.custom-sticky-head[_v-399a4f78] {\n    top: 142px;\n    padding-top: 5px; }\n  /* line 169, stdin */\n  .classes-table .w-40[_v-399a4f78] {\n    width: 60%; } }\n\n@media (max-width: 576px) {\n  /* line 175, stdin */\n  span.ellipsis.staff[_v-399a4f78] {\n    max-width: 96px; }\n  /* line 178, stdin */\n  span.ellipsis.category[_v-399a4f78] {\n    max-width: 64px; }\n  /* line 182, stdin */\n  .classes-table .w-40[_v-399a4f78] {\n    width: 100%; }\n  /* line 183, stdin */\n  .classes-table .w-20[_v-399a4f78] {\n    width: auto;\n    margin-bottom: 8px; } }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-399a4f78", module.exports)
  } else {
    hotAPI.update("_v-399a4f78", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"moment":727,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],909:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.sticky-day-selector[_v-2a3e7655] {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 101px;\n  background: white; }\n\n@media (max-width: 1000px) {\n  /* line 8, stdin */\n  .sticky-day-selector[_v-2a3e7655] {\n    top: 89px; } }\n\n@media (max-width: 768px) {\n  /* line 13, stdin */\n  .sticky-day-selector[_v-2a3e7655] {\n    top: 142px; } }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['branchUrl', 'studioUrl', 'isWebstudio', 'filterOption', 'updateQuery', 'branchId'],
    data: function data() {
        return {
            ajaxing: false,
            config: {
                recently_days: 21,
                far_future_days: 90
            },
            current: {
                date: '',
                page: 1,
                ajaxingMore: true
            },
            schedules: [],
            pageMeta: {}
        };
    },

    computed: {
        noData: function noData() {
            return this.schedules.length <= 0;
        }
    },
    mounted: function mounted() {
        this.refresh();
    },

    methods: {
        refresh: function refresh() {
            var _this = this;

            if (this.ajaxing) return;
            this.current.date = this.filterOption.date || moment().format('YYYY/MM/DD');
            this.current.page = 0;
            this.$nextTick(function () {
                $17.daySelector({
                    el: '#day-selector-v2',
                    widthRef: '#vue-branch-app',
                    loadWhenReady: true,
                    dayStart: new Date(),
                    selectedDay: _this.current.date,
                    type: 'd',
                    count: Number(_this.config.far_future_days - 1), //顯示包含今天需-1
                    trigger: _this.fetchData,
                    disableDateClick: _this.ajaxing
                });
            });
        },
        fetchData: function fetchData(date) {
            var _this2 = this;

            var flag = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            if (this.ajaxing) return;
            if (this.current.date == date) {
                this.current.page++;
            } else {
                this.schedules = [];
                this.current.date = date;
                this.updateQuery({ date: date });
                this.current.page = 1;
            }
            this.ajaxing = true;
            flag.ajaxing = true;
            this.$http.get('/webapi/branch-class-schedule/' + this.branchId, {
                'params': {
                    date: this.dateFormat(date),
                    page: this.current.page,
                    view_type: 'day'
                }
            }).then(function (response) {
                _this2.config = response.data.config;
                _this2.prepareShowDate(response);
                _this2.ajaxing = false;
                flag.ajaxing = false;
            }, function (error) {
                var type = error.data.hasOwnProperty('msg') && error.data.msg === 'ThrottleRequestsException' ? 'warning' : 'error';
                var err = error.data.hasOwnProperty('message') ? error.data.message : "讀取資料發生錯誤，請重新嘗試";
                $17.swal({
                    type: type,
                    title: err,
                    showCancelButton: false
                });
                _this2.ajaxing = false;
                flag.ajaxing = false;
            });
        },
        prepareShowDate: function prepareShowDate(response) {
            if (!response.data.pageData || !response.data.pageMeta) return;
            if (this.current.page > 1) {
                this.schedules = this.schedules.concat(response.data.pageData);
            } else {
                this.schedules = response.data.pageData;
            }

            this.pageMeta = response.data.pageMeta;
            var isNextAvailable = this.pageMeta.hasOwnProperty('currentPage') && this.pageMeta.hasOwnProperty('lastPage') && this.pageMeta.currentPage != this.pageMeta.lastPage;
            this.current.ajaxingMore = isNextAvailable;
        },
        fetchNextPage: function fetchNextPage() {
            if (this.current.ajaxingMore) {
                this.fetchData(this.current.date);
            }
        },
        dateFormat: function dateFormat(date) {
            return date.split('/').join('-');
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-2a3e7655=\"\">\n    <div class=\"sticky-day-selector\" _v-2a3e7655=\"\">\n        <div id=\"day-selector-v2\" _v-2a3e7655=\"\"></div>\n    </div>\n    <section id=\"site-content\" class=\"search-result\" _v-2a3e7655=\"\">\n        <div class=\"results\" _v-2a3e7655=\"\">\n            <div v-if=\"!noData\" _v-2a3e7655=\"\">\n                <v-class-table :schedules=\"schedules\" :lazy-loading=\"true\" :is-webstudio=\"isWebstudio\" :fetch-next=\"fetchNextPage\" _v-2a3e7655=\"\">\n                </v-class-table>\n            </div>\n            <div v-if=\"noData&amp;&amp;!ajaxing\" style=\"text-align: center; padding: 25px 0;\" _v-2a3e7655=\"\">\n                <img src=\"/images/noData.svg\" width=\"105\" height=\"60\" _v-2a3e7655=\"\">\n                <div style=\"color: #6c6c6c;\" class=\"m-top-10\" _v-2a3e7655=\"\">{{ i18n.t('class.have_no_any_class') }}</div>\n            </div>\n            <v-spinner :ajaxing=\"ajaxing\" _v-2a3e7655=\"\"></v-spinner>\n        </div>\n    </section>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.sticky-day-selector[_v-2a3e7655] {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 101px;\n  background: white; }\n\n@media (max-width: 1000px) {\n  /* line 8, stdin */\n  .sticky-day-selector[_v-2a3e7655] {\n    top: 89px; } }\n\n@media (max-width: 768px) {\n  /* line 13, stdin */\n  .sticky-day-selector[_v-2a3e7655] {\n    top: 142px; } }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-2a3e7655", module.exports)
  } else {
    hotAPI.update("_v-2a3e7655", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],910:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _index = require('./index.vue');

var _index2 = _interopRequireDefault(_index);

var _dayView = require('./day-view.vue');

var _dayView2 = _interopRequireDefault(_dayView);

var _agendaView = require('./agenda-view.vue');

var _agendaView2 = _interopRequireDefault(_agendaView);

var _classFilterModal = require('./class-filter-modal.vue');

var _classFilterModal2 = _interopRequireDefault(_classFilterModal);

var _class_booking_btn = require('./class_booking_btn.vue');

var _class_booking_btn2 = _interopRequireDefault(_class_booking_btn);

var _class_table = require('./class_table.vue');

var _class_table2 = _interopRequireDefault(_class_table);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//partial
_vue2.default.component('class-view', _index2.default);
_vue2.default.component('day-view', _dayView2.default);
_vue2.default.component('agenda-view', _agendaView2.default);
_vue2.default.component('class-filter-modal', _classFilterModal2.default);

//partial
_vue2.default.component('class-booking-btn', _class_booking_btn2.default);
_vue2.default.component('v-class-table', _class_table2.default);

},{"./agenda-view.vue":905,"./class-filter-modal.vue":906,"./class_booking_btn.vue":907,"./class_table.vue":908,"./day-view.vue":909,"./index.vue":911,"vue":792}],911:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 3, stdin */\n#branch-class-tab .top-sticky-filter {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 46px;\n  background: white;\n  padding-top: 5px;\n  z-index: 10; }\n\n/* line 10, stdin */\n#branch-class-tab .filter-section {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: end;\n      justify-content: flex-end; }\n\n/* line 14, stdin */\n#branch-class-tab .dropdown-select .fp-select {\n  min-width: 150px;\n  width: 100%;\n  margin-bottom: 0;\n  border: 1px solid #EEEEEE;\n  border-radius: 8px; }\n  /* line 20, stdin */\n  #branch-class-tab .dropdown-select .fp-select::before {\n    line-height: 46px;\n    color: #000000;\n    z-index: 3; }\n  /* line 25, stdin */\n  #branch-class-tab .dropdown-select .fp-select select {\n    height: 46px;\n    border: none;\n    background-color: white; }\n\n/* line 31, stdin */\n#branch-class-tab .btn-brand--label.background-none {\n  background-color: white;\n  color: #38B0E3; }\n\n/* line 36, stdin */\n#branch-class-tab .switch--btn {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-align: center;\n      align-items: center;\n  border-radius: 9px;\n  border: 1px solid #EEEEEE;\n  background-color: #ffffff; }\n  /* line 42, stdin */\n  #branch-class-tab .switch--btn a:first-child {\n    border-bottom-left-radius: 9px;\n    border-top-left-radius: 9px; }\n  /* line 46, stdin */\n  #branch-class-tab .switch--btn a:last-child {\n    border-bottom-right-radius: 9px;\n    border-top-right-radius: 9px; }\n  /* line 50, stdin */\n  #branch-class-tab .switch--btn a:hover {\n    box-shadow: rgba(0, 0, 0, 0.35) 0px -47px 36px -60px inset; }\n  /* line 53, stdin */\n  #branch-class-tab .switch--btn label {\n    margin: 0;\n    padding: 10px 36px 7px 36px;\n    color: #000000; }\n  /* line 58, stdin */\n  #branch-class-tab .switch--btn .active {\n    background: #38B0E3; }\n    /* line 60, stdin */\n    #branch-class-tab .switch--btn .active label {\n      color: #ffffff; }\n\n/* line 65, stdin */\n#branch-class-tab .web-show {\n  display: block; }\n\n/* line 68, stdin */\n#branch-class-tab .pad-show {\n  display: none; }\n\n@media (max-width: 1000px) {\n  /* line 72, stdin */\n  #branch-class-tab .web-show {\n    display: none; }\n  /* line 75, stdin */\n  #branch-class-tab .pad-show {\n    display: block; }\n  /* line 78, stdin */\n  #branch-class-tab .filter-section {\n    -ms-flex-align: center;\n        align-items: center;\n    -ms-flex-pack: justify;\n        justify-content: space-between;\n    padding: 0 20px; }\n  /* line 83, stdin */\n  #branch-class-tab .switch--btn label {\n    padding: 6px 36px 0px 36px; } }\n\n@media (max-width: 768px) {\n  /* line 88, stdin */\n  #branch-class-tab .top-sticky-filter {\n    top: 100px; } }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['branchUrl', 'studioUrl', 'isWebstudio', 'branchId'],
    data: function data() {
        return {
            currentView: '',
            filterOption: {
                staff: '',
                category: '',
                date: ''
            },
            serviceProviders: {
                '': '所有人員' //required: default option
            },
            categories: {}
        };
    },

    computed: {
        agendaView: function agendaView() {
            return this.currentView == 'agenda-view';
        },
        hasFilter: function hasFilter() {
            return this.filterOption.staff || this.filterOption.category;
        }
    },
    watch: {
        currentView: function currentView(newVal) {
            if (!newVal) return;
            var query = $17.getUrlQueryStrings();
            var promoteEvent = query.promote_event == undefined ? '' : query.promote_event;
            if (newVal == 'agenda-view') {
                this.appendParamsToUrl({
                    tab: query.tab,
                    view: this.currentView,
                    service_provider_id: this.filterOption.staff,
                    service_category_id: this.filterOption.category,
                    promote_event: promoteEvent
                });
            } else {
                this.appendParamsToUrl({
                    tab: query.tab,
                    view: this.currentView,
                    date: this.filterOption.date,
                    promote_event: promoteEvent
                });
            }
        }
    },
    created: function created() {
        this.initViewFromQuery();
    },
    mounted: function mounted() {
        this.init();
    },

    methods: {
        init: function init() {
            this.fetchScheduleCategory();
            this.fetchServiceProvider();
        },
        initViewFromQuery: function initViewFromQuery() {
            var query = $17.getUrlQueryStrings();
            this.currentView = query.view || 'agenda-view';
            var today = (0, _moment2.default)().format('YYYY/MM/DD');
            var queryDate = query.date || today;
            var isAfterToday = (0, _moment2.default)(queryDate).isAfter(today);
            this.filterOption = {
                staff: query.service_provider_id || '',
                category: query.service_category_id || '',
                date: isAfterToday ? queryDate : today
            };
        },
        fetchScheduleCategory: function fetchScheduleCategory() {
            var _this = this;

            this.$http.get('/webapi/schedule-category').then(function (response) {
                var res = response.data || {};
                _this.categories = res;
            });
        },
        fetchServiceProvider: function fetchServiceProvider() {
            var _this2 = this;

            // TODO REMOVE:
            // expect api return key-value pair obj: "service_provider_id:service_provider_name"
            // {
            //     222: Tina,
            //     223: Leo,
            //     224: Rex,
            //     '': '全部人員', //required default option，可前端拿到資料後再補
            // }
            this.$http.get('/webapi/base/current-valid-provider', {
                'params': {
                    branch_id: this.branchId
                }
            }).then(function (response) {
                var res = response.data || {};

                var formatted = res.reduce(function (carry, staff) {
                    carry[staff.id] = staff.name;

                    return carry;
                }, {
                    '': '所有人員'
                });
                _this2.serviceProviders = formatted;
                // this.categories = res;
            });
        },
        updateFilterToQuery: function updateFilterToQuery() {
            var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var query = $17.getUrlQueryStrings();
            this.filterOption = (0, _extends3.default)({}, this.filterOption, params);
            var newQuery = (0, _extends3.default)({}, query, params);
            this.appendParamsToUrl(newQuery);
        },
        appendParamsToUrl: function appendParamsToUrl(newQuery) {
            var newQueryString = $17.queryStringBuilder(newQuery);
            history.replaceState({}, null, '?' + newQueryString);
        },
        openFilterModal: function openFilterModal() {
            this.$refs.class_filter_modal.showModal();
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div id=\"branch-class-tab\">\n    <div class=\"top-sticky-filter\">\n        <div class=\"filter-section\">\n            <div class=\"web-show m-right-25\" v-if=\"agendaView\">\n                <div class=\"select dropdown-select\">\n                    <span class=\"fp-select\">\n                        <select class=\"grey--100\" name=\"service_provider\" v-model=\"filterOption.staff\" @change=\"updateFilterToQuery({'service_provider_id': filterOption.staff})\">\n                            <option v-for=\"(item, key) in serviceProviders\" :value=\"key\">{{item}}</option>\n                        </select>\n                    </span>\n                </div>\n            </div>\n            <div class=\"web-show m-right-25\" v-if=\"agendaView\">\n                <div class=\"select dropdown-select\">\n                    <span class=\"fp-select\">\n                        <select class=\"grey--100\" name=\"service_category\" v-model=\"filterOption.category\" @change=\"updateFilterToQuery({'service_category_id': filterOption.category})\">\n                            <option v-for=\"(item, key) in categories\" :value=\"key\">{{item}}</option>\n                        </select>\n                    </span>\n                </div>\n            </div>\n            <div class=\"pad-show\" v-if=\"agendaView\">\n                <a class=\"btn-brand--label primary-business-color-background\" @click=\"openFilterModal\" v-if=\"hasFilter\">\n                    <i class=\"material-icons\">filter_list</i> {{ i18n.t('general.filter_by') }}\n                </a>\n                <a class=\"btn-brand--label background-none primary-business-color-font\" @click=\"openFilterModal\" v-else=\"\">\n                    <i class=\"material-icons\">filter_list</i> {{ i18n.t('general.filter_by') }}\n                </a>\n            </div>\n            <div v-else=\"\"></div>\n            <div>\n                <div class=\"switch--btn\">\n                    <a :class=\"{active: currentView == 'agenda-view', 'primary-business-color-background': currentView == 'agenda-view'}\">\n                        <input type=\"radio\" id=\"agenda-view\" value=\"agenda-view\" v-model=\"currentView\" style=\"display: none;\">\n                        <label for=\"agenda-view\">\n                            <i class=\"material-icons\">calendar_view_day</i>\n                        </label> \n                    </a>\n                    <a :class=\"{active: currentView == 'day-view', 'primary-business-color-background': currentView == 'day-view'}\">\n                        <input type=\"radio\" id=\"day-view\" value=\"day-view\" v-model=\"currentView\" style=\"display: none;\">\n                        <label for=\"day-view\">\n                            <i class=\"material-icons\">today</i>\n                        </label>\n                    </a>\n                </div>                    \n            </div>\n        </div>\n    </div>\n    <class-filter-modal ref=\"class_filter_modal\" :service-providers=\"serviceProviders\" :categories=\"categories\" :filter-option=\"filterOption\" :update-query=\"updateFilterToQuery\"></class-filter-modal>\n    <keep-alive>\n        <component :is=\"currentView\" :branch-id=\"branchId\" :branch-url=\"branchUrl\" :studio-url=\"studioUrl\" :is-webstudio=\"isWebstudio\" :filter-option=\"filterOption\" :categories=\"categories\" :update-query=\"updateFilterToQuery\"></component>            \n    </keep-alive>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 3, stdin */\n#branch-class-tab .top-sticky-filter {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 46px;\n  background: white;\n  padding-top: 5px;\n  z-index: 10; }\n\n/* line 10, stdin */\n#branch-class-tab .filter-section {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: end;\n      justify-content: flex-end; }\n\n/* line 14, stdin */\n#branch-class-tab .dropdown-select .fp-select {\n  min-width: 150px;\n  width: 100%;\n  margin-bottom: 0;\n  border: 1px solid #EEEEEE;\n  border-radius: 8px; }\n  /* line 20, stdin */\n  #branch-class-tab .dropdown-select .fp-select::before {\n    line-height: 46px;\n    color: #000000;\n    z-index: 3; }\n  /* line 25, stdin */\n  #branch-class-tab .dropdown-select .fp-select select {\n    height: 46px;\n    border: none;\n    background-color: white; }\n\n/* line 31, stdin */\n#branch-class-tab .btn-brand--label.background-none {\n  background-color: white;\n  color: #38B0E3; }\n\n/* line 36, stdin */\n#branch-class-tab .switch--btn {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-align: center;\n      align-items: center;\n  border-radius: 9px;\n  border: 1px solid #EEEEEE;\n  background-color: #ffffff; }\n  /* line 42, stdin */\n  #branch-class-tab .switch--btn a:first-child {\n    border-bottom-left-radius: 9px;\n    border-top-left-radius: 9px; }\n  /* line 46, stdin */\n  #branch-class-tab .switch--btn a:last-child {\n    border-bottom-right-radius: 9px;\n    border-top-right-radius: 9px; }\n  /* line 50, stdin */\n  #branch-class-tab .switch--btn a:hover {\n    box-shadow: rgba(0, 0, 0, 0.35) 0px -47px 36px -60px inset; }\n  /* line 53, stdin */\n  #branch-class-tab .switch--btn label {\n    margin: 0;\n    padding: 10px 36px 7px 36px;\n    color: #000000; }\n  /* line 58, stdin */\n  #branch-class-tab .switch--btn .active {\n    background: #38B0E3; }\n    /* line 60, stdin */\n    #branch-class-tab .switch--btn .active label {\n      color: #ffffff; }\n\n/* line 65, stdin */\n#branch-class-tab .web-show {\n  display: block; }\n\n/* line 68, stdin */\n#branch-class-tab .pad-show {\n  display: none; }\n\n@media (max-width: 1000px) {\n  /* line 72, stdin */\n  #branch-class-tab .web-show {\n    display: none; }\n  /* line 75, stdin */\n  #branch-class-tab .pad-show {\n    display: block; }\n  /* line 78, stdin */\n  #branch-class-tab .filter-section {\n    -ms-flex-align: center;\n        align-items: center;\n    -ms-flex-pack: justify;\n        justify-content: space-between;\n    padding: 0 20px; }\n  /* line 83, stdin */\n  #branch-class-tab .switch--btn label {\n    padding: 6px 36px 0px 36px; } }\n\n@media (max-width: 768px) {\n  /* line 88, stdin */\n  #branch-class-tab .top-sticky-filter {\n    top: 100px; } }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-2b27b343", module.exports)
  } else {
    hotAPI.update("_v-2b27b343", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"lodash":717,"moment":727,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],912:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.row-main[_v-d995c392] {\n  display: -ms-flexbox;\n  display: flex; }\n\n/* line 6, stdin */\n.scroll-panel[_v-d995c392] {\n  min-height: 100px;\n  max-height: 300px;\n  overflow-y: auto;\n  margin-bottom: 20px; }\n\n/* line 12, stdin */\n.tab-panel[_v-d995c392] {\n  display: -ms-flexbox;\n  display: flex;\n  margin: 15px 0; }\n  /* line 15, stdin */\n  .tab-panel > div[_v-d995c392] {\n    -ms-flex: 1;\n        flex: 1;\n    padding: 5px;\n    text-align: center;\n    color: #fff; }\n    /* line 20, stdin */\n    .tab-panel > div.active[_v-d995c392] {\n      background-color: #38b0e3; }\n    /* line 23, stdin */\n    .tab-panel > div[_v-d995c392]:not(.active) {\n      background-color: #aaa;\n      cursor: pointer; }\n      /* line 26, stdin */\n      .tab-panel > div[_v-d995c392]:not(.active):hover {\n        background-color: #919191; }\n\n/* line 33, stdin */\n.subscription-panel-header .notice-info[_v-d995c392] {\n  margin: 10px 0;\n  background: #FDF6EC;\n  border: 1px solid #FFDFB6;\n  border-radius: 4px;\n  padding: 10px;\n  color: #0C5460;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  -ms-flex-align: center;\n      align-items: center; }\n  /* line 43, stdin */\n  .subscription-panel-header .notice-info .notice-mark[_v-d995c392] {\n    background: #e5a146;\n    border-radius: 50%;\n    padding: 3px 9px;\n    margin-right: 10px;\n    color: #fff; }\n\n/* line 53, stdin */\n.buy-panel-footer[_v-d995c392] {\n  display: -ms-flexbox;\n  display: flex; }\n  /* line 55, stdin */\n  .buy-panel-footer div[_v-d995c392] {\n    padding: 10px;\n    text-align: center;\n    cursor: pointer;\n    color: #fff;\n    white-space: nowrap; }\n  /* line 62, stdin */\n  .buy-panel-footer [_v-d995c392]:first-child {\n    -ms-flex: 1;\n        flex: 1;\n    background-color: #ccc;\n    min-width: 90px;\n    margin-right: 10px; }\n    /* line 67, stdin */\n    .buy-panel-footer [_v-d995c392]:first-child:hover {\n      background-color: #b3b3b3; }\n  /* line 71, stdin */\n  .buy-panel-footer [_v-d995c392]:last-child {\n    -ms-flex: 4;\n        flex: 4;\n    margin-left: 10px;\n    background-color: #38b0e3; }\n    /* line 75, stdin */\n    .buy-panel-footer [_v-d995c392]:last-child:hover {\n      background-color: #1d97cb; }\n\n/* line 80, stdin */\n.group1[_v-d995c392],\n.group2[_v-d995c392],\n.group3[_v-d995c392] {\n  padding-right: 10px;\n  display: -ms-flexbox;\n  display: flex; }\n  /* line 85, stdin */\n  .group1 > div[_v-d995c392],\n  .group2 > div[_v-d995c392],\n  .group3 > div[_v-d995c392] {\n    padding: 5px; }\n  /* line 88, stdin */\n  .group1 > [_v-d995c392]:first-child,\n  .group2 > [_v-d995c392]:first-child,\n  .group3 > [_v-d995c392]:first-child {\n    -ms-flex: 1;\n        flex: 1; }\n  /* line 91, stdin */\n  .group1 > [_v-d995c392]:last-child,\n  .group2 > [_v-d995c392]:last-child,\n  .group3 > [_v-d995c392]:last-child {\n    width: 100px;\n    text-align: right; }\n\n/* line 96, stdin */\n.p-t-5[_v-d995c392] {\n  padding-top: 5px; }\n\n/* line 99, stdin */\n.p-b-5[_v-d995c392] {\n  padding-bottom: 5px; }\n\n/* line 102, stdin */\n.fz-1[_v-d995c392] {\n  font-size: 18px; }\n\n/* line 105, stdin */\n.fz-s[_v-d995c392] {\n  font-size: 12px;\n  color: #aaaaad; }\n\n/* line 109, stdin */\n.date-span[_v-d995c392] {\n  background-color: #d6d6d6;\n  padding: 2px 15px;\n  font-size: 14px; }\n\n/* line 114, stdin */\n.schedule-box[_v-d995c392] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  padding: 15px 0;\n  border-bottom: 1px solid #d6d6d6; }\n  /* line 120, stdin */\n  .schedule-box > div[_v-d995c392] {\n    padding: 5px 15px; }\n  /* line 123, stdin */\n  .schedule-box[_v-d995c392]:hover {\n    background-color: #fdfdfd; }\n\n/* line 127, stdin */\n.s-box-group-1[_v-d995c392] {\n  width: 100%;\n  display: -ms-flexbox;\n  display: flex; }\n  /* line 130, stdin */\n  .s-box-group-1 .s-name[_v-d995c392] {\n    -ms-flex: 1;\n        flex: 1; }\n  /* line 133, stdin */\n  .s-box-group-1 .s-point[_v-d995c392] {\n    width: 100px;\n    text-align: right; }\n\n/* line 138, stdin */\n.s-box-group-2[_v-d995c392] {\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%; }\n  /* line 141, stdin */\n  .s-box-group-2 .s-time_span[_v-d995c392] {\n    -ms-flex: 1;\n        flex: 1; }\n  /* line 144, stdin */\n  .s-box-group-2 .s-teacher[_v-d995c392] {\n    -ms-flex: 1;\n        flex: 1;\n    display: -ms-flexbox;\n    display: flex; }\n    /* line 147, stdin */\n    .s-box-group-2 .s-teacher .s-t-img[_v-d995c392] {\n      width: 30px; }\n      /* line 149, stdin */\n      .s-box-group-2 .s-teacher .s-t-img img[_v-d995c392] {\n        width: 20px;\n        border-radius: 50%;\n        border: 1px solid #38b0e3; }\n\n/* line 159, stdin */\n.s-info-btn[_v-d995c392] {\n  width: 30px; }\n\n/* line 162, stdin */\ni[_v-d995c392] {\n  color: #929292; }\n\n/* line 165, stdin */\n.service-box[_v-d995c392] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  border-bottom: 1px solid #d6d6d6;\n  padding: 15px 5px; }\n  /* line 170, stdin */\n  .service-box .row-main > div[_v-d995c392] {\n    padding: 5px 15px; }\n  /* line 173, stdin */\n  .service-box .row-main > div[_v-d995c392]:nth-child(1),\n  .service-box .row-main > div[_v-d995c392]:nth-child(2) {\n    -ms-flex: 1;\n        flex: 1; }\n  /* line 177, stdin */\n  .service-box .row-main > div[_v-d995c392]:last-child {\n    text-align: right;\n    -ms-flex: 2;\n        flex: 2; }\n  /* line 181, stdin */\n  .service-box .row-main > div[_v-d995c392]:nth-child(1) {\n    min-width: 115px; }\n  /* line 184, stdin */\n  .service-box .row-main > div[_v-d995c392]:nth-child(2) {\n    min-width: 50px;\n    white-space: nowrap; }\n  /* line 190, stdin */\n  .service-box[_v-d995c392]:hover {\n    background-color: #fdfdfd; }\n\n/* line 194, stdin */\n.step[_v-d995c392] {\n  position: absolute;\n  transition: all .5s;\n  width: 100%;\n  top: 0; }\n  /* line 199, stdin */\n  .step.active[_v-d995c392] {\n    position: relative;\n    transition-delay: .3s;\n    left: 0; }\n\n/* line 205, stdin */\n.step1[_v-d995c392]:not(.active) {\n  left: -150%;\n  height: 0; }\n\n/* line 209, stdin */\n.step2[_v-d995c392]:not(.active) {\n  left: 150%;\n  height: 0; }\n\n/* line 213, stdin */\n.step3[_v-d995c392]:not(.active) {\n  left: 150%;\n  height: 0; }\n\n/* line 217, stdin */\n.body-panel[_v-d995c392] {\n  position: relative;\n  overflow: hidden; }\n\n/* line 221, stdin */\n.fa-info-circle[_v-d995c392]:hover,\n.fa-info-circle.active[_v-d995c392] {\n  cursor: pointer;\n  color: #38b0e3; }\n\n/* line 226, stdin */\n.discount[_v-d995c392] {\n  color: green; }\n\n/* line 229, stdin */\n.discount-percentage[_v-d995c392] {\n  color: white;\n  display: inline-block;\n  text-align: center;\n  vertical-align: middle;\n  padding: 2px 12px;\n  border: 0px solid #ffffff;\n  border-radius: 100px; }\n\n/* line 238, stdin */\n.form-control-xxx[_v-d995c392] {\n  width: 200px;\n  display: inline; }\n\n/* line 242, stdin */\n.notice-more[_v-d995c392] {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-align: center;\n      align-items: center;\n  white-space: nowrap; }\n\n@media screen and (max-width: 999px) {\n  /* line 248, stdin */\n  .schedule-box > div[_v-d995c392],\n  .service-box > div[_v-d995c392] {\n    padding: 5px 0; } }\n\n/* line 253, stdin */\n.error-msg[_v-d995c392] {\n  height: 20px;\n  color: #e07c7a; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['studio_id', 'branch_id', 'card', 'bus', 'is_login'],
    data: function data() {
        return {
            contract: {},
            pricingOption: 'general',
            tab: '',
            stepAt: 1,
            useCouponBotton: true,
            couponError: false,
            ajaxDetail: false,
            ajaxBuying: false,
            ajexCoupon: false,
            ajaxAllowNext: false,
            contractDetail: {
                scheduleList: [],
                serviceList: [],
                link: null
            },
            coupon: {},
            coupon_code: '',
            appointment_note: '',
            descriptionStyle: {
                wordBreak: 'break-word',
                marginTop: '20px',
                padding: '10px',
                color: '#fff',
                backgroundColor: '#b3b3b3',
                borderRadius: '5px'
            },
            invoiceActive: 0,
            invoice: {
                invoiceData: {
                    showWord: ''
                }
            },
            currentInvoiceCategory: 'person',
            currentInvoiceType: 'CarrierPay2Go',
            currentInvoiceNum: '',
            currentInvoiceName: '',
            invoiceReset: true,
            isInWebStudio: 1,
            paymentMethods: [],
            selectedPaymentMethod: {},
            approveTermList: [],
            is_enabled_terms: 0,
            approvalTermUrl: window.location.origin + '/approval-term/purchase?studio_id=' + this.studio_id,
            error: {
                approval_term: ''
            }
        };
    },
    mounted: function mounted() {
        var _this = this;

        $('#contract-detail-modal').on('hidden.bs.modal', function (e) {
            _this.coupon = {};
            _this.coupon_code = '';
            _this.couponError = false;
            _this.resetUrlQuery();
        });
        $(document).keydown(function (objEvent) {
            if (objEvent.keyCode == 9) {
                objEvent.preventDefault();
            }
        });
        this.fetchInitData();
    },
    destroyed: function destroyed() {
        $('#contract-detail-modal').off('hidden.bs.modal');
    },

    methods: {
        setInitTab: function setInitTab() {
            if ((0, _keys2.default)(this.contractDetail.scheduleList).length) return this.tab = 'schedule';
            if ((0, _keys2.default)(this.contractDetail.serviceList).length) return this.tab = 'service';
        },
        closePanel: function closePanel() {
            $('#contract-detail-modal').modal('hide');
        },
        resetUrlQuery: function resetUrlQuery() {
            var query = $17.getUrlQueryStrings();
            if (query.hasOwnProperty('id')) {
                delete query.id;
            }
            if (query.hasOwnProperty('pricing_option_id')) {
                delete query.pricing_option_id;
            }
            var newQueryString = $17.queryStringBuilder(query);
            history.replaceState({}, null, '?' + newQueryString);
        },
        buyBtnClick: function buyBtnClick() {
            if (!this.selectedPaymentMethod.type_id) return;
            this.$store.dispatch('setWeblog', { 'name': i18n.t('pass.thirdparty_credit_card'), 'message': i18n.t('pass.click_button') });
            if (this.selectedPaymentMethod.type_id == 2) {
                // 線上刷卡
                if (this.card) return this.buyContract();
                this.bus.$emit('validate-new-card');
            } else {
                this.buyContract();
            }
        },
        hasList: function hasList(type) {
            return (0, _keys2.default)(this.contractDetail[type + 'List']).length;
        },
        tabIs: function tabIs(tab) {
            return this.tab == tab;
        },
        tabTo: function tabTo(tab) {
            this.tab = tab;
        },
        toStep: function toStep(step) {
            if (this.ajaxBuying) return;
            if (step == 2 && !this.is_login) {
                this.$refs.loginForm.login();
                return;
            }
            this.stepAt = step;
        },
        stepIs: function stepIs(step) {
            return this.stepAt == step ? 'active' : '';
        },
        toggleDesc: function toggleDesc(target) {
            Vue.set(target, 'showDesc', !target.showDesc);
        },
        ajaxBuy: function ajaxBuy(status) {
            this.ajaxBuying = status;
            if (status) {
                $.blockUI();
                return;
            }
            $.unblockUI();
        },
        buyContract: function buyContract(card) {
            var _this2 = this;

            if (this.ajaxBuying) return;
            this.ajaxBuy(true);
            this.bus.$emit('v-model-lock');
            var url = '/api/contract/buy/' + this.contract.id;
            this.error.approval_term = '';
            if (this.is_enabled_terms === 0 && this.approveTermList.is_show_in_client_side !== 0) {
                this.error.approval_term = '該項為必填！';
                this.ajaxBuy(false);
                this.bus.$emit('v-model-unlock');
                return;
            }
            var invoice = [];
            if (this.invoiceActive) {
                invoice = this.getPostInvoice();
            }
            var params = {
                card: card,
                branch_id: this.branch_id,
                invoice: invoice,
                coupon_code: this.coupon && this.coupon.code ? this.coupon.code : '',
                fb_event_source_url: window.location.href,
                appointment_note: this.appointment_note,
                payment_type: {
                    studio_payment_method_id: this.selectedPaymentMethod.payment_method_id,
                    payment_type_id: this.selectedPaymentMethod.type_id
                },
                is_enabled_terms: this.is_enabled_terms
            };
            if (this.pricingOption == 'subscription') {
                params['product_pricing_option_id'] = this.contract.pricing_option_id;
            }
            this.$http.post(url, params).then(function (response) {
                _this2.bus.$emit('v-model-unlock');
                $('#contract-detail-modal').on('hidden.bs.modal', function () {
                    $('#contract-detail-modal').unbind();
                    _this2.ajaxBuy(false);
                    if (response.data.success) {
                        if (_this2.selectedPaymentMethod.type_id == 2) {
                            _this2.cardPaymentConfirm(card);
                        } else {
                            _this2.standardPaymentConfirm(response.data);
                        }
                        return;
                    }
                    return swal({
                        type: 'warning',
                        text: response.data.message
                    }, function () {
                        return $('#contract-detail-modal').modal('show');
                    });
                });
                $('#contract-detail-modal').modal('hide');
            }).catch(function (response) {
                var errorType = 'error';
                var text = '';
                var hasErrorIdentifiable = response.data.hasOwnProperty('code') && _this2.$errorIdentifiable.includes(response.data.code);
                var warnings = ["1R001", "1R002", "1R003", "1R004", "1R005", "1R006"];
                if (response.data.msg == 'ThrottleRequestsException' || hasErrorIdentifiable && warnings.includes(response.data.code)) {
                    errorType = 'warning';
                }
                if (hasErrorIdentifiable) {
                    text = '[' + response.data.code + '] ' + i18n.t('error.msg.' + response.data.code);
                } else {
                    text = response.data.message ? response.data.message : i18n.t('pass.unknow_error_to_service');
                }
                _this2.errorHandler(text, errorType);
            });
        },
        cardPaymentConfirm: function cardPaymentConfirm(card) {
            var _this3 = this;

            this.card = this.card || card.card.replace(/(\d{6})\d*(\d{4})/, '$1******$2');
            var text = i18n.t('pass.buy_success');
            if (this.contract.is_lesson) text += i18n.t('pass.class_to_reserved');

            swal({
                type: 'success',
                text: text
            });

            setTimeout(function () {
                var params = {
                    promote_event: 'contract_purchase_success'
                };
                var newQueryString = $17.queryStringBuilder(params);
                if (_this3.contract.is_lesson) return window.location.href = '/my-class' + '?' + newQueryString;
                var newURL = document.URL.split('?')[0];
                window.history.replaceState(null, null, newURL + '?' + newQueryString);
                location.reload();
            }, 1500);
        },
        standardPaymentConfirm: function standardPaymentConfirm(data) {
            if (data.success) {
                //等待確認是不是這邊也都只能回主站路由
                var _data$data = data.data,
                    order_id = _data$data.order_id,
                    order_status = _data$data.order_status,
                    payment_action_record_id = _data$data.payment_action_record_id;

                window.open('/payment/confirm?order_id=' + order_id + '&payment_action_record_id=' + payment_action_record_id + '&promote_event=contract_purchase_success', '_self');
            } else {
                this.errorHandler(data.message);
            }
        },
        errorHandler: function errorHandler(msg) {
            var _this4 = this;

            var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'error';

            this.bus.$emit('v-model-unlock');
            $('#contract-detail-modal').on('hidden.bs.modal', function () {
                $('#contract-detail-modal').unbind();
                _this4.ajaxBuy(false);
                swal({
                    type: type,
                    text: msg
                }, function () {
                    return $('#contract-detail-modal').modal('show');
                });
            });
            $('#contract-detail-modal').modal('hide');
        },
        ajaxContractDone: function ajaxContractDone() {
            this.ajaxDetail = false;
            this.bus.$emit('ajax-contract-done');
        },
        checkAllowOnlinePayment: function checkAllowOnlinePayment() {
            var _this5 = this;

            this.ajaxAllowNext = true;
            this.$http.post('/webapi/branch/' + this.branch_id + '/purchase/payment-types', {
                products: [{
                    type: 'contract',
                    id: this.contract.id,
                    pricing_option_id: this.contract.pricing_option_id || ''
                }]
            }).then(function (response) {
                _this5.paymentMethods = response.data || [];
                _this5.$refs.switch_payment_method.generatePaymentMethods(response.data);
                _this5.ajaxAllowNext = false;
            });
        },
        updatePaymentMethod: function updatePaymentMethod(data) {
            this.selectedPaymentMethod = data;
        },
        getInvoice: function getInvoice() {
            var _this6 = this;

            this.ajaxAllowNext = true;
            this.$http.get(base_url + '/webapi/invoice/active/' + this.branch_id).then(function (response) {
                _this6.invoiceActive = parseInt(response.data);
            });
        },
        changeInvocie: function changeInvocie(data) {
            this.invoice = data;
        },
        confirmCoupon: function confirmCoupon() {
            var _this7 = this;

            this.couponError = false;
            this.$http.get('/webapi/coupons/' + this.coupon_code + '?branch_id=' + this.branch_id + '&contract_id=' + this.contract.id + '&price=' + this.contract.price_num + '&sub_total=' + this.subTotal()).then(function (response) {
                _this7.coupon = response.data.coupon;
                if (_this7.coupon === null || _this7.coupon === undefined) {
                    _this7.couponError = true;
                }
            }).catch(function (response) {
                _this7.couponError = true;
            });
        },
        confirmInvoice: function confirmInvoice() {
            if (!this.invoice.invoiceData.checked) {
                $17.swal({
                    type: 'error',
                    title: i18n.t('invoice.paramater_error'),
                    showCancelButton: false
                });
                return;
            }
            this.currentInvoiceCategory = this.invoice.invoiceCategory;
            this.currentInvoiceType = this.invoice.invoiceType;
            this.currentInvoiceNum = this.invoice.invoiceData.num;
            this.currentInvoiceName = this.invoice.invoiceData.name;
            this.toStep(2);
        },
        resetInvoice: function resetInvoice() {
            this.invoiceReset = !this.invoiceReset;
            this.toStep(2);
        },
        getPostInvoice: function getPostInvoice() {
            return {
                'method': this.currentInvoiceType,
                'carrier_num': this.currentInvoiceNum,
                'carrier_name': this.currentInvoiceName
            };
        },
        getRealPrice: function getRealPrice(price, discount) {
            if (parseInt(price) - parseInt(discount) <= 0) {
                return 0;
            }
            return parseInt(price) - parseInt(discount);
        },
        getDiscountPercentage: function getDiscountPercentage(price, discount) {
            return Math.round(parseInt(discount) / parseInt(price) * 100);
        },
        deleteCoupon: function deleteCoupon() {
            this.useCouponBotton = true;
            this.couponError = false;
            this.coupon = {};
            this.coupon_code = '';
        },
        subTotal: function subTotal() {
            var total = parseInt(this.contract.price_num) - parseInt(this.contract.discount);
            if (total <= 0) {
                total = 0;
            }
            return total;
        },
        subTotal2: function subTotal2() {
            var total = 0;
            if (this.pricingOption == 'subscription') {
                total = this.contract.enable_first_price ? this.contract.first_price : this.contract.price;
                return $17.thousandthFormat(total);
            }
            if (this.coupon.discount === undefined) {
                return $17.thousandthFormat(this.subTotal());
            }
            total = this.subTotal() - parseInt(this.coupon.discount);
            if (total <= 0) {
                total = 0;
            }
            return $17.thousandthFormat(total);
        },
        showApprovalTermInput: function showApprovalTermInput() {
            return this.approveTermList.is_show_in_client_side !== 0;
        },
        allowDiscountInput: function allowDiscountInput() {
            return this.pricingOption !== 'subscription';
        },

        fetchInitData: function fetchInitData() {
            this.$http.get(base_url + '/webapi/init/data').then(function (response) {
                this.isInWebStudio = response.data.is_in_webstudio;
            });
        },
        fetchContractDetail: function fetchContractDetail(contract) {
            var _this8 = this;

            this.ajaxDetail = true;
            this.$http.get(base_url + '/api/contract/detail/' + contract.id).then(function (response) {
                _this8.contractDetail = response.data;
                _this8.setInitTab();
                _this8.ajaxContractDone();
            });
        },
        showContractModal: function showContractModal(contract) {
            this.fetchApprovalTermData();
            this.stepAt = 1;
            $('#contract-detail-modal').modal('show');
            if (this.contract == contract) return this.ajaxContractDone();
            this.pricingOption = contract.hasOwnProperty('pricing_option_id') ? 'subscription' : 'general';
            this.contract = contract;
            this.checkAllowOnlinePayment();
        },
        fetchApprovalTermData: function fetchApprovalTermData() {
            var _this9 = this;

            this.$http.get('/webapi/approval-term/studio?studio_id=' + this.studio_id).then(function (response) {
                _this9.approveTermList = response.body;
            }).catch(function (error) {
                $17.swal({
                    type: 'error',
                    title: '取得資料錯誤',
                    text: error.data.error,
                    showCancelButton: false
                });
            });
        },
        thousandFormat: function thousandFormat(number) {
            return $17.thousandthFormat(number);
        }
    },
    watch: {
        'contract': function contract(n, o) {
            this.fetchContractDetail(n);
        },
        'branch_id': function branch_id(n, o) {
            undefined.getInvoice();
        },
        'coupon_code': function coupon_code(n, o) {
            if (n.length > 0) {
                this.useCouponBotton = false;
            } else {
                this.useCouponBotton = true;
            }
        }
    },
    created: function created() {
        var _this10 = this;

        this.bus.$on('new-card-validated', function (card) {
            _this10.buyContract(card);
            _this10.$store.dispatch('setWeblog', { 'name': i18n.t('pass.thirdparty_credit_card'), 'message': i18n.t('pass.validate_card_success') });
        });
        this.getInvoice();
    },

    computed: {
        invoiceShow: function invoiceShow() {
            return !this.invoice.invoiceData.showWord ? '' : this.invoice.invoiceData.showWord;
        },

        showLoginFB: function showLoginFB() {
            return this.isInWebStudio == 1 ? 0 : 1;
        },
        subscriptionDiscountPercentage: function subscriptionDiscountPercentage() {
            var contract = this.contract;
            if (this.pricingOption == 'subscription') {
                var isPointOrCount = contract.contract_type == 2 || contract.contract_type == 3;
                var originVal = isPointOrCount ? contract.origin_value : contract.origin_effective_days;
                var subVal = isPointOrCount ? contract.value : contract.effective_days;
                if (originVal == 0 || subVal == 0) {
                    return '';
                };
                var originUnitPrice = contract.origin_price / originVal;
                var subUnitPrice = contract.price / subVal;
                var unitDiscount = 1 - subUnitPrice / originUnitPrice;
                if (unitDiscount == 0) {
                    return '';
                };
                return '\u7D04\u7BC0\u7701 ' + Math.round(unitDiscount * 100) + '%';
            }
            return '';
        },
        hasPaymentMethods: function hasPaymentMethods() {
            return this.selectedPaymentMethod ? this.selectedPaymentMethod.type_id : false;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal id=\"contract-detail-modal\" :bus=\"bus\" no-footer=\"\" _v-d995c392=\"\">\n    <div slot=\"title\" class=\"st-text-black\" _v-d995c392=\"\">\n        {{ pricingOption == 'subscription' ? i18n.t('pass.buy_subscription_contract') : i18n.t('pass.buy_contract') }}\n    </div>\n    <div slot=\"body\" _v-d995c392=\"\">\n        <!-- 訂閱方案 -->\n        <div class=\"subscription-panel-header st-space-y-5\" v-if=\"pricingOption == 'subscription'\" _v-d995c392=\"\">\n            <div class=\"st-text-18 st-text-black\" _v-d995c392=\"\">\n                {{ contract.name }}\n            </div>\n            <div _v-d995c392=\"\">\n                <div class=\"st-text-16\" _v-d995c392=\"\">\n                    <div v-show=\"contract.enable_first_price\" class=\"st-mb-2\" _v-d995c392=\"\"> \n                        <span class=\"st-text-gray-90\" _v-d995c392=\"\">{{ i18n.t('pass.first_period_payment') }}</span>\n                        <span class=\"st-text-danger st-pl-0.5\" _v-d995c392=\"\">{{ contract.currency + ' ' + thousandFormat(contract.first_price) }}</span> \n                        <hr class=\"st-my-2.5\" _v-d995c392=\"\">\n                    </div>\n                    <span class=\"st-text-gray-90\" _v-d995c392=\"\">{{ i18n.t('pass.payment_each_term') }}</span>\n                    <span class=\"st-text-danger st-pl-0.5 st-pr-1\" _v-d995c392=\"\">{{ contract.currency + ' ' + thousandFormat(contract.price) }}</span>\n                    <span class=\"st-bg-danger st-px-2 st-py-0.5 st-rounded-16 st-text-12 st-text-white\" v-show=\"subscriptionDiscountPercentage\" _v-d995c392=\"\">\n                        {{ subscriptionDiscountPercentage }}\n                    </span>\n                </div>\n                <div class=\"notice-info\" _v-d995c392=\"\">\n                    <span _v-d995c392=\"\"><span class=\"notice-mark\" _v-d995c392=\"\">!</span>{{ contract.notify_wording }}</span>\n                    <a href=\"https://17fithelp.zendesk.com/hc/zh-tw/articles/4407063456921\" target=\"_blank\" _v-d995c392=\"\">\n                        <span class=\"notice-more\" _v-d995c392=\"\">\n                            了解詳情\n                        </span>\n                    </a>\n                </div>\n            </div>\n            <div _v-d995c392=\"\">\n                <div class=\"st-space-y-5\" v-show=\"stepAt == 1\" _v-d995c392=\"\">\n                    <div class=\"st-text-14 st-text-black\" _v-d995c392=\"\">\n                        <div class=\"st-flex\" _v-d995c392=\"\">\n                            <div class=\"st-w-1 st-h-6 st-bg-secondary st-mr-2 st-rounded-4 primary-business-color-background\" _v-d995c392=\"\"></div>\n                            <div class=\"st-text-16 st-font-medium\" _v-d995c392=\"\">{{ i18n.t('pass.contract_rights_each_term') }}</div>\n                        </div>\n                        <div class=\"st-my-0.5\" _v-d995c392=\"\">\n                            <div v-show=\"contract.value\" _v-d995c392=\"\">{{ contract.show_value }}</div>\n                            <div _v-d995c392=\"\">{{ i18n.t('pass.effective_days') }}：{{ contract.effective_days }}{{ i18n.t('unit.days') }}</div>    \n                        </div>\n                    </div>\n                    <div v-show=\"contract.extend_description\" class=\"st-text-14 st-text-black\" _v-d995c392=\"\"> \n                        <div class=\"st-flex\" _v-d995c392=\"\">\n                            <div class=\"st-w-1 st-h-6 st-bg-secondary st-mr-2 st-rounded-4 primary-business-color-background\" _v-d995c392=\"\"></div>\n                            <div class=\"st-text-16 st-font-medium\" _v-d995c392=\"\">{{ i18n.t('pass.subscription_direction') }}</div>\n                        </div>\n                        <div class=\"st-my-0.5\" _v-d995c392=\"\">\n                            <div v-html=\"contract.extend_description\" _v-d995c392=\"\"></div> \n                        </div>\n                    </div>\n                    <div v-show=\"contract.description\" class=\"st-text-14 st-text-black\" _v-d995c392=\"\"> \n                        <div class=\"st-flex\" _v-d995c392=\"\">\n                            <div class=\"st-w-1 st-h-6 st-bg-secondary st-mr-2 st-rounded-4 primary-business-color-background\" _v-d995c392=\"\"></div>\n                            <div class=\"st-text-16 st-font-medium\" _v-d995c392=\"\">{{ i18n.t('pass.info') }}</div>\n                        </div>\n                        <div class=\"st-my-0.5\" _v-d995c392=\"\">\n                            <p class=\"txt-small word-break grey--100\" _v-d995c392=\"\">{{contract.description}}</p>\n                        </div>\n                    </div>\n                    <external-link-button v-if=\"contractDetail !== null\" :link=\"contractDetail.link\" _v-d995c392=\"\"></external-link-button> \n                </div>\n            </div>\n        </div>\n        <!-- 一般方案 -->\n        <div class=\"buy-panel-header\" v-else=\"\" _v-d995c392=\"\">\n            <div class=\"st-flex st-gap-2 st-mb-2\" _v-d995c392=\"\">\n                <div class=\"st-grow\" _v-d995c392=\"\">\n                    <div _v-d995c392=\"\">\n                        <div class=\"st-text-black st-text-18\" _v-d995c392=\"\">{{ contract.name }}</div>\n                    </div>\n                    <div class=\"st-text-16 st-text-gray-90\" _v-d995c392=\"\">\n                        <span _v-d995c392=\"\">{{ contract.count }}</span>\n                        <span v-show=\"contract.count &amp;&amp; contract.show_effective_days\" _v-d995c392=\"\">, </span>\n                        <span v-show=\"contract.show_effective_days\" _v-d995c392=\"\">{{ i18n.t('pass.expire_time') }}: {{ contract.effective_days+' '+i18n.t('unit.days') }}</span>\n                    </div>\n                </div>\n                <div _v-d995c392=\"\">\n                    <div v-if=\"contract.experience_plan\" _v-d995c392=\"\">\n                        <promotion-experience-label _v-d995c392=\"\"></promotion-experience-label>\n                    </div>\n                    <div class=\"st-mt-2 st-text-18 st-font-medium st-text-danger st-whitespace-nowrap\" _v-d995c392=\"\">\n                        {{contract.currency}} {{ contract.price }}\n                    </div>\n                </div>\n            </div>\n            <external-link-button v-if=\"contractDetail !== null\" :link=\"contractDetail.link\" _v-d995c392=\"\"></external-link-button>\n        </div>\n\n        <v-spinner :ajaxing=\"ajaxDetail\" _v-d995c392=\"\"></v-spinner>\n        <div v-show=\"! ajaxDetail\" class=\"body-panel\" _v-d995c392=\"\">\n            <div class=\"step1 step\" :class=\"stepIs(1)\" _v-d995c392=\"\">\n                <div class=\"buy-panel-body\" _v-d995c392=\"\">\n                    <div class=\"tab-panel\" _v-d995c392=\"\">\n                        <div :class=\"{ active: tabIs('schedule'), 'primary-business-color-background-hover': tabIs('schedule'), 'primary-business-color-background': tabIs('schedule')}\" @click=\"tabTo('schedule')\" v-if=\"hasList('schedule')\" _v-d995c392=\"\">\n                            {{ i18n.t('pass.class_can_go') }}\n                        </div>\n                        <div :class=\"{ active: tabIs('service'), 'primary-business-color-background-hover': tabIs('service'), 'primary-business-color-background': tabIs('service')}\" @click=\"tabTo('service')\" v-if=\"hasList('service')\" _v-d995c392=\"\">\n                            {{ i18n.t('pass.service_can_go') }}\n                        </div>\n                    </div>\n                    <div class=\"scroll-panel\" _v-d995c392=\"\">\n                        <div v-show=\"tabIs('schedule')\" _v-d995c392=\"\">\n                            <template v-for=\"(g, key) in contractDetail.scheduleList\">\n                                <div class=\"date-span\" _v-d995c392=\"\">{{ key }}</div>\n                                <div v-for=\"s in g\" class=\"schedule-box\" _v-d995c392=\"\">\n                                    <div class=\"s-box-group-1\" _v-d995c392=\"\">\n                                        <div class=\"s-name\" _v-d995c392=\"\">{{ s.name }}</div>\n                                        <div class=\"s-point\" v-show=\"contract.show_point\" _v-d995c392=\"\">{{ s.point }} {{ i18n.t('pass.point') }}</div>    \n                                    </div>\n                                    <div class=\"s-box-group-2\" _v-d995c392=\"\">\n                                        <div class=\"s-time_span\" _v-d995c392=\"\"><i class=\"fa-clock-o fa\" _v-d995c392=\"\"></i> {{ s.time_span }}</div>\n                                        <div class=\"s-teacher\" v-if=\"s.teacher\" _v-d995c392=\"\">\n                                            <div class=\"s-t-img\" _v-d995c392=\"\"><img class=\"primary-business-color-border\" :src=\"s.teacher_img\" _v-d995c392=\"\"></div>\n                                            <div _v-d995c392=\"\">{{ s.teacher }}</div>\n                                        </div>\n                                        <div class=\"s-info-btn\" _v-d995c392=\"\"><i class=\"fa fa-info-circle\" :class=\"{active: s.showDesc}\" @click=\"toggleDesc(s)\" v-if=\"s.notice\" _v-d995c392=\"\"></i></div>\n                                    </div>\n                                    <div class=\"description-box\" v-show=\"s.showDesc\" _v-d995c392=\"\">\n                                        <div :style=\"descriptionStyle\" _v-d995c392=\"\">\n                                            {{ s.notice }}\n                                        </div>\n                                    </div>\n                                </div>\n                            </template>\n                        </div>\n                        <div v-show=\"tabIs('service')\" _v-d995c392=\"\">\n                            <template v-for=\"g in contractDetail.serviceList\">\n                                <div v-for=\"s in g\" class=\"service-box\" _v-d995c392=\"\">\n                                    <div class=\"row-main\" _v-d995c392=\"\">\n                                        <div _v-d995c392=\"\">{{ s.name }}</div>\n                                        <div _v-d995c392=\"\"><i class=\"fa-clock-o fa\" _v-d995c392=\"\"></i> {{ s.service_time }}</div>\n                                        <div style=\"white-space: nowrap;\" _v-d995c392=\"\">\n                                            <span v-show=\"contract.show_point\" _v-d995c392=\"\">{{ s.point }}  {{ i18n.t('pass.point') }}</span>\n                                            <span style=\"min-width: 20px;display:inline-block;\" _v-d995c392=\"\"><i class=\"fa fa-info-circle\" :class=\"{active: s.showDesc}\" @click=\"toggleDesc(s)\" v-show=\"s.description\" _v-d995c392=\"\">\n                                            </i></span>\n                                        </div>    \n                                    </div>\n                                    <div class=\"description-box\" v-show=\"s.showDesc\" _v-d995c392=\"\">\n                                        <div :style=\"descriptionStyle\" _v-d995c392=\"\">\n                                            {{ s.description }}\n                                        </div>\n                                    </div>\n                                </div>\n                                \n                            </template>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"st-flex st-items-center st-mb-2 st-text-14 st-text-danger\" v-if=\"(!ajaxAllowNext&amp;&amp;!hasPaymentMethods)\" _v-d995c392=\"\">\n                    <span class=\"material-icons st-mr-1\" _v-d995c392=\"\">error</span>{{ i18n.t('payment.not_allow_online_payment') }}\n                </div>\n                <div class=\"buy-panel-footer\" _v-d995c392=\"\">\n                    <div class=\"fz-1\" @click=\"closePanel\" _v-d995c392=\"\">{{ i18n.t('pass.close') }}</div>\n                    <div v-if=\"(!ajaxAllowNext&amp;&amp;hasPaymentMethods)\" class=\"fz-1 primary-business-color-background-hover primary-business-color-background\" @click=\"toStep(2)\" _v-d995c392=\"\">\n                        {{ i18n.t('pass.next') }}\n                    </div>\n                    <div v-else-if=\"(!ajaxAllowNext&amp;&amp;!hasPaymentMethods)\" class=\"fz-1 !st-bg-primary\" _v-d995c392=\"\">\n                        {{ i18n.t('payment.unavailable_payment') }}\n                    </div>\n                    <div class=\"fz-1 primary-business-color-background-hover primary-business-color-background\" v-else=\"\" _v-d995c392=\"\">\n                        <i class=\"fa fa-spinner fa-spin\" style=\"color: #fff;background-color:transparent;\" _v-d995c392=\"\"></i>\n                    </div>\n                </div>\n            </div>\n            <div class=\"step2 step\" :class=\"stepIs(2)\" _v-d995c392=\"\">\n                <div class=\"buy-panel-body st-pb-4\" _v-d995c392=\"\">\n                    <hr class=\"st-my-4\" _v-d995c392=\"\">\n                    <div v-if=\"parseInt(contract.discount) > 0\" _v-d995c392=\"\">\n                        <div class=\"discount clearfix p-top-5 p-bottom-5 st-text-18\" _v-d995c392=\"\">\n                            <div class=\"col-md-9 text-left st-pl-0 st-text-gray-90\" _v-d995c392=\"\">{{ i18n.t('promotion.discount') }}</div>\n                            <div class=\"col-md-3 text-right st-pr-0 st-text-red\" _v-d995c392=\"\">- {{contract.currency + ' ' + contract.discount}}</div>\n                        </div>\n                        <hr class=\"st-my-4\" _v-d995c392=\"\">\n                    </div>\n\n                    <div v-if=\"allowDiscountInput()\" _v-d995c392=\"\">\n                        <div class=\"clearfix\" v-if=\"this.coupon.discount === undefined\" _v-d995c392=\"\">\n                            <div class=\"col-md-5 col-xs-5 st-pl-0\" _v-d995c392=\"\">\n                                <input v-model=\"coupon_code\" class=\"form-control col-md-5 st-mb-0\" :placeholder=\"i18n.t('promotion.promotion_code')\" type=\"text\" _v-d995c392=\"\">\n                            </div>\n                            <button :disabled=\"useCouponBotton\" class=\"btn btn-primary col-md-2\" @click.prevent.stop=\"confirmCoupon()\" _v-d995c392=\"\">{{ i18n.t('promotion.submit') }}</button>\n                        </div>\n                        <div class=\"clearfix discount\" v-else=\"\" _v-d995c392=\"\">\n                            <div class=\"col-md-1\" _v-d995c392=\"\"><span style=\"cursor:pointer;\" @click=\"deleteCoupon()\" _v-d995c392=\"\"><i class=\"fa fa-times-circle fz-1\" _v-d995c392=\"\"></i></span></div>\n                            <div class=\"col-md-8 st-text-gray-90\" _v-d995c392=\"\">{{coupon.name}}</div>\n                            <div class=\"col-md-3 text-right st-pr-0 st-text-danger\" _v-d995c392=\"\">- {{contract.currency + ' ' + coupon.discount}}</div>\n                        </div>\n                        <div class=\"p-left-15 st-text-red\" v-if=\"couponError === true\" _v-d995c392=\"\">{{ i18n.t('promotion.invalid_promotion') }}</div>\n                        <hr class=\"st-my-4\" _v-d995c392=\"\">\n                    </div>\n                    \n                    <div class=\"fz-1 m-bottom-15 st-flex st-font-medium st-justify-between st-text-18 st-text-black\" _v-d995c392=\"\">\n                        <div class=\"st-text-gray-90\" _v-d995c392=\"\">{{ i18n.t('promotion.total') }}</div>\n                        <div class=\"st-text-danger\" _v-d995c392=\"\">\n                            <span class=\"p-right-5\" _v-d995c392=\"\">{{contract.currency}}</span>\n                            <span _v-d995c392=\"\">{{subTotal2()}}</span>                                \n                        </div>\n                    </div>\n\n                    <buy-contract-switch-payment-method-part ref=\"switch_payment_method\" :card=\"card\" :bus=\"bus\" @update-payment-method=\"updatePaymentMethod\" _v-d995c392=\"\">\n                    </buy-contract-switch-payment-method-part>\n                    \n                    <div class=\"st-mt-5\" v-if=\"invoiceActive\" _v-d995c392=\"\">\n                        <div class=\"st-border st-border-gray-30 st-border-solid st-border-b-0 st-rounded-t-4 st-text-16 st-py-3 st-px-4\" _v-d995c392=\"\">\n                            {{ i18n.t('invoice.lottery') }}\n                        </div>\n                        <div class=\"st-border st-border-gray-30 st-border-solid st-rounded-b-4 st-p-4 st-text-16 st-flex\" _v-d995c392=\"\">\n                            <div class=\"st-grow\" _v-d995c392=\"\">{{ invoiceShow }}</div>\n                            <div _v-d995c392=\"\">\n                                <a class=\"st-text-secondary st-font-bold\" @click.prevent.stop=\"toStep(3)\" _v-d995c392=\"\">{{ i18n.t('general.change') }}</a>\n                            </div>\n                        </div>                            \n                    </div>\n                    <div v-if=\"contract.contract_type == 4\" _v-d995c392=\"\">\n                        <hr _v-d995c392=\"\">\n                        <div class=\"fz-1\" _v-d995c392=\"\">{{ i18n.t('pass.appointment_note') }}</div>\n                        <div style=\"padding-top:20px; display: flex;justify-content: space-between;\" _v-d995c392=\"\">\n                            <textarea v-model=\"appointment_note\" class=\"form-control col-md-5\" :placeholder=\"i18n.t('pass.enter_note')\" _v-d995c392=\"\"></textarea>\n                        </div> \n                    </div>                                                   \n                    <div class=\"fz-1\" style=\"padding-top:20px;\" v-if=\"showApprovalTermInput()\" _v-d995c392=\"\">\n                        <input v-model=\"is_enabled_terms\" name=\"is_enabled_terms\" type=\"checkbox\" :true-value=\"1\" :false-value=\"0\" class=\"st-h-3.5 st-w-5\" style=\"-webkit-appearance:checkbox;\" _v-d995c392=\"\">\n                        {{ i18n.t('pass.approval_term') }} <a :href=\"approvalTermUrl\" target=\"_blank\" _v-d995c392=\"\">{{approveTermList.name}}</a>\n                        <div class=\"error-msg\" _v-d995c392=\"\">\n                            <span _v-d995c392=\"\">{{ error.approval_term }}</span>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"buy-panel-footer\" _v-d995c392=\"\">\n                    <div class=\"fz-1\" @click=\"toStep(1)\" _v-d995c392=\"\">{{ i18n.t('pass.previous') }}</div>\n                    <div v-if=\"!ajaxBuying\" class=\"fz-1 primary-business-color-background-hover primary-business-color-background\" @click.prevent.stop=\"buyBtnClick\" _v-d995c392=\"\">\n                        {{ i18n.t('pass.buy') }}\n                    </div>\n                    <div class=\"fz-1\" v-else=\"\" _v-d995c392=\"\">\n                        <i class=\"fa fa-spinner fa-spin\" style=\"color: #fff;background-color:transparent;\" _v-d995c392=\"\"></i>\n                    </div>\n                </div>\n            </div>\n            <div class=\"step3 step\" :class=\"stepIs(3)\" _v-d995c392=\"\">\n                <div class=\"buy-panel-body\" _v-d995c392=\"\">\n                    <div class=\"fz-1\" _v-d995c392=\"\">{{ i18n.t('invoice.lottery') }}</div>\n                    <div style=\"padding-left: 20px;padding-top:20px;\" _v-d995c392=\"\">\n                        <invoice-method-select :bus=\"bus\" :branch_id=\"branch_id\" :current-categeory=\"currentInvoiceCategory\" :current-type=\"currentInvoiceType\" :is-reset=\"invoiceReset\" @change-invoice=\"changeInvocie\" _v-d995c392=\"\"></invoice-method-select>\n                    </div>\n                </div>\n                <div class=\"buy-panel-footer\" _v-d995c392=\"\">\n                    <div class=\"fz-1\" @click=\"resetInvoice()\" _v-d995c392=\"\">{{ i18n.t('general.cancel') }}</div>\n                    <div v-if=\"!ajaxBuying\" class=\"fz-1 primary-business-color-background-hover primary-business-color-background\" @click.prevent.stop=\"confirmInvoice()\" _v-d995c392=\"\">\n                        {{ i18n.t('general.ok') }}\n                    </div>\n                    <div class=\"fz-1\" v-else=\"\" _v-d995c392=\"\">\n                        <i class=\"fa fa-spinner fa-spin\" style=\"color: #fff;background-color:transparent;\" _v-d995c392=\"\"></i>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <web-user-login-hidden-form ref=\"loginForm\" platform-define=\"seventeen-fit\" :show-fb=\"showLoginFB\" dest-url-type=\"current\" _v-d995c392=\"\"></web-user-login-hidden-form>\n    </div>\n</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.row-main[_v-d995c392] {\n  display: -ms-flexbox;\n  display: flex; }\n\n/* line 6, stdin */\n.scroll-panel[_v-d995c392] {\n  min-height: 100px;\n  max-height: 300px;\n  overflow-y: auto;\n  margin-bottom: 20px; }\n\n/* line 12, stdin */\n.tab-panel[_v-d995c392] {\n  display: -ms-flexbox;\n  display: flex;\n  margin: 15px 0; }\n  /* line 15, stdin */\n  .tab-panel > div[_v-d995c392] {\n    -ms-flex: 1;\n        flex: 1;\n    padding: 5px;\n    text-align: center;\n    color: #fff; }\n    /* line 20, stdin */\n    .tab-panel > div.active[_v-d995c392] {\n      background-color: #38b0e3; }\n    /* line 23, stdin */\n    .tab-panel > div[_v-d995c392]:not(.active) {\n      background-color: #aaa;\n      cursor: pointer; }\n      /* line 26, stdin */\n      .tab-panel > div[_v-d995c392]:not(.active):hover {\n        background-color: #919191; }\n\n/* line 33, stdin */\n.subscription-panel-header .notice-info[_v-d995c392] {\n  margin: 10px 0;\n  background: #FDF6EC;\n  border: 1px solid #FFDFB6;\n  border-radius: 4px;\n  padding: 10px;\n  color: #0C5460;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  -ms-flex-align: center;\n      align-items: center; }\n  /* line 43, stdin */\n  .subscription-panel-header .notice-info .notice-mark[_v-d995c392] {\n    background: #e5a146;\n    border-radius: 50%;\n    padding: 3px 9px;\n    margin-right: 10px;\n    color: #fff; }\n\n/* line 53, stdin */\n.buy-panel-footer[_v-d995c392] {\n  display: -ms-flexbox;\n  display: flex; }\n  /* line 55, stdin */\n  .buy-panel-footer div[_v-d995c392] {\n    padding: 10px;\n    text-align: center;\n    cursor: pointer;\n    color: #fff;\n    white-space: nowrap; }\n  /* line 62, stdin */\n  .buy-panel-footer [_v-d995c392]:first-child {\n    -ms-flex: 1;\n        flex: 1;\n    background-color: #ccc;\n    min-width: 90px;\n    margin-right: 10px; }\n    /* line 67, stdin */\n    .buy-panel-footer [_v-d995c392]:first-child:hover {\n      background-color: #b3b3b3; }\n  /* line 71, stdin */\n  .buy-panel-footer [_v-d995c392]:last-child {\n    -ms-flex: 4;\n        flex: 4;\n    margin-left: 10px;\n    background-color: #38b0e3; }\n    /* line 75, stdin */\n    .buy-panel-footer [_v-d995c392]:last-child:hover {\n      background-color: #1d97cb; }\n\n/* line 80, stdin */\n.group1[_v-d995c392],\n.group2[_v-d995c392],\n.group3[_v-d995c392] {\n  padding-right: 10px;\n  display: -ms-flexbox;\n  display: flex; }\n  /* line 85, stdin */\n  .group1 > div[_v-d995c392],\n  .group2 > div[_v-d995c392],\n  .group3 > div[_v-d995c392] {\n    padding: 5px; }\n  /* line 88, stdin */\n  .group1 > [_v-d995c392]:first-child,\n  .group2 > [_v-d995c392]:first-child,\n  .group3 > [_v-d995c392]:first-child {\n    -ms-flex: 1;\n        flex: 1; }\n  /* line 91, stdin */\n  .group1 > [_v-d995c392]:last-child,\n  .group2 > [_v-d995c392]:last-child,\n  .group3 > [_v-d995c392]:last-child {\n    width: 100px;\n    text-align: right; }\n\n/* line 96, stdin */\n.p-t-5[_v-d995c392] {\n  padding-top: 5px; }\n\n/* line 99, stdin */\n.p-b-5[_v-d995c392] {\n  padding-bottom: 5px; }\n\n/* line 102, stdin */\n.fz-1[_v-d995c392] {\n  font-size: 18px; }\n\n/* line 105, stdin */\n.fz-s[_v-d995c392] {\n  font-size: 12px;\n  color: #aaaaad; }\n\n/* line 109, stdin */\n.date-span[_v-d995c392] {\n  background-color: #d6d6d6;\n  padding: 2px 15px;\n  font-size: 14px; }\n\n/* line 114, stdin */\n.schedule-box[_v-d995c392] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  padding: 15px 0;\n  border-bottom: 1px solid #d6d6d6; }\n  /* line 120, stdin */\n  .schedule-box > div[_v-d995c392] {\n    padding: 5px 15px; }\n  /* line 123, stdin */\n  .schedule-box[_v-d995c392]:hover {\n    background-color: #fdfdfd; }\n\n/* line 127, stdin */\n.s-box-group-1[_v-d995c392] {\n  width: 100%;\n  display: -ms-flexbox;\n  display: flex; }\n  /* line 130, stdin */\n  .s-box-group-1 .s-name[_v-d995c392] {\n    -ms-flex: 1;\n        flex: 1; }\n  /* line 133, stdin */\n  .s-box-group-1 .s-point[_v-d995c392] {\n    width: 100px;\n    text-align: right; }\n\n/* line 138, stdin */\n.s-box-group-2[_v-d995c392] {\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%; }\n  /* line 141, stdin */\n  .s-box-group-2 .s-time_span[_v-d995c392] {\n    -ms-flex: 1;\n        flex: 1; }\n  /* line 144, stdin */\n  .s-box-group-2 .s-teacher[_v-d995c392] {\n    -ms-flex: 1;\n        flex: 1;\n    display: -ms-flexbox;\n    display: flex; }\n    /* line 147, stdin */\n    .s-box-group-2 .s-teacher .s-t-img[_v-d995c392] {\n      width: 30px; }\n      /* line 149, stdin */\n      .s-box-group-2 .s-teacher .s-t-img img[_v-d995c392] {\n        width: 20px;\n        border-radius: 50%;\n        border: 1px solid #38b0e3; }\n\n/* line 159, stdin */\n.s-info-btn[_v-d995c392] {\n  width: 30px; }\n\n/* line 162, stdin */\ni[_v-d995c392] {\n  color: #929292; }\n\n/* line 165, stdin */\n.service-box[_v-d995c392] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  border-bottom: 1px solid #d6d6d6;\n  padding: 15px 5px; }\n  /* line 170, stdin */\n  .service-box .row-main > div[_v-d995c392] {\n    padding: 5px 15px; }\n  /* line 173, stdin */\n  .service-box .row-main > div[_v-d995c392]:nth-child(1),\n  .service-box .row-main > div[_v-d995c392]:nth-child(2) {\n    -ms-flex: 1;\n        flex: 1; }\n  /* line 177, stdin */\n  .service-box .row-main > div[_v-d995c392]:last-child {\n    text-align: right;\n    -ms-flex: 2;\n        flex: 2; }\n  /* line 181, stdin */\n  .service-box .row-main > div[_v-d995c392]:nth-child(1) {\n    min-width: 115px; }\n  /* line 184, stdin */\n  .service-box .row-main > div[_v-d995c392]:nth-child(2) {\n    min-width: 50px;\n    white-space: nowrap; }\n  /* line 190, stdin */\n  .service-box[_v-d995c392]:hover {\n    background-color: #fdfdfd; }\n\n/* line 194, stdin */\n.step[_v-d995c392] {\n  position: absolute;\n  transition: all .5s;\n  width: 100%;\n  top: 0; }\n  /* line 199, stdin */\n  .step.active[_v-d995c392] {\n    position: relative;\n    transition-delay: .3s;\n    left: 0; }\n\n/* line 205, stdin */\n.step1[_v-d995c392]:not(.active) {\n  left: -150%;\n  height: 0; }\n\n/* line 209, stdin */\n.step2[_v-d995c392]:not(.active) {\n  left: 150%;\n  height: 0; }\n\n/* line 213, stdin */\n.step3[_v-d995c392]:not(.active) {\n  left: 150%;\n  height: 0; }\n\n/* line 217, stdin */\n.body-panel[_v-d995c392] {\n  position: relative;\n  overflow: hidden; }\n\n/* line 221, stdin */\n.fa-info-circle[_v-d995c392]:hover,\n.fa-info-circle.active[_v-d995c392] {\n  cursor: pointer;\n  color: #38b0e3; }\n\n/* line 226, stdin */\n.discount[_v-d995c392] {\n  color: green; }\n\n/* line 229, stdin */\n.discount-percentage[_v-d995c392] {\n  color: white;\n  display: inline-block;\n  text-align: center;\n  vertical-align: middle;\n  padding: 2px 12px;\n  border: 0px solid #ffffff;\n  border-radius: 100px; }\n\n/* line 238, stdin */\n.form-control-xxx[_v-d995c392] {\n  width: 200px;\n  display: inline; }\n\n/* line 242, stdin */\n.notice-more[_v-d995c392] {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-align: center;\n      align-items: center;\n  white-space: nowrap; }\n\n@media screen and (max-width: 999px) {\n  /* line 248, stdin */\n  .schedule-box > div[_v-d995c392],\n  .service-box > div[_v-d995c392] {\n    padding: 5px 0; } }\n\n/* line 253, stdin */\n.error-msg[_v-d995c392] {\n  height: 20px;\n  color: #e07c7a; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-d995c392", module.exports)
  } else {
    hotAPI.update("_v-d995c392", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/object/keys":56,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],913:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['card', 'branch_id', 'bus', 'studio_id'],
    data: function data() {
        return {
            service_id: '',
            schedule_id: '',
            ajaxContracts: false,
            ajaxContract: false,
            sellableContracts: []
        };
    },

    methods: {
        ajaxContractsDone: function ajaxContractsDone() {
            this.ajaxContracts = false;
            this.bus.$emit('ajax-contracts-done');
        },
        loadContractsBy: function loadContractsBy(type, id) {
            var _this = this;

            this[type + '_id'] = id;
            this.ajaxContracts = true;
            this.$http.get(base_url + ('/api/contract_list/by_' + type + '/' + id + '?branch_id=' + this.branch_id)).then(function (response) {
                _this.sellableContracts = response.data;
                _this.ajaxContractsDone();
            });
        }
    },
    created: function created() {
        var _this2 = this;

        this.bus.$on('ajax-contracts', function (type, id) {
            $('#contract-list-modal').modal('show');
            if (_this2[type + '_id'] == id) return _this2.ajaxContractsDone();
            _this2.loadContractsBy(type, id);
        });
        this.bus.$on('ajax-contract-done', function () {
            _this2.ajaxContract = false;
        });
        this.bus.$on('Branch.Contract.Selected', function (contract) {
            if (_this2.ajaxContract) return;
            _this2.ajaxContract = true;
            _this2.$refs.contract_detail_modal.showContractModal(contract);
        });
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div>\n    <v-modal id=\"contract-list-modal\" no-footer=\"\" no-border-radius=\"\" :bus=\"bus\">\n        <div slot=\"title\">{{ i18n.t('pass.item_with_pass') }}</div>\n        <div slot=\"body\">\n            <template v-if=\"ajaxContracts\">\n                <v-spinner :ajaxing=\"ajaxContracts\"></v-spinner>\n            </template>\n            <div v-else=\"\">\n                <contract-list :contracts=\"sellableContracts\" :bus=\"bus\"></contract-list>\n            </div>\n        </div>\n    </v-modal>\n    <contract-detail-modal ref=\"contract_detail_modal\" :studio_id=\"studio_id\" :branch_id=\"branch_id\" :card=\"card\" :is_login=\"true\" :bus=\"bus\"></contract-detail-modal>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-2b23c478", module.exports)
  } else {
    hotAPI.update("_v-2b23c478", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],914:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 3, stdin */\n#subscription-contract-container .swiper-button-prev, #subscription-contract-container .swiper-button-next {\n  background-image: none;\n  top: 55%;\n  background-color: #F1F1F5;\n  width: 16px;\n  height: 32px;\n  padding: 3px 3px;\n  border-radius: 4px; }\n  /* line 11, stdin */\n  #subscription-contract-container .swiper-button-prev.swiper-button-disabled, #subscription-contract-container .swiper-button-next.swiper-button-disabled {\n    opacity: 0; }\n  /* line 14, stdin */\n  #subscription-contract-container .swiper-button-prev:after, #subscription-contract-container .swiper-button-next:after {\n    font-family: \"Material Icons\";\n    font-size: 20px;\n    color: #000; }\n\n/* line 20, stdin */\n#subscription-contract-container .swiper-button-prev {\n  left: 0; }\n  /* line 22, stdin */\n  #subscription-contract-container .swiper-button-prev:after {\n    content: \"\\e5e0\"; }\n\n/* line 26, stdin */\n#subscription-contract-container .swiper-button-next {\n  right: 0; }\n  /* line 28, stdin */\n  #subscription-contract-container .swiper-button-next:after {\n    content: \"\\e5e1\";\n    margin-left: -5px; }\n\n/* line 2, stdin */\n.swiper-card[_v-5784e26c] {\n  width: 100%;\n  height: 100%;\n  border-radius: 8px;\n  background: #fff;\n  border: 1px solid #E2E2EA; }\n  /* line 8, stdin */\n  .swiper-card .card-header[_v-5784e26c] {\n    background: #FAFAFB;\n    border-bottom: 1px solid #E2E2EA;\n    border-radius: 7px 7px 0px 0px;\n    text-align: center;\n    font-size: 14px;\n    font-weight: 500;\n    padding: 9px; }\n  /* line 17, stdin */\n  .swiper-card .card-body[_v-5784e26c] {\n    padding: 15px; }\n    /* line 19, stdin */\n    .swiper-card .card-body .row-ellipsis[_v-5784e26c] {\n      display: block;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap; }\n    /* line 25, stdin */\n    .swiper-card .card-body .description a[_v-5784e26c] {\n      font-size: 16px; }\n    /* line 28, stdin */\n    .swiper-card .card-body .highlight-font[_v-5784e26c] {\n      border-radius: 4px;\n      font-size: 14px;\n      padding: 4px 6px;\n      background: #38B0E3;\n      color: #fff; }\n    /* line 35, stdin */\n    .swiper-card .card-body .card-button[_v-5784e26c] {\n      position: absolute;\n      bottom: 15px; }\n      /* line 38, stdin */\n      .swiper-card .card-body .card-button .btn--black[_v-5784e26c] {\n        width: 155px;\n        height: 34px;\n        font-size: 14px; }\n\n/* line 46, stdin */\n.space-between[_v-5784e26c] {\n  display: -ms-flexbox;\n  display: flex;\n  margin-top: 16px;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap; }\n\n/* line 54, stdin */\n.description a[_v-5784e26c] {\n  color: #0099FF;\n  font-size: 14px;\n  text-decoration: underline; }\n\n/* line 60, stdin */\n.detail[_v-5784e26c] {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-align: center;\n      align-items: center;\n  gap: 24px;\n  margin-left: auto; }\n\n/* line 66, stdin */\n.discount[_v-5784e26c] {\n  background: #82C43C;\n  color: #ffffff;\n  padding: 4px 8px;\n  border-radius: 20px; }\n\n/* line 72, stdin */\n.discount-color[_v-5784e26c] {\n  color: #82C43C; }\n\n/* line 75, stdin */\n.font-bold[_v-5784e26c] {\n  font-weight: 700; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['isLogin', 'card', 'branchId', 'bus'],
    data: function data() {
        return {
            studio_id: this.$attrs['studio-id'],
            selectedTarget: {
                name: '',
                description: ''
            },
            targetType: '',
            ajaxContract: false,
            contracts: {},
            contractGroup: null,
            subscription: [],
            ajaxing: {
                contract: false,
                subscription: false
            }
        };
    },

    computed: {
        showSubscriptionContract: function showSubscriptionContract() {
            return _lodash2.default.isEmpty(this.subscription) ? false : true;
        },
        noAvailableContracts: function noAvailableContracts() {
            if (this.ajaxing.contract || this.ajaxing.subscription) {
                return false;
            }
            return !this.contractGroup && !this.showSubscriptionContract;
        },
        noDataMsg: function noDataMsg() {
            return i18n.t('pass.have_no_any_contract');
        },
        swiperOption: function swiperOption() {
            var vm = this;
            return {
                slidesPerView: 'auto',
                freeMode: true,
                spaceBetween: 15,
                on: {
                    click: function click(event) {
                        var dataset = event.target.dataset;

                        if (dataset.buyContractId && dataset.buyPricingOptionId) {
                            vm.preSelectContract('subscription', {
                                'buyContractId': dataset.buyContractId,
                                'buyPricingOptionId': dataset.buyPricingOptionId
                            });
                            vm.buyContract(vm.selectedTarget);
                        } else if (dataset.descriptionId) {
                            vm.preSelectContract('subscription', {
                                'buyContractId': dataset.descriptionId,
                                'buyPricingOptionId': dataset.buyPricingOptionId
                            });
                            vm.showDescription(vm.selectedTarget);
                        }
                    }
                }
            };
        }
    },
    created: function created() {
        var _this = this;

        this.bus.$on('ajax-contract-done', function () {
            _this.ajaxContract = false;
        });
        this.bus.$on('Branch.Contract.Selected', function (contract) {
            if (_this.ajaxContract) return;
            _this.ajaxContract = true;
            _this.$refs.contract_detail_modal.showContractModal(contract);
        });
    },
    mounted: function mounted() {
        this.refresh(true);
    },

    methods: {
        refresh: function refresh(checkData) {
            if (checkData) {
                if (!_lodash2.default.isEmpty(this.contracts)) return;
            }
            this.fetchContract();
            this.fetchSubscription();
        },
        fetchContract: function fetchContract() {
            var _this2 = this;

            if (!this.branchId || this.ajaxing.contract) return;
            this.ajaxing.contract = true;
            this.$http.get('/api/branch/' + this.branchId + '/pricing').then(function (response) {
                _this2.contracts = response.data;
                if (_lodash2.default.isEmpty(_this2.contracts)) {
                    _this2.contractGroup = null;
                } else {
                    var contractsQty = 0;
                    _this2.contracts.forEach(function (item) {
                        return contractsQty += item.contracts.length;
                    });
                    _this2.contractGroup = contractsQty <= 0 ? null : _this2.contracts;
                }
            }, function (error) {
                var err = error.data;
                if (err.msg == 'ThrottleRequestsException') {
                    $17.swal({
                        title: err.message,
                        type: 'warning',
                        showCancelButton: false
                    });
                }
                _this2.ajaxing.contract = false;
            }).then(function () {
                _this2.ajaxing.contract = false;
                _this2.autoRedirectByQuery();
            });
        },
        fetchSubscription: function fetchSubscription() {
            var _this3 = this;

            if (!this.branchId || this.ajaxing.subscription) return;
            this.ajaxing.subscription = true;
            this.$http.get('/webapi/branch/' + this.branchId + '/pricing').then(function (response) {
                _this3.subscription = response.data;
            }, function (error) {
                _this3.ajaxing.subscription = false;
            }).then(function () {
                _this3.ajaxing.subscription = false;
                _this3.autoRedirectByQuery();
                setTimeout(function () {
                    _this3.$refs.subscription_contract.updateSwiper();
                }, 1000);
            });
        },
        checkTargetContractType: function checkTargetContractType(basis, data) {
            if (basis == 'urlQuery') {
                if (data.hasOwnProperty('pricing_option_id') && data.hasOwnProperty('id')) {
                    this.targetType = 'subscription';
                } else if (!data.hasOwnProperty('pricing_option_id') && data.hasOwnProperty('id')) {
                    this.targetType = 'contracts';
                } else {
                    this.targetType = '';
                }
            } else {
                this.targetType = data.hasOwnProperty('pricing_option_id') ? 'subscription' : 'contracts';
            }
        },
        autoRedirectByQuery: function autoRedirectByQuery() {
            var _this4 = this;

            var query = $17.getUrlQueryStrings();
            var contractId = query.hasOwnProperty('id') ? query.id : null;
            var pricingOptionId = query.hasOwnProperty('pricing_option_id') ? query.pricing_option_id : null;
            this.checkTargetContractType('urlQuery', query);

            if (!this.targetType) return;
            if (_lodash2.default.isEmpty(this[this.targetType])) return;
            this.preSelectContract(this.targetType, {
                'buyContractId': contractId,
                'buyPricingOptionId': pricingOptionId
            });
            this.$nextTick(function () {
                if (_this4.selectedTarget.id) {
                    _this4.bus.$emit('Branch.Contract.Selected', _this4.selectedTarget);
                }
            });
        },
        preSelectContract: function preSelectContract(type, dataArray) {
            var _this5 = this;

            this.selectedTarget = {
                name: '',
                description: ''
            };
            switch (type) {
                case 'subscription':
                    (0, _entries2.default)(this.subscription).forEach(function (_ref) {
                        var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
                            key = _ref2[0],
                            contract = _ref2[1];

                        if (contract.id == dataArray.buyContractId && contract.pricing_option_id == dataArray.buyPricingOptionId) {
                            _this5.selectedTarget = contract;
                        }
                    });
                    break;
                case 'contracts':
                    this.contracts.forEach(function (group) {
                        group.contracts.forEach(function (contract) {
                            if (contract.id == dataArray.buyContractId) {
                                _this5.selectedTarget = contract;
                            }
                        });
                    });
                    break;
            }
            if (!this.selectedTarget.id) {
                this.targetType = '';
            }
        },
        buyContract: function buyContract(contract) {
            this.checkTargetContractType('selectedContract', contract);
            var query = $17.getUrlQueryStrings();
            var params = (0, _extends3.default)({}, query, {
                id: contract.id
            });
            if (this.targetType == 'subscription') {
                params['pricing_option_id'] = contract.pricing_option_id;
            }
            var newQueryString = $17.queryStringBuilder(params);
            history.replaceState({}, null, '?' + newQueryString);

            this.selectedTarget = contract;
            this.bus.$emit('Branch.Contract.Selected', this.selectedTarget);
        },
        discountPercentage: function discountPercentage(price, discount) {
            return Math.round(parseInt(discount) / parseInt(price) * 100);
        },
        realPrice: function realPrice(price, discount) {
            if (parseInt(price) - parseInt(discount) <= 0) {
                return 0;
            }
            return this.thousandFormat(parseInt(price) - parseInt(discount));
        },
        showDescription: function showDescription(item) {
            this.selectedTarget = item;
            this.checkTargetContractType('selectedContract', item);
            $('#branch-contract-description').modal('show');
        },
        thousandFormat: function thousandFormat(number) {
            return $17.thousandthFormat(number);
        },
        isDiscount: function isDiscount(item) {
            return parseInt(item.discount) > 0;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-5784e26c=\"\">\n    <div style=\"text-align: center; padding: 25px 0;\" v-show=\"noAvailableContracts\" _v-5784e26c=\"\">\n        <img src=\"/images/noData.svg\" width=\"105\" height=\"60\" _v-5784e26c=\"\">\n        <div style=\"color: #6c6c6c;\" class=\"m-top-10\" _v-5784e26c=\"\">{{noDataMsg}}</div>\n    </div>\n\n    <div v-show=\"!ajaxing.subscription &amp;&amp; showSubscriptionContract\" class=\"m-bottom-30\" id=\"subscription-contract-container\" _v-5784e26c=\"\">\n        <div class=\"m-bottom-15 m-left-15\" style=\"font-size: 26px; color: #000;\" _v-5784e26c=\"\">訂閱制方案\n            <a href=\"https://17fithelp.zendesk.com/hc/zh-tw/articles/4407063456921\" target=\"_blank\" _v-5784e26c=\"\"><i class=\"material-icons\" style=\"color: #000;\" _v-5784e26c=\"\">help_outline</i></a>\n        </div>\n        <v-carousel ref=\"subscription_contract\" :slid-slots=\"subscription\" :custom-swiper-option=\"swiperOption\" :pagination-show=\"false\" :navigation-show=\"true\" :pagination-dynamic-bullets=\"true\" swiper-slide-style=\"width: 184px; height: 232px; margin-left: 15px;\" _v-5784e26c=\"\">\n            <template slot=\"swiper-card\" slot-scope=\"{item}\">\n                <div class=\"swiper-card\" _v-5784e26c=\"\">\n                    <div class=\"card-header\" _v-5784e26c=\"\">{{ item.purchase_strategy_name }}</div>\n                    <div class=\"card-body\" _v-5784e26c=\"\">\n                        <font class=\"title-5 grey--100 row-ellipsis\" _v-5784e26c=\"\">{{item.name}}</font>\n                        <div class=\"description m-bottom-8\" _v-5784e26c=\"\">\n                            <a v-show=\"item.extend_description\" :data-description-id=\"item.id\" :data-buy-pricing-option-id=\"item.pricing_option_id\" _v-5784e26c=\"\">{{i18n.t('pass.subscription_direction')}}</a>\n                        </div>\n                        <div class=\"space-between\" _v-5784e26c=\"\">\n                            <span class=\"highlight-font primary-business-color-background\" _v-5784e26c=\"\">{{ item.purchase_strategy_short_name }}</span>\n                            <span class=\"font-bold grey--100 text-right\" _v-5784e26c=\"\">\n                                <div _v-5784e26c=\"\">{{ item.value &gt; 0 ? item.show_value : item.effective_days+'天' }}</div>\n                                <div _v-5784e26c=\"\">{{ item.currency }} {{ item.format_price }}</div>\n                            </span>\n                        </div>\n                        <div class=\"card-button\" _v-5784e26c=\"\">\n                            <a class=\"btn--black primary-business-color-background-hover\" :data-buy-contract-id=\"item.id\" :data-buy-pricing-option-id=\"item.pricing_option_id\" _v-5784e26c=\"\">{{ i18n.t('pass.buy') }}</a>\n                        </div>\n                    </div>\n                </div>\n            </template>\n        </v-carousel>\n    </div>\n    <v-spinner :ajaxing=\"ajaxing.contract || ajaxing.subscription\" _v-5784e26c=\"\"></v-spinner>\n    <div v-if=\"contractGroup\" _v-5784e26c=\"\">\n        <v-collapse-list list-id=\"contract_accordion_list\" :is-loading=\"ajaxing.contract\" :data-source=\"contractGroup\" :no-data-message=\"noDataMsg\" child-item-key=\"contracts\" _v-5784e26c=\"\">\n            <template slot=\"head\" slot-scope=\"{item}\">\n                <div _v-5784e26c=\"\">{{item.name}}</div>\n            </template>\n            <template slot=\"body\" slot-scope=\"{child_item}\">\n                <div style=\"margin: 16px;\" _v-5784e26c=\"\">\n                    <div class=\"head\" _v-5784e26c=\"\">\n                        <font class=\"title-5 grey--100\" _v-5784e26c=\"\">{{child_item.name}}</font>\n                    </div>\n                    <div class=\"space-between\" _v-5784e26c=\"\">\n                        <div class=\"description m-bottom-10\" _v-5784e26c=\"\">\n                            <a class=\"m-right-5\" v-show=\"child_item.description\" @click.prevent=\"showDescription(child_item)\" _v-5784e26c=\"\">{{i18n.t('pass.info')}}</a>\n                            <span v-if=\"child_item.experience_plan==1\" _v-5784e26c=\"\">\n                                <promotion-experience-label _v-5784e26c=\"\"></promotion-experience-label>\n                            </span>\n                        </div>\n                        <div _v-5784e26c=\"\"></div>\n                        <div class=\"detail\" _v-5784e26c=\"\">\n                            <p class=\"regular font-bold grey--80\" _v-5784e26c=\"\">{{child_item.count}}</p>\n                            <div v-if=\"isDiscount(child_item)\" class=\"discount\" _v-5784e26c=\"\">-{{ discountPercentage(child_item.price_num, child_item.discount) }}％</div>\n                            <p class=\"regular font-bold grey--100\" :class=\"{ 'discount-color':isDiscount(child_item) }\" _v-5784e26c=\"\">{{child_item.currency}}{{realPrice(child_item.price_num, child_item.discount)}}</p>\n                            <div _v-5784e26c=\"\">\n                                <a class=\"btn--black primary-business-color-background-hover\" v-if=\"child_item.can_sell\" @click=\"buyContract(child_item)\" _v-5784e26c=\"\">{{ i18n.t('pass.buy') }}</a>\n                                <a class=\"bookingDisalbed\" v-else=\"\" _v-5784e26c=\"\">{{ i18n.t('pass.sold_out') }}</a>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </template>\n        </v-collapse-list>\n    </div>\n\n    <v-modal id=\"branch-contract-description\" border-radius-level=\"20px\" no-footer=\"\" _v-5784e26c=\"\">\n        <div slot=\"title\" _v-5784e26c=\"\">\n            <font class=\"title-5 grey--100\" v-if=\"selectedTarget\" _v-5784e26c=\"\">{{selectedTarget.name}}</font>\n            <p class=\"txt-small grey--70\" _v-5784e26c=\"\">{{targetType == 'contracts' ? i18n.t('pass.info') : i18n.t('pass.subscription_direction')}}</p>\n        </div>\n        <div slot=\"body\" _v-5784e26c=\"\">\n            <p class=\"txt-small word-break grey--100\" v-if=\"targetType == 'contracts'\" _v-5784e26c=\"\">{{selectedTarget.description}}</p>\n            <div v-else=\"\" v-html=\"selectedTarget.extend_description\" _v-5784e26c=\"\"></div> \n        </div>\n    </v-modal>\n\n    <contract-detail-modal ref=\"contract_detail_modal\" :studio_id=\"studio_id\" :branch_id=\"branchId\" :card=\"card\" :bus=\"bus\" :is_login=\"isLogin\" _v-5784e26c=\"\"></contract-detail-modal>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 3, stdin */\n#subscription-contract-container .swiper-button-prev, #subscription-contract-container .swiper-button-next {\n  background-image: none;\n  top: 55%;\n  background-color: #F1F1F5;\n  width: 16px;\n  height: 32px;\n  padding: 3px 3px;\n  border-radius: 4px; }\n  /* line 11, stdin */\n  #subscription-contract-container .swiper-button-prev.swiper-button-disabled, #subscription-contract-container .swiper-button-next.swiper-button-disabled {\n    opacity: 0; }\n  /* line 14, stdin */\n  #subscription-contract-container .swiper-button-prev:after, #subscription-contract-container .swiper-button-next:after {\n    font-family: \"Material Icons\";\n    font-size: 20px;\n    color: #000; }\n\n/* line 20, stdin */\n#subscription-contract-container .swiper-button-prev {\n  left: 0; }\n  /* line 22, stdin */\n  #subscription-contract-container .swiper-button-prev:after {\n    content: \"\\e5e0\"; }\n\n/* line 26, stdin */\n#subscription-contract-container .swiper-button-next {\n  right: 0; }\n  /* line 28, stdin */\n  #subscription-contract-container .swiper-button-next:after {\n    content: \"\\e5e1\";\n    margin-left: -5px; }\n\n/* line 2, stdin */\n.swiper-card[_v-5784e26c] {\n  width: 100%;\n  height: 100%;\n  border-radius: 8px;\n  background: #fff;\n  border: 1px solid #E2E2EA; }\n  /* line 8, stdin */\n  .swiper-card .card-header[_v-5784e26c] {\n    background: #FAFAFB;\n    border-bottom: 1px solid #E2E2EA;\n    border-radius: 7px 7px 0px 0px;\n    text-align: center;\n    font-size: 14px;\n    font-weight: 500;\n    padding: 9px; }\n  /* line 17, stdin */\n  .swiper-card .card-body[_v-5784e26c] {\n    padding: 15px; }\n    /* line 19, stdin */\n    .swiper-card .card-body .row-ellipsis[_v-5784e26c] {\n      display: block;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap; }\n    /* line 25, stdin */\n    .swiper-card .card-body .description a[_v-5784e26c] {\n      font-size: 16px; }\n    /* line 28, stdin */\n    .swiper-card .card-body .highlight-font[_v-5784e26c] {\n      border-radius: 4px;\n      font-size: 14px;\n      padding: 4px 6px;\n      background: #38B0E3;\n      color: #fff; }\n    /* line 35, stdin */\n    .swiper-card .card-body .card-button[_v-5784e26c] {\n      position: absolute;\n      bottom: 15px; }\n      /* line 38, stdin */\n      .swiper-card .card-body .card-button .btn--black[_v-5784e26c] {\n        width: 155px;\n        height: 34px;\n        font-size: 14px; }\n\n/* line 46, stdin */\n.space-between[_v-5784e26c] {\n  display: -ms-flexbox;\n  display: flex;\n  margin-top: 16px;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap; }\n\n/* line 54, stdin */\n.description a[_v-5784e26c] {\n  color: #0099FF;\n  font-size: 14px;\n  text-decoration: underline; }\n\n/* line 60, stdin */\n.detail[_v-5784e26c] {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-align: center;\n      align-items: center;\n  gap: 24px;\n  margin-left: auto; }\n\n/* line 66, stdin */\n.discount[_v-5784e26c] {\n  background: #82C43C;\n  color: #ffffff;\n  padding: 4px 8px;\n  border-radius: 20px; }\n\n/* line 72, stdin */\n.discount-color[_v-5784e26c] {\n  color: #82C43C; }\n\n/* line 75, stdin */\n.font-bold[_v-5784e26c] {\n  font-weight: 700; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-5784e26c", module.exports)
  } else {
    hotAPI.update("_v-5784e26c", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/object/entries":54,"babel-runtime/helpers/extends":66,"babel-runtime/helpers/slicedToArray":70,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],915:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.contract[_v-f7f08fb8] {\n  padding: 20px 10px;\n  display: -ms-flexbox;\n  display: flex;\n  border-bottom: 1px solid #f5f5f7;\n  cursor: default;\n  -ms-flex-direction: column;\n      flex-direction: column; }\n  /* line 8, stdin */\n  .contract[_v-f7f08fb8]:hover {\n    background-color: #fdfdfd; }\n\n/* line 12, stdin */\n.discount-percentage[_v-f7f08fb8] {\n  color: white;\n  display: inline-block;\n  text-align: center;\n  vertical-align: middle;\n  padding: 2px 12px;\n  border: 0px solid #ffffff;\n  border-radius: 80px;\n  background-color: #1ab91a;\n  font-size: 12px; }\n\n/* line 23, stdin */\n.row-main[_v-f7f08fb8] {\n  display: -ms-flexbox;\n  display: flex; }\n\n/* line 26, stdin */\n.row-item[_v-f7f08fb8] {\n  min-width: 0; }\n\n/* line 29, stdin */\n.left-row[_v-f7f08fb8] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex: 1;\n      flex: 1;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap; }\n\n/* line 34, stdin */\n.contract-name[_v-f7f08fb8] {\n  -ms-flex: 1;\n      flex: 1;\n  display: -ms-flexbox;\n  display: flex;\n  padding-right: 15px;\n  -ms-flex-direction: column;\n      flex-direction: column; }\n  /* line 39, stdin */\n  .contract-name p[_v-f7f08fb8] {\n    word-break: break-word;\n    padding-top: 15px;\n    margin: 0;\n    font-size: 12px; }\n\n/* line 47, stdin */\n.contract-info[_v-f7f08fb8] {\n  width: 100px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column; }\n  /* line 52, stdin */\n  .contract-info > div[_v-f7f08fb8] {\n    padding-right: 20px;\n    text-align: right; }\n\n/* line 58, stdin */\n.contract-info > div[_v-f7f08fb8]:first-child {\n  min-height: 32px; }\n\n/* line 62, stdin */\n.contract-description[_v-f7f08fb8] {\n  width: 100%;\n  white-space: pre-wrap;\n  text-align: right;\n  max-height: 40px;\n  color: #aaaaaa;\n  font-size: 13px; }\n  /* line 69, stdin */\n  .contract-description p[_v-f7f08fb8] {\n    -webkit-line-clamp: 1;\n    overflow: hidden;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    text-align: left;\n    width: 70%; }\n  /* line 78, stdin */\n  .contract-description label[_v-f7f08fb8] {\n    margin-right: 15px;\n    color: #00bbf9;\n    font-size: 13px;\n    transform: translate(0, -37px); }\n  /* line 85, stdin */\n  .contract-description .description-checkbox[_v-f7f08fb8] {\n    opacity: 0;\n    position: absolute;\n    pointer-events: none; }\n    /* line 89, stdin */\n    .contract-description .description-checkbox:checked + p[_v-f7f08fb8] {\n      -webkit-line-clamp: unset;\n      width: 100%; }\n    /* line 93, stdin */\n    .contract-description .description-checkbox:checked ~ label[_v-f7f08fb8] {\n      transform: translate(0, 0); }\n\n/* line 101, stdin */\n.contract-buy[_v-f7f08fb8] {\n  width: 70px;\n  min-width: 70px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: end;\n      justify-content: flex-end;\n  white-space: pre-wrap;\n  margin: auto 0; }\n\n/* line 110, stdin */\n.default-buy-btn[_v-f7f08fb8] {\n  cursor: pointer;\n  padding: 8px 0px;\n  width: 63px;\n  height: 36px;\n  font-size: 15px;\n  text-align: center;\n  background-color: #000;\n  transition: all .2s;\n  color: #fff; }\n  /* line 121, stdin */\n  .default-buy-btn.disabled[_v-f7f08fb8] {\n    opacity: .2; }\n\n/* line 125, stdin */\n.discount[_v-f7f08fb8] {\n  color: green; }\n\n/* line 128, stdin */\n.contract-desc-hint[_v-f7f08fb8]:hover,\n.contract-desc-hint.active[_v-f7f08fb8] {\n  cursor: pointer;\n  color: #38b0e3; }\n\n@media screen and (min-width: 1000px) {\n  /* line 134, stdin */\n  .default-buy-btn[_v-f7f08fb8]:not(.disabled):hover {\n    background-color: #38b0e3; } }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['contracts', 'bus', 'updateUrl'],
    data: function data() {
        return {
            contractList: this.contracts.map(function (c) {
                c.showDesc = false;
                return _.clone(c);
            }),
            descriptionStyle: {
                wordBreak: 'break-word',
                marginTop: '20px',
                padding: '10px',
                color: '#fff',
                backgroundColor: '#b3b3b3',
                borderRadius: '5px'
            }
        };
    },
    mounted: function mounted() {
        window.addEventListener('load', function () {
            var description = document.getElementsByClassName('contract-description');
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(description), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var element = _step.value;

                    var p = element.children[1];
                    var isOverflown = p.scrollHeight > p.clientHeight || p.scrollWidth > p.clientWidth;
                    if (!isOverflown) {
                        element.children[2].style.display = 'none';
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        });
    },

    computed: {},
    methods: {
        toggleDesc: function toggleDesc(target) {
            target.showDesc = !target.showDesc;
        },
        showDetails: function showDetails(contract) {
            if (this.updateUrl) {
                history.replaceState(document.URL.split(base_url)[1], null, '?tab=pricing&id=' + contract.id);
            }
            this.bus.$emit('Branch.Contract.Selected', contract);
        },
        getRealPrice: function getRealPrice(price, discount) {
            if (parseInt(price) - parseInt(discount) <= 0) {
                return 0;
            }
            return parseInt(price) - parseInt(discount);
        },
        getDiscountPercentage: function getDiscountPercentage(price, discount) {
            return Math.round(parseInt(discount) / parseInt(price) * 100);
        },
        showMoreDescription: function showMoreDescription(id) {
            var checked = $('#' + id).is(":checked");
            var label = $('.toggle-' + id);
            var parent = $('.toggle-' + id).parent();
            if (checked) {
                label.text('展開說明▾');
                parent.css('max-height', '40px');
            } else {
                label.text('收合說明▴');
                parent.css('max-height', 'fit-content');
            }
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"contract-list\" _v-f7f08fb8=\"\">\n    <div class=\"contract\" v-for=\"c in contractList\" _v-f7f08fb8=\"\">\n        <div class=\"row-main\" _v-f7f08fb8=\"\">\n            <div class=\"left-row row-item\" _v-f7f08fb8=\"\">\n                <div class=\"contract-name\" _v-f7f08fb8=\"\">\n                    <span _v-f7f08fb8=\"\">{{ c.name }}</span>\n                    <p v-if=\"c.experience_plan==1\" _v-f7f08fb8=\"\">\n                        <promotion-experience-label _v-f7f08fb8=\"\"></promotion-experience-label>\n                    </p>\n                    <p v-if=\"c.description\" _v-f7f08fb8=\"\">\n                        <span class=\"sbig-hidden\" _v-f7f08fb8=\"\">\n                            <span class=\"contract-desc-hint\" :class=\"{active: c.showDesc}\" @click=\"toggleDesc(c)\" _v-f7f08fb8=\"\">\n                                <i class=\"fa fa-info-circle\" _v-f7f08fb8=\"\"></i> {{ i18n.t('pass.info') }}\n                            </span>\n                        </span>\n                    </p>\n                </div>\n                <div class=\"contract-info\" _v-f7f08fb8=\"\">\n                    <div _v-f7f08fb8=\"\">{{ c.count }}</div>\n                    <div :class=\"c.discount > 0 ? 'discount' : ''\" _v-f7f08fb8=\"\">{{c.currency}} {{ getRealPrice(c.price_num, c.discount) }}</div>\n                    <div class=\"m-top-10\" v-if=\"parseInt(c.discount) > 0\" _v-f7f08fb8=\"\"><span class=\"discount-percentage\" _v-f7f08fb8=\"\">- {{ getDiscountPercentage(c.price_num, c.discount) }}％</span></div>\n                </div>\n                <div class=\"contract-description\" v-if=\"c.description\" _v-f7f08fb8=\"\">\n                    <input class=\"description-checkbox\" type=\"checkbox\" :id=\"c.id\" _v-f7f08fb8=\"\">\n                    <p :class=\"'description-wrap-' + c.id\" _v-f7f08fb8=\"\">{{ c.description }}</p>\n                    <label :for=\"c.id\" :class=\"'toggle-' + c.id\" @click=\"showMoreDescription(c.id)\" _v-f7f08fb8=\"\">展開說明▾</label>\n                </div>\n            </div>\n            <div class=\"contract-buy row-item\" _v-f7f08fb8=\"\">\n                <div v-if=\"c.can_sell\" class=\"default-buy-btn primary-business-color-background-hover\" @click=\"showDetails(c)\" _v-f7f08fb8=\"\">{{ i18n.t('pass.buy') }}</div>\n                <div class=\"default-buy-btn disabled\" v-else=\"\" _v-f7f08fb8=\"\">{{ i18n.t('pass.sold_out') }}</div>\n            </div>\n        </div>\n        <div class=\"row-description sbig-hidden description-box\" v-show=\"c.showDesc\" _v-f7f08fb8=\"\">\n            <div :style=\"descriptionStyle\" _v-f7f08fb8=\"\">\n                {{ c.description }}\n            </div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.contract[_v-f7f08fb8] {\n  padding: 20px 10px;\n  display: -ms-flexbox;\n  display: flex;\n  border-bottom: 1px solid #f5f5f7;\n  cursor: default;\n  -ms-flex-direction: column;\n      flex-direction: column; }\n  /* line 8, stdin */\n  .contract[_v-f7f08fb8]:hover {\n    background-color: #fdfdfd; }\n\n/* line 12, stdin */\n.discount-percentage[_v-f7f08fb8] {\n  color: white;\n  display: inline-block;\n  text-align: center;\n  vertical-align: middle;\n  padding: 2px 12px;\n  border: 0px solid #ffffff;\n  border-radius: 80px;\n  background-color: #1ab91a;\n  font-size: 12px; }\n\n/* line 23, stdin */\n.row-main[_v-f7f08fb8] {\n  display: -ms-flexbox;\n  display: flex; }\n\n/* line 26, stdin */\n.row-item[_v-f7f08fb8] {\n  min-width: 0; }\n\n/* line 29, stdin */\n.left-row[_v-f7f08fb8] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex: 1;\n      flex: 1;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap; }\n\n/* line 34, stdin */\n.contract-name[_v-f7f08fb8] {\n  -ms-flex: 1;\n      flex: 1;\n  display: -ms-flexbox;\n  display: flex;\n  padding-right: 15px;\n  -ms-flex-direction: column;\n      flex-direction: column; }\n  /* line 39, stdin */\n  .contract-name p[_v-f7f08fb8] {\n    word-break: break-word;\n    padding-top: 15px;\n    margin: 0;\n    font-size: 12px; }\n\n/* line 47, stdin */\n.contract-info[_v-f7f08fb8] {\n  width: 100px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column; }\n  /* line 52, stdin */\n  .contract-info > div[_v-f7f08fb8] {\n    padding-right: 20px;\n    text-align: right; }\n\n/* line 58, stdin */\n.contract-info > div[_v-f7f08fb8]:first-child {\n  min-height: 32px; }\n\n/* line 62, stdin */\n.contract-description[_v-f7f08fb8] {\n  width: 100%;\n  white-space: pre-wrap;\n  text-align: right;\n  max-height: 40px;\n  color: #aaaaaa;\n  font-size: 13px; }\n  /* line 69, stdin */\n  .contract-description p[_v-f7f08fb8] {\n    -webkit-line-clamp: 1;\n    overflow: hidden;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    text-align: left;\n    width: 70%; }\n  /* line 78, stdin */\n  .contract-description label[_v-f7f08fb8] {\n    margin-right: 15px;\n    color: #00bbf9;\n    font-size: 13px;\n    transform: translate(0, -37px); }\n  /* line 85, stdin */\n  .contract-description .description-checkbox[_v-f7f08fb8] {\n    opacity: 0;\n    position: absolute;\n    pointer-events: none; }\n    /* line 89, stdin */\n    .contract-description .description-checkbox:checked + p[_v-f7f08fb8] {\n      -webkit-line-clamp: unset;\n      width: 100%; }\n    /* line 93, stdin */\n    .contract-description .description-checkbox:checked ~ label[_v-f7f08fb8] {\n      transform: translate(0, 0); }\n\n/* line 101, stdin */\n.contract-buy[_v-f7f08fb8] {\n  width: 70px;\n  min-width: 70px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: end;\n      justify-content: flex-end;\n  white-space: pre-wrap;\n  margin: auto 0; }\n\n/* line 110, stdin */\n.default-buy-btn[_v-f7f08fb8] {\n  cursor: pointer;\n  padding: 8px 0px;\n  width: 63px;\n  height: 36px;\n  font-size: 15px;\n  text-align: center;\n  background-color: #000;\n  transition: all .2s;\n  color: #fff; }\n  /* line 121, stdin */\n  .default-buy-btn.disabled[_v-f7f08fb8] {\n    opacity: .2; }\n\n/* line 125, stdin */\n.discount[_v-f7f08fb8] {\n  color: green; }\n\n/* line 128, stdin */\n.contract-desc-hint[_v-f7f08fb8]:hover,\n.contract-desc-hint.active[_v-f7f08fb8] {\n  cursor: pointer;\n  color: #38b0e3; }\n\n@media screen and (min-width: 1000px) {\n  /* line 134, stdin */\n  .default-buy-btn[_v-f7f08fb8]:not(.disabled):hover {\n    background-color: #38b0e3; } }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-f7f08fb8", module.exports)
  } else {
    hotAPI.update("_v-f7f08fb8", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/get-iterator":46,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],916:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _contractListModal = require('./contract-list-modal.vue');

var _contractListModal2 = _interopRequireDefault(_contractListModal);

var _contractListTab = require('./contract-list-tab.vue');

var _contractListTab2 = _interopRequireDefault(_contractListTab);

var _contractDetailModal = require('./contract-detail-modal.vue');

var _contractDetailModal2 = _interopRequireDefault(_contractDetailModal);

var _contractList = require('./contract-list.vue');

var _contractList2 = _interopRequireDefault(_contractList);

var _switchPaymentMethodPart = require('./switch-payment-method-part.vue');

var _switchPaymentMethodPart2 = _interopRequireDefault(_switchPaymentMethodPart);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('branch-contract-list-modal', _contractListModal2.default);
_vue2.default.component('contract-view', _contractListTab2.default);

_vue2.default.component('contract-detail-modal', _contractDetailModal2.default);
_vue2.default.component('contract-list', _contractList2.default);

_vue2.default.component('buy-contract-switch-payment-method-part', _switchPaymentMethodPart2.default);

},{"./contract-detail-modal.vue":912,"./contract-list-modal.vue":913,"./contract-list-tab.vue":914,"./contract-list.vue":915,"./switch-payment-method-part.vue":917,"vue":792}],917:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\ninput[type=radio][_v-a9ed0738] {\n  -webkit-appearance: radio;\n     -moz-appearance: radio;\n          appearance: radio;\n  width: inherit;\n  margin-right: 5px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['card', 'bus'],
    data: function data() {
        return {
            selectedPaymentTypeId: 0,
            validPaymentMethods: []
        };
    },

    computed: {
        isMultiPaymentType: function isMultiPaymentType() {
            return this.validPaymentMethods.length > 1;
        },
        isAvailablePaymentMethod: function isAvailablePaymentMethod() {
            return this.selectedPayment ? this.selectedPayment.type_id : false;
        },
        selectedPayment: function selectedPayment() {
            var _this = this;

            var types = this.validPaymentMethods || [];
            return types.find(function (item) {
                return item.type_id == _this.selectedPaymentTypeId;
            }) || {};
        }
    },
    watch: {
        selectedPaymentTypeId: function selectedPaymentTypeId(newVal) {
            if (newVal) {
                this.$emit('update-payment-method', this.selectedPayment);
            }
        }
    },
    methods: {
        generatePaymentMethods: function generatePaymentMethods(paymentMethods) {
            this.validPaymentMethods = paymentMethods;
            this.selectedPaymentTypeId = this.validPaymentMethods[0] ? this.validPaymentMethods[0].type_id : 0;
            this.$emit('update-payment-method', this.selectedPayment);
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div v-show=\"isAvailablePaymentMethod\" _v-a9ed0738=\"\">\n    <div class=\"st-border st-border-gray-30 st-border-solid st-border-b-0 st-rounded-t-4 st-text-16 st-py-3 st-px-4\" _v-a9ed0738=\"\">\n        {{ i18n.t('pass.payment_method') }}\n    </div>\n    <div class=\"st-border st-border-gray-30 st-border-solid st-rounded-b-4 st-p-4 st-text-16\" _v-a9ed0738=\"\">\n        <div v-if=\"isMultiPaymentType\" class=\"st-flex st-space-x-3\" _v-a9ed0738=\"\">\n            <label v-for=\"payment in validPaymentMethods\" _v-a9ed0738=\"\">\n                <input type=\"radio\" v-model=\"selectedPaymentTypeId\" :value=\"payment.type_id\" _v-a9ed0738=\"\">\n                {{ i18n.t(('payment.'+payment.name_key)) }}\n            </label>\n        </div>\n        <div v-else=\"\" _v-a9ed0738=\"\">\n            {{ i18n.t(('payment.'+selectedPayment.name_key)) }}\n        </div>\n\n        <div v-show=\"selectedPaymentTypeId == 2\" _v-a9ed0738=\"\">\n            <span v-if=\"card\" _v-a9ed0738=\"\"><i class=\"fa fa-credit-card\" _v-a9ed0738=\"\"></i> {{ card }}</span>\n            <v-new-card-form v-if=\"!card\" :bus=\"bus\" _v-a9ed0738=\"\"></v-new-card-form>\n        </div>\n        <div class=\"st-bg-gray-20 st-mt-3 st-p-2 st-rounded-4\" v-show=\"selectedPayment.notice\" _v-a9ed0738=\"\">\n            {{ selectedPayment.notice }}\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\ninput[type=radio][_v-a9ed0738] {\n  -webkit-appearance: radio;\n     -moz-appearance: radio;\n          appearance: radio;\n  width: inherit;\n  margin-right: 5px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-a9ed0738", module.exports)
  } else {
    hotAPI.update("_v-a9ed0738", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],918:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _index = require('./index.vue');

var _index2 = _interopRequireDefault(_index);

var _branchIntro = require('./branch-intro.vue');

var _branchIntro2 = _interopRequireDefault(_branchIntro);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('./contract');
require('./service');
require('./class');
require('./staff');

_vue2.default.component('web-branch-app', _index2.default);
_vue2.default.component('branch-intro', _branchIntro2.default);

},{"./branch-intro.vue":904,"./class":910,"./contract":916,"./index.vue":919,"./service":920,"./staff":922,"vue":792}],919:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['studio', 'branch', 'isWebstudio', 'isShowRating', 'bus', 'isLogin', 'card', 'webstudioBusinessColor'],
    data: function data() {
        return {
            currentTab: '',
            urlTab: '',
            tabsToUrl: {
                'class-view': 'classes',
                'service-view': 'appointments',
                'contract-view': 'pricing',
                'staff-view': 'staffs',
                'rating-comments': 'comments',
                'branch-intro': 'info'
            }
        };
    },

    computed: {},
    mounted: function mounted() {
        this.init();
    },

    methods: {
        init: function init() {
            var _this = this;

            var query = $17.getUrlQueryStrings();
            var defaultTab = this.studio.class_base ? 'class-view' : 'service-view';
            var urlTab = '';
            if (query.tab) {
                urlTab = (0, _keys2.default)(this.tabsToUrl).find(function (key) {
                    return _this.tabsToUrl[key] === query.tab;
                });
            }
            this.changeTab(urlTab ? urlTab : defaultTab, false);
        },
        changeTab: function changeTab(tabName) {
            var refreshQuery = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            if (this.checkTabValidation(tabName)) {
                this.currentTab = tabName || this.currentTab;
                this.updateUrl(this.urlTab, refreshQuery);
            } else {
                return window.location.href = window.location.pathname;
            }
        },
        checkTabValidation: function checkTabValidation(tab) {
            if (this.tabsToUrl.hasOwnProperty(tab)) {
                this.urlTab = this.tabsToUrl[tab];
                return true;
            } else {
                return false;
            }
        },
        updateUrl: function updateUrl(tabName) {
            var replaced = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var query = $17.getUrlQueryStrings();
            var params = {};
            if (replaced) {
                params = {
                    tab: tabName
                };
            } else {
                params = (0, _extends3.default)({}, query, {
                    tab: tabName
                });
            }
            var newQueryString = $17.queryStringBuilder(params);
            history.replaceState({}, null, '?' + newQueryString);
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div>\n    <v-branch-tab :studio=\"studio\" :is-websutdio=\"isWebstudio\" :is-show-rating=\"isShowRating\" :current-tab=\"currentTab\" :select-tab=\"changeTab\" :webstudio-business-color=\"webstudioBusinessColor\"></v-branch-tab>\n\n    <div id=\"vue-branch-app-switch\">\n        <keep-alive>\n            <component :is=\"currentTab\" :current-branch=\"branch\" :branch-url=\"branch.url\" :studio-url=\"studio.url\" :studio-id=\"studio.id\" :branch-id=\"branch.id\" :is-login=\"isLogin\" :is-webstudio=\"isWebstudio\" :bus=\"bus\" :card=\"card\">\n            </component>                \n        </keep-alive>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-b84401cc", module.exports)
  } else {
    hotAPI.update("_v-b84401cc", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/object/keys":56,"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785}],920:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _index = require('./index.vue');

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('service-view', _index2.default);

},{"./index.vue":921,"vue":792}],921:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\nfont.title-5[_v-1240bc40] {\n  color: #171725;\n  font-weight: 700;\n  font-size: 18px; }\n\n/* line 9, stdin */\n.description a[_v-1240bc40] {\n  color: #0099FF;\n  font-size: 14px;\n  text-decoration: underline; }\n\n/* line 16, stdin */\n.space-between[_v-1240bc40] {\n  display: -ms-flexbox;\n  display: flex;\n  margin-top: 16px;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap; }\n\n/* line 24, stdin */\n.detail[_v-1240bc40] {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-align: center;\n      align-items: center;\n  gap: 24px;\n  margin-left: auto; }\n  /* line 29, stdin */\n  .detail .time[_v-1240bc40] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n    gap: 5px;\n    color: #696974;\n    font-weight: 500;\n    font-size: 16px; }\n    /* line 36, stdin */\n    .detail .time i[_v-1240bc40] {\n      font-size: 20px; }\n  /* line 41, stdin */\n  .detail .price span[_v-1240bc40] {\n    font-size: 14px;\n    font-weight: 500;\n    color: #171725; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        studioId: {
            default: 0
        },
        branchId: {
            default: 0
        },
        isLogin: {
            type: [Boolean, String]
        }
    },
    data: function data() {
        return {
            ajaxing: false,
            dataSource: [],
            priceEnum: {},
            selectedService: '',
            serviceList: [],
            descriptionModal: {},
            isInWebStudio: 1
        };
    },
    mounted: function mounted() {
        this.refresh(true);
        this.fetchInitData();
    },

    computed: {
        serviceTotal: function serviceTotal() {
            return this.serviceList.map(function (value) {
                return value.name;
            }).join(' ,');
        },
        priceTotal: function priceTotal() {
            var vm = this;
            return this.serviceList.reduce(function (pre, current) {
                if (vm.hasContract(current)) return pre;
                return pre + parseInt(current.price);
            }, 0).toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
        },
        timeTotal: function timeTotal() {
            var timeInMinute = this.serviceList.reduce(function (pre, current) {
                return pre + parseInt(current.service_time);
            }, 0);
            return Math.floor(timeInMinute / 60) + ' ' + i18n.t('general.hours') + timeInMinute % 60 + ' ' + i18n.t('general.minutes');
        },
        noServiceMsg: function noServiceMsg() {
            return i18n.t('service.have_no_any_service');
        },

        showLoginFB: function showLoginFB() {
            return this.isInWebStudio == 1 ? 0 : 1;
        }
    },
    methods: {
        refresh: function refresh(checkData) {
            if (this.ajaxing) return;
            if (checkData) {
                if (!_lodash2.default.isEmpty(this.dataSource)) return;
            }
            this.fetchData();
        },
        fetchData: function fetchData() {
            var _this = this;

            if (!this.branchId) return;
            this.ajaxing = true;
            var params = this.getUrlParamValue('r');
            this.$http.get('/api/branch/' + this.branchId + '/services?r=' + params).then(function (response) {
                _this.dataSource = response.data.menuGroups;
                _this.priceEnum = response.data.servicePriceList;
                _this.selectedService = response.data.selectedService;
                if (_this.selectedService) {
                    _this.redirectToAppointment();
                }
                _this.ajaxing = false;
            }, function (error) {
                _this.ajaxing = false;
            });
        },
        redirectToAppointment: function redirectToAppointment() {
            if (!this.isLogin) {
                this.$refs.loginForm.login();
                return;
            };
            var vm = this;
            this.dataSource.forEach(function (mg) {
                mg.services.forEach(function (s) {
                    if (s.id == vm.selectedService) {
                        vm.submitSelectedService(s);
                    }
                });
            });
        },
        submitSelectedService: function submitSelectedService(service) {
            var _this2 = this;

            if (!this.isLogin) {
                this.$refs.loginForm.login();
                return;
            };
            this.ajaxing = true;
            this.serviceList = this.toggleValueInList(this.serviceList, service);
            this.$nextTick(function () {
                _this2.formSubmit();
            });
        },
        toggleValueInList: function toggleValueInList(array, service) {
            if (array.indexOf(service) > -1) {
                return array.filter(function (each) {
                    return each != service;
                });
            }
            return array.concat(service);
        },
        formSubmit: function formSubmit() {
            var form = document.createElement("form");
            form.setAttribute("method", "post");
            form.setAttribute("action", "/service-flow-sp");

            var params = [];
            params['currency'] = this.serviceList[0].currency;
            params['studio_id'] = this.studioId;
            params['branch_id'] = this.branchId;
            params['selected_services'] = this.serviceList.map(function (s) {
                return s.id;
            });
            params['selected_services_namelist'] = this.serviceTotal;
            params['selected_services_timetotal'] = this.timeTotal;
            params['selected_services_pricetotal'] = this.priceTotal;
            params['service_url'] = window.location.origin + window.location.pathname + '?tab=appointments';

            for (var key in params) {
                var hiddenField = document.createElement("input");
                hiddenField.setAttribute("type", "hidden");
                hiddenField.setAttribute("name", key);
                hiddenField.setAttribute("value", params[key]);

                form.appendChild(hiddenField);
            }

            document.body.appendChild(form);
            form.submit();
        },
        serviceAppointCheck: function serviceAppointCheck(service) {
            if (this.hasService(service)) return 'service_checked';
            return 'booking';
        },
        hasContract: function hasContract(service) {
            if (!(service.id in this.priceEnum)) return false;
            return this.priceEnum[service.id] == 2;
        },
        hasService: function hasService(service) {
            return this.serviceList.indexOf(service) > -1;
        },
        thousandthFormat: function thousandthFormat(number) {
            return $17.thousandthFormat(number);
        },
        showDescription: function showDescription(service) {
            this.descriptionModal = service;
            $('#branch-service-description').modal('show');
        },

        fetchInitData: function fetchInitData() {
            this.$http.get(base_url + '/webapi/init/data').then(function (response) {
                this.isInWebStudio = response.data.is_in_webstudio;
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-1240bc40=\"\">\n    <v-collapse-list list-id=\"service_accordion_list\" :is-loading=\"ajaxing\" :data-source=\"dataSource\" :no-data-message=\"noServiceMsg\" child-item-key=\"services\" _v-1240bc40=\"\">\n        <template slot=\"head\" slot-scope=\"{item}\">\n            <div _v-1240bc40=\"\">{{item.menu_group_name}}</div>\n        </template>\n        <template slot=\"body\" slot-scope=\"{child_item}\">\n            <div style=\"margin: 16px\" _v-1240bc40=\"\">\n                <div class=\"head\" _v-1240bc40=\"\">\n                    <font class=\"title-5\" _v-1240bc40=\"\">{{child_item.name}}</font>\n                </div>\n                <div class=\"space-between\" _v-1240bc40=\"\">\n                    <div class=\"description\" _v-1240bc40=\"\">\n                        <a v-show=\"child_item.description\" @click.prevent=\"showDescription(child_item)\" _v-1240bc40=\"\">{{i18n.t('service.description')}}</a>\n                    </div>\n                    <div class=\"detail\" _v-1240bc40=\"\">\n                        <span class=\"time\" _v-1240bc40=\"\"><i class=\"material-icons\" _v-1240bc40=\"\">schedule</i>{{child_item.service_time}} {{i18n.t('general.minutes')}}</span>\n                        <div class=\"price\" _v-1240bc40=\"\">\n                            <span v-if=\"priceEnum[child_item.id] == 1\" _v-1240bc40=\"\">\n                                {{child_item.currency}} {{thousandthFormat(child_item.price)}}\n                                <span v-show=\"child_item.price_floor == 1\" _v-1240bc40=\"\">up</span>                                    \n                            </span>\n                            <span v-if=\"priceEnum[child_item.id] == 2\" _v-1240bc40=\"\">\n                                <i class=\"material-icons\" _v-1240bc40=\"\">task_alt</i>{{i18n.t('service.have_contract')}}\n                            </span>\n                            <span v-if=\"priceEnum[child_item.id] == 3\" _v-1240bc40=\"\">\n                                {{i18n.t('service.only_booking_by_contract')}}\n                            </span>\n                        </div>\n                        <span _v-1240bc40=\"\"><a class=\"btn--black primary-business-color-background-hover\" @click=\"submitSelectedService(child_item)\" _v-1240bc40=\"\">{{i18n.t('general.appointment')}}</a></span>\n                    </div>\n                </div>\n            </div>\n        </template>\n    </v-collapse-list>\n    <v-modal id=\"branch-service-description\" border-radius-level=\"20px\" no-footer=\"\" _v-1240bc40=\"\">\n        <div slot=\"title\" _v-1240bc40=\"\">\n            <font class=\"title-5 grey--100\" _v-1240bc40=\"\">{{this.descriptionModal.name}}</font>\n            <p class=\"txt-small grey--70\" _v-1240bc40=\"\">{{i18n.t('service.description')}}</p>\n        </div>\n        <div slot=\"body\" _v-1240bc40=\"\">\n            <p class=\"txt-small word-break grey--100\" _v-1240bc40=\"\">{{this.descriptionModal.description}}</p>\n        </div>\n    </v-modal>\n    <web-user-login-hidden-form ref=\"loginForm\" platform-define=\"seventeen-fit\" :show-fb=\"showLoginFB\" dest-url-type=\"current\" _v-1240bc40=\"\"></web-user-login-hidden-form>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\nfont.title-5[_v-1240bc40] {\n  color: #171725;\n  font-weight: 700;\n  font-size: 18px; }\n\n/* line 9, stdin */\n.description a[_v-1240bc40] {\n  color: #0099FF;\n  font-size: 14px;\n  text-decoration: underline; }\n\n/* line 16, stdin */\n.space-between[_v-1240bc40] {\n  display: -ms-flexbox;\n  display: flex;\n  margin-top: 16px;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap; }\n\n/* line 24, stdin */\n.detail[_v-1240bc40] {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-align: center;\n      align-items: center;\n  gap: 24px;\n  margin-left: auto; }\n  /* line 29, stdin */\n  .detail .time[_v-1240bc40] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n    gap: 5px;\n    color: #696974;\n    font-weight: 500;\n    font-size: 16px; }\n    /* line 36, stdin */\n    .detail .time i[_v-1240bc40] {\n      font-size: 20px; }\n  /* line 41, stdin */\n  .detail .price span[_v-1240bc40] {\n    font-size: 14px;\n    font-weight: 500;\n    color: #171725; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-1240bc40", module.exports)
  } else {
    hotAPI.update("_v-1240bc40", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],922:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _staff_view = require('./staff_view.vue');

var _staff_view2 = _interopRequireDefault(_staff_view);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('staff-view', _staff_view2.default);

},{"./staff_view.vue":923,"vue":792}],923:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.branch-staff-view[_v-c67e94ca] {\n  margin-left: -12px;\n  margin-right: -12px; }\n  /* line 5, stdin */\n  .branch-staff-view .content[_v-c67e94ca] {\n    display: -ms-flexbox;\n    display: flex;\n    gap: 24px;\n    padding: 16px; }\n  /* line 10, stdin */\n  .branch-staff-view .header[_v-c67e94ca] {\n    font-size: 24px;\n    font-weight: bold;\n    color: #000000; }\n  /* line 15, stdin */\n  .branch-staff-view .gallery[_v-c67e94ca] {\n    white-space: nowrap; }\n  /* line 18, stdin */\n  .branch-staff-view .intro[_v-c67e94ca] {\n    margin-top: 8px;\n    overflow: hidden;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    text-align: left; }\n    /* line 24, stdin */\n    .branch-staff-view .intro.list[_v-c67e94ca] {\n      -webkit-line-clamp: 4; }\n    /* line 27, stdin */\n    .branch-staff-view .intro.grid[_v-c67e94ca] {\n      -webkit-line-clamp: 2; }\n  /* line 31, stdin */\n  .branch-staff-view .avatar-holder[_v-c67e94ca] {\n    height: 160px;\n    max-width: 160px;\n    text-align: center; }\n  /* line 36, stdin */\n  .branch-staff-view .avatar-thumb[_v-c67e94ca] {\n    width: 160px;\n    height: 160px;\n    display: inline-block;\n    border-radius: 50%;\n    background-size: cover;\n    background-position: center; }\n    /* line 43, stdin */\n    .branch-staff-view .avatar-thumb.grid[_v-c67e94ca] {\n      width: 140px;\n      height: 140px; }\n  /* line 48, stdin */\n  .branch-staff-view .overflow[_v-c67e94ca] {\n    display: -webkit-inline-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 1; }\n  @media (min-width: 0px) and (max-width: 1000px) {\n    /* line 2, stdin */\n    .branch-staff-view[_v-c67e94ca] {\n      margin: 0; } }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        branchId: {
            default: 0
        },
        studioId: {
            default: 0
        }
    },
    data: function data() {
        return {
            ajaxing: false,
            staff: [],
            selectedSp: {}
        };
    },

    computed: {
        apiConfig: function apiConfig() {
            return {
                methods: 'get',
                apiurl: '/api/branch/' + this.branchId + '/staffs'
            };
        },
        commentApiConfig: function commentApiConfig() {
            if (_lodash2.default.isEmpty(this.selectedSp)) return {};
            return {
                apiurl: '/api/staff/comments/' + this.selectedSp.id + '?studio_id=' + this.studioId
            };
        }
    },
    watch: {},
    mounted: function mounted() {
        this.refresh(true);
    },

    updated: function updated() {
        $('.gallery').lightGallery({
            thumbnail: true
        }).click(function (event) {
            event.preventDefault();
            event.stopPropagation();
        });
    },
    methods: {
        refresh: function refresh() {
            var checkData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            if (this.ajaxing) return;
            if (checkData) {
                if (!_lodash2.default.isEmpty(this.staff)) return;
            };
            this.$refs.staff_view.fetchData();
            this.ajaxing = true;
        },
        fetchSuccess: function fetchSuccess(data) {
            this.staff = data;
            this.ajaxing = false;
        },
        fetchFail: function fetchFail(data) {
            this.ajaxing = false;
            $17.swal({
                type: 'error',
                title: "讀取資料發生錯誤，請重新嘗試",
                showCancelButton: false
            });
        },
        showStaffComment: function showStaffComment(sp) {
            this.selectedSp = sp;
            $('#v-comment-modal').modal('show');
        },
        avatar: function avatar(staff) {
            var path = staff.pic;
            var defaultAvatar = '/images/default.png';
            return 'url(' + path + '), url(' + defaultAvatar + ')';
        },
        thousandthFormat: function thousandthFormat(number) {
            return $17.thousandthFormat(number);
        },
        removeBr: function removeBr(des) {
            return des.replace(/<br ?\/?>/ig, " ");
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"branch-staff-view\" _v-c67e94ca=\"\">\n    <div class=\"m-right-15\" style=\"text-align: right;\" _v-c67e94ca=\"\">\n        <v-switch-layout-btn :target-view=\"$refs.staff_view\" _v-c67e94ca=\"\">\n        </v-switch-layout-btn>            \n    </div>\n    <v-switch-layout ref=\"staff_view\" :api-config=\"apiConfig\" :json-data=\"staff\" list-style-class=\"col-xs-12 p-left-0 p-right-0\" grid-style-class=\"col-sm-6 col-xs-12 p-left-0 p-right-0\" @fetch-success-callback=\"fetchSuccess\" @fetch-fail-callback=\"fetchFail\" _v-c67e94ca=\"\">\n        <template slot=\"list\" slot-scope=\"{item}\">\n            <div class=\"round-border content\" @click.prevent=\"showStaffComment(item)\" v-if=\"!_.isEmpty(item)\" _v-c67e94ca=\"\">\n                <div class=\"avatar-holder\" _v-c67e94ca=\"\">\n                    <div class=\"avatar-thumb\" :style=\"{'background-image': avatar(item) }\" _v-c67e94ca=\"\"></div>\n                </div>\n                <div style=\"width: 100%;\" _v-c67e94ca=\"\">\n                    <div style=\"display:flex; align-items:center; justify-content:space-between;\" _v-c67e94ca=\"\">\n                        <div class=\"header\" _v-c67e94ca=\"\">{{item.name}}\n                            <span class=\"gallery\" v-show=\"item.galleries.length>0\" _v-c67e94ca=\"\">\n                                <a :href=\"item.pic\" class=\"gallery background-image-link btn-brand--label m-left-15 primary-business-color-background\" _v-c67e94ca=\"\"><i class=\"material-icons\" _v-c67e94ca=\"\">insert_photo</i>{{ i18n.t('staff.album') }} ({{item.galleries.length}})</a>\n                                <a v-for=\"gallery in item.galleries\" :href=\"gallery.pic\" hidden=\"\" _v-c67e94ca=\"\">\n                                    <img :src=\"gallery.pic\" _v-c67e94ca=\"\">\n                                </a>\n                            </span>\n                        </div>\n                        <div v-show=\"item.rating>0\" _v-c67e94ca=\"\">\n                            <a class=\"btn-brand--label m-right-10 primary-business-color-background\" _v-c67e94ca=\"\">{{item.rating_avg}}</a>\n                            <p class=\"regular grey--80 overflow\" _v-c67e94ca=\"\">{{thousandthFormat(item.rating)}} {{ i18n.t('rating.comments') }}</p>\n                        </div>\n                    </div>\n                    <div _v-c67e94ca=\"\">\n                        <p class=\"regular intro list\" v-if=\"item.desc\" _v-c67e94ca=\"\">{{removeBr(item.desc)}}</p>\n                        <p class=\"regular intro grey--60\" v-else=\"\" _v-c67e94ca=\"\">{{i18n.t('staff.no_further_info')}}</p>\n                    </div>\n                </div>\n            </div>\n        </template>\n\n        <template slot=\"grid\" slot-scope=\"{item}\">\n            <div class=\"round-border\" style=\"padding: 16px; height: 260px;\" @click.prevent=\"showStaffComment(item)\" v-if=\"!_.isEmpty(item)\" _v-c67e94ca=\"\">\n                <div style=\"display: flex; gap: 24px;\" _v-c67e94ca=\"\">\n                    <div class=\"avatar-holder\" _v-c67e94ca=\"\">\n                        <div class=\"avatar-thumb grid\" :style=\"{'background-image': avatar(item) }\" _v-c67e94ca=\"\"></div>\n                    </div>\n                    <div style=\"width: 100%;\" _v-c67e94ca=\"\">\n                        <div class=\"header\" _v-c67e94ca=\"\">\n                            <div _v-c67e94ca=\"\">{{item.name}}</div>\n                            <div v-show=\"item.rating>0\" style=\"display: flex; align-items: center;\" _v-c67e94ca=\"\">\n                                <a class=\"btn-brand--label m-right-10 primary-business-color-background\" _v-c67e94ca=\"\">{{item.rating_avg}}</a>\n                                <p class=\"regular grey--80 overflow\" _v-c67e94ca=\"\">{{thousandthFormat(item.rating)}} {{ i18n.t('rating.comments') }}</p>\n                            </div>\n                            <span class=\"gallery\" v-show=\"item.galleries.length>0\" _v-c67e94ca=\"\">\n                                <a :href=\"item.pic\" class=\"gallery background-image-link btn-brand--label m-top-5 primary-business-color-background\" _v-c67e94ca=\"\"><i class=\"material-icons\" _v-c67e94ca=\"\">insert_photo</i>{{ i18n.t('staff.album') }} ({{item.galleries.length}})</a>\n                                <a v-for=\"gallery in item.galleries\" :href=\"gallery.pic\" hidden=\"\" _v-c67e94ca=\"\">\n                                    <img :src=\"gallery.pic\" _v-c67e94ca=\"\">\n                                </a>\n                            </span>\n                        </div>\n                    </div>\n                </div>\n                <div _v-c67e94ca=\"\">\n                    <p class=\"regular intro grid\" v-if=\"item.desc\" _v-c67e94ca=\"\">{{removeBr(item.desc)}}</p>\n                    <p class=\"regular intro grey--60\" v-else=\"\" _v-c67e94ca=\"\">{{i18n.t('staff.no_further_info')}}</p>\n                </div>\n            </div>\n        </template>\n\n    </v-switch-layout>\n    <v-comment-modal :api-config=\"commentApiConfig\" :service-provider=\"selectedSp\" _v-c67e94ca=\"\"></v-comment-modal>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.branch-staff-view[_v-c67e94ca] {\n  margin-left: -12px;\n  margin-right: -12px; }\n  /* line 5, stdin */\n  .branch-staff-view .content[_v-c67e94ca] {\n    display: -ms-flexbox;\n    display: flex;\n    gap: 24px;\n    padding: 16px; }\n  /* line 10, stdin */\n  .branch-staff-view .header[_v-c67e94ca] {\n    font-size: 24px;\n    font-weight: bold;\n    color: #000000; }\n  /* line 15, stdin */\n  .branch-staff-view .gallery[_v-c67e94ca] {\n    white-space: nowrap; }\n  /* line 18, stdin */\n  .branch-staff-view .intro[_v-c67e94ca] {\n    margin-top: 8px;\n    overflow: hidden;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    text-align: left; }\n    /* line 24, stdin */\n    .branch-staff-view .intro.list[_v-c67e94ca] {\n      -webkit-line-clamp: 4; }\n    /* line 27, stdin */\n    .branch-staff-view .intro.grid[_v-c67e94ca] {\n      -webkit-line-clamp: 2; }\n  /* line 31, stdin */\n  .branch-staff-view .avatar-holder[_v-c67e94ca] {\n    height: 160px;\n    max-width: 160px;\n    text-align: center; }\n  /* line 36, stdin */\n  .branch-staff-view .avatar-thumb[_v-c67e94ca] {\n    width: 160px;\n    height: 160px;\n    display: inline-block;\n    border-radius: 50%;\n    background-size: cover;\n    background-position: center; }\n    /* line 43, stdin */\n    .branch-staff-view .avatar-thumb.grid[_v-c67e94ca] {\n      width: 140px;\n      height: 140px; }\n  /* line 48, stdin */\n  .branch-staff-view .overflow[_v-c67e94ca] {\n    display: -webkit-inline-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 1; }\n  @media (min-width: 0px) and (max-width: 1000px) {\n    /* line 2, stdin */\n    .branch-staff-view[_v-c67e94ca] {\n      margin: 0; } }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-c67e94ca", module.exports)
  } else {
    hotAPI.update("_v-c67e94ca", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],924:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _modal = require('./modal.vue');

var _modal2 = _interopRequireDefault(_modal);

var _index = require('./index.vue');

var _index2 = _interopRequireDefault(_index);

var _interaction = require('./interaction.vue');

var _interaction2 = _interopRequireDefault(_interaction);

var _oneTimeEmailAuthForm = require('./one-time-email-auth-form.vue');

var _oneTimeEmailAuthForm2 = _interopRequireDefault(_oneTimeEmailAuthForm);

var _verifyCodeInteractionForm = require('./verify-code-interaction-form.vue');

var _verifyCodeInteractionForm2 = _interopRequireDefault(_verifyCodeInteractionForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('web-auth-service-modal', _modal2.default);
_vue2.default.component('web-auth-service-index', _index2.default);
_vue2.default.component('web-auth-service-interaction', _interaction2.default);
_vue2.default.component('web-one-time-email-auth-form', _oneTimeEmailAuthForm2.default);
_vue2.default.component('web-verify-code-interaction-form', _verifyCodeInteractionForm2.default);

},{"./index.vue":925,"./interaction.vue":926,"./modal.vue":927,"./one-time-email-auth-form.vue":928,"./verify-code-interaction-form.vue":929,"vue":792}],925:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        dispatchers: {
            default: function _default() {
                return [];
            }
        },
        attrs: {
            type: Object,
            default: function _default() {
                return [];
            }
        },
        autoSubmit: {
            default: false
        }
    },
    data: function data() {
        return {
            interactionRoute: 'AuthInteraction',
            method: 'email',
            formComponents: {
                email: {
                    name: "web-one-time-email-auth-form",
                    params: {}
                }
            },
            loading: false
        };
    },

    computed: {
        dispatcherArray: function dispatcherArray() {
            if (!_lodash2.default.isArray(this.dispatchers)) {
                return [this.dispatchers];
            }
            return this.dispatchers;
        },

        formComponent: function formComponent() {
            return this.formComponents[this.method] || {};
        }
    },
    methods: {
        onFormRequested: function onFormRequested(payload) {
            if (payload.state == 'waiting-interaction') {
                this.$emit('requested', payload);
            } else {
                $17.swal({
                    type: 'error',
                    title: '發生錯誤',
                    text: '不支援的驗證狀態[' + payload.state + ']',
                    showCancelButton: false
                });
            }
        },
        onFormLocked: function onFormLocked() {
            this.loading = true;
        },
        onFormUnlocked: function onFormUnlocked() {
            this.loading = false;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div>\n    <v-spinner :ajaxing=\"loading\"></v-spinner>\n\n    <div v-show=\"!loading\" class=\"bottom-fixed-container-padding\">\n        <form v-show=\"false\">\n            <div class=\"form-group\">\n                <div class=\"form-group-title\">\n                    <div class=\"row\">\n                        <form class=\"col-12\">\n                            <div class=\"status\">\n                                <label>\n                                    簡訊驗證\n                                    <input v-model=\"method\" type=\"radio\" data-role=\"segmented\" name=\"method\" value=\"phone-text\">\n                                </label>\n                                <label>\n                                    Email驗證\n                                    <input v-model=\"method\" type=\"radio\" data-role=\"segmented\" name=\"method\" value=\"email\">\n                                </label>\n                            </div>\n                        </form>\n                    </div>\n                </div>\n            </div>\n        </form>\n        <component :is=\"formComponent.name\" :attrs=\"attrs\" :dispatchers=\"dispatcherArray\" :auto-submit=\"autoSubmit\" v-on:requested=\"onFormRequested\" v-on:lock-form=\"onFormLocked\" v-on:unlock-form=\"onFormUnlocked\"></component>\n\n        <div v-if=\"!formComponent.hasOwnProperty('name')\" class=\"mbsc-align-center mbsc-txt-muted\">尚未支援</div>\n\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-66515a78", module.exports)
  } else {
    hotAPI.update("_v-66515a78", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"lodash":717,"vue":792,"vue-hot-reload-api":785}],926:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        id: {
            default: ''
        },
        interaction: {
            default: ''
        },
        attrs: {
            type: Object,
            default: function _default() {
                return [];
            }
        }
    },
    data: function data() {
        return {
            formComponents: {
                'verify.code': {
                    name: "web-verify-code-interaction-form",
                    params: {}
                }
            },
            loading: false
        };
    },
    mounted: function mounted() {},

    computed: {
        formComponent: function formComponent() {
            return this.formComponents[this.interaction] || {};
        }
    },
    methods: {
        onFormSuccess: function onFormSuccess(payload) {
            var self = this;
            var successMsg = '已完成驗證';
            $17.swal({
                type: 'success',
                title: successMsg,
                showCancelButton: false
            });
            this.$emit('succeed');
        },
        onFormLocked: function onFormLocked() {
            this.loading = true;
        },
        onFormUnlocked: function onFormUnlocked() {
            this.loading = false;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div>\n    <v-spinner :ajaxing=\"loading\"></v-spinner>\n    <component v-show=\"!loading\" :is=\"formComponent.name\" :ticket=\"id\" :attrs=\"attrs\" v-on:success=\"onFormSuccess\" v-on:lock-form=\"onFormLocked\" v-on:unlock-form=\"onFormUnlocked\" @auto-resent=\"$emit('auto-resent')\"></component>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-b40cc590", module.exports)
  } else {
    hotAPI.update("_v-b40cc590", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],927:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.logo[_v-17c7c6d3] {\n  max-width: 100%; }\n\n/* line 6, stdin */\n.message-content[_v-17c7c6d3] {\n  width: 90%;\n  margin: 20px auto; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vuex = require('vuex');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    mounted: function mounted() {},

    props: {
        modalId: {
            default: 'auth-interaction-modal'
        },
        attrs: {
            default: {}
        },
        successCallback: {
            type: Function,
            default: function _default() {}
        }
    },
    data: function data() {
        return {
            ticketParams: {},
            currentActiveStep: '',
            interActive: false,
            autoSubmit: false
        };
    },
    methods: {
        setRequestedPayment: function setRequestedPayment(payload) {
            this.ticketParams = payload.params;
            this.attrs = _lodash2.default.assign(this.attrs, payload.query);
            this.interActive = true;
        },
        resent: function resent() {
            this.autoSubmit = true;
            this.interActive = false;
        },
        reset: function reset() {
            this.ticketParams = {};
            this.interActive = false;
        },
        succeed: function succeed() {
            $(this.$el).modal('hide');
            this.successCallback();
            this.reset();
        }
    },
    computed: {
        title: function title() {
            return this.interActive ? '輸入驗證碼' : '傳送驗證碼';
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal :id=\"modalId\" no-footer=\"\" no-cancel=\"\" @close=\"reset()\" confirm-btn-text=\"關閉\" _v-17c7c6d3=\"\">\n    <span slot=\"title\" _v-17c7c6d3=\"\">{{ title }}</span>\n    <template slot=\"body\">\n        <web-auth-service-index v-if=\"!interActive\" dispatchers=\"member->bind.studio.member\" :attrs=\"attrs\" @changetointeraction=\"setRequestedPayment\" v-on:requested=\"setRequestedPayment\" :auto-submit=\"autoSubmit\" _v-17c7c6d3=\"\"></web-auth-service-index>\n        <web-auth-service-interaction v-if=\"interActive\" :id=\"ticketParams.id\" :interaction=\"ticketParams.interaction\" :attrs=\"attrs\" :ticket-params=\"ticketParams\" @auto-resent=\"resent\" @succeed=\"succeed\" _v-17c7c6d3=\"\"></web-auth-service-interaction>\n    </template>\n</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.logo[_v-17c7c6d3] {\n  max-width: 100%; }\n\n/* line 6, stdin */\n.message-content[_v-17c7c6d3] {\n  width: 90%;\n  margin: 20px auto; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-17c7c6d3", module.exports)
  } else {
    hotAPI.update("_v-17c7c6d3", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],928:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        dispatchers: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        attrs: {
            type: Object,
            default: function _default() {
                return {};
            }
        },
        autoSubmit: {
            default: false
        }
    },
    data: function data() {
        return {
            method: "one.time.email",
            disabledInput: 0,
            forceDisabledInput: 0,
            disabledSubmit: 1,
            params: {
                email: ''
            }
        };
    },
    mounted: function mounted() {
        if (this.attrs.verify_email) {
            this.params.email = this.attrs.verify_email;
            this.params.email_verified = this.attrs.email_verified;
            this.forceDisabledInput = this.attrs.email_verified;
        }

        if (this.autoSubmit) {
            this.getAuthentication();
        }
    },

    beforeDestroy: function beforeDestroy() {},
    computed: {
        model: function model() {}
    },
    watch: {
        params: {
            handler: function handler(values) {
                // for (let key in values) {
                //     this.model.params[key] = values[key] ? values[key] : undefined;
                // }
                if (this.params.email) {
                    this.disabledSubmit = 0;
                } else {
                    this.disabledSubmit = 1;
                }
            },

            deep: true
        },
        autoSubmit: function autoSubmit(newVal) {
            if (newVal) {
                this.getAuthentication();
            }
        },
        'attrs.verify_email': function attrsVerify_email(newVal) {
            this.params.email = newVal;
        },
        'attrs.email_verified': function attrsEmail_verified(newVal) {
            this.forceDisabledInput = newVal;
        }
    },
    methods: {
        initModel: function initModel() {
            // this.model.dispatchers = this.dispatchers;
            // this.model.method = this.method;
            // this.model.params = {};
        },
        lockForm: function lockForm() {
            this.$emit("lock-form");
            this.disabledInput = 1;
        },
        unlockForm: function unlockForm() {
            this.$emit("unlock-form");
            this.disabledInput = 0;
        },
        getAuthentication: function getAuthentication() {
            var _this = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                var id;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (_this.validateEmail(_this.params.email)) {
                                    _context.next = 3;
                                    break;
                                }

                                $17.swal({
                                    title: 'Email 驗證失敗，請輸入合法Email!',
                                    text: "",
                                    type: 'error',
                                    showCancelButton: false
                                });
                                return _context.abrupt('return');

                            case 3:
                                if (!(!_this.autoSubmit && (_this.disabledInput == 1 || _this.disabledSubmit == 1))) {
                                    _context.next = 5;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 5:
                                _context.next = 7;
                                return _this.requestAuth();

                            case 7:
                                id = _context.sent;

                                if (id) {
                                    _this.getAuth(id);
                                }

                            case 9:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        requestAuth: function requestAuth() {
            var _this2 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _this2.lockForm();
                                return _context2.abrupt('return', _this2.$http.post('/webapi/authentication/', {
                                    'dispatchers': _this2.dispatchers,
                                    'method': _this2.method,
                                    'params': _this2.params
                                }).then(function (response) {
                                    return response.data.model.id;
                                    _this2.unlockForm();
                                }, function (error) {
                                    _this2.showPopup(error);
                                    return false;
                                }));

                            case 2:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        getAuth: function getAuth(id) {
            var _this3 = this;

            this.lockForm();
            this.$http.get('/webapi/authentication/' + id, {
                'dispatchers': this.dispatchers,
                'method': this.method,
                'params': this.params
            }).then(function (response) {
                _this3.emitRequestSuccess(response.data.model);
                _this3.unlockForm();
            }, function (error) {
                _this3.showPopup(error);
                return false;
            });
        },
        showPopup: function showPopup(error) {
            $17.swal({
                title: '發起驗證失敗',
                text: error.data.message,
                type: 'error',
                showCancelButton: false
            });
            this.unlockForm();
        },
        emitRequestSuccess: function emitRequestSuccess(payload) {
            this.$emit("requested", {
                state: payload.state,
                query: {
                    verify_email: this.params.email,
                    verify_by: 'verify_email',
                    method: 'email'
                },
                params: payload
            });
        },
        validateEmail: function validateEmail(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<form>\n    <div class=\"form-group\">\n        <label for=\"email\">\n            <h5>電子郵件</h5>\n        </label></div>\n        <input name=\"email\" type=\"text\" placeholder=\"my-account@17fit.com\" required=\"\" id=\"email\" :disabled=\"disabledInput == 1 || forceDisabledInput == 1\" v-model=\"params.email\">\n    \n    <div class=\"text-right\">\n        <button class=\"btn btn-primary btn-lg\" type=\"button\" @click.prevent.stop=\"getAuthentication\" :disabled=\"disabledInput == 1||disabledSubmit == 1\">\n            發送驗證碼\n        </button>\n    </div>\n</form>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-2ac94f29", module.exports)
  } else {
    hotAPI.update("_v-2ac94f29", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785}],929:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.row[_v-6a11a316] {\n  margin-bottom: 15px; }\n\n/* line 5, stdin */\n.input-secret[_v-6a11a316] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: baseline;\n      align-items: baseline;\n  -ms-flex-pack: center;\n      justify-content: center; }\n\n/* line 11, stdin */\nlabel[_v-6a11a316] {\n  min-width: 6em; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _props$watch$data$com;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (_props$watch$data$com = {
    props: {
        ticket: {
            type: String
        },
        attrs: {
            default: function _default() {
                return {};
            }
        },
        ticketParams: {
            default: function _default() {
                return {};
            }
        }
    },
    watch: {
        'attrs.verify_by': function attrsVerify_by(newVal) {
            this.property = this.attrs[newVal] ? this.attrs[newVal] : '';
        }
    },
    data: function data() {
        return {
            indexRoute: 'AuthService',
            disabledInput: 0,
            disabledSubmit: 1,
            params: {
                secret: ''
            },
            property: ''
        };
    },

    computed: {}
}, (0, _defineProperty3.default)(_props$watch$data$com, 'watch', {
    params: {
        handler: function handler(values) {
            if (this.params.secret) {
                this.disabledSubmit = 0;
            } else {
                this.disabledSubmit = 1;
            }
        },

        deep: true
    }
}), (0, _defineProperty3.default)(_props$watch$data$com, 'methods', {
    lockForm: function lockForm() {
        this.disabledInput = 1;
        this.$emit("lock-form");
    },
    unlockForm: function unlockForm() {
        this.disabledInput = 0;
        this.$emit("unlock-form");
    },
    showPopup: function showPopup(error) {
        $17.swal({
            type: 'error',
            title: '確認驗證碼過程發生錯誤',
            text: error.data.message,
            showCancelButton: false
        });
        this.unlockForm();
        throw error;
    },
    checkTicketState: function checkTicketState(payload) {
        if (payload.state == "waiting-interaction") {
            $17.swal({
                type: 'error',
                title: '驗證失敗',
                text: '確認驗證碼失敗, 請重新輸入驗證碼',
                showCancelButton: false
            });
            return true;
        }
        if (payload.state == "accepted") {
            this.emitSuccess(payload);
            return true;
        }
    },
    emitSuccess: function emitSuccess(payload) {
        var self = this;
        this.$emit("success", payload);
    },
    resend: function resend() {
        var _this = this;

        var vm = this;
        $17.swal({
            title: '每日最高可發送3次',
            type: 'info',
            showCancelButton: true,
            confirmButtonText: '確定',
            cancelButtonText: '取消'
        }, function (isConfirm) {
            if (isConfirm) {
                _this.$emit('auto-resent');
            }
        });
    },
    validateSecret: function validateSecret() {
        var _this2 = this;

        this.lockForm();
        return this.$http.put('/webapi/authentication/interaction/' + this.ticket, {
            'id': this.ticket,
            'secret': this.params.secret
        }).then(function (response) {
            _this2.checkTicketState(response.data.model);
            _this2.unlockForm();
        }, function (error) {
            _this2.showPopup(error);
        });
    }
}), _props$watch$data$com);
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-6a11a316=\"\">\n    <div class=\"row\" _v-6a11a316=\"\">\n            <div class=\"col-xs-12\" _v-6a11a316=\"\">\n                <span _v-6a11a316=\"\">驗證碼已發送至 {{attrs.verify_email}}</span>\n            </div>\n        </div>\n    <div class=\"row\" _v-6a11a316=\"\">\n        <div class=\"col-xs-12\" _v-6a11a316=\"\">\n            <span _v-6a11a316=\"\">請檢查你的信箱</span>\n        </div>\n    </div>\n    <div class=\"input-secret\" _v-6a11a316=\"\">\n        <label for=\"secret\" _v-6a11a316=\"\">輸入驗證碼</label>\n        \n        <input name=\"secret\" type=\"text\" id=\"secret\" placeholder=\"4位數字驗證碼\" required=\"\" data-icon=\"key\" :disabled=\"disabledInput == 1\" v-model=\"params.secret\" _v-6a11a316=\"\">\n    </div>\n\n    <div class=\"row text-right\" _v-6a11a316=\"\">\n        <div class=\"col-xs-12\" _v-6a11a316=\"\">\n            <button class=\"btn btn-info\" v-on:click.prevent=\"resend()\" _v-6a11a316=\"\">\n                重新發送\n            </button>\n            <button class=\"btn btn-primary\" type=\"button\" @click.prevent.stop=\"validateSecret\" :disabled=\"disabledInput == 1||disabledSubmit == 1\" _v-6a11a316=\"\">\n                確認送出\n            </button>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.row[_v-6a11a316] {\n  margin-bottom: 15px; }\n\n/* line 5, stdin */\n.input-secret[_v-6a11a316] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: baseline;\n      align-items: baseline;\n  -ms-flex-pack: center;\n      justify-content: center; }\n\n/* line 11, stdin */\nlabel[_v-6a11a316] {\n  min-width: 6em; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-6a11a316", module.exports)
  } else {
    hotAPI.update("_v-6a11a316", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/defineProperty":65,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],930:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('./auth-service');

},{"./auth-service":924,"vue":792}],931:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.btn-default[_v-21424530] {\n  color: #5bc0de;\n  border: 1px solid #ddd;\n  text-transform: none; }\n")
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        link: {
            require: true,
            default: null
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<a :href=\"link.url\" class=\"btn btn-default\" target=\"__blank\" v-if=\"link !== null\" _v-21424530=\"\">\n    <i class=\"fa\" :class=\"link.fa_icon\" _v-21424530=\"\"></i>\n    <span _v-21424530=\"\">\n        {{ link.button_show_string }}\n    </span>\n</a>   \n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.btn-default[_v-21424530] {\n  color: #5bc0de;\n  border: 1px solid #ddd;\n  text-transform: none; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-21424530", module.exports)
  } else {
    hotAPI.update("_v-21424530", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],932:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _button = require('./button.vue');

var _button2 = _interopRequireDefault(_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('external-link-button', _button2.default);

},{"./button.vue":931,"vue":792}],933:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _comments = require('./rating/comments.vue');

var _comments2 = _interopRequireDefault(_comments);

var _commentListTemplate = require('./rating/comment-list-template.vue');

var _commentListTemplate2 = _interopRequireDefault(_commentListTemplate);

var _vCommentModal = require('./rating/v-comment-modal.vue');

var _vCommentModal2 = _interopRequireDefault(_vCommentModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('./message');
require('./invoice');
require('./qrcode');
require('./approval_term');
require('./voucher');
require('./promotion_experience');
require('./promotion_contract');
require('./comment');
require('./external_link');
require('./rating');
require('./membership');
require('./live-stream');
require('./auth');
require('./layout');
require('./branch');
require('./studio');
require('./schedule');
require('./landing-page');
require('./payment');
require('./rate_limit_exceeded');
require('./account-service');
require('./member-link');

_vue2.default.component('comment-list-template', _commentListTemplate2.default);
_vue2.default.component('rating-comments', _comments2.default);
_vue2.default.component('v-comment-modal', _vCommentModal2.default);

},{"./account-service":879,"./approval_term":894,"./auth":897,"./branch":918,"./comment":930,"./external_link":932,"./invoice":934,"./landing-page":942,"./layout":945,"./live-stream":946,"./member-link":950,"./membership":955,"./message":965,"./payment":968,"./promotion_contract":971,"./promotion_experience":979,"./qrcode":983,"./rate_limit_exceeded":986,"./rating":990,"./rating/comment-list-template.vue":987,"./rating/comments.vue":989,"./rating/v-comment-modal.vue":992,"./schedule":993,"./studio":995,"./voucher":997,"vue":792}],934:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _invoiceMethodSelect = require('./invoice-method-select.vue');

var _invoiceMethodSelect2 = _interopRequireDefault(_invoiceMethodSelect);

var _invoiceMethodPerson = require('./invoice-method-person.vue');

var _invoiceMethodPerson2 = _interopRequireDefault(_invoiceMethodPerson);

var _invoiceMethodCompany = require('./invoice-method-company.vue');

var _invoiceMethodCompany2 = _interopRequireDefault(_invoiceMethodCompany);

var _invoiceMethodDonate = require('./invoice-method-donate.vue');

var _invoiceMethodDonate2 = _interopRequireDefault(_invoiceMethodDonate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('invoice-method-select', _invoiceMethodSelect2.default);
_vue2.default.component('invoice-method-person', _invoiceMethodPerson2.default);
_vue2.default.component('invoice-method-company', _invoiceMethodCompany2.default);
_vue2.default.component('invoice-method-donate', _invoiceMethodDonate2.default);

},{"./invoice-method-company.vue":935,"./invoice-method-donate.vue":936,"./invoice-method-person.vue":937,"./invoice-method-select.vue":938,"vue":792}],935:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\ninput[type=radio][_v-49857008] {\n  -webkit-appearance: radio;\n     -moz-appearance: radio;\n          appearance: radio;\n  width: inherit;\n  margin-right: 5px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['bus', 'data', 'currentType', 'isReset'],
    data: function data() {
        return {
            selectedType: 'UBN',
            name: '',
            num: ''
        };
    },
    created: function created() {
        this.$emit('changed', this.changeData);
    },

    methods: {},
    watch: {
        'name': function name(n, o) {
            this.$emit('changed', this.changeData);
        },
        'num': function num(n, o) {
            this.$emit('changed', this.changeData);
        },
        'isReset': function isReset(n, o) {
            this.selectedType = this.currentType;
        }
    },
    computed: {
        changeData: function changeData() {
            return {
                'type': this.selectedType,
                'data': {
                    'checked': this.checked,
                    'showWord': this.showWord,
                    'name': this.name,
                    'num': this.num
                }
            };
        },
        checked: function checked() {
            return this.name.length > 1 && this.num.length == 8 ? true : false;
        },
        showWord: function showWord() {
            return i18n.t('invoice.company') + ',' + this.num;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-49857008=\"\">\n    <div class=\"row\" _v-49857008=\"\">\n        <div class=\"col-sm-3 col-xs-4 text-right\" _v-49857008=\"\">\n            <label for=\"write_ubn_num\" _v-49857008=\"\">\n                {{ i18n.t('invoice.person_data.ubn_num') }}\n            </label>\n        </div>\n        <div class=\"col-sm-9 col-xs-8\" _v-49857008=\"\">\n            <input type=\"text\" v-model=\"num\" value=\"\" minlength=\"8\" maxlength=\"8\" id=\"write_ubn_num\" min-=\"\" :placeholder=\"i18n.t('invoice.person_data.write_ubn_num')\" _v-49857008=\"\">\n        </div>\n    </div>\n    <div class=\"row\" _v-49857008=\"\">\n        <div class=\"col-sm-3 col-xs-4 text-right\" _v-49857008=\"\">\n            <label for=\"write_ubn_title\" _v-49857008=\"\">\n                {{ i18n.t('invoice.person_data.ubn_title') }}\n            </label>\n        </div>\n        <div class=\"col-sm-9 col-xs-8\" _v-49857008=\"\">\n            <input type=\"text\" v-model=\"name\" value=\"\" id=\"write_ubn_title\" :placeholder=\"i18n.t('invoice.person_data.write_ubn_title')\" _v-49857008=\"\">\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\ninput[type=radio][_v-49857008] {\n  -webkit-appearance: radio;\n     -moz-appearance: radio;\n          appearance: radio;\n  width: inherit;\n  margin-right: 5px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-49857008", module.exports)
  } else {
    hotAPI.update("_v-49857008", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],936:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\ninput[type=radio][_v-1a85ebb4] {\n  -webkit-appearance: radio;\n     -moz-appearance: radio;\n          appearance: radio;\n  width: inherit;\n  margin-right: 5px; }\n\n/* line 7, stdin */\n.method[_v-1a85ebb4] {\n  max-height: 30vh;\n  padding-left: 30px;\n  overflow-y: scroll;\n  overflow-x: hidden; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['bus', 'data', 'currentType', 'isReset'],
    data: function data() {
        return {
            selectedType: 'LoveCode',
            selected: null
        };
    },
    created: function created() {
        this.$emit('changed', this.changeData);
    },

    methods: {},
    watch: {
        'selected': function selected(n, o) {
            this.$emit('changed', this.changeData);
        },
        'isReset': function isReset(n, o) {
            this.selectedType = this.currentType;
        }
    },
    computed: {
        changeData: function changeData() {
            return {
                'type': this.selectedType,
                'data': {
                    'checked': this.checked,
                    'showWord': this.showWord,
                    'num': this.selected,
                    'name': ''
                }
            };
        },
        showWord: function showWord() {
            return i18n.t('invoice.donate');
        },
        checked: function checked() {
            return this.selected ? true : false;
        },
        options: function options() {
            if (this.data.donate.LoveCode.default_input.option_list && this.data.donate.LoveCode.default_input.option_list[0]) {
                return this.data.donate.LoveCode.default_input.option_list;
            }
            return [];
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"method\" _v-1a85ebb4=\"\">\n    <div class=\"row\" v-for=\" option in options \" _v-1a85ebb4=\"\">\n        <div class=\"col-xs-12\" _v-1a85ebb4=\"\">\n            <div _v-1a85ebb4=\"\">\n                <label _v-1a85ebb4=\"\">\n                    <input type=\"radio\" v-model=\"selected\" :value=\"option.love_code\" _v-1a85ebb4=\"\">\n                    {{ option.name }}\n                </label>\n            </div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\ninput[type=radio][_v-1a85ebb4] {\n  -webkit-appearance: radio;\n     -moz-appearance: radio;\n          appearance: radio;\n  width: inherit;\n  margin-right: 5px; }\n\n/* line 7, stdin */\n.method[_v-1a85ebb4] {\n  max-height: 30vh;\n  padding-left: 30px;\n  overflow-y: scroll;\n  overflow-x: hidden; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-1a85ebb4", module.exports)
  } else {
    hotAPI.update("_v-1a85ebb4", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],937:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\ninput[type=radio][_v-12f6599a] {\n  -webkit-appearance: radio;\n     -moz-appearance: radio;\n          appearance: radio;\n  width: inherit;\n  margin-right: 5px; }\n\n/* line 7, stdin */\n.invoice-person[_v-12f6599a] {\n  padding-left: 30px; }\n\n/* line 10, stdin */\n.row[_v-12f6599a] {\n  margin-bottom: 15px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['bus', 'data', 'currentType', 'isReset'],
    data: function data() {
        return {
            selectedType: 'CarrierPay2Go'
        };
    },
    created: function created() {
        this.$emit('changed', this.changeData);
    },

    methods: {},
    watch: {
        'selectedType': function selectedType(n, o) {
            this.$emit('changed', this.changeData);
        },
        'isReset': function isReset(n, o) {
            this.selectedType = this.currentType;
        }
    },
    computed: {
        changeData: function changeData() {
            return {
                'type': this.selectedType,
                'data': {
                    'checked': this.checked,
                    'showWord': this.showWord,
                    'name': '',
                    'num': ''
                }
            };
        },
        checked: function checked() {
            return true;
        },
        showWord: function showWord() {
            if (this.selectedType === 'CarrierPay2Go') {
                return i18n.t('invoice.person') + ',' + i18n.t('invoice.winning_alert');
            }
            if (this.selectedType === 'PrintCode') {
                return i18n.t('invoice.person') + ',' + i18n.t('invoice.get_print_code');
            }

            return '';
        },
        printerCodeRemark: function printerCodeRemark() {
            if (typeof this.data.person.PrintCode !== 'undefined' && typeof this.data.person.PrintCode.addition !== 'undefined') {
                return this.data.person.PrintCode.addition.remark;
            }

            return '';
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"invoice-person\" _v-12f6599a=\"\">\n    <div class=\"row\" _v-12f6599a=\"\">\n        <div class=\"col-sm-3 col-xs-4\" _v-12f6599a=\"\">\n            \n                <label _v-12f6599a=\"\">\n                    <input type=\"radio\" v-model=\"selectedType\" value=\"CarrierPay2Go\" _v-12f6599a=\"\">\n                    {{ i18n.t('invoice.person_data.carry_pay2_go') }}\n                </label>\n            \n        </div>\n        <div class=\"col-sm-9 col-xs-8\" _v-12f6599a=\"\">\n              {{ i18n.t('invoice.person_data.info') }}\n        </div>\n    </div>\n    <div class=\"row\" v-if=\"data.person.hasOwnProperty('PrintCode')\" _v-12f6599a=\"\">\n        <div class=\"col-sm-3 col-xs-4\" _v-12f6599a=\"\">\n                <label _v-12f6599a=\"\">\n                    <input type=\"radio\" v-model=\"selectedType\" value=\"PrintCode\" _v-12f6599a=\"\">\n                    {{ i18n.t('invoice.person_data.print_code') }}\n                </label>\n        </div>\n        <div class=\"col-sm-9 col-xs-8\" _v-12f6599a=\"\">\n            {{ printerCodeRemark }}\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\ninput[type=radio][_v-12f6599a] {\n  -webkit-appearance: radio;\n     -moz-appearance: radio;\n          appearance: radio;\n  width: inherit;\n  margin-right: 5px; }\n\n/* line 7, stdin */\n.invoice-person[_v-12f6599a] {\n  padding-left: 30px; }\n\n/* line 10, stdin */\n.row[_v-12f6599a] {\n  margin-bottom: 15px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-12f6599a", module.exports)
  } else {
    hotAPI.update("_v-12f6599a", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],938:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\ninput[type=radio][_v-f062707e] {\n  -webkit-appearance: radio;\n     -moz-appearance: radio;\n          appearance: radio;\n  width: inherit;\n  margin-right: 5px; }\n\n/* line 7, stdin */\n.inovice-type[_v-f062707e] {\n  margin-bottom: 5px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['bus', 'branch_id', 'currentCategeory', 'currentType', 'isReset'],
    data: function data() {
        return {
            setting: {
                person: {},
                company: {},
                donate: {}
            },
            selectedType: 'person',
            invoiceType: '',
            invoiceData: {},
            showWord: ''
        };
    },
    created: function created() {
        this.getInvoice();
    },

    methods: {
        getInvoice: function getInvoice() {
            var _this = this;

            this.$http.get('/webapi/invoice/settings/' + this.branch_id).then(function (response) {
                _this.setting = response.data;
            });
        },
        changed: function changed(data) {
            this.invoiceType = data.type;
            this.invoiceData = data.data;
        }
    },
    watch: {
        'branch_id': function branch_id(n, o) {
            undefined.getInvoice();
        },
        'invoiceType': function invoiceType(n, o) {
            this.$emit('change-invoice', {
                'invoiceType': this.invoiceType,
                'invoiceData': this.invoiceData,
                'invoiceCategory': this.selectedType
            });
        },
        'invoiceData': function invoiceData(n, o) {
            this.$emit('change-invoice', {
                'invoiceType': this.invoiceType,
                'invoiceData': this.invoiceData,
                'invoiceCategory': this.selectedType
            });
        },
        'isReset': function isReset(n, o) {
            this.selectedType = this.currentCategeory;
        }
    },
    computed: {
        componentType: function componentType() {
            switch (this.selectedType) {
                case 'person':
                    return 'invoice-method-person';
                    break;

                case 'company':
                    return 'invoice-method-company';
                    break;

                case 'donate':
                    return 'invoice-method-donate';
                    break;

                default:
                    break;
            }
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-f062707e=\"\">\n    <div class=\"row\" _v-f062707e=\"\">\n        <div class=\"col-xs-12\" _v-f062707e=\"\">\n            <div class=\"inovice-type\" _v-f062707e=\"\">{{ i18n.t('invoice.select_invoice_type') }}</div>\n        </div>\n    </div>\n    <div class=\"row\" _v-f062707e=\"\">\n        <div class=\"col-sm-4 col-xs-4\" _v-f062707e=\"\">\n                <label _v-f062707e=\"\">\n                    <input type=\"radio\" v-model=\"selectedType\" value=\"person\" _v-f062707e=\"\">{{ i18n.t('invoice.person') }}\n                </label>\n        </div>\n        <div class=\"col-sm-4 col-xs-4\" _v-f062707e=\"\">\n                <label _v-f062707e=\"\">\n                    <input type=\"radio\" v-model=\"selectedType\" value=\"company\" _v-f062707e=\"\">{{ i18n.t('invoice.company') }}\n                </label>\n        </div>\n        <div class=\"col-sm-4 col-xs-4\" _v-f062707e=\"\">\n                <label _v-f062707e=\"\">\n                    <input type=\"radio\" v-model=\"selectedType\" value=\"donate\" _v-f062707e=\"\">{{ i18n.t('invoice.donate') }}\n                </label>\n        </div>\n    </div>\n    <hr _v-f062707e=\"\">\n    <component :is=\"componentType\" :data=\"setting\" :bus=\"bus\" :current-type=\"currentType\" :is-reset=\"isReset\" @changed=\"changed\" _v-f062707e=\"\"></component>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\ninput[type=radio][_v-f062707e] {\n  -webkit-appearance: radio;\n     -moz-appearance: radio;\n          appearance: radio;\n  width: inherit;\n  margin-right: 5px; }\n\n/* line 7, stdin */\n.inovice-type[_v-f062707e] {\n  margin-bottom: 5px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-f062707e", module.exports)
  } else {
    hotAPI.update("_v-f062707e", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],939:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 3, stdin */\n.article-report-section .swiper-button-prev, .article-report-section .swiper-button-next {\n  background-image: none;\n  top: 50%; }\n  /* line 6, stdin */\n  .article-report-section .swiper-button-prev:after, .article-report-section .swiper-button-next:after {\n    font-family: \"Material Icons\";\n    font-size: 35px;\n    color: #68A1DD; }\n\n/* line 12, stdin */\n.article-report-section .swiper-button-prev {\n  left: 0; }\n  /* line 14, stdin */\n  .article-report-section .swiper-button-prev:after {\n    content: \"\\e5e0\"; }\n\n/* line 18, stdin */\n.article-report-section .swiper-button-next {\n  right: 0; }\n  /* line 20, stdin */\n  .article-report-section .swiper-button-next:after {\n    content: \"\\e5e1\"; }\n\n/* line 2, stdin */\n.show-on-mobile[_v-1f18fc68] {\n  display: none; }\n\n/* line 5, stdin */\n.article-report-section[_v-1f18fc68] {\n  padding-top: 200px;\n  max-width: 1140px;\n  margin: 0 auto;\n  position: relative; }\n\n/* line 11, stdin */\n.blue-bold[_v-1f18fc68] {\n  font-size: 46px;\n  font-weight: 700;\n  color: #38B0E3;\n  text-align: center; }\n\n/* line 17, stdin */\n.article[_v-1f18fc68] {\n  margin: 60px auto 100px auto; }\n  /* line 19, stdin */\n  .article .content[_v-1f18fc68] {\n    color: #4A4A4A;\n    padding: 0 25px;\n    margin-bottom: 60px;\n    height: var(--post-view-height); }\n    /* line 24, stdin */\n    .article .content img[_v-1f18fc68] {\n      width: 100%;\n      border-radius: 10px; }\n    /* line 28, stdin */\n    .article .content .title[_v-1f18fc68] {\n      font-size: 24px;\n      font-weight: bold;\n      margin: 20px auto;\n      -webkit-line-clamp: 3;\n      overflow: hidden;\n      display: -webkit-box;\n      -webkit-box-orient: vertical;\n      min-height: 63px; }\n      /* line 37, stdin */\n      .article .content .title a[_v-1f18fc68] {\n        color: #4A4A4A;\n        text-decoration: underline; }\n    /* line 42, stdin */\n    .article .content .source[_v-1f18fc68] {\n      font-size: 16px; }\n    /* line 45, stdin */\n    .article .content .more[_v-1f18fc68] {\n      color: #38B0E3;\n      font-size: 16px; }\n    /* line 49, stdin */\n    .article .content.to-blog[_v-1f18fc68] {\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-direction: column;\n          flex-direction: column;\n      -ms-flex-align: center;\n          align-items: center;\n      -ms-flex-pack: center;\n          justify-content: center; }\n      /* line 54, stdin */\n      .article .content.to-blog .tx[_v-1f18fc68] {\n        text-align: center;\n        margin-bottom: 30px;\n        font-size: 26px; }\n\n/* line 62, stdin */\n.business-promote[_v-1f18fc68] {\n  margin: 40px auto 100px auto; }\n\n/* line 65, stdin */\n.carousel-card[_v-1f18fc68] {\n  padding: 40px 0; }\n  /* line 67, stdin */\n  .carousel-card .card-content[_v-1f18fc68] {\n    background: linear-gradient(180deg, #286FB8 0%, #1B479F 100%);\n    box-shadow: 5px 10px 20px rgba(0, 0, 0, 0.12);\n    border-radius: 10px;\n    min-height: 430px;\n    max-width: 320px;\n    width: 100%;\n    margin: 0 auto;\n    height: 100%;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n        flex-direction: column;\n    -ms-flex-pack: justify;\n        justify-content: space-between; }\n    /* line 79, stdin */\n    .carousel-card .card-content .type-icon[_v-1f18fc68] {\n      -ms-flex-item-align: end;\n          -ms-grid-row-align: end;\n          align-self: end;\n      margin-top: -10px; }\n    /* line 83, stdin */\n    .carousel-card .card-content .top[_v-1f18fc68] {\n      color: #fff;\n      font-size: 22px;\n      margin: 0 35px 0 35px; }\n    /* line 88, stdin */\n    .carousel-card .card-content .bottom[_v-1f18fc68] {\n      background: url(https://blog.17fit.com/wp-content/uploads/2021/10/witness-white-background.png) no-repeat;\n      background-size: cover;\n      border-radius: 0 0 7px 7px;\n      padding: 20px;\n      font-size: 16px;\n      color: #4A4A4A;\n      text-align: center; }\n      /* line 96, stdin */\n      .carousel-card .card-content .bottom img[_v-1f18fc68] {\n        height: 50px;\n        width: auto;\n        margin-bottom: 5px; }\n\n/* line 105, stdin */\n.blue-pl[_v-1f18fc68] {\n  position: absolute;\n  left: -200px;\n  top: 0; }\n  /* line 109, stdin */\n  .blue-pl img[_v-1f18fc68] {\n    width: 240px; }\n\n/* line 113, stdin */\n.red-pl[_v-1f18fc68] {\n  position: absolute;\n  right: -220px;\n  margin-top: -200px; }\n  /* line 117, stdin */\n  .red-pl img[_v-1f18fc68] {\n    width: 265px; }\n\n/* line 121, stdin */\n.green-pl[_v-1f18fc68] {\n  position: absolute;\n  right: -200px;\n  margin-top: -400px; }\n  /* line 125, stdin */\n  .green-pl img[_v-1f18fc68] {\n    width: 345px; }\n\n@media (max-width: 992px) {\n  /* line 130, stdin */\n  .article-report-section[_v-1f18fc68] {\n    padding-top: 100px; }\n  /* line 133, stdin */\n  .blue-bold[_v-1f18fc68] {\n    font-size: 36px; }\n  /* line 138, stdin */\n  .article .content .title[_v-1f18fc68] {\n    font-size: 18px; }\n  /* line 141, stdin */\n  .article .content.to-blog[_v-1f18fc68] {\n    min-height: 250px; }\n    /* line 143, stdin */\n    .article .content.to-blog .tx[_v-1f18fc68] {\n      font-size: 20px; }\n  /* line 150, stdin */\n  .carousel-card .card-content[_v-1f18fc68] {\n    min-height: 369px;\n    max-width: 293px;\n    margin: 0 auto; }\n    /* line 154, stdin */\n    .carousel-card .card-content .top[_v-1f18fc68] {\n      font-size: 18px; }\n    /* line 157, stdin */\n    .carousel-card .card-content .bottom[_v-1f18fc68] {\n      margin-bottom: -1px; }\n  /* line 162, stdin */\n  .blue-pl[_v-1f18fc68] {\n    left: -50px; }\n    /* line 164, stdin */\n    .blue-pl img[_v-1f18fc68] {\n      width: 135px; }\n  /* line 168, stdin */\n  .red-pl[_v-1f18fc68] {\n    right: -80px; }\n    /* line 170, stdin */\n    .red-pl img[_v-1f18fc68] {\n      width: 192px; }\n  /* line 174, stdin */\n  .green-pl[_v-1f18fc68] {\n    right: -20px;\n    margin-top: -250px; }\n    /* line 177, stdin */\n    .green-pl img[_v-1f18fc68] {\n      width: 170px; } }\n\n@media (max-width: 576px) {\n  /* line 183, stdin */\n  .show-on-mobile[_v-1f18fc68] {\n    display: block; }\n  /* line 186, stdin */\n  .blue-bold[_v-1f18fc68] {\n    font-size: 33px; }\n  /* line 190, stdin */\n  .carousel-card .card-content[_v-1f18fc68] {\n    min-height: 330px;\n    max-width: 270px;\n    margin: 0 auto; }\n    /* line 194, stdin */\n    .carousel-card .card-content .top[_v-1f18fc68] {\n      font-size: 16px; }\n  /* line 199, stdin */\n  .blue-pl[_v-1f18fc68] {\n    left: -40px;\n    top: 625px; }\n    /* line 202, stdin */\n    .blue-pl img[_v-1f18fc68] {\n      width: 95px; } }\n")
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        blogPost: {
            type: [Array, Object]
        }
    },
    data: function data() {
        return {
            articleViewHeight: 200,
            knowledge: [{
                "id": 1,
                "type": "fitness",
                "logo": "https://blog.17fit.com/wp-content/uploads/2021/10/logo_TMMA.png",
                "branch_name": "TMMA 台北格鬥運動館",
                "key_member": "執行長 邱郁智",
                "comment": " 17FIT 團隊常會站在客戶的立場看待事情、即時性的回應，同時也帶動品牌每年營收穩定成長 25%！"
            }, {
                "id": 2,
                "type": "beauty",
                "logo": "https://blog.17fit.com/wp-content/uploads/2021/10/logo_Hygeia.png",
                "branch_name": "海吉兒健康美甲概念館",
                "key_member": "執行總監 簡少騏",
                "comment": "「簡單方便」和「團隊專業度」是選擇 17FIT 的兩大關鍵。它是美容業者經營管理的「大幫手」而非「小幫手」而已。"
            }, {
                "id": 3,
                "type": "fitness",
                "logo": "https://blog.17fit.com/wp-content/uploads/2021/10/logo_good-time.png",
                "branch_name": "好時光女生運動樂園",
                "key_member": "創辦人 Steffi",
                "comment": "大家都應該知道，免費工具功能有限且耗時。為了讓工作更有效率，我們選擇 17FIT ，因為它有最完整的功能。"
            }, {
                "id": 4,
                "type": "fitness",
                "logo": "https://blog.17fit.com/wp-content/uploads/2021/10/S3-logo_HRC.png",
                "branch_name": "HRC 舞蹈工作室",
                "key_member": "創辦人 Bboy Bojin 陳柏均",
                "comment": "我很訝異在 17FIT 上的經營成效這麼好。在「預約課程」或是「線上服務」，都使我在經營管理上更加有效率。"
            }, {
                "id": 5,
                "type": "beauty",
                "logo": "https://blog.17fit.com/wp-content/uploads/2021/10/S3-logo_Hitomi.png",
                "branch_name": "心傳美學",
                "key_member": "美容師 Hitomi",
                "comment": "如果要給 17FIT 打分數，滿分五顆星，那我會給五顆星星。"
            }, {
                "id": 6,
                "type": "fitness",
                "logo": "https://blog.17fit.com/wp-content/uploads/2021/10/S3-logo_forest.png",
                "branch_name": "森林跑站 RunBase",
                "key_member": "板橋店店長 Paige",
                "comment": "給 17FIT 八個字：專業、熱情、積極、服務。透過系統，可以直接線上買課程，不用再透過人力或紙本。"
            }, {
                "id": 7,
                "type": "beauty",
                "logo": "https://blog.17fit.com/wp-content/uploads/2021/10/S3-logo_water.png",
                "branch_name": "水芙蓉堂平衡美學",
                "key_member": "堂主 巧薇",
                "comment": "因為嘗試過很多不同的系統，才越來越來清楚自己想要的是什麼，這也是我最終選擇 17FIT 的原因。"
            }, {
                "id": 8,
                "type": "fitness",
                "logo": "https://blog.17fit.com/wp-content/uploads/2021/10/S3-logo_WAO.png",
                "branch_name": "WAO TAIWAN",
                "key_member": "創辦人 Rocky",
                "comment": "使用 17FIT 之後，不僅讓櫃檯人員減少工作量，學生也對 APP 中顯示的課程紀錄產生信賴感。"
            }, {
                "id": 9,
                "type": "beauty",
                "logo": "https://blog.17fit.com/wp-content/uploads/2021/10/S3-logo_whisper.png",
                "branch_name": "花敘 Whisper 基隆美甲工作室",
                "key_member": "陳亭安",
                "comment": "使用 17FIT 後，客人可以自己選他需要的時段，非常方便。且有線上刷卡系統，不用擔心無故取消被浪費時間。"
            }, {
                "id": 10,
                "type": "fitness",
                "logo": "https://blog.17fit.com/wp-content/uploads/2021/10/S3-logo_yoga.png",
                "branch_name": "拙真瑜伽",
                "key_member": "創辦人 Vincent",
                "comment": "透過 17FIT ，更了解品牌該如何經營。我也很慶幸使用了這套系統，它協助我們系統化的思考如何經營自己的教室。"
            }],
            articles: [{
                img: 'https://blog.17fit.com/wp-content/uploads/2021/10/S4-photo_marketing.png',
                title: '行銷轉型前要先營運轉型！ 17FIT 推健身美業一站式解決方案',
                link: 'https://meet.bnext.com.tw/articles/view/47648',
                source: 'Meet 創業小聚'
            }, {
                img: 'https://blog.17fit.com/wp-content/uploads/2021/10/S4-photo_law.png',
                title: '打造法律防護力！ 17FIT 攜事務所提供法規諮詢',
                link: 'https://meet.bnext.com.tw/blog/view/27837',
                source: 'Meet 創業小聚'
            }]

        };
    },

    computed: {
        swiperOption: function swiperOption() {
            return {
                slidesPerView: 3,
                spaceBetween: 30,
                slidesPerGroup: 3,
                loop: true,
                init: true,
                breakpoints: {
                    992: {
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                        spaceBetween: 30
                    },
                    576: {
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                        spaceBetween: 10
                    }
                },
                speed: 300,
                autoplay: {
                    delay: 6000
                }
            };
        },
        hasBlogPost: function hasBlogPost() {
            return !_lodash2.default.isEmpty(this.blogPost);
        }
    },
    mounted: function mounted() {
        this.$refs.landing_carousel.manualUpdate();
    },

    methods: {
        handleResize: function handleResize() {
            var wordpressImg = document.querySelector('.article img');
            var imgHeight = wordpressImg.width / 1.94;
            this.articleViewHeight = imgHeight + 130;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"article-report-section\" _v-1f18fc68=\"\">\n    <div _v-1f18fc68=\"\">\n        <div class=\"blue-pl\" _v-1f18fc68=\"\">\n            <img class=\"lax lax_preset_spin:946:360\" src=\"https://blog.17fit.com/wp-content/uploads/2021/10/S3-blue-planet.png\" alt=\"\" _v-1f18fc68=\"\">\n        </div>\n        <div class=\"blue-bold\" _v-1f18fc68=\"\">聽聽更多同業<br class=\"show-on-mobile\" _v-1f18fc68=\"\">使用 17FIT 的心得</div>\n        <div class=\"business-promote\" _v-1f18fc68=\"\">\n            <v-carousel ref=\"landing_carousel\" :slid-slots=\"knowledge\" :custom-swiper-option=\"swiperOption\" :pagination-show=\"true\" :navigation-show=\"true\" :pagination-dynamic-bullets=\"true\" swiper-slide-style=\"width: auto; height: auto;\" _v-1f18fc68=\"\">\n                <template slot=\"swiper-card\" slot-scope=\"{item}\">\n                    <div class=\"carousel-card\" _v-1f18fc68=\"\">\n                        <div class=\"card-content\" _v-1f18fc68=\"\">\n                            <img class=\"type-icon\" v-if=\"item['type'] == 'fitness'\" src=\"https://blog.17fit.com/wp-content/uploads/2021/10/witness-tag_fitness.png\" width=\"85px\" alt=\"fitness\" _v-1f18fc68=\"\">\n                            <img class=\"type-icon\" v-else=\"\" src=\"https://blog.17fit.com/wp-content/uploads/2021/10/witness-tag_salon.png\" width=\"85px\" alt=\"beauty\" _v-1f18fc68=\"\">\n                            <div class=\"top\" _v-1f18fc68=\"\">\n                                {{ item.comment }}\n                            </div>\n                            <div class=\"bottom\" _v-1f18fc68=\"\">\n                                <img :src=\"item.logo\" :alt=\"item.branch_name\" _v-1f18fc68=\"\">\n                                <div _v-1f18fc68=\"\">{{ item.branch_name }}</div>\n                                <div _v-1f18fc68=\"\">{{ item.key_member }}</div>\n                            </div>\n                        </div>\n                    </div>\n                </template>\n            </v-carousel>                \n        </div>\n    </div>\n    <div _v-1f18fc68=\"\">\n        <div class=\"blue-bold\" _v-1f18fc68=\"\">媒體採訪報導</div>\n        <div class=\"article row\" _v-1f18fc68=\"\">\n            <div v-for=\"article in articles\" class=\"content col-md-6 col-sm-6 col-xs-12\" _v-1f18fc68=\"\">\n                <img :src=\"article.img\" :alt=\"article.title\" _v-1f18fc68=\"\">\n                <div class=\"title\" _v-1f18fc68=\"\"><a :href=\"article.link\" target=\"_blank\" _v-1f18fc68=\"\">{{ article.title }}</a></div>\n                <div class=\"source\" _v-1f18fc68=\"\">{{ article.source }}</div>\n            </div>\n        </div>\n    </div>\n    <div v-show=\"hasBlogPost\" _v-1f18fc68=\"\">\n        <div class=\"blue-bold\" _v-1f18fc68=\"\">推薦閱讀文章</div>\n        <div class=\"red-pl\" _v-1f18fc68=\"\">\n            <img class=\"lax lax_preset_spin:946:360\" src=\"https://blog.17fit.com/wp-content/uploads/2021/10/S4-red-planet.png\" alt=\"\" _v-1f18fc68=\"\">\n        </div>\n        <div class=\"article row\" :style=\"{'--post-view-height': articleViewHeight+'px'}\" _v-1f18fc68=\"\">\n            <div v-for=\"post in blogPost\" class=\"content col-md-6 col-sm-6 col-xs-12\" _v-1f18fc68=\"\">\n                <img class=\"post-img\" :src=\"post.img\" :alt=\"post.title\" _v-1f18fc68=\"\">\n                <div class=\"title\" _v-1f18fc68=\"\">{{ post.title }}</div>\n                <a class=\"more\" :href=\"post.link\" target=\"_blank\" _v-1f18fc68=\"\">閱讀更多 &gt;</a>\n            </div>\n            <div class=\"content to-blog col-md-6 col-sm-6 col-xs-12\" _v-1f18fc68=\"\">\n                <div class=\"tx\" _v-1f18fc68=\"\">更多產業知識，都在<br class=\"show-on-mobile\" _v-1f18fc68=\"\"> 17FIT 商學院</div>\n                <landing-golden-btn text=\"前往部落格\" href=\"https://blog.17fit.com/\" _v-1f18fc68=\"\"></landing-golden-btn>\n            </div>\n        </div>\n        <div class=\"green-pl\" _v-1f18fc68=\"\">\n            <img src=\"https://blog.17fit.com/wp-content/uploads/2021/10/S5-green-planet.png\" alt=\"\" _v-1f18fc68=\"\">\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 3, stdin */\n.article-report-section .swiper-button-prev, .article-report-section .swiper-button-next {\n  background-image: none;\n  top: 50%; }\n  /* line 6, stdin */\n  .article-report-section .swiper-button-prev:after, .article-report-section .swiper-button-next:after {\n    font-family: \"Material Icons\";\n    font-size: 35px;\n    color: #68A1DD; }\n\n/* line 12, stdin */\n.article-report-section .swiper-button-prev {\n  left: 0; }\n  /* line 14, stdin */\n  .article-report-section .swiper-button-prev:after {\n    content: \"\\e5e0\"; }\n\n/* line 18, stdin */\n.article-report-section .swiper-button-next {\n  right: 0; }\n  /* line 20, stdin */\n  .article-report-section .swiper-button-next:after {\n    content: \"\\e5e1\"; }\n\n/* line 2, stdin */\n.show-on-mobile[_v-1f18fc68] {\n  display: none; }\n\n/* line 5, stdin */\n.article-report-section[_v-1f18fc68] {\n  padding-top: 200px;\n  max-width: 1140px;\n  margin: 0 auto;\n  position: relative; }\n\n/* line 11, stdin */\n.blue-bold[_v-1f18fc68] {\n  font-size: 46px;\n  font-weight: 700;\n  color: #38B0E3;\n  text-align: center; }\n\n/* line 17, stdin */\n.article[_v-1f18fc68] {\n  margin: 60px auto 100px auto; }\n  /* line 19, stdin */\n  .article .content[_v-1f18fc68] {\n    color: #4A4A4A;\n    padding: 0 25px;\n    margin-bottom: 60px;\n    height: var(--post-view-height); }\n    /* line 24, stdin */\n    .article .content img[_v-1f18fc68] {\n      width: 100%;\n      border-radius: 10px; }\n    /* line 28, stdin */\n    .article .content .title[_v-1f18fc68] {\n      font-size: 24px;\n      font-weight: bold;\n      margin: 20px auto;\n      -webkit-line-clamp: 3;\n      overflow: hidden;\n      display: -webkit-box;\n      -webkit-box-orient: vertical;\n      min-height: 63px; }\n      /* line 37, stdin */\n      .article .content .title a[_v-1f18fc68] {\n        color: #4A4A4A;\n        text-decoration: underline; }\n    /* line 42, stdin */\n    .article .content .source[_v-1f18fc68] {\n      font-size: 16px; }\n    /* line 45, stdin */\n    .article .content .more[_v-1f18fc68] {\n      color: #38B0E3;\n      font-size: 16px; }\n    /* line 49, stdin */\n    .article .content.to-blog[_v-1f18fc68] {\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-direction: column;\n          flex-direction: column;\n      -ms-flex-align: center;\n          align-items: center;\n      -ms-flex-pack: center;\n          justify-content: center; }\n      /* line 54, stdin */\n      .article .content.to-blog .tx[_v-1f18fc68] {\n        text-align: center;\n        margin-bottom: 30px;\n        font-size: 26px; }\n\n/* line 62, stdin */\n.business-promote[_v-1f18fc68] {\n  margin: 40px auto 100px auto; }\n\n/* line 65, stdin */\n.carousel-card[_v-1f18fc68] {\n  padding: 40px 0; }\n  /* line 67, stdin */\n  .carousel-card .card-content[_v-1f18fc68] {\n    background: linear-gradient(180deg, #286FB8 0%, #1B479F 100%);\n    box-shadow: 5px 10px 20px rgba(0, 0, 0, 0.12);\n    border-radius: 10px;\n    min-height: 430px;\n    max-width: 320px;\n    width: 100%;\n    margin: 0 auto;\n    height: 100%;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n        flex-direction: column;\n    -ms-flex-pack: justify;\n        justify-content: space-between; }\n    /* line 79, stdin */\n    .carousel-card .card-content .type-icon[_v-1f18fc68] {\n      -ms-flex-item-align: end;\n          -ms-grid-row-align: end;\n          align-self: end;\n      margin-top: -10px; }\n    /* line 83, stdin */\n    .carousel-card .card-content .top[_v-1f18fc68] {\n      color: #fff;\n      font-size: 22px;\n      margin: 0 35px 0 35px; }\n    /* line 88, stdin */\n    .carousel-card .card-content .bottom[_v-1f18fc68] {\n      background: url(https://blog.17fit.com/wp-content/uploads/2021/10/witness-white-background.png) no-repeat;\n      background-size: cover;\n      border-radius: 0 0 7px 7px;\n      padding: 20px;\n      font-size: 16px;\n      color: #4A4A4A;\n      text-align: center; }\n      /* line 96, stdin */\n      .carousel-card .card-content .bottom img[_v-1f18fc68] {\n        height: 50px;\n        width: auto;\n        margin-bottom: 5px; }\n\n/* line 105, stdin */\n.blue-pl[_v-1f18fc68] {\n  position: absolute;\n  left: -200px;\n  top: 0; }\n  /* line 109, stdin */\n  .blue-pl img[_v-1f18fc68] {\n    width: 240px; }\n\n/* line 113, stdin */\n.red-pl[_v-1f18fc68] {\n  position: absolute;\n  right: -220px;\n  margin-top: -200px; }\n  /* line 117, stdin */\n  .red-pl img[_v-1f18fc68] {\n    width: 265px; }\n\n/* line 121, stdin */\n.green-pl[_v-1f18fc68] {\n  position: absolute;\n  right: -200px;\n  margin-top: -400px; }\n  /* line 125, stdin */\n  .green-pl img[_v-1f18fc68] {\n    width: 345px; }\n\n@media (max-width: 992px) {\n  /* line 130, stdin */\n  .article-report-section[_v-1f18fc68] {\n    padding-top: 100px; }\n  /* line 133, stdin */\n  .blue-bold[_v-1f18fc68] {\n    font-size: 36px; }\n  /* line 138, stdin */\n  .article .content .title[_v-1f18fc68] {\n    font-size: 18px; }\n  /* line 141, stdin */\n  .article .content.to-blog[_v-1f18fc68] {\n    min-height: 250px; }\n    /* line 143, stdin */\n    .article .content.to-blog .tx[_v-1f18fc68] {\n      font-size: 20px; }\n  /* line 150, stdin */\n  .carousel-card .card-content[_v-1f18fc68] {\n    min-height: 369px;\n    max-width: 293px;\n    margin: 0 auto; }\n    /* line 154, stdin */\n    .carousel-card .card-content .top[_v-1f18fc68] {\n      font-size: 18px; }\n    /* line 157, stdin */\n    .carousel-card .card-content .bottom[_v-1f18fc68] {\n      margin-bottom: -1px; }\n  /* line 162, stdin */\n  .blue-pl[_v-1f18fc68] {\n    left: -50px; }\n    /* line 164, stdin */\n    .blue-pl img[_v-1f18fc68] {\n      width: 135px; }\n  /* line 168, stdin */\n  .red-pl[_v-1f18fc68] {\n    right: -80px; }\n    /* line 170, stdin */\n    .red-pl img[_v-1f18fc68] {\n      width: 192px; }\n  /* line 174, stdin */\n  .green-pl[_v-1f18fc68] {\n    right: -20px;\n    margin-top: -250px; }\n    /* line 177, stdin */\n    .green-pl img[_v-1f18fc68] {\n      width: 170px; } }\n\n@media (max-width: 576px) {\n  /* line 183, stdin */\n  .show-on-mobile[_v-1f18fc68] {\n    display: block; }\n  /* line 186, stdin */\n  .blue-bold[_v-1f18fc68] {\n    font-size: 33px; }\n  /* line 190, stdin */\n  .carousel-card .card-content[_v-1f18fc68] {\n    min-height: 330px;\n    max-width: 270px;\n    margin: 0 auto; }\n    /* line 194, stdin */\n    .carousel-card .card-content .top[_v-1f18fc68] {\n      font-size: 16px; }\n  /* line 199, stdin */\n  .blue-pl[_v-1f18fc68] {\n    left: -40px;\n    top: 625px; }\n    /* line 202, stdin */\n    .blue-pl img[_v-1f18fc68] {\n      width: 95px; } }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-1f18fc68", module.exports)
  } else {
    hotAPI.update("_v-1f18fc68", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],940:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.shadow-card[_v-ff093bb4] {\n  text-align: center;\n  padding-bottom: 50px; }\n  /* line 5, stdin */\n  .shadow-card .top[_v-ff093bb4] {\n    max-width: 1140px;\n    width: 100%;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    height: var(--visual-height); }\n    /* line 10, stdin */\n    .shadow-card .top .business[_v-ff093bb4], .shadow-card .top .consumer[_v-ff093bb4] {\n      width: 50%;\n      height: 100%;\n      text-align: left;\n      padding: 40px 80px;\n      color: #4A4A4A; }\n      /* line 16, stdin */\n      .shadow-card .top .business .type[_v-ff093bb4], .shadow-card .top .consumer .type[_v-ff093bb4] {\n        font-size: 45px;\n        font-weight: 700; }\n      /* line 20, stdin */\n      .shadow-card .top .business .description[_v-ff093bb4], .shadow-card .top .consumer .description[_v-ff093bb4] {\n        font-size: 16px;\n        font-weight: 500;\n        margin-top: 10px;\n        margin-bottom: 35px; }\n    /* line 27, stdin */\n    .shadow-card .top .business[_v-ff093bb4] {\n      background: url(\"https://blog.17fit.com/wp-content/uploads/2021/10/S2-illu_boss.png\") no-repeat;\n      background-size: cover; }\n    /* line 31, stdin */\n    .shadow-card .top .consumer[_v-ff093bb4] {\n      background: url(\"https://blog.17fit.com/wp-content/uploads/2021/10/S2-illu_consumer.png\") no-repeat;\n      background-size: cover; }\n  /* line 36, stdin */\n  .shadow-card .bottom[_v-ff093bb4] {\n    max-width: 1140px;\n    width: 100%;\n    margin: 0 auto;\n    background: #FFFFFF;\n    box-shadow: 5px 10px 20px rgba(0, 0, 0, 0.12);\n    border-radius: 0px 0px 20px 20px;\n    padding: 50px 0;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    -ms-flex-pack: space-evenly;\n        justify-content: space-evenly;\n    transform: translateY(-7px); }\n    /* line 47, stdin */\n    .shadow-card .bottom img[_v-ff093bb4] {\n      width: 16%; }\n  @media (max-width: 992px) {\n    /* line 53, stdin */\n    .shadow-card .top .business[_v-ff093bb4], .shadow-card .top .consumer[_v-ff093bb4] {\n      padding: 25px 30px; }\n      /* line 55, stdin */\n      .shadow-card .top .business .type[_v-ff093bb4], .shadow-card .top .consumer .type[_v-ff093bb4] {\n        font-size: 40px; }\n      /* line 58, stdin */\n      .shadow-card .top .business .description[_v-ff093bb4], .shadow-card .top .consumer .description[_v-ff093bb4] {\n        font-size: 14px;\n        margin-bottom: 20px; } }\n  @media (max-width: 576px) {\n    /* line 2, stdin */\n    .shadow-card[_v-ff093bb4] {\n      padding-bottom: 10px;\n      margin-left: -20px;\n      margin-right: -20px; }\n      /* line 74, stdin */\n      .shadow-card .top[_v-ff093bb4] {\n        -ms-flex-direction: column-reverse;\n            flex-direction: column-reverse; }\n        /* line 76, stdin */\n        .shadow-card .top .business[_v-ff093bb4], .shadow-card .top .consumer[_v-ff093bb4] {\n          width: 100%;\n          text-align: center; }\n        /* line 80, stdin */\n        .shadow-card .top .business[_v-ff093bb4] {\n          background: url(\"https://blog.17fit.com/wp-content/uploads/2021/10/Phone-illu_boss.png\") no-repeat;\n          background-size: cover; }\n        /* line 84, stdin */\n        .shadow-card .top .consumer[_v-ff093bb4] {\n          background: url(\"https://blog.17fit.com/wp-content/uploads/2021/10/Phone-illu_consumer.png\") no-repeat;\n          background-size: cover; }\n      /* line 89, stdin */\n      .shadow-card .bottom[_v-ff093bb4] {\n        box-shadow: none;\n        padding: 20px 0;\n        -ms-flex-wrap: wrap;\n            flex-wrap: wrap; }\n        /* line 93, stdin */\n        .shadow-card .bottom img[_v-ff093bb4] {\n          width: 30%;\n          height: auto;\n          -ms-flex-item-align: start;\n              align-self: flex-start; } }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    data: function data() {
        return {
            keyVisualHeight: 570,
            brands: [{ img: 'https://blog.17fit.com/wp-content/uploads/2021/08/fitness-logo-01.png', name: '森林跑站' }, { img: 'https://blog.17fit.com/wp-content/uploads/2021/08/fitness-logo-02.png', name: 'TMMA' }, { img: 'https://blog.17fit.com/wp-content/uploads/2021/08/fitness-logo-03.png', name: '好時光' }, { img: 'https://blog.17fit.com/wp-content/uploads/2021/08/fitness-logo-04.png', name: 'HRC' }, { img: 'https://blog.17fit.com/wp-content/uploads/2021/08/fitness-logo-05.png', name: 'WAO' }, { img: 'https://blog.17fit.com/wp-content/uploads/2021/08/fitness-logo-06.png', name: 'Body travel' }]
        };
    },
    mounted: function mounted() {},

    methods: {
        resizeKeyVisualHeight: function resizeKeyVisualHeight() {
            var width = window.innerWidth;
            var maxWidth = 1140;
            if (width > maxWidth) {
                this.keyVisualHeight = maxWidth / 2 * 1.128;
            } else if (width > 576 && width <= maxWidth) {
                this.keyVisualHeight = (width - 40) / 2 * 1.128;
            } else {
                this.keyVisualHeight = width * 1.21 * 2;
            }
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"shadow-card\" _v-ff093bb4=\"\">\n    <div class=\"top\" :style=\"{'--visual-height': keyVisualHeight+'px'}\" _v-ff093bb4=\"\">\n        <div class=\"business\" _v-ff093bb4=\"\">\n            <div class=\"type\" _v-ff093bb4=\"\">我是經營者</div>\n            <div class=\"description\" _v-ff093bb4=\"\">用科技，倍速擴大你的營收！立即加入最多<br _v-ff093bb4=\"\">運動、美容店家都在使用的線上營運系統</div>\n            <landing-golden-btn text=\"了解更多\" href=\"/business\" target=\"_self\" _v-ff093bb4=\"\"></landing-golden-btn>\n        </div>\n        <div class=\"consumer\" _v-ff093bb4=\"\">\n            <div class=\"type\" _v-ff093bb4=\"\">我是消費者</div>\n            <div class=\"description\" _v-ff093bb4=\"\">從運動到美容，全台已經有超過 1200 萬人次<br _v-ff093bb4=\"\">透過 17FIT，找到最適合自己的理想店家</div>\n            <landing-golden-btn text=\"開始探索\" href=\"/class-list\" target=\"_self\" _v-ff093bb4=\"\"></landing-golden-btn>\n        </div>\n    </div>\n    <div class=\"bottom\" _v-ff093bb4=\"\">\n        <img v-for=\"brand in brands\" :src=\"brand.img\" :alt=\"brand.name\" _v-ff093bb4=\"\">\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.shadow-card[_v-ff093bb4] {\n  text-align: center;\n  padding-bottom: 50px; }\n  /* line 5, stdin */\n  .shadow-card .top[_v-ff093bb4] {\n    max-width: 1140px;\n    width: 100%;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    height: var(--visual-height); }\n    /* line 10, stdin */\n    .shadow-card .top .business[_v-ff093bb4], .shadow-card .top .consumer[_v-ff093bb4] {\n      width: 50%;\n      height: 100%;\n      text-align: left;\n      padding: 40px 80px;\n      color: #4A4A4A; }\n      /* line 16, stdin */\n      .shadow-card .top .business .type[_v-ff093bb4], .shadow-card .top .consumer .type[_v-ff093bb4] {\n        font-size: 45px;\n        font-weight: 700; }\n      /* line 20, stdin */\n      .shadow-card .top .business .description[_v-ff093bb4], .shadow-card .top .consumer .description[_v-ff093bb4] {\n        font-size: 16px;\n        font-weight: 500;\n        margin-top: 10px;\n        margin-bottom: 35px; }\n    /* line 27, stdin */\n    .shadow-card .top .business[_v-ff093bb4] {\n      background: url(\"https://blog.17fit.com/wp-content/uploads/2021/10/S2-illu_boss.png\") no-repeat;\n      background-size: cover; }\n    /* line 31, stdin */\n    .shadow-card .top .consumer[_v-ff093bb4] {\n      background: url(\"https://blog.17fit.com/wp-content/uploads/2021/10/S2-illu_consumer.png\") no-repeat;\n      background-size: cover; }\n  /* line 36, stdin */\n  .shadow-card .bottom[_v-ff093bb4] {\n    max-width: 1140px;\n    width: 100%;\n    margin: 0 auto;\n    background: #FFFFFF;\n    box-shadow: 5px 10px 20px rgba(0, 0, 0, 0.12);\n    border-radius: 0px 0px 20px 20px;\n    padding: 50px 0;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    -ms-flex-pack: space-evenly;\n        justify-content: space-evenly;\n    transform: translateY(-7px); }\n    /* line 47, stdin */\n    .shadow-card .bottom img[_v-ff093bb4] {\n      width: 16%; }\n  @media (max-width: 992px) {\n    /* line 53, stdin */\n    .shadow-card .top .business[_v-ff093bb4], .shadow-card .top .consumer[_v-ff093bb4] {\n      padding: 25px 30px; }\n      /* line 55, stdin */\n      .shadow-card .top .business .type[_v-ff093bb4], .shadow-card .top .consumer .type[_v-ff093bb4] {\n        font-size: 40px; }\n      /* line 58, stdin */\n      .shadow-card .top .business .description[_v-ff093bb4], .shadow-card .top .consumer .description[_v-ff093bb4] {\n        font-size: 14px;\n        margin-bottom: 20px; } }\n  @media (max-width: 576px) {\n    /* line 2, stdin */\n    .shadow-card[_v-ff093bb4] {\n      padding-bottom: 10px;\n      margin-left: -20px;\n      margin-right: -20px; }\n      /* line 74, stdin */\n      .shadow-card .top[_v-ff093bb4] {\n        -ms-flex-direction: column-reverse;\n            flex-direction: column-reverse; }\n        /* line 76, stdin */\n        .shadow-card .top .business[_v-ff093bb4], .shadow-card .top .consumer[_v-ff093bb4] {\n          width: 100%;\n          text-align: center; }\n        /* line 80, stdin */\n        .shadow-card .top .business[_v-ff093bb4] {\n          background: url(\"https://blog.17fit.com/wp-content/uploads/2021/10/Phone-illu_boss.png\") no-repeat;\n          background-size: cover; }\n        /* line 84, stdin */\n        .shadow-card .top .consumer[_v-ff093bb4] {\n          background: url(\"https://blog.17fit.com/wp-content/uploads/2021/10/Phone-illu_consumer.png\") no-repeat;\n          background-size: cover; }\n      /* line 89, stdin */\n      .shadow-card .bottom[_v-ff093bb4] {\n        box-shadow: none;\n        padding: 20px 0;\n        -ms-flex-wrap: wrap;\n            flex-wrap: wrap; }\n        /* line 93, stdin */\n        .shadow-card .bottom img[_v-ff093bb4] {\n          width: 30%;\n          height: auto;\n          -ms-flex-item-align: start;\n              align-self: flex-start; } }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-ff093bb4", module.exports)
  } else {
    hotAPI.update("_v-ff093bb4", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],941:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.gold-btn[_v-5ff35006] {\n  background: linear-gradient(90deg, #FFB900 0%, #FE6759 100%);\n  border-radius: 100px;\n  padding: 12px 55px;\n  color: white;\n  font-size: 26px;\n  font-weight: 700;\n  transition: 0.2s all ease-in-out;\n  border: 1px solid white; }\n  /* line 11, stdin */\n  .gold-btn.disable[_v-5ff35006] {\n    background: rgba(255, 255, 255, 0.7);\n    color: rgba(248, 145, 27, 0.7); }\n  /* line 15, stdin */\n  .gold-btn[_v-5ff35006]:hover {\n    background: white;\n    color: #F8911B;\n    border: 1px solid #FF8B11; }\n  @media (max-width: 992px) {\n    /* line 2, stdin */\n    .gold-btn[_v-5ff35006] {\n      font-size: 16px;\n      padding: 7px 34px; } }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        text: {
            required: true
        },
        href: {},
        target: {
            default: '_blank'
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-5ff35006=\"\">\n    <a class=\"gold-btn\" :href=\"href\" :target=\"target\" _v-5ff35006=\"\">{{ text }}</a>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.gold-btn[_v-5ff35006] {\n  background: linear-gradient(90deg, #FFB900 0%, #FE6759 100%);\n  border-radius: 100px;\n  padding: 12px 55px;\n  color: white;\n  font-size: 26px;\n  font-weight: 700;\n  transition: 0.2s all ease-in-out;\n  border: 1px solid white; }\n  /* line 11, stdin */\n  .gold-btn.disable[_v-5ff35006] {\n    background: rgba(255, 255, 255, 0.7);\n    color: rgba(248, 145, 27, 0.7); }\n  /* line 15, stdin */\n  .gold-btn[_v-5ff35006]:hover {\n    background: white;\n    color: #F8911B;\n    border: 1px solid #FF8B11; }\n  @media (max-width: 992px) {\n    /* line 2, stdin */\n    .gold-btn[_v-5ff35006] {\n      font-size: 16px;\n      padding: 7px 34px; } }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-5ff35006", module.exports)
  } else {
    hotAPI.update("_v-5ff35006", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],942:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _index = require('./index.vue');

var _index2 = _interopRequireDefault(_index);

var _businessConsumerSection = require('./business-consumer-section.vue');

var _businessConsumerSection2 = _interopRequireDefault(_businessConsumerSection);

var _articleReportSection = require('./article-report-section.vue');

var _articleReportSection2 = _interopRequireDefault(_articleReportSection);

var _goldenBtn = require('./golden-btn.vue');

var _goldenBtn2 = _interopRequireDefault(_goldenBtn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('web-landing-page', _index2.default);
_vue2.default.component('business-consumer-section', _businessConsumerSection2.default);
_vue2.default.component('article-report-section', _articleReportSection2.default);
_vue2.default.component('landing-golden-btn', _goldenBtn2.default);

},{"./article-report-section.vue":939,"./business-consumer-section.vue":940,"./golden-btn.vue":941,"./index.vue":943,"vue":792}],943:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.landing-container[_v-3a71007d] {\n  max-width: 1440px;\n  width: 100%;\n  padding: 0 20px;\n  margin: 0 auto; }\n\n/* line 8, stdin */\n.landing-fixed-header-bg[_v-3a71007d], .landing-fixed-header[_v-3a71007d] {\n  height: 72px;\n  width: 100%;\n  max-width: 1920px;\n  position: fixed;\n  transition: all .5s ease-in-out; }\n\n/* line 15, stdin */\n.landing-fixed-header-bg[_v-3a71007d] {\n  background: linear-gradient(180deg, #2B7DD1 0%, #18419A 100%);\n  top: -100px;\n  z-index: 9; }\n  /* line 19, stdin */\n  .landing-fixed-header-bg.in[_v-3a71007d] {\n    top: 0; }\n\n/* line 23, stdin */\n.landing-fixed-header[_v-3a71007d] {\n  background: transparent;\n  top: 0;\n  z-index: 10; }\n  /* line 27, stdin */\n  .landing-fixed-header .logo[_v-3a71007d] {\n    max-height: 50px;\n    width: 150px;\n    margin-top: 10px; }\n  /* line 32, stdin */\n  .landing-fixed-header .funcion-bar[_v-3a71007d] {\n    display: -ms-flexbox;\n    display: flex;\n    padding: 6px 26px; }\n\n/* line 37, stdin */\n.funcion-bar[_v-3a71007d] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  padding: 25px; }\n  /* line 42, stdin */\n  .funcion-bar .btn-group a[_v-3a71007d] {\n    width: 130px;\n    border-radius: 100px;\n    border: 1px solid white;\n    font-size: 18px;\n    font-weight: bold;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    padding: 6px 0;\n    margin-top: 10px;\n    -ms-flex-pack: center;\n        justify-content: center;\n    -ms-flex-align: center;\n        align-items: center; }\n    /* line 53, stdin */\n    .funcion-bar .btn-group a.create-store[_v-3a71007d] {\n      color: white;\n      background: transparent; }\n      /* line 54, stdin */\n      .funcion-bar .btn-group a.create-store .icon[_v-3a71007d] {\n        width: 17px;\n        height: 15px;\n        -webkit-mask: url(\"/images/landing/header-icon_store.svg\") no-repeat center/contain;\n                mask: url(\"/images/landing/header-icon_store.svg\") no-repeat center/contain;\n        background-color: white; }\n      /* line 62, stdin */\n      .funcion-bar .btn-group a.create-store[_v-3a71007d]:hover {\n        color: #225DAC;\n        background: white; }\n        /* line 63, stdin */\n        .funcion-bar .btn-group a.create-store:hover .icon[_v-3a71007d] {\n          background-color: #225DAC; }\n    /* line 71, stdin */\n    .funcion-bar .btn-group a.login[_v-3a71007d] {\n      color: #225DAC;\n      background: white; }\n      /* line 72, stdin */\n      .funcion-bar .btn-group a.login .icon[_v-3a71007d] {\n        width: 13px;\n        height: 15px;\n        -webkit-mask: url(\"/images/landing/header-icon_login.svg\") no-repeat center/contain;\n                mask: url(\"/images/landing/header-icon_login.svg\") no-repeat center/contain;\n        background-color: #225DAC; }\n      /* line 80, stdin */\n      .funcion-bar .btn-group a.login[_v-3a71007d]:hover {\n        color: white;\n        background: transparent; }\n        /* line 81, stdin */\n        .funcion-bar .btn-group a.login:hover .icon[_v-3a71007d] {\n          background-color: white; }\n\n/* line 91, stdin */\n.banner-content[_v-3a71007d] {\n  text-align: center;\n  color: white; }\n  /* line 94, stdin */\n  .banner-content .til[_v-3a71007d] {\n    margin-top: 130px;\n    font-size: 70px;\n    font-weight: 600; }\n  /* line 99, stdin */\n  .banner-content .sub[_v-3a71007d] {\n    font-size: 20px;\n    font-weight: 500; }\n\n/* line 104, stdin */\n.universe-bg[_v-3a71007d] {\n  box-shadow: inset 0 -100px 100px rgba(0, 0, 0, 0.5);\n  max-width: 1920px;\n  height: 100%;\n  width: 100%;\n  animation: universe-bg-change 10s linear infinite;\n  position: fixed;\n  top: 0;\n  z-index: -10;\n  overflow: hidden; }\n  /* line 114, stdin */\n  .universe-bg img.animation[_v-3a71007d] {\n    position: absolute; }\n\n/* line 118, stdin */\n.uni-green[_v-3a71007d] {\n  width: 150px;\n  left: 90px;\n  top: 100px;\n  animation: bounce 0.5s;\n  animation-direction: alternate;\n  animation-iteration-count: infinite; }\n\n/* line 126, stdin */\n.uni-red[_v-3a71007d] {\n  animation: rotate 20s linear infinite;\n  right: 100px;\n  top: 100px;\n  width: 100px; }\n\n/* line 132, stdin */\n.uni-star1[_v-3a71007d] {\n  animation: glitter 6s linear 0s infinite normal;\n  left: 350px;\n  top: 400px;\n  width: 22px; }\n\n/* line 138, stdin */\n.uni-star2[_v-3a71007d] {\n  animation: glitter 6s linear 0s infinite normal;\n  right: 300px;\n  top: 120px; }\n\n/* line 143, stdin */\n.uni-star2[_v-3a71007d] {\n  right: 300px;\n  top: 120px; }\n\n/* line 147, stdin */\n.uni-star3[_v-3a71007d] {\n  right: 400px;\n  top: 420px;\n  width: 20px; }\n\n/* line 152, stdin */\n.uni-dot1[_v-3a71007d] {\n  animation: glitter 6s linear 0s infinite normal;\n  left: 450px;\n  top: 350px;\n  animation-delay: 1s; }\n\n/* line 158, stdin */\n.uni-dot2[_v-3a71007d] {\n  animation: brightness 3s infinite;\n  right: 100px;\n  width: 8px; }\n\n/* line 163, stdin */\n.fade-in-section[_v-3a71007d] {\n  opacity: 0;\n  transform: translateY(20vh);\n  visibility: hidden;\n  transition: opacity 1200ms ease-out, transform 600ms ease-out, visibility 1200ms ease-out;\n  will-change: opacity, transform, visibility; }\n  /* line 170, stdin */\n  .fade-in-section.is-visible[_v-3a71007d] {\n    opacity: 1;\n    transform: none;\n    visibility: visible; }\n\n/* line 176, stdin */\n.landing-content[_v-3a71007d] {\n  margin-top: 350px; }\n\n/* line 179, stdin */\n.top-curve-cover[_v-3a71007d] {\n  background: url(\"/images/landing/PC-header_background.svg\");\n  height: 200px;\n  width: 100%;\n  background-size: cover;\n  text-align: right; }\n  /* line 185, stdin */\n  .top-curve-cover .rocket[_v-3a71007d] {\n    margin-right: 100px;\n    opacity: 0;\n    transition: opacity .5s ease-in-out; }\n    /* line 189, stdin */\n    .top-curve-cover .rocket.is-visible[_v-3a71007d] {\n      opacity: 1;\n      position: relative; }\n    /* line 193, stdin */\n    .top-curve-cover .rocket.animation[_v-3a71007d] {\n      opacity: 1;\n      animation: rocket-fly 3s linear 1;\n      animation-delay: 5s; }\n  /* line 199, stdin */\n  .top-curve-cover .rocket-smoke[_v-3a71007d] {\n    opacity: 0; }\n    /* line 201, stdin */\n    .top-curve-cover .rocket-smoke.animation[_v-3a71007d] {\n      animation: fade-in 3s linear 1;\n      animation-delay: 5s; }\n\n/* line 207, stdin */\n.white-bg[_v-3a71007d] {\n  background: white; }\n\n/* line 210, stdin */\n.blue-bg[_v-3a71007d] {\n  background: url(https://blog.17fit.com/wp-content/uploads/2021/10/S3-blue-background.png) white;\n  background-repeat: no-repeat;\n  background-size: 100% auto; }\n\n/* line 215, stdin */\n.landing-contact[_v-3a71007d] {\n  background: url(https://blog.17fit.com/wp-content/uploads/2021/10/S6-background.png) white;\n  background-repeat: no-repeat;\n  background-size: 100% auto;\n  position: relative; }\n  /* line 220, stdin */\n  .landing-contact .grow[_v-3a71007d] {\n    height: var(--contact-height);\n    width: 100%;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n    -ms-flex-pack: center;\n        justify-content: center;\n    -ms-flex-direction: column;\n        flex-direction: column; }\n  /* line 228, stdin */\n  .landing-contact .tx[_v-3a71007d] {\n    font-size: 46px;\n    font-weight: 600;\n    color: #fff;\n    text-align: center;\n    margin-bottom: 50px; }\n\n/* line 237, stdin */\n.shooting-star[_v-3a71007d] {\n  position: absolute;\n  left: -200px;\n  width: 120px;\n  height: 2px;\n  background: url(\"/images/landing/shooting-star.png\") center center no-repeat;\n  background-size: 100% 100%;\n  transform: rotate(20deg);\n  top: 0;\n  left: 50%;\n  opacity: 0; }\n\n/* line 250, stdin */\n.shooting-star-1[_v-3a71007d] {\n  top: 149px;\n  animation: 25s shooting-star 10.8s infinite; }\n\n/* line 250, stdin */\n.shooting-star-2[_v-3a71007d] {\n  top: 130px;\n  animation: 24s shooting-star 8.6s infinite; }\n\n/* line 250, stdin */\n.shooting-star-3[_v-3a71007d] {\n  top: 183px;\n  animation: 24s shooting-star 17s infinite; }\n\n/* line 250, stdin */\n.shooting-star-4[_v-3a71007d] {\n  top: 71px;\n  animation: 25s shooting-star 1.5s infinite; }\n\n/* line 250, stdin */\n.shooting-star-5[_v-3a71007d] {\n  top: 47px;\n  animation: 23s shooting-star 19.3s infinite; }\n\n/* line 250, stdin */\n.shooting-star-6[_v-3a71007d] {\n  top: 55px;\n  animation: 24s shooting-star 6s infinite; }\n\n@media (max-width: 1440px) and (max-height: 768px) {\n  /* line 257, stdin */\n  .landing-content[_v-3a71007d] {\n    margin-top: 270px; }\n  /* line 261, stdin */\n  .top-curve-cover .rocket[_v-3a71007d] {\n    margin-right: 75px; } }\n\n@media (max-width: 992px) {\n  /* line 268, stdin */\n  .landing-content[_v-3a71007d] {\n    margin-top: 250px; }\n  /* line 271, stdin */\n  .uni-green[_v-3a71007d] {\n    left: -10px;\n    top: 150px; }\n  /* line 275, stdin */\n  .uni-red[_v-3a71007d] {\n    right: 10px; }\n  /* line 278, stdin */\n  .uni-star1[_v-3a71007d] {\n    left: 150px;\n    top: 350px; }\n  /* line 282, stdin */\n  .uni-dot1[_v-3a71007d] {\n    left: 250px;\n    top: 300px; }\n  /* line 287, stdin */\n  .banner-content .til[_v-3a71007d] {\n    font-size: 45px; }\n  /* line 290, stdin */\n  .banner-content .sub[_v-3a71007d] {\n    font-size: 16px; }\n  /* line 294, stdin */\n  .top-curve-cover[_v-3a71007d] {\n    height: 210px; }\n    /* line 296, stdin */\n    .top-curve-cover .rocket[_v-3a71007d] {\n      margin-right: 0; }\n  /* line 300, stdin */\n  .landing-contact[_v-3a71007d] {\n    background: url(https://blog.17fit.com/wp-content/uploads/2021/10/tablet-S6-biue-background.png) white;\n    background-repeat: no-repeat;\n    background-size: 100% auto; }\n    /* line 304, stdin */\n    .landing-contact .tx[_v-3a71007d] {\n      font-size: 36px; } }\n\n@media (max-width: 576px) {\n  /* line 311, stdin */\n  .hidden-on-mobile[_v-3a71007d] {\n    display: none !important; }\n  /* line 314, stdin */\n  .landing-content[_v-3a71007d] {\n    margin-top: 51px; }\n  /* line 317, stdin */\n  .landing-contact[_v-3a71007d] {\n    background: url(https://blog.17fit.com/wp-content/uploads/2021/10/Phone-S5-blue-background.png) white;\n    background-repeat: no-repeat;\n    background-size: 100% auto; }\n    /* line 321, stdin */\n    .landing-contact .tx[_v-3a71007d] {\n      font-size: 33px;\n      max-width: 288px; }\n  /* line 326, stdin */\n  .landing-fixed-header-bg[_v-3a71007d] {\n    top: 0;\n    height: 51px; }\n  /* line 330, stdin */\n  .landing-fixed-header[_v-3a71007d] {\n    height: 51px;\n    width: 100%;\n    position: fixed;\n    top: 0; }\n    /* line 335, stdin */\n    .landing-fixed-header .logo[_v-3a71007d] {\n      width: 93px;\n      margin-top: 0; }\n    /* line 339, stdin */\n    .landing-fixed-header .funcion-bar[_v-3a71007d] {\n      display: -ms-flexbox;\n      display: flex;\n      padding: 6px 0; }\n      /* line 343, stdin */\n      .landing-fixed-header .funcion-bar .btn-group a[_v-3a71007d] {\n        font-size: 16px;\n        width: 93px;\n        margin-top: 3px;\n        padding: 4px 0; }\n        /* line 348, stdin */\n        .landing-fixed-header .funcion-bar .btn-group a.create-store[_v-3a71007d] {\n          display: none; } }\n\n@keyframes fade-in {\n  0% {\n    opacity: 0; }\n  40% {\n    opacity: 0; }\n  50% {\n    opacity: .5; }\n  100% {\n    opacity: 1; } }\n\n@keyframes rocket-fly {\n  0% {\n    transform: translate(0, 0); }\n  10% {\n    transform: translate(-2px, 5px); }\n  30% {\n    transform: translate(0, 0); }\n  40% {\n    transform: translate(-2px, 5px); }\n  50% {\n    transform: translate(0, 0);\n    width: 245px;\n    height: auto; }\n  60% {\n    transform: translate(-100px, -120px);\n    width: 200px;\n    height: auto;\n    opacity: 1; }\n  100% {\n    transform: translate(-500px, -500px);\n    width: 50px;\n    height: auto;\n    opacity: 0; } }\n\n@keyframes brightness {\n  0%, 100% {\n    filter: brightness(none) blur(0px) hue-rotate(0deg) saturate(none); }\n  50% {\n    filter: brightness(10) blur(3px) hue-rotate(180deg) saturate(10); } }\n\n@keyframes glitter {\n  0% {\n    transform: scale(0.3) rotate(0deg);\n    opacity: 0; }\n  25% {\n    transform: scale(1) rotate(360deg);\n    opacity: 1; }\n  50% {\n    transform: scale(0.3) rotate(720deg);\n    opacity: 0; }\n  100% {\n    transform: scale(0.3) rotate(0deg);\n    opacity: 0; } }\n\n@keyframes bounce {\n  from {\n    transform: translate3d(0, 0, 0); }\n  to {\n    transform: translate3d(0, 10px, 0); } }\n\n@keyframes rotate {\n  from {\n    transform: rotate(0deg); }\n  to {\n    transform: rotate(360deg); } }\n\n@keyframes universe-bg-change {\n  0% {\n    background: #3b93ff; }\n  25% {\n    background: #2B7DD1; }\n  75% {\n    background: #18419A; }\n  100% {\n    background: #3b93ff; } }\n\n@keyframes shooting-star {\n  0% {\n    opacity: 0;\n    transform: translate(0, 0) rotate(20deg); }\n  15% {\n    opacity: 1;\n    transform: translate(800px, 250px) rotate(20deg); }\n  16%, 100% {\n    opacity: 0; } }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	props: {
		auth: {}
	},
	data: function data() {
		return {
			ajaxing: false,
			contactSectionHeight: 570,
			containerMax: 1920,
			blogPost: []
		};
	},
	mounted: function mounted() {
		window.addEventListener('resize', this.resizeAdjust);
		window.addEventListener('scroll', this.handleScroll);
		this.resizeAdjust();
		this.getPost();
		this.readyShow();
	},

	methods: {
		readyShow: function readyShow() {
			var vm = this;
			var rocket = document.querySelector('.top-curve-cover .rocket');
			setTimeout(function () {
				$('.fade-in-section')[0].classList.add("is-visible");
			}, 2000);
			setTimeout(function () {
				$('.fade-in-section')[1].classList.add("is-visible");
				vm.toggleRocketAnimateClass('add');
			}, 4000);
			rocket.addEventListener('animationend', function () {
				vm.toggleRocketAnimateClass('remove');
				setTimeout(function () {
					vm.toggleRocketAnimateClass('add');
				}, 10000);
			});
		},
		toggleRocketAnimateClass: function toggleRocketAnimateClass() {
			var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "add";

			var rocket = document.querySelector('.top-curve-cover .rocket');
			var rocketSmoke = document.querySelector('.top-curve-cover .rocket-smoke');
			var reverseAction = action == 'remove' ? 'add' : 'remove';
			rocket.classList[action]("animation");
			rocketSmoke.classList[action]("animation");
			setTimeout(function () {
				rocket.classList[reverseAction]("is-visible");
			}, 3000);
		},
		resizeAdjust: function resizeAdjust() {
			this.contactHeight();
			this.$refs.key_visaul.resizeKeyVisualHeight();
			this.$refs.blog_article.handleResize();
		},
		contactHeight: function contactHeight() {
			var width = window.innerWidth;
			if (width > 992) {
				var rWidth = width > this.containerMax ? this.containerMax : width;
				this.contactSectionHeight = rWidth / 2.63;
			} else if (width > 576 && width <= 992) {
				this.contactSectionHeight = width / 2.1;
			} else {
				this.contactSectionHeight = width / 1.06;
			}
		},
		handleScroll: function handleScroll() {
			var rootElement = document.documentElement;
			var scrollTotal = rootElement.scrollHeight - rootElement.clientHeight;
			var ratio = rootElement.scrollTop / scrollTotal;
			if (ratio > 0.12) {
				$('.landing-fixed-header-bg').addClass('in');
			} else {
				$('.landing-fixed-header-bg').removeClass('in');
			}
		},
		getPost: function getPost() {
			var _this = this;

			this.$http.get('/webapi/blog-article/get').then(function (response) {
				_this.blogPost = response.data;
			});
		}
	}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-3a71007d=\"\">\n    <div style=\"overflow: hidden;\" _v-3a71007d=\"\">\n\t\t<div class=\"landing-fixed-header-bg\" _v-3a71007d=\"\"></div>\n\t\t<div class=\"landing-fixed-header\" _v-3a71007d=\"\">\n\t\t\t<div class=\"landing-container\" _v-3a71007d=\"\">\n\t\t\t\t<div class=\"funcion-bar\" _v-3a71007d=\"\">\n\t\t\t\t\t<img src=\"/images/17fit-logo-white.svg\" class=\"logo\" _v-3a71007d=\"\">\n\t\t\t\t\t<div class=\"btn-group\" _v-3a71007d=\"\">\n\t\t\t\t\t\t<a class=\"create-store m-right-20\" href=\"/business\" target=\"_self\" _v-3a71007d=\"\"><i class=\"icon m-right-5\" _v-3a71007d=\"\"></i>線上開館</a>\n\t\t\t\t\t\t<a v-if=\"auth\" class=\"login\" href=\"/my-account\" target=\"_self\" _v-3a71007d=\"\"><i class=\"icon m-right-5\" _v-3a71007d=\"\"></i>我的帳戶</a>\n\t\t\t\t\t\t<a v-else=\"\" class=\"login\" @click.stop.prevent=\"$refs.loginForm.login()\" _v-3a71007d=\"\"><i class=\"icon m-right-5\" _v-3a71007d=\"\"></i>登入</a>\n\t\t\t\t\t</div>\t\t\t\t\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n        <div class=\"universe-bg banner-content hidden-on-mobile\" _v-3a71007d=\"\">\n\t\t\t<div class=\"landing-container\" _v-3a71007d=\"\">\n\t\t\t\t<img class=\"animation uni-green\" src=\"https://blog.17fit.com/wp-content/uploads/2021/10/S5-green-planet.png\" _v-3a71007d=\"\">\n\t\t\t\t<img class=\"animation uni-red\" src=\"https://blog.17fit.com/wp-content/uploads/2021/10/S4-red-planet.png\" _v-3a71007d=\"\">\n\t\t\t\t<div class=\"til fade-in-section\" _v-3a71007d=\"\">用科技幫您做生意</div>\n\t\t\t\t<div class=\"sub fade-in-section m-top-15\" _v-3a71007d=\"\">專為運動、美容場域而生的雲端管理系統</div>\n\t\t\t\t<img class=\"animation uni-star1\" src=\"https://blog.17fit.com/wp-content/uploads/2021/10/star.png\" _v-3a71007d=\"\">\n\t\t\t\t<img class=\"animation uni-star2\" src=\"https://blog.17fit.com/wp-content/uploads/2021/10/star.png\" _v-3a71007d=\"\">\n\t\t\t\t<img class=\"animation uni-star3\" src=\"https://blog.17fit.com/wp-content/uploads/2021/10/star.png\" _v-3a71007d=\"\">\n\t\t\t\t<img class=\"animation uni-dot1\" src=\"https://blog.17fit.com/wp-content/uploads/2021/10/round-star.png\" _v-3a71007d=\"\">\n\t\t\t\t<img class=\"animation uni-dot2\" src=\"https://blog.17fit.com/wp-content/uploads/2021/10/round-star.png\" _v-3a71007d=\"\">\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"landing-content\" _v-3a71007d=\"\">\n\t\t\t<div class=\"top-curve-cover hidden-on-mobile\" _v-3a71007d=\"\">\n\t\t\t\t<svg class=\"rocket animation\" width=\"245\" height=\"346\" viewBox=\"0 0 245 346\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" _v-3a71007d=\"\">\n\t\t\t\t<g filter=\"url(#filter0_d)\" class=\"rocket-smoke animation\" _v-3a71007d=\"\">\n\t\t\t\t<rect x=\"120.585\" y=\"203.572\" width=\"103.629\" height=\"112.428\" fill=\"url(#pattern0)\" shape-rendering=\"crispEdges\" _v-3a71007d=\"\"></rect>\n\t\t\t\t</g>\n\t\t\t\t<g filter=\"url(#filter1_d)\" _v-3a71007d=\"\">\n\t\t\t\t<rect x=\"15\" y=\"13.5421\" width=\"174.997\" height=\"231.7\" transform=\"rotate(-1.1598 15 13.5421)\" fill=\"url(#pattern1)\" shape-rendering=\"crispEdges\" _v-3a71007d=\"\"></rect>\n\t\t\t\t</g>\n\t\t\t\t<defs _v-3a71007d=\"\">\n\t\t\t\t<filter id=\"filter0_d\" x=\"100.585\" y=\"193.572\" width=\"143.63\" height=\"152.428\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\" _v-3a71007d=\"\">\n\t\t\t\t<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\" _v-3a71007d=\"\"></feFlood>\n\t\t\t\t<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\" _v-3a71007d=\"\"></feColorMatrix>\n\t\t\t\t<feOffset dy=\"10\" _v-3a71007d=\"\"></feOffset>\n\t\t\t\t<feGaussianBlur stdDeviation=\"10\" _v-3a71007d=\"\"></feGaussianBlur>\n\t\t\t\t<feComposite in2=\"hardAlpha\" operator=\"out\" _v-3a71007d=\"\"></feComposite>\n\t\t\t\t<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0\" _v-3a71007d=\"\"></feColorMatrix>\n\t\t\t\t<feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow\" _v-3a71007d=\"\"></feBlend>\n\t\t\t\t<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow\" result=\"shape\" _v-3a71007d=\"\"></feBlend>\n\t\t\t\t</filter>\n\t\t\t\t<pattern id=\"pattern0\" patternContentUnits=\"objectBoundingBox\" width=\"1\" height=\"1\" _v-3a71007d=\"\">\n\t\t\t\t<use xlink:href=\"#image0\" transform=\"translate(-0.00131443) scale(0.00191341 0.00176367)\" _v-3a71007d=\"\"></use>\n\t\t\t\t</pattern>\n\t\t\t\t<filter id=\"filter1_d\" x=\"0\" y=\"0\" width=\"219.65\" height=\"275.194\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\" _v-3a71007d=\"\">\n\t\t\t\t<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\" _v-3a71007d=\"\"></feFlood>\n\t\t\t\t<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\" _v-3a71007d=\"\"></feColorMatrix>\n\t\t\t\t<feOffset dx=\"5\" dy=\"10\" _v-3a71007d=\"\"></feOffset>\n\t\t\t\t<feGaussianBlur stdDeviation=\"10\" _v-3a71007d=\"\"></feGaussianBlur>\n\t\t\t\t<feComposite in2=\"hardAlpha\" operator=\"out\" _v-3a71007d=\"\"></feComposite>\n\t\t\t\t<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0\" _v-3a71007d=\"\"></feColorMatrix>\n\t\t\t\t<feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow\" _v-3a71007d=\"\"></feBlend>\n\t\t\t\t<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow\" result=\"shape\" _v-3a71007d=\"\"></feBlend>\n\t\t\t\t</filter>\n\t\t\t\t<pattern id=\"pattern1\" patternContentUnits=\"objectBoundingBox\" width=\"1\" height=\"1\" _v-3a71007d=\"\">\n\t\t\t\t<use xlink:href=\"#image1\" transform=\"translate(0 -0.000801827) scale(0.000898473 0.000678593)\" _v-3a71007d=\"\"></use>\n\t\t\t\t</pattern>\n\t\t\t\t<image id=\"image0\" width=\"524\" height=\"567\" xlink:href=\"data:image/png;base64,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\" _v-3a71007d=\"\"></image>\n\t\t\t\t<image id=\"image1\" width=\"1113\" height=\"1476\" xlink:href=\"data:image/png;base64,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\" _v-3a71007d=\"\"></image>\n\t\t\t\t</defs>\n\t\t\t\t</svg>\n\t\t\t</div>\n\t\t\t<div class=\"white-bg\" style=\"margin-top: -10px\" _v-3a71007d=\"\">\n\t\t\t\t<div class=\"landing-container\" _v-3a71007d=\"\">\n\t\t\t\t\t<business-consumer-section ref=\"key_visaul\" _v-3a71007d=\"\"></business-consumer-section>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"blue-bg\" style=\"margin-top: -10px; padding-bottom: 30px;\" _v-3a71007d=\"\">\n\t\t\t\t<div class=\"landing-container\" _v-3a71007d=\"\">\n\t\t\t\t\t<article-report-section ref=\"blog_article\" :blog-post=\"blogPost\" _v-3a71007d=\"\"></article-report-section>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"landing-contact\" style=\"margin-top: -110px\" _v-3a71007d=\"\">\n\t\t\t\t<div class=\"grow\" :style=\"{'--contact-height': contactSectionHeight+'px'}\" _v-3a71007d=\"\">\n\t\t\t\t\t<div v-for=\"i in 10\" :class=\"'shooting-star-'+i\" class=\"shooting-star\" _v-3a71007d=\"\"></div>\n\t\t\t\t\t<div class=\"tx\" _v-3a71007d=\"\">預約系統領導品牌<br _v-3a71007d=\"\">\n\t\t\t\t\t\t用科技，帶動您的業績成長</div>\n\t\t\t\t\t<landing-golden-btn text=\"請專人與我聯繫\" href=\"/b/consultation\" _v-3a71007d=\"\"></landing-golden-btn>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<web-user-login-hidden-form ref=\"loginForm\" platform-define=\"seventeen-fit\" :show-fb=\"1\" dest-url-type=\"current\" _v-3a71007d=\"\"></web-user-login-hidden-form>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.landing-container[_v-3a71007d] {\n  max-width: 1440px;\n  width: 100%;\n  padding: 0 20px;\n  margin: 0 auto; }\n\n/* line 8, stdin */\n.landing-fixed-header-bg[_v-3a71007d], .landing-fixed-header[_v-3a71007d] {\n  height: 72px;\n  width: 100%;\n  max-width: 1920px;\n  position: fixed;\n  transition: all .5s ease-in-out; }\n\n/* line 15, stdin */\n.landing-fixed-header-bg[_v-3a71007d] {\n  background: linear-gradient(180deg, #2B7DD1 0%, #18419A 100%);\n  top: -100px;\n  z-index: 9; }\n  /* line 19, stdin */\n  .landing-fixed-header-bg.in[_v-3a71007d] {\n    top: 0; }\n\n/* line 23, stdin */\n.landing-fixed-header[_v-3a71007d] {\n  background: transparent;\n  top: 0;\n  z-index: 10; }\n  /* line 27, stdin */\n  .landing-fixed-header .logo[_v-3a71007d] {\n    max-height: 50px;\n    width: 150px;\n    margin-top: 10px; }\n  /* line 32, stdin */\n  .landing-fixed-header .funcion-bar[_v-3a71007d] {\n    display: -ms-flexbox;\n    display: flex;\n    padding: 6px 26px; }\n\n/* line 37, stdin */\n.funcion-bar[_v-3a71007d] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  padding: 25px; }\n  /* line 42, stdin */\n  .funcion-bar .btn-group a[_v-3a71007d] {\n    width: 130px;\n    border-radius: 100px;\n    border: 1px solid white;\n    font-size: 18px;\n    font-weight: bold;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    padding: 6px 0;\n    margin-top: 10px;\n    -ms-flex-pack: center;\n        justify-content: center;\n    -ms-flex-align: center;\n        align-items: center; }\n    /* line 53, stdin */\n    .funcion-bar .btn-group a.create-store[_v-3a71007d] {\n      color: white;\n      background: transparent; }\n      /* line 54, stdin */\n      .funcion-bar .btn-group a.create-store .icon[_v-3a71007d] {\n        width: 17px;\n        height: 15px;\n        -webkit-mask: url(\"/images/landing/header-icon_store.svg\") no-repeat center/contain;\n                mask: url(\"/images/landing/header-icon_store.svg\") no-repeat center/contain;\n        background-color: white; }\n      /* line 62, stdin */\n      .funcion-bar .btn-group a.create-store[_v-3a71007d]:hover {\n        color: #225DAC;\n        background: white; }\n        /* line 63, stdin */\n        .funcion-bar .btn-group a.create-store:hover .icon[_v-3a71007d] {\n          background-color: #225DAC; }\n    /* line 71, stdin */\n    .funcion-bar .btn-group a.login[_v-3a71007d] {\n      color: #225DAC;\n      background: white; }\n      /* line 72, stdin */\n      .funcion-bar .btn-group a.login .icon[_v-3a71007d] {\n        width: 13px;\n        height: 15px;\n        -webkit-mask: url(\"/images/landing/header-icon_login.svg\") no-repeat center/contain;\n                mask: url(\"/images/landing/header-icon_login.svg\") no-repeat center/contain;\n        background-color: #225DAC; }\n      /* line 80, stdin */\n      .funcion-bar .btn-group a.login[_v-3a71007d]:hover {\n        color: white;\n        background: transparent; }\n        /* line 81, stdin */\n        .funcion-bar .btn-group a.login:hover .icon[_v-3a71007d] {\n          background-color: white; }\n\n/* line 91, stdin */\n.banner-content[_v-3a71007d] {\n  text-align: center;\n  color: white; }\n  /* line 94, stdin */\n  .banner-content .til[_v-3a71007d] {\n    margin-top: 130px;\n    font-size: 70px;\n    font-weight: 600; }\n  /* line 99, stdin */\n  .banner-content .sub[_v-3a71007d] {\n    font-size: 20px;\n    font-weight: 500; }\n\n/* line 104, stdin */\n.universe-bg[_v-3a71007d] {\n  box-shadow: inset 0 -100px 100px rgba(0, 0, 0, 0.5);\n  max-width: 1920px;\n  height: 100%;\n  width: 100%;\n  animation: universe-bg-change 10s linear infinite;\n  position: fixed;\n  top: 0;\n  z-index: -10;\n  overflow: hidden; }\n  /* line 114, stdin */\n  .universe-bg img.animation[_v-3a71007d] {\n    position: absolute; }\n\n/* line 118, stdin */\n.uni-green[_v-3a71007d] {\n  width: 150px;\n  left: 90px;\n  top: 100px;\n  animation: bounce 0.5s;\n  animation-direction: alternate;\n  animation-iteration-count: infinite; }\n\n/* line 126, stdin */\n.uni-red[_v-3a71007d] {\n  animation: rotate 20s linear infinite;\n  right: 100px;\n  top: 100px;\n  width: 100px; }\n\n/* line 132, stdin */\n.uni-star1[_v-3a71007d] {\n  animation: glitter 6s linear 0s infinite normal;\n  left: 350px;\n  top: 400px;\n  width: 22px; }\n\n/* line 138, stdin */\n.uni-star2[_v-3a71007d] {\n  animation: glitter 6s linear 0s infinite normal;\n  right: 300px;\n  top: 120px; }\n\n/* line 143, stdin */\n.uni-star2[_v-3a71007d] {\n  right: 300px;\n  top: 120px; }\n\n/* line 147, stdin */\n.uni-star3[_v-3a71007d] {\n  right: 400px;\n  top: 420px;\n  width: 20px; }\n\n/* line 152, stdin */\n.uni-dot1[_v-3a71007d] {\n  animation: glitter 6s linear 0s infinite normal;\n  left: 450px;\n  top: 350px;\n  animation-delay: 1s; }\n\n/* line 158, stdin */\n.uni-dot2[_v-3a71007d] {\n  animation: brightness 3s infinite;\n  right: 100px;\n  width: 8px; }\n\n/* line 163, stdin */\n.fade-in-section[_v-3a71007d] {\n  opacity: 0;\n  transform: translateY(20vh);\n  visibility: hidden;\n  transition: opacity 1200ms ease-out, transform 600ms ease-out, visibility 1200ms ease-out;\n  will-change: opacity, transform, visibility; }\n  /* line 170, stdin */\n  .fade-in-section.is-visible[_v-3a71007d] {\n    opacity: 1;\n    transform: none;\n    visibility: visible; }\n\n/* line 176, stdin */\n.landing-content[_v-3a71007d] {\n  margin-top: 350px; }\n\n/* line 179, stdin */\n.top-curve-cover[_v-3a71007d] {\n  background: url(\"/images/landing/PC-header_background.svg\");\n  height: 200px;\n  width: 100%;\n  background-size: cover;\n  text-align: right; }\n  /* line 185, stdin */\n  .top-curve-cover .rocket[_v-3a71007d] {\n    margin-right: 100px;\n    opacity: 0;\n    transition: opacity .5s ease-in-out; }\n    /* line 189, stdin */\n    .top-curve-cover .rocket.is-visible[_v-3a71007d] {\n      opacity: 1;\n      position: relative; }\n    /* line 193, stdin */\n    .top-curve-cover .rocket.animation[_v-3a71007d] {\n      opacity: 1;\n      animation: rocket-fly 3s linear 1;\n      animation-delay: 5s; }\n  /* line 199, stdin */\n  .top-curve-cover .rocket-smoke[_v-3a71007d] {\n    opacity: 0; }\n    /* line 201, stdin */\n    .top-curve-cover .rocket-smoke.animation[_v-3a71007d] {\n      animation: fade-in 3s linear 1;\n      animation-delay: 5s; }\n\n/* line 207, stdin */\n.white-bg[_v-3a71007d] {\n  background: white; }\n\n/* line 210, stdin */\n.blue-bg[_v-3a71007d] {\n  background: url(https://blog.17fit.com/wp-content/uploads/2021/10/S3-blue-background.png) white;\n  background-repeat: no-repeat;\n  background-size: 100% auto; }\n\n/* line 215, stdin */\n.landing-contact[_v-3a71007d] {\n  background: url(https://blog.17fit.com/wp-content/uploads/2021/10/S6-background.png) white;\n  background-repeat: no-repeat;\n  background-size: 100% auto;\n  position: relative; }\n  /* line 220, stdin */\n  .landing-contact .grow[_v-3a71007d] {\n    height: var(--contact-height);\n    width: 100%;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n    -ms-flex-pack: center;\n        justify-content: center;\n    -ms-flex-direction: column;\n        flex-direction: column; }\n  /* line 228, stdin */\n  .landing-contact .tx[_v-3a71007d] {\n    font-size: 46px;\n    font-weight: 600;\n    color: #fff;\n    text-align: center;\n    margin-bottom: 50px; }\n\n/* line 237, stdin */\n.shooting-star[_v-3a71007d] {\n  position: absolute;\n  left: -200px;\n  width: 120px;\n  height: 2px;\n  background: url(\"/images/landing/shooting-star.png\") center center no-repeat;\n  background-size: 100% 100%;\n  transform: rotate(20deg);\n  top: 0;\n  left: 50%;\n  opacity: 0; }\n\n/* line 250, stdin */\n.shooting-star-1[_v-3a71007d] {\n  top: 149px;\n  animation: 25s shooting-star 10.8s infinite; }\n\n/* line 250, stdin */\n.shooting-star-2[_v-3a71007d] {\n  top: 130px;\n  animation: 24s shooting-star 8.6s infinite; }\n\n/* line 250, stdin */\n.shooting-star-3[_v-3a71007d] {\n  top: 183px;\n  animation: 24s shooting-star 17s infinite; }\n\n/* line 250, stdin */\n.shooting-star-4[_v-3a71007d] {\n  top: 71px;\n  animation: 25s shooting-star 1.5s infinite; }\n\n/* line 250, stdin */\n.shooting-star-5[_v-3a71007d] {\n  top: 47px;\n  animation: 23s shooting-star 19.3s infinite; }\n\n/* line 250, stdin */\n.shooting-star-6[_v-3a71007d] {\n  top: 55px;\n  animation: 24s shooting-star 6s infinite; }\n\n@media (max-width: 1440px) and (max-height: 768px) {\n  /* line 257, stdin */\n  .landing-content[_v-3a71007d] {\n    margin-top: 270px; }\n  /* line 261, stdin */\n  .top-curve-cover .rocket[_v-3a71007d] {\n    margin-right: 75px; } }\n\n@media (max-width: 992px) {\n  /* line 268, stdin */\n  .landing-content[_v-3a71007d] {\n    margin-top: 250px; }\n  /* line 271, stdin */\n  .uni-green[_v-3a71007d] {\n    left: -10px;\n    top: 150px; }\n  /* line 275, stdin */\n  .uni-red[_v-3a71007d] {\n    right: 10px; }\n  /* line 278, stdin */\n  .uni-star1[_v-3a71007d] {\n    left: 150px;\n    top: 350px; }\n  /* line 282, stdin */\n  .uni-dot1[_v-3a71007d] {\n    left: 250px;\n    top: 300px; }\n  /* line 287, stdin */\n  .banner-content .til[_v-3a71007d] {\n    font-size: 45px; }\n  /* line 290, stdin */\n  .banner-content .sub[_v-3a71007d] {\n    font-size: 16px; }\n  /* line 294, stdin */\n  .top-curve-cover[_v-3a71007d] {\n    height: 210px; }\n    /* line 296, stdin */\n    .top-curve-cover .rocket[_v-3a71007d] {\n      margin-right: 0; }\n  /* line 300, stdin */\n  .landing-contact[_v-3a71007d] {\n    background: url(https://blog.17fit.com/wp-content/uploads/2021/10/tablet-S6-biue-background.png) white;\n    background-repeat: no-repeat;\n    background-size: 100% auto; }\n    /* line 304, stdin */\n    .landing-contact .tx[_v-3a71007d] {\n      font-size: 36px; } }\n\n@media (max-width: 576px) {\n  /* line 311, stdin */\n  .hidden-on-mobile[_v-3a71007d] {\n    display: none !important; }\n  /* line 314, stdin */\n  .landing-content[_v-3a71007d] {\n    margin-top: 51px; }\n  /* line 317, stdin */\n  .landing-contact[_v-3a71007d] {\n    background: url(https://blog.17fit.com/wp-content/uploads/2021/10/Phone-S5-blue-background.png) white;\n    background-repeat: no-repeat;\n    background-size: 100% auto; }\n    /* line 321, stdin */\n    .landing-contact .tx[_v-3a71007d] {\n      font-size: 33px;\n      max-width: 288px; }\n  /* line 326, stdin */\n  .landing-fixed-header-bg[_v-3a71007d] {\n    top: 0;\n    height: 51px; }\n  /* line 330, stdin */\n  .landing-fixed-header[_v-3a71007d] {\n    height: 51px;\n    width: 100%;\n    position: fixed;\n    top: 0; }\n    /* line 335, stdin */\n    .landing-fixed-header .logo[_v-3a71007d] {\n      width: 93px;\n      margin-top: 0; }\n    /* line 339, stdin */\n    .landing-fixed-header .funcion-bar[_v-3a71007d] {\n      display: -ms-flexbox;\n      display: flex;\n      padding: 6px 0; }\n      /* line 343, stdin */\n      .landing-fixed-header .funcion-bar .btn-group a[_v-3a71007d] {\n        font-size: 16px;\n        width: 93px;\n        margin-top: 3px;\n        padding: 4px 0; }\n        /* line 348, stdin */\n        .landing-fixed-header .funcion-bar .btn-group a.create-store[_v-3a71007d] {\n          display: none; } }\n\n@keyframes fade-in {\n  0% {\n    opacity: 0; }\n  40% {\n    opacity: 0; }\n  50% {\n    opacity: .5; }\n  100% {\n    opacity: 1; } }\n\n@keyframes rocket-fly {\n  0% {\n    transform: translate(0, 0); }\n  10% {\n    transform: translate(-2px, 5px); }\n  30% {\n    transform: translate(0, 0); }\n  40% {\n    transform: translate(-2px, 5px); }\n  50% {\n    transform: translate(0, 0);\n    width: 245px;\n    height: auto; }\n  60% {\n    transform: translate(-100px, -120px);\n    width: 200px;\n    height: auto;\n    opacity: 1; }\n  100% {\n    transform: translate(-500px, -500px);\n    width: 50px;\n    height: auto;\n    opacity: 0; } }\n\n@keyframes brightness {\n  0%, 100% {\n    filter: brightness(none) blur(0px) hue-rotate(0deg) saturate(none); }\n  50% {\n    filter: brightness(10) blur(3px) hue-rotate(180deg) saturate(10); } }\n\n@keyframes glitter {\n  0% {\n    transform: scale(0.3) rotate(0deg);\n    opacity: 0; }\n  25% {\n    transform: scale(1) rotate(360deg);\n    opacity: 1; }\n  50% {\n    transform: scale(0.3) rotate(720deg);\n    opacity: 0; }\n  100% {\n    transform: scale(0.3) rotate(0deg);\n    opacity: 0; } }\n\n@keyframes bounce {\n  from {\n    transform: translate3d(0, 0, 0); }\n  to {\n    transform: translate3d(0, 10px, 0); } }\n\n@keyframes rotate {\n  from {\n    transform: rotate(0deg); }\n  to {\n    transform: rotate(360deg); } }\n\n@keyframes universe-bg-change {\n  0% {\n    background: #3b93ff; }\n  25% {\n    background: #2B7DD1; }\n  75% {\n    background: #18419A; }\n  100% {\n    background: #3b93ff; } }\n\n@keyframes shooting-star {\n  0% {\n    opacity: 0;\n    transform: translate(0, 0) rotate(20deg); }\n  15% {\n    opacity: 1;\n    transform: translate(800px, 250px) rotate(20deg); }\n  16%, 100% {\n    opacity: 0; } }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-3a71007d", module.exports)
  } else {
    hotAPI.update("_v-3a71007d", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],944:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 12, stdin */\n#branch-tabs[_v-d28ed16a] {\n  border-bottom: 1px solid #ccc;\n  margin-bottom: 20px;\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n  background: white;\n  z-index: 10; }\n  /* line 19, stdin */\n  #branch-tabs ul[_v-d28ed16a] {\n    margin-bottom: 0;\n    white-space: nowrap;\n    overflow-x: auto;\n    overflow-y: hidden;\n    display: -ms-inline-flexbox;\n    display: inline-flex; }\n    /* line 25, stdin */\n    #branch-tabs ul.tabs[_v-d28ed16a] {\n      border-bottom: none; }\n      /* line 27, stdin */\n      #branch-tabs ul.tabs li[_v-d28ed16a] {\n        width: auto;\n        display: inline; }\n        /* line 3, stdin */\n        #branch-tabs ul.tabs li[_v-d28ed16a]:hover::after {\n          content: '';\n          display: block;\n          width: 100%;\n          height: 3px;\n          background: var(--tab-theme-color);\n          border-radius: 100px 100px 0px 0px; }\n        /* line 33, stdin */\n        #branch-tabs ul.tabs li a[_v-d28ed16a] {\n          color: #92929D;\n          font-size: 18px;\n          font-weight: 500;\n          transition: 0.2s bottom ease-in-out;\n          border: none;\n          padding: 8px 22px;\n          display: inline-block; }\n          /* line 41, stdin */\n          #branch-tabs ul.tabs li a[_v-d28ed16a]:hover {\n            border: none;\n            color: var(--tab-theme-color);\n            bottom: 0; }\n        /* line 3, stdin */\n        #branch-tabs ul.tabs li.on[_v-d28ed16a]::after {\n          content: '';\n          display: block;\n          width: 100%;\n          height: 3px;\n          background: var(--tab-theme-color);\n          border-radius: 100px 100px 0px 0px; }\n        /* line 49, stdin */\n        #branch-tabs ul.tabs li.on a[_v-d28ed16a] {\n          color: var(--tab-theme-color); }\n  @media screen and (max-width: 768px) {\n    /* line 12, stdin */\n    #branch-tabs[_v-d28ed16a] {\n      top: 54px; } }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['studio', 'webstudioBusinessColor', 'isWebsutdio', 'isShowRating', 'currentTab', 'selectTab'],
    data: function data() {
        return {
            brandColor: '#38b0e3'
        };
    },
    mounted: function mounted() {
        if (this.isWebsutdio) {
            var isSet = this.webstudioBusinessColor ? true : false;
            var isWhite = this.webstudioBusinessColor.match(/^(?:white|#fff(?:fff)?|rgba?\(\s*255\s*,\s*255\s*,\s*255\s*(?:,\s*1\s*)?\))$/i);
            this.brandColor = isSet && !isWhite ? '#' + this.webstudioBusinessColor : '#38b0e3';
        } else {
            this.brandColor = '#38b0e3';
        }
    },

    computed: {},
    methods: {
        tabOn: function tabOn(tab) {
            return tab == this.currentTab ? 'on' : '';
        },
        changeTab: function changeTab(tab) {
            this.selectTab && this.selectTab(tab);
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div id=\"branch-tabs\" _v-d28ed16a=\"\">\n    <ul class=\"tabs primary-business-color-border\" :style=\"{'--tab-theme-color': brandColor}\" _v-d28ed16a=\"\">\n        <li v-if=\"studio.class_base\" :class=\"tabOn('class-view')\" _v-d28ed16a=\"\">\n            <a @click=\"changeTab('class-view')\" _v-d28ed16a=\"\">{{i18n.t('general.class')}}</a>\n        </li>\n        <li v-if=\"studio.service_base\" :class=\"tabOn('service-view')\" _v-d28ed16a=\"\">\n            <a @click=\"changeTab('service-view')\" _v-d28ed16a=\"\">\n                {{i18n.t('general.service')}}\n            </a>\n        </li>\n        <li :class=\"tabOn('contract-view')\" _v-d28ed16a=\"\">\n            <a @click=\"changeTab('contract-view')\" _v-d28ed16a=\"\">\n                {{i18n.t('general.contract')}}\n            </a>\n        </li>\n        <li :class=\"tabOn('staff-view')\" _v-d28ed16a=\"\">\n            <a @click=\"changeTab('staff-view')\" _v-d28ed16a=\"\">\n                {{i18n.t('general.staff')}}\n            </a>\n        </li>\n        <li :class=\"tabOn('rating-comments')\" v-if=\"isShowRating\" _v-d28ed16a=\"\">\n            <a @click=\"changeTab('rating-comments')\" _v-d28ed16a=\"\">\n                {{i18n.t('general.rating')}}\n            </a>\n        </li>\n        <li :class=\"tabOn('branch-intro')\" class=\"sbig-hidden\" _v-d28ed16a=\"\">\n            <a @click=\"changeTab('branch-intro')\" _v-d28ed16a=\"\">\n                {{i18n.t('general.info')}}\n            </a>\n        </li>\n    </ul>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 12, stdin */\n#branch-tabs[_v-d28ed16a] {\n  border-bottom: 1px solid #ccc;\n  margin-bottom: 20px;\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n  background: white;\n  z-index: 10; }\n  /* line 19, stdin */\n  #branch-tabs ul[_v-d28ed16a] {\n    margin-bottom: 0;\n    white-space: nowrap;\n    overflow-x: auto;\n    overflow-y: hidden;\n    display: -ms-inline-flexbox;\n    display: inline-flex; }\n    /* line 25, stdin */\n    #branch-tabs ul.tabs[_v-d28ed16a] {\n      border-bottom: none; }\n      /* line 27, stdin */\n      #branch-tabs ul.tabs li[_v-d28ed16a] {\n        width: auto;\n        display: inline; }\n        /* line 3, stdin */\n        #branch-tabs ul.tabs li[_v-d28ed16a]:hover::after {\n          content: '';\n          display: block;\n          width: 100%;\n          height: 3px;\n          background: var(--tab-theme-color);\n          border-radius: 100px 100px 0px 0px; }\n        /* line 33, stdin */\n        #branch-tabs ul.tabs li a[_v-d28ed16a] {\n          color: #92929D;\n          font-size: 18px;\n          font-weight: 500;\n          transition: 0.2s bottom ease-in-out;\n          border: none;\n          padding: 8px 22px;\n          display: inline-block; }\n          /* line 41, stdin */\n          #branch-tabs ul.tabs li a[_v-d28ed16a]:hover {\n            border: none;\n            color: var(--tab-theme-color);\n            bottom: 0; }\n        /* line 3, stdin */\n        #branch-tabs ul.tabs li.on[_v-d28ed16a]::after {\n          content: '';\n          display: block;\n          width: 100%;\n          height: 3px;\n          background: var(--tab-theme-color);\n          border-radius: 100px 100px 0px 0px; }\n        /* line 49, stdin */\n        #branch-tabs ul.tabs li.on a[_v-d28ed16a] {\n          color: var(--tab-theme-color); }\n  @media screen and (max-width: 768px) {\n    /* line 12, stdin */\n    #branch-tabs[_v-d28ed16a] {\n      top: 54px; } }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-d28ed16a", module.exports)
  } else {
    hotAPI.update("_v-d28ed16a", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],945:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _branch_tabs = require('./branch_tabs.vue');

var _branch_tabs2 = _interopRequireDefault(_branch_tabs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('v-branch-tab', _branch_tabs2.default);

},{"./branch_tabs.vue":944,"vue":792}],946:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _redirect = require('./redirect.vue');

var _redirect2 = _interopRequireDefault(_redirect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('live-stream-redirect', _redirect2.default);

},{"./redirect.vue":947,"vue":792}],947:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("@charset \"UTF-8\";\n/* line 2, stdin */\n.live-redirect-container[_v-7059081f] {\n  background: url(\"https://blog.17fit.com/wp-content/uploads/2021/10/stream_bg.png\") no-repeat top;\n  background-size: cover;\n  height: 100vh;\n  padding-bottom: 80px;\n  padding-top: 80px;\n  color: #ffffff; }\n  /* line 9, stdin */\n  .live-redirect-container .row[_v-7059081f] {\n    margin: 0 auto;\n    height: 85vh;\n    overflow: scroll; }\n  /* line 14, stdin */\n  .live-redirect-container .flex-end[_v-7059081f] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: end;\n        justify-content: flex-end; }\n  /* line 18, stdin */\n  .live-redirect-container .content[_v-7059081f] {\n    max-width: 440px;\n    width: 100%;\n    margin-right: 25px;\n    font-size: 18px; }\n    /* line 23, stdin */\n    .live-redirect-container .content i[_v-7059081f] {\n      color: #ffffff; }\n    /* line 26, stdin */\n    .live-redirect-container .content label[_v-7059081f] {\n      font-size: 16px;\n      color: #ffffff; }\n    /* line 30, stdin */\n    .live-redirect-container .content input[_v-7059081f] {\n      color: #000; }\n    /* line 33, stdin */\n    .live-redirect-container .content .title[_v-7059081f] {\n      font-size: 40px; }\n    /* line 36, stdin */\n    .live-redirect-container .content .note[_v-7059081f], .live-redirect-container .content .link[_v-7059081f] {\n      margin: 30px auto 40px auto; }\n    /* line 39, stdin */\n    .live-redirect-container .content .btn-trsparent[_v-7059081f] {\n      background-color: transparent;\n      border: 1px solid #ffffff; }\n    /* line 43, stdin */\n    .live-redirect-container .content .description[_v-7059081f] {\n      white-space: pre-wrap; }\n  /* line 47, stdin */\n  .live-redirect-container .white-card[_v-7059081f] {\n    margin-left: 25px;\n    background: #FFFFFF;\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.08);\n    border-radius: 20px;\n    width: 312px;\n    color: #000;\n    font-size: 16px;\n    padding: 24px; }\n    /* line 56, stdin */\n    .live-redirect-container .white-card div[_v-7059081f] {\n      margin-bottom: 24px; }\n  /* line 60, stdin */\n  .live-redirect-container .by-17FIT div[_v-7059081f] {\n    position: fixed;\n    bottom: 30px;\n    display: block;\n    width: 100%;\n    text-align: center;\n    font-size: 18px; }\n  @media screen and (max-width: 767px) {\n    /* line 2, stdin */\n    .live-redirect-container[_v-7059081f] {\n      padding-top: 50px; }\n      /* line 71, stdin */\n      .live-redirect-container .content[_v-7059081f], .live-redirect-container .white-card[_v-7059081f] {\n        margin: 20px auto;\n        max-width: 440px;\n        width: 100%; }\n        /* line 75, stdin */\n        .live-redirect-container .content .icon[_v-7059081f], .live-redirect-container .content .title[_v-7059081f], .live-redirect-container .content .button[_v-7059081f], .live-redirect-container .white-card .icon[_v-7059081f], .live-redirect-container .white-card .title[_v-7059081f], .live-redirect-container .white-card .button[_v-7059081f] {\n          text-align: center; } }\n  @media screen and (max-width: 414px) {\n    /* line 2, stdin */\n    .live-redirect-container[_v-7059081f] {\n      background: url(\"https://blog.17fit.com/wp-content/uploads/2021/06/Mobile_已建立直播連結.png\") no-repeat top;\n      background-size: cover; } }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    data: function data() {
        return {
            ajaxing: false,
            url: '',
            state: 'on_going',
            icon: '',
            data: {},
            voucherId: null
        };
    },

    watch: {},
    computed: {
        title: function title() {
            switch (this.state) {
                case 'not_start':
                    return '目前還不是上課時間唷！';
                    break;
                case 'waiting':
                    return '正在等待店家建立直播連結...';
                    break;
                case 'not_live':
                    return '此課程未開啟直播功能';
                    break;
                case 'done':
                    return '課程已結束';
                    break;
                case 'on_going':
                    return '已建立直播連結';
                    break;
                default:
                    return '發生錯誤，請重新嘗試！';
            }
        },
        note: function note() {
            switch (this.state) {
                case 'not_start':
                    this.icon = 'fa-clock-o';
                    return '請於距上課時間30分鐘內重新整理網頁，如果場館已經建立直播連結，將會顯示。';
                    break;
                case 'waiting':
                    this.icon = 'fa-ellipsis-h';
                    return '請於上課時間內重新整理網頁，如果場館已經建立直播連結，將會顯示。';
                    break;
                case 'on_going':
                    this.icon = 'fa-video-camera';
                    return '';
                    break;
                default:
                    this.icon = 'fa-exclamation-circle';
                    return '請洽詢開課場館。';
            }
        },
        showDescription: function showDescription() {
            return this.state == 'not_start' || this.state == 'waiting' || this.state == 'on_going';
        },
        showLink: function showLink() {
            return this.state == 'on_going';
        },
        isLive: function isLive() {
            return this.state !== 'not_live';
        }
    },
    mounted: function mounted() {
        this.fetchData();
    },

    methods: {
        fetchData: function fetchData() {
            var _this = this;

            this.ajaxing = true;
            var q = this.queryString();
            if (!q.hasOwnProperty('code')) {
                this.state = 'error';
                return;
            }
            this.$http.get('/webapi/booking-redirect?code=' + q.code).then(function (response) {
                _this.data = response.data;
                _this.state = _this.data.state;
                _this.url = _this.data.live_link;
                _this.ajaxing = false;
            }, function (error) {
                _this.ajaxing = false;
            });
        },
        openLink: function openLink() {
            window.open(this.url, '_blank');
        },
        copyLink: function copyLink() {
            if (navigator.clipboard) {
                navigator.clipboard.writeText(this.url);
                $.notify('複製成功', { position: "top center", className: "success" });
            } else {
                $.notify('複製失敗', { position: "top center", className: "error" });
            }
        },
        openQrcode: function openQrcode(bookingId) {
            this.voucherId = bookingId;
            $('#voucher-modal').modal('show');
        },
        queryString: function queryString() {
            var queryString = {};
            var query = window.location.search.substring(1);
            var vars = query.split("&");
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split("=");
                if (typeof queryString[pair[0]] === "undefined") {
                    queryString[pair[0]] = pair[1];
                } else if (typeof queryString[pair[0]] === "string") {
                    var arr = [queryString[pair[0]], pair[1]];
                    queryString[pair[0]] = arr;
                } else {
                    queryString[pair[0]].push(pair[1]);
                }
            }
            return queryString;
        },
        timeFormat: function timeFormat(date, time) {
            return moment(date + ' ' + time).format('YYYY-MM-DD HH:mm');
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"live-redirect-container\" _v-7059081f=\"\">\n    <v-spinner :ajaxing=\"ajaxing\" _v-7059081f=\"\"></v-spinner>\n   <div class=\"row\" v-show=\"!ajaxing\" _v-7059081f=\"\">\n       <div class=\"col-sm-6 col-xs-12 flex-end\" _v-7059081f=\"\">\n           <div class=\"content\" _v-7059081f=\"\">\n               <div class=\"icon\" _v-7059081f=\"\"><i class=\"fa fa-4x\" :class=\"icon\" _v-7059081f=\"\"></i></div>\n               <div class=\"title\" _v-7059081f=\"\"><b _v-7059081f=\"\">{{ title }}</b></div>\n               <div class=\"note\" v-show=\"note\" _v-7059081f=\"\">{{ note }}</div>\n               <div class=\"link\" v-if=\"showLink\" _v-7059081f=\"\">\n                   <label _v-7059081f=\"\">直播連結</label>\n                   <input type=\"text\" v-model=\"url\" readonly=\"\" _v-7059081f=\"\">\n                   <div class=\"button\" _v-7059081f=\"\">\n                       <button class=\"btn btn-primary btn--inverse\" @click=\"openLink\" _v-7059081f=\"\">開啟連結</button>\n                       <button class=\"btn btn-primary btn-trsparent\" @click=\"copyLink\" _v-7059081f=\"\">複製連結</button>\n                   </div>\n               </div>\n               <div v-if=\"!isLive\" _v-7059081f=\"\">\n                   <button class=\"btn btn-primary btn--inverse\" @click=\"openQrcode(data.booking_id)\" _v-7059081f=\"\">上課憑證</button>\n               </div>\n               <div class=\"description\" v-if=\"showDescription\" _v-7059081f=\"\">\n                   <b v-show=\"data.description\" _v-7059081f=\"\">額外說明：</b>\n                   <div _v-7059081f=\"\">{{ data.description }}</div>\n               </div>\n           </div>\n       </div>\n       <div class=\"col-sm-6 col-xs-12\" _v-7059081f=\"\">\n           <div class=\"white-card\" _v-7059081f=\"\">\n               <b _v-7059081f=\"\">課程名稱</b>\n               <div _v-7059081f=\"\">{{ data.schedule_name }}</div>\n               <b _v-7059081f=\"\">開始時間</b>\n               <div _v-7059081f=\"\">{{ timeFormat(data.date, data.start_time) }}</div>\n               <b _v-7059081f=\"\">人員</b>\n               <div _v-7059081f=\"\">{{ data.sp_nick_name?data.sp_nick_name:data.sp_name }}</div>\n               <b _v-7059081f=\"\">場館</b>\n               <div _v-7059081f=\"\">{{ data.branch_name }}</div>\n           </div>\n       </div>\n   </div>\n   <div class=\"by-17FIT\" _v-7059081f=\"\">\n       <div _v-7059081f=\"\">由<span _v-7059081f=\"\"><img src=\"/images/17fit-logo-white.svg\" width=\"66px\" _v-7059081f=\"\"></span>提供支援</div>\n   </div>\n   <voucher-modal :id=\"voucherId\" _v-7059081f=\"\"></voucher-modal>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["@charset \"UTF-8\";\n/* line 2, stdin */\n.live-redirect-container[_v-7059081f] {\n  background: url(\"https://blog.17fit.com/wp-content/uploads/2021/10/stream_bg.png\") no-repeat top;\n  background-size: cover;\n  height: 100vh;\n  padding-bottom: 80px;\n  padding-top: 80px;\n  color: #ffffff; }\n  /* line 9, stdin */\n  .live-redirect-container .row[_v-7059081f] {\n    margin: 0 auto;\n    height: 85vh;\n    overflow: scroll; }\n  /* line 14, stdin */\n  .live-redirect-container .flex-end[_v-7059081f] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: end;\n        justify-content: flex-end; }\n  /* line 18, stdin */\n  .live-redirect-container .content[_v-7059081f] {\n    max-width: 440px;\n    width: 100%;\n    margin-right: 25px;\n    font-size: 18px; }\n    /* line 23, stdin */\n    .live-redirect-container .content i[_v-7059081f] {\n      color: #ffffff; }\n    /* line 26, stdin */\n    .live-redirect-container .content label[_v-7059081f] {\n      font-size: 16px;\n      color: #ffffff; }\n    /* line 30, stdin */\n    .live-redirect-container .content input[_v-7059081f] {\n      color: #000; }\n    /* line 33, stdin */\n    .live-redirect-container .content .title[_v-7059081f] {\n      font-size: 40px; }\n    /* line 36, stdin */\n    .live-redirect-container .content .note[_v-7059081f], .live-redirect-container .content .link[_v-7059081f] {\n      margin: 30px auto 40px auto; }\n    /* line 39, stdin */\n    .live-redirect-container .content .btn-trsparent[_v-7059081f] {\n      background-color: transparent;\n      border: 1px solid #ffffff; }\n    /* line 43, stdin */\n    .live-redirect-container .content .description[_v-7059081f] {\n      white-space: pre-wrap; }\n  /* line 47, stdin */\n  .live-redirect-container .white-card[_v-7059081f] {\n    margin-left: 25px;\n    background: #FFFFFF;\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.08);\n    border-radius: 20px;\n    width: 312px;\n    color: #000;\n    font-size: 16px;\n    padding: 24px; }\n    /* line 56, stdin */\n    .live-redirect-container .white-card div[_v-7059081f] {\n      margin-bottom: 24px; }\n  /* line 60, stdin */\n  .live-redirect-container .by-17FIT div[_v-7059081f] {\n    position: fixed;\n    bottom: 30px;\n    display: block;\n    width: 100%;\n    text-align: center;\n    font-size: 18px; }\n  @media screen and (max-width: 767px) {\n    /* line 2, stdin */\n    .live-redirect-container[_v-7059081f] {\n      padding-top: 50px; }\n      /* line 71, stdin */\n      .live-redirect-container .content[_v-7059081f], .live-redirect-container .white-card[_v-7059081f] {\n        margin: 20px auto;\n        max-width: 440px;\n        width: 100%; }\n        /* line 75, stdin */\n        .live-redirect-container .content .icon[_v-7059081f], .live-redirect-container .content .title[_v-7059081f], .live-redirect-container .content .button[_v-7059081f], .live-redirect-container .white-card .icon[_v-7059081f], .live-redirect-container .white-card .title[_v-7059081f], .live-redirect-container .white-card .button[_v-7059081f] {\n          text-align: center; } }\n  @media screen and (max-width: 414px) {\n    /* line 2, stdin */\n    .live-redirect-container[_v-7059081f] {\n      background: url(\"https://blog.17fit.com/wp-content/uploads/2021/06/Mobile_已建立直播連結.png\") no-repeat top;\n      background-size: cover; } }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-7059081f", module.exports)
  } else {
    hotAPI.update("_v-7059081f", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],948:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _languageSwitchFooter = require('../account-service/partials/language-switch-footer.vue');

var _languageSwitchFooter2 = _interopRequireDefault(_languageSwitchFooter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        'language-switch-footer': _languageSwitchFooter2.default
    },
    data: function data() {
        return {
            detail: null,
            login_info: null,
            ajaxing: true
        };
    },
    mounted: function mounted() {
        this.getTokenDetail();
    },

    methods: {
        confirm: function confirm() {
            var payload = {
                studio_member_id: this.detail.studio_member.id,
                member_id: this.detail.seventeen_member.id
            };

            this.ajaxing = true;
            this.$http.post('/webapi/member-link/linking', payload).then(function (response) {
                var login_info = response.data.data;
                var token = login_info.token;
                var subdomain = login_info.subdomain ? login_info.subdomain : '';

                window.location.href = '//' + window.location.host + '/member-link/success?token=' + token + '&subdomain=' + subdomain;
            }, function (error) {
                var errCode = error.body.code ? error.body.code : '1M0000';
                window.location.href = '//' + window.location.host + '/member-link/fail?auth_result=fail&auth_error_code=' + errCode;
            });
        },
        getTokenDetail: function getTokenDetail() {
            var _this = this;

            var urlParams = new URLSearchParams(window.location.search);
            var token = urlParams.get('token');
            var studioMemberId = urlParams.get('studio_member_id');

            var payload = {
                params: {
                    token: token,
                    studio_member_id: studioMemberId
                }
            };

            this.ajaxing = true;
            this.$http.get('/webapi/member-link/jwt-detail', payload).then(function (response) {
                _this.detail = response.data.data;
                _this.ajaxing = false;
            }, function (error) {
                var errCode = error.body.code ? error.body.code : '1M0000';
                window.location.href = '//' + window.location.host + '/member-link/fail?auth_result=fail&auth_error_code=' + errCode;
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"st-h-screen st-flex st-flex-col\" _v-669b0a19=\"\">\n    <div class=\"st-mx-auto st-max-w-sm st-w-full st-px-3.5 st-overflow-auto st-flex-grow\" _v-669b0a19=\"\">\n        <v-spinner :ajaxing=\"ajaxing\" _v-669b0a19=\"\"></v-spinner>\n        <div v-show=\"!ajaxing\" _v-669b0a19=\"\">\n            <div class=\"st-space-y-7 st-pt-7\" _v-669b0a19=\"\">\n                <template v-if=\"detail\">\n                    <div class=\"st-text-24 st-text-black st-font-medium\" _v-669b0a19=\"\">確認連結資訊</div>\n\n                    <div class=\"st-flex st-justify-center st-items-center st-flex-col\" _v-669b0a19=\"\">\n                        <div class=\"st-flex st-justify-center st-items-center st-flex-col\" _v-669b0a19=\"\">\n                            <img v-if=\"detail.seventeen_member.picture_path\" :src=\"detail.seventeen_member.picture_path\" class=\"st-border st-border-gray-40 st-border-solid\" style=\"border-radius: 50%\" width=\"84\" height=\"84\" alt=\"avatar\" _v-669b0a19=\"\">\n                            <div class=\"st-mt-3 st-text-18 st-text-black\" _v-669b0a19=\"\">{{ detail.seventeen_member.name }}</div>\n                            <div class=\"st-mt-2 st-text-16\" _v-669b0a19=\"\">{{ detail.seventeen_member.account }}</div>\n                        </div>\n                    </div>\n\n                    <div class=\"st-flex st-items-center\" _v-669b0a19=\"\">\n                        <div class=\"st-w-full st-h-px st-bg-gray-40\" _v-669b0a19=\"\"></div>\n                        <div class=\"st-mx-3 st-text-16 st-text-gray-90\" _v-669b0a19=\"\"><span class=\"material-icons\" _v-669b0a19=\"\">sync</span></div>\n                        <div class=\"st-w-full st-h-px st-bg-gray-40\" _v-669b0a19=\"\"></div>\n                    </div>\n\n                    <div _v-669b0a19=\"\">\n                        <div class=\"st-text-16 st-text-black\" _v-669b0a19=\"\">您在 {{ detail.brand_name }} 的資訊</div>\n                        <div class=\"st-mt-2 st-rounded-4 st-p-3.5 st-space-y-2 st-text-14 st-text-gray-90 st-bg-gray-20\" _v-669b0a19=\"\">\n                            <div class=\"st-flex st-items-center\" _v-669b0a19=\"\">\n                                <span class=\"material-icons st-pr-2\" _v-669b0a19=\"\">person</span>\n                                {{ detail.studio_member.name ? detail.studio_member.name : '-' }}\n                            </div>\n                            <div class=\"st-flex st-items-center\" _v-669b0a19=\"\">\n                                <span class=\"material-icons st-pr-2\" _v-669b0a19=\"\">smartphone</span>\n                                {{ detail.studio_member.phone ? detail.studio_member.phone : '-' }}\n                            </div>\n                            <div class=\"st-flex st-items-center\" _v-669b0a19=\"\">\n                                <span class=\"material-icons st-pr-2\" _v-669b0a19=\"\">mail</span>\n                                {{ detail.studio_member.email ? detail.studio_member.email : '-' }}\n                            </div>\n                        </div>\n                    </div>\n\n                    <st-button primary=\"\" full=\"\" filled=\"\" text=\"確認連結\" @click=\"confirm\" _v-669b0a19=\"\"></st-button>\n                </template>\n            </div>\n        </div>\n    </div>\n    <div class=\"st-mx-auto st-max-w-sm st-w-full st-px-3.5\" _v-669b0a19=\"\">\n        <language-switch-footer page-name=\"17FIT 技術支援\" _v-669b0a19=\"\"></language-switch-footer>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-669b0a19", module.exports)
  } else {
    hotAPI.update("_v-669b0a19", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"../account-service/partials/language-switch-footer.vue":885,"vue":792,"vue-hot-reload-api":785}],949:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _languageSwitchFooter = require('../account-service/partials/language-switch-footer.vue');

var _languageSwitchFooter2 = _interopRequireDefault(_languageSwitchFooter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        'language-switch-footer': _languageSwitchFooter2.default
    },
    data: function data() {
        return {
            ajaxing: false,
            message: ''
        };
    },
    mounted: function mounted() {
        this.init();
    },

    methods: {
        init: function init() {
            var urlParams = new URLSearchParams(window.location.search);
            var errCode = urlParams.get('auth_error_code');
            this.message = errCode && this.$errorIdentifiable.includes(errCode) ? i18n.t('error.msg.' + errCode) : '發生不明錯誤，請重新嘗試';
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"st-h-screen st-flex st-flex-col\" _v-21ef9995=\"\">\n    <div class=\"st-mx-auto st-max-w-sm st-w-full st-px-3.5 st-overflow-auto st-flex-grow\" _v-21ef9995=\"\">\n        <v-spinner :ajaxing=\"ajaxing\" _v-21ef9995=\"\"></v-spinner>\n        <div v-show=\"!ajaxing\" _v-21ef9995=\"\">\n            <div class=\"st-space-y-7\" _v-21ef9995=\"\">\n                <div class=\"st-flex st-justify-center st-items-center st-flex-col\" _v-21ef9995=\"\">\n                    <div class=\"st-flex st-justify-center st-items-center\" style=\"width: 190px;height: 190px;\" _v-21ef9995=\"\">\n                        <img src=\"/images/status/fail_circle.svg\" alt=\"fail\" class=\"st-my-10\" _v-21ef9995=\"\">\n                    </div>\n                    <div class=\"st-text-24 st-text-black st-font-medium\" _v-21ef9995=\"\">連結失敗</div>\n                    <div class=\"st-mt-7 st-text-16 st-text-gray-90\" _v-21ef9995=\"\">{{ message }}</div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"st-mx-auto st-max-w-sm st-w-full st-px-3.5\" _v-21ef9995=\"\">\n        <language-switch-footer page-name=\"17FIT 技術支援\" _v-21ef9995=\"\"></language-switch-footer>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-21ef9995", module.exports)
  } else {
    hotAPI.update("_v-21ef9995", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"../account-service/partials/language-switch-footer.vue":885,"vue":792,"vue-hot-reload-api":785}],950:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _invite = require('./invite.vue');

var _invite2 = _interopRequireDefault(_invite);

var _confirm = require('./confirm.vue');

var _confirm2 = _interopRequireDefault(_confirm);

var _success = require('./success.vue');

var _success2 = _interopRequireDefault(_success);

var _fail = require('./fail.vue');

var _fail2 = _interopRequireDefault(_fail);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('member-link-invite', _invite2.default);
_vue2.default.component('member-link-confirm', _confirm2.default);
_vue2.default.component('member-link-success', _success2.default);
_vue2.default.component('member-link-fail', _fail2.default);

},{"./confirm.vue":948,"./fail.vue":949,"./invite.vue":951,"./success.vue":952,"vue":792}],951:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _languageSwitchFooter = require('../account-service/partials/language-switch-footer.vue');

var _languageSwitchFooter2 = _interopRequireDefault(_languageSwitchFooter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        'language-switch-footer': _languageSwitchFooter2.default
    },
    data: function data() {
        return {
            detail: null,
            ajaxing: false
        };
    },
    mounted: function mounted() {
        this.getTokenDetail();
    },

    methods: {
        link: function link() {
            var urlParams = new URLSearchParams(window.location.search);
            var token = urlParams.get('member_link_token');
            var successUrl = location.origin + '/member-link/confirm?studio_member_id=' + this.detail.studio_member.id;
            return window.location.href = '/account?success_url=' + successUrl + '&cancel_url=' + location.origin + '/member-link/invite?member_link_token=' + token + '&show_fb=1';
        },
        getTokenDetail: function getTokenDetail() {
            var _this = this;

            var urlParams = new URLSearchParams(window.location.search);
            var token = urlParams.get('member_link_token');

            var payload = {
                params: {
                    member_link_token: token
                }
            };

            this.ajaxing = true;
            this.$http.get('/webapi/member-link/detail', payload).then(function (response) {
                _this.detail = response.data.data;
                _this.ajaxing = false;
            }, function (error) {
                window.location.href = '//' + window.location.host + '/member-link/fail';
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"st-h-screen st-flex st-flex-col\" _v-32346f80=\"\">\n    <div class=\"st-mx-auto st-max-w-sm st-w-full st-px-3.5 st-overflow-auto st-flex-grow\" _v-32346f80=\"\">\n        <v-spinner :ajaxing=\"ajaxing\" _v-32346f80=\"\"></v-spinner>\n        <div v-show=\"!ajaxing\" _v-32346f80=\"\">\n            <div class=\"st-space-y-7 st-pt-7\" _v-32346f80=\"\">\n                <img src=\"/images/invite/link.png\" class=\"st-w-full\" alt=\"link\" _v-32346f80=\"\">\n\n                <template v-if=\"detail\">\n                    <div _v-32346f80=\"\">\n                        <div class=\"st-text-24 st-text-black st-font-medium\" _v-32346f80=\"\">連結帳戶</div>\n                        <div class=\"st-text-16 st-mt-3.5\" _v-32346f80=\"\">\n                            <div _v-32346f80=\"\">{{ detail.brand_name }} 使用 17FIT 線上預約平台。</div>\n                            <div _v-32346f80=\"\">點擊以下按鈕完成帳戶連結程序。</div>\n                        </div>\n                    </div>\n\n\n                    <div class=\"st-w-full st-h-px st-bg-gray-40\" _v-32346f80=\"\"></div>\n\n                    <div class=\"st-flex st-items-center st-text-16 st-text-black\" _v-32346f80=\"\">\n                        <span class=\"material-icons st-pr-1\" _v-32346f80=\"\">info</span>\n                        請確認您在 {{ detail.brand_name }} 的資訊\n                    </div>\n\n                    <div _v-32346f80=\"\">\n                        <div class=\"st-mt-2 st-rounded-4 st-p-3.5 st-space-y-2 st-text-14 st-text-gray-90 st-bg-gray-20\" _v-32346f80=\"\">\n                            <div class=\"st-flex st-items-center\" _v-32346f80=\"\">\n                                <span class=\"material-icons st-pr-2\" _v-32346f80=\"\">person</span>\n                                {{ detail.studio_member.name ? detail.studio_member.name : '-' }}\n                            </div>\n                            <div class=\"st-flex st-items-center\" _v-32346f80=\"\">\n                                <span class=\"material-icons st-pr-2\" _v-32346f80=\"\">smartphone</span>\n                                {{ detail.studio_member.phone ? detail.studio_member.phone : '-' }}\n                            </div>\n                            <div class=\"st-flex st-items-center\" _v-32346f80=\"\">\n                                <span class=\"material-icons st-pr-2\" _v-32346f80=\"\">mail</span>\n                                {{ detail.studio_member.email ? detail.studio_member.email : '-' }}\n                            </div>\n                        </div>\n                    </div>\n\n                    <st-button primary=\"\" full=\"\" filled=\"\" text=\"開始連結帳戶\" @click=\"link\" _v-32346f80=\"\"></st-button>\n                </template>\n            </div>\n        </div>\n    </div>\n    <div class=\"st-mx-auto st-max-w-sm st-w-full st-px-3.5\" _v-32346f80=\"\">\n        <language-switch-footer page-name=\"17FIT 技術支援\" _v-32346f80=\"\"></language-switch-footer>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-32346f80", module.exports)
  } else {
    hotAPI.update("_v-32346f80", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"../account-service/partials/language-switch-footer.vue":885,"vue":792,"vue-hot-reload-api":785}],952:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _languageSwitchFooter = require('../account-service/partials/language-switch-footer.vue');

var _languageSwitchFooter2 = _interopRequireDefault(_languageSwitchFooter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        'language-switch-footer': _languageSwitchFooter2.default
    },
    data: function data() {
        return {
            subdomain: null,
            token: null,
            ajaxing: false
        };
    },
    mounted: function mounted() {
        this.init();
    },

    methods: {
        init: function init() {
            var urlParams = new URLSearchParams(window.location.search);
            this.token = urlParams.get('token');
            this.subdomain = urlParams.get('subdomain');
        },
        toWebStudio: function toWebStudio() {
            var successUrl = '/studios';
            var failUrl = '/studios';

            var href = window.location.hostname + '/authorization/jwt?token=' + this.token + '&success_url=' + successUrl + '&fail_url=' + failUrl;

            if (this.subdomain) {
                href = this.subdomain + '.' + href;
            }

            return window.location.replace('//' + href);
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"st-h-screen st-flex st-flex-col\" _v-067b09dc=\"\">\n    <div class=\"st-mx-auto st-max-w-sm st-w-full st-px-3.5 st-overflow-auto st-flex-grow\" _v-067b09dc=\"\">\n        <v-spinner :ajaxing=\"ajaxing\" _v-067b09dc=\"\"></v-spinner>\n        <div v-show=\"!ajaxing\" _v-067b09dc=\"\">\n            <div class=\"st-space-y-7\" _v-067b09dc=\"\">\n                <div class=\"st-flex st-justify-center st-items-center st-flex-col\" _v-067b09dc=\"\">\n                    <lottie-player src=\"/images/status/lottie/success_circle.json\" background=\"transparent\" speed=\"1\" direction=\"1\" mode=\"normal\" style=\"width: 190px; height: auto\" autoplay=\"\" _v-067b09dc=\"\"></lottie-player>\n                    <div class=\"st-text-24 st-text-black st-font-medium\" _v-067b09dc=\"\">連結成功</div>\n                    <div class=\"st-mt-7 st-text-16 st-text-gray-90\" _v-067b09dc=\"\">您已可以使用 17FIT 相關服務</div>\n                </div>\n                <div _v-067b09dc=\"\">\n                    <st-button v-if=\"subdomain\" primary=\"\" full=\"\" filled=\"\" text=\"前往品牌網站\" @click=\"toWebStudio\" _v-067b09dc=\"\"></st-button>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"st-mx-auto st-max-w-sm st-w-full st-px-3.5\" _v-067b09dc=\"\">\n        <language-switch-footer page-name=\"17FIT 技術支援\" _v-067b09dc=\"\"></language-switch-footer>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-067b09dc", module.exports)
  } else {
    hotAPI.update("_v-067b09dc", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"../account-service/partials/language-switch-footer.vue":885,"vue":792,"vue-hot-reload-api":785}],953:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.transfer-group[_v-438d9d08] {\n  margin-bottom: 24px; }\n  /* line 4, stdin */\n  .transfer-group .code-title[_v-438d9d08] {\n    color: #28b0e3;\n    font-size: 18px; }\n  /* line 8, stdin */\n  .transfer-group .success-title[_v-438d9d08] {\n    color: #111827;\n    font-weight: bold;\n    font-size: 18px; }\n  /* line 13, stdin */\n  .transfer-group .mleft[_v-438d9d08] {\n    margin-left: 24px; }\n  /* line 16, stdin */\n  .transfer-group .alert[_v-438d9d08] {\n    margin-left: 24px;\n    margin-right: 24px; }\n\n/* line 21, stdin */\n.code-block[_v-438d9d08] {\n  font-size: 40px;\n  font-weight: 900; }\n  /* line 24, stdin */\n  .code-block textarea[_v-438d9d08] {\n    margin-bottom: 0px; }\n  /* line 27, stdin */\n  .code-block .error-message[_v-438d9d08] {\n    font-size: 14px; }\n\n/* line 31, stdin */\n.error-message[_v-438d9d08] {\n  color: red; }\n\n/* line 34, stdin */\n.check[_v-438d9d08] {\n  font-size: 90px;\n  color: #A5DC86; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vuex = require('vuex');

exports.default = {
    created: function created() {
        var _this = this;

        window.Event.$on('openReceiveMemberContract', function (code) {
            if (code) {
                _this.code = code;
            }
            $(_this.$el).modal('show');
        });
    },
    destroyed: function destroyed() {
        window.Event.$off('openReceiveMemberContract');
    },

    data: function data() {
        return {
            ajaxing: false,
            title: "轉贈碼兌換",
            code: '',
            errorMessage: '',
            errorStatus: false,
            successData: {
                'name': '',
                'validTime': '',
                'value': ''
            },
            showType: 'exchanged'
        };
    },
    props: {
        receivedReload: {
            type: Boolean,
            default: false
        }
    },
    computed: {},
    methods: {
        receive: function receive() {
            var _this2 = this;

            this.ajaxing = true;
            this.errorStatus = false;
            var data = {
                code: this.code
            };
            this.$http.post('/webapi/member-contract/transfer/receive', data).then(function (response) {
                _this2.successData = response.data;
                _this2.showType = 'success';
                _this2.title = "轉贈碼兌換成功";
                _this2.ajaxing = false;
                _this2.$store.dispatch('filters/updateQueryStrings', { 'transfer-code': '' });
            }, function (error) {
                _this2.errorStatus = true;
                _this2.errorMessage = error.body.message;
                _this2.ajaxing = false;
            });
        },
        reset: function reset() {
            this.code = null;
            this.successData = {
                'name': '',
                'validTime': '',
                'value': ''
            };
            this.showType = 'exchanged';
            this.title = "轉贈碼兌換";
        },
        close: function close() {
            if (this.receivedReload) {
                location.reload();
            }
            this.closeDirect();
        },
        closeDirect: function closeDirect() {
            $(this.$el).modal('hide');
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal id=\"contract-receive-modal\" :remove-btn-show=\"false\" no-footer=\"\" :close-modal-event=\"reset\" confirm-btn-text=\"關閉\" :block-hide-without-close=\"true\" _v-438d9d08=\"\">\n    <span slot=\"title\" _v-438d9d08=\"\">{{title}}</span>\n    <template slot=\"body\">\n        <v-spinner :ajaxing=\"ajaxing\" _v-438d9d08=\"\"></v-spinner>\n        <div class=\"contract-transfer\" v-show=\"!ajaxing &amp;&amp; showType=='exchanged'\" _v-438d9d08=\"\">\n            <div class=\"transfer-group text-center\" _v-438d9d08=\"\">\n                <span class=\"code-title\" _v-438d9d08=\"\">輸入轉贈碼</span>\n            </div>\n            <div class=\"transfer-group code-block\" _v-438d9d08=\"\">\n                <textarea name=\"\" id=\"\" cols=\"30\" rows=\"10\" v-model=\"code\" _v-438d9d08=\"\">                    </textarea>\n                <div class=\"error-message\" v-show=\"errorStatus\" _v-438d9d08=\"\">\n                    {{ errorMessage }}\n                </div>\n            </div>\n            <div class=\"transfer-group\" _v-438d9d08=\"\">\n                <div class=\"alert alert-info\" role=\"alert\" _v-438d9d08=\"\">\n                    <ul _v-438d9d08=\"\">\n                        <li _v-438d9d08=\"\">轉贈方案超過期限，尚未領取會自動失效</li>\n                        <li _v-438d9d08=\"\">轉贈方案領取後，退還需洽場館人員</li>\n                    </ul>\n                </div>\n            </div>\n            <div class=\"transfer-group text-center\" _v-438d9d08=\"\">\n                <div class=\"btn btn--gray btn-lg\" @click=\"closeDirect\" _v-438d9d08=\"\">取消</div>\n                <div class=\"btn btn-primary btn-lg\" @click=\"receive()\" _v-438d9d08=\"\">確認兌換</div>\n            </div>\n        </div>\n        <div class=\"contract-transfer\" v-show=\"!ajaxing&amp;&amp; showType=='success'\" _v-438d9d08=\"\">\n            <div class=\"transfer-group text-center check\" _v-438d9d08=\"\">\n                <i class=\"fa fa-check-circle-o\" aria-hidden=\"true\" _v-438d9d08=\"\"></i>\n            </div>\n            <div class=\"transfer-group \" _v-438d9d08=\"\">\n                <div class=\"code-title mleft\" _v-438d9d08=\"\">方案名稱</div>\n            </div>\n            <div class=\"transfer-group\" _v-438d9d08=\"\">\n                <div class=\"success-title mleft\" _v-438d9d08=\"\">{{successData.name}}</div>\n            </div>\n            <div class=\"transfer-group\" _v-438d9d08=\"\">\n                <div class=\"code-title mleft\" _v-438d9d08=\"\">方案期間</div>\n            </div>\n            <div class=\"transfer-group\" _v-438d9d08=\"\">\n                <div class=\"success-title mleft\" _v-438d9d08=\"\">{{successData.validTime}}</div>\n            </div>\n            <div class=\"transfer-group\" _v-438d9d08=\"\">\n                <div class=\"code-title mleft\" _v-438d9d08=\"\">受贈價值</div>\n            </div>\n            <div class=\"transfer-group\" _v-438d9d08=\"\">\n                <div class=\"success-title mleft\" _v-438d9d08=\"\">{{successData.value}}</div>\n            </div>\n            <div class=\"transfer-group phone-mode\" _v-438d9d08=\"\">\n                <div class=\"alert alert-info\" role=\"alert\" _v-438d9d08=\"\">\n                    <ul _v-438d9d08=\"\">\n                        <li _v-438d9d08=\"\">轉贈方案超過期限，或是超過一年尚未領取會自動失效</li>\n                        <li _v-438d9d08=\"\">轉贈方案送出且經受贈方領取後，退還需洽場館人員</li>\n                    </ul>\n                </div>\n            </div>\n            \n            <div class=\"transfer-group text-center\" _v-438d9d08=\"\">\n                <div class=\"btn btn-primary btn-lg\" @click=\"close\" _v-438d9d08=\"\">確認</div>\n            </div>\n        </div>\n    </template>\n</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.transfer-group[_v-438d9d08] {\n  margin-bottom: 24px; }\n  /* line 4, stdin */\n  .transfer-group .code-title[_v-438d9d08] {\n    color: #28b0e3;\n    font-size: 18px; }\n  /* line 8, stdin */\n  .transfer-group .success-title[_v-438d9d08] {\n    color: #111827;\n    font-weight: bold;\n    font-size: 18px; }\n  /* line 13, stdin */\n  .transfer-group .mleft[_v-438d9d08] {\n    margin-left: 24px; }\n  /* line 16, stdin */\n  .transfer-group .alert[_v-438d9d08] {\n    margin-left: 24px;\n    margin-right: 24px; }\n\n/* line 21, stdin */\n.code-block[_v-438d9d08] {\n  font-size: 40px;\n  font-weight: 900; }\n  /* line 24, stdin */\n  .code-block textarea[_v-438d9d08] {\n    margin-bottom: 0px; }\n  /* line 27, stdin */\n  .code-block .error-message[_v-438d9d08] {\n    font-size: 14px; }\n\n/* line 31, stdin */\n.error-message[_v-438d9d08] {\n  color: red; }\n\n/* line 34, stdin */\n.check[_v-438d9d08] {\n  font-size: 90px;\n  color: #A5DC86; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-438d9d08", module.exports)
  } else {
    hotAPI.update("_v-438d9d08", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],954:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.contract-transfer[_v-7140533c] {\n  margin-left: 24px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vuex = require('vuex');

exports.default = {
    created: function created() {
        var _this = this;

        window.Event.$on('fetchMemberContractTransfer', function (id) {
            _this.memberContractId = id;
            _this.showCodeType = "success";
            _this.fetchMemberContract();
        });
        window.Event.$on('fetchMemberContractCode', function (id) {
            _this.memberContractExchangeId = id;
            _this.showCodeType = "code";
            _this.fetchCode();
        });
    },
    destroyed: function destroyed() {
        window.Event.$off('fetchMemberContractTransfer');
        window.Event.$off('fetchMemberContractCode');
    },

    data: function data() {
        return {
            ajaxing: false,
            step: 'membership-contract-transfer-start',
            title: "開始轉贈",
            contract: {
                id: null,
                name: null,
                type: null,
                unused: null,
                enable_member_transfer: null
            },
            memberContractId: null,
            memberContractExchangeId: null,
            transferData: {
                code: '',
                url: ''
            },
            showCodeType: 'success'
        };
    },
    computed: {},
    methods: {
        close: function close() {
            $(this.$el).modal('hide');
        },
        checkStep: function checkStep(step) {
            return this.step === step;
        },
        changeTitle: function changeTitle(title) {
            this.title = title;
        },
        reset: function reset() {
            this.contract = {
                id: null,
                name: null,
                type: null,
                unused: null,
                enable_member_transfer: null
            };
            this.transferData = {
                code: '',
                url: ''
            };
            this.title = "開始轉贈";
            this.memberContractId = null;
            this.memberContractExchangeId = null;
            this.step = 'membership-contract-transfer-start';
            this.showCodeType = "success";
        },
        fetchMemberContract: function fetchMemberContract() {
            var _this2 = this;

            if (this.memberContractId == null) {
                this.reset();
                return;
            }
            this.ajaxing = true;
            this.$http.get('/webapi/member-contract/' + this.memberContractId).then(function (response) {
                _this2.ajaxing = false;
                _this2.contract = response.data;
                $(_this2.$el).modal('show');
            }, function (error) {
                $17.swal({
                    title: error.body.message,
                    type: 'warning',
                    showCancelButton: false
                });
                _this2.ajaxing = false;
            });
        },
        transferred: function transferred(data) {
            this.step = 'membership-contract-transfer-success-code';
            this.transferData.code = data.code;
            this.transferData.url = data.url;
        },
        fetchCode: function fetchCode() {
            var _this3 = this;

            if (this.memberContractExchangeId == null) {
                this.reset();
                return;
            }
            this.ajaxing = true;
            this.$http.get('/webapi/member-contract-exchange-record/' + this.memberContractExchangeId + '/code').then(function (response) {
                _this3.ajaxing = false;
                _this3.transferred(response.data);
                $(_this3.$el).modal('show');
            }, function (error) {
                $17.swal({
                    title: error.body.message,
                    type: 'warning',
                    showCancelButton: false
                });
                _this3.ajaxing = false;
            });
        },
        cancel: function cancel() {
            var _this4 = this;

            if (this.memberContractExchangeId == null) {
                return;
            }
            $17.swal({
                title: '確認取消此次轉贈嗎?',
                type: 'warning'
            }, function () {
                _this4.ajaxing = true;
                _this4.$http.post('/webapi/member-contract-exchange-record/' + _this4.memberContractExchangeId + '/cancel').then(function (response) {
                    _this4.ajaxing = false;
                    _this4.fetchList();
                    _this4.close();
                }, function (error) {
                    $17.swal({
                        type: 'error',
                        title: error.body.message,
                        showCancelButton: false
                    });
                    _this4.ajaxing = false;
                });
            });
        },
        fetchList: function fetchList() {
            this.$emit('fresh-list');
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal id=\"contract-transfer-modal\" :remove-btn-show=\"false\" no-footer=\"\" :close-modal-event=\"reset\" confirm-btn-text=\"關閉\" :block-hide-without-close=\"true\" _v-7140533c=\"\">\n    <span slot=\"title\" _v-7140533c=\"\">{{title}}</span>\n    <template slot=\"body\">\n        <v-spinner :ajaxing=\"ajaxing\" _v-7140533c=\"\"></v-spinner>\n        <div class=\"contract-transfer\" _v-7140533c=\"\">\n            <membership-contract-transfer-start :id=\"contract.id\" :name=\"contract.name\" :type=\"contract.type\" :unused=\"contract.unused\" v-on:change-title=\"changeTitle\" v-on:transferred=\"transferred\" v-on:closed=\"close\" v-if=\"step=='membership-contract-transfer-start' &amp;&amp; !ajaxing\" _v-7140533c=\"\"></membership-contract-transfer-start>\n            <membership-contract-transfer-success-code :code=\"transferData.code\" :url=\"transferData.url\" v-on:change-title=\"changeTitle\" v-on:closed=\"close\" v-if=\"step=='membership-contract-transfer-success-code' &amp;&amp; !ajaxing\" :show-type=\"showCodeType\" @cancel=\"cancel\" _v-7140533c=\"\"></membership-contract-transfer-success-code>\n        </div>\n    </template>\n</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.contract-transfer[_v-7140533c] {\n  margin-left: 24px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-7140533c", module.exports)
  } else {
    hotAPI.update("_v-7140533c", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],955:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _membershipContractNav = require('./membership-contract-nav.vue');

var _membershipContractNav2 = _interopRequireDefault(_membershipContractNav);

var _subscriptionList = require('./subscription-list.vue');

var _subscriptionList2 = _interopRequireDefault(_subscriptionList);

var _subscriptionModal = require('./subscription-modal.vue');

var _subscriptionModal2 = _interopRequireDefault(_subscriptionModal);

var _activeSubscription = require('./partials/active-subscription.vue');

var _activeSubscription2 = _interopRequireDefault(_activeSubscription);

var _finishedSubscription = require('./partials/finished-subscription.vue');

var _finishedSubscription2 = _interopRequireDefault(_finishedSubscription);

var _contractTransferModal = require('./contract-transfer-modal.vue');

var _contractTransferModal2 = _interopRequireDefault(_contractTransferModal);

var _contractReceiveModal = require('./contract-receive-modal.vue');

var _contractReceiveModal2 = _interopRequireDefault(_contractReceiveModal);

var _memberContractTransferList = require('./member-contract-transfer-list.vue');

var _memberContractTransferList2 = _interopRequireDefault(_memberContractTransferList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('./transfer_contract');

_vue2.default.component('membership-contract-nav', _membershipContractNav2.default);
_vue2.default.component('membership-subscription', _subscriptionList2.default);
_vue2.default.component('membership-subscription-modal', _subscriptionModal2.default);
_vue2.default.component('active-subscription-order', _activeSubscription2.default);
_vue2.default.component('finished-subscription-order', _finishedSubscription2.default);

_vue2.default.component('contract-transfer-modal', _contractTransferModal2.default);
_vue2.default.component('contract-receive-modal', _contractReceiveModal2.default);
_vue2.default.component('member-contract-transfer-list', _memberContractTransferList2.default);

},{"./contract-receive-modal.vue":953,"./contract-transfer-modal.vue":954,"./member-contract-transfer-list.vue":956,"./membership-contract-nav.vue":957,"./partials/active-subscription.vue":958,"./partials/finished-subscription.vue":959,"./subscription-list.vue":960,"./subscription-modal.vue":961,"./transfer_contract":962,"vue":792}],956:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.title-name[_v-278dda54] {\n  font-size: 40px;\n  font-weight: 700; }\n\n/* line 7, stdin */\n.status-bar .btn-default[_v-278dda54]:hover {\n  color: #333; }\n\n/* line 13, stdin */\n.table-list .row[_v-278dda54] {\n  border: 1px solid #E5E7EB;\n  padding: 8px 10px; }\n\n/* line 17, stdin */\n.table-list .row[_v-278dda54]:first-child {\n  border-radius: 5px 5px 0 0; }\n\n/* line 20, stdin */\n.table-list .row[_v-278dda54]:last-child {\n  border-radius: 0 0 5px 5px; }\n\n/* line 23, stdin */\n.table-list .table-item[_v-278dda54] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center; }\n  /* line 27, stdin */\n  .table-list .table-item small[_v-278dda54] {\n    color: #AAAAAA; }\n\n/* line 33, stdin */\n.phone-mode-show[_v-278dda54] {\n  display: none; }\n\n/* line 37, stdin */\n.email[_v-278dda54] {\n  text-overflow: ellipsis; }\n\n@media screen and (max-width: 767px) {\n  /* line 42, stdin */\n  .phone-mode[_v-278dda54] {\n    display: none; }\n  /* line 45, stdin */\n  .phone-mode-show[_v-278dda54] {\n    display: block; } }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            pageMeta: {},
            records: [],
            ajaxing: false,
            id: null,
            name: '',
            statuses: {
                all: 0,
                waiting: 0,
                exchanged: 0,
                canceled: 0
            },
            currentState: ''
        };
    },
    mounted: function mounted() {
        var path = window.location.pathname.split("/");
        this.id = path[2];
        this.currentState = this.getUrlParamValue('status') ? this.getUrlParamValue('status') : '';
        if (window.screen.width < 767) {
            this.changeActiveStatus('0');
        } else {
            this.getRecords();
        }
    },

    methods: {
        getRecords: function getRecords() {
            var _this = this;

            if (this.id == null) {
                return;
            }
            var params = {
                page: this.getUrlParamValue('page') ? this.getUrlParamValue('page') : 1,
                status: this.getUrlParamValue('status') ? this.getUrlParamValue('status') : ''
            };
            this.ajaxing = true;
            this.$http.get('/webapi/member-contract/' + this.id + '/transfer', { params: params }).then(function (response) {
                _this.ajaxing = false;
                _this.records = response.data.orders;
                _this.pageMeta = response.data.pageMeta;
                _this.name = response.data.contractName;
                _this.statuses = response.data.statuses;
            }, function (error) {
                $17.swal({
                    title: error.body.message,
                    type: 'warning',
                    showCancelButton: false
                });
                _this.ajaxing = false;
            });
        },
        showCode: function showCode(id) {
            var _this2 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return window.Event.$emit('fetchMemberContractCode', id);

                            case 2:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        showStatuses: function showStatuses(num) {
            if (num * 1 > 99) {
                return '99+';
            }

            return num;
        },
        changeActiveStatus: function changeActiveStatus(status) {
            this.currentState = status;
            this.$store.dispatch('filters/updateQueryStrings', { status: status });
            this.getRecords();
        },
        checkActive: function checkActive(status) {
            return this.currentState === status;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"container\" _v-278dda54=\"\">\n   <div _v-278dda54=\"\">\n       <h3 class=\"title-name\" _v-278dda54=\"\">{{ name }}</h3>\n   </div>\n    <div class=\"alert alert-info phone-mode-show\" role=\"alert\" v-show=\"!ajaxing\" _v-278dda54=\"\">\n        行動裝置的轉贈管理只提供最新狀態為等待中的轉贈碼，如需更多細節請至電腦操作。\n    </div>\n   <v-spinner :ajaxing=\"ajaxing\" _v-278dda54=\"\"></v-spinner>\n   <div class=\"m-bottom-20 status-bar\" v-show=\"!ajaxing\" _v-278dda54=\"\">\n        <div class=\"btn phone-mode\" :class=\"{'btn--primary':checkActive(''),'btn-default':!checkActive('')}\" @click=\"changeActiveStatus('')\" _v-278dda54=\"\">\n            全部({{showStatuses(statuses.all)}})\n        </div>\n        <div class=\"btn \" :class=\"{'btn--primary':checkActive('0'),'btn-default':!checkActive('0')}\" @click=\"changeActiveStatus('0')\" _v-278dda54=\"\">等待中({{showStatuses(statuses.waiting)}})</div>\n        <div class=\"btn phone-mode\" :class=\"{'btn--primary':checkActive('1'),'btn-default':!checkActive('1')}\" @click=\"changeActiveStatus('1')\" _v-278dda54=\"\">已兌換({{showStatuses(statuses.exchanged)}})</div>\n        <div class=\"btn phone-mode\" :class=\"{'btn--primary':checkActive('2'),'btn-default':!checkActive('2')}\" @click=\"changeActiveStatus('2')\" _v-278dda54=\"\">已取消({{showStatuses(statuses.canceled)}})</div>\n   </div>\n   <div class=\"m-bottom-20 table-list\" v-show=\"!ajaxing\" _v-278dda54=\"\">\n       <div class=\"row table-item\" _v-278dda54=\"\">\n           <div class=\"col-sm-2 col-xs-3\" _v-278dda54=\"\">\n               建立日期\n           </div>\n           <div class=\"col-sm-2 phone-mode\" _v-278dda54=\"\">\n               姓名\n           </div>\n           <div class=\"col-sm-3 phone-mode\" _v-278dda54=\"\">\n               E-MAIN\n           </div>\n           <div class=\"col-sm-1 col-xs-3\" _v-278dda54=\"\">\n               最新狀態\n           </div>\n           <div class=\"col-sm-2 col-xs-3\" _v-278dda54=\"\">\n               轉贈價值\n           </div>\n           <div class=\"col-sm-2 col-xs-3\" _v-278dda54=\"\">\n               \n           </div>\n       </div>\n       <div class=\"row table-item\" v-for=\"record in records\" :key=\"record.id\" _v-278dda54=\"\">\n           <div class=\"col-sm-2 col-xs-3\" _v-278dda54=\"\">\n               <div _v-278dda54=\"\">{{ record.created_date }}</div>\n               <div _v-278dda54=\"\">\n                   <small _v-278dda54=\"\">\n                       {{ record.created_time }}\n                   </small>\n               </div>\n           </div>\n           <div class=\"col-sm-2 phone-mode\" _v-278dda54=\"\">\n               {{ record.name }}\n           </div>\n           <div class=\"col-sm-3 email phone-mode\" _v-278dda54=\"\">\n               {{ record.email }}\n           </div>\n           <div class=\"col-sm-1 col-xs-3\" _v-278dda54=\"\">\n               {{ record.status_name }}\n           </div>\n           <div class=\"col-sm-2 col-xs-3\" _v-278dda54=\"\">\n               {{ record.transferred_value }}{{  record.transferred_unit }}\n           </div>\n           <div class=\"col-sm-2 col-xs-3\" _v-278dda54=\"\">\n               <div _v-278dda54=\"\">\n                   <a href=\"\" @click.stop.prevent=\"showCode(record.id)\" v-if=\"record.status==0\" _v-278dda54=\"\">查看</a>\n               </div>\n           </div>\n       </div>\n   </div>\n   <v-sql-pagination v-show=\"!ajaxing\" ref=\"pager\" :page-meta=\"pageMeta\" @page-change-callback=\"getRecords\" _v-278dda54=\"\">\n    </v-sql-pagination>\n    <contract-transfer-modal @fresh-list=\"getRecords\" _v-278dda54=\"\"></contract-transfer-modal>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.title-name[_v-278dda54] {\n  font-size: 40px;\n  font-weight: 700; }\n\n/* line 7, stdin */\n.status-bar .btn-default[_v-278dda54]:hover {\n  color: #333; }\n\n/* line 13, stdin */\n.table-list .row[_v-278dda54] {\n  border: 1px solid #E5E7EB;\n  padding: 8px 10px; }\n\n/* line 17, stdin */\n.table-list .row[_v-278dda54]:first-child {\n  border-radius: 5px 5px 0 0; }\n\n/* line 20, stdin */\n.table-list .row[_v-278dda54]:last-child {\n  border-radius: 0 0 5px 5px; }\n\n/* line 23, stdin */\n.table-list .table-item[_v-278dda54] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center; }\n  /* line 27, stdin */\n  .table-list .table-item small[_v-278dda54] {\n    color: #AAAAAA; }\n\n/* line 33, stdin */\n.phone-mode-show[_v-278dda54] {\n  display: none; }\n\n/* line 37, stdin */\n.email[_v-278dda54] {\n  text-overflow: ellipsis; }\n\n@media screen and (max-width: 767px) {\n  /* line 42, stdin */\n  .phone-mode[_v-278dda54] {\n    display: none; }\n  /* line 45, stdin */\n  .phone-mode-show[_v-278dda54] {\n    display: block; } }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-278dda54", module.exports)
  } else {
    hotAPI.update("_v-278dda54", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],957:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.nav-pills > li.active > a[_v-5079fffb], .nav-pills > li.active > a[_v-5079fffb]:hover, .nav-pills > li.active > a[_v-5079fffb]:focus {\n  color: black;\n  background-color: #f4f4f4; }\n  /* line 5, stdin */\n  .nav-pills > li.active > a .marked-style[_v-5079fffb], .nav-pills > li.active > a:hover .marked-style[_v-5079fffb], .nav-pills > li.active > a:focus .marked-style[_v-5079fffb] {\n    background-color: #38b0e3; }\n\n/* line 9, stdin */\n.nav-content[_v-5079fffb] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  color: black;\n  font-weight: 500; }\n  /* line 14, stdin */\n  .nav-content:hover .marked-style[_v-5079fffb] {\n    background-color: #38b0e3; }\n\n/* line 19, stdin */\n.nav-pills .marked-style[_v-5079fffb] {\n  width: 5px;\n  height: 20px;\n  background: #eee;\n  margin-right: 10px;\n  border-radius: 10px; }\n\n@media screen and (max-width: 767px) {\n  /* line 29, stdin */\n  .nav-pills > li.active > a[_v-5079fffb], .nav-pills > li.active > a[_v-5079fffb]:hover, .nav-pills > li.active > a[_v-5079fffb]:focus {\n    color: #38b0e3;\n    background-color: #ffffff;\n    border-color: #38b0e3; }\n  /* line 34, stdin */\n  .nav-content[_v-5079fffb] {\n    color: #bbb;\n    border: 2px solid;\n    border-color: #f4f4f4;\n    border-radius: 50px; }\n  /* line 40, stdin */\n  ul.nav.nav-pills.nav-stacked[_v-5079fffb] {\n    display: -ms-flexbox;\n    display: flex;\n    margin-bottom: 20px; }\n    /* line 43, stdin */\n    ul.nav.nav-pills.nav-stacked li[_v-5079fffb] {\n      margin-right: 10px; }\n    /* line 46, stdin */\n    ul.nav.nav-pills.nav-stacked span[_v-5079fffb] {\n      margin: 0 10px; }\n    /* line 49, stdin */\n    ul.nav.nav-pills.nav-stacked .marked-style[_v-5079fffb] {\n      display: none; } }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    data: function data() {
        return {
            mode: 'valid',
            headerColor: '#38B0E3'
        };
    },
    mounted: function mounted() {
        var vm = this;
        var params = this.getUrlParamValue('contract_type');
        this.mode = params ? params : 'valid';
        this.headerColor = this.mode == 'valid' ? '#38B0E3' : '#888888';
        $('.table-contract-header').each(function () {
            $(this).css('background-color', vm.headerColor);
        });
    },

    methods: {}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-5079fffb=\"\">\n    <ul class=\"nav nav-pills nav-stacked\" _v-5079fffb=\"\">\n        <li :class=\"{ active: mode == 'valid' }\" _v-5079fffb=\"\">\n            <a class=\"nav-content\" href=\"?contract_type=valid\" _v-5079fffb=\"\">\n                <div class=\"marked-style\" _v-5079fffb=\"\"></div><span _v-5079fffb=\"\">有效方案</span>\n            </a>\n        </li>\n        <li :class=\"{ active: mode == 'expire' }\" _v-5079fffb=\"\">\n            <a class=\"nav-content\" href=\"?contract_type=expire\" _v-5079fffb=\"\">\n                <div class=\"marked-style\" _v-5079fffb=\"\"></div><span _v-5079fffb=\"\">失效方案</span>\n            </a>\n        </li>\n    </ul>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.nav-pills > li.active > a[_v-5079fffb], .nav-pills > li.active > a[_v-5079fffb]:hover, .nav-pills > li.active > a[_v-5079fffb]:focus {\n  color: black;\n  background-color: #f4f4f4; }\n  /* line 5, stdin */\n  .nav-pills > li.active > a .marked-style[_v-5079fffb], .nav-pills > li.active > a:hover .marked-style[_v-5079fffb], .nav-pills > li.active > a:focus .marked-style[_v-5079fffb] {\n    background-color: #38b0e3; }\n\n/* line 9, stdin */\n.nav-content[_v-5079fffb] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  color: black;\n  font-weight: 500; }\n  /* line 14, stdin */\n  .nav-content:hover .marked-style[_v-5079fffb] {\n    background-color: #38b0e3; }\n\n/* line 19, stdin */\n.nav-pills .marked-style[_v-5079fffb] {\n  width: 5px;\n  height: 20px;\n  background: #eee;\n  margin-right: 10px;\n  border-radius: 10px; }\n\n@media screen and (max-width: 767px) {\n  /* line 29, stdin */\n  .nav-pills > li.active > a[_v-5079fffb], .nav-pills > li.active > a[_v-5079fffb]:hover, .nav-pills > li.active > a[_v-5079fffb]:focus {\n    color: #38b0e3;\n    background-color: #ffffff;\n    border-color: #38b0e3; }\n  /* line 34, stdin */\n  .nav-content[_v-5079fffb] {\n    color: #bbb;\n    border: 2px solid;\n    border-color: #f4f4f4;\n    border-radius: 50px; }\n  /* line 40, stdin */\n  ul.nav.nav-pills.nav-stacked[_v-5079fffb] {\n    display: -ms-flexbox;\n    display: flex;\n    margin-bottom: 20px; }\n    /* line 43, stdin */\n    ul.nav.nav-pills.nav-stacked li[_v-5079fffb] {\n      margin-right: 10px; }\n    /* line 46, stdin */\n    ul.nav.nav-pills.nav-stacked span[_v-5079fffb] {\n      margin: 0 10px; }\n    /* line 49, stdin */\n    ul.nav.nav-pills.nav-stacked .marked-style[_v-5079fffb] {\n      display: none; } }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-5079fffb", module.exports)
  } else {
    hotAPI.update("_v-5079fffb", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],958:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.light-grey-border-table[_v-46f4e58a] {\n  font-size: 14px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['nextOrder', 'latestOrder', 'finishedOrders', 'finishedOrdersPageMeta', 'pageChangeCallBack'],
    data: function data() {
        return {
            currentView: 'current-order'
        };
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-46f4e58a=\"\">\n    <!-- <font class=\"title-5 grey--100\">訂閱狀態：訂閱中</font> -->\n    <div id=\"underline-tabs\" class=\"primary-business-color-border\" :style=\"{'--tab-theme-color': '#0062FF'}\" _v-46f4e58a=\"\">\n        <ul class=\"tabs\" _v-46f4e58a=\"\">\n            <li @click.prevent=\"[currentView='current-order']\" :class=\"currentView=='current-order' ? 'on' : ''\" _v-46f4e58a=\"\">\n                <a _v-46f4e58a=\"\">當前的訂單</a>\n            </li>\n            <li @click.prevent=\"[currentView='finished-order']\" :class=\"currentView=='finished-order' ? 'on' : ''\" _v-46f4e58a=\"\">\n                <a _v-46f4e58a=\"\">已完成的訂單</a>\n            </li>\n        </ul>\n    </div>\n    <div v-if=\"currentView === 'current-order'\" _v-46f4e58a=\"\">\n        <div _v-46f4e58a=\"\">\n            <p class=\"regular grey--80\" _v-46f4e58a=\"\">預計到來的訂單</p>\n            <div class=\"row\" _v-46f4e58a=\"\">\n                <div class=\"col-md-12\" _v-46f4e58a=\"\">\n                    <div class=\"light-grey-border-table\" v-if=\"nextOrder!=null&amp;&amp;nextOrder.date\" _v-46f4e58a=\"\">\n                        <table class=\"rwd-table\" _v-46f4e58a=\"\">\n                            <tbody _v-46f4e58a=\"\"><tr _v-46f4e58a=\"\">\n                                <th _v-46f4e58a=\"\">預計付款日期</th>\n                                <th _v-46f4e58a=\"\">預計支付金額</th>\n                                <th _v-46f4e58a=\"\">訂單狀態</th>\n                                <th _v-46f4e58a=\"\">訂單編號</th>\n                                <th _v-46f4e58a=\"\"></th>\n                            </tr>\n                            <tr _v-46f4e58a=\"\">\n                                <td data-th=\"預計付款日期\" _v-46f4e58a=\"\">{{nextOrder.date}}</td>\n                                <td data-th=\"預計支付金額\" _v-46f4e58a=\"\">{{nextOrder.currency}} {{nextOrder.money}}</td>\n                                <td data-th=\"訂單狀態\" _v-46f4e58a=\"\">{{nextOrder.order_status}}</td>\n                                <td data-th=\"訂單編號\" _v-46f4e58a=\"\">{{nextOrder.order_id}}</td>\n                                <td _v-46f4e58a=\"\"></td>\n                            </tr>\n                        </tbody></table>\n                    </div>\n                    <div class=\"content-inner m-top-10 m-bottom-10\" v-else=\"\" _v-46f4e58a=\"\">\n                        <p _v-46f4e58a=\"\">找不到結果</p>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"m-top-25\" _v-46f4e58a=\"\">\n            <p class=\"regular grey--80\" _v-46f4e58a=\"\">最近一期的訂單</p>\n            <div class=\"row\" _v-46f4e58a=\"\">\n                <div class=\"col-md-12\" _v-46f4e58a=\"\">\n                    <div class=\"light-grey-border-table\" v-if=\"latestOrder !=null &amp;&amp; latestOrder.date\" _v-46f4e58a=\"\">\n                        <table class=\"rwd-table\" _v-46f4e58a=\"\">\n                            <tbody _v-46f4e58a=\"\"><tr _v-46f4e58a=\"\">\n                                <th _v-46f4e58a=\"\">付款日期</th>\n                                <th _v-46f4e58a=\"\">支付金額</th>\n                                <th _v-46f4e58a=\"\">訂單狀態</th>\n                                <th _v-46f4e58a=\"\">訂單編號</th>\n                                <th _v-46f4e58a=\"\"></th>\n                            </tr>\n                            <tr _v-46f4e58a=\"\">\n                                <td data-th=\"付款日期\" _v-46f4e58a=\"\">{{latestOrder.date}}</td>\n                                <td data-th=\"支付金額\" _v-46f4e58a=\"\">{{latestOrder.currency}} {{latestOrder.money}}</td>\n                                <td data-th=\"訂單狀態\" _v-46f4e58a=\"\">{{latestOrder.order_status}}</td>\n                                <td data-th=\"訂單編號\" _v-46f4e58a=\"\">{{latestOrder.order_id}}</td>\n                                <td _v-46f4e58a=\"\">\n                                    <a style=\"color: #50B5FF;font-weight: 500;\" v-if=\"false\" _v-46f4e58a=\"\">\n                                        <i class=\"fa fa-external-link\" _v-46f4e58a=\"\"></i> 查看方案\n                                    </a>\n                                </td>\n                            </tr>\n                        </tbody></table>\n                    </div>\n                    <div class=\"content-inner m-top-10 m-bottom-10\" v-else=\"\" _v-46f4e58a=\"\">\n                        <p _v-46f4e58a=\"\">找不到結果</p>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div v-if=\"currentView === 'finished-order'\" _v-46f4e58a=\"\">\n        <div _v-46f4e58a=\"\">\n            <p class=\"regular grey--80\" _v-46f4e58a=\"\">已完成的訂單</p>\n            <div class=\"row\" _v-46f4e58a=\"\">\n                <div class=\"col-md-12\" _v-46f4e58a=\"\">\n                    <div class=\"light-grey-border-table\" v-if=\"finishedOrders.length > 0\" _v-46f4e58a=\"\">\n                        <table class=\"rwd-table\" _v-46f4e58a=\"\">\n                            <tbody _v-46f4e58a=\"\"><tr _v-46f4e58a=\"\">\n                                <th _v-46f4e58a=\"\">付款日期</th>\n                                <th _v-46f4e58a=\"\">支付金額</th>\n                                <th _v-46f4e58a=\"\">訂單狀態</th>\n                                <th _v-46f4e58a=\"\">訂單編號</th>\n                                <th _v-46f4e58a=\"\"></th>\n                            </tr>\n                            <tr v-for=\"order in finishedOrders\" _v-46f4e58a=\"\">\n                                <td data-th=\"付款日期\" _v-46f4e58a=\"\">{{order.date}}</td>\n                                <td data-th=\"支付金額\" _v-46f4e58a=\"\">{{order.currency}} {{order.money}}</td>\n                                <td data-th=\"訂單狀態\" _v-46f4e58a=\"\">{{order.order_status}}</td>\n                                <td data-th=\"訂單編號\" _v-46f4e58a=\"\">{{order.order_id}}</td>\n                                <td _v-46f4e58a=\"\">\n                                    <a style=\"color: #50B5FF;font-weight: 500;\" v-if=\"false\" _v-46f4e58a=\"\">\n                                        <i class=\"fa fa-external-link\" _v-46f4e58a=\"\"></i> 查看方案\n                                    </a>\n                                </td>\n                            </tr>\n                        </tbody></table>\n                    </div>\n                    <div class=\"content-inner m-top-10 m-bottom-10\" v-else=\"\" _v-46f4e58a=\"\">\n                        <p _v-46f4e58a=\"\">找不到結果</p>\n                    </div>\n                </div>\n                <div class=\"row col-md-12\" _v-46f4e58a=\"\">\n                    <v-sql-pagination-noquery :page-meta=\"finishedOrdersPageMeta\" @page-change-callback=\"pageChangeCallBack\" _v-46f4e58a=\"\"></v-sql-pagination-noquery>   \n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.light-grey-border-table[_v-46f4e58a] {\n  font-size: 14px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-46f4e58a", module.exports)
  } else {
    hotAPI.update("_v-46f4e58a", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],959:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['finishedOrders', 'finishedOrdersPageMeta', 'pageChangeCallBack'],
    data: function data() {
        return {
            pageMeta: {}
        };
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div>\n    <div class=\"row\">\n        <div class=\"col-md-12\">\n            <div class=\"light-grey-border-table\" v-if=\"finishedOrders.length > 0\">\n                <table class=\"rwd-table\">\n                    <tbody><tr>\n                        <th>付款日期</th>\n                        <th>支付金額</th>\n                        <th>訂單狀態</th>\n                        <th>訂單編號</th>\n                        <th></th>\n                    </tr>\n                    <tr v-for=\"order in finishedOrders\">\n                        <td data-th=\"付款日期\">{{order.date}}</td>\n                        <td data-th=\"支付金額\">{{order.currency}} {{order.money}}</td>\n                        <td data-th=\"訂單狀態\">{{order.order_status}}</td>\n                        <td data-th=\"訂單編號\">{{order.order_id}}</td>\n                        <td>\n                            <a style=\"color: #50B5FF;font-weight: 500;\" v-if=\"false\">\n                                <i class=\"fa fa-external-link\"></i> 查看方案\n                            </a>\n                        </td>\n                    </tr>\n                </tbody></table>\n            </div>\n            <div class=\"content-inner m-top-10 m-bottom-10\" v-else=\"\">\n                <p>找不到結果</p>\n            </div>\n        </div>\n    </div>\n    <div class=\"row col-md-12\">\n        <v-sql-pagination-noquery :page-meta=\"finishedOrdersPageMeta\" @page-change-callback=\"pageChangeCallBack\"></v-sql-pagination-noquery>      \n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-c44d74e2", module.exports)
  } else {
    hotAPI.update("_v-c44d74e2", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],960:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.payment-money[_v-46ff3f6c] {\n  color: #92929D;\n  display: block; }\n\n/* line 6, stdin */\n.more-info[_v-46ff3f6c] {\n  color: #50B5FF; }\n\n@media (min-width: 1px) and (max-width: 768px) {\n  /* line 10, stdin */\n  .payment-money[_v-46ff3f6c] {\n    display: inline; }\n    /* line 12, stdin */\n    .payment-money[_v-46ff3f6c]:before {\n      content: ', '; } }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    data: function data() {
        return {
            records: [],
            ajaxing: false,
            isInWebStudio: false
        };
    },
    mounted: function mounted() {
        this.fetchInitData();
        this.getRecords();
    },

    methods: {
        getRecords: function getRecords() {
            var _this = this;

            this.ajaxing = true;
            this.$http.get('/webapi/member/subscribe/list').then(function (response) {
                _this.ajaxing = false;
                _this.records = response.data;
            }, function (error) {
                $17.swal({
                    type: 'error',
                    title: "取得訂閱發生錯誤，請重新嘗試",
                    showCancelButton: false
                });
                _this.ajaxing = false;
            });
        },
        showModal: function showModal(order) {
            this.$refs.subscribe_modal.showModal(order);
        },

        fetchInitData: function fetchInitData() {
            var _this2 = this;

            this.$http.get(base_url + '/webapi/init/data').then(function (response) {
                _this2.isInWebStudio = response.data.is_in_webstudio;
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-46ff3f6c=\"\">\n    <div class=\"container\" _v-46ff3f6c=\"\">\n        <div class=\"row member-subscription-list-table\" _v-46ff3f6c=\"\">\n            <div class=\"col-md-10 col-md-push-1\" _v-46ff3f6c=\"\">\n                <div class=\"row\" _v-46ff3f6c=\"\">\n                    <div class=\"section-title col-md-2\" _v-46ff3f6c=\"\">\n                        <h3 class=\"primary-business-color-font\" _v-46ff3f6c=\"\"><i class=\"material-icons\" _v-46ff3f6c=\"\">cached</i> 訂閱管理</h3>\n                    </div>\n                </div>\n                <v-spinner :ajaxing=\"ajaxing\" _v-46ff3f6c=\"\"></v-spinner>\n                <div class=\"row\" v-show=\"!ajaxing\" _v-46ff3f6c=\"\">\n                    <div class=\"section-content col-md-12\" _v-46ff3f6c=\"\">\n                        <div class=\"light-grey-border-table\" v-if=\"records.length > 0\" _v-46ff3f6c=\"\">\n                            <table class=\"rwd-table\" _v-46ff3f6c=\"\">\n                                <tbody _v-46ff3f6c=\"\"><tr _v-46ff3f6c=\"\">\n                                    <th v-if=\"!isInWebStudio\" _v-46ff3f6c=\"\">品牌名稱</th>\n                                    <th _v-46ff3f6c=\"\">購買項目</th>\n                                    <th _v-46ff3f6c=\"\">訂閱狀態</th>\n                                    <th _v-46ff3f6c=\"\">下一期</th>\n                                    <th _v-46ff3f6c=\"\">付款資訊</th>\n                                    <th _v-46ff3f6c=\"\"></th>\n                                </tr>\n                                <tr v-for=\"order in records\" _v-46ff3f6c=\"\">\n                                    <td v-if=\"!isInWebStudio\" data-th=\"品牌名稱\" class=\"\" _v-46ff3f6c=\"\">{{order.studio_name}}</td>\n                                    <td data-th=\"購買項目\" class=\"\" _v-46ff3f6c=\"\">{{order.buy_name}}</td>\n                                    <td data-th=\"訂閱狀態\" class=\"\" _v-46ff3f6c=\"\">{{order.subscribe_status}}</td>\n                                    <td data-th=\"下一期\" class=\"\" _v-46ff3f6c=\"\">{{order.next_pay_date}}\n                                        <span class=\"payment-money\" v-show=\"order.subscribe_status_boolean &amp;&amp; order.next_pay_money!=''\" _v-46ff3f6c=\"\">{{order.currency}} {{order.next_pay_money}}</span>\n                                    </td>\n                                    <td data-th=\"付款資訊\" class=\"\" _v-46ff3f6c=\"\">\n                                        {{order.pay_data_string}}\n                                    </td>\n                                    <td _v-46ff3f6c=\"\"><a style=\"color: #50B5FF;font-weight: 500;\" @click=\"showModal(order)\" _v-46ff3f6c=\"\">更多資訊</a></td>\n                                </tr>\n                            </tbody></table>\n                        </div>\n                        <div class=\"content-inner\" v-else=\"\" _v-46ff3f6c=\"\">\n                            <p _v-46ff3f6c=\"\">找不到結果</p>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <membership-subscription-modal @refresh=\"getRecords()\" ref=\"subscribe_modal\" _v-46ff3f6c=\"\"></membership-subscription-modal>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.payment-money[_v-46ff3f6c] {\n  color: #92929D;\n  display: block; }\n\n/* line 6, stdin */\n.more-info[_v-46ff3f6c] {\n  color: #50B5FF; }\n\n@media (min-width: 1px) and (max-width: 768px) {\n  /* line 10, stdin */\n  .payment-money[_v-46ff3f6c] {\n    display: inline; }\n    /* line 12, stdin */\n    .payment-money[_v-46ff3f6c]:before {\n      content: ', '; } }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-46ff3f6c", module.exports)
  } else {
    hotAPI.update("_v-46ff3f6c", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],961:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 3, stdin */\n.body-top[_v-ff12d59e] {\n  height: 30px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: justify;\n      justify-content: space-between; }\n  /* line 8, stdin */\n  .body-top span[_v-ff12d59e] {\n    font-size: 12px; }\n  /* line 11, stdin */\n  .body-top .stop-sb-btn[_v-ff12d59e] {\n    font-size: 14px;\n    color: #DC3545;\n    border: 1px solid #DC3545;\n    padding: 4px 8px;\n    border-radius: 4px; }\n    /* line 17, stdin */\n    .body-top .stop-sb-btn[_v-ff12d59e]:hover {\n      color: white;\n      background: #DC3545; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {},
    data: function data() {
        return {
            id: null,
            isSubscribe: 1,
            ajaxing: {
                loading: false,
                cancel: false
            },
            contract: {
                buy_type: null,
                buy_name: '',
                studio_name: ''
            },
            nextOrder: {},
            latestOrder: {},
            lastFinishContractData: {
                expire_date: '',
                remain: ''
            },
            finishedOrders: [],
            finishedOrdersPageMeta: {},
            autoRenewalTerminatedAt: ''
        };
    },

    computed: {
        subscriptionState: function subscriptionState() {
            return this.isSubscribe ? '訂閱中' : '已終止';
        },
        componentName: function componentName() {
            return this.isSubscribe ? 'active-subscription-order' : 'finished-subscription-order';
        }
    },
    methods: {
        clickFinishSubscribe: function clickFinishSubscribe() {
            var _this = this;

            var remainValue = '';
            if ([2, 3].indexOf(this.contract.buy_type) != -1) {
                remainValue = '<li>剩餘：' + this.lastFinishContractData.remain + '</li>';
            }
            var showHtml = '<div style="font-weight:normal">若您確定要取消訂閱，請確認以下內容。<br><ul style="text-align: left;margin-left: 4em;margin-top:1em;}"><li>終止方案：' + this.contract.buy_name + '</li><li>最近一期方案資訊<ul><li>到期日：' + this.lastFinishContractData.expire_date + ' </li>' + remainValue + '</ul></li></ul></div>';

            $17.swal({
                title: '您確定要終止訂閱了嗎',
                html: showHtml,
                type: 'warning',
                confirmButtonText: '確認'
            }, function () {
                _this.stopSubscribe();
            });
        },
        stopSubscribe: function stopSubscribe() {
            var _this2 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _this2.ajaxing.cancel = true;

                                _this2.$http.post('/webapi/member/subscribe/' + _this2.id + '/cancel').then(function () {
                                    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(response) {
                                        return _regenerator2.default.wrap(function _callee$(_context) {
                                            while (1) {
                                                switch (_context.prev = _context.next) {
                                                    case 0:
                                                        _context.next = 2;
                                                        return _this2.getRecord();

                                                    case 2:
                                                        _this2.$emit('refresh');
                                                        _this2.ajaxing.cancel = false;

                                                    case 4:
                                                    case 'end':
                                                        return _context.stop();
                                                }
                                            }
                                        }, _callee, _this2);
                                    }));

                                    return function (_x) {
                                        return _ref.apply(this, arguments);
                                    };
                                }(), function (error) {
                                    $17.swal({
                                        type: 'error',
                                        title: "終止訂閱發生錯誤，請重新嘗試",
                                        showCancelButton: false
                                    });
                                    _this2.ajaxing.cancel = false;
                                });

                            case 2:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        showModal: function showModal(params) {
            var _this3 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _this3.isSubscribe = params.isSubscribe;
                                _this3.id = params.id;
                                $.blockUI();
                                _this3.ajaxing.loading = true;
                                _context3.next = 6;
                                return _promise2.default.all([_this3.getRecord(), _this3.getRecordFinish()]).then(function () {
                                    _this3.ajaxing.loading = false;
                                    $.unblockUI();
                                    $('#member-subscription-modal').modal('show');
                                });

                            case 6:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3);
            }))();
        },
        getRecord: function getRecord() {
            var _this4 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return _this4.$http.get('/webapi/member/subscribe/' + _this4.id).then(function (response) {
                                    _this4.ajaxing.loading = false;

                                    var data = response.data;
                                    _this4.isSubscribe = data.subscribe_status_boolean;
                                    _this4.contract.buy_type = data.buy_type;
                                    _this4.contract.buy_name = data.buy_name;
                                    _this4.contract.studio_name = data.studio_name;
                                    _this4.nextOrder = data.on_coming_details;
                                    _this4.latestOrder = data.last_finish_details;
                                    _this4.lastFinishContractData = data.last_finish_contract_data;
                                    _this4.autoRenewalTerminatedAt = data.auto_renewal_terminated_at;
                                }, function (error) {
                                    $17.swal({
                                        type: 'error',
                                        title: "取得資料發生錯誤，請重新嘗試",
                                        showCancelButton: false
                                    });
                                    _this4.ajaxing.loading = false;
                                });

                            case 2:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this4);
            }))();
        },
        getRecordFinish: function getRecordFinish(page) {
            var _this5 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5() {
                return _regenerator2.default.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return _this5.$http.get('/webapi/member/subscribe/' + _this5.id + '/finished', {
                                    'params': { 'page': !!page ? page : 1 }
                                }).then(function (response) {
                                    _this5.ajaxing.loading = false;
                                    var finish_details = response.data;
                                    _this5.finishedOrders = finish_details.finishDetails;
                                    _this5.finishedOrdersPageMeta = finish_details.pageMeta;
                                }, function (error) {
                                    $17.swal({
                                        type: 'error',
                                        title: "取得資料發生錯誤，請重新嘗試",
                                        showCancelButton: false
                                    });
                                    _this5.ajaxing.loading = false;
                                });

                            case 2:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this5);
            }))();
        },
        reset: function reset() {
            this.id = null;
            this.isSubscribe = 1;
            this.ajaxing = {
                loading: false,
                cancel: false
            };
            this.contract = {};
            // dummy data
            this.nextOrder = {};
            this.latestOrder = {};
            this.finishedOrders = [];
            this.lastFinishContractData = {
                expire_date: '',
                remain: ''
            };
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal :close-modal-event=\"reset\" id=\"member-subscription-modal\" border-radius-level=\"20px\" no-footer=\"\" _v-ff12d59e=\"\">\n        <div slot=\"title\" _v-ff12d59e=\"\">\n            <font class=\"title-5 grey--100\" _v-ff12d59e=\"\">購買項目：{{contract.buy_name}}</font>\n            <p class=\"txt-small grey--70\" _v-ff12d59e=\"\">{{contract.studio_name}}</p>\n        </div>\n        <div slot=\"body\" _v-ff12d59e=\"\">\n            <div class=\"body-top m-bottom-25\" _v-ff12d59e=\"\">\n                <font class=\"title-5 grey--100\" _v-ff12d59e=\"\">訂閱狀態：{{ subscriptionState }}\n                    <span class=\"grey--70\" v-show=\"!isSubscribe\" _v-ff12d59e=\"\">{{ autoRenewalTerminatedAt }}</span>\n                </font>\n                <a class=\"stop-sb-btn\" @click=\"clickFinishSubscribe\" v-show=\"isSubscribe &amp;&amp; !ajaxing.cancel\" _v-ff12d59e=\"\">終止訂閱</a>\n                <v-spinner-button :ajaxing=\"ajaxing.cancel\" fa-size=\"fa-3x\" _v-ff12d59e=\"\"></v-spinner-button>\n            </div>\n            <v-spinner :ajaxing=\"ajaxing.loading\" _v-ff12d59e=\"\"></v-spinner>\n            <div v-show=\"!ajaxing.loading\" _v-ff12d59e=\"\">\n                <keep-alive _v-ff12d59e=\"\">\n                    <component :is=\"componentName\" :next-order=\"nextOrder\" :latest-order=\"latestOrder\" :finished-orders=\"finishedOrders\" :finished-orders-page-meta=\"finishedOrdersPageMeta\" :page-change-call-back=\"getRecordFinish\" _v-ff12d59e=\"\"></component>\n                </keep-alive>\n            </div>\n        </div>            \n</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 3, stdin */\n.body-top[_v-ff12d59e] {\n  height: 30px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: justify;\n      justify-content: space-between; }\n  /* line 8, stdin */\n  .body-top span[_v-ff12d59e] {\n    font-size: 12px; }\n  /* line 11, stdin */\n  .body-top .stop-sb-btn[_v-ff12d59e] {\n    font-size: 14px;\n    color: #DC3545;\n    border: 1px solid #DC3545;\n    padding: 4px 8px;\n    border-radius: 4px; }\n    /* line 17, stdin */\n    .body-top .stop-sb-btn[_v-ff12d59e]:hover {\n      color: white;\n      background: #DC3545; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-ff12d59e", module.exports)
  } else {
    hotAPI.update("_v-ff12d59e", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/promise":59,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],962:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _membershipContractTransferStart = require('./membership-contract-transfer-start.vue');

var _membershipContractTransferStart2 = _interopRequireDefault(_membershipContractTransferStart);

var _membershipContractTransferSuccessCode = require('./membership-contract-transfer-success-code.vue');

var _membershipContractTransferSuccessCode2 = _interopRequireDefault(_membershipContractTransferSuccessCode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('membership-contract-transfer-start', _membershipContractTransferStart2.default);
_vue2.default.component('membership-contract-transfer-success-code', _membershipContractTransferSuccessCode2.default);

},{"./membership-contract-transfer-start.vue":963,"./membership-contract-transfer-success-code.vue":964,"vue":792}],963:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.transfer-group[_v-d42cc5be] {\n  margin-bottom: 24px;\n  font-weight: 500; }\n  /* line 5, stdin */\n  .transfer-group label[_v-d42cc5be] {\n    color: #28b0e3;\n    font-size: 18px; }\n  /* line 9, stdin */\n  .transfer-group .show-text[_v-d42cc5be] {\n    font-size: 20px; }\n  /* line 12, stdin */\n  .transfer-group .alert-info[_v-d42cc5be] {\n    text-align: left; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        id: {
            default: null,
            require: true
        },
        name: {
            default: null,
            require: true
        },
        type: {
            default: null,
            require: true
        },
        unused: {
            default: null,
            require: true
        }
    },
    data: function data() {
        return {
            step: 'init',
            changeValue: 0,
            ajaxing: {
                fetchCode: false
            }
        };
    },

    watch: {
        id: function id(newVal) {
            this.step = 'init';
        }
    },
    computed: {
        expectedValue: function expectedValue() {
            return this.unused - this.changeValue;
        },
        typeText: function typeText() {
            switch (this.type) {
                case 2:
                    return '點';
                    break;

                case 3:
                    return '次';
                    break;

                default:
                    break;
            }
        },
        stepTitle: function stepTitle() {
            if (this.step == 'init') {
                return '開始轉贈';
            }
            if (this.step == 'confirm') {
                return '確認轉贈';
            }
        }
    },
    mounted: function mounted() {},

    methods: {
        changeStep: function changeStep(step) {
            this.step = step;
            this.$emit('change-title', this.stepTitle);
        },
        creating: function creating() {
            var _this = this;

            this.ajaxing.fetchCode = true;
            var data = {
                id: this.id,
                value: this.changeValue
            };
            this.$http.post('/webapi/member-contract/' + this.id + '/transfer/create', data).then(function (response) {
                _this.ajaxing.fetchCode = false;
                var receive = response.data;
                _this.$emit('transferred', {
                    'code': receive.code,
                    'url': receive.url
                });
            }, function (error) {
                $17.swal({
                    title: error.body.message,
                    type: 'warning',
                    showCancelButton: false
                });
                _this.ajaxing.fetchCode = false;
            });
        },
        closed: function closed() {
            this.step = 'init';
            this.$emit('closed');
        },
        changeToCheckTransfer: function changeToCheckTransfer() {
            if (this.changeValue <= 0 || this.changeValue > this.unused) {
                $17.swal({
                    title: '轉贈價值須介於0~' + this.unused + '之間',
                    type: 'warning',
                    showCancelButton: false
                });
                return;
            }
            this.changeStep('confirm');
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-d42cc5be=\"\">\n    <v-spinner :ajaxing=\"ajaxing.fetchCode\" _v-d42cc5be=\"\"></v-spinner>\n    <div class=\"contract-trans\" v-show=\"!ajaxing.fetchCode\" _v-d42cc5be=\"\">\n        <div class=\"transfer-group\" _v-d42cc5be=\"\">\n            <label for=\"\" _v-d42cc5be=\"\">方案名稱</label>\n            <div class=\"show-text\" _v-d42cc5be=\"\">{{name}}</div>\n        </div>\n        <div class=\"transfer-group\" _v-d42cc5be=\"\">\n            <label for=\"\" _v-d42cc5be=\"\">目前剩餘</label>\n            <div class=\"show-text\" _v-d42cc5be=\"\">{{unused}}{{typeText}}</div>\n        </div>\n        <div class=\"transfer-group\" _v-d42cc5be=\"\">\n            <label for=\"\" _v-d42cc5be=\"\">轉贈價值(點數或次數)</label>\n            <div v-show=\"step=='init'\" _v-d42cc5be=\"\">\n                <input type=\"number\" name=\"\" min=\"1\" :max=\"unused\" v-model=\"changeValue\" _v-d42cc5be=\"\">\n            </div>\n            <div v-show=\"step=='confirm'\" _v-d42cc5be=\"\">\n                <div class=\"show-text\" _v-d42cc5be=\"\">{{changeValue}}{{typeText}}</div>\n            </div>\n        </div>\n        <div class=\"transfer-group\" _v-d42cc5be=\"\">\n            <label for=\"\" _v-d42cc5be=\"\">預計剩餘</label>\n            <div _v-d42cc5be=\"\">\n                <div class=\"show-text\" _v-d42cc5be=\"\">{{expectedValue}}{{typeText}}</div>\n            </div>\n        </div>\n        <div class=\"transfer-group text-center\" v-show=\"step=='init'\" _v-d42cc5be=\"\">\n            <div class=\"btn btn--gray btn-lg\" @click=\"closed\" _v-d42cc5be=\"\">取消</div>\n            <div class=\"btn btn-primary btn-lg\" @click=\"changeToCheckTransfer()\" _v-d42cc5be=\"\">確認轉贈內容</div>\n        </div>\n        <div class=\"transfer-group text-center\" v-show=\"step=='confirm'\" _v-d42cc5be=\"\">\n        <div class=\"alert alert-info\" role=\"alert\" _v-d42cc5be=\"\">\n            按下產生轉贈碼後，原方案內的點數或次數將立即扣除。產生後如需調整，請再透過<strong _v-d42cc5be=\"\">轉贈管理</strong>進行。\n        </div>\n        </div>\n        <div class=\"transfer-group text-center\" v-show=\"step=='confirm'\" _v-d42cc5be=\"\">\n            <div class=\"btn btn--gray btn-lg\" @click=\"changeStep('init')\" _v-d42cc5be=\"\">上一步</div>\n            <div class=\"btn btn-primary btn-lg\" @click=\"creating()\" _v-d42cc5be=\"\">產生轉贈碼</div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.transfer-group[_v-d42cc5be] {\n  margin-bottom: 24px;\n  font-weight: 500; }\n  /* line 5, stdin */\n  .transfer-group label[_v-d42cc5be] {\n    color: #28b0e3;\n    font-size: 18px; }\n  /* line 9, stdin */\n  .transfer-group .show-text[_v-d42cc5be] {\n    font-size: 20px; }\n  /* line 12, stdin */\n  .transfer-group .alert-info[_v-d42cc5be] {\n    text-align: left; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-d42cc5be", module.exports)
  } else {
    hotAPI.update("_v-d42cc5be", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],964:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.transfer-group[_v-30e80788] {\n  margin-bottom: 24px; }\n  /* line 4, stdin */\n  .transfer-group .code-text[_v-30e80788] {\n    font-weight: 700;\n    font-size: 24px; }\n  /* line 8, stdin */\n  .transfer-group .code-title[_v-30e80788] {\n    color: #28b0e3;\n    font-size: 18px; }\n  /* line 12, stdin */\n  .transfer-group .code-block[_v-30e80788] {\n    font-size: 24px;\n    font-weight: 700;\n    word-break: break-all; }\n  /* line 17, stdin */\n  .transfer-group .success_copy[_v-30e80788] {\n    color: #449D44;\n    font-size: 14px; }\n\n/* line 22, stdin */\n#code[_v-30e80788] {\n  max-width: 75%; }\n\n/* line 25, stdin */\n.check[_v-30e80788] {\n  font-size: 90px;\n  color: #A5DC86; }\n\n/* line 29, stdin */\n.link-url[_v-30e80788] {\n  border: 1px solid #CED4DA;\n  border-radius: 5px;\n  padding: 8px 16px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap; }\n\n/* line 37, stdin */\n.fa-clone[_v-30e80788] {\n  font-size: 24px;\n  margin-left: 12px; }\n\n/* line 41, stdin */\n.phone-mode[_v-30e80788] {\n  display: block; }\n\n/* line 44, stdin */\n.phone-mode-show[_v-30e80788] {\n  display: none; }\n\n@media screen and (max-width: 767px) {\n  /* line 48, stdin */\n  .phone-mode[_v-30e80788] {\n    display: none; }\n  /* line 51, stdin */\n  .phone-mode-show[_v-30e80788] {\n    display: block; }\n  /* line 54, stdin */\n  .success_copy[_v-30e80788] {\n    display: block;\n    text-align: center; } }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        code: {
            default: null,
            require: true
        },
        url: {
            default: null,
            require: true
        },
        showType: {
            default: 'success',
            require: false
        },
        unused: {
            default: null,
            require: true
        }
    },
    data: function data() {
        return {
            step: 'init',
            changeValue: 0,
            ajaxing: {
                fetchCode: false
            },
            successCopyStatus: false,
            successUrlCopyStatus: false
        };
    },

    computed: {
        successType: function successType() {
            return this.showType == 'success';
        },
        codeType: function codeType() {
            return this.showType == 'code';
        }
    },
    mounted: function mounted() {
        this.changeStep();
    },

    methods: {
        changeStep: function changeStep() {
            if (this.successType) {
                this.$emit('change-title', '產生轉贈碼');
            }
            if (this.codeType) {
                this.$emit('change-title', '查看轉贈碼');
            }
        },
        closed: function closed() {
            this.$emit('closed');
        },
        copy: function copy(code, status) {
            var _this = this;

            var aux = document.createElement("input");

            aux.setAttribute("value", code);

            document.body.appendChild(aux);
            aux.select();
            document.execCommand("copy");
            document.body.removeChild(aux);

            this[status] = true;
            setTimeout(function () {
                _this[status] = false;
            }, 3000);
        },
        cancel: function cancel() {
            this.$emit('cancel');
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"contract-trans\" _v-30e80788=\"\">\n    <div class=\"transfer-group text-center check\" v-show=\"successType\" _v-30e80788=\"\">\n        <i class=\"fa fa-check-circle-o\" aria-hidden=\"true\" _v-30e80788=\"\"></i>\n    </div>\n    <div class=\"transfer-group text-center\" _v-30e80788=\"\">\n        <span class=\"code-title\" _v-30e80788=\"\">轉贈碼</span>\n    </div>\n    <div class=\"transfer-group text-center\" _v-30e80788=\"\">\n        <span class=\"code-block\" _v-30e80788=\"\">{{ code }}</span>\n        <a @click.stop.prevent=\"copy(code,'successCopyStatus')\" target=\"_blank\" _v-30e80788=\"\">\n            <i class=\"fa fa-clone\" aria-hidden=\"true\" _v-30e80788=\"\"></i>\n        </a>\n        <div class=\"success_copy\" v-show=\"successCopyStatus\" _v-30e80788=\"\">\n            複製成功!\n        </div>\n    </div>\n    <div class=\"transfer-group phone-mode\" _v-30e80788=\"\">\n        <div class=\"alert alert-info\" role=\"alert\" _v-30e80788=\"\">\n            <ul _v-30e80788=\"\">\n                <li _v-30e80788=\"\">轉贈方案超過期限，或是超過一年尚未領取會自動失效</li>\n                <li _v-30e80788=\"\">轉贈方案送出且經受贈方領取後，退還需洽場館人員</li>\n            </ul>\n       </div>\n    </div>\n    <div class=\"transfer-group\" _v-30e80788=\"\">\n        <span class=\"code-title\" _v-30e80788=\"\">分享連結</span>\n    </div>\n    <div class=\"transfer-group link-url\" _v-30e80788=\"\">\n        <a @click=\"copy(url,'successUrlCopyStatus')\" _v-30e80788=\"\">{{url}}</a>\n    </div>\n    <div class=\"transfer-group text-center\" _v-30e80788=\"\">\n        <div class=\"success_copy\" v-show=\"successUrlCopyStatus\" _v-30e80788=\"\">\n            複製成功!\n        </div>\n    </div>\n    <div class=\"transfer-group phone-mode-show\" _v-30e80788=\"\">\n        <div class=\"alert alert-info\" role=\"alert\" _v-30e80788=\"\">\n            <ul _v-30e80788=\"\">\n                <li _v-30e80788=\"\">轉贈方案超過期限，或是超過一年尚未領取會自動失效</li>\n                <li _v-30e80788=\"\">轉贈方案送出且經受贈方領取後，退還需洽場館人員</li>\n            </ul>\n       </div>\n    </div>\n    <div class=\"transfer-group text-center\" _v-30e80788=\"\">\n        <div class=\"btn btn-danger btn--inverse btn-lg\" v-show=\"codeType\" @click=\"cancel()\" _v-30e80788=\"\">刪除轉贈碼</div>\n        <div class=\"btn btn-primary btn-lg\" @click=\"closed()\" _v-30e80788=\"\">確認</div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.transfer-group[_v-30e80788] {\n  margin-bottom: 24px; }\n  /* line 4, stdin */\n  .transfer-group .code-text[_v-30e80788] {\n    font-weight: 700;\n    font-size: 24px; }\n  /* line 8, stdin */\n  .transfer-group .code-title[_v-30e80788] {\n    color: #28b0e3;\n    font-size: 18px; }\n  /* line 12, stdin */\n  .transfer-group .code-block[_v-30e80788] {\n    font-size: 24px;\n    font-weight: 700;\n    word-break: break-all; }\n  /* line 17, stdin */\n  .transfer-group .success_copy[_v-30e80788] {\n    color: #449D44;\n    font-size: 14px; }\n\n/* line 22, stdin */\n#code[_v-30e80788] {\n  max-width: 75%; }\n\n/* line 25, stdin */\n.check[_v-30e80788] {\n  font-size: 90px;\n  color: #A5DC86; }\n\n/* line 29, stdin */\n.link-url[_v-30e80788] {\n  border: 1px solid #CED4DA;\n  border-radius: 5px;\n  padding: 8px 16px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap; }\n\n/* line 37, stdin */\n.fa-clone[_v-30e80788] {\n  font-size: 24px;\n  margin-left: 12px; }\n\n/* line 41, stdin */\n.phone-mode[_v-30e80788] {\n  display: block; }\n\n/* line 44, stdin */\n.phone-mode-show[_v-30e80788] {\n  display: none; }\n\n@media screen and (max-width: 767px) {\n  /* line 48, stdin */\n  .phone-mode[_v-30e80788] {\n    display: none; }\n  /* line 51, stdin */\n  .phone-mode-show[_v-30e80788] {\n    display: block; }\n  /* line 54, stdin */\n  .success_copy[_v-30e80788] {\n    display: block;\n    text-align: center; } }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-30e80788", module.exports)
  } else {
    hotAPI.update("_v-30e80788", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],965:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _list = require('./list.vue');

var _list2 = _interopRequireDefault(_list);

var _modal = require('./modal.vue');

var _modal2 = _interopRequireDefault(_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('messages-list', _list2.default);
_vue2.default.component('messages-modal', _modal2.default);

},{"./list.vue":966,"./modal.vue":967,"vue":792}],966:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.title[_v-297b1bca] {\n  font-weight: bold; }\n\n/* line 5, stdin */\np[_v-297b1bca] {\n  font-size: 1.25em; }\n\n/* line 8, stdin */\nhr[_v-297b1bca] {\n  margin: 0; }\n\n/* line 11, stdin */\n.message-content[_v-297b1bca] {\n  cursor: pointer;\n  padding-top: 15px;\n  padding-bottom: 5px; }\n\n/* line 16, stdin */\n.show-all[_v-297b1bca] {\n  margin-top: 20px; }\n\n/* line 19, stdin */\n.gray[_v-297b1bca] {\n  color: #c0c0c0; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    data: function data() {
        return {
            list: [],
            openId: null,
            ajaxing: false
        };
    },
    watch: {},
    methods: {
        getData: function getData(showAll) {
            var _this = this;

            this.ajaxing = true;
            this.$http.get('/webapi/messages/').then(function (response) {
                _this.ajaxing = false;
                _this.list = response.body;
            }, function (error) {
                _this.ajaxing = false;
            });
        },
        openDetail: function openDetail(id) {
            this.openId = id;
            $("#message-modal").modal('show');
        }
    },
    created: function created() {
        this.getData();
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"container\" _v-297b1bca=\"\">\n    <div class=\"row\" _v-297b1bca=\"\">\n        <div class=\"col-xs-12 col-sm-11 col-sm-offset-1\" _v-297b1bca=\"\">\n            <h4 _v-297b1bca=\"\">{{i18n.t('messages.my_message')}}</h4>\n        </div>\n    </div>\n    <v-spinner :ajaxing=\"ajaxing\" _v-297b1bca=\"\"></v-spinner>\n    <template v-for=\"item in list\" v-show=\"!ajaxing\">\n        <div class=\"row\" _v-297b1bca=\"\">\n            <div class=\"col-xs-12 col-sm-11 col-sm-offset-1\" _v-297b1bca=\"\">\n                <hr _v-297b1bca=\"\">\n            </div>\n        </div>\n        <div class=\"row message-content\" @click=\"openDetail(item.id)\" _v-297b1bca=\"\">\n            <div class=\"col-xs-1 col-sm-1 col-sm-offset-1\" _v-297b1bca=\"\">\n                <p v-show=\"item.isRead\" class=\"color-success\" _v-297b1bca=\"\">\n                    <i class=\"fa fa-check\" _v-297b1bca=\"\"></i>\n                </p>\n            </div>\n            <div class=\"col-xs-2 col-sm-1\" _v-297b1bca=\"\">\n                <p class=\"date gray text-right\" _v-297b1bca=\"\">{{ item.sentDate }}</p>\n            </div>\n            <div class=\"col-xs-3 col-sm-2\" _v-297b1bca=\"\">\n                <p class=\"title\" _v-297b1bca=\"\">\n                    {{ item.studioName }}\n                </p>\n            </div>\n            <div class=\"col-xs-6 col-sm-7\" _v-297b1bca=\"\">\n                <p class=\"title\" _v-297b1bca=\"\">\n                    {{ item.title }}\n                    <span v-show=\"item.preview.length>0\" class=\"p-left-5 p-right-5\" _v-297b1bca=\"\">-</span>\n                    <span class=\"gray\" _v-297b1bca=\"\">\n                        {{ item.preview }}\n                    </span>\n                </p>\n            </div>\n        </div>\n    </template>\n    <messages-modal :id=\"this.openId\" _v-297b1bca=\"\"></messages-modal>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.title[_v-297b1bca] {\n  font-weight: bold; }\n\n/* line 5, stdin */\np[_v-297b1bca] {\n  font-size: 1.25em; }\n\n/* line 8, stdin */\nhr[_v-297b1bca] {\n  margin: 0; }\n\n/* line 11, stdin */\n.message-content[_v-297b1bca] {\n  cursor: pointer;\n  padding-top: 15px;\n  padding-bottom: 5px; }\n\n/* line 16, stdin */\n.show-all[_v-297b1bca] {\n  margin-top: 20px; }\n\n/* line 19, stdin */\n.gray[_v-297b1bca] {\n  color: #c0c0c0; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-297b1bca", module.exports)
  } else {
    hotAPI.update("_v-297b1bca", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],967:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.logo[_v-49f6bd80] {\n  max-width: 100%; }\n\n/* line 6, stdin */\n.message-content[_v-49f6bd80] {\n  width: 90%;\n  margin: 20px auto; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vuex = require('vuex');

exports.default = {
    mounted: function mounted() {},

    data: function data() {
        return {
            content: [],
            sentTime: null,
            setudioLogoSrc: null,
            studioName: null,
            title: null,
            ajaxing: false
        };
    },
    props: ['id'],
    computed: {},
    methods: {
        submit: function submit() {
            $(this.$el).modal('hide');
        },
        getContentComponent: function getContentComponent(contentItem) {
            switch (contentItem.dataType) {
                case 'text':
                    return 'v-messages-text-content';
                case 'gallery':
                    return 'v-messages-gallery-content';
                case 'action_buy':
                    return 'v-messages-action-buy-content';
                case 'action_url':
                    return 'v-messages-action-url-content';
                default:
                    break;
            }
        }
    },
    watch: {
        id: function id(val) {
            var _this = this;

            if (val == null) {
                return;
            }
            this.ajaxing = true;
            this.$http.get('/webapi/messages/' + val).then(function (response) {
                _this.ajaxing = false;
                _this.content = response.data.content;
                _this.sentTime = response.data.sentTime;
                _this.setudioLogoSrc = response.data.setudioLogo;
                _this.studioName = response.data.studioName;
                _this.title = response.data.title;
            }, function (error) {
                _this.ajaxing = false;
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal id=\"message-modal\" :save-clicked=\"submit\" :remove-btn-show=\"false\" no-cancel=\"\" confirm-btn-text=\"關閉\" _v-49f6bd80=\"\">\n    <span slot=\"title\" _v-49f6bd80=\"\">通知內容</span>\n    <template slot=\"body\">\n        <v-spinner :ajaxing=\"ajaxing\" _v-49f6bd80=\"\"></v-spinner>\n        <template v-if=\"!ajaxing\">\n            <div class=\"row\" _v-49f6bd80=\"\">\n                <div class=\"col-xs-12\" _v-49f6bd80=\"\">\n                    <p class=\"title\" _v-49f6bd80=\"\">{{title}}</p>\n                </div>\n            </div>\n            <div class=\"row\" _v-49f6bd80=\"\">\n                <div class=\"col-xs-12\" _v-49f6bd80=\"\">\n                    <div class=\"col-xs-4 col-sm-2\" _v-49f6bd80=\"\">\n                        <img :src=\"setudioLogoSrc\" onerror=\"this.src ='/images/blank.gif';\" class=\"logo\" _v-49f6bd80=\"\">\n                    </div>\n                    <div class=\"col-xs-8 col-sm-10\" _v-49f6bd80=\"\">\n                        <div class=\"row\" _v-49f6bd80=\"\">\n                            <div class=\"col-xs-12\" _v-49f6bd80=\"\">{{studioName}}</div>\n                            <div class=\"col-xs-12\" _v-49f6bd80=\"\">{{sentTime}}</div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"row\" _v-49f6bd80=\"\">\n                <div class=\"col-xs-12\" _v-49f6bd80=\"\">\n                    <div class=\"content message-content\" _v-49f6bd80=\"\">\n                        <div class=\"row\" v-for=\"row in content\" _v-49f6bd80=\"\">\n                            <div class=\"col-xs-12\" _v-49f6bd80=\"\">\n                                <component :is=\"getContentComponent(row)\" :data=\"row\" :member-message-id=\"id\" _v-49f6bd80=\"\"></component>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </template>\n    </template>\n</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.logo[_v-49f6bd80] {\n  max-width: 100%; }\n\n/* line 6, stdin */\n.message-content[_v-49f6bd80] {\n  width: 90%;\n  margin: 20px auto; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-49f6bd80", module.exports)
  } else {
    hotAPI.update("_v-49f6bd80", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],968:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _standardConfirm = require('./standard-confirm.vue');

var _standardConfirm2 = _interopRequireDefault(_standardConfirm);

var _unpaidNotification = require('./unpaid-notification.vue');

var _unpaidNotification2 = _interopRequireDefault(_unpaidNotification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('standard-payment-confirm', _standardConfirm2.default);
_vue2.default.component('latest-unpaid-notification', _unpaidNotification2.default);

},{"./standard-confirm.vue":969,"./unpaid-notification.vue":970,"vue":792}],969:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    data: function data() {
        return {
            payment: {},
            isSuccess: true,
            ajaxing: false,
            btnClass: ['st-justify-center']
        };
    },
    mounted: function mounted() {
        this.fetchData();
    },

    methods: {
        fetchData: function fetchData() {
            var _this = this;

            var params = $17.getUrlQueryStrings();
            if (!params.hasOwnProperty('order_id') || !params.hasOwnProperty('payment_action_record_id')) {
                this.isSuccess = false;
                return;
            }
            this.ajaxing = true;
            this.$http.get('/webapi/payment-success-info/order/' + params.order_id + '?payment_action_record_id=' + params.payment_action_record_id).then(function (response) {
                _this.payment = response.data;
                _this.isSuccess = true;
                _this.ajaxing = false;
            }).catch(function (error) {
                console.log(error);
                _this.isSuccess = false;
                _this.ajaxing = false;
            });
        },
        forwardPayment: function forwardPayment() {
            window.open(this.payment['payment-link'], '_self');
        },
        forwardMyAccount: function forwardMyAccount() {
            window.open('/my-account', '_self');
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"st-max-w-sm st-mx-auto st-my-16 st-w-full st-text-black st-text-center\">\n    <v-spinner :ajaxing=\"ajaxing\"></v-spinner>\n    <div v-show=\"!ajaxing\">\n        <div v-show=\"isSuccess\">\n            <div class=\"st-mb-8\"><img class=\"st-w-28 st-h-28\" src=\"/images/icon/confirm-check.svg\"></div>\n            <div>{{ i18n.t('payment.order_confirmation') }}</div>\n            <div>\n                {{ i18n.t('payment.payment_time_remind_first') }}\n                <span class=\"st-text-danger\">{{ payment['payment-expire-time'] }}</span>\n            </div>\n            <hr>\n            <div class=\"st-font-regular st-inline-flex st-items-center st-mb-8 st-text-neutral\">\n                <span class=\"material-icons\">info_outline</span>\n                {{ i18n.t('payment.payment_expire_note') }}\n            </div>                \n        </div>\n        <div v-show=\"!isSuccess\">\n            <div>\n                <span class=\"material-icons st-text-danger st-text-42\">error</span>\n            </div>\n            <div>\n                {{ i18n.t('general.unknown_error_try_again') }}\n            </div>\n        </div>\n        <div class=\"st-px-2 st-space-y-4\">\n            <st-button type=\"primary\" :text=\"i18n.t('payment.forward_to_payment')\" :btn-class=\"btnClass\" full=\"\" filled=\"\" @click=\"forwardPayment\" v-show=\"isSuccess\"></st-button>\n            <st-button type=\"primary\" :text=\"i18n.t('payment.back_to_myaccount')\" :btn-class=\"btnClass\" full=\"\" outline=\"\" @click=\"forwardMyAccount\"></st-button>\n        </div>            \n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-519f2fe4", module.exports)
  } else {
    hotAPI.update("_v-519f2fe4", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],970:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    data: function data() {
        return {
            isShow: false,
            notification: {}
        };
    },
    mounted: function mounted() {
        var path = location.pathname.split('/')[1];
        if (path == 'my-account') {
            this.fetchLatestUnpaidOrderByMember();
        }
    },

    methods: {
        fetchLatestUnpaidOrderByMember: function fetchLatestUnpaidOrderByMember() {
            var _this = this;

            this.$http.get('/webapi/member/unpaid-order/first').then(function (response) {
                _this.notification = response.data;
                _this.isShow = new Date() < new Date(_this.notification['payment-expire-time']);
            }).catch(function (error) {
                _this.isShow = false;
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"container\" v-if=\"isShow\">\n    <div class=\"st-bg-yellow/20 st-border st-border-yellow st-border-solid st-flex st-items-center st-mt-5 st-p-3 st-rounded-4 st-space-x-2 st-text-16\">\n        <span class=\"material-icons st-mr-1\">info_outline</span>\n        {{ i18n.t('payment.latest_unpaid_order_alert', { expire_time: notification['payment-expire-time'] }) }}\n        <span class=\"st-bg-yellow st-h-4 st-w-[1px]\"></span>\n        <a class=\"hover:st-text-black hover:st-underline st-text-black\" :href=\"notification['payment-link']\" target=\"_self\">{{ i18n.t('payment.forward_check_up') }}</a>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-12f24e65", module.exports)
  } else {
    hotAPI.update("_v-12f24e65", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],971:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _promotionContract = require('./promotion-contract.vue');

var _promotionContract2 = _interopRequireDefault(_promotionContract);

var _promotionContractContent = require('./promotion-contract-content.vue');

var _promotionContractContent2 = _interopRequireDefault(_promotionContractContent);

var _paymentPanel = require('./payment-panel.vue');

var _paymentPanel2 = _interopRequireDefault(_paymentPanel);

var _mapModal = require('./map-modal.vue');

var _mapModal2 = _interopRequireDefault(_mapModal);

var _ratingStar = require('../rating/rating-star.vue');

var _ratingStar2 = _interopRequireDefault(_ratingStar);

var _commentsModal = require('../rating/comments-modal.vue');

var _commentsModal2 = _interopRequireDefault(_commentsModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('promotion-contract', _promotionContract2.default);
_vue2.default.component('promotion-contract-content', _promotionContractContent2.default);
_vue2.default.component('payment-panel', _paymentPanel2.default);
_vue2.default.component('map-modal', _mapModal2.default);

_vue2.default.component('rating-star', _ratingStar2.default);
_vue2.default.component('comment-modal-vue', _commentsModal2.default);

},{"../rating/comments-modal.vue":988,"../rating/rating-star.vue":991,"./map-modal.vue":972,"./payment-panel.vue":973,"./promotion-contract-content.vue":974,"./promotion-contract.vue":975,"vue":792}],972:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        modalTitle: {
            type: String
        },
        coordinate: {
            required: true
        }
    },
    data: function data() {
        return {};
    },

    watch: {
        coordinate: {
            deep: true,
            immediate: true,
            handler: function handler(newVal, oldVal) {
                if (newVal) {
                    this.getLocationFromCoordinate();
                }
            }
        }
    },
    mounted: function mounted() {},

    methods: {
        getLocationFromCoordinate: function getLocationFromCoordinate() {
            var _this = this;

            var coordinate = this.coordinate.split(',');
            var location = { lat: parseFloat(coordinate[0]), lng: parseFloat(coordinate[1]) };
            this.map = new google.maps.Map(document.getElementById('googleMapBody'), {
                center: location,
                scrollwheel: false,
                scaleControl: true,
                zoom: 16
            });

            var infowindow = new google.maps.InfoWindow();
            infowindow.setContent('<b>' + this.modalTitle + '</b>');

            var marker = new google.maps.Marker({ map: this.map, position: location });
            marker.addListener('click', function () {
                infowindow.open(_this.map, marker);
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-77841160=\"\">\n    <v-modal id=\"map-modal\" class=\"map-modal-vue\" border-radius-level=\"20px\" no-footer=\"\" _v-77841160=\"\">\n        <div slot=\"title\" _v-77841160=\"\">\n            {{modalTitle}}\n        </div>\n        <div slot=\"body\" style=\"height: 300px;\" _v-77841160=\"\">\n            <div id=\"googleMapBody\" style=\"height: 100%;\" _v-77841160=\"\"></div>\n        </div>\n    </v-modal>\n\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-77841160", module.exports)
  } else {
    hotAPI.update("_v-77841160", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],973:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n#payment-panel[_v-01768551] {\n  font-family: PingFangTC; }\n  /* line 5, stdin */\n  #payment-panel .sticky-height[_v-01768551] {\n    background: #fff;\n    display: inline-block;\n    height: var(--fixpanel-height); }\n  /* line 10, stdin */\n  #payment-panel div.sticky[_v-01768551] {\n    width: 95%;\n    max-width: 640px;\n    position: -webkit-sticky;\n    position: sticky;\n    top: 72px;\n    padding: 20px;\n    background-color: #fff;\n    font-size: 20px;\n    box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15), 0 -1px 15px 0 rgba(138, 138, 138, 0.3);\n    border-radius: 8px;\n    display: inline-block;\n    margin: 0.5rem 1rem; }\n  /* line 24, stdin */\n  #payment-panel .title[_v-01768551] {\n    font-size: 26px;\n    font-weight: 500;\n    color: #1f1f1f;\n    margin-bottom: 14px; }\n  /* line 30, stdin */\n  #payment-panel .studio-name[_v-01768551] {\n    font-size: 16px;\n    font-weight: 500;\n    color: #4a4a4a; }\n  /* line 35, stdin */\n  #payment-panel .contract[_v-01768551] {\n    font-size: 21px;\n    font-weight: 600;\n    color: #4a4a4a;\n    margin: 23px 0 20px 0; }\n  /* line 41, stdin */\n  #payment-panel .price[_v-01768551] {\n    font-size: 36px;\n    font-weight: 500;\n    color: #00488e; }\n  /* line 46, stdin */\n  #payment-panel .stars[_v-01768551] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: baseline;\n        align-items: baseline; }\n  /* line 50, stdin */\n  #payment-panel .stars-remark[_v-01768551] {\n    font-size: 16px;\n    margin-left: 5px;\n    color: #9b9b9b; }\n  /* line 55, stdin */\n  #payment-panel .pay-button[_v-01768551] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n    -ms-flex-pack: center;\n        justify-content: center; }\n  /* line 60, stdin */\n  #payment-panel .show-on-fix-bottom[_v-01768551] {\n    display: none; }\n\n@media (max-width: 992px) {\n  /* line 68, stdin */\n  #payment-panel div.sticky[_v-01768551] {\n    position: relative;\n    top: 0;\n    width: 95%;\n    max-width: 640px;\n    height: auto;\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n    margin-bottom: 0;\n    padding-bottom: 0;\n    box-shadow: none;\n    padding-top: 5px; }\n  /* line 82, stdin */\n  #payment-panel .sticky-height[_v-01768551] {\n    height: 0 !important; }\n  /* line 85, stdin */\n  #payment-panel .contract[_v-01768551] {\n    margin: 23px 0 0 0; }\n  /* line 88, stdin */\n  #payment-panel .btn[_v-01768551] {\n    margin: 0; }\n  /* line 91, stdin */\n  #payment-panel .fix-btn[_v-01768551] {\n    background-color: #ffffff;\n    padding: 5px 8px;\n    box-shadow: 0 -1px 11px 0 rgba(0, 0, 0, 0.16);\n    position: fixed;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n    z-index: 10; }\n  /* line 101, stdin */\n  #payment-panel .pay-button[_v-01768551] {\n    -ms-flex-pack: justify;\n        justify-content: space-between; }\n  /* line 104, stdin */\n  #payment-panel .show-on-fix-bottom[_v-01768551] {\n    display: inline; }\n  /* line 107, stdin */\n  #payment-panel .hide-on-fix-bottom[_v-01768551] {\n    display: none; } }\n\n@media all and (min-height: 650px) {\n  /* line 115, stdin */\n  #payment-panel .fix-btn[_v-01768551] {\n    padding: 5px 8px 1.5em 8px;\n    transition: bottom 0.3s; } }\n")
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        containerHeight: {
            type: Number,
            default: 500
        },
        promotionInfo: {
            required: true
        },
        link: {}
    },
    data: function data() {
        return {
            prevScrollpos: window.pageYOffset
        };
    },
    created: function created() {
        window.addEventListener('scroll', this.handleScroll);
    },

    computed: {
        noComments: function noComments() {
            return this.promotionInfo.score_count <= 0;
        }
    },
    methods: {
        height: function height() {
            return this.containerHeight + Number(300);
        },
        handleScroll: function handleScroll(event) {
            var currentScrollPos = window.pageYOffset;
            if (this.prevScrollpos < currentScrollPos) {
                document.getElementById("fix-btn").style.bottom = "0";
            } else {
                document.getElementById("fix-btn").style.bottom = "-75px";
            }
            this.prevScrollpos = currentScrollPos;
        }
    },
    destroyed: function destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div id=\"payment-panel\" _v-01768551=\"\">\n    <div class=\"sticky\" _v-01768551=\"\">\n        <div class=\"title\" _v-01768551=\"\">{{promotionInfo.promotion_title}}</div>\n        <div class=\"studio-name\" _v-01768551=\"\">{{promotionInfo.branch_name}}</div>\n        <div class=\"stars\" v-if=\"!noComments\" _v-01768551=\"\">\n            <rating-star :rating=\"promotionInfo.score_avg\" _v-01768551=\"\"></rating-star>\n            <div class=\"stars-remark\" _v-01768551=\"\">({{promotionInfo.score_count}})</div>\n        </div>\n        <div class=\"contract\" _v-01768551=\"\">{{promotionInfo.contract_name}}</div>\n        <div class=\"price hide-on-fix-bottom\" _v-01768551=\"\">{{promotionInfo.currency}} {{promotionInfo.price}}</div>\n        <div class=\"fix-btn\" id=\"fix-btn\" _v-01768551=\"\">\n            <a :href=\"link\" target=\"__blank\" type=\"button\" class=\"btn btn-info btn-lg btn-block m-top-15\" _v-01768551=\"\">\n                <div class=\"pay-button\" _v-01768551=\"\">\n                    <i class=\"fa fa-shopping-cart p-right-5\" aria-hidden=\"true\" _v-01768551=\"\"></i>\n                    <div _v-01768551=\"\">前往購買</div>\n                    <div class=\"show-on-fix-bottom\" _v-01768551=\"\">{{promotionInfo.currency}} {{promotionInfo.price}}</div>\n                </div>\n            </a>\n        </div>\n    </div>\n    <div class=\"sticky-height\" :style=\"'--fixpanel-height:'+ height() +'px;'\" _v-01768551=\"\"></div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n#payment-panel[_v-01768551] {\n  font-family: PingFangTC; }\n  /* line 5, stdin */\n  #payment-panel .sticky-height[_v-01768551] {\n    background: #fff;\n    display: inline-block;\n    height: var(--fixpanel-height); }\n  /* line 10, stdin */\n  #payment-panel div.sticky[_v-01768551] {\n    width: 95%;\n    max-width: 640px;\n    position: -webkit-sticky;\n    position: sticky;\n    top: 72px;\n    padding: 20px;\n    background-color: #fff;\n    font-size: 20px;\n    box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15), 0 -1px 15px 0 rgba(138, 138, 138, 0.3);\n    border-radius: 8px;\n    display: inline-block;\n    margin: 0.5rem 1rem; }\n  /* line 24, stdin */\n  #payment-panel .title[_v-01768551] {\n    font-size: 26px;\n    font-weight: 500;\n    color: #1f1f1f;\n    margin-bottom: 14px; }\n  /* line 30, stdin */\n  #payment-panel .studio-name[_v-01768551] {\n    font-size: 16px;\n    font-weight: 500;\n    color: #4a4a4a; }\n  /* line 35, stdin */\n  #payment-panel .contract[_v-01768551] {\n    font-size: 21px;\n    font-weight: 600;\n    color: #4a4a4a;\n    margin: 23px 0 20px 0; }\n  /* line 41, stdin */\n  #payment-panel .price[_v-01768551] {\n    font-size: 36px;\n    font-weight: 500;\n    color: #00488e; }\n  /* line 46, stdin */\n  #payment-panel .stars[_v-01768551] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: baseline;\n        align-items: baseline; }\n  /* line 50, stdin */\n  #payment-panel .stars-remark[_v-01768551] {\n    font-size: 16px;\n    margin-left: 5px;\n    color: #9b9b9b; }\n  /* line 55, stdin */\n  #payment-panel .pay-button[_v-01768551] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n    -ms-flex-pack: center;\n        justify-content: center; }\n  /* line 60, stdin */\n  #payment-panel .show-on-fix-bottom[_v-01768551] {\n    display: none; }\n\n@media (max-width: 992px) {\n  /* line 68, stdin */\n  #payment-panel div.sticky[_v-01768551] {\n    position: relative;\n    top: 0;\n    width: 95%;\n    max-width: 640px;\n    height: auto;\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n    margin-bottom: 0;\n    padding-bottom: 0;\n    box-shadow: none;\n    padding-top: 5px; }\n  /* line 82, stdin */\n  #payment-panel .sticky-height[_v-01768551] {\n    height: 0 !important; }\n  /* line 85, stdin */\n  #payment-panel .contract[_v-01768551] {\n    margin: 23px 0 0 0; }\n  /* line 88, stdin */\n  #payment-panel .btn[_v-01768551] {\n    margin: 0; }\n  /* line 91, stdin */\n  #payment-panel .fix-btn[_v-01768551] {\n    background-color: #ffffff;\n    padding: 5px 8px;\n    box-shadow: 0 -1px 11px 0 rgba(0, 0, 0, 0.16);\n    position: fixed;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n    z-index: 10; }\n  /* line 101, stdin */\n  #payment-panel .pay-button[_v-01768551] {\n    -ms-flex-pack: justify;\n        justify-content: space-between; }\n  /* line 104, stdin */\n  #payment-panel .show-on-fix-bottom[_v-01768551] {\n    display: inline; }\n  /* line 107, stdin */\n  #payment-panel .hide-on-fix-bottom[_v-01768551] {\n    display: none; } }\n\n@media all and (min-height: 650px) {\n  /* line 115, stdin */\n  #payment-panel .fix-btn[_v-01768551] {\n    padding: 5px 8px 1.5em 8px;\n    transition: bottom 0.3s; } }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-01768551", module.exports)
  } else {
    hotAPI.update("_v-01768551", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],974:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n#contract-nav[_v-250d2504] {\n  margin: 30px 0 10px 0;\n  font-size: 18px;\n  font-weight: 500; }\n  /* line 7, stdin */\n  #contract-nav .nav-tabs[_v-250d2504] {\n    border-bottom: none;\n    transform: translateX(-15px); }\n  /* line 11, stdin */\n  #contract-nav .nav-tabs > li.active > a[_v-250d2504], #contract-nav .nav-tabs > li.active > a[_v-250d2504]:hover, #contract-nav .nav-tabs > li.active > a[_v-250d2504]:focus {\n    color: #38b0e3;\n    cursor: default;\n    background-color: #fff;\n    border: none;\n    border-bottom-color: transparent; }\n  /* line 18, stdin */\n  #contract-nav .nav-tabs > li > a[_v-250d2504] {\n    color: #4a4a4a;\n    border: none; }\n  /* line 22, stdin */\n  #contract-nav .nav-tabs .right-border[_v-250d2504]:after {\n    content: '';\n    height: 45%;\n    width: 1px;\n    position: absolute;\n    right: 0;\n    top: 13px;\n    background-color: #979797; }\n  /* line 31, stdin */\n  #contract-nav .nav-tabs > li > a[_v-250d2504]:hover {\n    background-color: #fff;\n    border-color: #fff; }\n\n/* line 37, stdin */\n#contract-detail .detail-list-style[_v-250d2504] {\n  padding: 20px 0 20px 0; }\n\n/* line 40, stdin */\n#contract-detail .detail-list-style .content[_v-250d2504] {\n  position: relative;\n  margin: 15px 0;\n  text-align: justify;\n  font-size: 16px;\n  font-weight: normal;\n  line-height: 1.5;\n  letter-spacing: 0.5px;\n  white-space: pre-line; }\n\n/* line 50, stdin */\n#contract-detail .detail-list-header[_v-250d2504] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between; }\n\n/* line 54, stdin */\n#contract-detail .stars-remark[_v-250d2504] {\n  font-size: 12px;\n  font-weight: 500;\n  color: #4a4a4a; }\n\n/* line 59, stdin */\n#contract-detail .comments-link[_v-250d2504] {\n  font-size: 16px;\n  color: #38b0e3;\n  text-decoration: underline;\n  font-weight: 500; }\n\n/* line 65, stdin */\n#contract-detail .bottom-line[_v-250d2504] {\n  border-bottom: solid 1px #dddddd;\n  font-weight: 500;\n  color: #4a4a4a; }\n\n/* line 70, stdin */\n#contract-detail .list-title[_v-250d2504] {\n  font-size: 18px;\n  font-weight: 600;\n  color: #000;\n  padding-left: 5px;\n  border-left: 8px solid #38b0e3; }\n\n/* line 77, stdin */\n#contract-detail .display-flex[_v-250d2504] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: justify;\n      justify-content: space-between; }\n\n/* line 82, stdin */\n#contract-detail .external-link-btn[_v-250d2504] {\n  font-size: 16px;\n  border: none;\n  padding: 0;\n  text-decoration: underline;\n  color: #38b0e3; }\n  /* line 88, stdin */\n  #contract-detail .external-link-btn[_v-250d2504]:hover {\n    background-color: white; }\n  /* line 91, stdin */\n  #contract-detail .external-link-btn[_v-250d2504]:focus {\n    background-color: white; }\n  /* line 94, stdin */\n  #contract-detail .external-link-btn[_v-250d2504]:active {\n    background-color: white;\n    box-shadow: none; }\n\n/* line 99, stdin */\n#contract-detail .locate-btn[_v-250d2504] {\n  font-size: 18px;\n  padding: 8px 15px;\n  border-radius: 5px;\n  color: #00498e;\n  border: 1px solid #d2d9e2; }\n  /* line 105, stdin */\n  #contract-detail .locate-btn[_v-250d2504]:hover {\n    border: 1px solid #00498e; }\n  /* line 108, stdin */\n  #contract-detail .locate-btn[_v-250d2504]:active {\n    background-color: #e7eefe;\n    border: 1px solid #00498e; }\n\n@media (max-width: 992px) {\n  /* line 116, stdin */\n  #contract-nav[_v-250d2504] {\n    margin: 0;\n    text-align: center; }\n    /* line 120, stdin */\n    #contract-nav .nav-tabs[_v-250d2504] {\n      display: inline-block;\n      transform: translateX(0); }\n  /* line 126, stdin */\n  #contract-detail .de-flex-on-small[_v-250d2504] {\n    display: block; }\n  /* line 129, stdin */\n  #contract-detail .locate-btn[_v-250d2504] {\n    margin-top: 10px; } }\n\n/* line 3, stdin */\n#contract-content /deep/ .image img {\n  max-width: 100%;\n  height: auto; }\n\n/* line 9, stdin */\n#contract-content .image img {\n  max-width: 100%;\n  height: auto; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        promotionInfo: {
            required: true
        }
    },
    data: function data() {
        return {
            commentApiData: {},
            tab: 'contract'
        };
    },

    computed: {
        noComments: function noComments() {
            return this.promotionInfo.score_count <= 0;
        }
    },
    methods: {
        moreComments: function moreComments() {
            this.getComments();
        },
        openMap: function openMap() {
            $('#map-modal').modal('show');
        },
        selectTab: function selectTab(selected_tab) {
            this.tab = selected_tab;
        },
        getComments: function getComments() {
            var _this = this;

            $.blockUI();
            this.$http.get('/api/branch/' + this.promotionInfo.branch_id + '/ratings', { page: 1 }).then(function (response) {
                $.unblockUI();
                $('#comments-modal').modal('show');
                _this.commentApiData = response.data;
                _this.ajaxing = false;
            }, function (error) {
                $.unblockUI();
                _this.ajaxing = false;
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-250d2504=\"\">\n    <div id=\"contract-nav\" _v-250d2504=\"\">\n        <ul class=\"nav nav-tabs\" _v-250d2504=\"\">\n            <li class=\"right-border\" @click.prevent=\"selectTab('contract')\" :class=\"{active: tab === 'contract'}\" _v-250d2504=\"\">\n                <a href=\"#\" _v-250d2504=\"\">方案說明</a>\n            </li>\n            <li @click.prevent=\"selectTab('content')\" :class=\"{active: tab === 'content'}\" _v-250d2504=\"\">\n                <a href=\"#\" _v-250d2504=\"\">詳細資訊</a>\n            </li>\n        </ul>\n    </div>\n    <div id=\"contract-detail\" v-if=\"tab == 'contract'\" _v-250d2504=\"\">\n        <div class=\"detail-list-style bottom-line\" style=\"overflow: hidden;\" _v-250d2504=\"\">\n            <div class=\"display-flex\" _v-250d2504=\"\">\n                <div class=\"list-title\" _v-250d2504=\"\">方案說明</div>\n                <external-link-button class=\"external-link-btn\" v-if=\"promotionInfo.link !== null\" :link=\"promotionInfo.link\" _v-250d2504=\"\"></external-link-button> \n            </div>\n            <div class=\"content\" _v-250d2504=\"\">{{promotionInfo.description}}</div>\n        </div>\n        <div class=\"detail-list-style bottom-line\" _v-250d2504=\"\">\n            <div class=\"list-title\" _v-250d2504=\"\">店家介紹</div>\n            <div class=\"content\" _v-250d2504=\"\">{{promotionInfo.branch_introduction}}</div>\n        </div>\n        <div class=\"detail-list-style bottom-line\" _v-250d2504=\"\">\n            <div class=\"list-title\" _v-250d2504=\"\">營業時間</div>\n            <div class=\"content\" _v-250d2504=\"\">\n                <div class=\"row\" v-for=\"(time, index) in promotionInfo.business_hour\" :key=\"index\" _v-250d2504=\"\">\n                    <div class=\"col-md-2 col-xs-3 p-right-0\" _v-250d2504=\"\">{{time.day}}</div>\n                    <div class=\"col-md-10 col-xs-9 p-left-0\" _v-250d2504=\"\">{{time.hours}}</div>\n                </div>                \n            </div>\n        </div>\n        <div class=\"detail-list-style bottom-line\" _v-250d2504=\"\">\n            <div class=\"list-title\" _v-250d2504=\"\">店家位置</div>\n            <div class=\"content display-flex de-flex-on-small\" _v-250d2504=\"\">\n                <div _v-250d2504=\"\">{{promotionInfo.address}}</div>\n                <a class=\"btn locate-btn\" v-if=\"promotionInfo.coordinate !== ''\" @click=\"openMap\" _v-250d2504=\"\">\n                    <i class=\"fa fa-map-marker fa-lg p-right-5\" _v-250d2504=\"\"></i>\n                    <span _v-250d2504=\"\">\n                        Map\n                    </span>\n                </a>                 \n            </div>\n        </div>\n        <div class=\"detail-list-style bottom-line\" v-if=\"!noComments\" _v-250d2504=\"\">\n            <div class=\"detail-list-header\" _v-250d2504=\"\">\n                <div _v-250d2504=\"\">\n                    <div class=\"list-title m-bottom-10\" _v-250d2504=\"\">評價</div>\n                    <div style=\"display: flex; align-items: baseline;\" _v-250d2504=\"\">\n                        <rating-star :rating=\"promotionInfo.score_avg\" _v-250d2504=\"\"></rating-star>\n                        <div class=\"stars-remark\" _v-250d2504=\"\">({{promotionInfo.score_count}}則評論)</div>                  \n                    </div>\n                </div>\n                <div _v-250d2504=\"\">\n                    <a @click=\"moreComments\" class=\"comments-link\" _v-250d2504=\"\">查看全部評價</a>\n                </div>\n            </div>\n            <div _v-250d2504=\"\">\n                <comment-list-template :comments=\"promotionInfo.comments\" _v-250d2504=\"\"></comment-list-template>\n            </div>\n        </div>\n        <div class=\"detail-list-style\" _v-250d2504=\"\">\n            <div class=\"list-title\" _v-250d2504=\"\">注意事項</div>\n            <div class=\"content\" _v-250d2504=\"\">{{promotionInfo.notice}}</div>\n        </div>\n    </div>\n\n    <div id=\"contract-content\" v-if=\"tab == 'content'\" _v-250d2504=\"\">\n        <div v-html=\"promotionInfo.content\" _v-250d2504=\"\">\n        </div>\n    </div>\n\n    <comment-modal-vue :api-data=\"commentApiData\" _v-250d2504=\"\"></comment-modal-vue>\n    <map-modal :modal-title=\"promotionInfo.branch_name\" :coordinate=\"promotionInfo.coordinate\" _v-250d2504=\"\"></map-modal>\n</div>\n\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n#contract-nav[_v-250d2504] {\n  margin: 30px 0 10px 0;\n  font-size: 18px;\n  font-weight: 500; }\n  /* line 7, stdin */\n  #contract-nav .nav-tabs[_v-250d2504] {\n    border-bottom: none;\n    transform: translateX(-15px); }\n  /* line 11, stdin */\n  #contract-nav .nav-tabs > li.active > a[_v-250d2504], #contract-nav .nav-tabs > li.active > a[_v-250d2504]:hover, #contract-nav .nav-tabs > li.active > a[_v-250d2504]:focus {\n    color: #38b0e3;\n    cursor: default;\n    background-color: #fff;\n    border: none;\n    border-bottom-color: transparent; }\n  /* line 18, stdin */\n  #contract-nav .nav-tabs > li > a[_v-250d2504] {\n    color: #4a4a4a;\n    border: none; }\n  /* line 22, stdin */\n  #contract-nav .nav-tabs .right-border[_v-250d2504]:after {\n    content: '';\n    height: 45%;\n    width: 1px;\n    position: absolute;\n    right: 0;\n    top: 13px;\n    background-color: #979797; }\n  /* line 31, stdin */\n  #contract-nav .nav-tabs > li > a[_v-250d2504]:hover {\n    background-color: #fff;\n    border-color: #fff; }\n\n/* line 37, stdin */\n#contract-detail .detail-list-style[_v-250d2504] {\n  padding: 20px 0 20px 0; }\n\n/* line 40, stdin */\n#contract-detail .detail-list-style .content[_v-250d2504] {\n  position: relative;\n  margin: 15px 0;\n  text-align: justify;\n  font-size: 16px;\n  font-weight: normal;\n  line-height: 1.5;\n  letter-spacing: 0.5px;\n  white-space: pre-line; }\n\n/* line 50, stdin */\n#contract-detail .detail-list-header[_v-250d2504] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between; }\n\n/* line 54, stdin */\n#contract-detail .stars-remark[_v-250d2504] {\n  font-size: 12px;\n  font-weight: 500;\n  color: #4a4a4a; }\n\n/* line 59, stdin */\n#contract-detail .comments-link[_v-250d2504] {\n  font-size: 16px;\n  color: #38b0e3;\n  text-decoration: underline;\n  font-weight: 500; }\n\n/* line 65, stdin */\n#contract-detail .bottom-line[_v-250d2504] {\n  border-bottom: solid 1px #dddddd;\n  font-weight: 500;\n  color: #4a4a4a; }\n\n/* line 70, stdin */\n#contract-detail .list-title[_v-250d2504] {\n  font-size: 18px;\n  font-weight: 600;\n  color: #000;\n  padding-left: 5px;\n  border-left: 8px solid #38b0e3; }\n\n/* line 77, stdin */\n#contract-detail .display-flex[_v-250d2504] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: justify;\n      justify-content: space-between; }\n\n/* line 82, stdin */\n#contract-detail .external-link-btn[_v-250d2504] {\n  font-size: 16px;\n  border: none;\n  padding: 0;\n  text-decoration: underline;\n  color: #38b0e3; }\n  /* line 88, stdin */\n  #contract-detail .external-link-btn[_v-250d2504]:hover {\n    background-color: white; }\n  /* line 91, stdin */\n  #contract-detail .external-link-btn[_v-250d2504]:focus {\n    background-color: white; }\n  /* line 94, stdin */\n  #contract-detail .external-link-btn[_v-250d2504]:active {\n    background-color: white;\n    box-shadow: none; }\n\n/* line 99, stdin */\n#contract-detail .locate-btn[_v-250d2504] {\n  font-size: 18px;\n  padding: 8px 15px;\n  border-radius: 5px;\n  color: #00498e;\n  border: 1px solid #d2d9e2; }\n  /* line 105, stdin */\n  #contract-detail .locate-btn[_v-250d2504]:hover {\n    border: 1px solid #00498e; }\n  /* line 108, stdin */\n  #contract-detail .locate-btn[_v-250d2504]:active {\n    background-color: #e7eefe;\n    border: 1px solid #00498e; }\n\n@media (max-width: 992px) {\n  /* line 116, stdin */\n  #contract-nav[_v-250d2504] {\n    margin: 0;\n    text-align: center; }\n    /* line 120, stdin */\n    #contract-nav .nav-tabs[_v-250d2504] {\n      display: inline-block;\n      transform: translateX(0); }\n  /* line 126, stdin */\n  #contract-detail .de-flex-on-small[_v-250d2504] {\n    display: block; }\n  /* line 129, stdin */\n  #contract-detail .locate-btn[_v-250d2504] {\n    margin-top: 10px; } }\n\n/* line 3, stdin */\n#contract-content /deep/ .image img {\n  max-width: 100%;\n  height: auto; }\n\n/* line 9, stdin */\n#contract-content .image img {\n  max-width: 100%;\n  height: auto; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-250d2504", module.exports)
  } else {
    hotAPI.update("_v-250d2504", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],975:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.font-dimgray[_v-72acf950] {\n  color: #6a6a6a; }\n\n/* line 5, stdin */\n.font-mediumturquoise[_v-72acf950] {\n  color: #38b0e3; }\n\n/* line 8, stdin */\n.contract-breadcrumb[_v-72acf950] {\n  font-size: 18px;\n  padding: 8px 15px;\n  margin: 22px 0 2px 0;\n  list-style: none;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap; }\n\n/* line 17, stdin */\n.promotion-contract-content[_v-72acf950] {\n  max-width: 640px; }\n\n/* line 20, stdin */\n.contract-detail[_v-72acf950] {\n  max-width: 640px; }\n\n/* line 23, stdin */\n.show-on-small-screen[_v-72acf950] {\n  display: none; }\n\n@media (max-width: 992px) {\n  /* line 28, stdin */\n  .padding-adjust[_v-72acf950] {\n    padding-right: 0;\n    padding-left: 0; }\n  /* line 32, stdin */\n  .show-on-large-screen[_v-72acf950] {\n    display: none; }\n  /* line 35, stdin */\n  .show-on-small-screen[_v-72acf950] {\n    display: inline; }\n  /* line 38, stdin */\n  .promotion-contract-content[_v-72acf950] {\n    display: block;\n    margin: 0 auto;\n    padding: 0 20px; }\n  /* line 43, stdin */\n  .divided-border[_v-72acf950] {\n    content: ' ';\n    background-color: #eeeeee;\n    display: block;\n    height: 20px;\n    width: 100%; } }\n\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            ajaxing: false,
            containerHeight: 500,
            promotionInfo: {},
            imageLoop: true,
            imageData: [],
            experienceUrl: '',
            branchUrl: '',
            paymentUrl: ''
        };
    },
    mounted: function mounted() {
        this.getContainerHeight();
        this.getPromotionInfo();
    },
    created: function created() {},

    computed: {},
    methods: {
        getUrlValue: function getUrlValue() {
            var pathName = window.location.pathname;
            return {
                'branch_id': pathName.split("/")[2],
                'contract_id': pathName.split("/")[4]
            };
        },
        getContainerHeight: function getContainerHeight() {
            this.containerHeight = this.$refs.infoBox.clientHeight;
        },
        getPromotionInfo: function getPromotionInfo() {
            var _this = this;

            var vm = this;
            this.ajaxing = true;
            var postData = this.getUrlValue();
            this.$http.get('/webapi/promotion-contract/' + postData.branch_id + '/' + postData.contract_id).then(function (response) {
                var hostUrl = window.location.hostname;
                if (response.data.site_is_active) {
                    _this.promotionInfo = response.data;
                    _this.prepareCarouselImage(response.data);
                    _this.prepareComponentLink(response.data);
                    _this.ajaxing = false;
                } else {
                    window.location.replace("https://" + hostUrl);
                }
            }, function (error) {
                _this.ajaxing = false;
            });
        },
        prepareCarouselImage: function prepareCarouselImage(data) {
            var imageSet = data.carousel_image;
            var primaryIndex = imageSet.map(function (item) {
                return item.is_primary;
            }).indexOf(1);
            if (imageSet.length <= 0) {
                this.imageData = [{ id: 1,
                    src: data.branch_header_image }];
            }
            if (imageSet.length > 0 && primaryIndex != -1) {
                var primary = imageSet.splice(primaryIndex, 1);
                imageSet.unshift.apply(imageSet, (0, _toConsumableArray3.default)(primary));
                this.imageData = imageSet;
            } else if (imageSet.length > 0 && primaryIndex == -1) {
                this.imageData = imageSet;
            }
            if (this.imageData.length < 3) {
                this.imageLoop = false;
            }
        },
        prepareComponentLink: function prepareComponentLink(data) {
            var host = window.location.host;
            this.experienceUrl = 'https://' + host + '/intro-offer';
            this.branchUrl = 'https://' + host + '/' + data.studio_url + '/' + data.branch_url + '?tab=classes';
            this.paymentUrl = 'https://' + host + '/' + data.studio_url + '/' + data.branch_url + '?tab=pricing&id=' + data.contract_id;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n    <div class=\"container\" ref=\"infoBox\" _v-72acf950=\"\">\n        <v-spinner :ajaxing=\"ajaxing\" _v-72acf950=\"\"></v-spinner>\n        <div class=\"row\" v-show=\"!ajaxing\" _v-72acf950=\"\">\n            <div class=\"col-md-12 col-xs-12\" _v-72acf950=\"\">\n                <div class=\"contract-breadcrumb\" _v-72acf950=\"\">\n                    <a class=\"font-dimgray\" :href=\"experienceUrl\" target=\"__blank\" _v-72acf950=\"\">找體驗方案</a>\n                    <span class=\"font-mediumturquoise\" _v-72acf950=\"\"> &gt; </span>\n                    <a class=\"font-dimgray\" font-dimgray=\"\" :href=\"branchUrl\" target=\"__blank\" _v-72acf950=\"\">{{promotionInfo.branch_name}}</a>\n                    <span class=\"font-mediumturquoise\" _v-72acf950=\"\"> &gt; </span>\n                    {{promotionInfo.contract_name}}\n                </div>\n            </div>\n\n            <div class=\"col-lg-7 col-md-7 col-xs-12 padding-adjust\" _v-72acf950=\"\">\n                <div class=\"m-top-10\" _v-72acf950=\"\">\n                    <v-album-carousel :navigation-show=\"true\" :slid-slots=\"imageData\" :loop=\"imageLoop\" _v-72acf950=\"\"></v-album-carousel>\n                </div>\n                <div class=\"show-on-small-screen\" _v-72acf950=\"\">\n                    <payment-panel :container-height=\"containerHeight\" :promotion-info=\"promotionInfo\" :link=\"paymentUrl\" _v-72acf950=\"\">\n                    </payment-panel> <!--這兩個component要一樣-->\n                </div>\n                <div class=\"divided-border\" _v-72acf950=\"\"></div>\n                <div class=\"promotion-contract-content\" _v-72acf950=\"\">\n                    <promotion-contract-content :promotion-info=\"promotionInfo\" _v-72acf950=\"\"></promotion-contract-content>\n                </div>\n            </div>\n\n            <div class=\"col-lg-5 col-md-5 col-xs-12 show-on-large-screen\" _v-72acf950=\"\">\n                <payment-panel :container-height=\"containerHeight\" :promotion-info=\"promotionInfo\" :link=\"paymentUrl\" _v-72acf950=\"\">\n                </payment-panel>  <!--這兩個component要一樣-->\n            </div>\n        </div>\n\n    <div _v-72acf950=\"\">\n</div></div>"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.font-dimgray[_v-72acf950] {\n  color: #6a6a6a; }\n\n/* line 5, stdin */\n.font-mediumturquoise[_v-72acf950] {\n  color: #38b0e3; }\n\n/* line 8, stdin */\n.contract-breadcrumb[_v-72acf950] {\n  font-size: 18px;\n  padding: 8px 15px;\n  margin: 22px 0 2px 0;\n  list-style: none;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap; }\n\n/* line 17, stdin */\n.promotion-contract-content[_v-72acf950] {\n  max-width: 640px; }\n\n/* line 20, stdin */\n.contract-detail[_v-72acf950] {\n  max-width: 640px; }\n\n/* line 23, stdin */\n.show-on-small-screen[_v-72acf950] {\n  display: none; }\n\n@media (max-width: 992px) {\n  /* line 28, stdin */\n  .padding-adjust[_v-72acf950] {\n    padding-right: 0;\n    padding-left: 0; }\n  /* line 32, stdin */\n  .show-on-large-screen[_v-72acf950] {\n    display: none; }\n  /* line 35, stdin */\n  .show-on-small-screen[_v-72acf950] {\n    display: inline; }\n  /* line 38, stdin */\n  .promotion-contract-content[_v-72acf950] {\n    display: block;\n    margin: 0 auto;\n    padding: 0 20px; }\n  /* line 43, stdin */\n  .divided-border[_v-72acf950] {\n    content: ' ';\n    background-color: #eeeeee;\n    display: block;\n    height: 20px;\n    width: 100%; } }\n\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-72acf950", module.exports)
  } else {
    hotAPI.update("_v-72acf950", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/toConsumableArray":71,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],976:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.promotion-card[_v-5ad68c52] {\n  max-width: 340px;\n  margin: 15px 10px;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  transition: box-shadow .25s;\n  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);\n  cursor: pointer; }\n\n/* line 12, stdin */\n.promotion-card[_v-5ad68c52]:hover {\n  box-shadow: 0 8px 17px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19); }\n\n/* line 15, stdin */\n.img-branch[_v-5ad68c52] {\n  width: 100%; }\n\n/* line 19, stdin */\n.contract-info[_v-5ad68c52] {\n  height: 9em;\n  display: -ms-flexbox;\n  display: flex;\n  background: #f7f6f6;\n  padding-left: 1em;\n  -ms-flex-pack: distribute;\n      justify-content: space-around; }\n\n/* line 28, stdin */\n.price[_v-5ad68c52] {\n  border-radius: 50%;\n  width: 80%;\n  height: 80%;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  color: #fff;\n  background: linear-gradient(305deg, #36E0B3 5%, #1965F3 95%);\n  background: -moz-linear-gradient(305deg, #36E0B3 5%, #1965F3 95%);\n  background: -webkit-linear-gradient(305deg, #36E0B3 5%, #1965F3 95%);\n  background: -o-linear-gradient(305deg, #36E0B3 5%, #1965F3 95%);\n  -ms-flex-direction: column;\n      flex-direction: column; }\n  /* line 41, stdin */\n  .price .real-price[_v-5ad68c52] {\n    font-size: 1.5em; }\n  /* line 44, stdin */\n  .price .price-currency[_v-5ad68c52] {\n    font-size: 0.5em; }\n\n/* line 49, stdin */\n.price-radios[_v-5ad68c52] {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  height: 7em;\n  width: 7em; }\n\n/* line 57, stdin */\n.price-space[_v-5ad68c52] {\n  margin-top: 1em; }\n\n/* line 60, stdin */\n.contract-name[_v-5ad68c52] {\n  font-size: 16px;\n  margin-top: 1em;\n  white-space: normal;\n  text-overflow: clip;\n  overflow-x: hidden;\n  max-width: 20em;\n  height: 3em; }\n\n/* line 69, stdin */\n.branch-name[_v-5ad68c52], .addition[_v-5ad68c52] {\n  color: #929292;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow-x: hidden;\n  max-width: 14em;\n  line-height: 200%;\n  font-size: 0.75em; }\n\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        contract: {
            default: {}
        }
    },
    computed: {
        isPromote: function isPromote() {
            return !!this.contract.site_is_active;
        },
        mainImage: function mainImage() {
            return this.isPromote && this.contract.promotion_primary_pic_url ? this.contract.promotion_primary_pic_url : this.contract.header_img;
        }
    },
    methods: {
        purchase: function purchase(event) {
            var base_url = window.location.origin;
            var href = base_url + '/' + this.contract.studio_url + '/' + this.contract.branch_url + '?tab=pricing&id=' + this.contract.id;
            var promotionHref = base_url + '/branch/' + this.contract.branch_id + '/contract/' + this.contract.id;

            if (this.isPromote) {
                window.open(promotionHref);
            } else {
                window.open(href);
            }
            // location.href=href;
        },
        clipWord: function clipWord(str) {
            if (str && str.length > 35) {
                str = str.substring(0, 35) + '...';
            }
            return str;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"promotion-card\" @click=\"purchase\" _v-5ad68c52=\"\">\n        <div class=\"\" _v-5ad68c52=\"\">\n            <img :src=\"mainImage\" onerror=\"this.src='/images/branch-empty.png';\" class=\"img-fluid img-branch\" :alt=\"contract.name\" _v-5ad68c52=\"\">\n        </div>\n        <div class=\"\" _v-5ad68c52=\"\">\n            <div class=\"contract-info\" _v-5ad68c52=\"\">\n                <div class=\"text-space\" _v-5ad68c52=\"\">\n                        <div class=\"\" _v-5ad68c52=\"\">\n                            <div class=\"contract-name\" v-show=\"isPromote\" _v-5ad68c52=\"\">\n                                {{ clipWord(contract.promotion_title) }}\n                            </div>\n                            <div class=\"contract-name\" v-show=\"!isPromote\" _v-5ad68c52=\"\">\n                                {{ clipWord(contract.contract_name) }}\n                            </div>\n                        </div>\n                        <div class=\"\" _v-5ad68c52=\"\">\n                            <div class=\"branch-name\" _v-5ad68c52=\"\">\n                                {{contract.branch_name}}\n                            </div>\n                        </div>\n                        <div class=\"\" _v-5ad68c52=\"\">\n                            <div class=\"addition\" _v-5ad68c52=\"\">\n                                <span v-if=\"contract.rating_branch\" _v-5ad68c52=\"\">\n                                    評價({{contract.rating_branch}}),\n                                </span>\n                                <span _v-5ad68c52=\"\">\n                                    距離 {{contract.distance}}km\n                                </span>\n                            </div>\n                        </div>\n                </div>\n                <div class=\"price-space text-center\" _v-5ad68c52=\"\">\n                    <div class=\"price-radios\" _v-5ad68c52=\"\">\n                        <div class=\"price\" _v-5ad68c52=\"\">\n                            <div _v-5ad68c52=\"\">&nbsp;</div>\n                            <div class=\"real-price\" _v-5ad68c52=\"\">{{contract.price}}</div>\n                            <div class=\"price-currency\" _v-5ad68c52=\"\">{{contract.currency}}</div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.promotion-card[_v-5ad68c52] {\n  max-width: 340px;\n  margin: 15px 10px;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  transition: box-shadow .25s;\n  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);\n  cursor: pointer; }\n\n/* line 12, stdin */\n.promotion-card[_v-5ad68c52]:hover {\n  box-shadow: 0 8px 17px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19); }\n\n/* line 15, stdin */\n.img-branch[_v-5ad68c52] {\n  width: 100%; }\n\n/* line 19, stdin */\n.contract-info[_v-5ad68c52] {\n  height: 9em;\n  display: -ms-flexbox;\n  display: flex;\n  background: #f7f6f6;\n  padding-left: 1em;\n  -ms-flex-pack: distribute;\n      justify-content: space-around; }\n\n/* line 28, stdin */\n.price[_v-5ad68c52] {\n  border-radius: 50%;\n  width: 80%;\n  height: 80%;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  color: #fff;\n  background: linear-gradient(305deg, #36E0B3 5%, #1965F3 95%);\n  background: -moz-linear-gradient(305deg, #36E0B3 5%, #1965F3 95%);\n  background: -webkit-linear-gradient(305deg, #36E0B3 5%, #1965F3 95%);\n  background: -o-linear-gradient(305deg, #36E0B3 5%, #1965F3 95%);\n  -ms-flex-direction: column;\n      flex-direction: column; }\n  /* line 41, stdin */\n  .price .real-price[_v-5ad68c52] {\n    font-size: 1.5em; }\n  /* line 44, stdin */\n  .price .price-currency[_v-5ad68c52] {\n    font-size: 0.5em; }\n\n/* line 49, stdin */\n.price-radios[_v-5ad68c52] {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  height: 7em;\n  width: 7em; }\n\n/* line 57, stdin */\n.price-space[_v-5ad68c52] {\n  margin-top: 1em; }\n\n/* line 60, stdin */\n.contract-name[_v-5ad68c52] {\n  font-size: 16px;\n  margin-top: 1em;\n  white-space: normal;\n  text-overflow: clip;\n  overflow-x: hidden;\n  max-width: 20em;\n  height: 3em; }\n\n/* line 69, stdin */\n.branch-name[_v-5ad68c52], .addition[_v-5ad68c52] {\n  color: #929292;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow-x: hidden;\n  max-width: 14em;\n  line-height: 200%;\n  font-size: 0.75em; }\n\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-5ad68c52", module.exports)
  } else {
    hotAPI.update("_v-5ad68c52", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],977:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.filter-title[_v-7e781abc] {\n  display: -ms-flexbox;\n  display: flex;\n  font-size: 2.5em; }\n  /* line 5, stdin */\n  .filter-title a[_v-7e781abc] {\n    margin-right: 0.5em; }\n\n/* line 11, stdin */\n.filter-option div[_v-7e781abc] {\n  text-align: left; }\n\n/* line 15, stdin */\n.filter-view[_v-7e781abc] {\n  max-width: 756px;\n  margin: auto; }\n  /* line 19, stdin */\n  .filter-view .filter-option div[_v-7e781abc] {\n    text-align: left; }\n  /* line 23, stdin */\n  .filter-view .filter-tag[_v-7e781abc] {\n    margin-top: 50px;\n    margin-bottom: 20px;\n    /* Hide the browser's default checkbox */\n    /* Create a custom checkbox */\n    /* On mouse-over, add a grey background color */\n    /* When the checkbox is checked, add a blue background */\n    /* Create the checkmark/indicator (hidden when not checked) */\n    /* Show the checkmark when checked */\n    /* Style the checkmark/indicator */ }\n    /* line 26, stdin */\n    .filter-view .filter-tag div[_v-7e781abc] {\n      text-align: left; }\n    /* line 29, stdin */\n    .filter-view .filter-tag .col-tag[_v-7e781abc] {\n      width: 20%;\n      position: relative;\n      min-height: 1px;\n      padding-right: 15px;\n      padding-left: 15px;\n      float: left; }\n    /* line 37, stdin */\n    .filter-view .filter-tag .tag-content[_v-7e781abc] {\n      display: block;\n      position: relative;\n      padding-left: 25px;\n      margin-bottom: 12px;\n      cursor: pointer;\n      font-size: 14px;\n      -webkit-user-select: none;\n         -moz-user-select: none;\n          -ms-user-select: none;\n              user-select: none; }\n    /* line 47, stdin */\n    .filter-view .filter-tag .tag-content input[_v-7e781abc] {\n      position: absolute;\n      opacity: 0;\n      cursor: pointer;\n      height: 0;\n      width: 0; }\n    /* line 56, stdin */\n    .filter-view .filter-tag .checkmark[_v-7e781abc] {\n      position: absolute;\n      top: 0;\n      left: 0;\n      height: 16px;\n      width: 16px;\n      background-color: #ffffff;\n      border: 1px solid black; }\n    /* line 67, stdin */\n    .filter-view .filter-tag .tag-content:hover input ~ .checkmark[_v-7e781abc] {\n      background-color: #ffffff; }\n    /* line 72, stdin */\n    .filter-view .filter-tag .tag-content input:checked ~ .checkmark[_v-7e781abc] {\n      background-color: #38b0e3;\n      border: none; }\n    /* line 78, stdin */\n    .filter-view .filter-tag .checkmark[_v-7e781abc]:after {\n      content: \"\";\n      position: absolute;\n      display: none; }\n    /* line 85, stdin */\n    .filter-view .filter-tag .tag-content input:checked ~ .checkmark[_v-7e781abc]:after {\n      display: block; }\n    /* line 90, stdin */\n    .filter-view .filter-tag .tag-content .checkmark[_v-7e781abc]:after {\n      left: 6px;\n      top: 2px;\n      width: 5px;\n      height: 10px;\n      border: solid white;\n      border-width: 0 3px 3px 0;\n      -webkit-transform: rotate(45deg);\n      -ms-transform: rotate(45deg);\n      transform: rotate(45deg); }\n  /* line 102, stdin */\n  .filter-view label[_v-7e781abc] {\n    font-size: 15px;\n    font-weight: normal;\n    letter-spacing: -0.36px; }\n\n/* line 109, stdin */\n.filter-btn div[_v-7e781abc] {\n  max-width: 400px;\n  margin: auto; }\n  /* line 112, stdin */\n  .filter-btn div a[_v-7e781abc] {\n    font-size: 16px; }\n  /* line 115, stdin */\n  .filter-btn div .btn-info[_v-7e781abc] {\n    border-radius: 8px;\n    background-color: #38b0e3; }\n  /* line 119, stdin */\n  .filter-btn div .btn-info[_v-7e781abc]:hover {\n    background-color: #51c1f0; }\n  /* line 122, stdin */\n  .filter-btn div .btn-info[_v-7e781abc]:active {\n    background-color: #1293c9; }\n  /* line 125, stdin */\n  .filter-btn div .btn-reset[_v-7e781abc] {\n    background-color: white;\n    color: #38b0e3;\n    border-radius: 8px;\n    border: solid 1px #38b0e3; }\n  /* line 131, stdin */\n  .filter-btn div .btn-reset[_v-7e781abc]:hover {\n    background-color: #51c1f0;\n    color: white;\n    border: solid 1px #51c1f0; }\n  /* line 136, stdin */\n  .filter-btn div .btn-reset[_v-7e781abc]:active {\n    background-color: #1293c9;\n    border: solid 1px #1293c9; }\n\n@media (max-width: 768px) {\n  /* line 145, stdin */\n  .filter-view .filter-tag .col-tag[_v-7e781abc] {\n    width: 25%; } }\n\n@media (max-width: 480px) {\n  /* line 153, stdin */\n  .filter-option .col-xs-6[_v-7e781abc] {\n    width: 100%; }\n  /* line 159, stdin */\n  .filter-view .filter-tag .row[_v-7e781abc] {\n    margin-bottom: 70px; }\n  /* line 162, stdin */\n  .filter-view .filter-tag .col-tag[_v-7e781abc] {\n    width: 50%; }\n  /* line 168, stdin */\n  .filter-btn[_v-7e781abc] {\n    left: 0;\n    width: 100%;\n    background-color: #ffffff;\n    transform: translate(0, -50px);\n    padding: 5px; }\n    /* line 174, stdin */\n    .filter-btn div[_v-7e781abc] {\n      max-width: 100%;\n      padding-right: 5px;\n      padding-left: 5px; } }\n\n@charset \"UTF-8\";\n/* line 2, stdin */\n#experience-contract-filter {\n  padding-right: 0 !important; }\n  /* line 4, stdin */\n  #experience-contract-filter .modal-dialog {\n    width: 100%;\n    margin: 0; }\n  /* line 8, stdin */\n  #experience-contract-filter .modal-content {\n    border-radius: 0; }\n  /* line 11, stdin */\n  #experience-contract-filter .modal-content {\n    text-align: center;\n    font-size: 22px;\n    font-weight: 600;\n    color: #000000; }\n  /* line 17, stdin */\n  #experience-contract-filter .modal-title {\n    font-size: 22px;\n    font-weight: 600; }\n  /* line 22, stdin */\n  #experience-contract-filter .filter-view .multiselect {\n    border-radius: 8px;\n    box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.17); }\n    /* line 25, stdin */\n    #experience-contract-filter .filter-view .multiselect .multiselect__option--highlight, #experience-contract-filter .filter-view .multiselect .multiselect__option--highlight:after {\n      background-color: #f3f3f3;\n      color: #000000;\n      content: ''; }\n    /* line 30, stdin */\n    #experience-contract-filter .filter-view .multiselect .multiselect__option--selected {\n      background-color: white; }\n    /* line 33, stdin */\n    #experience-contract-filter .filter-view .multiselect .multiselect__option--selected:after {\n      background-color: white;\n      content: '✔';\n      color: #38b0e3; }\n\n@media (max-width: 480px) {\n  /* line 43, stdin */\n  #experience-contract-filter .modal-content {\n    height: 100vh; }\n  /* line 46, stdin */\n  #experience-contract-filter .modal-title {\n    font-size: 18px; } }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vuex = require('vuex');

exports.default = {
    props: {
        init: {},
        filterOption: {},
        sortOption: {}
    },
    data: function data() {
        return {
            sorting_first: 1,
            radios: 50,
            price: "",
            family_key_name: '',
            contract_tag_category_id: 1,
            checkedTags: [],

            selected_category: '',
            selected_sorting: '',
            selected_price: '',
            selected_distance: '',

            tag_list: [],
            category_options: [],
            sorting_options: [{ id: 1, name: '最新' }, { id: 2, name: '評價數量' }, { id: 3, name: '價格由低到高' }, { id: 4, name: '價格由高到低' }, { id: 5, name: '距離' }],
            distance_options: [{ id: 1, name: '1 KM' }, { id: 3, name: '3 KM' }, { id: 5, name: '5 KM' }, { id: 10, name: '10 KM' }, { id: 30, name: '30 KM' }, { id: 50, name: '50 KM' }, { id: 300, name: '不限距離' }],
            price_options: [{ id: 1000, name: '低於 NT$1000' }, { id: 3000, name: '低於 NT$3000' }, { id: 5000, name: '低於 NT$5000' }]
        };
    },
    watch: {
        init: function init(oldVal, newVal) {
            if (newVal) {
                this.syncOptionToView(this.filterOption, this.sortOption);
                this.watchCategory();
                this.submitOptions();
            }
        },
        checkedTags: function checkedTags(newVal) {
            var distanceFilter = this.distance_options.slice(0, 6);
            if (newVal.length == 1) {
                distanceFilter.push({ id: 300, name: '不限距離' });
                this.distance_options = distanceFilter;
            } else {
                this.distance_options = distanceFilter;
                if (this.selected_distance) {
                    this.selected_distance = this.selected_distance.id > 50 ? distanceFilter[distanceFilter.length - 1] : this.selected_distance;
                };
            }
        }
    },
    created: function created() {},
    mounted: function mounted() {
        this.getTagList();
        var vm = this;
        $(this.$el).on('show.bs.modal', function () {
            vm.syncOptionToView(vm.filterOption, vm.sortOption);
            vm.$nextTick(function () {
                vm.checkedTags = vm.filterOption.tags;
            });
        });
    },
    destroyed: function destroyed() {
        $(this.$el).off('show.bs.modal');
    },

    methods: {
        syncOptionToView: function syncOptionToView(filterOption, sortOption) {
            var tagsArr = filterOption.tags.filter(function (item) {
                return item;
            });
            this.checkedTags = tagsArr;
            this.selected_category = this.category_options.find(function (obj) {
                return obj.id == filterOption.contract_tag_category_id;
            });
            this.selected_sorting = this.sorting_options.find(function (obj) {
                return obj.id == sortOption[0];
            });
            this.selected_distance = this.distance_options.find(function (obj) {
                return obj.id == filterOption.radios;
            });
            this.selected_price = this.price_options.find(function (obj) {
                return obj.id == filterOption.price;
            });
        },
        watchCategory: function watchCategory() {
            var _this = this;

            this.$watch('selected_category', function (oldVal, newVal) {
                if (oldVal !== newVal) {
                    _this.checkedTags = [];
                }
            });
        },
        reset: function reset() {
            this.selected_sorting = '';
            this.selected_distance = '';
            this.selected_price = '';
            this.selected_category = '';
            this.checkedTags = [];

            this.sorting_first = 1;
            this.radios = 50;
            this.price = "";
            this.family_key_name = '';
            this.contract_tag_category_id = 1;
        },
        submitOptions: function submitOptions() {
            var _this2 = this;

            this.sorting_first = this.selected_sorting ? this.selected_sorting.id : 1;
            this.radios = this.selected_distance ? this.selected_distance.id : 50;
            this.price = this.selected_price ? this.selected_price.id : '';
            this.contract_tag_category_id = this.selected_category ? this.selected_category.id : 1;

            var tags = this.tag_list.find(function (obj) {
                return obj.id == _this2.contract_tag_category_id;
            });
            var selectedTag = [];
            if (this.checkedTags) {
                this.checkedTags.forEach(function (id) {
                    selectedTag.push(tags.contract_tag.find(function (tag) {
                        return tag.id == id;
                    }));
                });
            };
            var sortOption = [this.sorting_first];
            var filterOption = {
                'radios': this.radios,
                'price': this.price,
                'family_key_name': this.family_key_name,
                'is_default': this.is_default,
                'contract_tag_category_id': this.contract_tag_category_id,
                'tags': this.checkedTags
            };

            this.$emit('change-option', {
                'filterOption': filterOption,
                'sortOption': sortOption,
                'displayTag': selectedTag
            });

            $(this.$el).modal('hide');
        },
        getTagList: function getTagList() {
            var _this3 = this;

            this.category_options = [];
            this.$http.get('/webapi/contract-tag-list').then(function (response) {
                _this3.tag_list = response.data;

                //sorting tags by order and set category_options
                _this3.tag_list.forEach(function (category) {
                    category.contract_tag.sort(function (a, b) {
                        return a.order - b.order;
                    });
                    _this3.category_options.push({
                        id: category.id,
                        name: category.name
                    });
                });

                _this3.$emit('get-tags', _this3.tag_list);
            }, function (error) {});
        },
        getTagsByCategory: function getTagsByCategory() {
            var categoryId = 1; //default
            if (this.selected_category) {
                categoryId = this.selected_category.id;
            };
            var tags = this.tag_list.find(function (obj) {
                return obj.id == categoryId;
            });
            if (tags) {
                return tags.contract_tag;
            };
        }
    },
    computed: {
        is_default: function is_default() {
            return this.sorting_first == 1 && this.radios == 50 && this.price == "" && this.contract_tag_category_id == 1 && this.checkedTags == [];
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal id=\"experience-contract-filter\" class=\"experience-contract-filter-vue\" no-footer=\"\" _v-7e781abc=\"\">\n    <div slot=\"title\" _v-7e781abc=\"\">篩選條件</div>\n    <div slot=\"body\" _v-7e781abc=\"\">\n        <div class=\"filter-view\" _v-7e781abc=\"\">\n            <div class=\"row filter-option\" _v-7e781abc=\"\">\n                <div class=\"col-xs-6\" _v-7e781abc=\"\">\n                    <label _v-7e781abc=\"\">類型</label>\n                    <v-mutiselect :model.sync=\"selected_category\" :options=\"category_options\" :multiple=\"false\" :close-on-select=\"true\" :searchable=\"false\" deselect-label=\"✔\" label=\"name\" track-by=\"id\" tag-name=\"name\" placeholder=\"運動與健身\" _v-7e781abc=\"\"></v-mutiselect>\n                </div>\n                <div class=\"col-xs-6\" _v-7e781abc=\"\">\n                    <label _v-7e781abc=\"\">排序方式</label>\n                    <v-mutiselect :model.sync=\"selected_sorting\" :options=\"sorting_options\" :multiple=\"false\" :close-on-select=\"true\" :searchable=\"false\" deselect-label=\"✔\" label=\"name\" track-by=\"id\" tag-name=\"name\" placeholder=\"最新\" _v-7e781abc=\"\"></v-mutiselect>\n                </div>\n            </div>\n            <div class=\"row filter-option\" _v-7e781abc=\"\">\n                <div class=\"col-xs-6\" _v-7e781abc=\"\">\n                    <label _v-7e781abc=\"\">距離</label>\n                    <v-mutiselect :model.sync=\"selected_distance\" :options=\"distance_options\" :multiple=\"false\" :close-on-select=\"true\" :searchable=\"false\" deselect-label=\"✔\" label=\"name\" track-by=\"id\" tag-name=\"name\" placeholder=\"50 KM\" _v-7e781abc=\"\"></v-mutiselect>\n                </div>\n                <div class=\"col-xs-6\" _v-7e781abc=\"\">\n                    <label _v-7e781abc=\"\">價格範圍</label>\n                    <v-mutiselect :model.sync=\"selected_price\" :options=\"price_options\" :multiple=\"false\" :close-on-select=\"true\" :searchable=\"false\" deselect-label=\"✔\" label=\"name\" track-by=\"id\" tag-name=\"name\" placeholder=\"不限\" _v-7e781abc=\"\"></v-mutiselect>\n                </div>\n            </div>\n            <div class=\"row filter-tag\" _v-7e781abc=\"\">\n                <div class=\"col-xs-12\" _v-7e781abc=\"\">\n                    <label _v-7e781abc=\"\">標籤</label>\n                    <div class=\"row m-top-20 m-bottom-50\" _v-7e781abc=\"\">\n                        <div class=\"col-tag\" v-for=\"(tag, index) in getTagsByCategory()\" :key=\"index\" _v-7e781abc=\"\">\n                            <label class=\"tag-content\" _v-7e781abc=\"\">{{tag.name}}\n                                <input type=\"checkbox\" :value=\"tag.id\" v-model=\"checkedTags\" _v-7e781abc=\"\">\n                                <span class=\"checkmark\" _v-7e781abc=\"\"></span>\n                            </label>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"filter-btn\" _v-7e781abc=\"\">\n            <div class=\"row\" _v-7e781abc=\"\">\n                <div class=\"col-xs-6\" _v-7e781abc=\"\">\n                    <a href=\"\" type=\"button\" class=\"btn btn-lg btn-block btn-reset\" @click.prevent.stop=\"reset\" _v-7e781abc=\"\">重置篩選條件</a>\n                </div>\n                <div class=\"col-xs-6\" _v-7e781abc=\"\">\n                    <a href=\"\" type=\"button\" class=\"btn btn-info btn-lg btn-block\" @click.prevent=\"submitOptions\" _v-7e781abc=\"\">完成</a>\n                </div>\n            </div>\n            \n        </div>\n    </div>\n</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.filter-title[_v-7e781abc] {\n  display: -ms-flexbox;\n  display: flex;\n  font-size: 2.5em; }\n  /* line 5, stdin */\n  .filter-title a[_v-7e781abc] {\n    margin-right: 0.5em; }\n\n/* line 11, stdin */\n.filter-option div[_v-7e781abc] {\n  text-align: left; }\n\n/* line 15, stdin */\n.filter-view[_v-7e781abc] {\n  max-width: 756px;\n  margin: auto; }\n  /* line 19, stdin */\n  .filter-view .filter-option div[_v-7e781abc] {\n    text-align: left; }\n  /* line 23, stdin */\n  .filter-view .filter-tag[_v-7e781abc] {\n    margin-top: 50px;\n    margin-bottom: 20px;\n    /* Hide the browser's default checkbox */\n    /* Create a custom checkbox */\n    /* On mouse-over, add a grey background color */\n    /* When the checkbox is checked, add a blue background */\n    /* Create the checkmark/indicator (hidden when not checked) */\n    /* Show the checkmark when checked */\n    /* Style the checkmark/indicator */ }\n    /* line 26, stdin */\n    .filter-view .filter-tag div[_v-7e781abc] {\n      text-align: left; }\n    /* line 29, stdin */\n    .filter-view .filter-tag .col-tag[_v-7e781abc] {\n      width: 20%;\n      position: relative;\n      min-height: 1px;\n      padding-right: 15px;\n      padding-left: 15px;\n      float: left; }\n    /* line 37, stdin */\n    .filter-view .filter-tag .tag-content[_v-7e781abc] {\n      display: block;\n      position: relative;\n      padding-left: 25px;\n      margin-bottom: 12px;\n      cursor: pointer;\n      font-size: 14px;\n      -webkit-user-select: none;\n         -moz-user-select: none;\n          -ms-user-select: none;\n              user-select: none; }\n    /* line 47, stdin */\n    .filter-view .filter-tag .tag-content input[_v-7e781abc] {\n      position: absolute;\n      opacity: 0;\n      cursor: pointer;\n      height: 0;\n      width: 0; }\n    /* line 56, stdin */\n    .filter-view .filter-tag .checkmark[_v-7e781abc] {\n      position: absolute;\n      top: 0;\n      left: 0;\n      height: 16px;\n      width: 16px;\n      background-color: #ffffff;\n      border: 1px solid black; }\n    /* line 67, stdin */\n    .filter-view .filter-tag .tag-content:hover input ~ .checkmark[_v-7e781abc] {\n      background-color: #ffffff; }\n    /* line 72, stdin */\n    .filter-view .filter-tag .tag-content input:checked ~ .checkmark[_v-7e781abc] {\n      background-color: #38b0e3;\n      border: none; }\n    /* line 78, stdin */\n    .filter-view .filter-tag .checkmark[_v-7e781abc]:after {\n      content: \"\";\n      position: absolute;\n      display: none; }\n    /* line 85, stdin */\n    .filter-view .filter-tag .tag-content input:checked ~ .checkmark[_v-7e781abc]:after {\n      display: block; }\n    /* line 90, stdin */\n    .filter-view .filter-tag .tag-content .checkmark[_v-7e781abc]:after {\n      left: 6px;\n      top: 2px;\n      width: 5px;\n      height: 10px;\n      border: solid white;\n      border-width: 0 3px 3px 0;\n      -webkit-transform: rotate(45deg);\n      -ms-transform: rotate(45deg);\n      transform: rotate(45deg); }\n  /* line 102, stdin */\n  .filter-view label[_v-7e781abc] {\n    font-size: 15px;\n    font-weight: normal;\n    letter-spacing: -0.36px; }\n\n/* line 109, stdin */\n.filter-btn div[_v-7e781abc] {\n  max-width: 400px;\n  margin: auto; }\n  /* line 112, stdin */\n  .filter-btn div a[_v-7e781abc] {\n    font-size: 16px; }\n  /* line 115, stdin */\n  .filter-btn div .btn-info[_v-7e781abc] {\n    border-radius: 8px;\n    background-color: #38b0e3; }\n  /* line 119, stdin */\n  .filter-btn div .btn-info[_v-7e781abc]:hover {\n    background-color: #51c1f0; }\n  /* line 122, stdin */\n  .filter-btn div .btn-info[_v-7e781abc]:active {\n    background-color: #1293c9; }\n  /* line 125, stdin */\n  .filter-btn div .btn-reset[_v-7e781abc] {\n    background-color: white;\n    color: #38b0e3;\n    border-radius: 8px;\n    border: solid 1px #38b0e3; }\n  /* line 131, stdin */\n  .filter-btn div .btn-reset[_v-7e781abc]:hover {\n    background-color: #51c1f0;\n    color: white;\n    border: solid 1px #51c1f0; }\n  /* line 136, stdin */\n  .filter-btn div .btn-reset[_v-7e781abc]:active {\n    background-color: #1293c9;\n    border: solid 1px #1293c9; }\n\n@media (max-width: 768px) {\n  /* line 145, stdin */\n  .filter-view .filter-tag .col-tag[_v-7e781abc] {\n    width: 25%; } }\n\n@media (max-width: 480px) {\n  /* line 153, stdin */\n  .filter-option .col-xs-6[_v-7e781abc] {\n    width: 100%; }\n  /* line 159, stdin */\n  .filter-view .filter-tag .row[_v-7e781abc] {\n    margin-bottom: 70px; }\n  /* line 162, stdin */\n  .filter-view .filter-tag .col-tag[_v-7e781abc] {\n    width: 50%; }\n  /* line 168, stdin */\n  .filter-btn[_v-7e781abc] {\n    left: 0;\n    width: 100%;\n    background-color: #ffffff;\n    transform: translate(0, -50px);\n    padding: 5px; }\n    /* line 174, stdin */\n    .filter-btn div[_v-7e781abc] {\n      max-width: 100%;\n      padding-right: 5px;\n      padding-left: 5px; } }\n\n@charset \"UTF-8\";\n/* line 2, stdin */\n#experience-contract-filter {\n  padding-right: 0 !important; }\n  /* line 4, stdin */\n  #experience-contract-filter .modal-dialog {\n    width: 100%;\n    margin: 0; }\n  /* line 8, stdin */\n  #experience-contract-filter .modal-content {\n    border-radius: 0; }\n  /* line 11, stdin */\n  #experience-contract-filter .modal-content {\n    text-align: center;\n    font-size: 22px;\n    font-weight: 600;\n    color: #000000; }\n  /* line 17, stdin */\n  #experience-contract-filter .modal-title {\n    font-size: 22px;\n    font-weight: 600; }\n  /* line 22, stdin */\n  #experience-contract-filter .filter-view .multiselect {\n    border-radius: 8px;\n    box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.17); }\n    /* line 25, stdin */\n    #experience-contract-filter .filter-view .multiselect .multiselect__option--highlight, #experience-contract-filter .filter-view .multiselect .multiselect__option--highlight:after {\n      background-color: #f3f3f3;\n      color: #000000;\n      content: ''; }\n    /* line 30, stdin */\n    #experience-contract-filter .filter-view .multiselect .multiselect__option--selected {\n      background-color: white; }\n    /* line 33, stdin */\n    #experience-contract-filter .filter-view .multiselect .multiselect__option--selected:after {\n      background-color: white;\n      content: '✔';\n      color: #38b0e3; }\n\n@media (max-width: 480px) {\n  /* line 43, stdin */\n  #experience-contract-filter .modal-content {\n    height: 100vh; }\n  /* line 46, stdin */\n  #experience-contract-filter .modal-title {\n    font-size: 18px; } }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-7e781abc", module.exports)
  } else {
    hotAPI.update("_v-7e781abc", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],978:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.search-container[_v-f9f69230] {\n  max-width: 756px;\n  width: 100%;\n  margin: auto;\n  margin-top: 73px; }\n\n/* line 8, stdin */\n.search-btn[_v-f9f69230] {\n  max-width: 402px;\n  font-size: 16px;\n  padding-top: 14px;\n  padding-bottom: 14px;\n  display: block;\n  margin: 36px auto 26px auto; }\n\n/* line 16, stdin */\n.input-container i[_v-f9f69230] {\n  position: absolute; }\n\n/* line 19, stdin */\n.input-container[_v-f9f69230] {\n  width: 100%;\n  height: 40px;\n  border-radius: 8px;\n  box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.17);\n  background-color: #ffffff; }\n\n/* line 26, stdin */\n.icon[_v-f9f69230] {\n  padding: 10px;\n  padding-left: 0px;\n  width: 18px;\n  height: 18px;\n  color: #89ceed; }\n\n/* line 33, stdin */\n.input-field[_v-f9f69230] {\n  width: 100%;\n  border: none;\n  color: #000000;\n  margin-bottom: 0;\n  height: 40px;\n  font-size: 14px;\n  padding: 10px 10px 10px 25px;\n  background-color: #ffffff; }\n\n/* line 44, stdin */\n.filter-option[_v-f9f69230] {\n  margin: 0px 4em; }\n\n/* line 47, stdin */\n.filter-view[_v-f9f69230] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  background-color: white;\n  width: 100%;\n  height: 100%;\n  z-index: 100; }\n  /* line 55, stdin */\n  .filter-view .container[_v-f9f69230] {\n    position: relative;\n    top: 15%;\n    height: 100%; }\n  @media (max-width: 767px) {\n    /* line 61, stdin */\n    .filter-view .container[_v-f9f69230] {\n      top: 6%; } }\n\n@media (max-width: 480px) {\n  /* line 68, stdin */\n  .search-container[_v-f9f69230] {\n    margin-top: 5px; } }\n\n/* line 2, stdin */\n#geo-search {\n  padding-right: 0 !important; }\n  /* line 4, stdin */\n  #geo-search .modal-dialog {\n    width: 100%;\n    margin: 0; }\n  /* line 8, stdin */\n  #geo-search .modal-content {\n    border-radius: 0; }\n  /* line 11, stdin */\n  #geo-search .modal-content {\n    text-align: center;\n    font-size: 22px;\n    font-weight: 600;\n    color: #000000; }\n  /* line 17, stdin */\n  #geo-search .modal-title {\n    font-size: 22px;\n    font-weight: 600; }\n\n@media (max-width: 768px) {\n  /* line 24, stdin */\n  .adjusto-pac-container {\n    top: 207px !important; } }\n\n@media (max-width: 480px) {\n  /* line 29, stdin */\n  .adjusto-pac-container {\n    top: 138px !important; }\n  /* line 33, stdin */\n  #geo-search .modal-content {\n    height: 100vh; }\n  /* line 36, stdin */\n  #geo-search .modal-title {\n    font-size: 18px; } }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vuex = require('vuex');

exports.default = {
    props: {
        init: {},
        keyword: {
            default: ''
        },
        addressDetail: {
            default: ''
        }
    },
    data: function data() {
        return {
            coordinate: {
                latitude: 25.0248208,
                longitude: 121.55354639999999
            },
            address: '',
            key_words: ''
        };
    },
    created: function created() {
        this.bootGoogleMap();
    },
    mounted: function mounted() {
        var vm = this;
        $(this.$el).on('show.bs.modal', function () {
            vm.updateView();
        });
    },
    destroyed: function destroyed() {
        $(this.$el).off('show.bs.modal');
    },

    watch: {
        init: function init(oldVal, newVal) {
            if (newVal) {
                this.updateView();
                document.querySelector(".pac-container").classList.add("adjusto-pac-container");
            }
        }
    },
    methods: {
        updateView: function updateView() {
            var _this = this;

            this.address = '';
            this.$nextTick(function () {
                _this.address = _this.addressDetail;
                _this.key_words = _this.keyword;
            });
        },
        updatePlace: function updatePlace(event) {
            this.coordinate.latitude = event.geometry.location.lat();
            this.coordinate.longitude = event.geometry.location.lng();
            this.address = event.formatted_address;
        },
        submitKeyword: function submitKeyword() {
            this.$emit('change-geo', {
                'coordinate': this.coordinate,
                'address': this.address,
                'keyword': this.key_words
            });
            $(this.$el).modal('hide');
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal id=\"geo-search\" class=\"geo-search-vue\" no-footer=\"\" _v-f9f69230=\"\">\n    <div slot=\"title\" _v-f9f69230=\"\">搜尋</div>\n    <div slot=\"body\" _v-f9f69230=\"\">\n        <div class=\"search-container\" _v-f9f69230=\"\">\n            <div class=\"row m-left-0 m-right-0\" _v-f9f69230=\"\">\n                <div class=\"input-container col-xs-12 col-sm-12\" _v-f9f69230=\"\">\n                    <i class=\"fa fa-search icon\" _v-f9f69230=\"\"></i> \n                    <input class=\"input-field\" type=\"text\" placeholder=\"請輸入關鍵字\" v-model=\"key_words\" _v-f9f69230=\"\">\n                </div>\n                <div class=\"input-container col-xs-12 col-sm-12 m-top-30\" _v-f9f69230=\"\">\n                    <i class=\"fa fa-map-marker fa-lg icon\" _v-f9f69230=\"\"></i> \n                    <gmap-autocomplete class=\"input-field\" placeholder=\"請輸入地址、地標\" :value=\"address\" name=\"search_address\" style=\"width:100%;\" maxlength=\"100\" :select-first-on-enter=\"true\" @place_changed=\"updatePlace($event)\" _v-f9f69230=\"\">\n                    </gmap-autocomplete>\n                </div>\n            </div>                \n        </div>\n        <div class=\"search-btn\" _v-f9f69230=\"\">\n            <a href=\"\" type=\"button\" class=\"btn btn-info btn-lg btn-block\" @click.prevent=\"submitKeyword\" _v-f9f69230=\"\">開始搜尋</a>\n        </div>\n    </div>\n</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.search-container[_v-f9f69230] {\n  max-width: 756px;\n  width: 100%;\n  margin: auto;\n  margin-top: 73px; }\n\n/* line 8, stdin */\n.search-btn[_v-f9f69230] {\n  max-width: 402px;\n  font-size: 16px;\n  padding-top: 14px;\n  padding-bottom: 14px;\n  display: block;\n  margin: 36px auto 26px auto; }\n\n/* line 16, stdin */\n.input-container i[_v-f9f69230] {\n  position: absolute; }\n\n/* line 19, stdin */\n.input-container[_v-f9f69230] {\n  width: 100%;\n  height: 40px;\n  border-radius: 8px;\n  box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.17);\n  background-color: #ffffff; }\n\n/* line 26, stdin */\n.icon[_v-f9f69230] {\n  padding: 10px;\n  padding-left: 0px;\n  width: 18px;\n  height: 18px;\n  color: #89ceed; }\n\n/* line 33, stdin */\n.input-field[_v-f9f69230] {\n  width: 100%;\n  border: none;\n  color: #000000;\n  margin-bottom: 0;\n  height: 40px;\n  font-size: 14px;\n  padding: 10px 10px 10px 25px;\n  background-color: #ffffff; }\n\n/* line 44, stdin */\n.filter-option[_v-f9f69230] {\n  margin: 0px 4em; }\n\n/* line 47, stdin */\n.filter-view[_v-f9f69230] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  background-color: white;\n  width: 100%;\n  height: 100%;\n  z-index: 100; }\n  /* line 55, stdin */\n  .filter-view .container[_v-f9f69230] {\n    position: relative;\n    top: 15%;\n    height: 100%; }\n  @media (max-width: 767px) {\n    /* line 61, stdin */\n    .filter-view .container[_v-f9f69230] {\n      top: 6%; } }\n\n@media (max-width: 480px) {\n  /* line 68, stdin */\n  .search-container[_v-f9f69230] {\n    margin-top: 5px; } }\n\n/* line 2, stdin */\n#geo-search {\n  padding-right: 0 !important; }\n  /* line 4, stdin */\n  #geo-search .modal-dialog {\n    width: 100%;\n    margin: 0; }\n  /* line 8, stdin */\n  #geo-search .modal-content {\n    border-radius: 0; }\n  /* line 11, stdin */\n  #geo-search .modal-content {\n    text-align: center;\n    font-size: 22px;\n    font-weight: 600;\n    color: #000000; }\n  /* line 17, stdin */\n  #geo-search .modal-title {\n    font-size: 22px;\n    font-weight: 600; }\n\n@media (max-width: 768px) {\n  /* line 24, stdin */\n  .adjusto-pac-container {\n    top: 207px !important; } }\n\n@media (max-width: 480px) {\n  /* line 29, stdin */\n  .adjusto-pac-container {\n    top: 138px !important; }\n  /* line 33, stdin */\n  #geo-search .modal-content {\n    height: 100vh; }\n  /* line 36, stdin */\n  #geo-search .modal-title {\n    font-size: 18px; } }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-f9f69230", module.exports)
  } else {
    hotAPI.update("_v-f9f69230", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],979:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _index = require('./index.vue');

var _index2 = _interopRequireDefault(_index);

var _contractCard = require('./contract-card.vue');

var _contractCard2 = _interopRequireDefault(_contractCard);

var _loadingCard = require('./loading-card.vue');

var _loadingCard2 = _interopRequireDefault(_loadingCard);

var _filter = require('./filter.vue');

var _filter2 = _interopRequireDefault(_filter);

var _geoSearch = require('./geo-search.vue');

var _geoSearch2 = _interopRequireDefault(_geoSearch);

var _promotionLabel = require('./promotion-label.vue');

var _promotionLabel2 = _interopRequireDefault(_promotionLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('promotion-experience-contract-index', _index2.default);
_vue2.default.component('promotion-experience-contract-card', _contractCard2.default);
_vue2.default.component('promotion-experience-contract-loading-card', _loadingCard2.default);
_vue2.default.component('promotion-experience-contract-filter', _filter2.default);
_vue2.default.component('promotion-experience-contract-geo-search', _geoSearch2.default);
_vue2.default.component('promotion-experience-label', _promotionLabel2.default);

},{"./contract-card.vue":976,"./filter.vue":977,"./geo-search.vue":978,"./index.vue":980,"./loading-card.vue":981,"./promotion-label.vue":982,"vue":792}],980:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.card-list[_v-94537784] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -ms-flex-pack: center;\n      justify-content: center; }\n\n/* line 7, stdin */\n.search-d-flex[_v-94537784] {\n  display: -ms-flexbox;\n  display: flex;\n  gap: 24px;\n  -ms-flex-pack: center;\n      justify-content: center; }\n  /* line 11, stdin */\n  .search-d-flex .search-item[_v-94537784] {\n    max-width: 613px;\n    -ms-flex-positive: 1;\n        flex-grow: 1; }\n\n/* line 19, stdin */\n.search-row[_v-94537784] {\n  font-size: 1.5em;\n  margin-top: 1em;\n  padding-bottom: 10px;\n  padding-top: 10px;\n  vertical-align: middle; }\n  /* line 25, stdin */\n  .search-row .search-bar[_v-94537784] {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    width: 100%;\n    max-width: 500px; }\n    /* line 31, stdin */\n    .search-row .search-bar .address[_v-94537784]::before {\n      content: \"\"; }\n  /* line 35, stdin */\n  .search-row .filterDefault[_v-94537784] {\n    color: white;\n    border-radius: 8px;\n    box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.17);\n    background-color: #38b0e3;\n    font-size: 16px;\n    font-weight: 500; }\n\n/* line 45, stdin */\n.search-row.fixed[_v-94537784] {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  background-color: #fff;\n  width: 100%;\n  margin-top: 0;\n  z-index: 5;\n  box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.17); }\n\n/* line 56, stdin */\n.filter-result[_v-94537784] {\n  margin-top: 30px;\n  margin-bottom: 15px; }\n  /* line 59, stdin */\n  .filter-result .container[_v-94537784] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: center;\n        justify-content: center;\n    -ms-flex-align: center;\n        align-items: center; }\n    /* line 63, stdin */\n    .filter-result .container .tags[_v-94537784] {\n      display: -ms-flexbox;\n      display: flex;\n      font-size: 18px;\n      font-weight: 500;\n      letter-spacing: normal;\n      max-width: 250px; }\n      /* line 69, stdin */\n      .filter-result .container .tags span[_v-94537784] {\n        color: #1f1f1f; }\n      /* line 72, stdin */\n      .filter-result .container .tags .content[_v-94537784] {\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        color: #38b0e3; }\n    /* line 79, stdin */\n    .filter-result .container .category[_v-94537784] {\n      font-size: 14px;\n      font-weight: normal;\n      letter-spacing: normal;\n      color: #626262; }\n\n/* line 88, stdin */\n.show-data.fixed .carousel[_v-94537784] {\n  margin-top: 80px; }\n\n/* line 93, stdin */\n.carousel[_v-94537784] {\n  margin: 2em 10px 1em 10px; }\n\n/* line 97, stdin */\n.left-search[_v-94537784] {\n  display: -ms-flexbox;\n  display: flex;\n  border-radius: 8px;\n  box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.17);\n  background-color: #ffffff; }\n  /* line 102, stdin */\n  .left-search .search-icon[_v-94537784] {\n    width: 62px;\n    background-color: #38b0e3;\n    border-bottom-right-radius: 8px;\n    border-top-right-radius: 8px;\n    text-align: center;\n    color: white; }\n    /* line 109, stdin */\n    .left-search .search-icon .fa[_v-94537784] {\n      vertical-align: middle; }\n\n/* line 115, stdin */\n.btn-geo[_v-94537784] {\n  color: #000;\n  height: 37px;\n  line-height: normal;\n  text-align: left;\n  margin-left: 10px; }\n\n/* line 123, stdin */\n.btn-filter[_v-94537784] {\n  color: #929292;\n  border: 1px solid rgba(92, 92, 92, 0.16);\n  text-align: left;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.16); }\n\n/* line 129, stdin */\n.btn-animate[_v-94537784]:hover {\n  background-color: #51c1f0; }\n\n/* line 132, stdin */\n.btn-animate[_v-94537784]:active {\n  background-color: #1293c9; }\n\n/* line 135, stdin */\n.not-found[_v-94537784] {\n  margin-top: 4em; }\n  /* line 137, stdin */\n  .not-found .not-found-img[_v-94537784] {\n    height: 15em;\n    margin: auto;\n    width: auto;\n    display: block; }\n  /* line 144, stdin */\n  .not-found .not-found-word[_v-94537784] {\n    color: #929292;\n    font-size: 2em;\n    text-align: center;\n    margin-top: 1em; }\n\n/* line 152, stdin */\n.load-more[_v-94537784] {\n  color: #fff;\n  background-color: #00a699; }\n  /* line 155, stdin */\n  .load-more[_v-94537784]:hover {\n    background-color: #008489; }\n\n@media (max-width: 768px) {\n  /* line 160, stdin */\n  .carousel[_v-94537784] {\n    display: none; }\n  /* line 163, stdin */\n  .search-row[_v-94537784] {\n    padding: 5px; }\n  /* line 166, stdin */\n  .search-row.fixed[_v-94537784] {\n    padding-top: 59px;\n    box-shadow: none; }\n  /* line 170, stdin */\n  .search-row .search-bar[_v-94537784] {\n    width: 300px; }\n  /* line 173, stdin */\n  .show-data.fixed[_v-94537784] {\n    margin-top: 65px; } }\n\n@media (max-width: 480px) {\n  /* line 178, stdin */\n  .search-d-flex[_v-94537784] {\n    gap: 4px; }\n  /* line 181, stdin */\n  .search-row .search-bar[_v-94537784] {\n    width: 150px; }\n  /* line 184, stdin */\n  .filter-result[_v-94537784] {\n    margin-top: 18px; }\n    /* line 187, stdin */\n    .filter-result .container .tags[_v-94537784] {\n      font-size: 16px;\n      max-width: 222px; }\n    /* line 191, stdin */\n    .filter-result .container .category[_v-94537784] {\n      font-size: 12px; } }\n\n@media (max-width: 320px) {\n  /* line 201, stdin */\n  .filter-result .container .tags[_v-94537784] {\n    width: 54%; } }\n\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _vuex = require('vuex');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            init: true,
            ajaxing: false,
            updatePage: false,
            coordinate: {
                latitude: 25.0248208,
                longitude: 121.55354639999999
            },
            address: '',
            contract_tags: '',
            contract_tag_list: [],
            show_tag_list: [],
            show_category: '',
            showMore: true,
            sortOption: [1],
            filterOption: {
                radios: 10
            },
            page: 1,
            contractList: [],
            defaultLoadingCount: 12,
            carouselData: [],
            carouselSetting: {
                speed: 2000,
                active: 0
            },
            totalCount: '',
            remain: 0,
            isFixed: false,
            family: ''
        };
    },
    mounted: function mounted() {
        if ($(window).width() > 769) {
            this.getCarousels();
        };
    },
    created: function created() {
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed: function destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
    },

    watch: {
        updatePage: {
            handler: function handler(newVal, oldVal) {
                if (newVal) {
                    this.getData();
                }
            }
        }
    },
    computed: {
        loadingCount: function loadingCount() {
            if (this.ajaxing) {
                if (this.page == 1) {
                    return this.defaultLoadingCount;
                } else {
                    return 3;
                }
            }
            return 0;
        },
        displayTagsName: function displayTagsName() {
            var list = "";
            if (this.show_tag_list) {
                this.show_tag_list.forEach(function (element) {
                    list += element.name + ',';
                });
            }

            return list;
        },
        displayCategoryName: function displayCategoryName() {
            var _this = this;

            var category = this.contract_tag_list.find(function (obj) {
                return obj.id == _this.filterOption.contract_tag_category_id;
            });
            if (category) {
                return category.name;
            };
            return '';
        }
    },
    methods: {
        initFromQuery: function initFromQuery(init) {
            if (init) {
                var query = $17.getUrlQueryStrings();
                this.filterOption = {
                    'radios': query.hasOwnProperty('radios') ? query.radios : 50,
                    'price': query.hasOwnProperty('price') ? query.price : '',
                    'contract_tag_category_id': query.hasOwnProperty('category') ? query.category : 1,
                    'tags': query.hasOwnProperty('tags') ? query.tags.split(',') : [],
                    'keyword': query.hasOwnProperty('keyword') ? query.keyword : ''
                };
                this.sortOption = query.hasOwnProperty('sort') ? query.sort.split(',') : [1];

                if (query.hasOwnProperty('address')) {
                    this.coordinate = {
                        'latitude': query.lat,
                        'longitude': query.long
                    };
                    this.address = query.address;
                }

                if (query.history_from == 'home') {
                    this.keywordMatchTags(query);
                    this.radiosSettingBySearch();
                }
                this.init = false;
            }
        },
        radiosSettingBySearch: function radiosSettingBySearch(query) {
            //default radios: one tag搜尋時不限距離，其他預設50KM
            if (this.filterOption.tags.length == 1) {
                this.filterOption.radios = 300;
            } else {
                this.filterOption.radios = 50;
            };
        },
        keywordMatchTags: function keywordMatchTags(query) {
            //if keyword match tags, search by tag
            if (query.hasOwnProperty('keyword')) {
                var matchTag = this.checkKeywordMatchTag();
                if (matchTag) {
                    this.filterOption['tags'] = _lodash2.default.union(this.filterOption.tags, [matchTag.id.toString()]);
                }
            };
        },
        checkKeywordMatchTag: function checkKeywordMatchTag() {
            var _this2 = this;

            var query = $17.getUrlQueryStrings();
            var tags = this.contract_tag_list.find(function (obj) {
                return obj.id == _this2.filterOption['contract_tag_category_id'];
            }).contract_tag;
            var selectedTagIdx = '';
            var query_keyword = query.keyword;

            if (query_keyword) {
                for (var i = 0; i < query_keyword.length; i++) {
                    var matchIdx = '';
                    matchIdx = $.map(tags, function (item, index) {
                        return item.name.charCodeAt(i);
                    }).indexOf(query_keyword.charCodeAt(i));
                    matchIdx == -1 ? matchIdx = '' : selectedTagIdx += matchIdx;
                };
                var allEqual = function allEqual(arr) {
                    return arr.every(function (v) {
                        return v === arr[0];
                    });
                };
                if (allEqual(selectedTagIdx.split(" ")) && selectedTagIdx.length == query_keyword.length && selectedTagIdx.length == tags[selectedTagIdx[0]].name.length) {
                    return tags[selectedTagIdx[0]];
                }
            };
            return false;
        },
        getData: function getData(append) {
            var _this3 = this;

            var vm = this;
            var filters = this.filterOption;
            this.showMore = false;
            if (!append) {
                this.page = 1;
                this.contractList = [];
            }
            filters['page'] = this.page;

            var params = {
                'params': {
                    'coordinate': this.coordinate,
                    'filter_option': filters,
                    'sort_option': this.sortOption
                }
            };
            this.ajaxing = true;
            this.$http.get('/webapi/promotion-experience', params).then(function (response) {
                _this3.ajaxing = false;

                if (response.data.contractList.length == _this3.defaultLoadingCount) {
                    _this3.showMore = true;
                }

                _this3.totalCount = response.data.totalCount;
                _this3.remain = response.data.remain;

                if (append) {
                    _this3.contractList = _this3.contractList.concat(response.data.contractList);
                    return;
                }
                _this3.contractList = response.data.contractList;
                _this3.updatePage = false;
                return;
            }, function (error) {
                _this3.updatePage = false;
                _this3.showMore = false;
                _this3.ajaxing = false;
            });
        },
        getCarousels: function getCarousels() {
            var _this4 = this;

            this.ajaxing = true;
            this.$http.get('/webapi/intro-carousels').then(function (response) {
                _this4.ajaxing = false;

                _this4.carouselData = response.data.carousels;
                _this4.carouselSetting = response.data.settings;
                return;
            }, function (error) {
                _this4.ajaxing = false;
            });
        },
        updatePlace: function updatePlace(event) {
            this.coordinate = event.geometry.location.toJSON();
        },
        changeOption: function changeOption(options) {
            var cloneOption = (0, _assign2.default)({}, this.filterOption);
            this.sortOption = options.sortOption;
            this.filterOption = (0, _extends3.default)({}, cloneOption, options.filterOption);
            this.show_tag_list = options.displayTag;
            this.updatePage = true;
            this.updateQueryStrings('option', options);
            this.scrollTop();
        },
        getTagList: function getTagList(tags) {
            this.contract_tag_list = tags;
            this.initFromQuery(this.init);
        },
        changeGeo: function changeGeo(geo) {
            this.coordinate = geo.coordinate;
            this.address = geo.address;
            this.filterOption = (0, _extends3.default)({}, this.filterOption, {
                'keyword': geo.keyword
            });
            this.updateQueryStrings('geo-search', geo);
            this.updatePage = true;
        },
        updateQueryStrings: function updateQueryStrings(type, filter) {
            var urlQuery = $17.getUrlQueryStrings();
            var payload = {};
            if (urlQuery.hasOwnProperty('history_from')) {
                delete urlQuery.history_from;
            }
            switch (type) {
                case 'geo-search':
                    payload = {
                        address: filter.address,
                        lat: filter.coordinate.latitude,
                        long: filter.coordinate.longitude,
                        keyword: filter.keyword
                    };
                    break;
                case 'option':
                    payload = {
                        radios: filter.filterOption.radios,
                        category: filter.filterOption.contract_tag_category_id,
                        tags: filter.filterOption.tags,
                        price: filter.filterOption.price,
                        sort: filter.sortOption
                    };
                    break;
            }
            urlQuery = (0, _extends3.default)({}, urlQuery, payload);
            var newQueryString = $17.queryStringBuilder(urlQuery);
            history.replaceState({}, null, '?' + newQueryString);
        },
        changeFilterStatus: function changeFilterStatus(status) {
            $('#experience-contract-filter').modal('show');
        },
        changeGeoStatus: function changeGeoStatus() {
            $('#geo-search').modal('show');
        },
        getLocation: function getLocation() {
            var _this5 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                var vm;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                vm = _this5;

                                if (!navigator.geolocation) {
                                    _context.next = 4;
                                    break;
                                }

                                _context.next = 4;
                                return navigator.geolocation.getCurrentPosition(function (coordinate) {
                                    vm.coordinate = {
                                        latitude: coordinate.coords.latitude,
                                        longitude: coordinate.coords.longitude
                                    };
                                    vm.address = '我的位置';
                                });

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this5);
            }))();
        },
        addPage: function addPage() {
            this.page = this.page + 1;
            this.getData(true);
        },
        handleScroll: function handleScroll() {
            var fixSize = window.screen.width < 769 ? 20 : 130;
            if (window.scrollY > fixSize) {
                this.isFixed = true;
            } else {
                this.isFixed = false;
            }
        },
        scrollTop: function scrollTop() {
            window.scrollTo({
                top: 0
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n    <div class=\"container\" _v-94537784=\"\">\n        <div class=\"search-row\" :class=\"{'fixed':isFixed}\" _v-94537784=\"\">\n            <div class=\"search-d-flex\" _v-94537784=\"\">\n                <div class=\"search-item\" _v-94537784=\"\">\n                    <a class=\"left-search\" @click.prevent=\"changeGeoStatus()\" _v-94537784=\"\">\n                        <div href=\"\" class=\"btn btn-geo btn-block\" _v-94537784=\"\">\n                            <div class=\"search-bar\" _v-94537784=\"\">{{ filterOption.keyword }} \n                                <span v-if=\"filterOption.keyword &amp;&amp; address\" _v-94537784=\"\">, </span>\n                                <span class=\"address\" v-if=\"address\" _v-94537784=\"\">{{ address }}</span>\n                            </div>\n                        </div>\n                        <div class=\"search-icon btn-animate\" _v-94537784=\"\"><i class=\"fa fa-search icon\" _v-94537784=\"\"></i></div>\n                    </a>\n                </div>\n                <div class=\"filter-item\" _v-94537784=\"\">\n                    <a href=\"#\" class=\"btn btn-filter btn-animate\" :class=\"{'filterDefault':!filterOption.is_default}\" @click.prevent.stop=\"changeFilterStatus()\" _v-94537784=\"\">\n                        <i class=\"fa fa-filter\" aria-hidden=\"true\" _v-94537784=\"\"></i>\n                        篩選條件\n                    </a>\n                </div>\n            </div>\n        </div>\n        <div class=\"filter-result\" v-if=\"displayTagsName || displayCategoryName\" _v-94537784=\"\">\n            <div class=\"container\" _v-94537784=\"\">\n                <div class=\"tags\" v-if=\"displayTagsName\" _v-94537784=\"\">\n                    <span _v-94537784=\"\">「</span>\n                    <div class=\"content\" _v-94537784=\"\">{{displayTagsName}}</div>\n                    <span _v-94537784=\"\">」</span>\n                </div>\n                <div class=\"category\" _v-94537784=\"\"> ({{displayCategoryName}}) 搜尋結果</div>\n            </div>\n        </div>\n        <div class=\"show-data\" :class=\"{'fixed':isFixed}\" _v-94537784=\"\">\n            <div class=\"carousel\" _v-94537784=\"\">\n                <v-carousel v-if=\"carouselSetting.active\" :slid-slots=\"carouselData\" :speed=\"carouselSetting.speed\" _v-94537784=\"\"></v-carousel>\n            </div>\n            <div class=\"\" _v-94537784=\"\">\n                <div class=\"card-list\" _v-94537784=\"\">\n                    <promotion-experience-contract-card v-for=\"contract in contractList\" :contract=\"contract\" _v-94537784=\"\"></promotion-experience-contract-card>\n                </div>\n                <div class=\"card-list\" _v-94537784=\"\">\n                    <promotion-experience-contract-loading-card v-for=\"n in loadingCount\" _v-94537784=\"\"></promotion-experience-contract-loading-card>\n                </div>\n            </div>\n            <div v-if=\"contractList.length == 0 &amp;&amp; loadingCount ==0\" class=\"not-found\" _v-94537784=\"\">\n                <div _v-94537784=\"\">\n                    <img src=\"/images/found-icon.png\" class=\"img-fluid img-branch not-found-img\" alt=\"\" _v-94537784=\"\">\n                </div>\n                    <div class=\"not-found-word\" _v-94537784=\"\">\n                        我們找不到任何結果，請嘗試新的搜尋...\n                    </div>\n            </div>\n\n            <div class=\"row\" _v-94537784=\"\">\n                <div class=\"col-xs-12 text-center\" v-show=\"showMore &amp;&amp; remain > 0\" _v-94537784=\"\">\n                    <div class=\"load-more btn btn-default btn-lg\" @click.prevent.stop=\"addPage()\" _v-94537784=\"\">\n                        顯示更多{{ '( '+ remain+' )'}}\n                    </div>\n                </div>\n            </div>\n        </div>\n        <promotion-experience-contract-filter :init=\"init\" :filter-option=\"filterOption\" :sort-option=\"sortOption\" @get-tags=\"getTagList\" @change-option=\"changeOption\" _v-94537784=\"\"></promotion-experience-contract-filter>\n        <promotion-experience-contract-geo-search :init=\"init\" :keyword=\"filterOption.keyword\" :address-detail=\"address\" @change-geo=\"changeGeo\" _v-94537784=\"\"></promotion-experience-contract-geo-search>\n\n    <div _v-94537784=\"\">\n</div></div>"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.card-list[_v-94537784] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -ms-flex-pack: center;\n      justify-content: center; }\n\n/* line 7, stdin */\n.search-d-flex[_v-94537784] {\n  display: -ms-flexbox;\n  display: flex;\n  gap: 24px;\n  -ms-flex-pack: center;\n      justify-content: center; }\n  /* line 11, stdin */\n  .search-d-flex .search-item[_v-94537784] {\n    max-width: 613px;\n    -ms-flex-positive: 1;\n        flex-grow: 1; }\n\n/* line 19, stdin */\n.search-row[_v-94537784] {\n  font-size: 1.5em;\n  margin-top: 1em;\n  padding-bottom: 10px;\n  padding-top: 10px;\n  vertical-align: middle; }\n  /* line 25, stdin */\n  .search-row .search-bar[_v-94537784] {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    width: 100%;\n    max-width: 500px; }\n    /* line 31, stdin */\n    .search-row .search-bar .address[_v-94537784]::before {\n      content: \"\"; }\n  /* line 35, stdin */\n  .search-row .filterDefault[_v-94537784] {\n    color: white;\n    border-radius: 8px;\n    box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.17);\n    background-color: #38b0e3;\n    font-size: 16px;\n    font-weight: 500; }\n\n/* line 45, stdin */\n.search-row.fixed[_v-94537784] {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  background-color: #fff;\n  width: 100%;\n  margin-top: 0;\n  z-index: 5;\n  box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.17); }\n\n/* line 56, stdin */\n.filter-result[_v-94537784] {\n  margin-top: 30px;\n  margin-bottom: 15px; }\n  /* line 59, stdin */\n  .filter-result .container[_v-94537784] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: center;\n        justify-content: center;\n    -ms-flex-align: center;\n        align-items: center; }\n    /* line 63, stdin */\n    .filter-result .container .tags[_v-94537784] {\n      display: -ms-flexbox;\n      display: flex;\n      font-size: 18px;\n      font-weight: 500;\n      letter-spacing: normal;\n      max-width: 250px; }\n      /* line 69, stdin */\n      .filter-result .container .tags span[_v-94537784] {\n        color: #1f1f1f; }\n      /* line 72, stdin */\n      .filter-result .container .tags .content[_v-94537784] {\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        color: #38b0e3; }\n    /* line 79, stdin */\n    .filter-result .container .category[_v-94537784] {\n      font-size: 14px;\n      font-weight: normal;\n      letter-spacing: normal;\n      color: #626262; }\n\n/* line 88, stdin */\n.show-data.fixed .carousel[_v-94537784] {\n  margin-top: 80px; }\n\n/* line 93, stdin */\n.carousel[_v-94537784] {\n  margin: 2em 10px 1em 10px; }\n\n/* line 97, stdin */\n.left-search[_v-94537784] {\n  display: -ms-flexbox;\n  display: flex;\n  border-radius: 8px;\n  box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.17);\n  background-color: #ffffff; }\n  /* line 102, stdin */\n  .left-search .search-icon[_v-94537784] {\n    width: 62px;\n    background-color: #38b0e3;\n    border-bottom-right-radius: 8px;\n    border-top-right-radius: 8px;\n    text-align: center;\n    color: white; }\n    /* line 109, stdin */\n    .left-search .search-icon .fa[_v-94537784] {\n      vertical-align: middle; }\n\n/* line 115, stdin */\n.btn-geo[_v-94537784] {\n  color: #000;\n  height: 37px;\n  line-height: normal;\n  text-align: left;\n  margin-left: 10px; }\n\n/* line 123, stdin */\n.btn-filter[_v-94537784] {\n  color: #929292;\n  border: 1px solid rgba(92, 92, 92, 0.16);\n  text-align: left;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.16); }\n\n/* line 129, stdin */\n.btn-animate[_v-94537784]:hover {\n  background-color: #51c1f0; }\n\n/* line 132, stdin */\n.btn-animate[_v-94537784]:active {\n  background-color: #1293c9; }\n\n/* line 135, stdin */\n.not-found[_v-94537784] {\n  margin-top: 4em; }\n  /* line 137, stdin */\n  .not-found .not-found-img[_v-94537784] {\n    height: 15em;\n    margin: auto;\n    width: auto;\n    display: block; }\n  /* line 144, stdin */\n  .not-found .not-found-word[_v-94537784] {\n    color: #929292;\n    font-size: 2em;\n    text-align: center;\n    margin-top: 1em; }\n\n/* line 152, stdin */\n.load-more[_v-94537784] {\n  color: #fff;\n  background-color: #00a699; }\n  /* line 155, stdin */\n  .load-more[_v-94537784]:hover {\n    background-color: #008489; }\n\n@media (max-width: 768px) {\n  /* line 160, stdin */\n  .carousel[_v-94537784] {\n    display: none; }\n  /* line 163, stdin */\n  .search-row[_v-94537784] {\n    padding: 5px; }\n  /* line 166, stdin */\n  .search-row.fixed[_v-94537784] {\n    padding-top: 59px;\n    box-shadow: none; }\n  /* line 170, stdin */\n  .search-row .search-bar[_v-94537784] {\n    width: 300px; }\n  /* line 173, stdin */\n  .show-data.fixed[_v-94537784] {\n    margin-top: 65px; } }\n\n@media (max-width: 480px) {\n  /* line 178, stdin */\n  .search-d-flex[_v-94537784] {\n    gap: 4px; }\n  /* line 181, stdin */\n  .search-row .search-bar[_v-94537784] {\n    width: 150px; }\n  /* line 184, stdin */\n  .filter-result[_v-94537784] {\n    margin-top: 18px; }\n    /* line 187, stdin */\n    .filter-result .container .tags[_v-94537784] {\n      font-size: 16px;\n      max-width: 222px; }\n    /* line 191, stdin */\n    .filter-result .container .category[_v-94537784] {\n      font-size: 12px; } }\n\n@media (max-width: 320px) {\n  /* line 201, stdin */\n  .filter-result .container .tags[_v-94537784] {\n    width: 54%; } }\n\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-94537784", module.exports)
  } else {
    hotAPI.update("_v-94537784", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/object/assign":50,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],981:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 3, stdin */\n.promotion-card[_v-562452c5] {\n  max-width: 300px;\n  margin: 15px 10px;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  transition: box-shadow .25s;\n  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12); }\n\n/* line 13, stdin */\n.img-branch[_v-562452c5] {\n  width: 300px;\n  height: 204px;\n  background-color: #d6d6d6; }\n\n/* line 20, stdin */\n.contract-info[_v-562452c5] {\n  height: 9em;\n  display: -ms-flexbox;\n  display: flex;\n  background: #f7f6f6;\n  padding-left: 1em;\n  -ms-flex-pack: distribute;\n      justify-content: space-around; }\n\n/* line 29, stdin */\n.price[_v-562452c5] {\n  border-radius: 50%;\n  width: 80%;\n  height: 80%;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-direction: column;\n      flex-direction: column; }\n\n/* line 39, stdin */\n.price-radios[_v-562452c5] {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  height: 6em;\n  width: 6em;\n  border-radius: 50%;\n  background-color: #d6d6d6; }\n\n/* line 49, stdin */\n.price-space[_v-562452c5] {\n  margin-top: 1em; }\n\n/* line 52, stdin */\n.contract-name[_v-562452c5] {\n  height: 1.5em;\n  margin-top: 2em;\n  width: 10em;\n  border-radius: 0.5em;\n  background-color: #d6d6d6; }\n\n/* line 60, stdin */\n.branch-name[_v-562452c5], .addition[_v-562452c5] {\n  width: 10em;\n  height: 0.75em;\n  margin: 1em 0;\n  border-radius: 0.5em;\n  background-color: #d6d6d6; }\n\n/* line 69, stdin */\n.loading[_v-562452c5] {\n  position: relative; }\n  /* line 73, stdin */\n  .loading[_v-562452c5]::after {\n    display: block;\n    content: '';\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    transform: translateX(-100%);\n    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);\n    animation: loading 1.5s infinite linear; }\n\n@keyframes loading {\n  100% {\n    transform: translateX(100%); } }\n\n\n")
"use strict";

Object.defineProperty(exports, "__esModule", {
        value: true
});
exports.default = {};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"promotion-card\" _v-562452c5=\"\">\n        <div class=\"\" _v-562452c5=\"\">\n            <div class=\"img-fluid img-branch loading\" alt=\"\" _v-562452c5=\"\">\n            </div>\n        </div>\n        <div class=\"\" _v-562452c5=\"\">\n            <div class=\"contract-info loading\" _v-562452c5=\"\">\n                <div class=\"text-space\" _v-562452c5=\"\">\n                        <div class=\"\" _v-562452c5=\"\">\n                            <div class=\"contract-name\" _v-562452c5=\"\">\n                                <div class=\"\" _v-562452c5=\"\">&nbsp;</div>\n                            </div>\n                        </div>\n                        <div class=\"\" _v-562452c5=\"\">\n                            <div class=\"branch-name\" _v-562452c5=\"\">\n                                <div class=\"\" _v-562452c5=\"\">&nbsp;</div>\n                            </div>\n                        </div>\n                        <div class=\"\" _v-562452c5=\"\">\n                            <div class=\"addition\" _v-562452c5=\"\">\n                                <span _v-562452c5=\"\">\n                                   <div class=\"\" _v-562452c5=\"\">&nbsp;</div>\n                                </span>\n                            </div>\n                        </div>\n                </div>\n                <div class=\"price-space text-center\" _v-562452c5=\"\">\n                    <div class=\"price-radios\" _v-562452c5=\"\">\n                        <div class=\"price\" _v-562452c5=\"\">\n                            <div class=\"\" _v-562452c5=\"\">&nbsp;</div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 3, stdin */\n.promotion-card[_v-562452c5] {\n  max-width: 300px;\n  margin: 15px 10px;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  transition: box-shadow .25s;\n  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12); }\n\n/* line 13, stdin */\n.img-branch[_v-562452c5] {\n  width: 300px;\n  height: 204px;\n  background-color: #d6d6d6; }\n\n/* line 20, stdin */\n.contract-info[_v-562452c5] {\n  height: 9em;\n  display: -ms-flexbox;\n  display: flex;\n  background: #f7f6f6;\n  padding-left: 1em;\n  -ms-flex-pack: distribute;\n      justify-content: space-around; }\n\n/* line 29, stdin */\n.price[_v-562452c5] {\n  border-radius: 50%;\n  width: 80%;\n  height: 80%;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-direction: column;\n      flex-direction: column; }\n\n/* line 39, stdin */\n.price-radios[_v-562452c5] {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  height: 6em;\n  width: 6em;\n  border-radius: 50%;\n  background-color: #d6d6d6; }\n\n/* line 49, stdin */\n.price-space[_v-562452c5] {\n  margin-top: 1em; }\n\n/* line 52, stdin */\n.contract-name[_v-562452c5] {\n  height: 1.5em;\n  margin-top: 2em;\n  width: 10em;\n  border-radius: 0.5em;\n  background-color: #d6d6d6; }\n\n/* line 60, stdin */\n.branch-name[_v-562452c5], .addition[_v-562452c5] {\n  width: 10em;\n  height: 0.75em;\n  margin: 1em 0;\n  border-radius: 0.5em;\n  background-color: #d6d6d6; }\n\n/* line 69, stdin */\n.loading[_v-562452c5] {\n  position: relative; }\n  /* line 73, stdin */\n  .loading[_v-562452c5]::after {\n    display: block;\n    content: '';\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    transform: translateX(-100%);\n    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);\n    animation: loading 1.5s infinite linear; }\n\n@keyframes loading {\n  100% {\n    transform: translateX(100%); } }\n\n\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-562452c5", module.exports)
  } else {
    hotAPI.update("_v-562452c5", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],982:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.label[_v-3ec62fb6] {\n  border: 1px solid #008489;\n  color: #008489;\n  border-radius: 4px;\n  font-size: 14px;\n  font-weight: 400; }\n")
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	props: [],
	data: function data() {
		return {};
	},

	computed: {},
	methods: {}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div for=\"\" class=\"label\" _v-3ec62fb6=\"\">\n\t{{ i18n.t('pass.trail_plan') }}\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.label[_v-3ec62fb6] {\n  border: 1px solid #008489;\n  color: #008489;\n  border-radius: 4px;\n  font-size: 14px;\n  font-weight: 400; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-3ec62fb6", module.exports)
  } else {
    hotAPI.update("_v-3ec62fb6", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],983:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _single = require('./single.vue');

var _single2 = _interopRequireDefault(_single);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('qrcode-single', _single2.default);

},{"./single.vue":984,"vue":792}],984:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.qrcode[_v-0b6542c4] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  height: 100vh; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    watch: {},
    computed: {
        urlValue: function urlValue() {
            var pathName = window.location.pathname;
            var pathArray = pathName.split("/");
            return atob(pathArray.pop().replace(/_/g, '/').replace(/-/g, '+'));
            // return atob(pathArray.pop());
        }
    },
    methods: {}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"qrcode\" _v-0b6542c4=\"\">\n    <div class=\"qrcode-real\" _v-0b6542c4=\"\">\n        <v-qrcode class=\"qr-booking\" id=\"qrcode-single\" :options=\"{ width: 200 }\" :value=\"urlValue\" type=\"canvas\" _v-0b6542c4=\"\"></v-qrcode>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.qrcode[_v-0b6542c4] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  height: 100vh; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-0b6542c4", module.exports)
  } else {
    hotAPI.update("_v-0b6542c4", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],985:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    data: function data() {
        return {
            redirect: {
                back_url: '/',
                dest_url: '/'
            },
            domain: ''
        };
    },
    mounted: function mounted() {
        var query = $17.getUrlQueryStrings();
        var host = location.host;
        var isWebstudio = host.split('.')[0] == query.studio_uri;
        this.domain = host;
        if (query.class_id) {
            this.redirect.back_url = '/myclass-confirm/' + query.class_id;
        }
        if (query.branch_uri && query.studio_uri) {
            this.redirect.dest_url = isWebstudio ? '/' + query.branch_uri : '/' + query.studio_uri + '/' + query.branch_uri;
            this.redirect.dest_url += '?tab=classes';
        }
    },

    methods: {
        back: function back() {
            var url = this.redirect.back_url;
            window.open(url, '_self');
        },
        toOthers: function toOthers() {
            var url = this.redirect.dest_url;
            window.open(url, '_self');
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"st-flex st-justify-center st-items-center st-flex-col st-justify-between st-h-screen\">\n    <div></div>\n    <div class=\"st-max-w-sm st-w-full st-text-center st-space-y-4 st-px-2\">\n        <lottie-player src=\"/images/lottie/rate_limit_alert_main.json\" background=\"transparent\" speed=\"1\" style=\"width: 100%; height: auto\" direction=\"1\" mode=\"normal\" autoplay=\"\"></lottie-player>\n        <div class=\"st-font-bold st-font-medium st-text-20 st-text-black\">{{  i18n.t('class.booking_rate_limit_exceeded_message')  }}</div>\n        <st-button :text=\"i18n.t('general.return')\" @click=\"back\" full=\"\"></st-button>\n        <st-button :text=\"i18n.t('class.toward_more_class')\" @click=\"toOthers\" ghost=\"\" full=\"\"></st-button>\n    </div>\n    <div class=\"st-text-center st-mb-2\">\n        <img src=\"/images/PWAicon-114x114.jpg\" width=\"48px\">\n        <div class=\"st-text-14\">{{ i18n.t('general.supported_by_17fit') }}</div>\n   </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-7172385a", module.exports)
  } else {
    hotAPI.update("_v-7172385a", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],986:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _classBookingRedirect = require('./class-booking-redirect.vue');

var _classBookingRedirect2 = _interopRequireDefault(_classBookingRedirect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('class-booking-rate-limit-exceeded-redirect', _classBookingRedirect2.default);

},{"./class-booking-redirect.vue":985,"vue":792}],987:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 3, stdin */\n#comment-rating-modal .comment-rating-list[_v-1699bfde] {\n  width: 100%; }\n\n/* line 6, stdin */\n#comment-rating-modal .member-img[_v-1699bfde] {\n  background-image: var(--member-avatar);\n  border: 1px solid #38b0e3;\n  width: 60px;\n  height: 60px; }\n\n/* line 12, stdin */\n#comment-rating-modal .comment-list-content[_v-1699bfde] {\n  width: 100%; }\n  /* line 14, stdin */\n  #comment-rating-modal .comment-list-content .row > div[_v-1699bfde] {\n    padding: 15px 15px 8px 8px; }\n\n/* line 18, stdin */\n#comment-rating-modal .comment-score[_v-1699bfde] {\n  text-align: right;\n  vertical-align: sub;\n  font-size: 18px;\n  font-weight: 900; }\n\n/* line 24, stdin */\n#comment-rating-modal .comment-text[_v-1699bfde] {\n  padding: 0px !important;\n  border-bottom: none; }\n\n/* line 28, stdin */\n#comment-rating-modal .comment-text-in[_v-1699bfde] {\n  padding: 0px 15px 18px 15px; }\n\n@media (max-width: 415px) {\n  /* line 35, stdin */\n  #comment-rating-modal .comment-list-content .row > div[_v-1699bfde] {\n    margin-left: 5px;\n    padding: 15px 10px 8px 8px; }\n  /* line 39, stdin */\n  #comment-rating-modal .comment-list-content .row > div[_v-1699bfde]:nth-child(2) {\n    margin-left: 13px; }\n  /* line 43, stdin */\n  #comment-rating-modal .col-xs-6[_v-1699bfde] {\n    width: 40%; } }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        defaultAvatar: {
            default: '/images/default-avatar.png'
        },
        comments: {}
    },
    data: function data() {
        return {};
    },

    methods: {
        memberAvatar: function memberAvatar(path) {
            if (path == '/images/default.png') {
                return '/images/default-avatar.png';
            }
            return path;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div id=\"comment-rating-modal\" class=\"comment-rating-list row\" _v-1699bfde=\"\">\n    <div class=\"col-md-12 comment-list-content p-left-25 p-right-20\" _v-1699bfde=\"\">\n        <template v-for=\"(comment,index) in comments\">\n            <div class=\"row m-bottom-5\" _v-1699bfde=\"\">\n                <div class=\"col-md-2 col-xs-2 text-center\" _v-1699bfde=\"\">\n                    <div class=\"staff_img member-img margin_center\" :style=\"'--member-avatar:' + 'url(' + memberAvatar(comment.member_img) + ')' \" _v-1699bfde=\"\">\n                    </div>\n                </div>\n                <div class=\"col-md-2 col-xs-4 text-center\" _v-1699bfde=\"\">\n                    <div class=\"comment-data\" _v-1699bfde=\"\">\n                        <div _v-1699bfde=\"\">{{comment.member_name}}</div>\n                    </div>\n                    <div class=\"comment-data\" _v-1699bfde=\"\">{{comment.date}}</div>\n                </div>\n                <div class=\"col-md-8 col-xs-6 comment-score\" _v-1699bfde=\"\">\n                    <rating-star :rating=\"comment.rating\" _v-1699bfde=\"\"></rating-star>\n                </div>\n            </div>\n            <div class=\"row\" _v-1699bfde=\"\">\n                <div colspan=\"3\" class=\"comment-text\" _v-1699bfde=\"\">\n                    <div class=\"comment-text-in\" _v-1699bfde=\"\">{{comment.comment}}</div>\n                </div>\n            </div>\n        </template>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 3, stdin */\n#comment-rating-modal .comment-rating-list[_v-1699bfde] {\n  width: 100%; }\n\n/* line 6, stdin */\n#comment-rating-modal .member-img[_v-1699bfde] {\n  background-image: var(--member-avatar);\n  border: 1px solid #38b0e3;\n  width: 60px;\n  height: 60px; }\n\n/* line 12, stdin */\n#comment-rating-modal .comment-list-content[_v-1699bfde] {\n  width: 100%; }\n  /* line 14, stdin */\n  #comment-rating-modal .comment-list-content .row > div[_v-1699bfde] {\n    padding: 15px 15px 8px 8px; }\n\n/* line 18, stdin */\n#comment-rating-modal .comment-score[_v-1699bfde] {\n  text-align: right;\n  vertical-align: sub;\n  font-size: 18px;\n  font-weight: 900; }\n\n/* line 24, stdin */\n#comment-rating-modal .comment-text[_v-1699bfde] {\n  padding: 0px !important;\n  border-bottom: none; }\n\n/* line 28, stdin */\n#comment-rating-modal .comment-text-in[_v-1699bfde] {\n  padding: 0px 15px 18px 15px; }\n\n@media (max-width: 415px) {\n  /* line 35, stdin */\n  #comment-rating-modal .comment-list-content .row > div[_v-1699bfde] {\n    margin-left: 5px;\n    padding: 15px 10px 8px 8px; }\n  /* line 39, stdin */\n  #comment-rating-modal .comment-list-content .row > div[_v-1699bfde]:nth-child(2) {\n    margin-left: 13px; }\n  /* line 43, stdin */\n  #comment-rating-modal .col-xs-6[_v-1699bfde] {\n    width: 40%; } }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-1699bfde", module.exports)
  } else {
    hotAPI.update("_v-1699bfde", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],988:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 3, stdin */\n#comments-modal .comment-modal-title[_v-e340c8be] {\n  font-size: 18px;\n  font-weight: 600;\n  color: #000;\n  padding-left: 5px;\n  border-left: 8px solid #38b0e3; }\n\n/* line 10, stdin */\n#comments-modal .modal-sub-title-md[_v-e340c8be] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: baseline;\n      align-items: baseline; }\n\n/* line 14, stdin */\n#comments-modal .modal-sub-title-sm[_v-e340c8be] {\n  display: none; }\n\n/* line 17, stdin */\n#comments-modal .remark-style[_v-e340c8be] {\n  font-size: 12px;\n  margin-left: 9px; }\n\n/* line 21, stdin */\n#comments-modal .body-scrollable[_v-e340c8be] {\n  max-height: 600px;\n  overflow-y: auto;\n  overflow-x: hidden; }\n\n@media (max-width: 576px) {\n  /* line 30, stdin */\n  #comments-modal .comment-modal-title[_v-e340c8be] {\n    border-left: none;\n    text-align: center; }\n  /* line 34, stdin */\n  #comments-modal .modal-sub-title-md[_v-e340c8be] {\n    display: none; }\n  /* line 37, stdin */\n  #comments-modal .modal-sub-title-sm[_v-e340c8be] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: baseline;\n        align-items: baseline; } }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        apiData: {
            required: true
        }
    },
    data: function data() {
        return {
            defaultAvatar: '/images/default-avatar.png',
            ajaxing: false
        };
    },
    mounted: function mounted() {},

    methods: {}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-e340c8be=\"\">\n    <v-modal id=\"comments-modal\" class=\"comment-modal-vue\" :body-class=\"'p-right-0'\" no-footer=\"\" _v-e340c8be=\"\">\n        <div slot=\"title\" _v-e340c8be=\"\">\n            <div class=\"comment-modal-title\" _v-e340c8be=\"\">\n                評價\n            </div>\n            <div class=\"modal-sub-title-md\" _v-e340c8be=\"\">\n                <rating-star :rating=\"apiData.score_avg\" _v-e340c8be=\"\"></rating-star>\n                <div class=\"remark-style\" _v-e340c8be=\"\">({{apiData.score_count}}則評論)</div>\n            </div>\n        </div>\n        <div slot=\"body\" _v-e340c8be=\"\">\n            <div class=\"body-scrollable\" _v-e340c8be=\"\">\n                <div class=\"modal-sub-title-sm\" _v-e340c8be=\"\">\n                    <rating-star :rating=\"apiData.score_avg\" _v-e340c8be=\"\"></rating-star>\n                    <div class=\"remark-style\" _v-e340c8be=\"\">({{apiData.score_count}}則評論)</div>\n                </div>\n                <comment-list-template :comments=\"apiData.ratings\" _v-e340c8be=\"\"></comment-list-template>\n            </div>\n\n        </div>\n    </v-modal>\n\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 3, stdin */\n#comments-modal .comment-modal-title[_v-e340c8be] {\n  font-size: 18px;\n  font-weight: 600;\n  color: #000;\n  padding-left: 5px;\n  border-left: 8px solid #38b0e3; }\n\n/* line 10, stdin */\n#comments-modal .modal-sub-title-md[_v-e340c8be] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: baseline;\n      align-items: baseline; }\n\n/* line 14, stdin */\n#comments-modal .modal-sub-title-sm[_v-e340c8be] {\n  display: none; }\n\n/* line 17, stdin */\n#comments-modal .remark-style[_v-e340c8be] {\n  font-size: 12px;\n  margin-left: 9px; }\n\n/* line 21, stdin */\n#comments-modal .body-scrollable[_v-e340c8be] {\n  max-height: 600px;\n  overflow-y: auto;\n  overflow-x: hidden; }\n\n@media (max-width: 576px) {\n  /* line 30, stdin */\n  #comments-modal .comment-modal-title[_v-e340c8be] {\n    border-left: none;\n    text-align: center; }\n  /* line 34, stdin */\n  #comments-modal .modal-sub-title-md[_v-e340c8be] {\n    display: none; }\n  /* line 37, stdin */\n  #comments-modal .modal-sub-title-sm[_v-e340c8be] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: baseline;\n        align-items: baseline; } }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-e340c8be", module.exports)
  } else {
    hotAPI.update("_v-e340c8be", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],989:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.list-margin[_v-3a1fc07e] {\n  padding: 16px;\n  margin: 12px 0; }\n\n/* line 6, stdin */\n.member-img[_v-3a1fc07e] {\n  width: 64px;\n  height: 64px; }\n\n/* line 10, stdin */\n.show-more[_v-3a1fc07e] {\n  display: inline;\n  float: right;\n  color: #38b0e3;\n  text-decoration: underline;\n  margin-top: 20px; }\n\n/* line 17, stdin */\n.small-overflow-hidden[_v-3a1fc07e] {\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n  display: -webkit-inline-box;\n  -webkit-box-orient: vertical;\n  text-align: left;\n  width: 80%; }\n  /* line 24, stdin */\n  .small-overflow-hidden.show[_v-3a1fc07e] {\n    overflow: none;\n    width: 100%; }\n\n@media (min-width: 0px) and (max-width: 1000px) {\n  /* line 31, stdin */\n  .view-container[_v-3a1fc07e] {\n    margin: 0 16px; } }\n")
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        branchId: {
            default: 0
        }
    },
    data: function data() {
        return {
            ratings: {},
            scoreAvg: "",
            scoreCount: ""
        };
    },

    watch: {},
    mounted: function mounted() {
        this.refresh(true);
    },

    computed: {
        apiConfig: function apiConfig() {
            return {
                methods: 'get',
                apiurl: "/api/branch/" + this.branchId + "/ratings",
                dataName: 'comments'
            };
        },
        noDataMsg: function noDataMsg() {
            return i18n.t('rating.have_no_any_comment');
        }
    },
    methods: {
        refresh: function refresh() {
            var checkData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            if (checkData) {
                if (!_lodash2.default.isEmpty(this.ratings)) return;
            };
            this.$refs.rating_view.fetchData();
        },
        fetchSuccess: function fetchSuccess(data) {
            var _this = this;

            this.ratings = data;
            this.scoreAvg = data.scoreAvg;
            this.scoreCount = data.scoreCount;
            this.$nextTick(function () {
                _this.mountedUI(data);
            });
        },
        fetchFail: function fetchFail(data) {
            $17.swal({
                type: 'error',
                title: "讀取資料發生錯誤，請重新嘗試",
                showCancelButton: false
            });
        },
        avatar: function avatar(pic) {
            var path = pic;
            var defaultAvatar = '/images/default.png';
            return "url(" + path + "), url(" + defaultAvatar + ")";
        },
        showMore: function showMore(event) {
            $(event.target).prev().toggleClass('show');
            $(event.target).css('display', 'none');
        },
        mountedUI: function mountedUI(data) {
            data.comments.forEach(function (item) {
                var el = $(".small-overflow-hidden[data-show=" + item.id + "]")[0];
                if (el) {
                    var isEllipsisActive = el.offsetWidth < el.scrollWidth || el.offsetHeight < el.scrollHeight;
                    el.nextElementSibling.style.display = isEllipsisActive ? 'inline' : 'none';
                }
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n    <div class=\"view-container\" _v-3a1fc07e=\"\">\n        <div style=\"display: flex; align-items: center; gap: 8px;\" v-show=\"scoreCount\" _v-3a1fc07e=\"\">\n            <a class=\"btn-brand--label primary-business-color-background\" _v-3a1fc07e=\"\">{{ scoreAvg }}</a>\t\t\t\n\t\t\t<p class=\"regular\" _v-3a1fc07e=\"\">{{ scoreCount }} {{i18n.t('rating.comments')}}</p>\n        </div>\n        <v-switch-layout ref=\"rating_view\" :api-config=\"apiConfig\" :no-data-message=\"noDataMsg\" list-style-class=\"col-xs-12 p-left-0 p-right-0\" @fetch-success-callback=\"fetchSuccess\" @fetch-fail-callback=\"fetchFail\" _v-3a1fc07e=\"\">\n            <template slot=\"list\" slot-scope=\"{item}\">\n                <div class=\"round-border list-margin\" _v-3a1fc07e=\"\">\n                    <div _v-3a1fc07e=\"\">\n                        <div style=\"display: inline-flex; gap: 16px; align-items: center;\" _v-3a1fc07e=\"\">\n                            <span _v-3a1fc07e=\"\">\n                                <div class=\"member-img staff_img margin_center\" :style=\"{'background-image': avatar(item.member_pic) }\" _v-3a1fc07e=\"\"></div>\n                            </span>\n                            <span _v-3a1fc07e=\"\">\n                                <font class=\"title-5\" style=\"color: #000000;\" _v-3a1fc07e=\"\">{{item.member_name}}</font>\n                                <p class=\"ex-small grey--70\" _v-3a1fc07e=\"\">{{item.date}}</p>\n                            </span>                            \n                        </div>\n                        <a class=\"btn-brand--label primary-business-color-background\" style=\"display: inline-block;float: right;\" _v-3a1fc07e=\"\">{{item.score}}</a>\n                    </div>\n                    <div class=\"m-top-10 m-bottom-15\" _v-3a1fc07e=\"\">\n                        <p class=\"txt-small word-break grey--70 small-overflow-hidden\" :data-show=\"item.id\" _v-3a1fc07e=\"\">{{item.comment}}</p>\n                        <span class=\"show-more\" @click.prevent=\"showMore\" _v-3a1fc07e=\"\">{{i18n.t('rating.more')}}</span>\n                    </div>\n                </div>\n            </template>\n        </v-switch-layout>\n    </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.list-margin[_v-3a1fc07e] {\n  padding: 16px;\n  margin: 12px 0; }\n\n/* line 6, stdin */\n.member-img[_v-3a1fc07e] {\n  width: 64px;\n  height: 64px; }\n\n/* line 10, stdin */\n.show-more[_v-3a1fc07e] {\n  display: inline;\n  float: right;\n  color: #38b0e3;\n  text-decoration: underline;\n  margin-top: 20px; }\n\n/* line 17, stdin */\n.small-overflow-hidden[_v-3a1fc07e] {\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n  display: -webkit-inline-box;\n  -webkit-box-orient: vertical;\n  text-align: left;\n  width: 80%; }\n  /* line 24, stdin */\n  .small-overflow-hidden.show[_v-3a1fc07e] {\n    overflow: none;\n    width: 100%; }\n\n@media (min-width: 0px) and (max-width: 1000px) {\n  /* line 31, stdin */\n  .view-container[_v-3a1fc07e] {\n    margin: 0 16px; } }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-3a1fc07e", module.exports)
  } else {
    hotAPI.update("_v-3a1fc07e", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],990:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

},{"vue":792}],991:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("@charset \"UTF-8\";\n/* line 2, stdin */\n.rating-stars {\n  --percent: calc(var(--rating) / 10 * 100%);\n  --star-size: 14px;\n  --star-color: #dddddd;\n  --star-background: #5adfff;\n  display: inline-block;\n  font-size: var(--star-size);\n  font-family: Times;\n  line-height: 1; }\n  /* line 13, stdin */\n  .rating-stars::before {\n    content: '★★★★★';\n    letter-spacing: 3px;\n    background: linear-gradient(90deg, var(--star-background) var(--percent), var(--star-color) var(--percent));\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent; }\n")
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        rating: {
            type: [Number, String],
            default: 0,
            description: "Number only, rating out of 10."
        }
    },
    watch: {},
    computed: {},
    methods: {}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"rating-stars-container\">\n    <div class=\"rating-stars\" :style=\"'--rating:'+rating+';'\" aria-label=\"Rating out of 10.\">\n</div>\n</div>"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["@charset \"UTF-8\";\n/* line 2, stdin */\n.rating-stars {\n  --percent: calc(var(--rating) / 10 * 100%);\n  --star-size: 14px;\n  --star-color: #dddddd;\n  --star-background: #5adfff;\n  display: inline-block;\n  font-size: var(--star-size);\n  font-family: Times;\n  line-height: 1; }\n  /* line 13, stdin */\n  .rating-stars::before {\n    content: '★★★★★';\n    letter-spacing: 3px;\n    background: linear-gradient(90deg, var(--star-background) var(--percent), var(--star-color) var(--percent));\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-17f260c5", module.exports)
  } else {
    hotAPI.update("_v-17f260c5", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],992:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.staff_img[_v-5361846b] {\n  width: 40px;\n  height: 40px; }\n\n/* line 6, stdin */\n.member_img[_v-5361846b] {\n  width: 80px;\n  height: 80px; }\n\n/* line 10, stdin */\n.show-more[_v-5361846b] {\n  display: none; }\n\n@media screen and (max-width: 414px) {\n  /* line 14, stdin */\n  .show-more[_v-5361846b] {\n    display: inline;\n    float: right;\n    color: #38b0e3;\n    text-decoration: underline;\n    margin-top: 20px; }\n  /* line 21, stdin */\n  .small-overflow-hidden[_v-5361846b] {\n    -webkit-line-clamp: 2;\n    overflow: hidden;\n    display: -webkit-inline-box;\n    -webkit-box-orient: vertical;\n    text-align: left;\n    width: 80%; }\n    /* line 28, stdin */\n    .small-overflow-hidden.show[_v-5361846b] {\n      overflow: none;\n      width: 100%; } }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['apiConfig', 'serviceProvider', 'branch'],
    data: function data() {
        return {
            ajaxing: false,
            comments: [],
            pageMeta: {},
            next: false,
            currentStaffId: 0
        };
    },

    watch: {
        apiConfig: {
            handler: function handler(newV) {
                if (newV) {
                    this.reset();
                    this.fetchData(1, newV);
                }
            },

            deep: true,
            immediate: true
        }
    },
    computed: {},
    mounted: function mounted() {
        var _this = this;

        $(this.$el).scroll(function (event) {
            var modal = $('#v-comment-modal')[0];
            var scrollTotal = modal.scrollHeight - modal.clientHeight;
            var nextPage = _this.pageMeta.lastPage > _this.pageMeta.currentPage ? _this.pageMeta.currentPage + 1 : null;
            var readyNext = !_this.ajaxing && !_this.next;
            if (modal.scrollTop / scrollTotal == 1 && nextPage && readyNext) {
                _this.fetchData(nextPage, _this.apiConfig);
            }
        });
    },
    destroyed: function destroyed() {},

    methods: {
        fetchData: function fetchData() {
            var _this2 = this;

            var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
            var config = arguments[1];

            page == 1 ? this.ajaxing = true : this.next = true;
            this.$http.get(config.apiurl, {
                params: { page: page }
            }).then(function (response) {
                _this2.ajaxing = false;
                _this2.next = false;
                if (_.isEqual(config, _this2.apiConfig)) {
                    _this2.set(response.data);
                }
            }, function (error) {
                _this2.ajaxing = false;
                _this2.next = false;
            });
        },
        set: function set(result) {
            var _this3 = this;

            var page = result.hasOwnProperty('pageMeta') ? result.pageMeta.currentPage : 1;
            var dataName = this.apiConfig.hasOwnProperty('dataName') ? this.apiConfig.dataName : 'data';
            if (page == 1) {
                if (this.ajaxing || this.next) {
                    this.reset();
                    return;
                }
                this.comments = result[dataName];
                this.pageMeta = result.pageMeta;
            } else {
                this.comments = this.comments.concat(result[dataName]);
                this.pageMeta = result.pageMeta;
            }
            this.$nextTick(function () {
                _this3.mountedUI(result);
            });
        },
        reset: function reset() {
            this.comments = [];
            this.pageMeta = {};
        },
        showMore: function showMore(event) {
            $(event.target).prev().toggleClass('show');
            $(event.target).css('display', 'none');
        },
        mountedUI: function mountedUI(data) {
            var dataName = this.apiConfig.hasOwnProperty('dataName') ? this.apiConfig.dataName : 'data';
            if ($('#v-comment-modal .modal-dialog').width() < 414) {
                data[dataName].forEach(function (item) {
                    var el = $('.small-overflow-hidden[data-show=' + item.id + ']')[0];
                    var isEllipsisActive = el.offsetWidth < el.scrollWidth || el.offsetHeight < el.scrollHeight;
                    if (!isEllipsisActive) {
                        el.nextElementSibling.style.display = 'none';
                    }
                });
            }
        },
        thousandthFormat: function thousandthFormat(number) {
            return $17.thousandthFormat(number);
        },
        avatar: function avatar(pic) {
            var path = pic ? pic : '/images/default.png';
            var defaultAvatar = '/images/default.png';
            return 'url(' + path + '), url(' + defaultAvatar + ')';
        },
        removeBr: function removeBr(des) {
            return des.replace(/<br ?\/?>/ig, " ");
        }
    }

};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal id=\"v-comment-modal\" :body-class=\"'p-right-0'\" border-radius-level=\"20px\" no-footer=\"\" _v-5361846b=\"\">\n    <div slot=\"title\" _v-5361846b=\"\">\n        <div v-if=\"serviceProvider\" _v-5361846b=\"\">\n            <div style=\"display: flex; gap: 16px\" _v-5361846b=\"\">\n                <span _v-5361846b=\"\">\n                    <div class=\"staff_img margin_center\" :style=\"{'background-image': avatar(serviceProvider.pic) }\" _v-5361846b=\"\"></div>\n                </span>\n                <span _v-5361846b=\"\">\n                    <font class=\"title-4\" style=\"color: #171725;\" _v-5361846b=\"\">{{serviceProvider.name}}</font>\n                    <p class=\"ex-small grey--80\" _v-5361846b=\"\">{{thousandthFormat(serviceProvider.rating)}} {{ i18n.t('rating.comments') }}</p>\n                </span>\n            </div>\n            <div class=\"m-top-10\" v-if=\"serviceProvider.desc\" _v-5361846b=\"\">\n                <p class=\"txt-small word-break grey--70\" _v-5361846b=\"\">{{removeBr(serviceProvider.desc)}}</p>\n            </div>                \n        </div>\n        <div v-else-if=\"branch\" _v-5361846b=\"\">\n            <font class=\"title-4\" style=\"color: #171725;\" _v-5361846b=\"\">{{branch.branch_name}}</font>\n            <p class=\"ex-small grey--80\" _v-5361846b=\"\">{{thousandthFormat(branch.score_count)}} {{ i18n.t('rating.comments') }}</p>\n        </div>\n        <div v-else=\"\" _v-5361846b=\"\">\n            <font class=\"title-4\" _v-5361846b=\"\">{{ i18n.t('general.rating') }}</font>\n        </div>\n    </div>\n    <div slot=\"body\" _v-5361846b=\"\">\n        <div class=\"m-right-15\" _v-5361846b=\"\">\n            <v-base-card :is-loading=\"ajaxing\" :data-source=\"comments\" css-class=\"divide-line\" :ajaxing-next=\"next\" _v-5361846b=\"\">\n                <template slot-scope=\"{item}\">\n                    <div _v-5361846b=\"\">\n                        <div style=\"display: inline-flex; gap: 16px; align-items: center;\" _v-5361846b=\"\">\n                            <span _v-5361846b=\"\">\n                                <div class=\"staff_img member_img margin_center\" :style=\"{'background-image': avatar(item.member_pic) }\" _v-5361846b=\"\"></div>\n                            </span>\n                            <span _v-5361846b=\"\">\n                                <font class=\"title-5\" style=\"color: #000000;\" _v-5361846b=\"\">{{item.member_name}}</font>\n                                <p class=\"ex-small grey--70\" _v-5361846b=\"\">{{item.date}}</p>\n                            </span>                            \n                        </div>\n                        <a class=\"btn-brand--label primary-business-color-background\" style=\"display: inline-block;float: right;\" _v-5361846b=\"\">{{item.score}}</a>\n                    </div>\n                    <div class=\"m-top-10 m-bottom-15\" _v-5361846b=\"\">\n                        <p class=\"txt-small word-break grey--70 small-overflow-hidden\" :data-show=\"item.id\" _v-5361846b=\"\">{{item.comment}}</p><span class=\"show-more\" @click.prevent=\"showMore\" _v-5361846b=\"\">看更多</span>\n                    </div>\n                </template>\n            </v-base-card> \n        </div>\n    </div>\n</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.staff_img[_v-5361846b] {\n  width: 40px;\n  height: 40px; }\n\n/* line 6, stdin */\n.member_img[_v-5361846b] {\n  width: 80px;\n  height: 80px; }\n\n/* line 10, stdin */\n.show-more[_v-5361846b] {\n  display: none; }\n\n@media screen and (max-width: 414px) {\n  /* line 14, stdin */\n  .show-more[_v-5361846b] {\n    display: inline;\n    float: right;\n    color: #38b0e3;\n    text-decoration: underline;\n    margin-top: 20px; }\n  /* line 21, stdin */\n  .small-overflow-hidden[_v-5361846b] {\n    -webkit-line-clamp: 2;\n    overflow: hidden;\n    display: -webkit-inline-box;\n    -webkit-box-orient: vertical;\n    text-align: left;\n    width: 80%; }\n    /* line 28, stdin */\n    .small-overflow-hidden.show[_v-5361846b] {\n      overflow: none;\n      width: 100%; } }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-5361846b", module.exports)
  } else {
    hotAPI.update("_v-5361846b", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],993:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _scheduleListApp = require('./schedule-list-app.vue');

var _scheduleListApp2 = _interopRequireDefault(_scheduleListApp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('v-schedule-list-app', _scheduleListApp2.default);

},{"./schedule-list-app.vue":994,"vue":792}],994:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.schedule-list-section[_v-2068dbb6] {\n  margin-left: -12px;\n  margin-right: -12px; }\n  /* line 6, stdin */\n  .schedule-list-section .round-border.list[_v-2068dbb6] {\n    display: -ms-flexbox;\n    display: flex; }\n    /* line 8, stdin */\n    .schedule-list-section .round-border.list .branch-img[_v-2068dbb6] {\n      border-top-left-radius: 8px;\n      border-bottom-left-radius: 8px; }\n    /* line 12, stdin */\n    .schedule-list-section .round-border.list .detail[_v-2068dbb6] {\n      margin: auto 16px auto 24px; }\n  /* line 17, stdin */\n  .schedule-list-section .round-border.grid .img-box[_v-2068dbb6] {\n    background-color: #c3c3c3;\n    position: relative;\n    width: 100%;\n    padding-top: 58%;\n    border-top-left-radius: 8px;\n    border-top-right-radius: 8px; }\n  /* line 25, stdin */\n  .schedule-list-section .round-border.grid .detail[_v-2068dbb6] {\n    padding: 16px;\n    height: 245px; }\n  /* line 31, stdin */\n  .schedule-list-section img[_v-2068dbb6] {\n    background-color: #c3c3c3; }\n  /* line 34, stdin */\n  .schedule-list-section .detail[_v-2068dbb6] {\n    width: 100%; }\n  /* line 37, stdin */\n  .schedule-list-section .item-center[_v-2068dbb6] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center; }\n  /* line 41, stdin */\n  .schedule-list-section .overflow-hidden[_v-2068dbb6] {\n    overflow: hidden;\n    display: -webkit-inline-box;\n    -webkit-box-orient: vertical;\n    text-align: left;\n    width: 100%;\n    -webkit-line-clamp: 1; }\n  /* line 49, stdin */\n  .schedule-list-section .map-btn[_v-2068dbb6] {\n    background-color: #0099FF; }\n\n/* line 54, stdin */\n.search-section.web-search[_v-2068dbb6] {\n  display: -ms-flexbox;\n  display: flex;\n  gap: 8px;\n  -ms-flex-align: start;\n      align-items: flex-start; }\n\n/* line 59, stdin */\n.search-section.modal-search[_v-2068dbb6] {\n  max-width: 500px;\n  margin: 60px auto;\n  padding: 0 20px;\n  text-align: center; }\n\n/* line 65, stdin */\n.search-section .btn[_v-2068dbb6] {\n  padding: 8px 16px; }\n\n/* line 68, stdin */\n.search-section .w-auto[_v-2068dbb6] {\n  -ms-flex-positive: 1;\n      flex-grow: 1; }\n\n/* line 71, stdin */\n.search-section input[_v-2068dbb6] {\n  width: 100%;\n  border: 1px solid #EEEEEE;\n  border-radius: 8px;\n  margin-bottom: 0;\n  background-color: #ffffff;\n  padding: 12px 28px 12px 12px; }\n\n/* line 79, stdin */\n.search-section #select-category .fp-select[_v-2068dbb6] {\n  min-width: 130px;\n  width: 100%;\n  margin-bottom: 0;\n  border: 1px solid #EEEEEE;\n  border-radius: 8px; }\n  /* line 85, stdin */\n  .search-section #select-category .fp-select[_v-2068dbb6]::before {\n    line-height: 46px;\n    color: #000000;\n    z-index: 3; }\n  /* line 90, stdin */\n  .search-section #select-category .fp-select select[_v-2068dbb6] {\n    height: 46px;\n    border: none;\n    background-color: white; }\n\n/* line 96, stdin */\n.search-section .filter-result[_v-2068dbb6] {\n  padding: 9px; }\n  /* line 98, stdin */\n  .search-section .filter-result br[_v-2068dbb6] {\n    display: none; }\n\n/* line 102, stdin */\n.search-section .pad-show.btn.btn-default--label[_v-2068dbb6] {\n  background: #44444F; }\n\n/* line 106, stdin */\n.sticky-section[_v-2068dbb6] {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  background: white;\n  padding-top: 8px; }\n\n/* line 113, stdin */\n.web-show[_v-2068dbb6] {\n  display: block; }\n\n/* line 116, stdin */\n.pad-show[_v-2068dbb6] {\n  display: none; }\n\n@media screen and (max-width: 991px) {\n  /* line 120, stdin */\n  .search-section[_v-2068dbb6] {\n    -ms-flex-align: center;\n        align-items: center; }\n  /* line 123, stdin */\n  .web-show[_v-2068dbb6] {\n    display: none; }\n  /* line 126, stdin */\n  .pad-show[_v-2068dbb6] {\n    display: block; } }\n\n@media screen and (max-width: 768px) {\n  /* line 131, stdin */\n  .sticky-section[_v-2068dbb6] {\n    top: 54px; } }\n\n@media screen and (max-width: 576px) {\n  /* line 137, stdin */\n  .search-section .title-5[_v-2068dbb6] {\n    font-size: 16px; }\n  /* line 140, stdin */\n  .search-section.web-search[_v-2068dbb6] {\n    display: -ms-flexbox;\n    display: flex;\n    gap: 8px;\n    -ms-flex-align: center;\n        align-items: center; }\n  /* line 145, stdin */\n  .search-section .filter-result[_v-2068dbb6] {\n    padding: 0; }\n    /* line 147, stdin */\n    .search-section .filter-result br[_v-2068dbb6] {\n      display: block; } }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: [],
    data: function data() {
        return {
            ajaxing: false,
            category: {},
            filter: {
                start_time: '00:00',
                end_time: '23:59',
                keyword: '',
                service_category_id: '',
                date: ''
            },
            show: {
                start_time: '00:00',
                end_time: '23:59',
                keyword: '',
                service_category_id: ''
            },
            mapSelected: {}
        };
    },

    computed: {
        apiConfig: function apiConfig() {
            return {
                methods: 'get',
                apiurl: '/webapi/schedule-list',
                payload: (0, _extends3.default)({}, this.filter, {
                    page: 1
                }),
                dataName: 'list'
            };
        },
        showStart: function showStart() {
            var start = this.timeToIntString(this.show.start_time);
            var format = this.IntTimeFormat(start, 12);
            return format.time + ' ' + format.hr + ':' + format.min;
        },
        showEnd: function showEnd() {
            var end = this.timeToIntString(this.show.end_time);
            var format = this.IntTimeFormat(end, 12);
            return format.time + ' ' + format.hr + ':' + format.min;
        },
        categoryName: function categoryName() {
            return this.category[this.filter.service_category_id];
        }
    },
    mounted: function mounted() {
        this.initFilter();
    },

    methods: {
        initFilter: function initFilter() {
            var _this = this;

            this.fetchScheduleCategory();

            var params = $17.getUrlQueryStrings();
            var queryDate = params.date ? params.date : '';
            var today = (0, _moment2.default)().format('YYYY-MM-DD');
            var tomorrow = (0, _moment2.default)().add(1, 'days').format('YYYY-MM-DD');
            var date = tomorrow;
            if (queryDate) {
                date = (0, _moment2.default)(queryDate).isBefore(today) ? tomorrow : queryDate;
            }
            this.filter = {
                start_time: params.start_time ? params.start_time : '00:00',
                end_time: params.end_time ? params.end_time : '23:59',
                keyword: params.keyword ? params.keyword : '',
                service_category_id: params.service_category_id ? params.service_category_id : '',
                date: date
            };
            this.$nextTick(function () {
                _this.syncViewWithFilter();
                _this.initTimeSlider("#slider-big-vue");
                _this.initDaySelector();
            });
        },
        initTimeSlider: function initTimeSlider(target) {
            var vm = this;
            var min = this.timeToIntString(this.filter.start_time);
            var max = this.timeToIntString(this.filter.end_time);
            this.$nextTick(function () {
                $(target).slider({
                    range: true,
                    min: 0,
                    max: 1440,
                    step: 15,
                    values: [min, max],
                    slide: function slide(e, ui) {
                        var start = vm.IntTimeFormat(ui.values[0], 24);
                        var end = vm.IntTimeFormat(ui.values[1], 24);
                        vm.show.start_time = start.hr + ':' + start.min;
                        vm.show.end_time = end.hr + ':' + end.min;
                    }
                });
                $(target).draggable();
            });
        },
        initDaySelector: function initDaySelector() {
            $17.daySelector({
                el: '#schedule-day-selector',
                widthRef: '#vue-schedule-app',
                loadWhenReady: true,
                dayStart: new Date(),
                selectedDay: this.filter.date,
                type: 'm',
                count: 6,
                trigger: this.selectDate,
                disableDateClick: this.ajaxing
            });
        },
        selectDate: function selectDate(date) {
            var _this2 = this;

            var flag = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            this.filter.date = (0, _moment2.default)(date).format('YYYY-MM-DD');
            this.show.date = this.filter.date;
            this.$nextTick(function () {
                _this2.$refs.schedule_list_view.fetchData();
                _this2.updateQueryStrings(_this2.filter);
                _this2.ajaxing = true;
                flag.ajaxing = false;
            });
        },
        fetchSuccess: function fetchSuccess(data) {
            this.ajaxing = false;
        },
        fetchFail: function fetchFail(data) {
            this.ajaxing = false;
        },
        fetchScheduleCategory: function fetchScheduleCategory() {
            var _this3 = this;

            this.$http.get('/webapi/schedule-category').then(function (response) {
                _this3.category = response.data;
            });
        },
        showResult: function showResult() {
            this.filter = (0, _extends3.default)({}, this.filter, this.show);
            this.syncViewWithFilter();
            $('#schedule-list-search-modal').modal('hide');
        },
        resetAll: function resetAll() {
            var reset = {
                start_time: '00:00',
                end_time: '23:59',
                keyword: '',
                service_category_id: ''
            };
            this.filter = (0, _extends3.default)({}, this.filter, reset);
            this.syncViewWithFilter();
            this.initTimeSlider("#slider-big-vue");
            $('#schedule-list-search-modal').modal('hide');
        },
        syncViewWithFilter: function syncViewWithFilter() {
            var _this4 = this;

            this.$nextTick(function () {
                _this4.$refs.schedule_list_view.fetchData();
                _this4.show = (0, _assign2.default)({}, _this4.filter);
                _this4.updateQueryStrings(_this4.filter);
            });
        },
        showFilter: function showFilter() {
            if (this.ajaxing) return;
            this.initTimeSlider("#slider-small-vue");
            $('#schedule-list-search-modal').modal('show');
        },
        showMap: function showMap(item) {
            this.mapSelected = item;
            $('#map-modal').modal('show');
        },
        updateQueryStrings: function updateQueryStrings(params) {
            var newQueryString = $17.queryStringBuilder(params);
            history.replaceState({}, null, '?' + newQueryString);
        },
        timeToIntString: function timeToIntString(time) {
            var res = time.split(":");
            return parseInt(res[0] * 60) + parseInt(res[1]);
        },
        IntTimeFormat: function IntTimeFormat(value) {
            var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 12;

            var time = '';
            var hours = Math.floor(value / 60);
            var minutes = value - hours * 60;

            if (mode == 24) {
                return {
                    hr: hours,
                    min: minutes
                };
            };

            if (hours >= 12) {
                time = i18n.t('general.afternoon');
                if (hours == 12) {
                    hours = hours;
                    minutes = minutes;
                } else {
                    hours = hours - 12;
                    minutes = minutes;
                    if (hours == 12 && minutes == 0) {
                        hours = 11;
                        minutes = 59;
                    }
                }
            } else {
                time = i18n.t('general.morning');
                hours = hours;
                minutes = minutes;
            }
            hours = ("0" + hours).slice(-2);
            minutes = ("0" + minutes).slice(-2);
            return {
                time: time,
                hr: hours,
                min: minutes
            };
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div id=\"vue-schedule-app\" class=\"m-top-25\" _v-2068dbb6=\"\">\n<div class=\"container\" style=\"margin: 0 auto;\" _v-2068dbb6=\"\">\n    <div class=\"sticky-section\" _v-2068dbb6=\"\">\n        <div class=\"search-section web-search\" _v-2068dbb6=\"\">\n            <div class=\"web-show w-auto\" _v-2068dbb6=\"\">\n                <input placeholder=\"請輸入關鍵字\" v-model=\"show.keyword\" name=\"keyword\" type=\"text\" class=\"keyword\" _v-2068dbb6=\"\">\n                <i class=\"material-icons\" style=\"position: absolute; transform: translate(-30px, 10px);}\" _v-2068dbb6=\"\">search</i>\n            </div>\n            <div class=\"web-show select w-20\" id=\"select-category\" _v-2068dbb6=\"\">\n                <span class=\"fp-select\" _v-2068dbb6=\"\">\n                    <select id=\"service_category_id\" class=\"service_category_id grey--100\" name=\"service_category_id\" v-model=\"show.service_category_id\" _v-2068dbb6=\"\">\n                        <option v-for=\"(item, key) in category\" :value=\"key\" _v-2068dbb6=\"\">{{item}}</option>\n                    </select>\n                </span>\n            </div> \n            <div class=\"web-show start-end-time m-left-5\" _v-2068dbb6=\"\">\n                <div class=\"select\" _v-2068dbb6=\"\">\n                    <div id=\"time-range\" style=\"width: 280px; text-align: center;\" _v-2068dbb6=\"\">\n                        <span class=\"grey--90\" _v-2068dbb6=\"\">{{showStart}}</span> - <span class=\"grey--90\" _v-2068dbb6=\"\">{{showEnd}}</span>\n                        <div id=\"slider-range\" _v-2068dbb6=\"\">\n                            <div id=\"slider-big-vue\" class=\"slider\" _v-2068dbb6=\"\"></div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <a class=\"web-show btn btn-primary--label m-top-10\" @click.prevent=\"showResult\" :disabled=\"ajaxing\" _v-2068dbb6=\"\">顯示結果</a>\n            <a class=\"web-show btn btn-default--label m-top-10\" @click.prevent=\"resetAll\" :disabled=\"ajaxing\" _v-2068dbb6=\"\">重置</a>\n\n            <div class=\"pad-show w-auto filter-result\" _v-2068dbb6=\"\">\n                <font class=\"title-5 grey--80\" _v-2068dbb6=\"\">\n                    {{filter.keyword}} <span v-show=\"filter.keyword\" _v-2068dbb6=\"\">, <br _v-2068dbb6=\"\"></span> \n                    <span v-show=\"filter.service_category_id\" _v-2068dbb6=\"\">{{categoryName}}</span>\n                </font>\n            </div>\n            <a class=\"pad-show btn btn-default--label m-top-5\" @click.prevent=\"showFilter\" :disabled=\"ajaxing\" _v-2068dbb6=\"\"><i class=\"material-icons\" _v-2068dbb6=\"\">filter_list</i> 篩選項目</a>\n\n            <v-switch-layout-btn :target-view=\"$refs.schedule_list_view\" _v-2068dbb6=\"\">\n            </v-switch-layout-btn>       \n        </div>\n        <div _v-2068dbb6=\"\">\n            <div id=\"schedule-day-selector\" _v-2068dbb6=\"\"></div>\n        </div>             \n    </div>\n\n\n    <div class=\"schedule-list-section\" _v-2068dbb6=\"\">\n        <v-switch-layout ref=\"schedule_list_view\" :api-config=\"apiConfig\" list-style-class=\"col-xs-12 p-left-0 p-right-0\" grid-style-class=\"col-md-4 col-sm-6 col-xs-12 p-left-0 p-right-0\" @fetch-success-callback=\"fetchSuccess\" @fetch-fail-callback=\"fetchFail\" _v-2068dbb6=\"\">\n            <template slot=\"list\" slot-scope=\"{item}\">\n                <div class=\"round-border list\" _v-2068dbb6=\"\">\n                    <div _v-2068dbb6=\"\"><img class=\"branch-img\" :src=\"item.branch_img\" height=\"170px\" width=\"283px\" _v-2068dbb6=\"\"></div>\n                    <div class=\"detail\" _v-2068dbb6=\"\">\n                        <div class=\"header m-bottom-10 item-center\" _v-2068dbb6=\"\">\n                            <img v-if=\"item.is_live\" src=\"/images/live-stream.png\" width=\"30px\" height=\"auto\" _v-2068dbb6=\"\">\n                            <font class=\"title-4 grey--100 m-left-5\" _v-2068dbb6=\"\">{{item.class_name}}</font>\n                        </div>\n                        <div class=\"item-center m-bottom-10\" @click.prevent.stop=\"showMap(item)\" _v-2068dbb6=\"\">\n                            <a class=\"btn-primary--label m-right-5 map-btn primary-business-color-backgroun\" _v-2068dbb6=\"\"><i class=\"material-icons\" _v-2068dbb6=\"\">location_on</i>MAP</a>\n                            <p class=\"regular grey--80\" _v-2068dbb6=\"\">{{item.landmark}}</p>\n                        </div>\n                        <div class=\"m-bottom-15\" _v-2068dbb6=\"\">\n                            <p class=\"regular font-bold grey--80\" _v-2068dbb6=\"\">{{item.branch_name}}</p>\n                        </div>\n                        <div style=\"display: flex; justify-content: space-between;\" _v-2068dbb6=\"\">\n                            <div class=\"item-center\" style=\"gap: 16px\" _v-2068dbb6=\"\">\n                                <span class=\"item-center\" _v-2068dbb6=\"\">\n                                    <i class=\"material-icons style-brand primary-business-color-font\" _v-2068dbb6=\"\">schedule</i>\n                                    <p class=\"txt-small grey--80\" _v-2068dbb6=\"\">{{item.start_time}} ~ {{item.end_time}}</p>\n                                </span>\n                                <span class=\"item-center\" v-if=\"item.staff_has_staff\" _v-2068dbb6=\"\">\n                                    <img class=\"staff_pic primary-business-color-border\" :src=\"item.staff_img_src\" _v-2068dbb6=\"\">\n                                    <p class=\"txt-small grey--80\" _v-2068dbb6=\"\">{{item.staff_name}}</p>\n                                </span>\n                            </div>\n                            <div class=\"item-center\" style=\"gap: 16px\" _v-2068dbb6=\"\">\n                                <span _v-2068dbb6=\"\">\n                                    <p class=\"regular align-center style-brand primary-business-color-font\" v-if=\"item.has_bookable_contract\" _v-2068dbb6=\"\">\n                                        <i class=\"material-icons style-brand primary-business-color-font\" _v-2068dbb6=\"\">task_alt</i> {{item.has_bookable_contract_text}}\n                                    </p>\n                                    <p class=\"regular grey--80 font-bold\" v-else-if=\"item.isOnlyBookByContract\" _v-2068dbb6=\"\">{{item.isOnlyBookByContractText}}</p>\n                                    <p class=\"regular grey--80 font-bold\" v-else=\"\" _v-2068dbb6=\"\">{{item.sale_currency}} {{item.sale_price}}</p>\n                                </span>\n                                <class-booking-btn :schedule=\"item\" _v-2068dbb6=\"\"></class-booking-btn>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                \n            </template>\n            <template slot=\"grid\" slot-scope=\"{item}\">\n                <div class=\"round-border grid\" _v-2068dbb6=\"\">\n                    <div class=\"img-box\" :style=\"'background-image: url('+ item.branch_img + '); background-size: cover;'\" _v-2068dbb6=\"\"></div>\n                    <div class=\"detail\" _v-2068dbb6=\"\">\n                        <div class=\"header m-bottom-15 item-center\" _v-2068dbb6=\"\">\n                            <img v-if=\"item.is_live\" src=\"/images/live-stream.png\" width=\"30px\" height=\"auto\" _v-2068dbb6=\"\">\n                            <font class=\"title-4 grey--100 overflow-hidden m-left-5\" _v-2068dbb6=\"\">{{item.class_name}}</font>\n                        </div>\n                        <div class=\"item-center m-bottom-10\" @click.prevent.stop=\"showMap(item)\" _v-2068dbb6=\"\">\n                            <a class=\"btn-primary--label m-right-5 map-btn primary-business-color-backgroun\" _v-2068dbb6=\"\"><i class=\"material-icons\" _v-2068dbb6=\"\">location_on</i>MAP</a>\n                            <p class=\"regular grey--80\" _v-2068dbb6=\"\">{{item.landmark}}</p>\n                        </div>\n                        <div class=\"m-bottom-10\" _v-2068dbb6=\"\">\n                            <p class=\"regular font-bold grey--80 overflow-hidden m-left-5\" _v-2068dbb6=\"\">{{item.branch_name}}</p>\n                        </div>\n                        <div class=\"item-center m-bottom-25\" style=\"gap: 16px\" _v-2068dbb6=\"\">\n                            <span class=\"item-center\" _v-2068dbb6=\"\">\n                                <i class=\"material-icons style-brand primary-business-color-font\" _v-2068dbb6=\"\">schedule</i>\n                                <p class=\"txt-small grey--80\" _v-2068dbb6=\"\">{{item.start_time}} ~ {{item.end_time}}</p>\n                            </span>\n                            <span class=\"item-center\" v-if=\"item.staff_has_staff\" _v-2068dbb6=\"\">\n                                <img class=\"staff_pic primary-business-color-border\" :src=\"item.staff_img_src\" _v-2068dbb6=\"\">\n                                <p class=\"txt-small grey--80\" _v-2068dbb6=\"\">{{item.staff_name}}</p>\n                            </span>\n                        </div>\n                        <div style=\"display: flex; justify-content: space-between; align-items: center;\" _v-2068dbb6=\"\">\n                            <span _v-2068dbb6=\"\">\n                                <p class=\"regular align-center style-brand primary-business-color-font\" v-if=\"item.has_bookable_contract\" _v-2068dbb6=\"\">\n                                    <i class=\"material-icons style-brand primary-business-color-font\" _v-2068dbb6=\"\">task_alt</i> {{item.has_bookable_contract_text}}\n                                </p>\n                                <p class=\"regular grey--80 font-bold\" v-else-if=\"item.isOnlyBookByContract\" _v-2068dbb6=\"\">{{item.isOnlyBookByContractText}}</p>\n                                <p class=\"regular grey--80 font-bold\" v-else=\"\" _v-2068dbb6=\"\">{{item.sale_currency}} {{item.sale_price}}</p>\n                            </span>\n                            <class-booking-btn :schedule=\"item\" _v-2068dbb6=\"\"></class-booking-btn>\n                        </div>\n                    </div>\n                </div>\n            </template>\n        </v-switch-layout>\n    </div>\n\n    <v-modal id=\"schedule-list-search-modal\" border-radius-level=\"20px\" no-footer=\"\" _v-2068dbb6=\"\">\n        <div slot=\"title\" _v-2068dbb6=\"\">\n            <font class=\"title-5 grey--100\" _v-2068dbb6=\"\">{{ i18n.t('general.filter_by') }}</font>\n        </div>\n        <div slot=\"body\" _v-2068dbb6=\"\">\n            <div class=\"search-section modal-search\" _v-2068dbb6=\"\">\n                <div class=\"m-bottom-15\" _v-2068dbb6=\"\">\n                    <input placeholder=\"請輸入關鍵字\" v-model=\"show.keyword\" name=\"keyword\" type=\"text\" class=\"keyword\" _v-2068dbb6=\"\">\n                    <i class=\"material-icons\" style=\"position: absolute; transform: translate(-30px, 10px);}\" _v-2068dbb6=\"\">search</i>\n                </div>\n                <div class=\"select m-bottom-15\" id=\"select-category\" _v-2068dbb6=\"\">\n                    <span class=\"fp-select\" _v-2068dbb6=\"\">\n                        <select id=\"service_category_id\" class=\"service_category_id grey--100\" name=\"service_category_id\" v-model=\"show.service_category_id\" _v-2068dbb6=\"\">\n                            <option v-for=\"(item, key) in category\" :value=\"key\" _v-2068dbb6=\"\">{{item}}</option>\n                        </select>\n                    </span>\n                </div> \n                <div class=\"start-end-time\" _v-2068dbb6=\"\">\n                    <div class=\"select\" _v-2068dbb6=\"\">\n                        <div id=\"time-range\" style=\"width: 100%; text-align: center;\" _v-2068dbb6=\"\">\n                            <span _v-2068dbb6=\"\">{{showStart}}</span> - <span _v-2068dbb6=\"\">{{showEnd}}</span>\n                            <div id=\"slider-range\" _v-2068dbb6=\"\">\n                                <div id=\"slider-small-vue\" class=\"slider\" _v-2068dbb6=\"\"></div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div style=\"margin-top: 40px;\" _v-2068dbb6=\"\">\n                    <a class=\"btn btn-primary--label m-top-10\" @click.prevent=\"showResult\" :disabled=\"ajaxing\" _v-2068dbb6=\"\">顯示結果</a>\n                    <a class=\"btn btn-default--label m-top-10\" @click.prevent=\"resetAll\" :disabled=\"ajaxing\" _v-2068dbb6=\"\">重置</a>                    \n                </div>\n            </div>\n        </div>\n    </v-modal>\n    <map-modal :modal-title=\"mapSelected.branch_name\" :coordinate=\"mapSelected.branch_coordinate\" _v-2068dbb6=\"\"></map-modal> \n</div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.schedule-list-section[_v-2068dbb6] {\n  margin-left: -12px;\n  margin-right: -12px; }\n  /* line 6, stdin */\n  .schedule-list-section .round-border.list[_v-2068dbb6] {\n    display: -ms-flexbox;\n    display: flex; }\n    /* line 8, stdin */\n    .schedule-list-section .round-border.list .branch-img[_v-2068dbb6] {\n      border-top-left-radius: 8px;\n      border-bottom-left-radius: 8px; }\n    /* line 12, stdin */\n    .schedule-list-section .round-border.list .detail[_v-2068dbb6] {\n      margin: auto 16px auto 24px; }\n  /* line 17, stdin */\n  .schedule-list-section .round-border.grid .img-box[_v-2068dbb6] {\n    background-color: #c3c3c3;\n    position: relative;\n    width: 100%;\n    padding-top: 58%;\n    border-top-left-radius: 8px;\n    border-top-right-radius: 8px; }\n  /* line 25, stdin */\n  .schedule-list-section .round-border.grid .detail[_v-2068dbb6] {\n    padding: 16px;\n    height: 245px; }\n  /* line 31, stdin */\n  .schedule-list-section img[_v-2068dbb6] {\n    background-color: #c3c3c3; }\n  /* line 34, stdin */\n  .schedule-list-section .detail[_v-2068dbb6] {\n    width: 100%; }\n  /* line 37, stdin */\n  .schedule-list-section .item-center[_v-2068dbb6] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center; }\n  /* line 41, stdin */\n  .schedule-list-section .overflow-hidden[_v-2068dbb6] {\n    overflow: hidden;\n    display: -webkit-inline-box;\n    -webkit-box-orient: vertical;\n    text-align: left;\n    width: 100%;\n    -webkit-line-clamp: 1; }\n  /* line 49, stdin */\n  .schedule-list-section .map-btn[_v-2068dbb6] {\n    background-color: #0099FF; }\n\n/* line 54, stdin */\n.search-section.web-search[_v-2068dbb6] {\n  display: -ms-flexbox;\n  display: flex;\n  gap: 8px;\n  -ms-flex-align: start;\n      align-items: flex-start; }\n\n/* line 59, stdin */\n.search-section.modal-search[_v-2068dbb6] {\n  max-width: 500px;\n  margin: 60px auto;\n  padding: 0 20px;\n  text-align: center; }\n\n/* line 65, stdin */\n.search-section .btn[_v-2068dbb6] {\n  padding: 8px 16px; }\n\n/* line 68, stdin */\n.search-section .w-auto[_v-2068dbb6] {\n  -ms-flex-positive: 1;\n      flex-grow: 1; }\n\n/* line 71, stdin */\n.search-section input[_v-2068dbb6] {\n  width: 100%;\n  border: 1px solid #EEEEEE;\n  border-radius: 8px;\n  margin-bottom: 0;\n  background-color: #ffffff;\n  padding: 12px 28px 12px 12px; }\n\n/* line 79, stdin */\n.search-section #select-category .fp-select[_v-2068dbb6] {\n  min-width: 130px;\n  width: 100%;\n  margin-bottom: 0;\n  border: 1px solid #EEEEEE;\n  border-radius: 8px; }\n  /* line 85, stdin */\n  .search-section #select-category .fp-select[_v-2068dbb6]::before {\n    line-height: 46px;\n    color: #000000;\n    z-index: 3; }\n  /* line 90, stdin */\n  .search-section #select-category .fp-select select[_v-2068dbb6] {\n    height: 46px;\n    border: none;\n    background-color: white; }\n\n/* line 96, stdin */\n.search-section .filter-result[_v-2068dbb6] {\n  padding: 9px; }\n  /* line 98, stdin */\n  .search-section .filter-result br[_v-2068dbb6] {\n    display: none; }\n\n/* line 102, stdin */\n.search-section .pad-show.btn.btn-default--label[_v-2068dbb6] {\n  background: #44444F; }\n\n/* line 106, stdin */\n.sticky-section[_v-2068dbb6] {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  background: white;\n  padding-top: 8px; }\n\n/* line 113, stdin */\n.web-show[_v-2068dbb6] {\n  display: block; }\n\n/* line 116, stdin */\n.pad-show[_v-2068dbb6] {\n  display: none; }\n\n@media screen and (max-width: 991px) {\n  /* line 120, stdin */\n  .search-section[_v-2068dbb6] {\n    -ms-flex-align: center;\n        align-items: center; }\n  /* line 123, stdin */\n  .web-show[_v-2068dbb6] {\n    display: none; }\n  /* line 126, stdin */\n  .pad-show[_v-2068dbb6] {\n    display: block; } }\n\n@media screen and (max-width: 768px) {\n  /* line 131, stdin */\n  .sticky-section[_v-2068dbb6] {\n    top: 54px; } }\n\n@media screen and (max-width: 576px) {\n  /* line 137, stdin */\n  .search-section .title-5[_v-2068dbb6] {\n    font-size: 16px; }\n  /* line 140, stdin */\n  .search-section.web-search[_v-2068dbb6] {\n    display: -ms-flexbox;\n    display: flex;\n    gap: 8px;\n    -ms-flex-align: center;\n        align-items: center; }\n  /* line 145, stdin */\n  .search-section .filter-result[_v-2068dbb6] {\n    padding: 0; }\n    /* line 147, stdin */\n    .search-section .filter-result br[_v-2068dbb6] {\n      display: block; } }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-2068dbb6", module.exports)
  } else {
    hotAPI.update("_v-2068dbb6", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/object/assign":50,"babel-runtime/helpers/extends":66,"lodash":717,"moment":727,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],995:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _studiosMapApp = require('./studios-map-app.vue');

var _studiosMapApp2 = _interopRequireDefault(_studiosMapApp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('v-studio-map', _studiosMapApp2.default);

},{"./studios-map-app.vue":996,"vue":792}],996:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.branch-list-section[_v-0fe37988] {\n  margin-left: -12px;\n  margin-right: -12px; }\n  /* line 6, stdin */\n  .branch-list-section .round-border.list[_v-0fe37988] {\n    display: -ms-flexbox;\n    display: flex; }\n    /* line 8, stdin */\n    .branch-list-section .round-border.list img[_v-0fe37988] {\n      border-top-left-radius: 8px;\n      border-bottom-left-radius: 8px; }\n    /* line 12, stdin */\n    .branch-list-section .round-border.list .header[_v-0fe37988] {\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-pack: justify;\n          justify-content: space-between; }\n    /* line 17, stdin */\n    .branch-list-section .round-border.list .detail[_v-0fe37988] {\n      margin: auto 16px auto 24px; }\n    /* line 20, stdin */\n    .branch-list-section .round-border.list .overflow-hidden[_v-0fe37988] {\n      -webkit-line-clamp: 2; }\n  /* line 25, stdin */\n  .branch-list-section .round-border.grid .img-box[_v-0fe37988] {\n    background-color: #c3c3c3;\n    position: relative;\n    width: 100%;\n    padding-top: 58%;\n    border-top-left-radius: 8px;\n    border-top-right-radius: 8px; }\n  /* line 33, stdin */\n  .branch-list-section .round-border.grid .header[_v-0fe37988] {\n    min-height: 63px; }\n  /* line 36, stdin */\n  .branch-list-section .round-border.grid .detail[_v-0fe37988] {\n    padding: 16px;\n    min-height: 230px; }\n  /* line 40, stdin */\n  .branch-list-section .round-border.grid .btn-group span[_v-0fe37988] {\n    width: 50%; }\n    /* line 42, stdin */\n    .branch-list-section .round-border.grid .btn-group span p[_v-0fe37988] {\n      white-space: nowrap;\n      text-overflow: ellipsis;\n      overflow: hidden; }\n  /* line 48, stdin */\n  .branch-list-section .round-border.grid .overflow-hidden[_v-0fe37988] {\n    -webkit-line-clamp: 3; }\n  /* line 53, stdin */\n  .branch-list-section img[_v-0fe37988] {\n    background-color: #c3c3c3; }\n  /* line 56, stdin */\n  .branch-list-section .detail[_v-0fe37988] {\n    width: 100%; }\n  /* line 59, stdin */\n  .branch-list-section .item-center[_v-0fe37988] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center; }\n  /* line 63, stdin */\n  .branch-list-section .overflow-hidden[_v-0fe37988] {\n    overflow: hidden;\n    display: -webkit-inline-box;\n    -webkit-box-orient: vertical;\n    text-align: left;\n    width: 100%; }\n  /* line 70, stdin */\n  .branch-list-section .map-btn[_v-0fe37988] {\n    background-color: #0099FF; }\n\n/* line 74, stdin */\n.search-section[_v-0fe37988] {\n  display: -ms-flexbox;\n  display: flex;\n  gap: 24px;\n  -ms-flex-align: center;\n      align-items: center; }\n  /* line 78, stdin */\n  .search-section .open_filter[_v-0fe37988] {\n    width: 100%;\n    height: 46px;\n    border-radius: 8px;\n    border: 1px solid #EEEEEE; }\n    /* line 83, stdin */\n    .search-section .open_filter a[_v-0fe37988] {\n      font-size: 16px;\n      color: #000000; }\n  /* line 88, stdin */\n  .search-section #select-classsort .fp-select[_v-0fe37988] {\n    min-width: 130px;\n    width: 100%;\n    margin-bottom: 0;\n    border: 1px solid #EEEEEE;\n    border-radius: 8px; }\n    /* line 94, stdin */\n    .search-section #select-classsort .fp-select[_v-0fe37988]::before {\n      line-height: 46px;\n      color: #000000;\n      z-index: 3; }\n    /* line 99, stdin */\n    .search-section #select-classsort .fp-select select[_v-0fe37988] {\n      height: 46px;\n      border: none;\n      background-color: white; }\n\n/* line 108, stdin */\n#studio-map-search-modal .fp-select[_v-0fe37988], #studio-map-search-modal .keyword[_v-0fe37988] {\n  width: 100%;\n  border: 1px solid #EEEEEE;\n  border-radius: 8px; }\n  /* line 112, stdin */\n  #studio-map-search-modal .fp-select select[_v-0fe37988], #studio-map-search-modal .keyword select[_v-0fe37988] {\n    padding-left: 15px; }\n\n/* line 116, stdin */\n#studio-map-search-modal .btn-group[_v-0fe37988] {\n  display: block;\n  text-align: center; }\n\n/* line 120, stdin */\n#studio-map-search-modal .btn[_v-0fe37988] {\n  padding: 8px 16px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['isWebstudio', 'isShowRating'],
    data: function data() {
        var _ref;

        return _ref = {
            apiConfig: {
                methods: 'get',
                apiurl: '/branch-list',
                dataName: 'data'
            },
            loading: false,
            ajaxingCategory: false,
            keyword: '',
            category: [],
            branches: [],
            selectCategory: ''
        }, (0, _defineProperty3.default)(_ref, 'keyword', ''), (0, _defineProperty3.default)(_ref, 'filterSelected', {
            keyword: '',
            category: ''
        }), (0, _defineProperty3.default)(_ref, 'mapSelected', {}), (0, _defineProperty3.default)(_ref, 'commentSelected', {}), _ref;
    },

    computed: {
        commentApiConfig: function commentApiConfig() {
            if (_lodash2.default.isEmpty(this.commentSelected)) return {};
            return {
                apiurl: '/api/branch/' + this.commentSelected.id + '/ratings',
                dataName: 'comments'
            };
        },
        filterResult: function filterResult() {
            var string = '';
            var isSelectBoth = this.filterSelected.keyword && this.filterSelected.category;
            if (this.filterSelected.keyword) {
                string += this.filterSelected.keyword;
            }
            if (isSelectBoth) {
                string += ', ';
            }
            if (this.filterSelected.category) {
                string += this.category[this.filterSelected.category];
            }
            return string;
        }
    },
    mounted: function mounted() {
        var params = $17.getUrlQueryStrings();
        if (this.isWebstudio == '1' && params.hasOwnProperty('category')) {
            delete params.category;
            this.syncUrlQuery(params);
        } else {
            this.getServiceCategory();
        }

        this.fetchData();
    },

    methods: {
        getServiceCategory: function getServiceCategory() {
            var _this = this;

            if (!_lodash2.default.isEmpty(this.category)) return;
            this.ajaxingCategory = true;
            this.$http.get('/service-category').then(function (response) {
                _this.category = response.data.category;
                _this.ajaxingCategory = false;
            }, function (error) {
                _this.ajaxingCategory = false;
            });
        },
        fetchData: function fetchData() {
            this.loading = true;
            var params = $17.getUrlQueryStrings();
            this.apiConfig.payload = params;
            this.$refs.branch_list_view.fetchData();
        },
        fetchSuccess: function fetchSuccess(data) {
            this.loading = false;
            this.branches = data;
        },
        fetchFail: function fetchFail(data) {
            this.loading = false;
            $17.swal({
                type: 'error',
                title: "讀取資料發生錯誤，請重新嘗試",
                showCancelButton: false
            });
        },
        openFilterModal: function openFilterModal() {
            $('#studio-map-search-modal').modal('show');
        },
        syncUrlQuery: function syncUrlQuery(params) {
            var newQueryString = $17.queryStringBuilder(params);
            history.replaceState({}, null, '?' + newQueryString);
        },
        showResult: function showResult() {
            var _this2 = this;

            this.filterSelected = {
                keyword: this.keyword,
                category: this.selectCategory
            };
            this.syncUrlQuery(this.filterSelected);
            this.$nextTick(function () {
                _this2.fetchData();
                $('#studio-map-search-modal').modal('hide');
            });
        },
        reset: function reset() {
            this.keyword = '';
            this.selectCategory = '';
            this.showResult();
        },
        showMap: function showMap(branch) {
            this.mapSelected = branch;
            $('#map-modal').modal('show');
        },
        showComment: function showComment(branch) {
            this.commentSelected = branch;
            $('#v-comment-modal').modal('show');
        },
        redirectToBranch: function redirectToBranch(branch) {
            if (this.isWebstudio == '1') {
                return window.location.href = '/' + branch.url;
            } else {
                return window.location.href = '/' + branch.studio_url + '/' + branch.url;
            }
        },
        thousandthFormat: function thousandthFormat(number) {
            return $17.thousandthFormat(number);
        },
        showRating: function showRating(branch) {
            return branch.score_count > 0 && this.isShowRating == '1';
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"m-top-25\" _v-0fe37988=\"\">\n    <div class=\"search-section\" v-show=\"!loading\" _v-0fe37988=\"\">\n        <div class=\"open_filter\" _v-0fe37988=\"\">\n            <a @click=\"openFilterModal\" _v-0fe37988=\"\">\n                <span v-if=\"filterResult\" _v-0fe37988=\"\">{{filterResult}}</span>\n                <span v-else=\"\" _v-0fe37988=\"\">{{ i18n.t('filter.no_pick_up') }}</span>\n            </a>\n        </div>\n        <div class=\"select\" id=\"select-classsort\" _v-0fe37988=\"\">\n            <span class=\"fp-select\" _v-0fe37988=\"\">\n                <select id=\"service_category_id\" class=\"service_category_id\" name=\"service_category_id\" _v-0fe37988=\"\">\n                    <option value=\"\" selected=\"selected\" _v-0fe37988=\"\">{{ i18n.t('filter.sort_recommend') }}</option>\n                </select>\n            </span>\n        </div>\n        <v-switch-layout-btn :target-view=\"$refs.branch_list_view\" _v-0fe37988=\"\">\n        </v-switch-layout-btn>\n    </div>\n\n    <div class=\"branch-list-section\" _v-0fe37988=\"\">\n        <v-switch-layout ref=\"branch_list_view\" :api-config=\"apiConfig\" list-style-class=\"col-xs-12 p-left-0 p-right-0\" grid-style-class=\"col-md-4 col-sm-6 col-xs-12 p-left-0 p-right-0\" @fetch-success-callback=\"fetchSuccess\" @fetch-fail-callback=\"fetchFail\" _v-0fe37988=\"\">\n            <template slot=\"list\" slot-scope=\"{item}\">\n                <div class=\"round-border list\" @click=\"redirectToBranch(item)\" _v-0fe37988=\"\">\n                    <div _v-0fe37988=\"\"><img :src=\"item.header_img\" height=\"170px\" width=\"283px\" _v-0fe37988=\"\"></div>\n                    <div class=\"detail\" _v-0fe37988=\"\">\n                        <div class=\"header\" _v-0fe37988=\"\">\n                            <font class=\"title-4 grey--100\" _v-0fe37988=\"\">{{item.branch_name}}</font>\n                            <span class=\"item-center\" @click.prevent.stop=\"showComment(item)\" v-if=\"showRating(item)\" _v-0fe37988=\"\">\n                                <a class=\"btn-brand--label m-right-10 primary-business-color-background\" _v-0fe37988=\"\">{{item.score_avg}}</a>\n                                <p class=\"regular grey--80 overflow\" _v-0fe37988=\"\">{{thousandthFormat(item.score_count)}} {{ i18n.t('rating.comments') }}</p>\n                            </span>\n                        </div>\n                        <div class=\"m-top-10 m-bottom-10 item-center\" _v-0fe37988=\"\">\n                            <a class=\"btn-primary--label m-right-5 map-btn primary-business-color-background\" @click.prevent.stop=\"showMap(item)\" _v-0fe37988=\"\"><i class=\"material-icons\" _v-0fe37988=\"\">location_on</i>MAP</a>\n                            <p class=\"regular grey--80\" _v-0fe37988=\"\">{{item.landmark}}</p>\n                        </div>\n                        <p class=\"regular word-break grey--90 overflow-hidden\" _v-0fe37988=\"\">{{item.introduction}}</p>\n                    </div>\n                </div>\n                \n            </template>\n            <template slot=\"grid\" slot-scope=\"{item}\">\n                <div class=\"round-border grid\" @click=\"redirectToBranch(item)\" _v-0fe37988=\"\">\n                    <div class=\"img-box\" :style=\"'background-image: url('+ item.header_img + '); background-size: cover;'\" _v-0fe37988=\"\"></div>\n                    <div class=\"detail\" _v-0fe37988=\"\">\n                        <div class=\"header\" _v-0fe37988=\"\">\n                            <font class=\"title-4 grey--100\" _v-0fe37988=\"\">{{item.branch_name}}</font>\n                        </div>\n                        <div class=\"m-top-10 m-bottom-10 item-center btn-group\" _v-0fe37988=\"\">\n                            <span class=\"item-center\" @click.prevent.stop=\"showMap(item)\" _v-0fe37988=\"\">\n                                <a class=\"btn-primary--label m-right-5 map-btn primary-business-color-backgroun\" _v-0fe37988=\"\"><i class=\"material-icons\" _v-0fe37988=\"\">location_on</i>MAP</a>\n                                <p class=\"regular grey--80\" _v-0fe37988=\"\">{{item.landmark}}</p>\n                            </span>\n                            <span class=\"item-center\" @click.prevent.stop=\"showComment(item)\" v-if=\"showRating(item)\" _v-0fe37988=\"\">\n                                <a class=\"btn-brand--label m-right-5 primary-business-color-background\" _v-0fe37988=\"\">{{item.score_avg}}</a>\n                                <p class=\"regular grey--80 overflow\" _v-0fe37988=\"\">{{thousandthFormat(item.score_count)}} {{ i18n.t('rating.comments') }}</p>\n                            </span>\n                        </div>\n                        <p class=\"regular word-break grey--90 overflow-hidden\" _v-0fe37988=\"\">{{item.introduction}}</p>\n                    </div>\n                </div>\n            </template>\n        </v-switch-layout>\n    </div>\n\n    <v-modal id=\"studio-map-search-modal\" border-radius-level=\"20px\" no-footer=\"\" _v-0fe37988=\"\">\n        <div slot=\"title\" _v-0fe37988=\"\">\n            <font class=\"title-5 grey--100\" _v-0fe37988=\"\">{{ i18n.t('general.filter_by') }}</font>\n        </div>\n        <div slot=\"body\" _v-0fe37988=\"\">\n            <div _v-0fe37988=\"\">\n                <div class=\"row\" style=\"margin: 40px auto; max-width: 480px\" _v-0fe37988=\"\">\n                    <input placeholder=\"關鍵字\" v-model=\"keyword\" name=\"keyword\" type=\"text\" class=\"col-xs-12 keyword\" _v-0fe37988=\"\">\n                    <div class=\"select\" v-if=\"isWebstudio != '1'\" _v-0fe37988=\"\">\n                        <span class=\"fp-select\" _v-0fe37988=\"\">\n                            <select v-model=\"selectCategory\" _v-0fe37988=\"\">\n                                <option v-for=\"(item, key) in category\" :value=\"key\" _v-0fe37988=\"\">{{item}}</option>\n                            </select>\n                        </span>\n                    </div>\n                    <div style=\"display: block; text-align: center;\" _v-0fe37988=\"\">\n                        <a class=\"btn btn-primary--label m-right-25\" @click.prevent=\"showResult\" _v-0fe37988=\"\">{{ i18n.t('general.show_result') }}</a>\n                        <a class=\"btn btn-default--label\" @click=\"reset\" _v-0fe37988=\"\">{{ i18n.t('general.reset') }}</a>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </v-modal>\n    <map-modal :modal-title=\"mapSelected.branch_name\" :coordinate=\"mapSelected.coordinate\" _v-0fe37988=\"\"></map-modal>\n    <v-comment-modal :api-config=\"commentApiConfig\" :branch=\"commentSelected\" _v-0fe37988=\"\"></v-comment-modal>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.branch-list-section[_v-0fe37988] {\n  margin-left: -12px;\n  margin-right: -12px; }\n  /* line 6, stdin */\n  .branch-list-section .round-border.list[_v-0fe37988] {\n    display: -ms-flexbox;\n    display: flex; }\n    /* line 8, stdin */\n    .branch-list-section .round-border.list img[_v-0fe37988] {\n      border-top-left-radius: 8px;\n      border-bottom-left-radius: 8px; }\n    /* line 12, stdin */\n    .branch-list-section .round-border.list .header[_v-0fe37988] {\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-pack: justify;\n          justify-content: space-between; }\n    /* line 17, stdin */\n    .branch-list-section .round-border.list .detail[_v-0fe37988] {\n      margin: auto 16px auto 24px; }\n    /* line 20, stdin */\n    .branch-list-section .round-border.list .overflow-hidden[_v-0fe37988] {\n      -webkit-line-clamp: 2; }\n  /* line 25, stdin */\n  .branch-list-section .round-border.grid .img-box[_v-0fe37988] {\n    background-color: #c3c3c3;\n    position: relative;\n    width: 100%;\n    padding-top: 58%;\n    border-top-left-radius: 8px;\n    border-top-right-radius: 8px; }\n  /* line 33, stdin */\n  .branch-list-section .round-border.grid .header[_v-0fe37988] {\n    min-height: 63px; }\n  /* line 36, stdin */\n  .branch-list-section .round-border.grid .detail[_v-0fe37988] {\n    padding: 16px;\n    min-height: 230px; }\n  /* line 40, stdin */\n  .branch-list-section .round-border.grid .btn-group span[_v-0fe37988] {\n    width: 50%; }\n    /* line 42, stdin */\n    .branch-list-section .round-border.grid .btn-group span p[_v-0fe37988] {\n      white-space: nowrap;\n      text-overflow: ellipsis;\n      overflow: hidden; }\n  /* line 48, stdin */\n  .branch-list-section .round-border.grid .overflow-hidden[_v-0fe37988] {\n    -webkit-line-clamp: 3; }\n  /* line 53, stdin */\n  .branch-list-section img[_v-0fe37988] {\n    background-color: #c3c3c3; }\n  /* line 56, stdin */\n  .branch-list-section .detail[_v-0fe37988] {\n    width: 100%; }\n  /* line 59, stdin */\n  .branch-list-section .item-center[_v-0fe37988] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center; }\n  /* line 63, stdin */\n  .branch-list-section .overflow-hidden[_v-0fe37988] {\n    overflow: hidden;\n    display: -webkit-inline-box;\n    -webkit-box-orient: vertical;\n    text-align: left;\n    width: 100%; }\n  /* line 70, stdin */\n  .branch-list-section .map-btn[_v-0fe37988] {\n    background-color: #0099FF; }\n\n/* line 74, stdin */\n.search-section[_v-0fe37988] {\n  display: -ms-flexbox;\n  display: flex;\n  gap: 24px;\n  -ms-flex-align: center;\n      align-items: center; }\n  /* line 78, stdin */\n  .search-section .open_filter[_v-0fe37988] {\n    width: 100%;\n    height: 46px;\n    border-radius: 8px;\n    border: 1px solid #EEEEEE; }\n    /* line 83, stdin */\n    .search-section .open_filter a[_v-0fe37988] {\n      font-size: 16px;\n      color: #000000; }\n  /* line 88, stdin */\n  .search-section #select-classsort .fp-select[_v-0fe37988] {\n    min-width: 130px;\n    width: 100%;\n    margin-bottom: 0;\n    border: 1px solid #EEEEEE;\n    border-radius: 8px; }\n    /* line 94, stdin */\n    .search-section #select-classsort .fp-select[_v-0fe37988]::before {\n      line-height: 46px;\n      color: #000000;\n      z-index: 3; }\n    /* line 99, stdin */\n    .search-section #select-classsort .fp-select select[_v-0fe37988] {\n      height: 46px;\n      border: none;\n      background-color: white; }\n\n/* line 108, stdin */\n#studio-map-search-modal .fp-select[_v-0fe37988], #studio-map-search-modal .keyword[_v-0fe37988] {\n  width: 100%;\n  border: 1px solid #EEEEEE;\n  border-radius: 8px; }\n  /* line 112, stdin */\n  #studio-map-search-modal .fp-select select[_v-0fe37988], #studio-map-search-modal .keyword select[_v-0fe37988] {\n    padding-left: 15px; }\n\n/* line 116, stdin */\n#studio-map-search-modal .btn-group[_v-0fe37988] {\n  display: block;\n  text-align: center; }\n\n/* line 120, stdin */\n#studio-map-search-modal .btn[_v-0fe37988] {\n  padding: 8px 16px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-0fe37988", module.exports)
  } else {
    hotAPI.update("_v-0fe37988", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/defineProperty":65,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],997:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _modal = require('./modal.vue');

var _modal2 = _interopRequireDefault(_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('voucher-modal', _modal2.default);

},{"./modal.vue":998,"vue":792}],998:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.membercard-notes .notes-inner[_v-e9693132] {\n  background: rgba(255, 255, 255, 0.8); }\n\n/* line 2, stdin */\n#voucher-modal .modal-body {\n  background: #38b0e4; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vuex = require('vuex');

exports.default = {
    mounted: function mounted() {},

    data: function data() {
        return {
            ajaxing: false,
            member_name: '',
            branch_name: '',
            date: '',
            time: '',
            schedule_name: '',
            summary: '',
            notice: '',
            booking_code: ''
        };
    },
    props: ["id", "closeModalEvent"],
    computed: {},
    methods: {
        submit: function submit() {
            $(this.$el).modal("hide");
        }
    },
    watch: {
        id: function id(val) {
            var _this = this;

            if (val == null) {
                return;
            }
            this.ajaxing = true;
            this.$http.get("/webapi/myclass-voucher/" + val).then(function (response) {
                _this.ajaxing = false;
                _this.member_name = response.data.member_name;
                _this.branch_name = response.data.branch_name;
                _this.date = response.data.date;
                _this.time = response.data.time;
                _this.schedule_name = response.data.schedule_name;
                _this.summary = response.data.summary;
                _this.notice = response.data.notice;
                _this.booking_code = response.data.booking_code;
                $(_this.$el).modal('show');
            }, function (error) {
                _this.ajaxing = false;
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal id=\"voucher-modal\" :save-clicked=\"submit\" :remove-btn-show=\"false\" :close-modal-event=\"closeModalEvent\" no-header=\"\" no-footer=\"\" confirm-btn-text=\"關閉\" _v-e9693132=\"\">\n    <span slot=\"title\" _v-e9693132=\"\">上課憑證</span>\n    <template slot=\"body\">\n        <v-spinner :ajaxing=\"ajaxing\" color=\"#fff\" _v-e9693132=\"\"></v-spinner>\n        <div class=\"membercard\" v-show=\"!ajaxing\" _v-e9693132=\"\">\n            <div class=\"row\" _v-e9693132=\"\">\n                <div class=\"membercard-inner col-md-8 col-sm-10 col-md-push-2 col-sm-push-1\" _v-e9693132=\"\">\n                    <div class=\"membercard-container\" _v-e9693132=\"\">\n                        <v-qrcode class=\"qr-booking\" id=\"qrcode-single\" :options=\"{ width: 200 }\" :value=\"booking_code\" type=\"canvas\" _v-e9693132=\"\"></v-qrcode>\n\n                        <h2 class=\"membership-nr\" _v-e9693132=\"\">{{member_name}}</h2>\n                        <hr _v-e9693132=\"\">\n                        <div class=\"membership-description\" _v-e9693132=\"\">\n                            <p _v-e9693132=\"\">\n                                <span class=\"h3\" _v-e9693132=\"\">{{branch_name}}</span>\n                            </p>\n                        </div>\n                        <div class=\"membership-datetime\" _v-e9693132=\"\">\n                            <p _v-e9693132=\"\">\n                                <span class=\"date\" _v-e9693132=\"\">\n                                    <i class=\"fa fa-calendar\" _v-e9693132=\"\"></i>\n                                    <b class=\"srt\" _v-e9693132=\"\">日期:</b>\n                                     {{date}}\n                                </span>\n                                <span class=\"time\" _v-e9693132=\"\">\n                                    <i class=\"fa fa-clock-o\" style=\"color: inherit;\" _v-e9693132=\"\"></i>\n                                    <b class=\"srt\" _v-e9693132=\"\">時間:</b>\n                                     {{time}}\n                                </span>\n                            </p>\n                        </div>\n                        <div class=\"membership-description\" _v-e9693132=\"\">\n                            <p _v-e9693132=\"\">\n                                <span class=\"h3\" _v-e9693132=\"\">{{ schedule_name }}</span>\n                            </p>\n                        </div>\n\n                        <div class=\"membercard-notes row\" _v-e9693132=\"\">\n                            <div class=\"col-sm-12\" _v-e9693132=\"\">\n                                <div class=\"notes-inner\" _v-e9693132=\"\">\n                                    <p _v-e9693132=\"\"> 場館注意事項:  {{summary}}\n                                    </p>\n                                    <p _v-e9693132=\"\"> 課程注意事項:  {{notice}}\n                                    </p>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </template>\n</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.membercard-notes .notes-inner[_v-e9693132] {\n  background: rgba(255, 255, 255, 0.8); }\n\n/* line 2, stdin */\n#voucher-modal .modal-body {\n  background: #38b0e4; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-e9693132", module.exports)
  } else {
    hotAPI.update("_v-e9693132", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],999:[function(require,module,exports){
'use strict';

require('./webadmin');
require('./front');

},{"./front":933,"./webadmin":1193}],1000:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.sortable > tbody > tr[_v-53d33309] {\n  cursor: pointer; }\n\n/* line 5, stdin */\np[_v-53d33309] {\n  font-size: 13px;\n  line-height: 25px;\n  margin: 0px; }\n\n/* line 11, stdin */\np.content[_v-53d33309] {\n  color: #000000; }\n\n/* line 15, stdin */\n.media-left > img[_v-53d33309] {\n  max-width: 114px; }\n\n/* line 19, stdin */\n.checkbox label[_v-53d33309]:after {\n  content: '';\n  display: table;\n  clear: both; }\n\n/* line 25, stdin */\n.checkbox .cr[_v-53d33309] {\n  position: relative;\n  display: inline-block;\n  border: 1px solid #a9a9a9;\n  border-radius: .25em;\n  width: 1.3em;\n  height: 1.3em;\n  float: left;\n  margin-right: .5em; }\n\n/* line 36, stdin */\n.checkbox .cr .cr-icon[_v-53d33309] {\n  position: absolute;\n  font-size: .8em;\n  line-height: 0;\n  top: 50%;\n  left: 15%; }\n\n/* line 44, stdin */\n.checkbox label input[type=\"checkbox\"][_v-53d33309] {\n  display: none; }\n\n/* line 48, stdin */\n.checkbox label input[type=\"checkbox\"] + .cr > .cr-icon[_v-53d33309] {\n  opacity: 0; }\n\n/* line 52, stdin */\n.checkbox label input[type=\"checkbox\"]:checked + .cr > .cr-icon[_v-53d33309] {\n  opacity: 1; }\n\n/* line 56, stdin */\n.checkbox label input[type=\"checkbox\"]:disabled + .cr[_v-53d33309] {\n  opacity: .5; }\n\n/* line 59, stdin */\n.fa-barcode[_v-53d33309] {\n  margin-left: -1.5em;\n  vertical-align: middle; }\n\n/* line 64, stdin */\n.barcode-input[_v-53d33309] {\n  height: 28px; }\n\n/* line 68, stdin */\n.barcode[_v-53d33309] {\n  margin-top: 20px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

var _socket = require('socket.io-client');

var _socket2 = _interopRequireDefault(_socket);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            memberId: null,
            isConnec: false,
            socket: null,
            openVideoNotice: "",
            gateShow: true,
            flowQueryOption: [{
                'value': '7',
                'option': '顯示最近 7 天 '
            }, {
                'value': '0',
                'option': '顯示全部'
            }]
        };
    },
    mounted: function mounted() {
        var _this = this;

        this.fetchRecords();
        $('#crm').on('hidden.bs.modal', this.fetchRecords);
        setInterval(function () {
            _this.$store.commit('webadmin/admission/REFRESH_ELAPSED_TIME');
        }, 1000);

        window.Event.$on('socketConnect', function (branchId) {
            _this.socket = _socket2.default.connect(store.state.webadmin.configure.socketHost, { query: "branchId=" + branchId });
        });

        this.getNoticeCookie();
    },


    watch: {
        branchId: function branchId(val, oldVal) {
            this.checkBranchIdBeing(val, oldVal);
        },
        selectFlowQueryDate: function selectFlowQueryDate(val, oldVal) {
            this.fetchRecords();
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        unLeavedRecords: function unLeavedRecords(state) {
            return state.webadmin.admission.branchUnleavedRecords;
        },
        dailyRecords: function dailyRecords(state) {
            return state.webadmin.admission.branchDailyRecords;
        },
        studioId: function studioId(state) {
            return state.webadmin.configure.studioId;
        },
        branchId: function branchId(state) {
            return state.webadmin.configure.branchId;
        },
        selectTicketId: function selectTicketId(state) {
            return state.webadmin.admission.selectTicketId;
        },
        selectTicket: function selectTicket(state) {
            return state.webadmin.admission.selectTicket;
        },
        unLeaved: function unLeaved(state) {
            return state.webadmin.admission.unLeavedRecord;
        },
        flowQueryDate: function flowQueryDate(state) {
            return state.webadmin.admission.flowQueryDate;
        }
    }), {
        dailyRecordsAmount: function dailyRecordsAmount() {
            return this.dailyRecords.length;
        },
        unLeavedRecordsAmount: function unLeavedRecordsAmount() {
            return this.unLeavedRecords.length;
        },

        ticketId: {
            set: function set(newVal) {
                this.$store.commit('webadmin/admission/SET_SELECT_TICKET_ID', newVal);
            },
            get: function get() {
                return this.selectTicketId;
            }
        },
        selectFlowQueryDate: {
            set: function set(newVal) {
                this.$store.commit('webadmin/admission/SET_FLOW_QUERY_DATE', newVal);
            },
            get: function get() {
                return this.flowQueryDate;
            }
        }
    }),
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('webadmin/admission', ['getCurrentType']), {
        checkAvalibleTicketStatus: function checkAvalibleTicketStatus() {
            return this.selectTicket.status == 0 && new Date(this.selectTicket.end_time) > new Date();
        },
        checkBranchIdBeing: function checkBranchIdBeing(val, oldVal) {
            if (val !== oldVal && !this.isConnec) {
                this.isConnect = true;
                window.Event.$emit('socketConnect', val);
                this.socketToServerOn();
            }
        },
        socketToServerOn: function socketToServerOn() {
            this.socket.on('admission_notice', function (data) {
                window.Event.$emit('Device.Admission.Clearance', data);
            });
        },
        openUnleavedRecord: function openUnleavedRecord(record) {
            var _this2 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!(record.type === 'contract')) {
                                    _context.next = 3;
                                    break;
                                }

                                _context.next = 3;
                                return _this2.selectMemberHandler(record.member.id);

                            case 3:
                                if (!(record.type === 'ticket')) {
                                    _context.next = 7;
                                    break;
                                }

                                _this2.ticketId = record.ticket.id;
                                _context.next = 7;
                                return _this2.showAdmissionModal();

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        selectMemberHandler: function selectMemberHandler(m) {
            var _this3 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (m) {
                                    _context2.next = 2;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 2:
                                _this3.memberId = m;
                                _context2.next = 5;
                                return _this3.showOperationModal();

                            case 5:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        },
        showOperationModal: function showOperationModal() {
            var _this4 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _this4.$store.dispatch('webadmin/crm/getMember', { memberId: _this4.memberId });
                                window.Event.$emit('changeCurrentView');
                                window.Event.$emit('resetData');
                                window.Event.$emit('fetchMemberTagList', _this4.memberId);
                                window.Event.$emit('fetchUpcoming', _this4.memberId);
                                window.Event.$emit('fetchMemberContract', _this4.memberId);
                                window.Event.$emit('fetchMemberStatus', _this4.memberId);
                                $('#crm').modal('show');

                            case 8:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this4);
            }))();
        },
        fetchRecords: function fetchRecords() {
            this.$store.dispatch('webadmin/admission/getUnLeavedRecords');
            this.$store.dispatch('webadmin/admission/getDailyRecords');
        },
        showAdmissionModal: function showAdmissionModal() {
            var _this5 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
                var status;
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _this5.$store.commit('webadmin/admission/RESET_TICKET_ADMISSION');
                                $.blockUI();
                                _context4.next = 4;
                                return _this5.$store.dispatch('webadmin/admission/getTicket', {
                                    'ticketId': _this5.selectTicketId,
                                    branchId: _this5.branchId
                                });

                            case 4:
                                status = _context4.sent;

                                if (status) {
                                    _context4.next = 8;
                                    break;
                                }

                                $.unblockUI();
                                return _context4.abrupt('return');

                            case 8:
                                _context4.next = 10;
                                return _this5.$store.dispatch('webadmin/admission/getTicketUnLeavedRecord', _this5.selectTicketId);

                            case 10:
                                if (!(!_this5.checkAvalibleTicketStatus() && !_this5.unLeaved.id)) {
                                    _context4.next = 15;
                                    break;
                                }

                                if (_this5.selectTicket.status != 0) {
                                    $17.swal({
                                        type: 'error',
                                        title: '此票券已使用',
                                        showCancelButton: false
                                    });
                                }

                                if (new Date(_this5.selectTicket.end_time) < new Date()) {
                                    $17.swal({
                                        type: 'error',
                                        title: '此票券已過期',
                                        html: '票券號碼:' + _this5.selectTicket.id + '<br>購買時間:' + _this5.selectTicket.created_at + '<br>使用期限時間:' + _this5.selectTicket.end_time,
                                        showCancelButton: false
                                    });
                                }
                                $.unblockUI();
                                return _context4.abrupt('return');

                            case 15:

                                $.unblockUI();

                                if (!_this5.unLeaved.id) {
                                    _context4.next = 19;
                                    break;
                                }

                                $('#ticket-out-admission-modal').modal('show');
                                return _context4.abrupt('return');

                            case 19:

                                $('#ticket-enter-admission-modal').modal('show');

                            case 20:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this5);
            }))();
        },
        setNoticeCookie: function setNoticeCookie() {
            document.cookie = 'openVideoNotice=' + this.openVideoNotice;
        },
        getNoticeCookie: function getNoticeCookie() {
            var val = document.cookie.replace(/(?:(?:^|.*;\s*)openVideoNotice\s*\=\s*([^;]*).*$)|^.*$/, "$1");
            if (val) {
                this.openVideoNotice = val === 'true' ? true : false;
            }
        },
        changeGateShow: function changeGateShow() {
            this.gateShow = !this.gateShow;
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div id=\"dashboard-content\" _v-53d33309=\"\">\n    <v-dashboard-tabs tab=\"admission\" _v-53d33309=\"\"></v-dashboard-tabs>\n    <div class=\"row\" _v-53d33309=\"\">\n        <div class=\"col-xs-12  col-md-12\" _v-53d33309=\"\">\n            <div class=\"st-flex st-flex-wrap st-items-center st-gap-7\" _v-53d33309=\"\">\n                <div class=\"st-max-w-sm st-w-full\" _v-53d33309=\"\">\n                    <v-member-selector :studio-id=\"studioId\" :keep=\"true\" :member-change=\"selectMemberHandler\" :clear-when-select=\"true\" _v-53d33309=\"\">\n                    </v-member-selector>\n                </div>\n                <span _v-53d33309=\"\">\n                    <input type=\"text\" class=\"barcode-input\" v-model=\"ticketId\" @input.lazy=\"showAdmissionModal\" _v-53d33309=\"\">\n                    <i class=\"fa fa-barcode fa-2x\" aria-hidden=\"true\" v-show=\"ticketId.length==0\" _v-53d33309=\"\"></i>\n                </span>\n                <span class=\"checkbox\" _v-53d33309=\"\">\n                    <label style=\"padding-left: 0px;\" _v-53d33309=\"\">\n                        <input type=\"checkbox\" value=\"1\" v-model=\"openVideoNotice\" @change=\"setNoticeCookie\" _v-53d33309=\"\">\n                        <span class=\"cr\" _v-53d33309=\"\"><i class=\"cr-icon glyphicon glyphicon-ok\" _v-53d33309=\"\"></i></span>\n                        開啟入/出場通知音效\n                    </label>\n                </span>\n            </div>\n        </div>\n    </div>\n    <div class=\"row\" _v-53d33309=\"\">\n        <div class=\"col-md-12\" _v-53d33309=\"\">\n            <div class=\"st-flex st-flex-wrap st-items-center\" _v-53d33309=\"\">\n                <div class=\"st-text-28 st-flex-1\" _v-53d33309=\"\">\n                    出入場通知\n                </div>\n                <div class=\"st-text-right st-mr-10\" @click=\"changeGateShow\" _v-53d33309=\"\">\n                    <a _v-53d33309=\"\">\n                    <span class=\"material-icons\" v-show=\"gateShow\" _v-53d33309=\"\">\n                        expand_less\n                    </span>\n                    <span class=\"material-icons\" v-show=\"!gateShow\" _v-53d33309=\"\">\n                        expand_more\n                    </span>\n                    </a>\n                </div>\n            </div>\n            <div class=\"\" v-show=\"gateShow\" _v-53d33309=\"\">\n               <notice-admission @fetch-record=\"fetchRecords\" :open-video-notice=\"openVideoNotice\" _v-53d33309=\"\"></notice-admission>\n            </div>\n        </div>\n    </div>\n    <hr _v-53d33309=\"\">\n    <div class=\"row\" _v-53d33309=\"\">\n        <div class=\"col-xs-12  col-md-4\" _v-53d33309=\"\">\n            <h3 _v-53d33309=\"\">待出場人數：{{ unLeavedRecordsAmount }}</h3>\n        </div>\n        <div class=\"col-xs-12 col-md-offset-6 col-md-2\" _v-53d33309=\"\">\n            <v-mutiselect :model.sync=\"selectFlowQueryDate\" :options=\"flowQueryOption\" :multiple=\"false\" :close-on-select=\"true\" :clear-on-select=\"true\" :searchable=\"true\" label=\"option\" track-by=\"value\" tag-name=\"option\" class=\"m-right-15\" _v-53d33309=\"\"></v-mutiselect>\n        </div>\n    </div>\n    <v-table :ajaxing=\"false\" :length=\"unLeavedRecordsAmount\" _v-53d33309=\"\">\n        <table class=\"table sortable\" _v-53d33309=\"\">\n            <thead _v-53d33309=\"\">\n            <tr _v-53d33309=\"\">\n                <th _v-53d33309=\"\">姓名</th>\n                <th _v-53d33309=\"\">手機</th>\n                <th _v-53d33309=\"\">使用方案</th>\n                <th _v-53d33309=\"\">剩餘</th>\n                <th _v-53d33309=\"\">入場時間</th>\n                <th _v-53d33309=\"\">經過時間</th>\n            </tr>\n            </thead>\n            <tbody _v-53d33309=\"\">\n            <tr v-for=\"r in unLeavedRecords\" :key=\"r.id\" @click=\"openUnleavedRecord(r)\" _v-53d33309=\"\">\n                <td class=\"col-md-1\" _v-53d33309=\"\"> {{ r.member.name }}</td>\n                <td class=\"col-md-2\" _v-53d33309=\"\"> {{ r.member.phone }}</td>\n                <td class=\"col-md-3\" _v-53d33309=\"\"> {{ r.contract_name }}</td>\n                <td class=\"col-md-2\" v-if=\"r.unused != null\" _v-53d33309=\"\"> {{ r.unused }} {{r.contract_type}}</td>\n                <td class=\"col-md-2\" v-if=\"r.unused == null\" _v-53d33309=\"\"></td>\n                <td class=\"col-md-2\" _v-53d33309=\"\"> {{ r.entered_at }}</td>\n                <td class=\"col-md-2\" _v-53d33309=\"\"> {{ r.elapsed_time }} 分鐘</td>\n            </tr>\n            </tbody>\n        </table>\n    </v-table>\n    <h3 _v-53d33309=\"\">今日入場人次：{{ dailyRecordsAmount }}</h3>\n    <v-table :ajaxing=\"false\" :length=\"dailyRecordsAmount\" _v-53d33309=\"\">\n        <table class=\"table\" _v-53d33309=\"\">\n            <thead _v-53d33309=\"\">\n            <tr _v-53d33309=\"\">\n                <th _v-53d33309=\"\">姓名</th>\n                <th _v-53d33309=\"\">手機</th>\n                <th _v-53d33309=\"\">使用方案</th>\n                <th _v-53d33309=\"\">入場時間</th>\n                <th _v-53d33309=\"\">出場時間</th>\n                <th _v-53d33309=\"\"></th>\n            </tr>\n            </thead>\n            <tbody _v-53d33309=\"\">\n            <tr v-for=\"r in dailyRecords\" :key=\"r.id\" _v-53d33309=\"\">\n                <td class=\"col-md-1\" _v-53d33309=\"\"> {{ r.member.name }}</td>\n                <td class=\"col-md-2\" _v-53d33309=\"\"> {{ r.member.phone }}</td>\n                <td class=\"col-md-3\" _v-53d33309=\"\"> {{ r.contract_name }}</td>\n                <td class=\"col-md-2\" _v-53d33309=\"\"> {{ r.entered_at }}</td>\n                <td class=\"col-md-2\" _v-53d33309=\"\"> {{ r.leaved_at }}</td>\n                <td class=\"col-md-2\" _v-53d33309=\"\"></td>\n            </tr>\n            </tbody>\n        </table>\n    </v-table>\n    <crm-home :member-id=\"memberId\" :studio-id=\"studioId\" _v-53d33309=\"\">\n    </crm-home>\n    <v-ticket-enter-admission _v-53d33309=\"\"></v-ticket-enter-admission>\n    <v-ticket-out-admission _v-53d33309=\"\"></v-ticket-out-admission>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.sortable > tbody > tr[_v-53d33309] {\n  cursor: pointer; }\n\n/* line 5, stdin */\np[_v-53d33309] {\n  font-size: 13px;\n  line-height: 25px;\n  margin: 0px; }\n\n/* line 11, stdin */\np.content[_v-53d33309] {\n  color: #000000; }\n\n/* line 15, stdin */\n.media-left > img[_v-53d33309] {\n  max-width: 114px; }\n\n/* line 19, stdin */\n.checkbox label[_v-53d33309]:after {\n  content: '';\n  display: table;\n  clear: both; }\n\n/* line 25, stdin */\n.checkbox .cr[_v-53d33309] {\n  position: relative;\n  display: inline-block;\n  border: 1px solid #a9a9a9;\n  border-radius: .25em;\n  width: 1.3em;\n  height: 1.3em;\n  float: left;\n  margin-right: .5em; }\n\n/* line 36, stdin */\n.checkbox .cr .cr-icon[_v-53d33309] {\n  position: absolute;\n  font-size: .8em;\n  line-height: 0;\n  top: 50%;\n  left: 15%; }\n\n/* line 44, stdin */\n.checkbox label input[type=\"checkbox\"][_v-53d33309] {\n  display: none; }\n\n/* line 48, stdin */\n.checkbox label input[type=\"checkbox\"] + .cr > .cr-icon[_v-53d33309] {\n  opacity: 0; }\n\n/* line 52, stdin */\n.checkbox label input[type=\"checkbox\"]:checked + .cr > .cr-icon[_v-53d33309] {\n  opacity: 1; }\n\n/* line 56, stdin */\n.checkbox label input[type=\"checkbox\"]:disabled + .cr[_v-53d33309] {\n  opacity: .5; }\n\n/* line 59, stdin */\n.fa-barcode[_v-53d33309] {\n  margin-left: -1.5em;\n  vertical-align: middle; }\n\n/* line 64, stdin */\n.barcode-input[_v-53d33309] {\n  height: 28px; }\n\n/* line 68, stdin */\n.barcode[_v-53d33309] {\n  margin-top: 20px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-53d33309", module.exports)
  } else {
    hotAPI.update("_v-53d33309", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"socket.io-client":765,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1001:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _modal = require('./modal.vue');

var _modal2 = _interopRequireDefault(_modal);

var _index = require('./index.vue');

var _index2 = _interopRequireDefault(_index);

var _table = require('./table.vue');

var _table2 = _interopRequireDefault(_table);

var _dashboard = require('./dashboard.vue');

var _dashboard2 = _interopRequireDefault(_dashboard);

var _ticketEnterAdmission = require('./ticket-enter-admission.vue');

var _ticketEnterAdmission2 = _interopRequireDefault(_ticketEnterAdmission);

var _ticketOutAdmission = require('./ticket-out-admission.vue');

var _ticketOutAdmission2 = _interopRequireDefault(_ticketOutAdmission);

var _noticeAdmission = require('./notice-admission.vue');

var _noticeAdmission2 = _interopRequireDefault(_noticeAdmission);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('admission-modal', _modal2.default);
_vue2.default.component('webadmin-admission-index', _index2.default);
_vue2.default.component('webadmin-dashboard-admission', _dashboard2.default);
_vue2.default.component('admission-table', _table2.default);
_vue2.default.component('v-ticket-enter-admission', _ticketEnterAdmission2.default);
_vue2.default.component('v-ticket-out-admission', _ticketOutAdmission2.default);
_vue2.default.component('notice-admission', _noticeAdmission2.default);

},{"./dashboard.vue":1000,"./index.vue":1002,"./modal.vue":1003,"./notice-admission.vue":1004,"./table.vue":1005,"./ticket-enter-admission.vue":1006,"./ticket-out-admission.vue":1007,"vue":792}],1002:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        canCreate: function canCreate(state) {
            return state.webadmin.configure.webFunctions.WebadminAdmissionsCreate;
        },
        studioId: function studioId(state) {
            return state.webadmin.configure.studioId;
        },
        branchId: function branchId(state) {
            return state.webadmin.configure.branchId;
        },
        items: function items(state) {
            return state.webadmin.admission.settings;
        },
        selectedStudioId: function selectedStudioId(state) {
            return state.filters.selected_studio_id;
        },
        selectedBranchId: function selectedBranchId(state) {
            return state.filters.selected_branch_id;
        }
    })),
    methods: {
        createSettings: function createSettings() {
            this.$store.commit('webadmin/admission/RESET_FORM_DATA');
            $('#admission-modal').modal('show');
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n    <div class=\"content-inner\">\n        <v-select-studio-and-branch :studio_id=\"studioId\" :branch_id=\"branchId\" :branch-without-filtered-option=\"false\"></v-select-studio-and-branch>\n        <h4>\n            <button type=\"button\" class=\"btn btn-success\" @click=\"createSettings\" v-if=\"canCreate\">\n                <i class=\"fa fa-plus\"></i>\n                新增入場設定\n            </button>\n        </h4>\n        <admission-table :branch-id=\"selectedBranchId\" :items=\"items\"></admission-table>\n        <admission-modal :studio-id=\"selectedStudioId\" :branch-id=\"selectedBranchId\"></admission-modal>\n    <div>\n</div></div>"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-1fea98c7", module.exports)
  } else {
    hotAPI.update("_v-1fea98c7", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vuex":803}],1003:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.input-group-addon[_v-5d3df5bc] {\n  background-color: #fff;\n  border: 0px solid #fff; }\n\n/* line 6, stdin */\n.fa-trash[_v-5d3df5bc] {\n  margin-left: 0.5em; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {};
    },

    props: ['studioId', 'branchId'],
    mounted: function mounted() {
        $.fn.bootstrapSwitch.defaults.onColor = 'info';
        $(this.$el).find('.enter-btn, .out-btn, .record-out-btn, .limit-duration-btn').bootstrapSwitch({ onText: '啟用', offText: '關閉' }).on('switchChange.bootstrapSwitch', this.switchChange);
        $(this.$el).find('.enable-limit-time-btn').bootstrapSwitch({ onText: '是', offText: '否' }).on('switchChange.bootstrapSwitch', this.switchChange);
        $('#admission-modal').on('hidden.bs.modal', function (e) {
            $('.enter-btn').bootstrapSwitch('state', false);
            $('.out-btn').bootstrapSwitch('state', false);
            $('.record-out-btn').bootstrapSwitch('state', false);
            $('.enable-limit-time-btn').bootstrapSwitch('state', false);
        });
    },

    computed: (0, _extends3.default)({
        canRemove: function canRemove() {
            return this.$store.state.is_17fit;
        },
        createdMode: function createdMode() {
            return this.id == null;
        },

        id: {
            get: function get() {
                return this.$store.state.webadmin.admission.data.id;
            },
            set: function set(value) {
                this.$store.commit('webadmin/admission/UPDATE_FORM_INPUT', { id: value });
            }
        },
        name: {
            get: function get() {
                return this.$store.state.webadmin.admission.data.name;
            },
            set: function set(value) {
                this.$store.commit('webadmin/admission/UPDATE_FORM_INPUT', { name: value });
            }
        },
        is_enabled_enter_point: {
            get: function get() {
                return this.$store.state.webadmin.admission.data.is_enabled_enter_point;
            },
            set: function set(value) {
                this.$store.commit('webadmin/admission/UPDATE_FORM_INPUT', { is_enabled_enter_point: value });
            }
        },
        is_enabled_out_point: {
            get: function get() {
                return this.$store.state.webadmin.admission.data.is_enabled_out_point;
            },
            set: function set(value) {
                this.$store.commit('webadmin/admission/UPDATE_FORM_INPUT', { is_enabled_out_point: value });
            }
        },
        enter_minus_point: {
            get: function get() {
                return this.$store.state.webadmin.admission.data.enter_minus_point;
            },
            set: function set(value) {
                this.$store.commit('webadmin/admission/UPDATE_FORM_INPUT', { enter_minus_point: value });
            }
        },
        after_enter_time_minus_point: {
            get: function get() {
                return this.$store.state.webadmin.admission.data.after_enter_time_minus_point;
            },
            set: function set(value) {
                this.$store.commit('webadmin/admission/UPDATE_FORM_INPUT', { after_enter_time_minus_point: value });
            }
        },
        out_time_unit: {
            get: function get() {
                return this.$store.state.webadmin.admission.data.out_time_unit;
            },
            set: function set(value) {
                this.$store.commit('webadmin/admission/UPDATE_FORM_INPUT', { out_time_unit: value });
            }
        },
        out_minus_point: {
            get: function get() {
                return this.$store.state.webadmin.admission.data.out_minus_point;
            },
            set: function set(value) {
                this.$store.commit('webadmin/admission/UPDATE_FORM_INPUT', { out_minus_point: value });
            }
        },
        type: {
            get: function get() {
                return this.$store.state.webadmin.admission.data.type;
            },
            set: function set(value) {
                this.$store.commit('webadmin/admission/UPDATE_FORM_INPUT', { type: value });
            }
        },
        limit_time: {
            get: function get() {
                return this.$store.state.webadmin.admission.data.limit_time;
            },
            set: function set(value) {
                this.$store.commit('webadmin/admission/UPDATE_FORM_INPUT', { limit_time: value });
            }
        },
        is_enabled_out: {
            get: function get() {
                return this.$store.state.webadmin.admission.data.is_enabled_out;
            },
            set: function set(value) {
                this.$store.commit('webadmin/admission/UPDATE_FORM_INPUT', { is_enabled_out: value });
            }
        },
        is_enabled_limit_time: {
            get: function get() {
                return this.$store.state.webadmin.admission.data.is_enabled_limit_time;
            },
            set: function set(value) {
                this.$store.commit('webadmin/admission/UPDATE_FORM_INPUT', { is_enabled_limit_time: value });
            }
        },
        limit_time_duration: {
            get: function get() {
                return this.$store.state.webadmin.admission.data.limit_time_duration;
            },
            set: function set(value) {
                this.$store.commit('webadmin/admission/UPDATE_FORM_INPUT', { limit_time_duration: value });
            }
        },
        url: function url() {
            return this.id ? '/adminapi/admission/' + this.id : '/adminapi/admission';
        },
        showPointSettings: function showPointSettings() {
            return this.types.point.id == this.type;
        },
        typeName: function typeName() {
            for (var p in this.types) {
                if (this.types[p].id == this.type) {
                    return this.types[p].name;
                }
            }
            return '';
        }
    }, (0, _vuex.mapState)({
        types: function types(state) {
            return state.webadmin.admission.types;
        }
    }), {
        durations: {
            get: function get() {
                return this.$store.state.webadmin.admission.data.durations;
            },
            set: function set(value) {
                this.$store.commit('webadmin/admission/UPDATE_FORM_INPUT', { durations: value });
            }
        },
        durationTime: function durationTime() {
            var durations = [];
            var newHour = '00';
            for (var hour = 0; hour < 24; hour++) {
                newHour = hour.toString().padStart(2, '0');
                durations[hour * 4 + 0] = newHour + ':00';
                durations[hour * 4 + 1] = newHour + ':15';
                durations[hour * 4 + 2] = newHour + ':30';
                durations[hour * 4 + 3] = newHour + ':45';
            }
            durations.push('23:59');

            return durations;
        },
        durationWeek: function durationWeek() {
            var durations = {
                1: '星期一',
                2: '星期二',
                3: '星期三',
                4: '星期四',
                5: '星期五',
                6: '星期六',
                7: '星期日'
            };

            return durations;
        }
    }),
    methods: {
        getFormData: function getFormData() {
            var formData = _.pick(this, 'name', 'type', 'is_enabled_out', 'is_enabled_limit_time', 'is_enabled_enter_point', 'is_enabled_out_point', 'enter_minus_point', 'enter_minus_point', 'after_enter_time_minus_point', 'out_time_unit', 'out_minus_point', 'limit_time', 'limit_time_duration');
            formData['is_enabled_limit_time'] = formData['is_enabled_limit_time'] ? 1 : 0;
            formData['studio_id'] = this.studioId;
            formData['branch_id'] = this.branchId;
            formData['durations'] = this.durations;
            return formData;
        },
        submit: function submit() {
            if (!this.beforeSubmit()) {
                return;
            }
            if (this.id) {
                this.$store.dispatch('webadmin/admission/update', { id: this.id, data: this.getFormData() }).then(this.successHandler);
            } else {
                this.$store.dispatch('webadmin/admission/create', this.getFormData()).then(this.successHandler);
            }
        },
        successHandler: function successHandler() {
            $('#admission-modal').modal('hide');
            this.$store.dispatch('webadmin/admission/fetchAdmissionSettings', this.branchId);
            this.durations = [];
        },
        remove: function remove() {
            var _this = this;

            $17.swal({
                title: '確認刪除「' + this.name + '」?',
                type: 'warning'
            }, function () {
                _this.$store.dispatch('webadmin/admission/delete', { id: _this.id }).then(function () {
                    _this.$store.dispatch('webadmin/admission/fetchAdmissionSettings', _this.branchId);
                    $('#admission-modal').modal('hide');
                });
            });
        },
        switchChange: function switchChange(event, state) {
            this[$(event.target).prop('name')] = Number(state);
        },
        appendDuration: function appendDuration() {
            var dus = this.convertToValues(this.durations);
            dus.push({
                allow_start: '',
                allow_end: ''
            });
            this.saveDuration(dus);
        },
        deleteDuration: function deleteDuration(index) {
            var newArray = this.convertToValues(this.durations);
            this.durations = [];
            this.$delete(newArray, index);
            this.durations = newArray;
            this.saveDuration(this.durations);
        },
        changeDuration: function changeDuration(type, index, newValue) {
            var old = this.durations[index][type];
            var duration = {};
            var setValue = newValue;
            duration['allow_week'] = this.durations[index]['allow_week'];
            duration['allow_start'] = this.durations[index]['allow_start'];
            duration['allow_end'] = this.durations[index]['allow_end'];

            duration[type] = newValue;

            if (duration['allow_start'] && duration['allow_end'] && this.getTimeMin(duration['allow_start']) > this.getTimeMin(duration['allow_end'])) {

                duration[type] = old;

                $17.swal({
                    title: '開始時間不可大於結束時間',
                    type: 'error'
                });
            }

            this.$store.commit('webadmin/admission/SET_SELECT_DURATION', {
                index: index,
                value: duration
            });
            this.$forceUpdate();
        },
        saveDuration: function saveDuration(values) {
            this.durations = values;
            var newArray = this.convertToValues(this.durations);
            this.$store.commit('webadmin/admission/SET_DURATION', newArray);
        },
        convertToValues: function convertToValues(object) {
            return JSON.parse((0, _stringify2.default)(object));
        },
        getTimeMin: function getTimeMin(s) {
            var part = s.match(/(\d+):(\d+)(?: )?(am|pm)?/i);

            var hh = parseInt(part[1], 10);
            var mm = parseInt(part[2], 10);

            return hh * 60 + mm;
        },
        beforeSubmit: function beforeSubmit() {
            return this.durations.reduce(function (carry, value) {
                if (!value['allow_start'] || !value['allow_end'] || value['allow_start'] == '' || value['allow_end'] == '') {
                    $17.swal({
                        title: '開始/結束時間未選擇',
                        type: 'error'
                    });
                    carry = false;
                }

                return carry;
            }, true);
        },
        close: function close() {
            this.$store.commit('webadmin/admission/RESET_FORM_DATA');
        }
    },
    watch: {
        is_enabled_enter_point: function is_enabled_enter_point(newValue) {
            $('.enter-btn').bootstrapSwitch('state', !!newValue);
        },
        is_enabled_out_point: function is_enabled_out_point(newValue) {
            $('.out-btn').bootstrapSwitch('state', !!this.is_enabled_out_point);
        },
        is_enabled_out: function is_enabled_out(newValue) {
            $('.record-out-btn').bootstrapSwitch('state', !!this.is_enabled_out);
        },
        is_enabled_limit_time: function is_enabled_limit_time(newValue) {
            $('.enable-limit-time-btn').bootstrapSwitch('state', !!this.is_enabled_limit_time);
        },
        limit_time_duration: function limit_time_duration(newValue) {
            $('.limit-duration-btn').bootstrapSwitch('state', !!this.limit_time_duration);
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal id=\"admission-modal\" :save-clicked=\"submit\" :remove-btn-show=\"canRemove\" :remove-clicked=\"remove\" :close-modal-event=\"close\" open-size=\"modal-lg\" _v-5d3df5bc=\"\">\n    <span slot=\"title\" _v-5d3df5bc=\"\">入場設定</span>\n    <template slot=\"body\">\n        <form class=\"form-horizontal\" _v-5d3df5bc=\"\">\n            <div class=\"form-group\" _v-5d3df5bc=\"\">\n                <label for=\"name\" class=\"col-sm-3\" _v-5d3df5bc=\"\">名稱</label>\n                <div class=\"col-sm-5\" _v-5d3df5bc=\"\">\n                  <input type=\"text\" id=\"name\" name=\"name\" v-model=\"name\" class=\"form-control\" placeholder=\"入場設定名稱\" _v-5d3df5bc=\"\">\n                </div>\n            </div>\n            <div class=\"form-group\" _v-5d3df5bc=\"\">\n                <label for=\"type\" class=\"col-sm-3\" _v-5d3df5bc=\"\">適用類型</label>\n                <div class=\"col-sm-4\" _v-5d3df5bc=\"\">\n                  <select v-show=\"createdMode\" class=\"form-control\" v-model=\"type\" _v-5d3df5bc=\"\">\n                    &nbsp;&nbsp;<option value=\"\" disabled=\"\" selected=\"\" _v-5d3df5bc=\"\">請選擇類型</option>\n                      <option :value=\"t.id\" v-for=\"t in types\" _v-5d3df5bc=\"\">{{ t.name }}</option>\n                  </select>\n                  <p v-show=\"!createdMode\" class=\"form-control-static\" _v-5d3df5bc=\"\">{{ typeName }}</p>\n                </div>\n            </div>\n            <div v-show=\"true\" _v-5d3df5bc=\"\">\n                <div class=\"form-group\" _v-5d3df5bc=\"\">\n                    <label class=\"col-sm-3\" _v-5d3df5bc=\"\">限制入場時段</label>\n                    <div class=\"col-sm-5\" _v-5d3df5bc=\"\">\n                        <div class=\"btn-group\" _v-5d3df5bc=\"\">\n                            <input type=\"checkbox\" name=\"limit_time_duration\" v-model=\"limit_time_duration\" v-bind:true-value=\"1\" v-bind:false-value=\"0\" class=\"limit-duration-btn\" _v-5d3df5bc=\"\">\n                        </div>\n                    </div>\n                </div>\n                <div class=\"form-group\" _v-5d3df5bc=\"\">\n                    <div class=\"col-sm-5 col-sm-offset-3\" _v-5d3df5bc=\"\">\n                        <a @click.prevent.stop=\"appendDuration\" class=\"append-duration-time\" _v-5d3df5bc=\"\">\n                            <i class=\"fa fa-plus\" aria-hidden=\"true\" _v-5d3df5bc=\"\"></i>新增一個時段\n                        </a>\n                    </div>\n                </div>\n                <div class=\"form-group\" v-for=\"(duration, index) in durations\" :key=\"index\" _v-5d3df5bc=\"\">\n                    <div class=\"col-sm-offset-3 col-sm-2 col-xs-3\" _v-5d3df5bc=\"\">\n                        <select class=\"form-control\" :value=\"duration.allow_week\" :key=\"index\n                            +'allow_week'\" @change=\"changeDuration('allow_week',index,$event.target.value)\" _v-5d3df5bc=\"\">\n                            <option :value=\"indexWeek\" v-for=\"(t,indexWeek) in durationWeek\" :key=\"t.allow_week\" _v-5d3df5bc=\"\">{{ t }}</option>\n                        </select>\n                    </div> \n                    <div class=\"col-sm-2 col-xs-3\" _v-5d3df5bc=\"\">\n                        <select class=\"form-control\" :value=\"duration.allow_start\" :key=\"index\n                            +'allow_start'\" @change=\"changeDuration('allow_start',index,$event.target.value)\" _v-5d3df5bc=\"\">\n                            <option :value=\"t\" v-for=\"t in durationTime\" :key=\"t.allow_start\" _v-5d3df5bc=\"\">{{ t }}</option>\n                        </select>\n                    </div> \n                    <div class=\"col-sm-1 col-xs-1\" _v-5d3df5bc=\"\">\n                            <div class=\"\" _v-5d3df5bc=\"\">~</div>\n                    </div>\n                    <div class=\"col-sm-2 col-xs-3\" _v-5d3df5bc=\"\">\n                        <select class=\"form-control\" :value=\"duration.allow_end\" :key=\"index+'allow_end'\" @change=\"changeDuration('allow_end',index,$event.target.value)\" _v-5d3df5bc=\"\">\n                            <option :value=\"t\" v-for=\"t in durationTime\" :key=\"t.allow_end\" _v-5d3df5bc=\"\">{{ t }}</option>\n                        </select>\n                    </div>\n                    <div class=\"col-sm-1 col-xs-1\" _v-5d3df5bc=\"\">\n                        <i class=\"fa fa-trash fa-2x\" aria-hidden=\"true\" @click=\"deleteDuration(index)\" _v-5d3df5bc=\"\"></i>\n                    </div>\n                </div>\n            </div>\n            <div v-show=\"!showPointSettings\" _v-5d3df5bc=\"\">\n                <div class=\"form-group\" _v-5d3df5bc=\"\">\n                    <label class=\"col-sm-3\" _v-5d3df5bc=\"\">記錄出場 <a href=\"javascript:void(0)\" _v-5d3df5bc=\"\"><i class=\"fa fa-question-circle\" help=\"開啟後，系統就會自動記錄會員的出場時間。\" _v-5d3df5bc=\"\"></i></a></label>\n                    <div class=\"col-sm-5\" _v-5d3df5bc=\"\">\n                        <div class=\"btn-group\" _v-5d3df5bc=\"\">\n                            <input type=\"checkbox\" name=\"is_enabled_out\" v-model=\"is_enabled_out\" value=\"1\" class=\"record-out-btn\" _v-5d3df5bc=\"\">\n                        </div>\n                    </div>\n                </div>\n                <div v-show=\"is_enabled_out\" _v-5d3df5bc=\"\">\n                    <div class=\"form-group\" _v-5d3df5bc=\"\">\n                        <div class=\"col-sm-offset-3 col-sm-7 col-xs-12\" _v-5d3df5bc=\"\">\n                            <label class=\"col-sm-5\" _v-5d3df5bc=\"\">限制入場時間 </label>\n                            <div class=\"col-sm-5\" _v-5d3df5bc=\"\">\n                                <div class=\"btn-group\" _v-5d3df5bc=\"\">\n                                    <input type=\"checkbox\" name=\"is_enabled_limit_time\" v-model=\"is_enabled_limit_time\" value=\"1\" class=\"enable-limit-time-btn\" _v-5d3df5bc=\"\">\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <div v-show=\"is_enabled_limit_time\" class=\"form-group\" _v-5d3df5bc=\"\">\n                        <div class=\"col-sm-offset-3 col-sm-7 col-xs-12\" _v-5d3df5bc=\"\">\n                            <label class=\"col-sm-5\" _v-5d3df5bc=\"\">限制入場時間 </label>\n                            <div class=\"col-sm-7\" _v-5d3df5bc=\"\">\n                                <div class=\"input-group\" _v-5d3df5bc=\"\">\n                                    <input type=\"number\" name=\"limit_time\" v-model=\"limit_time\" class=\"form-control\" _v-5d3df5bc=\"\">\n                                    <div class=\"input-group-addon\" _v-5d3df5bc=\"\">分鐘</div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div v-show=\"showPointSettings\" _v-5d3df5bc=\"\">\n                <hr class=\"normal\" _v-5d3df5bc=\"\">\n                <div class=\"form-group\" _v-5d3df5bc=\"\">\n                    <label class=\"col-sm-3\" _v-5d3df5bc=\"\">入場扣點</label>\n                    <div class=\"col-sm-5\" _v-5d3df5bc=\"\">\n                        <div class=\"btn-group\" _v-5d3df5bc=\"\">\n                            <input type=\"checkbox\" name=\"is_enabled_enter_point\" v-model=\"is_enabled_enter_point\" value=\"1\" class=\"enter-btn\" _v-5d3df5bc=\"\">\n                        </div>\n                    </div>\n                </div>\n                <div v-show=\"is_enabled_enter_point\" class=\"form-group\" _v-5d3df5bc=\"\">\n                    <div class=\"col-sm-offset-3 col-sm-3 col-xs-6\" _v-5d3df5bc=\"\">\n                        <div class=\"input-group\" _v-5d3df5bc=\"\">\n                            <input type=\"number\" name=\"enter_minus_point\" v-model=\"enter_minus_point\" class=\"form-control\" _v-5d3df5bc=\"\">\n                            <div class=\"input-group-addon\" _v-5d3df5bc=\"\">點</div>\n                        </div>\n                    </div>\n                </div>\n                <hr class=\"normal\" _v-5d3df5bc=\"\">\n                <div class=\"form-group\" _v-5d3df5bc=\"\">\n                    <label class=\"col-sm-3\" _v-5d3df5bc=\"\">出場扣點</label>\n                    <div class=\"col-sm-5\" _v-5d3df5bc=\"\">\n                        <div class=\"btn-group\" _v-5d3df5bc=\"\">\n                            <input type=\"checkbox\" name=\"is_enabled_out_point\" v-model=\"is_enabled_out_point\" value=\"1\" class=\"out-btn\" _v-5d3df5bc=\"\">\n                        </div>\n                    </div>\n                </div>\n                <div v-show=\"is_enabled_out_point\" class=\"form-group\" _v-5d3df5bc=\"\">\n                    <div class=\"col-sm-offset-3 col-sm-7 col-xs-12\" _v-5d3df5bc=\"\">\n                        <div class=\"input-group\" _v-5d3df5bc=\"\">\n                            <div class=\"input-group-addon\" _v-5d3df5bc=\"\">入場</div>\n                            <input type=\"number\" name=\"after_enter_time_minus_point\" v-model=\"after_enter_time_minus_point\" class=\"form-control\" _v-5d3df5bc=\"\">\n                            <div class=\"input-group-addon\" _v-5d3df5bc=\"\">分鐘後, 開始計時扣點</div>\n                        </div>\n                    </div>\n                </div>\n                <div v-show=\"is_enabled_out_point\" class=\"form-group\" _v-5d3df5bc=\"\">\n                    <div class=\"col-sm-offset-3 col-sm-7 col-xs-12\" _v-5d3df5bc=\"\">\n                        <div class=\"input-group\" _v-5d3df5bc=\"\">\n                            <div class=\"input-group-addon\" _v-5d3df5bc=\"\">每</div>\n                            <input type=\"number\" name=\"out_time_unit\" v-model=\"out_time_unit\" class=\"form-control\" _v-5d3df5bc=\"\">\n                            <div class=\"input-group-addon\" _v-5d3df5bc=\"\">分鐘, 扣</div>\n                            <input type=\"number\" name=\"out_minus_point\" v-model=\"out_minus_point\" class=\"form-control\" _v-5d3df5bc=\"\">\n                            <div class=\"input-group-addon\" _v-5d3df5bc=\"\">點</div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </form>\n    </template>\n</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.input-group-addon[_v-5d3df5bc] {\n  background-color: #fff;\n  border: 0px solid #fff; }\n\n/* line 6, stdin */\n.fa-trash[_v-5d3df5bc] {\n  margin-left: 0.5em; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-5d3df5bc", module.exports)
  } else {
    hotAPI.update("_v-5d3df5bc", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/json/stringify":48,"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1004:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    data: function data() {
        return {
            gateentry: null,
            gateexit: null,
            gateerror: null,
            entryTimeoutId: null,
            exitTimeoutId: null,
            entryTime: 0,
            exitTime: 0,
            timeoutId: 0,
            entry: {
                memberName: '',
                sourceType: '',
                sourceName: '',
                picturePath: null,
                actionMessage: '',
                actionStatus: '',
                sourceInfo: ''
            },
            exit: {
                memberName: '',
                sourceType: '',
                sourceName: '',
                picturePath: null,
                actionMessage: '',
                actionStatus: '',
                sourceInfo: ''
            },
            sourceTypeTw: {
                contract: '方案',
                ticket: '票券',
                booking: '預約'
            },
            actionStatusTw: {
                finished: '成功',
                error: '失敗'
            }
        };
    },

    props: ['openVideoNotice'],
    mounted: function mounted() {
        var _this = this;

        this.gateentry = new Audio("/video/gateIn.mp3");
        this.gateexit = new Audio("/video/gateOut.mp3");
        this.gateerror = new Audio("/video/gateError.mp3");

        window.Event.$on('Device.Admission.Clearance', function (data) {
            _this.gateVideoPlay(data);
            var type = data.device.actionType;
            _this[type + 'Time'] = 1;
            clearTimeout(_this[type + 'TimeoutId']);
            setTimeout(function () {
                _this.setTime(type);
            }, 1000);
            _this.showNotice(data, type);
            _this.triggerUpdate();
        });
    },

    methods: {
        gateVideoPlay: function gateVideoPlay(data) {
            if (this.openVideoNotice) {
                if (data.deviceActionStatus === 'finished') {
                    var clearanceStatus = data.device.actionType;
                    this['gate' + clearanceStatus].pause();
                    this['gate' + clearanceStatus].currentTime = 0;
                    this['gate' + clearanceStatus].play();
                } else {
                    var _clearanceStatus = data.deviceActionStatus;
                    this['gate' + _clearanceStatus].pause();
                    this['gate' + _clearanceStatus].currentTime = 0;
                    this['gate' + _clearanceStatus].play();
                }
            }
        },
        showNotice: function showNotice(data, type) {
            this.setDefaultValue(type);
            this[type].actionStatus = data.deviceActionStatus;
            this[type].actionMessage = data.device.actionMessage;
            if (data.deviceActionStatus === 'finished') {
                this[type].memberName = data.member.name;
                this[type].picturePath = data.member.pic;
                this[type].sourceType = this.sourceTypeTw[data.auth.source.type];
                this[type].sourceName = data.auth.source.name;
                if (data.auth.source.type === 'contract') {
                    if (data.auth.source.info.contractType !== 1) {
                        this[type].sourceInfo = '剩餘 ';
                    } else {
                        this[type].sourceInfo = '';
                    }
                    this[type].sourceInfo += data.auth.source.info.valueBalance + this.concatType(data.auth.source.info.contractType);
                } else if (data.auth.source.type === "ticket") {
                    this[type].sourceInfo = data.auth.source.id;
                }
            }
        },
        triggerUpdate: function triggerUpdate() {
            var _this2 = this;

            clearTimeout(this.timeoutId);
            this.timeoutId = setTimeout(function () {
                _this2.$emit("fetch-record");
            }, 5000);
        },
        setTime: function setTime(type) {
            var _this3 = this;

            if (this[type + 'Time'] >= 59) {
                this[type].actionStatus = '';
            } else {
                this[type + 'Time']++;
                this[type + 'TimeoutId'] = setTimeout(function () {
                    _this3.setTime(type);
                }, 1000);
            }
        },
        concatType: function concatType(type) {
            switch (type) {
                case 1:
                    return '無限';
                case 2:
                    return '點數';
                case 3:
                    return '次數';
            }
        },
        changeActionStatusStyle: function changeActionStatusStyle(actionStatus) {
            if (actionStatus === 'finished') {
                return 'green';
            } else {
                return 'danger';
            }
        },
        setDefaultValue: function setDefaultValue(type) {
            this[type].sourceInfo = '-';
            this[type].memberName = '-';
            this[type].picturePath = '/images/default.png';
            this[type].sourceType = '-';
            this[type].sourceName = '-';
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"st-flex st-flex-wrap\">\n    <div class=\"st-w-full lg:st-w-1/2 st-py-3 st-pr-4\">\n        <div class=\"st-mb-4 st-flex\">\n            <div class=\"st-w-1 st-h-7 st-inline-block st-rounded-4 st-mr-3\" style=\"background-color:#38B0E3\"></div>\n            <span class=\"st-text-20 st-text-gray-90 st-font-medium\">入場</span>\n        </div>\n        <div class=\"st-bg-opacity-5 st-border-0 st-border-l-8 st-border-solid st-rounded-4 st-px-5 st-py-3.5 st-h-52\" :class=\"'st-border-' + changeActionStatusStyle(entry.actionStatus) + ' st-bg-' + changeActionStatusStyle(entry.actionStatus)\" v-show=\"entry.actionStatus !== ''\">\n            <div class=\"st-flex st-gap-3\">\n                <div>\n                    <img class=\"st-w-36 st-h-36 st-rounded-4\" :src=\"entry.picturePath\">\n                </div>\n                <div class=\"st-w-full st-text-16 st-text-black st-font-regular st-space-y-2\">\n                    <div class=\"st-flex st-items-center st-justify-between\">\n                        <div class=\"st-font-bold st-text-28\" :class=\"'st-text-' + changeActionStatusStyle(entry.actionStatus)\">\n                            <div v-show=\"entry.actionStatus === 'finished'\"><span class=\"material-icons st-text-28 st-mr-4\">check_circle</span>入場成功\n                            </div>\n                            <div v-show=\"entry.actionStatus === 'error'\">\n                                <span class=\"material-icons st-text-28 st-mr-4\">warning</span>入場失敗\n                            </div>\n                        </div>\n                        <div class=\"st-text-gray-90 st-font-medium\">{{entryTime}} 秒前</div>\n                    </div>\n                    <div>\n                        <span class=\"st-text-20 st-font-medium\">{{entry.memberName}}</span>\n                    </div>\n                    <div>\n                        <span class=\"st-text-gray-90 st-mr-4\">類型</span> {{entry.sourceType}}\n                    </div>\n                    <div>\n                        <span class=\"st-text-gray-90 st-mr-4\">名稱</span> {{entry.sourceName}}\n                    </div>\n                    <div>\n                        <span class=\"st-text-gray-90 st-mr-4\">資訊</span> {{entry.sourceInfo}}\n                    </div>\n                    <div>\n                        <span class=\"st-text-gray-90 st-mr-4\">提示</span> {{entry.actionMessage}}\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"st-border-0 st-rounded-4 st-px-5 st-py-3.5 st-bg-gray-20 st-h-52\" v-show=\"entry.actionStatus === ''\">\n            <div class=\"st-flex st-justify-center st-flex-col st-items-center st-h-full\">\n                <img class=\"st-w-14\" src=\"/images/gate-nottice-no.png\">\n                <div class=\"st-text-16\">目前無入場通知</div>\n            </div>\n        </div>\n    </div>\n    <div class=\"st-w-full lg:st-w-1/2 st-py-3 st-pr-4\">\n        <div class=\"st-mb-4 st-flex\">\n            <div class=\"st-w-1 st-h-7 st-inline-block st-rounded-4 st-mr-3\" style=\"background-color:#38B0E3\"></div>\n            <span class=\"st-text-20 st-text-gray-90 st-font-medium\">出場</span>\n        </div>\n        <div class=\"st-bg-opacity-5 st-border-0 st-border-l-8 st-border-solid st-rounded-4 st-px-5 st-py-3.5 st-h-52\" :class=\"'st-border-' + changeActionStatusStyle(exit.actionStatus) + ' st-bg-' + changeActionStatusStyle(exit.actionStatus)\" v-show=\"exit.actionStatus !== ''\">\n            <div class=\"st-flex st-gap-3\">\n                <div>\n                    <img class=\"st-w-36 st-h-36\" :src=\"exit.picturePath\">\n                </div>\n                <div class=\"st-w-full st-text-16 st-text-black st-font-regular st-space-y-2\">\n                    <div class=\"st-flex st-items-center st-justify-between\">\n                        <div class=\"st-font-bold st-text-28\" :class=\"'st-text-' + changeActionStatusStyle(exit.actionStatus)\">\n                            <div v-show=\"exit.actionStatus === 'finished'\">\n                                <span class=\"material-icons st-text-28 st-mr-4\">check_circle</span>出場成功\n                            </div>\n                            <div v-show=\"exit.actionStatus === 'error'\">\n                                <span class=\"material-icons st-text-28 st-mr-4\">warning</span>出場失敗\n                            </div>\n                        </div>\n                        <div class=\"st-text-gray-90 st-font-medium\">{{exitTime}} 秒前</div>\n                    </div>\n                    <div>\n                        <span class=\"st-text-20 st-font-medium\">{{exit.memberName}}</span>\n                    </div>\n                    <div>\n                        <span class=\"st-text-gray-90 st-mr-4\">類型</span> {{exit.sourceType}}\n                    </div>\n                    <div>\n                        <span class=\"st-text-gray-90 st-mr-4\">名稱</span> {{exit.sourceName}}\n                    </div>\n                    <div>\n                        <span class=\"st-text-gray-90 st-mr-4\">資訊</span> {{exit.sourceInfo}}\n                    </div>\n                    <div>\n                        <span class=\"st-text-gray-90 st-mr-4\">提示</span> {{exit.actionMessage}}\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"st-border-0 st-rounded-4 st-px-5 st-py-3.5 st-bg-gray-20 st-h-52\" v-show=\"exit.actionStatus == ''\">\n            <div class=\"st-flex st-justify-center st-flex-col st-items-center st-h-full\">\n                <img class=\"st-w-14\" src=\"/images/gate-nottice-no.png\">\n                <div class=\"st-text-16\">目前無出場通知</div>\n            </div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-0c18a96f", module.exports)
  } else {
    hotAPI.update("_v-0c18a96f", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],1005:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.sortable > tbody > tr[_v-4cf4647a] {\n  cursor: pointer; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['branchId', 'items'],
    mounted: function mounted() {
        if (this.branchId == null) {
            return;
        }
        this.$store.dispatch('webadmin/admission/fetchAdmissionSettings', this.branchId);
    },

    watch: {
        branchId: function branchId(val) {
            this.$store.dispatch('webadmin/admission/fetchAdmissionSettings', val);
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        ajaxing: function ajaxing(state) {
            return state.webadmin.admission.ajaxingSettings;
        }
    })),
    methods: {
        edit: function edit(it) {
            this.$store.dispatch('webadmin/admission/fetchOne', { id: it.id });
            $('#admission-modal').modal('show');
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-table :ajaxing=\"ajaxing\" :length=\"items.length\" _v-4cf4647a=\"\">\n    <table class=\"table sortable\" _v-4cf4647a=\"\">\n        <thead _v-4cf4647a=\"\">\n            <tr _v-4cf4647a=\"\">\n                <th _v-4cf4647a=\"\">名稱</th>\n                <th _v-4cf4647a=\"\">類型</th>\n            </tr>\n        </thead>\n        <tbody _v-4cf4647a=\"\">\n            <tr v-for=\"it in items\" @click=\"edit(it)\" :key=\"it.id\" _v-4cf4647a=\"\">\n                <td _v-4cf4647a=\"\"> {{ it.name }} </td>\n                <td _v-4cf4647a=\"\"> {{ it.type }} </td>\n            </tr>\n        </tbody>\n    </table>\n</v-table>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.sortable > tbody > tr[_v-4cf4647a] {\n  cursor: pointer; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-4cf4647a", module.exports)
  } else {
    hotAPI.update("_v-4cf4647a", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1006:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n\t.timing[_v-e92c7224] {\n\t    padding: 3px;\n\t    border: 1px solid;\n\t    background: #eee;\n\t}\n\t.btn-submit-admission[_v-e92c7224] {\n    \tmargin-top: 15px;\n\t}\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			nowTimer: moment().format('YYYY-MM-DD HH:mm:ss')
		};
	},
	created: function created() {
		setInterval(this.refreshNowTimer, 500);
	},

	computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
		contractTypes: function contractTypes(state) {
			return state.webadmin.admission.contractTypes;
		},
		selectTicket: function selectTicket(state) {
			return state.webadmin.admission.selectTicket;
		},
		settingInfo: function settingInfo(state) {
			return state.webadmin.admission.settingInfo;
		},
		errorData: function errorData(state) {
			return state.webadmin.admission.errorData;
		}
	}), {
		admissionSetting: function admissionSetting() {
			return this.settingInfo && this.settingInfo.name ? this.settingInfo.name : '';
		}
	}),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('webadmin/admission', ['showAdmissionInfo']), {
		refreshNowTimer: function refreshNowTimer() {
			this.nowTimer = moment().format('YYYY-MM-DD HH:mm:ss');
		},
		submit: function submit(e) {
			var _this = this;

			return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								$(e.target).prop('disabled', true);
								_context.next = 3;
								return _this.$store.dispatch('webadmin/admission/createTicketEnterRecord', {
									id: _this.selectTicket.id
								}).then(function (o) {
									_this.$store.dispatch('webadmin/admission/alertEnterSuccess');
									// window.Event.$emit('fetchMemberContract', this.memberId)
									$('#ticket-enter-admission-modal').modal('hide');
									_this.$store.dispatch('webadmin/admission/getUnLeavedRecords');
									_this.$store.dispatch('webadmin/admission/getDailyRecords');
								}).catch(function (o) {
									_this.$store.dispatch('webadmin/admission/admissionErrorAlert', o);
								});

							case 3:
								$(e.target).prop('disabled', false);

							case 4:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		}
	})
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal id=\"ticket-enter-admission-modal\" no-footer=\"\" no-border-radius=\"\" _v-e92c7224=\"\">\n\t<template slot=\"title\">入場</template>\n\t<template slot=\"body\">\n\t\t<form class=\"form-horizontal\" _v-e92c7224=\"\">\n\t\t\t<div class=\"row\" _v-e92c7224=\"\">\n\t\t\t\t<label class=\"control-label col-sm-3\" _v-e92c7224=\"\">票券號碼</label>\n\t\t\t\t<p class=\"form-control-static col-sm-9\" _v-e92c7224=\"\">{{selectTicket.id}}</p>\n\t\t\t</div>\n\t\t\t<div class=\"row\" _v-e92c7224=\"\">\n\t\t\t\t<label class=\"control-label col-sm-3\" _v-e92c7224=\"\">入場設定</label>\n\t\t\t\t<p class=\"form-control-static col-sm-9\" _v-e92c7224=\"\">{{ admissionSetting }} <a @click.prevent=\"showAdmissionInfo\" _v-e92c7224=\"\"><i class=\"fa fa-question-circle\" _v-e92c7224=\"\"></i></a></p>\n\t\t\t</div>\n\t\t\t<div class=\"row\" _v-e92c7224=\"\">\n\t\t\t\t<label class=\"control-label col-sm-3\" _v-e92c7224=\"\">售出時間</label>\n\t\t\t\t<p class=\"form-control-static col-sm-9\" _v-e92c7224=\"\">{{selectTicket.created_at}}</p>\n\t\t\t</div>\n\t\t\t<div class=\"row\" _v-e92c7224=\"\">\n\t\t\t\t<label class=\"control-label col-sm-3\" _v-e92c7224=\"\">有效期限</label>\n\t\t\t\t<p class=\"form-control-static col-sm-9\" _v-e92c7224=\"\">{{selectTicket.end_time}}</p>\n\t\t\t</div>\n\t\t\t<div class=\"row\" _v-e92c7224=\"\">\n\t\t\t\t<label class=\"control-label col-sm-3\" _v-e92c7224=\"\">入場時間</label>\n\t\t\t\t<p class=\"form-control-static col-sm-9\" _v-e92c7224=\"\"><span class=\"timing\" _v-e92c7224=\"\">{{ nowTimer }}</span></p>\n\t\t\t</div>\n\t\t\t<button type=\"button\" class=\"btn btn-primary btn-lg btn-block btn-submit-admission\" @click.prevent=\"submit\" _v-e92c7224=\"\">入場</button>\n\t\t</form>\n\t</template>\n</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n\t.timing[_v-e92c7224] {\n\t    padding: 3px;\n\t    border: 1px solid;\n\t    background: #eee;\n\t}\n\t.btn-submit-admission[_v-e92c7224] {\n    \tmargin-top: 15px;\n\t}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-e92c7224", module.exports)
  } else {
    hotAPI.update("_v-e92c7224", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1007:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n\t.timing[_v-3b104164] {\n\t    padding: 3px;\n\t    border: 1px solid;\n\t    background: #eee;\n\t}\n\t.btn-submit-admission[_v-3b104164] {\n    \tmargin-top: 15px;\n\t}\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	props: ['ticketId'],
	data: function data() {
		return {
			nowTimer: moment().format('YYYY-MM-DD HH:mm:ss')
		};
	},
	created: function created() {
		setInterval(this.refreshNowTimer, 500);
	},

	computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
		contractTypes: function contractTypes(state) {
			return state.webadmin.admission.contractTypes;
		},
		selectTicket: function selectTicket(state) {
			return state.webadmin.admission.selectTicket;
		},
		errorData: function errorData(state) {
			return state.webadmin.admission.errorData;
		},
		record: function record(state) {
			return state.webadmin.admission.unLeavedRecord;
		},
		entered_at: function entered_at(state) {
			return state.webadmin.admission.unLeavedRecord.entered_at;
		}
	}), {
		admissionSetting: function admissionSetting() {
			return this.record && this.record.admission ? this.record.admission.name : '';
		},
		showStatus: function showStatus() {
			switch (this.selectTicket.status) {
				case 0:
					return '未使用';
					break;
				case 2:
					return '已使用';
					break;
				case 3:
					return '作廢';
					break;
			}
		},
		passTime: function passTime() {
			return moment(this.nowTimer).diff(moment(this.entered_at), 'seconds');
		}
	}),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('webadmin/admission', ['showAdmissionInfo']), {
		refreshNowTimer: function refreshNowTimer() {
			this.nowTimer = moment().format('YYYY-MM-DD HH:mm:ss');
		},
		isOverLimitTime: function isOverLimitTime() {
			return this.record.limit_time > 0 && this.record.limit_time * 60 < this.passTime;
		},
		outHandler: function outHandler(e, force) {
			var _this = this;

			return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								$(e.target).prop('disabled', true);
								_context.next = 3;
								return _this.$store.dispatch('webadmin/admission/markTicketLeaved', { id: _this.record.id, force: force }).then(function () {
									$17.swal({
										type: 'success',
										title: '確認出場',
										showCancelButton: false
									});
									$('#ticket-out-admission-modal').modal('hide');
									_this.$store.dispatch('webadmin/admission/getUnLeavedRecords');
									_this.$store.dispatch('webadmin/admission/getDailyRecords');
								}).catch(function (o) {
									_this.$store.dispatch('webadmin/admission/admissionErrorAlert', o);
								});

							case 3:
								$(e.target).prop('disabled', false);

							case 4:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		},
		submit: function submit(e) {
			var _this2 = this;

			if (this.isOverLimitTime()) {
				$17.swal({
					title: '超出時間',
					type: 'info',
					showCancelButton: true,
					confirmButtonText: '前往結帳',
					cancelButtonText: '略過, 允許出場'
				}, function (isConfirm) {
					if (isConfirm) {
						window.Event.$emit('createOrder');
						$('#out-admission-modal').modal('hide');
						return false;
					}
					_this2.outHandler(e, true);
				});
				return false;
			} else {
				this.outHandler(e, false);
			}
		}
	})
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal id=\"ticket-out-admission-modal\" no-footer=\"\" no-border-radius=\"\" _v-3b104164=\"\">\n\t<template slot=\"title\">出場</template>\n\t<template slot=\"body\">\n\t\t<form class=\"form-horizontal\" _v-3b104164=\"\">\n\t\t\t<div class=\"row\" _v-3b104164=\"\">\n\t\t\t\t<label class=\"control-label col-sm-3\" _v-3b104164=\"\">票券號碼</label>\n\t\t\t\t<p class=\"form-control-static col-sm-9\" _v-3b104164=\"\">{{selectTicket.id}}</p>\n\t\t\t</div>\n\t\t\t<div class=\"row\" _v-3b104164=\"\">\n\t\t\t\t<label class=\"control-label col-sm-3\" _v-3b104164=\"\">入場設定</label>\n\t\t\t\t<p class=\"form-control-static col-sm-9\" _v-3b104164=\"\">{{ admissionSetting }} <a @click.prevent=\"showAdmissionInfo\" _v-3b104164=\"\"><i class=\"fa fa-question-circle\" _v-3b104164=\"\"></i></a></p>\n\t\t\t</div>\n\t\t\t<div class=\"row\" _v-3b104164=\"\">\n\t\t\t\t<label class=\"control-label col-sm-3\" _v-3b104164=\"\">入場時間</label>\n\t\t\t\t<p class=\"form-control-static col-sm-9\" _v-3b104164=\"\">{{record.entered_at}}</p>\n\t\t\t</div>\n\t\t\t<div class=\"row\" _v-3b104164=\"\">\n\t\t\t\t<label class=\"control-label col-sm-3\" _v-3b104164=\"\">現在時間</label>\n\t\t\t\t<p class=\"form-control-static col-sm-9\" _v-3b104164=\"\"><span class=\"timing\" _v-3b104164=\"\">{{ nowTimer }}</span></p>\n\t\t\t</div>\n\t\t\t<div class=\"row\" _v-3b104164=\"\">\n\t\t\t\t<label class=\"control-label col-sm-3\" _v-3b104164=\"\">有效期限</label>\n\t\t\t\t<p class=\"form-control-static col-sm-9\" _v-3b104164=\"\">{{selectTicket.end_time}}</p>\n\t\t\t</div>\n\t\t\t<div class=\"row\" _v-3b104164=\"\">\n\t\t\t\t<label class=\"control-label col-sm-3\" _v-3b104164=\"\">狀態</label>\n\t\t\t\t<p class=\"form-control-static col-sm-9\" _v-3b104164=\"\">{{showStatus}}</p>\n\t\t\t</div>\n\n\t\t\t<button type=\"button\" class=\"btn btn-primary btn-lg btn-block btn-submit-admission\" @click.prevent=\"submit\" _v-3b104164=\"\">出場</button>\n\t\t</form>\n\t</template>\n</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n\t.timing[_v-3b104164] {\n\t    padding: 3px;\n\t    border: 1px solid;\n\t    background: #eee;\n\t}\n\t.btn-submit-admission[_v-3b104164] {\n    \tmargin-top: 15px;\n\t}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-3b104164", module.exports)
  } else {
    hotAPI.update("_v-3b104164", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1008:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _preview = require('./preview.vue');

var _preview2 = _interopRequireDefault(_preview);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//Page
_vue2.default.component('preview-agree-term', _preview2.default);

},{"./preview.vue":1009,"vue":792}],1009:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.vue-agree-term[_v-51e9727b] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  height: 100vh;\n  background-color: #f6f7f8; }\n  /* line 7, stdin */\n  .vue-agree-term .term-container[_v-51e9727b] {\n    position: relative;\n    overflow: overlay;\n    background: white;\n    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.19);\n    background-color: #ffffff;\n    max-width: 960px;\n    width: 100%;\n    margin: 20px;\n    padding: 30px; }\n  /* line 18, stdin */\n  .vue-agree-term .download[_v-51e9727b] {\n    width: 900px;\n    margin: 0 auto; }\n    /* line 22, stdin */\n    .vue-agree-term .download button[_v-51e9727b] {\n      position: fixed;\n      bottom: 50px;\n      margin-left: 750px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            ajaxing: false,
            ajaxing_download: false,
            term_content: '',
            signature: '',
            signature_watermark: '',
            postData: {
                password: null,
                password_confirmation: null
            }
        };
    },
    mounted: function mounted() {
        this.fetchTermPreview();
        $('#download-modal').on('shown.bs.modal', function () {
            this.postData = {
                password: null,
                password_confirmation: null
            };
        });
    },

    watch: {},
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        OutputMemberApprovalTerm: function OutputMemberApprovalTerm(state) {
            return state.webadmin.configure.webFunctions.WebadminMemberApprovalTermOutput;
        }
    }), (0, _vuex.mapState)('webadmin/configure', ['isSeventeen']), {
        signaturePic: function signaturePic() {
            if (this.signature) {
                return this.signature;
            } else {
                return '/images/broken_image.png';
            };
        },
        showSignature: function showSignature() {
            if (this.isSeventeen) {
                return true;
            } else {
                var query = $17.getUrlQueryStrings();
                return query.hasOwnProperty('mode') && query.mode === 'download';
            }
        },
        signatureWatermark: function signatureWatermark() {
            return this.signature_watermark ? this.signature_watermark : '/images/broken_image.png';
        },
        termId: function termId() {
            return window.location.pathname.split("/")[2];
        }
    }),
    methods: {
        setPwd: function setPwd() {
            this.postData = {
                password: null,
                password_confirmation: null
            };
            $('#download-modal').modal('show');
        },
        dataURItoBlob: function dataURItoBlob(dataURI) {
            var byteString = window.atob(dataURI);
            var arrayBuffer = new ArrayBuffer(byteString.length);
            var int8Array = new Uint8Array(arrayBuffer);
            for (var i = 0; i < byteString.length; i++) {
                int8Array[i] = byteString.charCodeAt(i);
            }
            var blob = new Blob([int8Array], { type: 'application/pdf' });
            return blob;
        },
        download: function download() {
            var _this = this;

            if (this.ajaxing_download) return;
            this.ajaxing_download = true;
            this.$http.post('/adminapi/approval-term/member/download/' + this.termId, this.postData).then(function (response) {
                var data = response.data;
                var pdfString = data.value;
                var fileName = data.name + '.pdf';

                var linkSource = 'data:application/pdf;base64,' + pdfString;
                var downloadLink = document.createElement("a");
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();

                $('#download-modal').modal('hide');
                _this.ajaxing_download = false;
            }).catch(function (error) {
                $17.swal({
                    title: '發生錯誤',
                    text: error.data.message,
                    type: 'error',
                    showCancelButton: false
                });
                _this.ajaxing_download = false;
            });
        },
        fetchTermPreview: function fetchTermPreview() {
            var _this2 = this;

            this.ajaxing = true;
            this.$http.get('/adminapi/approval-term/member/view/' + this.termId).then(function (response) {
                _this2.term_content = response.data.content;
                _this2.signature = response.data.signature_pic;
                _this2.signature_watermark = response.data.signature_watermark;
                _this2.ajaxing = false;
            }).catch(function (error) {
                _this2.ajaxing = false;
                $17.swal({
                    title: '發生錯誤',
                    text: error.data.message,
                    type: 'error',
                    showCancelButton: false
                });
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-51e9727b=\"\">\n    <div class=\"vue-agree-term\" _v-51e9727b=\"\">\n        <v-spinner :ajaxing=\"ajaxing\" id=\"v-spinner\" _v-51e9727b=\"\"></v-spinner>\n        <div class=\"term-container\" v-show=\"!ajaxing\" _v-51e9727b=\"\">\n            <div v-if=\"OutputMemberApprovalTerm\" _v-51e9727b=\"\">\n                <div v-html=\"term_content\" _v-51e9727b=\"\"></div>\n                <div class=\"m-top-70 m-bottom-80\" v-if=\"showSignature\" _v-51e9727b=\"\">\n                    <hr _v-51e9727b=\"\">\n                    <div class=\"text-right\" _v-51e9727b=\"\">\n                        <img v-if=\"isSeventeen\" :src=\"signaturePic\" alt=\"簽名\" width=\"300\" _v-51e9727b=\"\">\n                        <img v-else=\"\" :src=\"signatureWatermark\" alt=\"浮水印簽名\" width=\"300\" _v-51e9727b=\"\">\n                    </div>\n                </div>\n                <div class=\"download\" _v-51e9727b=\"\">\n                    <button v-if=\"showSignature\" @click=\"setPwd\" class=\"btn btn-primary\" _v-51e9727b=\"\"><i class=\"fa fa-download\" _v-51e9727b=\"\"></i> 加密並下載PDF</button>\n                </div>\n            </div>\n            <h1 v-else=\"\" class=\"text-center\" _v-51e9727b=\"\">您沒有權限</h1>\n        </div>\n    </div>\n\n    <v-modal id=\"download-modal\" no-cancel=\"\" data-backdrop=\"static\" confirm-btn-text=\"下載\" :save-clicked=\"download\" _v-51e9727b=\"\">\n        <h4 slot=\"title\" _v-51e9727b=\"\">設定 PDF 密碼</h4>\n        <div slot=\"body\" _v-51e9727b=\"\">\n            <v-spinner :ajaxing=\"ajaxing_download\" _v-51e9727b=\"\"></v-spinner>\n            <div class=\"row\" v-show=\"!ajaxing_download\" _v-51e9727b=\"\">\n                <div class=\"col-sm-12\" _v-51e9727b=\"\">\n                    <div class=\"form-group\" _v-51e9727b=\"\">\n                        <label class=\"col-sm-4 control-label p-t-0\" _v-51e9727b=\"\">PDF 密碼</label>\n                        <div class=\"col-sm-8\" _v-51e9727b=\"\">\n                            <input type=\"password\" required=\"\" class=\"form-control w-100 d-inline\" placeholder=\"請設定密碼\" v-model.trim=\"postData.password\" _v-51e9727b=\"\">\n                        </div>\n                    </div>\n                </div>\n                <div class=\"col-sm-12 m-top-20\" _v-51e9727b=\"\">\n                    <div class=\"form-group\" _v-51e9727b=\"\">\n                        <label class=\"col-sm-4 control-label p-t-0\" _v-51e9727b=\"\">PDF 密碼再確認</label>\n                        <div class=\"col-sm-8\" _v-51e9727b=\"\">\n                            <input type=\"password\" required=\"\" class=\"form-control w-100 d-inline\" placeholder=\"請再次輸入設定密碼\" v-model.trim=\"postData.password_confirmation\" _v-51e9727b=\"\">\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </v-modal>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.vue-agree-term[_v-51e9727b] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  height: 100vh;\n  background-color: #f6f7f8; }\n  /* line 7, stdin */\n  .vue-agree-term .term-container[_v-51e9727b] {\n    position: relative;\n    overflow: overlay;\n    background: white;\n    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.19);\n    background-color: #ffffff;\n    max-width: 960px;\n    width: 100%;\n    margin: 20px;\n    padding: 30px; }\n  /* line 18, stdin */\n  .vue-agree-term .download[_v-51e9727b] {\n    width: 900px;\n    margin: 0 auto; }\n    /* line 22, stdin */\n    .vue-agree-term .download button[_v-51e9727b] {\n      position: fixed;\n      bottom: 50px;\n      margin-left: 750px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-51e9727b", module.exports)
  } else {
    hotAPI.update("_v-51e9727b", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1010:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _list = require('./list.vue');

var _list2 = _interopRequireDefault(_list);

var _modal = require('./modal.vue');

var _modal2 = _interopRequireDefault(_modal);

var _parameterSelector = require('./parameter-selector.vue');

var _parameterSelector2 = _interopRequireDefault(_parameterSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('webadmin-approval-term-list', _list2.default);
_vue2.default.component('webadmin-approval-term-modal', _modal2.default);
_vue2.default.component('webadmin-approval-term-parameter-selector', _parameterSelector2.default);

},{"./list.vue":1011,"./modal.vue":1012,"./parameter-selector.vue":1013,"vue":792}],1011:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.btn-success[_v-536da1ba], .btn-default[_v-536da1ba] {\n  margin-bottom: 15px; }\n\n/* line 5, stdin */\n.not_published[_v-536da1ba] {\n  color: red; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            pageData: {},
            ajaxing: false,
            pageMeta: {},
            id: null
        };
    },
    created: function created() {},
    watch: {
        ACTIVE_STUDIO_ID: function ACTIVE_STUDIO_ID(newVal) {
            if (newVal) {
                this.changed();
            }
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('webadmin/configure', ['ACTIVE_STUDIO_ID', 'ACTIVE_BRANCH_ID']), (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId', 'isBranch']), (0, _vuex.mapState)('filters', ['selected_studio_id', 'selected_branch_id', 'updateQueryStrings'])),
    methods: {
        showModal: function showModal(item) {
            $('#approval-term-modal').modal('show');
        },
        changed: function changed() {
            var _this = this;

            var branch_id = this.selected_branch_id;
            if (this.selected_branch_id === null || this.selected_branch_id === 'null') {
                branch_id = '';
            }
            var params = {
                owner: [{
                    owner_type: 'studio',
                    owner_id: this.ACTIVE_STUDIO_ID
                }],
                page: this.getUrlParamValue('page') ? this.getUrlParamValue('page') : 1
            };

            this.ajaxing = true;
            this.$http.get('/adminapi/approval-term/list', { params: params }).then(function (response) {
                _this.ajaxing = false;
                _this.pageData = response.data.pageData;
                _this.pageMeta = response.data.pageMeta;
            }, function (error) {
                _this.ajaxing = false;
            });
        },
        setUpdateId: function setUpdateId(id) {
            this.id = id;
            this.showModal();
        },
        refresh: function refresh() {
            this.id = null;
            this.changed();
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"container\" _v-536da1ba=\"\">\n    <div class=\"row\" _v-536da1ba=\"\">\n        <div class=\"col-sm-6\" _v-536da1ba=\"\">\n            <a type=\"button\" class=\"btn btn-success\" @click.stop.prevent=\"showModal\" _v-536da1ba=\"\">\n                <i class=\"fa fa-plus\" aria-hidden=\"true\" _v-536da1ba=\"\"></i>新增條款\n            </a>\n            <a type=\"button\" class=\"btn btn-default\" target=\"_blank\" href=\"/webadmin/dynamic-parameter/list\" _v-536da1ba=\"\">\n                自訂參數代碼\n            </a>\n        </div>\n    </div>\n    <div class=\"row\" _v-536da1ba=\"\">\n        <div class=\"col-sm-6\" _v-536da1ba=\"\">\n            <v-multiselect-studio-and-branch :studio_id=\"studioId\" :show-branch=\"false\" _v-536da1ba=\"\"></v-multiselect-studio-and-branch>\n        </div>\n    </div>\n    <div class=\"text-center\" _v-536da1ba=\"\">\n\n        <v-spinner :ajaxing=\"ajaxing\" _v-536da1ba=\"\">\n\n        </v-spinner>\n\n        <table v-show=\"!ajaxing\" class=\"table pagin-table\" _v-536da1ba=\"\">\n            <thead _v-536da1ba=\"\">\n                <tr _v-536da1ba=\"\">\n                    <th _v-536da1ba=\"\">條款名稱</th>\n                    <th _v-536da1ba=\"\">場館</th>\n                    <th _v-536da1ba=\"\">狀態</th>\n                    <th _v-536da1ba=\"\">發佈</th>\n                    <th _v-536da1ba=\"\">動作</th>\n                </tr>\n            </thead>\n\n            <tbody align=\"left\" _v-536da1ba=\"\">\n                <tr v-for=\"item in pageData\" _v-536da1ba=\"\">\n                    <td _v-536da1ba=\"\">{{item.name}}</td>\n                    <td _v-536da1ba=\"\">不限館別</td>\n                    <td _v-536da1ba=\"\">\n                        <span v-if=\"item.is_active\" _v-536da1ba=\"\">\n                            啟用\n                        </span>\n                        <span v-else=\"\" _v-536da1ba=\"\">\n                            停用\n                        </span>\n                    </td>\n                    <td _v-536da1ba=\"\">\n                        <span v-if=\"item.is_published\" _v-536da1ba=\"\">\n                            已發佈\n                        </span>\n                        <span v-else=\"\" class=\"not_published\" _v-536da1ba=\"\">\n                            未發佈\n                        </span>\n                    </td>\n                    <td _v-536da1ba=\"\">\n                        <a @click.stop.prevent=\"setUpdateId(item.id)\" _v-536da1ba=\"\">編輯</a>\n                    </td>\n                </tr>\n            </tbody>\n        </table>\n    </div>\n    <v-sql-pagination v-show=\"!ajaxing\" ref=\"pager\" :page-meta=\"pageMeta\" @page-change-callback=\"changed\" _v-536da1ba=\"\">\n    </v-sql-pagination>\n    <webadmin-approval-term-modal :id=\"id\" owner-type=\"studio\" :owner-id=\"ACTIVE_STUDIO_ID\" @refresh=\"refresh\" _v-536da1ba=\"\"></webadmin-approval-term-modal>\n</div>    \n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.btn-success[_v-536da1ba], .btn-default[_v-536da1ba] {\n  margin-bottom: 15px; }\n\n/* line 5, stdin */\n.not_published[_v-536da1ba] {\n  color: red; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-536da1ba", module.exports)
  } else {
    hotAPI.update("_v-536da1ba", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1012:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.right-options[_v-319cfc7e] {\n  height: 80vh;\n  overflow-y: auto; }\n\n/* line 6, stdin */\n.dropdown-menu[_v-319cfc7e] {\n  width: 200px; }\n\n/* line 9, stdin */\n.disabled-button[_v-319cfc7e] {\n  background-color: #bdbdbd;\n  color: #fff; }\n\n/* line 3, stdin */\n.ckeditor-approval .ck-editor__editable_inline {\n  height: 60vh; }\n\n/* line 6, stdin */\n.ckeditor-approval .ck.ck-editor__main > .ck-editor__editable.ck-read-only {\n  background-color: #efefef; }\n\n/* line 10, stdin */\n.append-parameter {\n  margin-bottom: 22px; }\n")
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: (0, _defineProperty3.default)({
    id: {
      type: Number,
      default: null
    },
    ownerType: {
      type: String,
      default: null
    },
    ownerId: {
      type: Number,
      default: null
    }
  }, "id", {
    type: Number,
    default: null
  }),
  data: function data() {
    return {
      studio_id: 0,
      view: {
        ajaxing: false
      },
      model: {
        content: "",
        name: "",
        is_published: 0,
        is_active: 1
      },
      parameters: [],
      selectedParas: [],
      selectedParasOrigin: [],
      appendParameterMode: false,
      savingEditorData: false,
      approveTermList: []
    };
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      $('[data-toggle="popover"]').popover();
      var vm = this;
      $('#approval-term-modal').on('shown.bs.modal', function () {
        vm.getParameter();
      });
    });
  },

  created: function created() {},
  watch: {
    id: function id(newVal) {
      this.resetForm();
      if (!newVal) {
        return;
      }
      this.show();
    },
    ownerId: function ownerId() {
      this.getParameter();
    }
  },
  computed: {
    title: function title() {
      return this.createMode ? "新增條款" : "編輯條款";
    },
    currentParameters: function currentParameters() {
      return this.selectedParas.reduce(function (carry, item) {
        carry.push(item.dynamic_parameter_id);
        return carry;
      }, []);
    },
    notSelectedParameters: function notSelectedParameters() {
      var _this = this;

      return this.parameters.filter(function (item) {
        return _this.currentParameters.indexOf(item.id) == -1;
      });
    },
    createMode: function createMode() {
      return !this.id;
    },
    published: function published() {
      return this.model.is_published;
    },
    checkCreateSuccess: function checkCreateSuccess() {
      return this.model.name.length > 0 && this.model.content.length > 0;
    }
  },
  methods: {
    getParameter: function getParameter() {
      var _this2 = this;

      if (!this.ownerId) {
        return;
      }
      this.view.ajaxing = true;
      var params = {
        owner_type: this.ownerType,
        owner_id: this.ownerId
      };
      this.$http.get("/adminapi/dynamic-parameter/usable-list", { params: params }).then(function (response) {
        _this2.parameters = response.data;
        _lodash2.default.delay(function () {
          _this2.view.ajaxing = false;
        }, 400);
      }, function (error) {
        $17.swal({
          title: error.body.message,
          type: "warning"
        });
        _this2.view.ajaxing = false;
      });
    },
    getEditorDataAndSave: function getEditorDataAndSave(data) {
      this.model.content = data;
    },
    watchCkEditor: function watchCkEditor(data) {
      this.model.content = data;
    },
    fetchTermsData: function fetchTermsData() {
      var _this3 = this;

      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this3.$http.get('/adminapi/user-interface-layout-setting/approve-term/get/' + _this3.ownerId).then(function (response) {
                  _this3.approveTermList = response.data.result;
                }).catch(function (error) {
                  $17.swal({
                    type: 'error',
                    title: '取得資料錯誤',
                    text: error.data.error,
                    showCancelButton: false
                  });
                  _this3.view.ajaxing = false;
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    show: function show() {
      var _this4 = this;

      this.view.ajaxing = true;
      this.$http.get('/adminapi/approval-term/update/' + this.id).then(function (response) {
        _this4.model = response.data.term;
        _this4.selectedParas = JSON.parse((0, _stringify2.default)(response.data.parameters));
        _this4.selectedParasOrigin = JSON.parse((0, _stringify2.default)(response.data.parameters));
        _lodash2.default.delay(function () {
          _this4.view.ajaxing = false;
        }, 400);
      }, function (error) {
        $17.swal({
          title: error.body.message,
          type: 'warning'
        });
        _this4.view.ajaxing = false;
      });
    },
    creating: function creating() {
      var _this5 = this;

      this.savingEditorData = true;
      this.view.ajaxing = true;
      var data = this.model;

      data.owner_type = this.ownerType;
      data.owner_id = this.ownerId;
      data.parameters = this.selectedParas;
      this.$http.post('/adminapi/approval-term/create', data).then(function (response) {
        _this5.view.ajaxing = false;
        $17.swal({
          title: '條款新增成功',
          type: "success",
          showCancelButton: false
        });
        $('#approval-term-modal').modal('hide');
        _this5.refresh();
      }, function (error) {
        $17.swal({
          title: error.body.message,
          type: 'warning',
          showCancelButton: false
        });
        _this5.view.ajaxing = false;
      });
    },
    updatCheck: function updatCheck() {
      var _this6 = this;

      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this6.view.ajaxing = true;

                if (!_this6.model.is_active) {
                  _context2.next = 4;
                  break;
                }

                _this6.updating();
                return _context2.abrupt("return");

              case 4:
                _context2.next = 6;
                return _this6.fetchTermsData();

              case 6:
                if (!(_this6.approveTermList.approval_term_id != _this6.id)) {
                  _context2.next = 9;
                  break;
                }

                _this6.updating();
                return _context2.abrupt("return");

              case 9:
                $17.swal({
                  title: '停用同意條款？',
                  text: '此條款為客戶在線上購買方案時，需同意的條款',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: '停用',
                  cancelButtonText: '取消'
                }, function (isConfirm) {
                  if (isConfirm) {
                    _this6.updating();
                  } else {
                    _this6.view.ajaxing = false;
                  }
                });

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this6);
      }))();
    },
    updating: function updating() {
      var _this7 = this;

      this.savingEditorData = true;
      var data = this.model;

      data.owner_type = this.ownerType;
      data.owner_id = this.ownerId;
      data.parameters = this.selectedParas;
      this.$http.post('/adminapi/approval-term/update/' + this.id, data).then(function (response) {
        _this7.view.ajaxing = false;
        $17.swal({
          title: '條款修改成功',
          type: "success",
          showCancelButton: false
        });
        $('#approval-term-modal').modal('hide');
        _this7.refresh();
      }, function (error) {
        $17.swal({
          title: error.body.message,
          type: 'warning',
          showCancelButton: false
        });
        _this7.view.ajaxing = false;
      });
    },
    publishing: function publishing() {
      var _this8 = this;

      $17.swal({
        title: '發佈後無法編輯',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: '確定',
        cancelButtonText: '取消'
      }, function (isConfirm) {
        if (isConfirm) {
          _this8.model.is_published = 1;
          _this8.updatCheck();
        }
      });
    },
    refresh: function refresh() {
      this.resetForm();
      this.$emit('refresh');
    },
    resetForm: function resetForm() {
      this.view.ajaxing = false;
      this.savingEditorData = false;
      this.model = {
        content: "",
        name: "",
        is_published: 0,
        is_active: 0
      };
      this.selectedParas = [];
    },
    appendParameter: function appendParameter(option) {
      this.selectedParas.push(this.convertParameter(option));
      this.appendParameterMode = false;
    },
    convertParameter: function convertParameter(option) {
      return {
        id: option.id,
        dynamic_parameter_id: option.id,
        identity_code_full: option.identity_code_full,
        name: option.name,
        display_name: option.display_name ? option.display_name : '',
        data_input_required: option.data_input_required ? option.data_input_required : '',
        data_input_disabled: option.data_input_disabled ? option.data_input_disabled : ''
      };
    },
    updateParameter: function updateParameter(parameter) {
      this.selectedParas = this.selectedParas.map(function (selected) {
        if (selected.dynamic_parameter_id == parameter.dynamic_parameter_id) {
          return parameter;
        }
        return selected;
      });
    },
    removeParameter: function removeParameter(parameter) {
      this.selectedParas = this.selectedParas.filter(function (selected) {
        if (selected.dynamic_parameter_id == parameter.dynamic_parameter_id) {
          return false;
        }
        return true;
      });
    },
    resetToOriginParameter: function resetToOriginParameter(parameter) {
      this.selectedParas = this.selectedParas.map(function (selected) {
        if (selected.dynamic_parameter_id == parameter.dynamic_parameter_id) {
          return origin;
        }
        return selected;
      });
    }
  }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal id=\"approval-term-modal\" :close-modal-event=\"refresh\" no-footer=\"\" no-border-radius=\"\" open-size=\"modal-lg\" :block-hide-without-close=\"true\" _v-319cfc7e=\"\">\n  <div slot=\"title\" _v-319cfc7e=\"\">{{ title }}</div>\n  <div slot=\"body\" _v-319cfc7e=\"\">\n    <v-spinner :ajaxing=\"view.ajaxing\" _v-319cfc7e=\"\"></v-spinner>\n    <div class=\"row\" v-show=\"!view.ajaxing\" _v-319cfc7e=\"\">\n      <div class=\"col-sm-9 col-xs-12\" _v-319cfc7e=\"\">\n        <div _v-319cfc7e=\"\">\n          <div class=\"clearfix m-top-10\" _v-319cfc7e=\"\">\n            <div class=\"clearfix\" _v-319cfc7e=\"\">\n              <label class=\"col-lg-2 col-md-2 col-xs-12 p-top-5 require\" for=\"name\" _v-319cfc7e=\"\">條款名稱\n                <v-required _v-319cfc7e=\"\"></v-required>\n              </label>\n              <div class=\"col-lg-10 col-md-10 col-xs-12\" _v-319cfc7e=\"\">\n                <input name=\"name\" v-model=\"model.name\" class=\"form-control\" type=\"text\" placeholder=\"請輸入條款名稱\" _v-319cfc7e=\"\">\n              </div>\n            </div>\n          </div>\n        </div>\n        <div _v-319cfc7e=\"\">\n          <div class=\"clearfix m-top-10\" _v-319cfc7e=\"\">\n            <div class=\"clearfix\" _v-319cfc7e=\"\">\n              <label class=\"col-lg-2 col-md-2 col-xs-12 p-top-5 require\" for=\"name\" _v-319cfc7e=\"\">內容\n                <v-required _v-319cfc7e=\"\"></v-required>\n              </label>\n              <div class=\"col-lg-10 col-md-10 col-xs-12 ckeditor-approval\" _v-319cfc7e=\"\">\n                <ck-editor :click-save=\"savingEditorData\" :init-editor-data=\"model.content\" @update-ck-editor-data=\"getEditorDataAndSave\" @watch-ck-editor=\"watchCkEditor\" :disabled=\"(published)?true:false\" placeholder=\"輸入內容\" :toolbar=\"[&quot;heading&quot;,&quot;bold&quot;, &quot;italic&quot;, &quot;blockQuote&quot;,&quot;numberedList&quot;, &quot;bulletedList&quot;]\" _v-319cfc7e=\"\"></ck-editor>\n              </div>\n\n            </div>\n          </div>\n        </div>\n        <div _v-319cfc7e=\"\">\n          <div class=\"clearfix m-top-10\" v-show=\"!createMode\" _v-319cfc7e=\"\">\n              <div class=\"clearfix\" _v-319cfc7e=\"\">\n                  <label class=\"col-lg-2 col-md-2 col-xs-12 p-top-5 require\" for=\"name\" _v-319cfc7e=\"\">狀態\n                  </label>\n                  <div class=\"col-lg-10 col-md-10 col-xs-12 p-top-5\" _v-319cfc7e=\"\">\n                      <input id=\"active\" v-model=\"model.is_active\" type=\"radio\" :value=\"1\" _v-319cfc7e=\"\">\n                      <label for=\"active\" _v-319cfc7e=\"\">啟用\n                      </label>\n                      <input id=\"stop\" v-model=\"model.is_active\" type=\"radio\" :value=\"0\" _v-319cfc7e=\"\">\n                      <label for=\"stop\" _v-319cfc7e=\"\">停用\n                      </label>\n                  </div>\n              </div>\n          </div>\n        </div>\n        <div class=\"text-right m-top-10 m-right-5\" _v-319cfc7e=\"\">\n          <button class=\"btn\" v-if=\"createMode\" @click=\"creating\" v-show=\"!view.ajaxing\" :disabled=\"!checkCreateSuccess\" v-bind:class=\"{ 'disabled-button': !checkCreateSuccess, 'btn-primary': checkCreateSuccess }\" _v-319cfc7e=\"\">\n            新增\n          </button>\n          <button class=\"btn\" v-if=\"!createMode\" @click=\"updatCheck\" v-show=\"!view.ajaxing\" :disabled=\"!checkCreateSuccess\" v-bind:class=\"{ 'disabled-button': !checkCreateSuccess, 'btn-primary': checkCreateSuccess }\" _v-319cfc7e=\"\">\n            儲存\n          </button>\n          <button class=\"btn\" v-if=\"!createMode &amp;&amp; !published\" @click=\"publishing()\" :disabled=\"!checkCreateSuccess\" v-show=\"!view.ajaxing\" v-bind:class=\"{ 'disabled-button': !checkCreateSuccess, 'btn-success': checkCreateSuccess }\" _v-319cfc7e=\"\">\n            發佈\n          </button>\n        </div>\n      </div>\n      <div class=\"col-sm-3 col-xs-12 right-options p-right-30\" _v-319cfc7e=\"\">\n        <div class=\"row\" _v-319cfc7e=\"\">\n          <div class=\"col-xs-8\" _v-319cfc7e=\"\">\n            參數代碼\n            <a href=\"https://17fithelp.zendesk.com/hc/zh-tw/articles/900005250303\" target=\"_blank\" _v-319cfc7e=\"\">\n              <i class=\"fa fa-question-circle\" aria-hidden=\"true\" _v-319cfc7e=\"\"></i>\n            </a>\n          </div>\n        </div>\n        <div class=\"row\" v-if=\"!published\" _v-319cfc7e=\"\">\n          <div class=\"col-xs-12 append-parameter\" _v-319cfc7e=\"\">\n            <v-mutiselect :options=\"notSelectedParameters\" :close-on-select=\"true\" :searchable=\"true\" :select-event-append=\"appendParameter\" :reset-after=\"true\" placeholder=\"新增參數代碼\" label=\"name\" track-by=\"id\" _v-319cfc7e=\"\"></v-mutiselect>\n          </div>\n        </div>\n        <webadmin-approval-term-parameter-selector v-for=\"parameter in selectedParas\" :published=\"published\" :parameter=\"parameter\" @update=\"updateParameter\" @remove=\"removeParameter\" @reset=\"resetToOriginParameter\" _v-319cfc7e=\"\"></webadmin-approval-term-parameter-selector>\n      </div>\n    </div>\n  </div>\n</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.right-options[_v-319cfc7e] {\n  height: 80vh;\n  overflow-y: auto; }\n\n/* line 6, stdin */\n.dropdown-menu[_v-319cfc7e] {\n  width: 200px; }\n\n/* line 9, stdin */\n.disabled-button[_v-319cfc7e] {\n  background-color: #bdbdbd;\n  color: #fff; }\n\n/* line 3, stdin */\n.ckeditor-approval .ck-editor__editable_inline {\n  height: 60vh; }\n\n/* line 6, stdin */\n.ckeditor-approval .ck.ck-editor__main > .ck-editor__editable.ck-read-only {\n  background-color: #efefef; }\n\n/* line 10, stdin */\n.append-parameter {\n  margin-bottom: 22px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-319cfc7e", module.exports)
  } else {
    hotAPI.update("_v-319cfc7e", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/json/stringify":48,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/defineProperty":65,"babel-runtime/regenerator":75,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1013:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.identity_code_full[_v-6ffdd11f] {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  width: 90px;\n  color: #d4d4d4; }\n  @media (max-width: 575.98px) {\n    /* line 2, stdin */\n    .identity_code_full[_v-6ffdd11f] {\n      width: 145px; } }\n\n/* line 12, stdin */\n.nest-border[_v-6ffdd11f] {\n  border: solid 1px #d4d4d4;\n  margin-left: 0px;\n  margin-right: 0px;\n  margin-bottom: 14px; }\n  /* line 17, stdin */\n  .nest-border label[_v-6ffdd11f] {\n    margin-bottom: 0;\n    margin-top: 3px; }\n\n/* line 22, stdin */\n.dropdown-menu[_v-6ffdd11f] {\n  right: -25px;\n  left: auto;\n  padding: 10px;\n  width: 205px;\n  margin-top: 15px; }\n\n/* line 29, stdin */\n.setting[_v-6ffdd11f] {\n  font-weight: bold; }\n\n/* line 32, stdin */\n.copy[_v-6ffdd11f] {\n  overflow: hidden;\n  white-space: nowrap; }\n\n/* line 36, stdin */\n.gray-btn[_v-6ffdd11f] {\n  color: #fff;\n  background-color: #c4c4c4; }\n")
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    parameter: {
      type: Object,
      default: {}
    },
    published: {}
  },
  mounted: function mounted() {
    this.parameterSelf = JSON.parse((0, _stringify2.default)(this.parameter));
    this.parameterDefault = JSON.parse((0, _stringify2.default)(this.parameter));
    if (!this.parameterSelf.display_name) {
      this.parameterSelf.display_name = this.parameterSelf.name;
    }
    if (!this.parameterDefault.display_name) {
      this.parameterDefault.display_name = this.parameterDefault.name;
    }
  },
  data: function data() {
    return {
      parameterSelf: {},
      parameterDefault: {}
    };
  },

  watch: {
    parameter: {
      handler: function handler(newVal) {
        this.parameterSelf = JSON.parse((0, _stringify2.default)(newVal));
        if (!newVal.display_name) {
          this.parameterSelf.display_name = newVal.name;
        }
      },
      deep: true
    }
  },
  computed: {},
  methods: {
    save: function save() {
      this.$emit("update", this.parameterSelf);
      this.close();
    },
    remove: function remove() {
      this.$emit("remove", this.parameter);
      this.close();
    },
    close: function close() {
      $('[data-toggle="dropdown"]').parent().removeClass("open");
    },
    copyText: function copyText(code) {
      navigator.clipboard.writeText(code);
      $.notify('已複製代碼', { className: 'success', globalPosition: 'top center', autoHideDelay: 2000 });
    },
    reset: function reset() {
      this.parameterSelf = JSON.parse((0, _stringify2.default)(this.parameterDefault));
      this.$emit("update", this.parameterSelf);
      this.close();
    }
  }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-6ffdd11f=\"\">\n  <div class=\"row\" _v-6ffdd11f=\"\">\n    <div class=\"col-xs-12\" _v-6ffdd11f=\"\">\n      <div class=\"input-group\" _v-6ffdd11f=\"\">\n        <input type=\"text\" class=\"form-control\" :value=\"parameterSelf.name\" :aria-describedby=\"\n            'basic-addon' + parameterSelf.dynamic_parameter_id\n          \" disabled=\"\" value=\"\" style=\"background-color: #fff;\" _v-6ffdd11f=\"\">\n        <span v-if=\"!published\" class=\"input-group-addon\" :id=\"'basic-addon' + parameterSelf.dynamic_parameter_id\" _v-6ffdd11f=\"\">\n          <div class=\"dropdown\" _v-6ffdd11f=\"\">\n            <span class=\"dropdown-toggle\" type=\"button\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" style=\"cursor: pointer;\" _v-6ffdd11f=\"\">\n              <i class=\"fa fa-cog\" aria-hidden=\"true\" _v-6ffdd11f=\"\"></i>\n            </span>\n            <div class=\"dropdown-menu\" @click.stop=\"\" aria-labelledby=\"dropdownMenuButton\" _v-6ffdd11f=\"\">\n              <div class=\"\" _v-6ffdd11f=\"\">\n                <div class=\"row\" _v-6ffdd11f=\"\">\n                  <div class=\"col-xs-6\" _v-6ffdd11f=\"\">\n                    <label for=\"\" class=\"setting\" _v-6ffdd11f=\"\"> 設定 </label>\n                  </div>\n                  <div class=\"col-xs-6 text-right\" _v-6ffdd11f=\"\">\n                    <label class=\"\" _v-6ffdd11f=\"\">\n                      <a @click.stop.prevent=\"copyText(parameterSelf.identity_code_full)\" class=\"copy\" _v-6ffdd11f=\"\">複製代碼</a>\n                    </label>\n                  </div>\n                </div>\n                <div class=\"row m-top-10 m-bottom-10\" _v-6ffdd11f=\"\">\n                  <div class=\"col-xs-12\" _v-6ffdd11f=\"\">\n                    <input type=\"checkbox\" name=\"\" :id=\"'para-' + parameterSelf.dynamic_parameter_id\" v-model=\"parameterSelf.data_input_required\" :true-value=\"1\" :false-value=\"0\" _v-6ffdd11f=\"\">\n                    <label :for=\"'para-' + parameterSelf.dynamic_parameter_id\" _v-6ffdd11f=\"\">\n                      必填\n                    </label>\n                  </div>\n                </div>\n                <div class=\"row\" _v-6ffdd11f=\"\">\n                  <div class=\"col-xs-12\" _v-6ffdd11f=\"\">\n                    <input type=\"text\" name=\"\" class=\"form-control\" placeholder=\"自訂參數代碼名稱\" v-model=\"parameterSelf.display_name\" _v-6ffdd11f=\"\">\n                  </div>\n                </div>\n                <div class=\"row text-right m-top-10 p-right-30\" _v-6ffdd11f=\"\">\n                  <div class=\"col-xs-12\" _v-6ffdd11f=\"\">\n                    <a href=\"\" class=\"btn btn-default\" @click.prevent.stop=\"remove\" _v-6ffdd11f=\"\">\n                      <i class=\"fa fa-trash\" aria-hidden=\"true\" style=\"color:red\" _v-6ffdd11f=\"\"></i>\n                    </a>\n                    <a href=\"\" class=\"btn btn-primary\" @click.prevent.stop=\"save\" _v-6ffdd11f=\"\">\n                      確定\n                    </a>\n                    <a href=\"\" class=\"btn btn-default gray-btn\" @click.prevent.stop=\"reset\" _v-6ffdd11f=\"\">\n                      重置\n                    </a>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </span>\n      </div>\n    </div>\n  </div>\n  <div class=\"row nest-border \" _v-6ffdd11f=\"\">\n    <div class=\"col-xs-6\" _v-6ffdd11f=\"\">\n      <div class=\"input-group\" _v-6ffdd11f=\"\">\n        <label class=\"identity_code_full\" _v-6ffdd11f=\"\">{{\n          parameterSelf.identity_code_full\n        }}</label>\n      </div>\n    </div>\n    <div class=\"col-xs-6 text-right \" _v-6ffdd11f=\"\">\n      <label class=\"\" v-show=\"!published\" _v-6ffdd11f=\"\">\n        <a @click.stop.prevent=\"copyText(parameterSelf.identity_code_full)\" class=\"copy\" _v-6ffdd11f=\"\">複製代碼</a>\n      </label>\n    </div>\n  </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.identity_code_full[_v-6ffdd11f] {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  width: 90px;\n  color: #d4d4d4; }\n  @media (max-width: 575.98px) {\n    /* line 2, stdin */\n    .identity_code_full[_v-6ffdd11f] {\n      width: 145px; } }\n\n/* line 12, stdin */\n.nest-border[_v-6ffdd11f] {\n  border: solid 1px #d4d4d4;\n  margin-left: 0px;\n  margin-right: 0px;\n  margin-bottom: 14px; }\n  /* line 17, stdin */\n  .nest-border label[_v-6ffdd11f] {\n    margin-bottom: 0;\n    margin-top: 3px; }\n\n/* line 22, stdin */\n.dropdown-menu[_v-6ffdd11f] {\n  right: -25px;\n  left: auto;\n  padding: 10px;\n  width: 205px;\n  margin-top: 15px; }\n\n/* line 29, stdin */\n.setting[_v-6ffdd11f] {\n  font-weight: bold; }\n\n/* line 32, stdin */\n.copy[_v-6ffdd11f] {\n  overflow: hidden;\n  white-space: nowrap; }\n\n/* line 36, stdin */\n.gray-btn[_v-6ffdd11f] {\n  color: #fff;\n  background-color: #c4c4c4; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-6ffdd11f", module.exports)
  } else {
    hotAPI.update("_v-6ffdd11f", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/json/stringify":48,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1014:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _setting = require('./setting.vue');

var _setting2 = _interopRequireDefault(_setting);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('bonus-setting', _setting2.default);

},{"./setting.vue":1015,"vue":792}],1015:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.inputs[_v-4ddae6ca] {\n  display: inline-block;\n  width: 80px; }\n\n/* line 8, stdin */\n.config-table th[_v-4ddae6ca], .config-table tr[_v-4ddae6ca], .config-table td[_v-4ddae6ca] {\n  border: 0; }\n\n/* line 13, stdin */\n.handler[_v-4ddae6ca] {\n  text-align: right;\n  width: 100px;\n  font-weight: bold; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            ajaxing: false,
            open_account_system: 0,
            account_system_id: 0,
            account_system_exchange_rate: 1,
            event_hooks: { //key=event_handler_type
                online_buy: {
                    show_front: 1,
                    is_enable: 0,
                    can_be_overwritten: 0,
                    items: { //key=judgement
                        every_dollars_DOLLARS: {
                            DOLLARS: 0,
                            point: 0,
                            start_after_days: 0,
                            valid_days: 365,
                            emitter_type: 'payment_source_record_categories',
                            emitter_id: 2 //線上
                        }
                    }
                },
                seventeen_buy: {
                    show_front: 1,
                    is_enable: 0,
                    can_be_overwritten: 0,
                    items: { //key=judgement
                        every_dollars_DOLLARS: {
                            DOLLARS: 0,
                            point: 0,
                            start_after_days: 0,
                            valid_days: 365,
                            emitter_type: 'payment_source_record_categories',
                            emitter_id: 3 //17fit
                        }
                    }
                },
                webadmin_buy: {
                    show_front: 1,
                    is_enable: 0,
                    can_be_overwritten: 0,
                    items: { //key=judgement
                        every_dollars_DOLLARS: {
                            DOLLARS: 0,
                            point: 0,
                            start_after_days: 0,
                            valid_days: 365,
                            emitter_type: 'payment_source_record_categories',
                            emitter_id: 1
                        }
                    }
                },
                online_booking_class: {
                    show_front: 1,
                    is_enable: 0,
                    can_be_overwritten: 0,
                    items: { //key=judgement
                        class_attend: {
                            point: 0,
                            start_after_days: 0,
                            valid_days: 365,
                            emitter_type: 'booking_source_record_categories',
                            emitter_id: 2 //線上
                        }
                    }
                },
                seventeen_booking_class: {
                    show_front: 1,
                    is_enable: 0,
                    can_be_overwritten: 0,
                    items: { //key=judgement
                        class_attend: {
                            point: 0,
                            start_after_days: 0,
                            valid_days: 365,
                            emitter_type: 'booking_source_record_categories',
                            emitter_id: 3 //線上
                        }
                    }
                },
                webadmin_booking_class: {
                    show_front: 1,
                    is_enable: 0,
                    can_be_overwritten: 0,
                    items: { //key=judgement
                        class_attend: {
                            point: 0,
                            start_after_days: 0,
                            valid_days: 365,
                            emitter_type: 'booking_source_record_categories',
                            emitter_id: 1 //線上
                        }
                    }
                },
                online_booking_service: {
                    show_front: 1,
                    is_enable: 0,
                    can_be_overwritten: 0,
                    items: { //key=judgement
                        service_attend: {
                            point: 0,
                            start_after_days: 0,
                            valid_days: 365,
                            emitter_type: 'booking_source_record_categories',
                            emitter_id: 2 //線上
                        }
                    }
                },
                seventeen_booking_service: {
                    show_front: 1,
                    is_enable: 0,
                    can_be_overwritten: 0,
                    items: { //key=judgement
                        service_attend: {
                            point: 0,
                            start_after_days: 0,
                            valid_days: 365,
                            emitter_type: 'booking_source_record_categories',
                            emitter_id: 3 //線上
                        }
                    }
                },
                webadmin_booking_service: {
                    show_front: 1,
                    is_enable: 0,
                    can_be_overwritten: 0,
                    items: { //key=judgement
                        service_attend: {
                            point: 0,
                            start_after_days: 0,
                            valid_days: 365,
                            emitter_type: 'booking_source_record_categories',
                            emitter_id: 1 //線上
                        }
                    }
                }
            }
        };
    },
    mounted: function mounted() {},

    watch: {
        branchId: function branchId(val) {
            this.getConfig();
        },
        'event_hooks.online_buy.is_enable': function event_hooksOnline_buyIs_enable(newV) {
            if (newV == 0) {
                this.event_hooks.online_buy.can_be_overwritten = 0;
            }
        },
        'event_hooks.seventeen_buy.is_enable': function event_hooksSeventeen_buyIs_enable(newV) {
            if (newV == 0) {
                this.event_hooks.seventeen_buy.can_be_overwritten = 0;
            }
        },
        'event_hooks.webadmin_buy.is_enable': function event_hooksWebadmin_buyIs_enable(newV) {
            if (newV == 0) {
                this.event_hooks.webadmin_buy.can_be_overwritten = 0;
            }
        },
        'event_hooks.online_booking_class.is_enable': function event_hooksOnline_booking_classIs_enable(newV) {
            if (newV == 0) {
                this.event_hooks.online_booking_class.can_be_overwritten = 0;
            }
        },
        'event_hooks.seventeen_booking_class.is_enable': function event_hooksSeventeen_booking_classIs_enable(newV) {
            if (newV == 0) {
                this.event_hooks.seventeen_booking_class.can_be_overwritten = 0;
            }
        },
        'event_hooks.webadmin_booking_class.is_enable': function event_hooksWebadmin_booking_classIs_enable(newV) {
            if (newV == 0) {
                this.event_hooks.webadmin_booking_class.can_be_overwritten = 0;
            }
        },
        'event_hooks.online_booking_service.is_enable': function event_hooksOnline_booking_serviceIs_enable(newV) {
            if (newV == 0) {
                this.event_hooks.online_booking_service.can_be_overwritten = 0;
            }
        },
        'event_hooks.seventeen_booking_service.is_enable': function event_hooksSeventeen_booking_serviceIs_enable(newV) {
            if (newV == 0) {
                this.event_hooks.seventeen_booking_service.can_be_overwritten = 0;
            }
        },
        'event_hooks.webadmin_booking_service.is_enable': function event_hooksWebadmin_booking_serviceIs_enable(newV) {
            if (newV == 0) {
                this.event_hooks.webadmin_booking_service.can_be_overwritten = 0;
            }
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId', 'isSeventeen', 'isStudio', 'isBranch']), (0, _vuex.mapState)({
        canUpdate: function canUpdate(state) {
            return state.webadmin.configure.webFunctions.WebadminBonusSetting;
        }
    }), {
        disabledSave: function disabledSave() {
            if (this.isBranch && this.open_account_system == 1) {
                return false;
            }

            if (this.isStudio && (this.account_system_id > 0 || this.account_system_id == 0 && this.open_account_system == 1)) {
                return false;
            }

            return true;
        }
    }),
    methods: {
        checkKeyPress: function checkKeyPress(e) {
            if (e.charCode === 46 || e.charCode === 45) {
                e.preventDefault();
            }
        },
        validate: function validate() {
            try {
                var msg = '';
                if (this.open_account_system) {
                    if (!this.account_system_exchange_rate || this.account_system_exchange_rate <= 0) {
                        msg += "匯率設定-必須大於0<br/>";
                    }
                    if (!/^(?=[^.])\d*(?:\.\d{0,2})?$/.test(this.account_system_exchange_rate)) {
                        msg += "匯率設定-僅接受小數點後兩位<br/>";
                    }
                    if (this.event_hooks.online_buy.is_enable) {
                        if (this.event_hooks.online_buy.items.every_dollars_DOLLARS.DOLLARS > 0 && this.isInt(this.event_hooks.online_buy.items.every_dollars_DOLLARS.DOLLARS)) {
                            if (this.event_hooks.online_buy.items.every_dollars_DOLLARS.point <= 0 || !this.isInt(this.event_hooks.online_buy.items.every_dollars_DOLLARS.point)) {
                                msg += "購買-給予點數必須為大於0整數<br/>";
                            }
                            if (this.event_hooks.online_buy.items.every_dollars_DOLLARS.valid_days <= 0 || this.event_hooks.online_buy.items.every_dollars_DOLLARS.valid_days > 9999 || !this.isInt(this.event_hooks.online_buy.items.every_dollars_DOLLARS.valid_days)) {
                                msg += "購買-有效天數必須為1-9999整數<br/>";
                            }
                            if (!this.isInt(this.event_hooks.online_buy.items.every_dollars_DOLLARS.start_after_days)) {
                                msg += "購買-給予幾天後生效必須為整數<br/>";
                            }
                        } else {
                            msg += "購買-每幾元必須為大於0整數<br/>";
                        }
                    } else {
                        this.event_hooks.online_buy.can_be_overwritten = 0;
                    }
                    if (this.event_hooks.online_booking_class.is_enable) {
                        if (this.event_hooks.online_booking_class.items.class_attend.point > 0 || !this.isInt(this.event_hooks.online_booking_class.items.class_attend.point)) {
                            if (this.event_hooks.online_booking_class.items.class_attend.valid_days <= 0 || this.event_hooks.online_booking_class.items.class_attend.valid_days > 9999 || !this.isInt(this.event_hooks.online_booking_class.items.class_attend.valid_days)) {
                                msg += "線上課程預約-有效天數必須為1-9999整數<br/>";
                            }
                            if (!this.isInt(this.event_hooks.online_booking_class.items.class_attend.start_after_days)) {
                                msg += "線上課程預約-給予幾天後生效必須為整數<br/>";
                            }
                        } else {
                            msg += "線上課程預約-每次出席給點必須為大於0整數<br/>";
                        }
                    } else {
                        this.event_hooks.online_booking_class.can_be_overwritten = 0;
                    }
                    if (this.event_hooks.online_booking_service.is_enable) {
                        if (this.event_hooks.online_booking_service.items.service_attend.point > 0 || !this.isInt(this.event_hooks.online_booking_service.items.service_attend.point)) {
                            if (this.event_hooks.online_booking_service.items.service_attend.valid_days <= 0 || this.event_hooks.online_booking_service.items.service_attend.valid_days > 9999 || !this.isInt(this.event_hooks.online_booking_service.items.service_attend.valid_days)) {
                                msg += "線上服務預約-有效天數必須為1-9999整數<br/>";
                            }
                            if (!this.isInt(this.event_hooks.online_booking_service.items.service_attend.start_after_days)) {
                                msg += "線上服務預約-給予幾天後生效必須為整數<br/>";
                            }
                        } else {
                            msg += "線上服務預約-每次出席給點必須為大於0整數<br/>";
                        }
                    } else {
                        this.event_hooks.online_booking_service.can_be_overwritten = 0;
                    }
                }
                if (msg !== '') {
                    throw { title: '請注意', text: msg };
                }
            } catch (e) {
                this.alert('warning', e.title, '', e.text);
                return false;
            }

            this.save();
        },
        getConfig: function getConfig() {
            var _this2 = this;

            this.ajaxing = true;
            this.$http.get('/adminapi/bonus/setting').then(function (response) {
                var data = response.data.data;
                _this2.open_account_system = data.open_account_system;
                if (data.hasOwnProperty('account_system')) {
                    _this2.account_system_id = data.account_system.id;
                    _this2.account_system_exchange_rate = data.account_system.exchange_rate;
                    _this2.event_hooks = data.event_hooks;
                } else {
                    _this2.account_system_id = 0;
                }
                _this2.ajaxing = false;
            }).catch(function (response) {
                _this2.alert('error', '取得紅利設定失敗');
                _this2.ajaxing = false;
            });
        },
        save: function save() {
            var _this3 = this;

            this.ajaxing = true;
            var postData = this.generatePostData();

            this.$http.post('/adminapi/bonus/setting', postData).then(function (response) {
                _this3.getConfig();
                _this3.alert('success', '儲存成功');
                _this3.ajaxing = false;
            }).catch(function (response) {
                _this3.alert('error', '儲存失敗', response.data.message);
                _this3.ajaxing = false;
            });
        },
        generatePostData: function generatePostData() {
            var postData = {};
            postData.open_account_system = this.open_account_system;
            postData.account_system_id = this.account_system_id;
            postData.event_hooks = _lodash2.default.cloneDeep(this.event_hooks);
            postData = this.changeJudgement(['online_buy', 'seventeen_buy', 'webadmin_buy'], postData);
            if (this.isStudio) {
                postData.account_system_exchange_rate = this.account_system_exchange_rate;
            }
            return postData;
        },
        changeJudgement: function changeJudgement(buy_types, postData) {
            var _this = this;
            buy_types.forEach(function (buy_type) {
                var every_dollars_judgement = 'every_dollars_' + _this.event_hooks[buy_type].items.every_dollars_DOLLARS.DOLLARS;
                postData.event_hooks[buy_type].items[every_dollars_judgement] = postData.event_hooks[buy_type].items.every_dollars_DOLLARS;
                delete postData.event_hooks[buy_type].items.every_dollars_DOLLARS;
            });
            return postData;
        },
        alert: function alert(type, title) {
            var text = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
            var html = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

            $17.swal({
                title: title,
                text: text,
                type: type,
                html: html,
                showCancelButton: false
            });
        },
        isInt: function isInt(v) {
            var n = Number(v);
            return n === (n | 0);
        },
        isShowSetting: function isShowSetting(buy, booking_class, booking_service) {
            if (this.event_hooks[buy].show_front == 0 && this.event_hooks[booking_class].show_front == 0 && this.event_hooks[booking_service].show_front == 0) {
                return false;
            }
            return true;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-4ddae6ca=\"\">\n    <v-spinner :ajaxing=\"ajaxing\" _v-4ddae6ca=\"\"></v-spinner>\n    <div class=\"col-xs-12 m-bottom-50\" v-if=\"!ajaxing&amp;&amp;canUpdate\" _v-4ddae6ca=\"\">\n        <h3 v-if=\"isStudio\" _v-4ddae6ca=\"\">品牌設定</h3>\n        <h3 v-if=\"isBranch\" _v-4ddae6ca=\"\">場館設定</h3>\n        <div class=\"form-horizontal\" v-if=\"isStudio\" _v-4ddae6ca=\"\">\n            <div class=\"form-group\" _v-4ddae6ca=\"\">\n                <label class=\"col-sm-3 control-label\" _v-4ddae6ca=\"\">會員紅利積點系統</label>\n                <div class=\"col-sm-7\" _v-4ddae6ca=\"\">\n                    <v-bs-switch v-model=\"open_account_system\" id=\"open_account_system\" _v-4ddae6ca=\"\"></v-bs-switch>\n                </div>\n            </div>\n            <div class=\"form-group\" v-if=\"open_account_system\" _v-4ddae6ca=\"\">\n                <label class=\"col-sm-3 control-label\" _v-4ddae6ca=\"\">匯率設定</label>\n                <div class=\"col-sm-7\" _v-4ddae6ca=\"\">\n                    每1點紅利可折抵 <input v-model=\"account_system_exchange_rate\" step=\"0.01\" type=\"number\" min=\"0\" onwheel=\"this.blur()\" class=\"inputs form-control\" _v-4ddae6ca=\"\"> 元\n                </div>\n            </div>\n        </div>\n\n        <div v-if=\"open_account_system\" class=\"m-left-50\" _v-4ddae6ca=\"\">\n            <h3 class=\"m-top-30\" _v-4ddae6ca=\"\">透過品牌通路獲得紅利</h3>\n            <div class=\"table-responsive\" _v-4ddae6ca=\"\">\n                <table class=\"table config-table\" _v-4ddae6ca=\"\">\n                    <thead _v-4ddae6ca=\"\">\n                    <tr _v-4ddae6ca=\"\">\n                        <th _v-4ddae6ca=\"\"></th>\n                        <th class=\"text-center\" v-if=\"isShowSetting('online_buy','online_booking_class','online_booking_service')\" _v-4ddae6ca=\"\">自動給予會員紅利</th>\n                        <th class=\"text-center\" v-if=\"!isShowSetting('online_buy','online_booking_class','online_booking_service')\" _v-4ddae6ca=\"\">無設定可編輯</th>\n                        <th class=\"text-center\" v-if=\"isStudio\" _v-4ddae6ca=\"\">允許場館設定<br _v-4ddae6ca=\"\">紅利獲得事件</th>\n                        <th _v-4ddae6ca=\"\"></th>\n                    </tr>\n                    </thead>\n                    <tbody _v-4ddae6ca=\"\">\n                    <tr v-if=\"event_hooks.online_buy.show_front==1\" _v-4ddae6ca=\"\">\n                        <td class=\"handler\" _v-4ddae6ca=\"\">線上購買</td>\n                        <td class=\"text-center\" _v-4ddae6ca=\"\">\n                            <v-bs-switch v-model=\"event_hooks.online_buy.is_enable\" id=\"every_dollars_DOLLARS_is_enable\" _v-4ddae6ca=\"\"></v-bs-switch>\n                        </td>\n                        <td class=\"text-center\" v-if=\"isStudio\" _v-4ddae6ca=\"\">\n                            <v-bs-switch :disabled=\"!event_hooks.online_buy.is_enable\" v-model=\"event_hooks.online_buy.can_be_overwritten\" id=\"every_dollars_DOLLARS_can_be_overwritten\" _v-4ddae6ca=\"\"></v-bs-switch>\n                        </td>\n                        <td _v-4ddae6ca=\"\">\n                            每 <input type=\"number\" step=\"1\" min=\"0\" onwheel=\"this.blur()\" class=\"inputs form-control\" @keypress=\"checkKeyPress\" v-model=\"event_hooks.online_buy.items.every_dollars_DOLLARS.DOLLARS\" _v-4ddae6ca=\"\"> 元，\n                            給 <input type=\"number\" step=\"1\" min=\"0\" onwheel=\"this.blur()\" class=\"inputs form-control\" @keypress=\"checkKeyPress\" v-model=\"event_hooks.online_buy.items.every_dollars_DOLLARS.point\" _v-4ddae6ca=\"\"> 點，\n                            給予後 <input type=\"number\" step=\"1\" min=\"0\" onwheel=\"this.blur()\" class=\"inputs form-control\" @keypress=\"checkKeyPress\" v-model=\"event_hooks.online_buy.items.every_dollars_DOLLARS.start_after_days\" _v-4ddae6ca=\"\"> 天生效，\n                            有效天數 <input type=\"number\" step=\"1\" min=\"0\" onwheel=\"this.blur()\" class=\"inputs form-control\" @keypress=\"checkKeyPress\" v-model=\"event_hooks.online_buy.items.every_dollars_DOLLARS.valid_days\" _v-4ddae6ca=\"\"> 天\n                        </td>\n                    </tr>\n                    <tr v-if=\"event_hooks.online_booking_class.show_front==1\" _v-4ddae6ca=\"\">\n                        <td class=\"handler\" _v-4ddae6ca=\"\">線上課程預約</td>\n                        <td class=\"text-center\" _v-4ddae6ca=\"\">\n                            <v-bs-switch v-model=\"event_hooks.online_booking_class.is_enable\" id=\"class_attend_is_enable\" _v-4ddae6ca=\"\"></v-bs-switch>\n                        </td>\n                        <td class=\"text-center\" v-if=\"isStudio\" _v-4ddae6ca=\"\">\n                            <v-bs-switch :disabled=\"!event_hooks.online_booking_class.is_enable\" v-model=\"event_hooks.online_booking_class.can_be_overwritten\" id=\"class_attend_can_be_overwritten\" _v-4ddae6ca=\"\"></v-bs-switch>\n                        </td>\n                        <td _v-4ddae6ca=\"\">\n                            每次出席給 <input type=\"number\" step=\"1\" min=\"0\" onwheel=\"this.blur()\" class=\"inputs form-control\" @keypress=\"checkKeyPress\" v-model=\"event_hooks.online_booking_class.items.class_attend.point\" _v-4ddae6ca=\"\"> 點，\n                            給予後 <input type=\"number\" step=\"1\" min=\"0\" onwheel=\"this.blur()\" class=\"inputs form-control\" @keypress=\"checkKeyPress\" v-model=\"event_hooks.online_booking_class.items.class_attend.start_after_days\" _v-4ddae6ca=\"\"> 天生效，\n                            有效天數 <input type=\"number\" step=\"1\" min=\"0\" onwheel=\"this.blur()\" class=\"inputs form-control\" @keypress=\"checkKeyPress\" v-model=\"event_hooks.online_booking_class.items.class_attend.valid_days\" _v-4ddae6ca=\"\"> 天\n                        </td>\n                    </tr>\n                    <tr v-if=\"event_hooks.online_booking_service.show_front==1\" _v-4ddae6ca=\"\">\n                        <td class=\"handler\" _v-4ddae6ca=\"\">線上服務預約</td>\n                        <td class=\"text-center\" _v-4ddae6ca=\"\">\n                            <v-bs-switch v-model=\"event_hooks.online_booking_service.is_enable\" id=\"service_attend_is_enable\" _v-4ddae6ca=\"\"></v-bs-switch>\n                        </td>\n                        <td class=\"text-center\" v-if=\"isStudio\" _v-4ddae6ca=\"\">\n                            <v-bs-switch :disabled=\"!event_hooks.online_booking_service.is_enable\" v-model=\"event_hooks.online_booking_service.can_be_overwritten\" id=\"service_attend_can_be_overwritten\" _v-4ddae6ca=\"\"></v-bs-switch>\n                        </td>\n                        <td _v-4ddae6ca=\"\">\n                            每次出席給 <input type=\"number\" step=\"1\" min=\"0\" onwheel=\"this.blur()\" class=\"inputs form-control\" @keypress=\"checkKeyPress\" v-model=\"event_hooks.online_booking_service.items.service_attend.point\" _v-4ddae6ca=\"\"> 點，\n                            給予後 <input type=\"number\" step=\"1\" min=\"0\" onwheel=\"this.blur()\" class=\"inputs form-control\" @keypress=\"checkKeyPress\" v-model=\"event_hooks.online_booking_service.items.service_attend.start_after_days\" _v-4ddae6ca=\"\"> 天生效，\n                            有效天數 <input type=\"number\" step=\"1\" min=\"0\" onwheel=\"this.blur()\" class=\"inputs form-control\" @keypress=\"checkKeyPress\" v-model=\"event_hooks.online_booking_service.items.service_attend.valid_days\" _v-4ddae6ca=\"\"> 天\n                        </td>\n                    </tr>\n                    </tbody>\n                </table>\n            </div>\n\n            <h3 class=\"m-top-30\" _v-4ddae6ca=\"\">透過 17FIT 通路獲得紅利</h3>\n            <div class=\"table-responsive\" _v-4ddae6ca=\"\">\n                <table class=\"table config-table\" _v-4ddae6ca=\"\">\n                    <thead _v-4ddae6ca=\"\">\n                    <tr _v-4ddae6ca=\"\">\n                        <th _v-4ddae6ca=\"\"></th>\n                        <th class=\"text-center\" v-if=\"isShowSetting('seventeen_buy','seventeen_booking_class','seventeen_booking_service')\" _v-4ddae6ca=\"\">自動給予會員紅利</th>\n                        <th class=\"text-center\" v-if=\"!isShowSetting('seventeen_buy','seventeen_booking_class','seventeen_booking_service')\" _v-4ddae6ca=\"\">無設定可編輯</th>\n                        <th class=\"text-center\" v-if=\"isStudio\" _v-4ddae6ca=\"\">允許場館設定<br _v-4ddae6ca=\"\">紅利獲得事件</th>\n                        <th _v-4ddae6ca=\"\"></th>\n                    </tr>\n                    </thead>\n                    <tbody _v-4ddae6ca=\"\">\n                    <tr v-if=\"event_hooks.seventeen_buy.show_front==1\" _v-4ddae6ca=\"\">\n                        <td class=\"handler\" _v-4ddae6ca=\"\">線上購買</td>\n                        <td class=\"text-center\" _v-4ddae6ca=\"\">\n                            <v-bs-switch v-model=\"event_hooks.seventeen_buy.is_enable\" id=\"seventeen_every_dollars_DOLLARS_is_enable\" _v-4ddae6ca=\"\"></v-bs-switch>\n                        </td>\n                        <td class=\"text-center\" v-if=\"isStudio\" _v-4ddae6ca=\"\">\n                            <v-bs-switch :disabled=\"!event_hooks.seventeen_buy.is_enable\" v-model=\"event_hooks.seventeen_buy.can_be_overwritten\" id=\"seventeen_every_dollars_DOLLARS_can_be_overwritten\" _v-4ddae6ca=\"\"></v-bs-switch>\n                        </td>\n                        <td _v-4ddae6ca=\"\">\n                            每 <input type=\"number\" step=\"1\" min=\"0\" onwheel=\"this.blur()\" class=\"inputs form-control\" @keypress=\"checkKeyPress\" v-model=\"event_hooks.seventeen_buy.items.every_dollars_DOLLARS.DOLLARS\" _v-4ddae6ca=\"\"> 元，\n                            給 <input type=\"number\" step=\"1\" min=\"0\" onwheel=\"this.blur()\" class=\"inputs form-control\" @keypress=\"checkKeyPress\" v-model=\"event_hooks.seventeen_buy.items.every_dollars_DOLLARS.point\" _v-4ddae6ca=\"\"> 點，\n                            給予後 <input type=\"number\" step=\"1\" min=\"0\" onwheel=\"this.blur()\" class=\"inputs form-control\" @keypress=\"checkKeyPress\" v-model=\"event_hooks.seventeen_buy.items.every_dollars_DOLLARS.start_after_days\" _v-4ddae6ca=\"\"> 天生效，\n                            有效天數 <input type=\"number\" step=\"1\" min=\"0\" onwheel=\"this.blur()\" class=\"inputs form-control\" @keypress=\"checkKeyPress\" v-model=\"event_hooks.seventeen_buy.items.every_dollars_DOLLARS.valid_days\" _v-4ddae6ca=\"\"> 天\n                        </td>\n                    </tr>\n                    <tr v-if=\"event_hooks.seventeen_booking_class.show_front==1\" _v-4ddae6ca=\"\">\n                        <td class=\"handler\" _v-4ddae6ca=\"\">線上課程預約</td>\n                        <td class=\"text-center\" _v-4ddae6ca=\"\">\n                            <v-bs-switch v-model=\"event_hooks.seventeen_booking_class.is_enable\" id=\"seventeen_class_attend_is_enable\" _v-4ddae6ca=\"\"></v-bs-switch>\n                        </td>\n                        <td class=\"text-center\" v-if=\"isStudio\" _v-4ddae6ca=\"\">\n                            <v-bs-switch :disabled=\"!event_hooks.seventeen_booking_class.is_enable\" v-model=\"event_hooks.seventeen_booking_class.can_be_overwritten\" id=\"seventeen_class_attend_can_be_overwritten\" _v-4ddae6ca=\"\"></v-bs-switch>\n                        </td>\n                        <td _v-4ddae6ca=\"\">\n                            每次出席給 <input type=\"number\" step=\"1\" min=\"0\" onwheel=\"this.blur()\" class=\"inputs form-control\" @keypress=\"checkKeyPress\" v-model=\"event_hooks.seventeen_booking_class.items.class_attend.point\" _v-4ddae6ca=\"\"> 點，\n                            給予後 <input type=\"number\" step=\"1\" min=\"0\" onwheel=\"this.blur()\" class=\"inputs form-control\" @keypress=\"checkKeyPress\" v-model=\"event_hooks.seventeen_booking_class.items.class_attend.start_after_days\" _v-4ddae6ca=\"\"> 天生效，\n                            有效天數 <input type=\"number\" step=\"1\" min=\"0\" onwheel=\"this.blur()\" class=\"inputs form-control\" @keypress=\"checkKeyPress\" v-model=\"event_hooks.seventeen_booking_class.items.class_attend.valid_days\" _v-4ddae6ca=\"\"> 天\n                        </td>\n                    </tr>\n                    <tr v-if=\"event_hooks.seventeen_booking_service.show_front==1\" _v-4ddae6ca=\"\">\n                        <td class=\"handler\" _v-4ddae6ca=\"\">線上服務預約</td>\n                        <td class=\"text-center\" _v-4ddae6ca=\"\">\n                            <v-bs-switch v-model=\"event_hooks.seventeen_booking_service.is_enable\" id=\"seventeen_service_attend_is_enable\" _v-4ddae6ca=\"\"></v-bs-switch>\n                        </td>\n                        <td class=\"text-center\" v-if=\"isStudio\" _v-4ddae6ca=\"\">\n                            <v-bs-switch :disabled=\"!event_hooks.seventeen_booking_service.is_enable\" v-model=\"event_hooks.seventeen_booking_service.can_be_overwritten\" id=\"seventeen_service_attend_can_be_overwritten\" _v-4ddae6ca=\"\"></v-bs-switch>\n                        </td>\n                        <td _v-4ddae6ca=\"\">\n                            每次出席給 <input type=\"number\" step=\"1\" min=\"0\" onwheel=\"this.blur()\" class=\"inputs form-control\" @keypress=\"checkKeyPress\" v-model=\"event_hooks.seventeen_booking_service.items.service_attend.point\" _v-4ddae6ca=\"\"> 點，\n                            給予後 <input type=\"number\" step=\"1\" min=\"0\" onwheel=\"this.blur()\" class=\"inputs form-control\" @keypress=\"checkKeyPress\" v-model=\"event_hooks.seventeen_booking_service.items.service_attend.start_after_days\" _v-4ddae6ca=\"\"> 天生效，\n                            有效天數 <input type=\"number\" step=\"1\" min=\"0\" onwheel=\"this.blur()\" class=\"inputs form-control\" @keypress=\"checkKeyPress\" v-model=\"event_hooks.seventeen_booking_service.items.service_attend.valid_days\" _v-4ddae6ca=\"\"> 天\n                        </td>\n                    </tr>\n                    </tbody>\n                </table>\n            </div>\n\n            <h3 class=\"m-top-30\" _v-4ddae6ca=\"\">透過管理後台獲得紅利</h3>\n            <div class=\"table-responsive\" _v-4ddae6ca=\"\">\n                <table class=\"table config-table\" _v-4ddae6ca=\"\">\n                    <thead _v-4ddae6ca=\"\">\n                    <tr _v-4ddae6ca=\"\">\n                        <th _v-4ddae6ca=\"\"></th>\n                        <th class=\"text-center\" v-if=\"isShowSetting('webadmin_buy','webadmin_booking_class','webadmin_booking_service')\" _v-4ddae6ca=\"\">自動給予會員紅利</th>\n                        <th class=\"text-center\" v-if=\"!isShowSetting('webadmin_buy','webadmin_booking_class','webadmin_booking_service')\" _v-4ddae6ca=\"\">無設定可編輯</th>\n                        <th class=\"text-center\" v-if=\"isStudio\" _v-4ddae6ca=\"\">允許場館設定<br _v-4ddae6ca=\"\">紅利獲得事件</th>\n                        <th _v-4ddae6ca=\"\"></th>\n                    </tr>\n                    </thead>\n                    <tbody _v-4ddae6ca=\"\">\n                    <tr v-if=\"event_hooks.webadmin_buy.show_front==1\" _v-4ddae6ca=\"\">\n                        <td class=\"handler\" _v-4ddae6ca=\"\">後台購買</td>\n                        <td class=\"text-center\" _v-4ddae6ca=\"\">\n                            <v-bs-switch v-model=\"event_hooks.webadmin_buy.is_enable\" id=\"webadmin_every_dollars_DOLLARS_is_enable\" _v-4ddae6ca=\"\"></v-bs-switch>\n                        </td>\n                        <td class=\"text-center\" v-if=\"isStudio\" _v-4ddae6ca=\"\">\n                            <v-bs-switch :disabled=\"!event_hooks.webadmin_buy.is_enable\" v-model=\"event_hooks.webadmin_buy.can_be_overwritten\" id=\"webadmin_every_dollars_DOLLARS_can_be_overwritten\" _v-4ddae6ca=\"\"></v-bs-switch>\n                        </td>\n                        <td _v-4ddae6ca=\"\">\n                            每 <input type=\"number\" step=\"1\" min=\"0\" onwheel=\"this.blur()\" class=\"inputs form-control\" @keypress=\"checkKeyPress\" v-model=\"event_hooks.webadmin_buy.items.every_dollars_DOLLARS.DOLLARS\" _v-4ddae6ca=\"\"> 元，\n                            給 <input type=\"number\" step=\"1\" min=\"0\" onwheel=\"this.blur()\" class=\"inputs form-control\" @keypress=\"checkKeyPress\" v-model=\"event_hooks.webadmin_buy.items.every_dollars_DOLLARS.point\" _v-4ddae6ca=\"\"> 點，\n                            給予後 <input type=\"number\" step=\"1\" min=\"0\" onwheel=\"this.blur()\" class=\"inputs form-control\" @keypress=\"checkKeyPress\" v-model=\"event_hooks.webadmin_buy.items.every_dollars_DOLLARS.start_after_days\" _v-4ddae6ca=\"\"> 天生效，\n                            有效天數 <input type=\"number\" step=\"1\" min=\"0\" onwheel=\"this.blur()\" class=\"inputs form-control\" @keypress=\"checkKeyPress\" v-model=\"event_hooks.webadmin_buy.items.every_dollars_DOLLARS.valid_days\" _v-4ddae6ca=\"\"> 天\n                        </td>\n                    </tr>\n                    <tr v-if=\"event_hooks.webadmin_booking_class.show_front==1\" _v-4ddae6ca=\"\">\n                        <td class=\"handler\" _v-4ddae6ca=\"\">後台課程預約</td>\n                        <td class=\"text-center\" _v-4ddae6ca=\"\">\n                            <v-bs-switch v-model=\"event_hooks.webadmin_booking_class.is_enable\" id=\"webadmin_class_attend_is_enable\" _v-4ddae6ca=\"\"></v-bs-switch>\n                        </td>\n                        <td class=\"text-center\" v-if=\"isStudio\" _v-4ddae6ca=\"\">\n                            <v-bs-switch :disabled=\"!event_hooks.webadmin_booking_class.is_enable\" v-model=\"event_hooks.webadmin_booking_class.can_be_overwritten\" id=\"webadmin_class_attend_can_be_overwritten\" _v-4ddae6ca=\"\"></v-bs-switch>\n                        </td>\n                        <td _v-4ddae6ca=\"\">\n                            每次出席給 <input type=\"number\" step=\"1\" min=\"0\" onwheel=\"this.blur()\" class=\"inputs form-control\" @keypress=\"checkKeyPress\" v-model=\"event_hooks.webadmin_booking_class.items.class_attend.point\" _v-4ddae6ca=\"\"> 點，\n                            給予後 <input type=\"number\" step=\"1\" min=\"0\" onwheel=\"this.blur()\" class=\"inputs form-control\" @keypress=\"checkKeyPress\" v-model=\"event_hooks.webadmin_booking_class.items.class_attend.start_after_days\" _v-4ddae6ca=\"\"> 天生效，\n                            有效天數 <input type=\"number\" step=\"1\" min=\"0\" onwheel=\"this.blur()\" class=\"inputs form-control\" @keypress=\"checkKeyPress\" v-model=\"event_hooks.webadmin_booking_class.items.class_attend.valid_days\" _v-4ddae6ca=\"\"> 天\n                        </td>\n                    </tr>\n                    <tr v-if=\"event_hooks.webadmin_booking_service.show_front==1\" _v-4ddae6ca=\"\">\n                        <td class=\"handler\" _v-4ddae6ca=\"\">後台服務預約</td>\n                        <td class=\"text-center\" _v-4ddae6ca=\"\">\n                            <v-bs-switch v-model=\"event_hooks.webadmin_booking_service.is_enable\" id=\"webadmin_service_attend_is_enable\" _v-4ddae6ca=\"\"></v-bs-switch>\n                        </td>\n                        <td class=\"text-center\" v-if=\"isStudio\" _v-4ddae6ca=\"\">\n                            <v-bs-switch :disabled=\"!event_hooks.webadmin_booking_service.is_enable\" v-model=\"event_hooks.webadmin_booking_service.can_be_overwritten\" id=\"webadmin_service_attend_can_be_overwritten\" _v-4ddae6ca=\"\"></v-bs-switch>\n                        </td>\n                        <td _v-4ddae6ca=\"\">\n                            每次出席給 <input type=\"number\" step=\"1\" min=\"0\" onwheel=\"this.blur()\" class=\"inputs form-control\" @keypress=\"checkKeyPress\" v-model=\"event_hooks.webadmin_booking_service.items.service_attend.point\" _v-4ddae6ca=\"\"> 點，\n                            給予後 <input type=\"number\" step=\"1\" min=\"0\" onwheel=\"this.blur()\" class=\"inputs form-control\" @keypress=\"checkKeyPress\" v-model=\"event_hooks.webadmin_booking_service.items.service_attend.start_after_days\" _v-4ddae6ca=\"\"> 天生效，\n                            有效天數 <input type=\"number\" step=\"1\" min=\"0\" onwheel=\"this.blur()\" class=\"inputs form-control\" @keypress=\"checkKeyPress\" v-model=\"event_hooks.webadmin_booking_service.items.service_attend.valid_days\" _v-4ddae6ca=\"\"> 天\n                        </td>\n                    </tr>\n                    </tbody>\n                </table>\n            </div>\n        </div>\n        <div class=\"text-center\" v-if=\"disabledSave&amp;&amp;isBranch\" _v-4ddae6ca=\"\">\n            無設定可編輯\n        </div>\n        <div class=\"text-center m-top-50\" _v-4ddae6ca=\"\">\n            <button class=\"btn btn-primary\" :disabled=\"disabledSave\" @click.prevent=\"validate()\" _v-4ddae6ca=\"\">儲存</button>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.inputs[_v-4ddae6ca] {\n  display: inline-block;\n  width: 80px; }\n\n/* line 8, stdin */\n.config-table th[_v-4ddae6ca], .config-table tr[_v-4ddae6ca], .config-table td[_v-4ddae6ca] {\n  border: 0; }\n\n/* line 13, stdin */\n.handler[_v-4ddae6ca] {\n  text-align: right;\n  width: 100px;\n  font-weight: bold; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-4ddae6ca", module.exports)
  } else {
    hotAPI.update("_v-4ddae6ca", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1016:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'BookClassBatchContinueIndex',
    props: {
        query: {
            type: Object,
            required: true,
            description: 'Passing query from url'
        },
        widgetOpen: {
            type: Boolean,
            required: true,
            description: 'Widget open/close state'
        }
    },
    data: function data() {
        return {
            ajaxing: false
        };
    },
    created: function created() {
        this.initDefaultValue();
    },
    mounted: function mounted() {},

    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('webadmin/stepProgressGroup', ['currentStep'])),
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('webadmin/stepProgressGroup', ['initSteps', 'clearAll']), {
        initDefaultValue: function initDefaultValue() {
            var defaultInfo = {};
            var hasData = this.query.widget_contract_id && this.query.widget_contract_name && this.query.widget_member_id && this.query.widget_member_name;

            if (hasData) {
                var stepDefaultData = {
                    contract: {
                        contract_id: Number(this.query.widget_contract_id),
                        contract_name: this.query.widget_contract_name
                    },
                    member: {
                        id: Number(this.query.widget_member_id),
                        name: this.query.widget_member_name
                    },
                    branch: null
                };
                if (this.query.widget_branch_id) {
                    stepDefaultData['branch'] = { id: Number(this.query.widget_branch_id), branch_name: null };
                }
                defaultInfo = (0, _assign2.default)(defaultInfo, stepDefaultData);
            }

            this.initSteps([{ name: '選擇客戶及預約資訊', component: 'widget-class-batch-continue-info', data: defaultInfo }, { name: '選擇日期並預覽', component: 'widget-class-batch-continue-preview', data: {} }]);
        },
        closeFloatWidget: function closeFloatWidget() {
            var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            if (force) {
                this.closeClear();
            } else {
                var vm = this;
                $17.swal({
                    title: '確定要離開嗎？',
                    text: '畫面中的資料將不會被保留',
                    type: 'warning',
                    confirmButtonText: '離開',
                    cancelButtonText: '取消'
                }, function (confirm) {
                    if (confirm) {
                        vm.closeClear();
                    }
                });
            }
        },
        closeClear: function closeClear() {
            var _this = this;

            this.$bus.$emit('FloatWidget.Close');
            this.$nextTick(function () {
                _this.clearAll();
            });
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"st-flex\" _v-5c678f50=\"\">\n    <div class=\"background-grey--30 st-w-64 st-px-4 st-py-4\" _v-5c678f50=\"\">\n        <step-progress-group _v-5c678f50=\"\"></step-progress-group>\n    </div>\n    <component v-if=\"currentStep.component\" :is=\"currentStep.component\" @close=\"closeFloatWidget\" _v-5c678f50=\"\"></component>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-5c678f50", module.exports)
  } else {
    hotAPI.update("_v-5c678f50", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/object/assign":50,"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vuex":803}],1017:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            ajaxing: false,
            contracts: [],
            branches: [],
            data: {
                contract: null,
                branch: null,
                member: null,
                enableAdvancedFilter: false,
                filter: {
                    schedule_weekday: [1, 2, 3, 4, 5, 6, 7],
                    schedule_start_time_start: '00:00',
                    schedule_start_time_end: '24:00',
                    schedule_name: '',
                    schedule_staff_name: '',
                    batch_iterator_times: 50
                }
            },
            weekOptions: [{ text: '星期一', value: 1, selected: true }, { text: '星期二', value: 2, selected: true }, { text: '星期三', value: 3, selected: true }, { text: '星期四', value: 4, selected: true }, { text: '星期五', value: 5, selected: true }, { text: '星期六', value: 6, selected: true }, { text: '星期日', value: 7, selected: true }],
            startTimeOptions: [{ text: '00:00', value: '00:00', selected: true }, { text: '01:00', value: '01:00', selected: false }, { text: '02:00', value: '02:00', selected: false }, { text: '03:00', value: '03:00', selected: false }, { text: '04:00', value: '04:00', selected: false }, { text: '05:00', value: '05:00', selected: false }, { text: '06:00', value: '06:00', selected: false }, { text: '07:00', value: '07:00', selected: false }, { text: '08:00', value: '08:00', selected: false }, { text: '09:00', value: '09:00', selected: false }, { text: '10:00', value: '10:00', selected: false }, { text: '11:00', value: '11:00', selected: false }, { text: '12:00', value: '12:00', selected: false }, { text: '13:00', value: '13:00', selected: false }, { text: '14:00', value: '14:00', selected: false }, { text: '15:00', value: '15:00', selected: false }, { text: '16:00', value: '16:00', selected: false }, { text: '17:00', value: '17:00', selected: false }, { text: '18:00', value: '18:00', selected: false }, { text: '19:00', value: '19:00', selected: false }, { text: '20:00', value: '20:00', selected: false }, { text: '21:00', value: '21:00', selected: false }, { text: '22:00', value: '22:00', selected: false }, { text: '23:00', value: '23:00', selected: false }],
            endTimeOptions: [{ text: '01:00', value: '01:00', selected: false }, { text: '02:00', value: '02:00', selected: false }, { text: '03:00', value: '03:00', selected: false }, { text: '04:00', value: '04:00', selected: false }, { text: '05:00', value: '05:00', selected: false }, { text: '06:00', value: '06:00', selected: false }, { text: '07:00', value: '07:00', selected: false }, { text: '08:00', value: '08:00', selected: false }, { text: '09:00', value: '09:00', selected: false }, { text: '10:00', value: '10:00', selected: false }, { text: '11:00', value: '11:00', selected: false }, { text: '12:00', value: '12:00', selected: false }, { text: '13:00', value: '13:00', selected: false }, { text: '14:00', value: '14:00', selected: false }, { text: '15:00', value: '15:00', selected: false }, { text: '16:00', value: '16:00', selected: false }, { text: '17:00', value: '17:00', selected: false }, { text: '18:00', value: '18:00', selected: false }, { text: '19:00', value: '19:00', selected: false }, { text: '20:00', value: '20:00', selected: false }, { text: '21:00', value: '21:00', selected: false }, { text: '22:00', value: '22:00', selected: false }, { text: '23:00', value: '23:00', selected: false }, { text: '24:00', value: '24:00', selected: true }]
        };
    },
    created: function created() {
        var _this = this;

        if (this.hasCurrentStepData) {
            this.data = (0, _assign2.default)({}, this.currentStep.data);
            if (!this.currentStep.data.hasOwnProperty('enableAdvancedFilter')) {
                this.resetFilter();
            }
            this.$nextTick(function () {
                _this.getContracts();
                _this.mountedFilter();
            });
        }
    },
    mounted: function mounted() {},

    watch: {
        data: {
            handler: function handler(newVal) {
                this.updateCurrentData(newVal);
            },
            deep: true
        },
        'data.contract': function dataContract(n) {
            if (n && n.contract_id && n.allowed_branches) {
                this.branches = n.allowed_branches;
            } else {
                this.branches = [];
            }
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId']), (0, _vuex.mapGetters)('webadmin/stepProgressGroup', ['currentStep', 'hasCurrentStepData']), {
        disableNext: function disableNext() {
            return !(!this.ajaxing && this.data.branch && this.data.contract && this.data.member.id > 0 && this.data.filter.schedule_weekday.length > 0 && this.data.filter.schedule_start_time_start && this.data.filter.schedule_start_time_end && this.data.filter.schedule_start_time_start < this.data.filter.schedule_start_time_end && this.data.filter.schedule_name.length <= 50 && this.data.filter.schedule_staff_name.length <= 50 && this.data.filter.batch_iterator_times >= 1 && this.data.filter.batch_iterator_times <= 50);
        },
        disableAdvancedFilter: function disableAdvancedFilter() {
            return !(this.data.branch && this.data.contract && this.data.member.id > 0);
        },
        weekSelectText: function weekSelectText() {
            return this.data.filter.schedule_weekday.length == 7 ? '全部週間' : '週間';
        }
    }),
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('webadmin/stepProgressGroup', ['initSteps', 'updateCurrentData', 'prevStep', 'nextStep']), {
        memberChange: function memberChange(e) {
            this.data.member = e;
            this.data.contract = null;
            this.data.branch = null;

            if (e) {
                this.getContracts();
            } else {
                this.contracts = [];
            }
        },
        next: function next() {
            if (this.disableNext) return;
            this.nextStep();
        },
        getContracts: function getContracts() {
            var _this2 = this;

            if (!this.data.member) return;
            this.ajaxing = true;
            this.contracts = [];
            // NOTE: 此階段僅開放“次數”方案
            var params = {
                params: {
                    contract_type: [3]
                }
            };
            this.$http.get('/adminapi/member-contract-select-list/' + this.data.member.id, params).then(function (response) {
                _this2.ajaxing = false;
                _this2.contracts = response.data.records;
                _this2.initDefaultValue();
            }).catch(function (response) {
                $17.swal({
                    type: 'error',
                    title: '發生錯誤',
                    text: '取得會員方案失敗',
                    showCancelButton: false
                });
                _this2.ajaxing = false;
            });
        },
        initDefaultValue: function initDefaultValue() {
            var _this3 = this;

            if (this.data.contract) {
                var defaultContract = this.contracts.find(function (item) {
                    return item.contract_id === _this3.data.contract.contract_id;
                });
                this.data.contract = defaultContract;
                if (defaultContract) {
                    this.branches = defaultContract ? defaultContract.allowed_branches : [];

                    if (this.data.branch && this.branches.length) {
                        var defaultBranch = this.branches.find(function (item) {
                            return item.id === _this3.data.branch.id;
                        });
                        this.data.branch = { id: defaultBranch.id, branch_name: defaultBranch.branch_name };
                    } else {
                        this.data.branch = null;
                    }
                } else {
                    this.data.contract = null;
                    this.data.branch = null;
                }
            }
        },
        showAdvancedFilter: function showAdvancedFilter() {
            this.$set(this.data, 'enableAdvancedFilter', true);
            this.mountedFilter();
        },
        mountedFilter: function mountedFilter() {
            var params = this.data.filter;
            if (!params) return;
            this.weekOptions.forEach(function (item) {
                item.selected = params.schedule_weekday.includes(item.value);
            });
            this.startTimeOptions.forEach(function (item) {
                item.selected = item.value == params.schedule_start_time_start;
            });
            this.endTimeOptions.forEach(function (item) {
                item.selected = item.value == params.schedule_start_time_end;
            });
        },
        resetFilter: function resetFilter() {
            var defaultFilter = {
                enableAdvancedFilter: false,
                filter: {
                    schedule_weekday: [1, 2, 3, 4, 5, 6, 7],
                    schedule_start_time_start: '00:00',
                    schedule_start_time_end: '24:00',
                    schedule_name: '',
                    schedule_staff_name: '',
                    batch_iterator_times: 50
                }
            };
            this.$set(this.data, 'enableAdvancedFilter', false);
            this.$set(this.data, 'filter', defaultFilter.filter);
        },
        selectWeekDay: function selectWeekDay(value) {
            this.data.filter.schedule_weekday = value;
        },
        selectStartTime: function selectStartTime(value) {
            this.data.filter.schedule_start_time_start = value;
        },
        selectEndTime: function selectEndTime(value) {
            this.data.filter.schedule_start_time_end = value;
        },
        batchTimesChecker: function batchTimesChecker(event) {
            if (event.target.value < 1) {
                this.data.filter.batch_iterator_times = 1;
            } else if (event.target.value > 50) {
                this.data.filter.batch_iterator_times = 50;
            }
        },
        contractValueDisplay: function contractValueDisplay(contract) {
            if (contract) {
                var contractTypeEnum = {
                    1: '無限',
                    2: contract.contract_unused + '點',
                    3: contract.contract_unused + '次'
                };
                return contractTypeEnum[contract.contract_type] || '-';
            }
            return '-';
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"st-w-full st-flex st-flex-col\" _v-301b6ea0=\"\">\n    <div class=\"st-flex-1 st-overflow-hidden\" _v-301b6ea0=\"\">\n        <div class=\"st-h-full st-overflow-y-auto st-p-4\" _v-301b6ea0=\"\">\n            <div class=\"st-grid xl:st-grid-cols-2 md:st-grid-cols-1\" _v-301b6ea0=\"\">\n                <div _v-301b6ea0=\"\">\n                    <div class=\"st-mb-6\" _v-301b6ea0=\"\">\n                        <div class=\"st-font-bold st-text-16 st-mb-1\" _v-301b6ea0=\"\">選擇客戶<span class=\"st-text-danger\" _v-301b6ea0=\"\">*</span></div>\n                        <v-member-multi-select v-if=\"studioId!=null\" id=\"search-member\" :disabled=\"data.enableAdvancedFilter\" :studio-id=\"studioId\" :allow-clear=\"true\" :default-selected-member=\"data.member\" :member-change=\"memberChange\" _v-301b6ea0=\"\"></v-member-multi-select>\n                    </div>\n                    <div class=\"st-mb-6\" _v-301b6ea0=\"\">\n                        <div class=\"st-font-bold st-text-16 st-mb-1\" _v-301b6ea0=\"\">選擇方案<span class=\"st-text-danger\" _v-301b6ea0=\"\">*</span></div>\n                        <v-mutiselect :model.sync=\"data.contract\" :disabled=\"!data.member || data.enableAdvancedFilter\" :options=\"contracts\" :multiple=\"false\" :close-on-select=\"true\" :searchable=\"false\" :allow-empty=\"false\" label=\"contract_name\" track-by=\"contract_id\" :placeholder=\"ajaxing?'方案讀取中':'請選擇方案'\" _v-301b6ea0=\"\"></v-mutiselect>\n                        <div class=\"st-text-14 st-text-gray-90\" _v-301b6ea0=\"\">\n                            目前剩餘權益 {{ contractValueDisplay(data.contract) }}\n                        </div>\n                    </div>\n                    <div class=\"st-mb-6\" _v-301b6ea0=\"\">\n                        <div class=\"st-font-bold st-text-16 st-mb-1\" _v-301b6ea0=\"\">選擇預約哪個場館的課程<span class=\"st-text-danger\" _v-301b6ea0=\"\">*</span></div>\n                        <v-mutiselect :model.sync=\"data.branch\" :disabled=\"!data.member || data.enableAdvancedFilter\" :options=\"branches\" :multiple=\"false\" :close-on-select=\"true\" :searchable=\"false\" :allow-empty=\"false\" label=\"branch_name\" track-by=\"id\" :placeholder=\"ajaxing?'場館讀取中':'請選擇場館'\" _v-301b6ea0=\"\"></v-mutiselect>\n                    </div>\n                    <div v-show=\"!data.enableAdvancedFilter\" _v-301b6ea0=\"\">\n                        <st-button ghost=\"\" @click=\"showAdvancedFilter\" :disabled=\"disableAdvancedFilter\" :btn-class=\"['st-ml-auto']\" _v-301b6ea0=\"\">\n                            <div class=\"st-text-secondary st-text-16 st-font-medium st-flex st-items-center\" _v-301b6ea0=\"\">\n                                <span class=\"material-icons st-text-20\" _v-301b6ea0=\"\">add</span>\n                                <span _v-301b6ea0=\"\">進階條件</span>\n                            </div>\n                        </st-button>\n                    </div>\n                </div>\n                <div v-if=\"data.enableAdvancedFilter\" _v-301b6ea0=\"\">\n                    <div class=\"md:st-w-full xl:st-max-w-sm st-ml-auto\" _v-301b6ea0=\"\">\n                        <div class=\"st-w-full st-border-solid st-border st-border-gray-40 st-rounded-4\" _v-301b6ea0=\"\">\n                            <div class=\"st-flex st-items-center st-justify-between st-bg-gray-20 st-p-3.5\" _v-301b6ea0=\"\">\n                                <div class=\"st-text-16 st-text-black st-font-medium\" _v-301b6ea0=\"\">進階條件</div>\n                                <div _v-301b6ea0=\"\">\n                                    <st-button ghost=\"\" @click=\"resetFilter\" _v-301b6ea0=\"\">\n                                        <span class=\"st-gray-90 st-text-15 st-underline\" _v-301b6ea0=\"\">取消條件</span>\n                                    </st-button>\n                                </div>\n                            </div>\n                            <div class=\"st-p-3.5 st-space-y-3 st-text-16 st-text-black\" _v-301b6ea0=\"\">\n                                <st-multiple-select label=\"週間\" required=\"\" @change=\"selectWeekDay\" :options=\"weekOptions\" :empty-text=\"weekSelectText\" select-all=\"\" _v-301b6ea0=\"\"></st-multiple-select>\n                                <div _v-301b6ea0=\"\">\n                                    <div class=\"st-mb-1\" _v-301b6ea0=\"\">\n                                        開始時間範圍<span class=\"st-text-danger\" _v-301b6ea0=\"\">*</span>\n                                    </div>\n                                    <div class=\"st-flex st-items-center\" _v-301b6ea0=\"\">\n                                        <st-single-select empty-text=\"請選擇\" :options=\"startTimeOptions\" @change=\"selectStartTime\" _v-301b6ea0=\"\"></st-single-select>\n                                        <span class=\"st-px-2\" _v-301b6ea0=\"\">～</span>\n                                        <st-single-select empty-text=\"請選擇\" :options=\"endTimeOptions\" @change=\"selectEndTime\" _v-301b6ea0=\"\"></st-single-select>\n                                    </div>\n                                </div>\n                                <st-input label=\"課表名稱包含\" placeholder=\"請輸入關鍵字\" v-model=\"data.filter.schedule_name\" :error=\"data.filter.schedule_name.length > 50\" error-text=\"輸入字數不得超過50字\" _v-301b6ea0=\"\"></st-input>\n                                <st-input label=\"服務提供者名稱包含\" placeholder=\"請輸入關鍵字\" v-model=\"data.filter.schedule_staff_name\" :error=\"data.filter.schedule_staff_name.length > 50\" error-text=\"輸入字數不得超過50字\" _v-301b6ea0=\"\"></st-input>\n                                <div class=\"st-w-1/2\" _v-301b6ea0=\"\">\n                                    <st-input label=\"預約堂數上限\" required=\"\" type=\"number\" v-model=\"data.filter.batch_iterator_times\" @blur=\"batchTimesChecker\" _v-301b6ea0=\"\"></st-input>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n        </div>\n    </div>\n\n    <div class=\"st-flex st-border-solid st-border-0 st-border-t st-border-t-gray-40 st-justify-end st-items-center st-p-4\" _v-301b6ea0=\"\">\n        <a class=\"st-mr-4 st-text-black\" @click=\"$emit('close')\" _v-301b6ea0=\"\">取消</a>\n        <st-button black=\"\" text=\"下一步\" :disabled=\"disableNext\" @click=\"next\" _v-301b6ea0=\"\"></st-button>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-301b6ea0", module.exports)
  } else {
    hotAPI.update("_v-301b6ea0", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/object/assign":50,"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vuex":803}],1018:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            ajaxing: false,
            bookingAjaxing: false,
            maxBatchIteratorTimes: 50,
            data: {
                date: null
            },
            records: [],
            previewInfo: {}
        };
    },
    created: function created() {
        if (this.hasCurrentStepData) {
            this.data = (0, _assign2.default)({}, this.currentStep.data);
        }
    },
    mounted: function mounted() {},

    watch: {
        data: {
            handler: function handler(newVal) {
                this.updateCurrentData(newVal);
            },
            deep: true
        },
        'data.date': function dataDate() {
            this.getData();
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId']), (0, _vuex.mapGetters)('webadmin/stepProgressGroup', ['currentStep', 'stepsData', 'getDataByIndex', 'hasCurrentStepData']), {
        infoData: function infoData() {
            return this.getDataByIndex(0);
        },
        tableConfig: function tableConfig() {
            return {
                columns: [{ keys: "date", head: "開課日期" }, {
                    keys: 'week_day',
                    head: '週間',
                    html: function html(item) {
                        var weekDay = moment(item.date).day();
                        var chineseDay = $17.getChineseWeekday(weekDay);
                        return '<div>\u661F\u671F' + chineseDay + '</div>';
                    }
                }, {
                    keys: "time_start",
                    head: "時間",
                    html: function html(item) {
                        return moment(item.time_start, ['HH:mm:ss']).format('HH:mm') + ' ~ ' + moment(item.time_end, ['HH:mm:ss']).format('HH:mm');
                    }
                }, { keys: "schedules_name", head: "課表名稱" }, { keys: "staff_name", head: "服務提供者" }, {
                    keys: "booking_num",
                    head: "訂課人數",
                    html: function html(item) {
                        return item.booking_num + '/' + item.qty;
                    }
                }]
            };
        },
        advancedFilter: function advancedFilter() {
            return this.stepsData[0].filter || {};
        }
    }),
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('webadmin/stepProgressGroup', ['updateCurrentData', 'prevStep']), {
        prev: function prev() {
            this.prevStep();
        },
        book: function book() {
            if (!this.records.length) {
                $17.swal({
                    type: 'warning',
                    title: '無課程可供預約',
                    showCancelButton: false
                });
                return false;
            }

            var vm = this;
            vm.bookingAjaxing = true;
            var memberId = this.stepsData[0].member.id;
            var postData = this.apiParams();
            this.$http.post('/adminapi/continue-batch-booking', postData).then(function (response) {
                vm.bookingAjaxing = false;
                $17.swal({
                    title: '執行完成',
                    type: 'success',
                    confirmButtonText: '查看客戶資料',
                    cancelButtonText: '關閉'
                }, function (confirm) {
                    if (confirm) {
                        vm.$emit('close', true);
                        vm.$nextTick(function () {
                            window.open('/webadmin/member_studio?f[id]=' + memberId, '_blank');
                        });
                    } else {
                        vm.$emit('close', true);
                    }
                });
            }).catch(function (err) {
                vm.bookingAjaxing = false;
                $17.swal({
                    type: 'error',
                    title: '執行失敗',
                    text: err.body.message,
                    showCancelButton: false
                });
            });
        },
        getData: function getData() {
            var _this = this;

            if (!this.data.date) return;
            this.ajaxing = true;
            this.records = [];
            var params = this.apiParams();
            this.$http.get('/adminapi/continue-batch-booking/list', {
                params: params
            }).then(function (response) {
                _this.ajaxing = false;
                _this.records = response.data.records;
                _this.previewInfo = {
                    batch_iterator_times: response.data.batch_iterator_times,
                    contract_unused: response.data.contract_unused,
                    count: response.data.count,
                    contract_type: response.data.contract_type
                };
            }).catch(function (response) {
                $17.swal({
                    type: 'error',
                    title: '發生錯誤',
                    text: '預覽課程失敗',
                    showCancelButton: false
                });
                _this.ajaxing = false;
            });
        },
        apiParams: function apiParams() {
            return (0, _extends3.default)({
                branch_id: this.stepsData[0].branch.id,
                member_id: this.stepsData[0].member.id,
                contract_id: this.stepsData[0].contract.contract_id,
                start_date: this.data.date
            }, this.stepsData[0].filter);
        },
        weekDayDisplay: function weekDayDisplay() {
            var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

            var text = '';
            values.forEach(function (value) {
                if (text) {
                    text += ', 星期' + $17.getChineseWeekday(value);
                } else {
                    text += '星期' + $17.getChineseWeekday(value);
                }
            });
            return text;
        },
        contractValueDisplay: function contractValueDisplay(value, type) {
            var contractTypeEnum = {
                1: '無限',
                2: value + '點',
                3: value + '次'
            };
            return contractTypeEnum[type] || '-';
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"st-w-full st-flex st-flex-col\" _v-faa98474=\"\">\n    <div class=\"st-flex-1 st-overflow-hidden\" _v-faa98474=\"\">\n        <div class=\"st-h-full st-overflow-y-auto st-p-4\" _v-faa98474=\"\">\n            <div class=\"st-grid xl:st-grid-cols-2 md:st-grid-cols-1\" _v-faa98474=\"\">\n                <div _v-faa98474=\"\">\n                    <div class=\"st-mb-6\" _v-faa98474=\"\">\n                        <div class=\"st-font-bold st-text-16 st-mb-1\" _v-faa98474=\"\">選擇客戶</div>\n                        <div class=\"st-text-16\" _v-faa98474=\"\">{{ infoData.member.name }}</div>\n                    </div>\n                    <div class=\"st-mb-6\" _v-faa98474=\"\">\n                        <div class=\"st-font-bold st-text-16 st-mb-1\" _v-faa98474=\"\">選擇方案</div>\n                        <div class=\"st-text-16\" _v-faa98474=\"\">{{ infoData.contract.contract_name }}</div>\n                        <div class=\"st-text-14 st-text-gray-90\" _v-faa98474=\"\">目前剩餘權益 {{ contractValueDisplay(infoData.contract.contract_unused, infoData.contract.contract_type) }}</div>\n                    </div>\n                    <div class=\"st-mb-6\" _v-faa98474=\"\">\n                        <div class=\"st-font-bold st-text-16 st-mb-1\" _v-faa98474=\"\">選擇預約哪個場館的課程</div>\n                        <div class=\"st-text-16\" _v-faa98474=\"\">{{ infoData.branch.branch_name }}</div>\n                    </div>\n                    <div _v-faa98474=\"\">\n                        <div class=\"st-font-bold st-text-16 st-mb-1\" _v-faa98474=\"\">選擇從什麼時間開始預約<span class=\"st-text-danger\" _v-faa98474=\"\">*</span></div>\n                        <v-date-picker v-model=\"data.date\" _v-faa98474=\"\"></v-date-picker>\n                    </div>\n                </div>\n                <div v-if=\"stepsData[0].enableAdvancedFilter\" _v-faa98474=\"\">\n                    <div class=\"md:st-w-full xl:st-max-w-sm st-ml-auto\" _v-faa98474=\"\">\n                        <div class=\"st-w-full st-border-solid st-border st-border-gray-40 st-rounded-4\" _v-faa98474=\"\">\n                            <div class=\"st-bg-gray-20 st-p-3.5\" _v-faa98474=\"\">\n                                <div class=\"st-text-16 st-text-black st-font-medium\" _v-faa98474=\"\">進階條件</div>\n                            </div>\n                            <div class=\"st-p-3.5 st-space-y-3 st-text-16 st-text-black\" _v-faa98474=\"\">\n                                <div _v-faa98474=\"\">\n                                    <div class=\"st-font-medium st-mb-1\" _v-faa98474=\"\">週間</div>\n                                    <div _v-faa98474=\"\">{{ weekDayDisplay(advancedFilter.schedule_weekday) }}</div>\n                                </div>\n                                <div _v-faa98474=\"\">\n                                    <div class=\"st-font-medium st-mb-1\" _v-faa98474=\"\">開始時間範圍</div>\n                                    <div _v-faa98474=\"\">{{ advancedFilter.schedule_start_time_start }} ～ {{ advancedFilter.schedule_start_time_end }}</div>\n                                </div>\n                                <div _v-faa98474=\"\">\n                                    <div class=\"st-font-medium st-mb-1\" _v-faa98474=\"\">課表名稱包含</div>\n                                    <div _v-faa98474=\"\">{{ advancedFilter.schedule_name || '-' }}</div>\n                                </div>\n                                <div _v-faa98474=\"\">\n                                    <div class=\"st-font-medium st-mb-1\" _v-faa98474=\"\">服務提供者名稱包含</div>\n                                    <div _v-faa98474=\"\">{{ advancedFilter.schedule_staff_name || '-' }}</div>\n                                </div>\n                                <div _v-faa98474=\"\">\n                                    <div class=\"st-font-medium st-mb-1\" _v-faa98474=\"\">預約堂數上限</div>\n                                    <div _v-faa98474=\"\">{{ advancedFilter.batch_iterator_times }}</div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n\n            <hr v-if=\"data.date\" class=\"st-h-px st-my-8 st-bg-gray-200 st-border-0 st-bg-gray-40\" _v-faa98474=\"\">\n\n            <div v-if=\"data.date\" _v-faa98474=\"\">\n                <div class=\"st-text-20 st-mb-3 st-pl-2 st-color-primary st-border-solid st-border-0 st-border-l-4 st-border-l-secondary\" _v-faa98474=\"\">預覽</div>\n                <div class=\"st-text-16 st-text-gray-90\" v-if=\"records.length\" _v-faa98474=\"\">\n                    <div v-if=\"records.length >= previewInfo.batch_iterator_times\" class=\"st-text-danger st-mb-3 st-flex st-items-center\" _v-faa98474=\"\">\n                        <i class=\"material-icons\" _v-faa98474=\"\">info</i>\n                        <div class=\"st-pl-1\" _v-faa98474=\"\">請注意，本次的預約已達單次執行上限</div>\n                    </div>\n                    <ul class=\"st-pl-8\" _v-faa98474=\"\">\n                        <li _v-faa98474=\"\">預約堂數\n                            <span class=\"st-font-medium st-text-black st-mr-1\" _v-faa98474=\"\">{{ previewInfo.count }}</span>\n                            (預約堂數上限 <span class=\"st-font-medium st-text-black\" _v-faa98474=\"\">{{ previewInfo.batch_iterator_times }}</span>)\n                        </li>\n                        <li _v-faa98474=\"\">預約後剩餘權益 <span class=\"st-font-medium st-text-black\" _v-faa98474=\"\">{{ contractValueDisplay(previewInfo.contract_unused, previewInfo.contract_type) }}</span></li>\n                    </ul>\n                    <div class=\"st-mb-2\" _v-faa98474=\"\">\n                        確定完成請點擊「預約」\n                    </div>\n                </div>\n                <v-smart-table ref=\"previewTable\" :table-config=\"tableConfig\" :is-ajaxing=\"ajaxing\" :data=\"{records:records}\" :page-sync-url-query=\"false\" _v-faa98474=\"\"></v-smart-table>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"st-flex st-border-solid st-border-0 st-border-t st-border-t-gray-40 st-justify-end st-items-center st-p-4\" _v-faa98474=\"\">\n        <a class=\"st-mr-4 st-text-black\" @click=\"$emit('close')\" _v-faa98474=\"\">取消</a>\n        <st-button class=\"st-mr-4\" neutral=\"\" text=\"上一步\" @click=\"prev\" _v-faa98474=\"\"></st-button>\n        <st-button black=\"\" text=\"預約\" :disabled=\"!data.date\" @click=\"book\" _v-faa98474=\"\"></st-button>\n    </div>\n    <v-block-percentage-ui v-if=\"bookingAjaxing\" :count=\"records.length\" single-time=\"2000\" _v-faa98474=\"\">\n    </v-block-percentage-ui>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-faa98474", module.exports)
  } else {
    hotAPI.update("_v-faa98474", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/object/assign":50,"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vuex":803}],1019:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _info = require('./continue/info.vue');

var _info2 = _interopRequireDefault(_info);

var _preview = require('./continue/preview.vue');

var _preview2 = _interopRequireDefault(_preview);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//連續預約
_vue2.default.component('widget-class-batch-continue-info', _info2.default);
_vue2.default.component('widget-class-batch-continue-preview', _preview2.default);

},{"./continue/info.vue":1017,"./continue/preview.vue":1018,"vue":792}],1020:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    name: 'BookClassBatchIndex',
    props: {
        query: {
            type: Object,
            required: true,
            description: 'Passing query from url'
        },
        widgetOpen: {
            type: Boolean,
            required: true,
            description: 'Widget open/close state'
        }
    },
    data: function data() {
        var defaultModeOptions = { name: '連續預約', id: 'continue' };
        return {
            ajaxing: false,
            mode: defaultModeOptions,
            modeOptions: [defaultModeOptions]
        };
    },
    mounted: function mounted() {},

    methods: {
        submit: function submit() {
            var _this = this;

            this.closeFloatWidget();

            this.$nextTick(function () {
                switch (_this.mode.id) {
                    case 'continue':
                        var payload = {
                            widget: 'book.class.batch.continue',
                            widget_config_width: 'full'
                        };
                        window.Event.$emit('FloatWidget.Show', payload);
                        break;
                }
            });
        },
        closeFloatWidget: function closeFloatWidget() {
            this.$bus.$emit('FloatWidget.Close');
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"st-w-full st-flex st-flex-col\" _v-6133125c=\"\">\n    <div class=\"st-flex-1 st-overflow-hidden\" _v-6133125c=\"\">\n        <div class=\"st-h-full st-overflow-y-auto st-p-4\" _v-6133125c=\"\">\n            <div _v-6133125c=\"\">\n                <div class=\"st-font-bold st-text-16 st-mb-1\" _v-6133125c=\"\">預約模式</div>\n                <v-mutiselect :model.sync=\"mode\" :options=\"modeOptions\" :multiple=\"false\" :allow-empty=\"false\" label=\"name\" track-by=\"id\" :placeholder=\"ajaxing?'預約模式讀取中':'請選擇預約模式'\" _v-6133125c=\"\"></v-mutiselect>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"st-flex st-border-solid st-border-0 st-border-t st-border-t-gray-40 st-justify-end st-items-center st-p-4\" _v-6133125c=\"\">\n        <a class=\"st-mr-4 st-text-black\" @click=\"closeFloatWidget\" _v-6133125c=\"\">取消</a>\n        <st-button black=\"\" text=\"確認\" @click=\"submit\" _v-6133125c=\"\"></st-button>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-6133125c", module.exports)
  } else {
    hotAPI.update("_v-6133125c", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],1021:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 3, stdin */\n.links-table td[_v-2ca8e938] {\n  border: none; }\n")
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        contents: {
            type: Array,
            required: true
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"row page-notice\" v-if=\"contents.length > 0\" _v-2ca8e938=\"\">\n    <div class=\"col-md-1\" _v-2ca8e938=\"\"></div>\n    <div class=\"col-md-8\" _v-2ca8e938=\"\">\n        <p style=\"color: #d9534f\" _v-2ca8e938=\"\">**請注意**</p>\n        <p style=\"color: #777\" v-for=\"text in contents\" _v-2ca8e938=\"\">{{text}}</p>\n\n    </div>\n    <div class=\"col-md-1\" _v-2ca8e938=\"\"></div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 3, stdin */\n.links-table td[_v-2ca8e938] {\n  border: none; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-2ca8e938", module.exports)
  } else {
    hotAPI.update("_v-2ca8e938", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1022:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 3, stdin */\n.links-table td[_v-4b39f29e] {\n  border: none; }\n")
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        list: {
            type: Object,
            required: true
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<table class=\"table\" _v-4b39f29e=\"\">\n    <tbody _v-4b39f29e=\"\">\n    <tr v-for=\"(row,key) in list\" v-if=\"row.show\" _v-4b39f29e=\"\">\n        <td width=\"15%\" align=\"right\" _v-4b39f29e=\"\">{{row.item}}</td>\n        <td width=\"10%\" align=\"center\" _v-4b39f29e=\"\">\n            <button @click=\"$emit('btn-click-copy', key)\" type=\"button\" class=\"btn btn-primary\" _v-4b39f29e=\"\">\n                複製連結\n            </button>\n        </td>\n        <td _v-4b39f29e=\"\">\n            <input :id=\"'url-'+key\" type=\"text\" class=\"form-control\" :value=\"row.url\" readonly=\"\" _v-4b39f29e=\"\">\n        </td>\n        <td width=\"20%\" _v-4b39f29e=\"\">\n            <button @click=\"$emit('btn-click-setting', key)\" v-if=\"row.show_setting_btn\" type=\"button\" class=\"btn btn-success\" _v-4b39f29e=\"\">\n                設定\n            </button>\n        </td>\n    </tr>\n    </tbody>\n</table>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 3, stdin */\n.links-table td[_v-4b39f29e] {\n  border: none; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-4b39f29e", module.exports)
  } else {
    hotAPI.update("_v-4b39f29e", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1023:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    facebook: {
        v1: {
            appUrlHook: function appUrlHook(urls, branchId, lineLiffv2Id, isStudio) {
                var url = 'https://chatbot.17fit.com/fb/' + branchId;
                var qs = isStudio ? "?mode=studio&auto_switch=true" : '';
                urls.class.url = url + '/booking/class' + qs;
                urls.service.url = url + '/booking/service' + qs;
                urls.contract.url = url + '/contract/category' + qs;
                urls.bookings.url = url + '/member/bookings' + qs;
                urls.info.url = url + '/biz-info' + qs;
                urls.member.url = url + '/member-center' + qs;
            },
            canRead: function canRead(context) {
                return context.canReadFb;
            },
            notices: []
        }
    },

    liff: {
        v1: {
            appUrlHook: function appUrlHook(urls, branchId) {
                var url = 'line://app/1562115950-lVGY6z71?branch_id=' + branchId + '&path=';
                urls.class.url = url + 'booking/class';
                urls.service.url = url + 'booking/service';
                urls.contract.url = url + 'contract/category';
                urls.bookings.url = url + 'member/bookings';
                urls.info.url = url + 'biz-info';
                urls.member.url = url + 'member-center';
            },
            canRead: function canRead(context) {
                return context.canReadLiff;
            },
            notices: ["因配合LINE改版，請使用V2新版，V1舊版未來將不再更新！", "您只需要將原本使用V1舊版連結之處，直接更換為V2即可，不需要重新進行設定。"]
        },
        v2: {
            isDefault: true,
            appUrlHook: function appUrlHook(urls, branchId, lineLiffv2Id, isStudio) {
                var url = 'https://liff.line.me/' + lineLiffv2Id + '/liffv2/aliase?branch_id=' + branchId;
                if (isStudio) {
                    url += "&mode=studio&auto_switch=true";
                }
                urls.class.url = url + '&path=booking/class';
                urls.service.url = url + '&path=booking/service';
                urls.contract.url = url + '&path=contract/category';
                urls.bookings.url = url + '&path=member/bookings';
                urls.info.url = url + '&path=biz-info';
                urls.member.url = url + '&path=member-center';
            },
            canRead: function canRead(context) {
                return context.canReadLiff;
            },
            notices: ["因配合LINE改版，請使用V2新版，V1舊版未來將不再更新！", "您只需要將原本使用V1舊版連結之處，直接更換為V2即可，不需要重新進行設定。"]
        }
    }
};

},{}],1024:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _index = require('./index.vue');

var _index2 = _interopRequireDefault(_index);

var _botFunctionUrlTable = require('./bot-function-url-table.vue');

var _botFunctionUrlTable2 = _interopRequireDefault(_botFunctionUrlTable);

var _botFunctionUrlNotice = require('./bot-function-url-notice.vue');

var _botFunctionUrlNotice2 = _interopRequireDefault(_botFunctionUrlNotice);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('index-bot-view', _index2.default);
_vue2.default.component('bot-function-url-table', _botFunctionUrlTable2.default);
_vue2.default.component('bot-function-url-notice', _botFunctionUrlNotice2.default);

},{"./bot-function-url-notice.vue":1021,"./bot-function-url-table.vue":1022,"./index.vue":1025,"vue":792}],1025:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.items input[_v-6d70e176] {\n  padding-right: 5px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _values = require('babel-runtime/core-js/object/values');

var _values2 = _interopRequireDefault(_values);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _vuex = require('vuex');

var _config = require('./config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        var platform = this.getPlatform();
        var configRoot = this.initConfig(platform);
        var result = this.initVersion(configRoot);

        return {
            platform: platform,
            version: result.version,
            versionCounter: result.counter,
            configRoot: configRoot,
            studio: {},
            branch_encrypt_ids: '',
            list: {
                class: {
                    show: false,
                    item: '預約課程',
                    url: '',
                    show_setting_btn: true
                },
                service: {
                    show: false,
                    item: '預約服務',
                    url: '',
                    show_setting_btn: true
                },
                contract: {
                    show: true,
                    item: '購買方案',
                    url: '',
                    show_setting_btn: true
                },
                bookings: {
                    show: true,
                    item: '查詢我的預約',
                    url: '',
                    show_setting_btn: false
                },
                info: {
                    show: true,
                    item: '商家資訊',
                    url: '',
                    show_setting_btn: true
                },
                member: {
                    show: true,
                    item: '帳戶與方案',
                    url: '',
                    show_setting_btn: false
                }
            },
            ajaxing: false,
            info: {
                ajaxing: false,
                items: {},
                branch_values: [],
                postInfo: {}
            }
        };
    },
    watch: {
        selected_studio_id: function selected_studio_id(val) {
            if (val > 0) {
                this.getBranchEncryptIds();
            }
        },
        selected_branch_id: function selected_branch_id(val) {
            this.generateLinks();
        },
        version: function version(val) {
            if (val) {
                this.generateLinks();
            }
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId', 'lineLiffv2Id', 'studioName']), (0, _vuex.mapState)('filters', ['selected_studio_id', 'selected_branch_id']), (0, _vuex.mapState)({
        canReadFb: function canReadFb(state) {
            return state.webadmin.configure.webFunctions.WebadminBotViewFbIndex;
        },
        canReadLiff: function canReadLiff(state) {
            return state.webadmin.configure.webFunctions.WebadminBotViewLiffIndex;
        }
    }), {
        config: function config() {
            return this.getConfig();
        },
        currentEncryptBranchId: function currentEncryptBranchId() {
            if (this.selected_branch_id == 'null') {
                return (0, _values2.default)(this.branch_encrypt_ids)[0];
            }
            return this.branch_encrypt_ids[this.selected_branch_id];
        },
        canRead: function canRead() {
            return this.getConfig().canRead(this);
        }
    }),
    methods: {
        initConfig: function initConfig(platform) {
            if (!_config2.default[platform]) {
                throw Error('Cannot find current config info of platform [' + platform + ']');
            }
            return _config2.default[platform];
        },
        initVersion: function initVersion(config) {
            var length = 0;
            var currentVersion = null;

            for (var version in config) {
                length++;
                if (length == 1) {
                    currentVersion = version;
                }

                if (config[version].isDefault) {
                    currentVersion = version;
                }
            }

            return {
                version: currentVersion,
                counter: length
            };
        },
        getConfig: function getConfig() {
            return this.configRoot[this.version];
        },
        getPlatform: function getPlatform() {
            var urlPath = window.location.href.split('?')[0]; //TODO REFACTOR: 暫解，預計用Vue router優化
            return urlPath.split('/').pop(); //facebook,liff
        },
        generateLinks: function generateLinks() {
            this.list.class.show = this.studio.class_base == 1;
            this.list.service.show = this.studio.service_base == 1;
            var isStudio = false;
            this.list.info.show_setting_btn = true;
            if (this.selected_branch_id == 'null') {
                isStudio = true;
                this.list.info.show_setting_btn = false;
            }

            this.config.appUrlHook(this.list, this.currentEncryptBranchId, this.lineLiffv2Id, isStudio);
        },
        getSelectStudioName: function getSelectStudioName() {
            return "品牌-" + this.studioName;
        },
        saveInfo: function saveInfo() {
            var _this = this;

            this.info.ajaxing = true;
            this.$http.post('/adminapi/chatbot/biz-info/save/' + this.selected_branch_id, this.info.postInfo).then(function (response) {
                $17.swal({
                    title: '儲存成功',
                    type: 'success',
                    showCancelButton: false
                });
                _this.info.ajaxing = false;
                $('#edit-biz-info').modal('hide');
            }, function (error) {
                $17.swal({
                    title: '儲存失敗',
                    type: 'error',
                    showCancelButton: false
                });
                _this.info.ajaxing = false;
            });
        },
        editInfoModal: function editInfoModal() {
            var _this2 = this;

            this.info.ajaxing = true;
            this.$http.get('/adminapi/chatbot/biz-info/list/' + this.selected_branch_id).then(function (response) {
                var data = response.data.data;
                _this2.info.items = data.items;
                _this2.info.branch_values = data.values;
                _this2.info.postInfo = _lodash2.default.cloneDeep(data.values);
                _this2.info.ajaxing = false;
            }, function (error) {
                $17.swal({
                    title: '取得商家資訊失敗',
                    type: 'error',
                    showCancelButton: false
                });
                _this2.info.ajaxing = false;
            });
            $('#edit-biz-info').modal('show');
        },
        linkAction: function linkAction(key) {
            switch (key) {
                case 'class':
                    window.open('/webadmin/service', '_blank');
                    break;
                case 'service':
                    window.open('/webadmin/menu', '_blank');
                    break;
                case 'contract':
                    window.open('/webadmin/contract', '_blank');
                    break;
                case 'info':
                    this.editInfoModal();
                    break;
            }
        },
        copy: function copy(key) {
            var testingCodeToCopy = document.querySelector('#url-' + key);
            testingCodeToCopy.select();
            try {
                document.execCommand('copy');
                $17.swal({
                    title: '已複製',
                    type: 'success',
                    showCancelButton: false
                });
            } catch (err) {
                $17.swal({
                    title: '複製失敗，請重新操作',
                    type: 'error',
                    showCancelButton: false
                });
            }
            window.getSelection().removeAllRanges();
        },
        getBranchEncryptIds: function getBranchEncryptIds() {
            var _this3 = this;

            this.ajaxing = true;
            this.$http.get('/adminapi/studio/' + this.selected_studio_id + '/branches/encrypts').then(function (response) {
                _this3.studio = response.data.studio;
                _this3.branch_encrypt_ids = response.data.encrypt_ids;
                _this3.generateLinks();
                _this3.ajaxing = false;
            }, function (error) {
                _this3.ajaxing = false;
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"col-xs-12\" v-if=\"canRead\" _v-6d70e176=\"\">\n    <v-select-studio-and-branch :studio_id=\"studioId\" :branch_id=\"branchId\" :branch-without-filtered-option=\"true\" :branch-without-filtered-option-word=\"getSelectStudioName()\" _v-6d70e176=\"\">\n    </v-select-studio-and-branch>\n    <v-spinner :ajaxing=\"ajaxing\" _v-6d70e176=\"\"></v-spinner>\n    <div class=\"table-responsive m-top-20 links-table\" v-if=\"!ajaxing &amp;&amp; typeof currentEncryptBranchId=='string'\" _v-6d70e176=\"\">\n\n        <div class=\"page-header\" _v-6d70e176=\"\">\n            <bot-function-url-notice :contents=\"config.notices\" _v-6d70e176=\"\"></bot-function-url-notice>\n\n            <div class=\"row page-version\" style=\"margin-top: 30px; margin-bottom: 30px\" v-if=\"versionCounter > 1\" _v-6d70e176=\"\">\n                <div class=\"col-md-1\" _v-6d70e176=\"\"></div>\n                <div class=\"col-md-8\" _v-6d70e176=\"\">\n                    <form _v-6d70e176=\"\">\n                        <label class=\"radio-inline\" v-for=\"(item, key) in configRoot\" _v-6d70e176=\"\">\n                            <input type=\"radio\" v-model=\"version\" :value=\"key\" style=\"position: relative\" _v-6d70e176=\"\"> {{key}}\n                        </label>\n                    </form>\n                </div>\n                <div class=\"col-md-1\" _v-6d70e176=\"\"></div>\n            </div>\n        </div>\n\n        <bot-function-url-table :list=\"list\" @btn-click-setting=\"linkAction\" @btn-click-copy=\"copy\" _v-6d70e176=\"\"></bot-function-url-table>\n\n        <v-modal id=\"edit-biz-info\" confirm-btn-text=\"確認\" no-cancel=\"\" :save-clicked=\"saveInfo\" _v-6d70e176=\"\">\n            <h4 slot=\"title\" _v-6d70e176=\"\">商家資訊</h4>\n            <div slot=\"body\" _v-6d70e176=\"\">\n                <v-spinner :ajaxing=\"info.ajaxing\" _v-6d70e176=\"\"></v-spinner>\n                <div v-if=\"!info.ajaxing&amp;&amp;Object.keys(info.postInfo).length\" class=\"items\" _v-6d70e176=\"\">\n                    <div v-for=\"item in info.items\" _v-6d70e176=\"\">\n                        <label :for=\"'info'+item.id\" _v-6d70e176=\"\">\n                            <input v-model=\"info.postInfo[item.id]['is_active']\" :true-value=\"1\" :false-value=\"0\" type=\"checkbox\" :id=\"'info'+item.id\" _v-6d70e176=\"\">\n                            <span class=\"m-left-5\" _v-6d70e176=\"\">{{item.name}}</span>\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </v-modal>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.items input[_v-6d70e176] {\n  padding-right: 5px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-6d70e176", module.exports)
  } else {
    hotAPI.update("_v-6d70e176", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"./config":1023,"babel-runtime/core-js/object/values":58,"babel-runtime/helpers/extends":66,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1026:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require("vuex");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ['rowData'],
  data: function data() {
    return {
      ajaxing: false,
      result: {
        records: [this.rowData],
        pageMeta: {}
      },
      editData: {}
    };
  },
  mounted: function mounted() {},

  computed: (0, _extends3.default)({}, (0, _vuex.mapState)("webadmin/configure", ["isSeventeen"]), {
    tableConfigModify: function tableConfigModify() {
      var configs = {
        columns: [{ keys: "remark", head: "備註1" }, { keys: "remark2", head: "備註2" }, { keys: "remark3", head: "備註3" }, { keys: "remark4", head: "備註4" }, {
          keys: "edit",
          head: "",
          html: function html(item) {
            return "<st-button outline icon left-icon=\"edit\" @click=\"clickHandler('editModal')\"></st-button>";
          }
        }]
      };
      return configs;
    }
  }),
  methods: {
    refreshData: function refreshData() {
      this.$http.get('/adminapi/branch-fee-deduction/get/' + this.transactionId, {}).then(function (response) {
        this.result.records = [response.data.data];
      }, function (response) {});
      this.$refs['smart_table'].refresh();
    },
    close: function close() {
      this.rowData.subRow.close();
    },
    clickHtmlHandler: function clickHtmlHandler(val) {
      this[val.action](val.row);
    },

    editModal: function editModal() {
      var item = this.rowData;
      this.transactionId = item.id;
      this.editData = {
        remark: item.remark,
        remark2: item.remark2,
        remark3: item.remark3,
        remark4: item.remark4
      };
      $('#editModal').modal('show');
    },
    editRemark: function editRemark() {
      var editData = this.editData;
      this.ajaxing = true;
      this.$http.patch('/adminapi/branch-fee-deduction/' + this.transactionId + '/edit', editData).then(function (response) {
        this.ajaxing = false;
        $('#editModal').modal('hide');
        this.refreshData();
      }, function (response) {
        this.ajaxing = false;
        $17.swal({
          title: '編輯失敗',
          type: 'error',
          showCancelButton: false
        });
      });
    }
  }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-01148088=\"\">\n  <div style=\"display: flex; justify-content: space-between; align-items: center;\" _v-01148088=\"\">\n    <h5 _v-01148088=\"\">更多資訊</h5>\n    <button type=\"button\" @click=\"close\" class=\"close\" _v-01148088=\"\"><i class=\"fa fa-remove\" _v-01148088=\"\"></i></button>\n  </div>\n  <v-smart-table ref=\"smart_table\" :table-config=\"tableConfigModify\" :data=\"result\" @html-click-callback=\"clickHtmlHandler\" _v-01148088=\"\"></v-smart-table>\n  <v-modal id=\"editModal\" confirm-btn-text=\"確認\" :save-clicked=\"editRemark\" close-btn-text=\"取消\" _v-01148088=\"\">\n    <h4 slot=\"title\" _v-01148088=\"\">編輯備註</h4>\n    <form slot=\"body\" class=\"form-horizontal\" _v-01148088=\"\">\n      <div class=\"form-group\" _v-01148088=\"\">\n        <div class=\"col-sm-12\" _v-01148088=\"\">\n          <st-input type=\"text\" placeholder=\"請輸入備註1\" label=\"備註1\" v-model=\"editData.remark\" _v-01148088=\"\"></st-input>\n        </div>\n        <div class=\"col-sm-12\" _v-01148088=\"\">\n          <st-input type=\"text\" placeholder=\"請輸入備註2\" label=\"備註2\" v-model=\"editData.remark2\" _v-01148088=\"\"></st-input>\n        </div>\n        <div class=\"col-sm-12\" _v-01148088=\"\">\n          <st-input type=\"text\" placeholder=\"請輸入備註3\" label=\"備註3\" v-model=\"editData.remark3\" _v-01148088=\"\"></st-input>\n        </div>\n        <div class=\"col-sm-12\" _v-01148088=\"\">\n          <st-input type=\"text\" placeholder=\"請輸入備註4\" label=\"備註4\" v-model=\"editData.remark4\" _v-01148088=\"\"></st-input>\n        </div>\n      </div>\n    </form>\n  </v-modal>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-01148088", module.exports)
  } else {
    hotAPI.update("_v-01148088", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vuex":803}],1027:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _send = require('./send.vue');

var _send2 = _interopRequireDefault(_send);

var _list = require('./list.vue');

var _list2 = _interopRequireDefault(_list);

var _sub = require('./_sub.vue');

var _sub2 = _interopRequireDefault(_sub);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('branch-fee-deduction-send', _send2.default);
_vue2.default.component('branch-fee-deduction-list', _list2.default);
_vue2.default.component('branch-fee-deduction-sub-row', _sub2.default);

},{"./_sub.vue":1026,"./list.vue":1028,"./send.vue":1029,"vue":792}],1028:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n/* line 2, stdin */\n.page-div[_v-327aac59] {\n  padding: 0px 15px;\n  margin-bottom: 15px; }\n\n/* line 7, stdin */\n.form-title[_v-327aac59] {\n  font-size: 16px;\n  font-weight: bold;\n  display: inline-block;\n  width: 60px; }\n")
"use strict";

/**
 * 使用方法
 * init(ipAddress,deviceID);	// 連線與初始裝置
 * setOptionByPrintDetail();	// 設定是否列印分頁 預設列印 (true)
 * setInvoice(invoiceData);		// 設定列印發票資料
 * print;						// 列印發票
 */

/**
 *   電子發票資料格式
 *	invoiceData
 *
 * @param string  invoiceWord         - 電子發票證明聯 or 電子發票證明聯補印
 * @param string  sellerTitle         - 賣方標題名稱
 * @param string  invoicePeriod       - 期別 (yyymmdd)
 * @param string  invoiceNumber       - 發票字軌號碼
 * @param string  invoiceDateTime     - 發票開立時間 (YYYY-mm-dd hh:mm:ss)
 * @param integer randomNumber        - 隨機碼 (四位數)
 * @param integer salesAmount         - 銷售額
 * @param integer taxAmount           - 稅額
 * @param integer totalAmount         - 總計 (含稅)
 * @param string  sellerIdentifier    - 賣方統編
 * @param string  buyerIdentifier     - 買方統編
 * @param string  barCodeContent      - barCode
 * @param string  qrcodeContentOne    - qrcode 1
 * @param string  qrcodeContentTwo    - qrcode 2
 * @param string  taxType             - 稅別 應稅 TX 零稅率 TZ 免稅為空值
 * @param string  buyerName           - 買方名稱
 * @param string  buyerOrderId        - 買方訂單代碼
 * @param array   detail              - 購買明細 [名稱、數量、單價、金額]
 *
 * @return JSON
 *
 */

/**
 *   電子發票折讓資料格式
 *	CreditInvoice
 *
 * @param string  invoiceWord         - 電子發票證明聯 or 電子發票證明聯補印
 * @param string  invoicePrintDay     - 列印日期
 * @param string  sellerIdentifier    - 賣方統編
 * @param string  sellerTitle         - 賣方標題名稱
 * @param string  invoiceDateTime     - 發票開立時間 (YYYY-mm-dd)
 * @param string  invoiceNumber       - 發票字軌號碼
 * @param string  buyerIdentifier     - 買方統編
 * @param string  buyerName           - 買方名稱
 * @param integer taxAmount           - 稅額
 * @param integer salesAmount         - 銷售額
 * @param array   detail              - 購買明細 [名稱、單價、數量、金額 (未稅)、課稅別]
 *
 * @return JSON
 *
 */

/**
 *   電子發票折讓資料格式
 *	CreditInvoice
 *
 * @param string  invoiceWord         - 電子發票證明聯 or 電子發票證明聯補印
 * @param string  invoicePrintDay     - 列印日期
 * @param string  sellerIdentifier    - 賣方統編
 * @param string  sellerTitle         - 賣方標題名稱
 * @param string  invoiceDateTime     - 發票開立時間 (YYYY-mm-dd)
 * @param string  invoiceNumber       - 發票字軌號碼
 * @param string  buyerIdentifier     - 買方統編
 * @param string  buyerName           - 買方名稱
 * @param integer taxAmount           - 稅額
 * @param integer salesAmount         - 銷售額
 * @param array   detail              - 購買明細 [名稱、單價、數量、金額 (未稅)、課稅別]
 *
 * @return JSON
 *
 */
// Sample
/*
{
	"invoiceWord"		: "電子發票證明聯",
    "sellerTitle" 		: "老虎網路科技股份有限公司",
    "invoicePeriod" 	: "106 年 09-10 月",
    "invoiceNumber" 	: "WH-12345941",
    "invoiceDateTime" 	: "2017-09-09 14:13:12",
    "randomNumber" 		: "0000",
    "salesAmount" 		: "650",
    "taxAmount" 		: "50",
    "totalAmount" 		: "700",
    "sellerIdentifier" 	: "12345123",
    "buyerIdentifier" 	: "23424324",
    "barCodeContent" 	: "1234567890ABCDZZDJG",
    "qrcodeContentOne" 	: "9RqPT+lw+9fyex0dhQtDxMkR+lyLOfzU82DVYlWjI1oVBf5iiT08BgXX/LriIOu5CuIXDi7dlR73yxoYYb8l+rwr9Mhj6GWhH/jmScugyY0=:**********:3:7:1:130140240010203:1:80.000",
    "qrcodeContentTwo" 	: "9RqPT+lw+9fyex0dhQtDxMkR+lyLOfzU82DVYlWjI1oVBf5iiT08BgXX/LriIOu5CuIXDi7dlR73yxoYYb8l+rwr9Mhj6GWhH/jmScugyY0=:**********:3:7:1:130140240010203:1:80.000",
    "taxType"			: "TX",
    "buyerName"			: "陳俊仁",
    "buyerOrderId"		: "170907e694",
    "detail"            : [
                            ["飛輪票","1","100","100"],
                            ["飛輪票","1","1000","1000"],
                            ["飛輪","1","10","10"],
                            ["飛輪票","11","100","1100"],
                            ["飛輪票","123","100","12300"],
                            ["飛輪票","14","100","1400"],
                            ["CHANN","1","399","399"],
                            ["飛輪票票票","112","10","1220"],
                            ["飛輪票","1","100","100"],
                            ["跳舞卷","2","300","600"]
                          ]
}
*/

/*
"invoiceWord"		: "電子發票銷貨退回、進貨退回或折讓證明單證明聯"
"invoicePrintDay" 	: "2016-12-15"
"sellerIdentifier"	: "66668888"
"sellerTitle" 		: "這是一間公司"
"invoiceDateTime"	: "2016-11-23"
"invoiceNumber"		: "CD-00000009"
"buyerIdentifier" 	: ""
"buyerName"			: "Meslissa"
"taxAmount"			: "5"
"salesAmount"		: "15"
"detail"			: [
						["good","20","1","15","TX"],
						["good","20","1","15","TX"],
						["good","20","1","15","TX"]
					  ]

Add a comment to this line
*/

var printer = {

    _device: null,
    _builder: null,
    _lang: "zh-tw",
    _textSmooth: true,
    _printerAddress: {},

    // 自訂選擇是否列印明細
    _optionByPrintDetail: true,

    _invoiceWord: "",
    _invoiceDetailTitle: "交 易 明 細",
    _invoiceHeader: "[品名]     [數量][單價][金額]",

    _sellerTitle: "",
    _invoicePeriod: "",
    _invoiceNumber: "",
    _invoicePrintDay: "",
    _invoiceDateTime: "",
    _randomNumber: "",
    _salesAmount: "",
    _taxAmount: "",
    _totalAmount: "",
    _sellerIdentifier: "",
    _buyerIdentifier: "",
    _barCodeContent: "",
    _qrCodeContentOne: "",
    _qrCodeContentTwo: "",
    _taxType: "",
    _buyerName: "",
    _buyerOrderId: "",
    _detail: null,
    _remark: '',

    _studioName: "",
    _contractName: "",
    _ticketName: "",
    _description: "",
    _endTime: "",
    _userName: "",
    _ticketNumber: "",
    _qrCode: "",

    onReceive: function onReceive() {},

    // 設定 發票語系
    setLang: function setLang(lang) {
        if (lang != '') {
            return this._lang = lang;
        }
    },

    // 設定 發票抬頭		
    setInvoiceWord: function setInvoiceWord(invoiceWord) {
        if (invoiceWord != '') {
            return this._invoiceWord = invoiceWord;
        }
        return console.log("發票抬頭 設定錯誤");
    },

    // 設定 賣方標題
    setSellerTitle: function setSellerTitle(sellerTitle) {
        if (sellerTitle != '') {
            return this._sellerTitle = sellerTitle;
        }
        return console.log("賣方標題 設定錯誤");
    },

    // 設定 期別
    setInvoicePeriod: function setInvoicePeriod(invoicePeriod) {
        if (invoicePeriod != '') {
            return this._invoicePeriod = invoicePeriod;
        }
        return console.log("期別 設定錯誤");
    },

    // 設定 發票字軌號碼
    setInvoiceNumber: function setInvoiceNumber(invoiceNumber) {
        if (invoiceNumber != '') {
            return this._invoiceNumber = invoiceNumber;
        }
        return console.log("發票字軌號碼 設定錯誤");
    },

    //發票列印日期 (YYYY-mm-dd)
    setInvoicePrintDay: function setInvoicePrintDay(invoicePrintDay) {

        if (invoicePrintDay != '') {

            return this._invoicePrintDay = invoicePrintDay;
        }
        return console.log("發票列印日 設定錯誤");
    },

    //發票開立時間 (YYYY-mm-dd hh:mm:ss)
    setInvoiceDateTime: function setInvoiceDateTime(invoiceDateTime) {
        if (invoiceDateTime != '') {
            return this._invoiceDateTime = invoiceDateTime;
        }
        return console.log("發票開立時間 設定錯誤");
    },

    // 隨機碼 (四位數)
    setRandomNumber: function setRandomNumber(randomNumber) {
        if (randomNumber != '') {
            return this._randomNumber = randomNumber;
        }
        return console.log("隨機碼 設定錯誤");
    },

    // 銷售額
    setSalesAmount: function setSalesAmount(salesAmount) {
        if (salesAmount !== '') {
            return this._salesAmount = salesAmount;
        }
        return console.log("銷售額 設定錯誤");
    },

    // 稅額
    setTaxAmount: function setTaxAmount(taxAmount) {
        if (taxAmount !== '') {
            return this._taxAmount = taxAmount;
        }
        return console.log("稅額 設定錯誤");
    },

    // 總計 (含稅)
    setTotalAmount: function setTotalAmount(totalAmount) {
        if (totalAmount !== '') {
            return this._totalAmount = totalAmount;
        }
        return console.log("總計 設定錯誤");
    },

    // 賣方統編
    setSellerIdentifier: function setSellerIdentifier(sellerIdentifier) {
        if (sellerIdentifier !== '') {
            return this._sellerIdentifier = sellerIdentifier;
        }
        return console.log("賣方統編 設定錯誤");
    },

    // 買方統編
    setBuyerIdentifier: function setBuyerIdentifier(buyerIdentifier) {
        if (buyerIdentifier !== '') {
            return this._buyerIdentifier = buyerIdentifier;
        }
        return console.log("買方統編 未設定");
    },

    // barCode 產生
    setBarCodeContent: function setBarCodeContent(barCodeContent) {
        //ESC POS 指令
        var device_code = "\x1d\x48\x00\x1d\x68\x30\x1d\x77\x01\x1d\x6b\x45\x13";
        var x = "";

        if (barCodeContent != '') {
            for (i = 0; i < barCodeContent.length; i++) {
                x += this.num_string(barCodeContent.charCodeAt(i).toString(16));
            }
            return this._barCodeContent = device_code + x;
        }
        return console.log("barCode 設定錯誤");
    },

    //QRCode (左邊)
    setQrCodeContentOne: function setQrCodeContentOne(qrCodeContentOne) {
        if (qrCodeContentOne != '') {
            return this._qrCodeContentOne = qrCodeContentOne;
        }
        return console.log("QRCode(左) 設定錯誤");
    },

    //QRCode (右邊)
    setQrCodeContentTwo: function setQrCodeContentTwo(qrCodeContentTwo) {
        if (qrCodeContentTwo != '') {
            return this._qrCodeContentTwo = qrCodeContentTwo;
        }
        return console.log("QRCode(右) 設定錯誤");
    },

    // 應稅為 TX 零稅率為 TZ 免稅為空值
    setTaxType: function setTaxType(taxType) {
        if (taxType != '') {
            return this._taxType = taxType;
        }
        return "";
    },

    // 買方名稱
    setBuyerName: function setBuyerName(buyerName) {
        if (buyerName != '') {
            return this._buyerName = buyerName;
        }
        return console.log("買方名稱 設定錯誤");
    },

    // Remark
    setRemark: function setRemark(remark) {
        if (remark != '') {
            return this._remark = remark;
        }
        return console.log("發票 Remark 未設定");
    },

    // 訂單編號
    setBuyerOrderId: function setBuyerOrderId(buyerOrderId) {
        if (buyerOrderId != '') {
            return this._buyerOrderId = buyerOrderId;
        }
        return console.log("訂單編號 設定錯誤");
    },

    // 訂單明細
    setDetail: function setDetail(detail) {
        if (detail != '') {
            return this._detail = detail;
        }
        return "";
    },

    //場館名稱
    setStudioName: function setStudioName(studioName) {
        if (studioName != '') {
            return this._studioName = studioName;
        }
        return console.log("場館名稱 未設定");
    },

    // 方案名稱
    setContractName: function setContractName(contractName) {
        if (contractName != '') {
            return this._contractName = contractName;
        }
        return console.log("方案名稱 未設定");
    },

    // 票卷名稱
    setTicketName: function setTicketName(TicketName) {
        if (TicketName != '') {
            return this._ticketName = TicketName;
        }
        return console.log("票卷名稱 未設定");
    },

    // 描述
    setDescription: function setDescription(description) {
        if (description != '') {
            return this._description = description;
        }
        return console.log("方案描述 未設定");
    },

    // 到期時間(使用效期)
    setEndTime: function setEndTime(endTime) {
        if (endTime != '') {
            return this._endTime = '使用效期(exp):' + endTime;
        }
        return console.log("到期時間(使用效期) 未設定");
    },

    // 使用者
    setUserName: function setUserName(userName) {
        if (userName != '') {
            return this._userName = userName;
        }
        return console.log("使用者 未設定");
    },

    // 票卷代碼
    setTicketNumber: function setTicketNumber(ticketNumber) {
        if (ticketNumber != '') {
            return this._ticketNumber = ticketNumber;
        }
        return console.log("票券代碼 未設定");
    },

    // QrCode
    setQrCode: function setQrCode(qrCode) {
        if (qrCode != '') {
            return this._qrCode = qrCode;
        }
        return console.log("票卷 QrCode 未設定");
    },

    // 字串轉換
    num_string: function num_string(num) {
        if (/^[a-f0-9]{1,2}$/i.test(num)) {
            return eval('"\\x' + num + '"');
        }
    },

    // 列印平滑字體
    setTextSmooth: function setTextSmooth(mode) {
        if (mode == false) {
            return this._textSmooth = false;
        }
    },

    //處理位移
    paddingLeft: function paddingLeft(str, lenght) {
        lenght = typeof lenght !== 'undefined' ? lenght : 7;

        if (str.length >= lenght) return str;else return this.paddingLeft(str + " ", lenght);
    },

    // 圖碼轉換
    escapeCode: function escapeCode(s) {
        var escape = /\\x[0-9A-Fa-f]{2}/g;
        if (escape.test(s)) {
            s = s.replace(escape, function (c) {
                return String.fromCharCode(parseInt(c.slice(2), 16));
            });
        }
        return this.escapeText(s);
    },

    // 字元處理
    escapeText: function escapeText(s) {
        var x = s + "\n";
        var escape = /\\[tnr\\]|\\/g;
        if (escape.test(x)) {
            s = s.replace(escape, function (c) {
                var r = '';
                switch (c) {
                    case '\\t':
                        r = '\x09';
                        break;
                    case '\\n':
                        r = '\x0a';
                        break;
                    case '\\r':
                        r = '\x0d';
                        break;
                    case '\\\\':
                        r = '\\';
                        break;
                    default:
                        break;
                }
                return r;
            });
        }
        return s;
    },

    setPrinterAddress: function setPrinterAddress(ipAddress, deviceID) {
        this._printerAddress = {
            host_name: deviceID,
            protocol: 'http',
            host: ipAddress,
            path: '/cgi-bin/epos/service.cgi?devid=' + deviceID + '&time?out=60000'
        };
    },

    // 設定 裝置
    init: function init(ipAddress, deviceID) {
        this.setPrinterAddress(ipAddress, deviceID);
        var address = this._printerAddress.protocol + '://' + this._printerAddress.host + this._printerAddress.path;
        this._device = new epson.ePOSPrint(address);
        this._device.onreceive = this.onReceive;
        this._builder = new epson.ePOSBuilder();
    },

    // 設定 是否列印明細
    setOptionByPrintDetail: function setOptionByPrintDetail(mode) {
        if (mode == false) {
            return this._optionByPrintDetail = false;
        }
    },

    // 設定要列印的發票內容
    setInvoice: function setInvoice(invoiceData) {
        this.setInvoiceWord(invoiceData.invoiceWord);
        this.setSellerTitle(invoiceData.sellerTitle);
        this.setInvoicePeriod(invoiceData.invoicePeriod);
        this.setInvoiceNumber(invoiceData.invoiceNumber);
        this.setInvoiceDateTime(invoiceData.invoiceDateTime);
        this.setRandomNumber(invoiceData.randomNumber);
        this.setSalesAmount(invoiceData.salesAmount);
        this.setTaxAmount(invoiceData.taxAmount);
        this.setTotalAmount(invoiceData.totalAmount);
        this.setSellerIdentifier(invoiceData.sellerIdentifier);
        this.setBuyerIdentifier(invoiceData.buyerIdentifier);
        this.setBarCodeContent(invoiceData.barCodeContent);
        this.setQrCodeContentOne(invoiceData.qrCodeContentOne);
        this.setQrCodeContentTwo(invoiceData.qrCodeContentTwo);
        this.setTaxType(invoiceData.taxType);
        this.setBuyerName(invoiceData.buyerName);
        this.setBuyerOrderId(invoiceData.buyerOrderId);
        this.setDetail(invoiceData.detail);
        this.setRemark(invoiceData.remark);
    },

    // 設定方案
    setMemberContract: function setMemberContract(memberContractData) {
        this.setStudioName(memberContractData.studioName);
        this.setContractName(memberContractData.contractName);
        this.setDescription(memberContractData.description);
        this.setEndTime(memberContractData.endTime);
        this.setUserName(memberContractData.userName);
        this.setQrCode(memberContractData.qrCode);
    },

    // 設定票卷
    setTicket: function setTicket(ticketData) {
        this.setStudioName(ticketData.studioName);
        this.setTicketName(ticketData.ticketName);
        this.setDescription(ticketData.description);
        this.setEndTime(ticketData.endTime);
        this.setTicketNumber(ticketData.ticketNumber);
        this.setQrCode(ticketData.qrCode);
    },

    // 列印發票
    // 設定要列印的折讓內容
    setCreditInvoice: function setCreditInvoice(invoiceData) {
        this.setInvoiceWord(invoiceData.invoiceWord);
        this.setInvoicePrintDay(invoiceData.invoicePrintDay);
        this.setSellerIdentifier(invoiceData.sellerIdentifier);
        this.setSellerTitle(invoiceData.sellerTitle);
        this.setInvoiceDateTime(invoiceData.invoiceDateTime);
        this.setInvoiceNumber(invoiceData.invoiceNumber);
        this.setBuyerIdentifier(invoiceData.buyerIdentifier);
        this.setBuyerName(invoiceData.buyerName);
        this.setTaxAmount(invoiceData.taxAmount);
        this.setSalesAmount(invoiceData.salesAmount);
        this.setDetail(invoiceData.detail);
    },
    //清理暫存資料
    setClean: function setClean() {
        this._invoiceWord = "";
        this._sellerTitle = "";
        this._invoicePeriod = "";
        this._invoiceNumber = "";
        this._invoicePrintDay = "";
        this._invoiceDateTime = "";
        this._randomNumber = "";
        this._salesAmount = "";
        this._taxAmount = "";
        this._totalAmount = "";
        this._sellerIdentifier = "";
        this._buyerIdentifier = "";
        this._barCodeContent = "";
        this._qrCodeContentOne = "";
        this._qrCodeContentTwo = "";
        this._taxType = "";
        this._buyerName = "";
        this._buyerOrderId = "";
        this._detail = null;

        this._studioName = "";
        this._contractName = "";
        this._ticketName = "";
        this._description = "";
        this._endTime = "";
        this._userName = "";
        this._ticketNumber = "";
        this._qrCode = "";
    },
    // 列印
    print: function print() {
        this._builder.addTextLang(this._lang);
        this._builder.addTextSmooth(this._textSmooth);
        this._builder.addPageBegin();
        this._builder.addPageArea(0, 0, 480, 710);
        this._builder.addTextSize(1, 2);
        this._builder.addPagePosition(37, 54);
        this._builder.addText(this.escapeText(this._sellerTitle));

        if (this._invoiceWord.length == 7) {
            this._builder.addTextSize(2, 2);
            this._builder.addPagePosition(17, 124);
            this._builder.addText(this.escapeText(this._invoiceWord));
        }
        if (this._invoiceWord.length > 7) {
            this._builder.addTextDouble(true, true);
            this._builder.addTextSize(1, 2);
            this._builder.addPagePosition(63, 124);
            this._builder.addText(this.escapeText(this._invoiceWord));
        }

        this._builder.addTextSize(2, 2);
        this._builder.addPagePosition(62, 194);
        this._builder.addText(this.escapeText(this._invoicePeriod));
        this._builder.addTextDouble(true, true);
        this._builder.addTextSize(3, 3);
        this._builder.addPagePosition(42, 254);
        this._builder.addText(this.escapeText(this._invoiceNumber));
        this._builder.addTextSize(1, 1);
        this._builder.addPagePosition(27, 280);
        if (this._buyerIdentifier != null) {
            this._builder.addText(this.escapeText(this._invoiceDateTime + "        格式 25"));
        } else {
            this._builder.addText(this.escapeText(this._invoiceDateTime));
        }

        this._builder.addPagePosition(27, 306);
        this._builder.addText(this.escapeText("隨機碼 : " + this._randomNumber + "      總計 : " + this._totalAmount));
        this._builder.addPagePosition(27, 332);

        if (this._buyerIdentifier != null) {
            this._builder.addText(this.escapeText("賣方 : " + this._sellerIdentifier + "    買方 : " + this._buyerIdentifier));
        } else {
            this._builder.addText(this.escapeText("賣方 : " + this._sellerIdentifier));
        }

        this._builder.addPagePosition(27, 396);
        this._builder.addCommand(this._barCodeContent);

        this._builder.addPagePosition(37, 420);
        this._builder.addSymbol(this.escapeCode(this._qrCodeContentOne), "qrcode_model_2", "level_q", 3, 8, 0);
        this._builder.addPagePosition(200, 420);
        this._builder.addSymbol(this.escapeCode(this._qrCodeContentTwo), "qrcode_model_2", "level_q", 3, 6, 0);
        // if (this._remark !== '') {
        //     this._builder.addPagePosition(10, 568);
        //     this._builder.addText(this.escapeText("備註 : " + this._remark));
        // }
        // this._builder.addPagePosition(10, 594);
        //this._builder.addText(this.escapeText("退貨憑電子發票證明聯辦理"));
        this._builder.addPagePosition(25, 640);
        this._builder.addText(this.escapeText("--------------------------------------"));
        this._builder.addPageEnd();
        // 如果買方有開統編，明細一定要印，不能切斷
        if (this._buyerIdentifier == null) {
            this._builder.addCut(this._builder.CUT_NO_FEED);
        }

        // 總高計算
        var headerH = 170; // 交易明細的頭
        var detailH = 0; // 交易明細
        var footerH = 300; // 課稅別那塊
        for (var y = 0; y < this._detail.length; y++) {
            detailH += 60;
        }
        var totalH = headerH + detailH + footerH;
        var fullPageH = 710;
        if (totalH > 710) {
            fullPageH = 710 * Math.ceil(totalH / 710);
        }

        // 如果不列印明細，買方也不能開統編
        if (this._optionByPrintDetail == true || this._buyerIdentifier != null) {
            this._builder.addPageBegin();
            this._builder.addPageArea(0, 0, 480, fullPageH);
            this._builder.addPagePosition(5, 20);
            this._builder.addPagePosition(20, 104);
            this._builder.addTextSize(2, 2);
            this._builder.addText(this.escapeText(this._invoiceDetailTitle));
            this._builder.addTextSize(1, 1);
            this._builder.addPagePosition(20, 140);
            this._builder.addText(this.escapeText(this._invoiceHeader));

            var yPosition = 170;
            for (i = 0; i < this._detail.length; i++) {
                this._builder.addPagePosition(20, yPosition);
                var productName = this._detail[i][0];
                this._builder.addText(productName);
                var halfWidth = productName.match(/[!-~]/g) == undefined ? 0 : productName.match(/[!-~]/g).length;
                //計算減少半形字需佔用的空間
                var detailPosition = parseInt((productName.length - halfWidth + halfWidth / 2.5) / 15) * 30;
                yPosition = yPosition + 30 + detailPosition;

                this._builder.addPagePosition(20, yPosition);
                this._builder.addText("                " + this.paddingLeft(this._detail[i][1], 8) + " " + this.paddingLeft(this._detail[i][2], 6) + " " + this.paddingLeft(this._detail[i][3], 6));

                // this._builder.addText(this.escapeText(this.paddingLeft(this._detail[i][0]) + " " + this.paddingLeft(this._detail[i][1], 8) + " " + this.paddingLeft(this._detail[i][2], 6) + " " + this.paddingLeft(this._detail[i][3], 6)));

                yPosition = yPosition + 30;
            }
            if (710 - (headerH + detailH) > footerH) {
                yPosition = yPosition + 30;
            } else {
                this._builder.addPageEnd();
                this._builder.addPageBegin();
                this._builder.addPageArea(0, 0, 480, 300);
                yPosition = 30;
            }

            this._builder.addPagePosition(20, yPosition);
            this._builder.addText(this.escapeText("課稅別 : " + this._taxType));

            if (this._buyerIdentifier != null) {
                yPosition = yPosition + 30;
                this._builder.addPagePosition(20, yPosition);
                this._builder.addText(this.escapeText("銷售額 : " + this._salesAmount + "      稅額 : " + this._taxAmount));
            }
            yPosition = yPosition + 30;
            this._builder.addPagePosition(20, yPosition);
            this._builder.addText(this.escapeText("總計 : " + this._totalAmount));

            yPosition = yPosition + 30;
            this._builder.addPagePosition(5, yPosition);
            this._builder.addText(this.escapeText("--------------------------------------"));

            yPosition = yPosition + 30;
            this._builder.addPagePosition(20, yPosition);
            this._builder.addText(this.escapeText("買受人 : " + this._buyerName));

            yPosition = yPosition + 30;
            this._builder.addPagePosition(20, yPosition);
            this._builder.addText(this.escapeText("訂單編號 : " + this._buyerOrderId));

            if (this._remark !== '') {
                yPosition = yPosition + 30;
                this._builder.addPagePosition(20, yPosition);
                this._builder.addText(this.escapeText("備註 : " + this._remark));
            }
            yPosition = yPosition + 30;
            this._builder.addPagePosition(20, yPosition);
            this._builder.addText(this.escapeText("退貨憑電子發票證明聯辦理"));

            this._builder.addPageEnd();
            this._builder.addCut(this._builder.CUT_NO_FEED);
        }
    },

    // 列印方案
    printMemberContract: function printMemberContract() {
        this._builder.addTextAlign(this._builder['ALIGN_CENTER']);
        this._builder.addTextLang(this._lang);
        this._builder.addTextSmooth(true);

        this._builder.addTextSize(1, 2);
        this._builder.addText(this.escapeText(this._studioName + "\n"));

        this._builder.addTextSize(1, 2);
        this._builder.addText(this.escapeText(this._contractName + "\n"));

        this._builder.addTextSize(1, 1);
        this._builder.addText(this.escapeText("------------------------------------------\n"));

        this._builder.addTextAlign(this._builder['ALIGN_LEFT']);
        this._builder.addText(this.escapeText(this._description + "\n"));

        this._builder.addTextAlign(this._builder['ALIGN_CENTER']);
        this._builder.addText(this.escapeText("------------------------------------------\n"));
        this._builder.addText(this.escapeText(this._endTime + "\n"));
        this._builder.addText(this.escapeText("------------------------------------------\n"));
        this._builder.addText(this.escapeText(this._userName + "\n"));
        this._builder.addText(this.escapeText("------------------------------------------\n"));
        this._builder.addSymbol(this.escapeCode(this._qrCode), "qrcode_model_2", "level_m", 8, 8, 0);
        this._builder.addText(this.escapeText("\n\n\n\n\n"));
        this._builder.addCut(this._builder.CUT_NO_FEED);
    },

    // 列印票卷
    printTicket: function printTicket() {
        this._builder.addTextAlign(this._builder['ALIGN_CENTER']);
        this._builder.addTextLang(this._lang);
        this._builder.addTextSmooth(true);

        this._builder.addTextSize(1, 2);
        this._builder.addText(this.escapeText(this._studioName + "\n"));

        this._builder.addTextSize(1, 2);
        this._builder.addText(this.escapeText(this._ticketName + "\n"));

        this._builder.addTextSize(1, 1);
        this._builder.addText(this.escapeText("------------------------------------------\n"));

        this._builder.addTextAlign(this._builder['ALIGN_LEFT']);
        this._builder.addText(this.escapeText(this._description + "\n"));

        this._builder.addTextAlign(this._builder['ALIGN_CENTER']);
        this._builder.addText(this.escapeText("------------------------------------------\n"));
        this._builder.addText(this.escapeText(this._endTime + "\n"));
        this._builder.addText(this.escapeText("------------------------------------------\n"));
        this._builder.addText(this.escapeText(this._ticketNumber + "\n"));
        this._builder.addText(this.escapeText("------------------------------------------\n"));
        this._builder.addSymbol(this.escapeCode(this._qrCode), "qrcode_model_2", "level_m", 8, 8, 0);
        this._builder.addText(this.escapeText("\n\n\n\n\n"));
        this._builder.addCut(this._builder.CUT_NO_FEED);
    },
    buildData: function buildData() {
        return this._builder.toString();
    },
    realPrint: function realPrint() {
        var data = this.buildData();
        this._device.send(data);
        this.clearCache();
    },
    clearCache: function clearCache() {
        this._builder.message = '';
        this.setClean();
    },


    // 列印折讓發票
    printCreditInvoice: function printCreditInvoice() {
        this._builder.addTextAlign(this._builder['ALIGN_CENTER']);
        this._builder.addTextLang(this._lang);
        this._builder.addTextSmooth(true);
        this._builder.addTextSize(2, 2);

        this._builder.addText(this.escapeText(this._invoiceWord + "\n"));

        this._builder.addTextSize(3, 3);

        this._builder.addText(this.escapeText(this._invoicePrintDay + "\n"));

        this._builder.addTextAlign(this._builder['ALIGN_LEFT']);
        this._builder.addTextSize(1, 1);

        this._builder.addText(this.escapeText("賣方統編 : " + this._sellerIdentifier + "\n"));
        this._builder.addText(this.escapeText("賣方名稱 : " + this._sellerTitle + "\n"));
        this._builder.addText(this.escapeText("\n"));
        this._builder.addText(this.escapeText("發票開立日期 : " + this._invoiceDateTime + "\n"));

        this._builder.addTextAlign(this._builder['ALIGN_CENTER']);
        this._builder.addTextSize(3, 3);

        this._builder.addText(this.escapeText(this._invoiceNumber + "\n"));

        this._builder.addTextAlign(this._builder['ALIGN_LEFT']);
        this._builder.addTextSize(1, 1);

        this._builder.addText(this.escapeText("買方統編 : " + this._buyerIdentifier + "\n"));
        this._builder.addText(this.escapeText("買方名稱 : " + this._buyerName + "\n"));
        this._builder.addText(this.escapeText("\n\n\n\n\n"));
        this._builder.addText(this.escapeText("------------------------------------------\n"));
        this._builder.addText(this.escapeText("品名 單價*數量 金額 (未稅) 課稅別" + "\n"));

        for (i = 0; i < this._detail.length; i++) {
            this._builder.addText(this._detail[i]['name'] + "\n");
            //Add a comment to this line
            this._builder.addText("      " + this.paddingLeft(this._detail[i]['price'], 15) + " " + this.paddingLeft(this._detail[i]['amount'], 10) + " " + this._detail[i]['tax'] + "\n");
        }

        this._builder.addText(this.escapeText("營業稅合計 : " + this._taxAmount + "\n"));
        this._builder.addText(this.escapeText("金額 (不含稅之進貨額) 合計 : " + this._salesAmount + "\n"));
        this._builder.addText(this.escapeText("\n\n\n"));
        this._builder.addText(this.escapeText("簽收人 : " + "\n\n\n\n\n\n\n"));

        this._builder.addCut(this._builder.CUT_NO_FEED);
    },

    setPrinterDefault: function setPrinterDefault(ip) {
        printer.init(ip, 'local_printer');

        printer._builder.addCommand('\x1D\x28\x45\x03\x00\x01\x49\x4E\x1D\x28\x45\x04\x00\x05\x03\x02\x00\x1D\x28\x45\x04\x00\x05\x0B\x01\x00\x1D\x28\x45\x04\x00\x02\x4F\x55\x54');

        printer._device.send(printer._builder.toString());
    }
};
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    var vm = this;
    return {
      tableConfig: {
        subRow: {
          enable: true
        },
        subRowStyleCondition: function subRowStyleCondition(row, idx) {
          return {
            'background-color': '#E5E7EB'
          };
        },
        columns: [{
          keys: 'created_at',
          head: '發動時間',
          minWidth: '200px',
          html: function html(item) {
            var iconClass = item.subRow.isShow ? 'fa fa-caret-up' : 'fa fa-caret-down';
            return '<button class="btn btn-sm m-right-10" @click="clickHandler(\'viewSubRow\')"><span class="' + iconClass + '"></span></button>' + item.created_at;
          }
        }, { keys: "brand_name", head: "品牌" }, { keys: "branch_name", head: "場館" }, {
          keys: "process_value",
          head: "金額",
          html: function html(item) {
            return vm.thousandthFormat(item.process_value);
          }
        }, {
          keys: "option1",
          head: "費用類型",
          html: function html(item) {
            return item.option1 == 4 ? '其他費用' : '';
          }
        }, {
          keys: "process_balance_type",
          head: "交易正負值",
          html: function html(item) {
            return item.process_balance_type == 0 ? '收款' : '退款';
          }
        }, { keys: "option2", head: "預計撥款日" }, {
          keys: "current_state",
          head: "指示狀態",
          html: function html(item) {
            var currentState = { 1: '等待', 2: '失敗', 3: '成功' };
            return currentState[item.current_state];
          }
        }, { keys: "transaction_id", head: "處理流水號" }, { keys: "serial", head: "自訂編號" }]
      },
      relatedFilterWatcher: {
        studio_id: {
          watcher: null,
          options: "studioList",
          vModel: "studioId",
          trackBy: "id",
          type: "single"
        },
        branch_id: {
          watcher: "studioId",
          options: "branchList",
          vModel: "branchIds",
          trackBy: "id",
          type: "multiple"
        }
      },
      result: {
        records: [],
        pageMeta: {}
      },
      localFilter: {
        remark: ''
      }
    };
  },
  created: function created() {
    this.syncRelatedMultipleSelectByQuery({ vm: this, relatedFilterWatcher: this.relatedFilterWatcher });
  },
  mounted: function mounted() {
    var _this = this;

    this.configuredRun(function () {
      _this.changeFilterOption({
        prop: "studioId",
        value: {
          id: _this.configureStates.studioId,
          brand_name: ""
        }
      });
      _this.changeFilterOption({
        prop: "branchIds",
        value: _this.configureStates.branchIds
      });
      if (_this.configureStates.isSeventeen) {
        return _this.fetchStudioList();
      }
      if (_this.configureStates.isBranch) {
        _this.branchIds = [{
          id: _this.configureStates.branchIds,
          branch_name: ""
        }];
      }
    });

    this.changeDateOption({
      prop: 'startDate',
      value: moment().add(-1, 'months').startOf('month').format('YYYY/MM/DD')
    });

    this.changeDateOption({
      prop: 'endDate',
      value: moment().add(-1, 'months').endOf('month').format('YYYY/MM/DD')
    });

    var query = $17.getUrlQueryStrings();
    this.localFilter.remark = query.remark ? query.remark : '';
  },

  watch: (0, _defineProperty3.default)({}, "filterOptions.studioId", function filterOptionsStudioId(n, o) {
    if ((this.configureStates.isSeventeen || this.configureStates.isStudio) && n && n.id) {
      this.fetchBranchList({
        studioId: n.id
      });
    }
  }),
  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
    configureStates: function configureStates(state) {
      return state.webadmin.configure;
    }
  }), (0, _vuex.mapState)("webadmin/configure", ["configured", "studioList", "branchList", "branchId"]), (0, _vuex.mapState)("webadmin/baseReport", ["blockOpenStatus", "dateOptions", "filterOptions", "itemOptions", "ajaxing", "list", "total", "pageMeta", "queryPara"]), {
    studioId: {
      get: function get() {
        return this.filterOptions.studioId;
      },
      set: function set(newValue) {
        var _this2 = this;

        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
          return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return _this2.changeFilterOption({ 'prop': 'studioId', value: newValue });

                case 2:
                  _this2.cleanBranch();

                  if (!newValue) {
                    _context.next = 6;
                    break;
                  }

                  _context.next = 6;
                  return _this2.fetchBranchList({ studioId: newValue.id });

                case 6:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this2);
        }))();
      }
    },
    branchIds: {
      get: function get() {
        return this.filterOptions.branchIds;
      },
      set: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(newValue) {
          return _regenerator2.default.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  this.changeFilterOption({ 'prop': 'branchIds', value: newValue });

                case 1:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        function set(_x) {
          return _ref.apply(this, arguments);
        }

        return set;
      }()
    },
    display: {
      get: function get() {
        return this.$store.state.webadmin.baseReport.display;
      },
      set: function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(newValue) {
          return _regenerator2.default.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return this.changeDisplay(newValue);

                case 2:
                case 'end':
                  return _context3.stop();
              }
            }
          }, _callee3, this);
        }));

        function set(_x2) {
          return _ref2.apply(this, arguments);
        }

        return set;
      }()
    },
    tableConfigModify: function tableConfigModify() {
      var configs = this.tableConfig;
      return configs;
    }
  }),
  methods: (0, _extends3.default)({
    thousandthFormat: function thousandthFormat(value) {
      return '$' + $17.thousandthFormat(value);
    },
    getParam: function getParam() {
      var data = {
        'start_date': this.dateOptions.startDate,
        'end_date': this.dateOptions.endDate,
        'display': this.display
      };
      if (this.filterOptions.studioId && this.filterOptions.studioId.hasOwnProperty('id') && this.filterOptions.studioId != 0) {
        data.studio_id = this.studioId.id;
      }
      if (this.filterOptions.branchIds && this.filterOptions.branchIds.length > 0) {
        data.branch_id = this.branchIds.map(function (item) {
          return item.id;
        });
      }
      if (this.localFilter.remark) {
        data.remark = this.localFilter.remark;
      }
      return data;
    },
    submitSearch: function submitSearch() {
      this.changeFilterOption({ prop: "pageSize", value: 25 });
      var params = this.getParam();
      $17.updateUrlQueryString(params);
      this.keepQueryParam(params);

      this.changePage(1);
    }
  }, (0, _vuex.mapActions)("webadmin/configure", ["configuredRun", "fetchStudioList", "fetchBranchList"]), (0, _vuex.mapActions)("webadmin/baseReport", ["submit", "toggleBlock", "changeDateOption", "changeFilterOption", "changeItemOption", "cleanBranch", "changeAjaxing", "changeDateOptionAfter", "syncDateAndDisplayByQuery", "syncLocalMultipleSelectByQuery", "syncRelatedMultipleSelectByQuery", "changeDisplay", "keepQueryParam"]), {
    getQueryResult: function getQueryResult(params) {
      var _this3 = this;

      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                params['query_type'] = params.order_id ? 'order_id' : 'time';

                _this3.result = {
                  records: [],
                  pageMeta: {}
                };
                _this3.changeAjaxing(true);
                _context4.next = 5;
                return _this3.$http.get('/adminapi/branch-fee-deduction/list/', { params: params }).then(function (response) {
                  _this3.result = response.data;
                }, function (error) {
                  $17.swal({
                    title: error.body.message,
                    type: "warning"
                  });
                });

              case 5:
                _this3.changeAjaxing(false);

              case 6:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this3);
      }))();
    },
    changePage: function changePage(page) {
      var _this4 = this;

      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5() {
        var params;
        return _regenerator2.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this4.changeFilterOption({
                  prop: "page",
                  value: page
                });

                params = _this4.queryPara;


                params.page_size = _this4.filterOptions.pageSize;
                params.page = _this4.filterOptions.page;

                _context5.next = 6;
                return _this4.getQueryResult(params);

              case 6:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this4);
      }))();
    },
    clickHtmlHandler: function clickHtmlHandler(val) {
      this[val.action](val.row);
    },
    viewSubRow: function viewSubRow(item) {
      var subRow = { component: 'branch-fee-deduction-sub-row' };
      item.subRow.auto(subRow);
    }
  })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"page-div\" _v-327aac59=\"\">\n  <v-webadmin-report :block-open-status=\"blockOpenStatus\" :date-options=\"dateOptions\" :toggle-block=\"toggleBlock\" :change-date-option=\"changeDateOptionAfter\" :submit=\"submitSearch\" limit-date=\"90\" title=\"藍新金流-平台費用扣款指示列表\" _v-327aac59=\"\">\n    <div slot=\"second-block\" _v-327aac59=\"\">\n      <div class=\"filters\" _v-327aac59=\"\">\n        <div class=\"row\" _v-327aac59=\"\">\n          <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen\" _v-327aac59=\"\">\n            <div class=\"form-group\" _v-327aac59=\"\">\n              <v-mutiselect :model.sync=\"studioId\" :options=\"studioList\" :preserve-search=\"true\" :placeholder=\"configureStates.ajaxing.studioList ? '品牌讀取中…' : '全部品牌'\" label=\"brand_name\" track-by=\"id\" _v-327aac59=\"\">\n              </v-mutiselect>\n            </div>\n          </div>\n          <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen || configureStates.isStudio\" _v-327aac59=\"\">\n            <div class=\"form-group\" _v-327aac59=\"\">\n              <v-mutiselect :model.sync=\"branchIds\" :options=\"branchList\" :multiple=\"true\" :close-on-select=\"true\" :clear-on-select=\"false\" :hide-selected=\"false\" :preserve-search=\"true\" :searchable=\"false\" :placeholder=\"configureStates.ajaxing.branchList ? '場館讀取中…' : '全部場館'\" label=\"branch_name\" track-by=\"id\" tag-name=\"branch_name\" :max-height=\"500\" _v-327aac59=\"\">\n              </v-mutiselect>\n            </div>\n          </div>\n          <div class=\"col-sm-6\" _v-327aac59=\"\">\n            <div class=\"form-group\" _v-327aac59=\"\">\n              <st-input type=\"text\" placeholder=\"搜尋備註關鍵字\" v-model=\"localFilter.remark\" icon=\"search\" _v-327aac59=\"\"></st-input>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n\n  </v-webadmin-report>\n  <div v-show=\"display === 'show'\" _v-327aac59=\"\">\n    <div class=\"m-top-10\" _v-327aac59=\"\">\n      <v-smart-table ref=\"smart_table\" :table-config=\"tableConfigModify\" :is-ajaxing=\"ajaxing\" :data=\"{records:result.records,pageMeta:result.pageMeta}\" :page-sync-url-query=\"false\" @change-page=\"changePage\" @html-click-callback=\"clickHtmlHandler\" _v-327aac59=\"\"></v-smart-table>\n    </div>\n  </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n/* line 2, stdin */\n.page-div[_v-327aac59] {\n  padding: 0px 15px;\n  margin-bottom: 15px; }\n\n/* line 7, stdin */\n.form-title[_v-327aac59] {\n  font-size: 16px;\n  font-weight: bold;\n  display: inline-block;\n  width: 60px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-327aac59", module.exports)
  } else {
    hotAPI.update("_v-327aac59", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/defineProperty":65,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1029:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.select2-container--default .select2-selection--single .select2-selection__placeholder[_v-2ca04643] {\n  color: inherit; }\n\n/* line 6, stdin */\n.select-outer-div[_v-2ca04643] {\n  display: block !important; }\n\n/* line 10, stdin */\n.search-option[_v-2ca04643] {\n  max-width: 400px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            ajaxing: false,
            defaultStudioId: 0,
            defaultBranchId: 0,
            info: {
                deduction_min: 1,
                deduction_max: 50000,
                types: null
            },
            postData: {
                feeType: null,
                amount: 1,
                remark: '',
                remark2: '',
                remark3: '',
                remark4: ''
            }
        };
    },
    mounted: function mounted() {
        this.getInfo();
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId', 'isBranch']), (0, _vuex.mapState)('filters', ['selected_studio_id', 'selected_branch_id'])),
    methods: {
        save: function save() {
            var amount = parseInt(this.postData.amount);
            var max = parseInt(this.info.deduction_max);
            var min = parseInt(this.info.deduction_min);
            if (amount == 0) {
                this.alert('warning', '\u91D1\u984D\u4E0D\u53EF\u70BA0\u5143');
                return false;
            }
            if (amount > max || amount < min) {
                this.alert('warning', '\u91D1\u984D\u5FC5\u9808\u4ECB\u65BC ' + min + ' ~ ' + max + ' \u5143');
                return false;
            }

            this.postData.branch_id = this.selected_branch_id;
            var vm = this;
            $17.swal({
                title: "送出",
                text: "您確定要做扣款指示",
                type: "warning"
            }, function (isConfirm) {
                vm.ajaxing = true;
                if (!isConfirm) {
                    vm.ajaxing = false;
                    return;
                }
                vm.$http.post('/adminapi/branch-fee-deduction/send', vm.postData).then(function (response) {
                    vm.alert('success', '提交成功');
                    vm.ajaxing = false;
                    vm.reset();
                }).catch(function (response) {
                    vm.alert('error', response.data.message);
                    vm.ajaxing = false;
                });
            });
        },
        reset: function reset() {
            this.defaultStudioId = 0;
            this.defaultBranchId = 0;
            this.postData = {
                feeType: null,
                amount: 1,
                remark: '',
                remark2: '',
                remark3: '',
                remark4: ''
            };
        },
        checkQueryString: function checkQueryString() {
            var query = $17.getUrlQueryStrings();
            this.defaultStudioId = query.hasOwnProperty('studio_id') ? Number(query['studio_id']) : 0;
            this.defaultBranchId = query.hasOwnProperty('branch_id') ? Number(query['branch_id']) : 0;
            this.postData = {
                feeType: query.hasOwnProperty('fee_type') ? Number(query['fee_type']) : 4,
                amount: query.hasOwnProperty('amount') ? Number(query['amount']) : 1,
                remark: query.hasOwnProperty('remark') ? decodeURI(query['remark'].toString()) : '',
                remark2: query.hasOwnProperty('remark2') ? decodeURI(query['remark2'].toString()) : '',
                remark3: query.hasOwnProperty('remark3') ? decodeURI(query['remark3'].toString()) : '',
                remark4: query.hasOwnProperty('remark4') ? decodeURI(query['remark4'].toString()) : ''
            };
        },
        getInfo: function getInfo() {
            var _this = this;

            this.ajaxing = true;
            this.$http.get('/adminapi/branch-fee-deduction/info').then(function (response) {
                _this.info = response.data.data;
                _this.checkQueryString();
                _this.$nextTick(function () {
                    _this.ajaxing = false;
                });
            }).catch(function (response) {
                _this.alert('error', response.data.message);
                _this.ajaxing = false;
            });
        },
        alert: function alert(type, title) {
            var text = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
            var html = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

            $17.swal({
                title: title,
                text: text,
                type: type,
                html: html,
                showCancelButton: false
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-2ca04643=\"\">\n    <div class=\"page-header\" _v-2ca04643=\"\">\n        <h1 _v-2ca04643=\"\">藍新金流 - 平台費用扣款指示</h1>\n    </div>\n    <v-spinner :ajaxing=\"ajaxing\" _v-2ca04643=\"\"></v-spinner>\n    <div class=\"col-xs-12 m-bottom-50\" v-show=\"!ajaxing\" _v-2ca04643=\"\">\n        <div class=\"form-horizontal\" _v-2ca04643=\"\">\n            <div class=\"form-group\" _v-2ca04643=\"\">\n                <label class=\"col-sm-3 control-label\" _v-2ca04643=\"\">\n                    <div class=\"form-group\" _v-2ca04643=\"\">品牌與場館</div>\n                </label>\n                <div class=\"col-sm-9\" style=\"padding-left: 30px\" _v-2ca04643=\"\">\n                    <v-multiselect-studio-and-branch :studio_id=\"studioId\" :branch_id=\"branchId\" :default_studio_id=\"defaultStudioId\" :default_branch_id=\"defaultBranchId\" default_branch_source=\"filters/getBranchPayment\" branch-without-filtered-option-word=\"請選擇場館\" _v-2ca04643=\"\"></v-multiselect-studio-and-branch>\n                </div>\n            </div>\n            <div class=\"form-group\" _v-2ca04643=\"\">\n                <label class=\"col-sm-3 control-label\" _v-2ca04643=\"\"><div class=\"form-group\" _v-2ca04643=\"\">金額</div></label>\n                <div class=\"col-sm-7\" _v-2ca04643=\"\">\n                    <input type=\"number\" class=\"form-control\" v-model=\"postData.amount\" _v-2ca04643=\"\">\n                </div>\n            </div>\n            <div class=\"form-group\" _v-2ca04643=\"\">\n                <label class=\"col-sm-3 control-label\" _v-2ca04643=\"\"><div class=\"form-group\" _v-2ca04643=\"\">費用類型</div>\n                </label>\n                <div class=\"col-sm-7\" _v-2ca04643=\"\">\n                    <select v-model=\"postData.feeType\" class=\"form-control w-100 d-inline\" _v-2ca04643=\"\">\n                        <option :value=\"null\" _v-2ca04643=\"\">請選擇</option>\n                        <option v-for=\"(type,key) in info.types\" :value=\"key\" _v-2ca04643=\"\">{{ type }}</option>\n                    </select>\n                </div>\n            </div>\n            <div class=\"form-group\" _v-2ca04643=\"\">\n                <label class=\"col-sm-3 control-label\" _v-2ca04643=\"\"><div class=\"form-group\" _v-2ca04643=\"\">備註1</div></label>\n                <div class=\"col-sm-7\" _v-2ca04643=\"\">\n                    <textarea class=\"form-control\" v-model=\"postData.remark\" _v-2ca04643=\"\"></textarea>\n                </div>\n            </div>\n            <div class=\"form-group\" _v-2ca04643=\"\">\n              <label class=\"col-sm-3 control-label\" _v-2ca04643=\"\"><div class=\"form-group\" _v-2ca04643=\"\">備註2</div></label>\n              <div class=\"col-sm-7\" _v-2ca04643=\"\">\n                <textarea class=\"form-control\" v-model=\"postData.remark2\" _v-2ca04643=\"\"></textarea>\n              </div>\n            </div>\n            <div class=\"form-group\" _v-2ca04643=\"\">\n              <label class=\"col-sm-3 control-label\" _v-2ca04643=\"\"><div class=\"form-group\" _v-2ca04643=\"\">備註3</div></label>\n              <div class=\"col-sm-7\" _v-2ca04643=\"\">\n                <textarea class=\"form-control\" v-model=\"postData.remark3\" _v-2ca04643=\"\"></textarea>\n              </div>\n            </div>\n            <div class=\"form-group\" _v-2ca04643=\"\">\n              <label class=\"col-sm-3 control-label\" _v-2ca04643=\"\"><div class=\"form-group\" _v-2ca04643=\"\">備註4</div></label>\n              <div class=\"col-sm-7\" _v-2ca04643=\"\">\n                <textarea class=\"form-control\" v-model=\"postData.remark4\" _v-2ca04643=\"\"></textarea>\n              </div>\n            </div>\n        </div>\n\n        <div class=\"text-center m-top-50\" _v-2ca04643=\"\">\n            <button class=\"btn btn-primary\" :disabled=\"!selected_branch_id || postData.feeType == null\" @click=\"save()\" _v-2ca04643=\"\">確認送出</button>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.select2-container--default .select2-selection--single .select2-selection__placeholder[_v-2ca04643] {\n  color: inherit; }\n\n/* line 6, stdin */\n.select-outer-div[_v-2ca04643] {\n  display: block !important; }\n\n/* line 10, stdin */\n.search-option[_v-2ca04643] {\n  max-width: 400px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-2ca04643", module.exports)
  } else {
    hotAPI.update("_v-2ca04643", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1030:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            modal: {
                title: '',
                id: 0
            },
            view: {
                cancel_policy_list: [],
                ajaxing: false,
                action: 'create',
                default_cancel_policies: [],
                studio_id: null,
                show_content: false
            }
        };
    },
    created: function created() {
        // this.configureStates.branchId
    },
    mounted: function mounted() {
        var _this = this;

        $('#cancel-policy-modal').on('hidden.bs.modal', function (e) {
            _this.$refs.cancel_policy_modal.resetForm();
        });
    },

    watch: {
        studioId: function studioId(val, old) {
            if (!this.isSeventeen) {
                this.view.studio_id = val;
                this.getCancelPolicyList(this.view.studio_id);
            }
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'isSeventeen']), (0, _vuex.mapState)('filters', ['selected_studio_id'])),
    methods: {
        getDefaultCancelPolicies: function getDefaultCancelPolicies() {
            var _this2 = this;

            this.$http.get('/adminapi/cancel_policies/default').then(function (response) {
                _this2.view.default_cancel_policies = response.body;
                // console.log(this.view.room_list);
            }, function (error) {});
        },
        getCancelPolicyList: function getCancelPolicyList(studioId) {
            var _this3 = this;

            this.view.ajaxing = true;
            this.getDefaultCancelPolicies();
            if (studioId === null || studioId === '') {
                return;
            }
            this.$refs.cancel_policy_modal.getContractList(studioId);
            this.$refs.cancel_policy_modal.getContractTypes();
            this.view.studio_id = studioId;
            this.$http.get('/adminapi/cancel_policies?studio_id=' + studioId).then(function (response) {
                _this3.view.cancel_policy_list = response.body;
                _this3.view.ajaxing = false;
                _this3.view.show_content = true;
                // console.log(this.view.room_list);
            }, function (error) {
                _this3.view.ajaxing = false;
            });
        },
        showModal: function showModal(item, action) {
            this.$refs.cancel_policy_modal.setStudioID(this.view.studio_id);
            this.modal.title = item.name;
            this.modal.id = item.id;
            this.view.action = action;
            $('#cancel-policy-modal').modal('show');
        },
        refresh: function refresh() {
            this.getCancelPolicyList(this.view.studio_id);
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div>\n    <div>\n        <v-select-studio-and-branch v-if=\"isSeventeen\" :studio_id=\"studioId\" :show-branch=\"false\" :studio-change-call-back=\"getCancelPolicyList\" :branch-without-filtered-option=\"true\"></v-select-studio-and-branch>\n    </div>\n    <v-spinner :ajaxing=\"view.ajaxing\"></v-spinner>\n    <div v-show=\"view.show_content &amp;&amp; !view.ajaxing\" class=\"table-div m-top-20\">\n            <div class=\"m-bottom-10\">\n                <input class=\"btn btn-md btn-success\" @click=\"showModal({id:0,name:'新增補課政策'}, 'create')\" type=\"button\" value=\"＋新增補課政策\">\n            </div>\n            <table id=\"cancel-policy-list\" class=\"table table-striped\">\n                <tbody>\n                <tr class=\"top-border\" style=\"cursor: pointer;\" v-for=\"item in view.default_cancel_policies\">\n                    <td class=\"col-md-6\"><span class=\"pull-left\">{{ item.name }}</span></td>\n                    <td class=\"col-md-6\"><span class=\"pull-right\">{{ item.desc }}</span></td>\n                </tr>\n                <tr @click=\"showModal(item, 'update')\" class=\"top-border\" v-for=\"item in view.cancel_policy_list\">\n                    <td class=\"col-md-6\"><span class=\"pull-left\">{{ item.name }}</span></td>\n                    <td class=\"col-md-6\"><i class=\"fa fa-chevron-right pull-right\" aria-hidden=\"true\"></i></td>\n                </tr>\n                </tbody>\n            </table>\n    </div>\n\n    <cancel-policy-modal @refresh=\"refresh\" ref=\"cancel_policy_modal\" :action=\"view.action\" :title=\"modal.title\" :id=\"modal.id\"></cancel-policy-modal>\n\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-609b8dda", module.exports)
  } else {
    hotAPI.update("_v-609b8dda", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1031:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        id: {
            type: Number,
            default: 0
        },
        title: {
            type: String,
            default: ''
        },
        action: {
            type: String,
            default: ''
        }
    },
    data: function data() {
        return {
            studio_id: 0,
            view: {
                ajaxing: false,
                contractAjaxing: false,
                showButton: false,
                contractList: [],
                canSubmit: true,
                contract_types: []
            },
            model: {
                name: '',
                contract_type: 0,
                is_cancel_online: 0,
                cancel_limit_time: null,
                is_make_up_class: 0,
                is_limited: 0,
                make_up_class_limit: null,
                contract_id: null
            }
        };
    },
    mounted: function mounted() {
        $.fn.bootstrapSwitch.defaults.onColor = 'info';
        $(this.$el).find('.is_cancel_online_switch').bootstrapSwitch({ onText: '開啟', offText: '關閉' }).on('switchChange.bootstrapSwitch', this.switchChange);
        $(this.$el).find('.is_cancel_online_switch').bootstrapSwitch('state', this.model.is_cancel_online);

        $(this.$el).find('.is_make_up_class_switch').bootstrapSwitch({ onText: '開啟', offText: '關閉' }).on('switchChange.bootstrapSwitch', this.switchChange2);
        $(this.$el).find('.is_make_up_class_switch').bootstrapSwitch('state', this.model.is_cancel_online);
    },

    created: function created() {
        if (this.id !== null && this.id !== 0) {
            this.show();
        }
    },
    watch: {
        studio_id: function studio_id(n, o) {
            if (this.studio_id !== 0) {
                this.onCall(this.id, this.action, n);
            }
        }
    },
    computed: {},
    methods: {
        getContractTypes: function getContractTypes() {
            var _this = this;

            this.$http.get('/adminapi/cancel_policies/contract_types').then(function (response) {
                _this.view.contract_types = response.body;
            }, function (error) {});
        },
        getContractList: function getContractList(studio_id) {
            var _this2 = this;

            this.view.contractAjaxing = true;
            this.$http.get('/adminapi/cancel_policies/contracts?studio_id=' + studio_id).then(function (response) {
                _this2.view.contractList = response.body;
                _this2.view.contractAjaxing = false;
            }, function (error) {
                _this2.view.contractAjaxing = false;
            });
        },
        show: function show() {
            var _this3 = this;

            this.view.ajaxing = true;
            this.$http.get('/adminapi/cancel_policies/' + this.id).then(function (response) {
                _this3.model.name = response.body.name;
                _this3.model.contract_type = response.body.contract_type;
                _this3.model.is_cancel_online = Number(response.body.is_cancel_online);
                $('.is_cancel_online_switch').bootstrapSwitch('state', _this3.model.is_cancel_online);
                _this3.model.cancel_limit_time = response.body.cancel_limit_time;
                _this3.model.is_make_up_class = Number(response.body.is_make_up_class);
                $('.is_make_up_class_switch').bootstrapSwitch('state', _this3.model.is_make_up_class);
                _this3.model.is_limited = response.body.is_limited;
                _this3.model.make_up_class_limit = response.body.make_up_class_limit;
                _this3.model.contract_id = response.body.contract_id;
                _lodash2.default.delay(function () {
                    _this3.view.ajaxing = false;
                }, 400);
            }, function (error) {
                $17.swal({
                    title: error.body.message,
                    type: 'warning'
                });
                _this3.view.ajaxing = false;
            });
        },
        creating: function creating() {
            var _this4 = this;

            this.view.ajaxing = true;
            this.$http.post('/adminapi/cancel_policies', {
                studio_id: this.studio_id,
                name: this.model.name,
                contract_type: this.model.contract_type,
                is_cancel_online: this.model.is_cancel_online,
                cancel_limit_time: this.model.cancel_limit_time,
                is_make_up_class: this.model.is_make_up_class,
                is_limited: this.model.is_limited,
                make_up_class_limit: this.model.make_up_class_limit,
                contract_id: this.model.contract_id,
                _method: 'post'
            }).then(function (response) {
                _this4.view.ajaxing = false;
                _this4.resetForm();
                $('#cancel-policy-modal').modal('hide');
                _this4.$emit('refresh');
            }, function (error) {
                $17.swal({
                    title: error.body.message,
                    type: 'warning'
                });
                _this4.view.ajaxing = false;
            });
        },
        resetForm: function resetForm() {
            $('.is_cancel_online_switch').bootstrapSwitch('state', 0);
            $('.is_make_up_class_switch').bootstrapSwitch('state', 0);
            this.view.ajaxing = false;
            this.view.contractAjaxing = false, this.view.showButton = false;
            this.view.canSubmit = true;
            this.studio_id = 0;
            this.model.name = '';
            this.model.contract_type = 0;
            this.model.is_cancel_online = 0;
            this.model.cancel_limit_time = null;
            this.model.is_make_up_class = 0;
            this.model.is_limited = 0;
            this.model.make_up_class_limit = null;
            this.model.contract_id = null;
        },

        deleting: function deleting() {
            var _this5 = this;

            this.view.ajaxing = true;
            this.$http.delete('/adminapi/cancel_policies/' + this.id).then(function (response) {
                _this5.view.ajaxing = false;
                $('#cancel-policy-modal').modal('hide');
                _this5.$emit('refresh');
            }, function (error) {
                $17.swal({
                    title: error.body.message,
                    type: 'warning'
                });
                _this5.view.ajaxing = false;
            });
        },
        switchChange: function switchChange(event, state) {
            this.model.is_cancel_online = Number(state);
        },
        switchChange2: function switchChange2(event, state) {
            this.model.is_make_up_class = Number(state);
        },

        updating: function updating() {
            var _this6 = this;

            this.view.ajaxing = true;
            this.$http.patch('/adminapi/cancel_policies/' + this.id, {
                name: this.model.name,
                is_cancel_online: this.model.is_cancel_online,
                cancel_limit_time: this.model.cancel_limit_time,
                is_make_up_class: this.model.is_make_up_class,
                is_limited: this.model.is_limited,
                make_up_class_limit: this.model.make_up_class_limit,
                contract_id: this.model.contract_id
            }).then(function (response) {
                _this6.view.ajaxing = false;
                $('#cancel-policy-modal').modal('hide');
                _this6.$emit('refresh');
            }, function (error) {
                _this6.view.ajaxing = false;
            });
        },
        selectContract: function selectContract(value) {
            this.model.contract_id = value;
        },
        onCall: function onCall(id, action, studio_id) {
            if (action === 'update') {
                this.view.showButton = true;
                this.show(id);
            } else {
                this.view.showButton = false;
            }
        },
        submitPolicy: function submitPolicy() {
            this.view.canSubmit = true;
            this.checkRequire();

            if (this.view.canSubmit === false) {
                $17.swal({
                    title: '尚有必填欄位未填',
                    type: 'warning'
                });
                this.view.ajaxing = false;
            } else {
                if (this.action === 'update') {
                    this.updating();
                } else {
                    this.creating();
                }
            }
        },
        checkRequire: function checkRequire() {
            if (this.model.name === '') {
                this.view.canSubmit = false;
            }
            if (this.model.contract_type === 0 || this.model.contract_type === '0') {
                this.view.canSubmit = false;
            }
            if (this.model.is_make_up_class === 1) {
                if (this.model.contract_id === null || this.model.contract_id === 0) {
                    this.view.canSubmit = false;
                }
            }
        },
        setStudioID: function setStudioID(id) {
            this.studio_id = id;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div id=\"cancel-policy-modal\" class=\"modal fade\" data-backdrop=\"static\" data-keyboard=\"false\" role=\"dialog\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n\n            <div class=\"modal-header\">\n                <button type=\"button\" v-show=\"!view.ajaxing\" class=\"close\" data-dismiss=\"modal\">×</button>\n                <h4 class=\"modal-title\">{{ title }}</h4>\n            </div>\n\n            <div class=\"modal-body\">\n                <v-spinner :ajaxing=\"view.ajaxing\"></v-spinner>\n                <div v-show=\"!view.ajaxing\">\n                    <div class=\"clearfix\">\n                        <label class=\"col-lg-3 col-md-3 col-xs-12 p-top-5 require\" for=\"name\">名稱 <span>*</span></label>\n                        <div class=\"col-lg-9 col-md-9 col-xs-12\"><input maxlength=\"30\" type=\"text\" class=\"form-control\" id=\"name\" placeholder=\"請輸入名稱\" v-model=\"model.name\"></div>\n                    </div>\n\n                    <div class=\"clearfix\">\n                        <label class=\"col-lg-3 col-md-3 col-xs-12 p-top-5 require\" for=\"contract_type\">方案類型 <span>*</span></label>\n                        <div class=\"col-lg-9 col-md-9 col-xs-12\">\n                            <select class=\"\" id=\"contract_type\" v-model=\"model.contract_type\">\n                               <option selected=\"true\" value=\"0\">請選擇</option>\n                               <option :key=\"type.id\" v-for=\"type in view.contract_types\" :value=\"type.id\">\n                                   {{ type.name }}\n                               </option>\n                             </select>\n                        </div>\n                    </div>\n\n                    <div>\n                        <div class=\"clearfix\">\n                            <label class=\"col-lg-3 col-md-3 col-xs-12 p-top-5\" for=\"is_cancel_online\">允許取消</label>\n\n                            <div class=\"col-lg-9 col-md-9 col-xs-12\">\n                                <div class=\"btn-group col-md-12 p-left-0\">\n                                    <input type=\"checkbox\" v-model=\"model.is_cancel_online\" id=\"is_cancel_online\" class=\"limit-btn is_cancel_online_switch\">\n                                </div>\n                                <div v-show=\"model.is_cancel_online\" class=\"count-group col-md-12 m-top-20 p-left-0 p-right-0\">\n                                    <div class=\"col-md-6 p-left-0 text-right p-right-5\">最晚取消時間，課程開始前</div>\n                                    <div class=\"col-md-6 p-left-0 p-right-0\">\n                                        <div class=\"col-md-8 p-left-0 p-right-0\">\n                                            <input min=\"1\" style=\"height: 26px; width:100%;\" type=\"number\" maxlength=\"6\" id=\"cancel_limit_time\" placeholder=\"0\" class=\"form-control\" v-model=\"model.cancel_limit_time\">\n                                        </div>\n                                        <div class=\"col-md-4 p-left-5 p-right-0\">小時</div></div>\n                                </div>\n                                <div v-show=\"model.is_cancel_online\">\n                                    <div class=\"btn-group col-md-12 p-left-0 m-top-10\">\n                                        <label for=\"is_make_up_class\" class=\"p-right-15\">請假補課<a href=\"javascript:void(0)\"><i class=\"fa fa-question-circle column_desc\" help=\"取消課程時，自動補方案給客戶。當功能為開啟時，每次取消課程時，系統將會自動贈與指定的方案給予客戶。\"></i></a>\n                                        </label>\n                                        <input type=\"checkbox\" id=\"is_make_up_class\" v-model=\"model.is_make_up_class\" class=\"limit-btn is_make_up_class_switch\">\n                                    </div>\n                                    <div v-show=\"model.is_make_up_class\">\n                                        <div class=\"col-md-12 p-left-0 m-top-10 m-bottom-10\">\n                                            <v-select2 :match=\"model.contract_id\" :options=\"view.contractList\" :disabled=\"view.contractAjaxing\" :updated=\"selectContract\" :placeholder=\"view.contractAjaxing ? '方案讀取中…' : '請選擇方案'\"></v-select2>\n                                        </div>\n                                        <div class=\"col-md-12 p-left-0\">\n                                            <input type=\"radio\" value=\"0\" id=\"is_limited\" v-model=\"model.is_limited\"><label class=\"m-left-5\" for=\"is_limited\">不限制補課次數</label>\n                                        </div>\n                                        <div class=\"col-md-12 p-left-0\">\n                                            <input type=\"radio\" value=\"1\" id=\"is_not_limited\" v-model=\"model.is_limited\"><label class=\"m-left-5\" for=\"is_not_limited\">限制補課次數</label>\n                                            <input min=\"0\" v-show=\"model.is_limited === '1' || model.is_limited === 1\" style=\"height: 26px; padding: 3px;\" type=\"number\" v-model=\"model.make_up_class_limit\">\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n\n                        </div>\n                    </div>\n\n                </div>\n\n            </div>\n\n            <div class=\"modal-footer\">\n                <button v-show=\"view.showButton &amp;&amp; !view.ajaxing\" @click=\"deleting\" type=\"button\" class=\"btn btn-danger\" style=\"position:absolute;left: 10px;\" data-dismiss=\"modal\">刪除</button>\n                <button v-show=\"!view.ajaxing\" type=\"button\" class=\"btn btn-primary\" @click=\"submitPolicy\">送出\n                    </button>\n                <button type=\"button\" v-show=\"!view.ajaxing\" class=\"btn btn-default\" data-dismiss=\"modal\">關閉</button>\n            </div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-190054f0", module.exports)
  } else {
    hotAPI.update("_v-190054f0", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1032:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 3, stdin */\n.checkstudio-booking-list .card-list[_v-3e11e2b8] {\n  border: none;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -ms-flex-pack: start;\n      justify-content: flex-start; }\n\n@media screen and (max-width: 768px) {\n  /* line 11, stdin */\n  .checkstudio-booking-list .btn-success[_v-3e11e2b8] {\n    margin-left: -20px; }\n  /* line 14, stdin */\n  .checkstudio-booking-list .class-header[_v-3e11e2b8] {\n    margin-top: 15px; }\n  /* line 17, stdin */\n  .checkstudio-booking-list .class-detail[_v-3e11e2b8] {\n    margin-left: 0; }\n    /* line 19, stdin */\n    .checkstudio-booking-list .class-detail div[_v-3e11e2b8] {\n      margin-bottom: 14px;\n      margin-right: auto;\n      -ms-flex: 0 50%;\n          flex: 0 50%; }\n  /* line 25, stdin */\n  .checkstudio-booking-list .card-list[_v-3e11e2b8] {\n    padding: 0;\n    margin-top: 10px; } }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vuex = require('vuex');

exports.default = {
    props: {
        confirmData: {
            type: [Array, Object],
            required: true
        }
    },
    data: function data() {
        return {
            view: {
                'service_name': '',
                'date': '',
                'staff_name': '',
                'time_start': '',
                'time_end': '',
                'qty': 0
            }
        };
    },
    mounted: function mounted() {},

    computed: {
        schedule: function schedule() {
            if (this.confirmData.schedule) {
                return this.confirmData.schedule;
            };
            return this.view;
        }
    },
    methods: {
        showMemberCard: function showMemberCard(target) {
            this.$refs.memberProfileOverview.onCall(target.dataset.memberId, target);
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-3e11e2b8=\"\">\n    <div class=\"checkstudio-booking-list\" _v-3e11e2b8=\"\">\n        <div class=\"card-list\" _v-3e11e2b8=\"\">\n            <template v-for=\"(booking, index) in confirmData.bookings\">\n                <webadmin-checkstudio-confirm-card :key=\"index\" :booking=\"booking\" :schedule=\"confirmData.schedule\" :show-member-profile=\"showMemberCard\" _v-3e11e2b8=\"\">\n                </webadmin-checkstudio-confirm-card>\n            </template>\n        </div>\n    </div>\n    <v-member-profile-overview ref=\"memberProfileOverview\" position-config=\"webadmin/appointment/schedule-class:records[].member\" _v-3e11e2b8=\"\"></v-member-profile-overview>\n</div>    \n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 3, stdin */\n.checkstudio-booking-list .card-list[_v-3e11e2b8] {\n  border: none;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -ms-flex-pack: start;\n      justify-content: flex-start; }\n\n@media screen and (max-width: 768px) {\n  /* line 11, stdin */\n  .checkstudio-booking-list .btn-success[_v-3e11e2b8] {\n    margin-left: -20px; }\n  /* line 14, stdin */\n  .checkstudio-booking-list .class-header[_v-3e11e2b8] {\n    margin-top: 15px; }\n  /* line 17, stdin */\n  .checkstudio-booking-list .class-detail[_v-3e11e2b8] {\n    margin-left: 0; }\n    /* line 19, stdin */\n    .checkstudio-booking-list .class-detail div[_v-3e11e2b8] {\n      margin-bottom: 14px;\n      margin-right: auto;\n      -ms-flex: 0 50%;\n          flex: 0 50%; }\n  /* line 25, stdin */\n  .checkstudio-booking-list .card-list[_v-3e11e2b8] {\n    padding: 0;\n    margin-top: 10px; } }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-3e11e2b8", module.exports)
  } else {
    hotAPI.update("_v-3e11e2b8", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1033:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n#checkstudio-customer-card[_v-51cf89a3] {\n  font-size: 16px; }\n  /* line 5, stdin */\n  #checkstudio-customer-card .customer-card-container .dropdown[_v-51cf89a3] {\n    position: absolute;\n    transform: translate(265px, -35px); }\n    /* line 8, stdin */\n    #checkstudio-customer-card .customer-card-container .dropdown .btn[_v-51cf89a3] {\n      color: black;\n      background-color: white;\n      padding-top: 0px;\n      margin-top: 7px; }\n      /* line 13, stdin */\n      #checkstudio-customer-card .customer-card-container .dropdown .btn[_v-51cf89a3]:hover {\n        color: black;\n        background-color: #f5f5f5; }\n      /* line 17, stdin */\n      #checkstudio-customer-card .customer-card-container .dropdown .btn[_v-51cf89a3]:active {\n        color: black;\n        box-shadow: none;\n        background-color: #f5f5f5; }\n      /* line 22, stdin */\n      #checkstudio-customer-card .customer-card-container .dropdown .btn span[_v-51cf89a3] {\n        font-size: 20px;\n        font-weight: 500; }\n    /* line 27, stdin */\n    #checkstudio-customer-card .customer-card-container .dropdown .dropdown-menu[_v-51cf89a3] {\n      min-width: 128px;\n      transform: translate(-85px, 0); }\n    /* line 31, stdin */\n    #checkstudio-customer-card .customer-card-container .dropdown .dropdown-menu > li > a[_v-51cf89a3] {\n      font-weight: 500;\n      font-size: 14px;\n      margin-right: 0;\n      padding: 6px 15px; }\n      /* line 36, stdin */\n      #checkstudio-customer-card .customer-card-container .dropdown .dropdown-menu > li > a[_v-51cf89a3]:focus {\n        background-color: #ececec; }\n  /* line 41, stdin */\n  #checkstudio-customer-card .customer-card-container .member-name[_v-51cf89a3] {\n    cursor: pointer; }\n  /* line 45, stdin */\n  #checkstudio-customer-card .customer-card-content[_v-51cf89a3] {\n    padding: 35px 22px;\n    max-width: 345px;\n    margin: 15px 10px;\n    box-shadow: 1px 1px 7px 0 rgba(0, 0, 0, 0.33);\n    background-color: #ffffff;\n    transition: box-shadow .25s; }\n    /* line 52, stdin */\n    #checkstudio-customer-card .customer-card-content[_v-51cf89a3]:hover {\n      box-shadow: 0 8px 17px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19); }\n  /* line 56, stdin */\n  #checkstudio-customer-card .txt-bold[_v-51cf89a3] {\n    font-weight: 500; }\n  /* line 59, stdin */\n  #checkstudio-customer-card .txt-sm[_v-51cf89a3] {\n    font-size: 12px;\n    color: #575757; }\n  /* line 63, stdin */\n  #checkstudio-customer-card .card-top[_v-51cf89a3] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n    min-width: 300px; }\n  /* line 68, stdin */\n  #checkstudio-customer-card .member-img[_v-51cf89a3] {\n    background-color: #8f8f8f;\n    border: 1px solid #8f8f8f;\n    width: 70px;\n    height: 70px;\n    border-radius: 50%; }\n  /* line 75, stdin */\n  #checkstudio-customer-card .card-body[_v-51cf89a3] {\n    margin-top: 13px;\n    border-top: solid 1px #d5d5d5;\n    min-height: 116px; }\n  /* line 80, stdin */\n  #checkstudio-customer-card .single-payment[_v-51cf89a3] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n    -ms-flex-pack: justify;\n        justify-content: space-between; }\n  /* line 85, stdin */\n  #checkstudio-customer-card .note[_v-51cf89a3] {\n    white-space: pre; }\n  /* line 88, stdin */\n  #checkstudio-customer-card .remark[_v-51cf89a3] {\n    margin-top: 20px; }\n    /* line 89, stdin */\n    #checkstudio-customer-card .remark textarea[_v-51cf89a3] {\n      padding: 5px;\n      margin-bottom: 0;\n      font-size: 14px;\n      width: 100% !important;\n      background-color: #f6f6f6;\n      max-height: 59px; }\n    /* line 98, stdin */\n    #checkstudio-customer-card .remark .buttons[_v-51cf89a3] {\n      padding: 0; }\n      /* line 100, stdin */\n      #checkstudio-customer-card .remark .buttons .btn-primary[_v-51cf89a3]:hover {\n        color: #ffffff; }\n      /* line 103, stdin */\n      #checkstudio-customer-card .remark .buttons .btn-default[_v-51cf89a3]:hover {\n        color: #333;\n        background-color: #ffffff; }\n      /* line 107, stdin */\n      #checkstudio-customer-card .remark .buttons i[_v-51cf89a3] {\n        margin: 0; }\n  /* line 113, stdin */\n  #checkstudio-customer-card .card-footer .attend-confirm[_v-51cf89a3] {\n    width: 100%;\n    margin: 0;\n    padding: 12px 48px; }\n  /* line 118, stdin */\n  #checkstudio-customer-card .card-footer .btn-default[_v-51cf89a3]:hover {\n    color: #333; }\n  @media screen and (max-width: 768px) {\n    /* line 125, stdin */\n    #checkstudio-customer-card .customer-card-container .dropdown[_v-51cf89a3] {\n      transform: translate(245px, -35px); }\n    /* line 129, stdin */\n    #checkstudio-customer-card .customer-card-content[_v-51cf89a3] {\n      max-width: 320px; } }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        booking: {
            type: [Array, Object]
        },
        waiting: {
            type: [Array, Object]
        },
        schedule: {
            type: Object
        },
        showMemberProfile: {}
    },
    data: function data() {
        return {
            init: true,
            ajaxing: false,
            edit_remark: false,
            disable_remark_btn: false,
            disable_attend_btn: false,
            disable_absent_btn: false,
            tagStyle: { 'margin': '6px -5px' },
            defaultImg: 'this.src=https://"' + window.location.hostname + '/images/default.png"',
            remark: ''
        };
    },
    mounted: function mounted() {},

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        canCancel: function canCancel(state) {
            return state.webadmin.configure.webFunctions.WebadminBookingsCancel;
        },
        canAddBooking: function canAddBooking(state) {
            return state.webadmin.configure.webFunctions.WebadminBookingsCreate;
        }
    }), {
        isWaiting: function isWaiting() {
            return this.waiting ? true : false;
        },
        memberInfo: function memberInfo() {
            if (this.waiting) {
                return this.waiting;
            } else {
                return this.booking.member;
            }
        },
        hasManagementRemark: function hasManagementRemark() {
            return this.booking.remark ? true : false;
        },
        bookingAlreadyCancel: function bookingAlreadyCancel() {
            return this.booking.already_cancel;
        },
        attendStatusConfirm: function attendStatusConfirm() {
            return this.booking.confirm_status == 'y';
        },
        absentStatusConfirm: function absentStatusConfirm() {
            return this.booking.confirm_status == 'n';
        },
        enableBookingCanceled: function enableBookingCanceled() {
            if (this.booking.confirm_status == 'y' || this.booking.confirm_status == 'n' || this.booking.already_cancel) {
                return false;
            } else {
                return true;
            };
        }
    }),
    watch: {},
    methods: {
        editRemark: function editRemark() {
            if (!this.edit_remark) {
                this.edit_remark = true;
                this.remark = this.booking.remark;
            };
        },
        closeRemark: function closeRemark() {
            this.edit_remark = false;
            this.booking.remark = this.remark;
        },
        saveRemark: function saveRemark() {
            var _this = this;

            this.disable_remark_btn = true;
            this.$http.post('/adminapi/checkstudio/remark/' + this.booking.id, { remark: this.booking.remark }).then(function (response) {
                if (response.data.success == 'false') {
                    _this.closeRemark();
                    $17.swal({
                        type: 'error',
                        title: '儲存管理備註失敗',
                        showCancelButton: false
                    });
                }
                _this.edit_remark = false;
                _this.disable_remark_btn = false;
            }, function (error) {
                _this.edit_remark = false;
                _this.disable_remark_btn = false;
            });
        },
        openOperateOrder: function openOperateOrder(payload) {
            window.Event.$emit("System.Pos.Order.Open", payload);
        },
        openOrCreateOrder: function openOrCreateOrder(payload) {
            var _this2 = this;

            this.$store.dispatch('pos/updateAllStatus', [{ 'key': 'select_branch_id', value: this.schedule.branch_id }]);
            this.$store.dispatch('pos/openOrCreateOrder', { 'order_id': payload.order_id }).then(function () {
                $('#modalDefault').modal('hide');
                if (payload.type == 'edit') {
                    _this2.$store.dispatch('pos/getCommonlyUsedItem', payload.branch_id);
                    _this2.$store.commit('pos/POS_SETSTATUS', { 'key': 'select_branch_id', value: payload.branch_id });
                    $('#order-edit').modal('show');
                }

                if (payload.type == 'show') {
                    $('#order-show').modal('show');
                }
            });
        },
        attendConfirm: function attendConfirm(state, confirm) {
            var _this3 = this;

            var vm = this;
            var bookingId = this.booking.id;
            var payment_status = this.booking.order.payment_status;

            if (state === 'attend') {
                this.disable_attend_btn = true;
            } else {
                this.disable_absent_btn = true;
            };

            this.$http.post('/adminapi/checkstudio/confirm/' + this.booking.id, { confirm: confirm }).then(function (response) {
                vm.showAttendResult(response.data);
            }, function (error) {
                _this3.disable_attend_btn = false;
                _this3.disable_absent_btn = false;
            });
        },
        showAttendResult: function showAttendResult(data) {
            var vm = this;
            var canceledStatus = ['l', 'a', 'i'];
            if (data.saving == 'y') {
                this.booking.confirm_status = data.result;
            } else {
                if (canceledStatus.includes(data.result)) {
                    window.Event.$emit("ClassBooking.Changed");
                    $17.swal({
                        type: 'error',
                        title: '出／缺席失敗',
                        text: '此預約已取消',
                        showCancelButton: false
                    });
                } else {
                    $17.swal({
                        type: 'error',
                        title: '出／缺席失敗',
                        text: data.message,
                        showCancelButton: false
                    });
                }
            }
            this.disable_attend_btn = false;
            this.disable_absent_btn = false;
        },
        bookingCancel: function bookingCancel(state) {
            var _this4 = this;

            if (!this.canCancel) {
                this.cancelError('權限不足');
                return;
            };
            var vm = this;
            var msg = '';
            var url = '';
            if (state == '1') {
                msg = '\u78BA\u5B9A\u300C\u53D6\u6D88\u300D ' + this.booking.member.name + '\u9810\u7D04';
                url = '/adminapi/class-booking/cancel/';
            } else {
                msg = '\u78BA\u5B9A\u300C\u7121\u689D\u4EF6\u53D6\u6D88\u300D ' + this.booking.member.name + '\u6B64\u9810\u7D04';
                url = '/adminapi/class-booking/unconditional-cancel/';
            };

            this.disable_attend_btn = true;
            this.disable_absent_btn = true;

            $17.swal({
                title: msg,
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: '確定',
                cancelButtonText: '取消'
            }, function (isConfirm) {
                if (isConfirm) {
                    _this4.$http.post(url + _this4.booking.id).then(function (response) {
                        if (response.data.success) {
                            $.notify('取消成功', { className: 'success', globalPosition: 'top center', clickToHide: true });
                            window.Event.$emit("ClassBooking.Changed");
                        } else {
                            vm.cancelError();
                        };
                        vm.disable_attend_btn = false;
                        vm.disable_absent_btn = false;
                    }, function (error) {
                        vm.cancelError();
                        vm.disable_attend_btn = false;
                        vm.disable_absent_btn = false;
                    });
                };
            });
        },
        cancelError: function cancelError() {
            var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

            $.notify('\u53D6\u6D88\u5931\u6557  ' + msg, { className: 'error', globalPosition: 'top center', clickToHide: true });
        },
        OpenBookingModal: function OpenBookingModal() {
            if (!this.canAddBooking) {
                $.notify('權限不足', { className: 'error', globalPosition: 'top center', clickToHide: true });
                return;
            }
            window.Event.$emit("ClassBookingModal.Show", {
                date: this.schedule.date,
                branch_id: this.schedule.branch_id,
                studio_id: this.schedule.studio_id,
                schedule_id: this.schedule.id,
                member_id: this.waiting.id,
                name: this.waiting.name,
                phone: this.waiting.phone,
                email: this.waiting.email
            });
        },
        hoverOnName: function hoverOnName(event) {
            this.showMemberProfile(event.target);
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div id=\"checkstudio-customer-card\" _v-51cf89a3=\"\">\n    <div class=\"customer-card-content\" _v-51cf89a3=\"\">\n        <div class=\"customer-card-container\" _v-51cf89a3=\"\">\n            <div class=\"dropdown\" _v-51cf89a3=\"\">\n                <button class=\"btn dropdown-toggle\" type=\"button\" id=\"confirmCardMenu\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"true\" _v-51cf89a3=\"\">\n                    <span _v-51cf89a3=\"\">...</span>\n                </button>\n                <ul class=\"dropdown-menu\" aria-labelledby=\"confirmCardMenu\" v-if=\"!isWaiting\" _v-51cf89a3=\"\">\n                    <li v-show=\"enableBookingCanceled &amp;&amp; booking.allow_cancel\" _v-51cf89a3=\"\"><a @click.prevent=\"bookingCancel('1')\" _v-51cf89a3=\"\">取消預約</a></li>\n                    <li v-show=\"enableBookingCanceled &amp;&amp; booking.allow_unconditional_cancel\" _v-51cf89a3=\"\"><a @click.prevent=\"bookingCancel('0')\" _v-51cf89a3=\"\">無條件取消預約</a></li>\n                    <li _v-51cf89a3=\"\"><a @click.prevent=\"editRemark\" _v-51cf89a3=\"\">{{ hasManagementRemark ? '編輯管理備註' : '新增管理備註' }}</a></li>\n                </ul>\n                <ul class=\"dropdown-menu\" aria-labelledby=\"confirmCardMenu\" v-else=\"\" _v-51cf89a3=\"\">\n                    <li _v-51cf89a3=\"\"><a @click=\"OpenBookingModal\" _v-51cf89a3=\"\">新增預約</a></li>\n                </ul>\n            </div>\n            <div class=\"card-top\" _v-51cf89a3=\"\">\n                <img class=\"member-img margin_center\" :src=\"memberInfo.avatar\" :on-error=\"defaultImg\" :data-member-id=\"memberInfo.id\" @mouseover.prevent=\"hoverOnName\" _v-51cf89a3=\"\">\n                <div class=\"m-left-20\" _v-51cf89a3=\"\">\n                    <div class=\"m-bottom-6 member-name\" :data-member-id=\"memberInfo.id\" @mouseover.prevent=\"hoverOnName\" _v-51cf89a3=\"\">姓名：{{memberInfo.name}}</div>\n                    <v-member-tag :member-tags=\"memberInfo.tags\" :tag-style=\"tagStyle\" _v-51cf89a3=\"\"></v-member-tag>\n                    <div _v-51cf89a3=\"\">手機：{{memberInfo.phone}}</div>\n                </div>\n            </div>\n            <div class=\"card-body\" v-if=\"!isWaiting\" _v-51cf89a3=\"\">\n                <div class=\"booking-detail m-top-10\" _v-51cf89a3=\"\">\n                    <div v-if=\"booking.use_contract\" _v-51cf89a3=\"\">\n                        <div class=\"txt-bold m-bottom-5\" _v-51cf89a3=\"\">方案</div>\n                        <div _v-51cf89a3=\"\">{{booking.contract.name}}</div>\n                        <div v-if=\"booking.contract.has_value\" _v-51cf89a3=\"\">\n                            剩餘：{{booking.contract.unused}} {{booking.contract.unit}}\n                        </div>\n                        <div class=\"txt-sm m-top-4\" _v-51cf89a3=\"\">(到期日:{{booking.contract.expired_date}})</div>                    \n                    </div>\n                    <div class=\"single-payment\" v-else=\"\" _v-51cf89a3=\"\">\n                        <div class=\"txt-bold m-bottom-5\" _v-51cf89a3=\"\">單次購買</div>\n                        <div :id=\"'payment-success-'+booking.order.id\" class=\"btn btn-success\" v-show=\"booking.order.payment_status === 1\" _v-51cf89a3=\"\">\n                            <span _v-51cf89a3=\"\">已付款</span>\n                        </div>\n                        <div :id=\"'payment-fail-'+booking.order.id\" class=\"btn btn-danger\" v-show=\"booking.order.payment_status === 0\" @click=\"openOperateOrder({ 'order_id':booking.order.id,'branch_id':booking.order.branch_id, \n                            'mode':'edit',\n                            'event_type':'checkStudio' })\" _v-51cf89a3=\"\">\n                            <span _v-51cf89a3=\"\">尚未付款</span>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"costumer-note m-top-15\" v-if=\"booking.client_booking_note\" _v-51cf89a3=\"\">\n                    <div class=\"txt-bold m-bottom-5\" _v-51cf89a3=\"\">客戶預約備註：</div>\n                    <div class=\"note\" _v-51cf89a3=\"\">{{booking.client_booking_note}}</div>\n                </div>\n                <div class=\"remark\" v-show=\"hasManagementRemark || this.edit_remark\" _v-51cf89a3=\"\">\n                    <textarea name=\"remark\" placeholder=\"輸入管理備註...\" v-model=\"booking.remark\" @click.prevent=\"editRemark\" _v-51cf89a3=\"\"></textarea>\n                    <div class=\"buttons text-right\" v-show=\"edit_remark\" _v-51cf89a3=\"\">\n                        <button class=\"btn btn-primary btn-sm remark_sent\" @click.prevent=\"saveRemark\" :disabled=\"disable_remark_btn\" _v-51cf89a3=\"\">儲存</button>\n                        <button class=\"btn btn-default btn-sm\" @click.prevent=\"closeRemark\" :disabled=\"disable_remark_btn\" _v-51cf89a3=\"\"><i class=\"fa fa fa-times\" _v-51cf89a3=\"\"></i></button>\n                    </div>\n                </div>\n            </div>\n            <div class=\"card-footer m-top-15\" v-if=\"!isWaiting\" _v-51cf89a3=\"\">\n                <div class=\"row\" v-if=\"bookingAlreadyCancel\" _v-51cf89a3=\"\">\n                    <div class=\"col-xs-12 text-center\" _v-51cf89a3=\"\"> 已取消 </div>\n                </div>\n                <div class=\"row\" v-else=\"\" _v-51cf89a3=\"\">\n                    <div class=\"p-right-5 col-xs-6\" v-if=\"attendStatusConfirm\" _v-51cf89a3=\"\">\n                        <button class=\"attend-confirm btn btn-success\" @click.prevent=\"attendConfirm('attend', 0)\" :disabled=\"disable_attend_btn\" _v-51cf89a3=\"\">\n                            <span _v-51cf89a3=\"\"><i class=\"fa fa-check-square-o\" _v-51cf89a3=\"\"></i> 出席</span>\n                        </button>                        \n                    </div>\n                    <div class=\"p-right-5 col-xs-6\" v-else=\"\" _v-51cf89a3=\"\">\n                        <button class=\"attend-confirm btn btn-default\" @click.prevent=\"attendConfirm('attend', 'y')\" :disabled=\"disable_attend_btn\" _v-51cf89a3=\"\">\n                            <span _v-51cf89a3=\"\"><i class=\"fa fa-square-o\" _v-51cf89a3=\"\"></i> 出席</span>\n                        </button>\n                    </div>\n                    <div class=\"p-left-5 col-xs-6\" v-if=\"absentStatusConfirm\" _v-51cf89a3=\"\">\n                        <button class=\"attend-confirm btn btn-danger\" @click.prevent=\"attendConfirm('absent', 0)\" :disabled=\"disable_absent_btn\" _v-51cf89a3=\"\">\n                            <span _v-51cf89a3=\"\"><i class=\"fa fa-check-square-o\" _v-51cf89a3=\"\"></i> 缺席</span>\n                        </button>                        \n                    </div>\n                    <div class=\"p-left-5 col-xs-6\" v-else=\"\" _v-51cf89a3=\"\">\n                        <button class=\"attend-confirm btn btn-default\" @click.prevent=\"attendConfirm('absent', 'n')\" :disabled=\"disable_absent_btn\" _v-51cf89a3=\"\">\n                            <span _v-51cf89a3=\"\"><i class=\"fa fa-square-o\" _v-51cf89a3=\"\"></i> 缺席</span>\n                        </button>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n#checkstudio-customer-card[_v-51cf89a3] {\n  font-size: 16px; }\n  /* line 5, stdin */\n  #checkstudio-customer-card .customer-card-container .dropdown[_v-51cf89a3] {\n    position: absolute;\n    transform: translate(265px, -35px); }\n    /* line 8, stdin */\n    #checkstudio-customer-card .customer-card-container .dropdown .btn[_v-51cf89a3] {\n      color: black;\n      background-color: white;\n      padding-top: 0px;\n      margin-top: 7px; }\n      /* line 13, stdin */\n      #checkstudio-customer-card .customer-card-container .dropdown .btn[_v-51cf89a3]:hover {\n        color: black;\n        background-color: #f5f5f5; }\n      /* line 17, stdin */\n      #checkstudio-customer-card .customer-card-container .dropdown .btn[_v-51cf89a3]:active {\n        color: black;\n        box-shadow: none;\n        background-color: #f5f5f5; }\n      /* line 22, stdin */\n      #checkstudio-customer-card .customer-card-container .dropdown .btn span[_v-51cf89a3] {\n        font-size: 20px;\n        font-weight: 500; }\n    /* line 27, stdin */\n    #checkstudio-customer-card .customer-card-container .dropdown .dropdown-menu[_v-51cf89a3] {\n      min-width: 128px;\n      transform: translate(-85px, 0); }\n    /* line 31, stdin */\n    #checkstudio-customer-card .customer-card-container .dropdown .dropdown-menu > li > a[_v-51cf89a3] {\n      font-weight: 500;\n      font-size: 14px;\n      margin-right: 0;\n      padding: 6px 15px; }\n      /* line 36, stdin */\n      #checkstudio-customer-card .customer-card-container .dropdown .dropdown-menu > li > a[_v-51cf89a3]:focus {\n        background-color: #ececec; }\n  /* line 41, stdin */\n  #checkstudio-customer-card .customer-card-container .member-name[_v-51cf89a3] {\n    cursor: pointer; }\n  /* line 45, stdin */\n  #checkstudio-customer-card .customer-card-content[_v-51cf89a3] {\n    padding: 35px 22px;\n    max-width: 345px;\n    margin: 15px 10px;\n    box-shadow: 1px 1px 7px 0 rgba(0, 0, 0, 0.33);\n    background-color: #ffffff;\n    transition: box-shadow .25s; }\n    /* line 52, stdin */\n    #checkstudio-customer-card .customer-card-content[_v-51cf89a3]:hover {\n      box-shadow: 0 8px 17px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19); }\n  /* line 56, stdin */\n  #checkstudio-customer-card .txt-bold[_v-51cf89a3] {\n    font-weight: 500; }\n  /* line 59, stdin */\n  #checkstudio-customer-card .txt-sm[_v-51cf89a3] {\n    font-size: 12px;\n    color: #575757; }\n  /* line 63, stdin */\n  #checkstudio-customer-card .card-top[_v-51cf89a3] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n    min-width: 300px; }\n  /* line 68, stdin */\n  #checkstudio-customer-card .member-img[_v-51cf89a3] {\n    background-color: #8f8f8f;\n    border: 1px solid #8f8f8f;\n    width: 70px;\n    height: 70px;\n    border-radius: 50%; }\n  /* line 75, stdin */\n  #checkstudio-customer-card .card-body[_v-51cf89a3] {\n    margin-top: 13px;\n    border-top: solid 1px #d5d5d5;\n    min-height: 116px; }\n  /* line 80, stdin */\n  #checkstudio-customer-card .single-payment[_v-51cf89a3] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n    -ms-flex-pack: justify;\n        justify-content: space-between; }\n  /* line 85, stdin */\n  #checkstudio-customer-card .note[_v-51cf89a3] {\n    white-space: pre; }\n  /* line 88, stdin */\n  #checkstudio-customer-card .remark[_v-51cf89a3] {\n    margin-top: 20px; }\n    /* line 89, stdin */\n    #checkstudio-customer-card .remark textarea[_v-51cf89a3] {\n      padding: 5px;\n      margin-bottom: 0;\n      font-size: 14px;\n      width: 100% !important;\n      background-color: #f6f6f6;\n      max-height: 59px; }\n    /* line 98, stdin */\n    #checkstudio-customer-card .remark .buttons[_v-51cf89a3] {\n      padding: 0; }\n      /* line 100, stdin */\n      #checkstudio-customer-card .remark .buttons .btn-primary[_v-51cf89a3]:hover {\n        color: #ffffff; }\n      /* line 103, stdin */\n      #checkstudio-customer-card .remark .buttons .btn-default[_v-51cf89a3]:hover {\n        color: #333;\n        background-color: #ffffff; }\n      /* line 107, stdin */\n      #checkstudio-customer-card .remark .buttons i[_v-51cf89a3] {\n        margin: 0; }\n  /* line 113, stdin */\n  #checkstudio-customer-card .card-footer .attend-confirm[_v-51cf89a3] {\n    width: 100%;\n    margin: 0;\n    padding: 12px 48px; }\n  /* line 118, stdin */\n  #checkstudio-customer-card .card-footer .btn-default[_v-51cf89a3]:hover {\n    color: #333; }\n  @media screen and (max-width: 768px) {\n    /* line 125, stdin */\n    #checkstudio-customer-card .customer-card-container .dropdown[_v-51cf89a3] {\n      transform: translate(245px, -35px); }\n    /* line 129, stdin */\n    #checkstudio-customer-card .customer-card-content[_v-51cf89a3] {\n      max-width: 320px; } }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-51cf89a3", module.exports)
  } else {
    hotAPI.update("_v-51cf89a3", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1034:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.checkstudio-confirm-page[_v-3f6e090a] {\n  margin: 0 auto;\n  padding: 20px 30px;\n  font-family: PingFangTC; }\n  /* line 6, stdin */\n  .checkstudio-confirm-page .return-page[_v-3f6e090a] {\n    margin-left: 20px;\n    font-size: 16px;\n    font-weight: 500;\n    color: #7c7c7c; }\n  /* line 12, stdin */\n  .checkstudio-confirm-page .class-header[_v-3f6e090a] {\n    margin-top: 25px;\n    text-align: center;\n    line-height: 42px;\n    font-size: 18px;\n    font-weight: 500;\n    letter-spacing: -0.43px;\n    color: #ffffff;\n    background-color: #86959f; }\n  /* line 22, stdin */\n  .checkstudio-confirm-page .class-detail[_v-3f6e090a] {\n    margin-left: 20px;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    font-size: 18px;\n    font-weight: 500;\n    color: #000000; }\n    /* line 29, stdin */\n    .checkstudio-confirm-page .class-detail div[_v-3f6e090a] {\n      margin-right: 60px; }\n  @media screen and (max-width: 768px) {\n    /* line 2, stdin */\n    .checkstudio-confirm-page[_v-3f6e090a] {\n      padding: 10px 20px; }\n      /* line 36, stdin */\n      .checkstudio-confirm-page .return-page[_v-3f6e090a] {\n        margin-left: 0; } }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            ajaxing: false,
            schedule_id: 0,
            booking_list: [],
            waiting_list: []
        };
    },
    mounted: function mounted() {
        var _this = this;

        var vm = this;
        this.generateData();
        window.Event.$on("ClassBooking.Changed", function () {
            _this.getBookingList();
            _this.getWaitingList();
        });
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        canAddBooking: function canAddBooking(state) {
            return state.webadmin.configure.webFunctions.WebadminBookingsCreate;
        }
    }), {
        selectOrderId: function selectOrderId() {
            return store.state.pos.select_order.id;
        },
        bookingQty: function bookingQty() {
            return this.booking_list.bookings ? this.booking_list.bookings.length : 0;
        },
        waitingQty: function waitingQty() {
            return this.waiting_list ? this.waiting_list.length : 0;
        },
        schedule: function schedule() {
            if (this.booking_list.schedule) {
                return this.booking_list.schedule;
            };
            return {
                'service_name': '',
                'date': '',
                'staff_name': '',
                'time_start': '',
                'time_end': '',
                'qty': 0
            };
        }
    }),
    methods: (0, _extends3.default)({
        getScheduleID: function getScheduleID() {
            var urlPath = window.location.href.split('?')[0]; //TODO REFACTOR: 暫解，預計用Vue router優化
            var id = urlPath.split('/')[6];
            this.schedule_id = id;
        },
        generateData: function generateData() {
            this.getBookingList();
            this.getWaitingList();
        },
        getBookingList: function getBookingList() {
            var _this2 = this;

            this.getScheduleID();
            this.booking_list = [];
            this.ajaxing = true;
            this.$http.get('/adminapi/checkstudio/confirm/' + this.schedule_id).then(function (response) {
                _this2.ajaxing = false;
                _this2.booking_list = response.data;
                _this2.$store.commit('filters/SETSTATUS', { 'key': 'selected_studio_id', value: response.data.studioId });
                _this2.getBranchList();
            }, function (error) {
                _this2.ajaxing = false;
                $.notify('取得訂課名單失敗，請重新操作！', { className: 'error', globalPosition: 'top center', clickToHide: true });
            });
        },
        getWaitingList: function getWaitingList() {
            var _this3 = this;

            this.getScheduleID();
            this.waiting_list = [];
            this.$http.get('/adminapi/checkstudio/waiting_list/' + this.schedule_id).then(function (response) {
                _this3.waiting_list = response.data;
            }, function (error) {
                $.notify('取得候補名單失敗，請重新操作！', { className: 'error', globalPosition: 'top center', clickToHide: true });
            });
        },
        OpenBookingModal: function OpenBookingModal() {
            if (!this.canAddBooking) {
                $.notify('權限不足', { className: 'error', globalPosition: 'top center', clickToHide: true });
                return;
            };
            window.Event.$emit("ClassBookingModal.Show", {
                date: this.booking_list.schedule.date,
                branch_id: this.booking_list.branchId,
                studio_id: this.booking_list.studioId,
                schedule_id: this.booking_list.schedule.id
            });
        },
        back: function back() {
            window.location = document.referrer;
        }
    }, (0, _vuex.mapActions)('filters', ['getBranchList'])),
    beforeDestroy: function beforeDestroy() {
        window.Event.$off("ClassBooking.Changed");
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-3f6e090a=\"\">\n    <v-spinner :ajaxing=\"ajaxing\" _v-3f6e090a=\"\"></v-spinner>\n    <div class=\"checkstudio-confirm-page\" v-show=\"!ajaxing\" _v-3f6e090a=\"\">\n        <a class=\"return-page\" @click=\"back\" _v-3f6e090a=\"\"> <i class=\"fa fa-chevron-left\" _v-3f6e090a=\"\"></i> 返回</a>\n        <div class=\"class-header\" _v-3f6e090a=\"\">{{schedule.service_name}}</div>\n        <div class=\"class-detail m-top-20\" _v-3f6e090a=\"\">\n            <div _v-3f6e090a=\"\">人員：{{schedule.staff_name}}</div>\n            <div _v-3f6e090a=\"\">日期：{{schedule.date}}</div>\n            <div _v-3f6e090a=\"\">時間：{{schedule.time_start}}-{{schedule.time_end}}</div>\n            <div _v-3f6e090a=\"\">訂位人數：{{bookingQty}}/{{schedule.qty}}</div>\n        </div>\n        <div class=\"m-left-20 m-top-20\" style=\"display: flex;\" _v-3f6e090a=\"\">\n            <button class=\"btn btn-success\" @click=\"OpenBookingModal\" _v-3f6e090a=\"\"><i class=\"fa fa-plus\" _v-3f6e090a=\"\"></i>新增預約</button>\n            <edit-live-link-btn-with-modal :schedule-id=\"schedule.id\" v-show=\"schedule.id\" _v-3f6e090a=\"\"></edit-live-link-btn-with-modal>\n        </div>\n\n        <webadmin-checkstudio-booking-list :confirm-data=\"booking_list\" _v-3f6e090a=\"\"></webadmin-checkstudio-booking-list>\n\n        <div class=\"p-top-20\" style=\"font-size: 18px; border-top: 1px solid #d6d7d9;\" v-show=\"waitingQty !== 0\" _v-3f6e090a=\"\">候補 ({{ waitingQty }})</div>\n        <webadmin-checkstudio-watiting-list :waiting-list=\"waiting_list\" :schedule=\"booking_list.schedule\" _v-3f6e090a=\"\"></webadmin-checkstudio-watiting-list>\n    </div>\n    <webadmin-operate-modal ref=\"operate\" :enable-change-member=\"false\" event-scope=\"sideBar\" _v-3f6e090a=\"\">\n        <template slot=\"event\">\n            <webadmin-order-operate-event-slot-utility event-scope=\"sideBar\" :operate-ref=\"$refs.operate\" _v-3f6e090a=\"\"></webadmin-order-operate-event-slot-utility>\n        </template>\n    </webadmin-operate-modal>\n    <class-booking-modal _v-3f6e090a=\"\"></class-booking-modal>\n</div>    \n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.checkstudio-confirm-page[_v-3f6e090a] {\n  margin: 0 auto;\n  padding: 20px 30px;\n  font-family: PingFangTC; }\n  /* line 6, stdin */\n  .checkstudio-confirm-page .return-page[_v-3f6e090a] {\n    margin-left: 20px;\n    font-size: 16px;\n    font-weight: 500;\n    color: #7c7c7c; }\n  /* line 12, stdin */\n  .checkstudio-confirm-page .class-header[_v-3f6e090a] {\n    margin-top: 25px;\n    text-align: center;\n    line-height: 42px;\n    font-size: 18px;\n    font-weight: 500;\n    letter-spacing: -0.43px;\n    color: #ffffff;\n    background-color: #86959f; }\n  /* line 22, stdin */\n  .checkstudio-confirm-page .class-detail[_v-3f6e090a] {\n    margin-left: 20px;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    font-size: 18px;\n    font-weight: 500;\n    color: #000000; }\n    /* line 29, stdin */\n    .checkstudio-confirm-page .class-detail div[_v-3f6e090a] {\n      margin-right: 60px; }\n  @media screen and (max-width: 768px) {\n    /* line 2, stdin */\n    .checkstudio-confirm-page[_v-3f6e090a] {\n      padding: 10px 20px; }\n      /* line 36, stdin */\n      .checkstudio-confirm-page .return-page[_v-3f6e090a] {\n        margin-left: 0; } }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-3f6e090a", module.exports)
  } else {
    hotAPI.update("_v-3f6e090a", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1035:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _confirm = require('./confirm.vue');

var _confirm2 = _interopRequireDefault(_confirm);

var _bookingList = require('./booking-list.vue');

var _bookingList2 = _interopRequireDefault(_bookingList);

var _waitingList = require('./waiting-list.vue');

var _waitingList2 = _interopRequireDefault(_waitingList);

var _confirmCard = require('./confirm-card.vue');

var _confirmCard2 = _interopRequireDefault(_confirmCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('webadmin-checkstudio-confirm', _confirm2.default);
_vue2.default.component('webadmin-checkstudio-confirm-card', _confirmCard2.default);
_vue2.default.component('webadmin-checkstudio-booking-list', _bookingList2.default);
_vue2.default.component('webadmin-checkstudio-watiting-list', _waitingList2.default);

},{"./booking-list.vue":1032,"./confirm-card.vue":1033,"./confirm.vue":1034,"./waiting-list.vue":1037,"vue":792}],1036:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.checkstudio-widget[_v-6c7f64b7] {\n  margin: 0 auto;\n  padding: 5px; }\n  /* line 5, stdin */\n  .checkstudio-widget .title[_v-6c7f64b7] {\n    font-size: 14px;\n    font-weight: 400; }\n  /* line 9, stdin */\n  .checkstudio-widget .schedule[_v-6c7f64b7] {\n    font-size: 12px;\n    font-weight: 400; }\n    /* line 12, stdin */\n    .checkstudio-widget .schedule b[_v-6c7f64b7] {\n      font-weight: 600;\n      width: 60px;\n      display: inline-block;\n      margin-right: 16px; }\n  /* line 19, stdin */\n  .checkstudio-widget .active-display[_v-6c7f64b7] {\n    color: #646464;\n    font-size: 12px;\n    font-weight: 400; }\n  @media screen and (max-width: 768px) {\n    /* line 2, stdin */\n    .checkstudio-widget[_v-6c7f64b7] {\n      padding: 10px 20px; } }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'CheckStudio',
    props: {
        query: {
            type: Object,
            required: true,
            description: 'Passing query from url'
        },
        widgetOpen: {
            type: Boolean,
            required: true,
            description: 'Widget open/close state'
        }
    },
    data: function data() {
        return {
            ajaxing: false,
            schedule_id: 0,
            booking_list: [],
            waiting_list: [],
            booking_list_show: true,
            waiting_list_show: true
        };
    },

    watch: {
        'query': {
            handler: function handler(newV) {
                if (newV.widget_schedule_id !== this.schedule_id) {
                    this.generateData();
                }
            },
            deep: true
        }
    },
    mounted: function mounted() {
        var _this = this;

        var vm = this;
        this.generateData();

        this.$bus.$on("ClassBooking.Changed", function () {
            _this.getBookingList();
            _this.getWaitingList();
            _this.refreshSchedulePage();
        });
        this.$bus.$on('Pos.Bill.Order', function () {
            _this.getBookingList();
        });
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        canAddBooking: function canAddBooking(state) {
            return state.webadmin.configure.webFunctions.WebadminBookingsCreate;
        }
    }), {
        selectOrderId: function selectOrderId() {
            return store.state.pos.select_order.id;
        },
        bookingQty: function bookingQty() {
            return this.booking_list.bookings ? this.booking_list.bookings.length : 0;
        },
        waitingQty: function waitingQty() {
            return this.waiting_list ? this.waiting_list.length : 0;
        },
        schedule: function schedule() {
            if (this.booking_list.schedule) {
                return this.booking_list.schedule;
            };
            return {
                'service_name': '',
                'date': '',
                'staff_name': '',
                'time_start': '',
                'time_end': '',
                'qty': 0
            };
        }
    }),
    methods: {
        generateData: function generateData() {
            this.getBookingList();
            this.getWaitingList();
        },
        getScheduleID: function getScheduleID() {
            this.schedule_id = Number(this.query.widget_schedule_id);
            this.$emit('open-window-path', '/webadmin/checkstudio/confirm/' + this.query.widget_schedule_id);
        },
        getBookingList: function getBookingList() {
            var _this2 = this;

            this.getScheduleID();
            this.booking_list = [];
            this.ajaxing = true;
            this.$http.get('/adminapi/checkstudio/confirm/' + this.schedule_id).then(function (response) {
                _this2.ajaxing = false;
                _this2.booking_list = response.data;
                _this2.$store.commit('filters/SETSTATUS', { 'key': 'selected_studio_id', value: response.data.studioId });
            }, function (error) {
                _this2.ajaxing = false;
                $.notify('取得訂課名單失敗，請重新操作！', { className: 'error', globalPosition: 'top center', clickToHide: true });
            });
        },
        getWaitingList: function getWaitingList() {
            var _this3 = this;

            this.getScheduleID();
            this.waiting_list = [];
            this.$http.get('/adminapi/checkstudio/waiting_list/' + this.schedule_id).then(function (response) {
                _this3.waiting_list = response.data;
            }, function (error) {
                $.notify('取得候補名單失敗，請重新操作！', { className: 'error', globalPosition: 'top center', clickToHide: true });
            });
        },
        refreshSchedulePage: function refreshSchedulePage() {
            this.$bus.$emit('Schedule.Records.Refresh');
        },
        OpenBookingModal: function OpenBookingModal() {
            if (!this.canAddBooking) {
                $.notify('權限不足', { className: 'error', globalPosition: 'top center', clickToHide: true });
                return;
            };
            this.$bus.$emit("ClassBookingModal.Show", {
                date: this.booking_list.schedule.date,
                branch_id: this.booking_list.branchId,
                studio_id: this.booking_list.studioId,
                schedule_id: this.booking_list.schedule.id
            });
        },
        billSuccessCallBack: function billSuccessCallBack(response) {
            $("#payment-success-" + this.selectOrderId).show();
            $("#payment-fail-" + this.selectOrderId).hide();
            this.$store.dispatch('pos/resetSelectOrder');
            this.$store.dispatch('pos/orderEditSucces');
        },
        billFailCallBack: function billFailCallBack(response) {
            $("#payment-success-" + this.selectOrderId).hide();
            $("#payment-fail-" + this.selectOrderId).show();
            $('#order-edit').modal('hide');
            $('#multi-alert-modal').modal('show');
        },
        showBookingList: function showBookingList() {
            this.booking_list_show = !this.booking_list_show;
        },
        showWaitingList: function showWaitingList() {
            this.waiting_list_show = !this.waiting_list_show;
        }
    },
    beforeDestroy: function beforeDestroy() {
        this.$bus.$off("ClassBooking.Changed");
        this.$bus.$off("Pos.Bill.Order");
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-6c7f64b7=\"\">\n    <v-spinner :ajaxing=\"ajaxing\" _v-6c7f64b7=\"\"></v-spinner>\n    <div class=\"checkstudio-widget\" v-show=\"!ajaxing\" _v-6c7f64b7=\"\">\n        <div class=\"m-left-20 m-top-20 title\" _v-6c7f64b7=\"\">{{schedule.service_name}}</div>\n        <div class=\"m-left-20 m-top-20\" _v-6c7f64b7=\"\">\n            <button class=\"btn btn-success m-bottom-5\" @click=\"OpenBookingModal\" _v-6c7f64b7=\"\"><i class=\"fa fa-plus\" _v-6c7f64b7=\"\"></i>新增預約</button>\n            <edit-live-link-btn-with-modal :schedule-id=\"schedule_id\" v-show=\"schedule_id\" _v-6c7f64b7=\"\"></edit-live-link-btn-with-modal>\n        </div>\n        <div class=\"m-left-20 m-top-20 schedule\" _v-6c7f64b7=\"\">\n            <div class=\"m-bottom-10\" _v-6c7f64b7=\"\"><b _v-6c7f64b7=\"\">時間</b>{{schedule.date}} {{schedule.time_start}}-{{schedule.time_end}}</div>\n            <div class=\"m-bottom-10\" _v-6c7f64b7=\"\"><b _v-6c7f64b7=\"\">人員</b>{{schedule.staff_name}}</div>\n            <div _v-6c7f64b7=\"\"><b _v-6c7f64b7=\"\">訂位人數</b>{{bookingQty}}/{{schedule.qty}}</div>\n        </div>\n        <div v-if=\"bookingQty == 0 &amp;&amp; waitingQty == 0\" style=\"text-align: center; padding-top: 100px;\" _v-6c7f64b7=\"\">\n            <img src=\"/images/no-data-img.png\" width=\"105\" height=\"60\" _v-6c7f64b7=\"\">\n            <div style=\"color: #6c6c6c;\" class=\"m-top-10\" _v-6c7f64b7=\"\">尚無預約</div>\n        </div>\n        <div class=\"p-bottom-90 p-top-20\" v-else=\"\" _v-6c7f64b7=\"\">\n            <a class=\"m-left-20 active-display\" @click.prevent=\"showBookingList\" _v-6c7f64b7=\"\">\n                <i class=\"fa fa-caret-down\" v-if=\"booking_list_show\" _v-6c7f64b7=\"\"></i><i class=\"fa fa-caret-right\" v-else=\"\" _v-6c7f64b7=\"\"></i>\n                <span class=\"m-left-10\" _v-6c7f64b7=\"\">已預約 ({{bookingQty}})</span>\n            </a>\n            <webadmin-checkstudio-booking-list :confirm-data=\"booking_list\" v-show=\"booking_list_show\" _v-6c7f64b7=\"\"></webadmin-checkstudio-booking-list>\n            <hr _v-6c7f64b7=\"\">\n            <a class=\"m-left-20 active-display\" @click.prevent=\"showWaitingList\" _v-6c7f64b7=\"\">\n                <i class=\"fa fa-caret-down\" v-if=\"waiting_list_show\" _v-6c7f64b7=\"\"></i><i class=\"fa fa-caret-right\" v-else=\"\" _v-6c7f64b7=\"\"></i>\n                <span class=\"m-left-10\" _v-6c7f64b7=\"\">候補 ({{waitingQty}})</span>\n            </a>\n            <webadmin-checkstudio-watiting-list :waiting-list=\"waiting_list\" :schedule=\"booking_list.schedule\" v-show=\"waiting_list_show\" _v-6c7f64b7=\"\"></webadmin-checkstudio-watiting-list>            \n        </div>\n    </div>\n    <webadmin-operate-modal :should-use-parallel-modal=\"false\" ref=\"operate\" :enable-change-member=\"false\" event-scope=\"sideBar\" _v-6c7f64b7=\"\">\n        <template slot=\"event\">\n            <webadmin-order-operate-event-slot-utility event-scope=\"sideBar\" :operate-ref=\"$refs.operate\" _v-6c7f64b7=\"\"></webadmin-order-operate-event-slot-utility>\n        </template>\n    </webadmin-operate-modal>\n    <class-booking-modal _v-6c7f64b7=\"\"></class-booking-modal>\n</div>    \n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.checkstudio-widget[_v-6c7f64b7] {\n  margin: 0 auto;\n  padding: 5px; }\n  /* line 5, stdin */\n  .checkstudio-widget .title[_v-6c7f64b7] {\n    font-size: 14px;\n    font-weight: 400; }\n  /* line 9, stdin */\n  .checkstudio-widget .schedule[_v-6c7f64b7] {\n    font-size: 12px;\n    font-weight: 400; }\n    /* line 12, stdin */\n    .checkstudio-widget .schedule b[_v-6c7f64b7] {\n      font-weight: 600;\n      width: 60px;\n      display: inline-block;\n      margin-right: 16px; }\n  /* line 19, stdin */\n  .checkstudio-widget .active-display[_v-6c7f64b7] {\n    color: #646464;\n    font-size: 12px;\n    font-weight: 400; }\n  @media screen and (max-width: 768px) {\n    /* line 2, stdin */\n    .checkstudio-widget[_v-6c7f64b7] {\n      padding: 10px 20px; } }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-6c7f64b7", module.exports)
  } else {
    hotAPI.update("_v-6c7f64b7", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1037:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 3, stdin */\n.checkstudio-waiting-list .card-list[_v-271c7178] {\n  border: none;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -ms-flex-pack: start;\n      justify-content: flex-start; }\n\n@media screen and (max-width: 768px) {\n  /* line 11, stdin */\n  .checkstudio-waiting-list .card-list[_v-271c7178] {\n    padding: 0;\n    margin-top: 10px; } }\n")
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        waitingList: {
            type: [Array, Object]
        },
        schedule: {}
    },
    data: function data() {
        return {};
    },

    computed: {
        isWaitingExist: function isWaitingExist() {
            var qty = this.waitingQty();
            return qty > 0 ? true : false;
        }
    },
    methods: {
        waitingQty: function waitingQty() {
            if (this.waitingList) {
                return this.waitingList.length;
            };
            return 0;
        },
        showMemberCard: function showMemberCard(target) {
            this.$refs.memberProfileOverview.onCall(target.dataset.memberId, target);
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-271c7178=\"\">\n    <div class=\"checkstudio-waiting-list\" v-show=\"isWaitingExist\" _v-271c7178=\"\">\n        <div class=\"card-list\" _v-271c7178=\"\">\n            <template v-for=\"(waiting, index) in waitingList\">\n                <webadmin-checkstudio-confirm-card :key=\"index\" :waiting=\"waiting\" :schedule=\"schedule\" :show-member-profile=\"showMemberCard\" _v-271c7178=\"\">\n                </webadmin-checkstudio-confirm-card>\n            </template>\n        </div>\n    </div>\n    <v-member-profile-overview ref=\"memberProfileOverview\" position-config=\"webadmin/appointment/schedule-class:records[].member\" _v-271c7178=\"\"></v-member-profile-overview>\n</div>    \n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 3, stdin */\n.checkstudio-waiting-list .card-list[_v-271c7178] {\n  border: none;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -ms-flex-pack: start;\n      justify-content: flex-start; }\n\n@media screen and (max-width: 768px) {\n  /* line 11, stdin */\n  .checkstudio-waiting-list .card-list[_v-271c7178] {\n    padding: 0;\n    margin-top: 10px; } }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-271c7178", module.exports)
  } else {
    hotAPI.update("_v-271c7178", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1038:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.form-group[_v-3af7c63c] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: baseline;\n      align-items: baseline; }\n\n/* line 6, stdin */\n.field-lab[_v-3af7c63c] {\n  text-align: right; }\n\n/* line 9, stdin */\n.vue-radio-input[_v-3af7c63c] {\n  display: inline-block;\n  padding-left: 10px; }\n\n@media screen and (max-width: 480px) {\n  /* line 14, stdin */\n  .form-group[_v-3af7c63c] {\n    display: block; }\n  /* line 17, stdin */\n  .field-lab[_v-3af7c63c] {\n    text-align: left; } }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _from = require('babel-runtime/core-js/array/from');

var _from2 = _interopRequireDefault(_from);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {},
    data: function data() {
        return {
            modal_on: false,
            schedule_list: [],
            member_contracts: [],
            numbers: [1, 2, 3, 4, 5],
            selected_schedule: '',
            selected_member_contract: '',
            loading: {
                schedule: false,
                contract: false
            },
            ajaxing: {
                submit: false
            },
            disableOption: {
                date: false,
                studio: false,
                branch: false,
                schedule: false,
                member: false
            },
            postData: {
                date: '',
                studio_id: '',
                branch_id: '',
                schedule_id: '',
                member_id: '',
                name: '',
                phone: '',
                email: '',
                contract_type: 0,
                member_contract_id: '',
                number: '',
                remark: ''
            }
        };
    },
    created: function created() {
        var _this = this;

        window.Event.$on("ClassBookingModal.Show", function (data) {
            _this.showModal(data);
        });
    },
    mounted: function mounted() {},

    watch: {
        'postData.date': {
            handler: function handler(newVal) {
                if (newVal && this.postData.branch_id) {
                    this.fetchSchedule();
                };
            }
        },
        'postData.branch_id': {
            handler: function handler(newVal) {
                this.schedule_list = [];
                this.selected_schedule = '';
                if (newVal && this.postData.date) {
                    this.fetchSchedule();
                };
            }
        },
        selected_schedule: function selected_schedule(newVal) {
            if (!this.isDefaultMember) {
                this.getBindedMember('reset');
                window.Event.$emit("reselect-member-ui-func");
            };
        },

        'postData.name': {
            handler: function handler(newVal) {
                this.postData.contract_type = 0;
            }
        },
        'postData.contract_type': {
            handler: function handler(newVal) {
                if (!this.postData.name && this.modal_on && newVal == 1) {
                    $17.swal({
                        title: '請先選擇客戶',
                        type: 'error',
                        showCancelButton: false
                    });
                };
                newVal == 0 ? this.selected_member_contract = '' : this.fetchContract();
            }
        },
        selected_member_contract: function selected_member_contract(newVal) {
            if (newVal) {
                this.numbers = newVal.numbers;
                this.postData.number = newVal.numbers[0];
                this.postData.member_contract_id = newVal.id;
            } else {
                this.numbers = [];
                this.postData.number = '';
                this.postData.member_contract_id = '';
            }
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        canDelete: function canDelete(state) {
            return state.webadmin.configure.webFunctions.WebadminScheduleDelete;
        },
        canEdit: function canEdit(state) {
            return state.webadmin.configure.webFunctions.WebadminScheduleIndex;
        }
    }), (0, _vuex.mapState)('webadmin/configure', ['isSeventeen', 'isBranch', 'studioId', 'branchId']), {
        isContract: function isContract() {
            return this.postData.contract_type === 1;
        },
        isUseableContract: function isUseableContract() {
            return this.member_contracts.length > 0 || this.loading.contract;
        },
        disableMemberSelect: function disableMemberSelect() {
            return this.postData.studio_id && this.selected_schedule ? false : true;
        },
        isDefaultMember: function isDefaultMember() {
            if (this.disableOption.member) {
                return {
                    'id': this.postData.member_id,
                    'name': this.postData.name,
                    'phone': this.postData.phone,
                    'email': this.postData.email
                };
            } else {
                return false;
            };
        },
        disableSubmit: function disableSubmit() {
            return this.ajaxing.submit;
        }
    }),
    methods: {
        resetData: function resetData() {
            this.selected_schedule = '';
            this.selected_member_contract = '';
            this.postData = _lodash2.default.mapValues(this.postData, function () {
                return '';
            });
            this.postData.contract_type = 0;
            this.disableOption = _lodash2.default.mapValues(this.disableOption, function () {
                return false;
            });
        },
        showModal: function showModal(data) {
            if (data) {
                this.disableOption = {
                    date: data.date ? true : false,
                    studio: data.studio_id ? true : false,
                    branch: data.branch_id ? true : false,
                    schedule: data.schedule_id ? true : false,
                    member: data.name ? true : false
                };
                this.postData = (0, _extends3.default)({}, this.postData, data);
            };
            this.modal_on = true;
            $('#class-booking-modal').modal('show');
        },
        fetchSchedule: function fetchSchedule() {
            var _this2 = this;

            this.schedule_list = [];
            this.selected_schedule = '';
            this.loading.schedule = true;

            this.$http.get('/adminapi/schedule/get-schedule-by-date?date=' + this.postData.date + '&branch_id=' + this.postData.branch_id).then(function (response) {
                _this2.schedule_list = response.data;
                _this2.loading.schedule = false;
                if (_this2.disableOption.schedule) {
                    _this2.selected_schedule = _this2.schedule_list.find(function (item) {
                        return item.id == _this2.postData.schedule_id;
                    });
                };
            }).catch(function (response) {
                $17.swal({
                    title: '無法取得課表',
                    text: response.data.message,
                    type: 'error',
                    showCancelButton: false
                });
                _this2.loading.schedule = false;
            });
        },
        fetchContract: function fetchContract() {
            var _this3 = this;

            var vm = this;
            var data = {
                'member_id': this.postData.member_id,
                'date': this.postData.date,
                'schedule_id': this.postData.schedule_id,
                'branch_id': this.postData.branch_id,
                'contract_type': this.postData.contract_type
            };
            var params = $.param(data);
            this.loading.contract = true;
            this.$http.get('/adminapi/member/' + data.member_id + '/contracts?' + params).then(function (response) {
                var contracts = response.data;
                _this3.member_contracts = contracts.map(function (contract) {
                    switch (contract.type) {
                        case 1:
                            contract.name += '(\u53EF\u7528\u6642\u9593' + contract.start_time + '~' + contract.end_time + ')';
                            break;
                        case 2:
                            contract.name += '(\u5269\u9918' + contract.remain + '\u9EDE)';
                            break;
                        case 3:
                            contract.name += '(\u5269\u9918' + contract.remain + '\u6B21)';
                            break;
                    };
                    if (contract.owner_member_id !== vm.postData.member_id) {
                        contract.name += '(\u64C1\u6709\u8005' + contract.owner_name + ')';
                    };
                    return {
                        id: contract.id,
                        name: contract.name,
                        numbers: (0, _from2.default)({ length: contract.numbers }, function (_, i) {
                            return i + 1;
                        })
                    };
                });
                _this3.loading.contract = false;
            }).catch(function (error) {
                _this3.loading.contract = false;
            });
        },
        openScheduleList: function openScheduleList() {
            if (!this.postData.date || !this.postData.branch_id) {
                $17.swal({
                    title: '請先選擇日期及場館',
                    type: 'error',
                    showCancelButton: false
                });
                return;
            };
        },
        closeModalEvent: function closeModalEvent() {
            this.modal_on = false;
            this.resetData();
        },
        getBindedStudio: function getBindedStudio(studioId) {
            this.postData.studio_id = studioId;
        },
        getBindedBranch: function getBindedBranch(branchId) {
            this.postData.branch_id = branchId;
        },
        getBindedMember: function getBindedMember(member) {
            if (member == 'reset') {
                this.postData.member_id = '';
                this.postData.name = '';
                this.postData.phone = '';
                this.postData.email = '';
            } else {
                this.postData.member_id = member.member_id;
                this.postData.name = member.member_name;
                this.postData.phone = member.member_phone;
                this.postData.email = member.member_email;
            };
        },
        submit: function submit() {
            this.ajaxing.submit = true;
            this.postData.schedule_id = this.selected_schedule.id;
            this.postData.member_contract_id = this.selected_member_contract ? this.selected_member_contract.id : '';
            this.checkIsOverLimit();
        },
        checkIsOverLimit: function checkIsOverLimit() {
            var _this4 = this;

            if (this.postData.contract_type == 0) {
                this.postData.number = 1;
            };
            this.$http.get('/adminapi/bookings/check-is-over-limit?booking_number=' + this.postData.number + '&schedule_id=' + this.postData.schedule_id).then(function (response) {
                if (response.data.is_over_limit == true) {
                    $17.swal({
                        title: '預約名額超過剩餘名額或課程不在可訂課時間，仍要預約？',
                        type: 'info',
                        showCancelButton: true,
                        confirmButtonText: '預約'
                    }, function (isConfirm) {
                        if (isConfirm) {
                            _this4.postAddClass();
                        } else {
                            _this4.ajaxing.submit = false;
                        }
                    });
                } else {
                    _this4.postAddClass();
                };
            }).catch(function (response) {
                _this4.ajaxing.submit = false;
                $17.swal({
                    title: '新增訂課錯誤',
                    text: response.data.message,
                    type: 'error',
                    showCancelButton: false
                });
            });
        },
        postAddClass: function postAddClass() {
            var _this5 = this;

            this.$http.post('/adminapi/bookings/store', this.postData).then(function (response) {
                window.Event.$emit("ClassBooking.Changed");
                _this5.cancel();
                $.notify('新增訂課成功', { className: 'success', globalPosition: 'top center', clickToHide: true });
                _this5.ajaxing.submit = false;
            }).catch(function (response) {
                _this5.ajaxing.submit = false;
                $17.swal({
                    title: '新增訂課失敗',
                    text: response.data.message,
                    type: 'error',
                    showCancelButton: false
                });
            });
        },
        cancel: function cancel() {
            $('#class-booking-modal').modal('hide');
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-3af7c63c=\"\">\n    <v-modal id=\"class-booking-modal\" :close-modal-event=\"closeModalEvent\" _v-3af7c63c=\"\">\n        <div slot=\"title\" _v-3af7c63c=\"\">\n            <h4 _v-3af7c63c=\"\">新增預約</h4>\n        </div>\n        <div slot=\"body\" _v-3af7c63c=\"\">\n            <div class=\"form-horizontal\" _v-3af7c63c=\"\">\n            <div class=\"row form-group\" _v-3af7c63c=\"\">\n                <div class=\"field-lab col-sm-3\" _v-3af7c63c=\"\">\n                    <label class=\"control-label\" _v-3af7c63c=\"\">日期</label>\n                </div>\n                <div class=\"col-sm-8\" _v-3af7c63c=\"\">\n                    <v-datepicker input-class=\"schedule-date\" v-model=\"postData.date\" placeholder=\"選擇日期\" :disabled=\"disableOption.date\" _v-3af7c63c=\"\"></v-datepicker>\n                </div>\n            </div>\n\n            <template v-if=\"!isBranch\">\n                <v-multiselect-studio-and-branch-form :studio_id=\"postData.studio_id == '' ? 0 : postData.studio_id\" :branch_id=\"postData.branch_id == '' ? 0 : postData.branch_id\" :branch-without-filtered-option=\"false\" :branch-change-call-back=\"getBindedBranch\" :studio-change-call-back=\"getBindedStudio\" :disable-studio-option=\"disableOption.studio\" :disable-branch-option=\"disableOption.branch\" _v-3af7c63c=\"\"></v-multiselect-studio-and-branch-form>                    \n            </template>\n\n\n            <div class=\"row form-group\" _v-3af7c63c=\"\">\n                <div class=\"field-lab col-sm-3\" _v-3af7c63c=\"\">\n                    <label class=\"control-label\" _v-3af7c63c=\"\">課表</label>\n                </div>\n                <div class=\"col-sm-8\" _v-3af7c63c=\"\">\n                    <v-mutiselect :model.sync=\"selected_schedule\" :options=\"schedule_list\" :close-on-select=\"true\" :clear-on-select=\"false\" :searchable=\"true\" placeholder=\"請選擇\" label=\"name\" track-by=\"id\" :disabled=\"disableOption.schedule\" :open-event-append=\"openScheduleList\" :is-loading=\"loading.schedule\" _v-3af7c63c=\"\"></v-mutiselect>\n                </div>\n            </div>\n\n            <edit-member-form :studio_id=\"postData.studio_id\" :member-change-call-back=\"getBindedMember\" :disabled=\"disableMemberSelect\" :default-member=\"isDefaultMember\" _v-3af7c63c=\"\"></edit-member-form>\n\n            <div class=\"row form-group\" _v-3af7c63c=\"\">\n                <div class=\"field-lab col-sm-3\" _v-3af7c63c=\"\">\n                    <label class=\"control-label\" _v-3af7c63c=\"\"><span style=\"color: red;\" _v-3af7c63c=\"\">*</span>預約方式</label>\n                </div>\n                <div class=\"col-sm-3\" _v-3af7c63c=\"\">\n                    <label class=\"vue-radio-input\" _v-3af7c63c=\"\">\n                        <input type=\"radio\" :value=\"1\" v-model=\"postData.contract_type\" _v-3af7c63c=\"\"> 方案\n                    </label>\n                    <label class=\"vue-radio-input\" _v-3af7c63c=\"\">\n                        <input type=\"radio\" :value=\"0\" v-model=\"postData.contract_type\" _v-3af7c63c=\"\"> 單次\n                    </label>\n                </div>\n            </div>\n            <div class=\"row form-group\" v-show=\"isContract\" _v-3af7c63c=\"\">\n                <div class=\"field-lab col-sm-3\" _v-3af7c63c=\"\"></div>\n                <div class=\"col-sm-8\" v-if=\"isUseableContract\" _v-3af7c63c=\"\">\n                    <v-mutiselect :model.sync=\"selected_member_contract\" :options=\"member_contracts\" :close-on-select=\"true\" :clear-on-select=\"false\" :searchable=\"false\" placeholder=\"請選擇\" label=\"name\" track-by=\"id\" :is-loading=\"loading.contract\" _v-3af7c63c=\"\"></v-mutiselect>\n                </div>\n                <div class=\"col-sm-8\" v-else=\"\" _v-3af7c63c=\"\">\n                    <span style=\"color: red;\" _v-3af7c63c=\"\">沒有可使用的方案</span>\n                </div>\n            </div>\n            <div class=\"row form-group\" v-show=\"isContract &amp;&amp; selected_member_contract\" _v-3af7c63c=\"\">\n                <div class=\"field-lab col-sm-3\" _v-3af7c63c=\"\">\n                    <label class=\"control-label\" _v-3af7c63c=\"\"><span style=\"color: red;\" _v-3af7c63c=\"\">*</span>數量</label>\n                </div>\n                <div class=\"col-sm-8\" _v-3af7c63c=\"\">\n                    <v-mutiselect :model.sync=\"postData.number\" :options=\"numbers\" :searchable=\"false\" :close-on-select=\"true\" :allow-empty=\"false\" placeholder=\"請選擇\" _v-3af7c63c=\"\"></v-mutiselect>\n                </div>\n            </div>\n            <div class=\"row\" _v-3af7c63c=\"\">\n                <div class=\"field-lab col-sm-3\" _v-3af7c63c=\"\">\n                    <label class=\"control-label\" for=\"management-remark\" _v-3af7c63c=\"\">管理備註</label>\n                </div>\n                <div class=\"col-sm-8\" _v-3af7c63c=\"\">\n                    <textarea id=\"management-remark\" class=\"col-sm-12 form-control\" name=\"remark\" cols=\"30\" rows=\"5\" v-model=\"postData.remark\" :disabled=\"false\" _v-3af7c63c=\"\"></textarea>\n                </div>\n            </div>\n            </div>\n        </div>\n        <div slot=\"footer\" _v-3af7c63c=\"\">\n            <div style=\"float:right;width:80%;\" _v-3af7c63c=\"\">\n                <button class=\"btn btn-primary btn-post-appointment\" @click.prevent=\"submit\" :disabled=\"disableSubmit\" _v-3af7c63c=\"\">\n                    <span v-show=\"!ajaxing.submit\" _v-3af7c63c=\"\">送出</span>\n                    <i v-show=\"ajaxing.submit\" class=\"fa fa-spin fa-spinner\" _v-3af7c63c=\"\"></i>\n                </button>\n                <button class=\"btn btn-default\" @click.prevent=\"cancel\" _v-3af7c63c=\"\">取消</button>\n            </div>\n        </div>\n    </v-modal>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.form-group[_v-3af7c63c] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: baseline;\n      align-items: baseline; }\n\n/* line 6, stdin */\n.field-lab[_v-3af7c63c] {\n  text-align: right; }\n\n/* line 9, stdin */\n.vue-radio-input[_v-3af7c63c] {\n  display: inline-block;\n  padding-left: 10px; }\n\n@media screen and (max-width: 480px) {\n  /* line 14, stdin */\n  .form-group[_v-3af7c63c] {\n    display: block; }\n  /* line 17, stdin */\n  .field-lab[_v-3af7c63c] {\n    text-align: left; } }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-3af7c63c", module.exports)
  } else {
    hotAPI.update("_v-3af7c63c", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/array/from":45,"babel-runtime/helpers/extends":66,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1039:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.form-group[_v-5bd0a8f4] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: baseline;\n      align-items: baseline; }\n  /* line 5, stdin */\n  .form-group .col-sm-2[_v-5bd0a8f4] {\n    padding-left: 0; }\n\n@media screen and (max-width: 480px) {\n  /* line 10, stdin */\n  .form-group[_v-5bd0a8f4] {\n    display: -ms-grid;\n    display: grid; }\n    /* line 12, stdin */\n    .form-group .input-title[_v-5bd0a8f4] {\n      -ms-grid-row: 1;\n          grid-row: 1;\n      text-align: left; }\n    /* line 16, stdin */\n    .form-group .control-label[_v-5bd0a8f4] {\n      text-align: left; }\n    /* line 19, stdin */\n    .form-group .switch-btn[_v-5bd0a8f4] {\n      -ms-grid-row: 2;\n          grid-row: 2;\n      margin-bottom: 10px; }\n    /* line 23, stdin */\n    .form-group .col-sm-2[_v-5bd0a8f4] {\n      padding-left: 15px; } }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        'studio_id': {},
        'disabled': {
            default: false,
            type: Boolean
        },
        'defaultMember': {
            default: false,
            type: [Object, Boolean],
            description: 'If default member exit, show member only and hidden 重新選擇 button'
        },
        'memberChangeCallBack': {
            type: Function
        }
    },
    data: function data() {
        return {
            view: {
                member_allow_online_booking: 1,
                action: 'create',
                booking: {
                    member_id: '',
                    member_name: '',
                    member_email: '',
                    member_phone: '',
                    booking_admin: 0,
                    member_is_walkin: 0
                }
            },
            postData: {
                member_id: 0
            },
            create_member: {
                status: false,
                name: '',
                phone: '',
                email: ''
            }
        };
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        canCreateMember: function canCreateMember(state) {
            return state.webadmin.configure.webFunctions.WebadminMemberStudioIndex;
        }
    }), {
        memberNotWalkin: function memberNotWalkin() {
            return this.view.booking.member_is_walkin === 0;
        },
        createMember: function createMember() {
            return this.create_member.status;
        },
        disableMemberSearch: function disableMemberSearch() {
            return !this.studio_id;
        },
        showReadMode: function showReadMode() {
            return this.postData.member_id > 0 || this.defaultMember;
        }
    }),
    watch: {
        defaultMember: function defaultMember(newVal) {
            if (newVal) {
                this.setViewMode(newVal);
            } else {
                this.resetMemberUI(false);
            }
        }
    },
    mounted: function mounted() {
        var _this = this;

        window.Event.$on("reselect-member-ui-func", function () {
            _this.resetMemberUI(false);
        });
    },

    methods: {
        clickCreateMember: function clickCreateMember() {
            if (!this.canCreateMember) {
                $.notify('權限不足', { className: 'error', globalPosition: 'top center', clickToHide: true });
                return;
            };
            this.resetMemberUI(true);
        },
        memberMultiSelectedAction: function memberMultiSelectedAction(e) {
            var _this2 = this;

            this.$store.dispatch('webadmin/crm/getMemberStatus', e.id).then(function () {
                _this2.view.member_allow_online_booking = _this2.$store.state.webadmin.crm.memberStatus.hasOwnProperty('online_booking') ? _this2.$store.state.webadmin.crm.memberStatus.online_booking : 1;
            });

            this.view.booking.member_email = e.email;
            this.view.booking.member_name = e.name;
            this.view.booking.member_phone = e.phone;
            this.view.booking.member_id = e.id;
            this.view.booking.member_is_walkin = 0;
            this.view.booking.booking_admin = 0;
            this.postData.member_id = e.id;
            this.memberChangeCallBack && this.memberChangeCallBack(this.view.booking);
        },
        memberRunSelectedAction: function memberRunSelectedAction(e) {
            this.view.booking.member_email = '';
            this.view.booking.member_name = '';
            this.view.booking.member_phone = '';
            this.view.booking.member_id = '';
            this.view.booking.member_is_walkin = 0;
            this.view.booking.booking_admin = 0;
            this.postData.member_id = 0;
            this.memberChangeCallBack && this.memberChangeCallBack('reset');
        },
        submitNewMember: function submitNewMember() {
            var _this3 = this;

            if (!this.canCreateMember) {
                $17.swal({
                    title: '權限不足',
                    type: 'error',
                    showCancelButton: false
                });
                return;
            };
            if (this.disabled) {
                $17.swal({
                    title: '請先選擇場館及課表',
                    type: 'error',
                    showCancelButton: false
                });
                return;
            };
            if (!this.create_member.name) {
                $17.swal({
                    title: '姓名為必填',
                    type: 'error',
                    showCancelButton: false
                });
                return;
            };

            this.$http.post('/adminapi/member/add-studio-member/' + this.studio_id, {
                name: this.create_member.name,
                phone: this.create_member.phone,
                email: this.create_member.email
            }).then(function (response) {
                var newMember = response.data.data;
                _this3.setViewMode(newMember);
                _this3.memberChangeCallBack && _this3.memberChangeCallBack(_this3.view.booking);
            }).catch(function (response) {
                $17.swal({
                    title: '新增客戶發生錯誤',
                    text: response.data.message ? JSON.parse(response.data.message) : '新增失敗',
                    type: 'error',
                    showCancelButton: false
                });
                _this3.resetMemberUI(true);
                _this3.memberChangeCallBack && _this3.memberChangeCallBack('reset');
            });
        },
        setViewMode: function setViewMode(member) {
            this.postData.member_id = member.id;
            this.view.booking.member_id = member.id;
            this.view.booking.member_name = member.name;
            this.view.booking.member_email = member.email;
            this.view.booking.member_phone = member.phone;
            this.view.booking.member_is_walkin = 0;
            this.view.booking.booking_admin = 0;
            this.create_member = {
                status: false,
                name: '',
                phone: '',
                email: ''
            };
        },
        resetMemberUI: function resetMemberUI(status) {
            this.view.member_allow_online_booking = 1;
            this.postData.member_id = 0;
            this.create_member = {
                status: status,
                name: '',
                phone: '',
                email: ''
            };
            this.memberChangeCallBack && this.memberChangeCallBack('reset');
        }
    },
    beforeDestroy: function beforeDestroy() {
        window.Event.$off("reselect-member-ui-func");
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div v-if=\"showReadMode\" _v-5bd0a8f4=\"\">\n    <div class=\"form-group\" _v-5bd0a8f4=\"\">\n        <label class=\"col-sm-3 control-label input-title\" _v-5bd0a8f4=\"\">客戶姓名</label>\n        <div class=\"col-sm-6\" _v-5bd0a8f4=\"\">\n            <label class=\"control-label\" _v-5bd0a8f4=\"\">{{view.booking.member_name}}</label>\n            <v-member-tag :member-id=\"postData.member_id\" _v-5bd0a8f4=\"\"></v-member-tag>\n        </div>\n        <div class=\"col-sm-2 switch-btn\" v-if=\"view.action==='create' &amp;&amp; !defaultMember\" _v-5bd0a8f4=\"\">\n            <button class=\"btn btn-primary\" @click=\"resetMemberUI(false)\" _v-5bd0a8f4=\"\">重新選擇</button>\n        </div>\n        <div class=\"col-sm-2 switch-btn\" v-else-if=\"view.action==='update' &amp;&amp; view.booking.booking_admin===0 &amp;&amp; memberNotWalkin\" _v-5bd0a8f4=\"\">\n            <h4 class=\"m-top-2\" _v-5bd0a8f4=\"\">\n                <span class=\"label label-info\" _v-5bd0a8f4=\"\">線上預約</span>\n            </h4>\n        </div>\n    </div>\n    <div class=\"form-group\" v-show=\"memberNotWalkin\" _v-5bd0a8f4=\"\">\n        <label class=\"col-sm-3 control-label\" _v-5bd0a8f4=\"\">電子郵件</label>\n        <div class=\"col-sm-5\" _v-5bd0a8f4=\"\"><label class=\"control-label\" _v-5bd0a8f4=\"\">{{view.booking.member_email}}</label></div>\n        <div class=\"col-sm-1\" _v-5bd0a8f4=\"\"></div>\n    </div>\n    <div class=\"form-group\" v-show=\"memberNotWalkin\" _v-5bd0a8f4=\"\">\n        <label class=\"col-sm-3 control-label\" _v-5bd0a8f4=\"\">行動電話</label>\n        <div class=\"col-sm-5\" _v-5bd0a8f4=\"\"><label class=\"control-label\" _v-5bd0a8f4=\"\">{{view.booking.member_phone}}</label></div>\n        <div class=\"col-sm-1\" _v-5bd0a8f4=\"\"></div>\n    </div>\n</div>\n\n<div v-else-if=\"createMember\" _v-5bd0a8f4=\"\">\n    <div class=\"form-group\" _v-5bd0a8f4=\"\">\n        <label class=\"col-sm-3 control-label input-title\" _v-5bd0a8f4=\"\">新增客戶</label>\n        <div class=\"col-sm-6\" _v-5bd0a8f4=\"\">\n            <input type=\"text\" v-model=\"create_member.name\" class=\"form-control\" placeholder=\"客戶姓名\" _v-5bd0a8f4=\"\">\n        </div>\n        <div class=\"col-sm-2 switch-btn\" _v-5bd0a8f4=\"\">\n            <button class=\"btn btn-primary\" @click=\"resetMemberUI(false)\" _v-5bd0a8f4=\"\">重新選擇</button>\n        </div>\n    </div>\n    <div class=\"form-group\" _v-5bd0a8f4=\"\">\n        <label class=\"col-sm-3 control-label\" _v-5bd0a8f4=\"\"></label>\n        <div class=\"col-sm-6\" _v-5bd0a8f4=\"\">\n            <input type=\"email\" v-model=\"create_member.email\" class=\"form-control\" placeholder=\"電子郵件 ex.demo.xmail.com\" _v-5bd0a8f4=\"\">\n        </div>\n    </div>\n    <div class=\"form-group\" _v-5bd0a8f4=\"\">\n        <label class=\"col-sm-3 control-label\" _v-5bd0a8f4=\"\"></label>\n        <div class=\"col-sm-6\" _v-5bd0a8f4=\"\">\n            <input type=\"text\" v-model=\"create_member.phone\" class=\"form-control\" placeholder=\"行動電話 ex.0987654321\" _v-5bd0a8f4=\"\">\n        </div>\n    </div>\n    <div class=\"form-group\" _v-5bd0a8f4=\"\">\n        <label class=\"col-sm-3 control-label\" _v-5bd0a8f4=\"\"></label>\n        <div class=\"col-sm-6\" _v-5bd0a8f4=\"\">\n            <button class=\"btn btn-primary form-control\" @click=\"submitNewMember\" _v-5bd0a8f4=\"\">確認新增</button>\n        </div>\n    </div>\n</div>\n\n<div v-else=\"\" _v-5bd0a8f4=\"\">\n    <div class=\"form-group\" _v-5bd0a8f4=\"\">\n        <label class=\"col-sm-3 control-label input-title\" _v-5bd0a8f4=\"\">客戶</label>\n        <div class=\"col-sm-6\" _v-5bd0a8f4=\"\">\n            <v-member-multi-select id=\"search-member\" :studio-id=\"postData.studio_id\" :keep=\"true\" :clear-when-select=\"true\" :disabled=\"disabled\" :selected-action=\"memberMultiSelectedAction\" :unselected-action=\"memberRunSelectedAction\" :max-height=\"250\" _v-5bd0a8f4=\"\">\n            </v-member-multi-select>\n        </div>\n        <div class=\"col-sm-2 switch-btn\" v-if=\"view.action==='create' &amp;&amp; postData.member_id===0\" _v-5bd0a8f4=\"\">\n            <button class=\"btn btn-success\" v-if=\"!createMember\" @click=\"clickCreateMember\" _v-5bd0a8f4=\"\">\n                <i class=\"fa fa-plus\" _v-5bd0a8f4=\"\"></i> 新增客戶\n            </button>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.form-group[_v-5bd0a8f4] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: baseline;\n      align-items: baseline; }\n  /* line 5, stdin */\n  .form-group .col-sm-2[_v-5bd0a8f4] {\n    padding-left: 0; }\n\n@media screen and (max-width: 480px) {\n  /* line 10, stdin */\n  .form-group[_v-5bd0a8f4] {\n    display: -ms-grid;\n    display: grid; }\n    /* line 12, stdin */\n    .form-group .input-title[_v-5bd0a8f4] {\n      -ms-grid-row: 1;\n          grid-row: 1;\n      text-align: left; }\n    /* line 16, stdin */\n    .form-group .control-label[_v-5bd0a8f4] {\n      text-align: left; }\n    /* line 19, stdin */\n    .form-group .switch-btn[_v-5bd0a8f4] {\n      -ms-grid-row: 2;\n          grid-row: 2;\n      margin-bottom: 10px; }\n    /* line 23, stdin */\n    .form-group .col-sm-2[_v-5bd0a8f4] {\n      padding-left: 15px; } }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-5bd0a8f4", module.exports)
  } else {
    hotAPI.update("_v-5bd0a8f4", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1040:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _classBookingModal = require('./class-booking-modal.vue');

var _classBookingModal2 = _interopRequireDefault(_classBookingModal);

var _editMemberForm = require('./edit-member-form.vue');

var _editMemberForm2 = _interopRequireDefault(_editMemberForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('class-booking-modal', _classBookingModal2.default);
_vue2.default.component('edit-member-form', _editMemberForm2.default);

},{"./class-booking-modal.vue":1038,"./edit-member-form.vue":1039,"vue":792}],1041:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("@media (min-width: 992px) {\n  /* line 3, stdin */\n  .modal-lg[_v-34db6d5b] {\n    width: 1200px; } }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        title: {
            type: String,
            default: ''
        }
    },
    data: function data() {
        return {
            ajaxing: false,
            image: '',
            view: {
                action: 'create'
            },
            currentId: 0,
            postData: {
                id: 0,
                name: '',
                alt: '',
                type: 1,
                active: 0,
                active_time: '',
                inactive_time: '',
                src: '',
                src_type: 'img',
                action_url: ''
            }
        };
    },

    methods: {
        onChange: function onChange(event) {
            var vm = this;
            this.$nextTick(function () {
                $17.imageToString({
                    image: event.target.files[0],
                    width: 1170,
                    height: 280,
                    callback: function callback(imageString) {
                        vm.postData.src = imageString;
                        vm.image = imageString;
                    }
                });
            });
        },
        submit: function submit() {
            if (this.view.action === 'update') {
                this.update();
            } else if (this.view.action === 'create') {
                this.create();
            }
        },
        show: function show() {
            var _this = this;

            this.ajaxing = true;
            this.$http.get('/adminapi/carousel/item/' + this.currentId).then(function (response) {
                var data = response.body;
                _this.image = data.src;
                _this.postData = {
                    id: data.id,
                    name: data.name,
                    alt: data.alt,
                    type: data.type,
                    active: data.active,
                    active_time: data.active_time,
                    inactive_time: data.inactive_time,
                    src: data.src,
                    src_type: data.src_type,
                    action_url: data.action_url
                };
                _this.ajaxing = false;
            }).catch(function (response) {
                _this.ajaxing = false;
                $17.swal({
                    title: '取得資料失敗',
                    type: 'error',
                    showCancelButton: false
                });
            });
        },
        create: function create() {
            var _this2 = this;

            this.ajaxing = true;
            this.$http.post('/adminapi/carousel/item/', this.postData).then(function (response) {
                _this2.ajaxing = false;
                _this2.finishModal();
                $17.swal({
                    title: '新增成功',
                    type: 'success',
                    showCancelButton: false
                });
            }).catch(function (response) {
                _this2.ajaxing = false;
                $17.swal({
                    title: '新增失敗',
                    text: response.data.message,
                    type: 'error',
                    showCancelButton: false
                });
            });
        },
        deletePage: function deletePage() {
            var vm = this;
            $17.swal({
                title: '確定刪除？',
                type: 'warning'
            }, function () {
                vm.ajaxing = true;
                vm.$http.delete('/adminapi/carousel/item/' + vm.currentId).then(function (response) {
                    vm.ajaxing = false;
                    vm.finishModal();
                    $17.swal({
                        title: '刪除成功',
                        type: 'success',
                        showCancelButton: false
                    });
                }).catch(function (response) {
                    vm.ajaxing = false;
                    $17.swal({
                        title: '刪除失敗',
                        text: response.data.errorMessage,
                        type: 'error',
                        showCancelButton: false
                    });
                });
            });
        },
        update: function update() {
            var _this3 = this;

            this.ajaxing = true;
            this.$http.put('/adminapi/carousel/item/' + this.currentId, this.postData).then(function (response) {
                _this3.ajaxing = false;
                _this3.finishModal();
                $17.swal({
                    title: '更新成功',
                    type: 'success',
                    showCancelButton: false
                });
            }).catch(function (response) {
                _this3.ajaxing = false;
                $17.swal({
                    title: '更新失敗',
                    text: response.data.message,
                    type: 'error',
                    showCancelButton: false
                });
            });
        },
        finishModal: function finishModal() {
            this.$emit('refresh');
            $('#carousel-modal').modal('hide');
        },
        resetForm: function resetForm() {
            this.image = '';
            this.currentId = 0;
            this.postData = {
                id: 0,
                name: '',
                alt: '',
                type: 1,
                active: 0,
                active_time: '',
                inactive_time: '',
                src: '',
                src_type: 'img',
                action_url: ''
            };
        },
        onCall: function onCall(id, action) {
            this.resetForm();

            this.view.action = action;
            if (action === 'update') {
                this.currentId = id;
                this.show();
            }
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div id=\"carousel-modal\" class=\"modal fade\" role=\"dialog\" data-keyboard=\"false\" data-backdrop=\"static\" _v-34db6d5b=\"\">\n    <div class=\"modal-dialog modal-lg\" _v-34db6d5b=\"\">\n        <div class=\"modal-content\" _v-34db6d5b=\"\">\n            <div class=\"modal-header\" _v-34db6d5b=\"\">\n                <button type=\"button\" v-show=\"!ajaxing\" class=\"close\" data-dismiss=\"modal\" _v-34db6d5b=\"\">×</button>\n                <h4 class=\"modal-title\" _v-34db6d5b=\"\">{{ title }}</h4>\n            </div>\n            <v-spinner :ajaxing=\"ajaxing\" _v-34db6d5b=\"\"></v-spinner>\n            <div v-show=\"!ajaxing\" class=\"modal-body\" _v-34db6d5b=\"\">\n                <div class=\"form-horizontal\" _v-34db6d5b=\"\">\n                    <div class=\"form-group\" _v-34db6d5b=\"\">\n                        <label class=\"col-sm-2 control-label p-t-0\" _v-34db6d5b=\"\">識別名稱</label>\n                        <div class=\"col-sm-10 m-bottom-20\" _v-34db6d5b=\"\">\n                            <input type=\"text\" class=\"form-control\" v-model=\"postData.name\" _v-34db6d5b=\"\">\n                        </div>\n                    </div>\n                    <div class=\"form-group\" _v-34db6d5b=\"\">\n                        <label class=\"col-sm-2 control-label p-t-0\" _v-34db6d5b=\"\">Banner圖示</label>\n                        <div class=\"col-sm-10 m-bottom-20\" _v-34db6d5b=\"\">\n                            <input type=\"file\" class=\"upload\" @change=\"onChange\" accept=\"image/jpeg,image/png,image/jpg\" _v-34db6d5b=\"\">\n                            <div class=\"row m-top-5\" v-show=\"image!==''\" _v-34db6d5b=\"\">\n                                <img :src=\"image\" class=\"col-xs-12 col-sm-3\" _v-34db6d5b=\"\">\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"form-group\" _v-34db6d5b=\"\">\n                        <label class=\"col-sm-2 control-label p-t-0\" _v-34db6d5b=\"\">ALT</label>\n                        <div class=\"col-sm-10 m-bottom-20\" _v-34db6d5b=\"\">\n                            <input type=\"text\" class=\"form-control\" v-model=\"postData.alt\" _v-34db6d5b=\"\">\n                        </div>\n                    </div>\n                    <div class=\"form-group\" _v-34db6d5b=\"\">\n                        <label class=\"col-sm-2 control-label p-t-0\" _v-34db6d5b=\"\">顯示</label>\n                        <div class=\"col-sm-10\" _v-34db6d5b=\"\">\n                            <label _v-34db6d5b=\"\">\n                                <input v-model=\"postData.active\" :checked=\"postData.is_hidden==1\" value=\"1\" type=\"radio\" _v-34db6d5b=\"\"> 顯示\n                            </label>\n                            <label class=\"m-right-10\" _v-34db6d5b=\"\">\n                                <input v-model=\"postData.active\" :checked=\"postData.is_hidden==0\" value=\"0\" type=\"radio\" _v-34db6d5b=\"\"> 不顯示\n                            </label>\n                        </div>\n                    </div>\n                    <div class=\"form-group\" _v-34db6d5b=\"\">\n                        <label class=\"col-sm-2 control-label p-t-0\" _v-34db6d5b=\"\">啟用時間</label>\n                        <div class=\"col-sm-10 m-bottom-20\" _v-34db6d5b=\"\">\n                            <input type=\"text\" class=\"form-control\" v-model=\"postData.active_time\" _v-34db6d5b=\"\">\n                        </div>\n                    </div>\n                    <div class=\"form-group\" _v-34db6d5b=\"\">\n                        <label class=\"col-sm-2 control-label p-t-0\" _v-34db6d5b=\"\">失效時間</label>\n                        <div class=\"col-sm-10 m-bottom-20\" _v-34db6d5b=\"\">\n                            <input type=\"text\" class=\"form-control\" v-model=\"postData.inactive_time\" _v-34db6d5b=\"\">\n                        </div>\n                    </div>\n                    <div class=\"form-group\" _v-34db6d5b=\"\">\n                        <label class=\"col-sm-2 control-label p-t-0\" _v-34db6d5b=\"\">連結網址</label>\n                        <div class=\"col-sm-10 m-bottom-20\" _v-34db6d5b=\"\">\n                            <input type=\"text\" class=\"form-control\" v-model=\"postData.action_url\" _v-34db6d5b=\"\">\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div v-show=\"!ajaxing\" class=\"modal-footer\" _v-34db6d5b=\"\">\n                <button v-if=\"view.action!='create'\" @click=\"deletePage()\" class=\"btn btn-danger btn--inverse pull-left\" _v-34db6d5b=\"\">刪除</button>\n                <button class=\"btn btn-primary pull-right\" @click.prevent=\"submit\" _v-34db6d5b=\"\">儲存</button>\n            </div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["@media (min-width: 992px) {\n  /* line 3, stdin */\n  .modal-lg[_v-34db6d5b] {\n    width: 1200px; } }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-34db6d5b", module.exports)
  } else {
    hotAPI.update("_v-34db6d5b", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1042:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    data: function data() {
        return {
            jquery: $,
            ajaxing: false,
            modal: {
                title: ''
            },
            view: {
                list: []
            },
            postData: {
                active: 1,
                speed: 2000
            }
        };
    },
    mounted: function mounted() {
        this.getList();
    },

    methods: {
        getList: function getList() {
            var _this = this;

            this.ajaxing = true;
            this.$http.get('/adminapi/carousel/list').then(function (response) {
                _this.view.list = response.body.items;
                _this.view.active = response.body.settings.active;
                _this.view.speed = response.body.settings.speed;
                _this.ajaxing = false;
            }).catch(function (response) {
                _this.ajaxing = false;
                $17.swal({
                    title: '取得資料失敗',
                    type: 'error',
                    showCancelButton: false
                });
            });
        },
        updateSetting: function updateSetting() {
            var _this2 = this;

            this.ajaxing = true;
            this.$http.post('/adminapi/carousel/update-setting', this.postData).then(function (response) {
                _this2.ajaxing = false;
            }).catch(function (response) {
                _this2.ajaxing = false;
                $17.swal({
                    title: '更新狀態失敗',
                    type: 'error',
                    showCancelButton: false
                });
            });
        },

        showModal: function showModal(item, action) {
            this.$refs.carouselModal.onCall(item.id, action);
            this.modal.title = action === 'update' ? '編輯頁面' : '新增頁面';
            $('#carousel-modal').modal('show');
        },
        refresh: function refresh() {
            this.ajaxing = true;
            this.getList();
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-49c1fb88=\"\">\n    <cms-tab tab=\"carousels\" _v-49c1fb88=\"\"></cms-tab>\n    <div class=\"m-top-20\" _v-49c1fb88=\"\">\n        <h2 class=\"m-bottom-20\" _v-49c1fb88=\"\"></h2>\n        <div class=\"form-horizontal\" _v-49c1fb88=\"\">\n            <div class=\"form-group\" _v-49c1fb88=\"\">\n                <label class=\"col-sm-2 control-label p-t-0\" _v-49c1fb88=\"\">啟用</label>\n                <div class=\"col-sm-10 m-bottom-20\" _v-49c1fb88=\"\">\n                    <input type=\"checkbox\" class=\"form-control\" :true-value=\"1\" :false-value=\"0\" v-model=\"postData.active\" _v-49c1fb88=\"\">\n                </div>\n            </div>\n            <div class=\"form-group\" _v-49c1fb88=\"\">\n                <label class=\"col-sm-2 control-label p-t-0\" _v-49c1fb88=\"\">速度(ms)</label>\n                <div class=\"col-sm-10 m-bottom-20\" _v-49c1fb88=\"\">\n                    <input type=\"number\" class=\"form-control\" :min=\"2000\" :max=\"12000\" v-model=\"postData.speed\" _v-49c1fb88=\"\">\n                </div>\n            </div>\n\n             <button type=\"button\" class=\"btn btn-primary m-bottom-20\" @click=\"updateSetting\" _v-49c1fb88=\"\">\n               異動狀態\n            </button>\n        </div>\n        <v-spinner :ajaxing=\"ajaxing\" _v-49c1fb88=\"\"></v-spinner>\n        <div v-show=\"!ajaxing\" _v-49c1fb88=\"\">\n            <button type=\"button\" class=\"btn btn-success m-bottom-20\" @click=\"showModal({id:0,name:''}, 'create')\" _v-49c1fb88=\"\">\n                <i class=\"fa fa-plus\" _v-49c1fb88=\"\"></i> 新增Banner\n            </button>\n            <div class=\"table-responsive\" v-if=\"this.view.list.length>0\" _v-49c1fb88=\"\">\n                <table class=\"table\" _v-49c1fb88=\"\">\n                    <thead _v-49c1fb88=\"\">\n                    <tr _v-49c1fb88=\"\">\n                        <th class=\"col-xs-4\" _v-49c1fb88=\"\">識別名稱</th>\n                        <th class=\"col-xs-2\" _v-49c1fb88=\"\">是否啟用</th>\n                        <th class=\"col-xs-2\" _v-49c1fb88=\"\">啟用時間</th>\n                        <th class=\"col-xs-2\" _v-49c1fb88=\"\">結束時間</th>\n                        <th class=\"col-xs-2\" _v-49c1fb88=\"\"></th>\n                    </tr>\n                    </thead>\n                    <tbody _v-49c1fb88=\"\">\n                    <tr v-for=\"carousel in view.list\" _v-49c1fb88=\"\">\n                        <td _v-49c1fb88=\"\">{{carousel.name}}</td>\n                        <td _v-49c1fb88=\"\">{{(carousel.active)?'啟用':'停用'}}</td>\n                        <td _v-49c1fb88=\"\">{{carousel.active_time}}</td>\n                        <td _v-49c1fb88=\"\">{{carousel.inactive_time}}</td>\n                        <td class=\"text-center\" _v-49c1fb88=\"\">\n                            <button class=\"btn btn-primary\" @click=\"showModal({id:carousel.id,name:carousel.name}, 'update')\" _v-49c1fb88=\"\">編輯</button>\n                        </td>\n                    </tr>\n                    </tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n\n     <cms-carousel-modal @refresh=\"refresh\" ref=\"carouselModal\" :title=\"modal.title\" _v-49c1fb88=\"\">\n    </cms-carousel-modal>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-49c1fb88", module.exports)
  } else {
    hotAPI.update("_v-49c1fb88", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],1043:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            jquery: $,
            ajaxing: false,
            sectionType: 0,
            view: {
                list: [],
                pages: []
            }
        };
    },
    mounted: function mounted() {
        this.getList();
    },

    methods: {
        getList: function getList() {
            var _this = this;

            this.ajaxing = true;
            this.$http.get('/adminapi/cms/footer-items/' + this.sectionType).then(function (response) {
                _this.view.list = response.body.footerItems;
                _this.view.pages = response.body.pages;
                _this.ajaxing = false;
            }).catch(function (response) {
                _this.ajaxing = false;
                $17.swal({
                    title: '取得資料失敗',
                    type: 'error',
                    showCancelButton: false
                });
            });
        },

        save: function save() {
            var vm = this;
            $17.swal({
                title: '確定儲存全部？',
                type: 'warning'
            }, function () {
                vm.$http.post('/adminapi/cms/footer-items/' + this.sectionType, (0, _stringify2.default)(vm.view.list)).then(function (response) {
                    $17.swal({
                        title: '儲存成功',
                        type: 'success',
                        showCancelButton: false
                    });
                }).catch(function (response) {
                    $17.swal({
                        title: '儲存失敗',
                        text: response.data.errorMessage,
                        type: 'error',
                        showCancelButton: false
                    });
                });
            });
        },
        append: function append() {
            this.view.list.push({
                id: 0,
                cms_page_id: 0,
                type: 0,
                section_type: this.sectionType,
                is_hidden: 0,
                link_name: '',
                link: '',
                target: '_self',
                sort: 0
            });
        },
        deleteItem: function deleteItem(id) {
            var vm = this;
            $17.swal({
                title: '確定刪除？',
                type: 'warning'
            }, function () {
                vm.ajaxing = true;
                vm.$http.delete('/adminapi/cms/link-item/' + id).then(function (response) {
                    vm.ajaxing = false;
                    vm.getList();
                    $17.swal({
                        title: '刪除成功',
                        type: 'success',
                        showCancelButton: false
                    });
                }).catch(function (response) {
                    vm.ajaxing = false;
                    $17.swal({
                        title: '刪除失敗',
                        type: 'error',
                        showCancelButton: false
                    });
                });
            });
        },
        deleteAppend: function deleteAppend(index) {
            this.view.list.splice(index, 1);
        },
        refresh: function refresh() {
            this.ajaxing = true;
            this.getList();
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-f0d72f14=\"\">\n    <cms-tab tab=\"footer-items\" _v-f0d72f14=\"\"></cms-tab>\n    <div class=\"m-top-20\" _v-f0d72f14=\"\">\n        <h2 class=\"m-bottom-20\" _v-f0d72f14=\"\">頁尾設置</h2>\n        <select v-model=\"sectionType\" @change=\"getList()\" class=\"form-control m-top-20 m-bottom-20\" style=\"width:200px\" _v-f0d72f14=\"\">\n            <option value=\"0\" _v-f0d72f14=\"\">經營者</option>\n            <option value=\"2\" _v-f0d72f14=\"\">消費者</option>\n        </select>\n        <v-spinner :ajaxing=\"ajaxing\" _v-f0d72f14=\"\"></v-spinner>\n        <div v-show=\"!ajaxing\" _v-f0d72f14=\"\">\n            <button type=\"button\" class=\"btn btn-success m-bottom-20\" @click=\"append()\" _v-f0d72f14=\"\">\n                <i class=\"fa fa-plus\" _v-f0d72f14=\"\"></i> 新增項目\n            </button>\n            <div class=\"table-responsive\" v-if=\"this.view.list.length>0\" _v-f0d72f14=\"\">\n                <table class=\"table\" _v-f0d72f14=\"\">\n                    <thead _v-f0d72f14=\"\">\n                    <tr _v-f0d72f14=\"\">\n                        <th class=\"col-xs-2\" _v-f0d72f14=\"\">類型</th>\n                        <th class=\"col-xs-2\" _v-f0d72f14=\"\">頁面名稱</th>\n                        <th class=\"col-xs-4\" _v-f0d72f14=\"\">連結</th>\n                        <th class=\"col-xs-1\" _v-f0d72f14=\"\">開新分頁</th>\n                        <th class=\"col-xs-1\" _v-f0d72f14=\"\">順序</th>\n                        <th class=\"col-xs-2\" _v-f0d72f14=\"\"></th>\n                    </tr>\n                    </thead>\n                    <tbody _v-f0d72f14=\"\">\n                    <tr v-for=\"(item,index) in view.list\" _v-f0d72f14=\"\">\n                        <td _v-f0d72f14=\"\">\n                            <select class=\"form-control\" v-model=\"view.list[index].type\" _v-f0d72f14=\"\">\n                                <option value=\"0\" :selected=\"item.type==0\" _v-f0d72f14=\"\">連結</option>\n                                <option value=\"1\" :selected=\"item.type==1\" _v-f0d72f14=\"\">頁面</option>\n                            </select>\n                        </td>\n                        <td _v-f0d72f14=\"\">\n                            <input type=\"text\" v-if=\"view.list[index].type==0\" v-model=\"view.list[index].link_name\" class=\"form-control\" _v-f0d72f14=\"\">\n                            <select class=\"form-control\" v-model=\"view.list[index].cms_page_id\" v-else=\"\" _v-f0d72f14=\"\">\n                                <option value=\"0\" _v-f0d72f14=\"\">請選擇</option>\n                                <option :value=\"pageId\" v-for=\"(page,pageId) in view.pages\" _v-f0d72f14=\"\">{{page}}</option>\n                            </select>\n                        </td>\n                        <td _v-f0d72f14=\"\">\n                            <input type=\"text\" placeholder=\"https://\" v-if=\"view.list[index].type==0\" v-model=\"view.list[index].link\" class=\"form-control\" _v-f0d72f14=\"\">\n                        </td>\n                        <td _v-f0d72f14=\"\">\n                            <label _v-f0d72f14=\"\">\n                                <input type=\"checkbox\" v-model=\"view.list[index].target\" true-value=\"_blank\" false-value=\"_self\" _v-f0d72f14=\"\"> 是\n                            </label>\n                        </td>\n                        <td _v-f0d72f14=\"\">\n                            <input type=\"text\" class=\"form-control\" v-model=\"view.list[index].sort\" _v-f0d72f14=\"\">\n                        </td>\n                        <td class=\"text-center\" _v-f0d72f14=\"\">\n                            <button v-if=\"item.id>0\" class=\"btn btn-danger\" @click=\"deleteItem(item.id)\" _v-f0d72f14=\"\">\n                                刪除\n                            </button>\n                            <button v-show=\"item.id==0\" class=\"btn btn-default\" @click=\"deleteAppend(index)\" v-else=\"\" _v-f0d72f14=\"\">\n                                刪除\n                            </button>\n                        </td>\n                    </tr>\n                    </tbody>\n                </table>\n            </div>\n            <div class=\"col-xs-12 text-center\" v-show=\"this.view.list.length>0\" _v-f0d72f14=\"\">\n                <button class=\"btn btn-primary\" @click=\"save()\" _v-f0d72f14=\"\">儲存全部</button>\n            </div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-f0d72f14", module.exports)
  } else {
    hotAPI.update("_v-f0d72f14", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/json/stringify":48,"vue":792,"vue-hot-reload-api":785}],1044:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    data: function data() {
        return {
            ajaxing: false,
            jquery: $,
            image: '',
            postData: {
                id: 1,
                ogImage: '',
                content: '',
                css: '',
                description: '',
                keywords: ''
            }
        };
    },
    mounted: function mounted() {
        this.getHomePage();
    },

    methods: {
        onChange: function onChange(event) {
            var vm = this;
            this.$nextTick(function () {
                $17.imageToString({
                    image: event.target.files[0],
                    width: 1200,
                    height: 630,
                    callback: function callback(imageString) {
                        vm.postData.ogImage = imageString;
                        vm.image = imageString;
                    }
                });
            });
        },
        getHomePage: function getHomePage() {
            var _this = this;

            this.ajaxing = true;
            this.$http.get('/adminapi/cms/home').then(function (response) {
                _this.ajaxing = false;
                var data = response.data;
                _this.postData.content = data.content;
                _this.postData.css = data.css;
                _this.postData.description = data.description;
                _this.postData.keywords = data.keywords;
                _this.image = data.og_image;
            }).catch(function (response) {
                _this.ajaxing = false;
                $17.swal({
                    title: '取得首頁資料失敗',
                    type: 'error',
                    showCancelButton: false
                });
            });
        },
        updateHomePage: function updateHomePage() {
            var _this2 = this;

            this.ajaxing = true;
            this.$http.put('/adminapi/cms/page', this.postData).then(function (response) {
                _this2.ajaxing = false;
                $17.swal({
                    title: '儲存成功',
                    type: 'success',
                    showCancelButton: false
                });
            }).catch(function (response) {
                _this2.ajaxing = false;
                $17.swal({
                    title: '儲存失敗',
                    type: 'error',
                    showCancelButton: false
                });
            });
        },
        preview: function preview() {
            this.$http.post('/adminapi/cms/page/preview/0', this.postData).then(function (response) {
                var w = window.open('about:blank', '_blank');
                w.document.open();
                w.document.write(response.data.preview);
                w.document.close();
            }).catch(function (response) {
                $17.swal({
                    title: '預覽失敗',
                    text: '請允許開啟彈跳視窗',
                    type: 'error',
                    showCancelButton: false
                });
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-3ff9fa7a=\"\">\n    <cms-tab tab=\"home\" _v-3ff9fa7a=\"\"></cms-tab>\n    <v-spinner :ajaxing=\"ajaxing\" _v-3ff9fa7a=\"\"></v-spinner>\n    <div class=\"col-xs-12 m-bottom-50\" v-show=\"!ajaxing\" _v-3ff9fa7a=\"\">\n        <div class=\"form-horizontal\" _v-3ff9fa7a=\"\">\n            <div class=\"form-group\" _v-3ff9fa7a=\"\">\n                <label class=\"col-sm-2 control-label p-t-0\" _v-3ff9fa7a=\"\">網址</label>\n                <div class=\"col-sm-10 m-bottom-20\" _v-3ff9fa7a=\"\">\n                    https://17fit.com/business\n                    <button class=\"btn btn-primary btn-sm\" @click=\"preview\" _v-3ff9fa7a=\"\"><i class=\"fa fa-search\" _v-3ff9fa7a=\"\"></i> 預覽</button>\n                </div>\n            </div>\n            <div class=\"form-group\" _v-3ff9fa7a=\"\">\n                <label class=\"col-sm-2 control-label p-t-0\" _v-3ff9fa7a=\"\">自訂縮圖</label>\n                <div class=\"col-sm-10 m-bottom-20\" _v-3ff9fa7a=\"\">\n                    <input type=\"file\" class=\"upload\" @change=\"onChange\" accept=\"image/jpeg,image/png,image/jpg\" _v-3ff9fa7a=\"\">\n                    <br _v-3ff9fa7a=\"\">\n                    <div class=\"row\" v-show=\"image!==''\" _v-3ff9fa7a=\"\">\n                        <img :src=\"image\" class=\"col-xs-12 col-sm-3\" _v-3ff9fa7a=\"\">\n                    </div>\n                </div>\n            </div>\n            <div class=\"form-group\" _v-3ff9fa7a=\"\">\n                <label class=\"col-sm-2 control-label p-t-0\" _v-3ff9fa7a=\"\">內容</label>\n                <div class=\"col-sm-10\" _v-3ff9fa7a=\"\">\n                    <textarea cols=\"30\" rows=\"10\" v-model=\"postData.content\" _v-3ff9fa7a=\"\"></textarea>\n                </div>\n            </div>\n            <div class=\"form-group\" _v-3ff9fa7a=\"\">\n                <label class=\"col-sm-2 control-label p-t-0\" _v-3ff9fa7a=\"\">CSS</label>\n                <div class=\"col-sm-10\" _v-3ff9fa7a=\"\">\n                    <textarea v-model=\"postData.css\" cols=\"30\" rows=\"10\" class=\"form-control\" _v-3ff9fa7a=\"\"></textarea>\n                </div>\n            </div>\n            <div class=\"form-group\" _v-3ff9fa7a=\"\">\n                <label class=\"col-sm-2 control-label p-t-0\" _v-3ff9fa7a=\"\">Description</label>\n                <div class=\"col-sm-10\" _v-3ff9fa7a=\"\">\n                    <textarea v-model=\"postData.description\" cols=\"30\" rows=\"5\" class=\"form-control\" _v-3ff9fa7a=\"\"></textarea>\n                </div>\n            </div>\n            <div class=\"form-group\" _v-3ff9fa7a=\"\">\n                <label class=\"col-sm-2 control-label p-t-0\" _v-3ff9fa7a=\"\">Keywords</label>\n                <div class=\"col-sm-10\" _v-3ff9fa7a=\"\">\n                    <textarea v-model=\"postData.keywords\" cols=\"30\" rows=\"2\" class=\"form-control\" _v-3ff9fa7a=\"\"></textarea>\n                </div>\n            </div>\n        </div>\n        <div class=\"text-center\" _v-3ff9fa7a=\"\">\n            <button class=\"btn btn-primary\" @click.prevent=\"updateHomePage()\" _v-3ff9fa7a=\"\">儲存</button>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-3ff9fa7a", module.exports)
  } else {
    hotAPI.update("_v-3ff9fa7a", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],1045:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _home = require('./home.vue');

var _home2 = _interopRequireDefault(_home);

var _nav = require('./nav.vue');

var _nav2 = _interopRequireDefault(_nav);

var _navModal = require('./nav-modal.vue');

var _navModal2 = _interopRequireDefault(_navModal);

var _footer = require('./footer.vue');

var _footer2 = _interopRequireDefault(_footer);

var _pages = require('./pages.vue');

var _pages2 = _interopRequireDefault(_pages);

var _pageModal = require('./page-modal.vue');

var _pageModal2 = _interopRequireDefault(_pageModal);

var _tab = require('./tab.vue');

var _tab2 = _interopRequireDefault(_tab);

var _carousels = require('./carousels.vue');

var _carousels2 = _interopRequireDefault(_carousels);

var _carouselModal = require('./carousel-modal.vue');

var _carouselModal2 = _interopRequireDefault(_carouselModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('cms-home', _home2.default);
_vue2.default.component('cms-nav-items', _nav2.default);
_vue2.default.component('cms-nav-modal', _navModal2.default);
_vue2.default.component('cms-footer-items', _footer2.default);
_vue2.default.component('cms-pages', _pages2.default);
_vue2.default.component('cms-page-modal', _pageModal2.default);
_vue2.default.component('cms-tab', _tab2.default);
_vue2.default.component('cms-carousels', _carousels2.default);
_vue2.default.component('cms-carousel-modal', _carouselModal2.default);

},{"./carousel-modal.vue":1041,"./carousels.vue":1042,"./footer.vue":1043,"./home.vue":1044,"./nav-modal.vue":1046,"./nav.vue":1047,"./page-modal.vue":1048,"./pages.vue":1049,"./tab.vue":1050,"vue":792}],1046:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vuex = require('vuex');

exports.default = {
    props: {
        title: {
            type: String,
            default: ''
        }
    },
    data: function data() {
        return {
            ajaxing: false,
            view: {
                action: 'create',
                pages: {}
            },
            currentId: 0,
            postData: {
                id: 0,
                is_hidden: 1,
                link: '',
                type: 0,
                sort: 0,
                name: '',
                target: '',
                linkItems: []
            }
        };
    },

    methods: {
        changeLinkItemType: function changeLinkItemType(index, value) {
            var _this = this;

            this.$nextTick(function () {
                if (value == 0) {
                    _this.postData.linkItems[index].cms_page_id = 0;
                } else {
                    _this.postData.linkItems[index].link_name = '';
                    _this.postData.linkItems[index].link = '';
                }
            });
        },
        submit: function submit() {
            if (this.view.action === 'update') {
                this.update();
            } else if (this.view.action === 'create') {
                this.create();
            }
        },
        onCall: function onCall(id, action, pages) {
            this.resetForm();
            this.view.action = action;
            this.view.pages = pages;
            if (action === 'update') {
                this.currentId = id;
                this.show();
            }
        },
        show: function show() {
            var _this2 = this;

            this.ajaxing = true;
            this.$http.get('/adminapi/cms/nav-bar-items/show/' + this.currentId).then(function (response) {
                var data = response.body;
                _this2.postData = {
                    id: data.id,
                    is_hidden: data.is_hidden,
                    link: data.link,
                    type: data.type,
                    sort: data.sort,
                    name: data.name,
                    target: data.target,
                    linkItems: data.linkItems
                };
                _this2.ajaxing = false;
            }).catch(function (response) {
                _this2.ajaxing = false;
                $17.swal({
                    title: '取得資料失敗',
                    type: 'error',
                    showCancelButton: false
                });
            });
        },
        create: function create() {
            var _this3 = this;

            this.ajaxing = true;
            this.$http.post('/adminapi/cms/nav-bar-items', this.postData).then(function (response) {
                _this3.ajaxing = false;
                _this3.finishModal();
                $17.swal({
                    title: '新增成功',
                    type: 'success',
                    showCancelButton: false
                });
            }).catch(function (response) {
                _this3.ajaxing = false;
                $17.swal({
                    title: '新增失敗',
                    text: response.data.message,
                    type: 'error',
                    showCancelButton: false
                });
            });
        },

        deleteItem: function deleteItem(id, index) {
            var vm = this;
            $17.swal({
                title: '確定刪除？',
                type: 'warning'
            }, function () {
                vm.$http.delete('/adminapi/cms/link-item/' + id).then(function (response) {
                    $17.swal({
                        title: '刪除成功',
                        type: 'success',
                        showCancelButton: false
                    });
                    vm.postData.linkItems.splice(index, 1);
                }).catch(function (response) {
                    $17.swal({
                        title: '刪除失敗',
                        type: 'error',
                        showCancelButton: false
                    });
                });
            });
        },
        deleteNav: function deleteNav() {
            var vm = this;
            $17.swal({
                title: '確定刪除？',
                type: 'warning'
            }, function () {
                vm.ajaxing = true;
                vm.$http.delete('/adminapi/cms/nav-bar-items/' + vm.currentId).then(function (response) {
                    vm.ajaxing = false;
                    vm.finishModal();
                    $17.swal({
                        title: '刪除成功',
                        type: 'success',
                        showCancelButton: false
                    });
                }).catch(function (response) {
                    vm.ajaxing = false;
                    $17.swal({
                        title: '刪除失敗',
                        type: 'error',
                        showCancelButton: false
                    });
                });
            });
        },

        deleteAppend: function deleteAppend(index) {
            this.postData.linkItems.splice(index, 1);
        },
        update: function update() {
            var _this4 = this;

            this.ajaxing = true;
            this.$http.put('/adminapi/cms/nav-bar-items', this.postData).then(function (response) {
                _this4.ajaxing = false;
                _this4.finishModal();
                $17.swal({
                    title: '更新成功',
                    type: 'success',
                    showCancelButton: false
                });
            }).catch(function (response) {
                _this4.ajaxing = false;
                $17.swal({
                    title: '更新失敗',
                    type: 'error',
                    showCancelButton: false
                });
            });
        },
        finishModal: function finishModal() {
            this.$emit('refresh');
            $('#nav-modal').modal('hide');
        },

        append: function append() {
            this.postData.linkItems.push({
                id: 0,
                cms_page_id: 0,
                type: 0,
                is_hidden: 0,
                link_name: '',
                link: '',
                target: '_self',
                sort: 0
            });
        },
        resetForm: function resetForm() {
            this.currentId = 0;
            this.postData = {
                id: 0,
                is_hidden: 0,
                link: '',
                type: 0,
                sort: 0,
                name: '',
                target: '',
                linkItems: []
            };
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div id=\"nav-modal\" class=\"modal fade\" role=\"dialog\" data-keyboard=\"false\" data-backdrop=\"static\" _v-585089f8=\"\">\n    <div class=\"modal-dialog modal-lg\" _v-585089f8=\"\">\n        <div class=\"modal-content\" _v-585089f8=\"\">\n            <div class=\"modal-header\" _v-585089f8=\"\">\n                <button type=\"button\" v-show=\"!ajaxing\" class=\"close\" data-dismiss=\"modal\" _v-585089f8=\"\">×</button>\n                <h4 class=\"modal-title\" _v-585089f8=\"\">{{ title }}</h4>\n            </div>\n            <v-spinner :ajaxing=\"ajaxing\" _v-585089f8=\"\"></v-spinner>\n            <div v-show=\"!ajaxing\" class=\"modal-body\" _v-585089f8=\"\">\n                <div class=\"form-horizontal\" _v-585089f8=\"\">\n                    <div class=\"form-group\" _v-585089f8=\"\">\n                        <label class=\"col-sm-2 control-label p-t-0\" _v-585089f8=\"\">選單標題</label>\n                        <div class=\"col-sm-10 m-bottom-20\" _v-585089f8=\"\">\n                            <input type=\"text\" class=\"form-control\" v-model=\"postData.name\" _v-585089f8=\"\">\n                        </div>\n                    </div>\n                    <div class=\"form-group\" _v-585089f8=\"\">\n                        <label class=\"col-sm-2 control-label p-t-0\" _v-585089f8=\"\">排序</label>\n                        <div class=\"col-sm-10 m-bottom-20\" _v-585089f8=\"\">\n                            <input type=\"number\" class=\"form-control\" v-model=\"postData.sort\" _v-585089f8=\"\">\n                        </div>\n                    </div>\n                    <div class=\"form-group\" _v-585089f8=\"\">\n                        <label class=\"col-sm-2 control-label p-t-0\" _v-585089f8=\"\">類型</label>\n                        <div class=\"col-sm-10 m-bottom-20\" _v-585089f8=\"\">\n                            <select class=\"form-control\" v-model=\"postData.type\" _v-585089f8=\"\">\n                                <option value=\"0\" :selected=\"postData.type==0\" _v-585089f8=\"\">連結</option>\n                                <option value=\"1\" :selected=\"postData.type==1\" _v-585089f8=\"\">選單</option>\n                            </select>\n                        </div>\n                    </div>\n                    <div class=\"form-group\" v-if=\"postData.type==0\" _v-585089f8=\"\">\n                        <label class=\"col-sm-2 control-label p-t-0\" _v-585089f8=\"\">網址</label>\n                        <div class=\"col-sm-10 m-bottom-20\" _v-585089f8=\"\">\n                            <input type=\"text\" class=\"form-control\" v-model=\"postData.link\" _v-585089f8=\"\">\n                        </div>\n                    </div>\n                    <div class=\"form-group\" v-if=\"postData.type==0\" _v-585089f8=\"\">\n                        <label class=\"col-sm-2 control-label p-t-0\" _v-585089f8=\"\">開新分頁</label>\n                        <div class=\"col-sm-10 m-bottom-20\" _v-585089f8=\"\">\n                            <label _v-585089f8=\"\">\n                                <input type=\"checkbox\" v-model=\"postData.target\" true-value=\"_blank\" false-value=\"_self\" _v-585089f8=\"\"> 是\n                            </label>\n                        </div>\n                    </div>\n                    <div v-if=\"postData.type==1\" _v-585089f8=\"\">\n                        <button type=\"button\" class=\"btn btn-success m-bottom-20\" @click=\"append()\" _v-585089f8=\"\">\n                            <i class=\"fa fa-plus\" _v-585089f8=\"\"></i> 新增項目\n                        </button>\n                        <div class=\"table-responsive\" _v-585089f8=\"\">\n                            <table class=\"table m-bottom-50\" _v-585089f8=\"\">\n                                <thead _v-585089f8=\"\">\n                                <tr _v-585089f8=\"\">\n                                    <th class=\"col-xs-2\" _v-585089f8=\"\">類型</th>\n                                    <th class=\"col-xs-2\" _v-585089f8=\"\">頁面名稱</th>\n                                    <th class=\"col-xs-4\" _v-585089f8=\"\">連結</th>\n                                    <th class=\"col-xs-1\" _v-585089f8=\"\">開新分頁</th>\n                                    <th class=\"col-xs-1\" _v-585089f8=\"\">順序</th>\n                                    <th class=\"col-xs-2\" _v-585089f8=\"\"></th>\n                                </tr>\n                                </thead>\n                                <tbody _v-585089f8=\"\">\n                                <tr v-for=\"(item,index) in postData.linkItems\" v-show=\"postData.linkItems.length>0\" _v-585089f8=\"\">\n                                    <td _v-585089f8=\"\">\n                                        <select class=\"form-control\" v-model=\"postData.linkItems[index].type\" @change=\"changeLinkItemType(index,$event.target.value)\" _v-585089f8=\"\">\n                                            <option value=\"0\" :selected=\"item.type==0\" _v-585089f8=\"\">連結</option>\n                                            <option value=\"1\" :selected=\"item.type==1\" _v-585089f8=\"\">頁面</option>\n                                        </select>\n                                    </td>\n                                    <td _v-585089f8=\"\">\n                                        <input type=\"text\" v-if=\"postData.linkItems[index].type==0\" v-model=\"postData.linkItems[index].link_name\" class=\"form-control\" _v-585089f8=\"\">\n                                        <select class=\"form-control\" v-model=\"postData.linkItems[index].cms_page_id\" v-else=\"\" _v-585089f8=\"\">\n                                            <option value=\"0\" _v-585089f8=\"\">請選擇</option>\n                                            <option :value=\"pageId\" v-for=\"(page,pageId) in view.pages\" _v-585089f8=\"\">{{page}}</option>\n                                        </select>\n                                    </td>\n                                    <td _v-585089f8=\"\">\n                                        <input type=\"text\" v-if=\"postData.linkItems[index].type==0\" v-model=\"postData.linkItems[index].link\" class=\"form-control\" placeholder=\"https://\" _v-585089f8=\"\">\n                                    </td>\n                                    <td _v-585089f8=\"\">\n                                        <label _v-585089f8=\"\">\n                                            <input type=\"checkbox\" v-model=\"postData.linkItems[index].target\" true-value=\"_blank\" false-value=\"_self\" _v-585089f8=\"\"> 是\n                                        </label>\n                                    </td>\n                                    <td _v-585089f8=\"\">\n                                        <input type=\"text\" class=\"form-control\" v-model=\"postData.linkItems[index].sort\" _v-585089f8=\"\">\n                                    </td>\n                                    <td class=\"text-center\" _v-585089f8=\"\">\n                                        <button v-if=\"item.id>0\" class=\"btn btn-danger\" @click=\"deleteItem(item.id,index)\" _v-585089f8=\"\">\n                                            刪除\n                                        </button>\n                                        <button v-show=\"item.id==0\" class=\"btn btn-default\" @click=\"deleteAppend(index)\" v-else=\"\" _v-585089f8=\"\">\n                                            刪除\n                                        </button>\n                                    </td>\n                                </tr>\n                                </tbody>\n                            </table>\n                        </div>\n                    </div>\n                    <div class=\"form-group\" _v-585089f8=\"\">\n                        <label class=\"col-sm-2 control-label p-t-0\" _v-585089f8=\"\">顯示</label>\n                        <div class=\"col-sm-10\" _v-585089f8=\"\">\n                            <label class=\"m-right-10\" _v-585089f8=\"\">\n                                <input v-model=\"postData.is_hidden\" :checked=\"postData.is_hidden==0\" value=\"0\" type=\"radio\" _v-585089f8=\"\"> 顯示\n                            </label>\n                            <label _v-585089f8=\"\">\n                                <input v-model=\"postData.is_hidden\" :checked=\"postData.is_hidden==1\" value=\"1\" type=\"radio\" _v-585089f8=\"\"> 不顯示\n                            </label>\n                        </div>\n                    </div>\n                </div>\n\n            </div>\n            <div v-show=\"!ajaxing\" class=\"modal-footer\" _v-585089f8=\"\">\n                <button v-if=\"view.action!='create'\" @click=\"deleteNav()\" class=\"btn btn-danger btn--inverse pull-left\" _v-585089f8=\"\">刪除</button>\n                <button class=\"btn btn-primary pull-right\" @click.prevent=\"submit\" _v-585089f8=\"\">儲存</button>\n            </div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-585089f8", module.exports)
  } else {
    hotAPI.update("_v-585089f8", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vuex":803}],1047:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    data: function data() {
        return {
            jquery: $,
            ajaxing: false,
            modal: {
                title: ''
            },
            view: {
                list: [],
                pages: []
            }
        };
    },
    mounted: function mounted() {
        this.getList();
    },

    methods: {
        getList: function getList() {
            var _this = this;

            this.ajaxing = true;
            this.$http.get('/adminapi/cms/nav-bar-items').then(function (response) {
                _this.view.list = response.body.navItems;
                _this.view.pages = response.body.pages;
                _this.ajaxing = false;
            }).catch(function (response) {
                _this.ajaxing = false;
                $17.swal({
                    title: '取得資料失敗',
                    type: 'error',
                    showCancelButton: false
                });
            });
        },

        showModal: function showModal(item, action) {
            this.$refs.navModal.onCall(item.id, action, this.view.pages);
            this.modal.title = action === 'update' ? '編輯導覽列項目' : '新增導覽列項目';
            $('#nav-modal').modal('show');
        },
        refresh: function refresh() {
            this.ajaxing = true;
            this.getList();
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-13274950=\"\">\n    <cms-tab tab=\"nav-bar-items\" _v-13274950=\"\"></cms-tab>\n    <div class=\"m-top-20\" _v-13274950=\"\">\n        <h2 class=\"m-bottom-20\" _v-13274950=\"\">導覽列設置</h2>\n        <v-spinner :ajaxing=\"ajaxing\" _v-13274950=\"\"></v-spinner>\n        <div v-show=\"!ajaxing\" _v-13274950=\"\">\n            <button type=\"button\" class=\"btn btn-success m-bottom-20\" @click=\"showModal({id:0,name:''}, 'create')\" _v-13274950=\"\">\n                <i class=\"fa fa-plus\" _v-13274950=\"\"></i> 新增項目\n            </button>\n            <div class=\"table-responsive\" v-if=\"this.view.list.length>0\" _v-13274950=\"\">\n                <table class=\"table\" _v-13274950=\"\">\n                    <thead _v-13274950=\"\">\n                    <tr _v-13274950=\"\">\n                        <th class=\"col-xs-4\" _v-13274950=\"\">標題</th>\n                        <th class=\"col-xs-3\" _v-13274950=\"\">連結</th>\n                        <th class=\"col-xs-1\" _v-13274950=\"\">排序</th>\n                        <th class=\"col-xs-1\" _v-13274950=\"\">顯示</th>\n                        <th class=\"col-xs-3\" _v-13274950=\"\"></th>\n                    </tr>\n                    </thead>\n                    <tbody _v-13274950=\"\">\n                    <tr v-for=\"item in view.list\" _v-13274950=\"\">\n                        <td _v-13274950=\"\">{{item.name}}</td>\n                        <td _v-13274950=\"\">{{item.link}}</td>\n                        <td _v-13274950=\"\">{{item.sort}}</td>\n                        <td _v-13274950=\"\">{{item.is_hidden==1?'否':'是'}}</td>\n                        <td class=\"text-center\" _v-13274950=\"\">\n                            <button class=\"btn btn-primary\" @click=\"showModal({id:item.id,name:item.title}, 'update')\" _v-13274950=\"\">編輯</button>\n                        </td>\n                    </tr>\n                    </tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n    <cms-nav-modal @refresh=\"refresh\" ref=\"navModal\" :title=\"modal.title\" _v-13274950=\"\">\n    </cms-nav-modal>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-13274950", module.exports)
  } else {
    hotAPI.update("_v-13274950", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],1048:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("@media (min-width: 992px) {\n  /* line 3, stdin */\n  .modal-lg[_v-5f18d94a] {\n    width: 1200px; } }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        title: {
            type: String,
            default: ''
        }
    },
    data: function data() {
        return {
            ajaxing: false,
            image: '',
            view: {
                action: 'create'
            },
            currentId: 0,
            postData: {
                id: 0,
                is_home_page: 0,
                is_hidden: 1,
                url: '',
                title: '',
                ogImage: '',
                content: '',
                css: '',
                description: '',
                keywords: ''
            }
        };
    },

    methods: {
        preview: function preview() {
            this.$http.post('/adminapi/cms/page/preview/' + this.postData.web_type, this.postData).then(function (response) {
                var w = window.open('about:blank', '_blank');
                w.document.open();
                w.document.write(response.data.preview);
                w.document.close();
            }).catch(function (response) {
                $17.swal({
                    title: '預覽失敗',
                    text: '請允許開啟彈跳視窗',
                    type: 'error',
                    showCancelButton: false
                });
            });
        },
        onChange: function onChange(event) {
            var vm = this;
            this.$nextTick(function () {
                $17.imageToString({
                    image: event.target.files[0],
                    width: 1200,
                    height: 630,
                    callback: function callback(imageString) {
                        vm.postData.ogImage = imageString;
                        vm.image = imageString;
                    }
                });
            });
        },
        submit: function submit() {
            if (this.view.action === 'update') {
                this.update();
            } else if (this.view.action === 'create') {
                this.create();
            }
        },
        onCall: function onCall(id, action, webType) {
            this.resetForm();
            this.postData.web_type = webType;
            this.view.action = action;
            if (action === 'update') {
                this.currentId = id;
                this.show();
            }
        },
        show: function show() {
            var _this = this;

            this.ajaxing = true;
            this.$http.get('/adminapi/cms/page/show/' + this.currentId).then(function (response) {
                var data = response.body;
                _this.image = data.og_image;
                _this.postData = {
                    id: data.id,
                    web_type: data.web_type,
                    is_hidden: data.is_hidden,
                    url: data.url,
                    title: data.title,
                    ogImage: '',
                    content: data.content,
                    css: data.css,
                    description: data.description,
                    keywords: data.keywords
                };
                _this.ajaxing = false;
            }).catch(function (response) {
                _this.ajaxing = false;
                $17.swal({
                    title: '取得資料失敗',
                    type: 'error',
                    showCancelButton: false
                });
            });
        },
        create: function create() {
            var _this2 = this;

            this.ajaxing = true;
            this.$http.post('/adminapi/cms/page', this.postData).then(function (response) {
                _this2.ajaxing = false;
                _this2.finishModal();
                $17.swal({
                    title: '新增成功',
                    type: 'success',
                    showCancelButton: false
                });
            }).catch(function (response) {
                _this2.ajaxing = false;
                $17.swal({
                    title: '新增失敗',
                    text: response.data.message,
                    type: 'error',
                    showCancelButton: false
                });
            });
        },
        deletePage: function deletePage() {
            var vm = this;
            $17.swal({
                title: '確定刪除？',
                type: 'warning'
            }, function () {
                vm.ajaxing = true;
                vm.$http.delete('/adminapi/cms/page/' + vm.currentId).then(function (response) {
                    vm.ajaxing = false;
                    vm.finishModal();
                    $17.swal({
                        title: '刪除成功',
                        type: 'success',
                        showCancelButton: false
                    });
                }).catch(function (response) {
                    vm.ajaxing = false;
                    $17.swal({
                        title: '刪除失敗',
                        text: response.data.errorMessage,
                        type: 'error',
                        showCancelButton: false
                    });
                });
            });
        },
        update: function update() {
            var _this3 = this;

            this.ajaxing = true;
            this.$http.put('/adminapi/cms/page', this.postData).then(function (response) {
                _this3.ajaxing = false;
                _this3.finishModal();
                $17.swal({
                    title: '更新成功',
                    type: 'success',
                    showCancelButton: false
                });
            }).catch(function (response) {
                _this3.ajaxing = false;
                $17.swal({
                    title: '更新失敗',
                    text: response.data.message,
                    type: 'error',
                    showCancelButton: false
                });
            });
        },
        finishModal: function finishModal() {
            this.$emit('refresh');
            $('#page-modal').modal('hide');
        },
        resetForm: function resetForm() {
            this.image = '';
            this.currentId = 0;
            this.postData = {
                id: 0,
                web_type: 0,
                is_home_page: 0,
                is_hidden: 1,
                url: '',
                title: '',
                ogImage: '',
                content: '',
                css: '',
                description: '',
                keywords: ''
            };
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div id=\"page-modal\" class=\"modal fade\" role=\"dialog\" data-keyboard=\"false\" data-backdrop=\"static\" _v-5f18d94a=\"\">\n    <div class=\"modal-dialog modal-lg\" _v-5f18d94a=\"\">\n        <div class=\"modal-content\" _v-5f18d94a=\"\">\n            <div class=\"modal-header\" _v-5f18d94a=\"\">\n                <button type=\"button\" v-show=\"!ajaxing\" class=\"close\" data-dismiss=\"modal\" _v-5f18d94a=\"\">×</button>\n                <h4 class=\"modal-title\" _v-5f18d94a=\"\">{{ title }}</h4>\n            </div>\n            <v-spinner :ajaxing=\"ajaxing\" _v-5f18d94a=\"\"></v-spinner>\n            <div v-show=\"!ajaxing\" class=\"modal-body\" _v-5f18d94a=\"\">\n                <div class=\"form-horizontal\" _v-5f18d94a=\"\">\n                    <div class=\"form-group\" _v-5f18d94a=\"\">\n                        <label class=\"col-sm-2 control-label p-t-0\" _v-5f18d94a=\"\">網站標題</label>\n                        <div class=\"col-sm-10 m-bottom-20\" _v-5f18d94a=\"\">\n                            <input type=\"text\" class=\"form-control\" v-model=\"postData.title\" _v-5f18d94a=\"\">\n                        </div>\n                    </div>\n                    <div class=\"form-group\" _v-5f18d94a=\"\">\n                        <label class=\"col-sm-2 control-label p-t-0\" _v-5f18d94a=\"\">網址</label>\n                        <div class=\"col-sm-10 m-bottom-20\" _v-5f18d94a=\"\">\n                            <div class=\"input-group\" _v-5f18d94a=\"\">\n                                <span v-if=\"postData.web_type==0\" class=\"input-group-addon\" _v-5f18d94a=\"\">https://17fit.com/b/</span>\n                                <span class=\"input-group-addon\" v-else=\"\" _v-5f18d94a=\"\">https://17fit.com/c/</span>\n                                <input type=\"text\" style=\"width:200px\" class=\"form-control\" v-model=\"postData.url\" _v-5f18d94a=\"\">\n                            </div>\n                            <button class=\"btn btn-primary btn-sm\" @click=\"preview\" _v-5f18d94a=\"\"><i class=\"fa fa-search\" _v-5f18d94a=\"\"></i> 預覽</button>\n                        </div>\n                    </div>\n                    <div class=\"form-group\" _v-5f18d94a=\"\">\n                        <label class=\"col-sm-2 control-label p-t-0\" _v-5f18d94a=\"\">自訂縮圖</label>\n                        <div class=\"col-sm-10 m-bottom-20\" _v-5f18d94a=\"\">\n                            <input type=\"file\" class=\"upload\" @change=\"onChange\" accept=\"image/jpeg,image/png,image/jpg\" _v-5f18d94a=\"\">\n                            <div class=\"row m-top-5\" v-show=\"image!==''\" _v-5f18d94a=\"\">\n                                <img :src=\"image\" class=\"col-xs-12 col-sm-3\" _v-5f18d94a=\"\">\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"form-group\" _v-5f18d94a=\"\">\n                        <label class=\"col-sm-2 control-label p-t-0\" _v-5f18d94a=\"\">內容</label>\n                        <div class=\"col-sm-10\" _v-5f18d94a=\"\">\n                            <textarea cols=\"30\" rows=\"10\" v-model=\"postData.content\" _v-5f18d94a=\"\"></textarea>\n                        </div>\n                    </div>\n                    <div class=\"form-group\" _v-5f18d94a=\"\">\n                        <label class=\"col-sm-2 control-label p-t-0\" _v-5f18d94a=\"\">CSS</label>\n                        <div class=\"col-sm-10\" _v-5f18d94a=\"\">\n                            <textarea v-model=\"postData.css\" cols=\"30\" rows=\"10\" class=\"form-control\" _v-5f18d94a=\"\"></textarea>\n                        </div>\n                    </div>\n                    <div class=\"form-group\" _v-5f18d94a=\"\">\n                        <label class=\"col-sm-2 control-label p-t-0\" _v-5f18d94a=\"\">Description</label>\n                        <div class=\"col-sm-10\" _v-5f18d94a=\"\">\n                            <textarea v-model=\"postData.description\" cols=\"30\" rows=\"5\" class=\"form-control\" _v-5f18d94a=\"\"></textarea>\n                        </div>\n                    </div>\n                    <div class=\"form-group\" _v-5f18d94a=\"\">\n                        <label class=\"col-sm-2 control-label p-t-0\" _v-5f18d94a=\"\">Keywords</label>\n                        <div class=\"col-sm-10\" _v-5f18d94a=\"\">\n                            <textarea v-model=\"postData.keywords\" cols=\"30\" rows=\"2\" class=\"form-control\" _v-5f18d94a=\"\"></textarea>\n                        </div>\n                    </div>\n                    <div class=\"form-group\" _v-5f18d94a=\"\">\n                        <label class=\"col-sm-2 control-label p-t-0\" _v-5f18d94a=\"\">顯示</label>\n                        <div class=\"col-sm-10\" _v-5f18d94a=\"\">\n                            <label class=\"m-right-10\" _v-5f18d94a=\"\">\n                                <input v-model=\"postData.is_hidden\" :checked=\"postData.is_hidden==0\" value=\"0\" type=\"radio\" _v-5f18d94a=\"\"> 顯示\n                            </label>\n                            <label _v-5f18d94a=\"\">\n                                <input v-model=\"postData.is_hidden\" :checked=\"postData.is_hidden==1\" value=\"1\" type=\"radio\" _v-5f18d94a=\"\"> 不顯示\n                            </label>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div v-show=\"!ajaxing\" class=\"modal-footer\" _v-5f18d94a=\"\">\n                <button v-if=\"view.action!='create'\" @click=\"deletePage()\" class=\"btn btn-danger btn--inverse pull-left\" _v-5f18d94a=\"\">刪除</button>\n                <button class=\"btn btn-primary pull-right\" @click.prevent=\"submit\" _v-5f18d94a=\"\">儲存</button>\n            </div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["@media (min-width: 992px) {\n  /* line 3, stdin */\n  .modal-lg[_v-5f18d94a] {\n    width: 1200px; } }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-5f18d94a", module.exports)
  } else {
    hotAPI.update("_v-5f18d94a", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1049:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    data: function data() {
        return {
            jquery: $,
            ajaxing: false,
            webType: 0,
            modal: {
                title: ''
            },
            view: {
                list: []
            }
        };
    },
    mounted: function mounted() {
        this.getList();
    },

    methods: {
        getList: function getList() {
            var _this = this;

            this.ajaxing = true;
            this.$http.get('/adminapi/cms/pages/' + this.webType).then(function (response) {
                _this.view.list = response.body;
                _this.ajaxing = false;
            }).catch(function (response) {
                _this.ajaxing = false;
                $17.swal({
                    title: '取得資料失敗',
                    type: 'error',
                    showCancelButton: false
                });
            });
        },

        showModal: function showModal(item, action) {
            this.$refs.pageModal.onCall(item.id, action, this.webType);
            this.modal.title = action === 'update' ? '編輯頁面' : '新增頁面';
            $('#page-modal').modal('show');
        },
        refresh: function refresh() {
            this.ajaxing = true;
            this.getList();
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-795e9639=\"\">\n    <cms-tab tab=\"pages\" _v-795e9639=\"\"></cms-tab>\n    <div class=\"m-top-20\" _v-795e9639=\"\">\n        <h2 class=\"m-bottom-20\" _v-795e9639=\"\">頁面設置</h2>\n        <select v-model=\"webType\" @change=\"getList()\" class=\"form-control m-top-20 m-bottom-20\" style=\"width:200px\" _v-795e9639=\"\">\n            <option value=\"0\" _v-795e9639=\"\">經營者</option>\n            <option value=\"1\" _v-795e9639=\"\">消費者</option>\n        </select>\n        <v-spinner :ajaxing=\"ajaxing\" _v-795e9639=\"\"></v-spinner>\n        <div v-show=\"!ajaxing\" _v-795e9639=\"\">\n            <button type=\"button\" class=\"btn btn-success m-bottom-20\" @click=\"showModal({id:0,name:''}, 'create')\" _v-795e9639=\"\">\n                <i class=\"fa fa-plus\" _v-795e9639=\"\"></i> 新增頁面\n            </button>\n            <div class=\"table-responsive\" v-if=\"this.view.list.length>0\" _v-795e9639=\"\">\n                <table class=\"table\" _v-795e9639=\"\">\n                    <thead _v-795e9639=\"\">\n                    <tr _v-795e9639=\"\">\n                        <th class=\"col-xs-4\" _v-795e9639=\"\">標題</th>\n                        <th class=\"col-xs-4\" _v-795e9639=\"\">連結</th>\n                        <th class=\"col-xs-2\" _v-795e9639=\"\">顯示</th>\n                        <th class=\"col-xs-2\" _v-795e9639=\"\"></th>\n                    </tr>\n                    </thead>\n                    <tbody _v-795e9639=\"\">\n                    <tr v-for=\"page in view.list\" _v-795e9639=\"\">\n                        <td _v-795e9639=\"\">{{page.title}}</td>\n                        <td _v-795e9639=\"\">\n                            <a v-if=\"webType==0\" :href=\"'/b/'+page.url\" target=\"_blank\" _v-795e9639=\"\">https://17fit.com/b/{{page.url}}</a>\n                            <a v-else=\"\" :href=\"'/c/'+page.url\" target=\"_blank\" _v-795e9639=\"\">https://17fit.com/c/{{page.url}}</a>\n                        </td>\n                        <td _v-795e9639=\"\">{{page.is_hidden==1?'否':'是'}}</td>\n                        <td class=\"text-center\" _v-795e9639=\"\">\n                            <button class=\"btn btn-primary\" @click=\"showModal({id:page.id,name:page.title}, 'update')\" _v-795e9639=\"\">編輯</button>\n                        </td>\n                    </tr>\n                    </tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n    <cms-page-modal @refresh=\"refresh\" ref=\"pageModal\" :title=\"modal.title\" _v-795e9639=\"\">\n    </cms-page-modal>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-795e9639", module.exports)
  } else {
    hotAPI.update("_v-795e9639", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],1050:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['tab'],
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        canEditFooter: function canEditFooter(state) {
            return state.webadmin.configure.webFunctions.WebadminCmsFooter;
        },
        canEditHome: function canEditHome(state) {
            return state.webadmin.configure.webFunctions.WebadminCmsHome;
        },
        canEditNav: function canEditNav(state) {
            return state.webadmin.configure.webFunctions.WebadminCmsNav;
        },
        canEditPages: function canEditPages(state) {
            return state.webadmin.configure.webFunctions.WebadminCmsPages;
        },
        canEditCarousels: function canEditCarousels(state) {
            return state.webadmin.configure.webFunctions.WebadminCmsCarousels;
        }
    })),
    methods: {
        bindTabActive: function bindTabActive(t) {
            return this.tab === t ? { active: true } : {};
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"m-bottom-20\">\n    <ul class=\"nav nav-tabs\">\n        <li v-if=\"canEditHome\" role=\"presentation\" v-bind:class=\"bindTabActive('home')\"><a href=\"/webadmin/cms/home\">商家首頁</a></li>\n        <li v-if=\"canEditNav\" role=\"presentation\" v-bind:class=\"bindTabActive('nav-bar-items')\"><a href=\"/webadmin/cms/nav-bar-items\">導覽頁</a></li>\n        <li v-if=\"canEditFooter\" role=\"presentation\" v-bind:class=\"bindTabActive('footer-items')\"><a href=\"/webadmin/cms/footer-items\">頁尾選單</a></li>\n        <li v-if=\"canEditPages\" role=\"presentation\" v-bind:class=\"bindTabActive('pages')\"><a href=\"/webadmin/cms/pages\">頁面</a></li>\n        <li role=\"presentation\" v-bind:class=\"bindTabActive('carousels')\"><a href=\"/webadmin/cms/carousels\">Banner列表</a></li>\n    </ul>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-32b7e8ca", module.exports)
  } else {
    hotAPI.update("_v-32b7e8ca", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vuex":803}],1051:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.btn-success[_v-61ceab8b] {\n  margin-top: 10px;\n  margin-bottom: 15px;\n  margin-left: 15px; }\n\n/* line 8, stdin */\ntr.border_bottom td[_v-61ceab8b] {\n  border-bottom: 1pt solid #ddd; }\n\n/* line 12, stdin */\n.alert[_v-61ceab8b] {\n  display: none; }\n\n/* line 16, stdin */\nh6[_v-61ceab8b] {\n  color: #807a7a; }\n\n/* line 20, stdin */\ntable[_v-61ceab8b] {\n  width: 100%;\n  border-bottom: 10px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            items: [],
            resultOrder: [],
            startAjax: false,
            editAjax: false,
            postData: {
                name: '',
                type: 1,
                value: 0,
                reason: ''
            },
            modal: {
                action: 'create',
                title: '新增折扣項目',
                currentId: 0
            }
        };
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId', 'isBranch']), (0, _vuex.mapState)('filters', ['selected_studio_id', 'selected_branch_id'])),
    methods: {
        changeDiscountType: function changeDiscountType() {
            this.postData.value = 0;
        },
        openModal: function openModal(action, itemIndex) {
            this.modal.action = action;
            if (action == 'update' && typeof itemIndex != 'undefined') {
                var updateItem = this.items[itemIndex];
                this.modal.currentId = updateItem.id;
                this.modal.title = updateItem.name;
                this.postData = {
                    name: updateItem.name,
                    type: updateItem.type,
                    value: updateItem.value,
                    reason: updateItem.reason
                };
            } else {
                this.modal.title = '新增折扣項目';
                this.postData.branch_id = this.selected_branch_id;
            }
            $('#itemModal').modal('show');
        },
        getList: function getList() {
            var _this = this;

            this.startAjax = true;
            this.$http.get('/adminapi/commonly_used_discounts/branch/' + this.selected_branch_id).then(function (response) {
                _this.items = response.data.items;
                _this.startAjax = false;
            }).catch(function (response) {
                _this.alert('取得常用折扣項目失敗', '', 'error');
                _this.startAjax = false;
            });
        },

        submit: function submit() {
            if (!this.postData.value || this.postData.value < 0) {
                this.alert('請輸入數值 需大於0', '', 'warning');
                return false;
            }
            if (!this.postData.name) {
                this.alert('請輸入常用項目暱稱', '', 'warning');
                return false;
            }
            if (!this.postData.reason.trim()) {
                this.alert('請輸入折扣原因', '', 'warning');
                return false;
            }
            if (!this.postData.type) {
                this.alert('請選擇折扣類型', '', 'warning');
                return false;
            }
            if (this.modal.action == 'create') {
                this.create();
            } else {
                this.update();
            }
        },
        create: function create() {
            var _this2 = this;

            this.editAjax = true;
            this.$http.post('/adminapi/commonly_used_discounts/create', this.postData).then(function (response) {
                _this2.alert('儲存成功', '', 'success');
                _this2.getList();
                _this2.editAjax = false;
                $('#itemModal').modal('hide');
            }).catch(function (response) {
                _this2.alert('儲存失敗', '', 'error');
                _this2.editAjax = false;
            });
        },
        update: function update() {
            var _this3 = this;

            this.editAjax = true;
            this.$http.patch('/adminapi/commonly_used_discounts/update/' + this.modal.currentId, this.postData).then(function (response) {
                _this3.alert('儲存成功', '', 'success');
                _this3.getList();
                _this3.editAjax = false;
                $('#itemModal').modal('hide');
            }).catch(function (response) {
                _this3.alert('儲存失敗', '', 'error');
                _this3.editAjax = false;
            });
        },
        deleteItem: function deleteItem() {
            var vm = this;
            $17.swal({
                title: '確認要刪除此項目嗎？',
                text: '',
                type: 'warning',
                showCancelButton: true,
                closeOnConfirm: false,
                showLoaderOnConfirm: true
            }, function (answer) {
                if (answer) {
                    vm.editAjax = false;
                    vm.$http.delete('/adminapi/commonly_used_discounts', { body: { id: vm.modal.currentId } }).then(function (response) {
                        vm.alert('刪除成功', '', 'success');
                        vm.getList();
                        vm.editAjax = false;
                        $('#itemModal').modal('hide');
                    }).catch(function (response) {
                        vm.alert('刪除失敗', '', 'error');
                        vm.editAjax = false;
                    });
                }
            });
        },

        alert: function alert(title, message, type) {
            $17.swal({
                title: title,
                text: message,
                type: type,
                showCancelButton: false,
                showLoaderOnConfirm: true
            });
        }
    },
    watch: {
        selected_branch_id: function selected_branch_id(val) {
            if (this.isBranch && val > 0) {
                this.getList();
            }
        },
        'postData.value': function postDataValue(val) {
            //比例不可大於100
            if (this.postData.type == 2 && (val > 100 || val != parseInt(val))) {
                this.postData.value = 0;
            }
        }
    },
    mounted: function mounted() {
        var _this4 = this;

        var vm = this;
        $('#itemModal').on('hidden.bs.modal', function (e) {
            _this4.postData = {
                name: '',
                type: 1,
                value: 0,
                reason: ''
            };
            _this4.modal = {
                action: 'create',
                title: '新增折扣項目',
                currentId: 0
            };
        });
        $('#sortableArea').sortable({
            stop: function stop(e, ui) {
                vm.resultOrder = $('#sortableArea').sortable("toArray", { attribute: 'id' });
                vm.startAjax = true;
                vm.$http.post('/adminapi/commonly_used_discounts/sort', { sortable: vm.resultOrder }).then(function (response) {
                    vm.startAjax = false;
                    $(".alert-success").fadeTo(2000, 500).slideUp(500, function () {
                        $(".alert-success").slideUp(500);
                    });
                }, function (response) {
                    $(".alert-danger").fadeTo(2000, 500).slideUp(500, function () {
                        $(".alert-danger").slideUp(500);
                    });
                });
            }
        });
        $('#sortableArea').disableSelection();
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-61ceab8b=\"\">\n    <div _v-61ceab8b=\"\">\n        <v-select-studio-and-branch :studio_id=\"studioId\" :branch_id=\"branchId\" :branch-change-call-back=\"getList\" _v-61ceab8b=\"\"></v-select-studio-and-branch>\n    </div>\n\n    <!--alert success-->\n    <div class=\"alert alert-success\" role=\"alert\" _v-61ceab8b=\"\">\n        <strong _v-61ceab8b=\"\">排序更新成功！</strong>\n    </div>\n    <!--alert success-->\n\n    <!--alert danger-->\n    <div class=\"alert alert-danger\" role=\"alert\" _v-61ceab8b=\"\">\n        <strong _v-61ceab8b=\"\">排序更新失敗</strong>\n    </div>\n    <!--alert danger-->\n\n    <button type=\"button\" class=\"btn btn-success\" v-if=\"selected_branch_id > 0\" v-on:click=\"openModal('create')\" _v-61ceab8b=\"\">新增折扣項目\n    </button>\n\n    <div class=\"container text-center\" _v-61ceab8b=\"\">\n        <v-spinner :ajaxing=\"startAjax\" _v-61ceab8b=\"\"></v-spinner>\n        <table v-show=\"!startAjax&amp;&amp;items.length>0\" class=\"table\" _v-61ceab8b=\"\">\n            <thead _v-61ceab8b=\"\">\n            <tr _v-61ceab8b=\"\">\n                <th width=\"30%\" _v-61ceab8b=\"\">名稱</th>\n                <th _v-61ceab8b=\"\">動作</th>\n            </tr>\n            </thead>\n            <tbody align=\"left\" id=\"sortableArea\" _v-61ceab8b=\"\">\n            <tr class=\"border_bottom\" v-for=\"(item,index) in items\" :key=\"item.id\" :id=\"item.id\" _v-61ceab8b=\"\">\n                <td _v-61ceab8b=\"\">{{item.name}}</td>\n                <td _v-61ceab8b=\"\">\n                    <a href=\"#\" v-on:click=\"openModal('update',index)\" _v-61ceab8b=\"\">編輯</a>\n                </td>\n            </tr>\n            </tbody>\n        </table>\n    </div>\n\n    <v-modal id=\"itemModal\" no-cancel=\"\" confirm-btn-text=\"儲存\" :remove-clicked=\"deleteItem\" :remove-btn-show=\"modal.action=='update'\" :save-clicked=\"submit\" _v-61ceab8b=\"\">\n        <h4 slot=\"title\" _v-61ceab8b=\"\">{{modal.title}}</h4>\n        <div slot=\"body\" _v-61ceab8b=\"\">\n            <v-spinner :ajaxing=\"editAjax\" _v-61ceab8b=\"\"></v-spinner>\n            <form class=\"form-horizontal clearfix\" v-show=\"!editAjax\" _v-61ceab8b=\"\">\n                <div class=\"col-sm-12\" _v-61ceab8b=\"\">\n                    <div class=\"form-group\" _v-61ceab8b=\"\">\n                        <div class=\"col-sm-2\" _v-61ceab8b=\"\">\n                            <label _v-61ceab8b=\"\">\n                                <input checked=\"checked\" @change=\"changeDiscountType\" v-model=\"postData.type\" type=\"radio\" value=\"1\" _v-61ceab8b=\"\">\n                                金額\n                            </label>\n                        </div>\n                        <div class=\"col-sm-2\" _v-61ceab8b=\"\">\n                            <label _v-61ceab8b=\"\">\n                                <input checked=\"checked\" @change=\"changeDiscountType\" v-model=\"postData.type\" type=\"radio\" value=\"2\" _v-61ceab8b=\"\">\n                                比例\n                            </label>\n                        </div>\n                    </div>\n                    <div class=\"form-group\" _v-61ceab8b=\"\">\n                        <input class=\"col-xs-6 form-control\" onwheel=\"javascript:this.blur();\" type=\"number\" step=\"1\" min=\"1\" v-model=\"postData.value\" placeholder=\"數值\" _v-61ceab8b=\"\">\n                    </div>\n                    <div class=\"form-group\" _v-61ceab8b=\"\">\n                        <input class=\"col-sm-12 form-control\" type=\"text\" v-model=\"postData.name\" placeholder=\"常用項目暱稱\" _v-61ceab8b=\"\">\n                    </div>\n                    <div class=\"form-group\" _v-61ceab8b=\"\">\n                        <textarea class=\"col-sm-12 form-control\" rows=\"5\" v-model=\"postData.reason\" placeholder=\"折扣原因\" _v-61ceab8b=\"\"></textarea>\n                    </div>\n                </div>\n            </form>\n        </div>\n    </v-modal>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.btn-success[_v-61ceab8b] {\n  margin-top: 10px;\n  margin-bottom: 15px;\n  margin-left: 15px; }\n\n/* line 8, stdin */\ntr.border_bottom td[_v-61ceab8b] {\n  border-bottom: 1pt solid #ddd; }\n\n/* line 12, stdin */\n.alert[_v-61ceab8b] {\n  display: none; }\n\n/* line 16, stdin */\nh6[_v-61ceab8b] {\n  color: #807a7a; }\n\n/* line 20, stdin */\ntable[_v-61ceab8b] {\n  width: 100%;\n  border-bottom: 10px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-61ceab8b", module.exports)
  } else {
    hotAPI.update("_v-61ceab8b", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1052:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n#delete[_v-47612246] {\n  margin-right: 5%; }\n\n/* line 5, stdin */\n.btn-success[_v-47612246] {\n  margin-top: 10px;\n  margin-bottom: 15px;\n  margin-left: 15px; }\n\n/* line 11, stdin */\ntr.border_bottom td[_v-47612246] {\n  border-bottom: 1pt solid #ddd; }\n\n/* line 15, stdin */\n.alert[_v-47612246] {\n  display: none; }\n\n/* line 19, stdin */\nh6[_v-47612246] {\n  color: #807a7a; }\n\n/* line 23, stdin */\ntable[_v-47612246] {\n  width: 100%;\n  border-bottom: 10px; }\n\n/* line 28, stdin */\ntr.border_bottom td span[_v-47612246] {\n  display: inline; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            products: {},
            createBtn: '確認新增',
            items: [],
            itemName: {},
            itemId: {},
            startOrder: [],
            resultOrder: [],
            length: 0,
            startAjax: false,
            text: '',
            model: {
                name: '',
                commonly_usable_type: 'Contract',
                commonly_usable_id: 0
            }
        };
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId', 'isBranch', 'isSeventeen']), (0, _vuex.mapState)('filters', ['selected_studio_id', 'selected_branch_id'])),
    methods: {
        createModal: function createModal() {
            this.changeType('contracts');
            $('#createModal').modal('show');
        },
        getList: function getList(id) {
            var _this2 = this;

            this.startAjax = true;
            id = id === null || id === undefined ? this.selected_branch_id : id;
            api = '/adminapi/commonly_used_items';
            if (id !== null && id !== undefined) {
                api += '?branch_id=' + id;
            }
            this.$http.get(api).then(function (response) {
                if (response.body.length > 0) {
                    _this2.startAjax = false;
                    _this2.items = response.body;
                    _this2.length = _this2.items.length;
                } else {
                    _this2.startAjax = false;
                    _this2.items = [];
                    _this2.text = '尚未新增項目';
                }
            }, function (error) {
                _this2.startAjax = false;
            });
        },
        changeType: function changeType(type) {
            var _this3 = this;

            this.model.commonly_usable_id = 0;
            this.startAjax = true;
            this.$http.get('/adminapi/pos/get_product_list/' + this.selected_branch_id + '/' + type).then(function (response) {
                var items = _this3.itemFilter(response.body.list);
                _this3.products = items;
                _this3.startAjax = false;
            }, function (error) {
                _this3.startAjax = false;
            });
        },
        itemFilter: function itemFilter(list) {
            var newList = [];
            list.forEach(function (item) {
                item.items.forEach(function (i) {
                    newList.push(i);
                });
            });
            return newList;
        },
        createItem: function createItem() {
            if (this.model.commonly_usable_id === 0 || this.model.commonly_usable_id === '0') {
                this.alert('請選擇一個項目', '', 'warning');
            } else {
                var itemName = $('#createItemName').val();
                this.$http.post('/adminapi/commonly_used_items', { name: this.model.name,
                    commonly_usable_type: this.model.commonly_usable_type,
                    commonly_usable_id: this.model.commonly_usable_id,
                    branch_id: this.selected_branch_id,
                    order: 0
                }).then(function (response) {
                    $('#createModal').modal('hide');
                    this.getList();
                    this.alert('新增常用項目', '新增成功', 'success');
                }, function (response) {
                    this.alert('新增失敗', '新增失敗', 'warning');
                });
            }
        },
        deleteItem: function deleteItem(id) {
            var _this = this;
            $17.swal({
                title: '刪除常用項目',
                text: '確認要刪除此項目嗎？',
                type: 'warning',
                showCancelButton: true,
                closeOnConfirm: false,
                showLoaderOnConfirm: true
            }, function (answer) {
                if (answer) {
                    _this.startAjax = true;
                    _this.$http.delete('/adminapi/commonly_used_items/' + id).then(function (response) {
                        _this.startAjax = false;
                        _this.getList();
                    }, function (response) {
                        _this.startAjax = false;
                    });
                }
            });
        },
        alert: function alert(title, message, type, showCancelBtn) {
            $17.swal({
                title: title,
                text: message,
                type: type,
                showCancelButton: false,
                showLoaderOnConfirm: true
            });
        }
    },
    mounted: function mounted() {
        var _this4 = this;

        this.getList();
        var _this = this;
        $('#createModal').on('hidden.bs.modal', function (e) {
            _this4.model.name = '';
            _this4.model.commonly_usable_type = 'Contract';
            _this4.model.commonly_usable_id = 0;
        });
        $('#sortableArea').sortable({
            stop: function stop(e, ui) {
                _this.resultOrder = $('#sortableArea').sortable("toArray", { attribute: 'id' });
                //start AJAXing
                _this.startAjax = true;
                _this.$http.post('/adminapi/commonly_used_items/order', { new: _this.resultOrder }).then(function (response) {
                    _this.startAjax = false;
                    $(".alert-success").fadeTo(2000, 500).slideUp(500, function () {
                        $(".alert-success").slideUp(500);
                    });
                }, function (response) {
                    $(".alert-danger").fadeTo(2000, 500).slideUp(500, function () {
                        $(".alert-danger").slideUp(500);
                    });
                });
            },
            start: function start(event, ui) {
                this.startOrder = $('#sortableArea').sortable("toArray", { attribute: 'id' });
            }
        });
        $('#sortableArea').disableSelection();
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n    <div _v-47612246=\"\">\n\n        <div _v-47612246=\"\">\n            <v-select-studio-and-branch :studio_id=\"studioId\" :branch_id=\"branchId\" :branch-change-call-back=\"getList\" _v-47612246=\"\"></v-select-studio-and-branch>\n        </div>\n\n        <!--alert success-->\n        <div class=\"alert alert-success\" role=\"alert\" _v-47612246=\"\">\n            <strong _v-47612246=\"\">排序更新成功！</strong>\n        </div>\n\t\t<!--alert success-->\n\n\t\t<!--alert danger-->\n        <div class=\"alert alert-danger\" role=\"alert\" _v-47612246=\"\">\n            <strong _v-47612246=\"\">排序更新失敗</strong>\n        </div>\n\t\t<!--alert danger-->\n\n        <button type=\"button\" class=\"btn btn-success\" v-if=\"selected_branch_id > 0\" v-on:click=\"createModal\" _v-47612246=\"\">新增常用項目</button>\n\n        <div class=\"container text-center\" _v-47612246=\"\">\n\n            <v-spinner :ajaxing=\"startAjax\" _v-47612246=\"\">\n\n            </v-spinner>\n\n            <table v-show=\"!startAjax\" class=\"table pagin-table\" _v-47612246=\"\">\n                <thead _v-47612246=\"\">\n                <tr _v-47612246=\"\">\n                    <th width=\"30%\" _v-47612246=\"\">名稱</th>\n                    <th _v-47612246=\"\">動作</th>\n                </tr>\n                </thead>\n\n                <tbody align=\"left\" id=\"sortableArea\" _v-47612246=\"\">\n                <tr class=\"border_bottom\" v-for=\"item in items\" :key=\"item.id\" :id=\"item.id\" _v-47612246=\"\">\n                    <td _v-47612246=\"\">{{item.name}}</td>\n                    <td _v-47612246=\"\">\n                        <span id=\"delete\" _v-47612246=\"\">\n                            <a href=\"#\" v-on:click=\"deleteItem(item.id)\" _v-47612246=\"\">刪除</a>\n                        </span>\n                    </td>\n                </tr>\n                </tbody>\n            </table>\n        </div>\n\n        <v-modal id=\"createModal\" :confirm-btn-text=\"createBtn\" no-cancel=\"\" :save-clicked=\"createItem\" :pop-ajaxing=\"startAjax\" _v-47612246=\"\">\n            <h4 slot=\"title\" _v-47612246=\"\">新增常用項目</h4>\n            <form slot=\"body\" class=\"form-horizontal\" _v-47612246=\"\">\n                <div class=\"form-group\" _v-47612246=\"\">\n                    <div class=\"col-sm-12\" _v-47612246=\"\">\n                        <div class=\"row\" _v-47612246=\"\">\n                            <div class=\"col-sm-2\" _v-47612246=\"\">\n                                <input checked=\"checked\" id=\"contracts\" v-model=\"model.commonly_usable_type\" type=\"radio\" @change=\"changeType('contracts')\" name=\"item_type\" value=\"Contract\" :disabled=\"startAjax == 1\" _v-47612246=\"\">\n                                <label for=\"contracts\" _v-47612246=\"\">方案</label>\n                            </div>\n                            <div class=\"col-sm-2\" _v-47612246=\"\">\n                                <input id=\"tickets\" type=\"radio\" v-model=\"model.commonly_usable_type\" @change=\"changeType('ticket_settings')\" name=\"item_type\" value=\"TicketSetting\" :disabled=\"startAjax == 1\" _v-47612246=\"\">\n                                <label for=\"tickets\" _v-47612246=\"\">票券</label>\n                            </div>\n                            <div class=\"col-sm-2\" _v-47612246=\"\">\n                                <input id=\"physical_products\" type=\"radio\" v-model=\"model.commonly_usable_type\" @change=\"changeType('physical_products')\" name=\"item_type\" value=\"PhysicalProduct\" :disabled=\"startAjax == 1\" _v-47612246=\"\">\n                                <label for=\"physical_products\" _v-47612246=\"\">產品</label>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"col-sm-12 m-top-10 m-bottom-10\" _v-47612246=\"\">\n                            <v-spinner :ajaxing=\"startAjax\" _v-47612246=\"\">\n                            <select v-show=\"!startAjax\" class=\"form-control\" v-model=\"model.commonly_usable_id\" _v-47612246=\"\">\n                            <option value=\"0\" _v-47612246=\"\">請選擇項目</option>\n                            <option v-for=\"product in products\" :key=\"product.id\" :value=\"product.id\" _v-47612246=\"\">\n                            {{ product.name }}\n                            </option>\n                        </select>\n                    </v-spinner></div>\n                    <div class=\"col-sm-12\" _v-47612246=\"\">\n                        <input v-model=\"model.name\" @keydown.enter.prevent=\"createItem\" name=\"item_name\" class=\"form-control\" placeholder=\"常用項目暱稱 (選填)\" _v-47612246=\"\">\n                    </div>\n                </div>\n            </form>\n        </v-modal>\n\n\n    </div>\n\n\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n#delete[_v-47612246] {\n  margin-right: 5%; }\n\n/* line 5, stdin */\n.btn-success[_v-47612246] {\n  margin-top: 10px;\n  margin-bottom: 15px;\n  margin-left: 15px; }\n\n/* line 11, stdin */\ntr.border_bottom td[_v-47612246] {\n  border-bottom: 1pt solid #ddd; }\n\n/* line 15, stdin */\n.alert[_v-47612246] {\n  display: none; }\n\n/* line 19, stdin */\nh6[_v-47612246] {\n  color: #807a7a; }\n\n/* line 23, stdin */\ntable[_v-47612246] {\n  width: 100%;\n  border-bottom: 10px; }\n\n/* line 28, stdin */\ntr.border_bottom td span[_v-47612246] {\n  display: inline; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-47612246", module.exports)
  } else {
    hotAPI.update("_v-47612246", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1053:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vuex = require('vuex');

exports.default = {
    props: {
        branchesAdmissions: {
            require: true
        },
        contractType: {
            require: true
        },
        defaultAdmissions: {
            type: Object,
            default: function _default() {
                return {};
            }
        },
        defaultEnable: {
            default: 0
        }
    },
    data: function data() {
        return {
            is_enabled_admission: 0,
            admissions: {}
        };
    },

    watch: {
        is_enabled_admission: function is_enabled_admission(newVal) {
            if (!newVal) {
                this.admissions = {};
            }
            this.$emit('change-admission', {
                'is_enabled_admission': newVal,
                'admissions': this.admissions
            });
        },
        defaultEnable: function defaultEnable(newVal) {
            this.is_enabled_admission = newVal;
        },

        admissions: {
            handler: function handler(newVal) {
                undefined.$emit('change-admission', {
                    'is_enabled_admission': undefined.is_enabled_admission,
                    'admissions': undefined.admissions
                });
            },
            deep: true
        }
    },
    mounted: function mounted() {
        var _this = this;

        this.$nextTick(function () {
            _this.is_enabled_admission = _this.defaultEnable;
        });
    },

    computed: {},
    methods: {
        changeAdmissionSelect: function changeAdmissionSelect(data) {
            this.admissions[data.branch_id] = data.admission_id;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div>\n    <div class=\"group-input\">\n        <label for=\"is_enabled_admission\">入場設定</label>\n        <div class=\"btn-group\">\n            <v-bs-switch v-model=\"is_enabled_admission\" id=\"is_enabled_admission\"></v-bs-switch>\n        </div>\n    </div>\n    <div class=\"group-input\" v-show=\"is_enabled_admission\">\n        <label></label>\n        <p class=\"admission-hint\">請選擇要開啟的入場服務</p>\n    </div>\n    <div class=\"group-input\" v-show=\"is_enabled_admission\">\n        <label></label>\n        <div v-show=\"is_enabled_admission\">\n            <div v-for=\"branch in branchesAdmissions\">\n                <webadmin-branch-admission-item :branch=\"branch\" :contract-type=\"contractType\" :default-items=\"defaultAdmissions\" @select-admission=\"changeAdmissionSelect\">\n                </webadmin-branch-admission-item>\n            </div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-c13dcb50", module.exports)
  } else {
    hotAPI.update("_v-c13dcb50", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1054:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vuex = require('vuex');

exports.default = {
    props: {
        contractType: {
            require: true
        },
        branch: {
            require: true
        },
        defaultItems: {
            default: function _default() {
                return {};
            }
        }
    },
    data: function data() {
        return {
            currentSelect: null
        };
    },

    watch: {
        currentSelect: function currentSelect(newVal) {
            this.$emit('select-admission', {
                'branch_id': this.branch.id,
                'admission_id': newVal
            });
        },
        contractType: function contractType() {
            this.currentSelect = null;
        },
        defaultAdmissionItem: function defaultAdmissionItem(newVal) {
            this.currentSelect = newVal;
        }
    },
    computed: {
        defaultAdmissionItem: function defaultAdmissionItem() {
            if (typeof this.defaultItems[this.branch.id] !== 'undefined') {
                return this.defaultItems[this.branch.id];
            }
            return null;
        }
    },
    methods: {
        displayAdmission: function displayAdmission(type) {
            return this.contractType == type && [1, 2, 3].indexOf(type) >= 0;
        }
    },
    mounted: function mounted() {
        this.currentSelect = this.defaultAdmissionItem;
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div>\n    <div class=\"group-input\">\n        <label class=\"branch\">{{ branch.name }}</label>\n    </div>\n    <div v-show=\"displayAdmission(admission.type)\" v-for=\"admission in branch.admissions\" class=\"group-input branch-row\">\n        <label></label>\n        <div>\n            <label class=\"setting\">\n                <input class=\"check-setting\" type=\"checkbox\" :value=\"admission.id\" v-model=\"currentSelect\" v-bind:true-value=\"admission.id\" v-bind:false-value=\"null\">\n                {{ admission.name }}\n            </label>\n        </div>\n    </div>\n    <hr>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-a9b05144", module.exports)
  } else {
    hotAPI.update("_v-a9b05144", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1055:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.ck-editor__editable {\n  max-height: 960px !important;\n  min-height: 300px !important; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ckeditor5BuildClassic = require('@ckeditor/ckeditor5-build-classic');

var _ckeditor5BuildClassic2 = _interopRequireDefault(_ckeditor5BuildClassic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        initEditorData: {
            type: String,
            description: 'default content from database'
        },
        clickSave: {
            type: Boolean,
            default: false,
            description: 'Listen to this vale, if true return editorDataStorage'
        },
        toolbar: {
            type: Array,
            default: function _default() {
                return ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|', 'indent', 'outdent', '|', 'ckfinder', 'blockQuote', 'undo', 'redo'];
            },
            description: 'Listen to this vale, if true return editorDataStorage'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: ''
        }
    },
    data: function data() {
        return {
            editor: _ckeditor5BuildClassic2.default,
            editorDataStorage: '',
            editorConfig: {
                language: 'zh-tw',
                toolbar: this.toolbar,
                ckfinder: {
                    language: 'zh-tw',
                    uploadUrl: '/cksource/ckfinder/connector?command=QuickUpload&type=Images&responseType=json'
                },
                heading: {
                    options: [{ model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' }, { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' }, { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' }, { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' }]
                },
                placeholder: this.placeholder,
                FontBackgroundColorConfig: 'Black'
            }
        };
    },
    create: function create() {
        this.setEditorData();
    },

    watch: {
        editorDataStorage: function editorDataStorage(newVal) {
            this.$emit('watch-ck-editor', this.editorDataStorage);
        },
        clickSave: function clickSave(newVal) {
            if (newVal == true) {
                this.$emit('update-ck-editor-data', this.editorDataStorage);
            }
        },
        initEditorData: {
            handler: function handler(newVal) {
                this.editorDataStorage = newVal;
            },

            immediate: true
        }
    },
    methods: {
        removePopupEditor: function removePopupEditor() {
            $('#cke_editor1').remove();
        },
        setEditorData: function setEditorData() {
            this.editorDataStorage = this.initEditorData;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div>\n    <ckeditor :editor=\"editor\" v-model=\"editorDataStorage\" :config=\"editorConfig\" @focus=\"removePopupEditor\" :disabled=\"disabled\"></ckeditor>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.ck-editor__editable {\n  max-height: 960px !important;\n  min-height: 300px !important; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-605d6e0d", module.exports)
  } else {
    hotAPI.update("_v-605d6e0d", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"@ckeditor/ckeditor5-build-classic":1,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1056:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.btn-inverse[_v-46c73f9a] {\n  background-color: #444444;\n  color: #ffffff; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        config: {
            type: Object,
            description: 'setting config'
        },
        pictureSizeVerification: {
            type: Boolean,
            default: false
        },
        canSelectPicture: {
            type: Boolean,
            default: true
        },
        canMediaLibrary: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            selectUrl: ""
        };
    },
    mounted: function mounted() {},
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        canMediaLibraryIndex: function canMediaLibraryIndex(state) {
            return state.webadmin.configure.webFunctions.WebadminMediaLibraryIndex;
        }
    }), (0, _vuex.mapState)('webadmin/configure', ['studioId'])),
    methods: {
        ckFileModel: function ckFileModel() {
            var vm = this;
            if (!this.canMediaLibraryIndex && this.canMediaLibrary) {
                $17.swal({
                    title: '',
                    text: '您無此權限，請確認系統方案',
                    type: 'error',
                    showCancelButton: false
                });
                return;
            }
            CKFinder.modal({
                chooseFiles: true,
                width: 800,
                height: 600,
                removeModules: vm.config.removeModules,
                connectorPath: '/cksource/ckfinder/connector/' + vm.config.rootFolder,
                onInit: function onInit(finder) {
                    vm.onFilesChoose(finder);
                    vm.onDeleteFiles(finder);
                    vm.onFileUpload(finder);
                    vm.onCopyFile(finder);
                }
            });
        },
        onFilesChoose: function onFilesChoose(finder) {
            var vm = this;
            finder.on('files:choose', function (evt) {
                if (vm.canSelectPicture) {
                    var file = evt.data.files.first();
                    var folder = file.get('folder');
                    finder.request('command:send', {
                        name: 'ImageInfo',
                        folder: folder,
                        params: { fileName: file.get('name') }
                    }).done(function (response) {
                        if (response.error) {
                            return;
                        }
                        vm.sizeVerification(response, file);
                    });
                } else {
                    $17.swal({
                        title: '',
                        text: '您無此權限，請洽系統管理員',
                        type: 'error',
                        showCancelButton: false
                    });
                }
            });
        },
        onDeleteFiles: function onDeleteFiles(finder) {
            var vm = this;
            finder.on('command:after:DeleteFiles', function (evt) {
                vm.$emit('reload');
            });
        },
        onFileUpload: function onFileUpload(finder) {
            finder.on('command:error:FileUpload', function (evt) {
                if (evt.data.response.error.number == 601) {
                    finder.request('dialog:info', {
                        msg: '上傳失敗，總容量已達 1GB，請洽 17FIT',
                        title: '警告'
                    });
                } else {
                    finder.request('dialog:info', {
                        msg: '上傳失敗，檔案請勿超過 5MB',
                        title: '警告'
                    });
                }
            });
        },
        onCopyFile: function onCopyFile(finder) {
            var vm = this;
            finder.on('command:error:CopyFiles', function (evt) {
                if (evt.data.response.error.number == 601) {
                    finder.request('closePopup');
                    vm.$emit('error-handle');
                }
            });
        },
        sizeVerification: function sizeVerification(response, file) {
            if (this.pictureSizeVerification) {
                if (response.width / 400 != response.height / 300) {
                    $17.swal({
                        title: '設定失敗,圖片比例必須為4:3',
                        type: 'warning',
                        showCancelButton: false
                    });
                    return;
                }
            }
            this.$emit('setting-image', {
                "url": file.getUrl(),
                "name": file.get('name'),
                'folder': response.currentFolder.url
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<button type=\"button\" class=\"btn btn-default\" @click=\"ckFileModel\" _v-46c73f9a=\"\"><i class=\"fa fa-image\" _v-46c73f9a=\"\"></i>\n    從媒體庫加入\n</button>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.btn-inverse[_v-46c73f9a] {\n  background-color: #444444;\n  color: #ffffff; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-46c73f9a", module.exports)
  } else {
    hotAPI.update("_v-46c73f9a", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1057:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.reset_flex[_v-220efdd8] {\n  -ms-flex: none;\n      flex: none; }\n\n/* line 6, stdin */\n.label-subtitle[_v-220efdd8] {\n  font-size: 0.5em;\n  color: #7a7a7a; }\n\n/* line 11, stdin */\n.setting-tooltip[_v-220efdd8] {\n  position: relative;\n  display: inline-block; }\n\n/* line 16, stdin */\n.setting-tooltip .tooltiptext[_v-220efdd8] {\n  visibility: hidden;\n  width: 120px;\n  background-color: #606060;\n  color: #fff;\n  text-align: center;\n  border-radius: 6px;\n  padding: 5px 0;\n  position: absolute;\n  z-index: 1;\n  bottom: 150%;\n  left: 50%;\n  margin-left: -60px; }\n\n/* line 31, stdin */\n.setting-tooltip .tooltiptext[_v-220efdd8]::after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  margin-left: -5px;\n  border-width: 5px;\n  border-style: solid;\n  border-color: #606060 transparent transparent transparent; }\n\n/* line 42, stdin */\n.setting-tooltip:hover .tooltiptext[_v-220efdd8] {\n  visibility: visible; }\n\n/* line 2, stdin */\n.contact-modal-calendar {\n  top: -280px;\n  right: -45px; }\n\n/* line 8, stdin */\n.contract-modal-vue textarea {\n  margin: 0; }\n\n/* line 12, stdin */\n.contract-modal-vue .primary-color {\n  background-color: #38b0e3; }\n\n/* line 17, stdin */\n.contract-modal-vue .nav-pills .active a {\n  background-color: #38b0e3; }\n\n/* line 21, stdin */\n.contract-modal-vue .nav-pills :not(.active) a {\n  color: #38b0e3; }\n\n/* line 25, stdin */\n.contract-modal-vue .time_span_group {\n  display: -ms-flexbox;\n  display: flex; }\n  /* line 27, stdin */\n  .contract-modal-vue .time_span_group #time_span_group {\n    -ms-flex: 1;\n        flex: 1; }\n  /* line 30, stdin */\n  .contract-modal-vue .time_span_group .search-btn {\n    width: 40px;\n    max-width: 40px;\n    padding-left: 10px; }\n    /* line 34, stdin */\n    .contract-modal-vue .time_span_group .search-btn div {\n      background-color: #38b0e3;\n      color: white;\n      border-radius: 3px;\n      cursor: pointer; }\n      /* line 39, stdin */\n      .contract-modal-vue .time_span_group .search-btn div i {\n        display: block;\n        padding: 9px; }\n\n/* line 46, stdin */\n.contract-modal-vue .class_list {\n  display: -ms-flexbox;\n  display: flex; }\n  /* line 48, stdin */\n  .contract-modal-vue .class_list .list-box {\n    border: 1px solid #000;\n    border-top: none;\n    height: 250px;\n    max-height: 250px; }\n    /* line 53, stdin */\n    .contract-modal-vue .class_list .list-box .list-search {\n      padding: 5px; }\n    /* line 56, stdin */\n    .contract-modal-vue .class_list .list-box .list {\n      margin-right: 5px;\n      height: 200px;\n      overflow-y: auto; }\n  /* line 62, stdin */\n  .contract-modal-vue .class_list .item {\n    padding: 5px;\n    cursor: pointer; }\n    /* line 65, stdin */\n    .contract-modal-vue .class_list .item:hover {\n      background-color: #eee; }\n  /* line 69, stdin */\n  .contract-modal-vue .class_list .waiting,\n  .contract-modal-vue .class_list .selected {\n    -ms-flex: 1;\n        flex: 1; }\n    /* line 72, stdin */\n    .contract-modal-vue .class_list .waiting .title,\n    .contract-modal-vue .class_list .selected .title {\n      border: 1px solid #000;\n      padding: 5px;\n      padding-left: 10px;\n      text-align: left; }\n  /* line 79, stdin */\n  .contract-modal-vue .class_list .sep {\n    border-top: 1px solid #000;\n    border-bottom: 1px solid #000;\n    background-color: #e1e1e1;\n    width: 20px;\n    max-width: 20px; }\n\n/* line 88, stdin */\n.contract-modal-vue .group-input {\n  min-height: 34px;\n  margin-bottom: 20px;\n  display: -ms-flexbox;\n  display: flex; }\n  /* line 93, stdin */\n  .contract-modal-vue .group-input label {\n    width: 160px; }\n    /* line 96, stdin */\n    .contract-modal-vue .group-input label span {\n      color: red; }\n  /* line 101, stdin */\n  .contract-modal-vue .group-input label.setting, .contract-modal-vue .group-input label.branch {\n    width: inherit; }\n  /* line 105, stdin */\n  .contract-modal-vue .group-input div {\n    -ms-flex: 1;\n        flex: 1; }\n  /* line 109, stdin */\n  .contract-modal-vue .group-input.branch-row {\n    margin-bottom: 0px; }\n\n/* line 114, stdin */\n.contract-modal-vue .switch-btn-group {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: baseline;\n      align-items: baseline; }\n  /* line 118, stdin */\n  .contract-modal-vue .switch-btn-group .btn-group {\n    width: 130px;\n    max-width: 130px; }\n  /* line 122, stdin */\n  .contract-modal-vue .switch-btn-group .count-group {\n    -ms-flex: 1;\n        flex: 1;\n    max-width: 130px; }\n\n@media (max-width: 1000px) {\n  /* line 129, stdin */\n  .contract-modal-vue .group-input {\n    display: block; } }\n\n/* line 134, stdin */\n.contract-modal-vue .admission-hint {\n  margin: -10px 0 0px; }\n\n@media (min-width: 768px) {\n  /* line 138, stdin */\n  .contract-modal-vue .display-switch {\n    text-align: right; } }\n\n/* line 142, stdin */\n.contract-modal-vue .display-switch label {\n  font-size: 14px; }\n\n/* line 147, stdin */\n.contract-modal-vue .func-bar {\n  margin-bottom: 15px; }\n")
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _vuex = require("vuex");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        studioId: {
            require: true
        },
        branchId: {
            require: true
        },
        contracts: {
            require: true
        },
        nowAction: {
            require: true
        },
        categoryId: {
            default: null
        },
        currentId: {
            default: null,
            require: false
        },
        serviceId: {
            type: Number,
            default: 0
        }
    },
    data: function data() {
        return {
            modal: {
                title: "",
                submitWord: ""
            },
            configureTemplate: {
                status: 1,
                booking_online: 0,
                show_online: 0,
                is_fine: 0,
                is_enabled_admission: 0,
                sell_start_day_switch: false,
                sell_end_day_switch: false,
                people_purchase_limit_switch: false,
                effective_days_switch: 1,
                purchase_limit: 1,
                effective_days: 30,
                people_purchase_limit: 1,
                category_id: null,
                name: "",
                price: "",
                description: "",
                type: 0,
                point_value: 30,
                count_value: 30,
                can_book_many: 0,
                muti_booking: 0,
                sell_start_day: null,
                sell_end_day: null,
                end_day_field: new Date(),
                start_day_field: new Date(),
                yetSelectedFilter: "",
                selectedFilter: "",
                service_group: [],
                currentShow: [],
                classList: [],
                selectedClass: [],
                promote_by_17: 0,
                experience_plan: 0,
                branch_admission: {},
                defaultAdmissions: {},
                defaultEnabledAdmission: 0,
                cancel_policy_id: 0,
                enable_external_link: 0,
                external_link_object: {},
                default_external_link_id: null,
                enable_member_transfer: 0,
                sales_site: {
                    is_active: 0
                }
            },
            contract: {
                service_group: []
            },
            studio: {
                name: "",
                contract: [],
                service_group: [],
                contract_group: [],
                transferSettingState: 0
            },
            displayGroup: [{
                value: 1,
                show: ["effective_days", "booking_online", "muti_booking", "can_book_many", "is_enabled_admission", "cancel_policy"]
            }, {
                value: 2,
                show: ["point_value", "effective_days", "people_purchase_limit", "can_book_many", "muti_booking", "booking_online", "is_enabled_admission", "cancel_policy"]
            }, {
                value: 3,
                show: ["count_value", "effective_days", "people_purchase_limit", "can_book_many", "muti_booking", "booking_online", "is_enabled_admission", "cancel_policy"]
            }, {
                value: 4,
                show: ["time_span", "class_list", "purchase_limit", "lesson_cancel_policy"]
            }],
            branchesAdmissions: [],
            typeList: [{ value: 3, zh: '次數' }, { value: 2, zh: '點數' }, { value: 1, zh: '無限' }, { value: 4, zh: '期課' }],
            specialGroup: {
                id: '',
                name: ''
            },
            serviceDefaultSpecialGroup: {
                id: '',
                name: ''
            },
            cancel_policies: [],
            ajaxing: {
                serviceGroup: false,
                submit: false,
                cancelList: false,
                singleSpecial: false
            },
            isClone: false,
            requiredFields: {
                general: ['name', 'price', 'type'],
                type2: ['point_value'],
                type3: ['count_value']
            },
            errors: {
                target: null,
                fieldName: {
                    name: '名稱',
                    price: '價格',
                    type: '類型',
                    service_group: '群組',
                    point_value: '點數',
                    count_value: '次數',
                    class_list: '課程'
                }
            },
            watcherExperiencePlan: null,
            watcherPeoplePurchaseLimitSwitch: null
        };
    },

    filters: {},
    watch: {
        nowAction: function nowAction(newVal) {
            if (newVal == 'create') {
                if (this.isClone) {
                    this.cloneContract();
                } else {
                    this.newContract();
                }
            }
            if (newVal == 'update') {
                this.showEditPanel();
            }
        },
        serviceId: function serviceId(newVal) {
            if (newVal) {
                this.getSpecialSingleContractGroup(newVal);
            }
        },
        'contract.purchase_limit': function contractPurchase_limit(newVal) {
            this._checkIsNumber('purchase_limit');
        },
        'contract.effective_days': function contractEffective_days(newVal) {
            this._checkIsNumber('effective_days');
        },
        'contract.people_purchase_limit': function contractPeople_purchase_limit(newVal) {
            this._checkIsNumber('people_purchase_limit');
        },
        'contract.sell_start_day': function contractSell_start_day(newVal) {
            if (!newVal) this.contract.sell_start_day = null;
        },
        'contract.sell_end_day': function contractSell_end_day(newVal) {
            if (!newVal) this.contract.sell_end_day = null;
        },
        'contract.experience_plan': function contractExperience_plan(newVal) {
            if (!newVal) this.contract.promote_by_17 = 0;
        },
        studioId: function studioId() {
            this.refreshData();
            this.getStudioTransferActive();
        },
        isSeventeen: function isSeventeen(val) {
            if (val) {
                this.fetchStudioList();
            };
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['isSeventeen', 'studioList']), {
        cateGories: function cateGories() {
            return this.contracts.map(function (item) {
                return {
                    id: item.id,
                    name: item.name
                };
            });
        },
        allServiceGroupIds: function allServiceGroupIds() {
            var ids = this.contract.service_group.map(function (group) {
                return group.id;
            });

            if (this.specialGroup.id) {
                ids = ids.concat([this.specialGroup.id]);
            }

            return ids;
        },
        showAdmissionSetting: function showAdmissionSetting() {
            return this.checkDisplay('is_enabled_admission') && this.$store.state.webadmin.configure.webFunctions.WebadminAdmissionsIndex;
        },
        displayShowOnline: function displayShowOnline() {
            return this.contract.show_online == 1 ? 'block' : 'none';
        },
        canCreate: function canCreate() {
            return this.$store.state.webadmin.configure.webFunctions.WebadminContractCreate;
        },
        canUpdate: function canUpdate() {
            return this.$store.state.webadmin.configure.webFunctions.WebadminContractUpdate;
        },
        canDelete: function canDelete() {
            return this.$store.state.webadmin.configure.webFunctions.WebadminContractDelete;
        },
        updateMode: function updateMode() {
            return this.nowAction === 'update';
        },
        canRemoveContract: function canRemoveContract() {
            return Boolean(this.canDelete) && this.updateMode;
        },
        canSubmit: function canSubmit() {
            if (this.nowAction == 'create' && this.canCreate) return true;
            if (this.updateMode && this.canUpdate) return true;
            return false;
        },
        studioName: function studioName() {
            var _this = this;

            var studio = this.studioList.find(function (item) {
                return item.id == _this.studioId;
            });
            return studio ? studio.brand_name : '';
        },
        showTransfer: function showTransfer() {
            return [2, 3].indexOf(this.contract.type) > -1 && this.studio.transferSettingState;
        }
    }),
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('webadmin/configure', ['fetchStudioList']), {
        checkPrice: function checkPrice() {
            if (this.contract.price < 0) {
                this.contract.price = 0;
            }
        },
        openSpecialGroupModel: function openSpecialGroupModel() {
            $("#special_contract-modal").modal("show");
        },
        closeSpecialGroup: function closeSpecialGroup() {
            this.resetSpecialGroup();
        },
        updateSelectClass: function updateSelectClass(selectedClass) {
            this.contract.selectedClass = selectedClass;
        },
        checkDisplay: function checkDisplay(field) {
            if (typeof this.contract.currentShow === "undefined") {
                return false;
            }
            return this.contract.currentShow.indexOf(field) > -1;
        },
        setType: function setType(value) {
            this.contract.type = value;
            if (value == 1) {
                this.contract.effective_days_switch = 1;
            }
            if (value == 4) {
                this.contract.booking_online = 1;
            }

            for (var prop in this.displayGroup) {
                if (this.displayGroup[prop].value == value) {
                    return this.contract.currentShow = this.displayGroup[prop].show;
                }
            }
        },
        getStudioBranchesAdmission: function getStudioBranchesAdmission() {
            var _this2 = this;

            if (!this.studioId) {
                return;
            }
            this.branchesAdmissions = [];

            this.$http.get('/adminapi/studio/' + this.studioId + '/branches/admissions').then(function (response) {
                _this2.branchesAdmissions = response.data;
            }, function (error) {
                $17.swal({
                    title: '讀取失敗。',
                    type: 'error'
                });
            });
        },
        getStudioTransferActive: function getStudioTransferActive() {
            var _this3 = this;

            if (!this.studioId) {
                return;
            }
            this.studio.transferSettingState = 0;
            this.$http.get("/adminapi/contract-transfer/setting/studio/" + this.studioId).then(function (response) {
                _this3.studio.transferSettingState = response.data.data.open_account_system;
            }).catch(function (response) {
                $17.swal({
                    title: '讀取轉贈失敗。',
                    type: 'error'
                });
            });
        },
        refreshData: function refreshData() {
            this.getStudioBranchesAdmission();
            this.getCancelPolicies();
            this.getContractGroupList();
            if (this.serviceId) {
                this.getSpecialSingleContractGroup(this.serviceId);
            }
        },
        getCancelPolicies: function getCancelPolicies() {
            var _this4 = this;

            if (this.studioId === 0 || this.studio === '0') {
                return;
            }
            this.ajaxing.cancelList = true;
            var params = {
                studio_id: this.studioId
            };

            this.$http.get('/adminapi/cancel_policies/all', { params: params }).then(function (response) {
                _this4.cancel_policies = response.data;
                _this4.ajaxing.cancelList = false;
            }, function (error) {
                _this4.ajaxing.cancelList = false;
                $17.swal({
                    title: '讀取失敗。',
                    type: 'error'
                });
            });
        },
        newContract: function newContract() {
            this.contract.cancel_policy_id = 0;
            this.newInfo();
            this.contract = _lodash2.default.clone(this.configureTemplate);
            if (this.categoryId) {
                this.contract.category_id = this.categoryId;
            }
            this.resetSpecialGroup();
            $('#contract-modal').modal('show');
        },
        cloneContract: function cloneContract() {
            this.contract.selectedClass = [];
            var tempContract = _lodash2.default.clone(this.contract);
            this.newInfo();

            //推廣網址不複製
            delete tempContract.edit_promote_url;

            this.contract = tempContract;
        },
        newInfo: function newInfo() {
            this.modal.title = '新增方案';
            this.modal.submitWord = '送出';
        },
        specialContractSubmit: function specialContractSubmit(specialGroup) {
            this.specialGroup = specialGroup;
            $('#contract-modal').trigger('focus');
        },
        getContractGroupList: function getContractGroupList() {
            var _this5 = this;

            if (!this.studioId) {
                return;
            }
            this.studio.contract_group = [];
            var params = {
                studio_id: this.studioId
            };

            this.$http.get('/api/schedule/contract_group', { params: params }).then(function (response) {
                _this5.studio.contract_group = response.data;
            }, function (error) {
                $17.swal({
                    title: '讀取失敗。',
                    type: 'error'
                });
            });
        },
        resetSpecialGroup: function resetSpecialGroup() {
            if (this.serviceId !== 0) {
                this.specialGroup = this.serviceDefaultSpecialGroup;
                return;
            }
            this.specialGroup = {
                id: '',
                name: ''
            };
        },
        showEditPanel: function showEditPanel() {
            var _this6 = this;

            $.blockUI();
            this.$http.get('/adminapi/contract/single/' + this.currentId).then(function (response) {
                var result = response.data;
                result.data.end_day_field = new Date(result.data.end_day_field);
                result.data.start_day_field = new Date(result.data.sell_start_day);
                result.data.yetSelectedFilter = '';
                result.data.selectedFilter = '';
                result.data.service_group = _this6.convertServiceGroup(result.data.service_group);
                result.data.branch_admission = _this6.convertAdmissions(result.data.admissions);
                result.data.defaultAdmissions = _this6.convertAdmissions(result.data.admissions);;
                result.data.defaultEnabledAdmission = result.data.is_enabled_admission;
                result.data.external_link_object = {};

                _this6.contract = result.data;
                _this6.contract.show_online = result.data.show_online == '1' ? 1 : 0;
                _this6.contract.cancel_policy_id = result.data.cancel_policy_id;
                _this6.setType(result.data.type);
                _this6.modal.title = '修改方案';
                _this6.modal.submitWord = '修改';
                if (result.data.special_group.length != 0) {
                    _this6.specialGroup = result.data.special_group;
                } else {
                    _this6.specialGroup.id = null;
                }
                $.unblockUI();

                _this6.deepClonePostData();
            }, function (error) {
                $.unblockUI();
                $17.swal({
                    title: '讀取方案失敗。',
                    type: 'error'
                });
            }).then(function () {
                $('#contract-modal').modal('show');
            });
        },
        convertServiceGroup: function convertServiceGroup(serviceGroupIds) {
            return this.studio.contract_group.reduce(function (carry, group) {
                if (serviceGroupIds.indexOf(group.id) > -1) {
                    carry.push(group);
                }
                return carry;
            }, []);
        },
        reset: function reset() {
            this.resetSpecialGroup();
            this.contract = _lodash2.default.clone(this.configureTemplate);
            this.modal = {
                title: "",
                submitWord: ""
            };
            this.isClone = false;
            this.$emit('close');
        },
        deleteContract: function deleteContract() {
            var _this7 = this;

            var vm = this;
            var alert = function alert(msg) {
                $17.swal({
                    title: '刪除失敗',
                    text: msg,
                    type: 'error'
                });
            };
            $17.swal({
                title: "刪除方案",
                text: "您確定要刪除方案: " + this.contract.name,
                type: "warning"
            }, function (isConfirm) {
                if (!isConfirm) return;
                $.blockUI();
                _this7.$http.delete('/adminapi/contract?id=' + _this7.currentId).then(function (response) {
                    if (!response.data.success) {
                        $.unblockUI();
                        alert('請重新嘗試');
                        return;
                    }
                    vm.freshList();
                    $.unblockUI();
                    vm.reset();
                    vm.$emit('fetch-new');
                    $('#contract-modal').modal('hide');
                }, function (error) {
                    $.unblockUI();
                    alert(error.data.message);
                });
            });
        },
        validateField: function validateField(field) {
            for (var prop in field) {
                var current = field[prop];
                if (!this.contract[current]) {
                    this.errors.target = this.errors.fieldName[current];
                    return true;
                }
            }
            return false;
        },
        hasUnfilledRequired: function hasUnfilledRequired() {
            if (this.validateField(this.requiredFields.general)) return true;
            if (this.validateField(this.requiredFields['type' + this.contract.type])) return true;
            if (this.contract.type == 4 && this.contract.status === 1 && !this.getSelectedLesson().length) {
                this.errors.target = this.errors.fieldName.class_list;
                return true;
            }
            if (this.contract.status === 1 && this.allServiceGroupIds.length < 1) {
                this.errors.target = this.errors.fieldName.service_group;
                return true;
            }
            return false;
        },
        hasUnfilledAlert: function hasUnfilledAlert() {
            var text = '欄位 [' + this.errors.target + '] 為必填！';
            $17.swal({ showCancelButton: false, text: text });
        },
        getSelectedLesson: function getSelectedLesson() {
            return this.contract.selectedClass.map(function (c) {
                return c.id;
            });
        },
        submitContract: function submitContract() {
            if (this.ajaxing.submit) return;
            if (this.hasUnfilledRequired()) {
                this.hasUnfilledAlert();
                return;
            }
            this.ajaxing.submit = true;
            this.preparePostData();
            if (this.nowAction == 'create' && this.canCreate) return this.submitCreate();
            if (this.updateMode && this.canUpdate) return this.submitUpdate();
        },
        preparePostData: function preparePostData() {
            this.postData = {};
            this.postData.studio_id = this.studioId, this.postData.name = this.contract.name;
            this.postData.price = this.contract.price;
            this.postData.description = this.contract.description;
            this.postData.type = this.contract.type;
            this.postData.service_group = this.allServiceGroupIds;
            this.postData.booking_online = this.contract.booking_online;
            this.postData.show_online = this.contract.show_online;
            this.postData.is_fine = this.contract.is_fine;
            this.postData.is_enabled_admission = this.contract.is_enabled_admission;
            this.postData.sell_start_day = this.contract.sell_start_day_switch ? this.contract.sell_start_day : null;
            this.postData.sell_end_day = this.contract.sell_end_day_switch ? this.contract.sell_end_day : null;
            this.postData.purchase_limit = this.contract.type == 4 ? this.contract.purchase_limit : 0;
            this.postData.effective_days = this.contract.effective_days_switch ? this.contract.effective_days : 0;
            this.postData.lessons = this.getSelectedLesson();
            this.postData.people_purchase_limit = this.contract.people_purchase_limit_switch ? this.contract.people_purchase_limit : 0;
            this.postData.can_book_many = this.contract.can_book_many;
            this.postData.muti_booking = this.contract.muti_booking;
            this.postData.category_id = this.contract.category_id;
            this.postData.status = this.contract.status;
            this.postData.cancel_policy_id = this.contract.cancel_policy_id;
            this.postData.experience_plan = this.contract.experience_plan;
            this.postData.promote_by_17 = this.contract.promote_by_17;
            this.postData.branch_admission = this.contract.branch_admission;
            this.postData.enable_external_link = this.contract.enable_external_link;
            this.postData.external_link_id = this.contract.external_link_object.id ? this.contract.external_link_object.id : null;
            this.postData.enable_member_transfer = this.contract.enable_member_transfer;

            if (this.contract.type == 2) this.postData.value = this.contract.point_value;
            if (this.contract.type == 3) this.postData.value = this.contract.count_value;
        },
        deepClonePostData: function deepClonePostData() {
            this.beforePostData = {};
            this.beforePostData.studio_id = this.studioId, this.beforePostData.name = this.contract.name;
            this.beforePostData.price = this.contract.price;
            this.beforePostData.description = this.contract.description;
            this.beforePostData.type = this.contract.type;
            this.beforePostData.service_group = this.allServiceGroupIds;
            this.beforePostData.booking_online = this.contract.booking_online;
            this.beforePostData.is_fine = this.contract.is_fine;
            this.beforePostData.is_enabled_admission = this.contract.is_enabled_admission;
            this.beforePostData.sell_start_day = this.contract.sell_start_day_switch ? this.contract.sell_start_day : null;
            this.beforePostData.sell_end_day = this.contract.sell_end_day_switch ? this.contract.sell_end_day : null;
            this.beforePostData.purchase_limit = this.contract.type == 4 ? this.contract.purchase_limit : 0;
            this.beforePostData.effective_days = this.contract.effective_days_switch ? this.contract.effective_days : 0;
            this.beforePostData.lessons = this.getSelectedLesson();
            this.beforePostData.people_purchase_limit = this.contract.people_purchase_limit_switch ? this.contract.people_purchase_limit : 0;
            this.beforePostData.can_book_many = this.contract.can_book_many;
            this.beforePostData.muti_booking = this.contract.muti_booking;
            this.beforePostData.category_id = this.contract.category_id;
            this.beforePostData.cancel_policy_id = this.contract.cancel_policy_id;
            this.beforePostData.experience_plan = this.contract.experience_plan;
            this.beforePostData.promote_by_17 = this.contract.promote_by_17;
            this.beforePostData.branch_admission = this.contract.branch_admission;
            this.beforePostData.enable_external_link = this.contract.enable_external_link;
            this.beforePostData.external_link_id = this.contract.external_link_object.id ? this.contract.external_link_object.id : null;
            this.beforePostData.enable_member_transfer = this.contract.enable_member_transfer;

            if (this.contract.type == 2) this.beforePostData.value = this.contract.point_value;
            if (this.contract.type == 3) this.beforePostData.value = this.contract.count_value;
        },
        submitUpdate: function submitUpdate() {
            var _this8 = this;

            this.postData.id = this.currentId;
            this.ajaxing.submit = true;
            this.$http.patch('/adminapi/contract', this.postData).then(function (response) {
                if (!response.data.success) return _this8.resultFailProcess(response.data.message);
                _this8.freshList();
                _this8.ajaxing.submit = false;
                _this8.$emit('fetch-new');
                _this8.reset();
                $('#contract-modal').modal('hide');
            }, function (error) {
                _this8.ajaxing.submit = false;
                $17.swal({
                    title: '更新失敗',
                    text: error.data.message,
                    type: 'error'
                });
            });
        },
        submitCreate: function submitCreate() {
            var _this9 = this;

            this.ajaxing.submit = true;
            this.$http.post('/adminapi/contract', this.postData).then(function (response) {
                if (!response.data.success) return _this9.resultFailProcess(response.data.message);
                _this9.freshList();
                _this9.ajaxing.submit = false;
                _this9.resetCreateSetting();
                _this9.$emit('fetch-new');
                _this9.reset();
                $('#contract-modal').modal('hide');
            }, function (error) {
                _this9.ajaxing.submit = false;
                $17.swal({
                    title: '新增失敗',
                    text: error.data.message,
                    type: 'error',
                    showCancelButton: false
                });
            });
        },
        resultFailProcess: function resultFailProcess(message) {
            this.ajaxing.submit = false;
            $17.swal({ showCancelButton: false, text: message });
        },
        clone: function clone() {
            this.isClone = true;
            this.$emit('clone');
        },
        setAdmission: function setAdmission(para) {
            this.contract.is_enabled_admission = para.is_enabled_admission;
            this.contract.branch_admission = para.admissions;
        },
        convertAdmissions: function convertAdmissions(admissions) {
            return admissions.reduce(function (carry, admission) {
                carry[admission.branch_id] = admission['settings'][0];
                return carry;
            }, {});
        },
        resetCreateSetting: function resetCreateSetting() {
            this.createConfigure = _lodash2.default.clone(this.configureTemplate);
        },
        _checkIsNumber: function _checkIsNumber(index, newVal) {
            var newVal = this.contract[index];
            if (typeof newVal == "string") this.contract[index] = parseInt(newVal);
            if (isNaN(newVal) || newVal < 1) this.contract[index] = 1;
        },
        freshList: function freshList() {
            this.$emit('fetch-list');
        },
        getSpecialSingleContractGroup: function getSpecialSingleContractGroup() {
            var _this10 = this;

            this.ajaxing.singleSpecial = true;
            this.$http.get('/adminapi/service/' + this.serviceId + '/special-group').then(function (response) {
                _this10.ajaxing.singleSpecial = false;
                _this10.serviceDefaultSpecialGroup = {
                    id: response.data.id,
                    name: response.data.name
                };
                _this10.specialGroup = {
                    id: response.data.id,
                    name: response.data.name
                };
            }, function (error) {
                _this10.ajaxing.singleSpecial = false;
                $17.swal({
                    title: '讀取失敗。',
                    type: 'error'
                });
            });
        }
    }),
    mounted: function mounted() {
        this.refreshData();
        this.getStudioTransferActive();
        if (this.isSeventeen && this.studioList.length <= 0) {
            this.fetchStudioList();
        }
    },
    created: function created() {
        this.resetCreateSetting();
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-220efdd8=\"\">\n    <v-modal :close-modal-event=\"reset\" id=\"contract-modal\" class=\"contract-modal-vue\" confirm-btn-text=\"確認\" _v-220efdd8=\"\">\n        <div slot=\"title\" _v-220efdd8=\"\">\n            <h4 class=\"modal-title\" _v-220efdd8=\"\">\n                <span v-if=\"isSeventeen\" _v-220efdd8=\"\">[{{ studioName }}] -</span>\n                {{ modal.title }}\n                <v-admin-operate-record type=\"contract\" :id=\"currentId\" _v-220efdd8=\"\"></v-admin-operate-record>\n            </h4>\n        </div>\n        <div slot=\"body\" _v-220efdd8=\"\">\n            <div class=\"group-input\" _v-220efdd8=\"\">\n                <label for=\"name\" _v-220efdd8=\"\">\n                    名稱\n                    <span _v-220efdd8=\"\">*</span>\n                </label>\n                <div _v-220efdd8=\"\">\n                    <input maxlength=\"30\" type=\"text\" class=\"form-control\" id=\"name\" placeholder=\"請輸入名稱\" v-model=\"contract.name\" _v-220efdd8=\"\">\n                </div>\n            </div>\n            <div class=\"group-input\" _v-220efdd8=\"\">\n                <label for=\"price\" _v-220efdd8=\"\">\n                    價格\n                    <span _v-220efdd8=\"\">*</span>\n                </label>\n                <div _v-220efdd8=\"\">\n                    <input type=\"number\" maxlength=\"6\" id=\"price\" placeholder=\"請輸入價格\" class=\"form-control\" v-model=\"contract.price\" min=\"0\" @change=\"checkPrice\" _v-220efdd8=\"\">\n                </div>\n            </div>\n            <div class=\"line\" _v-220efdd8=\"\"></div>\n            <div class=\"group-input\" _v-220efdd8=\"\">\n                <label for=\"service_group\" _v-220efdd8=\"\">群組</label>\n                <div _v-220efdd8=\"\">\n                    <v-spinner-button :ajaxing=\"ajaxing.serviceGroup\" _v-220efdd8=\"\"></v-spinner-button>\n                    <v-mutiselect v-show=\"!ajaxing.serviceGroup\" :model.sync=\"contract.service_group\" :options=\"studio.contract_group\" :multiple=\"true\" :close-on-select=\"true\" :searchable=\"true\" label=\"name\" track-by=\"id\" tag-name=\"name\" placeholder=\"請選擇群組\" _v-220efdd8=\"\"></v-mutiselect>\n                </div>\n            </div>\n            <v-spinner-button :ajaxing=\"ajaxing.singleSpecial\" _v-220efdd8=\"\"></v-spinner-button>\n            <div class=\"group-input\" v-show=\"!ajaxing.singleSpecial\" _v-220efdd8=\"\">\n                <label _v-220efdd8=\"\"></label>\n                <div v-show=\"!specialGroup.id\" _v-220efdd8=\"\">\n                    <input maxlength=\"30\" type=\"text\" class=\"form-control\" id=\"special_group\" @click=\"openSpecialGroupModel\" placeholder=\"請選擇課程或服務\" _v-220efdd8=\"\">\n                </div>\n                <div class=\"special-text\" v-show=\"specialGroup.id\" _v-220efdd8=\"\">\n                    <button type=\"button\" class=\"close\" v-if=\"serviceId==0\" @click=\"closeSpecialGroup\" _v-220efdd8=\"\">×</button>\n                    {{specialGroup.name}}\n                </div>\n            </div>\n            <div class=\"line\" _v-220efdd8=\"\"></div>\n            <div class=\"group-input\" _v-220efdd8=\"\">\n                <label for=\"price\" _v-220efdd8=\"\">\n                    分類\n                    <span _v-220efdd8=\"\">*</span>\n                </label>\n                <div _v-220efdd8=\"\">\n                    <select class=\"form-control\" v-model=\"contract.category_id\" _v-220efdd8=\"\">\n                        <option v-for=\"c in cateGories\" v-bind:value=\"c.id\" _v-220efdd8=\"\">{{ c.name }}</option>\n                    </select>\n                </div>\n            </div>\n            <div class=\"group-input\" _v-220efdd8=\"\">\n                <label for=\"type\" _v-220efdd8=\"\">\n                    類型\n                    <span _v-220efdd8=\"\">*</span>\n                </label>\n                <ul class=\"nav nav-pills\" style=\"height:40px;\" _v-220efdd8=\"\">\n                    <li v-for=\"t in typeList\" :class=\"{active: t.value==contract.type}\" @click=\"setType(t.value)\" role=\"presentation\" v-show=\"nowAction == 'create' || t.value==contract.type\" _v-220efdd8=\"\">\n                        <a href=\"javascript:void(0);\" _v-220efdd8=\"\">{{ t.zh }}</a>\n                    </li>\n                </ul>\n            </div>\n            <div v-if=\"contract.type\" _v-220efdd8=\"\">\n                <div class=\"group-input\" v-show=\"checkDisplay('count_value')\" _v-220efdd8=\"\">\n                    <label for=\"count_value\" _v-220efdd8=\"\">\n                        次數\n                        <span _v-220efdd8=\"\">*</span>\n                    </label>\n                    <div _v-220efdd8=\"\">\n                        <input type=\"text\" maxlength=\"6\" id=\"count_value\" placeholder=\"請輸入次數\" class=\"form-control\" v-model=\"contract.count_value\" _v-220efdd8=\"\">\n                    </div>\n                </div>\n                <div class=\"group-input\" v-show=\"checkDisplay('point_value')\" _v-220efdd8=\"\">\n                    <label for=\"point_value\" _v-220efdd8=\"\">\n                        點數\n                        <span _v-220efdd8=\"\">*</span>\n                    </label>\n                    <div _v-220efdd8=\"\">\n                        <input type=\"text\" maxlength=\"6\" id=\"point_value\" placeholder=\"請輸入點數\" class=\"form-control\" v-model=\"contract.point_value\" _v-220efdd8=\"\">\n                    </div>\n                </div>\n                <webadmin-contract-time-span v-show=\"checkDisplay('time_span')\" :studio-id=\"studioId\" :contract-group-ids=\"allServiceGroupIds\" :default-selected-class=\"contract.selectedClass\" :default-class-list=\"contract.classList\" :is-clone=\"isClone\" @select-class=\"updateSelectClass\" _v-220efdd8=\"\">\n                </webadmin-contract-time-span>\n                <div v-show=\"checkDisplay('effective_days')\" _v-220efdd8=\"\">\n\t\t\t\t\t<div class=\"group-input\" _v-220efdd8=\"\">\n\t\t\t\t\t\t<label for=\"effective_days\" _v-220efdd8=\"\">有效天數</label>\n                        <div class=\"btn-group\" _v-220efdd8=\"\">\n                            <v-bs-switch v-model=\"contract.effective_days_switch\" id=\"effective_days_switch\" _v-220efdd8=\"\"></v-bs-switch>\n                        </div>\n                        <div class=\"count-group\" v-show=\"contract.effective_days_switch\" _v-220efdd8=\"\">\n\t\t\t\t\t\t\t<input type=\"text\" maxlength=\"6\" id=\"effective_days\" placeholder=\"請輸入天數限制\" class=\"form-control\" v-model=\"contract.effective_days\" _v-220efdd8=\"\">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n                <div v-show=\"checkDisplay('booking_online')\" _v-220efdd8=\"\">\n\t\t\t\t\t<hr _v-220efdd8=\"\">\n\t\t\t\t\t<div class=\"group-input\" _v-220efdd8=\"\">\n\t\t\t\t\t\t<label for=\"booking_online\" _v-220efdd8=\"\">線上預約</label>\n                        <div class=\"btn-group\" _v-220efdd8=\"\">\n                            <v-bs-switch v-model=\"contract.booking_online\" id=\"booking_online\" _v-220efdd8=\"\"></v-bs-switch>\n                        </div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div v-show=\"contract.booking_online\" _v-220efdd8=\"\">\n\t\t\t\t\t\t<div class=\"group-input\" v-show=\"checkDisplay('can_book_many')\" _v-220efdd8=\"\">\n\t\t\t\t\t\t\t<label _v-220efdd8=\"\"></label>\n\t\t\t\t\t\t\t<div _v-220efdd8=\"\">\n\t\t\t\t\t\t\t\t<label _v-220efdd8=\"\">\n\t\t\t\t\t\t\t\t\t<input type=\"checkbox\" v-bind:true-value=\"1\" v-bind:false-value=\"0\" v-model=\"contract.can_book_many\" _v-220efdd8=\"\"> 允許單次多筆\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"group-input\" v-show=\"checkDisplay('muti_booking')\" _v-220efdd8=\"\">\n\t\t\t\t\t\t\t<label _v-220efdd8=\"\"></label>\n\t\t\t\t\t\t\t<div _v-220efdd8=\"\">\n\t\t\t\t\t\t\t\t<label _v-220efdd8=\"\">\n\t\t\t\t\t\t\t\t\t<input type=\"checkbox\" v-bind:true-value=\"1\" v-bind:false-value=\"0\" v-model=\"contract.muti_booking\" _v-220efdd8=\"\"> 允許多次單筆\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n                <hr _v-220efdd8=\"\">\n\n                <div v-show=\"checkDisplay('cancel_policy')\" class=\"group-input\" _v-220efdd8=\"\">\n\t\t\t\t\t<label for=\"is_fine\" _v-220efdd8=\"\">取消政策</label>\n                    <div class=\"btn-group\" _v-220efdd8=\"\">\n\t\t\t\t        <v-bs-switch v-model=\"contract.is_fine\" id=\"is_fine\" _v-220efdd8=\"\"></v-bs-switch>\n                    </div>\n\t\t\t\t</div>\n\n\t\t\t\t<div v-show=\"checkDisplay('lesson_cancel_policy')\" class=\"group-input\" _v-220efdd8=\"\">\n\t\t\t\t\t<label for=\"is_fine\" _v-220efdd8=\"\">補課政策</label>\n\t\t\t\t\t<div class=\"switch-btn-group\" _v-220efdd8=\"\">\n\t\t\t\t\t\t<div class=\"btn-group\" _v-220efdd8=\"\">\n\t\t\t\t\t\t\t <select class=\"form-control\" v-model=\"contract.cancel_policy_id\" _v-220efdd8=\"\">\n\t\t\t\t\t\t\t\t<option v-for=\"c in cancel_policies\" :value=\"c.id\" _v-220efdd8=\"\">{{ c.name }}</option>\n\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n                \n                <webadmin-admission-span v-if=\"showAdmissionSetting\" :branches-admissions=\"branchesAdmissions\" :default-admissions=\"contract.defaultAdmissions\" :contract-type=\"contract.type\" :default-enable=\"contract.defaultEnabledAdmission\" @change-admission=\"setAdmission\" _v-220efdd8=\"\"></webadmin-admission-span>\n                <div class=\"group-input\" _v-220efdd8=\"\">\n\t\t\t\t\t<label for=\"description\" _v-220efdd8=\"\">說明</label>\n\t\t\t\t\t<div _v-220efdd8=\"\">\n                        <textarea maxlength=\"1500\" placeholder=\"非必填，最多1500個字\" v-model=\"contract.description\" _v-220efdd8=\"\"></textarea>\n                    </div>\n\t\t\t\t</div>\n\t\t\t\t<hr _v-220efdd8=\"\">\n                <div class=\"group-input\" _v-220efdd8=\"\">\n\t\t\t\t\t<label for=\"status\" _v-220efdd8=\"\">狀態\n\t\t\t\t\t\t<a href=\"javascript:void(0)\" _v-220efdd8=\"\"><i class=\"fa fa-question-circle\" help=\"上架：此方案可以被加入訂單中進行銷售<br>下架：此方案無法被加入訂單中進行銷售\" _v-220efdd8=\"\"></i></a>\n\t\t\t\t\t</label>\n\t\t\t\t\t<div class=\"switch-btn-group\" _v-220efdd8=\"\">\n\t\t\t\t\t\t<div class=\"col-sm-4\" _v-220efdd8=\"\">\n\t\t\t\t\t\t\t<label _v-220efdd8=\"\">\n\t\t\t\t\t\t\t\t<input type=\"radio\" :value=\"1\" v-model=\"contract.status\" _v-220efdd8=\"\"> 上架\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t<label _v-220efdd8=\"\">\n\t\t\t\t\t\t\t\t<input type=\"radio\" :value=\"0\" v-model=\"contract.status\" _v-220efdd8=\"\"> 下架\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n                <div v-show=\"contract.status\" _v-220efdd8=\"\">\n\t\t\t\t\t<div class=\"group-input\" _v-220efdd8=\"\">\n\t\t\t\t\t\t<label for=\"show_online\" _v-220efdd8=\"\">線上銷售</label>\n                        <div class=\"btn-group\" _v-220efdd8=\"\">\n                            <v-bs-switch v-model=\"contract.show_online\" id=\"show_online\" _v-220efdd8=\"\"></v-bs-switch>\n                        </div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div :style=\"{ display:displayShowOnline }\" _v-220efdd8=\"\">\n                        <div class=\"group-input\" _v-220efdd8=\"\">\n                            <label for=\"experience_plan\" _v-220efdd8=\"\"></label>\n                            <div class=\"switch-btn-group\" _v-220efdd8=\"\">\n                                <div _v-220efdd8=\"\">\n                                    <span style=\"font-size: 0.875rem\" _v-220efdd8=\"\">\n                                            這是體驗方案?\n                                    </span> \n                                    <label style=\"display: inline-block;\n                                            padding-left: 10px;\n                                            width: 50px;\" _v-220efdd8=\"\">\n                                        <input type=\"radio\" :value=\"1\" v-model=\"contract.experience_plan\" _v-220efdd8=\"\"> 是\n                                    </label>\n                                    <label style=\"display: inline-block;\n                                        padding-left: 10px;\n                                        width: 50px;\" _v-220efdd8=\"\">\n                                        <input type=\"radio\" :value=\"0\" v-model=\"contract.experience_plan\" _v-220efdd8=\"\"> 否\n                                    </label>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"group-input\" v-show=\"contract.experience_plan\" style=\"padding-left: 110px\" _v-220efdd8=\"\">\n                            <label _v-220efdd8=\"\"></label>\n                            <div class=\"switch-btn-group\" _v-220efdd8=\"\">\n                                <label style=\"width: 180px\" _v-220efdd8=\"\">\n                                    <input type=\"checkbox\" v-model=\"contract.promote_by_17\" :true-value=\"1\" :false-value=\"0\" _v-220efdd8=\"\"> 在 17FIT 平台加強推廣\n                                </label>\n                                <a href=\"https://17fithelp.zendesk.com/hc/zh-tw/articles/900002567646-加強推廣\" target=\"_blank\" class=\"st-underline\" _v-220efdd8=\"\">暸解更多</a>\n                            </div>\n                        </div>\n                        <div class=\"group-input\" _v-220efdd8=\"\">\n                            <label _v-220efdd8=\"\"></label>\n                            <div _v-220efdd8=\"\">\n                                <div _v-220efdd8=\"\">\n                                    <span v-if=\"nowAction === 'create'\" class=\"st-text-16 st-opacity-60\" _v-220efdd8=\"\">方案銷售頁</span>\n                                    <a v-else=\"\" class=\"st-text-16 st-underline\" :href=\"contract.edit_promote_url\" target=\"_blank\" _v-220efdd8=\"\">方案銷售頁</a>\n                                </div>\n                                <div class=\"label-subtitle\" v-if=\"contract.sales_site.is_active\" _v-220efdd8=\"\">頁面狀態：已啟用</div>\n                                <div class=\"label-subtitle\" v-else=\"\" _v-220efdd8=\"\">頁面狀態：未啟用</div>\n                            </div>\n                        </div>\n\t\t\t\t\t\t<div class=\"group-input\" v-show=\"checkDisplay('purchase_limit')\" _v-220efdd8=\"\">\n\t\t                    <label _v-220efdd8=\"\"></label>\n\t\t                    <div class=\"switch-btn-group\" _v-220efdd8=\"\">\n\t\t                    \t<label _v-220efdd8=\"\">限制總銷售份數</label>\n\t\t                    \t<div class=\"count-group\" style=\"position: relative;\" _v-220efdd8=\"\">\n\t\t\t\t\t\t\t\t\t<input type=\"text\" min=\"6\" id=\"purchase_limit\" placeholder=\"請輸入數量限制\" class=\"form-control\" v-model=\"contract.purchase_limit\" _v-220efdd8=\"\">\n\t\t\t\t\t\t\t\t</div>\n\t\t                    </div>\n\t\t                </div>\n\t\t\t\t\t\t<div class=\"group-input\" _v-220efdd8=\"\">\n\t\t\t\t\t\t\t<label _v-220efdd8=\"\"></label>\n\t\t\t\t\t\t\t<div class=\"switch-btn-group\" _v-220efdd8=\"\">\n\t\t\t\t\t\t\t\t<label _v-220efdd8=\"\">\n\t\t\t\t\t\t\t\t\t<input type=\"checkbox\" v-model=\"contract.sell_start_day_switch\" _v-220efdd8=\"\"> 管理開始販售日期\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t<div class=\"count-group\" v-show=\"contract.sell_start_day_switch\" style=\"position: relative;\" _v-220efdd8=\"\">\n                                    <v-datepicker v-model=\"contract.sell_start_day\" placeholder=\"請輸入日期\" calendar-class=\"contact-modal-calendar\" _v-220efdd8=\"\"></v-datepicker>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"group-input\" _v-220efdd8=\"\">\n\t\t\t\t\t\t\t<label _v-220efdd8=\"\"></label>\n\t\t\t\t\t\t\t<div class=\"switch-btn-group\" _v-220efdd8=\"\">\n\t\t\t\t\t\t\t\t<label _v-220efdd8=\"\">\n\t\t\t\t\t\t\t\t\t<input type=\"checkbox\" v-model=\"contract.sell_end_day_switch\" _v-220efdd8=\"\"> 管理結束販售日期\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t<div class=\"count-group\" v-show=\"contract.sell_end_day_switch\" style=\"position: relative;\" _v-220efdd8=\"\">\n                                    <v-datepicker v-model=\"contract.sell_end_day\" placeholder=\"請輸入日期\" calendar-class=\"contact-modal-calendar\" _v-220efdd8=\"\"></v-datepicker>  \n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"group-input\" v-show=\"checkDisplay('people_purchase_limit')\" _v-220efdd8=\"\">\n\t\t\t\t\t\t\t<label _v-220efdd8=\"\"></label>\n\t\t\t\t\t\t\t<div class=\"switch-btn-group\" _v-220efdd8=\"\">\n\t\t\t\t\t\t\t\t<label _v-220efdd8=\"\">\n\t\t\t\t\t\t\t\t\t<input type=\"checkbox\" v-model=\"contract.people_purchase_limit_switch\" _v-220efdd8=\"\"> 限制每人可購買次數\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t<div class=\"count-group\" v-show=\"contract.people_purchase_limit_switch\" _v-220efdd8=\"\">\n\t\t\t\t\t\t\t\t\t<input type=\"number\" maxlength=\"6\" id=\"people_purchase_limit\" placeholder=\"請輸入數量限制\" class=\"form-control\" v-model=\"contract.people_purchase_limit\" _v-220efdd8=\"\">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n                        <div class=\"group-input\" _v-220efdd8=\"\">\n                            <label for=\"name\" _v-220efdd8=\"\">\n                                \n                            </label>\n                            <div _v-220efdd8=\"\">\n                                <div _v-220efdd8=\"\">\n                                    <label _v-220efdd8=\"\">\n                                        <input type=\"checkbox\" v-bind:true-value=\"1\" v-bind:false-value=\"0\" v-model=\"contract.enable_external_link\" _v-220efdd8=\"\"> 顯示外部連結按鈕\n                                    </label>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"group-input\" v-show=\"contract.enable_external_link\" _v-220efdd8=\"\">\n                            <label for=\"name\" _v-220efdd8=\"\">\n                                \n                            </label>\n                            <div _v-220efdd8=\"\">\n                                <v-select-external-link-item :studio-id=\"studioId\" v-model=\"contract.external_link_object\" :default-id=\"contract.default_external_link_id\" _v-220efdd8=\"\"></v-select-external-link-item>\n                            </div>\n                        </div>\n                        <div class=\"group-input\" v-if=\"showTransfer\" _v-220efdd8=\"\">\n                            <label _v-220efdd8=\"\">\n                                \n                            </label>\n                            <div _v-220efdd8=\"\">\n                                <label _v-220efdd8=\"\">\n                                    <input type=\"checkbox\" v-bind:true-value=\"1\" v-bind:false-value=\"0\" v-model=\"contract.enable_member_transfer\" _v-220efdd8=\"\"> 允許客戶在線上進行轉贈操作\n                                </label>\n                            </div>\n                        </div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n            </div>\n        </div>\n        <div slot=\"footer\" _v-220efdd8=\"\">\n\t\t\t<button v-show=\"canRemoveContract\" @click=\"deleteContract\" type=\"button\" class=\"btn btn-danger\" style=\"position:absolute;left: 10px;\" _v-220efdd8=\"\">刪除</button>\n\t\t\t<button type=\"button\" class=\"btn btn-default\" @click=\"clone\" v-show=\"updateMode\" _v-220efdd8=\"\">複製</button>\n\t\t\t<button type=\"button\" class=\"btn btn-primary\" @click=\"submitContract\" :disabled=\"ajaxing.submit\" v-show=\"canSubmit\" _v-220efdd8=\"\">\n\t\t\t\t<span v-show=\"!ajaxing.submit\" _v-220efdd8=\"\">{{ modal.submitWord }}</span>\n\t\t\t\t<i v-show=\"ajaxing.submit\" class=\"fa fa-spin fa-spinner\" _v-220efdd8=\"\"></i>\n\t\t\t</button>\n\t\t</div>\n        </v-modal>\n    \t<webadmin-special-contract-modal v-if=\"studioId\" :studio-id=\"studioId\" :branch-id=\"branchId\" @submit=\"specialContractSubmit\" _v-220efdd8=\"\"></webadmin-special-contract-modal>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.reset_flex[_v-220efdd8] {\n  -ms-flex: none;\n      flex: none; }\n\n/* line 6, stdin */\n.label-subtitle[_v-220efdd8] {\n  font-size: 0.5em;\n  color: #7a7a7a; }\n\n/* line 11, stdin */\n.setting-tooltip[_v-220efdd8] {\n  position: relative;\n  display: inline-block; }\n\n/* line 16, stdin */\n.setting-tooltip .tooltiptext[_v-220efdd8] {\n  visibility: hidden;\n  width: 120px;\n  background-color: #606060;\n  color: #fff;\n  text-align: center;\n  border-radius: 6px;\n  padding: 5px 0;\n  position: absolute;\n  z-index: 1;\n  bottom: 150%;\n  left: 50%;\n  margin-left: -60px; }\n\n/* line 31, stdin */\n.setting-tooltip .tooltiptext[_v-220efdd8]::after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  margin-left: -5px;\n  border-width: 5px;\n  border-style: solid;\n  border-color: #606060 transparent transparent transparent; }\n\n/* line 42, stdin */\n.setting-tooltip:hover .tooltiptext[_v-220efdd8] {\n  visibility: visible; }\n\n/* line 2, stdin */\n.contact-modal-calendar {\n  top: -280px;\n  right: -45px; }\n\n/* line 8, stdin */\n.contract-modal-vue textarea {\n  margin: 0; }\n\n/* line 12, stdin */\n.contract-modal-vue .primary-color {\n  background-color: #38b0e3; }\n\n/* line 17, stdin */\n.contract-modal-vue .nav-pills .active a {\n  background-color: #38b0e3; }\n\n/* line 21, stdin */\n.contract-modal-vue .nav-pills :not(.active) a {\n  color: #38b0e3; }\n\n/* line 25, stdin */\n.contract-modal-vue .time_span_group {\n  display: -ms-flexbox;\n  display: flex; }\n  /* line 27, stdin */\n  .contract-modal-vue .time_span_group #time_span_group {\n    -ms-flex: 1;\n        flex: 1; }\n  /* line 30, stdin */\n  .contract-modal-vue .time_span_group .search-btn {\n    width: 40px;\n    max-width: 40px;\n    padding-left: 10px; }\n    /* line 34, stdin */\n    .contract-modal-vue .time_span_group .search-btn div {\n      background-color: #38b0e3;\n      color: white;\n      border-radius: 3px;\n      cursor: pointer; }\n      /* line 39, stdin */\n      .contract-modal-vue .time_span_group .search-btn div i {\n        display: block;\n        padding: 9px; }\n\n/* line 46, stdin */\n.contract-modal-vue .class_list {\n  display: -ms-flexbox;\n  display: flex; }\n  /* line 48, stdin */\n  .contract-modal-vue .class_list .list-box {\n    border: 1px solid #000;\n    border-top: none;\n    height: 250px;\n    max-height: 250px; }\n    /* line 53, stdin */\n    .contract-modal-vue .class_list .list-box .list-search {\n      padding: 5px; }\n    /* line 56, stdin */\n    .contract-modal-vue .class_list .list-box .list {\n      margin-right: 5px;\n      height: 200px;\n      overflow-y: auto; }\n  /* line 62, stdin */\n  .contract-modal-vue .class_list .item {\n    padding: 5px;\n    cursor: pointer; }\n    /* line 65, stdin */\n    .contract-modal-vue .class_list .item:hover {\n      background-color: #eee; }\n  /* line 69, stdin */\n  .contract-modal-vue .class_list .waiting,\n  .contract-modal-vue .class_list .selected {\n    -ms-flex: 1;\n        flex: 1; }\n    /* line 72, stdin */\n    .contract-modal-vue .class_list .waiting .title,\n    .contract-modal-vue .class_list .selected .title {\n      border: 1px solid #000;\n      padding: 5px;\n      padding-left: 10px;\n      text-align: left; }\n  /* line 79, stdin */\n  .contract-modal-vue .class_list .sep {\n    border-top: 1px solid #000;\n    border-bottom: 1px solid #000;\n    background-color: #e1e1e1;\n    width: 20px;\n    max-width: 20px; }\n\n/* line 88, stdin */\n.contract-modal-vue .group-input {\n  min-height: 34px;\n  margin-bottom: 20px;\n  display: -ms-flexbox;\n  display: flex; }\n  /* line 93, stdin */\n  .contract-modal-vue .group-input label {\n    width: 160px; }\n    /* line 96, stdin */\n    .contract-modal-vue .group-input label span {\n      color: red; }\n  /* line 101, stdin */\n  .contract-modal-vue .group-input label.setting, .contract-modal-vue .group-input label.branch {\n    width: inherit; }\n  /* line 105, stdin */\n  .contract-modal-vue .group-input div {\n    -ms-flex: 1;\n        flex: 1; }\n  /* line 109, stdin */\n  .contract-modal-vue .group-input.branch-row {\n    margin-bottom: 0px; }\n\n/* line 114, stdin */\n.contract-modal-vue .switch-btn-group {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: baseline;\n      align-items: baseline; }\n  /* line 118, stdin */\n  .contract-modal-vue .switch-btn-group .btn-group {\n    width: 130px;\n    max-width: 130px; }\n  /* line 122, stdin */\n  .contract-modal-vue .switch-btn-group .count-group {\n    -ms-flex: 1;\n        flex: 1;\n    max-width: 130px; }\n\n@media (max-width: 1000px) {\n  /* line 129, stdin */\n  .contract-modal-vue .group-input {\n    display: block; } }\n\n/* line 134, stdin */\n.contract-modal-vue .admission-hint {\n  margin: -10px 0 0px; }\n\n@media (min-width: 768px) {\n  /* line 138, stdin */\n  .contract-modal-vue .display-switch {\n    text-align: right; } }\n\n/* line 142, stdin */\n.contract-modal-vue .display-switch label {\n  font-size: 14px; }\n\n/* line 147, stdin */\n.contract-modal-vue .func-bar {\n  margin-bottom: 15px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-220efdd8", module.exports)
  } else {
    hotAPI.update("_v-220efdd8", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1058:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n.time_span_duration{\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n}\n\n.endtime-modal-calendar{\n    right:90px;\n}\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vuex = require('vuex');

exports.default = {
    props: {
        contractGroupIds: {
            default: function _default() {
                return [];
            }
        },
        specialGroupId: {
            default: null
        },
        studioId: {
            require: true
        },
        defaultSelectedClass: {
            default: []
        },
        defaultClassList: {
            default: []
        },
        isClone: {
            default: false
        }
    },
    mounted: function mounted() {
        this.classList = this.defaultClassList;
        this.selectedClass = this.defaultSelectedClass;
    },
    data: function data() {
        return {
            yetSelectedFilter: '',
            ajaxScheduleList: false,
            selectedFilter: '',
            selectedClass: [],
            classList: [],
            startDate: new Date(),
            endDate: new Date(new Date().getTime() + 24 * 60 * 60 * 1000)
        };
    },

    watch: {
        selectedClass: function selectedClass(newVal) {
            this.$emit('select-class', newVal);
        },
        defaultClassList: function defaultClassList(newVal) {
            this.classList = newVal;
        },
        isClone: function isClone(newVal) {
            if (newVal) {
                this.clearSelectedClass();
            }
        }
    },
    computed: {
        yetSelectedClassList: function yetSelectedClassList() {
            var selectedIds = [];
            var array = [];
            if (this.selectedClass) {
                selectedIds = this.selectedClass.map(function (c) {
                    return c.id;
                });
            }
            if (this.classList) {
                array = this.classList.filter(function (item) {
                    return selectedIds.indexOf(item.id) == -1;
                }.bind(this));
            }
            var key = this.yetSelectedFilter;
            var field = 'name';
            if (key == '' || typeof key === 'undefined') return array;
            var reg = new RegExp(key.split('').join('.*'));
            return array.filter(function (item) {
                return reg.test(item[field]);
            });
        },
        selectedClassList: function selectedClassList() {
            var array = this.selectedClass;
            var key = this.selectedFilter;
            var field = 'name';
            if (key == '' || typeof key === 'undefined') return array;
            var reg = new RegExp(key.split('').join('.*'));
            return array.filter(function (item) {
                return reg.test(item[field]);
            });
        }
    },
    methods: {
        clearSelectedClass: function clearSelectedClass() {
            this.selectedClass = [];
        },
        addClass: function addClass(c) {
            this.selectedClass.push(c);
        },
        allAddClass: function allAddClass(c) {
            this.selectedClass = this.selectedClass.concat(c);
        },
        getClassList: function getClassList() {
            var _this = this;

            if (this.ajaxScheduleList) return;
            this.ajaxScheduleList = true;
            this.classList = [];
            this.clearSelectedClass();
            var contractGroupIds = this.contractGroupIds;
            if (this.specialGroupId !== null) {
                contractGroupIds.push(this.specialGroupId);
            }
            var params = {
                studio_id: this.studioId,
                start_date: moment(this.startDate).format('YYYY/MM/DD'),
                end_date: moment(this.endDate).format('YYYY/MM/DD'),
                contract_group_ids: contractGroupIds
            };
            this.ajaxScheduleList = true;

            this.$http.get('/api/schedule', { params: params }).then(function (response) {
                _this.classList = response.data;
                _this.ajaxScheduleList = false;
            }, function (error) {
                _this.ajaxScheduleList = false;

                $17.swal({
                    title: '讀取失敗。',
                    type: 'error'
                });
            });
        },
        removeClass: function removeClass(c) {
            this.selectedClass = this.selectedClass.filter(function (item) {
                return item != c;
            });
        },
        updateDate: function updateDate(data) {
            this[data.prop] = data.date;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div>\n    <div class=\"group-input\">\n        <label for=\"time_start\">日期</label>\n        <div class=\"time_span_group\">\n            <div class=\"time_span_duration\">\n                <v-datepicker v-model=\"startDate\" placeholder=\"開始日期\"></v-datepicker>\n                <v-datepicker v-model=\"endDate\" placeholder=\"結束日期\" calendar-class=\"endtime-modal-calendar\"></v-datepicker>\n            </div>\n            <div class=\"search-btn\">\n                <div>\n                    <i v-show=\"!ajaxScheduleList\" class=\"fa fa-search\" @click=\"getClassList\"></i>\n                    <i v-show=\"ajaxScheduleList\" class=\"fa fa-spin fa-spinner\"></i>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"group-input\">\n        <label>課程 <span>*</span></label>\n        <div class=\"class_list\">\n            <div class=\"waiting\">\n                <div class=\"title\">可選擇<a class=\"pull-right\" @click.prevent=\"allAddClass(yetSelectedClassList)\">全選</a></div>\n                <div class=\"list-box\">\n                    <div class=\"list-search\">\n                        <input type=\"text\" class=\"form-control\" placeholder=\"課程關鍵字...\" v-model=\"yetSelectedFilter\">\n                    </div>\n                    <div class=\"list\">\n                        <div v-for=\"c in yetSelectedClassList\" class=\"item\" @click=\"addClass(c)\">@{{ c.name }}</div>\n                        <div style=\"text-align:center;padding:5px;\">\n                            <v-spinner :ajaxing=\"ajaxScheduleList\">\n                                <span v-show=\"!ajaxScheduleList &amp;&amp; !yetSelectedClassList.length\">尚無可選擇之課程</span>\n                            </v-spinner>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"sep\"></div>\n            <div class=\"selected\">\n                <div class=\"title\">已選取<a class=\"pull-right\" @click.prevent=\"clearSelectedClass\">清除</a></div>\n                <div class=\"list-box\">\n                    <div class=\"list-search\">\n                        <input type=\"text\" class=\"form-control\" placeholder=\"課程關鍵字...\" v-model=\"selectedFilter\">\n                    </div>\n                    <div class=\"list\">\n                        <div v-for=\"c in selectedClassList\" class=\"item\" @click=\"removeClass(c)\">@{{ c.name }}</div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n.time_span_duration{\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n}\n\n.endtime-modal-calendar{\n    right:90px;\n}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-3be350b2", module.exports)
  } else {
    hotAPI.update("_v-3be350b2", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1059:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _special_contract_modal = require('./special_contract_modal.vue');

var _special_contract_modal2 = _interopRequireDefault(_special_contract_modal);

var _contract_modal = require('./contract_modal.vue');

var _contract_modal2 = _interopRequireDefault(_contract_modal);

var _contract_time_span = require('./contract_time_span.vue');

var _contract_time_span2 = _interopRequireDefault(_contract_time_span);

var _admission_span = require('./admission_span.vue');

var _admission_span2 = _interopRequireDefault(_admission_span);

var _promote_setting = require('./promote_setting.vue');

var _promote_setting2 = _interopRequireDefault(_promote_setting);

var _ckFinderModel = require('./ckFinderModel.vue');

var _ckFinderModel2 = _interopRequireDefault(_ckFinderModel);

var _ckEditor = require('./ckEditor.vue');

var _ckEditor2 = _interopRequireDefault(_ckEditor);

var _transferContractSetting = require('./transfer-contract-setting.vue');

var _transferContractSetting2 = _interopRequireDefault(_transferContractSetting);

var _branch_admission_item = require('./branch_admission_item.vue');

var _branch_admission_item2 = _interopRequireDefault(_branch_admission_item);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('webadmin-special-contract-modal', _special_contract_modal2.default);

//item   

_vue2.default.component('webadmin-contract-modal', _contract_modal2.default);
_vue2.default.component('webadmin-contract-time-span', _contract_time_span2.default);
_vue2.default.component('webadmin-admission-span', _admission_span2.default);
_vue2.default.component('webadmin-promote-setting', _promote_setting2.default);
_vue2.default.component('ck-finder-model', _ckFinderModel2.default);
_vue2.default.component('ck-editor', _ckEditor2.default);
_vue2.default.component('webadmin-transfer-contract-setting', _transferContractSetting2.default);

//item
_vue2.default.component('webadmin-branch-admission-item', _branch_admission_item2.default);

},{"./admission_span.vue":1053,"./branch_admission_item.vue":1054,"./ckEditor.vue":1055,"./ckFinderModel.vue":1056,"./contract_modal.vue":1057,"./contract_time_span.vue":1058,"./promote_setting.vue":1060,"./special_contract_modal.vue":1061,"./transfer-contract-setting.vue":1062,"vue":792}],1060:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.edit-contract-promo-container[_v-06cad4e9] {\n  max-width: 850px;\n  margin: 0.5em 3em; }\n\n/* line 6, stdin */\n.display-flex-center[_v-06cad4e9] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center; }\n\n/* line 10, stdin */\n.border-bottom-style[_v-06cad4e9] {\n  border-bottom: 1px solid #454545; }\n\n/* line 13, stdin */\n.promo-img[_v-06cad4e9] {\n  padding: 0.5em 0.5em;\n  width: 100%;\n  height: auto; }\n\n/* line 18, stdin */\n.selected-border[_v-06cad4e9] {\n  border: 5px solid;\n  padding: 0 !important; }\n\n/* line 22, stdin */\n.img-dropdown-menu[_v-06cad4e9] {\n  left: 1.6em; }\n\n/* line 25, stdin */\n.promotion-img-container[_v-06cad4e9] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap; }\n  /* line 28, stdin */\n  .promotion-img-container div[_v-06cad4e9] {\n    -ms-flex: 0 0 33%;\n        flex: 0 0 33%; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _vuex = require('vuex');

var _ckeditor5BuildClassic = require('@ckeditor/ckeditor5-build-classic');

var _ckeditor5BuildClassic2 = _interopRequireDefault(_ckeditor5BuildClassic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            loadImage: false,
            ajaxing: false,
            promote_images: {},
            contract_id: 0,
            savingEditorData: false,
            editor_data: '',
            origin_contract_info: [],
            contract_info: [],
            mainTagId: [],
            //multiselect
            tag17fit: [],
            tagOptions: [],
            primaryTag: [],
            selected17fitTag: [],
            selectedTag: [],
            selectedPrimaryTag: [],
            config: {
                rootFolder: 'contract_promote',
                removeModules: 'RenameFile,FilesMoveCopy,CreateFolder,DeleteFolder'
            }
        };
    },
    mounted: function mounted() {
        this.contract_id = this.urlValue();
        this.getPromoteImage(this.contract_id);
        this.getPromotionData();
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'isSeventeen', 'isStudio', 'isBranch']), {
        disablePost: function disablePost() {
            if (this.promote_images == '' || !this.contract_info.promotion_title || this.selectedPrimaryTag == '') {
                return true;
            };
            return false;
        }
    }),
    methods: {
        urlValue: function urlValue() {
            var pathName = window.location.pathname;
            var pathArray = pathName.split("/");
            return pathArray.pop();
        },
        getPromoteImage: function getPromoteImage(contract_id) {
            var _this = this;

            this.loadImage = true;
            this.$http.get('/adminapi/contract-promote/get-image/' + contract_id).then(function (response) {
                _this.loadImage = false;
                var result = response.data;
                _this.promote_images = result;
            }, function (error) {
                _this.alert('讀取方案圖片失敗', error.data.message, 'error', false);
            });
        },
        insertImage: function insertImage(image) {
            var _this2 = this;

            this.loadImage = true;
            var postData = {
                "file_name": image.name,
                "s3_url": image.url,
                "contract_id": this.contract_id,
                "studio_id": this.studioId
            };

            this.$http.post('/adminapi/contract-promote/insert-image', postData).then(function (response) {
                _this2.loadImage = false;
                _this2.getPromoteImage(_this2.contract_id);
            }, function (error) {
                _this2.loadImage = false;
                _this2.alert('新增失敗', error.data.message, 'error', false);
            });
        },
        setPrimary: function setPrimary(item) {
            var _this3 = this;

            this.$http.put('/adminapi/contract-promote/set-image-primary', item).then(function (response) {
                _this3.getPromoteImage(item.contract_id);
            }, function (error) {
                _this3.loadImage = false;
                _this3.alert('更新失敗', error.data.message, 'error', false);
            });
        },
        deleteImage: function deleteImage(id) {
            var _this4 = this;

            this.$http.delete('/adminapi/contract-promote/delete-image/' + id).then(function (response) {
                _this4.getPromoteImage(_this4.contract_id);
            }, function (error) {
                _this4.loadImage = false;
                _this4.alert('刪除失敗', error.data.message, 'error', false);
            });
        },
        getPromotionData: function getPromotionData() {
            var _this5 = this;

            var vm = this;
            this.ajaxing = true;
            this.$http.get('/adminapi/contract-tag/index').then(function (response) {
                vm.prepareMultiSelect(response.data);
                _this5.ajaxing = false;
            }, function (error) {
                _this5.ajaxing = false;
                _this5.alert('取得標籤列表失敗', error.data.message, 'error', false);
            }).then(function () {
                vm.getAdvancedContract(_this5.contract_id);
            });
        },
        prepareMultiSelect: function prepareMultiSelect(data) {
            var _this6 = this;

            this.primaryTag = [];
            this.tag17fit = [];
            this.tagOptions = [];

            var vm = this;
            data.categories.forEach(function (category) {
                _this6.mainTagId.push(category.primary_tag_id);
            });
            data.tags.forEach(function (element) {
                if (_this6.mainTagId.includes(element.id)) {
                    vm.primaryTag.push(element);
                } else if (element.allow_branch_select == 0) {
                    vm.tag17fit.push(element);
                } else {
                    vm.tagOptions.push(element);
                };
            });
        },
        getAdvancedContract: function getAdvancedContract(contract_id) {
            var _this7 = this;

            //reset data
            this.selected17fitTag = [];
            this.selectedTag = [];
            this.selectedPrimaryTag = [];

            var vm = this;
            this.ajaxing = true;
            this.$http.get('/adminapi/contract-promote/' + contract_id).then(function (response) {
                _this7.origin_contract_info = JSON.parse((0, _stringify2.default)(response.data));;
                _this7.contract_info = response.data;
                _this7.editor_data = response.data.content;
                response.data.contract_tag.forEach(function (element) {
                    if (_this7.mainTagId.includes(element.id)) {
                        vm.selectedPrimaryTag.push(element);
                    } else if (element.allow_branch_select == 0) {
                        vm.selected17fitTag.push(element);
                    } else {
                        vm.selectedTag.push(element);
                    };
                });
                _this7.ajaxing = false;
            }, function (error) {
                _this7.ajaxing = false;
                _this7.alert('讀取方案資料失敗', error.data.message, 'error', false);
            });
        },
        watchCkEditor: function watchCkEditor(data) {
            this.editor_data = data;
        },
        clickSubmit: function clickSubmit(mode) {
            this.savingEditorData = true;
            switch (mode) {
                case 'close':
                    this.contract_info.is_active = 0;
                    break;
                case 'active':
                    this.contract_info.is_active = 1;
                    break;
            }
        },
        getEditorDataAndSave: function getEditorDataAndSave(data) {
            this.ajaxSave();
            this.editor_data = data;
            this.savingEditorData = false;
        },
        ajaxSave: function ajaxSave() {
            var _this8 = this;

            if (this.disablePost) {
                this.alert('儲存錯誤', '主標題&特色圖為必填', 'error', false);
                return false;
            };
            this.ajaxing = true;
            var vm = this;
            var postData = this.getPostData();
            this.$http.post('/adminapi/contract-promote/save', { data: postData }).then(function (response) {
                _this8.ajaxing = false;
                $17.swal({
                    title: '儲存成功',
                    type: 'success',
                    showCancelButton: false
                });
                vm.getAdvancedContract(_this8.contract_id);
            }, function (error) {
                _this8.ajaxing = false;
                _this8.alert('儲存', error.data.message, 'error', false);
            });
        },
        getPostData: function getPostData() {
            var postData = {
                id: this.urlValue(), //contract id
                promotion_title: this.contract_info.promotion_title,
                notice: this.contract_info.notice ? this.contract_info.notice : '',
                content: this.editor_data ? this.editor_data : '',
                is_active: this.contract_info.is_active,
                contract_tags: []
            };
            if (this.selected17fitTag.length > 0 || this.selectedTag.length > 0) {
                this.selected17fitTag.concat(this.selectedTag).forEach(function (tag) {
                    postData.contract_tags.push(tag.id);
                });
            };
            this.selectedPrimaryTag.forEach(function (tag) {
                postData.contract_tags.push(tag.id);
            });
            return postData;
        },
        alert: function alert(title, message, type, showCancel) {
            $17.swal({
                title: title,
                text: message,
                type: type,
                showCancelButton: showCancel
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-06cad4e9=\"\">\n    <v-spinner :ajaxing=\"ajaxing\" _v-06cad4e9=\"\"></v-spinner>\n    <div class=\"edit-contract-promo-container\" v-show=\"!ajaxing\" _v-06cad4e9=\"\">\n        <div class=\"m-bottom-20 display-flex-center\" _v-06cad4e9=\"\">\n            <h1 class=\"m-top-10\" _v-06cad4e9=\"\">方案銷售頁設定</h1>\n            <div class=\"m-left-15\" _v-06cad4e9=\"\">\n                <button type=\"button\" class=\"btn btn-primary\" @click=\"clickSubmit('save')\" :disabled=\"disablePost\" _v-06cad4e9=\"\">儲存</button>\n                <button type=\"button\" class=\"btn btn-success\" @click=\"clickSubmit('active')\" :disabled=\"disablePost\" v-if=\"!contract_info.is_active\" _v-06cad4e9=\"\">啟用</button>\n                <button type=\"button\" class=\"btn btn-danger\" @click=\"clickSubmit('close')\" :disabled=\"disablePost\" v-else=\"\" _v-06cad4e9=\"\">停用</button>\n            </div>\n        </div>\n        <div class=\"border-bottom-style m-bottom-15\" _v-06cad4e9=\"\">\n            <div class=\"form-group row\" _v-06cad4e9=\"\">\n                <div class=\"col-sm-2\" _v-06cad4e9=\"\">品牌</div>\n                <div class=\"col-sm-10\" _v-06cad4e9=\"\">{{contract_info.studio}}</div>\n            </div>\n            <div class=\"form-group row\" _v-06cad4e9=\"\">\n                <div class=\"col-sm-2\" _v-06cad4e9=\"\">方案</div>\n                <div class=\"col-sm-10\" _v-06cad4e9=\"\">{{contract_info.contract_name}}</div>\n            </div>\n            <div class=\"form-group row\" _v-06cad4e9=\"\">\n                <div class=\"col-sm-2\" _v-06cad4e9=\"\">頁面狀態</div>\n                <div class=\"col-sm-10\" v-if=\"!contract_info.is_active\" _v-06cad4e9=\"\">未啟用</div>\n                <div class=\"col-sm-10\" v-else=\"\" _v-06cad4e9=\"\">已啟用</div>\n            </div>\n            <div class=\"form-group row\" _v-06cad4e9=\"\">\n                <div class=\"col-sm-2\" _v-06cad4e9=\"\">銷售場館</div>\n                <div class=\"col-sm-10\" _v-06cad4e9=\"\">\n                    <div v-for=\"(branch, index) in contract_info.branch\" :key=\"index\" _v-06cad4e9=\"\">\n                        <div class=\"m-bottom-10\" _v-06cad4e9=\"\">{{branch.branch_name}}</div>\n                        <div class=\"display-flex-center m-bottom-10\" _v-06cad4e9=\"\">\n                            <input type=\"text\" class=\"form-control\" :placeholder=\"branch.promotion_url\" disabled=\"\" _v-06cad4e9=\"\">\n                            <button type=\"button\" class=\"btn btn-secondary\" _v-06cad4e9=\"\">\n                                <a :href=\"branch.promotion_url\" target=\"_blank\" _v-06cad4e9=\"\">前往查看</a>\n                            </button>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"border-bottom-style m-bottom-15\" _v-06cad4e9=\"\">\n            <div class=\"form-group row\" _v-06cad4e9=\"\">\n                <div class=\"col-sm-2\" _v-06cad4e9=\"\">主標題<span style=\"color: red;\" _v-06cad4e9=\"\">*</span></div>\n                <div class=\"col-sm-10\" _v-06cad4e9=\"\">\n                    <input type=\"text\" class=\"form-control\" maxlength=\"30\" v-model=\"contract_info.promotion_title\" _v-06cad4e9=\"\">\n                </div>\n            </div>\n            <div class=\"form-group row\" _v-06cad4e9=\"\">\n                <div class=\"col-sm-2\" _v-06cad4e9=\"\">特色圖<span style=\"color: red;\" _v-06cad4e9=\"\">*</span></div>\n                <div class=\"col-sm-10\" _v-06cad4e9=\"\">\n                    <ck-finder-model @setting-image=\"insertImage\" @reload=\"getPromoteImage(contract_id)\" :config=\"config\" :picture-size-verification=\"true\" _v-06cad4e9=\"\"></ck-finder-model>\n                    <span class=\"m-left-10\" _v-06cad4e9=\"\">*請先將圖片比例裁切為4:3  \n                        <a target=\"_blank\" href=\"https://17fithelp.zendesk.com/hc/zh-tw/articles/900002612703\" _v-06cad4e9=\"\">教學請點我</a>\n                    </span>\n                </div>\n            </div>\n\n            <div class=\"form-group row\" _v-06cad4e9=\"\">\n                <div class=\"col-sm-2\" _v-06cad4e9=\"\"></div>\n                <div class=\"col-sm-10\" _v-06cad4e9=\"\">\n                    <v-spinner :ajaxing=\"loadImage\" _v-06cad4e9=\"\"></v-spinner>\n                    <div class=\"promotion-img-container\" _v-06cad4e9=\"\">\n                        <div class=\"dropdown p-left-0 p-right-0\" v-for=\"(item,index) in promote_images\" v-show=\"!loadImage\" _v-06cad4e9=\"\">\n                            <img :src=\"item.s3_url\" :class=\"['dropdown-toggle', 'promo-img', item.is_primary == 1 ? 'selected-border' : '']\" type=\"button\" :id=\"'menu' + item.id\" data-toggle=\"dropdown\" _v-06cad4e9=\"\">\n                            <ul class=\"dropdown-menu img-dropdown-menu\" :aria-labelledby=\"'menu' + item.id\" _v-06cad4e9=\"\">\n                                <li _v-06cad4e9=\"\"><a href=\"#\" @click=\"setPrimary(item)\" _v-06cad4e9=\"\">設為主要</a></li>\n                                <li _v-06cad4e9=\"\"><a href=\"#\" @click=\"deleteImage(item.id)\" _v-06cad4e9=\"\">刪除</a></li>\n                            </ul>\n                        </div>                            \n                    </div>\n\n                </div>\n            </div>\n            <div class=\"form-group row\" _v-06cad4e9=\"\">\n                <div class=\"col-sm-2\" _v-06cad4e9=\"\">方案說明</div>\n                <div class=\"col-sm-10\" _v-06cad4e9=\"\">\n                    <textarea class=\"form-control\" rows=\"5\" :placeholder=\"contract_info.description\" disabled=\"\" _v-06cad4e9=\"\"></textarea>\n                </div>\n            </div>\n            <div class=\"form-group row\" _v-06cad4e9=\"\">\n                <div class=\"col-sm-2\" _v-06cad4e9=\"\">注意事項</div>\n                <div class=\"col-sm-10\" _v-06cad4e9=\"\">\n                    <textarea class=\"form-control\" rows=\"5\" v-model=\"contract_info.notice\" _v-06cad4e9=\"\"></textarea>\n                </div>\n            </div>\n            <div class=\"form-group row\" _v-06cad4e9=\"\">\n                <div class=\"col-sm-2\" _v-06cad4e9=\"\">分類<span style=\"color: red;\" _v-06cad4e9=\"\">*</span></div>\n                <div class=\"col-sm-10\" _v-06cad4e9=\"\">\n                    <v-mutiselect :multiple=\"true\" :options=\"primaryTag\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :searchable=\"false\" track-by=\"id\" label=\"name\" tag-name=\"name\" placeholder=\"請選擇\" :model.sync=\"selectedPrimaryTag\" _v-06cad4e9=\"\">\n                    </v-mutiselect>\n                </div>\n            </div>\n            <div class=\"form-group row\" _v-06cad4e9=\"\">\n                <div class=\"col-sm-2\" _v-06cad4e9=\"\">標籤</div>\n                <div class=\"col-sm-10\" _v-06cad4e9=\"\">\n                    <v-mutiselect :multiple=\"true\" :options=\"tagOptions\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :searchable=\"false\" track-by=\"id\" label=\"name\" tag-name=\"name\" placeholder=\"請選擇\" :model.sync=\"selectedTag\" _v-06cad4e9=\"\">\n                    </v-mutiselect>\n                </div>\n            </div>\n            <div class=\"form-group row\" _v-06cad4e9=\"\">\n                <div class=\"col-sm-2\" _v-06cad4e9=\"\">17FIT標籤</div>\n                <div class=\"col-sm-10\" _v-06cad4e9=\"\">\n                    <v-mutiselect :multiple=\"true\" :options=\"tag17fit\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :searchable=\"false\" :disabled=\"!isSeventeen\" track-by=\"id\" label=\"name\" tag-name=\"name\" placeholder=\"請選擇\" :model.sync=\"selected17fitTag\" _v-06cad4e9=\"\">\n                    </v-mutiselect>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"m-bottom-50\" _v-06cad4e9=\"\">\n            <div class=\"m-bottom-10\" _v-06cad4e9=\"\">詳細介紹</div>\n            <ck-editor :click-save=\"savingEditorData\" :init-editor-data=\"editor_data\" @update-ck-editor-data=\"getEditorDataAndSave\" @watch-ck-editor=\"watchCkEditor\" _v-06cad4e9=\"\"></ck-editor>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.edit-contract-promo-container[_v-06cad4e9] {\n  max-width: 850px;\n  margin: 0.5em 3em; }\n\n/* line 6, stdin */\n.display-flex-center[_v-06cad4e9] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center; }\n\n/* line 10, stdin */\n.border-bottom-style[_v-06cad4e9] {\n  border-bottom: 1px solid #454545; }\n\n/* line 13, stdin */\n.promo-img[_v-06cad4e9] {\n  padding: 0.5em 0.5em;\n  width: 100%;\n  height: auto; }\n\n/* line 18, stdin */\n.selected-border[_v-06cad4e9] {\n  border: 5px solid;\n  padding: 0 !important; }\n\n/* line 22, stdin */\n.img-dropdown-menu[_v-06cad4e9] {\n  left: 1.6em; }\n\n/* line 25, stdin */\n.promotion-img-container[_v-06cad4e9] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap; }\n  /* line 28, stdin */\n  .promotion-img-container div[_v-06cad4e9] {\n    -ms-flex: 0 0 33%;\n        flex: 0 0 33%; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-06cad4e9", module.exports)
  } else {
    hotAPI.update("_v-06cad4e9", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"@ckeditor/ckeditor5-build-classic":1,"babel-runtime/core-js/json/stringify":48,"babel-runtime/helpers/extends":66,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1061:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n.class-select{\n    max-height: 200px;\n}\n.modal-fix-height{\n    min-height:350px;\n}\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        studioId: {},
        branchId: {}

    },
    data: function data() {
        return {
            special_contract_group: [],
            specialGroup: {
                id: '',
                name: ''
            },
            isService: 0,
            ajaxing: false
        };
    },

    filters: {},
    watch: {
        isService: function isService(newVal) {
            this.getSpecialContractGroupList();
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('filters', ['selected_branch_id']), (0, _vuex.mapState)('webadmin/configure', ['isBranch', 'isSeventeen']), {
        placeHolder: function placeHolder() {
            return this.ajaxing ? '讀取中...' : '請選擇';
        }
    }),
    methods: {
        submitSpecialGroup: function submitSpecialGroup() {
            this.$emit('submit', this.specialGroup);
            $(this.$el).modal('hide');
            this.reset();
        },
        getSpecialContractGroupList: function getSpecialContractGroupList() {
            var _this = this;

            this.reset();
            this.special_contract_group = [];
            var params = {
                studio_id: this.studioId,
                branch_id: this.selected_branch_id || this.branchId,
                is_service: this.isService
            };

            var queryString = 'studio_id=' + params.studio_id + '&branch_id=' + params.branch_id + '&is_service=' + params.is_service;
            this.ajaxing = true;
            this.$http.get('/api/schedule/special_contract_group', { params: params }).then(function (response) {
                _this.special_contract_group = response.body;
                _this.ajaxing = false;
            }, function (error) {
                _this.ajaxing = false;

                $17.swal({
                    title: '讀取失敗。',
                    type: 'error'
                });
            });
        },
        reset: function reset() {
            this.specialGroup = {
                id: '',
                name: ''
            };
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal id=\"special_contract-modal\" :save-clicked=\"submitSpecialGroup\" confirm-btn-text=\"確認\" :close-modal-event=\"reset\">\n     <div slot=\"title\">選擇項目</div>\n     <div slot=\"body\">\n        <div class=\"modal-fix-height\">\n            <div class=\"group-input\">\n                <v-select-studio-and-branch :studio_id=\"studioId\" :branch_id=\"branchId\" :branch-without-filtered-option=\"false\" :branch-change-call-back=\"getSpecialContractGroupList\"></v-select-studio-and-branch>\n            </div>\n            <div class=\"group-input\">\n                <div class=\"switch-btn-group\">\n                    <label style=\"display: inline-block;width: 60px;\">\n                        <input type=\"radio\" :value=\"0\" v-model=\"isService\"> 課程\n                    </label>\n                    <label style=\"display: inline-block;width: 60px;\">\n                        <input type=\"radio\" :value=\"1\" v-model=\"isService\"> 服務\n                    </label>\n                </div>\n            </div>\n            <div class=\"class-select\">\n                <v-spinner-button :ajaxing=\"ajaxing\"></v-spinner-button>\n                <v-mutiselect v-show=\"!ajaxing\" :model.sync=\"specialGroup\" :options=\"special_contract_group\" :multiple=\"false\" :close-on-select=\"true\" :clear-on-select=\"true\" :searchable=\"true\" :max-height=\"150\" label=\"name\" track-by=\"id\" tag-name=\"name\" :placeholder=\"placeHolder\"></v-mutiselect>\n            </div>\n        </div>\n     </div>\n </v-modal>\n\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n.class-select{\n    max-height: 200px;\n}\n.modal-fix-height{\n    min-height:350px;\n}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-168c21c4", module.exports)
  } else {
    hotAPI.update("_v-168c21c4", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1062:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            ajaxing: {
                fetch: true,
                save: false
            },
            disabledSave: false,
            postData: {
                account_system_id: null,
                open_account_system: 0
            }
        };
    },
    mounted: function mounted() {
        this.fetch();
    },

    watch: {
        selected_studio_id: function selected_studio_id() {
            this.fetch();
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId', 'isBranch']), (0, _vuex.mapState)('filters', ['selected_studio_id'])),
    methods: {
        fetch: function fetch() {
            var _this = this;

            if (!this.selected_studio_id) {
                this.ajaxing.fetch = false;
                return;
            }
            this.ajaxing.fetch = true;

            this.$http.get('/adminapi/contract-transfer/setting/studio/' + this.selected_studio_id).then(function (response) {
                _this.postData.open_account_system = response.data.data.open_account_system;
                _this.postData.account_system_id = response.data.data.account_system.id;

                _this.ajaxing.fetch = false;
            }).catch(function (response) {
                _this.ajaxing.fetch = false;
            });
        },
        save: function save() {
            var _this2 = this;

            this.ajaxing.save = true;
            var postData = this.postData;

            this.$http.post('/adminapi/contract-transfer/setting/studio/' + this.selected_studio_id, postData).then(function (response) {
                _this2.fetch();
                _this2.alert('success', '儲存成功');
                _this2.ajaxing.save = false;
            }).catch(function (response) {
                _this2.alert('error', '儲存失敗', response.data.message);
                _this2.ajaxing.save = false;
            });
        },
        alert: function alert(type, title) {
            var text = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
            var html = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

            $17.swal({
                title: title,
                text: text,
                type: type,
                html: html,
                showCancelButton: false
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-3badff4f=\"\">\n    <v-spinner :ajaxing=\"ajaxing.fetch\" _v-3badff4f=\"\"></v-spinner>\n    <v-multiselect-studio-and-branch :studio_id=\"studioId\" :show-branch=\"false\" v-show=\"!ajaxing.fetch\" _v-3badff4f=\"\"></v-multiselect-studio-and-branch>\n    <div class=\"col-xs-12 m-bottom-50\" v-if=\"!ajaxing.fetch\" _v-3badff4f=\"\">\n        <h3 _v-3badff4f=\"\">品牌設定</h3>\n        <div class=\"form-horizontal\" _v-3badff4f=\"\">\n            <div class=\"form-group\" _v-3badff4f=\"\">\n                <label class=\"col-sm-3 control-label\" _v-3badff4f=\"\">客戶方案轉贈</label>\n                <div class=\"col-sm-7\" _v-3badff4f=\"\">\n                    <v-bs-switch v-model=\"postData.open_account_system\" id=\"open_account_system\" _v-3badff4f=\"\"></v-bs-switch>\n                </div> \n            </div>\n        </div>\n\n        <div class=\"text-center m-top-50\" _v-3badff4f=\"\">\n            <button class=\"btn btn-primary\" :disabled=\"disabledSave\" @click.prevent=\"save()\" _v-3badff4f=\"\">儲存</button>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-3badff4f", module.exports)
  } else {
    hotAPI.update("_v-3badff4f", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vuex":803}],1063:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _index = require('./index.vue');

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('contract-tag-management', _index2.default);

},{"./index.vue":1064,"vue":792}],1064:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.contract-tag-edit-btn[_v-0b282bf6] {\n  margin-top: 10px;\n  margin-bottom: 15px;\n  margin-left: 15px; }\n\n/* line 7, stdin */\n.header-bottom-line[_v-0b282bf6] {\n  margin: 10px 7px 10px 0px;\n  border-bottom: 3px solid #454545; }\n\n/* line 11, stdin */\n.row-bottom-line[_v-0b282bf6] {\n  margin: 10px 7px 10px 0px;\n  border-bottom: 1px solid #e6e6e6; }\n\n/* line 15, stdin */\n.number-input[_v-0b282bf6] {\n  width: 4.5em; }\n\n/* line 18, stdin */\n.contract-tag-img[_v-0b282bf6] {\n  margin-bottom: 10px;\n  width: 10em;\n  height: 100%; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            ajaxing: false,
            create_tag: {
                imgUploaded: false,
                name: '',
                order: '',
                tagCategories: [],
                allowBranchSelect: false,
                imageUrl: ''
            },
            update_tag: [],
            tagCategoriesOptions: []
        };
    },
    mounted: function mounted() {
        this.fetch();
    },
    computed: {},
    methods: {
        fetch: function fetch() {
            var _this = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this.resetData();

                            case 2:
                                _context.next = 4;
                                return _this.fetchCategories();

                            case 4:
                                _context.next = 6;
                                return _this.fetchContractTag();

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        resetData: function resetData() {
            this.create_tag.imgUploaded = false;
            this.create_tag.name = '';
            this.create_tag.order = '';
            this.create_tag.tagCategories = [], this.create_tag.allowBranchSelect = false;
            this.create_tag.imageUrl = '';
        },
        fetchCategories: function fetchCategories() {
            var _this2 = this;

            this.tagCategoriesOptions = [];
            this.ajaxing = true;
            this.$http.get('/adminapi/contract-tag/contract-tag-categories').then(function (response) {
                _this2.ajaxing = false;
                _this2.tagCategoriesOptions = response.data;
            }, function (error) {
                _this2.ajaxing = false;
            });
        },
        fetchContractTag: function fetchContractTag() {
            var _this3 = this;

            this.ajaxing = true;
            this.$http.get('/adminapi/contract-tag/index').then(function (response) {
                _this3.prepareTagList(response.data);
                _this3.ajaxing = false;
            }, function (error) {
                _this3.ajaxing = false;
            });
        },
        prepareTagList: function prepareTagList(data) {
            var vm = this;
            this.update_tag = [];
            var primaryTagId = [];
            data.categories.forEach(function (category) {
                primaryTagId.push(category.primary_tag_id);
            });
            data.tags.forEach(function (element) {
                if (!primaryTagId.includes(element.id)) {
                    vm.update_tag.push(element);
                };
            });
        },
        createContractTag: function createContractTag() {
            var _this4 = this;

            this.ajaxing = true;
            var postData = {
                name: this.create_tag.name,
                order: this.create_tag.order,
                allow_branch_select: this.create_tag.allowBranchSelect == true ? 1 : 0,
                contract_tag_image: this.create_tag.imageUrl,
                contract_tag_category: []
            };
            this.create_tag.tagCategories.forEach(function (item) {
                postData.contract_tag_category.push(item.id);
            });
            this.$http.post('/adminapi/contract-tag/create', postData).then(function (response) {
                _this4.alert('新增標籤', '新增成功', 'success');
                _this4.fetch();
            }, function (error) {
                _this4.alert('新增標籤', '新增失敗', 'warning');
                _this4.ajaxing = false;
            });
        },
        updateContractTag: function updateContractTag() {
            var _this5 = this;

            this.ajaxing = true;
            this.update_tag.forEach(function (tag) {
                var arr = [];
                tag.contract_tag_category.forEach(function (item) {
                    arr.push(item.id);
                });
                tag.contract_tag_category = arr;
                tag.allow_branch_select = tag.allow_branch_select == true ? 1 : 0;
            });
            var postData = this.update_tag;
            this.$http.patch('/adminapi/contract-tag/update', { data: postData }).then(function (response) {
                _this5.fetch();
                _this5.alert('更新標籤', '儲存成功', 'success');
            }, function (error) {
                _this5.alert('更新標籤', '儲存失敗', 'warning');
                _this5.ajaxing = false;
            });
        },
        deleteContractTag: function deleteContractTag(tagId) {
            var _this6 = this;

            this.ajaxing = true;
            this.$http.delete('/adminapi/contract-tag/' + tagId).then(function (response) {
                _this6.fetch();
                _this6.alert('刪除標籤', '刪除成功', 'success');
            }, function (error) {
                _this6.alert('刪除標籤', '刪除失敗', 'warning');
                _this6.ajaxing = false;
            });
        },
        uploadImage: function uploadImage(tagId) {
            var vm = this;
            $('#picture' + tagId).change(function () {
                var _this7 = this;

                $17.imageCropToString({
                    image: $("#picture" + tagId).prop('files')[0],
                    inputId: 'picture' + tagId,
                    width: 400,
                    height: 400,
                    cropBtnClass: 'btn btn--cta primary-business-color-background primary-business-color-background-hover',
                    reUploadBtnClass: 'invisible',
                    showCropCircle: true,
                    callback: function () {
                        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(imageString) {
                            return _regenerator2.default.wrap(function _callee2$(_context2) {
                                while (1) {
                                    switch (_context2.prev = _context2.next) {
                                        case 0:
                                            vm.ajaxing = true;

                                            if (!(imageString == 'fail crop')) {
                                                _context2.next = 4;
                                                break;
                                            }

                                            vm.ajaxing = false;
                                            return _context2.abrupt('return', false);

                                        case 4:
                                            _context2.next = 6;
                                            return vm.$http.post('/adminapi/contract-tag/image/' + tagId, { data: imageString });

                                        case 6:
                                            vm.fetch();

                                        case 7:
                                        case 'end':
                                            return _context2.stop();
                                    }
                                }
                            }, _callee2, _this7);
                        }));

                        return function callback(_x) {
                            return _ref.apply(this, arguments);
                        };
                    }()
                });
            });
        },
        deleteImage: function deleteImage(tagId) {
            var _this8 = this;

            this.ajaxing = true;
            this.$http.delete('/adminapi/contract-tag/image/' + tagId).then(function (response) {
                _this8.fetch();
                _this8.alert('刪除圖片', '刪除成功', 'success');
            }, function (error) {
                _this8.alert('刪除標籤', '刪除失敗', 'warning');
                _this8.ajaxing = false;
            });
        },
        alert: function alert(title, message, type, showCancelBtn) {
            $17.swal({
                title: title,
                text: message,
                type: type,
                showCancelButton: false,
                showLoaderOnConfirm: true
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-0b282bf6=\"\">\n    <v-spinner :ajaxing=\"ajaxing\" _v-0b282bf6=\"\"></v-spinner>\n    <div v-show=\"!ajaxing\" _v-0b282bf6=\"\">\n        <div _v-0b282bf6=\"\">\n            <button type=\"button\" class=\"btn btn-success contract-tag-edit-btn\" @click=\"createContractTag\" _v-0b282bf6=\"\">新增</button>\n            <div class=\"container\" _v-0b282bf6=\"\">\n                <div class=\"row header-bottom-line\" _v-0b282bf6=\"\">\n                    <div class=\"col-sm-2\" _v-0b282bf6=\"\">標籤名稱</div>\n                    <div class=\"col-sm-1\" _v-0b282bf6=\"\">排序</div>\n                    <div class=\"col-sm-3\" _v-0b282bf6=\"\">類別</div>\n                    <div class=\"col-sm-2\" _v-0b282bf6=\"\">允許店家選取</div>\n                    <div class=\"col-sm-4\" _v-0b282bf6=\"\"></div>\n                </div>\n                <div class=\"row\" _v-0b282bf6=\"\">\n                    <div class=\"col-sm-2\" _v-0b282bf6=\"\">\n                        <input type=\"text\" placeholder=\"名稱\" class=\"form-control input-sm\" v-model=\"create_tag.name\" _v-0b282bf6=\"\">\n                    </div>\n                    <div class=\"col-sm-1\" _v-0b282bf6=\"\">\n                        <input type=\"number\" value=\"排序\" class=\"input-sm number-input\" v-model=\"create_tag.order\" min=\"0\" _v-0b282bf6=\"\">\n                    </div>\n                    <div class=\"col-sm-3\" _v-0b282bf6=\"\">\n                        <v-mutiselect :multiple=\"true\" :options=\"tagCategoriesOptions\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :searchable=\"false\" track-by=\"id\" label=\"name\" tag-name=\"name\" placeholder=\"請選擇\" :model.sync=\"create_tag.tagCategories\" _v-0b282bf6=\"\">\n                        </v-mutiselect>\n                    </div>\n                    <div class=\"col-sm-2\" _v-0b282bf6=\"\">\n                        <input type=\"checkbox\" v-model=\"create_tag.allowBranchSelect\" _v-0b282bf6=\"\">\n                    </div>\n                    <div class=\"col-sm-4\" _v-0b282bf6=\"\">\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div _v-0b282bf6=\"\">\n            <button type=\"button\" class=\"btn btn-info contract-tag-edit-btn\" @click=\"updateContractTag\" _v-0b282bf6=\"\">儲存</button>\n            <div class=\"container\" _v-0b282bf6=\"\">\n                <div class=\"row header-bottom-line\" _v-0b282bf6=\"\">\n                    <div class=\"col-sm-2\" _v-0b282bf6=\"\">標籤名稱</div>\n                    <div class=\"col-sm-1\" _v-0b282bf6=\"\">排序</div>\n                    <div class=\"col-sm-3\" _v-0b282bf6=\"\">類別</div>\n                    <div class=\"col-sm-2\" _v-0b282bf6=\"\">允許店家選取</div>\n                    <div class=\"col-sm-3\" _v-0b282bf6=\"\"></div>\n                    <div class=\"col-sm-1\" _v-0b282bf6=\"\"></div>\n                </div>\n                <div class=\"row m-bottom-10 row-bottom-line\" v-for=\"(tag,index) in update_tag\" :key=\"index\" _v-0b282bf6=\"\">\n                    <div class=\"col-sm-2\" _v-0b282bf6=\"\">\n                        <input type=\"text\" placeholder=\"名稱\" class=\"form-control input-sm\" v-model=\"tag.name\" _v-0b282bf6=\"\">\n                    </div>\n                    <div class=\"col-sm-1\" _v-0b282bf6=\"\">\n                        <input type=\"number\" value=\"排序\" class=\"input-sm number-input\" v-model=\"tag.order\" min=\"0\" _v-0b282bf6=\"\">\n                    </div>\n                    <div class=\"col-sm-3 m-bottom-10\" _v-0b282bf6=\"\">\n                        <v-mutiselect :multiple=\"true\" :options=\"tagCategoriesOptions\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :searchable=\"false\" track-by=\"id\" label=\"name\" tag-name=\"name\" placeholder=\"請選擇\" :model.sync=\"tag.contract_tag_category\" _v-0b282bf6=\"\">\n                        </v-mutiselect>\n                    </div>\n                    <div class=\"col-sm-1\" _v-0b282bf6=\"\">\n                        <input type=\"checkbox\" v-model=\"tag.allow_branch_select\" _v-0b282bf6=\"\">\n                    </div>\n                    <div class=\"col-sm-3 text-center\" _v-0b282bf6=\"\">\n                        <div class=\"form-inline text-center\" v-if=\"tag.contract_tag_image\" _v-0b282bf6=\"\">\n                            <div class=\"form-group\" _v-0b282bf6=\"\">\n                                <img :src=\"tag.contract_tag_image\" class=\"contract-tag-img\" _v-0b282bf6=\"\">\n                            </div>\n                            <div class=\"form-group\" _v-0b282bf6=\"\">\n                                <button type=\"button\" class=\"btn btn-sm btn-muted\" @click=\"deleteImage(tag.id)\" _v-0b282bf6=\"\">刪除</button>\n                            </div>\n                        </div>\n                        <div @click.once=\"uploadImage(tag.id)\" v-else=\"\" _v-0b282bf6=\"\">\n                            <label :for=\"'picture'+tag.id\" class=\"btn btn-sm btn-primary\" _v-0b282bf6=\"\">圖片上傳</label>\n                            <input :id=\"'picture'+tag.id\" :name=\"'picture'+tag.id\" type=\"file\" style=\"visibility:hidden;\" accept=\"image/gif, image/jpeg, image/png, image/jpg, image/x-icon\" _v-0b282bf6=\"\">\n                        </div>\n                    </div>\n                    <div class=\"col-sm-2 text-center\" _v-0b282bf6=\"\">\n                        <button type=\"button\" class=\"btn btn-sm btn-danger\" @click=\"deleteContractTag(tag.id)\" _v-0b282bf6=\"\">刪除標籤</button>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n\n</div>    \n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.contract-tag-edit-btn[_v-0b282bf6] {\n  margin-top: 10px;\n  margin-bottom: 15px;\n  margin-left: 15px; }\n\n/* line 7, stdin */\n.header-bottom-line[_v-0b282bf6] {\n  margin: 10px 7px 10px 0px;\n  border-bottom: 3px solid #454545; }\n\n/* line 11, stdin */\n.row-bottom-line[_v-0b282bf6] {\n  margin: 10px 7px 10px 0px;\n  border-bottom: 1px solid #e6e6e6; }\n\n/* line 15, stdin */\n.number-input[_v-0b282bf6] {\n  width: 4.5em; }\n\n/* line 18, stdin */\n.contract-tag-img[_v-0b282bf6] {\n  margin-bottom: 10px;\n  width: 10em;\n  height: 100%; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-0b282bf6", module.exports)
  } else {
    hotAPI.update("_v-0b282bf6", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1065:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n.title[_v-5a0a59be] {\n    font-size: 14px;\n}\n.gray-text[_v-5a0a59be] {\n    font-size: 12px;\n    color:rgb(141, 140, 140);\n}\n.table-status[_v-5a0a59be] {\n    color: white;\n    display: inline-block;\n    text-align: center;\n    vertical-align: middle;\n    padding: 6px 15px;\n    border: 0px solid #ffffff;\n    border-radius: 100px;\n}\n.active[_v-5a0a59be] {\n    background-color: #00b306; \n}\n.disabled[_v-5a0a59be] {\n    background-color: #C8C8C8; \n}\n.table-cursor[_v-5a0a59be] {\n    cursor:pointer;\n}\n.expired[_v-5a0a59be] {\n    display: inline-block;\n    text-align: center;\n    vertical-align: middle;\n    padding: 0px 4px;\n    border: 1px solid #f50000;\n    border-radius: 4px;\n    background: #ffffff;\n    background: -webkit-gradient(linear, left top, left bottom, from(#ffffff), to(#ffffff));\n    background: -moz-linear-gradient(top, #ffffff, #ffffff);\n    background: linear-gradient(to bottom, #ffffff, #ffffff);\n    font: normal normal normal 10px arial;\n    color: #ff002b;\n    text-decoration: none;\n}\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _mapState;

var _vuex = require('vuex');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            modal: {
                title: '',
                name: ''
            },
            view: {
                items: [],
                ajaxing: false,
                action: 'create',
                show_content: false,
                contracts: [],
                tickets: [],
                products: [],
                tags: []
            }
        };
    },
    watch: {
        selectedBranchId: function selectedBranchId(val, old) {
            if (val === null || val === '' || val === 0) {
                this.findName(this.selectedStudioId, 'studio');
            } else {
                this.findName(val, 'branch');
            }
            this.getList();
        }
    },
    mounted: function mounted() {
        var _this = this;

        $('#coupon-modal').on('hidden.bs.modal', function (e) {
            _this.$refs.coupon_modal.resetForm();
        });
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)((_mapState = {
        studioId: function studioId(state) {
            return state.webadmin.configure.studioId;
        },
        branchId: function branchId(state) {
            return state.webadmin.configure.branchId;
        },
        studioOptions: function studioOptions(state) {
            return state.filters.studioOptions;
        },
        branchOptions: function branchOptions(state) {
            return state.filters.branchOptions;
        },
        selectedBranchId: function selectedBranchId(state) {
            return state.filters.selected_branch_id;
        },
        selectedStudioId: function selectedStudioId(state) {
            return state.filters.selected_studio_id;
        }
    }, (0, _defineProperty3.default)(_mapState, 'selectedBranchId', function selectedBranchId(state) {
        return state.filters.selected_branch_id;
    }), (0, _defineProperty3.default)(_mapState, 'is17fit', function is17fit(state) {
        return state.is_17fit;
    }), _mapState))),
    methods: {
        getList: function getList() {
            var _this2 = this;

            this.view.items = [];
            this.view.ajaxing = true;
            this.$http.get('/adminapi/coupons?studio_id=' + this.selectedStudioId + '&branch_id=' + this.selectedBranchId).then(function (response) {
                if (response.body.length > 0) {
                    _this2.view.items = response.body;
                    _this2.view.show_content = true;
                }
                _this2.view.ajaxing = false;
            }, function (error) {
                _this2.view.ajaxing = false;
            });
            branch_id = this.selectedBranchId === null || this.selectedBranchId === 0 || this.selectedBranchId === 'null' ? '&branch_id=0' : '&branch_id=' + this.selectedBranchId;
            this.$http.get('/adminapi/studio_branch_resources/contracts?studio_id=' + this.selectedStudioId + branch_id).then(function (response) {
                if (response.body.length > 0) {
                    _this2.view.contracts = response.body;
                }
                _this2.view.ajaxing = false;
            }, function (error) {
                _this2.view.ajaxing = false;
            });
            this.$http.get('/adminapi/studio_branch_resources/tickets?studio_id=' + this.selectedStudioId + branch_id).then(function (response) {
                if (response.body.length > 0) {
                    _this2.view.tickets = response.body;
                }
                _this2.view.ajaxing = false;
            }, function (error) {
                _this2.view.ajaxing = false;
            });
            this.$http.get('/adminapi/studio_branch_resources/products?studio_id=' + this.selectedStudioId + branch_id).then(function (response) {
                if (response.body.length > 0) {
                    _this2.view.products = response.body;
                    _this2.view.show_content = true;
                }
                _this2.view.ajaxing = false;
            }, function (error) {
                _this2.view.ajaxing = false;
            });
            this.$http.get('/adminapi/studio_branch_resources/tags?studio_id=' + this.selectedStudioId).then(function (response) {
                if (response.body.length > 0) {
                    _this2.view.tags = response.body;
                    _this2.view.show_content = true;
                }
                _this2.view.ajaxing = false;
            }, function (error) {
                _this2.view.ajaxing = false;
            });
        },
        getTypeName: function getTypeName(type) {
            return type === '1' || type === 1 ? '促銷' : '優惠券';
        },
        getStatusName: function getStatusName(status, isExpired) {
            if (isExpired === '1' || isExpired === 1) {
                return '停止';
            }
            return status === '1' || status === 1 ? '啟用' : '停止';
        },
        getStatusClass: function getStatusClass(status, isExpired) {
            if (isExpired === '1' || isExpired === 1) {
                return 'disabled';
            }
            return status === '1' || status === 1 ? 'active' : 'disabled';
        },
        checkTypeReturnValue: function checkTypeReturnValue(type, value) {
            return type === '2' || type === 2 ? value : '-';
        },
        checkDateReturnValue: function checkDateReturnValue(isNeverEnd, date) {
            return isNeverEnd === '1' || isNeverEnd === 1 ? '-' : date;
        },
        showModal: function showModal(item, action) {
            if (this.selectedBranchId === null || this.selectedBranchId === '') {
                $17.swal({
                    title: '場館為必填欄位',
                    type: 'warning'
                });
            } else {
                if (action === 'update') {
                    this.modal.title = '編輯' + item.name;
                    this.$refs.coupon_view_modal.onCall(item.id);
                    $('#coupon-view-modal').modal('show');
                } else {
                    this.modal.title = '新增優惠';
                    this.$refs.coupon_modal.onCall(item, action);
                    $('#coupon-modal').modal('show');
                }
            }
        },
        makeCodes: function makeCodes() {
            var _this3 = this;

            this.view.ajaxing = true;
            this.$http.get('/adminapi/coupons/codes').then(function (response) {
                _this3.view.ajaxing = false;
                alert('產生優惠碼成功');
            }, function (error) {
                _this3.view.ajaxing = false;
                alert('產生優惠碼發生錯誤');
            });
        },
        refresh: function refresh() {
            this.view.ajaxing = true;
            this.getList();
        },
        findName: function findName(id, type) {
            var vm = this;
            if (type === 'studio') {
                _lodash2.default.forEach(this.studioOptions, function (studio) {
                    if (studio.id === id) {
                        vm.modal.name = studio.brand_name;
                    }
                });
            } else {
                _lodash2.default.forEach(this.branchOptions, function (branch) {
                    if (branch.id === id) {
                        vm.modal.name = branch.branch_name;
                    }
                });
            }
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n    <div class=\"content-inner\" _v-5a0a59be=\"\">\n    <v-select-studio-and-branch :studio_id=\"studioId\" :branch_id=\"branchId\" :branch-without-filtered-option=\"true\" branch-without-filtered-option-word=\"品牌優惠\" _v-5a0a59be=\"\"></v-select-studio-and-branch>\n        <h4 _v-5a0a59be=\"\">\n            <button type=\"button\" class=\"btn btn-success\" @click=\"showModal(null, 'create')\" _v-5a0a59be=\"\">\n                <i class=\"fa fa-plus\" _v-5a0a59be=\"\"></i>\n                新增優惠\n            </button>\n            <button v-if=\"is17fit === true\" type=\"button\" class=\"btn btn-success\" @click=\"makeCodes()\" _v-5a0a59be=\"\">\n                產生1000筆優惠碼\n            </button>\n        </h4>\n        <v-spinner :ajaxing=\"view.ajaxing\" _v-5a0a59be=\"\"></v-spinner>\n        <div v-show=\"!view.ajaxing &amp;&amp; view.show_content\" _v-5a0a59be=\"\"> \n            <table id=\"coupon-list\" class=\"table table-hover\" _v-5a0a59be=\"\">\n                <thead _v-5a0a59be=\"\">\n                    <tr _v-5a0a59be=\"\"><th class=\"text-center\" _v-5a0a59be=\"\">名稱</th>\n                    <th class=\"text-center\" _v-5a0a59be=\"\">使用</th>\n                    <th class=\"text-center\" _v-5a0a59be=\"\">開始</th>\n                    <th class=\"text-center\" _v-5a0a59be=\"\">結束</th>\n                    <th class=\"text-center\" _v-5a0a59be=\"\">狀態</th>\n                </tr></thead>\n                <tbody _v-5a0a59be=\"\">\n                    <tr @click.prevent=\"showModal(item, 'update')\" class=\"top-border table-cursor\" v-for=\"item in view.items\" _v-5a0a59be=\"\">\n                        <td class=\"col-lg-3\" _v-5a0a59be=\"\">\n                            <div class=\"m-bottom-10 clearfix\" _v-5a0a59be=\"\"><span class=\"pull-left title\" _v-5a0a59be=\"\">{{ item.name }}</span></div>\n                            <div class=\"gray-text\" _v-5a0a59be=\"\"><span _v-5a0a59be=\"\">{{ getTypeName(item.type) }}</span><span v-if=\"item.type === '2' || item.type === 2\" _v-5a0a59be=\"\">: {{item.code}}</span> <span class=\"m-left-10 expired\" v-if=\"item.is_expired === '1'\" _v-5a0a59be=\"\">已過期</span></div>\n                        </td>\n                        <td class=\"col-lg-1 text-center\" _v-5a0a59be=\"\">\n                            {{ checkTypeReturnValue(item.type, item.used_count) }}\n                        </td>\n                        <td class=\"col-lg-3 text-center\" _v-5a0a59be=\"\">\n                            {{ item.start_date }}\n                        </td>\n                        <td class=\"col-lg-3 text-center\" _v-5a0a59be=\"\">\n                            {{ checkDateReturnValue(item.is_never_end, item.end_date) }}\n                        </td>\n                        <td class=\"col-lg-2 text-center\" _v-5a0a59be=\"\"><span :class=\"getStatusClass(item.is_active, item.is_expired)\" class=\"table-status\" _v-5a0a59be=\"\">{{ getStatusName(item.is_active, item.is_expired) }}</span></td>\n                    </tr>\n                </tbody>\n            </table>\n        </div>\n        <coupon-modal @refresh=\"refresh\" :tags=\"view.tags\" :contracts=\"view.contracts\" :tickets=\"view.tickets\" :products=\"view.products\" ref=\"coupon_modal\" :name=\"modal.name\" :title=\"modal.title\" :studio-id=\"selectedStudioId\" :branch-id=\"selectedBranchId\" _v-5a0a59be=\"\"></coupon-modal>\n        <coupon-view-modal @refresh=\"refresh\" ref=\"coupon_view_modal\" :contracts=\"view.contracts\" :name=\"modal.name\" :title=\"modal.title\" :studio-id=\"selectedStudioId\" :branch-id=\"selectedBranchId\" _v-5a0a59be=\"\"></coupon-view-modal>\n    <div _v-5a0a59be=\"\">\n</div></div>"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n.title[_v-5a0a59be] {\n    font-size: 14px;\n}\n.gray-text[_v-5a0a59be] {\n    font-size: 12px;\n    color:rgb(141, 140, 140);\n}\n.table-status[_v-5a0a59be] {\n    color: white;\n    display: inline-block;\n    text-align: center;\n    vertical-align: middle;\n    padding: 6px 15px;\n    border: 0px solid #ffffff;\n    border-radius: 100px;\n}\n.active[_v-5a0a59be] {\n    background-color: #00b306; \n}\n.disabled[_v-5a0a59be] {\n    background-color: #C8C8C8; \n}\n.table-cursor[_v-5a0a59be] {\n    cursor:pointer;\n}\n.expired[_v-5a0a59be] {\n    display: inline-block;\n    text-align: center;\n    vertical-align: middle;\n    padding: 0px 4px;\n    border: 1px solid #f50000;\n    border-radius: 4px;\n    background: #ffffff;\n    background: -webkit-gradient(linear, left top, left bottom, from(#ffffff), to(#ffffff));\n    background: -moz-linear-gradient(top, #ffffff, #ffffff);\n    background: linear-gradient(to bottom, #ffffff, #ffffff);\n    font: normal normal normal 10px arial;\n    color: #ff002b;\n    text-decoration: none;\n}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-5a0a59be", module.exports)
  } else {
    hotAPI.update("_v-5a0a59be", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/defineProperty":65,"babel-runtime/helpers/extends":66,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1066:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n.pac-container {\n    z-index: 2000;\n}\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vuex = require('vuex');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['studioId', 'branchId', 'title', 'name', 'contracts', 'tickets', 'products', 'tags'],
    data: function data() {
        return {
            studio_id: 0,
            view: {
                ajaxing: false,
                canSubmit: true,
                action: 'create'
            },
            is_never_end: false,
            model: {
                id: null,
                name: '',
                type: '1',
                is_using_together: false,
                code_id: 0,
                code: '',
                discount_type: 2,
                discount_value: 1,
                start_date: null,
                end_date: null,
                start_hour: '00',
                end_hour: '00',
                start_minute: '00',
                end_minute: '00',
                range_use_type: 1,
                select_contracts: [],
                select_tickets: [],
                select_products: [],
                select_white_tags: [],
                select_black_tags: [],
                min_price: 0,
                member_use_type: 1,
                use_restriction_type: 1,
                usage_count: 1,
                max_usage_type: 1,
                max_usage_count: 0,
                is_active: 1
            }
        };
    },

    filters: {
        uppercase: function uppercase(v) {
            return v.toUpperCase();
        }
    },
    watch: {
        is_never_end: function is_never_end(val, old) {
            this.$refs.vdate.setNeverEnd(val);
        }
    },
    computed: {
        start_date: function start_date() {
            return this.model.start_date + ' ' + this.model.start_hour + ':' + this.model.start_minute;
        },
        end_date: function end_date() {
            return this.model.end_date + ' ' + this.model.end_hour + ':' + this.model.end_minute;
        }
    },
    methods: {
        /*getCode: function () {
            this.view.ajaxing = true;
            this.$http.get('/adminapi/coupons/get_code' + '?studio_id=' + this.studioId)
                .then((response) => {
                    var code = response.body;
                    this.model.code_id = code.code_id;
                    this.model.code = code.code;
                    _.delay(() => {this.view.ajaxing = false;}, 400);
                }, (error) => {
                    $17.swal({
                        title: error.body.message,
                        type: 'warning'
                    });
                    this.view.ajaxing = false;
                });
        },*/
        show: function show(id) {
            var _this = this;

            this.view.ajaxing = true;
            this.$http.get('/adminapi/coupons/' + id).then(function (response) {
                var coupon = response.body;
                _this.model.id = coupon.id;
                _this.model.name = coupon.name;
                _this.model.code = coupon.code;
                _this.model.type = coupon.type;
                _this.is_never_end = coupon.is_never_end;
                _this.model.is_using_together = coupon.is_using_together;
                _this.model.discount_type = coupon.discount_type;
                _this.model.discount_value = coupon.discount_value;
                _this.model.start_date = coupon.start_date;
                _this.model.end_date = coupon.end_date;
                _this.$refs.vdate.setStartDate(coupon.start_date);
                _this.$refs.vdate.setStartHour(coupon.start_hour);
                _this.$refs.vdate.setStartMinute(coupon.start_minute);
                _this.$refs.vdate.setEndDate(coupon.end_date);
                _this.$refs.vdate.setEndHour(coupon.end_hour);
                _this.$refs.vdate.setEndMinute(coupon.end_minute);
                _this.model.range_use_type = coupon.range_use_type;
                _this.model.select_contracts = coupon.select_contracts;
                _this.model.select_tickets = coupon.select_tickets;
                _this.model.select_products = coupon.select_products;
                _this.model.select_white_tags = coupon.select_white_tags;
                _this.model.select_black_tags = coupon.select_black_tags;
                _this.model.min_price = coupon.min_price;
                _this.model.member_use_type = coupon.member_use_type;
                _this.model.use_restriction_type = coupon.use_restriction_type;
                _this.model.usage_count = coupon.usage_count;
                _this.model.max_usage_type = coupon.max_usage_type;
                _this.model.max_usage_count = coupon.max_usage_count;
                _this.model.is_active = coupon.is_active;

                _lodash2.default.delay(function () {
                    _this.view.ajaxing = false;
                }, 400);
            }, function (error) {
                $17.swal({
                    title: error.body.message,
                    type: 'warning'
                });
                _this.view.ajaxing = false;
            });
        },
        creating: function creating() {
            var _this2 = this;

            this.view.ajaxing = true;
            this.$http.post('/adminapi/coupons', {
                name: this.model.name,
                type: this.model.type,
                is_never_end: this.is_never_end === true ? 1 : 0,
                is_using_together: this.model.is_using_together === true ? 1 : 0,
                discount_type: this.model.discount_type,
                discount_value: this.model.discount_value,
                start_date: this.start_date,
                end_date: this.end_date,
                range_use_type: this.model.range_use_type,
                select_contracts: this.model.select_contracts,
                select_tickets: this.model.select_tickets,
                select_products: this.model.select_products,
                select_white_tags: this.model.select_white_tags,
                select_black_tags: this.model.select_black_tags,
                min_price: this.model.min_price,
                member_use_type: this.model.member_use_type,
                use_restriction_type: this.model.use_restriction_type,
                usage_count: this.model.usage_count,
                max_usage_type: this.model.max_usage_type,
                max_usage_count: this.model.max_usage_count,
                is_active: this.model.is_active,
                studio_id: this.studioId,
                branch_id: this.branchId
            }).then(function (response) {
                _this2.resetForm();
                _this2.view.ajaxing = false;
                _this2.$emit('refresh');
                $('#coupon-modal').modal('hide');
            }, function (error) {
                $17.swal({
                    title: error.body.message,
                    type: 'warning'
                });
                _this2.view.ajaxing = false;
            });
        },
        resetForm: function resetForm() {
            this.model.id = null;
            this.model.name = '';
            this.model.code_id = 0;
            this.model.type = 1;
            this.is_never_end = false;
            this.model.is_using_together = false;
            this.model.code = '';
            this.model.discount_type = 1;
            this.model.discount_value = 0;
            this.model.start_date = null;
            this.model.end_date = null;
            this.model.start_hour = '00';
            this.model.end_hour = '00';
            this.model.start_minute = '00';
            this.model.end_minute = '00';
            this.$refs.vdate.setStartDate('');
            this.$refs.vdate.setEndDate('');
            this.$refs.vdate.setStartHour('00');
            this.$refs.vdate.setEndHour('00');
            this.$refs.vdate.setStartMinute('00');
            this.$refs.vdate.setEndMinute('00');
            this.model.range_use_type = 1;
            this.model.select_contracts = [];
            this.model.select_tickets = [];
            this.model.select_products = [];
            this.model.select_white_tags = [];
            this.model.select_black_tags = [];
            this.model.min_price = 0;
            this.model.member_use_type = 1;
            this.model.use_restriction_type = 1;
            this.model.usage_count = 1;
            this.model.max_usage_type = 1;
            this.model.max_usage_count = 0;
            this.model.is_active = 1;
        },

        deleting: function deleting() {
            var _this3 = this;

            this.view.ajaxing = true;
            this.$http.delete('/adminapi/coupons/' + this.model.id).then(function (response) {
                _this3.view.ajaxing = false;
                _this3.$emit('refresh');
                $('#coupon-modal').modal('hide');
            }, function (error) {
                _this3.view.ajaxing = false;
            });
        },
        updating: function updating() {
            var _this4 = this;

            this.view.ajaxing = true;
            this.$http.patch('/adminapi/coupons/' + this.model.id, {
                name: this.model.name,
                type: this.model.type,
                is_never_end: this.is_never_end,
                is_using_together: this.model.is_using_together,
                discount_type: this.model.discount_type,
                discount_value: this.model.discount_value,
                start_date: this.start_date,
                end_date: this.end_date,
                range_use_type: this.model.range_use_type,
                select_contracts: this.model.select_contracts,
                select_tickets: this.model.select_tickets,
                select_products: this.model.select_products,
                select_white_tags: this.model.select_white_tags,
                select_black_tags: this.model.select_black_tags,
                min_price: this.model.min_price,
                member_use_type: this.model.member_use_type,
                use_restriction_type: this.model.use_restriction_type,
                usage_count: this.model.usage_count,
                max_usage_type: this.model.max_usage_type,
                max_usage_count: this.model.max_usage_count,
                is_active: this.model.is_active,
                studio_id: this.studioId,
                branch_id: this.branchId
            }).then(function (response) {
                _this4.view.ajaxing = false;
                _this4.resetForm();
                _this4.$emit('refresh');
                $('#coupon-modal').modal('hide');
            }, function (error) {
                _this4.view.ajaxing = false;
            });
        },
        onCall: function onCall(id, action) {
            this.view.action = action;
            if (action === 'update') {
                this.model.id = id;
                this.view.showButton = true;
                this.show(this.model.id);
            } else if (action === 'create') {
                //this.getCode();
                this.view.showButton = false;
            }
        },
        submitCoupon: function submitCoupon() {
            this.view.canSubmit = true;
            this.checkRequire();
            if (this.view.canSubmit === false) {
                $17.swal({
                    title: '還有必填欄位尚未填寫或是日期設置不正確',
                    type: 'warning'
                });
                this.view.ajaxing = false;
                return false;
            }
            if (!this.isPositiveInteger(this.model.discount_value)) {
                $17.swal({
                    title: '優惠輸入不正確',
                    text: "只接受整數，不接受 (負數、小數點、字元)",
                    type: 'error'
                });
                this.view.ajaxing = false;
                return false;
            }

            if (this.view.action === 'update') {
                this.updating();
            } else {
                this.creating();
            }
        },
        isPositiveInteger: function isPositiveInteger(n) {
            return (/^\+?[0-9][\d]*$/.test(n)
            );
        },
        checkRequire: function checkRequire() {
            if (this.model.name === '' || isNaN(this.model.discount_value) || isNaN(this.model.min_price)) {
                this.view.canSubmit = false;
            }
            if (this.model.type === '2') {
                if (isNaN(this.model.usage_count) || isNaN(this.model.max_usage_count)) {
                    this.view.canSubmit = false;
                }
            }
            this.checkDate();
        },
        checkDate: function checkDate() {
            if (this.is_never_end === true) {
                if (this.model.start_date === '') {
                    this.view.canSubmit = false;
                }
            } else {
                if (this.model.start_date === '' || this.model.end_date === '') {
                    this.view.canSubmit = false;
                }
            }
            var today = new Date();
            start_date = new Date(this.start_date);
            end_date = new Date(this.end_date);
            if (end_date <= start_date || end_date <= today) {
                this.view.canSubmit = false;
            }
        },
        refreshStartDate: function refreshStartDate(date) {
            this.model.start_date = date;
        },
        refreshEndDate: function refreshEndDate(date) {
            this.model.end_date = date;
        },
        refreshStartHour: function refreshStartHour(hour) {
            this.model.start_hour = hour;
        },
        refreshEndHour: function refreshEndHour(hour) {
            this.model.end_hour = hour;
        },
        refreshStartMinute: function refreshStartMinute(minute) {
            this.model.start_minute = minute;
        },
        refreshEndMinute: function refreshEndMinute(minute) {
            this.model.end_minute = minute;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n    <div>\n        <div id=\"coupon-modal\" class=\"modal fade\" role=\"dialog\">\n            <div class=\"modal-dialog\">\n                <div class=\"modal-content\">\n                    <div class=\"modal-header\">\n                        <button type=\"button\" v-show=\"!view.ajaxing\" class=\"close\" data-dismiss=\"modal\">×</button>\n                        <h4 class=\"modal-title\">{{ title }}</h4>\n                    </div>\n                    <v-spinner :ajaxing=\"view.ajaxing\"></v-spinner>\n                    <div v-show=\"!view.ajaxing\" class=\"modal-body\">\n                            <div class=\"clearfix m-top-10\">\n                                <div class=\"clearfix\">\n                                    <label class=\"col-lg-3 col-md-3 col-xs-12 p-top-5 require\" for=\"name\">名稱 </label>\n                                    <div class=\"col-lg-9 col-md-9 col-xs-12\">\n                                        <input name=\"name\" v-model=\"model.name\" class=\"col-lg-9 col-md-9 col-xs-12 form-control\" type=\"text\" maxlength=\"50\">\n                                    </div>\n                                </div>\n\n                                <div class=\"clearfix\">\n                                    <label class=\"col-lg-3 col-md-3 col-xs-12 p-top-5 require\" for=\"\">類型 </label>\n                                    <div class=\"col-lg-9 col-md-9 col-xs-12\">\n                                        <div class=\"col-lg-12 col-md-12 col-xs-12\">\n                                            <input type=\"radio\" value=\"1\" name=\"type\" id=\"type1\" v-model=\"model.type\"><label class=\"m-left-5\" for=\"type1\">促銷</label>\n                                        </div>\n                                        <div class=\"col-lg-12 col-md-12 col-xs-12\">\n                                            <input type=\"radio\" value=\"2\" name=\"type\" id=\"type2\" v-model=\"model.type\"><label class=\"m-left-5\" for=\"type2\">優惠券</label>\n                                        </div>\n                                    </div>\n                                </div>\n\n                                <div v-if=\"model.type === '2'\" class=\"clearfix\">\n                                    <label class=\"col-lg-3 col-md-3 col-xs-12 p-top-5 require\" for=\"\"> </label>\n                                    <div class=\"col-lg-9 col-md-9 col-xs-12\">\n                                        <div class=\"col-lg-12 col-md-12 col-xs-12 p-top-5\">\n                                            <input type=\"checkbox\" value=\"1\" name=\"is_using_together\" id=\"is_using_together\" v-model=\"model.is_using_together\"><label class=\"m-left-5\" for=\"is_using_together\">可與其他優惠一起使用</label>\n                                        </div>\n                                    </div>\n                                </div>\n\n                                <hr>\n\n                                <div class=\"clearfix\">\n                                    <label class=\"col-lg-3 col-md-3 col-xs-12 p-top-5 require\" for=\"\">優惠方式 </label>\n                                    <div class=\"col-lg-9 col-md-9 col-xs-12\">\n                                        <div class=\"col-lg-12 col-md-12 col-xs-12\">\n                                            <input type=\"radio\" value=\"2\" name=\"discount_type\" id=\"discount_type2\" v-model=\"model.discount_type\"><label class=\"m-left-5\" for=\"discount_type2\">折扣比例</label>\n                                            <input min=\"1\" max=\"99\" v-if=\"model.discount_type === '2' || model.discount_type === 2\" style=\"height: 26px; padding: 3px;\" type=\"number\" v-model=\"model.discount_value\">％\n                                        </div>\n                                        <div class=\"col-lg-12 col-md-12 col-xs-12\">\n                                            <input type=\"radio\" value=\"1\" name=\"discount_type\" id=\"discount_type1\" v-model=\"model.discount_type\"><label class=\"m-left-5\" for=\"discount_type1\">折扣金額</label>\n                                            <input min=\"1\" v-if=\"model.discount_type === '1' || model.discount_type === 1\" style=\"height: 26px; padding: 3px;\" type=\"number\" v-model=\"model.discount_value\">\n                                        </div>\n                                    </div>\n                                </div>\n\n                                <hr>\n\n                                <div class=\"clearfix\">\n                                    <v-start-end-date type=\"datetime\" ref=\"vdate\" class=\"p-bottom-10 p-left-15\" @startdate=\"refreshStartDate\" @enddate=\"refreshEndDate\" @starthour=\"refreshStartHour\" @endhour=\"refreshEndHour\" @startminute=\"refreshStartMinute\" @endminute=\"refreshEndMinute\"></v-start-end-date>    \n                                     <div class=\"col-lg-12 col-md-12 col-xs-12 p-left-85\">\n                                        <input type=\"checkbox\" value=\"1\" name=\"is_never_end\" id=\"is_never_end\" v-model=\"is_never_end\"><label class=\"m-left-5\" for=\"is_never_end\">永不結束</label>\n                                    </div>                            \n                                </div>\n\n                                <hr>\n\n                                <div class=\"clearfix m-top-5 m-bottom-5\">\n                                    <label class=\"col-lg-3 col-md-3 col-xs-12 p-top-5 require\" for=\"\">適用範圍 </label>\n                                    <div class=\"col-lg-9 col-md-9 col-xs-12\">\n                                        <div class=\"col-lg-12 col-md-12 col-xs-12\">\n                                            <input type=\"radio\" value=\"1\" name=\"range_use_type\" id=\"range_use_type1\" v-model=\"model.range_use_type\"><label class=\"m-left-5\" for=\"range_use_type1\">全部項目</label>\n                                        </div>\n                                        <div class=\"col-lg-12 col-md-12 col-xs-12\">\n                                            <div class=\"m-bottom-10\"><input type=\"radio\" value=\"2\" name=\"range_use_type\" id=\"range_use_type2\" v-model=\"model.range_use_type\"><label class=\"m-left-5\" for=\"range_use_type2\">指定項目</label></div>\n                                            <div v-show=\"model.range_use_type === '2' || model.range_use_type === 2\" class=\"col-lg-12 col-md-12 col-xs-12\">\n                                                <div>\n                                                    <v-mutiselect :model.sync=\"model.select_contracts\" :options=\"contracts\" :multiple=\"true\" :close-on-select=\"true\" :clear-on-select=\"true\" :searchable=\"true\" label=\"name\" track-by=\"id\" tag-name=\"name\" placeholder=\"請選擇方案\" class=\"m-bottom-10\"></v-mutiselect>\n                                                </div>   \n                                                <div>\n                                                    <v-mutiselect :model.sync=\"model.select_tickets\" :options=\"tickets\" :multiple=\"true\" :close-on-select=\"true\" :clear-on-select=\"true\" :searchable=\"true\" label=\"name\" track-by=\"id\" tag-name=\"name\" placeholder=\"請選擇票券\" class=\"m-bottom-10\" style=\"display:none;\"></v-mutiselect> \n                                                </div> \n                                                <div>\n                                                    <v-mutiselect :model.sync=\"model.select_products\" :options=\"products\" :multiple=\"true\" :close-on-select=\"true\" :clear-on-select=\"true\" :searchable=\"true\" label=\"name\" track-by=\"id\" tag-name=\"name\" placeholder=\"請選擇產品\" class=\"m-bottom-10\" style=\"display:none;\"></v-mutiselect>  \n                                                </div>                                 \n                                            </div>\n                                        </div>    \n                                    </div>\n                                </div>\n\n                                <div class=\"clearfix m-top-5 m-bottom-5\">\n                                    <label class=\"col-lg-3 col-md-3 col-xs-12 p-top-5 require\" for=\"min_price\">適用金額 </label>\n                                    <div class=\"col-lg-9 col-md-9 col-xs-12\">\n                                        項目金額不可小於<input name=\"min_price\" v-model=\"model.min_price\" style=\"height: 26px; padding: 3px;\" type=\"number\" maxlength=\"50\">元\n                                    </div>\n                                </div>\n\n                                <div v-if=\"model.type === '2'\">\n                                    <div class=\"clearfix m-top-5 m-bottom-5\">\n                                        <label class=\"col-lg-3 col-md-3 col-xs-12 p-top-5 require\" for=\"\">適用客戶 </label>\n                                        <div class=\"col-lg-9 col-md-9 col-xs-12\">\n                                            <div class=\"col-lg-12 col-md-12 col-xs-12\">\n                                                <input type=\"radio\" value=\"1\" name=\"member_use_type\" id=\"member_use_type1\" v-model=\"model.member_use_type\"><label class=\"m-left-5\" for=\"member_use_type1\">全部</label>\n                                            </div>\n                                            <div class=\"col-lg-12 col-md-12 col-xs-12\">\n                                                <div class=\"m-bottom-10\"><input type=\"radio\" value=\"2\" name=\"member_use_type\" id=\"member_use_type2\" v-model=\"model.member_use_type\"><label class=\"m-left-5\" for=\"member_use_type2\">指定標籤可以使用</label></div>\n                                                <div v-show=\"model.member_use_type === '2' || model.member_use_type === 2\" class=\"col-lg-12 col-md-12 col-xs-12\">\n                                                    <v-mutiselect :model.sync=\"model.select_white_tags\" :options=\"tags\" :multiple=\"true\" :close-on-select=\"true\" :clear-on-select=\"true\" :searchable=\"true\" label=\"name\" track-by=\"id\" tag-name=\"name\" placeholder=\"請選擇客戶標籤\" class=\"m-bottom-10\"></v-mutiselect>                                  \n                                                </div>\n                                            </div>    \n                                        </div>\n                                    </div>\n\n                                    <hr>\n\n                                    <div class=\"clearfix\">\n                                        <label class=\"col-lg-3 col-md-3 col-xs-12 p-top-5 require\" for=\"\">排除黑名單 </label>\n                                        <div class=\"col-lg-9 col-md-9 col-xs-12\">\n                                            <v-mutiselect :model.sync=\"model.select_black_tags\" :options=\"tags\" :multiple=\"true\" :close-on-select=\"true\" :clear-on-select=\"true\" :searchable=\"true\" label=\"name\" track-by=\"id\" tag-name=\"name\" placeholder=\"請選擇客戶標籤\" class=\"m-bottom-10\"></v-mutiselect>   \n                                        </div>\n                                    </div>\n\n                                    <hr>\n\n                                    <div class=\"clearfix\">\n                                        <label class=\"col-lg-3 col-md-3 col-xs-12 p-top-5 require\" for=\"\">客戶使用限制 </label>\n                                        <div class=\"col-lg-9 col-md-9 col-xs-12\">\n                                            <div class=\"col-lg-12 col-md-12 col-xs-12\">\n                                                <input type=\"radio\" value=\"1\" name=\"use_restriction_type\" id=\"use_restriction_type1\" v-model=\"model.use_restriction_type\"><label class=\"m-left-5\" for=\"use_restriction_type1\">無限制</label>\n                                            </div>\n                                            <div class=\"col-lg-12 col-md-12 col-xs-12\">\n                                                <input type=\"radio\" value=\"2\" name=\"use_restriction_type\" id=\"use_restriction_type2\" v-model=\"model.use_restriction_type\"><label class=\"m-left-5\" for=\"use_restriction_type2\">每人限用</label>\n                                                <input min=\"0\" style=\"height: 26px; padding: 3px;\" type=\"number\" v-model=\"model.usage_count\">\n                                                <label class=\"m-left-5\" for=\"use_restriction_type2\">次</label>\n                                            </div>\n                                            <div class=\"col-lg-12 col-md-12 col-xs-12\">\n                                                <input type=\"radio\" value=\"3\" name=\"use_restriction_type\" id=\"use_restriction_type3\" v-model=\"model.use_restriction_type\"><label class=\"m-left-5\" for=\"use_restriction_type3\">每人限用一次而且必須是新客戶</label>\n                                            </div>\n                                        </div>\n                                    </div>\n\n                                    <hr>\n\n                                    <div class=\"clearfix\">\n                                        <label class=\"col-lg-3 col-md-3 col-xs-12 p-top-5 require\" for=\"\">最大使用量 <span>*</span></label>\n                                        <div class=\"col-lg-9 col-md-9 col-xs-12\">\n                                            <div class=\"col-lg-12 col-md-12 col-xs-12\">\n                                                <input type=\"radio\" value=\"1\" name=\"max_usage_type\" id=\"max_usage_type1\" v-model=\"model.max_usage_type\"><label class=\"m-left-5\" for=\"max_usage_type1\">無限制</label>\n                                            </div>\n                                            <div class=\"col-lg-12 col-md-12 col-xs-12\">\n                                                <input type=\"radio\" value=\"2\" name=\"max_usage_type\" id=\"max_usage_type2\" v-model=\"model.max_usage_type\"><label class=\"m-left-5\" for=\"max_usage_type2\">有限制</label>\n                                                <input min=\"0\" v-show=\"model.max_usage_type === '2' || model.max_usage_type === 2\" style=\"height: 26px; padding: 3px;\" type=\"number\" v-model=\"model.max_usage_count\">\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n\n                                <hr>\n\n                                <div class=\"clearfix m-bottom-20\">\n                                    <label class=\"col-lg-3 col-md-3 col-xs-12 p-top-5 require\" for=\"\">狀態 </label>\n                                    <div class=\"col-lg-9 col-md-9 col-xs-12\">\n                                        <div class=\"col-lg-12 col-md-12 col-xs-12\">\n                                            <input type=\"radio\" value=\"1\" name=\"is_active\" id=\"is_active1\" v-model=\"model.is_active\"><label class=\"m-left-5\" for=\"is_active1\">啟用</label>\n                                        </div>\n                                        <div class=\"col-lg-12 col-md-12 col-xs-12\">\n                                            <input type=\"radio\" value=\"0\" name=\"is_active\" id=\"is_active2\" v-model=\"model.is_active\"><label class=\"m-left-5\" for=\"is_active2\">不啟用</label>\n                                        </div>\n                                    </div>\n                                </div>\n\n                                <hr>\n\n                                <div class=\"alert alert-warning\" role=\"alert\">注意! 促銷設定新增/變更，需要20分鐘才會生效</div>\n\n                            </div>\n\n                    <div class=\"modal-footer\">\n                        <button v-show=\"view.showButton &amp;&amp; !view.ajaxing\" @click=\"deleting\" type=\"button\" class=\"btn btn-danger\" style=\"position:absolute;left: 10px;\" data-dismiss=\"modal\">刪除</button>\n                        <button v-show=\"!view.ajaxing\" type=\"button\" class=\"btn btn-primary\" @click=\"submitCoupon\">送出\n                            </button>\n                        <button type=\"button\" v-show=\"!view.ajaxing\" class=\"btn btn-default\" data-dismiss=\"modal\">關閉</button>\n                    </div>\n\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n.pac-container {\n    z-index: 2000;\n}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-0b80c619", module.exports)
  } else {
    hotAPI.update("_v-0b80c619", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1067:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n.modal-body .clearfix {\n    margin-top:5px;\n}\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vuex = require('vuex');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['studioId', 'branchId', 'title', 'name', 'contracts', 'tickets', 'products', 'tags'],
    data: function data() {
        return {
            studio_id: 0,
            view: {
                ajaxing: false,
                canSubmit: true,
                action: 'create'
            },
            is_never_end: false,
            is_expired: 0,
            model: {
                id: null,
                name: '',
                type: '1',
                is_using_together: 0,
                code_id: 0,
                code: '',
                discount_type: 1,
                discount_value: 0,
                start_date: null,
                end_date: null,
                start_hour: '00',
                end_hour: '00',
                start_minute: '00',
                end_minute: '00',
                range_use_type: 1,
                select_contracts: [],
                select_tickets: [],
                select_products: [],
                select_white_tags: [],
                select_black_tags: [],
                min_price: 0,
                member_use_type: 1,
                use_restriction_type: 1,
                usage_count: 1,
                max_usage_type: 1,
                max_usage_count: 0,
                is_active: 1,
                is_available: 1
            }
        };
    },

    filters: {
        uppercase: function uppercase(v) {
            return v.toUpperCase();
        }
    },
    watch: {},
    computed: {
        start_date: function start_date() {
            return this.model.start_date + ' ' + this.model.start_hour + ':' + this.model.start_minute;
        },
        end_date: function end_date() {
            return this.model.end_date + ' ' + this.model.end_hour + ':' + this.model.end_minute;
        },
        typeName: function typeName() {
            return this.model.type === '1' || this.model.type === 1 ? '促銷' : '優惠券';
        },
        using_together: function using_together() {
            return this.model.is_using_together === 1 || this.model.is_using_together === '1' ? '可與其他優惠一起使用' : '不可與其他優惠一起使用';
        },
        start_full_date: function start_full_date() {
            return this.model.start_date + ' ' + this.model.start_hour + ':' + this.model.start_minute;
        },
        end_full_date: function end_full_date() {
            return this.model.end_date + ' ' + this.model.end_hour + ':' + this.model.end_minute;
        },
        range_use_type_name: function range_use_type_name() {
            return this.model.range_use_type === 1 ? '全部項目' : '指定項目';
        },
        member_use_type_name: function member_use_type_name() {
            return this.model.member_use_type === 1 ? '全部' : '指定標籤可以使用';
        },
        use_restriction_type_name: function use_restriction_type_name() {
            if (this.model.use_restriction_type === 1) {
                return '無限制';
            } else if (this.model.use_restriction_type === 2) {
                return '每人限用' + this.model.usage_count + '次';
            } else {
                return '每人限用一次而且必須是新客戶';
            }
        },
        max_usage_type_name: function max_usage_type_name() {
            return this.model.max_usage_type === 1 ? '無限制' : '限制' + this.model.max_usage_count + '次';
        },
        discount_type_name: function discount_type_name() {
            return this.model.discount_type === 2 ? '折扣比例' + this.model.discount_value + '%' : '折抵' + this.model.discount_value + '元';
        }
    },
    methods: {
        show: function show(id) {
            var _this = this;

            this.view.ajaxing = true;
            this.$http.get('/adminapi/coupons/' + id).then(function (response) {
                var coupon = response.body;
                _this.model.id = coupon.id;
                _this.model.name = coupon.name;
                _this.model.code = coupon.code;
                _this.model.type = coupon.type;
                _this.is_never_end = coupon.is_never_end;
                _this.is_expired = coupon.is_expired, _this.model.is_using_together = coupon.is_using_together;
                _this.model.discount_type = coupon.discount_type;
                _this.model.discount_value = coupon.discount_value;
                _this.model.start_date = coupon.start_date;
                _this.model.end_date = coupon.end_date;
                _this.model.start_hour = coupon.start_hour;
                _this.model.end_hour = coupon.end_hour;
                _this.model.start_minute = coupon.start_minute;
                _this.model.end_minute = coupon.end_minute;
                _this.model.range_use_type = coupon.range_use_type;
                _this.model.select_contracts = coupon.select_contracts;
                _this.model.select_tickets = coupon.select_tickets;
                _this.model.select_products = coupon.select_products;
                _this.model.select_white_tags = coupon.select_white_tags;
                _this.model.select_black_tags = coupon.select_black_tags;
                _this.model.min_price = coupon.min_price;
                _this.model.member_use_type = coupon.member_use_type;
                _this.model.use_restriction_type = coupon.use_restriction_type;
                _this.model.usage_count = coupon.usage_count;
                _this.model.max_usage_type = coupon.max_usage_type;
                _this.model.max_usage_count = coupon.max_usage_count;
                _this.model.is_active = coupon.is_active;
                _this.model.is_available = coupon.is_available;

                _lodash2.default.delay(function () {
                    _this.view.ajaxing = false;
                }, 400);
            }, function (error) {
                $17.swal({
                    title: error.body.message,
                    type: 'warning'
                });
                _this.view.ajaxing = false;
            });
        },
        resetForm: function resetForm() {
            this.model.id = null;
            this.model.name = '';
            this.model.code_id = 0;
            this.model.type = 1;
            this.is_never_end = false;
            this.model.is_using_together = 0;
            this.model.code = '';
            this.model.discount_type = 1;
            this.model.discount_value = 0;
            this.model.start_date = null;
            this.model.end_date = null;
            this.model.start_hour = '00';
            this.model.end_hour = '00';
            this.model.start_minute = '00';
            this.model.end_minute = '00';
            this.model.range_use_type = 1;
            this.model.select_contracts = [];
            this.model.select_tickets = [];
            this.model.select_products = [];
            this.model.select_white_tags = [];
            this.model.select_black_tags = [];
            this.model.min_price = 0;
            this.model.member_use_type = 1;
            this.model.use_restriction_type = 1;
            this.model.usage_count = 1;
            this.model.max_usage_type = 1;
            this.model.max_usage_count = 0;
            this.model.is_active = 1;
            this.model.is_available = 1;
        },

        deleting: function deleting() {
            if (this.model.is_available === 0 || this.model.is_available === '0') {
                this.deleteCoupon();
            } else if (this.model.is_active === 1 || this.model.is_active === '1') {
                $17.swal({
                    title: '啟用中的優惠不能被刪除,請先停用該優惠',
                    type: 'warning',
                    showCancelButton: false
                });
            } else {
                this.deleteCoupon();
            }
        },
        deleteCoupon: function deleteCoupon() {
            v = this;
            $17.swal({
                title: '確定要刪除這個優惠嗎',
                type: 'warning'
            }, function (isConfirm) {
                if (isConfirm) {
                    v.view.ajaxing = true;
                    v.$http.delete('/adminapi/coupons/' + v.model.id).then(function (response) {
                        v.view.ajaxing = false;
                        v.$emit('refresh');
                        $('#coupon-view-modal').modal('hide');
                    }, function (error) {
                        v.view.ajaxing = false;
                    });
                }
            });
        },
        updating: function updating() {
            var _this2 = this;

            this.view.ajaxing = true;
            this.$http.patch('/adminapi/coupons/' + this.model.id, {
                type: this.model.type,
                is_active: this.model.is_active,
                studio_id: this.studioId,
                branch_id: this.branchId
            }).then(function (response) {
                _this2.view.ajaxing = false;
                _this2.resetForm();
                _this2.$emit('refresh');
                $('#coupon-view-modal').modal('hide');
            }, function (error) {
                _this2.view.ajaxing = false;
            });
        },
        onCall: function onCall(id) {
            this.model.id = id;
            this.view.showButton = true;
            this.show(this.model.id);
        },
        submitCoupon: function submitCoupon() {
            this.updating();
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n    <div>\n        <div id=\"coupon-view-modal\" class=\"modal fade\" role=\"dialog\">\n            <div class=\"modal-dialog\">\n                <div class=\"modal-content\">\n                    <div class=\"modal-header\">\n                        <button type=\"button\" v-show=\"!view.ajaxing\" class=\"close\" data-dismiss=\"modal\">×</button>\n                        <h4 class=\"modal-title\">{{ title }}</h4>\n                    </div>\n                    <v-spinner :ajaxing=\"view.ajaxing\"></v-spinner>\n                    <div v-show=\"!view.ajaxing\" class=\"modal-body\">\n                            <div class=\"clearfix m-top-10\">\n\n                                <div v-if=\"is_expired === 0 || is_expired === '0'\" class=\"clearfix m-bottom-20\">\n                                    <label class=\"col-lg-3 col-md-3 col-xs-12 p-top-5 require\" for=\"\">狀態 </label>\n                                    <div class=\"col-lg-9 col-md-9 col-xs-12\">\n                                        <div class=\"col-lg-6 col-md-6 col-xs-12\">\n                                            <input type=\"radio\" value=\"1\" name=\"status_is_active\" id=\"is_active1\" v-model=\"model.is_active\"><label class=\"m-left-5\">啟用</label>\n                                        </div>\n                                        <div class=\"col-lg-6 col-md-6 col-xs-12\">\n                                            <input type=\"radio\" value=\"0\" name=\"status_is_active\" id=\"is_active2\" v-model=\"model.is_active\"><label class=\"m-left-5\">不啟用</label>\n                                        </div>\n                                    </div>\n                                </div>\n\n                                <div class=\"clearfix\">\n                                    <label class=\"col-lg-3 col-md-3 col-xs-12 p-top-5 require\" for=\"\">名稱 </label>\n                                    <div class=\"col-lg-9 col-md-9 col-xs-12 p-top-5\">\n                                        <span>{{ model.name }}</span>\n                                    </div>\n                                </div>\n\n                                <div v-if=\"model.code !== ''\" class=\"clearfix\">\n                                    <label class=\"col-lg-3 col-md-3 col-xs-12 p-top-5 require\" for=\"\">優惠代碼 </label>\n                                    <div class=\"col-lg-9 col-md-9 col-xs-12 p-top-5\">\n                                        <span>{{ model.code | uppercase }}</span>\n                                        <span class=\"m-left-10\"> {{ using_together }} </span>\n                                    </div>\n                                </div>\n\n                                <div class=\"clearfix\">\n                                    <label class=\"col-lg-3 col-md-3 col-xs-12 p-top-5 require\" for=\"\">類型 </label>\n                                    <div class=\"col-lg-9 col-md-9 col-xs-12 p-top-5\">\n                                        <span>{{ typeName }}</span>\n                                    </div>\n                                </div>\n\n                                <hr>\n\n                                <div class=\"clearfix\">\n                                    <label class=\"col-lg-3 col-md-3 col-xs-12 p-top-5 require\" for=\"\">優惠方式 </label>\n                                    <div class=\"col-lg-9 col-md-9 col-xs-12 p-top-5\">\n                                        <span>{{ discount_type_name }}</span>\n                                    </div>\n                                </div>\n\n                                <hr>\n\n                                <div class=\"clearfix\">\n                                    <label class=\"col-lg-3 col-md-3 col-xs-12 p-top-5 require\" for=\"\">開始日期 </label>\n                                    <div class=\"col-lg-9 col-md-9 col-xs-12 p-top-5\">\n                                        <span>{{ start_full_date }}</span>\n                                    </div>                              \n                                </div>\n\n                                <div class=\"clearfix\">\n                                    <label class=\"col-lg-3 col-md-3 col-xs-12 p-top-5 require\" for=\"\">結束日期 </label>\n                                    <div class=\"col-lg-9 col-md-9 col-xs-12 p-top-5\">\n                                        <span>{{ is_never_end === '1' || is_never_end === true || is_never_end === 1 ? '永不結束' : end_full_date }}</span>\n                                    </div>                              \n                                </div>\n\n                                <hr>\n\n                                <div class=\"clearfix m-top-5 m-bottom-5\">\n                                    <label class=\"col-lg-3 col-md-3 col-xs-12 p-top-5 require\" for=\"\">適用範圍 </label>\n                                    <div class=\"col-lg-9 col-md-9 col-xs-12\">\n                                        <div class=\"col-lg-12 col-md-12 col-xs-12 p-top-5\">\n                                            <span>{{ range_use_type_name }}</span>\n                                        </div>\n                                        <div class=\"col-lg-12 col-md-12 col-xs-12\">\n                                            <div v-show=\"model.range_use_type === '2' || model.range_use_type === 2\" class=\"col-lg-12 col-md-12 col-xs-12\">\n                                                <div>\n                                                    <v-mutiselect v-if=\"model.select_contracts.length > 0\" :disabled=\"true\" :model.sync=\"model.select_contracts\" :options=\"model.select_contracts\" :multiple=\"true\" :close-on-select=\"true\" :clear-on-select=\"true\" :searchable=\"true\" label=\"name\" track-by=\"id\" tag-name=\"name\" placeholder=\"請選擇方案\" class=\"m-bottom-10\"></v-mutiselect>\n                                                </div>                                 \n                                            </div>\n                                        </div>    \n                                    </div>\n                                </div>\n\n                                <hr>\n\n                                <div class=\"clearfix m-top-5 m-bottom-5\">\n                                    <label class=\"col-lg-3 col-md-3 col-xs-12 p-top-5 require\" for=\"\">適用金額 </label>\n                                    <div class=\"col-lg-9 col-md-9 col-xs-12 p-top-5\">\n                                        <span v-if=\"model.type === '2' || model.type === 2\">訂單</span><span v-if=\"model.type === '1' || model.type === 1\">項目</span>金額不可小於<span>{{model.min_price}}</span>元\n                                    </div>\n                                </div>\n\n                                <div v-if=\"model.type === '2' || model.type === 2\">\n                                    <div class=\"clearfix m-top-5 m-bottom-5\">\n                                        <label class=\"col-lg-3 col-md-3 col-xs-12 p-top-5 require\" for=\"\">適用客戶 </label>\n                                        <div class=\"col-lg-9 col-md-9 col-xs-12\">\n                                            <div class=\"col-lg-12 col-md-12 col-xs-12 p-top-5\">\n                                                <span>{{ member_use_type_name }}</span>\n                                            </div>\n                                            <div class=\"col-lg-12 col-md-12 col-xs-12\">\n                                                <div v-show=\"model.member_use_type === '2' || model.member_use_type === 2\" class=\"col-lg-12 col-md-12 col-xs-12\">\n                                                    <v-mutiselect v-if=\"model.select_white_tags.length > 0\" :disabled=\"true\" :model.sync=\"model.select_white_tags\" :options=\"model.select_white_tags\" :multiple=\"true\" :close-on-select=\"true\" :clear-on-select=\"true\" :searchable=\"true\" label=\"name\" track-by=\"id\" tag-name=\"name\" placeholder=\"請選擇客戶標籤\" class=\"m-bottom-10\"></v-mutiselect>                                  \n                                                </div>\n                                            </div>    \n                                        </div>\n                                    </div>\n\n                                    <hr>\n\n                                    <div class=\"clearfix\">\n                                        <label class=\"col-lg-3 col-md-3 col-xs-12 p-top-5 require\" for=\"\">排除黑名單 </label>\n                                        <div class=\"col-lg-9 col-md-9 col-xs-12\">\n                                            <v-mutiselect v-if=\"model.select_black_tags.length > 0\" :disabled=\"true\" :model.sync=\"model.select_black_tags\" :options=\"model.select_black_tags\" :multiple=\"true\" :close-on-select=\"true\" :clear-on-select=\"true\" :searchable=\"true\" label=\"name\" track-by=\"id\" tag-name=\"name\" placeholder=\"請選擇客戶標籤\" class=\"m-bottom-10\"></v-mutiselect>\n                                        </div>\n                                    </div>\n\n                                    <hr>\n\n                                    <div class=\"clearfix\">\n                                        <label class=\"col-lg-3 col-md-3 col-xs-12 p-top-5 require\" for=\"\">客戶使用限制 </label>\n                                        <div class=\"col-lg-9 col-md-9 col-xs-12 p-top-5\">\n                                            <span>{{ use_restriction_type_name }}</span>\n                                        </div>\n                                    </div>\n\n                                    <hr>\n\n                                    <div class=\"clearfix\">\n                                        <label class=\"col-lg-3 col-md-3 col-xs-12 p-top-5 require\" for=\"\">最大使用量</label>\n                                        <div class=\"col-lg-9 col-md-9 col-xs-12 p-top-5\">\n                                            <span>{{ max_usage_type_name }}\n                                        </span></div>\n                                    </div>\n                                </div>\n\n                                <hr>\n\n                                <div class=\"alert alert-warning\" role=\"alert\">注意! 促銷設定新增/變更，需要20分鐘才會生效</div>\n\n                                \n\n                    </div>\n\n                    <div class=\"modal-footer\">\n                        <button v-show=\"view.showButton &amp;&amp; !view.ajaxing\" @click=\"deleting\" type=\"button\" class=\"btn btn-danger\" style=\"position:absolute;left: 10px;\" data-dismiss=\"modal\">刪除</button>\n                        <button v-if=\"is_expired === 0 || is_expired === '0'\" v-show=\"!view.ajaxing\" type=\"button\" class=\"btn btn-primary\" @click=\"submitCoupon\">送出\n                            </button>\n                        <button type=\"button\" v-show=\"!view.ajaxing\" class=\"btn btn-default\" data-dismiss=\"modal\">關閉</button>\n                    </div>\n\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n.modal-body .clearfix {\n    margin-top:5px;\n}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-15a6b6d7", module.exports)
  } else {
    hotAPI.update("_v-15a6b6d7", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1068:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.w-50[_v-97f2bcbe] {\n  width: 50px; }\n\n/* line 6, stdin */\n.w-100[_v-97f2bcbe] {\n  width: 100px; }\n\n/* line 10, stdin */\n.w-200[_v-97f2bcbe] {\n  width: 200px; }\n\n/* line 14, stdin */\n.d-inline[_v-97f2bcbe] {\n  display: inline-block; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['memberId', 'studioId'],
    data: function data() {
        return {
            ajaxing: false,
            ajaxing_contracts: false,
            ajaxing_templates: false,
            ajaxing_issue_methods: false,
            ajaxing_salesmen: false,
            is_invoice_setting_active: false,
            template_type: 0,
            branch: {},
            previewText: '',
            selectTemplate: {},
            view: {
                payments: [],
                contracts: [],
                invoice_issue_methods: [],
                invoice_charities: [],
                invoice_love_code: {},
                selected_issue_method: '',
                salesmen: [],
                templates: []
            },
            postData: {
                branch_payment_method_ids: [],
                total: 0,
                buyable_id: '',
                buyable_model: 'contracts',
                invoice_issue_method_id: '',
                level_1_data: '',
                start_date: '',
                frequency: 0,
                pay_times: '',
                per_days: '',
                date_each_month: '',
                buyer_name: '',
                buyer_email: '',
                invoice_title: '',
                invoice_ubn: '',
                invoice_love_code: '',
                invoice_carrier_num: '',
                template_id: ''
            }
        };
    },
    created: function created() {
        var _this = this;

        window.Event.$on('auto-pay-plan-open-create', function (data) {
            _this.resetData();
            _this.view.payments = data.payments;
            _this.postData.start_date = moment().format('YYYY-MM-DD');
            _this.postData.buyer_name = _this.customer.name;
            _this.postData.buyer_email = _this.customer.email;
            _this.getContracts();
            _this.getInvoiceIssueMethods();
            _this.getSalesmen();
            _this.getTemplate();
            $('#create-auto-pay-plan-modal').modal('show');
        });
        window.Event.$on('auto-pay-plan-branch', function (branch) {
            _this.branch = branch;
        });
        window.Event.$on('auto-pay-plan-template', function () {
            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(data) {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.previewText = '';
                                _this.postData.template_id = data.template_id;
                                _context.next = 4;
                                return _this.getTemplate();

                            case 4:
                                _context.next = 6;
                                return _this.changetemplate();

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }));

            return function (_x) {
                return _ref.apply(this, arguments);
            };
        }());
    },
    mounted: function mounted() {
        var vm = this;
        this.$nextTick(function () {
            $('.start_date').datetimepicker({
                format: 'YYYY-MM-DD',
                locale: 'zh-tw'
            }).on('dp.change', function (e) {
                if (e.date) {
                    vm.postData.start_date = e.date.locale('zh-tw').format('YYYY-MM-DD');
                } else {
                    vm.postData.start_date = moment().add(1, 'days').format('YYYY-MM-DD');
                }
            });
        });
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['isBranch']), (0, _vuex.mapState)({
        customer: function customer(state) {
            return state.webadmin.crm.member;
        },
        canCreateAutoPayPlan: function canCreateAutoPayPlan(state) {
            return state.webadmin.configure.webFunctions.WebadminAutoPayPlanCreate;
        },
        canUseAutoPayPlanTemplate: function canUseAutoPayPlanTemplate(state) {
            return state.webadmin.configure.webFunctions.WebadminAutoPayPlanTemplate;
        }
    }), {
        monthDays: function monthDays() {
            var days = [];
            for (var i = 1; i <= 28; i++) {
                days.push(i);
            }
            return days;
        }
    }),
    watch: {
        'postData.pay_times': function postDataPay_times(val, oldV) {
            if (val > 120) {
                this.postData.pay_times = 120;
            }
            if (val < 1) {
                this.postData.pay_times = 1;
            }
        },
        'view.invoice_love_code.love_code': function viewInvoice_love_codeLove_code(val, oldV) {
            this.postData.invoice_love_code = val;
        },
        'view.selected_issue_method': function viewSelected_issue_method(val, oldV) {
            if (val) {
                this.postData.issue_name = this.view.invoice_issue_methods[val].name;
                this.postData.invoice_issue_method_id = this.view.invoice_issue_methods[val].method_id;
                if (val != 'LoveCode') {
                    this.postData.invoice_love_code = '';
                }
                if (val != 'UBN') {
                    this.postData.invoice_title = '';
                    this.postData.invoice_ubn = '';
                }
                if (val != 'CarrierPhone' || val != 'CarrierNPC') {
                    this.postData.invoice_carrier_num = '';
                }
            }
        }
    },
    methods: {
        preview: function preview() {
            if (this.postData.frequency == 0 && (this.postData.per_days < 1 || this.postData.per_days > 365 || this.postData.per_days.trim() == '')) {
                this.alert('頻率', '天數必須大於 1 天、小於 365 天', 'warning');
                return false;
            }
            if (this.postData.frequency == 1 && !this.postData.date_each_month) {
                this.alert('頻率', '請選擇每月幾號', 'warning');
                return false;
            }
            if (this.postData.pay_times <= 0 || !this.postData.pay_times) {
                this.alert('次數', '必須介於1次至120次之間', 'warning');
                return false;
            }
            if (!this.postData.buyable_id) {
                this.alert('請選擇購買方案', '', 'warning');
                return false;
            }
            if (this.postData.total <= 0 || this.postData.total > 100000 || !this.postData.total) {
                this.alert('金額', '必須介於一元至十萬元之間', 'warning');
                return false;
            }
            if (this.is_invoice_setting_active && !this.postData.invoice_issue_method_id) {
                this.alert('發票', '請選擇發票開立方式', 'warning');
                return false;
            }
            if (this.is_invoice_setting_active && this.postData.invoice_issue_method_id > 0) {
                if ((this.view.selected_issue_method == 'CarrierPhone' || this.view.selected_issue_method == 'CarrierNPC') && !this.postData.invoice_carrier_num.trim()) {
                    this.alert('發票', '請輸入條碼', 'warning');
                    return false;
                }
                if (this.view.selected_issue_method == 'LoveCode' && !this.postData.invoice_love_code.trim()) {
                    this.alert('發票', '請選擇愛心碼捐贈單位', 'warning');
                    return false;
                }
                if (this.view.selected_issue_method == 'UBN' && (!this.postData.invoice_title.trim() || !this.postData.invoice_ubn.trim())) {
                    this.alert('發票', '請輸入公司抬頭及統一編號', 'warning');
                    return false;
                }
            }
            if (!this.postData.buyer_email.trim() || !this.postData.buyer_name.trim()) {
                this.alert('購買人', '請輸入購買人姓名及信箱', 'warning');
                return false;
            }
            this.passDataToPreview();
        },
        passDataToPreview: function passDataToPreview() {
            this.postData.studio_id = this.studioId;
            this.postData.branch_id = this.branch.id;

            var price = this.postData.total;
            var payTimes = this.postData.pay_times;
            var startDate = this.postData.start_date;
            var data = {};
            if (this.postData.frequency == 1) {
                //每月幾號
                this.postData.per_days = '';
                var eachDate = this.postData.date_each_month;
                var startDay = moment(startDate).format('D');
                var sMonth = startDay > eachDate ? 1 : 0;
                for (var i = 0; i < payTimes; i++) {
                    var plusMonth = sMonth + i;
                    var d = moment(startDate).startOf('month').add(plusMonth, 'month').add(eachDate - 1, 'day').format('YYYY-MM-DD');
                    data[d] = {
                        date: d,
                        sub_total: price
                    };
                }
            } else {
                //每隔幾天
                this.postData.date_each_month = '';
                data[startDate] = {
                    date: startDate,
                    sub_total: price
                };
                for (var _i = 0; _i < payTimes - 1; _i++) {
                    startDate = moment(startDate).add(this.postData.per_days, 'day').format('YYYY-MM-DD');
                    data[startDate] = {
                        date: startDate,
                        sub_total: price
                    };
                }
            }
            window.Event.$emit('auto-pay-plan-pass-to-preview', { postData: this.postData, previewData: data });
        },
        changeContract: function changeContract(e) {
            var target = this.$refs['contract' + e.target.value][0];
            var price = target.dataset.price;
            this.postData.total = parseInt(price.replace(/[$,]/g, ''));
            this.postData.contract_name = target.dataset.name;
        },
        changetemplate: function changetemplate() {
            this.previewText = '';
            this.view.templates.forEach(function (item, index) {
                if (item.id == this.postData.template_id) {
                    this.selectTemplate = item;
                    var frequency = '';
                    if (item.frequency == 0) {
                        frequency = item.per_days + '天';
                    } else {
                        frequency = item.date_each_month + '號';
                    }
                    this.previewText = '頻率: ' + frequency + ' , 次數:' + item.pay_times + ' , 購買方案: ' + item.contract_name + ' , 金額: ' + item.price;
                }
            }, this);
        },
        getSalesmen: function getSalesmen() {
            var _this2 = this;

            this.ajaxing_salesmen = true;
            this.$http.get('/adminapi/salseman/' + this.studioId, { params: { branch_ids: [this.branch.id] } }).then(function (response) {
                this.view.salesmen = response.data.list;
                this.ajaxing_salesmen = false;
            }).catch(function (response) {
                _this2.alert('取得業務代表失敗', '', 'warning');
                _this2.ajaxing_salesmen = false;
            });
        },
        getInvoiceCharities: function getInvoiceCharities() {
            var _this3 = this;

            this.$http.get('/adminapi/invoice_setting/charities/branch/' + this.branch.id).then(function (response) {
                this.view.invoice_charities = response.data.list;
            }).catch(function (response) {
                _this3.alert('取得愛心碼失敗', '', 'warning');
            });
        },
        getContracts: function getContracts() {
            var _this4 = this;

            this.ajaxing_contracts = true;
            this.$http.get('/adminapi/pos/get_product_list/' + this.branch.id + '/contracts').then(function (response) {
                this.view.contracts = response.data.list;
                this.ajaxing_contracts = false;
            }).catch(function (response) {
                _this4.alert('取得方案列表失敗', '', 'warning');
                _this4.ajaxing_contracts = false;
            });
        },
        getTemplate: function getTemplate() {
            var _this5 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _this5.ajaxing_templates = true;
                                _this5.view.templates = [];
                                _context2.next = 4;
                                return _this5.$http.get('/adminapi/auto_pay_plan_template/list/' + _this5.branch.id).then(function (response) {
                                    this.view.templates = response.data;
                                    this.ajaxing_templates = false;
                                }).catch(function (response) {
                                    _this5.alert('取得模板列表失敗', '', 'warning');
                                    _this5.ajaxing_templates = false;
                                });

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this5);
            }))();
        },
        getInvoiceIssueMethods: function getInvoiceIssueMethods() {
            var _this6 = this;

            this.ajaxing_issue_methods = true;
            this.$http.get('/adminapi/invoice_setting/branch/' + this.branch.id + '/issue_methods').then(function (response) {
                this.view.invoice_issue_methods = response.data.invoice_issue_methods;
                this.getInvoiceCharities();
                this.is_invoice_setting_active = true;
                this.ajaxing_issue_methods = false;
            }).catch(function (response) {
                _this6.is_invoice_setting_active = false;
                _this6.ajaxing_issue_methods = false;
            });
        },

        alert: function alert(title, message, type) {
            $17.swal({
                title: title,
                text: message,
                type: type,
                showCancelButton: false,
                showLoaderOnConfirm: true
            });
        },
        resetData: function resetData() {
            this.view = {
                payments: [],
                contracts: [],
                invoice_issue_methods: [],
                invoice_charities: [],
                invoice_love_code: {},
                selected_issue_method: '',
                salesmen: []
            };
            this.postData = {
                branch_payment_method_ids: [],
                total: 0,
                buyable_id: '',
                buyable_model: 'contracts',
                invoice_issue_method_id: '',
                level_1_data: '',
                start_date: '',
                frequency: 0,
                pay_times: '',
                per_days: '',
                date_each_month: '',
                buyer_name: '',
                buyer_email: '',
                invoice_title: '',
                invoice_ubn: '',
                invoice_love_code: '',
                invoice_carrier_num: '',
                template_id: ''
            };
        },
        openTemplateModel: function openTemplateModel() {
            window.Event.$emit('auto-pay-plan-open-template', { contracts: this.view.contracts });
        },
        applyTemplate: function applyTemplate() {
            this.postData.buyable_id = this.selectTemplate.contract_id;
            this.postData.total = this.selectTemplate.price;
            this.postData.frequency = this.selectTemplate.frequency;
            this.postData.pay_times = this.selectTemplate.pay_times;
            this.postData.per_days = this.selectTemplate.per_days;
            this.postData.date_each_month = this.selectTemplate.date_each_month;
            this.postData.contract_name = this.selectTemplate.contract_name;
        },
        editTemplateModel: function editTemplateModel() {
            window.Event.$emit('auto-pay-plan-edit-template', { contracts: this.view.contracts, template_id: this.postData.template_id });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal v-show=\"canCreateAutoPayPlan\" id=\"create-auto-pay-plan-modal\" open-size=\"modal-lg\" confirm-btn-text=\"下一步\" no-cancel=\"\" parallel-modal=\"\" :save-clicked=\"preview\" _v-97f2bcbe=\"\">\n    <h4 slot=\"title\" _v-97f2bcbe=\"\">新增自動支付計畫</h4>\n    <div slot=\"body\" _v-97f2bcbe=\"\">\n        <v-spinner :ajaxing=\"ajaxing\" _v-97f2bcbe=\"\"></v-spinner>\n        <div class=\"form-horizontal\" _v-97f2bcbe=\"\">\n            <div class=\"form-group\" v-if=\"!isBranch\" _v-97f2bcbe=\"\">\n                <label class=\"col-sm-3 control-label p-t-0\" _v-97f2bcbe=\"\">場館</label>\n                <div class=\"col-sm-9\" _v-97f2bcbe=\"\">\n                    <label _v-97f2bcbe=\"\">{{branch.branch_name}}</label>\n                </div>\n            </div>\n            <div class=\"form-group\" _v-97f2bcbe=\"\">\n                <label class=\"col-sm-3 control-label p-t-0\" _v-97f2bcbe=\"\">開始日期</label>\n                <div class=\"col-sm-9\" _v-97f2bcbe=\"\">\n                    <input type=\"text\" class=\"start_date form-control w-200\" v-model=\"postData.start_date\" _v-97f2bcbe=\"\">\n                </div>\n            </div>\n            <div class=\"form-group\" _v-97f2bcbe=\"\">\n                <label class=\"col-sm-3 control-label p-t-0\" _v-97f2bcbe=\"\">建立方式</label>\n                <div class=\"col-sm-9\" _v-97f2bcbe=\"\">\n                    <label class=\"col-sm-2\" _v-97f2bcbe=\"\">\n                        <input v-model=\"template_type\" value=\"0\" type=\"radio\" _v-97f2bcbe=\"\">自訂\n                    </label>\n                    <label class=\"col-sm-2\" _v-97f2bcbe=\"\">\n                        <input v-model=\"template_type\" value=\"1\" type=\"radio\" _v-97f2bcbe=\"\">模板\n                    </label>\n                    <span class=\"col-sm-4\" v-show=\"canUseAutoPayPlanTemplate\" _v-97f2bcbe=\"\">\n                        <label style=\"color:#006CE5\" @click=\"openTemplateModel\" _v-97f2bcbe=\"\">新增模板\n                        </label>\n                    </span>\n                </div>\n            </div>\n            <div class=\"form-group\" v-show=\"template_type == 1\" _v-97f2bcbe=\"\">\n                <label class=\"col-sm-3 control-label p-t-0\" _v-97f2bcbe=\"\">選擇模板</label>\n                <div class=\"col-sm-3\" _v-97f2bcbe=\"\">\n                    <v-spinner-button :ajaxing=\"ajaxing_templates\" _v-97f2bcbe=\"\"></v-spinner-button>\n                    <select v-if=\"!ajaxing_templates\" @change=\"changetemplate($event)\" v-model=\"postData.template_id\" class=\"form-control\" _v-97f2bcbe=\"\">\n                        <option value=\"\" disabled=\"\" _v-97f2bcbe=\"\">請選擇</option>\n                        <option v-for=\"template in view.templates\" :value=\"template.id\" _v-97f2bcbe=\"\">{{ template.name }}</option>\n                    </select>\n                </div>\n                <div v-show=\"postData.template_id\" _v-97f2bcbe=\"\">\n                    <span class=\"col-sm-1\" _v-97f2bcbe=\"\">\n                        <label style=\"color:#006CE5\" @click=\"applyTemplate\" _v-97f2bcbe=\"\">套用\n                        </label>\n                    </span>\n                    <span class=\"col-sm-1\" v-show=\"canUseAutoPayPlanTemplate\" _v-97f2bcbe=\"\">\n                        <label style=\"color:#006CE5\" @click=\"editTemplateModel\" _v-97f2bcbe=\"\">編輯\n                        </label>\n                    </span>\n                </div>\n            </div>\n            <div class=\"form-group\" v-show=\"postData.template_id &amp;&amp; template_type == 1\" _v-97f2bcbe=\"\">\n                <label class=\"col-sm-3 control-label p-t-0\" _v-97f2bcbe=\"\"></label>\n                <div class=\"col-sm-9\" style=\"color:#929292\" _v-97f2bcbe=\"\">\n                    {{previewText}}\n                </div>\n            </div>\n            <hr _v-97f2bcbe=\"\">\n            <div class=\"form-group\" _v-97f2bcbe=\"\">\n                <label class=\"col-sm-3 control-label p-t-0\" _v-97f2bcbe=\"\">頻率</label>\n                <div class=\"col-sm-9\" _v-97f2bcbe=\"\">\n                    <label class=\"col-sm-4\" _v-97f2bcbe=\"\">\n                        <input v-model=\"postData.frequency\" :checked=\"postData.frequency==0\" value=\"0\" type=\"radio\" _v-97f2bcbe=\"\">\n                        每隔 <input type=\"number\" onwheel=\"this.blur()\" step=\"1\" maxlength=\"3\" min=\"1\" max=\"365\" class=\"form-control w-100 d-inline\" v-model=\"postData.per_days\" _v-97f2bcbe=\"\">\n                        天\n                    </label>\n                    <label class=\"col-sm-4\" _v-97f2bcbe=\"\">\n                        <input v-model=\"postData.frequency\" :checked=\"postData.frequency==1\" value=\"1\" type=\"radio\" _v-97f2bcbe=\"\">\n                        每月\n                        <select v-model=\"postData.date_each_month\" class=\"form-control w-100 d-inline\" _v-97f2bcbe=\"\">\n                            <option value=\"\" disabled=\"\" _v-97f2bcbe=\"\">請選擇</option>\n                            <option v-for=\"day in monthDays\" :value=\"day\" _v-97f2bcbe=\"\">{{day}}</option>\n                        </select> 號\n                    </label>\n                </div>\n            </div>\n            <div class=\"form-group\" _v-97f2bcbe=\"\">\n                <label class=\"col-sm-3 control-label p-t-0\" _v-97f2bcbe=\"\">次數</label>\n                <div class=\"col-sm-9\" _v-97f2bcbe=\"\">\n                    <input type=\"number\" onwheel=\"this.blur()\" maxlength=\"3\" max=\"120\" min=\"1\" step=\"1\" class=\"form-control w-100\" v-model=\"postData.pay_times\" _v-97f2bcbe=\"\">\n                </div>\n            </div>\n            <div class=\"form-group\" _v-97f2bcbe=\"\">\n                <label class=\"col-sm-3 control-label p-t-0\" _v-97f2bcbe=\"\">購買方案</label>\n                <div class=\"col-sm-7\" _v-97f2bcbe=\"\">\n                    <v-spinner-button :ajaxing=\"ajaxing_contracts\" _v-97f2bcbe=\"\"></v-spinner-button>\n                    <select v-show=\"!ajaxing_contracts\" @change=\"changeContract($event)\" v-model=\"postData.buyable_id\" class=\"form-control\" _v-97f2bcbe=\"\">\n                        <option value=\"\" disabled=\"\" _v-97f2bcbe=\"\">請選擇</option>\n                        <optgroup :label=\"category.name\" v-for=\"category in view.contracts\" v-if=\"category.items.length\" _v-97f2bcbe=\"\">\n                            <option :value=\"contract.id\" :ref=\"'contract'+contract.id\" :data-price=\"contract.price\" :data-name=\"contract.name\" v-for=\"contract in category.items\" _v-97f2bcbe=\"\">\n                                {{contract.name}}\n                            </option>\n                        </optgroup>\n                    </select>\n                </div>\n            </div>\n            <div class=\"form-group\" _v-97f2bcbe=\"\">\n                <label class=\"col-sm-3 control-label p-t-0\" _v-97f2bcbe=\"\">金額</label>\n                <div class=\"col-sm-9\" _v-97f2bcbe=\"\">\n                    <input type=\"number\" min=\"1\" step=\"1\" onwheel=\"this.blur()\" class=\"form-control w-200\" v-model=\"postData.total\" _v-97f2bcbe=\"\">\n                </div>\n            </div>\n            <div class=\"form-group\" _v-97f2bcbe=\"\">\n                <label class=\"col-sm-3 control-label p-t-0\" _v-97f2bcbe=\"\">支付方式</label>\n                <div class=\"col-sm-9\" _v-97f2bcbe=\"\">\n                    <v-mutiselect :model.sync=\"postData.branch_payment_method_ids\" :options=\"view.payments\" :multiple=\"true\" :close-on-select=\"true\" :clear-on-select=\"true\" :searchable=\"true\" label=\"payable_show\" track-by=\"id\" tag-name=\"payable_show\" placeholder=\"請選擇\" _v-97f2bcbe=\"\">\n                    </v-mutiselect>\n                </div>\n            </div>\n            <v-spinner-button :ajaxing=\"ajaxing_issue_methods\" _v-97f2bcbe=\"\"></v-spinner-button>\n            <div class=\"form-group\" v-show=\"!ajaxing_issue_methods&amp;&amp;is_invoice_setting_active\" _v-97f2bcbe=\"\">\n                <label class=\"col-sm-3 control-label p-t-0\" _v-97f2bcbe=\"\">發票</label>\n                <div class=\"col-sm-9\" _v-97f2bcbe=\"\">\n                    <div _v-97f2bcbe=\"\">\n                        <label class=\"m-right-10\" v-for=\"method in view.invoice_issue_methods\" _v-97f2bcbe=\"\">\n                            <input v-model=\"view.selected_issue_method\" :checked=\"method.is_default==1\" :value=\"method.method\" type=\"radio\" _v-97f2bcbe=\"\"> {{method.name}}\n                        </label>\n                        <br _v-97f2bcbe=\"\">\n                        <div v-if=\"view.selected_issue_method=='CarrierPhone' || view.selected_issue_method=='CarrierNPC'\" _v-97f2bcbe=\"\">\n                            <input type=\"text\" class=\"form-control w-200\" v-model=\"postData.invoice_carrier_num\" placeholder=\"條碼\" _v-97f2bcbe=\"\">\n                        </div>\n                        <div v-if=\"view.selected_issue_method=='UBN'\" _v-97f2bcbe=\"\">\n                            <input type=\"text\" class=\"form-control w-200\" v-model=\"postData.invoice_title\" placeholder=\"公司抬頭\" _v-97f2bcbe=\"\">\n                            <input type=\"text\" class=\"form-control w-200\" v-model=\"postData.invoice_ubn\" placeholder=\"公司統編\" _v-97f2bcbe=\"\">\n                        </div>\n                        <v-mutiselect class=\"order-issue-love\" v-if=\"view.selected_issue_method=='LoveCode'\" :model.sync=\"view.invoice_love_code\" :options=\"view.invoice_charities\" :multiple=\"false\" :close-on-select=\"true\" :clear-on-select=\"true\" :searchable=\"true\" label=\"name\" track-by=\"love_code\" tag-name=\"name\" placeholder=\"請選擇\" _v-97f2bcbe=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n            </div>\n            <hr _v-97f2bcbe=\"\">\n            <div class=\"form-group\" _v-97f2bcbe=\"\">\n                <label class=\"col-sm-3 control-label p-t-0\" _v-97f2bcbe=\"\">購買人姓名</label>\n                <div class=\"col-sm-9\" _v-97f2bcbe=\"\">\n                    <input type=\"text\" class=\"form-control w-200\" v-model=\"postData.buyer_name\" _v-97f2bcbe=\"\">\n                </div>\n            </div>\n            <div class=\"form-group\" _v-97f2bcbe=\"\">\n                <label class=\"col-sm-3 control-label p-t-0\" _v-97f2bcbe=\"\">購買人信箱</label>\n                <div class=\"col-sm-9\" _v-97f2bcbe=\"\">\n                    <input type=\"email\" class=\"form-control w-200\" v-model=\"postData.buyer_email\" _v-97f2bcbe=\"\">\n                </div>\n            </div>\n            <div class=\"form-group\" _v-97f2bcbe=\"\">\n                <label class=\"col-sm-3 control-label p-t-0\" _v-97f2bcbe=\"\">業務代表</label>\n                <div class=\"col-sm-9 m-bottom-20\" _v-97f2bcbe=\"\">\n                    <v-spinner-button :ajaxing=\"ajaxing_salesmen\" _v-97f2bcbe=\"\"></v-spinner-button>\n                    <select v-if=\"!ajaxing_salesmen&amp;&amp;view.salesmen.length\" class=\"form-control w-200\" v-model=\"postData.level_1_data\" _v-97f2bcbe=\"\">\n                        <option value=\"\" _v-97f2bcbe=\"\">請選擇</option>\n                        <option v-for=\"sales in view.salesmen\" :value=\"sales\" _v-97f2bcbe=\"\">{{sales.name}}</option>\n                    </select>\n                    <label v-else-if=\"!ajaxing_salesmen&amp;&amp;!view.salesmen.length\" _v-97f2bcbe=\"\">無業務代表</label>\n                </div>\n            </div>\n        </div>\n    </div>\n</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.w-50[_v-97f2bcbe] {\n  width: 50px; }\n\n/* line 6, stdin */\n.w-100[_v-97f2bcbe] {\n  width: 100px; }\n\n/* line 10, stdin */\n.w-200[_v-97f2bcbe] {\n  width: 200px; }\n\n/* line 14, stdin */\n.d-inline[_v-97f2bcbe] {\n  display: inline-block; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-97f2bcbe", module.exports)
  } else {
    hotAPI.update("_v-97f2bcbe", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1069:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.w-50[_v-c2265222] {\n  width: 50px; }\n\n/* line 6, stdin */\n.w-100[_v-c2265222] {\n  width: 100px; }\n\n/* line 10, stdin */\n.w-200[_v-c2265222] {\n  width: 200px; }\n\n/* line 14, stdin */\n.d-inline[_v-c2265222] {\n  display: inline-block; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['memberId', 'studioId'],
    data: function data() {
        var _viewData;

        return {
            ajaxing: false,
            ajaxing_plan_data: false,
            ajaxing_issue_methods: false,
            ajaxing_salesmen: false,
            is_invoice_setting_active: false,
            branch: {},
            view: {
                contracts: [],
                invoice_issue_methods: [],
                invoice_charities: [],
                invoice_love_code: {},
                selected_issue_method: '',
                salesmen: []
            },
            autoPayPlanId: null,
            postData: {
                invoice_issue_method_id: null,
                level_1_data: '',
                buyer_name: '',
                buyer_email: '',
                invoice_title: '',
                invoice_ubn: '',
                invoice_love_code: '',
                invoice_carrier_num: ''
            },
            viewData: (_viewData = {
                start_date: '',
                buy_contract: '',
                frequency: '',
                money: '',
                payment_method: ''
            }, (0, _defineProperty3.default)(_viewData, 'start_date', ''), (0, _defineProperty3.default)(_viewData, 'pay_times', ''), _viewData)
        };
    },
    created: function created() {
        var _this = this;

        window.Event.$on('auto-pay-plan-open-edit', function () {
            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(data) {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this.getInvoiceIssueMethods();

                            case 2:
                                _context.next = 4;
                                return _this.getSalesmen();

                            case 4:
                                _this.autoPayPlanId = data.planId;
                                $('#edit-auto-pay-plan-modal').modal('show');

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }));

            return function (_x) {
                return _ref.apply(this, arguments);
            };
        }());
        window.Event.$on('auto-pay-plan-branch', function (branch) {
            _this.branch = branch;
        });
    },
    mounted: function mounted() {
        var vm = this;
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['isBranch']), (0, _vuex.mapState)({
        customer: function customer(state) {
            return state.webadmin.crm.member;
        }
    })),
    watch: {
        'autoPayPlanId': function autoPayPlanId(val, oldV) {
            if (val) {
                this.getPlanData();
            }
        },
        'view.invoice_love_code.love_code': function viewInvoice_love_codeLove_code(val, oldV) {
            this.postData.invoice_love_code = val;
        },
        'view.selected_issue_method': function viewSelected_issue_method(val, oldV) {
            if (val) {
                this.postData.issue_name = this.view.invoice_issue_methods[val].name;
                this.postData.invoice_issue_method_id = this.view.invoice_issue_methods[val].method_id;
                if (val != 'LoveCode') {
                    this.postData.invoice_love_code = '';
                }
                if (val != 'UBN') {
                    this.postData.invoice_title = '';
                    this.postData.invoice_ubn = '';
                }
                if (val != 'CarrierPhone' && val != 'CarrierNPC') {
                    this.postData.invoice_carrier_num = '';
                }
            }
        }
    },
    methods: {
        check: function check() {
            if (this.is_invoice_setting_active && !this.postData.invoice_issue_method_id) {
                this.alert('發票', '請選擇發票開立方式', 'warning');
                return false;
            }
            if (this.is_invoice_setting_active && this.postData.invoice_issue_method_id > 0) {
                if ((this.view.selected_issue_method == 'CarrierPhone' || this.view.selected_issue_method == 'CarrierNPC') && !this.postData.invoice_carrier_num.trim()) {
                    this.alert('發票', '請輸入條碼', 'warning');
                    return false;
                }
                if (this.view.selected_issue_method == 'LoveCode' && !this.postData.invoice_love_code.trim()) {
                    this.alert('發票', '請選擇愛心碼捐贈單位', 'warning');
                    return false;
                }
                if (this.view.selected_issue_method == 'UBN' && (!this.postData.invoice_title.trim() || !this.postData.invoice_ubn.trim())) {
                    this.alert('發票', '請輸入公司抬頭及統一編號', 'warning');
                    return false;
                }
            }
            if (!this.postData.buyer_email.trim() || !this.postData.buyer_name.trim()) {
                this.alert('購買人', '請輸入購買人姓名及信箱', 'warning');
                return false;
            }

            return true;
        },
        getSalesmen: function getSalesmen() {
            var _this2 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _this2.ajaxing_salesmen = true;
                                _context2.next = 3;
                                return _this2.$http.get('/adminapi/salseman/' + _this2.studioId, { params: { branch_ids: [_this2.branch.id] } }).then(function (response) {
                                    this.view.salesmen = response.data.list;
                                    this.ajaxing_salesmen = false;
                                }).catch(function (response) {
                                    _this2.alert('取得業務代表失敗', '', 'warning');
                                    _this2.ajaxing_salesmen = false;
                                });

                            case 3:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        getInvoiceCharities: function getInvoiceCharities() {
            var _this3 = this;

            this.$http.get('/adminapi/invoice_setting/charities/branch/' + this.branch.id).then(function (response) {
                this.view.invoice_charities = response.data.list;
            }).catch(function (response) {
                _this3.alert('取得愛心碼失敗', '', 'warning');
            });
        },
        getInvoiceIssueMethods: function getInvoiceIssueMethods() {
            var _this4 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _this4.ajaxing_issue_methods = true;
                                _context3.next = 3;
                                return _this4.$http.get('/adminapi/invoice_setting/branch/' + _this4.branch.id + '/issue_methods').then(function (response) {
                                    this.view.invoice_issue_methods = response.data.invoice_issue_methods;
                                    this.getInvoiceCharities();
                                    this.is_invoice_setting_active = true;
                                    this.ajaxing_issue_methods = false;
                                }).catch(function (response) {
                                    // this.alert('取得發票設定失敗', '', 'warning');
                                    _this4.is_invoice_setting_active = false;
                                    _this4.ajaxing_issue_methods = false;
                                });

                            case 3:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this4);
            }))();
        },

        alert: function alert(title, message, type) {
            $17.swal({
                title: title,
                text: message,
                type: type,
                showCancelButton: false,
                showLoaderOnConfirm: true
            });
        },
        resetData: function resetData() {
            this.view = {
                payments: [],
                invoice_issue_methods: [],
                invoice_charities: [],
                invoice_love_code: {},
                selected_issue_method: '',
                salesmen: []
            };
            this.postData = {
                invoice_issue_method_id: '',
                level_1_data: '',
                buyer_name: '',
                buyer_email: '',
                invoice_title: '',
                invoice_ubn: '',
                invoice_love_code: '',
                invoice_carrier_num: ''
            };
            this.autoPayPlanId = null;
        },
        getPlanData: function getPlanData() {
            var _this5 = this;

            this.ajaxing_plan_data = true;
            this.$http.get('/adminapi/auto_pay_plan/edit/' + this.autoPayPlanId).then(function (response) {
                var _viewData2;

                this.view.selected_issue_method = response.data.invoice_issue_method_select_method;
                this.viewData = (_viewData2 = {
                    start_date: response.data.start_date,
                    buy_contract: response.data.buy_contract,
                    frequency: response.data.frequency,
                    money: response.data.money,
                    payment_method: response.data.payment_method
                }, (0, _defineProperty3.default)(_viewData2, 'start_date', response.data.start_date), (0, _defineProperty3.default)(_viewData2, 'pay_times', response.data.pay_times), _viewData2);

                this.postData = {
                    invoice_issue_method_id: response.data.invoice_issue_method_id,
                    buyer_name: response.data.buyer_name,
                    buyer_email: response.data.buyer_email,
                    invoice_title: response.data.invoice_title,
                    invoice_ubn: response.data.invoice_ubn,
                    invoice_love_code: response.data.invoice_love_code,
                    invoice_carrier_num: response.data.invoice_carrier_num
                };
                if (response.data.invoice_issue_method_select_method == 'LoveCode') {
                    this.view.invoice_love_code = this.view.invoice_charities.reduce(function (carry, love) {
                        if (love.love_code == response.data.invoice_love_code) {
                            carry = love;
                        }

                        return carry;
                    }, null);
                }

                this.postData.level_1_data = this.view.salesmen.reduce(function (carry, sales) {
                    if (sales.id == response.data.level_1_member_id) {
                        carry = sales;
                    }

                    return carry;
                }, null);

                this.ajaxing_plan_data = false;
            }).catch(function (response) {
                _this5.ajaxing_plan_data = false;
                _this5.alert('取得方案失敗', '', 'warning');
            });
        },
        submit: function submit() {
            if (!this.check()) {
                return;
            }

            var selected_issue_method = this.view.selected_issue_method;
            var postData = this.postData;
            if ((0, _keys2.default)(this.view.invoice_issue_methods).length > 0) {
                postData.issue_name = this.view.invoice_issue_methods[selected_issue_method].name;

                postData.invoice_issue_method_id = this.view.invoice_issue_methods[selected_issue_method].method_id;
                if (selected_issue_method != 'LoveCode') {
                    postData.invoice_love_code = '';
                }
                if (selected_issue_method != 'UBN') {
                    postData.invoice_title = '';
                    postData.invoice_ubn = '';
                }
                if (selected_issue_method != 'CarrierPhone' && selected_issue_method != 'CarrierNPC') {
                    postData.invoice_carrier_num = '';
                }
            } else {
                postData.invoice_carrier_num = '';
                postData.invoice_title = '';
                postData.invoice_ubn = '';
                postData.invoice_love_code = '';
            }
            this.$http.patch('/adminapi/auto_pay_plan/update/' + this.autoPayPlanId, postData).then(function (response) {
                $.unblockUI();
                $17.swal({
                    title: '修改成功',
                    text: '',
                    type: 'success',
                    showCancelButton: false
                });
                this.resetData();
                $('#edit-auto-pay-plan-modal').modal('hide');
                window.Event.$emit('auto-pay-plan-refresh');
            }).catch(function (response) {
                $.unblockUI();
                $17.swal({
                    title: '修改失敗',
                    text: response.data.hasOwnProperty('message') ? response.data.message : '',
                    type: 'error',
                    showCancelButton: false
                });
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal id=\"edit-auto-pay-plan-modal\" open-size=\"modal-lg\" confirm-btn-text=\"儲存\" no-cancel=\"\" :save-clicked=\"submit\" _v-c2265222=\"\">\n    <h4 slot=\"title\" _v-c2265222=\"\">修改自動支付計畫</h4>\n    <div slot=\"body\" _v-c2265222=\"\">\n        <v-spinner :ajaxing=\"ajaxing_plan_data\" _v-c2265222=\"\"></v-spinner>\n        <div class=\"form-horizontal\" v-show=\"!ajaxing_plan_data\" _v-c2265222=\"\">\n            <div class=\"form-group\" v-if=\"!isBranch\" _v-c2265222=\"\">\n                <label class=\"col-sm-3 control-label p-t-0\" _v-c2265222=\"\">場館</label>\n                <div class=\"col-sm-9\" _v-c2265222=\"\">\n                    <label _v-c2265222=\"\">{{branch.branch_name}}</label>\n                </div>\n            </div>\n            <div class=\"form-group\" _v-c2265222=\"\">\n                <label class=\"col-sm-3 control-label p-t-0\" _v-c2265222=\"\">開始日期</label>\n                <div class=\"col-sm-9\" _v-c2265222=\"\">\n                   <label _v-c2265222=\"\">{{viewData.start_date}}</label>\n                </div>\n            </div>\n            <hr _v-c2265222=\"\">\n            <div class=\"form-group\" _v-c2265222=\"\">\n                <label class=\"col-sm-3 control-label p-t-0\" _v-c2265222=\"\">頻率</label>\n                <div class=\"col-sm-9\" _v-c2265222=\"\">\n                    <label _v-c2265222=\"\">{{viewData.frequency}}</label>\n                </div>\n            </div>\n            <div class=\"form-group\" _v-c2265222=\"\">\n                <label class=\"col-sm-3 control-label p-t-0\" _v-c2265222=\"\">次數</label>\n                <div class=\"col-sm-9\" _v-c2265222=\"\">\n                   <label _v-c2265222=\"\">{{viewData.pay_times}}</label>\n                </div>\n            </div>\n            <div class=\"form-group\" _v-c2265222=\"\">\n                <label class=\"col-sm-3 control-label p-t-0\" _v-c2265222=\"\">購買方案</label>\n                <div class=\"col-sm-7\" _v-c2265222=\"\">\n                    <label _v-c2265222=\"\">{{viewData.buy_contract}}</label>\n                </div>\n            </div>\n            <div class=\"form-group\" _v-c2265222=\"\">\n                <label class=\"col-sm-3 control-label p-t-0\" _v-c2265222=\"\">金額</label>\n                <div class=\"col-sm-9\" _v-c2265222=\"\">\n                    <label _v-c2265222=\"\">{{viewData.money}}</label>\n                </div>\n            </div>\n            <div class=\"form-group\" _v-c2265222=\"\">\n                <label class=\"col-sm-3 control-label p-t-0\" _v-c2265222=\"\">支付方式</label>\n                <div class=\"col-sm-9\" _v-c2265222=\"\">\n                    <label _v-c2265222=\"\">{{viewData.payment_method}}</label>\n                </div>\n            </div>\n            <v-spinner-button :ajaxing=\"ajaxing_issue_methods\" _v-c2265222=\"\"></v-spinner-button>\n            <div class=\"form-group\" v-show=\"!ajaxing_issue_methods&amp;&amp;is_invoice_setting_active\" _v-c2265222=\"\">\n                <label class=\"col-sm-3 control-label p-t-0\" _v-c2265222=\"\">發票</label>\n                <div class=\"col-sm-9\" _v-c2265222=\"\">\n                    <div _v-c2265222=\"\">\n                        <label class=\"m-right-10\" v-for=\"method in view.invoice_issue_methods\" _v-c2265222=\"\">\n                            <input v-model=\"view.selected_issue_method\" :checked=\"method.is_default==1\" :value=\"method.method\" type=\"radio\" _v-c2265222=\"\"> {{method.name}}\n                        </label>\n                        <br _v-c2265222=\"\">\n                        <div v-if=\"view.selected_issue_method=='CarrierPhone' || view.selected_issue_method=='CarrierNPC'\" _v-c2265222=\"\">\n                            <input type=\"text\" class=\"form-control w-200\" v-model=\"postData.invoice_carrier_num\" placeholder=\"條碼\" _v-c2265222=\"\">\n                        </div>\n                        <div v-if=\"view.selected_issue_method=='UBN'\" _v-c2265222=\"\">\n                            <input type=\"text\" class=\"form-control w-200\" v-model=\"postData.invoice_title\" placeholder=\"公司抬頭\" _v-c2265222=\"\">\n                            <input type=\"text\" class=\"form-control w-200\" v-model=\"postData.invoice_ubn\" placeholder=\"公司統編\" _v-c2265222=\"\">\n                        </div>\n                        <v-mutiselect class=\"order-issue-love\" v-if=\"view.selected_issue_method=='LoveCode'\" :model.sync=\"view.invoice_love_code\" :options=\"view.invoice_charities\" :multiple=\"false\" :close-on-select=\"true\" :clear-on-select=\"true\" :searchable=\"true\" label=\"name\" track-by=\"love_code\" tag-name=\"name\" placeholder=\"請選擇\" _v-c2265222=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n            </div>\n            <hr _v-c2265222=\"\">\n            <div class=\"form-group\" _v-c2265222=\"\">\n                <label class=\"col-sm-3 control-label p-t-0\" _v-c2265222=\"\">購買人姓名</label>\n                <div class=\"col-sm-9\" _v-c2265222=\"\">\n                    <input type=\"text\" class=\"form-control w-200\" v-model=\"postData.buyer_name\" _v-c2265222=\"\">\n                </div>\n            </div>\n            <div class=\"form-group\" _v-c2265222=\"\">\n                <label class=\"col-sm-3 control-label p-t-0\" _v-c2265222=\"\">購買人信箱</label>\n                <div class=\"col-sm-9\" _v-c2265222=\"\">\n                    <input type=\"email\" class=\"form-control w-200\" v-model=\"postData.buyer_email\" _v-c2265222=\"\">\n                </div>\n            </div>\n            <div class=\"form-group\" _v-c2265222=\"\">\n                <label class=\"col-sm-3 control-label p-t-0\" _v-c2265222=\"\">業務代表</label>\n                <div class=\"col-sm-9 m-bottom-20\" _v-c2265222=\"\">\n                    <v-spinner-button :ajaxing=\"ajaxing_salesmen\" _v-c2265222=\"\"></v-spinner-button>\n                    <select v-if=\"!ajaxing_salesmen&amp;&amp;view.salesmen.length\" class=\"form-control w-200\" v-model=\"postData.level_1_data\" _v-c2265222=\"\">\n                        <option value=\"\" _v-c2265222=\"\">請選擇</option>\n                        <option v-for=\"sales in view.salesmen\" :value=\"sales\" _v-c2265222=\"\">{{sales.name}}</option>\n                    </select>\n                    <label v-else-if=\"!ajaxing_salesmen&amp;&amp;!view.salesmen.length\" _v-c2265222=\"\">無業務代表</label>\n                </div>\n            </div>\n        </div>\n    </div>\n</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.w-50[_v-c2265222] {\n  width: 50px; }\n\n/* line 6, stdin */\n.w-100[_v-c2265222] {\n  width: 100px; }\n\n/* line 10, stdin */\n.w-200[_v-c2265222] {\n  width: 200px; }\n\n/* line 14, stdin */\n.d-inline[_v-c2265222] {\n  display: inline-block; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-c2265222", module.exports)
  } else {
    hotAPI.update("_v-c2265222", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/object/keys":56,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/defineProperty":65,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1070:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _list = require('./list.vue');

var _list2 = _interopRequireDefault(_list);

var _create = require('./create.vue');

var _create2 = _interopRequireDefault(_create);

var _preview = require('./preview.vue');

var _preview2 = _interopRequireDefault(_preview);

var _view = require('./view.vue');

var _view2 = _interopRequireDefault(_view);

var _template = require('./template.vue');

var _template2 = _interopRequireDefault(_template);

var _edit = require('./edit.vue');

var _edit2 = _interopRequireDefault(_edit);

var _viewTable = require('./partial/view-table.vue');

var _viewTable2 = _interopRequireDefault(_viewTable);

var _classicInformation = require('./partial/classic-information.vue');

var _classicInformation2 = _interopRequireDefault(_classicInformation);

var _subscribeInformation = require('./partial/subscribe-information.vue');

var _subscribeInformation2 = _interopRequireDefault(_subscribeInformation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('auto-pay-plan-list', _list2.default);
_vue2.default.component('auto-pay-plan-create-modal', _create2.default);
_vue2.default.component('auto-pay-plan-preview-modal', _preview2.default);
_vue2.default.component('auto-pay-plan-view-modal', _view2.default);
_vue2.default.component('auto-pay-plan-template-modal', _template2.default);
_vue2.default.component('auto-pay-plan-edit-modal', _edit2.default);

//partial
_vue2.default.component('auto-pay-plan-view-modal-view-table', _viewTable2.default);
_vue2.default.component('auto-pay-plan-classic-information', _classicInformation2.default);
_vue2.default.component('auto-pay-plan-subscribe-information', _subscribeInformation2.default);

},{"./create.vue":1068,"./edit.vue":1069,"./list.vue":1071,"./partial/classic-information.vue":1072,"./partial/subscribe-information.vue":1073,"./partial/view-table.vue":1074,"./preview.vue":1075,"./template.vue":1076,"./view.vue":1077,"vue":792}],1071:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n#auto-pay-plan-list[_v-e0b6a0fa] {\n  min-height: 100px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['memberId', 'studioId'],
    data: function data() {
        var _this = this;

        return {
            alert: '',
            allow_to_use: false,
            branch_ajaxing: false,
            credit_ajax: false,
            plan_ajaxing: false,
            payment_ajaxing: false,
            branches: [],
            branch_id: 0,
            selected_payload_id: '',
            payments: [],
            plans: {},
            tableConfig: {
                columns: [{
                    keys: 'start_date',
                    head: '期程',
                    html: function html(plan) {
                        var count_details = plan.count_details;
                        if (count_details == 0) {
                            count_details = '<i class="fa fa-refresh" aria-hidden="true"></i>';
                        }
                        return '<div>' + plan.start_date + ' ~ ' + plan.end_date + '</div><div class="color-gray"> ' + plan.count_done_details + ' / ' + count_details + '</div>';
                    },
                    disabledClick: false
                }, {
                    keys: 'total_unpaid',
                    head: '尚未完成結帳',
                    disabledClick: false
                }, {
                    keys: 'total_paid',
                    head: '累計已結帳金額',
                    disabledClick: false
                }, {
                    keys: 'category',
                    head: '支付模式',
                    disabledClick: false
                }, {
                    keys: 'id',
                    head: '',
                    minWidth: '2em',
                    component: {
                        name: 'v-smart-button',
                        vBind: function vBind(item) {
                            return {
                                'button-show': item.category != '訂閱',
                                'click-function-event': _this.editPlanDataModal,
                                'click-data': { 'id': item.id },
                                'button-string': '編輯'
                            };
                        }
                    }
                }, {
                    keys: 'id',
                    head: '',
                    minWidth: '2em',
                    component: {
                        name: 'v-smart-button',
                        vBind: function vBind(item) {
                            return {
                                'button-show': true,
                                'click-function-event': _this.editPlanDetailModal,
                                'click-data': { 'id': item.id },
                                'button-string': '查看'
                            };
                        }
                    }
                }]
            }
        };
    },
    created: function created() {
        var _this2 = this;

        window.Event.$on('add-binding-member-credit-card-branch', function (payload) {
            _this2.getPayments();
        });
        window.Event.$on('auto-pay-plan-refresh', function () {
            _this2.getPlans();
        });
    },
    mounted: function mounted() {
        if (this.isBranch) {
            this.branch_id = this.branchId;
            window.Event.$emit('auto-pay-plan-branch', { id: this.branchId });
        } else if (this.studioId > 0) {
            this.getBranches();
        }
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['branchId', 'isBranch', 'isSeventeen']), (0, _vuex.mapState)("webadmin/baseReport", ["filterOptions", "pageMeta", "queryPara"]), (0, _vuex.mapState)({
        canReadAutoPayPlan: function canReadAutoPayPlan(state) {
            return state.webadmin.configure.webFunctions.WebadminAutoPayPlanIndex;
        },
        canCreateAutoPayPlan: function canCreateAutoPayPlan(state) {
            return state.webadmin.configure.webFunctions.WebadminAutoPayPlanCreate;
        }
    })),
    watch: {
        branch_id: function branch_id(val, oldV) {
            if (val > 0) {
                this.checkAllowToUseByBranch();
                this.getPayments();
                this.getPlans();
            }
        }
    },
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)("webadmin/baseReport", ["changeFilterOption"]), {
        deletePayload: function deletePayload() {
            var vm = this;
            if (!vm.selected_payload_id) {
                return;
            }
            $17.swal({
                title: '確認刪除支付方式?',
                text: '',
                type: 'warning',
                confirmButtonText: '確定'
            }, (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                var checkStatus;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                $.blockUI();
                                checkStatus = null;
                                _context2.next = 4;
                                return vm.deletePayloadCheck().then(function (response) {
                                    checkStatus = response.data.status;
                                });

                            case 4:
                                if (checkStatus) {
                                    _context2.next = 10;
                                    break;
                                }

                                $.unblockUI();
                                $17.swal({
                                    title: '此支付方式已被使用，請確認是否要刪除?',
                                    text: '',
                                    type: 'warning',
                                    confirmButtonText: '確定'
                                }, (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                                    return _regenerator2.default.wrap(function _callee$(_context) {
                                        while (1) {
                                            switch (_context.prev = _context.next) {
                                                case 0:
                                                    $.blockUI();
                                                    vm.$http.delete('/adminapi/branch_payment_payload/' + vm.selected_payload_id).then(function (response) {
                                                        vm.getPayments();
                                                        $17.swal({
                                                            title: '刪除成功',
                                                            type: 'success',
                                                            showCancelButton: false
                                                        });
                                                        $.unblockUI();
                                                    }).catch(function (response) {
                                                        $17.swal({
                                                            title: '刪除失敗，請重新整理',
                                                            text: response.data.hasOwnProperty('message') ? response.data.message : '',
                                                            type: 'warning',
                                                            showCancelButton: false
                                                        });
                                                        $.unblockUI();
                                                    });

                                                case 2:
                                                case 'end':
                                                    return _context.stop();
                                            }
                                        }
                                    }, _callee, this);
                                })));

                                return _context2.abrupt('return');

                            case 10:
                                vm.$http.delete('/adminapi/branch_payment_payload/' + vm.selected_payload_id).then(function (response) {
                                    vm.getPayments();
                                    $17.swal({
                                        title: '刪除成功',
                                        type: 'success',
                                        showCancelButton: false
                                    });
                                    $.unblockUI();
                                }).catch(function (response) {
                                    $17.swal({
                                        title: '刪除失敗，請重新整理',
                                        text: response.data.hasOwnProperty('message') ? response.data.message : '',
                                        type: 'warning',
                                        showCancelButton: false
                                    });
                                    $.unblockUI();
                                });

                            case 11:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            })));
        },
        deletePayloadCheck: function deletePayloadCheck() {
            var _this3 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return _this3.$http.get('/adminapi/branch_payment_payload/' + _this3.selected_payload_id + '/delete-check');

                            case 2:
                                return _context3.abrupt('return', _context3.sent);

                            case 3:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3);
            }))();
        },
        editPlanDetailModal: function editPlanDetailModal(data) {
            var planId = data.id;
            window.Event.$emit('auto-pay-plan-view', { planId: planId, allPayments: this.payments, allowToUse: this.allow_to_use });
        },
        changeBranch: function changeBranch(e) {
            var branch = this.branches[e.target.selectedIndex];
            window.Event.$emit('auto-pay-plan-branch', branch);
        },
        getBranches: function getBranches() {
            var _this4 = this;

            if (this.studioId == '' || this.studioId == 0) return;
            this.branch_ajaxing = true;
            this.$http.get('/adminapi/init/branch_select_list?studio_id=' + this.studioId).then(function (response) {
                _this4.branches = response.data.branches;
                _this4.branch_id = _this4.branches[0].id;
                _this4.branch_ajaxing = false;
                window.Event.$emit('auto-pay-plan-branch', _this4.branches[0]);
            }).catch(function (response) {
                $17.swal({
                    title: '取得場館列表失敗',
                    type: 'warning',
                    showCancelButton: false
                });
            });
        },
        getPayments: function getPayments() {
            var _this5 = this;

            this.payment_ajaxing = true;
            this.$http.get('/adminapi/branch_payment_payload/member/' + this.memberId + '/branch/' + this.branch_id + '/auto_pay_plan?allow_scope=merchant').then(function (response) {
                _this5.payments = response.data.payments;
                _this5.selected_payload_id = _this5.payments.length ? _this5.payments[0].id : '';
                _this5.payment_ajaxing = false;
            }).catch(function (response) {
                $17.swal({
                    title: '取得會員可用的支付方式失敗',
                    type: 'warning',
                    showCancelButton: false
                });
                _this5.payment_ajaxing = false;
            });
        },
        checkAllowToUseByBranch: function checkAllowToUseByBranch() {
            var _this6 = this;

            this.$http.get('/adminapi/auto_pay_plan/check_branch/' + this.branch_id).then(function (response) {
                _this6.allow_to_use = true;
            }).catch(function (response) {
                _this6.allow_to_use = false;
                _this6.alert = response.data.hasOwnProperty('error') ? response.data.error : '發生不明錯誤，請重新整理';
            });
        },
        changePage: function changePage(page) {
            var _this7 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
                var params;
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _this7.changeFilterOption({
                                    prop: "page",
                                    value: page
                                });

                                params = _this7.queryPara;


                                params.page_size = _this7.filterOptions.pageSize;
                                params.page = _this7.filterOptions.page;

                                _context4.next = 6;
                                return _this7.getPlans(params);

                            case 6:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this7);
            }))();
        },
        getPlans: function getPlans(params) {
            var _this8 = this;

            this.plan_ajaxing = true;
            this.$http.get('/adminapi/auto_pay_plan/list', { params: (0, _extends3.default)({ branch_id: this.branch_id, member_id: this.memberId }, params) }).then(function (response) {
                _this8.plans = response.data;
                _this8.plan_ajaxing = false;
            }).catch(function (response) {
                $17.swal({
                    title: '取得自動支付計畫列表失敗',
                    type: 'warning',
                    showCancelButton: false
                });
            });
        },
        createPlanModal: function createPlanModal() {
            window.Event.$emit('auto-pay-plan-open-create', { payments: this.payments });
        },
        addCreditModal: function addCreditModal() {
            $('#add-credit-modal').modal('show');
        },
        editPlanDataModal: function editPlanDataModal(data) {
            var planId = data.id;
            window.Event.$emit('auto-pay-plan-open-edit', { planId: planId, allPayments: this.payments, allowToUse: this.allow_to_use });
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div id=\"auto-pay-plan-list\" _v-e0b6a0fa=\"\">\n    <v-spinner :ajaxing=\"branch_ajaxing\" _v-e0b6a0fa=\"\"></v-spinner>\n    <div v-if=\"!branch_ajaxing\" _v-e0b6a0fa=\"\">\n        <div class=\"row\" _v-e0b6a0fa=\"\">\n            <div class=\"col-md-4\" v-show=\"!isBranch\" _v-e0b6a0fa=\"\">\n                <select class=\"form-control\" v-model=\"branch_id\" @change=\"changeBranch($event)\" _v-e0b6a0fa=\"\">\n                    <option v-for=\"branch in branches\" :value=\"branch.id\" _v-e0b6a0fa=\"\">{{branch.branch_name}}</option>\n                </select>\n            </div>\n        </div>\n        <div v-show=\"alert!==''&amp;&amp;!allow_to_use\" class=\"alert alert-danger m-top-5\" role=\"alert\" _v-e0b6a0fa=\"\">\n            <button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-label=\"Close\" _v-e0b6a0fa=\"\">\n                <span aria-hidden=\"true\" _v-e0b6a0fa=\"\">×</span>\n            </button>\n            {{alert}}\n        </div>\n        <div _v-e0b6a0fa=\"\">\n            <div class=\"row\" _v-e0b6a0fa=\"\">\n                <div class=\"col-md-5  m-top-10 m-bottom-5\" _v-e0b6a0fa=\"\">\n                    <button class=\"btn btn-primary\" v-if=\"allow_to_use&amp;&amp;canCreateAutoPayPlan&amp;&amp;!isSeventeen\" @click=\"createPlanModal()\" _v-e0b6a0fa=\"\">新增自動支付計畫</button>\n                </div>\n                <v-spinner-button :ajaxing=\"payment_ajaxing\" _v-e0b6a0fa=\"\"></v-spinner-button>\n                <div v-if=\"!payment_ajaxing\" class=\"add-cards col-md-7 m-top-10 m-bottom-5\" _v-e0b6a0fa=\"\">\n                    <span class=\"pull-left p-top-5\" _v-e0b6a0fa=\"\">可用的支付方式：</span>\n                    <select v-if=\"payments.length\" v-model=\"selected_payload_id\" class=\"form-control pull-left\" style=\"width: 150px;\" _v-e0b6a0fa=\"\">\n                        <option v-for=\"payload in payments\" :value=\"payload.id\" :checked=\"selected_payload_id==payload.id\" _v-e0b6a0fa=\"\">{{payload.payable_show}}</option>\n                    </select>\n                    <span class=\"dropdown\" _v-e0b6a0fa=\"\">\n                        <button class=\"btn btn-xs btn-default dropdown-toggle\" type=\"button\" id=\"drop5\" data-toggle=\"dropdown\" _v-e0b6a0fa=\"\">\n                            <span _v-e0b6a0fa=\"\">\n                                <i class=\"fa fa-cog fa-2x\" _v-e0b6a0fa=\"\"></i>\n                            </span>\n                        </button>\n                        <ul class=\"dropdown-menu\" aria-labelledby=\"drop5\" _v-e0b6a0fa=\"\">\n                            <li _v-e0b6a0fa=\"\">\n                                <a v-if=\"allow_to_use&amp;&amp;canCreateAutoPayPlan&amp;&amp;!isSeventeen\" style=\"font-weight: bold;\" @click.prevent.stop=\"addCreditModal()\" _v-e0b6a0fa=\"\">新增</a>\n                            </li>\n                            <li v-if=\"payments.length\" _v-e0b6a0fa=\"\">\n                                <a v-if=\"allow_to_use&amp;&amp;canCreateAutoPayPlan&amp;&amp;!isSeventeen\" style=\"font-weight: bold;\" @click.prevent.stop=\"deletePayload()\" _v-e0b6a0fa=\"\">刪除</a>\n                            </li>\n                        </ul>\n                    </span>\n                </div>\n            </div>\n            <div class=\"row m-top-20\" _v-e0b6a0fa=\"\">\n                <div class=\"col-xs-12\" _v-e0b6a0fa=\"\">\n                    <v-spinner :ajaxing=\"plan_ajaxing\" _v-e0b6a0fa=\"\"></v-spinner>\n                    <v-smart-table ref=\"smart_table\" :table-config=\"tableConfig\" :is-ajaxing=\"plan_ajaxing\" :data=\"plans\" :page-sync-url-query=\"false\" @change-page=\"changePage\" _v-e0b6a0fa=\"\"></v-smart-table>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n#auto-pay-plan-list[_v-e0b6a0fa] {\n  min-height: 100px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-e0b6a0fa", module.exports)
  } else {
    hotAPI.update("_v-e0b6a0fa", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1072:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.w-50[_v-1cbdb3e4] {\n  width: 50px; }\n\n/* line 6, stdin */\n.w-100[_v-1cbdb3e4] {\n  width: 100px !important; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['plan', 'payments', 'allowToUse', 'initSelectedPayments'],
    data: function data() {
        return {
            postData: {
                payments: []
            }
        };
    },

    watch: {
        initSelectedPayments: {
            handler: function handler(val, oldVal) {
                console.log(val);
                this.postData.payments = val;
            },
            deep: true
        }
    },
    mounted: function mounted() {
        this.postData.payments = this.initSelectedPayments;
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['isSeventeen']), (0, _vuex.mapState)({
        canUpdateAutoPayPlan: function canUpdateAutoPayPlan(state) {
            return state.webadmin.configure.webFunctions.WebadminAutoPayPlanUpdate;
        }
    })),
    methods: {
        selectEventAppend: function selectEventAppend(option) {
            this.appendPaymentPayload(option.id);
        },
        removeEventAppend: function removeEventAppend(option) {
            this.deletePaymentPayload(option.id);
        },
        deletePaymentPayload: function deletePaymentPayload(payloadId) {
            $.blockUI();
            this.$http.delete('/adminapi/auto_pay_plan/delete/branch_payment_payload/' + this.plan.id, { body: { payload_id: payloadId } }).then(function (response) {
                $.unblockUI();
            }).catch(function (response) {
                $17.swal({
                    title: '刪除失敗，請重新整理',
                    text: response.data.hasOwnProperty('message') ? response.data.message : '',
                    type: 'warning',
                    showCancelButton: false
                });
                $.unblockUI();
            });
        },
        appendPaymentPayload: function appendPaymentPayload(payloadId) {
            $.blockUI();
            this.$http.post('/adminapi/auto_pay_plan/create/branch_payment_payload/' + this.plan.id, { payload_id: payloadId }).then(function (response) {
                $.unblockUI();
            }).catch(function (response) {
                $17.swal({
                    title: '新增失敗，請重新整理',
                    text: response.data.hasOwnProperty('message') ? response.data.message : '',
                    type: 'warning',
                    showCancelButton: false
                });
                $.unblockUI();
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-1cbdb3e4=\"\">\n    <div class=\"row m-bottom-10\" v-show=\"plan.salesman!==''\" _v-1cbdb3e4=\"\">\n        <div class=\"col-xs-12\" _v-1cbdb3e4=\"\">\n            <label _v-1cbdb3e4=\"\">業務代表：{{plan.salesman}}</label>\n        </div>\n    </div>\n    <div class=\"row\" v-show=\"plan.is_done==0\" _v-1cbdb3e4=\"\">\n        <div class=\"col-xs-12\" _v-1cbdb3e4=\"\">\n            <label _v-1cbdb3e4=\"\">支付方式：</label>\n            <v-mutiselect :disabled=\"!allowToUse||!canUpdateAutoPayPlan||isSeventeen\" :model.sync=\"postData.payments\" :options=\"payments\" :multiple=\"true\" :close-on-select=\"true\" :clear-on-select=\"true\" :searchable=\"true\" :select-event-append=\"selectEventAppend\" :remove-event-append=\"removeEventAppend\" label=\"payable_show\" track-by=\"id\" tag-name=\"payable_show\" placeholder=\"請選擇\" _v-1cbdb3e4=\"\">\n            </v-mutiselect>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.w-50[_v-1cbdb3e4] {\n  width: 50px; }\n\n/* line 6, stdin */\n.w-100[_v-1cbdb3e4] {\n  width: 100px !important; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-1cbdb3e4", module.exports)
  } else {
    hotAPI.update("_v-1cbdb3e4", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1073:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\nlabel[_v-49d4e4f4] {\n  font-family: Noto Sans TC;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 26px;\n  letter-spacing: 0px;\n  text-align: left; }\n\n/* line 12, stdin */\n.btn-danger[_v-49d4e4f4] {\n  padding-left: 48px;\n  padding-right: 48px; }\n\n/* line 16, stdin */\n.fa-history[_v-49d4e4f4] {\n  color: #888888; }\n\n/* line 20, stdin */\n.content[_v-49d4e4f4] {\n  margin: 30px 45px; }\n\n/* line 23, stdin */\n.tippy-name[_v-49d4e4f4] {\n  font-weight: 700;\n  color: #455A72; }\n\n/* line 27, stdin */\n.tippy-value[_v-49d4e4f4] {\n  font-weight: 400;\n  margin-left: 10px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _tippy = require('tippy.js');

var _tippy2 = _interopRequireDefault(_tippy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        rule: {
            default: ''
        },
        status: {
            default: ''
        },
        id: {
            default: null
        }
    },
    data: function data() {
        return {
            ajaxing: false,
            terminated: {
                terminated_at: '',
                terminated_by: ''
            },
            content: 'Loading...'
        };
    },

    methods: {
        stopSubscription: function stopSubscription() {
            if (this.id == null) {
                return;
            }
            var vm = this;
            $17.swal({
                title: '確認終止訂閱嗎?',
                text: '',
                type: 'warning',
                confirmButtonText: '確定'
            }, (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                vm.ajaxing = true;
                                vm.$http.post('/adminapi/auto_pay_plan/' + vm.id + '/auto-renewal/terminate').then(function (response) {
                                    vm.ajaxing = false;
                                    vm.$emit('get-details');
                                    window.Event.$emit('auto-pay-plan-refresh');
                                }).catch(function (response) {
                                    $17.swal({
                                        title: '終止失敗，請重新整理',
                                        text: response.data.hasOwnProperty('message') ? response.data.message : '',
                                        type: 'warning',
                                        showCancelButton: false
                                    });
                                    vm.ajaxing = false;
                                });

                            case 2:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            })));
        },
        initDate: function initDate(instance) {
            var _this = this;

            return this.$http.get("/adminapi/auto_pay_plan/" + this.id + "/auto-renewal/terminate").then(function (response) {
                _this.terminated = response.data;
                var template = _this.$el.getElementsByClassName('tippy')[0];
                return template;
            }).then(function (template) {
                instance.setProps({
                    content: template.innerHTML
                });
            });
        },
        showTippy: function showTippy(e) {
            var vm = this;
            var tooltip = (0, _tippy2.default)(e.target, {
                content: this.content,
                duration: 0,
                arrow: false,
                placement: 'right',
                theme: 'light-border',
                interactive: false,
                allowHTML: true,
                trigger: 'click',
                maxWidth: 'none',
                onShow: function onShow(instance) {
                    vm.initDate(instance);
                },
                onShown: function onShown(instance, event) {
                    instance.setProps({
                        interactive: true
                    });
                },
                onHidden: function onHidden(instance) {
                    instance.setProps({
                        content: this.content
                    });
                    instance.destroy();
                }
            });
            tooltip.show();
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-49d4e4f4=\"\">\n    <div class=\"row\" _v-49d4e4f4=\"\">\n        <div class=\"col-xs-12\" _v-49d4e4f4=\"\">\n            <label _v-49d4e4f4=\"\">17FIT 訂閱功能: {{rule}}</label>\n        </div>\n    </div>\n    <div class=\"row\" _v-49d4e4f4=\"\">\n        <div class=\"col-xs-12\" _v-49d4e4f4=\"\">\n            <label _v-49d4e4f4=\"\">17FIT 訂閱狀態: \n                <span v-if=\"status\" _v-49d4e4f4=\"\">\n                    訂閱中\n                </span>\n                <span v-else=\"\" _v-49d4e4f4=\"\">\n                    終止 \n                    <a target=\"_blank\" class=\"btn btn-default btn-xs\" @click.stop.prevent=\"showTippy($event)\" help=\"異動記錄\" _v-49d4e4f4=\"\">\n                        <i class=\"fa fa-history\" aria-hidden=\"true\" _v-49d4e4f4=\"\"></i>\n                    </a>\n                    <div class=\"tippy\" style=\"display:none\" _v-49d4e4f4=\"\">\n                        <div class=\"content\" _v-49d4e4f4=\"\">\n                            <div class=\"row m-bottom-10\" _v-49d4e4f4=\"\">\n                                <div class=\"col-xs-12\" _v-49d4e4f4=\"\">\n                                    <span class=\"tippy-name\" _v-49d4e4f4=\"\">終止時間</span>\n                                    <span class=\"tippy-value\" _v-49d4e4f4=\"\">{{ terminated.terminated_at}}</span>\n                                </div>\n                            </div>\n                            <div class=\"row\" _v-49d4e4f4=\"\">\n                                <div class=\"col-xs-12\" _v-49d4e4f4=\"\">\n                                    <span class=\"tippy-name\" _v-49d4e4f4=\"\">操作人員</span>\n                                    <span class=\"tippy-value\" _v-49d4e4f4=\"\">{{ terminated.terminated_by}}</span>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </span>\n            </label>\n        </div>\n    </div>\n    <div class=\"row m-top-15 m-bottom-30\" v-if=\"status\" _v-49d4e4f4=\"\">\n        <div class=\"col-xs-3\" _v-49d4e4f4=\"\">\n            <v-spinner-button :ajaxing=\"ajaxing\" fa-size=\"fa-3x\" _v-49d4e4f4=\"\"></v-spinner-button>\n            <div v-show=\"!ajaxing\" @click=\"stopSubscription\" class=\"btn btn-danger btn--inverse\" _v-49d4e4f4=\"\">\n                終止訂閱\n            </div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\nlabel[_v-49d4e4f4] {\n  font-family: Noto Sans TC;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 26px;\n  letter-spacing: 0px;\n  text-align: left; }\n\n/* line 12, stdin */\n.btn-danger[_v-49d4e4f4] {\n  padding-left: 48px;\n  padding-right: 48px; }\n\n/* line 16, stdin */\n.fa-history[_v-49d4e4f4] {\n  color: #888888; }\n\n/* line 20, stdin */\n.content[_v-49d4e4f4] {\n  margin: 30px 45px; }\n\n/* line 23, stdin */\n.tippy-name[_v-49d4e4f4] {\n  font-weight: 700;\n  color: #455A72; }\n\n/* line 27, stdin */\n.tippy-value[_v-49d4e4f4] {\n  font-weight: 400;\n  margin-left: 10px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-49d4e4f4", module.exports)
  } else {
    hotAPI.update("_v-49d4e4f4", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/regenerator":75,"tippy.js":780,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1074:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.w-50[_v-c39dddce] {\n  width: 50px; }\n\n/* line 6, stdin */\n.w-100[_v-c39dddce] {\n  width: 100px !important; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        details: {
            default: []
        },
        plan: {
            default: {}
        },
        allowEdit: {
            default: true
        }
    },
    data: function data() {
        return {
            alert: '',
            disabledDate: 'notBeforeToday',
            metaData: {
                count: 0,
                currentPage: 1,
                lastPage: 1,
                perPage: 12,
                total: 0
            },
            postData: {
                selected_data: {},
                selected_action: 'cancel',
                selected_detail_ids: []
            },
            action_mode: 'normal'
        };
    },

    watch: {
        details: function details(newVal) {
            this.metaData.total = newVal.length;
            this.metaData.count = newVal.length;
            this.metaData.currentPage = 1;
            this.metaData.lastPage = Math.ceil(newVal.length / this.metaData.perPage);
        }
    },
    mounted: function mounted() {
        this.metaData.total = this.details.length;
        this.metaData.count = this.details.length;
        this.metaData.currentPage = 1;
        this.metaData.lastPage = Math.ceil(this.details.length / this.metaData.perPage);
    },
    created: function created() {
        var _this = this;

        window.Event.$on('auto-pay-plan-view', function (data) {
            _this.alert = '';
            _this.postData = {
                selected_data: {},
                selected_action: 'cancel',
                selected_detail_ids: []
            };
            _this.action_mode = 'normal';
            _this.metaData.currentPage = 1;
        });
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['isSeventeen']), (0, _vuex.mapState)({
        canAutoPayPlanUpdateDetail: function canAutoPayPlanUpdateDetail(state) {
            return state.webadmin.configure.webFunctions.WebadminAutoPayPlanUpdateDetail;
        }
    }), {
        page_list: function page_list() {
            return this.paginate();
        }
    }),
    methods: {
        showCheckbox: function showCheckbox(detail) {
            var afterToday = moment(detail.date).isAfter(moment());
            return !this.isSeventeen && detail.status == 0 && afterToday && detail.cancel_at == null;
        },
        changeActionMode: function changeActionMode(mode) {
            this.action_mode = mode;
        },
        selectOne: function selectOne(e, detail) {
            var checked = e.target.checked;
            if (checked) {
                this.postData.selected_data[detail.id] = {
                    date: detail.date,
                    sub_total: detail.sub_total
                };
            } else {
                if (this.postData.selected_data.hasOwnProperty(detail.id)) {
                    delete this.postData.selected_data[detail.id];
                }
            }
        },
        saveSelectedData: function saveSelectedData() {
            if (!this.canAutoPayPlanUpdateDetail) return;
            this.alert = '';
            var vm = this;
            if (this.postData.selected_action === 'cancel') {
                if (!this.postData.selected_detail_ids.length) {
                    $17.swal({
                        title: '您沒有勾選的項目',
                        type: 'warning',
                        showCancelButton: false
                    });
                    return false;
                }
                $17.swal({
                    title: '確認進行「取消排程」?',
                    type: 'warning',
                    confirmButtonText: '確定'
                }, function () {
                    $.blockUI();
                    vm.$http.post('/adminapi/auto_pay_plan/cancel_details/' + vm.plan.id, {
                        cancel_ids: vm.postData.selected_detail_ids
                    }).then(function (response) {
                        vm.postData.selected_detail_ids = [];
                        vm.postData.selected_data = {};
                        vm.postData.selected_action = 'cancel';
                        vm.action_mode = 'normal';

                        var data = response.data;
                        if (data.data.hasOwnProperty('is_empty_plan') && data.data.is_empty_plan == false) {
                            vm.getDetails();
                        } else {
                            $('#view-auto-pay-plan-modal').modal('hide');
                        }
                        window.Event.$emit('auto-pay-plan-refresh');
                        $17.swal({
                            title: '取消成功',
                            type: 'success',
                            showCancelButton: false
                        });
                        $.unblockUI();
                    }).catch(function (response) {
                        $17.swal({
                            title: '取消失敗',
                            text: response.data.hasOwnProperty('message') ? response.data.message : '',
                            type: 'error',
                            showCancelButton: false
                        });
                        $.unblockUI();
                    });
                });
            }
            if (this.postData.selected_action === 'update') {
                if (!(0, _keys2.default)(this.postData.selected_data).length) {
                    $17.swal({
                        title: '您沒有勾選的項目',
                        type: 'warning',
                        showCancelButton: false
                    });
                    return false;
                }

                var msg = '';
                try {
                    var dateException = 'dateException';
                    var subTotalException = 'subTotalException';
                    (0, _entries2.default)(this.postData.selected_data).forEach(function (_ref) {
                        var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
                            key = _ref2[0],
                            detail = _ref2[1];

                        if (!moment(detail.date).isValid()) {
                            msg += '請檢查「日期」格式\n';
                            throw dateException;
                        }
                        var subTotal = detail.sub_total;
                        if (subTotal < 1 || subTotal % 1 != 0 || subTotal > 100000) {
                            msg += '每項更新的「支付金額」，必須介於一元至十萬元之間、不可有小數點\n';
                            throw subTotalException;
                        }
                    });
                } catch (e) {
                    this.alert = msg;
                    return false;
                }

                $17.swal({
                    title: '確認進行「更新排程」?',
                    type: 'warning',
                    confirmButtonText: '確定'
                }, function () {
                    $.blockUI();
                    vm.$http.post('/adminapi/auto_pay_plan/update_details/' + vm.plan.id, {
                        update_data: vm.postData.selected_data
                    }).then(function (response) {
                        vm.postData.selected_detail_ids = [];
                        vm.postData.selected_data = {};
                        vm.postData.selected_action = 'cancel';
                        vm.action_mode = 'normal';

                        vm.getDetails();
                        window.Event.$emit('auto-pay-plan-refresh');
                        $17.swal({
                            title: '更新成功',
                            type: 'success',
                            showCancelButton: false
                        });
                        $.unblockUI();
                    }).catch(function (response) {
                        $17.swal({
                            title: '更新失敗',
                            text: response.data.hasOwnProperty('message') ? response.data.message : '',
                            type: 'error',
                            showCancelButton: false
                        });
                        $.unblockUI();
                    });
                });
            }
        },
        getDetails: function getDetails() {
            this.$emit('get-details');
        },
        paginate: function paginate() {
            var pageNum = this.metaData.currentPage - 1;
            var start = pageNum * this.metaData.perPage;
            var end = (pageNum + 1) * this.metaData.perPage;
            return this.details.slice(start, end);
        },
        changePage: function changePage(page) {
            this.metaData.currentPage = page;
        },
        thousandthFormat: function thousandthFormat(money) {
            money = Math.abs(money);
            money = $17.thousandthFormat(money);
            return '$' + money;
        },
        createOrder: function createOrder(payload) {
            var _this2 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this2.openOrderModal({
                                    'order_id': '',
                                    'branch_id': payload.branch_id,
                                    'bind_auto_pay_plan_detail_id': payload.detail_id,
                                    'order_operate_type': 'edit'
                                });

                            case 2:
                                _this2.getDetails();

                            case 3:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        openOrderModal: function openOrderModal(payload) {
            var _this3 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return _this3.$store.dispatch('pos/openOrCreateOrder', { 'order_id': payload.order_id, 'bind_auto_pay_plan_detail_id': payload.bind_auto_pay_plan_detail_id }).then(function () {
                                    if (payload.order_operate_type == 'edit') {
                                        _this3.$store.dispatch('pos/getCommonlyUsedItem', payload.branch_id);
                                        $('#auto-pay-order-edit').modal('show');
                                    }

                                    if (payload.order_operate_type == 'show') {
                                        $('#auto-pay-order-show').modal('show');
                                    }
                                });

                            case 2:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        },
        checkValidDate: function checkValidDate(date) {
            return moment().isAfter(date);
        },
        openOperateOrder: function openOperateOrder(detail) {
            var type = detail.order_operate_type;

            if (detail.order_id == "") {
                type = 'edit';
            }
            window.Event.$emit("System.Pos.Order.Open", {
                'order_id': detail.order_id,
                'mode': type,
                'bind_auto_pay_plan_detail_id': detail.id,
                'event_calls': {
                    'fetchDetails': this.getDetails
                },
                'event_type': 'autoPay'
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-c39dddce=\"\">\n    <div v-if=\"canAutoPayPlanUpdateDetail &amp;&amp; allowEdit\" class=\"m-top-20 m-bottom-20\" _v-c39dddce=\"\">\n        <button v-if=\"action_mode==='normal'\" class=\"btn btn-primary\" @click=\"changeActionMode('edit')\" _v-c39dddce=\"\">編輯</button>\n        <div v-else=\"\" _v-c39dddce=\"\">\n            <select class=\"w-100\" v-model=\"postData.selected_action\" _v-c39dddce=\"\">\n                <option value=\"cancel\" _v-c39dddce=\"\">取消排程</option>\n                <option value=\"update\" _v-c39dddce=\"\">更新排程</option>\n            </select>\n            <button class=\"btn btn-primary\" @click=\"saveSelectedData\" _v-c39dddce=\"\">確認</button>\n            <button class=\"btn btn-default\" @click=\"changeActionMode('normal')\" _v-c39dddce=\"\">取消</button>\n        </div>\n    </div>\n    <div _v-c39dddce=\"\">\n        <div v-show=\"this.alert!==''\" class=\"alert alert-danger\" role=\"alert\" _v-c39dddce=\"\">\n            <button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-label=\"Close\" _v-c39dddce=\"\">\n                <span aria-hidden=\"true\" _v-c39dddce=\"\">×</span>\n            </button>\n            {{ alert }}\n        </div>\n        <div class=\"table-responsive m-top-20\" _v-c39dddce=\"\">\n            <table class=\"table table-hover\" _v-c39dddce=\"\">\n                <thead _v-c39dddce=\"\">\n                <tr _v-c39dddce=\"\">\n                    <th v-if=\"action_mode==='edit'\" _v-c39dddce=\"\"></th>\n                    <th _v-c39dddce=\"\">排程日期</th>\n                    <th _v-c39dddce=\"\">金額</th>\n                    <th _v-c39dddce=\"\">購買方案</th>\n                    <th _v-c39dddce=\"\">排程支付結果</th>\n                    <th _v-c39dddce=\"\">訂單狀態</th>\n                    <th _v-c39dddce=\"\">訂單金額</th>\n                    <th _v-c39dddce=\"\">訂單編號</th>\n                </tr>\n                </thead>\n                <tbody _v-c39dddce=\"\">\n                <tr v-for=\"(detail,key,index) in page_list\" _v-c39dddce=\"\">\n                    <td v-if=\"action_mode==='edit'\" _v-c39dddce=\"\">\n                        <input v-if=\"showCheckbox(detail)\" type=\"checkbox\" @click=\"selectOne($event,detail)\" v-model=\"postData.selected_detail_ids\" :value=\"detail.id\" _v-c39dddce=\"\">\n                    </td>\n                    <td _v-c39dddce=\"\">\n                        <v-date-picker v-if=\"action_mode==='edit' &amp;&amp; postData.selected_data.hasOwnProperty(detail.id)\" v-model=\"postData.selected_data[detail.id].date\" :disabled-date=\"disabledDate\" :editable=\"false\" :clearable=\"false\" input-class=\"form-control w-100\" _v-c39dddce=\"\"></v-date-picker>\n                        <span v-else=\"\" _v-c39dddce=\"\">{{detail.date}}</span>\n                    </td>\n                    <td _v-c39dddce=\"\">\n                        <input v-if=\"action_mode==='edit' &amp;&amp; postData.selected_data.hasOwnProperty(detail.id)\" type=\"number\" step=\"1\" min=\"1\" onwheel=\"this.blur()\" v-model=\"postData.selected_data[detail.id].sub_total\" class=\"form-control w-100\" _v-c39dddce=\"\">\n                        <span v-else=\"\" _v-c39dddce=\"\">{{thousandthFormat(detail.sub_total)}}</span>\n                    </td>\n                    <td _v-c39dddce=\"\">{{plan.buy_name}}</td>\n                    <td _v-c39dddce=\"\">{{detail.status_show}}</td>\n                    <td _v-c39dddce=\"\">{{detail.order_payment_status_name}}</td>\n                    <td _v-c39dddce=\"\">\n                    <span v-if=\"detail.order_total!=0\" _v-c39dddce=\"\">{{thousandthFormat(detail.order_total)}}</span>\n                    <span v-else=\"\" _v-c39dddce=\"\"></span>\n                    </td>\n                    <td _v-c39dddce=\"\">\n                        <span v-if=\"detail.order_id !=''\" _v-c39dddce=\"\">\n                            <a href=\"\" @click.prevent.stop=\"openOperateOrder(detail)\" _v-c39dddce=\"\">\n                            {{detail.order_id}}\n                            </a>\n                        </span>\n                        <span v-else=\"\" _v-c39dddce=\"\">\n                            <div class=\"btn btn-success\" v-if=\"checkValidDate(detail.date)\" @click=\"openOperateOrder(detail)\" _v-c39dddce=\"\">\n                                立即結帳\n                            </div>\n                        </span>\n                    </td>\n                </tr>\n                </tbody>\n            </table>\n        </div>\n    </div>\n    <div class=\"text-center\" _v-c39dddce=\"\">\n        <v-sql-pagination-noquery :page-meta=\"metaData\" @page-change-callback=\"changePage\" _v-c39dddce=\"\"></v-sql-pagination-noquery>   \n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.w-50[_v-c39dddce] {\n  width: 50px; }\n\n/* line 6, stdin */\n.w-100[_v-c39dddce] {\n  width: 100px !important; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-c39dddce", module.exports)
  } else {
    hotAPI.update("_v-c39dddce", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/object/entries":54,"babel-runtime/core-js/object/keys":56,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/helpers/slicedToArray":70,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1075:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.w-50[_v-c03a701a] {\n  width: 50px; }\n\n/* line 6, stdin */\n.w-100[_v-c03a701a] {\n  width: 100px; }\n\n/* line 10, stdin */\n.on-focus[_v-c03a701a] {\n  border: 1px solid red; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['memberId'],
    data: function data() {
        return {
            alert: '',
            pagination: {
                per_page: 12,
                current_page: 1
            },
            postData: {},
            previewData: {}
        };
    },
    created: function created() {
        var _this = this;

        window.Event.$on('auto-pay-plan-pass-to-preview', function (data) {
            _this.alert = '';
            _this.pagination.current_page = 1;
            _this.previewData = data.previewData;
            _this.postData = data.postData;
            $('#preview-auto-pay-plan-modal').modal('show');
        });
    },
    mounted: function mounted() {
        var vm = this;
        this.$nextTick(function () {
            $('#preview-auto-pay-plan-modal').on('shown.bs.modal', function () {
                $('.vue-datetimepicker').datetimepicker({
                    format: 'YYYY-MM-DD',
                    locale: 'zh-tw'
                }).on('dp.change', function (e) {
                    var current = $(e.target);
                    var name = current.attr('name');
                    var value = current.val();
                    vm.previewData[name.toString()]['date'] = value;
                });
            });
        });
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        canCreateAutoPayPlan: function canCreateAutoPayPlan(state) {
            return state.webadmin.configure.webFunctions.WebadminAutoPayPlanCreate;
        }
    }), {
        page_list: function page_list() {
            return this.paginate();
        },
        page_count: function page_count() {
            return Math.ceil((0, _keys2.default)(this.previewData).length / this.pagination.per_page);
        }
    }),
    methods: {
        checkFocusClass: function checkFocusClass(key) {
            var keys = (0, _keys2.default)(this.previewData);
            if (keys.length > 0) {
                var currentIdx = keys.indexOf(key);
                if (currentIdx > 0) {
                    if (this.previewData[key.toString()].date <= this.previewData[keys[currentIdx - 1]].date) {
                        return true;
                    }
                }
            }
            return false;
        },
        submit: function submit() {
            var _this2 = this;

            var msg = '';
            try {
                var dateException = 'dateException';
                var subTotalException = 'subTotalException';
                var checkIndex = 0;
                var keys = (0, _keys2.default)(this.previewData);
                (0, _entries2.default)(this.previewData).forEach(function (_ref) {
                    var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
                        key = _ref2[0],
                        detail = _ref2[1];

                    if (checkIndex === 0 && moment(detail.date).isBefore(_this2.postData.start_date)) {
                        msg += '第 1 項「日期」不可早於計畫開始日\n';
                        throw dateException;
                    }
                    if (!moment(detail.date).isValid()) {
                        msg += '第' + (checkIndex + 1) + '項「日期」格式錯誤\n';
                        throw dateException;
                    }
                    if (checkIndex > 0 && detail.date <= _this2.previewData[keys[checkIndex - 1]].date) {
                        msg += '請檢查紅框處需大於上一個日期\n';
                        throw dateException;
                    }
                    var subTotal = detail.sub_total;
                    if (subTotal < 1 || subTotal % 1 != 0 || subTotal > 100000) {
                        msg += '第' + (checkIndex + 1) + '項「支付金額」，必須介於一元至十萬元之間、不可有小數點\n';
                        throw subTotalException;
                    }
                    checkIndex++;
                });
            } catch (e) {
                this.alert = msg;
                return false;
            }

            $.blockUI();
            var total = 0;
            (0, _entries2.default)(this.previewData).forEach(function (entry) {
                total += parseInt(entry[1].sub_total);
            });
            var createData = this.postData;
            createData['member_id'] = this.memberId;
            createData['details'] = this.previewData;
            createData['total'] = total;

            this.$http.post('/adminapi/auto_pay_plan/create', createData).then(function (response) {
                $.unblockUI();
                $17.swal({
                    title: '新增成功',
                    text: '',
                    type: 'success',
                    showCancelButton: false
                });
                $('#preview-auto-pay-plan-modal').modal('hide');
                $('#create-auto-pay-plan-modal').modal('hide');
                window.Event.$emit('auto-pay-plan-refresh');
            }).catch(function (response) {
                $.unblockUI();
                $17.swal({
                    title: '新增失敗',
                    text: response.data.hasOwnProperty('message') ? response.data.message : '',
                    type: 'error',
                    showCancelButton: false
                });
            });
        },
        paginate: function paginate() {
            var pageNum = this.pagination.current_page - 1;
            var start = pageNum * this.pagination.per_page;
            var end = (pageNum + 1) * this.pagination.per_page;
            var list = {};
            (0, _entries2.default)(this.previewData).slice(start, end).forEach(function (entry) {
                list[entry[0]] = entry[1];
            });
            return list;
        },
        changePage: function changePage(page) {
            this.pagination.current_page = page;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal v-show=\"canCreateAutoPayPlan\" id=\"preview-auto-pay-plan-modal\" open-size=\"modal-lg\" confirm-btn-text=\"確認送出\" no-cancel=\"\" parallel-modal=\"\" :save-clicked=\"submit\" _v-c03a701a=\"\">\n    <h4 slot=\"title\" _v-c03a701a=\"\">新增自動支付計畫</h4>\n    <div slot=\"body\" _v-c03a701a=\"\">\n        <div _v-c03a701a=\"\">\n            <div v-show=\"this.alert!==''\" class=\"alert alert-danger\" role=\"alert\" _v-c03a701a=\"\">\n                <button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-label=\"Close\" _v-c03a701a=\"\">\n                    <span aria-hidden=\"true\" _v-c03a701a=\"\">×</span>\n                </button>\n                {{alert}}\n            </div>\n            <div class=\"table-responsive\" _v-c03a701a=\"\">\n                <table class=\"table table-hover\" _v-c03a701a=\"\">\n                    <thead _v-c03a701a=\"\">\n                    <tr _v-c03a701a=\"\">\n                        <th _v-c03a701a=\"\"></th>\n                        <th _v-c03a701a=\"\">日期</th>\n                        <th _v-c03a701a=\"\">支付金額</th>\n                        <th _v-c03a701a=\"\">購買方案</th>\n                        <th _v-c03a701a=\"\">發票</th>\n                    </tr>\n                    </thead>\n                    <tbody _v-c03a701a=\"\">\n                    <tr v-for=\"(row,key,index) in page_list\" _v-c03a701a=\"\">\n                        <td class=\"text-center\" _v-c03a701a=\"\">\n                            {{pagination.current_page&gt;1?((pagination.current_page-1)*pagination.per_page)+index+1:index+1}}\n                        </td>\n                        <td _v-c03a701a=\"\"><input type=\"text\" :class=\"{'on-focus': checkFocusClass(key)}\" :ref=\"'date'+key\" :name=\"key\" v-model=\"previewData[key].date\" class=\"form-control w-100 vue-datetimepicker\" _v-c03a701a=\"\"></td>\n                        <td _v-c03a701a=\"\"><input type=\"number\" step=\"1\" min=\"1\" v-model=\"previewData[key].sub_total\" class=\"form-control w-100\" onwheel=\"this.blur()\" _v-c03a701a=\"\"></td>\n                        <td _v-c03a701a=\"\">{{postData.contract_name}}</td>\n                        <td _v-c03a701a=\"\">{{postData.issue_name}}</td>\n                    </tr>\n                    </tbody>\n                </table>\n            </div>\n            <div class=\"text-center\" _v-c03a701a=\"\">\n                <v-paginate v-model=\"pagination.current_page\" :page-count=\"page_count\" container-class=\"pagination\" prev-text=\"<<\" next-text=\">>\" :click-handler=\"changePage\" _v-c03a701a=\"\">\n                </v-paginate>\n            </div>\n        </div>\n    </div>\n</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.w-50[_v-c03a701a] {\n  width: 50px; }\n\n/* line 6, stdin */\n.w-100[_v-c03a701a] {\n  width: 100px; }\n\n/* line 10, stdin */\n.on-focus[_v-c03a701a] {\n  border: 1px solid red; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-c03a701a", module.exports)
  } else {
    hotAPI.update("_v-c03a701a", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/object/entries":54,"babel-runtime/core-js/object/keys":56,"babel-runtime/helpers/extends":66,"babel-runtime/helpers/slicedToArray":70,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1076:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.w-50[_v-76230edf] {\n  width: 50px; }\n\n/* line 6, stdin */\n.w-100[_v-76230edf] {\n  width: 100px; }\n\n/* line 10, stdin */\n.w-200[_v-76230edf] {\n  width: 200px; }\n\n/* line 14, stdin */\n.d-inline[_v-76230edf] {\n  display: inline-block; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['memberId', 'studioId'],
    data: function data() {
        return {
            ajaxing: false,
            ajaxing_contracts: false,
            branch: {},
            price: 0,
            view: {
                contracts: []
            },
            postData: {
                total: 0,
                buyable_id: '',
                name: '',
                frequency: 0,
                pay_times: '',
                per_days: '',
                date_each_month: ''
            },
            confirmText: '儲存',
            enableDelete: false,
            templateTitle: '新增'
        };
    },
    created: function created() {
        var _this = this;

        window.Event.$on('auto-pay-plan-open-template', function (data) {
            _this.resetData();
            if (data.contracts.length !== 0) {
                _this.view.contracts = data.contracts;
            } else {
                _this.getContracts();
            }
            $('#template-auto-pay-plan-modal').modal('show');
        });
        window.Event.$on('auto-pay-plan-edit-template', function (data) {
            _this.resetData();
            _this.confirmText = '確定';
            _this.enableDelete = true;
            _this.templateTitle = '編輯';
            if (data.contracts.length !== 0) {
                _this.view.contracts = data.contracts;
            } else {
                _this.getContracts();
            }
            _this.getTemplate(data.template_id);
            $('#template-auto-pay-plan-modal').modal('show');
        });
        window.Event.$on('auto-pay-plan-branch', function (branch) {
            _this.branch = branch;
        });
    },
    mounted: function mounted() {
        var vm = this;
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['isBranch']), (0, _vuex.mapState)({
        customer: function customer(state) {
            return state.webadmin.crm.member;
        },
        canCreateAutoPayPlan: function canCreateAutoPayPlan(state) {
            return state.webadmin.configure.webFunctions.WebadminAutoPayPlanCreate;
        }
    }), {
        monthDays: function monthDays() {
            var days = [];
            for (var i = 1; i <= 28; i++) {
                days.push(i);
            }
            return days;
        }
    }),
    watch: {
        'postData.pay_times': function postDataPay_times(val, oldV) {
            if (val > 120) {
                this.postData.pay_times = 120;
            }
            if (val < 1) {
                this.postData.pay_times = 1;
            }
        }
    },
    methods: {
        submit: function submit() {
            if (this.postData.frequency == 0 && (this.postData.per_days < 1 || this.postData.per_days > 365 || this.postData.per_days.trim() == '')) {
                this.alert('頻率', '天數必須大於 1 天、小於 365 天', 'warning');
                return false;
            }
            if (this.postData.frequency == 1 && !this.postData.date_each_month) {
                this.alert('頻率', '請選擇每月幾號', 'warning');
                return false;
            }
            if (this.postData.pay_times <= 0 || !this.postData.pay_times) {
                this.alert('次數', '必須介於1次至120次之間', 'warning');
                return false;
            }
            if (!this.postData.buyable_id) {
                this.alert('請選擇購買方案', '', 'warning');
                return false;
            }
            if (this.price <= 0 || this.price > 100000 || !this.price) {
                this.alert('金額', '必須介於一元至十萬元之間', 'warning');
                return false;
            }
            if (!this.postData.name || this.postData.name == '') {
                this.alert('請填寫模板名稱', '', 'warning');
                return false;
            }

            var data = {
                studio_id: this.studioId,
                branch_id: this.branch.id,
                contract_id: this.postData.buyable_id,
                name: this.postData.name,
                price: this.price,
                frequency: this.postData.frequency,
                pay_times: this.postData.pay_times,
                per_days: this.postData.frequency == 0 ? this.postData.per_days : '',
                date_each_month: this.postData.frequency == 1 ? this.postData.date_each_month : ''
            };

            if (!this.postData.id) {
                this.createTmplate(data);
            } else {
                this.editTmplate(data);
            }
        },
        createTmplate: function createTmplate(data) {
            this.$http.post('/adminapi/auto_pay_plan_template/create', data).then(function (response) {
                window.Event.$emit('auto-pay-plan-template', { template_id: response.data.id });
                $.unblockUI();
                $17.swal({
                    title: '新增成功',
                    text: '',
                    type: 'success',
                    showCancelButton: false
                });
                $('#template-auto-pay-plan-modal').modal('hide');
            });
        },
        editTmplate: function editTmplate(data) {
            this.$http.post('/adminapi/auto_pay_plan_template/edit/' + this.postData.id, data).then(function (response) {
                window.Event.$emit('auto-pay-plan-template', { template_id: this.postData.id });
                $.unblockUI();
                $17.swal({
                    title: '修改成功',
                    text: '',
                    type: 'success',
                    showCancelButton: false
                });
                $('#template-auto-pay-plan-modal').modal('hide');
            });
        },
        changeContract: function changeContract(e) {
            var target = this.$refs['contract' + e.target.value][0];
            var price = target.dataset.price;
            this.price = parseInt(price.replace(/[$,]/g, ''));
            this.postData.contract_name = target.dataset.name;
        },
        changeFrequency: function changeFrequency(data) {
            if (data) {
                this.postData.per_days = '';
            } else {
                this.postData.date_each_month = '';
            }
        },
        getContracts: function getContracts() {
            var _this2 = this;

            this.ajaxing_contracts = true;
            this.$http.get('/adminapi/pos/get_product_list/' + this.branch.id + '/contracts').then(function (response) {
                this.view.contracts = response.data.list;
                this.ajaxing_contracts = false;
            }).catch(function (response) {
                _this2.alert('取得方案列表失敗', '', 'warning');
                _this2.ajaxing_contracts = false;
            });
        },
        getTemplate: function getTemplate(id) {
            var _this3 = this;

            this.$http.get('/adminapi/auto_pay_plan_template/template/' + id).then(function (response) {
                this.postData = response.data;
                this.price = this.postData.price;
                this.postData.buyable_id = this.postData.contract_id;
            }).catch(function (response) {
                _this3.alert('取得資料失敗', '', 'warning');
            });
        },

        alert: function alert(title, message, type) {
            $17.swal({
                title: title,
                text: message,
                type: type,
                showCancelButton: false,
                showLoaderOnConfirm: true
            });
        },
        resetData: function resetData() {
            this.view = {
                contracts: []
            };
            this.postData = {
                total: 0,
                buyable_id: '',
                name: '',
                frequency: 0,
                pay_times: '',
                per_days: '',
                date_each_month: ''
            };
            this.price = 0;
        },
        removeClicked: function removeClicked() {
            var _this4 = this;

            $17.swal({
                title: '確認刪除「' + this.postData.name + '」?',
                type: 'warning'
            }, function () {
                $('#plan-function-group-modal').modal('hide');
                var url = '/adminapi/auto_pay_plan_template/delete/' + _this4.postData.id;
                _this4.$http.delete(url).then(function (response) {
                    window.Event.$emit('auto-pay-plan-template', { template_id: '' });
                    $.unblockUI();
                    $17.swal({
                        title: '刪除成功',
                        text: '',
                        type: 'success',
                        showCancelButton: false
                    });
                    $('#template-auto-pay-plan-modal').modal('hide');
                }, function (error) {
                    $('#plan-function-group-modal').modal('show');
                    $17.swal({
                        title: '刪除失敗',
                        text: error.data.message,
                        type: 'error',
                        showCancelButton: false
                    });
                });
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal v-show=\"canCreateAutoPayPlan\" id=\"template-auto-pay-plan-modal\" open-size=\"modal-lg\" :confirm-btn-text=\"confirmText\" no-cancel=\"\" parallel-modal=\"\" :remove-clicked=\"removeClicked\" :remove-btn-show=\"enableDelete\" :save-clicked=\"submit\" _v-76230edf=\"\">\n    <h4 slot=\"title\" _v-76230edf=\"\">{{templateTitle}}自動支付模板</h4>\n    <div slot=\"body\" _v-76230edf=\"\">\n        <v-spinner :ajaxing=\"ajaxing\" _v-76230edf=\"\"></v-spinner>\n        <div class=\"form-horizontal\" _v-76230edf=\"\">\n            <div class=\"form-group\" _v-76230edf=\"\">\n                <label class=\"col-sm-3 control-label p-t-0\" _v-76230edf=\"\">名稱</label>\n                <div class=\"col-sm-9\" _v-76230edf=\"\">\n                    <input type=\"text\" class=\"form-control w-200\" v-model=\"postData.name\" _v-76230edf=\"\">\n                </div>\n                <div class=\"col-sm-7\" _v-76230edf=\"\">\n                </div>\n            </div>\n            <hr _v-76230edf=\"\">\n            <div class=\"form-group\" _v-76230edf=\"\">\n                <label class=\"col-sm-3 control-label p-t-0\" _v-76230edf=\"\">頻率</label>\n                <div class=\"col-sm-9\" _v-76230edf=\"\">\n                    <label class=\"col-sm-4\" _v-76230edf=\"\">\n                        <input v-model=\"postData.frequency\" :checked=\"postData.frequency==0\" value=\"0\" type=\"radio\" @click=\"changeFrequency(0)\" _v-76230edf=\"\">\n                        每隔 <input type=\"number\" onwheel=\"this.blur()\" step=\"1\" maxlength=\"3\" min=\"1\" max=\"365\" class=\"form-control w-100 d-inline\" v-model=\"postData.per_days\" _v-76230edf=\"\">\n                        天\n                    </label>\n                    <label class=\"col-sm-4\" _v-76230edf=\"\">\n                        <input v-model=\"postData.frequency\" :checked=\"postData.frequency==1\" value=\"1\" type=\"radio\" @click=\"changeFrequency(1)\" _v-76230edf=\"\">\n                        每月\n                        <select v-model=\"postData.date_each_month\" class=\"form-control w-100 d-inline\" _v-76230edf=\"\">\n                            <option value=\"\" disabled=\"\" _v-76230edf=\"\">請選擇</option>\n                            <option v-for=\"day in monthDays\" :value=\"day\" _v-76230edf=\"\">{{day}}</option>\n                        </select> 號\n                    </label>\n                </div>\n            </div>\n            <div class=\"form-group\" _v-76230edf=\"\">\n                <label class=\"col-sm-3 control-label p-t-0\" _v-76230edf=\"\">次數</label>\n                <div class=\"col-sm-9\" _v-76230edf=\"\">\n                    <input type=\"number\" onwheel=\"this.blur()\" maxlength=\"3\" max=\"120\" min=\"1\" step=\"1\" class=\"form-control w-100\" v-model=\"postData.pay_times\" _v-76230edf=\"\">\n                </div>\n            </div>\n            <div class=\"form-group\" _v-76230edf=\"\">\n                <label class=\"col-sm-3 control-label p-t-0\" _v-76230edf=\"\">購買方案</label>\n                <div class=\"col-sm-7\" _v-76230edf=\"\">\n                    <v-spinner-button :ajaxing=\"ajaxing_contracts\" _v-76230edf=\"\"></v-spinner-button>\n                    <select v-show=\"!ajaxing_contracts\" @change=\"changeContract($event)\" v-model=\"postData.buyable_id\" class=\"form-control\" _v-76230edf=\"\">\n                        <option value=\"\" disabled=\"\" _v-76230edf=\"\">請選擇</option>\n                        <optgroup :label=\"category.name\" v-for=\"category in view.contracts\" v-if=\"category.items.length\" _v-76230edf=\"\">\n                            <option :value=\"contract.id\" :ref=\"'contract'+contract.id\" :data-price=\"contract.price\" :data-name=\"contract.name\" v-for=\"contract in category.items\" _v-76230edf=\"\">\n                                {{contract.name}}\n                            </option>\n                        </optgroup>\n                    </select>\n                </div>\n            </div>\n            <div class=\"form-group\" _v-76230edf=\"\">\n                <label class=\"col-sm-3 control-label p-t-0\" _v-76230edf=\"\">金額</label>\n                <div class=\"col-sm-9\" _v-76230edf=\"\">\n                    <input type=\"number\" min=\"1\" step=\"1\" onwheel=\"this.blur()\" class=\"form-control w-200\" v-model=\"price\" _v-76230edf=\"\">\n                </div>\n            </div>\n        </div>\n    </div>\n</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.w-50[_v-76230edf] {\n  width: 50px; }\n\n/* line 6, stdin */\n.w-100[_v-76230edf] {\n  width: 100px; }\n\n/* line 10, stdin */\n.w-200[_v-76230edf] {\n  width: 200px; }\n\n/* line 14, stdin */\n.d-inline[_v-76230edf] {\n  display: inline-block; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-76230edf", module.exports)
  } else {
    hotAPI.update("_v-76230edf", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1077:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.w-50[_v-f29243ec] {\n  width: 50px; }\n\n/* line 6, stdin */\n.w-100[_v-f29243ec] {\n  width: 100px !important; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['memberId'],
    data: function data() {
        return {
            allow_to_use: false,
            ajaxing: false,
            plan_id: 0,
            plan: {},
            details: [],
            payments: [],
            postData: {
                payments: []
            },
            subscription: {
                rule: "",
                status: ""
            },
            informationMethod: ''
        };
    },
    created: function created() {
        var _this = this;

        window.Event.$on('auto-pay-plan-view', function (data) {
            _this.allow_to_use = false;
            _this.postData = {
                payments: []
            };
            _this.subscription = data.subscription;
            _this.allow_to_use = data.allowToUse;
            _this.payments = data.allPayments;
            _this.plan_id = data.planId;
            _this.action_mode = 'normal';
            _this.getDetails(data.planId);
            $('#view-auto-pay-plan-modal').modal('show');
        });
    },
    mounted: function mounted() {},

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['isSeventeen']), (0, _vuex.mapState)({
        canReadAutoPayPlan: function canReadAutoPayPlan(state) {
            return state.webadmin.configure.webFunctions.WebadminAutoPayPlanIndex;
        },
        canUpdateAutoPayPlan: function canUpdateAutoPayPlan(state) {
            return state.webadmin.configure.webFunctions.WebadminAutoPayPlanUpdate;
        }
    })),
    methods: {
        selectEventAppend: function selectEventAppend(option) {
            this.appendPaymentPayload(option.id);
        },
        removeEventAppend: function removeEventAppend(option) {
            this.deletePaymentPayload(option.id);
        },
        getDetails: function getDetails() {
            this.ajaxing = true;
            this.$http.get('/adminapi/auto_pay_plan/details/' + this.plan_id).then(function (response) {
                this.plan = response.data.plan;
                this.details = response.data.details;
                this.subscription = response.data.subscription;
                this.postData.payments = response.data.payments;
                this.ajaxing = false;
            }).catch(function (response) {
                $17.swal({
                    title: '取得計劃細節失敗',
                    text: response.data.hasOwnProperty('message') ? response.data.message : '',
                    type: 'error',
                    showCancelButton: false
                });
            });
        },
        deletePaymentPayload: function deletePaymentPayload(payloadId) {
            $.blockUI();
            this.$http.delete('/adminapi/auto_pay_plan/delete/branch_payment_payload/' + this.plan_id, { body: { payload_id: payloadId } }).then(function (response) {
                $.unblockUI();
            }).catch(function (response) {
                $17.swal({
                    title: '刪除失敗，請重新整理',
                    text: response.data.hasOwnProperty('message') ? response.data.message : '',
                    type: 'warning',
                    showCancelButton: false
                });
                $.unblockUI();
            });
        },
        appendPaymentPayload: function appendPaymentPayload(payloadId) {
            $.blockUI();
            this.$http.post('/adminapi/auto_pay_plan/create/branch_payment_payload/' + this.plan_id, { payload_id: payloadId }).then(function (response) {
                $.unblockUI();
            }).catch(function (response) {
                $17.swal({
                    title: '新增失敗，請重新整理',
                    text: response.data.hasOwnProperty('message') ? response.data.message : '',
                    type: 'warning',
                    showCancelButton: false
                });
                $.unblockUI();
            });
        },
        billSuccessCallBack: function billSuccessCallBack() {
            $('#auto-pay-order-edit').modal('hide');
            $('#multi-alert-modal').modal('show');
            this.getDetails();
            window.Event.$emit('auto-pay-plan-refresh');
            window.Event.$emit('add-binding-member-credit-card-branch');
        },
        invalidSuccessCallBack: function invalidSuccessCallBack() {
            this.getDetails();
            $('#auto-pay-order-show').modal('hide');
            $('#auto-pay-order-edit').modal('hide');
        },
        billFailCallBack: function billFailCallBack() {
            $('#multi-alert-modal').modal('show');
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-f29243ec=\"\">\n    <v-modal v-show=\"canReadAutoPayPlan\" id=\"view-auto-pay-plan-modal\" open-size=\"modal-lg\" parallel-modal=\"\" no-footer=\"\" _v-f29243ec=\"\">\n        <h4 slot=\"title\" _v-f29243ec=\"\">管理自動支付計畫</h4>\n        <div slot=\"body\" _v-f29243ec=\"\">\n            <v-spinner :ajaxing=\"ajaxing\" _v-f29243ec=\"\"></v-spinner>\n            <div v-if=\"!ajaxing\" _v-f29243ec=\"\">\n                <auto-pay-plan-subscribe-information :rule=\"subscription.rule\" :status=\"subscription.status\" :id=\"plan_id\" @get-details=\"getDetails\" v-if=\"plan.category=='subscribe'\" _v-f29243ec=\"\"></auto-pay-plan-subscribe-information>\n                <auto-pay-plan-classic-information :plan=\"plan\" :payments=\"payments\" :allow-to-use=\"allow_to_use\" :init-selected-payments=\"postData.payments\" v-if=\"plan.category=='classic'\" _v-f29243ec=\"\"></auto-pay-plan-classic-information>\n                <auto-pay-plan-view-modal-view-table :details=\"details\" :plan=\"plan\" @get-details=\"getDetails\" :allow-edit=\"plan.category=='classic'\" _v-f29243ec=\"\"></auto-pay-plan-view-modal-view-table>\n            </div>\n        </div>\n    </v-modal>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.w-50[_v-f29243ec] {\n  width: 50px; }\n\n/* line 6, stdin */\n.w-100[_v-f29243ec] {\n  width: 100px !important; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-f29243ec", module.exports)
  } else {
    hotAPI.update("_v-f29243ec", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1078:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n#sub-row-container[_v-3f3445af] {\n  margin: 8px auto; }\n  /* line 4, stdin */\n  #sub-row-container .table-container[_v-3f3445af] {\n    max-height: 285px;\n    overflow: auto; }\n  /* line 8, stdin */\n  #sub-row-container table.table[_v-3f3445af] {\n    background-color: #F1F1F5; }\n    /* line 10, stdin */\n    #sub-row-container table.table thead[_v-3f3445af] {\n      position: -webkit-sticky;\n      position: sticky;\n      top: 0; }\n    /* line 15, stdin */\n    #sub-row-container table.table tr th[_v-3f3445af] {\n      color: #6B7280; }\n      /* line 17, stdin */\n      #sub-row-container table.table tr th[_v-3f3445af]:first-child {\n        border-radius: 4px 0px 0px 0px; }\n      /* line 20, stdin */\n      #sub-row-container table.table tr th[_v-3f3445af]:last-child {\n        border-radius: 0px 4px 0px 0px; }\n    /* line 24, stdin */\n    #sub-row-container table.table tr th[_v-3f3445af], #sub-row-container table.table tr td[_v-3f3445af] {\n      padding: 5px;\n      font-size: 14px;\n      background-color: white; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _tippy = require('tippy.js');

var _tippy2 = _interopRequireDefault(_tippy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['rowData'],
    data: function data() {
        return {
            ajaxing: false,
            records: [],
            actionType: {
                'spend': '預約',
                'return': '取消'
            },
            bookingType: {
                'class': '課程',
                'service': '服務'
            }

        };
    },
    mounted: function mounted() {
        this.fetchRecords();
    },

    computed: {
        noData: function noData() {
            return _lodash2.default.isEmpty(this.records);
        }
    },
    methods: {
        fetchRecords: function fetchRecords() {
            var _this = this;

            this.ajaxing = true;
            this.$http.get('/adminapi/customers/booking/contract/course/' + this.rowData.id).then(function (response) {
                _this.records = response.data;
                _this.ajaxing = false;
            }, function (error) {
                _this.ajaxing = false;
            });
        },
        reasonFormat: function reasonFormat(item) {
            return this.actionType[item.action_type] + ' : ' + this.bookingType[item.booking_target_type] + ' ' + item.booking_date + ' ' + item.booking_time + ' ' + item.booking_name;
        },
        showReason: function showReason(el) {
            var text = el.target.innerHTML;
            var tooltip = (0, _tippy2.default)(el.target, {
                content: text,
                arrow: true,
                theme: 'light-border',
                onHidden: function onHidden(instance) {
                    instance.destroy();
                }
            });
            tooltip.show();
        },
        close: function close() {
            if (this.rowData) {
                this.rowData.subRow.close();
            }
        },

        moment: function (_moment) {
            function moment(_x) {
                return _moment.apply(this, arguments);
            }

            moment.toString = function () {
                return _moment.toString();
            };

            return moment;
        }(function (date) {
            return moment(date);
        })
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div id=\"sub-row-container\" _v-3f3445af=\"\">\n    <div style=\"display: flex; justify-content: space-between; align-items: center;\" _v-3f3445af=\"\">\n        <p class=\"grey--90 regular\" _v-3f3445af=\"\">關聯方案</p>\n        <a class=\"grey--90\" @click.prevent=\"close\" _v-3f3445af=\"\">\n            <i class=\"fa fa-remove fa-x\" _v-3f3445af=\"\"></i>\n        </a>\n    </div>\n    <div class=\"m-top-8 table-container\" _v-3f3445af=\"\">\n        <div class=\"centered\" v-if=\"ajaxing\" _v-3f3445af=\"\">查詢中...</div>\n        <div v-else=\"\" _v-3f3445af=\"\">\n            <div v-show=\"noData\" style=\"text-align: center; padding: 25px 0;\" _v-3f3445af=\"\">\n                <img src=\"/images/no-data-img.png\" width=\"105\" height=\"60\" _v-3f3445af=\"\">\n                <div style=\"color: #6c6c6c;\" class=\"m-top-10\" _v-3f3445af=\"\">目前暫無資料</div>\n            </div>\n            <table class=\"table\" v-if=\"!noData\" _v-3f3445af=\"\">\n                <thead _v-3f3445af=\"\">\n                    <tr _v-3f3445af=\"\">\n                        <th _v-3f3445af=\"\">方案名稱</th>\n                        <th _v-3f3445af=\"\">客戶方案編號</th>\n                        <th _v-3f3445af=\"\">日期時間</th>\n                        <th _v-3f3445af=\"\">原因</th>\n                        <th _v-3f3445af=\"\">異動</th>\n                    </tr>\n                </thead>\n                <tbody _v-3f3445af=\"\">\n                    <tr v-for=\"item in records\" _v-3f3445af=\"\">\n                        <td style=\"max-width: 10em;\" _v-3f3445af=\"\">{{item.contract_name}}</td>\n                        <td _v-3f3445af=\"\">{{item.member_contract_id}}</td>\n                        <td _v-3f3445af=\"\">\n                            <div _v-3f3445af=\"\">{{moment(item.created_time).format('YYYY-MM-DD')}}</div>\n                            <div class=\"grey--70\" _v-3f3445af=\"\">{{moment(item.created_time).format('HH:mm:ss')}}</div>\n                        </td>\n                        <td style=\"max-width: 12em;\" _v-3f3445af=\"\">\n                            <p class=\"m-bottom-0 word-ellipsis pointer\" @mouseenter.prevent.stop=\"showReason\" _v-3f3445af=\"\">{{reasonFormat(item)}}</p>\n                        </td>\n                        <td _v-3f3445af=\"\">{{item.spend_value}}</td>\n                    </tr>\n                </tbody>\n            </table>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n#sub-row-container[_v-3f3445af] {\n  margin: 8px auto; }\n  /* line 4, stdin */\n  #sub-row-container .table-container[_v-3f3445af] {\n    max-height: 285px;\n    overflow: auto; }\n  /* line 8, stdin */\n  #sub-row-container table.table[_v-3f3445af] {\n    background-color: #F1F1F5; }\n    /* line 10, stdin */\n    #sub-row-container table.table thead[_v-3f3445af] {\n      position: -webkit-sticky;\n      position: sticky;\n      top: 0; }\n    /* line 15, stdin */\n    #sub-row-container table.table tr th[_v-3f3445af] {\n      color: #6B7280; }\n      /* line 17, stdin */\n      #sub-row-container table.table tr th[_v-3f3445af]:first-child {\n        border-radius: 4px 0px 0px 0px; }\n      /* line 20, stdin */\n      #sub-row-container table.table tr th[_v-3f3445af]:last-child {\n        border-radius: 0px 4px 0px 0px; }\n    /* line 24, stdin */\n    #sub-row-container table.table tr th[_v-3f3445af], #sub-row-container table.table tr td[_v-3f3445af] {\n      padding: 5px;\n      font-size: 14px;\n      background-color: white; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-3f3445af", module.exports)
  } else {
    hotAPI.update("_v-3f3445af", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"lodash":717,"tippy.js":780,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1079:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _index = require('./index.vue');

var _index2 = _interopRequireDefault(_index);

var _contractBookingRecords = require('./contract-booking-records.vue');

var _contractBookingRecords2 = _interopRequireDefault(_contractBookingRecords);

var _listActionBtn = require('./list-action-btn.vue');

var _listActionBtn2 = _interopRequireDefault(_listActionBtn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('member-booking-list', _index2.default);
_vue2.default.component('member-contract-booking-records', _contractBookingRecords2.default);
_vue2.default.component('member-booking-list-action-btn', _listActionBtn2.default);

},{"./contract-booking-records.vue":1078,"./index.vue":1080,"./list-action-btn.vue":1081,"vue":792}],1080:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _tippy = require('tippy.js');

var _tippy2 = _interopRequireDefault(_tippy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ["memberId", "studioId"],
    data: function data() {
        var member_id = this.memberId;
        var studio_id = this.studioId;
        return {
            contentTabView: 'booking',
            items: [{ 'name': 'booking', 'title': '預約紀錄' }, { 'name': 'waiting', 'title': '候補紀錄' }],
            ajaxing: false,
            data: {},
            bookingTableConfig: {
                columns: [{
                    keys: 'id',
                    head: '預約編號',
                    minWidth: '5em'
                }, {
                    keys: 'item_name',
                    head: '預約項目',
                    maxWidth: '10em',
                    html: function html(item) {
                        var content = '<p class="word-ellipsis m-bottom-0 pointer" @mouseenter.prevent.stop="clickHandler(\'showDetail\', $event)">' + item.item_name + '</p>';
                        if (item.branch_name) {
                            content += '<p class="word-ellipsis m-bottom-0 grey--70">' + item.branch_name + '</p>';
                        }
                        return content;
                    }
                }, {
                    keys: 'start_datetime',
                    head: '開始時間',
                    minWidth: '7em',
                    html: function html(item) {
                        var datetime = moment(item.start_datetime);
                        var date = datetime.isValid() ? datetime.format('YYYY-MM-DD') : '無紀錄';
                        var time = datetime.isValid() ? datetime.format('HH:mm:ss') : '-';
                        var content = '<div>' + date + '</div>';
                        content += '<div class="grey--70">' + time + '</div>';
                        return content;
                    }
                }, {
                    keys: 'confirm_status',
                    head: '狀態',
                    minWidth: '8em'
                }, {
                    keys: 'staff_name',
                    head: '服務提供者'
                }, {
                    keys: 'id',
                    head: '動作',
                    minWidth: '5em',
                    component: {
                        name: 'member-booking-list-action-btn'
                    }
                }],
                subRow: {
                    enable: true
                },
                subRowStyleCondition: function subRowStyleCondition(rowData, rowIdx) {
                    return { 'background-color': '#F1F1F5' };
                }
            },
            waitingTableConfig: {
                columns: [{
                    keys: 'created_at',
                    head: '建立時間',
                    minWidth: '7em',
                    html: function html(item) {
                        var datetime = moment(item.created_at);
                        var date = datetime.isValid() ? datetime.format('YYYY-MM-DD') : '無紀錄';
                        var time = datetime.isValid() ? datetime.format('HH:mm:ss') : '-';
                        var content = '<div>' + date + '</div>';
                        content += '<div class="grey--70">' + time + '</div>';
                        return content;
                    }
                }, {
                    keys: 'schedules_name',
                    head: '候補項目',
                    minWidth: '10em',
                    html: function html(item) {
                        var content = '<p class="word-ellipsis m-bottom-0 pointer" @mouseenter.prevent.stop="clickHandler(\'showDetail\', $event)">' + item.schedules_name + '</p>';
                        if (item.branch_name) {
                            content += '<p class="word-ellipsis m-bottom-0 grey--70" >' + item.branch_name + '</p>';
                        }
                        return content;
                    }
                }, {
                    keys: 'start_datetime',
                    head: '課程開始時間',
                    minWidth: '7em',
                    html: function html(item) {
                        var datetime = moment(item.start_datetime);
                        var date = datetime.isValid() ? datetime.format('YYYY-MM-DD') : '無紀錄';
                        var time = datetime.isValid() ? datetime.format('HH:mm:ss') : '-';
                        var content = '<div>' + date + '</div>';
                        content += '<div class="grey--70">' + time + '</div>';
                        return content;
                    }
                }, {
                    keys: 'staff_name',
                    head: '服務提供者'
                }],
                subRow: {
                    enable: true
                },
                subRowStyleCondition: function subRowStyleCondition(rowData, rowIdx) {
                    return { 'background-color': '#F1F1F5' };
                }
            },
            bookingApiConfig: {
                method: 'get',
                apiurl: '/adminapi/customers/booking/records/' + member_id + '/studio/' + studio_id,
                payload: { page: 1 },
                recordName: 'list'
            },
            waitingApiConfig: {
                method: 'get',
                apiurl: '/adminapi/customers/schedule_waiting/records/' + member_id + '/studio/' + studio_id,
                payload: { page: 1 },
                recordName: 'list'
            }
        };
    },
    mounted: function mounted() {},

    watch: {
        'contentTabView': function contentTabView(n, o) {
            this.contentTabView = n;
        }
    },
    computed: {
        noData: function noData() {
            return _lodash2.default.isEmpty(this.bookings);
        }
    },
    methods: {
        contentTabShow: function contentTabShow(name) {
            return this.contentTabView == name;
        },
        colEventHandler: function colEventHandler(item) {
            if (item.action === 'showDetail') {
                var el = item.mouseEvent.target;
                var tooltip = (0, _tippy2.default)(el, {
                    content: el.innerHTML,
                    arrow: true,
                    theme: 'light-border',
                    allowHTML: true,
                    onHidden: function onHidden(instance) {
                        instance.destroy();
                    }
                });
                tooltip.show();
            }
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-content-tab :model.sync=\"contentTabView\" title=\"預約\" :items=\"items\">\n    <template slot=\"content-tab-items\">\n        <div v-if=\"contentTabShow('booking')\">\n            <v-smart-table ref=\"smart-table\" :table-config=\"bookingTableConfig\" :api-config=\"bookingApiConfig\" :page-sync-url-query=\"false\" @html-click-callback=\"colEventHandler\"></v-smart-table>\n        </div>\n        <div v-if=\"contentTabShow('waiting')\">\n            <v-smart-table ref=\"smart-table\" :table-config=\"waitingTableConfig\" :api-config=\"waitingApiConfig\" :page-sync-url-query=\"false\" @html-click-callback=\"colEventHandler\"></v-smart-table>\n        </div>\n    </template>\n</v-content-tab>\n\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-792b4266", module.exports)
  } else {
    hotAPI.update("_v-792b4266", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"lodash":717,"tippy.js":780,"vue":792,"vue-hot-reload-api":785}],1081:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\nul[_v-4062b068] {\n  list-style-type: none;\n  padding: 0; }\n\n/* line 6, stdin */\n.tooltip-menu[_v-4062b068] {\n  position: relative;\n  display: inline-block; }\n  /* line 9, stdin */\n  .tooltip-menu .tooltiptext[_v-4062b068] {\n    display: none;\n    visibility: hidden;\n    background-color: #FAFAFB;\n    box-shadow: 4px 8px 16px rgba(0, 0, 0, 0.12);\n    color: #171725;\n    text-align: center;\n    border-radius: 4px;\n    left: -135px;\n    top: 10px;\n    position: absolute;\n    z-index: 1; }\n    /* line 21, stdin */\n    .tooltip-menu .tooltiptext p[_v-4062b068] {\n      cursor: pointer;\n      padding: 8px 16px; }\n      /* line 24, stdin */\n      .tooltip-menu .tooltiptext p[_v-4062b068]:hover {\n        border-radius: 4px;\n        background-color: #38B0E3;\n        color: white; }\n  /* line 32, stdin */\n  .tooltip-menu:hover .tooltiptext[_v-4062b068] {\n    visibility: visible;\n    display: inherit; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['rowData'],
    data: function data() {
        return {};
    },
    mounted: function mounted() {},

    methods: {
        openRelationContracts: function openRelationContracts() {
            var subRow = {
                component: 'member-contract-booking-records'
            };
            this.rowData.subRow.load(subRow);
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-4062b068=\"\">\n    <a class=\"btn btn-default btn-xs tooltip-menu\" _v-4062b068=\"\">\n        <i class=\"fa fa-ellipsis-h fa-lg\" _v-4062b068=\"\"></i>\n        <span class=\"tooltiptext\" _v-4062b068=\"\">\n            <p class=\"txt-small grey--100\" @click.prevent=\"openRelationContracts\" _v-4062b068=\"\">查詢預約關聯方案</p>\n        </span>\n    </a>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\nul[_v-4062b068] {\n  list-style-type: none;\n  padding: 0; }\n\n/* line 6, stdin */\n.tooltip-menu[_v-4062b068] {\n  position: relative;\n  display: inline-block; }\n  /* line 9, stdin */\n  .tooltip-menu .tooltiptext[_v-4062b068] {\n    display: none;\n    visibility: hidden;\n    background-color: #FAFAFB;\n    box-shadow: 4px 8px 16px rgba(0, 0, 0, 0.12);\n    color: #171725;\n    text-align: center;\n    border-radius: 4px;\n    left: -135px;\n    top: 10px;\n    position: absolute;\n    z-index: 1; }\n    /* line 21, stdin */\n    .tooltip-menu .tooltiptext p[_v-4062b068] {\n      cursor: pointer;\n      padding: 8px 16px; }\n      /* line 24, stdin */\n      .tooltip-menu .tooltiptext p[_v-4062b068]:hover {\n        border-radius: 4px;\n        background-color: #38B0E3;\n        color: white; }\n  /* line 32, stdin */\n  .tooltip-menu:hover .tooltiptext[_v-4062b068] {\n    visibility: visible;\n    display: inherit; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-4062b068", module.exports)
  } else {
    hotAPI.update("_v-4062b068", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1082:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n#vue-card-container[_v-2ccbb00a] {\n  display: block;\n  width: auto;\n  border: solid 1px #e6e6e6;\n  border-radius: 4px; }\n  /* line 7, stdin */\n  #vue-card-container .head[_v-2ccbb00a] {\n    min-height: 43px;\n    background-color: #f5f5f5;\n    border-bottom: solid 1px #e6e6e6; }\n  /* line 12, stdin */\n  #vue-card-container .footer[_v-2ccbb00a] {\n    margin-top: 0;\n    min-height: 30px;\n    border-top: solid 1px #e6e6e6; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        showHeader: {
            default: true
        },
        showFooter: {
            default: true
        },
        cardClass: {
            default: 'm-bottom-15'
        }
    },
    data: function data() {
        return {};
    },
    computed: {},
    mounted: function mounted() {},

    methods: {}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div id=\"vue-card-container\" :class=\"cardClass\" _v-2ccbb00a=\"\">\n    <div class=\"head\" v-if=\"showHeader\" _v-2ccbb00a=\"\">\n        <slot name=\"head\" _v-2ccbb00a=\"\"></slot>\n    </div>\n    <div class=\"body\" _v-2ccbb00a=\"\">\n        <slot name=\"body\" _v-2ccbb00a=\"\"></slot>\n    </div>\n    <div class=\"footer\" v-if=\"showFooter\" _v-2ccbb00a=\"\">\n        <slot name=\"footer\" _v-2ccbb00a=\"\"></slot>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n#vue-card-container[_v-2ccbb00a] {\n  display: block;\n  width: auto;\n  border: solid 1px #e6e6e6;\n  border-radius: 4px; }\n  /* line 7, stdin */\n  #vue-card-container .head[_v-2ccbb00a] {\n    min-height: 43px;\n    background-color: #f5f5f5;\n    border-bottom: solid 1px #e6e6e6; }\n  /* line 12, stdin */\n  #vue-card-container .footer[_v-2ccbb00a] {\n    margin-top: 0;\n    min-height: 30px;\n    border-top: solid 1px #e6e6e6; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-2ccbb00a", module.exports)
  } else {
    hotAPI.update("_v-2ccbb00a", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1083:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ['studioId'],
  mounted: function mounted() {
    window.Event.$on('showCreateCustomerModal', function () {
      $('#crm-create-customer').modal('show');
    });
  },

  methods: {
    storeSuccess: function storeSuccess() {
      location.reload();
    }
  }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n    <v-modal id=\"crm-create-customer\" parallel-modal=\"\" no-footer=\"\" _v-c5630b4e=\"\">\n\t\t<div slot=\"title\" _v-c5630b4e=\"\">新增客戶</div>\n\t\t<div slot=\"body\" _v-c5630b4e=\"\">\n\t\t\t<v-customer-profile mode=\"create\" :studio-id=\"studioId\" :store-success-callback=\"storeSuccess\" _v-c5630b4e=\"\"></v-customer-profile>\n\t\t</div>\n    </v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-c5630b4e", module.exports)
  } else {
    hotAPI.update("_v-c5630b4e", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],1084:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _index = require('./index.vue');

var _index2 = _interopRequireDefault(_index);

var _memberOrderBlock = require('./member-order-block.vue');

var _memberOrderBlock2 = _interopRequireDefault(_memberOrderBlock);

var _memberClassBlock = require('./member-class-block.vue');

var _memberClassBlock2 = _interopRequireDefault(_memberClassBlock);

var _memberServiceBlock = require('./member-service-block.vue');

var _memberServiceBlock2 = _interopRequireDefault(_memberServiceBlock);

var _memberAdmissionBlock = require('./member-admission-block.vue');

var _memberAdmissionBlock2 = _interopRequireDefault(_memberAdmissionBlock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('member-dashboard', _index2.default);
_vue2.default.component('member-order-block', _memberOrderBlock2.default);
_vue2.default.component('member-class-block', _memberClassBlock2.default);
_vue2.default.component('member-service-block', _memberServiceBlock2.default);
_vue2.default.component('member-admission-block', _memberAdmissionBlock2.default);

},{"./index.vue":1085,"./member-admission-block.vue":1086,"./member-class-block.vue":1087,"./member-order-block.vue":1088,"./member-service-block.vue":1089,"vue":792}],1085:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['memberId', 'studioId'],
    data: function data() {
        return {
            datePickerOptions: {
                shortcuts: ['range_past_30d_include_today', 'range_past_90d_include_today', 'range_past_180d_include_today', 'range_past_365d_include_today'],
                disabledDate: "disabledBeforePast365DaysAndAfterToday",
                rangeDateFixedEnd: moment().format('YYYY-MM-DD'),
                clearable: false,
                editable: false,
                range: true
            },
            titleBannerStyle: 'st-font-medium st-py-3 st-text-16 st-text-black',
            recentActivityChartsConfig: [{
                titleText: '最後一次課程出席日期',
                compTag: 'dashboard-text-display',
                api: {
                    url: '/adminapi/dashboard/chart',
                    method: 'get',
                    params: {
                        member_id: this.memberId,
                        studio_id: this.studioId,
                        metrics: 'booking/class',
                        aggregation: 'first',
                        chart: 'text-display',
                        date_direction: 'past',
                        attendance_status: ['attend']
                    },
                    dateHelper: 'dateRangeToday'
                }
            }, {
                titleText: '下次課程預約日期',
                compTag: 'dashboard-text-display',
                api: {
                    url: '/adminapi/dashboard/chart',
                    method: 'get',
                    params: {
                        member_id: this.memberId,
                        studio_id: this.studioId,
                        metrics: 'booking/class',
                        aggregation: 'first',
                        chart: 'text-display',
                        date_direction: 'future',
                        attendance_status: ['unset', 'attend', 'absence']
                    },
                    dateHelper: 'dateRangeToday'
                }
            }, {
                titleText: '最後一次服務出席日期',
                compTag: 'dashboard-text-display',
                api: {
                    url: '/adminapi/dashboard/chart',
                    method: 'get',
                    params: {
                        member_id: this.memberId,
                        studio_id: this.studioId,
                        metrics: 'booking/service',
                        aggregation: 'first',
                        chart: 'text-display',
                        date_direction: 'past',
                        attendance_status: ['attend']
                    },
                    dateHelper: 'dateRangeToday'
                }
            }, {
                titleText: '下次服務預約日期',
                compTag: 'dashboard-text-display',
                api: {
                    url: '/adminapi/dashboard/chart',
                    method: 'get',
                    params: {
                        member_id: this.memberId,
                        studio_id: this.studioId,
                        metrics: 'booking/service',
                        aggregation: 'first',
                        chart: 'text-display',
                        date_direction: 'future',
                        attendance_status: ['unset', 'attend', 'absence']
                    },
                    dateHelper: 'dateRangeToday'
                }
            }, {
                titleText: '最後一次入場日期',
                compTag: 'dashboard-text-display',
                api: {
                    url: '/adminapi/dashboard/chart',
                    method: 'get',
                    params: {
                        member_id: this.memberId,
                        studio_id: this.studioId,
                        metrics: 'member-admission-record',
                        aggregation: 'first',
                        chart: 'text-display',
                        date_direction: 'past'
                    },
                    dateHelper: 'dateRangeToday'
                }
            }, {
                titleText: '最後一次消費日期',
                compTag: 'dashboard-text-display',
                api: {
                    url: '/adminapi/dashboard/chart',
                    method: 'get',
                    params: {
                        member_id: this.memberId,
                        studio_id: this.studioId,
                        metrics: 'order',
                        aggregation: 'first',
                        chart: 'text-display',
                        date_direction: 'past'
                    },
                    dateHelper: 'dateRangeToday'
                }
            }],
            memberOrder: {
                fullWidthSlotConfig: {
                    titleText: '消費金額',
                    compTag: 'dashboard-period-comparison',
                    compAttr: {
                        upperBound: 10,
                        lowerBound: -10,
                        unit: '元'
                    },
                    api: {
                        url: '/adminapi/dashboard/chart',
                        method: 'get',
                        params: {
                            member_id: this.memberId,
                            studio_id: this.studioId,
                            metrics: 'order',
                            aggregation: 'sum',
                            chart: 'multi-numbers'
                        },
                        dateHelper: 'dateRangePastComparison'
                    }
                }
            },
            memberClass: {
                leftSlotConfig: {
                    titleText: '課程預約次數',
                    compTag: 'dashboard-doughnut-chart',
                    compAttr: {
                        labelWithPercentage: true
                    },
                    api: {
                        url: '/adminapi/dashboard/chart',
                        method: 'get',
                        params: {
                            member_id: this.memberId,
                            studio_id: this.studioId,
                            metrics: 'booking/class',
                            aggregation: 'sum',
                            chart: 'doughnut',
                            attendance_status: ['unset', 'attend', 'absence']
                        },
                        dateHelper: 'dateRangeClassic'
                    }
                },
                rightSlotFirstRowConfig: {
                    titleText: '出席次數',
                    compTag: 'dashboard-period-comparison',
                    compAttr: {
                        upperBound: 10,
                        lowerBound: -10,
                        unit: '次'
                    },
                    api: {
                        url: '/adminapi/dashboard/chart',
                        method: 'get',
                        params: {
                            member_id: this.memberId,
                            studio_id: this.studioId,
                            metrics: 'booking/class',
                            aggregation: 'count',
                            chart: 'multi-numbers',
                            attendance_status: ['attend']
                        },
                        dateHelper: 'dateRangePastComparison'
                    }
                },
                rightSlotSecondRowConfig: {
                    titleText: '預約次數',
                    compTag: 'dashboard-period-comparison',
                    compAttr: {
                        upperBound: 10,
                        lowerBound: -10,
                        unit: '次'
                    },
                    api: {
                        url: '/adminapi/dashboard/chart',
                        method: 'get',
                        params: {
                            member_id: this.memberId,
                            studio_id: this.studioId,
                            metrics: 'booking/class',
                            aggregation: 'count',
                            chart: 'multi-numbers',
                            attendance_status: ['unset', 'attend', 'absence']
                        },
                        dateHelper: 'dateRangePastComparison'
                    }
                },
                rightSlotThirdRowConfig: {
                    titleText: '最常預約的服務提供者',
                    compTag: 'dashboard-text-display',
                    api: {
                        url: '/adminapi/dashboard/chart',
                        method: 'get',
                        params: {
                            member_id: this.memberId,
                            studio_id: this.studioId,
                            metrics: 'booking/class/service-provider',
                            aggregation: 'max',
                            chart: 'text',
                            attendance_status: ['unset', 'attend', 'absence']
                        },
                        dateHelper: 'dateRangeSingleInterval'
                    }
                },
                fullWidthSlotConfig: {
                    titleText: '詳細出席紀錄',
                    compTag: 'dashboard-scatter-chart',
                    compAttr: {
                        xAxesMode: 'entireDateRangeTime',
                        yAxesMode: 'day24HourTime'
                    },
                    api: {
                        url: '/adminapi/dashboard/chart',
                        method: 'get',
                        params: {
                            member_id: this.memberId,
                            studio_id: this.studioId,
                            metrics: 'booking/class/service-provider',
                            aggregation: null,
                            chart: 'scatter',
                            attendance_status: ['unset', 'attend', 'absence']
                        },
                        dateHelper: 'dateRangeClassicAutoExpandDays'
                    }
                }
            },
            memberService: {
                leftSlotConfig: {
                    titleText: '服務預約次數',
                    compTag: 'dashboard-doughnut-chart',
                    compAttr: {
                        labelWithPercentage: true
                    },
                    api: {
                        url: '/adminapi/dashboard/chart',
                        method: 'get',
                        params: {
                            member_id: this.memberId,
                            studio_id: this.studioId,
                            metrics: 'booking/service',
                            aggregation: 'sum',
                            chart: 'doughnut',
                            attendance_status: ['unset', 'attend', 'absence']
                        },
                        dateHelper: 'dateRangeClassic'
                    }
                },
                rightSlotFirstRowConfig: {
                    titleText: '出席次數',
                    compTag: 'dashboard-period-comparison',
                    compAttr: {
                        upperBound: 10,
                        lowerBound: -10,
                        unit: '次'
                    },
                    api: {
                        url: '/adminapi/dashboard/chart',
                        method: 'get',
                        params: {
                            member_id: this.memberId,
                            studio_id: this.studioId,
                            metrics: 'booking/service',
                            aggregation: 'count',
                            chart: 'multi-numbers',
                            attendance_status: ['attend']
                        },
                        dateHelper: 'dateRangePastComparison'
                    }
                },
                rightSlotSecondRowConfig: {
                    titleText: '預約次數',
                    compTag: 'dashboard-period-comparison',
                    compAttr: {
                        upperBound: 10,
                        lowerBound: -10,
                        unit: '次'
                    },
                    api: {
                        url: '/adminapi/dashboard/chart',
                        method: 'get',
                        params: {
                            member_id: this.memberId,
                            studio_id: this.studioId,
                            metrics: 'booking/service',
                            aggregation: 'count',
                            chart: 'multi-numbers',
                            attendance_status: ['unset', 'attend', 'absence']
                        },
                        dateHelper: 'dateRangePastComparison'
                    }
                },
                rightSlotThirdRowConfig: {
                    titleText: '最常預約的服務提供者',
                    compTag: 'dashboard-text-display',
                    api: {
                        url: '/adminapi/dashboard/chart',
                        method: 'get',
                        params: {
                            member_id: this.memberId,
                            studio_id: this.studioId,
                            metrics: 'booking/service/service-provider',
                            aggregation: 'max',
                            chart: 'text',
                            attendance_status: ['unset', 'attend', 'absence']
                        },
                        dateHelper: 'dateRangeSingleInterval'
                    }
                },
                fullWidthSlotConfig: {
                    titleText: '詳細出席紀錄',
                    compTag: 'dashboard-scatter-chart',
                    compAttr: {
                        xAxesMode: 'entireDateRangeTime',
                        yAxesMode: 'day24HourTime'
                    },
                    api: {
                        url: '/adminapi/dashboard/chart',
                        method: 'get',
                        params: {
                            member_id: this.memberId,
                            studio_id: this.studioId,
                            metrics: 'booking/service/service-provider',
                            aggregation: null,
                            chart: 'scatter',
                            attendance_status: ['unset', 'attend', 'absence']
                        },
                        dateHelper: 'dateRangeClassicAutoExpandDays'
                    }
                }
            },
            memberAdmission: {
                leftSlotConfig: {
                    titleText: '入場時段分佈 (單位：次數)',
                    compTag: 'dashboard-bar-chart',
                    api: {
                        url: '/adminapi/dashboard/chart',
                        method: 'get',
                        params: {
                            member_id: this.memberId,
                            studio_id: this.studioId,
                            metrics: 'member-admission-record',
                            aggregation: 'count',
                            chart: 'bar'
                        },
                        dateHelper: 'dateRangeInterval24Hours'
                    }
                },
                rightSlotFirstRowConfig: {
                    titleText: '入場次數',
                    compTag: 'dashboard-period-comparison',
                    compAttr: {
                        upperBound: 10,
                        lowerBound: -10,
                        unit: '次'
                    },
                    api: {
                        url: '/adminapi/dashboard/chart',
                        method: 'get',
                        params: {
                            member_id: this.memberId,
                            studio_id: this.studioId,
                            metrics: 'member-admission-record',
                            aggregation: 'count',
                            chart: 'multi-numbers'
                        },
                        dateHelper: 'dateRangePastComparison'
                    }
                },
                rightSlotSecondRowConfig: {
                    titleText: '最常入場的時段',
                    compTag: 'dashboard-text-display',
                    api: {
                        url: '/adminapi/dashboard/chart',
                        method: 'get',
                        params: {
                            member_id: this.memberId,
                            studio_id: this.studioId,
                            metrics: 'member-admission-record',
                            aggregation: 'max',
                            chart: 'text'
                        },
                        dateHelper: 'dateRangeSingleInterval'
                    }
                }
            }
        };
    },
    created: function created() {},

    computed: {},
    methods: {}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"-st-mt-4\">\n    <div>\n        <div :class=\"titleBannerStyle\">近期活動</div>\n        <grid-slots-block ref=\"member_recent_activity_block\" :charts-config=\"recentActivityChartsConfig\"></grid-slots-block>\n    </div>\n    <hr class=\"st-border-gray-40 st-mb-4 st-mt-7\">\n    <div>\n        <div :class=\"titleBannerStyle\">消費與訂單</div>\n        <member-order-block :date-picker-options=\"datePickerOptions\" :full-width-slot-config=\"memberOrder.fullWidthSlotConfig\"></member-order-block>\n    </div>\n    <div>\n        <div :class=\"titleBannerStyle\">課程預約及出席</div>\n        <member-class-block :date-picker-options=\"datePickerOptions\" :left-slot-config=\"memberClass.leftSlotConfig\" :right-slot-first-row-config=\"memberClass.rightSlotFirstRowConfig\" :right-slot-second-row-config=\"memberClass.rightSlotSecondRowConfig\" :right-slot-third-row-config=\"memberClass.rightSlotThirdRowConfig\" :full-width-slot-config=\"memberClass.fullWidthSlotConfig\"></member-class-block>\n    </div>\n    <div>\n        <div :class=\"titleBannerStyle\">服務預約及出席</div>\n        <member-service-block :date-picker-options=\"datePickerOptions\" :left-slot-config=\"memberService.leftSlotConfig\" :right-slot-first-row-config=\"memberService.rightSlotFirstRowConfig\" :right-slot-second-row-config=\"memberService.rightSlotSecondRowConfig\" :right-slot-third-row-config=\"memberService.rightSlotThirdRowConfig\" :full-width-slot-config=\"memberService.fullWidthSlotConfig\"></member-service-block>\n    </div>\n    <div>\n        <div :class=\"titleBannerStyle\">入場</div>\n        <member-admission-block :date-picker-options=\"datePickerOptions\" :left-slot-config=\"memberAdmission.leftSlotConfig\" :right-slot-first-row-config=\"memberAdmission.rightSlotFirstRowConfig\" :right-slot-second-row-config=\"memberAdmission.rightSlotSecondRowConfig\"></member-admission-block>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-20e9db3e", module.exports)
  } else {
    hotAPI.update("_v-20e9db3e", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],1086:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _dashboardHelper = require('../../dashboard/dashboard-helper');

exports.default = {
    props: {
        defaultDateUnit: {
            type: String,
            default: 'd'
        },
        defaultDateShortcut: {
            type: String,
            default: '過去 30 天'
        },
        defaultDates: {
            type: Array,
            default: function _default() {
                var defaultS = moment().subtract(29, 'days').format('YYYY-MM-DD');
                var defaultE = moment().format('YYYY-MM-DD');
                return [defaultS, defaultE];
            }
        },
        datePickerOptions: {
            type: Object
        },
        chartTitleStyle: {
            type: [String, Array, Object],
            default: 'st-my-2 st-text-16 st-text-gray-90'
        },
        leftSlotConfig: Object,
        rightSlotFirstRowConfig: Object,
        rightSlotSecondRowConfig: Object
    },
    data: function data() {
        return {
            dates: this.defaultDates,
            datesObj: {},
            leftSlot: {
                requestObj: {},
                responseObj: {},
                ajaxing: false
            },
            rightSlotFirstRow: {
                requestObj: {},
                responseObj: {},
                ajaxing: false
            },
            rightSlotSecondRow: {
                requestObj: {},
                responseObj: {},
                ajaxing: false
            }
        };
    },
    mounted: function mounted() {
        this.dateChange({
            start: this.defaultDates[0],
            end: this.defaultDates[1],
            unit: this.defaultDateUnit,
            shortcuts_text: this.defaultDateShortcut
        });
    },

    computed: {
        dateShortcutText: function dateShortcutText() {
            if (moment(this.datesObj.end) < moment()) {
                return '(過去 ' + (moment(this.datesObj.end).diff(moment(this.datesObj.start), 'days') + 1) + ' 天)';
            };
            return '';
        }
    },
    methods: {
        dateChange: function dateChange(e) {
            this.datesObj = e;
            this.updateView();
        },
        updateView: function updateView() {
            this.getCharts('leftSlot');
            this.getCharts('rightSlotFirstRow');
            this.getCharts('rightSlotSecondRow');
        },
        getCharts: function getCharts(slot) {
            var _this = this;

            var configName = slot + 'Config';
            if (this[configName] && this[slot]) {
                this.$set(this[slot], 'ajaxing', true);
                var api = this[configName].api;
                var params = api.params;
                params['date_range'] = (0, _dashboardHelper.dateRangeHelper)({
                    datesObj: this.datesObj,
                    dateHelper: api.dateHelper
                });
                this.$set(this[slot], 'requestObj', params);
                this.$http[api.method](api.url, { params: params }).then(function (response) {
                    _this.$set(_this[slot], 'responseObj', response.data);
                    _this.$set(_this[slot], 'ajaxing', false);
                }).catch(function (response) {
                    _this.$set(_this[slot], 'ajaxing', false);
                    $17.swal({
                        title: '圖表顯示失敗',
                        text: '\u7121\u6CD5\u53D6\u5F97 ' + _this[slot].titleText + ' \u8CC7\u6599',
                        type: 'warning',
                        showCancelButton: false
                    });
                });
            }
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"st-border st-border-gray-40 st-border-solid st-my-3 st-p-5 st-rounded-4\">\n    <div class=\"st-gap-2 st-grid st-grid-cols-1 md:st-grid-cols-2 st-mb-6\">\n        <v-date-picker ref=\"date_picker\" v-model=\"dates\" range=\"\" @change=\"dateChange\" v-bind=\"datePickerOptions\"></v-date-picker>\n        <span class=\"st-flex st-items-center st-text-16 st-text-gray-90\">{{ dateShortcutText }}</span>\n    </div>\n    <div>\n        <div class=\"st-gap-2 st-grid st-grid-cols-1 md:st-grid-cols-2\">\n            <div>\n                <div v-if=\"leftSlotConfig\">\n                    <div :class=\"chartTitleStyle\">{{ leftSlotConfig.titleText }}</div>\n                    <div class=\"st-mt-7\">\n                        <component ref=\"left_slot_chart\" :is=\"leftSlotConfig.compTag\" v-bind=\"leftSlotConfig.compAttr\" :request-obj=\"leftSlot.requestObj\" :response-obj=\"leftSlot.responseObj\" :ajaxing=\"leftSlot.ajaxing\"></component>\n                    </div>\n                </div>\n            </div>\n            <div>\n                <div v-if=\"rightSlotFirstRowConfig\">\n                    <div :class=\"chartTitleStyle\">{{ rightSlotFirstRowConfig.titleText }}</div>\n                    <component ref=\"right_slot_first_row_chart\" :is=\"rightSlotFirstRowConfig.compTag\" v-bind=\"rightSlotFirstRowConfig.compAttr\" :request-obj=\"rightSlotFirstRow.requestObj\" :response-obj=\"rightSlotFirstRow.responseObj\" :ajaxing=\"rightSlotFirstRow.ajaxing\"></component>\n                    <hr class=\"st-border-gray-40 st-mb-4 st-mt-3\">\n                </div>\n                <div v-if=\"rightSlotSecondRowConfig\">\n                    <div :class=\"chartTitleStyle\">{{ rightSlotSecondRowConfig.titleText }}</div>\n                    <component ref=\"right_slot_second_row_chart\" :is=\"rightSlotSecondRowConfig.compTag\" v-bind=\"rightSlotSecondRowConfig.compAttr\" :request-obj=\"rightSlotSecondRow.requestObj\" :response-obj=\"rightSlotSecondRow.responseObj\" :ajaxing=\"rightSlotSecondRow.ajaxing\"></component>\n                    <hr class=\"st-border-gray-40 st-mb-4 st-mt-3\">\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-4815b117", module.exports)
  } else {
    hotAPI.update("_v-4815b117", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"../../dashboard/dashboard-helper":1137,"vue":792,"vue-hot-reload-api":785}],1087:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _dashboardHelper = require('../../dashboard/dashboard-helper');

exports.default = {
    props: {
        defaultDateUnit: {
            type: String,
            default: 'd'
        },
        defaultDateShortcut: {
            type: String,
            default: '過去 90 天'
        },
        defaultDates: {
            type: Array,
            default: function _default() {
                var defaultS = moment().subtract(89, 'days').format('YYYY-MM-DD');
                var defaultE = moment().format('YYYY-MM-DD');
                return [defaultS, defaultE];
            }
        },
        datePickerOptions: {
            type: Object
        },
        chartTitleStyle: {
            type: [String, Array, Object],
            default: 'st-my-2 st-text-16 st-text-gray-90'
        },
        leftSlotConfig: Object,
        rightSlotFirstRowConfig: Object,
        rightSlotSecondRowConfig: Object,
        rightSlotThirdRowConfig: Object,
        fullWidthSlotConfig: Object
    },
    data: function data() {
        return {
            dates: this.defaultDates,
            datesObj: {},
            leftSlot: {
                requestObj: {},
                responseObj: {},
                ajaxing: false
            },
            rightSlotFirstRow: {
                requestObj: {},
                responseObj: {},
                ajaxing: false
            },
            rightSlotSecondRow: {
                requestObj: {},
                responseObj: {},
                ajaxing: false
            },
            rightSlotThirdRow: {
                requestObj: {},
                responseObj: {
                    datasets: {
                        text: '',
                        date: ''
                    }
                },
                ajaxing: false
            },
            fullWidthSlot: {
                requestObj: {},
                responseObj: {
                    datasets: []
                },
                ajaxing: false
            }
        };
    },
    mounted: function mounted() {
        this.dateChange({
            start: this.defaultDates[0],
            end: this.defaultDates[1],
            unit: this.defaultDateUnit,
            shortcuts_text: this.defaultDateShortcut
        });
    },

    computed: {
        dateShortcutText: function dateShortcutText() {
            if (moment(this.datesObj.end) < moment()) {
                return '(過去 ' + (moment(this.datesObj.end).diff(moment(this.datesObj.start), 'days') + 1) + ' 天)';
            };
            return '';
        }
    },
    methods: {
        dateChange: function dateChange(e) {
            this.datesObj = e;
            this.updateView();
        },
        updateView: function updateView() {
            this.getCharts('leftSlot');
            this.getCharts('rightSlotFirstRow');
            this.getCharts('rightSlotSecondRow');
            this.getCharts('rightSlotThirdRow');
            this.getCharts('fullWidthSlot');
        },
        getCharts: function getCharts(slot) {
            var _this = this;

            var configName = slot + 'Config';
            if (this[configName] && this[slot]) {
                this.$set(this[slot], 'ajaxing', true);
                var api = this[configName].api;
                var params = api.params;
                params['date_range'] = (0, _dashboardHelper.dateRangeHelper)({
                    datesObj: this.datesObj,
                    dateHelper: api.dateHelper
                });
                this.$set(this[slot], 'requestObj', params);
                this.$http[api.method](api.url, { params: params }).then(function (response) {
                    _this.$set(_this[slot], 'responseObj', response.data);
                    _this.$set(_this[slot], 'ajaxing', false);
                }).catch(function (response) {
                    _this.$set(_this[slot], 'ajaxing', false);
                    $17.swal({
                        title: '圖表顯示失敗',
                        text: '\u7121\u6CD5\u53D6\u5F97 ' + _this[slot].titleText + ' \u8CC7\u6599',
                        type: 'warning',
                        showCancelButton: false
                    });
                });
            }
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"st-border st-border-gray-40 st-border-solid st-my-3 st-p-5 st-rounded-4\">\n    <div class=\"st-gap-2 st-grid st-grid-cols-1 md:st-grid-cols-2 st-mb-6\">\n        <v-date-picker ref=\"date_picker\" v-model=\"dates\" range=\"\" @change=\"dateChange\" v-bind=\"datePickerOptions\"></v-date-picker>\n        <span class=\"st-flex st-items-center st-text-16 st-text-gray-90\">{{ dateShortcutText }}</span>\n    </div>\n    <div>\n        <div class=\"st-gap-2 st-grid st-grid-cols-1 md:st-grid-cols-2\">\n            <div>\n                <div v-if=\"leftSlotConfig\">\n                    <div :class=\"chartTitleStyle\">{{ leftSlotConfig.titleText }}</div>\n                    <div class=\"st-mt-7\">\n                        <component ref=\"left_slot_chart\" :is=\"leftSlotConfig.compTag\" v-bind=\"leftSlotConfig.compAttr\" :request-obj=\"leftSlot.requestObj\" :response-obj=\"leftSlot.responseObj\" :ajaxing=\"leftSlot.ajaxing\"></component>\n                    </div>\n                </div>\n            </div>\n            <div>\n                <div v-if=\"rightSlotFirstRowConfig\">\n                    <div :class=\"chartTitleStyle\">{{ rightSlotFirstRowConfig.titleText }}</div>\n                    <component ref=\"right_slot_first_row_chart\" :is=\"rightSlotFirstRowConfig.compTag\" v-bind=\"rightSlotFirstRowConfig.compAttr\" :request-obj=\"rightSlotFirstRow.requestObj\" :response-obj=\"rightSlotFirstRow.responseObj\" :ajaxing=\"rightSlotFirstRow.ajaxing\"></component>\n                    <hr class=\"st-border-gray-40 st-mb-4 st-mt-3\">\n                </div>\n                <div v-if=\"rightSlotSecondRowConfig\">\n                    <div :class=\"chartTitleStyle\">{{ rightSlotSecondRowConfig.titleText }}</div>\n                    <component ref=\"right_slot_second_row_chart\" :is=\"rightSlotSecondRowConfig.compTag\" v-bind=\"rightSlotSecondRowConfig.compAttr\" :request-obj=\"rightSlotSecondRow.requestObj\" :response-obj=\"rightSlotSecondRow.responseObj\" :ajaxing=\"rightSlotSecondRow.ajaxing\"></component>\n                    <hr class=\"st-border-gray-40 st-mb-4 st-mt-3\">\n                </div>\n                <div v-if=\"rightSlotThirdRowConfig\">\n                    <div :class=\"chartTitleStyle\">{{ rightSlotThirdRowConfig.titleText }}</div>\n                    <component ref=\"right_slot_third_row_chart\" :is=\"rightSlotThirdRowConfig.compTag\" v-bind=\"rightSlotThirdRowConfig.compAttr\" :request-obj=\"rightSlotThirdRow.requestObj\" :response-obj=\"rightSlotThirdRow.responseObj\" :ajaxing=\"rightSlotThirdRow.ajaxing\"></component>\n                    <hr class=\"st-border-gray-40 st-mb-4 st-mt-3\">\n                </div>\n            </div>\n        </div>\n        <div class=\"st-grid st-grid-cols-1\">\n            <div v-if=\"fullWidthSlotConfig\">\n                <div :class=\"chartTitleStyle\">{{ fullWidthSlotConfig.titleText }}</div>\n                <component ref=\"bottom_full_slot_chart\" :is=\"fullWidthSlotConfig.compTag\" v-bind=\"fullWidthSlotConfig.compAttr\" :request-obj=\"fullWidthSlot.requestObj\" :response-obj=\"fullWidthSlot.responseObj\" :ajaxing=\"fullWidthSlot.ajaxing\"></component>\n            </div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-915ee274", module.exports)
  } else {
    hotAPI.update("_v-915ee274", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"../../dashboard/dashboard-helper":1137,"vue":792,"vue-hot-reload-api":785}],1088:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _dashboardHelper = require('../../dashboard/dashboard-helper');

exports.default = {
    props: {
        defaultDateUnit: {
            type: String,
            default: 'd'
        },
        defaultDateShortcut: {
            type: String,
            default: '過去 365 天'
        },
        defaultDates: {
            type: Array,
            default: function _default() {
                var defaultS = moment().subtract(364, 'days').format('YYYY-MM-DD');
                var defaultE = moment().format('YYYY-MM-DD');
                return [defaultS, defaultE];
            }
        },
        datePickerOptions: {
            type: Object
        },
        chartTitleStyle: {
            type: [String, Array, Object],
            default: 'st-my-2 st-text-16 st-text-gray-90'
        },
        fullWidthSlotConfig: Object
    },
    data: function data() {
        return {
            dates: this.defaultDates,
            datesObj: {},
            fullWidthSlot: {
                requestObj: {},
                responseObj: { datasets: [] },
                ajaxing: false
            }
        };
    },
    mounted: function mounted() {
        this.dateChange({
            start: this.defaultDates[0],
            end: this.defaultDates[1],
            unit: this.defaultDateUnit,
            shortcuts_text: this.defaultDateShortcut
        });
    },

    computed: {
        dateShortcutText: function dateShortcutText() {
            if (moment(this.datesObj.end) < moment()) {
                return '(過去 ' + (moment(this.datesObj.end).diff(moment(this.datesObj.start), 'days') + 1) + ' 天)';
            };
            return '';
        }
    },
    methods: {
        dateChange: function dateChange(e) {
            this.datesObj = e;
            this.updateView();
        },
        updateView: function updateView() {
            this.getCharts('fullWidthSlot');
        },
        getCharts: function getCharts(slot) {
            var _this = this;

            var configName = slot + 'Config';
            if (this[configName] && this[slot]) {
                this.$set(this[slot], 'ajaxing', true);
                var api = this[configName].api;
                var params = api.params;
                params['date_range'] = (0, _dashboardHelper.dateRangeHelper)({
                    datesObj: this.datesObj,
                    dateHelper: api.dateHelper
                });
                this.$set(this[slot], 'requestObj', params);
                this.$http[api.method](api.url, { params: params }).then(function (response) {
                    _this.$set(_this[slot], 'responseObj', response.data);
                    _this.$set(_this[slot], 'ajaxing', false);
                }).catch(function (response) {
                    _this.$set(_this[slot], 'ajaxing', false);
                    $17.swal({
                        title: '圖表顯示失敗',
                        text: '\u7121\u6CD5\u53D6\u5F97 ' + _this[slot].titleText + ' \u8CC7\u6599',
                        type: 'warning',
                        showCancelButton: false
                    });
                });
            }
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"st-border st-border-gray-40 st-border-solid st-my-3 st-p-5 st-rounded-4\">\n    <div class=\"st-gap-2 st-grid st-grid-cols-1 md:st-grid-cols-2 st-mb-6\">\n        <v-date-picker ref=\"date_picker\" v-model=\"dates\" range=\"\" @change=\"dateChange\" v-bind=\"datePickerOptions\"></v-date-picker>\n        <span class=\"st-flex st-items-center st-text-16 st-text-gray-90\">{{ dateShortcutText }}</span>\n    </div>\n    <div>\n        <div class=\"st-grid st-grid-cols-1\">\n            <div v-if=\"fullWidthSlotConfig\">\n                <div :class=\"chartTitleStyle\">{{ fullWidthSlotConfig.titleText }}</div>\n                <component ref=\"full_width_slot_chart\" :is=\"fullWidthSlotConfig.compTag\" v-bind=\"fullWidthSlotConfig.compAttr\" :request-obj=\"fullWidthSlot.requestObj\" :response-obj=\"fullWidthSlot.responseObj\" :ajaxing=\"fullWidthSlot.ajaxing\"></component>\n                <hr class=\"st-border-gray-40 st-mb-0 st-mt-3\">\n            </div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-03b9991c", module.exports)
  } else {
    hotAPI.update("_v-03b9991c", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"../../dashboard/dashboard-helper":1137,"vue":792,"vue-hot-reload-api":785}],1089:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _dashboardHelper = require('../../dashboard/dashboard-helper');

exports.default = {
    props: {
        defaultDateUnit: {
            type: String,
            default: 'd'
        },
        defaultDateShortcut: {
            type: String,
            default: '過去 90 天'
        },
        defaultDates: {
            type: Array,
            default: function _default() {
                var defaultS = moment().subtract(89, 'days').format('YYYY-MM-DD');
                var defaultE = moment().format('YYYY-MM-DD');
                return [defaultS, defaultE];
            }
        },
        datePickerOptions: {
            type: Object
        },
        chartTitleStyle: {
            type: [String, Array, Object],
            default: 'st-my-2 st-text-16 st-text-gray-90'
        },
        leftSlotConfig: Object,
        rightSlotFirstRowConfig: Object,
        rightSlotSecondRowConfig: Object,
        rightSlotThirdRowConfig: Object,
        fullWidthSlotConfig: Object
    },
    data: function data() {
        return {
            dates: this.defaultDates,
            datesObj: {},
            leftSlot: {
                requestObj: {},
                responseObj: {},
                ajaxing: false
            },
            rightSlotFirstRow: {
                requestObj: {},
                responseObj: {},
                ajaxing: false
            },
            rightSlotSecondRow: {
                requestObj: {},
                responseObj: {},
                ajaxing: false
            },
            rightSlotThirdRow: {
                requestObj: {},
                responseObj: {
                    datasets: {
                        text: '',
                        date: ''
                    }
                },
                ajaxing: false
            },
            fullWidthSlot: {
                requestObj: {},
                responseObj: {
                    datasets: []
                },
                ajaxing: false
            }
        };
    },
    mounted: function mounted() {
        this.dateChange({
            start: this.defaultDates[0],
            end: this.defaultDates[1],
            unit: this.defaultDateUnit,
            shortcuts_text: this.defaultDateShortcut
        });
    },

    computed: {
        dateShortcutText: function dateShortcutText() {
            if (moment(this.datesObj.end) < moment()) {
                return '(過去 ' + (moment(this.datesObj.end).diff(moment(this.datesObj.start), 'days') + 1) + ' 天)';
            };
            return '';
        }
    },
    methods: {
        dateChange: function dateChange(e) {
            this.datesObj = e;
            this.updateView();
        },
        updateView: function updateView() {
            this.getCharts('leftSlot');
            this.getCharts('rightSlotFirstRow');
            this.getCharts('rightSlotSecondRow');
            this.getCharts('rightSlotThirdRow');
            this.getCharts('fullWidthSlot');
        },
        getCharts: function getCharts(slot) {
            var _this = this;

            var configName = slot + 'Config';
            if (this[configName] && this[slot]) {
                this.$set(this[slot], 'ajaxing', true);
                var api = this[configName].api;
                var params = api.params;
                params['date_range'] = (0, _dashboardHelper.dateRangeHelper)({
                    datesObj: this.datesObj,
                    dateHelper: api.dateHelper
                });
                this.$set(this[slot], 'requestObj', params);
                this.$http[api.method](api.url, { params: params }).then(function (response) {
                    _this.$set(_this[slot], 'responseObj', response.data);
                    _this.$set(_this[slot], 'ajaxing', false);
                }).catch(function (response) {
                    _this.$set(_this[slot], 'ajaxing', false);
                    $17.swal({
                        title: '圖表顯示失敗',
                        text: '\u7121\u6CD5\u53D6\u5F97 ' + _this[slot].titleText + ' \u8CC7\u6599',
                        type: 'warning',
                        showCancelButton: false
                    });
                });
            }
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"st-border st-border-gray-40 st-border-solid st-my-3 st-p-5 st-rounded-4\">\n    <div class=\"st-gap-2 st-grid st-grid-cols-1 md:st-grid-cols-2 st-mb-6\">\n        <v-date-picker ref=\"date_picker\" v-model=\"dates\" range=\"\" @change=\"dateChange\" v-bind=\"datePickerOptions\"></v-date-picker>\n        <span class=\"st-flex st-items-center st-text-16 st-text-gray-90\">{{ dateShortcutText }}</span>\n    </div>\n    <div>\n        <div class=\"st-gap-2 st-grid st-grid-cols-1 md:st-grid-cols-2\">\n            <div>\n                <div v-if=\"leftSlotConfig\">\n                    <div :class=\"chartTitleStyle\">{{ leftSlotConfig.titleText }}</div>\n                    <div class=\"st-mt-7\">\n                        <component ref=\"left_slot_chart\" :is=\"leftSlotConfig.compTag\" v-bind=\"leftSlotConfig.compAttr\" :request-obj=\"leftSlot.requestObj\" :response-obj=\"leftSlot.responseObj\" :ajaxing=\"leftSlot.ajaxing\"></component>\n                    </div>\n                </div>\n            </div>\n            <div>\n                <div v-if=\"rightSlotFirstRowConfig\">\n                    <div :class=\"chartTitleStyle\">{{ rightSlotFirstRowConfig.titleText }}</div>\n                    <component ref=\"right_slot_first_row_chart\" :is=\"rightSlotFirstRowConfig.compTag\" v-bind=\"rightSlotFirstRowConfig.compAttr\" :request-obj=\"rightSlotFirstRow.requestObj\" :response-obj=\"rightSlotFirstRow.responseObj\" :ajaxing=\"rightSlotFirstRow.ajaxing\"></component>\n                    <hr class=\"st-border-gray-40 st-mb-4 st-mt-3\">\n                </div>\n                <div v-if=\"rightSlotSecondRowConfig\">\n                    <div :class=\"chartTitleStyle\">{{ rightSlotSecondRowConfig.titleText }}</div>\n                    <component ref=\"right_slot_second_row_chart\" :is=\"rightSlotSecondRowConfig.compTag\" v-bind=\"rightSlotSecondRowConfig.compAttr\" :request-obj=\"rightSlotSecondRow.requestObj\" :response-obj=\"rightSlotSecondRow.responseObj\" :ajaxing=\"rightSlotSecondRow.ajaxing\"></component>\n                    <hr class=\"st-border-gray-40 st-mb-4 st-mt-3\">\n                </div>\n                <div v-if=\"rightSlotThirdRowConfig\">\n                    <div :class=\"chartTitleStyle\">{{ rightSlotThirdRowConfig.titleText }}</div>\n                    <component ref=\"right_slot_third_row_chart\" :is=\"rightSlotThirdRowConfig.compTag\" v-bind=\"rightSlotThirdRowConfig.compAttr\" :request-obj=\"rightSlotThirdRow.requestObj\" :response-obj=\"rightSlotThirdRow.responseObj\" :ajaxing=\"rightSlotThirdRow.ajaxing\"></component>\n                    <hr class=\"st-border-gray-40 st-mb-4 st-mt-3\">\n                </div>\n            </div>\n        </div>\n        <div class=\"st-grid st-grid-cols-1\">\n            <div v-if=\"fullWidthSlotConfig\">\n                <div :class=\"chartTitleStyle\">{{ fullWidthSlotConfig.titleText }}</div>\n                <component ref=\"bottom_full_slot_chart\" :is=\"fullWidthSlotConfig.compTag\" v-bind=\"fullWidthSlotConfig.compAttr\" :request-obj=\"fullWidthSlot.requestObj\" :response-obj=\"fullWidthSlot.responseObj\" :ajaxing=\"fullWidthSlot.ajaxing\"></component>\n            </div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-442c637a", module.exports)
  } else {
    hotAPI.update("_v-442c637a", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"../../dashboard/dashboard-helper":1137,"vue":792,"vue-hot-reload-api":785}],1090:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.credit-input[_v-220ffe14] {\n  width: 80px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['memberId'],
    data: function data() {
        return {
            branch_id: 0
        };
    },
    created: function created() {
        var _this = this;

        window.Event.$on('auto-pay-plan-branch', function (branch) {
            _this.branch_id = branch.id;
        });
        this.$on('new-card-validated', function (card) {
            var vm = _this;

            vm.create(card);
            vm.$store.dispatch('setWeblog', { 'name': '後台綁卡', 'message': 'branch_id[' + vm.branch_id + '] 綁 member_id[' + vm.memberId + '] 信用卡' });
        });
    },
    mounted: function mounted() {
        var vm = this;
        $('#add-credit-modal').on('hidden.bs.modal', function () {
            vm.$emit('reset-new-card-form');
        });
    },

    methods: {
        validate: function validate() {
            this.$emit('validate-new-card');
        },
        create: function create(card) {
            $.blockUI();
            this.$http.post('/adminapi/branch_payment_payload/create/binding_credits/auto_pay_plan/' + this.memberId + '/branch/' + this.branch_id, {
                number: card.card,
                year: card.year,
                month: card.month,
                cvc: card.authCode
            }).then(function (response) {
                $.unblockUI();
                window.Event.$emit('add-binding-member-credit-card-branch', response.data.payload);
                $('#add-credit-modal').modal('hide');
                $17.swal({
                    title: '綁定成功',
                    text: '',
                    type: 'success',
                    showCancelButton: false
                });
            }).catch(function (response) {
                $.unblockUI();
                $17.swal({
                    title: '綁定失敗',
                    text: response.data.hasOwnProperty('message') ? response.data.message : '',
                    type: 'error',
                    showCancelButton: false
                });
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal id=\"add-credit-modal\" confirm-btn-text=\"確定\" no-cancel=\"\" parallel-modal=\"\" :save-clicked=\"validate\" _v-220ffe14=\"\">\n    <h4 slot=\"title\" _v-220ffe14=\"\">新增綁定信用卡</h4>\n    <div slot=\"body\" _v-220ffe14=\"\">\n        <div style=\"border: 1px solid #bbb;border-left: 5px solid #bbb;padding: 20px\" _v-220ffe14=\"\">\n            <span class=\"glyphicon glyphicon-info-sign\" aria-hidden=\"true\" _v-220ffe14=\"\"></span>\n            為確認卡片的有效性，此客戶須刷下新台幣 1 元作為金流測試費。\n        </div>\n        <v-new-card-form :bus=\"this\" _v-220ffe14=\"\"></v-new-card-form>\n    </div>\n</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.credit-input[_v-220ffe14] {\n  width: 80px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-220ffe14", module.exports)
  } else {
    hotAPI.update("_v-220ffe14", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1091:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/admission', ['settingInfo', 'types']), {
		isPoint: function isPoint() {
			return this.settingInfo.type == this.types.point.id;
		},
		typeName: function typeName() {
			for (var t in this.types) {
				if (this.types[t].id == this.settingInfo.type) {
					return this.types[t].name;
				}
			}
			return '';
		}
	}),
	methods: {
		trueOrFalse: function trueOrFalse(v) {
			return v ? '是' : '否';
		}
	}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal id=\"admission-info-modal\" no-footer=\"\" no-border-radius=\"\" parallel-modal=\"\" open-size=\"modal-sm\" _v-2fcff16c=\"\">\n\t<template slot=\"title\">\n\t\t{{ settingInfo.name }}\n\t</template>\n\t<template slot=\"body\">\n\t\t<p _v-2fcff16c=\"\">類型：{{ typeName }}</p>\n\t\t<p v-show=\"!isPoint\" _v-2fcff16c=\"\">\n\t\t\t紀錄出場：{{ trueOrFalse(settingInfo.is_enabled_out) }}\n\t\t</p>\n\t\t<p v-show=\"!isPoint\" _v-2fcff16c=\"\">\n\t\t\t限制入場時間：{{ trueOrFalse(settingInfo.is_enabled_limit_time) }}\n\t\t\t<span v-show=\"settingInfo.is_enabled_limit_time\" _v-2fcff16c=\"\">, {{ settingInfo.limit_time }}分鐘</span>\n\t\t</p>\n\t\t<p v-show=\"isPoint\" _v-2fcff16c=\"\">\n\t\t\t入場扣點：{{ trueOrFalse(settingInfo.is_enabled_enter_point) }}\n\t\t\t<span v-show=\"settingInfo.is_enabled_enter_point\" _v-2fcff16c=\"\">\n\t\t\t\t, {{ settingInfo.enter_minus_point }}點\n\t\t\t</span>\n\t\t</p>\n\t\t<p v-show=\"isPoint\" _v-2fcff16c=\"\">\n\t\t\t出場扣點：{{ trueOrFalse(settingInfo.is_enabled_out_point) }}\n\t\t\t<span v-show=\"settingInfo.is_enabled_out_point\" _v-2fcff16c=\"\">\n\t\t\t\t, 入場後{{ settingInfo.after_enter_time_minus_point }}分鐘開始計時，\n\t\t\t\t每{{ settingInfo.out_time_unit }}分鐘扣{{ settingInfo.out_minus_point }}點\n\t\t\t</span>\n\t\t</p>\n\t</template>\n</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-2fcff16c", module.exports)
  } else {
    hotAPI.update("_v-2fcff16c", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1092:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n#data tbody > tr:last-child > td[_v-19e9dc4a] {\n  border-top: 0; }\n\n/* line 6, stdin */\n.add-border[_v-19e9dc4a] {\n  border-top: 1px solid #ddd; }\n\n/* line 10, stdin */\nthead[_v-19e9dc4a] {\n  background-color: #EEE; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['memberId', 'extraData'],
    mounted: function mounted() {},

    methods: (0, _extends3.default)({
        bookClassBatch: function bookClassBatch(memberContract) {
            var payload = {
                widget: 'book.class.batch.continue',
                widget_config_width: 'full',
                widget_contract_id: memberContract.id,
                widget_contract_name: memberContract.name,
                widget_member_id: memberContract.memberId,
                widget_member_name: memberContract.ownerName
            };
            if (this.extraData && this.extraData.hasOwnProperty('branch_id')) {
                payload['widget_branch_id'] = this.extraData.branch_id;
            }
            window.Event.$emit('FloatWidget.Show', payload);
            $('#modal-contract').modal('hide');
            $('#order-show').modal('hide');
        },

        showModalStatus: function showModalStatus() {
            this.$store.commit('webadmin/crm/CRM_CHANGE_CONTRACT', this.mainContract);
            $('#modalStatus-contract').modal('show');
        },
        showModalTime: function showModalTime(main) {
            this.$store.commit('webadmin/crm/CRM_CHANGE_CONTRACT', this.mainContract);
            $('#modalTime-contract').modal('show');
        },
        showModalPoint: function showModalPoint(main) {
            this.$store.commit('webadmin/crm/CRM_CHANGE_CONTRACT', this.mainContract);
            $('#modalPoint-contract').modal('show');
        },
        printContract: function printContract(main) {
            console.log("open printContract");
        },
        outputContract: function outputContract(main) {
            console.log("open printContract");
        },
        openBookingsPage: function openBookingsPage(main) {
            window.open(window.location.origin + "/webadmin/bookings?f%5Bmember_contract_id%5D=" + this.mainContract.memberContractId, '_blank');
        },
        openServiceBookingsPage: function openServiceBookingsPage(main) {
            window.open(window.location.origin + "/webadmin/service-bookings/list?member_contract_id=" + this.mainContract.memberContractId, '_blank');
        },
        cancelAllBookings: function cancelAllBookings() {
            var _this = this;
            $17.swal({
                title: i18n.t('pass.cancel_all_bookings'),
                html: '系統將會執行下面的動作。請注意，此操作無法返回。<ol class="text-left p-top-10"><li>尚未開始的預約將被【無條件取消】</li><li>方案的剩餘權益將被【清除】</li><li>方案的狀態將被設定為【失效】</li><ol>',
                type: 'warning',
                confirmButtonText: i18n.t('pass.confirm_cancel_all_bookings'),
                cancelButtonText: i18n.t('general.close'),
                showCancelButton: true,
                closeOnConfirm: false,
                showLoaderOnConfirm: true
            }, function (isConfirm) {
                if (isConfirm) {
                    $.blockUI();
                    _this.$http.post('/adminapi/member-contract/power-cancel-bookings/' + _this.mainContract.memberContractId).then(function (response) {
                        if (_this.memberId) {
                            _this.$store.dispatch('webadmin/crm/fetchMemberContract', _this.memberId);
                        }
                        var newData = response.data.memberContract;
                        var tmpMainContract = (0, _assign2.default)({}, _this.mainContract);
                        tmpMainContract.totalValue = 0;
                        tmpMainContract.expiration.startTime = newData.start_time;
                        tmpMainContract.expiration.endTime = newData.end_time;
                        tmpMainContract.status = 2;
                        _this.$store.commit('webadmin/crm/CRM_CHANGE_CONTRACT', tmpMainContract);
                        $.unblockUI();
                        _this.alert(i18n.t('pass.cancel_success'), '', 'success');
                    }).catch(function (response) {
                        $.unblockUI();
                        var message = response.data.hasOwnProperty('message') ? response.data.message : '';
                        _this.alert(i18n.t('general.unknown_error'), message, 'error');
                    });
                }
            });
        },
        alert: function alert(title, message, type) {
            $17.swal({
                title: title,
                text: message,
                type: type,
                showCancelButton: false,
                showLoaderOnConfirm: true
            });
        }
    }, (0, _vuex.mapActions)('webadmin/print', ['outputMembercontract', 'previewMembercontract'])),
    computed: (0, _extends3.default)({
        name: function name() {
            if (!this.mainContract) {
                return '';
            }
            return this.mainContract.name;
        },
        showStatus: function showStatus() {
            if (!this.mainContract) {
                return '';
            }
            return this.mainContract.showStatus;
        },
        status: function status() {
            if (!this.mainContract) {
                return '';
            }
            return this.mainContract.status;
        },
        pauseTime: function pauseTime() {
            if (!this.mainContract || !this.mainContract.hasOwnProperty('pauseTime')) {
                return '';
            }
            return this.mainContract.pauseTime;
        },
        startTime: function startTime() {
            if (!this.mainContract.expiration) {
                return '';
            }
            return this.mainContract.expiration.startTime;
        },
        endTime: function endTime() {
            if (!this.mainContract.expiration || this.mainContract.expiration.endTime == '-') {
                return '';
            }
            return this.mainContract.expiration.endTime;
        },
        titleOfContractValue: function titleOfContractValue() {
            if (!this.mainContract) {
                return '';
            }
            return this.mainContract.titleOfContractValue;
        },
        totalValue: function totalValue() {
            if (!this.mainContract) {
                return '';
            }
            return this.mainContract.totalValue;
        },
        contractValueName: function contractValueName() {
            if (!this.mainContract) {
                return '';
            }
            return this.mainContract.contractValueName;
        },
        contractType: function contractType() {
            if (!this.mainContract) {
                return '';
            }
            return this.mainContract.contractType;
        },
        isShared: function isShared() {
            if (!this.mainContract) {
                return '';
            }
            return this.mainContract.isShared;
        },
        remainValueDisplayText: function remainValueDisplayText() {
            if (this.contractType == 1 && !this.endTime) {
                return '無限';
            }
            return this.totalValue + this.contractValueName;
        }
    }, (0, _vuex.mapState)({
        canPowerCancel: function canPowerCancel(state) {
            return state.webadmin.configure.webFunctions.WebadminMemberStudioContractPowerCancel;
        },
        contractEditable: function contractEditable(state) {
            return state.webadmin.configure.webFunctions.WebadminMemberStudioContractEdit;
        },
        mainContract: function mainContract(state) {
            return state.webadmin.crm.changedContract;
        }
    }))
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<!--更改頁面-->\n<v-modal id=\"modal-contract\" no-footer=\"\" parallel-modal=\"\" _v-19e9dc4a=\"\">\n    <h4 slot=\"title\" _v-19e9dc4a=\"\">{{name}}</h4>\n    <form slot=\"body\" class=\"form-horizontal\" autocomplete=\"off\" _v-19e9dc4a=\"\">\n        <table slot=\"table\" class=\"table\" _v-19e9dc4a=\"\">\n            <thead _v-19e9dc4a=\"\">\n                <tr _v-19e9dc4a=\"\">\n                    <td _v-19e9dc4a=\"\">\n                    \n                    </td>\n                    <td class=\"text-right\" _v-19e9dc4a=\"\">\n                        <span class=\"colorGrey\" _v-19e9dc4a=\"\">{{titleOfContractValue}}</span>\n                    </td>\n                </tr>\n            </thead>\n            <tbody _v-19e9dc4a=\"\">\n                <tr v-if=\"contractType != 4\" _v-19e9dc4a=\"\">\n                    <th _v-19e9dc4a=\"\">剩餘{{titleOfContractValue}}</th>\n                    <td class=\"text-right\" _v-19e9dc4a=\"\">\n                        <div id=\"\" _v-19e9dc4a=\"\">\n                            <span _v-19e9dc4a=\"\">\n                                {{remainValueDisplayText}}\n                            </span>\n                            <button v-if=\"!isShared &amp;&amp; contractEditable &amp;&amp; status!=2\" class=\"btn btn-primary btn-xs\" v-show=\"contractType != 1\" @click.stop.prevent=\"showModalPoint(this.mainContract)\" _v-19e9dc4a=\"\">\n                                <i class=\"fa fa-pencil\" _v-19e9dc4a=\"\"></i>\n                            </button>\n                        </div>\n                    </td>\n                </tr>\n                <tr _v-19e9dc4a=\"\">\n                    <th _v-19e9dc4a=\"\">有效期間</th>\n                    <td class=\"text-right\" _v-19e9dc4a=\"\">\n                        {{startTime}}~{{endTime}}\n                        <button v-if=\"!isShared &amp;&amp; contractEditable &amp;&amp; status!=2\" class=\"btn btn-primary btn-xs\" @click.stop.prevent=\"showModalTime(this.mainContract)\" _v-19e9dc4a=\"\"><i class=\"fa fa-pencil\" _v-19e9dc4a=\"\"></i></button>\n                        <div v-if=\"this.mainContract.expired\" class=\"expired\" _v-19e9dc4a=\"\">已過期</div>\n                    </td>\n                </tr>\n                <tr _v-19e9dc4a=\"\">\n                    <th _v-19e9dc4a=\"\">狀態</th>\n                    <td class=\"text-right\" _v-19e9dc4a=\"\">\n                        {{showStatus}}\n                        <span class=\"p-left-5\" v-show=\"status==3\" _v-19e9dc4a=\"\">\n                            {{pauseTime.pauseStartTime}}~{{pauseTime.pauseEndTime}}\n                        </span>\n                        <button v-if=\"!isShared &amp;&amp; contractEditable &amp;&amp; status!=2 &amp;&amp; contractType != 4\" class=\"btn btn-primary btn-xs\" @click.stop.prevent=\"showModalStatus()\" _v-19e9dc4a=\"\"><i class=\"fa fa-pencil\" _v-19e9dc4a=\"\"></i></button>\n                    </td>\n                </tr>\n            </tbody>\n        </table>\n        <div class=\"content-inner\" _v-19e9dc4a=\"\">\n            <input type=\"button\" class=\"btn btn-primary\" value=\"管理已訂課程\" @click=\"openBookingsPage(mainContract)\" _v-19e9dc4a=\"\">\n            <input type=\"button\" class=\"btn btn-primary\" value=\"管理已訂服務\" @click=\"openServiceBookingsPage(mainContract)\" _v-19e9dc4a=\"\">\n            <div class=\"btn-group dropup\" _v-19e9dc4a=\"\">\n                <button type=\"button\" class=\"btn btn-primary dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" _v-19e9dc4a=\"\">\n                    進階功能 <span class=\"caret\" _v-19e9dc4a=\"\"></span>\n                </button>\n                <ul class=\"dropdown-menu\" _v-19e9dc4a=\"\">\n                    <li _v-19e9dc4a=\"\"><a class=\"!st-px-4 !st-py-2 st-text-16\" @click.prevent=\"outputMembercontract({'memberContractId':mainContract.memberContractId,'memberId':mainContract.memberId})\" _v-19e9dc4a=\"\">輸出方案</a></li>\n                    <li _v-19e9dc4a=\"\"><a class=\"!st-px-4 !st-py-2 st-text-16\" @click.prevent=\"previewMembercontract({'memberContractId':mainContract.memberContractId,'memberId':mainContract.memberId})\" _v-19e9dc4a=\"\">列印方案</a></li>\n                    <li v-if=\"(status==1||status==3) &amp;&amp; contractType != 4\" _v-19e9dc4a=\"\"><a class=\"!st-px-4 !st-py-2 st-text-16\" @click.prevent=\"bookClassBatch(mainContract)\" _v-19e9dc4a=\"\">批次預約</a></li>\n                </ul>\n            </div>\n            <input v-if=\"canPowerCancel &amp;&amp; !isShared &amp;&amp; status!=2\" type=\"button\" class=\"btn btn-danger btn--inverse pull-right\" :value=\"i18n.t('pass.cancel_all_bookings')\" @click=\"cancelAllBookings()\" _v-19e9dc4a=\"\">\n        </div>\n    </form>\n</v-modal>\n<!--更改頁面-->\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n#data tbody > tr:last-child > td[_v-19e9dc4a] {\n  border-top: 0; }\n\n/* line 6, stdin */\n.add-border[_v-19e9dc4a] {\n  border-top: 1px solid #ddd; }\n\n/* line 10, stdin */\nthead[_v-19e9dc4a] {\n  background-color: #EEE; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-19e9dc4a", module.exports)
  } else {
    hotAPI.update("_v-19e9dc4a", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/object/assign":50,"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1093:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n#data tbody > tr:last-child > td[_v-688b9a90] {\n  border-top: 0; }\n\n/* line 6, stdin */\n.add-border[_v-688b9a90] {\n  border-top: 1px solid #ddd; }\n\n/* line 10, stdin */\nthead[_v-688b9a90] {\n  background-color: #EEE; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['memberId'],
    data: function data() {
        return {
            point: 0,
            currentValue: 0,
            startAjax: false,
            reason: '',
            record_type: 100
        };
    },
    mounted: function mounted() {
        var _this = this;

        $(this.$el).find('#modalPoint-contract').on('shown.bs.modal', (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _this.refresh();
                            _this.currentValue = _this.originalCurrentValue;

                        case 2:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        })));
    },

    watch: {
        currentValue: function currentValue(val) {
            this.point = val - this.originalCurrentValue;
        }
    },
    methods: {
        changeContractValue: function changeContractValue() {
            if (!this.checkIsValid()) {
                return false;
            }
            var vm = this;
            this.startAjax = true;
            this.$http.post('/adminapi/member-contract/update-value/' + this.memberContractId, {
                totalValue: this.currentValue,
                addValue: this.point,
                recordType: this.record_type,
                reason: this.reason,
                is17Fit: this.is17Fit
            }).then(function (response) {
                if (typeof this.memberId != 'undefined' && this.memberId != '' && this.memberId != null) {
                    this.$store.dispatch('webadmin/crm/fetchMemberContract', this.memberId);
                }
                this.startAjax = false;
                var tmpMainContract = (0, _assign2.default)({}, this.mainContract);
                tmpMainContract.totalValue = this.currentValue;
                tmpMainContract.addValue = this.point;
                tmpMainContract.recordType = this.record_type;
                tmpMainContract.reason = this.reason;
                tmpMainContract.is17Fit = this.is17Fit;
                this.$store.commit('webadmin/crm/CRM_CHANGE_CONTRACT', tmpMainContract);
                $("#modalPoint-contract").modal('hide');
                this.alert('修改成功', '', 'success');
                this.refresh();
            }, function (response) {
                this.startAjax = false;
                this.alert('修改失敗', '', 'warning');
            });
        },
        addValue: function addValue() {
            this.point++;
            this.currentValue++;
        },
        subtractValue: function subtractValue() {
            if (this.currentValue <= 0) return;
            this.point--;
            this.currentValue--;
        },
        slideUpAlert: function slideUpAlert() {
            $(".alert-danger").fadeTo(2000, 500).slideUp(500, function () {
                $(".alert-danger").slideUp(500);
            });
        },
        alert: function alert(title, message, type, showCancelBtn) {
            $17.swal({
                title: title,
                text: message,
                type: type,
                showCancelButton: false,
                showLoaderOnConfirm: true
            });
        },
        refresh: function refresh() {
            this.currentValue = 0;
            this.point = 0;
            this.reason = '';
            this.record_type = 100;
        },
        checkIsValid: function checkIsValid() {
            if (this.reason == '' || this.record_type == '') {
                this.slideUpAlert();
                return false;
            }
            if (this.record_type == 99 && this.point < 0) {
                this.slideUpAlert();
                return false;
            }
            if (this.record_type == 98 && this.point > 0) {
                this.slideUpAlert();
                return false;
            }
            if (this.currentValue < 0) {
                this.slideUpAlert();
                return false;
            }
            return true;
        }
    },
    computed: (0, _extends3.default)({
        name: function name() {
            if (!this.mainContract) {
                return '';
            }
            return this.mainContract.name;
        },
        contractValueName: function contractValueName() {
            if (!this.mainContract) {
                return '';
            }
            return this.mainContract.contractValueName;
        },
        titleOfContractValue: function titleOfContractValue() {
            if (!this.mainContract) {
                return '';
            }
            return this.mainContract.titleOfContractValue;
        },
        memberContractId: function memberContractId() {
            if (!this.mainContract) {
                return '';
            }
            return this.mainContract.memberContractId;
        },
        is17Fit: function is17Fit() {
            if (!this.mainContract) {
                return '';
            }
            return this.mainContract.is17Fit;
        },
        symbol: function symbol() {

            if (this.originalCurrentValue - this.currentValue <= 0) {
                return '+';
            }

            return '';
        }
    }, (0, _vuex.mapState)({
        mainContract: function mainContract(state) {
            return state.webadmin.crm.changedContract;
        },
        originalCurrentValue: function originalCurrentValue(state) {
            return state.webadmin.crm.changedContract.totalValue;
        }
    }))

};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-688b9a90=\"\">\n<v-spinner :ajaxing=\"startAjax\" style=\"align:center\" _v-688b9a90=\"\">\n</v-spinner>\n<!--更改點數/次-->\n<v-modal id=\"modalPoint-contract\" :close-modal-event=\"refresh\" v-show=\"!startAjax\" no-footer=\"\" parallel-modal=\"\" _v-688b9a90=\"\">\n    <h4 slot=\"title\" _v-688b9a90=\"\">{{name}}</h4>\n    <!--alert danger-->\n    <div slot=\"body\" class=\"alert alert-danger\" role=\"alert\" style=\"display: none\" _v-688b9a90=\"\">\n        <strong v-if=\"reason == ''\" _v-688b9a90=\"\">備註不可空白</strong>\n        <strong v-if=\"record_type ==''\" _v-688b9a90=\"\">請選擇操作類型</strong>\n        <strong v-if=\"!currentValue\" _v-688b9a90=\"\">{{titleOfContractValue}}未異動</strong>\n        <strong v-if=\"this.record_type == 99\" _v-688b9a90=\"\">贈送：異動{{titleOfContractValue}}不可小於零</strong>\n        <strong v-if=\"this.record_type == 98\" _v-688b9a90=\"\">退費：異動{{titleOfContractValue}}不可大於零</strong>\n        <strong v-if=\"currentValue < 0\" _v-688b9a90=\"\">編輯{{titleOfContractValue}}不可為負值</strong>\n    </div>\n    <!--alert danger-->\n    <form slot=\"body\" accept-charset=\"UTF-8\" class=\"form-horizontal\" autocomplete=\"off\" enctype=\"multipart/form-data\" _v-688b9a90=\"\">\n        <div _v-688b9a90=\"\">\n            <div class=\"form-group\" _v-688b9a90=\"\">\n                <label class=\"col-xs-2 control-label\" _v-688b9a90=\"\">剩餘{{titleOfContractValue}}</label>\n                <label class=\"col-xs-10 control-labe \" _v-688b9a90=\"\">\n                    <div class=\"text-left\" _v-688b9a90=\"\">{{originalCurrentValue}}</div>\n                </label>\n            </div>\n            <div class=\"form-group\" _v-688b9a90=\"\">\n                <label for=\"value\" class=\"col-xs-2 control-label\" _v-688b9a90=\"\">編輯{{titleOfContractValue}}</label>\n                <div class=\"col-xs-10\" _v-688b9a90=\"\">\n                    <div class=\"input-group\" _v-688b9a90=\"\">\n                        <span class=\"input-group-btn\" _v-688b9a90=\"\">\n                            <button type=\"button\" class=\"btn btn-danger\" @click=\"subtractValue\" _v-688b9a90=\"\">\n                                <i class=\"fa fa-minus\" _v-688b9a90=\"\"></i>\n                            </button>\n                        </span>\n                        <input id=\"value\" class=\"form-control\" name=\"value\" type=\"text\" v-model=\"currentValue\" _v-688b9a90=\"\">\n                        <span class=\"input-group-addon \" _v-688b9a90=\"\">{{contractValueName}}</span>\n                        <span class=\"input-group-btn\" _v-688b9a90=\"\">\n                                <button type=\"button\" class=\"btn btn-success\" @click=\"addValue\" _v-688b9a90=\"\">\n                                    <i class=\"fa fa-plus\" _v-688b9a90=\"\"></i>\n                                </button>\n                        </span>\n                        <span class=\"input-group-addon \" id=\"change_value\" _v-688b9a90=\"\">\n                        <span _v-688b9a90=\"\">{{symbol}}{{point}}</span>\n                            <input id=\"add_value\" v-model=\"point\" type=\"hidden\" _v-688b9a90=\"\">\n                        </span>\n                    </div>\n                </div>\n            </div>\n            <div class=\"form-group\" _v-688b9a90=\"\">\n                <label for=\"record_type\" class=\"col-sm-2 control-label\" _v-688b9a90=\"\">操作</label>\n                <div class=\"col-sm-10\" _v-688b9a90=\"\">\n                    <select id=\"record_type\" v-model=\"record_type\" class=\"form-control\" name=\"record_type\" _v-688b9a90=\"\">\n                        <option value=\"100\" _v-688b9a90=\"\">一般加扣</option>\n                        <option value=\"99\" _v-688b9a90=\"\">贈送</option>\n                        <option value=\"98\" _v-688b9a90=\"\">退費</option>\n                    </select>\n                </div>\n            </div>\n            <div class=\"form-group\" _v-688b9a90=\"\">\n                <label for=\"reason\" class=\"col-sm-2 control-label\" _v-688b9a90=\"\">備註</label>\n                <div class=\"col-sm-10\" _v-688b9a90=\"\">\n                    <textarea id=\"remark\" class=\"form-control\" rows=\"4\" v-model=\"reason\" name=\"reason\" cols=\"50\" _v-688b9a90=\"\"></textarea>\n                </div>\n            </div>\n            <div class=\"form-group\" _v-688b9a90=\"\">\n                <div class=\"col-sm-5 col-sm-offset-2\" _v-688b9a90=\"\">\n                    <input type=\"button\" class=\"btn btn-primary\" value=\"修改\" @click=\"changeContractValue\" _v-688b9a90=\"\">\n                </div>\n            </div>\n        </div>\n    </form>\n</v-modal>\n<!--更改點數/次-->\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n#data tbody > tr:last-child > td[_v-688b9a90] {\n  border-top: 0; }\n\n/* line 6, stdin */\n.add-border[_v-688b9a90] {\n  border-top: 1px solid #ddd; }\n\n/* line 10, stdin */\nthead[_v-688b9a90] {\n  background-color: #EEE; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-688b9a90", module.exports)
  } else {
    hotAPI.update("_v-688b9a90", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/object/assign":50,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1094:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\ninput[type=text][_v-1edcc6c4] {\n  width: inherit; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['memberId'],
    data: function data() {
        return {
            startAjax: false,
            currentMemberContractId: '',
            currentStatus: 0,
            currentPauseStartTime: '',
            currentPauseEndTime: '',
            reason: '',
            pauseDays: 0
        };
    },
    updated: function updated() {},
    mounted: function mounted() {
        var _this = this;

        $(this.$el).on('show.bs.modal', function () {
            _this.refresh();
        });
    },

    methods: {
        timeChange: function timeChange() {
            var _this2 = this;

            this.$nextTick(function () {
                _this2.detectDateValidation();
            });
        },
        detectDateValidation: function detectDateValidation() {
            if (this.currentPauseStartTime == '' || this.currentPauseEndTime == '') return;
            if (moment(this.currentPauseEndTime).isBefore(moment(this.currentPauseStartTime))) {
                this.currentPauseEndTime = this.currentPauseStartTime;
            }
            this.pauseDays = moment(this.currentPauseEndTime).diff(moment(this.currentPauseStartTime), 'days') + 1;
        },
        pauseDaysChange: function pauseDaysChange(val) {
            var changeVal = val >= 1 ? val - 1 : 0;
            if (!this.currentPauseStartTime) {
                this.currentPauseStartTime = moment().format('YYYY-MM-DD');
            }
            this.currentPauseEndTime = moment(this.currentPauseStartTime).add(changeVal, 'days').format('YYYY-MM-DD');
        },

        changeContractStatus: function changeContractStatus() {
            var _this3 = this;

            if (this.reason.trim() === '') {
                this.alert('請填寫原因', '', 'warning');
                return false;
            }
            if (this.currentStatus == 3) {
                if (this.currentPauseStartTime === '' || this.currentPauseEndTime === '') {
                    this.alert('請填寫開始日期及結束日期', '', 'warning');
                    return false;
                }
                if (this.currentPauseStartTime !== '' && moment(this.currentPauseStartTime).isBefore(moment(this.startTime)) || this.currentPauseEndTime !== '' && moment(this.currentPauseEndTime).isAfter(moment(this.endTime))) {
                    this.alert('日期錯誤', '暫停期限 需在方案有效期限 (' + this.startTime + '~' + this.endTime + ') 內', 'warning');
                    return false;
                }
                if (this.currentPauseStartTime !== '' && this.currentPauseEndTime !== '' && moment(this.currentPauseEndTime).isBefore(moment(this.currentPauseStartTime))) {
                    this.alert('日期錯誤', '暫停開始日期 不可大於 暫停結束日期', 'warning');
                    return false;
                }
            } else {
                this.currentPauseStartTime = '';
                this.currentPauseEndTime = '';
            }
            $.blockUI();
            this.$http.post('/adminapi/member-contract/update-status/' + this.memberContractId, {
                pauseStartDate: this.currentPauseStartTime,
                pauseEndDate: this.currentPauseEndTime,
                status: this.currentStatus,
                reason: this.reason.trim()
            }).then(function (response) {
                if (typeof _this3.memberId != 'undefined' && _this3.memberId != '' && _this3.memberId != null) {
                    _this3.$store.dispatch('webadmin/crm/fetchMemberContract', _this3.memberId);
                }
                _this3.startAjax = false;
                var tmpMainContract = (0, _assign2.default)({}, _this3.mainContract);
                tmpMainContract.pauseTime.pauseStartTime = _this3.currentPauseStartTime;
                tmpMainContract.pauseTime.pauseEndTime = _this3.currentPauseEndTime;
                tmpMainContract.status = response.data.status;
                tmpMainContract.showStatus = response.data.showStatus;
                tmpMainContract.pauseTime = {
                    pauseStartTime: _this3.currentPauseStartTime,
                    pauseEndTime: _this3.currentPauseEndTime
                };
                _this3.$store.commit('webadmin/crm/CRM_CHANGE_CONTRACT', tmpMainContract);
                $(_this3.$el).modal('hide');
                _this3.alert('修改成功', '', 'success');
                _this3.refresh();
                $.unblockUI();
            }, function (response) {
                var err = response.data.hasOwnProperty('errMessage') ? response.data.errMessage : '';
                _this3.alert('修改失敗', err, 'warning');
                $.unblockUI();
            });
        },
        alert: function alert(title, message, type) {
            $17.swal({
                title: title,
                text: message,
                type: type,
                showCancelButton: false,
                showLoaderOnConfirm: true
            });
        },

        refresh: function () {
            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                this.currentMemberContractId = this.memberContractId;
                                this.currentStatus = this.status;
                                this.currentPauseStartTime = this.pauseStartTime;
                                this.currentPauseEndTime = this.pauseEndTime;
                                this.reason = '';
                                if (this.currentPauseEndTime) {
                                    this.pauseDays = moment(this.currentPauseEndTime).diff(moment(this.currentPauseStartTime), 'days') + 1;
                                } else {
                                    this.pauseDays = 0;
                                }

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function refresh() {
                return _ref.apply(this, arguments);
            }

            return refresh;
        }()
    },
    computed: (0, _extends3.default)({
        name: function name() {
            if (!this.mainContract) {
                return '';
            }
            return this.mainContract.name;
        },
        status: function status() {
            if (!this.mainContract) {
                return '';
            }
            return this.mainContract.status;
        },
        pauseStartTime: function pauseStartTime() {
            if (!this.mainContract.pauseTime) {
                return '';
            }
            return this.mainContract.pauseTime.pauseStartTime;
        },
        pauseEndTime: function pauseEndTime() {
            if (!this.mainContract.pauseTime) {
                return '';
            }
            return this.mainContract.pauseTime.pauseEndTime;
        },
        startTime: function startTime() {
            if (!this.mainContract.expiration) {
                return '';
            }
            return this.mainContract.expiration.startTime;
        },
        endTime: function endTime() {
            if (!this.mainContract.expiration || this.mainContract.expiration.endTime == '-') {
                return '';
            }
            return this.mainContract.expiration.endTime;
        },
        memberContractId: function memberContractId() {
            if (!this.mainContract) {
                return '';
            }
            return this.mainContract.memberContractId;
        }
    }, (0, _vuex.mapState)({
        mainContract: function mainContract(state) {
            return state.webadmin.crm.changedContract;
        }
    }))
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal id=\"modalStatus-contract\" parallel-modal=\"\" _v-1edcc6c4=\"\">\n    <h4 slot=\"title\" _v-1edcc6c4=\"\">{{name}}</h4>\n\n    <form slot=\"body\" autocomplete=\"off\" _v-1edcc6c4=\"\">\n        <div class=\"st-grid st-grid-cols-12 st-gap-y-5\" _v-1edcc6c4=\"\">\n            <label class=\"st-col-span-2 st-text-right st-font-bold st-mr-5\" _v-1edcc6c4=\"\">狀態</label>\n            <div class=\"st-col-span-10\" _v-1edcc6c4=\"\">\n                <div class=\"st-flex st-space-x-2\" _v-1edcc6c4=\"\">\n                    <st-radio name=\"active\" label=\"啟用\" value=\"1\" :model.sync=\"currentStatus\" _v-1edcc6c4=\"\"></st-radio>\n                    <st-radio name=\"pause\" label=\"暫停\" value=\"3\" :model.sync=\"currentStatus\" _v-1edcc6c4=\"\"></st-radio>\n                    <st-radio name=\"expire\" label=\"失效\" value=\"2\" :model.sync=\"currentStatus\" _v-1edcc6c4=\"\"></st-radio>                        \n                </div>\n\n                <div v-show=\"currentStatus==3\" class=\"st-max-w-fit st-ml-6 st-my-6 st-space-y-5\" _v-1edcc6c4=\"\">\n                    <st-input label=\"開始日期\" _v-1edcc6c4=\"\">\n                        <div slot=\"input\" slot-scope=\"{ inputClass }\" _v-1edcc6c4=\"\">\n                            <v-date-picker v-model=\"currentPauseStartTime\" :input-class=\"inputClass\" :clearable=\"false\" @input=\"timeChange\" _v-1edcc6c4=\"\"></v-date-picker>\n                        </div>\n                    </st-input>\n                    <st-input label=\"結束日期\" _v-1edcc6c4=\"\">\n                        <div slot=\"input\" slot-scope=\"{ inputClass }\" _v-1edcc6c4=\"\">\n                            <v-date-picker v-model=\"currentPauseEndTime\" :value=\"currentPauseEndTime\" :input-class=\"inputClass\" :clearable=\"false\" @input=\"timeChange\" _v-1edcc6c4=\"\"></v-date-picker>\n                        </div>\n                    </st-input>\n                    <st-input label=\"暫停天數\" type=\"number\" min=\"1\" v-model=\"pauseDays\" @input=\"pauseDaysChange\" _v-1edcc6c4=\"\"></st-input>\n                </div>\n            </div>\n\n            <label class=\"st-col-span-2 st-text-right st-font-bold st-mr-5\" _v-1edcc6c4=\"\">原因</label>\n            <div class=\"st-col-span-10\" _v-1edcc6c4=\"\">\n                <st-input type=\"text\" v-model=\"reason\" _v-1edcc6c4=\"\"></st-input>\n            </div>\n        </div>\n    </form>\n    <div slot=\"footer\" _v-1edcc6c4=\"\">\n        <div _v-1edcc6c4=\"\">\n            <input type=\"button\" class=\"btn btn-primary\" value=\"修改\" @click=\"changeContractStatus()\" _v-1edcc6c4=\"\">\n        </div> \n    </div>\n</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\ninput[type=text][_v-1edcc6c4] {\n  width: inherit; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-1edcc6c4", module.exports)
  } else {
    hotAPI.update("_v-1edcc6c4", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/object/assign":50,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1095:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['memberId'],
    data: function data() {
        return {
            startAjax: false,
            reason: '',
            currentMemberContractId: null,
            beforeStartTime: '',
            beforeEndTime: '',
            afterStartTime: '',
            afterEndTime: '',
            startDaysDiff: 0,
            endDaysDiff: 0
        };
    },
    updated: function updated() {},
    mounted: function mounted() {
        var _this = this;

        $(this.$el).on('show.bs.modal', function () {
            _this.refresh();
        });
    },

    methods: {
        startDaysChange: function startDaysChange(val) {
            var startTime = moment(this.beforeStartTime).add(val, 'days').format('YYYY-MM-DD');
            var valid = this.detectDateValidation(startTime, this.afterEndTime);
            this.afterStartTime = valid ? startTime : this.afterEndTime;
            this.startDaysDiff = moment(this.afterStartTime).diff(moment(this.beforeStartTime), 'days');
        },
        endDaysChange: function endDaysChange(val) {
            var endTime = moment(this.beforeEndTime).add(val, 'days').format('YYYY-MM-DD');
            var valid = this.detectDateValidation(this.afterStartTime, endTime);
            this.afterEndTime = valid ? endTime : this.afterStartTime;
            this.endDaysDiff = this.beforeEndTime ? moment(this.afterEndTime).diff(moment(this.beforeEndTime), 'days') : 0;
        },
        startTimeChange: function startTimeChange(val) {
            var _this2 = this;

            var valid = this.detectDateValidation(val, this.afterEndTime);
            this.$nextTick(function () {
                if (!valid) {
                    _this2.afterStartTime = _this2.afterEndTime;
                }
                _this2.startDaysDiff = moment(_this2.afterStartTime).diff(moment(_this2.beforeStartTime), 'days');
            });
        },
        endTimeChange: function endTimeChange(val) {
            var _this3 = this;

            var valid = this.detectDateValidation(this.afterStartTime, val);
            this.$nextTick(function () {
                if (!valid) {
                    _this3.afterEndTime = _this3.afterStartTime;
                }
                _this3.endDaysDiff = _this3.beforeEndTime ? moment(_this3.afterEndTime).diff(moment(_this3.beforeEndTime), 'days') : 0;
            });
        },
        detectDateValidation: function detectDateValidation(start, end) {
            if (!end) return true;
            if (moment(end).isBefore(moment(start))) return false;
            return true;
        },

        changeContractDate: function changeContractDate(memberContractId) {
            var _this4 = this;

            if (!this.checkIsValid()) {
                return false;
            }
            $.blockUI();
            this.$http.post('/adminapi/member-contract/update-date/' + this.memberContractId, {
                startDate: this.afterStartTime,
                endDate: this.afterEndTime,
                reason: this.reason
            }).then(function (response) {
                if (typeof _this4.memberId != 'undefined' && _this4.memberId != '' && _this4.memberId != null) {
                    _this4.$store.dispatch('webadmin/crm/fetchMemberContract', _this4.memberId);
                }
                _this4.startAjax = false;
                var tmpMainContract = (0, _assign2.default)({}, _this4.mainContract);
                tmpMainContract.expiration.startTime = _this4.afterStartTime;
                tmpMainContract.expiration.endTime = _this4.afterEndTime;
                tmpMainContract.reason = _this4.reason;
                _this4.$store.commit('webadmin/crm/CRM_CHANGE_CONTRACT', tmpMainContract);
                $(_this4.$el).modal('hide');
                _this4.alert('修改成功', '', 'success');
                _this4.refresh();
                $.unblockUI();
            }, function (error) {
                _this4.alert('修改失敗', '', 'warning');
                $.unblockUI();
            });
        },
        alert: function alert(title, message, type, showCancelBtn) {
            $17.swal({
                title: title,
                text: message,
                type: type,
                showCancelButton: false,
                showLoaderOnConfirm: true
            });
        },

        refresh: function () {
            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                var defaultPeriod;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                defaultPeriod = {
                                    start: !this.mainContract.expiration ? '' : this.mainContract.expiration.startTime,
                                    end: !this.mainContract.expiration || this.mainContract.expiration.endTime == '-' ? '' : this.mainContract.expiration.endTime
                                };

                                this.currentMemberContractId = this.memberContractId;
                                this.beforeStartTime = defaultPeriod.start;
                                this.beforeEndTime = defaultPeriod.end;
                                this.afterStartTime = defaultPeriod.start;
                                this.afterEndTime = defaultPeriod.end;
                                this.startDaysDiff = 0;
                                this.endDaysDiff = 0;
                                this.reason = '';

                            case 9:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function refresh() {
                return _ref.apply(this, arguments);
            }

            return refresh;
        }(),
        checkIsValid: function checkIsValid() {
            if (this.reason == '') {
                this.alert('原因不可空白', '', 'warning');
                return false;
            }
            return true;
        }
    },
    computed: (0, _extends3.default)({
        name: function name() {
            if (!this.mainContract) {
                return '';
            }
            return this.mainContract.name;
        },
        memberContractId: function memberContractId() {
            if (!this.mainContract) {
                return '';
            }
            return this.mainContract.memberContractId;
        },
        beforeContractPeriods: function beforeContractPeriods() {
            if (this.beforeEndTime) {
                return moment(this.beforeEndTime).diff(moment(this.beforeStartTime), 'days') + 1;
            }
            return 0;
        },
        afterContractPeriods: function afterContractPeriods() {
            if (this.afterEndTime) {
                return moment(this.afterEndTime).diff(moment(this.afterStartTime), 'days') + 1;
            }
            return 0;
        },
        overallChangedText: function overallChangedText() {
            if (this.beforeContractPeriods && this.afterContractPeriods) {
                var changedVal = this.afterContractPeriods - this.beforeContractPeriods;
                return changedVal >= 0 ? '+' + changedVal + ' 天' : changedVal + ' 天';
            }
            return '-';
        }
    }, (0, _vuex.mapState)({
        mainContract: function mainContract(state) {
            return state.webadmin.crm.changedContract;
        }
    }))

};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal id=\"modalTime-contract\" open-size=\"modal-lg\" parallel-modal=\"\">\n    <h4 slot=\"title\">{{name}}</h4>\n    <form slot=\"body\" autocomplete=\"off\">\n        <div class=\"st-grid st-grid-cols-12 st-gap-y-5\">\n            <label class=\"st-col-span-12 md:st-col-span-2 st-text-left md:st-text-right st-font-bold st-mr-5\">有效期間</label>\n            <div class=\"st-col-span-12 md:st-col-span-10\">\n                <div class=\"st-grid st-grid-cols-1 md:st-grid-cols-3 st-gap-5\">\n                    <st-input label=\"目前方案開始日期\">\n                        <div class=\"st-pt-3\" slot=\"input\">{{ beforeStartTime }}</div>\n                    </st-input>\n                    <st-input label=\"目前方案結束日期\">\n                        <div class=\"st-pt-3\" slot=\"input\">{{ beforeEndTime || ' - ' }}</div>\n                    </st-input>\n                    <st-input label=\"目前方案有效期間\">\n                        <div class=\"st-pt-3\" slot=\"input\">{{ beforeContractPeriods ?  beforeContractPeriods+' 天':'無限'}}</div>\n                    </st-input>\n\n                    <hr class=\"md:st-col-span-3 st-border-gray-20 st-w-full st-m-0\">\n\n                    <div class=\"st-flex st-gap-2 st-items-end md:st-items-stretch lg:st-items-end st-flex-row md:st-flex-col lg:st-flex-row\">\n                        <st-input label=\"調整後方案開始日期\" :input-class=\"['st-min-w-28']\">\n                            <div slot=\"input\" slot-scope=\"{ inputClass }\">\n                                <v-date-picker v-model=\"afterStartTime\" :value=\"afterStartTime\" :input-class=\"inputClass\" :clearable=\"false\" @input=\"startTimeChange\"></v-date-picker>\n                            </div>\n                        </st-input>\n                        <st-input type=\"number\" v-model=\"startDaysDiff\" @input=\"startDaysChange\" :input-class=\"['st-w-16']\"></st-input>\n                    </div>\n                    <div class=\"st-flex st-gap-2 st-items-end md:st-items-stretch lg:st-items-end st-flex-row md:st-flex-col lg:st-flex-row\">\n                        <st-input label=\"調整後方案結束日期\" :input-class=\"['st-min-w-28']\">\n                            <div slot=\"input\" slot-scope=\"{ inputClass }\">\n                                <v-date-picker v-model=\"afterEndTime\" :value=\"afterEndTime\" :input-class=\"inputClass\" :clearable=\"true\" @input=\"endTimeChange\"></v-date-picker>\n                            </div>\n                        </st-input>\n                        <st-input type=\"number\" v-model=\"endDaysDiff\" @input=\"endDaysChange\" :input-class=\"['st-w-16']\" :disabled=\"!beforeEndTime\"></st-input>\n                    </div>\n                    <st-input label=\"調整後方案有效期間\">\n                        <div class=\"st-pt-3\" slot=\"input\">{{ afterContractPeriods ?  afterContractPeriods+' 天':'無限' }}</div>\n                    </st-input>\n\n                    <div class=\"st-bg-gray-20 md:st-col-span-3 st-px-4 st-py-2\">\n                        方案有效期間異動 : {{ overallChangedText }}\n                    </div>\n                </div>\n            </div>\n\n            <label class=\"st-col-span-12 md:st-col-span-2 st-text-left md:st-text-right st-font-bold st-mr-5\">原因</label>\n            <div class=\"st-col-span-12 md:st-col-span-10\">\n                <st-input type=\"text\" v-model=\"reason\"></st-input>\n            </div>\n        </div>\n    </form>\n    <div slot=\"footer\">\n        <div>\n            <input type=\"button\" class=\"btn btn-primary\" value=\"修改\" readonly=\"readonly\" @click=\"changeContractDate(memberContractId)\">\n        </div>\n    </div>\n</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-31bbefee", module.exports)
  } else {
    hotAPI.update("_v-31bbefee", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/object/assign":50,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vuex":803}],1096:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.tag[_v-22ad6c5e] {\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: 10px;\n  margin-left: 15px; }\n\n/* line 9, stdin */\n.btns[_v-22ad6c5e] {\n  margin-top: 10%; }\n\n/* line 13, stdin */\n.btn-primary[_v-22ad6c5e] {\n  padding-left: 2em;\n  padding-right: 2em;\n  background-color: #38b0e3;\n  position: absolute;\n  right: 1em;\n  border: 0; }\n\n/* line 22, stdin */\n#goToTag[_v-22ad6c5e] {\n  color: #fff;\n  background-color: white;\n  border-color: #38b0e3;\n  color: #38b0e3; }\n\n/* line 29, stdin */\n#title[_v-22ad6c5e] {\n  color: #a4a9ad; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        memberId: {}
    },
    data: function data() {
        return {
            tags: [],
            checkedOrNot: [],
            updateBtn: '儲存更新',
            status: '',
            startAjax: false,
            text: ''
        };
    },
    created: function created() {
        var _this = this;

        window.Event.$on('editTag', function () {
            _this.editTagModal();
        });
    },
    destroyed: function destroyed() {
        window.Event.$off('editTag');
    },

    methods: {
        editTagModal: function editTagModal() {
            $('#editTagModal').modal('show');
            this.getTagList();
            this.getMemberTagList();
        },
        updateTags: function updateTags() {
            this.$http.post('/adminapi/member-tag/' + this.memberId, {
                tagId: this.checkedOrNot
            }).then(function (response) {
                this.getMemberTagList();
                window.Event.$emit('updateProfileTag', this.memberId);
                $('#editTagModal').modal('hide');
            }, function (response) {});
        },
        getTagList: function getTagList() {
            this.startAjax = true;
            this.text = '';
            this.$http.get('/adminapi/tag/index').then(function (response) {
                this.tags = response.body.columns;
                this.startAjax = false;
                if (this.tags.length == 0) {
                    this.text = '目前無標籤';
                }
            }, function (response) {});
        },
        getMemberTagList: function getMemberTagList() {
            this.startAjax = true;
            this.$http.get('/adminapi/member-tag/' + this.memberId).then(function (response) {
                this.startAjax = false;
                this.checkedOrNot = $.map(response.body, function (val, i) {
                    return val.tag_id;
                });
            }, function (response) {});
        }
    },
    watch: {
        checkedOrNot: function checkedOrNot(val) {
            this.checkedOrNot = val;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<!--編輯標籤-->\n<v-modal id=\"editTagModal\" no-footer=\"\" parallel-modal=\"\" _v-22ad6c5e=\"\">\n    <h4 slot=\"title\" id=\"title\" _v-22ad6c5e=\"\">套用標籤</h4>\n    <form slot=\"body\" _v-22ad6c5e=\"\">\n        <v-spinner :ajaxing=\"startAjax\" _v-22ad6c5e=\"\">\n        </v-spinner>\n        <h3 v-show=\"!startAjax\" _v-22ad6c5e=\"\">{{text}}</h3>\n        <div id=\"checkboxArea\" v-for=\"tag in tags\" v-show=\"!startAjax\" :key=\"tag.id\" _v-22ad6c5e=\"\">\n            <input name=\"tagList\" v-model=\"checkedOrNot\" type=\"checkbox\" :id=\"'tag'+tag.id\" :value=\"tag.id\" _v-22ad6c5e=\"\">\n            <label :for=\"'tag'+tag.id\" _v-22ad6c5e=\"\">{{tag.name}}</label>\n        </div>\n        <div class=\"btns\" _v-22ad6c5e=\"\">\n            <a href=\"/webadmin/tag\" class=\"btn btn-default\" id=\"goToTag\" _v-22ad6c5e=\"\">管理標籤</a>\n            <button type=\"button\" class=\"btn btn-primary\" v-on:click=\"updateTags\" _v-22ad6c5e=\"\">儲存更新</button>\n        </div>\n    </form>\n</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.tag[_v-22ad6c5e] {\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: 10px;\n  margin-left: 15px; }\n\n/* line 9, stdin */\n.btns[_v-22ad6c5e] {\n  margin-top: 10%; }\n\n/* line 13, stdin */\n.btn-primary[_v-22ad6c5e] {\n  padding-left: 2em;\n  padding-right: 2em;\n  background-color: #38b0e3;\n  position: absolute;\n  right: 1em;\n  border: 0; }\n\n/* line 22, stdin */\n#goToTag[_v-22ad6c5e] {\n  color: #fff;\n  background-color: white;\n  border-color: #38b0e3;\n  color: #38b0e3; }\n\n/* line 29, stdin */\n#title[_v-22ad6c5e] {\n  color: #a4a9ad; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-22ad6c5e", module.exports)
  } else {
    hotAPI.update("_v-22ad6c5e", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1097:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n\t.timing[_v-cfad876c] {\n\t    padding: 3px;\n\t    border: 1px solid;\n\t    background: #eee;\n\t}\n\t.btn-submit-admission[_v-cfad876c] {\n    \tmargin-top: 15px;\n\t}\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	props: ['memberId'],
	data: function data() {
		return {
			nowTimer: moment().format('YYYY-MM-DD HH:mm:ss')
		};
	},
	created: function created() {
		setInterval(this.refreshNowTimer, 500);
	},

	watch: {
		'record.now': function recordNow(newVal) {
			if (newVal) {
				this.nowTimer = moment(this.record.now).format('YYYY-MM-DD HH:mm:ss');
			}
		}
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
		contractTypes: function contractTypes(state) {
			return state.webadmin.admission.contractTypes;
		},
		member: function member(state) {
			return state.webadmin.crm.member;
		},
		memberStatusAdmission: function memberStatusAdmission(state) {
			return state.webadmin.crm.memberStatus.hasOwnProperty('admission') ? state.webadmin.crm.memberStatus.admission : 1;
		},
		contracts: function contracts(state) {
			return state.webadmin.admission.memberContracts;
		},
		errorData: function errorData(state) {
			return state.webadmin.admission.errorData;
		},
		record: function record(state) {
			return state.webadmin.admission.unLeavedRecord;
		}
	}), {
		remainingValue: function remainingValue() {
			return this.selectedContract && this.selectedContract.unused ? this.selectedContract.unused : '';
		},
		remainingUnit: function remainingUnit() {
			return this.selectedContract && this.selectedContract.type_unit ? this.selectedContract.type_unit : '';
		},
		admissionSetting: function admissionSetting() {
			return this.selectedContract && this.selectedContract.admission ? this.selectedContract.admission.name : '';
		},

		selectedContract: {
			get: function get() {
				return this.$store.state.webadmin.admission.selectedMemberContract;
			},
			set: function set(v) {
				if (!v) return;
				this.$store.commit('webadmin/admission/SET_SELECTED_MEMBER_CONTRACT', v);
				this.$store.commit('webadmin/admission/UPDATE_SETTING_INFO', v.admission);
			}
		}
	}),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('webadmin/admission', ['showAdmissionInfo']), {
		refreshNowTimer: function refreshNowTimer() {
			this.nowTimer = moment(this.nowTimer).add(1, 's').format('YYYY-MM-DD HH:mm:ss');
		},
		submit: function submit(e) {
			var _this = this;

			return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								$(e.target).prop('disabled', true);
								_context.next = 3;
								return _this.$store.dispatch('webadmin/admission/createEnterRecord', {
									id: _this.memberId,
									data: {
										member_contract_id: _this.selectedContract.id
									}
								}).then(function (o) {
									_this.$store.dispatch('webadmin/admission/alertEnterSuccess');
									window.Event.$emit('fetchMemberContract', _this.memberId);
									$('#enter-admission-modal').modal('hide');
								}).catch(function (o) {
									_this.$store.dispatch('webadmin/admission/admissionErrorAlert', o);
								});

							case 3:
								$(e.target).prop('disabled', false);

							case 4:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		}
	})
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n\t<v-modal id=\"enter-admission-modal\" no-footer=\"\" no-border-radius=\"\" parallel-modal=\"\" _v-cfad876c=\"\">\n\t\t<template slot=\"title\">入場</template>\n\t\t<template slot=\"body\">\n            <v-member-info :picture=\"member.picture_path\" :name=\"member.name\" :phone=\"member.phone\" :email=\"member.email\" _v-cfad876c=\"\">\n            </v-member-info>\n            <hr class=\"normal\" _v-cfad876c=\"\">\n\t\t\t<form class=\"form-horizontal\" _v-cfad876c=\"\">\n\t\t\t\t<div class=\"row\" _v-cfad876c=\"\">\n\t\t\t\t\t<label class=\"control-label col-sm-3\" _v-cfad876c=\"\">使用方案</label>\n\t\t\t\t\t<div class=\"col-sm-7\" _v-cfad876c=\"\">\n\t\t\t\t\t\t<select class=\"form-control\" v-model=\"selectedContract\" _v-cfad876c=\"\">\n\t\t\t\t\t\t\t<option v-for=\"c in contracts\" :value=\"c\" _v-cfad876c=\"\">\n\t\t\t\t\t\t\t{{ c.name }}\n\t\t\t\t\t\t\t</option>\n\t\t\t\t\t\t</select>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"row\" _v-cfad876c=\"\">\n\t\t\t\t\t<label class=\"control-label col-sm-3\" _v-cfad876c=\"\">入場設定</label>\n\t\t\t\t\t<p class=\"form-control-static col-sm-9\" _v-cfad876c=\"\">{{ admissionSetting }} <a @click.prevent=\"showAdmissionInfo\" _v-cfad876c=\"\"><i class=\"fa fa-question-circle\" _v-cfad876c=\"\"></i></a></p>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"row\" _v-cfad876c=\"\">\n\t\t\t\t\t<label class=\"control-label col-sm-3\" _v-cfad876c=\"\">剩餘</label>\n\t\t\t\t\t<p class=\"form-control-static col-sm-9\" _v-cfad876c=\"\">{{ remainingValue }} {{ remainingUnit }}</p>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"row\" _v-cfad876c=\"\">\n\t\t\t\t\t<label class=\"control-label col-sm-3\" _v-cfad876c=\"\">入場時間</label>\n\t\t\t\t\t<p class=\"form-control-static col-sm-9\" _v-cfad876c=\"\"><span class=\"timing\" _v-cfad876c=\"\">{{ nowTimer }}</span></p>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"row\" v-show=\"memberStatusAdmission===0\" _v-cfad876c=\"\">\n\t\t\t\t\t<label class=\"control-label col-sm-3\" _v-cfad876c=\"\"></label>\n\t\t\t\t\t<div class=\"form-control-static col-sm-9\" _v-cfad876c=\"\"><label class=\"color-danger\" _v-cfad876c=\"\"><i class=\"fa fa-warning p-right-5\" _v-cfad876c=\"\"></i> 此客戶目前被停止自助入場</label></div>\n\t\t\t\t</div>\n\t\t\t\t<button type=\"button\" class=\"btn btn-primary btn-lg btn-block btn-submit-admission\" @click.prevent=\"submit\" _v-cfad876c=\"\">入場</button>\n\t\t\t</form>\n\t\t</template>\n\t</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n\t.timing[_v-cfad876c] {\n\t    padding: 3px;\n\t    border: 1px solid;\n\t    background: #eee;\n\t}\n\t.btn-submit-admission[_v-cfad876c] {\n    \tmargin-top: 15px;\n\t}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-cfad876c", module.exports)
  } else {
    hotAPI.update("_v-cfad876c", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1098:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _servant = require('./servant.vue');

var _servant2 = _interopRequireDefault(_servant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('servant-card', _servant2.default);

},{"./servant.vue":1107,"vue":792}],1099:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n#crm .modal-body {\n  padding-top: 0px; }\n\n/* line 5, stdin */\n.profile {\n  margin-top: -20px; }\n\n/* line 3, stdin */\n#modal-title[_v-0a816048] {\n  display: inline; }\n\n/* line 7, stdin */\n.modal[_v-0a816048] {\n  overflow-x: hidden;\n  overflow-y: auto; }\n\n/* line 12, stdin */\n.tabs[_v-0a816048] {\n  margin-bottom: 20px; }\n\n/* line 19, stdin */\n.col-sm-2[_v-0a816048] {\n  background: #EEE; }\n\n/* line 23, stdin */\n.no-float[_v-0a816048] {\n  display: table-cell;\n  float: none; }\n\n/* line 28, stdin */\nspan.glyphicon-user[_v-0a816048] {\n  font-size: 1.5em; }\n\n@media (max-width: 990px) {\n  /* line 33, stdin */\n  .no-float[_v-0a816048] {\n    display: block; } }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['memberId', 'studioId'],
    data: function data() {
        return {
            currentView: 'crm-home-main',
            modalSize: 'modal-lg',
            showModal: false,
            keepAlivePage: ['member-dashboard']
        };
    },

    methods: {
        isActive: function isActive(name) {
            return this.currentView == name ? 'active' : '';
        },
        tabClick: function tabClick(name) {
            this.currentView = name;
        },
        storeProfileSuccess: function storeProfileSuccess() {
            location.reload();
        },
        resetFields: function resetFields() {
            (0, _assign2.default)(this.$data, this.$options.data());
        },
        resetData: function resetData() {
            this.$store.commit('webadmin/crm/CRM_RESET');
        },
        createOrder: function createOrder() {
            this.$store.dispatch('pos/openOrCreateOrder', { 'successCallBack': this.initModal });
        },
        initModal: function initModal() {
            this.$store.dispatch('filters/getMember', this.memberId);
            this.$store.dispatch('pos/changeOrderValue', { 'member_id': this.memberId });
            this.$store.dispatch('pos/changeOrderValue', { 'branch_id': this.selectBranchId });
            $('#order-edit').modal('show');
        },

        billSuccessCallBack: function billSuccessCallBack(response) {
            this.$store.dispatch('pos/resetSelectOrder', { 'callback': this.successCallBackFunction });
            this.$store.dispatch('webadmin/crm/fetchMemberContract', this.memberId);
            window.Event.$emit('fetch-member-history-orders');
        },
        successCallBackFunction: function successCallBackFunction(response) {
            var vm = this;
            $('#order-edit').modal('hide');
            $('#multi-alert-modal').modal('show');
        },
        billFailCallBack: function billFailCallBack(response) {
            $('#order-edit').modal('hide');
            $('#multi-alert-modal').modal('show');
        },

        refundFailCallBack: function refundFailCallBack(response) {
            $('#order-refund').modal('hide');
            $('#multi-alert-modal').modal('show');
        },
        refundSuccessCallBack: function refundSuccessCallBack(response) {
            $('#order-refund').modal('hide');
            $('#multi-alert-modal').modal('show');
            window.Event.$emit('fetch-member-history-orders');
        },
        refundCancelCallBack: function refundCancelCallBack(response) {
            $('#order-refund').modal('hide');
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        canReadAutoPayPlan: function canReadAutoPayPlan(state) {
            return state.webadmin.configure.webFunctions.WebadminAutoPayPlanIndex;
        },
        updateMemberRight: function updateMemberRight(state) {
            return state.webadmin.configure.webFunctions.WebadminMemberStudioUpdate;
        },
        infoRecordEditViewSelf: function infoRecordEditViewSelf(state) {
            return state.webadmin.configure.webFunctions.WebadminInfoRecordEditViewSelf;
        },
        infoRecordViewAll: function infoRecordViewAll(state) {
            return state.webadmin.configure.webFunctions.WebadminInfoRecordViewAll;
        },
        canReadPayOrder: function canReadPayOrder(state) {
            return state.webadmin.configure.webFunctions.WebadminPosPayList;
        },
        canReadUnpayOrder: function canReadUnpayOrder(state) {
            return state.webadmin.configure.webFunctions.WebadminPosUnpayList;
        },
        webadminMemberDashboard: function webadminMemberDashboard(state) {
            return state.webadmin.configure.webFunctions.WebadminMemberDashboard;
        },
        customer: function customer(state) {
            return state.webadmin.crm.member;
        },
        selectBranchId: function selectBranchId(state) {
            return state.pos.select_branch_id;
        }
    }), {
        select_order_id: function select_order_id() {
            return store.state.pos.order_id;
        },
        alert_obj: function alert_obj() {
            return store.state.pos.alert_obj;
        }
    }),
    created: function created() {
        var _this = this;

        window.Event.$on('resetData', function () {
            _this.resetFields();
        });
        window.Event.$on('changeCurrentView', function () {
            _this.currentView = 'crm-home-main';
        });
        window.Event.$on('createOrder', function () {
            _this.createOrder();
        });
    },
    mounted: function mounted() {
        var _this2 = this;

        $("#crm").on('shown.bs.modal', function () {
            _this2.showModal = true;
        });
        $("#crm").on('hidden.bs.modal', function () {
            _this2.showModal = false;
        });
    },
    destroyed: function destroyed() {
        window.Event.$off('resetData');
        window.Event.$off('changeCurrentView');
        window.Event.$off('createOrder');
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-0a816048=\"\">\n\t<v-modal id=\"crm\" no-footer=\"\" parallel-modal=\"\" :open-size=\"modalSize\" :close-modal-event=\"resetData\" class=\"modal\" _v-0a816048=\"\">\n        <div slot=\"title\" class=\"header\" _v-0a816048=\"\">\n            <span class=\"glyphicon glyphicon-user\" _v-0a816048=\"\"></span>\n            <h3 id=\"modal-title\" _v-0a816048=\"\">客戶資料</h3>\n        </div>\n\n        <div slot=\"body\" _v-0a816048=\"\">\n\t\t\t<div class=\"row\" _v-0a816048=\"\">\n\t\t\t\t<div class=\"col-sm-10 no-float\" _v-0a816048=\"\">\n\t\t\t\t\t<profile :member-id=\"memberId\" _v-0a816048=\"\">\n\t\t\t\t\t</profile>\n\n\t\t\t\t\t<div class=\"tabs\" _v-0a816048=\"\">\n\t\t\t\t\t\t<ul class=\"nav nav-tabs nav-justified\" _v-0a816048=\"\">\n\t\t\t\t\t\t\t<li @click.prevent=\"tabClick('crm-home-main')\" :class=\"isActive('crm-home-main')\" _v-0a816048=\"\">\n\t\t\t\t\t\t\t\t<a _v-0a816048=\"\">主頁</a>\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t<li v-if=\"updateMemberRight\" @click.prevent=\"tabClick('v-customer-profile')\" :class=\"isActive('v-customer-profile')\" _v-0a816048=\"\">\n\t\t\t\t\t\t\t\t<a _v-0a816048=\"\">個人資料</a>\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t<li v-if=\"canReadAutoPayPlan\" @click.prevent=\"tabClick('auto-pay-plan-list')\" :class=\"isActive('auto-pay-plan-list')\" _v-0a816048=\"\">\n\t\t\t\t\t\t\t\t<a _v-0a816048=\"\">自動支付</a>\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t<li @click.prevent=\"tabClick('member-bonus-info')\" :class=\"isActive('member-bonus-info')\" _v-0a816048=\"\">\n\t\t\t\t\t\t\t\t<a _v-0a816048=\"\">紅利積點</a>\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t<li v-if=\"infoRecordEditViewSelf||infoRecordViewAll\" @click.prevent=\"tabClick('info-record-list')\" :class=\"isActive('info-record-list')\" _v-0a816048=\"\">\n\t\t\t\t\t\t\t\t<a _v-0a816048=\"\">紀錄及文件</a>\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t<li v-if=\"canReadPayOrder || canReadUnpayOrder\" @click.prevent=\"tabClick('member-history-order')\" :class=\"isActive('member-history-order')\" _v-0a816048=\"\">\n\t\t\t\t\t\t\t\t<a _v-0a816048=\"\">訂單</a>\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t<li @click.prevent=\"tabClick('member-booking-list')\" :class=\"isActive('member-booking-list')\" _v-0a816048=\"\">\n\t\t\t\t\t\t\t\t<a _v-0a816048=\"\">預約</a>\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t<li v-if=\"webadminMemberDashboard\" @click.prevent=\"tabClick('member-dashboard')\" :class=\"isActive('member-dashboard')\" _v-0a816048=\"\">\n\t\t\t\t\t\t\t\t<a _v-0a816048=\"\">分析指標</a>\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t</ul>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div id=\"pressTabChangeArea\" v-if=\"showModal\" _v-0a816048=\"\">\n\t\t\t\t\t\t<keep-alive :include=\"keepAlivePage\" _v-0a816048=\"\">\n\t\t\t\t\t\t\t<component :is=\"currentView\" :member-id=\"memberId\" :studio-id=\"studioId\" :store-success-callback=\"storeProfileSuccess\" mode=\"edit\" _v-0a816048=\"\">\n\t\t\t\t\t\t\t</component>\n\t\t\t\t\t\t</keep-alive>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-sm-2 no-float\" _v-0a816048=\"\">\n\t\t\t\t\t<right-sidebar :member=\"memberId\" _v-0a816048=\"\">\n\t\t\t\t\t</right-sidebar>\n\t\t\t\t</div>\n\t\t\t</div>\n        </div>\n        <crm-home-main _v-0a816048=\"\">\n        </crm-home-main>\n    </v-modal>\n    <contract-edit :member-id=\"memberId\" _v-0a816048=\"\"></contract-edit>\n    <contract-time-edit :member-id=\"memberId\" _v-0a816048=\"\"></contract-time-edit>\n    <contract-point-edit :member-id=\"memberId\" _v-0a816048=\"\"></contract-point-edit>\n    <contract-status-edit :member-id=\"memberId\" _v-0a816048=\"\"></contract-status-edit>\n\t<member-status-edit :member-id=\"memberId\" _v-0a816048=\"\">\n\t</member-status-edit>\n\n    <v-enter-admission-modal :member-id=\"memberId\" _v-0a816048=\"\"></v-enter-admission-modal>\n    <v-out-admission-modal :member-id=\"memberId\" _v-0a816048=\"\"></v-out-admission-modal>\n    <admission-info-modal _v-0a816048=\"\"></admission-info-modal>\n\n    <edit-tag :member-id=\"memberId\" _v-0a816048=\"\"></edit-tag>\n   \t<v-shared-contract :studio-id=\"studioId\" _v-0a816048=\"\"></v-shared-contract>\n\t<webadmin-operate-modal ref=\"operate\" :enable-change-member=\"false\" event-scope=\"webadmin\" _v-0a816048=\"\">\n\t\t<template slot=\"event\">\n\t\t\t<template slot=\"event\">\n\t\t\t\t<webadmin-order-operate-event-slot-utility event-scope=\"webadmin\" :operate-ref=\"$refs.operate\" _v-0a816048=\"\"></webadmin-order-operate-event-slot-utility>\n\t\t\t</template>\n\t\t</template>\n\t</webadmin-operate-modal>\n\t<v-multi-alert-model :model-title=\"'訂單 '+select_order_id\" :alert-obj=\"alert_obj\" _v-0a816048=\"\">\n    </v-multi-alert-model>\n\t<add-member-credit-modal :member-id=\"memberId\" _v-0a816048=\"\">\n\t</add-member-credit-modal>\n\t<auto-pay-plan-create-modal :member-id=\"memberId\" :studio-id=\"studioId\" _v-0a816048=\"\">\n\t</auto-pay-plan-create-modal>\n\t<auto-pay-plan-preview-modal :member-id=\"memberId\" _v-0a816048=\"\">\n\t</auto-pay-plan-preview-modal>\n\t<auto-pay-plan-view-modal :member-id=\"memberId\" _v-0a816048=\"\">\n\t</auto-pay-plan-view-modal>\n\t<auto-pay-plan-template-modal :member-id=\"memberId\" :studio-id=\"studioId\" _v-0a816048=\"\">\n\t</auto-pay-plan-template-modal>\n\t<member-bonus-create-modal :member-id=\"memberId\" :studio-id=\"studioId\" _v-0a816048=\"\">\n\t</member-bonus-create-modal>\n\t<member-bonus-records-modal :member-id=\"memberId\" :studio-id=\"studioId\" _v-0a816048=\"\">\n\t</member-bonus-records-modal>\n\t<info-record-create-modal :member-id=\"memberId\" :studio-id=\"studioId\" _v-0a816048=\"\"></info-record-create-modal>\n\t<info-record-edit-modal :member-id=\"memberId\" :studio-id=\"studioId\" _v-0a816048=\"\"></info-record-edit-modal>\n\t<v-image-full-view _v-0a816048=\"\"></v-image-full-view>\n\t<auto-pay-plan-edit-modal :member-id=\"memberId\" :studio-id=\"studioId\" _v-0a816048=\"\">\n\t</auto-pay-plan-edit-modal>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n#crm .modal-body {\n  padding-top: 0px; }\n\n/* line 5, stdin */\n.profile {\n  margin-top: -20px; }\n\n/* line 3, stdin */\n#modal-title[_v-0a816048] {\n  display: inline; }\n\n/* line 7, stdin */\n.modal[_v-0a816048] {\n  overflow-x: hidden;\n  overflow-y: auto; }\n\n/* line 12, stdin */\n.tabs[_v-0a816048] {\n  margin-bottom: 20px; }\n\n/* line 19, stdin */\n.col-sm-2[_v-0a816048] {\n  background: #EEE; }\n\n/* line 23, stdin */\n.no-float[_v-0a816048] {\n  display: table-cell;\n  float: none; }\n\n/* line 28, stdin */\nspan.glyphicon-user[_v-0a816048] {\n  font-size: 1.5em; }\n\n@media (max-width: 990px) {\n  /* line 33, stdin */\n  .no-float[_v-0a816048] {\n    display: block; } }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-0a816048", module.exports)
  } else {
    hotAPI.update("_v-0a816048", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/object/assign":50,"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1100:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.header[_v-646bc233] {\n  padding: 11px; }\n  /* line 4, stdin */\n  .header h5[_v-646bc233] {\n    margin-top: 0;\n    margin-bottom: 0; }\n\n/* line 9, stdin */\n.card-footer[_v-646bc233] {\n  cursor: pointer;\n  text-align: center;\n  padding: 10px;\n  font-size: 14px;\n  color: #8a8a8a; }\n\n/* line 17, stdin */\ntextarea[_v-646bc233] {\n  border: none;\n  margin-bottom: 0; }\n\n/* line 21, stdin */\n.title[_v-646bc233] {\n  border-bottom: solid;\n  border-bottom-width: medium;\n  border-bottom-color: #e6e6e6;\n  display: block;\n  width: auto;\n  margin-bottom: 10px; }\n\n/* line 30, stdin */\n.header[_v-646bc233] {\n  padding: 11px; }\n  /* line 32, stdin */\n  .header h5[_v-646bc233] {\n    margin-top: 0;\n    margin-bottom: 0; }\n\n/* line 37, stdin */\n.card-footer[_v-646bc233] {\n  cursor: pointer;\n  text-align: center;\n  padding: 5px;\n  height: 30px;\n  font-size: 14px;\n  color: #8a8a8a; }\n\n/* line 46, stdin */\ntextarea[_v-646bc233] {\n  border: none;\n  margin-bottom: 0; }\n\n/* line 51, stdin */\n.show-effective[_v-646bc233] {\n  cursor: pointer;\n  color: #878787; }\n\n/* line 56, stdin */\nh5[_v-646bc233] {\n  font-size: 16px;\n  font-weight: bold; }\n\n/* line 61, stdin */\n.status-title[_v-646bc233] {\n  margin-bottom: 0; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _contentCard = require('../content-card.vue');

var _contentCard2 = _interopRequireDefault(_contentCard);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: { contentCard: _contentCard2.default },
    props: ['memberId', 'studioId'],
    data: function data() {
        return {
            showEffective: false,
            upcomingBooking: {
                footer: false,
                isShowMore: false
            },
            validPlan: {
                footer: false,
                isShowMore: false
            },
            memberTerms: {
                footer: false,
                isShowMore: false
            },
            remarkIsEditMode: false
        };
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        contractRemark: function contractRemark(state) {
            return state.webadmin.crm.member.contract_remark;
        }
    }), {
        getMemberId: function getMemberId() {
            return this.memberId;
        }
    }, (0, _vuex.mapState)({
        ReadMemberApprovalTerm: function ReadMemberApprovalTerm(state) {
            return state.webadmin.configure.webFunctions.WebadminMemberApprovalTermRead;
        }
    })),
    mounted: function mounted() {
        if (!this.memberId) return;
        this.$store.dispatch('webadmin/crm/fetchMemberContract', this.memberId);
        window.Event.$emit('fetchUpcoming', this.memberId);
        window.Event.$emit('fetchMemberStatus', this.memberId);
        window.Event.$emit('fetchMemberTerms', this.memberId);
    },

    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('webadmin/crm', ['getMember']), {
        changeShowEffective: function changeShowEffective() {
            this.showEffective = !this.showEffective;
        },
        saveClicked: function () {
            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                var _this = this;

                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.$http.post('/adminapi/member/' + this.memberId + '/remark/contract', { 'comment': this.contractRemark }).then(function (response) {
                                    _this.resetClicked();
                                    return true;
                                }, function (response) {
                                    $17.swal({
                                        title: '更新失敗',
                                        type: 'error',
                                        showCancelButton: false,
                                        showLoaderOnConfirm: true
                                    });
                                    return false;
                                });

                            case 2:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function saveClicked() {
                return _ref.apply(this, arguments);
            }

            return saveClicked;
        }(),
        resetClicked: function resetClicked() {
            this.getMember({ memberId: this.memberId });
        },
        changeText: function changeText(newConment) {
            this.$store.commit('webadmin/crm/CRM_CHANGE_COMMENT', newConment);
        },
        bindRemarkMode: function bindRemarkMode(value) {
            this.remarkIsEditMode = value;
        },
        isShowUpcomingBookingFooter: function isShowUpcomingBookingFooter(e) {
            this.upcomingBooking.footer = e;
        },
        isShowValidPlanFooter: function isShowValidPlanFooter(e) {
            this.validPlan.footer = e;
        },
        moreUpcomingBooking: function moreUpcomingBooking() {
            this.upcomingBooking.isShowMore = !this.upcomingBooking.isShowMore;
            window.Event.$emit('fetchShowMore', this.upcomingBooking.isShowMore);
        },
        moreValidPlan: function moreValidPlan() {
            this.validPlan.isShowMore = !this.validPlan.isShowMore;
            window.Event.$emit('fetchValidPlanShowMore', this.validPlan.isShowMore);
        },
        isShowMemberTermsFooter: function isShowMemberTermsFooter(e) {
            this.memberTerms.footer = e;
        },
        moreMemberTerms: function moreMemberTerms() {
            this.memberTerms.isShowMore = !this.memberTerms.isShowMore;
            window.Event.$emit('fetchTermsShowMore', this.memberTerms.isShowMore);
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-646bc233=\"\">\n    <content-card :show-footer=\"upcomingBooking.footer\" _v-646bc233=\"\">\n        <div slot=\"head\" _v-646bc233=\"\">\n            <div class=\"header\" _v-646bc233=\"\">\n                <h5 _v-646bc233=\"\">尚未開始的預約</h5>\n            </div>\n        </div>\n        <div slot=\"body\" _v-646bc233=\"\">\n            <upcoming-booking :member-id=\"getMemberId\" :is-show-more=\"isShowUpcomingBookingFooter\" _v-646bc233=\"\"></upcoming-booking>                \n        </div>\n        <div slot=\"footer\" _v-646bc233=\"\">\n            <div class=\"card-footer\" @click.prevent=\"moreUpcomingBooking\" _v-646bc233=\"\">{{ upcomingBooking.isShowMore ? '收合' : '展開顯示更多' }}</div>\n        </div>\n    </content-card>\n\n    <content-card :show-footer=\"validPlan.footer\" _v-646bc233=\"\">\n        <div slot=\"head\" _v-646bc233=\"\">\n            <div class=\"header row\" _v-646bc233=\"\">\n                <div class=\"col-xs-6 text-left\" _v-646bc233=\"\">\n                    <h5 _v-646bc233=\"\">擁有方案</h5>\n                </div>\n                <div class=\"col-xs-6 text-right show-effective\" _v-646bc233=\"\">\n                    <span @click=\"changeShowEffective\" _v-646bc233=\"\">\n                        <input type=\"checkbox\" :checked=\"showEffective\" _v-646bc233=\"\"> 顯示過期及無效\n                    </span>\n                </div>\n            </div>\n        </div>\n        <div slot=\"body\" _v-646bc233=\"\">\n            <valid-plan :member-id=\"getMemberId\" :show-effective=\"showEffective\" :is-show-more=\"isShowValidPlanFooter\" _v-646bc233=\"\"></valid-plan>             \n        </div>\n        <div slot=\"footer\" _v-646bc233=\"\">\n            <div class=\"card-footer\" @click.prevent=\"moreValidPlan\" _v-646bc233=\"\">{{ validPlan.isShowMore ? '收合' : '展開顯示更多' }}</div>\n        </div>\n    </content-card>\n\n    <content-card :show-footer=\"false\" :card-class=\" !remarkIsEditMode?'m-bottom-15':'m-bottom-50' \" _v-646bc233=\"\">\n        <div slot=\"head\" _v-646bc233=\"\">\n            <div class=\"header\" _v-646bc233=\"\">\n                <h5 _v-646bc233=\"\">備註</h5>\n            </div>\n        </div>\n        <div slot=\"body\" _v-646bc233=\"\">\n            <v-singel-ajax-textarea :textarea-style=\"{ 'border': 'none', 'margin-bottom': '0' }\" :edit-btn-style=\"{ 'position': 'absolute', 'right': '20px', 'margin-top': '8px' }\" :current-text=\"contractRemark\" :save-clicked=\"saveClicked\" :reset-clicked=\"resetClicked\" :change-text=\"changeText\" :is-edit-mode=\"bindRemarkMode\" _v-646bc233=\"\"></v-singel-ajax-textarea>\n        </div>\n    </content-card>\n\n    <content-card :show-footer=\"false\" _v-646bc233=\"\">\n        <div slot=\"head\" _v-646bc233=\"\">\n            <div class=\"header\" _v-646bc233=\"\">\n                <h5 _v-646bc233=\"\">狀態</h5>\n            </div>\n        </div>\n        <div slot=\"body\" _v-646bc233=\"\">\n            <member-statuses :member-id=\"memberId\" _v-646bc233=\"\"></member-statuses>\n        </div>\n    </content-card>\n\n    <content-card v-if=\"ReadMemberApprovalTerm\" :show-footer=\"memberTerms.footer\" _v-646bc233=\"\">\n        <div slot=\"head\" _v-646bc233=\"\">\n            <div class=\"header\" _v-646bc233=\"\">\n                <h5 _v-646bc233=\"\">已同意條款</h5>\n            </div>\n        </div>\n        <div slot=\"body\" _v-646bc233=\"\">\n            <member-terms :member-id=\"getMemberId\" :is-show-more=\"isShowMemberTermsFooter\" _v-646bc233=\"\"></member-terms>                \n        </div>\n        <div slot=\"footer\" _v-646bc233=\"\">\n            <div class=\"card-footer \" @click.prevent=\"moreMemberTerms\" _v-646bc233=\"\">{{ memberTerms.isShowMore ? '收合' : '展開顯示更多' }}\n            </div>\n        </div>\n    </content-card>\n\n    <servant-card :member-id=\"memberId\" _v-646bc233=\"\"></servant-card>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.header[_v-646bc233] {\n  padding: 11px; }\n  /* line 4, stdin */\n  .header h5[_v-646bc233] {\n    margin-top: 0;\n    margin-bottom: 0; }\n\n/* line 9, stdin */\n.card-footer[_v-646bc233] {\n  cursor: pointer;\n  text-align: center;\n  padding: 10px;\n  font-size: 14px;\n  color: #8a8a8a; }\n\n/* line 17, stdin */\ntextarea[_v-646bc233] {\n  border: none;\n  margin-bottom: 0; }\n\n/* line 21, stdin */\n.title[_v-646bc233] {\n  border-bottom: solid;\n  border-bottom-width: medium;\n  border-bottom-color: #e6e6e6;\n  display: block;\n  width: auto;\n  margin-bottom: 10px; }\n\n/* line 30, stdin */\n.header[_v-646bc233] {\n  padding: 11px; }\n  /* line 32, stdin */\n  .header h5[_v-646bc233] {\n    margin-top: 0;\n    margin-bottom: 0; }\n\n/* line 37, stdin */\n.card-footer[_v-646bc233] {\n  cursor: pointer;\n  text-align: center;\n  padding: 5px;\n  height: 30px;\n  font-size: 14px;\n  color: #8a8a8a; }\n\n/* line 46, stdin */\ntextarea[_v-646bc233] {\n  border: none;\n  margin-bottom: 0; }\n\n/* line 51, stdin */\n.show-effective[_v-646bc233] {\n  cursor: pointer;\n  color: #878787; }\n\n/* line 56, stdin */\nh5[_v-646bc233] {\n  font-size: 16px;\n  font-weight: bold; }\n\n/* line 61, stdin */\n.status-title[_v-646bc233] {\n  margin-bottom: 0; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-646bc233", module.exports)
  } else {
    hotAPI.update("_v-646bc233", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"../content-card.vue":1082,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1101:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.member-status-caledar {\n  margin-left: 150px; }\n\n/* line 5, stdin */\n.member-status-caledar-input {\n  max-width: 150px;\n  padding: 7px 10px; }\n\n/* line 2, stdin */\n.vdp-datepicker[_v-069960cc] {\n  position: inherit; }\n\n/* line 5, stdin */\n.date[_v-069960cc] {\n  width: 150px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vuex = require('vuex');

exports.default = {
    props: ['memberId'],
    data: function data() {
        return {
            title: '線上預約',
            memberStatus: {},
            postData: {
                type: 'online_booking',
                status: 1,
                allow_date: '',
                stop_date: '',
                auto_allow: 0,
                auto_stop: 0
            }
        };
    },
    watch: {
        'postData': {
            handler: function handler(newVal) {
                var currentDate = moment().locale('zh-tw').format('YYYY-MM-DD');
                if (newVal.auto_stop == 1 && newVal.stop_date == '') {
                    this.postData.stop_date = currentDate;
                };
                if (newVal.auto_allow == 1 && newVal.allow_date == '') {
                    this.postData.allow_date = currentDate;
                };
            },
            deep: true
        }
    },
    created: function created() {
        var _this = this;

        this.postData = {
            type: 'online_booking',
            status: 1,
            allow_date: '',
            stop_date: '',
            auto_allow: 0,
            auto_stop: 0
        };
        this.$root.$on('openStatusModal', function (payload) {
            _this.initData(payload);
            $('#member-status-modal').modal('show');
        });
    },
    mounted: function mounted() {},

    methods: {
        updateStatus: function updateStatus() {
            var _this2 = this;

            var today = moment().format('YYYY-MM-DD');
            if (this.postData.auto_allow == 1 && (this.postData.allow_date === '' || moment(this.postData.allow_date).isSameOrBefore(today))) {
                this.alert('自動允許日期', '需大於今天', 'warning');
                return false;
            } else if (this.postData.auto_allow == 0) {
                this.postData.allow_date = '';
            }
            if (this.postData.auto_stop == 1 && (this.postData.stop_date === '' || moment(this.postData.stop_date).isSameOrBefore(today))) {
                this.alert('自動停止日期', '需大於今天', 'warning');
                return false;
            } else if (this.postData.auto_stop == 0) {
                this.postData.stop_date = '';
            }
            if (this.postData.allow_date !== '' && this.postData.stop_date !== '' && moment(this.postData.allow_date).isSame(moment(this.postData.stop_date))) {
                this.alert('日期錯誤', '自動停止日期 不可等於 自動允許日期', 'warning');
                return false;
            }
            this.$http.patch('/adminapi/member/' + this.memberStatus.member_id + '/update-statuses', this.postData).then(function (response) {
                _this2.ajaxing = false;
                window.Event.$emit('fetchMemberStatus', _this2.memberStatus.member_id);
                _this2.alert('修改會員狀態成功', '', 'success');
                $('#member-status-modal').modal('hide');
            }, function (response) {
                _this2.ajaxing = false;
                _this2.alert('修改會員狀態失敗', '', 'error');
                return false;
            });
        },
        initData: function initData(payload) {
            this.memberStatus = payload.memberStatus;
            this.postData.type = payload.type;
            this.postData.status = this.memberStatus.hasOwnProperty(payload.type) ? this.memberStatus[payload.type] : 1;
            this.postData.auto_allow = this.memberStatus.hasOwnProperty('auto_allow_' + payload.type) ? this.memberStatus['auto_allow_' + payload.type] : 0;
            this.postData.auto_stop = this.memberStatus.hasOwnProperty('auto_stop_' + payload.type) ? this.memberStatus['auto_stop_' + payload.type] : 0;
            this.postData.allow_date = this.memberStatus.hasOwnProperty('allow_' + payload.type + '_date') && moment(this.memberStatus['allow_' + payload.type + '_date']).isValid() ? moment(this.memberStatus['allow_' + payload.type + '_date']).format('YYYY-MM-DD') : '';
            this.postData.stop_date = this.memberStatus.hasOwnProperty('stop_' + payload.type + '_date') && moment(this.memberStatus['stop_' + payload.type + '_date']).isValid() ? moment(this.memberStatus['stop_' + payload.type + '_date']).format('YYYY-MM-DD') : '';

            if (payload.type === 'admission') {
                this.title = '自助入場';
            } else {
                this.title = '線上預約';
            }
        },

        alert: function alert(title, message, type) {
            $17.swal({
                title: title,
                text: message,
                type: type,
                showCancelButton: false,
                showLoaderOnConfirm: true
            });
        }
    },
    computed: {}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal id=\"member-status-modal\" no-footer=\"\" parallel-modal=\"\" _v-069960cc=\"\">\n    <h4 slot=\"title\" _v-069960cc=\"\">{{title}}</h4>\n    <form slot=\"body\" class=\"form-horizontal\" _v-069960cc=\"\">\n        <div class=\"form-group\" _v-069960cc=\"\">\n            <div class=\"col-xs-12\" _v-069960cc=\"\">\n                <label _v-069960cc=\"\"><input type=\"radio\" v-model=\"postData.status\" value=\"1\" _v-069960cc=\"\"> 允許</label>\n                <label class=\"m-left-20\" _v-069960cc=\"\"><input type=\"radio\" v-model=\"postData.status\" value=\"0\" _v-069960cc=\"\"> 停止</label>\n            </div>\n        </div>\n        <hr _v-069960cc=\"\">\n        <div class=\"form-group\" _v-069960cc=\"\">\n            <div class=\"col-xs-12\" _v-069960cc=\"\">\n                <div class=\"clearfix\" _v-069960cc=\"\">\n                    <label class=\"pull-left m-right-10\" _v-069960cc=\"\">\n                        <input type=\"checkbox\" v-model=\"postData.auto_stop\" :true-value=\"1\" :false-value=\"0\" _v-069960cc=\"\">\n                        設定自動停止日期\n                    </label>\n                    <div v-show=\"postData.auto_stop==1\" _v-069960cc=\"\">\n                        <v-datepicker v-model=\"postData.stop_date\" calendar-class=\"member-status-caledar\" input-class=\"member-status-caledar-input\" _v-069960cc=\"\"></v-datepicker>\n                    </div>\n                </div>\n                <div class=\"clearfix\" _v-069960cc=\"\">\n                    <label class=\"pull-left m-right-10\" _v-069960cc=\"\">\n                        <input type=\"checkbox\" v-model=\"postData.auto_allow\" :true-value=\"1\" :false-value=\"0\" _v-069960cc=\"\">\n                        設定自動允許日期\n                    </label>\n                    <div v-show=\"postData.auto_allow==1\" _v-069960cc=\"\">\n                        <v-datepicker v-model=\"postData.allow_date\" calendar-class=\"member-status-caledar\" input-class=\"member-status-caledar-input\" _v-069960cc=\"\"></v-datepicker>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"clearfix\" _v-069960cc=\"\">\n            <input type=\"button\" class=\"btn btn-primary pull-right\" value=\"確認\" @click=\"updateStatus()\" _v-069960cc=\"\">\n        </div>\n    </form>\n</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.member-status-caledar {\n  margin-left: 150px; }\n\n/* line 5, stdin */\n.member-status-caledar-input {\n  max-width: 150px;\n  padding: 7px 10px; }\n\n/* line 2, stdin */\n.vdp-datepicker[_v-069960cc] {\n  position: inherit; }\n\n/* line 5, stdin */\n.date[_v-069960cc] {\n  width: 150px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-069960cc", module.exports)
  } else {
    hotAPI.update("_v-069960cc", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1102:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['memberId'],
    data: function data() {
        return {
            memberStatus: {},
            ajaxing: false,
            isNegative: 'color-danger'
        };
    },
    methods: {
        openModal: function openModal(type) {
            this.$root.$emit('openStatusModal', { type: type, memberStatus: this.memberStatus });
        },
        fetchMemberStatus: function fetchMemberStatus(memberId) {
            var _this = this;

            this.ajaxing = true;
            this.$http.get('/adminapi/member/' + memberId + '/status').then(function (response) {
                _this.memberStatus = response.data.member_status;
                _this.ajaxing = false;
            }, function (response) {
                _this.ajaxing = false;
                $17.swal({
                    title: '取得會員狀態失敗',
                    type: 'error',
                    showCancelButton: false,
                    showLoaderOnConfirm: true
                });
                return false;
            });
        }
    },
    created: function created() {
        var _this2 = this;

        window.Event.$on('fetchMemberStatus', function (memberId) {
            _this2.fetchMemberStatus(memberId);
        });
    },
    mounted: function mounted() {
        if (!this.memberId) return;
        this.fetchMemberStatus(this.memberId);
    },
    destroyed: function destroyed() {
        window.Event.$off('fetchMemberStatus');
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        canEditAdmission: function canEditAdmission(state) {
            return state.webadmin.configure.webFunctions.WebadminMemberStudioStatusAdmission;
        },
        canEditOnlineBooking: function canEditOnlineBooking(state) {
            return state.webadmin.configure.webFunctions.WebadminMemberStudioStatusOnlineBooking;
        }
    }), {
        hasOnlineBookingStatus: function hasOnlineBookingStatus() {
            return this.memberStatus.hasOwnProperty('online_booking');
        },
        hasAdmissionStatus: function hasAdmissionStatus() {
            return this.memberStatus.hasOwnProperty('admission');
        },
        showAllowOnlineBookingDate: function showAllowOnlineBookingDate() {
            return this.hasOnlineBookingStatus && this.memberStatus.auto_allow_online_booking == 0 ? false : moment(this.memberStatus.allow_online_booking_date).format('YYYY-MM-DD');
        },
        showStopOnlineBookingDate: function showStopOnlineBookingDate() {
            return this.hasOnlineBookingStatus && this.memberStatus.auto_stop_online_booking == 0 ? false : moment(this.memberStatus.stop_online_booking_date).format('YYYY-MM-DD');
        },
        showAllowAdmissionDate: function showAllowAdmissionDate() {
            return this.hasAdmissionStatus && this.memberStatus.auto_allow_admission == 0 ? false : moment(this.memberStatus.allow_admission_date).format('YYYY-MM-DD');
        },
        showStopAdmissionDate: function showStopAdmissionDate() {
            return this.hasAdmissionStatus && this.memberStatus.auto_stop_admission == 0 ? false : moment(this.memberStatus.stop_admission_date).format('YYYY-MM-DD');
        },
        allowOnlineBookingStatus: function allowOnlineBookingStatus() {
            return !this.hasOnlineBookingStatus || this.hasOnlineBookingStatus && this.memberStatus.online_booking == 1 ? true : false;
        },
        allowAdmissionStatus: function allowAdmissionStatus() {
            return !this.hasAdmissionStatus || this.hasAdmissionStatus && this.memberStatus.admission == 1 ? true : false;
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-689f6f69=\"\">\n    <v-spinner :ajaxing=\"ajaxing\" _v-689f6f69=\"\">\n    </v-spinner>\n    <table class=\"status-table table m-bottom-0\" v-show=\"!ajaxing\" _v-689f6f69=\"\">\n        <tbody _v-689f6f69=\"\">\n        <tr _v-689f6f69=\"\">\n            <th style=\"border-top: none;\" _v-689f6f69=\"\">線上預約</th>\n            <td class=\"text-right\" style=\"border-top: none;\" _v-689f6f69=\"\">\n                <span v-if=\"!allowOnlineBookingStatus\" class=\"color-danger\" _v-689f6f69=\"\">停止</span>\n                <span v-else=\"\" _v-689f6f69=\"\">允許</span>\n                <button v-if=\"canEditOnlineBooking\" class=\"btn btn-primary btn-xs\" @click=\"openModal('online_booking')\" _v-689f6f69=\"\"><i class=\"fa fa-pencil\" _v-689f6f69=\"\"></i></button>\n                <div class=\"color-gray p-bottom-5\" v-show=\"showAllowOnlineBookingDate||showStopOnlineBookingDate\" _v-689f6f69=\"\">\n                    <span v-show=\"showAllowOnlineBookingDate\" _v-689f6f69=\"\">自動允許:{{showAllowOnlineBookingDate}}</span>\n                    <span v-show=\"showStopOnlineBookingDate\" class=\"m-left-10\" _v-689f6f69=\"\">自動停止:{{showStopOnlineBookingDate}}</span>\n                </div>\n            </td>\n        </tr>\n        <tr _v-689f6f69=\"\">\n            <th _v-689f6f69=\"\">自助入場</th>\n            <td class=\"text-right\" _v-689f6f69=\"\">\n                <span v-if=\"!allowAdmissionStatus\" class=\"color-danger\" _v-689f6f69=\"\">停止</span>\n                <span v-else=\"\" _v-689f6f69=\"\">允許</span>\n                <button v-if=\"canEditAdmission\" class=\"btn btn-primary btn-xs\" @click=\"openModal('admission')\" _v-689f6f69=\"\"><i class=\"fa fa-pencil\" _v-689f6f69=\"\"></i></button>\n                <div class=\"color-gray p-bottom-5\" v-show=\"showAllowAdmissionDate||showStopAdmissionDate\" _v-689f6f69=\"\">\n                    <span v-show=\"showAllowAdmissionDate\" _v-689f6f69=\"\">自動允許:{{showAllowAdmissionDate}}</span>\n                    <span v-show=\"showStopAdmissionDate\" class=\"m-left-10\" _v-689f6f69=\"\">自動停止:{{showStopAdmissionDate}}</span>\n                </div>\n            </td>\n        </tr>\n        </tbody>\n    </table>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-689f6f69", module.exports)
  } else {
    hotAPI.update("_v-689f6f69", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vuex":803}],1103:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert(".tippy-box[data-animation=fade][data-state=hidden]{opacity:0}[data-tippy-root]{max-width:calc(100vw - 10px)}.tippy-box{position:relative;background-color:#333;color:#fff;border-radius:4px;font-size:14px;line-height:1.4;outline:0;transition-property:transform,visibility,opacity}.tippy-box[data-placement^=top]>.tippy-arrow{bottom:0}.tippy-box[data-placement^=top]>.tippy-arrow:before{bottom:-7px;left:0;border-width:8px 8px 0;border-top-color:initial;transform-origin:center top}.tippy-box[data-placement^=bottom]>.tippy-arrow{top:0}.tippy-box[data-placement^=bottom]>.tippy-arrow:before{top:-7px;left:0;border-width:0 8px 8px;border-bottom-color:initial;transform-origin:center bottom}.tippy-box[data-placement^=left]>.tippy-arrow{right:0}.tippy-box[data-placement^=left]>.tippy-arrow:before{border-width:8px 0 8px 8px;border-left-color:initial;right:-7px;transform-origin:center left}.tippy-box[data-placement^=right]>.tippy-arrow{left:0}.tippy-box[data-placement^=right]>.tippy-arrow:before{left:-7px;border-width:8px 8px 8px 0;border-right-color:initial;transform-origin:center right}.tippy-box[data-inertia][data-state=visible]{transition-timing-function:cubic-bezier(.54,1.5,.38,1.11)}.tippy-arrow{width:16px;height:16px;color:#333}.tippy-arrow:before{content:\"\";position:absolute;border-color:transparent;border-style:solid}.tippy-content{position:relative;padding:5px 9px;z-index:1}\n.tippy-box[data-theme~=light-border]{background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,8,16,.15);color:#333;box-shadow:0 4px 14px -2px rgba(0,8,16,.08)}.tippy-box[data-theme~=light-border]>.tippy-backdrop{background-color:#fff}.tippy-box[data-theme~=light-border]>.tippy-arrow:after,.tippy-box[data-theme~=light-border]>.tippy-svg-arrow:after{content:\"\";position:absolute;z-index:-1}.tippy-box[data-theme~=light-border]>.tippy-arrow:after{border-color:transparent;border-style:solid}.tippy-box[data-theme~=light-border][data-placement^=top]>.tippy-arrow:before{border-top-color:#fff}.tippy-box[data-theme~=light-border][data-placement^=top]>.tippy-arrow:after{border-top-color:rgba(0,8,16,.2);border-width:7px 7px 0;top:17px;left:1px}.tippy-box[data-theme~=light-border][data-placement^=top]>.tippy-svg-arrow>svg{top:16px}.tippy-box[data-theme~=light-border][data-placement^=top]>.tippy-svg-arrow:after{top:17px}.tippy-box[data-theme~=light-border][data-placement^=bottom]>.tippy-arrow:before{border-bottom-color:#fff;bottom:16px}.tippy-box[data-theme~=light-border][data-placement^=bottom]>.tippy-arrow:after{border-bottom-color:rgba(0,8,16,.2);border-width:0 7px 7px;bottom:17px;left:1px}.tippy-box[data-theme~=light-border][data-placement^=bottom]>.tippy-svg-arrow>svg{bottom:16px}.tippy-box[data-theme~=light-border][data-placement^=bottom]>.tippy-svg-arrow:after{bottom:17px}.tippy-box[data-theme~=light-border][data-placement^=left]>.tippy-arrow:before{border-left-color:#fff}.tippy-box[data-theme~=light-border][data-placement^=left]>.tippy-arrow:after{border-left-color:rgba(0,8,16,.2);border-width:7px 0 7px 7px;left:17px;top:1px}.tippy-box[data-theme~=light-border][data-placement^=left]>.tippy-svg-arrow>svg{left:11px}.tippy-box[data-theme~=light-border][data-placement^=left]>.tippy-svg-arrow:after{left:12px}.tippy-box[data-theme~=light-border][data-placement^=right]>.tippy-arrow:before{border-right-color:#fff;right:16px}.tippy-box[data-theme~=light-border][data-placement^=right]>.tippy-arrow:after{border-width:7px 7px 7px 0;right:17px;top:1px;border-right-color:rgba(0,8,16,.2)}.tippy-box[data-theme~=light-border][data-placement^=right]>.tippy-svg-arrow>svg{right:11px}.tippy-box[data-theme~=light-border][data-placement^=right]>.tippy-svg-arrow:after{right:12px}.tippy-box[data-theme~=light-border]>.tippy-svg-arrow{fill:#fff}.tippy-box[data-theme~=light-border]>.tippy-svg-arrow:after{background-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMCA2czEuNzk2LS4wMTMgNC42Ny0zLjYxNUM1Ljg1MS45IDYuOTMuMDA2IDggMGMxLjA3LS4wMDYgMi4xNDguODg3IDMuMzQzIDIuMzg1QzE0LjIzMyA2LjAwNSAxNiA2IDE2IDZIMHoiIGZpbGw9InJnYmEoMCwgOCwgMTYsIDAuMikiLz48L3N2Zz4=);background-size:16px 6px;width:16px;height:6px}\n/* line 2, stdin */\n.list[_v-ecb13ce4] {\n  border: 10px;\n  padding: 10px 0;\n  font-size: 14px;\n  border-bottom: solid 1px #e6e6e6;\n  cursor: pointer; }\n\n/* line 10, stdin */\n.list[_v-ecb13ce4]:nth-last-child(1) {\n  border-bottom: none; }\n\n/* line 14, stdin */\n.term-show-name[_v-ecb13ce4] {\n  font-weight: 500;\n  color: #337ab7;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis; }\n\n/* line 22, stdin */\n.fa-check-circle[_v-ecb13ce4] {\n  color: #64d09c; }\n\n/* line 26, stdin */\n.fa-times-circle[_v-ecb13ce4] {\n  color: #b7b7b7; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _tippy = require('tippy.js');

var _tippy2 = _interopRequireDefault(_tippy);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        memberId: {},
        isShowMore: {
            type: Function
        }
    },
    data: function data() {
        return {
            startAjax: true,
            showBtn: false,
            termsData: [],
            terms: [],
            signatures: {}
        };
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        OutputMemberApprovalTerm: function OutputMemberApprovalTerm(state) {
            return state.webadmin.configure.webFunctions.WebadminMemberApprovalTermOutput;
        },
        DeleteMemberApprovalTerm: function DeleteMemberApprovalTerm(state) {
            return state.webadmin.configure.webFunctions.WebadminMemberApprovalTermDelete;
        },
        ViewSignatureMemberApprovalTerm: function ViewSignatureMemberApprovalTerm(state) {
            return state.webadmin.configure.webFunctions.WebadminMemberApprovalTermViewSignature;
        }
    })),
    created: function created() {
        var _this = this;

        window.Event.$on('fetchMemberTerms', function (memberId) {
            _this.fetchMemberTerms(memberId);
        });
        window.Event.$on('fetchTermsShowMore', function (value) {
            _this.fetchShowMore(value);
        });
    },

    watch: {
        memberId: function memberId(newVal) {
            if (newVal) {
                this.fetchMemberTerms(newVal);
            }
        }
    },
    mounted: function mounted() {
        if (!this.memberId) return;
        this.fetchMemberTerms(this.memberId);
    },

    methods: {
        viewSignature: function viewSignature(termId, idx) {
            if (!this.ViewSignatureMemberApprovalTerm) return;

            var vue = this;
            var id = '#signature' + termId;

            this.$nextTick(function () {
                var content = '<div style="font-size: 16px">載入中...請稍候...</div>';
                var container = '#tippy-container' + termId;
                (0, _tippy2.default)(container, {
                    target: id,
                    content: content,
                    trigger: 'click',
                    duration: 0,
                    animation: 'scale',
                    arrow: true,
                    placement: 'top',
                    theme: 'light-border',
                    allowHTML: true,
                    onHidden: function onHidden(instance) {
                        instance.setContent(content);
                    },
                    onShow: function onShow(instance) {
                        if (vue.signatures.hasOwnProperty(termId)) {
                            var signature = vue.signatures[termId];
                            var _content = '<div style="text-align: center"><div style="font-size: 20px;padding:10px 0;">條款簽名</div><img style="border: gray 1px solid" src="' + signature + '"></div>';
                            instance.setContent(_content);
                        } else {
                            vue.$http.get('/adminapi/approval-term/member/view-signature/' + termId).then(function (response) {
                                var signature = response.data.signature;
                                vue.signatures[termId] = signature;
                                var content = '<div style="text-align: center"><div style="font-size: 20px;padding:10px 0;">條款簽名</div><img style="border: gray 1px solid" src="' + signature + '"></div>';
                                instance.setContent(content);
                            }).catch(function (error) {
                                instance.setContent('預覽簽名檔案發生錯誤');
                            });
                        }
                    }
                });
            });
        },
        fetchMemberTerms: function fetchMemberTerms(memberId) {
            var _this2 = this;

            this.startAjax = true;
            this.$http.get('/adminapi/approval-term/member/list/' + memberId).then(function (response) {
                _this2.terms = response.data;
                _this2.termsData = _this2.terms.slice(0, 5);
                _this2.isShowMore && _this2.isShowMore(_this2.terms.length > 5);
                _this2.startAjax = false;
            }).catch(function (error) {
                _this2.startAjax = false;
            });
        },

        fetchShowMore: function fetchShowMore(value) {
            if (value) {
                this.termsData = this.terms;
            } else {
                this.termsData = this.terms.slice(0, 5);
            }
        },
        downloadTerm: function downloadTerm(termId) {
            this.openNewWindow(termId, 'download');
        },
        openNewWindow: function openNewWindow(termId) {
            var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            if (this.OutputMemberApprovalTerm) {
                var url = '/term/' + termId;
                if (mode) url = url + ('?mode=' + mode);
                window.open(url, '_blank');
            }
        },
        removeTerm: function removeTerm(termId) {
            var selectTerm = this.terms.find(function (item) {
                return item.id == termId;
            });
            var vm = this;
            $17.swal({
                title: '\u78BA\u8A8D\u522A\u9664\u689D\u6B3E-' + selectTerm.name + '\uFF1F',
                type: 'info',
                showCancelButton: true,
                confirmButtonText: '刪除',
                cancelButtonText: '取消'
            }, function (isConfirm) {
                if (isConfirm) {
                    vm.delete(termId);
                }
            });
        },
        delete: function _delete(termId) {
            var _this3 = this;

            this.startAjax = true;
            this.$http.delete('/adminapi/approval-term/member/' + termId).then(function (response) {
                _this3.fetchMemberTerms(_this3.memberId);
            }).catch(function (error) {
                _this3.startAjax = false;
                $17.swal({
                    title: '刪除失敗',
                    type: 'error',
                    showCancelButton: false
                });
            });
        }
    },
    destroyed: function destroyed() {
        window.Event.$off('fetchMemberTerms');
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-ecb13ce4=\"\">\n    <v-spinner :ajaxing=\"startAjax\" id=\"v-spinner\" _v-ecb13ce4=\"\">\n    </v-spinner>\n    <div class=\"row\" style=\"margin: 0 10px;\" v-show=\"!startAjax\" _v-ecb13ce4=\"\">\n        <div class=\"col-sm-12\" _v-ecb13ce4=\"\">\n            <div class=\"row list\" v-for=\"(detail,idx) in termsData\" id=\"tippy-container\" _v-ecb13ce4=\"\">\n                <div class=\"col-sm-5 term-show-name\" @click.prevent=\"openNewWindow(detail.id)\" _v-ecb13ce4=\"\">\n                    <i class=\"fa fa-file p-right-5\" _v-ecb13ce4=\"\"></i>{{detail.name}}\n                </div>\n                <div class=\"col-sm-2\" :id=\"'tippy-container'+detail.id\" _v-ecb13ce4=\"\">\n                    <span v-if=\"detail.is_signed\" @click=\"viewSignature(detail.id,idx)\" :id=\"'signature'+detail.id\" _v-ecb13ce4=\"\">\n                        <i class=\"fa fa-check-circle\" _v-ecb13ce4=\"\"></i>\n                        簽名\n                    </span>\n                    <span v-else=\"\" _v-ecb13ce4=\"\">\n                        <i class=\"fa fa-times-circle\" _v-ecb13ce4=\"\"></i>\n                        未簽名\n                    </span>\n                </div>\n                <div class=\"col-sm-4\" _v-ecb13ce4=\"\">\n                    {{detail.approval_at}}\n                </div>\n                <div class=\"col-sm-1\" v-if=\"DeleteMemberApprovalTerm || OutputMemberApprovalTerm\" _v-ecb13ce4=\"\">\n                    <button class=\"btn btn-primary btn-xs dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" _v-ecb13ce4=\"\"><i class=\"fa fa-ellipsis-h\" _v-ecb13ce4=\"\"></i></button>\n                    <ul class=\"dropdown-menu dropdown-menu-right\" style=\" min-width: 74px; right: 15px; \" _v-ecb13ce4=\"\">\n                        <li v-if=\"DeleteMemberApprovalTerm\" _v-ecb13ce4=\"\"><a @click.prevent=\"removeTerm(detail.id)\" _v-ecb13ce4=\"\">刪除</a></li>\n                        <li v-if=\"OutputMemberApprovalTerm\" _v-ecb13ce4=\"\"><a @click.prevent=\"downloadTerm(detail.id)\" _v-ecb13ce4=\"\">下載（Beta）</a></li>\n                    </ul>\n                </div>\n            </div>\n        </div>\n        <div style=\"margin: 15px;font-size: 15px;color: #898989;\" v-if=\"terms.length == 0\" _v-ecb13ce4=\"\">\n            暫無內容\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache[".tippy-box[data-animation=fade][data-state=hidden]{opacity:0}[data-tippy-root]{max-width:calc(100vw - 10px)}.tippy-box{position:relative;background-color:#333;color:#fff;border-radius:4px;font-size:14px;line-height:1.4;outline:0;transition-property:transform,visibility,opacity}.tippy-box[data-placement^=top]>.tippy-arrow{bottom:0}.tippy-box[data-placement^=top]>.tippy-arrow:before{bottom:-7px;left:0;border-width:8px 8px 0;border-top-color:initial;transform-origin:center top}.tippy-box[data-placement^=bottom]>.tippy-arrow{top:0}.tippy-box[data-placement^=bottom]>.tippy-arrow:before{top:-7px;left:0;border-width:0 8px 8px;border-bottom-color:initial;transform-origin:center bottom}.tippy-box[data-placement^=left]>.tippy-arrow{right:0}.tippy-box[data-placement^=left]>.tippy-arrow:before{border-width:8px 0 8px 8px;border-left-color:initial;right:-7px;transform-origin:center left}.tippy-box[data-placement^=right]>.tippy-arrow{left:0}.tippy-box[data-placement^=right]>.tippy-arrow:before{left:-7px;border-width:8px 8px 8px 0;border-right-color:initial;transform-origin:center right}.tippy-box[data-inertia][data-state=visible]{transition-timing-function:cubic-bezier(.54,1.5,.38,1.11)}.tippy-arrow{width:16px;height:16px;color:#333}.tippy-arrow:before{content:\"\";position:absolute;border-color:transparent;border-style:solid}.tippy-content{position:relative;padding:5px 9px;z-index:1}\n.tippy-box[data-theme~=light-border]{background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,8,16,.15);color:#333;box-shadow:0 4px 14px -2px rgba(0,8,16,.08)}.tippy-box[data-theme~=light-border]>.tippy-backdrop{background-color:#fff}.tippy-box[data-theme~=light-border]>.tippy-arrow:after,.tippy-box[data-theme~=light-border]>.tippy-svg-arrow:after{content:\"\";position:absolute;z-index:-1}.tippy-box[data-theme~=light-border]>.tippy-arrow:after{border-color:transparent;border-style:solid}.tippy-box[data-theme~=light-border][data-placement^=top]>.tippy-arrow:before{border-top-color:#fff}.tippy-box[data-theme~=light-border][data-placement^=top]>.tippy-arrow:after{border-top-color:rgba(0,8,16,.2);border-width:7px 7px 0;top:17px;left:1px}.tippy-box[data-theme~=light-border][data-placement^=top]>.tippy-svg-arrow>svg{top:16px}.tippy-box[data-theme~=light-border][data-placement^=top]>.tippy-svg-arrow:after{top:17px}.tippy-box[data-theme~=light-border][data-placement^=bottom]>.tippy-arrow:before{border-bottom-color:#fff;bottom:16px}.tippy-box[data-theme~=light-border][data-placement^=bottom]>.tippy-arrow:after{border-bottom-color:rgba(0,8,16,.2);border-width:0 7px 7px;bottom:17px;left:1px}.tippy-box[data-theme~=light-border][data-placement^=bottom]>.tippy-svg-arrow>svg{bottom:16px}.tippy-box[data-theme~=light-border][data-placement^=bottom]>.tippy-svg-arrow:after{bottom:17px}.tippy-box[data-theme~=light-border][data-placement^=left]>.tippy-arrow:before{border-left-color:#fff}.tippy-box[data-theme~=light-border][data-placement^=left]>.tippy-arrow:after{border-left-color:rgba(0,8,16,.2);border-width:7px 0 7px 7px;left:17px;top:1px}.tippy-box[data-theme~=light-border][data-placement^=left]>.tippy-svg-arrow>svg{left:11px}.tippy-box[data-theme~=light-border][data-placement^=left]>.tippy-svg-arrow:after{left:12px}.tippy-box[data-theme~=light-border][data-placement^=right]>.tippy-arrow:before{border-right-color:#fff;right:16px}.tippy-box[data-theme~=light-border][data-placement^=right]>.tippy-arrow:after{border-width:7px 7px 7px 0;right:17px;top:1px;border-right-color:rgba(0,8,16,.2)}.tippy-box[data-theme~=light-border][data-placement^=right]>.tippy-svg-arrow>svg{right:11px}.tippy-box[data-theme~=light-border][data-placement^=right]>.tippy-svg-arrow:after{right:12px}.tippy-box[data-theme~=light-border]>.tippy-svg-arrow{fill:#fff}.tippy-box[data-theme~=light-border]>.tippy-svg-arrow:after{background-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMCA2czEuNzk2LS4wMTMgNC42Ny0zLjYxNUM1Ljg1MS45IDYuOTMuMDA2IDggMGMxLjA3LS4wMDYgMi4xNDguODg3IDMuMzQzIDIuMzg1QzE0LjIzMyA2LjAwNSAxNiA2IDE2IDZIMHoiIGZpbGw9InJnYmEoMCwgOCwgMTYsIDAuMikiLz48L3N2Zz4=);background-size:16px 6px;width:16px;height:6px}\n/* line 2, stdin */\n.list[_v-ecb13ce4] {\n  border: 10px;\n  padding: 10px 0;\n  font-size: 14px;\n  border-bottom: solid 1px #e6e6e6;\n  cursor: pointer; }\n\n/* line 10, stdin */\n.list[_v-ecb13ce4]:nth-last-child(1) {\n  border-bottom: none; }\n\n/* line 14, stdin */\n.term-show-name[_v-ecb13ce4] {\n  font-weight: 500;\n  color: #337ab7;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis; }\n\n/* line 22, stdin */\n.fa-check-circle[_v-ecb13ce4] {\n  color: #64d09c; }\n\n/* line 26, stdin */\n.fa-times-circle[_v-ecb13ce4] {\n  color: #b7b7b7; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-ecb13ce4", module.exports)
  } else {
    hotAPI.update("_v-ecb13ce4", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"tippy.js":780,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1104:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 3, stdin */\n.timing[_v-58a55dc0] {\n  padding: 3px;\n  border: 1px solid;\n  background: #eee; }\n\n/* line 8, stdin */\n.stop-timing[_v-58a55dc0] {\n  cursor: pointer;\n  margin-left: 5px;\n  color: #ff0000; }\n\n/* line 13, stdin */\n.already-stop-timing[_v-58a55dc0] {\n  cursor: not-allowed;\n  margin-left: 5px;\n  color: #999; }\n\n/* line 18, stdin */\n.btn-submit-admission[_v-58a55dc0] {\n  margin-top: 15px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	props: ['memberId'],
	data: function data() {
		return {
			nowTimer: moment().format('YYYY-MM-DD HH:mm:ss'),
			currentTimerId: null
		};
	},
	mounted: function mounted() {
		$('#out-admission-modal').on('show.bs.modal', this.startTiming);
		$('#out-admission-modal').on('hidden.bs.modal', this.stopJsTiming);
	},

	watch: {
		'record.now': function recordNow(newVal) {
			if (newVal) {
				this.nowTimer = moment(this.record.now).format('YYYY-MM-DD HH:mm:ss');
			}
		}
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
		contractTypes: function contractTypes(state) {
			return state.webadmin.admission.contractTypes;
		},
		record: function record(state) {
			return state.webadmin.admission.unLeavedRecord;
		},
		member: function member(state) {
			return state.webadmin.crm.member;
		},
		ignoreOverLimit: function ignoreOverLimit(state) {
			return state.webadmin.admission.ignoreOverLimit;
		}
	}), {
		stopTimingAt: {
			get: function get() {
				return this.record.stop_timing_at ? this.record.stop_timing_at : this.nowTimer;
			}
		},
		isPoint: function isPoint() {
			return this.record.contract_type === this.contractTypes.point;
		},
		minusValue: function minusValue() {
			if (this.record.minus_point_when_out && this.isPoint) {
				var minutes = this.passTime;
				var value = (minutes - this.record.after_enter_time_minus_point) / this.record.out_time_unit * this.record.out_minus_point;
				value = Math.floor(value);
				return value > 0 ? value : 0;
			}
			return 0;
		},
		minusUnit: function minusUnit() {
			return this.record.contract_type_unit;
		},
		passTime: function passTime() {
			var now = this.record.stop_timing_at ? moment(this.record.stop_timing_at) : moment(this.nowTimer);
			var enteredAt = moment(this.record.entered_at);
			var duration = moment.duration(now.diff(enteredAt));
			var minutes = Math.floor(duration.asMinutes());
			return minutes;
		},
		admissionName: function admissionName() {
			return this.record.admission ? this.record.admission.name : '';
		}
	}),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('webadmin/admission', ['showAdmissionInfo']), {
		refreshNowTimer: function refreshNowTimer() {
			this.nowTimer = moment(this.nowTimer).add(1, 's').format('YYYY-MM-DD HH:mm:ss');
		},
		startTiming: function startTiming(e) {
			if (this.record.stop_timing_at) return;
			this.currentTimerId = setInterval(this.refreshNowTimer, 1000);
		},
		stopJsTiming: function stopJsTiming() {
			clearInterval(this.currentTimerId);
		},
		stopTiming: function stopTiming() {
			var _this = this;

			return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_this.stopJsTiming();
								_context.next = 3;
								return _this.$store.dispatch('webadmin/admission/stopTiming', _this.record.id);

							case 3:
								_context.next = 5;
								return _this.$store.dispatch('webadmin/admission/getUnLeavedRecord', _this.member.id);

							case 5:
								if (_this.record.stop_timing_at) {
									$17.swal({
										title: '已停止計時',
										type: 'info',
										showCancelButton: false
									});
								}

							case 6:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		},
		isOverLimitTime: function isOverLimitTime() {
			return this.record.limit_time > 0 && this.record.limit_time < this.passTime;
		},
		outHandler: function outHandler(e) {
			var _this2 = this;

			return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
				return _regenerator2.default.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								$(e.target).prop('disabled', true);
								_context2.next = 3;
								return _this2.$store.dispatch('webadmin/admission/markLeaved', _this2.record.id).then(function () {
									$17.swal({
										type: 'success',
										title: '確認出場',
										showCancelButton: false
									});
									window.Event.$emit('fetchMemberContract', _this2.member.id);
									$('#out-admission-modal').modal('hide');
								}).catch(function (o) {
									_this2.$store.dispatch('webadmin/admission/admissionErrorAlert', o);
								});

							case 3:
								$(e.target).prop('disabled', false);

							case 4:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, _this2);
			}))();
		},
		submit: function submit(e) {
			var _this3 = this;

			if (this.isOverLimitTime()) {
				$17.swal({
					title: '超出時間',
					type: 'info',
					showCancelButton: true,
					confirmButtonText: '前往結帳',
					cancelButtonText: '略過，允許出場'
				}, function (isConfirm) {
					if (isConfirm) {
						window.Event.$emit('createOrder');
						$('#out-admission-modal').modal('hide');
						return false;
					}
					_this3.outHandler(e);
				});
				return false;
			}
			this.outHandler(e);
		}
	})
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n\t<v-modal id=\"out-admission-modal\" no-footer=\"\" parallel-modal=\"\" no-border-radius=\"\" _v-58a55dc0=\"\">\n\t\t<template slot=\"title\">出場</template>\n\t\t<template slot=\"body\">\n            <v-member-info :picture=\"member.picture_path\" :name=\"member.name\" :phone=\"member.phone\" :email=\"member.email\" _v-58a55dc0=\"\">\n            </v-member-info>\n            <hr class=\"normal\" _v-58a55dc0=\"\">\n\t\t\t<form class=\"form-horizontal\" _v-58a55dc0=\"\">\n\t\t\t\t<div class=\"row\" _v-58a55dc0=\"\">\n\t\t\t\t\t<label class=\"control-label col-sm-3\" _v-58a55dc0=\"\">使用方案</label>\n\t\t\t\t\t<p class=\"form-control-static col-sm-9\" _v-58a55dc0=\"\">{{ record.contract_name }}</p>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"row\" _v-58a55dc0=\"\">\n\t\t\t\t\t<label class=\"control-label col-sm-3\" _v-58a55dc0=\"\">入場設定</label>\n\t\t\t\t\t<p class=\"form-control-static col-sm-9\" _v-58a55dc0=\"\">{{ admissionName }} <a @click.prevnet=\"showAdmissionInfo\" _v-58a55dc0=\"\"><i class=\"fa fa-question-circle\" _v-58a55dc0=\"\"></i></a></p>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"row\" _v-58a55dc0=\"\">\n\t\t\t\t\t<label class=\"control-label col-sm-3\" _v-58a55dc0=\"\">剩餘</label>\n\t\t\t\t\t<p class=\"form-control-static col-sm-9\" _v-58a55dc0=\"\">{{ record.remain }} {{ minusUnit }}</p>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"row\" _v-58a55dc0=\"\">\n\t\t\t\t\t<label class=\"control-label col-sm-3\" _v-58a55dc0=\"\">入場</label>\n\t\t\t\t\t<p class=\"form-control-static col-sm-9\" _v-58a55dc0=\"\">{{ record.entered_at }}</p>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"row\" _v-58a55dc0=\"\">\n\t\t\t\t\t<label class=\"control-label col-sm-3\" _v-58a55dc0=\"\">計時</label>\n\t\t\t\t\t<p class=\"form-control-static col-sm-9\" _v-58a55dc0=\"\">\n\t\t\t\t\t\t<span class=\"timing\" _v-58a55dc0=\"\">{{ stopTimingAt }}</span>\n\t\t\t\t\t\t<span v-show=\"isPoint\" class=\"stop-timing\" v-if=\"!record.stop_timing_at\" @click=\"stopTiming\" _v-58a55dc0=\"\">\n\t\t\t\t\t\t\t停止計時\n\t\t\t\t\t\t\t<i class=\"fa fa-clock-o\" _v-58a55dc0=\"\"></i>\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span class=\"already-stop-timing\" v-show=\"isPoint\" v-else=\"\" _v-58a55dc0=\"\">已停止計時</span>\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"row\" _v-58a55dc0=\"\">\n\t\t\t\t\t<label class=\"control-label col-sm-3\" _v-58a55dc0=\"\">經過時間</label>\n\t\t\t\t\t<p class=\"form-control-static col-sm-9\" _v-58a55dc0=\"\">{{ passTime }} 分鐘</p>\n\t\t\t\t</div>\n\t\t\t\t<div v-show=\"isPoint\" class=\"row\" _v-58a55dc0=\"\">\n\t\t\t\t\t<label class=\"control-label col-sm-3\" _v-58a55dc0=\"\">扣除</label>\n\t\t\t\t\t<p class=\"form-control-static col-sm-9\" _v-58a55dc0=\"\">{{ minusValue }} {{ minusUnit }}</p>\n\t\t\t\t</div>\n\t\t\t\t<button type=\"button\" class=\"btn btn-primary btn-lg btn-block btn-submit-admission\" @click.prevent=\"submit\" _v-58a55dc0=\"\">出場</button>\n\t\t\t</form>\n\t\t</template>\n\t</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 3, stdin */\n.timing[_v-58a55dc0] {\n  padding: 3px;\n  border: 1px solid;\n  background: #eee; }\n\n/* line 8, stdin */\n.stop-timing[_v-58a55dc0] {\n  cursor: pointer;\n  margin-left: 5px;\n  color: #ff0000; }\n\n/* line 13, stdin */\n.already-stop-timing[_v-58a55dc0] {\n  cursor: not-allowed;\n  margin-left: 5px;\n  color: #999; }\n\n/* line 18, stdin */\n.btn-submit-admission[_v-58a55dc0] {\n  margin-top: 15px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-58a55dc0", module.exports)
  } else {
    hotAPI.update("_v-58a55dc0", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1105:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n#profile-img[_v-69227e1f] {\n  margin-right: 10px;\n  width: 120px;\n  float: left; }\n\n/* line 8, stdin */\n#v-spinner[_v-69227e1f] {\n  align: center; }\n\n/* line 12, stdin */\n.bottom-margin[_v-69227e1f] {\n  margin-bottom: 5px; }\n\n/* line 16, stdin */\n.self[_v-69227e1f] {\n  width: 555px;\n  margin-top: 30px; }\n\n/* line 21, stdin */\n.self ul[_v-69227e1f] {\n  list-style-type: none; }\n\n/* line 25, stdin */\n.profile[_v-69227e1f] {\n  height: 145px;\n  margin-bottom: 10px; }\n\n/* line 30, stdin */\n.label[_v-69227e1f] {\n  margin-right: 1%;\n  margin-bottom: 1%; }\n\n/* line 35, stdin */\n.tagged[_v-69227e1f] {\n  width: 640px; }\n\n/* line 39, stdin */\nspan[_v-69227e1f] {\n  display: inline-block; }\n\n@media (max-width: 768px) {\n  /* line 44, stdin */\n  .tagged[_v-69227e1f] {\n    display: inline-block;\n    width: 200px;\n    height: 50px; } }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        memberId: {}
    },
    data: function data() {
        return {
            tags: [],
            startAjax: false
        };
    },

    methods: {
        fetchTagList: function fetchTagList(memberId) {
            var _this = this;

            this.startAjax = true;
            this.$http.get('/adminapi/member-tag/' + memberId).then(function (response) {
                _this.startAjax = false;
                _this.tags = response.body;
            });
        },
        resetFields: function resetFields() {
            (0, _assign2.default)(this.$data, this.$options.data());
        }
    },
    created: function created() {
        var _this2 = this;

        window.Event.$on('resetData', function () {
            _this2.resetFields();
        });
        window.Event.$on('fetchMemberTagList', function (memberId) {
            _this2.fetchTagList(memberId);
        });
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        customer: function customer(state) {
            return state.webadmin.crm.member;
        }
    })),
    mounted: function mounted() {
        var _this3 = this;

        window.Event.$on('updateProfileTag', function (memberId) {
            _this3.fetchTagList(memberId);
        });
    },
    destroyed: function destroyed() {
        window.Event.$off('fetchMemberTagList');
        window.Event.$off('updateProfileTag');
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n    <div class=\"profile\" _v-69227e1f=\"\">\n\t\t<img id=\"profile-img\" :src=\"customer.picture_path\" _v-69227e1f=\"\">\n        <div class=\"self\" _v-69227e1f=\"\">\n            <v-spinner :ajaxing=\"startAjax\" id=\"v-spinner\" _v-69227e1f=\"\">\n            </v-spinner>\n            <ul v-show=\"!startAjax\" _v-69227e1f=\"\">\n\t\t\t \t<li class=\"bottom-margin\" style=\"font-size: 20px;\" _v-69227e1f=\"\">{{ customer.name }}</li>\n                <li _v-69227e1f=\"\">\n                    <v-member-tag :member-tags=\"tags\" :tag-style=\"{margin: '-3px 0px 5px 0px'}\" _v-69227e1f=\"\"></v-member-tag>\n                </li>\n                <li class=\"bottom-margin\" _v-69227e1f=\"\">\n                    <i class=\"fa fa-phone\" _v-69227e1f=\"\"></i>\n                    <span class=\"m-left-5\" _v-69227e1f=\"\">{{ customer.phone }}</span>\n                </li>\n\t\t\t\t<li class=\"bottom-margin\" _v-69227e1f=\"\">\n                    <i class=\"fa fa-envelope\" _v-69227e1f=\"\"></i>\n                    <span class=\"m-left-5\" _v-69227e1f=\"\">{{ customer.email }}</span>\n                </li>\n            </ul>\n        </div>\n    </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n#profile-img[_v-69227e1f] {\n  margin-right: 10px;\n  width: 120px;\n  float: left; }\n\n/* line 8, stdin */\n#v-spinner[_v-69227e1f] {\n  align: center; }\n\n/* line 12, stdin */\n.bottom-margin[_v-69227e1f] {\n  margin-bottom: 5px; }\n\n/* line 16, stdin */\n.self[_v-69227e1f] {\n  width: 555px;\n  margin-top: 30px; }\n\n/* line 21, stdin */\n.self ul[_v-69227e1f] {\n  list-style-type: none; }\n\n/* line 25, stdin */\n.profile[_v-69227e1f] {\n  height: 145px;\n  margin-bottom: 10px; }\n\n/* line 30, stdin */\n.label[_v-69227e1f] {\n  margin-right: 1%;\n  margin-bottom: 1%; }\n\n/* line 35, stdin */\n.tagged[_v-69227e1f] {\n  width: 640px; }\n\n/* line 39, stdin */\nspan[_v-69227e1f] {\n  display: inline-block; }\n\n@media (max-width: 768px) {\n  /* line 44, stdin */\n  .tagged[_v-69227e1f] {\n    display: inline-block;\n    width: 200px;\n    height: 50px; } }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-69227e1f", module.exports)
  } else {
    hotAPI.update("_v-69227e1f", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/object/assign":50,"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1106:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 3, stdin */\n.right-btn[_v-51328cbe] {\n  margin-top: 10px; }\n\n/* line 11, stdin */\n.fa[_v-51328cbe] {\n  padding-right: 10px; }\n\n/* line 14, stdin */\n.btn.btn-hide.btn-block[_v-51328cbe] {\n  background-color: #EEE;\n  border: none; }\n  /* line 18, stdin */\n  .btn.btn-hide.btn-block[_v-51328cbe]:hover {\n    color: red;\n    box-shadow: none; }\n\n@media (min-width: 989px) {\n  /* line 24, stdin */\n  .bottom-up[_v-51328cbe] {\n    position: absolute;\n    bottom: 5px; } }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        member: {}
    },
    methods: {
        editTagModal: function editTagModal() {
            window.Event.$emit('editTag');
        },
        createOrderModal: function createOrderModal() {
            window.Event.$emit('createOrder', this.member);
        },
        openOperateOrder: function openOperateOrder() {
            window.Event.$emit("System.Pos.Order.Open", {
                'order_id': '',
                'mode': 'edit',
                'event_type': 'crmCreate',
                'member_id': this.member
            });
        },

        deleteMember: function () {
            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                var _this = this;

                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                $17.swal({
                                    title: '刪除確認？',
                                    text: "確認刪除此客戶",
                                    type: 'warning'
                                }, (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                                    return _regenerator2.default.wrap(function _callee$(_context) {
                                        while (1) {
                                            switch (_context.prev = _context.next) {
                                                case 0:
                                                    _context.next = 2;
                                                    return _this.$store.dispatch('webadmin/crm/deleteMember', {
                                                        'memberId': _this.member,
                                                        'successCallBack': _this.successCallBack,
                                                        'failCallBack': _this.failCallBack
                                                    });

                                                case 2:
                                                case 'end':
                                                    return _context.stop();
                                            }
                                        }
                                    }, _callee, _this);
                                })));

                            case 1:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function deleteMember() {
                return _ref.apply(this, arguments);
            }

            return deleteMember;
        }(),
        showAdmissionModal: function showAdmissionModal() {
            var _this2 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
                var contracts;
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _this2.$store.commit('webadmin/admission/RESET_MEMBER_ADMISSION');
                                $.blockUI();
                                _context3.next = 4;
                                return _this2.$store.dispatch('webadmin/crm/getMemberStatus', _this2.member);

                            case 4:
                                _context3.next = 6;
                                return _this2.$store.dispatch('webadmin/admission/getUnLeavedRecord', _this2.member);

                            case 6:
                                _context3.next = 8;
                                return _this2.$store.dispatch('webadmin/admission/getContracts', _this2.member);

                            case 8:
                                $.unblockUI();

                                if (!(!_this2.unLeaved.id && _this2.customerContracts.length <= 0)) {
                                    _context3.next = 12;
                                    break;
                                }

                                _this2.$store.dispatch('webadmin/admission/alertNotAdmissionContract');
                                return _context3.abrupt('return');

                            case 12:
                                if (!_this2.unLeaved.id) {
                                    _context3.next = 15;
                                    break;
                                }

                                $('#out-admission-modal').modal('show');
                                return _context3.abrupt('return');

                            case 15:
                                contracts = _this2.$store.state.webadmin.admission.memberContracts;

                                _this2.$store.commit('webadmin/admission/SET_SELECTED_MEMBER_CONTRACT', contracts[0]);
                                _this2.$store.commit('webadmin/admission/UPDATE_SETTING_INFO', contracts[0].admission);
                                $('#enter-admission-modal').modal('show');

                            case 19:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this2);
            }))();
        },
        successCallBack: function successCallBack() {
            $17.swal({
                title: '刪除成功',
                type: 'success'
            });
            window.Event.$emit('deletedMember');
        },
        failCallBack: function failCallBack() {
            $17.swal({
                title: '刪除失敗',
                type: 'error'
            });
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        canAdmission: function canAdmission(state) {
            return state.webadmin.configure.webFunctions.WebadminCustomerAdmission;
        },
        deleteMemberRight: function deleteMemberRight(state) {
            return state.webadmin.configure.webFunctions.WebadminMemberStudioDelete;
        },
        isBranch: function isBranch(state) {
            return state.webadmin.configure.isBranch;
        },
        orderEdit: function orderEdit(state) {
            return state.webadmin.configure.webFunctions.WebadminOrderEdit;
        },
        tagIndex: function tagIndex(state) {
            return state.webadmin.configure.webFunctions.WebadminTagIndex;
        },
        unLeaved: function unLeaved(state) {
            return state.webadmin.admission.unLeavedRecord;
        },
        customerContracts: function customerContracts(state) {
            return state.webadmin.admission.memberContracts;
        }
    }), {
        showAdmission: function showAdmission() {
            return this.isBranch && this.canAdmission;
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div id=\"rightSideBar\" class=\"\" _v-51328cbe=\"\">\n    <div class=\"row\" _v-51328cbe=\"\">\n        <div class=\"col-xs-12\" _v-51328cbe=\"\">\n            <button type=\"button\" v-if=\"orderEdit\" class=\"btn btn-default btn-block right-btn btn--blue\" @click=\"openOperateOrder\" _v-51328cbe=\"\">\n                <i class=\"fa fa-shopping-cart\" aria-hidden=\"true\" _v-51328cbe=\"\"></i>新增訂單\n            </button>\n        </div>\n        <div class=\"col-xs-12\" _v-51328cbe=\"\">\n            <button type=\"button\" v-if=\"tagIndex\" class=\"btn btn-default right-btn btn-block btn--blue\" @click=\"editTagModal\" _v-51328cbe=\"\">\n                <i class=\"fa fa-tags\" aria-hidden=\"true\" _v-51328cbe=\"\"></i>標籤\n            </button>\n        </div>\n        <div v-show=\"showAdmission\" class=\"col-xs-12\" _v-51328cbe=\"\">\n            <button type=\"button\" class=\"btn btn-default right-btn btn-block btn--blue\" @click=\"showAdmissionModal\" _v-51328cbe=\"\">\n                <i class=\"fa fa-sign-in\" aria-hidden=\"true\" _v-51328cbe=\"\"></i>入/出場\n            </button>\n        </div>\n        <!--\n        <div class=\"col-xs-12 bottom-up\">\n            <button type=\"button\" v-if=\"deleteMemberRight\" class=\"btn btn-block btn-hide\" @click=\"deleteMember\">\n                <span>刪除此客戶</span>\n            </button>\n        </div>\n        -->\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 3, stdin */\n.right-btn[_v-51328cbe] {\n  margin-top: 10px; }\n\n/* line 11, stdin */\n.fa[_v-51328cbe] {\n  padding-right: 10px; }\n\n/* line 14, stdin */\n.btn.btn-hide.btn-block[_v-51328cbe] {\n  background-color: #EEE;\n  border: none; }\n  /* line 18, stdin */\n  .btn.btn-hide.btn-block[_v-51328cbe]:hover {\n    color: red;\n    box-shadow: none; }\n\n@media (min-width: 989px) {\n  /* line 24, stdin */\n  .bottom-up[_v-51328cbe] {\n    position: absolute;\n    bottom: 5px; } }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-51328cbe", module.exports)
  } else {
    hotAPI.update("_v-51328cbe", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1107:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.branch-color[_v-58012a87] {\n  color: #848484; }\n")
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require("vuex");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ["memberId"],
  data: function data() {
    return {
      ajaxing: false,
      ajaxingEdit: false,
      types: {},
      servants: {},
      salesmenData: {
        orderSalesmen: {},
        orderSalesmenFormat: {}
      },
      salsemanVisible: {},
      modelId: 'servant',
      customerServantTypeId: null
    };
  },
  watch: {
    memberId: function memberId(val) {
      this.fetchMemberServants();
    },
    ACTIVE_STUDIO_ID: function ACTIVE_STUDIO_ID(val) {
      if (val > 0) {
        this.getServantVisible();
        this.fetchMemberServants();
      }
    }
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)("webadmin/configure", ["ACTIVE_STUDIO_ID", "ACTIVE_BRANCH_ID"]), (0, _vuex.mapState)({
    memberServantEdit: function memberServantEdit(state) {
      return state.webadmin.configure.webFunctions.WebadminMemberServantEdit;
    }
  }), {
    activeSalsemanVisible: function activeSalsemanVisible() {
      if (!this.salsemanVisible[this.customerServantTypeId]) {
        return [];
      }
      return this.salsemanVisible[this.customerServantTypeId];
    },
    typeString: function typeString() {
      return this.types[this.customerServantTypeId] ? this.types[this.customerServantTypeId]["name"] : '';
    }
  }),
  methods: {
    fetchMemberServants: function fetchMemberServants() {
      var _this = this;

      if (!this.memberId || !this.ACTIVE_STUDIO_ID) {
        return;
      }
      this.ajaxing = true;
      this.$http.post("/adminapi/servant/studio/" + this.ACTIVE_STUDIO_ID + "/member/" + this.memberId).then(function (response) {
        _this.types = response.data.types;
        _this.servants = response.data.servants;

        _this.ajaxing = false;
      }, function (response) {
        _this.ajaxing = false;
        $17.swal({
          title: "取得會員服務人員錯誤",
          type: "error",
          showCancelButton: false,
          showLoaderOnConfirm: true
        });
        return false;
      });
    },
    editServant: function editServant(customerServantTypeId, editId) {
      var _this2 = this;

      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.customerServantTypeId = customerServantTypeId;
                _context.next = 3;
                return _this2.getEditServant(editId);

              case 3:
                $("#" + _this2.modelId).modal("show");

                $('#crm').animate({ scrollTop: 0 }, "fast");

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    checkExist: function checkExist(servant, i) {
      if (typeof servant["level_" + i + "_servant"] == "undefined") {
        return false;
      }

      return true;
    },
    checkVisible: function checkVisible(customerServantTypeId, i) {
      if (!this.salsemanVisible[customerServantTypeId]["level_" + i + "_visible"]) {
        return false;
      }

      return true;
    },
    getServantVisible: function getServantVisible() {
      var _this3 = this;

      if (!this.ACTIVE_STUDIO_ID) {
        return;
      }
      this.$http.post("/adminapi/servant/salesperson-visible", {
        studio_id: this.ACTIVE_STUDIO_ID
      }).then(function (response) {
        _this3.salsemanVisible = response.data;
      });
    },
    getEditServant: function getEditServant(editId) {
      var _this4 = this;

      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:

                _this4.ajaxingEdit = true;
                _context2.next = 3;
                return _this4.$http.get("/adminapi/servant/edit/" + editId).then(function (response) {
                  _this4.salesmenData = response.data;
                  _this4.ajaxingEdit = false;
                }, function (response) {
                  _this4.ajaxingEdit = false;
                  $17.swal({
                    title: "取得目前會員服務人員錯誤",
                    type: "error",
                    showCancelButton: false,
                    showLoaderOnConfirm: true
                  });
                  return false;
                });

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    }
  },
  created: function created() {},
  mounted: function mounted() {
    this.fetchMemberServants();
    this.getServantVisible();
  },
  destroyed: function destroyed() {}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-58012a87=\"\">\n  <v-spinner :ajaxing=\"ajaxing\" id=\"v-spinner\" _v-58012a87=\"\">\n  <div v-show=\"!ajaxing\" _v-58012a87=\"\">\n    <content-card v-for=\"(servant, id) in servants\" :key=\"id\" :show-footer=\"false\" _v-58012a87=\"\">\n      <div slot=\"head\" _v-58012a87=\"\">\n        <div class=\"header row p-top-5\" _v-58012a87=\"\">\n          <div class=\"col-xs-6 text-left p-left-30\" _v-58012a87=\"\">\n            <h5 _v-58012a87=\"\">\n              {{ types[id][\"name\"] }}\n            </h5>\n          </div>\n          <div class=\"col-xs-6 text-right show-effective p-right-30\" _v-58012a87=\"\">\n            <a class=\"btn btn--primary\" v-show=\"!ajaxingEdit &amp;&amp; memberServantEdit\" @click=\"editServant(id,servant.id)\" _v-58012a87=\"\"> \n              設定 \n            </a>\n            <v-spinner-button :ajaxing=\"ajaxingEdit\" _v-58012a87=\"\"></v-spinner-button>\n          </div>\n        </div>\n      </div>\n      <div slot=\"body\" _v-58012a87=\"\">\n        <div style=\"margin: 20px\" class=\"text-left\" v-for=\"i in 6\" v-if=\"checkExist(servant, i) &amp;&amp; checkVisible(id,i)\" _v-58012a87=\"\">\n          <div class=\"m-bottom-10\" _v-58012a87=\"\">\n            <label class=\"m-right-10\" _v-58012a87=\"\">\n              {{ types[id][\"name\"] }} {{ i }} :\n              {{\n                servant[\"level_\" + i + \"_servant\"]\n                  ? servant[\"level_\" + i + \"_servant\"][\"member_name\"]\n                  : \"\"\n              }}\n              <span class=\"branch-color\" _v-58012a87=\"\">\n                {{\n                  servant[\"level_\" + i + \"_servant\"]\n                    ? \"(\" +\n                      servant[\"level_\" + i + \"_servant\"][\"member_branch\"] +\n                      \")\"\n                    : \"\"\n                }}\n              </span>\n            </label>\n          </div>\n        </div>\n      </div>\n    </content-card>\n  </div>\n  <webadmin-salseman-order-setting :order-salesmen=\"salesmenData.orderSalesmen\" :salseman-visible=\"activeSalsemanVisible\" :model-id=\"modelId\" :customer-servant-type-id=\"customerServantTypeId\" servant-operation-type=\"studio-member\" :type-string=\"typeString\" @refresh-salesmen-list=\"fetchMemberServants\" _v-58012a87=\"\"></webadmin-salseman-order-setting>\n</v-spinner></div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.branch-color[_v-58012a87] {\n  color: #848484; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-58012a87", module.exports)
  } else {
    hotAPI.update("_v-58012a87", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1108:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.booking[_v-097e7abc] {\n  border: 10px;\n  border-bottom: solid;\n  border-bottom-width: thin;\n  border-bottom-color: #e6e6e6;\n  padding: 10px; }\n\n/* line 10, stdin */\n.booking[_v-097e7abc]:nth-last-child(1) {\n  border-bottom: none; }\n\n/* line 14, stdin */\n.padding-left[_v-097e7abc] {\n  padding-left: 80px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        memberId: {},
        isShowMore: {
            type: Function
        }
    },
    data: function data() {
        return {
            startAjax: false,
            showBtn: false,
            upcomingData: [],
            upcoming: [],
            moreText: '<i class="fa fa-plus"></i> 顯示全部',
            lessText: '<i class="fa fa-minus"></i> 顯示全部'
        };
    },
    methods: {
        fetchUpcoming: function fetchUpcoming(memberId) {
            var _this = this;

            this.startAjax = true;
            this.$http.get('/adminapi/upcoming-booking/' + memberId).then(function (response) {
                _this.startAjax = false;
                _this.upcoming = response.body;
                _this.upcomingData = _this.upcoming.slice(0, 3);
                _this.isShowMore && _this.isShowMore(_this.upcoming.length > 3);
            }, function (response) {
                _this.startAjax = false;
            });
        },
        fetchShowMore: function fetchShowMore(value) {
            if (value) {
                this.upcomingData = this.upcoming;
            } else {
                this.upcomingData = this.upcoming.slice(0, 3);
            }
        }
    },
    created: function created() {
        var _this2 = this;

        window.Event.$on('fetchUpcoming', function (memberId) {
            _this2.fetchUpcoming(memberId);
        });
        window.Event.$on('fetchShowMore', function (value) {
            _this2.fetchShowMore(value);
        });
    },
    mounted: function mounted() {
        if (!this.memberId) return;
        this.fetchUpcoming(this.memberId);
    },
    destroyed: function destroyed() {
        window.Event.$off('fetchUpcoming');
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-097e7abc=\"\">\n    <v-spinner :ajaxing=\"startAjax\" id=\"v-spinner\" _v-097e7abc=\"\">\n    </v-spinner>\n    <div v-show=\"!startAjax\" _v-097e7abc=\"\">\n        <div class=\"booking show-effective\" v-for=\"detail in upcomingData\" _v-097e7abc=\"\">\n            <table _v-097e7abc=\"\">\n                <tbody _v-097e7abc=\"\">\n                <tr _v-097e7abc=\"\">\n                    <td _v-097e7abc=\"\">{{detail.date}}</td>\n                    <td class=\"padding-left\" _v-097e7abc=\"\">{{detail.name}}</td>\n                </tr>\n                <tr _v-097e7abc=\"\">\n                    <td _v-097e7abc=\"\">{{detail.start_time}}</td>\n                    <td class=\"padding-left\" _v-097e7abc=\"\">{{detail.servcie_provider_name}}</td>\n                </tr>\n                </tbody>\n            </table>\n        </div>\n        <div style=\"margin: 15px;font-size: 15px;color: #898989;\" v-if=\"upcomingData.length == 0\" _v-097e7abc=\"\">\n            暫無內容\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.booking[_v-097e7abc] {\n  border: 10px;\n  border-bottom: solid;\n  border-bottom-width: thin;\n  border-bottom-color: #e6e6e6;\n  padding: 10px; }\n\n/* line 10, stdin */\n.booking[_v-097e7abc]:nth-last-child(1) {\n  border-bottom: none; }\n\n/* line 14, stdin */\n.padding-left[_v-097e7abc] {\n  padding-left: 80px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-097e7abc", module.exports)
  } else {
    hotAPI.update("_v-097e7abc", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1109:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n#data tbody > tr:last-child > td[_v-51bf64e2] {\n  border-top: 0; }\n\n/* line 6, stdin */\n.add-border[_v-51bf64e2] {\n  border-top: 1px solid #ddd; }\n\n/* line 10, stdin */\nthead[_v-51bf64e2] {\n  background-color: #EEE; }\n\n/* line 14, stdin */\n.onwer-txt[_v-51bf64e2] {\n  color: #aaa; }\n\n/* line 18, stdin */\n.expired[_v-51bf64e2] {\n  color: red;\n  margin: 0.5em 0; }\n\n/* line 22, stdin */\n.colorGrey[_v-51bf64e2] {\n  color: #878787; }\n\n/* line 25, stdin */\n.colorRed[_v-51bf64e2] {\n  color: red; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['mainContract', 'memberId'],
    mounted: function mounted() {
        this.preloadModalData(this.mainContract.main);
    },

    methods: {
        preloadModalData: function preloadModalData(main) {
            this.$store.commit('webadmin/crm/CRM_CHANGE_CONTRACT', main);
        },
        showModal: function showModal(main) {
            this.$store.commit('webadmin/crm/CRM_CHANGE_CONTRACT', main);
            $('#modal-contract').modal('show');
        },
        showModalTime: function showModalTime(main) {
            this.$store.commit('webadmin/crm/CRM_CHANGE_CONTRACT', main);
            $('#modalTime-contract').modal('show');
        },
        showModalPoint: function showModalPoint(main) {
            this.$store.commit('webadmin/crm/CRM_CHANGE_CONTRACT', main);
            $('#modalPoint-contract').modal('show');
        },
        showSharedMemberModal: function showSharedMemberModal(main) {
            window.Event.$emit('openSharedMemberModal', main);
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        canShareContract: function canShareContract(state) {
            return state.webadmin.configure.webFunctions.WebadminMemberStudioShareContract;
        },
        contractEditable: function contractEditable(state) {
            return state.webadmin.configure.webFunctions.WebadminMemberStudioContractEdit;
        }
    }), {
        statusClass: function statusClass() {
            var statusClass = {
                1: '',
                2: 'colorRed',
                3: 'colorGrey'
            };
            return statusClass[this.mainContract.main.status];
        },
        endTime: function endTime() {
            if (!this.mainContract.main.expiration || this.mainContract.main.expiration.endTime == '-') {
                return '';
            }
            return this.mainContract.main.expiration.endTime;
        },
        remainValueDisplayText: function remainValueDisplayText() {
            if (this.mainContract.main.contractType == 1 && !this.endTime) {
                return '無限';
            }
            return this.mainContract.main.totalValue + this.mainContract.main.contractValueName;
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n    <div _v-51bf64e2=\"\">\n        <table class=\"table\" _v-51bf64e2=\"\">\n            <thead _v-51bf64e2=\"\">\n                <tr _v-51bf64e2=\"\">\n                    <td _v-51bf64e2=\"\">\n                        {{mainContract.main.name}}\n                    </td>\n                    <td class=\"text-right\" _v-51bf64e2=\"\">\n                        <span class=\"colorGrey\" _v-51bf64e2=\"\">{{mainContract.main.titleOfContractValue}}</span>\n                        <button class=\"btn btn-primary btn-xs\" @click=\"showModal(mainContract.main)\" _v-51bf64e2=\"\">\n                            <i class=\"fa fa-pencil\" _v-51bf64e2=\"\"></i>\n                        </button>\n                    </td>\n                </tr>\n            </thead>\n            <tbody _v-51bf64e2=\"\">\n                <tr v-if=\"mainContract.main.contractType != 4\" _v-51bf64e2=\"\">\n                    <th _v-51bf64e2=\"\">剩餘{{mainContract.main.titleOfContractValue}}</th>\n                    <td class=\"text-right\" _v-51bf64e2=\"\">\n                        <div id=\"\" _v-51bf64e2=\"\">\n                            <span _v-51bf64e2=\"\">\n\t\t\t\t\t            {{remainValueDisplayText}}\n\t\t\t\t\t        </span>\n                        </div>\n                    </td>\n                </tr>\n                <tr _v-51bf64e2=\"\">\n                    <th _v-51bf64e2=\"\">有效期間</th>\n                    <td class=\"text-right\" _v-51bf64e2=\"\">\n                        {{mainContract.main.expiration.startTime}}~{{mainContract.main.expiration.endTime}}\n                        <div v-if=\"mainContract.main.expired\" class=\"expired\" _v-51bf64e2=\"\">已過期</div>\n                    </td>\n                </tr>\n                <tr _v-51bf64e2=\"\">\n                    <th _v-51bf64e2=\"\">狀態</th>\n                    <td class=\"text-right\" _v-51bf64e2=\"\">\n                        <div :class=\"statusClass\" _v-51bf64e2=\"\">\n                            {{mainContract.main.showStatus}}\n                            <span class=\"p-left-5\" v-show=\"mainContract.main.status==3\" _v-51bf64e2=\"\">\n                                {{mainContract.main.pauseTime.pauseStartTime}}~{{mainContract.main.pauseTime.pauseEndTime}}\n                            </span>\n                        </div>\n                    </td>\n                </tr>\n                <tr _v-51bf64e2=\"\">\n                    <td v-if=\"mainContract.main.contractType != 4\" _v-51bf64e2=\"\">\n                        <button v-if=\"!mainContract.main.isShared &amp;&amp; canShareContract\" type=\"button\" class=\"btn btn-info btn-sm btn--inverse\" @click.prevent=\"showSharedMemberModal(mainContract.main)\" _v-51bf64e2=\"\"><i class=\"fa fa-users\" _v-51bf64e2=\"\"></i> 分享方案\n                        </button>\n                        <span v-if=\"mainContract.main.isShared\" _v-51bf64e2=\"\">\n                            {{ mainContract.main.ownerName }} <span class=\"onwer-txt\" _v-51bf64e2=\"\">是擁有人</span>\n                        </span>\n                    </td>\n                    <td v-else=\"\" _v-51bf64e2=\"\"></td>\n                    <td class=\"text-right\" _v-51bf64e2=\"\">\n                        <v-member-contract-record-btn :member-contract-id=\"mainContract.main.memberContractId\" _v-51bf64e2=\"\">\n                        </v-member-contract-record-btn>\n                    </td>\n                </tr>\n            </tbody>\n        </table>\n        <div _v-51bf64e2=\"\">\n            <v-member-contract-record-table :member-contract-id=\"mainContract.main.memberContractId\" :show-users=\"true\" _v-51bf64e2=\"\"></v-member-contract-record-table>\n        </div>\n    </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n#data tbody > tr:last-child > td[_v-51bf64e2] {\n  border-top: 0; }\n\n/* line 6, stdin */\n.add-border[_v-51bf64e2] {\n  border-top: 1px solid #ddd; }\n\n/* line 10, stdin */\nthead[_v-51bf64e2] {\n  background-color: #EEE; }\n\n/* line 14, stdin */\n.onwer-txt[_v-51bf64e2] {\n  color: #aaa; }\n\n/* line 18, stdin */\n.expired[_v-51bf64e2] {\n  color: red;\n  margin: 0.5em 0; }\n\n/* line 22, stdin */\n.colorGrey[_v-51bf64e2] {\n  color: #878787; }\n\n/* line 25, stdin */\n.colorRed[_v-51bf64e2] {\n  color: red; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-51bf64e2", module.exports)
  } else {
    hotAPI.update("_v-51bf64e2", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1110:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n#data tbody > tr:last-child > td[_v-be372658] {\n  border-top: 0; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        memberId: {},
        showEffective: {},
        isShowMore: {
            type: Function
        }
    },
    data: function data() {
        return {
            isNegative: 'color-danger',
            validPlanData: []
        };
    },
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('webadmin/crm', ['getMember']), {
        fetchShowMore: function fetchShowMore(value) {
            var spliceData = JSON.parse((0, _stringify2.default)(this.filterMainContracts)).slice(0, 3);
            if (value) {
                this.validPlanData = this.filterMainContracts;
            } else {
                this.validPlanData = spliceData;
            };
        }
    }),
    mounted: function mounted() {
        var _this = this;

        window.Event.$on('fetchMemberContract', function (memberId) {
            _this.ajaxing = true;
            var vm = _this;
            _this.$store.dispatch('webadmin/crm/fetchMemberContract', memberId).then(function () {
                vm.ajaxing = false;
            });
        });
        window.Event.$on('fetchValidPlanShowMore', function (value) {
            _this.fetchShowMore(value);
        });
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        mainContracts: function mainContracts(state) {
            return state.webadmin.crm.mainContracts;
        }
    }), {
        ajaxing: {
            get: function get() {
                if (!this.$store.state.webadmin.configure.ajaxing.validPlan) {
                    this.ajaxing = false;
                }
                return this.$store.state.webadmin.configure.ajaxing.validPlan;
            },
            set: function set(value) {
                this.$store.commit('webadmin/configure/CHANGE_AJAXING', { key: 'validPlan', value: value });
            }
        },
        filterMainContracts: {
            get: function get() {
                var _this2 = this;

                if (!this.mainContracts && this.mainContracts.length == 0) {
                    return [];
                }
                return this.mainContracts.filter(function (mainContract) {
                    return _this2.showEffective || !_this2.showEffective && !mainContract.main.invalid && !mainContract.main.expired && mainContract.main.status != 2;
                });
            }
        }
    }),
    watch: {
        filterMainContracts: function filterMainContracts(newVal) {
            if (newVal) {
                this.isShowMore && this.isShowMore(newVal.length > 3);
                this.fetchShowMore(false);
            };
        }
    },
    destroyed: function destroyed() {
        window.Event.$off('fetchMemberContract');
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div style=\"margin: 17px 12px;\" _v-be372658=\"\">\n    <v-spinner :ajaxing=\"ajaxing\" _v-be372658=\"\">\n    </v-spinner>\n    <div v-show=\"!ajaxing\" _v-be372658=\"\">\n        <div v-for=\"(value, key)  in validPlanData\" :key=\"value.main.memberContractId\" _v-be372658=\"\">\n            <valid-plan-detail-records :main-contract=\"value\" :member-id=\"memberId\" _v-be372658=\"\"></valid-plan-detail-records>\n        </div>\n        <div style=\"font-size: 15px;color: #898989;\" v-if=\"validPlanData.length == 0\" _v-be372658=\"\">\n            暫無內容\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n#data tbody > tr:last-child > td[_v-be372658] {\n  border-top: 0; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-be372658", module.exports)
  } else {
    hotAPI.update("_v-be372658", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/json/stringify":48,"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1111:[function(require,module,exports){
'use strict';

require('./home');
require('./booking');
require('./auto_pay_plan');
require('./member_bonus');
require('./order');
require('./info_record');
require('./dashboard');

},{"./auto_pay_plan":1070,"./booking":1079,"./dashboard":1084,"./home":1098,"./info_record":1114,"./member_bonus":1117,"./order":1120}],1112:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\ntextarea[_v-ad056462] {\n  min-height: 30vh; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['memberId', 'studioId'],
    data: function data() {
        return {
            postData: {
                content: ''
            },
            infoRecordId: null,
            ajaxing: {
                submit: false,
                file: false
            },
            fileList: [],
            uploaded: false
        };
    },
    created: function created() {
        var _this = this;

        window.Event.$on('info-record-open-create', function (data) {
            _this.resetData();
            // $('#info-record-create-modal').modal('show');
            _this.saveRecord();
        });
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['isBranch']), (0, _vuex.mapState)({
        customer: function customer(state) {
            return state.webadmin.crm.member;
        },
        infoRecordDeleteSelf: function infoRecordDeleteSelf(state) {
            return state.webadmin.configure.webFunctions.WebadminInfoRecordDeleteSelf;
        },
        infoRecordDeleteAll: function infoRecordDeleteAll(state) {
            return state.webadmin.configure.webFunctions.WebadminInfoRecordDeleteAll;
        },
        infoRecordDownload: function infoRecordDownload(state) {
            return state.webadmin.configure.webFunctions.WebadminInfoRecordDownload;
        }
    }), {
        canDownload: function canDownload() {
            return !!this.infoRecordDownload;
        }
    }),
    methods: {
        resetData: function resetData() {
            this.postData.content = '';
            this.uploaded = false;
        },
        saveRecord: function saveRecord() {
            var _this2 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                var data;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                data = {
                                    // content:this.postData.content,
                                    customer_member_id: _this2.memberId,
                                    studio_id: _this2.studioId
                                };
                                _context.next = 3;
                                return _this2.$http.post('/adminapi/info_record/customer/', data).then(function (response) {
                                    // this.ajaxing.submit = false;
                                    _this2.infoRecordId = response.data.id;
                                    $('#info-record-create-modal').modal('show');
                                    window.Event.$emit('info-record-created', true);
                                }).catch(function (response) {
                                    // this.ajaxing.submit = false;
                                    $17.swal({
                                        title: '發生錯誤，請重新整理。',
                                        text: "",
                                        type: 'warning',
                                        showCancelButton: false
                                    });
                                });

                            case 3:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        updateNewContent: function updateNewContent() {
            var _this3 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                var data;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _this3.ajaxing.submit = true;
                                data = {
                                    content: _this3.postData.content
                                    // customer_member_id:this.memberId,
                                    // studio_id:this.studioId,
                                };
                                _context2.next = 4;
                                return _this3.$http.post('/adminapi/info_record/' + _this3.infoRecordId + '/customer/create', data).then(function (response) {
                                    _this3.ajaxing.submit = false;
                                    _this3.fileList = [];
                                    $17.swal({
                                        title: '儲存成功',
                                        text: "",
                                        type: 'success',
                                        showCancelButton: false
                                    });
                                    $('#info-record-create-modal').modal('hide');
                                    window.Event.$emit('info-record-refresh', true);
                                }).catch(function (response) {
                                    _this3.ajaxing.submit = false;
                                    $17.swal({
                                        title: '儲存失敗',
                                        text: response.data.message,
                                        type: 'warning',
                                        showCancelButton: false
                                    });
                                });

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        },
        changeFileAjaxing: function changeFileAjaxing(changeState) {
            this.ajaxing.file = changeState;
        },
        appendList: function appendList(para) {
            var id = para.id;
            this.fileList.unshift(para);
            this.uploaded = true;
        },
        deletedFileList: function deletedFileList(index) {
            this.fileList.splice(index, 1);
        },
        canDelete: function canDelete(createMemberId) {
            if (this.infoRecordDeleteAll) {
                return true;
            }
            if (this.userMemberId == createMemberId && this.infoRecordDeleteSelf) {
                return true;
            }
            return false;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal id=\"info-record-create-modal\" open-size=\"modal-md\" confirm-btn-text=\"確認\" no-cancel=\"\" no-footer=\"\" parallel-modal=\"\" _v-ad056462=\"\">\n    <h4 slot=\"title\" _v-ad056462=\"\">新增紀錄</h4>\n    <div slot=\"body\" _v-ad056462=\"\">\n        <v-spinner :ajaxing=\"ajaxing.submit\" _v-ad056462=\"\"></v-spinner>\n        <div class=\"form-horizontal\" v-show=\"!ajaxing.submit\" _v-ad056462=\"\">\n            <div class=\"form-group\" _v-ad056462=\"\">\n                <div class=\"col-sm-12\" _v-ad056462=\"\">\n                    <textarea name=\"\" id=\"\" placeholder=\"輸入文字...\" v-model=\"postData.content\" _v-ad056462=\"\"></textarea>\n                </div>\n            </div>\n        </div>\n        <div class=\"form-horizontal m-bottom-15\" v-show=\"!ajaxing.submit\" _v-ad056462=\"\">\n            <v-client-uploading :ajaxing=\"ajaxing.file\" _v-ad056462=\"\"></v-client-uploading>\n        </div>\n        <div class=\"form-horizontal m-bottom-15\" v-show=\"!ajaxing.submit\" v-for=\"(file,index) in fileList\" :key=\"index\" _v-ad056462=\"\"> \n            <v-client-file-item :id=\"file.id\" :name=\"file.name\" :down-url=\"file.downUrl\" :thumbnail=\"file.thumbnail\" :file-type=\"file.fileType\" icon=\"fa fa-file-text-o\" sub-url=\"info-record\" :can-delete=\"canDelete(file.member_id)\" @deleted=\"deletedFileList(index)\" _v-ad056462=\"\"></v-client-file-item>\n        </div>\n        <div class=\"form-horizontal\" v-show=\"!ajaxing.submit &amp;&amp;!ajaxing.file\" _v-ad056462=\"\">\n            <div class=\"form-group\" _v-ad056462=\"\">\n                <div class=\"col-xs-6\" _v-ad056462=\"\">\n                    <v-client-upload sub-url=\"info-record\" :group-id=\"studioId\" :relation-id=\"infoRecordId\" v-show=\"!ajaxing.file\" :can-download=\"canDownload\" @change-ajaxing=\"changeFileAjaxing\" @uploaded=\"appendList\" _v-ad056462=\"\"></v-client-upload>\n                </div>\n                <div class=\"col-xs-6 text-right\" _v-ad056462=\"\">\n                    <input type=\"text\" class=\"btn btn-primary\" value=\"確認\" @click=\"updateNewContent\" _v-ad056462=\"\">\n                </div>\n            </div>\n        </div>\n    </div>\n</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\ntextarea[_v-ad056462] {\n  min-height: 30vh; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-ad056462", module.exports)
  } else {
    hotAPI.update("_v-ad056462", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1113:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\ntextarea[_v-50dcb69d] {\n  min-height: 30vh; }\n\n/* line 5, stdin */\n.btn[_v-50dcb69d] {\n  width: 100px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['memberId', 'studioId'],
    data: function data() {
        return {
            postData: {
                content: ''
            },
            infoRecordId: null,
            ownerId: null,
            ajaxing: {
                submit: false,
                file: false
            },
            fileList: [],
            uploaded: false
        };
    },
    created: function created() {
        var _this = this;

        window.Event.$on('info-record-open-edit', function (data) {
            _this.resetData();
            _this.infoRecordId = data.infoRecordId;
            _this.ownerId = data.ownerId;
            _this.postData.content = data.content;
            _this.fileList = data.files ? data.files : [];
            _this.uploaded = false;
            $('#info-record-edit-modal').modal('show');
        });
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['isBranch']), (0, _vuex.mapState)({
        userMemberId: function userMemberId(state) {
            return state.user_member_id;
        },
        customer: function customer(state) {
            return state.webadmin.crm.member;
        },
        infoRecordDeleteSelf: function infoRecordDeleteSelf(state) {
            return state.webadmin.configure.webFunctions.WebadminInfoRecordDeleteSelf;
        },
        infoRecordDeleteAll: function infoRecordDeleteAll(state) {
            return state.webadmin.configure.webFunctions.WebadminInfoRecordDeleteAll;
        },
        infoRecordDownload: function infoRecordDownload(state) {
            return state.webadmin.configure.webFunctions.WebadminInfoRecordDownload;
        }
    }), {
        canDownload: function canDownload() {
            return !!this.infoRecordDownload;
        }
    }),
    methods: {
        resetData: function resetData() {
            this.postData.content = '';
        },
        saveRecord: function saveRecord() {
            var _this2 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                var data;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                data = {
                                    content: _this2.postData.content,
                                    customer_member_id: _this2.memberId
                                };

                                _this2.ajaxing.submit = true;
                                _context.next = 4;
                                return _this2.$http.put('/adminapi/info_record/' + _this2.infoRecordId + '/customer', data).then(function (response) {
                                    _this2.ajaxing.submit = false;
                                    _this2.uploaded = true;
                                    $17.swal({
                                        title: '編輯成功',
                                        text: "",
                                        type: 'success',
                                        showCancelButton: false
                                    });
                                    $('#info-record-edit-modal').modal('hide');
                                    // window.Event.$emit('info-record-refresh',true);
                                }).catch(function (response) {
                                    _this2.ajaxing.submit = false;
                                    $17.swal({
                                        title: '編輯失敗',
                                        text: "",
                                        type: 'warning',
                                        showCancelButton: false
                                    });
                                });

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        deleteRecord: function deleteRecord() {
            window.Event.$emit('info-record-delete', this.infoRecordId);
        },
        canDelete: function canDelete(createMemberId) {
            if (this.infoRecordDeleteAll) {
                return true;
            }
            if (this.userMemberId == createMemberId && this.infoRecordDeleteSelf) {
                return true;
            }
            return false;
        },
        deletedFileList: function deletedFileList(index) {
            this.fileList.splice(index, 1);
            this.uploaded = true;
        },
        changeFileAjaxing: function changeFileAjaxing(changeState) {
            this.ajaxing.file = changeState;
        },
        appendList: function appendList(para) {
            var id = para.id;
            this.fileList.unshift(para);
            this.uploaded = true;
        },
        refresh: function refresh() {
            if (this.uploaded) {
                window.Event.$emit('info-record-refresh', true);
            }
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal id=\"info-record-edit-modal\" open-size=\"modal-md\" confirm-btn-text=\"儲存\" no-cancel=\"\" no-footer=\"\" parallel-modal=\"\" :close-modal-event=\"refresh\" _v-50dcb69d=\"\">\n    <h4 slot=\"title\" _v-50dcb69d=\"\">編輯紀錄</h4>\n    <div slot=\"body\" _v-50dcb69d=\"\">\n        <v-spinner :ajaxing=\"ajaxing.submit\" _v-50dcb69d=\"\"></v-spinner>\n        <div class=\"form-horizontal\" v-show=\"!ajaxing.submit\" _v-50dcb69d=\"\">\n            <div class=\"form-group\" _v-50dcb69d=\"\">\n                <div class=\"col-sm-12\" _v-50dcb69d=\"\">\n                    <textarea name=\"\" id=\"\" placeholder=\"輸入文字...\" v-model=\"postData.content\" _v-50dcb69d=\"\"></textarea>\n                </div>\n            </div>\n        </div>\n        <div class=\"form-horizontal m-bottom-15\" v-show=\"!ajaxing.submit\" _v-50dcb69d=\"\">\n            <v-client-uploading :ajaxing=\"ajaxing.file\" _v-50dcb69d=\"\"></v-client-uploading>\n        </div>\n        <div class=\"form-horizontal m-bottom-15\" v-show=\"!ajaxing.submit\" v-for=\"(file,index) in fileList\" :key=\"index\" _v-50dcb69d=\"\">\n            <v-client-file-item :id=\"file.id\" :name=\"file.name\" :down-url=\"file.downUrl\" :thumbnail=\"file.thumbnail\" :file-type=\"file.fileType\" icon=\"fa fa-file-text-o\" sub-url=\"info-record\" :can-download=\"canDownload\" :can-delete=\"canDelete(file.member_id)\" @deleted=\"deletedFileList(index)\" _v-50dcb69d=\"\"></v-client-file-item>\n        </div>\n        <div class=\"form-horizontal\" v-show=\"!ajaxing.submit\" _v-50dcb69d=\"\">\n            <div class=\"form-group\" _v-50dcb69d=\"\">\n                <div class=\"col-xs-6\" _v-50dcb69d=\"\">\n                    <v-client-upload sub-url=\"info-record\" :group-id=\"studioId\" :relation-id=\"infoRecordId\" v-show=\"!ajaxing.file\" @change-ajaxing=\"changeFileAjaxing\" @uploaded=\"appendList\" _v-50dcb69d=\"\"></v-client-upload>\n                </div>\n                <div class=\"col-xs-6 text-right\" _v-50dcb69d=\"\">\n                    <input type=\"text\" v-if=\"canDelete(ownerId) \" class=\"btn btn-danger\" value=\"刪除\" @click=\"deleteRecord\" _v-50dcb69d=\"\">\n                    <input type=\"text\" class=\"btn btn-primary\" value=\"確認\" @click=\"saveRecord\" _v-50dcb69d=\"\">\n                </div>\n            </div>\n        </div>\n    </div>\n</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\ntextarea[_v-50dcb69d] {\n  min-height: 30vh; }\n\n/* line 5, stdin */\n.btn[_v-50dcb69d] {\n  width: 100px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-50dcb69d", module.exports)
  } else {
    hotAPI.update("_v-50dcb69d", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1114:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _list = require('./list.vue');

var _list2 = _interopRequireDefault(_list);

var _create = require('./create.vue');

var _create2 = _interopRequireDefault(_create);

var _edit = require('./edit.vue');

var _edit2 = _interopRequireDefault(_edit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('info-record-list', _list2.default);
_vue2.default.component('info-record-create-modal', _create2.default);
_vue2.default.component('info-record-edit-modal', _edit2.default);

},{"./create.vue":1112,"./edit.vue":1113,"./list.vue":1115,"vue":792}],1115:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n#info-record-list[_v-41948f31] {\n  min-height: 100px; }\n\n/* line 5, stdin */\n.base-row[_v-41948f31] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between; }\n  /* line 8, stdin */\n  .base-row .action[_v-41948f31] {\n    color: #fff;\n    background-color: #878787;\n    padding-left: 5px;\n    padding-right: 5px;\n    font-size: 16px;\n    border-radius: 50%;\n    margin-top: 5px;\n    cursor: pointer; }\n\n/* line 19, stdin */\n.base-info[_v-41948f31] {\n  display: -ms-flexbox;\n  display: flex; }\n  /* line 21, stdin */\n  .base-info img[_v-41948f31] {\n    width: 40px;\n    border-radius: 50%;\n    margin-right: 5px; }\n\n/* line 27, stdin */\n.content-text[_v-41948f31] {\n  word-break: break-all;\n  padding-right: 30px;\n  margin-top: 10px;\n  white-space: pre-wrap; }\n\n/* line 33, stdin */\n.list-item[_v-41948f31] {\n  margin-top: 10px;\n  margin-bottom: 10px; }\n\n/* line 37, stdin */\n.edit-time[_v-41948f31] {\n  color: #A3A3A3;\n  margin-top: 2px; }\n\n/* line 41, stdin */\n.hr[_v-41948f31] {\n  margin-top: 10px;\n  margin-bottom: 10px; }\n  /* line 44, stdin */\n  .hr[_v-41948f31]:last-of-type {\n    display: none; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['memberId', 'studioId'],
    data: function data() {
        return {
            alert: '',
            allow_to_use: false,
            branch_ajaxing: false,
            credit_ajax: false,
            info_record_ajaxing: false,
            info_ajaxing: false,
            info_records: [],
            branches: [],
            branch_id: 0,
            selected_payload_id: '',
            plans: [],
            pageRows: 50,
            info_created_ajaxing: false,
            filterFile: false
        };
    },
    created: function created() {
        var _this = this;

        window.Event.$on('info-record-refresh', function () {
            _this.refresh();
        });
        window.Event.$on('info-record-delete', function (infoRecordId) {
            _this.deleteInfoRecord(infoRecordId);
        });

        window.Event.$on('info-record-created', function (infoRecordId) {
            _this.info_created_ajaxing = false;
        });
    },
    mounted: function mounted() {
        this.getInfoList();
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['branchId', 'isBranch', 'isSeventeen']), (0, _vuex.mapState)({
        userMemberId: function userMemberId(state) {
            return state.user_member_id;
        },
        infoRecordEditViewSelf: function infoRecordEditViewSelf(state) {
            return state.webadmin.configure.webFunctions.WebadminInfoRecordEditViewSelf;
        },
        infoRecordDeleteSelf: function infoRecordDeleteSelf(state) {
            return state.webadmin.configure.webFunctions.WebadminInfoRecordDeleteSelf;
        },
        infoRecordEditAll: function infoRecordEditAll(state) {
            return state.webadmin.configure.webFunctions.WebadminInfoRecordEditAll;
        },
        infoRecordDeleteAll: function infoRecordDeleteAll(state) {
            return state.webadmin.configure.webFunctions.WebadminInfoRecordDeleteAll;
        },
        infoRecordViewAll: function infoRecordViewAll(state) {
            return state.webadmin.configure.webFunctions.WebadminInfoRecordViewAll;
        },
        infoRecordDownload: function infoRecordDownload(state) {
            return state.webadmin.configure.webFunctions.WebadminInfoRecordDownload;
        }
    }), {
        pages: function pages() {
            return parseInt(this.info_records.length / this.pageRows);
        },
        showMore: function showMore() {
            return this.info_records.length % this.pageRows == 0 && this.info_records.length != 0;
        },
        canDownload: function canDownload() {
            return !!this.infoRecordDownload;
        },
        filteredInfoRecords: function filteredInfoRecords() {
            if (this.filterFile) {
                return this.info_records.filter(function (record) {
                    return record.files && (0, _keys2.default)(record.files).length > 0;
                });
            }

            return this.info_records;
        }
    }),
    watch: {},
    methods: {
        editPlanModal: function editPlanModal(planId) {
            window.Event.$emit('info-record-view', { planId: planId, allPayments: this.payments, allowToUse: this.allow_to_use });
        },
        loadMore: function loadMore() {
            this.getInfoList(2);
        },
        refresh: function refresh() {
            this.getInfoList(1);
        },
        getInfoList: function getInfoList(actionType) {
            var _this2 = this;

            var pages = this.pages;

            if (actionType == 2) {
                pages = this.pages + 1;
            }

            this.info_record_ajaxing = true;
            this.$http.get('/adminapi/info_record/customer/' + this.memberId + '?pages=' + this.pages).then(function (response) {
                if (actionType == 1) {
                    _this2.info_records = [];
                }
                _this2.info_records = _this2.info_records.concat(response.data);
                _this2.info_record_ajaxing = false;
            }).catch(function (response) {
                $17.swal({
                    title: '取得列表失敗',
                    type: 'warning',
                    showCancelButton: false
                });
                _this2.info_record_ajaxing = false;
            });
        },
        createInfoRecord: function createInfoRecord() {
            window.Event.$emit('info-record-open-create');
            this.info_created_ajaxing = true;
        },
        deleteInfoRecord: function deleteInfoRecord(infoRecordId) {
            var vm = this;
            $17.swal({
                title: '確認刪除？',
                text: '',
                type: 'warning',
                confirmButtonText: '確定'
            }, function () {
                $.blockUI();

                vm.$http.delete('/adminapi/info_record/' + infoRecordId + '/customer').then(function (response) {
                    $17.swal({
                        title: '刪除成功',
                        type: 'success',
                        showCancelButton: false
                    });
                    vm.refresh();
                    $('#info-record-edit-modal').modal('hide');
                    $.unblockUI();
                }).catch(function (response) {
                    $17.swal({
                        title: '刪除失敗，請重新整理',
                        text: response.data.hasOwnProperty('message') ? response.data.message : '',
                        type: 'warning',
                        showCancelButton: false
                    });
                    $.unblockUI();
                });
            });
        },
        editInfoRecord: function editInfoRecord(infoRecordId, content, ownerId, files) {
            window.Event.$emit('info-record-open-edit', { 'infoRecordId': infoRecordId, 'content': content, 'ownerId': ownerId, 'files': files });
        },
        canEdit: function canEdit(createMemberId) {

            if (this.infoRecordEditAll) {
                return true;
            }
            if (this.userMemberId == createMemberId && this.infoRecordEditViewSelf) {
                return true;
            }
            return false;
        },
        canDelete: function canDelete(createMemberId) {

            if (this.infoRecordDeleteAll) {
                return true;
            }
            if (this.userMemberId == createMemberId && this.infoRecordDeleteSelf) {
                return true;
            }
            return false;
        },
        canView: function canView(createMemberId) {

            if (this.infoRecordViewAll) {
                return true;
            }
            if (this.userMemberId == createMemberId && this.infoRecordEditViewSelf) {
                return true;
            }
            return false;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div id=\"info-record-list\" _v-41948f31=\"\">\n    <v-spinner :ajaxing=\"info_record_ajaxing\" _v-41948f31=\"\"></v-spinner>\n    <div v-if=\"!info_record_ajaxing\" _v-41948f31=\"\">\n        <div v-show=\"alert!==''&amp;&amp;!allow_to_use\" class=\"alert alert-danger m-top-5\" role=\"alert\" _v-41948f31=\"\">\n            <button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-label=\"Close\" _v-41948f31=\"\">\n                <span aria-hidden=\"true\" _v-41948f31=\"\">×</span>\n            </button>\n            {{alert}}\n        </div>\n        <div _v-41948f31=\"\">\n            <div class=\"row m-bottom-20\" _v-41948f31=\"\">\n                <div class=\"col-xs-6  m-top-10 m-bottom-5\" _v-41948f31=\"\">\n                    <button class=\"btn btn-success\" v-show=\"!info_created_ajaxing\" @click.prevent=\"createInfoRecord\" _v-41948f31=\"\">新增</button>\n                    <v-spinner-button :ajaxing=\"info_created_ajaxing\" fa-size=\"fa-2x\" _v-41948f31=\"\"></v-spinner-button>\n                </div>\n                <div class=\"col-xs-6  m-top-10 m-bottom-5 text-right\" _v-41948f31=\"\">\n                    <label for=\"only-show-file\" _v-41948f31=\"\">\n                        <input type=\"checkbox\" name=\"\" id=\"only-show-file\" v-model=\"filterFile\" :true-value=\"1\" :false-value=\"0\" _v-41948f31=\"\">\n                        <small _v-41948f31=\"\">只顯示有檔案</small>\n                    </label>\n                </div>\n            </div>\n            <template v-for=\"info_record in filteredInfoRecords\" v-if=\"canView(info_record.member_id)\">\n            <div class=\"row\" _v-41948f31=\"\">\n                <div class=\"col-xs-12\" _v-41948f31=\"\">\n                    <div _v-41948f31=\"\">\n                        <div class=\"list-item\" _v-41948f31=\"\">\n                            <div class=\"base-row\" _v-41948f31=\"\">\n                                <div class=\"base-info\" _v-41948f31=\"\">\n                                    <div _v-41948f31=\"\">\n                                        <img :src=\"info_record.member_pic\" class=\"\" alt=\"\" onerror=\"this.src='/images/default.png'\" _v-41948f31=\"\">\n                                    </div>\n                                    <div _v-41948f31=\"\">\n                                        <div _v-41948f31=\"\">{{ info_record.member_name }}</div>\n                                        <div class=\"edit-time\" _v-41948f31=\"\">{{ info_record.updated_at }}</div>\n                                    </div>\n                                </div>\n                                <div v-if=\"canDelete(info_record.member_id) || canEdit(info_record.member_id)\" _v-41948f31=\"\">\n                                    <div class=\"action dropdown\" _v-41948f31=\"\">\n                                        <i class=\"fa fa-ellipsis-h\" aria-hidden=\"true\" type=\"button\" id=\"dropdownMenu1\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"true\" _v-41948f31=\"\">\n                                        </i>\n                                        <ul class=\"dropdown-menu\" aria-labelledby=\"dropdownMenu1\" _v-41948f31=\"\">\n                                            <li v-if=\"canDelete(info_record.member_id)\" _v-41948f31=\"\"><a href=\"#\" @click.prevent=\"deleteInfoRecord(info_record.id)\" _v-41948f31=\"\">刪除</a></li>\n                                            <li v-if=\"canEdit(info_record.member_id)\" _v-41948f31=\"\"><a href=\"#\" @click=\"editInfoRecord(info_record.id,info_record.content,info_record.member_id,info_record.files)\" _v-41948f31=\"\">編輯</a></li>\n                                        </ul>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"content-text\" _v-41948f31=\"\">{{info_record.content}}</div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"row\" _v-41948f31=\"\">\n                <div class=\"col-xs-12\" _v-41948f31=\"\">\n                    <v-client-file-item v-for=\"file in info_record.files\" :id=\"file.id\" :name=\"file.name\" :down-url=\"file.downUrl\" :thumbnail=\"file.thumbnail\" :file-type=\"file.fileType\" icon=\"fa fa-file-text-o\" sub-url=\"info-record\" display-type=\"thumbnail\" :can-download=\"canDownload\" _v-41948f31=\"\"></v-client-file-item>\n                </div>\n            </div>\n            <hr class=\"hr\" _v-41948f31=\"\">\n            </template>\n            <div class=\"row\" v-show=\"showMore\" _v-41948f31=\"\">\n                <div class=\"col-xs-12 text-center\" _v-41948f31=\"\">\n                    <div class=\"btn btn-default btn--inverse m-top-20\" @click=\"loadMore\" _v-41948f31=\"\">載入更多</div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n#info-record-list[_v-41948f31] {\n  min-height: 100px; }\n\n/* line 5, stdin */\n.base-row[_v-41948f31] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between; }\n  /* line 8, stdin */\n  .base-row .action[_v-41948f31] {\n    color: #fff;\n    background-color: #878787;\n    padding-left: 5px;\n    padding-right: 5px;\n    font-size: 16px;\n    border-radius: 50%;\n    margin-top: 5px;\n    cursor: pointer; }\n\n/* line 19, stdin */\n.base-info[_v-41948f31] {\n  display: -ms-flexbox;\n  display: flex; }\n  /* line 21, stdin */\n  .base-info img[_v-41948f31] {\n    width: 40px;\n    border-radius: 50%;\n    margin-right: 5px; }\n\n/* line 27, stdin */\n.content-text[_v-41948f31] {\n  word-break: break-all;\n  padding-right: 30px;\n  margin-top: 10px;\n  white-space: pre-wrap; }\n\n/* line 33, stdin */\n.list-item[_v-41948f31] {\n  margin-top: 10px;\n  margin-bottom: 10px; }\n\n/* line 37, stdin */\n.edit-time[_v-41948f31] {\n  color: #A3A3A3;\n  margin-top: 2px; }\n\n/* line 41, stdin */\n.hr[_v-41948f31] {\n  margin-top: 10px;\n  margin-bottom: 10px; }\n  /* line 44, stdin */\n  .hr[_v-41948f31]:last-of-type {\n    display: none; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-41948f31", module.exports)
  } else {
    hotAPI.update("_v-41948f31", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/object/keys":56,"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1116:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.w-100[_v-908ee58a] {\n  width: 100px; }\n\n/* line 6, stdin */\n.w-200[_v-908ee58a] {\n  width: 200px; }\n\n/* line 10, stdin */\n.d-inline[_v-908ee58a] {\n  display: inline-block; }\n\n/* line 14, stdin */\n#type-select[_v-908ee58a] {\n  text-align-last: center; }\n  /* line 17, stdin */\n  #type-select option[_v-908ee58a] {\n    direction: rtl; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['memberId', 'studioId'],
    data: function data() {
        return {
            ajaxing: false,
            max_negative_point: 0,
            postData: {
                type: 'positive',
                start_date: '',
                point: 1,
                valid_days: 365,
                reason: ''
            }
        };
    },
    created: function created() {},
    mounted: function mounted() {
        var _this = this;

        window.Event.$on('create-member-bonus-init-points', function (balance) {
            _this.max_negative_point = Math.round(balance);
        });
        $('#create-member-bonus-modal').on('shown.bs.modal', function () {
            _this.postData.start_date = moment().format('YYYY-MM-DD');
            var vm = _this;
            _this.$nextTick(function () {
                $('.start_date').datetimepicker({
                    format: 'YYYY-MM-DD',
                    locale: 'zh-tw'
                }).on('dp.change', function (e) {
                    if (e.date) {
                        vm.postData.start_date = e.date.locale('zh-tw').format('YYYY-MM-DD');
                    } else {
                        vm.postData.start_date = moment().format('YYYY-MM-DD');
                    }
                });
            });
        });
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['isBranch']), (0, _vuex.mapState)({
        canUseBonus: function canUseBonus(state) {
            return state.webadmin.configure.webFunctions.WebadminBonusMember;
        }
    })),
    watch: {
        'postData.type': function postDataType(nVal, oVal) {
            if (nVal != oVal) {
                this.postData.point = 1;
            }
        },
        'postData.point': function postDataPoint(nVal, oVal) {
            if (this.postData.type == 'negative' && nVal > this.max_negative_point) {
                this.postData.point = this.max_negative_point;
            } else if (nVal < 1) {
                this.postData.point = 1;
            }
        }
    },
    methods: {
        save: function save() {
            var _this2 = this;

            if (this.postData.type != 'positive' && this.postData.type != 'negative') {
                this.alert('動作', '需為增加或減少', 'warning');
                return false;
            }
            if (this.postData.point < 1 || !this.postData.point) {
                this.alert('點數', '需大於1點', 'warning');
                return false;
            }
            if (this.postData.type == 'positive') {
                if (moment(this.postData.start_date).isBefore(moment().format('YYYY-MM-DD'))) {
                    this.alert('開始日期', '必須大於等於今天', 'warning');
                    return false;
                }
                if (this.postData.valid_days <= 0 || this.postData.valid_days > 9999) {
                    this.alert('有效天數', '必須為 1-9999 整數', 'warning');
                    return false;
                }
            }
            if (this.postData.reason == '' || !this.postData.reason) {
                this.alert('原因', '為必填', 'warning');
                return false;
            }

            this.ajaxing = true;
            this.$http.post('/adminapi/member/bonus/' + this.memberId + '/create', this.postData).then(function (response) {
                _this2.resetData();
                window.Event.$emit('member-bonus-refresh');
                _this2.ajaxing = false;
                $17.swal({
                    title: '編輯成功',
                    text: '',
                    type: 'success',
                    showCancelButton: false
                });
                $('#create-member-bonus-modal').modal('hide');
            }).catch(function (response) {
                _this2.resetData();
                _this2.ajaxing = false;
                $17.swal({
                    title: '編輯失敗',
                    type: 'warning',
                    showCancelButton: false
                });
                $('#create-member-bonus-modal').modal('hide');
            });
        },
        resetData: function resetData() {
            this.postData = {
                type: 'positive',
                start_date: '',
                point: 1,
                valid_days: 365,
                reason: ''
            };
        },

        alert: function alert(title, message, type) {
            $17.swal({
                title: title,
                text: message,
                type: type,
                showCancelButton: false,
                showLoaderOnConfirm: true
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal v-show=\"canUseBonus\" id=\"create-member-bonus-modal\" confirm-btn-text=\"確認\" no-cancel=\"\" parallel-modal=\"\" :save-clicked=\"save\" _v-908ee58a=\"\">\n    <h4 slot=\"title\" _v-908ee58a=\"\">編輯客戶紅利</h4>\n    <div slot=\"body\" _v-908ee58a=\"\">\n        <v-spinner :ajaxing=\"ajaxing\" _v-908ee58a=\"\"></v-spinner>\n        <div class=\"form-horizontal\" v-if=\"!ajaxing\" _v-908ee58a=\"\">\n            <div class=\"form-group\" _v-908ee58a=\"\">\n                <div class=\"col-xs-3 p-t-0\" _v-908ee58a=\"\">\n                    <select v-model=\"postData.type\" class=\"form-control\" id=\"type-select\" _v-908ee58a=\"\">\n                        <option value=\"positive\" _v-908ee58a=\"\">增加</option>\n                        <option value=\"negative\" _v-908ee58a=\"\">減少</option>\n                    </select>\n                </div>\n                <div class=\"col-xs-9\" _v-908ee58a=\"\">\n                    <input type=\"number\" step=\"1\" onwheel=\"this.blur()\" min=\"1\" class=\"form-control w-100 d-inline\" v-model=\"postData.point\" _v-908ee58a=\"\"> 點\n                </div>\n            </div>\n            <div class=\"form-group\" v-if=\"postData.type=='positive'\" _v-908ee58a=\"\">\n                <label class=\"col-xs-3 control-label p-t-0\" _v-908ee58a=\"\">開始日期</label>\n                <div class=\"col-xs-9\" _v-908ee58a=\"\">\n                    <input type=\"text\" class=\"start_date form-control w-100\" v-model=\"postData.start_date\" _v-908ee58a=\"\">\n                </div>\n            </div>\n            <div class=\"form-group\" v-if=\"postData.type=='positive'\" _v-908ee58a=\"\">\n                <label class=\"col-xs-3 control-label p-t-0\" _v-908ee58a=\"\">有效天數</label>\n                <div class=\"col-xs-9\" _v-908ee58a=\"\">\n                    <input type=\"number\" step=\"1\" onwheel=\"this.blur()\" max=\"9999\" min=\"1\" class=\"form-control w-100 d-inline\" v-model=\"postData.valid_days\" _v-908ee58a=\"\"> 天\n                </div>\n            </div>\n            <div class=\"form-group m-bottom-30\" _v-908ee58a=\"\">\n                <label class=\"col-xs-3 control-label p-t-0\" _v-908ee58a=\"\">原因</label>\n                <div class=\"col-xs-9\" _v-908ee58a=\"\">\n                    <textarea v-model=\"postData.reason\" cols=\"30\" rows=\"4\" class=\"form-control\" placeholder=\"請輸入原因\" _v-908ee58a=\"\"></textarea>\n                </div>\n            </div>\n        </div>\n    </div>\n</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.w-100[_v-908ee58a] {\n  width: 100px; }\n\n/* line 6, stdin */\n.w-200[_v-908ee58a] {\n  width: 200px; }\n\n/* line 10, stdin */\n.d-inline[_v-908ee58a] {\n  display: inline-block; }\n\n/* line 14, stdin */\n#type-select[_v-908ee58a] {\n  text-align-last: center; }\n  /* line 17, stdin */\n  #type-select option[_v-908ee58a] {\n    direction: rtl; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-908ee58a", module.exports)
  } else {
    hotAPI.update("_v-908ee58a", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1117:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _list = require('./list.vue');

var _list2 = _interopRequireDefault(_list);

var _create = require('./create.vue');

var _create2 = _interopRequireDefault(_create);

var _records = require('./records.vue');

var _records2 = _interopRequireDefault(_records);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('member-bonus-info', _list2.default);
_vue2.default.component('member-bonus-create-modal', _create2.default);
_vue2.default.component('member-bonus-records-modal', _records2.default);

},{"./create.vue":1116,"./list.vue":1118,"./records.vue":1119,"vue":792}],1118:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['memberId', 'studioId'],
    data: function data() {
        return {
            ajaxing: false,
            bonus_system_state: 'none',
            recently: [],
            currency: 'NT$',
            balance: 0,
            dollars: 0
        };
    },
    mounted: function mounted() {
        var _this = this;

        window.Event.$on('member-bonus-refresh', function () {
            _this.getInfo();
        });
        this.getInfo();
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['isBranch', 'isSeventeen']), (0, _vuex.mapState)({
        canUseBonus: function canUseBonus(state) {
            return state.webadmin.configure.webFunctions.WebadminBonusMember;
        }
    })),
    methods: {
        getInfo: function getInfo() {
            var _this2 = this;

            this.ajaxing = true;
            this.$http.get('/adminapi/member/bonus/' + this.memberId + '/info').then(function (response) {
                var data = response.data.data;
                _this2.bonus_system_state = data.bonus_system_state;
                if (data.bonus_system_state != 'none') {
                    _this2.recently = data.recently;
                    _this2.currency = data.currency;
                    _this2.balance = data.balance;
                    _this2.dollars = data.dollars;
                }
                _this2.ajaxing = false;
            }).catch(function (response) {
                $17.swal({
                    title: '取得客戶紅利失敗',
                    type: 'warning',
                    showCancelButton: false
                });
                _this2.ajaxing = false;
            });
        },
        createModal: function createModal() {
            window.Event.$emit('create-member-bonus-init-points', this.balance);
            $('#create-member-bonus-modal').modal('show');
        },
        recordsModel: function recordsModel() {
            $('#member-bonus-records-modal').modal('show');
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div id=\"member-bonus-info\" _v-0630b99d=\"\">\n    <v-spinner :ajaxing=\"ajaxing\" _v-0630b99d=\"\"></v-spinner>\n    <div v-if=\"!ajaxing\" _v-0630b99d=\"\">\n        <div v-if=\"bonus_system_state!='none'\" _v-0630b99d=\"\">\n            <div class=\"row\" v-if=\"bonus_system_state=='off'\" _v-0630b99d=\"\">\n                <div class=\"col-md-12\" _v-0630b99d=\"\">\n                    <div class=\"alert alert-danger m-top-5\" role=\"alert\" _v-0630b99d=\"\">紅利系統關閉中</div>\n                </div>\n            </div>\n            <div class=\"row\" _v-0630b99d=\"\">\n                <div class=\"col-md-12\" _v-0630b99d=\"\">\n                    <div _v-0630b99d=\"\">\n                        現有的紅利積點：{{balance}} 點（匯率換算 {{currency}} {{dollars}} 元）\n                        <button v-if=\"!isSeventeen&amp;&amp;canUseBonus&amp;&amp;bonus_system_state=='on'\" type=\"button\" class=\"btn btn-primary btn-xs\" @click.prevent=\"createModal\" _v-0630b99d=\"\">\n                            <i class=\"fa fa-pencil\" _v-0630b99d=\"\"></i>\n                        </button>\n                    </div>\n                    <div v-if=\"balance>0\" _v-0630b99d=\"\">\n                        即將到期：{{recently.points}} 點 即將於 {{recently.valid_end_at}} 到期\n                    </div>\n                </div>\n            </div>\n            <div class=\"row m-top-30 m-bottom-30\" _v-0630b99d=\"\">\n                <div class=\"col-md-12 text-center\" _v-0630b99d=\"\">\n                    <button type=\"button\" @click=\"recordsModel\" class=\"btn btn-primary\" _v-0630b99d=\"\">瀏覽紅利記錄</button>\n                </div>\n            </div>\n        </div>\n        <div v-else=\"\" _v-0630b99d=\"\">\n            <div class=\"row\" _v-0630b99d=\"\">\n                <div class=\"col-md-12 \" _v-0630b99d=\"\">\n                    <div class=\"alert alert-danger m-top-5\" role=\"alert\" _v-0630b99d=\"\">尚無紅利系統</div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-0630b99d", module.exports)
  } else {
    hotAPI.update("_v-0630b99d", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vuex":803}],1119:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['memberId', 'studioId'],
    data: function data() {
        return {
            ajaxing: false,
            member_name: '',
            records: []
        };
    },
    mounted: function mounted() {
        var _this = this;

        $('#member-bonus-records-modal').on('shown.bs.modal', function () {
            _this.records = [];
            _this.member_name = '';
            _this.getRecords();
        });
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['isBranch']), (0, _vuex.mapState)({
        canUseBonus: function canUseBonus(state) {
            return state.webadmin.configure.webFunctions.WebadminBonusMember;
        }
    })),
    methods: {
        getRecords: function getRecords() {
            var _this2 = this;

            this.ajaxing = true;
            this.$http.get('/adminapi/member/bonus/' + this.memberId + '/records').then(function (response) {
                var data = response.data.data;
                _this2.records = data.records;
                _this2.member_name = data.member_name;
                _this2.ajaxing = false;
            }).catch(function (response) {
                $17.swal({
                    title: '取得客戶紅利記錄失敗',
                    type: 'warning',
                    showCancelButton: false
                });
                _this2.ajaxing = false;
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal v-show=\"canUseBonus\" id=\"member-bonus-records-modal\" open-size=\"modal-lg\" no-footer=\"\" parallel-modal=\"\" _v-a21285da=\"\">\n    <h4 slot=\"title\" _v-a21285da=\"\">{{member_name}} 紅利記錄</h4>\n    <div slot=\"body\" _v-a21285da=\"\">\n        <v-spinner :ajaxing=\"ajaxing\" _v-a21285da=\"\"></v-spinner>\n        <div class=\"row\" v-if=\"!ajaxing\" _v-a21285da=\"\">\n            <div class=\"col-xs-12\" _v-a21285da=\"\">\n                <div class=\"table-responsive\" v-if=\"records.length\" _v-a21285da=\"\">\n                    <table class=\"table\" _v-a21285da=\"\">\n                        <thead _v-a21285da=\"\">\n                        <tr _v-a21285da=\"\">\n                            <th _v-a21285da=\"\">點數</th>\n                            <th _v-a21285da=\"\">原因</th>\n                            <th _v-a21285da=\"\">操作人</th>\n                            <th _v-a21285da=\"\">操作時間</th>\n                            <th _v-a21285da=\"\">有效期開始</th>\n                            <th _v-a21285da=\"\">有效期結束</th>\n                        </tr>\n                        </thead>\n                        <tbody _v-a21285da=\"\">\n                        <tr v-for=\"record in records\" _v-a21285da=\"\">\n                            <td _v-a21285da=\"\">{{record.point}} 點</td>\n                            <td _v-a21285da=\"\">{{record.reason}}</td>\n                            <td _v-a21285da=\"\">{{record.source}}</td>\n                            <td _v-a21285da=\"\">{{record.operated_at}}</td>\n                            <td _v-a21285da=\"\">{{record.valid_start}}</td>\n                            <td _v-a21285da=\"\">{{record.valid_end}}</td>\n                        </tr>\n                        </tbody>\n                    </table>\n                </div>\n                <div class=\"text-center\" v-else=\"\" _v-a21285da=\"\">沒有資料</div>\n            </div>\n        </div>\n    </div>\n</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-a21285da", module.exports)
  } else {
    hotAPI.update("_v-a21285da", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vuex":803}],1120:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _index = require('./index.vue');

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('member-history-order', _index2.default);

},{"./index.vue":1121,"vue":792}],1121:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 3, stdin */\n#member-history-order .header[_v-74f5379b] {\n  padding: 12px 25px; }\n  /* line 5, stdin */\n  #member-history-order .header ul[_v-74f5379b] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center; }\n  /* line 9, stdin */\n  #member-history-order .header li a[_v-74f5379b] {\n    padding: 6px 20px; }\n\n/* line 13, stdin */\n#member-history-order .nav > li > a[_v-74f5379b]:hover, #member-history-order .nav > li > a[_v-74f5379b]:focus {\n  border-radius: 18px; }\n\n/* line 16, stdin */\n#member-history-order .nav-pills > li.active > a[_v-74f5379b], #member-history-order .nav-pills > li.active > a[_v-74f5379b]:hover, #member-history-order .nav-pills > li.active > a[_v-74f5379b]:focus {\n  background-color: #38b0e3;\n  border-radius: 18px; }\n\n/* line 3, stdin */\n.table > tbody > tr > td.text-overflow-hidden {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  max-width: 160px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['memberId', 'studioId'],
    data: function data() {
        return {
            payment_filter: 1,
            payColumnConfig: ['member', 'payment_action', 'invoice', 'discount'],
            unpayColumnConfig: ['member', 'qty', 'price', 'subtotal', 'discount']
        };
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        orders: function orders(state) {
            return state.pos.orders;
        },
        fetchAjaxing: function fetchAjaxing(state) {
            return state.pos.fetch_ajaxing;
        },
        canReadPayOrder: function canReadPayOrder(state) {
            return state.webadmin.configure.webFunctions.WebadminPosPayList;
        },
        canReadUnpayOrder: function canReadUnpayOrder(state) {
            return state.webadmin.configure.webFunctions.WebadminPosUnpayList;
        }
    }), (0, _vuex.mapState)('webadmin/configure', ['isSeventeen']), {
        pageMeta: function pageMeta() {
            return store.state.pos.page_meta;
        }
    }),
    mounted: function mounted() {
        var _this = this;

        this.$store.commit("filters/SETSTATUS", {
            key: "selected_studio_id",
            value: this.studioId
        });
        this.initOrderValue();
        window.Event.$on('fetch-member-history-orders', function () {
            _this.getOrderList(_this.pageMeta.currentPage);
        });
    },

    watch: {
        payment_filter: function payment_filter(newVal) {
            var payment_statuses = newVal == 0 ? [0, 4, 5] : [1, 2, 6, 7, 8, 9];
            this.$store.dispatch('pos/updateAllStatus', [{ 'key': 'payment_filter', value: this.payment_filter }, { 'key': 'filter_payment_statuses', value: payment_statuses }]);
            this.getOrderList();
        }
    },
    methods: {
        initOrderValue: function initOrderValue() {
            if (this.canReadPayOrder) {
                this.payment_filter = 1;
            } else {
                this.payment_filter = 0;
            };

            if (this.isSeventeen) {
                this.$store.commit('filters/SETSTATUS', { 'key': 'selected_studio_id', value: this.studioId });
            };

            var timeStart = moment('2000-01-01').format('YYYY-MM-DD');
            var timeEnd = moment().format('YYYY-MM-DD');

            var payment_statuses = this.payment_filter == 0 ? [0, 4, 5] : [1, 2, 6, 7, 8, 9];

            this.$store.dispatch('pos/updateAllStatus', [{ 'key': 'filter_time_limit', value: 'no_limit' }, { 'key': 'filter_member_id', value: this.memberId }, { 'key': 'time_start', value: timeStart }, { 'key': 'time_end', value: timeEnd }, { 'key': 'page_size', value: 5 }, { 'key': 'filter_payment_types', value: [13, 14, 17] }, { 'key': 'filter_payment_statuses', value: payment_statuses }, { 'key': 'payment_filter', value: this.payment_filter }]);

            this.getOrderList();
        },
        getOrderList: function getOrderList(page) {
            if (typeof page === 'number') {
                this.$store.commit('pos/POS_SETSTATUS', { 'key': 'page', value: page });
            } else {
                this.$store.commit('pos/POS_SETSTATUS', { 'key': 'page', value: 1 });
            };

            this.$store.dispatch('pos/getOrderList');
        },

        openOrCreateOperateOrder: function openOrCreateOperateOrder(payload) {
            payload.event_type = 'crmOrder';
            window.Event.$emit("System.Pos.Order.Open", payload);
        }
    },
    destroy: function destroy() {
        this.$store.commit('pos/POS_SETSTATUS', { 'key': 'page', value: '' });
        window.Event.$off('fetch-member-history-orders');
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div id=\"member-history-order\" _v-74f5379b=\"\">\n    <v-spinner :ajaxing=\"fetchAjaxing\" _v-74f5379b=\"\"></v-spinner>\n    <content-card v-show=\"!fetchAjaxing\" :show-footer=\"false\" _v-74f5379b=\"\">\n        <div slot=\"head\" _v-74f5379b=\"\">\n            <div class=\"header\" _v-74f5379b=\"\">\n                <ul class=\"nav nav-pills\" _v-74f5379b=\"\">\n                    <li role=\"presentation\" v-if=\"canReadPayOrder\" :class=\"{active: payment_filter == 1}\" @click.prevent=\"payment_filter=1\" style=\"margin-right: 14px;\" _v-74f5379b=\"\">\n                        <a _v-74f5379b=\"\">已結帳</a>\n                    </li>\n                    <li role=\"presentation\" v-if=\"canReadUnpayOrder\" :class=\"{active: payment_filter == 0}\" @click.prevent=\"payment_filter=0\" _v-74f5379b=\"\">\n                        <a _v-74f5379b=\"\">未結帳</a>\n                    </li>\n                </ul>\n            </div>\n        </div>\n        <div slot=\"body\" _v-74f5379b=\"\">\n            <div style=\"padding: 10px;\" _v-74f5379b=\"\">\n                <div v-if=\"orders.length > 0\" _v-74f5379b=\"\">\n                    <order-list-pay v-if=\"payment_filter==1\" :hidden-columns-config=\"payColumnConfig\" @get-order-list=\"getOrderList\" @open-operate-order=\"openOrCreateOperateOrder\" _v-74f5379b=\"\"></order-list-pay>\n                    <order-list-unpay v-if=\"payment_filter==0\" :hidden-columns-config=\"unpayColumnConfig\" @get-order-list=\"getOrderList\" @open-operate-order=\"openOrCreateOperateOrder\" _v-74f5379b=\"\"></order-list-unpay>\n                    <v-sql-pagination-noquery :page-meta=\"pageMeta\" @page-change-callback=\"getOrderList\" _v-74f5379b=\"\"></v-sql-pagination-noquery>                          \n                </div>\n                <div style=\"font-size: 15px;color: #898989;\" v-else=\"\" _v-74f5379b=\"\">\n                    暫無內容\n                </div>\n            </div>\n        </div>\n    </content-card>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 3, stdin */\n#member-history-order .header[_v-74f5379b] {\n  padding: 12px 25px; }\n  /* line 5, stdin */\n  #member-history-order .header ul[_v-74f5379b] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center; }\n  /* line 9, stdin */\n  #member-history-order .header li a[_v-74f5379b] {\n    padding: 6px 20px; }\n\n/* line 13, stdin */\n#member-history-order .nav > li > a[_v-74f5379b]:hover, #member-history-order .nav > li > a[_v-74f5379b]:focus {\n  border-radius: 18px; }\n\n/* line 16, stdin */\n#member-history-order .nav-pills > li.active > a[_v-74f5379b], #member-history-order .nav-pills > li.active > a[_v-74f5379b]:hover, #member-history-order .nav-pills > li.active > a[_v-74f5379b]:focus {\n  background-color: #38b0e3;\n  border-radius: 18px; }\n\n/* line 3, stdin */\n.table > tbody > tr > td.text-overflow-hidden {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  max-width: 160px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-74f5379b", module.exports)
  } else {
    hotAPI.update("_v-74f5379b", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1122:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.unique[_v-5b03fe03] {\n  color: #aaa; }\n\n/* line 5, stdin */\n.clickable[_v-5b03fe03] {\n  color: #38b0e3; }\n\n/* line 8, stdin */\n.sortable > tbody > tr[_v-5b03fe03] {\n  cursor: pointer; }\n\n/* line 11, stdin */\n.fa-check[_v-5b03fe03] {\n  color: #00a000; }\n\n/* line 14, stdin */\n.fa-remove[_v-5b03fe03] {\n  color: #FF0000; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['studioId', 'rowClicked'],
    data: function data() {
        return {
            fields: [],
            ajaxing: false
        };
    },
    created: function created() {
        var _this = this;

        window.Event.$on('refresh', function () {
            _this.refresh();
        });
    },

    methods: {
        itemClicked: function itemClicked(f) {
            if (f.is_readonly) return;
            this.rowClicked(f);
        },
        uniquedTxt: function uniquedTxt(f) {
            return f.uniqued ? '不允許重複' : '';
        },
        refresh: function refresh() {
            var _this2 = this;

            this.ajaxing = true;
            $.get('/adminapi/custom_fields/' + this.studioId, function (data) {
                _this2.fields = data.fields;
                _this2.ajaxing = false;
            });
        }
    },
    watch: {
        studioId: function studioId(v) {
            if (!v) return;
            this.refresh();
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-table :ajaxing=\"ajaxing\" :length=\"fields.length\" _v-5b03fe03=\"\">\n    <table class=\"table sortable\" _v-5b03fe03=\"\">\n        <thead _v-5b03fe03=\"\">\n            <tr _v-5b03fe03=\"\">\n                <td _v-5b03fe03=\"\"></td>\n                <td _v-5b03fe03=\"\">名稱</td>\n                <td _v-5b03fe03=\"\"></td>\n            </tr>\n        </thead>\n        <tbody _v-5b03fe03=\"\">\n            <tr v-for=\"f in fields\" @click.prevent=\"itemClicked(f)\" _v-5b03fe03=\"\">\n                <td _v-5b03fe03=\"\"><i class=\"fa fa-list\" aria-hidden=\"true\" _v-5b03fe03=\"\"></i></td>\n                <td :class=\"{clickable: !f.is_ref}\" _v-5b03fe03=\"\">{{ f.name }}</td>\n                <td class=\"unique\" _v-5b03fe03=\"\">{{ uniquedTxt(f) }}</td>\n            </tr>\n        </tbody>\n    </table>\n</v-table>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.unique[_v-5b03fe03] {\n  color: #aaa; }\n\n/* line 5, stdin */\n.clickable[_v-5b03fe03] {\n  color: #38b0e3; }\n\n/* line 8, stdin */\n.sortable > tbody > tr[_v-5b03fe03] {\n  cursor: pointer; }\n\n/* line 11, stdin */\n.fa-check[_v-5b03fe03] {\n  color: #00a000; }\n\n/* line 14, stdin */\n.fa-remove[_v-5b03fe03] {\n  color: #FF0000; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-5b03fe03", module.exports)
  } else {
    hotAPI.update("_v-5b03fe03", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1123:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _custom_field_list = require('./custom_field_list.vue');

var _custom_field_list2 = _interopRequireDefault(_custom_field_list);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('./profile-card-setting');

_vue2.default.component('webadmin-custom-field-list', _custom_field_list2.default);

},{"./custom_field_list.vue":1122,"./profile-card-setting":1125,"vue":792}],1124:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.title[_v-4dfcebde] {\n  padding: 10px;\n  font-size: 14px;\n  color: #6B7280;\n  font-weight: 500;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between; }\n\n/* line 10, stdin */\n.setting-row[_v-4dfcebde] {\n  padding: 8px 11px;\n  border-bottom: 1px solid #E5E7EB;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  gap: 8px; }\n  /* line 16, stdin */\n  .setting-row[_v-4dfcebde]:last-child {\n    border-bottom: none; }\n  /* line 19, stdin */\n  .setting-row label[_v-4dfcebde] {\n    margin-bottom: 0; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['ajaxing', 'positionConfig'],
    data: function data() {
        return {
            position: [{ id: '1', name: '課程/預約管理/客戶姓名', value: 'webadmin/booking/schedule-class:records[].member', select: true }, { id: '2', name: '服務/預約管理/客戶姓名', value: 'webadmin/booking/schedule-service:modal.member', select: true }, { id: '3', name: '日程中的服務項目/最右側客戶姓名', value: 'webadmin/calendar-merchant:modal.member', select: true }, { id: '4', name: '點名頁/客戶姓名', value: 'webadmin/appointment/schedule-class:records[].member', select: true }, { id: '5', name: '方案/使用中的會員/客戶姓名', value: 'webadmin/member-contract:records[].member', select: true }]
        };
    },
    mounted: function mounted() {
        this.initView();
    },

    methods: {
        initView: function initView() {
            var hiddenAttr = this.positionConfig.effect_position.hidden;
            this.position.forEach(function (item) {
                item.select = !hiddenAttr.includes(item.value);
            });
        },
        save: function save() {
            var hiddenAttr = [];
            this.position.forEach(function (item) {
                if (item.select == false) {
                    hiddenAttr.push(item.value);
                }
            });
            this.$emit('save-setting', {
                type: 'display-position',
                data: {
                    effect: 'webadmin/*',
                    hidden: hiddenAttr
                }
            });
        },
        cancel: function cancel() {
            this.initView();
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-4dfcebde=\"\">\n    <div _v-4dfcebde=\"\">\n        <content-card :show-footer=\"false\" _v-4dfcebde=\"\">\n            <div slot=\"head\" _v-4dfcebde=\"\">\n                <div class=\"title\" _v-4dfcebde=\"\">顯示位置的路徑\n                    <a href=\"https://17fithelp.zendesk.com/hc/zh-tw/articles/4405434211353\" target=\"_blank\" _v-4dfcebde=\"\"><i class=\"fa fa-info-circle\" _v-4dfcebde=\"\"></i></a>\n                </div>\n            </div>\n            <div slot=\"body\" _v-4dfcebde=\"\">\n                <div class=\"setting-row\" v-for=\"item in position\" _v-4dfcebde=\"\">\n                    <input type=\"checkbox\" :id=\"item.id\" value=\"tag\" v-model=\"item.select\" _v-4dfcebde=\"\">\n                    <label :for=\"item.id\" _v-4dfcebde=\"\">{{item.name}}</label>                    \n                </div>\n            </div>\n        </content-card>\n        <div class=\"m-bottom-20 text-right\" _v-4dfcebde=\"\">\n            <button class=\"btn btn-default\" @click=\"cancel\" _v-4dfcebde=\"\">取消</button>\n            <button class=\"btn btn-primary btn--inverse\" @click=\"save\" _v-4dfcebde=\"\">儲存</button>\n        </div>\n    </div>    \n</div>\n\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.title[_v-4dfcebde] {\n  padding: 10px;\n  font-size: 14px;\n  color: #6B7280;\n  font-weight: 500;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between; }\n\n/* line 10, stdin */\n.setting-row[_v-4dfcebde] {\n  padding: 8px 11px;\n  border-bottom: 1px solid #E5E7EB;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  gap: 8px; }\n  /* line 16, stdin */\n  .setting-row[_v-4dfcebde]:last-child {\n    border-bottom: none; }\n  /* line 19, stdin */\n  .setting-row label[_v-4dfcebde] {\n    margin-bottom: 0; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-4dfcebde", module.exports)
  } else {
    hotAPI.update("_v-4dfcebde", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1125:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _index = require('./index.vue');

var _index2 = _interopRequireDefault(_index);

var _showItem = require('./show-item.vue');

var _showItem2 = _interopRequireDefault(_showItem);

var _displayPosition = require('./display-position.vue');

var _displayPosition2 = _interopRequireDefault(_displayPosition);

var _profilePreview = require('./profile-preview.vue');

var _profilePreview2 = _interopRequireDefault(_profilePreview);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('profile-card-display-setting', _index2.default);
_vue2.default.component('profile-card-show-item-setting', _showItem2.default);
_vue2.default.component('profile-card-display-position-setting', _displayPosition2.default);
_vue2.default.component('profile-card-preview', _profilePreview2.default);

},{"./display-position.vue":1124,"./index.vue":1126,"./profile-preview.vue":1127,"./show-item.vue":1128,"vue":792}],1126:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            ajaxing: true,
            currentView: 'profile-card-show-item-setting',
            customField: [],
            positionConfig: {
                effect_position: {
                    effect: 'webadmin/*',
                    hidden: []
                }
            },
            hiddenField: [],
            cardPreviewConfig: {
                card: { tags: true },
                custom_field: []
            }
        };
    },
    created: function created() {},
    mounted: function mounted() {},

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId']), (0, _vuex.mapState)('filters', ['selected_studio_id', 'selected_branch_id']), {
        studio_id: function studio_id() {
            return this.studioId || this.selected_studio_id;
        },
        branch_id: function branch_id() {
            return this.branchId || this.selected_branch_id;
        }
    }),
    watch: {
        'studio_id': {
            handler: function handler(newVal) {
                if (newVal) {
                    this.refresh();
                }
            }
        }
    },
    methods: {
        refresh: function refresh() {
            var _this = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this.fetchCardUiSetting();

                            case 2:
                                _context.next = 4;
                                return _this.fetchCustomField();

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        fetchCustomField: function fetchCustomField() {
            var _this2 = this;

            if (!this.studio_id) return;
            this.ajaxing = true;
            this.$http.get('/adminapi/custom_fields/' + this.studio_id).then(function (response) {
                _this2.customField = response.data.fields;
                _this2.ajaxing = false;
            }, function (error) {
                _this2.ajaxing = false;
            });
        },
        fetchCardUiSetting: function fetchCardUiSetting() {
            var _this3 = this;

            if (!this.studio_id) return;
            this.positionConfig = {
                effect_position: { effect: 'webadmin/*', hidden: [] }
            };
            this.ajaxing = true;
            this.$http.post('/adminapi/layout-setting/user_card_setting/index', {
                studio_id: this.studio_id,
                branch_id: 0,
                effect_position: (0, _stringify2.default)(this.positionConfig.effect_position)
            }).then(function (response) {
                _this3.positionConfig = {
                    effect_position: JSON.parse(response.data.setting.effect_position)
                };
                _this3.hiddenField = response.data.hidden_field;
                _this3.ajaxing = false;
            }, function (error) {
                _this3.ajaxing = false;
            });
        },
        save: function save(setting) {
            switch (setting.type) {
                case 'display-position':
                    this.savePosition(setting.data);
                    break;
                case 'hidden-field':
                    this.saveHiddenField(setting.data);
                    break;
            }
        },
        savePosition: function savePosition(data) {
            var _this4 = this;

            this.ajaxing = true;
            var postData = {
                effect_position: data
            };
            this.$http.post('/adminapi/layout-setting/user_card_setting/position', {
                studio_id: this.studio_id,
                branch_id: 0,
                effect_position: (0, _stringify2.default)(postData.effect_position)
            }).then(function (response) {
                _this4.ajaxing = false;
                _this4.positionConfig = {
                    effect_position: JSON.parse(response.data.effect_position)
                };
            }, function (error) {
                _this4.ajaxing = false;
            });
        },
        saveHiddenField: function saveHiddenField(data) {
            var _this5 = this;

            this.ajaxing = true;
            this.$http.post('/adminapi/layout-setting/user_card_setting/hidden_field', {
                studio_id: this.studio_id,
                branch_id: 0,
                'hidden_params': data
            }).then(function (response) {
                _this5.ajaxing = false;
                _this5.hiddenField = data;
            }, function (error) {
                _this5.ajaxing = false;
            });
        },
        syncCardPreview: function syncCardPreview(data) {
            this.cardPreviewConfig[data.scope] = data.data;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div style=\"margin: 0 20px 0 15px;\" class=\"row\" _v-24c09038=\"\">\n    <div class=\"m-left-15\" _v-24c09038=\"\">\n        <v-multiselect-studio-and-branch :studio_id=\"studioId\" :branch_id=\"branchId\" :show-branch=\"false\" _v-24c09038=\"\"></v-multiselect-studio-and-branch>\n    </div>\n\n    <div _v-24c09038=\"\">\n        <div class=\"col-sm-6 col-xs-12 setting-section\" _v-24c09038=\"\">\n            <div class=\"tabs\" style=\"margin: 24px 0 16px 0;\" _v-24c09038=\"\">\n                <ul class=\"nav nav-tabs\" _v-24c09038=\"\">\n                    <li @click.prevent=\"[currentView='profile-card-show-item-setting']\" :class=\"currentView=='profile-card-show-item-setting' ? 'active' : ''\" _v-24c09038=\"\">\n                        <a _v-24c09038=\"\">顯示項目</a>\n                    </li>\n                    <li @click.prevent=\"[currentView='profile-card-display-position-setting']\" :class=\"currentView=='profile-card-display-position-setting' ? 'active' : ''\" _v-24c09038=\"\">\n                        <a _v-24c09038=\"\">顯示位置</a>\n                    </li>\n                </ul>\n            </div>\n            <v-spinner :ajaxing=\"ajaxing\" _v-24c09038=\"\"></v-spinner>\n            <div v-show=\"!ajaxing\" _v-24c09038=\"\">\n                <component :is=\"currentView\" :ajaxing=\"ajaxing\" :custom-field=\"customField\" :hidden-field=\"hiddenField\" :position-config=\"positionConfig\" @save-setting=\"save\" @select-change=\"syncCardPreview\" _v-24c09038=\"\"></component>                    \n            </div>\n        </div>\n        <div style=\"margin-top: 77px\" class=\"col-sm-6 col-xs-12\" v-show=\"!ajaxing\" _v-24c09038=\"\">\n            <profile-card-preview :preview-config=\"cardPreviewConfig\" _v-24c09038=\"\"></profile-card-preview>\n        </div>            \n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-24c09038", module.exports)
  } else {
    hotAPI.update("_v-24c09038", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/json/stringify":48,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1127:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n#profile-card-preview[_v-4bdc46ec] {\n  max-width: 362px;\n  border: 1px solid #B5B5BE;\n  border-radius: 8px; }\n  /* line 6, stdin */\n  #profile-card-preview .profile-card-content[_v-4bdc46ec] {\n    margin: 24px 10px; }\n  /* line 9, stdin */\n  #profile-card-preview .profile-card-top[_v-4bdc46ec] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n    padding-bottom: 16px; }\n    /* line 13, stdin */\n    #profile-card-preview .profile-card-top .name[_v-4bdc46ec] {\n      font-size: 20px;\n      font-weight: 700; }\n    /* line 17, stdin */\n    #profile-card-preview .profile-card-top .phone[_v-4bdc46ec] {\n      font-size: 14px;\n      font-weight: 500;\n      color: #666666; }\n    /* line 22, stdin */\n    #profile-card-preview .profile-card-top .email[_v-4bdc46ec] {\n      font-size: 14px;\n      font-weight: 500;\n      text-decoration: underline; }\n  /* line 28, stdin */\n  #profile-card-preview .profile-card-body[_v-4bdc46ec] {\n    padding-top: 16px;\n    border-top: solid 1px #d5d5d5; }\n    /* line 31, stdin */\n    #profile-card-preview .profile-card-body .custom-filed-row[_v-4bdc46ec] {\n      display: -ms-grid;\n      display: grid;\n      -ms-grid-columns: 70px auto;\n          grid-template-columns: 70px auto;\n      font-size: 15px;\n      margin-bottom: 8px; }\n    /* line 37, stdin */\n    #profile-card-preview .profile-card-body .head[_v-4bdc46ec] {\n      font-weight: 700;\n      text-align: right; }\n    /* line 41, stdin */\n    #profile-card-preview .profile-card-body .text[_v-4bdc46ec] {\n      color: #666666;\n      padding-left: 20px;\n      display: -ms-inline-flexbox;\n      display: inline-flex;\n      -ms-flex-align: center;\n          align-items: center;\n      word-break: break-all; }\n  /* line 49, stdin */\n  #profile-card-preview .member-img[_v-4bdc46ec] {\n    background-color: #8f8f8f;\n    border: 1px solid #8f8f8f;\n    width: 120px;\n    height: 120px;\n    border-radius: 50%; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['previewConfig'],
    data: function data() {
        return {
            tags: [{ name: '預覽標籤' }, { name: '預覽標籤1' }, { name: '預覽標籤2' }, { name: '預覽標籤3' }]
        };
    },

    methods: {
        showFieldText: function showFieldText(type) {
            switch (type) {
                case 1:
                    return '預設單行內容';
                    break;
                case 2:
                    return '預設多行內容';
                    break;
                case 3:
                    return '預設單選';
                    break;
                case 4:
                    return '預設複選內容';
                    break;
                case 5:
                    return '2021-01-01';
                    break;

            }
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div id=\"profile-card-preview\" _v-4bdc46ec=\"\">\n    <div class=\"profile-card-content\" _v-4bdc46ec=\"\">\n        <div class=\"profile-card-top\" _v-4bdc46ec=\"\">\n            <img class=\"member-img margin_center\" src=\"/images/default.png\" _v-4bdc46ec=\"\">\n            <div class=\"m-left-20\" _v-4bdc46ec=\"\">\n                <div class=\"m-bottom-6 name\" _v-4bdc46ec=\"\">黃先生\n                    <a class=\"m-left-10\" _v-4bdc46ec=\"\"><i class=\"fa fa-external-link\" _v-4bdc46ec=\"\"></i></a>\n                </div>\n                <div class=\"phone\" _v-4bdc46ec=\"\">0912345678</div>\n                <div class=\"email\" _v-4bdc46ec=\"\">\n                    <a _v-4bdc46ec=\"\">preview@17fit.com</a>\n                </div>\n                <div v-show=\"previewConfig.card.tags\" _v-4bdc46ec=\"\">\n                    <v-member-tag :member-tags=\"tags\" _v-4bdc46ec=\"\"></v-member-tag>\n                </div>\n            </div>\n        </div>\n        <div class=\"profile-card-body\" _v-4bdc46ec=\"\">\n            <div class=\"custom-filed-row\" v-for=\"field in previewConfig.custom_field\" v-if=\"!field.disable &amp;&amp; field.select\" _v-4bdc46ec=\"\">\n                <div class=\"head\" _v-4bdc46ec=\"\">{{field.name}}</div>\n                <div class=\"text\" _v-4bdc46ec=\"\">{{showFieldText(field.field_type)}}</div>\n            </div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n#profile-card-preview[_v-4bdc46ec] {\n  max-width: 362px;\n  border: 1px solid #B5B5BE;\n  border-radius: 8px; }\n  /* line 6, stdin */\n  #profile-card-preview .profile-card-content[_v-4bdc46ec] {\n    margin: 24px 10px; }\n  /* line 9, stdin */\n  #profile-card-preview .profile-card-top[_v-4bdc46ec] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n    padding-bottom: 16px; }\n    /* line 13, stdin */\n    #profile-card-preview .profile-card-top .name[_v-4bdc46ec] {\n      font-size: 20px;\n      font-weight: 700; }\n    /* line 17, stdin */\n    #profile-card-preview .profile-card-top .phone[_v-4bdc46ec] {\n      font-size: 14px;\n      font-weight: 500;\n      color: #666666; }\n    /* line 22, stdin */\n    #profile-card-preview .profile-card-top .email[_v-4bdc46ec] {\n      font-size: 14px;\n      font-weight: 500;\n      text-decoration: underline; }\n  /* line 28, stdin */\n  #profile-card-preview .profile-card-body[_v-4bdc46ec] {\n    padding-top: 16px;\n    border-top: solid 1px #d5d5d5; }\n    /* line 31, stdin */\n    #profile-card-preview .profile-card-body .custom-filed-row[_v-4bdc46ec] {\n      display: -ms-grid;\n      display: grid;\n      -ms-grid-columns: 70px auto;\n          grid-template-columns: 70px auto;\n      font-size: 15px;\n      margin-bottom: 8px; }\n    /* line 37, stdin */\n    #profile-card-preview .profile-card-body .head[_v-4bdc46ec] {\n      font-weight: 700;\n      text-align: right; }\n    /* line 41, stdin */\n    #profile-card-preview .profile-card-body .text[_v-4bdc46ec] {\n      color: #666666;\n      padding-left: 20px;\n      display: -ms-inline-flexbox;\n      display: inline-flex;\n      -ms-flex-align: center;\n          align-items: center;\n      word-break: break-all; }\n  /* line 49, stdin */\n  #profile-card-preview .member-img[_v-4bdc46ec] {\n    background-color: #8f8f8f;\n    border: 1px solid #8f8f8f;\n    width: 120px;\n    height: 120px;\n    border-radius: 50%; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-4bdc46ec", module.exports)
  } else {
    hotAPI.update("_v-4bdc46ec", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1128:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.title[_v-6745f7c9] {\n  padding: 10px;\n  font-size: 14px;\n  color: #6B7280;\n  font-weight: 500; }\n\n/* line 8, stdin */\n.setting-row[_v-6745f7c9] {\n  padding: 8px 11px;\n  border-bottom: 1px solid #E5E7EB;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  gap: 8px; }\n  /* line 14, stdin */\n  .setting-row[_v-6745f7c9]:last-child {\n    border-bottom: none; }\n  /* line 17, stdin */\n  .setting-row label[_v-6745f7c9] {\n    margin-bottom: 0; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['ajaxing', 'customField', 'hiddenField'],
    data: function data() {
        return {
            showTags: true,
            fields: [],
            disableField: ['picture', 'name', 'email', 'phone']
        };
    },
    mounted: function mounted() {
        this.initView();
    },

    watch: {
        customField: function customField(newVal) {
            if (!_lodash2.default.isEmpty(newVal)) {
                this.initView();
            }
        },

        'fields': {
            handler: function handler(newVal) {
                if (!_lodash2.default.isEmpty(newVal)) {
                    this.$emit('select-change', {
                        scope: 'custom_field',
                        data: newVal
                    });
                }
            },
            deep: true,
            immediate: true
        },
        showTags: function showTags(newVal) {
            this.$emit('select-change', {
                scope: 'card',
                data: { tags: newVal }
            });
        }
    },
    methods: {
        initView: function initView() {
            var _this = this;

            var vm = this;
            var customFieldIds = [];
            this.hiddenField.forEach(function (item) {
                if (item.field_type == 'custom_field') {
                    customFieldIds.push(item.field_id);
                } else {
                    vm.showTags = false;
                }
            });
            this.fields = this.customField.map(function (item) {
                var isDisableField = _this.disableField.includes(item.ref_field);
                var isHidden = customFieldIds.includes(item.id);
                return {
                    id: item.id,
                    name: item.name,
                    disable: item.is_ref ? isDisableField : false,
                    select: isDisableField || !isHidden,
                    field_type: item.field_type
                };
            });
        },
        save: function save() {
            var hiddenField = [];
            this.fields.forEach(function (item) {
                if (!item.select) {
                    hiddenField.push({
                        field_id: item.id,
                        field_type: 'custom_field'
                    });
                }
            });
            if (!this.showTags) {
                hiddenField.push({ field_id: 0, field_type: 'customer_tag' });
            }
            this.$emit('save-setting', {
                type: 'hidden-field',
                data: hiddenField
            });
        },
        cancel: function cancel() {
            this.initView();
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-6745f7c9=\"\">\n    <content-card :show-footer=\"false\" _v-6745f7c9=\"\">\n        <div slot=\"head\" _v-6745f7c9=\"\">\n            <div class=\"title\" _v-6745f7c9=\"\">客戶資料卡</div>\n        </div>\n        <div slot=\"body\" _v-6745f7c9=\"\">\n            <div class=\"setting-row\" _v-6745f7c9=\"\">\n                <input type=\"checkbox\" id=\"tag\" value=\"tag\" v-model=\"showTags\" _v-6745f7c9=\"\">\n                <label for=\"tag\" _v-6745f7c9=\"\">標籤</label>\n            </div>\n        </div>\n    </content-card>\n    <content-card :show-footer=\"false\" _v-6745f7c9=\"\">\n        <div slot=\"head\" _v-6745f7c9=\"\">\n            <div class=\"title\" _v-6745f7c9=\"\">客戶欄位</div>\n        </div>\n        <div slot=\"body\" _v-6745f7c9=\"\">\n            <div class=\"setting-row\" v-for=\"item in fields\" _v-6745f7c9=\"\">\n                <input type=\"checkbox\" :id=\"item.id\" v-model=\"item.select\" :disabled=\"item.disable\" _v-6745f7c9=\"\">\n                <label :for=\"item.id\" _v-6745f7c9=\"\">{{item.name}}</label>                    \n            </div>\n        </div>\n    </content-card>\n    <div class=\"m-bottom-20 text-right\" _v-6745f7c9=\"\">\n        <button class=\"btn btn-default\" @click=\"cancel\" _v-6745f7c9=\"\">取消</button>\n        <button class=\"btn btn-primary btn--inverse\" @click=\"save\" _v-6745f7c9=\"\">儲存</button>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.title[_v-6745f7c9] {\n  padding: 10px;\n  font-size: 14px;\n  color: #6B7280;\n  font-weight: 500; }\n\n/* line 8, stdin */\n.setting-row[_v-6745f7c9] {\n  padding: 8px 11px;\n  border-bottom: 1px solid #E5E7EB;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  gap: 8px; }\n  /* line 14, stdin */\n  .setting-row[_v-6745f7c9]:last-child {\n    border-bottom: none; }\n  /* line 17, stdin */\n  .setting-row label[_v-6745f7c9] {\n    margin-bottom: 0; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-6745f7c9", module.exports)
  } else {
    hotAPI.update("_v-6745f7c9", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1129:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _setting = require('./setting.vue');

var _setting2 = _interopRequireDefault(_setting);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('custom-service-bookable-setting', _setting2.default);

},{"./setting.vue":1130,"vue":792}],1130:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.col[_v-5de91330] {\n  width: calc(100% / 7); }\n\n/* line 6, stdin */\n.day[_v-5de91330], .time[_v-5de91330] {\n  padding: 10px;\n  text-align: center; }\n\n/* line 11, stdin */\n.day[_v-5de91330] {\n  border-bottom: 1px solid #000; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            ajaxing: true,
            view: {
                show_edit_btn: false,
                step: 0,
                selected_days: [],
                times: { 0: [], 1: [], 2: [], 3: [], 4: [], 5: [], 6: [] },
                mapping: { 0: '週日', 1: '週一', 2: '週二', 3: '週三', 4: '週四', 5: '週五', 6: '週六' },
                origin: {
                    start_time: '',
                    end_time: '',
                    gap: '15',
                    times: {}
                }
            },
            postData: {
                start_time: '',
                end_time: '',
                gap: '15',
                times: { 0: [], 1: [], 2: [], 3: [], 4: [], 5: [], 6: [] }
            }
        };
    },
    mounted: function mounted() {},

    watch: {
        selected_studio_id: function selected_studio_id(val) {
            if (val > 0) {}
        },
        selected_branch_id: function selected_branch_id(val) {
            if (val > 0) {
                this.getSetting();
            }
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId']), (0, _vuex.mapState)('filters', ['selected_studio_id', 'selected_branch_id']), (0, _vuex.mapState)({
        canRead: function canRead(state) {
            return state.webadmin.configure.webFunctions.WebadminCustomServiceBookableSettingIndex;
        },
        canUpdate: function canUpdate(state) {
            return state.webadmin.configure.webFunctions.WebadminCustomServiceBookableSettingUpdate;
        }
    }), {
        showStep0: function showStep0() {
            return this.canRead && this.view.step === 0;
        },
        showStep1: function showStep1() {
            return this.canUpdate && this.view.step === 1;
        },
        showStep2: function showStep2() {
            return this.canUpdate && this.view.step === 2;
        },
        showSetting: function showSetting() {
            return this.view.step === 0 && (0, _keys2.default)(this.view.origin.times).length || this.showStep2;
        },
        isPeriodOk: function isPeriodOk() {
            return moment(this.postData.start_time, 'HH:mm').isValid() && moment(this.postData.end_time, 'HH:mm').isValid() && moment(this.postData.start_time, 'HH:mm').isBefore(moment(this.postData.end_time, 'HH:mm'));
        }
    }),
    methods: {
        init: function init() {
            this.view = {
                show_edit_btn: this.canUpdate,
                step: 0,
                selected_days: [],
                times: { 0: [], 1: [], 2: [], 3: [], 4: [], 5: [], 6: [] },
                mapping: { 0: '週日', 1: '週一', 2: '週二', 3: '週三', 4: '週四', 5: '週五', 6: '週六' },
                origin: {
                    start_time: '',
                    end_time: '',
                    gap: '15',
                    times: {}
                }
            };
            this.postData = {
                start_time: '',
                end_time: '',
                gap: '15',
                times: { 0: [], 1: [], 2: [], 3: [], 4: [], 5: [], 6: [] }
            };
        },
        cancel: function cancel() {
            var _this = this;

            this.view.step = 0;
            this.view.show_edit_btn = this.canUpdate;
            this.postData = _lodash2.default.cloneDeep(this.view.origin);
            this.$nextTick(function () {
                _this.setOriginTimes();
            });
        },
        selectTime: function selectTime(dayOfWeek) {
            var defaultData = this.view.times[dayOfWeek].length;
            var currentData = this.postData.times[dayOfWeek].length;
            if (defaultData === currentData) {
                this.view.selected_days.push(dayOfWeek);
            } else {
                _lodash2.default.pull(this.view.selected_days, dayOfWeek);
            }
        },
        selectDay: function selectDay(dayOfWeek) {
            var isChecked = this.view.selected_days.includes(dayOfWeek);
            this.postData.times[dayOfWeek] = isChecked ? this.view.times[dayOfWeek] : [];
        },
        buildSetting: function buildSetting() {
            var all = {};
            for (var dayOfWeek = 0; dayOfWeek < 7; dayOfWeek++) {
                var newTime = moment(this.postData.start_time, 'HH:mm');
                all[dayOfWeek] = [];
                while (newTime.isSameOrBefore(moment(this.postData.end_time, 'HH:mm'))) {
                    all[dayOfWeek].push(newTime.format('HH:mm'));
                    newTime = moment(newTime.add(this.postData.gap, 'minutes'), 'HH:mm');
                }
                newTime = moment(this.postData.start_time, 'HH:mm');
            }
            this.view.times = all;
        },
        toStep1: function toStep1() {
            var vm = this;
            this.view.show_edit_btn = false;
            this.view.step = 1;
            this.$nextTick(function () {
                $('.timepicker').datetimepicker({
                    stepping: 15,
                    format: 'HH:mm',
                    locale: 'zh-tw'
                }).on('dp.change', function (e) {
                    var name = $(e.target).attr('name');
                    vm.postData[name] = e.date ? e.date.format('HH:mm') : '00:00';
                });
            });
        },
        toStep2: function toStep2() {
            var _this2 = this;

            if (!this.isPeriodOk) {
                $17.swal({
                    title: '開始時間必須早於結束時間',
                    type: 'warning'
                });
                return false;
            }
            this.view.selected_days = [];
            this.postData.times = { 0: [], 1: [], 2: [], 3: [], 4: [], 5: [], 6: [] };
            this.view.step = 2;
            this.$nextTick(function () {
                _this2.buildSetting();
            });
        },
        update: function update() {
            var _this3 = this;

            this.ajaxing = true;
            this.$http.post('/adminapi/custom-service-bookable-setting/update/' + this.selected_branch_id, this.postData).then(function (response) {
                var setting = response.data.setting;
                var times = response.data.times;
                _this3.view.step = 0;
                _this3.view.show_edit_btn = !!_this3.canUpdate;
                _this3.view.origin.times = times;
                _this3.view.origin.gap = setting.gap;
                _this3.view.origin.start_time = setting.start_time;
                _this3.view.origin.end_time = setting.end_time;
                _this3.postData.gap = setting.gap;
                _this3.postData.start_time = setting.start_time;
                _this3.postData.end_time = setting.end_time;
                _this3.ajaxing = false;
            }, function (error) {
                _this3.ajaxing = false;
            });
        },
        getSetting: function getSetting() {
            var _this4 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this4.init();
                                _this4.ajaxing = true;
                                _context.next = 4;
                                return _this4.$http.get('/adminapi/custom-service-bookable-setting/' + _this4.selected_branch_id).then(function (response) {
                                    var setting = response.data.setting;
                                    var times = response.data.times;
                                    _this4.view.show_edit_btn = !!_this4.canUpdate;
                                    if (setting) {
                                        _this4.view.origin.times = times;
                                        _this4.view.origin.gap = setting.gap;
                                        _this4.view.origin.start_time = setting.start_time;
                                        _this4.view.origin.end_time = setting.end_time;
                                        _this4.postData.gap = setting.gap;
                                        _this4.postData.start_time = setting.start_time;
                                        _this4.postData.end_time = setting.end_time;
                                        _this4.$nextTick(function () {
                                            _this4.setOriginTimes();
                                        });
                                    }
                                    _this4.ajaxing = false;
                                }, function (error) {
                                    _this4.ajaxing = false;
                                });

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this4);
            }))();
        },
        setOriginTimes: function setOriginTimes() {
            this.buildSetting();
            var times = this.view.origin.times;
            for (var dayOfWeek in times) {
                this.postData.times[dayOfWeek] = times[dayOfWeek];
                this.selectTime(dayOfWeek);
            }
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"col-xs-12\" _v-5de91330=\"\">\n    <v-select-studio-and-branch :studio_id=\"studioId\" :branch_id=\"branchId\" :branch-without-filtered-option=\"false\" _v-5de91330=\"\">\n    </v-select-studio-and-branch>\n    <div class=\"col-xs-12\" _v-5de91330=\"\">\n        <h3 _v-5de91330=\"\">\n            自訂 - 線上預約時段\n            <button class=\"btn btn-primary\" v-if=\"view.show_edit_btn\" @click=\"toStep1\" _v-5de91330=\"\">編輯</button>\n        </h3>\n    </div>\n    <v-spinner :ajaxing=\"ajaxing\" _v-5de91330=\"\"></v-spinner>\n    <div v-if=\"!ajaxing\" _v-5de91330=\"\">\n        <div class=\"m-top-20 row col-xs-12\" v-if=\"showStep1 || showStep2\" _v-5de91330=\"\">\n            <h4 class=\"m-bottom-20\" _v-5de91330=\"\">步驟一：設定時段條件</h4>\n            <div class=\"form-horizontal\" _v-5de91330=\"\">\n                <div class=\"form-group col-sm-12\" _v-5de91330=\"\">\n                    <label _v-5de91330=\"\">開始時間：</label>\n                    <input type=\"text\" v-model=\"postData.start_time\" :disabled=\"showStep2\" placeholder=\"請選擇開始時間\" style=\"width:150px;\" class=\"timepicker\" name=\"start_time\" _v-5de91330=\"\">\n                </div>\n                <div class=\"form-group col-sm-12\" _v-5de91330=\"\">\n                    <label _v-5de91330=\"\">結束時間：</label>\n                    <input type=\"text\" v-model=\"postData.end_time\" :disabled=\"showStep2\" placeholder=\"請選擇結束時間\" style=\"width: 150px\" class=\"timepicker\" name=\"end_time\" _v-5de91330=\"\">\n                </div>\n            </div>\n            <div class=\"m-top-10 m-bottom-10 clearfix\" _v-5de91330=\"\">\n                <label _v-5de91330=\"\">客戶在線上預約時的間隔時間：</label>\n                <select v-model=\"postData.gap\" :disabled=\"showStep2?'disabled':false\" _v-5de91330=\"\">\n                    <option value=\"15\" _v-5de91330=\"\">15分鐘</option>\n                    <option value=\"30\" _v-5de91330=\"\">30分鐘</option>\n                    <option value=\"60\" _v-5de91330=\"\">1小時</option>\n                </select>\n            </div>\n            <div class=\"m-t-10\" v-if=\"showStep1\" _v-5de91330=\"\">\n                <button class=\"btn btn-default m-right-10\" @click=\"cancel(1)\" _v-5de91330=\"\">取消</button>\n                <button class=\"btn btn-primary\" @click=\"toStep2\" _v-5de91330=\"\">下一步</button>\n            </div>\n        </div>\n\n        <div class=\"m-top-20 m-bottom-30 row col-xs-12\" _v-5de91330=\"\">\n            <h4 v-if=\"showStep2\" class=\"m-bottom-20\" _v-5de91330=\"\">步驟二：設定時段條件</h4>\n            <div v-if=\"showSetting\" class=\"m-bottom-10 clearfix\" _v-5de91330=\"\">\n                <div class=\"col pull-left\" v-for=\"(times,dayOfWeek) in view.times\" _v-5de91330=\"\">\n                    <div class=\"day\" _v-5de91330=\"\">{{view.mapping[dayOfWeek]}}</div>\n                    <div class=\"time\" v-if=\"showStep1 || showStep2\" _v-5de91330=\"\">\n                        <label _v-5de91330=\"\"><input type=\"checkbox\" v-model=\"view.selected_days\" @change=\"selectDay(dayOfWeek)\" :value=\"dayOfWeek\" _v-5de91330=\"\"> 全時段</label>\n                    </div>\n                    <div class=\"time\" v-for=\"time in times\" _v-5de91330=\"\">\n                        <label _v-5de91330=\"\">\n                            <input :disabled=\"showStep0\" type=\"checkbox\" v-model=\"postData.times[dayOfWeek]\" @change=\"selectTime(dayOfWeek)\" :value=\"time\" _v-5de91330=\"\">\n                            {{time}}\n                        </label>\n                    </div>\n                </div>\n            </div>\n            <div class=\"m-top-10 text-center\" v-if=\"showStep2\" _v-5de91330=\"\">\n                <button class=\"btn btn-default m-right-10\" @click=\"cancel(2)\" _v-5de91330=\"\">取消</button>\n                <button class=\"btn btn-primary\" @click=\"update\" _v-5de91330=\"\">確認儲存</button>\n            </div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.col[_v-5de91330] {\n  width: calc(100% / 7); }\n\n/* line 6, stdin */\n.day[_v-5de91330], .time[_v-5de91330] {\n  padding: 10px;\n  text-align: center; }\n\n/* line 11, stdin */\n.day[_v-5de91330] {\n  border-bottom: 1px solid #000; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-5de91330", module.exports)
  } else {
    hotAPI.update("_v-5de91330", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/object/keys":56,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1131:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        studioId: {
            default: null
        }
    },
    methods: {
        clearAllTemporaryCustomers: function clearAllTemporaryCustomers() {
            this.$http.post('/adminapi/customers/temporary/delete', {
                'studio_id': this.studioId
            }).then(function (response) {
                $17.swal({
                    title: '已清除暫存客戶名單',
                    type: 'success',
                    showCancelButton: false
                });
            }, function (error) {
                $17.swal({
                    title: '發生錯誤',
                    type: 'error',
                    showCancelButton: false
                });
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<a href=\"javascript:void(0)\" @click=\"clearAllTemporaryCustomers\">清除</a>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-e2f7843e", module.exports)
  } else {
    hotAPI.update("_v-e2f7843e", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1132:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _deleteTempCustomer = require('./delete-temp-customer.vue');

var _deleteTempCustomer2 = _interopRequireDefault(_deleteTempCustomer);

var _selectStudioServants = require('./select-studio-servants.vue');

var _selectStudioServants2 = _interopRequireDefault(_selectStudioServants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//Page
_vue2.default.component('webadmin-delete-temp-customer', _deleteTempCustomer2.default);
_vue2.default.component('webadmin-select-studio-servants', _selectStudioServants2.default);

},{"./delete-temp-customer.vue":1131,"./select-studio-servants.vue":1135,"vue":792}],1133:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.panel-body > .clearfix[_v-20283036] {\n  margin-top: 15px; }\n\n/* line 6, stdin */\n.checkbox-text[_v-20283036] {\n  font-size: 14px;\n  margin-left: 3px; }\n\n/* line 11, stdin */\ninput[type=\"checkbox\"][_v-20283036] {\n  position: inherit; }\n\n/* line 15, stdin */\n.checkbox label[_v-20283036] {\n  padding-left: 0; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            pageSize: 25,
            temporaryPageSize: 99999,
            customerList: '',
            view: {
                list: [],
                ajaxing: false,
                pageMeta: {},
                tags: [],
                ajax: {
                    tag: false,
                    csv: false,
                    customerList: false
                },
                memberId: '',
                filters: {
                    white_tags: '',
                    black_tags: '',
                    white_type: 1,
                    black_type: 1,
                    gender: 2,
                    start_date: '',
                    end_date: '',
                    age_start: '',
                    age_end: '',
                    birthday_month: '',
                    birthday_day: '',
                    field_name: 'all',
                    field_value: '',
                    use_temporary_customers: 0,
                    servant: null
                },
                servantCheck: true
            },
            jquery: $
        };
    },
    watch: {},
    mounted: function mounted() {
        var vm = this;
        this.$nextTick(function () {
            $('.datepicker-vue').datetimepicker({
                format: 'YYYY-MM-DD',
                widgetPositioning: {
                    horizontal: 'right',
                    vertical: 'bottom'
                }
            }).on("dp.change", function (e) {
                var current = $(e.target);
                var name = current.attr('name');
                var value = $(this).val();
                vm.view.filters[name] = value;
            });
        });
        $('#filter-collapse').on('hidden.bs.collapse', function () {
            $('#filter-arrow').attr('class', 'icon-arrow fa fa-lg fa-angle-right');
        }).on('shown.bs.collapse', function () {
            $('#filter-arrow').attr('class', 'icon-arrow fa fa-lg fa-angle-down');
        });
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'isSeventeen']), (0, _vuex.mapState)('filters', ['selected_studio_id']), {
        studio_id: function studio_id() {
            var sid = 0;
            if (this.isSeventeen) {
                sid = this.selected_studio_id;
            } else {
                sid = this.studioId;
            }
            this.getTags(sid);
            return sid;
        }
    }),
    methods: {
        showCustomerListModal: function showCustomerListModal() {
            var _this = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this.callTemporaryListAPI(_this.temporaryPageSize);

                            case 2:
                                $('#customer-list-modal').modal('show');

                            case 3:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        getCustomers: function getCustomers() {
            var memberIds = '';
            for (var i = 0; i < this.customerList.length; i++) {
                if (i === this.customerList.length - 1) {
                    memberIds += this.customerList[i].id;
                } else {
                    memberIds += this.customerList[i].id + ',';
                }
            }
            return memberIds;
        },

        showModal: function showModal(memberId) {
            this.view.memberId = memberId;
            this.$store.dispatch('webadmin/crm/getMember', { memberId: memberId });
            window.Event.$emit('changeCurrentView');
            window.Event.$emit('resetData');
            window.Event.$emit('fetchMemberTagList', memberId);
            window.Event.$emit('fetchUpcoming', memberId);
            window.Event.$emit('fetchMemberContract', memberId);
            window.Event.$emit('fetchMemberStatus', memberId);
            $('#crm').modal('show');
        },
        getTags: function getTags(sid) {
            var _this2 = this;

            this.view.ajax.tag = true;
            this.$http.get('/adminapi/studio_branch_resources/tags?studio_id=' + sid).then(function (response) {
                if (response.body.length > 0) {
                    _this2.view.tags = response.body;
                }
                _this2.view.ajax.tag = false;
            }, function (error) {
                _this2.view.ajax.tag = false;
            });
        },
        searchList: function searchList() {
            this.$store.dispatch('filters/updateQueryStrings', { page: 1 });
            this.fetchList();
        },
        initList: function initList() {
            for (param in this.view.filters) {
                this.$data.view.filters[param] = this.getUrlParamValue(param);
            }
            this.fetchList();
        },
        formValidator: function formValidator(fetch) {
            var msg = '';
            if (this.view.filters.start_date === '' && this.view.filters.end_date !== '') {
                msg = '請選擇建立日期範圍';
            } else if (this.view.filters.start_date !== '' && this.view.filters.end_date === '') {
                msg = '請選擇建立日期範圍';
            } else if (this.view.filters.age_start === '' && this.view.filters.age_end !== '') {
                msg = '請選擇年齡範圍';
            } else if (this.view.filters.age_start !== '' && this.view.filters.age_end === '') {
                msg = '請選擇年齡範圍';
            } else if (this.view.filters.birthday_month !== '' && this.view.filters.birthday_day !== '') {
                var maxDaysInMonth = new Date(new Date().getFullYear(), this.view.filters.birthday_month, 0).getDate();
                var wrongFeb = this.view.filters.birthday_month === 2 && this.view.filters.birthday_day > 29;
                var wrongOthers = this.view.filters.birthday_month !== 2 && this.view.filters.birthday_day > maxDaysInMonth;
                if (wrongFeb || wrongOthers) {
                    msg = '生日範圍為無效日期';
                }
            } else if (!this.view.servantCheck) {
                msg = '請選擇關聯人員';
            }
            if (msg !== '') {
                $17.swal({
                    title: msg,
                    showCancelButton: false
                });
            } else {
                fetch(this.pageSize);
            }
        },
        fetchList: function fetchList() {
            if (!this.studio_id || this.studio_id == 0) {
                if (this.isSeventeen) {
                    $17.swal({
                        title: '請選擇品牌',
                        type: 'error',
                        showCancelButton: false
                    });
                } else {
                    return false;
                }
            } else {
                this.formValidator(this.callListAPI);
            }
        },

        getPayload: function getPayload(pageSize) {
            return {
                studio_id: this.studio_id,
                start: this.view.filters.start_date,
                end: this.view.filters.end_date,
                white_tags: this.view.filters.white_tags,
                black_tags: this.view.filters.black_tags,
                white_type: this.view.filters.white_type,
                black_type: this.view.filters.black_type,
                gender: this.view.filters.gender,
                age_start: this.view.filters.age_start,
                age_end: this.view.filters.age_end,
                birthday_month: this.monthDayLeadingZero(this.view.filters.birthday_month),
                birthday_day: this.monthDayLeadingZero(this.view.filters.birthday_day),
                field_name: this.view.filters.field_name,
                field_value: this.view.filters.field_value,
                use_temporary_customers: this.view.filters.use_temporary_customers === true ? 1 : 0,
                page_size: pageSize,
                page: this.getUrlParamValue('page') ? this.getUrlParamValue('page') : 1,
                servant_type_id: this.view.filters.servant ? this.view.filters.servant.type_id : '',
                servant_member_id: this.view.filters.servant ? this.view.filters.servant.member_id : '',
                servant_studio_id: this.view.filters.servant ? this.view.filters.servant.studio_id : '',
                servant_branch_id: this.view.filters.servant ? this.view.filters.servant.branch_id : 0
            };
        },
        monthDayLeadingZero: function monthDayLeadingZero(value) {
            if (!value) {
                return;
            } else {
                return ("0" + value).slice(-2);
            }
        },

        callListAPI: function callListAPI(pageSize) {
            var _this3 = this;

            var payload = this.getPayload(pageSize);
            this.view.ajaxing = true;
            this.$http.post('/adminapi/customers', payload).then(function (response) {
                this.view.list = response.data.list;
                this.view.pageMeta = response.data.pageMeta;
                this.$store.dispatch('filters/updateQueryStrings', payload.params);
                this.view.ajaxing = false;
            }, function (error) {
                _this3.view.ajaxing = false;
            });
        },
        callTemporaryListAPI: function () {
            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(pageSize) {
                var _this4 = this;

                var payload;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                payload = this.getPayload(pageSize);

                                this.view.ajax.customerList = true;
                                _context2.next = 4;
                                return this.$http.post('/adminapi/customers', payload).then(function (response) {
                                    this.customerList = response.data.list;
                                    var customers = this.getCustomers();
                                    this.$refs.customerListModal.setCustomers(customers);
                                    this.view.ajax.customerList = false;
                                }, function (error) {
                                    _this4.view.ajax.customerList = false;
                                });

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function callTemporaryListAPI(_x) {
                return _ref.apply(this, arguments);
            }

            return callTemporaryListAPI;
        }(),
        refresh: function refresh() {
            this.view.ajaxing = true;
            this.fetchList();
        },
        exportCustomerListModal: function exportCustomerListModal() {
            var _this5 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
                var result;
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return _this5.callExportListData();

                            case 2:
                                result = _this5.csvDataHandler(_this5.customerList);

                                _this5.download(result);

                            case 4:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this5);
            }))();
        },
        callExportListData: function callExportListData() {
            var _this6 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
                var payload;
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                payload = _this6.getPayload(_this6.temporaryPageSize);

                                _this6.view.ajax.csv = true;
                                _context4.next = 4;
                                return _this6.$http.post('/adminapi/customers', payload).then(function (response) {
                                    this.customerList = response.data.list;
                                    this.view.ajax.csv = false;
                                }, function (error) {
                                    _this6.view.ajax.csv = false;
                                });

                            case 4:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this6);
            }))();
        },
        csvDataHandler: function csvDataHandler(listData) {
            var data = [];
            _lodash2.default.assign(data, listData);
            data = this.columnFormatter(data);
            return Papa.unparse(data, {
                delimiter: ','
            });
        },
        columnFormatter: function columnFormatter(data) {
            String.prototype.replaceAll = function (search, replacement) {
                var target = this;
                return target.replace(new RegExp(search, 'g'), replacement);
            };
            return this.columnCustomFormatter(data);
        },
        columnCustomFormatter: function columnCustomFormatter(data) {
            var results = _lodash2.default.map(data, function (value) {
                return _lodash2.default.pick(value, ['name', 'phone', 'email']);
            });
            results = (0, _stringify2.default)(results);
            results = results.replaceAll('name', '姓名');
            results = results.replaceAll('phone', '手機');
            results = results.replaceAll('email', '信箱');

            return results;
        },
        download: function download(_csvString) {
            var downloadLink = document.createElement("a");
            downloadLink.download = "客戶進階搜尋.csv";
            downloadLink.innerHTML = "Download File";
            if (window.webkitURL != null) {
                var code = encodeURIComponent(_csvString);
                downloadLink.href = "data:application/csv;charset=utf-8,%EF%BB%BF" + code;
            }
            downloadLink.click();
        },
        setServant: function setServant(event) {
            this.view.filters.servant = event.servant;
        },
        setServantCheck: function setServantCheck(check) {
            this.view.servantCheck = check;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"col-xs-12\" _v-20283036=\"\">\n    <div id=\"filter-collapse\" class=\"group panel panel-default\" _v-20283036=\"\">\n\n        <div role=\"tab\" data-toggle=\"collapse\" href=\"#filters\" class=\"panel-heading\" aria-expanded=\"true\" _v-20283036=\"\">\n            <h4 class=\"panel-title\" _v-20283036=\"\">\n                <i id=\"filter-arrow\" class=\"icon-arrow fa fa-lg fa-angle-down\" _v-20283036=\"\"></i>\n                &nbsp; 篩選條件\n            </h4>\n        </div>\n\n        <div id=\"filters\" role=\"tabpanel\" class=\"panel-collapse collapse in\" aria-expanded=\"true\" _v-20283036=\"\">\n            <div class=\"p-top-10 p-bottom-10 panel-body inner-div\" _v-20283036=\"\">\n                <div class=\"col-xs-12\" _v-20283036=\"\">\n                    <v-select-studio-and-branch v-if=\"isSeventeen\" :show-branch=\"false\" :studio_id=\"studioId\" :studio-change-call-back=\"getTags\" :branch-without-filtered-option=\"true\" _v-20283036=\"\">\n                    </v-select-studio-and-branch>\n                </div>\n\n                <div class=\"col-xs-12\" _v-20283036=\"\">\n                    <div class=\"form-horizontal\" _v-20283036=\"\">\n                        <div class=\"form-group\" _v-20283036=\"\">\n                            <label class=\"col-lg-3 col-md-3 control-label\" _v-20283036=\"\">包含的客戶標籤</label>\n                            <div class=\"col-lg-6 col-md-6\" _v-20283036=\"\">\n                                <v-mutiselect :model.sync=\"view.filters.white_tags\" :options=\"view.tags\" :multiple=\"true\" :close-on-select=\"true\" :clear-on-select=\"true\" :searchable=\"true\" label=\"name\" track-by=\"id\" tag-name=\"name\" placeholder=\"請選擇客戶標籤\" class=\"m-bottom-10\" :is-loading=\"view.ajax.tag\" _v-20283036=\"\"></v-mutiselect>\n                            </div>\n                            <div class=\"col-lg-3 col-md-3\" _v-20283036=\"\">\n                                <input type=\"radio\" value=\"1\" name=\"white_type\" id=\"white_and\" v-model=\"view.filters.white_type\" _v-20283036=\"\">\n                                <label class=\"m-left-5 m-right-15\" for=\"white_and\" _v-20283036=\"\">全部符合</label>\n                                <input type=\"radio\" value=\"0\" name=\"white_type\" id=\"white_or\" v-model=\"view.filters.white_type\" _v-20283036=\"\">\n                                <label class=\"m-left-5 m-right-15\" for=\"white_or\" _v-20283036=\"\">任一符合</label>\n                            </div>\n                        </div>\n\n                        <div class=\"form-group\" _v-20283036=\"\">\n                            <label class=\"col-lg-3 col-md-3 control-label\" _v-20283036=\"\">排除的客戶標籤</label>\n                            <div class=\"col-lg-6 col-md-6\" _v-20283036=\"\">\n                                <v-mutiselect :model.sync=\"view.filters.black_tags\" :options=\"view.tags\" :multiple=\"true\" :close-on-select=\"true\" :clear-on-select=\"true\" :searchable=\"true\" label=\"name\" track-by=\"id\" tag-name=\"name\" placeholder=\"請選擇客戶標籤\" class=\"m-bottom-10\" :is-loading=\"view.ajax.tag\" _v-20283036=\"\"></v-mutiselect>\n                            </div>\n                            <div class=\"col-lg-3 col-md-3\" _v-20283036=\"\">\n                                <input type=\"radio\" value=\"1\" name=\"black_type\" id=\"black_and\" v-model=\"view.filters.black_type\" _v-20283036=\"\">\n                                <label class=\"m-left-5 m-right-15\" for=\"black_and\" _v-20283036=\"\">全部符合</label>\n\n                                <input type=\"radio\" value=\"0\" name=\"black_type\" id=\"black_or\" v-model=\"view.filters.black_type\" _v-20283036=\"\">\n                                <label class=\"m-left-5 m-right-15\" for=\"black_or\" _v-20283036=\"\">任一符合</label>\n                            </div>\n                        </div>\n\n                        <div class=\"form-group\" _v-20283036=\"\">\n                            <label class=\"col-lg-3 col-md-3 control-label\" _v-20283036=\"\">客戶建立日期</label>\n                            <div class=\"col-lg-9 col-md-9\" _v-20283036=\"\">\n                                <div class=\"input-group pull-left\" style=\"width: 100px; padding-right:10px\" _v-20283036=\"\">\n                                    <span class=\"input-group-addon\" _v-20283036=\"\">開始日期</span>\n                                    <input type=\"text\" class=\"input-sm datepicker-vue\" id=\"start_date\" name=\"start_date\" v-model=\"view.filters.start_date\" lazy=\"\" _v-20283036=\"\">\n                                </div>\n                                <div class=\"input-group pull-left\" style=\"width: 100px\" _v-20283036=\"\">\n                                    <span class=\"input-group-addon\" _v-20283036=\"\">結束日期</span>\n                                    <input type=\"text\" class=\"input-sm datepicker-vue\" id=\"end_date\" name=\"end_date\" v-model=\"view.filters.end_date\" lazy=\"\" _v-20283036=\"\">\n                                </div>\n                            </div>\n                        </div>\n\n                        <div class=\"form-group\" _v-20283036=\"\">\n                            <label class=\"col-lg-3 col-md-3 control-label\" _v-20283036=\"\">性別</label>\n                            <div class=\"col-lg-9 col-md-9\" _v-20283036=\"\">\n                                <input type=\"radio\" value=\"2\" name=\"gender\" id=\"gender-all\" v-model=\"view.filters.gender\" _v-20283036=\"\"><label class=\"m-left-5 m-right-15\" for=\"gender-all\" _v-20283036=\"\">不限</label>\n                                <input type=\"radio\" value=\"1\" name=\"gender\" id=\"gender-1\" v-model=\"view.filters.gender\" _v-20283036=\"\"><label class=\"m-left-5 m-right-15\" for=\"gender-1\" _v-20283036=\"\">男</label>\n                                <input type=\"radio\" value=\"0\" name=\"gender\" id=\"gender-0\" v-model=\"view.filters.gender\" _v-20283036=\"\"><label class=\"m-left-5 m-right-15\" for=\"gender-0\" _v-20283036=\"\">女</label>\n                            </div>\n                        </div>\n\n                        <div class=\"form-group\" _v-20283036=\"\">\n                            <label class=\"col-lg-3 col-md-3 control-label\" _v-20283036=\"\">生日</label>\n                            <div class=\"col-lg-9 col-md-9\" _v-20283036=\"\">\n                                <select class=\"input-sm\" style=\"width:120px\" v-model=\"view.filters.birthday_month\" _v-20283036=\"\">\n                                    <option value=\"\" _v-20283036=\"\">月</option>\n                                    <option v-for=\"birthday_month in 12\" :value=\"birthday_month\" _v-20283036=\"\">{{ birthday_month\n                                        }}\n                                    </option>\n                                </select>\n                                <span class=\"p-left-10 p-right-10\" _v-20283036=\"\">/</span>\n                                <select class=\"input-sm\" style=\"width:120px\" v-model=\"view.filters.birthday_day\" _v-20283036=\"\">\n                                    <option value=\"\" _v-20283036=\"\">日</option>\n                                    <option v-for=\"birthday_day in 31\" :value=\"birthday_day\" _v-20283036=\"\">{{ birthday_day }}\n                                    </option>\n                                </select>\n                            </div>\n                        </div>\n\n                        <div class=\"form-group\" _v-20283036=\"\">\n                            <label class=\"col-lg-3 col-md-3 control-label\" _v-20283036=\"\">年齡</label>\n                            <div class=\"col-lg-9 col-md-9\" _v-20283036=\"\">\n                                <select class=\"input-sm\" style=\"width:120px\" v-model=\"view.filters.age_start\" _v-20283036=\"\">\n                                    <option value=\"\" _v-20283036=\"\">請選擇</option>\n                                    <option v-for=\"age in 99\" :value=\"age\" _v-20283036=\"\">{{ age }}</option>\n                                </select>\n                                <span class=\"p-left-10 p-right-10\" _v-20283036=\"\">~</span>\n                                <select class=\"input-sm\" style=\"width:120px\" v-model=\"view.filters.age_end\" _v-20283036=\"\">\n                                    <option value=\"\" _v-20283036=\"\">請選擇</option>\n                                    <option v-for=\"age in 99\" :value=\"age\" _v-20283036=\"\">{{ age }}</option>\n                                </select>\n                            </div>\n                        </div>\n\n                        <div class=\"form-group\" _v-20283036=\"\">\n                            <label class=\"col-lg-3 col-md-3 control-label\" _v-20283036=\"\">欄位</label>\n                            <div class=\"col-lg-9 col-md-9\" _v-20283036=\"\">\n                                <div class=\"input-group\" _v-20283036=\"\">\n                                    <select class=\"nput-group-addon input-sm\" style=\"width:120px;margin-right:10px\" v-model=\"view.filters.field_name\" _v-20283036=\"\">\n                                        <option value=\"all\" _v-20283036=\"\">不限</option>\n                                        <option value=\"name\" _v-20283036=\"\">姓名</option>\n                                        <option value=\"phone\" _v-20283036=\"\">手機</option>\n                                        <option value=\"email\" _v-20283036=\"\">Email</option>\n                                        <option value=\"address\" _v-20283036=\"\">住址</option>\n                                    </select>\n                                    <input class=\"input-sm\" style=\"width:145px\" type=\"text\" value=\"\" v-model=\"view.filters.field_value\" _v-20283036=\"\">\n                                </div>\n                            </div>\n                        </div>\n\n                        <div class=\"form-group\" _v-20283036=\"\">\n                            <div class=\"col-sm-offset-3 col-sm-9\" _v-20283036=\"\">\n                                <div class=\"checkbox\" _v-20283036=\"\">\n                                    <label class=\"\" for=\"use_temporary_customers\" _v-20283036=\"\">\n                                        <input type=\"checkbox\" id=\"use_temporary_customers\" name=\"use_temporary_customers\" v-model=\"view.filters.use_temporary_customers\" _v-20283036=\"\">\n                                        <span class=\"checkbox-text\" _v-20283036=\"\">使用暫存客戶名單</span>\n                                    </label>\n                                    <webadmin-delete-temp-customer :studio-id=\"selected_studio_id\" _v-20283036=\"\"></webadmin-delete-temp-customer>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"clearfix\" _v-20283036=\"\">\n                            <label class=\"col-lg-3 col-md-3 col-xs-12 p-top-5 text-right\" for=\"\" _v-20283036=\"\">關聯人員</label>\n                            <div class=\"col-lg-9 col-md-9 col-xs-12\" _v-20283036=\"\">\n                                <webadmin-select-studio-servants :studio-id=\"studio_id\" @update-servant=\"setServant($event)\" @servant-selected-check=\"setServantCheck($event)\" _v-20283036=\"\"></webadmin-select-studio-servants>\n                            </div>\n                        </div>\n                        <div class=\"form-group m-bottom-15\" _v-20283036=\"\">\n                            <div class=\"col-sm-offset-3 col-sm-3 col-xs-12 p-top-15\" _v-20283036=\"\">\n                                <button class=\"btn btn-primary col-md-12\" type=\"button\" @click=\"searchList\" _v-20283036=\"\">顯示於網頁\n                                </button>\n                            </div>\n                            <div class=\"col-sm-6 col-xs-12 text-right p-top-15\" _v-20283036=\"\">\n                                <button class=\"btn btn-default\" type=\"button\" @click=\"exportCustomerListModal\" _v-20283036=\"\">\n                                    <span _v-20283036=\"\">匯出CSV</span><i v-show=\"view.ajax.csv\" class=\"fa fa-spin fa-spinner\" _v-20283036=\"\"></i>\n                                </button>\n                                <button class=\"btn btn-default\" type=\"button\" @click=\"showCustomerListModal\" _v-20283036=\"\">\n                                    <span _v-20283036=\"\">加入到暫存客戶名單</span><i v-show=\"view.ajax.customerList\" class=\"fa fa-spin fa-spinner\" _v-20283036=\"\"></i>\n                                </button>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n            <v-spinner :ajaxing=\"view.ajaxing\" _v-20283036=\"\"></v-spinner>\n            <div v-show=\"!view.ajaxing\" _v-20283036=\"\">\n                <div class=\"table-responsive m-top-20 m-bottom-20\" v-if=\"Object.keys(this.view.list).length>0\" _v-20283036=\"\">\n                    <table class=\"table table-hover service-bookings-table\" _v-20283036=\"\">\n                        <thead _v-20283036=\"\">\n                        <tr _v-20283036=\"\">\n                            <th _v-20283036=\"\">姓名</th>\n                            <th _v-20283036=\"\">手機</th>\n                            <th _v-20283036=\"\">信箱</th>\n                        </tr>\n                        </thead>\n                        <tbody _v-20283036=\"\">\n                        <tr v-for=\"member in view.list\" _v-20283036=\"\">\n                            <td _v-20283036=\"\">\n                                <a class=\"modal-link\" data-toggle=\"modal\" @click=\"showModal(member.id)\" _v-20283036=\"\">\n                                    {{member.name}}\n                                </a>\n                            </td>\n                            <td _v-20283036=\"\">{{ member.phone }}</td>\n                            <td _v-20283036=\"\">{{ member.email }}</td>\n                        </tr>\n                        </tbody>\n                    </table>\n                </div>\n                <v-sql-pagination ref=\"pager\" :page-meta=\"view.pageMeta\" @page-change-callback=\"fetchList\" _v-20283036=\"\">\n                </v-sql-pagination>\n                <h3 class=\"m-top-20 m-bottom-20\" v-if=\"Object.keys(this.view.list).length === 0\" _v-20283036=\"\">無搜尋結果</h3>\n            </div>\n\n            <crm-home :member-id=\"view.memberId\" :studio-id=\"studio_id\" _v-20283036=\"\">\n            </crm-home>\n            <customer-list-modal :studio-id=\"selected_studio_id\" ref=\"customerListModal\" _v-20283036=\"\"></customer-list-modal>\n\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.panel-body > .clearfix[_v-20283036] {\n  margin-top: 15px; }\n\n/* line 6, stdin */\n.checkbox-text[_v-20283036] {\n  font-size: 14px;\n  margin-left: 3px; }\n\n/* line 11, stdin */\ninput[type=\"checkbox\"][_v-20283036] {\n  position: inherit; }\n\n/* line 15, stdin */\n.checkbox label[_v-20283036] {\n  padding-left: 0; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-20283036", module.exports)
  } else {
    hotAPI.update("_v-20283036", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/json/stringify":48,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1134:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n.desc {\n    color: #bfbfbf;\n}\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        studioId: {
            default: null
        }
    },
    data: function data() {
        return {
            view: {
                ajaxing: false
            },
            type: 1,
            customers: ''
        };
    },
    mounted: function mounted() {},

    created: function created() {},
    watch: {},
    computed: {},
    methods: {
        action: function action() {
            var _this = this;

            this.view.ajaxing = true;
            this.$http.post('/adminapi/customers/temporary', {
                customers: this.customers,
                type: this.type,
                'studio_id': this.studioId
            }).then(function (response) {
                _this.view.ajaxing = false;
                $('#customer-list-modal').modal('hide');
                $17.swal({
                    title: '更新成功',
                    text: '暫存名單：' + response.data + '人',
                    type: 'success',
                    showCancelButton: false
                });
            }, function (error) {
                $17.swal({
                    title: error.body.message,
                    type: 'warning'
                });
                _this.view.ajaxing = false;
            });
        },
        setCustomers: function setCustomers(customers) {
            this.customers = customers;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div id=\"customer-list-modal\" class=\"modal fade\" data-backdrop=\"static\" data-keyboard=\"false\" role=\"dialog\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n\n            <div class=\"modal-header\">\n                <button type=\"button\" v-show=\"!view.ajaxing\" class=\"close\" data-dismiss=\"modal\">×</button>\n                <h4 class=\"modal-title\">加入到暫存客戶名單</h4>\n            </div>\n\n            <div class=\"modal-body\">\n                <v-spinner :ajaxing=\"view.ajaxing\"></v-spinner>\n                <div v-show=\"!view.ajaxing\" class=\"p-left-30 p-top-30 p-bottom-30\">\n                    <div class=\"m-bottom-15\"><input type=\"radio\" id=\"action-type1\" v-model=\"type\" value=\"1\"><label for=\"action-type1\" class=\"m-left-3\">加入</label> - <label for=\"action-type1\" class=\"m-left-10 desc\"> 將這些客戶加入暫存名單 </label></div>\n                    <div class=\"m-bottom-15\"><input type=\"radio\" id=\"action-type2\" v-model=\"type\" value=\"2\"><label for=\"action-type2\" class=\"m-left-3\">移除</label> - <label for=\"action-type2\" class=\"m-left-10 desc\"> 將這些客戶從暫存名單中移除 </label></div>\n                    <div class=\"\"><input type=\"radio\" v-model=\"type\" id=\"action-type3\" value=\"3\"><label for=\"action-type3\" class=\"m-left-3\">置換</label> - <label for=\"action-type3\" class=\"m-left-10 desc\"> 將暫存名單完全置換成這些客戶 </label></div>\n                </div>\n            </div>\n\n            <div class=\"modal-footer text-right\">\n                <button type=\"button\" class=\"btn btn-primary\" @click=\"action\">確認\n                </button>\n            </div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n.desc {\n    color: #bfbfbf;\n}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-e31be11e", module.exports)
  } else {
    hotAPI.update("_v-e31be11e", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1135:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        studioId: {
            default: null
        }
    },
    data: function data() {
        return {
            servantTypes: [],
            servants: [],
            branchList: [],
            selectedType: null,
            selectedBranch: null,
            selectedServant: null,
            ajaxing: {
                type: false,
                branch: false,
                servants: false
            }
        };
    },
    mounted: function mounted() {
        this.getServantTypes();
        this.getBranchList();
    },

    computed: {
        servantSelectedCheck: function servantSelectedCheck() {
            return !(this.selectedType != null && this.selectedServant == null);
        }
    },
    watch: {
        studioId: function studioId() {
            this.getServantTypes();
            this.getBranchList();
            this.servants = [];
            this.branchList = [];
            this.selectedType = [];
            this.selectedBranch = null;
            this.selectedServant = null;
            this.selectedType = null;
        },
        selectedType: function selectedType() {
            this.getStudioCustomerServants();
            this.servants = [];
            this.selectedServant = null;
            this.emitChangeStatus();
        },
        selectedBranch: function selectedBranch() {
            this.getStudioCustomerServants();
            this.servants = [];
            this.selectedServant = null;
            this.emitChangeStatus();
        },
        selectedServant: function selectedServant(newVal) {
            this.emitChangeStatus();
            this.$emit('update-servant', { 'servant': newVal });
        }
    },
    methods: {
        getServantTypes: function getServantTypes() {
            var _this = this;

            if (!this.studioId || this.studioId == 0) {
                return;
            }
            this.ajaxing.type = true;
            this.$http.get('/adminapi/servant/available-servant-type', {
                params: {
                    'studio_id': this.studioId
                }
            }).then(function (response) {
                if (response.body.length > 0) {
                    _this.servantTypes = response.body;
                }
                _this.ajaxing.type = false;
            }, function (error) {
                $17.swal({
                    title: '讀取人員類型發生錯誤',
                    type: 'error',
                    showCancelButton: false
                });
                _this.ajaxing.type = false;
            });
        },
        getBranchList: function getBranchList() {
            var _this2 = this;

            if (!this.studioId || this.studioId == 0) return;
            this.ajaxing.branch = true;
            this.$http.get('/adminapi/init/branch_select_list?studio_id=' + this.studioId).then(function (response) {
                var branches = [];
                branches = response.data.branches;
                branches.unshift({
                    branch_name: "品牌",
                    id: 0
                });
                _this2.branchList = response.data.branches;
                _this2.ajaxing.branch = false;
            }, function (error) {
                $17.swal({
                    title: '讀取場館發生錯誤',
                    type: 'error',
                    showCancelButton: false
                });
                _this2.ajaxing.branch = false;
            });
        },
        getStudioCustomerServants: function getStudioCustomerServants() {
            var _this3 = this;

            if (!this.selectedType || !this.studioId || !this.selectedBranch) {
                return;
            }
            this.ajaxing.servant = true;
            this.$http.get('/adminapi/servant/studio-customer-servants', {
                params: {
                    'studio_id': this.studioId,
                    'branch_id': this.selectedBranch.id,
                    'customer_servant_type_id': this.selectedType.id
                }
            }).then(function (response) {
                if (response.body.length > 0) {
                    _this3.servants = response.body;
                }
                _this3.ajaxing.servant = false;
            }, function (error) {
                $17.swal({
                    title: '讀取人員發生錯誤',
                    type: 'error',
                    showCancelButton: false
                });
                _this3.ajaxing.servant = false;
            });
        },
        emitChangeStatus: function emitChangeStatus() {
            this.$emit('servant-selected-check', this.servantSelectedCheck);
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n    <div class=\"clearfix\">\n         <div>\n             <v-mutiselect v-show=\"!ajaxing.type\" :model.sync=\"selectedType\" :options=\"servantTypes\" :multiple=\"false\" :close-on-select=\"true\" :clear-on-select=\"true\" :searchable=\"true\" label=\"name\" track-by=\"id\" tag-name=\"name\" placeholder=\"請選擇人員類型\" class=\"m-bottom-10 p-left-0 col-lg-3 col-md-3 col-xs-6\"></v-mutiselect>\n             <v-spinner-button :ajaxing=\"ajaxing.type\" fa-size=\"fa-3x\"></v-spinner-button>\n             <v-mutiselect v-show=\"selectedType &amp;&amp; !ajaxing.branch\" :model.sync=\"selectedBranch\" :options=\"branchList\" :multiple=\"false\" :close-on-select=\"true\" :clear-on-select=\"true\" :searchable=\"true\" label=\"branch_name\" track-by=\"id\" tag-name=\"branch_name\" placeholder=\"請選擇場館\" class=\"m-bottom-10 col-lg-3 col-md-3 col-xs-6\"></v-mutiselect>\n             <v-spinner-button :ajaxing=\"selectedType &amp;&amp; ajaxing.branch\" fa-size=\"fa-3x\"></v-spinner-button>\n             <v-mutiselect v-show=\"selectedType &amp;&amp; !ajaxing.servant\" :model.sync=\"selectedServant\" :options=\"servants\" :multiple=\"false\" :close-on-select=\"true\" :clear-on-select=\"true\" :searchable=\"true\" label=\"member_name\" track-by=\"member_id\" tag-name=\"member_name\" placeholder=\"請選擇人員\" class=\"m-bottom-10 col-lg-3 col-md-3 col-xs-6\"></v-mutiselect>\n             <v-spinner-button :ajaxing=\"selectedType &amp;&amp; ajaxing.servant\" fa-size=\"fa-3x\"></v-spinner-button>\n     </div>\n</div>"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-ff0d9bd8", module.exports)
  } else {
    hotAPI.update("_v-ff0d9bd8", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1136:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _bar = require('../../../utilities/webadmin/chart/bar.js');

var _bar2 = _interopRequireDefault(_bar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        BarChart: _bar2.default
    },
    props: {
        responseObj: {
            type: Object,
            default: function _default() {
                return {
                    labels: null,
                    datasets: null
                };
            }
        },
        ajaxing: {
            type: Boolean,
            default: false
        },
        scalesOptions: {
            type: Object
        }
    },
    data: function data() {
        return {
            default_options: {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: false
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            min: 0,
                            beginAtZero: true,
                            callback: function callback(value, index, values) {
                                return Intl.NumberFormat().format(value);
                                // return '$' + Intl.NumberFormat().format((value / 1000)) + 'K';
                            }
                        }
                    }]
                }
            },
            default_attr: {
                width: 400,
                height: 200
            }
        };
    },

    computed: {
        attrs: function attrs() {
            return (0, _assign2.default)(this.default_attr, this.$attrs);
        },
        chartOptions: function chartOptions() {
            var o = (0, _assign2.default)(this.default_options, {});
            var vue = this;
            if (this.scalesOptions) {
                o.scales = this.scalesOptions;
            }
            if (this.responseObj.hasOwnProperty('extra') && this.responseObj.extra.hasOwnProperty('customToolTipTitles')) {
                o['tooltips'] = {
                    callbacks: {
                        title: function title(tooltipItems, data) {
                            var tooltipItem = tooltipItems[0];
                            var customToolTipTitles = vue.responseObj.extra.customToolTipTitles;
                            return customToolTipTitles[tooltipItem.index];
                        }
                    }
                };
            }
            return o;
        },
        chartData: function chartData() {
            return {
                labels: this.responseObj.labels,
                datasets: this.responseObj.datasets
            };
        }
    },
    methods: {}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"chart\" _v-37a5dd38=\"\">\n    <v-spinner-button :style=\"{width: '100%','line-height':default_attr.height+'px',height:default_attr.height+'px'}\" :ajaxing=\"ajaxing\" fa-size=\"fa-2x\" class=\"text-center\" _v-37a5dd38=\"\"></v-spinner-button>\n    <bar-chart v-show=\"!ajaxing\" :chart-data=\"chartData\" :options=\"chartOptions\" v-bind=\"attrs\" _v-37a5dd38=\"\"></bar-chart>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-37a5dd38", module.exports)
  } else {
    hotAPI.update("_v-37a5dd38", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"../../../utilities/webadmin/chart/bar.js":1561,"babel-runtime/core-js/object/assign":50,"vue":792,"vue-hot-reload-api":785}],1137:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.transformDataMatchAxes = exports.chartAxesHelper = exports.dateRangeHelper = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.dateRangeHelper = dateRangeHelper;
exports.chartAxesHelper = chartAxesHelper;
exports.transformDataMatchAxes = transformDataMatchAxes;


function dateRangeHelper(_ref) {
    var datesObj = _ref.datesObj,
        dateHelper = _ref.dateHelper;

    var config = {
        'dateRangeClassic': dateRangeClassic,
        'dateRangeClassicAutoExpandDays': dateRangeClassicAutoExpandDays, // FIX EXPAND 30 DAYS
        'dateRangePastComparison': dateRangePastComparison,
        'dateRangeToday': dateRangeToday,
        'dateRangeSingleInterval': dateRangeSingleInterval,
        'dateRangeInterval24Hours': dateRangeInterval24Hours,
        'default': dateRangeClassic
    };
    var helperFn = config[dateHelper];
    if (helperFn) {
        return helperFn(datesObj);
    } else {
        return config['default'](datesObj);
    }
}

function dateRangeClassic(datesObj) {
    try {
        var unit = datesObj ? datesObj.unit : 'd';
        var diff = (0, _moment2.default)(datesObj.end).diff((0, _moment2.default)(datesObj.start), 'days') + 1;
        var start_end_days = Math.ceil(diff);
        var obj = { interval: { number: 0, unit: unit }, decrease: 0 };
        obj.begin = datesObj.end;
        obj.final = datesObj.start;
        switch (unit) {
            case 'd':
                var days = start_end_days;
                var intervalNum = 0;
                if (days <= 7) {
                    intervalNum = 1;
                } else if (days > 7 && days <= 60) {
                    intervalNum = 7;
                } else if (days > 60 && days <= 180) {
                    intervalNum = 30;
                } else if (days > 180) {
                    intervalNum = 90;
                }
                obj.interval.number = intervalNum;
                obj.interval.unit = 'days';
                obj.decrease = Math.ceil(days / intervalNum);
                break;
            case 'monthly':
                var months = Math.round(start_end_days / 30);
                obj.interval.number = 1;
                obj.interval.unit = 'months';
                obj.decrease = months;
                break;
            default:
                throw '錯誤的時間單位';
        }
        return obj;
    } catch (e) {
        console.error(e);
    }
}

function dateRangePastComparison(datesObj) {
    try {
        var diffUnit = 'days';
        if (datesObj.unit == 'd') diffUnit = 'days';
        if (datesObj.unit == 'monthly') diffUnit = 'months';
        var dateDiff = Math.abs((0, _moment2.default)(datesObj.start).diff(datesObj.end, diffUnit));
        return {
            begin: datesObj.end,
            final: (0, _moment2.default)(datesObj.end).subtract(dateDiff * 2 + 1, diffUnit).format('YYYY-MM-DD'),
            interval: {
                number: dateDiff + 1,
                unit: diffUnit
            },
            decrease: 2
        };
    } catch (e) {
        console.error(e);
    }
}

function dateRangeClassicAutoExpandDays(datesObj) {
    var obj = (0, _assign2.default)({}, datesObj);
    obj.end = (0, _moment2.default)(datesObj.end).add(30, 'days').format('YYYY-MM-DD');
    return dateRangeClassic(obj);
}

function dateRangeToday(datesObj) {
    var today = (0, _moment2.default)().format('YYYY-MM-DD');
    return {
        begin: today,
        final: today,
        interval: {
            number: 1,
            unit: 'days'
        },
        decrease: 1
    };
}

function dateRangeSingleInterval(datesObj) {
    var diff = (0, _moment2.default)(datesObj.end).diff((0, _moment2.default)(datesObj.start), 'days') + 1;
    var start_end_days = Math.ceil(diff);
    return {
        begin: datesObj.end,
        final: datesObj.start,
        interval: {
            number: start_end_days,
            unit: 'days'
        },
        decrease: 1
    };
}

function dateRangeInterval24Hours(datesObj) {
    return {
        begin: datesObj.end,
        final: datesObj.start,
        interval: {
            number: 24,
            unit: 'hours'
        },
        decrease: 24
    };
}

function chartAxesHelper(_ref2) {
    var mode = _ref2.mode,
        dateRange = _ref2.dateRange;

    try {
        switch (mode) {
            case 'entireDateRangeTime':
                var min = dateRange.final;
                var max = dateRange.begin;
                var diff = Math.ceil((0, _moment2.default)(min).diff((0, _moment2.default)(max), 'days') + 1);
                var unit = 'month';
                if (Math.abs(diff) <= 61) {
                    unit = 'week';
                }
                var option = {
                    type: 'time',
                    time: {
                        unit: unit,
                        displayFormats: {}
                    },
                    ticks: {
                        min: (0, _moment2.default)(min, 'YYYY-MM-DD'),
                        max: (0, _moment2.default)(max, 'YYYY-MM-DD')
                    }
                };
                option.time.displayFormats[unit] = 'YYYY/MM/DD';
                return option;

            case 'day24HourTime':
                return {
                    type: 'time',
                    time: {
                        unit: 'hour',
                        displayFormats: {
                            hour: 'h A'
                        }
                    },
                    ticks: {
                        min: (0, _moment2.default)('00:00:00', 'hh:mm:ss'),
                        max: (0, _moment2.default)('24:00:00', 'hh:mm:ss')
                    }
                };
            default:
                return null;
        }
    } catch (e) {
        console.error(e);
    }
}

function transformDataMatchAxes(_ref3) {
    var AxesMode = _ref3.AxesMode,
        val = _ref3.val;

    try {
        var config = {
            'entireDateRangeTime': function entireDateRangeTime(val) {
                return (0, _moment2.default)(val);
            },
            'day24HourTime': function day24HourTime(val) {
                return (0, _moment2.default)(val, 'hh:mm:ss');
            }
        };
        if (config[AxesMode]) {
            return config[AxesMode](val);
        } else {
            throw 'Invalid chartAxes Mode';
        }
    } catch (e) {
        console.error(e);
    }
}

},{"babel-runtime/core-js/object/assign":50,"moment":727}],1138:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        title: {
            type: String
        },
        slot1Config: {
            type: Object,
            required: true
            // example: {
            //     titleText: '銷售概況',
            //     compTag: 'dashboard-bar-chart',
            //     compAttr: {//這邊可以蓋掉chart compo裏面的default_attr
            //         width: 200,
            //         height: 100,
            //     },
            //     api: {
            //         url: '/adminapi/dashboard/chart-amount',
            //         method: 'get',
            //         params: {
            //         studio_id: this.selected_studio_id,
            //         branch_id: this.selected_branch_id,
            //         metrics: 'order',
            //         aggregation: 'payment-source-sum',
            //         chart: 'payment-source-doughnut',
            //         },
            //     },
            //     getIntervalAndDecrease: (start_end_days) => {
            //         return {
            //             interval: {number: 1, unit: 'd'},
            //             decrease: Math.ceil(start_end_days / interval.number),
            //         }
            //     },
            // },
        },
        slot2Config: {
            type: Object
        },
        outLink: {
            type: Object
        },
        datePickerShortcuts: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        defaultDates: {
            type: Array,
            default: function _default() {
                var defaultS = moment().subtract(30, 'days').format('YYYY-MM-DD');
                var defaultE = moment().format('YYYY-MM-DD');
                return [defaultS, defaultE];
            }
        }
    },
    data: function data() {
        return {
            dates: this.defaultDates,
            slot1_ajaxing: false,
            slot2_ajaxing: false,
            slot1_response_obj: {},
            slot2_response_obj: {},
            interval_and_decrease: {}
        };
    },

    computed: {
        start_date: function start_date() {
            return this.dates[0];
        },
        end_date: function end_date() {
            return this.dates[1];
        },
        start_end_days: function start_end_days() {
            var diff = moment(this.end_date).diff(moment(this.start_date), 'days') + 1;
            return Math.ceil(diff);
        },
        start_end_months: function start_end_months() {
            var diff = this.start_end_days / 30;
            console.log('start_end_months', diff);
            return Math.round(diff);
        },
        showBlock: function showBlock() {
            var query = $17.getUrlQueryStrings();
            if (query.hasOwnProperty('metrics')) {
                if (this.slot1Config && query['metrics'] === this.slot1Config.api.params.metrics) {
                    return true;
                } else if (this.slot2Config && query['metrics'] === this.slot2Config.api.params.metrics) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return true;
            }
        }
    },
    methods: {
        showChart: function showChart(slotConfigName) {
            if (this[slotConfigName]) {
                var query = $17.getUrlQueryStrings();
                if (query.hasOwnProperty('chart')) {
                    return query['chart'] === this[slotConfigName].api.params.chart;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        makeIntervalAndDecrease: function makeIntervalAndDecrease(datesObj) {
            try {
                var unit = datesObj ? datesObj.unit : 'd';
                var obj = { interval: { number: 0, unit: unit }, decrease: 0 };

                switch (unit) {
                    case 'd':
                        var days = this.start_end_days;
                        var intervalNum = 0;
                        if (days <= 7) {
                            intervalNum = 1;
                        } else if (days > 7 && days <= 60) {
                            intervalNum = 7;
                        } else if (days > 60 && days <= 180) {
                            intervalNum = 30;
                        } else if (days > 180) {
                            intervalNum = 90;
                        }
                        obj.interval.number = intervalNum;
                        obj.interval.unit = 'days';
                        obj.decrease = Math.ceil(days / intervalNum);
                        break;
                    case 'monthly':
                        var months = Math.round(this.start_end_days / 30);
                        obj.interval.number = 1;
                        obj.interval.unit = 'months';
                        obj.decrease = months;
                        break;
                    default:
                        throw '錯誤的時間單位';
                }
                this.interval_and_decrease = obj;
            } catch (e) {
                console.error(e);
            }
        },
        getCharts: function getCharts(e) {
            var _this = this;

            if (!moment(this.start_date).isValid() || !moment(this.end_date).isValid()) {
                return false;
            }
            if (moment(this.start_date).isBefore(moment('2017-01-01'))) {
                $17.swal({
                    title: '開始日期不可早於2017年',
                    text: "",
                    type: 'warning',
                    showCancelButton: false
                });
                return false;
            }
            if (moment(this.start_date).isAfter(this.end_date)) {
                $17.swal({
                    title: '開始日期不可大於結束日期',
                    text: "",
                    type: 'warning',
                    showCancelButton: false
                });
                return false;
            }
            this.makeIntervalAndDecrease(e);
            this.$nextTick(function () {
                _this.getSlot1Chart();
                _this.getSlot2Chart();
            });
        },
        getSlot1Chart: function getSlot1Chart() {
            var _this2 = this;

            if (this.showBlock && this.showChart('slot1Config')) {
                this.slot1_ajaxing = true;
                var api = this.slot1Config.api;
                var intervalAndDecrease = this.getIntervalAndDecrease('slot1Config');
                var params = (0, _assign2.default)(api.params, {
                    date_range: {
                        begin: this.end_date,
                        final: this.start_date,
                        interval: intervalAndDecrease.interval,
                        decrease: intervalAndDecrease.decrease
                    }
                });
                this.$http[api.method](api.url, { params: params }).then(function (response) {
                    _this2.slot1_response_obj = response.data;
                    _this2.slot1_ajaxing = false;
                }).catch(function (response) {
                    _this2.slot1_ajaxing = false;
                    $17.swal({
                        title: '圖表顯示失敗',
                        text: '\u7121\u6CD5\u53D6\u5F97 ' + _this2.slot1Config.titleText + ' \u8CC7\u6599',
                        type: 'warning',
                        showCancelButton: false
                    });
                });
            }
        },
        getSlot2Chart: function getSlot2Chart() {
            var _this3 = this;

            if (this.showBlock && this.showChart('slot2Config')) {
                this.slot2_ajaxing = true;
                var api = this.slot2Config.api;
                var intervalAndDecrease = this.getIntervalAndDecrease('slot2Config');
                var params = (0, _assign2.default)(api.params, {
                    date_range: {
                        begin: this.end_date,
                        final: this.start_date,
                        interval: intervalAndDecrease.interval,
                        decrease: intervalAndDecrease.decrease
                    }
                });
                this.$http[api.method](api.url, { params: params }).then(function (response) {
                    _this3.slot2_response_obj = response.data;
                    _this3.slot2_ajaxing = false;
                }).catch(function (response) {
                    _this3.slot2_ajaxing = false;
                    $17.swal({
                        title: '圖表顯示失敗',
                        text: '\u7121\u6CD5\u53D6\u5F97 ' + _this3.slot2Config.titleText + ' \u8CC7\u6599',
                        type: 'warning',
                        showCancelButton: false
                    });
                });
            }
        },
        getIntervalAndDecrease: function getIntervalAndDecrease(slotConfigName) {
            try {
                return this[slotConfigName].getIntervalAndDecrease(this.start_end_days);
            } catch (e) {
                return this.interval_and_decrease;
            }
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div v-if=\"showBlock\" _v-05045d7e=\"\">\n    <h4 class=\"text-muted\" _v-05045d7e=\"\">{{ title }}</h4>\n    <div class=\"panel panel-default\" _v-05045d7e=\"\">\n        <div class=\"panel-body\" _v-05045d7e=\"\">\n            <div class=\"m-bottom-10\" v-if=\"showChart('slot1Config')\" _v-05045d7e=\"\">\n                <h4 class=\"text-muted m-top-5 m-bottom-5\" _v-05045d7e=\"\">{{ slot1Config.titleText }}</h4>\n                <div class=\"m-top-20\" _v-05045d7e=\"\">\n                    <component :is=\"slot1Config.compTag\" :response-obj=\"slot1_response_obj\" :ajaxing=\"slot1_ajaxing\" v-bind=\"slot1Config.compAttr\" ref=\"slot1Chart\" _v-05045d7e=\"\"></component>\n                </div>\n            </div>\n\n            <div v-if=\"showChart('slot2Config')\" _v-05045d7e=\"\">\n                <h4 class=\"text-muted m-top-20 m-bottom-5\" _v-05045d7e=\"\">{{ slot2Config.titleText }}</h4>\n                <div class=\"m-top-20\" _v-05045d7e=\"\">\n                    <component :is=\"slot2Config.compTag\" :response-obj=\"slot2_response_obj\" :ajaxing=\"slot2_ajaxing\" v-bind=\"slot2Config.compAttr\" ref=\"slot2Chart\" _v-05045d7e=\"\"></component>\n                </div>\n            </div>\n\n            <div class=\"row m-top-20\" style=\"line-height: 32px;\" _v-05045d7e=\"\">\n                <div class=\"col-xs-8\" _v-05045d7e=\"\">\n                    <v-date-picker v-model=\"dates\" range=\"\" @change=\"getCharts\" :shortcuts=\"datePickerShortcuts\" _v-05045d7e=\"\"></v-date-picker>\n                </div>\n                <div class=\"col-xs-4 text-right\" v-if=\"outLink\" _v-05045d7e=\"\">\n                    <a :href=\"outLink.url\" target=\"_blank\" _v-05045d7e=\"\">{{ outLink.name }}<i class=\"p-left-5 fa fa-chevron-right\" _v-05045d7e=\"\"></i></a>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-05045d7e", module.exports)
  } else {
    hotAPI.update("_v-05045d7e", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/object/assign":50,"vue":792,"vue-hot-reload-api":785,"vuex":803}],1139:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _doughnut = require('../../../utilities/webadmin/chart/doughnut.js');

var _doughnut2 = _interopRequireDefault(_doughnut);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        DoughnutChart: _doughnut2.default
    },
    props: {
        responseObj: {
            type: Object,
            default: function _default() {
                return {
                    labels: null,
                    datasets: null
                };
            }
        },
        ajaxing: {
            type: Boolean,
            default: false
        },
        labelWithPercentage: Boolean
    },
    data: function data() {
        return {
            default_options: {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    position: 'right',
                    onClick: null
                }
            },
            default_attr: {
                width: 400,
                height: 200
            }
        };
    },
    mounted: function mounted() {},

    computed: {
        attrs: function attrs() {
            return (0, _assign2.default)(this.default_attr, this.$attrs);
        },
        chartOptions: function chartOptions() {
            var vm = this;
            var o = (0, _assign2.default)(this.default_options, {});
            o['elements'] = {
                center: { text: '', color: '#777777', maxFontSize: 20 }
            };
            o['tooltips'] = {
                callbacks: {
                    label: function label(tooltipItems, data) {
                        var datasetIndex = tooltipItems.datasetIndex;
                        var index = tooltipItems.index;
                        return vm.responseObj.labels[index] + "：" + data.datasets[datasetIndex].data[index];
                    }
                }
            };
            if (this.responseObj.hasOwnProperty('extra') && this.responseObj.extra.hasOwnProperty('doughnutMiddleValue')) {
                o.elements.center.text = this.responseObj.extra.doughnutMiddleValue;
            }
            if (this.isAllZero) {
                o.tooltips = false;
                o.legend.onClick = null;
            }
            return o;
        },
        chartData: function chartData() {
            var dataset = this.responseObj.datasets ? JSON.parse((0, _stringify2.default)(this.responseObj.datasets[0])) : { data: [], backgroundColor: [] };
            var labels = this.responseObj.labels;
            if (this.labelWithPercentage) {
                labels = this.labelAppendPercentage(labels, dataset);
            }
            if (this.isAllZero) {
                dataset.data.push(1);
                dataset.backgroundColor.push('#F1F1F5');
                dataset.borderWidth = 0;
            }
            return {
                labels: labels,
                datasets: [dataset]
            };
        },
        overall: function overall() {
            var data = this.responseObj.datasets ? this.responseObj.datasets[0].data : [0];
            return data.reduce(function (a, b) {
                return a + b;
            });
        },
        isAllZero: function isAllZero() {
            return this.overall > 0 ? false : true;
        }
    },
    methods: {
        labelAppendPercentage: function labelAppendPercentage(labels, dataset) {
            var _this = this;

            if (!labels) return null;
            return labels.map(function (item, index) {
                var percentage = Math.round(dataset.data[index] / _this.overall * 100) || 0;
                return item + percentage + '%';
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"chart\" _v-520d0943=\"\">\n    <v-spinner-button :style=\"{width: '100%','line-height':default_attr.height+'px',height:default_attr.height+'px'}\" :ajaxing=\"ajaxing\" fa-size=\"fa-2x\" class=\"text-center\" _v-520d0943=\"\"></v-spinner-button>\n    <doughnut-chart v-show=\"!ajaxing\" :chart-data=\"chartData\" :options=\"chartOptions\" v-bind=\"attrs\" _v-520d0943=\"\"></doughnut-chart>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-520d0943", module.exports)
  } else {
    hotAPI.update("_v-520d0943", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"../../../utilities/webadmin/chart/doughnut.js":1562,"babel-runtime/core-js/json/stringify":48,"babel-runtime/core-js/object/assign":50,"vue":792,"vue-hot-reload-api":785}],1140:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            showMemberChart: false,
            amount: {
                labels: [],
                data: [],
                total: 0
            },
            bookings: {
                chartType: 'day',
                labels: [],
                perLine: {},
                count: 0
            },
            members: {
                chartType: 'day',
                labels: [],
                perLine: {},
                count: 0
            },
            amountLine: {
                chartType: 'day',
                labels: [],
                perLine: {}
            }
        };
    },
    mounted: function mounted() {},

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        canDashboard: function canDashboard(state) {
            return state.webadmin.configure.webFunctions.WebadminDashboardIndex;
        }
    }), (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId', 'isBranch', 'isSeventeen']), (0, _vuex.mapState)('filters', ['selected_studio_id', 'selected_branch_id']), {
        paymentSourceChart: function paymentSourceChart() {
            return {
                slot1: {
                    titleText: '銷售概況 (單位：金額)',
                    compTag: 'dashboard-bar-chart',
                    api: {
                        url: '/adminapi/dashboard/chart',
                        method: 'get',
                        params: {
                            studio_id: this.selected_studio_id,
                            branch_id: this.selected_branch_id,
                            metrics: 'order',
                            aggregation: 'sum',
                            chart: 'bar'
                        }
                    },
                    getIntervalAndDecrease: function getIntervalAndDecrease(start_end_days) {
                        return {
                            interval: { number: 1, unit: 'days' },
                            decrease: Math.ceil(start_end_days / 1)
                        };
                    }
                },
                datePickerShortcuts: ['range_today', 'range_yesterday', 'range_past_7d', 'range_past_30d', 'range_past_90d', 'range_past_180d']
            };
        },
        bookingSourceChart: function bookingSourceChart() {
            return {
                slot1: {
                    titleText: '預約概況 (單位：人次)',
                    compTag: 'dashboard-bar-chart',
                    api: {
                        url: '/adminapi/dashboard/chart',
                        method: 'get',
                        params: {
                            studio_id: this.selected_studio_id,
                            branch_id: this.selected_branch_id,
                            metrics: 'booking-list',
                            aggregation: 'sum',
                            chart: 'bar'
                        }
                    },
                    getIntervalAndDecrease: function getIntervalAndDecrease(start_end_days) {
                        return {
                            interval: { number: 1, unit: 'days' },
                            decrease: Math.ceil(start_end_days / 1)
                        };
                    }
                },
                datePickerShortcuts: ['range_yesterday', 'range_past_7d', 'range_past_30d', 'range_past_90d', 'range_past_180d']
            };
        },
        newMemberChart: function newMemberChart() {
            return {
                slot1: {
                    titleText: '新客戶概況 (單位：人)',
                    compTag: 'dashboard-bar-chart',
                    api: {
                        url: '/adminapi/dashboard/chart',
                        method: 'get',
                        params: {
                            studio_id: this.selected_studio_id,
                            branch_id: this.selected_branch_id,
                            metrics: 'new-customer',
                            aggregation: 'sum',
                            chart: 'bar'
                        }
                    },
                    getIntervalAndDecrease: function getIntervalAndDecrease(start_end_days) {
                        return {
                            interval: { number: 1, unit: 'days' },
                            decrease: Math.ceil(start_end_days / 1)
                        };
                    }
                },
                datePickerShortcuts: ['range_yesterday', 'range_past_7d', 'range_past_30d', 'range_past_90d', 'range_past_180d']
            };
        }
    }),
    watch: {
        isSeventeen: function isSeventeen(val, oldV) {
            if (!val) {
                window.location.href = '/webadmin/dashboard';
            }
        },

        selected_studio_id: function selected_studio_id(val, oldV) {
            var _this = this;

            if (!this.isSeventeen) {
                window.location.href = '/webadmin/dashboard';
            } else if (val > 0 && !this.isBranch) {
                this.$nextTick(function () {
                    _this.$refs.paymentSourceChart.getCharts();
                    _this.$refs.bookingSourceChart.getCharts();
                    _this.$refs.newMemberChart.getCharts();
                });
            }
        },
        selected_branch_id: function selected_branch_id(val, oldV) {
            var _this2 = this;

            if (!this.isSeventeen) {
                window.location.href = '/webadmin/dashboard';
            } else {
                this.$nextTick(function () {
                    _this2.$refs.paymentSourceChart.getCharts();
                    _this2.$refs.bookingSourceChart.getCharts();
                    _this2.$refs.newMemberChart.getCharts();
                });
            }
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-f92cc9a0=\"\">\n    <v-dashboard-tabs tab=\"dashboard-view\" _v-f92cc9a0=\"\"></v-dashboard-tabs>\n    <div class=\"container\" v-show=\"canDashboard\" _v-f92cc9a0=\"\">\n        <div class=\"row\" _v-f92cc9a0=\"\">\n            <div class=\"col-12\" v-show=\"!isBranch\" _v-f92cc9a0=\"\">\n                <v-multiselect-studio-and-branch :studio_id=\"studioId\" :branch_id=\"branchId\" :branch-without-filtered-option=\"true\" _v-f92cc9a0=\"\"></v-multiselect-studio-and-branch>\n            </div>\n        </div>\n        <div class=\"row\" _v-f92cc9a0=\"\">\n            <div class=\"col-xs-12\" _v-f92cc9a0=\"\">\n                <webadmin-dashboard-v2s-block ref=\"paymentSourceChart\" title=\"您的銷售狀況如何？\" :slot1-config=\"paymentSourceChart.slot1\" :date-picker-shortcuts=\"paymentSourceChart.datePickerShortcuts\" _v-f92cc9a0=\"\"></webadmin-dashboard-v2s-block>\n            </div>\n            <div class=\"col-xs-12\" _v-f92cc9a0=\"\">\n                <webadmin-dashboard-v2s-block ref=\"bookingSourceChart\" title=\"您的預約狀況如何？\" :slot1-config=\"bookingSourceChart.slot1\" :date-picker-shortcuts=\"bookingSourceChart.datePickerShortcuts\" _v-f92cc9a0=\"\"></webadmin-dashboard-v2s-block>\n            </div>\n            <div class=\"col-xs-12\" _v-f92cc9a0=\"\">\n                <webadmin-dashboard-v2s-block ref=\"newMemberChart\" title=\"您有多少新客戶？\" :slot1-config=\"newMemberChart.slot1\" :date-picker-shortcuts=\"newMemberChart.datePickerShortcuts\" _v-f92cc9a0=\"\"></webadmin-dashboard-v2s-block>\n            </div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-f92cc9a0", module.exports)
  } else {
    hotAPI.update("_v-f92cc9a0", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vuex":803}],1141:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _index = require('./index.vue');

var _index2 = _interopRequireDefault(_index);

var _indexView = require('./index-view.vue');

var _indexView2 = _interopRequireDefault(_indexView);

var _dashboardV2sBlock = require('./dashboard-v2s-block.vue');

var _dashboardV2sBlock2 = _interopRequireDefault(_dashboardV2sBlock);

var _doughnutChart = require('./doughnut-chart.vue');

var _doughnutChart2 = _interopRequireDefault(_doughnutChart);

var _barChart = require('./bar-chart.vue');

var _barChart2 = _interopRequireDefault(_barChart);

var _lineChart = require('./line-chart.vue');

var _lineChart2 = _interopRequireDefault(_lineChart);

var _numberDisplay = require('./number-display.vue');

var _numberDisplay2 = _interopRequireDefault(_numberDisplay);

var _scatterChart = require('./scatter-chart.vue');

var _scatterChart2 = _interopRequireDefault(_scatterChart);

var _textDisplayChart = require('./text-display-chart.vue');

var _textDisplayChart2 = _interopRequireDefault(_textDisplayChart);

var _periodComparisonChart = require('./period-comparison-chart.vue');

var _periodComparisonChart2 = _interopRequireDefault(_periodComparisonChart);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('./partials'); //17FIT 才能看


_vue2.default.component('webadmin-dashboard', _index2.default);
_vue2.default.component('webadmin-dashboard-view', _indexView2.default);
_vue2.default.component('webadmin-dashboard-v2s-block', _dashboardV2sBlock2.default);

_vue2.default.component('dashboard-doughnut-chart', _doughnutChart2.default);
_vue2.default.component('dashboard-bar-chart', _barChart2.default);
_vue2.default.component('dashboard-line-chart', _lineChart2.default);
_vue2.default.component('dashboard-number-display', _numberDisplay2.default);
_vue2.default.component('dashboard-scatter-chart', _scatterChart2.default);
_vue2.default.component('dashboard-text-display', _textDisplayChart2.default);
_vue2.default.component('dashboard-period-comparison', _periodComparisonChart2.default);

},{"./bar-chart.vue":1136,"./dashboard-v2s-block.vue":1138,"./doughnut-chart.vue":1139,"./index-view.vue":1140,"./index.vue":1142,"./line-chart.vue":1143,"./number-display.vue":1144,"./partials":1146,"./period-comparison-chart.vue":1147,"./scatter-chart.vue":1148,"./text-display-chart.vue":1149,"vue":792}],1142:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            showMemberChart: false,
            amount: {
                labels: [],
                data: [],
                total: 0
            },
            bookings: {
                chartType: 'day',
                labels: [],
                perLine: {},
                count: 0
            },
            members: {
                chartType: 'day',
                labels: [],
                perLine: {},
                count: 0
            },
            amountLine: {
                chartType: 'day',
                labels: [],
                perLine: {}
            }
        };
    },
    mounted: function mounted() {},

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        canDashboard: function canDashboard(state) {
            return state.webadmin.configure.webFunctions.WebadminDashboardIndex;
        }
    }), (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId', 'isBranch', 'isSeventeen']), (0, _vuex.mapState)('filters', ['selected_studio_id', 'selected_branch_id']), {
        paymentSourceChart: function paymentSourceChart() {
            return {
                slot1: {
                    titleText: '總銷售金額',
                    compTag: 'dashboard-doughnut-chart',
                    api: {
                        url: '/adminapi/dashboard/chart',
                        method: 'get',
                        params: {
                            studio_id: this.selected_studio_id,
                            branch_id: this.selected_branch_id,
                            metrics: 'order',
                            aggregation: 'payment-source-sum',
                            chart: 'doughnut'
                        }
                    }
                },
                slot2: {
                    titleText: '銷售概況 (單位：金額)',
                    compTag: 'dashboard-bar-chart',
                    api: {
                        url: '/adminapi/dashboard/chart',
                        method: 'get',
                        params: {
                            studio_id: this.selected_studio_id,
                            branch_id: this.selected_branch_id,
                            metrics: 'order',
                            aggregation: 'sum',
                            chart: 'bar'
                        }
                    }
                },
                outLink: {
                    name: '銷售總覽',
                    url: '/webadmin/report/order-detail-total-sale'
                },
                datePickerShortcuts: ['range_today', 'range_yesterday', 'range_past_7d', 'range_past_30d', 'range_past_90d', 'range_past_180d']
            };
        },
        bookingSourceChart: function bookingSourceChart() {
            return {
                slot1: {
                    titleText: '總預約次數',
                    compTag: 'dashboard-doughnut-chart',
                    api: {
                        url: '/adminapi/dashboard/chart',
                        method: 'get',
                        params: {
                            studio_id: this.selected_studio_id,
                            branch_id: this.selected_branch_id,
                            metrics: 'booking-list',
                            aggregation: 'booking-source-sum',
                            chart: 'doughnut'
                        }
                    }
                },
                slot2: {
                    titleText: '預約概況 (單位：人次)',
                    compTag: 'dashboard-bar-chart',
                    api: {
                        url: '/adminapi/dashboard/chart',
                        method: 'get',
                        params: {
                            studio_id: this.selected_studio_id,
                            branch_id: this.selected_branch_id,
                            metrics: 'booking-list',
                            aggregation: 'sum',
                            chart: 'bar'
                        }
                    }
                },
                outLink: {
                    name: '預約總覽',
                    url: '/webadmin/report/booking-total-list'
                },
                datePickerShortcuts: ['range_yesterday', 'range_past_7d', 'range_past_30d', 'range_past_90d', 'range_past_180d']
            };
        },
        newMemberChart: function newMemberChart() {
            return {
                slot1: {
                    titleText: '新客戶數量',
                    compTag: 'dashboard-number-display',
                    api: {
                        url: '/adminapi/dashboard/chart',
                        method: 'get',
                        params: {
                            studio_id: this.selected_studio_id,
                            branch_id: this.selected_branch_id,
                            metrics: 'new-customer',
                            aggregation: 'count',
                            chart: 'number-display'
                        }
                    }
                },
                slot2: {
                    titleText: '新客戶概況 (單位：人)',
                    compTag: 'dashboard-bar-chart',
                    api: {
                        url: '/adminapi/dashboard/chart',
                        method: 'get',
                        params: {
                            studio_id: this.selected_studio_id,
                            branch_id: this.selected_branch_id,
                            metrics: 'new-customer',
                            aggregation: 'sum',
                            chart: 'bar'
                        }
                    }
                },
                datePickerShortcuts: ['range_yesterday', 'range_past_7d', 'range_past_30d', 'range_past_90d', 'range_past_180d']
            };
        },
        unreachedContractValueChart: function unreachedContractValueChart() {
            return {
                slot1: {
                    titleText: '未認列方案營收',
                    compTag: 'dashboard-line-chart',
                    api: {
                        url: '/adminapi/dashboard/chart',
                        method: 'get',
                        params: {
                            studio_id: this.selected_studio_id,
                            branch_id: this.selected_branch_id,
                            metrics: 'unreached-contract-value',
                            aggregation: 'sum',
                            chart: 'line'
                        }
                    }
                },
                datePickerShortcuts: ['range_past_1m', 'range_monthly_3m', 'range_monthly_6m', 'range_past_30d', 'range_past_60d', 'range_past_90d', 'range_past_180d']
            };
        },
        recognitionContractValueChart: function recognitionContractValueChart() {
            return {
                slot1: {
                    titleText: '方案的銷售與認列',
                    compTag: 'dashboard-line-chart',
                    api: {
                        url: '/adminapi/dashboard/chart',
                        method: 'get',
                        params: {
                            studio_id: this.selected_studio_id,
                            branch_id: this.selected_branch_id,
                            metrics: 'recognition-contract-value',
                            aggregation: 'sum',
                            chart: 'line'
                        }
                    }
                },
                outLink: {
                    name: '認列價值報表',
                    url: '/webadmin/report/recognition'
                },
                datePickerShortcuts: ['range_past_1m', 'range_monthly_3m', 'range_monthly_6m', 'range_past_30d', 'range_past_60d', 'range_past_90d', 'range_past_180d']
            };
        }
    }),
    watch: {
        selected_studio_id: function selected_studio_id(val, oldV) {
            var _this = this;

            if (val > 0 && !this.isBranch) {
                this.$nextTick(function () {
                    _this.execute();
                });
            }
        },
        selected_branch_id: function selected_branch_id(val, oldV) {
            var _this2 = this;

            this.$nextTick(function () {
                _this2.execute();
            });
        }
    },
    methods: {
        execute: function execute() {
            this.$refs.paymentSourceChart.getCharts();
            this.$refs.bookingSourceChart.getCharts();
            this.$refs.newMemberChart.getCharts();
            this.$refs.unreachedContractValueChart.getCharts();
            // this.$refs.recognitionContractValueChart.getCharts(); todo 暫時隱藏此圖表，預計會跟 unreachedContractValueChart 合併顯示
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n    <div _v-debc0cdc=\"\">\n        <v-dashboard-tabs tab=\"dashboard\" _v-debc0cdc=\"\"></v-dashboard-tabs>\n        <div class=\"container\" v-show=\"canDashboard\" style=\"padding-bottom: 50px;\" _v-debc0cdc=\"\">\n            <div class=\"row\" _v-debc0cdc=\"\">\n                <div class=\"col-xs-12\" v-show=\"!isBranch\" _v-debc0cdc=\"\">\n                    <v-multiselect-studio-and-branch :studio_id=\"studioId\" :branch_id=\"branchId\" :branch-without-filtered-option=\"true\" _v-debc0cdc=\"\"></v-multiselect-studio-and-branch>\n                </div>\n            </div>\n            <div class=\"row\" _v-debc0cdc=\"\">\n                <div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-4\" _v-debc0cdc=\"\">\n                    <webadmin-dashboard-v2s-block ref=\"paymentSourceChart\" title=\"您的銷售狀況如何？\" :slot1-config=\"paymentSourceChart.slot1\" :slot2-config=\"paymentSourceChart.slot2\" :out-link=\"paymentSourceChart.outLink\" :date-picker-shortcuts=\"paymentSourceChart.datePickerShortcuts\" _v-debc0cdc=\"\"></webadmin-dashboard-v2s-block>\n                </div>\n                <div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-4\" _v-debc0cdc=\"\">\n                    <webadmin-dashboard-v2s-block ref=\"bookingSourceChart\" title=\"您的預約狀況如何？\" :slot1-config=\"bookingSourceChart.slot1\" :slot2-config=\"bookingSourceChart.slot2\" :out-link=\"bookingSourceChart.outLink\" :date-picker-shortcuts=\"bookingSourceChart.datePickerShortcuts\" _v-debc0cdc=\"\"></webadmin-dashboard-v2s-block>\n                </div>\n                <div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-4\" _v-debc0cdc=\"\">\n                    <webadmin-dashboard-v2s-block ref=\"newMemberChart\" title=\"您有多少新客戶？\" :slot1-config=\"newMemberChart.slot1\" :slot2-config=\"newMemberChart.slot2\" :out-link=\"newMemberChart.outLink\" :date-picker-shortcuts=\"newMemberChart.datePickerShortcuts\" _v-debc0cdc=\"\"></webadmin-dashboard-v2s-block>\n                </div>\n                <div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\" _v-debc0cdc=\"\">\n                    <webadmin-dashboard-v2s-block ref=\"unreachedContractValueChart\" title=\"長期來看，累積尚未認列的方案價值有什麼變化？\" :slot1-config=\"unreachedContractValueChart.slot1\" :slot2-config=\"unreachedContractValueChart.slot2\" :out-link=\"unreachedContractValueChart.outLink\" :date-picker-shortcuts=\"unreachedContractValueChart.datePickerShortcuts\" _v-debc0cdc=\"\"></webadmin-dashboard-v2s-block>\n                </div>\n<!--                todo 暫時隱藏此圖表，預計會跟 unreachedContractValueChart 合併顯示-->\n<!--                <div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\">-->\n<!--                    <webadmin-dashboard-v2s-block-->\n<!--                        ref=\"recognitionContractValueChart\"-->\n<!--                        title=\"您的方案預收和認列狀況，相較之下如何？\"-->\n<!--                        :slot1-config=\"recognitionContractValueChart.slot1\"-->\n<!--                        :slot2-config=\"recognitionContractValueChart.slot2\"-->\n<!--                        :out-link=\"recognitionContractValueChart.outLink\"-->\n<!--                        :date-picker-shortcuts=\"recognitionContractValueChart.datePickerShortcuts\"-->\n<!--                    ></webadmin-dashboard-v2s-block>-->\n<!--                </div>-->\n            </div>\n        </div>\n    </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-debc0cdc", module.exports)
  } else {
    hotAPI.update("_v-debc0cdc", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vuex":803}],1143:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _line = require('../../../utilities/webadmin/chart/line.js');

var _line2 = _interopRequireDefault(_line);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        LineChart: _line2.default
    },
    props: {
        responseObj: {
            type: Object,
            default: function _default() {
                return {
                    labels: null,
                    datasets: null
                };
            }
        },
        ajaxing: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            default_options: {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: false
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            callback: function callback(value, index, values) {
                                return Intl.NumberFormat().format(value);
                                // return '$' + Intl.NumberFormat().format((value / 1000)) + 'K';
                            }
                        }
                    }]
                }
            },
            default_attr: {
                width: 400,
                height: 200
            }
        };
    },

    computed: {
        attrs: function attrs() {
            return (0, _assign2.default)(this.default_attr, this.$attrs);
        },
        chartOptions: function chartOptions() {
            var o = (0, _assign2.default)(this.default_options, {});
            var vue = this;
            if (this.responseObj.hasOwnProperty('extra')) {
                var extra = this.responseObj.extra;
                if (extra.hasOwnProperty('customToolTipTitles')) {
                    o['tooltips'] = {
                        callbacks: {
                            title: function title(tooltipItems, data) {
                                var tooltipItem = tooltipItems[0];
                                var customToolTipTitles = vue.responseObj.extra.customToolTipTitles;
                                return customToolTipTitles[tooltipItem.index];
                            }
                        }
                    };
                }
                if (extra.hasOwnProperty('legend_display')) {
                    o.legend.display = vue.responseObj.extra.legend_display;
                }
            }
            return o;
        },
        chartData: function chartData() {
            return {
                labels: this.responseObj.labels,
                datasets: this.responseObj.datasets
            };
        }
    },
    methods: {}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"chart\" _v-42d1feb5=\"\">\n    <v-spinner-button :style=\"{width: '100%','line-height':default_attr.height+'px',height:default_attr.height+'px'}\" :ajaxing=\"ajaxing\" fa-size=\"fa-2x\" class=\"text-center\" _v-42d1feb5=\"\"></v-spinner-button>\n    <line-chart v-show=\"!ajaxing\" :chart-data=\"chartData\" :options=\"chartOptions\" v-bind=\"attrs\" _v-42d1feb5=\"\"></line-chart>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-42d1feb5", module.exports)
  } else {
    hotAPI.update("_v-42d1feb5", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"../../../utilities/webadmin/chart/line.js":1563,"babel-runtime/core-js/object/assign":50,"vue":792,"vue-hot-reload-api":785}],1144:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        responseObj: {
            type: Object,
            default: function _default() {
                return {
                    labels: null,
                    datasets: null
                };
            }
        },
        ajaxing: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {};
    },

    computed: {
        number: function number() {
            return this.responseObj.datasets || 0;
        }
    },
    methods: {}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-c078d0a4=\"\">\n    <v-spinner-button :ajaxing=\"ajaxing\" fa-size=\"fa-2x\" class=\"text-center\" _v-c078d0a4=\"\"></v-spinner-button>\n    <h2 v-show=\"!ajaxing\" class=\"text-muted m-top-5 m-bottom-5\" _v-c078d0a4=\"\">{{number}}</h2>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-c078d0a4", module.exports)
  } else {
    hotAPI.update("_v-c078d0a4", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],1145:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dashboardHelper = require('../dashboard-helper');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        chartsConfig: {
            type: Array,
            required: true
        },
        datesObj: {
            type: Object
        }
    },
    data: function data() {
        return {
            chartTitleStyle: 'st-my-2 st-text-16 st-text-gray-90',
            gridSlots: []
        };
    },
    created: function created() {
        this.refreshChart();
    },

    methods: {
        refreshChart: function refreshChart() {
            this.getGridSlotsChart();
        },
        getGridSlotsChart: function getGridSlotsChart() {
            var _this = this;

            this.chartsConfig.forEach(function (chart, index) {
                _this.setSlotsData(index, {
                    titleText: chart.titleText,
                    responseObj: {},
                    ajaxing: false
                });
                _this.getChart(chart.api, index);
            });
        },
        getChart: function getChart(api, index) {
            var vm = this;
            if (api) {
                vm.setSlotsData(index, { ajaxing: true });
                var params = api.params;
                params['date_range'] = (0, _dashboardHelper.dateRangeHelper)({
                    datesObj: this.datesObj,
                    dateHelper: api.dateHelper
                });
                this.$http[api.method](api.url, { params: params }).then(function (response) {
                    vm.setSlotsData(index, {
                        responseObj: response.data,
                        ajaxing: false
                    });
                }).catch(function (response) {
                    vm.setSlotsData(index, { ajaxing: false });
                    $17.swal({
                        title: '圖表顯示失敗',
                        text: '\u7121\u6CD5 ' + vm.gridSlots[index].titleText + ' \u8CC7\u6599',
                        type: 'warning',
                        showCancelButton: false
                    });
                });
            }
        },
        setSlotsData: function setSlotsData(index, obj) {
            var data = (0, _extends3.default)({}, this.gridSlots[index], obj);
            this.$set(this.gridSlots, index, data);
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"st-gap-x-1.5 st-gap-y-2 st-grid st-grid-cols-1 sm:st-grid-cols-2 md:st-grid-cols-3\">\n    <div v-for=\"(chart, index) in chartsConfig\" class=\"st-border st-border-gray-40 st-border-solid st-p-3.5 st-rounded-4\">\n         <div :class=\"chartTitleStyle\">{{ chart.titleText }}</div>\n         <component :ref=\"('grid_chart_'+index)\" :is=\"chart.compTag\" v-bind=\"chart.compAttr\" :response-obj=\"gridSlots[index].responseObj\" :ajaxing=\"gridSlots[index].ajaxing\"></component>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-11f6408b", module.exports)
  } else {
    hotAPI.update("_v-11f6408b", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"../dashboard-helper":1137,"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785}],1146:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _gridSlotsBlock = require('./grid-slots-block.vue');

var _gridSlotsBlock2 = _interopRequireDefault(_gridSlotsBlock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('grid-slots-block', _gridSlotsBlock2.default);

},{"./grid-slots-block.vue":1145,"vue":792}],1147:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        responseObj: {
            type: Object,
            default: function _default() {
                return {
                    labels: null,
                    datasets: null
                };
            }
        },
        ajaxing: {
            type: Boolean,
            default: false
        },
        upperBound: {
            type: Number,
            default: 0
        },
        lowerBound: {
            type: Number,
            default: 0
        },
        unit: {
            type: String,
            default: ''
        }
    },
    data: function data() {
        return {};
    },

    computed: {
        currentValue: function currentValue() {
            if (!this.responseObj.datasets) return 0;
            return Number(this.responseObj.datasets[1]) || 0;
        },
        lastValue: function lastValue() {
            if (!this.responseObj.datasets) return 0;
            return Number(this.responseObj.datasets[0]) || 0;
        },
        percentage: function percentage() {
            if (this.lastValue == 0) return 0;
            return Math.round((this.currentValue - this.lastValue) / this.lastValue * 100 * 10) / 10;
        },
        level: function level() {
            if (this.percentage >= this.upperBound) return 'grow';
            if (this.percentage <= this.lowerBound) return 'decline';
            return 'stay';
        },
        textDisplay: function textDisplay() {
            if (this.percentage >= 0) {
                return '+' + this.percentage + '%';
            } else {
                return this.percentage + '%';
            }
        }
    },
    methods: {
        thousandthFormat: function thousandthFormat(num) {
            return $17.thousandthFormat(num);
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div>\n    <v-spinner-button :ajaxing=\"ajaxing\" fa-size=\"fa-2x\" class=\"text-center\"></v-spinner-button>\n    <div v-show=\"!ajaxing\" class=\"st-flex st-flex-wrap st-font-medium st-gap-2 st-items-end st-text-20 st-text-black\">\n        <div>{{ thousandthFormat(currentValue) +' '+unit }}</div>\n        <div class=\"st-text-14\" :class=\"{\n            'st-text-success': level == 'grow',\n            'st-text-danger': level == 'decline',\n            'st-text-gray-90': level == 'stay'\n        }\">\n            <span>{{ textDisplay }}</span>\n            <span class=\"material-icons st-text-14\" v-if=\"level == 'grow'\">north</span>\n            <span class=\"material-icons st-text-14\" v-if=\"level == 'decline'\">south</span>\n        </div>\n        <div class=\"st-text-14 st-text-gray-90\">(上一個時段：{{ thousandthFormat(lastValue)+' '+unit }})</div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-f2c13734", module.exports)
  } else {
    hotAPI.update("_v-f2c13734", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],1148:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _scatter = require('../../../utilities/webadmin/chart/scatter.js');

var _scatter2 = _interopRequireDefault(_scatter);

var _dashboardHelper = require('./dashboard-helper');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        ScatterChart: _scatter2.default
    },
    props: {
        responseObj: {
            type: Object,
            default: function _default() {
                return {
                    labels: null,
                    datasets: null
                };
            }
        },
        requestObj: {
            type: Object
        },
        ajaxing: {
            type: Boolean,
            default: false
        },
        xAxesMode: {
            type: String
        },
        yAxesMode: {
            type: String
        }
    },
    data: function data() {
        return {
            default_options: {
                responsive: true,
                maintainAspectRatio: true
            },
            default_attr: {
                width: 400,
                height: 200
            },
            scalesOptions: {}
        };
    },

    computed: {
        attrs: function attrs() {
            return (0, _assign2.default)(this.default_attr, this.$attrs);
        },
        chartOptions: function chartOptions() {
            var o = (0, _assign2.default)(this.default_options, {});
            var vue = this;
            if (!_lodash2.default.isEmpty(this.scalesOptions)) {
                o['scales'] = this.scalesOptions;
            }
            o['tooltips'] = {
                callbacks: {
                    label: function label(tooltipItems, data) {
                        var datasetIndex = tooltipItems.datasetIndex;
                        var index = tooltipItems.index;
                        var label = data.datasets[datasetIndex].label;
                        if (data.datasets[datasetIndex].data[index].hasOwnProperty('label_text')) {
                            label += '\uFF1A(' + data.datasets[datasetIndex].data[index].label_text + ')';
                        } else {
                            label += '\uFF1A(' + data.datasets[datasetIndex].data[index].x + ', ' + data.datasets[datasetIndex].data[index].y + ')';
                        }
                        return label;
                    },
                    afterBody: function afterBody(tooltipItems, data) {
                        var datasetIndex = tooltipItems[0].datasetIndex;
                        var index = tooltipItems[0].index;
                        return data.datasets[datasetIndex].data[index].extra || '';
                    }
                }
            };
            return o;
        },
        chartData: function chartData() {
            var vue = this;
            var data = this.responseObj.datasets || [];
            var result = [];
            data.forEach(function (item) {
                var itemData = item.data.map(function (item) {
                    return {
                        x: vue.xDataFormat(item.x),
                        y: vue.yDataFormat(item.y),
                        label_text: item.x + ', ' + item.y,
                        extra: item.extra || []
                    };
                });
                result.push((0, _extends3.default)({}, item, {
                    data: itemData
                }));
            });
            return { datasets: result };
        }
    },
    watch: {
        ajaxing: function ajaxing(newVal) {
            if (newVal) {
                this.generateScaleOptions(this.requestObj);
            }
        }
    },
    methods: {
        generateScaleOptions: function generateScaleOptions(params) {
            var scales = {};
            if (this.xAxesMode) {
                scales['xAxes'] = [(0, _dashboardHelper.chartAxesHelper)({
                    mode: this.xAxesMode,
                    dateRange: params.date_range
                })];
            }
            if (this.yAxesMode) {
                scales['yAxes'] = [(0, _dashboardHelper.chartAxesHelper)({
                    mode: this.yAxesMode,
                    dateRange: params.date_range
                })];
            }
            this.scalesOptions = scales;
        },
        xDataFormat: function xDataFormat(val) {
            if (this.xAxesMode) {
                return (0, _dashboardHelper.transformDataMatchAxes)({
                    AxesMode: this.xAxesMode,
                    val: val
                });
            } else {
                return val;
            }
        },
        yDataFormat: function yDataFormat(val) {
            if (this.yAxesMode) {
                return (0, _dashboardHelper.transformDataMatchAxes)({
                    AxesMode: this.yAxesMode,
                    val: val
                });
            } else {
                return val;
            }
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"chart st-overflow-x-auto\" _v-33032362=\"\">\n    <v-spinner-button :style=\"{width: '100%','line-height':default_attr.height+'px',height:default_attr.height+'px'}\" :ajaxing=\"ajaxing\" fa-size=\"fa-2x\" class=\"text-center\" _v-33032362=\"\"></v-spinner-button>\n    <div class=\"st-min-w-[500px]\" _v-33032362=\"\">\n        <scatter-chart v-show=\"!ajaxing\" :chart-data=\"chartData\" :options=\"chartOptions\" v-bind=\"attrs\" _v-33032362=\"\"></scatter-chart>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-33032362", module.exports)
  } else {
    hotAPI.update("_v-33032362", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"../../../utilities/webadmin/chart/scatter.js":1564,"./dashboard-helper":1137,"babel-runtime/core-js/object/assign":50,"babel-runtime/helpers/extends":66,"lodash":717,"vue":792,"vue-hot-reload-api":785}],1149:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        responseObj: {
            type: Object,
            default: function _default() {
                return {
                    labels: null,
                    datasets: null
                };
            }
        },
        ajaxing: {
            type: Boolean,
            default: false
        },
        prefix: {
            type: String,
            default: ''
        },
        suffix: {
            type: String,
            default: ''
        }
    },
    data: function data() {
        return {};
    },

    computed: {
        datasets: function datasets() {
            return this.responseObj.datasets || { text: '', date: '' };
        },
        text: function text() {
            if (this.datasets.text) {
                return this.prefix + this.datasets.text + this.suffix;
            }
            return '-';
        },
        date: function date() {
            if (this.datasets.date) {
                return moment(this.datasets.date).format('YYYY/MM/DD');
            }
            return '';
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div>\n    <v-spinner-button :ajaxing=\"ajaxing\" fa-size=\"fa-2x\" class=\"text-center\"></v-spinner-button>\n    <div v-show=\"!ajaxing\" class=\"st-font-medium st-gap-2 st-text-20 st-text-black\">\n        <div>\n            <span>{{ text }}</span>\n            <span v-show=\"date\" class=\"st-text-14 st-ml-1.5\">({{date}})</span>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-74ddd963", module.exports)
  } else {
    hotAPI.update("_v-74ddd963", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],1150:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _list = require('./list.vue');

var _list2 = _interopRequireDefault(_list);

var _modal = require('./modal.vue');

var _modal2 = _interopRequireDefault(_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('webadmin-dynamic-parameter-list', _list2.default);
_vue2.default.component('webadmin-dynamic-parameter-modal', _modal2.default);

},{"./list.vue":1151,"./modal.vue":1152,"vue":792}],1151:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.btn-success[_v-fc567cce], .btn-default[_v-fc567cce] {\n  margin-bottom: 15px; }\n\n/* line 5, stdin */\n.not_published[_v-fc567cce] {\n  color: red; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            list: {},
            ajaxing: false,
            editId: null
        };
    },
    created: function created() {},
    watch: {
        ACTIVE_STUDIO_ID: function ACTIVE_STUDIO_ID(newVal) {
            if (newVal) {
                this.changed();
            }
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('webadmin/configure', ['ACTIVE_STUDIO_ID', 'ACTIVE_BRANCH_ID']), (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId', 'isBranch']), (0, _vuex.mapState)('filters', ['selected_studio_id', 'selected_branch_id', 'updateQueryStrings'])),
    methods: {
        showModal: function showModal(item) {
            this.editId = null;
            $('#dynamic-parameter-modal').modal('show');
        },
        changed: function changed() {
            var _this = this;

            var branch_id = this.selected_branch_id;
            if (this.selected_branch_id === null || this.selected_branch_id === 'null') {
                branch_id = '';
            }
            var params = {
                owner: [{
                    owner_type: 'studio',
                    owner_id: this.ACTIVE_STUDIO_ID
                }]
            };

            this.ajaxing = true;
            this.$http.get('/adminapi/dynamic-parameter/list', { params: params }).then(function (response) {
                _this.ajaxing = false;
                _this.list = response.data;
            }, function (error) {
                _this.ajaxing = false;
            });
        },
        edit: function edit(id) {
            this.editId = id;
            $('#dynamic-parameter-modal').modal('show');
        },
        refresh: function refresh() {
            this.editId = null;
            this.changed();
        },
        deleting: function deleting(id) {
            var _this2 = this;

            $17.swal({
                title: '確認刪除？',
                text: '此操作無法返回',
                type: 'warning',
                showCancelButton: true,
                closeOnConfirm: false,
                showLoaderOnConfirm: true
            }, function (answer) {
                if (answer) {
                    _this2.ajaxing = true;
                    _this2.$http.delete('/adminapi/dynamic-parameter/' + id).then(function (response) {
                        _this2.ajaxing = false;
                        _this2.refresh();
                    }, function (error) {
                        $17.swal({
                            title: error.body.message,
                            type: 'warning'
                        });
                        _this2.ajaxing = false;
                    });
                }
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"container\" _v-fc567cce=\"\">\n    <div class=\"row\" _v-fc567cce=\"\">\n        <div class=\"col-sm-6\" _v-fc567cce=\"\">\n            <a type=\"button\" class=\"btn btn-success\" @click=\"showModal\" _v-fc567cce=\"\">\n                <i class=\"fa fa-plus\" aria-hidden=\"true\" _v-fc567cce=\"\"></i>新增參數代碼\n            </a>\n        </div>\n    </div>\n    <div class=\"row\" _v-fc567cce=\"\">\n        <div class=\"col-sm-6\" _v-fc567cce=\"\">\n            <v-multiselect-studio-and-branch :studio_id=\"studioId\" :show-branch=\"false\" _v-fc567cce=\"\"></v-multiselect-studio-and-branch>\n        </div>\n    </div>\n    <div class=\"text-center\" _v-fc567cce=\"\">\n\n        <v-spinner :ajaxing=\"ajaxing\" _v-fc567cce=\"\">\n\n        </v-spinner>\n\n        <table v-show=\"!ajaxing\" class=\"table pagin-table\" _v-fc567cce=\"\">\n            <thead _v-fc567cce=\"\">\n                <tr _v-fc567cce=\"\">\n                    <th _v-fc567cce=\"\">參數代碼</th>\n                    <th _v-fc567cce=\"\">名稱</th>\n                    <th _v-fc567cce=\"\">類型</th>\n                    <th _v-fc567cce=\"\">動作</th>\n                    <th _v-fc567cce=\"\"></th>\n                </tr>\n            </thead>\n\n            <tbody align=\"left\" _v-fc567cce=\"\">\n                <tr v-for=\"item in list\" _v-fc567cce=\"\">\n                    <td _v-fc567cce=\"\">{{item.identity_code}}</td>\n                    <td _v-fc567cce=\"\">{{item.name}}</td>\n                    <td _v-fc567cce=\"\">{{item.data_input_name}}</td>\n                    <td _v-fc567cce=\"\">\n                        <a @click.stop.prevent=\"edit(item.id)\" _v-fc567cce=\"\">編輯</a>\n                    </td>\n                    <td _v-fc567cce=\"\">\n                        <a @click.stop.prevent=\"deleting(item.id)\" _v-fc567cce=\"\">刪除</a>\n                    </td>\n                </tr>\n            </tbody>\n        </table>\n    </div>\n    <webadmin-dynamic-parameter-modal :id=\"editId\" owner-type=\"studio\" :owner-id=\"ACTIVE_STUDIO_ID\" @refresh=\"refresh\" @close-modal-event=\"refresh\" _v-fc567cce=\"\"></webadmin-dynamic-parameter-modal>\n</div>    \n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.btn-success[_v-fc567cce], .btn-default[_v-fc567cce] {\n  margin-bottom: 15px; }\n\n/* line 5, stdin */\n.not_published[_v-fc567cce] {\n  color: red; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-fc567cce", module.exports)
  } else {
    hotAPI.update("_v-fc567cce", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1152:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n.item{\n    margin-top:10px;\n}\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        id: {
            type: Number,
            default: null
        },
        ownerType: {
            type: String,
            default: null
        },
        ownerId: {
            type: Number,
            default: null
        }
    },
    data: function data() {
        return {
            studio_id: 0,
            view: {
                ajaxing: false
            },
            model: {
                identity_code: '',
                name: '',
                data_input_type: '',
                data_input_attr: []
            },
            inputTypes: [{
                'value': 'text-line',
                'name': '單行輸入'
            }, {
                'value': 'textarea',
                'name': '多行文字'
            }, {
                'value': 'select-single',
                'name': '單選'
            }, {
                'value': 'checkbox-group',
                'name': '複選'
            }, {
                'value': 'date-pick',
                'name': '日期'
            }, {
                'value': 'number',
                'name': '數字'
            }],
            items: []
        };
    },
    mounted: function mounted() {},

    created: function created() {},
    watch: {
        id: function id(newVal) {
            this.resetForm();
            if (!newVal) {
                return;
            }
            this.show();
        },
        'model.data_input_type': function modelData_input_type(newCal) {
            if (!this.showAddNewItemBtn) {
                this.items = [];
            }
        }
    },
    computed: {
        title: function title() {
            return this.createMode ? '新增參數' : '編輯參數';
        },
        createMode: function createMode() {
            return !this.id;
        },
        showAddNewItemBtn: function showAddNewItemBtn() {
            return ['select-single', 'checkbox-group'].indexOf(this.model.data_input_type) > -1;
        }
    },
    methods: {
        show: function show() {
            var _this = this;

            this.view.ajaxing = true;
            this.$http.get('/adminapi/dynamic-parameter/update/' + this.id).then(function (response) {
                _this.model = response.data;
                _this.items = response.data.data_input_attr_items;
                _lodash2.default.delay(function () {
                    _this.view.ajaxing = false;
                }, 400);
            }, function (error) {
                $17.swal({
                    title: error.body.message,
                    type: 'warning'
                });
                _this.view.ajaxing = false;
            });
        },
        creating: function creating() {
            var _this2 = this;

            if (!this.checkIdentityCode(this.model.identity_code)) {
                $17.swal({
                    title: '代碼只可包含英數字',
                    type: 'warning'
                });
                return;
            }
            this.view.ajaxing = true;
            var data = this.model;

            data.owner_type = this.ownerType;
            data.owner_id = this.ownerId;
            data.data_input_attr_items = this.getFinalItems();

            this.$http.post('/adminapi/dynamic-parameter/create', data).then(function (response) {
                _this2.view.ajaxing = false;
                $('#dynamic-parameter-modal').modal('hide');
                _this2.refresh();
            }, function (error) {
                $17.swal({
                    title: error.body.message,
                    type: 'warning'
                });
                _this2.view.ajaxing = false;
            });
        },
        updating: function updating() {
            var _this3 = this;

            this.view.ajaxing = true;

            this.$http.post('/adminapi/dynamic-parameter/update/' + this.id, { 'name': this.model.name }).then(function (response) {
                _this3.view.ajaxing = false;
                $('#dynamic-parameter-modal').modal('hide');
                _this3.refresh();
            }, function (error) {
                $17.swal({
                    title: error.body.message,
                    type: 'warning'
                });
                _this3.view.ajaxing = false;
            });
        },
        resetForm: function resetForm() {
            this.view.ajaxing = false;
            this.model = {
                identity_code: '',
                name: '',
                data_input_type: ''
            };
            this.items = [];
        },
        checkIdentityCode: function checkIdentityCode(code) {
            return (/^[A-Za-z0-9_]+$/.exec(code)
            );
        },
        removeItem: function removeItem(index) {
            this.items.splice(index, 1);
        },
        addItem: function addItem(name, value) {
            this.items.push(this.toItemObj(name, value));
        },
        toItemObj: function toItemObj(n, v) {
            return { name: n, value: v };
        },
        getFinalItems: function getFinalItems() {
            return this.items.map(function (item) {
                item.name = item.value;

                return item;
            });
        },
        refresh: function refresh() {
            this.resetForm();
            this.$emit('refresh');
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal id=\"dynamic-parameter-modal\" :close-modal-event=\"refresh\" no-border-radius=\"\" no-footer=\"\">\n    <div slot=\"title\">{{ title }}</div>\n    <div slot=\"body\">\n        <v-spinner :ajaxing=\"view.ajaxing\"></v-spinner>\n        <div v-show=\"!view.ajaxing\">\n                <div class=\"clearfix m-top-10\">\n                    <div class=\"clearfix\">\n                        <label class=\"col-lg-3 col-md-3 col-xs-12 p-top-5 require\" for=\"name\">代碼 </label>\n                        <div class=\"col-lg-9 col-md-9 col-xs-12\">\n                            <input name=\"name\" v-model=\"model.identity_code\" :disabled=\"!!id\" class=\"form-control\" type=\"text\">\n                        </div>\n                        <div class=\" col-lg-offset-3 col-md-offset-3 col-xs-12 col-lg-9 col-md-9 col-xs-12\">\n                            <small>限定英數字，不可重複</small>\n                        </div>\n                    </div>\n                </div>\n        </div>\n        <div v-show=\"!view.ajaxing\">\n                <div class=\"clearfix m-top-10\">\n                    <div class=\"clearfix\">\n                        <label class=\"col-lg-3 col-md-3 col-xs-12 p-top-5 require\" for=\"name\">顯示名稱 </label>\n                        <div class=\"col-lg-9 col-md-9 col-xs-12\">\n                            <input name=\"name\" v-model=\"model.name\" class=\"form-control\" type=\"text\" maxlength=\"50\">\n                        </div>\n                    </div>\n                </div>\n        </div>\n        <div v-show=\"!view.ajaxing\">\n                <div class=\"clearfix m-top-10\">\n                    <div class=\"clearfix\">\n                        <label class=\"col-lg-3 col-md-3 col-xs-12 p-top-5 require\" for=\"name\">類型 </label>\n                        <div class=\"col-lg-9 col-md-9 col-xs-12\">\n                            <select v-model=\"model.data_input_type\" :disabled=\"!!id\" class=\" form-control\">\n                                <option v-for=\"inputType in inputTypes\" :value=\"inputType.value\">\n                                    {{ inputType.name }}\n                                </option>\n                            </select>\n                        </div>\n                    </div>\n                </div>\n        </div>\n        <div v-show=\"!view.ajaxing &amp;&amp; showAddNewItemBtn\">\n            <div class=\"item\">\n                <div v-for=\"(it, index) in items\" class=\"col-lg-9 col-lg-offset-3 col-md-offset-3 col-md-9 col-xs-12 text-right m-top-10\">\n                    <div class=\"input-group\">\n                        <input type=\"text\" class=\"form-control\" v-model=\"it.value\" placeholder=\"請輸入選項內容\">\n                        <span class=\"input-group-btn\">\n                            <a type=\"button\" v-show=\"createMode\" @click.prevent=\"removeItem(index)\" class=\"btn btn-danger\">\n                                <span class=\"glyphicon glyphicon-remove\" aria-hidden=\"true\"></span>\n                            </a>\n                        </span>\n                    </div>\n                </div>\n            </div>\n            <div class=\"form-group m-top-5\" v-show=\"createMode\">\n                <div class=\"col-lg-9 col-lg-offset-3 col-md-offset-3 col-md-9 col-xs-12 text-right m-top-10\">\n                    <p>\n                        <a href=\"javascript:void(0)\" @click.prevent=\"addItem('', '')\">\n                            + 新增選項\n                        </a>\n                    </p>\n                </div>\n            </div>\n        </div>\n        <div class=\"clearfix text-right\">\n            <button class=\"btn btn-primary\" v-if=\"createMode\" @click=\"creating\" v-show=\"!view.ajaxing\">新增</button>\n            <button class=\"btn btn-primary\" v-if=\"!createMode\" @click=\"updating\" v-show=\"!view.ajaxing\">儲存</button>\n        </div>\n    </div>\n</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n.item{\n    margin-top:10px;\n}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-f4a3447c", module.exports)
  } else {
    hotAPI.update("_v-f4a3447c", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1153:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.status-select[_v-69acc8d0] {\n  width: 150px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            modal: {
                title: ''
            },
            view: {
                list: [],
                ajaxing: false,
                action: 'create',
                show_content: false
            }
        };
    },
    watch: {
        selected_branch_id: function selected_branch_id() {
            if (this.isBranch) {
                this.fetchList();
            }
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId', 'isBranch']), (0, _vuex.mapState)('filters', ['selected_studio_id', 'selected_branch_id']), (0, _vuex.mapState)({
        canCreate: function canCreate(state) {
            return state.webadmin.configure.webFunctions.WebadminEventCreate;
        },
        canUpdate: function canUpdate(state) {
            return state.webadmin.configure.webFunctions.WebadminEventUpdate;
        }
    })),
    methods: {
        changeStatus: function changeStatus(eventId, value) {
            var _this = this;

            this.$http.patch('/adminapi/event/update/status/' + eventId, { status: value }).then(function (response) {
                _this.view.ajaxing = false;
                _this.refresh();
            }, function (error) {
                _this.view.ajaxing = false;
                $17.swal({
                    title: i18n.t('general.unknown_error'),
                    type: 'warning',
                    showCancelButton: false
                });
            });
        },
        fetchList: function fetchList() {
            var _this2 = this;

            this.view.ajaxing = true;
            this.$http.get('/adminapi/event/?branch_id=' + this.selected_branch_id).then(function (response) {
                _this2.view.list = response.body;
                _this2.view.ajaxing = false;
            }, function (error) {
                _this2.view.ajaxing = false;
            });
        },

        showModal: function showModal(item, action) {
            this.$refs.eventModal.onCall(item.id, action);
            this.$refs.eventModal.setDefaultIds(this.selected_studio_id, this.selected_branch_id);
            this.modal.title = (action === 'update' ? i18n.t('general.modify') : i18n.t('general.create')) + i18n.t('webadmin.event.event');
            $('#event-modal').modal('show');
        },
        refresh: function refresh() {
            this.view.ajaxing = true;
            this.fetchList();
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"col-xs-12\" _v-69acc8d0=\"\">\n    <v-select-studio-and-branch :studio_id=\"studioId\" :branch_id=\"branchId\" :branch-without-filtered-option=\"false\" :branch-change-call-back=\"fetchList\" _v-69acc8d0=\"\">\n    </v-select-studio-and-branch>\n    <v-spinner :ajaxing=\"view.ajaxing\" _v-69acc8d0=\"\"></v-spinner>\n    <div class=\"m-top-20\" v-show=\"!view.ajaxing\" _v-69acc8d0=\"\">\n        <button v-if=\"canCreate&amp;&amp;this.selected_branch_id>0\" type=\"button\" class=\"btn btn-success m-bottom-20\" @click=\"showModal({id:0,name:''}, 'create')\" _v-69acc8d0=\"\">\n            <i class=\"fa fa-plus\" _v-69acc8d0=\"\"></i> {{ i18n.t('general.create') + i18n.t('webadmin.event.event')}}\n        </button>\n        <div class=\"table-responsive\" v-if=\"this.view.list.length>0\" _v-69acc8d0=\"\">\n            <table class=\"table\" _v-69acc8d0=\"\">\n                <thead _v-69acc8d0=\"\">\n                <tr _v-69acc8d0=\"\">\n                    <th class=\"col-xs-7\" _v-69acc8d0=\"\">{{i18n.t('general.name')}}</th>\n                    <th class=\"col-xs-2\" _v-69acc8d0=\"\">{{i18n.t('general.status')}}</th>\n                    <th class=\"col-xs-3\" _v-69acc8d0=\"\"></th>\n                </tr>\n                </thead>\n                <tbody _v-69acc8d0=\"\">\n                <tr v-for=\"event in view.list\" _v-69acc8d0=\"\">\n                    <td _v-69acc8d0=\"\">{{event.name}}</td>\n                    <td _v-69acc8d0=\"\">\n                        <select v-if=\"canUpdate\" class=\"form-control status-select\" @change=\"changeStatus(event.id,$event.target.value)\" _v-69acc8d0=\"\">\n                            <option value=\"0\" :selected=\"event.status==0\" _v-69acc8d0=\"\">{{i18n.t('general.disable')}}</option>\n                            <option value=\"1\" :selected=\"event.status==1\" _v-69acc8d0=\"\">{{i18n.t('general.enable')}}</option>\n                        </select>\n                        <div v-else=\"\" _v-69acc8d0=\"\">{{event.status==0?i18n.t('general.disable'):i18n.t('general.enable')}}</div>\n                    </td>\n                    <td _v-69acc8d0=\"\">\n                        <button v-if=\"canUpdate\" class=\"btn btn-primary\" @click=\"showModal({id:event.id,name:event.name}, 'update')\" _v-69acc8d0=\"\">\n                            {{i18n.t('general.modify')}}\n                        </button>\n                    </td>\n                </tr>\n                </tbody>\n            </table>\n        </div>\n        <event-modal @refresh=\"refresh\" ref=\"eventModal\" :title=\"modal.title\" _v-69acc8d0=\"\">\n        </event-modal>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.status-select[_v-69acc8d0] {\n  width: 150px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-69acc8d0", module.exports)
  } else {
    hotAPI.update("_v-69acc8d0", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1154:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.thumbnail[_v-7ca007f3] {\n  height: 120px;\n  width: 120px;\n  line-height: 120px;\n  margin-bottom: 0; }\n\n/* line 9, stdin */\n.img-thumb[_v-7ca007f3] {\n  margin-bottom: 5px;\n  margin-right: 5px; }\n  /* line 12, stdin */\n  .img-thumb .thumbnail[_v-7ca007f3] {\n    -moz-background-size: contain;\n    -webkit-background-size: contain;\n    -o-background-size: contain;\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-position: center; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        title: {
            type: String,
            default: ''
        }
    },
    data: function data() {
        return {
            view: {
                ajaxing: false,
                ajaxingImage: false,
                ajaxingContracts: false,
                canSubmit: true,
                action: 'create',
                branchContracts: []
            },
            currentId: 0,
            postData: {
                studio_id: 0,
                branch_id: 0,
                name: '',
                description: '',
                url: '',
                contract_id: '',
                action: 0,
                status: 1,
                images: { 'old': [], 'new': [] }
            }
        };
    },
    mounted: function mounted() {},

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['isBranch']), (0, _vuex.mapState)('filters', ['branchOptions']), (0, _vuex.mapState)({
        canDelete: function canDelete(state) {
            return state.webadmin.configure.webFunctions.WebadminEventDelete;
        }
    }), {
        uploadImageBtnShow: function uploadImageBtnShow() {
            //限制上傳5張特色圖
            if (this.postData.images.new.length + this.postData.images.old.length === 5) {
                return false;
            }
            return true;
        }
    }),
    methods: {
        onChange: function onChange(event) {
            var vm = this;
            this.$nextTick(function () {
                $17.imageToString({
                    image: event.target.files[0],
                    width: 600,
                    height: 340,
                    callback: function callback(imageString) {
                        vm.postData.images.new.push(imageString);
                    }
                });
            });
        },
        getBranchContracts: function getBranchContracts() {
            this.view.ajaxingContracts = true;
            this.$http.get('/api/branch/' + this.postData.branch_id + '/pricing').then(function (response) {
                this.view.branchContracts = response.data;
                this.view.ajaxingContracts = false;
            });
        },
        submit: function submit() {
            if (this.view.action === 'update') {
                this.update();
            } else if (this.view.action === 'create') {
                this.create();
            }
        },
        onCall: function onCall(id, action) {
            this.view.action = action;
            if (action === 'update') {
                this.currentId = id;
                this.show();
            } else if (action === 'create') {
                this.resetForm();
            }
        },
        show: function show() {
            var _this = this;

            this.view.ajaxing = true;
            this.$http.get('/adminapi/event/show/' + this.currentId).then(function (response) {
                var data = response.body.data.event;
                _this.postData = {
                    studio_id: data.studio_id,
                    branch_id: data.branch_id,
                    name: data.name,
                    description: data.description,
                    url: data.url,
                    contract_id: data.contract_id,
                    action: data.action,
                    status: data.status,
                    images: { old: data.images, new: [] }
                };
                _this.view.ajaxing = false;
            }, function (error) {
                _this.view.ajaxing = false;
            });
        },
        create: function create() {
            var _this2 = this;

            this.view.ajaxing = true;
            this.$http.post('/adminapi/event/create', this.postData).then(function (response) {
                _this2.view.ajaxing = false;
                _this2.finishModal();
                $17.swal({
                    title: i18n.t('general.created_successfully'),
                    type: 'success',
                    showCancelButton: false
                });
            }, function (error) {
                _this2.view.ajaxing = false;
                $17.swal({
                    title: error.data.message,
                    type: 'warning',
                    showCancelButton: false
                });
            });
        },
        deleteEvent: function deleteEvent() {
            var vm = this;
            $17.swal({
                title: i18n.t('webadmin.event.delete_this_event'),
                type: 'warning'
            }, function () {
                vm.view.ajaxing = true;
                vm.$http.delete('/adminapi/event/' + vm.currentId).then(function (response) {
                    vm.view.ajaxing = false;
                    vm.finishModal();
                    $17.swal({
                        title: i18n.t('general.deleted_successfully'),
                        type: 'success',
                        showCancelButton: false
                    });
                }, function (error) {
                    vm.view.ajaxing = false;
                });
            });
        },
        deleteImage: function deleteImage(galleryId) {
            var vm = this;
            $17.swal({
                title: i18n.t('webadmin.general.delete_this_image'),
                type: 'warning'
            }, function () {
                vm.view.ajaxingImage = true;
                vm.$http.delete('/adminapi/event/image/' + galleryId).then(function (response) {
                    var index = vm.postData.images.old.findIndex(function (img) {
                        return img.gallery_id === galleryId;
                    });
                    if (index > -1) {
                        vm.postData.images.old.splice(index, 1);
                    }
                    vm.view.ajaxingImage = false;
                }, function (error) {
                    vm.view.ajaxingImage = false;
                });
            });
        },
        clearNewImage: function clearNewImage(index) {
            this.postData.images.new.splice(index, 1);
        },
        update: function update() {
            var _this3 = this;

            this.view.ajaxing = true;
            this.$http.patch('/adminapi/event/update/' + this.currentId, this.postData).then(function (response) {
                _this3.view.ajaxing = false;
                _this3.finishModal();
                $17.swal({
                    title: i18n.t('general.updated_successfully'),
                    type: 'success',
                    showCancelButton: false
                });
            }, function (error) {
                _this3.view.ajaxing = false;
                $17.swal({
                    title: error.data.message,
                    type: 'warning',
                    showCancelButton: false
                });
            });
        },
        setDefaultIds: function setDefaultIds(sId, bId) {
            this.postData.studio_id = sId;
            this.postData.branch_id = bId;
            this.getBranchContracts();
        },
        finishModal: function finishModal() {
            this.$emit('refresh');
            $('#event-modal').modal('hide');
        },
        resetForm: function resetForm() {
            this.postData = {
                studio_id: 0,
                branch_id: 0,
                name: '',
                description: '',
                url: '',
                contract_id: '',
                action: 0,
                status: 1,
                images: { 'old': [], 'new': [] }
            };
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div id=\"event-modal\" class=\"modal fade\" role=\"dialog\" _v-7ca007f3=\"\">\n    <div class=\"modal-dialog\" _v-7ca007f3=\"\">\n        <div class=\"modal-content\" _v-7ca007f3=\"\">\n            <div class=\"modal-header\" _v-7ca007f3=\"\">\n                <button type=\"button\" v-show=\"!view.ajaxing\" class=\"close\" data-dismiss=\"modal\" _v-7ca007f3=\"\">×</button>\n                <h4 class=\"modal-title\" _v-7ca007f3=\"\">{{ title }}</h4>\n            </div>\n            <v-spinner :ajaxing=\"view.ajaxing\" _v-7ca007f3=\"\"></v-spinner>\n            <div v-show=\"!view.ajaxing\" class=\"modal-body\" _v-7ca007f3=\"\">\n                <div class=\"clearfix\" v-if=\"view.action=='create'&amp;&amp;!isBranch\" _v-7ca007f3=\"\">\n                    <label class=\"col-sm-2\" _v-7ca007f3=\"\">{{i18n.t('general.branch')}}</label>\n                    <div class=\"col-sm-10\" _v-7ca007f3=\"\">\n                        <select class=\"form-control\" v-model=\"postData.branch_id\" _v-7ca007f3=\"\">\n                            <option :value=\"branch.id\" v-for=\"branch in branchOptions\" :selected=\"postData.branch_id==branch.id\" _v-7ca007f3=\"\">\n                                {{branch.branch_name}}\n                            </option>\n                        </select>\n                    </div>\n                </div>\n                <div class=\"clearfix\" _v-7ca007f3=\"\">\n                    <label class=\"col-sm-2\" _v-7ca007f3=\"\">{{i18n.t('webadmin.event.event_name')}}</label>\n                    <div class=\"col-sm-10\" _v-7ca007f3=\"\">\n                        <input type=\"text\" class=\"form-control\" v-model=\"postData.name\" _v-7ca007f3=\"\">\n                    </div>\n                </div>\n                <hr _v-7ca007f3=\"\">\n                <div class=\"clearfix\" _v-7ca007f3=\"\">\n                    <label class=\"col-sm-2\" _v-7ca007f3=\"\">\n                        {{i18n.t('webadmin.event.pics')}}\n                        <a href=\"javascript:void(0)\" _v-7ca007f3=\"\"><i class=\"fa fa-question-circle\" help=\"最多五張，建議寬高 600x340\" _v-7ca007f3=\"\"></i></a>\n                    </label>\n                    <div class=\"img-area col-sm-10\" _v-7ca007f3=\"\">\n                        <v-spinner :ajaxing=\"view.ajaxingImage\" class=\"text-center\" _v-7ca007f3=\"\">\n                        </v-spinner>\n                        <div class=\"pull-left img-thumb\" v-if=\"!view.ajaxingImage&amp;&amp;postData.images.hasOwnProperty('old')&amp;&amp;postData.images.old.length>0\" v-for=\"img in postData.images.old\" _v-7ca007f3=\"\">\n                            <div class=\"text-center thumbnail\" :style=\"{backgroundImage:'url('+img.picture_path+')'}\" _v-7ca007f3=\"\">\n                            </div>\n                            <a href=\"javascript:;\" @click=\"deleteImage(img.gallery_id)\" _v-7ca007f3=\"\">{{i18n.t('general.delete')}}</a>\n                        </div>\n                        <div class=\"pull-left img-thumb\" v-if=\"!view.ajaxingImage&amp;&amp;postData.images.hasOwnProperty('new')&amp;&amp;postData.images.new.length>0\" v-for=\"(img,index) in postData.images.new\" _v-7ca007f3=\"\">\n                            <div class=\"text-center thumbnail\" :style=\"{backgroundImage:'url('+img+')'}\" _v-7ca007f3=\"\">\n                            </div>\n                            <a href=\"javascript:;\" @click=\"clearNewImage(index)\" _v-7ca007f3=\"\">{{i18n.t('general.delete')}}</a>\n                        </div>\n                        <div class=\"fileUpload text-center thumbnail\" v-if=\"uploadImageBtnShow\" _v-7ca007f3=\"\">\n                            <i class=\"fa fa-plus fa-2x\" _v-7ca007f3=\"\"></i>\n                            <input type=\"file\" class=\"upload\" @change=\"onChange\" accept=\"image/jpeg,image/png,image/jpg\" _v-7ca007f3=\"\">\n                        </div>\n                    </div>\n                </div>\n                <hr _v-7ca007f3=\"\">\n                <div class=\"clearfix\" _v-7ca007f3=\"\">\n                    <label class=\"col-sm-2\" _v-7ca007f3=\"\">{{i18n.t('general.description')}}</label>\n                    <div class=\"col-sm-10\" _v-7ca007f3=\"\">\n                        <textarea class=\"form-control\" rows=\"8\" v-model=\"postData.description\" _v-7ca007f3=\"\"></textarea>\n                    </div>\n                </div>\n                <hr _v-7ca007f3=\"\">\n                <div class=\"clearfix\" _v-7ca007f3=\"\">\n                    <label class=\"col-sm-2\" _v-7ca007f3=\"\">{{i18n.t('webadmin.event.action_button')}}</label>\n                    <div class=\"col-sm-10\" _v-7ca007f3=\"\">\n                        <label class=\"m-right-10\" _v-7ca007f3=\"\">\n                            <input v-model=\"postData.action\" :checked=\"postData.status==0\" value=\"0\" type=\"radio\" _v-7ca007f3=\"\"> {{i18n.t('general.none')}}\n                        </label>\n                        <label class=\"m-right-10\" _v-7ca007f3=\"\">\n                            <input v-model=\"postData.action\" :checked=\"postData.status==1\" value=\"1\" type=\"radio\" _v-7ca007f3=\"\">\n                            {{i18n.t('webadmin.event.buy_now')}}\n                        </label>\n                        <label _v-7ca007f3=\"\">\n                            <input v-model=\"postData.action\" :checked=\"postData.status==2\" value=\"2\" type=\"radio\" _v-7ca007f3=\"\"> {{i18n.t('webadmin.event.new_page')}}\n                        </label>\n                        <div class=\"m-top-10 text-center\" v-if=\"postData.action==1\" _v-7ca007f3=\"\">\n                            <v-spinner-button :ajaxing=\"view.ajaxingContracts\" _v-7ca007f3=\"\"></v-spinner-button>\n                            <select v-show=\"!view.ajaxingContracts\" v-model=\"postData.contract_id\" class=\"form-control\" _v-7ca007f3=\"\">\n                                <option value=\"\" :selected=\"postData.contract_id===null||postData.contract_id==''\" _v-7ca007f3=\"\">請選擇方案</option>\n                                <optgroup :label=\"category.name\" v-for=\"category in view.branchContracts\" v-if=\"category.contracts.length>0\" _v-7ca007f3=\"\">\n                                    <option :selected=\"postData.contract_id==contract.id\" :value=\"contract.id\" v-for=\"contract in category.contracts\" _v-7ca007f3=\"\">\n                                        {{contract.name}}\n                                    </option>\n                                </optgroup>\n                            </select>\n                        </div>\n                        <div class=\"m-top-10\" v-else-if=\"postData.action==2\" _v-7ca007f3=\"\">\n                            <input v-model=\"postData.url\" type=\"text\" placeholder=\"https://\" class=\"form-control\" _v-7ca007f3=\"\">\n                        </div>\n                    </div>\n                </div>\n                <hr _v-7ca007f3=\"\">\n                <div class=\"clearfix\" _v-7ca007f3=\"\">\n                    <label class=\"col-sm-2\" _v-7ca007f3=\"\">{{i18n.t('general.status')}}</label>\n                    <div class=\"col-sm-10\" _v-7ca007f3=\"\">\n                        <label class=\"m-right-10\" _v-7ca007f3=\"\">\n                            <input v-model=\"postData.status\" :checked=\"postData.status==1\" value=\"1\" type=\"radio\" _v-7ca007f3=\"\"> {{i18n.t('general.enable')}}\n                        </label>\n                        <label _v-7ca007f3=\"\">\n                            <input v-model=\"postData.status\" :checked=\"postData.status==0\" value=\"0\" type=\"radio\" _v-7ca007f3=\"\"> {{i18n.t('general.disable')}}\n                        </label>\n                    </div>\n                </div>\n            </div>\n            <div v-show=\"!view.ajaxing\" class=\"modal-footer\" _v-7ca007f3=\"\">\n                <button v-if=\"canDelete&amp;&amp;view.action!='create'\" @click=\"deleteEvent()\" class=\"btn btn-danger btn--inverse pull-left\" _v-7ca007f3=\"\">{{i18n.t('general.delete')}}</button>\n                <button class=\"btn btn-primary pull-right\" @click.prevent=\"submit\" _v-7ca007f3=\"\">{{i18n.t('general.submit')}}</button>\n            </div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.thumbnail[_v-7ca007f3] {\n  height: 120px;\n  width: 120px;\n  line-height: 120px;\n  margin-bottom: 0; }\n\n/* line 9, stdin */\n.img-thumb[_v-7ca007f3] {\n  margin-bottom: 5px;\n  margin-right: 5px; }\n  /* line 12, stdin */\n  .img-thumb .thumbnail[_v-7ca007f3] {\n    -moz-background-size: contain;\n    -webkit-background-size: contain;\n    -o-background-size: contain;\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-position: center; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-7ca007f3", module.exports)
  } else {
    hotAPI.update("_v-7ca007f3", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1155:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _systemEmailIndex = require('./system-email-index.vue');

var _systemEmailIndex2 = _interopRequireDefault(_systemEmailIndex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('webadmin-export-system-email-index', _systemEmailIndex2.default);

},{"./system-email-index.vue":1156,"vue":792}],1156:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.row .label-category[_v-f0c2b08e] {\n  display: none; }\n  /* line 4, stdin */\n  .row .label-category[_v-f0c2b08e]:first-child {\n    display: block; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            branchCategories: [],
            memberType: [],
            selectCategories: [],
            getData: [],
            ajaxing: false,
            ajaxingLoad: false
        };
    },
    mounted: function mounted() {
        this.fetchCategory();
    },

    watch: {
        getData: function getData(n, o) {
            var results = this.csvDataHandler(n);
            this.download(results);
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId', 'isBranch']), (0, _vuex.mapState)('filters', ['selected_studio_id', 'selected_branch_id']), (0, _vuex.mapActions)('webadmin/baseReport', [])),
    methods: {
        fetchCategory: function fetchCategory() {
            var _this = this;

            this.ajaxingLoad = true;
            this.$http.get('/adminapi/branch_category').then(function (response) {
                _this.ajaxingLoad = false;
                _this.branchCategories = response.data;
            }).catch(function (response) {
                $17.swal({
                    title: '取得資料失敗',
                    text: "",
                    type: 'warning',
                    showCancelButton: false
                });
            });
        },
        fetchCSVData: function fetchCSVData() {
            var _this2 = this;

            this.ajaxing = true;
            this.$http.post('/adminapi/export/system-email', {
                'category-ids': this.selectCategories,
                'member-types': this.memberType
            }).then(function (response) {
                _this2.getData = response.data;
                _this2.ajaxing = false;
            }).catch(function (response) {
                $17.swal({
                    title: '取得資料失敗',
                    text: "",
                    type: 'warning',
                    showCancelButton: false
                });
            });
        },
        download: function download(_csvString) {
            var downloadLink = document.createElement("a");
            downloadLink.download = "export.csv";
            downloadLink.innerHTML = "Download File";
            if (window.webkitURL != null) {
                var csvData = new Blob(['\uFEFF' + _csvString], { type: 'text/csv;charset=utf-8' });
                var csvUrl = URL.createObjectURL(csvData);
                downloadLink.href = csvUrl;
            }
            downloadLink.click();
        },
        csvDataHandler: function csvDataHandler(data) {
            data = this.columnFormatter(data);
            return Papa.unparse(data, {
                delimiter: ','
            });
        },
        columnFormatter: function columnFormatter(d) {
            String.prototype.replaceAll = function (search, replacement) {
                var target = this;
                return target.replace(new RegExp(search, 'g'), replacement);
            };
            var data = _lodash2.default.map(d, function (value) {
                return _lodash2.default.pick(value, ['email', 'name', 'company', 'dep', 'phone', 'date']);
            });
            data = (0, _stringify2.default)(data);
            data = data.replaceAll('name', '姓名');
            data = data.replaceAll('email', '電子郵件');
            data = data.replaceAll('company', '公司');
            data = data.replaceAll('dep', '部門');
            data = data.replaceAll('phone', '電話');
            data = data.replaceAll('date', '匯出日期');

            return data;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-f0c2b08e=\"\">\n    <div class=\"row\" _v-f0c2b08e=\"\">\n        <div class=\"col-xs-12\" _v-f0c2b08e=\"\">\n            <h2 _v-f0c2b08e=\"\">篩選條件</h2>\n        </div>\n    </div>\n    <div class=\"row\" _v-f0c2b08e=\"\">\n        <div class=\"col-xs-2\" _v-f0c2b08e=\"\">\n            <p class=\"label-category\" _v-f0c2b08e=\"\">\n                商家類別\n            </p>\n        </div>\n        <div class=\"col-xs-4\" _v-f0c2b08e=\"\">\n           \n        </div>\n    </div>\n    <div class=\"row\" _v-f0c2b08e=\"\">\n        <div class=\"col-xs-10 col-xs-offset-2\" _v-f0c2b08e=\"\">\n            <v-spinner-button :ajaxing=\"ajaxingLoad\" _v-f0c2b08e=\"\"></v-spinner-button>\n        </div>\n    </div>\n    <div class=\"row\" v-for=\"category in branchCategories\" v-show=\"!ajaxingLoad\" _v-f0c2b08e=\"\">\n        <div class=\"col-xs-2\" _v-f0c2b08e=\"\">\n           \n        </div>\n        <div class=\"col-xs-4\" _v-f0c2b08e=\"\">\n            <input type=\"checkbox\" v-model=\"selectCategories\" :value=\"category.id\" :id=\"'c'+category.id\" _v-f0c2b08e=\"\">\n            <label :for=\"'c'+category.id\" _v-f0c2b08e=\"\">\n                {{ category.name }}\n            </label>\n        </div>\n    </div>\n    <hr _v-f0c2b08e=\"\">\n    <div class=\"row\" _v-f0c2b08e=\"\">\n        <div class=\"col-xs-2\" _v-f0c2b08e=\"\">\n            身份\n        </div>\n        <div class=\"col-xs-4\" _v-f0c2b08e=\"\">\n           \n        </div>\n    </div>\n    <div class=\"row\" _v-f0c2b08e=\"\">\n        <div class=\"col-xs-2\" _v-f0c2b08e=\"\">\n            \n        </div>\n        <div class=\"col-xs-4\" _v-f0c2b08e=\"\">\n            <input type=\"checkbox\" value=\"studio\" id=\"t1\" v-model=\"memberType\" _v-f0c2b08e=\"\">\n            <label for=\"t1\" _v-f0c2b08e=\"\">品牌</label>\n        </div>\n    </div>\n    <div class=\"row\" _v-f0c2b08e=\"\">\n        <div class=\"col-xs-2\" _v-f0c2b08e=\"\">\n            \n        </div>\n        <div class=\"col-xs-4\" _v-f0c2b08e=\"\">\n            <input type=\"checkbox\" value=\"branch\" id=\"t2\" v-model=\"memberType\" _v-f0c2b08e=\"\">\n            <label for=\"t2\" _v-f0c2b08e=\"\">場館</label>\n        </div>\n    </div>\n    <div class=\"row\" _v-f0c2b08e=\"\">\n        <div class=\"col-xs-2\" _v-f0c2b08e=\"\">\n            \n        </div>\n        <div class=\"col-xs-4\" _v-f0c2b08e=\"\">\n            <input type=\"checkbox\" value=\"service_provider\" id=\"t3\" v-model=\"memberType\" _v-f0c2b08e=\"\">\n            <label for=\"t3\" _v-f0c2b08e=\"\">服務提供者</label>\n        </div>\n    </div>\n    <div class=\"row\" _v-f0c2b08e=\"\">\n        <div class=\"col-xs-2\" _v-f0c2b08e=\"\">\n            \n        </div>\n        <div class=\"col-xs-4\" _v-f0c2b08e=\"\">\n            <input type=\"checkbox\" value=\"staff\" id=\"t4\" v-model=\"memberType\" _v-f0c2b08e=\"\">\n            <label for=\"t4\" _v-f0c2b08e=\"\">人員</label>\n        </div>\n    </div>\n    <div class=\"row\" _v-f0c2b08e=\"\">\n        <div class=\"col-xs-2\" _v-f0c2b08e=\"\">\n            \n        </div>\n        <div class=\"col-xs-4\" _v-f0c2b08e=\"\">\n            <input type=\"checkbox\" value=\"top_manger\" id=\"t5\" v-model=\"memberType\" _v-f0c2b08e=\"\">\n            <label for=\"t5\" _v-f0c2b08e=\"\">最高管理員</label>\n        </div>\n    </div>\n    <hr _v-f0c2b08e=\"\">\n    <div class=\"row col-xs-10 col-xs-offset-2\" _v-f0c2b08e=\"\">\n        <div class=\"btn btn-primary\" @click=\"fetchCSVData\" v-show=\"!ajaxing\" _v-f0c2b08e=\"\">\n            下載csv\n        </div>\n        <v-spinner-button :ajaxing=\"ajaxing\" _v-f0c2b08e=\"\"></v-spinner-button>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.row .label-category[_v-f0c2b08e] {\n  display: none; }\n  /* line 4, stdin */\n  .row .label-category[_v-f0c2b08e]:first-child {\n    display: block; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-f0c2b08e", module.exports)
  } else {
    hotAPI.update("_v-f0c2b08e", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/json/stringify":48,"babel-runtime/helpers/extends":66,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1157:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.icon[_v-38f186f3] {\n  margin-left: 10px;\n  margin-right: 5px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    mounted: function mounted() {},

    data: function data() {
        return {
            postDefaultData: {
                name: '',
                button_text: '',
                link_type: '',
                url: ''
            },
            postData: {
                name: '',
                button_text: '',
                link_type: '',
                url: ''
            },
            content: [],
            ajaxing: false,
            linkTypeList: {
                'get-detail': {
                    'text': '了解詳情',
                    'fa': 'fa-info-circle'
                },
                'watch-video': {
                    'text': '觀賞影片',
                    'fa': 'fa-play-circle'
                },
                'custom-text': {
                    'text': '自訂文字',
                    'fa': 'fa-external-link-square'
                }
            }
        };
    },
    props: ['openId', 'studioId', 'branchId', 'mode'],
    computed: {
        modeText: function modeText() {
            if (this.mode == "edit") {
                return '編輯';
            }
            return '新增';
        },
        btnText: function btnText() {
            if (this.mode == "edit") {
                return '儲存';
            }
            return '新增';
        }
    },
    methods: {
        submit: function submit() {
            // $(this.$el).modal('hide');
            if (this.mode == "create") {
                this.create();
            }

            if (this.mode == "edit") {
                this.update();
            }
        },
        create: function create() {
            var _this = this;

            if (!this.checkStringValid()) {
                return;
            }
            this.ajaxing = true;
            var data = this.postData;
            data.studio_id = this.studioId;
            data.branch_id = this.branchId;
            this.$http.post('/adminapi/external-link', data).then(function (response) {
                $17.swal({
                    title: '新增外部連結成功',
                    text: "",
                    type: 'success',
                    showCancelButton: false
                });
                _this.ajaxing = false;
                $(_this.$el).modal('hide');
                _this.$emit('fresh');
                _this.setDefault();
            }, function (error) {
                $17.swal({
                    title: '新增外部連結錯誤',
                    text: error.data.message,
                    type: 'error',
                    showCancelButton: false
                });
                _this.ajaxing = false;
            });
        },
        checkCustomTextLength: function checkCustomTextLength() {
            if (this.postData.button_text.length > 6) {
                $17.swal({
                    title: '自訂文字不可超過6個字',
                    text: "",
                    type: 'error',
                    showCancelButton: false
                });
                return false;
            }
            return true;
        },
        validURL: function validURL(str) {
            var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
            '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
            if (!!!pattern.test(str)) {
                $17.swal({
                    title: '請檢查網址',
                    text: "",
                    type: 'error',
                    showCancelButton: false
                });
                return false;
            }
            return true;
        },
        useCustomText: function useCustomText(link_type) {
            if (link_type === 'custom-text') {
                return true;
            }

            return false;
        },
        getLink: function getLink(val) {
            var _this2 = this;

            if (val == null) {
                return;
            }
            this.ajaxing = true;
            this.$http.get('/adminapi/external-link/' + val).then(function (response) {
                _this2.setDefault();
                _this2.ajaxing = false;
                _this2.postData.name = response.data.name;
                _this2.postData.link_type = response.data.link_type;
                _this2.postData.url = response.data.url;

                if (_this2.useCustomText(response.data.link_type)) {

                    _this2.postData.button_text = response.data.button_text;
                }
            }, function (error) {
                _this2.ajaxing = false;
            });
        },
        update: function update() {
            var _this3 = this;

            if (!this.checkStringValid()) {
                return;
            }
            this.ajaxing = true;
            var data = this.postData;
            this.$http.post('/adminapi/external-link/' + this.openId, data).then(function (response) {
                $17.swal({
                    title: '編輯外部連結成功',
                    text: "",
                    type: 'success',
                    showCancelButton: false
                });
                _this3.ajaxing = false;
                $(_this3.$el).modal('hide');
                _this3.$emit('fresh');
                _this3.setDefault();
            }, function (error) {
                $17.swal({
                    title: '編輯外部連結錯誤',
                    text: error.data.message,
                    type: 'error',
                    showCancelButton: false
                });
                _this3.ajaxing = false;
            });
        },
        deleteItem: function deleteItem() {
            var _this4 = this;

            $17.swal({
                title: '確認刪除？',
                text: '此操作無法返回',
                type: 'warning',
                showCancelButton: true,
                closeOnConfirm: false,
                showLoaderOnConfirm: true
            }, function (answer) {
                if (answer) {
                    _this4.ajaxing = true;

                    _this4.$http.delete('/adminapi/external-link/' + _this4.openId).then(function (response) {
                        $17.swal({
                            title: '刪除外部連結成功',
                            text: "",
                            type: 'success',
                            showCancelButton: false
                        });
                        _this4.ajaxing = false;
                        $(_this4.$el).modal('hide');
                        _this4.$emit('fresh');
                        _this4.setDefault();
                    }, function (error) {
                        $17.swal({
                            title: '刪除外部連結錯誤',
                            text: error.data.message,
                            type: 'error',
                            showCancelButton: false
                        });
                        $(_this4.$el).modal('hide');
                        _this4.$emit('fresh');
                        _this4.setDefault();
                        _this4.ajaxing = false;
                    });
                }
            });
        },
        closeModalEvent: function closeModalEvent() {
            this.setDefault();
            this.$emit('reset-open-id');
        },
        setDefault: function setDefault() {
            this.postData = JSON.parse((0, _stringify2.default)(this.postDefaultData));
        },
        checkEmoji: function checkEmoji(str) {
            var ranges = ['\uD83C[\uDF00-\uDFFF]', // U+1F300 to U+1F3FF
            '\uD83D[\uDC00-\uDE4F]', // U+1F400 to U+1F64F
            '\uD83D[\uDE80-\uDEFF]' // U+1F680 to U+1F6FF
            ];
            if (str.match(ranges.join('|'))) {
                $17.swal({
                    title: '名稱不可以含有表情符號',
                    text: "",
                    type: 'error',
                    showCancelButton: false
                });
                return false;
            } else {
                return true;
            }
            return true;
        },
        checkSpecial: function checkSpecial(str) {
            var format = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;

            if (format.test(str)) {
                $17.swal({
                    title: '名稱不可以含有特殊字元',
                    text: "",
                    type: 'error',
                    showCancelButton: false
                });
                return false;
            }
            return true;
        },
        checkStringValid: function checkStringValid() {
            return this.checkCustomTextLength() && this.validURL(this.postData.url) && this.checkEmoji(this.postData.name) && this.checkEmoji(this.postData.button_text) && this.checkSpecial(this.postData.name) && this.checkSpecial(this.postData.button_text);
        }
    },
    watch: {
        openId: function openId(val) {
            this.getLink(val);
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal id=\"external-content-modal\" :save-clicked=\"submit\" no-cancel=\"\" :confirm-btn-text=\"btnText\" :remove-btn-show=\"openId\" :remove-clicked=\"deleteItem\" :close-modal-event=\"closeModalEvent\" _v-38f186f3=\"\">\n    <span slot=\"title\" _v-38f186f3=\"\">{{ modeText }}外部連結</span>\n    <template slot=\"body\"> \n        <v-spinner :ajaxing=\"ajaxing\" _v-38f186f3=\"\"></v-spinner>\n        <form class=\"form-horizontal\" v-show=\"!ajaxing\" _v-38f186f3=\"\">\n            <div class=\"row\" _v-38f186f3=\"\">\n                <label class=\"col-sm-2 control-label\" _v-38f186f3=\"\">連結名稱:</label>\n                <div class=\"col-sm-10\" _v-38f186f3=\"\">\n                    <input type=\"text\" class=\"form-control\" v-model=\"postData.name\" _v-38f186f3=\"\">\n                </div>\n            </div>\n            <div class=\"row\" _v-38f186f3=\"\">\n                <label class=\"col-sm-2\" _v-38f186f3=\"\">\n                    <span class=\"link-text\" _v-38f186f3=\"\">連結按鈕:</span>\n                </label>\n                <div class=\"col-sm-10\" _v-38f186f3=\"\">\n                </div>\n            </div>\n            <div class=\"row m-top-10\" v-for=\"(item,key) in linkTypeList\" _v-38f186f3=\"\">\n                <label class=\"col-sm-2\" _v-38f186f3=\"\">\n                    <span _v-38f186f3=\"\"></span>\n                </label>\n                <div class=\"col-sm-10\" _v-38f186f3=\"\">\n                    <input type=\"radio\" name=\"linkType\" v-model=\"postData.link_type\" :value=\"key\" :id=\"'type'+key\" _v-38f186f3=\"\">\n                    <label class=\"control-label\" :for=\"'type'+key\" _v-38f186f3=\"\">\n                        <i class=\"icon fa\" :class=\"item.fa\" _v-38f186f3=\"\"></i>\n                        <span _v-38f186f3=\"\">{{ item.text }}</span>\n                    </label>\n                </div>\n                 <label class=\"col-sm-2\" v-if=\"key=='custom-text'\" _v-38f186f3=\"\">\n                    <span _v-38f186f3=\"\"></span>\n                </label>\n                <div class=\"col-sm-10 m-top-10\" v-if=\"key=='custom-text'\" _v-38f186f3=\"\">\n                    <input type=\"text\" class=\"form-control\" :disabled=\"!useCustomText(postData.link_type)\" v-model=\"postData.button_text\" max-length=\"6\" placeholder=\"最大字數限制:6\" _v-38f186f3=\"\">\n                </div>\n            </div>\n            <div class=\"row m-top-10\" _v-38f186f3=\"\">\n                <label class=\"col-sm-2 control-label\" _v-38f186f3=\"\">網址:</label>\n                <div class=\"col-sm-10\" _v-38f186f3=\"\">\n                    <input type=\"text\" class=\"form-control\" v-model=\"postData.url\" _v-38f186f3=\"\">\n                </div>\n            </div>\n        </form>\n    </template>\n</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.icon[_v-38f186f3] {\n  margin-left: 10px;\n  margin-right: 5px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-38f186f3", module.exports)
  } else {
    hotAPI.update("_v-38f186f3", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/json/stringify":48,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1158:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _list = require('./list.vue');

var _list2 = _interopRequireDefault(_list);

var _contentModal = require('./content-modal.vue');

var _contentModal2 = _interopRequireDefault(_contentModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('webadmin-external-link-list', _list2.default);
_vue2.default.component('webadmin-content-external-link-modal', _contentModal2.default);

},{"./content-modal.vue":1157,"./list.vue":1159,"vue":792}],1159:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.row[_v-361c0574] {\n  margin-top: 15px; }\n\n/* line 5, stdin */\n.list > .row[_v-361c0574] {\n  border-bottom: 1px solid #797e83; }\n\n/* line 8, stdin */\n.link-list[_v-361c0574] {\n  cursor: pointer; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            list: [],
            ajaxing: {
                list: false
            },
            mode: '',
            openId: null
        };
    },

    watch: {
        ACTIVE_BRANCH_ID: function ACTIVE_BRANCH_ID(newVal) {
            if (newVal > 0) {
                this.getList();
            }
        },
        ACTIVE_STUDIO_ID: function ACTIVE_STUDIO_ID() {
            if (this.ACTIVE_BRANCH_ID > 0) {
                this.getList();
            }
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId']), (0, _vuex.mapGetters)('webadmin/configure', ['ACTIVE_STUDIO_ID', 'ACTIVE_BRANCH_ID'])),
    mounted: function mounted() {},

    methods: {
        showDetail: function showDetail(itemId) {
            this.mode = "edit";
            this.openId = itemId;
            $('#external-content-modal').modal('show');
        },
        getList: function getList() {
            var _this = this;

            this.ajaxing.list = true;
            this.$http.get('/adminapi/external-link/branch/' + this.ACTIVE_BRANCH_ID).then(function (response) {
                _this.ajaxing.list = false;
                _this.list = response.data;
            }, function (error) {
                _this.ajaxing.list = false;
            });
        },
        showCreate: function showCreate() {
            this.mode = "create";
            $('#external-content-modal').modal('show');
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n    <div class=\"content-inner\" _v-361c0574=\"\">\n        <v-select-studio-and-branch :studio_id=\"studioId\" :branch-without-filtered-option=\"false\" :branch_id=\"branchId\" _v-361c0574=\"\"></v-select-studio-and-branch>\n    <div _v-361c0574=\"\">\n    <div class=\"content-inner\" _v-361c0574=\"\">\n        <v-spinner :ajaxing=\"ajaxing.list\" _v-361c0574=\"\"></v-spinner>\n        <div v-show=\"!ajaxing.list\" _v-361c0574=\"\">\n            <div class=\"row\" _v-361c0574=\"\">\n                <div class=\"col-xs-6\" _v-361c0574=\"\">\n                    <a href=\"#\" class=\"btn btn-success\" @click=\"showCreate\" v-show=\"ACTIVE_BRANCH_ID\" _v-361c0574=\"\">\n                        <i class=\"fa fa-plus\" _v-361c0574=\"\"></i> 新增連結按鈕\n                    </a>\n                </div>\n            </div>\n            <div class=\"table-responsive m-top-20\" _v-361c0574=\"\">\n                <table class=\"table\" _v-361c0574=\"\">\n                    <thead _v-361c0574=\"\">\n                    <tr _v-361c0574=\"\">\n                        <th class=\"col-sm-3\" _v-361c0574=\"\">名稱</th>\n                        <th class=\"col-sm-3\" _v-361c0574=\"\">按鈕文字</th>\n                        <th class=\"col-sm-6\" _v-361c0574=\"\">URL</th>\n                    </tr>\n                    </thead>\n                    <tbody _v-361c0574=\"\">\n                        <tr class=\"link-list\" v-for=\"item in list\" @click=\"showDetail(item.id)\" _v-361c0574=\"\">\n                            <td _v-361c0574=\"\">{{ item.name}}</td>\n                            <td _v-361c0574=\"\">\n                                <i class=\"fa\" :class=\"item.button_icon\" _v-361c0574=\"\"></i>\n                                \n                                {{ item.button_text}}</td>\n                            <td class=\"\" _v-361c0574=\"\">{{ item.url}}</td>\n                        </tr>\n                    </tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n    <webadmin-content-external-link-modal :studio-id=\"ACTIVE_STUDIO_ID\" :branch-id=\"ACTIVE_BRANCH_ID\" :open-id=\"openId\" :mode=\"mode\" @fresh=\"getList()\" @reset-open-id=\"openId=null\" _v-361c0574=\"\"></webadmin-content-external-link-modal>\n</div></div>"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.row[_v-361c0574] {\n  margin-top: 15px; }\n\n/* line 5, stdin */\n.list > .row[_v-361c0574] {\n  border-bottom: 1px solid #797e83; }\n\n/* line 8, stdin */\n.link-list[_v-361c0574] {\n  cursor: pointer; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-361c0574", module.exports)
  } else {
    hotAPI.update("_v-361c0574", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1160:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {},
    data: function data() {
        return {
            startAjax: false,
            years: [],
            months: [],
            selectYear: moment().year(),
            lists: []
        };
    },

    watch: {
        selectYear: function selectYear() {
            this.getMonths();
            if (this.selected_studio_id > 0) {
                this.fetchData();
            }
        }
    },
    created: function created() {
        this.getYears();
        this.getMonths();
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId']), (0, _vuex.mapState)('filters', ['selected_studio_id'])),
    methods: {
        issueInvoice: function issueInvoice(payload) {
            var _this = this;

            this.startAjax = true;
            this.$http.post('/adminapi/fee-management/create/order/' + payload.id).then(function (response) {
                _this.startAjax = false;
                if (response.data.status == 1) {
                    _this.fetchData();
                    _this.alert('開立成功', '', 'success');
                }
            }).catch(function (response) {
                _this.startAjax = false;
                _this.alert(response.data.message, '', 'warning');
            });
        },
        changeIsAllowance: function changeIsAllowance(e) {
            var putData = { is_allowance: e.target.checked === true ? 1 : 0 };
            this.updateData(e.target.value, putData);
        },
        updateData: function updateData(feeId, _updateData) {
            var _this2 = this;

            this.$http.put('/adminapi/fee-management/update/' + feeId, _updateData).then(function (response) {
                _this2.startAjax = false;
                _this2.alert('修改成功', '', 'success');
            }).catch(function (response) {
                _this2.startAjax = false;
                _this2.alert('修改失敗', '', 'warning');
            });
        },
        getYears: function getYears() {
            this.years = [];
            for (var year = this.selectYear; year >= 2018; year--) {
                this.years.push(year);
            }
        },
        getMonths: function getMonths() {
            this.months = [];
            var allMonths = this.selectYear == moment().year() ? moment().month() - 1 : 11;
            var m = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
            for (var month = allMonths; month >= 0; month--) {
                this.months.push(m[month]);
            }
        },

        studioChangeCallBack: function () {
            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(studioId) {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (studioId && this.selectYear) {
                                    this.fetchData();
                                }

                            case 1:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function studioChangeCallBack(_x) {
                return _ref.apply(this, arguments);
            }

            return studioChangeCallBack;
        }(),
        fetchData: function fetchData() {
            var _this3 = this;

            this.startAjax = true;
            this.$http.get('/adminapi/fee-management/studio/' + this.selected_studio_id, { params: { year: this.selectYear } }).then(function (response) {
                _this3.lists = response.data.lists;
                _this3.startAjax = false;
            }).catch(function (response) {
                _this3.startAjax = false;
                _this3.alert('取得資料失敗', '', 'warning');
            });
        },

        alert: function alert(title, message, type) {
            $17.swal({
                title: title,
                text: message,
                type: type,
                showCancelButton: false,
                showLoaderOnConfirm: true
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"col-sm-12\">\n    <div class=\"form-group clearfix\">\n        <label class=\"control-label p-t-5 m-right-10 pull-left\">年度</label>\n        <div class=\"pull-left\">\n            <select v-model=\"selectYear\" class=\"form-control\">\n                <option v-for=\"year in years\">{{year}}</option>\n            </select>\n        </div>\n    </div>\n    <div class=\"form-group\">\n        <v-select-studio-and-branch :studio_id=\"studioId\" :show-branch=\"false\" :studio-change-call-back=\"studioChangeCallBack\">\n        </v-select-studio-and-branch>\n    </div>\n    <v-spinner :ajaxing=\"startAjax\">\n    </v-spinner>\n    <div class=\"table-responsive\">\n        <table v-show=\"!startAjax&amp;&amp;Object.keys(lists).length>0\" class=\"table\">\n            <thead>\n            <tr>\n                <th>場館</th>\n                <th class=\"text-center\" v-for=\"month in months\">{{selectYear}}/{{month}}</th>\n            </tr>\n            </thead>\n            <tbody>\n            <tr v-for=\"(branch, branchName) in lists\">\n                <td>{{branchName}}</td>\n                <td v-for=\"month in months\" class=\"text-center\">\n                    <div v-if=\"branch.hasOwnProperty(month)&amp;&amp;branch[month]['fee']!==0\">\n                        <div class=\"m-bottom-10 m-top-10\">{{moneyFormat(branch[month]['fee'])}}</div>\n                        <button class=\"btn btn-sm btn-primary\" v-if=\"!branch[month]['invoice_number']&amp;&amp;branch[month]['fee']>0\" @click.prevent=\"issueInvoice({id:branch[month]['fee_management_id']})\">\n                            開立\n                        </button>\n                        <div v-else-if=\"branch[month]['fee']<0\">\n                            <label>\n                                <input type=\"checkbox\" @change=\"changeIsAllowance\" :value=\"branch[month]['fee_management_id']\" :checked=\"branch[month]['is_allowance']==1\"> 已折讓\n                            </label>\n                        </div>\n                        <div v-else=\"\">\n                            <div class=\"text-muted\">{{branch[month]['invoice_number']}}</div>\n                            <div class=\"text-muted\">{{moneyFormat(branch[month]['fee'])}}</div>\n                        </div>\n                    </div>\n                    <div class=\"m-bottom-10 m-top-10\" v-else=\"\">$0</div>\n                </td>\n            </tr>\n            </tbody>\n        </table>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-7fd5e898", module.exports)
  } else {
    hotAPI.update("_v-7fd5e898", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vuex":803}],1161:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _index = require('./index.vue');

var _index2 = _interopRequireDefault(_index);

var _settingFirebaseModal = require('./setting-firebase-modal.vue');

var _settingFirebaseModal2 = _interopRequireDefault(_settingFirebaseModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('setting-firebase-modal', _settingFirebaseModal2.default);
_vue2.default.component('webadmin-firebase-cloud-message-setting', _index2.default);

},{"./index.vue":1162,"./setting-firebase-modal.vue":1163,"vue":792}],1162:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.title-border-bottom[_v-327c8a6e] {\n  border-width: 1px;\n  border-bottom-style: solid; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _watch;

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      deviceList: [],
      tableConfig: {
        columns: [{
          keys: 'firebase_credentials_json',
          head: 'Json金鑰',
          height: '4em',
          maxWidth: '40em',
          headerStyle: { width: '40em' },
          html: function html(item) {
            var str = item.firebase_credentials_json;
            if (str && str.length > 50) {
              str = str.substring(0, 50) + '...';
            }
            return str;
          }

        }, {
          keys: 'status',
          head: '狀態',
          html: function html(item) {
            return item.status == 1 ? '<span class="st-text-green">\u555F\u7528\u4E2D</span>' : '<span class="st-text-gray-90">\u672A\u555F\u7528</span>';
          }
        }, {
          keys: 'action',
          head: '',
          minWidth: '5em',
          maxWidth: '5em',
          headerStyle: { width: '5em' },
          html: function html(item) {
            return '<div class="st-py-3">\n              <st-button neutral icon leftIcon=\'edit\' @click.prevent.stop="clickHandler(\'editSetting\', $event)"></st-button>\n              </div>';
          }
        }]
      },
      relatedFilterWatcher: {
        studio_id: {
          watcher: null,
          options: "studioList",
          vModel: "studioId",
          trackBy: "id",
          type: "single"
        }
      }
    };
  },
  created: function created() {},
  mounted: function mounted() {
    var _this = this;

    this.configuredRun(function () {
      _this.changeFilterOption({
        prop: 'studioId',
        value: {
          id: _this.configureStates.studioId,
          brand_name: ''
        }
      });
      if (_this.configureStates.isSeventeen) {
        return _this.fetchStudioList();
      }
      if (_this.configureStates.isStudio) {
        _this.fetchContractList({ 'studioId': _this.configureStates.studioId, 'withDelete': true });
        _this.getResult();
      }
    });
  },

  watch: (_watch = {}, (0, _defineProperty3.default)(_watch, 'filterOptions.studioId', function filterOptionsStudioId(n, o) {}), (0, _defineProperty3.default)(_watch, 'viewMode', function viewMode(newV) {
    if (newV) {
      this.reset();
    }
  }), _watch),
  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
    configureStates: function configureStates(state) {
      return state.webadmin.configure;
    },
    selectedStudioId: function selectedStudioId(state) {
      return state.filters.selected_studio_id;
    }
  }), (0, _vuex.mapState)('webadmin/configure', ['configured', 'studioList']), (0, _vuex.mapState)('webadmin/baseReport', ['blockOpenStatus', 'dateOptions', 'filterOptions', 'queryPara', "ajaxing"]), {
    studioId: {
      get: function get() {
        return this.filterOptions.studioId;
      },
      set: function set(newValue) {
        var _this2 = this;

        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
          return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return _this2.changeFilterOption({ 'prop': 'studioId', value: newValue });

                case 2:
                  if (newValue) {
                    _this2.getResult();
                  }

                case 3:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this2);
        }))();
      }
    }
  }),
  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('webadmin/configure', ['configuredRun', 'fetchStudioList', 'fetchContractList']), (0, _vuex.mapActions)('webadmin/baseReport', ['changeFilterOption', 'changeItemOption', "changeAjaxing"]), {
    clickHtmlHandler: function clickHtmlHandler(val) {
      this[val.action](val.row);
    },
    editSetting: function editSetting(firebase) {
      var studioId = this.studioId && this.studioId.hasOwnProperty('id') ? this.studioId.id : 0;
      if (firebase.firebase_credentials_json == '--') {
        this.$refs.setting_firebase_modal.show({ mode: 'create', firebase: { studio_id: studioId } });
      } else {
        this.$refs.setting_firebase_modal.show({
          mode: 'update',
          firebase: {
            id: studioId,
            studio_id: firebase.studio_id,
            firebase_credentials_json: firebase.firebase_credentials_json,
            status: firebase.status
          }
        });
      }
    },
    updateFilterOption: function updateFilterOption(field) {
      var _this3 = this;

      return function (value) {
        return _this3.changeFilterOption({
          prop: field,
          value: value
        });
      };
    },
    getResult: function getResult() {
      var _this4 = this;

      var type = 'firebase';
      var studioId = this.studioId && this.studioId.hasOwnProperty('id') ? this.studioId.id : 0;
      this.changeAjaxing(true);
      this.$http.get('/adminapi/cloud-message-setting/' + type + '/studio/' + studioId).then(function (response) {
        if (response.data[type] == null) {
          _this4.deviceList = [{ 'firebase_credentials_json': '--' }];
        } else {
          _this4.deviceList = [response.data[type]];
        }
        _this4.changeAjaxing(false);
      }, function (error) {
        _this4.changeAjaxing(false);
        $17.swal({
          title: error.body.message || '伺服器無回應，請檢查網路。',
          type: 'warning'
        });
      });
    }
  })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"page-div\" _v-327c8a6e=\"\">\n  <div class=\"col-sm-4\" v-show=\"configureStates.isSeventeen\" _v-327c8a6e=\"\">\n    <div class=\"form-group\" _v-327c8a6e=\"\">\n      <v-mutiselect :model.sync=\"studioId\" :options=\"studioList\" :preserve-search=\"true\" :placeholder=\"configureStates.ajaxing.studioList ? '品牌讀取中…' : '請選擇品牌'\" label=\"brand_name\" track-by=\"id\" _v-327c8a6e=\"\">\n      </v-mutiselect>\n    </div>\n  </div>\n  <div class=\"col-sm-12 st-text-24 st-leading-9 st-font-bold st-py-4 title-border-bottom st-border-gray-40\" _v-327c8a6e=\"\">\n    Firebase Cloud Message 設定\n  </div>\n  <div class=\"col-sm-12 m-top-10 st-p-4\" _v-327c8a6e=\"\">\n    <v-smart-table ref=\"smart_table\" :table-config=\"tableConfig\" :is-ajaxing=\"ajaxing\" :data=\"{ records: deviceList, pageMeta: {} }\" @html-click-callback=\"clickHtmlHandler\" _v-327c8a6e=\"\"></v-smart-table>\n  </div>\n  <setting-firebase-modal ref=\"setting_firebase_modal\" @input-result=\"getResult\" _v-327c8a6e=\"\">\n  </setting-firebase-modal>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.title-border-bottom[_v-327c8a6e] {\n  border-width: 1px;\n  border-bottom-style: solid; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-327c8a6e", module.exports)
  } else {
    hotAPI.update("_v-327c8a6e", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/defineProperty":65,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1163:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      mode: 'create', // update | create
      studioId: 0,
      firebase: {},
      ajaxing: false
    };
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({}), {
    modalTitle: function modalTitle() {
      return this.mode == 'update' ? '編輯金鑰' : '新增金鑰';
    }
  }),
  methods: {
    show: function show(_ref) {
      var mode = _ref.mode,
          firebase = _ref.firebase;

      this.mode = mode;
      this.studioId = firebase.studio_id;
      if (mode == 'update') {
        this.firebase = firebase;
      } else {
        this.resetData();
      }
      $(this.$el).modal('show');
    },
    resetData: function resetData() {
      this.firebase = {
        id: 0,
        firebase_credentials_json: '',
        status: ''
      };
    },
    save: function save() {
      var _this = this;

      var type = 'firebase';
      this.ajaxing = true;
      var params = {
        firebase_credentials_json: this.firebase.firebase_credentials_json,
        status: this.firebase.status ? 1 : 0
      };
      this.$http.put('/adminapi/cloud-message-setting/' + type + '/studio/' + this.studioId, { 'settings_params': params }).then(function (response) {
        _this.successHandler();
      }, function (error) {
        $17.swal({
          title: '設定失敗',
          type: 'error',
          showCancelButton: false
        });
        _this.successHandler();
      });
    },
    successHandler: function successHandler() {
      this.ajaxing = false;
      this.$emit('input-result');
      $(this.$el).modal('hide');
    },
    close: function close() {
      $(this.$el).modal('hide');
    }
  }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal id=\"setting_printer_modal\">\n  <span slot=\"title\">{{ modalTitle }}</span>\n  <template slot=\"body\">\n    <div class=\"st-space-y-4 st-my-3\">\n      <st-checkbox name=\"status\" label=\"啟用\" :model.sync=\"firebase.status\">\n      </st-checkbox>\n      <st-textarea placeholder=\"請填入 Json 金鑰\" rows=\"20\" label=\"Json 金鑰\" :disabled=\"ajaxing\" v-model=\"firebase.firebase_credentials_json\">\n      </st-textarea>\n    </div>\n  </template>\n  <template slot=\"footer\">\n    <div class=\"st-flex\">\n      <div class=\"st-flex st-grow st-justify-end st-space-x-2\">\n        <st-button primary=\"\" ghost=\"\" @click.prevent=\"close\" :disabled=\"ajaxing\">關閉</st-button>\n        <st-button primary=\"\" filled=\"\" @click.prevent=\"save\" :disabled=\"ajaxing\">儲存</st-button>\n      </div>\n    </div>\n  </template>\n</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-4be84598", module.exports)
  } else {
    hotAPI.update("_v-4be84598", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vuex":803}],1164:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n.float-widget[_v-0264db2e] {\n    width: var(--float-widget-width);\n    margin:0 var(--float-widget-offset-width) 0 0;\n    background: #ffffff;\n    z-index: 1060;\n    position: fixed;\n    top: 0;\n    right: 0;\n    height: 100vh;\n    -moz-transition: all 200ms ease-in;\n    -webkit-transition: all 200ms ease-in;\n    -o-transition: all 200ms ease-in;\n    transition: all 200ms ease-in;\n    overflow-y: scroll;\n    overflow-x:hidden;\n    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);    \n}\n@media all and (max-width: 767px){\n    .float-widget[_v-0264db2e] {\n        width: 100%;\n        margin: 0 -100% 0 0;\n        height: 100vh;\n        top: 0\n    }\n}\n\n/* line 2, stdin */\n.widget-header[_v-0264db2e] {\n  display: -ms-flexbox;\n  display: flex;\n  height: 60px;\n  border-bottom: 1px solid #E7E7E7;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  -ms-flex-align: center;\n      align-items: center;\n  position: -webkit-sticky;\n  position: sticky;\n  background: #fff;\n  top: 0;\n  z-index: 10; }\n  /* line 12, stdin */\n  .widget-header .title[_v-0264db2e] {\n    font-size: 20px; }\n  /* line 15, stdin */\n  .widget-header .widget-toggle[_v-0264db2e] {\n    cursor: pointer;\n    margin-bottom: 0; }\n  /* line 19, stdin */\n  .widget-header .external-link[_v-0264db2e] {\n    margin-right: 20px; }\n    /* line 21, stdin */\n    .widget-header .external-link i[_v-0264db2e] {\n      cursor: pointer;\n      color: #000; }\n\n/* line 27, stdin */\n.isOpen[_v-0264db2e] {\n  margin: 0; }\n\n/* line 30, stdin */\n.float-widget[_v-0264db2e]::-webkit-scrollbar {\n  display: none; }\n\n@media all and (max-width: 767px) {\n  /* line 35, stdin */\n  .widget-header .external-link[_v-0264db2e] {\n    display: none; } }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

var _tippy = require('tippy.js');

var _tippy2 = _interopRequireDefault(_tippy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'FloatWidget',
    data: function data() {
        return {
            widgetToggle: false,
            current: {
                // mode: 'side',
                width: 'default'
            },
            configs: {
                // mode: 'side',//side||center
                width: {
                    default: '389px',
                    small: '40%',
                    half: '50%',
                    large: '80%',
                    full: '100%'
                }
            },
            title: '',
            urlQuery: {},
            path: ''
        };
    },
    created: function created() {
        var cookies = Cookies.get();
        this.addCookieToUrl(cookies);
        this.bootstrapWebadmin();
    },
    mounted: function mounted() {
        var vm = this;
        this.urlQuery = $17.getUrlQueryStrings();
        this.initView();
        this.$bus.$on('FloatWidget.Show', function (widgetParams) {
            vm.emitFloatWidget(widgetParams);
        });
        this.$bus.$on('FloatWidget.Close', function () {
            vm.closeFloatWidget();
        });
    },
    destroyed: function destroyed() {
        this.$bus.$off('FloatWidget.Show');
        this.$bus.$off('FloatWidget.Close');
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        webFunctions: function webFunctions(state) {
            return state.webadmin.configure.webFunctions;
        }
    }), {
        cssVariable: function cssVariable() {
            var configWidth = this.configs.width[this.current.width];
            return {
                '--float-widget-width': configWidth,
                '--float-widget-offset-width': '-' + configWidth
            };
        }
    }),
    watch: {
        webFunctions: function webFunctions(newV) {
            this.generateFloatWidget();
        }
    },
    methods: {
        initView: function initView() {
            var newLink = (0, _tippy2.default)('.external-link', {
                content: '開新分頁',
                placement: 'bottom'
            });
        },
        emitFloatWidget: function emitFloatWidget(widget) {
            var params = this.checkConfig(widget);
            this.updateQueryStrings(params);
            this.generateFloatWidget();
        },
        checkConfig: function checkConfig(widget) {
            var widthConfig = this.current.width;
            if (widget.hasOwnProperty('widget_config_width') && (0, _keys2.default)(this.configs.width).includes(widget.widget_config_width)) {
                widthConfig = widget.widget_config_width;
            }

            widget.widget_config_width = widthConfig;
            return widget;
        },
        generateFloatWidget: function generateFloatWidget() {
            var disableWidget = this.urlQuery.hasOwnProperty('disable_fw');
            var isOpen = this.urlQuery.hasOwnProperty('widget');
            if (disableWidget) return;

            this.widgetToggle = isOpen;
            if (isOpen) {
                this.$router.hasPermission(this.webFunctions);
                this.$router.replace({
                    name: this.urlQuery.widget,
                    params: (0, _extends3.default)({}, this.urlQuery)
                });
                this.title = this.$route.meta.title;
                if (this.urlQuery.hasOwnProperty('widget_config_width')) {
                    this.current.width = this.urlQuery.widget_config_width;
                }
            };
        },
        close: function close() {
            if (this.$refs.widgetView.closeFloatWidget) {
                this.$refs.widgetView.closeFloatWidget();
            } else {
                this.closeFloatWidget();
            }
        },
        closeFloatWidget: function closeFloatWidget() {
            this.widgetToggle = false;
            var keys = [];
            for (var param in this.urlQuery) {
                if (String(param).includes('widget')) {
                    keys.push(param);
                }
            };
            this.removeQueryStrings(keys);
        },
        updateQueryStrings: function updateQueryStrings(queryObject) {
            this.urlQuery = $17.getUrlQueryStrings();
            for (var param in queryObject) {
                this.urlQuery[param] = queryObject[param].toString();
                Cookies.set(param, queryObject[param]);
            };
            var newQueryString = $17.queryStringBuilder(this.urlQuery);
            history.replaceState({}, null, '?' + newQueryString);
        },
        removeQueryStrings: function removeQueryStrings(keys) {
            var _this = this;

            this.urlQuery = $17.getUrlQueryStrings();
            keys.forEach(function (key) {
                delete _this.urlQuery[key];
                Cookies.remove(key);
            });
            var newQueryString = $17.queryStringBuilder(this.urlQuery);
            history.replaceState({}, null, '?' + newQueryString);
        },
        fetchExternalLinkPath: function fetchExternalLinkPath(path) {
            this.path = path;
        },
        addCookieToUrl: function addCookieToUrl(cookies) {
            var widget = {};
            for (var param in cookies) {
                if (String(param).includes('widget')) {
                    widget[param] = cookies[param];
                }
            };
            this.updateQueryStrings(widget);
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"float-widget\" :class=\"{ isOpen: widgetToggle }\" :style=\"cssVariable\" _v-0264db2e=\"\">\n    <div class=\"widget-header st-p-4\" ref=\"widgetHeader\" _v-0264db2e=\"\">\n        <div class=\"title\" _v-0264db2e=\"\">{{ title }}</div>\n        <div class=\"st-flex st-items-center\" _v-0264db2e=\"\">\n            <a class=\"external-link\" :href=\"path+'?disable_fw=1'\" target=\"_blank\" v-show=\"path\" _v-0264db2e=\"\">\n                <i class=\"fa fa-external-link\" _v-0264db2e=\"\"></i>\n            </a>\n            <label class=\"widget-toggle st-flex st-align-item-center st-text-gray-90\" @click=\"close\" _v-0264db2e=\"\">\n                <span class=\"material-icons\" _v-0264db2e=\"\">close</span>\n            </label>\n        </div>\n    </div>\n\n    <transition v-if=\"widgetToggle\" _v-0264db2e=\"\">\n        <router-view ref=\"widgetView\" class=\"st-h-[calc(100vh-60px)]\" :query=\"urlQuery\" :widget-open=\"widgetToggle\" @open-window-path=\"fetchExternalLinkPath\" _v-0264db2e=\"\"></router-view>\n    </transition>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n.float-widget[_v-0264db2e] {\n    width: var(--float-widget-width);\n    margin:0 var(--float-widget-offset-width) 0 0;\n    background: #ffffff;\n    z-index: 1060;\n    position: fixed;\n    top: 0;\n    right: 0;\n    height: 100vh;\n    -moz-transition: all 200ms ease-in;\n    -webkit-transition: all 200ms ease-in;\n    -o-transition: all 200ms ease-in;\n    transition: all 200ms ease-in;\n    overflow-y: scroll;\n    overflow-x:hidden;\n    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);    \n}\n@media all and (max-width: 767px){\n    .float-widget[_v-0264db2e] {\n        width: 100%;\n        margin: 0 -100% 0 0;\n        height: 100vh;\n        top: 0\n    }\n}\n\n/* line 2, stdin */\n.widget-header[_v-0264db2e] {\n  display: -ms-flexbox;\n  display: flex;\n  height: 60px;\n  border-bottom: 1px solid #E7E7E7;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  -ms-flex-align: center;\n      align-items: center;\n  position: -webkit-sticky;\n  position: sticky;\n  background: #fff;\n  top: 0;\n  z-index: 10; }\n  /* line 12, stdin */\n  .widget-header .title[_v-0264db2e] {\n    font-size: 20px; }\n  /* line 15, stdin */\n  .widget-header .widget-toggle[_v-0264db2e] {\n    cursor: pointer;\n    margin-bottom: 0; }\n  /* line 19, stdin */\n  .widget-header .external-link[_v-0264db2e] {\n    margin-right: 20px; }\n    /* line 21, stdin */\n    .widget-header .external-link i[_v-0264db2e] {\n      cursor: pointer;\n      color: #000; }\n\n/* line 27, stdin */\n.isOpen[_v-0264db2e] {\n  margin: 0; }\n\n/* line 30, stdin */\n.float-widget[_v-0264db2e]::-webkit-scrollbar {\n  display: none; }\n\n@media all and (max-width: 767px) {\n  /* line 35, stdin */\n  .widget-header .external-link[_v-0264db2e] {\n    display: none; } }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-0264db2e", module.exports)
  } else {
    hotAPI.update("_v-0264db2e", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/object/keys":56,"babel-runtime/helpers/extends":66,"tippy.js":780,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1165:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _index = require('../../book/widget_class_batch/index.vue');

var _index2 = _interopRequireDefault(_index);

var _index3 = require('../../book/widget_class_batch/continue/index.vue');

var _index4 = _interopRequireDefault(_index3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = [{
    path: '/book/class/batch',
    name: 'book.class.batch',
    component: _index2.default,
    meta: {
        title: '批次預約課程',
        webFunction: 'WebadminScheduleOverviewIndex'
    }
}, {
    path: '/book/class/batch/continue',
    name: 'book.class.batch.continue',
    component: _index4.default,
    meta: {
        title: '批次預約課程 - 連續預約',
        webFunction: 'WebadminScheduleOverviewIndex'
    }
}];

},{"../../book/widget_class_batch/continue/index.vue":1016,"../../book/widget_class_batch/index.vue":1020}],1166:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _sidebarCheckstudio = require('../../checkstudio/sidebar-checkstudio.vue');

var _sidebarCheckstudio2 = _interopRequireDefault(_sidebarCheckstudio);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = [{
    path: '/checkstudio',
    name: 'checkstudio.page',
    component: _sidebarCheckstudio2.default,
    meta: {
        title: '點名出席',
        webFunction: 'CheckstudioConfirm'
    }
}];

},{"../../checkstudio/sidebar-checkstudio.vue":1036}],1167:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _error = require('../vue/error.vue');

var _error2 = _interopRequireDefault(_error);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = [{
    path: '/error',
    name: 'error.page',
    component: _error2.default,
    meta: {
        title: '發生錯誤'
    }
}];

},{"../vue/error.vue":1169}],1168:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = require('vue-router');

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _general = require('./general');

var _general2 = _interopRequireDefault(_general);

var _checkstudio = require('./checkstudio');

var _checkstudio2 = _interopRequireDefault(_checkstudio);

var _book = require('./book');

var _book2 = _interopRequireDefault(_book);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

var routes = [].concat(_general2.default).concat(_checkstudio2.default).concat(_book2.default);

var router = new _vueRouter2.default({
    mode: 'abstract',
    routes: routes
});

_vueRouter2.default.prototype.hasPermission = function (webFunction) {
    this.beforeEach(function (to, from, next) {
        try {
            if (to.matched.length !== 1) {
                next({ name: 'error.page', params: { text: '無此頁面，請重新嘗試。' } });
            };
            if (!to.meta.hasOwnProperty('webFunction') || to.meta.webFunction == '') {
                next();
            };
            if (webFunction.hasOwnProperty(to.meta.webFunction)) {
                next();
            } else {
                next({ name: 'error.page', params: { text: '權限不足，請洽系統管理員' } });
            };
        } catch (e) {
            next({ name: 'error.page', params: { text: '無此頁面，請重新嘗試。' } });
        }
    });
};

exports.default = router;

},{"./book":1165,"./checkstudio":1166,"./general":1167,"vue":792,"vue-router":789}],1169:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.fa-times[_v-732c0ae8] {\n  border: 6px solid #ff6a6a;\n  border-radius: 50px;\n  padding: 5px 13px;\n  color: #ff6a6a; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    name: 'ErrorPage',
    data: function data() {
        return {
            message: ''
        };
    },
    mounted: function mounted() {
        this.message = this.$route.params.text ? this.$route.params.text : '發生錯誤，請重新嘗試！';
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-732c0ae8=\"\">\n    <div style=\"text-align: center; padding-top: 100px;\" _v-732c0ae8=\"\">\n        <i class=\"fa fa-times fa-4x\" _v-732c0ae8=\"\"></i>\n        <div style=\"color: #6c6c6c;\" class=\"m-top-10\" _v-732c0ae8=\"\">{{message}}</div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.fa-times[_v-732c0ae8] {\n  border: 6px solid #ff6a6a;\n  border-radius: 50px;\n  padding: 5px 13px;\n  color: #ff6a6a; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-732c0ae8", module.exports)
  } else {
    hotAPI.update("_v-732c0ae8", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1170:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 3, stdin */\n.steps-container .step-title {\n  font-size: 20px;\n  color: #44444F; }\n\n/* line 7, stdin */\n.steps-container .sub-title {\n  font-size: 16px;\n  color: #545555; }\n\n/* line 11, stdin */\n.steps-container .small-text {\n  font-size: 14px;\n  font-weight: 400;\n  color: #696974; }\n\n/* line 17, stdin */\n.blue-help {\n  color: #3F6DA0;\n  font-size: 18px; }\n\n/* line 2, stdin */\n.copy-class-container[_v-7eed1aea] {\n  padding-bottom: 175px; }\n\n/* line 5, stdin */\n.row[_v-7eed1aea] {\n  margin: 0; }\n\n/* line 8, stdin */\n.title[_v-7eed1aea] {\n  font-size: 28px;\n  font-weight: 700;\n  color: #333333;\n  margin: 15px 0 40px 0; }\n\n/* line 14, stdin */\n.flex-end[_v-7eed1aea] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: end;\n      justify-content: flex-end; }\n\n/* line 19, stdin */\n.bottom-function[_v-7eed1aea] {\n  height: 80px;\n  background: #FEFEFE;\n  box-shadow: 0px -4px 12px rgba(0, 0, 0, 0.08);\n  position: fixed;\n  bottom: 0;\n  left: 171px;\n  right: 0; }\n\n/* line 28, stdin */\n.fit-window[_v-7eed1aea] {\n  left: 0; }\n\n@media (min-width: 1px) and (max-width: 767px) {\n  /* line 32, stdin */\n  .bottom-function[_v-7eed1aea] {\n    left: 0; } }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            branchName: ''
        };
    },
    created: function created() {
        this.init();
    },
    mounted: function mounted() {
        this.adjustFunctionBar();
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/stepProgressGroup', ['currentStepIndex']), (0, _vuex.mapGetters)('webadmin/stepProgressGroup', ['currentStep', 'hasCurrentStepData', 'finalStepIndex', 'getDataByIndex']), {
        isPrev: function isPrev() {
            return this.currentStepIndex > 0;
        },
        isNext: function isNext() {
            return this.currentStepIndex < this.finalStepIndex;
        }
    }),
    watch: {
        currentStepIndex: function currentStepIndex(newVal) {
            if (this.getDataByIndex(0) && this.getDataByIndex(0).hasOwnProperty('branch')) {
                this.branchName = this.getDataByIndex(0).branch.name;
            }
        }
    },
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('webadmin/stepProgressGroup', ['initSteps', 'clearAll', 'prevStep', 'nextStep']), {
        init: function init() {
            this.initSteps([{ name: '選擇場館', component: 'class-copy-set-branch', data: {} }, { name: '指定日期區間', component: 'class-copy-set-timetable', data: {} }, { name: '選擇課程', component: 'class-copy-set-program', data: {} }, { name: '選擇課表', component: 'class-copy-set-class', data: {} }, { name: '選擇複製項目', component: 'class-copy-set-others', data: {} }, { name: '預覽', component: 'class-copy-preview-confirm', data: {} }]);
        },
        cancel: function cancel() {
            var vm = this;
            $17.swal({
                title: '取消複製？',
                text: '目前設定將不會被保留',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: '確定',
                cancelButtonText: '留在本頁'
            }, function (isConfirm) {
                if (isConfirm) {
                    vm.$router.push({
                        name: vm.$route.name,
                        query: (0, _extends3.default)({}, vm.$route.query, {
                            sub_page: 'calendar',
                            tab_hidden: false
                        })
                    });
                    window.location.reload(true);
                }
            });
        },
        proceedPrev: function proceedPrev() {
            var _this = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.prevStep();

                            case 1:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        proceedNext: function proceedNext() {
            var _this2 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                var beforeNext;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return _this2.$refs.processComponent.beforeNextCheck();

                            case 2:
                                beforeNext = _context2.sent;

                                if (beforeNext.success) {
                                    _this2.nextStep(beforeNext.data);
                                } else {
                                    $17.swal({
                                        title: beforeNext.message.title,
                                        text: beforeNext.message.text,
                                        type: 'error',
                                        showCancelButton: false
                                    });
                                }

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        submit: function submit() {
            this.$refs.processComponent.finalSubmit();
        },
        adjustFunctionBar: function adjustFunctionBar() {
            var _this3 = this;

            var resizeObserver = new ResizeObserver(function () {
                if ($('.side-nav').hasClass("hide-side-nav-pc")) {
                    $(_this3.$el).find('.bottom-function').addClass('fit-window');
                } else {
                    $(_this3.$el).find('.bottom-function').removeClass('fit-window');
                }
            });
            resizeObserver.observe(this.$el);
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"copy-class-container\" _v-7eed1aea=\"\">\n    <div class=\"row\" _v-7eed1aea=\"\">\n        <div class=\"col-xs-12\" _v-7eed1aea=\"\">\n            <div class=\"title\" _v-7eed1aea=\"\">\n                複製課表\n                <span v-show=\"branchName &amp;&amp; currentStepIndex > 0\" _v-7eed1aea=\"\"> - {{branchName}}</span>\n                <span _v-7eed1aea=\"\">\n                    <a class=\"blue-help\" href=\"https://17fithelp.zendesk.com/hc/zh-tw/articles/7586288870681\" target=\"_blank\" _v-7eed1aea=\"\">\n                        <i class=\"fa fa-question-circle\" _v-7eed1aea=\"\"></i>\n                    </a>\n                </span>\n            </div>\n        </div>\n        <div class=\"col-xs-3\" _v-7eed1aea=\"\">\n            <step-progress-group _v-7eed1aea=\"\"></step-progress-group>\n        </div>\n        <div class=\"col-xs-9 steps-container\" _v-7eed1aea=\"\">\n            <component ref=\"processComponent\" v-if=\"currentStep.component\" :is=\"currentStep.component\" _v-7eed1aea=\"\"></component>\n        </div>\n    </div>\n    <div class=\"bottom-function flex-end\" _v-7eed1aea=\"\">\n        <a class=\"btn btn-default m-right-10\" @click=\"cancel\" _v-7eed1aea=\"\">取消</a>\n        <a class=\"btn btn--inverse btn-primary m-right-10\" @click=\"proceedPrev\" v-if=\"isPrev\" _v-7eed1aea=\"\">上一步</a>\n        <a class=\"btn btn-primary m-right-30\" @click=\"proceedNext\" v-if=\"isNext\" _v-7eed1aea=\"\">下一步</a>\n        <a class=\"btn btn-primary m-right-30\" @click=\"submit\" v-else=\"\" _v-7eed1aea=\"\">開始複製</a>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 3, stdin */\n.steps-container .step-title {\n  font-size: 20px;\n  color: #44444F; }\n\n/* line 7, stdin */\n.steps-container .sub-title {\n  font-size: 16px;\n  color: #545555; }\n\n/* line 11, stdin */\n.steps-container .small-text {\n  font-size: 14px;\n  font-weight: 400;\n  color: #696974; }\n\n/* line 17, stdin */\n.blue-help {\n  color: #3F6DA0;\n  font-size: 18px; }\n\n/* line 2, stdin */\n.copy-class-container[_v-7eed1aea] {\n  padding-bottom: 175px; }\n\n/* line 5, stdin */\n.row[_v-7eed1aea] {\n  margin: 0; }\n\n/* line 8, stdin */\n.title[_v-7eed1aea] {\n  font-size: 28px;\n  font-weight: 700;\n  color: #333333;\n  margin: 15px 0 40px 0; }\n\n/* line 14, stdin */\n.flex-end[_v-7eed1aea] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: end;\n      justify-content: flex-end; }\n\n/* line 19, stdin */\n.bottom-function[_v-7eed1aea] {\n  height: 80px;\n  background: #FEFEFE;\n  box-shadow: 0px -4px 12px rgba(0, 0, 0, 0.08);\n  position: fixed;\n  bottom: 0;\n  left: 171px;\n  right: 0; }\n\n/* line 28, stdin */\n.fit-window[_v-7eed1aea] {\n  left: 0; }\n\n@media (min-width: 1px) and (max-width: 767px) {\n  /* line 32, stdin */\n  .bottom-function[_v-7eed1aea] {\n    left: 0; } }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-7eed1aea", module.exports)
  } else {
    hotAPI.update("_v-7eed1aea", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1171:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.sub-title[_v-28bd1b53] {\n  font-size: 14px; }\n\n/* line 5, stdin */\nol[_v-28bd1b53] {\n  margin-left: -1.5em; }\n\n/* line 8, stdin */\n.row[_v-28bd1b53] {\n  border-bottom: 1px solid #D5D5DC;\n  margin: 0;\n  font-size: 16px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            ajaxing: false,
            branchId: 0,
            daysOfWeek: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'],
            tableConfig: {
                columns: [{
                    keys: 'date',
                    head: '日期'
                }, {
                    keys: 'week_day',
                    head: '週間',
                    html: function html(item) {
                        var weekDay = moment(item.date).day();
                        var chineseDay = $17.getChineseWeekday(weekDay);
                        return '<div>\u661F\u671F' + chineseDay + '</div>';
                    }
                }, {
                    keys: 'time',
                    head: '時間'
                }, {
                    keys: 'name',
                    head: '課表名稱'
                }]

            },
            schedules: {
                records: [],
                pageMeta: {}
            },
            timetable: {},
            others: []
        };
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('webadmin/stepProgressGroup', ['stepsData']), {
        scheduleCount: function scheduleCount() {
            return this.schedules.records.length || 0;
        },
        copyToWeekCount: function copyToWeekCount() {
            return this.timetable.to ? this.timetable.to.length : 0;
        },
        totalCopyCount: function totalCopyCount() {
            return this.scheduleCount * this.copyToWeekCount;
        }
    }),
    mounted: function mounted() {
        this.init();
    },

    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('webadmin/stepProgressGroup', ['clearAll']), {
        init: function init() {
            var scheduleList = [];
            this.branchId = this.stepsData[0].branch.id;
            this.timetable = this.stepsData[1];
            this.others = this.stepsData[4].checkList;
            this.stepsData[3].schedules.records.forEach(function (item) {
                if (item.check) {
                    scheduleList.push(item);
                }
            });
            this.schedules.records = scheduleList;
        },
        finalSubmit: function finalSubmit() {
            var _this = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                var postData;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!_this.ajaxing) {
                                    _context.next = 2;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 2:
                                _this.ajaxing = true;
                                $.blockUI();
                                _context.next = 6;
                                return _this.generatePostData();

                            case 6:
                                postData = _context.sent;

                                _this.$http.post('/adminapi/schedule/clone-duration', postData).then(function (response) {
                                    if (response.data.success) {
                                        $17.swal({
                                            title: '課表已開始複製！',
                                            text: response.data.msg,
                                            type: 'success',
                                            showCancelButton: false
                                        }, function (confirm) {
                                            if (confirm) {
                                                _this.clearAll();
                                                _this.$router.push({
                                                    name: _this.$route.name,
                                                    query: (0, _extends3.default)({}, _this.$route.query, {
                                                        sub_page: 'calendar',
                                                        tab_hidden: false
                                                    })
                                                });
                                                window.location.reload(true);
                                            }
                                        });
                                    } else {
                                        $17.swal({
                                            title: '請稍候再試！',
                                            text: response.data.msg,
                                            type: 'error',
                                            showCancelButton: false
                                        });
                                    }
                                    _this.ajaxing = false;
                                    $.unblockUI();
                                }, function (error) {
                                    _this.ajaxing = false;
                                    $.unblockUI();
                                    $17.swal({
                                        title: '請稍候再試！',
                                        text: error.body.message,
                                        type: 'error',
                                        showCancelButton: false
                                    });
                                });

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        generatePostData: function generatePostData() {
            var data = {};
            data['branch_id'] = this.branchId;
            data['source_range'] = {
                type: 'class-schedule-ids',
                ids: []
            };
            data['target_ranges'] = [];

            this.others.forEach(function (item) {
                data[item.param] = item.value;
            });
            this.schedules.records.forEach(function (item) {
                data['source_range']['ids'].push(item.id);
            });
            this.timetable.to.forEach(function (item) {
                data['target_ranges'].push({
                    type: 'date-map-weekday',
                    from: item[0],
                    to: item[1]
                });
            });
            return data;
        },
        getChineseWeekday: function getChineseWeekday(weekday) {
            var week = $17.getChineseWeekday(Number(weekday + 1));
            return '星期' + week;
        },
        timeDisplay: function timeDisplay(timeArr) {
            if (timeArr) {
                return timeArr[0] + " ~ " + timeArr[1];
            }
            return '';
        },
        showDaysOfWeek: function showDaysOfWeek(days) {
            if (this.timetable.daysOfWeek) {
                return this.timetable.daysOfWeek[days];
            }
            return 0;
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-28bd1b53=\"\">\n    <div _v-28bd1b53=\"\">\n        <div class=\"step-title\" _v-28bd1b53=\"\">預覽</div>\n    </div>\n    <div class=\"row p-bottom-20\" _v-28bd1b53=\"\">\n        <div class=\"col-xs-6\" _v-28bd1b53=\"\">\n            <div class=\"sub-title m-bottom-15 m-top-25\" _v-28bd1b53=\"\">將課表從</div>\n            <div _v-28bd1b53=\"\">\n                {{ timeDisplay(timetable.from) }}\n            </div>\n            <template v-for=\"(value, index) in daysOfWeek\">\n                <div v-if=\"showDaysOfWeek(value)\" _v-28bd1b53=\"\">\n                    {{ getChineseWeekday(index) }}\n                </div>\n            </template>\n        </div>\n        <div class=\"col-xs-6\" _v-28bd1b53=\"\">\n            <div class=\"sub-title m-bottom-15 m-top-25\" _v-28bd1b53=\"\">複製到以下日期</div>\n            <ol _v-28bd1b53=\"\">\n                <li v-for=\"time in timetable.to\" _v-28bd1b53=\"\">\n                    {{ timeDisplay(time) }}\n                </li>\n            </ol>\n        </div>\n    </div>\n    <div class=\"row p-bottom-10\" _v-28bd1b53=\"\">\n        <div class=\"col-xs-12\" _v-28bd1b53=\"\">\n            <div class=\"sub-title m-bottom-15 m-top-25\" _v-28bd1b53=\"\">要被複製的項目</div>\n            <ol _v-28bd1b53=\"\">\n                <template v-for=\"item in others\">\n                    <li v-if=\"item.value\" _v-28bd1b53=\"\">\n                        {{ item.name }}\n                    </li>\n                </template>\n            </ol>\n        </div>\n    </div>\n    <div class=\"m-top-20\" _v-28bd1b53=\"\">\n        <div class=\"sub-title m-bottom-5\" _v-28bd1b53=\"\">要複製的課表</div>\n        <div class=\"small-text m-bottom-10\" _v-28bd1b53=\"\">\n            <span _v-28bd1b53=\"\">已選 {{scheduleCount}}，複製到{{copyToWeekCount}}週</span>\n            <span class=\"m-left-10\" _v-28bd1b53=\"\">總計複製課表數量：{{totalCopyCount}}</span>\n        </div>\n        <v-smart-table :table-config=\"tableConfig\" :data=\"schedules\" :page-sync-url-query=\"false\" _v-28bd1b53=\"\"></v-smart-table>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.sub-title[_v-28bd1b53] {\n  font-size: 14px; }\n\n/* line 5, stdin */\nol[_v-28bd1b53] {\n  margin-left: -1.5em; }\n\n/* line 8, stdin */\n.row[_v-28bd1b53] {\n  border-bottom: 1px solid #D5D5DC;\n  margin: 0;\n  font-size: 16px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-28bd1b53", module.exports)
  } else {
    hotAPI.update("_v-28bd1b53", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1172:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.select-content[_v-fbb9e5f6] {\n  width: 100%;\n  max-width: 400px;\n  min-width: 150px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            selectedBranch: {
                id: '',
                name: ''
            },
            options: [],
            ajaxing: false
        };
    },
    created: function created() {
        if (this.hasCurrentStepData) {
            this.selectedBranch = (0, _assign2.default)({}, this.currentStep.data.branch);
        } else {
            this.updateCurrentData({ branch: this.selectedBranch });
        }
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('webadmin/stepProgressGroup', ['currentStep', 'hasCurrentStepData']), (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId', 'isBranch', 'isStudio', 'isSeventeen']), (0, _vuex.mapState)('filters', ['selected_studio_id', 'selected_branch_id'])),
    mounted: function mounted() {
        if (this.isStudio) {
            if (!this.selectedBranch.id) {
                this.getQueryBranchId();
            }
        }
        if (this.isBranch) {
            this.getBranchData();
        }
    },

    watch: {
        isBranch: function isBranch(newVal) {
            if (newVal) {
                this.getBranchData();
            }
        },
        isStudio: function isStudio(newVal) {
            if (newVal) {
                this.getQueryBranchId();
            }
        }
    },
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('webadmin/stepProgressGroup', ['updateCurrentData']), {
        getQueryBranchId: function getQueryBranchId() {
            var params = this.$route.query;
            if (params.branch_id) {
                this.selectedBranch.id = params.branch_id;
            }
        },
        branchChange: function branchChange(id, name) {
            this.selectedBranch = {
                id: id,
                name: name
            };
        },
        getBranchData: function getBranchData() {
            var _this = this;

            this.ajaxing = true;
            this.$http.get('/adminapi/init/get_branch/' + this.branchId).then(function (response) {
                _this.ajaxing = false;
                var branch = {
                    id: _this.branchId,
                    name: response.data.name
                };
                _this.selectedBranch = branch;
                _this.options = [branch];
            });
        },
        cancel: function cancel() {
            this.$router.push({
                name: this.$route.name,
                query: (0, _extends3.default)({}, this.$route.query, {
                    sub_page: 'calendar',
                    tab_hidden: false
                })
            });
            window.location.reload(true);
        },
        beforeNextCheck: function beforeNextCheck() {
            var errorTitle = '';
            if (!this.selectedBranch.id || !this.selected_studio_id) {
                errorTitle = '請先選擇場館';
            }
            return {
                success: !errorTitle,
                message: {
                    title: errorTitle,
                    text: ''
                },
                data: {
                    branch: this.selectedBranch,
                    studioId: this.selected_studio_id
                }
            };
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-fbb9e5f6=\"\">\n    <v-multiselect-studio-and-branch :studio_id=\"studioId\" :branch_id=\"branchId\" :default_branch_id=\"selectedBranch.id\" :branch-change-call-back=\"branchChange\" _v-fbb9e5f6=\"\"></v-multiselect-studio-and-branch>\n    <div class=\"select-content\" v-if=\"isBranch\" _v-fbb9e5f6=\"\">\n        <v-mutiselect :model.sync=\"selectedBranch\" :options=\"options\" :is-loading=\"ajaxing\" placeholder=\"請選擇場館\" :disabled=\"true\" label=\"name\" track-by=\"id\" _v-fbb9e5f6=\"\"></v-mutiselect>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.select-content[_v-fbb9e5f6] {\n  width: 100%;\n  max-width: 400px;\n  min-width: 150px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-fbb9e5f6", module.exports)
  } else {
    hotAPI.update("_v-fbb9e5f6", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/object/assign":50,"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1173:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.isRed[_v-4b46a4e5] {\n  color: #fc5a5a; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _vuex = require('vuex');

var _tippy = require('tippy.js');

var _tippy2 = _interopRequireDefault(_tippy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        var vm = this;
        return {
            studioId: 0,
            branchId: 0,
            dates: [],
            timeRange: ['2022-03-20', '2020-03-26'],
            copyWeekCount: 0,
            postData: {
                selectAll: 1,
                maxCount: 200,
                selectCount: 0,
                schedules: {
                    records: [],
                    pageMeta: {}
                }
            },
            tableConfig: {
                columns: [{
                    keys: 'check',
                    head: '',
                    component: {
                        name: 'v-smart-check',
                        vBind: function vBind(item) {
                            return {
                                'check': item.check,
                                'change': function change(event) {
                                    item.check = !item.check ? 1 : 0;
                                    vm.checkChange(item);
                                }
                            };
                        }
                    }
                }, {
                    keys: 'date',
                    head: '開課日期'
                }, {
                    keys: 'week_day',
                    head: '週間',
                    html: function html(item) {
                        var weekDay = moment(item.date).day();
                        var chineseDay = $17.getChineseWeekday(weekDay);
                        return '<div>\u661F\u671F' + chineseDay + '</div>';
                    }
                }, {
                    keys: 'time',
                    head: '時間'
                }, {
                    keys: 'name',
                    head: '課表名稱'
                }]

            },
            ajaxing: false
        };
    },
    created: function created() {
        if (this.hasCurrentStepData) {
            this.postData = (0, _assign2.default)({}, this.currentStep.data);
        } else {
            this.updateCurrentData(this.postData);
        }
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('webadmin/stepProgressGroup', ['stepsData', 'currentStep', 'hasCurrentStepData']), {
        totalCopyCount: function totalCopyCount() {
            return this.postData.selectCount * this.copyWeekCount;
        }
    }),
    mounted: function mounted() {
        this.init();
    },

    watch: {
        postData: {
            handler: function handler(newVal) {
                this.updateCurrentData(newVal);
            },
            deep: true
        }
    },
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('webadmin/stepProgressGroup', ['updateCurrentData']), {
        init: function init() {
            this.copyWeekCount = this.stepsData[1].to.length;
            this.dates = this.stepsData[1].selectedDate;
            this.timeRange = this.stepsData[1].from;
            this.studioId = this.stepsData[0].studioId;
            this.branchId = this.stepsData[0].branch.id;
            if (this.hasCurrentStepData) {
                this.mountTippy();
            } else {
                this.fetchData();
            }
        },
        fetchData: function fetchData() {
            var _this = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                var service_ids;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.ajaxing = true;
                                _context.next = 3;
                                return _this.getServiceIds();

                            case 3:
                                service_ids = _context.sent;

                                _this.$http.get('/adminapi/schedule/list-by-service', {
                                    params: {
                                        studio_id: _this.studioId,
                                        branch_id: _this.branchId,
                                        service_ids: service_ids,
                                        dates: _this.dates
                                    }
                                }).then(function (response) {
                                    _this.postData.schedules.records = response.data.records;
                                    _this.postData.maxCount = response.data.max_class_schedule_batch_copy;
                                    _this.initData();
                                    _this.mountTippy();
                                    _this.ajaxing = false;
                                }, function (error) {
                                    _this.ajaxing = false;
                                });

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        getServiceIds: function getServiceIds() {
            var arr = [];
            this.stepsData[2].programs.records.forEach(function (item) {
                if (item.check) {
                    arr.push(item.id);
                }
            });
            return arr;
        },
        initData: function initData() {
            this.postData.schedules.records = this.postData.schedules.records.map(function (item) {
                return (0, _extends3.default)({
                    check: 0
                }, item);
            });
            this.checkAll();
        },
        mountTippy: function mountTippy() {
            var tooltip = (0, _tippy2.default)('.max-count-tooltip', {
                content: '\u55AE\u6B21\u80FD\u5920\u8907\u88FD\u7684\u8AB2\u8868\u6578\u91CF\u4E0A\u9650\u70BA ' + this.postData.maxCount + '\u3002'
            });
        },
        checkChange: function checkChange(event) {
            this.postData.selectAll = 0;
            if (event.check) {
                this.postData.selectCount += 1;
            } else {
                this.postData.selectCount -= 1;
            }
        },
        checkAll: function checkAll() {
            var _this2 = this;

            this.postData.schedules.records.forEach(function (item) {
                item.check = _this2.postData.selectAll;
            });
            this.postData.selectCount = this.postData.selectAll ? (0, _keys2.default)(this.postData.schedules.records).length : 0;
        },
        beforeNextCheck: function beforeNextCheck() {
            var errorMessage = '';
            var errorTitle = '';
            if (this.totalCopyCount > this.maxCount) {
                errorTitle = '課表數量過多';
                errorMessage = '\u8AB2\u8868\u6578\u91CF\u9700\u5C11\u65BC ' + this.maxCount + '\uFF0C\u8ACB\u8ABF\u6574\u8AB2\u8868\u6578\u91CF\u5F8C\u7E7C\u7E8C';
            }
            if (this.totalCopyCount == 0) {
                errorTitle = '課表數量不可為零';
                errorMessage = '請調整課表數量後繼續';
            }
            return {
                success: errorMessage ? false : true,
                message: {
                    title: errorTitle,
                    text: errorMessage
                },
                data: this.postData
            };
        }
    })

};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-4b46a4e5=\"\">\n    <div _v-4b46a4e5=\"\">\n        <div class=\"step-title\" _v-4b46a4e5=\"\">選擇課表</div>\n        <div class=\"sub-title\" _v-4b46a4e5=\"\">以下是 {{ timeRange[0] }} ~ {{ timeRange[1] }} 的課表，哪些要複製？</div>\n        <div class=\"small-text m-top-20\" v-show=\"!ajaxing\" _v-4b46a4e5=\"\">\n            <span _v-4b46a4e5=\"\">目前已選 {{postData.selectCount}} 個課表，複製到 {{copyWeekCount}} 週</span>\n            <span class=\"m-left-15\" _v-4b46a4e5=\"\">預計複製課表數量：\n                <span :class=\"{isRed: totalCopyCount > Number(postData.maxCount)}\" _v-4b46a4e5=\"\">{{totalCopyCount}}</span> / {{postData.maxCount}}\n                <a class=\"blue-help m-left-5 max-count-tooltip\" _v-4b46a4e5=\"\"><i class=\"fa fa-question-circle\" _v-4b46a4e5=\"\"></i></a>\n            </span>\n        </div>\n    </div>\n    <div class=\"m-top-20\" v-show=\"!ajaxing\" _v-4b46a4e5=\"\">\n        <div v-if=\"postData.schedules.records.length\" _v-4b46a4e5=\"\">\n            <input type=\"checkbox\" v-model=\"postData.selectAll\" name=\"select-all\" id=\"select-all\" :true-value=\"1\" :false-value=\"0\" @change=\"checkAll\" _v-4b46a4e5=\"\">\n            <label for=\"select-all\" style=\"color: #3273F6;\" _v-4b46a4e5=\"\">全部複製</label>\n        </div>\n        <div _v-4b46a4e5=\"\">\n            <v-smart-table :table-config=\"tableConfig\" :data=\"postData.schedules\" :page-sync-url-query=\"false\" _v-4b46a4e5=\"\"></v-smart-table>\n        </div>\n    </div>\n    <v-spinner :ajaxing=\"ajaxing\" _v-4b46a4e5=\"\"></v-spinner>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.isRed[_v-4b46a4e5] {\n  color: #fc5a5a; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-4b46a4e5", module.exports)
  } else {
    hotAPI.update("_v-4b46a4e5", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/object/assign":50,"babel-runtime/core-js/object/keys":56,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"tippy.js":780,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1174:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.check-list[_v-27aa8246] {\n  padding-top: 6px;\n  border-bottom: 1px solid #D5D5Dc; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            checkList: [{
                name: '人員及薪資條件',
                param: 'copy_staff',
                value: 1
            }, {
                name: '直播連結及額外說明',
                param: 'copy_live_streaming',
                value: 1
            }, {
                name: '外部連結',
                param: 'copy_external_link',
                value: 1
            }]
        };
    },
    created: function created() {
        if (this.hasCurrentStepData) {
            this.checkList = (0, _assign2.default)([], this.currentStep.data.checkList);
        } else {
            this.updateCurrentData({ checkList: this.checkList });
        }
    },

    watch: {
        checkList: {
            handler: function handler(newVal) {
                this.updateCurrentData({ checkList: newVal });
            },
            deep: true
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('webadmin/stepProgressGroup', ['currentStep', 'hasCurrentStepData'])),
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('webadmin/stepProgressGroup', ['updateCurrentData']), {
        beforeNextCheck: function beforeNextCheck() {
            var errorMessage = '';
            var errorTitle = '';
            return {
                success: errorMessage ? false : true,
                message: {
                    title: errorTitle,
                    text: errorMessage
                },
                data: { checkList: this.checkList }
            };
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-27aa8246=\"\">\n    <div _v-27aa8246=\"\">\n        <div class=\"step-title\" _v-27aa8246=\"\">選擇複製項目</div>\n        <div class=\"sub-title\" _v-27aa8246=\"\">哪些項目要被複製？</div> \n    </div>\n    <div class=\"m-top-15\" _v-27aa8246=\"\">\n        <div v-for=\"(item, index) in checkList\" :key=\"index\" class=\"check-list\" _v-27aa8246=\"\">\n            <input type=\"checkbox\" v-model=\"item.value\" :name=\"item.param\" :id=\"item.param\" :true-value=\"1\" :false-value=\"0\" _v-27aa8246=\"\">\n            <label :for=\"item.param\" _v-27aa8246=\"\">\n                {{ item.name }}\n            </label> \n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.check-list[_v-27aa8246] {\n  padding-top: 6px;\n  border-bottom: 1px solid #D5D5Dc; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-27aa8246", module.exports)
  } else {
    hotAPI.update("_v-27aa8246", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/object/assign":50,"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1175:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.isOrange[_v-3c38d2b1] {\n  color: #ff974a; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _vuex = require('vuex');

var _tippy = require('tippy.js');

var _tippy2 = _interopRequireDefault(_tippy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        var vm = this;
        return {
            studioId: 0,
            branchId: 0,
            dates: [],
            timeRange: ['2022-03-20', '2020-03-26'],
            copyWeekCount: 0,
            postData: {
                selectAll: 1,
                maxCount: 200,
                selectCount: {
                    service: 0,
                    schedule: 0
                },
                programs: {
                    records: [],
                    pageMeta: {}
                }
            },
            tableConfig: {
                columns: [{
                    keys: 'check',
                    head: '',
                    component: {
                        name: 'v-smart-check',
                        vBind: function vBind(item) {
                            return {
                                'check': item.check,
                                'change': function change(event) {
                                    item.check = !item.check ? 1 : 0;
                                    vm.checkChange(item);
                                }
                            };
                        }
                    }
                }, {
                    keys: 'name',
                    head: '課程名稱'
                }, {
                    keys: 'qty',
                    head: '課表數量'
                }]
            },
            ajaxing: false
        };
    },
    created: function created() {
        if (this.hasCurrentStepData) {
            this.postData = (0, _assign2.default)({}, this.currentStep.data);
        } else {
            this.updateCurrentData(this.postData);
        }
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('webadmin/stepProgressGroup', ['stepsData', 'currentStep', 'hasCurrentStepData']), {
        totalCopyCount: function totalCopyCount() {
            return this.postData.selectCount.schedule * this.copyWeekCount;
        }
    }),
    mounted: function mounted() {
        this.init();
    },

    watch: {
        postData: {
            handler: function handler(newVal) {
                this.updateCurrentData(newVal);
            },
            deep: true
        }
    },
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('webadmin/stepProgressGroup', ['updateCurrentData']), {
        init: function init() {
            this.copyWeekCount = this.stepsData[1].to.length;
            this.dates = this.stepsData[1].selectedDate;
            this.timeRange = this.stepsData[1].from;
            this.studioId = this.stepsData[0].studioId;
            this.branchId = this.stepsData[0].branch.id;
            if (this.hasCurrentStepData) {
                this.mountTippy();
            } else {
                this.fetchData();
            }
        },
        fetchData: function fetchData() {
            var _this = this;

            var vm = this;
            this.ajaxing = true;
            this.$http.get('/adminapi/schedule/service-group', {
                params: {
                    studio_id: this.studioId,
                    branch_id: this.branchId,
                    dates: this.dates
                }
            }).then(function (response) {
                _this.postData.programs.records = response.data.records;
                _this.postData.maxCount = response.data.max_class_schedule_batch_copy;
                _this.initData();
                _this.mountTippy();
                _this.ajaxing = false;
            }, function (error) {
                _this.ajaxing = false;
            });
        },
        initData: function initData() {
            this.postData.programs.records = this.postData.programs.records.map(function (item) {
                return (0, _extends3.default)({
                    check: 0
                }, item);
            });
            this.checkAll();
        },
        mountTippy: function mountTippy() {
            var tooltip = (0, _tippy2.default)('.max-count-tooltip', {
                content: '\u55AE\u6B21\u80FD\u5920\u8907\u88FD\u7684\u8AB2\u8868\u6578\u91CF\u4E0A\u9650\u70BA ' + this.postData.maxCount + '\u3002'
            });
        },
        checkChange: function checkChange(event) {
            this.postData.selectAll = 0;
            if (event.check) {
                this.postData.selectCount.service += 1;
                this.postData.selectCount.schedule += event.qty;
            } else {
                this.postData.selectCount.service -= 1;
                this.postData.selectCount.schedule -= event.qty;
            }
        },
        checkAll: function checkAll() {
            var _this2 = this;

            var qtyCount = 0;

            this.postData.programs.records.forEach(function (item) {
                item.check = _this2.postData.selectAll;
                qtyCount += item.qty;
            });
            this.postData.selectCount = {
                service: this.postData.selectAll ? (0, _keys2.default)(this.postData.programs.records).length : 0,
                schedule: this.postData.selectAll ? qtyCount : 0
            };
        },
        beforeNextCheck: function beforeNextCheck() {
            var errorMessage = '';
            var errorTitle = '';
            if (this.totalCopyCount == 0) {
                errorTitle = '課表數量不可為零';
                errorMessage = '請調整課程數量後繼續';
            }
            return {
                success: errorMessage ? false : true,
                message: {
                    title: errorTitle,
                    text: errorMessage
                },
                data: this.postData
            };
        }
    })

};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-3c38d2b1=\"\">\n    <div _v-3c38d2b1=\"\">\n        <div class=\"step-title\" _v-3c38d2b1=\"\">選擇課程</div>\n        <div class=\"sub-title\" _v-3c38d2b1=\"\">以下是 {{ timeRange[0] }} ~ {{ timeRange[1] }} 有開課的課程，哪些要複製？</div>\n        <div class=\"small-text m-top-20\" v-show=\"!ajaxing\" _v-3c38d2b1=\"\">\n            <span _v-3c38d2b1=\"\">目前已選 {{postData.selectCount.service}} 個課程，複製到 {{copyWeekCount}} 週</span>\n            <span class=\"m-left-15\" _v-3c38d2b1=\"\">預計複製課表數量：\n                <span :class=\"{isOrange: totalCopyCount > Number(postData.maxCount)}\" _v-3c38d2b1=\"\">{{totalCopyCount}}</span> / {{postData.maxCount}}\n                <a class=\"blue-help m-left-5 max-count-tooltip\" _v-3c38d2b1=\"\"><i class=\"fa fa-question-circle\" _v-3c38d2b1=\"\"></i></a>\n            </span>\n        </div>\n    </div>\n    <div class=\"m-top-20\" v-show=\"!ajaxing\" _v-3c38d2b1=\"\">\n        <div v-if=\"postData.programs.records.length\" _v-3c38d2b1=\"\">\n            <input type=\"checkbox\" v-model=\"postData.selectAll\" name=\"select-all\" id=\"select-all\" :true-value=\"1\" :false-value=\"0\" @change=\"checkAll\" _v-3c38d2b1=\"\">\n            <label for=\"select-all\" style=\"color: #3273F6;\" _v-3c38d2b1=\"\">全部複製</label>\n        </div>\n        <div _v-3c38d2b1=\"\">\n            <v-smart-table :table-config=\"tableConfig\" :data=\"postData.programs\" :page-sync-url-query=\"false\" _v-3c38d2b1=\"\"></v-smart-table>\n        </div>\n    </div>\n    <v-spinner :ajaxing=\"ajaxing\" _v-3c38d2b1=\"\"></v-spinner>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.isOrange[_v-3c38d2b1] {\n  color: #ff974a; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-3c38d2b1", module.exports)
  } else {
    hotAPI.update("_v-3c38d2b1", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/object/assign":50,"babel-runtime/core-js/object/keys":56,"babel-runtime/helpers/extends":66,"tippy.js":780,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1176:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.from-to-text[_v-81bda4e4] {\n  font-size: 18px;\n  color: #333333; }\n\n/* line 6, stdin */\n.check-select[_v-81bda4e4] {\n  display: -ms-flexbox;\n  display: flex; }\n  /* line 8, stdin */\n  .check-select .week-check[_v-81bda4e4] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n        flex-direction: column;\n    -ms-flex-align: center;\n        align-items: center; }\n  /* line 13, stdin */\n  .check-select input[_v-81bda4e4] {\n    width: 17px;\n    height: 17px; }\n\n/* line 18, stdin */\n.date-range-content[_v-81bda4e4] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  margin-bottom: 15px; }\n  /* line 22, stdin */\n  .date-range-content .remove-btn[_v-81bda4e4] {\n    height: 34px;\n    background: #CCCCCB;\n    border-radius: 0px 4px 4px 0px;\n    cursor: pointer; }\n    /* line 27, stdin */\n    .date-range-content .remove-btn i[_v-81bda4e4] {\n      padding: 10px;\n      color: #fff; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _vuex = require('vuex');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            daysOfWeek: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'],
            postData: {
                from: [],
                to: [[]],
                daysOfWeek: {
                    monday: 1,
                    tuesday: 1,
                    wednesday: 1,
                    thursday: 1,
                    friday: 1,
                    saturday: 1,
                    sunday: 1
                }
            }
        };
    },
    created: function created() {
        if (this.hasCurrentStepData) {
            this.postData = (0, _assign2.default)({}, this.currentStep.data);
        } else {
            this.updateCurrentData(this.postData);
        }
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('webadmin/stepProgressGroup', ['currentStep', 'hasCurrentStepData'])),
    mounted: function mounted() {},

    watch: {
        postData: {
            handler: function handler(newVal) {
                this.updateCurrentData(newVal);
            },
            deep: true
        }
    },
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('webadmin/stepProgressGroup', ['updateCurrentData']), {
        formatTime: function formatTime(date) {
            return (0, _moment2.default)(date).format('YYYY-MM-DD');
        },
        getChineseWeekday: function getChineseWeekday(weekday) {
            var week = $17.getChineseWeekday(Number(weekday + 1));
            return '星期' + week;
        },
        disabledPastWeek: function disabledPastWeek(date) {
            var endOfThisWeek = this.formatTime((0, _moment2.default)().isoWeekday(7).toDate());
            return (0, _moment2.default)(date).isSameOrBefore(endOfThisWeek);
        },
        fromCallBack: function fromCallBack(event) {
            this.postData.from = event.dates;
        },
        toCallBack: function toCallBack(event) {
            this.postData.to[event.datepicker_id] = event.dates;
        },
        addRange: function addRange() {
            if (this.postData.to.length >= 10) {
                $17.swal({
                    type: 'warning',
                    title: '目標週數過多',
                    text: '一次最多能將課表複製到 10 週，請調整課表數量後繼續。',
                    showCancelButton: false
                });
                return;
            }
            this.postData.to.push([]);
        },
        daysOfWeekTransformToDates: function daysOfWeekTransformToDates() {
            if (_lodash2.default.isEmpty(this.postData.from)) return null;
            var list = this.postData.daysOfWeek;
            var firstDayOfWeek = this.postData.from[0];
            var result = [];
            for (var key in list) {
                if (list[key]) {
                    var index = this.daysOfWeek.indexOf(key) + 1;
                    var date = (0, _moment2.default)(firstDayOfWeek).day(index).toDate();
                    result.push(this.formatTime(date));
                }
            }
            return result;
        },
        removeRange: function removeRange(index) {
            if (this.postData.to.length > 1) {
                this.postData.to.splice(index, 1);
            }
        },
        beforeNextCheck: function beforeNextCheck() {
            var _this = this;

            var errorMessage = '';
            var toErrorCount = 0;
            var weekSelectCount = 0;
            this.postData.to.forEach(function (item) {
                if (_lodash2.default.isEmpty(item)) {
                    toErrorCount += 1;
                }
            });
            this.daysOfWeek.forEach(function (item) {
                if (_this.postData.daysOfWeek[item]) {
                    weekSelectCount += 1;
                }
            });
            if (_lodash2.default.isEmpty(this.postData.from)) {
                errorMessage = '請選擇日期區間';
            }
            if (toErrorCount > 0) {
                errorMessage = '請選擇日期區間';
            }
            if (weekSelectCount == 0) {
                errorMessage = '請選擇日期區間';
            }
            this.postData['selectedDate'] = this.daysOfWeekTransformToDates();
            return {
                success: errorMessage ? false : true,
                message: {
                    title: errorMessage,
                    text: ''
                },
                data: this.postData
            };
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-81bda4e4=\"\">\n    <div _v-81bda4e4=\"\">\n        <div class=\"step-title\" _v-81bda4e4=\"\">指定日期區間</div>\n        <div class=\"sub-title\" _v-81bda4e4=\"\">要將課表從哪一週複製到哪一週呢？</div>    \n    </div>\n    <div class=\"m-top-20\" _v-81bda4e4=\"\">\n        <div class=\"from-to-text\" _v-81bda4e4=\"\">從</div>\n        <div _v-81bda4e4=\"\">\n            <v-week-date-picker :clearable=\"false\" :selected=\"fromCallBack\" :date-range=\"postData.from\" _v-81bda4e4=\"\"></v-week-date-picker>\n        </div>\n        <div class=\"m-top-20\" _v-81bda4e4=\"\">\n            <div class=\"check-select\" _v-81bda4e4=\"\">\n                <div v-for=\"(value, index) in daysOfWeek\" :key=\"value\" class=\"week-check\" _v-81bda4e4=\"\">\n                    <input type=\"checkbox\" v-model=\"postData.daysOfWeek[value]\" :name=\"value\" :id=\"value\" :true-value=\"1\" :false-value=\"0\" _v-81bda4e4=\"\">\n                    <label :for=\"value\" class=\"m-right-5 m-top-10\" _v-81bda4e4=\"\">\n                        {{getChineseWeekday(index)}}\n                    </label>                        \n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"m-top-50\" _v-81bda4e4=\"\">\n        <div class=\"from-to-text\" _v-81bda4e4=\"\">複製到</div>\n        <div v-for=\"(item, index) in postData.to\" class=\"date-range-content\" _v-81bda4e4=\"\">\n            <v-week-date-picker :clearable=\"false\" :id=\"index\" :disabled-date=\"disabledPastWeek\" :selected=\"toCallBack\" :date-range=\"item\" _v-81bda4e4=\"\"></v-week-date-picker>\n            <div class=\"remove-btn\" @click=\"removeRange(index)\" _v-81bda4e4=\"\">\n                <i class=\"fa fa-times fa-lg\" _v-81bda4e4=\"\"></i>\n            </div>\n        </div>\n        <a @click=\"addRange\" style=\"font-size: 16px;\" _v-81bda4e4=\"\">＋新增</a>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.from-to-text[_v-81bda4e4] {\n  font-size: 18px;\n  color: #333333; }\n\n/* line 6, stdin */\n.check-select[_v-81bda4e4] {\n  display: -ms-flexbox;\n  display: flex; }\n  /* line 8, stdin */\n  .check-select .week-check[_v-81bda4e4] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n        flex-direction: column;\n    -ms-flex-align: center;\n        align-items: center; }\n  /* line 13, stdin */\n  .check-select input[_v-81bda4e4] {\n    width: 17px;\n    height: 17px; }\n\n/* line 18, stdin */\n.date-range-content[_v-81bda4e4] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  margin-bottom: 15px; }\n  /* line 22, stdin */\n  .date-range-content .remove-btn[_v-81bda4e4] {\n    height: 34px;\n    background: #CCCCCB;\n    border-radius: 0px 4px 4px 0px;\n    cursor: pointer; }\n    /* line 27, stdin */\n    .date-range-content .remove-btn i[_v-81bda4e4] {\n      padding: 10px;\n      color: #fff; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-81bda4e4", module.exports)
  } else {
    hotAPI.update("_v-81bda4e4", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/object/assign":50,"babel-runtime/helpers/extends":66,"lodash":717,"moment":727,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1177:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        dateRange: {
            type: Array
        },
        id: {
            type: String | Number,
            default: 0
        },
        placeholder: {
            type: String,
            default: '請選擇日期'
        },
        disabledDate: {
            type: Function | String
        },
        clearable: {
            type: Boolean,
            default: true
        },
        selected: {
            type: Function
        }
    },
    data: function data() {
        return {
            value: null,
            dates: []
        };
    },

    watch: {
        dateRange: function dateRange(newVal) {
            if (newVal) {
                this.setDataRange();
            }
        }
    },
    mounted: function mounted() {
        this.initDefault();
    },

    methods: {
        initDefault: function initDefault() {
            if (this.dateRange.length) {
                this.setDataRange();
            }
        },
        setDataRange: function setDataRange() {
            this.value = this.dateRange[0] || null;
            this.dates = this.dateRange;
        },
        formatDateDisplay: function formatDateDisplay(dates) {
            return _lodash2.default.isEmpty(dates) ? '' : dates[0] + ' ~ ' + dates[1];
        },
        weekRange: function weekRange(date) {
            if (!date) return;
            this.dates = [this.formatTime(moment(date).isoWeekday(1).toDate()), this.formatTime(moment(date).isoWeekday(7).toDate())];
        },
        change: function change(event) {
            var key = this.id;
            this.weekRange(event.dates);
            this.selected && this.selected({
                datepicker_id: key,
                dates: this.dates
            });
        },
        formatTime: function formatTime(date) {
            return moment(date).format('YYYY-MM-DD');
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div style=\"max-width: 285px; width: 100%;\">\n    <v-date-picker v-model=\"value\" type=\"week\" :clearable=\"clearable\" :disabled-date=\"disabledDate\" @change=\"change\">\n        <template slot=\"input\">\n            {{ formatDateDisplay(dates) || placeholder }}\n        </template>\n    </v-date-picker>    \n</div>\n\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-46cd374c", module.exports)
  } else {
    hotAPI.update("_v-46cd374c", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"lodash":717,"vue":792,"vue-hot-reload-api":785}],1178:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _serviceBookingIndex = require('./service-booking-index.vue');

var _serviceBookingIndex2 = _interopRequireDefault(_serviceBookingIndex);

var _serviceBookingCalendar = require('./service-booking-calendar.vue');

var _serviceBookingCalendar2 = _interopRequireDefault(_serviceBookingCalendar);

var _scheduleIndex = require('./schedule-index.vue');

var _scheduleIndex2 = _interopRequireDefault(_scheduleIndex);

var _scheduleCalendar = require('./schedule-calendar.vue');

var _scheduleCalendar2 = _interopRequireDefault(_scheduleCalendar);

var _choiceServiceProviderModal = require('./utilities-modal/choice-service-provider-modal.vue');

var _choiceServiceProviderModal2 = _interopRequireDefault(_choiceServiceProviderModal);

var _choiceEventModal = require('./utilities-modal/choice-event-modal.vue');

var _choiceEventModal2 = _interopRequireDefault(_choiceEventModal);

var _blockTimeModal = require('./utilities-modal/block-time-modal.vue');

var _blockTimeModal2 = _interopRequireDefault(_blockTimeModal);

var _choiceDateModal = require('./utilities-modal/choice-date-modal.vue');

var _choiceDateModal2 = _interopRequireDefault(_choiceDateModal);

var _index = require('./class-copy/index.vue');

var _index2 = _interopRequireDefault(_index);

var _setBranch = require('./class-copy/set-branch.vue');

var _setBranch2 = _interopRequireDefault(_setBranch);

var _setTimetable = require('./class-copy/set-timetable.vue');

var _setTimetable2 = _interopRequireDefault(_setTimetable);

var _setProgram = require('./class-copy/set-program.vue');

var _setProgram2 = _interopRequireDefault(_setProgram);

var _setClass = require('./class-copy/set-class.vue');

var _setClass2 = _interopRequireDefault(_setClass);

var _setOthers = require('./class-copy/set-others.vue');

var _setOthers2 = _interopRequireDefault(_setOthers);

var _previewConfirm = require('./class-copy/preview-confirm.vue');

var _previewConfirm2 = _interopRequireDefault(_previewConfirm);

var _weekDatePicker = require('./class-copy/week-date-picker.vue');

var _weekDatePicker2 = _interopRequireDefault(_weekDatePicker);

var _refrehScheduleHelper = require('./refreh-schedule-helper.vue');

var _refrehScheduleHelper2 = _interopRequireDefault(_refrehScheduleHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('service-full-calendar-index', _serviceBookingIndex2.default);
_vue2.default.component('service-booking-calendar', _serviceBookingCalendar2.default);
_vue2.default.component('schedule-full-calendar-index', _scheduleIndex2.default);
_vue2.default.component('schedule-calendar', _scheduleCalendar2.default);
_vue2.default.component('choice-service-provider-modal', _choiceServiceProviderModal2.default);
_vue2.default.component('choice-event-modal', _choiceEventModal2.default);
_vue2.default.component('block-time-modal', _blockTimeModal2.default);
_vue2.default.component('choice-date-modal', _choiceDateModal2.default);

_vue2.default.component('class-copy-index', _index2.default);
_vue2.default.component('class-copy-set-branch', _setBranch2.default);
_vue2.default.component('class-copy-set-timetable', _setTimetable2.default);
_vue2.default.component('class-copy-set-program', _setProgram2.default);
_vue2.default.component('class-copy-set-class', _setClass2.default);
_vue2.default.component('class-copy-set-others', _setOthers2.default);
_vue2.default.component('class-copy-preview-confirm', _previewConfirm2.default);
_vue2.default.component('v-week-date-picker', _weekDatePicker2.default);
_vue2.default.component('refresh-schedule-helper', _refrehScheduleHelper2.default);

},{"./class-copy/index.vue":1170,"./class-copy/preview-confirm.vue":1171,"./class-copy/set-branch.vue":1172,"./class-copy/set-class.vue":1173,"./class-copy/set-others.vue":1174,"./class-copy/set-program.vue":1175,"./class-copy/set-timetable.vue":1176,"./class-copy/week-date-picker.vue":1177,"./refreh-schedule-helper.vue":1179,"./schedule-calendar.vue":1180,"./schedule-index.vue":1181,"./service-booking-calendar.vue":1182,"./service-booking-index.vue":1183,"./utilities-modal/block-time-modal.vue":1184,"./utilities-modal/choice-date-modal.vue":1185,"./utilities-modal/choice-event-modal.vue":1186,"./utilities-modal/choice-service-provider-modal.vue":1187,"vue":792}],1179:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        defaultBranch: {
            type: Object,
            default: function _default() {
                return {};
            }
        }
    },
    data: function data() {
        return {
            successMessage: '',
            selectedStudio: null,
            selectedBranch: null,
            ajaxing: false
        };
    },

    watch: {
        'branchOptions': {
            handler: function handler(newVal) {
                if (newVal && this.defaultBranch) {
                    this.preselectDefaultBranch();
                }
                if (this.isBranch) {
                    this.selectedBranch = newVal[0];
                }
            },

            deep: true
        },
        defaultBranch: function defaultBranch(newVal) {
            this.preselectDefaultBranch();
        }
    },
    mounted: function mounted() {
        var _this = this;

        window.Event.$on("System.Schedule.Cache-Refresh", function (data) {
            _this.init();
            $('#refresh-schedule-cache-modal').modal('show');
        });
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId', 'studioName', 'isBranch', 'isStudio', 'isSeventeen']), (0, _vuex.mapState)({
        studioOptions: function studioOptions(state) {
            return state.filters.studioOptions;
        },
        branchOptions: function branchOptions(state) {
            return state.filters.branchOptions;
        }
    }), {
        disabledSubmit: function disabledSubmit() {
            return this.ajaxing || !this.selectedBranch;
        }
    }),
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('filters', ['getStudioList', 'getBranchList']), {
        init: function init() {
            this.ajaxing = false;
            this.$refs.bootstrap_alert.closeAlertBox();
            this.preselectDefaultBranch();
            if (this.isSeventeen) this.getStudioList();
            if ((this.isStudio || this.isBranch) && _lodash2.default.isEmpty(this.branchOptions)) {
                this.selectStudio({
                    id: this.studioId,
                    brand_name: this.studioName
                });
            }
        },
        selectStudio: function selectStudio(studio) {
            this.$store.commit('filters/SETSTATUS', { 'key': 'selected_studio_id', value: studio.id });
            this.getBranchList();
        },
        preselectDefaultBranch: function preselectDefaultBranch() {
            var _this2 = this;

            if (!_lodash2.default.isEmpty(this.branchOptions) && this.defaultBranch.id) {
                this.selectedBranch = this.branchOptions.find(function (item) {
                    return item.id == _this2.defaultBranch.id;
                });
            }
        },
        submit: function submit() {
            var _this3 = this;

            if (this.disabledSubmit) return;
            var branchId = this.selectedBranch.id;
            this.ajaxing = true;
            this.$http.get('/adminapi/refresh-cache/class-schedule/branch/' + branchId).then(function (response) {
                _this3.successMessage = '<div class="st-flex st-items-center"><span class="material-icons st-mr-2">check_circle</span>\u5DF2\u9001\u51FA\u8981\u6C42</div>';
                _this3.$refs.bootstrap_alert.showAlert();
                _this3.hideModal();
                _this3.ajaxing = false;
            }).catch(function (response) {
                var hasErrorIdentifiable = response.data.hasOwnProperty('code') && _this3.$errorIdentifiable.includes(response.data.code);
                var text = response.data.message ? response.data.message : i18n.t('pass.unknow_error_to_service');
                if (hasErrorIdentifiable) text = '[' + response.data.code + '] ' + i18n.t('error.msg.' + response.data.code);
                _this3.errorAlert(text);
                _this3.ajaxing = false;
            });
        },
        hideModal: function hideModal() {
            $('#refresh-schedule-cache-modal').modal('hide');
        },
        errorAlert: function errorAlert(message) {
            $17.swal({
                title: message,
                type: 'error',
                showCancelButton: false,
                confirmButtonColor: '#5CAFDE',
                confirmButtonText: '確認',
                closeOnConfirm: true
            });
        }
    })

};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div>\n    <div class=\"st-fixed st-inset-x-0 st-top-6 st-z-[100] st-mx-auto st-max-w-xs st-w-full st-rounded-4 st-bg-white\">\n        <v-dismissible-alert-bootstrap ref=\"bootstrap_alert\" dismissible-style=\"st-bg-success/[.16] st-border-success st-mb-0 st-text-success\" :allow-close=\"true\" :text=\"successMessage\"></v-dismissible-alert-bootstrap>\n    </div>\n    <div>\n        <v-modal id=\"refresh-schedule-cache-modal\">\n            <div slot=\"title\">刷新線上課表</div>\n            <div slot=\"body\">\n                <div class=\"st-space-y-5 st-text-black\">\n                    <div v-if=\"isSeventeen\">\n                        <div class=\"st-text-16 st-font-medium\">請選擇品牌</div>\n                        <v-mutiselect :model.sync=\"selectedStudio\" :options=\"studioOptions\" :close-on-select=\"true\" :clear-on-select=\"false\" :preserve-search=\"true\" :searchable=\"true\" :allow-empty=\"false\" :select-event-append=\"selectStudio\" :max-height=\"130\" placeholder=\"請選擇品牌\" label=\"brand_name\" track-by=\"id\"></v-mutiselect>\n                    </div>\n                    <div>\n                        <div class=\"st-text-16 st-font-medium\">請選擇場館</div>\n                        <v-mutiselect :model.sync=\"selectedBranch\" :options=\"branchOptions\" :close-on-select=\"true\" :clear-on-select=\"false\" :searchable=\"true\" :allow-empty=\"false\" :max-height=\"130\" placeholder=\"請選擇場館\" label=\"branch_name\" track-by=\"id\" :disabled=\"isBranch\"></v-mutiselect>\n                    </div>\n                    <div class=\"st-text-danger st-text-16 st-font-regular st-flex st-items-center st-gap-2\">\n                        <span class=\"material-icons\">error_outline</span>\n                        <span>將刷新近 21 天內的課表，可能需要數分鐘的時間</span>\n                    </div>\n                </div>\n            </div>\n            <div slot=\"footer\">\n                <div class=\"st-flex st-gap-2 st-justify-end\">\n                    <st-button text=\"取消\" ghost=\"\" @click=\"hideModal\"></st-button>\n                    <st-button text=\"確定\" :disabled=\"disabledSubmit\" @click=\"submit\"></st-button>\n                </div>\n            </div>\n        </v-modal>\n    </div>\n</div>\n\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-25d1ca14", module.exports)
  } else {
    hotAPI.update("_v-25d1ca14", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vuex":803}],1180:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert(".tippy-box[data-animation=fade][data-state=hidden]{opacity:0}[data-tippy-root]{max-width:calc(100vw - 10px)}.tippy-box{position:relative;background-color:#333;color:#fff;border-radius:4px;font-size:14px;line-height:1.4;outline:0;transition-property:transform,visibility,opacity}.tippy-box[data-placement^=top]>.tippy-arrow{bottom:0}.tippy-box[data-placement^=top]>.tippy-arrow:before{bottom:-7px;left:0;border-width:8px 8px 0;border-top-color:initial;transform-origin:center top}.tippy-box[data-placement^=bottom]>.tippy-arrow{top:0}.tippy-box[data-placement^=bottom]>.tippy-arrow:before{top:-7px;left:0;border-width:0 8px 8px;border-bottom-color:initial;transform-origin:center bottom}.tippy-box[data-placement^=left]>.tippy-arrow{right:0}.tippy-box[data-placement^=left]>.tippy-arrow:before{border-width:8px 0 8px 8px;border-left-color:initial;right:-7px;transform-origin:center left}.tippy-box[data-placement^=right]>.tippy-arrow{left:0}.tippy-box[data-placement^=right]>.tippy-arrow:before{left:-7px;border-width:8px 8px 8px 0;border-right-color:initial;transform-origin:center right}.tippy-box[data-inertia][data-state=visible]{transition-timing-function:cubic-bezier(.54,1.5,.38,1.11)}.tippy-arrow{width:16px;height:16px;color:#333}.tippy-arrow:before{content:\"\";position:absolute;border-color:transparent;border-style:solid}.tippy-content{position:relative;padding:5px 9px;z-index:1}\n.tippy-box[data-theme~=light-border]{background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,8,16,.15);color:#333;box-shadow:0 4px 14px -2px rgba(0,8,16,.08)}.tippy-box[data-theme~=light-border]>.tippy-backdrop{background-color:#fff}.tippy-box[data-theme~=light-border]>.tippy-arrow:after,.tippy-box[data-theme~=light-border]>.tippy-svg-arrow:after{content:\"\";position:absolute;z-index:-1}.tippy-box[data-theme~=light-border]>.tippy-arrow:after{border-color:transparent;border-style:solid}.tippy-box[data-theme~=light-border][data-placement^=top]>.tippy-arrow:before{border-top-color:#fff}.tippy-box[data-theme~=light-border][data-placement^=top]>.tippy-arrow:after{border-top-color:rgba(0,8,16,.2);border-width:7px 7px 0;top:17px;left:1px}.tippy-box[data-theme~=light-border][data-placement^=top]>.tippy-svg-arrow>svg{top:16px}.tippy-box[data-theme~=light-border][data-placement^=top]>.tippy-svg-arrow:after{top:17px}.tippy-box[data-theme~=light-border][data-placement^=bottom]>.tippy-arrow:before{border-bottom-color:#fff;bottom:16px}.tippy-box[data-theme~=light-border][data-placement^=bottom]>.tippy-arrow:after{border-bottom-color:rgba(0,8,16,.2);border-width:0 7px 7px;bottom:17px;left:1px}.tippy-box[data-theme~=light-border][data-placement^=bottom]>.tippy-svg-arrow>svg{bottom:16px}.tippy-box[data-theme~=light-border][data-placement^=bottom]>.tippy-svg-arrow:after{bottom:17px}.tippy-box[data-theme~=light-border][data-placement^=left]>.tippy-arrow:before{border-left-color:#fff}.tippy-box[data-theme~=light-border][data-placement^=left]>.tippy-arrow:after{border-left-color:rgba(0,8,16,.2);border-width:7px 0 7px 7px;left:17px;top:1px}.tippy-box[data-theme~=light-border][data-placement^=left]>.tippy-svg-arrow>svg{left:11px}.tippy-box[data-theme~=light-border][data-placement^=left]>.tippy-svg-arrow:after{left:12px}.tippy-box[data-theme~=light-border][data-placement^=right]>.tippy-arrow:before{border-right-color:#fff;right:16px}.tippy-box[data-theme~=light-border][data-placement^=right]>.tippy-arrow:after{border-width:7px 7px 7px 0;right:17px;top:1px;border-right-color:rgba(0,8,16,.2)}.tippy-box[data-theme~=light-border][data-placement^=right]>.tippy-svg-arrow>svg{right:11px}.tippy-box[data-theme~=light-border][data-placement^=right]>.tippy-svg-arrow:after{right:12px}.tippy-box[data-theme~=light-border]>.tippy-svg-arrow{fill:#fff}.tippy-box[data-theme~=light-border]>.tippy-svg-arrow:after{background-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMCA2czEuNzk2LS4wMTMgNC42Ny0zLjYxNUM1Ljg1MS45IDYuOTMuMDA2IDggMGMxLjA3LS4wMDYgMi4xNDguODg3IDMuMzQzIDIuMzg1QzE0LjIzMyA2LjAwNSAxNiA2IDE2IDZIMHoiIGZpbGw9InJnYmEoMCwgOCwgMTYsIDAuMikiLz48L3N2Zz4=);background-size:16px 6px;width:16px;height:6px}\n.fc-icon,.fc-unselectable{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none}.fc-not-allowed,.fc-not-allowed .fc-event{cursor:not-allowed}.fc .fc-button:not(:disabled),.fc a[data-navlink],.fc-event.fc-event-draggable,.fc-event[href]{cursor:pointer}.fc-unselectable{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-touch-callout:none;-webkit-tap-highlight-color:transparent}.fc{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;font-size:1em}.fc,.fc *,.fc :after,.fc :before{box-sizing:border-box}.fc table{border-collapse:collapse;border-spacing:0;font-size:1em}.fc th{text-align:center}.fc td,.fc th{vertical-align:top;padding:0}.fc a[data-navlink]:hover{text-decoration:underline}.fc-direction-ltr{direction:ltr;text-align:left}.fc-direction-rtl{direction:rtl;text-align:right}.fc .fc-button,.fc-icon{font-weight:400;text-align:center;display:inline-block}.fc-theme-standard td,.fc-theme-standard th{border:1px solid #ddd;border:1px solid var(--fc-border-color,#ddd)}.fc-liquid-hack td,.fc-liquid-hack th{position:relative}@font-face{font-family:fcicons;src:url(\"data:application/x-font-ttf;charset=utf-8;base64,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\") format('truetype');font-weight:400;font-style:normal}.fc-icon{width:1em;height:1em;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;font-family:fcicons!important;speak:none;font-style:normal;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.fc .fc-scroller-harness-liquid,.fc .fc-scroller-liquid,.fc .fc-scrollgrid-liquid{height:100%}.fc-icon-chevron-left:before{content:\"\\e900\"}.fc-icon-chevron-right:before{content:\"\\e901\"}.fc-icon-chevrons-left:before{content:\"\\e902\"}.fc-icon-chevrons-right:before{content:\"\\e903\"}.fc-icon-minus-square:before{content:\"\\e904\"}.fc-icon-plus-square:before{content:\"\\e905\"}.fc-icon-x:before{content:\"\\e906\"}.fc .fc-button{overflow:visible;text-transform:none;margin:0;font-family:inherit}.fc .fc-button::-moz-focus-inner{padding:0;border-style:none}.fc .fc-button{-webkit-appearance:button;vertical-align:middle;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-color:transparent;border:1px solid transparent;padding:.4em .65em;font-size:1em;line-height:1.5;border-radius:.25em}.fc .fc-button:hover{text-decoration:none}.fc .fc-button:focus{outline:0;box-shadow:0 0 0 .2rem rgba(44,62,80,.25)}.fc .fc-button-primary:focus,.fc .fc-button-primary:not(:disabled).fc-button-active:focus,.fc .fc-button-primary:not(:disabled):active:focus{box-shadow:0 0 0 .2rem rgba(76,91,106,.5)}.fc .fc-button:disabled{opacity:.65}.fc .fc-button-primary{color:#fff;color:var(--fc-button-text-color,#fff);background-color:#2C3E50;background-color:var(--fc-button-bg-color,#2C3E50);border-color:#2C3E50;border-color:var(--fc-button-border-color,#2C3E50)}.fc .fc-button-primary:hover{color:#fff;color:var(--fc-button-text-color,#fff);background-color:#1e2b37;background-color:var(--fc-button-hover-bg-color,#1e2b37);border-color:#1a252f;border-color:var(--fc-button-hover-border-color,#1a252f)}.fc .fc-button-primary:disabled{color:#fff;color:var(--fc-button-text-color,#fff);background-color:#2C3E50;background-color:var(--fc-button-bg-color,#2C3E50);border-color:#2C3E50;border-color:var(--fc-button-border-color,#2C3E50)}.fc .fc-button-primary:not(:disabled).fc-button-active,.fc .fc-button-primary:not(:disabled):active{color:#fff;color:var(--fc-button-text-color,#fff);background-color:#1a252f;background-color:var(--fc-button-active-bg-color,#1a252f);border-color:#151e27;border-color:var(--fc-button-active-border-color,#151e27)}.fc .fc-button .fc-icon{vertical-align:middle;font-size:1.5em}.fc .fc-button-group{position:relative;display:-ms-inline-flexbox;display:inline-flex;vertical-align:middle}.fc .fc-button-group>.fc-button{position:relative;-ms-flex:1 1 auto;flex:1 1 auto}.fc .fc-button-group>.fc-button.fc-button-active,.fc .fc-button-group>.fc-button:active,.fc .fc-button-group>.fc-button:focus,.fc .fc-button-group>.fc-button:hover{z-index:1}.fc-direction-ltr .fc-button-group>.fc-button:not(:first-child){margin-left:-1px;border-top-left-radius:0;border-bottom-left-radius:0}.fc-direction-ltr .fc-button-group>.fc-button:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0}.fc-direction-rtl .fc-button-group>.fc-button:not(:first-child){margin-right:-1px;border-top-right-radius:0;border-bottom-right-radius:0}.fc-direction-rtl .fc-button-group>.fc-button:not(:last-child){border-top-left-radius:0;border-bottom-left-radius:0}.fc .fc-toolbar{display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-align:center;align-items:center}.fc .fc-toolbar.fc-header-toolbar{margin-bottom:1.5em}.fc .fc-toolbar.fc-footer-toolbar{margin-top:1.5em}.fc .fc-toolbar-title{font-size:1.75em;margin:0}.fc-direction-ltr .fc-toolbar>*>:not(:first-child){margin-left:.75em}.fc-direction-rtl .fc-toolbar>*>:not(:first-child){margin-right:.75em}.fc-direction-rtl .fc-toolbar-ltr{-ms-flex-direction:row-reverse;flex-direction:row-reverse}.fc .fc-scroller{-webkit-overflow-scrolling:touch;position:relative}.fc .fc-scroller-liquid-absolute{position:absolute;top:0;right:0;left:0;bottom:0}.fc .fc-scroller-harness{position:relative;overflow:hidden;direction:ltr}.fc-direction-rtl .fc-scroller-harness>.fc-scroller{direction:rtl}.fc-theme-standard .fc-scrollgrid{border:1px solid #ddd;border:1px solid var(--fc-border-color,#ddd)}.fc .fc-scrollgrid,.fc .fc-scrollgrid-section-footer>*,.fc .fc-scrollgrid-section-header>*{border-bottom-width:0}.fc .fc-scrollgrid,.fc .fc-scrollgrid table{width:100%;table-layout:fixed}.fc .fc-scrollgrid table{border-top-style:hidden;border-left-style:hidden;border-right-style:hidden}.fc .fc-scrollgrid{border-collapse:separate;border-right-width:0}.fc .fc-scrollgrid-section,.fc .fc-scrollgrid-section table,.fc .fc-scrollgrid-section>td{height:1px}.fc .fc-scrollgrid-section-liquid>td{height:100%}.fc .fc-scrollgrid-section>*{border-top-width:0;border-left-width:0}.fc .fc-scrollgrid-section-body table,.fc .fc-scrollgrid-section-footer table{border-bottom-style:hidden}.fc .fc-scrollgrid-section-sticky>*{background:var(--fc-page-bg-color,#fff);position:-webkit-sticky;position:sticky;z-index:3}.fc .fc-scrollgrid-section-header.fc-scrollgrid-section-sticky>*{top:0}.fc .fc-scrollgrid-section-footer.fc-scrollgrid-section-sticky>*{bottom:0}.fc .fc-scrollgrid-sticky-shim{height:1px;margin-bottom:-1px}.fc-sticky{position:-webkit-sticky;position:sticky}.fc .fc-view-harness{-ms-flex-positive:1;flex-grow:1;position:relative}.fc .fc-bg-event,.fc .fc-highlight,.fc .fc-non-business,.fc .fc-view-harness-active>.fc-view{position:absolute;top:0;left:0;right:0;bottom:0}.fc .fc-col-header-cell-cushion{display:inline-block;padding:2px 4px}.fc .fc-non-business{background:rgba(215,215,215,.3);background:var(--fc-non-business-color,rgba(215,215,215,.3))}.fc .fc-bg-event{background:var(--fc-bg-event-color,#8fdf82);opacity:.3;opacity:var(--fc-bg-event-opacity,.3)}.fc .fc-bg-event .fc-event-title{margin:.5em;font-size:.85em;font-size:var(--fc-small-font-size,.85em);font-style:italic}.fc .fc-highlight{background:rgba(188,232,241,.3);background:var(--fc-highlight-color,rgba(188,232,241,.3))}.fc .fc-cell-shaded,.fc .fc-day-disabled{background:rgba(208,208,208,.3);background:var(--fc-neutral-bg-color,rgba(208,208,208,.3))}a.fc-event,a.fc-event:hover{text-decoration:none}.fc-event .fc-event-main{position:relative;z-index:2}.fc-event-dragging:not(.fc-event-selected){opacity:.75}.fc-event-dragging.fc-event-selected{box-shadow:0 2px 7px rgba(0,0,0,.3)}.fc-event .fc-event-resizer{display:none;position:absolute;z-index:4}.fc-event-selected .fc-event-resizer,.fc-event:hover .fc-event-resizer,.fc-h-event{display:block}.fc-event-selected .fc-event-resizer{border-radius:4px;border-radius:calc(var(--fc-event-resizer-dot-total-width,8px)/ 2);border-width:1px;border-width:var(--fc-event-resizer-dot-border-width,1px);width:8px;width:var(--fc-event-resizer-dot-total-width,8px);height:8px;height:var(--fc-event-resizer-dot-total-width,8px);border-style:solid;border-color:inherit;background:var(--fc-page-bg-color,#fff)}.fc-event-selected .fc-event-resizer:before{content:'';position:absolute;top:-20px;left:-20px;right:-20px;bottom:-20px}.fc-event-selected:after,.fc-event-selected:before{content:\"\";position:absolute}.fc-event-selected{box-shadow:0 2px 5px rgba(0,0,0,.2)}.fc-event-selected:before{z-index:3;top:0;left:0;right:0;bottom:0}.fc-event-selected:after{background:rgba(0,0,0,.25);background:var(--fc-event-selected-overlay-color,rgba(0,0,0,.25));z-index:1;top:-1px;left:-1px;right:-1px;bottom:-1px}.fc-h-event{border:1px solid #3788d8;border:1px solid var(--fc-event-border-color,#3788d8);background-color:#3788d8;background-color:var(--fc-event-bg-color,#3788d8)}.fc-h-event .fc-event-main{color:#fff;color:var(--fc-event-text-color,#fff)}.fc-h-event .fc-event-main-frame{display:-ms-flexbox;display:flex}.fc-h-event .fc-event-time{max-width:100%;overflow:hidden}.fc-h-event .fc-event-title-container{-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1;min-width:0}.fc-h-event .fc-event-title{display:inline-block;vertical-align:top;left:0;right:0;max-width:100%;overflow:hidden}.fc-h-event.fc-event-selected:before{top:-10px;bottom:-10px}.fc-direction-ltr .fc-daygrid-block-event:not(.fc-event-start),.fc-direction-rtl .fc-daygrid-block-event:not(.fc-event-end){border-top-left-radius:0;border-bottom-left-radius:0;border-left-width:0}.fc-direction-ltr .fc-daygrid-block-event:not(.fc-event-end),.fc-direction-rtl .fc-daygrid-block-event:not(.fc-event-start){border-top-right-radius:0;border-bottom-right-radius:0;border-right-width:0}.fc-h-event:not(.fc-event-selected) .fc-event-resizer{top:0;bottom:0;width:8px;width:var(--fc-event-resizer-thickness,8px)}.fc-direction-ltr .fc-h-event:not(.fc-event-selected) .fc-event-resizer-start,.fc-direction-rtl .fc-h-event:not(.fc-event-selected) .fc-event-resizer-end{cursor:w-resize;left:-4px;left:calc(var(--fc-event-resizer-thickness,8px)/ -2)}.fc-direction-ltr .fc-h-event:not(.fc-event-selected) .fc-event-resizer-end,.fc-direction-rtl .fc-h-event:not(.fc-event-selected) .fc-event-resizer-start{cursor:e-resize;right:-4px;right:calc(var(--fc-event-resizer-thickness,8px)/ -2)}.fc-h-event.fc-event-selected .fc-event-resizer{top:50%;margin-top:-4px;margin-top:calc(var(--fc-event-resizer-dot-total-width,8px)/ -2)}.fc-direction-ltr .fc-h-event.fc-event-selected .fc-event-resizer-start,.fc-direction-rtl .fc-h-event.fc-event-selected .fc-event-resizer-end{left:-4px;left:calc(var(--fc-event-resizer-dot-total-width,8px)/ -2)}.fc-direction-ltr .fc-h-event.fc-event-selected .fc-event-resizer-end,.fc-direction-rtl .fc-h-event.fc-event-selected .fc-event-resizer-start{right:-4px;right:calc(var(--fc-event-resizer-dot-total-width,8px)/ -2)}.fc .fc-popover{position:absolute;z-index:9999;box-shadow:0 2px 6px rgba(0,0,0,.15)}.fc .fc-popover-header{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-align:center;align-items:center;padding:3px 4px}.fc .fc-popover-title{margin:0 2px}.fc .fc-popover-close{cursor:pointer;opacity:.65;font-size:1.1em}.fc-theme-standard .fc-popover{border:1px solid #ddd;border:1px solid var(--fc-border-color,#ddd);background:var(--fc-page-bg-color,#fff)}.fc-theme-standard .fc-popover-header{background:rgba(208,208,208,.3);background:var(--fc-neutral-bg-color,rgba(208,208,208,.3))}\n:root{--fc-daygrid-event-dot-width:8px}.fc-daygrid-day-events:after,.fc-daygrid-day-events:before,.fc-daygrid-day-frame:after,.fc-daygrid-day-frame:before,.fc-daygrid-event-harness:after,.fc-daygrid-event-harness:before{content:\"\";clear:both;display:table}.fc .fc-daygrid-body{position:relative;z-index:1}.fc .fc-daygrid-day.fc-day-today{background-color:rgba(255,220,40,.15);background-color:var(--fc-today-bg-color,rgba(255,220,40,.15))}.fc .fc-daygrid-day-frame{position:relative;min-height:100%}.fc .fc-daygrid-day-top{display:-ms-flexbox;display:flex;-ms-flex-direction:row-reverse;flex-direction:row-reverse}.fc .fc-day-other .fc-daygrid-day-top{opacity:.3}.fc .fc-daygrid-day-number{position:relative;z-index:4;padding:4px}.fc .fc-daygrid-day-events{margin-top:1px}.fc .fc-daygrid-body-balanced .fc-daygrid-day-events{position:absolute;left:0;right:0}.fc .fc-daygrid-body-unbalanced .fc-daygrid-day-events{position:relative;min-height:2em}.fc .fc-daygrid-body-natural .fc-daygrid-day-events{margin-bottom:1em}.fc .fc-daygrid-event-harness{position:relative}.fc .fc-daygrid-event-harness-abs{position:absolute;top:0;left:0;right:0}.fc .fc-daygrid-bg-harness{position:absolute;top:0;bottom:0}.fc .fc-daygrid-day-bg .fc-non-business{z-index:1}.fc .fc-daygrid-day-bg .fc-bg-event{z-index:2}.fc .fc-daygrid-day-bg .fc-highlight{z-index:3}.fc .fc-daygrid-event{z-index:6;margin-top:1px}.fc .fc-daygrid-event.fc-event-mirror{z-index:7}.fc .fc-daygrid-day-bottom{font-size:.85em;padding:2px 3px 0}.fc .fc-daygrid-day-bottom:before{content:\"\";clear:both;display:table}.fc .fc-daygrid-more-link{position:relative;z-index:4;cursor:pointer}.fc .fc-daygrid-week-number{position:absolute;z-index:5;top:0;padding:2px;min-width:1.5em;text-align:center;background-color:rgba(208,208,208,.3);background-color:var(--fc-neutral-bg-color,rgba(208,208,208,.3));color:grey;color:var(--fc-neutral-text-color,grey)}.fc .fc-more-popover .fc-popover-body{min-width:220px;padding:10px}.fc-direction-ltr .fc-daygrid-event.fc-event-start,.fc-direction-rtl .fc-daygrid-event.fc-event-end{margin-left:2px}.fc-direction-ltr .fc-daygrid-event.fc-event-end,.fc-direction-rtl .fc-daygrid-event.fc-event-start{margin-right:2px}.fc-direction-ltr .fc-daygrid-week-number{left:0;border-radius:0 0 3px}.fc-direction-rtl .fc-daygrid-week-number{right:0;border-radius:0 0 0 3px}.fc-liquid-hack .fc-daygrid-day-frame{position:static}.fc-daygrid-event{position:relative;white-space:nowrap;border-radius:3px;font-size:.85em;font-size:var(--fc-small-font-size,.85em)}.fc-daygrid-block-event .fc-event-time{font-weight:700}.fc-daygrid-block-event .fc-event-time,.fc-daygrid-block-event .fc-event-title{padding:1px}.fc-daygrid-dot-event{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;padding:2px 0}.fc-daygrid-dot-event .fc-event-title{-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1;min-width:0;overflow:hidden;font-weight:700}.fc-daygrid-dot-event.fc-event-mirror,.fc-daygrid-dot-event:hover{background:rgba(0,0,0,.1)}.fc-daygrid-dot-event.fc-event-selected:before{top:-10px;bottom:-10px}.fc-daygrid-event-dot{margin:0 4px;box-sizing:content-box;width:0;height:0;border:4px solid #3788d8;border:calc(var(--fc-daygrid-event-dot-width,8px)/ 2) solid var(--fc-event-border-color,#3788d8);border-radius:4px;border-radius:calc(var(--fc-daygrid-event-dot-width,8px)/ 2)}.fc-direction-ltr .fc-daygrid-event .fc-event-time{margin-right:3px}.fc-direction-rtl .fc-daygrid-event .fc-event-time{margin-left:3px}\n.fc-v-event{display:block;border:1px solid #3788d8;border:1px solid var(--fc-event-border-color,#3788d8);background-color:#3788d8;background-color:var(--fc-event-bg-color,#3788d8)}.fc-v-event .fc-event-main{color:#fff;color:var(--fc-event-text-color,#fff);height:100%}.fc-v-event .fc-event-main-frame{height:100%;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}.fc-v-event .fc-event-time{-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;max-height:100%;overflow:hidden}.fc-v-event .fc-event-title-container{-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1;min-height:0}.fc-v-event .fc-event-title{top:0;bottom:0;max-height:100%;overflow:hidden}.fc-v-event:not(.fc-event-start){border-top-width:0;border-top-left-radius:0;border-top-right-radius:0}.fc-v-event:not(.fc-event-end){border-bottom-width:0;border-bottom-left-radius:0;border-bottom-right-radius:0}.fc-v-event.fc-event-selected:before{left:-10px;right:-10px}.fc-v-event .fc-event-resizer-start{cursor:n-resize}.fc-v-event .fc-event-resizer-end{cursor:s-resize}.fc-v-event:not(.fc-event-selected) .fc-event-resizer{height:8px;height:var(--fc-event-resizer-thickness,8px);left:0;right:0}.fc-v-event:not(.fc-event-selected) .fc-event-resizer-start{top:-4px;top:calc(var(--fc-event-resizer-thickness,8px)/ -2)}.fc-v-event:not(.fc-event-selected) .fc-event-resizer-end{bottom:-4px;bottom:calc(var(--fc-event-resizer-thickness,8px)/ -2)}.fc-v-event.fc-event-selected .fc-event-resizer{left:50%;margin-left:-4px;margin-left:calc(var(--fc-event-resizer-dot-total-width,8px)/ -2)}.fc-v-event.fc-event-selected .fc-event-resizer-start{top:-4px;top:calc(var(--fc-event-resizer-dot-total-width,8px)/ -2)}.fc-v-event.fc-event-selected .fc-event-resizer-end{bottom:-4px;bottom:calc(var(--fc-event-resizer-dot-total-width,8px)/ -2)}.fc .fc-timegrid .fc-daygrid-body{z-index:2}.fc .fc-timegrid-axis-chunk>table,.fc .fc-timegrid-body,.fc .fc-timegrid-slots{position:relative;z-index:1}.fc .fc-timegrid-divider{padding:0 0 2px}.fc .fc-timegrid-body{min-height:100%}.fc .fc-timegrid-axis-chunk{position:relative}.fc .fc-timegrid-slot{height:1.5em;border-bottom:0}.fc .fc-timegrid-slot:empty:before{content:'\\00a0'}.fc .fc-timegrid-slot-minor{border-top-style:dotted}.fc .fc-timegrid-slot-label-cushion{display:inline-block;white-space:nowrap}.fc .fc-timegrid-slot-label{vertical-align:middle}.fc .fc-timegrid-axis-cushion,.fc .fc-timegrid-slot-label-cushion{padding:0 4px}.fc .fc-timegrid-axis-frame-liquid{height:100%}.fc .fc-timegrid-axis-frame{overflow:hidden;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:end;justify-content:flex-end}.fc .fc-timegrid-axis-cushion{max-width:60px;-ms-flex-negative:0;flex-shrink:0}.fc-direction-ltr .fc-timegrid-slot-label-frame{text-align:right}.fc-direction-rtl .fc-timegrid-slot-label-frame{text-align:left}.fc-liquid-hack .fc-timegrid-axis-frame-liquid{height:auto;position:absolute;top:0;right:0;bottom:0;left:0}.fc .fc-timegrid-col.fc-day-today{background-color:rgba(255,220,40,.15);background-color:var(--fc-today-bg-color,rgba(255,220,40,.15))}.fc .fc-timegrid-col-frame{min-height:100%;position:relative}.fc-media-screen.fc-liquid-hack .fc-timegrid-col-frame{height:auto;position:absolute;top:0;right:0;bottom:0;left:0}.fc-media-screen .fc-timegrid-cols{position:absolute;top:0;left:0;right:0;bottom:0}.fc-media-screen .fc-timegrid-cols>table{height:100%}.fc-media-screen .fc-timegrid-col-bg,.fc-media-screen .fc-timegrid-col-events,.fc-media-screen .fc-timegrid-now-indicator-container{position:absolute;top:0;left:0;right:0}.fc .fc-timegrid-col-bg{z-index:2}.fc .fc-timegrid-col-bg .fc-non-business{z-index:1}.fc .fc-timegrid-col-bg .fc-bg-event{z-index:2}.fc .fc-timegrid-col-bg .fc-highlight,.fc .fc-timegrid-col-events{z-index:3}.fc .fc-timegrid-bg-harness{position:absolute;left:0;right:0}.fc .fc-timegrid-now-indicator-container{bottom:0;overflow:hidden}.fc-direction-ltr .fc-timegrid-col-events{margin:0 2.5% 0 2px}.fc-direction-rtl .fc-timegrid-col-events{margin:0 2px 0 2.5%}.fc-timegrid-event-harness{position:absolute}.fc-timegrid-event-harness>.fc-timegrid-event{position:absolute;top:0;bottom:0;left:0;right:0}.fc-timegrid-event-harness-inset .fc-timegrid-event,.fc-timegrid-event.fc-event-mirror,.fc-timegrid-more-link{box-shadow:0 0 0 1px #fff;box-shadow:0 0 0 1px var(--fc-page-bg-color,#fff)}.fc-timegrid-event,.fc-timegrid-more-link{font-size:.85em;font-size:var(--fc-small-font-size,.85em);border-radius:3px}.fc-timegrid-event{margin-bottom:1px}.fc-timegrid-event .fc-event-main{padding:1px 1px 0}.fc-timegrid-event .fc-event-time{white-space:nowrap;font-size:.85em;font-size:var(--fc-small-font-size,.85em);margin-bottom:1px}.fc-timegrid-event-short .fc-event-main-frame{-ms-flex-direction:row;flex-direction:row;overflow:hidden}.fc-timegrid-event-short .fc-event-time:after{content:'\\00a0-\\00a0'}.fc-timegrid-event-short .fc-event-title{font-size:.85em;font-size:var(--fc-small-font-size,.85em)}.fc-timegrid-more-link{position:absolute;z-index:9999;color:inherit;color:var(--fc-more-link-text-color,inherit);background:var(--fc-more-link-bg-color,#d0d0d0);cursor:pointer;margin-bottom:1px}.fc-timegrid-more-link-inner{padding:3px 2px;top:0}.fc-direction-ltr .fc-timegrid-more-link{right:0}.fc-direction-rtl .fc-timegrid-more-link{left:0}.fc .fc-timegrid-now-indicator-line{position:absolute;z-index:4;left:0;right:0;border-style:solid;border-color:red;border-color:var(--fc-now-indicator-color,red);border-width:1px 0 0}.fc .fc-timegrid-now-indicator-arrow{position:absolute;z-index:4;margin-top:-5px;border-style:solid;border-color:red;border-color:var(--fc-now-indicator-color,red)}.fc-direction-ltr .fc-timegrid-now-indicator-arrow{left:0;border-width:5px 0 5px 6px;border-top-color:transparent;border-bottom-color:transparent}.fc-direction-rtl .fc-timegrid-now-indicator-arrow{right:0;border-width:5px 6px 5px 0;border-top-color:transparent;border-bottom-color:transparent}\n\n.tippy-box[data-theme~='nonbusiness-hour'] {\n  color: black;\n  background-color: white;\n  border: 1px solid black;\n}\n.fc .fc-timegrid-now-indicator-line {\n    z-index: 2;\n}\n.fc-event-main{\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n}\n.fc .fc-button-primary {\n    border: 1px solid;\n    background-color: #f5f5f5;\n    background-image: linear-gradient(to bottom,#fff,#e6e6e6);\n    background-repeat: repeat-x;\n    border-color: rgba(0,0,0,.1) rgba(0,0,0,.1) rgba(0,0,0,.25);\n    color: #333;\n    text-shadow: 0 1px 1px rgb(255 255 255 / 75%);\n    box-shadow: inset 0 1px 0 rgb(255 255 255 / 20%), 0 1px 2px rgb(0 0 0 / 5%);\n}\n.fc .fc-button-primary:hover {\n    color: #333;\n    text-decoration: none;\n}\n.fc .fc-button-primary:not(:disabled).fc-button-active, .fc .fc-button-primary:not(:disabled):active{\n    background-color: #ccc;\n    color: #333;\n    background-image: none;\n    box-shadow: inset 0 2px 4px rgb(0 0 0 / 15%), 0 1px 2px rgb(0 0 0 / 5%);\n}\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _tippy = require('tippy.js');

var _tippy2 = _interopRequireDefault(_tippy);

var _daygrid = require('@fullcalendar/daygrid');

var _daygrid2 = _interopRequireDefault(_daygrid);

var _interaction = require('@fullcalendar/interaction');

var _interaction2 = _interopRequireDefault(_interaction);

var _resourceTimegrid = require('@fullcalendar/resource-timegrid');

var _resourceTimegrid2 = _interopRequireDefault(_resourceTimegrid);

var _zhTw = require('@fullcalendar/core/locales/zh-tw');

var _zhTw2 = _interopRequireDefault(_zhTw);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['currentBranch', 'selectDate', 'events', 'selectSingleDayMode', 'removedScheduleId'],
    data: function data() {
        return {
            calendarOptions: {
                locale: _zhTw2.default,
                schedulerLicenseKey: '',
                plugins: [_daygrid2.default, _interaction2.default, _resourceTimegrid2.default],
                initialView: 'dayGridMonth',
                initialDate: '2021-03-16',
                firstDay: 1,
                height: this.scaleHeight,
                allDaySlot: false,
                nowIndicator: true,
                droppable: false,
                eventResourceEditable: true,
                dayMaxEventRows: true,
                headerToolbar: {
                    left: 'chooseResource chooseDate prev,next',
                    right: 'copyClass allOnline refreshSchedule timeGridDay,timeGridWeek,dayGridMonth'
                },
                eventDisplay: 'block',
                customButtons: {
                    prev: {
                        icon: 'chevron-left',
                        click: this.clickPrev
                    },
                    next: {
                        icon: 'chevron-right',
                        click: this.clickNext
                    },
                    chooseResource: {
                        text: '',
                        click: this.clickChooseResource
                    },
                    chooseDate: {
                        text: '',
                        click: this.clickChooseDate
                    },
                    timeGridDay: {
                        text: '天',
                        click: this.timeGridDay
                    },
                    timeGridWeek: {
                        text: '週',
                        click: this.timeGridWeek
                    },
                    dayGridMonth: {
                        text: '月',
                        click: this.dayGridMonth
                    },
                    copyClass: {
                        text: '複製課表',
                        click: this.copyClass
                    },
                    allOnline: {
                        text: '全部上架',
                        click: this.allOnline
                    },
                    refreshSchedule: {
                        text: '刷新線上課表',
                        click: this.refreshSchedule
                    }
                },
                slotLabelFormat: [{ hour: '2-digit', minute: '2-digit', hour12: false }],
                views: {
                    dayGridMonth: {
                        dayMaxEventRows: 4
                    },
                    timeGridDay: {
                        dayHeaderFormat: { weekday: 'long' }
                    },
                    timeGridWeek: {
                        dayHeaderFormat: { weekday: 'short', month: 'long', day: 'numeric', omitCommas: true }
                    }
                },
                dayCellDidMount: function dayCellDidMount(arg) {
                    if (arg.view.type == 'dayGridMonth') {
                        if (arg.isPast) {
                            arg.el.style.backgroundColor = 'rgb(204, 204, 204)';
                        } else {
                            arg.el.style.backgroundColor = '#ffffff';
                        }
                    }
                },
                eventDidMount: this.handlerEventDidMount,
                eventClick: this.handleEventClick,
                dateClick: this.handleDateClick,
                events: []
            },
            scaleHeight: 800,
            currentMonth: 0,
            isClone: false
        };
    },
    created: function created() {
        this.calendarOptions.schedulerLicenseKey = this.fullCalendarKey();
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['isStudio']), {
        calendarApi: function calendarApi() {
            return this.$refs.fullCalendar.getApi();
        },
        nextMonth: function nextMonth() {
            return this.currentMonth == 12 ? 1 : Number(this.currentMonth) + 1;
        }
    }),
    watch: {
        'currentBranch': {
            handler: function handler(newVal) {
                this.calendarBtnView();
            },
            deep: true
        },
        'selectDate': {
            handler: function handler(newVal) {
                var date = (0, _moment2.default)(newVal).format('YYYY-MM-DD');
                this.goToDate(date);
                this.setSelectDate();
                if (this.selectSingleDayMode) {
                    this.timeGridDay();
                };
            }
        },
        'events': {
            handler: function handler(newVal) {
                this.setEventSource();
            },
            deep: true
        },
        removedScheduleId: function removedScheduleId(newVal) {
            if (newVal) {
                var event = this.calendarApi.getEventById(newVal);
                event.remove();
            };
        }
    },
    mounted: function mounted() {
        var vm = this;
        this.initUI();
        var contentWrapper = document.querySelector('#content-wrapper');
        var myObserver = new ResizeObserver(function (entries) {
            vm.scaleHeight = $(window).height() - ($('#content-wrapper > div.tabs').height() + $('#admin-header').height()) - 40;
            vm.calendarApi.setOption('height', vm.scaleHeight);
            vm.calendarApi.render();
        });
        myObserver.observe(contentWrapper);
    },

    methods: {
        initUI: function initUI() {
            this.calendarApi.destroy();
            this.calendarApi.render();
        },
        calendarBtnView: function calendarBtnView() {
            $('.fc-chooseResource-button').html(this.currentBranch.name);
            this.setSelectDate();
        },
        contentTimeFormat: function contentTimeFormat(time) {
            return (0, _moment2.default)(time).format('HH:mm');
        },
        contentDateFormat: function contentDateFormat(date) {
            return (0, _moment2.default)(date).format('YYYY/MM/DD');
        },
        setEventSource: function setEventSource() {
            this.calendarApi.removeAllEvents();
            this.calendarApi.addEventSource(this.events);
            this.calendarApi.render();
        },
        goToDate: function goToDate(date) {
            this.calendarApi.gotoDate(date);
        },
        getDate: function getDate() {
            return (0, _moment2.default)(this.calendarApi.getDate());
        },
        clickChooseResource: function clickChooseResource() {
            $('#v-choice-service-provider-modal').modal('show');
        },
        clickChooseDate: function clickChooseDate() {
            $('#v-choice-date-modal').modal('show');
        },
        timeGridDay: function timeGridDay() {
            this.calendarApi.changeView('timeGridDay');
            this.setSelectDate();
        },
        timeGridWeek: function timeGridWeek() {
            this.calendarApi.changeView('timeGridWeek');
            this.setSelectDate();
        },
        dayGridMonth: function dayGridMonth() {
            this.calendarApi.changeView('dayGridMonth');
            this.setSelectDate();
        },
        clickPrev: function clickPrev() {
            this.calendarApi.prev();
            this.setSelectDate();
            this.refreshCalendarEvent();
        },
        clickNext: function clickNext() {
            this.calendarApi.next();
            this.setSelectDate();
            this.refreshCalendarEvent();
        },
        refreshSchedule: function refreshSchedule() {
            window.Event.$emit("System.Schedule.Cache-Refresh");
        },
        allOnline: function allOnline() {
            var vm = this;
            var existEvent = this.calendarApi.getEvents();
            this.currentMonth = (0, _moment2.default)(this.getDate()).format('M');
            if (existEvent.length == 0) {
                $17.swal({
                    title: this.currentMonth + '月份無課表可上架',
                    text: '',
                    type: 'warning',
                    showCancelButton: false
                });
                return;
            };
            $17.swal({
                title: '是否將' + this.currentMonth + '月份課表全部上架？',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#5cb85c',
                confirmButtonText: '確認',
                cancelButtonText: '取消',
                closeOnConfirm: true
            }, function (isConfirm) {
                if (isConfirm) {
                    vm.excuteAllOnline();
                };
            });
        },
        excuteAllOnline: function excuteAllOnline() {
            var _this = this;

            $.blockUI();
            var existEvent = this.calendarApi.getEvents();
            var currentMonth = this.currentMonth;
            var eventIds = $.map(existEvent, function (obj, idx) {
                if (currentMonth === (0, _moment2.default)(obj.start).format('M')) {
                    return obj.id;
                }
            });
            this.$http.post('/webadmin/schedule/one_step_online', {
                schedule_ids: eventIds
            }).then(function (response) {
                $.unblockUI();
                $.notify('全部上架成功', { className: 'success', globalPosition: 'top center' });
                _this.refreshCalendarEvent(true);
            });
        },
        copyClass: function copyClass() {
            var query = (0, _extends3.default)({}, this.$route.query, {
                sub_page: 'class_copy',
                tab_hidden: true
            });
            if (this.currentBranch.id && this.isStudio) {
                query['branch_id'] = this.currentBranch.id;
            }
            this.$router.push({
                name: this.$route.name,
                query: query
            });
        },
        refreshCalendarEvent: function refreshCalendarEvent() {
            var isForceUpdate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            this.$emit('refresh-calendar-event', {
                start_date: (0, _moment2.default)(this.calendarApi.view.currentStart).format('YYYY-MM-DD'),
                end_date: (0, _moment2.default)(this.calendarApi.view.currentEnd).subtract(1, 'days').format('YYYY-MM-DD'),
                force_update: isForceUpdate
            });
        },
        setSelectDate: function setSelectDate() {
            var currentStart = this.calendarApi.view.currentStart;
            var currentEnd = this.calendarApi.view.currentEnd;
            var type = this.calendarApi.view.type;
            var dateStr = '';
            if (type == 'timeGridDay') {
                dateStr = (0, _moment2.default)(currentStart).format('YYYY-MM-DD');
            } else if (type == 'timeGridWeek') {
                dateStr = (0, _moment2.default)(currentStart).format('YYYY-MM-DD') + '~' + (0, _moment2.default)(currentEnd).subtract(1, 'days').format('YYYY-MM-DD');
            } else {
                dateStr = (0, _moment2.default)(currentStart).format('YYYY-MM');
            };
            $('.fc-chooseDate-button').html('<i class="fa fa-calendar"></i> ' + dateStr);
        },
        handlerEventDidMount: function handlerEventDidMount(info) {
            var tooltip = (0, _tippy2.default)(info.el, {
                content: function content(ref) {
                    var template = document.getElementById(info.event.id);
                    return template ? template.innerHTML : '';
                },

                duration: 0,
                animation: 'scale',
                arrow: true,
                placement: 'left',
                theme: 'light-border',
                allowHTML: true
            });
        },
        handleEventClick: function handleEventClick(info) {
            this.$emit('handle-event-click', info);
        },
        handleDateClick: function handleDateClick(info) {
            this.$emit('handle-date-click', info);
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div>\n    <full-calendar ref=\"fullCalendar\" :options=\"calendarOptions\">\n        <template slot=\"eventContent\" slot-scope=\"arg\">\n            <span>{{contentTimeFormat(arg.event.start)}}</span>\n            <span>{{arg.event.title}}</span>\n            <div :id=\"arg.event.id\" style=\"display: none;\">\n                <div>名稱：{{arg.event.title}}</div>\n                <div>日期：{{contentDateFormat(arg.event.start)}}</div>\n                <div>時間：{{contentTimeFormat(arg.event.start)}} - {{contentTimeFormat(arg.event.end)}}</div>\n                <div>場館：{{arg.event.extendedProps.branch_name}}</div>\n                <div>課程：{{arg.event.extendedProps.service_name}}</div>\n                <div>人員：{{arg.event.extendedProps.trainer_name}}</div>\n                <div>狀態：{{arg.event.extendedProps.status}}</div>\n            </div>\n        </template>\n    </full-calendar>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache[".tippy-box[data-animation=fade][data-state=hidden]{opacity:0}[data-tippy-root]{max-width:calc(100vw - 10px)}.tippy-box{position:relative;background-color:#333;color:#fff;border-radius:4px;font-size:14px;line-height:1.4;outline:0;transition-property:transform,visibility,opacity}.tippy-box[data-placement^=top]>.tippy-arrow{bottom:0}.tippy-box[data-placement^=top]>.tippy-arrow:before{bottom:-7px;left:0;border-width:8px 8px 0;border-top-color:initial;transform-origin:center top}.tippy-box[data-placement^=bottom]>.tippy-arrow{top:0}.tippy-box[data-placement^=bottom]>.tippy-arrow:before{top:-7px;left:0;border-width:0 8px 8px;border-bottom-color:initial;transform-origin:center bottom}.tippy-box[data-placement^=left]>.tippy-arrow{right:0}.tippy-box[data-placement^=left]>.tippy-arrow:before{border-width:8px 0 8px 8px;border-left-color:initial;right:-7px;transform-origin:center left}.tippy-box[data-placement^=right]>.tippy-arrow{left:0}.tippy-box[data-placement^=right]>.tippy-arrow:before{left:-7px;border-width:8px 8px 8px 0;border-right-color:initial;transform-origin:center right}.tippy-box[data-inertia][data-state=visible]{transition-timing-function:cubic-bezier(.54,1.5,.38,1.11)}.tippy-arrow{width:16px;height:16px;color:#333}.tippy-arrow:before{content:\"\";position:absolute;border-color:transparent;border-style:solid}.tippy-content{position:relative;padding:5px 9px;z-index:1}\n.tippy-box[data-theme~=light-border]{background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,8,16,.15);color:#333;box-shadow:0 4px 14px -2px rgba(0,8,16,.08)}.tippy-box[data-theme~=light-border]>.tippy-backdrop{background-color:#fff}.tippy-box[data-theme~=light-border]>.tippy-arrow:after,.tippy-box[data-theme~=light-border]>.tippy-svg-arrow:after{content:\"\";position:absolute;z-index:-1}.tippy-box[data-theme~=light-border]>.tippy-arrow:after{border-color:transparent;border-style:solid}.tippy-box[data-theme~=light-border][data-placement^=top]>.tippy-arrow:before{border-top-color:#fff}.tippy-box[data-theme~=light-border][data-placement^=top]>.tippy-arrow:after{border-top-color:rgba(0,8,16,.2);border-width:7px 7px 0;top:17px;left:1px}.tippy-box[data-theme~=light-border][data-placement^=top]>.tippy-svg-arrow>svg{top:16px}.tippy-box[data-theme~=light-border][data-placement^=top]>.tippy-svg-arrow:after{top:17px}.tippy-box[data-theme~=light-border][data-placement^=bottom]>.tippy-arrow:before{border-bottom-color:#fff;bottom:16px}.tippy-box[data-theme~=light-border][data-placement^=bottom]>.tippy-arrow:after{border-bottom-color:rgba(0,8,16,.2);border-width:0 7px 7px;bottom:17px;left:1px}.tippy-box[data-theme~=light-border][data-placement^=bottom]>.tippy-svg-arrow>svg{bottom:16px}.tippy-box[data-theme~=light-border][data-placement^=bottom]>.tippy-svg-arrow:after{bottom:17px}.tippy-box[data-theme~=light-border][data-placement^=left]>.tippy-arrow:before{border-left-color:#fff}.tippy-box[data-theme~=light-border][data-placement^=left]>.tippy-arrow:after{border-left-color:rgba(0,8,16,.2);border-width:7px 0 7px 7px;left:17px;top:1px}.tippy-box[data-theme~=light-border][data-placement^=left]>.tippy-svg-arrow>svg{left:11px}.tippy-box[data-theme~=light-border][data-placement^=left]>.tippy-svg-arrow:after{left:12px}.tippy-box[data-theme~=light-border][data-placement^=right]>.tippy-arrow:before{border-right-color:#fff;right:16px}.tippy-box[data-theme~=light-border][data-placement^=right]>.tippy-arrow:after{border-width:7px 7px 7px 0;right:17px;top:1px;border-right-color:rgba(0,8,16,.2)}.tippy-box[data-theme~=light-border][data-placement^=right]>.tippy-svg-arrow>svg{right:11px}.tippy-box[data-theme~=light-border][data-placement^=right]>.tippy-svg-arrow:after{right:12px}.tippy-box[data-theme~=light-border]>.tippy-svg-arrow{fill:#fff}.tippy-box[data-theme~=light-border]>.tippy-svg-arrow:after{background-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMCA2czEuNzk2LS4wMTMgNC42Ny0zLjYxNUM1Ljg1MS45IDYuOTMuMDA2IDggMGMxLjA3LS4wMDYgMi4xNDguODg3IDMuMzQzIDIuMzg1QzE0LjIzMyA2LjAwNSAxNiA2IDE2IDZIMHoiIGZpbGw9InJnYmEoMCwgOCwgMTYsIDAuMikiLz48L3N2Zz4=);background-size:16px 6px;width:16px;height:6px}\n.fc-icon,.fc-unselectable{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none}.fc-not-allowed,.fc-not-allowed .fc-event{cursor:not-allowed}.fc .fc-button:not(:disabled),.fc a[data-navlink],.fc-event.fc-event-draggable,.fc-event[href]{cursor:pointer}.fc-unselectable{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-touch-callout:none;-webkit-tap-highlight-color:transparent}.fc{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;font-size:1em}.fc,.fc *,.fc :after,.fc :before{box-sizing:border-box}.fc table{border-collapse:collapse;border-spacing:0;font-size:1em}.fc th{text-align:center}.fc td,.fc th{vertical-align:top;padding:0}.fc a[data-navlink]:hover{text-decoration:underline}.fc-direction-ltr{direction:ltr;text-align:left}.fc-direction-rtl{direction:rtl;text-align:right}.fc .fc-button,.fc-icon{font-weight:400;text-align:center;display:inline-block}.fc-theme-standard td,.fc-theme-standard th{border:1px solid #ddd;border:1px solid var(--fc-border-color,#ddd)}.fc-liquid-hack td,.fc-liquid-hack th{position:relative}@font-face{font-family:fcicons;src:url(\"data:application/x-font-ttf;charset=utf-8;base64,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\") format('truetype');font-weight:400;font-style:normal}.fc-icon{width:1em;height:1em;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;font-family:fcicons!important;speak:none;font-style:normal;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.fc .fc-scroller-harness-liquid,.fc .fc-scroller-liquid,.fc .fc-scrollgrid-liquid{height:100%}.fc-icon-chevron-left:before{content:\"\\e900\"}.fc-icon-chevron-right:before{content:\"\\e901\"}.fc-icon-chevrons-left:before{content:\"\\e902\"}.fc-icon-chevrons-right:before{content:\"\\e903\"}.fc-icon-minus-square:before{content:\"\\e904\"}.fc-icon-plus-square:before{content:\"\\e905\"}.fc-icon-x:before{content:\"\\e906\"}.fc .fc-button{overflow:visible;text-transform:none;margin:0;font-family:inherit}.fc .fc-button::-moz-focus-inner{padding:0;border-style:none}.fc .fc-button{-webkit-appearance:button;vertical-align:middle;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-color:transparent;border:1px solid transparent;padding:.4em .65em;font-size:1em;line-height:1.5;border-radius:.25em}.fc .fc-button:hover{text-decoration:none}.fc .fc-button:focus{outline:0;box-shadow:0 0 0 .2rem rgba(44,62,80,.25)}.fc .fc-button-primary:focus,.fc .fc-button-primary:not(:disabled).fc-button-active:focus,.fc .fc-button-primary:not(:disabled):active:focus{box-shadow:0 0 0 .2rem rgba(76,91,106,.5)}.fc .fc-button:disabled{opacity:.65}.fc .fc-button-primary{color:#fff;color:var(--fc-button-text-color,#fff);background-color:#2C3E50;background-color:var(--fc-button-bg-color,#2C3E50);border-color:#2C3E50;border-color:var(--fc-button-border-color,#2C3E50)}.fc .fc-button-primary:hover{color:#fff;color:var(--fc-button-text-color,#fff);background-color:#1e2b37;background-color:var(--fc-button-hover-bg-color,#1e2b37);border-color:#1a252f;border-color:var(--fc-button-hover-border-color,#1a252f)}.fc .fc-button-primary:disabled{color:#fff;color:var(--fc-button-text-color,#fff);background-color:#2C3E50;background-color:var(--fc-button-bg-color,#2C3E50);border-color:#2C3E50;border-color:var(--fc-button-border-color,#2C3E50)}.fc .fc-button-primary:not(:disabled).fc-button-active,.fc .fc-button-primary:not(:disabled):active{color:#fff;color:var(--fc-button-text-color,#fff);background-color:#1a252f;background-color:var(--fc-button-active-bg-color,#1a252f);border-color:#151e27;border-color:var(--fc-button-active-border-color,#151e27)}.fc .fc-button .fc-icon{vertical-align:middle;font-size:1.5em}.fc .fc-button-group{position:relative;display:-ms-inline-flexbox;display:inline-flex;vertical-align:middle}.fc .fc-button-group>.fc-button{position:relative;-ms-flex:1 1 auto;flex:1 1 auto}.fc .fc-button-group>.fc-button.fc-button-active,.fc .fc-button-group>.fc-button:active,.fc .fc-button-group>.fc-button:focus,.fc .fc-button-group>.fc-button:hover{z-index:1}.fc-direction-ltr .fc-button-group>.fc-button:not(:first-child){margin-left:-1px;border-top-left-radius:0;border-bottom-left-radius:0}.fc-direction-ltr .fc-button-group>.fc-button:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0}.fc-direction-rtl .fc-button-group>.fc-button:not(:first-child){margin-right:-1px;border-top-right-radius:0;border-bottom-right-radius:0}.fc-direction-rtl .fc-button-group>.fc-button:not(:last-child){border-top-left-radius:0;border-bottom-left-radius:0}.fc .fc-toolbar{display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-align:center;align-items:center}.fc .fc-toolbar.fc-header-toolbar{margin-bottom:1.5em}.fc .fc-toolbar.fc-footer-toolbar{margin-top:1.5em}.fc .fc-toolbar-title{font-size:1.75em;margin:0}.fc-direction-ltr .fc-toolbar>*>:not(:first-child){margin-left:.75em}.fc-direction-rtl .fc-toolbar>*>:not(:first-child){margin-right:.75em}.fc-direction-rtl .fc-toolbar-ltr{-ms-flex-direction:row-reverse;flex-direction:row-reverse}.fc .fc-scroller{-webkit-overflow-scrolling:touch;position:relative}.fc .fc-scroller-liquid-absolute{position:absolute;top:0;right:0;left:0;bottom:0}.fc .fc-scroller-harness{position:relative;overflow:hidden;direction:ltr}.fc-direction-rtl .fc-scroller-harness>.fc-scroller{direction:rtl}.fc-theme-standard .fc-scrollgrid{border:1px solid #ddd;border:1px solid var(--fc-border-color,#ddd)}.fc .fc-scrollgrid,.fc .fc-scrollgrid-section-footer>*,.fc .fc-scrollgrid-section-header>*{border-bottom-width:0}.fc .fc-scrollgrid,.fc .fc-scrollgrid table{width:100%;table-layout:fixed}.fc .fc-scrollgrid table{border-top-style:hidden;border-left-style:hidden;border-right-style:hidden}.fc .fc-scrollgrid{border-collapse:separate;border-right-width:0}.fc .fc-scrollgrid-section,.fc .fc-scrollgrid-section table,.fc .fc-scrollgrid-section>td{height:1px}.fc .fc-scrollgrid-section-liquid>td{height:100%}.fc .fc-scrollgrid-section>*{border-top-width:0;border-left-width:0}.fc .fc-scrollgrid-section-body table,.fc .fc-scrollgrid-section-footer table{border-bottom-style:hidden}.fc .fc-scrollgrid-section-sticky>*{background:var(--fc-page-bg-color,#fff);position:-webkit-sticky;position:sticky;z-index:3}.fc .fc-scrollgrid-section-header.fc-scrollgrid-section-sticky>*{top:0}.fc .fc-scrollgrid-section-footer.fc-scrollgrid-section-sticky>*{bottom:0}.fc .fc-scrollgrid-sticky-shim{height:1px;margin-bottom:-1px}.fc-sticky{position:-webkit-sticky;position:sticky}.fc .fc-view-harness{-ms-flex-positive:1;flex-grow:1;position:relative}.fc .fc-bg-event,.fc .fc-highlight,.fc .fc-non-business,.fc .fc-view-harness-active>.fc-view{position:absolute;top:0;left:0;right:0;bottom:0}.fc .fc-col-header-cell-cushion{display:inline-block;padding:2px 4px}.fc .fc-non-business{background:rgba(215,215,215,.3);background:var(--fc-non-business-color,rgba(215,215,215,.3))}.fc .fc-bg-event{background:var(--fc-bg-event-color,#8fdf82);opacity:.3;opacity:var(--fc-bg-event-opacity,.3)}.fc .fc-bg-event .fc-event-title{margin:.5em;font-size:.85em;font-size:var(--fc-small-font-size,.85em);font-style:italic}.fc .fc-highlight{background:rgba(188,232,241,.3);background:var(--fc-highlight-color,rgba(188,232,241,.3))}.fc .fc-cell-shaded,.fc .fc-day-disabled{background:rgba(208,208,208,.3);background:var(--fc-neutral-bg-color,rgba(208,208,208,.3))}a.fc-event,a.fc-event:hover{text-decoration:none}.fc-event .fc-event-main{position:relative;z-index:2}.fc-event-dragging:not(.fc-event-selected){opacity:.75}.fc-event-dragging.fc-event-selected{box-shadow:0 2px 7px rgba(0,0,0,.3)}.fc-event .fc-event-resizer{display:none;position:absolute;z-index:4}.fc-event-selected .fc-event-resizer,.fc-event:hover .fc-event-resizer,.fc-h-event{display:block}.fc-event-selected .fc-event-resizer{border-radius:4px;border-radius:calc(var(--fc-event-resizer-dot-total-width,8px)/ 2);border-width:1px;border-width:var(--fc-event-resizer-dot-border-width,1px);width:8px;width:var(--fc-event-resizer-dot-total-width,8px);height:8px;height:var(--fc-event-resizer-dot-total-width,8px);border-style:solid;border-color:inherit;background:var(--fc-page-bg-color,#fff)}.fc-event-selected .fc-event-resizer:before{content:'';position:absolute;top:-20px;left:-20px;right:-20px;bottom:-20px}.fc-event-selected:after,.fc-event-selected:before{content:\"\";position:absolute}.fc-event-selected{box-shadow:0 2px 5px rgba(0,0,0,.2)}.fc-event-selected:before{z-index:3;top:0;left:0;right:0;bottom:0}.fc-event-selected:after{background:rgba(0,0,0,.25);background:var(--fc-event-selected-overlay-color,rgba(0,0,0,.25));z-index:1;top:-1px;left:-1px;right:-1px;bottom:-1px}.fc-h-event{border:1px solid #3788d8;border:1px solid var(--fc-event-border-color,#3788d8);background-color:#3788d8;background-color:var(--fc-event-bg-color,#3788d8)}.fc-h-event .fc-event-main{color:#fff;color:var(--fc-event-text-color,#fff)}.fc-h-event .fc-event-main-frame{display:-ms-flexbox;display:flex}.fc-h-event .fc-event-time{max-width:100%;overflow:hidden}.fc-h-event .fc-event-title-container{-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1;min-width:0}.fc-h-event .fc-event-title{display:inline-block;vertical-align:top;left:0;right:0;max-width:100%;overflow:hidden}.fc-h-event.fc-event-selected:before{top:-10px;bottom:-10px}.fc-direction-ltr .fc-daygrid-block-event:not(.fc-event-start),.fc-direction-rtl .fc-daygrid-block-event:not(.fc-event-end){border-top-left-radius:0;border-bottom-left-radius:0;border-left-width:0}.fc-direction-ltr .fc-daygrid-block-event:not(.fc-event-end),.fc-direction-rtl .fc-daygrid-block-event:not(.fc-event-start){border-top-right-radius:0;border-bottom-right-radius:0;border-right-width:0}.fc-h-event:not(.fc-event-selected) .fc-event-resizer{top:0;bottom:0;width:8px;width:var(--fc-event-resizer-thickness,8px)}.fc-direction-ltr .fc-h-event:not(.fc-event-selected) .fc-event-resizer-start,.fc-direction-rtl .fc-h-event:not(.fc-event-selected) .fc-event-resizer-end{cursor:w-resize;left:-4px;left:calc(var(--fc-event-resizer-thickness,8px)/ -2)}.fc-direction-ltr .fc-h-event:not(.fc-event-selected) .fc-event-resizer-end,.fc-direction-rtl .fc-h-event:not(.fc-event-selected) .fc-event-resizer-start{cursor:e-resize;right:-4px;right:calc(var(--fc-event-resizer-thickness,8px)/ -2)}.fc-h-event.fc-event-selected .fc-event-resizer{top:50%;margin-top:-4px;margin-top:calc(var(--fc-event-resizer-dot-total-width,8px)/ -2)}.fc-direction-ltr .fc-h-event.fc-event-selected .fc-event-resizer-start,.fc-direction-rtl .fc-h-event.fc-event-selected .fc-event-resizer-end{left:-4px;left:calc(var(--fc-event-resizer-dot-total-width,8px)/ -2)}.fc-direction-ltr .fc-h-event.fc-event-selected .fc-event-resizer-end,.fc-direction-rtl .fc-h-event.fc-event-selected .fc-event-resizer-start{right:-4px;right:calc(var(--fc-event-resizer-dot-total-width,8px)/ -2)}.fc .fc-popover{position:absolute;z-index:9999;box-shadow:0 2px 6px rgba(0,0,0,.15)}.fc .fc-popover-header{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-align:center;align-items:center;padding:3px 4px}.fc .fc-popover-title{margin:0 2px}.fc .fc-popover-close{cursor:pointer;opacity:.65;font-size:1.1em}.fc-theme-standard .fc-popover{border:1px solid #ddd;border:1px solid var(--fc-border-color,#ddd);background:var(--fc-page-bg-color,#fff)}.fc-theme-standard .fc-popover-header{background:rgba(208,208,208,.3);background:var(--fc-neutral-bg-color,rgba(208,208,208,.3))}\n:root{--fc-daygrid-event-dot-width:8px}.fc-daygrid-day-events:after,.fc-daygrid-day-events:before,.fc-daygrid-day-frame:after,.fc-daygrid-day-frame:before,.fc-daygrid-event-harness:after,.fc-daygrid-event-harness:before{content:\"\";clear:both;display:table}.fc .fc-daygrid-body{position:relative;z-index:1}.fc .fc-daygrid-day.fc-day-today{background-color:rgba(255,220,40,.15);background-color:var(--fc-today-bg-color,rgba(255,220,40,.15))}.fc .fc-daygrid-day-frame{position:relative;min-height:100%}.fc .fc-daygrid-day-top{display:-ms-flexbox;display:flex;-ms-flex-direction:row-reverse;flex-direction:row-reverse}.fc .fc-day-other .fc-daygrid-day-top{opacity:.3}.fc .fc-daygrid-day-number{position:relative;z-index:4;padding:4px}.fc .fc-daygrid-day-events{margin-top:1px}.fc .fc-daygrid-body-balanced .fc-daygrid-day-events{position:absolute;left:0;right:0}.fc .fc-daygrid-body-unbalanced .fc-daygrid-day-events{position:relative;min-height:2em}.fc .fc-daygrid-body-natural .fc-daygrid-day-events{margin-bottom:1em}.fc .fc-daygrid-event-harness{position:relative}.fc .fc-daygrid-event-harness-abs{position:absolute;top:0;left:0;right:0}.fc .fc-daygrid-bg-harness{position:absolute;top:0;bottom:0}.fc .fc-daygrid-day-bg .fc-non-business{z-index:1}.fc .fc-daygrid-day-bg .fc-bg-event{z-index:2}.fc .fc-daygrid-day-bg .fc-highlight{z-index:3}.fc .fc-daygrid-event{z-index:6;margin-top:1px}.fc .fc-daygrid-event.fc-event-mirror{z-index:7}.fc .fc-daygrid-day-bottom{font-size:.85em;padding:2px 3px 0}.fc .fc-daygrid-day-bottom:before{content:\"\";clear:both;display:table}.fc .fc-daygrid-more-link{position:relative;z-index:4;cursor:pointer}.fc .fc-daygrid-week-number{position:absolute;z-index:5;top:0;padding:2px;min-width:1.5em;text-align:center;background-color:rgba(208,208,208,.3);background-color:var(--fc-neutral-bg-color,rgba(208,208,208,.3));color:grey;color:var(--fc-neutral-text-color,grey)}.fc .fc-more-popover .fc-popover-body{min-width:220px;padding:10px}.fc-direction-ltr .fc-daygrid-event.fc-event-start,.fc-direction-rtl .fc-daygrid-event.fc-event-end{margin-left:2px}.fc-direction-ltr .fc-daygrid-event.fc-event-end,.fc-direction-rtl .fc-daygrid-event.fc-event-start{margin-right:2px}.fc-direction-ltr .fc-daygrid-week-number{left:0;border-radius:0 0 3px}.fc-direction-rtl .fc-daygrid-week-number{right:0;border-radius:0 0 0 3px}.fc-liquid-hack .fc-daygrid-day-frame{position:static}.fc-daygrid-event{position:relative;white-space:nowrap;border-radius:3px;font-size:.85em;font-size:var(--fc-small-font-size,.85em)}.fc-daygrid-block-event .fc-event-time{font-weight:700}.fc-daygrid-block-event .fc-event-time,.fc-daygrid-block-event .fc-event-title{padding:1px}.fc-daygrid-dot-event{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;padding:2px 0}.fc-daygrid-dot-event .fc-event-title{-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1;min-width:0;overflow:hidden;font-weight:700}.fc-daygrid-dot-event.fc-event-mirror,.fc-daygrid-dot-event:hover{background:rgba(0,0,0,.1)}.fc-daygrid-dot-event.fc-event-selected:before{top:-10px;bottom:-10px}.fc-daygrid-event-dot{margin:0 4px;box-sizing:content-box;width:0;height:0;border:4px solid #3788d8;border:calc(var(--fc-daygrid-event-dot-width,8px)/ 2) solid var(--fc-event-border-color,#3788d8);border-radius:4px;border-radius:calc(var(--fc-daygrid-event-dot-width,8px)/ 2)}.fc-direction-ltr .fc-daygrid-event .fc-event-time{margin-right:3px}.fc-direction-rtl .fc-daygrid-event .fc-event-time{margin-left:3px}\n.fc-v-event{display:block;border:1px solid #3788d8;border:1px solid var(--fc-event-border-color,#3788d8);background-color:#3788d8;background-color:var(--fc-event-bg-color,#3788d8)}.fc-v-event .fc-event-main{color:#fff;color:var(--fc-event-text-color,#fff);height:100%}.fc-v-event .fc-event-main-frame{height:100%;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}.fc-v-event .fc-event-time{-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;max-height:100%;overflow:hidden}.fc-v-event .fc-event-title-container{-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1;min-height:0}.fc-v-event .fc-event-title{top:0;bottom:0;max-height:100%;overflow:hidden}.fc-v-event:not(.fc-event-start){border-top-width:0;border-top-left-radius:0;border-top-right-radius:0}.fc-v-event:not(.fc-event-end){border-bottom-width:0;border-bottom-left-radius:0;border-bottom-right-radius:0}.fc-v-event.fc-event-selected:before{left:-10px;right:-10px}.fc-v-event .fc-event-resizer-start{cursor:n-resize}.fc-v-event .fc-event-resizer-end{cursor:s-resize}.fc-v-event:not(.fc-event-selected) .fc-event-resizer{height:8px;height:var(--fc-event-resizer-thickness,8px);left:0;right:0}.fc-v-event:not(.fc-event-selected) .fc-event-resizer-start{top:-4px;top:calc(var(--fc-event-resizer-thickness,8px)/ -2)}.fc-v-event:not(.fc-event-selected) .fc-event-resizer-end{bottom:-4px;bottom:calc(var(--fc-event-resizer-thickness,8px)/ -2)}.fc-v-event.fc-event-selected .fc-event-resizer{left:50%;margin-left:-4px;margin-left:calc(var(--fc-event-resizer-dot-total-width,8px)/ -2)}.fc-v-event.fc-event-selected .fc-event-resizer-start{top:-4px;top:calc(var(--fc-event-resizer-dot-total-width,8px)/ -2)}.fc-v-event.fc-event-selected .fc-event-resizer-end{bottom:-4px;bottom:calc(var(--fc-event-resizer-dot-total-width,8px)/ -2)}.fc .fc-timegrid .fc-daygrid-body{z-index:2}.fc .fc-timegrid-axis-chunk>table,.fc .fc-timegrid-body,.fc .fc-timegrid-slots{position:relative;z-index:1}.fc .fc-timegrid-divider{padding:0 0 2px}.fc .fc-timegrid-body{min-height:100%}.fc .fc-timegrid-axis-chunk{position:relative}.fc .fc-timegrid-slot{height:1.5em;border-bottom:0}.fc .fc-timegrid-slot:empty:before{content:'\\00a0'}.fc .fc-timegrid-slot-minor{border-top-style:dotted}.fc .fc-timegrid-slot-label-cushion{display:inline-block;white-space:nowrap}.fc .fc-timegrid-slot-label{vertical-align:middle}.fc .fc-timegrid-axis-cushion,.fc .fc-timegrid-slot-label-cushion{padding:0 4px}.fc .fc-timegrid-axis-frame-liquid{height:100%}.fc .fc-timegrid-axis-frame{overflow:hidden;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:end;justify-content:flex-end}.fc .fc-timegrid-axis-cushion{max-width:60px;-ms-flex-negative:0;flex-shrink:0}.fc-direction-ltr .fc-timegrid-slot-label-frame{text-align:right}.fc-direction-rtl .fc-timegrid-slot-label-frame{text-align:left}.fc-liquid-hack .fc-timegrid-axis-frame-liquid{height:auto;position:absolute;top:0;right:0;bottom:0;left:0}.fc .fc-timegrid-col.fc-day-today{background-color:rgba(255,220,40,.15);background-color:var(--fc-today-bg-color,rgba(255,220,40,.15))}.fc .fc-timegrid-col-frame{min-height:100%;position:relative}.fc-media-screen.fc-liquid-hack .fc-timegrid-col-frame{height:auto;position:absolute;top:0;right:0;bottom:0;left:0}.fc-media-screen .fc-timegrid-cols{position:absolute;top:0;left:0;right:0;bottom:0}.fc-media-screen .fc-timegrid-cols>table{height:100%}.fc-media-screen .fc-timegrid-col-bg,.fc-media-screen .fc-timegrid-col-events,.fc-media-screen .fc-timegrid-now-indicator-container{position:absolute;top:0;left:0;right:0}.fc .fc-timegrid-col-bg{z-index:2}.fc .fc-timegrid-col-bg .fc-non-business{z-index:1}.fc .fc-timegrid-col-bg .fc-bg-event{z-index:2}.fc .fc-timegrid-col-bg .fc-highlight,.fc .fc-timegrid-col-events{z-index:3}.fc .fc-timegrid-bg-harness{position:absolute;left:0;right:0}.fc .fc-timegrid-now-indicator-container{bottom:0;overflow:hidden}.fc-direction-ltr .fc-timegrid-col-events{margin:0 2.5% 0 2px}.fc-direction-rtl .fc-timegrid-col-events{margin:0 2px 0 2.5%}.fc-timegrid-event-harness{position:absolute}.fc-timegrid-event-harness>.fc-timegrid-event{position:absolute;top:0;bottom:0;left:0;right:0}.fc-timegrid-event-harness-inset .fc-timegrid-event,.fc-timegrid-event.fc-event-mirror,.fc-timegrid-more-link{box-shadow:0 0 0 1px #fff;box-shadow:0 0 0 1px var(--fc-page-bg-color,#fff)}.fc-timegrid-event,.fc-timegrid-more-link{font-size:.85em;font-size:var(--fc-small-font-size,.85em);border-radius:3px}.fc-timegrid-event{margin-bottom:1px}.fc-timegrid-event .fc-event-main{padding:1px 1px 0}.fc-timegrid-event .fc-event-time{white-space:nowrap;font-size:.85em;font-size:var(--fc-small-font-size,.85em);margin-bottom:1px}.fc-timegrid-event-short .fc-event-main-frame{-ms-flex-direction:row;flex-direction:row;overflow:hidden}.fc-timegrid-event-short .fc-event-time:after{content:'\\00a0-\\00a0'}.fc-timegrid-event-short .fc-event-title{font-size:.85em;font-size:var(--fc-small-font-size,.85em)}.fc-timegrid-more-link{position:absolute;z-index:9999;color:inherit;color:var(--fc-more-link-text-color,inherit);background:var(--fc-more-link-bg-color,#d0d0d0);cursor:pointer;margin-bottom:1px}.fc-timegrid-more-link-inner{padding:3px 2px;top:0}.fc-direction-ltr .fc-timegrid-more-link{right:0}.fc-direction-rtl .fc-timegrid-more-link{left:0}.fc .fc-timegrid-now-indicator-line{position:absolute;z-index:4;left:0;right:0;border-style:solid;border-color:red;border-color:var(--fc-now-indicator-color,red);border-width:1px 0 0}.fc .fc-timegrid-now-indicator-arrow{position:absolute;z-index:4;margin-top:-5px;border-style:solid;border-color:red;border-color:var(--fc-now-indicator-color,red)}.fc-direction-ltr .fc-timegrid-now-indicator-arrow{left:0;border-width:5px 0 5px 6px;border-top-color:transparent;border-bottom-color:transparent}.fc-direction-rtl .fc-timegrid-now-indicator-arrow{right:0;border-width:5px 6px 5px 0;border-top-color:transparent;border-bottom-color:transparent}\n\n.tippy-box[data-theme~='nonbusiness-hour'] {\n  color: black;\n  background-color: white;\n  border: 1px solid black;\n}\n.fc .fc-timegrid-now-indicator-line {\n    z-index: 2;\n}\n.fc-event-main{\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n}\n.fc .fc-button-primary {\n    border: 1px solid;\n    background-color: #f5f5f5;\n    background-image: linear-gradient(to bottom,#fff,#e6e6e6);\n    background-repeat: repeat-x;\n    border-color: rgba(0,0,0,.1) rgba(0,0,0,.1) rgba(0,0,0,.25);\n    color: #333;\n    text-shadow: 0 1px 1px rgb(255 255 255 / 75%);\n    box-shadow: inset 0 1px 0 rgb(255 255 255 / 20%), 0 1px 2px rgb(0 0 0 / 5%);\n}\n.fc .fc-button-primary:hover {\n    color: #333;\n    text-decoration: none;\n}\n.fc .fc-button-primary:not(:disabled).fc-button-active, .fc .fc-button-primary:not(:disabled):active{\n    background-color: #ccc;\n    color: #333;\n    background-image: none;\n    box-shadow: inset 0 2px 4px rgb(0 0 0 / 15%), 0 1px 2px rgb(0 0 0 / 5%);\n}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-4c36a547", module.exports)
  } else {
    hotAPI.update("_v-4c36a547", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"@fullcalendar/core/locales/zh-tw":5,"@fullcalendar/daygrid":8,"@fullcalendar/interaction":9,"@fullcalendar/resource-timegrid":13,"babel-runtime/helpers/extends":66,"moment":727,"tippy.js":780,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1181:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            selectSingleDayMode: false,
            ajaxing: false,
            date: {
                start_date: '',
                end_date: ''
            },
            currentBranch: {
                id: 0,
                name: ''
            },
            events: [],
            eventDate: '',
            locationName: '',
            removedScheduleId: 0,
            initModalData: {
                studioId: null,
                branchId: null,
                scheduleId: null,
                defaultStart: null,
                mode: '',
                location: ''
            },
            isCloneRunning: false
        };
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId', 'isBranch', 'isStudio', 'isSeventeen']), (0, _vuex.mapState)('filters', ['selected_studio_id', 'selected_branch_id']), {
        activeStudioId: function activeStudioId() {
            if (this.isSeventeen) {
                return this.selected_studio_id;
            }
            return this.studioId;
        }
    }),
    mounted: function mounted() {
        var vm = this;
        this.date.start_date = moment().format('YYYY-MM-DD');
    },

    watch: {
        isSeventeen: function isSeventeen(newVal) {
            $('#v-choice-service-provider-modal').modal('show');
            $('.fc-chooseResource-button').html('選擇場館');
        },
        isBranch: function isBranch(newVal) {
            if (newVal) {
                $('.fc-chooseResource-button').css('display', 'none');
                this.currentBranch.id = this.branchId;
                this.getScheduleEvent(this.date);
            };
        },
        currentBranch: function currentBranch(newVal) {
            this.getScheduleEvent(this.date);
        }
    },
    methods: {
        getScheduleEvent: function getScheduleEvent(date) {
            var _this = this;

            if (!this.currentBranch.id) return;
            var params = {
                date: moment(date.start_date).format('YYYY-MM'),
                branch_id: this.currentBranch.id
            };
            $.blockUI();
            this.$http.get('/webadmin/schedule/events', { params: params }).then(function (response) {
                _this.events = response.data.events;
                _this.locationName = response.data.location_name;
                _this.isCloneRunning = response.data.clone_running;
                $.unblockUI();
            }, function (error) {
                $.unblockUI();
            });
        },
        getBindBranch: function getBindBranch(data) {
            this.currentBranch = data;
        },
        getDaySelected: function getDaySelected(date) {
            this.getBindDate({ start_date: date.date });
            this.selectSingleDayMode = true;
        },
        getBindDate: function getBindDate(date) {
            this.selectSingleDayMode = false;
            if (!moment(date.start_date).isSame(this.date.start_date, 'month') && this.date.start_date || date.force_update) {
                this.getScheduleEvent(date);
            };
            if (date.hasOwnProperty('force_update')) {
                delete date.force_update;
            }
            this.date = (0, _extends3.default)({}, this.date, date);
        },
        removeSingleEvent: function removeSingleEvent(scheduleId) {
            this.removeSingleEvent = scheduleId;
        },
        fetchDateEvent: function fetchDateEvent(info) {
            this.initModalData = {
                studioId: this.activeStudioId,
                branchId: this.currentBranch.id,
                scheduleId: null,
                defaultStart: moment(info.date),
                mode: 'add',
                location: this.locationName
            };
            this.eventDate = moment(info.date).format('YYYY-MM-DD');
            $("#schedule-modal").modal('show');
        },
        fetchEvent: function fetchEvent(info) {
            this.initModalData = {
                studioId: this.activeStudioId,
                branchId: this.currentBranch.id,
                scheduleId: info.event.id,
                defaultStart: null,
                mode: 'update',
                location: ''
            };
            this.eventDate = moment(info.event.start).format('YYYY-MM-DD');
            $("#schedule-modal").modal('show');
        },
        fresh: function fresh() {
            this.getScheduleEvent({ start_date: this.date.start_date });
            this.clear();
        },
        clear: function clear() {
            this.initModalData = {
                studioId: null,
                branchId: null,
                scheduleId: null,
                defaultStart: null,
                mode: '',
                location: ''
            };
        }
    },
    destroyed: function destroyed() {
        $('#v-choice-service-provider-modal').unbind('hide.bs.modal');
        $('#v-choice-service-provider-modal').unbind('shown.bs.modal');
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"m-right-10\">\n    <schedule-calendar :select-single-day-mode=\"selectSingleDayMode\" :current-branch=\"currentBranch\" :events=\"events\" :select-date=\"date.start_date\" :removed-schedule-id=\"removedScheduleId\" @handle-date-click=\"fetchDateEvent\" @handle-event-click=\"fetchEvent\" @refresh-calendar-event=\"getBindDate\"></schedule-calendar>\n\n        \n    <choice-service-provider-modal @fetch-bind-branch=\"getBindBranch\" :is-choose-service-provider=\"false\" :current-branch=\"currentBranch\"></choice-service-provider-modal>\n    <choice-date-modal :current-date=\"date.start_date\" @fetch-select-date=\"getDaySelected\"></choice-date-modal>\n\n    <webadmin-schedule-edit-modal :studio-id=\"initModalData.studioId\" :branch-id=\"initModalData.branchId\" :mode=\"initModalData.mode\" :default-start=\"initModalData.defaultStart\" :schedule-id=\"initModalData.scheduleId\" @remove-single-schedule=\"removeSingleEvent\" v-on:clear=\"clear\" v-on:fresh=\"fresh\"></webadmin-schedule-edit-modal>\n\n    <refresh-schedule-helper :default-branch=\"currentBranch\"></refresh-schedule-helper>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-4af65999", module.exports)
  } else {
    hotAPI.update("_v-4af65999", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vuex":803}],1182:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert(".tippy-box[data-animation=fade][data-state=hidden]{opacity:0}[data-tippy-root]{max-width:calc(100vw - 10px)}.tippy-box{position:relative;background-color:#333;color:#fff;border-radius:4px;font-size:14px;line-height:1.4;outline:0;transition-property:transform,visibility,opacity}.tippy-box[data-placement^=top]>.tippy-arrow{bottom:0}.tippy-box[data-placement^=top]>.tippy-arrow:before{bottom:-7px;left:0;border-width:8px 8px 0;border-top-color:initial;transform-origin:center top}.tippy-box[data-placement^=bottom]>.tippy-arrow{top:0}.tippy-box[data-placement^=bottom]>.tippy-arrow:before{top:-7px;left:0;border-width:0 8px 8px;border-bottom-color:initial;transform-origin:center bottom}.tippy-box[data-placement^=left]>.tippy-arrow{right:0}.tippy-box[data-placement^=left]>.tippy-arrow:before{border-width:8px 0 8px 8px;border-left-color:initial;right:-7px;transform-origin:center left}.tippy-box[data-placement^=right]>.tippy-arrow{left:0}.tippy-box[data-placement^=right]>.tippy-arrow:before{left:-7px;border-width:8px 8px 8px 0;border-right-color:initial;transform-origin:center right}.tippy-box[data-inertia][data-state=visible]{transition-timing-function:cubic-bezier(.54,1.5,.38,1.11)}.tippy-arrow{width:16px;height:16px;color:#333}.tippy-arrow:before{content:\"\";position:absolute;border-color:transparent;border-style:solid}.tippy-content{position:relative;padding:5px 9px;z-index:1}\n.tippy-box[data-theme~=light-border]{background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,8,16,.15);color:#333;box-shadow:0 4px 14px -2px rgba(0,8,16,.08)}.tippy-box[data-theme~=light-border]>.tippy-backdrop{background-color:#fff}.tippy-box[data-theme~=light-border]>.tippy-arrow:after,.tippy-box[data-theme~=light-border]>.tippy-svg-arrow:after{content:\"\";position:absolute;z-index:-1}.tippy-box[data-theme~=light-border]>.tippy-arrow:after{border-color:transparent;border-style:solid}.tippy-box[data-theme~=light-border][data-placement^=top]>.tippy-arrow:before{border-top-color:#fff}.tippy-box[data-theme~=light-border][data-placement^=top]>.tippy-arrow:after{border-top-color:rgba(0,8,16,.2);border-width:7px 7px 0;top:17px;left:1px}.tippy-box[data-theme~=light-border][data-placement^=top]>.tippy-svg-arrow>svg{top:16px}.tippy-box[data-theme~=light-border][data-placement^=top]>.tippy-svg-arrow:after{top:17px}.tippy-box[data-theme~=light-border][data-placement^=bottom]>.tippy-arrow:before{border-bottom-color:#fff;bottom:16px}.tippy-box[data-theme~=light-border][data-placement^=bottom]>.tippy-arrow:after{border-bottom-color:rgba(0,8,16,.2);border-width:0 7px 7px;bottom:17px;left:1px}.tippy-box[data-theme~=light-border][data-placement^=bottom]>.tippy-svg-arrow>svg{bottom:16px}.tippy-box[data-theme~=light-border][data-placement^=bottom]>.tippy-svg-arrow:after{bottom:17px}.tippy-box[data-theme~=light-border][data-placement^=left]>.tippy-arrow:before{border-left-color:#fff}.tippy-box[data-theme~=light-border][data-placement^=left]>.tippy-arrow:after{border-left-color:rgba(0,8,16,.2);border-width:7px 0 7px 7px;left:17px;top:1px}.tippy-box[data-theme~=light-border][data-placement^=left]>.tippy-svg-arrow>svg{left:11px}.tippy-box[data-theme~=light-border][data-placement^=left]>.tippy-svg-arrow:after{left:12px}.tippy-box[data-theme~=light-border][data-placement^=right]>.tippy-arrow:before{border-right-color:#fff;right:16px}.tippy-box[data-theme~=light-border][data-placement^=right]>.tippy-arrow:after{border-width:7px 7px 7px 0;right:17px;top:1px;border-right-color:rgba(0,8,16,.2)}.tippy-box[data-theme~=light-border][data-placement^=right]>.tippy-svg-arrow>svg{right:11px}.tippy-box[data-theme~=light-border][data-placement^=right]>.tippy-svg-arrow:after{right:12px}.tippy-box[data-theme~=light-border]>.tippy-svg-arrow{fill:#fff}.tippy-box[data-theme~=light-border]>.tippy-svg-arrow:after{background-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMCA2czEuNzk2LS4wMTMgNC42Ny0zLjYxNUM1Ljg1MS45IDYuOTMuMDA2IDggMGMxLjA3LS4wMDYgMi4xNDguODg3IDMuMzQzIDIuMzg1QzE0LjIzMyA2LjAwNSAxNiA2IDE2IDZIMHoiIGZpbGw9InJnYmEoMCwgOCwgMTYsIDAuMikiLz48L3N2Zz4=);background-size:16px 6px;width:16px;height:6px}\n.fc-icon,.fc-unselectable{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none}.fc-not-allowed,.fc-not-allowed .fc-event{cursor:not-allowed}.fc .fc-button:not(:disabled),.fc a[data-navlink],.fc-event.fc-event-draggable,.fc-event[href]{cursor:pointer}.fc-unselectable{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-touch-callout:none;-webkit-tap-highlight-color:transparent}.fc{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;font-size:1em}.fc,.fc *,.fc :after,.fc :before{box-sizing:border-box}.fc table{border-collapse:collapse;border-spacing:0;font-size:1em}.fc th{text-align:center}.fc td,.fc th{vertical-align:top;padding:0}.fc a[data-navlink]:hover{text-decoration:underline}.fc-direction-ltr{direction:ltr;text-align:left}.fc-direction-rtl{direction:rtl;text-align:right}.fc .fc-button,.fc-icon{font-weight:400;text-align:center;display:inline-block}.fc-theme-standard td,.fc-theme-standard th{border:1px solid #ddd;border:1px solid var(--fc-border-color,#ddd)}.fc-liquid-hack td,.fc-liquid-hack th{position:relative}@font-face{font-family:fcicons;src:url(\"data:application/x-font-ttf;charset=utf-8;base64,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\") format('truetype');font-weight:400;font-style:normal}.fc-icon{width:1em;height:1em;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;font-family:fcicons!important;speak:none;font-style:normal;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.fc .fc-scroller-harness-liquid,.fc .fc-scroller-liquid,.fc .fc-scrollgrid-liquid{height:100%}.fc-icon-chevron-left:before{content:\"\\e900\"}.fc-icon-chevron-right:before{content:\"\\e901\"}.fc-icon-chevrons-left:before{content:\"\\e902\"}.fc-icon-chevrons-right:before{content:\"\\e903\"}.fc-icon-minus-square:before{content:\"\\e904\"}.fc-icon-plus-square:before{content:\"\\e905\"}.fc-icon-x:before{content:\"\\e906\"}.fc .fc-button{overflow:visible;text-transform:none;margin:0;font-family:inherit}.fc .fc-button::-moz-focus-inner{padding:0;border-style:none}.fc .fc-button{-webkit-appearance:button;vertical-align:middle;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-color:transparent;border:1px solid transparent;padding:.4em .65em;font-size:1em;line-height:1.5;border-radius:.25em}.fc .fc-button:hover{text-decoration:none}.fc .fc-button:focus{outline:0;box-shadow:0 0 0 .2rem rgba(44,62,80,.25)}.fc .fc-button-primary:focus,.fc .fc-button-primary:not(:disabled).fc-button-active:focus,.fc .fc-button-primary:not(:disabled):active:focus{box-shadow:0 0 0 .2rem rgba(76,91,106,.5)}.fc .fc-button:disabled{opacity:.65}.fc .fc-button-primary{color:#fff;color:var(--fc-button-text-color,#fff);background-color:#2C3E50;background-color:var(--fc-button-bg-color,#2C3E50);border-color:#2C3E50;border-color:var(--fc-button-border-color,#2C3E50)}.fc .fc-button-primary:hover{color:#fff;color:var(--fc-button-text-color,#fff);background-color:#1e2b37;background-color:var(--fc-button-hover-bg-color,#1e2b37);border-color:#1a252f;border-color:var(--fc-button-hover-border-color,#1a252f)}.fc .fc-button-primary:disabled{color:#fff;color:var(--fc-button-text-color,#fff);background-color:#2C3E50;background-color:var(--fc-button-bg-color,#2C3E50);border-color:#2C3E50;border-color:var(--fc-button-border-color,#2C3E50)}.fc .fc-button-primary:not(:disabled).fc-button-active,.fc .fc-button-primary:not(:disabled):active{color:#fff;color:var(--fc-button-text-color,#fff);background-color:#1a252f;background-color:var(--fc-button-active-bg-color,#1a252f);border-color:#151e27;border-color:var(--fc-button-active-border-color,#151e27)}.fc .fc-button .fc-icon{vertical-align:middle;font-size:1.5em}.fc .fc-button-group{position:relative;display:-ms-inline-flexbox;display:inline-flex;vertical-align:middle}.fc .fc-button-group>.fc-button{position:relative;-ms-flex:1 1 auto;flex:1 1 auto}.fc .fc-button-group>.fc-button.fc-button-active,.fc .fc-button-group>.fc-button:active,.fc .fc-button-group>.fc-button:focus,.fc .fc-button-group>.fc-button:hover{z-index:1}.fc-direction-ltr .fc-button-group>.fc-button:not(:first-child){margin-left:-1px;border-top-left-radius:0;border-bottom-left-radius:0}.fc-direction-ltr .fc-button-group>.fc-button:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0}.fc-direction-rtl .fc-button-group>.fc-button:not(:first-child){margin-right:-1px;border-top-right-radius:0;border-bottom-right-radius:0}.fc-direction-rtl .fc-button-group>.fc-button:not(:last-child){border-top-left-radius:0;border-bottom-left-radius:0}.fc .fc-toolbar{display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-align:center;align-items:center}.fc .fc-toolbar.fc-header-toolbar{margin-bottom:1.5em}.fc .fc-toolbar.fc-footer-toolbar{margin-top:1.5em}.fc .fc-toolbar-title{font-size:1.75em;margin:0}.fc-direction-ltr .fc-toolbar>*>:not(:first-child){margin-left:.75em}.fc-direction-rtl .fc-toolbar>*>:not(:first-child){margin-right:.75em}.fc-direction-rtl .fc-toolbar-ltr{-ms-flex-direction:row-reverse;flex-direction:row-reverse}.fc .fc-scroller{-webkit-overflow-scrolling:touch;position:relative}.fc .fc-scroller-liquid-absolute{position:absolute;top:0;right:0;left:0;bottom:0}.fc .fc-scroller-harness{position:relative;overflow:hidden;direction:ltr}.fc-direction-rtl .fc-scroller-harness>.fc-scroller{direction:rtl}.fc-theme-standard .fc-scrollgrid{border:1px solid #ddd;border:1px solid var(--fc-border-color,#ddd)}.fc .fc-scrollgrid,.fc .fc-scrollgrid-section-footer>*,.fc .fc-scrollgrid-section-header>*{border-bottom-width:0}.fc .fc-scrollgrid,.fc .fc-scrollgrid table{width:100%;table-layout:fixed}.fc .fc-scrollgrid table{border-top-style:hidden;border-left-style:hidden;border-right-style:hidden}.fc .fc-scrollgrid{border-collapse:separate;border-right-width:0}.fc .fc-scrollgrid-section,.fc .fc-scrollgrid-section table,.fc .fc-scrollgrid-section>td{height:1px}.fc .fc-scrollgrid-section-liquid>td{height:100%}.fc .fc-scrollgrid-section>*{border-top-width:0;border-left-width:0}.fc .fc-scrollgrid-section-body table,.fc .fc-scrollgrid-section-footer table{border-bottom-style:hidden}.fc .fc-scrollgrid-section-sticky>*{background:var(--fc-page-bg-color,#fff);position:-webkit-sticky;position:sticky;z-index:3}.fc .fc-scrollgrid-section-header.fc-scrollgrid-section-sticky>*{top:0}.fc .fc-scrollgrid-section-footer.fc-scrollgrid-section-sticky>*{bottom:0}.fc .fc-scrollgrid-sticky-shim{height:1px;margin-bottom:-1px}.fc-sticky{position:-webkit-sticky;position:sticky}.fc .fc-view-harness{-ms-flex-positive:1;flex-grow:1;position:relative}.fc .fc-bg-event,.fc .fc-highlight,.fc .fc-non-business,.fc .fc-view-harness-active>.fc-view{position:absolute;top:0;left:0;right:0;bottom:0}.fc .fc-col-header-cell-cushion{display:inline-block;padding:2px 4px}.fc .fc-non-business{background:rgba(215,215,215,.3);background:var(--fc-non-business-color,rgba(215,215,215,.3))}.fc .fc-bg-event{background:var(--fc-bg-event-color,#8fdf82);opacity:.3;opacity:var(--fc-bg-event-opacity,.3)}.fc .fc-bg-event .fc-event-title{margin:.5em;font-size:.85em;font-size:var(--fc-small-font-size,.85em);font-style:italic}.fc .fc-highlight{background:rgba(188,232,241,.3);background:var(--fc-highlight-color,rgba(188,232,241,.3))}.fc .fc-cell-shaded,.fc .fc-day-disabled{background:rgba(208,208,208,.3);background:var(--fc-neutral-bg-color,rgba(208,208,208,.3))}a.fc-event,a.fc-event:hover{text-decoration:none}.fc-event .fc-event-main{position:relative;z-index:2}.fc-event-dragging:not(.fc-event-selected){opacity:.75}.fc-event-dragging.fc-event-selected{box-shadow:0 2px 7px rgba(0,0,0,.3)}.fc-event .fc-event-resizer{display:none;position:absolute;z-index:4}.fc-event-selected .fc-event-resizer,.fc-event:hover .fc-event-resizer,.fc-h-event{display:block}.fc-event-selected .fc-event-resizer{border-radius:4px;border-radius:calc(var(--fc-event-resizer-dot-total-width,8px)/ 2);border-width:1px;border-width:var(--fc-event-resizer-dot-border-width,1px);width:8px;width:var(--fc-event-resizer-dot-total-width,8px);height:8px;height:var(--fc-event-resizer-dot-total-width,8px);border-style:solid;border-color:inherit;background:var(--fc-page-bg-color,#fff)}.fc-event-selected .fc-event-resizer:before{content:'';position:absolute;top:-20px;left:-20px;right:-20px;bottom:-20px}.fc-event-selected:after,.fc-event-selected:before{content:\"\";position:absolute}.fc-event-selected{box-shadow:0 2px 5px rgba(0,0,0,.2)}.fc-event-selected:before{z-index:3;top:0;left:0;right:0;bottom:0}.fc-event-selected:after{background:rgba(0,0,0,.25);background:var(--fc-event-selected-overlay-color,rgba(0,0,0,.25));z-index:1;top:-1px;left:-1px;right:-1px;bottom:-1px}.fc-h-event{border:1px solid #3788d8;border:1px solid var(--fc-event-border-color,#3788d8);background-color:#3788d8;background-color:var(--fc-event-bg-color,#3788d8)}.fc-h-event .fc-event-main{color:#fff;color:var(--fc-event-text-color,#fff)}.fc-h-event .fc-event-main-frame{display:-ms-flexbox;display:flex}.fc-h-event .fc-event-time{max-width:100%;overflow:hidden}.fc-h-event .fc-event-title-container{-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1;min-width:0}.fc-h-event .fc-event-title{display:inline-block;vertical-align:top;left:0;right:0;max-width:100%;overflow:hidden}.fc-h-event.fc-event-selected:before{top:-10px;bottom:-10px}.fc-direction-ltr .fc-daygrid-block-event:not(.fc-event-start),.fc-direction-rtl .fc-daygrid-block-event:not(.fc-event-end){border-top-left-radius:0;border-bottom-left-radius:0;border-left-width:0}.fc-direction-ltr .fc-daygrid-block-event:not(.fc-event-end),.fc-direction-rtl .fc-daygrid-block-event:not(.fc-event-start){border-top-right-radius:0;border-bottom-right-radius:0;border-right-width:0}.fc-h-event:not(.fc-event-selected) .fc-event-resizer{top:0;bottom:0;width:8px;width:var(--fc-event-resizer-thickness,8px)}.fc-direction-ltr .fc-h-event:not(.fc-event-selected) .fc-event-resizer-start,.fc-direction-rtl .fc-h-event:not(.fc-event-selected) .fc-event-resizer-end{cursor:w-resize;left:-4px;left:calc(var(--fc-event-resizer-thickness,8px)/ -2)}.fc-direction-ltr .fc-h-event:not(.fc-event-selected) .fc-event-resizer-end,.fc-direction-rtl .fc-h-event:not(.fc-event-selected) .fc-event-resizer-start{cursor:e-resize;right:-4px;right:calc(var(--fc-event-resizer-thickness,8px)/ -2)}.fc-h-event.fc-event-selected .fc-event-resizer{top:50%;margin-top:-4px;margin-top:calc(var(--fc-event-resizer-dot-total-width,8px)/ -2)}.fc-direction-ltr .fc-h-event.fc-event-selected .fc-event-resizer-start,.fc-direction-rtl .fc-h-event.fc-event-selected .fc-event-resizer-end{left:-4px;left:calc(var(--fc-event-resizer-dot-total-width,8px)/ -2)}.fc-direction-ltr .fc-h-event.fc-event-selected .fc-event-resizer-end,.fc-direction-rtl .fc-h-event.fc-event-selected .fc-event-resizer-start{right:-4px;right:calc(var(--fc-event-resizer-dot-total-width,8px)/ -2)}.fc .fc-popover{position:absolute;z-index:9999;box-shadow:0 2px 6px rgba(0,0,0,.15)}.fc .fc-popover-header{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-align:center;align-items:center;padding:3px 4px}.fc .fc-popover-title{margin:0 2px}.fc .fc-popover-close{cursor:pointer;opacity:.65;font-size:1.1em}.fc-theme-standard .fc-popover{border:1px solid #ddd;border:1px solid var(--fc-border-color,#ddd);background:var(--fc-page-bg-color,#fff)}.fc-theme-standard .fc-popover-header{background:rgba(208,208,208,.3);background:var(--fc-neutral-bg-color,rgba(208,208,208,.3))}\n:root{--fc-daygrid-event-dot-width:8px}.fc-daygrid-day-events:after,.fc-daygrid-day-events:before,.fc-daygrid-day-frame:after,.fc-daygrid-day-frame:before,.fc-daygrid-event-harness:after,.fc-daygrid-event-harness:before{content:\"\";clear:both;display:table}.fc .fc-daygrid-body{position:relative;z-index:1}.fc .fc-daygrid-day.fc-day-today{background-color:rgba(255,220,40,.15);background-color:var(--fc-today-bg-color,rgba(255,220,40,.15))}.fc .fc-daygrid-day-frame{position:relative;min-height:100%}.fc .fc-daygrid-day-top{display:-ms-flexbox;display:flex;-ms-flex-direction:row-reverse;flex-direction:row-reverse}.fc .fc-day-other .fc-daygrid-day-top{opacity:.3}.fc .fc-daygrid-day-number{position:relative;z-index:4;padding:4px}.fc .fc-daygrid-day-events{margin-top:1px}.fc .fc-daygrid-body-balanced .fc-daygrid-day-events{position:absolute;left:0;right:0}.fc .fc-daygrid-body-unbalanced .fc-daygrid-day-events{position:relative;min-height:2em}.fc .fc-daygrid-body-natural .fc-daygrid-day-events{margin-bottom:1em}.fc .fc-daygrid-event-harness{position:relative}.fc .fc-daygrid-event-harness-abs{position:absolute;top:0;left:0;right:0}.fc .fc-daygrid-bg-harness{position:absolute;top:0;bottom:0}.fc .fc-daygrid-day-bg .fc-non-business{z-index:1}.fc .fc-daygrid-day-bg .fc-bg-event{z-index:2}.fc .fc-daygrid-day-bg .fc-highlight{z-index:3}.fc .fc-daygrid-event{z-index:6;margin-top:1px}.fc .fc-daygrid-event.fc-event-mirror{z-index:7}.fc .fc-daygrid-day-bottom{font-size:.85em;padding:2px 3px 0}.fc .fc-daygrid-day-bottom:before{content:\"\";clear:both;display:table}.fc .fc-daygrid-more-link{position:relative;z-index:4;cursor:pointer}.fc .fc-daygrid-week-number{position:absolute;z-index:5;top:0;padding:2px;min-width:1.5em;text-align:center;background-color:rgba(208,208,208,.3);background-color:var(--fc-neutral-bg-color,rgba(208,208,208,.3));color:grey;color:var(--fc-neutral-text-color,grey)}.fc .fc-more-popover .fc-popover-body{min-width:220px;padding:10px}.fc-direction-ltr .fc-daygrid-event.fc-event-start,.fc-direction-rtl .fc-daygrid-event.fc-event-end{margin-left:2px}.fc-direction-ltr .fc-daygrid-event.fc-event-end,.fc-direction-rtl .fc-daygrid-event.fc-event-start{margin-right:2px}.fc-direction-ltr .fc-daygrid-week-number{left:0;border-radius:0 0 3px}.fc-direction-rtl .fc-daygrid-week-number{right:0;border-radius:0 0 0 3px}.fc-liquid-hack .fc-daygrid-day-frame{position:static}.fc-daygrid-event{position:relative;white-space:nowrap;border-radius:3px;font-size:.85em;font-size:var(--fc-small-font-size,.85em)}.fc-daygrid-block-event .fc-event-time{font-weight:700}.fc-daygrid-block-event .fc-event-time,.fc-daygrid-block-event .fc-event-title{padding:1px}.fc-daygrid-dot-event{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;padding:2px 0}.fc-daygrid-dot-event .fc-event-title{-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1;min-width:0;overflow:hidden;font-weight:700}.fc-daygrid-dot-event.fc-event-mirror,.fc-daygrid-dot-event:hover{background:rgba(0,0,0,.1)}.fc-daygrid-dot-event.fc-event-selected:before{top:-10px;bottom:-10px}.fc-daygrid-event-dot{margin:0 4px;box-sizing:content-box;width:0;height:0;border:4px solid #3788d8;border:calc(var(--fc-daygrid-event-dot-width,8px)/ 2) solid var(--fc-event-border-color,#3788d8);border-radius:4px;border-radius:calc(var(--fc-daygrid-event-dot-width,8px)/ 2)}.fc-direction-ltr .fc-daygrid-event .fc-event-time{margin-right:3px}.fc-direction-rtl .fc-daygrid-event .fc-event-time{margin-left:3px}\n.fc-v-event{display:block;border:1px solid #3788d8;border:1px solid var(--fc-event-border-color,#3788d8);background-color:#3788d8;background-color:var(--fc-event-bg-color,#3788d8)}.fc-v-event .fc-event-main{color:#fff;color:var(--fc-event-text-color,#fff);height:100%}.fc-v-event .fc-event-main-frame{height:100%;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}.fc-v-event .fc-event-time{-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;max-height:100%;overflow:hidden}.fc-v-event .fc-event-title-container{-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1;min-height:0}.fc-v-event .fc-event-title{top:0;bottom:0;max-height:100%;overflow:hidden}.fc-v-event:not(.fc-event-start){border-top-width:0;border-top-left-radius:0;border-top-right-radius:0}.fc-v-event:not(.fc-event-end){border-bottom-width:0;border-bottom-left-radius:0;border-bottom-right-radius:0}.fc-v-event.fc-event-selected:before{left:-10px;right:-10px}.fc-v-event .fc-event-resizer-start{cursor:n-resize}.fc-v-event .fc-event-resizer-end{cursor:s-resize}.fc-v-event:not(.fc-event-selected) .fc-event-resizer{height:8px;height:var(--fc-event-resizer-thickness,8px);left:0;right:0}.fc-v-event:not(.fc-event-selected) .fc-event-resizer-start{top:-4px;top:calc(var(--fc-event-resizer-thickness,8px)/ -2)}.fc-v-event:not(.fc-event-selected) .fc-event-resizer-end{bottom:-4px;bottom:calc(var(--fc-event-resizer-thickness,8px)/ -2)}.fc-v-event.fc-event-selected .fc-event-resizer{left:50%;margin-left:-4px;margin-left:calc(var(--fc-event-resizer-dot-total-width,8px)/ -2)}.fc-v-event.fc-event-selected .fc-event-resizer-start{top:-4px;top:calc(var(--fc-event-resizer-dot-total-width,8px)/ -2)}.fc-v-event.fc-event-selected .fc-event-resizer-end{bottom:-4px;bottom:calc(var(--fc-event-resizer-dot-total-width,8px)/ -2)}.fc .fc-timegrid .fc-daygrid-body{z-index:2}.fc .fc-timegrid-axis-chunk>table,.fc .fc-timegrid-body,.fc .fc-timegrid-slots{position:relative;z-index:1}.fc .fc-timegrid-divider{padding:0 0 2px}.fc .fc-timegrid-body{min-height:100%}.fc .fc-timegrid-axis-chunk{position:relative}.fc .fc-timegrid-slot{height:1.5em;border-bottom:0}.fc .fc-timegrid-slot:empty:before{content:'\\00a0'}.fc .fc-timegrid-slot-minor{border-top-style:dotted}.fc .fc-timegrid-slot-label-cushion{display:inline-block;white-space:nowrap}.fc .fc-timegrid-slot-label{vertical-align:middle}.fc .fc-timegrid-axis-cushion,.fc .fc-timegrid-slot-label-cushion{padding:0 4px}.fc .fc-timegrid-axis-frame-liquid{height:100%}.fc .fc-timegrid-axis-frame{overflow:hidden;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:end;justify-content:flex-end}.fc .fc-timegrid-axis-cushion{max-width:60px;-ms-flex-negative:0;flex-shrink:0}.fc-direction-ltr .fc-timegrid-slot-label-frame{text-align:right}.fc-direction-rtl .fc-timegrid-slot-label-frame{text-align:left}.fc-liquid-hack .fc-timegrid-axis-frame-liquid{height:auto;position:absolute;top:0;right:0;bottom:0;left:0}.fc .fc-timegrid-col.fc-day-today{background-color:rgba(255,220,40,.15);background-color:var(--fc-today-bg-color,rgba(255,220,40,.15))}.fc .fc-timegrid-col-frame{min-height:100%;position:relative}.fc-media-screen.fc-liquid-hack .fc-timegrid-col-frame{height:auto;position:absolute;top:0;right:0;bottom:0;left:0}.fc-media-screen .fc-timegrid-cols{position:absolute;top:0;left:0;right:0;bottom:0}.fc-media-screen .fc-timegrid-cols>table{height:100%}.fc-media-screen .fc-timegrid-col-bg,.fc-media-screen .fc-timegrid-col-events,.fc-media-screen .fc-timegrid-now-indicator-container{position:absolute;top:0;left:0;right:0}.fc .fc-timegrid-col-bg{z-index:2}.fc .fc-timegrid-col-bg .fc-non-business{z-index:1}.fc .fc-timegrid-col-bg .fc-bg-event{z-index:2}.fc .fc-timegrid-col-bg .fc-highlight,.fc .fc-timegrid-col-events{z-index:3}.fc .fc-timegrid-bg-harness{position:absolute;left:0;right:0}.fc .fc-timegrid-now-indicator-container{bottom:0;overflow:hidden}.fc-direction-ltr .fc-timegrid-col-events{margin:0 2.5% 0 2px}.fc-direction-rtl .fc-timegrid-col-events{margin:0 2px 0 2.5%}.fc-timegrid-event-harness{position:absolute}.fc-timegrid-event-harness>.fc-timegrid-event{position:absolute;top:0;bottom:0;left:0;right:0}.fc-timegrid-event-harness-inset .fc-timegrid-event,.fc-timegrid-event.fc-event-mirror,.fc-timegrid-more-link{box-shadow:0 0 0 1px #fff;box-shadow:0 0 0 1px var(--fc-page-bg-color,#fff)}.fc-timegrid-event,.fc-timegrid-more-link{font-size:.85em;font-size:var(--fc-small-font-size,.85em);border-radius:3px}.fc-timegrid-event{margin-bottom:1px}.fc-timegrid-event .fc-event-main{padding:1px 1px 0}.fc-timegrid-event .fc-event-time{white-space:nowrap;font-size:.85em;font-size:var(--fc-small-font-size,.85em);margin-bottom:1px}.fc-timegrid-event-short .fc-event-main-frame{-ms-flex-direction:row;flex-direction:row;overflow:hidden}.fc-timegrid-event-short .fc-event-time:after{content:'\\00a0-\\00a0'}.fc-timegrid-event-short .fc-event-title{font-size:.85em;font-size:var(--fc-small-font-size,.85em)}.fc-timegrid-more-link{position:absolute;z-index:9999;color:inherit;color:var(--fc-more-link-text-color,inherit);background:var(--fc-more-link-bg-color,#d0d0d0);cursor:pointer;margin-bottom:1px}.fc-timegrid-more-link-inner{padding:3px 2px;top:0}.fc-direction-ltr .fc-timegrid-more-link{right:0}.fc-direction-rtl .fc-timegrid-more-link{left:0}.fc .fc-timegrid-now-indicator-line{position:absolute;z-index:4;left:0;right:0;border-style:solid;border-color:red;border-color:var(--fc-now-indicator-color,red);border-width:1px 0 0}.fc .fc-timegrid-now-indicator-arrow{position:absolute;z-index:4;margin-top:-5px;border-style:solid;border-color:red;border-color:var(--fc-now-indicator-color,red)}.fc-direction-ltr .fc-timegrid-now-indicator-arrow{left:0;border-width:5px 0 5px 6px;border-top-color:transparent;border-bottom-color:transparent}.fc-direction-rtl .fc-timegrid-now-indicator-arrow{right:0;border-width:5px 6px 5px 0;border-top-color:transparent;border-bottom-color:transparent}\n\n.tippy-box[data-theme~='nonbusiness-hour'] {\n  color: black;\n  background-color: white;\n  border: 1px solid black;\n}\nth.fc-col-header-cell.fc-resource.service-provider-resource {\n    background: #333;\n    color: #fff;\n    padding: 5px 0;\n    cursor: pointer;\n}\n.fc .fc-timegrid-now-indicator-line {\n    z-index: 2;\n}\n.fc .fc-timegrid-col-bg .branch-block-time{\n    z-index: 3 !important;\n}\n.fc-media-screen .service-booking-event {\n    background: rgb(255, 255, 255);\n    border: 2px solid gray;\n}\n.fc-media-screen .service-provider-block-time {\n    border: 2px solid gray;\n    border-color: gray !important;\n    background-color: rgb(214, 214, 214);\n    z-index: 2;\n}\n.service-booking-event .fc-event-main{\n    color: rgb(0, 0, 0);\n}\n.fc-v-event .fc-event-main{\n    overflow: hidden;\n    white-space: normal;\n    text-overflow: ellipsis;\n}\n.service-booking-event-status {\n    position: absolute;\n    width: 6px;\n    top: 0;\n    right: auto;\n    bottom: 0;\n    left: 0;\n}\n.fc .fc-button-primary {\n    border: 1px solid;\n    background-color: #f5f5f5;\n    background-image: linear-gradient(to bottom,#fff,#e6e6e6);\n    background-repeat: repeat-x;\n    border-color: rgba(0,0,0,.1) rgba(0,0,0,.1) rgba(0,0,0,.25);\n    color: #333;\n    text-shadow: 0 1px 1px rgb(255 255 255 / 75%);\n    box-shadow: inset 0 1px 0 rgb(255 255 255 / 20%), 0 1px 2px rgb(0 0 0 / 5%);\n}\n.fc .fc-button-primary:hover {\n    color: #333;\n    text-decoration: none;\n}\n.fc .fc-button-primary:not(:disabled).fc-button-active, .fc .fc-button-primary:not(:disabled):active{\n    background-color: #ccc;\n    color: #333;\n    background-image: none;\n    box-shadow: inset 0 2px 4px rgb(0 0 0 / 15%), 0 1px 2px rgb(0 0 0 / 5%);\n}\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _tippy = require('tippy.js');

var _tippy2 = _interopRequireDefault(_tippy);

var _daygrid = require('@fullcalendar/daygrid');

var _daygrid2 = _interopRequireDefault(_daygrid);

var _interaction = require('@fullcalendar/interaction');

var _interaction2 = _interopRequireDefault(_interaction);

var _resourceTimegrid = require('@fullcalendar/resource-timegrid');

var _resourceTimegrid2 = _interopRequireDefault(_resourceTimegrid);

var _zhTw = require('@fullcalendar/core/locales/zh-tw');

var _zhTw2 = _interopRequireDefault(_zhTw);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['currentBranch', 'selectDate', 'serviceProvider', 'events'],
    data: function data() {
        return {
            calendarOptions: {
                locale: _zhTw2.default,
                schedulerLicenseKey: '',
                plugins: [_daygrid2.default, _interaction2.default, _resourceTimegrid2.default],
                initialView: 'resourceTimeGridDay',
                initialDate: '2021-03-16',
                height: this.scaleHeight,
                allDaySlot: false,
                nowIndicator: true,
                eventResourceEditable: false,
                droppable: false,
                headerToolbar: {
                    left: 'chooseResource chooseDate prev,next refresh',
                    right: 'resourceTimeGridDay,resourceTimeGridThreeDay,resourceTimeGridWeek'
                },
                customButtons: {
                    prev: {
                        icon: 'chevron-left',
                        click: this.clickPrev
                    },
                    next: {
                        icon: 'chevron-right',
                        click: this.clickNext
                    },
                    refresh: {
                        text: '',
                        click: this.resetCalendar
                    },
                    chooseResource: {
                        text: '',
                        click: this.clickChooseResource
                    },
                    chooseDate: {
                        text: '',
                        click: this.clickChooseDate
                    },
                    resourceTimeGridDay: {
                        text: '天',
                        click: this.clickDay
                    },
                    resourceTimeGridThreeDay: {
                        text: '3 天',
                        click: this.clickThreeDays
                    },
                    resourceTimeGridWeek: {
                        text: '週',
                        click: this.clickWeek
                    }
                },
                slotLabelFormat: [{ hour: '2-digit', minute: '2-digit', hour12: false }],
                views: {
                    resourceTimeGridDay: {},
                    resourceTimeGridThreeDay: {
                        dayHeaderFormat: { weekday: 'short' },
                        type: 'resourceTimeGrid',
                        duration: { days: 3 },
                        buttonText: '3 天'
                    },
                    resourceTimeGridWeek: {
                        dayHeaderFormat: { weekday: 'short' }
                    }
                },
                resourceOrder: 'sort',
                resources: [],
                eventDidMount: this.handlerEventDidMount,
                resourceLabelDidMount: this.handlerResourceLabelDidMount,
                eventClick: this.handleEventClick,
                dateClick: this.handleDateClick,
                events: []
            },
            scaleHeight: 800
        };
    },
    created: function created() {
        this.calendarOptions.schedulerLicenseKey = this.fullCalendarKey();
    },

    computed: {
        calendarApi: function calendarApi() {
            return this.$refs.fullCalendar.getApi();
        },
        serviceProviderResource: function serviceProviderResource() {
            var result = [];
            this.serviceProvider.forEach(function (item) {
                if (item.isChecked) {
                    result.push({
                        id: item.id,
                        title: item.name
                    });
                }
            });
            return result;
        }
    },
    watch: {
        'currentBranch': {
            handler: function handler(newVal) {
                $('.fc-chooseResource-button').html('<i class="fa fa-user-plus"></i> ' + newVal.name);
            },
            deep: true
        },
        'selectDate': {
            handler: function handler(newVal) {
                var date = (0, _moment2.default)(newVal).format('YYYY-MM-DD');
                this.goToDate(date);
                this.setSelectDate();
                this.emitDateChange();
            }
        },
        'serviceProvider': {
            handler: function handler(newVal) {
                var resources = this.calendarApi.getResources();
                resources.forEach(function (resource) {
                    resource.remove();
                });
                this.setCalendarResources();
            },
            deep: true
        }
    },
    mounted: function mounted() {
        var vm = this;
        this.initUI();
        var contentWrapper = document.querySelector('#content-wrapper');
        var myObserver = new ResizeObserver(function (entries) {
            vm.scaleHeight = $(window).height() - ($('#content-wrapper > div.tabs').height() + $('#admin-header').height()) - 40;
            vm.calendarApi.setOption('height', vm.scaleHeight);
            vm.calendarApi.render();
        });
        myObserver.observe(contentWrapper);
    },

    methods: {
        refreshCalendar: function refreshCalendar() {
            this.setCalendarResources();
            this.setEventSource();
        },
        initUI: function initUI() {
            this.calendarApi.destroy();
            this.calendarApi.render();
            $('.fc-refresh-button').html('<i class="fa fa-refresh"></i>');
            (0, _tippy2.default)('.fc-refresh-button', {
                content: '更新行事曆資訊',
                arrow: true,
                placement: 'right'
            });
        },
        contentTimeFormat: function contentTimeFormat(time) {
            return (0, _moment2.default)(time).format('HH:mm');
        },
        contentDateFormat: function contentDateFormat(date) {
            return (0, _moment2.default)(date).format('YYYY/MM/DD');
        },
        setCalendarResources: function setCalendarResources() {
            var _this = this;

            this.serviceProvider.forEach(function (item) {
                if (item.isChecked) {
                    _this.calendarApi.addResource({
                        id: item.role_relationship_id,
                        title: item.name,
                        sort: item.sort
                    });
                } else {
                    var resource = _this.calendarApi.getResourceById(item.role_relationship_id);
                    if (resource) {
                        resource.remove();
                    }
                }
            });
        },
        setEventSource: function setEventSource() {
            this.calendarApi.removeAllEvents();
            this.calendarApi.addEventSource(this.events.bookable_hours);
            this.calendarApi.addEventSource(this.events.block_hours);
            this.calendarApi.addEventSource(this.events.appointment_events);
            this.calendarApi.addEventSource(this.events.schedule_events);
            this.calendarApi.addEventSource(this.blockTimeConvertToFullCalendarEventObject(this.events.block_time_events));
            this.calendarApi.render();
        },
        updateSingleEventById: function updateSingleEventById(oldEventId, eventData) {
            var event = this.calendarApi.getEventById('service-booking-event-' + oldEventId);
            if (event) {
                event.remove();
            }
            this.calendarApi.addEventSource(eventData);
            this.calendarApi.render();
            $.unblockUI();
        },
        updateBlockTimeById: function updateBlockTimeById(oldEventId, eventData) {
            $.blockUI();
            this.removeBlockTimeById(oldEventId);
            this.calendarApi.addEventSource(this.blockTimeConvertToFullCalendarEventObject(eventData));
            this.calendarApi.render();
            $.unblockUI();
        },
        removeBlockTimeById: function removeBlockTimeById(oldEventId) {
            $.blockUI();
            var eventId = 'block-event-' + oldEventId;
            var currentView = this.calendarApi.view.type;
            var duration = 0;
            switch (currentView) {
                case 'resourceTimeGridDay':
                    duration = 1;break;
                case 'resourceTimeGridThreeDay':
                    duration = 3;break;
                case 'resourceTimeGridWeek':
                    duration = 7;break;
                default:
                    duration = 31;
            }
            for (var d = 0; d <= duration; d++) {
                var event = this.calendarApi.getEventById(eventId + '-' + d);
                if (event) {
                    event.remove();
                }
            }
            $.unblockUI();
        },
        blockTimeConvertToFullCalendarEventObject: function blockTimeConvertToFullCalendarEventObject(blockTimeEvents) {
            var events = [];
            var fullCalendarEndDate = (0, _moment2.default)(this.calendarApi.view.currentEnd);
            var fullCalendarStartDate = (0, _moment2.default)(this.calendarApi.view.currentStart);
            blockTimeEvents.forEach(function (blockTimeEvent) {
                var eventObj = {
                    id: 'block-event-' + blockTimeEvent.id,
                    start: (0, _moment2.default)(blockTimeEvent.start_date).format('YYYY-MM-DD') + ' ' + blockTimeEvent.start_time,
                    end: (0, _moment2.default)(blockTimeEvent.end_date).format('YYYY-MM-DD') + ' ' + blockTimeEvent.end_time,
                    description: blockTimeEvent.description,
                    blockTimeId: blockTimeEvent.id,
                    color: '#d6d6d6',
                    resourceId: Number(blockTimeEvent.role_relationship_id),
                    is_repeat: Number(blockTimeEvent.is_repeat),
                    className: 'service-provider-block-time',
                    textColor: '#000'
                };

                if (blockTimeEvent.is_repeat == 1) {
                    var sDate = (0, _moment2.default)(blockTimeEvent.start_date);
                    var eDate = (0, _moment2.default)(blockTimeEvent.end_date);
                    var index = 0;
                    for (var d = 0; fullCalendarEndDate.isAfter(sDate.format('YYYY-MM-DD')) && blockTimeEvent.end_status == 0 || (sDate.isBefore(eDate.format('YYYY-MM-DD')) || sDate.isSame(eDate.format('YYYY-MM-DD'))) && blockTimeEvent.end_status == 1; d++) {
                        var evnetStartDate = sDate.format('YYYY-MM-DD');
                        var isWithinCalendarViewPeriod = fullCalendarEndDate.isAfter(evnetStartDate) && fullCalendarStartDate.isBefore(evnetStartDate) || fullCalendarStartDate.isSame(evnetStartDate) || fullCalendarEndDate.isSame(evnetStartDate);
                        var e = (0, _extends3.default)({}, eventObj, {
                            id: eventObj.id + '-' + index,
                            start: evnetStartDate + ' ' + blockTimeEvent.start_time,
                            end: evnetStartDate + ' ' + blockTimeEvent.end_time
                        });
                        if (isWithinCalendarViewPeriod) {
                            if (Number(blockTimeEvent.monday) === 1 && sDate.day() === 1) {
                                events.push(e);
                            }
                            if (Number(blockTimeEvent.tuesday) === 1 && sDate.day() === 2) {
                                events.push(e);
                            }
                            if (Number(blockTimeEvent.wednesday) === 1 && sDate.day() === 3) {
                                events.push(e);
                            }
                            if (Number(blockTimeEvent.thursday) === 1 && sDate.day() === 4) {
                                events.push(e);
                            }
                            if (Number(blockTimeEvent.friday) === 1 && sDate.day() === 5) {
                                events.push(e);
                            }
                            if (Number(blockTimeEvent.saturday) === 1 && sDate.day() === 6) {
                                events.push(e);
                            }
                            if (Number(blockTimeEvent.sunday) === 1 && sDate.day() === 0) {
                                events.push(e);
                            }
                            index++;
                        }
                        sDate.add(1, 'days');
                    };
                } else {
                    eventObj.id = eventObj.id + '-0';
                    events.push(eventObj);
                };
            });
            return events;
        },
        goToDate: function goToDate(date) {
            this.calendarApi.gotoDate(date);
        },
        getDate: function getDate() {
            return (0, _moment2.default)(this.calendarApi.getDate()).format('YYYY-MM-DD');
        },
        resetCalendar: function resetCalendar() {
            this.$emit('update-calendar');
        },
        clickChooseResource: function clickChooseResource() {
            $('#v-choice-service-provider-modal').modal('show');
        },
        clickChooseDate: function clickChooseDate() {
            $('#v-choice-date-modal').modal('show');
        },
        clickDay: function clickDay() {
            this.calendarApi.changeView('resourceTimeGridDay');
            this.setSelectDate();
            this.emitDateChange();
        },
        clickThreeDays: function clickThreeDays() {
            this.calendarApi.changeView('resourceTimeGridThreeDay');
            this.setSelectDate();
            this.emitDateChange();
        },
        clickWeek: function clickWeek() {
            this.calendarApi.changeView('resourceTimeGridWeek');
            this.setSelectDate();
            this.emitDateChange();
        },
        clickPrev: function clickPrev() {
            this.calendarApi.prev();
            this.setSelectDate();
            this.emitDateChange();
        },
        clickNext: function clickNext() {
            this.calendarApi.next();
            this.setSelectDate();
            this.emitDateChange();
        },
        emitDateChange: function emitDateChange() {
            this.$emit('fetch-date-change', {
                start_date: (0, _moment2.default)(this.calendarApi.view.currentStart).format('YYYY-MM-DD'),
                end_date: (0, _moment2.default)(this.calendarApi.view.currentEnd).subtract(1, 'days').format('YYYY-MM-DD')
            });
        },
        setSelectDate: function setSelectDate(date) {
            var currentStart = this.calendarApi.view.currentStart;
            var currentEnd = this.calendarApi.view.currentEnd;
            var dateStr = '';
            if ((0, _moment2.default)(currentEnd).diff(currentStart, 'days') > 1) {
                dateStr = (0, _moment2.default)(currentStart).format('YYYY-MM-DD') + '~' + (0, _moment2.default)(currentEnd).subtract(1, 'days').format('MM-DD');
            } else {
                dateStr = (0, _moment2.default)(currentStart).format('YYYY-MM-DD');
            };
            $('.fc-chooseDate-button').html('<i class="fa fa-calendar"></i> ' + dateStr);
        },
        handlerResourceLabelDidMount: function handlerResourceLabelDidMount(info) {
            var vm = this;
            $(info.el).addClass('service-provider-resource');
            info.el.addEventListener('click', function () {
                vm.clickWeek();
                vm.$emit('select-single-resource', { id: info.resource._resource.id });
            });
        },
        handlerEventDidMount: function handlerEventDidMount(info) {
            if ($(info.el).hasClass('branch-block-time')) {
                var tooltip = (0, _tippy2.default)(info.el, {
                    content: '未營業時段',
                    followCursor: true,
                    plugins: [_tippy.followCursor],
                    duration: 0,
                    interactive: false,
                    arrow: false,
                    placement: 'left',
                    theme: 'nonbusiness-hour'
                });
            } else if ($(info.el).hasClass('unreserved')) {
                var _tooltip = (0, _tippy2.default)(info.el, {
                    content: '未開放預約時段',
                    followCursor: true,
                    plugins: [_tippy.followCursor],
                    duration: 0,
                    interactive: false,
                    arrow: false,
                    placement: 'left',
                    theme: 'nonbusiness-hour'
                });
            } else if ($(info.el).hasClass('service-booking-event') || $(info.el).hasClass('schedule-event') || $(info.el).hasClass('service-provider-block-time')) {
                var _tooltip2 = (0, _tippy2.default)(info.el, {
                    content: function content(ref) {
                        var template = document.getElementById(info.event.id);
                        return template.innerHTML;
                    },

                    duration: 0,
                    animation: 'scale',
                    arrow: true,
                    placement: 'left',
                    theme: 'light-border',
                    allowHTML: true
                });
            }
        },
        handleEventClick: function handleEventClick(info) {
            this.$emit('handle-event-click', info);
        },
        handleDateClick: function handleDateClick(info) {
            this.$emit('handle-date-click', info);
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div>\n    <full-calendar ref=\"fullCalendar\" :options=\"calendarOptions\">\n        <template slot=\"eventContent\" slot-scope=\"arg\">\n            <div v-if=\"arg.event.classNames.includes('service-booking-event')\">\n                <div class=\"service-booking-event-status\" :style=\"{'background-color':arg.event.extendedProps.status.color}\"></div>\n                <div style=\"margin-left: 7px; color: black;\">\n                    <img v-if=\"arg.event.classNames.includes('walk-in')\" style=\"width:15px\" src=\"/images/walking.png\">\n                    <strong>{{ arg.event.extendedProps.customer.name }}</strong><br>\n                    <small>{{ contentTimeFormat(arg.event.start) }}</small> - <small>{{ contentTimeFormat(arg.event.end) }}</small> <br>\n                    <div v-for=\"service in arg.event.extendedProps.services\">\n                        <div>{{ service.name }}</div>\n                    </div>                    \n                </div>\n                <div style=\"display: none;\" :id=\"arg.event.id\">\n                    <div>客戶：{{arg.event.extendedProps.customer.name}}</div>\n                    <div>電話：{{arg.event.extendedProps.customer.phone}}</div>\n                    <div>時間：<small>{{ contentTimeFormat(arg.event.start) }}</small> - <small>{{ contentTimeFormat(arg.event.end) }}</small></div>\n                    <div>服務：\n                        <span v-if=\"arg.event.extendedProps.services.length == 1\">\n                            {{ arg.event.extendedProps.services[0].name }}\n                        </span>\n                        <ul v-else=\"\">\n                            <li v-for=\"(service, idx) in arg.event.extendedProps.services\">\n                                {{ service.name }}\n                            </li>\n                        </ul>\n                    </div>\n                    <div>狀態：{{arg.event.extendedProps.status.name}}</div>\n                </div>\n            </div>\n\n            <div v-if=\"arg.event.classNames.includes('schedule-event')\">\n                <strong>{{ contentTimeFormat(arg.event.start) }}</strong> - <strong>{{ contentTimeFormat(arg.event.end) }}</strong> <br>\n                <div>{{ arg.event.title }}</div>\n                <div style=\"display: none;\" :id=\"arg.event.id\">\n                    <div>名稱：{{ arg.event.title }}</div>\n                    <div>日期：{{ contentDateFormat(arg.event.start) }}</div>\n                    <div>時間：<span>{{ contentTimeFormat(arg.event.start) }}</span> - <span>{{ contentTimeFormat(arg.event.end) }}</span></div>\n                    <div>場館：{{arg.event.extendedProps.branch_name}}</div>\n                    <div>課程：{{arg.event.extendedProps.service_name}}</div>\n                    <div>人員：{{arg.event.extendedProps.trainer_name}}</div>\n                    <div>狀態：{{arg.event.extendedProps.status}}</div>\n                </div>\n            </div>\n\n            <div v-if=\"arg.event.classNames.includes('service-provider-block-time')\">\n                <strong><i class=\"fa fa-ban\"></i></strong>\n                <strong v-if=\"arg.event.extendedProps.is_repeat\"><i class=\"fa fa-refresh\"></i></strong>\n                <b v-if=\"arg.event.extendedProps.description\">{{ arg.event.extendedProps.description }}</b>\n                <div style=\"display: none;\" :id=\"arg.event.id\">\n                    <div>時間：<span>{{ contentTimeFormat(arg.event.start) }}</span> - <span>{{ contentTimeFormat(arg.event.end) }}</span></div>\n                    <div>循環：{{ arg.event.extendedProps.is_repeat == 1 ? '是' : '否' }}</div>\n                    <div>備註：{{ arg.event.extendedProps.description }}</div>\n                </div>\n            </div>\n        </template>\n    </full-calendar>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache[".tippy-box[data-animation=fade][data-state=hidden]{opacity:0}[data-tippy-root]{max-width:calc(100vw - 10px)}.tippy-box{position:relative;background-color:#333;color:#fff;border-radius:4px;font-size:14px;line-height:1.4;outline:0;transition-property:transform,visibility,opacity}.tippy-box[data-placement^=top]>.tippy-arrow{bottom:0}.tippy-box[data-placement^=top]>.tippy-arrow:before{bottom:-7px;left:0;border-width:8px 8px 0;border-top-color:initial;transform-origin:center top}.tippy-box[data-placement^=bottom]>.tippy-arrow{top:0}.tippy-box[data-placement^=bottom]>.tippy-arrow:before{top:-7px;left:0;border-width:0 8px 8px;border-bottom-color:initial;transform-origin:center bottom}.tippy-box[data-placement^=left]>.tippy-arrow{right:0}.tippy-box[data-placement^=left]>.tippy-arrow:before{border-width:8px 0 8px 8px;border-left-color:initial;right:-7px;transform-origin:center left}.tippy-box[data-placement^=right]>.tippy-arrow{left:0}.tippy-box[data-placement^=right]>.tippy-arrow:before{left:-7px;border-width:8px 8px 8px 0;border-right-color:initial;transform-origin:center right}.tippy-box[data-inertia][data-state=visible]{transition-timing-function:cubic-bezier(.54,1.5,.38,1.11)}.tippy-arrow{width:16px;height:16px;color:#333}.tippy-arrow:before{content:\"\";position:absolute;border-color:transparent;border-style:solid}.tippy-content{position:relative;padding:5px 9px;z-index:1}\n.tippy-box[data-theme~=light-border]{background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,8,16,.15);color:#333;box-shadow:0 4px 14px -2px rgba(0,8,16,.08)}.tippy-box[data-theme~=light-border]>.tippy-backdrop{background-color:#fff}.tippy-box[data-theme~=light-border]>.tippy-arrow:after,.tippy-box[data-theme~=light-border]>.tippy-svg-arrow:after{content:\"\";position:absolute;z-index:-1}.tippy-box[data-theme~=light-border]>.tippy-arrow:after{border-color:transparent;border-style:solid}.tippy-box[data-theme~=light-border][data-placement^=top]>.tippy-arrow:before{border-top-color:#fff}.tippy-box[data-theme~=light-border][data-placement^=top]>.tippy-arrow:after{border-top-color:rgba(0,8,16,.2);border-width:7px 7px 0;top:17px;left:1px}.tippy-box[data-theme~=light-border][data-placement^=top]>.tippy-svg-arrow>svg{top:16px}.tippy-box[data-theme~=light-border][data-placement^=top]>.tippy-svg-arrow:after{top:17px}.tippy-box[data-theme~=light-border][data-placement^=bottom]>.tippy-arrow:before{border-bottom-color:#fff;bottom:16px}.tippy-box[data-theme~=light-border][data-placement^=bottom]>.tippy-arrow:after{border-bottom-color:rgba(0,8,16,.2);border-width:0 7px 7px;bottom:17px;left:1px}.tippy-box[data-theme~=light-border][data-placement^=bottom]>.tippy-svg-arrow>svg{bottom:16px}.tippy-box[data-theme~=light-border][data-placement^=bottom]>.tippy-svg-arrow:after{bottom:17px}.tippy-box[data-theme~=light-border][data-placement^=left]>.tippy-arrow:before{border-left-color:#fff}.tippy-box[data-theme~=light-border][data-placement^=left]>.tippy-arrow:after{border-left-color:rgba(0,8,16,.2);border-width:7px 0 7px 7px;left:17px;top:1px}.tippy-box[data-theme~=light-border][data-placement^=left]>.tippy-svg-arrow>svg{left:11px}.tippy-box[data-theme~=light-border][data-placement^=left]>.tippy-svg-arrow:after{left:12px}.tippy-box[data-theme~=light-border][data-placement^=right]>.tippy-arrow:before{border-right-color:#fff;right:16px}.tippy-box[data-theme~=light-border][data-placement^=right]>.tippy-arrow:after{border-width:7px 7px 7px 0;right:17px;top:1px;border-right-color:rgba(0,8,16,.2)}.tippy-box[data-theme~=light-border][data-placement^=right]>.tippy-svg-arrow>svg{right:11px}.tippy-box[data-theme~=light-border][data-placement^=right]>.tippy-svg-arrow:after{right:12px}.tippy-box[data-theme~=light-border]>.tippy-svg-arrow{fill:#fff}.tippy-box[data-theme~=light-border]>.tippy-svg-arrow:after{background-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMCA2czEuNzk2LS4wMTMgNC42Ny0zLjYxNUM1Ljg1MS45IDYuOTMuMDA2IDggMGMxLjA3LS4wMDYgMi4xNDguODg3IDMuMzQzIDIuMzg1QzE0LjIzMyA2LjAwNSAxNiA2IDE2IDZIMHoiIGZpbGw9InJnYmEoMCwgOCwgMTYsIDAuMikiLz48L3N2Zz4=);background-size:16px 6px;width:16px;height:6px}\n.fc-icon,.fc-unselectable{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none}.fc-not-allowed,.fc-not-allowed .fc-event{cursor:not-allowed}.fc .fc-button:not(:disabled),.fc a[data-navlink],.fc-event.fc-event-draggable,.fc-event[href]{cursor:pointer}.fc-unselectable{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-touch-callout:none;-webkit-tap-highlight-color:transparent}.fc{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;font-size:1em}.fc,.fc *,.fc :after,.fc :before{box-sizing:border-box}.fc table{border-collapse:collapse;border-spacing:0;font-size:1em}.fc th{text-align:center}.fc td,.fc th{vertical-align:top;padding:0}.fc a[data-navlink]:hover{text-decoration:underline}.fc-direction-ltr{direction:ltr;text-align:left}.fc-direction-rtl{direction:rtl;text-align:right}.fc .fc-button,.fc-icon{font-weight:400;text-align:center;display:inline-block}.fc-theme-standard td,.fc-theme-standard th{border:1px solid #ddd;border:1px solid var(--fc-border-color,#ddd)}.fc-liquid-hack td,.fc-liquid-hack th{position:relative}@font-face{font-family:fcicons;src:url(\"data:application/x-font-ttf;charset=utf-8;base64,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\") format('truetype');font-weight:400;font-style:normal}.fc-icon{width:1em;height:1em;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;font-family:fcicons!important;speak:none;font-style:normal;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.fc .fc-scroller-harness-liquid,.fc .fc-scroller-liquid,.fc .fc-scrollgrid-liquid{height:100%}.fc-icon-chevron-left:before{content:\"\\e900\"}.fc-icon-chevron-right:before{content:\"\\e901\"}.fc-icon-chevrons-left:before{content:\"\\e902\"}.fc-icon-chevrons-right:before{content:\"\\e903\"}.fc-icon-minus-square:before{content:\"\\e904\"}.fc-icon-plus-square:before{content:\"\\e905\"}.fc-icon-x:before{content:\"\\e906\"}.fc .fc-button{overflow:visible;text-transform:none;margin:0;font-family:inherit}.fc .fc-button::-moz-focus-inner{padding:0;border-style:none}.fc .fc-button{-webkit-appearance:button;vertical-align:middle;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-color:transparent;border:1px solid transparent;padding:.4em .65em;font-size:1em;line-height:1.5;border-radius:.25em}.fc .fc-button:hover{text-decoration:none}.fc .fc-button:focus{outline:0;box-shadow:0 0 0 .2rem rgba(44,62,80,.25)}.fc .fc-button-primary:focus,.fc .fc-button-primary:not(:disabled).fc-button-active:focus,.fc .fc-button-primary:not(:disabled):active:focus{box-shadow:0 0 0 .2rem rgba(76,91,106,.5)}.fc .fc-button:disabled{opacity:.65}.fc .fc-button-primary{color:#fff;color:var(--fc-button-text-color,#fff);background-color:#2C3E50;background-color:var(--fc-button-bg-color,#2C3E50);border-color:#2C3E50;border-color:var(--fc-button-border-color,#2C3E50)}.fc .fc-button-primary:hover{color:#fff;color:var(--fc-button-text-color,#fff);background-color:#1e2b37;background-color:var(--fc-button-hover-bg-color,#1e2b37);border-color:#1a252f;border-color:var(--fc-button-hover-border-color,#1a252f)}.fc .fc-button-primary:disabled{color:#fff;color:var(--fc-button-text-color,#fff);background-color:#2C3E50;background-color:var(--fc-button-bg-color,#2C3E50);border-color:#2C3E50;border-color:var(--fc-button-border-color,#2C3E50)}.fc .fc-button-primary:not(:disabled).fc-button-active,.fc .fc-button-primary:not(:disabled):active{color:#fff;color:var(--fc-button-text-color,#fff);background-color:#1a252f;background-color:var(--fc-button-active-bg-color,#1a252f);border-color:#151e27;border-color:var(--fc-button-active-border-color,#151e27)}.fc .fc-button .fc-icon{vertical-align:middle;font-size:1.5em}.fc .fc-button-group{position:relative;display:-ms-inline-flexbox;display:inline-flex;vertical-align:middle}.fc .fc-button-group>.fc-button{position:relative;-ms-flex:1 1 auto;flex:1 1 auto}.fc .fc-button-group>.fc-button.fc-button-active,.fc .fc-button-group>.fc-button:active,.fc .fc-button-group>.fc-button:focus,.fc .fc-button-group>.fc-button:hover{z-index:1}.fc-direction-ltr .fc-button-group>.fc-button:not(:first-child){margin-left:-1px;border-top-left-radius:0;border-bottom-left-radius:0}.fc-direction-ltr .fc-button-group>.fc-button:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0}.fc-direction-rtl .fc-button-group>.fc-button:not(:first-child){margin-right:-1px;border-top-right-radius:0;border-bottom-right-radius:0}.fc-direction-rtl .fc-button-group>.fc-button:not(:last-child){border-top-left-radius:0;border-bottom-left-radius:0}.fc .fc-toolbar{display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-align:center;align-items:center}.fc .fc-toolbar.fc-header-toolbar{margin-bottom:1.5em}.fc .fc-toolbar.fc-footer-toolbar{margin-top:1.5em}.fc .fc-toolbar-title{font-size:1.75em;margin:0}.fc-direction-ltr .fc-toolbar>*>:not(:first-child){margin-left:.75em}.fc-direction-rtl .fc-toolbar>*>:not(:first-child){margin-right:.75em}.fc-direction-rtl .fc-toolbar-ltr{-ms-flex-direction:row-reverse;flex-direction:row-reverse}.fc .fc-scroller{-webkit-overflow-scrolling:touch;position:relative}.fc .fc-scroller-liquid-absolute{position:absolute;top:0;right:0;left:0;bottom:0}.fc .fc-scroller-harness{position:relative;overflow:hidden;direction:ltr}.fc-direction-rtl .fc-scroller-harness>.fc-scroller{direction:rtl}.fc-theme-standard .fc-scrollgrid{border:1px solid #ddd;border:1px solid var(--fc-border-color,#ddd)}.fc .fc-scrollgrid,.fc .fc-scrollgrid-section-footer>*,.fc .fc-scrollgrid-section-header>*{border-bottom-width:0}.fc .fc-scrollgrid,.fc .fc-scrollgrid table{width:100%;table-layout:fixed}.fc .fc-scrollgrid table{border-top-style:hidden;border-left-style:hidden;border-right-style:hidden}.fc .fc-scrollgrid{border-collapse:separate;border-right-width:0}.fc .fc-scrollgrid-section,.fc .fc-scrollgrid-section table,.fc .fc-scrollgrid-section>td{height:1px}.fc .fc-scrollgrid-section-liquid>td{height:100%}.fc .fc-scrollgrid-section>*{border-top-width:0;border-left-width:0}.fc .fc-scrollgrid-section-body table,.fc .fc-scrollgrid-section-footer table{border-bottom-style:hidden}.fc .fc-scrollgrid-section-sticky>*{background:var(--fc-page-bg-color,#fff);position:-webkit-sticky;position:sticky;z-index:3}.fc .fc-scrollgrid-section-header.fc-scrollgrid-section-sticky>*{top:0}.fc .fc-scrollgrid-section-footer.fc-scrollgrid-section-sticky>*{bottom:0}.fc .fc-scrollgrid-sticky-shim{height:1px;margin-bottom:-1px}.fc-sticky{position:-webkit-sticky;position:sticky}.fc .fc-view-harness{-ms-flex-positive:1;flex-grow:1;position:relative}.fc .fc-bg-event,.fc .fc-highlight,.fc .fc-non-business,.fc .fc-view-harness-active>.fc-view{position:absolute;top:0;left:0;right:0;bottom:0}.fc .fc-col-header-cell-cushion{display:inline-block;padding:2px 4px}.fc .fc-non-business{background:rgba(215,215,215,.3);background:var(--fc-non-business-color,rgba(215,215,215,.3))}.fc .fc-bg-event{background:var(--fc-bg-event-color,#8fdf82);opacity:.3;opacity:var(--fc-bg-event-opacity,.3)}.fc .fc-bg-event .fc-event-title{margin:.5em;font-size:.85em;font-size:var(--fc-small-font-size,.85em);font-style:italic}.fc .fc-highlight{background:rgba(188,232,241,.3);background:var(--fc-highlight-color,rgba(188,232,241,.3))}.fc .fc-cell-shaded,.fc .fc-day-disabled{background:rgba(208,208,208,.3);background:var(--fc-neutral-bg-color,rgba(208,208,208,.3))}a.fc-event,a.fc-event:hover{text-decoration:none}.fc-event .fc-event-main{position:relative;z-index:2}.fc-event-dragging:not(.fc-event-selected){opacity:.75}.fc-event-dragging.fc-event-selected{box-shadow:0 2px 7px rgba(0,0,0,.3)}.fc-event .fc-event-resizer{display:none;position:absolute;z-index:4}.fc-event-selected .fc-event-resizer,.fc-event:hover .fc-event-resizer,.fc-h-event{display:block}.fc-event-selected .fc-event-resizer{border-radius:4px;border-radius:calc(var(--fc-event-resizer-dot-total-width,8px)/ 2);border-width:1px;border-width:var(--fc-event-resizer-dot-border-width,1px);width:8px;width:var(--fc-event-resizer-dot-total-width,8px);height:8px;height:var(--fc-event-resizer-dot-total-width,8px);border-style:solid;border-color:inherit;background:var(--fc-page-bg-color,#fff)}.fc-event-selected .fc-event-resizer:before{content:'';position:absolute;top:-20px;left:-20px;right:-20px;bottom:-20px}.fc-event-selected:after,.fc-event-selected:before{content:\"\";position:absolute}.fc-event-selected{box-shadow:0 2px 5px rgba(0,0,0,.2)}.fc-event-selected:before{z-index:3;top:0;left:0;right:0;bottom:0}.fc-event-selected:after{background:rgba(0,0,0,.25);background:var(--fc-event-selected-overlay-color,rgba(0,0,0,.25));z-index:1;top:-1px;left:-1px;right:-1px;bottom:-1px}.fc-h-event{border:1px solid #3788d8;border:1px solid var(--fc-event-border-color,#3788d8);background-color:#3788d8;background-color:var(--fc-event-bg-color,#3788d8)}.fc-h-event .fc-event-main{color:#fff;color:var(--fc-event-text-color,#fff)}.fc-h-event .fc-event-main-frame{display:-ms-flexbox;display:flex}.fc-h-event .fc-event-time{max-width:100%;overflow:hidden}.fc-h-event .fc-event-title-container{-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1;min-width:0}.fc-h-event .fc-event-title{display:inline-block;vertical-align:top;left:0;right:0;max-width:100%;overflow:hidden}.fc-h-event.fc-event-selected:before{top:-10px;bottom:-10px}.fc-direction-ltr .fc-daygrid-block-event:not(.fc-event-start),.fc-direction-rtl .fc-daygrid-block-event:not(.fc-event-end){border-top-left-radius:0;border-bottom-left-radius:0;border-left-width:0}.fc-direction-ltr .fc-daygrid-block-event:not(.fc-event-end),.fc-direction-rtl .fc-daygrid-block-event:not(.fc-event-start){border-top-right-radius:0;border-bottom-right-radius:0;border-right-width:0}.fc-h-event:not(.fc-event-selected) .fc-event-resizer{top:0;bottom:0;width:8px;width:var(--fc-event-resizer-thickness,8px)}.fc-direction-ltr .fc-h-event:not(.fc-event-selected) .fc-event-resizer-start,.fc-direction-rtl .fc-h-event:not(.fc-event-selected) .fc-event-resizer-end{cursor:w-resize;left:-4px;left:calc(var(--fc-event-resizer-thickness,8px)/ -2)}.fc-direction-ltr .fc-h-event:not(.fc-event-selected) .fc-event-resizer-end,.fc-direction-rtl .fc-h-event:not(.fc-event-selected) .fc-event-resizer-start{cursor:e-resize;right:-4px;right:calc(var(--fc-event-resizer-thickness,8px)/ -2)}.fc-h-event.fc-event-selected .fc-event-resizer{top:50%;margin-top:-4px;margin-top:calc(var(--fc-event-resizer-dot-total-width,8px)/ -2)}.fc-direction-ltr .fc-h-event.fc-event-selected .fc-event-resizer-start,.fc-direction-rtl .fc-h-event.fc-event-selected .fc-event-resizer-end{left:-4px;left:calc(var(--fc-event-resizer-dot-total-width,8px)/ -2)}.fc-direction-ltr .fc-h-event.fc-event-selected .fc-event-resizer-end,.fc-direction-rtl .fc-h-event.fc-event-selected .fc-event-resizer-start{right:-4px;right:calc(var(--fc-event-resizer-dot-total-width,8px)/ -2)}.fc .fc-popover{position:absolute;z-index:9999;box-shadow:0 2px 6px rgba(0,0,0,.15)}.fc .fc-popover-header{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-align:center;align-items:center;padding:3px 4px}.fc .fc-popover-title{margin:0 2px}.fc .fc-popover-close{cursor:pointer;opacity:.65;font-size:1.1em}.fc-theme-standard .fc-popover{border:1px solid #ddd;border:1px solid var(--fc-border-color,#ddd);background:var(--fc-page-bg-color,#fff)}.fc-theme-standard .fc-popover-header{background:rgba(208,208,208,.3);background:var(--fc-neutral-bg-color,rgba(208,208,208,.3))}\n:root{--fc-daygrid-event-dot-width:8px}.fc-daygrid-day-events:after,.fc-daygrid-day-events:before,.fc-daygrid-day-frame:after,.fc-daygrid-day-frame:before,.fc-daygrid-event-harness:after,.fc-daygrid-event-harness:before{content:\"\";clear:both;display:table}.fc .fc-daygrid-body{position:relative;z-index:1}.fc .fc-daygrid-day.fc-day-today{background-color:rgba(255,220,40,.15);background-color:var(--fc-today-bg-color,rgba(255,220,40,.15))}.fc .fc-daygrid-day-frame{position:relative;min-height:100%}.fc .fc-daygrid-day-top{display:-ms-flexbox;display:flex;-ms-flex-direction:row-reverse;flex-direction:row-reverse}.fc .fc-day-other .fc-daygrid-day-top{opacity:.3}.fc .fc-daygrid-day-number{position:relative;z-index:4;padding:4px}.fc .fc-daygrid-day-events{margin-top:1px}.fc .fc-daygrid-body-balanced .fc-daygrid-day-events{position:absolute;left:0;right:0}.fc .fc-daygrid-body-unbalanced .fc-daygrid-day-events{position:relative;min-height:2em}.fc .fc-daygrid-body-natural .fc-daygrid-day-events{margin-bottom:1em}.fc .fc-daygrid-event-harness{position:relative}.fc .fc-daygrid-event-harness-abs{position:absolute;top:0;left:0;right:0}.fc .fc-daygrid-bg-harness{position:absolute;top:0;bottom:0}.fc .fc-daygrid-day-bg .fc-non-business{z-index:1}.fc .fc-daygrid-day-bg .fc-bg-event{z-index:2}.fc .fc-daygrid-day-bg .fc-highlight{z-index:3}.fc .fc-daygrid-event{z-index:6;margin-top:1px}.fc .fc-daygrid-event.fc-event-mirror{z-index:7}.fc .fc-daygrid-day-bottom{font-size:.85em;padding:2px 3px 0}.fc .fc-daygrid-day-bottom:before{content:\"\";clear:both;display:table}.fc .fc-daygrid-more-link{position:relative;z-index:4;cursor:pointer}.fc .fc-daygrid-week-number{position:absolute;z-index:5;top:0;padding:2px;min-width:1.5em;text-align:center;background-color:rgba(208,208,208,.3);background-color:var(--fc-neutral-bg-color,rgba(208,208,208,.3));color:grey;color:var(--fc-neutral-text-color,grey)}.fc .fc-more-popover .fc-popover-body{min-width:220px;padding:10px}.fc-direction-ltr .fc-daygrid-event.fc-event-start,.fc-direction-rtl .fc-daygrid-event.fc-event-end{margin-left:2px}.fc-direction-ltr .fc-daygrid-event.fc-event-end,.fc-direction-rtl .fc-daygrid-event.fc-event-start{margin-right:2px}.fc-direction-ltr .fc-daygrid-week-number{left:0;border-radius:0 0 3px}.fc-direction-rtl .fc-daygrid-week-number{right:0;border-radius:0 0 0 3px}.fc-liquid-hack .fc-daygrid-day-frame{position:static}.fc-daygrid-event{position:relative;white-space:nowrap;border-radius:3px;font-size:.85em;font-size:var(--fc-small-font-size,.85em)}.fc-daygrid-block-event .fc-event-time{font-weight:700}.fc-daygrid-block-event .fc-event-time,.fc-daygrid-block-event .fc-event-title{padding:1px}.fc-daygrid-dot-event{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;padding:2px 0}.fc-daygrid-dot-event .fc-event-title{-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1;min-width:0;overflow:hidden;font-weight:700}.fc-daygrid-dot-event.fc-event-mirror,.fc-daygrid-dot-event:hover{background:rgba(0,0,0,.1)}.fc-daygrid-dot-event.fc-event-selected:before{top:-10px;bottom:-10px}.fc-daygrid-event-dot{margin:0 4px;box-sizing:content-box;width:0;height:0;border:4px solid #3788d8;border:calc(var(--fc-daygrid-event-dot-width,8px)/ 2) solid var(--fc-event-border-color,#3788d8);border-radius:4px;border-radius:calc(var(--fc-daygrid-event-dot-width,8px)/ 2)}.fc-direction-ltr .fc-daygrid-event .fc-event-time{margin-right:3px}.fc-direction-rtl .fc-daygrid-event .fc-event-time{margin-left:3px}\n.fc-v-event{display:block;border:1px solid #3788d8;border:1px solid var(--fc-event-border-color,#3788d8);background-color:#3788d8;background-color:var(--fc-event-bg-color,#3788d8)}.fc-v-event .fc-event-main{color:#fff;color:var(--fc-event-text-color,#fff);height:100%}.fc-v-event .fc-event-main-frame{height:100%;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}.fc-v-event .fc-event-time{-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;max-height:100%;overflow:hidden}.fc-v-event .fc-event-title-container{-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1;min-height:0}.fc-v-event .fc-event-title{top:0;bottom:0;max-height:100%;overflow:hidden}.fc-v-event:not(.fc-event-start){border-top-width:0;border-top-left-radius:0;border-top-right-radius:0}.fc-v-event:not(.fc-event-end){border-bottom-width:0;border-bottom-left-radius:0;border-bottom-right-radius:0}.fc-v-event.fc-event-selected:before{left:-10px;right:-10px}.fc-v-event .fc-event-resizer-start{cursor:n-resize}.fc-v-event .fc-event-resizer-end{cursor:s-resize}.fc-v-event:not(.fc-event-selected) .fc-event-resizer{height:8px;height:var(--fc-event-resizer-thickness,8px);left:0;right:0}.fc-v-event:not(.fc-event-selected) .fc-event-resizer-start{top:-4px;top:calc(var(--fc-event-resizer-thickness,8px)/ -2)}.fc-v-event:not(.fc-event-selected) .fc-event-resizer-end{bottom:-4px;bottom:calc(var(--fc-event-resizer-thickness,8px)/ -2)}.fc-v-event.fc-event-selected .fc-event-resizer{left:50%;margin-left:-4px;margin-left:calc(var(--fc-event-resizer-dot-total-width,8px)/ -2)}.fc-v-event.fc-event-selected .fc-event-resizer-start{top:-4px;top:calc(var(--fc-event-resizer-dot-total-width,8px)/ -2)}.fc-v-event.fc-event-selected .fc-event-resizer-end{bottom:-4px;bottom:calc(var(--fc-event-resizer-dot-total-width,8px)/ -2)}.fc .fc-timegrid .fc-daygrid-body{z-index:2}.fc .fc-timegrid-axis-chunk>table,.fc .fc-timegrid-body,.fc .fc-timegrid-slots{position:relative;z-index:1}.fc .fc-timegrid-divider{padding:0 0 2px}.fc .fc-timegrid-body{min-height:100%}.fc .fc-timegrid-axis-chunk{position:relative}.fc .fc-timegrid-slot{height:1.5em;border-bottom:0}.fc .fc-timegrid-slot:empty:before{content:'\\00a0'}.fc .fc-timegrid-slot-minor{border-top-style:dotted}.fc .fc-timegrid-slot-label-cushion{display:inline-block;white-space:nowrap}.fc .fc-timegrid-slot-label{vertical-align:middle}.fc .fc-timegrid-axis-cushion,.fc .fc-timegrid-slot-label-cushion{padding:0 4px}.fc .fc-timegrid-axis-frame-liquid{height:100%}.fc .fc-timegrid-axis-frame{overflow:hidden;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:end;justify-content:flex-end}.fc .fc-timegrid-axis-cushion{max-width:60px;-ms-flex-negative:0;flex-shrink:0}.fc-direction-ltr .fc-timegrid-slot-label-frame{text-align:right}.fc-direction-rtl .fc-timegrid-slot-label-frame{text-align:left}.fc-liquid-hack .fc-timegrid-axis-frame-liquid{height:auto;position:absolute;top:0;right:0;bottom:0;left:0}.fc .fc-timegrid-col.fc-day-today{background-color:rgba(255,220,40,.15);background-color:var(--fc-today-bg-color,rgba(255,220,40,.15))}.fc .fc-timegrid-col-frame{min-height:100%;position:relative}.fc-media-screen.fc-liquid-hack .fc-timegrid-col-frame{height:auto;position:absolute;top:0;right:0;bottom:0;left:0}.fc-media-screen .fc-timegrid-cols{position:absolute;top:0;left:0;right:0;bottom:0}.fc-media-screen .fc-timegrid-cols>table{height:100%}.fc-media-screen .fc-timegrid-col-bg,.fc-media-screen .fc-timegrid-col-events,.fc-media-screen .fc-timegrid-now-indicator-container{position:absolute;top:0;left:0;right:0}.fc .fc-timegrid-col-bg{z-index:2}.fc .fc-timegrid-col-bg .fc-non-business{z-index:1}.fc .fc-timegrid-col-bg .fc-bg-event{z-index:2}.fc .fc-timegrid-col-bg .fc-highlight,.fc .fc-timegrid-col-events{z-index:3}.fc .fc-timegrid-bg-harness{position:absolute;left:0;right:0}.fc .fc-timegrid-now-indicator-container{bottom:0;overflow:hidden}.fc-direction-ltr .fc-timegrid-col-events{margin:0 2.5% 0 2px}.fc-direction-rtl .fc-timegrid-col-events{margin:0 2px 0 2.5%}.fc-timegrid-event-harness{position:absolute}.fc-timegrid-event-harness>.fc-timegrid-event{position:absolute;top:0;bottom:0;left:0;right:0}.fc-timegrid-event-harness-inset .fc-timegrid-event,.fc-timegrid-event.fc-event-mirror,.fc-timegrid-more-link{box-shadow:0 0 0 1px #fff;box-shadow:0 0 0 1px var(--fc-page-bg-color,#fff)}.fc-timegrid-event,.fc-timegrid-more-link{font-size:.85em;font-size:var(--fc-small-font-size,.85em);border-radius:3px}.fc-timegrid-event{margin-bottom:1px}.fc-timegrid-event .fc-event-main{padding:1px 1px 0}.fc-timegrid-event .fc-event-time{white-space:nowrap;font-size:.85em;font-size:var(--fc-small-font-size,.85em);margin-bottom:1px}.fc-timegrid-event-short .fc-event-main-frame{-ms-flex-direction:row;flex-direction:row;overflow:hidden}.fc-timegrid-event-short .fc-event-time:after{content:'\\00a0-\\00a0'}.fc-timegrid-event-short .fc-event-title{font-size:.85em;font-size:var(--fc-small-font-size,.85em)}.fc-timegrid-more-link{position:absolute;z-index:9999;color:inherit;color:var(--fc-more-link-text-color,inherit);background:var(--fc-more-link-bg-color,#d0d0d0);cursor:pointer;margin-bottom:1px}.fc-timegrid-more-link-inner{padding:3px 2px;top:0}.fc-direction-ltr .fc-timegrid-more-link{right:0}.fc-direction-rtl .fc-timegrid-more-link{left:0}.fc .fc-timegrid-now-indicator-line{position:absolute;z-index:4;left:0;right:0;border-style:solid;border-color:red;border-color:var(--fc-now-indicator-color,red);border-width:1px 0 0}.fc .fc-timegrid-now-indicator-arrow{position:absolute;z-index:4;margin-top:-5px;border-style:solid;border-color:red;border-color:var(--fc-now-indicator-color,red)}.fc-direction-ltr .fc-timegrid-now-indicator-arrow{left:0;border-width:5px 0 5px 6px;border-top-color:transparent;border-bottom-color:transparent}.fc-direction-rtl .fc-timegrid-now-indicator-arrow{right:0;border-width:5px 6px 5px 0;border-top-color:transparent;border-bottom-color:transparent}\n\n.tippy-box[data-theme~='nonbusiness-hour'] {\n  color: black;\n  background-color: white;\n  border: 1px solid black;\n}\nth.fc-col-header-cell.fc-resource.service-provider-resource {\n    background: #333;\n    color: #fff;\n    padding: 5px 0;\n    cursor: pointer;\n}\n.fc .fc-timegrid-now-indicator-line {\n    z-index: 2;\n}\n.fc .fc-timegrid-col-bg .branch-block-time{\n    z-index: 3 !important;\n}\n.fc-media-screen .service-booking-event {\n    background: rgb(255, 255, 255);\n    border: 2px solid gray;\n}\n.fc-media-screen .service-provider-block-time {\n    border: 2px solid gray;\n    border-color: gray !important;\n    background-color: rgb(214, 214, 214);\n    z-index: 2;\n}\n.service-booking-event .fc-event-main{\n    color: rgb(0, 0, 0);\n}\n.fc-v-event .fc-event-main{\n    overflow: hidden;\n    white-space: normal;\n    text-overflow: ellipsis;\n}\n.service-booking-event-status {\n    position: absolute;\n    width: 6px;\n    top: 0;\n    right: auto;\n    bottom: 0;\n    left: 0;\n}\n.fc .fc-button-primary {\n    border: 1px solid;\n    background-color: #f5f5f5;\n    background-image: linear-gradient(to bottom,#fff,#e6e6e6);\n    background-repeat: repeat-x;\n    border-color: rgba(0,0,0,.1) rgba(0,0,0,.1) rgba(0,0,0,.25);\n    color: #333;\n    text-shadow: 0 1px 1px rgb(255 255 255 / 75%);\n    box-shadow: inset 0 1px 0 rgb(255 255 255 / 20%), 0 1px 2px rgb(0 0 0 / 5%);\n}\n.fc .fc-button-primary:hover {\n    color: #333;\n    text-decoration: none;\n}\n.fc .fc-button-primary:not(:disabled).fc-button-active, .fc .fc-button-primary:not(:disabled):active{\n    background-color: #ccc;\n    color: #333;\n    background-image: none;\n    box-shadow: inset 0 2px 4px rgb(0 0 0 / 15%), 0 1px 2px rgb(0 0 0 / 5%);\n}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-52fb6087", module.exports)
  } else {
    hotAPI.update("_v-52fb6087", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"@fullcalendar/core/locales/zh-tw":5,"@fullcalendar/daygrid":8,"@fullcalendar/interaction":9,"@fullcalendar/resource-timegrid":13,"babel-runtime/helpers/extends":66,"moment":727,"tippy.js":780,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1183:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            ajaxing: false,
            date: {
                start_date: '',
                end_date: ''
            },
            serviceProviders: [],
            currentBranch: {
                id: 0,
                name: ''
            },
            events: {
                block_hours: [],
                bookable_hours: [],
                appointment_events: [],
                block_time_events: [],
                schedule_events: []
            },
            initModalData: {
                role_relationship_id: 0,
                start_date: '',
                start_time: ''
            },
            blockTimeId: 0,
            selectedDate: '',
            eventBus: {
                booking_refreshSingle: ['System.Booking.Created', 'System.Booking.Updated', 'System.Booking.Checkout', 'System.Booking.Canceled', 'System.Booking.Attended', 'System.Booking.Attend-Canceled', 'System.Booking.Absence', 'System.Booking.Absence-Canceled'],
                booking_refreshAll: ['System.Booking.Batch-Create'],
                personalTime_remove: ['System.PersonalTime.Deleted'],
                personalTime_update: ['System.PersonalTime.Create', 'System.PersonalTime.Updated']
            },
            timeoutId: '',
            calendarIdleStateTimer: 900000,
            showTimeoutAlert: false
        };
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId', 'isBranch', 'isStudio', 'isSeventeen']), (0, _vuex.mapState)('filters', ['selected_studio_id', 'selected_branch_id']), {
        activeStudioId: function activeStudioId() {
            if (this.isSeventeen) {
                return this.selected_studio_id;
            }
            return this.studioId;
        },
        idleTimerFormat: function idleTimerFormat() {
            var delay = Number(this.calendarIdleStateTimer);
            return Math.round(delay / 60000);
        }
    }),
    created: function created() {
        this.getConfigTimer();
    },
    mounted: function mounted() {
        var vm = this;
        this.selectedDate = moment().format('YYYY-MM-DD');
        $('#v-choice-service-provider-modal').on('hide.bs.modal', function () {
            vm.getServiceCalendarEvent();
        });
        this.mountedEvent();
    },

    watch: {
        isSeventeen: function isSeventeen(newVal) {
            $('#v-choice-service-provider-modal').modal('show');
            $('.fc-chooseResource-button').html('<i class="fa fa-user-plus"></i>');
        },
        isStudio: function isStudio(newVal) {
            this.initCalendarParams();
        },
        isBranch: function isBranch(newVal) {
            this.initCalendarParams();
        },
        timeoutId: function timeoutId(newV, oldV) {
            window.clearTimeout(oldV);
        }
    },
    methods: {
        initCalendarParams: function initCalendarParams() {
            var _this = this;

            $.blockUI();
            this.$http.post('/webadmin/service-bookings/get_init_calendar_params').then(function (response) {
                var result = response.data;
                _this.serviceProviders = result.service_providers;
                _this.serviceProviders.forEach(function (element) {
                    element.isChecked = true;
                });
                _this.events = (0, _extends3.default)({}, _this.events, {
                    block_hours: result.branch.block_hours,
                    bookable_hours: result.branch.bookable_hours
                });
                _this.currentBranch = {
                    id: result.branch.id,
                    name: result.branch.name
                };
                _this.getServiceCalendarEvent();
            }, function (error) {
                $.unblockUI();
            });
        },
        getServiceCalendarEvent: function getServiceCalendarEvent() {
            var _this2 = this;

            if (!this.currentBranch.id) return;
            this.closeRefreshAlert();

            var params = {
                start_date: this.date.start_date,
                end_date: this.date.end_date ? this.date.end_date : this.date.start_date,
                branch_id: this.currentBranch.id,
                role_relationship_ids: []
            };
            this.serviceProviders.forEach(function (item) {
                if (item.isChecked) {
                    params.role_relationship_ids.push(item.role_relationship_id);
                }
            });
            $.blockUI();
            this.$http.get('/webadmin/service-bookings/events', { params: params }).then(function (response) {
                var result = response.data;
                _this2.events = (0, _extends3.default)({}, _this2.events, {
                    block_hours: result.branch.block_hours,
                    bookable_hours: result.branch.bookable_hours,
                    appointment_events: result.appointment_events,
                    block_time_events: result.block_time_events,
                    schedule_events: result.schedule_events
                });
            }, function (error) {
                $.unblockUI();
            }).then(function () {
                _this2.$refs.service_booking_calendar.refreshCalendar();
                $.unblockUI();
            });
        },
        setRefreshTimeout: function setRefreshTimeout() {
            var vm = this;
            var delay = Number(this.calendarIdleStateTimer);
            this.timeoutId = setTimeout(function () {
                if (vm.showTimeoutAlert) return;
                $17.swal({
                    title: '行事曆閒置過久',
                    text: '行事曆畫面已經超過 ' + vm.idleTimerFormat + ' 分鐘未更新。為避免與實際預約內容不同步，請重新整理後再操作',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: '重新整理',
                    cancelButtonText: '稍後進行',
                    onOpen: vm.detectSwalOpen()
                }, function (isConfirm) {
                    if (isConfirm) {
                        vm.updateCalendar();
                    } else {
                        vm.showTimeoutAlert = true;
                    }
                });
            }, delay);
        },
        detectSwalOpen: function detectSwalOpen() {
            this.setRefreshTimeout();
        },
        getConfigTimer: function getConfigTimer() {
            var _this3 = this;

            this.$http.get('/adminapi/system_config', {
                params: {
                    config: ['webadmin.timer']
                }
            }).then(function (response) {
                var timer = response.data['webadmin.timer'];
                _this3.calendarIdleStateTimer = timer.calendar_idle_state;
            });
        },
        closeRefreshAlert: function closeRefreshAlert() {
            this.showTimeoutAlert = false;
            this.setRefreshTimeout();
        },
        updateCalendar: function updateCalendar() {
            $('.modal:visible').modal('hide');
            this.getServiceCalendarEvent();
        },
        createServiceBooking: function createServiceBooking() {
            var vm = this;
            var tomorrow = moment(this.initModalData.start_date).add(1, "days").format('YYYY/MM/DD');
            var payload = {
                start_date: this.initModalData.start_date,
                batch_start_date: tomorrow,
                batch_end_date: tomorrow,
                start_time: this.initModalData.start_time,
                role_relationship_id: this.initModalData.role_relationship_id,
                studio_id: this.activeStudioId,
                branch_id: this.currentBranch.id
            };
            this.$http.get('/adminapi/service-bookings/get-init-booking/' + this.activeStudioId + '/' + this.currentBranch.id).then(function (response) {
                var data = response.data;
                payload.group_services = data.group_services;
                payload.staffs = data.staffs;
                $('#v-choices-event-modal').modal('hide');
                vm.$refs.serviceBookingModal.onCall(0, payload);
            }, function (error) {
                $17.swal({
                    title: '新增服務預約失敗',
                    type: 'error',
                    showCancelButton: false
                });
            });
        },
        getSingleAppointmentEvent: function getSingleAppointmentEvent(bookingId) {
            var _this4 = this;

            $.blockUI();
            this.$http.get('/adminapi/service-bookings/calender-event/' + bookingId).then(function (response) {
                _this4.$refs.service_booking_calendar.updateSingleEventById(bookingId, response.data);
            }, function (error) {
                $17.swal({
                    title: '行事曆更新失敗，請重新整理網頁',
                    type: 'error',
                    showCancelButton: false
                });
                $.unblockUI();
            });
        },
        selectSingleServiceProvider: function selectSingleServiceProvider(data) {
            this.serviceProviders.forEach(function (element) {
                if (element.role_relationship_id == data.id) {
                    element.isChecked = true;
                } else {
                    element.isChecked = false;
                };
            });
            this.getServiceCalendarEvent();
        },
        getBindBranch: function getBindBranch(data) {
            this.currentBranch = data;
        },
        getDaySelected: function getDaySelected(date) {
            this.selectedDate = date.date;
        },
        getBindDate: function getBindDate(date) {
            this.date = (0, _extends3.default)({}, this.date, date);
            if (date.hasOwnProperty('end_date') && date.hasOwnProperty('start_date')) {
                this.getServiceCalendarEvent();
            }
        },
        getServiceProvider: function getServiceProvider(data) {
            this.serviceProviders = data;
        },
        fetchDateEvent: function fetchDateEvent(info) {
            var selectDate = info.date;
            this.initModalData = {
                role_relationship_id: info.resource._resource.id,
                start_date: moment(selectDate).format('YYYY/MM/DD'),
                start_time: moment(selectDate).format('HH:mm')
            };
            this.blockTimeId = 0;
            $('#v-choices-event-modal').modal('show');
        },
        fetchEvent: function fetchEvent(info) {
            var event = info.event;
            if (event.classNames.includes('service-booking-event')) {
                var eventId = event.id.split('-');
                var bookingId = eventId[eventId.length - 1];
                this.$refs.serviceBookingModal.onCall(parseInt(bookingId));
            } else if (event.classNames.includes('service-provider-block-time')) {
                this.blockTimeId = event.extendedProps.blockTimeId;
                $('#v-block-time-modal').modal('show');
            };
        },
        mountedEvent: function mountedEvent() {
            var vm = this;
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)((0, _entries2.default)(this.eventBus)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var _step$value = (0, _slicedToArray3.default)(_step.value, 2),
                        key = _step$value[0],
                        items = _step$value[1];

                    switch (key) {
                        case 'booking_refreshSingle':
                            items.forEach(function (item) {
                                window.Event.$on(item, function (eventId) {
                                    vm.getSingleAppointmentEvent(eventId);
                                });
                            });
                            break;
                        case 'booking_refreshAll':
                            items.forEach(function (item) {
                                window.Event.$on(item, function () {
                                    vm.getServiceCalendarEvent();
                                });
                            });
                            break;
                        case 'personalTime_update':
                            items.forEach(function (item) {
                                window.Event.$on(item, function (data) {
                                    vm.$refs.service_booking_calendar.updateBlockTimeById(data.oldEventId, data.blockTime);
                                });
                            });
                            break;
                        case 'personalTime_remove':
                            items.forEach(function (item) {
                                window.Event.$on(item, function (data) {
                                    vm.$refs.service_booking_calendar.removeBlockTimeById(data.oldEventId);
                                });
                            });
                            break;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        },
        unmountedEvent: function unmountedEvent() {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = (0, _getIterator3.default)((0, _entries2.default)(this.eventBus)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var _step2$value = (0, _slicedToArray3.default)(_step2.value, 2),
                        key = _step2$value[0],
                        items = _step2$value[1];

                    items.forEach(function (item) {
                        window.Event.$off(item);
                    });
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        }
    },
    destroyed: function destroyed() {
        $('#v-choice-service-provider-modal').unbind('hide.bs.modal');
        $('#v-choice-date-modal').unbind('hide.bs.modal');
        this.unmountedEvent();
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"m-right-10\">\n    <div id=\"dismissible-alert\" v-show=\"showTimeoutAlert\">\n        <div class=\"alert dismissible-alert-container alert-warning m-right-10 m-left-10\" role=\"alert\">\n            <button type=\"button\" class=\"close\" aria-label=\"Close\" @click.prevent.stop=\"closeRefreshAlert\"><span aria-hidden=\"true\">×</span></button>\n            <strong>\n                <i class=\"fa fa-info-circle\"></i>\n            </strong> \n            行事曆畫面已經超過 {{idleTimerFormat}} 分鐘未更新。為避免與實際預約內容不同步，請重新整理後再操作\n            <span><button class=\"btn btn-info\" @click.prevent=\"updateCalendar\">重新整理</button></span>\n        </div>\n    </div>\n    <service-booking-calendar ref=\"service_booking_calendar\" :current-branch=\"currentBranch\" :service-provider=\"serviceProviders\" :events=\"events\" :select-date=\"selectedDate\" @select-single-resource=\"selectSingleServiceProvider\" @handle-date-click=\"fetchDateEvent\" @handle-event-click=\"fetchEvent\" @update-calendar=\"updateCalendar\" @fetch-date-change=\"getBindDate\"></service-booking-calendar>\n\n        \n    <choice-service-provider-modal @fetch-service-providers=\"getServiceProvider\" @fetch-bind-branch=\"getBindBranch\" :init-service-providers=\"serviceProviders\" :current-branch=\"currentBranch\"></choice-service-provider-modal>\n    <choice-date-modal :current-date=\"date.start_date\" @fetch-select-date=\"getDaySelected\"></choice-date-modal>\n    <choice-event-modal @create-service-booking=\"createServiceBooking\"></choice-event-modal>\n    <block-time-modal :service-provider=\"serviceProviders\" :block-time-id=\"blockTimeId\" :init-trainer-role-id=\"initModalData.role_relationship_id\" :init-start-date=\"initModalData.start_date\" :init-start-time=\"initModalData.start_time\"></block-time-modal>\n    <service-booking-modal ref=\"serviceBookingModal\"></service-booking-modal>\n\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-d6c5334e", module.exports)
  } else {
    hotAPI.update("_v-d6c5334e", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/get-iterator":46,"babel-runtime/core-js/object/entries":54,"babel-runtime/helpers/extends":66,"babel-runtime/helpers/slicedToArray":70,"vue":792,"vue-hot-reload-api":785,"vuex":803}],1184:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n/* line 2, stdin */\n.block-time-body[_v-15053922] {\n  min-height: 550px; }\n\n/* line 5, stdin */\n.input-group-addon[_v-15053922] {\n  transform: translate(-7px, 0); }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        serviceProvider: {
            type: Array,
            required: true
        },
        blockTimeId: {
            default: 0
        },
        initTrainerRoleId: {
            default: 0
        },
        initStartDate: {},
        initStartTime: {}
    },
    data: function data() {
        return {
            mode: 'create',
            ajaxing: false,
            postData: {},
            view: {
                selectTrainer: '',
                timeSelectMaxHeight: 200,
                daysOfWeek: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'],
                timeOptions: [],
                endStatus: [{ id: 0, name: '永久' }, { id: 1, name: '依結束日期' }],
                selectedEndStatus: ''
            }
        };
    },
    watch: {},
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId', 'isBranch', 'isStudio', 'isSeventeen']), (0, _vuex.mapState)('filters', ['selected_studio_id', 'selected_branch_id']), {
        activeStudioId: function activeStudioId() {
            if (this.isSeventeen) {
                return this.selected_studio_id;
            }
            return this.studioId;
        },
        activeBranchId: function activeBranchId() {
            if (this.isSeventeen || this.isStudio) {
                return this.selected_branch_id;
            }
            return this.branchId;
        },
        isRepeat: function isRepeat() {
            return this.postData.is_repeat;
        },
        showEndDate: function showEndDate() {
            return !this.isRepeat || this.postData.end_status == 1;
        }
    }),
    created: function created() {
        this.time_picker();
    },
    mounted: function mounted() {
        var vm = this;
        $('#v-block-time-modal').on('shown.bs.modal', function () {
            vm.initPostData();
            vm.initBlockTimeModal();
        });
    },
    destroyed: function destroyed() {
        $('#v-block-time-modal').unbind('shown.bs.modal');
    },

    methods: {
        initBlockTimeModal: function initBlockTimeModal() {
            if (this.blockTimeId) {
                this.fetchBlockAppointmentSchedule();
            } else {
                this.initCreateMode();
            }
        },
        fetchBlockAppointmentSchedule: function fetchBlockAppointmentSchedule() {
            var _this = this;

            this.mode = 'edit';
            this.ajaxing = true;
            this.$http.get('/webadmin/block_appointment_schedule/get/' + this.blockTimeId).then(function (response) {
                _this.ajaxing = false;
                _this.postData = response.data;
                _this.postData.start_time = response.data.start_time.slice(0, 5);
                _this.postData.end_time = response.data.end_time.slice(0, 5);
                _this.setServiceProviderSelectView(_this.postData.role_relationship_id);
                _this.view.selectedEndStatus = _this.view.endStatus.find(function (item) {
                    return item.id == _this.postData.end_status;
                });
            }, function (error) {
                _this.ajaxing = false;
                $17.swal({
                    title: '此資料不存在或已被刪除',
                    type: 'error',
                    showCancelButton: false
                });
            });
        },
        initCreateMode: function initCreateMode() {
            var _this2 = this;

            this.mode = 'create';
            this.postData.start_date = this.initStartDate;
            this.postData.end_date = this.initStartDate;
            this.postData.start_time = this.initStartTime;
            var startIdx = this.view.timeOptions.findIndex(function (time) {
                return time == _this2.postData.start_time;
            });
            this.postData.end_time = this.view.timeOptions[startIdx + 4];
            this.setServiceProviderSelectView(this.initTrainerRoleId);
        },
        initPostData: function initPostData() {
            this.postData = {
                role_relationship_id: 0,
                description: "",
                is_repeat: 0,
                start_date: "",
                start_time: "",
                end_date: "",
                end_time: "",
                end_status: 0,
                monday: 0,
                tuesday: 0,
                wednesday: 0,
                thursday: 0,
                friday: 0,
                saturday: 0,
                sunday: 0
            };
            this.view.selectedEndStatus = { id: 0, name: '永久' };
        },
        setServiceProviderSelectView: function setServiceProviderSelectView(role_relationship_id) {
            var sp = this.serviceProvider.find(function (trainer) {
                return trainer.role_relationship_id == role_relationship_id;
            });
            if (sp) {
                this.view.selectTrainer = sp;
                this.postData.role_relationship_id = sp.role_relationship_id;
            } else {
                this.view.selectTrainer = '';
                this.postData.role_relationship_id = '';
            };
        },
        selectEndStatus: function selectEndStatus(obj) {
            this.postData.end_status = obj.id;
        },
        getChineseWeekday: function getChineseWeekday(weekday) {
            var week = $17.getChineseWeekday(Number(weekday + 1));
            return '周' + week;
        },
        time_picker: function time_picker() {
            var timeObj = $17.getTimePicker(30);
            this.view.timeOptions = (0, _keys2.default)(timeObj).map(function (key) {
                return timeObj[key];
            });
            this.view.timeOptions.push("24:00");
        },
        store: function store() {
            var _this3 = this;

            $.blockUI();
            var mode = this.mode == 'create' ? 'Create' : 'Updated';
            this.postData.end_date = this.end_status == 0 ? this.postData.start_date : this.postData.end_date;
            this.postData.role_relationship_id = this.view.selectTrainer.role_relationship_id;
            this.$http.post('/webadmin/block_appointment_schedule/handler', this.postData).then(function (response) {
                if (response.data.success) {
                    $('#v-block-time-modal').modal('hide');
                    _this3.actionDone(mode, _this3.blockTimeId, response.data.data);
                    $.notify(response.data.msg, { className: 'success', globalPosition: 'top center' });
                } else {
                    $.notify(response.data.msg, { className: 'error', globalPosition: 'top center' });
                };
                $.unblockUI();
            }, function (error) {
                $.unblockUI();
                $.notify('儲存失敗', { className: 'error', globalPosition: 'top center' });
            });
        },
        remove: function remove() {
            var _this4 = this;

            $.blockUI();
            this.$http.delete('/webadmin/block_appointment_schedule/destroy/' + this.blockTimeId).then(function (response) {
                if (response.data.success) {
                    $('#v-block-time-modal').modal('hide');
                    _this4.actionDone('Deleted', _this4.blockTimeId);
                    $.notify(response.data.msg, { className: 'success', globalPosition: 'top center' });
                } else {
                    $.notify(response.data.msg, { className: 'error', globalPosition: 'top center' });
                };
                $.unblockUI();
            }, function (error) {
                $.unblockUI();
                $.notify('刪除失敗', { className: 'error', globalPosition: 'top center' });
            });
        },
        actionDone: function actionDone(action, oldBlockTimeId) {
            var apiResponse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

            var event = 'System.PersonalTime.';
            event += action;
            window.Event.$emit(event, {
                mode: action,
                oldEventId: oldBlockTimeId,
                blockTime: apiResponse
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal id=\"v-block-time-modal\" :confirm-btn-text=\"'送出'\" :remove-btn-show=\"mode == 'edit'\" :save-clicked=\"store\" :remove-clicked=\"remove\" _v-15053922=\"\">\n    <h4 slot=\"title\" _v-15053922=\"\">設定私人時間</h4>\n    <form slot=\"body\" class=\"form-horizontal block-time-body\" _v-15053922=\"\">\n        <v-spinner :ajaxing=\"ajaxing\" _v-15053922=\"\"></v-spinner>\n        <div v-show=\"!ajaxing\" _v-15053922=\"\">\n            <div class=\"form-group\" _v-15053922=\"\">\n                <label class=\"col-sm-3 control-label\" _v-15053922=\"\">人員</label>\n                <div class=\"col-sm-9\" _v-15053922=\"\">\n                    <v-mutiselect :model.sync=\"view.selectTrainer\" :options=\"serviceProvider\" :multiple=\"false\" :close-on-select=\"true\" :searchable=\"true\" :show-labels=\"false\" :allow-empty=\"false\" label=\"name\" track-by=\"id\" tag-name=\"name\" placeholder=\"選擇服務提供者\" _v-15053922=\"\"> \n                    </v-mutiselect>\n                </div>\n            </div>\n            <div class=\"form-group\" _v-15053922=\"\">\n                <label class=\"col-sm-3 control-label\" _v-15053922=\"\">備註</label>\n                <div class=\"col-sm-9\" _v-15053922=\"\">\n                    <input class=\"form-control\" type=\"text\" v-model=\"postData.description\" _v-15053922=\"\">\n                </div>\n            </div>\n            <div class=\"form-group\" _v-15053922=\"\">\n                <label class=\"col-sm-3 control-label\" _v-15053922=\"\">循環</label>\n                <div class=\"col-sm-9\" _v-15053922=\"\">\n                    <input type=\"checkbox\" v-model=\"postData.is_repeat\" :true-value=\"1\" :false-value=\"0\" name=\"is_repeat\" _v-15053922=\"\">\n                </div>\n            </div>\n            <div class=\"form-group\" v-show=\"isRepeat\" _v-15053922=\"\">\n                <label class=\"col-sm-3 control-label\" _v-15053922=\"\"></label>\n                <div class=\"col-sm-9\" _v-15053922=\"\">\n                    <label v-for=\"(value, index) in view.daysOfWeek\" :for=\"value\" :key=\"value\" class=\"m-right-5\" _v-15053922=\"\">\n                        <input class=\"form-control\" type=\"checkbox\" v-model=\"postData[value]\" :name=\"value\" :true-value=\"1\" :false-value=\"0\" _v-15053922=\"\"> {{getChineseWeekday(index)}}\n                    </label>\n                </div>\n            </div>\n            <div class=\"form-group\" v-show=\"isRepeat\" _v-15053922=\"\">\n                <label class=\"col-sm-3 control-label\" _v-15053922=\"\">時間</label>\n                <div class=\"col-sm-4\" _v-15053922=\"\">\n                    <v-mutiselect :model.sync=\"postData.start_time\" :options=\"view.timeOptions\" :searchable=\"false\" :close-on-select=\"true\" :show-labels=\"false\" :allow-empty=\"false\" :max-height=\"view.timeSelectMaxHeight\" placeholder=\"請選擇時間\" _v-15053922=\"\"></v-mutiselect>\n                </div>\n                <div class=\"col-sm-1 p-top-10\" _v-15053922=\"\">\n                    ～\n                </div>\n                <div class=\"col-sm-4\" _v-15053922=\"\">\n                    <v-mutiselect :model.sync=\"postData.end_time\" :options=\"view.timeOptions\" :searchable=\"false\" :close-on-select=\"true\" :show-labels=\"false\" :allow-empty=\"false\" :max-height=\"view.timeSelectMaxHeight\" placeholder=\"請選擇時間\" _v-15053922=\"\"></v-mutiselect>\n                </div>\n            </div>\n            <div class=\"form-group\" _v-15053922=\"\">\n                <label class=\"col-sm-3 control-label\" _v-15053922=\"\">開始日期</label>\n                <div class=\"col-sm-5\" _v-15053922=\"\">\n                    <div class=\"input-group\" _v-15053922=\"\">\n                        <v-datepicker v-model=\"postData.start_date\" placeholder=\"開始日期\" _v-15053922=\"\"></v-datepicker>\n                        <span class=\"input-group-addon\" _v-15053922=\"\">\n                            <span class=\"glyphicon glyphicon-calendar\" _v-15053922=\"\"></span>\n                        </span>\n                    </div>\n                </div>\n                <div class=\"col-sm-4\" v-show=\"!isRepeat\" _v-15053922=\"\">\n                    <v-mutiselect :model.sync=\"postData.start_time\" :options=\"view.timeOptions\" :searchable=\"false\" :close-on-select=\"true\" :show-labels=\"false\" :allow-empty=\"false\" :max-height=\"view.timeSelectMaxHeight\" placeholder=\"請選擇時間\" _v-15053922=\"\"></v-mutiselect>\n                </div>\n            </div>\n            <div class=\"form-group\" v-show=\"isRepeat\" _v-15053922=\"\">\n                <label class=\"col-sm-3 control-label\" _v-15053922=\"\">結束狀態</label>\n                <div class=\"col-sm-9\" _v-15053922=\"\">\n                    <v-mutiselect :model.sync=\"view.selectedEndStatus\" :options=\"view.endStatus\" :multiple=\"false\" :close-on-select=\"true\" :clear-on-select=\"true\" :searchable=\"false\" :allow-empty=\"false\" :select-event-append=\"selectEndStatus\" label=\"name\" track-by=\"id\" tag-name=\"name\" placeholder=\"請選擇\" _v-15053922=\"\"></v-mutiselect>\n                </div>\n            </div> \n            <div class=\"form-group\" v-show=\"showEndDate\" _v-15053922=\"\">\n                <label class=\"col-sm-3 control-label\" _v-15053922=\"\">結束日期</label>\n                <div class=\"col-sm-5\" _v-15053922=\"\">\n                    <div class=\"input-group\" _v-15053922=\"\">\n                        <v-datepicker v-model=\"postData.end_date\" placeholder=\"結束日期\" _v-15053922=\"\"></v-datepicker>\n                        <span class=\"input-group-addon\" _v-15053922=\"\">\n                            <span class=\"glyphicon glyphicon-calendar\" _v-15053922=\"\"></span>\n                        </span>\n                    </div>\n                </div>\n                <div class=\"col-sm-4\" v-show=\"!isRepeat\" _v-15053922=\"\">\n                    <v-mutiselect :model.sync=\"postData.end_time\" :options=\"view.timeOptions\" :searchable=\"false\" :close-on-select=\"true\" :show-labels=\"false\" :allow-empty=\"false\" :max-height=\"view.timeSelectMaxHeight\" placeholder=\"請選擇時間\" _v-15053922=\"\"></v-mutiselect>\n                </div>\n            </div>\n        </div>\n    </form>\n</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n/* line 2, stdin */\n.block-time-body[_v-15053922] {\n  min-height: 550px; }\n\n/* line 5, stdin */\n.input-group-addon[_v-15053922] {\n  transform: translate(-7px, 0); }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-15053922", module.exports)
  } else {
    hotAPI.update("_v-15053922", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/object/keys":56,"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1185:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.choiceDateModalClass {\n  border: none !important;\n  transform: translate(-15px, 0); }\n\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['currentDate'],
    data: function data() {
        return {
            date: ''
        };
    },

    watch: {
        currentDate: function currentDate(newVal) {
            if (newVal) {
                this.date = newVal;
            }
        }
    },
    mounted: function mounted() {
        var vm = this;
        this.date = moment().format('YYYY-MM-DD');
        $('#v-choice-date-modal').on('hide.bs.modal', function () {
            vm.$emit('fetch-select-date', { date: vm.date });
        });
    },

    methods: {
        confirm: function confirm() {
            $('#v-choice-date-modal').modal('hide');
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal id=\"v-choice-date-modal\" :open-size=\"'modal-sm'\" :save-clicked=\"confirm\" no-cancel=\"\" _v-39407030=\"\">\n    <h4 slot=\"title\" _v-39407030=\"\">選擇日期</h4>\n    <div slot=\"body\" _v-39407030=\"\">\n        <v-datepicker v-model=\"date\" :inline=\"true\" calendar-class=\"choiceDateModalClass\" _v-39407030=\"\"></v-datepicker>\n    </div>\n</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.choiceDateModalClass {\n  border: none !important;\n  transform: translate(-15px, 0); }\n\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-39407030", module.exports)
  } else {
    hotAPI.update("_v-39407030", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1186:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: [],
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        canCreateService: function canCreateService(state) {
            return state.webadmin.configure.webFunctions['WebadminService-bookingsCreate'];
        }
    })),
    methods: {
        createServiceBooking: function createServiceBooking() {
            this.$emit('create-service-booking');
        },
        createBlockTime: function createBlockTime() {
            $('#v-choices-event-modal').modal('hide');
            $('#v-block-time-modal').modal('show');
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n    <v-modal id=\"v-choices-event-modal\" :open-size=\"'modal-md'\" no-footer=\"\">\n    <h4 slot=\"title\"></h4>\n    <div slot=\"body\">\n        <button v-if=\"canCreateService\" @click=\"createServiceBooking\" id=\"btn-add-appointment-schedule\" type=\"button\" class=\"btn btn-primary btn-lg btn-block\">\n            <i class=\"fa fa-clock-o fa-lg\"></i> 新增預約\n        </button>\n        <button @click=\"createBlockTime\" id=\"btn-add-block-time\" type=\"button\" class=\"btn btn-danger btn-lg btn-block\">\n            <i class=\"fa fa-ban fa-lg\"></i> 私人時間\n        </button>\n    </div>\n</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-68b959e0", module.exports)
  } else {
    hotAPI.update("_v-68b959e0", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vuex":803}],1187:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.select-outer-div[_v-a0b8a4fa] {\n  -ms-flex-direction: column;\n      flex-direction: column; }\n\n/* line 6, stdin */\n.row label[_v-a0b8a4fa] {\n  display: block;\n  margin-top: 6px; }\n\n/* line 10, stdin */\n.row .head-row[_v-a0b8a4fa] {\n  border-bottom: 2px solid #dddddd;\n  padding-left: 7px; }\n\n/* line 14, stdin */\n.row .content-row[_v-a0b8a4fa] {\n  border-bottom: 1px solid #dddddd;\n  padding-left: 7px; }\n  /* line 17, stdin */\n  .row .content-row[_v-a0b8a4fa]:hover {\n    background-color: #f5f5f5; }\n  /* line 20, stdin */\n  .row .content-row[_v-a0b8a4fa]:nth-last-child(1) {\n    border-bottom: none; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        initServiceProviders: {},
        currentBranch: {},
        isChooseServiceProvider: {
            default: true
        }
    },
    data: function data() {
        return {
            ajaxing: false,
            serviceProviders: [],
            checkedAll: false,
            activeCheckWatcher: false
        };
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId', 'isBranch', 'isStudio', 'isSeventeen']), (0, _vuex.mapState)('filters', ['selected_studio_id', 'selected_branch_id', 'branchOptions']), {
        activeStudioId: function activeStudioId() {
            if (this.isSeventeen) {
                return this.selected_studio_id;
            }
            return this.studioId;
        },
        activeBranchId: function activeBranchId() {
            if (this.isSeventeen || this.isStudio) {
                return this.selected_branch_id;
            }
            return this.branchId;
        },
        activeBranchName: function activeBranchName() {
            var _this = this;

            var branchObj = this.branchOptions.find(function (branch) {
                return branch.id == _this.activeBranchId;
            });
            if (branchObj) {
                return branchObj.branch_name;
            };
            return this.currentBranch.name;
        }
    }),
    watch: {
        checkedAll: function checkedAll(newVal) {
            if (this.activeCheckWatcher) {
                this.syncSelectionWithCheckedAll();
            }
        }
    },
    mounted: function mounted() {
        var vm = this;
        $('#v-choice-service-provider-modal').on('shown.bs.modal', function () {
            vm.checkedAll = false;
            vm.serviceProviders = vm.initServiceProviders;
            vm.$nextTick(function () {
                vm.activeCheckWatcher = true;
            });
        });
        $('#v-choice-service-provider-modal').on('hidden.bs.modal', function () {
            vm.activeCheckWatcher = false;
        });
    },
    destroyed: function destroyed() {
        $('#v-choice-service-provider-modal').unbind('shown.bs.modal');
    },

    methods: {
        getBindBranch: function getBindBranch(data) {
            this.$emit('fetch-bind-branch', {
                id: this.activeBranchId,
                name: this.activeBranchName
            });
            if (this.isChooseServiceProvider) {
                this.fetchServiceprovider();
            };
        },
        fetchServiceprovider: function fetchServiceprovider() {
            var _this2 = this;

            if (this.currentBranch.id == this.activeBranchId) return;
            this.ajaxing = true;
            $.blockUI();
            this.$http.get('/adminapi/service-provider/get-execute?' + 'studio_id=' + this.activeStudioId + '&branch_id=' + this.activeBranchId).then(function (response) {
                _this2.ajaxing = false;
                $.unblockUI();
                var sp = response.data.data;
                _this2.serviceProviders = sp;
                _this2.checkedAll = false;
                _this2.serviceProviders.forEach(function (element) {
                    element.isChecked = true;
                });
                _this2.$emit('fetch-service-providers', sp);
            }, function (error) {
                _this2.ajaxing = false;
                $.unblockUI();
            });
        },
        confirm: function confirm() {
            $('#v-choice-service-provider-modal').modal('hide');
        },
        syncSelectionWithCheckedAll: function syncSelectionWithCheckedAll() {
            var _this3 = this;

            this.serviceProviders.forEach(function (sp) {
                sp.isChecked = _this3.checkedAll;
            });
            this.$forceUpdate();
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal id=\"v-choice-service-provider-modal\" :open-size=\"'modal-sm'\" :save-clicked=\"confirm\" no-cancel=\"\" _v-a0b8a4fa=\"\">\n    <h4 slot=\"title\" _v-a0b8a4fa=\"\">\n        <span v-if=\"isChooseServiceProvider\" _v-a0b8a4fa=\"\">選擇人員-{{activeBranchName}}</span>\n        <span v-else=\"\" _v-a0b8a4fa=\"\">選擇場館</span>\n    </h4>\n    <div slot=\"body\" _v-a0b8a4fa=\"\">\n        <div style=\"min-height: 300px;\" _v-a0b8a4fa=\"\">\n            <v-multiselect-studio-and-branch :studio_id=\"studioId\" :branch_id=\"branchId\" :default_branch_id=\"currentBranch.id\" :branch-without-filtered-option=\"false\" :branch-change-call-back=\"getBindBranch\" _v-a0b8a4fa=\"\"></v-multiselect-studio-and-branch>\n            <div v-if=\"isChooseServiceProvider\" _v-a0b8a4fa=\"\">\n                <v-spinner :ajaxing=\"ajaxing\" _v-a0b8a4fa=\"\"></v-spinner>\n                <div class=\"row p-left-20 p-right-20\" v-show=\"!ajaxing\" style=\" min-height: 200px; \" _v-a0b8a4fa=\"\">\n                    <div class=\"col-sm-12\" _v-a0b8a4fa=\"\">\n                        <div class=\"row head-row\" _v-a0b8a4fa=\"\">\n                            <label _v-a0b8a4fa=\"\">\n                                <input type=\"checkbox\" help=\"全選\" v-model=\"checkedAll\" _v-a0b8a4fa=\"\">\n                                <small class=\"m-left-5\" _v-a0b8a4fa=\"\">全選</small>\n                            </label>\n                        </div>\n                        <div class=\"row content-row\" v-for=\"sp in serviceProviders\" :key=\"sp.role_relationship_id\" _v-a0b8a4fa=\"\">\n                            <label _v-a0b8a4fa=\"\">\n                                <input type=\"checkbox\" v-model=\"sp.isChecked\" :name=\"sp.id\" _v-a0b8a4fa=\"\">\n                                <span class=\"m-left-20\" _v-a0b8a4fa=\"\">{{sp.name}}</span>\n                            </label>\n                        </div>\n                    </div>\n                </div>                \n            </div>                \n        </div>\n    </div>\n</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.select-outer-div[_v-a0b8a4fa] {\n  -ms-flex-direction: column;\n      flex-direction: column; }\n\n/* line 6, stdin */\n.row label[_v-a0b8a4fa] {\n  display: block;\n  margin-top: 6px; }\n\n/* line 10, stdin */\n.row .head-row[_v-a0b8a4fa] {\n  border-bottom: 2px solid #dddddd;\n  padding-left: 7px; }\n\n/* line 14, stdin */\n.row .content-row[_v-a0b8a4fa] {\n  border-bottom: 1px solid #dddddd;\n  padding-left: 7px; }\n  /* line 17, stdin */\n  .row .content-row[_v-a0b8a4fa]:hover {\n    background-color: #f5f5f5; }\n  /* line 20, stdin */\n  .row .content-row[_v-a0b8a4fa]:nth-last-child(1) {\n    border-bottom: none; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-a0b8a4fa", module.exports)
  } else {
    hotAPI.update("_v-a0b8a4fa", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1188:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.table[_v-9ba39aa2] {\n  margin-top: 15px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['errors'],
    data: function data() {
        return {};
    },

    methods: {},
    mounted: function mounted() {},
    watch: {},
    computed: {}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-9ba39aa2=\"\">\n    <table class=\"table table-striped\" _v-9ba39aa2=\"\">\n        <thead _v-9ba39aa2=\"\">\n            <tr _v-9ba39aa2=\"\">\n                <td _v-9ba39aa2=\"\">檢查錯誤資訊</td>\n            </tr>\n        </thead>\n        <tbody _v-9ba39aa2=\"\">\n            <tr v-for=\"error in errors\" _v-9ba39aa2=\"\">\n                <td _v-9ba39aa2=\"\">{{error}}</td>\n            </tr>\n        </tbody>\n    </table>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.table[_v-9ba39aa2] {\n  margin-top: 15px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-9ba39aa2", module.exports)
  } else {
    hotAPI.update("_v-9ba39aa2", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1189:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _invoice_tw_check = require('./invoice_tw_check.vue');

var _invoice_tw_check2 = _interopRequireDefault(_invoice_tw_check);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('webadmin-import-invoice-tw-check', _invoice_tw_check2.default);

},{"./invoice_tw_check.vue":1190,"vue":792}],1190:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.step[_v-6276d2c3] {\n  margin-left: 15px; }\n\n/* line 5, stdin */\n.table-result[_v-6276d2c3] {\n  margin-top: 30px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            files: '',
            ajaxing: false,
            errors: [],
            checkResult: []
        };
    },

    methods: {
        checkFileType: function checkFileType() {

            var ext = getExtension(this.files);
            switch (ext.toLowerCase()) {
                case 'csv':
                    return true;
            }
            return false;
        },
        fileImport: function fileImport(event) {
            var _this = this;

            if (!this.checkFileType) {
                $17.swal({
                    title: '請檢查檔案,此檔案不為CSV類型！',
                    showCancelButton: false,
                    type: 'error'
                });
            }

            this.ajaxing = true;
            this.resetData();
            var formData = new FormData();
            formData.append('files', this.files);

            this.$http.post('/adminapi/import/invoice_check', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            }).then(function (response) {
                _this.ajaxing = false;
                $17.swal({
                    title: '匯入成功',
                    showCancelButton: false,
                    type: 'success'
                });
                _this.files = '';
                document.getElementById('file').value = '';
                _this.checkResult = response.data;
            }, function (error) {
                _this.ajaxing = false;
                $17.swal({
                    title: '匯入失敗，請先檢查檔案！',
                    showCancelButton: false,
                    type: 'error'
                });
                _this.files = '';
                document.getElementById('file').value = '';
            });
        },
        resultCheck: function resultCheck(event) {
            var _this2 = this;

            if (!this.checkFileType) {
                $17.swal({
                    title: '請檢查檔案,此檔案不為CSV類型！',
                    showCancelButton: false,
                    type: 'error'
                });
            }

            this.ajaxing = true;
            this.resetData();
            var formData = new FormData();
            formData.append('files', this.files);

            this.$http.get('/adminapi/import/result_check').then(function (response) {
                _this2.ajaxing = false;
                _this2.checkResult = response.data;
            }, function (error) {
                _this2.ajaxing = false;
                $17.swal({
                    title: '匯入失敗，請先檢查檔案！',
                    showCancelButton: false,
                    type: 'error'
                });
            });
        },
        onFileChange: function onFileChange(event) {
            this.files = event.target.files[0]; // get input file object
        },
        clearFile: function clearFile(event) {
            this.files = ''; // get input file object
        },
        resetData: function resetData() {
            this.checkResult = [];
        }
    },
    mounted: function mounted() {},
    watch: {},
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId', 'isBranch']), (0, _vuex.mapState)('filters', ['selected_studio_id']))
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n    <div class=\"step\" _v-6276d2c3=\"\">\n        <h3 _v-6276d2c3=\"\">檢視上次匯入結果</h3>\n        <input type=\"button\" value=\"檢視\" class=\"btn btn-success\" @click.prevent=\"resultCheck\" _v-6276d2c3=\"\">\n        <h3 _v-6276d2c3=\"\">步驟一：下載範例</h3>\n        <h3 _v-6276d2c3=\"\">\n            <small _v-6276d2c3=\"\">下載範例CSV檔案，依照欄位依序填上:(ezPay電子發票開立序號,商店自訂編號,發票號碼,發票金額)。</small>\n        </h3>\n        <div _v-6276d2c3=\"\">\n            <a href=\"/example/import_invoice_check.csv\" class=\"btn btn-primary\" _v-6276d2c3=\"\">範例下載</a>\n        </div>\n        <h3 _v-6276d2c3=\"\">步驟二: 選擇上傳檔案</h3>\n        <h3 _v-6276d2c3=\"\">\n            <small _v-6276d2c3=\"\">選擇想要匯入的CSV檔案</small>\n        </h3>\n\t\t<form method=\"POST\" action=\"#\" accept-charset=\"UTF-8\" autocomplete=\"off\" id=\"file-form\" enctype=\"multipart/form-data\" _v-6276d2c3=\"\">\n            <input name=\"files\" id=\"file\" type=\"file\" v-on:change=\"onFileChange\" v-on:click=\"clearFile\" _v-6276d2c3=\"\">\n\t\t</form>\n        <div v-if=\"!!files\" _v-6276d2c3=\"\">\n            <h3 _v-6276d2c3=\"\">步驟三: 確認匯入</h3>\n            <div v-if=\"!ajaxing\" _v-6276d2c3=\"\">\n                <input type=\"button\" value=\"確認執行匯入\" class=\"btn btn-success\" @click.prevent=\"fileImport\" _v-6276d2c3=\"\">\n            </div>\n        </div>\n        <v-spinner :ajaxing=\"ajaxing\" _v-6276d2c3=\"\"></v-spinner>\n        <div class=\"table-result\" _v-6276d2c3=\"\">\n            <v-table :ajaxing=\"ajaxing\" :length=\"checkResult\" _v-6276d2c3=\"\">\n                <table class=\"table sortable\" _v-6276d2c3=\"\">\n                    <thead _v-6276d2c3=\"\">\n                        <tr _v-6276d2c3=\"\">\n                            <th _v-6276d2c3=\"\">發票號碼</th>\n                            <th _v-6276d2c3=\"\">狀態</th>\n                        </tr>\n                    </thead>\n                    <tbody _v-6276d2c3=\"\">\n                        <tr v-for=\"r in checkResult\" :key=\"r.id\" _v-6276d2c3=\"\">\n                            <td class=\"col-md-1\" _v-6276d2c3=\"\"> {{ r.invoice_number }} </td>\n                            <td class=\"col-md-2\" _v-6276d2c3=\"\"> {{ r.state_description }} </td>\n                        </tr>\n                    </tbody>\n                </table>\n            </v-table>\n        </div>\n    </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.step[_v-6276d2c3] {\n  margin-left: 15px; }\n\n/* line 5, stdin */\n.table-result[_v-6276d2c3] {\n  margin-top: 30px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-6276d2c3", module.exports)
  } else {
    hotAPI.update("_v-6276d2c3", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1191:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.table[_v-616500b4] {\n  margin-top: 15px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['title', 'data'],
    data: function data() {
        return {};
    },

    methods: {},
    mounted: function mounted() {},
    watch: {},
    computed: {}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-616500b4=\"\">\n    <table class=\"table table-striped\" _v-616500b4=\"\">\n        <thead _v-616500b4=\"\">\n            <tr _v-616500b4=\"\">\n                <td v-for=\"item in title\" _v-616500b4=\"\">{{ item }}</td>\n            </tr>\n        </thead>\n        <tbody _v-616500b4=\"\">\n            <tr v-for=\"row in data\" _v-616500b4=\"\">\n                <td v-for=\"item in row\" _v-616500b4=\"\">{{ item }}</td>\n            </tr>\n        </tbody>\n    </table>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.table[_v-616500b4] {\n  margin-top: 15px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-616500b4", module.exports)
  } else {
    hotAPI.update("_v-616500b4", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1192:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.step[_v-4b26bd9c] {\n  margin-left: 15px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            files: '',
            ajaxing: false,
            errors: [],
            previewTitle: [],
            previewData: []
        };
    },

    methods: {
        fileCheck: function fileCheck(event) {
            var _this = this;

            this.resetData();
            this.ajaxing = true;
            var formData = new FormData();
            formData.append('files', this.files);
            formData.append('studio_id', this.studioId);

            this.$http.post('/adminapi/import/studio_member/check/', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            }).then(function (response) {
                $17.swal({
                    title: '檢查成功',
                    showCancelButton: false,
                    type: 'success'
                });
                _this.ajaxing = false;
            }, function (error) {
                _this.ajaxing = false;

                try {
                    _this.errors = typeof error.data.message != "undefined" ? JSON.parse(error.data.message) : [];
                } catch (e) {
                    $17.swal({
                        title: error.data.message,
                        showCancelButton: false,
                        type: 'error'
                    });
                }
            });
        },
        filePreview: function filePreview(event) {
            var _this2 = this;

            this.ajaxing = true;
            this.resetData();
            var formData = new FormData();
            formData.append('files', this.files);
            formData.append('studio_id', this.studioId);

            this.$http.post('/adminapi/import/studio_member/preview/', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            }).then(function (response) {
                _this2.ajaxing = false;
                _this2.previewTitle = response.data.title;
                _this2.previewData = response.data.data;
                if (response.data.title === null) {
                    $17.swal({
                        title: '無可匯入資料',
                        showCancelButton: false,
                        type: 'error'
                    });
                }
            }, function (error) {
                _this2.ajaxing = false;
                $17.swal({
                    title: error.data.message,
                    showCancelButton: false,
                    type: 'error'
                });
            });
        },
        fileImport: function fileImport(event) {
            var _this3 = this;

            this.ajaxing = true;
            this.resetData();
            var formData = new FormData();
            formData.append('files', this.files);
            formData.append('studio_id', this.studioId);

            this.$http.post('/adminapi/import/studio_member/import/', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            }).then(function (response) {
                _this3.ajaxing = false;
                $17.swal({
                    title: '匯入成功',
                    showCancelButton: false,
                    type: 'success'
                });
                _this3.files = '';
                document.getElementById('file').value = '';
            }, function (error) {
                _this3.ajaxing = false;
                $17.swal({
                    title: '匯入失敗，請先檢查檔案！',
                    showCancelButton: false,
                    type: 'error'
                });
                _this3.files = '';
                document.getElementById('file').value = '';
            });
        },
        onFileChange: function onFileChange(event) {
            this.files = event.target.files[0]; // get input file object
        },
        clearFile: function clearFile(event) {
            this.files = ''; // get input file object
        },
        resetData: function resetData() {
            this.errors = [];
            this.previewTitle = [];
            this.previewData = [];
        }
    },
    mounted: function mounted() {},
    watch: {},
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId', 'isBranch']), (0, _vuex.mapState)('filters', ['selected_studio_id']))
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n    <div class=\"step\" _v-4b26bd9c=\"\">\n        <h3 _v-4b26bd9c=\"\">步驟一：下載範例</h3>\n        <h3 _v-4b26bd9c=\"\">\n            <small _v-4b26bd9c=\"\">下載範例Excel檔案，依照檔案內的說明，建立想要匯入的客戶資料。</small>\n        </h3>\n        <div _v-4b26bd9c=\"\">\n            <a href=\"/import_example.xls\" class=\"btn btn-primary\" _v-4b26bd9c=\"\">範例下載</a>\n        </div>\n        <h3 _v-4b26bd9c=\"\">步驟二: 選擇上傳檔案</h3>\n        <h3 _v-4b26bd9c=\"\">\n            <small _v-4b26bd9c=\"\">建議使用 Microsoft 系列工具匯出 Excel 檔案</small>\n        </h3>\n\t\t<form method=\"POST\" action=\"#\" accept-charset=\"UTF-8\" autocomplete=\"off\" id=\"file-form\" enctype=\"multipart/form-data\" _v-4b26bd9c=\"\">\n            <input name=\"files\" id=\"file\" type=\"file\" v-on:change=\"onFileChange\" v-on:click=\"clearFile\" _v-4b26bd9c=\"\">\n\t\t</form>\n        <div v-if=\"!!files\" _v-4b26bd9c=\"\">\n            <h3 _v-4b26bd9c=\"\">步驟三: 確認匯入</h3>\n            <h3 _v-4b26bd9c=\"\">\n                <div _v-4b26bd9c=\"\"><small _v-4b26bd9c=\"\">當按下檢查檔案，系統將偵測檔案是否符合上傳規格限制。</small></div>\n                <div _v-4b26bd9c=\"\"><small _v-4b26bd9c=\"\">您也可以先預覽想要匯入的資料是否正確。或是直接確認匯入檔案。</small></div>\n                <div _v-4b26bd9c=\"\"><small _v-4b26bd9c=\"\">請注意，一旦匯入成功，則無法返回操作！</small></div>\n            </h3>\n            <div v-if=\"!ajaxing\" _v-4b26bd9c=\"\">\n                <input type=\"button\" value=\"檢查檔案\" class=\"btn btn-primary\" @click.prevent=\"fileCheck\" _v-4b26bd9c=\"\">\n                <input type=\"button\" value=\"預覽\" class=\"btn btn-primary\" @click.prevent=\"filePreview\" _v-4b26bd9c=\"\">\n                <input type=\"button\" value=\"確認執行匯入\" class=\"btn btn-success\" @click.prevent=\"fileImport\" _v-4b26bd9c=\"\">\n            </div>\n        </div>\n        <v-spinner :ajaxing=\"ajaxing\" _v-4b26bd9c=\"\"></v-spinner>\n        <import-check-error-table v-if=\"errors.length>0\" :errors=\"errors\" _v-4b26bd9c=\"\"></import-check-error-table>\n        <import-preview-table :data=\"previewData\" :title=\"previewTitle\" _v-4b26bd9c=\"\"></import-preview-table>\n    </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.step[_v-4b26bd9c] {\n  margin-left: 15px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-4b26bd9c", module.exports)
  } else {
    hotAPI.update("_v-4b26bd9c", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1193:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _orderModal = require('./pos/order-modal.vue');

var _orderModal2 = _interopRequireDefault(_orderModal);

var _marker = require('../../../../../global/vue_google_maps/components/marker');

var _marker2 = _interopRequireDefault(_marker);

var _cluster = require('../../../../../global/vue_google_maps/components/cluster');

var _cluster2 = _interopRequireDefault(_cluster);

var _polyline = require('../../../../../global/vue_google_maps/components/polyline');

var _polyline2 = _interopRequireDefault(_polyline);

var _polygon = require('../../../../../global/vue_google_maps/components/polygon');

var _polygon2 = _interopRequireDefault(_polygon);

var _circle = require('../../../../../global/vue_google_maps/components/circle');

var _circle2 = _interopRequireDefault(_circle);

var _rectangle = require('../../../../../global/vue_google_maps/components/rectangle');

var _rectangle2 = _interopRequireDefault(_rectangle);

var _infoWindow = require('../../../../../global/vue_google_maps/components/infoWindow.vue');

var _infoWindow2 = _interopRequireDefault(_infoWindow);

var _map = require('../../../../../global/vue_google_maps/components/map.vue');

var _map2 = _interopRequireDefault(_map);

var _streetViewPanorama = require('../../../../../global/vue_google_maps/components/streetViewPanorama.vue');

var _streetViewPanorama2 = _interopRequireDefault(_streetViewPanorama);

var _placeInput = require('../../../../../global/vue_google_maps/components/placeInput.vue');

var _placeInput2 = _interopRequireDefault(_placeInput);

var _autocomplete = require('../../../../../global/vue_google_maps/components/autocomplete.vue');

var _autocomplete2 = _interopRequireDefault(_autocomplete);

var _orderListPay = require('./pos/order-list-pay.vue');

var _orderListPay2 = _interopRequireDefault(_orderListPay);

var _orderListUnpay = require('./pos/order-list-unpay.vue');

var _orderListUnpay2 = _interopRequireDefault(_orderListUnpay);

var _order_edit = require('./pos/order_edit.vue');

var _order_edit2 = _interopRequireDefault(_order_edit);

var _order_show = require('./pos/order_show.vue');

var _order_show2 = _interopRequireDefault(_order_show);

var _orderRefund = require('./pos/order-refund.vue');

var _orderRefund2 = _interopRequireDefault(_orderRefund);

var _orderRemark = require('./pos/order-remark.vue');

var _orderRemark2 = _interopRequireDefault(_orderRemark);

var _orderSalseman = require('./pos/order-salseman.vue');

var _orderSalseman2 = _interopRequireDefault(_orderSalseman);

var _orderPaymentShow = require('./pos/order-payment-show.vue');

var _orderPaymentShow2 = _interopRequireDefault(_orderPaymentShow);

var _orderSelect = require('./pos/order-select.vue');

var _orderSelect2 = _interopRequireDefault(_orderSelect);

var _invoiceManaual = require('./pos/invoice-manaual.vue');

var _invoiceManaual2 = _interopRequireDefault(_invoiceManaual);

var _order_detail_list = require('./pos/order_detail_list.vue');

var _order_detail_list2 = _interopRequireDefault(_order_detail_list);

var _order_detail_item_show = require('./pos/order_detail_item_show.vue');

var _order_detail_item_show2 = _interopRequireDefault(_order_detail_item_show);

var _order_detail_item_edit = require('./pos/order_detail_item_edit.vue');

var _order_detail_item_edit2 = _interopRequireDefault(_order_detail_item_edit);

var _order_detail_item_refund = require('./pos/order_detail_item_refund.vue');

var _order_detail_item_refund2 = _interopRequireDefault(_order_detail_item_refund);

var _product_list = require('./pos/product_list.vue');

var _product_list2 = _interopRequireDefault(_product_list);

var _product_append = require('./pos/product_append.vue');

var _product_append2 = _interopRequireDefault(_product_append);

var _product_item_show = require('./pos/product_item_show.vue');

var _product_item_show2 = _interopRequireDefault(_product_item_show);

var _order_issue_method = require('./pos/order_issue_method.vue');

var _order_issue_method2 = _interopRequireDefault(_order_issue_method);

var _list = require('./commonly_used_items/list.vue');

var _list2 = _interopRequireDefault(_list);

var _list3 = require('./commonly_used_discounts/list.vue');

var _list4 = _interopRequireDefault(_list3);

var _tagList = require('./tag/tag-list.vue');

var _tagList2 = _interopRequireDefault(_tagList);

var _index = require('./customer/index.vue');

var _index2 = _interopRequireDefault(_index);

var _manageCustomerListModal = require('./customer/manage-customer-list-modal.vue');

var _manageCustomerListModal2 = _interopRequireDefault(_manageCustomerListModal);

var _ticketList = require('./ticket/ticket-list.vue');

var _ticketList2 = _interopRequireDefault(_ticketList);

var _ticketModal = require('./ticket/ticket-modal.vue');

var _ticketModal2 = _interopRequireDefault(_ticketModal);

var _index3 = require('./location/index.vue');

var _index4 = _interopRequireDefault(_index3);

var _modal = require('./location/modal.vue');

var _modal2 = _interopRequireDefault(_modal);

var _index5 = require('./lesson_quantity_searching/index.vue');

var _index6 = _interopRequireDefault(_index5);

var _cancelPolicyList = require('./cancel_policy/cancel-policy-list.vue');

var _cancelPolicyList2 = _interopRequireDefault(_cancelPolicyList);

var _cancelPolicyModal = require('./cancel_policy/cancel-policy-modal.vue');

var _cancelPolicyModal2 = _interopRequireDefault(_cancelPolicyModal);

var _upcomingBooking = require('./crm/home/upcoming-booking.vue');

var _upcomingBooking2 = _interopRequireDefault(_upcomingBooking);

var _profile = require('./crm/home/profile.vue');

var _profile2 = _interopRequireDefault(_profile);

var _rightSidebar = require('./crm/home/right-sidebar.vue');

var _rightSidebar2 = _interopRequireDefault(_rightSidebar);

var _index7 = require('./crm/home/index.vue');

var _index8 = _interopRequireDefault(_index7);

var _main = require('./crm/home/main.vue');

var _main2 = _interopRequireDefault(_main);

var _addMemberCreditModal = require('./crm/home/add-member-credit-modal.vue');

var _addMemberCreditModal2 = _interopRequireDefault(_addMemberCreditModal);

var _validPlanDetailRecords = require('./crm/home/valid-plan-detail-records.vue');

var _validPlanDetailRecords2 = _interopRequireDefault(_validPlanDetailRecords);

var _createCustomer = require('./crm/create-customer.vue');

var _createCustomer2 = _interopRequireDefault(_createCustomer);

var _contentCard = require('./crm/content-card.vue');

var _contentCard2 = _interopRequireDefault(_contentCard);

var _validPlan = require('./crm/home/valid-plan.vue');

var _validPlan2 = _interopRequireDefault(_validPlan);

var _contractEdit = require('./crm/home/contract-edit.vue');

var _contractEdit2 = _interopRequireDefault(_contractEdit);

var _contractTimeEdit = require('./crm/home/contract-time-edit.vue');

var _contractTimeEdit2 = _interopRequireDefault(_contractTimeEdit);

var _contractPointEdit = require('./crm/home/contract-point-edit.vue');

var _contractPointEdit2 = _interopRequireDefault(_contractPointEdit);

var _contractStatusEdit = require('./crm/home/contract-status-edit.vue');

var _contractStatusEdit2 = _interopRequireDefault(_contractStatusEdit);

var _memberStatuses = require('./crm/home/member-statuses.vue');

var _memberStatuses2 = _interopRequireDefault(_memberStatuses);

var _memberStatusEdit = require('./crm/home/member-status-edit.vue');

var _memberStatusEdit2 = _interopRequireDefault(_memberStatusEdit);

var _editTag = require('./crm/home/edit-tag.vue');

var _editTag2 = _interopRequireDefault(_editTag);

var _enterAdmission = require('./crm/home/enter-admission.vue');

var _enterAdmission2 = _interopRequireDefault(_enterAdmission);

var _outAdmission = require('./crm/home/out-admission.vue');

var _outAdmission2 = _interopRequireDefault(_outAdmission);

var _admissionInfo = require('./crm/home/admission-info.vue');

var _admissionInfo2 = _interopRequireDefault(_admissionInfo);

var _memberTerms = require('./crm/home/member-terms.vue');

var _memberTerms2 = _interopRequireDefault(_memberTerms);

var _modal3 = require('./admission/modal.vue');

var _modal4 = _interopRequireDefault(_modal3);

var _index9 = require('./admission/index.vue');

var _index10 = _interopRequireDefault(_index9);

var _table = require('./admission/table.vue');

var _table2 = _interopRequireDefault(_table);

var _dashboard = require('./admission/dashboard.vue');

var _dashboard2 = _interopRequireDefault(_dashboard);

var _studioMember = require('./import/studio-member.vue');

var _studioMember2 = _interopRequireDefault(_studioMember);

var _checkErrorTable = require('./import/check-error-table.vue');

var _checkErrorTable2 = _interopRequireDefault(_checkErrorTable);

var _previewTable = require('./import/preview-table.vue');

var _previewTable2 = _interopRequireDefault(_previewTable);

var _form = require('./invoice_setting/form.vue');

var _form2 = _interopRequireDefault(_form);

var _branchPaymentMethods = require('./pos/branch-payment-methods.vue');

var _branchPaymentMethods2 = _interopRequireDefault(_branchPaymentMethods);

var _orderBoughtItemTicket = require('./pos/order-bought-item-ticket.vue');

var _orderBoughtItemTicket2 = _interopRequireDefault(_orderBoughtItemTicket);

var _index11 = require('./fee_management/index.vue');

var _index12 = _interopRequireDefault(_index11);

var _index13 = require('./event/index.vue');

var _index14 = _interopRequireDefault(_index13);

var _modal5 = require('./event/modal.vue');

var _modal6 = _interopRequireDefault(_modal5);

var _index15 = require('./studio_app_setting/index.vue');

var _index16 = _interopRequireDefault(_index15);

var _modal7 = require('./coupon/modal.vue');

var _modal8 = _interopRequireDefault(_modal7);

var _view_modal = require('./coupon/view_modal.vue');

var _view_modal2 = _interopRequireDefault(_view_modal);

var _index17 = require('./coupon/index.vue');

var _index18 = _interopRequireDefault(_index17);

var _vueDatepicker = require('../../../../../global/vue-datepicker/vue-datepicker.vue');

var _vueDatepicker2 = _interopRequireDefault(_vueDatepicker);

var _form3 = require('./line_pay_setting/form.vue');

var _form4 = _interopRequireDefault(_form3);

var _vue3 = require('@fullcalendar/vue');

var _vue4 = _interopRequireDefault(_vue3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('./reports');
require('./admission');
require('./salseman');
require('./print');
require('./message');
require('./studio');
require('./pos');
require('./pos_quick');
require('./cms');
require('./dashboard');
require('./salary');
require('./bot');
require('./plan');
require('./bonus');
require('./customer');
require('./import');
require('./studio_business');
require('./room');
require('./studio_business_app');
require('./service_provider_execute_module');
require('./mega_menu');
require('./service');
require('./system');
require('./export');
require('./contract');
require('./schedule');
require('./external_link');
require('./custom_service_bookable_setting');
require('./contract_tag');
require('./notify');
require('./system_right');
require('./branch_fee_deduction');
require('./member');
require('./line_bot');
require('./checkstudio');
require('./class_booking');
require('./layout_setting');
require('./approval_term');
require('./dynamic_parameter');
require('./agree-term');
require('./verification_appropriation');
require('./studio_plan');
require('./crm');
require('./member_contract');
require('./iot');
require('./product_group');
require('./live_link');
require('./media');
require('./service_booking');
require('./fullcalendar');
require('./studio_app_setting');
require('./subscribe');
require('./custom_field');
require('./merchant');
require('./firebase_cloud_message_setting');
require('./book/widget_class_batch');

_vue2.default.component('full-calendar', _vue4.default);

_vue2.default.component('datepicker', _vueDatepicker2.default);

_vue2.default.component('coupon-modal', _modal8.default);
_vue2.default.component('coupon-view-modal', _view_modal2.default);
_vue2.default.component('coupon-index', _index18.default);

_vue2.default.component('GmapMap', _map2.default);
_vue2.default.component('GmapMarker', _marker2.default);
_vue2.default.component('GmapCluster', _cluster2.default);
_vue2.default.component('GmapInfoWindow', _infoWindow2.default);
_vue2.default.component('GmapPolyline', _polyline2.default);
_vue2.default.component('GmapPolygon', _polygon2.default);
_vue2.default.component('GmapCircle', _circle2.default);
_vue2.default.component('GmapRectangle', _rectangle2.default);
_vue2.default.component('GmapAutocomplete', _autocomplete2.default);
_vue2.default.component('GmapPlaceInput', _placeInput2.default);
_vue2.default.component('GmapStreetViewPanorama', _streetViewPanorama2.default);

_vue2.default.component('order-modal', _orderModal2.default);
_vue2.default.component('order-list-pay', _orderListPay2.default);
_vue2.default.component('order-list-unpay', _orderListUnpay2.default);
_vue2.default.component('order-edit', _order_edit2.default);
_vue2.default.component('order-show', _order_show2.default);
_vue2.default.component('order-refund', _orderRefund2.default);
_vue2.default.component('order-select', _orderSelect2.default);
_vue2.default.component('webadmin-order-remark', _orderRemark2.default);
_vue2.default.component('webadmin-order-salseman', _orderSalseman2.default);
_vue2.default.component('webadmin-invoice-manaual', _invoiceManaual2.default);
_vue2.default.component('order-detail-list', _order_detail_list2.default);
_vue2.default.component('order-detail-item-show', _order_detail_item_show2.default);
_vue2.default.component('order-detail-item-edit', _order_detail_item_edit2.default);
_vue2.default.component('order-detail-item-refund', _order_detail_item_refund2.default);
_vue2.default.component('product-list', _product_list2.default);
_vue2.default.component('product-append', _product_append2.default);
_vue2.default.component('product-item-show', _product_item_show2.default);
_vue2.default.component('commonly-used-items-list', _list2.default);
_vue2.default.component('commonly-used-discounts-list', _list4.default);
_vue2.default.component('tag-list', _tagList2.default);
_vue2.default.component('customer-search', _index2.default);
_vue2.default.component('customer-list-modal', _manageCustomerListModal2.default);
_vue2.default.component('ticket-list', _ticketList2.default);
_vue2.default.component('ticket-modal', _ticketModal2.default);
_vue2.default.component('location-list', _index4.default);
_vue2.default.component('location-modal', _modal2.default);
_vue2.default.component('lesson-quantity-searching', _index6.default);
_vue2.default.component('cancel-policy-list', _cancelPolicyList2.default);
_vue2.default.component('cancel-policy-modal', _cancelPolicyModal2.default);
_vue2.default.component('upcoming-booking', _upcomingBooking2.default);
_vue2.default.component('profile', _profile2.default);
_vue2.default.component('right-sidebar', _rightSidebar2.default);
_vue2.default.component('crm-home', _index8.default);
_vue2.default.component('crm-home-main', _main2.default);
_vue2.default.component('add-member-credit-modal', _addMemberCreditModal2.default);
_vue2.default.component('valid-plan-detail-records', _validPlanDetailRecords2.default);
_vue2.default.component('create-customer', _createCustomer2.default);
_vue2.default.component('content-card', _contentCard2.default);
_vue2.default.component('valid-plan', _validPlan2.default);
_vue2.default.component('contract-edit', _contractEdit2.default);
_vue2.default.component('contract-time-edit', _contractTimeEdit2.default);
_vue2.default.component('contract-point-edit', _contractPointEdit2.default);
_vue2.default.component('contract-status-edit', _contractStatusEdit2.default);
_vue2.default.component('member-statuses', _memberStatuses2.default);
_vue2.default.component('member-status-edit', _memberStatusEdit2.default);
_vue2.default.component('edit-tag', _editTag2.default);
_vue2.default.component('webadmin-invoice-setting-form', _form2.default);
_vue2.default.component('admission-info-modal', _admissionInfo2.default);
_vue2.default.component('member-terms', _memberTerms2.default);
_vue2.default.component('v-enter-admission-modal', _enterAdmission2.default);
_vue2.default.component('v-out-admission-modal', _outAdmission2.default);
_vue2.default.component('webadmin-order-issue-method', _order_issue_method2.default);
_vue2.default.component('webadmin-branch-payment-methods', _branchPaymentMethods2.default);
_vue2.default.component('order-bought-item-ticket', _orderBoughtItemTicket2.default);
_vue2.default.component('order-payment-show', _orderPaymentShow2.default);
_vue2.default.component('import-studio-member', _studioMember2.default);
_vue2.default.component('import-check-error-table', _checkErrorTable2.default);
_vue2.default.component('import-preview-table', _previewTable2.default);
_vue2.default.component('fee-management', _index12.default);
_vue2.default.component('event', _index14.default);
_vue2.default.component('event-modal', _modal6.default);
_vue2.default.component('webadmin-studio-app-setting', _index16.default);

_vue2.default.component('line-pay-form', _form4.default);

},{"../../../../../global/vue-datepicker/vue-datepicker.vue":810,"../../../../../global/vue_google_maps/components/autocomplete.vue":813,"../../../../../global/vue_google_maps/components/circle":814,"../../../../../global/vue_google_maps/components/cluster":815,"../../../../../global/vue_google_maps/components/infoWindow.vue":816,"../../../../../global/vue_google_maps/components/map.vue":817,"../../../../../global/vue_google_maps/components/marker":819,"../../../../../global/vue_google_maps/components/placeInput.vue":820,"../../../../../global/vue_google_maps/components/polygon":821,"../../../../../global/vue_google_maps/components/polyline":822,"../../../../../global/vue_google_maps/components/rectangle":823,"../../../../../global/vue_google_maps/components/streetViewPanorama.vue":824,"./admission":1001,"./admission/dashboard.vue":1000,"./admission/index.vue":1002,"./admission/modal.vue":1003,"./admission/table.vue":1005,"./agree-term":1008,"./approval_term":1010,"./bonus":1014,"./book/widget_class_batch":1019,"./bot":1024,"./branch_fee_deduction":1027,"./cancel_policy/cancel-policy-list.vue":1030,"./cancel_policy/cancel-policy-modal.vue":1031,"./checkstudio":1035,"./class_booking":1040,"./cms":1045,"./commonly_used_discounts/list.vue":1051,"./commonly_used_items/list.vue":1052,"./contract":1059,"./contract_tag":1063,"./coupon/index.vue":1065,"./coupon/modal.vue":1066,"./coupon/view_modal.vue":1067,"./crm":1111,"./crm/content-card.vue":1082,"./crm/create-customer.vue":1083,"./crm/home/add-member-credit-modal.vue":1090,"./crm/home/admission-info.vue":1091,"./crm/home/contract-edit.vue":1092,"./crm/home/contract-point-edit.vue":1093,"./crm/home/contract-status-edit.vue":1094,"./crm/home/contract-time-edit.vue":1095,"./crm/home/edit-tag.vue":1096,"./crm/home/enter-admission.vue":1097,"./crm/home/index.vue":1099,"./crm/home/main.vue":1100,"./crm/home/member-status-edit.vue":1101,"./crm/home/member-statuses.vue":1102,"./crm/home/member-terms.vue":1103,"./crm/home/out-admission.vue":1104,"./crm/home/profile.vue":1105,"./crm/home/right-sidebar.vue":1106,"./crm/home/upcoming-booking.vue":1108,"./crm/home/valid-plan-detail-records.vue":1109,"./crm/home/valid-plan.vue":1110,"./custom_field":1123,"./custom_service_bookable_setting":1129,"./customer":1132,"./customer/index.vue":1133,"./customer/manage-customer-list-modal.vue":1134,"./dashboard":1141,"./dynamic_parameter":1150,"./event/index.vue":1153,"./event/modal.vue":1154,"./export":1155,"./external_link":1158,"./fee_management/index.vue":1160,"./firebase_cloud_message_setting":1161,"./fullcalendar":1178,"./import":1189,"./import/check-error-table.vue":1188,"./import/preview-table.vue":1191,"./import/studio-member.vue":1192,"./invoice_setting/form.vue":1194,"./iot":1195,"./layout_setting":1201,"./lesson_quantity_searching/index.vue":1208,"./line_bot":1210,"./line_pay_setting/form.vue":1213,"./live_link":1215,"./location/index.vue":1216,"./location/modal.vue":1217,"./media":1218,"./mega_menu":1220,"./member":1223,"./member_contract":1229,"./merchant":1233,"./message":1238,"./notify":1240,"./plan":1242,"./pos":1253,"./pos/branch-payment-methods.vue":1251,"./pos/invoice-manaual.vue":1254,"./pos/order-bought-item-ticket.vue":1255,"./pos/order-list-pay.vue":1256,"./pos/order-list-unpay.vue":1257,"./pos/order-modal.vue":1258,"./pos/order-payment-show.vue":1311,"./pos/order-refund.vue":1312,"./pos/order-remark.vue":1313,"./pos/order-salseman.vue":1314,"./pos/order-select.vue":1315,"./pos/order_detail_item_edit.vue":1316,"./pos/order_detail_item_refund.vue":1317,"./pos/order_detail_item_show.vue":1318,"./pos/order_detail_list.vue":1319,"./pos/order_edit.vue":1320,"./pos/order_issue_method.vue":1321,"./pos/order_show.vue":1322,"./pos/product_append.vue":1325,"./pos/product_item_show.vue":1326,"./pos/product_list.vue":1327,"./pos_quick":1328,"./print":1334,"./product_group":1342,"./reports":1359,"./room":1397,"./salary":1406,"./salseman":1418,"./schedule":1424,"./service":1427,"./service_booking":1434,"./service_provider_execute_module":1439,"./studio":1444,"./studio_app_setting":1447,"./studio_app_setting/index.vue":1448,"./studio_business":1450,"./studio_business_app":1452,"./studio_plan":1455,"./subscribe":1456,"./system":1461,"./system_right":1463,"./tag/tag-list.vue":1465,"./ticket/ticket-list.vue":1466,"./ticket/ticket-modal.vue":1467,"./verification_appropriation":1469,"@fullcalendar/vue":15,"vue":792}],1194:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.color-gray[_v-f53fa3ec] {\n  color: #ccc; }\n\n/* line 5, stdin */\n#invoice_online_print_remark[_v-f53fa3ec] {\n  max-width: 50vw;\n  display: inline-block; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {},
    data: function data() {
        return {};
    },

    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('webadmin/invoice', ['fetchCharities', 'fetchBranchSetting', 'update']), {
        branchChangeCallBack: function () {
            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(branchId) {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!(branchId == 'null')) {
                                    _context.next = 2;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 2:
                                _context.next = 4;
                                return this.fetchBranchSetting({
                                    branchId: branchId
                                });

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function branchChangeCallBack(_x) {
                return _ref.apply(this, arguments);
            }

            return branchChangeCallBack;
        }(),
        updateSetting: function () {
            var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(settingId) {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.update(settingId);

                            case 2:
                                status = _context2.sent;

                                $17.swal({
                                    title: '更改設定資料成功',
                                    text: "",
                                    type: 'success',
                                    showCancelButton: false
                                });

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function updateSetting(_x2) {
                return _ref2.apply(this, arguments);
            }

            return updateSetting;
        }()
    }),
    mounted: function mounted() {
        this.fetchCharities();
        var vm = this;
    },
    watch: {
        branchId: function () {
            var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(val, oldVal) {
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                if (this.isBranch) {
                                    this.branchChangeCallBack(val);
                                }

                            case 1:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function branchId(_x3, _x4) {
                return _ref3.apply(this, arguments);
            }

            return branchId;
        }()
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId', 'isBranch']), (0, _vuex.mapState)('webadmin/invoice', ['charities', 'setting']), {
        active: {
            get: function get() {
                return this.$store.state.webadmin.invoice.setting.active;
            },
            set: function set(newValue) {
                this.$store.commit('webadmin/invoice/SET_SETTING', {
                    'key': 'active',
                    value: newValue
                });
                if (!newValue) {
                    this.$store.commit('webadmin/invoice/SET_SETTING', {
                        'key': 'invoice_online',
                        value: false
                    });
                }
            }
        },
        hash_key: {
            get: function get() {
                return this.$store.state.webadmin.invoice.setting.hash_key;
            },
            set: function set(newValue) {
                this.$store.commit('webadmin/invoice/SET_SETTING', {
                    'key': 'hash_key',
                    value: newValue
                });
            }
        },
        hash_iv: {
            get: function get() {
                return this.$store.state.webadmin.invoice.setting.hash_iv;
            },
            set: function set(newValue) {
                this.$store.commit('webadmin/invoice/SET_SETTING', {
                    'key': 'hash_iv',
                    value: newValue
                });
            }
        },
        merchant_id: {
            get: function get() {
                return this.$store.state.webadmin.invoice.setting.merchant_id;
            },
            set: function set(newValue) {
                this.$store.commit('webadmin/invoice/SET_SETTING', {
                    'key': 'merchant_id',
                    value: newValue
                });
            }
        },
        auto_issue: {
            get: function get() {
                return this.$store.state.webadmin.invoice.setting.auto_issue;
            },
            set: function set(newValue) {
                this.$store.commit('webadmin/invoice/SET_SETTING', {
                    'key': 'auto_issue',
                    value: newValue
                });
            }
        },
        auto_allowance_issue: {
            get: function get() {
                return this.$store.state.webadmin.invoice.setting.auto_allowance_issue;
            },
            set: function set(newValue) {
                this.$store.commit('webadmin/invoice/SET_SETTING', {
                    'key': 'auto_allowance_issue',
                    value: newValue
                });
            }
        },
        invoice_online: {
            get: function get() {
                return this.$store.state.webadmin.invoice.setting.invoice_online;
            },
            set: function set(newValue) {
                this.$store.commit('webadmin/invoice/SET_SETTING', {
                    'key': 'invoice_online',
                    value: newValue
                });
            }
        },
        allow_duplicate_invoice_on_site: {
            get: function get() {
                return this.$store.state.webadmin.invoice.setting.allow_duplicate_invoice_on_site;
            },
            set: function set(newValue) {
                this.$store.commit('webadmin/invoice/SET_SETTING', {
                    'key': 'allow_duplicate_invoice_on_site',
                    value: newValue
                });
            }
        },
        invoice_online_print_remark: {
            get: function get() {
                return this.$store.state.webadmin.invoice.setting.invoice_online_print_remark;
            },
            set: function set(newValue) {
                this.$store.commit('webadmin/invoice/SET_SETTING', {
                    'key': 'invoice_online_print_remark',
                    value: newValue
                });
            }
        },
        issue_methods_active: {
            get: function get() {
                return this.$store.state.webadmin.invoice.setting.issue_methods.active;
            },
            set: function set(newValue) {
                this.$store.commit('webadmin/invoice/SET_ISSUE_ACTIVE', newValue);
            }
        },
        issue_methods_default: {
            get: function get() {
                return this.$store.state.webadmin.invoice.setting.issue_methods.default;
            },
            set: function set(newValue) {
                var active = this.issue_methods_active;
                this.issue_methods_active.indexOf(newValue) == -1 ? this.$store.commit('webadmin/invoice/APPEND_ISSUE_ACTIVE', newValue) : '';
                this.$store.commit('webadmin/invoice/SET_ISSUE_DEFAULT', newValue);
            }
        },
        setting_charities: {
            get: function get() {
                return this.$store.state.webadmin.invoice.setting.charities;
            },
            set: function set(newValue) {
                this.$store.commit('webadmin/invoice/SET_SETTING', {
                    'key': 'charities',
                    value: newValue
                });
            }
        },
        ubn: {
            get: function get() {
                return this.$store.state.webadmin.invoice.setting.ubn;
            },
            set: function set(newValue) {
                this.$store.commit('webadmin/invoice/SET_SETTING', {
                    'key': 'ubn',
                    value: newValue
                });
            }
        },
        show_title: {
            get: function get() {
                return this.$store.state.webadmin.invoice.setting.show_title;
            },
            set: function set(newValue) {
                this.$store.commit('webadmin/invoice/SET_SETTING', {
                    'key': 'show_title',
                    value: newValue
                });
            }
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-f53fa3ec=\"\">\n    <v-select-studio-and-branch :studio_id=\"studioId\" :branch_id=\"branchId\" :branch-change-call-back=\"branchChangeCallBack\" :branch-without-filtered-option=\"false\" _v-f53fa3ec=\"\"></v-select-studio-and-branch>\n    <h3 _v-f53fa3ec=\"\">  ezPay簡單付 電子發票設定</h3>\n    <form class=\"form-horizontal\" _v-f53fa3ec=\"\">\n        <div class=\"form-group\" _v-f53fa3ec=\"\">\n            <label for=\"active\" class=\"col-sm-2 control-label\" _v-f53fa3ec=\"\">啟用</label>\n            <div class=\"col-sm-10\" _v-f53fa3ec=\"\">\n                <input type=\"checkbox\" name=\"active\" value=\"1\" v-model=\"active\" id=\"active\" _v-f53fa3ec=\"\"> \n                <label for=\"active\" _v-f53fa3ec=\"\">啟用ezPay簡單付電子發票</label>\n            </div>\n        </div>\n        <div class=\"form-group\" _v-f53fa3ec=\"\">\n            <label for=\"ubn\" class=\"col-sm-2 control-label\" _v-f53fa3ec=\"\">統一編號</label>\n            <div class=\"col-sm-10\" _v-f53fa3ec=\"\">\n                <input type=\"text\" class=\"form-control\" id=\"ubn\" v-model=\"ubn\" _v-f53fa3ec=\"\">\n            </div>\n        </div>\n        <div class=\"form-group\" _v-f53fa3ec=\"\">\n            <label for=\"show-title\" class=\"col-sm-2 control-label\" _v-f53fa3ec=\"\">營業人企業識別標章</label>\n            <div class=\"col-sm-10\" _v-f53fa3ec=\"\">\n                <input type=\"text\" class=\"form-control\" id=\"show-title\" v-model=\"show_title\" _v-f53fa3ec=\"\">\n            </div>\n        </div>\n        <div class=\"form-group\" _v-f53fa3ec=\"\">\n            <label for=\"hash-key\" class=\"col-sm-2 control-label\" _v-f53fa3ec=\"\">Hash Key</label>\n            <div class=\"col-sm-10\" _v-f53fa3ec=\"\">\n                <input type=\"text\" class=\"form-control\" id=\"hash-key\" v-model=\"hash_key\" _v-f53fa3ec=\"\">\n            </div>\n        </div>\n        <div class=\"form-group\" _v-f53fa3ec=\"\">\n            <label for=\"hash-iv\" class=\"col-sm-2 control-label\" _v-f53fa3ec=\"\">Hash IV</label>\n            <div class=\"col-sm-10\" _v-f53fa3ec=\"\">\n                <input type=\"text\" class=\"form-control\" id=\"hash-iv\" v-model=\"hash_iv\" _v-f53fa3ec=\"\">\n            </div>\n        </div>\n        <div class=\"form-group\" _v-f53fa3ec=\"\">\n            <label for=\"merchant-id\" class=\"col-sm-2 control-label\" _v-f53fa3ec=\"\">商店代號</label>\n            <div class=\"col-sm-10\" _v-f53fa3ec=\"\">\n                <input type=\"text\" class=\"form-control\" id=\"merchant-id\" v-model=\"merchant_id\" _v-f53fa3ec=\"\">\n            </div>\n        </div>\n        <div class=\"form-group\" _v-f53fa3ec=\"\">\n            <label for=\"issue-method\" class=\"col-sm-2 control-label\" _v-f53fa3ec=\"\">允許開立方式</label>\n            <div class=\"col-sm-3\" _v-f53fa3ec=\"\">\n                <input type=\"checkbox\" name=\"issue_methods_active\" id=\"active-ubn\" value=\"UBN\" v-model=\"issue_methods_active\" :disabled=\"issue_methods_default=='UBN'\" _v-f53fa3ec=\"\">\n                <label for=\"active-ubn\" _v-f53fa3ec=\"\">三聯式發票</label>\n            </div>\n            <div class=\"col-sm-3\" _v-f53fa3ec=\"\">\n                <input type=\"radio\" name=\"issue_methods_default\" id=\"default-ubn\" value=\"UBN\" v-model=\"issue_methods_default\" _v-f53fa3ec=\"\">\n                <label for=\"default-ubn\" _v-f53fa3ec=\"\">預設</label>\n            </div>\n        </div>\n        <div class=\"form-group\" _v-f53fa3ec=\"\">\n            <label for=\"issue-method\" class=\"col-sm-2 control-label\" _v-f53fa3ec=\"\"></label>\n            <div class=\"col-sm-3\" _v-f53fa3ec=\"\">\n                <input type=\"checkbox\" name=\"issue_methods_active\" id=\"active-love\" value=\"LoveCode\" v-model=\"issue_methods_active\" :disabled=\"issue_methods_default=='LoveCode'\" _v-f53fa3ec=\"\">\n                <label for=\"active-love\" _v-f53fa3ec=\"\">愛心碼</label>\n            </div>\n            <div class=\"col-sm-3\" _v-f53fa3ec=\"\">\n                <input type=\"radio\" name=\"issue_methods_default\" id=\"default-love\" value=\"LoveCode\" v-model=\"issue_methods_default\" _v-f53fa3ec=\"\">\n                <label for=\"default-love\" _v-f53fa3ec=\"\">預設</label>\n            </div>\n        </div>\n        <div class=\"form-group\" _v-f53fa3ec=\"\">\n            <label for=\"issue-method\" class=\"col-sm-2 control-label\" _v-f53fa3ec=\"\"></label>\n            <div class=\"col-sm-3\" _v-f53fa3ec=\"\">\n                <input type=\"checkbox\" name=\"issue_methods_active\" id=\"active-print\" value=\"PrintCode\" v-model=\"issue_methods_active\" :disabled=\"issue_methods_default=='PrintCode'\" _v-f53fa3ec=\"\">\n                <label for=\"active-print\" _v-f53fa3ec=\"\">索取紙本</label>\n            </div>\n            <div class=\"col-sm-3\" _v-f53fa3ec=\"\">\n                <input type=\"radio\" name=\"issue_methods_default\" id=\"default-print\" value=\"PrintCode\" v-model=\"issue_methods_default\" _v-f53fa3ec=\"\">\n                <label for=\"default-print\" _v-f53fa3ec=\"\">預設</label>\n            </div>\n        </div>\n        <div class=\"form-group\" _v-f53fa3ec=\"\">\n            <label for=\"issue-method\" class=\"col-sm-2 control-label\" _v-f53fa3ec=\"\"></label>\n            <div class=\"col-sm-3\" _v-f53fa3ec=\"\">\n                <input type=\"checkbox\" name=\"issue_methods_active\" id=\"active-phone\" value=\"CarrierPhone\" v-model=\"issue_methods_active\" :disabled=\"issue_methods_default=='CarrierPhone'\" _v-f53fa3ec=\"\">\n                <label for=\"active-phone\" _v-f53fa3ec=\"\">手機條碼</label>\n            </div>\n            <div class=\"col-sm-3\" _v-f53fa3ec=\"\">\n                <input type=\"radio\" name=\"issue_methods_default\" id=\"default-phone\" value=\"CarrierPhone\" v-model=\"issue_methods_default\" _v-f53fa3ec=\"\">\n                <label for=\"default-phone\" _v-f53fa3ec=\"\">預設</label>\n            </div>\n        </div>\n        <div class=\"form-group\" _v-f53fa3ec=\"\">\n            <label for=\"issue-method\" class=\"col-sm-2 control-label\" _v-f53fa3ec=\"\"></label>\n            <div class=\"col-sm-3\" _v-f53fa3ec=\"\">\n                <input type=\"checkbox\" name=\"issue_methods_active\" id=\"active-npc\" value=\"CarrierNPC\" v-model=\"issue_methods_active\" :disabled=\"issue_methods_default=='CarrierNPC'\" _v-f53fa3ec=\"\">\n                <label for=\"active-npc\" _v-f53fa3ec=\"\">自然人憑證條碼</label>\n            </div>\n            <div class=\"col-sm-3\" _v-f53fa3ec=\"\">\n                <input type=\"radio\" name=\"issue_methods_default\" id=\"default-npc\" value=\"CarrierNPC\" v-model=\"issue_methods_default\" _v-f53fa3ec=\"\">\n                <label for=\"default-npc\" _v-f53fa3ec=\"\">預設</label>\n            </div>\n        </div>\n        <div class=\"form-group\" _v-f53fa3ec=\"\">\n            <label for=\"issue-method\" class=\"col-sm-2 control-label\" _v-f53fa3ec=\"\"></label>\n            <div class=\"col-sm-3\" _v-f53fa3ec=\"\">\n                <input type=\"checkbox\" name=\"issue_methods_active\" id=\"active-pay2go\" value=\"CarrierPay2Go\" v-model=\"issue_methods_active\" :disabled=\"issue_methods_default=='CarrierPay2Go'\" _v-f53fa3ec=\"\">\n                <label for=\"active-pay2go\" _v-f53fa3ec=\"\">會員載具</label>\n            </div>\n            <div class=\"col-sm-3\" _v-f53fa3ec=\"\">\n                <input type=\"radio\" name=\"issue_methods_default\" id=\"default-pay2go\" value=\"CarrierPay2Go\" v-model=\"issue_methods_default\" _v-f53fa3ec=\"\">\n                <label for=\"default-pay2go\" _v-f53fa3ec=\"\">預設</label>\n            </div>\n        </div>\n        <div class=\"form-group\" _v-f53fa3ec=\"\">\n            <label for=\"issue-method\" class=\"col-sm-2 control-label\" _v-f53fa3ec=\"\"></label>\n            <div class=\"col-sm-3\" _v-f53fa3ec=\"\">\n                <input type=\"checkbox\" name=\"issue_methods_active\" id=\"active-none\" value=\"None\" v-model=\"issue_methods_active\" :disabled=\"issue_methods_default=='None'\" _v-f53fa3ec=\"\">\n                <label for=\"active-none\" _v-f53fa3ec=\"\">不開立</label>\n            </div>\n            <div class=\"col-sm-3\" _v-f53fa3ec=\"\">\n                <input type=\"radio\" name=\"issue_methods_default\" id=\"default-none\" value=\"None\" v-model=\"issue_methods_default\" _v-f53fa3ec=\"\">\n                <label for=\"default-none\" _v-f53fa3ec=\"\">預設</label>\n            </div>\n        </div>\n        <div class=\"form-group\" _v-f53fa3ec=\"\">\n            <label for=\"charity\" class=\"col-sm-2 control-label\" _v-f53fa3ec=\"\">捐贈機構</label>\n            <div class=\"col-sm-10\" _v-f53fa3ec=\"\">\n                <v-mutiselect :model.sync=\"setting_charities\" :options=\"charities\" :multiple=\"true\" :close-on-select=\"true\" :clear-on-select=\"true\" :searchable=\"true\" label=\"name\" track-by=\"id\" tag-name=\"name\" placeholder=\"請選擇\" _v-f53fa3ec=\"\">\n            </v-mutiselect></div>\n        </div>\n        <div class=\"form-group\" _v-f53fa3ec=\"\">\n            <label for=\"auto-issue\" class=\"col-sm-2 control-label\" _v-f53fa3ec=\"\">自動開立發票</label>\n            <div class=\"col-sm-10\" _v-f53fa3ec=\"\">\n                <input type=\"checkbox\" value=\"1\" name=\"auto-issue\" id=\"auto_issue\" v-model=\"auto_issue\" _v-f53fa3ec=\"\"> \n                <label for=\"auto_issue\" _v-f53fa3ec=\"\">結帳後，同步開立發票</label>\n            </div>\n        </div>\n        <div class=\"form-group\" _v-f53fa3ec=\"\">\n            <label for=\"auto-allowance\" class=\"col-sm-2 control-label\" _v-f53fa3ec=\"\">自動折讓發票</label>\n            <div class=\"col-sm-10\" _v-f53fa3ec=\"\">\n                <input type=\"checkbox\" value=\"1\" name=\"auto-allowance\" v-model=\"auto_allowance_issue\" id=\"auto_allowance_issue\" _v-f53fa3ec=\"\"> \n                <label for=\"auto_allowance_issue\" _v-f53fa3ec=\"\">退費後，同步折讓發票</label>\n            </div>\n        </div>\n        <div class=\"form-group\" v-if=\"active\" _v-f53fa3ec=\"\">\n            <label for=\"\" class=\"col-sm-2 control-label\" _v-f53fa3ec=\"\">線上開立發票</label>\n            <div class=\"col-sm-10\" _v-f53fa3ec=\"\">\n                <input type=\"checkbox\" value=\"1\" name=\"online-issue\" v-model=\"invoice_online\" id=\"invoice_online\" _v-f53fa3ec=\"\"> \n                <label for=\"invoice_online\" _v-f53fa3ec=\"\">允許客戶在線上購買時，可自行選擇開立發票方式</label>\n            </div>\n        </div>\n        <div class=\"form-group\" v-show=\"invoice_online\" _v-f53fa3ec=\"\">\n            <label for=\"\" class=\"col-sm-2 control-label\" _v-f53fa3ec=\"\"></label>\n            <div class=\"col-sm-10\" _v-f53fa3ec=\"\">\n                <input type=\"checkbox\" :true-value=\"1\" name=\"allow_duplicate_invoice_on_site\" v-model=\"allow_duplicate_invoice_on_site\" id=\"allow_duplicate_invoice_on_site\" _v-f53fa3ec=\"\">\n                <label for=\"allow_duplicate_invoice_on_site\" _v-f53fa3ec=\"\">允許客戶索取二聯式紙本</label>\n            </div>\n        </div>\n        <div class=\"form-group\" v-show=\"invoice_online\" _v-f53fa3ec=\"\">\n            <label for=\"\" class=\"col-sm-2 control-label\" _v-f53fa3ec=\"\"></label>\n            <div class=\"col-sm-10\" _v-f53fa3ec=\"\">\n                <label for=\"invoice_online_print_remark\" _v-f53fa3ec=\"\">\n                    <small _v-f53fa3ec=\"\">當客戶要求索取紙本發票時的說明文字\n                        <small class=\"color-gray\" _v-f53fa3ec=\"\"> (限50字) :</small>\n                    </small>\n                </label>\n            </div>\n        </div>\n        <div class=\"form-group\" v-show=\"invoice_online\" _v-f53fa3ec=\"\">\n            <label for=\"\" class=\"col-sm-2 control-label\" _v-f53fa3ec=\"\"></label>\n            <div class=\"col-sm-10\" _v-f53fa3ec=\"\">\n                <textarea rows=\"2\" name=\"invoice-online-print-remark\" class=\"form-control\" v-model=\"invoice_online_print_remark\" maxlength=\"50\" id=\"invoice_online_print_remark\" _v-f53fa3ec=\"\">                    </textarea>\n            </div>\n        </div>\n        <div class=\"form-group\" _v-f53fa3ec=\"\">\n            <label for=\"\" class=\"col-sm-2 control-label\" _v-f53fa3ec=\"\"></label>\n            <div class=\"col-sm-3\" _v-f53fa3ec=\"\">\n                <input type=\"hidden\" name=\"type\" value=\"pay2go\" v-model=\"setting.type\" _v-f53fa3ec=\"\">\n                <button type=\"button\" class=\"btn btn-primary btn-block\" @click=\"updateSetting(setting.id)\" _v-f53fa3ec=\"\">送出</button>\n            </div>\n        </div>\n    </form>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.color-gray[_v-f53fa3ec] {\n  color: #ccc; }\n\n/* line 5, stdin */\n#invoice_online_print_remark[_v-f53fa3ec] {\n  max-width: 50vw;\n  display: inline-block; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-f53fa3ec", module.exports)
  } else {
    hotAPI.update("_v-f53fa3ec", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1195:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _kioskSettingIndex = require('./kiosk-setting-index.vue');

var _kioskSettingIndex2 = _interopRequireDefault(_kioskSettingIndex);

var _kioskSettingForm = require('./kiosk-setting-form.vue');

var _kioskSettingForm2 = _interopRequireDefault(_kioskSettingForm);

var _kioskSettingBasicTicketOnlySaleFlow = require('./kiosk-setting-basic-ticket-only-sale-flow.vue');

var _kioskSettingBasicTicketOnlySaleFlow2 = _interopRequireDefault(_kioskSettingBasicTicketOnlySaleFlow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('kiosk-setting-index', _kioskSettingIndex2.default);
_vue2.default.component('kiosk-setting-form', _kioskSettingForm2.default);
_vue2.default.component('kiosk-setting-basic-ticket-only-sale-flow', _kioskSettingBasicTicketOnlySaleFlow2.default);

},{"./kiosk-setting-basic-ticket-only-sale-flow.vue":1196,"./kiosk-setting-form.vue":1197,"./kiosk-setting-index.vue":1198,"vue":792}],1196:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.group[_v-2c7810a4], .row[_v-2c7810a4] {\n  margin-top: 15px;\n  margin-bottom: 15px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        defaultData: {
            default: {}
        },
        mode: {
            default: ""
        }
    },
    data: function data() {
        return {
            postData: {
                'index_start_button_name': '',
                'index_welcome_message': '',
                'select_product_countdown': null,
                'select_payment_method_countdown': null,
                'billed_success_countdown': null,
                'billed_success_tips': '',
                'billed_fail_countdown': null,
                'valid_payment_enums': [],
                'saleable_product_group_objects': {}
            },
            'available_product_group_objects': [],
            'available_payment_enums': [],
            tempSelectGroup: null,
            ajaxing: {
                productGroup: false,
                payment: false
            }
        };
    },
    mounted: function mounted() {
        this.getDefaultPayment();
        this.setCreateDefault(this.defaultData);
        this.fetchProductGroup();
    },

    watch: (0, _extends3.default)({
        postData: {
            handler: function handler(val) {
                this.$emit('changed', val);
                this.$emit('check-status', this.checkPostData());
            },

            deep: true
        },
        defaultData: {
            handler: function handler(val) {
                this.setCreateDefault(val);
            },

            deep: true
        }
    }, (0, _vuex.mapGetters)('webadmin/configure', ['ACTIVE_BRANCH_ID']), {
        ACTIVE_BRANCH_ID: function ACTIVE_BRANCH_ID(newVal) {
            this.fetchProductGroup();
        },
        tempSelectGroup: function tempSelectGroup(newVal) {
            if (!newVal || newVal == null || this.postData.saleable_product_group_objects[newVal.id] != undefined) {
                return;
            }

            this.postData.saleable_product_group_objects[newVal.id] = {
                id: newVal.id,
                name: newVal.name,
                order: 0
            };
        }
    }),
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId', 'isSeventeen', 'isStudio', 'isBranch']), (0, _vuex.mapGetters)('webadmin/configure', ['ACTIVE_BRANCH_ID'])),
    methods: {
        setCreateDefault: function setCreateDefault(val) {
            this.postData.index_start_button_name = val.index_start_button_name;
            this.postData.index_welcome_message = val.index_welcome_message;
            this.postData.select_product_countdown = val.select_product_countdown;
            this.postData.select_payment_method_countdown = val.select_payment_method_countdown;
            this.postData.billed_success_countdown = val.billed_success_countdown;
            this.postData.billed_success_tips = val.billed_success_tips;
            this.postData.billed_fail_countdown = val.billed_fail_countdown;

            if (this.mode == 'update') {
                this.postData.valid_payment_enums = val.valid_payment_enums;
                this.postData.saleable_product_group_objects = val.saleable_product_group_objects;
            }
            // this.available_payment_enums = val.available_payment_enums;
            // this.available_product_group_objects = val.available_product_group_objects;
        },
        getDefaultPayment: function getDefaultPayment() {
            var _this = this;

            this.ajaxing.payment = true;
            this.$http.get("/adminapi/kiosk/payment-methods").then(function (response) {
                _this.available_payment_enums = response.data;
                _this.ajaxing.payment = false;
            }, function (error) {
                _this.ajaxing.payment = false;
            });
        },
        fetchProductGroup: function fetchProductGroup() {
            var _this2 = this;

            this.group_items = [];
            this.ajaxing.productGroup = true;
            this.$http.get('/adminapi/product-group/' + this.ACTIVE_BRANCH_ID).then(function (response) {
                _this2.ajaxing.productGroup = false;
                _this2.available_product_group_objects = response.data;
            }, function (error) {
                _this2.ajaxing.productGroup = false;
            });
        },
        removeGroup: function removeGroup(id) {
            this.$delete(this.postData.saleable_product_group_objects, id);
        },
        checkPostData: function checkPostData() {
            if (!!this.postData.index_start_button_name && this.postData.select_product_countdown > 0 && this.postData.select_payment_method_countdown > 0 && this.postData.billed_success_countdown > 0 && this.postData.billed_fail_countdown > 0 && this.postData.select_product_countdown <= 200 && this.postData.select_payment_method_countdown <= 200 && this.postData.billed_success_countdown <= 200 && this.postData.billed_fail_countdown <= 200 && this.postData.valid_payment_enums.length <= 200 && (0, _keys2.default)(this.postData.saleable_product_group_objects).length > 0) {
                return true;
            }

            return false;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-2c7810a4=\"\">\n    <div class=\"row\" _v-2c7810a4=\"\">\n        <div class=\"col-xs-12\" _v-2c7810a4=\"\">\n            <h4 _v-2c7810a4=\"\">基礎售票</h4>\n        </div>\n    </div>\n    <div class=\"row\" _v-2c7810a4=\"\">\n        <div class=\"col-xs-2 col-xs-offset-1 text-right\" _v-2c7810a4=\"\">\n            <label for=\"index_start_button_name\" _v-2c7810a4=\"\">首頁啟動按鈕名稱<v-required _v-2c7810a4=\"\"></v-required></label>\n        </div> \n        <div class=\"col-xs-4 \" _v-2c7810a4=\"\">\n            <input type=\"text\" class=\"form-control\" v-model=\"postData.index_start_button_name\" id=\"index_start_button_name\" _v-2c7810a4=\"\">\n        </div> \n    </div>\n    <div class=\"row\" _v-2c7810a4=\"\">\n        <div class=\"col-xs-2 col-xs-offset-1 text-right\" _v-2c7810a4=\"\">\n            <label for=\"index_welcome_message\" _v-2c7810a4=\"\">首頁歡迎訊息</label>\n        </div> \n        <div class=\"col-xs-4 \" _v-2c7810a4=\"\">\n            <input type=\"text\" class=\"form-control\" v-model=\"postData.index_welcome_message\" id=\"index_welcome_message\" _v-2c7810a4=\"\">\n        </div> \n    </div>\n    <div class=\"row\" _v-2c7810a4=\"\">\n        <div class=\"col-xs-2 col-xs-offset-1 text-right\" _v-2c7810a4=\"\">\n            <label for=\"\" _v-2c7810a4=\"\">產品群組<v-required _v-2c7810a4=\"\"></v-required></label>\n        </div> \n        <div class=\"col-xs-4 \" _v-2c7810a4=\"\">\n            <v-spinner-button :ajaxing=\"ajaxing.productGroup\" _v-2c7810a4=\"\"></v-spinner-button>\n            <v-mutiselect v-show=\"!ajaxing.productGroup\" :model.sync=\"tempSelectGroup\" :options=\"available_product_group_objects\" :close-on-select=\"true\" :searchable=\"true\" :reset-after=\"true\" label=\"name\" track-by=\"id\" placeholder=\"請選擇群組\" _v-2c7810a4=\"\"></v-mutiselect>\n        </div> \n    </div>\n    <div class=\"group\" _v-2c7810a4=\"\">\n        <div class=\"row\" v-show=\"!ajaxing.productGroup\" _v-2c7810a4=\"\">\n            <div class=\"col-xs-2 col-xs-offset-1 text-right\" _v-2c7810a4=\"\">\n                \n            </div> \n            <div class=\"col-xs-2 \" _v-2c7810a4=\"\">\n                群組名稱\n            </div> \n            <div class=\"col-xs-2 \" _v-2c7810a4=\"\">\n                排序\n            </div> \n            <div class=\"col-xs-2 \" _v-2c7810a4=\"\">\n                \n            </div> \n        </div>\n    </div>\n    <div class=\"row\" v-show=\"!ajaxing.productGroup\" v-for=\"group in postData.saleable_product_group_objects\" _v-2c7810a4=\"\">\n        <div class=\"col-xs-2 col-xs-offset-1 text-right\" _v-2c7810a4=\"\">\n            \n        </div> \n        <div class=\"col-xs-2 \" _v-2c7810a4=\"\">\n            {{ group.name }}\n        </div> \n        <div class=\"col-xs-2 \" _v-2c7810a4=\"\">\n            <input type=\"number\" min=\"0\" class=\"form-control\" v-model=\"group.order\" _v-2c7810a4=\"\">\n        </div> \n        <div class=\"col-xs-2 \" _v-2c7810a4=\"\">\n            <a href=\"\" class=\"btn btn-default\" @click.prevent.stop=\"removeGroup(group.id)\" _v-2c7810a4=\"\">刪除</a>\n        </div> \n    </div>\n    <div class=\"row\" _v-2c7810a4=\"\">\n        <div class=\"col-xs-2 col-xs-offset-1 text-right\" _v-2c7810a4=\"\">\n            <label for=\"select_product_countdown\" _v-2c7810a4=\"\">選擇產品倒數<v-required _v-2c7810a4=\"\"></v-required></label>\n        </div> \n        <div class=\"col-xs-4 \" _v-2c7810a4=\"\">\n            <input type=\"number\" min=\"1\" class=\"form-control\" v-model=\"postData.select_product_countdown\" id=\"select_product_countdown\" required=\"\" _v-2c7810a4=\"\">\n        </div> \n    </div>\n     <div class=\"row\" _v-2c7810a4=\"\">\n        <div class=\"col-xs-2 col-xs-offset-1 text-right\" _v-2c7810a4=\"\">\n            <label for=\"select_payment_method_countdown\" _v-2c7810a4=\"\">選擇支付方式倒數<v-required _v-2c7810a4=\"\"></v-required></label>\n        </div> \n        <div class=\"col-xs-4 \" _v-2c7810a4=\"\">\n            <input type=\"number\" min=\"1\" class=\"form-control\" v-model=\"postData.select_payment_method_countdown\" id=\"select_payment_method_countdown\" required=\"\" _v-2c7810a4=\"\">\n        </div> \n    </div>\n     <div class=\"row\" _v-2c7810a4=\"\">\n        <div class=\"col-xs-2 col-xs-offset-1 text-right\" _v-2c7810a4=\"\">\n            <label for=\"billed_success_countdown\" _v-2c7810a4=\"\">結帳成功倒數<v-required _v-2c7810a4=\"\"></v-required></label>\n        </div> \n        <div class=\"col-xs-4 \" _v-2c7810a4=\"\">\n            <input type=\"number\" min=\"1\" class=\"form-control\" v-model=\"postData.billed_success_countdown\" id=\"billed_success_countdown\" required=\"\" _v-2c7810a4=\"\">\n        </div> \n    </div>\n    <div class=\"row\" _v-2c7810a4=\"\">\n        <div class=\"col-xs-2 col-xs-offset-1 text-right\" _v-2c7810a4=\"\">\n            <label for=\"billed_fail_countdown\" _v-2c7810a4=\"\">結帳失敗倒數<v-required _v-2c7810a4=\"\"></v-required></label>\n        </div> \n        <div class=\"col-xs-4 \" _v-2c7810a4=\"\">\n            <input type=\"number\" min=\"1\" class=\"form-control\" v-model=\"postData.billed_fail_countdown\" id=\"billed_fail_countdown\" required=\"\" _v-2c7810a4=\"\">\n        </div> \n    </div>\n    <div class=\"row\" _v-2c7810a4=\"\">\n        <div class=\"col-xs-2 col-xs-offset-1 text-right\" _v-2c7810a4=\"\">\n            <label for=\"billed_success_tips\" _v-2c7810a4=\"\">結帳成功提示</label>\n        </div> \n        <div class=\"col-xs-4 \" _v-2c7810a4=\"\">\n            <input type=\"text\" class=\"form-control\" v-model=\"postData.billed_success_tips\" id=\"billed_success_tips\" required=\"\" _v-2c7810a4=\"\">\n        </div> \n    </div>\n    <div class=\"row\" _v-2c7810a4=\"\">\n        <div class=\"col-xs-2 col-xs-offset-1 text-right\" _v-2c7810a4=\"\">\n            <label for=\"\" _v-2c7810a4=\"\">允許的支付方式<v-required _v-2c7810a4=\"\"></v-required></label>\n        </div> \n        <div class=\"col-xs-4 \" _v-2c7810a4=\"\">\n            <v-spinner-button :ajaxing=\"ajaxing.payment\" _v-2c7810a4=\"\"></v-spinner-button>\n            <div v-show=\"!ajaxing.payment\" v-for=\"(item,id) in available_payment_enums\" _v-2c7810a4=\"\">\n                <label :for=\"'e'+id\" _v-2c7810a4=\"\">\n                    <input type=\"checkbox\" name=\"\" :value=\"id\" v-model=\"postData.valid_payment_enums\" :id=\"'e'+id\" _v-2c7810a4=\"\">\n                    {{ item }}\n                </label>\n            </div>\n        </div> \n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.group[_v-2c7810a4], .row[_v-2c7810a4] {\n  margin-top: 15px;\n  margin-bottom: 15px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-2c7810a4", module.exports)
  } else {
    hotAPI.update("_v-2c7810a4", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/object/keys":56,"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1197:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.row[_v-24f58d0a] {\n  margin-top: 15px;\n  margin-bottom: 15px; }\n")
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _values = require("babel-runtime/core-js/object/values");

var _values2 = _interopRequireDefault(_values);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vuex = require("vuex");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      ajaxing: {
        template: false,
        default: false,
        creating: false,
        updating: false,
        binding: false,
        productGroup: false,
        editInit: false,
        init: false,
        redirect: false
      },
      settingTemplate: "",
      templateList: {},
      configData: {},
      postData: {
        template: null,
        configData: {},
        name: "",
        owner_type: "branches",
        owner_id: null
      },
      mode: "create",
      udid: "",
      serial_no: "",
      binding_code: "",
      binding_state: 0,
      configId: null,
      configPostCheck: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.mode = new URL(location.href).searchParams.get("mode");
              _context.next = 3;
              return _this.getTemplateList();

            case 3:
              if (!(_this.mode == "update")) {
                _context.next = 8;
                break;
              }

              _this.ajaxing.editInit = true;
              _this.udid = new URL(location.href).searchParams.get("id");
              _context.next = 8;
              return _this.getDeviceData();

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  watch: {
    "postData.template": function postDataTemplate(val) {
      this.changeSettingTemplate(val);
    },
    ACTIVE_BRANCH_ID: function ACTIVE_BRANCH_ID(newVal) {
      this.branchChangeCallBack(newVal);
    }
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapState)("webadmin/configure", ["studioId", "branchId", "isSeventeen", "isStudio", "isBranch"]), (0, _vuex.mapGetters)('webadmin/configure', ['ACTIVE_BRANCH_ID']), (0, _vuex.mapState)({
    canUpdate: function canUpdate(state) {
      return state.webadmin.configure.webFunctions.WebadminBonusSetting;
    }
  }), {
    templateListArray: function templateListArray() {
      return (0, _values2.default)(this.templateList);
    },
    bindingState: function bindingState() {
      switch (this.binding_state) {
        case 0:
          return '未配對';
          break;
        case 1:
          return '已配對';
          break;
        case 2:
          return '暫停配對';
          break;
      }
    },
    handleWord: function handleWord() {
      return this.mode == 'create' ? '確認新增' : "確認更新";
    }
  }),
  methods: {
    getTemplateList: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        var _this2 = this;

        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.ajaxing.template = true;

                _context2.next = 3;
                return this.$http.get("/adminapi/kiosk/template").then(function (response) {
                  _this2.templateList = response.data;
                  _this2.ajaxing.template = false;
                }, function (error) {
                  _this2.ajaxing.template = false;
                });

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getTemplateList() {
        return _ref.apply(this, arguments);
      }

      return getTemplateList;
    }(),
    getConfigData: function getConfigData() {
      var _this3 = this;

      if (this.postData.template == null) {
        this.settingTemplate = "";
        this.reset();
        return;
      }
      this.ajaxing.default = true;

      this.$http.get("/adminapi/kiosk/template/default/" + this.postData.template.id).then(function (response) {
        _this3.configData = response.data;
        _this3.ajaxing.default = false;
      }, function (error) {
        _this3.ajaxing.default = false;
      });
    },
    changeSettingTemplate: function changeSettingTemplate(val) {
      if (val == null) {
        this.settingTemplate = "";
        return;
      }

      this.settingTemplate = this.getSettingTemplateName(val.class_name);
    },
    getSettingTemplateName: function getSettingTemplateName(class_name) {
      var name = class_name.replace(/([A-Z])/g, "-$1").toLowerCase();

      return "kiosk-setting" + name;
    },
    setTemplatePostData: function setTemplatePostData(data) {
      this.postData.configData = data;
    },
    createDevice: function createDevice() {
      var _this4 = this;

      this.ajaxing.creating = true;
      var postData = this.postData;

      postData.application_id = postData.template.id;

      this.$http.post("/adminapi/kiosk/device", postData).then(function (response) {
        _this4.reset();
        _this4.ajaxing.creating = false;

        _this4.redirect();
      }, function (error) {
        _this4.ajaxing.creating = false;
      });
    },
    updateDevice: function updateDevice() {
      var _this5 = this;

      this.ajaxing.updating = true;
      var postData = this.postData;

      postData.application_id = postData.template.id;
      postData.udid = this.udid;
      postData.configId = this.configId;

      this.$http.post("/adminapi/kiosk/device/update", postData).then(function (response) {
        _this5.reset();
        _this5.ajaxing.updating = false;

        _this5.redirect();
      }, function (error) {
        _this5.ajaxing.updating = false;
      });
    },
    branchChangeCallBack: function branchChangeCallBack(branchId) {
      if (!branchId) {
        return;
      }
      this.postData.owner_id = branchId;
    },
    getDeviceData: function getDeviceData() {
      var _this6 = this;

      this.ajaxing.editInit = true;
      this.$http.get("/adminapi/kiosk/device?id=" + this.udid).then(function (response) {

        _this6.reset();
        var data = response.data;
        _this6.postData.template = _this6.templateList[data.application_id];

        _this6.configData = data.configData;
        _this6.configId = data.configId;
        _this6.postData.name = data.name;
        _this6.postData.owner_type = data.owner_type;
        _this6.postData.owner_id = data.owner_id;

        _this6.udid = data.udid;
        _this6.binding_code = data.binding_code;
        _this6.serial_no = data.serial_no;
        _this6.binding_state = data.binding_state;

        _this6.ajaxing.editInit = false;
      }, function (error) {
        _this6.ajaxing.editInit = false;
      });
    },
    reset: function reset() {
      this.postData = {
        template: null,
        configData: {},
        // name: "",
        owner_type: "branches",
        owner_id: null
        // deviceId: null,
      };

      // this.udid="";
      // this.serial_no="";
      // this.binding_code="";
      this.configData = {};
    },
    checkBindStatus: function checkBindStatus(type) {
      if (this.binding_state == 0) {}

      type = Number(type);
      switch (this.binding_state) {
        case 0:
          //未配對
          return [].indexOf(type) != -1;
          break;
        case 1:
          //已配對
          return [2, 0].indexOf(type) != -1;
          break;
        case 2:
          //暫停配對
          return [1].indexOf(type) != -1;
          break;

        default:
          return false;
      }
    },
    updateBindingStatus: function updateBindingStatus(newBindingState) {
      var _this7 = this;

      this.ajaxing.binding = true;

      this.$http.post("/adminapi/kiosk/device/binding-state", {
        udid: this.udid,
        binding_state: newBindingState
      }).then(function (response) {
        _this7.binding_state = Number(response.data);
        _this7.ajaxing.binding = false;
      }, function (error) {
        _this7.ajaxing.binding = false;
      });
    },
    inputEventAppend: function inputEventAppend(option) {
      this.changeSettingTemplate(option);
      this.getConfigData();
    },
    redirect: function redirect() {
      this.ajaxing.redirect = true;
      location.href = "/webadmin/kiosk-setting";
    },
    handleDevice: function handleDevice() {
      if (!this.checkPostData()) {
        $17.swal({
          title: '儲存失敗',
          text: "還有必填資料(*)未填寫，請檢查表單，倒數秒數須在1~200秒之間。",
          type: 'error',
          showCancelButton: false
        });
        return;
      }
      if (this.mode == 'create') {
        this.createDevice();
      }
      if (this.mode == 'update') {
        this.updateDevice();
      }
    },
    checkPostData: function checkPostData() {
      if (this.postData.template != null && this.postData.name.length > 0 && this.configPostCheck) {
        return true;
      }

      return false;
    },
    setPostCheck: function setPostCheck(val) {
      this.configPostCheck = val;
    }
  }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"content-inner\" _v-24f58d0a=\"\">\n  <v-spinner :ajaxing=\"ajaxing.editInit || ajaxing.redirect || ajaxing.template\" _v-24f58d0a=\"\"></v-spinner>\n  <div v-show=\"!ajaxing.editInit &amp;&amp; !ajaxing.template &amp;&amp; !ajaxing.redirect\" _v-24f58d0a=\"\">\n    <v-select-studio-and-branch v-show=\"mode=='create'\" :show-branch=\"true\" :studio_id=\"studioId\" :branch_id=\"branchId\" _v-24f58d0a=\"\"></v-select-studio-and-branch>\n    <div class=\"row\" _v-24f58d0a=\"\">\n      <div class=\"col-xs-12\" _v-24f58d0a=\"\">\n        <h1 _v-24f58d0a=\"\">KIOSK裝置設定</h1>\n      </div>\n    </div>\n    <div class=\"row\" _v-24f58d0a=\"\">\n      <div class=\"col-xs-2\" _v-24f58d0a=\"\">\n        <h4 _v-24f58d0a=\"\">基本設定</h4>\n      </div>\n      <div class=\"col-xs-5 \" v-if=\"binding_state!=0\" _v-24f58d0a=\"\">\n        <v-spinner-button :ajaxing=\"ajaxing.binding\" _v-24f58d0a=\"\"></v-spinner-button>\n        <template v-if=\"!ajaxing.binding\">\n          <div class=\"btn btn-warning\" v-if=\"checkBindStatus(2)\" @click=\"updateBindingStatus(2)\" _v-24f58d0a=\"\">暫停配對</div>\n          <div class=\"btn btn-success\" v-if=\"checkBindStatus(1)\" @click=\"updateBindingStatus(1)\" _v-24f58d0a=\"\">恢復配對</div>\n          <div class=\"btn btn-danger\" v-if=\"checkBindStatus(0)\" @click=\"updateBindingStatus(0)\" _v-24f58d0a=\"\">解除配對</div>\n        </template>\n      </div>\n    </div>\n    <div class=\"row\" _v-24f58d0a=\"\">\n      <div class=\"col-xs-2 col-xs-offset-1\" _v-24f58d0a=\"\">\n        <label for=\"\" _v-24f58d0a=\"\">配對狀態</label>\n      </div>\n      <div class=\"col-xs-4\" _v-24f58d0a=\"\">\n        <p _v-24f58d0a=\"\">{{ bindingState }}</p>\n      </div>\n      <div class=\"col-xs-2\" _v-24f58d0a=\"\">\n        <label for=\"\" _v-24f58d0a=\"\">配對碼</label>\n      </div>\n      <div class=\"col-xs-3\" _v-24f58d0a=\"\">\n        <p v-if=\"mode=='create'\" _v-24f58d0a=\"\">請先完成新增KIOSK裝置</p>\n        <p v-if=\"mode=='update'\" _v-24f58d0a=\"\">{{ binding_code }}</p>\n      </div>\n    </div>\n    <div class=\"row\" _v-24f58d0a=\"\">\n      <div class=\"col-xs-2 col-xs-offset-1\" _v-24f58d0a=\"\">\n        <label for=\"\" _v-24f58d0a=\"\">顯示名稱<v-required _v-24f58d0a=\"\"></v-required></label>\n      </div>\n      <div class=\"col-xs-4\" _v-24f58d0a=\"\">\n        <input type=\"text\" name=\"\" v-model=\"postData.name\" class=\"form-control\" _v-24f58d0a=\"\">\n      </div>\n      <div class=\"col-xs-2\" _v-24f58d0a=\"\">\n        <label for=\"\" _v-24f58d0a=\"\">配對機型</label>\n      </div>\n      <div class=\"col-xs-3\" _v-24f58d0a=\"\">\n        <p v-if=\"mode=='create' || serial_no==''\" _v-24f58d0a=\"\">尚未配對</p>\n        <p v-if=\"mode=='update' &amp;&amp; serial_no!=''\" _v-24f58d0a=\"\">{{ serial_no }}</p>\n      </div>\n    </div>\n    <div class=\"row\" _v-24f58d0a=\"\">\n      <div class=\"col-xs-2 col-xs-offset-1\" _v-24f58d0a=\"\">\n        <label for=\"\" _v-24f58d0a=\"\">模板<v-required _v-24f58d0a=\"\"></v-required></label>\n      </div>\n      <div class=\"col-xs-4\" _v-24f58d0a=\"\">\n        <v-mutiselect v-show=\"!ajaxing.template\" :model.sync=\"postData.template\" :options=\"templateListArray\" :close-on-select=\"true\" :searchable=\"true\" label=\"display_name\" track-by=\"id\" placeholder=\"請選擇模板\" :input-event-append=\"inputEventAppend\" _v-24f58d0a=\"\"></v-mutiselect>\n        <p v-if=\"(postData.template != null)\" _v-24f58d0a=\"\">\n          <small _v-24f58d0a=\"\">支援型號:</small>\n          <small v-for=\"product in templateList[(postData.template.id)]['supple_iot_products']\" _v-24f58d0a=\"\">{{ product.name }}</small>\n        </p>\n      </div>\n      <div class=\"col-xs-2\" _v-24f58d0a=\"\">\n        <label for=\"\" _v-24f58d0a=\"\">裝置ID</label>\n      </div>\n      <div class=\"col-xs-3\" _v-24f58d0a=\"\">\n        <p v-if=\"mode=='create'\" _v-24f58d0a=\"\">尚未配對</p>\n        <p v-if=\"mode=='update'\" _v-24f58d0a=\"\">{{ udid }}</p>\n      </div>\n    </div>\n    <hr _v-24f58d0a=\"\">\n    <component :is=\"settingTemplate\" :default-data=\"configData\" :mode=\"mode\" @changed=\"setTemplatePostData\" @check-status=\"setPostCheck\" _v-24f58d0a=\"\"></component>\n\n    <div class=\"row\" _v-24f58d0a=\"\">\n      <div class=\"col-xs-10 col-xs-offset-1 text-center\" _v-24f58d0a=\"\">\n        <v-spinner :ajaxing=\"ajaxing.creating || ajaxing.updating\" _v-24f58d0a=\"\"></v-spinner>\n        <div class=\"btn btn-primary\" @click=\"handleDevice()\" v-show=\"!ajaxing.creating &amp;&amp; !ajaxing.updating\" _v-24f58d0a=\"\">\n          {{ handleWord }}\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.row[_v-24f58d0a] {\n  margin-top: 15px;\n  margin-bottom: 15px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-24f58d0a", module.exports)
  } else {
    hotAPI.update("_v-24f58d0a", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/object/values":58,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1198:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.line[_v-29c22a2b] {\n  margin-top: 15px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            ajaxing: false,
            list: []
        };
    },
    mounted: function mounted() {},

    watch: {
        ACTIVE_BRANCH_ID: function ACTIVE_BRANCH_ID(val) {
            if (!val) {
                return;
            }
            this.getList(val);
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId', 'isSeventeen', 'isStudio', 'isBranch']), (0, _vuex.mapGetters)('webadmin/configure', ['ACTIVE_BRANCH_ID'])),
    methods: {
        getList: function () {
            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(branchId) {
                var _this = this;

                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!this.ajaxing) {
                                    _context.next = 2;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 2:
                                this.ajaxing = true;

                                _context.next = 5;
                                return this.$http.get("/adminapi/kiosk/devices/branch/" + branchId).then(function (response) {
                                    _this.list = response.data;
                                    _this.ajaxing = false;
                                }, function (error) {
                                    _this.ajaxing = false;
                                });

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function getList(_x) {
                return _ref.apply(this, arguments);
            }

            return getList;
        }()
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"content-inner\" _v-29c22a2b=\"\">\n    <v-spinner :ajaxing=\"ajaxing\" _v-29c22a2b=\"\"></v-spinner>\n    <template v-show=\"!ajaxing\">\n        <v-select-studio-and-branch v-show=\"!ajaxing\" :studio_id=\"studioId\" :branch_id=\"branchId\" :branch-change-call-back=\"getList\" _v-29c22a2b=\"\"></v-select-studio-and-branch>\n        <div v-if=\"!ajaxing\" _v-29c22a2b=\"\">\n            <div class=\"row m-top-20\" _v-29c22a2b=\"\">\n                <div class=\"col-xs-12\" _v-29c22a2b=\"\">\n                    <a class=\"btn btn-success\" href=\"/webadmin/kiosk-setting/edit?mode=create\" _v-29c22a2b=\"\">\n                        <i class=\"fa fa-plus\" aria-hidden=\"true\" _v-29c22a2b=\"\"></i>\n                        新增KIOSK\n                    </a>\n                </div>\n            </div>\n            <div class=\"row m-top-20\" _v-29c22a2b=\"\">\n                <div class=\"col-xs-2\" _v-29c22a2b=\"\">\n                    KIOKS名稱\n                </div>\n                <div class=\"col-xs-2\" _v-29c22a2b=\"\">\n                    配對碼\n                </div>\n                <div class=\"col-xs-5\" _v-29c22a2b=\"\">\n                    裝置ID\n                </div>\n                <div class=\"col-xs-3\" _v-29c22a2b=\"\"></div>\n            </div>\n            <hr _v-29c22a2b=\"\">\n            <div class=\"row line\" v-for=\"device in list\" _v-29c22a2b=\"\">\n                <div class=\"col-xs-2\" _v-29c22a2b=\"\">\n                    {{  device.name }}\n                </div>\n                <div class=\"col-xs-2\" _v-29c22a2b=\"\">\n                    {{  device.binding_code }}\n                </div>\n                <div class=\"col-xs-5\" _v-29c22a2b=\"\">\n                    {{  device.udid }}\n                </div>\n                <div class=\"col-xs-3\" _v-29c22a2b=\"\">\n                    <a :href=\"'/webadmin/kiosk-setting/edit?mode=update&amp;id='+device.udid\" _v-29c22a2b=\"\">設定</a>\n                </div>\n            </div>\n        </div>\n    </template>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.line[_v-29c22a2b] {\n  margin-top: 15px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-29c22a2b", module.exports)
  } else {
    hotAPI.update("_v-29c22a2b", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1199:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.header[_v-1b206054] {\n  padding: 13px; }\n  /* line 4, stdin */\n  .header h5[_v-1b206054] {\n    margin-top: 0; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        studioId: {},
        branchId: {}
    },
    data: function data() {
        return {
            ajaxing: {
                get: true,
                save: false
            },
            type: {},
            customerServantVisibleList: []
        };
    },
    mounted: function mounted() {
        if (!this.studioId) return;
        this.fetchCustomerSalesData();
    },

    watch: {
        studioId: function studioId(newVal) {
            this.fetchCustomerSalesData();
        }
    },
    methods: {
        fetchCustomerSalesData: function fetchCustomerSalesData() {
            var _this = this;

            this.ajaxing.get = true;
            var postData = {
                'studio_id': this.studioId,
                'type': this.servantType
            };
            this.$http.post('/adminapi/layout-setting/customer-servant-visible/get', postData).then(function (response) {
                var result = response.data.result;
                _this.customerServantVisibleList = result;
                _this.ajaxing.get = false;
            }).catch(function (error) {
                $17.swal({
                    type: 'error',
                    title: '取得資料錯誤',
                    text: error.data.error,
                    showCancelButton: false
                });
                _this.ajaxing.get = false;
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-1b206054=\"\">\n    <v-spinner :ajaxing=\"ajaxing.get\" _v-1b206054=\"\"></v-spinner>\n    <div v-show=\"!ajaxing.get\" _v-1b206054=\"\">\n        <customer-servant-layout-setting-item v-for=\"item in customerServantVisibleList\" :studio-id=\"studioId\" :branch-id=\"branchId\" :item=\"item\" _v-1b206054=\"\"></customer-servant-layout-setting-item>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.header[_v-1b206054] {\n  padding: 13px; }\n  /* line 4, stdin */\n  .header h5[_v-1b206054] {\n    margin-top: 0; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-1b206054", module.exports)
  } else {
    hotAPI.update("_v-1b206054", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1200:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.header[_v-48bd4007] {\n  padding: 13px; }\n  /* line 4, stdin */\n  .header h5[_v-48bd4007] {\n    margin-top: 0; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        studioId: {},
        branchId: {},
        item: {}
    },
    data: function data() {
        return {
            ajaxing: {
                get: true,
                save: false
            },
            customerServantVisibleList: [{ id: 'level_1_visible', label: '１', display: 1, disabled: true }, { id: 'level_2_visible', label: '２', display: 0, disabled: false }, { id: 'level_3_visible', label: '３', display: 0, disabled: false }, { id: 'level_4_visible', label: '４', display: 0, disabled: false }, { id: 'level_5_visible', label: '５', display: 0, disabled: false }, { id: 'level_6_visible', label: '６', display: 0, disabled: false }],
            type: {},
            servantType: ''
        };
    },
    mounted: function mounted() {
        this.fetchCustomerSalesData();
    },

    computed: {
        showServantName: function showServantName() {
            return this.servantType;
        }
    },
    watch: {
        item: function item(newVal) {
            this.fetchCustomerSalesData();
        }
    },
    methods: {
        fetchCustomerSalesData: function fetchCustomerSalesData() {
            var singleItem = this.item;
            this.servantType = singleItem.customer_servant_type_name;
            this.type = {
                id: singleItem.customer_servant_type_id,
                name: singleItem.customer_servant_type_name
            };
            this.customerServantVisibleList.forEach(function (item) {
                item.display = singleItem[item.id];
            });
        },
        save: function save() {
            var _this = this;

            this.ajaxing.save = true;
            var postData = {
                'studio_id': this.studioId,
                'customer_servant_type_id': this.type.id,
                'show_List': {}
            };
            this.customerServantVisibleList.forEach(function (item) {
                postData.show_List[item.id] = item.display ? 1 : 0;
            });
            this.$http.post('/adminapi/layout-setting/customer-servant-visible/update', postData).then(function (response) {
                _this.ajaxing.save = false;
                $17.swal({
                    type: 'success',
                    title: '儲存成功',
                    showCancelButton: false
                });
            }).catch(function (error) {
                $17.swal({
                    type: 'error',
                    title: '儲存失敗',
                    text: error.data.error,
                    showCancelButton: false
                });
                _this.ajaxing.save = false;
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-48bd4007=\"\">\n    <div _v-48bd4007=\"\">\n        <content-card :show-footer=\"false\" _v-48bd4007=\"\">\n            <div slot=\"head\" _v-48bd4007=\"\">\n                <div class=\"header\" _v-48bd4007=\"\">\n                    <h5 _v-48bd4007=\"\">客戶的{{showServantName}}</h5>\n                </div>\n            </div>\n            <div slot=\"body\" _v-48bd4007=\"\">\n                <div style=\"margin: 20px;\" _v-48bd4007=\"\">\n                    <div v-for=\"sales in customerServantVisibleList\" class=\"m-bottom-10\" _v-48bd4007=\"\">\n                        <label :for=\"sales.id\" class=\"m-right-10\" _v-48bd4007=\"\">{{showServantName}}{{sales.label}}</label>\n                        <input type=\"checkbox\" :name=\"sales.id\" :id=\"sales.id\" :disabled=\"sales.disabled\" v-model=\"sales.display\" _v-48bd4007=\"\">\n                        <label :for=\"sales.id\" _v-48bd4007=\"\">顯示</label>\n                    </div>                    \n                </div>\n            </div>\n        </content-card>\n        <div class=\"text-right m-bottom-15\" _v-48bd4007=\"\">\n            <button class=\"btn btn-primary\" @click.prevent=\"save\" :disabled=\"ajaxing.save\" _v-48bd4007=\"\">\n                <span v-show=\"!ajaxing.save\" _v-48bd4007=\"\">儲存</span>\n                <i v-show=\"ajaxing.save\" class=\"fa fa-spin fa-spinner\" _v-48bd4007=\"\"></i>\n            </button>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.header[_v-48bd4007] {\n  padding: 13px; }\n  /* line 4, stdin */\n  .header h5[_v-48bd4007] {\n    margin-top: 0; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-48bd4007", module.exports)
  } else {
    hotAPI.update("_v-48bd4007", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1201:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _webadminSetting = require('./webadminSetting.vue');

var _webadminSetting2 = _interopRequireDefault(_webadminSetting);

var _paymentSetting = require('./paymentSetting.vue');

var _paymentSetting2 = _interopRequireDefault(_paymentSetting);

var _userInterfaceSetting = require('./userInterfaceSetting.vue');

var _userInterfaceSetting2 = _interopRequireDefault(_userInterfaceSetting);

var _orderSales = require('./orderSales.vue');

var _orderSales2 = _interopRequireDefault(_orderSales);

var _customerServant = require('./customerServant.vue');

var _customerServant2 = _interopRequireDefault(_customerServant);

var _customerServantItem = require('./customerServantItem.vue');

var _customerServantItem2 = _interopRequireDefault(_customerServantItem);

var _userInterfaceScheduleAmount = require('./userInterfaceScheduleAmount.vue');

var _userInterfaceScheduleAmount2 = _interopRequireDefault(_userInterfaceScheduleAmount);

var _userInterfaceApprovalTerm = require('./userInterfaceApprovalTerm.vue');

var _userInterfaceApprovalTerm2 = _interopRequireDefault(_userInterfaceApprovalTerm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('webadmin-layout-setting', _webadminSetting2.default);
_vue2.default.component('payment-layout-setting', _paymentSetting2.default);
_vue2.default.component('user-interface-layout-setting', _userInterfaceSetting2.default);
_vue2.default.component('order-sales-layout-setting', _orderSales2.default);
_vue2.default.component('customer-servant-layout-setting', _customerServant2.default);
_vue2.default.component('customer-servant-layout-setting-item', _customerServantItem2.default);
_vue2.default.component('user-interface-layout-schedule-amount', _userInterfaceScheduleAmount2.default);
_vue2.default.component('user-interface-layout-approve-term', _userInterfaceApprovalTerm2.default);

},{"./customerServant.vue":1199,"./customerServantItem.vue":1200,"./orderSales.vue":1202,"./paymentSetting.vue":1203,"./userInterfaceApprovalTerm.vue":1204,"./userInterfaceScheduleAmount.vue":1205,"./userInterfaceSetting.vue":1206,"./webadminSetting.vue":1207,"vue":792}],1202:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.header[_v-5d855526] {\n  padding: 13px; }\n  /* line 4, stdin */\n  .header h5[_v-5d855526] {\n    margin-top: 0; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        studioId: {},
        branchId: {}
    },
    data: function data() {
        return {
            ajaxing: {
                get: true,
                save: false
            },
            orderSalesVisibleList: [{ id: 'level_1_salesperson_visible', label: '業務代表１', display: 1, disabled: true }, { id: 'level_2_salesperson_visible', label: '業務代表２', display: 0, disabled: false }, { id: 'level_3_salesperson_visible', label: '業務代表３', display: 0, disabled: false }, { id: 'level_4_salesperson_visible', label: '業務代表４', display: 0, disabled: false }, { id: 'level_5_salesperson_visible', label: '業務代表５', display: 0, disabled: false }, { id: 'level_6_salesperson_visible', label: '業務代表６', display: 0, disabled: false }]
        };
    },
    mounted: function mounted() {
        if (!this.studioId) return;
        this.fetchSalesPersonData();
    },

    computed: {},
    watch: {
        studioId: function studioId(newVal) {
            this.fetchSalesPersonData();
        }
    },
    methods: {
        fetchSalesPersonData: function fetchSalesPersonData() {
            var _this = this;

            this.ajaxing.get = true;
            var postData = {
                'studio_id': this.studioId
            };
            this.$http.post('/adminapi/layout-setting/salesperson-visible/get', postData).then(function (response) {
                var result = response.data.result;
                _this.orderSalesVisibleList.forEach(function (item) {
                    item.display = result[item.id];
                });
                _this.ajaxing.get = false;
            }).catch(function (error) {
                $17.swal({
                    type: 'error',
                    title: '取得資料錯誤',
                    text: error.data.error,
                    showCancelButton: false
                });
                _this.ajaxing.get = false;
            });
        },
        save: function save() {
            var _this2 = this;

            this.ajaxing.save = true;
            var postData = {
                'studio_id': this.studioId
            };
            this.orderSalesVisibleList.forEach(function (item) {
                postData[item.id] = item.display ? 1 : 0;
            });
            this.$http.post('/adminapi/layout-setting/salesperson-visible/update', postData).then(function (response) {
                _this2.ajaxing.save = false;
                $17.swal({
                    type: 'success',
                    title: '儲存成功',
                    showCancelButton: false
                });
            }).catch(function (error) {
                $17.swal({
                    type: 'error',
                    title: '儲存失敗',
                    text: error.data.error,
                    showCancelButton: false
                });
                _this2.ajaxing.save = false;
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-5d855526=\"\">\n    <v-spinner :ajaxing=\"ajaxing.get\" _v-5d855526=\"\"></v-spinner>\n    <div v-show=\"!ajaxing.get\" _v-5d855526=\"\">\n        <content-card :show-footer=\"false\" _v-5d855526=\"\">\n            <div slot=\"head\" _v-5d855526=\"\">\n                <div class=\"header\" _v-5d855526=\"\">\n                    <h5 _v-5d855526=\"\">訂單的業務代表</h5>\n                </div>\n            </div>\n            <div slot=\"body\" _v-5d855526=\"\">\n                <div style=\"margin: 20px;\" _v-5d855526=\"\">\n                    <div v-for=\"sales in orderSalesVisibleList\" class=\"m-bottom-10\" _v-5d855526=\"\">\n                        <label :for=\"sales.id\" class=\"m-right-10\" _v-5d855526=\"\">{{sales.label}}</label>\n                        <input type=\"checkbox\" :name=\"sales.id\" :id=\"sales.id\" :disabled=\"sales.disabled\" v-model=\"sales.display\" _v-5d855526=\"\">\n                        <label :for=\"sales.id\" _v-5d855526=\"\">顯示</label>\n                    </div>                    \n                </div>\n            </div>\n        </content-card>\n        <div class=\"text-right\" _v-5d855526=\"\">\n            <button class=\"btn btn-primary\" @click.prevent=\"save\" :disabled=\"ajaxing.save\" _v-5d855526=\"\">\n                <span v-show=\"!ajaxing.save\" _v-5d855526=\"\">儲存</span>\n                <i v-show=\"ajaxing.save\" class=\"fa fa-spin fa-spinner\" _v-5d855526=\"\"></i>\n            </button>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.header[_v-5d855526] {\n  padding: 13px; }\n  /* line 4, stdin */\n  .header h5[_v-5d855526] {\n    margin-top: 0; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-5d855526", module.exports)
  } else {
    hotAPI.update("_v-5d855526", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1203:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.row[_v-4f766af9] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center; }\n  /* line 5, stdin */\n  .row.header[_v-4f766af9] {\n    font-size: 20px;\n    font-weight: 500;\n    border-bottom: solid 2px #454545; }\n  /* line 10, stdin */\n  .row.body[_v-4f766af9] {\n    font-size: 15px;\n    border-bottom: solid 1px #d8d8d8;\n    padding: 5px 0; }\n    /* line 14, stdin */\n    .row.body label[_v-4f766af9] {\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-align: center;\n          align-items: center; }\n  /* line 19, stdin */\n  .row input[_v-4f766af9] {\n    height: 30px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            ajaxing: true,
            default_payment: [],
            custom_payment: []
        };
    },
    mounted: function mounted() {},

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId', 'isSeventeen']), (0, _vuex.mapState)('filters', ['selected_studio_id']), {
        allowAddMore: function allowAddMore() {
            return this.custom_payment.length < 10 || this.isSeventeen;
        }
    }),
    watch: {
        studioId: function studioId(newVal) {
            newVal ? this.fetchStudioPaymentMethod(newVal) : null;
        }
    },
    methods: {
        getStudioBind: function getStudioBind() {
            this.fetchStudioPaymentMethod(this.selected_studio_id);
        },
        fetchStudioPaymentMethod: function fetchStudioPaymentMethod(studioId) {
            var _this = this;

            this.ajaxing = true;
            this.default_payment = [];
            this.custom_payment = [];
            this.$http.get('/adminapi/layout-setting/payment-method/studio/' + studioId).then(function (response) {
                var result = response.data;
                result.forEach(function (item) {
                    if (item.is_custom == 0) {
                        _this.default_payment.push(item);
                    } else {
                        _this.custom_payment.push(item);
                    };
                });
                _this.ajaxing = false;
            }, function (error) {
                _this.ajaxing = false;
            });
        },
        addMorePaymentMethod: function addMorePaymentMethod() {
            var studioId = this.studioId ? this.studioId : this.selected_studio_id;
            var countCustomPayment = this.custom_payment.length;
            this.custom_payment.push({
                name: '\u81EA\u8A02' + (countCustomPayment + 1),
                studio_id: studioId,
                is_active: 0,
                is_custom: 1,
                alias_name: '',
                payment_type_id: 1, //現金
                payment_method_category_id: 5 //其他
            });
        },
        submit: function submit() {
            var _this2 = this;

            var studioId = this.studioId ? this.studioId : this.selected_studio_id;
            var postData = this.default_payment.concat(this.custom_payment);
            postData.forEach(function (item) {
                item.is_active = item.is_active ? 1 : 0;
                !item.alias_name ? delete item.alias_name : null;
            });
            this.ajaxing = true;
            this.$http.post('/adminapi/layout-setting/payment-method/studio/' + studioId + '/save', { data: postData }).then(function (response) {
                $17.swal({
                    title: '儲存成功',
                    type: 'success',
                    showCancelButton: false
                });
                _this2.ajaxing = false;
            }, function (error) {
                $17.swal({
                    title: '儲存失敗',
                    type: 'error',
                    showCancelButton: false
                });
                _this2.ajaxing = false;
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div style=\"margin: 0 20px 0 15px;\" _v-4f766af9=\"\">\n    <h3 _v-4f766af9=\"\">管理支付方式</h3>\n    <hr _v-4f766af9=\"\">\n    <div class=\"row\" v-if=\"isSeventeen\" _v-4f766af9=\"\">\n        <div class=\"col-md-3\" _v-4f766af9=\"\">\n            <v-multiselect-studio-and-branch :studio_id=\"studioId\" :branch_id=\"branchId\" :branch-without-filtered-option=\"false\" :studio-change-call-back=\"getStudioBind\" :show-branch=\"false\" _v-4f766af9=\"\"></v-multiselect-studio-and-branch>\n        </div>\n    </div>\n    <v-spinner :ajaxing=\"ajaxing\" _v-4f766af9=\"\"></v-spinner>\n    <div v-show=\"!ajaxing\" _v-4f766af9=\"\">\n        <div class=\"container\" _v-4f766af9=\"\">\n            <div class=\"row header\" _v-4f766af9=\"\">\n                <div class=\"col-sm-4\" _v-4f766af9=\"\">預設支付方式</div>\n                <div class=\"col-sm-4\" _v-4f766af9=\"\">顯示名稱</div>\n                <div class=\"col-sm-4\" _v-4f766af9=\"\"></div>\n            </div>\n            <div class=\"row body\" v-for=\"payment in default_payment\" _v-4f766af9=\"\">\n                <div class=\"col-sm-4\" _v-4f766af9=\"\">{{payment.name}}</div>\n                <div class=\"col-sm-4\" _v-4f766af9=\"\">\n                    <input type=\"text\" :placeholder=\"payment.name\" v-model=\"payment.alias_name\" _v-4f766af9=\"\">\n                </div>\n                <div class=\"col-sm-4\" _v-4f766af9=\"\">\n                    <label _v-4f766af9=\"\">\n                        <input type=\"checkbox\" v-model=\"payment.is_active\" _v-4f766af9=\"\">啟用\n                    </label>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"container m-top-50\" _v-4f766af9=\"\">\n            <div class=\"row header\" _v-4f766af9=\"\">\n                <div class=\"col-sm-4\" _v-4f766af9=\"\">自訂支付方式</div>\n                <div class=\"col-sm-4\" _v-4f766af9=\"\"></div>\n                <div class=\"col-sm-4\" _v-4f766af9=\"\"></div>\n            </div>\n            <div class=\"row body\" v-show=\"custom_payment.length <= 0\" _v-4f766af9=\"\">\n                <div class=\"col-sm-4\" _v-4f766af9=\"\">查無資料</div>\n            </div>\n            <div class=\"row body\" v-for=\"(custom, idx) in custom_payment\" :key=\"idx\" _v-4f766af9=\"\">\n                <div class=\"col-sm-4\" _v-4f766af9=\"\">{{custom.name}}</div>\n                <div class=\"col-sm-4\" _v-4f766af9=\"\">\n                    <input type=\"text\" :placeholder=\"custom.name\" v-model=\"custom.alias_name\" _v-4f766af9=\"\">\n                </div>\n                <div class=\"col-sm-4\" _v-4f766af9=\"\">\n                    <label _v-4f766af9=\"\">\n                        <input type=\"checkbox\" v-model=\"custom.is_active\" _v-4f766af9=\"\">啟用\n                    </label>\n                </div>\n            </div>\n            <div class=\"m-top-20\" v-show=\"allowAddMore\" _v-4f766af9=\"\">\n                <a @click=\"addMorePaymentMethod\" style=\"text-decoration: underline;\" _v-4f766af9=\"\"> +新增支付方式 </a>\n            </div>\n        </div>\n\n        <div class=\"m-top-30\" _v-4f766af9=\"\">\n            <button class=\"btn btn-primary\" @click=\"submit\" _v-4f766af9=\"\">送出</button>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.row[_v-4f766af9] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center; }\n  /* line 5, stdin */\n  .row.header[_v-4f766af9] {\n    font-size: 20px;\n    font-weight: 500;\n    border-bottom: solid 2px #454545; }\n  /* line 10, stdin */\n  .row.body[_v-4f766af9] {\n    font-size: 15px;\n    border-bottom: solid 1px #d8d8d8;\n    padding: 5px 0; }\n    /* line 14, stdin */\n    .row.body label[_v-4f766af9] {\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-align: center;\n          align-items: center; }\n  /* line 19, stdin */\n  .row input[_v-4f766af9] {\n    height: 30px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-4f766af9", module.exports)
  } else {
    hotAPI.update("_v-4f766af9", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1204:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\nh4[_v-f467ec44] {\n  font-size: 28px; }\n\n/* line 5, stdin */\n.sub-title[_v-f467ec44] {\n  color: #44444F;\n  font-size: 16px;\n  margin-top: 16px; }\n\n/* line 12, stdin */\n.quota-setting-form span[_v-f467ec44] {\n  margin-left: 5px; }\n\n/* line 15, stdin */\n.quota-setting-form input[_v-f467ec44] {\n  padding: 3px 12px; }\n\n/* line 18, stdin */\n.quota-setting-form .input-text[_v-f467ec44] {\n  font-size: 16px;\n  color: #000; }\n\n/* line 22, stdin */\n.quota-setting-form .font-bold[_v-f467ec44] {\n  font-weight: 500; }\n\n/* line 25, stdin */\n.quota-setting-form .sub-note[_v-f467ec44] {\n  margin-left: 21px;\n  font-size: 14px;\n  color: #707070;\n  margin-top: 12px; }\n\n/* line 31, stdin */\n.quota-setting-form .checkmark[_v-f467ec44] {\n  position: absolute;\n  top: 4px;\n  left: 0;\n  height: 13px;\n  width: 13px;\n  border-radius: 3px;\n  background-color: #d8d8d8;\n  margin-left: 0; }\n  /* line 40, stdin */\n  .quota-setting-form .checkmark[_v-f467ec44]:after {\n    content: \"\";\n    position: absolute;\n    display: none; }\n\n/* line 46, stdin */\n.quota-setting-form .checkmark-container[_v-f467ec44] {\n  display: block;\n  position: relative;\n  padding-left: 15px;\n  margin-bottom: 12px;\n  cursor: pointer;\n  font-size: 16px;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  width: 60px; }\n  /* line 55, stdin */\n  .quota-setting-form .checkmark-container input[_v-f467ec44] {\n    position: absolute;\n    opacity: 0;\n    cursor: pointer;\n    height: 0;\n    width: 0; }\n  /* line 62, stdin */\n  .quota-setting-form .checkmark-container:hover input ~ .checkmark[_v-f467ec44] {\n    background-color: #ccc; }\n  /* line 65, stdin */\n  .quota-setting-form .checkmark-container input:checked ~ .checkmark[_v-f467ec44] {\n    background-color: #2196F3; }\n  /* line 68, stdin */\n  .quota-setting-form .checkmark-container input:checked ~ .checkmark[_v-f467ec44]:after {\n    display: block; }\n  /* line 71, stdin */\n  .quota-setting-form .checkmark-container .checkmark[_v-f467ec44]:after {\n    left: 4px;\n    top: 0px;\n    width: 5.5px;\n    height: 10px;\n    border: solid white;\n    border-width: 0 2.5px 2.5px 0;\n    transform: rotate(45deg); }\n\n/* line 83, stdin */\n.quota-setting-form.none_active_gray span[_v-f467ec44] {\n  color: #707070; }\n\n/* line 86, stdin */\n.quota-setting-form.none_active_gray .font-bold[_v-f467ec44] {\n  color: black; }\n\n/* line 91, stdin */\n.quota-setting-form .block-background[_v-f467ec44] {\n  background-color: #FAFAFB;\n  max-width: 50%;\n  padding: 24px; }\n\n/* line 96, stdin */\n.quota-setting-form .approve-list[_v-f467ec44] {\n  max-width: 280px; }\n\n/* line 101, stdin */\n.action-bar[_v-f467ec44] {\n  text-align: right; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            ajaxing: {
                get: false,
                save: false,
                approve: false
            },
            beforeState: {
                selectedTerm: null,
                isShowInClientSide: 0
            },
            afterState: {
                selectedTerm: null,
                isShowInClientSide: 0
            },
            selectedStudioId: 0,
            approveTermList: []
        };
    },
    mounted: function mounted() {
        $17.toggleWebadminTopTabsByQuery();
        if (!this.studioId) return;
        this.fetchDisplayData(this.studioId);
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId', 'isSeventeen']), {
        loading: function loading() {
            return this.ajaxing.get || this.ajaxing.save;
        },
        isDisabled: function isDisabled() {
            return !this.afterState.isShowInClientSide;
        }
    }),
    watch: {
        studioId: function () {
            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(newVal) {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!newVal) {
                                    _context.next = 4;
                                    break;
                                }

                                _context.next = 3;
                                return this.fetchApproveTermData(newVal);

                            case 3:
                                this.fetchDisplayData(newVal);

                            case 4:
                                ;

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function studioId(_x) {
                return _ref.apply(this, arguments);
            }

            return studioId;
        }(),
        'afterState': {
            handler: function handler(newVal) {
                if (newVal.isShowInClientSide == 0) {
                    this.afterState.selectedTerm = null;
                };
            },
            deep: true
        }
    },
    methods: {
        setState: function setState(state) {
            if (state) {
                this.beforeState = state;
            } else {
                this.beforeState = {
                    selectedTerm: null,
                    isShowInClientSide: false
                };
            };
            this.afterState = (0, _assign2.default)({}, this.beforeState);
        },
        getBindedStudio: function getBindedStudio(id) {
            var _this = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return _this.fetchApproveTermData(id);

                            case 2:
                                _this.fetchDisplayData(id);
                                _this.selectedStudioId = id;

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this);
            }))();
        },
        fetchApproveTermData: function fetchApproveTermData(studioId) {
            var _this2 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _this2.setState();
                                _this2.ajaxing.approve = true;
                                _context3.next = 4;
                                return _this2.$http.get('/adminapi/approval-term/layout?studio_id=' + studioId).then(function (response) {
                                    _this2.approveTermList = response.data;
                                    _this2.ajaxing.approve = false;
                                }).catch(function (error) {
                                    $17.swal({
                                        type: 'error',
                                        title: '取得資料錯誤',
                                        text: error.data.error,
                                        showCancelButton: false
                                    });
                                    _this2.ajaxing.approve = false;
                                });

                            case 4:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this2);
            }))();
        },
        fetchDisplayData: function fetchDisplayData(studioId) {
            var _this3 = this;

            this.setState();
            this.ajaxing.get = true;
            this.$http.get('/adminapi/user-interface-layout-setting/approve-term/get/' + studioId).then(function (response) {
                var result = response.data.result;
                var selectedTerm = _this3.approveTermList.reduce(function (carry, item) {
                    if (item.id == result.approval_term_id) {
                        carry = item;
                    }

                    return carry;
                }, null);
                _this3.setState({
                    'isShowInClientSide': result.is_show_in_client_side,
                    'selectedTerm': selectedTerm
                });
                _this3.ajaxing.get = false;
            }).catch(function (error) {
                $17.swal({
                    type: 'error',
                    title: '取得資料錯誤',
                    text: error.data.error,
                    showCancelButton: false
                });
                _this3.ajaxing.get = false;
            });
        },
        save: function save() {
            var _this4 = this;

            var studioId = this.isSeventeen ? this.selectedStudioId : this.studioId;
            if (!studioId) return;
            this.ajaxing.save = true;
            var postData = {
                'studio_id': studioId,
                'is_show_in_client_side': this.afterState.isShowInClientSide && this.afterState.selectedTerm != null ? 1 : 0,
                'approval_term_id': this.afterState.isShowInClientSide && this.afterState.selectedTerm != null ? this.afterState.selectedTerm.id : 0
            };
            this.$http.post('/adminapi/user-interface-layout-setting/approve-term/update', postData).then(function (response) {
                _this4.ajaxing.save = false;
                _this4.setState(_this4.afterState);
                $17.swal({
                    type: 'success',
                    title: '儲存成功',
                    showCancelButton: false
                });
            }).catch(function (error) {
                _this4.reset();
                $17.swal({
                    type: 'warning',
                    title: '儲存失敗',
                    text: '因選擇的條款可能為停用，含有參數，或尚未發布所以無法設為同意條款，請調整後再重新設定',
                    showCancelButton: false
                });
                _this4.ajaxing.save = false;
            });
        },
        reset: function reset() {
            this.setState(this.beforeState);
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div style=\"margin: 30px 20px 0 50px;\" _v-f467ec44=\"\">\n    <v-multiselect-studio-and-branch :studio_id=\"studioId\" :show-branch=\"false\" :studio-change-call-back=\"getBindedStudio\" _v-f467ec44=\"\"></v-multiselect-studio-and-branch>\n\n    <h4 _v-f467ec44=\"\">同意條款設定</h4>\n    <div class=\"sub-title\" _v-f467ec44=\"\">讓客戶在線上購買方案時，需同意的條款</div>\n\n    <v-spinner :ajaxing=\"loading\" _v-f467ec44=\"\"></v-spinner>\n    <div v-show=\"!loading\" class=\"quota-setting-form m-bottom-50 m-left-0 m-top-30\" :class=\"{'none_active_gray' : !afterState.isShowInClientSide}\" _v-f467ec44=\"\">\n        <div class=\"row\" _v-f467ec44=\"\">\n            <div class=\"col-sm-12\" _v-f467ec44=\"\">\n                <label class=\"checkmark-container\" for=\"is_show_quota\" _v-f467ec44=\"\">\n                    <input type=\"checkbox\" :true-value=\"1\" :false-value=\"0\" id=\"is_show_quota\" name=\"is_show_quota\" v-model=\"afterState.isShowInClientSide\" _v-f467ec44=\"\">\n                    <span class=\"checkmark\" _v-f467ec44=\"\"></span>\n                    <span class=\"input-text font-bold\" _v-f467ec44=\"\">啟用</span>\n                </label>                    \n            </div>\n        </div>\n\n        <div class=\"row block-background\" _v-f467ec44=\"\">\n            <div class=\"col-sm-12\" _v-f467ec44=\"\">\n                <label _v-f467ec44=\"\">\n                    <span class=\"input-text\" _v-f467ec44=\"\">設定同意條款</span>\n                </label>\n                <div class=\"approve-list\" _v-f467ec44=\"\">\n                    <v-mutiselect :model.sync=\"afterState.selectedTerm\" :options=\"approveTermList\" :preserve-search=\"true\" :placeholder=\"ajaxing.approve ? '條款讀取中…' : '請選擇條款'\" label=\"name\" track-by=\"id\" :disabled=\"isDisabled\" _v-f467ec44=\"\">\n                    </v-mutiselect>\n                </div>\n                <div class=\"sub-note\" _v-f467ec44=\"\">\n                    <i class=\"fa fa-info-circle\" aria-hidden=\"true\" _v-f467ec44=\"\"></i>\n        條款如停用，含有參數，或尚未發布，則不會出現在條款選擇內\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"row\" _v-f467ec44=\"\">\n        <div class=\"col-sm-6 action-bar\" _v-f467ec44=\"\">\n            <button class=\"btn btn-default btn--inverse\" @click.prevent=\"reset\" _v-f467ec44=\"\">\n                <span _v-f467ec44=\"\">取消</span>\n            </button> \n            <button class=\"btn btn-primary\" @click.prevent=\"save\" _v-f467ec44=\"\">\n                <span _v-f467ec44=\"\">儲存</span>\n            </button>            \n        </div>            \n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\nh4[_v-f467ec44] {\n  font-size: 28px; }\n\n/* line 5, stdin */\n.sub-title[_v-f467ec44] {\n  color: #44444F;\n  font-size: 16px;\n  margin-top: 16px; }\n\n/* line 12, stdin */\n.quota-setting-form span[_v-f467ec44] {\n  margin-left: 5px; }\n\n/* line 15, stdin */\n.quota-setting-form input[_v-f467ec44] {\n  padding: 3px 12px; }\n\n/* line 18, stdin */\n.quota-setting-form .input-text[_v-f467ec44] {\n  font-size: 16px;\n  color: #000; }\n\n/* line 22, stdin */\n.quota-setting-form .font-bold[_v-f467ec44] {\n  font-weight: 500; }\n\n/* line 25, stdin */\n.quota-setting-form .sub-note[_v-f467ec44] {\n  margin-left: 21px;\n  font-size: 14px;\n  color: #707070;\n  margin-top: 12px; }\n\n/* line 31, stdin */\n.quota-setting-form .checkmark[_v-f467ec44] {\n  position: absolute;\n  top: 4px;\n  left: 0;\n  height: 13px;\n  width: 13px;\n  border-radius: 3px;\n  background-color: #d8d8d8;\n  margin-left: 0; }\n  /* line 40, stdin */\n  .quota-setting-form .checkmark[_v-f467ec44]:after {\n    content: \"\";\n    position: absolute;\n    display: none; }\n\n/* line 46, stdin */\n.quota-setting-form .checkmark-container[_v-f467ec44] {\n  display: block;\n  position: relative;\n  padding-left: 15px;\n  margin-bottom: 12px;\n  cursor: pointer;\n  font-size: 16px;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  width: 60px; }\n  /* line 55, stdin */\n  .quota-setting-form .checkmark-container input[_v-f467ec44] {\n    position: absolute;\n    opacity: 0;\n    cursor: pointer;\n    height: 0;\n    width: 0; }\n  /* line 62, stdin */\n  .quota-setting-form .checkmark-container:hover input ~ .checkmark[_v-f467ec44] {\n    background-color: #ccc; }\n  /* line 65, stdin */\n  .quota-setting-form .checkmark-container input:checked ~ .checkmark[_v-f467ec44] {\n    background-color: #2196F3; }\n  /* line 68, stdin */\n  .quota-setting-form .checkmark-container input:checked ~ .checkmark[_v-f467ec44]:after {\n    display: block; }\n  /* line 71, stdin */\n  .quota-setting-form .checkmark-container .checkmark[_v-f467ec44]:after {\n    left: 4px;\n    top: 0px;\n    width: 5.5px;\n    height: 10px;\n    border: solid white;\n    border-width: 0 2.5px 2.5px 0;\n    transform: rotate(45deg); }\n\n/* line 83, stdin */\n.quota-setting-form.none_active_gray span[_v-f467ec44] {\n  color: #707070; }\n\n/* line 86, stdin */\n.quota-setting-form.none_active_gray .font-bold[_v-f467ec44] {\n  color: black; }\n\n/* line 91, stdin */\n.quota-setting-form .block-background[_v-f467ec44] {\n  background-color: #FAFAFB;\n  max-width: 50%;\n  padding: 24px; }\n\n/* line 96, stdin */\n.quota-setting-form .approve-list[_v-f467ec44] {\n  max-width: 280px; }\n\n/* line 101, stdin */\n.action-bar[_v-f467ec44] {\n  text-align: right; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-f467ec44", module.exports)
  } else {
    hotAPI.update("_v-f467ec44", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/object/assign":50,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1205:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\nh4[_v-5c6e449e] {\n  font-size: 28px; }\n\n/* line 5, stdin */\n.sub-title[_v-5c6e449e] {\n  color: #44444F;\n  font-size: 16px;\n  margin-top: 16px; }\n\n/* line 12, stdin */\n.quota-setting-form span[_v-5c6e449e] {\n  margin-left: 5px; }\n\n/* line 15, stdin */\n.quota-setting-form input[_v-5c6e449e] {\n  padding: 3px 12px; }\n\n/* line 18, stdin */\n.quota-setting-form .input-text[_v-5c6e449e] {\n  font-size: 16px;\n  color: #000; }\n\n/* line 22, stdin */\n.quota-setting-form .font-bold[_v-5c6e449e] {\n  font-weight: 500; }\n\n/* line 25, stdin */\n.quota-setting-form .sub-note[_v-5c6e449e] {\n  margin-left: 21px;\n  font-size: 14px;\n  color: #707070;\n  margin-top: 12px; }\n\n/* line 31, stdin */\n.quota-setting-form .checkmark[_v-5c6e449e] {\n  position: absolute;\n  top: 4px;\n  left: 0;\n  height: 13px;\n  width: 13px;\n  border-radius: 3px;\n  background-color: #d8d8d8;\n  margin-left: 0; }\n  /* line 40, stdin */\n  .quota-setting-form .checkmark[_v-5c6e449e]:after {\n    content: \"\";\n    position: absolute;\n    display: none; }\n\n/* line 46, stdin */\n.quota-setting-form .checkmark-container[_v-5c6e449e] {\n  display: block;\n  position: relative;\n  padding-left: 15px;\n  margin-bottom: 12px;\n  cursor: pointer;\n  font-size: 16px;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none; }\n  /* line 54, stdin */\n  .quota-setting-form .checkmark-container input[_v-5c6e449e] {\n    position: absolute;\n    opacity: 0;\n    cursor: pointer;\n    height: 0;\n    width: 0; }\n  /* line 61, stdin */\n  .quota-setting-form .checkmark-container:hover input ~ .checkmark[_v-5c6e449e] {\n    background-color: #ccc; }\n  /* line 64, stdin */\n  .quota-setting-form .checkmark-container input:checked ~ .checkmark[_v-5c6e449e] {\n    background-color: #2196F3; }\n  /* line 67, stdin */\n  .quota-setting-form .checkmark-container input:checked ~ .checkmark[_v-5c6e449e]:after {\n    display: block; }\n  /* line 70, stdin */\n  .quota-setting-form .checkmark-container .checkmark[_v-5c6e449e]:after {\n    left: 4px;\n    top: 0px;\n    width: 5.5px;\n    height: 10px;\n    border: solid white;\n    border-width: 0 2.5px 2.5px 0;\n    transform: rotate(45deg); }\n\n/* line 82, stdin */\n.quota-setting-form.none_active_gray span[_v-5c6e449e] {\n  color: #707070; }\n\n/* line 85, stdin */\n.quota-setting-form.none_active_gray .font-bold[_v-5c6e449e] {\n  color: black; }\n\n/* line 90, stdin */\n.quota-setting-form .block-background[_v-5c6e449e] {\n  background-color: #FAFAFB;\n  max-width: 50%;\n  padding: 28px; }\n\n/* line 98, stdin */\n.action-bar[_v-5c6e449e] {\n  text-align: right; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            ajaxing: {
                get: false,
                save: false
            },
            beforeState: {},
            afterState: {},
            selectedStudioId: 0
        };
    },
    mounted: function mounted() {
        $17.toggleWebadminTopTabsByQuery();
        if (!this.studioId) return;
        this.fetchDisplayData(this.studioId);
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId', 'isSeventeen']), {
        loading: function loading() {
            return this.ajaxing.get || this.ajaxing.save;
        },
        isDisabled: function isDisabled() {
            return !this.afterState.is_show_remain_qty;
        }
    }),
    watch: {
        studioId: function studioId(newVal) {
            if (newVal) {
                this.fetchDisplayData(newVal);
            };
        },

        'afterState': {
            handler: function handler(newVal, oldVal) {
                if (newVal.is_show_remain_qty) {
                    if (newVal.show_remain_style == 0) {
                        this.afterState.show_remain_style = 1;
                    }
                };
            },
            deep: true
        }
    },
    methods: {
        setState: function setState(state) {
            if (state) {
                this.beforeState = state;
            } else {
                this.beforeState = {
                    is_show_remain_qty: 0,
                    show_remain_style: '',
                    limit_qty: 0
                };
            };
            this.afterState = (0, _assign2.default)({}, this.beforeState);
        },
        getBindedStudio: function getBindedStudio(id) {
            this.fetchDisplayData(id);
            this.selectedStudioId = id;
        },
        fetchDisplayData: function fetchDisplayData(studioId) {
            var _this = this;

            this.setState();
            this.ajaxing.get = true;
            this.$http.get('/adminapi/user-interface-layout-setting/booking-class/get/' + studioId).then(function (response) {
                var result = response.data.result;
                _this.setState(result);
                _this.ajaxing.get = false;
            }).catch(function (error) {
                $17.swal({
                    type: 'error',
                    title: '取得資料錯誤',
                    text: error.data.error,
                    showCancelButton: false
                });
                _this.ajaxing.get = false;
            });
        },
        save: function save() {
            var _this2 = this;

            var studioId = this.isSeventeen ? this.selectedStudioId : this.studioId;
            if (!studioId) return;
            this.ajaxing.save = true;
            var postData = {
                'studio_id': studioId,
                'is_show_remain_qty': this.afterState.is_show_remain_qty ? 1 : 0,
                'show_remain_style': this.afterState.show_remain_style,
                'limit_qty': this.afterState.limit_qty
            };
            this.$http.post('/adminapi/user-interface-layout-setting/booking-class/update', postData).then(function (response) {
                _this2.ajaxing.save = false;
                _this2.setState(_this2.afterState);
                $17.swal({
                    type: 'success',
                    title: '儲存成功',
                    showCancelButton: false
                });
            }).catch(function (error) {
                $17.swal({
                    type: 'error',
                    title: '儲存失敗',
                    text: error.data.error,
                    showCancelButton: false
                });
                _this2.ajaxing.save = false;
            });
        },
        reset: function reset() {
            this.setState(this.beforeState);
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div style=\"margin: 30px 20px 0 50px;\" _v-5c6e449e=\"\">\n    <v-multiselect-studio-and-branch :studio_id=\"studioId\" :show-branch=\"false\" :studio-change-call-back=\"getBindedStudio\" _v-5c6e449e=\"\"></v-multiselect-studio-and-branch>\n\n    <h4 _v-5c6e449e=\"\">課程名額顯示</h4>\n    <div class=\"sub-title\" _v-5c6e449e=\"\">讓客戶在線上預約課程時，查看名額</div>\n\n    <v-spinner :ajaxing=\"loading\" _v-5c6e449e=\"\"></v-spinner>\n    <div v-show=\"!loading\" class=\"quota-setting-form m-bottom-50 m-left-0 m-top-30\" :class=\"{'none_active_gray' : !afterState.is_show_remain_qty}\" _v-5c6e449e=\"\">\n        <div class=\"row\" _v-5c6e449e=\"\">\n            <div class=\"col-sm-12\" _v-5c6e449e=\"\">\n                <label class=\"checkmark-container\" for=\"is_show_quota\" _v-5c6e449e=\"\">\n                    <input type=\"checkbox\" id=\"is_show_quota\" name=\"is_show_quota\" v-model=\"afterState.is_show_remain_qty\" _v-5c6e449e=\"\">\n                    <span class=\"checkmark\" _v-5c6e449e=\"\"></span>\n                    <span class=\"input-text font-bold\" _v-5c6e449e=\"\">啟用</span>\n                </label>                    \n            </div>\n        </div>\n\n        <div class=\"row block-background\" _v-5c6e449e=\"\">\n            <div class=\"col-sm-12\" _v-5c6e449e=\"\">\n                <label _v-5c6e449e=\"\">\n                    <input type=\"radio\" v-model=\"afterState.show_remain_style\" value=\"1\" :disabled=\"isDisabled\" _v-5c6e449e=\"\">\n                    <span class=\"input-text\" _v-5c6e449e=\"\">顯示全部名額</span>\n                </label>\n                <div class=\"sub-note\" _v-5c6e449e=\"\">客戶將看到 (已報名 / 總名額) 。例如: (2 / 20)</div>\n            </div>\n            <div class=\"col-sm-12 m-top-20\" _v-5c6e449e=\"\">\n                <label _v-5c6e449e=\"\">\n                    <input type=\"radio\" v-model=\"afterState.show_remain_style\" value=\"2\" :disabled=\"isDisabled\" _v-5c6e449e=\"\">\n                    <span class=\"input-text\" _v-5c6e449e=\"\">\n                        當剩餘可預約人數少於\n                        <input type=\"number\" step=\"1\" min=\"0\" max=\"10000\" v-model.number=\"afterState.limit_qty\" :disabled=\"isDisabled\" _v-5c6e449e=\"\">\n                        時，顯示剩餘人數\n                    </span>\n                </label>\n                <div class=\"sub-note\" _v-5c6e449e=\"\">客戶將看到 剩 N 位，N=剩餘人數</div>\n            </div>\n        </div>\n    </div>\n    <div class=\"row\" _v-5c6e449e=\"\">\n        <div class=\"col-sm-6 action-bar\" _v-5c6e449e=\"\">\n            <button class=\"btn btn-default btn--inverse\" @click.prevent=\"reset\" _v-5c6e449e=\"\">\n                <span _v-5c6e449e=\"\">取消</span>\n            </button> \n            <button class=\"btn btn-primary\" @click.prevent=\"save\" _v-5c6e449e=\"\">\n                <span _v-5c6e449e=\"\">儲存</span>\n            </button>            \n        </div>            \n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\nh4[_v-5c6e449e] {\n  font-size: 28px; }\n\n/* line 5, stdin */\n.sub-title[_v-5c6e449e] {\n  color: #44444F;\n  font-size: 16px;\n  margin-top: 16px; }\n\n/* line 12, stdin */\n.quota-setting-form span[_v-5c6e449e] {\n  margin-left: 5px; }\n\n/* line 15, stdin */\n.quota-setting-form input[_v-5c6e449e] {\n  padding: 3px 12px; }\n\n/* line 18, stdin */\n.quota-setting-form .input-text[_v-5c6e449e] {\n  font-size: 16px;\n  color: #000; }\n\n/* line 22, stdin */\n.quota-setting-form .font-bold[_v-5c6e449e] {\n  font-weight: 500; }\n\n/* line 25, stdin */\n.quota-setting-form .sub-note[_v-5c6e449e] {\n  margin-left: 21px;\n  font-size: 14px;\n  color: #707070;\n  margin-top: 12px; }\n\n/* line 31, stdin */\n.quota-setting-form .checkmark[_v-5c6e449e] {\n  position: absolute;\n  top: 4px;\n  left: 0;\n  height: 13px;\n  width: 13px;\n  border-radius: 3px;\n  background-color: #d8d8d8;\n  margin-left: 0; }\n  /* line 40, stdin */\n  .quota-setting-form .checkmark[_v-5c6e449e]:after {\n    content: \"\";\n    position: absolute;\n    display: none; }\n\n/* line 46, stdin */\n.quota-setting-form .checkmark-container[_v-5c6e449e] {\n  display: block;\n  position: relative;\n  padding-left: 15px;\n  margin-bottom: 12px;\n  cursor: pointer;\n  font-size: 16px;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none; }\n  /* line 54, stdin */\n  .quota-setting-form .checkmark-container input[_v-5c6e449e] {\n    position: absolute;\n    opacity: 0;\n    cursor: pointer;\n    height: 0;\n    width: 0; }\n  /* line 61, stdin */\n  .quota-setting-form .checkmark-container:hover input ~ .checkmark[_v-5c6e449e] {\n    background-color: #ccc; }\n  /* line 64, stdin */\n  .quota-setting-form .checkmark-container input:checked ~ .checkmark[_v-5c6e449e] {\n    background-color: #2196F3; }\n  /* line 67, stdin */\n  .quota-setting-form .checkmark-container input:checked ~ .checkmark[_v-5c6e449e]:after {\n    display: block; }\n  /* line 70, stdin */\n  .quota-setting-form .checkmark-container .checkmark[_v-5c6e449e]:after {\n    left: 4px;\n    top: 0px;\n    width: 5.5px;\n    height: 10px;\n    border: solid white;\n    border-width: 0 2.5px 2.5px 0;\n    transform: rotate(45deg); }\n\n/* line 82, stdin */\n.quota-setting-form.none_active_gray span[_v-5c6e449e] {\n  color: #707070; }\n\n/* line 85, stdin */\n.quota-setting-form.none_active_gray .font-bold[_v-5c6e449e] {\n  color: black; }\n\n/* line 90, stdin */\n.quota-setting-form .block-background[_v-5c6e449e] {\n  background-color: #FAFAFB;\n  max-width: 50%;\n  padding: 28px; }\n\n/* line 98, stdin */\n.action-bar[_v-5c6e449e] {\n  text-align: right; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-5c6e449e", module.exports)
  } else {
    hotAPI.update("_v-5c6e449e", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/object/assign":50,"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1206:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\nh4[_v-26ec7911] {\n  font-size: 28px; }\n\n/* line 5, stdin */\n.sub-title[_v-26ec7911] {\n  color: #44444F;\n  font-size: 16px;\n  margin-top: 16px; }\n\n/* line 10, stdin */\nhr[_v-26ec7911] {\n  margin-top: 32px;\n  margin-bottom: 32px; }\n\n/* line 15, stdin */\n.block-background[_v-26ec7911] {\n  background-color: #FAFAFB;\n  max-width: 50%;\n  padding: 16px;\n  font-size: 16px;\n  margin-top: 8px; }\n\n/* line 22, stdin */\n.block-content[_v-26ec7911] {\n  width: 100%;\n  display: -ms-inline-flexbox;\n  display: inline-flex; }\n  /* line 25, stdin */\n  .block-content .block-content-left[_v-26ec7911] {\n    width: 50%; }\n  /* line 28, stdin */\n  .block-content .block-content-right[_v-26ec7911] {\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    -ms-flex-align: center;\n        align-items: center;\n    margin-left: 40px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            ajaxing: {
                booking: false,
                approval: false
            },
            bookingResult: {},
            approveResult: {},
            selectedStudioId: 0
        };
    },
    mounted: function mounted() {
        if (!this.studioId) return;
        this.fetchApproveData(this.studioId);
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId', 'isSeventeen']), (0, _vuex.mapState)({
        layoutSettingScheduleAmount: function layoutSettingScheduleAmount(state) {
            return state.webadmin.configure.webFunctions.WebadminCustomerLayoutSettingScheduleAmount;
        },
        layoutSettingApprovalTerm: function layoutSettingApprovalTerm(state) {
            return state.webadmin.configure.webFunctions.WebadminCustomerLayoutSettingApprovalTerm;
        }
    }), {
        loading: function loading() {
            return this.ajaxing.booking || this.ajaxing.approval;
        },
        bookingStatus: function bookingStatus() {
            return this.bookingResult.is_show_remain_qty ? '啟用' : '未啟用';
        },
        bookingAmountString: function bookingAmountString() {
            if (!this.bookingResult.is_show_remain_qty) {
                return '不顯示剩餘人數';
            }
            if (this.bookingResult.show_remain_style == '1') {
                return '顯示全部名額';
            }

            if (this.bookingResult.show_remain_style == '2') {
                return '當剩餘可預約人數少於' + this.bookingResult.limit_qty + '時，顯示剩餘人數';
            }
        },
        approveTermStatus: function approveTermStatus() {
            return this.approveResult.is_show_in_client_side ? '啟用' : '未啟用';
        },
        approveTermString: function approveTermString() {
            if (!this.approveResult.is_show_in_client_side) {
                return '無';
            }

            return this.approveResult.approval_term_name;
        }
    }),
    watch: {
        studioId: function studioId(newVal) {
            if (newVal) {
                this.fetchBookingData(newVal);
                this.fetchApproveData(newVal);
            };
        }
    },
    methods: {
        getBindedStudio: function getBindedStudio(id) {
            this.fetchBookingData(id);
            this.fetchApproveData(id);
            this.selectedStudioId = id;
        },
        openSchedule: function openSchedule() {
            if (this.layoutSettingScheduleAmount) {
                window.open("/webadmin/layout-setting/user-interface/schedule-amount?tab_hidden=true");
            } else {
                $17.swal({
                    type: 'error',
                    title: '您的權限不足，請洽管理者或客服人員!',
                    showCancelButton: false
                });
            }
        },
        openApproveTerm: function openApproveTerm() {
            if (this.layoutSettingApprovalTerm) {
                window.open("/webadmin/layout-setting/user-interface/approval-term?tab_hidden=true");
            } else {
                $17.swal({
                    type: 'error',
                    title: '您的權限不足，請洽管理者或客服人員!',
                    showCancelButton: false
                });
            }
        },
        fetchBookingData: function fetchBookingData(studioId) {
            var _this = this;

            this.ajaxing.booking = true;
            this.$http.get('/adminapi/user-interface-layout-setting/booking-class/get/' + studioId).then(function (response) {
                _this.bookingResult = response.data.result;
                _this.ajaxing.booking = false;
            }).catch(function (error) {
                $17.swal({
                    type: 'error',
                    title: '取得資料錯誤',
                    text: error.data.error,
                    showCancelButton: false
                });
                _this.ajaxing.booking = false;
            });
        },
        fetchApproveData: function fetchApproveData(studioId) {
            var _this2 = this;

            this.ajaxing.approval = true;
            this.$http.get('/adminapi/user-interface-layout-setting/approve-term/get/' + studioId).then(function (response) {
                _this2.approveResult = response.data.result;
                _this2.ajaxing.approval = false;
            }).catch(function (error) {
                $17.swal({
                    type: 'error',
                    title: '取得資料錯誤',
                    text: error.data.error,
                    showCancelButton: false
                });
                _this2.ajaxing.approval = false;
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div style=\"margin: 30px 20px 0 50px;\" _v-26ec7911=\"\">\n    <v-multiselect-studio-and-branch :studio_id=\"studioId\" :show-branch=\"false\" :studio-change-call-back=\"getBindedStudio\" _v-26ec7911=\"\"></v-multiselect-studio-and-branch>\n     <v-spinner :ajaxing=\"loading\" _v-26ec7911=\"\"></v-spinner>\n    <div v-show=\"!loading\" _v-26ec7911=\"\">\n        <h4 _v-26ec7911=\"\">課程名額顯示</h4>\n        <div class=\"sub-title\" _v-26ec7911=\"\">讓客戶在線上預約課程時，查看名額</div>\n        <div class=\"block-content \" v-show=\"!loading\" _v-26ec7911=\"\">\n            <div class=\"block-content-left block-background\" _v-26ec7911=\"\">\n                <label _v-26ec7911=\"\">\n                    <span class=\"input-text\" _v-26ec7911=\"\">{{bookingStatus}}</span>\n                </label>\n                <div class=\"sub-note\" _v-26ec7911=\"\">{{bookingAmountString}}</div>\n            </div>\n            <div class=\"block-content-right\" _v-26ec7911=\"\">      \n                <a href=\"\" @click.stop.prevent=\"openSchedule\" target=\"_blank\" class=\"btn btn-lg btn-primary\" _v-26ec7911=\"\">設定</a>\n            </div>\n        </div>\n    </div>\n    <hr _v-26ec7911=\"\">\n    <div v-show=\"!loading\" _v-26ec7911=\"\">\n        <h4 _v-26ec7911=\"\">同意條款設定</h4>\n        <div class=\"sub-title\" _v-26ec7911=\"\">讓客戶在線上購買方案時，需同意的條款</div>\n        <div class=\"block-content \" v-show=\"!loading\" _v-26ec7911=\"\">\n            <div class=\"block-content-left block-background\" _v-26ec7911=\"\">\n                <label _v-26ec7911=\"\">\n                    <span class=\"input-text\" _v-26ec7911=\"\">{{approveTermStatus}}</span>\n                </label>\n                <div class=\"sub-note\" _v-26ec7911=\"\">使用條款 : {{approveTermString}}</div>\n            </div>\n            <div class=\"block-content-right\" _v-26ec7911=\"\">      \n                <a href=\"\" target=\"_blank\" @click.stop.prevent=\"openApproveTerm\" class=\"btn btn-lg btn-primary\" _v-26ec7911=\"\">設定</a>\n            </div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\nh4[_v-26ec7911] {\n  font-size: 28px; }\n\n/* line 5, stdin */\n.sub-title[_v-26ec7911] {\n  color: #44444F;\n  font-size: 16px;\n  margin-top: 16px; }\n\n/* line 10, stdin */\nhr[_v-26ec7911] {\n  margin-top: 32px;\n  margin-bottom: 32px; }\n\n/* line 15, stdin */\n.block-background[_v-26ec7911] {\n  background-color: #FAFAFB;\n  max-width: 50%;\n  padding: 16px;\n  font-size: 16px;\n  margin-top: 8px; }\n\n/* line 22, stdin */\n.block-content[_v-26ec7911] {\n  width: 100%;\n  display: -ms-inline-flexbox;\n  display: inline-flex; }\n  /* line 25, stdin */\n  .block-content .block-content-left[_v-26ec7911] {\n    width: 50%; }\n  /* line 28, stdin */\n  .block-content .block-content-right[_v-26ec7911] {\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    -ms-flex-align: center;\n        align-items: center;\n    margin-left: 40px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-26ec7911", module.exports)
  } else {
    hotAPI.update("_v-26ec7911", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1207:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.tabs[_v-ef606754] {\n  margin: 35px 0; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            currentView: 'order-sales'
        };
    },
    mounted: function mounted() {},

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId'])),
    watch: {},
    methods: {
        fetchSalesPersonData: function fetchSalesPersonData() {
            var _this = this;

            this.ajaxing.get = true;
            var postData = {
                'studio_id': this.studioId
            };
            this.$http.post('/adminapi/layout-setting/salesperson-visible/get', postData).then(function (response) {
                var result = response.data.result;
                _this.orderSalesVisibleList.forEach(function (item) {
                    item.display = result[item.id];
                });
                _this.ajaxing.get = false;
            }).catch(function (error) {
                $17.swal({
                    type: 'error',
                    title: '取得資料錯誤',
                    text: error.data.error,
                    showCancelButton: false
                });
                _this.ajaxing.get = false;
            });
        },
        save: function save() {
            var _this2 = this;

            this.ajaxing.save = true;
            var postData = {
                'studio_id': this.studioId
            };
            this.orderSalesVisibleList.forEach(function (item) {
                postData[item.id] = item.display ? 1 : 0;
            });
            this.$http.post('/adminapi/layout-setting/salesperson-visible/update', postData).then(function (response) {
                _this2.ajaxing.save = false;
            }).catch(function (error) {
                $17.swal({
                    type: 'error',
                    title: '儲存失敗',
                    text: error.data.error,
                    showCancelButton: false
                });
                _this2.ajaxing.save = false;
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div style=\"margin: 0 20px 0 15px;\" _v-ef606754=\"\">\n    <div class=\"tabs\" _v-ef606754=\"\">\n        <ul class=\"nav nav-tabs\" _v-ef606754=\"\">\n            <li @click.prevent=\"[currentView='order-sales']\" :class=\"currentView=='order-sales' ? 'active' : ''\" _v-ef606754=\"\">\n                <a _v-ef606754=\"\">訂單業務代表</a>\n            </li>\n            <li @click.prevent=\"[currentView='customer-sales']\" :class=\"currentView=='customer-sales' ? 'active' : ''\" _v-ef606754=\"\">\n                <a _v-ef606754=\"\">客戶業務代表</a>\n            </li>\n        </ul>\n    </div>\n    <order-sales-layout-setting v-if=\"currentView === 'order-sales'\" :studio-id=\"studioId\" :branch-id=\"branchId\" _v-ef606754=\"\"></order-sales-layout-setting>\n    <customer-servant-layout-setting v-if=\"currentView === 'customer-sales'\" :servant-type=\"'業務代表'\" :studio-id=\"studioId\" :branch-id=\"branchId\" _v-ef606754=\"\"></customer-servant-layout-setting>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.tabs[_v-ef606754] {\n  margin: 35px 0; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-ef606754", module.exports)
  } else {
    hotAPI.update("_v-ef606754", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1208:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 4, stdin */\n.paginate-list {\n  list-style-type: none;\n  padding: 0; }\n  /* line 7, stdin */\n  .paginate-list li {\n    display: block; }\n\n/* line 12, stdin */\n.paginate-links.list {\n  list-style-type: none;\n  padding: 0;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none; }\n  /* line 16, stdin */\n  .paginate-links.list li.a {\n    cursor: pointer;\n    font-size: 1rem;\n    color: #42b983; }\n  /* line 21, stdin */\n  .paginate-links.list li.active a {\n    font-weight: bold; }\n  /* line 24, stdin */\n  .paginate-links.list li.next:before {\n    content: ' | ';\n    margin-right: 13px;\n    color: #ddd; }\n  /* line 29, stdin */\n  .paginate-links.list li.disabled a {\n    color: #ccc;\n    cursor: no-drop; }\n\n/* line 34, stdin */\n.paginate-links li {\n  display: inline-block;\n  margin: 0 10px; }\n\n/* line 39, stdin */\n.lesson_table tr td {\n  border-style: none !important;\n  border-width: 0em; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            list: [],
            paginate: ['list'],
            shown: false,
            contract_name: '',
            view: {
                ajaxing: false,
                show_content: false
            }
        };
    },
    watch: {},
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId', 'isSeventeen']), (0, _vuex.mapState)('filters', ['selected_studio_id', 'selected_branch_id'])),
    mounted: function mounted() {
        var _this = this;

        setTimeout(function () {
            _this.shown = true;
        }, 1000);
    },
    methods: {
        onSearch: function onSearch() {
            if (this.contract_name.length < 1) {
                this.alert('最少要輸入一個字元', '', 'warning');
            } else {
                this.getList();
            }
        },
        changeBranch: function changeBranch() {
            this.view.show_content = false;
        },
        getList: function getList() {
            var _this2 = this;

            this.view.ajaxing = true;
            if (this.selected_branch_id === null || this.selected_branch_id === 'null') {
                return;
            }
            this.$http.get('/adminapi/lesson_quantity_searching?branch_id=' + this.selected_branch_id + "&keyword=" + this.contract_name).then(function (response) {
                if (response.body.length > 0) {
                    _this2.list = response.body;
                    _this2.view.show_content = true;
                } else {
                    _this2.view.show_content = false;
                }
                _this2.view.ajaxing = false;
            }, function (error) {
                _this2.view.ajaxing = false;
                _this2.view.show_content = false;
            });
        },
        alert: function alert(title, message, type, showCancelBtn) {
            $17.swal({
                title: title,
                text: message,
                type: type,
                showCancelButton: false,
                showLoaderOnConfirm: true
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n    <div class=\"content-inner\">\n        <v-select-studio-and-branch :studio_id=\"studioId\" :branch-without-filtered-option=\"false\" :branch_id=\"branchId\" :branch-change-call-back=\"changeBranch\"></v-select-studio-and-branch>\n    <div>\n    <v-spinner :ajaxing=\"view.ajaxing\"></v-spinner>\n    <div v-show=\"!view.ajaxing\" class=\"m-top-20\">\n        <div v-if=\"selected_branch_id !== '' &amp;&amp; selected_branch_id !== 0 &amp;&amp; selected_branch_id !== null\" class=\"col-md-4 m-bottom-30\">\n            <div class=\"input-group\">\n                <input type=\"text\" @keyup.enter.prevent=\"onSearch\" v-model=\"contract_name\" class=\"form-control\" placeholder=\"輸入方案名稱\">\n                <span class=\"input-group-btn\">\n                    <a href=\"javascript:void(0)\" @click=\"onSearch\" class=\"btn btn-info\"><i class=\"fa fa-search\" aria-hidden=\"true\"></i></a>\n                </span>\n            </div>\n        </div>\n   \n        <div>\n            \n         <paginate v-show=\"view.show_content\" :per=\"25\" name=\"list\" :list=\"list\" class=\"paginate-list\">\n            <li v-for=\"item in paginated('list')\" :key=\"item.id\">\n                \n                <table class=\"table lesson_table\">\n\n                        <tbody><tr class=\"\">\n                            <td style=\"width:20%;\">方案名稱</td>\n                            <td>{{ item.contract_name }}</td>\n                        </tr>\n                        <tr class=\"\">\n                            <td>剩餘名額</td>\n                            <td>{{ item.quantity }}</td>\n                        </tr>\n                        <tr class=\"\">\n                            <td>課表名稱及名額</td>\n                            <td>\n                                <div v-for=\"schedule in item.schedules\" :key=\"schedule.id\">\n                                    {{ schedule.date + ' ' + schedule.time_start + ' ' + schedule.name + '(' + schedule.bookingCount + '/' + schedule.qty + ')'}} <br>\n                                </div>\n                            </td>\n                        </tr>\n\n                </tbody></table>\n                <hr>\n            </li>\n            </paginate>\n            <div v-show=\"view.show_content\">\n                <paginate-links for=\"list\" :show-step-links=\"true\" :async=\"true\">\n                </paginate-links>\n            </div>\n        </div>\n    </div>\n\n</div></div>"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 4, stdin */\n.paginate-list {\n  list-style-type: none;\n  padding: 0; }\n  /* line 7, stdin */\n  .paginate-list li {\n    display: block; }\n\n/* line 12, stdin */\n.paginate-links.list {\n  list-style-type: none;\n  padding: 0;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none; }\n  /* line 16, stdin */\n  .paginate-links.list li.a {\n    cursor: pointer;\n    font-size: 1rem;\n    color: #42b983; }\n  /* line 21, stdin */\n  .paginate-links.list li.active a {\n    font-weight: bold; }\n  /* line 24, stdin */\n  .paginate-links.list li.next:before {\n    content: ' | ';\n    margin-right: 13px;\n    color: #ddd; }\n  /* line 29, stdin */\n  .paginate-links.list li.disabled a {\n    color: #ccc;\n    cursor: no-drop; }\n\n/* line 34, stdin */\n.paginate-links li {\n  display: inline-block;\n  margin: 0 10px; }\n\n/* line 39, stdin */\n.lesson_table tr td {\n  border-style: none !important;\n  border-width: 0em; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-4c30caab", module.exports)
  } else {
    hotAPI.update("_v-4c30caab", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1209:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    data: function data() {
        return {
            api: {
                method: 'get',
                apiurl: '/adminapi/line-marketplace/get-binding-report',
                payload: {
                    page: 1
                }
            },
            apiConfig: {},
            csvConfig: {
                column: [{ keys: 'studio_name', name: '品牌名稱' }, { keys: 'branch_name', name: '場館名稱' }, { keys: 'has_line_mc_auth', name: '是否具有 LINE 市集外掛權限' }, { keys: 'account', name: 'OA 帳號' }, { keys: 'attach_state', name: '綁定狀態' }, { keys: 'attach_time', name: '最後一次綁定時間' }, { keys: 'deleted_time', name: '最後一次解除時間' }, { keys: 'studio_is_active', name: '品牌上下架狀態' }, { keys: 'branch_is_active', name: '場館上下架狀態' }],
                api: {
                    method: 'get',
                    apiurl: '/adminapi/line-marketplace/get-binding-report',
                    payload: {
                        page: 1,
                        pageSize: 99999
                    }
                }
            },
            tableConfig: {
                columns: [{
                    keys: 'studio_name',
                    head: '品牌名稱'
                }, {
                    keys: 'branch_name',
                    head: '場館名稱'
                }, {
                    keys: 'has_line_mc_auth',
                    head: '是否具有 LINE 市集外掛權限'
                }, {
                    keys: 'account',
                    head: 'OA 帳號'
                }, {
                    keys: 'attach_state',
                    head: '綁定狀態'
                }, {
                    keys: 'attach_time',
                    head: '最後一次綁定時間'
                }, {
                    keys: 'deleted_time',
                    head: '最後一次解除時間'
                }, {
                    keys: 'studio_is_active',
                    head: '品牌上下架狀態'
                }, {
                    keys: 'branch_is_active',
                    head: '場館上下架狀態'
                }]
            }
        };
    },
    mounted: function mounted() {},

    computed: {},
    methods: {
        showReport: function showReport() {
            if (this.apiConfig.apiurl) {
                this.$refs.smart_table.refresh();
            } else {
                this.apiConfig = this.api;
            }
        },
        exportCSV: function exportCSV() {
            this.$refs.smart_table.downloadCsv();
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"row p-right-10 p-left-20\">\n    <div class=\"col-md-12\">\n        <h3>查詢 LINE 外掛模組綁定狀態</h3>\n        <div>此報表查詢出的資訊為截至目前為止的資訊狀況</div>\n    </div>\n    <div class=\"col-md-12 m-bottom-20 m-top-10\">\n        <button type=\"button\" class=\"btn btn-default\" @click=\"showReport\">查詢</button>\n        <button type=\"button\" class=\"btn btn-default\" @click=\"exportCSV\">匯出 CSV</button>\n    </div>\n    <div class=\"col-md-12\">\n        <v-smart-table ref=\"smart_table\" :api-config=\"apiConfig\" :table-config=\"tableConfig\" :csv-config=\"csvConfig\" :page-sync-url-query=\"false\"></v-smart-table>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-3729a0ca", module.exports)
  } else {
    hotAPI.update("_v-3729a0ca", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],1210:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _lineMarketplaceSetting = require('./lineMarketplaceSetting.vue');

var _lineMarketplaceSetting2 = _interopRequireDefault(_lineMarketplaceSetting);

var _bindingReport = require('./bindingReport.vue');

var _bindingReport2 = _interopRequireDefault(_bindingReport);

var _material = require('./material.vue');

var _material2 = _interopRequireDefault(_material);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('line-marketplace-setting', _lineMarketplaceSetting2.default);
_vue2.default.component('line-marketplace-binding-report', _bindingReport2.default);
_vue2.default.component('line-marketplace-material', _material2.default);

},{"./bindingReport.vue":1209,"./lineMarketplaceSetting.vue":1211,"./material.vue":1212,"vue":792}],1211:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.select2-container--default .select2-selection--single .select2-selection__placeholder[_v-66969487] {\n  color: inherit; }\n\n/* line 6, stdin */\n.select-outer-div[_v-66969487] {\n  display: block !important; }\n\n/* line 10, stdin */\n.search-option[_v-66969487] {\n  max-width: 400px; }\n\n/* line 14, stdin */\n.btn--line-bot[_v-66969487] {\n  position: relative;\n  border-color: #00c200;\n  background: #00c200;\n  color: white; }\n  /* line 20, stdin */\n  .btn--line-bot [_v-66969487]::before {\n    position: absolute;\n    width: 50px;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    line-height: 40px;\n    font-family: 'FontAwesome';\n    content: \"\\f3c0\";\n    left: 0px;\n    border-right: 1px solid #008f00; }\n\n/* line 34, stdin */\n.fa-question-circle[_v-66969487] {\n  color: #377BB5;\n  font-size: 18px;\n  margin-left: 25px; }\n\n/* line 40, stdin */\n.btn-default[_v-66969487] {\n  color: #00c200;\n  border-color: #00c200; }\n\n/* line 45, stdin */\n.btn-primary[_v-66969487] {\n  border-color: #aaaaaa;\n  background-color: #aaaaaa; }\n\n/* line 50, stdin */\n.btn-default[_v-66969487]:hover {\n  border-color: #aaaaaa;\n  background-color: #aaaaaa; }\n\n/* line 55, stdin */\n.btn-default[_v-66969487]:hover {\n  background-color: white;\n  border-color: #00c200; }\n\n/* line 60, stdin */\ninput[type=radio][_v-66969487] {\n  transform: scale(1.5); }\n\n/* line 64, stdin */\n.i-hide[_v-66969487] {\n  display: none; }\n\n/* line 68, stdin */\n.myDIV:hover .i-hide[_v-66969487] {\n  display: inline; }\n\n/* line 2, stdin */\n.message {\n  max-width: 70em;\n  word-break: break-all !important; }\n")
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require("vuex");

var _tippy = require("tippy.js");

var _tippy2 = _interopRequireDefault(_tippy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        var action = 'bind';
        var url = new URL(window.location.href);
        return {
            system_plan: url.searchParams.get("system_plan"),
            isBindAlert: url.searchParams.get("isBindAlert"),
            ajaxing: false,
            richMenuAjaxing: true,
            richMenuMode: 'view',
            customizeRichMenuList: '',
            action: action,
            defaultStudioId: 0,
            defaultBranchId: 0,
            isBinding: 0,
            botInfo: "",
            owner_type: "",
            owner_id: "",
            bot_id: "",
            post_rich_menu_id: 0,
            displayName: "",
            pictureUrl: "",
            tableConfig: {
                columns: [{
                    keys: 'user_id', head: 'LINE 用戶',
                    html: function html(item) {
                        return "<button class=\"btn btn-success btn-sm\" @click.prevent.stop=\"clickHandler('click-line')\" id=\"tippy" + item.id + "\">\u986F\u793A\u8CC7\u8A0A</button>";
                    }
                }, { keys: 'message_text', head: '訊息內容', cssClass: "message" }, { keys: 'message_time', head: '時間' }, {
                    keys: 'member_name', head: '連動的客戶資料',
                    html: function html(item) {
                        return "<a class=\"\" @click.prevent.stop=\"clickHandler('click-member')\" >" + item.member_name + "</a>";
                    }
                }]
            },
            apiConfig: {},
            memberId: '',
            tippyAjax: false
        };
    },
    mounted: function mounted() {
        this.getQueryBranchId();
        this.bindAlert();
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId', 'isBranch', 'isSeventeen', 'studioName']), (0, _vuex.mapState)('filters', ['selected_studio_id', 'selected_branch_id']), {
        hooks: function hooks() {
            var hookName = "";
            if (this.owner_type == 'studio') {
                hookName = "lineMarketplace.studioBind";
            } else {
                hookName = "lineMarketplace.branchBind";
            }
            return (0, _defineProperty3.default)({}, hookName, {
                settingUrl: 'webadmin/line-marketplace/setting'
            });
        },
        auth: function auth() {
            return {
                owner_id: this.owner_id,
                owner_type: this.owner_type
            };
        }
    }),
    methods: {
        getQueryBranchId: function getQueryBranchId() {
            var urlParams = new URLSearchParams(window.location.search);
            this.defaultBranchId = parseInt(urlParams.get('branch_id'));
            this.defaultStudioId = parseInt(urlParams.get('studio_id'));
        },
        bindSubmit: function bindSubmit() {
            this.$refs.submitBind.submit();
        },
        bindAlert: function bindAlert() {
            if (this.isBindAlert === 'true') {
                window.history.pushState(null, null, "?");
                $17.swal({
                    text: '開通完成',
                    type: 'success',
                    showCancelButton: false,
                    confirmButtonText: '了解更多詳情'
                }, function () {
                    window.open('https://17fithelp.zendesk.com/hc/zh-tw/articles/900002906803', '_blank');
                });
            }
        },
        alert: function alert(type, title) {
            var text = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
            var html = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

            $17.swal({
                title: title,
                text: text,
                type: type,
                html: html,
                showCancelButton: false
            });
        },
        getBind: function getBind() {
            var _this2 = this;

            this.ajaxing = false;
            this.setChangeOwnerType();
            this.$http.get('/adminapi/line-marketplace/get-isBind/' + this.owner_type + '/' + this.owner_id).then(function (response) {
                _this2.isBinding = response.data.isBind;
                _this2.botInfo = response.data;
                _this2.ajaxing = true;
                if (_this2.botInfo.richMenu) {
                    _this2.post_rich_menu_id = _this2.botInfo.richMenu.id;
                }
                if (_this2.system_plan === 'line-mc' && _this2.isBinding === 0) {
                    _this2.bindSubmit();
                }
                _this2.getMessageLog();
                _this2.getCustomize();
            }, function (error) {
                _this2.ajaxing = true;
                _this2.isBinding = 0;
                _this2.botInfo = {};
                _this2.alert('error', error.data.error, "取得line 綁定資訊錯誤，請洽管理者或客服人員！");
            });
        },
        getMessageLog: function getMessageLog() {
            this.apiConfig = {
                method: 'get',
                apiurl: '/adminapi/line-marketplace/get-message-log/' + this.owner_type + '/' + this.owner_id,
                payload: {
                    page: this.getUrlParamValue('page') ? this.getUrlParamValue('page') : 1
                },
                recordName: 'pageData'
            };
        },
        clickDetach: function clickDetach() {
            var vm = this;
            $17.swal({
                title: '請確認是否解除連動?',
                text: '試用期間一旦解除連結，即屬試用期滿，恕無法再提供試用。',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: '確認',
                cancelButtonText: '取消'
            }, function (isConfirm) {
                if (isConfirm) {
                    vm.detachBind();
                }
            });
        },
        detachBind: function detachBind() {
            var _this3 = this;

            this.ajaxing = false;
            this.$http.get('/adminapi/line-marketplace/detach-bind/' + this.owner_type + '/' + this.owner_id).then(function (response) {
                _this3.isBinding = response.data.isBind;
                _this3.ajaxing = true;
            }).catch(function (error) {
                _this3.alert('error', error.data.error, "請洽管理者或客服人員！");
                _this3.ajaxing = true;
            });
        },
        getSelectStudioName: function getSelectStudioName() {
            return "品牌-" + this.studioName;
        },
        setChangeOwnerType: function setChangeOwnerType() {
            if (this.selected_branch_id == null) {
                this.owner_type = 'studio';
                this.owner_id = this.selected_studio_id;
            } else {
                this.owner_type = 'branch';
                this.owner_id = this.selected_branch_id;
            }
        },
        getTypeHook: function getTypeHook() {
            return {
                'lineMarketplace.bind': {
                    settingUrl: 'webadmin/line-marketplace/setting'
                }
            };
        },
        richMenuBind: function richMenuBind() {
            if (this.post_rich_menu_id < 1) {
                this.alert('warning', '請選擇圖文選單');
                return false;
            }
            var _this = this;
            $17.swal({
                title: '同步建立 圖文選單',
                text: "同步將系統預設圖文選單 建立於LINE官方帳號",
                type: 'info'
            }, function () {
                _this.richMenuAjaxing = false;
                _this.$http.post('/adminapi/line-marketplace/rich-menu-bind/' + _this.owner_type + '/' + _this.owner_id, { rich_menu_id: _this.post_rich_menu_id }).then(function (response) {
                    _this.alert('success', '同步成功', "");
                    _this.richMenuAjaxing = true;
                    _this.richMenuMode = 'view';
                    _this.botInfo.richMenu = response.data.data.richMenu;
                }).catch(function (error) {
                    _this.richMenuAjaxing = true;
                    _this.alert('error', '同步失敗', "請洽管理者或客服人員！");
                });
            });
        },
        clickHtmlHandler: function clickHtmlHandler(data) {
            switch (data.action) {
                case 'click-line':
                    if (!this.tippyAjax) {
                        this.getUserProfile(data.row.id, data.row.user_id);
                    }
                    break;
                case 'click-member':
                    this.memberId = data.row.member_id;
                    break;
            }
        },
        getUserProfile: function getUserProfile(id, userId) {
            var _this4 = this;

            this.tippyAjax = true;
            this.$http.get('/adminapi/line-marketplace/get-user-profile/' + this.botInfo.botId + '/' + userId).then(function (response) {
                _this4.displayName = response.data.displayName;
                _this4.pictureUrl = response.data.pictureUrl == null ? '/images/default.png' : response.data.pictureUrl;
                _this4.bind = '#tippy' + id;
                _this4.tippyAjax = false;
            }).then(function () {
                var template = document.getElementById('line-user-modal');
                (0, _tippy2.default)(_this4.bind, {
                    content: template.innerHTML,
                    allowHTML: true,
                    trigger: 'click',
                    onCreate: function onCreate(instance) {
                        instance.show();
                    }
                });
            });
        },
        getCustomize: function getCustomize() {
            var _this5 = this;

            this.$http.get('/adminapi/line-marketplace/get-customize-rich-menu-list/' + this.owner_id + '@' + this.owner_type).then(function (response) {
                _this5.customizeRichMenuList = response.data;
            }).catch(function (error) {
                _this5.alert('error', error.data.error, "請洽管理者或客服人員！");
            });
        },
        checkDeleteCustomizeRichMenu: function checkDeleteCustomizeRichMenu(id) {
            var _this6 = this;

            var vm = this;
            $17.swal({
                title: '確定刪除？',
                type: 'info',
                showCancelButton: true,
                confirmButtonText: '確定',
                cancelButtonText: '取消'
            }, function (isConfirm) {
                if (isConfirm) {
                    if (_this6.botInfo.richMenu !== null && id === _this6.botInfo.richMenu.id) {
                        setTimeout(function () {
                            _this6.alert('warning', '刪除失敗', "此圖文正在使用中");
                        }, "500");
                    } else {
                        vm.deleteCustomizeRichMenu(id);
                    }
                }
            });
        },
        deleteCustomizeRichMenu: function deleteCustomizeRichMenu(id) {
            var _this7 = this;

            this.$http.delete('/adminapi/line-marketplace/delete-customize-rich-menu/' + id + '?merchantOfficialAccountId=' + this.botInfo.merchantOfficialAccountId).then(function (response) {
                _this7.alert('success', '', "刪除成功");
                _this7.getCustomize();
            }, function (error) {
                _this7.alert('error', '刪除失敗', "請洽管理者或客服人員！");
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-66969487=\"\">\n    <div class=\"row\" _v-66969487=\"\">\n        <div class=\"col-md-3\" _v-66969487=\"\">\n            <v-multiselect-studio-and-branch :studio_id=\"studioId\" :branch_id=\"branchId\" :default_studio_id=\"defaultStudioId\" :default_branch_id=\"defaultBranchId\" :branch-without-filtered-option=\"true\" :branch-without-filtered-option-word=\"getSelectStudioName()\" :branch-change-call-back=\"getBind\" _v-66969487=\"\"></v-multiselect-studio-and-branch>\n        </div>\n    </div>\n    <div class=\"row\" _v-66969487=\"\">\n        <div class=\"col-md-3\" v-show=\"ajaxing\" _v-66969487=\"\">\n            <button type=\"button\" class=\"btn btn--line-bot\" @click.prevent=\"bindSubmit\" v-show=\"!isBinding\" _v-66969487=\"\">連動 LINE\n                官方帳號\n            </button>\n            <button type=\"button\" class=\"btn btn-default\" v-show=\"isBinding\" _v-66969487=\"\">已連動 LINE 官方帳號</button>\n            <a href=\"https://17fithelp.zendesk.com/hc/zh-tw/articles/900002906803\" target=\"_blank\" _v-66969487=\"\"><i class=\"fa fa-question-circle\" _v-66969487=\"\"></i></a>\n        </div>\n    </div>\n    <div class=\"row\" _v-66969487=\"\">\n        <div class=\"col-md-3 m-top-15 m-left-15\" v-show=\"isBinding\" _v-66969487=\"\">\n            連動的 OA 帳號：{{botInfo.disPlayName}} <span style=\"color:#929292\" _v-66969487=\"\">{{botInfo.basicId}}</span>\n        </div>\n    </div>\n    <div class=\"row\" _v-66969487=\"\">\n        <div class=\"col-md-3 m-top-15 m-left-15\" v-show=\"isBinding\" _v-66969487=\"\">\n            試用期間：{{botInfo.startDate}} ~ {{botInfo.endDate}}\n        </div>\n    </div>\n    <div class=\"row\" v-if=\"isSeventeen\" _v-66969487=\"\">\n        <div class=\"col-md-3 m-top-15 m-left-15\" v-show=\"isBinding\" _v-66969487=\"\">\n            系統方案：{{botInfo.systemPlan}}\n        </div>\n    </div>\n    <hr v-show=\"isBinding\" _v-66969487=\"\">\n    <h3 v-show=\"isBinding\" _v-66969487=\"\">推播訊息用量 <a href=\"https://17fithelp.zendesk.com/hc/zh-tw/articles/4404198404761\" target=\"_blank\" _v-66969487=\"\"><i class=\"fa fa-question-circle\" _v-66969487=\"\"></i></a></h3>\n    <div class=\"row\" _v-66969487=\"\">\n        <div class=\"col-md-3 m-top-15 m-left-15\" v-show=\"isBinding\" _v-66969487=\"\">\n            本月推播額度：{{botInfo.messageQuota}}\n        </div>\n    </div>\n    <div class=\"row\" _v-66969487=\"\">\n        <div class=\"col-md-3 m-top-15 m-left-15\" v-show=\"isBinding\" _v-66969487=\"\">\n            本月已傳送推播：{{botInfo.messageQuotaConsumption}}\n        </div>\n    </div>\n    <hr v-show=\"isBinding\" _v-66969487=\"\">\n    <h3 v-show=\"isBinding\" _v-66969487=\"\">圖文選單<a href=\"https://17fithelp.zendesk.com/hc/zh-tw/articles/7820992765721\" target=\"_blank\" _v-66969487=\"\"><i class=\"fa fa-question-circle\" _v-66969487=\"\"></i></a></h3>\n    <div class=\"m-top-15 m-left-15\" v-show=\"isBinding &amp;&amp; richMenuMode==='view'\" _v-66969487=\"\">\n        最後同步建立的圖文選單：\n    </div>\n    <div v-show=\"isBinding &amp;&amp; richMenuAjaxing\" _v-66969487=\"\">\n        <div class=\"row\" v-if=\"richMenuMode==='edit'\" _v-66969487=\"\">\n            <div class=\"col-md-3 m-botttmarketplaceom-10\" _v-66969487=\"\">\n                <a :href=\"'material/create?owner_type=' + owner_type + '&amp;owner_id=' + owner_id + '&amp;studio_id=' + selected_studio_id + '&amp;branch_id=' + selected_branch_id \" target=\"_blank\" _v-66969487=\"\">＋新增圖文選單</a>\n            </div>\n        </div>\n        <div class=\"row\" _v-66969487=\"\">\n            <div v-if=\"richMenuMode==='view'\" _v-66969487=\"\">\n                <div class=\"col-md-3 m-top-15 m-left-15\" _v-66969487=\"\">\n                    <img v-if=\"botInfo.richMenu\" :src=\"botInfo.richMenu.image_path\" class=\"img-thumbnail \" _v-66969487=\"\">\n                    <img v-else=\"\" src=\"/images/line_rich_menu.png\" class=\"img-thumbnail \" _v-66969487=\"\">\n                </div>\n            </div>\n            <div v-else=\"\" _v-66969487=\"\">\n                <div v-for=\"item in botInfo.absoluteRichMenuList\" class=\"col-md-3 m-top-15 m-left-15\" _v-66969487=\"\">\n                    <label _v-66969487=\"\">\n                        <input type=\"radio\" :value=\"item.id\" v-model=\"post_rich_menu_id\" _v-66969487=\"\">\n                        <span class=\"m-left-10\" _v-66969487=\"\">{{item.name}}</span>\n                        <img :src=\"item.image_path\" class=\"img-thumbnail\" style=\"margin-top: 5px\" _v-66969487=\"\">\n                    </label>\n                </div>\n                <div v-for=\"item in customizeRichMenuList\" class=\"col-md-3 m-top-15 m-left-15\" _v-66969487=\"\">\n                    <label class=\"myDIV\" _v-66969487=\"\">\n                        <input type=\"radio\" :value=\"item.id\" v-model=\"post_rich_menu_id\" _v-66969487=\"\">\n                        <span class=\"m-left-10\" _v-66969487=\"\">{{item.name}}</span><i @click.prevent.stop=\"checkDeleteCustomizeRichMenu(item.id)\" class=\"fa fa-trash-o m-left-10 i-hide\" _v-66969487=\"\"></i>\n                        <img :src=\"item.url\" class=\"img-thumbnail\" style=\"margin-top: 5px\" _v-66969487=\"\">\n                    </label>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\" _v-66969487=\"\">\n            <div class=\"col-md-3 m-top-15 m-left-15\" _v-66969487=\"\">\n                <div v-if=\"richMenuMode==='edit'\" _v-66969487=\"\">\n                    <button type=\"button\" class=\"btn btn-info\" @click.prevent=\"richMenuBind\" _v-66969487=\"\">同步建立</button>\n                    <button type=\"button\" class=\"btn btn-primary\" @click.prevent=\"richMenuMode='view'\" _v-66969487=\"\">返回</button>\n                </div>\n                <button v-else=\"\" type=\"button\" class=\"btn btn-info\" @click.prevent=\"richMenuMode='edit'\" _v-66969487=\"\">檢視所有圖文選單\n                </button>\n            </div>\n        </div>\n    </div>\n    <v-spinner :ajaxing=\"!richMenuAjaxing\" id=\"v-spinner\" _v-66969487=\"\">\n    </v-spinner>\n    <hr v-show=\"isBinding\" _v-66969487=\"\">\n    <h3 v-show=\"isBinding\" _v-66969487=\"\">其它設定</h3>\n    <div class=\"row\" _v-66969487=\"\">\n        <div class=\"col-md-12\" v-show=\"ajaxing\" _v-66969487=\"\">\n            <button type=\"button\" class=\"btn btn-primary\" v-show=\"isBinding\" @click.prevent=\"clickDetach\" _v-66969487=\"\">解除連動\n            </button>\n            <span style=\"color: red;\" v-show=\"isBinding\" _v-66969487=\"\">※ 請注意，試用期間一旦解除連結，即屬試用期滿，恕無法再提供試用。</span>\n        </div>\n    </div>\n    <form ref=\"submitBind\" :action=\"action\" method=\"post\" enctype=\"application/json\" _v-66969487=\"\">\n        <div v-for=\"(hook, hookName) in hooks\" _v-66969487=\"\">\n            <div v-for=\"(param, paramName) in hook\" _v-66969487=\"\">\n                <input type=\"hidden\" :name=\"'hooks[' + hookName + '][' + paramName + ']'\" :value=\"param\" _v-66969487=\"\">\n            </div>\n        </div>\n\n        <div v-for=\"(param, paramName) in auth\" _v-66969487=\"\">\n            <input type=\"hidden\" :name=\"'auth[' + paramName + ']'\" :value=\"param\" _v-66969487=\"\">\n        </div>\n    </form>\n    <hr v-show=\"isBinding\" _v-66969487=\"\">\n    <h3 v-show=\"isBinding\" _v-66969487=\"\">近期收到的訊息</h3>\n    <div v-show=\"isBinding\" _v-66969487=\"\">*點擊查看 LINE 用戶名稱及頭像</div>\n    <div class=\"row\" _v-66969487=\"\">\n        <div class=\"col-md-12\" v-show=\"ajaxing &amp;&amp; isBinding\" _v-66969487=\"\">\n            <v-smart-table ref=\"smart-table\" :table-config=\"tableConfig\" :api-config=\"apiConfig\" @html-click-callback=\"clickHtmlHandler\" _v-66969487=\"\"></v-smart-table>\n        </div>\n    </div>\n    <div id=\"line-user-modal\" hidden=\"\" _v-66969487=\"\">\n        <div style=\"display: flex ;align-items: center; gap: 20px 20px;height: 100px\" _v-66969487=\"\">\n            <img :src=\"pictureUrl\" style=\"border-radius:50%; width:70px;\" _v-66969487=\"\">\n            <span style=\"font-size: 16px; margin-right: 20px\" _v-66969487=\"\">\n                    {{displayName}}\n                </span>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.select2-container--default .select2-selection--single .select2-selection__placeholder[_v-66969487] {\n  color: inherit; }\n\n/* line 6, stdin */\n.select-outer-div[_v-66969487] {\n  display: block !important; }\n\n/* line 10, stdin */\n.search-option[_v-66969487] {\n  max-width: 400px; }\n\n/* line 14, stdin */\n.btn--line-bot[_v-66969487] {\n  position: relative;\n  border-color: #00c200;\n  background: #00c200;\n  color: white; }\n  /* line 20, stdin */\n  .btn--line-bot [_v-66969487]::before {\n    position: absolute;\n    width: 50px;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    line-height: 40px;\n    font-family: 'FontAwesome';\n    content: \"\\f3c0\";\n    left: 0px;\n    border-right: 1px solid #008f00; }\n\n/* line 34, stdin */\n.fa-question-circle[_v-66969487] {\n  color: #377BB5;\n  font-size: 18px;\n  margin-left: 25px; }\n\n/* line 40, stdin */\n.btn-default[_v-66969487] {\n  color: #00c200;\n  border-color: #00c200; }\n\n/* line 45, stdin */\n.btn-primary[_v-66969487] {\n  border-color: #aaaaaa;\n  background-color: #aaaaaa; }\n\n/* line 50, stdin */\n.btn-default[_v-66969487]:hover {\n  border-color: #aaaaaa;\n  background-color: #aaaaaa; }\n\n/* line 55, stdin */\n.btn-default[_v-66969487]:hover {\n  background-color: white;\n  border-color: #00c200; }\n\n/* line 60, stdin */\ninput[type=radio][_v-66969487] {\n  transform: scale(1.5); }\n\n/* line 64, stdin */\n.i-hide[_v-66969487] {\n  display: none; }\n\n/* line 68, stdin */\n.myDIV:hover .i-hide[_v-66969487] {\n  display: inline; }\n\n/* line 2, stdin */\n.message {\n  max-width: 70em;\n  word-break: break-all !important; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-66969487", module.exports)
  } else {
    hotAPI.update("_v-66969487", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/defineProperty":65,"babel-runtime/helpers/extends":66,"tippy.js":780,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1212:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 4, stdin */\n.btn-primary[_v-2d357895] {\n  border-color: #aaaaaa;\n  background-color: #aaaaaa; }\n")
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require("vuex");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        var url = new URL(window.location.href);
        return {
            ajaxing: false,
            name_check: false,
            image_check: false,
            owner_type: url.searchParams.get("owner_type"),
            owner_id: url.searchParams.get("owner_id"),
            studio_id: url.searchParams.get("studio_id"),
            branch_id: url.searchParams.get("branch_id"),
            rich_menu_class: 'FiveGrid',
            rich_menu_name: '',
            file_name: '',
            s3_url: '',
            folder: '',
            image: '',
            image_load: true,
            config: {
                rootFolder: '',
                removeModules: 'RenameFile,DeleteFile,CreateFolder,' + 'FilesMoveCopy,DeleteFolder,UploadFileButton,EditImage,RenameFolder,FormUpload'
            }
        };
    },
    mounted: function mounted() {},

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        canMediaLibraryEdit: function canMediaLibraryEdit(state) {
            return state.webadmin.configure.webFunctions.WebadminMediaLibraryEdit;
        }
    }), (0, _vuex.mapState)('webadmin/configure', ['s3StudioMedia'])),
    watch: {
        s3StudioMedia: function s3StudioMedia(val) {
            if (val) {
                this.config.rootFolder = val;
            }
        },
        canMediaLibraryEdit: function canMediaLibraryEdit(val) {
            if (val) {
                this.config.removeModules = 'RenameFile,DeleteFolder,EditImage';
            }
        }
    },
    methods: {
        insertImage: function insertImage(image) {
            $.blockUI();
            this.file_name = image.name;
            this.s3_url = image.url;
            this.folder = image.folder;
            this.image_load = false;
            var _this = this;
            this.checkImageCrop(image, function (url) {
                $17.swal({
                    title: '',
                    html: '此裁切後的檔案已存在<br>' + '是否重新裁切並加入相簿呢？',
                    type: 'warning',
                    confirmButtonText: '確認',
                    confirmButtonColor: '#337ab7'
                }, function (isConfirm) {
                    if (isConfirm) {
                        _this.openImageCrop(image);
                    } else {
                        _this.image = null;
                        _this.s3_url = url;
                        _this.image_load = true;
                    }
                });
            });
        },
        reload: function reload() {},
        checkPostData: function checkPostData(postData) {
            var check = false;
            this.name_check = false;
            this.image_check = false;

            if (postData.rich_menu_name === '' || postData.rich_menu_name.length > 16) {
                check = true;
                this.name_check = true;
                this.ajaxing = false;
            }

            if (postData.file_name === '') {
                check = true;
                this.image_check = true;
                this.ajaxing = false;
            }
            return check;
        },
        richMenuAdd: function richMenuAdd() {
            var _this2 = this;

            this.ajaxing = true;
            this.postData = {
                "file_name": this.file_name,
                "s3_url": this.s3_url,
                "owner_type": this.owner_type,
                "owner_id": this.owner_id,
                'rich_menu_name': this.rich_menu_name,
                'rich_menu_class': this.rich_menu_class,
                'folder': this.folder,
                'default_mata_type': 'Image1200x810',
                'image': this.image
            };
            if (this.checkPostData(this.postData)) {
                return;
            }

            this.$http.post('/adminapi/line-marketplace/rich-menu/insert', this.postData).then(function (response) {
                var query = 'studio_id=' + _this2.studio_id;
                if (_this2.owner_type !== 'studio') {
                    query += '&branch_id=' + _this2.branch_id;
                }
                location.href = '/webadmin/line-marketplace/setting?' + query;
            }, function (error) {
                _this2.ajaxing = false;
                _this2.alert('新增失敗', error.data.message, 'error', false);
            });
        },
        openImageCrop: function openImageCrop(image) {
            var _this3 = this;

            var my_sub_folder = image.url.split('/').slice(5).join('/');
            var _this = this;
            fetch('/adminapi/studio/media-bucket/loader?path=' + my_sub_folder).then(function (res) {
                return res.blob();
            }).then(function (blob) {
                _this.image = null;
                _this.s3_url = null;
                _this.file_name = '';
                _this.image_load = true;
                $17.imageCropToString({
                    image: blob,
                    inputId: 'picture',
                    width: 1200,
                    height: 810,
                    cropBtnClass: 'btn btn--primary',
                    reUploadBtnClass: 'btn btn-default',
                    showCropCircle: false,
                    callback: function () {
                        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(imageString) {
                            return _regenerator2.default.wrap(function _callee$(_context) {
                                while (1) {
                                    switch (_context.prev = _context.next) {
                                        case 0:
                                            _this3.loadImage = true;

                                            if (!(imageString == 'fail crop')) {
                                                _context.next = 3;
                                                break;
                                            }

                                            return _context.abrupt("return", false);

                                        case 3:
                                            _this.file_name = image.name;
                                            _this.image = imageString;

                                        case 5:
                                        case "end":
                                            return _context.stop();
                                    }
                                }
                            }, _callee, _this3);
                        }));

                        return function callback(_x) {
                            return _ref.apply(this, arguments);
                        };
                    }()
                });
            });
        },
        checkImageCrop: function checkImageCrop(image, callback) {
            var _this4 = this;

            var check = true;
            this.$http.get('/adminapi/media/studio-album/check-meta-storage?imageName=' + image.name + '&defaultMataType=Image1200x810').then(function (response) {
                _this4.loadImage = false;
                check = response.data.check;
                if (check !== null) {
                    $.unblockUI();
                    callback(check);
                } else {
                    $.unblockUI();
                    _this4.openImageCrop(image);
                }
            });
        },
        errorHandle: function errorHandle(error) {
            var _this = this;
            $17.swal({
                title: '媒體庫容量已達上限',
                html: '媒體庫已達到 1GB 的容量上限，<br>' + '請調整媒體庫的內容後，再重新嘗試',
                type: 'error',
                showCancelButton: false,
                confirmButtonText: '確認',
                confirmButtonColor: '#337ab7'
            }, function (isConfirm) {
                if (isConfirm) {
                    _this.$refs.ckFinder.ckFileModel();
                }
            });
        },
        getImageUrl: function getImageUrl() {
            return this.image || this.s3_url;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-2d357895=\"\">\n    <h3 _v-2d357895=\"\">新增圖文選單</h3>\n    <div _v-2d357895=\"\">\n        <h4 class=\"m-top-30 m-left-15\" _v-2d357895=\"\">\n            1.選擇版型\n        </h4>\n        <div class=\"row m-top-20 m-left-30 \" _v-2d357895=\"\">\n            <div class=\"col-md-2 m-right-20\" _v-2d357895=\"\">\n                <label _v-2d357895=\"\">\n                    <input type=\"radio\" value=\"FiveGrid\" v-model=\"rich_menu_class\" _v-2d357895=\"\"><span class=\"m-left-10\" _v-2d357895=\"\">五格</span>\n                </label>\n                <div _v-2d357895=\"\">\n                    <img src=\"/images/line/img-5.png\" style=\"margin-top: 5px;width: 100%\" _v-2d357895=\"\">\n                </div>\n            </div>\n            <div class=\"col-md-2 m-right-20\" _v-2d357895=\"\">\n                <label _v-2d357895=\"\">\n                    <input type=\"radio\" value=\"FourGrid\" v-model=\"rich_menu_class\" _v-2d357895=\"\"><span class=\"m-left-10\" _v-2d357895=\"\">四格</span>\n                </label>\n                <div _v-2d357895=\"\">\n                    <img src=\"/images/line/img-4.png\" style=\"margin-top: 5px;width: 100%\" _v-2d357895=\"\">\n                </div>\n            </div>\n            <div class=\"col-md-2 \" _v-2d357895=\"\">\n                <label _v-2d357895=\"\">\n                    <input type=\"radio\" value=\"ThreeGrid\" v-model=\"rich_menu_class\" _v-2d357895=\"\"><span class=\"m-left-10\" _v-2d357895=\"\">三格</span>\n                </label>\n                <div _v-2d357895=\"\">\n                    <img src=\"/images/line/img-3.png\" style=\"margin-top: 5px;width: 100%\" _v-2d357895=\"\">\n                </div>\n            </div>\n        </div>\n        <h4 class=\"m-top-30 m-left-15\" _v-2d357895=\"\">\n            2.上傳圖片\n        </h4>\n        <div class=\"row m-top-20 m-left-30\" _v-2d357895=\"\">\n            <ck-finder-model @setting-image=\"insertImage\" @reload=\"reload\" @error-handle=\"errorHandle()\" :config=\"config\" :can-media-library=\"true\" ref=\"ckFinder\" _v-2d357895=\"\"></ck-finder-model>\n            <div class=\"m-top-15\" _v-2d357895=\"\">\n                <img :src=\"getImageUrl()\" style=\"width:240px\" _v-2d357895=\"\">\n            </div>\n            <div class=\"m-left-5\" v-show=\"image_check\" style=\"color:#FC5A5A;\" _v-2d357895=\"\">*請上傳圖片</div>\n        </div>\n        <h4 class=\"m-top-30 m-left-15\" _v-2d357895=\"\">\n            3.添加識別名稱\n        </h4>\n        <div class=\"row m-top-20 m-left-30\" _v-2d357895=\"\">\n            <input type=\"text\" v-model=\"rich_menu_name\" placeholder=\"請輸入圖文選單的識別名稱\" style=\"width: 400px;height: 38px;\" _v-2d357895=\"\">\n            <div class=\"m-left-5\" v-show=\"name_check\" style=\"color:#FC5A5A;\" _v-2d357895=\"\">*請輸入 16 個以內的文字</div>\n        </div>\n        <div class=\"row m-top-50 m-left-10\" _v-2d357895=\"\">\n            <div _v-2d357895=\"\">\n                <button type=\"button\" class=\"btn btn-info\" @click.prevent=\"richMenuAdd\" v-show=\"image_load\" :disabled=\"ajaxing\" _v-2d357895=\"\">新增</button>\n            </div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 4, stdin */\n.btn-primary[_v-2d357895] {\n  border-color: #aaaaaa;\n  background-color: #aaaaaa; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-2d357895", module.exports)
  } else {
    hotAPI.update("_v-2d357895", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1213:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.radio-margin + .radio-margin[_v-f49e7200] {\n  margin-left: 10px; }\n\n/* line 6, stdin */\ninput[_v-f49e7200], textarea[_v-f49e7200], select[_v-f49e7200] {\n  max-width: 500px; }\n\n/* line 10, stdin */\n.input-group input[_v-f49e7200] {\n  max-width: inherit; }\n\n/* line 14, stdin */\n.input-group[_v-f49e7200] {\n  max-width: 200px; }\n\n/* line 18, stdin */\nspan.label[_v-f49e7200] {\n  font-size: 14px;\n  margin-left: 30px; }\n\n/* line 23, stdin */\nspan.attention[_v-f49e7200] {\n  color: red;\n  font-weight: 700; }\n\n/* line 28, stdin */\n.p-t-0[_v-f49e7200] {\n  padding-top: 0 !important; }\n\n/* line 32, stdin */\ntextarea[_v-f49e7200] {\n  margin: 0; }\n\n/* line 36, stdin */\n#finish-form[_v-f49e7200] {\n  margin-top: 50px; }\n\n/* line 40, stdin */\n.modify-fee[_v-f49e7200] {\n  margin: 50px 0; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {},
    data: function data() {
        return {
            startAjax: false,
            setting: {
                'id': '',
                'branch_id': null,
                'is_active': 0,
                'channel_id': '',
                'channel_secret': '',
                'device_type': 'POS',
                'enable_refund': 0
            }
        };
    },

    watch: {
        branchId: function () {
            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(val, oldVal) {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (this.isBranch) {
                                    this.branchChangeCallBack(val);
                                }

                            case 1:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function branchId(_x, _x2) {
                return _ref.apply(this, arguments);
            }

            return branchId;
        }()
    },
    mounted: function mounted() {},

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId', 'isBranch', 'isSeventeen'])),
    methods: {
        store: function store() {
            var _this = this;

            this.startAjax = true;
            this.$http.put('/adminapi/line_pay_setting/update/' + this.setting.id, (0, _stringify2.default)(this.setting)).then(function (response) {
                _this.startAjax = false;
                $17.swal({
                    title: '儲存成功',
                    text: "",
                    type: 'success',
                    showCancelButton: false
                });
            }).catch(function (response) {
                _this.startAjax = false;
                $17.swal({
                    title: '儲存失敗',
                    text: "",
                    type: 'warning',
                    showCancelButton: false
                });
            });
        },


        branchChangeCallBack: function () {
            var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(branchId) {
                var _this2 = this;

                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (branchId) {
                                    this.startAjax = true;
                                    this.setting.branch_id = branchId;
                                    Vue.http.get('/adminapi/line_pay_setting/edit/' + branchId).then(function (response) {
                                        _this2.setting = response.data;
                                        _this2.startAjax = false;
                                    }).catch(function (response) {
                                        _this2.startAjax = false;
                                        $17.swal({
                                            title: '取得資料失敗',
                                            text: "",
                                            type: 'warning',
                                            showCancelButton: false
                                        });
                                    });
                                }

                            case 1:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function branchChangeCallBack(_x3) {
                return _ref2.apply(this, arguments);
            }

            return branchChangeCallBack;
        }()
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"col-sm-12\" _v-f49e7200=\"\">\n    <v-select-studio-and-branch :studio_id=\"studioId\" :branch_id=\"branchId\" :branch-change-call-back=\"branchChangeCallBack\" _v-f49e7200=\"\">\n    </v-select-studio-and-branch>\n    <div _v-f49e7200=\"\">\n        <h3 class=\"\" _v-f49e7200=\"\">LinePay 設定\n            \n        </h3>\n    </div>\n    <v-spinner :ajaxing=\"startAjax\" id=\"v-spinner\" _v-f49e7200=\"\">\n    </v-spinner>\n    <div v-if=\"setting.branch_id&amp;&amp;!startAjax\" _v-f49e7200=\"\">\n        <form class=\"form-horizontal\" _v-f49e7200=\"\">\n            <div class=\"form-group\" _v-f49e7200=\"\">\n                <label for=\"is_active\" class=\"col-sm-2 control-label\" _v-f49e7200=\"\"></label>\n                <div class=\"col-sm-10\" _v-f49e7200=\"\">\n                    <input type=\"checkbox\" name=\"is_active\" v-bind:true-value=\"1\" v-bind:false-value=\"0\" v-model=\"setting.is_active\" id=\"is_active\" _v-f49e7200=\"\"> \n                    <label for=\"is_active\" _v-f49e7200=\"\">啟用</label>\n                </div>\n            </div>\n            <div class=\"form-group\" _v-f49e7200=\"\">\n                <label class=\"col-sm-2 control-label\" _v-f49e7200=\"\">Channel ID</label>\n                <div class=\"col-sm-10\" _v-f49e7200=\"\">\n                    <input type=\"text\" v-model=\"setting.channel_id\" class=\"form-control\" _v-f49e7200=\"\">\n                </div>\n            </div>\n            <div class=\"form-group\" _v-f49e7200=\"\">\n                <label class=\"col-sm-2 control-label\" _v-f49e7200=\"\">Channel Secret Key</label>\n                <div class=\"col-sm-10\" _v-f49e7200=\"\">\n                    <input type=\"text\" v-model=\"setting.channel_secret\" class=\"form-control\" _v-f49e7200=\"\">\n                </div>\n            </div>\n            <div class=\"form-group\" _v-f49e7200=\"\">\n                <label class=\"col-sm-2 control-label\" _v-f49e7200=\"\"></label>\n                <div class=\"col-sm-3\" _v-f49e7200=\"\">\n                    <button type=\"button\" class=\"col-xs-5 btn btn-primary\" @click.prevent=\"store\" _v-f49e7200=\"\">儲存</button>\n                </div>\n            </div>\n        </form>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.radio-margin + .radio-margin[_v-f49e7200] {\n  margin-left: 10px; }\n\n/* line 6, stdin */\ninput[_v-f49e7200], textarea[_v-f49e7200], select[_v-f49e7200] {\n  max-width: 500px; }\n\n/* line 10, stdin */\n.input-group input[_v-f49e7200] {\n  max-width: inherit; }\n\n/* line 14, stdin */\n.input-group[_v-f49e7200] {\n  max-width: 200px; }\n\n/* line 18, stdin */\nspan.label[_v-f49e7200] {\n  font-size: 14px;\n  margin-left: 30px; }\n\n/* line 23, stdin */\nspan.attention[_v-f49e7200] {\n  color: red;\n  font-weight: 700; }\n\n/* line 28, stdin */\n.p-t-0[_v-f49e7200] {\n  padding-top: 0 !important; }\n\n/* line 32, stdin */\ntextarea[_v-f49e7200] {\n  margin: 0; }\n\n/* line 36, stdin */\n#finish-form[_v-f49e7200] {\n  margin-top: 50px; }\n\n/* line 40, stdin */\n.modify-fee[_v-f49e7200] {\n  margin: 50px 0; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-f49e7200", module.exports)
  } else {
    hotAPI.update("_v-f49e7200", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/json/stringify":48,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1214:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.form-container[_v-6a6712c1] {\n  font-size: 16px;\n  font-weight: 400; }\n  /* line 5, stdin */\n  .form-container label[_v-6a6712c1] {\n    font-weight: 700; }\n  /* line 8, stdin */\n  .form-container input[_v-6a6712c1] {\n    width: 100%; }\n\n/* line 12, stdin */\n.setting-tooltip[_v-6a6712c1] {\n  position: relative;\n  display: inline-block; }\n\n/* line 17, stdin */\n.setting-tooltip .tooltiptext[_v-6a6712c1] {\n  visibility: hidden;\n  width: 120px;\n  background-color: #606060;\n  color: #fff;\n  text-align: center;\n  border-radius: 6px;\n  padding: 5px 0;\n  position: absolute;\n  z-index: 1;\n  bottom: 150%;\n  left: 50%;\n  margin-left: -60px; }\n\n/* line 32, stdin */\n.setting-tooltip .tooltiptext[_v-6a6712c1]::after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  margin-left: -5px;\n  border-width: 5px;\n  border-style: solid;\n  border-color: #606060 transparent transparent transparent; }\n\n/* line 43, stdin */\n.setting-tooltip:hover .tooltiptext[_v-6a6712c1] {\n  visibility: visible; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        scheduleId: {
            required: true
        },
        btnDisabled: {
            type: Boolean,
            default: false
        },
        showLiveBtn: {
            type: Boolean,
            default: true
        }
    },
    data: function data() {
        return {
            ajaxing: false,
            mode: 'create',
            origin: {},
            data: {}
        };
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        canEditClass: function canEditClass(state) {
            return state.webadmin.configure.webFunctions.WebadminScheduleIndex;
        }
    }), {
        isShowBtn: function isShowBtn() {
            if (!this.showLiveBtn || this.btnDisabled || !this.canEditClass) {
                return false;
            }
            return this.data.is_live;
        },
        isCreate: function isCreate() {
            return this.mode === 'create' ? true : false;
        },
        displayTitle: function displayTitle() {
            return this.mode === 'create' ? '建立直播連結' : '管理直播連結';
        }
    }),
    watch: {
        scheduleId: function scheduleId(newVal) {
            if (newVal) {
                this.refreshModal();
            }
        }
    },
    mounted: function mounted() {
        //TODO REMOVE AFTER REFACTOR V-MODAL
        var vm = this;
        $('#schedule-modal').on('hide.bs.modal', function (event) {
            event.stopPropagation();
            if ($(vm.$refs.live_link_edit.$el).hasClass('in')) {
                return false;
            }
        });
        $(this.$refs.live_link_edit.$el).on('shown.bs.modal', function (event) {
            event.target.style.paddingLeft = 0;
            $('#schedule-modal').scrollTop(0);
        });
        $(this.$refs.live_link_edit.$el).on('hide.bs.modal', function (event) {
            event.stopPropagation();
        });
    },
    destroyed: function destroyed() {
        //TODO REMOVE AFTER REFACTOR V-MODAL
        $('#schedule-modal').off('hide.bs.modal');
        if (this.$refs.live_link_edit) {
            $(this.$refs.live_link_edit.$el).off('shown.bs.modal');
            $(this.$refs.live_link_edit.$el).off('hide.bs.modal');
        }
    },

    methods: {
        OpenEditModal: function OpenEditModal() {
            $(this.$refs.live_link_edit.$el).modal('show');
        },
        closeEditModal: function closeEditModal() {
            $(this.$refs.live_link_edit.$el).modal('hide');
        },
        fetchLiveLinkData: function fetchLiveLinkData() {
            var _this = this;

            this.ajaxing = true;
            this.$http.get('/adminapi/live-link/' + this.scheduleId).then(function (response) {
                _this.origin = response.data;
                _this.data = (0, _extends3.default)({}, _this.origin);
                _this.mode = _this.data.live_id == 0 ? 'create' : 'edit';
                _this.ajaxing = false;
            }, function (error) {
                $17.swal({
                    title: '取得直播連結錯誤',
                    type: 'error',
                    showCancelButton: false
                });
                _this.ajaxing = false;
            });
        },
        refreshModal: function refreshModal() {
            if (this.btnDisabled || !this.showLiveBtn || !this.scheduleId) {
                return;
            }
            this.fetchLiveLinkData();
        },
        saveClicked: function saveClicked() {
            var _this2 = this;

            if (!this.canEditClass) {
                $17.swal({
                    title: '無此權限',
                    type: 'error',
                    showCancelButton: false
                });
                this.closeEditModal();
                return;
            }
            if (!$17.validURL(this.data.live_link)) {
                return;
            }
            this.ajaxing = true;
            this.$http.post('/adminapi/live-link/' + this.scheduleId, {
                'live_link': this.data.live_link,
                'description': this.data.description
            }).then(function (response) {
                if (response.data.msg == 'success') {
                    var result = response.data.data.result;
                    _this2.origin.live_id = result.id;
                    _this2.origin.live_link = result.live_link;
                    _this2.origin.description = result.description;
                    _this2.mode = 'edit';
                    _this2.data = (0, _extends3.default)({}, _this2.origin);
                    _this2.closeEditModal();
                    $17.swal({
                        title: '儲存成功',
                        type: 'success',
                        showCancelButton: false
                    });
                }
                _this2.ajaxing = false;
            }, function (error) {
                $17.swal({
                    title: '儲存直播連結發生錯誤',
                    type: 'error',
                    showCancelButton: false
                });
                _this2.ajaxing = false;
            });
        },
        removeClicked: function removeClicked() {
            var _this3 = this;

            $17.swal({
                title: '刪除直播連結？',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: '確定',
                cancelButtonText: '取消'
            }, function (isConfirm) {
                if (isConfirm) {
                    _this3.removeLink();
                }
            });
        },
        removeLink: function removeLink() {
            var _this4 = this;

            this.ajaxing = true;
            this.$http.delete('/adminapi/live-link/' + this.data.live_id).then(function (response) {
                _this4.refreshModal();
                _this4.closeEditModal();
                $17.swal({
                    title: '刪除成功',
                    type: 'success',
                    showCancelButton: false
                });
                _this4.ajaxing = false;
            }, function (error) {
                $17.swal({
                    title: '刪除直播連結錯誤',
                    type: 'error',
                    showCancelButton: false
                });
                _this4.ajaxing = false;
            });
        },
        timeFormat: function timeFormat(date, time) {
            return moment(date + ' ' + time).format('YYYY-MM-DD HH:mm');
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-6a6712c1=\"\">\n    <div v-if=\"isShowBtn\" _v-6a6712c1=\"\">\n        <button class=\"btn btn-primary\" :class=\"{'btn--inverse':!isCreate}\" @click=\"OpenEditModal\" :disabled=\"btnDisabled\" _v-6a6712c1=\"\"><i class=\"fa fa-video-camera m-right-5\" _v-6a6712c1=\"\"></i>{{ displayTitle }}</button>\n    </div>\n    <div v-if=\"btnDisabled\" _v-6a6712c1=\"\">\n        <a type=\"button\" class=\"btn btn-primary setting-tooltip\" :disabled=\"btnDisabled\" _v-6a6712c1=\"\">\n            <i class=\"fa fa-video-camera m-right-5\" _v-6a6712c1=\"\"></i>{{ displayTitle }}\n            <span class=\"tooltiptext\" _v-6a6712c1=\"\">請先新增課表</span>\n        </a>\n    </div>\n    <v-modal ref=\"live_link_edit\" id=\"live-link-edit-modal\" :parallel-modal=\"true\" confirm-btn-text=\"儲存\" close-btn-text=\"取消\" :remove-btn-show=\"!isCreate\" :save-clicked=\"saveClicked\" :remove-clicked=\"removeClicked\" _v-6a6712c1=\"\">\n        <div slot=\"title\" _v-6a6712c1=\"\">\n            <h4 _v-6a6712c1=\"\">{{ displayTitle }}</h4>\n        </div>\n        <div slot=\"body\" _v-6a6712c1=\"\">\n            <v-spinner :ajaxing=\"ajaxing\" _v-6a6712c1=\"\"></v-spinner>\n            <div v-show=\"!ajaxing\" class=\"form-container\" _v-6a6712c1=\"\">\n                <div class=\"m-bottom-15\" _v-6a6712c1=\"\">\n                    <label _v-6a6712c1=\"\">課程名稱</label>\n                    <div _v-6a6712c1=\"\">{{ data.schedule_name }}</div>\n                </div>\n                <div class=\"m-bottom-15\" _v-6a6712c1=\"\">\n                    <label _v-6a6712c1=\"\">開始時間</label>\n                    <div _v-6a6712c1=\"\">{{ timeFormat(data.date, data.start_time) }}</div>\n                </div>\n                <div class=\"m-bottom-15\" _v-6a6712c1=\"\">\n                    <label _v-6a6712c1=\"\">人員</label>\n                    <div _v-6a6712c1=\"\">{{ data.sp_nick_name ? data.sp_nick_name : data.sp_name }}</div>\n                </div>\n                <div class=\"m-bottom-15\" _v-6a6712c1=\"\">\n                    <label _v-6a6712c1=\"\">場館</label>\n                    <div _v-6a6712c1=\"\">{{ data.branch_name }}</div>\n                </div>\n                <div class=\"m-bottom-15\" _v-6a6712c1=\"\">\n                    <label _v-6a6712c1=\"\">直播連結</label><br _v-6a6712c1=\"\">\n                    <input type=\"text\" v-model=\"data.live_link\" _v-6a6712c1=\"\">\n                </div>\n                <div class=\"m-bottom-15\" _v-6a6712c1=\"\">\n                    <label _v-6a6712c1=\"\">額外說明</label>\n                    <textarea v-model=\"data.description\" cols=\"50\" rows=\"5\" placeholder=\"如有額外說明，請在此輸入...\" _v-6a6712c1=\"\"></textarea>\n                </div>                    \n            </div>\n        </div>\n    </v-modal>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.form-container[_v-6a6712c1] {\n  font-size: 16px;\n  font-weight: 400; }\n  /* line 5, stdin */\n  .form-container label[_v-6a6712c1] {\n    font-weight: 700; }\n  /* line 8, stdin */\n  .form-container input[_v-6a6712c1] {\n    width: 100%; }\n\n/* line 12, stdin */\n.setting-tooltip[_v-6a6712c1] {\n  position: relative;\n  display: inline-block; }\n\n/* line 17, stdin */\n.setting-tooltip .tooltiptext[_v-6a6712c1] {\n  visibility: hidden;\n  width: 120px;\n  background-color: #606060;\n  color: #fff;\n  text-align: center;\n  border-radius: 6px;\n  padding: 5px 0;\n  position: absolute;\n  z-index: 1;\n  bottom: 150%;\n  left: 50%;\n  margin-left: -60px; }\n\n/* line 32, stdin */\n.setting-tooltip .tooltiptext[_v-6a6712c1]::after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  margin-left: -5px;\n  border-width: 5px;\n  border-style: solid;\n  border-color: #606060 transparent transparent transparent; }\n\n/* line 43, stdin */\n.setting-tooltip:hover .tooltiptext[_v-6a6712c1] {\n  visibility: visible; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-6a6712c1", module.exports)
  } else {
    hotAPI.update("_v-6a6712c1", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1215:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _edit = require('./edit.vue');

var _edit2 = _interopRequireDefault(_edit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('edit-live-link-btn-with-modal', _edit2.default);

},{"./edit.vue":1214,"vue":792}],1216:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n#location-list tbody tr td {\n    background-color: white;\n    border-bottom: solid 1px #ddd;\n}\n.top-border {\n    border-top: solid 1px silver;\n}\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            modal: {
                title: ''
            },
            view: {
                location_list: [],
                ajaxing: false,
                action: 'create',
                studio_id: null,
                show_content: false
            }
        };
    },
    watch: {
        studioId: function studioId(val, old) {
            if (!this.isSeventeen) {
                this.view.studio_id = val;
                this.getLocationList(this.view.studio_id);
            }
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'isSeventeen']), (0, _vuex.mapState)('filters', ['selected_studio_id', 'selected_branch_id'])),
    mounted: function mounted() {
        var _this = this;

        $('#location-modal').on('hidden.bs.modal', function (e) {
            _this.$refs.location_modal.resetForm();
        });
    },
    methods: {
        getLocationList: function getLocationList(studioId) {
            var _this2 = this;

            this.view.ajaxing = true;
            if (studioId === null || studioId === '') {
                return;
            }
            this.view.studio_id = studioId;
            this.$http.get('/adminapi/locations?studio_id=' + this.view.studio_id).then(function (response) {
                _this2.view.location_list = response.body;
                _this2.view.ajaxing = false;
                _this2.view.show_content = true;
            }, function (error) {
                _this2.view.ajaxing = false;
            });
        },
        showModal: function showModal(item, action) {
            this.$refs.location_modal.setStudioID(this.view.studio_id);
            this.modal.title = action === 'update' ? i18n.t('location.modify') + item.location_name : i18n.t('location.add') + i18n.t('location.location');
            this.$refs.location_modal.onCall(item.id, action);
            $('#location-modal').modal('show');
        },
        refresh: function refresh() {
            this.view.ajaxing = true;
            this.getLocationList(this.view.studio_id);
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n    <div class=\"content-inner\">\n        <v-select-studio-and-branch v-if=\"isSeventeen\" :studio_id=\"studioId\" :branch-without-filtered-option=\"false\" :studio-change-call-back=\"getLocationList\"></v-select-studio-and-branch>\n    <div>\n    <v-spinner :ajaxing=\"view.ajaxing\"></v-spinner>\n    <div v-show=\"view.show_content &amp;&amp; !view.ajaxing\" class=\"table-div m-top-20\">\n        <button type=\"button\" class=\"btn btn-success m-bottom-20\" @click=\"showModal({id:0,name:''}, 'create')\">\n                <i class=\"fa fa-plus\"></i>\n                {{ i18n.t('location.add') + i18n.t('location.location') }}\n        </button>\n        \n            <table id=\"location-list\" class=\"table table-striped\">\n                <tbody>\n                <tr class=\"top-border\" v-for=\"item in view.location_list\">\n                    <td class=\"col-md-6\"><span class=\"pull-left\">{{ item.location_name }}</span></td>\n                    <td class=\"col-md-6\"><a class=\"btn btn-primary\" @click.prevent=\"showModal(item, 'update')\">{{ i18n.t('location.modify') }}</a></td>\n                </tr>\n                </tbody>\n            </table>\n    </div>\n\n    <location-modal @refresh=\"refresh\" ref=\"location_modal\" :title=\"modal.title\"></location-modal>\n</div></div>"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n#location-list tbody tr td {\n    background-color: white;\n    border-bottom: solid 1px #ddd;\n}\n.top-border {\n    border-top: solid 1px silver;\n}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-098daf4d", module.exports)
  } else {
    hotAPI.update("_v-098daf4d", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1217:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n.pac-container {\n    z-index: 2000;\n}\n\n.font-small {\n    font-size: small;\n    color: #8e8e8e;\n}\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vuex = require('vuex');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        title: {
            type: String,
            default: ''
        }
    },
    data: function data() {
        return {
            marker: {
                position: {
                    lat: 0,
                    lng: 0
                },
                opacity: 1,
                draggable: true,
                enabled: true,
                clicked: 0,
                rightClicked: 0
            },
            center: {
                lat: 0,
                lng: 0
            },
            reportedCenter: {
                lat: 0,
                lng: 0
            },
            studio_id: 0,
            view: {
                ajaxing: false,
                canSubmit: true,
                coordinateCorrect: true,
                action: 'create'
            },
            model: {
                id: null,
                name: '',
                address: '',
                coordinate: '0,0'
            }
        };
    },

    methods: {
        show: function show(id) {
            var _this = this;

            this.view.ajaxing = true;
            this.$http.get('/adminapi/locations/' + id).then(function (response) {
                _this.model.name = response.body.location_name;
                _this.model.address = response.body.address;
                _this.model.coordinate = response.body.coordinate;
                if (_this.model.coordinate !== null) {
                    _this.updatePlace(_this.model.coordinate);
                }
                _lodash2.default.delay(function () {
                    _this.view.ajaxing = false;
                }, 400);
            }, function (error) {
                $17.swal({
                    title: error.body.message,
                    type: 'warning'
                });
                _this.view.ajaxing = false;
            });
        },
        creating: function creating() {
            var _this2 = this;

            this.view.ajaxing = true;
            this.$http.post('/adminapi/locations', {
                id: this.id,
                location_name: this.model.name,
                address: this.model.address,
                coordinate: this.model.coordinate,
                studio_id: this.studio_id
            }).then(function (response) {
                _this2.resetForm();
                _this2.view.ajaxing = false;
                _this2.$emit('refresh');
                $('#location-modal').modal('hide');
            }, function (error) {
                _this2.view.ajaxing = false;
            });
        },
        resetForm: function resetForm() {
            this.model.name = '';
            this.model.address = '';
            document.getElementsByName('search_address')[0].value = '';
            this.model.coordinate = '0,0';
        },

        deleting: function deleting() {
            var _this3 = this;

            this.view.ajaxing = true;
            this.$http.delete('/adminapi/locations/' + this.model.id).then(function (response) {
                if (response.body === 'used') {
                    $17.swal({
                        title: i18n.t('location.used'),
                        type: 'warning',
                        showCancelButton: false,
                        confirmButtonText: i18n.t('location.got_it')
                    });
                } else {
                    _this3.view.ajaxing = false;
                    _this3.$emit('refresh');
                    $('#location-modal').modal('hide');
                }
            }, function (error) {
                _this3.view.ajaxing = false;
            });
        },
        updating: function updating() {
            var _this4 = this;

            this.view.ajaxing = true;
            this.$http.patch('/adminapi/locations/' + this.model.id, {
                location_name: this.model.name,
                address: this.model.address,
                coordinate: this.model.coordinate
            }).then(function (response) {
                _this4.view.ajaxing = false;
                _this4.resetForm();
                _this4.$emit('refresh');
                $('#location-modal').modal('hide');
            }, function (error) {
                _this4.view.ajaxing = false;
            });
        },
        onCall: function onCall(id, action) {
            this.view.action = action;
            if (action === 'update') {
                this.model.id = id;
                this.view.showButton = true;
                this.show(this.model.id);
            } else if (action === 'create') {
                this.updatePlace(this.model.coordinate);
                this.view.showButton = false;
            }
        },
        submitLocation: function submitLocation() {
            this.view.canSubmit = true;
            this.checkRequire();
            if (this.view.canSubmit === false) {
                $17.swal({
                    title: i18n.t('location.require_message'),
                    type: 'warning'
                });
                this.view.ajaxing = false;
            } else if (this.view.coordinateCorrect === false) {
                $17.swal({
                    title: i18n.t('location.wrong_address_message'),
                    type: 'warning'
                });
                this.view.ajaxing = false;
            } else {
                if (this.view.action === 'update') {
                    this.updating();
                } else {
                    this.creating();
                }
            }
        },
        checkRequire: function checkRequire() {
            if (this.model.name === '' || this.model.address === '') {
                this.view.canSubmit = false;
            }
            if (this.model.coordinate === '0,0') {
                this.view.coordinateCorrect = false;
            } else {
                this.view.coordinateCorrect = true;
            }
        },
        setStudioID: function setStudioID(id) {
            this.studio_id = id;
        },
        updatePlace: function updatePlace(place) {
            var lat = 0;
            var lng = 0;
            if (place && place.geometry && place.geometry.location) {
                // var map = this.$refs.map.$mapObject
                lat = place.geometry.location.lat();
                lng = place.geometry.location.lng();
            } else if (place.latLng) {
                lat = place.latLng.lat();
                lng = place.latLng.lng();
            } else {
                if (place.indexOf(',') !== -1) {
                    var coordinate = place.split(',');
                    lat = parseFloat(coordinate[0]);
                    lng = parseFloat(coordinate[1]);
                }
            }
            var marker = this.addMarker();
            marker.position.lat = lat;
            marker.position.lng = lng;
            var newCenter = {
                lat: lat,
                lng: lng
            };
            this.model.coordinate = lat.toString() + ',' + lng.toString();
            this.center = newCenter;
        },

        addMarker: function addMarker() {
            return this.marker;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div>\n    <div id=\"location-modal\" class=\"modal fade\" role=\"dialog\">\n        <div class=\"modal-dialog\">\n            <div class=\"modal-content\">\n                <div class=\"modal-header\">\n                    <button type=\"button\" v-show=\"!view.ajaxing\" class=\"close\" data-dismiss=\"modal\">×</button>\n                    <h4 class=\"modal-title\">{{ title }}</h4>\n                </div>\n                <v-spinner :ajaxing=\"view.ajaxing\"></v-spinner>\n                <div v-show=\"!view.ajaxing\" class=\"modal-body\">\n                        <div class=\"clearfix m-top-10\">\n                            <div class=\"clearfix\">\n                                <label class=\"col-lg-3 col-md-3 col-xs-12 p-top-5 require\" for=\"name\">{{ i18n.t('location.name') }} <span>*</span></label>\n                                <div class=\"col-lg-9 col-md-9 col-xs-12\">\n                                    <input name=\"name\" v-model=\"model.name\" class=\"col-lg-9 col-md-9 col-xs-12\" type=\"text\" maxlength=\"50\">\n                                </div>\n                            </div>\n                            <div class=\"clearfix\">\n                                <label class=\"col-lg-3 col-md-3 col-xs-12 p-top-5 require\">顯示地址 <span>*</span></label>\n                                <div class=\"col-lg-9 col-md-9 col-xs-12\">\n                                    <input v-model=\"model.address\" class=\"col-xs-12\" type=\"text\">\n                                    <p class=\"font-small m-top-10\">\n                                        客戶會看見的地址文字。除了標準的縣市、鄉鎮市區、道路或街名、樓層，你也可以輸入任何易於辨識的額外資訊\n                                    </p>\n                                </div>\n                            </div>\n                            <div>\n                                <label class=\"col-lg-3 col-md-3 col-xs-12 p-top-5 require\" for=\"search_address\">地圖位置</label>\n                                <div class=\"col-lg-9 col-md-9 col-xs-12\">\n                                    <p>\n                                    <gmap-autocomplete placeholder=\"請輸入地址，不含樓層\" name=\"search_address\" style=\"width:100%;\" maxlength=\"100\" :select-first-on-enter=\"true\" @place_changed=\"updatePlace($event)\">\n                                    </gmap-autocomplete>\n                                    </p>\n                                    <p class=\"m-bottom-15 font-small\">此處輸入的資訊將透過 google map，在地圖中顯示座標位置。客戶不會看見此處的文字</p>\n                                    <gmap-map :center=\"center\" ref=\"map\" :zoom=\"15\" map-type-id=\"roadmap\" style=\"width: 100%; height: 300px\">\n                                        <gmap-cluster :grid-size=\"50\">\n                                        <gmap-marker v-if=\"marker.enabled\" :position=\"marker.position\" :opacity=\"marker.opacity\" :draggable=\"marker.draggable\" :key=\"model.id\" @dragend=\"updatePlace($event)\">\n                                        </gmap-marker>\n                                        </gmap-cluster>\n                                    </gmap-map>\n                                </div>\n                            </div>\n                        </div>\n                </div>\n\n                <div class=\"modal-footer\">\n                    <button v-show=\"view.showButton &amp;&amp; !view.ajaxing\" @click=\"deleting\" type=\"button\" class=\"btn btn-danger\" style=\"position:absolute;left: 10px;\" data-dismiss=\"modal\">{{ i18n.t('location.delete') }}</button>\n                    <button v-show=\"!view.ajaxing\" type=\"button\" class=\"btn btn-primary\" @click=\"submitLocation\">{{ i18n.t('location.submit') }}\n                        </button>\n                    <button type=\"button\" v-show=\"!view.ajaxing\" class=\"btn btn-default\" data-dismiss=\"modal\">{{ i18n.t('location.close') }}</button>\n                </div>\n\n            </div>\n        </div>\n    </div>\n\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n.pac-container {\n    z-index: 2000;\n}\n\n.font-small {\n    font-size: small;\n    color: #8e8e8e;\n}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-89f7c8b0", module.exports)
  } else {
    hotAPI.update("_v-89f7c8b0", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1218:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _studioServiceProviderAlbum = require('./studioServiceProviderAlbum.vue');

var _studioServiceProviderAlbum2 = _interopRequireDefault(_studioServiceProviderAlbum);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//Page
_vue2.default.component('webadmin-studio-service-provider-album', _studioServiceProviderAlbum2.default);

},{"./studioServiceProviderAlbum.vue":1219,"vue":792}],1219:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("@charset \"UTF-8\";\n/* line 2, stdin */\n.header[_v-47c3695f], .body-col[_v-47c3695f] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  padding: 13px 24px;\n  gap: 24px; }\n  /* line 8, stdin */\n  .header span[_v-47c3695f], .body-col span[_v-47c3695f] {\n    color: #6B7280;\n    font-size: 14px;\n    font-weight: 500; }\n  /* line 14, stdin */\n  .header img[_v-47c3695f], .header input[_v-47c3695f], .header textarea[_v-47c3695f], .body-col img[_v-47c3695f], .body-col input[_v-47c3695f], .body-col textarea[_v-47c3695f] {\n    border-radius: 4px;\n    width: 100%;\n    max-height: 75px;\n    margin-bottom: 0; }\n\n/* line 22, stdin */\n.imgPreview[_v-47c3695f] {\n  display: none;\n  top: 0;\n  left: 0;\n  width: 100%;\n  /*容器佔滿整個螢幕*/\n  height: 100%;\n  position: fixed;\n  background: rgba(0, 0, 0, 0.5); }\n\n/* line 32, stdin */\n.imgPreview img[_v-47c3695f] {\n  z-index: 100;\n  width: 60%;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none; }\n\n/* line 42, stdin */\n.sticky-control-btn[_v-47c3695f] {\n  background: white;\n  padding: 12px 0;\n  position: -webkit-sticky;\n  position: sticky;\n  top: 50px; }\n  /* line 47, stdin */\n  .sticky-control-btn.bottom-shadow[_v-47c3695f] {\n    box-shadow: 0px 3px 2px -1px rgba(0, 0, 0, 0.1); }\n\n/* line 52, stdin */\n.control-item[_v-47c3695f] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between; }\n\n/* line 57, stdin */\n.w-100[_v-47c3695f] {\n  width: 100px; }\n\n/* line 61, stdin */\n.w-auto[_v-47c3695f] {\n  -ms-flex-positive: 1;\n      flex-grow: 1; }\n")
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require("vuex");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            ajaxing: false,
            data: "",
            album: {
                display_name: ""
            },
            config: {
                rootFolder: '',
                removeModules: 'RenameFile,DeleteFile,CreateFolder,' + 'FilesMoveCopy,DeleteFolder,UploadFileButton,EditImage,RenameFolder,FormUpload'
            },
            name: "",
            loadImage: false,
            albumId: "",
            imgPreview: "",
            changeItem: {},
            page: 1,
            lastPage: 1,
            canSelectPicture: false
        };
    },
    mounted: function mounted() {
        var _this2 = this;

        this.albumId = this.urlValue();
        this.getStudioAlbums();

        window.addEventListener('scroll', function (event) {
            _this2.handleScroll();
        });
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        canMediaStudioAlbumAddImage: function canMediaStudioAlbumAddImage(state) {
            return state.webadmin.configure.webFunctions.WebadminMediaStudioAlbumAddImage;
        },
        canMediaLibraryEdit: function canMediaLibraryEdit(state) {
            return state.webadmin.configure.webFunctions.WebadminMediaLibraryEdit;
        }
    }), (0, _vuex.mapState)('webadmin/configure', ['studioId', 's3StudioMedia'])),
    watch: {
        canMediaStudioAlbumAddImage: function canMediaStudioAlbumAddImage(val) {
            if (val) {
                this.canSelectPicture = true;
            }
        },
        canMediaLibraryEdit: function canMediaLibraryEdit(val) {
            if (val) {
                this.config.removeModules = 'RenameFile,DeleteFolder,EditImage';
            }
        },
        s3StudioMedia: function s3StudioMedia(val) {
            if (val) {
                this.config.rootFolder = val;
            }
        }
    },
    methods: {
        insertImage: function insertImage(image) {
            $.blockUI();
            this.loadImage = true;
            this.postData = {
                "file_name": image.name,
                "s3_url": image.url,
                "albumId": this.albumId,
                "studio_id": this.studioId,
                'folder': image.folder
            };
            var _this = this;
            this.checkImageCrop(image, function () {
                $17.swal({
                    title: '',
                    html: '此裁切後的檔案已存在<br>' + '是否重新裁切並加入相簿呢？',
                    type: 'warning',
                    confirmButtonText: '確認',
                    confirmButtonColor: '#337ab7'
                }, function (isConfirm) {
                    if (isConfirm) {
                        _this.openImageCrop(image);
                    } else {
                        _this.postData['image'] = null;
                        _this.postImage(_this.postData);
                    }
                });
            });
        },
        openImageCrop: function openImageCrop(image) {
            var _this3 = this;

            var my_sub_folder = image.url.split('/').slice(5).join('/');
            var _this = this;
            fetch('/adminapi/studio/media-bucket/loader?path=' + my_sub_folder).then(function (res) {
                return res.blob();
            }).then(function (blob) {
                $17.imageCropToString({
                    image: blob,
                    inputId: 'picture',
                    width: 400,
                    height: 300,
                    cropBtnClass: 'btn btn--primary',
                    reUploadBtnClass: 'btn btn-default',
                    showCropCircle: false,
                    callback: function () {
                        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(imageString) {
                            return _regenerator2.default.wrap(function _callee$(_context) {
                                while (1) {
                                    switch (_context.prev = _context.next) {
                                        case 0:
                                            _this3.loadImage = true;

                                            if (!(imageString == 'fail crop')) {
                                                _context.next = 3;
                                                break;
                                            }

                                            return _context.abrupt("return", false);

                                        case 3:
                                            _this.postData['image'] = imageString;
                                            _this.postImage(_this.postData);

                                        case 5:
                                        case "end":
                                            return _context.stop();
                                    }
                                }
                            }, _callee, _this3);
                        }));

                        return function callback(_x) {
                            return _ref.apply(this, arguments);
                        };
                    }()
                });
            });
        },
        postImage: function postImage(postData) {
            var _this4 = this;

            this.$http.post('/adminapi/media/studio-album/add-image', postData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (response) {
                _this4.getStudioAlbumItems();
            }, function (error) {
                _this4.loadImage = false;
                _this4.alert('新增失敗', error.data.message, 'error', false);
            });
        },
        checkImageCrop: function checkImageCrop(image, callback) {
            var _this5 = this;

            var check = true;
            this.$http.get('/adminapi/media/studio-album/check-meta-storage?imageName=' + image.name).then(function (response) {
                _this5.loadImage = false;
                check = response.data.check;
                if (check) {
                    $.unblockUI();
                    callback();
                } else {
                    $.unblockUI();
                    _this5.openImageCrop(image);
                }
            });
        },
        getStudioAlbums: function getStudioAlbums() {
            var _this6 = this;

            this.$http.get('/adminapi/media/studio-album/getAlbum/' + this.albumId).then(function (response) {
                _this6.album = response.data;
                _this6.getStudioAlbumItems();
            }, function (error) {
                $17.swal({
                    type: 'error',
                    title: error.data.message,
                    showCancelButton: false
                }, function () {
                    window.close();
                });
            });
        },
        getStudioAlbumItems: function getStudioAlbumItems(type) {
            var _this7 = this;

            this.ajaxing = true;
            if (type != 'more') {
                this.page = 1;
            }
            var query = $17.queryStringBuilder({
                default_mata_type: this.album.default_mata_type,
                page: this.page
            });
            this.$http.get('/adminapi/media/studio-album/getItems/' + this.albumId + '?' + query).then(function (response) {
                _this7.ajaxing = false;
                if (type == 'more') {
                    _this7.data = _this7.data.concat(response.data.pageData);
                } else {
                    _this7.data = response.data.pageData;
                }
                _this7.page = response.data.pageMeta.currentPage;
                _this7.lastPage = response.data.pageMeta.lastPage;
            }, function (error) {});
        },
        urlValue: function urlValue() {
            var pathName = window.location.pathname;
            var pathArray = pathName.split("/");
            return pathArray.pop();
        },
        enlargeImg: function enlargeImg(src) {
            this.imgPreview = src;
            $('.imgPreview').show();
        },
        imgPreviewClose: function imgPreviewClose() {
            $('.imgPreview').hide();
        },
        deleteAlbumItem: function deleteAlbumItem(albumItemId) {
            var _this = this;
            $17.swal({
                title: '',
                html: '確認刪除這張相片嗎？',
                type: 'warning',
                confirmButtonText: '確認',
                confirmButtonColor: '#337ab7'
            }, function (isConfirm) {
                if (isConfirm) {
                    _this.ajaxing = true;
                    _this.$http.delete('/adminapi/media/studio-album/remove-image-item/' + albumItemId).then(function (response) {
                        _this.ajaxing = false;
                        _this.getStudioAlbumItems();
                    }, function (error) {
                        _this.ajaxing = false;
                    });
                }
            });
        },
        updateItemData: function updateItemData(item) {
            this.changeItem[item.id] = {
                'id': item.id,
                'file_description': item.description,
                'file_sort_number': item.file_sort_number
            };
        },
        updateAlbumItem: function updateAlbumItem() {
            var _this8 = this;

            this.$http.put('/adminapi/media/studio-album/update-image-item/', { 'items': this.changeItem }).then(function (response) {
                _this8.ajaxing = false;
                _this8.getStudioAlbumItems();
            }, function (error) {
                _this8.ajaxing = false;
            });
        },
        handleScroll: function handleScroll() {
            var rootElement = document.documentElement;
            var scrollTotal = rootElement.scrollHeight - rootElement.clientHeight;
            var ratio = rootElement.scrollTop / scrollTotal;
            if (ratio == 1 && this.page + 1 <= this.lastPage && !this.ajaxing) {
                this.page = this.page + 1;
                this.getStudioAlbumItems('more');
            }
            if ($(window).scrollTop() > 170) {
                $('.sticky-control-btn').addClass('bottom-shadow');
            } else {
                $('.sticky-control-btn').removeClass('bottom-shadow');
            }
        },
        errorHandle: function errorHandle(error) {
            var _this = this;
            $17.swal({
                title: '媒體庫容量已達上限',
                html: '媒體庫已達到 1GB 的容量上限，<br>' + '請調整媒體庫的內容後，再重新嘗試',
                type: 'error',
                showCancelButton: false,
                confirmButtonText: '確認',
                confirmButtonColor: '#337ab7'
            }, function (isConfirm) {
                if (isConfirm) {
                    _this.$refs.ckFinder.ckFileModel();
                }
            });
            // this.$refs.ckFinder.ckFileModel()
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"m-right-10\" _v-47c3695f=\"\">\n\n    <div v-show=\"!ajaxing.get\" _v-47c3695f=\"\">\n        <h3 _v-47c3695f=\"\">{{album.display_name}}管理</h3>\n        <hr _v-47c3695f=\"\">\n        <div class=\"sticky-control-btn\" _v-47c3695f=\"\">\n            <div class=\"control-item\" style=\"\" _v-47c3695f=\"\">\n                <ck-finder-model @setting-image=\"insertImage\" @reload=\"getStudioAlbumItems()\" @error-handle=\"errorHandle()\" :config=\"config\" :picture-size-verification=\"false\" :can-select-picture=\"canSelectPicture\" ref=\"ckFinder\" _v-47c3695f=\"\"></ck-finder-model>\n                <button class=\"btn btn-primary\" @click=\"updateAlbumItem\" _v-47c3695f=\"\">\n                    <span _v-47c3695f=\"\">儲存</span>\n                </button>\n            </div>\n        </div>\n\n        <content-card :show-footer=\"false\" _v-47c3695f=\"\">\n            <div slot=\"head\" _v-47c3695f=\"\">\n                <div class=\"header\" _v-47c3695f=\"\">\n                    <span class=\"w-100\" _v-47c3695f=\"\">相片</span>\n                    <span class=\"w-100\" _v-47c3695f=\"\">自訂排序</span>\n                    <span class=\"w-auto\" _v-47c3695f=\"\">圖片描述</span>\n                    <span class=\"w-100\" _v-47c3695f=\"\"></span>\n                </div>\n            </div>\n            <div slot=\"body\" _v-47c3695f=\"\">\n                <div _v-47c3695f=\"\">\n                    <template v-for=\"item in data\" v-show=\"!ajaxing\">\n                        <div :key=\"item.id\" class=\"body-col\" _v-47c3695f=\"\">\n                            <div class=\"w-100\" _v-47c3695f=\"\"><img :src=\"item.pic_path\" @click=\"enlargeImg(item.pic_path)\" _v-47c3695f=\"\"></div>\n                            <div class=\"w-100\" _v-47c3695f=\"\"><input type=\"number\" v-model.number=\"item.file_sort_number\" @change=\"updateItemData(item)\" _v-47c3695f=\"\"></div>\n                            <div class=\"w-auto\" _v-47c3695f=\"\"><textarea cols=\"50\" rows=\"2\" v-model=\"item.description\" @change=\"updateItemData(item)\" _v-47c3695f=\"\"></textarea>\n                            </div>\n                            <div class=\"w-100 text-right\" _v-47c3695f=\"\"><a style=\"color: red;\" @click.prevent=\"deleteAlbumItem(item.id)\" _v-47c3695f=\"\">刪除</a></div>\n                        </div>\n                    </template>\n                    <template>\n                        <div v-show=\"data == ''\" class=\"m-left-30 m-top-25 m-bottom-25\" style=\"color: #AAAAAA;\" _v-47c3695f=\"\">\n                            <i class=\"fa fa-info-circle m-right-10\" _v-47c3695f=\"\"></i>請先透過媒體庫上傳照片後，再加入照片\n                        </div>\n                    </template>\n                </div>\n            </div>\n        </content-card>\n        <v-spinner :ajaxing=\"ajaxing\" _v-47c3695f=\"\"></v-spinner>\n        <div class=\"imgPreview\" @click=\"imgPreviewClose\" _v-47c3695f=\"\">\n            <img :src=\"imgPreview\" _v-47c3695f=\"\">\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["@charset \"UTF-8\";\n/* line 2, stdin */\n.header[_v-47c3695f], .body-col[_v-47c3695f] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  padding: 13px 24px;\n  gap: 24px; }\n  /* line 8, stdin */\n  .header span[_v-47c3695f], .body-col span[_v-47c3695f] {\n    color: #6B7280;\n    font-size: 14px;\n    font-weight: 500; }\n  /* line 14, stdin */\n  .header img[_v-47c3695f], .header input[_v-47c3695f], .header textarea[_v-47c3695f], .body-col img[_v-47c3695f], .body-col input[_v-47c3695f], .body-col textarea[_v-47c3695f] {\n    border-radius: 4px;\n    width: 100%;\n    max-height: 75px;\n    margin-bottom: 0; }\n\n/* line 22, stdin */\n.imgPreview[_v-47c3695f] {\n  display: none;\n  top: 0;\n  left: 0;\n  width: 100%;\n  /*容器佔滿整個螢幕*/\n  height: 100%;\n  position: fixed;\n  background: rgba(0, 0, 0, 0.5); }\n\n/* line 32, stdin */\n.imgPreview img[_v-47c3695f] {\n  z-index: 100;\n  width: 60%;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none; }\n\n/* line 42, stdin */\n.sticky-control-btn[_v-47c3695f] {\n  background: white;\n  padding: 12px 0;\n  position: -webkit-sticky;\n  position: sticky;\n  top: 50px; }\n  /* line 47, stdin */\n  .sticky-control-btn.bottom-shadow[_v-47c3695f] {\n    box-shadow: 0px 3px 2px -1px rgba(0, 0, 0, 0.1); }\n\n/* line 52, stdin */\n.control-item[_v-47c3695f] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between; }\n\n/* line 57, stdin */\n.w-100[_v-47c3695f] {\n  width: 100px; }\n\n/* line 61, stdin */\n.w-auto[_v-47c3695f] {\n  -ms-flex-positive: 1;\n      flex-grow: 1; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-47c3695f", module.exports)
  } else {
    hotAPI.update("_v-47c3695f", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1220:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _index = require('./index.vue');

var _index2 = _interopRequireDefault(_index);

var _single = require('./single.vue');

var _single2 = _interopRequireDefault(_single);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('webadmin-mega-index', _index2.default);
_vue2.default.component('webadmin-mega-single', _single2.default);

},{"./index.vue":1221,"./single.vue":1222,"vue":792}],1221:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.btn-success[_v-cfc9ebec] {\n  margin-bottom: 15px; }\n\n/* line 5, stdin */\n.list[_v-cfc9ebec] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  max-width: 840px; }\n  /* line 10, stdin */\n  .list .item[_v-cfc9ebec] {\n    width: 210px;\n    margin-bottom: 3em;\n    padding: 0 35px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            ajaxing: false,
            indexedMegaMenu: []
        };
    },
    mounted: function mounted() {
        this.fetch();
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', [])),
    methods: {
        fetch: function fetch() {
            var _this = this;

            this.indexedMegaMenu = [];
            this.ajaxing = true;
            this.$http.get('/adminapi/mega-menu').then(function (response) {
                _this.ajaxing = false;
                _this.indexedMegaMenu = response.body;
            }, function (error) {
                _this.ajaxing = false;
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-cfc9ebec=\"\">\n    <v-spinner :ajaxing=\"ajaxing\" _v-cfc9ebec=\"\"></v-spinner>\n    <div class=\"list\" v-show=\"!ajaxing\" _v-cfc9ebec=\"\"> \n        <div class=\"item\" v-for=\"(megaMenu,index) in indexedMegaMenu\" v-show=\"megaMenu.functions.length>0\" _v-cfc9ebec=\"\">\n            <webadmin-mega-single :title=\"megaMenu.title\" :icon=\"megaMenu.icon\" :functions=\"megaMenu.functions\" _v-cfc9ebec=\"\"></webadmin-mega-single>\n        </div>\n    </div>\n</div>    \n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.btn-success[_v-cfc9ebec] {\n  margin-bottom: 15px; }\n\n/* line 5, stdin */\n.list[_v-cfc9ebec] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  max-width: 840px; }\n  /* line 10, stdin */\n  .list .item[_v-cfc9ebec] {\n    width: 210px;\n    margin-bottom: 3em;\n    padding: 0 35px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-cfc9ebec", module.exports)
  } else {
    hotAPI.update("_v-cfc9ebec", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1222:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.btn-success[_v-77d2df40] {\n  margin-bottom: 15px; }\n\n/* line 5, stdin */\nh4[_v-77d2df40] {\n  color: #28679e;\n  font-size: 1.5em;\n  margin-bottom: 1em; }\n\n/* line 10, stdin */\na[_v-77d2df40] {\n  color: #000;\n  font-size: 1.25em; }\n  /* line 13, stdin */\n  a[_v-77d2df40]:hover {\n    color: #38b0e3; }\n\n/* line 17, stdin */\n.function_item[_v-77d2df40] {\n  line-height: 2em; }\n\n/* line 20, stdin */\n.icon[_v-77d2df40] {\n  margin-right: 8px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        title: {
            default: ''
        },
        icon: {
            default: ''
        },
        functions: {
            default: function _default() {
                return [];
            },
            type: Array
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['webFunctions', 'isSeventeen']), {
        showAll: function showAll() {
            var _this = this;

            return this.functions.reduce(function (carry, fun) {
                if (!carry) {
                    carry = _this.checkRight(fun.function);
                }

                return carry;
            }, false);
        }
    }),
    methods: {
        checkRight: function checkRight(right) {
            return !!this.webFunctions[right];
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div v-if=\"showAll\" _v-77d2df40=\"\">\n    <h4 _v-77d2df40=\"\">\n        <span v-html=\"icon\" class=\"icon\" _v-77d2df40=\"\"></span>\n        {{ title }}\n    </h4>\n    <div class=\"function_item\" v-for=\"wFunction in functions\" v-if=\"checkRight(wFunction.function)\" _v-77d2df40=\"\">\n        <a :href=\"wFunction.url\" _v-77d2df40=\"\">\n            {{ wFunction.name }}\n            <span v-show=\"isSeventeen\" _v-77d2df40=\"\">\n                ({{ wFunction.serial }})\n            </span>\n        </a>\n    </div>\n</div>    \n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.btn-success[_v-77d2df40] {\n  margin-bottom: 15px; }\n\n/* line 5, stdin */\nh4[_v-77d2df40] {\n  color: #28679e;\n  font-size: 1.5em;\n  margin-bottom: 1em; }\n\n/* line 10, stdin */\na[_v-77d2df40] {\n  color: #000;\n  font-size: 1.25em; }\n  /* line 13, stdin */\n  a[_v-77d2df40]:hover {\n    color: #38b0e3; }\n\n/* line 17, stdin */\n.function_item[_v-77d2df40] {\n  line-height: 2em; }\n\n/* line 20, stdin */\n.icon[_v-77d2df40] {\n  margin-right: 8px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-77d2df40", module.exports)
  } else {
    hotAPI.update("_v-77d2df40", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1223:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _vMemberTag = require('./v-member-tag.vue');

var _vMemberTag2 = _interopRequireDefault(_vMemberTag);

var _vMemberProfileOverview = require('./v-member-profile-overview.vue');

var _vMemberProfileOverview2 = _interopRequireDefault(_vMemberProfileOverview);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('v-member-tag', _vMemberTag2.default);
_vue2.default.component('v-member-profile-overview', _vMemberProfileOverview2.default);

},{"./v-member-profile-overview.vue":1224,"./v-member-tag.vue":1225,"vue":792}],1224:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.tippy-box[data-theme~=light-border] {\n  box-shadow: none; }\n\n/* line 5, stdin */\n.tippy-box {\n  max-width: 362px; }\n  /* line 7, stdin */\n  .tippy-box .profile-card-content {\n    margin: 24px 10px;\n    word-break: break-all; }\n  /* line 11, stdin */\n  .tippy-box .profile-card-top {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n    padding-bottom: 16px; }\n    /* line 15, stdin */\n    .tippy-box .profile-card-top .name {\n      font-size: 20px;\n      font-weight: 700; }\n    /* line 19, stdin */\n    .tippy-box .profile-card-top .phone {\n      font-size: 14px;\n      font-weight: 500;\n      color: #666666; }\n    /* line 24, stdin */\n    .tippy-box .profile-card-top .email {\n      font-size: 14px;\n      font-weight: 500;\n      text-decoration: underline; }\n  /* line 30, stdin */\n  .tippy-box .profile-card-body {\n    padding-top: 16px;\n    border-top: solid 1px #d5d5d5; }\n    /* line 33, stdin */\n    .tippy-box .profile-card-body .custom-filed-row {\n      display: -ms-grid;\n      display: grid;\n      -ms-grid-columns: 70px auto;\n          grid-template-columns: 70px auto;\n      font-size: 15px;\n      margin-bottom: 8px; }\n    /* line 39, stdin */\n    .tippy-box .profile-card-body .head {\n      font-weight: 700;\n      text-align: right; }\n    /* line 43, stdin */\n    .tippy-box .profile-card-body .text {\n      color: #666666;\n      padding-left: 20px;\n      display: -ms-inline-flexbox;\n      display: inline-flex;\n      -ms-flex-align: center;\n          align-items: center;\n      word-break: break-all; }\n  /* line 51, stdin */\n  .tippy-box .member-img {\n    background-color: #8f8f8f;\n    border: 1px solid #8f8f8f;\n    width: 120px;\n    height: 120px;\n    border-radius: 50%; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

var _tippy = require('tippy.js');

var _tippy2 = _interopRequireDefault(_tippy);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        memberId: {
            description: 'Member-id for fetch data.'
        },
        positionConfig: {
            type: String,
            default: 'webadmin/*'
        }
    },
    data: function data() {
        return {
            ajaxing: false,
            currentMemberId: 0,
            customCardBottomSec: [],
            customData: {},
            defaultImg: 'this.src="/images/default.png"',
            isShowTags: true,
            storeData: {}
        };
    },
    mounted: function mounted() {},
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['isBranch', 'isStudio', 'isSeventeen', 'customLayout', 'preventMemberIds']), (0, _vuex.mapState)({
        hasCardLayoutSetting: function hasCardLayoutSetting(state) {
            return state.webadmin.configure.webFunctions.WebadminCustomerProfileCardDisplay;
        }
    })),
    watch: {},
    methods: {
        fetchMemberData: function fetchMemberData(memberId, instance) {
            var _this = this;

            var id = memberId ? memberId : this.memberId;
            var vm = this;
            if (this.checkIsDataExist(id, instance)) return;
            if (this.ajaxing) return;
            if (this.currentMemberId == id) {
                instance.setContent(function (ref) {
                    var template = vm.$refs.member_profile_overview;
                    return template.innerHTML;
                });
            } else {
                this.currentMemberId = id;
                this.ajaxing = true;
                this.$http.get('/adminapi/customers/dataCard/' + id).then(function (response) {
                    var result = response.data;
                    _this.storeData[id] = result;
                    _this.gerateMemberCardData(result);
                    _this.ajaxing = false;
                }).then(function () {
                    instance.setContent(function (ref) {
                        var template = vm.$refs.member_profile_overview;
                        return template.innerHTML;
                    });
                }, function (error) {
                    instance.setContent('資料載入錯誤，請重新整理');
                    _this.ajaxing = false;
                });
            }
        },
        checkIsDataExist: function checkIsDataExist(id, instance) {
            var vm = this;
            if (this.storeData.hasOwnProperty(id)) {
                this.currentMemberId = id;
                this.gerateMemberCardData(this.storeData[id]);
                this.$nextTick(function () {
                    instance.setContent(function (ref) {
                        var template = vm.$refs.member_profile_overview;
                        return template.innerHTML;
                    });
                });
                return true;
            }
            return false;
        },
        gerateMemberCardData: function gerateMemberCardData(data) {
            var _this2 = this;

            this.customCardBottomSec = [];
            this.customData = data.customData;
            var setting = _lodash2.default.isEmpty(this.customLayout.customCard) ? { hidden_field: null, hidden_position: null } : this.customLayout.customCard;
            var fields = [];
            if (!this.isSeventeen && this.hasCardLayoutSetting) {
                if (setting.hidden_field) {
                    fields = setting.hidden_field.hasOwnProperty('custom_field') ? setting.hidden_field.custom_field : [];
                    this.isShowTags = setting.hidden_field.hasOwnProperty('customer_tag') ? false : true;
                }
                data.customFields.forEach(function (element) {
                    if (element.order > 4 && !fields.includes(element.id)) {
                        _this2.customCardBottomSec.push(element);
                    }
                });
                this.customCardBottomSec.sort(function (a, b) {
                    return a['order'] > b['order'] ? 1 : -1;
                });
            }
        },
        fieldTextFormat: function fieldTextFormat(field) {
            if (this.customData.hasOwnProperty(field.key)) {
                if (field.key == 'gender') {
                    return this.customData[field.key] == 0 ? '女' : '男';
                };
                if ((0, _typeof3.default)(this.customData[field.key]) == 'object') {
                    var value = this.customData[field.key] || '';
                    return value.toString();
                } else {
                    return this.customData[field.key];
                };
            } else {
                return '';
            };
        },
        onCall: function onCall(memberId, targetId) {
            if (!memberId) return;
            if (this.preventMemberIds.includes(memberId)) return;
            if (!this.isShowPositionByWebadminSetting()) return;
            var vm = this;
            var placement = window.innerWidth <= 768 ? 'bottom' : 'right';
            var tooltip = (0, _tippy2.default)(targetId, {
                content: '載入中...',
                duration: 0,
                arrow: false,
                placement: placement,
                theme: 'light-border',
                interactive: false,
                allowHTML: true,
                onShow: function onShow(instance) {
                    vm.fetchMemberData(memberId, instance);
                },
                onShown: function onShown(instance, event) {
                    instance.setProps({
                        interactive: true
                    });
                },
                onHidden: function onHidden(instance) {
                    instance.setContent('載入中...');
                    instance.destroy();
                }
            });
        },
        isShowPositionByWebadminSetting: function isShowPositionByWebadminSetting() {
            if (this.isSeventeen || !this.hasCardLayoutSetting) return true;
            if (this.positionConfig == 'webadmin/*') return true;
            if (this.customLayout.hasOwnProperty('customCard')) {
                return this.isShowCard();
            } else {
                return false;
            }
        },
        isShowCard: function isShowCard() {
            if (_lodash2.default.isEmpty(this.customLayout.customCard.hidden_position.effect_position)) return true;
            var path = window.location.pathname;
            var config = JSON.parse(this.customLayout.customCard.hidden_position.effect_position);
            var effectParams = config.effect || '';
            var hiddenParams = config.hidden || [];
            var exp = '';
            effectParams.split('/').forEach(function (item) {
                if (item != '*') {
                    exp += "[\/&]" + item;
                }
            });
            var rx = new RegExp(exp + ".*$");
            var isEffectPositionActive = path.match(rx);

            if (isEffectPositionActive == null) {
                return false;
            } else {
                var isHidden = hiddenParams.includes(this.positionConfig);
                return !isHidden;
            }
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div ref=\"member_profile_overview\" style=\"display: none;\">\n    <div class=\"profile-card-content\">\n        <div class=\"profile-card-top\">\n            <img class=\"member-img margin_center\" :src=\"customData.picture\" :on-error=\"defaultImg\">\n            <div class=\"m-left-20\">\n                <div class=\"m-bottom-10 name\">{{customData.name}} \n                    <a class=\"m-left-10\" :href=\"'/webadmin/member_studio?f[id]='+currentMemberId\" target=\"_blank\"><i class=\"fa fa-external-link\"></i></a>\n                </div>\n                <div class=\"m-bottom-5 phone\">{{customData.phone}}</div>\n                <div class=\"email\" v-if=\"customData.email\">\n                    <a :href=\"'mailto:' + customData.email\" target=\"_blank\">{{customData.email}}</a>\n                </div>\n                <div v-if=\"isShowTags || isSeventeen\">\n                    <v-member-tag :member-tags=\"customData.tags\"></v-member-tag>\n                </div>\n            </div>\n        </div>\n        <div class=\"profile-card-body\" v-show=\"customCardBottomSec.length > 0\">\n            <div class=\"custom-filed-row\" v-for=\"field in customCardBottomSec\">\n                <div class=\"head\">{{field.name}}</div>\n                <div class=\"text\">{{fieldTextFormat(field)}}</div>\n            </div>\n        </div>\n    </div>\n\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.tippy-box[data-theme~=light-border] {\n  box-shadow: none; }\n\n/* line 5, stdin */\n.tippy-box {\n  max-width: 362px; }\n  /* line 7, stdin */\n  .tippy-box .profile-card-content {\n    margin: 24px 10px;\n    word-break: break-all; }\n  /* line 11, stdin */\n  .tippy-box .profile-card-top {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n    padding-bottom: 16px; }\n    /* line 15, stdin */\n    .tippy-box .profile-card-top .name {\n      font-size: 20px;\n      font-weight: 700; }\n    /* line 19, stdin */\n    .tippy-box .profile-card-top .phone {\n      font-size: 14px;\n      font-weight: 500;\n      color: #666666; }\n    /* line 24, stdin */\n    .tippy-box .profile-card-top .email {\n      font-size: 14px;\n      font-weight: 500;\n      text-decoration: underline; }\n  /* line 30, stdin */\n  .tippy-box .profile-card-body {\n    padding-top: 16px;\n    border-top: solid 1px #d5d5d5; }\n    /* line 33, stdin */\n    .tippy-box .profile-card-body .custom-filed-row {\n      display: -ms-grid;\n      display: grid;\n      -ms-grid-columns: 70px auto;\n          grid-template-columns: 70px auto;\n      font-size: 15px;\n      margin-bottom: 8px; }\n    /* line 39, stdin */\n    .tippy-box .profile-card-body .head {\n      font-weight: 700;\n      text-align: right; }\n    /* line 43, stdin */\n    .tippy-box .profile-card-body .text {\n      color: #666666;\n      padding-left: 20px;\n      display: -ms-inline-flexbox;\n      display: inline-flex;\n      -ms-flex-align: center;\n          align-items: center;\n      word-break: break-all; }\n  /* line 51, stdin */\n  .tippy-box .member-img {\n    background-color: #8f8f8f;\n    border: 1px solid #8f8f8f;\n    width: 120px;\n    height: 120px;\n    border-radius: 50%; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-5572f30e", module.exports)
  } else {
    hotAPI.update("_v-5572f30e", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"babel-runtime/helpers/typeof":72,"lodash":717,"tippy.js":780,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1225:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n#member-tag-vue[_v-cbc03d24] {\n  display: -ms-flexbox;\n  display: flex; }\n  /* line 4, stdin */\n  #member-tag-vue .btn[_v-cbc03d24] {\n    border-radius: 4px; }\n  /* line 7, stdin */\n  #member-tag-vue .hover-tag[_v-cbc03d24] {\n    position: inherit;\n    margin-top: 13px; }\n  /* line 12, stdin */\n  #member-tag-vue .popup-tag[_v-cbc03d24] {\n    width: 250px;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    border-radius: 4px;\n    box-shadow: 1px 1px 7px 0 rgba(68, 68, 68, 0.5);\n    background-color: #ffffff;\n    opacity: 0;\n    position: absolute;\n    top: 40px;\n    left: 5px;\n    border: 1px solid transparent;\n    height: 0px;\n    padding: 5px;\n    overflow: hidden;\n    -webkit-transition: all 100ms;\n    transition: all 100ms;\n    z-index: 10;\n    display: none; }\n    /* line 31, stdin */\n    #member-tag-vue .popup-tag .btn[_v-cbc03d24] {\n      margin: 5px;\n      cursor: default; }\n  /* line 38, stdin */\n  #member-tag-vue .hover-tag[_v-cbc03d24]:hover {\n    position: relative; }\n    /* line 40, stdin */\n    #member-tag-vue .hover-tag:hover .popup-tag[_v-cbc03d24] {\n      display: block;\n      height: auto;\n      opacity: 1;\n      border: 1px solid #eeeeee; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        memberId: {
            description: 'Member-id for fetch data.'
        },
        memberTags: {
            desctiption: 'If member tags given, memberTags directly provide to component.'
        },
        tagStyle: {
            description: 'Style of tags'
        }
    },
    data: function data() {
        return {
            ajaxing: false,
            tags: []
        };
    },
    mounted: function mounted() {
        if (this.memberTags) {
            this.tags = this.memberTags;
        } else if (this.memberId) {
            this.fetch();
        };
    },
    computed: {
        tagNum: function tagNum() {
            return this.tags.length;
        },
        firstTag: function firstTag() {
            if (this.tags.length > 0) {
                return this.tags[0].name;
            }
            return null;
        },
        showTag: function showTag() {
            return this.tags.length > 0;
        }
    },
    watch: {
        memberId: function memberId(newV) {
            if (this.memberId) {
                this.fetch();
            };
        },
        memberTags: function memberTags(newV) {
            if (newV) {
                this.tags = newV;
            }
        }
    },
    methods: {
        fetch: function fetch() {
            var _this = this;

            this.ajaxing = true;
            this.$http.get('/adminapi/member/member_tag/' + this.memberId).then(function (response) {
                _this.ajaxing = false;
                _this.tags = response.body;
            }, function (error) {
                _this.ajaxing = false;
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div id=\"member-tag-vue\" v-if=\"showTag\" _v-cbc03d24=\"\">\n    <div :style=\"tagStyle\" class=\"hover-tag\" v-show=\"!ajaxing\" _v-cbc03d24=\"\">\n        <div type=\"button\" class=\"btn btn-info btn-sm\" v-if=\"firstTag\" _v-cbc03d24=\"\">{{firstTag}}</div>\n        <div type=\"button\" class=\"btn btn-info btn-sm\" v-if=\"tagNum > 1\" _v-cbc03d24=\"\">+{{tagNum -1}}</div>\n        <div class=\"popup-tag\" v-if=\"tagNum > 1\" _v-cbc03d24=\"\">\n            <div type=\"button\" class=\"btn btn-info btn-sm\" v-for=\"tag in tags\" _v-cbc03d24=\"\">{{tag.name}}</div>\n        </div>        \n    </div>\n</div>    \n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n#member-tag-vue[_v-cbc03d24] {\n  display: -ms-flexbox;\n  display: flex; }\n  /* line 4, stdin */\n  #member-tag-vue .btn[_v-cbc03d24] {\n    border-radius: 4px; }\n  /* line 7, stdin */\n  #member-tag-vue .hover-tag[_v-cbc03d24] {\n    position: inherit;\n    margin-top: 13px; }\n  /* line 12, stdin */\n  #member-tag-vue .popup-tag[_v-cbc03d24] {\n    width: 250px;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    border-radius: 4px;\n    box-shadow: 1px 1px 7px 0 rgba(68, 68, 68, 0.5);\n    background-color: #ffffff;\n    opacity: 0;\n    position: absolute;\n    top: 40px;\n    left: 5px;\n    border: 1px solid transparent;\n    height: 0px;\n    padding: 5px;\n    overflow: hidden;\n    -webkit-transition: all 100ms;\n    transition: all 100ms;\n    z-index: 10;\n    display: none; }\n    /* line 31, stdin */\n    #member-tag-vue .popup-tag .btn[_v-cbc03d24] {\n      margin: 5px;\n      cursor: default; }\n  /* line 38, stdin */\n  #member-tag-vue .hover-tag[_v-cbc03d24]:hover {\n    position: relative; }\n    /* line 40, stdin */\n    #member-tag-vue .hover-tag:hover .popup-tag[_v-cbc03d24] {\n      display: block;\n      height: auto;\n      opacity: 1;\n      border: 1px solid #eeeeee; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-cbc03d24", module.exports)
  } else {
    hotAPI.update("_v-cbc03d24", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1226:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.display-flex[_v-55b2d4b9] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center; }\n\n/* line 8, stdin */\n.title-container[_v-55b2d4b9] {\n  -ms-flex-pack: justify;\n      justify-content: space-between; }\n  /* line 11, stdin */\n  .title-container .btn[_v-55b2d4b9] {\n    padding: 7px 30px;\n    font-size: 16px; }\n\n/* line 18, stdin */\n.serial-search-setting a[_v-55b2d4b9] {\n  text-decoration: underline;\n  color: #0085FF; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            list: [],
            startAjax: true
        };
    },
    mounted: function mounted() {},

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'isSeventeen']), (0, _vuex.mapState)('filters', ['selected_studio_id'])),
    watch: {
        selected_studio_id: function selected_studio_id(newV, oldV) {
            if (newV > 0) {
                this.search();
            }
        }
    },
    methods: {
        search: function search() {
            var _this = this;

            this.startAjax = true;
            this.$http.get('/adminapi/member-contract/batch-event/record/' + this.selected_studio_id).then(function (response) {
                _this.list = response.data;
                _this.startAjax = false;
            }).catch(function (response) {
                _this.startAjax = false;
                $17.swal({
                    title: '取得資料失敗',
                    text: "",
                    type: 'warning',
                    showCancelButton: false
                });
            });
        },
        viewModel: function viewModel(reason) {
            reason = reason.replace(/[\n\r]/g, '<br>');
            $17.swal({
                title: '異動原因',
                html: reason,
                showCancelButton: false
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"col-sm-12\" _v-55b2d4b9=\"\">\n    <div class=\"title-container display-flex m-bottom-20\" _v-55b2d4b9=\"\">\n        <h2 _v-55b2d4b9=\"\">客戶方案批次處理紀錄</h2>\n    </div>\n    <div class=\"serial-search-setting\" _v-55b2d4b9=\"\">\n        <v-select-studio-and-branch :studio_id=\"studioId\" :show-branch=\"false\" _v-55b2d4b9=\"\">\n        </v-select-studio-and-branch>\n        <div _v-55b2d4b9=\"\">\n            <div class=\"table-responsive\" v-if=\"Object.keys(this.list).length>0\" _v-55b2d4b9=\"\">\n                <table class=\"table table-hover contentTable\" _v-55b2d4b9=\"\">\n                    <thead _v-55b2d4b9=\"\">\n                    <tr _v-55b2d4b9=\"\">\n                        <th _v-55b2d4b9=\"\">批次處理事件編號</th>\n                        <th _v-55b2d4b9=\"\">操作時間</th>\n                        <th _v-55b2d4b9=\"\">異動客戶方案數量</th>\n                        <th _v-55b2d4b9=\"\">操作者</th>\n                        <th _v-55b2d4b9=\"\">異動紀錄</th>\n                        <th _v-55b2d4b9=\"\">異動原因</th>\n                        <th _v-55b2d4b9=\"\">狀態</th>\n                    </tr>\n                    </thead>\n                    <tbody _v-55b2d4b9=\"\">\n                    <tr v-for=\"item in list\" _v-55b2d4b9=\"\">\n                        <td _v-55b2d4b9=\"\">{{item.id}}</td>\n                        <td _v-55b2d4b9=\"\">{{item.exec_completed_at}}</td>\n                        <td _v-55b2d4b9=\"\">{{item.exec_success_count}}</td>\n                        <td _v-55b2d4b9=\"\">{{item.name}}</td>\n                        <td _v-55b2d4b9=\"\">\n                            {{item.exec_command_description}}\n                        </td>\n                        <td _v-55b2d4b9=\"\"><span @click=\"viewModel(item.reason) \" style=\"cursor:pointer;color:blue;\" _v-55b2d4b9=\"\">查看</span></td>\n                        <td _v-55b2d4b9=\"\">{{item.exec_result !== 1? '失敗':'成功'}}</td>\n                    </tr>\n                    </tbody>\n                </table>\n            </div>\n\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.display-flex[_v-55b2d4b9] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center; }\n\n/* line 8, stdin */\n.title-container[_v-55b2d4b9] {\n  -ms-flex-pack: justify;\n      justify-content: space-between; }\n  /* line 11, stdin */\n  .title-container .btn[_v-55b2d4b9] {\n    padding: 7px 30px;\n    font-size: 16px; }\n\n/* line 18, stdin */\n.serial-search-setting a[_v-55b2d4b9] {\n  text-decoration: underline;\n  color: #0085FF; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-55b2d4b9", module.exports)
  } else {
    hotAPI.update("_v-55b2d4b9", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1227:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 3, stdin */\nform input[_v-a8bc6aee] {\n  max-width: 90px;\n  padding: 7px 12px; }\n\n/* line 8, stdin */\nform textarea[_v-a8bc6aee] {\n  max-width: 250px; }\n\n/* line 13, stdin */\n.form-head[_v-a8bc6aee] {\n  text-align: right;\n  padding-right: 0; }\n")
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        batchNumber: {
            default: null
        },
        batchSearch: {
            default: null
        },
        studioId: {
            default: null
        }
    },
    data: function data() {
        return {
            setting: {
                operator: 'increase',
                days: 0,
                reason: ""
            }
        };
    },
    mounted: function mounted() {},

    computed: {},
    methods: {
        submit: function submit() {
            var _this = this;

            if (this.setting.reason.trim() === "") {
                alert("請填寫異動原因");
                return;
            }
            if (this.setting.days <= 0) {
                alert("異動天數不可小於０");
                return;
            }
            var data = {
                batchSearch: this.batchSearch,
                setting: this.setting
            };
            $('#edit-batch-of-contract-modal').modal('hide');
            this.$emit("execute", 0);
            this.$http.post('/adminapi/member-contract/batch-change/execute/' + this.studioId, data).then(function (response) {
                window.location.href = "/webadmin/member-contract/batch-record";
            }, function (error) {
                _this.$emit("execute", 1);
                $17.swal({
                    title: error.body.message,
                    type: 'warning',
                    showCancelButton: false
                });
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal id=\"edit-batch-of-contract-modal\" :save-clicked=\"submit\" :close-btn-text=\"'取消'\" _v-a8bc6aee=\"\">\n    <span slot=\"title\" _v-a8bc6aee=\"\">提前/延後到期日</span>\n    <template slot=\"body\">\n\n        <form class=\"form-horizontal\" _v-a8bc6aee=\"\">\n            <div class=\"row m-bottom-10\" _v-a8bc6aee=\"\">\n                <div class=\"col-sm-12 m-bottom-20\" style=\"color: red;\" _v-a8bc6aee=\"\">注意:你將針對{{batchNumber}}筆客戶方案進行批次處理</div>\n                <div class=\"col-sm-3 form-head\" _v-a8bc6aee=\"\">\n                    <input type=\"radio\" name=\"increase\" id=\"increase\" v-model=\"setting.operator\" value=\"increase\" _v-a8bc6aee=\"\">\n                    <label for=\"increase\" _v-a8bc6aee=\"\">延後</label>\n                </div>\n                <div class=\"col-sm-9\" v-show=\"setting.operator == 'increase'\" _v-a8bc6aee=\"\">\n                    <input type=\"number\" v-model=\"setting.days\" _v-a8bc6aee=\"\">\n                    <span class=\"m-left-5\" _v-a8bc6aee=\"\"></span>天\n                </div>\n            </div>\n            <div class=\"row m-bottom-10\" _v-a8bc6aee=\"\">\n                <div class=\"col-sm-3 form-head\" _v-a8bc6aee=\"\">\n                    <input type=\"radio\" name=\"decrease\" id=\"decrease\" v-model=\"setting.operator\" value=\"decrease\" _v-a8bc6aee=\"\">\n                    <label for=\"decrease\" _v-a8bc6aee=\"\">提前</label>\n                </div>\n                <div class=\"col-sm-9\" v-show=\"setting.operator == 'decrease'\" _v-a8bc6aee=\"\">\n                    <input type=\"number\" v-model=\"setting.days\" _v-a8bc6aee=\"\">\n                    <span class=\"m-left-5\" _v-a8bc6aee=\"\"></span>天\n                </div>\n            </div>\n            <div class=\"row\" _v-a8bc6aee=\"\">\n                <div class=\"col-sm-3 form-head\" _v-a8bc6aee=\"\">\n                    <label _v-a8bc6aee=\"\">異動原因</label>\n                </div>\n                <div class=\"col-sm-9\" _v-a8bc6aee=\"\">\n                    <textarea name=\"reason\" rows=\"4\" cols=\"50\" v-model=\"setting.reason\" _v-a8bc6aee=\"\"></textarea>\n                </div>\n            </div>\n        </form>\n    </template>\n</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 3, stdin */\nform input[_v-a8bc6aee] {\n  max-width: 90px;\n  padding: 7px 12px; }\n\n/* line 8, stdin */\nform textarea[_v-a8bc6aee] {\n  max-width: 250px; }\n\n/* line 13, stdin */\n.form-head[_v-a8bc6aee] {\n  text-align: right;\n  padding-right: 0; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-a8bc6aee", module.exports)
  } else {
    hotAPI.update("_v-a8bc6aee", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1228:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.display-flex[_v-25f1ddd6] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center; }\n\n/* line 7, stdin */\n.dark-border[_v-25f1ddd6] {\n  border-top: 1px solid #4C4C4C; }\n\n/* line 11, stdin */\n.title-container[_v-25f1ddd6] {\n  -ms-flex-pack: justify;\n      justify-content: space-between; }\n  /* line 14, stdin */\n  .title-container .btn[_v-25f1ddd6] {\n    padding: 7px 30px;\n    font-size: 16px; }\n\n/* line 21, stdin */\n.serial-search-setting a[_v-25f1ddd6] {\n  text-decoration: underline;\n  color: #0085FF; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        var today = moment(new Date()).format('YYYY/MM/DD');
        return {
            today: today,
            list: [],
            pageMeta: [],
            startAjax: true,
            executeAjax: true,
            tagList: [],
            filters: {
                search_type: 1,
                date_type: 1,
                customer_type: 1,
                batch_number: '',
                start_date: today,
                end_date: today,
                tags: [],
                contract_type: {
                    point: 1,
                    count: 1,
                    unlimited: 1
                }
            },
            params: "",
            change: 1
        };
    },
    mounted: function mounted() {
        this.getMemberTags();
        this.setUrlSearch();
    },

    watch: {
        'filters.search_type': {
            handler: function handler(newVal) {
                this.list = [];
                this.pageMeta = [];
            }
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'isSeventeen']), {
        isPageData: function isPageData() {
            return this.pageMeta.total > 0;
        }
    }),
    methods: {
        search: function search() {
            var _this = this;

            this.startAjax = true;
            if (this.filters.search_type == 1) {
                this.filters.batch_number = "";
            }

            if (this.filters.date_type == 1) {
                this.filters.start_date = this.today;
                this.filters.end_date = this.today;
            }

            if (this.filters.customer_type == 1) {
                this.filters.tags = [];
            }

            this.params = {
                start_date: this.filters.start_date,
                end_date: this.filters.end_date,
                page: this.getUrlParamValue('page') ? this.getUrlParamValue('page') : 1,
                batch_number: this.filters.batch_number,
                search_type: this.filters.search_type,
                date_type: this.filters.date_type,
                customer_type: this.filters.customer_type
            };

            var contractType = [];
            (0, _entries2.default)(this.filters.contract_type).forEach(function (_ref) {
                var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
                    key = _ref2[0],
                    value = _ref2[1];

                if (value === 1) {
                    contractType.push(key);
                }
            });

            if (contractType.length > 0) {
                this.params['contract_type'] = contractType;
            }

            var tags = [];
            (0, _entries2.default)(this.filters.tags).forEach(function (_ref3) {
                var _ref4 = (0, _slicedToArray3.default)(_ref3, 2),
                    key = _ref4[0],
                    value = _ref4[1];

                tags.push(value['id']);
            });

            if (tags.length > 0) {
                this.params['tags'] = tags;
            }

            history.replaceState({}, null, '?' + this.serialize(this.params));
            this.$http.get('/adminapi/member-contract/batch-change/list/' + this.studioId, { 'params': this.params }).then(function (response) {
                _this.list = response.data.list;
                _this.pageMeta = response.data.pageMeta;

                _this.startAjax = false;
            }).catch(function (response) {
                _this.startAjax = false;
                $17.swal({
                    title: '取得資料失敗',
                    text: "",
                    type: 'warning',
                    showCancelButton: false
                });
            });
        },
        getMemberTags: function getMemberTags() {
            var _this2 = this;

            this.$http.get('/adminapi/tag/getList/options').then(function (response) {
                _this2.tagList = response.data[0];
                var _self = _this2;
                if (_this2.newTags) {
                    if (!Array.isArray(_this2.newTags)) {
                        _this2.newTags = _this2.newTags.split(',');
                    }
                    _this2.tagList.forEach(function (item) {
                        if (_self.newTags.includes(item.id.toString())) {
                            _self.filters.tags.push({
                                id: item.id,
                                name: item.name
                            });
                        }
                    });
                }
            }).catch(function (response) {
                $17.swal({
                    title: '取得資料失敗',
                    text: "",
                    type: 'warning',
                    showCancelButton: false
                });
            });
        },
        serialize: function serialize(obj, prefix) {
            var str = [],
                p;
            for (p in obj) {
                if (obj.hasOwnProperty(p)) {
                    var k = prefix ? prefix + "[" + p + "]" : p,
                        v = obj[p];
                    str.push(v !== null && (typeof v === 'undefined' ? 'undefined' : (0, _typeof3.default)(v)) === "object" ? this.serialize(v, k) : encodeURIComponent(k) + "=" + encodeURIComponent(v));
                }
            }
            return str.join("&");
        },
        setUrlSearch: function setUrlSearch() {
            var _this3 = this;

            var urlSearch = $17.getUrlQueryStrings();
            if (urlSearch) {
                return;
            }
            this.filters.start_date = urlSearch['start_date'] || this.today;
            this.filters.end_date = urlSearch['end_date'] || this.today;
            this.filters.batch_number = urlSearch['batch_Number'] || "";
            this.filters.search_type = parseInt(urlSearch['search_type']);
            this.filters.date_type = parseInt(urlSearch['date_type']);
            this.filters.customer_type = parseInt(urlSearch['customer_type']);
            this.newTags = urlSearch['tags'] || "";

            var newContract_type = urlSearch['contract_type'];
            if (!Array.isArray(urlSearch['contract_type'])) {
                newContract_type = newContract_type.split(',');
            }
            (0, _entries2.default)(newContract_type).forEach(function (_ref5) {
                var _ref6 = (0, _slicedToArray3.default)(_ref5, 2),
                    key = _ref6[0],
                    value = _ref6[1];

                _this3.filters.contract_type[value] = 1;
            });
        },
        openModel: function openModel() {
            if (this.pageMeta.total > 5000) {
                $17.swal({
                    title: '超出數量上限',
                    text: '單次處理方案數量上限為5000筆',
                    type: 'warning',
                    showCancelButton: false
                });
            } else {
                $('#edit-batch-of-contract-modal').modal('show');
            }
        },
        execute: function execute(status) {
            if (status == 0) {
                this.executeAjax = false;
            } else {
                this.executeAjax = true;
            }
        },
        formatDate: function formatDate(date) {
            return moment(date).format('YYYY/MM/DD');
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"col-sm-12\" _v-25f1ddd6=\"\">\n    <div class=\"title-container display-flex m-bottom-20\" _v-25f1ddd6=\"\">\n        <h2 _v-25f1ddd6=\"\">批次處理客戶方案</h2>\n        <button type=\"button\" class=\"btn btn-info\" @click=\"search\" _v-25f1ddd6=\"\">搜尋</button>\n    </div>\n    <div class=\"serial-search-setting\" v-show=\"executeAjax\" _v-25f1ddd6=\"\">\n        <div _v-25f1ddd6=\"\">\n            <input type=\"radio\" id=\"search-new\" :value=\"1\" v-model=\"filters.search_type\" _v-25f1ddd6=\"\">\n            <label for=\"search-new\" _v-25f1ddd6=\"\">新搜尋</label><br _v-25f1ddd6=\"\">\n            <input type=\"radio\" id=\"input-number\" :value=\"2\" v-model=\"filters.search_type\" _v-25f1ddd6=\"\">\n            <label for=\"input-number\" _v-25f1ddd6=\"\">輸入批次處理事件編號</label>\n            <span _v-25f1ddd6=\"\"><a href=\"/webadmin/member-contract/batch-record\" target=\"_blank\" _v-25f1ddd6=\"\">批次處理記錄</a></span>\n            <div class=\"m-left-15 m-top-5\" _v-25f1ddd6=\"\">\n                <input type=\"text\" name=\"serial-number\" v-model=\"filters.batch_number\" placeholder=\"請輸入編號\" _v-25f1ddd6=\"\">\n            </div>\n        </div>\n        <div v-show=\"filters.search_type == 1\" _v-25f1ddd6=\"\">\n            <hr _v-25f1ddd6=\"\">\n            <div _v-25f1ddd6=\"\">\n                <h4 class=\"m-bottom-20\" _v-25f1ddd6=\"\">方案有效日期</h4>\n                <input type=\"radio\" id=\"valid-contract\" :value=\"1\" v-model=\"filters.date_type\" _v-25f1ddd6=\"\">\n                <label for=\"valid-contract\" _v-25f1ddd6=\"\">所有今天有效的客戶方案</label><br _v-25f1ddd6=\"\">\n                <input type=\"radio\" id=\"range-contract\" :value=\"2\" v-model=\"filters.date_type\" _v-25f1ddd6=\"\">\n                <label for=\"range-contract\" _v-25f1ddd6=\"\">客戶方案有效日期介於</label>\n                <div class=\"display-flex m-left-15 m-top-5\" _v-25f1ddd6=\"\">\n                    <v-datepicker v-model=\"filters.start_date\" placeholder=\"選擇日期\" _v-25f1ddd6=\"\"></v-datepicker>\n                    <span class=\"m-left-5 m-right-5\" _v-25f1ddd6=\"\">～</span>\n                    <v-datepicker v-model=\"filters.end_date\" placeholder=\"選擇日期\" _v-25f1ddd6=\"\"></v-datepicker>\n                </div>\n            </div>\n            <hr _v-25f1ddd6=\"\">\n            <div _v-25f1ddd6=\"\">\n                <h4 class=\"m-bottom-20\" _v-25f1ddd6=\"\">客戶</h4>\n                <input type=\"radio\" id=\"all-customer\" :value=\"1\" v-model=\"filters.customer_type\" _v-25f1ddd6=\"\">\n                <label for=\"all-customer\" _v-25f1ddd6=\"\">所有客戶</label><br _v-25f1ddd6=\"\">\n                <input type=\"radio\" id=\"taged-customer\" :value=\"2\" v-model=\"filters.customer_type\" _v-25f1ddd6=\"\">\n                <label for=\"taged-customer\" _v-25f1ddd6=\"\">指定標籤客戶</label>\n                <div class=\"m-left-15 m-top-5\" style=\"max-width: 600px\" _v-25f1ddd6=\"\">\n                    <v-mutiselect :model.sync=\"filters.tags\" :options=\"tagList\" :disabled=\"false\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"false\" :placeholder=\"'請選擇'\" label=\"name\" track-by=\"id\" :taggable=\"true\" tag-name=\"name\" :max-height=\"500\" _v-25f1ddd6=\"\">\n                    </v-mutiselect>\n                </div>\n            </div>\n            <hr _v-25f1ddd6=\"\">\n            <div _v-25f1ddd6=\"\">\n                <h4 class=\"m-bottom-20\" _v-25f1ddd6=\"\">方案類型</h4>\n                <input type=\"checkbox\" id=\"point\" :true-value=\"1\" :false-value=\"0\" v-model=\"filters.contract_type.point\" _v-25f1ddd6=\"\">\n                <label for=\"point\" class=\"m-right-10\" _v-25f1ddd6=\"\">點數</label>\n                <input type=\"checkbox\" id=\"count\" :true-value=\"1\" :false-value=\"0\" v-model=\"filters.contract_type.count\" _v-25f1ddd6=\"\">\n                <label for=\"count\" class=\"m-right-10\" _v-25f1ddd6=\"\">次數</label>\n                <input type=\"checkbox\" id=\"unlimited\" :true-value=\"1\" :false-value=\"0\" v-model=\"filters.contract_type.unlimited\" _v-25f1ddd6=\"\">\n                <label for=\"unlimited\" class=\"m-right-10\" _v-25f1ddd6=\"\">無限</label>\n            </div>\n        </div>\n        <hr class=\"dark-border\" _v-25f1ddd6=\"\">\n        <div v-show=\"!startAjax\" _v-25f1ddd6=\"\">\n            <h4 v-if=\"isPageData\" class=\"m-bottom-20\" _v-25f1ddd6=\"\">搜尋結果{{pageMeta.total}}筆</h4>\n            <h4 v-else=\"\" style=\"width: 100%; text-align: center;\" _v-25f1ddd6=\"\">沒有資料</h4>\n            <div v-show=\"isPageData\" _v-25f1ddd6=\"\">\n                針對所有搜尋結果執行\n                <select v-model=\"change\" _v-25f1ddd6=\"\">\n                    <option value=\"1\" _v-25f1ddd6=\"\">提前/延後到期日</option>\n                </select>\n                <button type=\"button\" class=\"btn btn-info\" @click=\"openModel\" _v-25f1ddd6=\"\">開始</button>\n            </div>\n            <div class=\"table-responsive\" v-if=\"Object.keys(this.list).length>0\" _v-25f1ddd6=\"\">\n                <table class=\"table table-hover contentTable\" _v-25f1ddd6=\"\">\n                    <thead _v-25f1ddd6=\"\">\n                    <tr _v-25f1ddd6=\"\">\n                        <th _v-25f1ddd6=\"\">客戶姓名</th>\n                        <th _v-25f1ddd6=\"\">電話</th>\n                        <th _v-25f1ddd6=\"\">信箱</th>\n                        <th _v-25f1ddd6=\"\">方案名稱</th>\n                        <th _v-25f1ddd6=\"\">方案類型</th>\n                        <th _v-25f1ddd6=\"\">方案起訖日</th>\n                        <th _v-25f1ddd6=\"\">方案剩餘權益</th>\n                    </tr>\n                    </thead>\n                    <tbody _v-25f1ddd6=\"\">\n                    <tr v-for=\"transaction in list\" _v-25f1ddd6=\"\">\n                        <td _v-25f1ddd6=\"\">{{transaction.name}}</td>\n                        <td _v-25f1ddd6=\"\">{{transaction.phone}}</td>\n                        <td _v-25f1ddd6=\"\">{{transaction.email}}</td>\n                        <td _v-25f1ddd6=\"\">{{transaction.contractName}}</td>\n                        <td _v-25f1ddd6=\"\">{{transaction.contractsType}}</td>\n                        <td _v-25f1ddd6=\"\">\n                            {{formatDate(transaction.start_time)}} ~ {{formatDate(transaction.end_time)}}\n                        </td>\n                        <td _v-25f1ddd6=\"\">{{transaction.unused}}</td>\n                    </tr>\n                    </tbody>\n                </table>\n            </div>\n            <v-sql-pagination v-show=\"!startAjax\" ref=\"pager\" :page-meta=\"pageMeta\" @page-change-callback=\"search\" _v-25f1ddd6=\"\">\n            </v-sql-pagination>\n        </div>\n    </div>\n    <v-spinner :ajaxing=\"!executeAjax\" id=\"v-spinner\" _v-25f1ddd6=\"\"></v-spinner>\n    <change-content-modal :batch-number=\"pageMeta.total\" :batch-search=\"params\" :studio-id=\"studioId\" @execute=\"execute\" _v-25f1ddd6=\"\"></change-content-modal>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.display-flex[_v-25f1ddd6] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center; }\n\n/* line 7, stdin */\n.dark-border[_v-25f1ddd6] {\n  border-top: 1px solid #4C4C4C; }\n\n/* line 11, stdin */\n.title-container[_v-25f1ddd6] {\n  -ms-flex-pack: justify;\n      justify-content: space-between; }\n  /* line 14, stdin */\n  .title-container .btn[_v-25f1ddd6] {\n    padding: 7px 30px;\n    font-size: 16px; }\n\n/* line 21, stdin */\n.serial-search-setting a[_v-25f1ddd6] {\n  text-decoration: underline;\n  color: #0085FF; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-25f1ddd6", module.exports)
  } else {
    hotAPI.update("_v-25f1ddd6", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/object/entries":54,"babel-runtime/helpers/extends":66,"babel-runtime/helpers/slicedToArray":70,"babel-runtime/helpers/typeof":72,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1229:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _changeMemberContract = require('./change-member-contract.vue');

var _changeMemberContract2 = _interopRequireDefault(_changeMemberContract);

var _changeContentModal = require('./change-content-modal.vue');

var _changeContentModal2 = _interopRequireDefault(_changeContentModal);

var _batchMemberContractRecord = require('./batch-member-contract-record.vue');

var _batchMemberContractRecord2 = _interopRequireDefault(_batchMemberContractRecord);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('change-member-contract', _changeMemberContract2.default);
_vue2.default.component('change-content-modal', _changeContentModal2.default);
_vue2.default.component('batch-member-contract-record', _batchMemberContractRecord2.default);

},{"./batch-member-contract-record.vue":1226,"./change-content-modal.vue":1227,"./change-member-contract.vue":1228,"vue":792}],1230:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 3, stdin */\nform input[_v-c86b45c6] {\n  max-width: 90px;\n  padding: 7px 12px; }\n\n/* line 8, stdin */\nform textarea[_v-c86b45c6] {\n  max-width: 250px; }\n\n/* line 13, stdin */\n.form-head[_v-c86b45c6] {\n  text-align: right;\n  padding-right: 0; }\n\n/* line 17, stdin */\n.lock_info[_v-c86b45c6] {\n  color: #FC5A5A; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        merchantId: {
            default: null
        },
        merchant: {
            default: null
        }
    },
    data: function data() {
        return {
            status: 0,
            credit_fee: '',
            foreign_fee: '',
            allowForeignCard: 0,
            startAjax: false
        };
    },
    mounted: function mounted() {},

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId', 'isBranch', 'isSeventeen'])),
    methods: {
        edit: function edit(merchant) {
            this.status = merchant.status;
            this.allowForeignCard = merchant.allow_foreign_card;
            if (merchant.status != 0) {
                var vm = this;
                merchant.fees.forEach(function (item) {
                    switch (item.payment_code) {
                        case 0:
                            //信用卡一次付清金流手續費
                            vm.credit_fee = item.fee;
                            break;
                        case 8:
                            //國外信用卡金流手續費
                            vm.foreign_fee = item.fee;
                            break;
                    }
                });
            }

            $(this.$el).modal('show');
        },
        clear: function clear() {
            this.status = 0;
            this.credit_fee = '';
            this.foreign_fee = '';
            this.allowForeignCard = 0;
        },
        submit: function submit() {
            var _this = this;

            this.startAjax = true;
            var postData = {};

            postData['fees'] = [{ payment_code: 0, fee: this.credit_fee / 100 }, //payment_code=0=信用卡一次付清
            { payment_code: 8, fee: this.foreign_fee / 100 }];

            postData['allow_foreign_card'] = this.allowForeignCard;

            this.$http.put('/adminapi/merchant/send_modify/' + this.merchantId, postData).then(function (response) {
                _this.startAjax = false;
                var resData = response.data;
                $17.swal({
                    title: '提交成功',
                    text: "",
                    type: 'success',
                    showCancelButton: false
                });
                $(_this.$el).modal('hide');
                _this.$emit('updated-credit');
            }).catch(function (response) {
                _this.startAjax = false;
                var message = response.data.message ? response.data.message : '提交失敗';
                $17.swal({
                    text: message,
                    type: 'warning',
                    showCancelButton: false
                });
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal id=\"edit-credit-card-modal\" :save-clicked=\"submit\" close-btn-text=\"取消\" confirm-btn-text=\"儲存\" :close-modal-event=\"clear\" :locked=\"startAjax\" _v-c86b45c6=\"\">\n    <span slot=\"title\" _v-c86b45c6=\"\">金流手續費設定</span>\n    <template slot=\"body\">\n        <v-spinner :ajaxing=\"startAjax\" _v-c86b45c6=\"\"></v-spinner>\n        <div v-show=\"!startAjax\" _v-c86b45c6=\"\">\n            <div class=\"row m-top-25\" _v-c86b45c6=\"\">\n                <div class=\"col-sm-12\" _v-c86b45c6=\"\">\n                    <p _v-c86b45c6=\"\">藍新金流算法：若有小數點，取小數點後兩位，ex. 2.22</p>\n                </div>\n            </div>\n            <div class=\"row st-mt-6 st-ml-1 st-space-y-2\" _v-c86b45c6=\"\">\n                <div class=\"st-flex st-flex-wrap st-items-center\" _v-c86b45c6=\"\">\n                    <div class=\"st-mr-2\" _v-c86b45c6=\"\">一般信用卡金流手續費：</div>\n                    <div class=\"st-flex\" _v-c86b45c6=\"\">\n                        <input type=\"number\" step=\"0.01\" min=\"0\" v-model=\"credit_fee\" class=\"st-w-1/2 st-px-2 st-py-1\" _v-c86b45c6=\"\">\n                        <span class=\"input-group-btn\" _v-c86b45c6=\"\"><span class=\"btn btn-default\" _v-c86b45c6=\"\">%</span></span>\n                    </div>\n                </div>\n                <hr _v-c86b45c6=\"\">\n                <div class=\"st-flex st-flex-wrap st-items-center \" _v-c86b45c6=\"\">\n                    <label for=\"allow_foreign_card\" class=\"st-mt-2\" _v-c86b45c6=\"\">\n                    <input type=\"checkbox\" :true-value=\"1\" :false-value=\"0\" id=\"allow_foreign_card\" v-model=\"allowForeignCard\" _v-c86b45c6=\"\">\n                    啟用國外卡\n                    </label>\n                </div>\n                <div class=\"st-flex st-flex-wrap st-items-center\" v-show=\"allowForeignCard\" _v-c86b45c6=\"\">\n                    <div class=\"st-mr-2\" _v-c86b45c6=\"\">國外信用卡金流手續費：</div>\n                    <div class=\"st-flex\" _v-c86b45c6=\"\">\n                        <input type=\"number\" step=\"0.01\" min=\"0\" v-model=\"foreign_fee\" class=\"st-w-1/2 st-px-2 st-py-1\" _v-c86b45c6=\"\">\n                        <span class=\"input-group-btn\" _v-c86b45c6=\"\"><span class=\"btn btn-default\" _v-c86b45c6=\"\">%</span></span>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </template>\n</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 3, stdin */\nform input[_v-c86b45c6] {\n  max-width: 90px;\n  padding: 7px 12px; }\n\n/* line 8, stdin */\nform textarea[_v-c86b45c6] {\n  max-width: 250px; }\n\n/* line 13, stdin */\n.form-head[_v-c86b45c6] {\n  text-align: right;\n  padding-right: 0; }\n\n/* line 17, stdin */\n.lock_info[_v-c86b45c6] {\n  color: #FC5A5A; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-c86b45c6", module.exports)
  } else {
    hotAPI.update("_v-c86b45c6", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1231:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 3, stdin */\nform input[_v-b6b633b8] {\n  max-width: 90px;\n  padding: 7px 12px; }\n\n/* line 8, stdin */\nform textarea[_v-b6b633b8] {\n  max-width: 250px; }\n\n/* line 13, stdin */\n.form-head[_v-b6b633b8] {\n  text-align: right;\n  padding-right: 0; }\n\n/* line 17, stdin */\n.lock_info[_v-b6b633b8] {\n  color: #FC5A5A; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        merchantId: {
            default: null
        },
        merchant: {
            default: null
        }
    },
    data: function data() {
        return {
            status: 0,
            isLockCheckoutBy17fit: 0,
            isLockCheckoutByStudio: 0,
            startAjax: false,
            paymentTypeEnum: 0,
            title: ''
        };
    },
    mounted: function mounted() {},

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId', 'isBranch', 'isSeventeen'])),
    methods: {
        edit: function edit(config) {
            this.title = config.title;
            this.status = config.status;
            this.paymentTypeEnum = config.paymentTypeEnum;
            this.isLockCheckoutBy17fit = config.isLockCheckoutBy17fit;
            this.isLockCheckoutByStudio = config.isLockCheckoutByStudio;

            $(this.$el).modal('show');
        },
        clear: function clear() {
            this.title = '';
            this.status = 0;
            this.paymentTypeEnum = 0;
            this.isLockCheckoutBy17fit = 0;
            this.isLockCheckoutByStudio = 0;
        },
        submit: function submit() {
            var _this = this;

            this.startAjax = true;
            var postData = {};

            postData['is_lock_checkout_by_studio'] = this.isLockCheckoutByStudio;
            postData['payment_type_enum'] = this.paymentTypeEnum;

            if (this.isSeventeen) {
                postData['is_lock_checkout_by_17fit'] = this.isLockCheckoutBy17fit;
            }

            this.$http.post('/adminapi/merchant/change-active-data/' + this.merchantId, postData).then(function (response) {
                _this.startAjax = false;
                var resData = response.data;
                $17.swal({
                    title: '提交成功',
                    text: "",
                    type: 'success',
                    showCancelButton: false
                });
                $(_this.$el).modal('hide');
                _this.$emit('updated-credit');
            }).catch(function (response) {
                _this.startAjax = false;
                var message = response.data.message ? response.data.message : '提交失敗';
                $17.swal({
                    text: message,
                    type: 'warning',
                    showCancelButton: false
                });
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal id=\"edit-credit-card-modal\" :save-clicked=\"submit\" close-btn-text=\"取消\" confirm-btn-text=\"儲存\" :close-modal-event=\"clear\" :locked=\"startAjax\" _v-b6b633b8=\"\">\n    <span slot=\"title\" _v-b6b633b8=\"\">{{title}}</span>\n    <template slot=\"body\">\n        <v-spinner :ajaxing=\"startAjax\" _v-b6b633b8=\"\"></v-spinner>\n        <div v-show=\"!startAjax\" _v-b6b633b8=\"\">\n            <div class=\"row\" v-if=\"isSeventeen\" _v-b6b633b8=\"\">\n                <div class=\"col-sm-12\" _v-b6b633b8=\"\">\n                    <label for=\"is_lock_checkout_by_17fit\" _v-b6b633b8=\"\">\n                    <input type=\"checkbox\" :true-value=\"1\" :false-value=\"0\" id=\"is_lock_checkout_by_17fit\" v-model=\"isLockCheckoutBy17fit\" _v-b6b633b8=\"\">\n                    以 17FIT 角色停用此交易方式\n                    </label>\n                    \n                </div>\n                <div class=\"col-sm-12\" v-if=\"isLockCheckoutBy17fit==1\" _v-b6b633b8=\"\">\n                    <small class=\"lock_info\" _v-b6b633b8=\"\">\n                        *請注意！一但儲存完成，此場館的線上功能將立即被停用。\n                    </small>\n                </div>\n            </div>\n            <hr v-if=\"isSeventeen\" _v-b6b633b8=\"\">\n            <div _v-b6b633b8=\"\">\n                <span class=\"active-type\" _v-b6b633b8=\"\">開通狀態</span>\n                <span class=\"btn-status m-left-5\" _v-b6b633b8=\"\">\n                    <span class=\"label label-warning\" v-if=\"status==2\" _v-b6b633b8=\"\">審核中</span>\n                    <span class=\"label label-success\" v-else-if=\"status==1\" _v-b6b633b8=\"\">已開通</span>\n                    <span class=\"label label-danger\" v-else-if=\"status==3\" _v-b6b633b8=\"\">開通失敗</span>\n                    <span class=\"label label-default\" v-else=\"\" _v-b6b633b8=\"\">尚未開通</span>\n                </span>\n            </div>\n            <hr _v-b6b633b8=\"\">\n            <div class=\"row\" _v-b6b633b8=\"\">\n                <div class=\"col-sm-12\" _v-b6b633b8=\"\">\n                    <label for=\"is_lock_checkout_by_studio\" _v-b6b633b8=\"\">\n                    <input type=\"checkbox\" :true-value=\"0\" :false-value=\"1\" :disabled=\"isSeventeen\" id=\"is_lock_checkout_by_studio\" v-model=\"isLockCheckoutByStudio\" _v-b6b633b8=\"\">\n                    啟用狀態\n                    </label>\n                </div>\n            </div>\n        </div>\n    </template>\n</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 3, stdin */\nform input[_v-b6b633b8] {\n  max-width: 90px;\n  padding: 7px 12px; }\n\n/* line 8, stdin */\nform textarea[_v-b6b633b8] {\n  max-width: 250px; }\n\n/* line 13, stdin */\n.form-head[_v-b6b633b8] {\n  text-align: right;\n  padding-right: 0; }\n\n/* line 17, stdin */\n.lock_info[_v-b6b633b8] {\n  color: #FC5A5A; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-b6b633b8", module.exports)
  } else {
    hotAPI.update("_v-b6b633b8", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1232:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.radio-margin + .radio-margin[_v-0158947a] {\n  margin-left: 10px; }\n\n/* line 6, stdin */\ninput[_v-0158947a],\ntextarea[_v-0158947a],\nselect[_v-0158947a] {\n  max-width: 500px; }\n\n/* line 12, stdin */\n.input-group input[_v-0158947a] {\n  max-width: inherit; }\n\n/* line 16, stdin */\n.input-group[_v-0158947a] {\n  max-width: 150px; }\n\n/* line 20, stdin */\nspan.label[_v-0158947a] {\n  font-size: 14px;\n  margin-left: 30px; }\n\n/* line 25, stdin */\nspan.attention[_v-0158947a] {\n  color: red;\n  font-weight: 700; }\n\n/* line 30, stdin */\n.p-t-0[_v-0158947a] {\n  padding-top: 0 !important; }\n\n/* line 34, stdin */\ntextarea[_v-0158947a] {\n  margin: 0; }\n\n/* line 38, stdin */\n#finish-form[_v-0158947a] {\n  margin-top: 50px; }\n\n/* line 42, stdin */\n.modify-fee[_v-0158947a] {\n  margin: 50px 0; }\n\n/* line 46, stdin */\n.form-group.modify[_v-0158947a] {\n  padding-bottom: 20px; }\n\n/* line 50, stdin */\ninput[type=\"range\"][_v-0158947a] {\n  -webkit-appearance: none;\n  width: 100%;\n  border: none;\n  -webkit-appearance: slider-horizontal;\n     -moz-appearance: slider-horizontal;\n          appearance: slider-horizontal;\n  color: -internal-light-dark(#101010, white);\n  cursor: default;\n  padding: initial;\n  border: initial;\n  margin: 2px; }\n")
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require("vuex");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    merchantData: {},
    odvSettingData: []
  },
  data: function data() {
    return {
      startAjax: false,
      credit_fee: "",
      foreign_fee: "",
      default_credit_limit: {
        value: 1000000, //range bar 顯示預設一百萬
        max: 3000000, //上限三百萬
        min: 200000 //下限 200000
      },
      odvSettings: [],
      merchant: {
        type: "pay2go",
        branch_id: "",
        id: "",
        status: "",
        hash_key: "",
        hash_iv: "",
        is_company: "",
        member_name: "",
        member_phone: "",
        member_address: "",
        manager_name: "",
        manager_name_e: "",
        login_account: "",
        manager_mobile: "",
        manager_email: "",
        dispute_mail: "",
        merchant_email: "",
        merchant_id: "",
        merchant_name: "",
        merchant_name_e: "",
        merchant_web_url: "",
        merchant_addr_city: "",
        merchant_addr_area: "",
        merchant_addr: "",
        national_e: "",
        city_e: "",
        merchant_type: "",
        business_type: "",
        merchant_desc: "",
        bank_code: "",
        sub_bank_code: "",
        bank_account: "",
        credit_limit: "",
        fees: {},
        allow_foreign_card: 0,
        foreign_card_had_enable: 0,
        odv_setting_id: 1,
        is_lock_checkout_by_17fit: 0,
        is_lock_checkout_by_studio: 0,
        manager_id: "",
        manager_id_type: 1,
        id_card_date: "",
        id_card_place: "",
        id_from: 1,
        id_pic: "",
        personal_unified: "",
        company_unified: "",
        represent_name: "",
        capital_amount: "",
        incorporation_date: "",
        company_address: "",
        birthday: "",
        ARC_exp: "",
        ARC_srlno: "",
        passport_exp: "",
        represent_CPAdd: "",
        represent_capital_amt: "",
        represent_manager_name: "",
        merchant_en_addr: ""
      },
      cities: {},
      areas: {}
    };
  },

  watch: {
    merchantData: {
      handler: function handler(newValue, oldValue) {
        this.merchant = newValue;
      },

      deep: true
    },
    odvSettings: {
      handler: function handler(newValue, oldValue) {
        this.odvSettings = newValue;
      },

      deep: true
    },
    "merchant.merchant_addr_city": function merchantMerchant_addr_city(value) {
      var _this = this;

      this.$http.get("/api/cities").then(function (response) {
        _this.cities = [{ id: 0, name: "請選擇" }].concat(response.data);
        _this.getAreas(value);
      });
    },
    "merchant.fees": function merchantFees(value) {
      if (this.merchant.status != 0) {
        var vm = this;
        this.merchant.fees.forEach(function (item) {
          switch (item.payment_code) {
            case 0:
              //信用卡一次付清金流手續費
              vm.credit_fee = item.fee;
              break;
            case 8:
              //國外信用卡金流手續費
              vm.foreign_fee = item.fee;
              break;
          }
        });
      }
    }
  },
  mounted: function mounted() {
    this.merchant = this.merchantData;
    this.odvSettings = this.odvSettingData;
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapState)("webadmin/configure", ["studioId", "branchId", "isBranch", "isSeventeen"]), {
    format_credit_limit: function format_credit_limit() {
      return new Intl.NumberFormat().format(this.merchant.credit_limit);
    }
  }),
  methods: {
    getAreas: function getAreas(cityId) {
      var _this2 = this;

      this.$http.get("/api/districts/" + cityId).then(function (response) {
        _this2.areas = [{ id: 0, name: "請選擇" }].concat(response.data);
      });
    },
    store: function store() {
      var _this3 = this;

      if (this.merchant.manager_id_type == 5) {
        this.merchant.company_unified = this.merchant.manager_id;
      }

      if (this.merchant.manager_id_type == 0) {
        this.merchant.is_company = 0;
      } else {
        this.merchant.is_company = 1;
      }

      if (this.postVerify(this.merchant)) {
        this.startAjax = true;
        this.$http.put("/adminapi/merchant/update/" + this.merchant.id, (0, _stringify2.default)(this.merchant)).then(function (response) {
          _this3.startAjax = false;
          $17.swal({
            title: "若儲存後確認資料無誤，請通知 17FIT 人員協助後續提交申請處理。",
            text: "",
            type: "success",
            showCancelButton: false
          });
          _this3.$emit("merchant-update", _this3.merchant);
        }).catch(function (response) {
          _this3.startAjax = false;
          $17.swal({
            title: "儲存失敗",
            text: "",
            type: "warning",
            showCancelButton: false
          });
        });
      }
    },
    postVerify: function postVerify(postData) {
      var check = true;
      if (postData.manager_id_type != 0) {
        if (postData.manager_id === "" || postData.represent_name === "" || postData.capital_amount === "" || postData.incorporation_date === "" || postData.company_address === "") {
          $17.swal({
            title: "欄位為必填",
            text: "代表人證號，代表人姓名，實收資本額，核准設立日期，公司登記地址欄位需必填。",
            type: "warning",
            showCancelButton: false
          });
          check = false;
        }
      }
      if (postData.manager_id_type == 0 || postData.manager_id_type == 1) {
        if (postData.id_card_date === "" || postData.id_card_place === "" || postData.id_from === "" || postData.birthday === "") {
          $17.swal({
            title: "欄位為必填",
            text: "發證日期，身分證發證地點，身分證領補換，出生年月日。",
            type: "warning",
            showCancelButton: false
          });
          check = false;
        }
      }

      if (postData.manager_id_type == 2) {
        if (postData.id_card_date === "" || postData.birthday === "" || postData.ARC_exp === "" || postData.ARC_srlno === "") {
          $17.swal({
            title: "欄位為必填",
            text: "出生年月日，發證日期，居留證到期日，居留證背面序號。",
            type: "warning",
            showCancelButton: false
          });
          check = false;
        }
      }

      if (postData.manager_id_type == 3) {
        if (postData.birthday === "" || postData.passport_exp === "" || postData.ARC_srlno === "") {
          $17.swal({
            title: "欄位為必填",
            text: "出生年月日，護照到期日。",
            type: "warning",
            showCancelButton: false
          });
          check = false;
        }
      }

      if (postData.manager_id_type == 5) {
        if (postData.id_card_date === "" || postData.represent_CPAdd === "" || postData.represent_capital_amt === "" || postData.represent_manager_name === "") {
          $17.swal({
            title: "欄位為必填",
            text: "發證日期，法人登記地址，法人登記地址，法人實收資本額，法人公司代表人名稱。",
            type: "warning",
            showCancelButton: false
          });
          check = false;
        }
      }

      if (postData.manager_id_type == 6) {
        if (postData.id_card_date === "") {
          $17.swal({
            title: "欄位為必填",
            text: "發證日期。",
            type: "warning",
            showCancelButton: false
          });
          check = false;
        }
      }

      if ([2].indexOf(postData.manager_id_type) > -1 && this.validDate(postData.id_card_date, "發證日期") == false) {
        check = false;
      }

      if ([0, 1].indexOf(postData.manager_id_type) > -1 && this.validDate(this.convertMinguoToGregorian(postData.id_card_date), "發證日期") == false) {
        check = false;
      }

      if ([5, 6].indexOf(postData.manager_id_type) > -1 && this.validDate(postData.id_card_date, "法人公司的核准設立日期") == false) {
        check = false;
      }

      if ([0, 1, 2, 3].indexOf(postData.manager_id_type) > -1 && this.validDate(postData.birthday, "出生年月日") == false) {
        check = false;
      }
      if (postData.manager_id_type != 0 && this.validDate(postData.incorporation_date, "核准設立日期") == false) {
        check = false;
      }
      if (postData.manager_id_type == 2 && postData.ARC_exp != "00000000" && this.validDate(postData.ARC_exp, "居留證到期日") == false) {
        check = false;
      }
      if (postData.manager_id_type == 3 && this.validDate(postData.passport_exp, "護照到期日") == false) {
        check = false;
      }

      return check;
    },
    sendCreate: function sendCreate() {
      var _this4 = this;

      if (this.merchant.credit_limit < this.default_credit_limit.min || this.merchant.credit_limit > this.default_credit_limit.max) {
        $17.swal({
          text: "信用卡 30 天收款額度需介於" + this.default_credit_limit.min + "~" + this.default_credit_limit.max,
          type: "warning",
          showCancelButton: false
        });
        return false;
      }
      this.startAjax = true;
      this.$http.put("/adminapi/merchant/send_create/" + this.merchant.id, (0, _stringify2.default)(this.merchant)).then(function (response) {
        var resData = response.data;
        _this4.merchant.status = resData.status;
        _this4.merchant.hash_key = resData.hash_key;
        _this4.merchant.hash_iv = resData.hash_iv;
        _this4.merchant.credit_limit = resData.credit_limit;
        _this4.merchant.allow_foreign_card = resData.allow_foreign_card;
        _this4.merchant.fees = resData.fees;
        _this4.startAjax = false;
        $17.swal({
          title: "提交成功",
          text: "",
          type: "success",
          showCancelButton: false
        });
        _this4.$emit("fresh");
      }).catch(function (response) {
        var message = response.data.message ? response.data.message : "提交失敗";
        _this4.startAjax = false;
        $17.swal({
          text: message,
          type: "warning",
          showCancelButton: false
        });
      });
    },
    getCheckShowSetting: function getCheckShowSetting(type) {
      var showArray = {
        0: {
          manager_id: false,
          manager_id_type: false,
          id_card_date: true,
          id_card_place: true,
          id_from: true,
          id_pic: true,
          personal_unified: true,
          company_unified: false,
          represent_name: false,
          capital_amount: false,
          incorporation_date: false,
          company_address: false,
          birthday: true,
          ARC_exp: false,
          ARC_srlno: false,
          passport_exp: false,
          represent_CPAdd: false,
          represent_capital_amt: false,
          represent_manager_name: false
        },
        1: {
          manager_id: true,
          manager_id_type: true,
          id_card_date: true,
          id_card_place: true,
          id_from: true,
          id_pic: true,
          personal_unified: false,
          company_unified: true,
          represent_name: true,
          capital_amount: true,
          incorporation_date: true,
          company_address: true,
          birthday: true,
          ARC_exp: false,
          ARC_srlno: false,
          passport_exp: false,
          represent_CPAdd: false,
          represent_capital_amt: false,
          represent_manager_name: false
        },
        2: {
          manager_id: true,
          manager_id_type: true,
          id_card_date: true,
          id_card_place: false,
          id_from: false,
          id_pic: false,
          personal_unified: false,
          company_unified: true,
          represent_name: true,
          capital_amount: true,
          incorporation_date: true,
          company_address: true,
          birthday: true,
          ARC_exp: true,
          ARC_srlno: true,
          passport_exp: false,
          represent_CPAdd: false,
          represent_capital_amt: false,
          represent_manager_name: false
        },
        3: {
          manager_id: true,
          manager_id_type: true,
          id_card_date: false,
          id_card_place: false,
          id_from: false,
          id_pic: false,
          personal_unified: false,
          company_unified: true,
          represent_name: true,
          capital_amount: true,
          incorporation_date: true,
          company_address: true,
          birthday: true,
          ARC_exp: false,
          ARC_srlno: false,
          passport_exp: true,
          represent_CPAdd: false,
          represent_capital_amt: false,
          represent_manager_name: false
        },
        5: {
          manager_id: true,
          manager_id_type: true,
          id_card_date: true,
          id_card_place: false,
          id_from: false,
          id_pic: false,
          personal_unified: false,
          company_unified: false, //從manager_id 覆寫回來
          represent_name: true,
          capital_amount: true,
          incorporation_date: true,
          company_address: true,
          birthday: false,
          ARC_exp: false,
          ARC_srlno: false,
          passport_exp: false,
          represent_CPAdd: true,
          represent_capital_amt: true,
          represent_manager_name: true
        },
        6: {
          manager_id: true,
          manager_id_type: true,
          id_card_date: true,
          id_card_place: false,
          id_from: false,
          id_pic: false,
          personal_unified: false,
          company_unified: true,
          represent_name: true,
          capital_amount: true,
          incorporation_date: true,
          company_address: true,
          birthday: false,
          ARC_exp: false,
          ARC_srlno: false,
          passport_exp: false,
          represent_CPAdd: true,
          represent_capital_amt: true,
          represent_manager_name: true
        }
      };

      return showArray[type] || {};
    },
    checkNeedShow: function checkNeedShow(checkField) {
      var checkArr = this.getCheckShowSetting(this.merchant.manager_id_type);
      if (checkArr == {}) {
        return false;
      }
      return checkArr[checkField] || false;
    },
    validDate: function validDate(passportExp, alertText) {
      console.log(passportExp, alertText);
      if (passportExp !== "" && !moment(passportExp, "YYYYMMDD", true).isValid()) {
        $17.swal({
          title: "錯誤的日期",
          text: alertText,
          type: "warning",
          showCancelButton: false
        });
        return false;
      }

      return true;
    },
    convertMinguoToGregorian: function convertMinguoToGregorian(minguoInput) {
      var GREGORIAN_START_YEAR = 1911;
      var year = parseInt(minguoInput.substring(0, 3)) + GREGORIAN_START_YEAR;
      var month = minguoInput.substring(3, 5);
      var day = minguoInput.substring(5, 7);
      return "" + year + month + day;
    }
  }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"col-sm-12\" _v-0158947a=\"\">\n    <div _v-0158947a=\"\">\n        <form class=\"form-horizontal\" _v-0158947a=\"\">\n            <div class=\"form-group\" _v-0158947a=\"\">\n                <label class=\"col-sm-3 control-label\" _v-0158947a=\"\">身分類型 Identity type <v-required _v-0158947a=\"\"></v-required></label>\n                <div class=\"col-sm-9\" _v-0158947a=\"\">\n                    <select class=\"form-control\" v-model.number=\"merchant.manager_id_type\" _v-0158947a=\"\">\n                        <option value=\"0\" _v-0158947a=\"\">個人 Personal</option>\n                        <option value=\"1\" _v-0158947a=\"\">企業 - 代表人為本國自然人 Citizen of Taiwan</option>\n                        <option value=\"2\" _v-0158947a=\"\">企業 - 代表人為外國自然人 Foreign national</option>\n                        <option value=\"3\" _v-0158947a=\"\">企業 - 代表人為外國籍無居留證者 Foreign national without a residence permit</option>\n                        <option value=\"5\" _v-0158947a=\"\">企業 - 代表人為本國法人 Domestic corporation</option>\n                        <option value=\"6\" _v-0158947a=\"\">企業 - 代表人為外國法人 Foreign corporation</option>\n                    </select>\n                </div>\n            </div>\n\n            <div _v-0158947a=\"\">\n                <div class=\"form-group\" v-show=\"checkNeedShow('personal_unified')\" _v-0158947a=\"\">\n                    <label class=\"col-sm-3 control-label\" _v-0158947a=\"\">身分證字號 ID number    \n                    <v-required _v-0158947a=\"\"></v-required></label>\n                    <div class=\"col-sm-9\" _v-0158947a=\"\">\n                        <input type=\"text\" v-model=\"merchant.personal_unified\" class=\"form-control\" _v-0158947a=\"\">\n                    </div>\n                </div>\n                <div class=\"form-group\" v-show=\"checkNeedShow('manager_id')\" _v-0158947a=\"\">\n                    <label class=\"col-sm-3 control-label\" _v-0158947a=\"\">\n                        <span v-if=\"merchant.manager_id_type==1\" _v-0158947a=\"\">\n                          身分證字號 ID Card number\n                        </span>\n                        <span v-if=\"merchant.manager_id_type==2\" _v-0158947a=\"\">\n                          居留證號碼 Residence permit number\n                        </span>\n                        <span v-if=\"merchant.manager_id_type==3\" _v-0158947a=\"\">\n                          稅籍編號 Logic serial number (LOSN)\n                        </span>\n                        <span v-if=\"merchant.manager_id_type==5\" _v-0158947a=\"\">\n                          統一編號 Tax ID number\n                        </span>\n                        <span v-if=\"merchant.manager_id_type==6\" _v-0158947a=\"\">\n                          登記證號 Registered Number\n                        </span>\n                        <v-required _v-0158947a=\"\"></v-required>\n                    </label>\n                    <div class=\"col-sm-9\" _v-0158947a=\"\">\n                        <input type=\"text\" v-model=\"merchant.manager_id\" class=\"form-control\" _v-0158947a=\"\">\n                    </div>\n                </div>\n                <div class=\"form-group\" v-show=\"checkNeedShow('id_card_date')\" _v-0158947a=\"\">\n                    <label class=\"col-sm-3 control-label\" _v-0158947a=\"\">\n                        <span v-if=\"merchant.manager_id_type==0||merchant.manager_id_type==1\" _v-0158947a=\"\">\n                          身分證發證日期 ID Card date\n                        </span>\n                        <span v-if=\"merchant.manager_id_type==2\" _v-0158947a=\"\">\n                          居留證發證日期 Residence permit date\n                        </span>\n                        <span v-if=\"merchant.manager_id_type==5||merchant.manager_id_type==6\" _v-0158947a=\"\">\n                            法人公司的核准設立日期 Date of incorporation\n                        </span>\n                        <v-required _v-0158947a=\"\"></v-required>\n                    </label>\n                    <div class=\"col-sm-9\" _v-0158947a=\"\">\n                        <input type=\"text\" maxlength=\"8\" v-model=\"merchant.id_card_date\" class=\"form-control\" _v-0158947a=\"\">\n                        <span class=\"help-block\" v-if=\"merchant.manager_id_type==0|| merchant.manager_id_type==1\" _v-0158947a=\"\">\n                          民國年月日 ex. 1050515 (YYYMMDD)\n                        </span>\n                        <span class=\"help-block\" v-else=\"\" _v-0158947a=\"\">\n                            ex. 20190515 (YYYYMMDD)\n                        </span>\n                    </div>\n                </div>\n                <div class=\"form-group\" v-show=\"checkNeedShow('id_card_place')\" _v-0158947a=\"\">\n                    <label class=\"col-sm-3 control-label\" _v-0158947a=\"\">\n                        身分發證地點 ID Card place\n                        <v-required _v-0158947a=\"\"></v-required>\n                    </label>\n                    <div class=\"col-sm-9\" _v-0158947a=\"\">\n                        <select v-model=\"merchant.id_card_place\" class=\"form-control\" _v-0158947a=\"\">\n                            <option value=\"\" _v-0158947a=\"\">請選擇</option>\n                            <option value=\"基市\" _v-0158947a=\"\">基市</option>\n                            <option value=\"北市\" _v-0158947a=\"\">北市</option>\n                            <option value=\"新北市\" _v-0158947a=\"\">新北市</option>\n                            <option value=\"北縣\" _v-0158947a=\"\">北縣</option>\n                            <option value=\"桃市\" _v-0158947a=\"\">桃市</option>\n                            <option value=\"桃縣\" _v-0158947a=\"\">桃縣</option>\n                            <option value=\"竹市\" _v-0158947a=\"\">竹市</option>\n                            <option value=\"竹縣\" _v-0158947a=\"\">竹縣</option>\n                            <option value=\"苗縣\" _v-0158947a=\"\">苗縣</option>\n                            <option value=\"中市\" _v-0158947a=\"\">中市</option>\n                            <option value=\"中縣\" _v-0158947a=\"\">中縣</option>\n                            <option value=\"彰縣\" _v-0158947a=\"\">彰縣</option>\n                            <option value=\"投縣\" _v-0158947a=\"\">投縣</option>\n                            <option value=\"雲縣\" _v-0158947a=\"\">雲縣</option>\n                            <option value=\"嘉市\" _v-0158947a=\"\">嘉市</option>\n                            <option value=\"嘉縣\" _v-0158947a=\"\">嘉縣</option>\n                            <option value=\"南市\" _v-0158947a=\"\">南市</option>\n                            <option value=\"南縣\" _v-0158947a=\"\">南縣</option>\n                            <option value=\"高市\" _v-0158947a=\"\">高市</option>\n                            <option value=\"高縣\" _v-0158947a=\"\">高縣</option>\n                            <option value=\"屏縣\" _v-0158947a=\"\">屏縣</option>\n                            <option value=\"宜縣\" _v-0158947a=\"\">宜縣</option>\n                            <option value=\"花縣\" _v-0158947a=\"\">花縣</option>\n                            <option value=\"東縣\" _v-0158947a=\"\">東縣</option>\n                            <option value=\"連江\" _v-0158947a=\"\">連江</option>\n                            <option value=\"金門\" _v-0158947a=\"\">金門</option>\n                            <option value=\"澎縣\" _v-0158947a=\"\">澎縣</option>\n                        </select>\n                    </div>\n                </div>\n                <div class=\"form-group\" v-show=\"checkNeedShow('id_from')\" _v-0158947a=\"\">\n                    <label class=\"col-sm-3 control-label\" _v-0158947a=\"\">\n                        身分證領補換  ID Card form\n                        <v-required _v-0158947a=\"\"></v-required>\n                    </label>\n                    <div class=\"col-sm-9\" _v-0158947a=\"\">\n                        <label class=\"radio-margin\" _v-0158947a=\"\">\n                            <input type=\"radio\" v-model=\"merchant.id_from\" value=\"1\" _v-0158947a=\"\"> 初發 Initial issue\n                        </label>\n                        <label class=\"radio-margin\" _v-0158947a=\"\">\n                            <input type=\"radio\" v-model=\"merchant.id_from\" value=\"2\" _v-0158947a=\"\"> 補證 Re-issuance\n                        </label>\n                        <label class=\"radio-margin\" _v-0158947a=\"\">\n                            <input type=\"radio\" v-model=\"merchant.id_from\" value=\"3\" _v-0158947a=\"\"> 換發 Renewal\n                        </label>\n                    </div>\n                </div>\n                <div class=\"form-group\" v-show=\"checkNeedShow('ARC_exp')\" _v-0158947a=\"\">\n                    <label class=\"col-sm-3 control-label\" _v-0158947a=\"\">\n                        居留證到期日 Expiry date of residence permit\n                        <v-required _v-0158947a=\"\"></v-required>\n                    </label>\n                    <div class=\"col-sm-9\" _v-0158947a=\"\">\n                        <input type=\"text\" maxlength=\"8\" v-model=\"merchant.ARC_exp\" class=\"form-control\" _v-0158947a=\"\">\n                        <span class=\"help-block\" _v-0158947a=\"\">\n                          ex. 20190515 (YYYYMMDD) 若為永久居留證 Permanent Residence，請填入 00000000\n                        </span>\n                    </div>\n                </div>\n                <div class=\"form-group\" v-show=\"checkNeedShow('ARC_srlno')\" _v-0158947a=\"\">\n                    <label class=\"col-sm-3 control-label\" _v-0158947a=\"\">\n                        居留證背面序號 Residence permit number\n                        <v-required _v-0158947a=\"\"></v-required>\n                    </label>\n                    <div class=\"col-sm-9\" _v-0158947a=\"\">\n                        <input type=\"text\" v-model=\"merchant.ARC_srlno\" class=\"form-control\" _v-0158947a=\"\">\n                    </div>\n                </div>\n                <div class=\"form-group\" v-show=\"checkNeedShow('birthday')\" _v-0158947a=\"\">\n                    <label class=\"col-sm-3 control-label\" _v-0158947a=\"\">\n                        出生年月日 Birth date\n                        <v-required _v-0158947a=\"\"></v-required>\n                    </label>\n                    <div class=\"col-sm-9\" _v-0158947a=\"\">\n                        <input type=\"text\" maxlength=\"8\" v-model=\"merchant.birthday\" class=\"form-control\" _v-0158947a=\"\">\n                        <span class=\"help-block\" _v-0158947a=\"\">\n                          ex. 20190515 (YYYYMMDD)\n                        </span>\n                    </div>\n                </div>\n                <div class=\"form-group\" v-show=\"checkNeedShow('passport_exp')\" _v-0158947a=\"\">\n                    <label class=\"col-sm-3 control-label\" _v-0158947a=\"\">\n                        護照到期日 Expiry date of passport\n                        <v-required _v-0158947a=\"\"></v-required>\n                    </label>\n                    <div class=\"col-sm-9\" _v-0158947a=\"\">\n                        <input type=\"text\" maxlength=\"8\" v-model=\"merchant.passport_exp\" class=\"form-control\" _v-0158947a=\"\">\n                        <span class=\"help-block\" _v-0158947a=\"\">\n                          ex. 20190515 (YYYYMMDD)\n                        </span>\n                    </div>\n                </div>\n                <div class=\"form-group\" v-show=\"checkNeedShow('represent_manager_name')\" _v-0158947a=\"\">\n                    <label class=\"col-sm-3 control-label\" _v-0158947a=\"\">\n                        法人公司代表人名稱 Legal representative name\n                        <v-required v-if=\"merchant.manager_id_type==5\" _v-0158947a=\"\"></v-required>\n                    </label>\n                    <div class=\"col-sm-9\" _v-0158947a=\"\">\n                        <input type=\"text\" v-model=\"merchant.represent_manager_name\" class=\"form-control\" _v-0158947a=\"\">\n                        <span class=\"help-block\" _v-0158947a=\"\">\n                            填入法人公司的代表人中文姓名，若該法人代表為外國籍，無中文姓名，請帶入英文姓名\n                        </span>\n                    </div>\n                </div>\n                <div class=\"form-group\" v-show=\"checkNeedShow('represent_CPAdd')\" _v-0158947a=\"\">\n                    <label class=\"col-sm-3 control-label\" _v-0158947a=\"\">\n                        法人登記地址 Registered address of the corporation\n                        <v-required v-if=\"merchant.manager_id_type==5\" _v-0158947a=\"\"></v-required>\n                    </label>\n                    <div class=\"col-sm-9\" _v-0158947a=\"\">\n                        <input type=\"text\" v-model=\"merchant.represent_CPAdd\" class=\"form-control\" _v-0158947a=\"\">\n                    </div>\n                </div>\n                <div class=\"form-group\" v-show=\"checkNeedShow('represent_capital_amt')\" _v-0158947a=\"\">\n                    <label class=\"col-sm-3 control-label\" _v-0158947a=\"\">\n                        法人實收資本額 Paid-in capital of the corporation\n                        <v-required v-if=\"merchant.manager_id_type==5\" _v-0158947a=\"\"></v-required>\n                    </label>\n                    <div class=\"col-sm-9\" _v-0158947a=\"\">\n                        <input type=\"number\" v-model=\"merchant.represent_capital_amt\" class=\"form-control\" _v-0158947a=\"\">\n                    </div>\n                </div>\n                <div class=\"form-group\" v-show=\"checkNeedShow('company_unified')\" _v-0158947a=\"\">\n                    <label class=\"col-sm-3 control-label\" _v-0158947a=\"\">\n                        統一編號 Tax ID number\n                        <v-required _v-0158947a=\"\"></v-required>\n                    </label>\n                    <div class=\"col-sm-9\" _v-0158947a=\"\">\n                        <input type=\"text\" v-model=\"merchant.company_unified\" class=\"form-control\" _v-0158947a=\"\">\n                    </div>\n                </div>\n                <div class=\"form-group\" v-show=\"checkNeedShow('represent_name')\" _v-0158947a=\"\">\n                    <label class=\"col-sm-3 control-label\" _v-0158947a=\"\">\n                        代表人姓名 Represent name\n                        <v-required _v-0158947a=\"\"></v-required>\n                    </label>\n                    <div class=\"col-sm-9\" _v-0158947a=\"\">\n                    <input type=\"text\" v-model=\"merchant.represent_name\" class=\"form-control\" placeholder=\"企業代表人姓名\" _v-0158947a=\"\">\n                    </div>\n                </div>\n                <div class=\"form-group\" v-show=\"checkNeedShow('capital_amount')\" _v-0158947a=\"\">\n                    <label class=\"col-sm-3 control-label\" _v-0158947a=\"\">\n                        實收資本額 Paid-in capital of the company\n                        <v-required _v-0158947a=\"\"></v-required>\n                    </label>\n                    <div class=\"col-sm-9\" _v-0158947a=\"\">\n                    <input type=\"text\" v-model=\"merchant.capital_amount\" class=\"form-control\" placeholder=\"請帶入企業登記之實收資本額，僅接受數字\" _v-0158947a=\"\">\n                    </div>\n                </div>\n                <div class=\"form-group\" v-show=\"checkNeedShow('incorporation_date')\" _v-0158947a=\"\">\n                    <label class=\"col-sm-3 control-label\" _v-0158947a=\"\">\n                        核准設立日期 Date of incorporation\n                        <v-required _v-0158947a=\"\"></v-required>\n                    </label>\n                    <div class=\"col-sm-9\" _v-0158947a=\"\">\n                    <input type=\"text\" v-model=\"merchant.incorporation_date\" class=\"form-control\" placeholder=\"20190515\" _v-0158947a=\"\">\n                    </div>\n                </div>\n                <div class=\"form-group\" v-show=\"checkNeedShow('company_address')\" _v-0158947a=\"\">\n                    <label class=\"col-sm-3 control-label\" _v-0158947a=\"\">\n                        公司登記地址 Registered address of the company\n                        <v-required _v-0158947a=\"\"></v-required>\n                    </label>\n                    <div class=\"col-sm-9\" _v-0158947a=\"\">\n                    <input type=\"text\" v-model=\"merchant.company_address\" class=\"form-control\" placeholder=\"可接受中文、數字及”-“符號\" _v-0158947a=\"\">\n                    </div>\n                </div>\n                <div class=\"form-group\" v-show=\"merchant.manager_id_type!=0\" _v-0158947a=\"\">\n                    <label class=\"col-sm-3 control-label\" _v-0158947a=\"\">\n                        信用卡30天收款額度 Credit Card 30-Day Billing Limit\n                        <v-required _v-0158947a=\"\"></v-required>\n                    </label>\n                    <div class=\"col-sm-9\" _v-0158947a=\"\">\n                        <input v-model=\"merchant.credit_limit\" type=\"range\" :min=\"default_credit_limit.min\" :max=\"default_credit_limit.max\" step=\"100000\" _v-0158947a=\"\">\n                        <span class=\"help-block\" _v-0158947a=\"\">額度上限 {{format_credit_limit}}</span>\n                    </div>\n                </div>\n            </div>\n\n            <!--共同欄位-->\n            <div class=\"form-group\" _v-0158947a=\"\">\n                <label class=\"col-sm-3 control-label\" _v-0158947a=\"\">\n                    藍新會員名稱 Member name\n                    <v-required _v-0158947a=\"\"></v-required>\n                </label>\n                <div class=\"col-sm-9\" _v-0158947a=\"\">\n                    <input type=\"text\" v-model=\"merchant.member_name\" class=\"form-control\" placeholder=\"企業會員請提供公司登記之名稱 / 個人會員請提供身分證登記姓名\" _v-0158947a=\"\">\n                    <span class=\"help-block\" _v-0158947a=\"\">\n                    <span class=\"attention\" _v-0158947a=\"\">企業會員</span>請提供<span class=\"attention\" _v-0158947a=\"\">公司登記之名稱</span>，以 60 個字為限。<br _v-0158947a=\"\">\n                    <span class=\"attention\" _v-0158947a=\"\">個人會員</span>請提供<span class=\"attention\" _v-0158947a=\"\">身分證登記姓名</span>，以 20 個字為限。\n                </span>\n                </div>\n            </div>\n            <div class=\"form-group\" _v-0158947a=\"\">\n                <label class=\"col-sm-3 control-label\" _v-0158947a=\"\">\n                    會員電話 Member phone\n                    <v-required _v-0158947a=\"\"></v-required>\n                </label>\n                <div class=\"col-sm-9\" _v-0158947a=\"\">\n                    <input type=\"text\" v-model=\"merchant.member_phone\" class=\"form-control\" _v-0158947a=\"\">\n                    <span class=\"help-block\" _v-0158947a=\"\">\n                    可為市話或手機。例：0x-0000111 或 09xx-000111。\n                </span>\n                </div>\n            </div>\n            <div class=\"form-group\" _v-0158947a=\"\">\n                <label class=\"col-sm-3 control-label\" _v-0158947a=\"\">\n                    會員聯絡地址\n                    <v-required _v-0158947a=\"\"></v-required>\n                </label>\n                <div class=\"col-sm-9\" _v-0158947a=\"\">\n                    <input type=\"text\" v-model=\"merchant.member_address\" class=\"form-control\" _v-0158947a=\"\">\n                </div>\n            </div>\n            <div class=\"form-group\" _v-0158947a=\"\">\n                <label class=\"col-sm-3 control-label\" _v-0158947a=\"\">\n                    管理者中文姓名 Ｍanager Chinese name\n                    <v-required _v-0158947a=\"\"></v-required>\n                </label>\n                <div class=\"col-sm-9\" _v-0158947a=\"\">\n                    <input type=\"text\" v-model=\"merchant.manager_name\" class=\"form-control\" _v-0158947a=\"\">\n                    <span class=\"help-block\" _v-0158947a=\"\">\n                    為最高權限人員所持有，該人員即為本服務主要聯絡人，請正確填寫。\n                </span>\n                </div>\n            </div>\n            <div class=\"form-group\" _v-0158947a=\"\">\n                <label class=\"col-sm-3 control-label\" _v-0158947a=\"\">\n                    管理者英文姓名 Ｍanager English name\n                    <v-required _v-0158947a=\"\"></v-required>\n                </label>\n                <div class=\"col-sm-9\" _v-0158947a=\"\">\n                    <input type=\"text\" v-model=\"merchant.manager_name_e\" class=\"form-control\" _v-0158947a=\"\">\n                    <span class=\"help-block\" _v-0158947a=\"\">\n                    名 First name,姓 Last name ex. Xiao ming,Wang\n                </span>\n                </div>\n            </div>\n            <div class=\"form-group\" _v-0158947a=\"\">\n                <label class=\"col-sm-3 control-label\" _v-0158947a=\"\">\n                    管理者帳號 Newwebpay account\n                    <v-required _v-0158947a=\"\"></v-required>\n                </label>\n                <div class=\"col-sm-9\" _v-0158947a=\"\">\n                    <input type=\"text\" v-model=\"merchant.login_account\" class=\"form-control\" _v-0158947a=\"\">\n                    <span class=\"help-block\" _v-0158947a=\"\">\n                    限 20 個字。只接受英文、數字及「_」「 . 」「 @ 」，三種符號。\n                    </span>\n                </div>\n            </div>\n            <div class=\"form-group\" _v-0158947a=\"\">\n                <label class=\"col-sm-3 control-label\" _v-0158947a=\"\">\n                    管理者行動電話號碼 Manager's mobile\n                    <v-required _v-0158947a=\"\"></v-required>\n                </label>\n                <div class=\"col-sm-9\" _v-0158947a=\"\">\n                    <input type=\"text\" maxlength=\"10\" v-model=\"merchant.manager_mobile\" class=\"form-control\" _v-0158947a=\"\">\n                    <span class=\"help-block\" _v-0158947a=\"\">\n                    ex. 09XXXXYYYY\n                </span>\n                </div>\n            </div>\n            <div class=\"form-group\" _v-0158947a=\"\">\n                <label class=\"col-sm-3 control-label\" _v-0158947a=\"\">\n                    管理者 Email Manager's email\n                    <v-required _v-0158947a=\"\"></v-required>\n                </label>\n                <div class=\"col-sm-9\" _v-0158947a=\"\">\n                    <input type=\"email\" v-model=\"merchant.manager_email\" class=\"form-control\" _v-0158947a=\"\">\n                </div>\n            </div>\n            <div class=\"form-group\" _v-0158947a=\"\">\n                <label class=\"col-sm-3 control-label\" _v-0158947a=\"\">\n                    商店代號 Merchant ID\n                    <v-required _v-0158947a=\"\"></v-required>\n                </label>\n                <div class=\"col-sm-9\" _v-0158947a=\"\">\n                    <input type=\"text\" v-model=\"merchant.merchant_id\" class=\"form-control\" readonly=\"\" _v-0158947a=\"\">\n                </div>\n            </div>\n            <div class=\"form-group\" _v-0158947a=\"\">\n                <label class=\"col-sm-3 control-label\" _v-0158947a=\"\">\n                    商店中文名稱 Merchant Chinese name\n                    <v-required _v-0158947a=\"\"></v-required>\n                </label>\n                <div class=\"col-sm-9\" _v-0158947a=\"\">\n                    <input type=\"text\" v-model=\"merchant.merchant_name\" class=\"form-control\" readonly=\"\" _v-0158947a=\"\">\n                </div>\n            </div>\n            <div class=\"form-group\" _v-0158947a=\"\">\n                <label class=\"col-sm-3 control-label\" _v-0158947a=\"\">\n                    商店英文名稱 Merchant English name\n                    <v-required _v-0158947a=\"\"></v-required>\n                </label>\n                <div class=\"col-sm-9\" _v-0158947a=\"\">\n                    <input type=\"text\" v-model=\"merchant.merchant_name_e\" class=\"form-control\" readonly=\"\" _v-0158947a=\"\">\n                </div>\n            </div>\n            <div class=\"form-group\" _v-0158947a=\"\">\n                <label class=\"col-sm-3 control-label\" _v-0158947a=\"\">\n                    商店網址 Merchant website\n                    <v-required _v-0158947a=\"\"></v-required>\n                </label>\n                <div class=\"col-sm-9\" _v-0158947a=\"\">\n                    <input type=\"text\" v-model=\"merchant.merchant_web_url\" class=\"form-control\" readonly=\"\" _v-0158947a=\"\">\n                </div>\n            </div>\n            <div class=\"form-group\" _v-0158947a=\"\">\n                <label class=\"col-sm-3 control-label\" _v-0158947a=\"\">\n                    商店爭議款 Email Dispute mail\n                    <v-required _v-0158947a=\"\"></v-required>\n                </label>\n                <div class=\"col-sm-9\" _v-0158947a=\"\">\n                    <input type=\"email\" v-model=\"merchant.dispute_mail\" class=\"form-control\" _v-0158947a=\"\">\n                </div>\n            </div>\n            <div class=\"form-group\" _v-0158947a=\"\">\n                <label class=\"col-sm-3 control-label\" _v-0158947a=\"\">\n                    客服商店 Email Merchant mail\n                    <v-required _v-0158947a=\"\"></v-required>\n                </label>\n                <div class=\"col-sm-9\" _v-0158947a=\"\">\n                    <input type=\"text\" v-model=\"merchant.merchant_email\" class=\"form-control\" _v-0158947a=\"\">\n                    <span class=\"help-block\" _v-0158947a=\"\">\n                        可帶入多組信箱，請用[ , ]分隔，例：test@YYY.com,test2@YYY.com\n                    </span>\n                </div>\n            </div>\n            <div class=\"form-group\" _v-0158947a=\"\">\n                <label class=\"col-sm-3 control-label\" _v-0158947a=\"\">\n                    聯絡地址-城市  Contact City/Country\n                    <v-required _v-0158947a=\"\"></v-required>\n                </label>\n                <div class=\"col-sm-9\" _v-0158947a=\"\">\n                    <select v-model=\"merchant.merchant_addr_city\" class=\"form-control\" _v-0158947a=\"\">\n                        <option v-for=\"option in cities\" :value=\"option.id\" _v-0158947a=\"\">\n                            {{ option.name }}\n                        </option>\n                    </select>\n                </div>\n            </div>\n            <div class=\"form-group\" _v-0158947a=\"\">\n                <label class=\"col-sm-3 control-label\" _v-0158947a=\"\">\n                    聯絡地址-地區 Contact District\n                    <v-required _v-0158947a=\"\"></v-required>\n                </label>\n                <div class=\"col-sm-9\" _v-0158947a=\"\">\n                    <select v-model=\"merchant.merchant_addr_area\" class=\"form-control\" _v-0158947a=\"\">\n                        <option v-for=\"option in areas\" :value=\"option.id\" _v-0158947a=\"\">\n                            {{ option.name }}\n                        </option>\n                    </select>\n                </div>\n            </div>\n            <div class=\"form-group\" _v-0158947a=\"\">\n                <label class=\"col-sm-3 control-label\" _v-0158947a=\"\">\n                    聯絡地址-路名及門牌號碼 Contact Address\n                    <v-required _v-0158947a=\"\"></v-required>\n                </label>\n                <div class=\"col-sm-9\" _v-0158947a=\"\">\n                    <input type=\"text\" v-model=\"merchant.merchant_addr\" class=\"form-control\" _v-0158947a=\"\">\n                </div>\n            </div>\n            <div class=\"form-group\" _v-0158947a=\"\">\n                <label class=\"col-sm-3 control-label\" _v-0158947a=\"\">\n                    商店英文聯絡地址 English address\n                    <v-required _v-0158947a=\"\"></v-required>\n                </label>\n                <div class=\"col-sm-9\" _v-0158947a=\"\">\n                    <input type=\"text\" v-model=\"merchant.merchant_en_addr\" class=\"form-control\" _v-0158947a=\"\">\n                </div>\n            </div>\n            <div class=\"form-group\" _v-0158947a=\"\">\n                <label class=\"col-sm-3 control-label\" _v-0158947a=\"\">\n                    登記營業國家 Registered country\n                    <v-required _v-0158947a=\"\"></v-required>\n                </label>\n                <div class=\"col-sm-9\" _v-0158947a=\"\">\n                    <input type=\"text\" v-model=\"merchant.national_e\" class=\"form-control\" _v-0158947a=\"\">\n                    <span class=\"help-block\" _v-0158947a=\"\">\n                      設立登記營業國家英文名稱。 ex.  Taiwan\n                    </span>\n                </div>\n            </div>\n            <div class=\"form-group\" _v-0158947a=\"\">\n                <label class=\"col-sm-3 control-label\" _v-0158947a=\"\">\n                    登記營業城市 Registered city\n                    <v-required _v-0158947a=\"\"></v-required>\n                </label>\n                <div class=\"col-sm-9\" _v-0158947a=\"\">\n                    <input type=\"text\" v-model=\"merchant.city_e\" class=\"form-control\" _v-0158947a=\"\">\n                    <span class=\"help-block\" _v-0158947a=\"\">\n                      合作商店設立登記營業城市英文名稱。ex.  Taipei City\n                    </span>\n                </div>\n            </div>\n            <div class=\"form-group\" _v-0158947a=\"\">\n                <label class=\"col-sm-3 control-label\" _v-0158947a=\"\">\n                    販售商店類型 Merchant type\n                    <v-required _v-0158947a=\"\"></v-required>\n                </label>\n                <div class=\"col-sm-9\" _v-0158947a=\"\">\n                    <select class=\"form-control\" v-model=\"merchant.merchant_type\" _v-0158947a=\"\">\n                        <option value=\"1\" _v-0158947a=\"\">實體商品</option>\n                        <option value=\"2\" _v-0158947a=\"\">服務</option>\n                        <option value=\"3\" _v-0158947a=\"\">虛擬商品</option>\n                        <option value=\"4\" _v-0158947a=\"\">票券</option>\n                    </select>\n                </div>\n            </div>\n            <div class=\"form-group\" _v-0158947a=\"\">\n                <label class=\"col-sm-3 control-label\" _v-0158947a=\"\">\n                    販售商店類別 Business type\n                    <v-required _v-0158947a=\"\"></v-required>\n                </label>\n                <div class=\"col-sm-9\" _v-0158947a=\"\">\n                    <select class=\"form-control\" v-model=\"merchant.business_type\" _v-0158947a=\"\">\n                        <option value=\"7298\" _v-0158947a=\"\">美容美體服務</option>\n                        <option value=\"7999\" _v-0158947a=\"\">娛樂休閒服務</option>\n                        <option value=\"8299\" _v-0158947a=\"\">補習/教學服務</option>\n                        <option value=\"7392\" _v-0158947a=\"\">諮詢服務</option>\n                        <option value=\"8999\" _v-0158947a=\"\">其他專業服務</option>\n                        <option value=\"5941\" _v-0158947a=\"\">運動商品</option>\n                        <option value=\"4225\" _v-0158947a=\"\">倉儲服務</option>\n                        <option value=\"5977\" _v-0158947a=\"\">化妝/美容保養產品</option>\n                        <option value=\"4722\" _v-0158947a=\"\">旅行社</option>\n                        <option value=\"5992\" _v-0158947a=\"\">花店</option>\n                        <option value=\"4812\" _v-0158947a=\"\">電話通訊設備及服務</option>\n                        <option value=\"5995\" _v-0158947a=\"\">寵物用品</option>\n                        <option value=\"4899\" _v-0158947a=\"\">有線電視</option>\n                        <option value=\"7011\" _v-0158947a=\"\">飯店/民宿</option>\n                        <option value=\"5045\" _v-0158947a=\"\">3C 商品</option>\n                        <option value=\"7261\" _v-0158947a=\"\">喪葬服務及用品</option>\n                        <option value=\"5094\" _v-0158947a=\"\">寶石/黃金/珠寶貴重物</option>\n                        <option value=\"5192\" _v-0158947a=\"\">書報雜誌</option>\n                        <option value=\"7311\" _v-0158947a=\"\">廣告服務</option>\n                        <option value=\"5261\" _v-0158947a=\"\">園藝用品</option>\n                        <option value=\"7372\" _v-0158947a=\"\">網路資訊服務</option>\n                        <option value=\"5399\" _v-0158947a=\"\">一般商品買賣</option>\n                        <option value=\"5422\" _v-0158947a=\"\">冷凍食品</option>\n                        <option value=\"7519\" _v-0158947a=\"\">休閒交通工具租借</option>\n                        <option value=\"5462\" _v-0158947a=\"\">西點麵包</option>\n                        <option value=\"7996\" _v-0158947a=\"\">樂區/博覽會</option>\n                        <option value=\"5499\" _v-0158947a=\"\">食品名特產</option>\n                        <option value=\"5699\" _v-0158947a=\"\">服飾配件</option>\n                        <option value=\"8220\" _v-0158947a=\"\">學校</option>\n                        <option value=\"5732\" _v-0158947a=\"\">電器行</option>\n                        <option value=\"5812\" _v-0158947a=\"\">餐廳</option>\n                        <option value=\"8398\" _v-0158947a=\"\">社會福利團體</option>\n                        <option value=\"8651\" _v-0158947a=\"\">政治團體</option>\n                        <option value=\"5946\" _v-0158947a=\"\">攝影用品</option>\n                        <option value=\"8661\" _v-0158947a=\"\">宗教團體</option>\n                        <option value=\"5963\" _v-0158947a=\"\">直銷</option>\n                    </select>\n                </div>\n            </div>\n            <div class=\"form-group\" _v-0158947a=\"\">\n                <label class=\"col-sm-3 control-label\" _v-0158947a=\"\">\n                    商店簡介 Business introduction\n                    <v-required _v-0158947a=\"\"></v-required>\n                </label>\n                <div class=\"col-sm-9\" _v-0158947a=\"\">\n                    <textarea v-model=\"merchant.merchant_desc\" rows=\"5\" class=\"form-control\" _v-0158947a=\"\"></textarea>\n                </div>\n            </div>\n            <div class=\"form-group\" _v-0158947a=\"\">\n                <label class=\"col-sm-3 control-label\" _v-0158947a=\"\">\n                    金融機構銀行代碼 Bank code\n                    <v-required _v-0158947a=\"\"></v-required>\n                </label>\n                <div class=\"col-sm-9\" _v-0158947a=\"\">\n                    <input type=\"number\" v-model=\"merchant.bank_code\" class=\"form-control\" _v-0158947a=\"\">\n                    <span class=\"help-block\" _v-0158947a=\"\">\n                        ex. 012\n                    </span>\n                </div>\n            </div>\n            <div class=\"form-group\" _v-0158947a=\"\">\n                <label class=\"col-sm-3 control-label\" _v-0158947a=\"\">\n                    金融機構分行代碼 SubBank code\n                    <v-required _v-0158947a=\"\"></v-required>\n                </label>\n                <div class=\"col-sm-9\" _v-0158947a=\"\">\n                    <input type=\"number\" v-model=\"merchant.sub_bank_code\" class=\"form-control\" _v-0158947a=\"\">\n                    <span class=\"help-block\" _v-0158947a=\"\">\n                        ex. 2216\n                  </span>\n                </div>\n            </div>\n            <div class=\"form-group\" _v-0158947a=\"\">\n                <label class=\"col-sm-3 control-label\" _v-0158947a=\"\">\n                    金融機構帳戶帳號 Bank account\n                    <v-required _v-0158947a=\"\"></v-required>\n                </label>\n                <div class=\"col-sm-9\" _v-0158947a=\"\">\n                    <input type=\"number\" v-model=\"merchant.bank_account\" class=\"form-control\" _v-0158947a=\"\">\n                    <span class=\"help-block\" _v-0158947a=\"\">\n                      請填入金融機構帳戶之帳號。<span class=\"attention\" _v-0158947a=\"\">此金融機構帳號戶名需與藍新會員名稱相同。</span>\n                    </span>\n                </div>\n            </div> \n            <div class=\"form-group\" v-if=\"isSeventeen\" _v-0158947a=\"\">\n                <label class=\"col-sm-3 control-label\" _v-0158947a=\"\">\n                    是否需要核銷機制\n                    <v-required _v-0158947a=\"\"></v-required>\n                </label>\n                <div class=\"col-sm-9\" _v-0158947a=\"\">\n                    <label class=\"radio-margin\" v-for=\"item in odvSettings\" _v-0158947a=\"\">\n                        <input type=\"radio\" :value=\"item.id\" v-model=\"merchant.odv_setting_id\" _v-0158947a=\"\"> {{ item.merchant_form_display_name }}\n                    </label>\n                </div>\n            </div>\n            <div class=\"form-group\" _v-0158947a=\"\">\n                <label class=\"col-sm-3 control-label\" _v-0158947a=\"\"></label>\n                <div class=\"col-sm-3\" _v-0158947a=\"\">\n                    <button type=\"button\" class=\"col-xs-5 btn btn-primary\" @click.prevent=\"store\" _v-0158947a=\"\">儲存</button>\n                    <div class=\"col-xs-2\" _v-0158947a=\"\"></div>\n                    <button type=\"button\" class=\"col-xs-5 btn btn-default btn--blue\" @click.prevent=\"sendCreate\" v-if=\"isSeventeen\" _v-0158947a=\"\">提交</button>\n                </div>\n            </div>\n        </form>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.radio-margin + .radio-margin[_v-0158947a] {\n  margin-left: 10px; }\n\n/* line 6, stdin */\ninput[_v-0158947a],\ntextarea[_v-0158947a],\nselect[_v-0158947a] {\n  max-width: 500px; }\n\n/* line 12, stdin */\n.input-group input[_v-0158947a] {\n  max-width: inherit; }\n\n/* line 16, stdin */\n.input-group[_v-0158947a] {\n  max-width: 150px; }\n\n/* line 20, stdin */\nspan.label[_v-0158947a] {\n  font-size: 14px;\n  margin-left: 30px; }\n\n/* line 25, stdin */\nspan.attention[_v-0158947a] {\n  color: red;\n  font-weight: 700; }\n\n/* line 30, stdin */\n.p-t-0[_v-0158947a] {\n  padding-top: 0 !important; }\n\n/* line 34, stdin */\ntextarea[_v-0158947a] {\n  margin: 0; }\n\n/* line 38, stdin */\n#finish-form[_v-0158947a] {\n  margin-top: 50px; }\n\n/* line 42, stdin */\n.modify-fee[_v-0158947a] {\n  margin: 50px 0; }\n\n/* line 46, stdin */\n.form-group.modify[_v-0158947a] {\n  padding-bottom: 20px; }\n\n/* line 50, stdin */\ninput[type=\"range\"][_v-0158947a] {\n  -webkit-appearance: none;\n  width: 100%;\n  border: none;\n  -webkit-appearance: slider-horizontal;\n     -moz-appearance: slider-horizontal;\n          appearance: slider-horizontal;\n  color: -internal-light-dark(#101010, white);\n  cursor: default;\n  padding: initial;\n  border: initial;\n  margin: 2px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-0158947a", module.exports)
  } else {
    hotAPI.update("_v-0158947a", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/json/stringify":48,"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1233:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _index = require('./index.vue');

var _index2 = _interopRequireDefault(_index);

var _createForm = require('./create-form.vue');

var _createForm2 = _interopRequireDefault(_createForm);

var _statusView = require('./status-view.vue');

var _statusView2 = _interopRequireDefault(_statusView);

var _changeCreditModal = require('./change-credit-modal.vue');

var _changeCreditModal2 = _interopRequireDefault(_changeCreditModal);

var _changeCreditFeeModal = require('./change-credit-fee-modal.vue');

var _changeCreditFeeModal2 = _interopRequireDefault(_changeCreditFeeModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('webadmin-merchant-index', _index2.default);
_vue2.default.component('webadmin-merchant-create-form', _createForm2.default);
_vue2.default.component('webadmin-merchant-status-view', _statusView2.default);

_vue2.default.component('webadmin-change-credit-modal', _changeCreditModal2.default);
_vue2.default.component('webadmin-change-credit-fee-modal', _changeCreditFeeModal2.default);

},{"./change-credit-fee-modal.vue":1230,"./change-credit-modal.vue":1231,"./create-form.vue":1232,"./index.vue":1234,"./status-view.vue":1235,"vue":792}],1234:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\nh3[_v-0426c4c0] {\n  font-weight: 700;\n  font-size: 42px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {},
    data: function data() {
        return {
            showComponent: 'webadmin-merchant-create-form',
            startAjax: false,
            credit_fee: '',
            foreign_fee: '',
            default_credit_limit: {
                value: 1000000, //range bar 顯示預設一百萬
                max: 3000000, //上限三百萬
                min: 200000 //下限 200000
            },
            odvSettings: [],
            merchant: {
                type: 'pay2go',
                branch_id: '',
                id: '',
                status: '',
                hash_key: '',
                hash_iv: '',
                is_company: '',
                manager_id: '',
                manager_id_type: '',
                member_name: '',
                member_phone: '',
                manager_name: '',
                manager_name_e: '',
                login_account: '',
                manager_mobile: '',
                manager_email: '',
                merchant_id: '',
                merchant_name: '',
                merchant_name_e: '',
                merchant_web_url: '',
                merchant_addr_city: '',
                merchant_addr_area: '',
                merchant_addr: '',
                national_e: '',
                city_e: '',
                merchant_type: '',
                business_type: '',
                merchant_desc: '',
                bank_code: '',
                sub_bank_code: '',
                bank_account: '',
                credit_limit: '',
                fees: {},
                allow_foreign_card: 0,
                odv_setting_id: 1,
                is_lock_checkout_by_17fit: 0,
                is_lock_checkout_by_studio: 0,
                actived_at: null,
                bank_transfer_status: 0,
                is_lock_checkout_bank_transfer_by_17fit: 0,
                is_lock_checkout_bank_transfer_by_studio: 0,
                id_card_date: '',
                id_card_place: '',
                id_from: 1,
                id_pic: '',
                personal_unified: '',
                company_unified: '',
                represent_name: '',
                capital_amount: '',
                incorporation_date: '',
                company_address: '',
                birthday: '',
                ARC_exp: '',
                ARC_srlno: '',
                passport_exp: '',
                represent_CPAdd: '',
                represent_capital_amt: '',
                represent_manager_name: '',
                merchant_en_addr: '',
                last_merchant_status: '',
                last_member_status: ''
            },
            cities: {},
            areas: {}
        };
    },

    watch: {
        branchId: function () {
            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(val, oldVal) {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (this.isBranch) {
                                    this.branchChangeCallBack(val);
                                }

                            case 1:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function branchId(_x, _x2) {
                return _ref.apply(this, arguments);
            }

            return branchId;
        }(),
        'merchant.actived_at': function merchantActived_at(val) {
            if (val != null) {
                this.showComponent = 'webadmin-merchant-status-view';
            } else {
                this.showComponent = 'webadmin-merchant-create-form';
            }
        }
    },
    mounted: function mounted() {},

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId', 'isBranch', 'isSeventeen']), {
        format_credit_limit: function format_credit_limit() {
            return new Intl.NumberFormat().format(this.merchant.credit_limit);
        }
    }),
    methods: {
        branchChangeCallBack: function () {
            var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(branchId) {
                var _this = this;

                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (branchId) {
                                    this.reset();
                                    this.startAjax = true;
                                    this.merchant.branch_id = branchId;
                                    this.$http.get('/adminapi/merchant/edit/' + branchId).then(function (response) {
                                        var resData = response.data;
                                        if (resData.is_company === 0) {
                                            //個人
                                            _this.merchant.is_company = 0;
                                        } else {
                                            //企業
                                            _this.merchant.is_company = 1;
                                        }
                                        _this.merchant.id = resData.id;
                                        _this.merchant.status = resData.status;
                                        _this.merchant.hash_key = resData.hash_key;
                                        _this.merchant.hash_iv = resData.hash_iv;
                                        _this.merchant.allow_foreign_card = resData.allow_foreign_card;
                                        _this.merchant.id_card_place = resData.id_card_place;
                                        _this.merchant.id_card_date = resData.id_card_date;
                                        _this.merchant.id_from = resData.id_from;
                                        _this.merchant.id_pic = resData.id_pic;
                                        _this.merchant.personal_unified = resData.personal_unified;
                                        _this.merchant.company_unified = resData.company_unified;
                                        _this.merchant.represent_name = resData.represent_name;
                                        _this.merchant.capital_amount = resData.capital_amount;
                                        _this.merchant.incorporation_date = resData.incorporation_date;
                                        _this.merchant.company_address = resData.company_address;
                                        _this.merchant.manager_id = resData.manager_id;
                                        _this.merchant.manager_id_type = resData.manager_id_type;
                                        _this.merchant.member_name = resData.member_name;
                                        _this.merchant.member_phone = resData.member_phone;
                                        _this.merchant.manager_name = resData.manager_name;
                                        _this.merchant.manager_name_e = resData.manager_name_e;
                                        _this.merchant.login_account = resData.login_account;
                                        _this.merchant.manager_mobile = resData.manager_mobile;
                                        _this.merchant.manager_email = resData.manager_email;
                                        _this.merchant.merchant_id = resData.merchant_id;
                                        _this.merchant.merchant_name = resData.merchant_name;
                                        _this.merchant.merchant_name_e = resData.merchant_name_e;
                                        _this.merchant.merchant_web_url = resData.merchant_web_url;
                                        _this.merchant.merchant_addr_city = resData.merchant_addr_city;
                                        _this.merchant.merchant_addr_area = resData.merchant_addr_area;
                                        _this.merchant.merchant_addr = resData.merchant_addr;
                                        _this.merchant.national_e = resData.national_e;
                                        _this.merchant.city_e = resData.city_e;
                                        _this.merchant.merchant_type = resData.merchant_type;
                                        _this.merchant.business_type = resData.business_type;
                                        _this.merchant.merchant_desc = resData.merchant_desc;
                                        _this.merchant.bank_code = resData.bank_code;
                                        _this.merchant.sub_bank_code = resData.sub_bank_code;
                                        _this.merchant.bank_account = resData.bank_account;
                                        _this.merchant.credit_limit = resData.credit_limit;
                                        _this.merchant.fees = resData.fees;
                                        if (resData.odv_setting_id > 0) {
                                            _this.merchant.odv_setting_id = resData.odv_setting_id;
                                        } else {
                                            _this.merchant.odv_setting_id = resData.agreed_days === 7 ? 2 : 1;
                                        }

                                        _this.odvSettings = resData.odv_settings;
                                        _this.merchant.is_lock_checkout_by_17fit = resData.is_lock_checkout_by_17fit;
                                        _this.merchant.is_lock_checkout_by_studio = resData.is_lock_checkout_by_studio;
                                        _this.merchant.actived_at = resData.actived_at;
                                        _this.merchant.bank_transfer_status = resData.bank_transfer_status;
                                        _this.merchant.is_lock_checkout_bank_transfer_by_17fit = resData.is_lock_checkout_bank_transfer_by_17fit;
                                        _this.merchant.is_lock_checkout_bank_transfer_by_studio = resData.is_lock_checkout_bank_transfer_by_studio;
                                        _this.merchant.company_address = resData.company_address;
                                        _this.merchant.foreign_card_had_enable = resData.foreign_card_had_enable;
                                        _this.merchant.webatm_status = resData.webatm_status;
                                        _this.merchant.cvs_status = resData.cvs_status;
                                        _this.merchant.cvs_barcode_status = resData.cvs_barcode_status;
                                        _this.merchant.last_merchant_status = resData.last_merchant_status;
                                        _this.merchant.last_member_status = resData.last_member_status;
                                        _this.merchant.birthday = resData.birthday;
                                        _this.merchant.ARC_exp = resData.ARC_exp;
                                        _this.merchant.ARC_srlno = resData.ARC_srlno;
                                        _this.merchant.passport_exp = resData.passport_exp;
                                        _this.merchant.represent_CPAdd = resData.represent_CPAdd;
                                        _this.merchant.represent_capital_amt = resData.represent_capital_amt;
                                        _this.merchant.represent_manager_name = resData.represent_manager_name;
                                        _this.merchant.dispute_mail = resData.dispute_mail;
                                        _this.merchant.merchant_email = resData.merchant_email;
                                        _this.merchant.member_address = resData.member_address;
                                        _this.merchant.merchant_en_addr = resData.merchant_en_addr;

                                        _this.startAjax = false;

                                        //尚未開通的新商店預設額度
                                        if (_this.merchant.status == 0 && _this.merchant.credit_limit < 1) {
                                            _this.merchant.credit_limit = _this.default_credit_limit.value;
                                        }
                                    }).catch(function (response) {
                                        _this.startAjax = false;
                                        $17.swal({
                                            title: '取得資料失敗',
                                            text: "",
                                            type: 'warning',
                                            showCancelButton: false
                                        });
                                    });

                                    console.log('tsts:' + this.merchant.last_merchant_status == '01', this.merchant.last_merchant_status, "test1234");
                                }

                            case 1:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function branchChangeCallBack(_x3) {
                return _ref2.apply(this, arguments);
            }

            return branchChangeCallBack;
        }(),
        updateMerchant: function updateMerchant(merchant) {
            this.merchant = merchant;
        },
        reset: function reset() {
            var _merchant;

            this.merchant = (_merchant = {
                type: 'pay2go',
                branch_id: '',
                id: '',
                status: '',
                hash_key: '',
                hash_iv: '',
                is_company: '',
                id_card_date: '',
                id_card_place: '',
                id_from: 1,
                id_pic: '',
                personal_unified: '',
                company_unified: '',
                represent_name: '',
                capital_amount: '',
                incorporation_date: '',
                company_address: '',
                manager_id: '',
                manager_id_type: '',
                member_name: '',
                member_phone: '',
                manager_name: '',
                manager_name_e: '',
                login_account: '',
                manager_mobile: '',
                manager_email: '',
                merchant_id: '',
                merchant_name: '',
                merchant_name_e: '',
                merchant_web_url: '',
                merchant_addr_city: '',
                merchant_addr_area: '',
                merchant_addr: '',
                national_e: '',
                city_e: '',
                merchant_type: '',
                business_type: '',
                merchant_desc: '',
                bank_code: '',
                sub_bank_code: '',
                bank_account: '',
                credit_limit: '',
                fees: {},
                allow_foreign_card: 0,
                odv_setting_id: 1,
                is_lock_checkout_by_17fit: 0,
                is_lock_checkout_by_studio: 0,
                actived_at: null,
                bank_transfer_status: 0,
                is_lock_checkout_bank_transfer_by_17fit: 0,
                is_lock_checkout_bank_transfer_by_studio: 0
            }, (0, _defineProperty3.default)(_merchant, 'id_card_date', ''), (0, _defineProperty3.default)(_merchant, 'id_card_place', ''), (0, _defineProperty3.default)(_merchant, 'id_from', 1), (0, _defineProperty3.default)(_merchant, 'id_pic', ''), (0, _defineProperty3.default)(_merchant, 'personal_unified', ''), (0, _defineProperty3.default)(_merchant, 'company_unified', ''), (0, _defineProperty3.default)(_merchant, 'represent_name', ''), (0, _defineProperty3.default)(_merchant, 'capital_amount', ''), (0, _defineProperty3.default)(_merchant, 'incorporation_date', ''), (0, _defineProperty3.default)(_merchant, 'company_address', ''), (0, _defineProperty3.default)(_merchant, 'birthday', ''), (0, _defineProperty3.default)(_merchant, 'ARC_exp', ''), (0, _defineProperty3.default)(_merchant, 'ARC_srlno', ''), (0, _defineProperty3.default)(_merchant, 'passport_exp', ''), (0, _defineProperty3.default)(_merchant, 'represent_CPAdd', ''), (0, _defineProperty3.default)(_merchant, 'represent_capital_amt', ''), (0, _defineProperty3.default)(_merchant, 'represent_manager_name', ''), (0, _defineProperty3.default)(_merchant, 'merchant_en_addr', ''), (0, _defineProperty3.default)(_merchant, 'last_merchant_status', ''), (0, _defineProperty3.default)(_merchant, 'last_member_status', ''), _merchant);
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"col-sm-12\" _v-0426c4c0=\"\">\n    <v-multiselect-studio-and-branch :studio_id=\"studioId\" :branch_id=\"branchId\" :branch-change-call-back=\"branchChangeCallBack\" _v-0426c4c0=\"\">\n    </v-multiselect-studio-and-branch>\n    <div class=\"st-space-y-2\" _v-0426c4c0=\"\">\n        <div class=\"st-text-24 st-text-black st-font-bold\" _v-0426c4c0=\"\">\n            藍新金流 - 商店設定\n                <span class=\"\" v-if=\"merchant.last_merchant_status=='01'\" _v-0426c4c0=\"\"></span>\n                <span class=\"label label-success st-ml-4\" v-else-if=\"merchant.last_merchant_status=='04'\" _v-0426c4c0=\"\">審核中</span>\n                <span class=\"label label-default st-ml-4\" v-else=\"\" _v-0426c4c0=\"\">尚未開通</span>\n            </div>\n        <div class=\"st-text-16 st-text-gray-90\" _v-0426c4c0=\"\">\n            透過 17FIT 串接為藍新會員，開啟線上金流服務。\n            <a class=\"st-text-info\" v-if=\"merchant.actived_at!=null\" href=\"//www.newebpay.com\" target=\"_blank\" _v-0426c4c0=\"\">登入藍新金流</a>\n            \n        </div>\n    </div>\n    <hr class=\"st-border-gray-40 st-my-4\" _v-0426c4c0=\"\">\n    <v-spinner :ajaxing=\"startAjax\" id=\"v-spinner\" _v-0426c4c0=\"\">\n    </v-spinner>\n    <div v-if=\"merchant.branch_id&amp;&amp;!startAjax\" _v-0426c4c0=\"\">\n        <component :is=\"showComponent\" :merchant-data=\"merchant\" :odv-setting-data=\"odvSettings\" @fresh=\"branchChangeCallBack(merchant.branch_id)\" _v-0426c4c0=\"\"></component>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\nh3[_v-0426c4c0] {\n  font-weight: 700;\n  font-size: 42px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-0426c4c0", module.exports)
  } else {
    hotAPI.update("_v-0426c4c0", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/defineProperty":65,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1235:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 3, stdin */\n.info table[_v-54dd50ee], .info tr[_v-54dd50ee], .info td[_v-54dd50ee] {\n  border: 1px solid #E5E7EB; }\n\n/* line 6, stdin */\n.info table[_v-54dd50ee] {\n  width: 100%; }\n\n/* line 9, stdin */\n.info .table-title[_v-54dd50ee] {\n  background: #F9FAFB;\n  width: 20%;\n  color: #696974;\n  font-size: 14px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        merchantData: {}
    },
    data: function data() {
        return {
            startAjax: false,
            credit_fee: '',
            foreign_fee: '',
            merchant: {
                type: 'pay2go',
                branch_id: '',
                id: '',
                status: '',
                hash_key: '',
                hash_iv: '',
                is_company: '',
                id_card_date: '',
                id_card_place: '',
                id_from: 1,
                id_pic: '',
                personal_unified: '',
                company_unified: '',
                represent_name: '',
                capital_amount: '',
                incorporation_date: '',
                company_address: '',
                manager_id: '',
                manager_id_type: '',
                member_name: '',
                member_phone: '',
                manager_name: '',
                manager_name_e: '',
                login_account: '',
                manager_mobile: '',
                manager_email: '',
                merchant_id: '',
                merchant_name: '',
                merchant_name_e: '',
                merchant_web_url: '',
                merchant_addr_city: '',
                merchant_addr_area: '',
                merchant_addr: '',
                national_e: '',
                city_e: '',
                merchant_type: '',
                business_type: '',
                merchant_desc: '',
                bank_code: '',
                sub_bank_code: '',
                bank_account: '',
                credit_limit: '',
                fees: {},
                allow_foreign_card: 0,
                foreign_card_had_enable: 0,
                odv_setting_id: 1,
                is_lock_checkout_by_17fit: 0,
                is_lock_checkout_by_studio: 0,
                bank_transfer_status: 0,
                is_lock_checkout_bank_transfer_by_17fit: 0,
                is_lock_checkout_bank_transfer_by_studio: 0
            },
            subHeadStyle: ["st-flex st-font-medium st-items-center st-text-20 st-text-black", "before:st-content-[''] before:st-h-6 before:st-inline-block before:st-mr-2 before:st-rounded-4 before:st-w-1"]
        };
    },

    watch: {
        merchantData: {
            handler: function handler(newValue, oldValue) {
                this.merchant = newValue;
            },

            deep: true
        },
        'merchant.fees': function merchantFees(value) {
            if (this.merchant.status != 0) {
                var vm = this;
                this.merchant.fees.forEach(function (item) {
                    switch (item.payment_code) {
                        case 0:
                            //信用卡一次付清金流手續費
                            vm.credit_fee = item.fee;
                            break;
                        case 8:
                            //國外信用卡金流手續費
                            vm.foreign_fee = item.fee;
                            break;
                    }
                });
            }
        }
    },
    mounted: function mounted() {
        this.merchant = this.merchantData;
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId', 'isBranch', 'isSeventeen'])),
    methods: {
        sendModify: function sendModify(type) {
            var config = {
                status: 0,
                paymentTypeEnum: 0,
                isLockCheckoutBy17fit: 0,
                isLockCheckoutByStudio: 0
            };

            if (type == 'credit-card') {
                config.title = '線上刷卡';
                config.paymentTypeEnum = 2;
                config.status = this.merchant.status;
                config.isLockCheckoutBy17fit = this.merchant.is_lock_checkout_by_17fit;
                config.isLockCheckoutByStudio = this.merchant.is_lock_checkout_by_studio;
                config.allowForeignCard = this.merchant.allow_foreign_card;
            }

            if (type == 'bank-transfer') {
                config.title = '銀行轉帳';
                config.paymentTypeEnum = 6;
                config.status = this.merchant.bank_transfer_status;
                config.isLockCheckoutBy17fit = this.merchant.is_lock_checkout_bank_transfer_by_17fit;
                config.isLockCheckoutByStudio = this.merchant.is_lock_checkout_bank_transfer_by_studio;
            }

            this.$refs.changeCreditModal.edit(config);
        },
        sendModifyFee: function sendModifyFee() {
            this.$refs.changeCreditFeeModal.edit(this.merchant);
        },
        fresh: function fresh() {
            this.$emit('fresh');
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"st-text-16 st-mb-5\" _v-54dd50ee=\"\">\n    <div class=\"row info st-space-y-4\" _v-54dd50ee=\"\">\n        <div class=\"col-sm-12\" _v-54dd50ee=\"\">\n            <div :class=\"subHeadStyle\" class=\"before:st-bg-secondary\" _v-54dd50ee=\"\">\n                商店資訊\n                <span class=\"label label-success st-ml-2\" v-if=\"merchant.last_merchant_status=='01'\" _v-54dd50ee=\"\">已開通</span>\n            </div>\n        </div>\n        <div class=\"col-sm-12\" _v-54dd50ee=\"\">\n            <table _v-54dd50ee=\"\">\n                <tbody _v-54dd50ee=\"\"><tr _v-54dd50ee=\"\">\n                    <td class=\"p-left-15 p-top-10 p-bottom-10 table-title\" _v-54dd50ee=\"\">類型</td>\n                    <td class=\"p-left-15\" _v-54dd50ee=\"\"> {{merchant.is_company==1?'企業':'個人'}}</td>\n                </tr>\n                <tr _v-54dd50ee=\"\">\n                    <td class=\"p-left-15 p-top-10 p-bottom-10 table-title\" _v-54dd50ee=\"\">{{merchant.is_company==1?'統一編號':'身分證字號'}}</td>\n                    <td class=\"p-left-15\" _v-54dd50ee=\"\">\n                        {{merchant.is_company==1?merchant.company_unified:merchant.personal_unified}}\n                    </td>\n                </tr>\n                <tr _v-54dd50ee=\"\">\n                    <td class=\"p-left-15 p-top-10 p-bottom-10 table-title\" _v-54dd50ee=\"\">管理者帳號</td>\n                    <td class=\"p-left-15\" _v-54dd50ee=\"\">\n                        {{merchant.login_account}}\n                    </td>\n                </tr>\n                <tr _v-54dd50ee=\"\">\n                    <td class=\"p-left-15 p-top-10 p-bottom-10 table-title\" _v-54dd50ee=\"\">管理者 E-mail</td>\n                    <td class=\"p-left-15\" _v-54dd50ee=\"\">\n                        {{merchant.manager_email}}\n                    </td>\n                </tr>\n                <tr _v-54dd50ee=\"\">\n                    <td class=\"p-left-15 p-top-10 p-bottom-10 table-title\" _v-54dd50ee=\"\">商店代號</td>\n                    <td class=\"p-left-15\" _v-54dd50ee=\"\">\n                        {{merchant.merchant_id}}\n                    </td>\n                </tr>\n                <tr _v-54dd50ee=\"\">\n                    <td class=\"p-left-15 p-top-10 p-bottom-10 table-title\" _v-54dd50ee=\"\">商店中文名稱</td>\n                    <td class=\"p-left-15\" _v-54dd50ee=\"\">\n                        {{merchant.merchant_name}}\n                    </td>\n                </tr>\n                <tr _v-54dd50ee=\"\">\n                    <td class=\"p-left-15 p-top-10 p-bottom-10 table-title\" _v-54dd50ee=\"\">商店英文名稱</td>\n                    <td class=\"p-left-15\" _v-54dd50ee=\"\">\n                        {{merchant.merchant_name_e}}\n                    </td>\n                </tr>\n                <tr _v-54dd50ee=\"\">\n                    <td class=\"p-left-15 p-top-10 p-bottom-10 table-title\" _v-54dd50ee=\"\">商店網址</td>\n                    <td class=\"p-left-15\" _v-54dd50ee=\"\">\n                        {{merchant.merchant_web_url}}\n                    </td>\n                </tr>\n            </tbody></table>\n        </div>\n    </div>\n    <hr class=\"st-border-gray-40 st-my-6\" v-show=\"merchant.last_merchant_status=='01'\" _v-54dd50ee=\"\">\n    <div class=\"st-space-y-5\" v-show=\"merchant.last_merchant_status=='01'\" _v-54dd50ee=\"\">\n        <div class=\"row info st-space-y-4\" _v-54dd50ee=\"\">\n            <div class=\"col-sm-12\" _v-54dd50ee=\"\">\n                <div :class=\"subHeadStyle\" class=\"before:st-bg-secondary\" _v-54dd50ee=\"\">\n                    <span class=\"st-grow\" _v-54dd50ee=\"\">金流手續費設定</span>\n                    <st-button v-if=\"isSeventeen\" icon=\"\" neutral=\"\" left-icon=\"edit\" btn-class=\"!st-p-1\" @click=\"sendModifyFee()\" _v-54dd50ee=\"\">\n                    </st-button>\n                </div>\n            </div>\n            <div class=\"col-sm-12\" _v-54dd50ee=\"\">\n                <table _v-54dd50ee=\"\">\n                    <tbody _v-54dd50ee=\"\"><tr _v-54dd50ee=\"\">\n                        <td class=\"p-left-15 p-top-10 p-bottom-10 table-title\" _v-54dd50ee=\"\">一般信用卡金流手續費</td>\n                        <td class=\"p-left-15\" _v-54dd50ee=\"\"> {{credit_fee}}%</td>\n                    </tr>\n                    <tr _v-54dd50ee=\"\">\n                        <td class=\"p-left-15 p-top-10 p-bottom-10 table-title\" _v-54dd50ee=\"\">國外信用卡金流手續費</td>\n                        <td class=\"p-left-15\" _v-54dd50ee=\"\"> \n                            <span v-if=\"merchant.allow_foreign_card==1\" _v-54dd50ee=\"\">\n                                {{foreign_fee}}%\n                            </span>\n                            <span v-else=\"\" _v-54dd50ee=\"\">\n                                未開通\n                            </span>\n                        </td>\n                    </tr>\n                </tbody></table>\n            </div>\n        </div>\n        <div _v-54dd50ee=\"\">\n            <div class=\"row st-space-y-4\" _v-54dd50ee=\"\">\n                <div class=\"col-sm-12\" _v-54dd50ee=\"\">\n                    <div :class=\"subHeadStyle\" class=\"before:st-bg-secondary\" _v-54dd50ee=\"\">\n                        <div class=\"st-grow\" _v-54dd50ee=\"\">\n                            線上刷卡\n                            <span class=\"btn-status st-ml-2\" _v-54dd50ee=\"\">\n                                <span class=\"label label-warning\" v-if=\"merchant.status==2\" _v-54dd50ee=\"\">審核中</span>\n                                <span class=\"label label-success\" v-else-if=\"merchant.status==1\" _v-54dd50ee=\"\">已開通</span>\n                                <span class=\"label label-danger\" v-else-if=\"merchant.status==3\" _v-54dd50ee=\"\">開通失敗</span>\n                                <span class=\"label label-default\" v-else=\"\" _v-54dd50ee=\"\">尚未開通</span>\n                            </span>\n                        </div>\n                        <st-button v-if=\"merchant.status==1\" icon=\"\" neutral=\"\" left-icon=\"edit\" btn-class=\"!st-p-1\" @click=\"sendModify('credit-card')\" _v-54dd50ee=\"\">\n                        </st-button>\n                    </div>\n                </div>\n                <div class=\"col-sm-12 m-left-5 m-top-5 st-text-danger\" v-if=\"merchant.is_lock_checkout_by_17fit\" _v-54dd50ee=\"\">\n                    <div class=\"st-flex st-items-center\" _v-54dd50ee=\"\">\n                        <span class=\"material-icons st-mr-2\" _v-54dd50ee=\"\">info</span>\n                        <span _v-54dd50ee=\"\">線上刷卡功能已被暫時停用，造成不便敬請見諒！如有任何疑問請洽 17FIT 客服人員。</span>\n                    </div>\n                </div>\n                <div class=\"col-sm-12 st-ml-2 st-space-y-1\" v-if=\"merchant.status==1\" _v-54dd50ee=\"\">\n                    <div class=\"st-text-14 st-text-gray-90\" _v-54dd50ee=\"\">啟用狀態</div>\n                    <div class=\"st-text-16 st-text-black st-font-medium\" _v-54dd50ee=\"\">\n                        {{merchant.is_lock_checkout_by_studio==0?'啟用':'關閉'}}\n                    </div>\n                    <hr class=\"st-my-0\" _v-54dd50ee=\"\">\n                    <div class=\"st-text-14 st-text-gray-90\" _v-54dd50ee=\"\">國外卡</div>\n                    <div class=\"st-text-16 st-text-black st-font-medium\" _v-54dd50ee=\"\">\n                        {{merchant.allow_foreign_card==1?'開通':'未開通'}}\n                    </div>\n                    <hr class=\"st-my-0\" _v-54dd50ee=\"\">\n                </div>                \n            </div>\n        </div>\n        <div _v-54dd50ee=\"\">\n            <div class=\"row st-space-y-4\" _v-54dd50ee=\"\">\n                <div class=\"col-sm-12\" _v-54dd50ee=\"\">\n                    <div :class=\"subHeadStyle\" class=\"before:st-bg-secondary\" _v-54dd50ee=\"\">\n                        <div class=\"st-grow\" _v-54dd50ee=\"\">\n                            銀行轉帳\n                            <span class=\"btn-status st-ml-2\" _v-54dd50ee=\"\">\n                                <span class=\"label label-success\" v-if=\"merchant.bank_transfer_status==1\" _v-54dd50ee=\"\">已開通</span>\n                                <span class=\"label label-default\" v-else=\"\" _v-54dd50ee=\"\">尚未開通</span>\n                            </span>    \n                        </div>\n                        <st-button v-if=\"merchant.bank_transfer_status==1\" icon=\"\" neutral=\"\" left-icon=\"edit\" btn-class=\"!st-p-1\" @click=\"sendModify('bank-transfer')\" _v-54dd50ee=\"\">\n                        </st-button>\n                    </div>\n                </div>\n                <div class=\"col-sm-12 m-left-5 m-top-5 st-text-danger\" v-if=\"merchant.is_lock_checkout_bank_transfer_by_17fit\" _v-54dd50ee=\"\">\n                    <div class=\"st-flex st-items-center\" _v-54dd50ee=\"\">\n                        <span class=\"material-icons st-mr-2\" _v-54dd50ee=\"\">info</span>\n                        <span _v-54dd50ee=\"\">銀行轉帳功能已被暫時停用，造成不便敬請見諒！如有任何疑問請洽 17FIT 客服人員。</span>\n                    </div>\n                </div>\n                <div class=\"col-sm-12 st-ml-2 st-space-y-1\" v-if=\"merchant.bank_transfer_status==1\" _v-54dd50ee=\"\">\n                    <div class=\"st-text-14 st-text-gray-90\" _v-54dd50ee=\"\">啟用狀態</div>\n                    <div class=\"st-text-16 st-text-black st-font-medium\" _v-54dd50ee=\"\">\n                        {{merchant.is_lock_checkout_bank_transfer_by_studio==0?'啟用':'關閉'}}\n                    </div>\n                    <hr class=\"st-my-0\" _v-54dd50ee=\"\">\n                </div>\n            </div>\n        </div>\n    </div>\n    <webadmin-change-credit-modal ref=\"changeCreditModal\" :merchant-id=\"merchant.id\" @updated-credit=\"fresh\" _v-54dd50ee=\"\"></webadmin-change-credit-modal>\n    \n    <webadmin-change-credit-fee-modal v-if=\"isSeventeen\" ref=\"changeCreditFeeModal\" :merchant-id=\"merchant.id\" @updated-credit=\"fresh\" _v-54dd50ee=\"\"></webadmin-change-credit-fee-modal>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 3, stdin */\n.info table[_v-54dd50ee], .info tr[_v-54dd50ee], .info td[_v-54dd50ee] {\n  border: 1px solid #E5E7EB; }\n\n/* line 6, stdin */\n.info table[_v-54dd50ee] {\n  width: 100%; }\n\n/* line 9, stdin */\n.info .table-title[_v-54dd50ee] {\n  background: #F9FAFB;\n  width: 20%;\n  color: #696974;\n  font-size: 14px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-54dd50ee", module.exports)
  } else {
    hotAPI.update("_v-54dd50ee", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1236:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n#append-message-moddal .modal-content {\n  max-height: 90vh; }\n\n/* line 5, stdin */\n#append-message-moddal .selected-customer .multiselect {\n  max-height: 20vh;\n  overflow-y: scroll; }\n  /* line 8, stdin */\n  #append-message-moddal .selected-customer .multiselect .multiselect--active, #append-message-moddal .selected-customer .multiselect .multiselect__content, #append-message-moddal .selected-customer .multiselect .multiselect__select {\n    display: none; }\n\n/* line 2, stdin */\n.selected-customer[_v-0a9d4452] {\n  max-height: 20vh; }\n\n/* line 5, stdin */\n#title[_v-0a9d4452] {\n  width: 100%; }\n\n/* line 8, stdin */\n.row[_v-0a9d4452] {\n  margin-top: 5px;\n  margin-bottom: 5px; }\n\n/* line 12, stdin */\n#content-textarea[_v-0a9d4452] {\n  max-height: 40vh; }\n\n/* line 15, stdin */\n#title[_v-0a9d4452] {\n  border-left: none;\n  border-right: none; }\n\n/* line 19, stdin */\n.content-type-show[_v-0a9d4452] {\n  margin-bottom: 10px; }\n\n/* line 22, stdin */\n.content-text[_v-0a9d4452] {\n  margin-top: 5px; }\n\n/* line 25, stdin */\n.append-all[_v-0a9d4452] {\n  min-height: 40px;\n  font-size: 18px; }\n\n/* line 29, stdin */\n.select-customer[_v-0a9d4452] {\n  margin-top: 8px;\n  margin-right: -15px;\n  font-size: 16px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['studioId'],
    data: function data() {
        return {
            selectMembers: [],
            currentmemberIds: [],
            title: "",
            contentType: 'text_messages',
            contentTextarea: '',
            ajaxingAppendMember: false,
            ajaxingSubmit: false,
            appendAll: false,
            appendTemp: false,
            allBindNumber: 0,
            ajaxingEvents: false,
            selectedEvent: '',
            selectedBranch: '',
            eventList: [],
            branchList: []
        };
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['branchId', 'isBranch']), (0, _vuex.mapState)({
        userMemberId: 'user_member_id'
    }), {
        selectedNumber: function selectedNumber() {
            if (this.appendAll || this.appendTemp) {
                return this.allBindNumber;
            }
            return this.currentmemberIds.length;
        },
        showSelectMember: function showSelectMember() {
            if (!this.appendAll && this.selectMembers.length > 0) {
                return true;
            }

            return false;
        }
    }),
    mounted: function mounted() {
        $(".selected-customer").find(".multiselect__content-wrapper").css('max-height', 0);
    },

    methods: {
        submit: function submit() {
            var _this = this;

            if (this.title.length == 0) {
                this.alert('訊息主旨不可為空白', '', 'warning');
                return;
            }
            if (this.currentmemberIds.length == 0 && !this.appendAll && !this.appendTemp) {
                this.alert('至少要選擇一個客戶', '', 'warning');
                return;
            }
            switch (this.contentType) {
                case 'text_messages':
                    if (this.contentTextarea.length == 0) {
                        this.alert('訊息內容不可為空白', '', 'warning');
                        return;
                    }
                    break;
                case 'event_messages':
                    if (this.selectedEvent.length == 0) {
                        this.alert('請選擇活動', '', 'warning');
                        return;
                    }
                    break;
            }
            this.ajaxingSubmit = true;
            $('#append-message-moddal').modal('hide');

            $17.swal({
                title: '傳送中',
                text: '請稍後',
                type: 'warning',
                showCancelButton: false,
                showConfirmButton: false
            });

            this.$http.post('/adminapi/message/', {
                'type': this.contentType,
                'member_ids': (0, _stringify2.default)(this.currentmemberIds),
                'append_temp': this.appendTemp,
                'append_all': this.appendAll,
                'studio_id': this.studioId,
                'title': this.title,
                'message': this.contentType == 'event_messages' ? '' : this.contentTextarea,
                'event_id': this.contentType == 'event_messages' ? this.selectedEvent : '',
                'setting_studio_id': (0, _stringify2.default)([1, this.studioId])
            }).then(function (response) {
                _this.ajaxingSubmit = false;
                _this.alert('已傳送' + response.data.sentNumber + '則', '', 'success');
                _this.resetDefault();
                _this.$emit('message-sent');
            }, function (error) {
                if (error.response.status == '504') {
                    _this.alert('訊息發送中，請過數分鐘後至訊息列表確認', '', 'error');
                } else {
                    _this.alert('傳送失敗', error.body.message, 'error');
                    $('#append-message-moddal').modal('show');
                }

                _this.ajaxingSubmit = false;
            });
        },
        appendMember: function appendMember(payload) {
            this.appendMembers(payload.memberIds);
        },
        selectMemberHandler: function selectMemberHandler(member) {
            this.appendMembers([member.id]);
        },
        appendMembers: function appendMembers(memberIds) {
            var _this2 = this;

            if (!this.studioId) {
                return;
            }
            this.ajaxingAppendMember = true;
            newMemberIds = this.currentmemberIds.concat(memberIds);

            this.$http.post('/adminapi/member/muti', {
                'ids': newMemberIds,
                'studio_id': this.studioId
            }).then(function (response) {
                _this2.selectMembers = response.data.customers;
                _this2.ajaxingAppendMember = false;
            }, function (error) {
                _this2.ajaxingAppendMember = false;
            });
        },

        appendBindedCustomer: function () {
            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                var _this3 = this;

                var memberIds;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (this.studioId) {
                                    _context.next = 2;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 2:
                                if (!this.appendAll) {
                                    _context.next = 6;
                                    break;
                                }

                                this.appendAll = false;
                                this.allBindNumber = 0;
                                return _context.abrupt('return');

                            case 6:

                                this.ajaxingAppendMember = true;
                                memberIds = [];

                                this.appendAll = true;

                                _context.next = 11;
                                return this.$http.get('/adminapi/member/binded_number?studio_id=' + this.studioId).then(function (response) {
                                    _this3.allBindNumber = response.data;
                                    _this3.selectMembers = [];
                                    _this3.ajaxingAppendMember = false;
                                }, function (error) {
                                    _this3.ajaxingAppendMember = false;
                                    _this3.appendAll = false;
                                });

                            case 11:
                                this.syncSelectMembers(this.selectMembers);

                            case 12:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function appendBindedCustomer() {
                return _ref.apply(this, arguments);
            }

            return appendBindedCustomer;
        }(),
        appendTempCustomer: function () {
            var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                var _this4 = this;

                var memberIds;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (this.studioId) {
                                    _context2.next = 2;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 2:
                                if (!this.appendTemp) {
                                    _context2.next = 6;
                                    break;
                                }

                                this.appendTemp = false;
                                this.allBindNumber = 0;
                                return _context2.abrupt('return');

                            case 6:

                                this.ajaxingAppendMember = true;
                                memberIds = [];

                                this.appendTemp = true;

                                _context2.next = 11;
                                return this.$http.get('/adminapi/customers/temporary/bind_number').then(function (response) {
                                    _this4.allBindNumber = response.data;
                                    _this4.selectMembers = [];
                                    _this4.ajaxingAppendMember = false;
                                }, function (error) {
                                    _this4.ajaxingAppendMember = false;
                                    _this4.appendTemp = false;
                                });

                            case 11:
                                this.syncSelectMembers(this.selectMembers);

                            case 12:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function appendTempCustomer() {
                return _ref2.apply(this, arguments);
            }

            return appendTempCustomer;
        }(),
        syncSelectMembers: function syncSelectMembers(selectMembers) {
            memberIds = selectMembers.map(function (member) {
                return member.id;
            });
            this.currentmemberIds = memberIds;
        },
        resetDefault: function resetDefault() {
            this.selectMembers = [];
            this.currentmemberIds = [];
            this.title = "";
            this.contentType = 'text_messages';
            this.contentTextarea = '';
            this.appendAll = false;
            this.selectedEvent = '';
            this.selectedBranch = '';
            this.eventList = [];
            this.branchList = [];
        },
        emitSubmit: function emitSubmit() {
            this.$emit('ajaxing', this.ajaxingSubmit);
        },
        onCall: function onCall(action) {
            if (action == 'create') {
                this.resetDefault();
            }
            if (this.isBranch) {
                this.selectedBranch = this.branchId;
                this.fetchEvents();
            }
        },
        getBranchList: function getBranchList() {
            var _this5 = this;

            if (this.selectedBranch == '' && this.branchId == 0 && this.branchList.length == 0) {
                this.ajaxingEvents = true;
                this.$http.get('/adminapi/init/branch_select_list?studio_id=' + this.studioId).then(function (response) {
                    _this5.ajaxingEvents = false;
                    _this5.branchList = response.body.branches;
                });
            }
        },
        fetchEvents: function fetchEvents() {
            var _this6 = this;

            this.selectedEvent = '';
            this.ajaxingEvents = true;
            this.$http.get('/adminapi/event/?branch_id=' + this.selectedBranch).then(function (response) {
                _this6.eventList = response.body;
                _this6.ajaxingEvents = false;
            }, function (error) {
                _this6.ajaxingEvents = false;
            });
        },

        alert: function alert(title, message, type) {
            $17.swal({
                title: title,
                text: message,
                type: type,
                showCancelButton: false
            });
        }
    },
    watch: {
        selectMembers: function selectMembers(newVal, oldVal) {
            this.syncSelectMembers(newVal);
        },
        ajaxingSubmit: function ajaxingSubmit(newVal) {
            this.emitSubmit();
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal id=\"append-message-moddal\" :save-clicked=\"submit\" :remove-btn-show=\"false\" confirm-btn-text=\"確認發送\" _v-0a9d4452=\"\">\n    <span slot=\"title\" _v-0a9d4452=\"\">透過17FIT傳送通知({{ selectedNumber }}人)</span>\n    <template slot=\"body\">\n        <div class=\"row\" _v-0a9d4452=\"\">\n            <div class=\"col-xs-4 col-sm-2\" _v-0a9d4452=\"\">\n                <label for=\"\" class=\"select-customer\" _v-0a9d4452=\"\">選擇客戶:</label>\n            </div>\n            <div class=\"col-xs-8 col-sm-10\" v-show=\"!appendAll &amp;&amp; !appendTemp\" _v-0a9d4452=\"\">\n                <v-member-selector-binding :studio-id=\"studioId\" :keep=\"true\" :member-change=\"selectMemberHandler\" :clear-when-select=\"true\" v-if=\"studioId !==0\" :disabled=\"appendAll\" _v-0a9d4452=\"\">\n                \n            </v-member-selector-binding></div>\n            <div class=\"col-xs-8 col-sm-10\" v-show=\"appendTemp\" _v-0a9d4452=\"\">\n                <p class=\"select-customer\" _v-0a9d4452=\"\">所有暫存客戶</p>\n            </div>\n            <div class=\"col-xs-8 col-sm-10\" v-show=\"appendAll\" _v-0a9d4452=\"\">\n                <p class=\"select-customer\" _v-0a9d4452=\"\">所有客戶</p>\n            </div>\n        </div>\n        <div class=\"row\" _v-0a9d4452=\"\">\n            <div class=\"col-xs-12 selected-customer\" v-show=\"!ajaxingAppendMember\" _v-0a9d4452=\"\">\n                <v-mutiselect :model.sync=\"selectMembers\" :options=\"selectMembers\" :multiple=\"true\" :close-on-select=\"true\" :clear-on-select=\"true\" :searchable=\"false\" label=\"name\" track-by=\"id\" tag-name=\"name\" placeholder=\"目前沒有任何已選取的客戶\" v-show=\"showSelectMember\" _v-0a9d4452=\"\">\n                </v-mutiselect>\n            </div>\n            <div class=\"col-xs-12 selected-customer\" v-show=\"ajaxingAppendMember\" _v-0a9d4452=\"\">\n                <v-spinner :ajaxing=\"ajaxingAppendMember\" _v-0a9d4452=\"\"></v-spinner>\n            </div>\n        </div>\n        <div class=\"row\" _v-0a9d4452=\"\">\n            <div class=\"inline pull-right m-right-15\" _v-0a9d4452=\"\">\n                <div class=\"btn btn-default append-all\" v-show=\"!appendTemp\" @click.prevent.stop=\"appendBindedCustomer\" _v-0a9d4452=\"\">\n                    <span v-show=\"!appendAll\" _v-0a9d4452=\"\">加入所有客戶</span>\n                    <span v-show=\"appendAll\" _v-0a9d4452=\"\">取消加入所有客戶</span>\n                </div>\n                <div class=\"btn btn-default append-all\" v-show=\"!appendAll\" @click.prevent.stop=\"appendTempCustomer\" _v-0a9d4452=\"\">\n                    <span v-show=\"!appendTemp\" _v-0a9d4452=\"\">加入暫存客戶</span>\n                    <span v-show=\"appendTemp\" _v-0a9d4452=\"\">取消加入暫存客戶</span>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\" _v-0a9d4452=\"\">\n            <div class=\"col-xs-12\" _v-0a9d4452=\"\">\n                <input type=\"text\" name=\"title\" id=\"title\" v-model=\"title\" placeholder=\"主旨\" _v-0a9d4452=\"\">\n            </div>\n        </div>\n        <div class=\"row\" _v-0a9d4452=\"\">\n            <div class=\"col-xs-12 content-text\" _v-0a9d4452=\"\">\n                <label for=\"content-type\" _v-0a9d4452=\"\">內容</label>\n            </div>\n        </div>\n        <div class=\"row\" _v-0a9d4452=\"\">\n            <div class=\"col-xs-12 content-type-show\" _v-0a9d4452=\"\">\n                <label class=\"m-right-10\" _v-0a9d4452=\"\">\n                    <input type=\"radio\" name=\"content-type\" value=\"text_messages\" id=\"content-type\" v-model=\"contentType\" _v-0a9d4452=\"\"> 純文字\n                </label>\n                <label @click=\"getBranchList\" _v-0a9d4452=\"\">\n                    <input type=\"radio\" name=\"content-type\" value=\"event_messages\" v-model=\"contentType\" _v-0a9d4452=\"\"> 活動\n                </label>\n            </div>\n        </div>\n        <div class=\"row\" _v-0a9d4452=\"\">\n            <div class=\"col-xs-12\" _v-0a9d4452=\"\">\n                <textarea name=\"\" id=\"content-textarea\" cols=\"30\" rows=\"10\" v-if=\"contentType=='text_messages'\" v-model=\"contentTextarea\" _v-0a9d4452=\"\"></textarea>\n                <div class=\"text-center\" v-else=\"\" _v-0a9d4452=\"\">\n                    <v-spinner-button :ajaxing=\"ajaxingEvents\" _v-0a9d4452=\"\"></v-spinner-button>\n                    <div v-show=\"!ajaxingEvents\" _v-0a9d4452=\"\">\n                        <div class=\"col-xs-6 col-sm-4 p-left-0 p-right-0\" v-if=\"!isBranch\" _v-0a9d4452=\"\">\n                            <select v-model=\"selectedBranch\" class=\"form-control\" @change=\"fetchEvents\" _v-0a9d4452=\"\">\n                                <option value=\"\" :selected=\"selectedBranch===null||selectedBranch==''\" _v-0a9d4452=\"\">請選擇場館</option>\n                                <option :selected=\"selectedBranch==branch.id\" :value=\"branch.id\" v-for=\"branch in branchList\" _v-0a9d4452=\"\">\n                                    {{branch.branch_name}}\n                                </option>\n                            </select>\n                        </div>\n                        <div :class=\"[isBranch?'col-xs-12':'col-xs-6 col-sm-8']\" class=\"p-left-0 p-right-0\" _v-0a9d4452=\"\">\n                            <select v-model=\"selectedEvent\" class=\"form-control\" _v-0a9d4452=\"\">\n                                <option value=\"\" :selected=\"selectedEvent===null||selectedEvent==''\" _v-0a9d4452=\"\">請選擇活動</option>\n                                <option :selected=\"selectedEvent==event.id\" :value=\"event.id\" v-for=\"event in eventList\" _v-0a9d4452=\"\">\n                                    {{event.name}}\n                                </option>\n                            </select>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </template>\n</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n#append-message-moddal .modal-content {\n  max-height: 90vh; }\n\n/* line 5, stdin */\n#append-message-moddal .selected-customer .multiselect {\n  max-height: 20vh;\n  overflow-y: scroll; }\n  /* line 8, stdin */\n  #append-message-moddal .selected-customer .multiselect .multiselect--active, #append-message-moddal .selected-customer .multiselect .multiselect__content, #append-message-moddal .selected-customer .multiselect .multiselect__select {\n    display: none; }\n\n/* line 2, stdin */\n.selected-customer[_v-0a9d4452] {\n  max-height: 20vh; }\n\n/* line 5, stdin */\n#title[_v-0a9d4452] {\n  width: 100%; }\n\n/* line 8, stdin */\n.row[_v-0a9d4452] {\n  margin-top: 5px;\n  margin-bottom: 5px; }\n\n/* line 12, stdin */\n#content-textarea[_v-0a9d4452] {\n  max-height: 40vh; }\n\n/* line 15, stdin */\n#title[_v-0a9d4452] {\n  border-left: none;\n  border-right: none; }\n\n/* line 19, stdin */\n.content-type-show[_v-0a9d4452] {\n  margin-bottom: 10px; }\n\n/* line 22, stdin */\n.content-text[_v-0a9d4452] {\n  margin-top: 5px; }\n\n/* line 25, stdin */\n.append-all[_v-0a9d4452] {\n  min-height: 40px;\n  font-size: 18px; }\n\n/* line 29, stdin */\n.select-customer[_v-0a9d4452] {\n  margin-top: 8px;\n  margin-right: -15px;\n  font-size: 16px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-0a9d4452", module.exports)
  } else {
    hotAPI.update("_v-0a9d4452", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/json/stringify":48,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1237:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.logo[_v-b775a5e8] {\n  max-width: 8.333; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vuex = require('vuex');

exports.default = {
    mounted: function mounted() {},

    data: function data() {
        return {
            content: [],
            title: null,
            ajaxing: false
        };
    },
    props: ['openId'],
    computed: {},
    methods: {
        submit: function submit() {
            $(this.$el).modal('hide');
        },
        getContentComponent: function getContentComponent(contentItem) {
            switch (contentItem.dataType) {
                case 'text':
                    return 'v-messages-text-content';
                case 'gallery':
                    return 'v-messages-gallery-content';
                case 'action_buy':
                    return 'v-messages-action-buy-content';
                case 'action_url':
                    return 'v-messages-action-url-content';
                default:
                    break;
            }
        }
    },
    watch: {
        openId: function openId(val) {
            var _this = this;

            if (val == null) {
                return;
            }
            this.ajaxing = true;
            this.$http.get('/adminapi/message/' + val).then(function (response) {
                _this.ajaxing = false;
                _this.content = response.data.content;
                _this.title = response.data.title;
            }, function (error) {
                _this.ajaxing = false;
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal id=\"message-content-modal\" :save-clicked=\"submit\" :remove-btn-show=\"false\" no-cancel=\"\" confirm-btn-text=\"關閉\" _v-b775a5e8=\"\">\n    <span slot=\"title\" _v-b775a5e8=\"\">通知訊息</span>\n    <template slot=\"body\">\n        <v-spinner :ajaxing=\"ajaxing\" _v-b775a5e8=\"\"></v-spinner>\n        <template v-if=\"!ajaxing\">\n            <div class=\"clearfix\" _v-b775a5e8=\"\">\n                <label class=\"col-sm-2\" _v-b775a5e8=\"\">主旨</label>\n                <div class=\"col-sm-10\" _v-b775a5e8=\"\">{{title}}</div>\n            </div>\n            <hr _v-b775a5e8=\"\">\n            <div class=\"clearfix\" _v-b775a5e8=\"\">\n                <label class=\"col-sm-2\" _v-b775a5e8=\"\">內文</label>\n                <div class=\"col-sm-10\" _v-b775a5e8=\"\">\n                    <div class=\"col-xs-12\" v-for=\"row in content\" _v-b775a5e8=\"\">\n                        <component :is=\"getContentComponent(row)\" :data=\"row\" _v-b775a5e8=\"\"></component>\n                    </div>\n                </div>\n            </div>\n        </template>\n    </template>\n</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.logo[_v-b775a5e8] {\n  max-width: 8.333; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-b775a5e8", module.exports)
  } else {
    hotAPI.update("_v-b775a5e8", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1238:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _list = require('./list.vue');

var _list2 = _interopRequireDefault(_list);

var _appendModal = require('./append-modal.vue');

var _appendModal2 = _interopRequireDefault(_appendModal);

var _contentModal = require('./content-modal.vue');

var _contentModal2 = _interopRequireDefault(_contentModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('webadmin-message-list', _list2.default);
_vue2.default.component('webadmin-append-message-modal', _appendModal2.default);
_vue2.default.component('webadmin-content-message-modal', _contentModal2.default);

},{"./append-modal.vue":1236,"./content-modal.vue":1237,"./list.vue":1239,"vue":792}],1239:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.row[_v-71656f3b] {\n  margin-top: 15px; }\n\n/* line 5, stdin */\n.list > .row[_v-71656f3b] {\n  border-bottom: 1px solid #797e83; }\n\n/* line 8, stdin */\n.message-list[_v-71656f3b] {\n  cursor: pointer; }\n\n/* line 12, stdin */\n.table-responsive td[_v-71656f3b]:nth-child(2) {\n  max-width: 15em;\n  overflow: hidden;\n  text-overflow: ellipsis; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            ajaxingList: false,
            remain: 0,
            list: {},
            openId: null,
            ajaxingSubmit: false
        };
    },

    watch: {
        studioId: function studioId() {
            this.getList();
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'isSeventeen'])),
    mounted: function mounted() {},
    methods: {
        showDetail: function showDetail(id) {
            this.openId = id;
            $('#message-content-modal').modal('show');
        },
        appendNewMessage: function appendNewMessage() {
            this.$refs.messageModal.onCall('create');
            $('#append-message-moddal').modal('show');
        },
        getList: function getList() {
            var _this = this;

            this.ajaxingList = true;
            this.$http.get('/adminapi/message/list/' + this.studioId).then(function (response) {
                _this.list = response.data.list;
                _this.remain = response.data.remain;
                _this.ajaxingList = false;
            }, function (error) {
                _this.ajaxingList = false;
            });
        },
        modalAjaxing: function modalAjaxing(current) {
            this.ajaxingSubmit = current;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"container\" _v-71656f3b=\"\">\n    <v-spinner :ajaxing=\"ajaxingSubmit\" _v-71656f3b=\"\"></v-spinner>\n    <div v-show=\"!ajaxingSubmit\" _v-71656f3b=\"\">\n        <div class=\"row\" _v-71656f3b=\"\">\n            <div class=\"col-xs-6\" _v-71656f3b=\"\">\n                <a href=\"#\" class=\"btn btn-success\" @click=\"appendNewMessage\" _v-71656f3b=\"\">\n                    <i class=\"fa fa-plus\" _v-71656f3b=\"\"></i> 新增通知\n                </a>\n            </div>\n            <div class=\"col-xs-6 text-right\" _v-71656f3b=\"\">\n                剩餘:{{ remain }} 則\n            </div>\n        </div>\n        <div class=\"row\" _v-71656f3b=\"\">\n            <div class=\"col-xs-12 border-bottom\" _v-71656f3b=\"\">\n                <small class=\"notice color-gray\" _v-71656f3b=\"\">\n                    傳送通知，客戶可以在ＡＰＰ或網站查看訊息\n                </small>\n            </div>\n        </div>\n        <div class=\"table-responsive m-top-20\" v-show=\"!ajaxingList\" _v-71656f3b=\"\">\n            <table class=\"table\" _v-71656f3b=\"\">\n                <thead _v-71656f3b=\"\">\n                <tr _v-71656f3b=\"\">\n                    <th class=\"col-sm-2\" _v-71656f3b=\"\">時間</th>\n                    <th class=\"col-sm-8\" _v-71656f3b=\"\">主旨</th>\n                    <th class=\"col-sm-1 text-center\" _v-71656f3b=\"\">已讀人數</th>\n                    <th class=\"col-sm-1 text-center\" _v-71656f3b=\"\">通知人數</th>\n                </tr>\n                </thead>\n                <tbody _v-71656f3b=\"\">\n                <tr class=\"message-list\" v-for=\"item in list\" @click=\"showDetail(item.id)\" _v-71656f3b=\"\">\n                    <td class=\"color-gray\" _v-71656f3b=\"\">{{ item.sent_time}}</td>\n                    <td _v-71656f3b=\"\">{{ item.title}}</td>\n                    <td class=\"text-center\" _v-71656f3b=\"\">{{ item.read_times}}</td>\n                    <td class=\"text-center\" _v-71656f3b=\"\">{{ item.sent_number}}</td>\n                </tr>\n                </tbody>\n            </table>\n        </div>\n        <div _v-71656f3b=\"\">\n            <v-spinner :ajaxing=\"ajaxingList\" _v-71656f3b=\"\"></v-spinner>\n        </div>\n    </div>\n    <webadmin-append-message-modal ref=\"messageModal\" @message-sent=\"getList\" @ajaxing=\"modalAjaxing\" :studio-id=\"studioId\" _v-71656f3b=\"\">\n    </webadmin-append-message-modal>\n    <webadmin-content-message-modal :open-id=\"openId\" _v-71656f3b=\"\">\n    </webadmin-content-message-modal>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.row[_v-71656f3b] {\n  margin-top: 15px; }\n\n/* line 5, stdin */\n.list > .row[_v-71656f3b] {\n  border-bottom: 1px solid #797e83; }\n\n/* line 8, stdin */\n.message-list[_v-71656f3b] {\n  cursor: pointer; }\n\n/* line 12, stdin */\n.table-responsive td[_v-71656f3b]:nth-child(2) {\n  max-width: 15em;\n  overflow: hidden;\n  text-overflow: ellipsis; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-71656f3b", module.exports)
  } else {
    hotAPI.update("_v-71656f3b", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1240:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _setting = require('./setting.vue');

var _setting2 = _interopRequireDefault(_setting);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('webadmin-notify-setting', _setting2.default);

},{"./setting.vue":1241,"vue":792}],1241:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.inputs[_v-52faeddf] {\n  display: inline-block;\n  width: 80px; }\n\n/* line 8, stdin */\n.config-table th[_v-52faeddf], .config-table tr[_v-52faeddf], .config-table td[_v-52faeddf] {\n  border: 0; }\n\n/* line 13, stdin */\n.handler[_v-52faeddf] {\n  width: 100px;\n  font-weight: bold; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      ajaxing: false,
      open_notify_system: 1,
      notify_system_id: 0,
      titles: {
        1: '服務預約 - 成功',
        2: '服務預約 - 取消',
        3: '預約 - 即將到來',
        4: '自動支付 - 續約訂閱',
        5: '自動支付 - 取消訂閱',
        6: '自動支付 - 付款失敗',
        7: '課程預約 - 停課'
      },
      label: { //需要把email 或是 line bot 前綴給拿掉
        'online_booking_service_notify_customer': '通知消費者',
        'online_booking_service_notify_provider': '通知服務提供者',
        'online_booking_service_notify_branch_contact': '通知場館',
        'online_cancel_service_notify_customer': '通知消費者',
        'online_cancel_service_notify_provider': '通知服務提供者',
        'online_cancel_service_notify_branch_contact': '通知場館',
        'online_oncoming_service_notify_customer': '通知消費者',
        'admin_auto_pay_auto_renewal_success_notify_customer': '通知消費者',
        'admin_auto_pay_task_failed_notify_customer': '通知消費者',
        'general_auto_pay_auto_renewal_terminated_notify_customer': '通知消費者',
        'class_schedule_terminated_notify_customer': '通知消費者'
      },
      event_hooks: {}
    };
  },
  mounted: function mounted() {},

  watch: {
    branchId: function branchId(val) {
      this.getConfig();
    }
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId', 'isSeventeen', 'isStudio', 'isBranch']), (0, _vuex.mapState)({
    canUpdate: function canUpdate(state) {
      return state.webadmin.configure.webFunctions.WebadminNotifyDefaultIndex;
    }
  }), {
    disabledSave: function disabledSave() {
      if (this.isBranch && this.open_notify_system == 1) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = (0, _getIterator3.default)((0, _entries2.default)(this.event_hooks)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _step$value = (0, _slicedToArray3.default)(_step.value, 2),
                key = _step$value[0],
                hook_types = _step$value[1];

            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = (0, _getIterator3.default)((0, _entries2.default)(hook_types)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var _step2$value = (0, _slicedToArray3.default)(_step2.value, 2),
                    online_hook_key = _step2$value[0],
                    hook = _step2$value[1];

                //暫時先跳過不顯示17跟admin
                if (!this.checkKeyShow(online_hook_key)) {
                  continue;
                }
                if (hook.show_front) {
                  return false;
                }
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      if (this.isStudio && (this.notify_system_id > 0 || this.notify_system_id == 0 && this.open_notify_system == 1)) {
        return false;
      }

      return true;
    },
    showBranchAllowOverWritten: function showBranchAllowOverWritten() {
      return false;
    },
    specialHideItem: function specialHideItem() {
      return ['seventeen_booking_service_notify_customer', 'seventeen_booking_service_notify_provider', 'seventeen_booking_service_notify_branch_contact', 'admin_booking_service_notify_customer', 'admin_booking_service_notify_provider', 'admin_booking_service_notify_branch_contact', 'seventeen_cancel_service_notify_customer', 'seventeen_cancel_service_notify_provider', 'seventeen_cancel_service_notify_branch_contact', 'admin_cancel_service_notify_customer', 'admin_cancel_service_notify_provider', 'admin_cancel_service_notify_branch_contact'];
    }
  }),
  methods: {
    checkKeyPress: function checkKeyPress(e) {
      if (e.charCode === 46 || e.charCode === 45) {
        e.preventDefault();
      }
    },
    validate: function validate() {
      this.save();
    },
    getConfig: function getConfig() {
      var _this = this;

      this.ajaxing = true;
      this.$http.get('/adminapi/notify/setting').then(function (response) {
        var data = response.data.data;
        _this.open_notify_system = data.open_notify_system;
        if (data.hasOwnProperty('notify_system')) {
          _this.notify_system_id = data.notify_system.id;
          _this.event_hooks = data.event_hooks;
        } else {
          _this.notify_system_id = 0;
        }
        _this.ajaxing = false;
      }).catch(function (response) {
        _this.alert('error', '取得紅利設定失敗');
        _this.ajaxing = false;
      });
    },
    save: function save() {
      var _this2 = this;

      this.ajaxing = true;
      var postData = this.generatePostData();
      this.$http.post('/adminapi/notify/setting', postData).then(function (response) {
        _this2.alert('success', '儲存成功');
        _this2.ajaxing = false;
        _this2.getConfig();
      }).catch(function (response) {
        _this2.alert('error', '儲存失敗');
        _this2.ajaxing = false;
      });
    },
    generatePostData: function generatePostData() {
      var postData = {};
      postData.open_notify_system = this.open_notify_system;
      postData.notify_system_id = this.notify_system_id;
      event_hooks = _lodash2.default.cloneDeep(this.event_hooks);

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = (0, _getIterator3.default)((0, _entries2.default)(event_hooks)), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var _step3$value = (0, _slicedToArray3.default)(_step3.value, 2),
              key = _step3$value[0],
              hook_types = _step3$value[1];

          var _iteratorNormalCompletion4 = true;
          var _didIteratorError4 = false;
          var _iteratorError4 = undefined;

          try {
            for (var _iterator4 = (0, _getIterator3.default)((0, _entries2.default)(hook_types)), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
              var _step4$value = (0, _slicedToArray3.default)(_step4.value, 2),
                  online_hook_key = _step4$value[0],
                  hook = _step4$value[1];

              if (hook['email']) {
                if (this.checkKeyShow(online_hook_key)) {
                  seventeen_key = online_hook_key.replace('online', 'seventeen');
                  admin_key = online_hook_key.replace('online', 'admin');
                  var is_enable = hook.email['is_enable'];
                  event_hooks[key][seventeen_key].email['is_enable'] = is_enable;
                  event_hooks[key][seventeen_key].email['can_be_overwritten'] = is_enable;
                  event_hooks[key][admin_key].email['is_enable'] = is_enable;
                  event_hooks[key][admin_key].email['can_be_overwritten'] = is_enable;
                }
              }
            }
          } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion4 && _iterator4.return) {
                _iterator4.return();
              }
            } finally {
              if (_didIteratorError4) {
                throw _iteratorError4;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      postData.event_hooks = event_hooks;
      return postData;
    },
    alert: function alert(type, title) {
      var text = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var html = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

      $17.swal({
        title: title,
        text: text,
        type: type,
        html: html,
        showCancelButton: false
      });
    },
    resetOverWritten: function resetOverWritten(type, index) {
      this.event_hooks[type][index]['can_be_overwritten'] = 0;
    },
    checkKeyShow: function checkKeyShow(key) {
      if (this.specialHideItem.includes(key)) {
        return false;
      }
      return true;
    },
    checkEmailShow: function checkEmailShow(key) {
      if (this.specialHideItem.indexOf(key) != -1) {
        return false;
      }
      return key.includes("email");
    },
    checkLineShow: function checkLineShow(key) {
      if (this.specialHideItem.indexOf(key) != -1) {
        return false;
      }
      return key.includes("line");
    }
  }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-52faeddf=\"\">\n    <v-spinner :ajaxing=\"ajaxing\" _v-52faeddf=\"\"></v-spinner>\n    <div class=\"col-xs-12 m-bottom-50\" v-if=\"!ajaxing&amp;&amp;canUpdate\" _v-52faeddf=\"\">\n        <h2 _v-52faeddf=\"\">通知設定</h2>\n        <h4 v-if=\"isStudio&amp;&amp;false\" _v-52faeddf=\"\">品牌設定</h4>\n        <h4 v-if=\"isBranch&amp;&amp;false\" _v-52faeddf=\"\">場館設定</h4>\n\n        <div v-if=\"!disabledSave\" _v-52faeddf=\"\">\n            <div class=\"table-responsive\" v-for=\"(category, key) in event_hooks\" _v-52faeddf=\"\">\n                <h4 class=\"m-top-30\" _v-52faeddf=\"\">{{ titles[(key)] }}</h4>\n                <table class=\"table\" style=\"border: 1px solid #c7c4c3;\" _v-52faeddf=\"\">\n                    <thead _v-52faeddf=\"\">\n                    <tr _v-52faeddf=\"\">\n                        <th class=\"active\" _v-52faeddf=\"\">\n                            通知項目\n                        </th>\n                        <th class=\"active\" style=\"text-align: center;\" _v-52faeddf=\"\">\n                            <i class=\"fa fa-envelope m-right-5\" _v-52faeddf=\"\"></i>EMAIL\n                        </th>\n                        <th class=\"active\" style=\"text-align: center;\" _v-52faeddf=\"\">\n                            <img src=\"/images/mdi_line.png\" width=\"20px\" class=\"\" _v-52faeddf=\"\"> LINE推播\n                        </th>\n                    </tr>\n                    </thead>\n                    <tbody _v-52faeddf=\"\">\n                        <template>\n                            <tr v-for=\"(event_hook, index) in category\" v-show=\"checkKeyShow(index)\" _v-52faeddf=\"\">\n                              <td class=\"col-md-10\" _v-52faeddf=\"\">{{label[(index)]}}</td>\n                              <td class=\"text-center col-md-1\" _v-52faeddf=\"\">\n                                <div v-for=\"(email_hook, index) in event_hook\" _v-52faeddf=\"\">\n                                  <input type=\"checkbox\" v-model=\"email_hook.is_enable\" :true-value=\"1\" :false-value=\"0\" v-show=\"checkEmailShow(index)\" _v-52faeddf=\"\">\n                                </div>\n                              </td>\n                              <td class=\"text-center col-md-1\" _v-52faeddf=\"\">\n                                <div v-for=\"(line_hook, index) in event_hook\" _v-52faeddf=\"\">\n                                    <input type=\"checkbox\" v-model=\"line_hook.is_enable\" :true-value=\"1\" :false-value=\"0\" v-show=\"checkLineShow(index)\" _v-52faeddf=\"\">\n                                </div>\n                              </td>\n                            </tr>\n                        </template>\n                    </tbody>\n                </table>\n            </div>\n        </div>\n        <div class=\"text-center\" v-if=\"disabledSave&amp;&amp;isBranch\" _v-52faeddf=\"\">\n            無設定可編輯\n        </div>\n        <div class=\"text-center m-top-50\" v-if=\"!disabledSave\" _v-52faeddf=\"\">\n            <button class=\"btn btn-primary\" @click.prevent=\"validate()\" _v-52faeddf=\"\">儲存</button>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.inputs[_v-52faeddf] {\n  display: inline-block;\n  width: 80px; }\n\n/* line 8, stdin */\n.config-table th[_v-52faeddf], .config-table tr[_v-52faeddf], .config-table td[_v-52faeddf] {\n  border: 0; }\n\n/* line 13, stdin */\n.handler[_v-52faeddf] {\n  width: 100px;\n  font-weight: bold; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-52faeddf", module.exports)
  } else {
    hotAPI.update("_v-52faeddf", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/get-iterator":46,"babel-runtime/core-js/object/entries":54,"babel-runtime/helpers/extends":66,"babel-runtime/helpers/slicedToArray":70,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1242:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _modifyPlanFunctionGroup = require('./modify-plan-function-group.vue');

var _modifyPlanFunctionGroup2 = _interopRequireDefault(_modifyPlanFunctionGroup);

var _planFunctionSelectModal = require('./plan-function-select-modal.vue');

var _planFunctionSelectModal2 = _interopRequireDefault(_planFunctionSelectModal);

var _planFunctionGroupList = require('./plan-function-group-list.vue');

var _planFunctionGroupList2 = _interopRequireDefault(_planFunctionGroupList);

var _webFunctionGroupUpdateModal = require('./web-function-group-update-modal.vue');

var _webFunctionGroupUpdateModal2 = _interopRequireDefault(_webFunctionGroupUpdateModal);

var _planList = require('./plan-list.vue');

var _planList2 = _interopRequireDefault(_planList);

var _planEdit = require('./plan-edit.vue');

var _planEdit2 = _interopRequireDefault(_planEdit);

var _planCreate = require('./plan-create.vue');

var _planCreate2 = _interopRequireDefault(_planCreate);

var _planFunctionList = require('./plan-function-list.vue');

var _planFunctionList2 = _interopRequireDefault(_planFunctionList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//Page 
_vue2.default.component('webadmin-modify-plan-function-group', _modifyPlanFunctionGroup2.default);
_vue2.default.component('webadmin-plan-function-select-modal', _planFunctionSelectModal2.default);
_vue2.default.component('webadmin-plan-function-group-list', _planFunctionGroupList2.default);
_vue2.default.component('webadmin-web-function-group-update-modal', _webFunctionGroupUpdateModal2.default);
_vue2.default.component('webadmin-plan-list', _planList2.default);
_vue2.default.component('webadmin-plan-edit', _planEdit2.default);
_vue2.default.component('webadmin-plan-create', _planCreate2.default);
_vue2.default.component('webadmin-plan-function-list', _planFunctionList2.default);

},{"./modify-plan-function-group.vue":1243,"./plan-create.vue":1244,"./plan-edit.vue":1245,"./plan-function-group-list.vue":1246,"./plan-function-list.vue":1247,"./plan-function-select-modal.vue":1248,"./plan-list.vue":1249,"./web-function-group-update-modal.vue":1250,"vue":792}],1243:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.radio-margin + .radio-margin[_v-79bb997c] {\n  margin-left: 10px; }\n\n/* line 6, stdin */\ninput[_v-79bb997c], textarea[_v-79bb997c], select[_v-79bb997c] {\n  max-width: 500px; }\n\n/* line 10, stdin */\n.input-group input[_v-79bb997c] {\n  max-width: inherit; }\n\n/* line 14, stdin */\n.input-group[_v-79bb997c] {\n  max-width: 200px; }\n\n/* line 18, stdin */\nspan.label[_v-79bb997c] {\n  font-size: 14px;\n  margin-left: 30px; }\n\n/* line 23, stdin */\nspan.attention[_v-79bb997c] {\n  color: red;\n  font-weight: 700; }\n\n/* line 28, stdin */\n.p-t-0[_v-79bb997c] {\n  padding-top: 0 !important; }\n\n/* line 32, stdin */\ntextarea[_v-79bb997c] {\n  margin: 0; }\n\n/* line 36, stdin */\n#finish-form[_v-79bb997c] {\n  margin-top: 50px; }\n\n/* line 40, stdin */\n.modify-fee[_v-79bb997c] {\n  margin: 50px 0; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vuex = require('vuex');

exports.default = {
    props: {
        disabledForCheckbox: {
            type: Boolean,
            default: false
        },
        currentMode: {
            type: String,
            default: 'edit'
        },
        currentSelected: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        updateInit: {
            type: Number,
            default: 0
        },
        defaultSelected: {
            type: Array,
            default: function _default() {
                return [];
            }
        }
    },
    data: function data() {
        return {
            view: {
                ajaxing: false
            },
            keyMaps: [],
            subList: {}
        };
    },

    watch: {
        updateInit: function updateInit(newValue) {
            if (newValue) {
                this.getInitData();
                this.$emit('init-updated');
            }
        }
    },
    mounted: function mounted() {
        this.getInitData();
    },

    computed: {},
    methods: {
        getInitData: function getInitData() {
            var _this = this;

            this.view.ajaxing = true;

            this.$http.get('/adminapi/plan_function_group/').then(function (response) {
                _this.keyMaps = response.data.keyMaps;
                _this.subList = response.data.subList;
                _this.view.ajaxing = false;
            }, function (error) {
                _this.view.ajaxing = false;
            });
        },
        actionEvent: function actionEvent(props) {
            this.$emit('title-action', {
                props: props
            });
        },
        actionSubEvent: function actionSubEvent(props) {
            this.$emit('sub-action', {
                props: props
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-79bb997c=\"\">\n    <v-spinner :ajaxing=\"view.ajaxing\" _v-79bb997c=\"\"></v-spinner>\n    <v-collapse v-show=\"!view.ajaxing\" :current-mode=\"currentMode\" :disabled-for-checkbox=\"disabledForCheckbox\" :key-maps=\"keyMaps\" :sub-list=\"subList\" :default-checked=\"defaultSelected\" @click-title-event=\"actionEvent\" @click-sub-event=\"actionSubEvent\" _v-79bb997c=\"\"></v-collapse>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.radio-margin + .radio-margin[_v-79bb997c] {\n  margin-left: 10px; }\n\n/* line 6, stdin */\ninput[_v-79bb997c], textarea[_v-79bb997c], select[_v-79bb997c] {\n  max-width: 500px; }\n\n/* line 10, stdin */\n.input-group input[_v-79bb997c] {\n  max-width: inherit; }\n\n/* line 14, stdin */\n.input-group[_v-79bb997c] {\n  max-width: 200px; }\n\n/* line 18, stdin */\nspan.label[_v-79bb997c] {\n  font-size: 14px;\n  margin-left: 30px; }\n\n/* line 23, stdin */\nspan.attention[_v-79bb997c] {\n  color: red;\n  font-weight: 700; }\n\n/* line 28, stdin */\n.p-t-0[_v-79bb997c] {\n  padding-top: 0 !important; }\n\n/* line 32, stdin */\ntextarea[_v-79bb997c] {\n  margin: 0; }\n\n/* line 36, stdin */\n#finish-form[_v-79bb997c] {\n  margin-top: 50px; }\n\n/* line 40, stdin */\n.modify-fee[_v-79bb997c] {\n  margin: 50px 0; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-79bb997c", module.exports)
  } else {
    hotAPI.update("_v-79bb997c", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1244:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vuex = require('vuex');

exports.default = {
    data: function data() {
        return {
            view: {
                ajaxing: true
            },
            postData: {
                name: null,
                type: 1,
                plan_function: ''
            },
            plan_functions_options: []
        };
    },

    watch: {},
    mounted: function mounted() {
        this.reset();
        this.fetchData();
    },

    computed: {},
    methods: {
        fetchData: function fetchData() {
            var _this = this;

            this.view.ajaxing = true;
            this.$http.get('/adminapi/plan_function').then(function (response) {
                var data = response.data;
                _this.plan_functions_options = data;
                _this.view.ajaxing = false;
            }, function (error) {
                _this.view.ajaxing = false;
            });
        },
        toList: function toList() {
            window.location = webadmin_base_url + '/plan';
        },
        reset: function reset() {
            this.postData = {
                name: null,
                type: 1,
                plan_function: ''
            };
        },
        create: function create() {
            var _this2 = this;

            if (!this.postData.plan_function.id || !this.postData.name) {
                $17.swal({
                    title: '請填寫名稱並選擇類型與系統',
                    type: 'warning',
                    showCancelButton: false
                });
                return;
            }
            var vm = this;
            this.view.ajaxing = true;
            this.postData.plan_function_id = this.postData.plan_function.id;
            this.$http.post('/adminapi/plan', this.postData).then(function (response) {
                $17.swal({
                    title: '新增成功',
                    type: 'success',
                    showCancelButton: false,
                    showConfirmButton: false
                });
                _this2.view.ajaxing = false;
                setTimeout(function () {
                    _this2.toList();
                }, 2500);
            }, function (error) {
                _this2.view.ajaxing = false;
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"content-inner\" _v-4c8ad962=\"\">\n    <h2 class=\"m-bottom-30\" _v-4c8ad962=\"\">新增系統方案</h2>\n\n    <v-spinner :ajaxing=\"view.ajaxing\" _v-4c8ad962=\"\"></v-spinner>\n\n    <div v-if=\"!view.ajaxing\" class=\"form-horizontal\" _v-4c8ad962=\"\">\n        <div class=\"form-group\" _v-4c8ad962=\"\">\n            <label class=\"col-sm-2 control-label p-t-0\" _v-4c8ad962=\"\"><span class=\"text-danger\" _v-4c8ad962=\"\">*</span>系統方案名稱</label>\n            <div class=\"col-sm-10 m-bottom-20\" _v-4c8ad962=\"\">\n                <input type=\"text\" style=\"width: 300px\" v-model=\"postData.name\" placeholder=\"請輸入系統方案名稱\" class=\"form-control\" _v-4c8ad962=\"\">\n            </div>\n        </div>\n        <div class=\"form-group\" _v-4c8ad962=\"\">\n            <label class=\"col-sm-2 control-label p-t-0\" _v-4c8ad962=\"\"><span class=\"text-danger\" _v-4c8ad962=\"\">*</span>系統方案類型</label>\n            <div class=\"col-sm-10\" _v-4c8ad962=\"\">\n                <div _v-4c8ad962=\"\">\n                    <label class=\"m-right-10\" _v-4c8ad962=\"\">\n                        <input v-model=\"postData.type\" :checked=\"postData.type==1\" value=\"1\" type=\"radio\" _v-4c8ad962=\"\"> 主要系統方案\n                    </label>\n                    <label _v-4c8ad962=\"\">\n                        <input v-model=\"postData.type\" :checked=\"postData.type==0\" value=\"2\" type=\"radio\" _v-4c8ad962=\"\"> 加值系統方案\n                    </label>\n                </div>\n                <div _v-4c8ad962=\"\">\n                    <v-mutiselect style=\"width:300px\" :model.sync=\"postData.plan_function\" :options=\"plan_functions_options\" :multiple=\"false\" :close-on-select=\"true\" :searchable=\"false\" label=\"name\" track-by=\"id\" tag-name=\"name\" placeholder=\"請選擇系統\" _v-4c8ad962=\"\"></v-mutiselect>\n                </div>\n            </div>\n        </div>\n        <div class=\"form-group\" _v-4c8ad962=\"\">\n            <label class=\"col-sm-2 control-label p-t-0\" _v-4c8ad962=\"\"></label>\n            <div class=\"col-sm-10 m-bottom-20\" _v-4c8ad962=\"\">\n                <button class=\"btn btn-primary\" @click=\"create\" _v-4c8ad962=\"\">送出</button>\n                <button class=\"btn btn-default\" @click=\"toList\" _v-4c8ad962=\"\">取消</button>\n            </div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-4c8ad962", module.exports)
  } else {
    hotAPI.update("_v-4c8ad962", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vuex":803}],1245:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vuex = require('vuex');

exports.default = {
    props: {
        planId: {
            default: null
        }
    },
    data: function data() {
        return {
            view: {
                ajaxing: true
            },
            plan: {},
            postData: {}
        };
    },

    watch: {},
    mounted: function mounted() {
        this.fetchData();
    },

    computed: {},
    methods: {
        fetchData: function fetchData() {
            var _this = this;

            this.view.ajaxing = true;
            this.$http.get('/adminapi/plan/' + this.planId).then(function (response) {
                var data = response.data;
                _this.plan = data;
                _this.postData.order = data.order;
                _this.view.ajaxing = false;
            }, function (error) {
                _this.view.ajaxing = false;
            });
        },
        toList: function toList() {
            window.history.back();
        },
        update: function update() {
            var _this2 = this;

            this.view.ajaxing = true;
            this.$http.patch('/adminapi/plan/' + this.planId, this.postData).then(function (response) {
                $17.swal({
                    title: '儲存成功',
                    type: 'success',
                    showCancelButton: false
                });
                _this2.view.ajaxing = false;
            }, function (error) {
                _this2.view.ajaxing = false;
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"content-inner\" _v-9aa547c6=\"\">\n    <h2 class=\"m-bottom-30\" _v-9aa547c6=\"\">編輯系統方案</h2>\n\n    <v-spinner :ajaxing=\"view.ajaxing\" _v-9aa547c6=\"\"></v-spinner>\n\n    <div v-if=\"!view.ajaxing\" class=\"form-horizontal\" _v-9aa547c6=\"\">\n        <div class=\"form-group\" _v-9aa547c6=\"\">\n            <label class=\"col-sm-2 control-label p-t-0\" _v-9aa547c6=\"\">系統方案名稱</label>\n            <label class=\"col-sm-10\" style=\"cursor: default\" _v-9aa547c6=\"\">\n                {{plan.name}}\n            </label>\n        </div>\n        <div class=\"form-group\" _v-9aa547c6=\"\">\n            <label class=\"col-sm-2 control-label p-t-0\" _v-9aa547c6=\"\">系統方案類型</label>\n            <label class=\"col-sm-10\" style=\"cursor: default\" _v-9aa547c6=\"\">\n                {{plan.type===1?'主要系統方案':'加值型系統方案'}}\n            </label>\n        </div>\n        <div class=\"form-group\" _v-9aa547c6=\"\">\n            <label class=\"col-sm-2 control-label p-t-0\" _v-9aa547c6=\"\">排序</label>\n            <div class=\"col-sm-10 m-bottom-20\" _v-9aa547c6=\"\">\n                <input type=\"number\" style=\"width: 200px\" v-model=\"postData.order\" placeholder=\"請輸入排序\" class=\"form-control\" _v-9aa547c6=\"\">\n            </div>\n        </div>\n        <div class=\"form-group\" _v-9aa547c6=\"\">\n            <label class=\"col-sm-2 control-label p-t-0\" _v-9aa547c6=\"\"></label>\n            <div class=\"col-sm-10 m-bottom-20\" _v-9aa547c6=\"\">\n                <button class=\"btn btn-primary\" @click=\"update\" _v-9aa547c6=\"\">送出</button>\n                <button class=\"btn btn-default\" @click=\"toList\" _v-9aa547c6=\"\">回列表</button>\n            </div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-9aa547c6", module.exports)
  } else {
    hotAPI.update("_v-9aa547c6", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vuex":803}],1246:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.list[_v-44ccaf04] {\n  margin: 15px 30px; }\n\n/* line 5, stdin */\n.name-title[_v-44ccaf04] {\n  margin-bottom: 30px; }\n\n/* line 8, stdin */\n.action-button[_v-44ccaf04] {\n  margin-top: 15px;\n  margin-bottom: 15px;\n  float: right;\n  clear: both; }\n\n/* line 15, stdin */\n.function-name[_v-44ccaf04] {\n  margin-right: 5px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vuex = require('vuex');

exports.default = {
    props: {},
    data: function data() {
        return {
            view: {
                ajaxing: false
            },
            currentGroupId: null,
            enableDelete: false,
            postData: {
                name: null,
                colName: null
            },
            freshInit: 0,
            currentSelectSub: {}
        };
    },

    watch: {
        planFunctionId: function planFunctionId(newVal) {
            this.showPlanFunction(newVal);
        }
    },
    mounted: function mounted() {},

    computed: {},
    methods: {
        showModal: function showModal(data) {
            if (data) {
                this.currentGroupId = data.id;
                this.postData.name = data.name;
                this.enableDelete = !data.withCustom;
            } else {
                this.resetModalValue();
            }
            $('#plan-function-group-modal').modal('show');
        },
        resetModalValue: function resetModalValue() {
            this.currentGroupId = null;
            this.enableDelete = false;
            this.postData.name = null;
            this.postData.null = null;
        },

        showPlanFunction: function showPlanFunction(id) {
            var _this = this;

            var url = webadmin_base_url + '/plan_function/update/' + id;
            this.planFunctionId = id;

            this.$http.get(url).then(function (response) {

                _this.planFunctionName = response.data.name;
                _this.view.ajaxing = false;
            }, function (error) {
                _this.view.ajaxing = false;
            });
        },
        editGroup: function editGroup(data) {
            this.showModal(data.props.value);
        },
        saveClicked: function saveClicked() {
            if (this.currentGroupId == null) {
                this.createClicked();
            } else {
                this.updateClicked();
            }
        },
        createClicked: function createClicked() {
            var _this2 = this;

            this.view.ajaxing = true;
            $('#plan-function-group-modal').modal('hide');
            var url = '/adminapi/plan_function_group/creating';
            this.$http.post(url, {
                'col_name': this.postData.colName,
                'name': this.postData.name
            }).then(function (response) {
                _this2.view.ajaxing = false;
                _this2.freshInit = 1;
                $.notify('更新成功', {
                    position: "top center",
                    className: "success"
                });
                location.reload();
            }, function (error) {
                $('#plan-function-group-modal').modal('show');
                _this2.view.ajaxing = false;
                $17.swal({
                    title: '更新失敗',
                    text: error.data.message,
                    type: 'error',
                    showCancelButton: false
                });
            });
        },
        updateClicked: function updateClicked() {
            var _this3 = this;

            this.view.ajaxing = true;
            $('#plan-function-group-modal').modal('hide');
            var url = '/adminapi/plan_function_group/updating/' + this.currentGroupId;
            this.$http.post(url, {
                'name': this.postData.name
            }).then(function (response) {
                _this3.view.ajaxing = false;
                _this3.freshInit = 1;
                $.notify('更新成功', {
                    position: "top center",
                    className: "success"
                });
                location.reload();
            }, function (error) {
                $('#plan-function-group-modal').modal('show');
                _this3.view.ajaxing = false;
                $17.swal({
                    title: '更新失敗',
                    text: error.data.message,
                    type: 'error',
                    showCancelButton: false
                });
            });
        },
        removeClicked: function removeClicked() {
            var _this4 = this;

            $17.swal({
                title: '確認刪除「' + this.postData.name + '」?',
                type: 'warning'
            }, function () {
                _this4.view.ajaxing = true;
                $('#plan-function-group-modal').modal('hide');
                var url = '/adminapi/plan_function_group/delete/' + _this4.currentGroupId;
                _this4.$http.delete(url).then(function (response) {
                    _this4.view.ajaxing = false;
                    _this4.freshInit = 1;
                    $.notify('刪除成功', {
                        position: "top center",
                        className: "success"
                    });
                    location.reload();
                }, function (error) {
                    $('#plan-function-group-modal').modal('show');
                    _this4.view.ajaxing = false;
                    $17.swal({
                        title: '刪除失敗',
                        text: error.data.message,
                        type: 'error',
                        showCancelButton: false
                    });
                });
            });
        },
        clickSub: function clickSub(props) {
            this.currentSelectSub = props.props.value;
            $('#web-function-group-edit-modal').modal('show');
        },
        resetInit: function resetInit() {
            this.freshInit = 0;
        },
        changeInit: function changeInit() {
            this.freshInit = 1;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-44ccaf04=\"\">\n    <v-spinner :ajaxing=\"view.ajaxing\" _v-44ccaf04=\"\"></v-spinner>\n    <div v-show=\"!view.ajaxing\" class=\"list\" _v-44ccaf04=\"\">\n        <div class=\"name-title\" _v-44ccaf04=\"\">\n            <a @click.stop.prevent=\"showModal()\" class=\"btn btn-success\" _v-44ccaf04=\"\">\n                <div class=\"fa fa-plus\" _v-44ccaf04=\"\"></div>\n                新增模組\n            </a>\n        </div>\n        <webadmin-modify-plan-function-group current-mode=\"edit\" :current-selected=\"[]\" @title-action=\"editGroup\" @sub-action=\"clickSub\" :update-init=\"freshInit\" @init-updated=\"resetInit\" _v-44ccaf04=\"\"></webadmin-modify-plan-function-group>\n    </div>\n     <v-modal id=\"plan-function-group-modal\" :remove-btn-show=\"enableDelete\" :save-clicked=\"saveClicked\" :remove-clicked=\"removeClicked\" _v-44ccaf04=\"\">   \n        <div slot=\"title\" _v-44ccaf04=\"\">\n            新增模組\n        </div>\n        <div slot=\"body\" _v-44ccaf04=\"\">\n            <div _v-44ccaf04=\"\">\n                <label for=\"show-name\" _v-44ccaf04=\"\">模組名稱  </label>\n                <input type=\"text\" name=\"\" id=\"show-name\" v-model=\"postData.name\" _v-44ccaf04=\"\">\n            </div>\n            <div v-if=\"currentGroupId == null\" _v-44ccaf04=\"\">\n                <label for=\"col-name\" _v-44ccaf04=\"\">欄位英文  </label>\n                <input type=\"text\" name=\"\" id=\"col-name\" placeholder=\"chat_bot\" v-model=\"postData.colName\" _v-44ccaf04=\"\">\n            </div>\n        </div>\n    </v-modal>\n    <webadmin-web-function-group-update-modal :select-web-function=\"currentSelectSub\" @list-updated=\"changeInit\" _v-44ccaf04=\"\"></webadmin-web-function-group-update-modal>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.list[_v-44ccaf04] {\n  margin: 15px 30px; }\n\n/* line 5, stdin */\n.name-title[_v-44ccaf04] {\n  margin-bottom: 30px; }\n\n/* line 8, stdin */\n.action-button[_v-44ccaf04] {\n  margin-top: 15px;\n  margin-bottom: 15px;\n  float: right;\n  clear: both; }\n\n/* line 15, stdin */\n.function-name[_v-44ccaf04] {\n  margin-right: 5px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-44ccaf04", module.exports)
  } else {
    hotAPI.update("_v-44ccaf04", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1247:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _tippy = require('tippy.js');

var _tippy2 = _interopRequireDefault(_tippy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {},
    data: function data() {
        return {
            apiConfig: {
                method: 'get',
                apiurl: '/adminapi/plan_function/list',
                payload: {
                    page: this.getUrlParamValue('page') ? this.getUrlParamValue('page') : 1,
                    page_size: 25
                },
                recordName: 'list'
            },
            tableConfig: {
                columns: [{
                    keys: 'name',
                    head: '系統'
                }, {
                    keys: 'id',
                    head: '',
                    cssClass: 'text-right',
                    html: function html(item) {
                        return '<v-admin-operate-record btn-class="btn btn-info btn-xs" :default-data="[{name:\'\u6700\u5F8C\u66F4\u65B0\',value:\'' + item.updated_at + '\'},{name:\'\u66F4\u65B0\u4EBA\u54E1\',value:\'' + (item.admin ? item.admin.name : '') + '\'}]"></v-admin-operate-record>\n                                    <button class="btn btn-primary btn-xs" @click.prevent.stop="clickHandler(\'showPlanFunction\')"><i class="fa fa-pencil fa-lg"></i></button>\n                                    <button class="btn btn-danger btn-xs" @click.prevent.stop="clickHandler(\'deleteRow\')"><i class="fa fa-trash-o fa-lg"></i></button>';
                    }
                }]
            }
        };
    },

    methods: {
        refreshData: function refreshData() {
            this.$refs['table'].refresh();
        },
        clickHtmlHandler: function clickHtmlHandler(val) {
            this[val.action](val.row);
        },
        deleteRow: function deleteRow(planFunction) {
            if (planFunction.plans.length > 0) {
                var used = planFunction.plans.reduce(function (carry, item) {
                    return carry.concat(item.name);
                }, []).join('、');
                $17.swal({
                    title: '此系統仍有系統方案使用無法刪除',
                    text: '使用中的系統方案：' + used,
                    type: 'warning',
                    showCancelButton: false
                });
                return;
            }
            var vue = this;
            $17.swal({
                title: '確認刪除此系統？',
                type: 'warning'
            }, function () {
                $.blockUI();
                vue.$http.delete('/adminapi/plan_function/' + planFunction.id).then(function (response) {
                    $17.swal({
                        title: '刪除成功',
                        type: 'success',
                        showCancelButton: false
                    });
                    vue.refreshData();
                    $.unblockUI();
                }, function (error) {
                    $17.swal({
                        title: '刪除失敗',
                        text: error.body.message ? error.body.message : '不明錯誤',
                        type: 'error',
                        showCancelButton: false
                    });
                    $.unblockUI();
                });
            });
        },
        showPlanFunction: function showPlanFunction(planFunction) {
            this.$refs['plan-function-select-modal'].showPlanFunction(planFunction.id);
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"content-inner\">\n    <div class=\"m-bottom-30\">\n        <h2 class=\"clearfix\">\n            <span class=\"pull-left m-right-10\">系統列表</span>\n            <a class=\"btn btn-success pull-left\" @click.prevent=\"showPlanFunction\">新增系統</a>\n            <a href=\"/webadmin/plan\" class=\"btn btn-primary pull-right\">系統方案列表</a>\n        </h2>\n    </div>\n\n    <v-smart-table ref=\"table\" :table-config=\"tableConfig\" :api-config=\"apiConfig\" @html-click-callback=\"clickHtmlHandler\"></v-smart-table>\n\n    <webadmin-plan-function-select-modal ref=\"plan-function-select-modal\" :after-save-callback=\"refreshData\"></webadmin-plan-function-select-modal>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-6b06d070", module.exports)
  } else {
    hotAPI.update("_v-6b06d070", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"tippy.js":780,"vue":792,"vue-hot-reload-api":785}],1248:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 3, stdin */\n.name-title[_v-54daa524] {\n  margin-bottom: 30px; }\n\n/* line 6, stdin */\n.action-button[_v-54daa524] {\n  margin-top: 15px;\n  margin-bottom: 15px;\n  float: right;\n  clear: both; }\n\n/* line 13, stdin */\n.function-name[_v-54daa524] {\n  margin-right: 5px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        afterSaveCallback: {
            type: Function
        }
    },
    data: function data() {
        return {
            planFunctionId: null,
            selectFunctionGroups: [],
            defaultFunctionGroups: [],
            planFunctionName: '',
            view: {
                ajaxing: false,
                disabled: false
            },
            freshInit: 0
        };
    },
    mounted: function mounted() {
        var vm = this;
        $('#plan-function-modal').on('hide.bs.modal', function (event) {
            console.log('hide');
            vm.planFunctionId = null;
            vm.selectFunctionGroups = [];
            vm.defaultFunctionGroups = [];
            vm.planFunctionName = '';
            vm.view = {
                ajaxing: false,
                disabled: false
            };
            vm.freshInit = 0;
        });
    },

    methods: {
        showPlanFunction: function showPlanFunction() {
            var _this = this;

            var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
            var disabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            this.view.disabled = disabled === true ? true : false;
            if (id > 0) {
                var url = '/adminapi/plan_function/' + id + '/plan_function_group';
                this.planFunctionId = id;

                this.$http.get(url).then(function (response) {
                    _this.planFunctionName = response.data.name;
                    _this.selectFunctionGroups = response.data.planFunctions;
                    _this.defaultFunctionGroups = response.data.planFunctions;
                    $('#plan-function-modal').modal('show');
                    _this.view.ajaxing = false;
                }, function (error) {
                    _this.view.ajaxing = false;
                });
            } else {
                $('#plan-function-modal').modal('show');
            }
        },

        savePlanFunction: function savePlanFunction() {
            if (this.planFunctionId === null) {
                this.createPlanFunction();
            } else {
                this.updateFunction();
            }
        },
        createPlanFunction: function createPlanFunction() {
            var _this2 = this;

            var url = '/adminapi/plan_function/plan_function_group';
            var params = this.getPostData();
            this.view.ajaxing = true;

            this.$http.post(url, params).then(function (response) {
                $('#plan-function-modal').modal('hide');
                $17.swal({
                    title: '新增成功',
                    type: 'success',
                    showCancelButton: false
                });
                _this2.view.ajaxing = false;
                _this2.afterSaveCallback();
            }, function (error) {
                _this2.view.ajaxing = false;
                $17.swal({
                    title: '新增失敗',
                    text: error.data.message,
                    type: 'error',
                    showCancelButton: false
                });
            });
        },
        updateFunction: function updateFunction() {
            var _this3 = this;

            var url = '/adminapi/plan_function/' + this.planFunctionId + '/plan_function_group';
            var params = this.getPostData();
            this.view.ajaxing = true;

            this.$http.patch(url, params).then(function (response) {
                $('#plan-function-modal').modal('hide');
                _this3.view.ajaxing = false;

                $17.swal({
                    title: '更新成功',
                    type: 'success',
                    showCancelButton: false
                });
                _this3.afterSaveCallback();
            }, function (error) {
                _this3.view.ajaxing = false;
                $17.swal({
                    title: '更新失敗',
                    text: error.data.message,
                    type: 'error',
                    showCancelButton: false
                });
            });
        },

        getPostData: function getPostData() {
            return {
                name: this.planFunctionName,
                selected: this.selectFunctionGroups
            };
        },
        setCurrentSelect: function setCurrentSelect(data) {
            this.selectFunctionGroups = data.props.value;
        },
        resetInit: function resetInit() {
            this.freshInit = 0;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal id=\"plan-function-modal\" no-footer=\"\" _v-54daa524=\"\">   \n    <div slot=\"title\" _v-54daa524=\"\">\n        系統設定\n    </div>\n    <div slot=\"body\" _v-54daa524=\"\">\n        <v-spinner :ajaxing=\"view.ajaxing\" _v-54daa524=\"\"></v-spinner>\n        <div v-show=\"!view.ajaxing\" _v-54daa524=\"\">\n            <div class=\"name-title\" _v-54daa524=\"\">\n                <label for=\"plna_function_name\" class=\"function-name\" _v-54daa524=\"\">名稱</label>\n                <input :disabled=\"view.disabled\" type=\"text\" name=\"\" v-model=\"planFunctionName\" id=\"plna_function_name\" _v-54daa524=\"\">\n            </div>\n            <webadmin-modify-plan-function-group current-mode=\"checkbox\" :disabled-for-checkbox=\"view.disabled\" :current-selected=\"selectFunctionGroups\" :default-selected=\"defaultFunctionGroups\" @title-action=\"setCurrentSelect\" :update-init=\"freshInit\" @init-updated=\"resetInit\" _v-54daa524=\"\"></webadmin-modify-plan-function-group>\n            <div class=\"action-button\" _v-54daa524=\"\">\n                <input type=\"button\" :disabled=\"view.disabled\" class=\"btn btn-primary\" value=\"儲存\" @click.stop=\"savePlanFunction\" _v-54daa524=\"\">\n            </div>\n        </div>\n    </div>\n</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 3, stdin */\n.name-title[_v-54daa524] {\n  margin-bottom: 30px; }\n\n/* line 6, stdin */\n.action-button[_v-54daa524] {\n  margin-top: 15px;\n  margin-bottom: 15px;\n  float: right;\n  clear: both; }\n\n/* line 13, stdin */\n.function-name[_v-54daa524] {\n  margin-right: 5px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-54daa524", module.exports)
  } else {
    hotAPI.update("_v-54daa524", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1249:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _tippy = require('tippy.js');

var _tippy2 = _interopRequireDefault(_tippy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            plan_function_id: null,
            tippyInstance: [],
            apiConfig: {
                method: 'get',
                apiurl: '/adminapi/plan/list',
                payload: {
                    page: this.getUrlParamValue('page') ? this.getUrlParamValue('page') : 1,
                    page_size: 25
                },
                recordName: 'list'
            },
            tableConfig: {
                columns: [{
                    keys: 'id',
                    head: '序號'
                }, {
                    keys: 'type',
                    head: '類型',
                    html: function html(item) {
                        return item.type == 1 ? '主要' : '加值';
                    }
                }, {
                    keys: 'name',
                    head: '系統方案名稱',
                    maxWidth: '25em'
                }, {
                    keys: 'plan_function.name',
                    head: '系統',
                    html: function html(item) {
                        return '<a href="#" @click.prevent="clickHandler(\'showPlanFunction\')">' + item.plan_function.name + '</a>';
                    }
                }, {
                    keys: 'id',
                    head: '',
                    cssClass: 'text-right tippy-container',
                    html: function html(item) {
                        //2021-06-28 決議此版先不給刪除系統方案，原因請看JIRA
                        //<button class="btn btn-danger btn-xs" @click.prevent.stop="clickHandler('deletePlan')"><i class="fa fa-trash-o fa-lg"></i></button>
                        return '<a class="btn btn-info btn-xs" target="_blank" :href="\'/webadmin/studio_plan/\'+' + item.id + '">{{\'\u4F7F\u7528\u4E2D\u54C1\u724C\uFF1A\'+ ' + item.studio_plans.length + ' }}</a>\n                                        <v-admin-operate-record btn-class="btn btn-info btn-xs" :default-data="[{name:\'\u6700\u5F8C\u66F4\u65B0\',value:\'' + item.updated_at + '\'},{name:\'\u66F4\u65B0\u4EBA\u54E1\',value:\'' + (item.admin ? item.admin.name : '') + '\'}]"></v-admin-operate-record>\n                                        <a class="btn btn-primary btn-xs" :href="\'/webadmin/plan/update/\'+' + item.id + '"><i class="fa fa-pencil fa-lg"></i></a>';
                    }
                }]
            }
        };
    },

    methods: {
        clickHtmlHandler: function clickHtmlHandler(val) {
            this[val.action](val.row);
        },
        deletePlan: function deletePlan(plan) {
            //2021-06-28 決議此版先不給刪除系統方案
            if (plan.studio_plans.length > 0) {
                $17.swal({
                    title: '此方案仍有品牌使用無法刪除',
                    type: 'warning',
                    showCancelButton: false
                });
                return;
            }
            var vue = this;
            $17.swal({
                title: '確認刪除此系統方案？',
                type: 'warning'
            }, function () {
                var _this = this;

                $.blockUI();
                vue.$http.delete('/adminapi/plan/' + plan.id).then(function (response) {
                    $17.swal({
                        title: '刪除成功',
                        type: 'success',
                        showCancelButton: false
                    });
                    _this.$refs['table'].refresh();
                    $.unblockUI();
                }, function (error) {
                    $17.swal({
                        title: '刪除失敗',
                        type: 'error',
                        showCancelButton: false
                    });
                    $.unblockUI();
                });
            });
        },
        showPlanFunction: function showPlanFunction(plan) {
            this.$refs['plan-function-select-modal'].showPlanFunction(plan.plan_function.id, true);
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"content-inner\">\n    <div class=\"m-bottom-30\">\n        <h2 class=\"clearfix\">\n            <span class=\"pull-left m-right-10\">系統方案列表</span>\n            <a class=\"btn btn-success pull-left\" href=\"/webadmin/plan/create\">新增系統方案</a>\n            <a href=\"/webadmin/plan/function_group\" class=\"btn btn-default pull-left\">編輯模組選單</a>\n            <a href=\"/webadmin/plan/plan_function\" class=\"btn btn-primary pull-right\">系統列表</a>\n        </h2>\n    </div>\n\n    <v-smart-table ref=\"table\" :table-config=\"tableConfig\" :api-config=\"apiConfig\" @html-click-callback=\"clickHtmlHandler\"></v-smart-table>\n\n    <webadmin-plan-function-select-modal ref=\"plan-function-select-modal\">\n    </webadmin-plan-function-select-modal>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-b935969e", module.exports)
  } else {
    hotAPI.update("_v-b935969e", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"tippy.js":780,"vue":792,"vue-hot-reload-api":785}],1250:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 3, stdin */\n.name-title[_v-6d78ce82] {\n  margin-bottom: 30px; }\n\n/* line 6, stdin */\n.action-button[_v-6d78ce82] {\n  margin-top: 15px;\n  margin-bottom: 15px;\n  float: right;\n  clear: both; }\n\n/* line 13, stdin */\n.function-name[_v-6d78ce82] {\n  margin-right: 5px; }\n\n/* line 16, stdin */\n#select-name[_v-6d78ce82] {\n  padding-top: 7px; }\n\n/* line 19, stdin */\n.huge-margin[_v-6d78ce82] {\n  margin-bottom: 300px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vuex = require('vuex');

exports.default = {
    props: {
        selectWebFunction: {
            default: {}
        }
    },
    data: function data() {
        return {
            keyMaps: [],
            newFunctionGroup: null,
            view: {
                ajaxing: false
            }
        };
    },

    watch: {},
    mounted: function mounted() {
        this.getInitData();
    },

    computed: {
        selectWebFunctionId: function selectWebFunctionId() {
            if (typeof this.selectWebFunction.function_id === 'undefined') {
                return '';
            }
            return this.selectWebFunction.function_id;
        }
    },
    methods: {
        getInitData: function getInitData() {
            var _this = this;

            this.view.ajaxing = true;

            this.$http.get('/adminapi/plan_function_group/').then(function (response) {
                _this.keyMaps = response.data.keyMaps;
                _this.subList = response.data.subList;
                _this.view.ajaxing = false;
            }, function (error) {
                _this.view.ajaxing = false;
            });
        },
        updateFunction: function updateFunction() {
            var _this2 = this;

            if (this.newFunctionGroup === null) {
                $17.swal({
                    title: '請選擇一個網站群組',
                    type: 'error',
                    showCancelButton: false
                });

                return;
            }
            this.view.ajaxing = true;
            this.$http.post('/adminapi/web_function/updating/' + this.selectWebFunctionId, { 'id': this.newFunctionGroup.id }).then(function (response) {
                $('#web-function-group-edit-modal').modal('hide');
                _this2.view.ajaxing = false;
                _this2.getInitData();
                _this2.resetToInit();
                _this2.$emit('list-updated');
                $.notify('更新成功', {
                    position: "top center",
                    className: "success"
                });
                // location.reload();
            }, function (error) {
                _this2.view.ajaxing = false;
                $17.swal({
                    title: '更新失敗',
                    text: error.data.message,
                    type: 'error',
                    showCancelButton: false
                });
            });
        },
        resetToInit: function resetToInit() {
            this.newFunctionGroup = null;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal id=\"web-function-group-edit-modal\" no-footer=\"\" _v-6d78ce82=\"\">   \n    <div slot=\"title\" _v-6d78ce82=\"\">\n        移動功能至不同的模組\n    </div>\n    <div slot=\"body\" _v-6d78ce82=\"\">\n        <v-spinner :ajaxing=\"view.ajaxing\" _v-6d78ce82=\"\"></v-spinner>\n        <div v-show=\"!view.ajaxing\" class=\"form-horizontal\" _v-6d78ce82=\"\">\n            <div class=\"form-group\" _v-6d78ce82=\"\">\n                <label for=\"plna_function_name\" class=\"function-name col-sm-3 control-label\" _v-6d78ce82=\"\">功能群組:</label>\n                <div id=\"#\" class=\"col-sm-4 \" _v-6d78ce82=\"\">{{selectWebFunction.name}}</div>\n            </div>\n            <div class=\"form-group\" _v-6d78ce82=\"\">\n                <label for=\"function_group\" class=\"function-name col-sm-3 control-label\" _v-6d78ce82=\"\">新模組:</label>\n                <div class=\"col-sm-8\" _v-6d78ce82=\"\">\n                    <v-mutiselect :model.sync=\"newFunctionGroup\" :options=\"keyMaps\" :multiple=\"false\" :close-on-select=\"true\" :clear-on-select=\"true\" :searchable=\"true\" label=\"name\" track-by=\"id\" tag-name=\"name\" placeholder=\"請選擇群組\" class=\"m-bottom-10\" _v-6d78ce82=\"\"></v-mutiselect>\n                </div>\n            </div>\n            <div class=\"form-group\" _v-6d78ce82=\"\">\n                <div class=\"col-sm-4 col-sm-offset-3 huge-margin\" _v-6d78ce82=\"\">\n                    <input type=\"button\" value=\"修改\" @click=\"updateFunction\" class=\"btn btn-primary\" _v-6d78ce82=\"\">\n                </div>\n            </div>\n        </div>\n    </div>\n</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 3, stdin */\n.name-title[_v-6d78ce82] {\n  margin-bottom: 30px; }\n\n/* line 6, stdin */\n.action-button[_v-6d78ce82] {\n  margin-top: 15px;\n  margin-bottom: 15px;\n  float: right;\n  clear: both; }\n\n/* line 13, stdin */\n.function-name[_v-6d78ce82] {\n  margin-right: 5px; }\n\n/* line 16, stdin */\n#select-name[_v-6d78ce82] {\n  padding-top: 7px; }\n\n/* line 19, stdin */\n.huge-margin[_v-6d78ce82] {\n  margin-bottom: 300px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-6d78ce82", module.exports)
  } else {
    hotAPI.update("_v-6d78ce82", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1251:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\nul[_v-483061a0] {\n  padding-left: 0px; }\n\n/* line 5, stdin */\nli[_v-483061a0] {\n  list-style-type: none;\n  display: inline-block;\n  padding-left: 10px; }\n\n/* line 10, stdin */\n.row[_v-483061a0] {\n  margin-left: 0px;\n  margin-right: 0px; }\n\n/* line 14, stdin */\n.underline[_v-483061a0] {\n  text-decoration: underline; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            ajaxing: false,
            ajaxingChange: false,
            branch_payment_methods: []
        };
    },

    props: {
        branchId: {
            required: true
        },
        studioId: {
            required: true
        },
        currentType: {
            default: 'edit'
        },
        initValue: {
            default: null
        },
        showMethodWord: {
            default: '支付方式'
        }
    },
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('pos', ['seventeenExportOrder', 'getStudioPaumentMethod', 'changePaymentMethod']), {
        resetSelect: function resetSelect() {
            var _this = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.payment_method_select = null;
                                _this.branch_payment_methods = [];

                            case 2:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        getDefaultPaymentMethod: function getDefaultPaymentMethod() {
            return this.branch_payment_methods.reduce(function (carry, method) {
                if (method.branch_default == 1) {
                    carry = method.id;
                }
                return carry;
            }, 1);
        },
        changePaymentMethodWait: function changePaymentMethodWait(value) {
            var _this2 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _this2.checkPaymentType(value);

                                if (!_this2.ajaxingChange) {
                                    _context2.next = 3;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 3:
                                _this2.ajaxingChange = true;

                                if (!(_this2.currentType === 'edit')) {
                                    _context2.next = 7;
                                    break;
                                }

                                _context2.next = 7;
                                return _this2.changePaymentMethod();

                            case 7:
                                _this2.ajaxingChange = false;

                            case 8:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        checkPaymentType: function checkPaymentType(value) {
            if (this.currentType !== 'refund') {
                return;
            };
            if (value != this.initValue) {
                $17.swal({
                    type: 'warning',
                    title: '退費方式與原支付方式不一致',
                    showCancelButton: false
                });
            };
        },
        checkCreditExport: function checkCreditExport(paymentMethod) {
            var isRefund = this.currentType === 'refund';
            var isOnlineCreditPaymentMethod = this.branchPaymentMethodsShow[this.payment_method_select] && this.branchPaymentMethodsShow[this.payment_method_select].payment_type == 2 && paymentMethod.id === this.payment_method_select && this.payment_method_select != 2;

            return !!(this.canExportOrder17Only && isRefund && isOnlineCreditPaymentMethod);
        },
        sendExportOrder: function sendExportOrder() {
            if (!this.canExportOrder17Only) {
                return;
            }
            var self = this;
            $17.swal({
                title: '確認執行？',
                text: '立即撥款',
                type: 'warning',
                showCancelButton: true,
                closeOnConfirm: false,
                showLoaderOnConfirm: true
            }, function (answer) {
                if (answer) {
                    self.seventeenExportOrder();
                }
            });
        },
        checkShowLockPayment: function checkShowLockPayment(paymentMethod) {
            return this.currentType != 'edit' || this.currentType == 'edit' && !paymentMethod.is_locked;
        }
    }),
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('pos', ['select_order', 'studio_payment_methods']), (0, _vuex.mapState)({
        canExportOrder17Only: function canExportOrder17Only(state) {
            return state.webadmin.configure.webFunctions.WebadminPosExport17;
        }
    }), {
        payment_method_select: {
            get: function get() {

                this.branchId = this.select_order.branch_id;

                if (!this.$store.state.pos.payment_method_select) {
                    if (this.initValue !== null) {
                        this.payment_method_select = this.initValue;
                        this.changePaymentMethodWait();
                    } else {
                        //修改
                        if (this.select_order.payment_action_records && this.select_order.payment_action_records[0] && this.select_order.payment_action_records[0].studio_payment_method_id) {
                            this.payment_method_select = this.select_order.payment_action_records[0].studio_payment_method_id;
                        }
                        //新增
                        if (this.select_order.payment_action_records && !this.select_order.payment_action_records[0]) {
                            this.payment_method_select = this.getDefaultPaymentMethod();
                            this.changePaymentMethodWait();
                        }
                    }
                }

                return this.$store.state.pos.payment_method_select;
            },
            set: function set(newValue) {
                this.$store.commit('pos/POS_SETSTATUS', { 'key': 'payment_method_select', value: newValue });
            }
        },
        branchPaymentMethodsShow: function branchPaymentMethodsShow() {
            var vm = this;
            return this.branch_payment_methods.reduce(function (carry, method) {

                if (vm.currentType == 'refund' && method.payment_type === 2 && method.id != vm.initValue) {
                    // continue;
                } else {
                    // carry.push(method);
                    carry[method.id] = method;
                }

                // carry.push(method);
                // if(vm.currentType =='refund' && method.payment_type === 2 && method.id == vm.initValue){
                //      carry.push(method);
                // }

                // if(method.payment_type !== 2){
                //     carry.push(method);
                // }


                return carry;
            }, {});
        },
        showCreditInput: function showCreditInput() {
            if (this.currentType !== 'edit') {
                return false;
            }
            if (this.branchPaymentMethodsShow[this.payment_method_select] && this.branchPaymentMethodsShow[this.payment_method_select].payment_type == 2) {
                return true;
            }
            return false;
        },
        showCustomUserInput: function showCustomUserInput() {
            if (this.currentType !== 'edit') {
                return false;
            }
            if (this.branchPaymentMethodsShow[this.payment_method_select] && this.branchPaymentMethodsShow[this.payment_method_select].payment_type == 5) {
                return true;
            }
            return false;
        }
    }),
    watch: {
        studioId: function studioId(newStudioId) {
            var _this3 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                if (!(newStudioId && newStudioId != 0)) {
                                    _context3.next = 5;
                                    break;
                                }

                                _this3.ajaxing = true;
                                _context3.next = 4;
                                return _this3.getStudioPaumentMethod(newStudioId);

                            case 4:
                                _this3.ajaxing = false;

                            case 5:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3);
            }))();
        },
        branchId: function branchId(newBranchId) {
            var _this4 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                if (!_this4.studio_payment_methods[newBranchId]) {
                                    _context4.next = 4;
                                    break;
                                }

                                _context4.next = 3;
                                return _this4.resetSelect();

                            case 3:
                                _this4.branch_payment_methods = _this4.studio_payment_methods[newBranchId];

                            case 4:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this4);
            }))();
        },
        studio_payment_methods: function studio_payment_methods() {
            var _this5 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5() {
                return _regenerator2.default.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                if (!_this5.studio_payment_methods[_this5.select_order.branch_id]) {
                                    _context5.next = 4;
                                    break;
                                }

                                _context5.next = 3;
                                return _this5.resetSelect();

                            case 3:
                                _this5.branch_payment_methods = _this5.studio_payment_methods[_this5.select_order.branch_id];

                            case 4:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this5);
            }))();
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-483061a0=\"\">\n    <div class=\"row\" v-if=\"!ajaxing\" _v-483061a0=\"\">\n        <div class=\"col-xs-2\" _v-483061a0=\"\">\n            <label for=\"\" class=\" text-right\" _v-483061a0=\"\">{{ showMethodWord }}:</label>\n        </div>\n        <div class=\"col-xs-10\" _v-483061a0=\"\">\n            <v-spinner-button :ajaxing=\"ajaxingChange\" style=\"align:center\" _v-483061a0=\"\">\n            </v-spinner-button>\n            <div class=\"row\" v-show=\"!ajaxingChange\" _v-483061a0=\"\">\n                <div class=\"col-xs-12\" _v-483061a0=\"\">\n                    <ul class=\"\" _v-483061a0=\"\">\n                        <li v-for=\"(payment_method,index) in branchPaymentMethodsShow\" :key=\"payment_method.id\" _v-483061a0=\"\">\n                            <span v-if=\"checkShowLockPayment(payment_method)\" _v-483061a0=\"\">\n                                <input type=\"radio\" @change=\"changePaymentMethodWait(index)\" :value=\"payment_method.id\" v-model=\"payment_method_select\" :id=\"'payment_method'+currentType+index\" _v-483061a0=\"\">\n                                <label :for=\"'payment_method'+currentType+index\" _v-483061a0=\"\">{{ paymentDisplayName(payment_method) }}</label>\n                                <a class=\"underline p-right-10\" v-if=\"checkCreditExport(payment_method)\" @click.prevent=\"sendExportOrder\" _v-483061a0=\"\">立即撥款</a>\n                            </span>\n                        </li>\n                    </ul>\n                </div>\n            </div>\n            <div class=\"row\" v-show=\"!ajaxingChange\" _v-483061a0=\"\">\n                <div class=\"col-xs-12\" _v-483061a0=\"\">\n                    <webadmin-credit-card-input v-if=\"showCreditInput&amp;&amp;select_order\" _v-483061a0=\"\"></webadmin-credit-card-input>\n                    <webadmin-third-custom-user-input v-if=\"showCustomUserInput\" _v-483061a0=\"\"></webadmin-third-custom-user-input>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\nul[_v-483061a0] {\n  padding-left: 0px; }\n\n/* line 5, stdin */\nli[_v-483061a0] {\n  list-style-type: none;\n  display: inline-block;\n  padding-left: 10px; }\n\n/* line 10, stdin */\n.row[_v-483061a0] {\n  margin-left: 0px;\n  margin-right: 0px; }\n\n/* line 14, stdin */\n.underline[_v-483061a0] {\n  text-decoration: underline; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-483061a0", module.exports)
  } else {
    hotAPI.update("_v-483061a0", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1252:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.row[_v-454068e9] {\n  margin-left: 0px;\n  margin-right: 0px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            ajaxing: false,
            ajaxingChange: false,
            branch_payment_methods: []
            // payment_method_select:null
        };
    },

    props: {
        branchId: {
            required: true
        },
        studioId: {
            required: true
        },
        currentType: {
            default: 'edit'
        },
        initValue: {
            default: null
        },
        showMethodWord: {
            default: '支付方式'
        }
    },
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('pos', ['getStudioPaumentMethod', 'changePaymentMethod', 'getOrder']), {
        resetSelect: function resetSelect() {
            var _this = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.payment_method_select = null;
                                _this.branch_payment_methods = [];

                            case 2:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        changePaymentMethodWait: function changePaymentMethodWait() {
            var _this2 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _this2.ajaxingChange = true;
                                _context2.next = 3;
                                return _this2.changePaymentMethod();

                            case 3:
                                _this2.ajaxingChange = false;

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        changePaymentMethod: function changePaymentMethod() {
            var _this3 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                paymentActionRecordId = _this3.select_order.payment_action_records[0].id;
                                _context3.next = 3;
                                return _this3.$http.post('/adminapi/pos/change_studio_payment_method/' + paymentActionRecordId, {
                                    studio_payment_method_id: _this3.payment_method_select
                                }).then(function (response) {
                                    _this3.getOrder({ 'order_id': _this3.select_order.id });
                                    $("#change-payment-method-modal").modal('hide');
                                }, function (error) {
                                    $17.swal({
                                        title: "更改發生錯誤",
                                        text: "",
                                        type: 'error',
                                        showCancelButton: false,
                                        confirmButtonText: '確定'
                                    });
                                });

                            case 3:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3);
            }))();
        }
    }),
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('pos', ['select_order', 'studio_payment_methods', 'payment_method_select']), {
        payment_method_select: {
            get: function get() {
                return this.$store.state.pos.payment_method_select;
            },
            set: function set(newValue) {
                this.$store.commit('pos/POS_SETSTATUS', { 'key': 'payment_method_select', value: newValue });
            }
        },
        branchPaymentMethodsShow: function branchPaymentMethodsShow() {
            var vm = this;
            return this.branch_payment_methods.reduce(function (carry, method) {
                if (method.payment_type === 1) {
                    carry[method.id] = method;
                }
                return carry;
            }, {});
        }
    }),
    watch: {
        // async studioId(newStudioId) {
        //     if(newStudioId){
        //         this.ajaxing = true;
        //         await this.getStudioPaumentMethod(newStudioId);
        //         this.ajaxing = false;
        //     }
        // },
        branchId: function branchId(newBranchId) {
            var _this4 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                if (!_this4.studio_payment_methods[newBranchId]) {
                                    _context4.next = 4;
                                    break;
                                }

                                _context4.next = 3;
                                return _this4.resetSelect();

                            case 3:
                                _this4.branch_payment_methods = _this4.studio_payment_methods[newBranchId];

                            case 4:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this4);
            }))();
        },
        studio_payment_methods: function studio_payment_methods() {
            var _this5 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5() {
                return _regenerator2.default.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                if (!_this5.studio_payment_methods[_this5.select_order.branch_id]) {
                                    _context5.next = 4;
                                    break;
                                }

                                _context5.next = 3;
                                return _this5.resetSelect();

                            case 3:
                                _this5.branch_payment_methods = _this5.studio_payment_methods[_this5.select_order.branch_id];

                            case 4:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this5);
            }))();
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-454068e9=\"\">\n    <v-modal id=\"change-payment-method-modal\" no-footer=\"\" parallel-modal=\"\" _v-454068e9=\"\">\n        <span slot=\"title\" _v-454068e9=\"\">選擇支付方式</span>\n        <template slot=\"body\">\n            <div class=\"\" _v-454068e9=\"\">\n                <div class=\"row\" _v-454068e9=\"\">\n                    <div class=\"col-xs-12\" _v-454068e9=\"\">\n                        <v-spinner :ajaxing=\"ajaxingChange\" style=\"align:center\" _v-454068e9=\"\">\n                    </v-spinner></div>\n                </div>\n                <div class=\"row\" v-show=\"!ajaxingChange\" v-for=\"(payment_method,index) in branchPaymentMethodsShow\" :key=\"payment_method.id\" _v-454068e9=\"\">\n                    <div class=\"col-xs-12\" _v-454068e9=\"\">\n                        <input type=\"radio\" :value=\"payment_method.id\" v-model=\"payment_method_select\" :id=\"'change_payment_method'+currentType+index\" _v-454068e9=\"\">\n                        <label :for=\"'change_payment_method'+currentType+index\" _v-454068e9=\"\">{{ paymentDisplayName(payment_method) }}</label>\n                    </div>\n                </div>\n                <div class=\"row\" v-show=\"!ajaxingChange\" _v-454068e9=\"\">\n                    <div class=\"col-xs-12 text-right\" _v-454068e9=\"\">\n                        <input type=\"button\" value=\"儲存\" class=\"btn btn-primary\" @click=\"changePaymentMethodWait\" _v-454068e9=\"\">\n                    </div>\n                </div>\n            </div>\n        </template>\n    </v-modal>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.row[_v-454068e9] {\n  margin-left: 0px;\n  margin-right: 0px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-454068e9", module.exports)
  } else {
    hotAPI.update("_v-454068e9", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1253:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _creditCardInput = require('./payment_method/credit-card-input.vue');

var _creditCardInput2 = _interopRequireDefault(_creditCardInput);

var _thirdCustomUserInput = require('./payment_method/third-custom-user-input.vue');

var _thirdCustomUserInput2 = _interopRequireDefault(_thirdCustomUserInput);

var _change_payment_method = require('./change_payment_method.vue');

var _change_payment_method2 = _interopRequireDefault(_change_payment_method);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('./order-operate');

_vue2.default.component('webadmin-credit-card-input', _creditCardInput2.default);
_vue2.default.component('webadmin-third-custom-user-input', _thirdCustomUserInput2.default);
_vue2.default.component('webadmin-change-payment-method', _change_payment_method2.default);

},{"./change_payment_method.vue":1252,"./order-operate":1282,"./payment_method/credit-card-input.vue":1323,"./payment_method/third-custom-user-input.vue":1324,"vue":792}],1254:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.discount[_v-1ba72e59], .close[_v-1ba72e59] {\n  color: red; }\n\n/* line 5, stdin */\n.less-space[_v-1ba72e59] {\n  padding-right: 15px; }\n\n/* line 8, stdin */\n.already-refund[_v-1ba72e59] {\n  padding-left: 15px; }\n\n/* line 11, stdin */\n.color-red[_v-1ba72e59] {\n  color: red; }\n\n/* line 14, stdin */\n.row[_v-1ba72e59] {\n  margin-left: 0px;\n  margin-bottom: 15px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {};
    },

    methods: (0, _extends3.default)({}, (0, _vuex.mapMutations)('pos', ['SET_INVOICE_NUMBER']), (0, _vuex.mapActions)('pos', ['changeInvoiceNumber']), {
        withMoneyFormat: function withMoneyFormat(money) {
            return $17.moneyFormat(money);
        }
    }),
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('pos', ['select_order']), {
        invoice_number: {
            get: function get() {
                return this.select_order.invoice_manaual ? this.select_order.invoice_manaual.invoice_number : '';
            },
            set: function set(newValue) {
                this.SET_INVOICE_NUMBER(newValue);
            }
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"row\" _v-1ba72e59=\"\">\n    <div class=\"col-xs-12\" _v-1ba72e59=\"\">\n        <input type=\"text\" v-model.lazy=\"invoice_number\" @change=\"changeInvoiceNumber\" maxlength=\"10\" minlength=\"10\" placeholder=\"輸入發票號碼\" _v-1ba72e59=\"\">\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.discount[_v-1ba72e59], .close[_v-1ba72e59] {\n  color: red; }\n\n/* line 5, stdin */\n.less-space[_v-1ba72e59] {\n  padding-right: 15px; }\n\n/* line 8, stdin */\n.already-refund[_v-1ba72e59] {\n  padding-left: 15px; }\n\n/* line 11, stdin */\n.color-red[_v-1ba72e59] {\n  color: red; }\n\n/* line 14, stdin */\n.row[_v-1ba72e59] {\n  margin-left: 0px;\n  margin-bottom: 15px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-1ba72e59", module.exports)
  } else {
    hotAPI.update("_v-1ba72e59", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1255:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.row[_v-61a110f3] {\n  font-size: 16px;\n  margin-top: 15px; }\n  /* line 5, stdin */\n  .row[_v-61a110f3]:after {\n    content: \"\";\n    width: 100%;\n    border: 1.5px dotted #C7C4C3;\n    margin-top: 40px; }\n    /* line 10, stdin */\n    .row[_v-61a110f3]:after:last-child {\n      height: 0px; }\n\n/* line 15, stdin */\n.invalidAll[_v-61a110f3] {\n  color: red; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    methods: (0, _extends3.default)({
        reset: function reset() {},
        print: function print(ticketNumber, event) {
            var _this = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                $(event.target).prop('disabled', true);
                                $(event.target).notify("列印中請稍候.....", { position: "left", className: "success" });
                                setTimeout(function () {
                                    $(event.target).prop('disabled', false);
                                }, 2000);
                                _context.next = 5;
                                return _this.printTicket(ticketNumber);

                            case 5:
                                $(event.target).prop('disabled', false);

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        printAll: function printAll(detail_id, event) {
            var _this2 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!_this2.printing) {
                                    _context2.next = 2;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 2:
                                $(event.target).notify("列印中請稍候.....", { position: "bottom", className: "success" });
                                _this2.CHANGE_PRINT_STATUS(true);
                                setTimeout(function () {
                                    _this2.CHANGE_PRINT_STATUS(false);
                                }, 2000);
                                _context2.next = 7;
                                return _this2.printAllTicket(detail_id);

                            case 7:
                                _this2.CHANGE_PRINT_STATUS(false);

                            case 8:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        }
    }, (0, _vuex.mapActions)('pos', ['invliadTicket', 'invliadAllTicket']), (0, _vuex.mapMutations)('webadmin/print', ['CHANGE_PRINT_STATUS']), (0, _vuex.mapActions)('webadmin/print', ['checkDefaultPrinter', 'outputTicket', 'outputAllTicket', 'previewTicket', 'previewAllTicket'])),
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        title: function title(state) {
            return state.pos.bought_details.title;
        },
        items: function items(state) {
            return state.pos.bought_details.items;
        },
        detail_id: function detail_id(state) {
            return state.pos.bought_details.detail_id;
        },
        selectOrder: function selectOrder(state) {
            return state.pos.selectOrder;
        },
        printing: function printing(state) {
            return state.webadmin.print.printing;
        }
    }), {
        countShowNumber: function countShowNumber() {
            if (this.items && this.items.length > 0) {
                return this.items.reduce(function (current, it) {
                    return it.status == 0 && !it.isExpired ? parseInt(current) + 1 : current;
                }, 0);
            }

            return 0;
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal id=\"order-bought-ticket\" no-footer=\"\" parallel-modal=\"\" open-size=\"modal-lg\" :close-modal-event=\"reset\" _v-61a110f3=\"\">\n    <span slot=\"title\" _v-61a110f3=\"\">\n      {{ title }}\n    </span>\n    <div slot=\"body\" _v-61a110f3=\"\"> \n        <div class=\"row\" v-if=\"countShowNumber > 0\" _v-61a110f3=\"\">\n            <div class=\"col-xs-12\" _v-61a110f3=\"\">\n                <a href=\"#\" @click=\"outputAllTicket(detail_id)\" _v-61a110f3=\"\">輸出全部 ({{ countShowNumber}})</a>\n                <a href=\"#\" class=\"printAll\" @click.prevent.stop=\"previewAllTicket({ 'orderDetailId':detail_id})\" _v-61a110f3=\"\">列印全部 ({{ countShowNumber}})</a>\n                <a href=\"#\" class=\"invalidAll\" @click=\"invliadAllTicket(detail_id)\" _v-61a110f3=\"\">作廢全部 ({{ countShowNumber}})</a>\n            </div>\n        </div>\n        <div class=\"row\" v-for=\"item in items\" _v-61a110f3=\"\">\n            <div class=\"col-sm-7 col-xs-6\" _v-61a110f3=\"\">票券碼：{{item.ticketNumber}}</div>\n            <div class=\"col-sm-2 col-xs-3 text-right\" _v-61a110f3=\"\">{{item.statusWord}}</div>\n            <div class=\"col-sm-3 col-xs-3\" _v-61a110f3=\"\">\n                <div v-if=\"item.status==0 &amp;&amp; !item.isExpired\" _v-61a110f3=\"\">\n                    <button class=\"btn btn-primary\" @click=\"outputTicket(item.ticketNumber)\" _v-61a110f3=\"\">輸出</button>\n                    <button class=\"btn btn-primary\" @click=\"previewTicket({'ticketId':item.ticketNumber})\" _v-61a110f3=\"\">列印</button>\n                    <button class=\"btn btn-danger btn-inverse\" @click=\"invliadTicket(item.ticketNumber)\" _v-61a110f3=\"\">作廢</button>\n                </div>\n            </div>\n        </div>\n  </div>\n</v-modal>    \n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.row[_v-61a110f3] {\n  font-size: 16px;\n  margin-top: 15px; }\n  /* line 5, stdin */\n  .row[_v-61a110f3]:after {\n    content: \"\";\n    width: 100%;\n    border: 1.5px dotted #C7C4C3;\n    margin-top: 40px; }\n    /* line 10, stdin */\n    .row[_v-61a110f3]:after:last-child {\n      height: 0px; }\n\n/* line 15, stdin */\n.invalidAll[_v-61a110f3] {\n  color: red; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-61a110f3", module.exports)
  } else {
    hotAPI.update("_v-61a110f3", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1256:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.danger[_v-03928908] {\n  background-color: #f8d7da; }\n\n/* line 7, stdin */\n.order-header[_v-03928908] {\n  border-bottom: 2px solid #38b0e3; }\n\n/* line 10, stdin */\n.order_title[_v-03928908] {\n  background-color: #ebebeb; }\n  /* line 12, stdin */\n  .order_title td[_v-03928908] {\n    padding: 12px 6px; }\n\n/* line 16, stdin */\n.order_detail[_v-03928908] {\n  border-top: 1px solid #d6d6d6;\n  border-bottom: 1px solid #d6d6d6; }\n\n/* line 20, stdin */\n.table-responsive[_v-03928908] {\n  border: none; }\n\n/* line 23, stdin */\n.select-botton[_v-03928908] {\n  background-color: #38b0e3;\n  color: #efefef;\n  border-radius: 5px;\n  padding: 6px 18px;\n  border: none;\n  transition: .3s; }\n  /* line 30, stdin */\n  .select-botton[_v-03928908]:hover {\n    background-color: #1d97cb; }\n\n/* line 34, stdin */\n.color-red[_v-03928908] {\n  color: red; }\n\n/* line 37, stdin */\n.color-gray[_v-03928908] {\n  color: #C7C4C3; }\n\n/* line 40, stdin */\n.is_walkin[_v-03928908] {\n  width: 1em; }\n\n/* line 43, stdin */\n.text-overflow-hidden[_v-03928908] {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  max-width: 225px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        hiddenColumnsConfig: {
            default: '',
            description: "An array of list of hidden columns by columns_id. ie:['discount', 'payment_action']"
        }
    },
    data: function data() {
        return {};
    },
    mounted: function mounted() {
        this.setColumnConfig();
    },

    methods: {
        isDangerTitle: function isDangerTitle(order) {
            var isPending = order.refund_pending != null || order.invoice_issue_pending != null || order.invoice_allowance_pending != null;
            var isProblemOrder = order.after_pay_track_code >= 400;
            return isPending || isProblemOrder;
        },
        setColumnConfig: function setColumnConfig() {
            if (!this.hiddenColumnsConfig) {
                return;
            };
            var style = document.createElement('style');
            document.head.appendChild(style);
            this.hiddenColumnsConfig.forEach(function (el) {
                var index = document.getElementById(el).cellIndex;
                if (index) {
                    style.sheet.insertRule('#order-list-pay td:nth-child(' + (index + 1) + ') {display: none}');
                };
            });
        },

        openOrder: function openOrder(payload) {
            this.$store.dispatch('pos/openOrCreateOrder', payload).then(function () {
                $('#order-show').modal('show');
            });
        },
        openOrCreateOperateOrder: function openOrCreateOperateOrder(payload) {
            payload.mode = "show";
            payload.event_type = 'general';

            this.$emit('open-operate-order', payload);
        },
        /**
         * Open refund sync modal.
         * @param payload
         */
        syncPending: function syncPending(payload) {
            $.blockUI();

            var resource = '/adminapi/pos/order/' + payload.order_id + '/refund';
            var data = {};
            var self = this;

            this.$http.post(resource, data).then(function (_ref) {
                var data = _ref.data;

                // TODO add condition for success flag.
                $.unblockUI();
                $17.swal({
                    title: '同步退款資訊成功',
                    text: "",
                    showCancelButton: false,
                    type: 'success'
                }, function () {
                    self.$emit('get-order-list');
                });
            }, function (_ref2) {
                var data = _ref2.data;

                $.unblockUI();
                $17.swal({
                    title: '同步退款資訊發生錯誤',
                    text: "",
                    showCancelButton: false,
                    type: 'warning'
                }, function () {
                    self.$emit('get-order-list');
                });
            });
        },
        syncInvoicePending: function syncInvoicePending(payload) {
            $.blockUI();
            var resource = '/adminapi/invoice/order/' + payload.order_id;
            var data = {};
            var self = this;

            this.$http.post(resource, data).then(function (_ref3) {
                var data = _ref3.data;

                $.unblockUI();
                $17.swal({
                    title: '同步付款資訊成功',
                    text: "",
                    showCancelButton: false,
                    type: 'success'
                }, function () {
                    self.$emit('get-order-list');
                });
            }, function (_ref4) {
                var data = _ref4.data;

                $.unblockUI();
                $17.swal({
                    title: '同步付款資訊發生錯誤',
                    text: "",
                    showCancelButton: false,
                    type: 'warning'
                }, function () {
                    self.$emit('get-order-list');
                });
            });
        },

        checkFilter: function checkFilter(key, data) {
            var reg = new RegExp(key + '.*');
            return reg.test(data);
        },
        getOrderList: function getOrderList() {
            this.$emit('get-order-list');
        },
        changeSelectBranchValue: function changeSelectBranchValue(branch_id) {
            this.$emit('change-select-branch', branch_id);
        },
        discountValue: function discountValue(detail) {
            return !detail.order_detail_discount ? 0 : detail.order_detail_discount.value;
        },
        discountType: function discountType(detail) {
            return !detail.order_detail_discount ? 1 : detail.order_detail_discount.type;
        },
        discountValueShow: function discountValueShow(detail) {
            var discount_type = parseInt(detail.order_detail_discount.type);

            return typeof detail.order_detail_discount.value != 'undefined' && detail.order_detail_discount.value > 0 ? this.calulateDiscountTotal(detail.qty * detail.price, discount_type, detail.order_detail_discount.value) : '';
        },
        detailTotalMoney: function detailTotalMoney(detail) {
            return detail.sub_total;
        },
        detailSubTotal: function detailSubTotal(detail) {
            return detail.qty * detail.price;
        },
        withMoneyFormat: function withMoneyFormat(money) {
            return $17.moneyFormat(money);
        },
        withThousandthFormat: function withThousandthFormat(money) {
            return $17.thousandthFormat(money);
        },
        checkIsRefund: function checkIsRefund(order_detail) {
            return order_detail.refer_order_detail_id != null;
        },
        finalShowPaymentType: function finalShowPaymentType(order) {
            if (order.payment_action_record && order.payment_action_records.length !== 0) {
                return this.paymentDisplayName(order.payment_action_records[0].studio_payment_method);
            } else {
                return '';
            };
        },
        checkShowOpenButton: function checkShowOpenButton(order) {
            return order.refund_pending == null && order.invoice_issue_pending == null && order.invoice_allowance_pending == null && [4, 6].indexOf(order.payment_status) == -1;
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
        calulateDiscountTotal: 'pos/CALCULATE_DISCOUNT_DETAIL_MONEY'
    }), (0, _vuex.mapState)({
        orders: function orders(state) {
            return state.pos.orders;
        },
        time_start: function time_start(state) {
            return state.pos.time_start;
        },
        time_end: function time_end(state) {
            return state.pos.time_end;
        },
        branch_id: function branch_id(state) {
            return state.filters.selected_branch_id;
        },
        is_17fit: function is_17fit(state) {
            return state.pos.is_17fit;
        },
        payment_status: function payment_status(state) {
            return state.pos.payment_status;
        },
        payment_filter: function payment_filter(state) {
            return state.pos.payment_filter;
        }
    }))
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div id=\"order-list-pay\" _v-03928908=\"\">\n    <div class=\"table-responsive\" _v-03928908=\"\">\n        <table class=\"table orders-table\" _v-03928908=\"\">\n            <thead _v-03928908=\"\">\n                <tr class=\"order-header\" _v-03928908=\"\">\n                    <td id=\"order_id\" _v-03928908=\"\">訂單編號</td>\n                    <td id=\"payment_status_show\" _v-03928908=\"\">訂單狀態</td>\n                    <td id=\"checkout_at\" _v-03928908=\"\">結帳日期</td>\n                    <td id=\"member\" _v-03928908=\"\">客戶姓名</td>\n                    <td id=\"payment_action\" _v-03928908=\"\">支付方式</td>\n                    <td id=\"product\" _v-03928908=\"\">項目</td>\n                    <td id=\"invoice\" _v-03928908=\"\">發票</td>\n                    <td id=\"discount\" _v-03928908=\"\">折扣</td>\n                    <td id=\"payment_total\" _v-03928908=\"\">金額</td>\n                    <td id=\"checkout_member\" _v-03928908=\"\">結帳人員</td>\n                    <td id=\"action_button\" _v-03928908=\"\">動作</td>\n                </tr>\n            </thead>\n            <tbody _v-03928908=\"\">\n                <template v-for=\"order in orders\">\n                    <tr v-bind:class=\"['order_title', { danger:isDangerTitle(order) }]\" _v-03928908=\"\">\n                        <td _v-03928908=\"\">{{order.id}}</td>\n                        <td _v-03928908=\"\">{{order.payment_status_show}}</td>\n                        <td _v-03928908=\"\">{{order.checkout_at&amp;&amp;order.checkout_at.substring(0,16)}}</td>\n                        <td _v-03928908=\"\">\n                            <img v-if=\"order.is_walkin\" class=\"is_walkin\" src=\"/images/walking.png\" _v-03928908=\"\">\n                            {{order.member_name}}\n                        </td>\n                        <td _v-03928908=\"\">{{ finalShowPaymentType(order) }}</td>\n                        <td _v-03928908=\"\"></td>\n                        <td _v-03928908=\"\"> {{order.invoice_number}}</td>\n                        <td _v-03928908=\"\"></td>\n                        <td _v-03928908=\"\">\n                            <span v-show=\"order.payment_status > 0\" _v-03928908=\"\">\n                                <span v-if=\"order.payment_total_money >=0\" _v-03928908=\"\">{{ withMoneyFormat(order.payment_total_money) }} </span>\n                                <span v-else=\"\" class=\"color-red\" _v-03928908=\"\"> -{{ withMoneyFormat(Math.abs(order.payment_total_money)) }}</span>\n                            </span>\n                        </td>\n                        <td class=\"text-overflow-hidden\" style=\"max-width: 20px;\" _v-03928908=\"\">{{order.checkout_member_id==null||order.checkout_member_id==0?'':order.checkout_member.name}}</td>\n                        <td _v-03928908=\"\">\n                            <input v-show=\"checkShowOpenButton(order,'new')\" class=\"select-botton\" type=\"button\" value=\"開啟訂單\" :id=\"'button'+order.id\" v-on:click=\"openOrCreateOperateOrder({\n                                        'order_id':order.id,\n                                    })\" _v-03928908=\"\">\n                            <input v-show=\"(order.refund_pending != null)\" class=\"select-botton\" type=\"button\" value=\"同步訂單\" :id=\"'button'+order.id\" v-on:click=\"syncPending({'status':true,'order_id':order.id});\" _v-03928908=\"\">\n                            <input v-show=\"(order.invoice_issue_pending != null || order.invoice_allowance_pending != null)\" class=\"select-botton\" type=\"button\" value=\"同步訂單\" :id=\"'button'+order.id\" v-on:click=\"syncInvoicePending({'status':true,'order_id':order.id});\" _v-03928908=\"\">\n                        </td>\n                    </tr>\n                    <tr v-for=\"order_detail in order.order_details\" class=\"order_detail\" _v-03928908=\"\">\n                        <td _v-03928908=\"\"></td>\n                        <td _v-03928908=\"\"></td>\n                        <td _v-03928908=\"\"></td>\n                        <td _v-03928908=\"\"></td>\n                        <td _v-03928908=\"\"></td>\n                        <td class=\"text-overflow-hidden\" _v-03928908=\"\">\n                            <template v-if=\"order_detail.refer_order_detail_id != null\">\n                                <span class=\"color-red\" _v-03928908=\"\">退費：\n                                </span>\n                                {{order_detail.product_name}}\n                            </template>\n                            <template v-else-if=\"order_detail.refund_details.length >0\">\n                                <span class=\"color-gray\" _v-03928908=\"\">\n                                已退費：{{order_detail.product_name}}\n                                </span>\n                            </template>\n                            <template v-else=\"\">\n                                {{order_detail.product_name}}\n                            </template>\n                        </td>\n                        <td _v-03928908=\"\"></td>\n                        <td _v-03928908=\"\">\n                            <span v-if=\"order.type !=13 &amp;&amp; discountValue(order_detail)>0\" class=\"color-red\" _v-03928908=\"\">\n                                 {{'-'+withThousandthFormat(discountValueShow(order_detail))}}\n                            </span>\n                        </td>\n                        <td _v-03928908=\"\">\n                            <span v-if=\"detailTotalMoney(order_detail) >=0\" _v-03928908=\"\"> {{withMoneyFormat(detailTotalMoney(order_detail))}}</span>\n                            <span v-else=\"\" class=\"color-red\" _v-03928908=\"\"> -{{ withMoneyFormat(Math.abs(detailTotalMoney(order_detail)))}}</span>\n                        </td>\n                        <td _v-03928908=\"\"></td>\n                        <td _v-03928908=\"\"></td>\n                    </tr>\n                </template>\n            </tbody>\n        </table>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.danger[_v-03928908] {\n  background-color: #f8d7da; }\n\n/* line 7, stdin */\n.order-header[_v-03928908] {\n  border-bottom: 2px solid #38b0e3; }\n\n/* line 10, stdin */\n.order_title[_v-03928908] {\n  background-color: #ebebeb; }\n  /* line 12, stdin */\n  .order_title td[_v-03928908] {\n    padding: 12px 6px; }\n\n/* line 16, stdin */\n.order_detail[_v-03928908] {\n  border-top: 1px solid #d6d6d6;\n  border-bottom: 1px solid #d6d6d6; }\n\n/* line 20, stdin */\n.table-responsive[_v-03928908] {\n  border: none; }\n\n/* line 23, stdin */\n.select-botton[_v-03928908] {\n  background-color: #38b0e3;\n  color: #efefef;\n  border-radius: 5px;\n  padding: 6px 18px;\n  border: none;\n  transition: .3s; }\n  /* line 30, stdin */\n  .select-botton[_v-03928908]:hover {\n    background-color: #1d97cb; }\n\n/* line 34, stdin */\n.color-red[_v-03928908] {\n  color: red; }\n\n/* line 37, stdin */\n.color-gray[_v-03928908] {\n  color: #C7C4C3; }\n\n/* line 40, stdin */\n.is_walkin[_v-03928908] {\n  width: 1em; }\n\n/* line 43, stdin */\n.text-overflow-hidden[_v-03928908] {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  max-width: 225px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-03928908", module.exports)
  } else {
    hotAPI.update("_v-03928908", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1257:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.danger[_v-0fd33a4f] {\n  background-color: #f8d7da; }\n\n/* line 7, stdin */\n.order-header[_v-0fd33a4f] {\n  border-bottom: 2px solid #38b0e3; }\n\n/* line 10, stdin */\n.order_title[_v-0fd33a4f] {\n  background-color: #ebebeb; }\n  /* line 12, stdin */\n  .order_title td[_v-0fd33a4f] {\n    padding: 12px 6px; }\n\n/* line 16, stdin */\n.order_detail[_v-0fd33a4f] {\n  border-top: 1px solid #d6d6d6;\n  border-bottom: 1px solid #d6d6d6; }\n\n/* line 20, stdin */\n.table-responsive[_v-0fd33a4f] {\n  border: none; }\n\n/* line 23, stdin */\n.select-botton[_v-0fd33a4f] {\n  background-color: #38b0e3;\n  color: #efefef;\n  border-radius: 5px;\n  padding: 6px 18px;\n  border: none;\n  transition: .3s; }\n  /* line 30, stdin */\n  .select-botton[_v-0fd33a4f]:hover {\n    background-color: #1d97cb; }\n\n/* line 34, stdin */\n.color-red[_v-0fd33a4f] {\n  color: red; }\n\n/* line 37, stdin */\n.color-gray[_v-0fd33a4f] {\n  color: #C7C4C3; }\n\n/* line 40, stdin */\n.is_walkin[_v-0fd33a4f] {\n  width: 1em; }\n\n/* line 43, stdin */\n.text-overflow-hidden[_v-0fd33a4f] {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  max-width: 225px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        hiddenColumnsConfig: {
            default: '',
            description: "An array of list of hidden columns by columns_id. ie:['discount', 'action_button']"
        }
    },
    data: function data() {
        return {};
    },
    mounted: function mounted() {
        this.setColumnConfig();
    },

    methods: {
        setColumnConfig: function setColumnConfig() {
            if (!this.hiddenColumnsConfig) {
                return;
            };
            var style = document.createElement('style');
            document.head.appendChild(style);
            this.hiddenColumnsConfig.forEach(function (el) {
                var index = document.getElementById(el).cellIndex;
                if (index) {
                    style.sheet.insertRule('#order-list-unpay td:nth-child(' + (index + 1) + ') {display: none}');
                };
            });
        },
        openOrder: function openOrder(payload) {
            var _this = this;

            this.$store.dispatch('pos/openOrCreateOrder', payload).then(function () {
                $('#order-edit').modal('show');

                _this.changeSelectBranchValue(payload.branch_id);
                _this.$store.dispatch('pos/getCommonlyUsedItem', payload.branch_id);
            });
        },


        /**
         * Open checkout sync modal.
         * @param payload
         */
        syncPending: function syncPending(payload) {
            $.blockUI();

            var resource = '/adminapi/pos/bill_order/' + payload.order_id;
            var data = {
                'skip_alert': 1
            };
            var self = this;

            this.$http.post(resource, data).then(function (_ref) {
                var data = _ref.data;

                // TODO add condition for success flag.
                $.unblockUI();
                $17.swal({
                    title: '同步付款資訊成功',
                    text: "",
                    showCancelButton: false,
                    type: 'success'
                }, function () {
                    self.$emit('get-order-list');
                });
            }, function (_ref2) {
                var data = _ref2.data;

                $.unblockUI();
                $17.swal({
                    title: '同步付款資訊發生錯誤',
                    text: "",
                    showCancelButton: false,
                    type: 'warning'
                }, function () {
                    self.$emit('get-order-list');
                });
            });
        },
        checkFilter: function checkFilter(key, data) {
            var reg = new RegExp(key + '.*');
            return reg.test(data);
        },
        getOrderList: function getOrderList() {
            this.$emit('get-order-list');
        },
        changeSelectBranchValue: function changeSelectBranchValue(branch_id) {
            this.select_branch_id = branch_id;
            this.$emit('change-select-branch', branch_id);
        },
        discountValue: function discountValue(detail) {
            return !detail.order_detail_discount ? 0 : detail.order_detail_discount.value;
        },
        discountType: function discountType(detail) {
            return !detail.order_detail_discount ? 1 : detail.order_detail_discount.type;
        },
        discountValueShow: function discountValueShow(detail) {
            var discount_type = parseInt(detail.order_detail_discount.type);

            return typeof detail.order_detail_discount.value != 'undefined' && detail.order_detail_discount.value > 0 ? this.calulateDiscountTotal(detail.qty * detail.price, discount_type, detail.order_detail_discount.value) : '';
        },
        detailTotalMoney: function detailTotalMoney(detail) {
            return detail.sub_total;
        },
        detailSubTotal: function detailSubTotal(detail) {
            return detail.qty * detail.price;
        },
        withMoneyFormat: function withMoneyFormat(money) {
            return $17.moneyFormat(money);
        },
        withThousandthFormat: function withThousandthFormat(money) {
            return $17.thousandthFormat(money);
        },
        checkIsRefund: function checkIsRefund(order_detail) {
            return order_detail.refer_order_detail_id != null;
        },

        openOrCreateOperateOrder: function openOrCreateOperateOrder(payload) {
            payload.mode = "edit";
            payload.event_type = 'general';
            this.$emit('open-operate-order', payload);
        },
        checkShowOpenButton: function checkShowOpenButton(order) {
            return order.checkout_pending == null && [4, 6, 9].indexOf(order.payment_status) == -1;
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
        calulateDiscountTotal: 'pos/CALCULATE_DISCOUNT_DETAIL_MONEY'
    }), (0, _vuex.mapState)({
        orders: function orders(state) {
            return state.pos.orders;
        },
        time_start: function time_start(state) {
            return state.pos.time_start;
        },
        time_end: function time_end(state) {
            return state.pos.time_end;
        },
        branch_id: function branch_id(state) {
            return state.filters.selected_branch_id;
        },
        is_17fit: function is_17fit(state) {
            return state.pos.is_17fit;
        },
        payment_status: function payment_status(state) {
            return state.pos.payment_status;
        },
        payment_filter: function payment_filter(state) {
            return state.pos.payment_filter;
        }
    }), {
        select_branch_id: {
            get: function get() {
                return store.state.pos.select_branch_id;
            },
            set: function set(newValue) {
                this.$store.commit('pos/POS_SETSTATUS', { 'key': 'select_branch_id', value: newValue });
            }
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div id=\"order-list-unpay\" _v-0fd33a4f=\"\">\n    <div class=\"table-responsive\" _v-0fd33a4f=\"\">\n        <table class=\"table orders-table\" _v-0fd33a4f=\"\">\n            <thead _v-0fd33a4f=\"\">\n                <tr class=\"order-header\" _v-0fd33a4f=\"\">\n                    <td id=\"order_id\" _v-0fd33a4f=\"\">訂單編號</td>\n                    <td id=\"payment_status_show\" _v-0fd33a4f=\"\">訂單狀態</td>\n                    <td id=\"created_at\" _v-0fd33a4f=\"\">建立日期</td>\n                    <td id=\"member\" _v-0fd33a4f=\"\">客戶姓名</td>\n                    <td id=\"product\" _v-0fd33a4f=\"\">項目</td>\n                    <td id=\"qty\" _v-0fd33a4f=\"\">數量</td>\n                    <td id=\"price\" _v-0fd33a4f=\"\">單價</td>\n                    <td id=\"subtotal\" _v-0fd33a4f=\"\">小計</td>\n                    <td id=\"discount\" _v-0fd33a4f=\"\">折扣</td>\n                    <td id=\"payment_total\" _v-0fd33a4f=\"\">金額</td>\n                    <td id=\"action_button\" _v-0fd33a4f=\"\">動作</td>\n                </tr>\n            </thead>\n            <tbody _v-0fd33a4f=\"\">\n                <template v-for=\"order in this.orders\">\n                    <tr v-bind:class=\"['order_title', { danger: (order.checkout_pending != null),}]\" _v-0fd33a4f=\"\">\n                        <td _v-0fd33a4f=\"\">{{order.id}}</td>\n                        <td _v-0fd33a4f=\"\">{{order.payment_status_show}}</td>\n                        <td _v-0fd33a4f=\"\">{{order.date&amp;&amp;order.date.substring(0,16)}}</td>\n                        <td _v-0fd33a4f=\"\">\n                            <img v-if=\"order.is_walkin\" class=\"is_walkin\" src=\"/images/walking.png\" _v-0fd33a4f=\"\">\n                            {{order.member_name}}\n                        </td>\n                        <td _v-0fd33a4f=\"\"></td>\n                        <td _v-0fd33a4f=\"\"></td>\n                        <td _v-0fd33a4f=\"\"></td>\n                        <td _v-0fd33a4f=\"\"></td>\n                        <td _v-0fd33a4f=\"\"></td>\n                        <td _v-0fd33a4f=\"\">\n                            <span v-show=\"order.payment_status > 0 &amp;&amp; order.payment_total_money>0\" _v-0fd33a4f=\"\">\n                                <span v-if=\"order.payment_total_money >=0\" _v-0fd33a4f=\"\">{{ withMoneyFormat(order.payment_total_money) }} </span>\n                                <span v-else=\"\" class=\"color-red\" _v-0fd33a4f=\"\"> -{{ withMoneyFormat(Math.abs(order.payment_total_money)) }}</span>\n                            </span>\n                        </td>\n                        <td _v-0fd33a4f=\"\">\n                            <input v-show=\"checkShowOpenButton(order)\" class=\"select-botton\" type=\"button\" value=\"開啟訂單\" :id=\"'button'+order.id\" v-on:click=\"openOrCreateOperateOrder({'order_id':order.id})\" _v-0fd33a4f=\"\">\n                            <input v-show=\"(order.checkout_pending != null)\" class=\"select-botton\" type=\"button\" value=\"同步訂單\" :id=\"'button'+order.id\" v-on:click=\"syncPending({'status':true,'order_id':order.id,'branch_id':order.branch_id});\" _v-0fd33a4f=\"\">\n                        </td>\n                    </tr>\n                    <tr v-for=\"order_detail in order.order_details\" class=\"order_detail\" _v-0fd33a4f=\"\">\n                        <td _v-0fd33a4f=\"\"></td>\n                        <td _v-0fd33a4f=\"\"></td>\n                        <td _v-0fd33a4f=\"\"></td>\n                        <td _v-0fd33a4f=\"\"></td>\n                        <td class=\"text-overflow-hidden\" _v-0fd33a4f=\"\">\n                            <template v-if=\"order_detail.refer_order_detail_id != null\">\n                                <span class=\"color-red\" _v-0fd33a4f=\"\">退費：\n                                </span>\n                                {{order_detail.product_name}}\n                            </template>\n                            <template v-else-if=\"order_detail.refund_details.length >0\">\n                                <span class=\"color-gray\" _v-0fd33a4f=\"\">\n                                已退費：{{order_detail.product_name}}\n                                </span>\n                            </template>\n                            <template v-else=\"\">\n                                {{order_detail.product_name}}\n                            </template>\n                        </td>\n                        <td _v-0fd33a4f=\"\">{{order_detail.qty}}</td>\n                        <td _v-0fd33a4f=\"\">{{withThousandthFormat(order_detail.price)}}</td>\n                        <td _v-0fd33a4f=\"\">\n                            <span v-if=\"order_detail.refer_order_detail_id == null\" _v-0fd33a4f=\"\">\n                                {{withThousandthFormat(detailSubTotal(order_detail))}}\n                            </span>\n                        </td>\n                        <td _v-0fd33a4f=\"\">\n                            <span v-if=\"order.type !=13 &amp;&amp; discountValue(order_detail)>0\" class=\"color-red\" _v-0fd33a4f=\"\">\n                                 {{'-'+withThousandthFormat(discountValueShow(order_detail))}}\n                            </span>\n                            <span v-else=\"\" _v-0fd33a4f=\"\">\n                                \n                            </span>\n                        </td>\n                        <td _v-0fd33a4f=\"\">\n                            <span v-if=\"detailTotalMoney(order_detail) >=0\" _v-0fd33a4f=\"\"> {{withMoneyFormat(detailTotalMoney(order_detail))}}</span>\n                            <span v-else=\"\" class=\"color-red\" _v-0fd33a4f=\"\"> -{{ withMoneyFormat(Math.abs(detailTotalMoney(order_detail)))}}</span>\n                        </td>\n                        <td _v-0fd33a4f=\"\"></td>\n                    </tr>\n                </template>\n            </tbody>\n        </table>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.danger[_v-0fd33a4f] {\n  background-color: #f8d7da; }\n\n/* line 7, stdin */\n.order-header[_v-0fd33a4f] {\n  border-bottom: 2px solid #38b0e3; }\n\n/* line 10, stdin */\n.order_title[_v-0fd33a4f] {\n  background-color: #ebebeb; }\n  /* line 12, stdin */\n  .order_title td[_v-0fd33a4f] {\n    padding: 12px 6px; }\n\n/* line 16, stdin */\n.order_detail[_v-0fd33a4f] {\n  border-top: 1px solid #d6d6d6;\n  border-bottom: 1px solid #d6d6d6; }\n\n/* line 20, stdin */\n.table-responsive[_v-0fd33a4f] {\n  border: none; }\n\n/* line 23, stdin */\n.select-botton[_v-0fd33a4f] {\n  background-color: #38b0e3;\n  color: #efefef;\n  border-radius: 5px;\n  padding: 6px 18px;\n  border: none;\n  transition: .3s; }\n  /* line 30, stdin */\n  .select-botton[_v-0fd33a4f]:hover {\n    background-color: #1d97cb; }\n\n/* line 34, stdin */\n.color-red[_v-0fd33a4f] {\n  color: red; }\n\n/* line 37, stdin */\n.color-gray[_v-0fd33a4f] {\n  color: #C7C4C3; }\n\n/* line 40, stdin */\n.is_walkin[_v-0fd33a4f] {\n  width: 1em; }\n\n/* line 43, stdin */\n.text-overflow-hidden[_v-0fd33a4f] {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  max-width: 225px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-0fd33a4f", module.exports)
  } else {
    hotAPI.update("_v-0fd33a4f", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1258:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.discount[_v-45c5462e], .close[_v-45c5462e] {\n  color: red; }\n\n/* line 5, stdin */\n.less-space[_v-45c5462e] {\n  padding-right: 15px; }\n\n/* line 8, stdin */\n.already-refund[_v-45c5462e] {\n  padding-left: 15px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _extends2;

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    'refundSuccessCallBack': {},
    'refundFailCallBack': {},
    'refundCancelCallBack': {},
    'billSuccessCallBack': {},
    'billFailCallBack': {},
    'invalidSuccessCallBack': {},
    'closeModalEvent': Function,
    'enableEdit': {
      default: false
    },
    'enableShow': {
      default: false
    },
    'enableRefund': {
      default: false
    },
    'idPrefix': {
      default: 'order'
    },
    enableChangeMember: {}
  },
  data: function data() {
    return {
      autoPrintProcessed: false
    };
  },

  watch: {
    'select_order_detail': {
      handler: function handler(newVal) {
        if (newVal) {
          this.footerAbj.actionFunction = newVal.type == 13 ? 'previewDiscountNote' : 'previewOrder';
        }
      },
      deep: true
    }
  },
  methods: (0, _extends4.default)({
    billCheckoutSuccess: function billCheckoutSuccess(response) {
      var _this = this;

      if (this.autoPrintConfig.auto_printer_status) {
        this.autoPrintProcessed = true;
        this.$store.dispatch('webadmin/print/orderAutoPrint', {
          orderId: this.select_order_id,
          printConfig: this.autoPrintConfig
        });
        setTimeout(function () {
          _this.autoPrintProcessed = false;
        }, 3000);
      }
      this.billSuccessCallBack && this.billSuccessCallBack(response);
    },
    billCheckoutFail: function billCheckoutFail(response) {
      this.billFailCallBack && this.billFailCallBack(response);
    },

    closeModalEventRefund: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.$store.commit('pos/RESET_REFUND', { 'key': 'moneys', value: [] });
                _context.t0 = this.closeModalEvent;

                if (!_context.t0) {
                  _context.next = 5;
                  break;
                }

                _context.next = 5;
                return this.closeModalEvent();

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function closeModalEventRefund() {
        return _ref.apply(this, arguments);
      }

      return closeModalEventRefund;
    }(),
    closeModalEventA: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.t0 = this.closeModalEvent;

                if (!_context2.t0) {
                  _context2.next = 4;
                  break;
                }

                _context2.next = 4;
                return this.closeModalEvent();

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function closeModalEventA() {
        return _ref2.apply(this, arguments);
      }

      return closeModalEventA;
    }()
  }, (0, _vuex.mapActions)('webadmin/print', ['previewOrder']), {
    previewCurrentOrder: function previewCurrentOrder() {
      this.previewOrder({ 'orderId': this.id });
    }
  }),
  computed: (0, _extends4.default)({}, (0, _vuex.mapState)({
    select_order: function select_order(state) {
      return state.pos.select_order;
    },
    current_order_id: function current_order_id(state) {
      return state.pos.select_order.id;
    },
    alert_obj: function alert_obj(state) {
      return store.state.pos.alert_obj;
    },
    autoPrintConfig: function autoPrintConfig(state) {
      return state.webadmin.webLocalSetting.printerSetting;
    }
  }), (_extends2 = {
    extraDataForMemberContractEdit: function extraDataForMemberContractEdit() {
      return {
        branch_id: this.select_order.branch_id
      };
    },

    select_order_id: function select_order_id() {
      return store.state.pos.order_id;
    },
    select_order_detail: function select_order_detail() {
      return store.state.pos.current_order_detail;
    }
  }, (0, _defineProperty3.default)(_extends2, 'select_order_detail', function select_order_detail() {
    return store.state.pos.current_order_detail;
  }), (0, _defineProperty3.default)(_extends2, 'selectOrderStatusName', function selectOrderStatusName() {
    //新增
    return store.state.pos.select_order.orderStatusName || null;
  }), (0, _defineProperty3.default)(_extends2, 'selectTypeIcon', function selectTypeIcon() {
    var typeIcon = store.state.pos.select_order.type || null;

    switch (typeIcon) {
      case 13:
        return 'indeterminate_check_box';
        break;

      case 14:
        return 'payments';
        break;

      case 17:
        return 'auto_mode';
        break;

      default:
        break;
    }
  }), (0, _defineProperty3.default)(_extends2, 'disabledMultiAlertModal', function disabledMultiAlertModal() {
    return this.autoPrintProcessed;
  }), (0, _defineProperty3.default)(_extends2, 'footerAbj', function footerAbj() {
    return {
      actionFunction: "previewOrder",
      actionWord: this.autoPrintProcessed ? "列印處理中" : "列印全部",
      actionBtn: this.autoPrintProcessed ? "btn btn--inverse btn-default btn-lg" : "btn-success btn-lg",
      detailContent: "",
      detailTitle: "",
      icon: "",
      statusWord: "",
      disabled: this.autoPrintProcessed
    };
  }), _extends2))
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-45c5462e=\"\">\n    <v-modal :id=\"idPrefix+'-edit'\" no-footer=\"\" parallel-modal=\"\" open-size=\"modal-lg\" :close-modal-event=\"closeModalEventA\" v-if=\"enableEdit\" :body-class=\"['p-top-0','p-bottom-0','p-left-10','p-right-0']\" _v-45c5462e=\"\">\n      <span slot=\"title\" class=\"st-flex st-align-center\" _v-45c5462e=\"\">\n        <span class=\"material-icons\" _v-45c5462e=\"\">\n        {{selectTypeIcon}}\n        </span>\n        <span class=\"st-text-gray-90 st-mx-1\" _v-45c5462e=\"\"> \n          訂單\n        </span>\n        @{{current_order_id}}\n        <span class=\"st-mx-4\" _v-45c5462e=\"\">|</span>\n        <span class=\"st-mr-4\" _v-45c5462e=\"\">{{selectOrderStatusName}}</span>\n        <v-admin-operate-record type=\"order\" :id=\"current_order_id\" _v-45c5462e=\"\"></v-admin-operate-record>\n      </span>\n      <order-edit :bill-success-call-back=\"billCheckoutSuccess\" :bill-fail-call-back=\"billCheckoutFail\" :enable-change-member=\"enableChangeMember\" :invalid-success-call-back=\"invalidSuccessCallBack\" slot=\"body\" _v-45c5462e=\"\"></order-edit>\n    </v-modal>    \n    <v-modal :id=\"idPrefix+'-show'\" no-footer=\"\" parallel-modal=\"\" open-size=\"modal-lg\" :close-modal-event=\"closeModalEventA\" v-if=\"enableShow\" _v-45c5462e=\"\">\n      <span slot=\"title\" class=\"st-flex st-align-center\" _v-45c5462e=\"\">\n        <span class=\"material-icons\" _v-45c5462e=\"\">\n        {{selectTypeIcon}}\n        </span>\n        <span class=\"st-text-gray-90 st-mx-1\" _v-45c5462e=\"\"> \n          訂單\n        </span>\n        @{{current_order_id}}\n        <span class=\"st-mx-4\" _v-45c5462e=\"\">|</span>\n        <span class=\"st-mr-4\" _v-45c5462e=\"\">{{selectOrderStatusName}}</span>\n        <v-admin-operate-record type=\"order\" :id=\"current_order_id\" _v-45c5462e=\"\"></v-admin-operate-record>\n      </span>\n      <order-show slot=\"body\" :enable-refund=\"enableRefund\" :invalid-success-call-back=\"invalidSuccessCallBack\" _v-45c5462e=\"\"></order-show>\n    </v-modal>\n\n    <v-modal :id=\"idPrefix+'-refund'\" no-footer=\"\" parallel-modal=\"\" open-size=\"modal-lg\" :close-modal-event=\"closeModalEventRefund\" v-if=\"enableRefund\" _v-45c5462e=\"\">\n      <span slot=\"title\" class=\"st-flex st-align-center\" _v-45c5462e=\"\">\n        <span class=\"material-icons\" _v-45c5462e=\"\">\n        {{selectTypeIcon}}\n        </span>\n        <span class=\"st-text-gray-90 st-mx-1\" _v-45c5462e=\"\"> \n          訂單\n        </span>\n        @{{current_order_id}}\n        <span class=\"st-mx-4\" _v-45c5462e=\"\">|</span>\n        <span class=\"st-mr-4\" _v-45c5462e=\"\">{{selectOrderStatusName}}</span>\n        <v-admin-operate-record type=\"order\" :id=\"current_order_id\" _v-45c5462e=\"\"></v-admin-operate-record>\n      </span>\n      <order-refund slot=\"body\" :refund-success-call-back=\"refundSuccessCallBack\" :refund-fail-call-back=\"refundFailCallBack\" :refund-cancel-call-back=\"refundCancelCallBack\" _v-45c5462e=\"\"></order-refund>\n    </v-modal>\n\n    <product-list _v-45c5462e=\"\"></product-list>\n    <product-append _v-45c5462e=\"\"></product-append>\n    <product-item-show _v-45c5462e=\"\"></product-item-show>\n    <order-bought-item-ticket _v-45c5462e=\"\"></order-bought-item-ticket>\n\n    <contract-edit :extra-data=\"extraDataForMemberContractEdit\" _v-45c5462e=\"\"></contract-edit>\n    <contract-time-edit _v-45c5462e=\"\"></contract-time-edit>\n    <contract-point-edit _v-45c5462e=\"\"></contract-point-edit>\n    <contract-status-edit _v-45c5462e=\"\"></contract-status-edit>\n\n    <v-multi-alert-model :model-title=\"'訂單 '+select_order_id\" :alert-obj=\"alert_obj\" :disabled-all-action=\"disabledMultiAlertModal\" _v-45c5462e=\"\">\n    &gt;\n        <template slot=\"footer\" slot-scope=\"current_order_id\">\n\t\t\t  <v-custom-alert-item :icon=\"footerAbj.icon\" :status-word=\"footerAbj.statusWord\" :action-word=\"footerAbj.actionWord\" :action-function=\"footerAbj.actionFunction\" :detail-title=\"footerAbj.detailTitle\" :detail-content=\"footerAbj.detailContent\" :btn-disabled=\"footerAbj.disabled\" :action-btn=\"footerAbj.actionBtn\" _v-45c5462e=\"\">\n\t\t    </v-custom-alert-item>\n\t\t</template>\n    </v-multi-alert-model>\n\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.discount[_v-45c5462e], .close[_v-45c5462e] {\n  color: red; }\n\n/* line 5, stdin */\n.less-space[_v-45c5462e] {\n  padding-right: 15px; }\n\n/* line 8, stdin */\n.already-refund[_v-45c5462e] {\n  padding-left: 15px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-45c5462e", module.exports)
  } else {
    hotAPI.update("_v-45c5462e", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/defineProperty":65,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1259:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 3, stdin */\n.branchName[_v-78094e73] {\n  margin: 1em 0em;\n  font-size: 1em;\n  font-weight: bold; }\n")
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vuex = require("vuex");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        setting: {
            type: Object,
            default: function _default(rawProps) {}
        },
        order: {
            type: Object,
            default: function _default(rawProps) {
                return {
                    payment: ""
                };
            }
        },
        member: {
            type: Object,
            default: function _default(rawProps) {
                return {};
            }
        },
        details: {
            type: Array,
            default: function _default(rawProps) {
                return [];
            }
        },
        branch: {
            type: Object,
            default: function _default(rawProps) {
                return [];
            }
        },
        invoice: {
            type: Object,
            default: function _default(rawProps) {
                return [];
            }
        },
        payments: {
            type: Array,
            default: function _default(rawProps) {
                return [];
            }
        },
        orderChanging: {
            default: false
        },
        paymentCheckCallBack: {
            type: Function
        },
        invalidSuccessCallBack: {
            type: Function
        },
        actionData: {
            type: Object,
            default: function _default(rawProps) {
                return {
                    invoice: {},
                    paymentInput: [] //payment_action_record_id:{}
                };
            }
        },
        eventType: {
            default: 'general'
        }
    },
    data: function data() {
        return {
            ajaxing: {
                invalid: false,
                bill: false
            },
            skipBillingAlert: 0
        };
    },

    watch: {},
    methods: {
        orderCanBeDelete: function orderCanBeDelete() {
            return this.details.reduce(function (check, detail) {
                if (detail.can_be_delete == false) {
                    check = false;
                }
                return check;
            }, true);
        },
        invalidOrder: function invalidOrder() {
            var vm = this;
            if (this.order.payment_status > 0 || !this.orderCanBeDelete()) {
                return false;
            }
            $17.swal({
                title: "刪除確認？",
                text: "確認刪除此訂單",
                type: "warning"
            }, function () {
                $.blockUI({ timeout: 10000 });
                vm.$http.post("/adminapi/pos/invalid_order/" + vm.order.id).then(function (response) {
                    if (response.status) {
                        window.Event.$emit("System.Pos.Order.CancelSuccess", {
                            order_id: vm.order.id
                        });
                    }
                    $.unblockUI();
                }, function (_ref) {
                    var data = _ref.data;

                    $17.swal({
                        title: data.message,
                        text: "",
                        type: "warning"
                    });
                    $.unblockUI();
                });
            });
        },

        canBill: function canBill() {
            return this.branch.branch_id && (!this.checkHasMemberOnlyProduct || this.member.id) && this.checkHasProduct ? 1 : 0;
        },
        billOrder: function billOrder() {
            var _this2 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                var message;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                $.blockUI({ timeout: 10000 }); //外部處理

                                if (_this2.canBill()) {
                                    _context.next = 9;
                                    break;
                                }

                                message = "";

                                if (_this2.checkHasMemberOnlyProduct && !_this2.member.id) {
                                    message = "請選擇會員";
                                }
                                if (!_this2.branch.branch_id) {
                                    message = "請選擇場館";
                                }
                                if (!_this2.checkHasProduct) {
                                    message = "結帳至少要有一品項";
                                }

                                $17.swal({
                                    title: message,
                                    text: "",
                                    type: "warning"
                                });

                                $.unblockUI();
                                return _context.abrupt("return");

                            case 9:
                                _context.next = 11;
                                return _this2.billApiOrder();

                            case 11:
                                window.Event.$emit("Pos.Bill.Order");
                                $.unblockUI();

                            case 13:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },

        //兩邊都有
        checkIssueMethodAvailableCallback: function checkIssueMethodAvailableCallback() {
            var validateInvoice = this.actionData.invoice;

            if (validateInvoice.need_input && (validateInvoice.carrier_num == null || validateInvoice.carrier_num === "")) {
                $17.swal({
                    title: "請輸入發票相關資料",
                    text: "",
                    showCancelButton: false,
                    type: "warning"
                });
                return false;
            }
            if (validateInvoice.method == "UBN" && validateInvoice.carrier_name == "") {
                $17.swal({
                    title: "請輸入抬頭",
                    text: "",
                    showCancelButton: false,
                    type: "warning"
                });
                return false;
            }
            if (validateInvoice.method == "CarrierPay2Go" && (this.member.email == null || this.member.email == "")) {
                $17.swal({
                    title: "此客戶無電子郵件，無法使用會員載具！",
                    text: "",
                    showCancelButton: false,
                    type: "warning"
                });
                return false;
            }

            return true;
        },
        invoiceCheck: function invoiceCheck() {
            var validateInvoice = this.actionData.invoice;
            if (validateInvoice.method != "" && !this.checkIssueMethodAvailableCallback()) {
                return;
            }
        },
        basePaymentCheck: function basePaymentCheck() {
            //看能不能改成 for check
            if (!this.branch.branch_id || !this.payments[0].selected_method_id || this.payments[0].selected_method_id == 0) {
                $17.swal({
                    title: "目前尚未選擇任何支付方式",
                    text: "",
                    showCancelButton: false,
                    type: "warning"
                });

                return false;
            }
            return true;
        },
        billApiOrder: function billApiOrder(payload) {
            var _this3 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                var data, skip_alert, payment, setting;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                data = {};
                                skip_alert = 0;

                                if (typeof payload != 'undefined' && typeof payload.skip_alert != 'undefined') {
                                    skip_alert = payload.skip_alert;
                                }

                                if (!_this3.invoiceCheck()) {
                                    _context2.next = 5;
                                    break;
                                }

                                return _context2.abrupt("return");

                            case 5:
                                if (_this3.basePaymentCheck()) {
                                    _context2.next = 7;
                                    break;
                                }

                                return _context2.abrupt("return");

                            case 7:

                                //暫時預設只有一個
                                payment = _this3.payments[0];
                                setting = _this3.setting;

                                if (setting.action.billCheckCallback({
                                    order: _this3.order,
                                    payment: payment,
                                    actionData: _this3.actionData.payments[payment.payment_action_record_id]
                                })) {
                                    _context2.next = 11;
                                    break;
                                }

                                return _context2.abrupt("return");

                            case 11:

                                data = setting.action.constructPaymentInput({
                                    order: _this3.order,
                                    actionData: _this3.actionData.payments[payment.payment_action_record_id]
                                });

                                data.skip_alert = skip_alert;
                                $.blockUI({ timeout: 10000 });
                                _context2.next = 16;
                                return _this3.$http.post("/adminapi/pos/bill_order/" + _this3.order.id, data).then(function (response) {
                                    var data = response.data;
                                    if (data.success) {
                                        _this3.$emit('clear-action-data');
                                        _this3.$emit('set-alert-obj', data.data);
                                        window.Event.$emit("System.Pos.Order.BillSucceed", {
                                            order_id: _this3.order.id,
                                            member_id: _this3.member.id
                                        });
                                    } else {
                                        if (data.data.show_alert) {
                                            _this3.billAlert(data);
                                            return;
                                        }
                                        _this3.$emit('set-alert-obj', data.data);
                                        window.Event.$emit("System.Pos.Order.BillFailed", {
                                            order_id: _this3.order.id
                                        });
                                    }
                                }).catch(function (response) {
                                    window.Event.$emit("System.Pos.Order.BillFailed", {
                                        order_id: _this3.order.id
                                    });
                                });

                            case 16:
                                $.unblockUI();

                            case 17:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        },

        billAlert: function billAlert(response) {
            var _this = this;
            $17.swal({
                title: "確認是否仍要購買？",
                text: response.data.message,
                type: "warning",
                showCancelButton: true,
                closeOnConfirm: false,
                showLoaderOnConfirm: true
            }, function (answer) {
                if (answer) {
                    _this.billApiOrder({
                        skip_alert: 1
                    });
                }
            });
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        WebadminOrderEdit: function WebadminOrderEdit(state) {
            return state.webadmin.configure.webFunctions.WebadminOrderEdit;
        },
        WebadminOrderDelete: function WebadminOrderDelete(state) {
            return state.webadmin.configure.webFunctions.WebadminOrderDelete;
        }
    }), {
        actionActive: function actionActive() {
            var data = {};
            return this.setting.action ? this.setting.action.enableAction(data) : false;
        },
        checkHasProduct: function checkHasProduct() {
            return this.details && this.details.length > 0 ? true : false;
        },
        checkHasMemberOnlyProduct: function checkHasMemberOnlyProduct() {
            var memberOnlyProduct = this.details.filter(function (detail) {
                if (detail.product_type !== "contracts") {
                    return false;
                }
                return true;
            }, true);

            return memberOnlyProduct.length > 0 ? true : false;
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"row st-mt-6\" v-if=\"actionActive\" _v-78094e73=\"\">\n    <div class=\"col-sm-12\" _v-78094e73=\"\">\n        <v-spinner-button :ajaxing=\"orderChanging\" fa-size=\"fa-3x\" _v-78094e73=\"\"></v-spinner-button>\n    </div>\n    <div class=\"col-sm-6\" _v-78094e73=\"\">\n        <div class=\"btn btn-danger btn-lg btn--inverse st-ml-4\" @click=\"invalidOrder()\" v-if=\"WebadminOrderDelete &amp;&amp; orderCanBeDelete() &amp;&amp; !this.orderChanging\" _v-78094e73=\"\">\n            刪除訂單\n        </div>\n    </div>\n    <div class=\"col-sm-6 st-text-right\" _v-78094e73=\"\">\n        <div class=\"btn btn-success btn-lg st-mr-4 st-mb-2.5\" v-if=\"WebadminOrderEdit &amp;&amp; this.checkHasProduct &amp;&amp; !this.orderChanging\" @click=\"billOrder()\" _v-78094e73=\"\">\n            確認結帳\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 3, stdin */\n.branchName[_v-78094e73] {\n  margin: 1em 0em;\n  font-size: 1em;\n  font-weight: bold; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-78094e73", module.exports)
  } else {
    hotAPI.update("_v-78094e73", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1260:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _edit = require('./edit.vue');

var _edit2 = _interopRequireDefault(_edit);

var _show = require('./show.vue');

var _show2 = _interopRequireDefault(_show);

var _refund = require('./refund.vue');

var _refund2 = _interopRequireDefault(_refund);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('webadmin-order-operate-action-bar-edit-utility', _edit2.default);
_vue2.default.component('webadmin-order-operate-action-bar-show-utility', _show2.default);
_vue2.default.component('webadmin-order-operate-action-bar-refund-utility', _refund2.default);

},{"./edit.vue":1259,"./refund.vue":1261,"./show.vue":1262,"vue":792}],1261:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 3, stdin */\n.branchName[_v-0049e8a1] {\n  margin: 1em 0em;\n  font-size: 1em;\n  font-weight: bold; }\n")
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _values = require("babel-runtime/core-js/object/values");

var _values2 = _interopRequireDefault(_values);

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vuex = require("vuex");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    setting: {
      type: Object,
      default: function _default(rawProps) {}
    },
    order: {
      type: Object,
      default: function _default(rawProps) {
        return {
          payment: ""
        };
      }
    },
    member: {
      type: Object,
      default: function _default(rawProps) {
        return {};
      }
    },
    details: {
      type: Array,
      default: function _default(rawProps) {
        return [];
      }
    },
    branch: {
      type: Object,
      default: function _default(rawProps) {
        return [];
      }
    },
    invoice: {
      type: Object,
      default: function _default(rawProps) {
        return [];
      }
    },
    payments: {
      type: Array,
      default: function _default(rawProps) {
        return [];
      }
    },
    actionData: {
      type: Object,
      default: function _default(rawProps) {
        return {
          refundReason: "",
          invoice: {
            order_auto_allowance_issue: false
          },
          payments: {},
          details: {}
        };
      }
    },
    eventType: {
      default: 'general'
    }
  },
  data: function data() {
    return {
      ajaxing: {
        invalid: false,
        bill: false
      },
      skipBillingAlert: 0,
      refundMod: 'refund'
    };
  },
  mounted: function mounted() {},

  watch: {
    'actionData.payments': {
      handler: function handler(newValue, oldValue) {
        var _this = this;

        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
          return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _this.setRefundMode();

                case 1:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }))();
      },

      deep: true
    },
    'paymentMethodSelect': {
      handler: function handler(newValue, oldValue) {
        var _this2 = this;

        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
          return _regenerator2.default.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _this2.setRefundMode();

                case 1:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, _this2);
        }))();
      },

      deep: true
    },
    'payments': {
      handler: function handler(newValue, oldValue) {
        var _this3 = this;

        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
          return _regenerator2.default.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _this3.setRefundMode();

                case 1:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, _this3);
        }))();
      },

      deep: true
    }
  },
  methods: {
    checkLimitation: function checkLimitation() {
      if (this.actionData.refundReason.length === 0) {
        $17.swal({
          title: '退費原因不可為空',
          text: "",
          showCancelButton: false,
          type: 'warning'
        });
        return false;
      }
      if (!this.detailIds || (0, _values2.default)(this.detailIds).indexOf(true) === -1) {
        $17.swal({
          title: '請選擇要退的訂單項目！',
          text: "",
          showCancelButton: false,
          type: 'warning'
        });
        return false;
      }

      return true;
    },

    checkAndRefund: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(this.checkLimitation() == false)) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return");

              case 2:

                $.blockUI({ timeout: 10000 });
                _context4.next = 5;
                return this.refundOrderDetails({
                  orderId: this.order.id,
                  detailIds: this.detailIds,
                  reason: this.actionData.refundReason,
                  moneys: this.detailMoneys,
                  autoAllowanceIssue: this.actionData.invoice.order_auto_allowance_issue,
                  paymentMethodSelect: this.paymentMethodSelect
                });

              case 5:
                $.unblockUI();

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function checkAndRefund() {
        return _ref.apply(this, arguments);
      }

      return checkAndRefund;
    }(),
    refundOrderDetails: function refundOrderDetails(_ref2) {
      var _this4 = this;

      var orderId = _ref2.orderId,
          detailIds = _ref2.detailIds,
          moneys = _ref2.moneys,
          reason = _ref2.reason,
          autoAllowanceIssue = _ref2.autoAllowanceIssue,
          paymentMethodSelect = _ref2.paymentMethodSelect;
      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5() {
        return _regenerator2.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:

                $.blockUI({ timeout: 10000 });
                _context5.next = 3;
                return _this4.$http.post("/adminapi/pos/order/" + orderId + "/refund", {
                  detailIds: detailIds,
                  moneys: moneys,
                  reason: reason,
                  auto_allowance_issue: autoAllowanceIssue,
                  payment_method_select: paymentMethodSelect
                }).then(function (response) {

                  var data = response.data;
                  if (data.success) {
                    _this4.$emit("clear-action-data");
                    _this4.$emit("set-alert-obj", (0, _values2.default)(data.data));

                    window.Event.$emit("System.Pos.Order.RefundSuccess", {
                      order_id: data.orderId
                    });
                  } else {
                    _this4.$emit("set-alert-obj", (0, _values2.default)(data.data));
                    window.Event.$emit("System.Pos.Order.RefundFail", {
                      order_id: _this4.order.id
                    });
                  }
                }).catch(function (response) {
                  window.Event.$emit("System.Pos.Order.RefundFail", {
                    order_id: _this4.order.id
                  });
                });

              case 3:
                $.unblockUI();

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this4);
      }))();
    },
    appendRefundRequest: function appendRefundRequest() {
      var _this5 = this;

      if (this.checkLimitation() == false) {
        return;
      }

      var data = {
        'order_id': this.order.id,
        'refund_reason': this.actionData.refundReason,
        'details': this.detailMoneys
      };

      this.$http.post('/adminapi/order-refund-request/create/' + this.order.id, data).then(function (response) {
        window.Event.$emit("System.Pos.Order.RefundCancel", {
          order_id: data.orderId
        });
        $17.swal({
          title: '已接受申請',
          text: "",
          type: 'success',
          confirmButtonText: '查看退費處理紀錄',
          cancelButtonText: '關閉'
        }, function (isConfirm) {
          if (isConfirm) {
            window.open("/webadmin/order-refund-request/list?order_id=" + _this5.order.id, "_blank");
          };
        });
      }).catch(function (response) {
        $17.swal({
          title: '申請失敗',
          text: response.data.message,
          type: 'error',
          confirmButtonColor: '#E27B78',
          confirmButtonText: '查看退費處理紀錄',
          cancelButtonText: '關閉'
        }, function (isConfirm) {
          if (isConfirm) {
            window.open("/webadmin/order-refund-request/list?order_id=" + _this5.order.id, "_blank");
          };
        });
      });
    },
    setRefundMode: function setRefundMode() {
      var _this6 = this;

      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6() {
        var refundMod;
        return _regenerator2.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!_this6.setting.action) {
                  _context6.next = 6;
                  break;
                }

                _context6.next = 3;
                return _this6.setting.action.refundMod({
                  'isSeventeen': _this6.isSeventeen,
                  'payment': (0, _values2.default)(_this6.actionData.payments)[0],
                  'http': _this6.$http,
                  'branch_id': _this6.branch.branch_id,
                  'studio_payment_method_id': _this6.payments[0].selected_method_id,
                  'paymentMethodSelect': _this6.paymentMethodSelect
                });

              case 3:
                _context6.t0 = _context6.sent;
                _context6.next = 7;
                break;

              case 6:
                _context6.t0 = 'refund';

              case 7:
                refundMod = _context6.t0;

                console.log(refundMod);
                _this6.$nextTick(function () {
                  this.refundMod = refundMod;
                });

              case 10:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    }
  },
  computed: (0, _extends3.default)({
    //改用watch
    detailIds: function detailIds() {
      return (0, _values2.default)(this.actionData.details).reduce(function (carry, item) {
        carry[item.detailId] = item.needRefund;
        return carry;
      }, {});
    },
    detailMoneys: function detailMoneys() {
      return (0, _values2.default)(this.actionData.details).reduce(function (carry, item) {
        carry[item.detailId] = item.refundMoney;
        return carry;
      }, {});
    },
    paymentMethodSelect: function paymentMethodSelect() {
      var payments = (0, _values2.default)(this.actionData.payments);

      return payments.reduce(function (carry, payment) {
        carry.push(payment.payment_method_select);
        return carry;
      }, []);
    },
    actionActive: function actionActive() {
      var data = {};
      return this.setting.action ? this.setting.action.enableAction(data) : false;
    }
  }, (0, _vuex.mapState)('webadmin/configure', ['isSeventeen']))
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"row\" v-if=\"actionActive\" _v-0049e8a1=\"\">\n  <div class=\"col-sm-offset-9 col-sm-3 st-text-right\" _v-0049e8a1=\"\">\n    <input type=\"button\" value=\"確認退費\" class=\"btn btn-danger btn-lg\" @click=\"checkAndRefund\" v-if=\"refundMod=='refund'\" _v-0049e8a1=\"\">\n    <span v-if=\"refundMod=='refund-request'\" _v-0049e8a1=\"\">\n      <a href=\"https://17fithelp.zendesk.com/hc/zh-tw/articles/360000238202-如何退費-\" target=\"_blank\" class=\"m-right-15\" _v-0049e8a1=\"\">\n        瞭解詳情\n        <i class=\"fa fa-question-circle\" aria-hidden=\"true\" _v-0049e8a1=\"\"></i>\n      </a>\n      <input type=\"button\" value=\"申請退費\" class=\"btn btn-danger btn--inverse btn-lg\" @click=\"appendRefundRequest\" _v-0049e8a1=\"\">\n    </span>\n  </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 3, stdin */\n.branchName[_v-0049e8a1] {\n  margin: 1em 0em;\n  font-size: 1em;\n  font-weight: bold; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-0049e8a1", module.exports)
  } else {
    hotAPI.update("_v-0049e8a1", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/object/values":58,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1262:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 3, stdin */\n.branchName[_v-045a09e6] {\n  margin: 1em 0em;\n  font-size: 1em;\n  font-weight: bold; }\n")
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require("vuex");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    setting: {
      type: Object,
      default: function _default(rawProps) {}
    },
    order: {
      type: Object,
      default: function _default(rawProps) {
        return {
          payment: ""
        };
      }
    },
    member: {
      type: Object,
      default: function _default(rawProps) {
        return {};
      }
    },
    details: {
      type: Array,
      default: function _default(rawProps) {
        return [];
      }
    },
    branch: {
      type: Object,
      default: function _default(rawProps) {
        return [];
      }
    },
    invoice: {
      type: Object,
      default: function _default(rawProps) {
        return [];
      }
    },
    payments: {
      type: Array,
      default: function _default(rawProps) {
        return [];
      }
    },
    orderChanging: {
      default: false
    },
    paymentCheckCallBack: {
      type: Function
    },
    invalidSuccessCallBack: {
      type: Function
    },
    actionData: {
      type: Object,
      default: function _default(rawProps) {
        return {
          invoice: {},
          paymentInput: [] //payment_action_record_id:{}
        };
      }
    },
    checkStates: {
      type: Object,
      default: function _default(rawProps) {
        return {};
      }
    },
    eventType: {
      default: 'general'
    }
  },
  data: function data() {
    return {
      ajaxing: {
        invalid: false,
        bill: false
      },
      skipBillingAlert: 0
    };
  },

  watch: {},
  methods: (0, _extends3.default)({
    refundOrder: function refundOrder() {
      var _this = this;

      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                window.Event.$emit("System.Pos.Order.StartRefund", {
                  order_id: _this.order.id
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    invalidSuccessOrder: function invalidSuccessOrder() {
      var vm = this;
      $17.swal({
        title: "確認作廢此訂單？",
        type: "warning",
        showCancelButton: true,
        closeOnConfirm: false,
        showLoaderOnConfirm: true
      }, function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(answer) {
          return _regenerator2.default.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!answer) {
                    _context2.next = 5;
                    break;
                  }

                  $.blockUI({ timeout: 10000 });

                  _context2.next = 4;
                  return vm.$http.post("/adminapi/pos/order/" + vm.order.id + "/invalid-success-order").then(function (response) {
                    if (response.status) {
                      window.Event.$emit("System.Pos.Order.InvalidSuccess", {
                        order_id: vm.order.id,
                        mode: 'show'
                      });
                    }
                  }, function (_ref2) {
                    var data = _ref2.data;

                    $17.swal({
                      title: data.message,
                      text: "",
                      type: "warning"
                    });
                  });

                case 4:

                  $.unblockUI();

                case 5:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },

    orderIssue: function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
        var _this2 = this;

        var validateInvoice;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                $.blockUI({ timeout: 10000 });
                validateInvoice = this.actionData.invoice;

                if (!(validateInvoice.method != "" && !this.checkIssueMethodAvailableCallback())) {
                  _context3.next = 4;
                  break;
                }

                return _context3.abrupt("return");

              case 4:
                _context3.next = 6;
                return this.$http.post("/adminapi/invoice/order/" + this.order.id).then(function (response) {
                  var data = response.data;
                  if (data.success) {
                    _this2.$emit("clear-action-data");
                    _this2.$emit("set-alert-obj", data.data);
                    window.Event.$emit("System.Pos.Invoice.IssueSucceed", {
                      order_id: _this2.order.id
                    });
                  } else {
                    _this2.$emit("set-alert-obj", data.data);
                    window.Event.$emit("System.Pos.Invoice.IssueFailed", {
                      order_id: _this2.order.id
                    });
                  }
                }, function (_ref4) {
                  var data = _ref4.data;

                  window.Event.$emit("System.Pos.Invoice.IssueFailed", {
                    order_id: _this2.order.id
                  });
                  $17.swal({
                    title: data.message,
                    text: "",
                    showCancelButton: false,
                    type: "warning"
                  });
                });

              case 6:

                $.unblockUI();

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function orderIssue() {
        return _ref3.apply(this, arguments);
      }

      return orderIssue;
    }()
  }, (0, _vuex.mapActions)("webadmin/print", ["outputInvoice", "previewInvoice", "previewOrder", "outputDiscountNote", "printDiscountNote", "previewDiscountNote"]), {
    checkIssueMethodAvailableCallback: function checkIssueMethodAvailableCallback() {
      var validateInvoice = this.actionData.invoice;

      if (validateInvoice.need_input && (validateInvoice.carrier_num == null || validateInvoice.carrier_num === "")) {
        $17.swal({
          title: "請輸入發票相關資料",
          text: "",
          showCancelButton: false,
          type: "warning"
        });
        return false;
      }
      if (validateInvoice.method == "UBN" && validateInvoice.carrier_name == "") {
        $17.swal({
          title: "請輸入抬頭",
          text: "",
          showCancelButton: false,
          type: "warning"
        });
        return false;
      }
      if (validateInvoice.method == "CarrierPay2Go" && (this.member.email == null || this.member.email == "")) {
        $17.swal({
          title: "此客戶無電子郵件，無法使用會員載具！",
          text: "",
          showCancelButton: false,
          type: "warning"
        });
        return false;
      }

      return true;
    },

    orderAllowance: function () {
      var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
        var _this3 = this;

        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                $.blockUI({ timeout: 10000 });
                _context4.next = 3;
                return this.$http.post("/adminapi/invoice/order/" + this.order.id + "/allowance").then(function (response) {
                  var data = response.data;
                  if (data.success) {
                    _this3.$emit("set-alert-obj", data.data);
                    window.Event.$emit("System.Pos.Invoice.AllowanceSucceed", {
                      order_id: _this3.order.id
                    });
                  }
                }, function (_ref6) {
                  var data = _ref6.data;

                  $17.swal({
                    title: data.message,
                    text: "",
                    showCancelButton: false,
                    type: "warning"
                  });
                });

              case 3:
                $.unblockUI();

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function orderAllowance() {
        return _ref5.apply(this, arguments);
      }

      return orderAllowance;
    }(),
    checkEventTypeNotAllow: function checkEventTypeNotAllow(action) {
      if (action == 'refund') {
        return ['checkStudio', 'serviceBooking'].indexOf(this.eventType) !== -1;
      }

      return false;
    }
  }),
  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
    WebadminOrderRefund: function WebadminOrderRefund(state) {
      return state.webadmin.configure.webFunctions.WebadminOrderRefund;
    },
    is17fit: function is17fit(state) {
      return state.is_17fit;
    }
  }), {
    actionActive: function actionActive() {
      var data = {};
      return this.setting.action ? this.setting.action.enableAction(data) : false;
    },
    isInvalid: function isInvalid() {
      return this.order.system_enum == 'Invalid';
    },

    canRefund: function canRefund() {
      if (this.checkEventTypeNotAllow('refund')) {
        return false;
      }
      return this.order.type !== 13 && !this.isAllRefund && (!this.isNeed17fitRefund || this.isNeed17fitRefund && this.isInRefundableDay && this.is17fit) ? true : false;
    },
    isAllRefund: function isAllRefund() {
      if (!this.details) {
        return true;
      }
      var canRefundLength = 0;
      var vm = this;
      for (var i = 0; i < vm.details.length; i++) {
        if (vm.details[i] && vm.details[i].hasOwnProperty("rest_can_refund") && vm.details[i].rest_can_refund > 0) {
          canRefundLength++;
          break;
        }
      }
      return canRefundLength === 0;
    },
    isNeed17fitRefund: function isNeed17fitRefund() {
      if (!this.payments) {
        return false;
      }
      var methodCheck = this.payments.map(function ($item) {
        return [2].indexOf($item.selected_method_id) > -1 ? true : false;
      });
      return methodCheck.indexOf(true) > -1;
    },
    isInRefundableDay: function isInRefundableDay() {
      return $17.addDays(this.refundCheckDay, 7) > new Date() ? true : false;
    },
    refundCheckDay: function refundCheckDay() {
      return this.order.created_at;
    },
    isRefundOrder: function isRefundOrder() {
      return this.order.origin_order_id != null;
    },
    showInvoiceMethod: function showInvoiceMethod() {
      return this.invoice.order_invoice_active == 1 && !this.isRefundOrder && this.invoice.invoice_number == "" && this.order.total > 0 ? true : false;
    },
    showIssueButton: function showIssueButton() {
      return this.invoice.issue_method_select != "None" && this.invoice.issue_method_select != "" ? true : false;
    },
    showAllowanceNote: function showAllowanceNote() {
      return this.invoice.order_invoice_active == 1 && this.order.is_all_allowances && this.invoice.is_issued && (this.isRefundOrder || this.isInvalid) ? true : false;
    },
    showAllowance: function showAllowance() {
      return this.invoice.order_invoice_active == 1 && !this.order.is_all_allowances && this.invoice.is_issued && (this.isRefundOrder || this.isInvalid) ? true : false;
    },
    checkValidPrintType: function checkValidPrintType() {
      return ["PrintCode", "UBN"].indexOf(this.invoice.issue_method_select) != -1;
    }
  })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div v-if=\"actionActive\" class=\"st-ml-3\" _v-045a09e6=\"\">\n  <div class=\"row\" _v-045a09e6=\"\">\n    <div class=\"col-sm-12\" _v-045a09e6=\"\">\n      <v-spinner-button :ajaxing=\"orderChanging\" fa-size=\"fa-3x\" _v-045a09e6=\"\"></v-spinner-button>\n    </div>\n  </div>\n  <template v-if=\"!orderChanging\">\n  <div class=\"row\" v-if=\"!isInvalid\" _v-045a09e6=\"\">\n    <div class=\"col-sm-6\" v-if=\"canRefund &amp;&amp; WebadminOrderRefund\" _v-045a09e6=\"\">\n      <input type=\"button\" value=\"退費\" class=\"btn btn-danger btn--inverse\" @click=\"refundOrder\" _v-045a09e6=\"\">\n      <input type=\"button\" value=\"作廢訂單\" class=\"btn btn-default\" v-if=\"checkStates.is_allow_to_invalid_order\" @click=\"invalidSuccessOrder\" _v-045a09e6=\"\">\n    </div>\n    <div class=\"col-sm-6\" v-if=\"!(canRefund &amp;&amp; WebadminOrderRefund)\" _v-045a09e6=\"\"></div>\n    <div class=\"col-sm-6 st-text-right\" _v-045a09e6=\"\">\n      <input v-if=\"!isRefundOrder\" type=\"button\" value=\"列印全部\" class=\"btn btn-success\" @click=\"\n          previewOrder({ orderId: order.id, branchId: branch.branch_id })\n        \" _v-045a09e6=\"\">\n      <span v-if=\"invoice.invoice_number != '' &amp;&amp; checkValidPrintType\" _v-045a09e6=\"\">\n        <input type=\"button\" value=\"列印發票\" class=\"btn btn-success\" @click=\"\n            previewInvoice({ orderId: order.id, branchId: branch.branch_id })\n          \" _v-045a09e6=\"\">\n        <input type=\"button\" value=\"輸出發票\" class=\"btn btn-success\" @click=\"outputInvoice(order.id)\" _v-045a09e6=\"\">\n      </span>\n    </div>\n  </div>\n  <div class=\"row m-top-5\" v-if=\"showInvoiceMethod &amp;&amp; !isInvalid\" _v-045a09e6=\"\">\n    <div class=\"col-sm-6 col-sm-offset-6 st-text-right\" _v-045a09e6=\"\">\n      <input type=\"button\" value=\"開立發票\" class=\"btn btn-success btn-lg st-mr-4 st-mb-2.5\" v-show=\"showIssueButton\" @click=\"orderIssue\" _v-045a09e6=\"\">\n    </div>\n  </div>\n\n  <div class=\"row\" v-if=\"showAllowanceNote\" _v-045a09e6=\"\">\n    <div class=\"col-sm-6 col-sm-offset-6 st-text-right\" _v-045a09e6=\"\">\n      <input type=\"button\" value=\"列印折讓單\" class=\"btn btn-success\" @click=\"previewDiscountNote({ orderId: order.id })\" _v-045a09e6=\"\">\n      <input type=\"button\" value=\"輸出折讓單\" class=\"btn btn-success\" @click=\"outputDiscountNote(order.id)\" _v-045a09e6=\"\">\n    </div>\n  </div>\n  <div class=\"row\" v-if=\"showAllowance\" _v-045a09e6=\"\">\n    <div class=\"col-sm-6 col-sm-offset-6 st-text-right\" _v-045a09e6=\"\">\n      <input type=\"button\" value=\"折讓發票\" class=\"btn btn-danger btn-lg st-mr-4 st-mb-2.5\" @click=\"orderAllowance\" _v-045a09e6=\"\">\n    </div>\n  </div>\n</template>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 3, stdin */\n.branchName[_v-045a09e6] {\n  margin: 1em 0em;\n  font-size: 1em;\n  font-weight: bold; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-045a09e6", module.exports)
  } else {
    hotAPI.update("_v-045a09e6", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1263:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 3, stdin */\n.branchName[_v-61eee893] {\n  margin: 1em 0em;\n  font-size: 1em;\n  font-weight: bold; }\n")
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vuex = require("vuex");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        disableStudio: {
            default: false,
            type: Boolean
        },
        disableBranch: {
            default: false,
            type: Boolean
        },
        orderId: {
            default: ""
        },
        settingData: {
            type: Object,
            default: function _default(rawProps) {
                return {};
            }
        },
        studioId: {
            default: 0
        },
        branchId: {
            default: 0
        },
        setting: {
            type: Object,
            default: function _default(rawProps) {
                return {
                    enableEdit: function enableEdit(data) {
                        return true;
                    }
                }; //false
            }
        }
    },
    data: function data() {
        return {};
    },

    watch: {},
    methods: {
        studioChangeCallBack: function () {
            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(id) {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!(id && this.isSeventeen)) {
                                    _context.next = 4;
                                    break;
                                }

                                _context.next = 3;
                                return this.$http.post("/adminapi/pos/change_order_value/" + this.orderId, {
                                    studio_id: id
                                }).then(function (_ref2) {
                                    // resolve({ order: data })

                                    var data = _ref2.data;
                                }, function (data) {
                                    $17.swal({
                                        title: "修改訂單資訊發生錯誤",
                                        text: "",
                                        showCancelButton: false,
                                        type: "warning"
                                    });
                                });

                            case 3:
                                this.$emit("studio-change", studioId);

                            case 4:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function studioChangeCallBack(_x) {
                return _ref.apply(this, arguments);
            }

            return studioChangeCallBack;
        }(),
        branchChangeCallBack: function () {
            var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(id) {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!(id && !this.isBranch)) {
                                    _context2.next = 4;
                                    break;
                                }

                                _context2.next = 3;
                                return this.$http.post("/adminapi/pos/change_order_value/" + this.orderId, {
                                    branch_id: id
                                }).then(function (_ref4) {
                                    // resolve({ order: data })

                                    var data = _ref4.data;
                                }, function (data) {
                                    $17.swal({
                                        title: "修改訂單資訊發生錯誤",
                                        text: "",
                                        showCancelButton: false,
                                        type: "warning"
                                    });
                                });

                            case 3:
                                this.$emit("branch-change", id);

                            case 4:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function branchChangeCallBack(_x2) {
                return _ref3.apply(this, arguments);
            }

            return branchChangeCallBack;
        }()
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)("webadmin/configure", ["isSeventeen", "isStudio", "isBranch"]), (0, _vuex.mapState)({
        studioOptions: function studioOptions(state) {
            return state.filters.studioOptions;
        },
        branchOptions: function branchOptions(state) {
            return state.filters.branchOptions;
        }
    }), {
        studioName: function studioName() {
            var _this = this;

            var selected = this.studioOptions.find(function (item) {
                return item.id == _this.studioId;
            });

            return typeof selected != "undefined" ? selected.brand_name : "";
        },
        branchName: function branchName() {
            var _this2 = this;

            var selected = this.branchOptions.find(function (item) {
                return item.id == _this2.branchId;
            });
            if (!selected) {
                return;
            }
            return selected != "undefined" ? selected.branch_name : "";
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-61eee893=\"\">\n    <div class=\"row\" v-if=\"setting.enableEdit(settingData) &amp;&amp; (isStudio||isSeventeen)\" _v-61eee893=\"\">\n        <div class=\"col-sm-6 st-m-y-0\" _v-61eee893=\"\">\n            <v-multiselect-studio-and-branch-form :show-studio-label=\"false\" :show-branch-label=\"false\" :studio_id=\"studioId\" :branch_id=\"branchId\" :branch-without-filtered-option=\"false\" :branch-change-call-back=\"branchChangeCallBack\" :studio-change-call-back=\"studioChangeCallBack\" :disable-studio-option=\"disableStudio\" :disable-branch-option=\"disableBranch\" _v-61eee893=\"\">\n            </v-multiselect-studio-and-branch-form>\n        </div>\n    </div>\n    <div class=\"row\" v-if=\"setting.enableEdit(settingData) == false\" _v-61eee893=\"\">\n        <div class=\"col-sm-6\" v-if=\"isSeventeen\" _v-61eee893=\"\">\n            <div class=\"branchName\" _v-61eee893=\"\">\n                {{ studioName }}\n            </div>\n        </div>\n    </div>\n    <div class=\"row\" v-if=\"setting.enableEdit(settingData) == false\" _v-61eee893=\"\">\n        <div class=\"col-sm-6\" _v-61eee893=\"\">\n            <div class=\"branchName\" _v-61eee893=\"\">\n                {{ branchName }}\n            </div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 3, stdin */\n.branchName[_v-61eee893] {\n  margin: 1em 0em;\n  font-size: 1em;\n  font-weight: bold; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-61eee893", module.exports)
  } else {
    hotAPI.update("_v-61eee893", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1264:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        'branchId': {
            default: 0
        },
        addItemCallback: {
            type: Function
        },
        setting: {
            type: Object,
            default: function _default(rawProps) {
                return {
                    enableEdit: function enableEdit(data) {
                        return true;
                    }
                };
            }
        },
        settingData: {
            type: Object,
            default: function _default(rawProps) {
                return {};
            }
        }
    },
    data: function data() {
        return {
            ajaxing: {
                getData: false,
                button: false
            },
            commonlyUsedItems: []
        };
    },
    mounted: function mounted() {
        this.getCommonlyUsedItem();
    },

    watch: {
        branchId: function () {
            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(val, oldVal) {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                this.commonlyUsedItems = [];
                                this.getCommonlyUsedItem();

                            case 2:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function branchId(_x, _x2) {
                return _ref.apply(this, arguments);
            }

            return branchId;
        }()
    },
    methods: {
        getCommonlyUsedItem: function getCommonlyUsedItem() {
            var _this = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                var api;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                api = '/adminapi/commonly_used_items?branch_id=' + _this.branchId;

                                if (!(_this.branchId == 0 || _this.branchId == null || _this.branchId == undefined)) {
                                    _context2.next = 3;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 3:
                                _this.ajaxing.getData = true;
                                _context2.next = 6;
                                return _this.$http.get(api).then(function (data) {
                                    _this.commonlyUsedItems = data.body;
                                    _this.ajaxing.getData = false;
                                }, function (error) {
                                    _this.ajaxing.getData = false;
                                    $17.swal({
                                        title: "取得常用項目發生錯誤",
                                        text: "",
                                        showCancelButton: false,
                                        type: "warning"
                                    });
                                });

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this);
            }))();
        },

        addItem: function () {
            var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(id, type) {
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                this.ajaxing.button = true;
                                _context3.next = 3;
                                return this.addItemCallback({
                                    'branch_id': this.branchId,
                                    'product_type': type,
                                    'product_id': id,
                                    'amount': 1,
                                    'discount_type': 0,
                                    'discount_value': 0,
                                    'discount_reason': ''
                                });

                            case 3:
                                this.ajaxing.button = false;

                            case 4:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function addItem(_x3, _x4) {
                return _ref2.apply(this, arguments);
            }

            return addItem;
        }()
    },
    computed: {}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div v-if=\"setting.enableEdit(settingData)\" _v-49c86dca=\"\">\n    <label class=\"m-top-15 m-bottom-5 col-md-12 text-center\" _v-49c86dca=\"\">常用結帳項目</label>\n    <div class=\"col-md-12 m-top-5 m-bottom-5\" v-if=\"ajaxing.getData\" _v-49c86dca=\"\">\n        <v-spinner :ajaxing=\"ajaxing.getData\" fa-size=\"fa-3x\" _v-49c86dca=\"\"></v-spinner>\n    </div>\n    <div class=\"col-md-12 m-top-5 m-bottom-5\" v-if=\"!ajaxing.getData\" _v-49c86dca=\"\">\n        <div v-for=\"item in commonlyUsedItems\" :key=\"item.id\" class=\"col-md-12 m-bottom-10\" _v-49c86dca=\"\">\n            <div v-if=\"ajaxing.button\" class=\"btn btn-default disabled text-center col-md-12\" _v-49c86dca=\"\">\n                <v-spinner-button :ajaxing=\"ajaxing.button\" _v-49c86dca=\"\"></v-spinner-button>\n            </div>\n            <input v-if=\"!ajaxing.button\" @click=\"addItem(item.commonly_usable_id, item.type)\" class=\"commonly-item center-block btn btn-default col-md-12\" type=\"button\" :value=\"item.name\" _v-49c86dca=\"\">\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-49c86dca", module.exports)
  } else {
    hotAPI.update("_v-49c86dca", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785}],1265:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _orderDetailListRefund = require('./order-detail-list-refund.vue');

var _orderDetailListRefund2 = _interopRequireDefault(_orderDetailListRefund);

var _orderDetailListShow = require('./order-detail-list-show.vue');

var _orderDetailListShow2 = _interopRequireDefault(_orderDetailListShow);

var _orderDetailListEdit = require('./order-detail-list-edit.vue');

var _orderDetailListEdit2 = _interopRequireDefault(_orderDetailListEdit);

var _orderBoughtItemTicket = require('./order-bought-item-ticket.vue');

var _orderBoughtItemTicket2 = _interopRequireDefault(_orderBoughtItemTicket);

var _productItemShow = require('./product-item-show.vue');

var _productItemShow2 = _interopRequireDefault(_productItemShow);

var _orderDetailItemRefund = require('./order-detail-item-refund.vue');

var _orderDetailItemRefund2 = _interopRequireDefault(_orderDetailItemRefund);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//utility
_vue2.default.component('webadmin-order-operate-order-detail-list-refund-utility', _orderDetailListRefund2.default);
_vue2.default.component('webadmin-order-operate-order-detail-list-show-utility', _orderDetailListShow2.default);
_vue2.default.component('webadmin-order-operate-order-detail-list-edit-utility', _orderDetailListEdit2.default);
_vue2.default.component('webadmin-order-bought-item-ticket-utility', _orderBoughtItemTicket2.default);
_vue2.default.component('webadmin-order-product-item-show-utility', _productItemShow2.default);
_vue2.default.component('webadmin-order-operate-order-detail-list-refund-item-utility', _orderDetailItemRefund2.default);

},{"./order-bought-item-ticket.vue":1266,"./order-detail-item-refund.vue":1267,"./order-detail-list-edit.vue":1268,"./order-detail-list-refund.vue":1269,"./order-detail-list-show.vue":1270,"./product-item-show.vue":1271,"vue":792}],1266:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.row[_v-17c17e37] {\n  font-size: 16px;\n  margin-top: 15px; }\n  /* line 5, stdin */\n  .row[_v-17c17e37]:after {\n    content: \"\";\n    width: 100%;\n    border: 1.5px dotted #c7c4c3;\n    margin-top: 40px; }\n    /* line 10, stdin */\n    .row[_v-17c17e37]:after:last-child {\n      height: 0px; }\n\n/* line 15, stdin */\n.invalidAll[_v-17c17e37] {\n  color: red; }\n")
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require("vuex");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {},
  data: function data() {
    return {
      boughtDetails: {
        title: "",
        items: [],
        detail_id: null
      }
    };
  },

  methods: (0, _extends3.default)({
    reset: function reset() {
      this.boughtDetails = {
        title: "",
        items: [],
        detail_id: null
      };
    },
    print: function print(ticketNumber, event) {
      var _this = this;

      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                $(event.target).prop("disabled", true);
                $(event.target).notify("列印中請稍候.....", {
                  position: "left",
                  className: "success"
                });
                setTimeout(function () {
                  $(event.target).prop("disabled", false);
                }, 2000);
                _context.next = 5;
                return _this.printTicket(ticketNumber);

              case 5:
                $(event.target).prop("disabled", false);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    printAll: function printAll(detail_id, event) {
      var _this2 = this;

      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this2.printing) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                $(event.target).notify("列印中請稍候.....", {
                  position: "bottom",
                  className: "success"
                });
                _this2.CHANGE_PRINT_STATUS(true);
                setTimeout(function () {
                  _this2.CHANGE_PRINT_STATUS(false);
                }, 2000);
                _context2.next = 7;
                return _this2.printAllTicket(detail_id);

              case 7:
                _this2.CHANGE_PRINT_STATUS(false);

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    invalidTicket: function invalidTicket(ticket_id) {
      var _this3 = this;

      this.$http.post("/adminapi/ticket/" + ticket_id + "/invalid").then(function (_ref) {
        var data = _ref.data;

        _this3.$emit("fetch-bought-item", _this3.boughtDetails.detail_id);
        $17.swal({
          title: "此張票券作廢成功",
          text: "",
          showCancelButton: false,
          type: "success"
        });
      }, function (_ref2) {
        var data = _ref2.data;

        $17.swal({
          title: "作廢票券發生錯誤",
          text: "",
          showCancelButton: false,
          type: "success"
        });
      });
    },
    invalidAllTicket: function invalidAllTicket(order_detail_id) {
      var _this4 = this;

      this.$http.post("/adminapi/ticket/invalidAll/order_detail/" + order_detail_id).then(function (_ref3) {
        var data = _ref3.data;

        _this4.$emit("fetch-bought-item", _this4.boughtDetails.detail_id);
        $17.swal({
          title: "此筆項目作廢成功",
          text: "",
          showCancelButton: false,
          type: "success"
        });
      }, function (_ref4) {
        var data = _ref4.data;

        $17.swal({
          title: "作廢全部票券發生錯誤",
          text: "",
          showCancelButton: false,
          type: "success"
        });
      });
    }
  }, (0, _vuex.mapMutations)("webadmin/print", ["CHANGE_PRINT_STATUS"]), (0, _vuex.mapActions)("webadmin/print", ["checkDefaultPrinter", "outputTicket", "outputAllTicket", "previewTicket", "previewAllTicket"])),
  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
    printing: function printing(state) {
      return state.webadmin.print.printing;
    }
  }), {
    countShowNumber: function countShowNumber() {
      if (this.boughtDetails.items && this.boughtDetails.items.length > 0) {
        return this.boughtDetails.items.reduce(function (current, it) {
          return it.status == 0 && !it.isExpired ? parseInt(current) + 1 : current;
        }, 0);
      }

      return 0;
    }
  })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal id=\"order-operate-bought-ticket\" no-footer=\"\" parallel-modal=\"\" open-size=\"modal-lg\" :close-modal-event=\"reset\" _v-17c17e37=\"\">\n  <span slot=\"title\" _v-17c17e37=\"\">\n    {{ boughtDetails.title }}\n  </span>\n  <div slot=\"body\" _v-17c17e37=\"\">\n    <div class=\"row\" v-if=\"countShowNumber > 0\" _v-17c17e37=\"\">\n      <div class=\"col-xs-12\" _v-17c17e37=\"\">\n        <a href=\"#\" @click=\"outputAllTicket(boughtDetails.detail_id)\" _v-17c17e37=\"\">輸出全部 ({{ countShowNumber }})</a>\n        <a href=\"#\" class=\"printAll\" @click.prevent.stop=\"\n            previewAllTicket({ orderDetailId: boughtDetails.detail_id })\n          \" _v-17c17e37=\"\">列印全部 ({{ countShowNumber }})</a>\n        <a href=\"#\" class=\"invalidAll\" @click=\"invalidAllTicket(boughtDetails.detail_id)\" _v-17c17e37=\"\">作廢全部 ({{ countShowNumber }})</a>\n      </div>\n    </div>\n    <div class=\"row\" v-for=\"item in boughtDetails.items\" _v-17c17e37=\"\">\n      <div class=\"col-sm-7 col-xs-6\" _v-17c17e37=\"\">票券碼：{{ item.ticketNumber }}</div>\n      <div class=\"col-sm-2 col-xs-3 text-right\" _v-17c17e37=\"\">{{ item.statusWord }}</div>\n      <div class=\"col-sm-3 col-xs-3\" _v-17c17e37=\"\">\n        <div v-if=\"item.status == 0 &amp;&amp; !item.isExpired\" _v-17c17e37=\"\">\n          <button class=\"btn btn-primary\" @click=\"outputTicket(item.ticketNumber)\" _v-17c17e37=\"\">\n            輸出\n          </button>\n          <button class=\"btn btn-primary\" @click=\"previewTicket({ ticketId: item.ticketNumber })\" _v-17c17e37=\"\">\n            列印\n          </button>\n          <button class=\"btn btn-danger btn-inverse\" @click=\"invalidTicket(item.ticketNumber)\" _v-17c17e37=\"\">\n            作廢\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.row[_v-17c17e37] {\n  font-size: 16px;\n  margin-top: 15px; }\n  /* line 5, stdin */\n  .row[_v-17c17e37]:after {\n    content: \"\";\n    width: 100%;\n    border: 1.5px dotted #c7c4c3;\n    margin-top: 40px; }\n    /* line 10, stdin */\n    .row[_v-17c17e37]:after:last-child {\n      height: 0px; }\n\n/* line 15, stdin */\n.invalidAll[_v-17c17e37] {\n  color: red; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-17c17e37", module.exports)
  } else {
    hotAPI.update("_v-17c17e37", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1267:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.discount[_v-49ed8c09], .delete-icon[_v-49ed8c09] {\n  color: #d1352e; }\n\n/* line 5, stdin */\n.delete-icon[_v-49ed8c09] {\n  cursor: pointer;\n  max-width: 15px; }\n\n/* line 9, stdin */\ntr > td[_v-49ed8c09]:last-child {\n  padding-right: 15px; }\n\n/* line 12, stdin */\n.close-icon[_v-49ed8c09] {\n  font-size: 1.5em;\n  font-weight: bolder; }\n\n/* line 16, stdin */\n.item-refund[_v-49ed8c09] {\n  cursor: pointer; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['detail', 'needFullReturn', 'discountValueShow', 'isRefund', 'defaultDetail'],
    data: function data() {
        return {
            refund: false,
            money: null,
            detailId: null
        };
    },

    watch: {
        refund: function refund(newVal) {
            this.$emit('update-refund-data', {
                'detailId': this.detail.id,
                'refundMoney': this.money,
                'needRefund': newVal
            });
        },
        defaultDetail: function defaultDetail(newVal) {
            if (newVal != null) {
                this.refund = newVal.order_detail_id == this.detail.id;
                this.money = newVal.refund_amount;
            }
        }
    },
    methods: {
        changeCheckStatus: function changeCheckStatus() {
            if (this.isRefund) {
                return;
            }
            this.refund = !this.refund;
        },
        withMoneyFormat: function withMoneyFormat(money) {
            return $17.moneyFormat(money);
        },
        showModal: function showModal(buy_id) {
            this.$store.dispatch("webadmin/crm/fetchOneMemberContract", buy_id);
            $("#modal-contract").modal("show");
        },
        showOrderDetailWithProduct: function showOrderDetailWithProduct(detail) {
            window.Event.$emit("System.Pos.Order.ShowOrderDetailWithProduct", detail);
        }
    },
    computed: {
        refund_money: {
            get: function get() {
                if (!this.money) {
                    this.refund_money = this.detail.rest_can_refund;
                    this.money = this.detail.rest_can_refund;
                }
                return this.money;
            },
            set: function set(newValue) {
                if (newValue > this.detail.rest_can_refund) {
                    newValue = this.detail.rest_can_refund;
                }
                newValue = parseInt(newValue);
                this.money = newValue;
                this.$emit('update-refund-data', {
                    'detailId': this.detail.id,
                    'refundMoney': this.money,
                    'needRefund': this.refund
                });
            }
        },
        product_table_type: function product_table_type() {
            if (this.detail.product_type != "contracts") {
                return false;
            }
            return true;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<tr class=\"item-refund\" @click=\"changeCheckStatus\" _v-49ed8c09=\"\">\n    <td class=\"text-center delete-icon\" _v-49ed8c09=\"\">\n        <div class=\"already-refund\" v-if=\"isRefund\" _v-49ed8c09=\"\">\n            <span _v-49ed8c09=\"\">已退</span>\n        </div>\n        <div class=\"can-refund\" v-if=\"!isRefund\" _v-49ed8c09=\"\">\n            <input type=\"checkbox\" v-model=\"refund\" v-on:click.stop=\"\" _v-49ed8c09=\"\">\n        </div>\n    </td>\n    <td class=\"text-left\" _v-49ed8c09=\"\">\n        {{detail.product_name}}\n        <span _v-49ed8c09=\"\">&nbsp;</span>\n        <span class=\"text-danger item-refund\" v-if=\"product_table_type\" @click=\"showModal(detail.buy_id)\" _v-49ed8c09=\"\"><u _v-49ed8c09=\"\">查看</u></span>\n    </td>\n    <td class=\"text-right\" _v-49ed8c09=\"\">{{detail.qty}}</td>\n    <td class=\"text-right\" _v-49ed8c09=\"\">{{detail.price}}</td>\n    <td class=\"text-right\" _v-49ed8c09=\"\">{{withMoneyFormat(detail.detail_total_money)}}</td>\n    <td class=\"discount text-right\" _v-49ed8c09=\"\">\n        <span class=\"item-refund\" v-if=\"detail.order_detail_discount_value != 0\" @click.stop=\"showOrderDetailWithProduct(detail)\" _v-49ed8c09=\"\">\n            {{discountValueShow}}\n        </span>\n    </td>\n    <td class=\"text-right rest_can_refund\" v-if=\"detail.rest_can_refund>0\" _v-49ed8c09=\"\">\n        {{withMoneyFormat(detail.rest_can_refund)}}\n    </td>\n    <td v-else=\"\" _v-49ed8c09=\"\"></td>\n    <td class=\"text-right\" _v-49ed8c09=\"\">\n        <span v-if=\"refund\" class=\"text-left\" _v-49ed8c09=\"\">\n            <input type=\"number\" :placeholder=\"detail.rest_can_refund\" :max=\"detail.rest_can_refund\" min=\"0\" v-model.lazy.number=\"refund_money\" v-on:click.stop.prevent=\"\" _v-49ed8c09=\"\">\n        </span>\n        <span v-else=\"\" _v-49ed8c09=\"\"></span>\n    </td>\n</tr>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.discount[_v-49ed8c09], .delete-icon[_v-49ed8c09] {\n  color: #d1352e; }\n\n/* line 5, stdin */\n.delete-icon[_v-49ed8c09] {\n  cursor: pointer;\n  max-width: 15px; }\n\n/* line 9, stdin */\ntr > td[_v-49ed8c09]:last-child {\n  padding-right: 15px; }\n\n/* line 12, stdin */\n.close-icon[_v-49ed8c09] {\n  font-size: 1.5em;\n  font-weight: bolder; }\n\n/* line 16, stdin */\n.item-refund[_v-49ed8c09] {\n  cursor: pointer; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-49ed8c09", module.exports)
  } else {
    hotAPI.update("_v-49ed8c09", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1268:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 4, stdin */\n.item-edit[_v-56f982b0] {\n  cursor: default; }\n  /* line 7, stdin */\n  .item-edit[_v-56f982b0]:hover {\n    background: #edeff0; }\n\n/* line 12, stdin */\n.cursor-pointer[_v-56f982b0] {\n  cursor: pointer; }\n\n/* line 16, stdin */\n.discount[_v-56f982b0], .delete-icon[_v-56f982b0] {\n  color: #d1352e; }\n\n/* line 19, stdin */\n.delete-icon[_v-56f982b0] {\n  cursor: pointer;\n  max-width: 15px; }\n\n/* line 24, stdin */\n.close-icon[_v-56f982b0] {\n  font-size: 1.5em;\n  font-weight: bolder; }\n\n/* line 28, stdin */\n.footer[_v-56f982b0] {\n  background-color: #c7c4c3;\n  font-weight: bolder;\n  font-size: 1.2em; }\n\n/* line 34, stdin */\ntable[_v-56f982b0] {\n  margin: 10px 0;\n  width: 100%;\n  border: 2px solid #c7c4c3; }\n  /* line 41, stdin */\n  table thead tr[_v-56f982b0],\n  table tfoot tr[_v-56f982b0] {\n    border: 2px solid #c7c4c3; }\n  /* line 46, stdin */\n  table tbody tr[_v-56f982b0] {\n    border: 1px solid #c7c4c3; }\n    /* line 49, stdin */\n    table tbody tr td[_v-56f982b0],\n    table tbody tr th[_v-56f982b0] {\n      margin: 10px 0; }\n  /* line 55, stdin */\n  table tr[_v-56f982b0] {\n    line-height: 30px; }\n  /* line 59, stdin */\n  table tr > td[_v-56f982b0]:last-child {\n    padding-right: 15px; }\n  /* line 64, stdin */\n  table tfoot .color-red[_v-56f982b0] {\n    color: red; }\n")
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vuex = require("vuex");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        ajaxing: {
            type: Boolean,
            default: false
        },
        operateSelectedOrderDetail: Function,
        setting: {
            type: Object,
            default: function _default(rawProps) {
                return {
                    enableEdit: function enableEdit(data) {
                        return true;
                    },
                    canBeDelete: true, //false
                    enableChangeMember: true //false
                };
            }
        },
        total: {
            type: Number,
            default: function _default(rawProps) {
                return 90;
            }
        },
        details: {
            type: Array,
            default: function _default(rawProps) {
                return [{
                    qty: 1,
                    price: 100,
                    product_name: "test",
                    order_detail_discount_type: 1,
                    order_detail_discount_value: 10,
                    detail_total_money: 90
                }];
            }
        },
        settingData: {
            type: Object,
            default: function _default(rawProps) {
                return {};
            }
        }
    },
    data: function data() {
        return {};
    },

    methods: {
        withMoneyFormat: function withMoneyFormat(money) {
            return $17.moneyFormat(money);
        },
        canBeDelete: function canBeDelete(detail) {
            return this.setting.enableEdit(this.settingData) && detail.can_be_delete && this.WebadminOrderEdit;
        },
        discountValueShow: function discountValueShow(detail) {
            var discount_type = parseInt(detail.order_detail_discount_type);

            return typeof detail.order_detail_discount_value != "undefined" && detail.order_detail_discount_value > 0 ? this.calculateDiscountTotal(detail.qty * detail.price, discount_type, detail.order_detail_discount_value) : "";
        },

        //重複
        calculateDiscountTotal: function calculateDiscountTotal(total, discountType, discountValue) {
            discountType = parseInt(discountType);
            switch (discountType) {
                case 1:
                    return discountValue;
                    break;
                case 2:
                    return Math.round(total * (discountValue / 100));
                    break;
                default:
                    return discountValue;
            }
        },
        removeOneItem: function removeOneItem(detail) {
            if (!this.setting.enableEdit(this.settingData)) {
                return;
            }
            var vm = this;
            $17.swal({
                title: "刪除確認？",
                text: "確認刪除此項目",
                type: "warning"
            }, function () {
                vm.$http.post("/adminapi/pos/remove_order_detail/" + detail.id).then(function (_ref) {
                    var data = _ref.data;

                    vm.$emit("order-changed");
                }, function (_ref2) {
                    var data = _ref2.data;

                    $17.swal({
                        title: data.message,
                        text: "",
                        type: "warning"
                    });
                });
            });
        },
        showOrderDetailWithProduct: function showOrderDetailWithProduct(detail) {
            var _this = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (_this.setting.enableEdit(_this.settingData)) {
                                    _context.next = 2;
                                    break;
                                }

                                return _context.abrupt("return");

                            case 2:
                                _context.next = 4;
                                return _this.operateSelectedOrderDetail(detail);

                            case 4:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        WebadminOrderEdit: function WebadminOrderEdit(state) {
            return state.webadmin.configure.webFunctions.WebadminOrderEdit;
        }
    }))
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"st-mb-4\" _v-56f982b0=\"\">\n    <table _v-56f982b0=\"\">\n        <thead _v-56f982b0=\"\">\n            <tr _v-56f982b0=\"\">\n                <td _v-56f982b0=\"\">&nbsp;</td>\n                <td _v-56f982b0=\"\">項目名稱</td>\n                <td class=\"text-right\" _v-56f982b0=\"\">數量</td>\n                <td class=\"text-right\" _v-56f982b0=\"\">單價</td>\n                <td class=\"text-right\" _v-56f982b0=\"\">小計</td>\n                <td class=\"text-right\" _v-56f982b0=\"\">折扣</td>\n                <td class=\"text-right\" _v-56f982b0=\"\"></td>\n            </tr>\n        </thead>\n        <tbody _v-56f982b0=\"\">\n            <template v-for=\"(detail, index) in details\">\n                <tr class=\"item-edit\" :class=\"{'cursor-pointer':!ajaxing}\" @click=\"showOrderDetailWithProduct(detail)\" _v-56f982b0=\"\">\n                    <td class=\"text-center delete-icon\" @click.stop.prevent=\"removeOneItem(detail)\" v-if=\"canBeDelete(detail)\" _v-56f982b0=\"\">\n                        <span class=\"close-icon\" _v-56f982b0=\"\">×</span>\n                    </td>\n                    <td v-else=\"\" _v-56f982b0=\"\">&nbsp;</td>\n                    <td class=\"text-left\" _v-56f982b0=\"\">{{ detail.product_name }}</td>\n                    <td class=\"text-right\" _v-56f982b0=\"\">{{ detail.qty }}</td>\n                    <td class=\"text-right\" _v-56f982b0=\"\">{{ detail.price }}</td>\n                    <td class=\"text-right\" _v-56f982b0=\"\">{{ detail.qty * detail.price }}</td>\n                    <td class=\"discount text-right\" _v-56f982b0=\"\">{{ discountValueShow(detail) }}</td>\n                    <td class=\"text-right\" _v-56f982b0=\"\">${{ detail.detail_total_money }}</td>\n                </tr>\n            </template>\n        </tbody>\n        <tfoot class=\"footer\" _v-56f982b0=\"\">\n            <tr _v-56f982b0=\"\">\n                <td _v-56f982b0=\"\"></td>\n                <td _v-56f982b0=\"\">總計</td>\n                <td _v-56f982b0=\"\"></td>\n                <td _v-56f982b0=\"\"></td>\n                <td _v-56f982b0=\"\"></td>\n                <td _v-56f982b0=\"\"></td>\n                <td class=\"text-right\" _v-56f982b0=\"\">\n                    <span v-if=\"total >= 0\" _v-56f982b0=\"\"> {{ withMoneyFormat(total) }}</span>\n                    <span v-else=\"\" class=\"color-red\" _v-56f982b0=\"\">\n                        ({{ withMoneyFormat(Math.abs(total)) }})</span>\n                </td>\n            </tr>\n        </tfoot>\n    </table>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 4, stdin */\n.item-edit[_v-56f982b0] {\n  cursor: default; }\n  /* line 7, stdin */\n  .item-edit[_v-56f982b0]:hover {\n    background: #edeff0; }\n\n/* line 12, stdin */\n.cursor-pointer[_v-56f982b0] {\n  cursor: pointer; }\n\n/* line 16, stdin */\n.discount[_v-56f982b0], .delete-icon[_v-56f982b0] {\n  color: #d1352e; }\n\n/* line 19, stdin */\n.delete-icon[_v-56f982b0] {\n  cursor: pointer;\n  max-width: 15px; }\n\n/* line 24, stdin */\n.close-icon[_v-56f982b0] {\n  font-size: 1.5em;\n  font-weight: bolder; }\n\n/* line 28, stdin */\n.footer[_v-56f982b0] {\n  background-color: #c7c4c3;\n  font-weight: bolder;\n  font-size: 1.2em; }\n\n/* line 34, stdin */\ntable[_v-56f982b0] {\n  margin: 10px 0;\n  width: 100%;\n  border: 2px solid #c7c4c3; }\n  /* line 41, stdin */\n  table thead tr[_v-56f982b0],\n  table tfoot tr[_v-56f982b0] {\n    border: 2px solid #c7c4c3; }\n  /* line 46, stdin */\n  table tbody tr[_v-56f982b0] {\n    border: 1px solid #c7c4c3; }\n    /* line 49, stdin */\n    table tbody tr td[_v-56f982b0],\n    table tbody tr th[_v-56f982b0] {\n      margin: 10px 0; }\n  /* line 55, stdin */\n  table tr[_v-56f982b0] {\n    line-height: 30px; }\n  /* line 59, stdin */\n  table tr > td[_v-56f982b0]:last-child {\n    padding-right: 15px; }\n  /* line 64, stdin */\n  table tfoot .color-red[_v-56f982b0] {\n    color: red; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-56f982b0", module.exports)
  } else {
    hotAPI.update("_v-56f982b0", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1269:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 4, stdin */\n.footer[_v-3803fcc4] {\n  background-color: #c7c4c3;\n  font-weight: bolder;\n  font-size: 1.2em; }\n\n/* line 9, stdin */\ntable[_v-3803fcc4] {\n  margin: 10px 0;\n  width: 100%;\n  border: 2px solid #c7c4c3; }\n  /* line 15, stdin */\n  table thead tr[_v-3803fcc4],\n  table tfoot tr[_v-3803fcc4] {\n    border: 2px solid #c7c4c3; }\n  /* line 19, stdin */\n  table tbody tr[_v-3803fcc4] {\n    border: 1px solid #c7c4c3; }\n    /* line 21, stdin */\n    table tbody tr td[_v-3803fcc4],\n    table tbody tr th[_v-3803fcc4] {\n      margin: 10px 0; }\n  /* line 26, stdin */\n  table tr[_v-3803fcc4] {\n    line-height: 30px; }\n  /* line 29, stdin */\n  table tr > td[_v-3803fcc4]:last-child {\n    padding-right: 15px; }\n  /* line 34, stdin */\n  table tfoot .color-red[_v-3803fcc4] {\n    color: red; }\n")
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = require("babel-runtime/helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

var _values = require("babel-runtime/core-js/object/values");

var _values2 = _interopRequireDefault(_values);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    setting: {
      type: Object,
      default: function _default(rawProps) {
        return {};
      }
    },
    order: {
      type: Object,
      default: function _default(rawProps) {
        return {};
      }
    },
    details: {
      type: Array,
      default: function _default(rawProps) {
        return [{
          qty: 1,
          price: 100,
          product_name: "test",
          order_detail_discount_type: 1,
          order_detail_discount_value: 10,
          detail_total_money: 90
        }];
      }
    },
    defaultDetailsData: {
      type: Object,
      default: function _default(rawProps) {
        return {};
      }
    }
  },
  data: function data() {
    return {
      refundData: {},
      total: 0
    };
  },

  methods: {
    withMoneyFormat: function withMoneyFormat(money) {
      return $17.moneyFormat(money);
    },
    showAlreadyRefund: function showAlreadyRefund(detail) {
      return detail.rest_can_refund == 0;
    },
    discountValueShow: function discountValueShow(detail) {
      var discountType = parseInt(detail.order_detail_discount_type);

      return typeof detail.order_detail_discount_value != "undefined" && detail.order_detail_discount_value > 0 ? this.calculateDiscountTotal(detail.qty * detail.price, discountType, detail.order_detail_discount_value) : "";
    },
    calculateDiscountTotal: function calculateDiscountTotal(total, discountType, discountValue) {
      discountType = parseInt(discountType);
      switch (discountType) {
        case 1:
          return discountValue;
          break;
        case 2:
          return Math.round(total * (discountValue / 100));
          break;
        default:
          return discountValue;
      }
    },
    updateRefundData: function updateRefundData(data) {
      this.$set(this.refundData, data.detailId, data);
      // this.refundData[data.detailId]=data;

      this.countTotal();

      this.$emit("update-refund-detail", {
        type: "details",
        data: this.refundData
      });
    },
    countTotal: function countTotal() {
      this.total = (0, _values2.default)(this.refundData).reduce(function (carry, item) {
        if (item.needRefund) {
          carry += item.refundMoney;
        }

        return carry;
      }, 0);
    },
    getDefaultDetail: function getDefaultDetail(orderDetailId) {
      if ((0, _typeof3.default)(this.defaultDetailsData[orderDetailId]) == undefined) {
        return null;
      }
      return this.defaultDetailsData[orderDetailId];
    }
  }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"st-mb-4\" _v-3803fcc4=\"\">\n  <table _v-3803fcc4=\"\">\n    <thead _v-3803fcc4=\"\">\n      <tr _v-3803fcc4=\"\">\n        <td _v-3803fcc4=\"\">&nbsp;</td>\n        <td _v-3803fcc4=\"\">項目名稱</td>\n        <td class=\"text-right\" _v-3803fcc4=\"\">數量</td>\n        <td class=\"text-right\" _v-3803fcc4=\"\">單價</td>\n        <td class=\"text-right\" _v-3803fcc4=\"\">小計</td>\n        <td class=\"text-right\" _v-3803fcc4=\"\">折扣</td>\n        <td class=\"text-right\" _v-3803fcc4=\"\">剩餘</td>\n        <td class=\"text-right\" _v-3803fcc4=\"\"></td>\n      </tr>\n    </thead>\n    <tbody _v-3803fcc4=\"\">\n      <template v-for=\"(detail, index) in details\">\n        <webadmin-order-operate-order-detail-list-refund-item-utility :detail=\"detail\" :discount-value-show=\"discountValueShow(detail)\" :is-refund=\"showAlreadyRefund(detail)\" @update-refund-data=\"updateRefundData\" :default-detail=\"getDefaultDetail(detail.id)\" _v-3803fcc4=\"\"></webadmin-order-operate-order-detail-list-refund-item-utility>\n      </template>\n    </tbody>\n    <tfoot class=\"footer\" _v-3803fcc4=\"\">\n      <tr _v-3803fcc4=\"\">\n        <td _v-3803fcc4=\"\"></td>\n        <td _v-3803fcc4=\"\">退費金額</td>\n        <td _v-3803fcc4=\"\"></td>\n        <td _v-3803fcc4=\"\"></td>\n        <td _v-3803fcc4=\"\"></td>\n        <td _v-3803fcc4=\"\"></td>\n        <td _v-3803fcc4=\"\"></td>\n        <td class=\"text-right\" _v-3803fcc4=\"\">\n          <span v-if=\"total >= 0\" _v-3803fcc4=\"\"> {{ withMoneyFormat(total) }}</span>\n          <span v-else=\"\" class=\"color-red\" _v-3803fcc4=\"\">\n            ({{ withMoneyFormat(Math.abs(total)) }})</span>\n        </td>\n      </tr>\n    </tfoot>\n  </table>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 4, stdin */\n.footer[_v-3803fcc4] {\n  background-color: #c7c4c3;\n  font-weight: bolder;\n  font-size: 1.2em; }\n\n/* line 9, stdin */\ntable[_v-3803fcc4] {\n  margin: 10px 0;\n  width: 100%;\n  border: 2px solid #c7c4c3; }\n  /* line 15, stdin */\n  table thead tr[_v-3803fcc4],\n  table tfoot tr[_v-3803fcc4] {\n    border: 2px solid #c7c4c3; }\n  /* line 19, stdin */\n  table tbody tr[_v-3803fcc4] {\n    border: 1px solid #c7c4c3; }\n    /* line 21, stdin */\n    table tbody tr td[_v-3803fcc4],\n    table tbody tr th[_v-3803fcc4] {\n      margin: 10px 0; }\n  /* line 26, stdin */\n  table tr[_v-3803fcc4] {\n    line-height: 30px; }\n  /* line 29, stdin */\n  table tr > td[_v-3803fcc4]:last-child {\n    padding-right: 15px; }\n  /* line 34, stdin */\n  table tfoot .color-red[_v-3803fcc4] {\n    color: red; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-3803fcc4", module.exports)
  } else {
    hotAPI.update("_v-3803fcc4", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/object/values":58,"babel-runtime/helpers/typeof":72,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1270:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 4, stdin */\n.footer[_v-396b83ba] {\n  background-color: #c7c4c3;\n  font-weight: bolder;\n  font-size: 1.2em; }\n\n/* line 9, stdin */\ntable[_v-396b83ba] {\n  margin: 10px 0;\n  width: 100%;\n  border: 2px solid #c7c4c3; }\n  /* line 15, stdin */\n  table thead tr[_v-396b83ba],\n  table tfoot tr[_v-396b83ba] {\n    border: 2px solid #c7c4c3; }\n  /* line 19, stdin */\n  table tbody tr[_v-396b83ba] {\n    border: 1px solid #c7c4c3; }\n    /* line 21, stdin */\n    table tbody tr td[_v-396b83ba],\n    table tbody tr th[_v-396b83ba] {\n      margin: 10px 0; }\n  /* line 26, stdin */\n  table tr[_v-396b83ba] {\n    line-height: 30px; }\n  /* line 29, stdin */\n  table tr > td[_v-396b83ba]:last-child {\n    padding-right: 15px; }\n  /* line 34, stdin */\n  table tfoot .color-red[_v-396b83ba] {\n    color: red; }\n\n/* line 39, stdin */\n.discount[_v-396b83ba], .close[_v-396b83ba] {\n  color: red; }\n\n/* line 42, stdin */\n.less-space[_v-396b83ba] {\n  padding-right: 15px; }\n\n/* line 45, stdin */\n.already-refund[_v-396b83ba] {\n  padding-left: 15px; }\n\n/* line 48, stdin */\n.color-red[_v-396b83ba] {\n  color: red; }\n\n/* line 51, stdin */\n.item-show[_v-396b83ba] {\n  cursor: pointer; }\n\n/* line 54, stdin */\n.spinner[_v-396b83ba] {\n  display: inline; }\n\n/* line 57, stdin */\n.danger[_v-396b83ba] {\n  background-color: #f8d7da; }\n")
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    setting: {
      type: Object,
      default: function _default(rawProps) {
        return {};
      }
    },
    order: {
      type: Object,
      default: function _default(rawProps) {
        return {};
      }
    },
    details: {
      type: Array,
      default: function _default(rawProps) {
        return [{
          qty: 1,
          price: 100,
          product_name: "test",
          order_detail_discount_type: 1,
          order_detail_discount_value: 10,
          detail_total_money: 90
        }];
      }
    }
  },
  data: function data() {
    return {
      ajaxing: {
        memberContract: false,
        ticket: false
      }
    };
  },

  methods: {
    withMoneyFormat: function withMoneyFormat(money) {
      return $17.moneyFormat(money);
    },
    showAlreadyRefund: function showAlreadyRefund(detail) {
      return detail.refer_order_detail_id == null && detail.rest_can_refund == 0 && detail.price > 0 && detail.detail_total_money > 0;
    },
    isAssign: function isAssign(orderDetail, type) {
      return orderDetail.buy_model === type && orderDetail.buy_id > 0;
    },
    discountValueShow: function discountValueShow(detail) {
      var discountType = parseInt(detail.order_detail_discount_type);

      return typeof detail.order_detail_discount_value != "undefined" && detail.order_detail_discount_value > 0 ? this.calculateDiscountTotal(detail.qty * detail.price, discountType, detail.order_detail_discount_value) : "";
    },
    calculateDiscountTotal: function calculateDiscountTotal(total, discountType, discountValue) {
      discountType = parseInt(discountType);
      switch (discountType) {
        case 1:
          return discountValue;
          break;
        case 2:
          return Math.round(total * (discountValue / 100));
          break;
        default:
          return discountValue;
      }
    },
    trackDangerProduct: function trackDangerProduct(orderDetail) {
      if (this.order.type == 13) {
        //退費訂單不用顯示沒給到商品的警告
        return false;
      } else {
        switch (orderDetail.product_type) {
          case "contracts":
            return !this.isAssign(orderDetail, "member_contracts");
          case "ticket_settings":
            return !this.isAssign(orderDetail, "ticket_groups");
          default:
            return false;
        }
      }
    },
    showMemberContractModal: function showMemberContractModal(detail) {
      var _this = this;

      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var buy_id;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                buy_id = null;

                buy_id = detail.buy_id;
                _this.ajaxing.memberContract = true;
                _context.next = 5;
                return _this.$store.dispatch("webadmin/crm/fetchOneMemberContract", buy_id);

              case 5:
                $("#modal-contract").modal("show");
                _this.ajaxing.memberContract = false;

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    openBoughtTicket: function openBoughtTicket(detail) {
      var _this2 = this;

      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.ajaxing.ticket = true;
                window.Event.$emit("System.Pos.Order.OpenBoughtTicket", detail);
                _this2.ajaxing.ticket = false;

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    showOrderDetailWithProduct: function showOrderDetailWithProduct(detail) {
      window.Event.$emit("System.Pos.Order.ShowOrderDetailWithProduct", detail);
    }
  },
  computed: {}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"st-mb-4\" _v-396b83ba=\"\">\n  <table _v-396b83ba=\"\">\n    <thead _v-396b83ba=\"\">\n      <tr _v-396b83ba=\"\">\n        <td _v-396b83ba=\"\">&nbsp;</td>\n        <td _v-396b83ba=\"\">項目名稱</td>\n        <td class=\"text-right\" _v-396b83ba=\"\">數量</td>\n        <td class=\"text-right\" _v-396b83ba=\"\">單價</td>\n        <td class=\"text-right\" _v-396b83ba=\"\">小計</td>\n        <td class=\"text-right\" _v-396b83ba=\"\">折扣</td>\n        <td class=\"text-right\" _v-396b83ba=\"\"></td>\n        <td class=\"text-right\" _v-396b83ba=\"\">剩餘</td>\n      </tr>\n    </thead>\n    <tbody _v-396b83ba=\"\">\n      <template v-for=\"(detail, index) in details\">\n        <tr :class=\"['item-show', { danger: trackDangerProduct(detail) }]\" _v-396b83ba=\"\">\n          <td _v-396b83ba=\"\">\n            <div class=\"already-refund\" v-if=\"showAlreadyRefund(detail)\" _v-396b83ba=\"\">\n              <span _v-396b83ba=\"\">已退</span>\n            </div>\n          </td>\n          <td _v-396b83ba=\"\">\n            {{ detail.product_name }}\n            <span _v-396b83ba=\"\">&nbsp;</span>\n            <span class=\"text-danger item-refund\" v-if=\"\n                detail.product_type == 'contracts' &amp;&amp;\n                isAssign(detail, 'member_contracts')\n              \" v-show=\"!ajaxing.memberContract\" @click=\"showMemberContractModal(detail)\" _v-396b83ba=\"\">\n              <u _v-396b83ba=\"\">查看</u>\n            </span>\n            <span v-if=\"\n                detail.product_type == 'ticket_settings' &amp;&amp;\n                isAssign(detail, 'ticket_groups')\n              \" v-show=\"!ajaxing.ticket\" class=\"btn btn-success btn-xs\" @click=\"openBoughtTicket(detail)\" _v-396b83ba=\"\">顯示票券</span>\n            <v-spinner-button :ajaxing=\"ajaxing.ticket || ajaxing.memberContract\" _v-396b83ba=\"\"></v-spinner-button>\n          </td>\n          <td class=\"text-right\" _v-396b83ba=\"\">{{ detail.qty }}</td>\n          <td class=\"text-right\" _v-396b83ba=\"\">{{ detail.price }}</td>\n          <td class=\"text-right\" _v-396b83ba=\"\">\n            <span v-if=\"detail.refer_order_detail_id == null\" _v-396b83ba=\"\">\n              {{ withMoneyFormat(detail.qty * detail.price) }}\n            </span>\n          </td>\n          <td class=\"discount text-right\" _v-396b83ba=\"\">\n            <span class=\"item-show\" v-if=\"detail.order_detail_discount_value != 0\" @click.stop=\"showOrderDetailWithProduct(detail)\" _v-396b83ba=\"\">\n              {{ discountValueShow(detail) }}\n            </span>\n          </td>\n          <td class=\"text-right\" _v-396b83ba=\"\">\n            <span v-if=\"detail.detail_total_money >= 0\" _v-396b83ba=\"\">\n              {{ withMoneyFormat(detail.detail_total_money) }}</span>\n            <span v-else=\"\" class=\"color-red\" _v-396b83ba=\"\">\n              ({{\n                withMoneyFormat(Math.abs(detail.detail_total_money))\n              }})</span>\n          </td>\n          <td class=\"text-right less-space\" v-if=\"detail.rest_can_refund > 0\" _v-396b83ba=\"\">\n            {{ withMoneyFormat(detail.rest_can_refund) }}\n          </td>\n          <td v-else=\"\" _v-396b83ba=\"\"></td>\n        </tr>\n      </template>\n    </tbody>\n    <tfoot class=\"footer\" _v-396b83ba=\"\">\n      <tr _v-396b83ba=\"\">\n        <td _v-396b83ba=\"\"></td>\n        <td _v-396b83ba=\"\">總計</td>\n        <td _v-396b83ba=\"\"></td>\n        <td _v-396b83ba=\"\"></td>\n        <td _v-396b83ba=\"\"></td>\n        <td _v-396b83ba=\"\"></td>\n        <td class=\"text-right\" _v-396b83ba=\"\">\n          <span v-if=\"order.total >= 0\" _v-396b83ba=\"\">\n            {{ withMoneyFormat(order.total) }}</span>\n          <span v-else=\"\" class=\"color-red\" _v-396b83ba=\"\">\n            ({{ withMoneyFormat(Math.abs(order.total)) }})</span>\n        </td>\n        <td _v-396b83ba=\"\"></td>\n      </tr>\n    </tfoot>\n  </table>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 4, stdin */\n.footer[_v-396b83ba] {\n  background-color: #c7c4c3;\n  font-weight: bolder;\n  font-size: 1.2em; }\n\n/* line 9, stdin */\ntable[_v-396b83ba] {\n  margin: 10px 0;\n  width: 100%;\n  border: 2px solid #c7c4c3; }\n  /* line 15, stdin */\n  table thead tr[_v-396b83ba],\n  table tfoot tr[_v-396b83ba] {\n    border: 2px solid #c7c4c3; }\n  /* line 19, stdin */\n  table tbody tr[_v-396b83ba] {\n    border: 1px solid #c7c4c3; }\n    /* line 21, stdin */\n    table tbody tr td[_v-396b83ba],\n    table tbody tr th[_v-396b83ba] {\n      margin: 10px 0; }\n  /* line 26, stdin */\n  table tr[_v-396b83ba] {\n    line-height: 30px; }\n  /* line 29, stdin */\n  table tr > td[_v-396b83ba]:last-child {\n    padding-right: 15px; }\n  /* line 34, stdin */\n  table tfoot .color-red[_v-396b83ba] {\n    color: red; }\n\n/* line 39, stdin */\n.discount[_v-396b83ba], .close[_v-396b83ba] {\n  color: red; }\n\n/* line 42, stdin */\n.less-space[_v-396b83ba] {\n  padding-right: 15px; }\n\n/* line 45, stdin */\n.already-refund[_v-396b83ba] {\n  padding-left: 15px; }\n\n/* line 48, stdin */\n.color-red[_v-396b83ba] {\n  color: red; }\n\n/* line 51, stdin */\n.item-show[_v-396b83ba] {\n  cursor: pointer; }\n\n/* line 54, stdin */\n.spinner[_v-396b83ba] {\n  display: inline; }\n\n/* line 57, stdin */\n.danger[_v-396b83ba] {\n  background-color: #f8d7da; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-396b83ba", module.exports)
  } else {
    hotAPI.update("_v-396b83ba", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1271:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\nhr[_v-4899d495] {\n  margin-left: -20px;\n  margin-right: -20px; }\n\n/* line 6, stdin */\n.total-col[_v-4899d495] {\n  font-weight: bold; }\n\n/* line 9, stdin */\n.form-horizontal > .form-group > div > *[_v-4899d495] {\n  text-align: right; }\n\n/* line 12, stdin */\n#refund-reson[_v-4899d495] {\n  text-align: left; }\n")
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vuex = require("vuex");

exports.default = {
    data: function data() {
        return {
            detail: {
                buy_id: null,
                buy_model: "",
                can_be_delete: true,
                detail_total_money: null,
                id: null,
                order_detail_discount_type: null,
                order_detail_discount_value: 0,
                price: null,
                product_name: "",
                product_type: "",
                qty: 0,
                refer_order_detail_id: null,
                rest_can_refund: 0,
                discount_reason: ''
            }
        };
    },
    props: {
        locked: false
    },
    methods: {
        closeModal: function closeModal() {
            if (this.locked) return;
            $('#order-operate-product-item-show').modal('hide');
        },
        calculateDiscountTotal: function calculateDiscountTotal(total, discountType, discountValue) {
            discountType = parseInt(discountType);
            switch (discountType) {
                case 1:
                    return discountValue;
                    break;
                case 2:
                    return Math.round(total * (discountValue / 100));
                    break;
                default:
                    return discountValue;
            }
        }
    },
    computed: {
        discount_value: {
            get: function get() {
                var discountType = parseInt(this.discount_type);
                return this.calculateDiscountTotal(this.detail.detail_total_money, discountType, this.detail.order_detail_discount_value);
            }
        },
        discount_type: {
            get: function get() {
                return !this.detail.order_detail_discount_type ? 1 : this.detail.order_detail_discount_type;
            }
        },
        buy_number: {
            get: function get() {
                return this.detail.qty;
            }
        },
        total_money: function total_money() {
            return this.sub_total - this.discount_value;
        },
        sub_total: function sub_total() {
            return this.detail.qty * this.getPrice;
        },
        discount_ratio: function discount_ratio() {
            var discountRatio = new Number(this.discount_value / this.sub_total * 100);
            return discountRatio.toFixed(1);
        },
        canBuyMulti: function canBuyMulti() {
            return ['physical_products', 'ticket_settings'].indexOf(this.discount_type) != -1 ? true : false;
        },
        getPrice: function getPrice() {
            return this.detail.price;
        }
    },
    mounted: function mounted() {},
    created: function created() {}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal id=\"order-operate-product-item-show\" open-size=\"modal-lg\" no-cancel=\"\" parallel-modal=\"\" close-btn-text=\"返回\" no-footer=\"\" _v-4899d495=\"\">\n        <div slot=\"title\" _v-4899d495=\"\">\n            {{detail.product_name}}\n        </div>\n        <div slot=\"body\" _v-4899d495=\"\">\n            <form class=\"form-horizontal\" v-on:submit.prevent=\"\" _v-4899d495=\"\">\n                <div class=\"form-group\" _v-4899d495=\"\">\n                    <label class=\"col-sm-3\" _v-4899d495=\"\">價格</label>\n                    <div class=\"col-sm-5\" _v-4899d495=\"\">\n                        <p class=\"form-control-static\" _v-4899d495=\"\">{{getPrice}}</p>\n                    </div>\n                </div>\n                <div class=\"form-group\" v-show=\"canBuyMulti\" _v-4899d495=\"\">\n                    <label class=\"col-sm-3\" _v-4899d495=\"\">數量</label>\n                    <div class=\"col-sm-5\" _v-4899d495=\"\">\n                        <p class=\"form-control-static\" _v-4899d495=\"\">{{buy_number}}</p>\n                    </div>\n                </div>\n                <hr v-show=\"canBuyMulti\" _v-4899d495=\"\">\n                <div class=\"form-group\" v-show=\"canBuyMulti\" _v-4899d495=\"\">\n                    <label class=\"col-sm-3\" _v-4899d495=\"\">小計</label>\n                    <div class=\"col-sm-5\" _v-4899d495=\"\">\n                        <p class=\"form-control-static\" _v-4899d495=\"\"> {{ sub_total }}</p>\n                    </div>\n                </div>\n                <div class=\"form-group\" v-if=\"discount_value > 0\" _v-4899d495=\"\">\n                    <label class=\"col-sm-3\" _v-4899d495=\"\">折扣比例％</label>\n                    <div class=\"col-sm-5\" _v-4899d495=\"\">\n                        <p class=\"form-control-static\" _v-4899d495=\"\"> {{ discount_ratio }}</p>\n                    </div>\n                </div>\n                <div class=\"form-group\" v-if=\"discount_value > 0\" _v-4899d495=\"\">\n                    <label class=\"col-sm-3\" _v-4899d495=\"\">折扣金額$</label>\n                    <div class=\"col-sm-5\" _v-4899d495=\"\">\n                        <p class=\"form-control-static\" _v-4899d495=\"\"> {{ discount_value }}</p>\n                    </div>\n                </div>\n                <div class=\"form-group total-col\" _v-4899d495=\"\">\n                    <label class=\"col-sm-3\" _v-4899d495=\"\">總計</label>\n                    <div class=\"col-sm-5\" _v-4899d495=\"\">\n                        <p class=\"form-control-static\" _v-4899d495=\"\"> {{ total_money }}</p>\n                    </div>\n                </div>\n                <hr _v-4899d495=\"\">\n                <div class=\"form-group\" v-if=\"discount_value > 0\" _v-4899d495=\"\">\n                    <label class=\"col-sm-3\" _v-4899d495=\"\">折扣原因</label>\n                    <div class=\"col-sm-5\" _v-4899d495=\"\">\n                        <textarea readonly=\"\" id=\"refund-reson\" v-model.lazy=\"detail.discount_reason\" placeholder=\"此為必填\" _v-4899d495=\"\"></textarea>\n                    </div>\n                </div>\n            </form>\n        </div>\n</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\nhr[_v-4899d495] {\n  margin-left: -20px;\n  margin-right: -20px; }\n\n/* line 6, stdin */\n.total-col[_v-4899d495] {\n  font-weight: bold; }\n\n/* line 9, stdin */\n.form-horizontal > .form-group > div > *[_v-4899d495] {\n  text-align: right; }\n\n/* line 12, stdin */\n#refund-reson[_v-4899d495] {\n  text-align: left; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-4899d495", module.exports)
  } else {
    hotAPI.update("_v-4899d495", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1272:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.outsid-border[_v-7da39bbc] {\n  border: 2px solid #c7c4c3;\n  border-bottom: 0px;\n  margin-bottom: -10px; }\n  /* line 7, stdin */\n  .outsid-border .btn[_v-7da39bbc] {\n    margin: 10px 0 10px 20px; }\n\n/* line 12, stdin */\n.more-space[_v-7da39bbc] {\n  margin: 10px 15px; }\n\n/* line 16, stdin */\n.small-space[_v-7da39bbc] {\n  margin-right: 5px; }\n\n/* line 20, stdin */\n.right-space[_v-7da39bbc] {\n  margin-right: 15px; }\n\n/* line 24, stdin */\n.left-space[_v-7da39bbc] {\n  margin-left: 15px; }\n\n/* line 28, stdin */\n.order-edit .search-member[_v-7da39bbc] {\n  margin-top: 0px; }\n\n/* line 32, stdin */\n.commonly-used-items[_v-7da39bbc] {\n  word-break: break-all;\n  background-color: #eee;\n  min-height: 100vh; }\n  /* line 37, stdin */\n  .commonly-used-items .commonly-item.btn-default[_v-7da39bbc]:active {\n    background-color: #fff; }\n")
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vuex = require("vuex");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        setting: {
            type: Object,
            default: function _default(rawProps) {
                return {
                    order: {
                        canBeDelete: true //false
                    },
                    branch: {
                        enableEdit: function enableEdit(data) {
                            return true;
                        } //false
                    },
                    member: {
                        enableEdit: function enableEdit(data) {
                            return true;
                        }
                    },
                    details: {
                        enableEdit: function enableEdit(data) {
                            return true;
                        }
                    },
                    remark: {
                        enableEdit: function enableEdit(data) {
                            return true;
                        }
                    },
                    salesman: {
                        enableEdit: function enableEdit(data) {
                            return true;
                        }
                    },
                    invoice: {
                        enableEdit: function enableEdit(data) {
                            return true;
                        }
                    },
                    payments: {
                        enableEdit: function enableEdit(data) {
                            return true;
                        }
                    }
                };
            }
        },
        getOrder: {
            type: Function
        },
        defaultOrderData: {
            type: Object,
            default: function _default(rawProps) {
                return {};
            }
        },
        enableChangeMember: {
            default: true
        },
        eventType: {
            default: 'general'
        }
    },
    data: function data() {
        return {
            ajaxing: {
                appendDetail: false,
                editOrder: false,
                getOrder: false,
                operateSelectedOrderDetail: false
            },
            currentOrder: {
                //思考要不要向上提供元件共用
                order: {
                    id: "",
                    total: 0,
                    remark: ""
                },
                branch: {
                    studio_id: 0,
                    branch_id: 0
                },
                member: {
                    id: "",
                    photo: "",
                    name: "",
                    is_walkin: "",
                    phone: "",
                    email: ""
                },
                detailStatus: {},
                details: [],
                invoice: {
                    order_invoice_active: false,
                    issue_method_select: null,
                    carrier_number: ""
                },
                payments: []
            },
            actionData: {
                invoice: {},
                payments: {}
            }
        };
    },

    methods: {
        changeStudio: function changeStudio(id) {
            this.currentOrder.branch.studio_id = id;
            if (id) {
                this.execGetOrder();
            }
        },

        changeBranch: function () {
            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(id) {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                this.currentOrder.branch.branch_id = id;
                                if (id) {
                                    this.execGetOrder();
                                }

                            case 2:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function changeBranch(_x) {
                return _ref.apply(this, arguments);
            }

            return changeBranch;
        }(),
        changeMember: function changeMember() {
            this.execGetOrder();
        },
        execGetOrder: function execGetOrder() {
            var _this = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _this.ajaxing.getOrder = true;
                                _context2.next = 3;
                                return _this.getOrder(_this);

                            case 3:
                                _this.ajaxing.getOrder = false;

                            case 4:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this);
            }))();
        },
        operateSelectedOrderDetail: function operateSelectedOrderDetail(detail) {
            var _this2 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
                var showOrderDetailProduct;
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                if (!_this2.ajaxing.operateSelectedOrderDetail) {
                                    _context3.next = 2;
                                    break;
                                }

                                return _context3.abrupt("return");

                            case 2:
                                _this2.ajaxing.operateSelectedOrderDetail = true;
                                showOrderDetailProduct = {};
                                _context3.next = 6;
                                return _this2.$http.get("/adminapi/pos/show_order_detail_product/" + detail.id).then(function (_ref2) {
                                    var data = _ref2.data;

                                    showOrderDetailProduct = data.order_detail;
                                    _this2.ajaxing.operateSelectedOrderDetail = false;
                                }, function (data) {
                                    _this2.ajaxing.operateSelectedOrderDetail = false;
                                    $17.swal({
                                        title: data.message,
                                        text: "",
                                        type: "warning"
                                    });
                                });

                            case 6:

                                _this2.$refs.product.setEditDetail(detail, showOrderDetailProduct);

                            case 7:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this2);
            }))();
        },
        appendOrderDetail: function appendOrderDetail(detail) {
            var _this3 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _this3.ajaxing.appendDetail = true;

                                _context4.next = 3;
                                return _this3.$http.post("/adminapi/pos/append_order_detail/" + _this3.currentOrder.order.id, {
                                    branch_id: detail.branch_id,
                                    product_type: detail.product_type,
                                    product_id: detail.product_id,
                                    amount: detail.amount,
                                    discount_type: detail.discount_type,
                                    discount_value: detail.discount_value,
                                    discount_reason: detail.discount_reason,
                                    order_id: _this3.currentOrder.order.id
                                }).then(function (_ref3) {
                                    var data = _ref3.data;

                                    _this3.ajaxing.appendDetail = false;
                                    _this3.execGetOrder();
                                }, function (_ref4) {
                                    var data = _ref4.data;

                                    _this3.ajaxing.appendDetail = false;
                                    $17.swal({
                                        title: data.message,
                                        text: "",
                                        type: "warning"
                                    });
                                });

                            case 3:
                            case "end":
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this3);
            }))();
        },
        updateActionData: function updateActionData(payload) {
            if (payload.type == "invoice") {
                this.actionData.invoice = payload.data;
            }

            if (payload.type == "payment") {
                this.actionData.payments[payload.payment_action_record_id] = payload.data;
            }
        },
        clearActionData: function clearActionData() {
            this.actionData = {
                invoice: {},
                payments: {}
            };
        },
        setAlertObj: function setAlertObj(obj) {
            this.$emit("set-alert-obj", obj);
        },
        close: function close() {
            var vm = this;

            if (this.currentOrder.order.payment_status && this.currentOrder.order.payment_status > 0 || this.currentOrder.details.length > 0) {
                return false;
            }

            this.$http.post("/adminapi/pos/invalid_order/" + this.currentOrder.order.id).then(function (response) {});
        }
    },
    computed: {
        disableStudio: function disableStudio() {
            return this.checkHasProduct || this.ajaxing.appendDetail || this.currentOrder.branch.branch_id == 0;
        },
        disableBranch: function disableBranch() {
            return this.checkHasProduct || this.ajaxing.appendDetail || this.currentOrder.branch.branch_id == 0;
        },
        checkHasProduct: function checkHasProduct() {
            return this.currentOrder.details && this.currentOrder.details.length > 0 ? true : false;
        },
        enableChangeMemberCheck: function enableChangeMemberCheck() {
            return this.enableChangeMember && !this.checkHasProduct ? true : false;
        },
        detailSettingData: function detailSettingData() {
            return {};
        }
    },
    mounted: function mounted() {
        this.currentOrder = this.defaultOrderData;
        if (this.defaultOrderData.member && this.defaultOrderData.member.id) {
            this.$store.commit("filters/SETSTATUS", {
                key: "selected_search_member_id",
                value: this.defaultOrderData.member.id
            });
        }
    },

    watch: (0, _extends3.default)({
        defaultOrderData: {
            handler: function handler(newValue, oldValue) {
                this.currentOrder = newValue;
                if (newValue.member && newValue.member.id) {
                    this.$store.commit("filters/SETSTATUS", {
                        key: "selected_search_member_id",
                        value: newValue.member.id
                    });
                }
            },

            deep: true
        }
    }, (0, _vuex.mapState)({
        WebadminOrderEdit: function WebadminOrderEdit(state) {
            return state.webadmin.configure.webFunctions.WebadminOrderEdit;
        }
    }))
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"row p-left-0 p-right-0 p-top-0\" style=\"min-height: 100%\" _v-7da39bbc=\"\">\n    <div class=\"order-edit col-md-9 p-top-15 p-right-5\" :class=\"{\n    'col-md-9': setting.details.enableEdit(detailSettingData),\n    'col-md-12': !setting.details.enableEdit(detailSettingData),\n  }\" _v-7da39bbc=\"\">\n        <webadmin-order-operate-branch-utility :setting=\"setting.branch\" :studio-id=\"currentOrder.branch.studio_id\" :branch-id=\"currentOrder.branch.branch_id\" :disable-studio=\"disableStudio\" :disable-branch=\"disableBranch\" :order-id=\"currentOrder.order.id\" @studio-change=\"changeStudio\" @branch-change=\"changeBranch\" _v-7da39bbc=\"\">\n        </webadmin-order-operate-branch-utility>\n        <webadmin-order-operate-member-utility :setting=\"setting.member\" :order-id=\"currentOrder.order.id\" :member-data=\"currentOrder.member\" :enable-change-member=\"enableChangeMemberCheck\" @member-change=\"execGetOrder\" _v-7da39bbc=\"\"></webadmin-order-operate-member-utility>\n        <webadmin-product-operate-utility ref=\"product\" :setting=\"setting.details\" :branch-id=\"currentOrder.branch.branch_id\" :order-id=\"currentOrder.order.id\" :walk-in-member=\"currentOrder.member.is_walkin\" @order-changed=\"execGetOrder\" _v-7da39bbc=\"\">\n        </webadmin-product-operate-utility>\n        <webadmin-order-operate-order-detail-list-edit-utility :setting=\"setting.details\" :ajaxing=\"ajaxing.operateSelectedOrderDetail\" :details=\"currentOrder.details\" :total=\"currentOrder.order.total\" :operate-selected-order-detail=\"operateSelectedOrderDetail\" @order-changed=\"execGetOrder\" _v-7da39bbc=\"\">\n        </webadmin-order-operate-order-detail-list-edit-utility>\n        <webadmin-order-operate-remark-utility :default-remark=\"currentOrder.order.remark\" :setting=\"setting.remark\" @remark-change=\"execGetOrder\" :order-id=\"currentOrder.order.id\" _v-7da39bbc=\"\"></webadmin-order-operate-remark-utility>\n        <webadmin-order-operate-order-issue-method-utility :setting=\"setting.invoice\" :order=\"currentOrder.order\" :branch-id=\"currentOrder.branch.branch_id\" :invoice=\"currentOrder.invoice\" :member-email=\"currentOrder.member.email\" :manual-invoice-number=\"currentOrder.invoice.manual_invoice_number\" @updated-issue-method=\"execGetOrder\" @update-action-data=\"updateActionData\" _v-7da39bbc=\"\">\n        </webadmin-order-operate-order-issue-method-utility>\n        <webadmin-order-operate-branch-payment-methods-utility v-for=\"payment in currentOrder.payments\" :setting=\"setting.payments\" :order=\"currentOrder.order\" :member=\"currentOrder.member\" :branch-id=\"currentOrder.branch.branch_id\" :studio-id=\"currentOrder.branch.studio_id\" :payment=\"payment\" @updated-payment-method=\"execGetOrder\" @update-user-input=\"updateActionData\" _v-7da39bbc=\"\">\n        </webadmin-order-operate-branch-payment-methods-utility>\n        <webadmin-order-operate-salesman-utility :setting=\"setting.salesman\" :studio-id=\"currentOrder.branch.studio_id\" :order-id=\"currentOrder.order.id\" model-id=\"order-operate-salesman-modal\" _v-7da39bbc=\"\">\n        </webadmin-order-operate-salesman-utility>\n        <webadmin-order-operate-action-bar-edit-utility :setting=\"setting\" :order=\"currentOrder.order\" :branch=\"currentOrder.branch\" :member=\"currentOrder.member\" :details=\"currentOrder.details\" :invoice=\"currentOrder.invoice\" :payments=\"currentOrder.payments\" :action-data=\"actionData\" :order-changing=\"ajaxing.getOrder\" @set-alert-obj=\"setAlertObj\" @clear-action-data=\"clearActionData\" _v-7da39bbc=\"\">\n        </webadmin-order-operate-action-bar-edit-utility>\n    </div>\n    <div class=\"commonly-used-items col-md-3 p-left-0 p-right-0\" v-if=\"setting.details.enableEdit(detailSettingData)\" _v-7da39bbc=\"\">\n        <webadmin-commonly-used-items-utility :setting=\"setting.details\" :branch-id=\"currentOrder.branch.branch_id\" :add-item-callback=\"appendOrderDetail\" _v-7da39bbc=\"\"></webadmin-commonly-used-items-utility>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.outsid-border[_v-7da39bbc] {\n  border: 2px solid #c7c4c3;\n  border-bottom: 0px;\n  margin-bottom: -10px; }\n  /* line 7, stdin */\n  .outsid-border .btn[_v-7da39bbc] {\n    margin: 10px 0 10px 20px; }\n\n/* line 12, stdin */\n.more-space[_v-7da39bbc] {\n  margin: 10px 15px; }\n\n/* line 16, stdin */\n.small-space[_v-7da39bbc] {\n  margin-right: 5px; }\n\n/* line 20, stdin */\n.right-space[_v-7da39bbc] {\n  margin-right: 15px; }\n\n/* line 24, stdin */\n.left-space[_v-7da39bbc] {\n  margin-left: 15px; }\n\n/* line 28, stdin */\n.order-edit .search-member[_v-7da39bbc] {\n  margin-top: 0px; }\n\n/* line 32, stdin */\n.commonly-used-items[_v-7da39bbc] {\n  word-break: break-all;\n  background-color: #eee;\n  min-height: 100vh; }\n  /* line 37, stdin */\n  .commonly-used-items .commonly-item.btn-default[_v-7da39bbc]:active {\n    background-color: #fff; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-7da39bbc", module.exports)
  } else {
    hotAPI.update("_v-7da39bbc", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1273:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	props: {
		operateRef: {
			type: Object,
			default: function _default(rawProps) {
				return {};
			}
		}
	},
	data: function data() {
		return {
			eventCalls: {}
		};
	},

	methods: {
		operateBillSuccessCallBack: function operateBillSuccessCallBack() {
			window.Event.$emit('auto-pay-plan-refresh');
			window.Event.$emit('add-binding-member-credit-card-branch');

			this.operateRef.modalClose();
			this.fetchDetails();

			this.$emit('open-info', {
				status: 'show'
			});
		},
		operateInvalidSuccessCallBack: function operateInvalidSuccessCallBack(payload) {
			this.fetchDetails();
			$17.swal({
				title: '操作成功',
				text: '',
				type: 'success',
				showCancelButton: false
			});
			this.openOrderCallBack(payload);
		},
		operateCancelSuccessCallBack: function operateCancelSuccessCallBack() {
			this.fetchDetails();
			this.operateRef.modalClose();
		},
		operateBillFailCallBack: function operateBillFailCallBack() {
			this.operateRef.modalClose();
			this.$emit('open-info', {
				status: 'show'
			});
		},
		openOrderCallBack: function openOrderCallBack(payload) {
			var _this = this;

			return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.next = 2;
								return _this.operateRef.openOrderCallBack(payload);

							case 2:
								if (payload.order_id == "") {
									payload.event_calls.fetchDetails();
								}

							case 3:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		},
		operateRefundSuccessCallBack: function operateRefundSuccessCallBack(payload) {
			this.fetchDetails();
			this.operateRef.modalClose({
				order: {
					id: payload.order_id
				}
			});
			this.$emit('open-info', {
				status: 'show'
			});
		},
		fetchDetails: function fetchDetails() {
			if (typeof this.eventCalls.fetchDetails != 'undefined') {
				this.eventCalls.fetchDetails();
			}
		},
		openRefundModalCallBack: function openRefundModalCallBack(payload) {
			var _this2 = this;

			return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
				return _regenerator2.default.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								_this2.operateRef.$refs.orderOperate.operateType = 'refund';
								_this2.operateRef.$refs.orderOperate.resetModeData('refund');
								_this2.$nextTick(function () {
									_this2.operateRef.$refs.orderOperate.$refs.refundMode.execGetOrder();
								});

							case 3:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, _this2);
			}))();
		}
	}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div></div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-6bc99f84", module.exports)
  } else {
    hotAPI.update("_v-6bc99f84", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785}],1274:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	props: {
		operateRef: {
			type: Object,
			default: function _default(rawProps) {
				return {};
			}
		}
	},
	methods: {
		operateBillSuccessCallBack: function operateBillSuccessCallBack(payload) {
			this.operateRef.modalClose();
			this.$emit('open-info', {
				status: 'show'
			});
		},
		operateBillFailCallBack: function operateBillFailCallBack(payload) {
			this.operateRef.modalClose();
			this.$emit('open-info', {
				status: 'show'
			});
		},
		operateInvoiceIssueSucceedCallBack: function operateInvoiceIssueSucceedCallBack(payload) {
			this.operateRef.modalClose();
			this.$emit('open-info', {
				status: 'show'
			});
		},
		operateInvoiceIssueFailedCallBack: function operateInvoiceIssueFailedCallBack(payload) {
			this.operateRef.modalClose();
			this.$emit('open-info', {
				status: 'show'
			});
		},
		openOrderCallBack: function openOrderCallBack(payload) {
			this.operateRef.openOrderCallBack(payload);
		}
	}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div></div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-34963722", module.exports)
  } else {
    hotAPI.update("_v-34963722", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],1275:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	props: {
		operateRef: {
			type: Object,
			default: function _default(rawProps) {
				return {};
			}
		}
	},
	methods: {
		operateBillSuccessCallBack: function operateBillSuccessCallBack(payload) {
			window.Event.$emit('fetch-member-history-orders');
			this.operateRef.modalClose();
			this.$emit('open-info', {
				status: 'show'
			});
			this.$store.dispatch('webadmin/crm/fetchMemberContract', payload.member_id);
		},
		operateBillFailCallBack: function operateBillFailCallBack(payload) {
			this.operateRef.modalClose();
			this.$emit('open-info', {
				status: 'show'
			});
		},
		operateCancelSuccessCallBack: function operateCancelSuccessCallBack() {
			this.operateRef.modalClose();
		},
		operateInvoiceIssueSucceedCallBack: function operateInvoiceIssueSucceedCallBack(payload) {
			this.operateRef.modalClose();
			this.$emit('open-info', {
				status: 'show'
			});
		},
		operateInvoiceIssueFailedCallBack: function operateInvoiceIssueFailedCallBack(payload) {
			this.operateRef.modalClose();
			this.$emit('open-info', {
				status: 'show'
			});
		},
		openOrderCallBack: function openOrderCallBack(payload) {
			var _this = this;

			return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
				return _regenerator2.default.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								payload.need_open = false;
								_context2.next = 3;
								return _this.operateRef.openOrderCallBack(payload);

							case 3:
								if (!((0, _typeof3.default)(payload.member_id) != undefined)) {
									_context2.next = 6;
									break;
								}

								_context2.next = 6;
								return _this.$http.post('/adminapi/pos/change_order_value/' + _this.operateRef.currentOrder.order.id, {
									'member_id': payload.member_id
								}).then(function () {
									var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(_ref2) {
										var data = _ref2.data;
										return _regenerator2.default.wrap(function _callee$(_context) {
											while (1) {
												switch (_context.prev = _context.next) {
													case 0:
														payload.order_id = _this.operateRef.currentOrder.order.id;
														payload.need_open = true;
														_context.next = 4;
														return _this.operateRef.openOrderCallBack(payload);

													case 4:
													case 'end':
														return _context.stop();
												}
											}
										}, _callee, _this);
									}));

									return function (_x) {
										return _ref.apply(this, arguments);
									};
								}(), function (data) {
									$17.swal({
										title: "修改訂單資訊發生錯誤",
										text: "",
										showCancelButton: false,
										type: "warning"
									});
								});

							case 6:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, _this);
			}))();
		}
	}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div></div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-406ade02", module.exports)
  } else {
    hotAPI.update("_v-406ade02", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/typeof":72,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785}],1276:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	props: {
		operateRef: {
			type: Object,
			default: function _default(rawProps) {
				return {};
			}
		}
	},
	methods: {
		operateBillSuccessCallBack: function operateBillSuccessCallBack(payload) {
			window.Event.$emit('fetch-member-history-orders');
			this.operateRef.modalClose();
			this.$emit('open-info', {
				status: 'show'
			});
			this.$store.dispatch('webadmin/crm/fetchMemberContract', payload.member_id);
		},
		operateBillFailCallBack: function operateBillFailCallBack(payload) {
			this.operateRef.modalClose();
			this.$emit('open-info', {
				status: 'show'
			});
		},
		operateInvoiceAllowanceSucceedCallBack: function operateInvoiceAllowanceSucceedCallBack(payload) {
			this.operateRef.modalClose();
			this.$emit('open-info', {
				status: 'show'
			});
		},
		operateInvoiceIssueSucceedCallBack: function operateInvoiceIssueSucceedCallBack(payload) {
			this.operateRef.modalClose();
			this.$emit('open-info', {
				status: 'show'
			});
		},
		operateInvoiceIssueFailedCallBack: function operateInvoiceIssueFailedCallBack(payload) {
			this.operateRef.modalClose();
			this.$emit('open-info', {
				status: 'show'
			});
		},
		operateRefundSuccessCallBack: function operateRefundSuccessCallBack(payload) {
			window.Event.$emit('fetch-member-history-orders');
			this.operateRef.modalClose({
				order: {
					id: payload.order_id
				}
			});
			this.$emit('open-info', {
				status: 'show'
			});
		},
		operateRefundFailCallBack: function operateRefundFailCallBack(payload) {
			this.operateRef.modalClose();
			this.$emit('open-info', {
				status: 'show'
			});
		},
		operateRefundCancelCallBack: function operateRefundCancelCallBack(payload) {
			this.operateRef.modalClose();
		},
		operateCancelSuccessCallBack: function operateCancelSuccessCallBack() {
			this.operateRef.modalClose();
		},
		operateInvalidSuccessCallBack: function operateInvalidSuccessCallBack(payload) {
			$17.swal({
				title: '操作成功',
				text: '',
				type: 'success',
				showCancelButton: false
			});
			this.openOrderCallBack(payload);
		},
		openOrderCallBack: function openOrderCallBack(payload) {
			var _this = this;

			return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.next = 2;
								return _this.operateRef.openOrderCallBack(payload);

							case 2:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		},
		openRefundModalCallBack: function openRefundModalCallBack(payload) {
			var _this2 = this;

			return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
				return _regenerator2.default.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								_this2.operateRef.$refs.orderOperate.operateType = 'refund';
								_this2.operateRef.$refs.orderOperate.resetModeData('refund');
								_this2.$nextTick(function () {
									_this2.operateRef.$refs.orderOperate.$refs.refundMode.execGetOrder();
								});

							case 3:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, _this2);
			}))();
		}
	}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div></div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-88bba3ca", module.exports)
  } else {
    hotAPI.update("_v-88bba3ca", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785}],1277:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        operateRef: {
            type: Object,
            default: function _default(rawProps) {
                return {};
            }
        },
        eventOptionalData: {
            type: Object,
            default: function _default(rawProps) {
                return {};
            }
        },
        eventScope: {
            default: 'webadmin'
        }
    },
    data: function data() {
        var vm = this;
        return {
            component: 'webadmin-order-operate-event-slot-general-utility',
            eventType: 'general',
            handlers: {
                "System.Pos.Order.BillSucceed": function SystemPosOrderBillSucceed(data) {
                    if (!vm.isNeedFireEvent()) {
                        return;
                    }
                    vm.fireAutoPrint(data);
                    vm.$refs.eventComponent.operateBillSuccessCallBack(data);
                },
                "System.Pos.Order.BillFailed": function SystemPosOrderBillFailed(data) {
                    if (!vm.isNeedFireEvent()) {
                        return;
                    }
                    vm.$refs.eventComponent.operateBillFailCallBack(data);
                },
                "System.Pos.Invoice.IssueSucceed": function SystemPosInvoiceIssueSucceed(data) {
                    if (!vm.isNeedFireEvent()) {
                        return;
                    }
                    vm.$refs.eventComponent.operateInvoiceIssueSucceedCallBack(data);
                },
                "System.Pos.Invoice.IssueFailed": function SystemPosInvoiceIssueFailed(data) {
                    if (!vm.isNeedFireEvent()) {
                        return;
                    }
                    vm.$refs.eventComponent.operateInvoiceIssueFailedCallBack(data);
                },
                "System.Pos.Invoice.AllowanceSucceed": function SystemPosInvoiceAllowanceSucceed(data) {
                    if (!vm.isNeedFireEvent()) {
                        return;
                    }
                    vm.$refs.eventComponent.operateInvoiceAllowanceSucceedCallBack(data);
                },
                "System.Pos.Order.RefundSuccess": function SystemPosOrderRefundSuccess(data) {
                    if (!vm.isNeedFireEvent()) {
                        return;
                    }
                    vm.$refs.eventComponent.operateRefundSuccessCallBack(data);
                },
                "System.Pos.Order.RefundFail": function SystemPosOrderRefundFail(data) {
                    if (!vm.isNeedFireEvent()) {
                        return;
                    }
                    vm.$refs.eventComponent.operateRefundFailCallBack(data);
                },
                "System.Pos.Order.RefundCancel": function SystemPosOrderRefundCancel(data) {
                    if (!vm.isNeedFireEvent()) {
                        return;
                    }
                    vm.$refs.eventComponent.operateRefundCancelCallBack(data);
                },
                "System.Pos.Order.CancelSuccess": function SystemPosOrderCancelSuccess(data) {
                    if (!vm.isNeedFireEvent()) {
                        return;
                    }
                    vm.$refs.eventComponent.operateCancelSuccessCallBack(data);
                },
                "System.Pos.Order.InvalidSuccess": function SystemPosOrderInvalidSuccess(data) {
                    if (!vm.isNeedFireEvent()) {
                        return;
                    }
                    vm.$refs.eventComponent.operateInvalidSuccessCallBack(data);
                },
                "System.Pos.Order.Open": function SystemPosOrderOpen(data) {
                    if (typeof data.event_type != 'undefined') {
                        vm.eventType = data.event_type;
                    } else {
                        vm.eventType = 'general';
                    }

                    if (!vm.isNeedFireEvent()) {
                        return;
                    }

                    this.$forceUpdate();
                    if (typeof data.event_calls != 'undefined') {
                        vm.$refs.eventComponent.eventCalls = data.event_calls;
                    }

                    this.$nextTick(function () {
                        vm.$refs.eventComponent.openOrderCallBack(data);
                    });
                },
                "System.Pos.Order.StartRefund": function () {
                    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(data) {
                        return _regenerator2.default.wrap(function _callee$(_context) {
                            while (1) {
                                switch (_context.prev = _context.next) {
                                    case 0:
                                        _context.next = 2;
                                        return vm.$refs.eventComponent.openRefundModalCallBack(data, vm.eventOptionalData);

                                    case 2:
                                    case 'end':
                                        return _context.stop();
                                }
                            }
                        }, _callee, this);
                    }));

                    function SystemPosOrderStartRefund(_x) {
                        return _ref.apply(this, arguments);
                    }

                    return SystemPosOrderStartRefund;
                }()
            }
        };
    },

    computed: (0, _extends3.default)({
        alertModelId: function alertModelId() {
            if (this.eventScope == 'sideBar') {
                return 'order-multi-alert-sidebar-operate-modal';
            }

            return 'order-multi-alert-operate-modal';
        }
    }, (0, _vuex.mapState)({
        autoPrintConfig: function autoPrintConfig(state) {
            return state.webadmin.webLocalSetting.printerSetting;
        }
    })),
    mounted: function mounted() {
        window.Event.$on("System.Pos.Order.BillSucceed", this.handlers["System.Pos.Order.BillSucceed"]);
        window.Event.$on("System.Pos.Order.BillFailed", this.handlers["System.Pos.Order.BillFailed"]);
        window.Event.$on("System.Pos.Invoice.IssueSucceed", this.handlers["System.Pos.Invoice.IssueSucceed"]);
        window.Event.$on("System.Pos.Invoice.IssueFailed", this.handlers["System.Pos.Invoice.IssueFailed"]);
        window.Event.$on("System.Pos.Invoice.AllowanceSucceed", this.handlers["System.Pos.Invoice.AllowanceSucceed"]);
        window.Event.$on("System.Pos.Order.RefundSuccess", this.handlers["System.Pos.Order.RefundSuccess"]);
        window.Event.$on("System.Pos.Order.RefundFail", this.handlers["System.Pos.Order.RefundFail"]);
        window.Event.$on("System.Pos.Order.RefundCancel", this.handlers["System.Pos.Order.RefundCancel"]);
        window.Event.$on("System.Pos.Order.CancelSuccess", this.handlers["System.Pos.Order.CancelSuccess"]);
        window.Event.$on("System.Pos.Order.InvalidSuccess", this.handlers["System.Pos.Order.InvalidSuccess"]);
        window.Event.$on("System.Pos.Order.Open", this.handlers["System.Pos.Order.Open"]);
        window.Event.$on("System.Pos.Order.StartRefund", this.handlers["System.Pos.Order.StartRefund"]);
    },
    destroyed: function destroyed() {
        window.Event.$off("System.Pos.Order.BillSucceed", this.handlers["System.Pos.Order.BillSucceed"]);
        window.Event.$off("System.Pos.Order.BillFailed", this.handlers["System.Pos.Order.BillFailed"]);
        window.Event.$off("System.Pos.Invoice.IssueSucceed", this.handlers["System.Pos.Invoice.IssueSucceed"]);
        window.Event.$off("System.Pos.Invoice.IssueFailed", this.handlers["System.Pos.Invoice.IssueFailed"]);
        window.Event.$off("System.Pos.Invoice.AllowanceSucceed", this.handlers["System.Pos.Invoice.AllowanceSucceed"]);
        window.Event.$off("System.Pos.Order.RefundSuccess", this.handlers["System.Pos.Order.RefundSuccess"]);
        window.Event.$off("System.Pos.Order.RefundFail", this.handlers["System.Pos.Order.RefundFail"]);
        window.Event.$off("System.Pos.Order.RefundCancel", this.handlers["System.Pos.Order.RefundCancel"]);
        window.Event.$off("System.Pos.Order.CancelSuccess", this.handlers["System.Pos.Order.CancelSuccess"]);
        window.Event.$off("System.Pos.Order.InvalidSuccess", this.handlers["System.Pos.Order.InvalidSuccess"]);
        window.Event.$off("System.Pos.Order.Open", this.handlers["System.Pos.Order.Open"]);
        window.Event.$off("System.Pos.Order.StartRefund", this.handlers["System.Pos.Order.StartRefund"]);
    },
    unmounted: function unmounted() {
        //需要時再呼叫 暫時沒有用到 
        //for 會清除modal element 時使用 ex:side-bar 暫未加上去
        window.Event.$off('System.Pos.Order.BillSucceed');
        window.Event.$off('System.Pos.Order.BillFailed');
        window.Event.$off('System.Pos.Invoice.IssueSucceed');
        window.Event.$off('System.Pos.Invoice.IssueFailed');
        window.Event.$off('System.Pos.Invoice.AllowanceSucceed');
        window.Event.$off('System.Pos.Order.RefundSuccess');
        window.Event.$off('System.Pos.Order.RefundFail');
        window.Event.$off('System.Pos.Order.RefundCancel');
        window.Event.$off('System.Pos.Order.CancelSuccess');
        window.Event.$off('System.Pos.Order.InvalidSuccess');
        window.Event.$off('System.Pos.Order.Open');
        window.Event.$off('System.Pos.Order.StartRefund');
    },

    watch: {
        eventType: function () {
            var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(val, oldVal) {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.t0 = val;
                                _context2.next = _context2.t0 === 'general' ? 3 : _context2.t0 === 'autoPay' ? 5 : _context2.t0 === 'crmOrder' ? 7 : _context2.t0 === 'crmCreate' ? 9 : _context2.t0 === 'serviceBooking' ? 11 : _context2.t0 === 'checkStudio' ? 13 : _context2.t0 === 'refundRequest' ? 15 : 17;
                                break;

                            case 3:
                                this.component = 'webadmin-order-operate-event-slot-general-utility';
                                return _context2.abrupt('break', 18);

                            case 5:
                                this.component = 'webadmin-order-operate-event-slot-auto-pay-utility';
                                return _context2.abrupt('break', 18);

                            case 7:
                                this.component = 'webadmin-order-operate-event-slot-crm-order-utility';
                                return _context2.abrupt('break', 18);

                            case 9:
                                this.component = 'webadmin-order-operate-event-slot-crm-create-utility';
                                return _context2.abrupt('break', 18);

                            case 11:
                                this.component = 'webadmin-order-operate-event-slot-service-booking-utility';
                                return _context2.abrupt('break', 18);

                            case 13:
                                this.component = 'webadmin-order-operate-event-slot-check-studio-utility';
                                return _context2.abrupt('break', 18);

                            case 15:
                                this.component = 'webadmin-order-operate-event-slot-refund-request-utility';
                                return _context2.abrupt('break', 18);

                            case 17:
                                return _context2.abrupt('break', 18);

                            case 18:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function eventType(_x2, _x3) {
                return _ref2.apply(this, arguments);
            }

            return eventType;
        }()
    },
    methods: {
        getEventTypeScope: function getEventTypeScope(eventType) {
            if (eventType == 'checkStudio') {
                return 'sideBar';
            }

            return 'webadmin';
        },
        isNeedFireEvent: function isNeedFireEvent() {
            if (this.getEventTypeScope(this.eventType) == this.eventScope) {
                return true;
            }

            return false;
        },
        openInfoWindow: function openInfoWindow(para) {
            $("#" + this.alertModelId).modal(para.status);
        },
        fireAutoPrint: function fireAutoPrint(data) {
            if (this.autoPrintConfig.auto_printer_status) {
                window.Event.$emit("System.Pos.Order.Print.AutoActive");
                this.$store.dispatch('webadmin/print/orderAutoPrint', {
                    orderId: data.order_id,
                    printConfig: this.autoPrintConfig
                });
            }
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<component ref=\"eventComponent\" :is=\"component\" :operate-ref=\"operateRef\" @open-info=\"openInfoWindow\"></component>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-1d053385", module.exports)
  } else {
    hotAPI.update("_v-1d053385", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vuex":803}],1278:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	props: {
		operateRef: {
			type: Object,
			default: function _default(rawProps) {
				return {};
			}
		}
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
		WebadminOrderEdit: function WebadminOrderEdit(state) {
			return store.state.webadmin.configure.webFunctions.WebadminOrderEdit;
		},
		is17fit: function is17fit(state) {
			return state.is_17fit;
		}
	})),
	methods: {
		operateBillSuccessCallBack: function operateBillSuccessCallBack(payload) {
			this.operateRef.modalClose();
			this.$emit('open-info', {
				status: 'show'
			});
		},
		operateBillFailCallBack: function operateBillFailCallBack(payload) {
			this.operateRef.modalClose();
			this.$emit('open-info', {
				status: 'show'
			});
		},
		operateInvoiceAllowanceSucceedCallBack: function operateInvoiceAllowanceSucceedCallBack(payload) {
			this.operateRef.modalClose();
			this.$emit('open-info', {
				status: 'show'
			});
		},
		operateInvoiceIssueSucceedCallBack: function operateInvoiceIssueSucceedCallBack(payload) {
			this.operateRef.modalClose();
			this.$emit('open-info', {
				status: 'show'
			});
		},
		operateInvoiceIssueFailedCallBack: function operateInvoiceIssueFailedCallBack(payload) {
			this.operateRef.modalClose();
			this.$emit('open-info', {
				status: 'show'
			});
		},
		operateRefundSuccessCallBack: function operateRefundSuccessCallBack(payload) {
			this.operateRef.modalClose({
				order: {
					id: payload.order_id
				}
			});
			this.$emit('open-info', {
				status: 'show'
			});
		},
		operateRefundFailCallBack: function operateRefundFailCallBack(payload) {
			this.operateRef.modalClose();
			this.$emit('open-info', {
				status: 'show'
			});
		},
		operateRefundCancelCallBack: function operateRefundCancelCallBack(payload) {
			this.operateRef.modalClose();
		},
		operateCancelSuccessCallBack: function operateCancelSuccessCallBack() {
			this.operateRef.modalClose();
		},
		operateInvalidSuccessCallBack: function operateInvalidSuccessCallBack(payload) {
			$17.swal({
				title: '操作成功',
				text: '',
				type: 'success',
				showCancelButton: false
			});
			this.openOrderCallBack(payload);
		},
		openOrderCallBack: function openOrderCallBack(payload) {
			if (this.is17fit && payload.mode == 'edit' && payload.order_id == '' || !this.WebadminOrderEdit) {
				$17.swal({
					title: '無使用權限',
					type: 'error',
					showCancelButton: false
				});
				return;
			}

			this.operateRef.openOrderCallBack(payload);
		},
		openRefundModalCallBack: function openRefundModalCallBack(payload) {
			var _this = this;

			return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_this.operateRef.$refs.orderOperate.operateType = 'refund';
								_this.operateRef.$refs.orderOperate.resetModeData('refund');
								_this.$nextTick(function () {
									_this.operateRef.$refs.orderOperate.$refs.refundMode.execGetOrder();
								});

							case 3:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		}
	}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div></div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-50de1638", module.exports)
  } else {
    hotAPI.update("_v-50de1638", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vuex":803}],1279:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _eventSlot = require('./event-slot.vue');

var _eventSlot2 = _interopRequireDefault(_eventSlot);

var _general = require('./general.vue');

var _general2 = _interopRequireDefault(_general);

var _autoPay = require('./auto-pay.vue');

var _autoPay2 = _interopRequireDefault(_autoPay);

var _crmOrder = require('./crm-order.vue');

var _crmOrder2 = _interopRequireDefault(_crmOrder);

var _crmCreate = require('./crm-create.vue');

var _crmCreate2 = _interopRequireDefault(_crmCreate);

var _serviceBooking = require('./service-booking.vue');

var _serviceBooking2 = _interopRequireDefault(_serviceBooking);

var _checkStudio = require('./check-studio.vue');

var _checkStudio2 = _interopRequireDefault(_checkStudio);

var _refundRequest = require('./refund-request.vue');

var _refundRequest2 = _interopRequireDefault(_refundRequest);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('webadmin-order-operate-event-slot-utility', _eventSlot2.default);
_vue2.default.component('webadmin-order-operate-event-slot-general-utility', _general2.default);
_vue2.default.component('webadmin-order-operate-event-slot-auto-pay-utility', _autoPay2.default);
_vue2.default.component('webadmin-order-operate-event-slot-crm-order-utility', _crmOrder2.default);
_vue2.default.component('webadmin-order-operate-event-slot-crm-create-utility', _crmCreate2.default);
_vue2.default.component('webadmin-order-operate-event-slot-service-booking-utility', _serviceBooking2.default);
_vue2.default.component('webadmin-order-operate-event-slot-check-studio-utility', _checkStudio2.default);
_vue2.default.component('webadmin-order-operate-event-slot-refund-request-utility', _refundRequest2.default);

},{"./auto-pay.vue":1273,"./check-studio.vue":1274,"./crm-create.vue":1275,"./crm-order.vue":1276,"./event-slot.vue":1277,"./general.vue":1278,"./refund-request.vue":1280,"./service-booking.vue":1281,"vue":792}],1280:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	props: {
		operateRef: {
			type: Object,
			default: function _default(rawProps) {
				return {};
			}
		}
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
		WebadminOrderEdit: function WebadminOrderEdit(state) {
			return store.state.webadmin.configure.webFunctions.WebadminOrderEdit;
		},
		is17fit: function is17fit(state) {
			return state.is_17fit;
		}
	})),
	methods: {
		operateRefundSuccessCallBack: function operateRefundSuccessCallBack(payload) {
			this.operateRef.modalClose({
				order: {
					id: payload.order_id
				}
			});
			this.$emit('open-info', {
				status: 'show'
			});
		},
		operateRefundFailCallBack: function operateRefundFailCallBack(payload) {
			this.operateRef.modalClose();
			this.$emit('open-info', {
				status: 'show'
			});
		},
		openOrderCallBack: function openOrderCallBack(payload) {
			if (this.is17fit && payload.mode == 'edit' && payload.order_id == '' || !this.WebadminOrderEdit) {
				$17.swal({
					title: '無使用權限',
					type: 'error',
					showCancelButton: false
				});
				return;
			}

			this.operateRef.openOrderCallBack(payload);
		},
		openRefundModalCallBack: function openRefundModalCallBack(payload, eventOptionalData) {
			var _this = this;

			return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_this.operateRef.$refs.orderOperate.operateType = 'refund';
								_this.operateRef.$refs.orderOperate.resetModeData('refund');
								_this.$nextTick(function () {
									_this.operateRef.$refs.orderOperate.$refs.refundMode.execGetOrder();
									_this.operateRef.$refs.orderOperate.$refs.refundMode.setDefaultData(eventOptionalData.refund);
								});

							case 3:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		}
	}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div></div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-36f33cee", module.exports)
  } else {
    hotAPI.update("_v-36f33cee", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vuex":803}],1281:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	props: {
		operateRef: {
			type: Object,
			default: function _default(rawProps) {
				return {};
			}
		}
	},
	data: function data() {
		return {
			bookingId: null
		};
	},

	methods: {
		operateBillSuccessCallBack: function operateBillSuccessCallBack(payload) {
			$('#service-booking-edit-modal').modal('hide');
			$('#service-booking-view-modal').modal('hide');
			this.operateRef.modalClose();
			$("#order-multi-alert-operate-modal").modal("show");
			window.Event.$emit('System.Booking.Checkout', this.bookingId);
			window.Event.$emit("System.Booking.Service.FreshList");
		},
		operateBillFailCallBack: function operateBillFailCallBack(payload) {
			$('#service-booking-edit-modal').modal('hide');
			$('#service-booking-view-modal').modal('hide');
			this.operateRef.modalClose();
			$("#order-multi-alert-operate-modal").modal("show");

			window.Event.$emit('System.Booking.Checkout', this.bookingId);
			window.Event.$emit("System.Booking.Service.FreshList");
		},
		operateInvalidSuccessCallBack: function operateInvalidSuccessCallBack() {
			this.operateRef.modalClose();
		},
		openOrderCallBack: function openOrderCallBack(payload) {
			var _this = this;

			return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_this.bookingId = payload.booking_id;
								_this.operateRef.openOrderCallBack(payload);

							case 2:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		}
	}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div></div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-690abe86", module.exports)
  } else {
    hotAPI.update("_v-690abe86", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785}],1282:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _orderOperate = require('./order-operate.vue');

var _orderOperate2 = _interopRequireDefault(_orderOperate);

var _operateModal = require('./operate-modal.vue');

var _operateModal2 = _interopRequireDefault(_operateModal);

var _editMode = require('./edit-mode.vue');

var _editMode2 = _interopRequireDefault(_editMode);

var _showMode = require('./show-mode.vue');

var _showMode2 = _interopRequireDefault(_showMode);

var _refundMode = require('./refund-mode.vue');

var _refundMode2 = _interopRequireDefault(_refundMode);

var _branchOperate = require('./branch-operate.vue');

var _branchOperate2 = _interopRequireDefault(_branchOperate);

var _memberOperate = require('./member-operate.vue');

var _memberOperate2 = _interopRequireDefault(_memberOperate);

var _memberOperateSelectorResult = require('./member-operate-selector-result.vue');

var _memberOperateSelectorResult2 = _interopRequireDefault(_memberOperateSelectorResult);

var _orderDetailStatus = require('./order-detail-status.vue');

var _orderDetailStatus2 = _interopRequireDefault(_orderDetailStatus);

var _orderRemark = require('./order-remark.vue');

var _orderRemark2 = _interopRequireDefault(_orderRemark);

var _orderSalesman = require('./order-salesman.vue');

var _orderSalesman2 = _interopRequireDefault(_orderSalesman);

var _orderSalesmanSetting = require('./order-salesman-setting.vue');

var _orderSalesmanSetting2 = _interopRequireDefault(_orderSalesmanSetting);

var _orderIssueMethod = require('./order-issue-method.vue');

var _orderIssueMethod2 = _interopRequireDefault(_orderIssueMethod);

var _commonlyUsedItems = require('./commonly-used-items.vue');

var _commonlyUsedItems2 = _interopRequireDefault(_commonlyUsedItems);

var _orderAlertItem = require('./order-alert-item.vue');

var _orderAlertItem2 = _interopRequireDefault(_orderAlertItem);

var _orderSelect = require('./order-select.vue');

var _orderSelect2 = _interopRequireDefault(_orderSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('./detail');
require('./payment');
require('./product');
require('./action-bar');
require('./event-slot');

//main
_vue2.default.component('webadmin-order-operate', _orderOperate2.default);
_vue2.default.component('webadmin-operate-modal', _operateModal2.default);

//mode
_vue2.default.component('webadmin-order-operate-edit-mode', _editMode2.default);
_vue2.default.component('webadmin-order-operate-show-mode', _showMode2.default);
_vue2.default.component('webadmin-order-operate-refund-mode', _refundMode2.default);

//utility
_vue2.default.component('webadmin-order-operate-branch-utility', _branchOperate2.default);
_vue2.default.component('webadmin-order-operate-member-utility', _memberOperate2.default);
_vue2.default.component('webadmin-order-detail-status-utility', _orderDetailStatus2.default);
_vue2.default.component('webadmin-order-operate-member-selector-result-utility', _memberOperateSelectorResult2.default);
_vue2.default.component('webadmin-order-operate-remark-utility', _orderRemark2.default);

_vue2.default.component('webadmin-order-operate-salesman-utility', _orderSalesman2.default);
_vue2.default.component('webadmin-order-operate-salesman-setting-utility', _orderSalesmanSetting2.default);

_vue2.default.component('webadmin-order-operate-order-issue-method-utility', _orderIssueMethod2.default);
_vue2.default.component('webadmin-commonly-used-items-utility', _commonlyUsedItems2.default);
_vue2.default.component('webadmin-order-alert-item-utility', _orderAlertItem2.default);
_vue2.default.component('webadmin-order-select-utility', _orderSelect2.default);

},{"./action-bar":1260,"./branch-operate.vue":1263,"./commonly-used-items.vue":1264,"./detail":1265,"./edit-mode.vue":1272,"./event-slot":1279,"./member-operate-selector-result.vue":1283,"./member-operate.vue":1284,"./operate-modal.vue":1285,"./order-alert-item.vue":1286,"./order-detail-status.vue":1287,"./order-issue-method.vue":1288,"./order-operate.vue":1289,"./order-remark.vue":1290,"./order-salesman-setting.vue":1291,"./order-salesman.vue":1292,"./order-select.vue":1293,"./payment":1299,"./product":1301,"./refund-mode.vue":1306,"./show-mode.vue":1310,"vue":792}],1283:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.reselect[_v-42afcaee] {\n  color: #C7C4C3; }\n\n/* line 5, stdin */\n.less-space[_v-42afcaee] {\n  margin-left: 5px; }\n\n/* line 9, stdin */\n.select-info > div[_v-42afcaee] {\n  float: left;\n  margin-right: 20px; }\n\n/* line 13, stdin */\n.select-info[_v-42afcaee]:after {\n  content: '';\n  display: block;\n  clear: both;\n  visibility: hidden;\n  height: 0; }\n\n/* line 20, stdin */\n.member-photo > img[_v-42afcaee] {\n  height: 60px; }\n")
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    resetMemberAction: Function,
    enableChangeMember: {
      default: false
    },
    data: {
      type: Object
    }
  },
  methods: {
    resetSelectMember: function resetSelectMember() {
      this.resetMemberAction && this.resetMemberAction(0);
    }
  }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"select-info\" _v-42afcaee=\"\">\n  <div class=\"member-photo\" _v-42afcaee=\"\">\n    <img :src=\"data.picture_path\" :alt=\"data.name\" _v-42afcaee=\"\">\n  </div>\n  <div _v-42afcaee=\"\">\n    <div class=\"name\" _v-42afcaee=\"\">{{data.name}}\n      <div @click=\"resetSelectMember\" class=\"reselect btn btn-default btn-xs\" v-if=\"enableChangeMember&amp;&amp;data.name!=''\" _v-42afcaee=\"\">\n        <i class=\"fa fa-times-circle\" aria-hidden=\"true\" _v-42afcaee=\"\"></i>\n        <span class=\"less-space\" _v-42afcaee=\"\">變更客戶</span>\n      </div>\n    </div>\n    <div class=\"phone\" v-if=\"data.is_walkin != 1\" _v-42afcaee=\"\">{{data.phone}}</div>\n    <div class=\"email\" v-if=\"data.is_walkin != 1\" _v-42afcaee=\"\">{{data.email}}</div>\n  </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.reselect[_v-42afcaee] {\n  color: #C7C4C3; }\n\n/* line 5, stdin */\n.less-space[_v-42afcaee] {\n  margin-left: 5px; }\n\n/* line 9, stdin */\n.select-info > div[_v-42afcaee] {\n  float: left;\n  margin-right: 20px; }\n\n/* line 13, stdin */\n.select-info[_v-42afcaee]:after {\n  content: '';\n  display: block;\n  clear: both;\n  visibility: hidden;\n  height: 0; }\n\n/* line 20, stdin */\n.member-photo > img[_v-42afcaee] {\n  height: 60px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-42afcaee", module.exports)
  } else {
    hotAPI.update("_v-42afcaee", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1284:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 3, stdin */\n.branchName[_v-2cfa998b] {\n  margin: 1em 0em;\n  font-size: 1em;\n  font-weight: bold; }\n\n/* line 8, stdin */\n.member-photo > img[_v-2cfa998b] {\n  height: 60px; }\n\n/* line 12, stdin */\n.show-member > div[_v-2cfa998b] {\n  float: left;\n  margin-right: 20px; }\n\n/* line 16, stdin */\n.show-member[_v-2cfa998b]:after {\n  content: '';\n  display: block;\n  clear: both;\n  visibility: hidden;\n  height: 0; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        'setting': {
            type: Object,
            default: function _default(rawProps) {
                return {
                    enableEdit: function enableEdit(data) {
                        return true;
                    } //false
                };
            }
        },
        settingData: {
            type: Object,
            default: function _default(rawProps) {
                return {};
            }
        },
        enableChangeMember: {
            default: true //之後要思考要不要放回Setting 中運算
        },
        'orderId': {
            default: ''
        },
        'memberData': {
            type: Object,
            default: function _default(rawProps) {
                return {
                    id: '',
                    picture_path: '',
                    name: '',
                    is_walkin: '',
                    phone: '',
                    email: ''
                };
            }
        }
    },
    data: function data() {
        return {
            ajaxing: false
        };
    },

    watch: {},
    beforeDestroy: function beforeDestroy() {
        this.$store.commit('filters/SETSTATUS', {
            'key': 'selected_search_member_id',
            value: null
        });
    },

    methods: {
        memberChange: function () {
            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(data) {
                var _this = this;

                var memberId;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                memberId = data.id ? data.id : 0;

                                this.ajaxing = true;
                                _context.next = 4;
                                return this.$http.post('/adminapi/pos/change_order_value/' + this.orderId, {
                                    'member_id': memberId
                                }).then(function (_ref2) {
                                    var data = _ref2.data;
                                }, function (data) {
                                    $17.swal({
                                        title: '修改訂單資訊發生錯誤',
                                        type: 'error',
                                        showCancelButton: false
                                    });
                                    _this.ajaxing = false;
                                });

                            case 4:
                                this.$emit("member-change", data);
                                if (memberId !== 0) {
                                    this.$store.commit('filters/SETSTATUS', {
                                        'key': 'selected_search_member_id',
                                        value: data.id
                                    });
                                    this.ajaxing = false;
                                } else {
                                    this.$store.commit('filters/SETSTATUS', {
                                        'key': 'selected_search_member_id',
                                        value: null
                                    });
                                    this.ajaxing = false;
                                }

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function memberChange(_x) {
                return _ref.apply(this, arguments);
            }

            return memberChange;
        }(),
        selectedAction: function selectedAction(e) {
            if (e.params.data.id) {
                this.memberChange(e.params.data);
            }
        },
        unselectedAction: function unselectedAction() {
            this.memberChange({
                id: null,
                photo: '',
                name: '',
                is_walkin: '',
                phone: '',
                email: ''
            });
        }
    },
    computed: {}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-2cfa998b=\"\">\n    <div class=\"row\" v-if=\"setting.enableEdit(settingData)\" _v-2cfa998b=\"\">\n        <div class=\"col-sm-6 -st-mt-5\" _v-2cfa998b=\"\">\n            <v-member-selector v-show=\"!ajaxing\" :member-change=\"memberChange\" :selected-action=\"selectedAction\" :unselected-action=\"unselectedAction\" _v-2cfa998b=\"\">\n                <webadmin-order-operate-member-selector-result-utility :reset-member-action=\"unselectedAction\" :enable-change-member=\"enableChangeMember\" :data=\"memberData\" _v-2cfa998b=\"\">\n                </webadmin-order-operate-member-selector-result-utility>\n            </v-member-selector>\n            <v-spinner-button class=\"st-mt-5 st-mb-2 st-ml-5\" :ajaxing=\"ajaxing\" _v-2cfa998b=\"\"></v-spinner-button>\n        </div>\n    </div>\n    <div class=\"row\" v-if=\"!setting.enableEdit(settingData)\" _v-2cfa998b=\"\">\n        <div class=\"col-sm-6\" _v-2cfa998b=\"\">\n            <div class=\"show-member\" _v-2cfa998b=\"\">\n                <div class=\"member-photo\" _v-2cfa998b=\"\">\n                    <img class=\"photo\" v-bind:src=\"memberData.picture_path\" alt=\"\" _v-2cfa998b=\"\">\n                </div>\n                <div _v-2cfa998b=\"\">\n                    <div class=\"name\" _v-2cfa998b=\"\">{{ memberData.name }}</div>\n                    <div class=\"phone\" v-if=\"!memberData.is_walkin\" _v-2cfa998b=\"\">{{ memberData.phone }}</div>\n                    <div class=\"email\" v-if=\"!memberData.is_walkin\" _v-2cfa998b=\"\">{{ memberData.email }}</div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 3, stdin */\n.branchName[_v-2cfa998b] {\n  margin: 1em 0em;\n  font-size: 1em;\n  font-weight: bold; }\n\n/* line 8, stdin */\n.member-photo > img[_v-2cfa998b] {\n  height: 60px; }\n\n/* line 12, stdin */\n.show-member > div[_v-2cfa998b] {\n  float: left;\n  margin-right: 20px; }\n\n/* line 16, stdin */\n.show-member[_v-2cfa998b]:after {\n  content: '';\n  display: block;\n  clear: both;\n  visibility: hidden;\n  height: 0; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-2cfa998b", module.exports)
  } else {
    hotAPI.update("_v-2cfa998b", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1285:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    closeModalEvent: Function,
    enableChangeMember: {
      default: false
    },
    id: {
      default: 'order-operate-modal'
    },
    eventScope: {
      default: 'webadmin'
    },
    shouldUseParallelModal: {
      default: true
    }
  },
  data: function data() {
    return {
      currentOrder: {
        order: {},
        branch: {},
        member: {},
        details: [],
        invoice: {},
        payments: []
      },
      type: ""
    };
  },

  watch: {},
  methods: {
    closeModalEventA: function closeModalEventA() {
      var _this = this;

      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                //暫時放在這邊
                window.Event.$emit("System.Pos.Order.CloseOrder", {
                  type: _this.type
                });
                _this.currentOrder = {
                  order: {},
                  branch: {},
                  member: {},
                  details: [],
                  invoice: {},
                  payments: []
                };
                _this.type = "";
                _context.next = 5;
                return _this.closeModalEvent;

              case 5:
                _context.t0 = _context.sent;

                if (!_context.t0) {
                  _context.next = 9;
                  break;
                }

                _context.next = 9;
                return _this.closeModalEvent();

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    modalClose: function modalClose(payload) {
      if (typeof payload != "undefined" && typeof payload.order != "undefined") {
        this.$refs.orderOperate.fetchOrderData.order_id = payload.order.id;
      }
      $("#" + this.modalId).modal("hide");
    },
    openOrderCallBack: function openOrderCallBack(payload) {
      var _this2 = this;

      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        var bind_auto_pay_plan_detail_id, openStatus, needOpen;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:

                $.blockUI();
                _this2.type = payload.mode;
                bind_auto_pay_plan_detail_id = payload.bind_auto_pay_plan_detail_id;

                if (!bind_auto_pay_plan_detail_id) {
                  bind_auto_pay_plan_detail_id = null;
                }
                _this2.currentOrder.order.id = payload.order_id;
                _context2.next = 7;
                return _this2.$refs.orderOperate.getOrder(_this2, {
                  payment_filter: payload.payment,
                  bind_auto_pay_plan_detail_id: bind_auto_pay_plan_detail_id
                });

              case 7:
                openStatus = _context2.sent;

                _this2.$refs.orderOperate.eventType = payload.event_type;
                needOpen = true;

                if (typeof payload.need_open != 'undefined') needOpen = payload.need_open;
                if (openStatus && needOpen) {
                  $("#" + _this2.modalId).modal("show");
                }
                $.unblockUI();

                return _context2.abrupt('return');

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
    WebadminOrderEdit: function WebadminOrderEdit(state) {
      return store.state.webadmin.configure.webFunctions.WebadminOrderEdit;
    },
    is17fit: function is17fit(state) {
      return state.is_17fit;
    }
  }), {
    currentOrderId: function currentOrderId() {
      return this.currentOrder.order ? this.currentOrder.order.id : "";
    },
    selectTypeIcon: function selectTypeIcon() {
      var typeIcon = this.currentOrder.order ? this.currentOrder.order.type : null;

      switch (typeIcon) {
        case 13:
          return "indeterminate_check_box";
          break;

        case 14:
          return "payments";
          break;

        case 17:
          return "auto_mode";
          break;

        default:
          break;
      }
    },
    selectOrderStatusName: function selectOrderStatusName() {
      return this.currentOrder.order ? this.currentOrder.order.status_name : "";
    },
    modalId: function modalId() {
      if (this.eventScope == 'sideBar') {
        return 'sidebar-operate-modal';
      }

      return 'order-operate-modal';
    }
  })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div>\n  <v-modal :id=\"modalId\" no-footer=\"\" :parallel-modal=\"shouldUseParallelModal\" open-size=\"modal-lg\" :close-modal-event=\"closeModalEventA\" body-class=\"st-py-0\">\n    <span slot=\"title\">\n      <div class=\"st-flex st-items-end\">\n        <span class=\"material-icons st-mr-1\">\n          {{ selectTypeIcon }}\n        </span>\n        <span class=\"st-text-gray-90 st-mx-1\"> 訂單 </span>\n        @{{ currentOrderId }}\n        <span class=\"st-mx-2\">|</span>\n        <span class=\"st-mr-2\">{{ selectOrderStatusName }}</span>\n        <v-admin-operate-record type=\"order\" :id=\"currentOrderId\" :additions=\"['checkout']\"></v-admin-operate-record>\n      </div>\n    </span>\n    <webadmin-order-operate v-if=\"currentOrder!={}\" ref=\"orderOperate\" :open-order-call-back=\"openOrderCallBack\" slot=\"body\" :default-type=\"type\" :default-order-data=\"currentOrder\" :event-scope=\"eventScope\"></webadmin-order-operate>\n  </v-modal>\n  <slot name=\"event\"></slot>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-cd7c414c", module.exports)
  } else {
    hotAPI.update("_v-cd7c414c", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vuex":803}],1286:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.modal-footer > .alert-item {\n  padding: 0px; }\n\n/* line 5, stdin */\n.alert-item {\n  border-bottom: 1px solid #C7C4C3;\n  padding: 20px 0px 15px 0px; }\n\n/* line 9, stdin */\n.alert-item:last-child {\n  border: 0px; }\n\n/* line 2, stdin */\n.action[_v-79fdc77d] {\n  margin-top: 20px; }\n\n/* line 6, stdin */\n.icon[_v-79fdc77d] {\n  margin-top: 5px; }\n\n/* line 9, stdin */\n.btn[_v-79fdc77d] {\n  margin-right: 5px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	props: {
		actionBtn: {
			default: 'btn-default'
		},
		statusWord: {
			default: ''
		},
		actionWord: {
			default: ''
		},
		actionFunction: {},
		detailTitle: {},
		detailContent: {},
		icon: {
			default: 'success'
		},
		orderId: {
			default: ''
		}
	},
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('webadmin/print', ['outputInvoice', 'previewInvoice', 'previewOrder', 'previewDiscountNote']), {
		action: function action(actionFunction) {
			switch (actionFunction) {
				case 'openOrder':
					$('#order-multi-alert-operate-modal').modal('hide');
					this.$emit('action-operate', {
						type: 'openOrder',
						orderId: this.orderId });
					break;
				case 'outputInvoice':
					this.outputInvoice(this.orderId);
					break;
				case 'printInvoice':
					this.previewInvoice({ orderId: this.orderId });
					break;
				case 'previewOrder':
					this.previewOrder({ orderId: this.orderId });
					break;
				case 'previewDiscountNote':
					this.previewDiscountNote({ orderId: this.orderId });
					break;
			}
		}
	})
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"alert-item\" _v-79fdc77d=\"\">\n\t<div class=\"row\" _v-79fdc77d=\"\">\n\t\t<div class=\"col-xs-2 text-right icon\" _v-79fdc77d=\"\">\n\t\t\t<i v-if=\"icon=='success'\" class=\"fa fa-check-circle fa-4x\" aria-hidden=\"true\" style=\"color:green\" _v-79fdc77d=\"\"></i>\n\t\t\t<i v-if=\"icon=='fail'\" class=\"fa fa-times-circle fa-4x\" aria-hidden=\"true\" style=\"color:red\" _v-79fdc77d=\"\"></i>\n\t\t</div>\n\t\t<div class=\"col-xs-4\" _v-79fdc77d=\"\">\n\t\t\t<h3 _v-79fdc77d=\"\">{{ statusWord }}</h3>\n\t\t</div>\n\t\t<div class=\"col-xs-6 action\" v-if=\"actionWord!=''\" _v-79fdc77d=\"\">\n\t\t\t<span v-if=\"Array.isArray(actionWord)\" _v-79fdc77d=\"\">\n\t\t\t\t\t<div class=\"btn\" v-for=\"(word,index) in actionWord\" :class=\"actionBtn\" @click=\"action(actionFunction[index])\" _v-79fdc77d=\"\">\n\t\t\t\t\t\t{{ word }}\n\t\t\t\t\t</div>\n\t\t\t</span>\n\t\t\t<span v-else=\"\" _v-79fdc77d=\"\">\n\t\t\t\t<div class=\"btn\" :class=\"actionBtn\" @click=\"action(actionFunction)\" _v-79fdc77d=\"\">\n\t\t\t\t\t{{ actionWord }}\n\t\t\t\t</div>\n\t\t\t</span>\n\t\t</div>\n\t</div>\n\t<div class=\"row\" v-if=\"detailTitle\" _v-79fdc77d=\"\">\n\t\t<div class=\"col-xs-10 col-xs-offset-2\" _v-79fdc77d=\"\">\n\t\t\t{{ detailTitle}}\n\t\t</div>\n\t</div>\n\t<div class=\"row\" v-if=\"detailContent\" _v-79fdc77d=\"\">\n\t\t<div class=\"col-xs-10 col-xs-offset-2\" _v-79fdc77d=\"\">\n\t\t\t{{ detailContent}}\n\t\t</div>\n\t</div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.modal-footer > .alert-item {\n  padding: 0px; }\n\n/* line 5, stdin */\n.alert-item {\n  border-bottom: 1px solid #C7C4C3;\n  padding: 20px 0px 15px 0px; }\n\n/* line 9, stdin */\n.alert-item:last-child {\n  border: 0px; }\n\n/* line 2, stdin */\n.action[_v-79fdc77d] {\n  margin-top: 20px; }\n\n/* line 6, stdin */\n.icon[_v-79fdc77d] {\n  margin-top: 5px; }\n\n/* line 9, stdin */\n.btn[_v-79fdc77d] {\n  margin-right: 5px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-79fdc77d", module.exports)
  } else {
    hotAPI.update("_v-79fdc77d", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1287:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 3, stdin */\n.status-col[_v-60667ae5] {\n  border: 2px solid #C7C4C3;\n  margin: 10px 0px -12px 0px;\n  padding: 10px 15px; }\n")
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    invoice: {
      type: Object,
      default: function _default(rawProps) {
        return {
          invoice_number: ""
        };
      }
    },
    order: {
      type: Object,
      default: function _default(rawProps) {
        return {
          origin_order_id: null
        };
      }
    },
    type: {
      default: ''
    }
  },
  data: function data() {
    return {};
  },

  watch: {},
  methods: {},
  computed: {}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-60667ae5=\"\">\n  <div v-if=\"invoice.invoice_number !== ''\" class=\"row\" _v-60667ae5=\"\">\n    <div class=\"col-sm-12\" _v-60667ae5=\"\">\n      <div class=\"status-col\" _v-60667ae5=\"\">\n        <span _v-60667ae5=\"\">已開立發票 {{ invoice.invoice_number }}</span>\n      </div>\n    </div>\n  </div>\n  <div v-if=\"order.origin_order_id !== null\" class=\"row\" _v-60667ae5=\"\">\n    <div class=\"col-sm-12\" _v-60667ae5=\"\">\n      <div class=\"status-col\" _v-60667ae5=\"\">\n        <span _v-60667ae5=\"\">原訂單: {{ order.origin_order_id }}</span>\n      </div>\n    </div>\n  </div>\n  <div v-if=\"type=='refund'\" class=\"row\" _v-60667ae5=\"\">\n    <div class=\"col-sm-12\" _v-60667ae5=\"\">\n      <div class=\"status-col\" _v-60667ae5=\"\">\n        <span _v-60667ae5=\"\">選擇退費項目</span>\n      </div>\n    </div>\n  </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 3, stdin */\n.status-col[_v-60667ae5] {\n  border: 2px solid #C7C4C3;\n  margin: 10px 0px -12px 0px;\n  padding: 10px 15px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-60667ae5", module.exports)
  } else {
    hotAPI.update("_v-60667ae5", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1288:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 3, stdin */\n.order-issue-love .multiselect, .order-issue-love .multiselect__content-wrapper {\n  width: 80%; }\n\n/* line 6, stdin */\n.order-issue-love .multiselect__content-wrapper {\n  overflow-x: hidden; }\n\n/* line 2, stdin */\n.row[_v-7bc58ba4] {\n  margin-bottom: 10px; }\n\n/* line 5, stdin */\n.issue_method_list[_v-7bc58ba4] {\n  margin-left: 15px;\n  margin-right: 15px; }\n  /* line 8, stdin */\n  .issue_method_list ul[_v-7bc58ba4] {\n    display: inline;\n    padding-left: 0; }\n    /* line 11, stdin */\n    .issue_method_list ul li[_v-7bc58ba4] {\n      display: inline-block;\n      padding-right: 10px; }\n\n/* line 17, stdin */\n#remark_height[_v-7bc58ba4] {\n  height: auto;\n  margin-right: 15px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        'setting': {
            type: Object,
            default: function _default(rawProps) {
                return {
                    enableEdit: function enableEdit(data) {
                        return true;
                    } //false
                };
            }
        },
        'invoice': {
            type: Object,
            default: function _default(rawProps) {
                return {
                    'order_invoice_active': false,
                    'issue_method_select': '',
                    'invoice_remark': ''
                };
            }
        },
        memberEmail: {
            type: String,
            default: ''
        },
        branchId: {
            type: Number,
            default: null
        },
        order: {
            type: Object,
            default: function _default(rawProps) {
                return {};
            }
        },
        settingData: {
            type: Object,
            default: function _default(rawProps) {
                return {};
            }
        },
        manualInvoiceNumber: {
            type: String,
            default: ''
        }
    },
    data: function data() {
        return {
            ajaxing: {
                remark: false,
                issueMethod: false,
                invoiceNumber: false
            },
            settingDefault: false,
            branchCharities: [],
            'invoice_issue_methods': {},
            'issue_method_select': '',
            'issue_method_carrier': {
                num: null,
                name: ''
            },
            'invoice_remark': '',
            'manual_invoice_number': null
        };
    },

    mounted: function mounted() {
        if (this.orderId) {
            this.getOrderIssueMethods();
            this.fetchBranchCharities(this.branchId);
            this.manual_invoice_number = this.manualInvoiceNumber;
        }
    },
    destroyed: function destroyed() {
        this.RESET_CARRIER();
        this.issue_method_select = '';
        this.invoice_issue_methods = {};
        this.invoice_remark = '';
        this.manual_invoice_number = '';
    },

    methods: {
        RESET_CARRIER: function RESET_CARRIER() {
            this.issue_method_carrier = {
                num: null,
                name: ''
            };
        },

        getOrderIssueMethods: function () {
            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                this.ajaxing.issueMethod = true;
                                _context.next = 3;
                                return this.getOrderIssueMethod();

                            case 3:
                                this.RESET_CARRIER();
                                this.ajaxing.issueMethod = false;
                                _context.next = 7;
                                return this.setDefaultMethod();

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function getOrderIssueMethods() {
                return _ref.apply(this, arguments);
            }

            return getOrderIssueMethods;
        }(),
        setDefaultMethod: function setDefaultMethod() {
            var _this = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                var defaultIndex;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _this.settingDefault = true;
                                defaultIndex = '';


                                $.each(_this.invoice_issue_methods, function (index, method) {
                                    if (method.is_default == 1) {

                                        _this.issue_method_select = index;
                                        defaultIndex = index;

                                        if (index == 'UBN') {
                                            _this.issue_method_carrier.num = method.data.UBN;
                                            _this.issue_method_carrier.name = method.data.name;
                                        } else if (index == 'LoveCode') {
                                            var love_code = method.data;
                                            _this.issue_method_carrier.num = _this.branchCharities.filter(function (charity) {
                                                if (charity.love_code == love_code) {
                                                    return charity;
                                                }
                                            })[0];
                                        } else {
                                            _this.issue_method_carrier.num = method.data;
                                        }
                                    }
                                });

                                if (!(_this.issue_method_select !== _this.invoice.issue_method_select)) {
                                    _context2.next = 6;
                                    break;
                                }

                                _context2.next = 6;
                                return _this.updateIssueMethod(defaultIndex);

                            case 6:

                                _this.settingDefault = false;

                            case 7:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this);
            }))();
        },
        updateIssueMethod: function updateIssueMethod(val) {
            var _this2 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                if (!(_this2.issue_method_select && val)) {
                                    _context3.next = 3;
                                    break;
                                }

                                _context3.next = 3;
                                return _this2.changeOrderIssueMethod();

                            case 3:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this2);
            }))();
        },
        checkShowMethod: function checkShowMethod(method) {
            if (method == 'CarrierPay2Go') {
                return this.memberEmail != '' ? true : false;
            }

            return true;
        },
        changeOrderIssueMethod: function changeOrderIssueMethod() {
            var _this3 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
                var num, payload;
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                if (_this3.setting.enableEdit(_this3.settingData)) {
                                    _context4.next = 2;
                                    break;
                                }

                                return _context4.abrupt('return');

                            case 2:
                                if (_this3.orderId) {
                                    _context4.next = 4;
                                    break;
                                }

                                return _context4.abrupt('return');

                            case 4:
                                if (_this3.invoice.order_invoice_active) {
                                    _context4.next = 6;
                                    break;
                                }

                                return _context4.abrupt('return');

                            case 6:
                                if (_this3.issue_method_select) {
                                    _context4.next = 8;
                                    break;
                                }

                                return _context4.abrupt('return');

                            case 8:
                                num = _this3.issue_method_carrier.num;

                                if (!(_this3.issue_method_select == "UBN" && !_this3.checkUBNLength(num))) {
                                    _context4.next = 12;
                                    break;
                                }

                                _this3.issue_method_carrier.num = '';

                                return _context4.abrupt('return');

                            case 12:

                                if (_this3.issue_method_select == "LoveCode" && _this3.issue_method_carrier.num) {
                                    num = _this3.issue_method_carrier.num.love_code;
                                }

                                payload = {
                                    'method': _this3.issue_method_select,
                                    'carrier_num': num,
                                    'carrier_name': _this3.issue_method_carrier.name
                                };

                                _this3.ajaxing.issueMethod = true;
                                _this3.$http.post('/adminapi/invoice/order/' + _this3.orderId + '/issue_method', payload).then(function (_ref2) {
                                    var data = _ref2.data;

                                    _this3.ajaxing.issueMethod = false;
                                    _this3.$emit('updated-issue-method');
                                    _this3.$emit('update-action-data', {
                                        type: 'invoice',
                                        data: (0, _extends3.default)({}, payload, {
                                            need_input: _this3.needInput
                                        })
                                    });
                                }, function (_ref3) {
                                    var data = _ref3.data;

                                    _this3.ajaxing.issueMethod = false;
                                    $17.swal({
                                        title: '修改發票開立方式發生錯誤',
                                        text: "",
                                        showCancelButton: false,
                                        type: 'warning'
                                    });
                                });

                            case 16:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this3);
            }))();
        },
        checkUBNLength: function checkUBNLength(UBNNumber) {
            if (UBNNumber && UBNNumber.length > 8) {
                $17.swal({
                    title: '統一編號不可超過 8 碼',
                    text: "",
                    showCancelButton: false,
                    type: 'warning'
                });
                return false;
            }

            return true;
        },
        invoiceRemark: function invoiceRemark(remark) {
            var _this4 = this;

            this.ajaxing.remark = true;
            //初始設定時不要送出去修改
            this.$http.post('/adminapi/invoice/order/' + this.orderId + '/remark', { remark: remark }).then(function (_ref4) {
                var data = _ref4.data;

                _this4.ajaxing.remark = false;
            }, function (_ref5) {
                var data = _ref5.data;

                _this4.ajaxing.remark = false;
                $17.swal({
                    title: '寫入發票備註發生錯誤',
                    text: "",
                    showCancelButton: false,
                    type: 'warning'
                });
            });
        },

        getOrderIssueMethod: function () {
            var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(order_id) {
                var _this5 = this;

                return _regenerator2.default.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.$http.get('/adminapi/invoice/order/' + this.orderId + '/issue_method').then(function (_ref7) {
                                    var data = _ref7.data;

                                    _this5.invoice_issue_methods = data.issue_method;
                                }, function (_ref8) {
                                    var data = _ref8.data;

                                    $17.swal({
                                        title: '取得發票開立方式發生錯誤',
                                        text: "",
                                        showCancelButton: false,
                                        type: 'warning'
                                    });
                                });

                            case 2:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function getOrderIssueMethod(_x) {
                return _ref6.apply(this, arguments);
            }

            return getOrderIssueMethod;
        }(),
        fetchBranchCharities: function fetchBranchCharities(branchId) {
            var _this6 = this;

            if (!branchId) {
                return;
            }
            this.$http.get('/adminapi/invoice_setting/charities/branch/' + branchId).then(function (_ref9) {
                var data = _ref9.data;

                _this6.branchCharities = data.list;
            });
        },
        checkValidPrintType: function checkValidPrintType() {
            return ['PrintCode', 'UBN'].indexOf(this.issue_method_select) != -1;
        },
        changeInvoiceNumber: function changeInvoiceNumber(invoiceNumber) {
            var _this7 = this;

            this.ajaxing.invoiceNumber = true;
            this.$http.post('/adminapi/pos/order/' + this.orderId + '/invoice_number', { invoiceNumber: invoiceNumber }).then(function (_ref10) {
                var data = _ref10.data;

                _this7.ajaxing.invoiceNumber = false;
            }, function (_ref11) {
                var data = _ref11.data;

                _this7.ajaxing.invoiceNumber = false;
                $17.swal({
                    title: '寫入發票號碼發生錯誤',
                    text: "",
                    showCancelButton: false,
                    type: 'warning'
                });
            });
        }
    },
    computed: {
        enableRemarkShow: function enableRemarkShow() {
            //探討要不要拔掉
            return this.checkValidPrintType() && this.invoice_remark != '';
        },
        issueActive: function issueActive() {
            return this.invoice.order_invoice_active && this.setting.enableEdit(this.settingData);
        },
        isIssued: function isIssued() {
            return this.invoice.is_issued;
        },
        orderId: function orderId() {
            return this.order.id;
        },
        needInput: function needInput() {
            var selectMethod = this.invoice_issue_methods[this.issue_method_select];
            if (typeof selectMethod != 'undefined') {
                return selectMethod.need_input;
            }
            return false;
        }
    },
    watch: {
        'issue_method_carrier.num': function issue_method_carrierNum(val) {
            if (!this.settingDefault && this.issue_method_select && val) {
                this.changeOrderIssueMethod();
            }
        },
        'issue_method_carrier.name': function issue_method_carrierName(val) {
            if (!this.settingDefault && this.issue_method_select && val) {
                this.changeOrderIssueMethod();
            }
        },
        issue_method_select: function () {
            var _ref12 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(val, oldVal) {
                return _regenerator2.default.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                if (!(!this.settingDefault && this.issue_method_select && oldVal)) {
                                    _context6.next = 4;
                                    break;
                                }

                                _context6.next = 3;
                                return this.RESET_CARRIER();

                            case 3:
                                this.changeOrderIssueMethod();

                            case 4:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function issue_method_select(_x2, _x3) {
                return _ref12.apply(this, arguments);
            }

            return issue_method_select;
        }(),
        branchId: function branchId(newVal) {
            if (!newVal) {
                return;
            }
            this.getOrderIssueMethods();
            this.fetchBranchCharities(newVal);
        },
        orderId: function orderId(newVal) {
            this.getOrderIssueMethods();
        },
        manual_invoice_number: function manual_invoice_number(newVal) {
            this.changeInvoiceNumber(newVal);
        },
        invoice_remark: function invoice_remark(newVal) {
            this.invoiceRemark(newVal);
        },
        invoice_issue_methods: function (_invoice_issue_methods) {
            function invoice_issue_methods(_x4) {
                return _invoice_issue_methods.apply(this, arguments);
            }

            invoice_issue_methods.toString = function () {
                return _invoice_issue_methods.toString();
            };

            return invoice_issue_methods;
        }(function (val) {
            switch (val) {
                case 'CarrierNPC':
                    this.issue_method_carrier.name = invoice_issue_methods['CarrierNPC']['data']['name'];
                    break;
                case 'CarrierPhone':
                    this.issue_method_carrier.name = invoice_issue_methods['CarrierPhone']['data']['name'];
                    break;
                case 'UBN':
                    this.issue_method_carrier.name = invoice_issue_methods['UBN']['data']['name'];
                    this.issue_method_carrier.num = invoice_issue_methods['UBN']['data']['UBN'];
                    break;
                default:
                    break;
            }
        }),

        'invoice.invoice_remark': function invoiceInvoice_remark(newVal) {
            this.invoice_remark = newVal;
        },
        manualInvoiceNumber: function manualInvoiceNumber(newVal) {
            this.manual_invoice_number = newVal;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"issue_method_list\" _v-7bc58ba4=\"\">\n    <div class=\"row\" v-if=\"!invoice.order_invoice_active &amp;&amp; order.total>0\" _v-7bc58ba4=\"\"><!--manual-->\n        <div class=\"col-xs-2\" _v-7bc58ba4=\"\">\n            <label for=\"\" class=\" text-right\" _v-7bc58ba4=\"\">輸入發票號碼</label>\n        </div>\n        <div class=\"col-xs-10\" _v-7bc58ba4=\"\">\n            <v-spinner-button :ajaxing=\"ajaxing.invoiceNumber\" _v-7bc58ba4=\"\"></v-spinner-button>\n            <input v-show=\"!ajaxing.invoiceNumber\" type=\"text\" v-model.lazy=\"manual_invoice_number\" maxlength=\"10\" minlength=\"10\" placeholder=\"輸入發票號碼\" _v-7bc58ba4=\"\">\n        </div> \n    </div>\n    <template v-if=\"(Object.keys(invoice_issue_methods).length > 0 &amp;&amp; order.total>0)\">\n    <div class=\"row\" v-if=\"issueActive &amp;&amp; !isIssued\" _v-7bc58ba4=\"\">\n        <div class=\"col-xs-2\" _v-7bc58ba4=\"\">\n            <label for=\"\" class=\" text-right\" _v-7bc58ba4=\"\">發票</label>\n        </div>\n        <div class=\"col-xs-10\" _v-7bc58ba4=\"\">\n            <v-spinner-button :ajaxing=\"ajaxing.issueMethod\" _v-7bc58ba4=\"\"></v-spinner-button>\n            <ul class=\"\" v-show=\"!ajaxing.issueMethod\" _v-7bc58ba4=\"\">\n                <li v-for=\"(invoice_issue_method,index) in invoice_issue_methods\" _v-7bc58ba4=\"\">\n                    <span v-if=\"checkShowMethod(invoice_issue_method.method)\" _v-7bc58ba4=\"\">\n                        <input type=\"radio\" :value=\"index\" v-model=\"issue_method_select\" :id=\"'invoice'+index\" _v-7bc58ba4=\"\">\n                        <label :for=\"'invoice'+index\" _v-7bc58ba4=\"\">{{ invoice_issue_method.name}}</label>\n                    </span>\n                </li>\n            </ul>\n        </div>  \n    </div>\n    <div class=\"row\" v-if=\"issueActive&amp;&amp;!ajaxing.issueMethod&amp;&amp; !isIssued\" _v-7bc58ba4=\"\">\n        <div class=\"col-xs-10 col-xs-offset-2 invoice-input\" _v-7bc58ba4=\"\">\n            <input type=\"text\" v-model.lazy=\"issue_method_carrier.num\" v-if=\"'CarrierNPC' == issue_method_select\" _v-7bc58ba4=\"\">\n            <input type=\"text\" v-model.lazy=\"issue_method_carrier.num\" v-if=\"'CarrierPhone' == issue_method_select\" _v-7bc58ba4=\"\">\n\n            <v-mutiselect class=\"order-issue-love\" v-if=\"'LoveCode' == issue_method_select\" :model.sync=\"issue_method_carrier.num\" :options=\"branchCharities\" :multiple=\"false\" :close-on-select=\"true\" :clear-on-select=\"true\" :searchable=\"true\" label=\"name\" track-by=\"love_code\" tag-name=\"name\" placeholder=\"請選擇\" _v-7bc58ba4=\"\">\n            </v-mutiselect>\n            <input type=\"text\" v-model.lazy=\"issue_method_carrier.name\" v-if=\"'UBN' == issue_method_select\" placeholder=\"請輸入抬頭\" _v-7bc58ba4=\"\">\n            <input type=\"text\" v-model.lazy=\"issue_method_carrier.num\" v-if=\"'UBN' == issue_method_select\" placeholder=\"請輸入統一編號\" maxlength=\"8\" _v-7bc58ba4=\"\">\n        </div>\n    </div>\n    <div v-if=\"invoice.order_invoice_active\" _v-7bc58ba4=\"\">\n        <v-spinner-button :ajaxing=\"ajaxing.remark\" _v-7bc58ba4=\"\"></v-spinner-button>\n        <!--edit-->\n        <div class=\"row\" v-if=\"!isIssued&amp;&amp;!ajaxing.remark&amp;&amp;setting.enableEdit(settingData)\" _v-7bc58ba4=\"\">\n            <div class=\"col-xs-2\" _v-7bc58ba4=\"\">\n                <label for=\"\" class=\" text-right\" _v-7bc58ba4=\"\">發票備註</label>\n            </div>\n            <div class=\"col-xs-10\" _v-7bc58ba4=\"\">\n                <input type=\"text\" name=\"\" id=\"remark_height\" placeholder=\"例如：信用卡後四碼，字數限制12字\" size=\"40\" maxlength=\"12\" v-model.lazy=\"invoice_remark\" _v-7bc58ba4=\"\">\n            </div>\n        </div>\n        <!--show-->\n        <div class=\"row match-table\" v-if=\"isIssued&amp;&amp;enableRemarkShow\" _v-7bc58ba4=\"\">\n            <div class=\"col-sm-6 \" _v-7bc58ba4=\"\">\n                <label for=\"\" class=\"match-left\" _v-7bc58ba4=\"\">發票備註：</label>\n            </div>\n            <div class=\"col-sm-6 text-right \" _v-7bc58ba4=\"\">\n                <div class=\"match-right\" _v-7bc58ba4=\"\">{{invoice_remark}}</div>\n            </div>\n        </div>\n    </div>\n    </template> \n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 3, stdin */\n.order-issue-love .multiselect, .order-issue-love .multiselect__content-wrapper {\n  width: 80%; }\n\n/* line 6, stdin */\n.order-issue-love .multiselect__content-wrapper {\n  overflow-x: hidden; }\n\n/* line 2, stdin */\n.row[_v-7bc58ba4] {\n  margin-bottom: 10px; }\n\n/* line 5, stdin */\n.issue_method_list[_v-7bc58ba4] {\n  margin-left: 15px;\n  margin-right: 15px; }\n  /* line 8, stdin */\n  .issue_method_list ul[_v-7bc58ba4] {\n    display: inline;\n    padding-left: 0; }\n    /* line 11, stdin */\n    .issue_method_list ul li[_v-7bc58ba4] {\n      display: inline-block;\n      padding-right: 10px; }\n\n/* line 17, stdin */\n#remark_height[_v-7bc58ba4] {\n  height: auto;\n  margin-right: 15px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-7bc58ba4", module.exports)
  } else {
    hotAPI.update("_v-7bc58ba4", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1289:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _values = require("babel-runtime/core-js/object/values");

var _values2 = _interopRequireDefault(_values);

var _paymentSetting = require("./payment-setting");

var PaymentSetting = _interopRequireWildcard(_paymentSetting);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    openOrderCallBack: {},
    enableEdit: {
      default: false
    },
    enableShow: {
      default: false
    },
    enableRefund: {
      default: false
    },
    defaultType: {
      default: ""
    },
    enableChangeMember: true,
    defaultOrderData: {
      type: Object,
      default: function _default(rawProps) {
        return {
          order: {},
          branch: {},
          member: {},
          details: [],
          invoice: {},
          payments: []
        };
      }
    },
    eventScope: {
      default: 'webadmin'
    }
  },
  data: function data() {
    return {
      alertObj: [],
      fetchOrderData: {
        order_id: "",
        member_id: ""
      },
      modeData: {
        mode: "EditModal",
        status: "Init",
        paymentEnums: ["Cash"]
      },
      operateType: "",
      eventType: 'general',
      autoPrintProcessed: false
    };
  },

  watch: {
    defaultType: function defaultType(newVal) {
      this.operateType = newVal;
      this.resetModeData(newVal);
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (typeof window.Event._events["System.Pos.Order.OpenBoughtTicket"] != 'undefined') {
      console.log("System.Pos.Order.OpenBoughtTicket exist");
    } else {
      console.log("System.Pos.Order.OpenBoughtTicket not exist");
    }
    window.Event.$on("System.Pos.Order.OpenBoughtTicket", function (detail) {
      _this.openBoughtTicket(detail.id);
    });
    window.Event.$on("System.Pos.Order.ShowOrderDetailWithProduct", function (detail) {
      _this.showOrderDetailWithProduct(detail);
    });
    window.Event.$on("System.Pos.Order.Print.AutoActive", function () {
      _this.autoPrintProcessed = true;
      setTimeout(function () {
        _this.autoPrintProcessed = false;
      }, 3000);
    });
    window.Event.$on("System.Pos.Order.CloseOrder", function (para) {
      if (_this.$refs[_this.currentRefsMode]) {
        _this.$refs[_this.currentRefsMode].close();
      } else {
        // 如果不存在，可以選擇採取其他動作或不執行任何操作
        console.warn("Ref with name " + _this.currentRefsMode + " does not exist close method.");
      }
    });
  },
  methods: {
    updateFetchData: function updateFetchData(data) {
      this.fetchOrderData.order_id = data.order_id;
      this.fetchOrderData.member_id = data.member_id;
      this.modeData.status = data.orderStatusEnum;
      this.modeData.paymentEnums = data.paymentEnums;
    },
    setAlertObj: function setAlertObj(alertObj) {
      this.alertObj = Array.isArray(alertObj) ? alertObj : (0, _values2.default)(alertObj);
    },
    openAlertCallBack: function openAlertCallBack(payload) {
      if (payload.type == "openOrder") {
        this.openOrderCallBack({
          event_type: this.eventType,
          mode: "show",
          order_id: payload.orderId
        });
      }
    },
    getOrder: function getOrder(vm, payload) {
      var _this2 = this;

      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var openStatus;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // bind_auto_pay_plan_detail_id
                $.blockUI({ timeout: 10000 });
                openStatus = false;
                _context.next = 4;
                return _this2.$http.get("/adminapi/pos/get-operate-order/order/" + vm.currentOrder.order.id, { params: payload }).then(function (_ref) {
                  var data = _ref.data;

                  vm.currentOrder = data;

                  _this2.updateModeData(vm.currentOrder);
                  openStatus = true;
                }, function (_ref2) {
                  var data = _ref2.data;

                  $17.swal({
                    title: data.message,
                    text: "",
                    showCancelButton: false,
                    type: "warning"
                  });

                  return false;
                });

              case 4:
                $.unblockUI();
                return _context.abrupt("return", openStatus);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    openBoughtTicket: function openBoughtTicket(detailId) {
      var _this3 = this;

      this.$http.get("/adminapi/pos/order_detail/" + detailId + "/bought_item").then(function (_ref3) {
        var data = _ref3.data;

        _this3.$refs.boughtItemTicket.boughtDetails = data;
      }, function (_ref4) {
        var data = _ref4.data;

        $17.swal({
          title: "取得訂單項目發生錯誤",
          text: "",
          showCancelButton: false,
          type: "warning"
        });
      });
      $("#order-operate-bought-ticket").modal("show");
    },
    showOrderDetailWithProduct: function showOrderDetailWithProduct(detail) {
      this.$refs.productItemShow.detail = detail;
      $("#order-operate-product-item-show").modal("show");
    },
    resetModeData: function resetModeData(type) {
      switch (type) {
        case "edit":
          this.modeData = {
            mode: "EditModal",
            status: "Init",
            paymentEnums: ["Cash"]
          };
          break;

        case "show":
          this.modeData = {
            mode: "ShowModal",
            status: "Completed",
            paymentEnums: ["Cash"]
          };
          break;

        case "refund":
          this.modeData = {
            mode: "RefundModal",
            status: "Init",
            paymentEnums: ["Cash"]
          };
          break;

        default:
          this.modeData = {
            mode: "EditModal",
            status: "Init",
            paymentEnums: ["Cash"]
          };
          break;
      }
    },
    updateModeData: function updateModeData(currentOrder) {
      var paymentEnums = currentOrder.payments.reduce(function (carry, payment) {
        carry.push(payment.system_enum);
        return carry;
      }, []);

      this.updateFetchData({
        order_id: currentOrder.order.id,
        member_id: currentOrder.order.member_id,
        orderStatusEnum: currentOrder.order.system_enum,
        paymentEnums: paymentEnums
      });
    }
  },
  computed: {
    editSetting: function editSetting() {
      if (!PaymentSetting) {
        return {};
      }

      var mode = this.modeData.mode;
      var status = this.modeData.status;
      var paymentEnums = this.modeData.paymentEnums;
      var paymentEnum = paymentEnums[0];

      if (typeof PaymentSetting[mode][status] == "undefined") {
        status = "Default";
      }
      if (typeof PaymentSetting[mode][status][paymentEnum] == "undefined") {
        // status = "Default";
        paymentEnum = "Default";
      }
      //未來如果有複合型的時候，boolean 可以直接運算後丟進去，Function 採用 callback 封裝下去跑多個函示
      return PaymentSetting[mode][status][paymentEnum];
    },
    alertModelId: function alertModelId() {
      if (this.eventScope == 'sideBar') {
        return 'order-multi-alert-sidebar-operate-modal';
      }

      return 'order-multi-alert-operate-modal';
    },
    footerAbj: function footerAbj() {
      return {
        actionFunction: "previewOrder",
        actionWord: this.autoPrintProcessed ? "列印處理中" : "列印全部",
        actionBtn: this.autoPrintProcessed ? "btn btn--inverse btn-default btn-lg" : "btn-success btn-lg",
        detailContent: "",
        detailTitle: "",
        icon: "",
        statusWord: "",
        disabled: this.autoPrintProcessed
      };
    },
    disabledMultiAlertModal: function disabledMultiAlertModal() {
      return this.autoPrintProcessed;
    },
    currentRefsMode: function currentRefsMode() {
      return this.operateType + 'Mode';
    }
  }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div>\n  <webadmin-order-operate-edit-mode v-if=\"operateType == 'edit'\" :enable-change-member=\"enableChangeMember\" :default-order-data=\"defaultOrderData\" :setting=\"editSetting\" :get-order=\"getOrder\" @set-alert-obj=\"setAlertObj\" :event-type=\"eventType\" ref=\"editMode\">\n  </webadmin-order-operate-edit-mode>\n\n  <webadmin-order-operate-show-mode v-if=\"operateType == 'show'\" :enable-change-member=\"enableChangeMember\" :default-order-data=\"defaultOrderData\" :setting=\"editSetting\" :get-order=\"getOrder\" @set-alert-obj=\"setAlertObj\" :event-type=\"eventType\" ref=\"showMode\">\n  </webadmin-order-operate-show-mode>\n\n  <webadmin-order-operate-refund-mode ref=\"refundMode\" v-if=\"operateType == 'refund'\" :enable-change-member=\"enableChangeMember\" :default-order-data=\"defaultOrderData\" :setting=\"editSetting\" :get-order=\"getOrder\" @set-alert-obj=\"setAlertObj\" :event-type=\"eventType\">\n  </webadmin-order-operate-refund-mode>\n\n  <webadmin-order-product-item-show-utility @fetch-bought-item=\"openBoughtTicket\" ref=\"productItemShow\"></webadmin-order-product-item-show-utility>\n  <webadmin-order-bought-item-ticket-utility @fetch-bought-item=\"openBoughtTicket\" ref=\"boughtItemTicket\"></webadmin-order-bought-item-ticket-utility>\n\n  <contract-edit :member-id=\"fetchOrderData.member_id\"></contract-edit>\n  <contract-time-edit :member-id=\"fetchOrderData.member_id\"></contract-time-edit>\n  <contract-point-edit :member-id=\"fetchOrderData.member_id\"></contract-point-edit>\n  <contract-status-edit :member-id=\"fetchOrderData.member_id\"></contract-status-edit>\n\n  <!--後續看要不要上抽-->\n  <v-multi-alert-model :model-title=\"'訂單 ' + fetchOrderData.order_id\" :alert-obj=\"alertObj\" :id=\"alertModelId\" :disabled-all-action=\"disabledMultiAlertModal\">\n    <template slot=\"body\">\n      <webadmin-order-alert-item-utility :key=\"index\" v-for=\"(alert, index) in alertObj\" :order-id=\"fetchOrderData.order_id\" :icon=\"alert.icon\" :status-word=\"alert.statusWord\" :action-word=\"alert.actionWord\" :action-function=\"alert.actionFunction\" :detail-title=\"alert.detailTitle\" :detail-content=\"alert.detailContent\" :action-btn=\"alert.actionBtn\" action-btn=\"btn-success btn-lg\" @action-operate=\"openAlertCallBack\">\n      </webadmin-order-alert-item-utility>\n    </template>\n    <template slot=\"footer\">\n      <webadmin-order-alert-item-utility :order-id=\"fetchOrderData.order_id\" :icon=\"footerAbj.icon\" :status-word=\"footerAbj.statusWord\" :action-word=\"footerAbj.actionWord\" :action-function=\"footerAbj.actionFunction\" :detail-title=\"footerAbj.detailTitle\" :detail-content=\"footerAbj.detailContent\" :action-btn=\"footerAbj.actionBtn\" :btn-disabled=\"footerAbj.disabled\" @action-operate=\"openAlertCallBack\">\n      </webadmin-order-alert-item-utility>\n    </template>\n  </v-multi-alert-model>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-15b3e7bb", module.exports)
  } else {
    hotAPI.update("_v-15b3e7bb", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"./payment-setting":1294,"babel-runtime/core-js/object/values":58,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785}],1290:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.row[_v-253d7899] {\n  margin-left: 0px;\n  margin-right: 0px; }\n\n/* line 7, stdin */\n#remark_height[_v-253d7899] {\n  height: auto;\n  margin-right: 15px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        'setting': {
            type: Object,
            default: function _default(rawProps) {
                return {
                    enableEdit: function enableEdit(data) {
                        return true;
                    } //false
                };
            }
        },
        'defaultRemark': {
            type: String,
            default: function _default(rawProps) {
                return '';
            }
        },
        'orderId': {
            type: String,
            default: function _default(rawProps) {
                return '';
            }
        },
        settingData: {
            type: Object,
            default: function _default(rawProps) {
                return {};
            }
        }
    },
    data: function data() {
        return {
            remark: ''
        };
    },

    methods: {
        orderRemark: function orderRemark() {
            var _this = this;

            this.$http.post('/adminapi/pos/order/' + this.orderId + '/remark', {
                remark: this.remark
            }).then(function (_ref) {
                var data = _ref.data;

                _this.$emit('remark-change', _this.orderId);
            }, function (_ref2) {
                var data = _ref2.data;

                $17.swal({
                    title: '寫入訂單備註發生錯誤',
                    type: 'error',
                    showCancelButton: false
                });
            });
        }
    },
    watch: {
        defaultRemark: {
            handler: function handler(newValue, oldValue) {
                this.remark = newValue;
            },

            deep: true
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"row\" _v-253d7899=\"\">\n    <div class=\"col-xs-2\" _v-253d7899=\"\">\n        <label for=\"\" class=\" text-right\" _v-253d7899=\"\">訂單備註</label>\n    </div>\n    <div class=\"col-xs-10\" v-if=\"setting.enableEdit(settingData)\" _v-253d7899=\"\">\n        <textarea name=\"\" id=\"remark_height\" rows=\"1\" placeholder=\"\" v-model.lazy=\"remark\" @change=\"orderRemark\" _v-253d7899=\"\"></textarea>\n    </div>\n    <div class=\"col-xs-10\" v-else=\"\" _v-253d7899=\"\">\n        {{defaultRemark}}\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.row[_v-253d7899] {\n  margin-left: 0px;\n  margin-right: 0px; }\n\n/* line 7, stdin */\n#remark_height[_v-253d7899] {\n  height: auto;\n  margin-right: 15px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-253d7899", module.exports)
  } else {
    hotAPI.update("_v-253d7899", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1291:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        orderSalesmen: {
            required: true,
            default: {}
        },
        studioId: {
            required: true,
            default: 0
        },
        salsemanVisible: {
            required: true
        },
        modelId: {
            required: true
        },
        customerServantTypeId: {},
        servantOperationType: {
            default: 'order'
        },
        typeString: {
            default: '業務代表'
        }
    },
    data: function data() {
        return {
            salesList: [{ 'label': this.typeString + '１',
                'branch': '',
                'selectedSales': '' }, { 'label': this.typeString + '２',
                'branch': '',
                'selectedSales': '' }, { 'label': this.typeString + '３',
                'branch': '',
                'selectedSales': '' }, { 'label': this.typeString + '４',
                'branch': '',
                'selectedSales': '' }, { 'label': this.typeString + '５',
                'branch': '',
                'selectedSales': '' }, { 'label': this.typeString + '６',
                'branch': '',
                'selectedSales': '' }],
            siteList: [],
            salsemenList: [],
            ajaxing: false
        };
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['isBranch', 'branchList'])),
    mounted: function mounted() {
        var _this = this;

        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (!(_this.studioId != 0)) {
                                _context.next = 4;
                                break;
                            }

                            _context.next = 3;
                            return _this.fetchBranchList({ studioId: _this.studioId });

                        case 3:
                            _this.getSalesList(_this.studioId);

                        case 4:
                            if (_this.branchList) {
                                _this.siteList = [{ id: 0, branch_name: '不限場館' }];
                                _this.siteList = _this.siteList.concat(_this.branchList);
                            }

                        case 5:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },

    watch: {
        studioId: function studioId(newV) {
            var _this2 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!newV) {
                                    _context2.next = 4;
                                    break;
                                }

                                _context2.next = 3;
                                return _this2.fetchBranchList({ 'studioId': newV });

                            case 3:
                                _this2.getSalesList(newV);

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        branchList: function branchList(newV) {
            if (newV) {
                this.siteList = [{ id: 0, branch_name: '不限場館' }];
                this.siteList = this.siteList.concat(newV);
            }
        },
        customerServantTypeId: function customerServantTypeId(newV) {
            this.getSalesList(this.studioId);
        },
        typeString: function typeString(newVal) {
            this.salesList = [{ 'label': newVal + '１',
                'branch': '',
                'selectedSales': '' }, { 'label': newVal + '２',
                'branch': '',
                'selectedSales': '' }, { 'label': newVal + '３',
                'branch': '',
                'selectedSales': '' }, { 'label': newVal + '４',
                'branch': '',
                'selectedSales': '' }, { 'label': newVal + '５',
                'branch': '',
                'selectedSales': '' }, { 'label': newVal + '６',
                'branch': '',
                'selectedSales': '' }];
        }
    },
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('webadmin/configure', ['fetchBranchList']), {
        closeModel: function closeModel() {
            // this.$refs.modal.closeModal();
            $(this.$el).modal('hide');
        },
        showModel: function showModel() {
            $(this.$el).modal('show');
        },
        getSalesList: function getSalesList(studioId) {
            var _this3 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.t0 = _this3.servantOperationType;
                                _context3.next = _context3.t0 === 'order' ? 3 : _context3.t0 === 'studio-member' ? 6 : 9;
                                break;

                            case 3:
                                _context3.next = 5;
                                return _this3.getOrderSalesList(studioId);

                            case 5:
                                return _context3.abrupt('break', 12);

                            case 6:
                                _context3.next = 8;
                                return _this3.getStudioMemberSalesList(studioId);

                            case 8:
                                return _context3.abrupt('break', 12);

                            case 9:
                                _context3.next = 11;
                                return _this3.getOrderSalesList(studioId);

                            case 11:
                                return _context3.abrupt('break', 12);

                            case 12:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3);
            }))();
        },
        getOrderSalesList: function getOrderSalesList(studioId) {
            var _this4 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return _this4.$http.get('/adminapi/salseman/getAllServant/' + studioId).then(function (response) {
                                    _this4.salsemenList = response.data.list;
                                });

                            case 2:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this4);
            }))();
        },
        getStudioMemberSalesList: function getStudioMemberSalesList(studioId) {
            var _this5 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5() {
                return _regenerator2.default.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                if (!(!_this5.customerServantTypeId || !studioId)) {
                                    _context5.next = 2;
                                    break;
                                }

                                return _context5.abrupt('return');

                            case 2:
                                _context5.next = 4;
                                return _this5.$http.get('/adminapi/servant/studio/' + studioId + '/customer_servant_type/' + _this5.customerServantTypeId + '/getAllServant').then(function (response) {
                                    _this5.salsemenList = response.data.list;
                                });

                            case 4:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this5);
            }))();
        },
        getBranchSalsemenList: function getBranchSalsemenList(branch) {
            if (this.salsemenList && branch) {
                return this.salsemenList[branch.id] || [];
            } else {
                return [];
            }
        },
        getSelectList: function getSelectList(index) {
            if (!this.orderSalesmen) return;
            var list = {};
            list.member_id = this.orderSalesmen['level_' + (index + 1) + '_member_id'];

            if (index === 0 && this.servantOperationType == 'order') {
                list.member_id = this.orderSalesmen.member_id;
            }

            list.branch_id = this.orderSalesmen['level_' + (index + 1) + '_member_branch_id'];
            return list;
        },
        isShowOrderSalesmen: function isShowOrderSalesmen(index) {
            if (!this.salsemanVisible) return;
            return this.salsemanVisible['level_' + (index + 1) + '_salesperson_visible'] || this.salsemanVisible['level_' + (index + 1) + '_visible'];
        },
        save: function save() {
            var _this6 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6() {
                return _regenerator2.default.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _this6.ajaxing = true;
                                _context6.t0 = _this6.servantOperationType;
                                _context6.next = _context6.t0 === 'order' ? 4 : _context6.t0 === 'studio-member' ? 7 : 10;
                                break;

                            case 4:
                                _context6.next = 6;
                                return _this6.orderSave();

                            case 6:
                                return _context6.abrupt('break', 13);

                            case 7:
                                _context6.next = 9;
                                return _this6.studioMemberSave();

                            case 9:
                                return _context6.abrupt('break', 13);

                            case 10:
                                _context6.next = 12;
                                return _this6.orderSave();

                            case 12:
                                return _context6.abrupt('break', 13);

                            case 13:

                                _this6.ajaxing = false;

                            case 14:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, _this6);
            }))();
        },
        studioMemberSave: function studioMemberSave() {
            var _this7 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7() {
                return _regenerator2.default.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return _this7.$http.post('/adminapi/servant/update/' + _this7.orderSalesmen.id, { salesList: _this7.salesList }).then(function (response) {
                                    _this7.$emit('refresh-salesmen-list');
                                    _this7.alert('儲存成功', '', 'success');
                                    _this7.closeModel();
                                }).catch(function (response) {
                                    _this7.alert('儲存失敗', '', 'error');
                                });

                            case 2:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, _this7);
            }))();
        },
        orderSave: function orderSave() {
            var _this8 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8() {
                return _regenerator2.default.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return _this8.$http.post('/adminapi/salseman/order/' + _this8.orderSalesmen.id, { salesList: _this8.salesList }).then(function (response) {
                                    _this8.$emit('refresh-salesmen-list');
                                    _this8.alert('儲存成功', '', 'success');
                                    _this8.closeModel();
                                }).catch(function (response) {
                                    _this8.alert('儲存失敗', '', 'error');
                                });

                            case 2:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, _this8);
            }))();
        },
        alert: function alert(title, message, type) {
            $17.swal({
                title: title,
                text: message,
                type: type,
                showCancelButton: false,
                showLoaderOnConfirm: true
            });
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal :id=\"modelId\" :block-hide-without-close=\"true\" parallel-modal=\"\" :keep-alive=\"false\">\n    <div slot=\"title\">\n        <h4 class=\"modal-title\">設定{{typeString}}</h4>\n    </div>\n    <div slot=\"body\">\n        <div class=\"m-top-30 m-bottom-30 m-right-30\" style=\"min-height: 250px\">\n            <div class=\"row m-bottom-15\" v-for=\"(sales, index) in salesList\" v-show=\"isShowOrderSalesmen(index)\">\n                <webadmin-salseman-branch-select :sales=\"sales\" :salsemen-list=\"salsemenList\" :site-list=\"siteList\" :is-level-select=\"getSelectList(index)\"></webadmin-salseman-branch-select>\n            </div>\n        </div>\n    </div>\n    <div slot=\"footer\">\n        <button type=\"button\" v-show=\"!ajaxing\" class=\"btn btn-default btn--inverse\" @click=\"closeModel\">取消</button>\n        <button type=\"button\" v-show=\"!ajaxing\" class=\"btn btn-info\" @click=\"save\">儲存更新</button>\n        <v-spinner-button :ajaxing=\"ajaxing\"></v-spinner-button>\n    </div>\n</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-0d58ebaa", module.exports)
  } else {
    hotAPI.update("_v-0d58ebaa", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1292:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.row[_v-04ccf2a7] {\n  margin-left: 0px;\n  margin-right: 0px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            salesmenData: {
                orderSalesmen: {},
                orderSalesmenFormat: {}
            },
            ajaxingChange: false,
            salsemanVisible: ''
        };
    },

    props: {
        orderId: {
            required: true
        },
        studioId: {
            required: true
        },
        modelId: {
            required: true
        },
        setting: {
            type: Object,
            default: function _default(rawProps) {
                return {
                    enableEdit: function enableEdit(data) {
                        return true;
                    } //false
                };
            }
        },
        settingData: {
            type: Object,
            default: function _default(rawProps) {
                return {};
            }
        }
    },
    mounted: function mounted() {
        if (this.orderId) {
            this.getSalesman(this.orderId);
        }
        if (this.studioId) {
            this.getSalesmanVisible(this.studioId);
        }
    },

    watch: {
        orderId: function orderId(_orderId) {
            if (!_orderId) {
                return;
            }
            this.getSalesman(_orderId);
        },
        studioId: function studioId(val) {
            if (val) {
                this.getSalesmanVisible(val);
            }
        }
    },
    methods: {
        getSalesman: function getSalesman(orderId) {
            var _this = this;

            this.ajaxingChange = false;
            this.$http.get('/adminapi/salseman/order/' + orderId).then(function (response) {
                _this.salesmenData = response.data;
                _this.ajaxingChange = true;
            });
        },
        getSalesmanVisible: function getSalesmanVisible(studioId) {
            var _this2 = this;

            this.$http.post('/adminapi/layout-setting/salesperson-visible/get', { 'studio_id': studioId }).then(function (response) {
                _this2.salsemanVisible = response.data.result;
            });
        },
        showSettingModal: function showSettingModal() {
            this.$refs.salesmanSetting.showModel();
        },
        refreshSalesmenList: function refreshSalesmenList() {
            this.getSalesman(this.orderId);
        },
        isShowOrderSalesmen: function isShowOrderSalesmen(index) {
            if (!this.salsemanVisible) return;
            return this.salsemanVisible['level_' + index + '_salesperson_visible'];
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['isBranch']), (0, _vuex.mapState)({
        WebadminPosSalsemanEditunpay: function WebadminPosSalsemanEditunpay(state) {
            return state.webadmin.configure.webFunctions.WebadminPosSalsemanEditunpay;
        }
    }))

};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"row st-flex st-items-center m-bottom-10\" _v-04ccf2a7=\"\">\n    <div class=\"col-xs-2\" _v-04ccf2a7=\"\">\n        <label class=\" text-right\" _v-04ccf2a7=\"\">業務代表</label>\n    </div>\n    <div class=\"col-xs-4\" _v-04ccf2a7=\"\">\n        <div class=\"btn btn-default btn-sm st-ml-0\" v-if=\"setting.enableEdit(settingData) &amp;&amp; ajaxingChange &amp;&amp; WebadminPosSalsemanEditunpay\" @click=\"showSettingModal\" _v-04ccf2a7=\"\">\n            設定\n        </div>\n        <div v-show=\"ajaxingChange &amp;&amp; isShowOrderSalesmen(index)\" v-for=\"(item, index) in salesmenData.orderSalesmenFormat\" _v-04ccf2a7=\"\">{{index}}. {{item.salseman}}:（{{item.site}}）</div>\n    </div>\n    <div class=\"col-xs-3\" _v-04ccf2a7=\"\">\n\n    </div>\n    <webadmin-order-operate-salesman-setting-utility :studio-id=\"studioId\" :order-salesmen=\"salesmenData.orderSalesmen\" @refresh-salesmen-list=\"refreshSalesmenList\" :salseman-visible=\"salsemanVisible\" :model-id=\"modelId\" ref=\"salesmanSetting\" _v-04ccf2a7=\"\"></webadmin-order-operate-salesman-setting-utility>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.row[_v-04ccf2a7] {\n  margin-left: 0px;\n  margin-right: 0px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-04ccf2a7", module.exports)
  } else {
    hotAPI.update("_v-04ccf2a7", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1293:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.fa-search[_v-6c24cc15] {\n  cursor: pointer; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        payment: {
            default: 0
        }
    },
    data: function data() {
        return {
            orderId: ''
        };
    },

    methods: {
        checkOrderPaymentStatus: function checkOrderPaymentStatus(payload) {
            var order = context.state.select_order;
            if (payload.payment == 1 && !order.payment_status || payload.payment == 0 && order.payment_status) {
                return false;
            };
            return true;
        },
        checkIsValidOrderId: function checkIsValidOrderId() {
            if (this.orderId.length != 10) {
                $17.swal({
                    title: '訂單編號輸入錯誤',
                    text: "",
                    type: 'warning',
                    showCancelButton: false,
                    confirmButtonText: '確定'
                });
                return false;
            }
            return true;
        },
        openOrder: function openOrder() {
            var status = this.checkIsValidOrderId();
            var payload = { 'order_id': this.orderId };
            if (status) {
                if (this.payment == 1) {
                    payload.mode = "show";
                } else {
                    payload.mode = "edit";
                }
                payload.event_type = 'general';
                this.$emit('open-operate-order', payload);
            }
        }
    },
    computed: {}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"order-search input-group\" _v-6c24cc15=\"\">\n  <input type=\"text\" class=\"form-control\" placeholder=\"訂單編號\" v-model=\"orderId\" @keyup.enter=\"openOrder\" _v-6c24cc15=\"\">\n  <span class=\"input-group-addon\" _v-6c24cc15=\"\">\n    <div class=\"\" @click=\"openOrder\" _v-6c24cc15=\"\"><i class=\"fa fa-search\" _v-6c24cc15=\"\"></i></div>\n  </span>\n</div><!-- /input-group -->\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.fa-search[_v-6c24cc15] {\n  cursor: pointer; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-6c24cc15", module.exports)
  } else {
    hotAPI.update("_v-6c24cc15", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1294:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RefundModal = exports.ShowModal = exports.EditModal = undefined;

var _paymentSettingEdit = require('././setting/payment-setting-edit.js');

var _paymentSettingEdit2 = _interopRequireDefault(_paymentSettingEdit);

var _paymentSettingShow = require('././setting/payment-setting-show.js');

var _paymentSettingShow2 = _interopRequireDefault(_paymentSettingShow);

var _paymentSettingRefund = require('././setting/payment-setting-refund.js');

var _paymentSettingRefund2 = _interopRequireDefault(_paymentSettingRefund);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.EditModal = _paymentSettingEdit2.default;
exports.ShowModal = _paymentSettingShow2.default;
exports.RefundModal = _paymentSettingRefund2.default;

},{"././setting/payment-setting-edit.js":1307,"././setting/payment-setting-refund.js":1308,"././setting/payment-setting-show.js":1309}],1295:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\nul[_v-d3f7204c] {\n  padding-left: 0px; }\n\n/* line 5, stdin */\nli[_v-d3f7204c] {\n  list-style-type: none;\n  display: inline-block;\n  padding-left: 10px; }\n\n/* line 10, stdin */\n.row[_v-d3f7204c] {\n  margin-left: 0px;\n  margin-right: 0px; }\n\n/* line 14, stdin */\n.underline[_v-d3f7204c] {\n  text-decoration: underline; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vuex = require('vuex');

exports.default = {
    data: function data() {
        return {
            ajaxing: false,
            ajaxingChange: false,
            branch_payment_methods: [],
            studio_payment_methods: [],
            payment_method_select: null,
            customUserInput: {
                key: ''
            },
            creditInput: {
                'auth_type': 'input',
                'exist_main_card': 0,
                'main_card_num': '',
                'credit_num': '',
                'expi_mon': '',
                'expi_year': '',
                'cvs': '',
                'is_checked': false,
                'auto_pay_card_num': '',
                'exist_auto_pay_cards': false
            }
        };
    },
    mounted: function mounted() {
        if (this.studioId) {
            this.getStudioPaymentMethod(this.studioId);
        }
        if (this.payment && this.payment.selected_method_id) {
            this.changeDefaultPayment();
        }
    },

    props: {
        payments: {
            type: Array,
            default: function _default(rawProps) {
                return {};
            }
        },
        paymentMethodHeader: {
            type: String,
            default: '支付方式'
        },
        allowShowVerificationAppropriationSum: {
            type: Boolean,
            default: false,
            description: '是否顯示核銷/撥款金額'
        }
    },
    methods: {
        allowPaymentType: function allowPaymentType(id, type) {
            return type.indexOf(id) > -1;
        }
    },
    computed: {},
    watch: {}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-d3f7204c=\"\">\n    <div class=\"row\" _v-d3f7204c=\"\">\n        <div class=\"col-xs-2\" _v-d3f7204c=\"\">\n            <label for=\"\" class=\" text-right\" _v-d3f7204c=\"\">{{ paymentMethodHeader }}</label>\n        </div>\n        <div class=\"col-xs-10\" _v-d3f7204c=\"\">\n            <div class=\"st-flex st-items-center\" _v-d3f7204c=\"\">\n                <div v-for=\"payment in payments\" _v-d3f7204c=\"\">\n                    <label class=\"edit-label\" _v-d3f7204c=\"\">{{ payment.selected_method_name }} </label>\n                    <span v-if=\"allowShowVerificationAppropriationSum &amp;&amp; allowPaymentType(payment.payment_type_id,[2])\" style=\"color: red\" _v-d3f7204c=\"\">\n                        （已核銷：{{ payment.verification_appropriation.verification_sum }}／已撥款指示：{{ payment.verification_appropriation.appropriation_sum }}）\n                    </span>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\nul[_v-d3f7204c] {\n  padding-left: 0px; }\n\n/* line 5, stdin */\nli[_v-d3f7204c] {\n  list-style-type: none;\n  display: inline-block;\n  padding-left: 10px; }\n\n/* line 10, stdin */\n.row[_v-d3f7204c] {\n  margin-left: 0px;\n  margin-right: 0px; }\n\n/* line 14, stdin */\n.underline[_v-d3f7204c] {\n  text-decoration: underline; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-d3f7204c", module.exports)
  } else {
    hotAPI.update("_v-d3f7204c", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1296:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\nul[_v-09e419ba] {\n  padding-left: 0px; }\n\n/* line 5, stdin */\nli[_v-09e419ba] {\n  list-style-type: none;\n  display: inline-block;\n  padding-right: 10px; }\n\n/* line 10, stdin */\n.row[_v-09e419ba] {\n  margin-left: 0px;\n  margin-right: 0px; }\n\n/* line 14, stdin */\n.underline[_v-09e419ba] {\n  text-decoration: underline; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            ajaxing: false,
            ajaxingChange: false,
            branch_payment_methods: [],
            studio_payment_methods: [],
            payment_method_select: null,
            customUserInput: {
                key: ''
            },
            creditInput: {
                'auth_type': 'input',
                'exist_main_card': 0,
                'main_card_num': '',
                'credit_num': '',
                'expi_mon': '',
                'expi_year': '',
                'cvs': '',
                'is_checked': false,
                'auto_pay_card_num': '',
                'exist_auto_pay_cards': false
            }
        };
    },
    mounted: function mounted() {
        if (this.studioId) {
            this.getStudioPaymentMethod(this.studioId);
        }
        if (this.payment.selected_method_id) {
            this.changeDefaultPayment();
        }
    },

    props: {
        'setting': {
            type: Object,
            default: function _default(rawProps) {
                return {
                    enableEdit: function enableEdit(data) {
                        return true;
                    }, //false
                    moneyPaymentChange: true //false
                };
            }
        },
        'payment': {
            type: Object,
            default: function _default(rawProps) {
                return {
                    selected_method_id: '',
                    selected_method_name: ''
                };
            }
        },
        'verification_appropriation': {
            type: Object,
            default: function _default(rawProps) {
                return {
                    verification_sum: 0,
                    appropriation_sum: 0
                };
            }
        },
        branchId: {
            required: true
        },
        studioId: {
            required: true
        },
        order: {
            type: Object,
            default: function _default(rawProps) {
                return {};
            }
        },
        member: {
            type: Object,
            default: function _default(rawProps) {
                return {};
            }
        },
        currentType: {
            default: 'edit'
        },
        initValue: {
            default: null
        },
        allowEditPaymentMethod: {
            type: Boolean,
            default: true,
            description: '是否顯示變更付款方式按鈕'
        },
        paymentMethodHeader: {
            type: String,
            default: '支付方式'
        },
        settingData: {
            type: Object,
            default: function _default(rawProps) {
                return {};
            }
        }
    },
    methods: {
        resetSelect: function resetSelect() {
            var _this = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.payment_method_select = null;
                                _this.branch_payment_methods = [];
                                _this.resetUserInput();
                                _this.changeDefaultPayment();

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        resetUserInput: function resetUserInput() {
            this.customUserInput = {
                key: ''
            };
            this.creditInput = {
                'auth_type': 'input',
                'exist_main_card': 0,
                'main_card_num': '',
                'credit_num': '',
                'expi_mon': '',
                'expi_year': '',
                'cvs': '',
                'is_checked': false,
                'auto_pay_card_num': '',
                'exist_auto_pay_cards': false
            };
        },
        getDefaultPaymentMethod: function getDefaultPaymentMethod() {
            return this.branch_payment_methods.reduce(function (carry, method) {
                if (method.branch_default == 1) {
                    carry = method.id;
                }
                return carry;
            }, 1);
        },
        changePaymentMethodWait: function changePaymentMethodWait(value) {
            var _this2 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                var payment_type;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _this2.checkPaymentType(value);

                                if (!_this2.ajaxingChange) {
                                    _context2.next = 3;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 3:
                                _this2.ajaxingChange = true;

                                if (!(_this2.currentType === 'edit')) {
                                    _context2.next = 8;
                                    break;
                                }

                                _context2.next = 7;
                                return _this2.changePaymentMethod();

                            case 7:
                                _this2.$emit('updated-payment-method');

                            case 8:
                                if (!(_this2.currentType === 'refund')) {
                                    _context2.next = 14;
                                    break;
                                }

                                _context2.next = 11;
                                return _this2.changePaymentMethod();

                            case 11:
                                payment_type = _this2.paymentShow.payment_type;


                                if (payment_type == null) {
                                    payment_type = _this2.payment.payment_type_id;
                                }

                                _this2.$emit('update-refund-payment-method', {
                                    type: 'payment',
                                    payment_action_record_id: _this2.payment.payment_action_record_id,
                                    payment_type_id: payment_type,
                                    payment_method_select: _this2.payment_method_select
                                });

                            case 14:

                                _this2.ajaxingChange = false;

                            case 15:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        checkPaymentType: function checkPaymentType(value) {
            if (this.currentType !== 'refund') {
                return;
            };
            if (typeof value == "undefined") {
                return;
            }
            if (value != this.initValue) {
                $17.swal({
                    type: 'warning',
                    title: '退費方式與原支付方式不一致',
                    showCancelButton: false
                });
            };
        },
        checkCreditExport: function checkCreditExport(paymentMethod) {
            var isRefund = this.currentType === 'refund';
            var isOnlineCreditPaymentMethod = this.branchPaymentMethodsShow[this.payment_method_select] && this.branchPaymentMethodsShow[this.payment_method_select].payment_type == 2 && paymentMethod.id === this.payment_method_select && this.payment_method_select != 2;

            return !!(this.canExportOrder17Only && isRefund && isOnlineCreditPaymentMethod);
        },
        sendExportOrder: function sendExportOrder() {
            if (!this.canExportOrder17Only) {
                return;
            }
            var self = this;
            $17.swal({
                title: '確認執行？',
                text: '立即撥款',
                type: 'warning',
                showCancelButton: true,
                closeOnConfirm: false,
                showLoaderOnConfirm: true
            }, function (answer) {
                if (answer) {
                    self.seventeenExportOrder();
                }
            });
        },
        checkShowLockPayment: function checkShowLockPayment(paymentMethod) {
            return this.currentType != 'edit' || this.currentType == 'edit' && !paymentMethod.is_locked;
        },
        getStudioPaymentMethod: function getStudioPaymentMethod(studio_id) {
            var _this3 = this;

            this.$http.get('/adminapi/pos/payment_method/studio/' + studio_id).then(function (_ref) {
                var data = _ref.data;

                _this3.studio_payment_methods = data.payment_methods;
            }, function (_ref2) {
                var data = _ref2.data;

                $17.swal({
                    type: 'warning',
                    title: '取得支付方式發生錯誤',
                    showCancelButton: false
                });
            });
        },
        changePaymentMethod: function changePaymentMethod() {
            var _this4 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return _this4.$http.post('/adminapi/pos/order/' + _this4.order.id + '/payment_method', { studio_payment_method_id: _this4.payment_method_select }).then(function (_ref3) {
                                    var data = _ref3.data;
                                }, function (_ref4) {
                                    var data = _ref4.data;

                                    $17.swal({
                                        type: 'warning',
                                        title: '更改支付方式發生錯誤',
                                        showCancelButton: false
                                    });
                                });

                            case 2:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this4);
            }))();
        },
        seventeenExportOrder: function seventeenExportOrder() {
            var _this5 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                $.blockUI({ timeout: 10000 });
                                _context4.next = 3;
                                return _this5.$http.post('/adminapi/pos/order/' + _this5.order.id + '/seventeen_export').then(function (response) {
                                    var msg = response.message ? response.message : '撥款成功';
                                    $.unblockUI();
                                    $17.swal({
                                        title: msg,
                                        showCancelButton: false,
                                        type: 'success'
                                    });
                                }).catch(function (response) {
                                    $17.swal({
                                        type: 'warning',
                                        title: response.data.message,
                                        showCancelButton: false
                                    });
                                    $.unblockUI();
                                });

                            case 3:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this5);
            }))();
        },
        changePaidPaymentMethod: function changePaidPaymentMethod() {
            this.$refs.paymentChange.openModal();
        },
        currentActivePayment: function currentActivePayment(id) {
            return this.activePayments.reduce(function (carry, payment) {
                if (payment.id == id) {
                    carry = payment;
                }
                return carry;
            }, {});
        },
        checkIsActive: function checkIsActive(id) {
            var currentPayment = this.currentActivePayment(id);

            if (this.WebadminOrderEditPaymentMethod && currentPayment.payment_type == 1) {
                return true;
            }

            return false;
        },
        allowPaymentType: function allowPaymentType(id, type) {
            if (this.payment_method_select == null || id == null) {
                return false;
            }
            var payment = this.activePayments.find(function (item) {
                return item.id == id;
            });
            if (typeof payment == 'undefined') {
                return false;
            }
            return type.indexOf(payment.payment_type) !== -1;
        },
        openDetail: function openDetail() {
            var recordId = this.payment.payment_action_record_id;
            this.$http.get('/adminapi/order/payment-action-record/' + recordId + '/action').then(function (response) {
                var data = response.data;

                switch (data.action_type) {
                    case "open-url":
                        window.open(data.action_data, "_blank");
                        break;

                    default:
                        break;
                }
            });
        },
        updatePaymentInput: function updatePaymentInput() {
            this.$emit('update-user-input', {
                type: 'payment',
                payment_action_record_id: this.payment.payment_action_record_id,
                data: {
                    customUserInput: this.customUserInput,
                    creditInput: this.creditInput
                }
            });
        },
        changeDefaultPayment: function changeDefaultPayment() {
            if (this.payment_method_select != null) {
                return;
            }

            if (this.initValue !== null) {
                this.payment_method_select = this.initValue;
                this.changePaymentMethodWait();
            } else {
                //修改
                if (this.payment.selected_method_id) {
                    this.payment_method_select = this.payment.selected_method_id;
                } else {
                    this.payment_method_select = this.getDefaultPaymentMethod();
                    this.changePaymentMethodWait();
                }
            }
        },
        updateOrder: function updateOrder() {
            this.$emit('updated-payment-method');
        },
        updateNotExistSelectPaymentMethod: function updateNotExistSelectPaymentMethod() {
            if ((0, _keys2.default)(this.branchPaymentMethodsShow).indexOf(this.payment.selected_method_id.toString()) == -1) {
                this.payment_method_select = 1;
                this.changePaymentMethodWait();
            }
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        canExportOrder17Only: function canExportOrder17Only(state) {
            return state.webadmin.configure.webFunctions.WebadminPosExport17;
        },
        WebadminOrderEditPaymentMethod: function WebadminOrderEditPaymentMethod(state) {
            return state.webadmin.configure.webFunctions.WebadminPosChangeStudioPaymentMethod;
        }
    }), {
        branchPaymentMethodsShow: function branchPaymentMethodsShow() {
            var _this6 = this;

            var vm = this;
            return this.branch_payment_methods.reduce(function (carry, method) {
                //需要抽離邏輯到 setting 層級
                if (vm.currentType == 'refund' && method.payment_type === 2 && method.id != vm.initValue) {
                    // continue;
                } else if (method.payment_type === 6 && _this6.setting.enableEdit(_this6.settingData)) {
                    // continue;
                } else {
                    // carry.push(method);
                    carry[method.id] = method;
                }

                return carry;
            }, {});
        },
        showCreditInput: function showCreditInput() {
            if (this.currentType !== 'edit') {
                return false;
            }
            if (this.branchPaymentMethodsShow[this.payment_method_select] && this.branchPaymentMethodsShow[this.payment_method_select].payment_type == 2) {
                return true;
            }
            return false;
        },
        showCustomUserInput: function showCustomUserInput() {
            if (this.currentType !== 'edit') {
                return false;
            }
            if (this.branchPaymentMethodsShow[this.payment_method_select] && this.branchPaymentMethodsShow[this.payment_method_select].payment_type == 5) {
                return true;
            }
            return false;
        },
        paymentShow: function paymentShow() {
            if (this.branchPaymentMethodsShow[this.payment_method_select]) {
                return this.branchPaymentMethodsShow[this.payment_method_select];
            }
            return {
                'id': null,
                'name': '',
                'payment_type': null
            };
        },
        activePayments: function activePayments() {
            if (!this.studio_payment_methods[this.branchId]) {
                return [];
            }
            return this.studio_payment_methods[this.branchId];
        }
    }),
    watch: {
        studioId: function studioId(newStudioId) {
            var _this7 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5() {
                return _regenerator2.default.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                if (!(newStudioId && newStudioId != 0)) {
                                    _context5.next = 5;
                                    break;
                                }

                                _this7.ajaxing = true;
                                _context5.next = 4;
                                return _this7.getStudioPaymentMethod(newStudioId);

                            case 4:
                                _this7.ajaxing = false;

                            case 5:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this7);
            }))();
        },
        branchId: function branchId(newBranchId) {
            var _this8 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6() {
                return _regenerator2.default.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                if (!_this8.studio_payment_methods[newBranchId]) {
                                    _context6.next = 4;
                                    break;
                                }

                                _context6.next = 3;
                                return _this8.resetSelect();

                            case 3:
                                _this8.branch_payment_methods = _this8.studio_payment_methods[newBranchId];

                            case 4:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, _this8);
            }))();
        },
        studio_payment_methods: function studio_payment_methods() {
            var _this9 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7() {
                return _regenerator2.default.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                if (!_this9.studio_payment_methods[_this9.branchId]) {
                                    _context7.next = 5;
                                    break;
                                }

                                _context7.next = 3;
                                return _this9.resetSelect();

                            case 3:
                                _this9.branch_payment_methods = _this9.studio_payment_methods[_this9.branchId];
                                _this9.updateNotExistSelectPaymentMethod();

                            case 5:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, _this9);
            }))();
        },

        'payment.selected_method_id': function paymentSelected_method_id(newVal) {
            if (!newVal) {
                this.changeDefaultPayment();
            }
            this.payment_method_select = newVal;
        },
        'payment.selected_method_name': function paymentSelected_method_name(newVal) {
            this.payment_method_name = newVal;
        },
        customUserInput: {
            handler: function handler(newValue) {
                this.updatePaymentInput();
            },

            deep: true
        },
        creditInput: {
            handler: function handler(newValue) {
                this.updatePaymentInput();
            },

            deep: true
        },
        payment_method_select: function payment_method_select() {
            this.resetUserInput();
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-09e419ba=\"\">\n    <div class=\"row\" v-if=\"(!ajaxing&amp;&amp;setting.enableEdit(settingData)&amp;&amp;order.total>0)\" _v-09e419ba=\"\">\n        <div class=\"col-xs-2\" _v-09e419ba=\"\">\n            <label for=\"\" class=\" text-right\" _v-09e419ba=\"\">{{ paymentMethodHeader }}</label>\n        </div>\n        <div class=\"col-xs-10\" _v-09e419ba=\"\">\n            <v-spinner-button :ajaxing=\"ajaxingChange\" style=\"align:center\" _v-09e419ba=\"\">\n            </v-spinner-button>\n            <div class=\"\" v-show=\"!ajaxingChange\" _v-09e419ba=\"\">\n                <div class=\"\" _v-09e419ba=\"\">\n                    <ul class=\"\" v-if=\"Object.keys(branchPaymentMethodsShow).length>0\" _v-09e419ba=\"\">\n                        <li v-for=\"(payment_method,index) in branchPaymentMethodsShow\" :key=\"payment_method.id\" _v-09e419ba=\"\">\n                            <span v-if=\"checkShowLockPayment(payment_method)\" _v-09e419ba=\"\">\n                                <input type=\"radio\" @change=\"changePaymentMethodWait(index)\" :value=\"payment_method.id\" v-model=\"payment_method_select\" :id=\"'payment_method'+currentType+index\" _v-09e419ba=\"\">\n                                <label :for=\"'payment_method'+currentType+index\" _v-09e419ba=\"\">{{ paymentDisplayName(payment_method) }}</label>\n                                <a class=\"underline p-right-10\" v-if=\"checkCreditExport(payment_method)\" @click.prevent=\"sendExportOrder\" _v-09e419ba=\"\">立即撥款</a>\n                            </span>\n                        </li>\n                    </ul>\n                </div>\n            </div>\n            <div class=\"row\" v-show=\"!ajaxingChange\" _v-09e419ba=\"\">\n                <div class=\"col-xs-12\" _v-09e419ba=\"\">\n                    <webadmin-order-operate-branch-payment-credit-card-input-utility :order=\"order\" :member=\"member\" :credit-input=\"creditInput\" @update-credit-input=\"creditInput=$event\" v-if=\"showCreditInput&amp;&amp;order.id\" _v-09e419ba=\"\"></webadmin-order-operate-branch-payment-credit-card-input-utility>\n                    <webadmin-order-operate-branch-payment-third-custom-user-input-utility :custom-user-input=\"customUserInput\" @update-custom-user-input=\"customUserInput=$event\" v-if=\"showCustomUserInput\" _v-09e419ba=\"\"></webadmin-order-operate-branch-payment-third-custom-user-input-utility>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"row\" v-if=\"!setting.enableEdit(settingData)\" _v-09e419ba=\"\">\n        <div class=\"col-xs-2\" _v-09e419ba=\"\">\n            <label for=\"\" class=\" text-right\" _v-09e419ba=\"\">{{ paymentMethodHeader }}</label>\n        </div>\n        <div class=\"col-xs-10\" _v-09e419ba=\"\">\n            <div class=\"st-flex st-items-center\" _v-09e419ba=\"\">\n                <div class=\"st-mr-2 st-text-16\" _v-09e419ba=\"\">{{ paymentDisplayName(paymentShow) }}</div>\n                <input type=\"button\" v-if=\"checkIsActive(paymentShow.id) &amp;&amp; allowEditPaymentMethod\" class=\"btn btn-default btn--inverse btn-xs\" value=\"變更\" @click=\"changePaidPaymentMethod\" _v-09e419ba=\"\">\n                <a @click=\"openDetail()\" v-if=\"allowPaymentType(paymentShow.id,[6])\" class=\"st-flex st-items-center\" _v-09e419ba=\"\">\n                    查看詳情 \n                    <span class=\"material-icons\" _v-09e419ba=\"\">\n                    launch\n                    </span>\n                </a>\n            </div>\n        </div>\n    </div>\n    <webadmin-order-operate-branch-payment-change-payment-method-utility v-if=\"checkIsActive(paymentShow.id) &amp;&amp; allowEditPaymentMethod &amp;&amp;!setting.enableEdit(settingData)\" :studio-id=\"studioId\" :branch-id=\"branchId\" :order-id=\"order.id\" :payment=\"payment\" :studio-payment-methods=\"studio_payment_methods\" @payment-method-changed=\"updateOrder\" ref=\"paymentChange\" _v-09e419ba=\"\"></webadmin-order-operate-branch-payment-change-payment-method-utility>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\nul[_v-09e419ba] {\n  padding-left: 0px; }\n\n/* line 5, stdin */\nli[_v-09e419ba] {\n  list-style-type: none;\n  display: inline-block;\n  padding-right: 10px; }\n\n/* line 10, stdin */\n.row[_v-09e419ba] {\n  margin-left: 0px;\n  margin-right: 0px; }\n\n/* line 14, stdin */\n.underline[_v-09e419ba] {\n  text-decoration: underline; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-09e419ba", module.exports)
  } else {
    hotAPI.update("_v-09e419ba", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/object/keys":56,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1297:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.row[_v-71aa7932] {\n  margin-left: 0px;\n  margin-right: 0px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            ajaxing: false,
            ajaxingChange: false,
            branch_payment_methods: [],
            payment_method_select: null
        };
    },

    props: {
        branchId: {
            required: true
        },
        orderId: {
            required: true,
            default: null
        },
        'payment': {
            type: Object,
            default: function _default(rawProps) {
                return {};
            }
        },
        'studioPaymentMethods': {
            type: Object,
            default: function _default(rawProps) {
                return [];
            }
        }
    },
    methods: {
        resetSelect: function resetSelect() {
            var _this = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.payment_method_select = null;
                                _this.branch_payment_methods = [];

                            case 2:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        changePaymentMethodWait: function changePaymentMethodWait() {
            var _this2 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _this2.ajaxingChange = true;
                                _context2.next = 3;
                                return _this2.changePaymentMethod();

                            case 3:
                                _this2.ajaxingChange = false;

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        changePaymentMethod: function changePaymentMethod() {
            var _this3 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                paymentActionRecordId = _this3.payment.payment_action_record_id;

                                if (!(_this3.payment_method_select == null || _this3.payment_method_select == 0)) {
                                    _context3.next = 4;
                                    break;
                                }

                                $17.swal({
                                    title: "請選擇支付方式",
                                    text: "",
                                    type: 'error',
                                    showCancelButton: false,
                                    confirmButtonText: '確定'
                                });

                                return _context3.abrupt('return');

                            case 4:
                                _context3.next = 6;
                                return _this3.$http.post('/adminapi/pos/change_studio_payment_method/' + paymentActionRecordId, {
                                    studio_payment_method_id: _this3.payment_method_select
                                }).then(function (response) {
                                    _this3.$emit('payment-method-changed');
                                    $(_this3.$el).modal('hide');
                                }, function (error) {
                                    $17.swal({
                                        title: "更改發生錯誤",
                                        text: "",
                                        type: 'error',
                                        showCancelButton: false,
                                        confirmButtonText: '確定'
                                    });
                                });

                            case 6:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3);
            }))();
        },
        setBranchPaymentMethod: function setBranchPaymentMethod(branchId) {
            var _this4 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                if (!_this4.studioPaymentMethods[branchId]) {
                                    _context4.next = 4;
                                    break;
                                }

                                _context4.next = 3;
                                return _this4.resetSelect();

                            case 3:
                                _this4.branch_payment_methods = _this4.studioPaymentMethods[branchId];

                            case 4:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this4);
            }))();
        },
        openModal: function openModal() {
            $(this.$el).modal('show');
        }
    },
    computed: {
        branchPaymentMethodsShow: function branchPaymentMethodsShow() {
            var vm = this;
            return this.branch_payment_methods.reduce(function (carry, method) {
                if (method.payment_type === 1) {
                    carry[method.id] = method;
                }
                return carry;
            }, {});
        }
    },
    watch: {
        branchId: function branchId(newBranchId) {
            var _this5 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5() {
                return _regenerator2.default.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _this5.setBranchPaymentMethod(newBranchId);

                            case 1:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this5);
            }))();
        },
        studioPaymentMethods: function studioPaymentMethods() {
            var _this6 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6() {
                return _regenerator2.default.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _this6.setBranchPaymentMethod(_this6.branchId);

                            case 1:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, _this6);
            }))();
        },
        payment: function payment(newVal) {
            this.payment_method_select = newVal.selected_method_id;
        }
    },
    mounted: function mounted() {
        var _this7 = this;

        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7() {
            return _regenerator2.default.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            _context7.next = 2;
                            return _this7.setBranchPaymentMethod(_this7.branchId);

                        case 2:
                            _this7.payment_method_select = _this7.payment.selected_method_id;

                        case 3:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee7, _this7);
        }))();
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal id=\"order-operate-change-payment-method-modal\" no-footer=\"\" parallel-modal=\"\" :keep-alive=\"false\" _v-71aa7932=\"\">\n    <span slot=\"title\" _v-71aa7932=\"\">選擇支付方式</span>\n    <template slot=\"body\">\n        <div class=\"\" _v-71aa7932=\"\">\n            <div class=\"row\" _v-71aa7932=\"\">\n                <div class=\"col-xs-12\" _v-71aa7932=\"\">\n                    <v-spinner :ajaxing=\"ajaxingChange\" style=\"align:center\" _v-71aa7932=\"\">\n                </v-spinner></div>\n            </div>\n            <div class=\"row\" v-show=\"!ajaxingChange\" v-for=\"(payment_method,index) in branchPaymentMethodsShow\" :key=\"payment_method.id\" _v-71aa7932=\"\">\n                <div class=\"col-xs-12\" _v-71aa7932=\"\">\n                    <input type=\"radio\" :value=\"payment_method.id\" v-model=\"payment_method_select\" :id=\"'change_payment_method'+index\" _v-71aa7932=\"\">\n                    <label :for=\"'change_payment_method'+index\" _v-71aa7932=\"\">{{ paymentDisplayName(payment_method) }}</label>\n                </div>\n            </div>\n            <div class=\"row\" v-show=\"!ajaxingChange\" _v-71aa7932=\"\">\n                <div class=\"col-xs-12 text-right\" _v-71aa7932=\"\">\n                    <input type=\"button\" value=\"儲存\" class=\"btn btn-primary\" @click=\"changePaymentMethodWait\" _v-71aa7932=\"\">\n                </div>\n            </div>\n        </div>\n    </template>\n</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.row[_v-71aa7932] {\n  margin-left: 0px;\n  margin-right: 0px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-71aa7932", module.exports)
  } else {
    hotAPI.update("_v-71aa7932", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1298:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.row[_v-e95e0ce4] {\n  margin-left: 2em; }\n\n/* line 5, stdin */\n.auth-option[_v-e95e0ce4] {\n  margin-top: 1em;\n  margin-bottom: 0.5em; }\n  /* line 8, stdin */\n  .auth-option label[_v-e95e0ce4] {\n    margin-left: 5px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        'order': {
            type: Object,
            default: function _default(rawProps) {
                return {};
            }
        },
        'member': {
            type: Object,
            default: function _default(rawProps) {
                return {};
            }
        }
    },
    data: function data() {
        return {
            'credit_input': {
                'auth_type': 'input',
                'exist_main_card': 0,
                'allow_main_credit': 0,
                'main_card_num': '',
                'credit_num': '',
                'expi_mon': '',
                'expi_year': '',
                'cvs': '',
                'is_checked': false,
                'auto_pay_card_num': '',
                'exist_auto_pay_cards': false
            }
        };
    },

    mounted: function mounted() {
        this.fetchMainCredit();
        this.fetchAutoPayPlanCreditCard();
        if (this.allowMainCredit) {
            this.authType = 'auth';
            this.credit_input.allow_main_credit = this.allowMainCredit;
        }
    },
    destroyed: function destroyed() {
        this.credit_input = {
            'auth_type': 'input',
            'exist_main_card': 0,
            'allow_main_credit': 0,
            'main_card_num': '',
            'credit_num': '',
            'expi_mon': '',
            'expi_year': '',
            'cvs': '',
            'is_checked': false,
            'auto_pay_card_num': '',
            'exist_auto_pay_cards': false
        };
    },
    methods: {
        getYear: function getYear(add) {
            return moment().add(add, 'years').format('YYYY');
        },
        fetchMainCredit: function fetchMainCredit() {
            var _this = this;

            if (!this.allowMainCredit || !this.orderMemberId) {
                return;
            }
            this.$http.get('/adminapi/pos/order/' + this.order.id + '/credit_main').then(function (response) {
                _this.mainCreditNum = response.data.cardNum;
                _this.existMainCard = response.data.existMainCard;
                _this.credit_input.exist_main_card = response.data.existMainCard;
            }, function (error) {
                _this.view.ajaxing = false;
            });
        },
        fetchAutoPayPlanCreditCard: function fetchAutoPayPlanCreditCard() {
            var _this2 = this;

            if (!this.showAutoPayCreditCard || !this.orderMemberId) {
                return;
            }
            this.$http.get('/adminapi/pos/order/' + this.order.id + '/auto-pay-payload').then(function (response) {
                if (response.data.existAutoPayCards == 1) {
                    _this2.authType = 'auth-auto-pay-plan';
                }
                _this2.credit_input.auto_pay_card_num = response.data.autoPayCardNum;
                _this2.credit_input.exist_auto_pay_cards = response.data.existAutoPayCards;
            }, function (error) {
                _this2.view.ajaxing = false;
            });
        }
    },
    watch: {
        orderMemberId: function orderMemberId(newVal) {
            if (newVal) {
                this.fetchMainCredit();
                this.fetchAutoPayPlanCreditCard();
            }
        },

        credit_input: {
            handler: function handler(newValue) {
                this.$emit('update-credit-input', newValue);
            },

            deep: true
        }
    },
    computed: {
        creditNum: {
            get: function get() {
                return this.credit_input.credit_num;
            },
            set: function set(newValue) {
                this.credit_input.credit_num = newValue;
                this.$forceUpdate();
            }
        },
        expiMon: {
            get: function get() {
                if (this.credit_input.expi_mon === '') {
                    this.expiMon = '06';
                }
                return this.credit_input.expi_mon;
            },
            set: function set(newValue) {
                this.credit_input.expi_mon = newValue;
            }
        },
        expiYear: {
            get: function get() {
                if (this.credit_input.expi_year === '') {
                    this.expiYear = this.getYear(3);
                }
                return this.credit_input.expi_year;
            },
            set: function set(newValue) {
                this.credit_input.expi_year = newValue;
            }
        },
        cvs: {
            get: function get() {
                return this.credit_input.cvs;
            },
            set: function set(newValue) {
                this.credit_input.cvs = newValue;
            }
        },
        is_checked: {
            get: function get() {
                return this.credit_input.is_checked;
            },
            set: function set(newValue) {
                this.credit_input.is_checked = newValue;
            }
        },
        authType: {
            get: function get() {
                return this.credit_input.auth_type;
            },
            set: function set(newValue) {
                this.credit_input.auth_type = newValue;
            }
        },
        mainCreditNum: {
            get: function get() {
                return this.credit_input.main_card_num;
            },
            set: function set(newValue) {
                this.credit_input.main_card_num = newValue;
            }
        },
        allowMainCredit: function allowMainCredit() {
            return this.order.allow_main_credit;
        },
        orderMemberId: function orderMemberId() {
            return this.member.id;
        },
        existMainCard: function existMainCard() {
            return this.credit_input.exist_main_card;
        },
        showAutoPayCreditCard: function showAutoPayCreditCard() {
            return this.order.is_auto_pay_order;
        },
        autoPayCardNum: function autoPayCardNum() {
            return this.credit_input.auto_pay_card_num;
        },
        existAutoPayCards: function existAutoPayCards() {
            return this.credit_input.exist_auto_pay_cards;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-e95e0ce4=\"\">\n    <div class=\"auth-option\" _v-e95e0ce4=\"\">\n        <div class=\"row\" v-if=\"allowMainCredit\" _v-e95e0ce4=\"\">\n            <div class=\"col-xs-12 col-sm-12\" _v-e95e0ce4=\"\">\n                <input type=\"radio\" value=\"auth\" v-model=\"authType\" class=\"\" name=\"auth-type\" id=\"auth-type-auth\" _v-e95e0ce4=\"\">\n                <label for=\"auth-type-auth\" _v-e95e0ce4=\"\">授權信用卡</label>\n            \n                <input type=\"text\" name=\"\" :value=\"mainCreditNum\" disabled=\"\" id=\"\" v-show=\"existMainCard\" _v-e95e0ce4=\"\">\n                <span v-show=\"!existMainCard\" _v-e95e0ce4=\"\">{{mainCreditNum}}</span>\n            </div>\n        </div>\n        <div class=\"row\" v-if=\"showAutoPayCreditCard\" _v-e95e0ce4=\"\">\n            <div class=\"col-xs-12 col-sm-12\" _v-e95e0ce4=\"\">\n                <input type=\"radio\" value=\"auth-auto-pay-plan\" v-model=\"authType\" class=\"\" name=\"auth-type\" id=\"auth-type-auto-pay-plan\" _v-e95e0ce4=\"\">\n                <label for=\"auth-type-auto-pay-plan\" _v-e95e0ce4=\"\">授權信用卡</label>\n            \n                <input type=\"text\" name=\"\" :value=\"autoPayCardNum\" disabled=\"\" id=\"\" v-show=\"existAutoPayCards\" _v-e95e0ce4=\"\">\n                <span v-show=\"!existMainCard\" _v-e95e0ce4=\"\">{{mainCreditNum}}</span>\n            </div>\n        </div>\n        <div class=\"row\" _v-e95e0ce4=\"\">\n            <div class=\"col-xs-12 col-sm-12\" _v-e95e0ce4=\"\">\n                <input type=\"radio\" value=\"input\" v-model=\"authType\" class=\"\" name=\"auth-type\" id=\"auth-type-input\" _v-e95e0ce4=\"\">\n                <label for=\"auth-type-input\" _v-e95e0ce4=\"\">輸入信用卡</label>\n            </div>\n        </div>\n    </div>\n    <div class=\"form-group row\" v-show=\"authType=='input'\" _v-e95e0ce4=\"\">\n        <label for=\"credit-num\" class=\"col-xs-4 col-sm-3\" _v-e95e0ce4=\"\">信用卡號碼</label>\n        <div class=\"col-xs-7 col-sm-6\" _v-e95e0ce4=\"\">\n            <input type=\"text\" v-model=\"creditNum\" class=\"form-control\" id=\"credit-num\" maxlength=\"16\" minlength=\"16\" placeholder=\"填入16碼卡號\" _v-e95e0ce4=\"\">\n        </div>\n    </div>\n    <div class=\"form-group row\" v-show=\"authType=='input'\" _v-e95e0ce4=\"\">\n        <label for=\"credit-num\" class=\"col-xs-4 col-sm-3\" _v-e95e0ce4=\"\">到期日</label>\n            <div class=\"col-xs-3 col-sm-3\" _v-e95e0ce4=\"\">\n                <select name=\"expi-mon\" id=\"expi-mon\" class=\"form-control\" v-model=\"expiMon\" _v-e95e0ce4=\"\">\n                    <option value=\"01\" _v-e95e0ce4=\"\">01</option>\n                    <option value=\"02\" _v-e95e0ce4=\"\">02</option>\n                    <option value=\"03\" _v-e95e0ce4=\"\">03</option>\n                    <option value=\"04\" _v-e95e0ce4=\"\">04</option>\n                    <option value=\"05\" _v-e95e0ce4=\"\">05</option>\n                    <option value=\"06\" _v-e95e0ce4=\"\">06</option>\n                    <option value=\"07\" _v-e95e0ce4=\"\">07</option>\n                    <option value=\"08\" _v-e95e0ce4=\"\">08</option>\n                    <option value=\"09\" _v-e95e0ce4=\"\">09</option>\n                    <option value=\"10\" _v-e95e0ce4=\"\">10</option>\n                    <option value=\"11\" _v-e95e0ce4=\"\">11</option>\n                    <option value=\"12\" _v-e95e0ce4=\"\">12</option>\n                </select>\n            </div>\n            <div class=\"col-xs-4 col-sm-3\" _v-e95e0ce4=\"\">\n                <select name=\"expi-mon\" id=\"expi-year\" class=\"form-control\" v-model=\"expiYear\" _v-e95e0ce4=\"\">\n                    <option :value=\"getYear(0)\" _v-e95e0ce4=\"\">{{ getYear(0) }}</option>\n                    <option :value=\"getYear(n)\" v-for=\"n in  15\" _v-e95e0ce4=\"\">{{ getYear(n) }}</option>\n                </select>\n            </div>\n    </div>\n    <div class=\"form-group row\" v-show=\"authType=='input'\" _v-e95e0ce4=\"\">\n        <div class=\"col-xs-4 col-sm-3\" _v-e95e0ce4=\"\">\n            <label for=\"credit-num\" _v-e95e0ce4=\"\">安全碼</label>\n        </div>\n        <div class=\"col-xs-3 col-sm-2\" _v-e95e0ce4=\"\">\n            <input type=\"text\" v-model=\"cvs\" class=\"form-control\" id=\"credit-num\" maxlength=\"4\" minlength=\"3\" placeholder=\"***\" _v-e95e0ce4=\"\">\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.row[_v-e95e0ce4] {\n  margin-left: 2em; }\n\n/* line 5, stdin */\n.auth-option[_v-e95e0ce4] {\n  margin-top: 1em;\n  margin-bottom: 0.5em; }\n  /* line 8, stdin */\n  .auth-option label[_v-e95e0ce4] {\n    margin-left: 5px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-e95e0ce4", module.exports)
  } else {
    hotAPI.update("_v-e95e0ce4", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1299:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _branchPaymentMethods = require('./branch-payment-methods.vue');

var _branchPaymentMethods2 = _interopRequireDefault(_branchPaymentMethods);

var _thirdCustomUserInput = require('./third-custom-user-input.vue');

var _thirdCustomUserInput2 = _interopRequireDefault(_thirdCustomUserInput);

var _creditCardInput = require('./credit-card-input.vue');

var _creditCardInput2 = _interopRequireDefault(_creditCardInput);

var _changePaymentMethod = require('./change-payment-method.vue');

var _changePaymentMethod2 = _interopRequireDefault(_changePaymentMethod);

var _branchPaymentMethodShow = require('./branch-payment-method-show.vue');

var _branchPaymentMethodShow2 = _interopRequireDefault(_branchPaymentMethodShow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//utility
_vue2.default.component('webadmin-order-operate-branch-payment-methods-utility', _branchPaymentMethods2.default);

_vue2.default.component('webadmin-order-operate-branch-payment-third-custom-user-input-utility', _thirdCustomUserInput2.default);
_vue2.default.component('webadmin-order-operate-branch-payment-credit-card-input-utility', _creditCardInput2.default);
_vue2.default.component('webadmin-order-operate-branch-payment-change-payment-method-utility', _changePaymentMethod2.default);
_vue2.default.component('webadmin-order-operate-branch-payment-payment-show-method-utility', _branchPaymentMethodShow2.default);

},{"./branch-payment-method-show.vue":1295,"./branch-payment-methods.vue":1296,"./change-payment-method.vue":1297,"./credit-card-input.vue":1298,"./third-custom-user-input.vue":1300,"vue":792}],1300:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        'customUserInput': {
            type: Object,
            default: function _default(rawProps) {
                return {
                    key: ''
                };
            }
        }
    },
    computed: {
        thirdCustomUserKey: {
            get: function get() {
                return this.customUserInput.key;
            },
            set: function set(newValue) {
                this.$emit('update-custom-user-input', {
                    'key': newValue
                });
                this.$forceUpdate();
            }
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div>\n    <div class=\"form-group row\">\n        <div class=\"col-xs-7 col-sm-6\">\n            <input type=\"text\" v-model.lazy=\"thirdCustomUserKey\" class=\"form-control\" placeholder=\"掃瞄或輸入條碼...\">\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-8983752a", module.exports)
  } else {
    hotAPI.update("_v-8983752a", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],1301:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _productOperate = require('./product-operate.vue');

var _productOperate2 = _interopRequireDefault(_productOperate);

var _productAppendButton = require('./product-append-button.vue');

var _productAppendButton2 = _interopRequireDefault(_productAppendButton);

var _productListModal = require('./product-list-modal.vue');

var _productListModal2 = _interopRequireDefault(_productListModal);

var _productSelectModal = require('./product-select-modal.vue');

var _productSelectModal2 = _interopRequireDefault(_productSelectModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('webadmin-product-operate-utility', _productOperate2.default);
_vue2.default.component('webadmin-product-operate-append-btn-utility', _productAppendButton2.default);
_vue2.default.component('webadmin-product-operate-product-list-modal-utility', _productListModal2.default);
_vue2.default.component('webadmin-product-operate-product-select-modal-utility', _productSelectModal2.default);

},{"./product-append-button.vue":1302,"./product-list-modal.vue":1303,"./product-operate.vue":1304,"./product-select-modal.vue":1305,"vue":792}],1302:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 3, stdin */\n.outsid-border[_v-c89a0f06] {\n  border: 2px solid #C7C4C3;\n  border-bottom: 0px;\n  margin-bottom: -10px; }\n  /* line 7, stdin */\n  .outsid-border .btn[_v-c89a0f06] {\n    margin: 10px 0 10px 20px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        'walkInMember': {
            default: false
        }
    },
    data: function data() {
        return {};
    },
    mounted: function mounted() {},

    watch: {},
    methods: {
        openProductList: function openProductList(type) {
            this.$emit('product-append', type);
        }
    }

};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"\" _v-c89a0f06=\"\">\n    <div class=\"outsid-border\" _v-c89a0f06=\"\">\n        <div class=\"btn btn-success\" v-if=\"!walkInMember\" @click=\"openProductList('contracts')\" _v-c89a0f06=\"\">\n            <i class=\"fa fa-plus-circle\" aria-hidden=\"true\" _v-c89a0f06=\"\"></i>\n            <span class=\"small-space\" _v-c89a0f06=\"\">方案</span>\n        </div>\n        <div class=\"btn btn-success\" @click=\"openProductList('ticket_settings')\" _v-c89a0f06=\"\">\n            <span class=\"append-icon\" _v-c89a0f06=\"\">\n                <i class=\"fa fa-plus-circle\" aria-hidden=\"true\" _v-c89a0f06=\"\"></i>\n            </span>\n            <span class=\"small-space\" _v-c89a0f06=\"\">票券</span>\n        </div>\n        <div class=\"btn btn-success\" @click=\"openProductList('physical_products')\" _v-c89a0f06=\"\">\n            <span class=\"append-icon\" _v-c89a0f06=\"\">\n                <i class=\"fa fa-plus-circle\" aria-hidden=\"true\" _v-c89a0f06=\"\"></i>\n            </span>\n            <span class=\"small-space\" _v-c89a0f06=\"\">產品</span>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 3, stdin */\n.outsid-border[_v-c89a0f06] {\n  border: 2px solid #C7C4C3;\n  border-bottom: 0px;\n  margin-bottom: -10px; }\n  /* line 7, stdin */\n  .outsid-border .btn[_v-c89a0f06] {\n    margin: 10px 0 10px 20px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-c89a0f06", module.exports)
  } else {
    hotAPI.update("_v-c89a0f06", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1303:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 4, stdin */\n.item[_v-2b6bc936]::after {\n  margin: 20px -20px;\n  border-top: 1px solid #C7C4C3;\n  display: block; }\n\n/* line 10, stdin */\n.item[_v-2b6bc936] {\n  cursor: pointer;\n  padding: 10px 20px 0px 20px; }\n\n/* line 18, stdin */\n.category[_v-2b6bc936] {\n  background-color: #C7C4C3;\n  padding: 10px 20px 10px 20px; }\n\n/* line 23, stdin */\n.search-form[_v-2b6bc936] {\n  margin-bottom: 10px; }\n\n/* line 27, stdin */\nhr[_v-2b6bc936] {\n  margin-left: -40px;\n  margin-right: -40px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            product_category: {},
            product_list: [],
            product_show_list: [],
            current_selected_product: null,
            product_filter: '',
            product_category_selected: 0,
            type: null,
            ajaxing: {
                fetch_list: false
            }
        };
    },
    props: {
        'branchId': {
            default: 0
        }
    },
    methods: {
        clickProductList: function clickProductList(product) {
            this.$emit('product', product);
            $(this.$el).modal('hide');
        },

        checkFilter: function checkFilter(key, data) {
            var reg = new RegExp(key + '.*');
            return reg.test(data);
        },
        showCategory: function showCategory(filted_list) {
            return filted_list.items.length > 0;
        },
        itemClass: function itemClass(showAttr) {
            return ['col-xs-' + showAttr['colWidth'], 'text-' + showAttr['align']];
        },
        openList: function openList() {
            var _this = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!(_this.type == null || _this.branchId == 0 || _this.ajaxing.fetch_list)) {
                                    _context.next = 2;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 2:
                                _this.ajaxing.fetch_list = true;
                                $.blockUI({
                                    timeout: 1000,
                                    message: '',
                                    overlayCSS: {
                                        backgroundColor: 'transparent', // 設置為透明
                                        opacity: 0.5 // 透明度 (0-1)
                                    }
                                });
                                _this.$http.get('/adminapi/pos/get_product_list/' + _this.branchId + '/' + _this.type).then(function (response) {
                                    _this.product_list = response.data.list;
                                    _this.product_category = response.data.type;
                                    _this.product_show_list = response.data.show_list;
                                    $(_this.$el).modal('show');
                                    _this.ajaxing.fetch_list = false;
                                }).catch(function (response) {
                                    _this.ajaxing.fetch_list = false;
                                    $17.swal({
                                        type: 'warning',
                                        title: response.errMessage,
                                        showCancelButton: false
                                    });
                                });

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    },
    computed: {
        filted_category: function filted_category() {
            var vm = this;
            return this.product_list.map(function (product_category) {
                var isSelectedCategory = true;
                if (vm.product_category_selected != 0 && product_category.id != vm.product_category_selected) {
                    isSelectedCategory = false;
                }
                var item = {};
                item.id = product_category.id;
                item.name = product_category.name;
                item.items = product_category.items.filter(function (product) {
                    if (!isSelectedCategory) {
                        return false;
                    }
                    if (vm.order_id != '' && !vm.checkFilter(vm.product_filter, product.name)) {
                        return false;
                    }
                    return true;
                });
                return item;
            });
        },
        showTitle: function showTitle() {
            var word = '選擇';
            switch (this.current_selected_product) {
                case 'physical_products':
                    word = word + '產品';
                    break;
                case 'contracts':
                    word = word + '方案';
                    break;
                default:
                    word = '';
            }
            return word;
        }
    },
    watch: {
        product_category_selected: function product_category_selected() {
            this.$forceUpdate();
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal id=\"product-operate-list-modal\" no-footer=\"\" parallel-modal=\"\" open-size=\"modal-lg\" :keep-alive=\"false\" _v-2b6bc936=\"\">\n    <span slot=\"title\" _v-2b6bc936=\"\">{{showTitle}}</span>\n    <template slot=\"body\">\n        <div style=\"min-height: 90vh\" _v-2b6bc936=\"\">\n            <div class=\"row search-form\" _v-2b6bc936=\"\">\n                <form v-on:submit.prevent=\"\" _v-2b6bc936=\"\">\n                    <div class=\"col-xs-3\" _v-2b6bc936=\"\">\n                        <select name=\"product_category\" class=\"form-control\" v-model.lazy=\"product_category_selected\" _v-2b6bc936=\"\">\n                            <option value=\"0\" _v-2b6bc936=\"\">顯示所有分類</option>\n                            <option :value=\"index\" v-for=\"(name, index) in product_category\" _v-2b6bc936=\"\">{{name}}</option>\n                        </select>\n                    </div>\n                    <div class=\"col-xs-6\" _v-2b6bc936=\"\">\n                        <input type=\"text\" name=\"\" id=\"\" class=\"form-control\" v-model.lazy=\"product_filter\" _v-2b6bc936=\"\">\n                    </div>\n                    <div class=\"col-xs-3\" _v-2b6bc936=\"\">\n                        <input type=\"button\" class=\"form-control\" value=\"搜尋\" _v-2b6bc936=\"\">\n                    </div>\n                </form>\n            </div>\n            <div v-for=\"filted_list in filted_category\" v-show=\"showCategory(filted_list)\" _v-2b6bc936=\"\">\n                <div class=\"row category\" _v-2b6bc936=\"\">\n                    <div class=\"col-xs-12 \" _v-2b6bc936=\"\">\n                        {{filted_list.name}}\n                    </div>\n                </div>\n                <div v-for=\"product in filted_list.items\" class=\"item\" @click=\"clickProductList(product)\" _v-2b6bc936=\"\">\n                    <div class=\"row\" _v-2b6bc936=\"\">\n                        <div v-for=\"show in product_show_list\" v-bind:class=\"itemClass(show)\" _v-2b6bc936=\"\">\n                            {{product[show['fieldName']]}}\n                        </div>\n                    </div>\n                    <hr _v-2b6bc936=\"\">\n                </div>\n            </div>\n        </div>\n    </template>\n</v-modal>\n\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 4, stdin */\n.item[_v-2b6bc936]::after {\n  margin: 20px -20px;\n  border-top: 1px solid #C7C4C3;\n  display: block; }\n\n/* line 10, stdin */\n.item[_v-2b6bc936] {\n  cursor: pointer;\n  padding: 10px 20px 0px 20px; }\n\n/* line 18, stdin */\n.category[_v-2b6bc936] {\n  background-color: #C7C4C3;\n  padding: 10px 20px 10px 20px; }\n\n/* line 23, stdin */\n.search-form[_v-2b6bc936] {\n  margin-bottom: 10px; }\n\n/* line 27, stdin */\nhr[_v-2b6bc936] {\n  margin-left: -40px;\n  margin-right: -40px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-2b6bc936", module.exports)
  } else {
    hotAPI.update("_v-2b6bc936", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1304:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        'branchId': {
            default: 0
        },
        'orderId': {
            default: ''
        },
        'walkInMember': {
            default: false
        },
        setting: {
            type: Object,
            default: function _default(rawProps) {
                return {
                    enableEdit: function enableEdit(data) {
                        return true;
                    },
                    canBeDelete: true, //false
                    enableChangeMember: true //false
                };
            }
        },
        settingData: {
            type: Object,
            default: function _default(rawProps) {
                return {};
            }
        }
    },
    data: function data() {
        return {
            ajaxing: {
                getData: false,
                button: false
            }
        };
    },
    mounted: function mounted() {},

    watch: {
        branchId: function () {
            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(val, oldVal) {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function branchId(_x, _x2) {
                return _ref.apply(this, arguments);
            }

            return branchId;
        }()
    },
    methods: {
        openProductList: function openProductList(type) {
            this.$refs.list.type = type;
            this.$refs.list.openList();
        },
        appendProduct: function appendProduct(product) {
            this.$refs.select.select_product = product;
            this.$refs.select.append_mode = 'add';
            this.$refs.select.openModal();
        },
        setEditDetail: function setEditDetail(detail, productDetail) {
            this.$refs.select.select_order_detail = productDetail;
            this.$refs.select.select_product = productDetail.product;
            this.$refs.select.buy_number = productDetail.qty;
            this.$refs.select.current_selected_product_type = productDetail.product.table_type;
            this.$refs.select.select_product = productDetail.product;

            if (productDetail.order_detail_discount !== null) {
                this.$refs.select.discount_value = productDetail.order_detail_discount.value;
                this.$refs.select.discount_type = productDetail.order_detail_discount.type;
                this.$refs.select.discount_reason = productDetail.order_detail_discount.reason;
            }

            this.$refs.select.append_mode = 'edit';
            this.$refs.select.openModal();
        },
        editProduct: function editProduct(detail) {
            this.$refs.select.select_product = product;
            this.$refs.select.append_mode = 'add';
            this.$refs.select.openModal();
        },
        appendOrderDetailCallBack: function appendOrderDetailCallBack(detail) {
            var _this = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return _this.$http.post('/adminapi/pos/append_order_detail/' + detail.order_id, {
                                    'branch_id': detail.branch_id,
                                    'product_type': detail.product_type,
                                    'product_id': detail.product_id,
                                    'amount': detail.amount,
                                    'discount_type': detail.discount_type,
                                    'discount_value': detail.discount_value,
                                    'discount_reason': detail.discount_reason,
                                    'order_id': detail.order_id
                                }).then(function (_ref2) {
                                    // resolve({ order: data })

                                    var data = _ref2.data;
                                }, function (_ref3) {
                                    var data = _ref3.data;

                                    $17.swal({
                                        type: 'warning',
                                        title: data.message,
                                        showCancelButton: false
                                    });
                                });

                            case 2:
                                _this.$emit('order-changed');
                                _this.$refs.select.closeModal();

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this);
            }))();
        },
        editOrderDetailCallBack: function editOrderDetailCallBack(detail) {
            var _this2 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return _this2.$http.post('/adminapi/pos/modify_order_detail/' + detail.id, {
                                    'amount': detail.amount,
                                    'discount_value': detail.discount_value,
                                    'discount_type': detail.discount_type,
                                    'discount_reason': detail.discount_reason
                                }).then(function (_ref4) {
                                    // resolve({ order: data })

                                    var data = _ref4.data;
                                }, function (_ref5) {
                                    var data = _ref5.data;

                                    $17.swal({
                                        type: 'warning',
                                        title: data.message,
                                        showCancelButton: false
                                    });
                                });

                            case 2:
                                _this2.$emit('order-changed');
                                _this2.$refs.select.closeModal();

                            case 4:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this2);
            }))();
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        WebadminOrderEdit: function WebadminOrderEdit(state) {
            return state.webadmin.configure.webFunctions.WebadminOrderEdit;
        }
    }))
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div v-if=\"setting.enableEdit(settingData)\" _v-54ae313c=\"\">\n    <webadmin-product-operate-append-btn-utility :walk-in-member=\"walkInMember\" @product-append=\"openProductList\" _v-54ae313c=\"\">\n    </webadmin-product-operate-append-btn-utility>\n    <webadmin-product-operate-product-list-modal-utility ref=\"list\" :branch-id=\"branchId\" @product=\"appendProduct\" _v-54ae313c=\"\">\n    </webadmin-product-operate-product-list-modal-utility>\n    <webadmin-product-operate-product-select-modal-utility ref=\"select\" :branch-id=\"branchId\" :order-id=\"orderId\" :append-order-detail-callback=\"appendOrderDetailCallBack\" :edit-order-detail-callback=\"editOrderDetailCallBack\" _v-54ae313c=\"\">\n    </webadmin-product-operate-product-select-modal-utility>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-54ae313c", module.exports)
  } else {
    hotAPI.update("_v-54ae313c", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vuex":803}],1305:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\nhr[_v-31c98fd8] {\n  margin-left: -20px;\n  margin-right: -20px; }\n\n/* line 6, stdin */\n.total-col[_v-31c98fd8] {\n  font-weight: bold; }\n\n/* line 9, stdin */\n.form-horizontal > .form-group > div > *[_v-31c98fd8] {\n  text-align: right; }\n\n/* line 12, stdin */\n#refund-reson[_v-31c98fd8] {\n  text-align: left; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _isInteger = require('babel-runtime/core-js/number/is-integer');

var _isInteger2 = _interopRequireDefault(_isInteger);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            id: 'product_append',
            selected_used_discount: '',
            select_product: {
                allValueCount: "365天 無限",
                id: null,
                name: "",
                price: "",
                showPrice: "",
                type: ""
            },
            buy_number: 1,
            discount_type: 1,
            discount_value: 0,
            discount_reason: '',
            select_order_detail: {},
            append_mode: null,
            commonly_used_discounts: [],
            commonly_used_discounts_ajaxing: false
        };
    },
    props: {
        locked: false,
        branchId: {
            default: 0
        },
        orderId: {
            default: ''
        },
        appendOrderDetailCallback: Function,
        editOrderDetailCallback: Function
    },
    mounted: function mounted() {
        var vm = this;
        this.$nextTick(function () {
            $('#product_append').on('show.bs.modal', function () {
                vm.getUsedDiscount();
                if (vm.append_mode == 'add') {
                    vm.buy_number = 1;
                    vm.discount_value = 0;
                    vm.discount_type = 1;
                    vm.discount_reason = null;
                    vm.selected_used_discount = '';
                }
            });
            $('#product_append').on('hide.bs.modal', function () {
                vm.selected_used_discount = '';
                vm.commonly_used_discounts = [];
            });
        });
    },

    methods: {
        disableKeyPress: function disableKeyPress(e) {
            //46 是.//45 是-//48 是 0
            if (e.charCode == 46 || e.charCode == 45 || e.charCode == 48 && this.buy_number == 0) {
                e.preventDefault();
            }
        },
        openModal: function openModal() {
            $(this.$el).modal('show');
        },
        closeModal: function closeModal() {
            if (this.locked) return;
            $(this.$el).modal('hide');
        },
        saveBtnClicked: function saveBtnClicked() {
            var _this = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (_this.checkDiscount()) {
                                    _context.next = 2;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 2:
                                if (_this.checkReasonIsEntered()) {
                                    _context.next = 4;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 4:
                                _context.next = 6;
                                return _this.appendOrderDetailCallback({
                                    'branch_id': _this.branchId,
                                    'product_type': _this.select_product.type,
                                    'product_id': _this.select_product.id,
                                    'amount': _this.buy_number,
                                    'discount_type': _this.discount_type,
                                    'discount_value': _this.discount_value,
                                    'discount_reason': _this.discount_reason,
                                    'order_id': _this.orderId
                                });

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        editBtnClicked: function editBtnClicked() {
            var _this2 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (_this2.checkDiscount()) {
                                    _context2.next = 2;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 2:
                                if (_this2.checkReasonIsEntered()) {
                                    _context2.next = 4;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 4:
                                _context2.next = 6;
                                return _this2.editOrderDetailCallback({
                                    id: _this2.select_order_detail.id,
                                    order_id: _this2.orderId,
                                    amount: _this2.buy_number,
                                    discount_value: _this2.discount_value,
                                    discount_type: _this2.discount_type,
                                    discount_reason: _this2.discount_reason
                                });

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        removeThousandth: function removeThousandth(value) {
            if (!value) {
                return 0;
            }
            if (typeof value == 'number') {
                return value;
            }
            return value.replace(/[,]+/g, "");
        },
        formatThousandth: function formatThousandth(value) {
            return $17.moneyFormat(value);
        },
        resetProduct: function resetProduct() {
            this.select_product = {};
            this.buy_number = 1;
            this.discount_value = 0;
            this.discount_type = 1;
            this.discount_reason = null;
            this.selected_used_discount = '';
        },
        checkReasonIsEntered: function checkReasonIsEntered() {
            if (this.discount_value > 0 && !this.discount_reason) {
                $17.swal({
                    title: '請輸入折扣原因',
                    text: "",
                    type: 'error'
                });
                return false;
            }
            return true;
        },
        checkDiscount: function checkDiscount() {
            var discountValue = parseInt(this.discount_value);
            var discountType = parseInt(this.discount_type);
            var subTotal = parseInt(this.sub_total);

            if (!(0, _isInteger2.default)(discountValue)) {
                $17.swal({
                    title: '折扣輸入不正確',
                    text: "只接受整數，不接受 (負數、小數點、字元)",
                    type: 'error'
                });
                return false;
            }

            if (discountType == 1) {
                if (discountValue > subTotal || discountValue < 0) {
                    $17.swal({
                        title: '折扣金額輸入錯誤',
                        text: "折扣金額不得超過原有價格",
                        type: 'error'
                    });
                    return false;
                }
            }

            if (discountType == 2) {
                if (discountValue > 100 || discountValue < 0) {
                    $17.swal({
                        title: '折扣比例輸入錯誤',
                        text: "折扣比例區間為0-100",
                        type: 'error'
                    });
                    return false;
                }
            }
            return true;
        },
        getUsedDiscount: function getUsedDiscount() {
            var _this3 = this;

            if (!this.commonly_used_discounts.length) {
                this.commonly_used_discounts_ajaxing = true;
                this.$http.get('/adminapi/commonly_used_discounts/branch/' + this.branchId).then(function (_ref) {
                    var data = _ref.data;

                    _this3.commonly_used_discounts = data.items;
                    _this3.commonly_used_discounts_ajaxing = false;
                }, function (_ref2) {
                    var data = _ref2.data;

                    _this3.commonly_used_discounts_ajaxing = false;
                    $17.swal({
                        title: '開啟常用折扣項目發生錯誤',
                        text: "",
                        type: 'error'
                    });
                });
            }
        },
        onChangeDiscount: function onChangeDiscount() {
            if (this.selected_used_discount !== '') {
                this.discount_type = this.selected_used_discount.type;
                this.discount_value = this.selected_used_discount.value;
                this.discount_reason = this.selected_used_discount.reason;
            } else {
                this.discount_type = 1;
                this.discount_value = 0;
                this.discount_reason = '';
            }
        },
        calculateDiscountTotal: function calculateDiscountTotal(total, discountType, discountValue) {
            switch (discountType) {
                case 1:
                    return discountValue;
                    break;
                case 2:
                    return Math.round(total * (discountValue / 100));
                    break;
                default:
                    return discountValue;
            }
        },
        resetDiscountValue: function resetDiscountValue() {
            this.discount_value = 0;
            this.discount_reason = null;
        }
    },
    computed: {
        total_money: function total_money() {
            return this.sub_total - this.discount_total;
        },
        discount_total: function discount_total() {
            return this.calculateDiscountTotal(this.sub_total, this.discount_type, this.discount_value);
        },
        sub_total: function sub_total() {
            return this.buy_number * this.getPrice;
        },
        discount_ratio: function discount_ratio() {
            var discountRatio = new Number(this.discount_total / this.sub_total * 100);
            return discountRatio.toFixed(1);
        },
        getChangeAction: function getChangeAction() {
            if (this.append_mode == 'add') {
                return this.saveBtnClicked;
            }
            if (this.append_mode == 'edit') {
                return this.editBtnClicked;
            }
        },
        getChangeName: function getChangeName() {
            if (this.append_mode == 'add') {
                return '加入';
            }
            if (this.append_mode == 'edit') {
                return '修改';
            }
        },
        getAdditionShowTitle: function getAdditionShowTitle() {
            if (this.select_product.type == 'physical_products') {
                return '<span style="color: #C7C4C3;font-size: 0.5em;margin-left: 2em;">' + this.select_product.field3 + '</span>';
            }
        },
        getPrice: function getPrice() {
            if (this.append_mode == 'add') {
                return this.removeThousandth(this.select_product.price);
            }

            return this.select_order_detail.price;
        },
        canBuyMulti: function canBuyMulti() {
            return ['physical_products', 'ticket_settings'].indexOf(this.select_product.type) != -1 ? true : false;
        }
    },
    watch: {
        discount_value: function () {
            var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(newValue, oldVal) {
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                if (parseInt(this.discount_type) == 1) {
                                    if (newValue > this.sub_total || newValue < 0) {
                                        this.discount_value = 0;
                                    }
                                }

                                if (parseInt(this.discount_type) == 2) {
                                    if (newValue > 100 || newValue < 0) {
                                        this.discount_value = 0;
                                    }
                                }

                            case 2:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function discount_value(_x, _x2) {
                return _ref3.apply(this, arguments);
            }

            return discount_value;
        }()
    },
    created: function created() {}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal id=\"product_append\" open-size=\"modal-lg\" no-cancel=\"\" parallel-modal=\"\" :confirm-btn-text=\"getChangeName\" :save-clicked=\"getChangeAction\" close-btn-text=\"返回\" :close-clicked=\"resetProduct\" :keep-alive=\"false\" _v-31c98fd8=\"\">\n        <div slot=\"title\" _v-31c98fd8=\"\">{{select_product.name}}\n            <span v-html=\"getAdditionShowTitle\" _v-31c98fd8=\"\"></span>\n        </div>\n        <div slot=\"body\" _v-31c98fd8=\"\">\n            <form class=\"form-horizontal\" v-on:submit.prevent=\"\" _v-31c98fd8=\"\">\n                <div class=\"form-group\" _v-31c98fd8=\"\">\n                    <label class=\"col-sm-3\" _v-31c98fd8=\"\">價格</label>\n                    <div class=\"col-sm-3\" _v-31c98fd8=\"\">\n                        <p class=\"form-control-static\" _v-31c98fd8=\"\">{{getPrice}}</p>\n                    </div>\n                </div>\n                <div class=\"form-group\" v-show=\"canBuyMulti\" _v-31c98fd8=\"\">\n                    <label class=\"col-sm-3\" _v-31c98fd8=\"\">數量</label>\n                    <div class=\"col-sm-3\" _v-31c98fd8=\"\">\n                        <input type=\"number\" min=\"1\" class=\"form-control\" v-model=\"buy_number\" @keypress=\"disableKeyPress\" _v-31c98fd8=\"\">\n                    </div>\n                </div>\n                <hr v-show=\"canBuyMulti\" _v-31c98fd8=\"\">\n                <div class=\"form-group\" v-show=\"canBuyMulti\" _v-31c98fd8=\"\">\n                    <label class=\"col-sm-3\" _v-31c98fd8=\"\">小計</label>\n                    <div class=\"col-sm-3\" _v-31c98fd8=\"\">\n                        <p class=\"form-control-static\" _v-31c98fd8=\"\"> {{ sub_total }}</p>\n                    </div>\n                </div>\n                <div class=\"form-group\" _v-31c98fd8=\"\">\n                    <label class=\"col-sm-3\" _v-31c98fd8=\"\">常用折扣</label>\n                    <div class=\"col-sm-3\" _v-31c98fd8=\"\">\n                        <v-spinner-button :ajaxing=\"commonly_used_discounts_ajaxing\" _v-31c98fd8=\"\"></v-spinner-button>\n                        <select class=\"form-control\" v-show=\"!commonly_used_discounts_ajaxing\" v-model=\"selected_used_discount\" @change=\"onChangeDiscount\" _v-31c98fd8=\"\">\n                            <option value=\"\" _v-31c98fd8=\"\">請選擇</option>\n                            <option v-for=\"item in commonly_used_discounts\" :value=\"item\" _v-31c98fd8=\"\">\n                                {{item.name}}\n                            </option>\n                        </select>\n                    </div>\n                </div>\n                <div class=\"form-group\" _v-31c98fd8=\"\">\n                    <label class=\"col-sm-3\" _v-31c98fd8=\"\">折扣</label>\n                    <div class=\"col-sm-3\" _v-31c98fd8=\"\">\n                        <label _v-31c98fd8=\"\">\n                            <input type=\"radio\" name=\"optradio\" value=\"1\" v-model.number=\"discount_type\" @change=\"resetDiscountValue\" _v-31c98fd8=\"\"> 金額\n                        </label>\n                        <label _v-31c98fd8=\"\">\n                            <input type=\"radio\" name=\"optradio\" value=\"2\" v-model.number=\"discount_type\" @change=\"resetDiscountValue\" _v-31c98fd8=\"\"> 比例\n                        </label>\n                        <input type=\"number\" min=\"0\" :max=\"sub_total\" class=\"form-control\" v-if=\"discount_type == 1\" v-model.number=\"discount_value\" _v-31c98fd8=\"\">\n                        <input type=\"number\" min=\"0\" max=\"100\" class=\"form-control\" v-if=\"discount_type == 2\" v-model.number=\"discount_value\" _v-31c98fd8=\"\">\n                    </div>\n                </div>\n                <div class=\"form-group\" v-if=\"discount_value > 0\" _v-31c98fd8=\"\">\n                    <label class=\"col-sm-3\" _v-31c98fd8=\"\">折扣原因</label>\n                    <div class=\"col-sm-3\" _v-31c98fd8=\"\">\n                        <textarea id=\"refund-reson\" v-model.lazy=\"discount_reason\" placeholder=\"此為必填\" _v-31c98fd8=\"\"></textarea>\n                    </div>\n                </div>\n                <div class=\"form-group\" v-if=\"discount_value > 0\" _v-31c98fd8=\"\">\n                    <label class=\"col-sm-3\" _v-31c98fd8=\"\">折扣比例％</label>\n                    <div class=\"col-sm-3\" _v-31c98fd8=\"\">\n                        <p class=\"form-control-static\" _v-31c98fd8=\"\"> {{ discount_ratio }}</p>\n                    </div>\n                </div>\n                <div class=\"form-group\" v-if=\"discount_value > 0\" _v-31c98fd8=\"\">\n                    <label class=\"col-sm-3\" _v-31c98fd8=\"\">折扣金額$</label>\n                    <div class=\"col-sm-3\" _v-31c98fd8=\"\">\n                        <p class=\"form-control-static\" _v-31c98fd8=\"\"> {{ discount_total }}</p>\n                    </div>\n                </div>\n                <hr _v-31c98fd8=\"\">\n                <div class=\"form-group total-col\" _v-31c98fd8=\"\">\n                    <label class=\"col-sm-3\" _v-31c98fd8=\"\">總計</label>\n                    <div class=\"col-sm-3\" _v-31c98fd8=\"\">\n                        <p class=\"form-control-static\" _v-31c98fd8=\"\"> {{ total_money }}</p>\n                    </div>\n                </div>\n            </form>\n        </div>\n</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\nhr[_v-31c98fd8] {\n  margin-left: -20px;\n  margin-right: -20px; }\n\n/* line 6, stdin */\n.total-col[_v-31c98fd8] {\n  font-weight: bold; }\n\n/* line 9, stdin */\n.form-horizontal > .form-group > div > *[_v-31c98fd8] {\n  text-align: right; }\n\n/* line 12, stdin */\n#refund-reson[_v-31c98fd8] {\n  text-align: left; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-31c98fd8", module.exports)
  } else {
    hotAPI.update("_v-31c98fd8", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/number/is-integer":49,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1306:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.outsid-border[_v-622d368e] {\n  border: 2px solid #c7c4c3;\n  border-bottom: 0px;\n  margin-bottom: -10px; }\n  /* line 7, stdin */\n  .outsid-border .btn[_v-622d368e] {\n    margin: 10px 0 10px 20px; }\n\n/* line 11, stdin */\n.more-space[_v-622d368e] {\n  margin: 10px 15px; }\n\n/* line 15, stdin */\n.small-space[_v-622d368e] {\n  margin-right: 5px; }\n\n/* line 19, stdin */\n.right-space[_v-622d368e] {\n  margin-right: 15px; }\n\n/* line 23, stdin */\n.left-space[_v-622d368e] {\n  margin-left: 15px; }\n\n/* line 27, stdin */\n.order-edit .search-member[_v-622d368e] {\n  margin-top: 0px; }\n\n/* line 31, stdin */\n.commonly-used-items[_v-622d368e] {\n  word-break: break-all;\n  background-color: #eee;\n  min-height: 100vh; }\n  /* line 36, stdin */\n  .commonly-used-items .commonly-item.btn-default[_v-622d368e]:active {\n    background-color: #fff; }\n")
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vuex = require("vuex");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    setting: {
      type: Object,
      default: function _default(rawProps) {
        return {
          order: {
            canBeDelete: true //false
          },
          branch: {
            enableEdit: function enableEdit(data) {
              return true;
            } //false
          },
          member: {
            enableEdit: function enableEdit(data) {
              return true;
            }
          },
          details: {
            enableEdit: function enableEdit(data) {
              return true;
            }
          },
          remark: {
            enableEdit: function enableEdit(data) {
              return true;
            }
          },
          salesman: {
            enableEdit: function enableEdit(data) {
              return true;
            }
          },
          invoice: {
            enableEdit: function enableEdit(data) {
              return true;
            }
          },
          payments: {
            enableEdit: function enableEdit(data) {
              return true;
            }
          }
        };
      }
    },
    getOrder: {
      type: Function
    },
    defaultOrderData: {
      type: Object,
      default: function _default(rawProps) {
        return {};
      }
    },
    enableChangeMember: {
      default: true
    },
    eventType: {
      default: 'general'
    }
  },
  data: function data() {
    return {
      ajaxing: {
        appendDetail: false,
        editOrder: false,
        getOrder: false
      },
      refund_reason: "",

      currentOrder: {
        //思考要不要向上提供元件共用
        order: {
          id: "",
          total: 0,
          remark: ""
        },
        branch: {
          studio_id: 0,
          branch_id: 0
        },
        member: {
          id: "",
          photo: "",
          name: "",
          is_walkin: "",
          phone: "",
          email: ""
        },
        detailStatus: {},
        details: [],
        invoice: {
          order_invoice_active: false,
          issue_method_select: null,
          carrier_number: ""
        },
        payments: []
      },
      actionData: {
        refundReason: "",
        invoice: {
          order_auto_allowance_issue: false
        },
        payments: {},
        details: {}
      },
      defaultDetailsData: {}
    };
  },

  methods: {
    execGetOrder: function execGetOrder() {
      var _this = this;

      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.ajaxing.getOrder = true;
                _context.next = 3;
                return _this.getOrder(_this);

              case 3:
                _this.ajaxing.getOrder = false;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    updateActionData: function updateActionData(payload) {

      if (payload.type == "payment") {
        this.$set(this.actionData.payments, payload.payment_action_record_id, {
          payment_method_select: payload.payment_method_select,
          payment_type_id: payload.payment_type_id
        });
      }
      if (payload.type == "details") {
        this.actionData.details = payload.data;
      }
    },
    clearActionData: function clearActionData() {
      this.actionData = {
        refundReason: "",
        invoice: {
          order_auto_allowance_issue: false
        },
        payments: {},
        details: {}
      };
      this.defaultDetailsData = {};
    },
    setAlertObj: function setAlertObj(obj) {
      this.$emit("set-alert-obj", obj);
    },
    setDefaultData: function setDefaultData(dataObject) {
      this.actionData.refundReason = dataObject.reason;
      this.defaultDetailsData = dataObject.details;
    },
    close: function close() {
      console.log("Event");
    }
  },
  computed: {
    disableStudio: function disableStudio() {
      return this.checkHasProduct || this.ajaxing.appendDetail || this.currentOrder.branch.branch_id == 0;
    },
    disableBranch: function disableBranch() {
      return this.checkHasProduct || this.ajaxing.appendDetail || this.currentOrder.branch.branch_id == 0;
    },
    checkHasProduct: function checkHasProduct() {
      return this.currentOrder.details && this.currentOrder.details.length > 0 ? true : false;
    },
    enableChangeMemberCheck: function enableChangeMemberCheck() {
      return this.enableChangeMember && !this.checkHasProduct ? true : false;
    },
    isRefundOrder: function isRefundOrder() {
      return this.currentOrder.order.origin_order_id != null;
    },

    invoice_number: function invoice_number() {
      return this.currentOrder.invoice && this.currentOrder.invoice.invoice_number ? this.currentOrder.invoice.invoice_number : false;
    }
  },
  mounted: function mounted() {
    this.currentOrder = this.defaultOrderData;
    this.actionData.invoice.order_auto_allowance_issue = this.defaultOrderData.invoice.auto_allowance_issue ? true : false;
    if (this.defaultOrderData.member && this.defaultOrderData.member.id) {
      this.$store.commit("filters/SETSTATUS", {
        key: "selected_search_member_id",
        value: this.defaultOrderData.member.id
      });
    }
  },

  watch: (0, _extends3.default)({}, (0, _vuex.mapState)({
    WebadminOrderEdit: function WebadminOrderEdit(state) {
      return state.webadmin.configure.webFunctions.WebadminOrderEdit;
    }
  }))
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"row\" style=\"min-height: 100%\" _v-622d368e=\"\">\n  <div class=\"order-refund col-md-12 st-pb-5\" _v-622d368e=\"\">\n    <webadmin-order-operate-branch-utility :setting=\"setting.branch\" :studio-id=\"currentOrder.branch.studio_id\" :branch-id=\"currentOrder.branch.branch_id\" :disable-studio=\"disableStudio\" :disable-branch=\"disableBranch\" :order-id=\"currentOrder.order.id\" _v-622d368e=\"\">\n    </webadmin-order-operate-branch-utility>\n    <webadmin-order-operate-member-utility :setting=\"setting.member\" :order-id=\"currentOrder.order.id\" :member-data=\"currentOrder.member\" :enable-change-member=\"enableChangeMemberCheck\" _v-622d368e=\"\"></webadmin-order-operate-member-utility>\n    <webadmin-order-detail-status-utility type=\"refund\" :invoice=\"currentOrder.invoice\" _v-622d368e=\"\"></webadmin-order-detail-status-utility>\n    <webadmin-order-operate-order-detail-list-refund-utility :setting=\"setting.details\" :details=\"currentOrder.details\" :order=\"currentOrder.order\" @order-changed=\"execGetOrder\" @update-refund-detail=\"updateActionData\" :default-details-data=\"defaultDetailsData\" _v-622d368e=\"\">\n    </webadmin-order-operate-order-detail-list-refund-utility>\n    <webadmin-order-operate-branch-payment-payment-show-method-utility :payments=\"currentOrder.payments\" :allow-show-verification-appropriation-sum=\"true\" _v-622d368e=\"\"></webadmin-order-operate-branch-payment-payment-show-method-utility>\n    <webadmin-order-operate-branch-payment-methods-utility v-for=\"payment in currentOrder.payments\" :setting=\"setting.payments\" :order=\"currentOrder.order\" :member=\"currentOrder.member\" :branch-id=\"currentOrder.branch.branch_id\" :studio-id=\"currentOrder.branch.studio_id\" :payment=\"payment\" current-type=\"refund\" :init-value=\"payment.selected_method_id\" payment-method-header=\"退費方式\" @update-refund-payment-method=\"updateActionData\" _v-622d368e=\"\">\n    </webadmin-order-operate-branch-payment-methods-utility>\n    <div _v-622d368e=\"\">\n      <div class=\"row st-mx-0\" _v-622d368e=\"\">\n        <div class=\"col-xs-2\" _v-622d368e=\"\">\n          <label for=\"refundReason\" class=\"st-text-right\" _v-622d368e=\"\">退費原因</label>\n        </div>\n        <div class=\"col-xs-10\" _v-622d368e=\"\">\n          <textarea cols=\"30\" rows=\"10\" maxlength=\"255\" placeholder=\"輸入原因（必填）\" v-model=\"actionData.refundReason\" id=\"refundReason\" _v-622d368e=\"\"></textarea>\n        </div>\n      </div>\n    </div>\n    <div class=\"row\" _v-622d368e=\"\">\n      <div class=\"col-sm-offset-9 col-sm-3 text-right\" _v-622d368e=\"\">\n        <span v-if=\"invoice_number\" _v-622d368e=\"\">\n          <input type=\"checkbox\" id=\"order_auto_allowance_issue\" v-model=\"actionData.invoice.order_auto_allowance_issue\" _v-622d368e=\"\">\n          <label for=\"order_auto_allowance_issue\" _v-622d368e=\"\">退費後，同步折讓發票</label>\n        </span>\n      </div>\n    </div>\n    <webadmin-order-operate-action-bar-refund-utility :setting=\"setting\" :order=\"currentOrder.order\" :branch=\"currentOrder.branch\" :member=\"currentOrder.member\" :details=\"currentOrder.details\" :invoice=\"currentOrder.invoice\" :payments=\"currentOrder.payments\" :action-data=\"actionData\" :order-changing=\"ajaxing.getOrder\" :check-states=\"currentOrder.check_states\" @set-alert-obj=\"setAlertObj\" @clear-action-data=\"clearActionData\" _v-622d368e=\"\">\n    </webadmin-order-operate-action-bar-refund-utility>\n  </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.outsid-border[_v-622d368e] {\n  border: 2px solid #c7c4c3;\n  border-bottom: 0px;\n  margin-bottom: -10px; }\n  /* line 7, stdin */\n  .outsid-border .btn[_v-622d368e] {\n    margin: 10px 0 10px 20px; }\n\n/* line 11, stdin */\n.more-space[_v-622d368e] {\n  margin: 10px 15px; }\n\n/* line 15, stdin */\n.small-space[_v-622d368e] {\n  margin-right: 5px; }\n\n/* line 19, stdin */\n.right-space[_v-622d368e] {\n  margin-right: 15px; }\n\n/* line 23, stdin */\n.left-space[_v-622d368e] {\n  margin-left: 15px; }\n\n/* line 27, stdin */\n.order-edit .search-member[_v-622d368e] {\n  margin-top: 0px; }\n\n/* line 31, stdin */\n.commonly-used-items[_v-622d368e] {\n  word-break: break-all;\n  background-color: #eee;\n  min-height: 100vh; }\n  /* line 36, stdin */\n  .commonly-used-items .commonly-item.btn-default[_v-622d368e]:active {\n    background-color: #fff; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-622d368e", module.exports)
  } else {
    hotAPI.update("_v-622d368e", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1307:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    Default: {
        Default: {
            action: {
                enableAction: function enableAction(data) {
                    return false;
                },
                billCheckCallback: function billCheckCallback(data) {
                    return false;
                },
                constructPaymentInput: function constructPaymentInput(data) {
                    return {};
                }
            },
            branch: {
                enableEdit: function enableEdit(data) {
                    return false;
                }
            },
            member: {
                enableEdit: function enableEdit(data) {
                    return false;
                }
            },
            details: {
                enableEdit: function enableEdit(data) {
                    return false;
                }
            },
            remark: {
                enableEdit: function enableEdit(data) {
                    return false;
                }
            },
            salesman: {
                enableEdit: function enableEdit(data) {
                    return false;
                }
            },
            invoice: {
                enableEdit: function enableEdit(data) {
                    return false;
                }
            },
            payments: {
                enableEdit: function enableEdit(data) {
                    return false;
                }
            }
        }
    },
    Init: {
        //預設行為
        "Cash": {
            action: {
                enableAction: function enableAction(data) {
                    return true;
                },
                billCheckCallback: function billCheckCallback(data) {
                    return true;
                },
                constructPaymentInput: function constructPaymentInput(data) {
                    return {};
                }
            },
            branch: {
                enableEdit: function enableEdit(data) {
                    return true;
                }
            },
            member: {
                enableEdit: function enableEdit(data) {
                    return true;
                }
            },
            details: {
                enableEdit: function enableEdit(data) {
                    return true;
                }
            },
            remark: {
                enableEdit: function enableEdit(data) {
                    return true;
                }
            },
            salesman: {
                enableEdit: function enableEdit(data) {
                    return true;
                }
            },
            invoice: {
                enableEdit: function enableEdit(data) {
                    return true;
                }
            },
            payments: {
                enableEdit: function enableEdit(data) {
                    return true;
                }
            }
        },
        "Neweb.Credit": {
            action: {
                enableAction: function enableAction(data) {
                    return true;
                },
                billCheckCallback: function billCheckCallback(data) {
                    var creditInput = data.actionData.creditInput;
                    var payment = data.payment;
                    var order = data.order;

                    if (payment.payment_type_id === 2 && creditInput.auth_type != "auth" && creditInput.auth_type != "auth-auto-pay-plan") {

                        if (creditInput.credit_num.length < 13) {
                            $17.swal({
                                title: "信用卡號長度錯誤",
                                text: "",
                                type: "warning",
                                showCancelButton: false
                            });
                            return false;
                        }

                        if (creditInput.cvs.length < 3 || creditInput.cvs.length > 4) {
                            $17.swal({
                                title: "安全碼須為3碼",
                                text: "",
                                showCancelButton: false,
                                type: "warning"
                            });
                            return false;
                        }

                        var expiDate = creditInput.expi_year + creditInput.expi_mon;

                        if (moment(expiDate, "YYYYMM").isValid() && moment(expiDate, "YYYYMMDD").isBefore(moment())) {
                            $17.swal({
                                title: "信用卡到期日設定錯誤",
                                text: "",
                                showCancelButton: false,
                                type: "warning"
                            });
                            return false;
                        }
                    }

                    if (creditInput.auth_type == "auth") {
                        if (!creditInput.exist_main_card || !order.allow_main_credit) {
                            $17.swal({
                                title: "支付方式錯誤",
                                text: "請聯繫客戶在線上輸入新的信用卡，或選擇其他支付方式",
                                showCancelButton: false,
                                type: "warning"
                            });
                            return false;
                        }
                    }

                    if (creditInput.auth_type == "auth-auto-pay-plan") {
                        if (!creditInput.exist_auto_pay_cards || !order.is_auto_pay_order) {
                            $17.swal({
                                title: "支付方式錯誤",
                                text: "尚未有授權信用卡，請使用輸入信用卡，或選擇其他支付方式",
                                showCancelButton: false,
                                type: "warning"
                            });
                            return false;
                        }
                    }
                    return true;
                },
                constructPaymentInput: function constructPaymentInput(constructData) {
                    var creditInput = constructData.actionData.creditInput;
                    var order = constructData.order;
                    var data = {};

                    if (creditInput.auth_type == "input" && creditInput.credit_num.length != 0 && creditInput.cvs.length != 0) {
                        data["credit_info"] = {
                            auth_type: creditInput.auth_type,
                            credit_num: creditInput.credit_num,
                            cvs: creditInput.cvs,
                            expi_mon: creditInput.expi_mon,
                            expi_year: creditInput.expi_year
                        };
                    }
                    if (creditInput.auth_type == "auth") {
                        data["credit_info"] = {
                            auth_type: creditInput.auth_type
                        };
                    }

                    if (creditInput.auth_type == "auth-auto-pay-plan") {
                        data["credit_info"] = {
                            auth_type: creditInput.auth_type
                        };
                    }

                    if (order.is_auto_pay_order) {
                        data["bind_auto_pay_plan_credit_card_payload"] = 1;
                    }

                    return data;
                }
            },
            branch: {
                enableEdit: function enableEdit(data) {
                    return true;
                } //false
            },
            member: {
                enableEdit: function enableEdit(data) {
                    return true;
                }
            },
            details: {
                enableEdit: function enableEdit(data) {
                    return true;
                }
            },
            remark: {
                enableEdit: function enableEdit(data) {
                    return true;
                }
            },
            salesman: {
                enableEdit: function enableEdit(data) {
                    return true;
                }
            },
            invoice: {
                enableEdit: function enableEdit(data) {
                    return true;
                }
            },
            payments: {
                enableEdit: function enableEdit(data) {
                    return true;
                }
            }
        },
        "LinePay.LinePayBack": {
            action: {
                enableAction: function enableAction(data) {
                    return true;
                },
                billCheckCallback: function billCheckCallback(data) {
                    var customUserInput = data.actionData.customUserInput;

                    if (customUserInput.key.length == 0) {
                        $17.swal({
                            title: "支付方式錯誤",
                            text: "請輸入LinePay 條碼",
                            showCancelButton: false,
                            type: "warning"
                        });
                        return false;
                    }

                    return true;
                },
                constructPaymentInput: function constructPaymentInput(constructData) {
                    var customUserInput = constructData.actionData.customUserInput;
                    var data = {};

                    if (customUserInput.key.length != 0) {
                        data["third_custom_user_key"] = customUserInput.key;
                    }
                    return data;
                }
            },
            branch: {
                enableEdit: function enableEdit(data) {
                    return true;
                } //false
            },
            member: {
                enableEdit: function enableEdit(data) {
                    return true;
                }
            },
            details: {
                enableEdit: function enableEdit(data) {
                    return true;
                }
            },
            remark: {
                enableEdit: function enableEdit(data) {
                    return true;
                }
            },
            salesman: {
                enableEdit: function enableEdit(data) {
                    return true;
                }
            },
            invoice: {
                enableEdit: function enableEdit(data) {
                    return true;
                }
            },
            payments: {
                enableEdit: function enableEdit(data) {
                    return true;
                }
            }
        },
        "Neweb.BankTransfer": {
            action: {
                enableAction: function enableAction(data) {
                    return false;
                },
                billCheckCallback: function billCheckCallback(data) {
                    return true;
                },
                constructPaymentInput: function constructPaymentInput(constructData) {
                    return {};
                }
            },
            branch: {
                enableEdit: function enableEdit(data) {
                    return false;
                } //false
            },
            member: {
                enableEdit: function enableEdit(data) {
                    return false;
                }
            },
            details: {
                enableEdit: function enableEdit(data) {
                    return false;
                }
            },
            remark: {
                enableEdit: function enableEdit(data) {
                    return false;
                }
            },
            salesman: {
                enableEdit: function enableEdit(data) {
                    return false;
                }
            },
            invoice: {
                enableEdit: function enableEdit(data) {
                    return false;
                }
            },
            payments: {
                enableEdit: function enableEdit(data) {
                    return false;
                }
            }
        }
    }
};

},{}],1308:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    Default: {
        Default: {
            action: {
                enableAction: function enableAction(data) {
                    return false;
                },
                refundMod: function refundMod(data) {
                    return 'refund';
                }
            },
            branch: {
                enableEdit: function enableEdit(data) {
                    return false;
                } //false
            },
            member: {
                enableEdit: function enableEdit(data) {
                    return false;
                }
            },
            details: {
                enableEdit: function enableEdit(data) {
                    return false;
                }
            },
            remark: {
                enableEdit: function enableEdit(data) {
                    return false;
                }
            },
            salesman: {
                enableEdit: function enableEdit(data) {
                    return false;
                }
            },
            invoice: {
                enableEdit: function enableEdit(data) {
                    return false;
                }
            },
            payments: {
                enableEdit: function enableEdit(data) {
                    return false;
                }
            }
        }
    },
    Completed: {
        Default: {
            action: {
                enableAction: function enableAction(data) {
                    return true;
                },
                refundMod: function refundMod(data) {
                    return 'refund';
                }
            },
            branch: {
                enableEdit: function enableEdit(data) {
                    return false;
                } //false
            },
            member: {
                enableEdit: function enableEdit(data) {
                    return false;
                }
            },
            details: {
                enableEdit: function enableEdit(data) {
                    return true;
                }
            },
            remark: {
                enableEdit: function enableEdit(data) {
                    return false;
                }
            },
            salesman: {
                enableEdit: function enableEdit(data) {
                    return false;
                }
            },
            invoice: {
                enableEdit: function enableEdit(data) {
                    return false;
                }
            },
            payments: {
                enableEdit: function enableEdit(data) {
                    return true;
                }
            }
        },
        "Neweb.Credit": {
            action: {
                enableAction: function enableAction(data) {
                    return true;
                },
                refundMod: function () {
                    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(data) {
                        var mod;
                        return _regenerator2.default.wrap(function _callee$(_context) {
                            while (1) {
                                switch (_context.prev = _context.next) {
                                    case 0:
                                        if (!data.isSeventeen) {
                                            _context.next = 2;
                                            break;
                                        }

                                        return _context.abrupt('return', 'refund');

                                    case 2:
                                        mod = '';
                                        _context.next = 5;
                                        return data.http.get('/adminapi/verification-appropriation/setting/branch/' + data.branch_id + '/studio_payment_method?studio_payment_method_id=' + data.studio_payment_method_id).then(function (response) {

                                            if (response.data.id) {
                                                mod = 'refund-request';
                                            } else {
                                                mod = 'refund';
                                            }
                                        });

                                    case 5:

                                        if (mod == 'refund-request' && data.payment.payment_type_id != 2) {
                                            mod = 'refund';
                                        }

                                        return _context.abrupt('return', mod);

                                    case 7:
                                    case 'end':
                                        return _context.stop();
                                }
                            }
                        }, _callee, undefined);
                    }));

                    return function refundMod(_x) {
                        return _ref.apply(this, arguments);
                    };
                }()
            },
            branch: {
                enableEdit: function enableEdit(data) {
                    return false;
                } //false
            },
            member: {
                enableEdit: function enableEdit(data) {
                    return false;
                }
            },
            details: {
                enableEdit: function enableEdit(data) {
                    return true;
                }
            },
            remark: {
                enableEdit: function enableEdit(data) {
                    return false;
                }
            },
            salesman: {
                enableEdit: function enableEdit(data) {
                    return false;
                }
            },
            invoice: {
                enableEdit: function enableEdit(data) {
                    return false;
                }
            },
            payments: {
                enableEdit: function enableEdit(data) {
                    return true;
                }
            }
        }
    },
    Refund: {
        Default: {
            action: {
                enableAction: function enableAction(data) {
                    return true;
                },
                refundMod: function () {
                    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(data) {
                        var mod;
                        return _regenerator2.default.wrap(function _callee2$(_context2) {
                            while (1) {
                                switch (_context2.prev = _context2.next) {
                                    case 0:
                                        if (!data.isSeventeen) {
                                            _context2.next = 2;
                                            break;
                                        }

                                        return _context2.abrupt('return', 'refund');

                                    case 2:
                                        mod = '';
                                        _context2.next = 5;
                                        return data.http.get('/adminapi/verification-appropriation/setting/branch/' + data.branch_id + '/studio_payment_method?studio_payment_method_id=' + data.studio_payment_method_id).then(function (response) {

                                            if (response.data.id) {
                                                mod = 'refund-request';
                                            } else {
                                                mod = 'refund';
                                            }
                                        });

                                    case 5:

                                        if (mod == 'refund-request' && data.payment.payment_type_id != 2) {
                                            mod = 'refund';
                                        }

                                        return _context2.abrupt('return', mod);

                                    case 7:
                                    case 'end':
                                        return _context2.stop();
                                }
                            }
                        }, _callee2, undefined);
                    }));

                    return function refundMod(_x2) {
                        return _ref2.apply(this, arguments);
                    };
                }()
            },
            branch: {
                enableEdit: function enableEdit(data) {
                    return false;
                } //false
            },
            member: {
                enableEdit: function enableEdit(data) {
                    return false;
                }
            },
            details: {
                enableEdit: function enableEdit(data) {
                    return true;
                }
            },
            remark: {
                enableEdit: function enableEdit(data) {
                    return false;
                }
            },
            salesman: {
                enableEdit: function enableEdit(data) {
                    return false;
                }
            },
            invoice: {
                enableEdit: function enableEdit(data) {
                    return false;
                }
            },
            payments: {
                enableEdit: function enableEdit(data) {
                    return true;
                }
            }
        }
    }
};

},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/regenerator":75}],1309:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    Default: {
        Default: {
            action: {
                enableAction: function enableAction(data) {
                    return false;
                },
                billCheckCallback: function billCheckCallback(data) {
                    return false;
                },
                constructPaymentInput: function constructPaymentInput(data) {
                    return {};
                }
            },
            branch: {
                enableEdit: function enableEdit(data) {
                    return false;
                } //false
            },
            member: {
                enableEdit: function enableEdit(data) {
                    return false;
                }
            },
            details: {
                enableEdit: function enableEdit(data) {
                    return false;
                }
            },
            remark: {
                enableEdit: function enableEdit(data) {
                    return false;
                }
            },
            salesman: {
                enableEdit: function enableEdit(data) {
                    return false;
                }
            },
            invoice: {
                enableEdit: function enableEdit(data) {
                    return false;
                }
            },
            payments: {
                enableEdit: function enableEdit(data) {
                    return false;
                }
            }
        }
    },
    Completed: {
        Default: {
            action: {
                enableAction: function enableAction(data) {
                    return true;
                },
                billCheckCallback: function billCheckCallback(data) {
                    return false;
                },
                constructPaymentInput: function constructPaymentInput(data) {
                    return {};
                }
            },
            branch: {
                enableEdit: function enableEdit(data) {
                    return false;
                } //false
            },
            member: {
                enableEdit: function enableEdit(data) {
                    return false;
                }
            },
            details: {
                enableEdit: function enableEdit(data) {
                    return false;
                }
            },
            remark: {
                enableEdit: function enableEdit(data) {
                    return true;
                }
            },
            salesman: {
                enableEdit: function enableEdit(data) {
                    return true;
                }
            },
            invoice: {
                enableEdit: function enableEdit(data) {
                    return true;
                }
            },
            payments: {
                enableEdit: function enableEdit(data) {
                    return false;
                }
            }
        }
    },
    Refund: {
        Default: {
            action: {
                enableAction: function enableAction(data) {
                    return true;
                },
                billCheckCallback: function billCheckCallback(data) {
                    return false;
                },
                constructPaymentInput: function constructPaymentInput(data) {
                    return {};
                }
            },
            branch: {
                enableEdit: function enableEdit(data) {
                    return false;
                } //false
            },
            member: {
                enableEdit: function enableEdit(data) {
                    return false;
                }
            },
            details: {
                enableEdit: function enableEdit(data) {
                    return false;
                }
            },
            remark: {
                enableEdit: function enableEdit(data) {
                    return true;
                }
            },
            salesman: {
                enableEdit: function enableEdit(data) {
                    return true;
                }
            },
            invoice: {
                enableEdit: function enableEdit(data) {
                    return true;
                }
            },
            payments: {
                enableEdit: function enableEdit(data) {
                    return false;
                }
            }
        }
    },
    RefundCompleted: {
        Default: {
            action: {
                enableAction: function enableAction(data) {
                    return true;
                },
                billCheckCallback: function billCheckCallback(data) {
                    return false;
                },
                constructPaymentInput: function constructPaymentInput(data) {
                    return {};
                }
            },
            branch: {
                enableEdit: function enableEdit(data) {
                    return false;
                } //false
            },
            member: {
                enableEdit: function enableEdit(data) {
                    return false;
                }
            },
            details: {
                enableEdit: function enableEdit(data) {
                    return false;
                }
            },
            remark: {
                enableEdit: function enableEdit(data) {
                    return true;
                }
            },
            salesman: {
                enableEdit: function enableEdit(data) {
                    return true;
                }
            },
            invoice: {
                enableEdit: function enableEdit(data) {
                    return true;
                }
            },
            payments: {
                enableEdit: function enableEdit(data) {
                    return false;
                }
            }
        }
    },
    Invalid: {
        Default: {
            action: {
                enableAction: function enableAction(data) {
                    return true;
                },
                billCheckCallback: function billCheckCallback(data) {
                    return false;
                },
                constructPaymentInput: function constructPaymentInput(data) {
                    return {};
                }
            },
            branch: {
                enableEdit: function enableEdit(data) {
                    return false;
                } //false
            },
            member: {
                enableEdit: function enableEdit(data) {
                    return false;
                }
            },
            details: {
                enableEdit: function enableEdit(data) {
                    return false;
                }
            },
            remark: {
                enableEdit: function enableEdit(data) {
                    return false;
                }
            },
            salesman: {
                enableEdit: function enableEdit(data) {
                    return false;
                }
            },
            invoice: {
                enableEdit: function enableEdit(data) {
                    return false;
                }
            },
            payments: {
                enableEdit: function enableEdit(data) {
                    return false;
                }
            }
        }
    }
};

},{}],1310:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.outsid-border[_v-01cd1029] {\n  border: 2px solid #c7c4c3;\n  border-bottom: 0px;\n  margin-bottom: -10px; }\n  /* line 7, stdin */\n  .outsid-border .btn[_v-01cd1029] {\n    margin: 10px 0 10px 20px; }\n\n/* line 12, stdin */\n.more-space[_v-01cd1029] {\n  margin: 10px 15px; }\n\n/* line 16, stdin */\n.small-space[_v-01cd1029] {\n  margin-right: 5px; }\n\n/* line 20, stdin */\n.right-space[_v-01cd1029] {\n  margin-right: 15px; }\n\n/* line 24, stdin */\n.left-space[_v-01cd1029] {\n  margin-left: 15px; }\n\n/* line 28, stdin */\n.order-edit .search-member[_v-01cd1029] {\n  margin-top: 0px; }\n\n/* line 32, stdin */\n.commonly-used-items[_v-01cd1029] {\n  word-break: break-all;\n  background-color: #eee;\n  min-height: 100vh; }\n  /* line 37, stdin */\n  .commonly-used-items .commonly-item.btn-default[_v-01cd1029]:active {\n    background-color: #fff; }\n")
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vuex = require("vuex");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        setting: {
            type: Object,
            default: function _default(rawProps) {
                return {
                    order: {
                        canBeDelete: true //false
                    },
                    branch: {
                        enableEdit: function enableEdit(data) {
                            return true;
                        } //false
                    },
                    member: {
                        enableEdit: function enableEdit(data) {
                            return true;
                        }
                    },
                    details: {
                        enableEdit: function enableEdit(data) {
                            return true;
                        }
                    },
                    remark: {
                        enableEdit: function enableEdit(data) {
                            return true;
                        }
                    },
                    salesman: {
                        enableEdit: function enableEdit(data) {
                            return true;
                        }
                    },
                    invoice: {
                        enableEdit: function enableEdit(data) {
                            return true;
                        }
                    },
                    payments: {
                        enableEdit: function enableEdit(data) {
                            return true;
                        }
                    }
                };
            }
        },
        getOrder: {
            type: Function
        },
        defaultOrderData: {
            type: Object,
            default: function _default(rawProps) {
                return {};
            }
        },
        enableChangeMember: {
            default: true
        },
        eventType: {
            default: 'general'
        }
    },
    data: function data() {
        return {
            ajaxing: {
                appendDetail: false,
                editOrder: false,
                getOrder: false
            },
            currentOrder: {
                //思考要不要向上提供元件共用
                order: {
                    id: "",
                    total: 0,
                    remark: ""
                },
                branch: {
                    studio_id: 0,
                    branch_id: 0
                },
                member: {
                    id: "",
                    photo: "",
                    name: "",
                    is_walkin: "",
                    phone: "",
                    email: ""
                },
                detailStatus: {},
                details: [],
                invoice: {
                    order_invoice_active: false,
                    issue_method_select: null,
                    carrier_number: ""
                },
                payments: []
            },
            actionData: {
                invoice: {},
                payments: {}
            }
        };
    },

    methods: {
        execGetOrder: function execGetOrder() {
            var _this = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.ajaxing.getOrder = true;
                                _context.next = 3;
                                return _this.getOrder(_this);

                            case 3:
                                _this.ajaxing.getOrder = false;

                            case 4:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        updateActionData: function updateActionData(payload) {
            if (payload.type == "invoice") {
                this.actionData.invoice = payload.data;
            }

            if (payload.type == "payment") {
                this.actionData.payments[payload.payment_action_record_id] = payload.data;
            }
        },
        clearActionData: function clearActionData() {
            this.actionData = {
                invoice: {},
                payments: {}
            };
        },
        setAlertObj: function setAlertObj(obj) {
            this.$emit("set-alert-obj", obj);
        },
        close: function close() {
            console.log("Event");
        }
    },
    computed: {
        disableStudio: function disableStudio() {
            return this.checkHasProduct || this.ajaxing.appendDetail || this.currentOrder.branch.branch_id == 0;
        },
        disableBranch: function disableBranch() {
            return this.checkHasProduct || this.ajaxing.appendDetail || this.currentOrder.branch.branch_id == 0;
        },
        checkHasProduct: function checkHasProduct() {
            return this.currentOrder.details && this.currentOrder.details.length > 0 ? true : false;
        },
        enableChangeMemberCheck: function enableChangeMemberCheck() {
            return this.enableChangeMember && !this.checkHasProduct ? true : false;
        },
        isRefundOrder: function isRefundOrder() {
            return this.currentOrder.order.origin_order_id != null;
        },
        paymentMethodHeader: function paymentMethodHeader() {
            if (this.isRefundOrder) {
                return '退費方式';
            }

            return '支付方式';
        },
        currentOrderPayments: function currentOrderPayments() {
            return [this.currentOrder.payments[0]];
            //暫時只取第一個
            // return this.currentOrder.payments;
        }
    },
    mounted: function mounted() {
        this.currentOrder = this.defaultOrderData;
        if (this.defaultOrderData.member && this.defaultOrderData.member.id) {
            this.$store.commit("filters/SETSTATUS", {
                key: "selected_search_member_id",
                value: this.defaultOrderData.member.id
            });
        }
    },

    watch: (0, _extends3.default)({
        defaultOrderData: {
            handler: function handler(newValue, oldValue) {
                this.currentOrder = newValue;
                if (newValue.member && newValue.member.id) {
                    this.$store.commit("filters/SETSTATUS", {
                        key: "selected_search_member_id",
                        value: newValue.member.id
                    });
                }
            },

            deep: true
        }
    }, (0, _vuex.mapState)({
        WebadminOrderEdit: function WebadminOrderEdit(state) {
            return state.webadmin.configure.webFunctions.WebadminOrderEdit;
        }
    }))
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"row\" style=\"min-height: 100%\" _v-01cd1029=\"\">\n    <div class=\"order-show col-md-12 st-pb-5\" _v-01cd1029=\"\">\n        <webadmin-order-operate-branch-utility :setting=\"setting.branch\" :studio-id=\"currentOrder.branch.studio_id\" :branch-id=\"currentOrder.branch.branch_id\" :disable-studio=\"disableStudio\" :disable-branch=\"disableBranch\" :order-id=\"currentOrder.order.id\" _v-01cd1029=\"\">\n        </webadmin-order-operate-branch-utility>\n        <webadmin-order-operate-member-utility :setting=\"setting.member\" :order-id=\"currentOrder.order.id\" :member-data=\"currentOrder.member\" :enable-change-member=\"enableChangeMemberCheck\" _v-01cd1029=\"\"></webadmin-order-operate-member-utility>\n        <webadmin-order-detail-status-utility :invoice=\"currentOrder.invoice\" :order=\"currentOrder.order\" _v-01cd1029=\"\"></webadmin-order-detail-status-utility>\n        <webadmin-order-operate-order-detail-list-show-utility :setting=\"setting.details\" :details=\"currentOrder.details\" :order=\"currentOrder.order\" @order-changed=\"execGetOrder\" _v-01cd1029=\"\">\n        </webadmin-order-operate-order-detail-list-show-utility>\n        <webadmin-order-operate-order-issue-method-utility v-if=\"!isRefundOrder\" :setting=\"setting.invoice\" :order=\"currentOrder.order\" :branch-id=\"currentOrder.branch.branch_id\" :invoice=\"currentOrder.invoice\" :member-email=\"currentOrder.member.email\" :manual-invoice-number=\"currentOrder.invoice.manual_invoice_number\" @updated-issue-method=\"execGetOrder\" @update-action-data=\"updateActionData\" _v-01cd1029=\"\">\n        </webadmin-order-operate-order-issue-method-utility>\n        <webadmin-order-operate-remark-utility v-if=\"!isRefundOrder\" :default-remark=\"currentOrder.order.remark\" :setting=\"setting.remark\" @remark-change=\"execGetOrder\" :order-id=\"currentOrder.order.id\" _v-01cd1029=\"\"></webadmin-order-operate-remark-utility>\n        <webadmin-order-operate-branch-payment-methods-utility v-for=\"payment in currentOrderPayments\" :payment-method-header=\"paymentMethodHeader\" :setting=\"setting.payments\" :order=\"currentOrder.order\" :member=\"currentOrder.member\" :branch-id=\"currentOrder.branch.branch_id\" :studio-id=\"currentOrder.branch.studio_id\" :payment=\"payment\" @updated-payment-method=\"execGetOrder\" @update-user-input=\"updateActionData\" _v-01cd1029=\"\">\n        </webadmin-order-operate-branch-payment-methods-utility>\n        <webadmin-order-operate-salesman-utility :setting=\"setting.salesman\" :studio-id=\"currentOrder.branch.studio_id\" :order-id=\"currentOrder.order.id\" model-id=\"order-operate-salesman-modal\" _v-01cd1029=\"\">\n        </webadmin-order-operate-salesman-utility>\n        <div class=\"row st-mx-0\" v-if=\"isRefundOrder\" _v-01cd1029=\"\">\n            <div class=\"col-sm-2 match-left\" _v-01cd1029=\"\">\n                <label for=\"\" _v-01cd1029=\"\">退費原因</label>\n            </div>\n            <div class=\"col-sm-10\" _v-01cd1029=\"\">\n                <div class=\"match-right\" _v-01cd1029=\"\">{{ currentOrder.order.refund_reason }}</div>\n            </div>\n        </div>\n        <webadmin-order-operate-action-bar-show-utility :setting=\"setting\" :order=\"currentOrder.order\" :branch=\"currentOrder.branch\" :member=\"currentOrder.member\" :details=\"currentOrder.details\" :invoice=\"currentOrder.invoice\" :payments=\"currentOrder.payments\" :action-data=\"actionData\" :order-changing=\"ajaxing.getOrder\" :check-states=\"currentOrder.check_states\" @set-alert-obj=\"setAlertObj\" @clear-action-data=\"clearActionData\" :event-type=\"eventType\" _v-01cd1029=\"\">\n        </webadmin-order-operate-action-bar-show-utility>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.outsid-border[_v-01cd1029] {\n  border: 2px solid #c7c4c3;\n  border-bottom: 0px;\n  margin-bottom: -10px; }\n  /* line 7, stdin */\n  .outsid-border .btn[_v-01cd1029] {\n    margin: 10px 0 10px 20px; }\n\n/* line 12, stdin */\n.more-space[_v-01cd1029] {\n  margin: 10px 15px; }\n\n/* line 16, stdin */\n.small-space[_v-01cd1029] {\n  margin-right: 5px; }\n\n/* line 20, stdin */\n.right-space[_v-01cd1029] {\n  margin-right: 15px; }\n\n/* line 24, stdin */\n.left-space[_v-01cd1029] {\n  margin-left: 15px; }\n\n/* line 28, stdin */\n.order-edit .search-member[_v-01cd1029] {\n  margin-top: 0px; }\n\n/* line 32, stdin */\n.commonly-used-items[_v-01cd1029] {\n  word-break: break-all;\n  background-color: #eee;\n  min-height: 100vh; }\n  /* line 37, stdin */\n  .commonly-used-items .commonly-item.btn-default[_v-01cd1029]:active {\n    background-color: #fff; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-01cd1029", module.exports)
  } else {
    hotAPI.update("_v-01cd1029", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1311:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.row[_v-b272611a] {\n  margin-left: 0px;\n  margin-right: 0px; }\n\n/* line 6, stdin */\n.edit-label[_v-b272611a] {\n  margin-right: 0.5em; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        allowShowVerificationAppropriationSum: {
            type: Boolean,
            default: false,
            description: '是否顯示核銷/撥款金額'
        },
        allowEditPaymentMethod: {
            type: Boolean,
            default: true,
            description: '是否顯示變更付款方式按鈕'
        },
        paymentMethodHeader: {
            type: String,
            default: '支付方式'
        }
    },
    data: function data() {
        return {};
    },

    methods: {
        changePaymentMethod: function changePaymentMethod() {
            $("#change-payment-method-modal").modal('show');
        },
        currentActivePayment: function currentActivePayment(id) {
            return this.activePayments.reduce(function (carry, payment) {
                if (payment.id == id) {
                    carry = payment;
                }
                return carry;
            }, {});
        },
        checkIsActive: function checkIsActive(id) {
            var currentPayment = this.currentActivePayment(id);

            if (this.WebadminOrderEditPaymentMethod && currentPayment.payment_type == 1) {
                return true;
            }

            return false;
        },
        allowPaymentType: function allowPaymentType(id, type) {
            var payment = this.activePayments.find(function (item) {
                return item.id == id;
            });
            return type.indexOf(payment.payment_type) !== -1;
        },
        openDetail: function openDetail(actionObj) {
            var recordId = actionObj.payment_action_record_id;
            this.$http.get('/adminapi/order/payment-action-record/' + recordId + '/action').then(function (response) {
                var data = response.data;

                switch (data.action_type) {
                    case "open-url":
                        window.open(data.action_data, "_blank");
                        break;

                    default:
                        break;
                }
            });
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('pos', ['select_order', 'studio_payment_methods']), (0, _vuex.mapState)({
        WebadminOrderEditPaymentMethod: function WebadminOrderEditPaymentMethod(state) {
            return state.webadmin.configure.webFunctions.WebadminPosChangeStudioPaymentMethod;
        }
    }), (0, _vuex.mapGetters)('pos', ['GET_ACTIVE_STUDIO_ID',,]), {
        paymentName: function paymentName() {
            var nameObj = {};
            if (this.select_order && this.select_order.paymentNames && this.select_order.payment_action_records.length !== 0) {
                var showName = this.paymentDisplayName(this.select_order.payment_action_records[0].studio_payment_method);
                nameObj[(0, _keys2.default)(this.select_order.paymentNames)] = {
                    name: showName,
                    studio_payment_method_id: (0, _keys2.default)(this.select_order.paymentNames),
                    payment_action_record_id: this.select_order.payment_action_records[0].id
                };
            };
            return nameObj;
        },
        activePayments: function activePayments() {
            return this.studio_payment_methods[this.select_order.branch_id];
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-b272611a=\"\">\n<div class=\"row\" _v-b272611a=\"\">\n    <div class=\"col-xs-2\" _v-b272611a=\"\">\n        <label for=\"\" class=\" text-right\" _v-b272611a=\"\">{{ paymentMethodHeader }}</label>\n    </div>\n    <div class=\"col-xs-10\" _v-b272611a=\"\">\n        <div v-for=\"(obj,key) in paymentName\" class=\"st-flex st-items-center\" _v-b272611a=\"\">\n            <label class=\"edit-label\" _v-b272611a=\"\">{{ obj.name }} </label>\n            <input type=\"button\" v-if=\"checkIsActive(key) &amp;&amp; allowEditPaymentMethod\" class=\"btn btn-default btn--inverse btn-xs\" value=\"變更\" @click=\"changePaymentMethod\" _v-b272611a=\"\">\n            <span v-if=\"allowShowVerificationAppropriationSum &amp;&amp; allowPaymentType(key,[2])\" style=\"color: red\" _v-b272611a=\"\">\n                （已核銷：{{ select_order.verification_appropriation.verification_sum }}／已撥款指示：{{ select_order.verification_appropriation.appropriation_sum }}）\n            </span>\n            <a @click=\"openDetail(obj)\" v-if=\"allowPaymentType(key,[6])\" class=\"st-flex st-items-center\" _v-b272611a=\"\">\n                查看詳情 \n                <span class=\"material-icons\" _v-b272611a=\"\">\n                launch\n                </span>\n            </a>\n        </div>\n    </div>\n</div>\n<webadmin-change-payment-method v-bind:studio-id=\"GET_ACTIVE_STUDIO_ID\" v-bind:branch-id=\"select_order.branch_id\" _v-b272611a=\"\"></webadmin-change-payment-method>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.row[_v-b272611a] {\n  margin-left: 0px;\n  margin-right: 0px; }\n\n/* line 6, stdin */\n.edit-label[_v-b272611a] {\n  margin-right: 0.5em; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-b272611a", module.exports)
  } else {
    hotAPI.update("_v-b272611a", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/object/keys":56,"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1312:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 3, stdin */\n.member-photo > img[_v-65a74bc7] {\n  height: 60px; }\n\n/* line 7, stdin */\n.show-member > div[_v-65a74bc7] {\n  float: left;\n  margin-right: 20px; }\n\n/* line 11, stdin */\n.show-member[_v-65a74bc7]:after {\n  content: '';\n  display: block;\n  clear: both;\n  visibility: hidden;\n  height: 0; }\n\n/* line 20, stdin */\n.status-col[_v-65a74bc7] {\n  border: 2px solid #C7C4C3;\n  margin: 10px 0px -12px 0px;\n  padding: 10px 15px; }\n\n/* line 26, stdin */\n.branchName[_v-65a74bc7] {\n  margin: 1em 0em;\n  font-size: 1em;\n  font-weight: bold; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _values = require('babel-runtime/core-js/object/values');

var _values2 = _interopRequireDefault(_values);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    refundSuccessCallBack: {},
    refundFailCallBack: {},
    refundCancelCallBack: {}
  },
  data: function data() {
    return {
      refundRequestAjaxing: false,
      branch_order_detail_verification_setting_id: null
    };
  },

  methods: (0, _extends3.default)({
    showMessage: function showMessage(state, message) {
      message = typeof message === 'undefined' ? '' : message;
      var type = state ? 'success' : 'error';
      var state_text = state ? '成功' : '失敗';
      $17.swal({
        title: '作廢' + state_text,
        text: message,
        type: type,
        showCancelButton: false
      });
    }
  }, (0, _vuex.mapActions)({
    refundOrderDetails: 'pos/refundOrderDetails'
  }), {
    checkAndRefund: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.refund_reason.length === 0)) {
                  _context.next = 3;
                  break;
                }

                $17.swal({
                  title: '退費原因不可為空',
                  text: "",
                  type: 'warning'
                });
                return _context.abrupt('return');

              case 3:
                $.blockUI({ timeout: 10000 });
                _context.next = 6;
                return this.refundOrderDetails({
                  'order_id': this.order_id,
                  'detailIds': this.detailIds,
                  'reason': this.refund_reason,
                  'moneys': this.detailMoneys,
                  'auto_allowance_issue': this.auto_allowance_issue,
                  'successCallBack': this.successCallBack,
                  'failCallBack': this.failCallBack,
                  'payment_method_select': this.payment_method_select
                });

              case 6:
                $.unblockUI();

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function checkAndRefund() {
        return _ref.apply(this, arguments);
      }

      return checkAndRefund;
    }(),

    successCallBack: function successCallBack(response) {
      this.$store.commit('pos/RESET_REFUND', { 'key': 'moneys', value: [] });
      this.refundSuccessCallBack && this.refundSuccessCallBack(response);
    },
    failCallBack: function failCallBack(response) {
      this.refundFailCallBack && this.refundFailCallBack(response);
    },
    cancelCallBack: function cancelCallBack(response) {
      this.refundCancelCallBack && this.refundCancelCallBack(response);
    },
    appendRefundRequest: function appendRefundRequest() {
      var _this = this;

      if (this.refund_reason.length === 0) {
        $17.swal({
          title: '退費原因不可為空',
          text: "",
          showCancelButton: false,
          type: 'warning'
        });
        return;
      }
      if (!this.detailIds || (0, _values2.default)(this.detailIds).indexOf(true) === -1) {
        $17.swal({
          title: '請選擇要退的訂單項目！',
          text: "",
          showCancelButton: false,
          type: 'warning'
        });
        return;
      }

      var data = {
        'order_id': this.order_id,
        'refund_reason': this.refund_reason,
        'details': this.detailMoneys
      };
      this.refundRequestAjaxing = true;
      this.$http.post('/adminapi/order-refund-request/create/' + this.order_id, data).then(function (response) {
        _this.refundRequestAjaxing = false;

        _this.refundCancelCallBack && _this.refundCancelCallBack(response);
        $17.swal({
          title: '已接收申請',
          text: "",
          type: 'success',
          confirmButtonText: '查看退費處理紀錄',
          cancelButtonText: '關閉'
        }, function (isConfirm) {
          if (isConfirm) {
            window.open('/webadmin/order-refund-request/list?order_id=' + _this.order_id, "_blank");
          };
        });
      }).catch(function (response) {
        _this.refundRequestAjaxing = false;
        $17.swal({
          title: '申請失敗',
          text: response.data.message,
          type: 'error',
          confirmButtonColor: '#E27B78',
          confirmButtonText: '查看退費處理紀錄',
          cancelButtonText: '關閉'
        }, function (isConfirm) {
          if (isConfirm) {
            window.open('/webadmin/order-refund-request/list?order_id=' + _this.order_id, "_blank");
          };
        });
      });
    },
    getVerificationSetting: function getVerificationSetting(records) {
      var _this2 = this;

      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        var studio_payment_method_id;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                studio_payment_method_id = records[0].studio_payment_method_id;

                if (!(!_this2.select_order.branch_id || !studio_payment_method_id)) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt('return');

              case 3:
                _context2.next = 5;
                return _this2.$http.get('/adminapi/verification-appropriation/setting/branch/' + _this2.select_order.branch_id + '/studio_payment_method?studio_payment_method_id=' + studio_payment_method_id).then(function (response) {
                  _this2.branch_order_detail_verification_setting_id = null;
                  if (response.data.id) {
                    _this2.branch_order_detail_verification_setting_id = response.data.id;
                  }
                });

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }),
  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
    order_id: function order_id(state) {
      return state.pos.select_order.id;
    },
    order_type: function order_type(state) {
      return state.pos.select_order.type;
    },
    member: function member(state) {
      return state.pos.select_order.member;
    },
    studio: function studio(state) {
      return state.pos.select_order.studio;
    },
    detailIds: function detailIds(state) {
      return state.pos.refund.ids;
    },
    selectDetails: function selectDetails(state) {
      return state.pos.select_order.details;
    },
    detailMoneys: function detailMoneys(state) {
      return state.pos.refund.moneys;
    },
    branchName: function branchName(state) {
      return state.pos.select_order.branchName;
    },
    invoice: function invoice(state) {
      return state.pos.select_order.invoice;
    },
    select_order: function select_order(state) {
      return state.pos.select_order;
    },
    payment_method_select: function payment_method_select(state) {
      return state.pos.payment_method_select;
    },
    studioPaymentMethods: function studioPaymentMethods(state) {
      return state.pos.select_order.payment_action_records;
    },
    systemStudioPaymentMethods: function systemStudioPaymentMethods(state) {
      return state.pos.studio_payment_methods;
    },
    isSeventeen: function isSeventeen(state) {
      return state.webadmin.configure.isSeventeen;
    }
  }), (0, _vuex.mapState)('webadmin/configure', ['isSeventeen']), (0, _vuex.mapGetters)({}), {
    refund_reason: {
      get: function get() {
        return store.state.pos.refund.reason;
      },
      set: function set(newValue) {
        this.$store.commit('pos/POS_REFUND_SETSTATUS', { 'key': 'reason', value: newValue });
      }
    },
    auto_allowance_issue: {
      get: function get() {
        return store.state.pos.auto_allowance_issue;
      },
      set: function set(newValue) {
        this.$store.commit('pos/POS_SETSTATUS', { 'key': 'auto_allowance_issue', value: newValue });
      }
    },
    refund_money: {
      get: function get() {
        return store.state.pos.refund.money;
      },
      set: function set(newValue) {
        this.$store.commit('pos/POS_REFUND_SETSTATUS', { 'key': 'money', value: newValue });
      }
    },
    studio_name: function studio_name() {
      return this.studio && this.studio.brand_name ? this.studio.brand_name : '';
    },
    member_name: function member_name() {
      return this.member && this.member.name ? this.member.name : '';
    },
    member_email: function member_email() {
      return this.member && this.member.name ? this.member.email : '';
    },
    member_phone: function member_phone() {
      return this.member && this.member.name ? this.member.phone : '';
    },
    member_photo: function member_photo() {
      return this.member && this.member.name ? this.member.picture_path : '';
    },
    is_walkin: function is_walkin() {
      return this.$store.state.filters.selected_search_member_is_walkin;
    },

    order_auto_allowance_issue: {
      get: function get() {
        if (this.auto_allowance_issue === null) {
          this.auto_allowance_issue = this.select_order && this.select_order.invoice_setting && this.select_order.invoice_setting.auto_allowance_issue ? true : false;
        }
        return this.auto_allowance_issue;
      },
      set: function set(newValue) {
        this.$store.commit('pos/POS_SETSTATUS', { 'key': 'auto_allowance_issue', value: newValue });
      }
    },
    invoice_number: function invoice_number() {
      return this.invoice && this.invoice.invoice_number ? this.invoice.invoice_number : "";
    },
    initPaymentMethods: function initPaymentMethods() {
      var paymentNames = this.select_order && this.select_order.paymentNames ? this.select_order.paymentNames : {};

      return (0, _keys2.default)(paymentNames);
    },
    showRefund: function showRefund() {
      var _this3 = this;

      if (this.isSeventeen) {
        return true;
      }

      var branchPayment = this.systemStudioPaymentMethods[this.select_order.branch_id];
      if (branchPayment == undefined) {
        return true;
      }

      var selectPayment = branchPayment.reduce(function (payment, item) {
        if (item.id == _this3.payment_method_select) {
          payment = item;
        }
        return payment;
      }, false);

      if (this.branch_order_detail_verification_setting_id != null && !this.isSeventeen && selectPayment && selectPayment.payment_type == 2) {
        return false;
      }

      return true;
    }
  }),
  watch: {
    'select_order.payment_action_records': {
      deep: true,
      immediate: false,
      handler: function handler(newVal) {
        if (newVal) {
          this.getVerificationSetting(newVal);
        }
      }
    }
  }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"order-refund\" _v-65a74bc7=\"\">\n    <div class=\"row\" _v-65a74bc7=\"\">\n        <div class=\"col-sm-12\" _v-65a74bc7=\"\">\n            <div class=\"branchName\" _v-65a74bc7=\"\">\n                {{branchName}}\n            </div>\n        </div>\n    </div>\n    <div class=\"row\" _v-65a74bc7=\"\">\n        <div class=\"col-sm-12\" _v-65a74bc7=\"\">\n            <div class=\"show-member\" _v-65a74bc7=\"\">\n                <div class=\"member-photo\" _v-65a74bc7=\"\">\n                    <img class=\"photo\" v-bind:src=\"member_photo\" alt=\"\" _v-65a74bc7=\"\">\n                </div>\n                <div _v-65a74bc7=\"\">\n                    <div class=\"name\" _v-65a74bc7=\"\">{{member_name}}</div>\n                    <div class=\"phone\" v-if=\"!is_walkin\" _v-65a74bc7=\"\">{{member_phone}}</div>\n                    <div class=\"email\" v-if=\"!is_walkin\" _v-65a74bc7=\"\">{{member_email}}</div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"row\" _v-65a74bc7=\"\">\n        <div class=\"col-sm-12\" _v-65a74bc7=\"\">\n            <div class=\"status-col\" _v-65a74bc7=\"\">\n                <span _v-65a74bc7=\"\">選擇退費項目</span>\n            </div>\n        </div>\n    </div>\n    <div class=\"row\" _v-65a74bc7=\"\">\n        <div class=\"col-sm-12\" _v-65a74bc7=\"\">\n            <order-detail-list item-type=\"refund\" _v-65a74bc7=\"\"></order-detail-list>\n        </div>\n    </div>\n  <order-payment-show :allow-show-verification-appropriation-sum=\"true\" :allow-edit-payment-method=\"false\" _v-65a74bc7=\"\"></order-payment-show>\n  <webadmin-branch-payment-methods :init-value=\"initPaymentMethods[0]\" current-type=\"refund\" show-method-word=\"退費方式\" v-bind:studio-id=\"select_order.studio_id\" v-bind:branch-id=\"select_order.branch_id\" _v-65a74bc7=\"\"></webadmin-branch-payment-methods>           \n  <div class=\"row\" _v-65a74bc7=\"\">\n    <div class=\"col-sm-6\" _v-65a74bc7=\"\">\n       <label for=\"\" _v-65a74bc7=\"\">退費原因：</label>\n    </div> \n    <div class=\"col-sm-6\" _v-65a74bc7=\"\">\n        <textarea cols=\"30\" rows=\"10\" maxlength=\"255\" placeholder=\"輸入原因（必填）\" v-model=\"refund_reason\" _v-65a74bc7=\"\"></textarea>\n        </div>\n    </div>\n    <div class=\"row\" _v-65a74bc7=\"\">\n        <div class=\"col-sm-offset-9 col-sm-3 text-right\" _v-65a74bc7=\"\">\n          <span v-if=\"invoice_number\" _v-65a74bc7=\"\">\n            <input type=\"checkbox\" id=\"order_auto_allowance_issue\" v-model=\"order_auto_allowance_issue\" _v-65a74bc7=\"\">\n            <label for=\"order_auto_allowance_issue\" _v-65a74bc7=\"\">退費後，同步折讓發票</label> \n          </span>\n          <input v-show=\"showRefund\" type=\"button\" value=\"確認退費\" class=\"btn btn-danger btn-lg\" v-on:click=\"checkAndRefund\" _v-65a74bc7=\"\">\n          <v-spinner-button :ajaxing=\"refundRequestAjaxing\" _v-65a74bc7=\"\"></v-spinner-button>\n          <span v-show=\"!showRefund&amp;&amp;!refundRequestAjaxing\" _v-65a74bc7=\"\">\n            <a href=\"https://17fithelp.zendesk.com/hc/zh-tw/articles/360000238202-如何退費-\" target=\"_blank\" class=\"m-right-15\" _v-65a74bc7=\"\">\n              瞭解詳情\n              <i class=\"fa fa-question-circle\" aria-hidden=\"true\" _v-65a74bc7=\"\"></i>\n            </a>\n            <input type=\"button\" value=\"申請退費\" class=\"btn btn-danger btn--inverse btn-lg\" v-on:click=\"appendRefundRequest\" _v-65a74bc7=\"\">\n          </span>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 3, stdin */\n.member-photo > img[_v-65a74bc7] {\n  height: 60px; }\n\n/* line 7, stdin */\n.show-member > div[_v-65a74bc7] {\n  float: left;\n  margin-right: 20px; }\n\n/* line 11, stdin */\n.show-member[_v-65a74bc7]:after {\n  content: '';\n  display: block;\n  clear: both;\n  visibility: hidden;\n  height: 0; }\n\n/* line 20, stdin */\n.status-col[_v-65a74bc7] {\n  border: 2px solid #C7C4C3;\n  margin: 10px 0px -12px 0px;\n  padding: 10px 15px; }\n\n/* line 26, stdin */\n.branchName[_v-65a74bc7] {\n  margin: 1em 0em;\n  font-size: 1em;\n  font-weight: bold; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-65a74bc7", module.exports)
  } else {
    hotAPI.update("_v-65a74bc7", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/object/keys":56,"babel-runtime/core-js/object/values":58,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1313:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.row[_v-2208ebcf] {\n  margin-left: 0px;\n  margin-right: 0px; }\n\n/* line 6, stdin */\n#remark_height[_v-2208ebcf] {\n  height: auto;\n  margin-right: 15px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {};
    },

    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('pos', ['orderRemark']), (0, _vuex.mapMutations)('pos', ['SET_ORDER_REMARK'])),
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('pos', ['select_order']), {
        order_remark: {
            set: function set(newVal) {
                this.SET_ORDER_REMARK({ 'key': 'name', 'value': newVal });
            },
            get: function get() {
                return this.select_order ? this.select_order.remark : '';
            }
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"row\" _v-2208ebcf=\"\">\n    <div class=\"col-xs-2\" _v-2208ebcf=\"\">\n        <label for=\"\" class=\" text-right\" _v-2208ebcf=\"\">訂單備註</label>\n    </div>\n    <div class=\"col-xs-10\" _v-2208ebcf=\"\">\n        <textarea name=\"\" id=\"remark_height\" rows=\"1\" placeholder=\"\" v-model.lazy=\"order_remark\" @change=\"orderRemark\" _v-2208ebcf=\"\"></textarea>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.row[_v-2208ebcf] {\n  margin-left: 0px;\n  margin-right: 0px; }\n\n/* line 6, stdin */\n#remark_height[_v-2208ebcf] {\n  height: auto;\n  margin-right: 15px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-2208ebcf", module.exports)
  } else {
    hotAPI.update("_v-2208ebcf", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1314:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.row[_v-69f60e39] {\n  margin-left: 0px;\n  margin-right: 0px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            salesmenData: {
                orderSalesmen: {},
                orderSalesmenFormat: {}
            },
            ajaxingChange: false,
            salsemanVisible: ''
        };
    },

    props: {
        orderId: {
            required: true
        },
        modelId: {
            required: true
        },
        orderSalsemanEditable: {
            required: true
        }
    },
    watch: {
        orderId: function orderId(_orderId) {
            if (!_orderId) {
                return;
            }
            this.getSalseman(_orderId);
        },
        studioId: function studioId(val) {
            if (val) {
                this.getSalsemanVisible(val);
            }
        }
    },
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('pos', ['orderRemark']), (0, _vuex.mapMutations)('pos', ['SET_ORDER_REMARK']), {
        getSalseman: function getSalseman(orderId) {
            var _this = this;

            this.ajaxingChange = false;
            this.$http.get('/adminapi/salseman/order/' + orderId).then(function (response) {
                _this.salesmenData = response.data;
                _this.ajaxingChange = true;
            });
        },
        getSalsemanVisible: function getSalsemanVisible(studioId) {
            var _this2 = this;

            this.$http.post('/adminapi/layout-setting/salesperson-visible/get', { 'studio_id': studioId }).then(function (response) {
                _this2.salsemanVisible = response.data.result;
            });
        },
        showSettingModal: function showSettingModal() {
            $('#' + this.modelId).modal('show');
        },
        refreshSalesmenList: function refreshSalesmenList() {
            this.getSalseman(this.orderId);
        },
        isShowOrderSalesmen: function isShowOrderSalesmen(index) {
            if (!this.salsemanVisible) return;
            return this.salsemanVisible['level_' + index + '_salesperson_visible'];
        }
    }),
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId', 'isBranch']))

};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"row p-bottom-30\" _v-69f60e39=\"\">\n    <div class=\"col-xs-2\" _v-69f60e39=\"\">\n        <label class=\" text-right\" _v-69f60e39=\"\">業務代表：</label>\n    </div>\n    <div class=\"col-xs-4\" _v-69f60e39=\"\">\n        <div class=\"btn btn-default btn-sm m-bottom-10\" v-if=\"orderSalsemanEditable &amp;&amp; ajaxingChange\" @click=\"showSettingModal\" _v-69f60e39=\"\">\n            設定\n        </div>\n        <div v-show=\"ajaxingChange &amp;&amp; isShowOrderSalesmen(index)\" v-for=\"(item, index) in salesmenData.orderSalesmenFormat\" _v-69f60e39=\"\">{{index}}. {{item.salseman}}:（{{item.site}}）</div>\n    </div>\n    <div class=\"col-xs-3\" _v-69f60e39=\"\">\n\n    </div>\n    <webadmin-salseman-order-setting :order-salesmen=\"salesmenData.orderSalesmen\" @refresh-salesmen-list=\"refreshSalesmenList\" :salseman-visible=\"salsemanVisible\" :model-id=\"modelId\" _v-69f60e39=\"\"></webadmin-salseman-order-setting>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.row[_v-69f60e39] {\n  margin-left: 0px;\n  margin-right: 0px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-69f60e39", module.exports)
  } else {
    hotAPI.update("_v-69f60e39", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1315:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.fa-search[_v-68f03f4b] {\n  cursor: pointer; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        payment: {
            default: 0
        }
    },
    data: function data() {
        return {
            orderId: ''
        };
    },

    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('pos', ['openOrCreateOrder', 'checkIsValidOrderId', 'checkOrderPaymentStatus']), {
        openOrder: function openOrder() {
            var vm = this;
            this.checkIsValidOrderId({ 'orderId': this.orderId }).then(function (status) {
                if (status) {
                    vm.openOrCreateOrder({ 'status': true, 'order_id': vm.orderId, 'payment': vm.payment }).then(function () {
                        vm.checkPaymentStatus();
                    }, function () {});
                }
            });
        },
        checkPaymentStatus: function checkPaymentStatus() {
            var _this = this;

            var vm = this;
            this.checkOrderPaymentStatus({ 'payment': vm.payment }).then(function (status) {
                if (status) {
                    if (_this.payment == 1) {
                        $('#order-show').modal('show');
                    } else {
                        $('#order-edit').modal('show');
                    }
                } else {
                    $17.swal({
                        title: '無法開啟',
                        text: '查詢不到訂單',
                        type: 'warning',
                        showCancelButton: false
                    });
                }
            }, function () {});
        }
    }),
    computed: {}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"order-search input-group\" _v-68f03f4b=\"\">\n  <input type=\"text\" class=\"form-control\" placeholder=\"訂單編號\" v-model=\"orderId\" @keyup.enter=\"openOrder\" _v-68f03f4b=\"\">\n  <span class=\"input-group-addon\" _v-68f03f4b=\"\">\n    <div class=\"\" @click=\"openOrder\" _v-68f03f4b=\"\"><i class=\"fa fa-search\" _v-68f03f4b=\"\"></i></div>\n  </span>\n</div><!-- /input-group -->\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.fa-search[_v-68f03f4b] {\n  cursor: pointer; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-68f03f4b", module.exports)
  } else {
    hotAPI.update("_v-68f03f4b", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1316:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.discount[_v-ba0a7fee], .delete-icon[_v-ba0a7fee] {\n  color: #d1352e; }\n\n/* line 5, stdin */\n.delete-icon[_v-ba0a7fee] {\n  cursor: pointer;\n  max-width: 15px; }\n\n/* line 9, stdin */\ntr > td[_v-ba0a7fee]:last-child {\n  padding-right: 15px; }\n\n/* line 12, stdin */\n.close-icon[_v-ba0a7fee] {\n  font-size: 1.5em;\n  font-weight: bolder; }\n\n/* line 16, stdin */\n.item-edit[_v-ba0a7fee] {\n  cursor: pointer; }\n  /* line 18, stdin */\n  .item-edit[_v-ba0a7fee]:hover {\n    background: #edeff0; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['detail'],
    data: function data() {
        return {};
    },

    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
        removeOneItem: 'pos/removeDetail'
    }), {
        showOrderDetailWithProduct: function showOrderDetailWithProduct(detail) {
            if (!this.WebadminOrderEdit) {
                return;
            }
            var vm = this;
            this.$store.dispatch('pos/showOrderDetailWithProduct', detail.id).then(function () {
                vm.$store.commit('pos/POS_SETSTATUS', { 'key': 'append_mode', value: 'edit' });
                vm.$store.commit('pos/POS_SETSTATUS', { 'key': 'select_order_detail', value: detail });
                $('#product_append').modal('show');
            });
        }
    }),
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
        calulateDiscountTotal: 'pos/CALCULATE_DISCOUNT_DETAIL_MONEY'
    }), {
        discount_value: function discount_value() {
            return !this.detail.order_detail_discount ? 0 : this.detail.order_detail_discount.value;
        },
        discount_type: function discount_type() {
            return !this.detail.order_detail_discount ? 1 : this.detail.order_detail_discount.type;
        },
        qty: function qty() {
            return !this.detail ? 0 : this.detail.qty;
        },
        price: function price() {
            return !this.detail ? 0 : this.detail.price;
        },
        discountValueShow: function discountValueShow() {
            var discountType = parseInt(this.detail.order_detail_discount.type);

            return typeof this.discount_value != 'undefined' && this.discount_value > 0 ? this.calulateDiscountTotal(this.qty * this.price, discountType, this.discount_value) : '';
        },
        detail_total_money: function detail_total_money() {
            return this.detail.sub_total;
        }
    }, (0, _vuex.mapState)({
        WebadminOrderEdit: function WebadminOrderEdit(state) {
            return state.webadmin.configure.webFunctions.WebadminOrderEdit;
        }
    }))
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<tr class=\"item-edit\" @click=\"showOrderDetailWithProduct(detail)\" _v-ba0a7fee=\"\">\n    <td class=\"text-center delete-icon\" @click.stop.prevent=\"removeOneItem({order_detail_id:detail.id})\" v-if=\"detail.can_be_delete &amp;&amp; WebadminOrderEdit\" _v-ba0a7fee=\"\">\n        <!-- <i class=\"fa fa-times fa-2x\" aria-hidden=\"true\"></i> -->\n        <span class=\"close-icon\" _v-ba0a7fee=\"\">×</span>\n    </td>\n    <td v-else=\"\" _v-ba0a7fee=\"\">&nbsp;</td>\n    <td class=\"text-left\" _v-ba0a7fee=\"\">{{detail.product_name}}</td>\n    <td class=\"text-right\" _v-ba0a7fee=\"\">{{qty}}</td>\n    <td class=\"text-right\" _v-ba0a7fee=\"\">{{price}}</td>\n    <td class=\"text-right\" _v-ba0a7fee=\"\">{{qty * price}}</td>\n    <td class=\"discount text-right\" _v-ba0a7fee=\"\">{{discountValueShow}}</td>\n    <td class=\"text-right\" _v-ba0a7fee=\"\">${{detail_total_money}}</td>\n</tr>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.discount[_v-ba0a7fee], .delete-icon[_v-ba0a7fee] {\n  color: #d1352e; }\n\n/* line 5, stdin */\n.delete-icon[_v-ba0a7fee] {\n  cursor: pointer;\n  max-width: 15px; }\n\n/* line 9, stdin */\ntr > td[_v-ba0a7fee]:last-child {\n  padding-right: 15px; }\n\n/* line 12, stdin */\n.close-icon[_v-ba0a7fee] {\n  font-size: 1.5em;\n  font-weight: bolder; }\n\n/* line 16, stdin */\n.item-edit[_v-ba0a7fee] {\n  cursor: pointer; }\n  /* line 18, stdin */\n  .item-edit[_v-ba0a7fee]:hover {\n    background: #edeff0; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-ba0a7fee", module.exports)
  } else {
    hotAPI.update("_v-ba0a7fee", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1317:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.discount[_v-34a54cb7], .delete-icon[_v-34a54cb7] {\n  color: #d1352e; }\n\n/* line 5, stdin */\n.delete-icon[_v-34a54cb7] {\n  cursor: pointer;\n  max-width: 15px; }\n\n/* line 9, stdin */\ntr > td[_v-34a54cb7]:last-child {\n  padding-right: 15px; }\n\n/* line 12, stdin */\n.close-icon[_v-34a54cb7] {\n  font-size: 1.5em;\n  font-weight: bolder; }\n\n/* line 16, stdin */\n.item-refund[_v-34a54cb7] {\n  cursor: pointer; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['detail', 'needFullReturn'],
    data: function data() {
        return {
            refund: false,
            money: null,
            detailId: null
        };
    },

    beforeUpdate: function beforeUpdate() {
        // if(this.detailId != this.detail.id){
        //     this.refund=false;
        //     this.money= null;
        //     this.detailId= this.detail.id;
        //     this.$emit('count-total');
        // }
    },
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({}), {
        changeCheckStatus: function changeCheckStatus() {
            if (this.detail.isRefund) {
                return;
            }
            this.refund_id = !this.refund_id;
        },
        withMoneyFormat: function withMoneyFormat(money) {
            return $17.moneyFormat(money);
        },
        showModal: function showModal(buy_id) {
            this.$store.dispatch('webadmin/crm/fetchOneMemberContract', buy_id);
            $('#modal-contract').modal('show');
        },
        showOrderDetailWithProduct: function showOrderDetailWithProduct(detail) {
            var vm = this;
            this.$store.dispatch('pos/showOrderDetailWithProduct', detail.id).then(function () {
                vm.$store.commit('pos/POS_SETSTATUS', { 'key': 'select_order_detail', value: detail });
                $('#product_item_show').modal('show');
            });
        }
    }),
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
        calulateDiscountTotal: 'pos/CALCULATE_DISCOUNT_DETAIL_MONEY'
    }), {
        discount_value: function discount_value() {
            return !this.detail.order_detail_discount ? 0 : this.detail.order_detail_discount.value;
        },
        discount_type: function discount_type() {
            return !this.detail.order_detail_discount ? 1 : this.detail.order_detail_discount.type;
        },
        qty: function qty() {
            return !this.detail ? 0 : this.detail.qty;
        },
        price: function price() {
            return !this.detail ? 0 : this.detail.price;
        },
        rest_can_refund: function rest_can_refund() {
            return !this.detail ? 0 : this.detail.rest_can_refund;
        },
        detail_total_money: function detail_total_money() {
            return this.detail.sub_total;
        },
        discountValueShow: function discountValueShow() {
            var discountType = parseInt(this.detail.order_detail_discount.type);
            return typeof this.discount_value != 'undefined' && this.discount_value > 0 ? this.calulateDiscountTotal(this.qty * this.price, discountType, this.discount_value) : '';
        }
    }, (0, _vuex.mapState)({
        refund_ids: function refund_ids(state) {
            return state.pos.refund.ids;
        }
    }), {
        refund_id: {
            get: function get() {
                if (this.needFullReturn && !this.refund) {
                    this.refund_id = true;
                }
                return this.refund;
            },
            set: function set(newValue) {
                this.refund = newValue;
                this.$store.commit('pos/POS_REFUND_SETSTATUS', { 'key': 'ids.' + this.detail.id, value: newValue });
                this.$emit('count-total');
            }
        },
        refund_money: {
            get: function get() {
                if (!this.money) {
                    this.refund_money = this.detail.rest_can_refund;
                    this.money = this.detail.rest_can_refund;
                }
                if (this.needFullReturn) {
                    this.refund_money = this.detail.sub_total;
                }
                return this.money;
            },
            set: function set(newValue) {
                if (newValue > this.rest_can_refund) {
                    newValue = this.rest_can_refund;
                }
                newValue = parseInt(newValue);
                this.money = newValue;
                this.$store.commit('pos/POS_REFUND_SETSTATUS', { 'key': 'moneys.' + this.detail.id, value: newValue });
                this.$emit('count-total');
            }
        },
        product_table_type: function product_table_type() {
            if (this.detail.product.table_type != "contracts") {
                return false;
            }
            return true;
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<tr class=\"item-refund\" @click=\"changeCheckStatus\" _v-34a54cb7=\"\">\n    <td class=\"text-center delete-icon\" _v-34a54cb7=\"\">\n        <div class=\"already-refund\" v-if=\"detail.isRefund\" _v-34a54cb7=\"\">\n            <span _v-34a54cb7=\"\">已退</span>\n        </div>\n        <div class=\"can-refund\" v-if=\"!detail.isRefund\" _v-34a54cb7=\"\">\n            <input type=\"checkbox\" v-model=\"refund_id\" v-on:click.stop=\"\" _v-34a54cb7=\"\">\n        </div>\n    </td>\n    <td class=\"text-left\" _v-34a54cb7=\"\">\n        {{detail.product_name}}\n        <span _v-34a54cb7=\"\">&nbsp;</span>\n        <span class=\"text-danger item-refund\" v-if=\"product_table_type\" @click=\"showModal(detail.buy_id)\" _v-34a54cb7=\"\"><u _v-34a54cb7=\"\">查看</u></span>\n    </td>\n    <td class=\"text-right\" _v-34a54cb7=\"\">{{qty}}</td>\n    <td class=\"text-right\" _v-34a54cb7=\"\">{{price}}</td>\n    <td class=\"text-right\" _v-34a54cb7=\"\">{{withMoneyFormat(detail_total_money)}}</td>\n    <td class=\"discount text-right\" _v-34a54cb7=\"\">\n        <span class=\"item-refund\" v-if=\"discount_value != 0\" @click.stop=\"showOrderDetailWithProduct(detail)\" _v-34a54cb7=\"\">\n            {{discountValueShow}}\n        </span>\n    </td>\n    <td class=\"text-right rest_can_refund\" v-if=\"rest_can_refund>0\" _v-34a54cb7=\"\">\n        {{withMoneyFormat(rest_can_refund)}}\n    </td>\n    <td v-else=\"\" _v-34a54cb7=\"\"></td>\n    <td class=\"text-right\" _v-34a54cb7=\"\">\n        <span v-if=\"refund\" class=\"text-left\" _v-34a54cb7=\"\">\n            <input type=\"number\" :placeholder=\"rest_can_refund\" :max=\"rest_can_refund\" min=\"0\" v-model.lazy=\"refund_money\" v-on:click.stop.prevent=\"\" _v-34a54cb7=\"\">\n        </span>\n        <span v-else=\"\" _v-34a54cb7=\"\"></span>\n    </td>\n</tr>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.discount[_v-34a54cb7], .delete-icon[_v-34a54cb7] {\n  color: #d1352e; }\n\n/* line 5, stdin */\n.delete-icon[_v-34a54cb7] {\n  cursor: pointer;\n  max-width: 15px; }\n\n/* line 9, stdin */\ntr > td[_v-34a54cb7]:last-child {\n  padding-right: 15px; }\n\n/* line 12, stdin */\n.close-icon[_v-34a54cb7] {\n  font-size: 1.5em;\n  font-weight: bolder; }\n\n/* line 16, stdin */\n.item-refund[_v-34a54cb7] {\n  cursor: pointer; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-34a54cb7", module.exports)
  } else {
    hotAPI.update("_v-34a54cb7", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1318:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.discount[_v-2f4b7b7c], .close[_v-2f4b7b7c] {\n  color: red; }\n\n/* line 5, stdin */\n.less-space[_v-2f4b7b7c] {\n  padding-right: 15px; }\n\n/* line 8, stdin */\n.already-refund[_v-2f4b7b7c] {\n  padding-left: 15px; }\n\n/* line 11, stdin */\n.color-red[_v-2f4b7b7c] {\n  color: red; }\n\n/* line 14, stdin */\n.item-show[_v-2f4b7b7c] {\n  cursor: pointer; }\n\n/* line 17, stdin */\n.spinner[_v-2f4b7b7c] {\n  display: inline; }\n\n/* line 20, stdin */\n.danger[_v-2f4b7b7c] {\n  background-color: #f8d7da; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['detail'],
    data: function data() {
        return {
            ajaxingTicket: false,
            ajaxingMemberContract: false
        };
    },

    methods: {
        trackDangerProduct: function trackDangerProduct(orderDetail) {
            if (this.select_order.type == 13) {
                //退費訂單不用顯示沒給到商品的警告
                return false;
            } else {
                switch (orderDetail.product.table_type) {
                    case 'contracts':
                        return !this.isContractAssign(orderDetail);
                    case 'ticket_settings':
                        return !this.isTicketAssign(orderDetail);
                    case 'physical_products':
                        return !this.isPhysicalProductAssign(orderDetail);
                    default:
                        return false;
                }
            }
        },
        isContractAssign: function isContractAssign(orderDetail) {
            orderDetail = this.select_order.type == 13 ? orderDetail.origin_detail : orderDetail;
            return orderDetail.buy_model === 'member_contracts' && orderDetail.buy_id > 0;
        },
        isTicketAssign: function isTicketAssign(orderDetail) {
            orderDetail = this.select_order.type == 13 ? orderDetail.origin_detail : orderDetail;
            return orderDetail.buy_model === 'ticket_groups' && orderDetail.buy_id > 0;
        },
        isPhysicalProductAssign: function isPhysicalProductAssign(orderDetail) {
            orderDetail = this.select_order.type == 13 ? orderDetail.origin_detail : orderDetail;
            return orderDetail.product.table_id > 0;
        },

        withMoneyFormat: function withMoneyFormat(money) {
            return $17.moneyFormat(money);
        },
        showModal: function () {
            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                var buy_id;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                buy_id = null;


                                if (typeof this.detail.origin_detail !== 'undefined') {
                                    buy_id = this.detail.origin_detail.buy_id;
                                }
                                if (typeof this.detail.origin_detail === 'undefined') {
                                    buy_id = this.detail.buy_id;
                                }
                                this.ajaxingMemberContract = true;
                                _context.next = 6;
                                return this.$store.dispatch('webadmin/crm/fetchOneMemberContract', buy_id);

                            case 6:
                                $('#modal-contract').modal('show');
                                this.ajaxingMemberContract = false;

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function showModal() {
                return _ref.apply(this, arguments);
            }

            return showModal;
        }(),
        showOrderDetailWithProduct: function showOrderDetailWithProduct(detail) {
            var vm = this;
            this.$store.dispatch('pos/showOrderDetailWithProduct', detail.id).then(function () {
                vm.$store.commit('pos/POS_SETSTATUS', { 'key': 'select_order_detail', value: detail });
                $('#product_item_show').modal('show');
            });
        },
        openBoughtTicket: function () {
            var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(detailId) {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                this.ajaxingTicket = true;
                                _context2.next = 3;
                                return this.$store.dispatch('pos/getBoughtItem', detailId);

                            case 3:
                                $("#order-bought-ticket").modal('show');
                                this.ajaxingTicket = false;

                            case 5:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function openBoughtTicket(_x) {
                return _ref2.apply(this, arguments);
            }

            return openBoughtTicket;
        }()
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
        calulateDiscountTotal: 'pos/CALCULATE_DISCOUNT_DETAIL_MONEY'
    }), (0, _vuex.mapState)({
        select_order: function select_order(state) {
            return state.pos.select_order;
        }
    }), {
        discount_value: function discount_value() {
            return !this.detail.order_detail_discount ? 0 : this.detail.order_detail_discount.value;
        },
        discount_type: function discount_type() {
            return !this.detail.order_detail_discount ? 1 : this.detail.order_detail_discount.type;
        },
        qty: function qty() {
            return !this.detail ? 0 : this.detail.qty;
        },
        price: function price() {
            return !this.detail ? 0 : this.detail.price;
        },
        rest_can_refund: function rest_can_refund() {
            return !this.detail ? 0 : this.detail.rest_can_refund;
        },
        discountValueShow: function discountValueShow() {
            var discountType = parseInt(this.detail.order_detail_discount.type);

            return typeof this.discount_value != 'undefined' && this.discount_value > 0 ? this.calulateDiscountTotal(this.qty * this.price, discountType, this.discount_value) : '';
        },
        detail_total_money: function detail_total_money() {
            return this.detail.sub_total;
        },
        detail_total_money_show: function detail_total_money_show() {
            return '$' + this.detail_total_money;
        },
        showAlreadyRefund: function showAlreadyRefund() {
            return this.detail.isRefund && this.detail.refund_details.length > 0;
        },
        origin_detail: function origin_detail() {
            var _this = this;

            if (!this.detail.origin_details) {
                return {};
            }
            return this.detail.origin_details.reduce(function (carry, oDetail) {
                if (oDetail.id === _this.detail.refer_order_detail_id) {
                    carry = oDetail;
                }
                return carry;
            }, {});
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<tr :class=\"['item-show', { danger: (trackDangerProduct(detail)),}]\" _v-2f4b7b7c=\"\">\n    <td _v-2f4b7b7c=\"\">\n        <div class=\"already-refund\" v-if=\"showAlreadyRefund\" _v-2f4b7b7c=\"\">\n            <span _v-2f4b7b7c=\"\">已退</span>\n        </div>\n    </td>\n    <td _v-2f4b7b7c=\"\">\n        {{detail.product_name}}\n        <span _v-2f4b7b7c=\"\">&nbsp;</span>\n        <span class=\"text-danger item-refund\" v-if=\"detail.product.table_type=='contracts' &amp;&amp; isContractAssign(detail)\" v-show=\"!ajaxingMemberContract\" @click=\"showModal\" _v-2f4b7b7c=\"\">\n            <u _v-2f4b7b7c=\"\">查看</u>\n        </span>\n        <span v-if=\"detail.buy_model=='ticket_groups' &amp;&amp; isTicketAssign(detail)\" v-show=\"!ajaxingTicket\" class=\"btn btn-success btn-xs\" @click=\"openBoughtTicket(detail.id)\" _v-2f4b7b7c=\"\">顯示票券</span>\n        <v-spinner-button :ajaxing=\"ajaxingTicket || ajaxingMemberContract\" _v-2f4b7b7c=\"\"></v-spinner-button>\n    </td>\n    <td class=\"text-right\" _v-2f4b7b7c=\"\">{{qty}}</td>\n    <td class=\"text-right\" _v-2f4b7b7c=\"\">{{price}}</td>\n    <td class=\"text-right\" _v-2f4b7b7c=\"\">\n        <span v-if=\"detail.refer_order_detail_id == null\" _v-2f4b7b7c=\"\">\n            {{withMoneyFormat(qty * price)}}\n        </span>\n    </td>\n    <td class=\"discount text-right\" _v-2f4b7b7c=\"\">\n        <span class=\"item-show\" v-if=\"discount_value != 0\" @click.stop=\"showOrderDetailWithProduct(detail)\" _v-2f4b7b7c=\"\">\n            {{discountValueShow}}\n        </span>\n    </td>\n    <td class=\"text-right\" _v-2f4b7b7c=\"\">\n        <span v-if=\"detail_total_money >=0\" _v-2f4b7b7c=\"\"> {{withMoneyFormat(detail_total_money)}}</span>\n        <span v-else=\"\" class=\"color-red\" _v-2f4b7b7c=\"\"> ({{withMoneyFormat(Math.abs(detail_total_money))}})</span>\n    </td>\n    <td class=\"text-right less-space\" v-if=\"rest_can_refund>0\" _v-2f4b7b7c=\"\">\n        {{withMoneyFormat(rest_can_refund)}}\n    </td>\n    <td v-else=\"\" _v-2f4b7b7c=\"\"></td>\n</tr>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.discount[_v-2f4b7b7c], .close[_v-2f4b7b7c] {\n  color: red; }\n\n/* line 5, stdin */\n.less-space[_v-2f4b7b7c] {\n  padding-right: 15px; }\n\n/* line 8, stdin */\n.already-refund[_v-2f4b7b7c] {\n  padding-left: 15px; }\n\n/* line 11, stdin */\n.color-red[_v-2f4b7b7c] {\n  color: red; }\n\n/* line 14, stdin */\n.item-show[_v-2f4b7b7c] {\n  cursor: pointer; }\n\n/* line 17, stdin */\n.spinner[_v-2f4b7b7c] {\n  display: inline; }\n\n/* line 20, stdin */\n.danger[_v-2f4b7b7c] {\n  background-color: #f8d7da; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-2f4b7b7c", module.exports)
  } else {
    hotAPI.update("_v-2f4b7b7c", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1319:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 4, stdin */\n.footer[_v-c1823aca] {\n  background-color: #C7C4C3;\n  font-weight: bolder;\n  font-size: 1.2em; }\n\n/* line 9, stdin */\ntable[_v-c1823aca] {\n  margin: 10px 0;\n  width: 100%;\n  border: 2px solid #C7C4C3; }\n  /* line 14, stdin */\n  table thead tr[_v-c1823aca], table tfoot tr[_v-c1823aca] {\n    border: 2px solid #C7C4C3; }\n  /* line 18, stdin */\n  table tbody tr[_v-c1823aca] {\n    border: 1px solid #C7C4C3; }\n    /* line 20, stdin */\n    table tbody tr td[_v-c1823aca], table tbody tr th[_v-c1823aca] {\n      margin: 10px 0; }\n  /* line 24, stdin */\n  table tr[_v-c1823aca] {\n    line-height: 30px; }\n  /* line 27, stdin */\n  table tr > td[_v-c1823aca]:last-child {\n    padding-right: 15px; }\n  /* line 32, stdin */\n  table tfoot .color-red[_v-c1823aca] {\n    color: red; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {};
    },

    methods: {
        countRefundTotal: function countRefundTotal() {
            var vm = this;
            var total = 0;
            (0, _keys2.default)(this.order_details).map(function (index, elem) {
                var detaiId = vm.order_details[index].id;
                if (typeof vm.refund.ids[detaiId] != 'undefined' && vm.refund.ids[detaiId] == true) {
                    total += isNaN(vm.refund.moneys[detaiId]) ? 0 : vm.refund.moneys[detaiId];
                }
            });
            this.total = total;
        },
        withMoneyFormat: function withMoneyFormat(money) {
            return $17.moneyFormat(money);
        }
    },
    props: {
        itemType: {
            default: 'show'
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        order_details: function order_details(state) {
            return state.pos.select_order.details;
        },
        refund: function refund(state) {
            return state.pos.refund;
        },
        custom_total: function custom_total(state) {
            return state.pos.custom_total;
        }
    }), { total: {
            get: function get() {
                if ('refund'.indexOf(this.itemType) > -1) {
                    return this.custom_total;
                }
                return this.$store.state.pos.select_order.total;
            },
            set: function set(newValue) {
                if ('refund'.indexOf(this.itemType) > -1) {
                    this.$store.commit('pos/POS_SETSTATUS', { 'key': 'custom_total', value: newValue });
                    // return this.custom_total = newValue;
                }
            }
        },
        needFullReturn: function needFullReturn() {
            return this.$store.state.pos.select_order && this.$store.state.pos.select_order.needFullReturn ? this.$store.state.pos.select_order.needFullReturn : false;
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-c1823aca=\"\">\n    <table _v-c1823aca=\"\">\n        <thead _v-c1823aca=\"\">\n            <tr _v-c1823aca=\"\">\n                <td _v-c1823aca=\"\">&nbsp;</td>\n                <td _v-c1823aca=\"\">項目名稱</td>\n                <td class=\"text-right\" _v-c1823aca=\"\">數量</td>\n                <td class=\"text-right\" _v-c1823aca=\"\">單價</td>\n                <td class=\"text-right\" _v-c1823aca=\"\">小計</td>\n                <td class=\"text-right\" _v-c1823aca=\"\">折扣</td>\n                <td class=\"text-right\" v-if=\"itemType=='refund'\" _v-c1823aca=\"\">剩餘</td>\n                <td class=\"text-right\" _v-c1823aca=\"\"></td>\n                <td class=\"text-right\" v-if=\"itemType=='show'\" _v-c1823aca=\"\">剩餘</td>\n            </tr>\n        </thead>\n        <tbody _v-c1823aca=\"\">\n            <template v-if=\"itemType =='edit'\">\n                <order-detail-item-edit v-bind:detail=\"detail\" v-for=\"(detail,index) in order_details\" :key=\"detail.id\" _v-c1823aca=\"\"></order-detail-item-edit>\n            </template>\n            <template v-if=\"itemType =='show'\"> \n                <order-detail-item-show v-bind:detail=\"detail\" v-for=\"(detail,index) in order_details\" :key=\"detail.id\" _v-c1823aca=\"\"></order-detail-item-show>\n            </template>\n            <template v-if=\"itemType =='refund'\"> \n                <order-detail-item-refund v-bind:detail=\"detail\" v-bind:need-full-return=\"needFullReturn\" v-for=\"(detail,index) in order_details\" @count-total=\"countRefundTotal\" :key=\"detail.id\" _v-c1823aca=\"\">\n                    \n                </order-detail-item-refund>\n            </template>\n        </tbody>\n        <tfoot class=\"footer\" _v-c1823aca=\"\">\n            <tr _v-c1823aca=\"\">\n                <td _v-c1823aca=\"\"></td>\n                <td v-if=\"itemType =='refund'\" _v-c1823aca=\"\">退費金額</td>\n                <td v-if=\"itemType !='refund'\" _v-c1823aca=\"\">總計</td>\n                <td _v-c1823aca=\"\"></td>\n                <td _v-c1823aca=\"\"></td>\n                <td _v-c1823aca=\"\"></td>\n                <td _v-c1823aca=\"\"></td>\n                <td v-if=\"itemType=='refund'\" _v-c1823aca=\"\"></td>\n                <td class=\"text-right\" _v-c1823aca=\"\">\n                    <span v-if=\"total >=0\" _v-c1823aca=\"\"> {{withMoneyFormat(total)}}</span>\n                    <span v-else=\"\" class=\"color-red\" _v-c1823aca=\"\"> ({{withMoneyFormat(Math.abs(total))}})</span>\n                </td>\n                <td v-if=\"itemType=='show'\" _v-c1823aca=\"\"></td>\n            </tr>\n        </tfoot>\n    </table>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 4, stdin */\n.footer[_v-c1823aca] {\n  background-color: #C7C4C3;\n  font-weight: bolder;\n  font-size: 1.2em; }\n\n/* line 9, stdin */\ntable[_v-c1823aca] {\n  margin: 10px 0;\n  width: 100%;\n  border: 2px solid #C7C4C3; }\n  /* line 14, stdin */\n  table thead tr[_v-c1823aca], table tfoot tr[_v-c1823aca] {\n    border: 2px solid #C7C4C3; }\n  /* line 18, stdin */\n  table tbody tr[_v-c1823aca] {\n    border: 1px solid #C7C4C3; }\n    /* line 20, stdin */\n    table tbody tr td[_v-c1823aca], table tbody tr th[_v-c1823aca] {\n      margin: 10px 0; }\n  /* line 24, stdin */\n  table tr[_v-c1823aca] {\n    line-height: 30px; }\n  /* line 27, stdin */\n  table tr > td[_v-c1823aca]:last-child {\n    padding-right: 15px; }\n  /* line 32, stdin */\n  table tfoot .color-red[_v-c1823aca] {\n    color: red; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-c1823aca", module.exports)
  } else {
    hotAPI.update("_v-c1823aca", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/object/keys":56,"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1320:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.outsid-border[_v-d6221d6a] {\n  border: 2px solid #C7C4C3;\n  border-bottom: 0px;\n  margin-bottom: -10px; }\n  /* line 6, stdin */\n  .outsid-border .btn[_v-d6221d6a] {\n    margin: 10px 0 10px 20px; }\n\n/* line 10, stdin */\n.more-space[_v-d6221d6a] {\n  margin: 10px 15px; }\n\n/* line 13, stdin */\n.small-space[_v-d6221d6a] {\n  margin-right: 5px; }\n\n/* line 16, stdin */\n.right-space[_v-d6221d6a] {\n  margin-right: 15px; }\n\n/* line 19, stdin */\n.left-space[_v-d6221d6a] {\n  margin-left: 15px; }\n\n/* line 22, stdin */\n.order-edit .search-member[_v-d6221d6a] {\n  margin-top: 0px; }\n\n/* line 25, stdin */\n.commonly-used-items[_v-d6221d6a] {\n  word-break: break-all;\n  background-color: #EEE;\n  min-height: 100vh; }\n  /* line 29, stdin */\n  .commonly-used-items .commonly-item.btn-default[_v-d6221d6a]:active {\n    background-color: #fff; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        billSuccessCallBack: {},
        billFailCallBack: {},
        invalidSuccessCallBack: {},
        enableChangeMember: {}
    },
    data: function data() {
        return {
            commonlyButtonAjaxing: false
        };
    },

    // mounted: async function () {
    //     this.getCommonlyUsedItem();
    // },
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('pos', ['changeEditStatus', 'getCommonlyUsedItem']), {
        addItem: function addItem(id, type) {
            var _this2 = this;

            this.commonlyButtonAjaxing = true;
            this.$store.dispatch('pos/appendOrderDetail', {
                'branch_id': this.select_branch_id,
                'product_type': type,
                'product_id': id,
                'amount': 1,
                'discount_type': 0,
                'discount_value': 0,
                'discount_reason': '',
                'order_id': this.selectOrder.id
            }).then(function () {
                _this2.commonlyButtonAjaxing = false;
            });
        },
        memberChange: function () {
            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(new_member_id) {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                this.changeEditStatus(true);
                                _context.next = 3;
                                return this.$store.dispatch('pos/changeOrderValue', { 'member_id': new_member_id });

                            case 3:
                                this.changeEditStatus(false);

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function memberChange(_x) {
                return _ref.apply(this, arguments);
            }

            return memberChange;
        }(),
        invalidOrder: function invalidOrder(new_member_id) {
            var _this3 = this;

            this.$store.dispatch('pos/invalidOrder', {
                'successCallBack': function successCallBack(response) {
                    _this3.invalidSuccessCallBack && _this3.invalidSuccessCallBack(response);
                    $('#order-edit').modal('hide');
                }
            });
        },
        setBranchId: function setBranchId(newValue) {
            if (newValue && this.current_order_id) {
                this.$store.dispatch('pos/changeOrderValue', { 'branch_id': newValue });
            }

            this.getCommonlyUsedItem(newValue);
            this.$store.commit('pos/POS_SETSTATUS', { 'key': 'select_branch_id', value: newValue });
        },
        billOrder: function () {
            var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(order_id, skip_alert) {
                var message;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                skip_alert = skip_alert || 0;
                                $.blockUI();

                                if (this.canBill()) {
                                    _context2.next = 10;
                                    break;
                                }

                                message = '';

                                if (this.checkHasMemberOnlyProduct() && !this.select_member_id) {
                                    message = '請選擇會員';
                                }
                                if (!this.select_branch_id) {
                                    message = '請選擇場館';
                                }
                                if (!this.checkHasProduct) {
                                    message = '結帳至少要有一品項';
                                }

                                $17.swal({
                                    title: message,
                                    text: '',
                                    type: 'warning'
                                });

                                $.unblockUI();
                                return _context2.abrupt('return');

                            case 10:
                                _context2.next = 12;
                                return this.$store.dispatch('pos/billOrder', {
                                    order_id: order_id,
                                    successCallBack: this.billSuccessCallBack,
                                    failCallBack: this.billFailCallBack,
                                    alertCallBack: this.billAlertCallBack,
                                    skipAlert: skip_alert
                                });

                            case 12:
                                window.Event.$emit('Pos.Bill.Order');
                                $.unblockUI();

                            case 14:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function billOrder(_x2, _x3) {
                return _ref2.apply(this, arguments);
            }

            return billOrder;
        }(),
        checkHasMemberOnlyProduct: function checkHasMemberOnlyProduct() {
            var memberOnlyProduct = this.currentOrder.details.filter(function (details) {
                if (details.product.table_type.indexOf("contracts") == -1) {
                    return false;
                }
                return true;
            });

            return memberOnlyProduct.length > 0 ? true : false;
        },
        canBill: function canBill() {
            return this.select_branch_id && (!this.checkHasMemberOnlyProduct() || this.select_member_id) && this.checkHasProduct ? 1 : 0;
        },
        openProductList: function openProductList(type) {
            this.$store.dispatch('pos/openProductList', { type: type, branch_id: this.select_branch_id }).then(function () {
                $('#product-list-modal').modal('show');
            });
            this.$store.commit('pos/POS_SETSTATUS', { 'key': 'append_mode', value: 'add' });
            this.$store.commit('pos/POS_SETSTATUS', { 'key': 'discount_value', value: 0 });
            this.$store.commit('pos/POS_SETSTATUS', { 'key': 'current_selected_product_type', value: type });
        },
        getBranchList: function getBranchList() {
            this.$store.dispatch('filters/getBranchList');
        }
    }, (0, _vuex.mapActions)('pos', ['changeOrderSalseman', 'clearOrderSalseman']), {
        billAlertCallBack: function billAlertCallBack(response) {
            var _this = this;
            $17.swal({
                title: '確認是否仍要購買?',
                text: response.data.message,
                type: 'warning',
                showCancelButton: true,
                closeOnConfirm: false,
                showLoaderOnConfirm: true
            }, function (answer) {
                if (answer) {
                    _this.billOrder(response.order_id, 1);
                }
            });
        }
    }),
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        // 映射 this.count 为 store.state.count
        branch_id: function branch_id(state) {
            return state.user_branch_id;
        },
        branchOptions: function branchOptions(state) {
            return state.filters.branchOptions;
        },
        current_order_id: function current_order_id(state) {
            return state.pos.select_order.id;
        },
        currentOrder: function currentOrder(state) {
            return state.pos.select_order;
        },
        order_details: function order_details(state) {
            return state.pos.select_order.details;
        },
        WebadminOrderEdit: function WebadminOrderEdit(state) {
            return state.webadmin.configure.webFunctions.WebadminOrderEdit;
        },
        WebadminOrderDelete: function WebadminOrderDelete(state) {
            return state.webadmin.configure.webFunctions.WebadminOrderDelete;
        },
        orderCanBeDelete: function orderCanBeDelete(state) {
            return state.pos.select_order.canBeDelete;
        },
        invoiceSetting: function invoiceSetting(state) {
            return state.pos.select_order.invoice_setting;
        },
        selectOrder: function selectOrder(state) {
            return state.pos.select_order;
        },
        salseMemberId: function salseMemberId(state) {
            return state.pos.select_order.salse_member_id;
        },
        WebadminPosSalsemanEditunpay: function WebadminPosSalsemanEditunpay(state) {
            return state.webadmin.configure.webFunctions.WebadminPosSalsemanEditunpay;
        },
        editAjaxing: function editAjaxing(state) {
            return state.pos.edit_ajaxing;
        },
        getCommonlyUsedItemAjaxing: function getCommonlyUsedItemAjaxing(state) {
            return state.pos.get_commonly_used_item_ajaxing;
        },
        CommonlyUsedItems: function CommonlyUsedItems(state) {
            return state.pos.commonly_used_items;
        },
        userStudioId: function userStudioId(state) {
            return state.user_studio_id;
        }
    }), (0, _vuex.mapGetters)('pos', ['SHOW_MANAUAL_INVOICE', 'GET_ACTIVE_STUDIO_ID']), {
        select_branch_id: {
            get: function get() {
                return store.state.pos.select_branch_id;
            },
            set: function set(newValue) {
                if (newValue) {
                    this.$store.dispatch('pos/changeOrderValue', { 'branch_id': newValue });
                }
                this.getCommonlyUsedItem(newValue);
                this.$store.commit('pos/POS_SETSTATUS', { 'key': 'select_branch_id', value: newValue });
            }
        },
        select_member_id: function select_member_id() {
            return store.state.pos.select_order.member_id ? store.state.pos.select_order.member_id : '';
        },
        checkHasProduct: function checkHasProduct() {
            return this.order_details && this.order_details.length > 0 ? true : false;
        },
        checkCanChangeMember: function checkCanChangeMember() {
            return this.enableChangeMember && !this.checkHasProduct ? true : false;
        },
        walkInMember: function walkInMember() {
            return store.state.pos.select_order.member && store.state.pos.select_order.member.is_walkin ? store.state.pos.select_order.member.is_walkin : 0;
        },
        showInoviceMethod: function showInoviceMethod() {
            return this.invoiceActive == 1 && this.currentOrder.total > 0 ? true : false;
        },

        invoiceActive: function invoiceActive() {
            return this.selectOrder ? this.selectOrder.invoice_active : 0;
        },
        paymentActive: function paymentActive() {
            return this.selectOrder && this.selectOrder.total > 0 ? true : false;
        },
        selected_salseman: {
            get: function get() {
                return store.state.pos.selected_salseman;
            },
            set: function set(newValue) {
                this.$store.commit('pos/SET_ORDER_SALSEMAN', { 'salseman': newValue });
            }
        }
    }),
    watch: {
        selectOrder: function selectOrder(newOrder) {
            if (this.branch_id != 0 && !store.state.pos.select_branch_id) {
                this.setBranchId(this.branch_id);
            }

            if (this.branch_id == 0 && !store.state.pos.select_branch_id && !!this.branchOptions[0] && this.branchOptions[0].id) {
                this.setBranchId(this.branchOptions[0].id);
            }
        },

        userStudioId: function () {
            var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(newValue) {
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                if (this.branchOptions[0]) {
                                    _context3.next = 4;
                                    break;
                                }

                                _context3.next = 3;
                                return this.$store.commit('filters/SETSTATUS', { 'key': 'selected_studio_id', 'value': newValue });

                            case 3:
                                this.getBranchList();

                            case 4:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function userStudioId(_x4) {
                return _ref3.apply(this, arguments);
            }

            return userStudioId;
        }()
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"row p-left-0 p-right-0 p-top-0\" style=\"min-height:100%;\" _v-d6221d6a=\"\">\n  <div class=\"order-edit col-md-9 p-top-15 p-right-5\" _v-d6221d6a=\"\">\n        <div class=\"row\" _v-d6221d6a=\"\">\n            <div class=\"col-sm-6\" _v-d6221d6a=\"\">\n              <div v-if=\"branch_id == 0\" class=\"form-group\" _v-d6221d6a=\"\">\n                <div class=\"select-group\" _v-d6221d6a=\"\">\n                    <select id=\"select_branch\" class=\"form-control\" v-model.lazy=\"select_branch_id\" v-bind:disabled=\"checkHasProduct || commonlyButtonAjaxing\" _v-d6221d6a=\"\">\n                        <option v-for=\"branchOption in branchOptions\" :value=\"branchOption.id\" _v-d6221d6a=\"\">{{ branchOption.branch_name }}</option>\n                    </select>\n                </div>\n              </div>\n            </div>\n        </div>\n        <div class=\"row\" _v-d6221d6a=\"\">\n            <div class=\"filter col-sm-6\" _v-d6221d6a=\"\">\n              <v-member-selector :member-change=\"memberChange\" _v-d6221d6a=\"\">\n                <v-member-selector-result :reset-member-action=\"memberChange\" :enable-change-member=\"checkCanChangeMember\" _v-d6221d6a=\"\"></v-member-selector-result>\n\n                </v-member-selector>\n            </div> \n<!--            <div class=\"col-sm-offset-3 col-sm-3 text-right\">-->\n<!--              <webadmin-salseman-member-select-->\n<!--                  :branch-id=\"selectOrder.branch_id\"-->\n<!--                  :studio-id=\"GET_ACTIVE_STUDIO_ID\"-->\n<!--                  :changed=\"changeOrderSalseman\"-->\n<!--                  :clear-clicked=\"clearOrderSalseman\"-->\n<!--                  :salseman.sync=\"selected_salseman\"-->\n<!--                  :init-value=\"salseMemberId\"-->\n<!--                  :current-id=\"selectOrder.id\"-->\n<!--                  :editright=\"WebadminPosSalsemanEditunpay\"-->\n<!--              >-->\n<!--              </webadmin-salseman-member-select>-->\n<!--            </div>-->\n        </div>\n\n        <div class=\"row p-left-0 p-right-0 p-top-0 p-bottom-0\" _v-d6221d6a=\"\">\n            <div class=\"col-sm-12 border\" _v-d6221d6a=\"\">\n                <div class=\"outsid-border\" v-if=\"WebadminOrderEdit\" _v-d6221d6a=\"\">\n                    <div class=\"btn btn-success\" v-if=\"!walkInMember\" @click=\"openProductList('contracts')\" _v-d6221d6a=\"\">\n                        <i class=\"fa fa-plus-circle\" aria-hidden=\"true\" _v-d6221d6a=\"\"></i>\n                        <span class=\"small-space\" _v-d6221d6a=\"\">方案</span>\n                    </div>\n                    <div class=\"btn btn-success\" @click=\"openProductList('ticket_settings')\" _v-d6221d6a=\"\">\n                        <span class=\"append-icon\" _v-d6221d6a=\"\">\n                            <i class=\"fa fa-plus-circle\" aria-hidden=\"true\" _v-d6221d6a=\"\"></i>\n                        </span>\n                        <span class=\"small-space\" _v-d6221d6a=\"\">票券</span>\n                    </div>\n                    <div class=\"btn btn-success\" @click=\"openProductList('physical_products')\" _v-d6221d6a=\"\">\n                        <span class=\"append-icon\" _v-d6221d6a=\"\">\n                            <i class=\"fa fa-plus-circle\" aria-hidden=\"true\" _v-d6221d6a=\"\"></i>\n                        </span>\n                        <span class=\"small-space\" _v-d6221d6a=\"\">產品</span>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"row p-left-0 p-right-0 p-top-0 p-bottom-0\" _v-d6221d6a=\"\">\n            <div class=\"col-sm-12\" _v-d6221d6a=\"\">\n                <order-detail-list item-type=\"edit\" _v-d6221d6a=\"\"></order-detail-list>\n            </div>\n      </div>\n      <webadmin-order-remark _v-d6221d6a=\"\"></webadmin-order-remark>\n      <webadmin-order-issue-method v-show=\"showInoviceMethod\" _v-d6221d6a=\"\"></webadmin-order-issue-method>\n      <webadmin-invoice-manaual v-if=\"SHOW_MANAUAL_INVOICE\" _v-d6221d6a=\"\"></webadmin-invoice-manaual>\n      <webadmin-branch-payment-methods v-show=\"paymentActive\" v-bind:studio-id=\"GET_ACTIVE_STUDIO_ID\" v-bind:branch-id=\"selectOrder.branch_id\" _v-d6221d6a=\"\"></webadmin-branch-payment-methods>\n      <webadmin-order-salseman :order-salseman-editable=\"WebadminPosSalsemanEditunpay\" :order-id=\"current_order_id\" model-id=\"order-edit-setting-sales-modal\" _v-d6221d6a=\"\"></webadmin-order-salseman>\n      <div class=\"row\" _v-d6221d6a=\"\">\n        <div class=\"col-sm-12\" v-if=\"editAjaxing\" _v-d6221d6a=\"\">\n            <v-spinner-button :ajaxing=\"editAjaxing\" fa-size=\"fa-3x\" _v-d6221d6a=\"\"></v-spinner-button>\n        </div>\n        <div class=\"col-sm-6\" _v-d6221d6a=\"\">\n            <div class=\"btn btn-danger btn--inverse left-space\" @click=\"invalidOrder(current_order_id)\" v-if=\"WebadminOrderDelete &amp;&amp; orderCanBeDelete&amp;&amp;!this.editAjaxing\" _v-d6221d6a=\"\">刪除訂單\n            </div>\n        </div>\n        <div class=\"col-sm-6 text-right\" _v-d6221d6a=\"\">\n            <div class=\"btn btn-success btn-lg right-space m-bottom-10\" v-if=\"WebadminOrderEdit&amp;&amp;this.checkHasProduct&amp;&amp;!this.editAjaxing\" @click=\"billOrder(current_order_id)\" _v-d6221d6a=\"\">\n            確認結帳</div>\n        </div>\n      </div>\n    </div>\n    <div class=\"commonly-used-items col-md-3 p-left-0 p-right-0\" _v-d6221d6a=\"\">\n        <label class=\"m-top-15 m-bottom-5 col-md-12 text-center\" _v-d6221d6a=\"\">常用結帳項目</label>\n        <div class=\"col-md-12 m-top-5 m-bottom-5\" v-if=\"getCommonlyUsedItemAjaxing\" _v-d6221d6a=\"\">\n            <v-spinner :ajaxing=\"getCommonlyUsedItemAjaxing\" fa-size=\"fa-3x\" _v-d6221d6a=\"\"></v-spinner>\n        </div>\n        <div class=\"col-md-12 m-top-5 m-bottom-5\" v-if=\"!getCommonlyUsedItemAjaxing\" _v-d6221d6a=\"\">\n            <div v-for=\"item in CommonlyUsedItems\" :key=\"item.id\" class=\"col-md-12 m-bottom-10\" _v-d6221d6a=\"\">\n                <div v-if=\"commonlyButtonAjaxing\" class=\"btn btn-default disabled text-center col-md-12\" _v-d6221d6a=\"\"><v-spinner-button :ajaxing=\"commonlyButtonAjaxing\" _v-d6221d6a=\"\"></v-spinner-button></div>\n                <input v-if=\"!commonlyButtonAjaxing\" @click=\"addItem(item.commonly_usable_id, item.type)\" class=\"commonly-item center-block btn btn-default col-md-12\" type=\"button\" :value=\"item.name\" _v-d6221d6a=\"\">\n            </div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.outsid-border[_v-d6221d6a] {\n  border: 2px solid #C7C4C3;\n  border-bottom: 0px;\n  margin-bottom: -10px; }\n  /* line 6, stdin */\n  .outsid-border .btn[_v-d6221d6a] {\n    margin: 10px 0 10px 20px; }\n\n/* line 10, stdin */\n.more-space[_v-d6221d6a] {\n  margin: 10px 15px; }\n\n/* line 13, stdin */\n.small-space[_v-d6221d6a] {\n  margin-right: 5px; }\n\n/* line 16, stdin */\n.right-space[_v-d6221d6a] {\n  margin-right: 15px; }\n\n/* line 19, stdin */\n.left-space[_v-d6221d6a] {\n  margin-left: 15px; }\n\n/* line 22, stdin */\n.order-edit .search-member[_v-d6221d6a] {\n  margin-top: 0px; }\n\n/* line 25, stdin */\n.commonly-used-items[_v-d6221d6a] {\n  word-break: break-all;\n  background-color: #EEE;\n  min-height: 100vh; }\n  /* line 29, stdin */\n  .commonly-used-items .commonly-item.btn-default[_v-d6221d6a]:active {\n    background-color: #fff; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-d6221d6a", module.exports)
  } else {
    hotAPI.update("_v-d6221d6a", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1321:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 3, stdin */\n.order-issue-love .multiselect, .order-issue-love .multiselect__content-wrapper {\n  width: 80%; }\n\n/* line 6, stdin */\n.order-issue-love .multiselect__content-wrapper {\n  overflow-x: hidden; }\n\n/* line 2, stdin */\n.row[_v-25af32c8] {\n  margin-bottom: 10px; }\n\n/* line 5, stdin */\n.issue_method_list[_v-25af32c8] {\n  margin-left: 15px;\n  margin-right: 15px; }\n  /* line 8, stdin */\n  .issue_method_list ul[_v-25af32c8] {\n    display: inline;\n    padding-left: 0; }\n    /* line 11, stdin */\n    .issue_method_list ul li[_v-25af32c8] {\n      display: inline-block;\n      margin-left: 10px; }\n      /* line 14, stdin */\n      .issue_method_list ul li span[_v-25af32c8] {\n        margin-left: 5px; }\n    /* line 18, stdin */\n    .issue_method_list ul li[_v-25af32c8]:first-child {\n      margin-left: 0px; }\n\n/* line 25, stdin */\n#remark_height[_v-25af32c8] {\n  height: auto;\n  margin-right: 15px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            ajaxing: false,
            settingDefault: false
        };
    },

    mounted: function mounted() {
        if (this.select_order_id) {
            this.getOrderIssueMethods();
            this.fetchBranchCharities({ branchId: this.select_order.branch_id });
        }
    },
    destroyed: function destroyed() {
        this.RESET_CARRIER();
        this.issue_selected = '';
        this.changeOrderIssueMethod();
        this.POS_SETSTATUS({ 'invoice_issue_methods': {} });
        this.POS_SETSTATUS({ 'invoice_remark': '' });
    },

    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('pos', ['getOrderIssueMethod', 'changeOrderIssueMethod', 'invoiceRemark', 'changeEditStatus']), (0, _vuex.mapMutations)('pos', ['POS_SETSTATUS', 'SET_CARRIER', 'RESET_CARRIER', 'SET_INVOICE_REMARK']), (0, _vuex.mapActions)('webadmin/invoice', ['fetchBranchCharities']), {
        getOrderIssueMethods: function () {
            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                this.ajaxing = true;
                                _context.next = 3;
                                return this.getOrderIssueMethod();

                            case 3:
                                this.RESET_CARRIER();
                                _context.next = 6;
                                return this.fetchBranchCharities({ branchId: this.select_order.branch_id });

                            case 6:
                                this.ajaxing = false;
                                this.setDefaultMethod();

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function getOrderIssueMethods() {
                return _ref.apply(this, arguments);
            }

            return getOrderIssueMethods;
        }(),
        setDefaultMethod: function setDefaultMethod() {
            var _this = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                var defaultIndex;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _this.settingDefault = true;
                                defaultIndex = '';


                                $.each(_this.invoice_issue_methods, function (index, method) {
                                    if (method.is_default == 1) {
                                        _this.issue_selected = index;
                                        defaultIndex = index;

                                        if (index == 'UBN') {
                                            _this.issue_method_carrier_num = method.data.UBN;
                                            _this.issue_method_carrier_name = method.data.name;
                                        } else if (index == 'LoveCode') {
                                            var love_code = method.data;
                                            _this.issue_method_carrier_num = _this.branchCharities.filter(function (charity) {
                                                if (charity.love_code == love_code) {
                                                    return charity;
                                                }
                                            })[0];
                                        } else {
                                            _this.issue_method_carrier_num = method.data;
                                        }
                                    }
                                });

                                _context2.next = 5;
                                return _this.updateIssueMethod(defaultIndex);

                            case 5:
                                _this.settingDefault = false;

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this);
            }))();
        },
        updateIssueMethod: function updateIssueMethod(val) {
            var _this2 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                if (!(_this2.issue_selected && val)) {
                                    _context3.next = 3;
                                    break;
                                }

                                _context3.next = 3;
                                return _this2.changeOrderIssueMethod();

                            case 3:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this2);
            }))();
        },
        checkShowMethod: function checkShowMethod(method) {
            if (method == 'CarrierPay2Go') {
                return this.selected_search_member_email ? true : false;
            }

            return true;
        }
    }),
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('pos', ['invoice_issue_methods', 'select_order', 'select_branch_id', 'issue_method_select', 'issue_method_carrier']), (0, _vuex.mapState)('webadmin/invoice', ['branchCharities']), (0, _vuex.mapState)('filters', ['selected_search_member_email']), {
        select_order_id: function select_order_id() {
            return this.select_order.id;
        },

        issue_selected: {
            set: function set(newVal) {
                this.POS_SETSTATUS({ 'key': 'issue_method_select', 'value': newVal });
            },
            get: function get() {
                return this.issue_method_select;
            }
        },
        issue_method_carrier_num: {
            set: function set(newVal) {
                this.SET_CARRIER({ 'key': 'num', 'value': newVal });
            },
            get: function get() {
                return this.issue_method_carrier.num;
            }
        },
        issue_method_carrier_name: {
            set: function set(newVal) {
                this.SET_CARRIER({ 'key': 'name', 'value': newVal });
            },
            get: function get() {
                return this.issue_method_carrier.name;
            }
        },
        invoice_remark: {
            set: function set(newVal) {
                this.SET_INVOICE_REMARK({ 'key': 'name', 'value': newVal });
            },
            get: function get() {
                return this.$store.state.pos.invoice_remark;
            }
        }
    }),
    watch: {
        // select_order_id: function(val){
        //     if(this.select_order_id){
        //         this.getOrderIssueMethods();
        //     }
        // },
        // select_branch_id: function(val){
        //     if(this.select_order_id){
        //         this.getOrderIssueMethods();
        //     }
        // },
        issue_method_carrier_num: function issue_method_carrier_num(val) {
            if (!this.settingDefault && this.issue_selected && val) {
                this.changeOrderIssueMethod();
            }
        },

        issue_method_carrier_name: function issue_method_carrier_name(val) {
            if (!this.settingDefault && this.issue_selected && val) {
                this.changeOrderIssueMethod();
            }
        },
        issue_selected: function () {
            var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(val, oldVal) {
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                if (!(!this.settingDefault && this.issue_selected && oldVal)) {
                                    _context4.next = 4;
                                    break;
                                }

                                _context4.next = 3;
                                return this.RESET_CARRIER();

                            case 3:
                                this.changeOrderIssueMethod();

                            case 4:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function issue_selected(_x, _x2) {
                return _ref2.apply(this, arguments);
            }

            return issue_selected;
        }(),
        invoice_issue_methods: function (_invoice_issue_methods) {
            function invoice_issue_methods(_x3) {
                return _invoice_issue_methods.apply(this, arguments);
            }

            invoice_issue_methods.toString = function () {
                return _invoice_issue_methods.toString();
            };

            return invoice_issue_methods;
        }(function (val) {
            switch (val) {
                case 'CarrierNPC':
                    this.issue_method_carrier_name = invoice_issue_methods['CarrierNPC']['data']['name'];
                    break;
                case 'CarrierPhone':
                    this.issue_method_carrier_name = invoice_issue_methods['CarrierPhone']['data']['name'];
                    break;
                case 'UBN':
                    this.issue_method_carrier_name = invoice_issue_methods['UBN']['data']['name'];
                    this.issue_method_carrier_num = invoice_issue_methods['UBN']['data']['UBN'];
                    break;
                default:
                    break;
            }
        })
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"issue_method_list\" v-if=\"Object.keys(invoice_issue_methods).length > 0\" _v-25af32c8=\"\">\n    <v-spinner :ajaxing=\"ajaxing\" _v-25af32c8=\"\"></v-spinner>   \n    <div class=\"row\" v-if=\"!ajaxing\" _v-25af32c8=\"\">\n        <div class=\"col-xs-2\" _v-25af32c8=\"\">\n            <label for=\"\" class=\" text-right\" _v-25af32c8=\"\">發票:</label>\n        </div>\n        <div class=\"col-xs-10\" _v-25af32c8=\"\">\n            <ul class=\"\" _v-25af32c8=\"\">\n                <li v-for=\"(invoice_issue_method,index) in invoice_issue_methods\" _v-25af32c8=\"\">\n                    <span v-if=\"checkShowMethod(invoice_issue_method.method)\" _v-25af32c8=\"\">\n                        <input type=\"radio\" :value=\"index\" v-model=\"issue_selected\" :id=\"'invoice'+index\" _v-25af32c8=\"\">\n                        <label :for=\"'invoice'+index\" _v-25af32c8=\"\">{{ invoice_issue_method.name}}</label>\n                    </span>\n                </li>\n            </ul>\n        </div>  \n    </div>\n    <div class=\"row\" v-if=\"!ajaxing\" _v-25af32c8=\"\">\n        <div class=\"col-xs-10 col-xs-offset-2 invoice-input\" _v-25af32c8=\"\">\n            <input type=\"text\" v-model.lazy=\"issue_method_carrier_num\" v-if=\"'CarrierNPC' == issue_selected\" @change=\"updateIssueMethod\" _v-25af32c8=\"\">\n            <input type=\"text\" v-model.lazy=\"issue_method_carrier_num\" v-if=\"'CarrierPhone' == issue_selected\" @change=\"updateIssueMethod\" _v-25af32c8=\"\">\n\n            <v-mutiselect class=\"order-issue-love\" v-if=\"'LoveCode' == issue_selected\" :model.sync=\"issue_method_carrier_num\" :options=\"branchCharities\" :multiple=\"false\" :close-on-select=\"true\" :clear-on-select=\"true\" :searchable=\"true\" label=\"name\" track-by=\"love_code\" tag-name=\"name\" placeholder=\"請選擇\" _v-25af32c8=\"\">\n            </v-mutiselect>\n            <input type=\"text\" v-model.lazy=\"issue_method_carrier_name\" v-if=\"'UBN' == issue_selected\" placeholder=\"請輸入抬頭\" @change=\"updateIssueMethod\" _v-25af32c8=\"\">\n            <input type=\"text\" v-model.lazy=\"issue_method_carrier_num\" v-if=\"'UBN' == issue_selected\" placeholder=\"請輸入統一編號\" @change=\"updateIssueMethod\" maxlength=\"8\" _v-25af32c8=\"\">\n        </div>\n    </div>\n    <div class=\"row\" v-if=\"!ajaxing\" _v-25af32c8=\"\">\n        <div class=\"col-xs-2\" _v-25af32c8=\"\">\n            <label for=\"\" class=\" text-right\" _v-25af32c8=\"\">發票備註</label>\n        </div>\n        <div class=\"col-xs-10\" _v-25af32c8=\"\">\n            <input type=\"text\" name=\"\" id=\"remark_height\" placeholder=\"例如：信用卡後四碼，字數限制12字\" size=\"40\" maxlength=\"12\" v-model.lazy=\"invoice_remark\" @change=\"invoiceRemark\" _v-25af32c8=\"\">\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 3, stdin */\n.order-issue-love .multiselect, .order-issue-love .multiselect__content-wrapper {\n  width: 80%; }\n\n/* line 6, stdin */\n.order-issue-love .multiselect__content-wrapper {\n  overflow-x: hidden; }\n\n/* line 2, stdin */\n.row[_v-25af32c8] {\n  margin-bottom: 10px; }\n\n/* line 5, stdin */\n.issue_method_list[_v-25af32c8] {\n  margin-left: 15px;\n  margin-right: 15px; }\n  /* line 8, stdin */\n  .issue_method_list ul[_v-25af32c8] {\n    display: inline;\n    padding-left: 0; }\n    /* line 11, stdin */\n    .issue_method_list ul li[_v-25af32c8] {\n      display: inline-block;\n      margin-left: 10px; }\n      /* line 14, stdin */\n      .issue_method_list ul li span[_v-25af32c8] {\n        margin-left: 5px; }\n    /* line 18, stdin */\n    .issue_method_list ul li[_v-25af32c8]:first-child {\n      margin-left: 0px; }\n\n/* line 25, stdin */\n#remark_height[_v-25af32c8] {\n  height: auto;\n  margin-right: 15px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-25af32c8", module.exports)
  } else {
    hotAPI.update("_v-25af32c8", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1322:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 3, stdin */\n.member-photo > img[_v-213facbe] {\n  height: 60px; }\n\n/* line 7, stdin */\n.show-member > div[_v-213facbe] {\n  float: left;\n  margin-right: 20px; }\n\n/* line 11, stdin */\n.show-member[_v-213facbe]:after {\n  content: '';\n  display: block;\n  clear: both;\n  visibility: hidden;\n  height: 0; }\n\n/* line 20, stdin */\n.status-col[_v-213facbe] {\n  border: 2px solid #C7C4C3;\n  margin: 10px 0px -12px 0px;\n  padding: 10px 15px; }\n\n/* line 27, stdin */\n.match-table .match-right[_v-213facbe] {\n  padding-right: 17px; }\n\n/* line 30, stdin */\n.match-table .match-left[_v-213facbe] {\n  padding-left: 17px; }\n\n/* line 34, stdin */\n.branchName[_v-213facbe] {\n  margin: 1em 0em;\n  font-size: 1em;\n  font-weight: bold; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    enableRefund: {
      default: false
    },
    invalidSuccessCallBack: {}
  },
  data: function data() {
    return {
      printing: false,
      branch_order_detail_verification_setting_id: null
    };
  },

  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('pos', ['getOrder']), (0, _vuex.mapActions)('pos', ['changeOrderSalseman', 'clearOrderSalseman']), (0, _vuex.mapActions)('webadmin/print', ['outputInvoice', 'previewInvoice', 'previewOrder', 'outputDiscountNote', 'printDiscountNote', 'checkDefaultPrinter', 'previewDiscountNote']), {
    outputInvoice: function outputInvoice() {
      window.open(window.location.origin + "/adminapi/invoice/order/" + this.order_id + "/print/pdf", '_blank');
    },
    printDiscountNoteAction: function printDiscountNoteAction(order_id, e) {
      var _this = this;

      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                window.open('https://' + location.hostname + "/simple/webadmin/print/preview?type=discount-note&id=" + order_id + "&branch=" + _this.selectOrder.branch_id, '_blank');

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    refundOrder: function refundOrder() {
      var _this2 = this;

      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        var vm;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // let studio_payment_method_id = this.selectOrder.payment_action_records[0].studio_payment_method_id;
                // await this.getVerificationSetting(this.selectOrder.branch_id,studio_payment_method_id);

                // if(this.branch_order_detail_verification_setting_id && !this.is17fit){
                //   $17.swal({
                //     title: '請聯繫客服人員',
                //     text: '',
                //     type: 'error',
                //     showCancelButton: false,
                //   });

                //   return;
                // }
                vm = _this2;

                $('#order-show').modal('hide');
                _this2.$store.dispatch('pos/resetSelectOrder');
                _this2.$store.dispatch('pos/openOrCreateOrder', {
                  'order_id': _this2.order_id,
                  'successCallBack': function successCallBack() {
                    $("#order-refund").modal('show');
                  }
                });

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    showMessage: function showMessage(state, message) {
      message = typeof message === 'undefined' ? '' : message;
      var type = state ? 'success' : 'error';
      var state_text = state ? '成功' : '失敗';
      $17.swal({
        title: '作廢' + state_text,
        text: message,
        type: type,
        showCancelButton: false
      });
    },
    addDays: function addDays(date, days) {
      var thisDate = new Date();
      thisDate.setDate(thisDate.getDate() + days);
      return thisDate;
    },

    orderIssue: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                $.blockUI();
                _context3.next = 3;
                return this.$store.dispatch('pos/orderIssue', { successCallBack: this.issueSuccess, failCallBack: this.issueFail });

              case 3:

                $.unblockUI();

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function orderIssue() {
        return _ref.apply(this, arguments);
      }

      return orderIssue;
    }(),
    issueSuccess: function issueSuccess(response) {
      $('#order-show').modal('hide');
      $('#multi-alert-modal').modal('show');
    },
    issueFail: function issueFail(response) {
      $('#order-show').modal('hide');
      $('#multi-alert-modal').modal('show');
    },

    orderAllowance: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                $.blockUI();
                _context4.next = 3;
                return this.$store.dispatch('pos/orderAllowance', { successCallBack: this.allowanceSuccess, failCallBack: this.allowanceFail });

              case 3:
                $.unblockUI();

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function orderAllowance() {
        return _ref2.apply(this, arguments);
      }

      return orderAllowance;
    }(),
    allowanceSuccess: function allowanceSuccess(response) {
      this.showAlert();
    },
    allowanceFail: function allowanceFail(response) {
      this.showAlert();
    },
    invalidSuccess: function invalidSuccess(response) {
      this.getOrder({ order_id: this.order_id });
      $17.swal({
        title: '操作成功',
        text: '',
        type: 'success',
        showCancelButton: false
      });
      this.invalidSuccessCallBack && this.invalidSuccessCallBack(response);
    },
    invalidFail: function invalidFail(response) {
      this.getOrder({ order_id: this.order_id });
      $17.swal({
        title: '操作失敗',
        text: '',
        type: 'error',
        showCancelButton: false
      });
    },
    showAlert: function showAlert() {
      $('#order-show').modal('hide');
      $('#multi-alert-modal').modal('show');
    },
    checkValidPrintType: function checkValidPrintType() {
      return ['PrintCode', 'UBN'].indexOf(this.issueMethod) != -1;
    },
    getVerificationSetting: function getVerificationSetting(branch_id, studio_payment_method_id) {
      var _this3 = this;

      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5() {
        return _regenerator2.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(!branch_id || !studio_payment_method_id)) {
                  _context5.next = 2;
                  break;
                }

                return _context5.abrupt('return');

              case 2:
                _context5.next = 4;
                return _this3.$http.get('/adminapi/verification-appropriation/setting/branch/' + branch_id + '/studio_payment_method?studio_payment_method_id=' + studio_payment_method_id).then(function (response) {
                  _this3.branch_order_detail_verification_setting_id = null;
                  if (response.data.id) {
                    _this3.branch_order_detail_verification_setting_id = response.data.id;
                  }
                });

              case 4:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this3);
      }))();
    },
    invalidSuccessOrder: function invalidSuccessOrder() {
      var vm = this;
      $17.swal({
        title: '確認作廢此訂單?',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: false,
        showLoaderOnConfirm: true
      }, function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(answer) {
          return _regenerator2.default.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  if (!answer) {
                    _context6.next = 5;
                    break;
                  }

                  $.blockUI();
                  _context6.next = 4;
                  return vm.$store.dispatch('pos/invalidSuccessOrder', { successCallBack: vm.invalidSuccess, failCallBack: vm.invalidFail });

                case 4:
                  $.unblockUI();

                case 5:
                case 'end':
                  return _context6.stop();
              }
            }
          }, _callee6, this);
        }));

        return function (_x) {
          return _ref3.apply(this, arguments);
        };
      }());
    }
  }),
  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
    total: function total(state) {
      return state.pos.select_order.total;
    },
    order_id: function order_id(state) {
      return state.pos.select_order.id;
    },
    order_type: function order_type(state) {
      return state.pos.select_order.type;
    },
    member: function member(state) {
      return state.pos.select_order.member;
    },
    studio: function studio(state) {
      return state.pos.select_order.studio;
    },
    originOrderId: function originOrderId(state) {
      return state.pos.select_order.originId;
    },
    refundReason: function refundReason(state) {
      return state.pos.select_order.refund_reason;
    },
    orderDetails: function orderDetails(state) {
      return state.pos.select_order.details;
    },
    is17fit: function is17fit(state) {
      return state.is_17fit;
    },
    studioPaymentMethods: function studioPaymentMethods(state) {
      return state.pos.select_order.payment_action_records;
    },
    refundCheckDay: function refundCheckDay(state) {
      return state.pos.select_order.created_at;
    },
    WebadminOrderRefund: function WebadminOrderRefund(state) {
      return state.webadmin.configure.webFunctions.WebadminOrderRefund;
    },
    WebadminPosSalsemanEditpay: function WebadminPosSalsemanEditpay(state) {
      return state.webadmin.configure.webFunctions.WebadminPosSalsemanEditpay;
    },
    branchName: function branchName(state) {
      return state.pos.select_order.branchName;
    },
    invoiceSetting: function invoiceSetting(state) {
      return state.pos.select_order.invoice_setting;
    },
    invoice: function invoice(state) {
      return state.pos.select_order.invoice;
    },
    isAllowanced: function isAllowanced(state) {
      return state.pos.select_order.isAllowanced;
    },
    is_issued: function is_issued(state) {
      return state.pos.select_order.is_issued;
    },
    issueMethodSelect: function issueMethodSelect(state) {
      return state.pos.issue_method_select;
    },
    selectOrder: function selectOrder(state) {
      return state.pos.select_order;
    },
    issueMethod: function issueMethod(state) {
      return state.pos.select_order.issue_method;
    },
    issueRemark: function issueRemark(state) {
      return state.pos.select_order.invoice_remark;
    },
    printSettings: function printSettings(state) {
      return state.webadmin.print.settings;
    },
    salseMemberId: function salseMemberId(state) {
      return state.pos.select_order.salse_member_id;
    },
    orderStatusName: function orderStatusName(state) {
      return state.pos.select_order.orderStatusName;
    },
    orderStatus: function orderStatus(state) {
      return state.pos.select_order.payment_status;
    },
    isAllowToInvalidOrder: function isAllowToInvalidOrder(state) {
      return state.pos.select_order.isAllowToInvalidOrder;
    }
  }), (0, _vuex.mapGetters)('pos', ['SHOW_MANAUAL_INVOICE', 'GET_ACTIVE_STUDIO_ID',,]), (0, _vuex.mapGetters)('webadmin/invoice/', {
    print_data: 'EPSON_PRINT_DATA'
  }), {
    studio_name: function studio_name() {
      return this.studio && this.studio.brand_name ? this.studio.brand_name : '';
    },
    member_name: function member_name() {
      return this.member && this.member.name ? this.member.name : '';
    },
    member_email: function member_email() {
      return this.member && this.member.name ? this.member.email : '';
    },
    member_phone: function member_phone() {
      return this.member && this.member.name ? this.member.phone : '';
    },
    member_photo: function member_photo() {
      return this.member && this.member.name ? this.member.picture_path : '';
    },
    invoiceActive: function invoiceActive() {
      return this.selectOrder ? this.selectOrder.invoice_active : 0;
    },
    invoiceNumber: function invoiceNumber() {
      return this.invoice && this.invoice.invoice_number ? this.invoice.invoice_number : '';
    },
    canRefund: function canRefund() {
      return this.order_type !== 13 && !this.isAllRefund && (!this.isNeed17fitRefund || this.isNeed17fitRefund && this.isInRefundableDay && this.is17fit) ? true : false;
    },
    statusText: function statusText() {
      if (this.order_type == 13) {
        return '原訂單:' + this.originOrderId;
      }
      return this.orderStatusName;
    },
    isAllRefund: function isAllRefund() {
      if (!this.orderDetails) {
        return true;
      }
      var canRefundLength = 0;
      var vm = this;
      for (var i = 0; i < vm.orderDetails.length; i++) {
        if (vm.orderDetails[i] && vm.orderDetails[i].hasOwnProperty('rest_can_refund') && vm.orderDetails[i].rest_can_refund > 0) {
          canRefundLength++;
          break;
        }
      }
      return canRefundLength === 0;
    },
    isNeed17fitRefund: function isNeed17fitRefund() {
      if (!this.studioPaymentMethods) {
        return false;
      }
      var methodCheck = this.studioPaymentMethods.map(function ($item) {
        return [2].indexOf($item.studio_payment_method_id) > -1 ? true : false;
      });
      return methodCheck.indexOf(true) > -1;
    },
    isInRefundableDay: function isInRefundableDay() {
      return $17.addDays(this.refundCheckDay, 7) > new Date() ? true : false;
    },
    is_walkin: function is_walkin() {
      return this.$store.state.filters.selected_search_member_is_walkin;
    },
    showInoviceMethod: function showInoviceMethod() {
      return this.invoiceActive == 1 && this.originOrderId == null && this.invoiceNumber == "" && this.total > 0 ? true : false;
    },
    showAllowance: function showAllowance() {
      return this.invoiceActive == 1 && !this.isAllowanced && this.is_issued && (this.originOrderId != null || this.isInvalid) ? true : false;
    },
    showAllowanceNote: function showAllowanceNote() {
      return this.invoiceActive == 1 && this.isAllowanced && this.is_issued && (this.originOrderId != null || this.isInvalid) ? true : false;
    },
    showIssueButton: function showIssueButton() {
      return this.issueMethodSelect != 'None' && this.issueMethodSelect != '' ? true : false;
    },

    selected_salseman: {
      get: function get() {
        return store.state.pos.selected_salseman;
      },
      set: function set(newValue) {
        this.$store.commit('pos/SET_ORDER_SALSEMAN', { 'salseman': newValue });
      }
    },
    paymentMethodHeader: function paymentMethodHeader() {
      return this.originOrderId ? '退費方式' : '支付方式';
    },
    isInvalid: function isInvalid() {
      return this.orderStatus == 2;
    }
  }),
  watch: {}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"order-show\" _v-213facbe=\"\">\n    <div class=\"row\" _v-213facbe=\"\">\n      <div class=\"col-sm-6\" _v-213facbe=\"\">\n        <div class=\"branchName\" _v-213facbe=\"\">\n          {{branchName}}\n        </div>\n      </div>\n    </div>\n    <div class=\"row\" _v-213facbe=\"\">\n      <div class=\"col-sm-6\" _v-213facbe=\"\">\n        <div class=\"show-member\" _v-213facbe=\"\">\n          <div class=\"member-photo\" _v-213facbe=\"\">\n            <img class=\"photo\" v-bind:src=\"member_photo\" alt=\"\" _v-213facbe=\"\">\n          </div>\n          <div _v-213facbe=\"\">\n            <div class=\"name\" _v-213facbe=\"\">{{member_name}}</div>\n            <div class=\"phone\" v-if=\"!is_walkin\" _v-213facbe=\"\">{{member_phone}}</div>\n            <div class=\"email\" v-if=\"!is_walkin\" _v-213facbe=\"\">{{member_email}}</div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"row\" _v-213facbe=\"\">\n      <div class=\"col-sm-12\" _v-213facbe=\"\">\n        <div class=\"status-col\" _v-213facbe=\"\">\n          <span _v-213facbe=\"\">{{statusText}}</span>\n          <span v-if=\"invoiceNumber !==''\" _v-213facbe=\"\">已開立發票 {{invoiceNumber}}</span>\n        </div>\n      </div>\n    </div>\n      <div class=\"row\" _v-213facbe=\"\">\n          <div class=\"col-sm-12\" _v-213facbe=\"\">\n              <order-detail-list item-type=\"show\" _v-213facbe=\"\"></order-detail-list>\n          </div>\n      </div>\n      <webadmin-order-issue-method v-if=\"showInoviceMethod\" _v-213facbe=\"\"></webadmin-order-issue-method>\n      <webadmin-order-remark v-if=\"!originOrderId\" _v-213facbe=\"\"></webadmin-order-remark>\n      <webadmin-invoice-manaual v-if=\"SHOW_MANAUAL_INVOICE\" _v-213facbe=\"\"></webadmin-invoice-manaual>\n      <order-payment-show :payment-method-header=\"paymentMethodHeader\" _v-213facbe=\"\"></order-payment-show>\n      <webadmin-order-salseman :order-salseman-editable=\"WebadminPosSalsemanEditpay\" :order-id=\"order_id\" model-id=\"order-show-setting-sales-modal\" _v-213facbe=\"\"></webadmin-order-salseman>\n      <div class=\"row match-table\" v-if=\"invoiceNumber !='' &amp;&amp; checkValidPrintType() &amp;&amp; issueRemark!=''\" _v-213facbe=\"\">\n          <div class=\"col-sm-6 \" _v-213facbe=\"\">\n              <label for=\"\" class=\"match-left\" _v-213facbe=\"\">發票備註：</label>\n          </div>\n          <div class=\"col-sm-6 text-right \" _v-213facbe=\"\">\n              <div class=\"match-right\" _v-213facbe=\"\">{{issueRemark}}</div>\n          </div>\n      </div>\n      <div class=\"row\" v-if=\"!isInvalid\" _v-213facbe=\"\">\n          <div class=\"col-sm-6\" v-if=\"canRefund &amp;&amp; WebadminOrderRefund &amp;&amp; enableRefund\" _v-213facbe=\"\">\n              <input type=\"button\" value=\"退費\" class=\"btn btn-danger btn--inverse\" @click=\"refundOrder\" _v-213facbe=\"\">\n              <input type=\"button\" value=\"作廢訂單\" class=\"btn btn-default\" v-if=\"isAllowToInvalidOrder\" @click=\"invalidSuccessOrder\" _v-213facbe=\"\">\n          </div>\n          <div class=\"col-sm-6\" v-if=\"!(canRefund &amp;&amp; WebadminOrderRefund &amp;&amp; enableRefund)\" _v-213facbe=\"\">\n\n          </div>\n          <div class=\"col-sm-6 text-right\" _v-213facbe=\"\">\n              <input v-if=\"!originOrderId\" type=\"button\" value=\"列印全部\" class=\"btn btn-success\" @click=\"previewOrder({ 'orderId':order_id,'branchId':selectOrder.branch_id})\" _v-213facbe=\"\">\n              <span v-if=\"invoiceNumber !='' &amp;&amp; checkValidPrintType()\" _v-213facbe=\"\">\n                <input type=\"button\" value=\"列印發票\" class=\"btn btn-success\" @click=\"previewInvoice({ 'orderId':order_id,'branchId':selectOrder.branch_id})\" _v-213facbe=\"\">\n                <input type=\"button\" value=\"輸出發票\" class=\"btn btn-success\" @click=\"outputInvoice(order_id)\" _v-213facbe=\"\">\n              </span>\n          </div>\n      </div>\n      <div class=\"row m-top-5\" v-if=\"showInoviceMethod &amp;&amp; !isInvalid\" _v-213facbe=\"\">\n          <div class=\"col-sm-6 col-sm-offset-6 text-right\" _v-213facbe=\"\">\n              <input type=\"button\" value=\"開立發票\" class=\"btn btn-success btn-lg right-space\" v-show=\"showIssueButton\" @click=\"orderIssue\" _v-213facbe=\"\">\n          </div>\n      </div>\n      <div class=\"row\" v-if=\"originOrderId \" _v-213facbe=\"\">\n          <div class=\"col-sm-6 match-left\" _v-213facbe=\"\">\n              <label for=\"\" _v-213facbe=\"\">退費原因：</label>\n          </div>\n          <div class=\"col-sm-6 text-right \" _v-213facbe=\"\">\n              <div class=\"match-right\" _v-213facbe=\"\">{{refundReason}}</div>\n          </div>\n      </div>\n      <div class=\"row\" v-if=\"showAllowanceNote\" _v-213facbe=\"\">\n          <div class=\"col-sm-6 col-sm-offset-6 text-right\" _v-213facbe=\"\">\n              <input type=\"button\" value=\"列印折讓單\" class=\"btn btn-success\" @click=\"previewDiscountNote({ 'orderId':order_id})\" _v-213facbe=\"\">\n              <input type=\"button\" value=\"輸出折讓單\" class=\"btn btn-success\" @click=\"outputDiscountNote(order_id)\" _v-213facbe=\"\">\n          </div>\n      </div>\n      <div class=\"row\" v-if=\"showAllowance\" _v-213facbe=\"\">\n          <div class=\"col-sm-6 col-sm-offset-6 text-right\" _v-213facbe=\"\">\n              <input type=\"button\" value=\"折讓發票\" class=\"btn btn-danger btn-lg right-space\" @click=\"orderAllowance\" _v-213facbe=\"\">\n          </div>\n      </div>\n  </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 3, stdin */\n.member-photo > img[_v-213facbe] {\n  height: 60px; }\n\n/* line 7, stdin */\n.show-member > div[_v-213facbe] {\n  float: left;\n  margin-right: 20px; }\n\n/* line 11, stdin */\n.show-member[_v-213facbe]:after {\n  content: '';\n  display: block;\n  clear: both;\n  visibility: hidden;\n  height: 0; }\n\n/* line 20, stdin */\n.status-col[_v-213facbe] {\n  border: 2px solid #C7C4C3;\n  margin: 10px 0px -12px 0px;\n  padding: 10px 15px; }\n\n/* line 27, stdin */\n.match-table .match-right[_v-213facbe] {\n  padding-right: 17px; }\n\n/* line 30, stdin */\n.match-table .match-left[_v-213facbe] {\n  padding-left: 17px; }\n\n/* line 34, stdin */\n.branchName[_v-213facbe] {\n  margin: 1em 0em;\n  font-size: 1em;\n  font-weight: bold; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-213facbe", module.exports)
  } else {
    hotAPI.update("_v-213facbe", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1323:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.row[_v-770306fc] {\n  margin-left: 2em; }\n\n/* line 5, stdin */\n.auth-option[_v-770306fc] {\n  margin-top: 1em;\n  margin-bottom: 0.5em; }\n  /* line 8, stdin */\n  .auth-option label[_v-770306fc] {\n    margin-left: 5px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {};
    },

    mounted: function mounted() {
        this.fetchMainCredit();
        this.fetchAutoPayPlanCreditCard();
        if (this.allowMainCredit) {
            this.CHANGE_CREDIT_INPUT({ 'key': 'auth_type', 'value': 'auth' });
        }
    },
    destroyed: function destroyed() {
        this.CREDIT_INFO();
    },
    methods: (0, _extends3.default)({}, (0, _vuex.mapMutations)('pos', ['CHANGE_CREDIT_INPUT', 'CREDIT_INFO']), (0, _vuex.mapActions)('pos', ['changeInvoiceNumber']), {
        getYear: function getYear(add) {
            return moment().add(add, 'years').format('YYYY');
        },
        fetchMainCredit: function fetchMainCredit() {
            var _this = this;

            if (!this.allowMainCredit || !this.orderMemberId) {
                return;
            }
            this.$http.get('/adminapi/pos/order/' + this.select_order.id + '/credit_main').then(function (response) {
                _this.CHANGE_CREDIT_INPUT({ 'key': 'main_card_num', 'value': response.data.cardNum });
                _this.CHANGE_CREDIT_INPUT({ 'key': 'exist_main_card', 'value': response.data.existMainCard });
            }, function (error) {
                _this.view.ajaxing = false;
            });
        },
        fetchAutoPayPlanCreditCard: function fetchAutoPayPlanCreditCard() {
            var _this2 = this;

            if (!this.showAutoPayCreditCard || !this.orderMemberId) {
                return;
            }
            this.$http.get('/adminapi/pos/order/' + this.select_order.id + '/auto-pay-payload').then(function (response) {
                if (response.data.existAutoPayCards == 1) {
                    _this2.authType = 'auth-auto-pay-plan';
                }
                _this2.CHANGE_CREDIT_INPUT({ 'key': 'auto_pay_card_num', 'value': response.data.autoPayCardNum });
                _this2.CHANGE_CREDIT_INPUT({ 'key': 'exist_auto_pay_cards', 'value': response.data.existAutoPayCards });
            }, function (error) {
                _this2.view.ajaxing = false;
            });
        }
    }),
    watch: {
        orderMemberId: function orderMemberId(newVal) {
            if (newVal) {
                this.fetchMainCredit();
                this.fetchAutoPayPlanCreditCard();
            }
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('pos', ['select_order']), {
        creditNum: {
            get: function get() {
                return this.$store.state.pos.credit_input.credit_num;
            },
            set: function set(newValue) {
                this.CHANGE_CREDIT_INPUT({ 'key': 'credit_num', 'value': newValue.replace(/\D+/g, '') });
                this.$forceUpdate();
            }
        },
        expiMon: {
            get: function get() {
                if (this.$store.state.pos.credit_input.expi_mon === '') {
                    this.expiMon = '06';
                }
                return this.$store.state.pos.credit_input.expi_mon;
            },
            set: function set(newValue) {
                this.CHANGE_CREDIT_INPUT({ 'key': 'expi_mon', 'value': newValue });
            }
        },
        expiYear: {
            get: function get() {
                if (this.$store.state.pos.credit_input.expi_year === '') {
                    this.expiYear = this.getYear(3);
                }
                return this.$store.state.pos.credit_input.expi_year;
            },
            set: function set(newValue) {
                this.CHANGE_CREDIT_INPUT({ 'key': 'expi_year', 'value': newValue });
            }
        },
        cvs: {
            get: function get() {
                return this.$store.state.pos.credit_input.cvs;
            },
            set: function set(newValue) {
                this.CHANGE_CREDIT_INPUT({ 'key': 'cvs', 'value': newValue.replace(/\D+/g, '') });
                this.$forceUpdate();
            }
        },
        is_checked: {
            get: function get() {
                return this.$store.state.pos.credit_input.is_checked;
            },
            set: function set(newValue) {
                this.CHANGE_CREDIT_INPUT({ 'key': 'is_checked', 'value': newValue });
            }
        },
        authType: {
            get: function get() {
                return this.$store.state.pos.credit_input.auth_type;
            },
            set: function set(newValue) {
                this.CHANGE_CREDIT_INPUT({ 'key': 'auth_type', 'value': newValue });
            }
        },
        mainCreditNum: {
            get: function get() {
                return this.$store.state.pos.credit_input.main_card_num;
            },
            set: function set(newValue) {
                this.CHANGE_CREDIT_INPUT({ 'key': 'main_card_num', 'value': newValue });
            }
        },
        allowMainCredit: function allowMainCredit() {
            return this.select_order.allow_main_credit;
        },
        orderMemberId: function orderMemberId() {
            return this.select_order.member_id;
        },
        existMainCard: function existMainCard() {
            return this.$store.state.pos.credit_input.exist_main_card;
        },
        showAutoPayCreditCard: function showAutoPayCreditCard() {
            return this.select_order.is_auto_pay_order;
        },
        autoPayCardNum: function autoPayCardNum() {
            return this.$store.state.pos.credit_input.auto_pay_card_num;
        },
        existAutoPayCards: function existAutoPayCards() {
            return this.$store.state.pos.credit_input.exist_auto_pay_cards;
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-770306fc=\"\">\n    <div class=\"auth-option\" _v-770306fc=\"\">\n        <div class=\"row\" v-if=\"allowMainCredit\" _v-770306fc=\"\">\n            <div class=\"col-xs-12 col-sm-12\" _v-770306fc=\"\">\n                <input type=\"radio\" value=\"auth\" v-model=\"authType\" class=\"\" name=\"auth-type\" id=\"auth-type-auth\" _v-770306fc=\"\">\n                <label for=\"auth-type-auth\" _v-770306fc=\"\">授權信用卡</label>\n            \n                <input type=\"text\" name=\"\" :value=\"mainCreditNum\" disabled=\"\" id=\"\" v-show=\"existMainCard\" _v-770306fc=\"\">\n                <span v-show=\"!existMainCard\" _v-770306fc=\"\">{{mainCreditNum}}</span>\n            </div>\n        </div>\n        <div class=\"row\" v-if=\"showAutoPayCreditCard\" _v-770306fc=\"\">\n            <div class=\"col-xs-12 col-sm-12\" _v-770306fc=\"\">\n                <input type=\"radio\" value=\"auth-auto-pay-plan\" v-model=\"authType\" class=\"\" name=\"auth-type\" id=\"auth-type-auto-pay-plan\" _v-770306fc=\"\">\n                <label for=\"auth-type-auto-pay-plan\" _v-770306fc=\"\">授權信用卡</label>\n            \n                <input type=\"text\" name=\"\" :value=\"autoPayCardNum\" disabled=\"\" id=\"\" v-show=\"existAutoPayCards\" _v-770306fc=\"\">\n                <span v-show=\"!existMainCard\" _v-770306fc=\"\">{{mainCreditNum}}</span>\n            </div>\n        </div>\n        <div class=\"row\" _v-770306fc=\"\">\n            <div class=\"col-xs-12 col-sm-12\" _v-770306fc=\"\">\n                <input type=\"radio\" value=\"input\" v-model=\"authType\" class=\"\" name=\"auth-type\" id=\"auth-type-input\" _v-770306fc=\"\">\n                <label for=\"auth-type-input\" _v-770306fc=\"\">輸入信用卡</label>\n            </div>\n        </div>\n    </div>\n    <div class=\"form-group row\" v-show=\"authType=='input'\" _v-770306fc=\"\">\n        <label for=\"credit-num\" class=\"col-xs-4 col-sm-3\" _v-770306fc=\"\">信用卡號碼</label>\n        <div class=\"col-xs-7 col-sm-6\" _v-770306fc=\"\">\n            <input type=\"text\" v-model=\"creditNum\" class=\"form-control\" id=\"credit-num\" maxlength=\"16\" minlength=\"16\" placeholder=\"填入16碼卡號\" _v-770306fc=\"\">\n        </div>\n    </div>\n    <div class=\"form-group row\" v-show=\"authType=='input'\" _v-770306fc=\"\">\n        <label for=\"credit-num\" class=\"col-xs-4 col-sm-3\" _v-770306fc=\"\">到期日</label>\n            <div class=\"col-xs-3 col-sm-3\" _v-770306fc=\"\">\n                <select name=\"expi-mon\" id=\"expi-mon\" class=\"form-control\" v-model=\"expiMon\" _v-770306fc=\"\">\n                    <option value=\"01\" _v-770306fc=\"\">01</option>\n                    <option value=\"02\" _v-770306fc=\"\">02</option>\n                    <option value=\"03\" _v-770306fc=\"\">03</option>\n                    <option value=\"04\" _v-770306fc=\"\">04</option>\n                    <option value=\"05\" _v-770306fc=\"\">05</option>\n                    <option value=\"06\" _v-770306fc=\"\">06</option>\n                    <option value=\"07\" _v-770306fc=\"\">07</option>\n                    <option value=\"08\" _v-770306fc=\"\">08</option>\n                    <option value=\"09\" _v-770306fc=\"\">09</option>\n                    <option value=\"10\" _v-770306fc=\"\">10</option>\n                    <option value=\"11\" _v-770306fc=\"\">11</option>\n                    <option value=\"12\" _v-770306fc=\"\">12</option>\n                </select>\n            </div>\n            <div class=\"col-xs-4 col-sm-3\" _v-770306fc=\"\">\n                <select name=\"expi-mon\" id=\"expi-year\" class=\"form-control\" v-model=\"expiYear\" _v-770306fc=\"\">\n                    <option :value=\"getYear(0)\" _v-770306fc=\"\">{{ getYear(0) }}</option>\n                    <option :value=\"getYear(n)\" v-for=\"n in  15\" _v-770306fc=\"\">{{ getYear(n) }}</option>\n                </select>\n            </div>\n    </div>\n    <div class=\"form-group row\" v-show=\"authType=='input'\" _v-770306fc=\"\">\n        <div class=\"col-xs-4 col-sm-3\" _v-770306fc=\"\">\n            <label for=\"credit-num\" _v-770306fc=\"\">安全碼</label>\n        </div>\n        <div class=\"col-xs-3 col-sm-2\" _v-770306fc=\"\">\n            <input type=\"text\" v-model=\"cvs\" class=\"form-control\" id=\"credit-num\" maxlength=\"4\" minlength=\"3\" placeholder=\"***\" _v-770306fc=\"\">\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.row[_v-770306fc] {\n  margin-left: 2em; }\n\n/* line 5, stdin */\n.auth-option[_v-770306fc] {\n  margin-top: 1em;\n  margin-bottom: 0.5em; }\n  /* line 8, stdin */\n  .auth-option label[_v-770306fc] {\n    margin-left: 5px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-770306fc", module.exports)
  } else {
    hotAPI.update("_v-770306fc", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1324:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {};
    },

    methods: (0, _extends3.default)({}, (0, _vuex.mapMutations)('pos', ['CHANGE_CUSTOM_USER_INPUT'])),
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('pos', []), {
        thirdCustomUserKey: {
            get: function get() {
                return this.$store.state.pos.custom_user_input.key;
            },
            set: function set(newValue) {
                this.CHANGE_CUSTOM_USER_INPUT({ 'key': 'key', 'value': newValue.replace(/\D+/g, '') });
                this.$forceUpdate();
            }
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-05600859=\"\">\n    <div class=\"form-group row\" _v-05600859=\"\">\n        <div class=\"col-xs-7 col-sm-6\" _v-05600859=\"\">\n            <input type=\"text\" v-model=\"thirdCustomUserKey\" class=\"form-control\" placeholder=\"掃瞄或輸入條碼...\" _v-05600859=\"\">\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-05600859", module.exports)
  } else {
    hotAPI.update("_v-05600859", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vuex":803}],1325:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\nhr[_v-023e09da] {\n  margin-left: -20px;\n  margin-right: -20px; }\n\n/* line 6, stdin */\n.total-col[_v-023e09da] {\n  font-weight: bold; }\n\n/* line 9, stdin */\n.form-horizontal > .form-group > div > *[_v-023e09da] {\n  text-align: right; }\n\n/* line 12, stdin */\n#refund-reson[_v-023e09da] {\n  text-align: left; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _isInteger = require('babel-runtime/core-js/number/is-integer');

var _isInteger2 = _interopRequireDefault(_isInteger);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            id: 'product_append',
            selected_used_discount: ''
        };
    },
    props: {
        locked: false,
        removeBtnShow: {
            default: false
        },
        closeBtnText: {
            default: '返回'
        },
        saveClicked: {},
        removeClicked: {}
    },
    methods: {
        disableKeyPress: function disableKeyPress(e) {
            //46 是.//45 是-//48 是 0
            if (e.charCode == 46 || e.charCode == 45 || e.charCode == 48 && this.buy_number == 0) {
                e.preventDefault();
            }
        },
        closeModal: function closeModal() {
            if (this.locked) return;
            $('#' + this.id).modal('hide');
        },
        saveBtnClicked: function saveBtnClicked() {
            var _this = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (_this.checkDiscount()) {
                                    _context.next = 2;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 2:
                                if (_this.checkReasonIsEntered()) {
                                    _context.next = 4;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 4:
                                _context.next = 6;
                                return _this.$store.dispatch('pos/appendOrderDetail', {
                                    'branch_id': _this.select_order.branch_id,
                                    'product_type': _this.select_product.type,
                                    'product_id': _this.select_product.id,
                                    'amount': _this.buy_number,
                                    'discount_type': _this.discount_type,
                                    'discount_value': _this.discount_value,
                                    'discount_reason': _this.discount_reason,
                                    'order_id': _this.select_order.id
                                });

                            case 6:
                                $('#product_append').modal('hide');
                                $('#product-list-modal').modal('hide');

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        editBtnClicked: function editBtnClicked() {
            var _this2 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (_this2.checkDiscount()) {
                                    _context2.next = 2;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 2:
                                if (_this2.checkReasonIsEntered()) {
                                    _context2.next = 4;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 4:
                                _context2.next = 6;
                                return _this2.$store.dispatch('pos/changeOrderDetail', {
                                    amount: _this2.buy_number,
                                    discount_value: _this2.discount_value,
                                    discount_type: _this2.discount_type,
                                    discount_reason: _this2.discount_reason
                                });

                            case 6:
                                $('#product_append').modal('hide');
                                $('#product-list-modal').modal('hide');

                            case 8:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        removeThousandth: function removeThousandth(value) {
            if (!value) {
                return 0;
            }
            if (typeof value == 'number') {
                return value;
            }
            return value.replace(/[,]+/g, "");
        },
        formatThousandth: function formatThousandth(value) {
            return $17.moneyFormat(value);
        },
        resetProduct: function resetProduct() {
            this.$store.dispatch('pos/resetAllSelectProduct');
        },
        checkReasonIsEntered: function checkReasonIsEntered() {
            if (this.discount_value > 0 && !this.discount_reason) {
                $17.swal({
                    title: '請輸入折扣原因',
                    text: "",
                    type: 'error'
                });
                return false;
            }
            if (!(0, _isInteger2.default)(parseFloat(this.discount_value))) {
                $17.swal({
                    title: '折扣輸入不正確',
                    text: "只接受整數，不接受 (負數、小數點、字元)",
                    type: 'error'
                });
                return false;
            }
            return true;
        },
        checkDiscount: function checkDiscount() {
            var discountValue = parseFloat(this.discount_value);
            var discountType = parseInt(this.discount_type);
            var subTotal = parseInt(this.sub_total);
            if (!(0, _isInteger2.default)(discountValue)) {
                $17.swal({
                    title: '折扣輸入不正確',
                    text: "只接受整數，不接受 (負數、小數點、字元)",
                    type: 'error'
                });
                return false;
            }

            if (discountType == 1) {
                if (discountValue > subTotal || discountValue < 0) {
                    $17.swal({
                        title: '折扣金額輸入錯誤',
                        text: "折扣金額不得超過原有價格",
                        type: 'error'
                    });
                    return false;
                }
            }

            if (discountType == 2) {
                if (discountValue > 100 || discountValue < 0) {
                    $17.swal({
                        title: '折扣比例輸入錯誤',
                        text: "折扣比例區間為0-100",
                        type: 'error'
                    });
                    return false;
                }
            }
            return true;
        },
        getUsedDiscount: function getUsedDiscount() {
            if (!this.commonly_used_discounts.length) {
                this.$store.dispatch('pos/getCommonlyUsedDiscountList', { branch_id: this.select_order.branch_id });
            }
        },
        onChangeDiscount: function onChangeDiscount() {
            if (this.selected_used_discount !== '') {
                this.discount_type = this.selected_used_discount.type;
                this.discount_value = this.selected_used_discount.value;
                this.discount_reason = this.selected_used_discount.reason;
            } else {
                this.discount_type = 1;
                this.discount_value = 0;
                this.discount_reason = '';
            }
        }
    },
    computed: (0, _extends3.default)({
        discount_value: {
            get: function get() {
                return store.state.pos.discount_value;
            },
            set: function set(newValue) {

                if (parseInt(this.discount_type) == 1) {
                    if (newValue > this.sub_total || newValue < 0) {
                        this.$store.commit('pos/POS_SETSTATUS', { 'key': 'discount_value', value: 0 });
                        return;
                    }
                    this.$store.commit('pos/POS_SETSTATUS', { 'key': 'discount_value', value: newValue });
                }

                if (parseInt(this.discount_type) == 2) {
                    if (newValue > 100 || newValue < 0) {
                        this.$store.commit('pos/POS_SETSTATUS', { 'key': 'discount_value', value: 0 });
                        return;
                    }
                    this.$store.commit('pos/POS_SETSTATUS', { 'key': 'discount_value', value: newValue });
                }
            }
        },
        discount_type: {
            get: function get() {
                return !store.state.pos.discount_type ? 1 : store.state.pos.discount_type;
            },
            set: function set(newValue) {
                this.$store.commit('pos/POS_SETSTATUS', { 'key': 'discount_type', value: newValue });
                this.discount_value = 0;
            }
        },
        discount_reason: {
            get: function get() {
                return store.state.pos.discount_reason;
            },
            set: function set(newValue) {
                this.$store.commit('pos/POS_SETSTATUS', { 'key': 'discount_reason', value: newValue });
            }
        },
        buy_number: {
            get: function get() {
                return store.state.pos.buy_number;
            },
            set: function set(newValue) {
                this.$store.commit('pos/POS_SETSTATUS', { 'key': 'buy_number', value: newValue });
            }
        }
    }, (0, _vuex.mapState)({
        select_product: function select_product(state) {
            return state.pos.select_product;
        },
        select_order: function select_order(state) {
            return state.pos.select_order;
        },
        select_order_detail: function select_order_detail(state) {
            return state.pos.select_order_detail;
        },
        append_mode: function append_mode(state) {
            return state.pos.append_mode;
        },
        commonly_used_discounts: function commonly_used_discounts(state) {
            return state.pos.commonly_used_discounts;
        },
        commonly_used_discounts_ajaxing: function commonly_used_discounts_ajaxing(state) {
            return state.pos.get_commonly_used_discounts_ajaxing;
        }
    }), {
        total_money: function total_money() {
            return this.sub_total - this.discount_total;
        },
        discount_total: function discount_total() {
            return this.calulateDiscountTotal(this.sub_total, this.discount_type, this.discount_value);
        },
        sub_total: function sub_total() {
            return store.state.pos.buy_number * this.getPrice;
        },
        discount_ratio: function discount_ratio() {
            var discountRatio = new Number(this.discount_total / this.sub_total * 100);
            return discountRatio.toFixed(1);
        },
        getChangeAction: function getChangeAction() {
            if (this.append_mode == 'add') {
                return this.saveBtnClicked;
            }
            if (this.append_mode == 'edit') {
                return this.editBtnClicked;
            }
        },
        getChangeName: function getChangeName() {
            if (this.append_mode == 'add') {
                return '加入';
            }
            if (this.append_mode == 'edit') {
                return '修改';
            }
        }
    }, (0, _vuex.mapGetters)({
        canBuyMulti: 'pos/CHECK_MULTI_BUY',
        calulateDiscountTotal: 'pos/CALCULATE_DISCOUNT_DETAIL_MONEY'
    }), {
        getAdditionShowTitle: function getAdditionShowTitle() {
            if (this.select_product.type == 'physical_products') {
                return '<span style="color: #C7C4C3;font-size: 0.5em;margin-left: 2em;">' + this.select_product.field3 + '</span>';
            }
        },
        getPrice: function getPrice() {
            if (this.append_mode == 'add') {
                return this.removeThousandth(this.select_product.price);
            }

            return this.select_order_detail.price;
        }
    }),
    mounted: function mounted() {
        var vm = this;
        this.$nextTick(function () {
            $('#product_append').on('show.bs.modal', function () {
                vm.getUsedDiscount();
                if (this.append_mode == 'add') {
                    this.buy_number = 1;
                }
            });
            $('#product_append').on('hide.bs.modal', function () {
                vm.selected_used_discount = '';
                vm.$store.commit('pos/POS_SETSTATUS', { 'key': 'commonly_used_discounts', value: [] });
            });
        });
    },
    created: function created() {}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal id=\"product_append\" open-size=\"modal-lg\" no-cancel=\"\" parallel-modal=\"\" :confirm-btn-text=\"getChangeName\" :save-clicked=\"getChangeAction\" close-btn-text=\"返回\" :close-clicked=\"resetProduct\" _v-023e09da=\"\">\n        <div slot=\"title\" _v-023e09da=\"\">{{select_product.name}}\n            <span v-html=\"getAdditionShowTitle\" _v-023e09da=\"\"></span>\n        </div>\n        <div slot=\"body\" _v-023e09da=\"\">\n            <form class=\"form-horizontal\" v-on:submit.prevent=\"\" _v-023e09da=\"\">\n                <div class=\"form-group\" _v-023e09da=\"\">\n                    <label class=\"col-sm-3\" _v-023e09da=\"\">價格</label>\n                    <div class=\"col-sm-3\" _v-023e09da=\"\">\n                        <p class=\"form-control-static\" _v-023e09da=\"\">{{getPrice}}</p>\n                    </div>\n                </div>\n                <div class=\"form-group\" v-show=\"canBuyMulti\" _v-023e09da=\"\">\n                    <label class=\"col-sm-3\" _v-023e09da=\"\">數量</label>\n                    <div class=\"col-sm-3\" _v-023e09da=\"\">\n                        <input type=\"number\" min=\"1\" class=\"form-control\" v-model=\"buy_number\" @keypress=\"disableKeyPress\" _v-023e09da=\"\">\n                    </div>\n                </div>\n                <hr v-show=\"canBuyMulti\" _v-023e09da=\"\">\n                <div class=\"form-group\" v-show=\"canBuyMulti\" _v-023e09da=\"\">\n                    <label class=\"col-sm-3\" _v-023e09da=\"\">小計</label>\n                    <div class=\"col-sm-3\" _v-023e09da=\"\">\n                        <p class=\"form-control-static\" _v-023e09da=\"\"> {{ sub_total }}</p>\n                    </div>\n                </div>\n                <div class=\"form-group\" _v-023e09da=\"\">\n                    <label class=\"col-sm-3\" _v-023e09da=\"\">常用折扣</label>\n                    <div class=\"col-sm-3\" _v-023e09da=\"\">\n                        <v-spinner-button :ajaxing=\"commonly_used_discounts_ajaxing\" _v-023e09da=\"\"></v-spinner-button>\n                        <select class=\"form-control\" v-show=\"!commonly_used_discounts_ajaxing\" v-model=\"selected_used_discount\" @change=\"onChangeDiscount\" _v-023e09da=\"\">\n                            <option value=\"\" _v-023e09da=\"\">請選擇</option>\n                            <option v-for=\"item in commonly_used_discounts\" :value=\"item\" _v-023e09da=\"\">\n                                {{item.name}}\n                            </option>\n                        </select>\n                    </div>\n                </div>\n                <div class=\"form-group\" _v-023e09da=\"\">\n                    <label class=\"col-sm-3\" _v-023e09da=\"\">折扣</label>\n                    <div class=\"col-sm-3\" _v-023e09da=\"\">\n                        <label _v-023e09da=\"\">\n                            <input type=\"radio\" name=\"optradio\" value=\"1\" v-model=\"discount_type\" _v-023e09da=\"\"> 金額\n                        </label>\n                        <label _v-023e09da=\"\">\n                            <input type=\"radio\" name=\"optradio\" value=\"2\" v-model=\"discount_type\" _v-023e09da=\"\"> 比例\n                        </label>\n                        <input type=\"number\" min=\"0\" :max=\"sub_total\" class=\"form-control\" v-if=\"discount_type == 1\" v-model=\"discount_value\" _v-023e09da=\"\">\n                        <input type=\"number\" min=\"0\" max=\"100\" class=\"form-control\" v-if=\"discount_type == 2\" v-model=\"discount_value\" onkeyup=\"value=value.replace(/^[^\\d]+/g,'')\" _v-023e09da=\"\">\n                    </div>\n                </div>\n                <div class=\"form-group\" v-if=\"discount_value > 0\" _v-023e09da=\"\">\n                    <label class=\"col-sm-3\" _v-023e09da=\"\">折扣原因</label>\n                    <div class=\"col-sm-3\" _v-023e09da=\"\">\n                        <textarea id=\"refund-reson\" v-model.lazy=\"discount_reason\" placeholder=\"此為必填\" _v-023e09da=\"\"></textarea>\n                    </div>\n                </div>\n                <div class=\"form-group\" v-if=\"discount_value > 0\" _v-023e09da=\"\">\n                    <label class=\"col-sm-3\" _v-023e09da=\"\">折扣比例％</label>\n                    <div class=\"col-sm-3\" _v-023e09da=\"\">\n                        <p class=\"form-control-static\" _v-023e09da=\"\"> {{ discount_ratio }}</p>\n                    </div>\n                </div>\n                <div class=\"form-group\" v-if=\"discount_value > 0\" _v-023e09da=\"\">\n                    <label class=\"col-sm-3\" _v-023e09da=\"\">折扣金額$</label>\n                    <div class=\"col-sm-3\" _v-023e09da=\"\">\n                        <p class=\"form-control-static\" _v-023e09da=\"\"> {{ discount_total }}</p>\n                    </div>\n                </div>\n                <hr _v-023e09da=\"\">\n                <div class=\"form-group total-col\" _v-023e09da=\"\">\n                    <label class=\"col-sm-3\" _v-023e09da=\"\">總計</label>\n                    <div class=\"col-sm-3\" _v-023e09da=\"\">\n                        <p class=\"form-control-static\" _v-023e09da=\"\"> {{ total_money }}</p>\n                    </div>\n                </div>\n            </form>\n        </div>\n</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\nhr[_v-023e09da] {\n  margin-left: -20px;\n  margin-right: -20px; }\n\n/* line 6, stdin */\n.total-col[_v-023e09da] {\n  font-weight: bold; }\n\n/* line 9, stdin */\n.form-horizontal > .form-group > div > *[_v-023e09da] {\n  text-align: right; }\n\n/* line 12, stdin */\n#refund-reson[_v-023e09da] {\n  text-align: left; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-023e09da", module.exports)
  } else {
    hotAPI.update("_v-023e09da", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/number/is-integer":49,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1326:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\nhr[_v-173eac99] {\n  margin-left: -20px;\n  margin-right: -20px; }\n\n/* line 6, stdin */\n.total-col[_v-173eac99] {\n  font-weight: bold; }\n\n/* line 9, stdin */\n.form-horizontal > .form-group > div > *[_v-173eac99] {\n  text-align: right; }\n\n/* line 12, stdin */\n#refund-reson[_v-173eac99] {\n  text-align: left; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            id: 'product_item_show'
        };
    },
    props: {
        locked: false,
        removeBtnShow: {
            default: false
        },
        closeBtnText: {
            default: '返回'
        }
    },
    methods: {
        closeModal: function closeModal() {
            if (this.locked) return;
            $('#' + this.id).modal('hide');
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
        calulateDiscountTotal: 'pos/CALCULATE_DISCOUNT_DETAIL_MONEY'
    }), {
        discount_value: {
            get: function get() {
                var discountType = parseInt(this.discount_type);
                return this.calulateDiscountTotal(this.sub_total, discountType, store.state.pos.discount_value);
            }
        },
        discount_type: {
            get: function get() {
                return !store.state.pos.discount_type ? 1 : store.state.pos.discount_type;
            }
        },
        discount_reason: {
            get: function get() {
                return store.state.pos.discount_reason;
            }
        },
        buy_number: {
            get: function get() {
                return store.state.pos.buy_number;
            }
        }
    }, (0, _vuex.mapState)({
        select_product: function select_product(state) {
            return state.pos.select_product;
        },
        select_order: function select_order(state) {
            return state.pos.select_order;
        },
        select_order_detail: function select_order_detail(state) {
            return state.pos.select_order_detail;
        },
        append_mode: function append_mode(state) {
            return state.pos.append_mode;
        }
    }), {
        total_money: function total_money() {
            return this.sub_total - this.discount_value;
        },
        sub_total: function sub_total() {
            return store.state.pos.buy_number * this.getPrice;
        },
        discount_ratio: function discount_ratio() {
            var discountRatio = new Number(this.discount_value / this.sub_total * 100);
            return discountRatio.toFixed(1);
        }
    }, (0, _vuex.mapGetters)({
        canBuyMulti: 'pos/CHECK_MULTI_BUY'
    }), {
        getPrice: function getPrice() {
            return this.select_order_detail.price;
        }
    }),
    mounted: function mounted() {
        this.$nextTick(function () {
            $('#product_item_show').on('show.bs.modal', function () {
                if (this.append_mode == 'add') {
                    this.buy_number = 1;
                }
            });
        });
    },
    created: function created() {}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal id=\"product_item_show\" open-size=\"modal-lg\" no-cancel=\"\" parallel-modal=\"\" close-btn-text=\"返回\" no-footer=\"\" _v-173eac99=\"\">\n        <div slot=\"title\" _v-173eac99=\"\">\n            {{select_product.name}}\n        </div>\n        <div slot=\"body\" _v-173eac99=\"\">\n            <form class=\"form-horizontal\" v-on:submit.prevent=\"\" _v-173eac99=\"\">\n                <div class=\"form-group\" _v-173eac99=\"\">\n                    <label class=\"col-sm-3\" _v-173eac99=\"\">價格</label>\n                    <div class=\"col-sm-5\" _v-173eac99=\"\">\n                        <p class=\"form-control-static\" _v-173eac99=\"\">{{getPrice}}</p>\n                    </div>\n                </div>\n                <div class=\"form-group\" v-show=\"canBuyMulti\" _v-173eac99=\"\">\n                    <label class=\"col-sm-3\" _v-173eac99=\"\">數量</label>\n                    <div class=\"col-sm-5\" _v-173eac99=\"\">\n                        <p class=\"form-control-static\" _v-173eac99=\"\">{{buy_number}}</p>\n                    </div>\n                </div>\n                <hr v-show=\"canBuyMulti\" _v-173eac99=\"\">\n                <div class=\"form-group\" v-show=\"canBuyMulti\" _v-173eac99=\"\">\n                    <label class=\"col-sm-3\" _v-173eac99=\"\">小計</label>\n                    <div class=\"col-sm-5\" _v-173eac99=\"\">\n                        <p class=\"form-control-static\" _v-173eac99=\"\"> {{ sub_total }}</p>\n                    </div>\n                </div>\n                <div class=\"form-group\" v-if=\"discount_value > 0\" _v-173eac99=\"\">\n                    <label class=\"col-sm-3\" _v-173eac99=\"\">折扣比例％</label>\n                    <div class=\"col-sm-5\" _v-173eac99=\"\">\n                        <p class=\"form-control-static\" _v-173eac99=\"\"> {{ discount_ratio }}</p>\n                    </div>\n                </div>\n                <div class=\"form-group\" v-if=\"discount_value > 0\" _v-173eac99=\"\">\n                    <label class=\"col-sm-3\" _v-173eac99=\"\">折扣金額$</label>\n                    <div class=\"col-sm-5\" _v-173eac99=\"\">\n                        <p class=\"form-control-static\" _v-173eac99=\"\"> {{ discount_value }}</p>\n                    </div>\n                </div>\n                <div class=\"form-group total-col\" _v-173eac99=\"\">\n                    <label class=\"col-sm-3\" _v-173eac99=\"\">總計</label>\n                    <div class=\"col-sm-5\" _v-173eac99=\"\">\n                        <p class=\"form-control-static\" _v-173eac99=\"\"> {{ total_money }}</p>\n                    </div>\n                </div>\n                <hr _v-173eac99=\"\">\n                <div class=\"form-group\" v-if=\"discount_value > 0\" _v-173eac99=\"\">\n                    <label class=\"col-sm-3\" _v-173eac99=\"\">折扣原因</label>\n                    <div class=\"col-sm-5\" _v-173eac99=\"\">\n                        <textarea readonly=\"\" id=\"refund-reson\" v-model.lazy=\"discount_reason\" placeholder=\"此為必填\" _v-173eac99=\"\"></textarea>\n                    </div>\n                </div>\n            </form>\n        </div>\n</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\nhr[_v-173eac99] {\n  margin-left: -20px;\n  margin-right: -20px; }\n\n/* line 6, stdin */\n.total-col[_v-173eac99] {\n  font-weight: bold; }\n\n/* line 9, stdin */\n.form-horizontal > .form-group > div > *[_v-173eac99] {\n  text-align: right; }\n\n/* line 12, stdin */\n#refund-reson[_v-173eac99] {\n  text-align: left; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-173eac99", module.exports)
  } else {
    hotAPI.update("_v-173eac99", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1327:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 4, stdin */\n.item[_v-0d229944]::after {\n  margin: 20px -20px;\n  border-top: 1px solid #C7C4C3;\n  display: block; }\n\n/* line 9, stdin */\n.item[_v-0d229944] {\n  cursor: pointer;\n  padding: 10px 20px 0px 20px; }\n\n/* line 16, stdin */\n.category[_v-0d229944] {\n  background-color: #C7C4C3;\n  padding: 10px 20px 10px 20px; }\n\n/* line 20, stdin */\n.search-form[_v-0d229944] {\n  margin-bottom: 10px; }\n\n/* line 23, stdin */\nhr[_v-0d229944] {\n  margin-left: -40px;\n  margin-right: -40px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        productGroup: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        clickProductList: function clickProductList(product) {
            if (this.productGroup) {
                this.$emit('product', product);
            } else {
                this.opeandAppendOrder(product);
            }
        },

        checkFilter: function checkFilter(key, data) {
            var reg = new RegExp(key + '.*');
            return reg.test(data);
        },
        opeandAppendOrder: function opeandAppendOrder(product) {
            this.$store.commit('pos/POS_SETSTATUS', { 'key': 'select_product', value: product });
            this.$store.commit('pos/POS_SETSTATUS', { 'key': 'buy_number', value: 1 });
            this.$store.commit('pos/POS_SETSTATUS', { 'key': 'discount_value', value: 0 });
            this.$store.commit('pos/POS_SETSTATUS', { 'key': 'discount_type', value: 1 });
            this.$store.commit('pos/POS_SETSTATUS', { 'key': 'discount_reason', value: "" });
            $('#product_append').modal('show');
        },
        showCategory: function showCategory(filted_list) {
            return filted_list.items.length > 0;
        },
        itemClass: function itemClass(showAttr) {
            return ['col-xs-' + showAttr['colWidth'], 'text-' + showAttr['align']];
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        // 映射 this.count 为 store.state.count
        product_category: function product_category(state) {
            return state.pos.product_category;
        },
        product_list: function product_list(state) {
            return state.pos.product_list;
        },
        product_show_list: function product_show_list(state) {
            return state.pos.product_show_list;
        },
        current_selected_product: function current_selected_product(state) {
            return state.pos.current_selected_product;
        }
    }), {

        product_filter: {
            get: function get() {
                return store.state.pos.product_filter;
            },
            set: function set(newValue) {
                this.$store.commit('pos/POS_SETSTATUS', { 'key': 'product_filter', value: newValue });
            }
        },
        filted_category: function filted_category() {
            var vm = this;
            return this.product_list.map(function (product_category) {
                var isSelectedCategory = true;
                if (vm.product_category_selected != 0 && product_category.id != vm.product_category_selected) {
                    isSelectedCategory = false;
                }
                var item = {};
                item.id = product_category.id;
                item.name = product_category.name;
                item.items = product_category.items.filter(function (product) {
                    if (!isSelectedCategory) {
                        return false;
                    }
                    if (vm.order_id != '' && !vm.checkFilter(vm.product_filter, product.name)) {
                        return false;
                    }
                    return true;
                });
                return item;
            });
        },

        product_category_selected: {
            get: function get() {
                if (!store.state.pos.product_category_selected) {
                    this.product_category_selected = 0;
                }
                return store.state.pos.product_category_selected;
            },
            set: function set(newValue) {
                this.$store.commit('pos/POS_SETSTATUS', { 'key': 'product_category_selected', value: newValue });
            }
        },
        showTitle: function showTitle() {
            var word = '選擇';
            switch (this.current_selected_product) {
                case 'physical_products':
                    word = word + '產品';
                    break;
                case 'contracts':
                    word = word + '方案';
                    break;
                default:
                    word = '';
            }
            return word;
        }
    }),
    mounted: function mounted() {},
    created: function created() {},

    watch: {
        product_category_selected: function product_category_selected() {
            this.$forceUpdate();
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal id=\"product-list-modal\" no-footer=\"\" parallel-modal=\"\" open-size=\"modal-lg\" _v-0d229944=\"\">\n    <span slot=\"title\" _v-0d229944=\"\">{{showTitle}}</span>\n    <template slot=\"body\">\n        <div class=\"row search-form\" _v-0d229944=\"\">\n            <form v-on:submit.prevent=\"\" _v-0d229944=\"\">\n                <div class=\"col-xs-3\" _v-0d229944=\"\">\n                    <select name=\"product_category\" class=\"form-control\" v-model.lazy=\"product_category_selected\" _v-0d229944=\"\">\n                        <option value=\"0\" _v-0d229944=\"\">顯示所有分類</option>\n                        <option :value=\"index\" v-for=\"(name, index) in product_category\" _v-0d229944=\"\">{{name}}</option>\n                    </select>\n                </div>\n                <div class=\"col-xs-6\" _v-0d229944=\"\">\n                    <input type=\"text\" name=\"\" id=\"\" class=\"form-control\" v-model.lazy=\"product_filter\" _v-0d229944=\"\">\n                </div>\n                <div class=\"col-xs-3\" _v-0d229944=\"\">\n                    <input type=\"button\" class=\"form-control\" value=\"搜尋\" _v-0d229944=\"\">\n                </div>\n            </form>\n        </div>\n        <div v-for=\"filted_list in filted_category\" v-show=\"showCategory(filted_list)\" _v-0d229944=\"\">\n            <div class=\"row category\" _v-0d229944=\"\">\n                <div class=\"col-xs-12 \" _v-0d229944=\"\">\n                    {{filted_list.name}}\n                </div>\n            </div>\n            <div v-for=\"product in filted_list.items\" class=\"item\" @click=\"clickProductList(product)\" _v-0d229944=\"\">\n                <div class=\"row\" _v-0d229944=\"\">\n                    <div v-for=\"show in product_show_list\" v-bind:class=\"itemClass(show)\" _v-0d229944=\"\">\n                        {{product[show['fieldName']]}}\n                    </div>\n                </div>\n                <hr _v-0d229944=\"\">\n            </div>\n        </div>\n    </template>\n</v-modal>\n\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 4, stdin */\n.item[_v-0d229944]::after {\n  margin: 20px -20px;\n  border-top: 1px solid #C7C4C3;\n  display: block; }\n\n/* line 9, stdin */\n.item[_v-0d229944] {\n  cursor: pointer;\n  padding: 10px 20px 0px 20px; }\n\n/* line 16, stdin */\n.category[_v-0d229944] {\n  background-color: #C7C4C3;\n  padding: 10px 20px 10px 20px; }\n\n/* line 20, stdin */\n.search-form[_v-0d229944] {\n  margin-bottom: 10px; }\n\n/* line 23, stdin */\nhr[_v-0d229944] {\n  margin-left: -40px;\n  margin-right: -40px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-0d229944", module.exports)
  } else {
    hotAPI.update("_v-0d229944", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1328:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _main = require('./main.vue');

var _main2 = _interopRequireDefault(_main);

var _selectPaymentMethod = require('./select-payment-method.vue');

var _selectPaymentMethod2 = _interopRequireDefault(_selectPaymentMethod);

var _posItemList = require('./pos-item-list.vue');

var _posItemList2 = _interopRequireDefault(_posItemList);

var _posItem = require('./pos-item.vue');

var _posItem2 = _interopRequireDefault(_posItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('quick-pos-quick-main', _main2.default);
_vue2.default.component('quick-pos-quick-select-payment-method', _selectPaymentMethod2.default);
_vue2.default.component('quick-pos-quick-item-list', _posItemList2.default);
_vue2.default.component('quick-pos-quick-item', _posItem2.default);

},{"./main.vue":1329,"./pos-item-list.vue":1330,"./pos-item.vue":1331,"./select-payment-method.vue":1332,"vue":792}],1329:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.left[_v-1f3199bb] {\n  float: left;\n  width: 30vw; }\n\n/* line 6, stdin */\n.right[_v-1f3199bb] {\n  float: left;\n  width: 67vw;\n  padding-top: 5vh; }\n\n/* line 11, stdin */\nh4[_v-1f3199bb] {\n  margin-top: 40px;\n  margin-bottom: 20px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            view: {
                ajaxing: true
            },
            ipSelect: null,
            paymentSelected: null,
            paymentList: {},
            ticketList: {},
            printerList: {},
            titleStyle: 'st-text-16 st-font-medium st-text-black st-mb-2'
        };
    },

    created: function created() {
        this.bootstrapWebadmin();
    },
    methods: {
        fetchInit: function fetchInit() {
            var _this = this;

            this.view.ajaxing = true;
            this.$http.get('/simple/adminapi/pos_quick/init/' + this.studioId).then(function (response) {
                _this.paymentList = response.data.payments;
                _this.ticketList = response.data.tickets;
                _this.printerList = response.data.printers;
                _this.view.ajaxing = false;
            }, function (error) {
                _this.view.ajaxing = false;
                $17.swal({
                    title: '初始票券設定失敗',
                    text: error.data.message,
                    type: 'error',
                    showCancelButton: false
                });
            });
        },
        changePayment: function changePayment(id) {
            this.paymentSelected = id;
        },
        logout: function logout() {
            window.location = '/webadmin/logout';
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        studioId: function studioId(state) {
            return state.webadmin.configure.studioId;
        },
        branchId: function branchId(state) {
            return state.webadmin.configure.branchId;
        },
        selectedStudioId: function selectedStudioId(state) {
            return state.filters.selected_studio_id;
        },
        selectedBranchId: function selectedBranchId(state) {
            return state.filters.selected_branch_id;
        },
        isSeventeen: function isSeventeen(state) {
            return state.webadmin.configure.isSeventeen;
        },
        branches: function branches(state) {
            return state.filters.branchOptions;
        },
        localPrinterSetting: function localPrinterSetting(state) {
            return state.webadmin.webLocalSetting.printerSetting;
        }
    }), {
        currentPaymentList: function currentPaymentList() {
            if (!this.selectedBranchId || !this.paymentList[this.selectedBranchId]) {
                return [];
            }
            return this.paymentList[this.selectedBranchId];
        },
        currentTicketList: function currentTicketList() {
            if (!this.selectedBranchId || !this.ticketList[this.selectedBranchId]) {
                return [];
            }
            return this.ticketList[this.selectedBranchId];
        },
        currentPrinterList: function currentPrinterList() {
            if (!this.selectedBranchId || !this.printerList[this.selectedBranchId]) {
                return [];
            }
            return this.printerList[this.selectedBranchId];
        }
    }),
    watch: {
        studioId: function studioId(oldVal, newVal) {
            this.fetchInit();
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"main\" _v-1f3199bb=\"\">\n    <div class=\"left st-bg-gray-20 st-px-6 st-py-8 st-h-screen\" _v-1f3199bb=\"\">\n        <v-spinner :ajaxing=\"view.ajaxing\" _v-1f3199bb=\"\"></v-spinner>\n        <div v-if=\"!view.ajaxing\" _v-1f3199bb=\"\">\n            <div style=\"min-height: 80vh;\" _v-1f3199bb=\"\">\n                <div class=\"st-mb-3\" _v-1f3199bb=\"\">\n                    <div :class=\"titleStyle\" _v-1f3199bb=\"\">選擇銷售場館</div>\n                    <v-multiselect-studio-and-branch :studio_id=\"studioId\" :branch_id=\"branchId\" :default_branch_id=\"localPrinterSetting.branch_id\" :branch-without-filtered-option=\"false\" :show-branch-lable=\"true\" _v-1f3199bb=\"\"></v-multiselect-studio-and-branch>    \n                </div>\n                <div _v-1f3199bb=\"\">\n                    <div :class=\"titleStyle\" _v-1f3199bb=\"\">支付方式</div>\n                    <quick-pos-quick-select-payment-method :list=\"currentPaymentList\" :selected=\"paymentSelected\" @payment-change=\"changePayment\" _v-1f3199bb=\"\"></quick-pos-quick-select-payment-method>\n                </div>\n                <hr class=\"st-border-gray-50\" _v-1f3199bb=\"\">\n                <div class=\"st-mb-6\" _v-1f3199bb=\"\">\n                    <select-printer-agent _v-1f3199bb=\"\"></select-printer-agent>\n                </div>\n                <div _v-1f3199bb=\"\">\n                    <div :class=\"titleStyle\" _v-1f3199bb=\"\">列印裝置：{{ ipSelect }}</div>\n                    <select-list-already-load :select-ip.sync=\"ipSelect\" :items=\"currentPrinterList\" _v-1f3199bb=\"\"></select-list-already-load>\n                </div>\n            </div>\n            <div class=\"btn btn-default st-bg-gray-30\" @click=\"logout\" _v-1f3199bb=\"\">登出</div>\n        </div>\n    </div>\n    <div class=\"right st-h-screen\" v-show=\"currentTicketList.length > 0\" _v-1f3199bb=\"\">\n        <quick-pos-quick-item-list :tickets=\"currentTicketList\" :ip-select=\"ipSelect\" :payment-selected=\"paymentSelected\" :branch-id=\"selectedBranchId\" :studio-id=\"studioId\" _v-1f3199bb=\"\"></quick-pos-quick-item-list>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.left[_v-1f3199bb] {\n  float: left;\n  width: 30vw; }\n\n/* line 6, stdin */\n.right[_v-1f3199bb] {\n  float: left;\n  width: 67vw;\n  padding-top: 5vh; }\n\n/* line 11, stdin */\nh4[_v-1f3199bb] {\n  margin-top: 40px;\n  margin-bottom: 20px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-1f3199bb", module.exports)
  } else {
    hotAPI.update("_v-1f3199bb", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1330:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.list[_v-67365966] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: start;\n      justify-content: flex-start;\n  -ms-flex-flow: row;\n      flex-flow: row;\n  -ms-flex-line-pack: start;\n      align-content: start;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  margin-left: 3vw;\n  min-height: 75vh; }\n\n/* line 11, stdin */\n.one-litem[_v-67365966] {\n  width: 33%;\n  height: 15vh; }\n\n/* line 15, stdin */\n.page-navi[_v-67365966] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        tickets: {},
        ipSelect: {},
        paymentSelected: {
            default: null
        },
        branchId: {},
        studioId: {}
    },
    data: function data() {
        return {
            currentPage: 1,
            view: {
                ajaxing: false
            },
            orderId: ''
        };
    },

    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('webadmin/print', ['printOrder', 'directPrintOrder', 'checkDefaultPrinter']), {
        buyTicket: function buyTicket(id) {
            var _this = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this.checkActureValue();

                            case 2:
                                _this.view.ajaxing = true;
                                $.blockUI({ timeout: 10000 });
                                _context.next = 6;
                                return _this.$http.post('/simple/adminapi/pos_quick/buy/', {
                                    'studio_id': _this.studioId,
                                    'branch_id': _this.branchId,
                                    'ticket_setting_id': id,
                                    'studio_payment__type_id': _this.paymentSelected
                                }).then(function (response) {
                                    _this.view.ajaxing = false;
                                    $.unblockUI();
                                    $.notify("結帳完成", { position: "top center", className: "success" });
                                    _this.directPrintOrder({ 'order': response.data.order }).then(function (result) {}, function (error) {

                                        $17.swal({
                                            title: '列印票券失敗',
                                            text: '',
                                            type: 'error',
                                            showCancelButton: false
                                        });
                                    });
                                }, function (error) {
                                    _this.view.ajaxing = false;
                                    $.unblockUI();
                                    $17.swal({
                                        title: '購買票券失敗',
                                        text: error.data.message,
                                        type: 'error',
                                        showCancelButton: false
                                    });
                                });

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        pageClick: function pageClick(page) {
            this.currentPage = page;
        },
        checkActureValue: function checkActureValue() {
            var _this2 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (_this2.branchId) {
                                    _context2.next = 3;
                                    break;
                                }

                                $17.swal({
                                    title: '請選擇場館',
                                    text: '',
                                    type: 'error',
                                    showCancelButton: false
                                });
                                throw "請選擇場館";

                            case 3:
                                if (_this2.paymentSelected) {
                                    _context2.next = 6;
                                    break;
                                }

                                $17.swal({
                                    title: '請選擇支付方式',
                                    text: '',
                                    type: 'error',
                                    showCancelButton: false
                                });
                                throw "請選擇支付方式";

                            case 6:
                                if (_this2.ipSelect) {
                                    _context2.next = 9;
                                    break;
                                }

                                $17.swal({
                                    title: '請選擇列印裝置',
                                    text: '',
                                    type: 'error',
                                    showCancelButton: false
                                });
                                throw "請選擇列印裝置";

                            case 9:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        }
    }),
    computed: {
        pageCount: function pageCount() {
            return Math.ceil(this.tickets.length / 15);
        },
        currentPageItems: function currentPageItems() {
            return this.currentGroup[this.currentPage];
        },
        currentGroup: function currentGroup() {
            var currentNum = 1;
            var currentPageGroup = 1;
            return this.tickets.reduce(function (carry, item) {
                if (!carry[currentPageGroup]) {
                    carry[currentPageGroup] = [];
                }
                carry[currentPageGroup].push(item);
                currentNum++;
                if (currentNum % 15 === 1) {
                    currentPageGroup++;
                }
                return carry;
            }, []);
        }
    },
    watch: {
        branchId: function branchId() {
            this.currentPage = 1;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-67365966=\"\">\n    <div class=\"list\" _v-67365966=\"\">\n        <div class=\"one-litem\" v-for=\"ticket in currentPageItems\" v-bind:style=\"{ order: ticket.order_num}\" _v-67365966=\"\">\n            <quick-pos-quick-item :ticket=\"ticket\" @buy-ticket=\"buyTicket\" _v-67365966=\"\"></quick-pos-quick-item>\n        </div>\n    </div>\n    <div class=\"page-navi\" _v-67365966=\"\">\n        <v-paginate v-model=\"currentPage\" :page-count=\"pageCount\" container-class=\"pagination\" prev-text=\"<<\" next-text=\">>\" :click-handler=\"pageClick\" _v-67365966=\"\">\n        </v-paginate>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.list[_v-67365966] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: start;\n      justify-content: flex-start;\n  -ms-flex-flow: row;\n      flex-flow: row;\n  -ms-flex-line-pack: start;\n      align-content: start;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  margin-left: 3vw;\n  min-height: 75vh; }\n\n/* line 11, stdin */\n.one-litem[_v-67365966] {\n  width: 33%;\n  height: 15vh; }\n\n/* line 15, stdin */\n.page-navi[_v-67365966] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-67365966", module.exports)
  } else {
    hotAPI.update("_v-67365966", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1331:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.item[_v-226ffc6e] {\n  display: -ms-flexbox;\n  display: flex;\n  font-size: 1em;\n  width: 100%;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: distribute;\n      justify-content: space-around; }\n  /* line 4, stdin */\n  .item [_v-226ffc6e]:after {\n    clear: both; }\n\n/* line 12, stdin */\n.item-main[_v-226ffc6e] {\n  float: left;\n  display: -ms-flexbox;\n  display: flex;\n  border: 1px solid #aaa;\n  border-radius: 5px;\n  cursor: pointer;\n  width: 90%;\n  height: 80%;\n  background-color: #f6f6f6; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        ticket: {}
    },
    methods: {
        buy: function buy(id) {
            this.$emit('buy-ticket', id);
        }
    },
    computed: {},
    watch: {}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"item-main\" @click=\"buy(ticket.id)\" _v-226ffc6e=\"\"> \n    <div class=\"item\" _v-226ffc6e=\"\">\n        <span class=\"st-text-black\" _v-226ffc6e=\"\">{{ticket.name}}</span>\n        <span class=\"st-text-black\" _v-226ffc6e=\"\">{{ticket.price}}</span>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.item[_v-226ffc6e] {\n  display: -ms-flexbox;\n  display: flex;\n  font-size: 1em;\n  width: 100%;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: distribute;\n      justify-content: space-around; }\n  /* line 4, stdin */\n  .item [_v-226ffc6e]:after {\n    clear: both; }\n\n/* line 12, stdin */\n.item-main[_v-226ffc6e] {\n  float: left;\n  display: -ms-flexbox;\n  display: flex;\n  border: 1px solid #aaa;\n  border-radius: 5px;\n  cursor: pointer;\n  width: 90%;\n  height: 80%;\n  background-color: #f6f6f6; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-226ffc6e", module.exports)
  } else {
    hotAPI.update("_v-226ffc6e", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1332:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.btn--primary[_v-2b011e32] {\n  box-shadow: inset 0px 0px 0px 1px #1d97cb;\n  margin-bottom: 4px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        list: {
            default: []
        },
        selected: {
            default: null
        }
    },
    methods: {
        changeValue: function changeValue(id) {
            this.$emit('payment-change', id);
        }
    },
    computed: {},
    watch: {}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div v-if=\"list.length>0\" _v-2b011e32=\"\"> \n    <div class=\"btn-group\" role=\"group\" _v-2b011e32=\"\">\n        <button type=\"button\" class=\"btn btn--primary\" v-for=\"ite in list\" :value=\"ite.name\" @click=\"changeValue(ite.id)\" v-bind:class=\"{ 'btn--inverse': selected!=ite.id }\" _v-2b011e32=\"\">\n        {{ paymentDisplayName(ite) }}\n        </button>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.btn--primary[_v-2b011e32] {\n  box-shadow: inset 0px 0px 0px 1px #1d97cb;\n  margin-bottom: 4px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-2b011e32", module.exports)
  } else {
    hotAPI.update("_v-2b011e32", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1333:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            ajaxing: false,
            forwardData: '',
            disabledSubmit: false,
            port: '',
            remark: '',
            key: ''
        };
    },
    created: function created() {
        var params = new URLSearchParams(window.location.search);
        this.remark = params.get('remark');
        this.key = params.get('key');
        this.fetchData();
    },
    mounted: function mounted() {
        var vm = this;
        $(this.$el).on('submit', 'form#forward-hidden-form', function (e) {
            vm.disabledSubmit = true;
        });
    },

    computed: {
        remarkStr: function remarkStr() {
            return '{{' + this.remark + '}}';
        }
    },
    methods: {
        fetchData: function fetchData() {
            var _this = this;

            this.ajaxing = true;
            this.$http.get('/simple/adminapi/print_agent/forward_data', { params: { key: this.key } }).then(function (res) {
                var result = res.data;
                _this.$store.dispatch('setWeblog', { 'name': '確認要送到ＩＯＴ資料無異常', 'message': (0, _extends3.default)({ key: _this.key }, result) });
                if (result.success) {
                    _this.forwardData = result.data;
                    _this.port = result.express_port;
                    _this.forwardAgent();
                }
                _this.ajaxing = false;
            }, function (err) {
                _this.$store.dispatch('setWeblog', { 'name': '送到ＩＯＴ資料異常', 'message': (0, _extends3.default)({ key: _this.key }, err) });
                _this.ajaxing = false;
            });
        },
        closeWindow: function closeWindow() {
            window.close();
        },
        forwardAgent: function forwardAgent() {
            if (!this.forwardData || !this.port) return;
            var data = typeof this.forwardData == 'string' ? JSON.parse(this.forwardData) : this.forwardData;
            this.post('http://localhost:' + this.port + '/forward', data, 'post');
        },
        post: function post(path, params) {
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'post';

            this.disabledSubmit = true;
            var form = document.getElementById('forward-hidden-form');
            form.method = method;
            form.action = path;
            for (var key in params) {
                if (params.hasOwnProperty(key)) {
                    var hiddenField = document.createElement('input');
                    hiddenField.type = 'hidden';
                    hiddenField.name = key;
                    hiddenField.value = (0, _stringify2.default)(params[key]);

                    form.appendChild(hiddenField);
                }
            }
            this.disabledSubmit = false;
            form.submit();
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div style=\"text-align: center; margin-top: 50px;\">\n    <v-spinner :ajaxing=\"ajaxing\"></v-spinner>\n    <div v-show=\"!ajaxing\">\n        <div class=\"m-bottom-20\" v-show=\"forwardData\">\n            <h3 v-if=\"remark\">{{ remarkStr }}</h3>\n            <h2>自動送出列印資料中...</h2>\n            <p>如果畫面沒有自動跳轉，請手動點擊按鈕發送</p><br>\n            <p class=\"font-small\">請勿關閉此視窗</p>\n        </div>\n        <form id=\"forward-hidden-form\" v-show=\"forwardData\">\n            <input type=\"submit\" class=\"btn btn-primary\" value=\"發送列印資料\" :disabled=\"disabledSubmit\">\n        </form>\n        <div class=\"m-bottom-20\" v-show=\"!forwardData\">\n            <h3 v-if=\"remark\">{{ remarkStr }}</h3>\n            <h2>列印資料發送失敗</h2>\n            <p>未知錯誤造成發送失敗，請重新發送</p>\n            <p class=\"font-small\">重新發送後，可能導致正本發票變為補開發票</p><br>\n            <input type=\"button\" class=\"btn btn-danger\" value=\"關閉此視窗\" @click.prevent=\"closeWindow\">\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-cc574ad4", module.exports)
  } else {
    hotAPI.update("_v-cc574ad4", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/json/stringify":48,"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785}],1334:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _index = require('./index.vue');

var _index2 = _interopRequireDefault(_index);

var _preview = require('./preview.vue');

var _preview2 = _interopRequireDefault(_preview);

var _selectList = require('./select-list.vue');

var _selectList2 = _interopRequireDefault(_selectList);

var _selectListAlreadyLoad = require('./select-list-already-load.vue');

var _selectListAlreadyLoad2 = _interopRequireDefault(_selectListAlreadyLoad);

var _selectPrinterAgent = require('./select-printer-agent.vue');

var _selectPrinterAgent2 = _interopRequireDefault(_selectPrinterAgent);

var _forwardAgent = require('./forward-agent.vue');

var _forwardAgent2 = _interopRequireDefault(_forwardAgent);

var _settingPrinterModal = require('./setting-printer-modal.vue');

var _settingPrinterModal2 = _interopRequireDefault(_settingPrinterModal);

var _webLocalSetting = require('./web-local-setting.vue');

var _webLocalSetting2 = _interopRequireDefault(_webLocalSetting);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('webadmin-print-device-index', _index2.default);
_vue2.default.component('print-preview', _preview2.default);
_vue2.default.component('print-select-list', _selectList2.default);
_vue2.default.component('select-list-already-load', _selectListAlreadyLoad2.default);
_vue2.default.component('select-printer-agent', _selectPrinterAgent2.default);
_vue2.default.component('printer-forward-agent', _forwardAgent2.default);
_vue2.default.component('setting-printer-modal', _settingPrinterModal2.default);
_vue2.default.component('web-local-setting', _webLocalSetting2.default);

},{"./forward-agent.vue":1333,"./index.vue":1335,"./preview.vue":1336,"./select-list-already-load.vue":1337,"./select-list.vue":1338,"./select-printer-agent.vue":1339,"./setting-printer-modal.vue":1340,"./web-local-setting.vue":1341,"vue":792}],1335:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            currentBranchPrinterSetting: {},
            deviceList: [],
            borderStyle: 'st-border st-border-gray-40 st-border-solid st-p-3.5 st-rounded-4 st-text-14 st-text-black'
        };
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        canCreate: function canCreate(state) {
            return state.webadmin.configure.webFunctions.WebadminPrintDeviceCreate;
        },
        studioId: function studioId(state) {
            return state.webadmin.configure.studioId;
        },
        branchId: function branchId(state) {
            return state.webadmin.configure.branchId;
        },
        items: function items(state) {
            return state.webadmin.print.settings;
        },
        localPrinterSetting: function localPrinterSetting(state) {
            return state.webadmin.webLocalSetting.printerSetting;
        },
        ajaxing: function ajaxing(state) {
            return state.webadmin.print.ajaxingSettings;
        },
        selectedStudioId: function selectedStudioId(state) {
            return state.filters.selected_studio_id;
        },
        selectedBranchId: function selectedBranchId(state) {
            return state.filters.selected_branch_id;
        },
        isSeventeen: function isSeventeen(state) {
            return state.webadmin.configure.isSeventeen;
        },
        isStudio: function isStudio(state) {
            return state.webadmin.configure.isStudio;
        }
    }), {
        tableConfig: function tableConfig() {
            if (this.isStudio) {
                return {
                    columns: [{ keys: 'device_name', head: '裝置名稱' }, { keys: 'branch_name', head: '場館' }, { keys: 'device_ip', head: 'IP' }]
                };
            } else {
                return {
                    columns: [{ keys: 'device_name', head: '裝置名稱' }, {
                        keys: 'device_ip',
                        head: 'IP',
                        maxWidth: '10em',
                        headerStyle: { width: '10em' }
                    }, {
                        keys: 'action',
                        head: '',
                        minWidth: '4em',
                        maxWidth: '4em',
                        headerStyle: { width: '4em' },
                        html: function html(item) {
                            return '<st-button neutral icon leftIcon=\'edit\' @click.prevent.stop="clickHandler(\'click-printer-edit\', $event)"></st-button>';
                        }
                    }]
                };
            }
        },
        isExistPrinter: function isExistPrinter() {
            return this.items.length > 0;
        },
        isActiveAutoPrint: function isActiveAutoPrint() {
            return this.currentBranchPrinterSetting.auto_printer_status == 1 ? true : false;
        },
        autoPrintIncludeArea: function autoPrintIncludeArea() {
            var _this = this;

            if (!this.currentBranchPrinterSetting) return '';
            var result = [];
            var scopeName = {
                scope_invoice_status: '發票',
                scope_ticket_status: '票券',
                scope_contract_status: '方案'
            };
            (0, _keys2.default)(scopeName).forEach(function (key) {
                if (_this.currentBranchPrinterSetting[key] == 1) {
                    result.push(scopeName[key]);
                }
            });
            return result.join('、');
        }
    }),
    mounted: function mounted() {
        this.refreshData();
    },

    watch: {
        selectedBranchId: function selectedBranchId(newVal) {
            if (newVal) {
                this.refreshData();
            }
        },
        selectedStudioId: function selectedStudioId(newVal) {
            if (newVal) {
                this.refreshData();
            }
        },

        'localPrinterSetting': {
            handler: function handler(newVal) {
                this.currentBranchPrinterSetting = (0, _assign2.default)({}, newVal);
            },

            deep: true
        },
        'items': {
            handler: function handler(newVal) {
                var devices = (0, _assign2.default)([], newVal);;
                this.deviceList = devices.sort(function (a, b) {
                    return a.branch_id - b.branch_id;
                });
            },

            deep: true
        }
    },
    methods: {
        refreshData: function refreshData() {
            if (this.isStudio) {
                this.$store.dispatch('webadmin/print/fetchAllPrintSettings', this.selectedStudioId);
            } else if (this.selectedBranchId) {
                this.$store.dispatch('webadmin/print/fetchPrintSettings', this.selectedBranchId);
            }
        },
        createSettings: function createSettings() {
            this.$store.commit('webadmin/print/RESET_FORM_DATA');
            $('#print-device-moddal').modal('show');
        },
        forwardAutoPrintSetting: function forwardAutoPrintSetting() {
            var query = (0, _extends3.default)({}, this.$route.query, {
                sub_page: 'printer_setting',
                tab_hidden: true
            });
            this.$router.push({
                name: this.$route.name,
                query: query
            });
        },
        createPrinter: function createPrinter() {
            this.$refs.setting_printer_modal.show({ mode: 'create' });
        },
        editPrinter: function editPrinter(event) {
            if (event.action == 'click-printer-edit') {
                var device = event.row;
                this.$refs.setting_printer_modal.show({
                    mode: 'update',
                    device: {
                        id: device.id,
                        name: device.device_name,
                        ip: device.device_ip
                    }
                });
            }
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div>\n    <st-toolbar title=\"列印裝置\" :bar-hidden=\"isStudio\">\n        <div slot=\"select-tool\">\n            <v-multiselect-studio-and-branch :studio_id=\"studioId\" :branch_id=\"branchId\" :branch-without-filtered-option=\"false\" drop-down-container-class=\"st-pr-2\"></v-multiselect-studio-and-branch>\n        </div>\n        <div slot=\"buttons-tool\">\n            <div v-show=\"!isStudio\">\n                <st-button primary=\"\" filled=\"\" normal=\"\" v-if=\"canCreate\" left-icon=\"add\" text=\"新增列印裝置\" @click.prevent=\"createPrinter\">\n                </st-button>\n            </div>\n        </div>\n        <div slot=\"main-section\">\n            <div class=\"st-space-y-6\">\n                <div :class=\"borderStyle\">\n                    <div class=\"st-flex st-items-center st-justify-between\">\n                        <div>\n                            <div class=\"st-font-medium st-text-18\">本機列印設定</div>\n                            <div class=\"st-text-gray-90\">在結帳完成時，將依預設設定進行列印</div>\n                        </div>\n                        <div>\n                            <st-button secondary=\"\" filled=\"\" small=\"\" text=\"設定\" @click.prevent=\"forwardAutoPrintSetting\" :disabled=\"!isExistPrinter\">\n                            </st-button>\n                        </div>\n                    </div>\n                    <hr class=\"st-border-gray-40 st-my-2.5\">\n                    <div class=\"st-flex st-gap-8\">\n                        <div>預設印表機：\n                            <span>{{ this.currentBranchPrinterSetting.device_name || '無' }}</span>\n                            <span v-show=\"isStudio &amp;&amp; this.currentBranchPrinterSetting.device_ip\" class=\"st-text-gray-90\">({{ localPrinterSetting.branch_name }})</span>\n                        </div>\n                        <div class=\"st-flex st-items-center\" v-if=\"isActiveAutoPrint\">\n                            <span class=\"material-icons st-text-success st-text-16\">check_circle</span>\n                            <span>自動列印啟用</span>\n                        </div>\n                        <div class=\"st-flex st-items-center\" v-else=\"\">\n                            <span class=\"material-icons st-text-16 st-text-gray-90\">remove_circle</span>\n                            <span>自動列印未啟用</span>\n                        </div>\n                        <div v-if=\"isActiveAutoPrint\">\n                            列印範圍：<span>{{ autoPrintIncludeArea }}</span>\n                        </div>\n                    </div>\n                </div>\n                <div>\n                    <v-smart-table ref=\"smart_table\" :table-config=\"tableConfig\" :is-ajaxing=\"ajaxing\" :data=\"{ records: deviceList, pageMeta: {} }\" empty-data-text=\"您尚未新增列印裝置\" @html-click-callback=\"editPrinter\"></v-smart-table>\n                    <div v-show=\"(!ajaxing &amp;&amp; !isExistPrinter)\">\n                        <st-button secondary=\"\" filled=\"\" normal=\"\" left-icon=\"add\" text=\"新增列印裝置\" :btn-class=\"['st-mx-auto st-mt-7']\" @click.prevent=\"createPrinter\">\n                        </st-button>\n                    </div>\n                </div>\n            </div>\n            <setting-printer-modal ref=\"setting_printer_modal\" :studio-id=\"selectedStudioId\" :branch-id=\"selectedBranchId\">\n            </setting-printer-modal>\n        </div>\n    </st-toolbar>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-4ba7c02a", module.exports)
  } else {
    hotAPI.update("_v-4ba7c02a", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/object/assign":50,"babel-runtime/core-js/object/keys":56,"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vuex":803}],1336:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.btn[_v-bce3d8be] {\n  margin: 15px 5px 15px 15px; }\n\n/* line 5, stdin */\n.ip[_v-bce3d8be] {\n  margin: 15px 5px 15px 15px; }\n\n/* line 8, stdin */\n.content-inner[_v-bce3d8be] {\n  margin-left: 15px; }\n")
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require("vuex");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            printType: null,
            id: null,
            idMemberContract: null,
            idMember: null,
            ids: [],
            data: {},
            urlParams: [],
            studioId: null,
            branches: [],
            ipSelect: null,
            printing: false,
            iframeLoading: true
        };
    },

    methods: (0, _extends3.default)({
        getQueryValue: function getQueryValue() {
            var _this = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                var url;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                url = new URL(window.location);

                                _this.ids = url.searchParams.getAll("ids[]");
                                _this.printType = url.searchParams.get("type");
                                _this.idMember = url.searchParams.get("id-member");

                                _this.idMemberContract = url.searchParams.get("id-member-contract");
                                _this.id = url.searchParams.get("id");
                                if (!_this.id && _this.idMemberContract) {
                                    _this.id = _this.idMemberContract;
                                }

                            case 7:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    }, (0, _vuex.mapActions)('webadmin/print', ['printInvoice', 'printDiscountNote', 'printTicket', 'printAllTicket', 'printMembercontract', 'printOrder', 'checkDefaultPrinter']), {
        print: function print(e) {
            var _this2 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!(_this2.printCss === 'disabled')) {
                                    _context2.next = 2;
                                    break;
                                }

                                return _context2.abrupt("return");

                            case 2:
                                _context2.prev = 2;

                                _this2.printing = true;

                                _context2.t0 = _this2.printType;
                                _context2.next = _context2.t0 === 'invoice' ? 7 : _context2.t0 === 'discount-note' ? 10 : _context2.t0 === 'ticket' ? 13 : _context2.t0 === 'all-ticket' ? 16 : _context2.t0 === 'member-contract' ? 19 : _context2.t0 === 'order' ? 22 : 25;
                                break;

                            case 7:
                                _context2.next = 9;
                                return _this2.printInvoice(_this2.id);

                            case 9:
                                return _context2.abrupt("break", 26);

                            case 10:
                                _context2.next = 12;
                                return _this2.printDiscountNote(_this2.id);

                            case 12:
                                return _context2.abrupt("break", 26);

                            case 13:
                                _context2.next = 15;
                                return _this2.printTicket(_this2.id);

                            case 15:
                                return _context2.abrupt("break", 26);

                            case 16:
                                _context2.next = 18;
                                return _this2.printAllTicket(_this2.id);

                            case 18:
                                return _context2.abrupt("break", 26);

                            case 19:
                                _context2.next = 21;
                                return _this2.printMembercontract({ 'memberContractId': _this2.idMemberContract, 'memberId': _this2.idMember });

                            case 21:
                                return _context2.abrupt("break", 26);

                            case 22:
                                _context2.next = 24;
                                return _this2.printOrder({ 'orderId': _this2.id });

                            case 24:
                                return _context2.abrupt("break", 26);

                            case 25:
                                return _context2.abrupt("break", 26);

                            case 26:

                                setTimeout(function () {
                                    _this2.printing = false;
                                }, 3000);

                                _context2.next = 33;
                                break;

                            case 29:
                                _context2.prev = 29;
                                _context2.t1 = _context2["catch"](2);

                                _this2.printing = false;
                                $17.swal({
                                    title: '列印發生錯誤',
                                    text: '',
                                    type: 'error',
                                    showCancelButton: false
                                });

                            case 33:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2, [[2, 29]]);
            }))();
        },
        getStudioId: function getStudioId() {
            var _this3 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _this3.$http.get('/simple/adminapi/print/studio/' + _this3.printType + '/' + _this3.id).then(function (response) {

                                    _this3.studioId = parseInt(response.body.studio_id);
                                    _this3.branches = response.body.branches;
                                }, function (response) {
                                    // error callback
                                });

                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3);
            }))();
        },
        close: function close() {
            window.close();
        }
    }),
    mounted: function mounted() {
        var _this4 = this;

        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            _context4.next = 2;
                            return _this4.getQueryValue();

                        case 2:
                            _this4.getStudioId();
                            _this4.$store.dispatch('webadmin/print/fetchPrintSettingsNoneHttps', _this4.branch);
                            $("#pdfsrc").load(function () {
                                _this4.iframeLoading = false;
                            });

                        case 5:
                        case "end":
                            return _context4.stop();
                    }
                }
            }, _callee4, _this4);
        }))();
    },

    computed: (0, _extends3.default)({
        pdfurl: function pdfurl() {
            switch (this.printType) {
                case 'invoice':
                    return window.location.origin + '/adminapi/invoice/order/' + this.id + '/print/pdf?addition=preview';
                    break;
                case 'discount-note':
                    // http://localhost:8000/adminapi/invoice/order/1712210572/print/discount-note/pdf
                    return window.location.origin + '/adminapi/invoice/order/' + this.id + '/print/discount-note/pdf';
                    break;
                case 'ticket':
                    // http://localhost:8000/adminapi/ticket/17122102860001/print/pdf
                    return window.location.origin + '/adminapi/ticket/' + this.id + '/print/pdf';
                    break;
                case 'all-ticket':
                    // http://localhost:8000/adminapi/ticket/order_detail/101091/print/pdf
                    return window.location.origin + '/adminapi/ticket/order_detail/' + this.id + '/print/pdf';
                    break;
                case 'member-contract':
                    // http://localhost:8000/adminapi/member-contract/82720/member/84604/print/pdf
                    return window.location.origin + '/adminapi/member-contract/' + this.idMemberContract + '/member/' + this.idMember + '/print/pdf';
                    break;
                case 'order':
                    // http://localhost/adminapi/order/1803149aa8/print/pdf?addition=preview
                    return window.location.origin + '/adminapi/order/' + this.id + '/print/pdf?addition=preview';
                    break;
                default:
                    return '#';
                    break;
            }
        },
        printCss: function printCss() {
            return this.ipSelect && !this.printing && this.selectedAgent ? '' : 'disabled';
        }
    }, (0, _vuex.mapState)({
        settings: function settings(state) {
            return state.webadmin.print.settings;
        },
        selectedAgent: function selectedAgent(state) {
            return state.webadmin.print.printer_agent;
        }
    }))
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n    <div class=\"content-inner\" _v-bce3d8be=\"\">\n        <div class=\"row\" _v-bce3d8be=\"\">\n            <div class=\"col-xs-5\" _v-bce3d8be=\"\">\n                <div class=\"row\" _v-bce3d8be=\"\">\n                    <div class=\"btn btn-default col-xs-4\" @click=\"close\" _v-bce3d8be=\"\">關閉</div>\n                    <div class=\"btn btn-primary col-xs-5\" :class=\"printCss\" @click=\"print\" _v-bce3d8be=\"\">列印</div>\n                </div>\n                <select-printer-agent _v-bce3d8be=\"\"></select-printer-agent>\n                <div class=\"row\" _v-bce3d8be=\"\">\n                    <div class=\"ip\" _v-bce3d8be=\"\"> 現在印表機 IP: {{ipSelect}} </div>\n                </div>\n                <print-select-list :studio-id=\"studioId\" :branches=\"branches\" :select-ip.sync=\"ipSelect\" _v-bce3d8be=\"\"></print-select-list>\n            </div>\n            <div class=\"col-xs-7\" _v-bce3d8be=\"\">\n                <v-spinner :ajaxing=\"iframeLoading\" style=\"align:center\" _v-bce3d8be=\"\">\n                </v-spinner>\n                <iframe v-show=\"!iframeLoading\" :src=\"pdfurl\" id=\"pdfsrc\" style=\"width:400px; height:500px;\" frameborder=\"0\" _v-bce3d8be=\"\"></iframe>\n            </div>\n        </div>\n    <div _v-bce3d8be=\"\">\n</div></div>"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.btn[_v-bce3d8be] {\n  margin: 15px 5px 15px 15px; }\n\n/* line 5, stdin */\n.ip[_v-bce3d8be] {\n  margin: 15px 5px 15px 15px; }\n\n/* line 8, stdin */\n.content-inner[_v-bce3d8be] {\n  margin-left: 15px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-bce3d8be", module.exports)
  } else {
    hotAPI.update("_v-bce3d8be", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1337:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.sortable > tbody > tr[_v-d4f01320] {\n  cursor: pointer; }\n\n/* line 5, stdin */\n.ipsTr[_v-d4f01320] {\n  cursor: pointer; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        titleWord: {
            default: ''
        }
    },
    watch: {
        branches: function branches() {
            if (!this.defaultBranch) return;
            this.branchSelect = this.getSelectedBranch(this.defaultBranch);
        },

        localPrinterSetting: {
            handler: function handler(newVal) {
                if (!newVal.branch_id) return;
                this.branchSelect = {
                    id: newVal.branch_id,
                    branch_name: newVal.branch_name
                };
            },

            deep: true,
            immediate: true
        },
        branchSelect: {
            handler: function handler(val) {
                var _this = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                    return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    if (val.id) {
                                        _context.next = 2;
                                        break;
                                    }

                                    return _context.abrupt('return');

                                case 2:
                                    _this.defaultBranch = val.id;
                                    _this.generateBranchDevices(val.id);

                                case 4:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this);
                }))();
            },

            deep: true
        }
    },
    data: function data() {
        return {
            selectedPrinterId: null,
            branchSelect: null,
            defaultBranch: 0,
            startAjax: true
        };
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        localPrinterSetting: function localPrinterSetting(state) {
            return state.webadmin.webLocalSetting.printerSetting;
        },
        items: function items(state) {
            return state.webadmin.print.settings;
        },
        branches: function branches(state) {
            return state.filters.branchOptions;
        },
        isBranch: function isBranch(state) {
            return state.webadmin.configure.isBranch;
        }
    })),
    mounted: function mounted() {
        this.branchSelect = {
            id: this.localPrinterSetting.branch_id,
            branch_name: this.localPrinterSetting.branch_name
        };
    },

    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('webadmin/print', ['setInUsePrinter']), {
        generateBranchDevices: function generateBranchDevices(branchId) {
            var _this2 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _this2.startAjax = true;
                                _context2.next = 3;
                                return _this2.$store.dispatch('webadmin/print/fetchPrintSettingsNoneHttps', branchId);

                            case 3:
                                _context2.next = 5;
                                return _this2.setDefaultPrinter();

                            case 5:
                                _this2.startAjax = false;

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        setDefaultPrinter: function setDefaultPrinter() {
            var _this3 = this;

            var defaultPrinter = this.items.find(function (printer) {
                return printer.id == _this3.localPrinterSetting.device_id;
            });
            this.changePrinter(defaultPrinter || {});
        },
        changePrinter: function changePrinter(printer) {
            this.selectedPrinterId = printer.id;
            this.$emit('update:selectIp', printer.device_ip);
            this.setInUsePrinter(printer);
        },
        getSelectedBranch: function getSelectedBranch(id) {
            return this.branches.reduce(function (carry, branch) {
                if (branch.id == id) {
                    carry = branch;
                }
                return carry;
            }, {});
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"row\" _v-d4f01320=\"\">\n    <div class=\"col-xs-12\" _v-d4f01320=\"\">\n        <div v-if=\"!isBranch\" _v-d4f01320=\"\">\n            <v-mutiselect :model.sync=\"branchSelect\" :options=\"branches\" :multiple=\"false\" :close-on-select=\"true\" :clear-on-select=\"true\" :searchable=\"true\" label=\"branch_name\" track-by=\"id\" tag-name=\"branch_name\" placeholder=\"請選擇\" :allow-empty=\"false\" _v-d4f01320=\"\"></v-mutiselect>\n        </div>\n        <div _v-d4f01320=\"\">\n            <div v-if=\"isBranch\" class=\"st-text-16 st-py-2\" _v-d4f01320=\"\">{{ localPrinterSetting.branch_name }}</div>\n            <v-table :length=\"items.length\" _v-d4f01320=\"\">\n                <table class=\"table\" _v-d4f01320=\"\">\n                    <thead v-if=\"titleWord.length > 0\" _v-d4f01320=\"\">\n                        <tr _v-d4f01320=\"\">\n                            <th _v-d4f01320=\"\">{{titleWord}}</th>\n                        </tr>\n                    </thead>\n                    <tbody _v-d4f01320=\"\">\n                        <tr v-for=\"it in items\" :key=\"it.id\" class=\"ipsTr\" _v-d4f01320=\"\">\n                            <td @click.stop=\"changePrinter(it)\" style=\"border-bottom: 1px solid #ddd; border-top: none;\" _v-d4f01320=\"\">\n                                <st-radio :id=\"'printer'+it.id\" name=\"defaultPrinter\" :label=\"it.device_name\" :value=\"it.id\" :model.sync=\"selectedPrinterId\" _v-d4f01320=\"\"></st-radio>\n                            </td>\n                        </tr>\n                    </tbody>\n                </table>\n            </v-table>                \n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.sortable > tbody > tr[_v-d4f01320] {\n  cursor: pointer; }\n\n/* line 5, stdin */\n.ipsTr[_v-d4f01320] {\n  cursor: pointer; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-d4f01320", module.exports)
  } else {
    hotAPI.update("_v-d4f01320", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1338:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.sortable > tbody > tr[_v-44c326a8] {\n  cursor: pointer; }\n\n/* line 5, stdin */\n.ipsTr[_v-44c326a8] {\n  cursor: pointer; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['studioId', 'branches'],
    watch: {
        branchSelect: function branchSelect(val) {
            var _this = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.defaultBranch = val.id;
                                _this.startAjax = true;
                                _context.next = 4;
                                return _this.$store.dispatch('webadmin/print/fetchPrintSettingsNoneHttps', val.id);

                            case 4:
                                _context.next = 6;
                                return _this.setDefaultPrinter();

                            case 6:
                                _this.startAjax = false;

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        branches: function branches() {
            this.branchSelect = this.getSelectedBranch(this.defaultBranch);
        },

        localPrinterSetting: {
            handler: function handler(newVal) {
                if (newVal) {
                    this.branchSelect = this.getSelectedBranch(newVal.branch_id);
                }
            },

            deep: true
        }
    },
    data: function data() {
        return {
            branchSelect: null,
            startAjax: true,
            selectedPrinterId: null,
            defaultBranch: 0
        };
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        ajaxing: function ajaxing(state) {
            return state.webadmin.print.ajaxingSettings;
        },
        items: function items(state) {
            return state.webadmin.print.settings;
        },
        localPrinterSetting: function localPrinterSetting(state) {
            return state.webadmin.webLocalSetting.printerSetting;
        },
        isBranch: function isBranch(state) {
            return state.webadmin.configure.isBranch;
        }
    })),
    mounted: function mounted() {
        this.defaultBranch = this.localPrinterSetting.branch_id;
    },

    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('webadmin/print', ['setInUsePrinter']), {
        setDefaultPrinter: function setDefaultPrinter() {
            var _this2 = this;

            var defaultPrinter = this.items.find(function (printer) {
                return printer.id == _this2.localPrinterSetting.device_id;
            });
            this.changePrinter(defaultPrinter || {});
        },
        changePrinter: function changePrinter(printer) {
            this.selectedPrinterId = printer.id;
            this.$emit('update:selectIp', printer.device_ip);
            this.setInUsePrinter(printer);
        },
        getSelectedBranch: function getSelectedBranch(id) {
            return this.branches.reduce(function (carry, branch) {
                if (branch.id == id) {
                    carry = branch;
                }
                return carry;
            }, {});
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-44c326a8=\"\">\n    <v-spinner :ajaxing=\"startAjax\" style=\"align:center\" _v-44c326a8=\"\">\n    </v-spinner>\n    <div class=\"row\" v-if=\"!startAjax\" _v-44c326a8=\"\">\n        <div class=\"col-xs-12\" v-show=\"!isBranch\" _v-44c326a8=\"\">\n                <v-mutiselect :model.sync=\"branchSelect\" :options=\"branches\" :multiple=\"false\" :close-on-select=\"true\" :clear-on-select=\"true\" :searchable=\"true\" label=\"name\" track-by=\"id\" tag-name=\"name\" placeholder=\"請選擇\" :allow-empty=\"false\" _v-44c326a8=\"\"></v-mutiselect>\n        </div>\n    </div>\n    <div class=\"row\" v-if=\"!startAjax\" _v-44c326a8=\"\">\n        <div class=\"col-xs-12\" _v-44c326a8=\"\">\n        <v-table :length=\"items.length\" _v-44c326a8=\"\">\n            <table class=\"table\" _v-44c326a8=\"\">\n                <thead _v-44c326a8=\"\">\n                    <tr _v-44c326a8=\"\">\n                        <th _v-44c326a8=\"\">選擇列印裝置</th>\n                    </tr>\n                </thead>\n                <tbody _v-44c326a8=\"\">\n                    <tr v-for=\"it in items\" :key=\"it.id\" class=\"ipsTr\" _v-44c326a8=\"\">\n                        <td @click.stop=\"changePrinter(it)\" _v-44c326a8=\"\"> \n                            <input type=\"radio\" :value=\"it.id\" :id=\"'printer'+it.id\" name=\"defaultPrinter\" v-model=\"selectedPrinterId\" _v-44c326a8=\"\"> \n                            <label :for=\"'printer'+it.id\" _v-44c326a8=\"\"> {{ it.device_name }}</label>\n                        </td>\n                    </tr>\n                </tbody>\n            </table>\n        </v-table>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.sortable > tbody > tr[_v-44c326a8] {\n  cursor: pointer; }\n\n/* line 5, stdin */\n.ipsTr[_v-44c326a8] {\n  cursor: pointer; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-44c326a8", module.exports)
  } else {
    hotAPI.update("_v-44c326a8", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1339:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            defaultAgent: 'iot_kit'
        };
    },
    mounted: function mounted() {
        this.changeAgent('iot_kit');
    },

    computed: {},
    watch: {
        defaultAgent: function defaultAgent(newVal) {
            if (newVal) {
                this.changeAgent(newVal);
            }
        }
    },
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('webadmin/print', ['printerAgent']), {
        changeAgent: function changeAgent(agent) {
            this.printerAgent(agent);
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"m-top-20\">\n    <div class=\"st-text-16 st-font-medium st-text-black st-mb-2\">印表機呼叫方式</div>\n    <div>\n        <st-radio id=\"iot_kit\" name=\"iot_kit\" label=\"IoT Kit\" value=\"iot_kit\" :model.sync=\"defaultAgent\"></st-radio>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-21711af8", module.exports)
  } else {
    hotAPI.update("_v-21711af8", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vuex":803}],1340:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        studioId: {
            type: [String, Number]
        },
        branchId: {
            type: [String, Number]
        }
    },
    data: function data() {
        return {
            mode: 'create', // update | create
            device: {},
            ajaxing: false
        };
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        canRemove: function canRemove(state) {
            return state.webadmin.configure.webFunctions.WebadminPrintDeviceUpdate;
        }
    }), {
        modalTitle: function modalTitle() {
            return this.mode == 'update' ? '編輯列印裝置' : '新增列印裝置';
        }
    }),
    methods: {
        show: function show(_ref) {
            var mode = _ref.mode,
                device = _ref.device;

            this.mode = mode;
            if (mode == 'update') {
                this.device = device;
            } else {
                this.resetData();
            }
            $(this.$el).modal('show');
        },
        resetData: function resetData() {
            this.device = {
                id: 0,
                name: '',
                ip: ''
            };
        },
        save: function save() {
            this.ajaxing = true;
            var params = {
                device_name: this.device.name,
                device_ip: this.device.ip,
                studio_id: this.studioId,
                branch_id: this.branchId
            };
            if (this.mode == 'update') {
                this.$store.dispatch('webadmin/print/update', {
                    id: this.device.id,
                    data: params
                }).then(this.successHandler);
            } else {
                this.$store.dispatch('webadmin/print/create', params).then(this.successHandler);
            }
        },
        remove: function remove() {
            var _this = this;

            this.ajaxing = true;
            this.$http.get('/adminapi/print_device/check-web-local-printer-setting-in-use/' + this.device.id).then(function (response) {
                _this.ajaxing = false;
                if (response.data.in_use) {
                    $17.swal({
                        title: '「' + _this.device.name + '」使用中',
                        text: '請將 本機列印設定 > 預設印表機 更改為其它列印裝置，或點選「刪除」直接移除',
                        type: 'warning',
                        confirmButtonText: '刪除'
                    }, function (confirm) {
                        if (!confirm) return;
                        _this.ajaxing = true;
                        _this.$store.dispatch('webadmin/print/delete', { id: _this.device.id }).then(_this.successHandler).catch(function (err) {
                            return _this.errorHandler(err);
                        });
                    });
                } else {
                    $17.swal({
                        title: '確認刪除「' + _this.device.name + '」?',
                        type: 'warning',
                        confirmButtonText: '確認刪除'
                    }, function (confirm) {
                        if (!confirm) return;
                        _this.ajaxing = true;
                        _this.$store.dispatch('webadmin/print/delete', { id: _this.device.id }).then(_this.successHandler).catch(function (err) {
                            return _this.errorHandler(err);
                        });
                    });
                }
            });
        },
        successHandler: function successHandler() {
            this.ajaxing = false;
            this.$store.dispatch('webadmin/print/fetchPrintSettings', this.branchId);
            this.$store.dispatch('webadmin/webLocalSetting/fetchPrinterSetting');
            $(this.$el).modal('hide');
        },
        errorHandler: function errorHandler(err) {
            $17.swal({
                title: '刪除失敗',
                type: 'error',
                showCancelButton: false
            });
        },
        close: function close() {
            $(this.$el).modal('hide');
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal id=\"setting_printer_modal\">\n    <span slot=\"title\">{{ modalTitle }}</span>\n    <template slot=\"body\">\n        <div class=\"st-space-y-4 st-my-3\">\n            <st-input v-model=\"device.name\" type=\"text\" label=\"裝置名稱\" :disabled=\"ajaxing\" placeholder=\"ex.印表機1\">\n            </st-input>\n            <st-input v-model=\"device.ip\" type=\"text\" label=\"裝置IP\" :disabled=\"ajaxing\" placeholder=\"ex.172.20.10.4\">\n            </st-input>\n        </div>\n    </template>\n    <template slot=\"footer\">\n        <div class=\"st-flex\">\n            <div v-if=\"mode == 'update'\">\n                <st-button danger=\"\" outline=\"\" @click.prevent=\"remove\" :disabled=\"ajaxing\">刪除</st-button>\n            </div>\n            <div class=\"st-flex st-grow st-justify-end st-space-x-2\">\n                <st-button primary=\"\" ghost=\"\" @click.prevent=\"close\" :disabled=\"ajaxing\">關閉</st-button>\n                <st-button primary=\"\" filled=\"\" @click.prevent=\"save\" :disabled=\"ajaxing\">儲存</st-button>\n            </div>\n        </div>\n    </template>\n</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-1179d3d4", module.exports)
  } else {
    hotAPI.update("_v-1179d3d4", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vuex":803}],1341:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            printerAgent: 'iot_kit',
            printScope: {
                invoice: false,
                ticket: false,
                contract: false
            },
            activeAutoPrint: false,
            defaultPrinter: null,
            ajaxing: false
        };
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        localPrinterSetting: function localPrinterSetting(state) {
            return state.webadmin.webLocalSetting.printerSetting;
        },
        items: function items(state) {
            return state.webadmin.print.settings;
        },
        selectedStudioId: function selectedStudioId(state) {
            return state.filters.selected_studio_id;
        },
        selectedBranchId: function selectedBranchId(state) {
            return state.filters.selected_branch_id;
        }
    }), {
        isDisabledConfirm: function isDisabledConfirm() {
            var isSetPrinter = this.defaultPrinter ? true : false;
            if (this.activeAutoPrint) {
                return this.ajaxing || !isSetPrinter || this.isEmptyPrintScope;
            } else {
                return this.ajaxing || !isSetPrinter;
            }
        },
        isEmptyPrintScope: function isEmptyPrintScope() {
            return !this.printScope.invoice && !this.printScope.ticket && !this.printScope.contract;
        }
    }),
    mounted: function mounted() {
        if (!this.selectedBranchId || !this.selectedStudioId) {
            this.backToIndex();
            return;
        }
        if (this.selectedBranchId == this.localPrinterSetting.branch_id) {
            this.reset(this.localPrinterSetting);
        }
    },

    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('webadmin/webLocalSetting', ['fetchPrinterSetting', 'putPrinterSetting']), {
        save: function save() {
            var _this = this;

            if (_lodash2.default.isEmpty(this.localPrinterSetting)) {
                this.confirm();
                return;
            }

            $17.swal({
                title: '此裝置已被綁定',
                text: '請確認是否覆蓋該裝置原有的列印設定',
                type: 'warning'
            }, function (confirm) {
                if (confirm) {
                    _this.confirm();
                }
            });
        },
        confirm: function confirm() {
            var _this2 = this;

            this.ajaxing = true;
            var params = {
                settings_params: {
                    print_devices_id: this.defaultPrinter.id,
                    auto_printer_status: this.activeAutoPrint ? 1 : 0,
                    scope_invoice_status: this.printScope.invoice ? 1 : 0,
                    scope_ticket_status: this.printScope.ticket ? 1 : 0,
                    scope_contract_status: this.printScope.contract ? 1 : 0,
                    printer_agent: this.printerAgent
                }
            };
            this.putPrinterSetting(params).then(function (response) {
                _this2.ajaxing = false;
                _this2.fetchPrinterSetting();
                $17.swal({
                    title: response.data.message,
                    type: 'success',
                    showCancelButton: false
                }, function (confirm) {
                    if (confirm) {
                        _this2.backToIndex();
                    }
                });
            }).catch(function (error) {
                _this2.ajaxing = false;
                $17.swal({
                    title: error.data.message || '設定發生錯誤',
                    type: 'error',
                    showCancelButton: false
                });
            });
        },
        reset: function reset() {
            var data = (0, _assign2.default)({}, this.localPrinterSetting);
            if (_lodash2.default.isEmpty(data)) {
                this.printScope = {
                    invoice: false,
                    ticket: false,
                    contract: false
                };
                this.activeAutoPrint = false;
                this.defaultPrinter = null;
                this.printerAgent = 'iot_kit';
            } else {
                this.printScope = {
                    invoice: data.scope_invoice_status,
                    ticket: data.scope_ticket_status,
                    contract: data.scope_contract_status
                };
                this.activeAutoPrint = data.auto_printer_status;
                this.defaultPrinter = this.items.find(function (printer) {
                    return printer.id == data.device_id;
                });
                this.printerAgent = data.printer_agent || 'iot_kit';
            }
        },
        backToIndex: function backToIndex() {
            var query = (0, _extends3.default)({}, this.$route.query, {
                sub_page: 'printer_list',
                tab_hidden: false
            });
            this.$router.push({
                name: this.$route.name,
                query: query
            });
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"st-text-16 st-pb-24\">\n    <div class=\"st-text-24 st-font-bold st-text-black\">\n        本機列印設定\n    </div>\n    <hr class=\"st-border-gray-40 st-my-2.5\">\n    <div class=\"st-space-y-3\">\n        <div class=\"st-font-medium\">\n            預設印表機 <span class=\"st-text-danger\">(必填)</span>\n        </div>\n        <div>\n            <st-radio name=\"iot_kit\" label=\"IoT Kit\" value=\"iot_kit\" :model.sync=\"printerAgent\"></st-radio>\n        </div>\n        <div class=\"st-max-w-xs\">\n            <v-mutiselect :model.sync=\"defaultPrinter\" :options=\"items\" :close-on-select=\"true\" :clear-on-select=\"true\" :searchable=\"false\" placeholder=\"請選擇印表機\" label=\"device_name\" track-by=\"id\" :max-height=\"500\">\n            </v-mutiselect>\n        </div>\n    </div>\n    <div class=\"st-space-y-3 st-mt-7\">\n        <st-checkbox name=\"active_auto_print\" label=\"啟用自動列印\" :model.sync=\"activeAutoPrint\"></st-checkbox>\n        <div class=\"st-border-0 st-border-gray-40 st-border-l-4 st-border-solid st-ml-3 st-pl-3 st-space-y-2\" v-show=\"activeAutoPrint\">\n            <div class=\"st-font-medium\">列印範圍</div>\n            <div class=\"st-flex st-space-x-4\">\n                <st-checkbox name=\"invoice\" label=\"發票\" :model.sync=\"printScope.invoice\"></st-checkbox>\n                <st-checkbox name=\"ticket\" label=\"票券\" :model.sync=\"printScope.ticket\"></st-checkbox>\n                <st-checkbox name=\"contract\" label=\"方案\" :model.sync=\"printScope.contract\"></st-checkbox>\n            </div>\n            <div class=\"st-flex st-items-center st-text-14 st-text-danger\" v-show=\"isEmptyPrintScope\">\n                <span class=\"material-icons st-text-danger st-text-16\">info</span>您必須勾選至少一項\n            </div>\n        </div>\n    </div>\n    <st-action-bar confirm-text=\"儲存\" :disabled-confirm=\"isDisabledConfirm\" :disabled-cancel=\"ajaxing\" @confirm=\"save\" @cancel=\"backToIndex\"></st-action-bar>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-82d23964", module.exports)
  } else {
    hotAPI.update("_v-82d23964", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/object/assign":50,"babel-runtime/helpers/extends":66,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vuex":803}],1342:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _index = require('./index.vue');

var _index2 = _interopRequireDefault(_index);

var _productGroupModal = require('./product-group-modal.vue');

var _productGroupModal2 = _interopRequireDefault(_productGroupModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('webadmin-product-group', _index2.default);
_vue2.default.component('product-group-modal-vue', _productGroupModal2.default);

},{"./index.vue":1343,"./product-group-modal.vue":1344,"vue":792}],1343:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 4, stdin */\n.product-group-table tbody tr td[_v-4ccad226]:nth-child(1) {\n  width: 30em; }\n\n/* line 7, stdin */\n.product-group-table tbody tr td[_v-4ccad226]:nth-child(2) {\n  width: 5em; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            ajaxing: false,
            mode: '',
            group_name: '',
            group_id: '',
            group_items: [],
            group_products: [],
            added_product: {}
        };
    },
    mounted: function mounted() {},
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId']), (0, _vuex.mapState)('filters', ['selected_studio_id', 'selected_branch_id'])),
    watch: {
        selected_branch_id: function selected_branch_id(val) {
            if (val) {
                this.fetch();
            }
        }
    },
    methods: {
        getProduct: function getProduct(product) {
            product.display_name = '';
            product.sequence = 0;
            product.is_active = true;
            this.added_product = product;
            $('#product-list-modal').modal('hide');
        },
        fetch: function fetch() {
            var _this = this;

            this.group_items = [];
            this.ajaxing = true;
            this.$http.get('/adminapi/product-group/' + this.selected_branch_id).then(function (response) {
                _this.ajaxing = false;
                _this.group_items = response.body;
            }, function (error) {
                _this.ajaxing = false;
            });
        },
        openGroupModal: function openGroupModal(action, idx) {
            this.mode = action;
            if (action == 'update') {
                this.group_id = this.group_items[idx].id;
                this.group_name = this.group_items[idx].name;
                this.group_products = this.group_items[idx].products;
            } else if (action == 'create') {
                this.group_id = '';
                this.group_name = '';
                this.group_products = [];
            };
            $('#product-group-modal-vue').modal('show');
        },
        remove: function remove(idx) {
            var _this2 = this;

            this.ajaxing = true;
            var groupId = this.group_items[idx].id;
            this.$http.delete('/adminapi/product-group/' + groupId).then(function (response) {
                _this2.fetch();
            }, function (error) {
                _this2.ajaxing = false;
                $17.swal({
                    title: '刪除失敗',
                    type: 'error',
                    showCancelButton: false
                });
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"col-xs-12\" _v-4ccad226=\"\">\n    <div id=\"product-group\" _v-4ccad226=\"\"> \n        <div class=\"row m-top-15 m-bottom-30\" _v-4ccad226=\"\">\n            <div class=\"col-sm-3\" _v-4ccad226=\"\">\n                <v-select-studio-and-branch :studio_id=\"studioId\" :branch_id=\"branchId\" :branch-without-filtered-option=\"false\" _v-4ccad226=\"\">\n                </v-select-studio-and-branch>\n\n                <a type=\"button\" class=\"btn btn-success\" @click=\"openGroupModal('create', -1)\" _v-4ccad226=\"\">\n                    <i class=\"fa fa-plus-circle\" aria-hidden=\"true\" _v-4ccad226=\"\"></i>\n                    新增IOT 銷售項目\n                </a>\n            </div>\n        </div>\n\n        <v-spinner :ajaxing=\"ajaxing\" _v-4ccad226=\"\"></v-spinner>\n        <div class=\"row\" v-if=\"group_items.length !== 0 &amp;&amp; !ajaxing\" _v-4ccad226=\"\">\n            <div class=\"col-sm-12\" _v-4ccad226=\"\">\n                <div class=\"table-response\" _v-4ccad226=\"\">\n                    <table class=\"table table-hover product-group-table\" _v-4ccad226=\"\">\n                        <thead _v-4ccad226=\"\">\n                            <tr _v-4ccad226=\"\">\n                                <th _v-4ccad226=\"\">IOT 銷售項目名稱</th>\n                                <th _v-4ccad226=\"\">動作</th>\n                                <th _v-4ccad226=\"\"></th>\n                            </tr>\n                        </thead>\n                        <tbody _v-4ccad226=\"\">\n                            <tr v-for=\"(item, idx) in group_items\" :key=\"idx\" _v-4ccad226=\"\">\n                                <td _v-4ccad226=\"\">{{item.name}}</td>\n                                <td _v-4ccad226=\"\">\n                                    <a @click.prevent=\"openGroupModal('update', idx)\" _v-4ccad226=\"\">\n                                        <i class=\"fa fa-cog\" aria-hidden=\"true\" _v-4ccad226=\"\"></i>\n                                        設定\n                                    </a>\n                                </td>\n                                <td _v-4ccad226=\"\">\n                                    <a style=\"color: red;\" @click.prevent=\"remove(idx)\" _v-4ccad226=\"\">\n                                        <i class=\"fa fa-trash\" aria-hidden=\"true\" _v-4ccad226=\"\"></i>\n                                        刪除\n                                    </a>\n                                </td>\n                            </tr>\n                        </tbody>\n                    </table>\n                </div>\n            </div>\n        </div>\n\n        <product-group-modal-vue :mode=\"mode\" :products=\"group_products\" :added-product=\"added_product\" :group-name=\"group_name\" :group-id=\"group_id\" @fetch-data=\"fetch\" _v-4ccad226=\"\"></product-group-modal-vue>\n        <product-list :product-group=\"true\" @product=\"getProduct\" _v-4ccad226=\"\"></product-list>\n    </div>\n</div>    \n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 4, stdin */\n.product-group-table tbody tr td[_v-4ccad226]:nth-child(1) {\n  width: 30em; }\n\n/* line 7, stdin */\n.product-group-table tbody tr td[_v-4ccad226]:nth-child(2) {\n  width: 5em; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-4ccad226", module.exports)
  } else {
    hotAPI.update("_v-4ccad226", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1344:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 3, stdin */\n#product-group-modal-vue .d-flex[_v-e51f1148] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  gap: 20px; }\n\n/* line 8, stdin */\n#product-group-modal-vue input[_v-e51f1148] {\n  padding: 5px 12px; }\n\n/* line 11, stdin */\n#product-group-modal-vue label[_v-e51f1148] {\n  margin-top: 0.2em;\n  margin-bottom: 0;\n  font-size: 0.8rem; }\n\n/* line 16, stdin */\n#product-group-modal-vue .btn-container[_v-e51f1148] {\n  text-align: right; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        mode: {
            type: String
        },
        products: {
            type: [Array, Object]
        },
        addedProduct: {
            type: [Array, Object]
        },
        groupName: {
            type: String
        },
        groupId: {}
    },
    data: function data() {
        return {
            ajaxing: false,
            group_name: '',
            group_products: '',
            observer: '',
            refreshData: false
        };
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId']), (0, _vuex.mapState)('filters', ['selected_studio_id', 'selected_branch_id']), {
        create: function create() {
            return this.mode === 'create';
        },
        update: function update() {
            return this.mode === 'update';
        },
        disableSubmit: function disableSubmit() {
            return this.group_name == '';
        }
    }),
    mounted: function mounted() {
        var _this = this;

        var targetNode = document.getElementsByTagName('body')[0];
        var config = { attributes: true, attributeOldValue: true, attributeFilter: ['class'] };
        this.observer = new MutationObserver(function (mutations) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                var _loop = function _loop() {
                    var m = _step.value;

                    var newValue = m.target.getAttribute(m.attributeName);
                    _this.$nextTick(function () {
                        _this.onClassChange(newValue, m.oldValue);
                    });
                };

                for (var _iterator = (0, _getIterator3.default)(mutations), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    _loop();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        });
        this.observer.observe(targetNode, config);
    },

    watch: {
        refreshData: function refreshData(val) {
            if (val) {
                this.group_name = this.groupName;
                this.group_products = JSON.parse((0, _stringify2.default)(this.products));
            }
        },

        addedProduct: {
            handler: function handler(val) {
                this.appendProductToList(val);
            },
            deep: true
        }
    },
    methods: {
        onClassChange: function onClassChange(classAttrValue) {
            var classList = classAttrValue.split(' ');
            if (classList.includes('modal-open')) {
                this.refreshData = true;
            } else {
                this.refreshData = false;
            }
        },
        openProductList: function openProductList(type) {
            this.$store.dispatch('pos/openProductList', { type: type, branch_id: this.selected_branch_id }).then(function () {
                $('#product-list-modal').modal('show');
            });
        },
        appendProductToList: function appendProductToList(product) {
            var duplicateProduct = this.group_products.find(function (item) {
                return item.id == product.id;
            });
            if (duplicateProduct) {
                $17.swal({
                    title: product.name + ' \u5DF2\u65B0\u589E',
                    type: 'info',
                    showCancelButton: false
                });
            } else {
                this.group_products.push(product);
            };
        },
        remove: function remove(idx) {
            this.group_products.splice(idx, 1);
        },
        submit: function submit() {
            this.ajaxing = true;
            var postData = {};
            postData['name'] = this.group_name;
            postData['sequence'] = 0;
            postData['branch_id'] = this.selected_branch_id;
            postData['studio_id'] = this.selected_studio_id;
            if (this.group_products) {
                postData['products'] = [], this.group_products.forEach(function (product) {
                    postData.products.push({
                        name: product.display_name ? product.display_name : product.name,
                        sequence: product.sequence,
                        is_active: product.is_active ? 1 : 0,
                        table_id: product.id,
                        table_type: product.type
                    });
                });
            };

            this.submitPost(this.mode, postData);
        },
        submitPost: function submitPost(mode, postData) {
            var _this2 = this;

            var message = '';
            if (mode == 'create') {
                message = '新增失敗';
            } else if (mode == 'update') {
                postData['id'] = this.groupId;
                message = '修改失敗';
            }

            this.$http.post('/adminapi/product-group/' + mode, { data: postData }).then(function (response) {
                $('#product-group-modal-vue').modal('hide');
                _this2.ajaxing = false;
                _this2.$emit('fetch-data');
            }, function (error) {
                _this2.ajaxing = false;
                $17.swal({
                    title: message,
                    type: 'error',
                    showCancelButton: false
                });
            });
        }
    },
    beforeDestroy: function beforeDestroy() {
        this.observer.disconnect();
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-e51f1148=\"\">\n<v-modal id=\"product-group-modal-vue\" _v-e51f1148=\"\">\n        <div slot=\"title\" _v-e51f1148=\"\">\n            IOT 銷售項目設定\n        </div>\n        <div slot=\"body\" _v-e51f1148=\"\">\n            <div class=\"d-flex\" _v-e51f1148=\"\">\n                <div _v-e51f1148=\"\">IOT 銷售項目名稱*</div>\n                <div _v-e51f1148=\"\">\n                    <input type=\"text\" id=\"group-name\" name=\"group-name\" v-model=\"group_name\" placeholder=\"請輸入IOT 銷售項目名稱\" maxlength=\"30\" _v-e51f1148=\"\">\n                </div>\n            </div>\n\n            <div _v-e51f1148=\"\">\n                <div class=\"m-top-30 m-bottom-20\" _v-e51f1148=\"\">\n                    <a type=\"button\" class=\"btn btn-success\" @click=\"openProductList('ticket_settings')\" _v-e51f1148=\"\">\n                        <i class=\"fa fa-plus-circle\" aria-hidden=\"true\" _v-e51f1148=\"\"></i>\n                        加入票券\n                    </a>\n                </div>\n                <div class=\"row\" v-if=\"group_products.length !== 0\" _v-e51f1148=\"\">\n                    <div class=\"col-sm-12\" _v-e51f1148=\"\">\n                        <div class=\"table-response\" _v-e51f1148=\"\">\n                            <table class=\"table\" _v-e51f1148=\"\">\n                                <thead _v-e51f1148=\"\">\n                                    <tr _v-e51f1148=\"\">\n                                        <th _v-e51f1148=\"\">產品名稱</th>\n                                        <th _v-e51f1148=\"\">顯示名稱</th>\n                                        <th _v-e51f1148=\"\">金額</th>\n                                        <th _v-e51f1148=\"\">排序</th>\n                                        <th _v-e51f1148=\"\"></th>\n                                        <th _v-e51f1148=\"\"></th>\n                                    </tr>\n                                </thead>\n                                <tbody _v-e51f1148=\"\">\n                                    <tr v-for=\"(product, idx) in group_products\" :key=\"idx\" _v-e51f1148=\"\">\n                                        <td _v-e51f1148=\"\">{{product.name}}</td>\n                                        <td _v-e51f1148=\"\">\n                                            <input type=\"text\" id=\"product-name\" name=\"product-name\" :placeholder=\"product.name\" v-model=\"product.display_name\" _v-e51f1148=\"\">\n                                        </td>\n                                        <td _v-e51f1148=\"\">{{product.price}}</td>\n                                        <td _v-e51f1148=\"\">\n                                            <input type=\"number\" id=\"product-sequence\" name=\"product-sequence\" min=\"0\" max=\"999\" v-model=\"product.sequence\" _v-e51f1148=\"\">\n                                        </td>\n                                        <td _v-e51f1148=\"\">\n                                            <input type=\"checkbox\" id=\"is-active\" name=\"is-active\" v-model=\"product.is_active\" _v-e51f1148=\"\">\n                                            <label for=\"is-active\" _v-e51f1148=\"\">啟用</label>\n                                        </td>\n                                        <td _v-e51f1148=\"\">\n                                            <a style=\"color: red;\" @click.prevent=\"remove(idx)\" _v-e51f1148=\"\">\n                                                <i class=\"fa fa-trash\" aria-hidden=\"true\" _v-e51f1148=\"\"></i>\n                                                刪除\n                                            </a>\n                                        </td>\n                                    </tr>\n                                </tbody>\n                            </table>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div slot=\"footer\" _v-e51f1148=\"\">\n            <div class=\"btn-container\" _v-e51f1148=\"\">\n                <button v-show=\"!ajaxing\" type=\"button\" class=\"btn btn-primary\" @click.prevent=\"submit()\" :disabled=\"disableSubmit\" _v-e51f1148=\"\">送出</button>\n                <i v-show=\"ajaxing\" class=\"fa fa-spin fa-spinner\" _v-e51f1148=\"\"></i>\n            </div>                \n        <div _v-e51f1148=\"\">\n\n</div>\n</div></v-modal></div>"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 3, stdin */\n#product-group-modal-vue .d-flex[_v-e51f1148] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  gap: 20px; }\n\n/* line 8, stdin */\n#product-group-modal-vue input[_v-e51f1148] {\n  padding: 5px 12px; }\n\n/* line 11, stdin */\n#product-group-modal-vue label[_v-e51f1148] {\n  margin-top: 0.2em;\n  margin-bottom: 0;\n  font-size: 0.8rem; }\n\n/* line 16, stdin */\n#product-group-modal-vue .btn-container[_v-e51f1148] {\n  text-align: right; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-e51f1148", module.exports)
  } else {
    hotAPI.update("_v-e51f1148", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/get-iterator":46,"babel-runtime/core-js/json/stringify":48,"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1345:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.page-div[_v-29e7eacc] {\n  padding: 0px 15px;\n  margin-bottom: 15px; }\n\n/* line 7, stdin */\n.table-div[_v-29e7eacc] {\n  padding: 20px 0px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _watch;

var _vuex = require('vuex');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            display: 'show',
            result: {},
            detailList: {
                'list': [],
                'all_total': 0
            },
            summaryList: {
                'list': [],
                'all_total': 0,
                'success_paid': 0,
                'fail_unpaid': 0
            },
            contractIds: [],
            statuses: [],
            showCancel: 0,
            onlyLast: 0,
            tableSummaryVisitsConfig: {},
            csvSummaryVisitsConfig: {},
            tableDetailConfig: {
                columns: [{
                    keys: "name",
                    head: "姓名",
                    html: function html(item) {
                        var content = item.name;
                        if (item.member_id !== '' && item.member_id !== 0) {
                            content = '<a href="/webadmin/member_studio?f[id]=' + item.member_id + '" target="_blank">' + item.name + '</a>';
                        }
                        return content;
                    }
                }, { keys: "phone", head: "電話" }, { keys: "email", head: "電子郵件" }, { keys: "branch_name", head: "場館名稱" }, { keys: "contract_name", head: "使用方案" }, { keys: "entered_at", head: "入場日期時間" }, { keys: "leaved_at", head: "出場日期時間" }, { keys: "consume_value", head: "扣除" }]
            },
            csvDetailConfig: {
                column: [{ keys: "name", name: "姓名" }, { keys: "phone", name: "電話" }, { keys: "email", name: "電子郵件" }, { keys: "branch_name", name: "場館名稱" }, { keys: "contract_name", name: "使用方案" }, { keys: "entered_at", name: "入場日期時間" }, { keys: "leaved_at", name: "出場日期時間" }, { keys: "consume_value", name: "扣除" }],
                fileName: 'admission-record-' + moment().format("YYYYMMDDHHmmss"),
                jsonData: []
            },
            tableSummaryConfig: {
                columns: [{
                    keys: "name",
                    head: "姓名",
                    html: function html(item) {
                        var content = item.name;
                        if (item.member_id !== '' && item.member_id !== 0) {
                            content = '<a href="/webadmin/member_studio?f[id]=' + item.member_id + '" target="_blank">' + item.name + '</a>';
                        }
                        return content;
                    }
                }, { keys: "phone", head: "電話" }, { keys: "email", head: "電子郵件" }, { keys: "admissions_sum", head: "入場次數" }]
            },
            csvSummaryConfig: {
                column: [{ keys: "name", name: "姓名" }, { keys: "phone", name: "電話" }, { keys: "email", name: "電子郵件" }, { keys: "admissions_sum", name: "入場次數" }],
                fileName: 'admission-count-groupby-member-' + moment().format("YYYYMMDDHHmmss"),
                jsonData: []
            },
            relatedFilterWatcher: {
                studio_id: {
                    watcher: null,
                    options: "studioList",
                    vModel: "studioId",
                    trackBy: "id",
                    type: "single"
                },
                branch_ids: {
                    watcher: "studioId",
                    options: "branchList",
                    vModel: "branchIds",
                    trackBy: "id",
                    type: "multiple"
                }
            },
            multiFilter: {
                auto_pay_detail_status: {
                    watcher: null,
                    options: "stateList",
                    vModel: "statuses",
                    trackBy: "value",
                    type: "multiple"
                }
            }
        };
    },
    created: function created() {
        this.syncRelatedMultipleSelectByQuery({ vm: this, relatedFilterWatcher: this.relatedFilterWatcher });
        this.syncLocalMultipleSelectByQuery({ vm: this, multiFilter: this.multiFilter });
    },
    mounted: function mounted() {
        var _this = this;

        this.configuredRun(function () {
            _this.changeFilterOption({
                prop: 'studioId',
                value: {
                    id: _this.configureStates.studioId,
                    brand_name: ''
                }
            });
            _this.changeFilterOption({
                prop: 'branchId',
                value: _this.configureStates.branchId
            });
            if (_this.configureStates.isSeventeen) {
                return _this.fetchStudioList();
            }
            if (_this.configureStates.isBranch) {
                _this.branchIds = [{
                    'id': _this.configureStates.branchId,
                    'branch_name': ''
                }];
            }
            if (_this.configureStates.isStudio) {
                _this.fetchContractList({ 'studioId': _this.configureStates.studioId, 'withDelete': true });
            }
            if (_this.configureStates.isBranch) {
                _this.fetchContractList({ 'studioId': _this.configureStates.studioId, 'branchId': _this.configureStates.branchID, 'withDelete': true });
            }
        });
        this.syncDateAndDisplayByQuery();
        var query = $17.getUrlQueryStrings();
        this.showCancel = query.show_cancel ? query.show_cancel : 0;
        this.onlyLast = query.only_last ? query.only_last : 0;
        this.viewMode = query.view_mode ? query.view_mode : 'Detail';
    },

    watch: (_watch = {}, (0, _defineProperty3.default)(_watch, 'filterOptions.studioId', function filterOptionsStudioId(n, o) {
        if (this.configureStates.isSeventeen && !_lodash2.default.isEmpty(n)) {
            this.fetchBranchList({
                studioId: n.id
            });
        }
        if (this.configureStates.isStudio) {
            this.fetchBranchList({
                studioId: n.id
            });
        }
    }), (0, _defineProperty3.default)(_watch, 'viewMode', function viewMode(newV) {
        if (newV) {
            this.reset();
        }
    }), (0, _defineProperty3.default)(_watch, 'result', function result(newV) {
        if (newV.records !== undefined && newV.records.length > 0 && this.display === 'export') {
            if (this.viewMode == 'SummaryVisits') {
                this.downloadSummaryVisitsCsv(newV);
                return;
            }
            this['csv' + this.viewMode + 'Config'].jsonData = _lodash2.default.cloneDeep(newV.records);
            this.$refs.smart_table.downloadCsv();
        }
    }), _watch),
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        configureStates: function configureStates(state) {
            return state.webadmin.configure;
        }
    }), (0, _vuex.mapState)('webadmin/configure', ['configured', 'studioList', 'branchList', 'branchId', 'contractList']), (0, _vuex.mapState)('webadmin/baseReport', ['blockOpenStatus', 'dateOptions', 'filterOptions', 'queryPara', "ajaxing"]), {
        studioId: {
            get: function get() {
                return this.filterOptions.studioId;
            },
            set: function set(newValue) {
                var _this2 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                    return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.next = 2;
                                    return _this2.changeFilterOption({ 'prop': 'studioId', value: newValue });

                                case 2:
                                    _this2.cleanBranch();

                                    if (!newValue) {
                                        _context.next = 6;
                                        break;
                                    }

                                    _context.next = 6;
                                    return _this2.fetchBranchList({ studioId: newValue.id });

                                case 6:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this2);
                }))();
            }
        },
        branchIds: {
            get: function get() {
                return this.filterOptions.branchIds;
            },
            set: function set(newValue) {
                var _this3 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                    return _regenerator2.default.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    _context2.next = 2;
                                    return _this3.changeFilterOption({ 'prop': 'branchIds', value: newValue });

                                case 2:
                                case 'end':
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, _this3);
                }))();
            }
        },
        viewMode: {
            get: function get() {
                var viewMode = this.$store.state.webadmin.baseReport.itemOptions.viewMode;
                return viewMode.charAt(0).toUpperCase() + viewMode.slice(1);
            },
            set: function set(value) {
                this.changeItemOption({
                    prop: 'viewMode',
                    value: value
                });
            }
        }
    }),
    methods: (0, _extends3.default)({
        updateFilterOption: function updateFilterOption(field) {
            var _this4 = this;

            return function (value) {
                return _this4.changeFilterOption({
                    prop: field,
                    value: value
                });
            };
        }
    }, (0, _vuex.mapActions)('webadmin/configure', ['configuredRun', 'fetchStudioList', 'fetchBranchList', 'fetchContractList']), (0, _vuex.mapActions)('webadmin/baseReport', ['beforeSubmit', 'toggleBlock', 'changeDateOption', 'changeFilterOption', 'cleanBranch', 'cleanBranchRelated', 'changeItemOption', 'setDetailTarget', 'keepQueryParam', "changeAjaxing", "syncLocalMultipleSelectByQuery", "syncRelatedMultipleSelectByQuery", "syncDateAndDisplayByQuery", "changeDisplay"]), {
        submitSearch: function submitSearch() {
            this.beforeSubmit();
            switch (this.display) {
                case "export":
                    this.changeFilterOption({ prop: "pageSize", value: 9999999 });
                    break;
                case "show":
                    this.changeFilterOption({ prop: "pageSize", value: 25 });
                    break;
                default:
                    null;
            }
            var params = this.getParams();

            this.keepQueryParam(params);
            $17.updateUrlQueryString(params);

            this.changePage(1);
        },
        getDetailResult: function getDetailResult(params) {
            var _this5 = this;

            this.changeAjaxing(true);
            this.$http.get('/adminapi/report/fetch_all_admission_detail', { params: params }).then(function (response) {
                _this5.result = response.data;
                _this5.$refs.report.setCustomers(response.data.member_ids);
                _this5.changeAjaxing(false);
            }, function (error) {
                _this5.changeAjaxing(false);
                $17.swal({
                    title: error.body.message || '伺服器無回應，請檢查網路。',
                    type: 'warning'
                });
            });
        },
        getSummaryResult: function getSummaryResult(params) {
            var _this6 = this;

            this.changeAjaxing(true);
            this.$http.get('/adminapi/report/fetch_all_admission_total', { params: params }).then(function (response) {
                _this6.result = response.data;
                _this6.$refs.report.setCustomers(response.data.member_ids);
                _this6.changeAjaxing(false);
            }, function (error) {
                _this6.changeAjaxing(false);
                $17.swal({
                    title: error.body.message || '伺服器無回應，請檢查網路。',
                    type: 'warning'
                });
            });
        },
        checkMode: function checkMode(mode) {
            return this.viewMode === mode;
        },
        getParams: function getParams() {
            return {
                'studio_id': this.studioId && this.studioId.hasOwnProperty('id') ? this.studioId.id : 0,
                'branch_ids': this.branchIds.map(function (item) {
                    return item.id;
                }),
                'start_date': this.dateOptions.startDate,
                'end_date': this.dateOptions.endDate,
                'show_cancel': this.showCancel,
                'only_last': this.onlyLast,
                'view_mode': this.viewMode
            };
        },
        changePage: function changePage(page) {
            var _this7 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
                var params;
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _this7.changeFilterOption({
                                    prop: "page",
                                    value: page
                                });

                                params = _this7.queryPara;


                                params.page_size = _this7.filterOptions.pageSize;
                                params.page = _this7.filterOptions.page;

                                if (!(_this7.filterOptions.studioId.id > 0)) {
                                    _context3.next = 13;
                                    break;
                                }

                                _this7.reset();

                                if (!(_this7.viewMode == 'SummaryVisits')) {
                                    _context3.next = 12;
                                    break;
                                }

                                if (!(_this7.display == 'show')) {
                                    _context3.next = 10;
                                    break;
                                }

                                _this7.alert('不支援顯示於網頁', '', 'warning');
                                return _context3.abrupt('return');

                            case 10:
                                _this7.getDetailResult(params);
                                return _context3.abrupt('return');

                            case 12:
                                _this7['get' + _this7.viewMode + 'Result'](params);

                            case 13:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this7);
            }))();
        },
        reset: function reset() {
            this.result = {};
            this.$refs.report.setCustomers("");
        },
        getTableConfig: function getTableConfig() {
            return this['table' + this.viewMode + 'Config'];
        },
        getCsvConfig: function getCsvConfig() {
            return this['csv' + this.viewMode + 'Config'];
        },
        downloadSummaryVisitsCsv: function downloadSummaryVisitsCsv() {
            idArray = ['ID'];
            contractNameArray = ['入場方案'];
            subTotalArray = ['小計'];
            Array0 = ['00:00'];
            Array1 = ['01:00'];
            Array2 = ['02:00'];
            Array3 = ['03:00'];
            Array4 = ['04:00'];
            Array5 = ['05:00'];
            Array6 = ['06:00'];
            Array7 = ['07:00'];
            Array8 = ['08:00'];
            Array9 = ['09:00'];
            Array10 = ['10:00'];
            Array11 = ['11:00'];
            Array12 = ['12:00'];
            Array13 = ['13:00'];
            Array14 = ['14:00'];
            Array15 = ['15:00'];
            Array16 = ['16:00'];
            Array17 = ['17:00'];
            Array18 = ['18:00'];
            Array19 = ['19:00'];
            Array20 = ['20:00'];
            Array21 = ['21:00'];
            Array22 = ['22:00'];
            Array23 = ['23:00'];

            _lodash2.default.forEach(this.result.records, function (item) {
                nameFlag = false;
                var datetime = new Date(Date.parse(item.entered_at));
                _lodash2.default.forEach(idArray, function (idItem, key) {
                    if (idItem === item.id) {
                        nameFlag = true;
                        if (isNaN(subTotalArray[key])) {
                            subTotalArray[key] = 0;
                        }
                        contractNameArray[key] = item.csv_name;
                        subTotalArray[key] += 1;
                        time = datetime.getHours();
                        eval('if(isNaN(Array' + time + '[key])){Array' + time + '[key]=0}');
                        eval('Array' + time + '[key] += 1');
                    }
                });
                if (nameFlag === false) {
                    idArray.push(item.id);
                    contractNameArray[idArray.length - 1] = item.csv_name;
                    subTotalArray[idArray.length - 1] = 0;
                    subTotalArray[idArray.length - 1] += 1;
                    time = datetime.getHours();
                    eval('if(isNaN(Array' + time + '[idArray.length - 1])){Array' + time + '[idArray.length - 1]=0}');
                    eval('Array' + time + '[idArray.length - 1] += 1');
                }
            });
            var csv = [contractNameArray, subTotalArray];
            for (var index = 0; index <= 23; index++) {
                eval('csv.push(Array' + index + ')');
            }
            var results = this.csvDataHandler(csv);
            this.download(results);
        },
        download: function download(_csvString) {
            var downloadLink = document.createElement("a");
            downloadLink.download = 'admission-count-groupby-time-' + moment().format("YYYYMMDDHHmmss") + '.csv';
            downloadLink.innerHTML = "Download File";
            if (window.URL != null) {
                var code = encodeURIComponent(_csvString);
                downloadLink.href = "data:application/csv;charset=utf-8,%EF%BB%BF" + code;
            }
            downloadLink.click();
        },
        columnFormater: function columnFormater(data) {
            csv = (0, _stringify2.default)(data);
            return csv;
        },
        csvDataHandler: function csvDataHandler(data) {
            data = this.columnFormater(data);
            var results = Papa.unparse(data, {
                delimiter: ','
            });
            return results;
        },
        alert: function alert(title, message, type) {
            $17.swal({
                title: title,
                text: message,
                type: type,
                showCancelButton: false,
                showLoaderOnConfirm: true
            });
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"page-div\" _v-29e7eacc=\"\">\n    <v-webadmin-report :block-open-status=\"blockOpenStatus\" :date-options=\"dateOptions\" :toggle-block=\"toggleBlock\" :change-date-option=\"changeDateOption\" :is-open-temporary-customer-button=\"true\" :studio-id=\"studioId\" ref=\"report\" :disable-submit=\"ajaxing\" :submit=\"submitSearch\" limit-date=\"180\" title=\"入場報表\" _v-29e7eacc=\"\">\n        <div slot=\"second-block\" _v-29e7eacc=\"\">\n            <div class=\"row\" _v-29e7eacc=\"\">\n                <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen\" _v-29e7eacc=\"\">\n                    <div class=\"form-group\" _v-29e7eacc=\"\">\n                        <v-mutiselect :model.sync=\"studioId\" :options=\"studioList\" :preserve-search=\"true\" :placeholder=\"configureStates.ajaxing.studioList ? '品牌讀取中…' : '請選擇品牌'\" label=\"brand_name\" track-by=\"id\" _v-29e7eacc=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n                <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen || configureStates.isStudio\" _v-29e7eacc=\"\">\n                    <div class=\"form-group\" _v-29e7eacc=\"\">\n                        <v-mutiselect :model.sync=\"branchIds\" :options=\"branchList\" :disabled=\"configureStates.ajaxing.branchList\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"false\" :placeholder=\"configureStates.ajaxing.branchList ? '場館讀取中…' : '全部場館'\" label=\"branch_name\" track-by=\"id\" :taggable=\"true\" tag-name=\"branch_name\" _v-29e7eacc=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div slot=\"third-block\" _v-29e7eacc=\"\">\n            <div class=\"row\" _v-29e7eacc=\"\">\n                <div class=\"col-sm-6\" _v-29e7eacc=\"\">\n                    <div class=\"form-group\" _v-29e7eacc=\"\">\n                        <label _v-29e7eacc=\"\">\n                            <input name=\"view\" type=\"radio\" value=\"Detail\" v-model=\"viewMode\" checked=\"\" _v-29e7eacc=\"\"> 細節\n                        </label>\n                        <label _v-29e7eacc=\"\">\n                            <input name=\"view\" type=\"radio\" value=\"Summary\" v-model=\"viewMode\" _v-29e7eacc=\"\"> 總和\n                        </label>\n                        <label _v-29e7eacc=\"\">\n                            <input name=\"view\" type=\"radio\" value=\"SummaryVisits\" v-model=\"viewMode\" _v-29e7eacc=\"\"> 人次匯總\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div slot=\"fourth-block\" _v-29e7eacc=\"\">\n            <div class=\"row\" _v-29e7eacc=\"\">\n                <div class=\"col-sm-6\" _v-29e7eacc=\"\">\n                    <div class=\"form-group\" _v-29e7eacc=\"\">\n                        <label _v-29e7eacc=\"\">\n                            <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"show\" checked=\"\" _v-29e7eacc=\"\"> 顯示於網頁\n                        </label>\n                        <label _v-29e7eacc=\"\">\n                            <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"export\" _v-29e7eacc=\"\"> 匯出 CSV\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </v-webadmin-report>\n    <div class=\"m-top-10\" v-show=\"display == 'show'\" _v-29e7eacc=\"\">\n        <v-smart-table ref=\"smart_table\" :table-config=\"getTableConfig()\" :csv-config=\"getCsvConfig()\" :is-ajaxing=\"ajaxing\" :data=\"result\" :page-sync-url-query=\"false\" @change-page=\"changePage\" _v-29e7eacc=\"\"></v-smart-table>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.page-div[_v-29e7eacc] {\n  padding: 0px 15px;\n  margin-bottom: 15px; }\n\n/* line 7, stdin */\n.table-div[_v-29e7eacc] {\n  padding: 20px 0px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-29e7eacc", module.exports)
  } else {
    hotAPI.update("_v-29e7eacc", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/json/stringify":48,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/defineProperty":65,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1346:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.page-div[_v-08570e0c] {\n  padding: 0px 15px;\n  margin-bottom: 15px; }\n\n/* line 7, stdin */\n.table-div[_v-08570e0c] {\n  padding: 20px 0px; }\n\n/* line 10, stdin */\n.total-list[_v-08570e0c] {\n  margin-left: 10px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _watch;

var _vuex = require('vuex');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            display: 'show',
            total: 0,
            result: {},
            detailList: {
                'list': [],
                'all_total': 0
            },
            summaryList: {
                'list': [],
                'all_total': 0,
                'success_paid': 0,
                'fail_unpaid': 0
            },
            contractIds: [],
            statuses: [],
            stateList: [{ name: '已排定', value: 0 }, { name: '成功', value: 1 }, { name: '失敗', value: 2 }, { name: '略過', value: 5 }],
            showCancel: 0,
            onlyLast: 0,
            tableDetailConfig: {
                columns: [{ keys: "member_name", head: "客戶" }, { keys: "contract_name", head: "方案名稱" }, { keys: "date", head: "排程日期" }, { keys: "auto_pay_status", head: "自動支付結果" }, { keys: "sub_total", head: "金額" }, { keys: "order_id", head: "訂單編號" }, { keys: "order_status", head: "結帳狀態" }, { keys: "cancel_at", head: "取消時間" }]
            },
            csvDetailConfig: {
                column: [{ keys: "member_name", name: "客戶" }, { keys: "contract_name", name: "方案名稱" }, { keys: "date", name: "排程日期" }, { keys: "auto_pay_status", name: "自動支付結果" }, { keys: "sub_total", name: "金額" }, { keys: "order_id", name: "訂單編號" }, { keys: "order_status", name: "結帳狀態" }, { keys: "cancel_at", name: "取消時間" }]
            },
            tableSummaryConfig: {
                columns: [{ keys: "member_name", head: "客戶" }, { keys: "contract_name", head: "方案名稱" }, { keys: "all_times", head: "自動支付設定次數" }, { keys: "all_total", head: "應付總額" }, { keys: "success_times", head: "付款成功次數" }, { keys: "success_paid", head: "付款成功總額" }, { keys: "fail_times", head: "付款失敗次數" }, { keys: "fail_unpaid", head: "付款失敗總額" }]
            },
            csvSummaryConfig: {
                column: [{ keys: "member_name", name: "客戶" }, { keys: "contract_name", name: "方案名稱" }, { keys: "all_times", name: "自動支付設定次數" }, { keys: "all_total", name: "應付總額" }, { keys: "success_times", name: "付款成功次數" }, { keys: "success_paid", name: "付款成功總額" }, { keys: "fail_times", name: "付款失敗次數" }, { keys: "fail_unpaid", name: "付款失敗總額" }]
            },
            relatedFilterWatcher: {
                studio_id: {
                    watcher: null,
                    options: "studioList",
                    vModel: "studioId",
                    trackBy: "id",
                    type: "single"
                },
                branch_ids: {
                    watcher: "studioId",
                    options: "branchList",
                    vModel: "branchIds",
                    trackBy: "id",
                    type: "multiple"
                },
                contract_ids: {
                    watcher: "studioId",
                    options: "contractList",
                    vModel: "contractIds",
                    trackBy: "id",
                    type: "multiple"
                }
            },
            multiFilter: {
                auto_pay_detail_status: {
                    watcher: null,
                    options: "stateList",
                    vModel: "statuses",
                    trackBy: "value",
                    type: "multiple"
                }
            }
        };
    },
    created: function created() {
        this.syncRelatedMultipleSelectByQuery({ vm: this, relatedFilterWatcher: this.relatedFilterWatcher });
        this.syncLocalMultipleSelectByQuery({ vm: this, multiFilter: this.multiFilter });
    },
    mounted: function mounted() {
        var _this = this;

        this.configuredRun(function () {
            _this.changeFilterOption({
                prop: 'studioId',
                value: {
                    id: _this.configureStates.studioId,
                    brand_name: ''
                }
            });
            _this.changeFilterOption({
                prop: 'branchId',
                value: _this.configureStates.branchId
            });
            if (_this.configureStates.isSeventeen) {
                return _this.fetchStudioList();
            }
            if (_this.configureStates.isBranch) {
                _this.branchIds = [{
                    'id': _this.configureStates.branchId,
                    'branch_name': ''
                }];
            }
            if (_this.configureStates.isStudio) {
                _this.fetchContractList({ 'studioId': _this.configureStates.studioId, 'withDelete': true });
            }
            if (_this.configureStates.isBranch) {
                _this.fetchContractList({ 'studioId': _this.configureStates.studioId, 'branchId': _this.configureStates.branchID, 'withDelete': true });
            }
        });
        this.syncDateAndDisplayByQuery({
            'diffType': 'months',
            'diffNumber': -1
        });
        var query = $17.getUrlQueryStrings();
        this.showCancel = query.show_cancel ? query.show_cancel : 0;
        this.onlyLast = query.only_last ? query.only_last : 0;
        this.viewMode = query.view_mode ? query.view_mode : 'detail';
    },

    watch: (_watch = {}, (0, _defineProperty3.default)(_watch, 'filterOptions.studioId', function filterOptionsStudioId(n, o) {
        if (this.configureStates.isSeventeen || this.configureStates.isStudio) {
            this.fetchBranchList({
                studioId: n.id
            });
        }
        if (this.configureStates.isSeventeen && n.id != 0) {
            this.fetchContractList({ 'studioId': n.id });
        }
    }), (0, _defineProperty3.default)(_watch, 'result', function result(newValue) {
        if (newValue.records.length > 0 && this.display === 'export') {
            if (this.viewMode == 'detail') {
                this.csvDetailConfig.jsonData = _lodash2.default.cloneDeep(newValue.records);
                this.$refs.smart_table_detail.downloadCsv();
            }
            if (this.viewMode == 'summary') {
                this.csvSummaryConfig.jsonData = _lodash2.default.cloneDeep(newValue.records);
                this.$refs.smart_table_summary.downloadCsv();
            }
        }
    }), _watch),
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        configureStates: function configureStates(state) {
            return state.webadmin.configure;
        }
    }), (0, _vuex.mapState)('webadmin/configure', ['configured', 'studioList', 'branchList', 'branchId', 'contractList']), (0, _vuex.mapState)('webadmin/baseReport', ['blockOpenStatus', 'dateOptions', 'filterOptions', 'queryPara', "ajaxing"]), {
        studioId: {
            get: function get() {
                return this.filterOptions.studioId;
            },
            set: function set(newValue) {
                var _this2 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                    return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.next = 2;
                                    return _this2.changeFilterOption({ 'prop': 'studioId', value: newValue });

                                case 2:
                                    _this2.cleanBranch();

                                    if (!newValue) {
                                        _context.next = 6;
                                        break;
                                    }

                                    _context.next = 6;
                                    return _this2.fetchBranchList({ studioId: newValue.id });

                                case 6:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this2);
                }))();
            }
        },
        branchIds: {
            get: function get() {
                return this.filterOptions.branchIds;
            },
            set: function set(newValue) {
                var _this3 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                    return _regenerator2.default.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    _context2.next = 2;
                                    return _this3.changeFilterOption({ 'prop': 'branchIds', value: newValue });

                                case 2:
                                case 'end':
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, _this3);
                }))();
            }
        },
        viewMode: {
            get: function get() {
                return this.$store.state.webadmin.baseReport.itemOptions.viewMode;
            },
            set: function set(value) {
                this.changeItemOption({
                    prop: 'viewMode',
                    value: value
                });
            }
        }
    }),
    methods: (0, _extends3.default)({
        updateFilterOption: function updateFilterOption(field) {
            var _this4 = this;

            return function (value) {
                return _this4.changeFilterOption({
                    prop: field,
                    value: value
                });
            };
        }
    }, (0, _vuex.mapActions)('webadmin/configure', ['configuredRun', 'fetchStudioList', 'fetchBranchList', 'fetchContractList']), (0, _vuex.mapActions)('webadmin/baseReport', ['beforeSubmit', 'toggleBlock', 'changeDateOption', 'changeFilterOption', 'cleanBranch', 'cleanBranchRelated', 'changeItemOption', 'setDetailTarget', 'keepQueryParam', "changeAjaxing", "syncDateAndDisplayByQuery", "syncLocalMultipleSelectByQuery", "syncRelatedMultipleSelectByQuery", "changeDisplay"]), {
        submitSearch: function submitSearch() {
            this.beforeSubmit();
            switch (this.display) {
                case "export":
                    this.changeFilterOption({ prop: "pageSize", value: 9999999 });
                    break;
                case "show":
                    this.changeFilterOption({ prop: "pageSize", value: 25 });
                    break;
                default:
                    null;
            }
            var params = this.getParams();

            this.keepQueryParam(params);
            $17.updateUrlQueryString(params);

            this.getQueryResultTotalAll(params);
            this.changePage(1);
        },
        getDetailResult: function getDetailResult(params) {
            var _this5 = this;

            this.changeAjaxing(true);
            this.$http.get('/adminapi/report/fetch_auto_pay_plan_report_detail', { params: params }).then(function (response) {
                _this5.result = response.data;
                _this5.$refs.report.setCustomers(response.data.member_ids);
                _this5.changeAjaxing(false);
            }, function (error) {
                _this5.changeAjaxing(false);
                $17.swal({
                    title: error.body.message,
                    type: 'warning'
                });
            });
        },
        getSummaryResult: function getSummaryResult(params) {
            var _this6 = this;

            this.changeAjaxing(true);
            this.$http.get('/adminapi/report/fetch_auto_pay_plan_report_total', { params: params }).then(function (response) {
                _this6.result = response.data;
                _this6.$refs.report.setCustomers(response.data.member_ids);
                _this6.changeAjaxing(false);
            }, function (error) {
                _this6.changeAjaxing(false);
                $17.swal({
                    title: error.body.message,
                    type: 'warning'
                });
            });
        },
        getQueryResultTotalAll: function getQueryResultTotalAll(params) {
            var _this7 = this;

            this.changeAjaxing(true);
            this.$http.get('/adminapi/report/fetch_auto_pay_plan_report_total_all', { params: params }).then(function (response) {
                _this7.total = response.data.total;
                _this7.changeAjaxing(false);
            }, function (error) {
                _this7.changeAjaxing(false);
                $17.swal({
                    title: error.body.message,
                    type: 'warning'
                });
            });
        },
        checkMode: function checkMode(mode) {
            return this.viewMode === mode;
        },
        getParams: function getParams() {
            return {
                'studio_id': this.studioId.id,
                'branch_ids': this.branchIds.map(function (item) {
                    return item.id;
                }),
                'contract_ids': this.contractIds.map(function (item) {
                    return item.id;
                }),
                'auto_pay_detail_status': this.statuses.map(function (item) {
                    return item.value;
                }),
                'start_date': this.dateOptions.startDate,
                'end_date': this.dateOptions.endDate,
                'show_cancel': this.showCancel,
                'only_last': this.onlyLast,
                'view_mode': this.viewMode
            };
        },
        changePage: function changePage(page) {
            var _this8 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
                var params;
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _this8.changeFilterOption({
                                    prop: "page",
                                    value: page
                                });

                                params = _this8.queryPara;


                                params.page_size = _this8.filterOptions.pageSize;
                                params.page = _this8.filterOptions.page;

                                if (_this8.filterOptions.studioId.id > 0) {
                                    _this8.reset();
                                    if (_this8.viewMode == 'detail') {
                                        _this8.getDetailResult(params);
                                    }
                                    if (_this8.viewMode == 'summary') {
                                        _this8.getSummaryResult(params);
                                    }
                                }

                            case 5:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this8);
            }))();
        },
        reset: function reset() {
            this.result = {};
            this.$refs.report.setCustomers("");
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"page-div\" _v-08570e0c=\"\">\n    <v-webadmin-report :block-open-status=\"blockOpenStatus\" :date-options=\"dateOptions\" :toggle-block=\"toggleBlock\" :change-date-option=\"changeDateOption\" :is-open-temporary-customer-button=\"true\" :studio-id=\"studioId\" ref=\"report\" :disable-submit=\"ajaxing\" :submit=\"submitSearch\" limit-date=\"365\" title=\"自動支付排程細節\" _v-08570e0c=\"\">\n        <div slot=\"second-block\" _v-08570e0c=\"\">\n            <div class=\"row\" _v-08570e0c=\"\">\n                <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen\" _v-08570e0c=\"\">\n                    <div class=\"form-group\" _v-08570e0c=\"\">\n                        <v-mutiselect :model.sync=\"studioId\" :options=\"studioList\" :preserve-search=\"true\" :placeholder=\"configureStates.ajaxing.studioList ? '品牌讀取中…' : '請選擇品牌'\" label=\"brand_name\" track-by=\"id\" _v-08570e0c=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n                <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen || configureStates.isStudio\" _v-08570e0c=\"\">\n                    <div class=\"form-group\" _v-08570e0c=\"\">\n                        <v-mutiselect :model.sync=\"branchIds\" :options=\"branchList\" :disabled=\"configureStates.ajaxing.branchList\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"false\" :placeholder=\"configureStates.ajaxing.branchList ? '場館讀取中…' : '全部場館'\" label=\"branch_name\" track-by=\"id\" :taggable=\"true\" tag-name=\"branch_name\" _v-08570e0c=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n                <div class=\"col-sm-6\" _v-08570e0c=\"\">\n                    <div class=\"form-group\" _v-08570e0c=\"\">\n                        <v-mutiselect :model.sync=\"contractIds\" :options=\"contractList\" :disabled=\"configureStates.ajaxing.contractList\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"true\" :placeholder=\"configureStates.ajaxing.branchList ? '方案讀取中…' : '全部方案'\" label=\"name\" track-by=\"id\" :taggable=\"false\" tag-name=\"name\" :max-height=\"300\" open-direction=\"bottom\" _v-08570e0c=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n                <div class=\"col-sm-6\" _v-08570e0c=\"\">\n                    <div class=\"form-group\" _v-08570e0c=\"\">\n                        <v-mutiselect :model.sync=\"statuses\" :options=\"stateList\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"true\" placeholder=\"全部自動支付結果\" label=\"name\" track-by=\"value\" :taggable=\"false\" tag-name=\"name\" :max-height=\"300\" open-direction=\"bottom\" _v-08570e0c=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n                <div class=\"col-sm-6\" _v-08570e0c=\"\">\n                    <div class=\"form-group col-sm-6\" _v-08570e0c=\"\">\n                        <span _v-08570e0c=\"\">\n                        <input type=\"checkbox\" v-model=\"onlyLast\" :false-value=\"0\" :true-value=\"1\" id=\"onlyLast\" _v-08570e0c=\"\">\n                        <label for=\"onlyLast\" _v-08570e0c=\"\">只顯示最後一期</label>\n                    </span>\n                    </div>\n                    <div class=\"form-group col-sm-6\" _v-08570e0c=\"\">\n                        <span _v-08570e0c=\"\">\n                            <input type=\"checkbox\" v-model=\"showCancel\" :false-value=\"0\" :true-value=\"1\" id=\"showCancel\" _v-08570e0c=\"\">\n                            <label for=\"showCancel\" _v-08570e0c=\"\">顯示取消</label>\n                        </span>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div slot=\"third-block\" _v-08570e0c=\"\">\n            <div class=\"row\" _v-08570e0c=\"\">\n                <div class=\"col-sm-6\" _v-08570e0c=\"\">\n                    <div class=\"form-group\" _v-08570e0c=\"\">\n                        <label _v-08570e0c=\"\">\n                            <input name=\"view\" type=\"radio\" value=\"detail\" v-model=\"viewMode\" checked=\"\" _v-08570e0c=\"\"> 顯示細節\n                        </label>\n                        <label _v-08570e0c=\"\">\n                            <input name=\"view\" type=\"radio\" value=\"summary\" v-model=\"viewMode\" _v-08570e0c=\"\"> 顯示總和\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div slot=\"fourth-block\" _v-08570e0c=\"\">\n            <div class=\"row\" _v-08570e0c=\"\">\n                <div class=\"col-sm-6\" _v-08570e0c=\"\">\n                    <div class=\"form-group\" _v-08570e0c=\"\">\n                        <label _v-08570e0c=\"\">\n                            <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"show\" checked=\"\" _v-08570e0c=\"\"> 顯示於網頁\n                        </label>\n                        <label _v-08570e0c=\"\">\n                            <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"export\" _v-08570e0c=\"\"> 匯出 CSV\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div> \n    </v-webadmin-report>\n    <div class=\"m-top-10\" v-show=\"display == 'show'\" _v-08570e0c=\"\">\n        <div class=\"row total-list\" _v-08570e0c=\"\">\n            <h4 _v-08570e0c=\"\">總計:{{total}}</h4>\n        </div>\n        <v-smart-table v-if=\"viewMode=='summary'\" ref=\"smart_table_summary\" :table-config=\"tableSummaryConfig\" :csv-config=\"csvSummaryConfig\" :is-ajaxing=\"ajaxing\" :data=\"result\" :page-sync-url-query=\"false\" @change-page=\"changePage\" _v-08570e0c=\"\"></v-smart-table>\n        <v-smart-table v-if=\"viewMode=='detail'\" ref=\"smart_table_detail\" :table-config=\"tableDetailConfig\" :csv-config=\"csvDetailConfig\" :is-ajaxing=\"ajaxing\" :data=\"result\" :page-sync-url-query=\"false\" @change-page=\"changePage\" _v-08570e0c=\"\"></v-smart-table>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.page-div[_v-08570e0c] {\n  padding: 0px 15px;\n  margin-bottom: 15px; }\n\n/* line 7, stdin */\n.table-div[_v-08570e0c] {\n  padding: 20px 0px; }\n\n/* line 10, stdin */\n.total-list[_v-08570e0c] {\n  margin-left: 10px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-08570e0c", module.exports)
  } else {
    hotAPI.update("_v-08570e0c", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/defineProperty":65,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1347:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n/* line 2, stdin */\n.form-title[_v-7b050b81] {\n  font-size: 16px;\n  font-weight: bold;\n  display: inline-block;\n  width: 60px; }\n\n/* line 9, stdin */\n.summary[_v-7b050b81] {\n  font-size: 18px;\n  font-weight: 500;\n  margin-right: 2em;\n  display: inline-block; }\n\n/* line 16, stdin */\n#v-base-table .thead[_v-7b050b81] {\n  background-color: #c0c0c0; }\n")
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _watch;

var _vuex = require("vuex");

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      tableConfig: {
        columns: [{ keys: "branch_name", head: "場館名稱" }, { keys: "name", head: "客戶姓名" }, { keys: "phone", head: "手機" }, { keys: "email", head: "信箱" }, { keys: "total_duration_all_periods", head: "查詢範圍內期數" }, { keys: "total_duration_periods", head: "查詢範圍內應收期數" }, { keys: "total_duration_all", head: "查詢範圍內應收金額" }, { keys: "total_duration_real_pay_periods", head: "查詢範圍內實收期數" }, { keys: "total_duration_real_pay_money", head: "查詢範圍內實收金額" }, { keys: "total_duration_unpaid_periods", head: "查詢範圍內未收期數" }, { keys: "total_duration_unpaid_money", head: "查詢範圍內未收金額" }, { keys: "total_periods", head: "自動支付計畫總期數" }, { keys: "total_all", head: "自動支付計畫總價值" }, { keys: "total_paid", head: "累計已結帳" }, { keys: "total_unfinished", head: "累計尚未完成" }, { keys: "category", head: "支付模式" }, { keys: "renewal_type", head: "自動延展計畫狀態" }, { keys: "id",
          head: "動作",
          html: function html(item) {
            return "<a @click.prevent.stop=\"clickHandler('view-item')\">\u67E5\u770B</a>";
          }
        }]
      },
      csvConfig: {
        column: [{ keys: "branch_name", name: "場館名稱" }, { keys: "name", name: "客戶姓名" }, { keys: "phone", name: "手機" }, { keys: "email", name: "信箱" }, { keys: "total_duration_all_periods", name: "查詢範圍內期數" }, { keys: "total_duration_periods", name: "查詢範圍內應收期數" }, { keys: "total_duration_all", name: "查詢範圍內應收金額" }, { keys: "total_duration_real_pay_periods", name: "查詢範圍內實收期數" }, { keys: "total_duration_real_pay_money", name: "查詢範圍內實收金額" }, { keys: "total_duration_real_unpaid_periods", name: "查詢範圍內未收期數" }, { keys: "total_duration_real_unpaid_money", name: "查詢範圍內未收金額" }, { keys: "total_periods", name: "自動支付計畫總期數" }, { keys: "total_all", name: "自動支付計畫總價值" }, { keys: "total_paid", name: "累計已結帳" }, { keys: "total_unfinished", name: "累計尚未完成" }, { keys: "category", name: "支付模式" }, { keys: "renewal_type", name: "自動延展計畫狀態" }]
      },
      relatedFilterWatcher: {
        studio_id: {
          watcher: null,
          options: "studioList",
          vModel: "studioId",
          trackBy: "id",
          type: "single"
        },
        branch_id: {
          watcher: null,
          options: "branchList",
          vModel: "branchIds",
          trackBy: "id",
          type: "single"
        }
      },
      multiFilter: {
        terminate_status: {
          watcher: null,
          options: "statuses",
          vModel: "terminate_status",
          trackBy: "value",
          type: "single"
        },
        category: {
          watcher: null,
          options: "categories",
          vModel: "category",
          trackBy: "value",
          type: "single"
        }
      },
      result: {},
      summary: {},
      localFilter: {
        terminate_status: {
          name: "全部",
          value: null
        },
        category: {
          name: "全部",
          value: null
        }
      },
      categories: [{
        name: "全部",
        value: null
      }, {
        name: "訂閱",
        value: "subscribe"
      }, {
        name: "自動支付",
        value: "classic"
      }],
      statuses: [{
        name: "全部",
        value: null
      }, {
        name: "無",
        value: "none"
      }, {
        name: "啟用",
        value: "renewal"
      }, {
        name: "終止",
        value: "terminated"
      }],
      export: []
    };
  },
  created: function created() {
    this.syncRelatedMultipleSelectByQuery({ vm: this, relatedFilterWatcher: this.relatedFilterWatcher });
    this.syncLocalMultipleSelectByQuery({ vm: this, multiFilter: this.multiFilter });
  },
  mounted: function mounted() {
    var _this = this;

    this.configuredRun(function () {
      _this.changeFilterOption({
        prop: "studioId",
        value: {
          id: _this.configureStates.studioId,
          brand_name: ""
        }
      });
      _this.changeFilterOption({
        prop: "branchIds",
        value: _this.configureStates.branchIds
      });
      if (_this.configureStates.isSeventeen) {
        return _this.fetchStudioList();
      }
      if (_this.configureStates.isBranch) {
        _this.branchIds = [{
          id: _this.configureStates.branchIds,
          branch_name: ""
        }];
      }
    });
    this.syncDateAndDisplayByQuery({
      'diffType': 'months',
      'diffNumber': -1
    });
  },

  watch: (_watch = {}, (0, _defineProperty3.default)(_watch, "filterOptions.studioId", function filterOptionsStudioId(n, o) {
    if (this.configureStates.isSeventeen || this.configureStates.isStudio) {
      this.fetchBranchList({
        studioId: n.id
      });
    }
  }), (0, _defineProperty3.default)(_watch, "export", function _export(newV) {
    if (newV && newV.length > 0) {
      this.csvConfig.jsonData = this.mapStatus(newV);
      this.$refs.smart_table.downloadCsv();
    }
  }), _watch),
  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
    configureStates: function configureStates(state) {
      return state.webadmin.configure;
    }
  }), (0, _vuex.mapState)("webadmin/configure", ["configured", "studioList", "branchList", "serviceProviderList", "serviceList", "branchId"]), (0, _vuex.mapState)("webadmin/baseReport", ["blockOpenStatus", "dateOptions", "filterOptions", "itemOptions", "ajaxing", "list", "total", "pageMeta", "queryPara"]), {
    studioId: {
      get: function get() {
        return this.filterOptions.studioId;
      },
      set: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(newValue) {
          return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return this.$store.dispatch("webadmin/baseReport/changeFilterOption", {
                    prop: "studioId",
                    value: newValue
                  });

                case 2:
                  this.cleanBranch();

                  if (!newValue) {
                    _context.next = 6;
                    break;
                  }

                  _context.next = 6;
                  return this.fetchBranchList({ studioId: newValue.id });

                case 6:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function set(_x) {
          return _ref.apply(this, arguments);
        }

        return set;
      }()
    },
    branchIds: {
      get: function get() {
        return this.filterOptions.branchIds;
      },
      set: function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(newValue) {
          return _regenerator2.default.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return this.$store.dispatch("webadmin/baseReport/changeFilterOption", {
                    prop: "branchIds",
                    value: newValue
                  });

                case 2:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        function set(_x2) {
          return _ref2.apply(this, arguments);
        }

        return set;
      }()
    },
    terminate_status: {
      get: function get() {
        return this.localFilter.terminate_status;
      },
      set: function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(newValue) {
          return _regenerator2.default.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  this.localFilter.terminate_status = newValue;

                case 1:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, this);
        }));

        function set(_x3) {
          return _ref3.apply(this, arguments);
        }

        return set;
      }()
    },
    category: {
      get: function get() {
        return this.localFilter.category;
      },
      set: function () {
        var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(newValue) {
          return _regenerator2.default.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  this.localFilter.category = newValue;

                case 1:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, this);
        }));

        function set(_x4) {
          return _ref4.apply(this, arguments);
        }

        return set;
      }()
    },
    display: {
      get: function get() {
        return this.$store.state.webadmin.baseReport.display;
      },
      set: function () {
        var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(newValue) {
          return _regenerator2.default.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _context5.next = 2;
                  return this.$store.dispatch("webadmin/baseReport/changeDisplay", newValue);

                case 2:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5, this);
        }));

        function set(_x5) {
          return _ref5.apply(this, arguments);
        }

        return set;
      }()
    },
    tableConfigModify: function tableConfigModify() {
      var configs = this.tableConfig;
      if (this.configureStates.isSeventeen) {
        configs.columns.unshift({ keys: "studio_name", head: "品牌名稱" });
      }

      return configs;
    },
    csvConfigModify: function csvConfigModify() {
      var configs = this.csvConfig;
      if (this.configureStates.isSeventeen) {
        configs.column.unshift({ keys: "studio_name", name: "品牌名稱" });
      }

      return configs;
    }
  }),
  methods: (0, _extends3.default)({
    getParam: function getParam() {
      return {
        'start_date': this.dateOptions.startDate,
        'end_date': this.dateOptions.endDate,
        'display': this.display,
        'studio_id': this.filterOptions.studioId && this.filterOptions.studioId.id ? this.filterOptions.studioId.id : null,
        'branch_id': this.filterOptions.branchIds && this.filterOptions.branchIds.id ? this.filterOptions.branchIds.id : null,
        'terminate_status': this.localFilter.terminate_status && this.localFilter.terminate_status.value ? this.localFilter.terminate_status.value : null,
        'category': this.localFilter.category && this.localFilter.category.value ? this.localFilter.category.value : null
      };
    },
    submitSearch: function submitSearch() {
      switch (this.display) {
        case "export":
          this.changeFilterOption({ prop: "pageSize", value: 9999999 });
          break;
        case "show":
          this.changeFilterOption({ prop: "pageSize", value: 25 });
          break;
        default:
          null;
      }
      var params = this.getParam();
      $17.updateUrlQueryString(params);
      this.keepQueryParam(params);

      var paramsTotal = this.queryPara;
      paramsTotal.page_size = 9999999;

      this.getQueryResultTotal(paramsTotal);
      this.changePage(1);
    }
  }, (0, _vuex.mapActions)("webadmin/configure", ["configuredRun", "fetchStudioList", "fetchBranchList"]), (0, _vuex.mapActions)("webadmin/baseReport", ["submit", "toggleBlock", "changeDateOption", "changeFilterOption", "changeItemOption", "cleanBranch", "changeAjaxing", "changeDateOptionAfter", "syncDateAndDisplayByQuery", "syncLocalMultipleSelectByQuery", "syncRelatedMultipleSelectByQuery", "changeDisplay", "keepQueryParam"]), {
    mapStatus: function mapStatus(data) {
      var newData = _lodash2.default.cloneDeep(data);
      return newData;
    },
    getQueryResultTotal: function getQueryResultTotal(params) {
      var _this2 = this;

      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6() {
        return _regenerator2.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this2.summary = {};
                _this2.$http.get("/adminapi/report/auto-pay-plan/summary-total", {
                  params: params
                }).then(function (response) {
                  if (_this2.display == 'export') {}

                  if (_this2.display == 'show') {
                    _this2.summary = response.data.summary;
                  }
                }, function (error) {
                  $17.swal({
                    title: error.body.message,
                    type: "warning"
                  });
                });

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this2);
      }))();
    },
    getQueryResult: function getQueryResult(params) {
      var _this3 = this;

      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7() {
        return _regenerator2.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this3.result = {};
                _this3.changeAjaxing(true);
                _context7.next = 4;
                return _this3.$http.get("/adminapi/report/auto-pay-plan/summary-detail", {
                  params: params
                }).then(function (response) {
                  if (_this3.display == 'export') {
                    _this3.export = response.data.records;
                  }

                  if (_this3.display == 'show') {
                    _this3.result = response.data;
                  }
                }, function (error) {
                  $17.swal({
                    title: error.body.message,
                    type: "warning"
                  });
                });

              case 4:
                _this3.changeAjaxing(false);

              case 5:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this3);
      }))();
    },
    changePage: function changePage(page) {
      var _this4 = this;

      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8() {
        var params;
        return _regenerator2.default.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _this4.changeFilterOption({
                  prop: "page",
                  value: page
                });

                params = _this4.queryPara;


                params.page_size = _this4.filterOptions.pageSize;
                params.page = _this4.filterOptions.page;

                _context8.next = 6;
                return _this4.getQueryResult(params);

              case 6:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this4);
      }))();
    },
    clickHtmlHandler: function clickHtmlHandler(item) {
      window.open("/webadmin/member_studio?f[id]=" + item.row.member_id, '_blank');
    }
  })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"page-div\" _v-7b050b81=\"\">\n  <v-webadmin-report :block-open-status=\"blockOpenStatus\" :date-options=\"dateOptions\" :toggle-block=\"toggleBlock\" :change-date-option=\"changeDateOptionAfter\" :submit=\"submitSearch\" :disable-submit=\"ajaxing\" limit-date=\"730\" title=\"自動支付計畫總覽\" _v-7b050b81=\"\">\n    <div slot=\"second-block\" _v-7b050b81=\"\">\n      <div class=\"filters\" _v-7b050b81=\"\">\n        <div class=\"row\" _v-7b050b81=\"\">\n          <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen\" _v-7b050b81=\"\">\n            <div class=\"form-group\" _v-7b050b81=\"\">\n              <v-mutiselect :model.sync=\"studioId\" :options=\"studioList\" :preserve-search=\"true\" :placeholder=\"\n                  configureStates.ajaxing.studioList\n                    ? '品牌讀取中…'\n                    : '全部品牌'\n                \" label=\"brand_name\" track-by=\"id\" _v-7b050b81=\"\">\n              </v-mutiselect>\n            </div>\n          </div>\n          <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen || configureStates.isStudio\" _v-7b050b81=\"\">\n            <div class=\"form-group\" _v-7b050b81=\"\">\n              <v-mutiselect :model.sync=\"branchIds\" :options=\"branchList\" :multiple=\"false\" :close-on-select=\"true\" :clear-on-select=\"false\" :hide-selected=\"false\" :preserve-search=\"true\" :searchable=\"false\" :placeholder=\"\n                  configureStates.ajaxing.branchList\n                    ? '場館讀取中…'\n                    : '全部場館'\n                \" label=\"branch_name\" track-by=\"id\" tag-name=\"branch_name\" :max-height=\"500\" _v-7b050b81=\"\">\n              </v-mutiselect>\n            </div>\n          </div>\n          <div class=\"col-sm-6\" _v-7b050b81=\"\">\n            <div class=\"form-group\" _v-7b050b81=\"\">\n              <v-mutiselect :model.sync=\"localFilter.category\" :options=\"categories\" :multiple=\"false\" :close-on-select=\"true\" :clear-on-select=\"false\" :hide-selected=\"false\" :preserve-search=\"true\" :searchable=\"false\" placeholder=\"支付模式\" label=\"name\" track-by=\"value\" :max-height=\"500\" _v-7b050b81=\"\">\n              </v-mutiselect>\n            </div>\n          </div>\n          <div class=\"col-sm-6\" _v-7b050b81=\"\">\n            <div class=\"form-group\" _v-7b050b81=\"\">\n              <v-mutiselect :model.sync=\"localFilter.terminate_status\" :options=\"statuses\" :multiple=\"false\" :close-on-select=\"true\" :clear-on-select=\"false\" :hide-selected=\"false\" :preserve-search=\"true\" :searchable=\"false\" placeholder=\"自動延展計畫狀態\" label=\"name\" track-by=\"value\" :max-height=\"500\" _v-7b050b81=\"\">\n              </v-mutiselect>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div slot=\"fourth-block\" _v-7b050b81=\"\">\n              <div class=\"row\" _v-7b050b81=\"\">\n                  <div class=\"col-sm-6\" _v-7b050b81=\"\">\n                      <div class=\"form-group\" _v-7b050b81=\"\">\n                          <label _v-7b050b81=\"\">\n                              <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"show\" checked=\"\" _v-7b050b81=\"\"> 顯示於網頁\n                          </label>\n                          <label _v-7b050b81=\"\">\n                              <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"export\" _v-7b050b81=\"\"> 匯出 CSV\n                          </label>\n                      </div>\n                  </div>\n              </div>\n          </div>\n  </v-webadmin-report>\n  <div v-show=\"display === 'show'\" _v-7b050b81=\"\">\n    <div class=\"m-top-30\" _v-7b050b81=\"\">\n      <div class=\"summary\" _v-7b050b81=\"\">\n        應收總金額 (排程): {{summary.should_pay_total}}\n      </div>\n      <div class=\"summary\" _v-7b050b81=\"\">\n        實收總金額 (訂單): {{summary.real_pay_money}}\n      </div>\n      <div class=\"summary\" _v-7b050b81=\"\">\n        未收總金額 (排程): {{summary.unpaid_total}}\n      </div>\n    </div>\n    <div class=\"m-top-10\" _v-7b050b81=\"\">\n      <v-smart-table ref=\"smart_table\" :table-config=\"tableConfigModify\" :csv-config=\"csvConfigModify\" :is-ajaxing=\"ajaxing\" :data=\"result\" :page-sync-url-query=\"false\" @change-page=\"changePage\" @html-click-callback=\"clickHtmlHandler\" _v-7b050b81=\"\"></v-smart-table>\n    </div>\n  </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n/* line 2, stdin */\n.form-title[_v-7b050b81] {\n  font-size: 16px;\n  font-weight: bold;\n  display: inline-block;\n  width: 60px; }\n\n/* line 9, stdin */\n.summary[_v-7b050b81] {\n  font-size: 18px;\n  font-weight: 500;\n  margin-right: 2em;\n  display: inline-block; }\n\n/* line 16, stdin */\n#v-base-table .thead[_v-7b050b81] {\n  background-color: #c0c0c0; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-7b050b81", module.exports)
  } else {
    hotAPI.update("_v-7b050b81", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/defineProperty":65,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1348:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _watch;

var _vuex = require("vuex");

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      tableConfig: {
        columns: [{ keys: "id", head: "費用單編號" }, { keys: "studio_name", head: "品牌名稱" }, { keys: "branch_name", head: "場館名稱" }, { keys: "year_month", head: "年月份" }, { keys: "amount", head: "費用總額" }, { keys: "id",
          head: "明細",
          html: function html(item) {
            return "<a @click.prevent.stop=\"clickHandler('getFile')\">" + item.file_name + "</a>";
          }
        }]
      },
      csvConfig: {
        column: [{ keys: "id", name: "費用單編號" }, { keys: "studio_name", name: "品牌名稱" }, { keys: "branch_name", name: "場館名稱" }, { keys: "year_month", name: "年月份" }, { keys: "amount", name: "費用總額" }],
        fileName: "client-charge-" + moment().format("YYYYMMDDHHmmss")
      },
      relatedFilterWatcher: {
        studio_id: {
          watcher: null,
          options: "studioList",
          vModel: "studioId",
          trackBy: "id",
          type: "single"
        },
        branch_id: {
          watcher: null,
          options: "branchList",
          vModel: "branchIds",
          trackBy: "id",
          type: "single"
        },
        billing_system_charge_id: {
          watcher: null,
          options: "billingSystemCharges",
          vModel: "billingSystemCharge",
          trackBy: "id",
          type: "single"
        }
      },
      result: {},
      export: [],
      billingSystemCharges: [],
      billingSystemCharge: null,
      onlyShowNoneZero: false
    };
  },
  created: function created() {
    this.syncRelatedMultipleSelectByQuery({ vm: this, relatedFilterWatcher: this.relatedFilterWatcher });
    this.changeDateOption({
      prop: "minimumView",
      value: 'month'
    });

    this.changeDateOption({
      prop: "formatString",
      value: 'YYYY/MM'
    });
  },
  mounted: function mounted() {
    var _this = this;

    this.configuredRun(function () {
      _this.changeFilterOption({
        prop: "studioId",
        value: {
          id: _this.configureStates.studioId,
          brand_name: ""
        }
      });
      _this.changeFilterOption({
        prop: "branchIds",
        value: _this.configureStates.branchIds
      });
      if (_this.configureStates.isSeventeen) {
        return _this.fetchStudioList();
      }
      if (_this.configureStates.isBranch) {
        _this.branchIds = [{
          id: _this.configureStates.branchIds,
          branch_name: ""
        }];
      }
    });
    this.syncDateAndDisplayByQuery({
      'diffType': 'months',
      'diffNumber': 0,
      'formate': "YYYY/MM"
    });
    var query = $17.getUrlQueryStrings();

    this.onlyShowNoneZero = query.only_show_none_zero && query.only_show_none_zero == '1' ? true : false;
    this.getCharge();
  },

  watch: (_watch = {}, (0, _defineProperty3.default)(_watch, "filterOptions.studioId", function filterOptionsStudioId(n, o) {
    if (this.configureStates.isSeventeen || this.configureStates.isStudio) {
      this.fetchBranchList({
        studioId: n.id
      });
    }
  }), (0, _defineProperty3.default)(_watch, "export", function _export(newV) {
    if (newV && newV.length > 0) {
      this.csvConfig.jsonData = this.mapStatus(newV);
      this.$refs.smart_table.downloadCsv();
    }
  }), _watch),
  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
    configureStates: function configureStates(state) {
      return state.webadmin.configure;
    }
  }), (0, _vuex.mapState)("webadmin/configure", ["configured", "studioList", "branchList", "serviceProviderList", "serviceList", "branchId"]), (0, _vuex.mapState)("webadmin/baseReport", ["blockOpenStatus", "dateOptions", "filterOptions", "itemOptions", "ajaxing", "list", "total", "pageMeta", "queryPara"]), {
    studioId: {
      get: function get() {
        return this.filterOptions.studioId;
      },
      set: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(newValue) {
          return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return this.$store.dispatch("webadmin/baseReport/changeFilterOption", {
                    prop: "studioId",
                    value: newValue
                  });

                case 2:
                  this.cleanBranch();

                  if (!newValue) {
                    _context.next = 6;
                    break;
                  }

                  _context.next = 6;
                  return this.fetchBranchList({ studioId: newValue.id });

                case 6:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function set(_x) {
          return _ref.apply(this, arguments);
        }

        return set;
      }()
    },
    branchIds: {
      get: function get() {
        return this.filterOptions.branchIds;
      },
      set: function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(newValue) {
          return _regenerator2.default.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return this.$store.dispatch("webadmin/baseReport/changeFilterOption", {
                    prop: "branchIds",
                    value: newValue
                  });

                case 2:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        function set(_x2) {
          return _ref2.apply(this, arguments);
        }

        return set;
      }()
    },
    display: {
      get: function get() {
        return this.$store.state.webadmin.baseReport.display;
      },
      set: function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(newValue) {
          return _regenerator2.default.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return this.$store.dispatch("webadmin/baseReport/changeDisplay", newValue);

                case 2:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, this);
        }));

        function set(_x3) {
          return _ref3.apply(this, arguments);
        }

        return set;
      }()
    }
  }),
  methods: (0, _extends3.default)({
    getParam: function getParam() {
      return {
        'start_date': this.dateOptions.startDate,
        'end_date': this.dateOptions.endDate,
        'display': this.display,
        'studio_id': this.filterOptions.studioId && this.filterOptions.studioId.id ? this.filterOptions.studioId.id : null,
        'branch_id': this.filterOptions.branchIds && this.filterOptions.branchIds.id ? this.filterOptions.branchIds.id : null,
        "billing_system_charge_id": this.billingSystemCharge ? this.billingSystemCharge.id : null,
        "only_show_none_zero": this.onlyShowNoneZero ? 1 : 0
      };
    },
    submitSearch: function submitSearch() {
      switch (this.display) {
        case "export":
          this.changeFilterOption({ prop: "pageSize", value: 9999999 });
          break;
        case "show":
          this.changeFilterOption({ prop: "pageSize", value: 25 });
          break;
        default:
          null;
      }
      var params = this.getParam();
      $17.updateUrlQueryString(params);
      this.keepQueryParam(params);

      var paramsTotal = this.queryPara;
      paramsTotal.page_size = 9999999;

      this.changePage(1);
    }
  }, (0, _vuex.mapActions)("webadmin/configure", ["configuredRun", "fetchStudioList", "fetchBranchList"]), (0, _vuex.mapActions)("webadmin/baseReport", ["submit", "toggleBlock", "changeDateOption", "changeFilterOption", "changeItemOption", "cleanBranch", "changeAjaxing", "changeDateOptionAfter", "syncDateAndDisplayByQuery", "syncLocalMultipleSelectByQuery", "syncRelatedMultipleSelectByQuery", "changeDisplay", "keepQueryParam"]), {
    mapStatus: function mapStatus(data) {
      var newData = _lodash2.default.cloneDeep(data);
      return newData;
    },
    getCharge: function getCharge() {
      var _this2 = this;

      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this2.$http.get("/adminapi/report/fetch-billing-system-charge", {}).then(function (response) {
                  _this2.billingSystemCharges = response.data;
                }, function (error) {
                  $17.swal({
                    title: error.body.message,
                    type: "warning"
                  });
                });

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this2);
      }))();
    },
    getQueryResult: function getQueryResult(params) {
      var _this3 = this;

      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5() {
        return _regenerator2.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this3.result = {};
                _this3.changeAjaxing(true);
                _context5.next = 4;
                return _this3.$http.get("/adminapi/report/fetch-billing-system-period-charge", {
                  params: params
                }).then(function (response) {
                  if (_this3.display == 'export') {
                    _this3.export = response.data.records;
                  }

                  if (_this3.display == 'show') {
                    _this3.result = response.data;
                  }
                }, function (error) {
                  $17.swal({
                    title: error.body.message,
                    type: "warning"
                  });
                });

              case 4:
                _this3.changeAjaxing(false);

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this3);
      }))();
    },
    changePage: function changePage(page) {
      var _this4 = this;

      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6() {
        var params;
        return _regenerator2.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this4.changeFilterOption({
                  prop: "page",
                  value: page
                });

                params = _this4.queryPara;


                params.page_size = _this4.filterOptions.pageSize;
                params.page = _this4.filterOptions.page;

                _context6.next = 6;
                return _this4.getQueryResult(params);

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this4);
      }))();
    },
    clickHtmlHandler: function clickHtmlHandler(item) {
      this.getFile(item.row.id, item.row.file_name);
    },
    getFile: function getFile(id, file_name) {
      this.$http.get("/adminapi/report/fetch-billing-system-period-charge-file?id=" + id, {
        headers: this.headers,
        responseType: 'arraybuffer',
        'Accept': 'application/pdf'
      }).then(function (response) {
        var url = window.URL.createObjectURL(new Blob([response.data]));
        var link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', file_name);
        document.body.appendChild(link);
        link.click();
      }, function (error) {
        $17.swal({
          title: '檔案不存在',
          type: "warning"
        });
      });
    }
  })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"page-div\" _v-552caa74=\"\">\n  <v-webadmin-report :block-open-status=\"blockOpenStatus\" :date-options=\"dateOptions\" :toggle-block=\"toggleBlock\" :change-date-option=\"changeDateOptionAfter\" :submit=\"submitSearch\" limit-date=\"730\" title=\"平台費用結算\" _v-552caa74=\"\">\n    <div slot=\"second-block\" _v-552caa74=\"\">\n      <div class=\"filters\" _v-552caa74=\"\">\n        <div class=\"row\" _v-552caa74=\"\">\n          <div class=\"col-sm-6\" _v-552caa74=\"\">\n            <div class=\"form-group\" _v-552caa74=\"\">\n              <v-mutiselect :model.sync=\"billingSystemCharge\" :options=\"billingSystemCharges\" :multiple=\"false\" :close-on-select=\"true\" :clear-on-select=\"false\" :hide-selected=\"false\" :preserve-search=\"true\" :searchable=\"false\" placeholder=\"平台費用\" label=\"name\" track-by=\"id\" :max-height=\"500\" _v-552caa74=\"\">\n              </v-mutiselect>\n            </div>\n          </div>\n          <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen\" _v-552caa74=\"\">\n            <div class=\"form-group\" _v-552caa74=\"\">\n              <v-mutiselect :model.sync=\"studioId\" :options=\"studioList\" :preserve-search=\"true\" :placeholder=\"\n                  configureStates.ajaxing.studioList\n                    ? '品牌讀取中…'\n                    : '全部品牌'\n                \" label=\"brand_name\" track-by=\"id\" _v-552caa74=\"\">\n              </v-mutiselect>\n            </div>\n          </div>\n          <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen || configureStates.isStudio\" _v-552caa74=\"\">\n            <div class=\"form-group\" _v-552caa74=\"\">\n              <v-mutiselect :model.sync=\"branchIds\" :options=\"branchList\" :multiple=\"false\" :close-on-select=\"true\" :clear-on-select=\"false\" :hide-selected=\"false\" :preserve-search=\"true\" :searchable=\"false\" :placeholder=\"\n                  configureStates.ajaxing.branchList\n                    ? '場館讀取中…'\n                    : '全部場館'\n                \" label=\"branch_name\" track-by=\"id\" tag-name=\"branch_name\" :max-height=\"500\" _v-552caa74=\"\">\n              </v-mutiselect>\n            </div>\n          </div>\n          <div class=\"col-sm-6\" _v-552caa74=\"\">\n            <div class=\"form-group\" _v-552caa74=\"\">\n              <label _v-552caa74=\"\">\n                <input type=\"checkbox\" v-model=\"onlyShowNoneZero\" _v-552caa74=\"\">\n                不顯示費用為零\n              </label>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div slot=\"fourth-block\" _v-552caa74=\"\">\n              <div class=\"row\" _v-552caa74=\"\">\n                  <div class=\"col-sm-6\" _v-552caa74=\"\">\n                      <div class=\"form-group\" _v-552caa74=\"\">\n                          <label _v-552caa74=\"\">\n                              <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"show\" checked=\"\" _v-552caa74=\"\"> 顯示於網頁\n                          </label>\n                          <label _v-552caa74=\"\">\n                              <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"export\" _v-552caa74=\"\"> 匯出CSV\n                          </label>\n                      </div>\n                  </div>\n              </div>\n          </div>\n  </v-webadmin-report>\n  <div v-show=\"display === 'show'\" _v-552caa74=\"\">\n    <div class=\"m-top-10\" _v-552caa74=\"\">\n      <v-smart-table ref=\"smart_table\" :table-config=\"tableConfig\" :csv-config=\"csvConfig\" :is-ajaxing=\"ajaxing\" :data=\"result\" :page-sync-url-query=\"false\" @change-page=\"changePage\" @html-click-callback=\"clickHtmlHandler\" _v-552caa74=\"\"></v-smart-table>\n    </div>\n  </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-552caa74", module.exports)
  } else {
    hotAPI.update("_v-552caa74", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/defineProperty":65,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vuex":803}],1349:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.page-div[_v-23ab1c5d] {\n  padding: 0px 15px;\n  margin-bottom: 15px; }\n\n/* line 7, stdin */\n.m-l-15[_v-23ab1c5d] {\n  margin-left: 15px; }\n\n/* line 11, stdin */\n.table-div[_v-23ab1c5d] {\n  padding: 20px 0px; }\n\n/* line 15, stdin */\n.form-title[_v-23ab1c5d] {\n  font-size: 16px;\n  font-weight: bold;\n  display: inline-block;\n  width: 60px; }\n\n/* line 22, stdin */\n.negative-number[_v-23ab1c5d] {\n  color: red; }\n\n/* line 26, stdin */\n.cube[_v-23ab1c5d] {\n  max-width: 80px;\n  float: left;\n  margin: 12px 24px;\n  font-weight: bold;\n  font-size: 18px; }\n\n/* line 33, stdin */\n.total-list[_v-23ab1c5d] {\n  width: 100%;\n  border: 1px solid;\n  margin: 30px 0px; }\n\n/* line 38, stdin */\n.total-list[_v-23ab1c5d]:after {\n  clear: both; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _vuex = require('vuex');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            display: 'show',
            memberList: [],
            serviceType: {
                name: "包含課程及服務",
                value: 'all'
            },
            serviceTypeList: [{
                name: "包含課程及服務",
                value: 'all'
            }, {
                name: "只包含課程",
                value: 'class'
            }, {
                name: "只包含服務",
                value: 'service'
            }],
            bookingWay: {
                name: "包含方案及單次",
                value: 'all'
            },
            bookingWayList: [{
                name: "包含方案及單次",
                value: 'all'
            }, {
                name: "包含方案",
                value: 'contract'
            }, {
                name: "包含單次",
                value: 'single'
            }],
            bookingConfirm: {
                name: "包含缺席及遲退",
                value: 'all'
            },
            bookingConfirmList: [{
                name: "包含缺席及遲退",
                value: 'all'
            }, {
                name: "只包含缺席",
                value: 'absence'
            }, {
                name: "只包含遲退",
                value: 'cancel_late'
            }],
            onlineBooking: {
                name: "包含允許及停止線上預約",
                value: 'all'
            },
            onlineBookingList: [{
                name: "包含允許及停止線上預約",
                value: 'all'
            }, {
                name: "只包含允許線上預約",
                value: 'allow'
            }, {
                name: "只包含停止線上預約",
                value: 'ban'
            }]
        };
    },
    mounted: function mounted() {
        var _this = this;

        this.configuredRun(function () {
            _this.changeFilterOption({
                prop: 'studioId',
                value: {
                    id: _this.configureStates.studioId,
                    brand_name: ''
                }
            });
            _this.changeFilterOption({
                prop: 'branchId',
                value: _this.configureStates.branchId
            });
            if (_this.configureStates.isSeventeen) {
                return _this.fetchStudioList();
            }
            if (_this.configureStates.isBranch) {
                _this.branchIds = [{
                    'id': _this.configureStates.branchId,
                    'branch_name': ''
                }];
            }
        });

        this.changeDateOption({
            prop: 'startDate',
            value: moment().add(-1, 'months').format('YYYY/MM/DD')
        });

        this.changeDateOption({
            prop: 'endDate',
            value: moment().format('YYYY/MM/DD')
        });
    },

    watch: (0, _defineProperty3.default)({}, 'filterOptions.studioId', function filterOptionsStudioId(n, o) {
        if (this.configureStates.isSeventeen || this.configureStates.isStudio) {
            this.fetchBranchList({
                studioId: n.id
            });
        }
    }),
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        configureStates: function configureStates(state) {
            return state.webadmin.configure;
        }
    }), (0, _vuex.mapState)('webadmin/configure', ['configured', 'studioList', 'branchList', 'branchId', 'contractList']), (0, _vuex.mapState)('webadmin/baseReport', ['blockOpenStatus', 'dateOptions', 'filterOptions']), {
        studioId: {
            get: function get() {
                return this.filterOptions.studioId;
            },
            set: function set(newValue) {
                var _this2 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                    return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.next = 2;
                                    return _this2.changeFilterOption({ 'prop': 'studioId', value: newValue });

                                case 2:
                                    _this2.cleanBranch();

                                    if (!newValue) {
                                        _context.next = 6;
                                        break;
                                    }

                                    _context.next = 6;
                                    return _this2.fetchBranchList({ studioId: newValue.id });

                                case 6:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this2);
                }))();
            }
        },
        branchIds: {
            get: function get() {
                return this.filterOptions.branchIds;
            },
            set: function set(newValue) {
                var _this3 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                    return _regenerator2.default.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    _context2.next = 2;
                                    return _this3.changeFilterOption({ 'prop': 'branchIds', value: newValue });

                                case 2:
                                case 'end':
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, _this3);
                }))();
            }
        },
        ajaxing: {
            get: function get() {
                return this.$store.state.webadmin.baseReport.ajaxing;
            },
            set: function set(newValue) {
                var _this4 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
                    return _regenerator2.default.wrap(function _callee3$(_context3) {
                        while (1) {
                            switch (_context3.prev = _context3.next) {
                                case 0:
                                    _context3.next = 2;
                                    return _this4.changeAjaxing(newValue);

                                case 2:
                                case 'end':
                                    return _context3.stop();
                            }
                        }
                    }, _callee3, _this4);
                }))();
            }
        }
    }),
    methods: (0, _extends3.default)({
        updateFilterOption: function updateFilterOption(field) {
            var _this5 = this;

            return function (value) {
                return _this5.changeFilterOption({
                    prop: field,
                    value: value
                });
            };
        }
    }, (0, _vuex.mapActions)('webadmin/configure', ['configuredRun', 'fetchStudioList', 'fetchBranchList', 'fetchContractList']), (0, _vuex.mapActions)('webadmin/baseReport', ['beforeSubmit', 'toggleBlock', 'changeDateOption', 'changeFilterOption', 'cleanBranch', 'cleanBranchRelated', 'changeItemOption', 'setDetailTarget', "changeAjaxing"]), {
        submit: function submit() {
            this.beforeSubmit();
            this.getQUeryResault();
        },
        getQUeryResault: function getQUeryResault() {
            var _this6 = this;

            var queryString = this.getQueryString();
            this.ajaxing = true;
            this.$http.get('/adminapi/report/fetch_late_cancel_and_absence?' + queryString).then(function (response) {
                _this6.memberList = response.body;
                _this6.ajaxing = false;
            }, function (error) {
                _this6.ajaxing = false;
                $17.swal({
                    title: error.body.message,
                    type: 'warning'
                });
            });
        },
        getQueryString: function getQueryString() {
            var branchPara = this.branchIds.reduce(function (carry, branch) {
                return carry + '&branch_ids[]=' + branch.id;
            }, '');
            var studioPara = this.configureStates.isSeventeen ? '&studio_id=' + this.studioId.id : '';
            this.ajaxing = true;

            var branchQuery = '';
            var optionQuery = '';
            if (this.branchIds.length > 0) {
                branchQuery = this.branchIds.reduce(function (carry, branch) {
                    carry += '&branch_ids[]=' + branch.id;

                    return carry;
                }, '');
            }

            optionQuery = '&booking_way=' + this.bookingWay.value + '&service_type=' + this.serviceType.value + '&confirm_status=' + this.bookingConfirm.value + '&online_booking_status=' + this.onlineBooking.value;

            var queryString = 'start_date=' + this.dateOptions.startDate + '&end_date=' + this.dateOptions.endDate + branchPara + branchQuery + studioPara + optionQuery;
            return queryString;
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"page-div\" _v-23ab1c5d=\"\">\n    <v-webadmin-report :block-open-status=\"blockOpenStatus\" :date-options=\"dateOptions\" :toggle-block=\"toggleBlock\" :change-date-option=\"changeDateOption\" :disable-submit=\"ajaxing\" :submit=\"submit\" limit-date=\"90\" title=\"缺席及遲退報表\" _v-23ab1c5d=\"\">\n        <div slot=\"second-block\" _v-23ab1c5d=\"\">\n            <div class=\"row\" _v-23ab1c5d=\"\">\n                <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen\" _v-23ab1c5d=\"\">\n                    <div class=\"form-group\" _v-23ab1c5d=\"\">\n                        <v-mutiselect :model.sync=\"studioId\" :options=\"studioList\" :preserve-search=\"true\" :placeholder=\"configureStates.ajaxing.studioList ? '品牌讀取中…' : '請選擇品牌'\" label=\"brand_name\" track-by=\"id\" _v-23ab1c5d=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n                <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen || configureStates.isStudio\" _v-23ab1c5d=\"\">\n                    <div class=\"form-group\" _v-23ab1c5d=\"\">\n                        <v-mutiselect :model.sync=\"branchIds\" :options=\"branchList\" :disabled=\"configureStates.ajaxing.branchList\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"false\" :placeholder=\"configureStates.ajaxing.branchList ? '場館讀取中…' : '全部場館'\" label=\"branch_name\" track-by=\"id\" :taggable=\"true\" tag-name=\"branch_name\" _v-23ab1c5d=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n                <div class=\"col-sm-6\" _v-23ab1c5d=\"\">\n                    <div class=\"form-group\" _v-23ab1c5d=\"\">\n                        <v-mutiselect :model.sync=\"serviceType\" :options=\"serviceTypeList\" :multiple=\"false\" :close-on-select=\"true\" :clear-on-select=\"true\" :hide-selected=\"true\" :preserve-search=\"false\" :searchable=\"false\" label=\"name\" track-by=\"value\" tag-name=\"name\" _v-23ab1c5d=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n                <div class=\"col-sm-6\" _v-23ab1c5d=\"\">\n                    <div class=\"form-group\" _v-23ab1c5d=\"\">\n                        <v-mutiselect :model.sync=\"bookingWay\" :options=\"bookingWayList\" :multiple=\"false\" :close-on-select=\"true\" :clear-on-select=\"true\" :hide-selected=\"true\" :preserve-search=\"false\" :searchable=\"false\" label=\"name\" track-by=\"value\" tag-name=\"name\" _v-23ab1c5d=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n                <div class=\"col-sm-6\" _v-23ab1c5d=\"\">\n                    <div class=\"form-group\" _v-23ab1c5d=\"\">\n                        <v-mutiselect :model.sync=\"bookingConfirm\" :options=\"bookingConfirmList\" :multiple=\"false\" :close-on-select=\"true\" :clear-on-select=\"true\" :hide-selected=\"true\" :preserve-search=\"false\" :searchable=\"false\" label=\"name\" track-by=\"value\" tag-name=\"name\" _v-23ab1c5d=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div> \n                <div class=\"col-sm-6\" _v-23ab1c5d=\"\">\n                    <div class=\"form-group\" _v-23ab1c5d=\"\">\n                        <v-mutiselect :model.sync=\"onlineBooking\" :options=\"onlineBookingList\" :multiple=\"false\" :close-on-select=\"true\" :clear-on-select=\"true\" :hide-selected=\"true\" :preserve-search=\"false\" :searchable=\"false\" label=\"name\" track-by=\"value\" tag-name=\"name\" _v-23ab1c5d=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </v-webadmin-report>\n    <div v-show=\"display==='show'\" _v-23ab1c5d=\"\">\n        <div class=\"table-div\" _v-23ab1c5d=\"\">\n            <v-table :ajaxing=\"ajaxing\" :length=\"memberList.length\" _v-23ab1c5d=\"\">\n                <table class=\"table table-striped\" _v-23ab1c5d=\"\">\n                    <thead _v-23ab1c5d=\"\">\n                        <tr _v-23ab1c5d=\"\">\n                            <td _v-23ab1c5d=\"\">客戶姓名</td>\n                            <td _v-23ab1c5d=\"\">手機</td>\n                            <td _v-23ab1c5d=\"\">Email</td>\n                            <td _v-23ab1c5d=\"\">期間累積次數</td>\n                            <td _v-23ab1c5d=\"\">當前線上狀態</td>\n                        </tr>\n                    </thead>\n                    <tbody _v-23ab1c5d=\"\">\n                        <tr v-for=\"item in memberList\" _v-23ab1c5d=\"\">\n                            <td _v-23ab1c5d=\"\">{{ item.name }}</td>\n                            <td _v-23ab1c5d=\"\">{{ item.phone }}</td>\n                            <td _v-23ab1c5d=\"\">{{ item.email }}</td>\n                            <td _v-23ab1c5d=\"\">{{ item.times }}</td>\n                            <td _v-23ab1c5d=\"\">{{ item.timescurrentStatus }}</td>\n                        </tr>\n                    </tbody>\n                </table>\n            </v-table>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.page-div[_v-23ab1c5d] {\n  padding: 0px 15px;\n  margin-bottom: 15px; }\n\n/* line 7, stdin */\n.m-l-15[_v-23ab1c5d] {\n  margin-left: 15px; }\n\n/* line 11, stdin */\n.table-div[_v-23ab1c5d] {\n  padding: 20px 0px; }\n\n/* line 15, stdin */\n.form-title[_v-23ab1c5d] {\n  font-size: 16px;\n  font-weight: bold;\n  display: inline-block;\n  width: 60px; }\n\n/* line 22, stdin */\n.negative-number[_v-23ab1c5d] {\n  color: red; }\n\n/* line 26, stdin */\n.cube[_v-23ab1c5d] {\n  max-width: 80px;\n  float: left;\n  margin: 12px 24px;\n  font-weight: bold;\n  font-size: 18px; }\n\n/* line 33, stdin */\n.total-list[_v-23ab1c5d] {\n  width: 100%;\n  border: 1px solid;\n  margin: 30px 0px; }\n\n/* line 38, stdin */\n.total-list[_v-23ab1c5d]:after {\n  clear: both; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-23ab1c5d", module.exports)
  } else {
    hotAPI.update("_v-23ab1c5d", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/defineProperty":65,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1350:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.page-div[_v-54764a2a] {\n  padding: 0px 15px;\n  margin-bottom: 15px; }\n\n/* line 7, stdin */\n.table-div[_v-54764a2a] {\n  padding: 20px 0px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _watch;

var _vuex = require('vuex');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        var vm = this;
        return {
            display: 'show',
            bookingList: [],
            saleBranchId: null,
            consumeBranchId: null,
            bookingWay: {
                name: "方案預約",
                value: 'contract'
            },
            bookingWayList: [{
                name: "方案預約",
                value: 'contract'
            }, {
                name: "單次預約",
                value: 'single'
            }],
            bookingConfirm: {
                name: '出席狀態',
                value: null
            },
            bookingConfirmList: [{
                name: '出席狀態',
                value: null
            }, {
                name: "尚未確認",
                value: 'not_change'
            }, {
                name: "出席",
                value: 'confirm'
            }, {
                name: "缺席",
                value: 'absence'
            }, {
                name: "遲退",
                value: 'cancel_late'
            }, {
                name: "取消",
                value: 'cancel'
            }],
            currentActivePartial: 'contract',
            tableConfig: {
                columns: [{ keys: 'member_name', head: '客戶姓名' }, { keys: 'sale_branch_name', head: '銷售場館' }, { keys: 'consume_branch_name', head: '消耗場館' }, { keys: 'start_time', head: '開始時間' }, { keys: 'contract_name', head: '方案名稱' }, { keys: 'contract_type', head: '方案類型' }, { keys: 'contract_total', head: '方案權益' }, {
                    keys: 'contract_table_price',
                    head: '方案定價',
                    html: function html(item) {
                        return vm.thousandthFormat(item.contract_table_price);
                    }
                }, {
                    keys: 'contract_sale_price',
                    head: '結帳金額',
                    html: function html(item) {
                        return vm.thousandthFormat(item.contract_sale_price);
                    }
                }, { keys: 'name', head: '課程/服務項目' }, { keys: 'consume_value', head: '消耗點次' }, {
                    keys: 'consume_money',
                    head: '名目消耗價值',
                    html: function html(item) {
                        return vm.thousandthFormat(item.consume_money);
                    }
                }, {
                    keys: 'consume_money_by_order',
                    head: '實際消耗價值',
                    html: function html(item) {
                        return vm.thousandthFormat(item.consume_money_by_order);
                    }
                }, { keys: 'confirm_status', head: '出席狀態' }, { keys: 'staff_name', head: '人員' }]
            },
            tableConfigSingle: {
                columns: [{ keys: 'member_name', head: '客戶姓名' }, { keys: 'sale_branch_name', head: '銷售場館' }, { keys: 'consume_branch_name', head: '使用場館' }, { keys: 'start_time', head: '開始時間' }, {
                    keys: 'fixed_price',
                    head: '課程/服務定價',
                    html: function html(item) {
                        return vm.thousandthFormat(item.fixed_price);
                    }
                }, {
                    keys: 'billed_price',
                    head: '單次結帳金額',
                    html: function html(item) {
                        return vm.thousandthFormat(item.billed_price);
                    }
                }, { keys: 'name', head: '課程/服務項目' }, { keys: 'confirm_status', head: '出席狀態' }, { keys: 'staff_name', head: '人員' }]
            }
        };
    },
    mounted: function mounted() {
        var _this = this;

        this.configuredRun(function () {
            _this.changeFilterOption({
                prop: 'studioId',
                value: {
                    id: _this.configureStates.studioId,
                    brand_name: ''
                }
            });
            _this.changeFilterOption({
                prop: 'branchId',
                value: _this.configureStates.branchId
            });
            if (_this.configureStates.isSeventeen) {
                return _this.fetchStudioList();
            }
            if (_this.configureStates.isBranch) {
                _this.branchIds = [{
                    'id': _this.configureStates.branchId,
                    'branch_name': ''
                }];
            }
        });

        this.syncDateAndDisplayByQuery({
            'diffType': 'months',
            'diffNumber': -1
        });
    },

    watch: (_watch = {}, (0, _defineProperty3.default)(_watch, 'filterOptions.studioId', function filterOptionsStudioId(n, o) {
        this.fetchBranchList({
            studioId: n.id
        });
        this.saleBranchId = null;
        this.consumeBranchId = null;
    }), (0, _defineProperty3.default)(_watch, 'bookingList', function bookingList(newValue, oldValue) {
        var _this2 = this;

        if (newValue.length > 0 && this.display === 'export') {
            var formatter = '';

            if (this.currentActivePartial == 'contract') {
                formatter = this.columnContractFormatter;
            }

            if (this.currentActivePartial == 'single') {
                formatter = this.columnSingleFormatter;
            }

            this.csvDataHandler({ data: newValue, columnFormater: formatter }).then(function (results) {
                _this2.download({ csvString: results, name: 'booking_values_report_' + moment().format('YYYYMMDDHHmmss') });
            });
        }
    }), (0, _defineProperty3.default)(_watch, 'bookingWay', function bookingWay(newValue) {
        if (newValue.value == 'single') {
            if (this.saleBranchId == null && this.consumeBranchId != null) {
                this.saleBranchId = this.consumeBranchId;
            }

            if (this.consumeBranchId == null && this.saleBranchId != null) {
                this.consumeBranchId = this.saleBranchId;
            }
        }
    }), (0, _defineProperty3.default)(_watch, 'consumeBranchId', function consumeBranchId() {
        this.fetchBranchAppendList();
    }), (0, _defineProperty3.default)(_watch, 'branchList', function branchList() {
        this.fetchBranchAppendList();
    }), (0, _defineProperty3.default)(_watch, 'saleBranchId', function saleBranchId(newValue) {
        if (newValue != null && this.configureStates.isBranch) {
            this.consumeBranchId = newValue;
        }
    }), _watch),
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        configureStates: function configureStates(state) {
            return state.webadmin.configure;
        }
    }), (0, _vuex.mapState)('webadmin/configure', ['configured', 'studioList', 'branchList', 'branchId', 'contractList', 'serviceProviderList']), (0, _vuex.mapState)('webadmin/baseReport', ['blockOpenStatus', 'dateOptions', 'filterOptions', 'ajaxing']), {
        studioId: {
            get: function get() {
                return this.filterOptions.studioId;
            },
            set: function set(newValue) {
                var _this3 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                    return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.next = 2;
                                    return _this3.changeFilterOption({ 'prop': 'studioId', value: newValue });

                                case 2:
                                    _this3.cleanBranch();

                                    if (!newValue) {
                                        _context.next = 6;
                                        break;
                                    }

                                    _context.next = 6;
                                    return _this3.fetchBranchList({ studioId: newValue.id });

                                case 6:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this3);
                }))();
            }
        },
        records: function records() {
            return { records: this.bookingList, pageMeta: {} };
        },
        totalConsumeMoney: function totalConsumeMoney() {
            return this.bookingList.reduce(function (carry, list) {
                return {
                    consume_money: carry.consume_money += list.consume_money,
                    consume_money_by_order: carry.consume_money_by_order += list.consume_money_by_order
                };
            }, { consume_money: 0, consume_money_by_order: 0 });
        },
        totalConsumeMoneyBySingle: function totalConsumeMoneyBySingle() {
            return this.bookingList.reduce(function (carry, list) {
                return {
                    fixed_price: carry.fixed_price += list.fixed_price,
                    billed_price: carry.billed_price += list.billed_price
                };
            }, { fixed_price: 0, billed_price: 0 });
        },

        serviceProviderIds: {
            get: function get() {
                return this.filterOptions.serviceProviderIds;
            },
            set: function () {
                var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(newValue) {
                    return _regenerator2.default.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    _context2.next = 2;
                                    return this.$store.dispatch('webadmin/baseReport/changeFilterOption', {
                                        'prop': 'serviceProviderIds',
                                        value: newValue
                                    });

                                case 2:
                                case 'end':
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, this);
                }));

                function set(_x) {
                    return _ref.apply(this, arguments);
                }

                return set;
            }()
        }
    }),
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('webadmin/configure', ['configuredRun', 'fetchStudioList', 'fetchBranchList', 'fetchContractList', 'fetchServiceProviderAllList']), (0, _vuex.mapActions)('webadmin/baseReport', ['changeAjaxing', 'beforeSubmit', 'toggleBlock', 'changeDateOption', 'changeFilterOption', 'cleanBranch', 'download', 'csvDataHandler', 'syncDateAndDisplayByQuery', 'cleanBranchRelated']), {
        thousandthFormat: function thousandthFormat(money) {
            money = Math.abs(money);
            money = $17.thousandthFormat(money);
            return '$' + money;
        },
        submit: function submit() {
            var _this4 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _this4.beforeSubmit();

                                if (!(_this4.saleBranchId == null)) {
                                    _context3.next = 4;
                                    break;
                                }

                                $17.swal({
                                    title: '銷售場館為必選',
                                    type: 'warning'
                                });
                                return _context3.abrupt('return');

                            case 4:
                                if (!(_this4.saleBranchId == null)) {
                                    _context3.next = 7;
                                    break;
                                }

                                $17.swal({
                                    title: '使用場館為必選',
                                    type: 'warning'
                                });
                                return _context3.abrupt('return');

                            case 7:
                                _context3.next = 9;
                                return _this4.getQueryResult();

                            case 9:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this4);
            }))();
        },
        getQueryResult: function getQueryResult() {
            var _this5 = this;

            var payload = {
                params: {
                    studio_id: this.filterOptions.studioId && this.filterOptions.studioId.hasOwnProperty('id') ? this.filterOptions.studioId.id : 0,
                    sale_branch_id: this.saleBranchId.id,
                    consume_branch_id: this.consumeBranchId.id,
                    booking_way: this.bookingWay.value,
                    confirm_status: this.bookingConfirm.value,
                    start_date: this.dateOptions.startDate,
                    end_date: this.dateOptions.endDate,
                    service_provider_id: this.serviceProviderIds && this.serviceProviderIds.hasOwnProperty('id') ? this.serviceProviderIds.id : null
                }
            };

            this.changeAjaxing(true);
            this.$http.get('/adminapi/report/fetch_booking_consume_money_report', payload).then(function (response) {
                _this5.bookingList = response.body;
                _this5.currentActivePartial = _this5.bookingWay.value;
                _this5.changeAjaxing(false);
            }, function (error) {
                _this5.changeAjaxing(false);
                $17.swal({
                    title: error.body.message,
                    type: 'warning'
                });
            });
        },
        columnContractFormatter: function columnContractFormatter(data) {
            var data = _lodash2.default.map(data, function (value) {
                return _lodash2.default.pick(value, ['member_name', 'member_email', 'member_phone', 'sale_branch_name', 'consume_branch_name', 'start_time', 'contract_name', 'contract_type', 'contract_total', 'contract_table_price', 'contract_sale_price', 'name', 'consume_value', 'consume_money', 'consume_money_by_order', 'confirm_status', 'staff_name']);
            });

            data.unshift({
                'member_name': '小計',
                'member_email': '',
                'member_phone': '',
                'sale_branch_name': '',
                'consume_branch_name': '',
                'start_time': '',
                'contract_name': '',
                'contract_type': '',
                'contract_total': '',
                'contract_table_price': '',
                'contract_sale_price': '',
                'name': '',
                'consume_value': '',
                'consume_money': this.totalConsumeMoney.consume_money,
                'consume_money_by_order': this.totalConsumeMoney.consume_money_by_order,
                'confirm_status': '',
                'staff_name': ''
            });

            data = (0, _stringify2.default)(data);
            data = data.replaceAll('sale_branch_name', '銷售場館');
            data = data.replaceAll('start_time', '開始時間');
            data = data.replaceAll('confirm_status', '出席狀態');
            data = data.replaceAll('consume_branch_name', '消耗場館');
            data = data.replaceAll('consume_money_by_order', '實際消耗價值');
            data = data.replaceAll('consume_money', '名目消耗價值');
            data = data.replaceAll('contract_name', '方案名稱');
            data = data.replaceAll('contract_sale_price', '結帳金額');
            data = data.replaceAll('contract_table_price', '方案定價');
            data = data.replaceAll('contract_total', '方案權益');
            data = data.replaceAll('contract_type', '方案類型');
            data = data.replaceAll('member_name', '客戶姓名');
            data = data.replaceAll('member_email', '電子郵件');
            data = data.replaceAll('member_phone', '客戶電話');
            data = data.replaceAll('consume_value', '消耗點次');
            data = data.replaceAll('staff_name', '人員');
            data = data.replaceAll('name', '課程/服務項目');

            return data;
        },
        columnSingleFormatter: function columnSingleFormatter(data) {
            var data = _lodash2.default.map(data, function (value) {
                return _lodash2.default.pick(value, ['member_name', 'member_email', 'member_phone', 'sale_branch_name', 'consume_branch_name', 'start_time', 'fixed_price', 'billed_price', 'name', 'confirm_status', 'staff_name']);
            });

            data.unshift({
                'member_name': '小計',
                'member_email': '',
                'member_phone': '',
                'sale_branch_name': '',
                'consume_branch_name': '',
                'start_time': '',
                'fixed_price': this.totalConsumeMoneyBySingle.fixed_price,
                'billed_price': this.totalConsumeMoneyBySingle.billed_price,
                'name': '',
                'confirm_status': '',
                'staff_name': ''
            });

            data = (0, _stringify2.default)(data);
            data = data.replaceAll('sale_branch_name', '銷售場館');
            data = data.replaceAll('start_time', '開始時間');
            data = data.replaceAll('confirm_status', '出席狀態');
            data = data.replaceAll('consume_branch_name', '消耗場館');
            data = data.replaceAll('member_name', '客戶姓名');
            data = data.replaceAll('member_email', '電子郵件');
            data = data.replaceAll('member_phone', '客戶電話');
            data = data.replaceAll('staff_name', '人員');
            data = data.replaceAll('name', '課程/服務項目');
            data = data.replaceAll('fixed_price', '課程/服務定價');
            data = data.replaceAll('billed_price', '單次結帳金額');

            return data;
        },
        fetchBranchAppendList: function fetchBranchAppendList() {
            var _this6 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
                var studioId, branchIds, payload, data;
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _this6.$store.dispatch('webadmin/baseReport/changeFilterOption', {
                                    'prop': 'serviceProviderIds',
                                    value: null
                                });
                                studioId = _this6.filterOptions.studioId;
                                branchIds = _this6.consumeBranchId != null ? [_this6.consumeBranchId.id] : [];

                                if (branchIds.length == 0) {
                                    branchIds = _this6.branchList.map(function (elem) {
                                        return elem.id;
                                    });
                                }

                                if (!(branchIds.length == 0)) {
                                    _context4.next = 6;
                                    break;
                                }

                                return _context4.abrupt('return');

                            case 6:
                                payload = {
                                    studioId: studioId.id,
                                    branchIds: branchIds,
                                    startDate: _this6.dateOptions.startDate,
                                    endDate: _this6.dateOptions.endDate,
                                    isService: 0
                                };
                                _context4.next = 9;
                                return _this6.fetchServiceProviderAllList(payload);

                            case 9:
                                data = [].concat((0, _toConsumableArray3.default)(_this6.serviceProviderList));

                                data.unshift({
                                    id: 0,
                                    name: "無",
                                    nickname: "無"
                                });

                                _this6.FETCH_SERVICE_PROVIDER_LIST({
                                    serviceProviderList: data
                                });

                            case 12:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this6);
            }))();
        },
        changeDateOptionAfter: function changeDateOptionAfter($dateObj) {
            this.changeDateOption($dateObj);
            this.cleanBranchRelated();
            this.fetchBranchAppendList();
        }
    }, (0, _vuex.mapMutations)('webadmin/configure', ['FETCH_SERVICE_PROVIDER_LIST']))
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"page-div\" _v-54764a2a=\"\">\n    <v-webadmin-report :block-open-status=\"blockOpenStatus\" :date-options=\"dateOptions\" :toggle-block=\"toggleBlock\" :change-date-option=\"changeDateOptionAfter\" :disable-submit=\"ajaxing\" :submit=\"submit\" limit-date=\"31\" title=\"預約價值報表\" _v-54764a2a=\"\">\n        <div slot=\"second-block\" _v-54764a2a=\"\">\n            <div class=\"row\" _v-54764a2a=\"\">\n                <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen\" _v-54764a2a=\"\">\n                    <div class=\"form-group\" _v-54764a2a=\"\">\n                        <v-mutiselect :model.sync=\"studioId\" :options=\"studioList\" :preserve-search=\"true\" :placeholder=\"configureStates.ajaxing.studioList ? '品牌讀取中…' : '請選擇品牌'\" label=\"brand_name\" track-by=\"id\" _v-54764a2a=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n                <div class=\"col-sm-6\" _v-54764a2a=\"\">\n                    <div class=\"\" _v-54764a2a=\"\">\n                        <v-mutiselect :model.sync=\"saleBranchId\" :options=\"branchList\" :disabled=\"configureStates.ajaxing.branchList\" :multiple=\"false\" :close-on-select=\"true\" :clear-on-select=\"false\" :hide-selected=\"false\" :preserve-search=\"true\" :searchable=\"false\" :placeholder=\"configureStates.ajaxing.branchList ? '場館讀取中…' : '請選擇銷售場館'\" label=\"branch_name\" track-by=\"id\" :taggable=\"true\" tag-name=\"branch_name\" _v-54764a2a=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n                <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen || configureStates.isStudio\" _v-54764a2a=\"\">\n                    <div class=\"form-group\" _v-54764a2a=\"\">\n                        <v-mutiselect :model.sync=\"consumeBranchId\" :options=\"branchList\" :disabled=\"configureStates.ajaxing.branchList\" :multiple=\"false\" :close-on-select=\"true\" :clear-on-select=\"false\" :hide-selected=\"false\" :preserve-search=\"true\" :searchable=\"false\" :placeholder=\"configureStates.ajaxing.branchList ? '場館讀取中…' : '請選擇使用場館'\" label=\"branch_name\" track-by=\"id\" :taggable=\"true\" tag-name=\"branch_name\" _v-54764a2a=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n                <div class=\"col-sm-6\" _v-54764a2a=\"\">\n                    <div class=\"form-group\" _v-54764a2a=\"\">\n                        <v-mutiselect :model.sync=\"bookingWay\" :options=\"bookingWayList\" :multiple=\"false\" :close-on-select=\"true\" :clear-on-select=\"true\" :hide-selected=\"true\" :preserve-search=\"false\" :searchable=\"false\" label=\"name\" track-by=\"value\" tag-name=\"name\" _v-54764a2a=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n                <div class=\"col-sm-6\" _v-54764a2a=\"\">\n                    <div class=\"form-group\" _v-54764a2a=\"\">\n                        <v-mutiselect :model.sync=\"bookingConfirm\" :options=\"bookingConfirmList\" :multiple=\"false\" :close-on-select=\"true\" :clear-on-select=\"true\" :hide-selected=\"true\" :preserve-search=\"false\" :searchable=\"false\" label=\"name\" track-by=\"value\" tag-name=\"name\" _v-54764a2a=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div> \n                <div class=\"col-sm-6\" _v-54764a2a=\"\">\n                    <div class=\"form-group\" _v-54764a2a=\"\">\n                        <v-mutiselect :model.sync=\"serviceProviderIds\" :options=\"serviceProviderList\" :multiple=\"false\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"false\" :preserve-search=\"true\" :searchable=\"false\" :placeholder=\"configureStates.ajaxing.serviceProviderList ? '人員讀取中…' : '全部人員'\" label=\"name\" track-by=\"id\" :max-height=\"500\" tag-name=\"name\" _v-54764a2a=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div slot=\"fourth-block\" _v-54764a2a=\"\">\n            <div class=\"row\" _v-54764a2a=\"\">\n                <div class=\"col-sm-6\" _v-54764a2a=\"\">\n                    <div class=\"form-group row\" _v-54764a2a=\"\">\n                        <label _v-54764a2a=\"\">\n                            <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"show\" checked=\"\" _v-54764a2a=\"\"> 顯示於網頁\n                        </label>\n                        <label _v-54764a2a=\"\">\n                            <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"export\" _v-54764a2a=\"\"> 匯出 CSV\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </v-webadmin-report>\n    <div v-show=\"display==='show'\" _v-54764a2a=\"\">\n        <div class=\"table-div\" v-if=\"currentActivePartial=='contract'\" _v-54764a2a=\"\">\n            <h4 v-if=\"bookingList.length > 0 &amp;&amp; !ajaxing\" _v-54764a2a=\"\">\n                {{ '名目消耗價值：' + thousandthFormat(totalConsumeMoney.consume_money) }}\n                <span class=\"p-left-10 p-right-10\" _v-54764a2a=\"\">|</span>\n                {{ '實際消耗價值：' + thousandthFormat(totalConsumeMoney.consume_money_by_order) }}\n            </h4>\n            <v-smart-table :table-config=\"tableConfig\" :is-ajaxing=\"ajaxing\" :data=\"records\" :page-sync-url-query=\"false\" _v-54764a2a=\"\"></v-smart-table>\n        </div>\n\n        <div class=\"table-div\" v-if=\"currentActivePartial=='single'\" _v-54764a2a=\"\">\n            <h4 v-if=\"bookingList.length > 0 &amp;&amp; !ajaxing\" _v-54764a2a=\"\">\n                {{ '課程/服務定價：' + thousandthFormat(totalConsumeMoneyBySingle.fixed_price) }}\n                <span class=\"p-left-10 p-right-10\" _v-54764a2a=\"\">|</span>\n                {{ '單次結帳金額：' + thousandthFormat(totalConsumeMoneyBySingle.billed_price) }}\n            </h4>\n            <v-smart-table :table-config=\"tableConfigSingle\" :is-ajaxing=\"ajaxing\" :data=\"records\" :page-sync-url-query=\"false\" _v-54764a2a=\"\"></v-smart-table>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.page-div[_v-54764a2a] {\n  padding: 0px 15px;\n  margin-bottom: 15px; }\n\n/* line 7, stdin */\n.table-div[_v-54764a2a] {\n  padding: 20px 0px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-54764a2a", module.exports)
  } else {
    hotAPI.update("_v-54764a2a", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/json/stringify":48,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/defineProperty":65,"babel-runtime/helpers/extends":66,"babel-runtime/helpers/toConsumableArray":71,"babel-runtime/regenerator":75,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1351:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n/* line 3, stdin */\n.page-div[_v-73b45e20] {\n  padding: 0px 15px;\n  margin-bottom: 15px; }\n\n/* line 8, stdin */\n.m-l-15[_v-73b45e20] {\n  margin-left: 15px; }\n\n/* line 12, stdin */\n.table-div[_v-73b45e20] {\n  padding: 20px 0px; }\n\n/* line 16, stdin */\n.form-title[_v-73b45e20] {\n  font-size: 16px;\n  font-weight: bold;\n  display: inline-block;\n  width: 60px; }\n\n/* line 23, stdin */\n.refund-order[_v-73b45e20] {\n  color: red; }\n\n/* line 27, stdin */\n.negative-number[_v-73b45e20] {\n  color: red; }\n\n/* line 31, stdin */\n.origin-refunded[_v-73b45e20] {\n  color: #C7C4C3; }\n\n/* line 37, stdin */\n.price[_v-73b45e20] {\n  text-align: center; }\n\n/* line 41, stdin */\n.cube[_v-73b45e20] {\n  max-width: 80px;\n  float: left;\n  margin: 12px 24px;\n  font-weight: blod;\n  font-size: 18px; }\n\n/* line 49, stdin */\n.total-list[_v-73b45e20] {\n  margin: 15px 0px 0px 0px; }\n\n/* line 53, stdin */\n.total-list[_v-73b45e20]:after {\n  clear: both; }\n\n/* line 57, stdin */\n.table-striped thead[_v-73b45e20] {\n  border-bottom: 1px solid #000; }\n\n/* line 61, stdin */\n.multiselect[_v-73b45e20] {\n  padding-bottom: 5px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _watch;

var _vuex = require('vuex');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            display: 'show',
            tableConfig: {
                columns: [{ keys: 'date', head: '日期' }, { keys: 'time', head: '時間' }, { keys: 'service_name', head: '項目' }, { keys: 'staff_name', head: '人員' }, { keys: 'branch_name', head: '場館' }, { keys: 'name', head: '客戶' }, { keys: 'confirm_status', head: '狀態' }]
            },
            csvConfig: {
                column: [{ keys: 'date', name: '日期' }, { keys: 'time', name: '時間' }, { keys: 'service_name', name: '項目' }, { keys: 'staff_name', name: '人員' }, { keys: 'branch_name', name: '場館' }, { keys: 'name', name: '客戶' }, { keys: 'confirm_status', name: '狀態' }],
                fileName: 'data',
                jsonData: []
            },
            relatedFilterWatcher: {
                studio_id: { watcher: null, options: 'studioList', vModel: 'studioId', trackBy: 'id', select: 'single' },
                branch_ids: { watcher: null, options: 'branchList', vModel: 'branchIds', trackBy: 'id', select: 'multi' },
                confirm_statuses: { watcher: null, options: 'confirmStatus', vModel: 'confirmStatuses', trackBy: 'status', select: 'multi' },
                service_ids: { watcher: null, options: 'serviceList', vModel: 'serviceIds', trackBy: 'id', select: 'multi' },
                service_provider_ids: { watcher: null, options: 'serviceProviderList', vModel: 'serviceProviderIds', trackBy: 'id', select: 'multi' }
            }
        };
    },
    created: function created() {
        this.syncMultiSelectByQuery();
    },
    mounted: function mounted() {
        var _this = this;

        this.configuredRun(function () {
            _this.changeFilterOption({
                prop: 'studioId',
                value: {
                    id: _this.configureStates.studioId,
                    brand_name: ''
                }
            });
            _this.changeFilterOption({
                prop: 'branchId',
                value: _this.configureStates.branchId
            });
            if (_this.configureStates.isSeventeen) {
                return _this.fetchStudioList();
            }
            if (_this.configureStates.isBranch) {
                _this.branchIds = [{
                    'id': _this.configureStates.branchId,
                    'branch_name': ''
                }];
            }
        });
        this.initConfirmStatus();
        this.syncDateAndDisplayByQuery();
    },

    watch: (_watch = {}, (0, _defineProperty3.default)(_watch, 'filterOptions.studioId', function filterOptionsStudioId(n, o) {
        if (this.configureStates.isSeventeen && !_lodash2.default.isEmpty(n)) {
            this.fetchBranchList({
                studioId: n.id
            });
        }
        if (this.configureStates.isStudio) {
            this.fetchBranchList({
                studioId: n.id
            });
        }
    }), (0, _defineProperty3.default)(_watch, 'export', function _export(newV) {
        if (newV) {
            this.csvConfig.jsonData = this.mapStatus(newV);
            this.$refs.smart_table.downloadCsv();
        }
    }), (0, _defineProperty3.default)(_watch, 'display', function display(newV, oldV) {
        if (newV) {
            var obj = {
                display: newV
            };
            var newQuery = $17.updateUrlQueryString(obj);
        }
    }), _watch),
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        configureStates: function configureStates(state) {
            return state.webadmin.configure;
        }
    }), (0, _vuex.mapState)('webadmin/configure', ['configured', 'studioList', 'branchList', 'serviceProviderList', 'serviceList', 'branchId']), (0, _vuex.mapState)('webadmin/bookingTotalList', ['blockOpenStatus', 'dateOptions', 'filterOptions', 'ajaxing', 'export', 'list', 'total', 'pageMeta', 'confirmStatus', 'confirmStatusShow']), {
        bookingTotalRecord: function bookingTotalRecord() {
            return { records: this.mapStatus(this.list), pageMeta: this.pageMeta };
        },

        studioId: {
            get: function get() {
                return this.filterOptions.studioId;
            },
            set: function () {
                var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(newValue) {
                    return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.next = 2;
                                    return this.$store.dispatch('webadmin/bookingTotalList/changeFilterOption', { 'prop': 'studioId', value: newValue });

                                case 2:
                                    if (!_lodash2.default.isEmpty(newValue)) {
                                        $17.updateUrlQueryString({ studio_id: newValue.id });
                                    }
                                    this.cleanBranch();
                                    this.cleanBranchRelated();

                                    if (!newValue) {
                                        _context.next = 9;
                                        break;
                                    }

                                    _context.next = 8;
                                    return this.fetchBranchList({ studioId: newValue.id });

                                case 8:
                                    this.fetchBranchAppendList();

                                case 9:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, this);
                }));

                function set(_x) {
                    return _ref.apply(this, arguments);
                }

                return set;
            }()
        },
        branchIds: {
            get: function get() {
                return this.filterOptions.branchIds;
            },
            set: function () {
                var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(newValue) {
                    return _regenerator2.default.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    _context2.next = 2;
                                    return this.$store.dispatch('webadmin/bookingTotalList/changeFilterOption', { 'prop': 'branchIds', value: newValue });

                                case 2:
                                    $17.updateUrlQueryString({ branch_ids: newValue.map(function (el) {
                                            return el.id;
                                        }) });
                                    this.cleanBranchRelated();
                                    if (newValue.length != 0) {
                                        this.fetchBranchAppendList();
                                    }

                                case 5:
                                case 'end':
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, this);
                }));

                function set(_x2) {
                    return _ref2.apply(this, arguments);
                }

                return set;
            }()
        },
        serviceIds: {
            get: function get() {
                return this.filterOptions.serviceIds;
            },
            set: function () {
                var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(newValue) {
                    return _regenerator2.default.wrap(function _callee3$(_context3) {
                        while (1) {
                            switch (_context3.prev = _context3.next) {
                                case 0:
                                    _context3.next = 2;
                                    return this.$store.dispatch('webadmin/bookingTotalList/changeFilterOption', { 'prop': 'serviceIds', value: newValue });

                                case 2:
                                    $17.updateUrlQueryString({ service_ids: newValue.map(function (el) {
                                            return el.id;
                                        }) });

                                case 3:
                                case 'end':
                                    return _context3.stop();
                            }
                        }
                    }, _callee3, this);
                }));

                function set(_x3) {
                    return _ref3.apply(this, arguments);
                }

                return set;
            }()
        },
        serviceProviderIds: {
            get: function get() {
                return this.filterOptions.serviceProviderIds;
            },
            set: function () {
                var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(newValue) {
                    return _regenerator2.default.wrap(function _callee4$(_context4) {
                        while (1) {
                            switch (_context4.prev = _context4.next) {
                                case 0:
                                    _context4.next = 2;
                                    return this.$store.dispatch('webadmin/bookingTotalList/changeFilterOption', { 'prop': 'serviceProviderIds', value: newValue });

                                case 2:
                                    $17.updateUrlQueryString({ service_provider_ids: newValue.map(function (el) {
                                            return el.id;
                                        }) });

                                case 3:
                                case 'end':
                                    return _context4.stop();
                            }
                        }
                    }, _callee4, this);
                }));

                function set(_x4) {
                    return _ref4.apply(this, arguments);
                }

                return set;
            }()
        },
        confirmStatuses: {
            get: function get() {
                return this.filterOptions.confirmStatuses;
            },
            set: function () {
                var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(newValue) {
                    return _regenerator2.default.wrap(function _callee5$(_context5) {
                        while (1) {
                            switch (_context5.prev = _context5.next) {
                                case 0:
                                    _context5.next = 2;
                                    return this.$store.dispatch('webadmin/bookingTotalList/changeFilterOption', { 'prop': 'confirmStatuses', value: newValue });

                                case 2:
                                    $17.updateUrlQueryString({ confirm_statuses: newValue.map(function (el) {
                                            return el.status;
                                        }) });

                                case 3:
                                case 'end':
                                    return _context5.stop();
                            }
                        }
                    }, _callee5, this);
                }));

                function set(_x5) {
                    return _ref5.apply(this, arguments);
                }

                return set;
            }()
        }
    }),
    methods: (0, _extends3.default)({
        submitSearch: function submitSearch() {
            switch (this.display) {
                case 'export':
                    this.changeFilterOption({ 'prop': 'page', value: 1 });
                    this.changeFilterOption({ 'prop': 'pageSize', value: 9999999 });
                    break;
                case 'show':
                    this.changeFilterOption({ 'prop': 'page', value: 1 });
                    this.changeFilterOption({ 'prop': 'pageSize', value: 25 });
                    break;
                default:
                    null;
            }
            this.submit({ display: this.display });
        },
        syncDateAndDisplayByQuery: function syncDateAndDisplayByQuery() {
            var query = $17.getUrlQueryStrings();
            var start_date = query.start_date ? query.start_date : moment().add(-6, 'day');
            var end_date = query.end_date ? query.end_date : moment();
            this.display = query.display ? query.display : 'show';
            this.changeDateOption({
                prop: 'startDate',
                value: this.dateFormat(start_date)
            });
            this.changeDateOption({
                prop: 'endDate',
                value: this.dateFormat(end_date)
            });
        },
        syncMultiSelectByQuery: function syncMultiSelectByQuery() {
            var _this2 = this;

            var vm = this;
            var query = _lodash2.default.cloneDeep($17.getUrlQueryStrings());
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                var _loop = function _loop() {
                    var _step$value = (0, _slicedToArray3.default)(_step.value, 2),
                        key = _step$value[0],
                        value = _step$value[1];

                    value.watcher = _this2.$watch(value.options, function (newV, oldV) {
                        if (!_lodash2.default.isEmpty(newV)) {
                            var queryArr = query[key] ? query[key].split(",") : [];
                            var resultArr = [];
                            var isMultiSelect = value.select == 'multi';
                            queryArr.forEach(function (el) {
                                var findEl = newV.find(function (item) {
                                    return item[value.trackBy] == el;
                                });
                                findEl ? resultArr.push(findEl) : null;
                            });
                            vm[value.vModel] = isMultiSelect ? resultArr : resultArr[0];
                            value.watcher();
                        }
                    });
                };

                for (var _iterator = (0, _getIterator3.default)((0, _entries2.default)(this.relatedFilterWatcher)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    _loop();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        },
        thousandthFormat: function thousandthFormat(number) {
            return $17.thousandthFormat(number);
        },
        dateFormat: function dateFormat(date) {
            return moment(date).format('YYYY/MM/DD');
        },
        updateFilterOption: function updateFilterOption(field) {
            var _this3 = this;

            return function (value) {
                return _this3.changeFilterOption({
                    prop: field,
                    value: value
                });
            };
        }
    }, (0, _vuex.mapActions)('webadmin/configure', ['configuredRun', 'fetchStudioList', 'fetchBranchList', 'fetchServiceProviderList', 'fetchServiceList', 'pushObjectStatus']), (0, _vuex.mapActions)('webadmin/bookingTotalList', ['submit', 'changePage', 'toggleBlock', 'changeDateOption', 'changeFilterOption', 'changeItemOption', 'cleanBranch', 'cleanBranchRelated', 'initConfirmStatus']), (0, _vuex.mapActions)('webadmin/baseReport', ['download', 'csvDataHandler', 'columnFormater']), {
        fetchBranchAppendList: function fetchBranchAppendList() {
            var studioId = this.filterOptions.studioId;
            var branchIds = this.filterOptions.branchIds.map(function (elem) {
                return elem.id;
            });
            if (branchIds.length == 0) {
                branchIds = this.branchList.map(function (elem) {
                    return elem.id;
                });
            }
            var payload = {
                studioId: studioId.id,
                branchIds: branchIds,
                startDate: this.dateOptions.startDate,
                endDate: this.dateOptions.endDate
            };
            this.fetchServiceProviderList(payload);
            this.fetchServiceList(payload);
        },
        changeDateOptionAfter: function changeDateOptionAfter($dateObj) {
            this.changeDateOption($dateObj);
            this.cleanBranchRelated();
            this.fetchBranchAppendList();
            $17.updateUrlQueryString({
                start_date: this.dateOptions.startDate,
                end_date: this.dateOptions.endDate
            });
        },
        getShowName: function getShowName(status) {
            return this.confirmStatusShow[status];
        },
        mapStatus: function mapStatus(data) {
            var newData = _lodash2.default.cloneDeep(data);
            for (var key in newData) {
                newData[key].confirm_status = this.getShowName(newData[key].confirm_status);
            }
            return newData;
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"page-div\" _v-73b45e20=\"\">\n    <v-webadmin-report :block-open-status=\"blockOpenStatus\" :date-options=\"dateOptions\" :toggle-block=\"toggleBlock\" :change-date-option=\"changeDateOptionAfter\" :disable-submit=\"ajaxing\" :submit=\"submitSearch\" limit-date=\"180\" title=\"預約總覽\" _v-73b45e20=\"\">\n        <div slot=\"second-block\" _v-73b45e20=\"\">\n            <div class=\"filters\" _v-73b45e20=\"\">\n                <div class=\"row\" _v-73b45e20=\"\">\n                    <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen\" _v-73b45e20=\"\">\n                        <div class=\"form-group\" _v-73b45e20=\"\">\n                            <v-mutiselect :model.sync=\"studioId\" :options=\"studioList\" :preserve-search=\"true\" :placeholder=\"configureStates.ajaxing.studioList ? '品牌讀取中…' : '請選擇品牌'\" label=\"brand_name\" track-by=\"id\" _v-73b45e20=\"\">\n                            </v-mutiselect>\n                        </div>\n                    </div>\n                    <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen || configureStates.isStudio\" _v-73b45e20=\"\">\n                        <div class=\"form-group\" _v-73b45e20=\"\">\n                            <v-mutiselect :model.sync=\"branchIds\" :options=\"branchList\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"false\" :placeholder=\"configureStates.ajaxing.branchList ? '場館讀取中…' : '全部場館'\" label=\"branch_name\" track-by=\"id\" :taggable=\"true\" tag-name=\"branch_name\" :max-height=\"500\" _v-73b45e20=\"\">\n                            </v-mutiselect>\n                        </div>\n                    </div>\n                    <div class=\"col-sm-6\" _v-73b45e20=\"\">\n                        <div class=\"form-group\" _v-73b45e20=\"\">\n                            <v-mutiselect :model.sync=\"serviceProviderIds\" :options=\"serviceProviderList\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"false\" :placeholder=\"configureStates.ajaxing.serviceProviderList ? '人員讀取中…' : '全部人員'\" label=\"name\" track-by=\"id\" :max-height=\"500\" tag-name=\"name\" _v-73b45e20=\"\">\n\n                            </v-mutiselect>\n                        </div>\n                    </div>\n                    <div class=\"col-sm-6\" _v-73b45e20=\"\">\n                        <div class=\"form-group\" _v-73b45e20=\"\">\n                            <v-mutiselect :model.sync=\"serviceIds\" :options=\"serviceList\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :placeholder=\"configureStates.ajaxing.serviceList ? '項目讀取中…' : '全部項目'\" label=\"name\" track-by=\"id\" :max-height=\"500\" tag-name=\"name\" _v-73b45e20=\"\">\n                            </v-mutiselect>\n                        </div>\n                    </div>\n                    <div class=\"col-sm-6\" _v-73b45e20=\"\">\n                        <div class=\"form-group\" _v-73b45e20=\"\">\n                            <v-mutiselect :model.sync=\"confirmStatuses\" :options=\"confirmStatus\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"false\" placeholder=\"所有狀態\" label=\"name_type\" track-by=\"status\" :max-height=\"500\" tag-name=\"name_type\" _v-73b45e20=\"\">\n                            </v-mutiselect>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div slot=\"fourth-block\" _v-73b45e20=\"\">\n            <div class=\"row m-left-0\" _v-73b45e20=\"\">\n                <div class=\"col-sm-6\" _v-73b45e20=\"\">\n                    <div class=\"form-group row\" _v-73b45e20=\"\">\n                        <label _v-73b45e20=\"\">\n                            <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"show\" checked=\"\" _v-73b45e20=\"\"> 顯示於網頁\n                        </label>\n                        <label _v-73b45e20=\"\">\n                            <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"export\" _v-73b45e20=\"\"> 匯出 CSV\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </v-webadmin-report>\n    <div v-show=\"display==='show'\" _v-73b45e20=\"\">\n        <div class=\"row total-list\" v-if=\"list.length>0\" _v-73b45e20=\"\">\n            <h4 _v-73b45e20=\"\">總預約：{{thousandthFormat(total)}}</h4>\n        </div>\n        <div class=\"table-div\" _v-73b45e20=\"\">\n            <v-smart-table ref=\"smart_table\" :table-config=\"tableConfig\" :csv-config=\"csvConfig\" :is-ajaxing=\"ajaxing\" :data=\"bookingTotalRecord\" :page-sync-url-query=\"false\" @change-page=\"changePage\" _v-73b45e20=\"\"></v-smart-table>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n/* line 3, stdin */\n.page-div[_v-73b45e20] {\n  padding: 0px 15px;\n  margin-bottom: 15px; }\n\n/* line 8, stdin */\n.m-l-15[_v-73b45e20] {\n  margin-left: 15px; }\n\n/* line 12, stdin */\n.table-div[_v-73b45e20] {\n  padding: 20px 0px; }\n\n/* line 16, stdin */\n.form-title[_v-73b45e20] {\n  font-size: 16px;\n  font-weight: bold;\n  display: inline-block;\n  width: 60px; }\n\n/* line 23, stdin */\n.refund-order[_v-73b45e20] {\n  color: red; }\n\n/* line 27, stdin */\n.negative-number[_v-73b45e20] {\n  color: red; }\n\n/* line 31, stdin */\n.origin-refunded[_v-73b45e20] {\n  color: #C7C4C3; }\n\n/* line 37, stdin */\n.price[_v-73b45e20] {\n  text-align: center; }\n\n/* line 41, stdin */\n.cube[_v-73b45e20] {\n  max-width: 80px;\n  float: left;\n  margin: 12px 24px;\n  font-weight: blod;\n  font-size: 18px; }\n\n/* line 49, stdin */\n.total-list[_v-73b45e20] {\n  margin: 15px 0px 0px 0px; }\n\n/* line 53, stdin */\n.total-list[_v-73b45e20]:after {\n  clear: both; }\n\n/* line 57, stdin */\n.table-striped thead[_v-73b45e20] {\n  border-bottom: 1px solid #000; }\n\n/* line 61, stdin */\n.multiselect[_v-73b45e20] {\n  padding-bottom: 5px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-73b45e20", module.exports)
  } else {
    hotAPI.update("_v-73b45e20", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/get-iterator":46,"babel-runtime/core-js/object/entries":54,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/defineProperty":65,"babel-runtime/helpers/extends":66,"babel-runtime/helpers/slicedToArray":70,"babel-runtime/regenerator":75,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1352:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.page-div[_v-7a38f4aa] {\n  padding: 0px 15px;\n  margin-bottom: 15px; }\n\n/* line 7, stdin */\n.table-div[_v-7a38f4aa] {\n  padding: 20px 0px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _watch;

var _vuex = require('vuex');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            display: 'show',
            details: [],
            summaries: [],
            detailsTotal: {},
            summariesTotal: {},
            detailKeys: [],
            detailNames: {},
            csvConfig: {
                column: [],
                fileName: 'DailySale',
                jsonData: []
            },
            csvConfigSummary: {
                column: [],
                fileName: 'DailySale-Summary',
                jsonData: []
            }
        };
    },
    mounted: function mounted() {
        var _this = this;

        this.configuredRun(function () {
            _this.changeFilterOption({
                prop: 'studioId',
                value: {
                    id: _this.configureStates.studioId,
                    brand_name: ''
                }
            });
            _this.changeFilterOption({
                prop: 'branchId',
                value: _this.configureStates.branchId
            });
            if (_this.configureStates.isSeventeen) {
                return _this.fetchStudioList();
            }
            if (_this.configureStates.isBranch) {
                _this.branchIds = [{
                    'id': _this.configureStates.branchId,
                    'branch_name': ''
                }];
            }
        });

        this.syncDateAndDisplayByQuery();
        this.$nextTick(function () {
            _this.changeDateOption({
                prop: 'startDate',
                value: moment().add(-1, 'days').format('YYYY/MM/DD')
            });
            _this.changeDateOption({
                prop: 'endDate',
                value: moment().add(-1, 'days').format('YYYY/MM/DD')
            });
        });
    },

    watch: (_watch = {}, (0, _defineProperty3.default)(_watch, 'filterOptions.studioId', function filterOptionsStudioId(n, o) {
        if (this.configureStates.isSeventeen || this.configureStates.isStudio) {
            this.fetchBranchList({
                studioId: n.id
            });
        }
    }), (0, _defineProperty3.default)(_watch, 'details', function details(newValue, oldValue) {
        var _this2 = this;

        this.$nextTick(function () {
            if (newValue.length > 0 && _this2.display === 'export' && _this2.viewMode === 'detail') {
                _this2.downloadCsv();
            }
        });
    }), (0, _defineProperty3.default)(_watch, 'summaries', function summaries(newValue, oldValue) {
        var _this3 = this;

        this.$nextTick(function () {
            if ((0, _keys2.default)(newValue).length > 0 && _this3.display === 'export' && _this3.viewMode === 'summary') {
                _this3.downloadCsvSummary();
            }
        });
    }), _watch),
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        configureStates: function configureStates(state) {
            return state.webadmin.configure;
        }
    }), (0, _vuex.mapState)('webadmin/configure', ['configured', 'studioList', 'branchList', 'branchId']), (0, _vuex.mapState)("webadmin/baseReport", ["blockOpenStatus", "dateOptions", "filterOptions", "itemOptions", "ajaxing"]), {
        studioId: {
            get: function get() {
                return this.filterOptions.studioId;
            },
            set: function set(newValue) {
                var _this4 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                    return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.next = 2;
                                    return _this4.changeFilterOption({ 'prop': 'studioId', value: newValue });

                                case 2:
                                    newValue.id ? $17.updateUrlQueryString({ studio_id: newValue.id }) : null;
                                    _this4.cleanBranch();

                                    if (!newValue) {
                                        _context.next = 7;
                                        break;
                                    }

                                    _context.next = 7;
                                    return _this4.fetchBranchList({ studioId: newValue.id });

                                case 7:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this4);
                }))();
            }
        },
        branchIds: {
            get: function get() {
                return this.filterOptions.branchIds;
            },
            set: function set(newValue) {
                var _this5 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                    return _regenerator2.default.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    _context2.next = 2;
                                    return _this5.changeFilterOption({ 'prop': 'branchIds', value: newValue });

                                case 2:
                                case 'end':
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, _this5);
                }))();
            }
        },
        viewMode: {
            get: function get() {
                return this.itemOptions.viewMode;
            },
            set: function set(value) {
                this.changeItemOption({ prop: 'viewMode', value: value });
            }
        },
        summaryListKey: function summaryListKey() {
            var allKey = (0, _keys2.default)(this.summariesTotal.sub_total);
            var index = allKey.indexOf('total');
            allKey.splice(index, 1);
            index = allKey.indexOf('date');
            allKey.splice(index, 1);
            return allKey;
        },
        records: function records() {
            var r = _lodash2.default.sortBy(this.details, 'sortKey');
            return { records: r, pageMeta: {} };
        },
        summery_records: function summery_records() {
            return { records: this.summaries, pageMeta: {} };
        },
        tableConfigSummary: function tableConfigSummary() {
            var _this6 = this;

            if (!this.summariesTotal.hasOwnProperty('name')) return { columns: [] };
            var vm = this;
            var columns = [{ keys: 'date', head: '日期' }, {
                keys: 'total',
                head: this.summariesTotal.name['total'],
                html: function html(item) {
                    return item['total'] < 0 ? '<span style="color: red;">' + vm.thousandthFormat(item['total']) + '</span>' : vm.thousandthFormat(item['total']);
                }
            }];
            this.summaryListKey.forEach(function (key) {
                columns.push({
                    keys: key,
                    head: _this6.summariesTotal.name[key],
                    html: function html(item) {
                        return item[key] < 0 ? '<span style="color: red;">' + vm.thousandthFormat(item[key]) + '</span>' : vm.thousandthFormat(item[key]);
                    }
                });
            });
            var topThRow = {};
            for (var i in this.summariesTotal.sub_total) {
                topThRow[i] = this.summariesTotal.sub_total[i] < 0 ? '<span style="color: red;">' + vm.thousandthFormat(this.summariesTotal.sub_total[i]) + '</span>' : vm.thousandthFormat(this.summariesTotal.sub_total[i]);
            }
            topThRow['date'] = '總計';
            return { columns: columns, topThRow: topThRow };
        },
        tableConfig: function tableConfig() {
            var _this7 = this;

            var vm = this;
            var columns = [{ keys: 'checkout_date', head: '日期' }, { keys: 'name', head: '場館' }, {
                keys: 'total',
                head: '當日營業總計',
                html: function html(item) {
                    return item['total'] < 0 ? '<span style="color: red;">' + vm.thousandthFormat(item['total']) + '</span>' : vm.thousandthFormat(item['total']);
                }
            }];

            var _loop = function _loop(i) {
                columns.push({
                    keys: i,
                    head: _this7.detailNames[i],
                    html: function html(item) {
                        return item[i] < 0 || i.includes('outcome') ? '<span style="color: red;">' + vm.thousandthFormat(item[i]) + '</span>' : vm.thousandthFormat(item[i]);
                    }
                });
            };

            for (var i in this.detailNames) {
                _loop(i);
            }
            var topThRow = {};
            for (var i in this.detailsTotal) {
                topThRow[i] = this.detailsTotal[i] < 0 || i.includes('outcome') ? '<span style="color: red;">' + vm.thousandthFormat(this.detailsTotal[i]) + '</span>' : vm.thousandthFormat(this.detailsTotal[i]);
            }
            topThRow['name'] = '';
            topThRow['checkout_date'] = '總計';
            return { columns: columns, topThRow: topThRow };
        }
    }),
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('webadmin/configure', ['configuredRun', 'fetchStudioList', 'fetchBranchList']), (0, _vuex.mapActions)('webadmin/baseReport', ['changeAjaxing', 'beforeSubmit', 'toggleBlock', 'changeDateOption', 'changeFilterOption', 'changeItemOption', 'cleanBranch', 'changeDateOptionAfter', 'syncDateAndDisplayByQuery', 'syncRelatedMultipleSelectByQuery']), {
        downloadCsvSummary: function downloadCsvSummary() {
            var _this8 = this;

            if (!this.summariesTotal.hasOwnProperty('name')) return;
            var columns = [{ keys: 'date', name: '日期' }, { keys: 'total', name: this.summariesTotal.name['total'] }];
            this.summaryListKey.forEach(function (key) {
                columns.push({ keys: key, name: _this8.summariesTotal.name[key] });
            });

            var newData = _lodash2.default.cloneDeep(this.summery_records.records);
            newData.unshift(this.summariesTotal.sub_total);

            this.csvConfigSummary.column = columns;
            this.csvConfigSummary.jsonData = newData;

            this.$nextTick(function () {
                _this8.$refs.summary_smart_table.downloadCsv();
            });
        },
        downloadCsv: function downloadCsv() {
            var _this9 = this;

            var columns = [{ keys: 'checkout_date', name: '日期' }, { keys: 'name', name: '場館' }];
            for (var i in this.detailNames) {
                columns.push({ keys: i, name: this.detailNames[i] });
            }
            columns.push({ keys: 'total', name: '當日營業總計' });

            var newData = _lodash2.default.cloneDeep(this.records.records);
            newData.unshift(this.detailsTotal);

            this.csvConfig.column = columns;
            this.csvConfig.jsonData = newData;

            this.$nextTick(function () {
                _this9.$refs.detail_smart_table.downloadCsv();
            });
        },
        submitSearch: function submitSearch() {
            var _this10 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _this10.beforeSubmit();

                                if (!(moment.duration(moment({ hour: 0, minute: 0, seconds: 0 }).diff(_this10.dateOptions.endDate)).asDays() <= 0)) {
                                    _context3.next = 3;
                                    break;
                                }

                                return _context3.abrupt('return', $17.formatErrorAlert('日期: 結束日期不可大於昨天'));

                            case 3:
                                _context3.next = 5;
                                return _this10.getQueryResult();

                            case 5:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this10);
            }))();
        },
        getQueryResult: function getQueryResult() {
            var _this11 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
                var postData;
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                postData = {
                                    studio_id: _this11.filterOptions.studioId && _this11.filterOptions.studioId.hasOwnProperty('id') ? _this11.filterOptions.studioId.id : 0,
                                    branch_ids: _this11.filterOptions.branchIds.map(function (elem) {
                                        return elem.id;
                                    }),
                                    start_date: _this11.dateOptions.startDate,
                                    end_date: _this11.dateOptions.endDate
                                };

                                _this11.changeAjaxing(true);
                                _context4.next = 4;
                                return _this11.$http.post('/adminapi/report/fetch_branch_sale_daily_summary', postData).then(function (response) {
                                    _this11.changeAjaxing(false);
                                    _this11.details = response.data.details;
                                    _this11.detailKeys = response.data.details_keys;
                                    _this11.detailNames = response.data.details_names;
                                    _this11.summaries = response.data.summaries;
                                    _this11.detailsTotal = response.data.details_total;
                                    _this11.summariesTotal = response.data.summaries_total;
                                }).catch(function (err) {
                                    _this11.changeAjaxing(false);
                                });

                            case 4:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this11);
            }))();
        },
        thousandthFormat: function thousandthFormat(money) {
            money = Math.abs(money);
            money = $17.thousandthFormat(money);
            return '$' + money;
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"page-div\" _v-7a38f4aa=\"\">\n    <v-webadmin-report :block-open-status=\"blockOpenStatus\" :date-options=\"dateOptions\" :toggle-block=\"toggleBlock\" :change-date-option=\"changeDateOptionAfter\" :disable-submit=\"ajaxing\" :submit=\"submitSearch\" limit-date=\"90\" title=\"每日營業彙總表\" _v-7a38f4aa=\"\">\n        <div slot=\"second-block\" _v-7a38f4aa=\"\">\n            <div class=\"row\" _v-7a38f4aa=\"\">\n                <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen\" _v-7a38f4aa=\"\">\n                    <div class=\"form-group\" _v-7a38f4aa=\"\">\n                        <v-mutiselect :model.sync=\"studioId\" :options=\"studioList\" :preserve-search=\"true\" :placeholder=\"configureStates.ajaxing.studioList ? '品牌讀取中…' : '請選擇品牌'\" label=\"brand_name\" track-by=\"id\" _v-7a38f4aa=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n                <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen || configureStates.isStudio\" _v-7a38f4aa=\"\">\n                    <div class=\"form-group\" _v-7a38f4aa=\"\">\n                        <v-mutiselect :model.sync=\"branchIds\" :options=\"branchList\" :disabled=\"configureStates.ajaxing.branchList\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"false\" :placeholder=\"configureStates.ajaxing.branchList ? '場館讀取中…' : '全部場館'\" label=\"branch_name\" track-by=\"id\" :taggable=\"true\" tag-name=\"branch_name\" :max-height=\"500\" _v-7a38f4aa=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div slot=\"third-block\" _v-7a38f4aa=\"\">\n            <div class=\"row\" _v-7a38f4aa=\"\">\n                <div class=\"col-sm-6\" _v-7a38f4aa=\"\">\n                    <div class=\"form-group\" _v-7a38f4aa=\"\">\n                        <label _v-7a38f4aa=\"\">\n                            <input name=\"view\" type=\"radio\" value=\"detail\" v-model=\"viewMode\" checked=\"\" _v-7a38f4aa=\"\"> 顯示細節\n                        </label>\n                        <label _v-7a38f4aa=\"\">\n                            <input name=\"view\" type=\"radio\" value=\"summary\" v-model=\"viewMode\" _v-7a38f4aa=\"\"> 顯示總和\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div slot=\"fourth-block\" _v-7a38f4aa=\"\">\n            <div class=\"row\" _v-7a38f4aa=\"\">\n                <div class=\"col-sm-6\" _v-7a38f4aa=\"\">\n                    <div class=\"form-group row\" _v-7a38f4aa=\"\">\n                        <label _v-7a38f4aa=\"\">\n                            <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"show\" checked=\"\" _v-7a38f4aa=\"\"> 顯示於網頁\n                        </label>\n                        <label _v-7a38f4aa=\"\">\n                            <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"export\" _v-7a38f4aa=\"\"> 匯出 CSV\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </v-webadmin-report>\n    <div v-show=\"display==='show'\" _v-7a38f4aa=\"\">\n        <div class=\"table-div\" _v-7a38f4aa=\"\">\n            <v-smart-table v-if=\"viewMode === 'detail'\" ref=\"detail_smart_table\" :table-config=\"tableConfig\" :csv-config=\"csvConfig\" :is-ajaxing=\"ajaxing\" :data=\"records\" :page-sync-url-query=\"false\" _v-7a38f4aa=\"\"></v-smart-table>\n            <v-smart-table v-if=\"viewMode === 'summary'\" ref=\"summary_smart_table\" :table-config=\"tableConfigSummary\" :csv-config=\"csvConfigSummary\" :is-ajaxing=\"ajaxing\" :data=\"summery_records\" :page-sync-url-query=\"false\" _v-7a38f4aa=\"\"></v-smart-table>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.page-div[_v-7a38f4aa] {\n  padding: 0px 15px;\n  margin-bottom: 15px; }\n\n/* line 7, stdin */\n.table-div[_v-7a38f4aa] {\n  padding: 20px 0px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-7a38f4aa", module.exports)
  } else {
    hotAPI.update("_v-7a38f4aa", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/object/keys":56,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/defineProperty":65,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1353:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\nh4[_v-4af1fdb6] {\n  display: inline;\n  padding-right: 30px; }\n\n/* line 7, stdin */\n.page-div[_v-4af1fdb6] {\n  padding: 0 15px;\n  margin-bottom: 15px; }\n\n/* line 12, stdin */\n.table-div[_v-4af1fdb6] {\n  padding: 20px 0; }\n\n/* line 16, stdin */\n.total-list[_v-4af1fdb6] {\n  margin: 15px 0; }\n\n/* line 20, stdin */\n.total-list[_v-4af1fdb6]:after {\n  clear: both; }\n\n/* line 24, stdin */\n.table-striped thead[_v-4af1fdb6] {\n  border-bottom: 1px solid #000; }\n\n/* line 28, stdin */\n.multiselect[_v-4af1fdb6] {\n  padding-bottom: 5px; }\n\n/* line 32, stdin */\n.negative-number[_v-4af1fdb6] {\n  color: red; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    mounted: function mounted() {
        var _this = this;

        //日期限今天不可更改
        $('.first-block-default').text(moment().format('YYYY/MM/DD'));
        this.configuredRun(function () {
            _this.changeFilterOption({
                prop: 'studioId',
                value: {
                    id: _this.configureStates.studioId,
                    brand_name: ''
                }
            });
            if (_this.configureStates.isBranch) {
                _this.branchIds = [{
                    'id': _this.configureStates.branchId,
                    'branch_name': ''
                }];
            }
            _this.changeFilterOption({
                prop: 'checkoutMemberIsMe',
                value: 1
            });
        });
        this.changeDateOption({
            prop: 'startDate',
            value: moment().format('YYYY/MM/DD')
        });
        this.changeDateOption({
            prop: 'endDate',
            value: moment().format('YYYY/MM/DD')
        });
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        configureStates: function configureStates(state) {
            return state.webadmin.configure;
        }
    }), (0, _vuex.mapState)('webadmin/configure', ['configured']), (0, _vuex.mapState)('webadmin/checkoutReport', ['blockOpenStatus', 'dateOptions', 'filterOptions', 'ajaxing', 'list', 'invoice_order_total', 'invoice_total', 'allowance_order_total', 'allowance_total', 'total_by_payment', 'total_by_branch', 'confirmStatus', 'issueStatusShow', 'initTotalPayments', 'initBranchTotalPayments']), {
        studioId: {
            get: function get() {
                return this.filterOptions.studioId;
            },
            set: function set(newValue) {
                var _this2 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                    return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.next = 2;
                                    return _this2.changeFilterOption({ 'prop': 'studioId', value: newValue });

                                case 2:
                                    _this2.cleanBranch();

                                    if (!newValue) {
                                        _context.next = 6;
                                        break;
                                    }

                                    _context.next = 6;
                                    return _this2.fetchBranchList({ studioId: newValue.id });

                                case 6:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this2);
                }))();
            }
        },
        branchIds: {
            get: function get() {
                return this.filterOptions.branchIds;
            },
            set: function set(newValue) {
                var _this3 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                    return _regenerator2.default.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    _context2.next = 2;
                                    return _this3.changeFilterOption({ 'prop': 'branchIds', value: newValue });

                                case 2:
                                case 'end':
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, _this3);
                }))();
            }
        },
        issueStatuses: {
            get: function get() {
                return this.filterOptions.issueStatuses;
            },
            set: function set(newValue) {
                var _this4 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
                    return _regenerator2.default.wrap(function _callee3$(_context3) {
                        while (1) {
                            switch (_context3.prev = _context3.next) {
                                case 0:
                                    _context3.next = 2;
                                    return _this4.$store.dispatch('webadmin/checkoutReport/changeFilterOption', { 'prop': 'issueStatuses', value: newValue });

                                case 2:
                                case 'end':
                                    return _context3.stop();
                            }
                        }
                    }, _callee3, _this4);
                }))();
            }
        },
        onlyMyselfStaff: {
            get: function get() {
                return this.filterOptions.onlyMyselfStaff;
            },
            set: function set(newValue) {
                var _this5 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
                    return _regenerator2.default.wrap(function _callee4$(_context4) {
                        while (1) {
                            switch (_context4.prev = _context4.next) {
                                case 0:
                                    _context4.next = 2;
                                    return _this5.$store.dispatch('webadmin/checkoutReport/changeFilterOption', { 'prop': 'selectedStaff', value: newValue });

                                case 2:
                                case 'end':
                                    return _context4.stop();
                            }
                        }
                    }, _callee4, _this5);
                }))();
            }
        },
        viewMode: {
            get: function get() {
                return this.$store.state.webadmin.checkoutReport.itemOptions.viewMode;
            },
            set: function set(value) {
                this.changeItemOption({
                    prop: 'viewMode',
                    value: value
                });
            }
        }
    }),
    methods: (0, _extends3.default)({
        checkMode: function checkMode(mode) {
            return this.viewMode === mode;
        },
        thousandthFormat: function thousandthFormat(money) {
            return $17.thousandthFormat(money);
        }
    }, (0, _vuex.mapActions)('webadmin/configure', ['configuredRun', 'fetchStudioList', 'fetchBranchList', 'pushObjectStatus']), (0, _vuex.mapActions)('webadmin/checkoutReport', ['submitCheckoutMemberReport', 'toggleBlock', 'changeDateOption', 'changeFilterOption', 'changeItemOption', 'cleanBranch', 'cleanBranchRelated']), {
        generatePaymentDisplayName: function generatePaymentDisplayName(payment) {
            var _this6 = this;

            var result = '';
            payment.forEach(function (item) {
                result += _this6.paymentDisplayName(item);
            });
            return result;
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"page-div\" _v-4af1fdb6=\"\">\n    <v-webadmin-report :block-open-status=\"blockOpenStatus\" :date-options=\"dateOptions\" :toggle-block=\"toggleBlock\" :change-date-option=\"changeDateOption\" :disable-submit=\"ajaxing\" :submit=\"submitCheckoutMemberReport\" limit-date=\"1\" title=\"個別銷售人員結帳紀錄\" _v-4af1fdb6=\"\">\n        <div slot=\"second-block\" _v-4af1fdb6=\"\">\n            <div class=\"filters\" _v-4af1fdb6=\"\">\n                <div class=\"row\" _v-4af1fdb6=\"\">\n                    <div class=\"col-sm-6\" _v-4af1fdb6=\"\">\n                        <div class=\"form-group\" _v-4af1fdb6=\"\">\n                            <v-mutiselect :model.sync=\"issueStatuses\" :options=\"issueStatusShow\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"false\" :placeholder=\"issueStatuses.length>0 ? '' : '所有發票狀態'\" label=\"name\" track-by=\"status\" :max-height=\"500\" tag-name=\"name\" _v-4af1fdb6=\"\">\n                            </v-mutiselect>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div slot=\"third-block\" _v-4af1fdb6=\"\">\n            <div class=\"row\" _v-4af1fdb6=\"\">\n                <div class=\"col-sm-6\" _v-4af1fdb6=\"\">\n                    <div class=\"form-group\" _v-4af1fdb6=\"\">\n                        <label _v-4af1fdb6=\"\">\n                            <input name=\"view\" type=\"radio\" value=\"detail\" v-model=\"viewMode\" checked=\"\" _v-4af1fdb6=\"\"> 顯示細節\n                        </label>\n                        <label _v-4af1fdb6=\"\">\n                            <input name=\"view\" type=\"radio\" value=\"summary\" v-model=\"viewMode\" _v-4af1fdb6=\"\"> 顯示總和\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </v-webadmin-report>\n    <div class=\"row total-list\" v-if=\"Object.keys(list).length>0\" _v-4af1fdb6=\"\">\n        <div class=\"col-sm-12\" _v-4af1fdb6=\"\">\n            <h4 _v-4af1fdb6=\"\">總銷售金額: {{thousandthFormat(invoice_order_total)}}</h4>\n            <h4 _v-4af1fdb6=\"\">總開立金額: {{thousandthFormat(invoice_total)}}</h4>\n            <h4 _v-4af1fdb6=\"\">總退費金額: {{thousandthFormat(allowance_order_total)}}</h4>\n            <h4 _v-4af1fdb6=\"\">總折讓金額: {{thousandthFormat(allowance_total)}}</h4>\n        </div>\n        <div class=\"col-sm-12 m-top-20\" _v-4af1fdb6=\"\">\n            <h4 v-for=\"payment in total_by_payment\" _v-4af1fdb6=\"\">\n                {{ paymentDisplayName(payment) }}淨收入：\n                <span :class=\"[payment.income+payment.refund<0?'negative-number':'']\" _v-4af1fdb6=\"\">\n                    {{thousandthFormat(payment.income+payment.refund)}}\n                </span>\n            </h4>\n        </div>\n    </div>\n    <div class=\"table-div\" _v-4af1fdb6=\"\">\n        <v-table v-if=\"checkMode('detail')\" :ajaxing=\"ajaxing\" :length=\"Object.keys(list).length\" _v-4af1fdb6=\"\">\n            <table class=\"table table-striped\" _v-4af1fdb6=\"\">\n                <thead _v-4af1fdb6=\"\">\n                <tr _v-4af1fdb6=\"\">\n                    <td _v-4af1fdb6=\"\">訂單編號</td>\n                    <td _v-4af1fdb6=\"\">場館</td>\n                    <td _v-4af1fdb6=\"\">結帳日期</td>\n                    <td _v-4af1fdb6=\"\">銷售 (退費) 金額</td>\n                    <td _v-4af1fdb6=\"\">發票開立 (折讓) 金額</td>\n                    <td _v-4af1fdb6=\"\">發票號碼</td>\n                    <td _v-4af1fdb6=\"\">狀態</td>\n                    <td _v-4af1fdb6=\"\">支付方式</td>\n                </tr>\n                </thead>\n                <tbody _v-4af1fdb6=\"\">\n                <tr v-for=\"item in list\" _v-4af1fdb6=\"\">\n                    <td _v-4af1fdb6=\"\">{{ item.order_id }}</td>\n                    <td _v-4af1fdb6=\"\">{{ item.branch_name }}</td>\n                    <td _v-4af1fdb6=\"\">{{ item.checkout_at }}</td>\n                    <td v-if=\"((item.status==2||item.status==3)&amp;&amp;item.order_total>0)||(item.status==4&amp;&amp;item.order_total<0)\" class=\"negative-number text-center\" _v-4af1fdb6=\"\">({{ Math.abs(item.order_total) }})</td>\n                    <td class=\"text-center\" v-else=\"\" _v-4af1fdb6=\"\">{{ item.order_total }}</td>\n                    <td v-if=\"(item.status==2||item.status==3)&amp;&amp;item.allowance_total>0\" class=\"negative-number text-center\" _v-4af1fdb6=\"\">({{ item.allowance_total }})</td>\n                    <td class=\"text-center\" v-else=\"\" _v-4af1fdb6=\"\">{{ item.invoice_total }}</td>\n                    <td _v-4af1fdb6=\"\">{{ item.invoice_number }}</td>\n                    <td _v-4af1fdb6=\"\">{{ item.status_show }}</td>\n                    <td _v-4af1fdb6=\"\">{{ generatePaymentDisplayName(item.payment_method) }}</td>\n                </tr>\n                </tbody>\n            </table>\n        </v-table>\n        <v-table v-if=\"checkMode('summary')\" :ajaxing=\"ajaxing\" :length=\"Object.keys(list).length\" _v-4af1fdb6=\"\">\n            <table class=\"table table-striped\" _v-4af1fdb6=\"\">\n                <thead _v-4af1fdb6=\"\">\n                <tr _v-4af1fdb6=\"\">\n                    <td class=\"text-center\" _v-4af1fdb6=\"\">場館</td>\n                    <td v-for=\"payment in initTotalPayments\" class=\"text-center\" _v-4af1fdb6=\"\">{{payment}}</td>\n                </tr>\n                </thead>\n                <tbody _v-4af1fdb6=\"\">\n                <tr v-for=\"details in initBranchTotalPayments\" _v-4af1fdb6=\"\">\n                    <td v-for=\"value in details\" class=\"text-center\" _v-4af1fdb6=\"\">{{value}}</td>\n                </tr>\n                </tbody>\n            </table>\n        </v-table>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\nh4[_v-4af1fdb6] {\n  display: inline;\n  padding-right: 30px; }\n\n/* line 7, stdin */\n.page-div[_v-4af1fdb6] {\n  padding: 0 15px;\n  margin-bottom: 15px; }\n\n/* line 12, stdin */\n.table-div[_v-4af1fdb6] {\n  padding: 20px 0; }\n\n/* line 16, stdin */\n.total-list[_v-4af1fdb6] {\n  margin: 15px 0; }\n\n/* line 20, stdin */\n.total-list[_v-4af1fdb6]:after {\n  clear: both; }\n\n/* line 24, stdin */\n.table-striped thead[_v-4af1fdb6] {\n  border-bottom: 1px solid #000; }\n\n/* line 28, stdin */\n.multiselect[_v-4af1fdb6] {\n  padding-bottom: 5px; }\n\n/* line 32, stdin */\n.negative-number[_v-4af1fdb6] {\n  color: red; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-4af1fdb6", module.exports)
  } else {
    hotAPI.update("_v-4af1fdb6", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1354:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.page-div[_v-0c2ccb74] {\n  padding: 0px 15px;\n  margin-bottom: 15px; }\n\n/* line 6, stdin */\n.table-div[_v-0c2ccb74] {\n  padding: 20px 0px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            paymentSourceRecordCategories: [],
            paymentSourceRecordCategory: null,
            ajaxingPaymentSourceRecordCategory: false,
            detailList: {},
            export: {},
            colConfig: {
                columns: [{ keys: "sale_total", head: "總銷售金額" }, { keys: "issue_total", head: "總開立金額" }, { keys: "refund_total", head: "總退費金額" }, { keys: "allowance_total", head: "總折讓金額" }]
            },
            summaryList: {},
            paymentColConfig: {
                columns: []
            },
            paymentList: {},
            tableSummaryConfig: {
                columns: []
            },
            csvSummaryConfig: {
                column: []
            },
            summaryDetailList: {},
            tableConfig: {
                columns: [{ keys: "order_id", head: "訂單編號" }, { keys: "branch_name", head: "場館" }, { keys: "checkout_at", head: "結帳日期" }, { keys: "total", head: "銷售(退費)金額",
                    html: function html(item) {
                        if (item.total_raw < 0) {
                            return '<span style="color:red">' + item.total + '</span>';
                        }
                        return '<span style="color:gray">' + item.total + '</span>';
                    }
                }, { keys: "issued_total", head: "發票開立(折讓)金額",
                    html: function html(item) {
                        if (item.issued_total_raw < 0) {
                            return '<span style="color:red">' + item.issued_total + '</span>';
                        }
                        return '<span style="color:gray">' + item.issued_total + '</span>';
                    }
                }, { keys: "invoice_number", head: "發票號碼" }, { keys: "issued_status", head: "狀態" }, { keys: "checkout_member", head: "結帳人員" }, { keys: "payment_action_record_name", head: "交易方式" }]
            },
            csvConfig: {
                column: [{ keys: "order_id", name: "訂單編號" }, { keys: "branch_name", name: "場館" }, { keys: "checkout_at", name: "結帳日期" }, { keys: "total", name: "銷售(退費)金額" }, { keys: "issued_total", name: "發票開立(折讓)金額" }, { keys: "invoice_number", name: "發票號碼" }, { keys: "issued_status", name: "狀態" }, { keys: "checkout_member", name: "結帳人員" }, { keys: "payment_action_record_name", name: "交易方式" }]
            },
            relatedFilterWatcher: {
                studio_id: {
                    watcher: null,
                    options: "studioList",
                    vModel: "studioId",
                    trackBy: "id",
                    type: "single"
                },
                branch_ids: {
                    watcher: "studioId",
                    options: "branchList",
                    vModel: "branchIds",
                    trackBy: "id",
                    type: "multiple"
                },
                staffs: {
                    watcher: "studioId",
                    options: "staffMembers",
                    vModel: "selectedStaff",
                    trackBy: "id",
                    type: "multiple"
                }
            },
            issueStatusShow: [{
                name: "未開立",
                status: 0
            }, {
                name: "已開立",
                status: 1
            }, {
                name: "未折讓",
                status: 2
            }, {
                name: "已折讓",
                status: 3
            }, {
                name: "手動輸入",
                status: 4
            }],
            issueStatuses: [],
            selectedStaff: [],
            staffMembers: [],
            multiFilter: {
                issue_statuses: {
                    watcher: null,
                    options: "issueStatusShow",
                    vModel: "issueStatuses",
                    trackBy: "status",
                    type: "multiple"
                }
            },
            staffAjaxing: false
        };
    },
    created: function created() {
        this.syncLocalMultipleSelectByQuery({ vm: this, multiFilter: this.multiFilter });
        this.syncRelatedMultipleSelectByQuery({ vm: this, relatedFilterWatcher: this.relatedFilterWatcher });
    },
    mounted: function mounted() {
        var _this = this;

        this.syncDateAndDisplayByQuery({
            'diffType': 'week',
            'diffNumber': "0"
        });
        this.configuredRun(function () {
            _this.changeFilterOption({
                prop: 'studioId',
                value: {
                    id: _this.configureStates.studioId,
                    brand_name: ''
                }
            });

            _this.changeFilterOption({
                prop: 'branchId',
                value: _this.configureStates.branchId
            });

            if (_this.configureStates.isSeventeen) {
                return _this.fetchStudioList();
            };
            var query = $17.getUrlQueryStrings();
            var viewMode = query.view_mode ? query.view_mode : 'detail';
            _this.changeItemOption({
                prop: 'viewMode',
                value: viewMode
            });
        });

        this.fetchBranchList({ studioId: this.configureStates.studioId });
    },

    watch: {
        'configureStates.isBranch': function configureStatesIsBranch(newVal, oldVal) {
            if (newVal) {
                document.getElementsByClassName("control-box")[1].style.display = "none";
            }
        },
        viewMode: function viewMode() {
            this.detailList = {};
            this.summaryDetailList = {};
            this.tableSummaryConfig.columns = [];
            this.csvSummaryConfig.columns = [];
            this.paymentList = {};
            this.paymentColConfig.columns = [];
            this.summaryList = {};
        },
        studioId: function studioId(newVal) {
            this.initStaff();
            this.selectedStaff = [];
            this.staffMembers = [];
        },

        dateOptions: {
            handler: function handler(n, o) {
                this.initStaff();
            },
            deep: true
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        configureStates: function configureStates(state) {
            return state.webadmin.configure;
        }
    }), (0, _vuex.mapState)('webadmin/configure', ['configured', 'studioList', 'branchList', 'branchId', 'isSeventeen']), (0, _vuex.mapState)('webadmin/baseReport', ['blockOpenStatus', 'dateOptions', 'filterOptions', 'ajaxing', 'itemOptions']), {
        studioId: {
            get: function get() {
                return this.filterOptions.studioId;
            },
            set: function set(newValue) {
                var _this2 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                    return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.next = 2;
                                    return _this2.changeFilterOption({ 'prop': 'studioId', value: newValue });

                                case 2:
                                    _this2.cleanBranch();

                                    if (!newValue) {
                                        _context.next = 6;
                                        break;
                                    }

                                    _context.next = 6;
                                    return _this2.fetchBranchList({ studioId: newValue.id });

                                case 6:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this2);
                }))();
            }
        },
        branchIds: {
            get: function get() {
                return this.filterOptions.branchIds;
            },
            set: function set(newValue) {
                var _this3 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                    return _regenerator2.default.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    _this3.changeFilterOption({ 'prop': 'branchIds', value: newValue });
                                    if (newValue) {
                                        _this3.initStaff();
                                    }

                                case 2:
                                case 'end':
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, _this3);
                }))();
            }
        },
        viewMode: {
            get: function get() {
                return this.itemOptions.viewMode;
            },
            set: function set(value) {
                this.changeItemOption({
                    prop: 'viewMode',
                    value: value
                });
            }
        },
        display: {
            get: function get() {
                return this.$store.state.webadmin.baseReport.display;
            },
            set: function () {
                var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(newValue) {
                    return _regenerator2.default.wrap(function _callee3$(_context3) {
                        while (1) {
                            switch (_context3.prev = _context3.next) {
                                case 0:
                                    _context3.next = 2;
                                    return this.changeDisplay(newValue);

                                case 2:
                                case 'end':
                                    return _context3.stop();
                            }
                        }
                    }, _callee3, this);
                }));

                function set(_x) {
                    return _ref.apply(this, arguments);
                }

                return set;
            }()
        }
    }),
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('webadmin/configure', ['configuredRun', 'fetchStudioList', 'fetchBranchList']), (0, _vuex.mapActions)('webadmin/baseReport', ['beforeSubmit', 'toggleBlock', 'changeDateOption', 'changeFilterOption', 'cleanBranch', 'changeItemOption', 'changeAjaxing', "syncDateAndDisplayByQuery", "syncRelatedMultipleSelectByQuery", "syncLocalMultipleSelectByQuery", "changeDisplay"]), {
        submit: function submit() {
            this.beforeSubmit();
            var data = this.getPara();
            $17.updateUrlQueryString(data, true);
            this.getSummary(data);
            this.getResult(data);
        },
        getPara: function getPara() {
            var data = {
                'start_date': this.dateOptions.startDate,
                'end_date': this.dateOptions.endDate
            };

            if (this.studioId && this.studioId.id) {
                data.studio_id = this.studioId.id;
            }
            if (this.branchIds.length > 0) {
                data.branch_ids = this.branchIds.map(function (item) {
                    return item.id;
                });
            }
            if (this.issueStatuses.length > 0) {
                data.issue_statuses = this.issueStatuses.map(function (item) {
                    return item.status;
                });
            }
            if (this.selectedStaff.length > 0) {
                data.checkout_member_ids = this.selectedStaff.map(function (item) {
                    return item.id;
                });
            }

            data.checkout_member_is_me = 0;
            data.view_mode = this.viewMode;

            return data;
        },
        getSummary: function getSummary(data) {
            var _this4 = this;

            this.paymentList = {};
            this.paymentColConfig.columns = [];
            this.summaryList = {};

            this.$http.get('/adminapi/report/fetch-checkout-member-order-summary', { params: data }).then(function (response) {
                _this4.summaryList = response.data.total;
                _this4.paymentColConfig.columns = response.data.payment_cols;
                _this4.paymentList = response.data.payments;
            }, function (error) {
                $17.swal({
                    title: error.body.message,
                    type: 'warning'
                });
            });
        },
        getResult: function getResult(params) {
            var _this5 = this;

            var data = params;

            switch (this.display) {
                case "export":
                    data.page_size = 9999999;
                    break;
                case "summary":
                    data.page_size = 25;
                    break;
                default:
                    null;
            }
            this.changeAjaxing(true);

            if (this.viewMode == 'detail') {
                this.$http.get('/adminapi/report/fetch-checkout-member-order-detail', { params: data }).then(function (response) {
                    if (_this5.display == 'export') {
                        _this5.csvConfig.jsonData = response.data.records;
                        _this5.$nextTick(function () {
                            _this5.$refs.smart_table.downloadCsv();
                        });
                    }

                    if (_this5.display == 'show') {
                        _this5.detailList = response.data;
                    }
                    _this5.changeAjaxing(false);
                }, function (error) {
                    _this5.changeAjaxing(false);
                    $17.swal({
                        title: error.body.message,
                        type: 'warning'
                    });
                });
            }

            if (this.viewMode == 'summary') {
                this.$http.get('/adminapi/report/fetch-checkout-member-order-branch-summary', { params: data }).then(function (response) {
                    if (_this5.display == 'export') {
                        _this5.csvSummaryConfig.column = response.data.cols;
                        _this5.csvSummaryConfig.jsonData = response.data.records;

                        _this5.$nextTick(function () {
                            _this5.$refs.summary_smart_table.downloadCsv();
                        });
                    }

                    if (_this5.display == 'show') {
                        _this5.tableSummaryConfig.columns = response.data.cols;
                        _this5.summaryDetailList = response.data;
                    }
                    _this5.changeAjaxing(false);
                }, function (error) {
                    _this5.changeAjaxing(false);
                    $17.swal({
                        title: error.body.message,
                        type: 'warning'
                    });
                });
            }
        },
        changePage: function changePage(page) {
            var _this6 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
                var params;
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _this6.changeFilterOption({
                                    prop: "page",
                                    value: page
                                });

                                params = _this6.getPara();


                                params.page_size = _this6.filterOptions.pageSize;
                                params.page = _this6.filterOptions.page;

                                _context4.next = 6;
                                return _this6.getResult(params);

                            case 6:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this6);
            }))();
        },
        initStaff: function initStaff() {
            var _this7 = this;

            var branchIds = this.branchIds.map(function (elem) {
                return elem.id;
            });

            var postData = {
                params: {
                    branch_ids: branchIds,
                    start_date: this.dateOptions.startDate,
                    end_date: this.dateOptions.endDate
                }
            };

            if (!this.studioId || this.studioId.id == "0") {
                return;
            }
            this.staffAjaxing = true;
            this.$http.get('/adminapi/pos/checkout_members/studio/' + this.studioId.id, postData).then(function (response) {
                _this7.staffAjaxing = false;
                _this7.staffMembers = response.data.members;
            });
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"page-div\" _v-0c2ccb74=\"\">\n    <v-webadmin-report :block-open-status=\"blockOpenStatus\" :date-options=\"dateOptions\" :toggle-block=\"toggleBlock\" :change-date-option=\"changeDateOption\" ref=\"report\" :submit=\"submit\" limit-date=\"90\" title=\"全體銷售人員結帳紀錄\" _v-0c2ccb74=\"\">\n        <div slot=\"second-block\" _v-0c2ccb74=\"\">\n            <div class=\"row\" _v-0c2ccb74=\"\">\n                <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen\" _v-0c2ccb74=\"\">\n                    <div class=\"form-group\" _v-0c2ccb74=\"\">\n                        <v-mutiselect :model.sync=\"studioId\" :options=\"studioList\" :preserve-search=\"true\" :placeholder=\"configureStates.ajaxing.studioList ? '品牌讀取中…' : '請選擇品牌'\" label=\"brand_name\" track-by=\"id\" _v-0c2ccb74=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n                <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen || configureStates.isStudio\" _v-0c2ccb74=\"\">\n                    <div class=\"form-group\" _v-0c2ccb74=\"\">\n                        <v-mutiselect :model.sync=\"branchIds\" :options=\"branchList\" :disabled=\"configureStates.ajaxing.branchList\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"false\" :placeholder=\"configureStates.ajaxing.branchList ? '場館讀取中…' : '全部場館'\" label=\"branch_name\" track-by=\"id\" :taggable=\"true\" tag-name=\"branch_name\" _v-0c2ccb74=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n                <div class=\"col-sm-6\" _v-0c2ccb74=\"\">\n                    <div class=\"form-group\" _v-0c2ccb74=\"\">\n                        <v-mutiselect :model.sync=\"selectedStaff\" :options=\"staffMembers\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"true\" :placeholder=\"staffAjaxing ? '結帳人員讀取中…' : '全部結帳人員'\" label=\"name\" track-by=\"id\" :max-height=\"500\" tag-name=\"name\" _v-0c2ccb74=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n                <div class=\"col-sm-6\" _v-0c2ccb74=\"\">\n                    <div class=\"form-group\" _v-0c2ccb74=\"\">\n                        <v-mutiselect :model.sync=\"issueStatuses\" :options=\"issueStatusShow\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"false\" :placeholder=\"issueStatuses.length>0 ? '' : '所有發票狀態'\" label=\"name\" track-by=\"status\" :max-height=\"500\" tag-name=\"name\" _v-0c2ccb74=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div slot=\"third-block\" _v-0c2ccb74=\"\">\n            <div class=\"row\" _v-0c2ccb74=\"\">\n                <div class=\"col-sm-6\" _v-0c2ccb74=\"\">\n                    <div class=\"form-group\" _v-0c2ccb74=\"\">\n                        <label _v-0c2ccb74=\"\">\n                            <input name=\"view\" type=\"radio\" value=\"detail\" v-model=\"viewMode\" checked=\"\" _v-0c2ccb74=\"\"> 顯示細節\n                        </label>\n                        <label _v-0c2ccb74=\"\">\n                            <input name=\"view\" type=\"radio\" value=\"summary\" v-model=\"viewMode\" _v-0c2ccb74=\"\"> 顯示總和\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div slot=\"fourth-block\" _v-0c2ccb74=\"\">\n            <div class=\"row\" _v-0c2ccb74=\"\">\n                <div class=\"col-sm-6\" _v-0c2ccb74=\"\">\n                    <div class=\"form-group\" _v-0c2ccb74=\"\">\n                        <label _v-0c2ccb74=\"\">\n                            <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"show\" checked=\"\" _v-0c2ccb74=\"\"> 顯示於網頁\n                        </label>\n                        <label _v-0c2ccb74=\"\">\n                            <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"export\" _v-0c2ccb74=\"\"> 匯出CSV\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </v-webadmin-report>\n    <div v-show=\"display === 'show'\" _v-0c2ccb74=\"\">\n        <div class=\"m-top-30 m-bottom-20\" _v-0c2ccb74=\"\">\n            <div class=\"m-top-15\" _v-0c2ccb74=\"\">\n            <v-smart-table-summary :col-config=\"colConfig\" :data=\"summaryList\" _v-0c2ccb74=\"\"></v-smart-table-summary>\n            </div>\n            <div class=\"m-top-15\" _v-0c2ccb74=\"\">\n            <v-smart-table-summary :col-config=\"paymentColConfig\" :data=\"paymentList\" _v-0c2ccb74=\"\"></v-smart-table-summary>\n            </div>\n        </div>\n        <div class=\"m-top-20\" _v-0c2ccb74=\"\">\n            <v-smart-table v-if=\"viewMode=='detail'\" ref=\"smart_table\" :table-config=\"tableConfig\" :csv-config=\"csvConfig\" :is-ajaxing=\"ajaxing\" :data=\"detailList\" :page-sync-url-query=\"false\" @change-page=\"changePage\" _v-0c2ccb74=\"\"></v-smart-table>\n\n            <v-smart-table v-if=\"viewMode=='summary'\" ref=\"summary_smart_table\" :table-config=\"tableSummaryConfig\" :csv-config=\"csvSummaryConfig\" :is-ajaxing=\"ajaxing\" :data=\"summaryDetailList\" :page-sync-url-query=\"false\" _v-0c2ccb74=\"\"></v-smart-table>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.page-div[_v-0c2ccb74] {\n  padding: 0px 15px;\n  margin-bottom: 15px; }\n\n/* line 6, stdin */\n.table-div[_v-0c2ccb74] {\n  padding: 20px 0px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-0c2ccb74", module.exports)
  } else {
    hotAPI.update("_v-0c2ccb74", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1355:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.page-div[_v-53a01092] {\n  padding: 0px 15px;\n  margin-bottom: 15px; }\n\n/* line 6, stdin */\n.table-div[_v-53a01092] {\n  padding: 20px 0px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _watch;

var _vuex = require('vuex');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            paymentSourceRecordTypes: [],
            paymentSourceRecordType: null,
            ajaxingPaymentSourceRecordType: false,
            detailList: {},
            export: [],
            colConfig: {
                columns: [{ keys: "should_pay_total", head: "交易總額" }, { keys: "expense_total", head: "費用總額" }]
            },
            summaryList: {},
            tableConfig: {
                columns: [{ keys: "created_at", head: "購買日期時間" }, { keys: "order_id", head: "訂單編號" }, { keys: "studio_name", head: "品牌名稱" }, { keys: "branch_name", head: "場館名稱" }, { keys: "contract_name", head: "項目" }, { keys: "sub_total", head: "項目金額" }, { keys: "expense", head: "費用" }]
            },
            csvConfig: {
                column: [{ keys: "created_at", name: "購買日期時間" }, { keys: "order_id", name: "訂單編號" }, { keys: "studio_name", name: "品牌名稱" }, { keys: "branch_name", name: "場館名稱" }, { keys: "contract_name", name: "項目" }, { keys: "sub_total", name: "項目金額" }, { keys: "expense", name: "費用" }],
                fileName: "contract_promote_fee_records"
            },
            relatedFilterWatcher: {
                studio_id: {
                    watcher: null,
                    options: "studioList",
                    vModel: "studioId",
                    trackBy: "id",
                    type: "single"
                },
                branch_ids: {
                    watcher: null,
                    options: 'branchList',
                    vModel: 'branchIds',
                    trackBy: 'id',
                    type: "multiple"
                }
            },
            dateOptions: {
                startDate: moment().startOf('month').format('YYYY/MM/DD'),
                endDate: moment().endOf('month').format('YYYY/MM/DD'),
                disabled: true
            }
        };
    },
    created: function created() {
        this.syncRelatedMultipleSelectByQuery({ vm: this, relatedFilterWatcher: this.relatedFilterWatcher });
    },
    mounted: function mounted() {
        var _this = this;

        this.configuredRun(function () {

            _this.changeFilterOption({
                prop: 'studioId',
                value: {
                    id: _this.configureStates.studioId,
                    brand_name: ''
                }
            });
            _this.changeFilterOption({
                prop: 'branchId',
                value: _this.configureStates.branchId
            });

            if (_this.configureStates.isSeventeen) {
                return _this.fetchStudioList();
            }

            if (_this.configureStates.isBranch) {
                _this.branchIds = [{
                    'id': _this.configureStates.branchId,
                    'branch_name': ''
                }];
            }
        });

        this.changeItemOption({
            prop: 'viewMode',
            value: 'detail'
        });
    },

    watch: (_watch = {
        'configureStates.isBranch': function configureStatesIsBranch(newVal, oldVal) {
            if (newVal) {
                document.getElementsByClassName("control-box")[1].style.display = "none";
            }
        }
    }, (0, _defineProperty3.default)(_watch, 'filterOptions.studioId', function filterOptionsStudioId(n, o) {
        if (this.configureStates.isSeventeen && !_lodash2.default.isEmpty(n)) {
            this.fetchBranchList({
                studioId: n.id
            });
        }
        if (this.configureStates.isStudio) {
            this.fetchBranchList({
                studioId: n.id
            });
        }
    }), (0, _defineProperty3.default)(_watch, 'export', function _export(newV) {
        if (newV && newV.length > 0) {
            this.csvConfig.jsonData = _lodash2.default.cloneDeep(newV);
            this.$refs.smart_table.downloadCsv();
        }
    }), _watch),
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        configureStates: function configureStates(state) {
            return state.webadmin.configure;
        }
    }), (0, _vuex.mapState)('webadmin/configure', ['configured', 'studioList', 'branchList', 'branchId', 'isSeventeen']), (0, _vuex.mapState)('webadmin/baseReport', ['blockOpenStatus', 'filterOptions', 'ajaxing', 'itemOptions']), {
        studioId: {
            get: function get() {
                return this.filterOptions.studioId;
            },
            set: function set(newValue) {
                var _this2 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                    return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.next = 2;
                                    return _this2.changeFilterOption({ 'prop': 'studioId', value: newValue });

                                case 2:
                                    _this2.cleanBranch();

                                    if (!newValue) {
                                        _context.next = 6;
                                        break;
                                    }

                                    _context.next = 6;
                                    return _this2.fetchBranchList({ studioId: newValue.id });

                                case 6:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this2);
                }))();
            }
        },
        branchIds: {
            get: function get() {
                return this.filterOptions.branchIds;
            },
            set: function set(newValue) {
                var _this3 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                    return _regenerator2.default.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    _this3.changeFilterOption({ 'prop': 'branchIds', value: newValue });

                                case 1:
                                case 'end':
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, _this3);
                }))();
            }
        },
        viewMode: {
            get: function get() {
                return this.itemOptions.viewMode;
            },
            set: function set(value) {
                this.changeItemOption({
                    prop: 'viewMode',
                    value: value
                });
            }
        },
        display: {
            get: function get() {
                return this.$store.state.webadmin.baseReport.display;
            },
            set: function () {
                var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(newValue) {
                    return _regenerator2.default.wrap(function _callee3$(_context3) {
                        while (1) {
                            switch (_context3.prev = _context3.next) {
                                case 0:
                                    _context3.next = 2;
                                    return this.changeDisplay(newValue);

                                case 2:
                                case 'end':
                                    return _context3.stop();
                            }
                        }
                    }, _callee3, this);
                }));

                function set(_x) {
                    return _ref.apply(this, arguments);
                }

                return set;
            }()
        }
    }),
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('webadmin/configure', ['configuredRun', 'fetchStudioList', 'fetchBranchList']), (0, _vuex.mapActions)('webadmin/baseReport', ['beforeSubmit', 'toggleBlock', 'changeDateOption', 'changeFilterOption', 'cleanBranch', 'changeItemOption', 'changeAjaxing', "syncDateAndDisplayByQuery", "syncRelatedMultipleSelectByQuery", "changeDisplay"]), {
        submit: function submit() {
            var data = this.getPara();
            $17.updateUrlQueryString(data, true);
            this.getSummary(data);
            this.getResult(data);
        },
        getPara: function getPara() {
            var data = {};

            if (this.branchIds.length > 0) {
                data.branch_ids = this.branchIds.map(function (item) {
                    return item.id;
                });
            }

            return data;
        },
        getSummary: function getSummary(data) {
            var _this4 = this;

            this.$http.get('/adminapi/report/fetch-contract-promote-sales-summary-for-studio', { params: data }).then(function (response) {
                _this4.summaryList = response.data.records;
            }, function (error) {
                $17.swal({
                    title: error.body.message,
                    type: 'warning'
                });
            });
        },
        getResult: function getResult(params) {
            var _this5 = this;

            var data = params;

            switch (this.display) {
                case "export":
                    data.page_size = 9999999;
                    break;
                case "show":
                    data.page_size = 25;
                    break;
                default:
                    null;
            }

            this.changeAjaxing(true);
            this.$http.get('/adminapi/report/fetch-contract-promote-sales-report-for-studio', { params: data }).then(function (response) {
                if (_this5.display == 'export') {
                    _this5.export = response.data.records;
                }

                if (_this5.display == 'show') {
                    _this5.detailList = response.data;
                }
                _this5.changeAjaxing(false);
            }, function (error) {
                _this5.changeAjaxing(false);
                $17.swal({
                    title: error.body.message,
                    type: 'warning'
                });
            });
        },
        changePage: function changePage(page) {
            var _this6 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
                var params;
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _this6.changeFilterOption({
                                    prop: "page",
                                    value: page
                                });

                                params = _this6.getPara();


                                params.page_size = _this6.filterOptions.pageSize;
                                params.page = _this6.filterOptions.page;

                                _context4.next = 6;
                                return _this6.getResult(params);

                            case 6:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this6);
            }))();
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"page-div\" _v-53a01092=\"\">\n<v-webadmin-report :block-open-status=\"blockOpenStatus\" :date-options=\"dateOptions\" :toggle-block=\"toggleBlock\" :change-date-option=\"changeDateOption\" ref=\"report\" :submit=\"submit\" limit-date=\"730\" title=\"行銷服務費試算 - 加強推廣\" _v-53a01092=\"\">\n        <div slot=\"second-block\" _v-53a01092=\"\">\n            <div class=\"row\" _v-53a01092=\"\">\n                <div class=\"col-sm-6\" v-show=\"isSeventeen\" _v-53a01092=\"\">\n                    <div class=\"form-group\" _v-53a01092=\"\">\n                        <v-mutiselect :model.sync=\"studioId\" :options=\"studioList\" :preserve-search=\"true\" :close-on-select=\"true\" :placeholder=\"configureStates.ajaxing.studioList ? '品牌讀取中…' : '請選擇品牌'\" label=\"brand_name\" track-by=\"id\" _v-53a01092=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n                <div class=\"col-sm-6\" _v-53a01092=\"\">\n                    <div class=\"form-group\" _v-53a01092=\"\">\n                        <v-mutiselect :model.sync=\"branchIds\" :options=\"branchList\" :disabled=\"configureStates.ajaxing.branchList\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"false\" :placeholder=\"configureStates.ajaxing.branchList ? '場館讀取中…' : '全部場館'\" label=\"branch_name\" track-by=\"id\" :taggable=\"true\" tag-name=\"branch_name\" _v-53a01092=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div slot=\"third-block\" _v-53a01092=\"\">\n            <div class=\"row\" _v-53a01092=\"\">\n                <div class=\"col-sm-6\" _v-53a01092=\"\">\n                    <div class=\"form-group\" _v-53a01092=\"\">\n                        <label _v-53a01092=\"\">\n                            <input name=\"view\" type=\"radio\" value=\"detail\" v-model=\"viewMode\" checked=\"\" _v-53a01092=\"\"> 顯示細節\n                        </label>\n                        <!-- <label> V1只顯示細節\n                            <input name=\"view\" type=\"radio\" value=\"summary\" v-model=\"viewMode\"> 顯示總和\n                        </label> -->\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div slot=\"fourth-block\" _v-53a01092=\"\">\n            <div class=\"row\" _v-53a01092=\"\">\n                <div class=\"col-sm-6\" _v-53a01092=\"\">\n                    <div class=\"form-group\" _v-53a01092=\"\">\n                        <label _v-53a01092=\"\">\n                            <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"show\" checked=\"\" _v-53a01092=\"\"> 顯示於網頁\n                        </label>\n                        <label _v-53a01092=\"\">\n                            <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"export\" _v-53a01092=\"\"> 匯出CSV\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </v-webadmin-report>\n    <div v-show=\"display === 'show'\" _v-53a01092=\"\">\n        <div class=\"m-top-30\" _v-53a01092=\"\">\n            <v-smart-table-summary :col-config=\"colConfig\" :data=\"summaryList\" _v-53a01092=\"\"></v-smart-table-summary>\n        </div>\n        <div class=\"m-top-10\" _v-53a01092=\"\">\n            <v-smart-table ref=\"smart_table\" :table-config=\"tableConfig\" :csv-config=\"csvConfig\" :is-ajaxing=\"ajaxing\" :data=\"detailList\" :page-sync-url-query=\"false\" @change-page=\"changePage\" _v-53a01092=\"\"></v-smart-table>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.page-div[_v-53a01092] {\n  padding: 0px 15px;\n  margin-bottom: 15px; }\n\n/* line 6, stdin */\n.table-div[_v-53a01092] {\n  padding: 20px 0px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-53a01092", module.exports)
  } else {
    hotAPI.update("_v-53a01092", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/defineProperty":65,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1356:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.page-div[_v-2f226a45] {\n  padding: 0px 15px;\n  margin-bottom: 15px; }\n\n/* line 6, stdin */\n.table-div[_v-2f226a45] {\n  padding: 20px 0px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            paymentSourceRecordCategories: [],
            paymentSourceRecordCategory: null,
            ajaxingPaymentSourceRecordCategory: false,
            detailList: {},
            export: [],
            colConfig: {
                columns: [{ keys: "should_pay_total", head: "交易總額" }, { keys: "expense_total", head: "費用總額" }]
            },
            summaryList: {},
            // apiConfig: {
            //     method: 'get',               
            //     apiurl: '/adminapi/report/fetch_contract_promote_sales_summary', 
            //     payload: {
            //         start_date: '2022/01/11',
            //         end_date:  '2022/05/11',
            //         payment_source_record_category_id:null,

            //     },
            //     recordName: 'records', 
            // },
            tableConfig: {
                columns: [{ keys: "created_at", head: "購買日期時間" }, { keys: "order_id", head: "訂單編號" }, { keys: "studio_name", head: "品牌名稱" }, { keys: "branch_name", head: "場館名稱" }, { keys: "contract_name", head: "項目" }, { keys: "source_type_name_tw", head: "來源類型" }, { keys: "sub_total", head: "項目金額" }, { keys: "expense", head: "費用" }]
            },
            csvConfig: {
                column: [{ keys: "created_at", name: "購買日期時間" }, { keys: "order_id", name: "訂單編號" }, { keys: "studio_name", name: "品牌名稱" }, { keys: "branch_name", name: "場館名稱" }, { keys: "contract_name", name: "項目" }, { keys: "source_type_name_tw", name: "來源類型" }, { keys: "sub_total", name: "項目金額" }, { keys: "expense", name: "費用" }],
                fileName: "contract_promote_fee_records"
            },
            relatedFilterWatcher: {
                studio_id: {
                    watcher: null,
                    options: "studioList",
                    vModel: "studioId",
                    trackBy: "id",
                    type: "single"
                },
                payment_source_record_category_id: {
                    watcher: null,
                    options: "paymentSourceRecordCategories",
                    vModel: "paymentSourceRecordCategory",
                    trackBy: "id",
                    type: "single"
                },
                branch_ids: {
                    watcher: null,
                    options: 'branchList',
                    vModel: 'branchIds',
                    trackBy: 'id',
                    type: "multiple"
                }
            }
        };
    },
    created: function created() {
        this.syncRelatedMultipleSelectByQuery({ vm: this, relatedFilterWatcher: this.relatedFilterWatcher });
    },
    mounted: function mounted() {
        var _this = this;

        this.configuredRun(function () {
            _this.getSourceTypes();
            _this.changeFilterOption({
                prop: 'studioId',
                value: {
                    id: _this.configureStates.studioId,
                    brand_name: ''
                }
            });

            _this.changeFilterOption({
                prop: 'branchId',
                value: _this.configureStates.branchId
            });

            _this.fetchStudioList();
        });

        this.changeItemOption({
            prop: 'viewMode',
            value: 'detail'
        });

        this.syncDateAndDisplayByQuery({
            'diffType': 'months',
            'diffNumber': -1
        });
    },

    watch: {
        'configureStates.isBranch': function configureStatesIsBranch(newVal, oldVal) {
            if (newVal) {
                document.getElementsByClassName("control-box")[1].style.display = "none";
            }
        },
        export: function _export(newV) {
            if (newV && newV.length > 0) {
                this.csvConfig.jsonData = _lodash2.default.cloneDeep(newV);
                this.$refs.smart_table.downloadCsv();
            }
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        configureStates: function configureStates(state) {
            return state.webadmin.configure;
        }
    }), (0, _vuex.mapState)('webadmin/configure', ['configured', 'studioList', 'branchList', 'branchId']), (0, _vuex.mapState)('webadmin/baseReport', ['blockOpenStatus', 'dateOptions', 'filterOptions', 'ajaxing', 'itemOptions']), {
        studioId: {
            get: function get() {
                return this.filterOptions.studioId;
            },
            set: function set(newValue) {
                var _this2 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                    return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.next = 2;
                                    return _this2.changeFilterOption({ 'prop': 'studioId', value: newValue });

                                case 2:
                                    _this2.cleanBranch();

                                    if (!newValue) {
                                        _context.next = 6;
                                        break;
                                    }

                                    _context.next = 6;
                                    return _this2.fetchBranchList({ studioId: newValue.id });

                                case 6:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this2);
                }))();
            }
        },
        branchIds: {
            get: function get() {
                return this.filterOptions.branchIds;
            },
            set: function set(newValue) {
                var _this3 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                    return _regenerator2.default.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    _this3.changeFilterOption({ 'prop': 'branchIds', value: newValue });

                                case 1:
                                case 'end':
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, _this3);
                }))();
            }
        },
        viewMode: {
            get: function get() {
                return this.itemOptions.viewMode;
            },
            set: function set(value) {
                this.changeItemOption({
                    prop: 'viewMode',
                    value: value
                });
            }
        },
        display: {
            get: function get() {
                return this.$store.state.webadmin.baseReport.display;
            },
            set: function () {
                var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(newValue) {
                    return _regenerator2.default.wrap(function _callee3$(_context3) {
                        while (1) {
                            switch (_context3.prev = _context3.next) {
                                case 0:
                                    _context3.next = 2;
                                    return this.changeDisplay(newValue);

                                case 2:
                                case 'end':
                                    return _context3.stop();
                            }
                        }
                    }, _callee3, this);
                }));

                function set(_x) {
                    return _ref.apply(this, arguments);
                }

                return set;
            }()
        }
    }),
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('webadmin/configure', ['configuredRun', 'fetchStudioList', 'fetchBranchList']), (0, _vuex.mapActions)('webadmin/baseReport', ['beforeSubmit', 'toggleBlock', 'changeDateOption', 'changeFilterOption', 'cleanBranch', 'changeItemOption', 'changeAjaxing', "syncDateAndDisplayByQuery", "syncRelatedMultipleSelectByQuery", "changeDisplay"]), {
        submit: function submit() {
            this.beforeSubmit();
            var data = this.getPara();
            $17.updateUrlQueryString(data, true);
            this.getSummary(data);
            this.getResult(data);
        },
        getPara: function getPara() {
            var data = {
                'start_date': this.dateOptions.startDate,
                'end_date': this.dateOptions.endDate,
                'payment_source_record_category_id': this.paymentSourceRecordCategory != null ? this.paymentSourceRecordCategory.id : null
            };

            if (this.studioId && this.studioId.id) {
                data.studio_id = this.studioId.id;
            }
            if (this.branchIds.length > 0) {
                data.branch_ids = this.branchIds.map(function (item) {
                    return item.id;
                });
            }

            return data;
        },
        getSummary: function getSummary(data) {
            var _this4 = this;

            this.$http.get('/adminapi/report/fetch-contract-promote-sales-summary', { params: data }).then(function (response) {
                _this4.summaryList = response.data.records;
            }, function (error) {
                $17.swal({
                    title: error.body.message,
                    type: 'warning'
                });
            });
        },
        getResult: function getResult(params) {
            var _this5 = this;

            var data = params;

            switch (this.display) {
                case "export":
                    data.page_size = 9999999;
                    break;
                case "show":
                    data.page_size = 25;
                    break;
                default:
                    null;
            }

            this.changeAjaxing(true);
            this.$http.get('/adminapi/report/fetch-contract-promote-sales-report', { params: data }).then(function (response) {
                if (_this5.display == 'export') {
                    _this5.export = response.data.records;
                }

                if (_this5.display == 'show') {
                    _this5.detailList = response.data;
                }
                _this5.changeAjaxing(false);
            }, function (error) {
                _this5.changeAjaxing(false);
                $17.swal({
                    title: error.body.message,
                    type: 'warning'
                });
            });
        },
        getSourceTypes: function getSourceTypes() {
            var _this6 = this;

            this.ajaxingPaymentSourceRecordCategory = true;
            this.$http.get('/adminapi/init/payment-source-record-categories').then(function (response) {
                _this6.paymentSourceRecordCategories = response.data;
                _this6.ajaxingPaymentSourceRecordCategory = false;
            }, function (error) {
                _this6.ajaxingPaymentSourceRecordCategory = false;
                $17.swal({
                    title: error.body.message,
                    type: 'warning'
                });
            });
        },
        changePage: function changePage(page) {
            var _this7 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
                var params;
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _this7.changeFilterOption({
                                    prop: "page",
                                    value: page
                                });

                                params = _this7.getPara();


                                params.page_size = _this7.filterOptions.pageSize;
                                params.page = _this7.filterOptions.page;

                                _context4.next = 6;
                                return _this7.getResult(params);

                            case 6:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this7);
            }))();
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"page-div\" _v-2f226a45=\"\">\n    <v-webadmin-report :block-open-status=\"blockOpenStatus\" :date-options=\"dateOptions\" :toggle-block=\"toggleBlock\" :change-date-option=\"changeDateOption\" ref=\"report\" :disable-submit=\"ajaxing\" :submit=\"submit\" limit-date=\"730\" title=\"行銷服務費試算 - 加強推廣(17FIT)\" _v-2f226a45=\"\">\n        <div slot=\"second-block\" _v-2f226a45=\"\">\n            <div class=\"row\" _v-2f226a45=\"\">\n                <div class=\"col-sm-6\" _v-2f226a45=\"\">\n                    <div class=\"form-group\" _v-2f226a45=\"\">\n                        <v-mutiselect :model.sync=\"studioId\" :options=\"studioList\" :preserve-search=\"true\" :close-on-select=\"true\" :placeholder=\"configureStates.ajaxing.studioList ? '品牌讀取中…' : '請選擇品牌'\" label=\"brand_name\" track-by=\"id\" _v-2f226a45=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n                <div class=\"col-sm-6\" _v-2f226a45=\"\">\n                    <div class=\"form-group\" _v-2f226a45=\"\">\n                        <v-mutiselect :model.sync=\"branchIds\" :options=\"branchList\" :disabled=\"configureStates.ajaxing.branchList\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"false\" :placeholder=\"configureStates.ajaxing.branchList ? '場館讀取中…' : '全部場館'\" label=\"branch_name\" track-by=\"id\" :taggable=\"true\" tag-name=\"branch_name\" _v-2f226a45=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n                <div class=\"col-sm-6\" _v-2f226a45=\"\">\n                    <div class=\"form-group\" _v-2f226a45=\"\">\n                        <v-mutiselect :model.sync=\"paymentSourceRecordCategory\" :options=\"paymentSourceRecordCategories\" :disabled=\"ajaxingPaymentSourceRecordCategory\" :multiple=\"false\" :close-on-select=\"true\" :clear-on-select=\"false\" :hide-selected=\"false\" :preserve-search=\"false\" :searchable=\"true\" :placeholder=\"ajaxingPaymentSourceRecordCategory ? '通路來源讀取中…' : '全部通路來源'\" label=\"name\" track-by=\"id\" :taggable=\"true\" tag-name=\"name\" _v-2f226a45=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div slot=\"third-block\" _v-2f226a45=\"\">\n            <div class=\"row\" _v-2f226a45=\"\">\n                <div class=\"col-sm-6\" _v-2f226a45=\"\">\n                    <div class=\"form-group\" _v-2f226a45=\"\">\n                        <label _v-2f226a45=\"\">\n                            <input name=\"view\" type=\"radio\" value=\"detail\" v-model=\"viewMode\" checked=\"\" _v-2f226a45=\"\"> 顯示細節\n                        </label>\n                        <!-- <label> V1 只顯示細節\n                            <input name=\"view\" type=\"radio\" value=\"summary\" v-model=\"viewMode\"> 顯示總和\n                        </label> -->\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div slot=\"fourth-block\" _v-2f226a45=\"\">\n            <div class=\"row\" _v-2f226a45=\"\">\n                <div class=\"col-sm-6\" _v-2f226a45=\"\">\n                    <div class=\"form-group\" _v-2f226a45=\"\">\n                        <label _v-2f226a45=\"\">\n                            <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"show\" checked=\"\" _v-2f226a45=\"\"> 顯示於網頁\n                        </label>\n                        <label _v-2f226a45=\"\">\n                            <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"export\" _v-2f226a45=\"\"> 匯出 CSV\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </v-webadmin-report>\n    <div v-show=\"display === 'show'\" _v-2f226a45=\"\">\n        <div class=\"m-top-30\" _v-2f226a45=\"\">\n            <v-smart-table-summary :col-config=\"colConfig\" :data=\"summaryList\" _v-2f226a45=\"\"></v-smart-table-summary>\n        </div>\n        <div class=\"m-top-10\" _v-2f226a45=\"\">\n            <v-smart-table ref=\"smart_table\" :table-config=\"tableConfig\" :csv-config=\"csvConfig\" :is-ajaxing=\"ajaxing\" :data=\"detailList\" :page-sync-url-query=\"false\" @change-page=\"changePage\" _v-2f226a45=\"\"></v-smart-table>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.page-div[_v-2f226a45] {\n  padding: 0px 15px;\n  margin-bottom: 15px; }\n\n/* line 6, stdin */\n.table-div[_v-2f226a45] {\n  padding: 20px 0px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-2f226a45", module.exports)
  } else {
    hotAPI.update("_v-2f226a45", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1357:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            display: 'show',
            list: [],
            listKey: [],
            listTitle: {},
            allSystemPlans: [],
            systemPlans: [],
            indexes: []
        };
    },
    mounted: function mounted() {
        var _this = this;

        this.configuredRun(function () {
            _this.changeFilterOption({
                prop: 'studioId',
                value: []
            });

            return _this.fetchStudioList();
        });

        this.changeDateOption({
            prop: 'startDate',
            value: moment().add(-1, 'days').format('YYYY/MM/DD')
        });

        this.changeDateOption({
            prop: 'endDate',
            value: moment().add(-1, 'days').format('YYYY/MM/DD')
        });
        this.getSystemPlan();
    },

    watch: {
        list: function list(newValue, oldValue) {
            var _this2 = this;

            if (newValue.length > 0 && this.display === 'export') {
                this.csvDataHandler({ data: newValue, columnFormater: this.columnFormatter }).then(function (results) {
                    _this2.download({ csvString: results, name: 'change_record' });
                });
            }
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        configureStates: function configureStates(state) {
            return state.webadmin.configure;
        }
    }), (0, _vuex.mapState)('webadmin/configure', ['configured', 'studioList', 'branchList', 'branchId', 'isBranch', 'isStudio', 'isSeventeen']), (0, _vuex.mapState)('webadmin/baseReport', ['blockOpenStatus', 'dateOptions', 'filterOptions']), {
        studioId: {
            get: function get() {
                return this.filterOptions.studioId;
            },
            set: function set(newValue) {
                var _this3 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                    return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.next = 2;
                                    return _this3.changeFilterOption({ 'prop': 'studioId', value: newValue });

                                case 2:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this3);
                }))();
            }
        },
        ajaxing: {
            get: function get() {
                return this.$store.state.webadmin.baseReport.ajaxing;
            },
            set: function set(newValue) {
                var _this4 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                    return _regenerator2.default.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    _context2.next = 2;
                                    return _this4.changeAjaxing(newValue);

                                case 2:
                                case 'end':
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, _this4);
                }))();
            }
        },
        viewMode: {
            get: function get() {
                return this.$store.state.webadmin.baseReport.itemOptions.viewMode;
            },
            set: function set(value) {
                this.changeItemOption({
                    prop: 'viewMode',
                    value: value
                });
            }
        }
    }),
    methods: (0, _extends3.default)({
        checkMode: function checkMode(mode) {
            return this.viewMode === mode;
        }
    }, (0, _vuex.mapActions)('webadmin/configure', ['configuredRun', 'fetchStudioList', 'fetchBranchList', 'fetchContractList']), (0, _vuex.mapActions)('webadmin/baseReport', ['beforeSubmit', 'toggleBlock', 'changeDateOption', 'changeFilterOption', 'cleanBranch', 'cleanBranchRelated', 'changeItemOption', 'setDetailTarget', 'download', 'csvDataHandler', 'columnFormater', "changeAjaxing"]), {
        submit: function submit() {
            this.beforeSubmit();
            this.getResult();
        },
        getResult: function getResult() {
            var _this5 = this;

            var studioIds = _lodash2.default.map(this.filterOptions.studioId, function (studio) {
                return studio.id;
            });
            var systemPlans = _lodash2.default.map(this.systemPlans, function (plan) {
                return plan.id;
            });
            var data = {
                'start_date': this.dateOptions.startDate,
                'end_date': this.dateOptions.endDate,
                filters: {
                    'system_plan_ids': systemPlans,
                    'indexes': this.indexes,
                    'studio_ids': studioIds
                }
            };
            var params = $.param(data);
            this.ajaxing = true;
            this.$http.get('/adminapi/report/fetch_customer_ms_report?' + params).then(function (response) {
                _this5.ajaxing = false;
                _this5.list = response.body.list;
                _this5.listKey = response.body.key;
                _this5.listTitle = response.body.title;
            }, function (error) {
                _this5.ajaxing = false;
            });
        },
        getSystemPlan: function getSystemPlan() {
            var _this6 = this;

            this.$http.get('/adminapi/system-plan').then(function (response) {

                _this6.allSystemPlans = response.body;
            }, function (error) {});
        },
        columnFormatter: function columnFormatter(d) {
            var data = JSON.parse((0, _stringify2.default)(d));
            data = (0, _stringify2.default)(data);

            data = data.replaceAll('studio_name', '品牌名稱');
            data = data.replaceAll('system_plan', '系統方案');
            data = data.replaceAll('members', '客戶數');
            data = data.replaceAll('member_contracts', '方案數量');
            data = data.replaceAll('branch_name', '場館名稱');
            data = data.replaceAll('order_numbers', '訂單數量');
            data = data.replaceAll('order_income', '總收入');
            data = data.replaceAll('order_refund', '總退費');
            data = data.replaceAll('schedule_booked', '課程預約');
            data = data.replaceAll('schedule_booking_confirmed', '課程預約出席');
            data = data.replaceAll('appointment_booked', '服務預約');
            data = data.replaceAll('appointment_booking_confirmed', '服務預約出席');
            data = data.replaceAll('auto_pay_plan_detail_count', '已排程自動支付計畫數量');
            data = data.replaceAll('admission_count', '入場人次');
            return data;
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"page-div\" _v-14e0a5b8=\"\">\n    <v-webadmin-report :block-open-status=\"blockOpenStatus\" :date-options=\"dateOptions\" :toggle-block=\"toggleBlock\" :change-date-option=\"changeDateOption\" :disable-submit=\"ajaxing\" :submit=\"submit\" limit-date=\"365\" title=\"客戶營運指標\" _v-14e0a5b8=\"\">\n        <div slot=\"second-block\" _v-14e0a5b8=\"\">\n            <div class=\"row\" _v-14e0a5b8=\"\">\n                <div class=\"col-sm-6\" _v-14e0a5b8=\"\">\n                    <div class=\"form-group\" _v-14e0a5b8=\"\">\n                        <v-mutiselect :model.sync=\"studioId\" :options=\"studioList\" :preserve-search=\"true\" :placeholder=\"configureStates.ajaxing.studioList ? '品牌讀取中…' : '請選擇品牌'\" label=\"brand_name\" track-by=\"id\" :multiple=\"true\" tag-name=\"brand_name\" _v-14e0a5b8=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n                <div class=\"col-sm-6\" _v-14e0a5b8=\"\">\n                    <div class=\"form-group\" _v-14e0a5b8=\"\">\n                        <v-mutiselect :model.sync=\"systemPlans\" :options=\"allSystemPlans\" :preserve-search=\"true\" placeholder=\"請選擇系統方案\" label=\"name\" track-by=\"id\" :multiple=\"true\" tag-name=\"name\" _v-14e0a5b8=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div slot=\"third-block\" _v-14e0a5b8=\"\">\n            <div class=\"row\" _v-14e0a5b8=\"\">\n                <div class=\"col-sm-6\" _v-14e0a5b8=\"\">\n                    <div class=\"form-group\" _v-14e0a5b8=\"\">\n                        <label _v-14e0a5b8=\"\">\n                            <input name=\"view\" type=\"checkbox\" value=\"general\" v-model=\"indexes\" _v-14e0a5b8=\"\"> 一般指標\n                        </label>\n                        <label _v-14e0a5b8=\"\">\n                            <input name=\"view\" type=\"checkbox\" value=\"schedule\" v-model=\"indexes\" _v-14e0a5b8=\"\"> 課程指標\n                        </label>\n                        <label _v-14e0a5b8=\"\">\n                            <input name=\"view\" type=\"checkbox\" value=\"appointment\" v-model=\"indexes\" _v-14e0a5b8=\"\"> 服務指標\n                        </label>\n                        <label _v-14e0a5b8=\"\">\n                            <input name=\"view\" type=\"checkbox\" value=\"admission\" v-model=\"indexes\" _v-14e0a5b8=\"\"> 入場指標\n                        </label>\n                        <label _v-14e0a5b8=\"\">\n                            <input name=\"view\" type=\"checkbox\" value=\"auto_pay_plan\" v-model=\"indexes\" _v-14e0a5b8=\"\"> 自動支付指標\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div slot=\"fourth-block\" _v-14e0a5b8=\"\">\n            <div class=\"row\" _v-14e0a5b8=\"\">\n                <div class=\"col-sm-6\" _v-14e0a5b8=\"\">\n                    <div class=\"form-group row\" _v-14e0a5b8=\"\">\n                        <label _v-14e0a5b8=\"\">\n                            <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"show\" checked=\"\" _v-14e0a5b8=\"\"> 顯示於網頁\n                        </label>\n                        <label _v-14e0a5b8=\"\">\n                            <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"export\" _v-14e0a5b8=\"\"> 匯出 CSV\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </v-webadmin-report>\n    <div v-show=\"display=='show'\" _v-14e0a5b8=\"\">\n        <v-webadmin-report-list :list=\"list\" :list-key=\"listKey\" :list-title=\"listTitle\" :ajaxing=\"ajaxing\" _v-14e0a5b8=\"\"></v-webadmin-report-list>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-14e0a5b8", module.exports)
  } else {
    hotAPI.update("_v-14e0a5b8", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/json/stringify":48,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vuex":803}],1358:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.page-div[_v-2825aafd] {\n  padding: 0px 15px;\n  margin-bottom: 15px; }\n\n/* line 7, stdin */\n.m-l-15[_v-2825aafd] {\n  margin-left: 15px; }\n\n/* line 11, stdin */\n.table-div[_v-2825aafd] {\n  padding: 20px 0px; }\n\n/* line 15, stdin */\n.select-limit[_v-2825aafd] {\n  display: inline;\n  width: 50%; }\n\n/* line 20, stdin */\nlabel[_v-2825aafd] {\n  margin-right: 10px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _watch;

var _vuex = require('vuex');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            display: 'show',
            salsemanVisible: '',
            ajaxing: false,
            purchasingPriceMin: 0,
            purchasingPriceMax: null,
            purchasingQtyMin: 0,
            purchasingQtyMax: null,
            largeMemberList: [],
            viewLimit: 25
        };
    },
    mounted: function mounted() {
        var _this = this;

        this.getItemTypes();
        this.configuredRun(function () {
            _this.changeFilterOption({
                prop: 'studioId',
                value: {
                    id: _this.configureStates.studioId,
                    brand_name: ''
                }
            });
            _this.changeFilterOption({
                prop: 'branchId',
                value: _this.configureStates.branchId
            });
            if (_this.configureStates.isSeventeen) {
                return _this.fetchStudioList();
            }
            if (_this.configureStates.isBranch) {
                _this.branchIds = [{
                    'id': _this.configureStates.branchId,
                    'branch_name': ''
                }];
            }
        });

        this.changeDateOption({
            prop: 'startDate',
            value: moment().add(-1, 'months').format('YYYY/MM/DD')
        });

        this.changeDateOption({
            prop: 'endDate',
            value: moment().add(-1, 'days').format('YYYY/MM/DD')
        });
    },

    watch: (_watch = {}, (0, _defineProperty3.default)(_watch, 'filterOptions.studioId', function filterOptionsStudioId(n, o) {
        if (this.configureStates.isSeventeen || this.configureStates.isStudio) {
            this.fetchBranchList({
                studioId: n.id
            });
        }
    }), (0, _defineProperty3.default)(_watch, 'largeMemberList', function largeMemberList(newValue, oldValue) {
        var _this2 = this;

        if (newValue.length > 0 && this.display === 'export') {
            var results = this.csvDataHandler({ data: newValue, columnFormater: this.detailColumnFormater }).then(function (results) {
                _this2.download({ csvString: results, name: 'Big-Spender' });
            });
        }
    }), _watch),
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        configureStates: function configureStates(state) {
            return state.webadmin.configure;
        }
    }), (0, _vuex.mapState)('webadmin/configure', ['configured', 'studioList', 'branchList', 'branchId']), (0, _vuex.mapState)('webadmin/orderDetailsTotalSale', ['blockOpenStatus', 'dateOptions', 'filterOptions', "item_types", "items", "itemAjaxing"]), {
        studioId: {
            get: function get() {
                return this.filterOptions.studioId;
            },
            set: function set(newValue) {
                var _this3 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                    return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.next = 2;
                                    return _this3.changeFilterOption({ 'prop': 'studioId', value: newValue });

                                case 2:
                                    _this3.cleanBranch();

                                    if (!newValue) {
                                        _context.next = 6;
                                        break;
                                    }

                                    _context.next = 6;
                                    return _this3.fetchBranchList({ studioId: newValue.id });

                                case 6:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this3);
                }))();
            }
        },
        branchIds: {
            get: function get() {
                return this.filterOptions.branchIds;
            },
            set: function set(newValue) {
                var _this4 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                    return _regenerator2.default.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    _context2.next = 2;
                                    return _this4.changeFilterOption({ 'prop': 'branchIds', value: newValue });

                                case 2:
                                    if (_this4.selectedItemType !== 'all') {
                                        _this4.selectedItem = [];
                                        _this4.getItems();
                                    }

                                case 3:
                                case 'end':
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, _this4);
                }))();
            }
        },
        selectedItemType: {
            get: function get() {
                return this.filterOptions.selectedItemType;
            },
            set: function set(newValue) {
                var _this5 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
                    return _regenerator2.default.wrap(function _callee3$(_context3) {
                        while (1) {
                            switch (_context3.prev = _context3.next) {
                                case 0:
                                    _context3.next = 2;
                                    return _this5.$store.dispatch('webadmin/orderDetailsTotalSale/changeFilterOption', { 'prop': 'selectedItemType', value: newValue });

                                case 2:
                                    if (_this5.selectedItemType !== 'all') {
                                        _this5.selectedItem = [];
                                        _this5.getItems();
                                    }

                                case 3:
                                case 'end':
                                    return _context3.stop();
                            }
                        }
                    }, _callee3, _this5);
                }))();
            }
        },
        selectedItem: {
            get: function get() {
                return this.filterOptions.selectedItem;
            },
            set: function set(newValue) {
                var _this6 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
                    return _regenerator2.default.wrap(function _callee4$(_context4) {
                        while (1) {
                            switch (_context4.prev = _context4.next) {
                                case 0:
                                    _context4.next = 2;
                                    return _this6.$store.dispatch('webadmin/orderDetailsTotalSale/changeFilterOption', { 'prop': 'selectedItem', value: newValue });

                                case 2:
                                case 'end':
                                    return _context4.stop();
                            }
                        }
                    }, _callee4, _this6);
                }))();
            }
        },
        item_type_name: function item_type_name() {
            v = this;
            if (v.item_types.length <= 0 || v.item_types === null || v.selectedItemType === 'all' || v.selectedItemType === '') {
                return "";
            }
            item_type = _lodash2.default.find(v.item_types, function (o) {
                return o.id == v.selectedItemType;
            });
            return item_type.name;
        }
    }),
    methods: (0, _extends3.default)({
        updateFilterOption: function updateFilterOption(field) {
            var _this7 = this;

            return function (value) {
                return _this7.changeFilterOption({
                    prop: field,
                    value: value
                });
            };
        }
    }, (0, _vuex.mapActions)('webadmin/configure', ['configuredRun', 'fetchStudioList', 'fetchBranchList']), (0, _vuex.mapActions)('webadmin/orderDetailsTotalSale', ['toggleBlock', 'changeDateOption', 'changeFilterOption', 'cleanBranch', 'cleanBranchRelated', 'changeItemOption', 'getItemTypes', 'getItems']), (0, _vuex.mapActions)('webadmin/baseReport', ['beforeSubmit', 'download', 'csvDataHandler', 'columnFormater']), {
        submit: function submit() {
            if (!this.dateOptions.startDate || this.dateOptions.startDate == 'Invalid date') {
                $17.swal({
                    title: '日期：請填寫 開始日期',
                    type: 'warning'
                });
                return;
            }
            if (!this.dateOptions.endDate || this.dateOptions.endDate == 'Invalid date') {
                $17.swal({
                    title: '日期：請填寫 結束日期',
                    type: 'warning'
                });
                return;
            }
            if (this.dateOptions.startDate > this.dateOptions.endDate) {
                $17.swal({
                    title: '日期：開始日期不能大於結束日期',
                    type: 'warning'
                });
                return;
            }

            if (this.purchasingPriceMax && this.purchasingPriceMin > this.purchasingPriceMax) {
                $17.swal({
                    title: '最低消費金額不可大於最高',
                    type: 'warning'
                });
                return;
            }

            if (this.purchasingQtyMax && this.purchasingQtyMin > this.purchasingQtyMax) {
                $17.swal({
                    title: '最低購買數量不可大於最高',
                    type: 'warning'
                });
                return;
            }
            this.getResault();
        },
        getResault: function getResault() {
            var _this8 = this;

            var itemIds = this.filterOptions.selectedItem.map(function (elem) {
                return elem.id;
            });
            var postData = {
                studio_id: this.studioId.id,
                branch_ids: this.branchIds,
                start_date: this.dateOptions.startDate,
                end_date: this.dateOptions.endDate,
                item_type: this.filterOptions.selectedItemType,
                items: itemIds,
                purchasingPriceMin: this.purchasingPriceMin,
                purchasingPriceMax: this.purchasingPriceMax,
                purchasingQtyMin: this.purchasingQtyMin,
                purchasingQtyMax: this.purchasingQtyMax,
                viewLimit: this.viewLimit
            };
            this.ajaxing = true;
            this.$http.post('/adminapi/report/fetch-customer-spend-report-data', postData).then(function (response) {
                _this8.largeMemberList = response.body;
                _this8.ajaxing = false;
            }, function (error) {
                _this8.ajaxing = false;
                $17.swal({
                    title: error.body.message,
                    type: 'warning'
                });
            });
        },
        detailColumnFormater: function detailColumnFormater(data) {
            var data = _lodash2.default.map(data, function (value) {
                return _lodash2.default.pick(value, ['name', 'phone', 'email', 'total_qty', 'total']);
            });
            data = (0, _stringify2.default)(data);
            data = data.replaceAll('name', '客戶姓名');
            data = data.replaceAll('phone', '電話');
            data = data.replaceAll('email', '電子郵件');
            data = data.replaceAll('total_qty', '總購買次數');
            data = data.replaceAll('total', '總消費金額');
            return data;
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"page-div\" _v-2825aafd=\"\">\n    <v-webadmin-report :block-open-status=\"blockOpenStatus\" :date-options=\"dateOptions\" :toggle-block=\"toggleBlock\" :change-date-option=\"changeDateOption\" :disable-submit=\"ajaxing\" :submit=\"submit\" limit-date=\"92\" title=\"大戶報表\" _v-2825aafd=\"\">\n        <div slot=\"second-block\" _v-2825aafd=\"\">\n            <div class=\"row\" _v-2825aafd=\"\">\n                <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen\" _v-2825aafd=\"\">\n                    <div class=\"form-group\" _v-2825aafd=\"\">\n                        <v-mutiselect :model.sync=\"studioId\" :options=\"studioList\" :preserve-search=\"true\" :placeholder=\"configureStates.ajaxing.studioList ? '品牌讀取中…' : '請選擇品牌'\" label=\"brand_name\" track-by=\"id\" _v-2825aafd=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n                <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen || configureStates.isStudio\" _v-2825aafd=\"\">\n                    <div class=\"form-group\" _v-2825aafd=\"\">\n                        <v-mutiselect :model.sync=\"branchIds\" :options=\"branchList\" :disabled=\"configureStates.ajaxing.branchList\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"false\" :placeholder=\"configureStates.ajaxing.branchList ? '場館讀取中…' : '全部場館'\" label=\"branch_name\" track-by=\"id\" :taggable=\"true\" tag-name=\"branch_name\" :max-height=\"500\" _v-2825aafd=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n            </div>\n            <div class=\"row\" _v-2825aafd=\"\">\n                <div v-if=\"filterOptions.studioId !== null &amp;&amp; filterOptions.studioId.id !== 0\" class=\"col-sm-6\" _v-2825aafd=\"\">\n                    <div class=\"form-group\" _v-2825aafd=\"\">\n                        <select class=\"form-control\" v-model=\"selectedItemType\" _v-2825aafd=\"\">\n                            <option value=\"all\" _v-2825aafd=\"\">全部項目類型</option>\n                            <option :value=\"itemType.id\" :key=\"itemType.id\" v-for=\"itemType in item_types\" _v-2825aafd=\"\">{{ itemType.name }}</option>\n                        </select>\n                    </div>\n                </div>\n                <div v-if=\"selectedItemType !== 'schedules' &amp;&amp; selectedItemType !== 'services' &amp;&amp; selectedItemType !== 'all' &amp;&amp; filterOptions.studioId.id !== 0\" class=\"col-sm-6\" _v-2825aafd=\"\">\n                    <div class=\"form-group\" _v-2825aafd=\"\">\n                        <v-mutiselect :model.sync=\"selectedItem\" :options=\"items\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"true\" :placeholder=\"itemAjaxing ? '項目讀取中…' : '全部' + item_type_name\" label=\"name\" track-by=\"id\" tag-name=\"name\" _v-2825aafd=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n            </div>\n            <div class=\"row\" _v-2825aafd=\"\">\n                <div class=\"col-sm-12\" _v-2825aafd=\"\">\n                    <div class=\"form-group\" _v-2825aafd=\"\">\n                        <label _v-2825aafd=\"\">\n                            消費金額介於\n                        </label>\n                        <span _v-2825aafd=\"\">\n                            <input type=\"number\" v-model=\"purchasingPriceMin\" placeholder=\"最低消費金額\" _v-2825aafd=\"\">\n                            <label _v-2825aafd=\"\">\n                                ~\n                            </label>\n                            <input type=\"number\" v-model=\"purchasingPriceMax\" placeholder=\"最高消費金額\" _v-2825aafd=\"\">\n                        </span>\n                    </div>\n                </div>\n                <div class=\"col-sm-12\" _v-2825aafd=\"\">\n                    <div class=\"form-group\" _v-2825aafd=\"\">\n                        <label _v-2825aafd=\"\">\n                            訂單數量介於\n                        </label>\n                        <span _v-2825aafd=\"\">\n                            <input type=\"number\" v-model=\"purchasingQtyMin\" placeholder=\"最低購買數量\" _v-2825aafd=\"\">\n                            <label _v-2825aafd=\"\">\n                                ~\n                            </label>\n                            <input type=\"number\" v-model=\"purchasingQtyMax\" placeholder=\"最高購買數量\" _v-2825aafd=\"\">\n                        </span>\n                    </div>\n                </div>\n            </div>\n            <div class=\"row\" _v-2825aafd=\"\">\n                <div class=\"col-sm-6\" _v-2825aafd=\"\">\n                    <div class=\"form-group\" _v-2825aafd=\"\">\n                        <label _v-2825aafd=\"\">\n                            顯示客戶數量\n                        </label>\n                        <select class=\"form-control select-limit\" v-model=\"viewLimit\" _v-2825aafd=\"\">\n                            <option value=\"25\" _v-2825aafd=\"\">25</option>\n                            <option value=\"100\" _v-2825aafd=\"\">100</option>\n                            <option value=\"500\" _v-2825aafd=\"\">500</option>\n                            <option value=\"10000\" _v-2825aafd=\"\">1000</option>\n                        </select>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div slot=\"fourth-block\" _v-2825aafd=\"\">\n            <div class=\"row\" _v-2825aafd=\"\">\n                <div class=\"col-sm-6\" _v-2825aafd=\"\">\n                    <div class=\"form-group row\" _v-2825aafd=\"\">\n                        <label _v-2825aafd=\"\">\n                            <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"show\" checked=\"\" _v-2825aafd=\"\"> 顯示於網頁\n                        </label>\n                        <label _v-2825aafd=\"\">\n                            <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"export\" _v-2825aafd=\"\"> 匯出 CSV\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </v-webadmin-report>\n    <div v-show=\"display==='show'\" _v-2825aafd=\"\">\n        <div class=\"table-div\" _v-2825aafd=\"\">\n            <v-table :ajaxing=\"ajaxing\" :length=\"largeMemberList.length\" _v-2825aafd=\"\">\n                <table class=\"table table-striped\" _v-2825aafd=\"\">\n                    <thead _v-2825aafd=\"\">\n                    <tr _v-2825aafd=\"\">\n                        <td _v-2825aafd=\"\">客戶姓名</td>\n                        <td _v-2825aafd=\"\">電話</td>\n                        <td _v-2825aafd=\"\">電子郵件</td>\n                        <td _v-2825aafd=\"\">總訂單數量</td>\n                        <td _v-2825aafd=\"\">總消費金額</td>\n                    </tr>\n                    </thead>\n                    <tbody _v-2825aafd=\"\">\n                    <tr v-for=\"item in largeMemberList\" _v-2825aafd=\"\">\n                        <td _v-2825aafd=\"\">{{ item.name }}</td>\n                        <td _v-2825aafd=\"\">{{ item.phone }}</td>\n                        <td _v-2825aafd=\"\">{{ item.email }}</td>\n                        <td _v-2825aafd=\"\">{{ item.total_qty}}</td>\n                        <td _v-2825aafd=\"\">{{ item.total}}</td>\n                    </tr>\n                    </tbody>\n                </table>\n            </v-table>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.page-div[_v-2825aafd] {\n  padding: 0px 15px;\n  margin-bottom: 15px; }\n\n/* line 7, stdin */\n.m-l-15[_v-2825aafd] {\n  margin-left: 15px; }\n\n/* line 11, stdin */\n.table-div[_v-2825aafd] {\n  padding: 20px 0px; }\n\n/* line 15, stdin */\n.select-limit[_v-2825aafd] {\n  display: inline;\n  width: 50%; }\n\n/* line 20, stdin */\nlabel[_v-2825aafd] {\n  margin-right: 10px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-2825aafd", module.exports)
  } else {
    hotAPI.update("_v-2825aafd", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/json/stringify":48,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/defineProperty":65,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1359:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _payrollStatistics = require('./payroll-statistics.vue');

var _payrollStatistics2 = _interopRequireDefault(_payrollStatistics);

var _orderDetailsTotalSale = require('./order-details-total-sale.vue');

var _orderDetailsTotalSale2 = _interopRequireDefault(_orderDetailsTotalSale);

var _detailItem = require('./partial/sales/detail-item.vue');

var _detailItem2 = _interopRequireDefault(_detailItem);

var _summaryItem = require('./partial/sales/summary-item.vue');

var _summaryItem2 = _interopRequireDefault(_summaryItem);

var _reportTabList = require('./report-tab-list.vue');

var _reportTabList2 = _interopRequireDefault(_reportTabList);

var _bookingTotalList = require('./booking-total-list.vue');

var _bookingTotalList2 = _interopRequireDefault(_bookingTotalList);

var _admissionStatistics = require('./admission-statistics.vue');

var _admissionStatistics2 = _interopRequireDefault(_admissionStatistics);

var _ticketsUsedReport = require('./tickets-used-report.vue');

var _ticketsUsedReport2 = _interopRequireDefault(_ticketsUsedReport);

var _orderInvoiceList = require('./order-invoice-list.vue');

var _orderInvoiceList2 = _interopRequireDefault(_orderInvoiceList);

var _refundOrderInvoiceList = require('./refund-order-invoice-list.vue');

var _refundOrderInvoiceList2 = _interopRequireDefault(_refundOrderInvoiceList);

var _checkoutReport = require('./checkout-report.vue');

var _checkoutReport2 = _interopRequireDefault(_checkoutReport);

var _saleCheckoutReport = require('./sale-checkout-report.vue');

var _saleCheckoutReport2 = _interopRequireDefault(_saleCheckoutReport);

var _checkoutMemberReport = require('./checkout-member-report.vue');

var _checkoutMemberReport2 = _interopRequireDefault(_checkoutMemberReport);

var _branchDailySaleList = require('./branch-daily-sale-list.vue');

var _branchDailySaleList2 = _interopRequireDefault(_branchDailySaleList);

var _lastBookingAdmission = require('./last-booking-admission.vue');

var _lastBookingAdmission2 = _interopRequireDefault(_lastBookingAdmission);

var _memberReport = require('./member-report.vue');

var _memberReport2 = _interopRequireDefault(_memberReport);

var _reconitionReport = require('./reconition-report.vue');

var _reconitionReport2 = _interopRequireDefault(_reconitionReport);

var _bookingAbsenceReport = require('./booking-absence-report.vue');

var _bookingAbsenceReport2 = _interopRequireDefault(_bookingAbsenceReport);

var _salarySummary = require('./salary-summary.vue');

var _salarySummary2 = _interopRequireDefault(_salarySummary);

var _promotionCouponReport = require('./promotion-coupon-report.vue');

var _promotionCouponReport2 = _interopRequireDefault(_promotionCouponReport);

var _memberContractRemainReport = require('./member-contract-remain-report.vue');

var _memberContractRemainReport2 = _interopRequireDefault(_memberContractRemainReport);

var _bookingConsumeMoneyReport = require('./booking-consume-money-report.vue');

var _bookingConsumeMoneyReport2 = _interopRequireDefault(_bookingConsumeMoneyReport);

var _autoPayPlanReport = require('./auto-pay-plan-report.vue');

var _autoPayPlanReport2 = _interopRequireDefault(_autoPayPlanReport);

var _orderPaymentActionChangedReport = require('./order-payment-action-changed-report.vue');

var _orderPaymentActionChangedReport2 = _interopRequireDefault(_orderPaymentActionChangedReport);

var _memberContractAdminChangeReport = require('./member-contract-admin-change-report.vue');

var _memberContractAdminChangeReport2 = _interopRequireDefault(_memberContractAdminChangeReport);

var _yOYRevenueReport = require('./y-o-y-revenue-report.vue');

var _yOYRevenueReport2 = _interopRequireDefault(_yOYRevenueReport);

var _customerMsSummaryReport = require('./customer-ms-summary-report.vue');

var _customerMsSummaryReport2 = _interopRequireDefault(_customerMsSummaryReport);

var _contractPromotionSalesReport = require('./contract-promotion-sales-report.vue');

var _contractPromotionSalesReport2 = _interopRequireDefault(_contractPromotionSalesReport);

var _contractPromotionSalesReportForStudio = require('./contract-promotion-sales-report-for-studio.vue');

var _contractPromotionSalesReportForStudio2 = _interopRequireDefault(_contractPromotionSalesReportForStudio);

var _salesmenKpiReport = require('./salesmen-kpi-report.vue');

var _salesmenKpiReport2 = _interopRequireDefault(_salesmenKpiReport);

var _customerSpendReport = require('./customer-spend-report.vue');

var _customerSpendReport2 = _interopRequireDefault(_customerSpendReport);

var _memberContractTransferReport = require('./member-contract-transfer-report.vue');

var _memberContractTransferReport2 = _interopRequireDefault(_memberContractTransferReport);

var _autoPayPlanSummaryReport = require('./auto-pay-plan-summary-report.vue');

var _autoPayPlanSummaryReport2 = _interopRequireDefault(_autoPayPlanSummaryReport);

var _scheduleAttendReport = require('./schedule-attend-report.vue');

var _scheduleAttendReport2 = _interopRequireDefault(_scheduleAttendReport);

var _orderRefundRequestList = require('./order-refund-request-list.vue');

var _orderRefundRequestList2 = _interopRequireDefault(_orderRefundRequestList);

var _memberDiscoveryReport = require('./member-discovery-report.vue');

var _memberDiscoveryReport2 = _interopRequireDefault(_memberDiscoveryReport);

var _memberDiscoveryForStudioReport = require('./member-discovery-for-studio-report.vue');

var _memberDiscoveryForStudioReport2 = _interopRequireDefault(_memberDiscoveryForStudioReport);

var _billingSystemChargeReport = require('./billing-system-charge-report.vue');

var _billingSystemChargeReport2 = _interopRequireDefault(_billingSystemChargeReport);

var _unlimitedContractUsedRecordReport = require('./unlimited-contract-used-record-report.vue');

var _unlimitedContractUsedRecordReport2 = _interopRequireDefault(_unlimitedContractUsedRecordReport);

var _rating = require('./rating.vue');

var _rating2 = _interopRequireDefault(_rating);

var _newebpayBankTransferServiceFeeReport = require('./newebpay-bank-transfer-service-fee-report.vue');

var _newebpayBankTransferServiceFeeReport2 = _interopRequireDefault(_newebpayBankTransferServiceFeeReport);

var _newebpayBankTransferServiceFeeReportForStudio = require('./newebpay-bank-transfer-service-fee-report-for-studio.vue');

var _newebpayBankTransferServiceFeeReportForStudio2 = _interopRequireDefault(_newebpayBankTransferServiceFeeReportForStudio);

var _values = require('./partial/reconition/values.vue');

var _values2 = _interopRequireDefault(_values);

var _days = require('./partial/reconition/days.vue');

var _days2 = _interopRequireDefault(_days);

var _summaryItem3 = require('./partial/salary/summary-item.vue');

var _summaryItem4 = _interopRequireDefault(_summaryItem3);

var _detailModal = require('./partial/salary/detail-modal.vue');

var _detailModal2 = _interopRequireDefault(_detailModal);

var _promotionDetail = require('./partial/promotion/promotion-detail.vue');

var _promotionDetail2 = _interopRequireDefault(_promotionDetail);

var _promotionSummary = require('./partial/promotion/promotion-summary.vue');

var _promotionSummary2 = _interopRequireDefault(_promotionSummary);

var _couponDetail = require('./partial/promotion/coupon-detail.vue');

var _couponDetail2 = _interopRequireDefault(_couponDetail);

var _couponSummary = require('./partial/promotion/coupon-summary.vue');

var _couponSummary2 = _interopRequireDefault(_couponSummary);

var _operateModal = require('./partial/refund-order/operate-modal.vue');

var _operateModal2 = _interopRequireDefault(_operateModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//Page
_vue2.default.component('webadmin-order-details-total-sale-report-page', _orderDetailsTotalSale2.default);
_vue2.default.component('webadmin-payroll-statistics-report-page', _payrollStatistics2.default);
_vue2.default.component('webadmin-report-tab-list', _reportTabList2.default);
_vue2.default.component('webadmin-booking-total-list', _bookingTotalList2.default);
_vue2.default.component('webadmin-admission-statistics-report', _admissionStatistics2.default);
_vue2.default.component('webadmin-tickets-used-report', _ticketsUsedReport2.default);
_vue2.default.component('webadmin-order-invoice-list', _orderInvoiceList2.default);
_vue2.default.component('webadmin-refund-order-invoice-list', _refundOrderInvoiceList2.default);
_vue2.default.component('webadmin-checkout-report', _checkoutReport2.default);
_vue2.default.component('webadmin-sale-checkout-report', _saleCheckoutReport2.default);
_vue2.default.component('webadmin-checkout-member-report', _checkoutMemberReport2.default);
_vue2.default.component('webadmin-branch-daily-sale-list', _branchDailySaleList2.default);
_vue2.default.component('webadmin-last-booking-admission', _lastBookingAdmission2.default);
_vue2.default.component('webadmin-member-report', _memberReport2.default);
_vue2.default.component('webadmin-reconition-report', _reconitionReport2.default);
_vue2.default.component('webadmin-booking-absence-report', _bookingAbsenceReport2.default);
_vue2.default.component('webadmin-salary-summary-report', _salarySummary2.default);
_vue2.default.component('webadmin-promotion-coupon-report', _promotionCouponReport2.default);
_vue2.default.component('webadmin-member-contract-remain-report', _memberContractRemainReport2.default);
_vue2.default.component('webadmin-booking-consume-money-report', _bookingConsumeMoneyReport2.default);
_vue2.default.component('webadmin-auto-pay-plan-report', _autoPayPlanReport2.default);
_vue2.default.component('webadmin-order-payment-action-changed-report', _orderPaymentActionChangedReport2.default);
_vue2.default.component('webadmin-member-contact-admin-change-report', _memberContractAdminChangeReport2.default);
_vue2.default.component('webadmin-y-o-y-revenue-report', _yOYRevenueReport2.default);
_vue2.default.component('webadmin-customer-ms-summary-report', _customerMsSummaryReport2.default);
_vue2.default.component('webadmin-contract-promotion-sales-report', _contractPromotionSalesReport2.default);
_vue2.default.component('webadmin-contract-promotion-sales-report-for-studio', _contractPromotionSalesReportForStudio2.default);
_vue2.default.component('webadmin-salesmen-kpi-report', _salesmenKpiReport2.default);
_vue2.default.component('webadmin-spend-spend-report-page', _customerSpendReport2.default);
_vue2.default.component('webadmin-schedule-attend-report', _scheduleAttendReport2.default);
_vue2.default.component('member-contract-transfer-report', _memberContractTransferReport2.default);
_vue2.default.component('webadmin-auto-pay-plan-summary-report', _autoPayPlanSummaryReport2.default);
_vue2.default.component('webadmin-order-refund-request-list', _orderRefundRequestList2.default);
_vue2.default.component('webadmin-member-discovery-report', _memberDiscoveryReport2.default);
_vue2.default.component('webadmin-member-discovery-for-studio-report', _memberDiscoveryForStudioReport2.default);
_vue2.default.component('webadmin-billing-system-charge-report', _billingSystemChargeReport2.default);
_vue2.default.component('webadmin-unlimited-contract-used-record-report', _unlimitedContractUsedRecordReport2.default);
_vue2.default.component('webadmin-rating-report', _rating2.default);
_vue2.default.component('webadmin-newebpay-bank-transfer-service-fee-report', _newebpayBankTransferServiceFeeReport2.default);
_vue2.default.component('webadmin-newebpay-bank-transfer-service-fee-report-for-studio', _newebpayBankTransferServiceFeeReportForStudio2.default);

//Partial
_vue2.default.component('webadmin-sale-report-detail-result', _detailItem2.default);
_vue2.default.component('webadmin-sale-report-summary-result', _summaryItem2.default);
_vue2.default.component('webadmin-reconition-report-values', _values2.default);
_vue2.default.component('webadmin-reconition-report-days', _days2.default);
_vue2.default.component('webadmin-salary-report-summary', _summaryItem4.default);
_vue2.default.component('webadmin-salary-detail-modal', _detailModal2.default);
_vue2.default.component('webadmin-promotion-report-detail', _promotionDetail2.default);
_vue2.default.component('webadmin-promotion-report-summary', _promotionSummary2.default);
_vue2.default.component('webadmin-coupon-report-detail', _couponDetail2.default);
_vue2.default.component('webadmin-coupon-report-summary', _couponSummary2.default);
_vue2.default.component('webadmin-refund-order-operate-modal', _operateModal2.default);

},{"./admission-statistics.vue":1345,"./auto-pay-plan-report.vue":1346,"./auto-pay-plan-summary-report.vue":1347,"./billing-system-charge-report.vue":1348,"./booking-absence-report.vue":1349,"./booking-consume-money-report.vue":1350,"./booking-total-list.vue":1351,"./branch-daily-sale-list.vue":1352,"./checkout-member-report.vue":1353,"./checkout-report.vue":1354,"./contract-promotion-sales-report-for-studio.vue":1355,"./contract-promotion-sales-report.vue":1356,"./customer-ms-summary-report.vue":1357,"./customer-spend-report.vue":1358,"./last-booking-admission.vue":1360,"./member-contract-admin-change-report.vue":1361,"./member-contract-remain-report.vue":1362,"./member-contract-transfer-report.vue":1363,"./member-discovery-for-studio-report.vue":1364,"./member-discovery-report.vue":1365,"./member-report.vue":1366,"./newebpay-bank-transfer-service-fee-report-for-studio.vue":1367,"./newebpay-bank-transfer-service-fee-report.vue":1368,"./order-details-total-sale.vue":1369,"./order-invoice-list.vue":1370,"./order-payment-action-changed-report.vue":1371,"./order-refund-request-list.vue":1372,"./partial/promotion/coupon-detail.vue":1373,"./partial/promotion/coupon-summary.vue":1374,"./partial/promotion/promotion-detail.vue":1375,"./partial/promotion/promotion-summary.vue":1376,"./partial/reconition/days.vue":1377,"./partial/reconition/values.vue":1378,"./partial/refund-order/operate-modal.vue":1379,"./partial/salary/detail-modal.vue":1380,"./partial/salary/summary-item.vue":1381,"./partial/sales/detail-item.vue":1382,"./partial/sales/summary-item.vue":1383,"./payroll-statistics.vue":1384,"./promotion-coupon-report.vue":1385,"./rating.vue":1386,"./reconition-report.vue":1387,"./refund-order-invoice-list.vue":1388,"./report-tab-list.vue":1389,"./salary-summary.vue":1390,"./sale-checkout-report.vue":1391,"./salesmen-kpi-report.vue":1392,"./schedule-attend-report.vue":1393,"./tickets-used-report.vue":1394,"./unlimited-contract-used-record-report.vue":1395,"./y-o-y-revenue-report.vue":1396,"vue":792}],1360:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.page-div[_v-4f0fc2c3] {\n  padding: 0 15px;\n  margin-bottom: 15px; }\n\n/* line 7, stdin */\n.table-div[_v-4f0fc2c3] {\n  padding: 20px 0; }\n\n/* line 11, stdin */\n.table-striped thead[_v-4f0fc2c3] {\n  border-bottom: 1px solid #000; }\n\n/* line 15, stdin */\n.multiselect[_v-4f0fc2c3] {\n  padding-bottom: 5px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _watch;

var _vuex = require('vuex');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            display: 'show'
        };
    },
    created: function created() {},
    mounted: function mounted() {
        var _this = this;

        this.configuredRun(function () {
            _this.changeFilterOption({
                prop: 'studioId',
                value: {
                    id: _this.configureStates.studioId,
                    brand_name: ''
                }
            });
            if (_this.configureStates.isSeventeen) {
                return _this.fetchStudioList();
            }
            if (_this.configureStates.isBranch) {
                _this.branchIds = [{
                    'id': _this.configureStates.branchId,
                    'branch_name': ''
                }];
            }
        });
        this.changeDateOption({
            prop: 'startDate',
            value: moment().subtract(1, 'days').format('YYYY/MM/DD')
        });
        this.changeDateOption({
            prop: 'endDate',
            value: moment().subtract(1, 'days').format('YYYY/MM/DD')
        });
    },

    watch: (_watch = {}, (0, _defineProperty3.default)(_watch, 'filterOptions.studioId', function filterOptionsStudioId(n, o) {
        if (this.configureStates.isSeventeen || this.configureStates.isStudio) {
            this.fetchBranchList({
                studioId: n.id
            });
        }
    }), (0, _defineProperty3.default)(_watch, 'list', function list(n, o) {
        if (this.display === 'export') {
            var results = this.csvDataHandler(n);
            this.download(results);
        }
        this.getCustomers(n);
    }), _watch),
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        configureStates: function configureStates(state) {
            return state.webadmin.configure;
        }
    }), (0, _vuex.mapState)('webadmin/configure', ['configured', 'studioList', 'branchList']), (0, _vuex.mapState)('webadmin/lastBookingAdmissionReport', ['blockOpenStatus', 'dateOptions', 'filterOptions', 'ajaxing', 'list', 'typeShow']), {
        studioId: {
            get: function get() {
                return this.filterOptions.studioId;
            },
            set: function set(newValue) {
                var _this2 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                    return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.next = 2;
                                    return _this2.changeFilterOption({ 'prop': 'studioId', value: newValue });

                                case 2:
                                    _this2.cleanBranch();

                                    if (!newValue) {
                                        _context.next = 6;
                                        break;
                                    }

                                    _context.next = 6;
                                    return _this2.fetchBranchList({ studioId: newValue.id });

                                case 6:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this2);
                }))();
            }
        },
        branchIds: {
            get: function get() {
                return this.filterOptions.branchIds;
            },
            set: function set(newValue) {
                var _this3 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                    return _regenerator2.default.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    _context2.next = 2;
                                    return _this3.changeFilterOption({ 'prop': 'branchIds', value: newValue });

                                case 2:
                                case 'end':
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, _this3);
                }))();
            }
        },
        searchTypes: {
            get: function get() {
                return this.filterOptions.searchTypes;
            },
            set: function set(newValue) {
                var _this4 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
                    return _regenerator2.default.wrap(function _callee3$(_context3) {
                        while (1) {
                            switch (_context3.prev = _context3.next) {
                                case 0:
                                    _context3.next = 2;
                                    return _this4.$store.dispatch('webadmin/lastBookingAdmissionReport/changeFilterOption', { 'prop': 'searchTypes', value: newValue });

                                case 2:
                                case 'end':
                                    return _context3.stop();
                            }
                        }
                    }, _callee3, _this4);
                }))();
            }
        },
        excludeFuture: {
            get: function get() {
                return this.filterOptions.excludeFuture;
            },
            set: function set(newValue) {
                var _this5 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
                    return _regenerator2.default.wrap(function _callee4$(_context4) {
                        while (1) {
                            switch (_context4.prev = _context4.next) {
                                case 0:
                                    _context4.next = 2;
                                    return _this5.changeFilterOption({ 'prop': 'excludeFuture', value: newValue });

                                case 2:
                                case 'end':
                                    return _context4.stop();
                            }
                        }
                    }, _callee4, _this5);
                }))();
            }
        }
    }),
    methods: (0, _extends3.default)({
        getCustomers: function getCustomers(list) {
            var memberIds = '';
            if (list.length > 0) {
                for (var i = 0; i < list.length; i++) {
                    if (i === list.length - 1) {
                        memberIds += list[i].member_id;
                    } else {
                        memberIds += list[i].member_id + ',';
                    }
                }
            }
            this.$refs.report.setCustomers(memberIds);
            return memberIds;
        },
        updateFilterOption: function updateFilterOption(field) {
            var _this6 = this;

            return function (value) {
                return _this6.changeFilterOption({
                    prop: field,
                    value: value
                });
            };
        }
    }, (0, _vuex.mapActions)('webadmin/configure', ['configuredRun', 'fetchStudioList', 'fetchBranchList']), (0, _vuex.mapActions)('webadmin/lastBookingAdmissionReport', ['submitReport', 'toggleBlock', 'changeDateOption', 'changeFilterOption', 'changeItemOption', 'cleanBranch', 'cleanBranchRelated']), {
        download: function download(_csvString) {
            var downloadLink = document.createElement("a");
            downloadLink.download = "last_booking_admission_records_" + moment().format("YYYYMMDDHHmmss") + ".csv";
            downloadLink.innerHTML = "Download File";
            if (window.webkitURL != null) {
                var csvData = new Blob(['\uFEFF' + _csvString], { type: 'text/csv;charset=utf-8' });
                var csvUrl = URL.createObjectURL(csvData);
                downloadLink.href = csvUrl;
            }
            downloadLink.click();
        },
        csvDataHandler: function csvDataHandler(data) {
            data = this.columnFormatter(data);
            return Papa.unparse(data, {
                delimiter: ','
            });
        },
        columnFormatter: function columnFormatter(d) {
            String.prototype.replaceAll = function (search, replacement) {
                var target = this;
                return target.replace(new RegExp(search, 'g'), replacement);
            };
            var data = [];
            if (d.length == 0) {
                data[0] = { 'member_name': '', 'last_time': '', 'branch_name': '', 'display_type': '' };
            } else {
                data = _lodash2.default.map(d, function (value) {
                    return _lodash2.default.pick(value, ['member_name', 'last_time', 'branch_name', 'display_type']);
                });
            }
            data = (0, _stringify2.default)(data);
            data = data.replaceAll('member_name', '客戶姓名');
            data = data.replaceAll('last_time', '時間');
            data = data.replaceAll('branch_name', '場館');
            data = data.replaceAll('display_type', '出席/入場');
            return data;
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"page-div\" _v-4f0fc2c3=\"\">\n    <v-webadmin-report :block-open-status=\"blockOpenStatus\" :date-options=\"dateOptions\" :toggle-block=\"toggleBlock\" :change-date-option=\"changeDateOption\" :disable-submit=\"ajaxing\" :submit=\"submitReport\" :is-open-temporary-customer-button=\"true\" :studio-id=\"studioId\" ref=\"report\" limit-date=\"90\" title=\"最後一次出席入場\" _v-4f0fc2c3=\"\">\n        <div slot=\"second-block\" _v-4f0fc2c3=\"\">\n            <div class=\"filters\" _v-4f0fc2c3=\"\">\n                <div class=\"row\" _v-4f0fc2c3=\"\">\n                    <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen\" _v-4f0fc2c3=\"\">\n                        <div class=\"form-group\" _v-4f0fc2c3=\"\">\n                            <v-mutiselect :model.sync=\"studioId\" :options=\"studioList\" :preserve-search=\"true\" :placeholder=\"configureStates.ajaxing.studioList ? '品牌讀取中…' : '請選擇品牌'\" label=\"brand_name\" track-by=\"id\" _v-4f0fc2c3=\"\">\n                            </v-mutiselect>\n                        </div>\n                    </div>\n                    <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen || configureStates.isStudio\" _v-4f0fc2c3=\"\">\n                        <div class=\"form-group\" _v-4f0fc2c3=\"\">\n                            <v-mutiselect :model.sync=\"branchIds\" :options=\"branchList\" :disabled=\"configureStates.ajaxing.branchList\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"false\" :placeholder=\"configureStates.ajaxing.branchList ? '場館讀取中…' : '全部場館'\" label=\"branch_name\" track-by=\"id\" :taggable=\"true\" tag-name=\"branch_name\" :max-height=\"500\" _v-4f0fc2c3=\"\">\n                            </v-mutiselect>\n                        </div>\n                    </div>\n                    <div class=\"col-sm-6\" _v-4f0fc2c3=\"\">\n                        <div class=\"form-group\" _v-4f0fc2c3=\"\">\n                            <v-mutiselect :model.sync=\"searchTypes\" :options=\"typeShow\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"false\" :placeholder=\"searchTypes.length>0 ? '' : '出席及入場'\" label=\"name\" track-by=\"type\" :max-height=\"500\" tag-name=\"name\" _v-4f0fc2c3=\"\">\n                            </v-mutiselect>\n                        </div>\n                    </div>\n                    <div class=\"col-sm-12\" _v-4f0fc2c3=\"\">\n                        <div class=\"form-group\" _v-4f0fc2c3=\"\">\n                            <label _v-4f0fc2c3=\"\">\n                                <input type=\"checkbox\" v-model=\"excludeFuture\" _v-4f0fc2c3=\"\"> 排除已有未來預約的客戶\n                            </label>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div slot=\"fourth-block\" _v-4f0fc2c3=\"\">\n            <div class=\"row\" _v-4f0fc2c3=\"\">\n                <div class=\"col-sm-6\" _v-4f0fc2c3=\"\">\n                    <div class=\"form-group row\" _v-4f0fc2c3=\"\">\n                        <label _v-4f0fc2c3=\"\">\n                            <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"show\" checked=\"\" _v-4f0fc2c3=\"\"> 顯示於網頁\n                        </label>\n                        <label _v-4f0fc2c3=\"\">\n                            <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"export\" _v-4f0fc2c3=\"\"> 匯出 CSV\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </v-webadmin-report>\n\n    <div v-show=\"display==='show'\" _v-4f0fc2c3=\"\">\n        <div class=\"m-top-25\" v-if=\"Object.keys(list).length\" _v-4f0fc2c3=\"\">\n            <h4 _v-4f0fc2c3=\"\">總人次：{{Object.keys(list).length}}</h4>\n        </div>\n        <div class=\"table-div\" _v-4f0fc2c3=\"\">\n            <v-table :ajaxing=\"ajaxing\" :length=\"Object.keys(list).length\" _v-4f0fc2c3=\"\">\n                <table class=\"table table-striped\" _v-4f0fc2c3=\"\">\n                    <thead _v-4f0fc2c3=\"\">\n                    <tr _v-4f0fc2c3=\"\">\n                        <td _v-4f0fc2c3=\"\">客戶姓名</td>\n                        <td _v-4f0fc2c3=\"\">時間</td>\n                        <td _v-4f0fc2c3=\"\">場館</td>\n                        <td _v-4f0fc2c3=\"\">出席/入場</td>\n                    </tr>\n                    </thead>\n                    <tbody _v-4f0fc2c3=\"\">\n                    <tr v-for=\"item in list\" _v-4f0fc2c3=\"\">\n                        <td _v-4f0fc2c3=\"\">{{item.member_name}}</td>\n                        <td _v-4f0fc2c3=\"\">{{item.last_time}}</td>\n                        <td _v-4f0fc2c3=\"\">{{item.branch_name}}</td>\n                        <td _v-4f0fc2c3=\"\">{{item.display_type}}</td>\n                    </tr>\n                    </tbody>\n                </table>\n            </v-table>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.page-div[_v-4f0fc2c3] {\n  padding: 0 15px;\n  margin-bottom: 15px; }\n\n/* line 7, stdin */\n.table-div[_v-4f0fc2c3] {\n  padding: 20px 0; }\n\n/* line 11, stdin */\n.table-striped thead[_v-4f0fc2c3] {\n  border-bottom: 1px solid #000; }\n\n/* line 15, stdin */\n.multiselect[_v-4f0fc2c3] {\n  padding-bottom: 5px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-4f0fc2c3", module.exports)
  } else {
    hotAPI.update("_v-4f0fc2c3", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/json/stringify":48,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/defineProperty":65,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1361:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.page-div[_v-6e5d8836] {\n  padding: 0px 15px;\n  margin-bottom: 15px; }\n\n/* line 7, stdin */\n.m-l-15[_v-6e5d8836] {\n  margin-left: 15px; }\n\n/* line 11, stdin */\n.table-div[_v-6e5d8836] {\n  padding: 20px 0px; }\n\n/* line 15, stdin */\n.form-title[_v-6e5d8836] {\n  font-size: 16px;\n  font-weight: bold;\n  display: inline-block;\n  width: 60px; }\n\n/* line 22, stdin */\n.negative-number[_v-6e5d8836] {\n  color: red; }\n\n/* line 26, stdin */\n.cube[_v-6e5d8836] {\n  max-width: 80px;\n  float: left;\n  margin: 12px 24px;\n  font-weight: bold;\n  font-size: 18px; }\n\n/* line 33, stdin */\n.total-list[_v-6e5d8836] {\n  width: 100%;\n  border: 1px solid;\n  margin: 30px 0px; }\n\n/* line 38, stdin */\n.total-list[_v-6e5d8836]:after {\n  clear: both; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _watch;

var _vuex = require('vuex');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            display: 'show',
            valuesList: [],
            contractIds: [],
            changeMemberList: [],
            changeContractList: [],
            changeMemberListAjax: false,
            changeContractListAjax: false,
            MemberIds: [],
            ContractIds: []
        };
    },
    mounted: function mounted() {
        var _this = this;

        this.configuredRun(function () {
            _this.changeFilterOption({
                prop: 'studioId',
                value: {
                    id: _this.configureStates.studioId,
                    brand_name: ''
                }
            });
            _this.changeFilterOption({
                prop: 'branchId',
                value: _this.configureStates.branchId
            });
            if (_this.configureStates.isSeventeen) {
                return _this.fetchStudioList();
            }
            if (_this.configureStates.isBranch) {
                _this.branchIds = [{
                    'id': _this.configureStates.branchId,
                    'branch_name': ''
                }];
            }
        });

        this.changeDateOption({
            prop: 'startDate',
            value: moment().format('YYYY/MM/DD')
        });

        this.changeDateOption({
            prop: 'endDate',
            value: moment().format('YYYY/MM/DD')
        });
    },

    watch: (_watch = {}, (0, _defineProperty3.default)(_watch, 'filterOptions.studioId', function filterOptionsStudioId(n, o) {

        if (this.configureStates.isSeventeen || this.configureStates.isStudio) {
            this.fetchBranchList({
                studioId: n.id
            });
            if (n.id != 0) {
                this.initChangeMembers();
                this.initChangeContracts();
            }
        }
    }), (0, _defineProperty3.default)(_watch, 'valuesList', function valuesList(newValue, oldValue) {
        if (newValue.length > 0 && this.display === 'export') {
            var results = this.csvDataHandler(newValue);
            this.download(results);
        }
    }), (0, _defineProperty3.default)(_watch, 'dateOptions.startDate', function dateOptionsStartDate(n, o) {

        this.initChangeMembers();
        this.initChangeContracts();
    }), (0, _defineProperty3.default)(_watch, 'dateOptions.endDate', function dateOptionsEndDate(n, o) {

        this.initChangeMembers();
        this.initChangeContracts();
    }), _watch),
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        configureStates: function configureStates(state) {
            return state.webadmin.configure;
        }
    }), (0, _vuex.mapState)('webadmin/configure', ['configured', 'studioList', 'branchList', 'branchId']), (0, _vuex.mapState)('webadmin/baseReport', ['blockOpenStatus', 'dateOptions', 'filterOptions']), {
        studioId: {
            get: function get() {
                return this.filterOptions.studioId;
            },
            set: function set(newValue) {
                var _this2 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                    return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.next = 2;
                                    return _this2.changeFilterOption({ 'prop': 'studioId', value: newValue });

                                case 2:
                                    _this2.cleanBranch();

                                    if (!newValue) {
                                        _context.next = 6;
                                        break;
                                    }

                                    _context.next = 6;
                                    return _this2.fetchBranchList({ studioId: newValue.id });

                                case 6:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this2);
                }))();
            }
        },
        branchIds: {
            get: function get() {
                return this.filterOptions.branchIds;
            },
            set: function set(newValue) {
                var _this3 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                    return _regenerator2.default.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    _context2.next = 2;
                                    return _this3.changeFilterOption({ 'prop': 'branchIds', value: newValue });

                                case 2:
                                case 'end':
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, _this3);
                }))();
            }
        },
        ajaxing: {
            get: function get() {
                return this.$store.state.webadmin.baseReport.ajaxing;
            },
            set: function set(newValue) {
                var _this4 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
                    return _regenerator2.default.wrap(function _callee3$(_context3) {
                        while (1) {
                            switch (_context3.prev = _context3.next) {
                                case 0:
                                    _context3.next = 2;
                                    return _this4.changeAjaxing(newValue);

                                case 2:
                                case 'end':
                                    return _context3.stop();
                            }
                        }
                    }, _callee3, _this4);
                }))();
            }
        }
    }),
    methods: (0, _extends3.default)({
        updateFilterOption: function updateFilterOption(field) {
            var _this5 = this;

            return function (value) {
                return _this5.changeFilterOption({
                    prop: field,
                    value: value
                });
            };
        }
    }, (0, _vuex.mapActions)('webadmin/configure', ['configuredRun', 'fetchStudioList', 'fetchBranchList']), (0, _vuex.mapActions)('webadmin/baseReport', ['beforeSubmit', 'toggleBlock', 'changeDateOption', 'changeFilterOption', 'cleanBranch', 'cleanBranchRelated', 'changeItemOption', 'setDetailTarget', "changeAjaxing"]), {
        download: function download(_csvString) {
            var downloadLink = document.createElement("a");
            downloadLink.download = "member_contract_change.csv";
            downloadLink.innerHTML = "Download File";
            if (window.webkitURL != null) {
                var code = encodeURIComponent(_csvString);
                downloadLink.href = "data:application/csv;charset=utf-8,%EF%BB%BF" + code;
            }
            downloadLink.click();
        },
        columnFormater: function columnFormater(data) {
            String.prototype.replaceAll = function (search, replacement) {
                var target = this;
                return target.replace(new RegExp(search, 'g'), replacement);
            };

            return this.valueColumnFormater(data);
        },
        valueColumnFormater: function valueColumnFormater(data) {
            var data = _lodash2.default.map(data, function (value) {
                return _lodash2.default.pick(value, ['member_name', 'contract_name', 'created_at_old', 'admin_name', 'description']);
            });
            data = (0, _stringify2.default)(data);
            data = data.replaceAll('contractName', '客戶姓名');
            data = data.replaceAll('orderId', '方案名稱');
            data = data.replaceAll('memberName', '異動時間');
            data = data.replaceAll('totalRecognizedValue', '異動人');
            data = data.replaceAll('contractStartDay', '異動紀錄');

            return data;
        },
        csvDataHandler: function csvDataHandler(watchData) {
            var data = [];
            _lodash2.default.assign(data, watchData);
            data = this.columnFormater(data);
            var results = Papa.unparse(data, {
                delimiter: ','
            });
            return results;
        },
        submit: function submit() {
            this.beforeSubmit();
            this.getQueryResult();
        },
        getQueryResult: function getQueryResult() {
            var _this6 = this;

            this.ajaxing = true;

            if (!this.studioId || this.studioId.id == "0") {
                $17.swal({
                    title: '請選擇品牌！!',
                    type: 'warning'
                });
                this.ajaxing = false;
                return;
            }

            var branchQuery = '';
            var memberQuery = '';
            var contractQuery = '';

            if (this.branchIds.length > 0) {
                branchQuery = this.branchIds.reduce(function (carry, branch) {
                    carry += '&branch_ids[]=' + branch.id;

                    return carry;
                }, '');
            }

            if (this.MemberIds.length > 0) {
                memberQuery = this.MemberIds.reduce(function (carry, member) {
                    carry += '&member_ids[]=' + member.id;
                    return carry;
                }, '');
            }

            if (this.contractIds.length > 0) {
                contractQuery = this.contractIds.reduce(function (carry, contract) {
                    carry += '&contract_ids[]=' + contract.id;
                    return carry;
                }, '');
            }

            var queryString = 'start_date=' + this.dateOptions.startDate + '&end_date=' + this.dateOptions.endDate + branchQuery + memberQuery + contractQuery;

            this.$http.get('/adminapi/report/fetch_member_contract_change/studio/' + this.studioId.id + '?' + queryString).then(function (response) {
                var data = response.body;
                _this6.valuesList = data.contractChangeRecords;
                _this6.ajaxing = false;
            }, function (error) {
                _this6.ajaxing = false;
                if (error.status == 0) {
                    $17.swal({
                        title: '伺服器無回應，請檢查網路。',
                        type: 'error'
                    });
                    return;
                }
                $17.swal({
                    title: error.message,
                    type: 'warning'
                });
            });
        },
        initChangeMembers: function initChangeMembers() {
            var _this7 = this;

            this.MemberIds = [];
            this.changeMemberListAjax = true;

            if (!this.studioId || this.studioId.id == "0") {
                this.changeMemberListAjax = false;
                return;
            }

            var queryString = 'start_date=' + this.dateOptions.startDate + '&end_date=' + this.dateOptions.endDate;
            this.$http.get('/adminapi/report/member_contract_change/studio/' + this.studioId.id + '?' + queryString).then(function (response) {
                var data = response.body;
                _this7.changeMemberList = data.members;
                _this7.changeMemberListAjax = false;
            }, function (error) {
                _this7.changeMemberListAjax = false;
                if (error.status == 0) {
                    $17.swal({
                        title: '伺服器無回應，請檢查網路。',
                        type: 'error'
                    });
                    return;
                }
                $17.swal({
                    title: '取得場館人員資訊 error',
                    type: 'warning'
                });
            });
        },
        initChangeContracts: function initChangeContracts() {
            var _this8 = this;

            this.ContractIds = [];
            this.changeContractListAjax = true;
            if (!this.studioId || this.studioId.id == "0") {
                this.changeContractListAjax = false;
                return;
            }

            var queryString = 'start_date=' + this.dateOptions.startDate + '&end_date=' + this.dateOptions.endDate;
            this.$http.get('/adminapi/report/contract_change/studio/' + this.studioId.id + '?' + queryString).then(function (response) {
                var data = response.body;
                _this8.changeContractList = data.contracts;
                _this8.changeContractListAjax = false;
            }, function (error) {
                _this8.changeContractListAjax = false;
                if (error.status == 0) {
                    $17.swal({
                        title: '伺服器無回應，請檢查網路。',
                        type: 'error'
                    });
                    return;
                }
                $17.swal({
                    title: '取得場方案資訊 error',
                    type: 'warning'
                });
            });
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"page-div\" _v-6e5d8836=\"\">\n    <v-webadmin-report :block-open-status=\"blockOpenStatus\" :date-options=\"dateOptions\" :toggle-block=\"toggleBlock\" :change-date-option=\"changeDateOption\" :disable-submit=\"ajaxing\" :submit=\"submit\" limit-date=\"366\" title=\"管理者異動方案紀錄\" _v-6e5d8836=\"\">\n        <div slot=\"second-block\" _v-6e5d8836=\"\">\n            <div class=\"row\" _v-6e5d8836=\"\">\n                <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen\" _v-6e5d8836=\"\">\n                    <div class=\"form-group\" _v-6e5d8836=\"\">\n                        <v-mutiselect :model.sync=\"studioId\" :options=\"studioList\" :preserve-search=\"true\" :placeholder=\"configureStates.ajaxing.studioList ? '品牌讀取中…' : '請選擇品牌'\" label=\"brand_name\" track-by=\"id\" _v-6e5d8836=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n                <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen || configureStates.isStudio\" _v-6e5d8836=\"\">\n                    <div class=\"form-group\" _v-6e5d8836=\"\">\n                        <v-mutiselect :model.sync=\"branchIds\" :options=\"branchList\" :disabled=\"configureStates.ajaxing.branchList\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"false\" :placeholder=\"configureStates.ajaxing.branchList ? '場館讀取中…' : '全部場館'\" label=\"branch_name\" track-by=\"id\" :taggable=\"true\" tag-name=\"branch_name\" :max-height=\"500\" _v-6e5d8836=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n            </div>\n            <div class=\"row\" _v-6e5d8836=\"\">\n\n                <div class=\"col-sm-6\" _v-6e5d8836=\"\">\n                    <div class=\"form-group\" _v-6e5d8836=\"\">\n                        <v-mutiselect :model.sync=\"MemberIds\" :options=\"changeMemberList\" :disabled=\"changeMemberListAjax\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"true\" :placeholder=\"changeMemberListAjax ? '人員讀取中…' : '全部人員'\" label=\"name\" track-by=\"id\" :taggable=\"false\" tag-name=\"name\" :max-height=\"300\" open-direction=\"bottom\" _v-6e5d8836=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n\n                <div class=\"col-sm-6\" _v-6e5d8836=\"\">\n                    <div class=\"form-group\" _v-6e5d8836=\"\">\n                        <v-mutiselect :model.sync=\"contractIds\" :options=\"changeContractList\" :disabled=\"changeContractListAjax\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"true\" :placeholder=\"changeContractListAjax ? '方案讀取中…' : '全部方案'\" label=\"name\" track-by=\"id\" :taggable=\"false\" tag-name=\"name\" :max-height=\"300\" open-direction=\"bottom\" _v-6e5d8836=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div slot=\"fourth-block\" _v-6e5d8836=\"\">\n            <div class=\"row\" _v-6e5d8836=\"\">\n                <div class=\"col-sm-6\" _v-6e5d8836=\"\">\n                    <div class=\"form-group row\" _v-6e5d8836=\"\">\n                        <label _v-6e5d8836=\"\">\n                            <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"show\" checked=\"\" _v-6e5d8836=\"\"> 顯示於網頁\n                        </label>\n                        <label _v-6e5d8836=\"\">\n                            <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"export\" _v-6e5d8836=\"\"> 匯出 CSV\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </v-webadmin-report>\n    <div v-show=\"display == 'show'\" _v-6e5d8836=\"\">\n        <div class=\"table-div\" _v-6e5d8836=\"\">\n            <v-table :ajaxing=\"ajaxing\" :length=\"valuesList.length\" _v-6e5d8836=\"\">\n                <table class=\"table table-striped\" _v-6e5d8836=\"\">\n                    <thead _v-6e5d8836=\"\">\n                    <tr _v-6e5d8836=\"\">\n                        <td _v-6e5d8836=\"\">客戶姓名</td>\n                        <td _v-6e5d8836=\"\">方案名稱</td>\n                        <td _v-6e5d8836=\"\">異動時間</td>\n                        <td _v-6e5d8836=\"\">異動人</td>\n                        <td _v-6e5d8836=\"\">異動紀錄</td>\n                    </tr>\n                    </thead>\n                    <tbody _v-6e5d8836=\"\">\n                    <tr v-for=\"item in valuesList\" _v-6e5d8836=\"\">\n                        <td _v-6e5d8836=\"\">{{ item.member_name }}</td>\n                        <td _v-6e5d8836=\"\">{{ item.contract_name }}</td>\n                        <td _v-6e5d8836=\"\">{{ item.created_at_old }}</td>\n                        <td _v-6e5d8836=\"\">{{ item.admin_name }}</td>\n                        <td _v-6e5d8836=\"\">{{ item.description }}</td>\n                    </tr>\n                    </tbody>\n                </table>\n            </v-table>\n\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.page-div[_v-6e5d8836] {\n  padding: 0px 15px;\n  margin-bottom: 15px; }\n\n/* line 7, stdin */\n.m-l-15[_v-6e5d8836] {\n  margin-left: 15px; }\n\n/* line 11, stdin */\n.table-div[_v-6e5d8836] {\n  padding: 20px 0px; }\n\n/* line 15, stdin */\n.form-title[_v-6e5d8836] {\n  font-size: 16px;\n  font-weight: bold;\n  display: inline-block;\n  width: 60px; }\n\n/* line 22, stdin */\n.negative-number[_v-6e5d8836] {\n  color: red; }\n\n/* line 26, stdin */\n.cube[_v-6e5d8836] {\n  max-width: 80px;\n  float: left;\n  margin: 12px 24px;\n  font-weight: bold;\n  font-size: 18px; }\n\n/* line 33, stdin */\n.total-list[_v-6e5d8836] {\n  width: 100%;\n  border: 1px solid;\n  margin: 30px 0px; }\n\n/* line 38, stdin */\n.total-list[_v-6e5d8836]:after {\n  clear: both; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-6e5d8836", module.exports)
  } else {
    hotAPI.update("_v-6e5d8836", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/json/stringify":48,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/defineProperty":65,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1362:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.page-div[_v-5f4adb38] {\n  padding: 0px 15px;\n  margin-bottom: 15px; }\n\n/* line 8, stdin */\n.table-div[_v-5f4adb38] {\n  padding: 20px 0px; }\n\n/* line 11, stdin */\ninput[type=number][_v-5f4adb38] {\n  width: 6em; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _watch;

var _vuex = require('vuex');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            display: 'show',
            memberContractList: [],
            enableEndTime: 0,
            enableRemainValue: 0,
            endTimeEnd: '',
            endTimeStart: '',
            remainValueMin: '',
            remainValueMax: '',
            contractType: [],
            contractListType: [{
                name: "無限",
                value: 1
            }, {
                name: "點數",
                value: 2
            }, {
                name: "次數",
                value: 3
            }, {
                name: "期課",
                value: 4
            }]
        };
    },
    mounted: function mounted() {
        var _this = this;

        this.configuredRun(function () {
            _this.changeFilterOption({
                prop: 'studioId',
                value: {
                    id: _this.configureStates.studioId,
                    brand_name: ''
                }
            });
            _this.changeFilterOption({
                prop: 'branchId',
                value: _this.configureStates.branchId
            });
            if (_this.configureStates.isSeventeen) {
                return _this.fetchStudioList();
            }
            if (_this.configureStates.isBranch) {
                _this.branchIds = [{
                    'id': _this.configureStates.branchId,
                    'branch_name': ''
                }];
            }
        });

        this.changeDateOption({
            prop: 'startDate',
            value: moment().add(-1, 'months').format('YYYY/MM/DD')
        });

        this.changeDateOption({
            prop: 'endDate',
            value: moment().format('YYYY/MM/DD')
        });
    },

    watch: (_watch = {}, (0, _defineProperty3.default)(_watch, 'filterOptions.studioId', function filterOptionsStudioId(n, o) {
        if (this.configureStates.isSeventeen || this.configureStates.isStudio) {
            this.fetchBranchList({
                studioId: n.id
            });
        }
    }), (0, _defineProperty3.default)(_watch, 'memberContractList', function memberContractList(newVal, oldVal) {
        if (newVal.length > 0 && this.display == 'export') {
            var result = this.csvDataHandler(newVal);
            this.download(result);
        }
    }), _watch),
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        configureStates: function configureStates(state) {
            return state.webadmin.configure;
        }
    }), (0, _vuex.mapState)('webadmin/configure', ['configured', 'studioList', 'branchList', 'branchId', 'contractList']), (0, _vuex.mapState)('webadmin/baseReport', ['blockOpenStatus', 'dateOptions', 'filterOptions']), {
        studioId: {
            get: function get() {
                return this.filterOptions.studioId;
            },
            set: function set(newValue) {
                var _this2 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                    return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.next = 2;
                                    return _this2.changeFilterOption({ 'prop': 'studioId', value: newValue });

                                case 2:
                                    _this2.cleanBranch();

                                    if (!newValue) {
                                        _context.next = 6;
                                        break;
                                    }

                                    _context.next = 6;
                                    return _this2.fetchBranchList({ studioId: newValue.id });

                                case 6:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this2);
                }))();
            }
        },
        branchIds: {
            get: function get() {
                return this.filterOptions.branchIds;
            },
            set: function set(newValue) {
                var _this3 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                    return _regenerator2.default.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    _context2.next = 2;
                                    return _this3.changeFilterOption({ 'prop': 'branchIds', value: newValue });

                                case 2:
                                case 'end':
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, _this3);
                }))();
            }
        },
        ajaxing: {
            get: function get() {
                return this.$store.state.webadmin.baseReport.ajaxing;
            },
            set: function set(newValue) {
                var _this4 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
                    return _regenerator2.default.wrap(function _callee3$(_context3) {
                        while (1) {
                            switch (_context3.prev = _context3.next) {
                                case 0:
                                    _context3.next = 2;
                                    return _this4.changeAjaxing(newValue);

                                case 2:
                                case 'end':
                                    return _context3.stop();
                            }
                        }
                    }, _callee3, _this4);
                }))();
            }
        },
        memberIds: function memberIds() {
            var memberIds = '';
            for (var i = 0; i < this.memberContractList.length; i++) {
                if (i === this.memberContractList.length - 1) {
                    memberIds += this.memberContractList[i].member_id;
                } else {
                    memberIds += this.memberContractList[i].member_id + ',';
                }
            }

            return memberIds;
        }
    }),
    methods: (0, _extends3.default)({
        updateFilterOption: function updateFilterOption(field) {
            var _this5 = this;

            return function (value) {
                return _this5.changeFilterOption({
                    prop: field,
                    value: value
                });
            };
        }
    }, (0, _vuex.mapActions)('webadmin/configure', ['configuredRun', 'fetchStudioList', 'fetchBranchList', 'fetchContractList']), (0, _vuex.mapActions)('webadmin/baseReport', ['beforeSubmit', 'toggleBlock', 'changeDateOption', 'changeFilterOption', 'cleanBranch', 'cleanBranchRelated', 'changeItemOption', 'setDetailTarget', "changeAjaxing"]), {
        submit: function submit() {
            this.beforeSubmit();
            if (this.enableEndTime && this.endTimeStart == '' && this.endTimeEnd == '') {
                $17.swal({
                    title: '請填入到期日上限或下限',
                    type: 'warning'
                });
                return;
            }

            if (this.enableRemainValue && this.remainValueMin == '' && this.remainValueMax == '') {
                $17.swal({
                    title: '請填入剩餘價值上限或下限',
                    type: 'warning'
                });
                return;
            }

            this.getQUeryResault();
        },
        getQUeryResault: function getQUeryResault() {
            var _this6 = this;

            var queryString = this.getQueryString();
            this.ajaxing = true;
            this.$http.get('/adminapi/report/fetch_member_remain_value?' + queryString).then(function (response) {
                _this6.memberContractList = response.body;
                _this6.ajaxing = false;
                _this6.$refs.report.setCustomers(_this6.memberIds);
            }, function (error) {
                _this6.ajaxing = false;
                $17.swal({
                    title: error.body.message,
                    type: 'warning'
                });
            });
        },
        getQueryString: function getQueryString() {

            var branchPara = '';
            var contractTypePara = '';
            var studioPara = '&studio_id=' + this.studioId.id;
            var endTImePara = '&enable_end_time=' + this.enableEndTime + '&end_time_start=' + this.endTimeStart + '&end_time_end=' + this.endTimeEnd;
            var remainPara = '&enable_remain_value=' + this.enableRemainValue + '&remain_value_min=' + this.remainValueMin + '&remain_value_max=' + this.remainValueMax;

            if (this.branchIds.length > 0) {
                branchPara = this.branchIds.reduce(function (carry, branch) {
                    carry += '&branch_ids[]=' + branch.id;

                    return carry;
                }, '');
            }
            if (this.contractType.length > 0) {
                contractTypePara = this.contractType.reduce(function (carry, type) {

                    carry += '&contract_types[]=' + type.value;

                    return carry;
                }, '');
            }

            var queryString = 'date_range[start_date]=' + this.dateOptions.startDate + '&date_range[end_date]=' + this.dateOptions.endDate + branchPara + studioPara + endTImePara + remainPara + contractTypePara;
            return queryString;
        },
        csvDataHandler: function csvDataHandler(watchData) {
            var data = [];
            _lodash2.default.assign(data, watchData);
            data = this.columnFormatter(data);
            return Papa.unparse(data, {
                delimiter: ','
            });
        },
        columnFormatter: function columnFormatter(data) {
            String.prototype.replaceAll = function (search, replacement) {
                var target = this;
                return target.replace(new RegExp(search, 'g'), replacement);
            };
            return this.columnCustomFormatter(data);
        },
        columnCustomFormatter: function columnCustomFormatter(data) {
            var results = _lodash2.default.map(data, function (value) {
                return _lodash2.default.pick(value, ['buy_date', 'branch_name', 'member_name', 'phone', 'contract_name', 'type', 'remain', 'end_time']);
            });
            results = (0, _stringify2.default)(results);
            results = results.replaceAll('buy_date', '購買日');
            results = results.replaceAll('branch_name', '購買場館');
            results = results.replaceAll('member_name', '姓名');
            results = results.replaceAll('phone', '手機');
            results = results.replaceAll('contract_name', '方案');
            results = results.replaceAll('type', '類型');
            results = results.replaceAll('remain', '剩餘');
            results = results.replaceAll('end_time', '到期日');

            return results;
        },
        download: function download(_csvString) {
            var downloadLink = document.createElement("a");
            downloadLink.download = "客戶方案剩餘分析.csv";
            downloadLink.innerHTML = "Download File";
            if (window.webkitURL != null) {
                var code = encodeURIComponent(_csvString);
                downloadLink.href = "data:application/csv;charset=utf-8,%EF%BB%BF" + code;
            }
            downloadLink.click();
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"page-div\" _v-5f4adb38=\"\">\n    <v-webadmin-report :block-open-status=\"blockOpenStatus\" :date-options=\"dateOptions\" :toggle-block=\"toggleBlock\" :change-date-option=\"changeDateOption\" :disable-submit=\"ajaxing\" :submit=\"submit\" limit-date=\"365\" :is-open-temporary-customer-button=\"true\" :studio-id=\"studioId\" ref=\"report\" title=\"客戶方案剩餘分析\" _v-5f4adb38=\"\">\n        <div slot=\"second-block\" _v-5f4adb38=\"\">\n            <div class=\"row\" _v-5f4adb38=\"\">\n                <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen\" _v-5f4adb38=\"\">\n                    <div class=\"form-group\" _v-5f4adb38=\"\">\n                        <v-mutiselect :model.sync=\"studioId\" :options=\"studioList\" :preserve-search=\"true\" :placeholder=\"configureStates.ajaxing.studioList ? '品牌讀取中…' : '請選擇品牌'\" label=\"brand_name\" track-by=\"id\" _v-5f4adb38=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n                <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen || configureStates.isStudio\" _v-5f4adb38=\"\">\n                    <div class=\"form-group\" _v-5f4adb38=\"\">\n                        <v-mutiselect :model.sync=\"branchIds\" :options=\"branchList\" :disabled=\"configureStates.ajaxing.branchList\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"false\" :placeholder=\"configureStates.ajaxing.branchList ? '場館讀取中…' : '全部場館'\" label=\"branch_name\" track-by=\"id\" :taggable=\"true\" tag-name=\"branch_name\" _v-5f4adb38=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n                <div class=\"col-sm-6\" _v-5f4adb38=\"\">\n                    <div class=\"form-group\" _v-5f4adb38=\"\">\n                        <v-mutiselect :model.sync=\"contractType\" :options=\"contractListType\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"false\" :searchable=\"false\" label=\"name\" track-by=\"value\" tag-name=\"name\" :placeholder=\"'全部方案類型'\" _v-5f4adb38=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n                <div class=\"col-sm-12\" _v-5f4adb38=\"\">\n                    <div class=\"form-group\" _v-5f4adb38=\"\">\n                        <label _v-5f4adb38=\"\">\n                            <input type=\"checkbox\" :true-value=\"1\" :false-value=\"0\" v-model=\"enableRemainValue\" _v-5f4adb38=\"\"> 剩餘價值介於\n                        </label>\n                        <span _v-5f4adb38=\"\">\n                            <input type=\"number\" v-model=\"remainValueMin\" placeholder=\"ex:0\" _v-5f4adb38=\"\">\n                            <label _v-5f4adb38=\"\">\n                                ~\n                            </label>\n                            <input type=\"number\" v-model=\"remainValueMax\" placeholder=\"ex:10\" _v-5f4adb38=\"\">\n                        </span>\n                    </div>\n                </div>\n                <div class=\"col-sm-12\" _v-5f4adb38=\"\">\n                    <div class=\"form-group\" _v-5f4adb38=\"\">\n                        <label _v-5f4adb38=\"\">\n                            <input type=\"checkbox\" :true-value=\"1\" :false-value=\"0\" v-model=\"enableEndTime\" _v-5f4adb38=\"\"> 到期日距離今天介於\n                        </label>\n                        <span _v-5f4adb38=\"\">\n                            <input type=\"number\" v-model=\"endTimeStart\" placeholder=\"ex:-10\" _v-5f4adb38=\"\">\n                            <label _v-5f4adb38=\"\">\n                                ~\n                            </label>\n                            <input type=\"number\" v-model=\"endTimeEnd\" placeholder=\"ex:10\" _v-5f4adb38=\"\">\n                        </span>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div slot=\"fourth-block\" _v-5f4adb38=\"\">\n            <div class=\"row\" _v-5f4adb38=\"\">\n                <div class=\"col-sm-6\" _v-5f4adb38=\"\">\n                    <div class=\"form-group\" _v-5f4adb38=\"\">\n                        <label _v-5f4adb38=\"\">\n                            <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"show\" checked=\"\" _v-5f4adb38=\"\"> 顯示於網頁\n                        </label>\n                        <label _v-5f4adb38=\"\">\n                            <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"export\" _v-5f4adb38=\"\"> 匯出 CSV\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </v-webadmin-report>\n    <div v-show=\"display==='show'\" _v-5f4adb38=\"\">\n        <div class=\"table-div\" _v-5f4adb38=\"\">\n            <v-table :ajaxing=\"ajaxing\" :length=\"memberContractList.length\" _v-5f4adb38=\"\">\n                <table class=\"table table-striped\" _v-5f4adb38=\"\">\n                    <thead _v-5f4adb38=\"\">\n                        <tr _v-5f4adb38=\"\">\n                            <td _v-5f4adb38=\"\">購買日</td>\n                            <td _v-5f4adb38=\"\">購買場館</td>\n                            <td _v-5f4adb38=\"\">姓名</td>\n                            <td _v-5f4adb38=\"\">手機</td>\n                            <td _v-5f4adb38=\"\">方案</td>\n                            <td _v-5f4adb38=\"\">類型</td>\n                            <td _v-5f4adb38=\"\">剩餘</td>\n                            <td _v-5f4adb38=\"\">到期日</td>\n                        </tr>\n                    </thead>\n                    <tbody _v-5f4adb38=\"\">\n                        <tr v-for=\"item in memberContractList\" _v-5f4adb38=\"\">\n                            <td _v-5f4adb38=\"\">{{ item.buy_date }}</td>\n                            <td _v-5f4adb38=\"\">{{ item.branch_name }}</td>\n                            <td _v-5f4adb38=\"\">{{ item.member_name }}</td>\n                            <td _v-5f4adb38=\"\">{{ item.phone }}</td>\n                            <td _v-5f4adb38=\"\">{{ item.contract_name }}</td>\n                            <td _v-5f4adb38=\"\">{{ item.type }}</td>\n                            <td _v-5f4adb38=\"\">{{ item.remain }}</td>\n                            <td _v-5f4adb38=\"\">{{ item.end_time }}</td>\n                        </tr>\n                    </tbody>\n                </table>\n            </v-table>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.page-div[_v-5f4adb38] {\n  padding: 0px 15px;\n  margin-bottom: 15px; }\n\n/* line 8, stdin */\n.table-div[_v-5f4adb38] {\n  padding: 20px 0px; }\n\n/* line 11, stdin */\ninput[type=number][_v-5f4adb38] {\n  width: 6em; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-5f4adb38", module.exports)
  } else {
    hotAPI.update("_v-5f4adb38", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/json/stringify":48,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/defineProperty":65,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1363:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n/* line 3, stdin */\n.page-div[_v-7a2ebcce] {\n  padding: 0px 15px;\n  margin-bottom: 15px; }\n\n/* line 8, stdin */\n.m-l-15[_v-7a2ebcce] {\n  margin-left: 15px; }\n\n/* line 12, stdin */\n.table-div[_v-7a2ebcce] {\n  padding: 20px 0px; }\n\n/* line 16, stdin */\n.form-title[_v-7a2ebcce] {\n  font-size: 16px;\n  font-weight: bold;\n  display: inline-block;\n  width: 60px; }\n\n/* line 23, stdin */\n.refund-order[_v-7a2ebcce] {\n  color: red; }\n\n/* line 27, stdin */\n.negative-number[_v-7a2ebcce] {\n  color: red; }\n\n/* line 31, stdin */\n.origin-refunded[_v-7a2ebcce] {\n  color: #c7c4c3; }\n\n/* line 38, stdin */\n.price[_v-7a2ebcce] {\n  text-align: center; }\n\n/* line 42, stdin */\n.cube[_v-7a2ebcce] {\n  max-width: 80px;\n  float: left;\n  margin: 12px 24px;\n  font-weight: blod;\n  font-size: 18px; }\n\n/* line 50, stdin */\n.total-list[_v-7a2ebcce] {\n  margin: 15px 0px 0px 0px; }\n\n/* line 54, stdin */\n.total-list[_v-7a2ebcce]:after {\n  clear: both; }\n\n/* line 58, stdin */\n.table-striped thead[_v-7a2ebcce] {\n  border-bottom: 1px solid #000; }\n\n/* line 62, stdin */\n.multiselect[_v-7a2ebcce] {\n  padding-bottom: 5px; }\n")
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _watch;

var _vuex = require("vuex");

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      // display: "show",
      tableConfig: {
        columns: [{ keys: "id", head: "轉贈序號" }, { keys: "created_at", head: "建立時間" }, { keys: "status", head: "最新狀態" }, { keys: "receive_way", head: "兌換方式" }, { keys: "receive_time", head: "兌換時間" }, { keys: "contract_name", head: "方案名稱" }, { keys: "receive_order_id", head: "轉贈訂單編號" }, { keys: "receive_member_name", head: "受贈者" }, { keys: "transaction_value", head: "受贈價值點/次" }, { keys: "member_name", head: "方案持有人" }, { keys: "order_id", head: "訂單編號" }, { keys: "origin_value", head: "原方案點次" }, { keys: "transferred_value", head: "轉贈後方案剩餘點/次" }]
      },
      relatedFilterWatcher: {
        studio_id: {
          watcher: null,
          options: "studioList",
          vModel: "studioId",
          trackBy: "id",
          type: "single"
        },
        branch_ids: {
          watcher: null,
          options: "branchList",
          vModel: "branchIds",
          trackBy: "id",
          type: "single"
        }
      },
      multiFilter: {
        status: {
          watcher: null,
          options: "statuses",
          vModel: "status",
          trackBy: "value",
          type: "single"
        }
      },
      result: {},
      localFilter: {
        status: null
      },
      statuses: [{
        name: "等待中",
        value: "0"
      }, {
        name: "已兌換",
        value: "1"
      }, {
        name: "已取消",
        value: "2"
      }]
    };
  },
  created: function created() {
    this.syncRelatedMultipleSelectByQuery({ vm: this, relatedFilterWatcher: this.relatedFilterWatcher });
    this.syncLocalMultipleSelectByQuery({ vm: this, multiFilter: this.multiFilter });
  },
  mounted: function mounted() {
    var _this = this;

    this.configuredRun(function () {
      _this.changeFilterOption({
        prop: "studioId",
        value: {
          id: _this.configureStates.studioId,
          brand_name: ""
        }
      });
      _this.changeFilterOption({
        prop: "branchId",
        value: _this.configureStates.branchId
      });
      if (_this.configureStates.isSeventeen) {
        return _this.fetchStudioList();
      }
      if (_this.configureStates.isBranch) {
        _this.branchIds = [{
          id: _this.configureStates.branchId,
          branch_name: ""
        }];
      }
    });
    this.syncDateAndDisplayByQuery();
  },

  watch: (_watch = {}, (0, _defineProperty3.default)(_watch, "filterOptions.studioId", function filterOptionsStudioId(n, o) {
    if (this.configureStates.isSeventeen || this.configureStates.isStudio) {
      this.fetchBranchList({
        studioId: n.id
      });
    }
  }), (0, _defineProperty3.default)(_watch, "export", function _export(newV) {
    if (newV) {
      this.csvConfig.jsonData = this.mapStatus(newV);
      this.$refs.smart_table.downloadCsv();
    }
  }), (0, _defineProperty3.default)(_watch, "display", function display(newV, oldV) {
    if (newV) {
      var obj = {
        display: newV
      };
      var newQuery = $17.updateUrlQueryString(obj);
    }
  }), (0, _defineProperty3.default)(_watch, "status", function status(newV, oldV) {
    if (newV != null && newV.value) {
      var obj = {
        status: newV.value
      };
      var newQuery = $17.updateUrlQueryString(obj);
    } else {
      var _obj = {
        status: ''
      };
      $17.updateUrlQueryString(_obj);
    }
  }), (0, _defineProperty3.default)(_watch, "branchIds", function branchIds(newV) {
    if (newV != null && newV.id) {
      $17.updateUrlQueryString({
        branch_ids: newV.id
      });
    }
  }), _watch),
  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
    configureStates: function configureStates(state) {
      return state.webadmin.configure;
    }
  }), (0, _vuex.mapState)("webadmin/configure", ["configured", "studioList", "branchList", "serviceProviderList", "serviceList", "branchId"]), (0, _vuex.mapState)("webadmin/baseReport", ["blockOpenStatus", "dateOptions", "filterOptions", "itemOptions", "ajaxing", "export", "list", "total", "pageMeta", "display"]), {
    studioId: {
      get: function get() {
        return this.filterOptions.studioId;
      },
      set: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(newValue) {
          return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return this.$store.dispatch("webadmin/baseReport/changeFilterOption", {
                    prop: "studioId",
                    value: newValue
                  });

                case 2:
                  newValue.id ? $17.updateUrlQueryString({ studio_id: newValue.id }) : null;
                  this.cleanBranch();

                  if (!newValue) {
                    _context.next = 7;
                    break;
                  }

                  _context.next = 7;
                  return this.fetchBranchList({ studioId: newValue.id });

                case 7:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function set(_x) {
          return _ref.apply(this, arguments);
        }

        return set;
      }()
    },
    branchIds: {
      get: function get() {
        return this.filterOptions.branchIds;
      },
      set: function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(newValue) {
          return _regenerator2.default.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return this.$store.dispatch("webadmin/baseReport/changeFilterOption", {
                    prop: "branchIds",
                    value: newValue
                  });

                case 2:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        function set(_x2) {
          return _ref2.apply(this, arguments);
        }

        return set;
      }()
    },
    status: {
      get: function get() {
        return this.localFilter.status;
      },
      set: function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(newValue) {
          return _regenerator2.default.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  this.localFilter.status = newValue;

                case 1:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, this);
        }));

        function set(_x3) {
          return _ref3.apply(this, arguments);
        }

        return set;
      }()
    }
  }),
  methods: (0, _extends3.default)({
    submitSearch: function submitSearch() {
      switch (this.display) {
        // case "export":
        //   this.changeFilterOption({ prop: "page", value: 1 });
        //   this.changeFilterOption({ prop: "pageSize", value: 9999 });
        //   break;
        case "show":
          // this.changeFilterOption({ prop: "page", value: 1 });
          this.changeFilterOption({ prop: "pageSize", value: 25 });
          break;
        default:
          null;
      }
      this.changePage(1);
    }
  }, (0, _vuex.mapActions)("webadmin/configure", ["configuredRun", "fetchStudioList", "fetchBranchList"]), (0, _vuex.mapActions)("webadmin/baseReport", ["submit", "toggleBlock", "changeDateOption", "changeFilterOption", "changeItemOption", "cleanBranch", "changeAjaxing", "changeDateOptionAfter", "syncDateAndDisplayByQuery", "syncLocalMultipleSelectByQuery", "syncRelatedMultipleSelectByQuery"]), {
    mapStatus: function mapStatus(data) {
      var newData = _lodash2.default.cloneDeep(data);
      return newData;
    },
    getQueryResult: function getQueryResult(options) {
      var _this2 = this;

      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
        var params;
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(options.branchIds == null)) {
                  _context4.next = 3;
                  break;
                }

                $17.swal({
                  title: '請選擇場館',
                  type: "warning"
                });
                return _context4.abrupt("return");

              case 3:
                params = {
                  studio_id: options.studioId.id,
                  branch_id: options.branchIds.id,
                  start_date: options.startDate,
                  end_date: options.endDate,
                  page: options.page,
                  page_size: options.pageSize,
                  status: options.status != null && options.status.value ? options.status.value : null
                };
                _context4.next = 6;
                return _this2.$http.get("/adminapi/report/member-contract-exchange-report", {
                  params: params
                }).then(function (response) {
                  _this2.result = response.data;
                }, function (error) {
                  $17.swal({
                    title: error.body.message,
                    type: "warning"
                  });
                });

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this2);
      }))();
    },
    changePage: function changePage(page) {
      var _this3 = this;

      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5() {
        var params;
        return _regenerator2.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this3.changeAjaxing(true);
                _this3.changeFilterOption({
                  prop: "page",
                  value: page
                });
                params = (0, _extends3.default)({}, _this3.dateOptions, _this3.filterOptions, _this3.itemOptions, _this3.localFilter);

                $17.updateUrlQueryString(params);
                _context5.next = 6;
                return _this3.getQueryResult(params);

              case 6:
                _this3.changeAjaxing(false);

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this3);
      }))();
    }
  })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"page-div\" _v-7a2ebcce=\"\">\n  <v-webadmin-report :block-open-status=\"blockOpenStatus\" :date-options=\"dateOptions\" :toggle-block=\"toggleBlock\" :change-date-option=\"changeDateOptionAfter\" :disable-submit=\"ajaxing\" :submit=\"submitSearch\" limit-date=\"90\" title=\"轉贈紀錄\" _v-7a2ebcce=\"\">\n    <div slot=\"second-block\" _v-7a2ebcce=\"\">\n      <div class=\"filters\" _v-7a2ebcce=\"\">\n        <div class=\"row\" _v-7a2ebcce=\"\">\n          <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen\" _v-7a2ebcce=\"\">\n            <div class=\"form-group\" _v-7a2ebcce=\"\">\n              <v-mutiselect :model.sync=\"studioId\" :options=\"studioList\" :preserve-search=\"true\" :placeholder=\"\n                  configureStates.ajaxing.studioList\n                    ? '品牌讀取中…'\n                    : '請選擇品牌'\n                \" label=\"brand_name\" track-by=\"id\" _v-7a2ebcce=\"\">\n              </v-mutiselect>\n            </div>\n          </div>\n          <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen || configureStates.isStudio\" _v-7a2ebcce=\"\">\n            <div class=\"form-group\" _v-7a2ebcce=\"\">\n              <v-mutiselect :model.sync=\"branchIds\" :options=\"branchList\" :multiple=\"false\" :close-on-select=\"true\" :clear-on-select=\"false\" :hide-selected=\"false\" :preserve-search=\"true\" :searchable=\"false\" :placeholder=\"\n                  configureStates.ajaxing.branchList\n                    ? '場館讀取中…'\n                    : '請選擇場館'\n                \" label=\"branch_name\" track-by=\"id\" tag-name=\"branch_name\" :max-height=\"500\" _v-7a2ebcce=\"\">\n              </v-mutiselect>\n            </div>\n          </div>\n          <div class=\"col-sm-6\" _v-7a2ebcce=\"\">\n            <div class=\"form-group\" _v-7a2ebcce=\"\">\n              <v-mutiselect :model.sync=\"localFilter.status\" :options=\"statuses\" :multiple=\"false\" :close-on-select=\"true\" :clear-on-select=\"false\" :hide-selected=\"false\" :preserve-search=\"true\" :searchable=\"false\" placeholder=\"所有狀態\" label=\"name\" track-by=\"value\" :max-height=\"500\" _v-7a2ebcce=\"\">\n              </v-mutiselect>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div slot=\"fourth-block\" _v-7a2ebcce=\"\">\n      <div class=\"row m-left-0\" _v-7a2ebcce=\"\"></div>\n    </div>\n  </v-webadmin-report>\n  <div v-show=\"display === 'show'\" _v-7a2ebcce=\"\">\n    <div class=\"table-div\" _v-7a2ebcce=\"\">\n      <v-smart-table ref=\"smart_table\" :table-config=\"tableConfig\" :is-ajaxing=\"ajaxing\" :data=\"result\" :page-sync-url-query=\"false\" @change-page=\"changePage\" _v-7a2ebcce=\"\"></v-smart-table>\n    </div>\n  </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n/* line 3, stdin */\n.page-div[_v-7a2ebcce] {\n  padding: 0px 15px;\n  margin-bottom: 15px; }\n\n/* line 8, stdin */\n.m-l-15[_v-7a2ebcce] {\n  margin-left: 15px; }\n\n/* line 12, stdin */\n.table-div[_v-7a2ebcce] {\n  padding: 20px 0px; }\n\n/* line 16, stdin */\n.form-title[_v-7a2ebcce] {\n  font-size: 16px;\n  font-weight: bold;\n  display: inline-block;\n  width: 60px; }\n\n/* line 23, stdin */\n.refund-order[_v-7a2ebcce] {\n  color: red; }\n\n/* line 27, stdin */\n.negative-number[_v-7a2ebcce] {\n  color: red; }\n\n/* line 31, stdin */\n.origin-refunded[_v-7a2ebcce] {\n  color: #c7c4c3; }\n\n/* line 38, stdin */\n.price[_v-7a2ebcce] {\n  text-align: center; }\n\n/* line 42, stdin */\n.cube[_v-7a2ebcce] {\n  max-width: 80px;\n  float: left;\n  margin: 12px 24px;\n  font-weight: blod;\n  font-size: 18px; }\n\n/* line 50, stdin */\n.total-list[_v-7a2ebcce] {\n  margin: 15px 0px 0px 0px; }\n\n/* line 54, stdin */\n.total-list[_v-7a2ebcce]:after {\n  clear: both; }\n\n/* line 58, stdin */\n.table-striped thead[_v-7a2ebcce] {\n  border-bottom: 1px solid #000; }\n\n/* line 62, stdin */\n.multiselect[_v-7a2ebcce] {\n  padding-bottom: 5px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-7a2ebcce", module.exports)
  } else {
    hotAPI.update("_v-7a2ebcce", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/defineProperty":65,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1364:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.page-div[_v-60a66a1c] {\n  padding: 0px 15px;\n  margin-bottom: 15px; }\n\n/* line 6, stdin */\n.table-div[_v-60a66a1c] {\n  padding: 20px 0px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _watch;

var _vuex = require('vuex');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            paymentSourceRecordTypes: [],
            paymentSourceRecordType: null,
            ajaxingPaymentSourceRecordType: false,
            detailList: {},
            export: [],
            colConfig: {
                columns: [{ keys: "should_pay_total", head: "項目總額" }, { keys: "expense_total", head: "費用總額" }]
            },
            summaryList: {},
            tableConfig: {
                columns: [{ keys: "created_at", head: "購買日期時間" }, { keys: "order_id", head: "訂單編號" }, { keys: "studio_name", head: "品牌名稱" }, { keys: "branch_name", head: "場館名稱" }, { keys: "member_name", head: "客戶" }, { keys: "product_name", head: "項目" }, { keys: "sub_total", head: "項目金額" }, { keys: "expense", head: "費用" }]
            },
            csvConfig: {
                column: [{ keys: "created_at", name: "購買日期時間" }, { keys: "order_id", name: "訂單編號" }, { keys: "studio_name", name: "品牌名稱" }, { keys: "branch_name", name: "場館名稱" }, { keys: "member_name", name: "客戶" }, { keys: "product_name", name: "項目" }, { keys: "sub_total", name: "項目金額" }, { keys: "expense", name: "費用" }],
                fileName: "member_discovery_fee_records"
            },
            relatedFilterWatcher: {
                studio_id: {
                    watcher: null,
                    options: "studioList",
                    vModel: "studioId",
                    trackBy: "id",
                    type: "single"
                },
                branch_ids: {
                    watcher: null,
                    options: 'branchList',
                    vModel: 'branchIds',
                    trackBy: 'id',
                    type: "multiple"
                }
            },
            dateOptions: {
                startDate: moment().startOf('month').format('YYYY/MM/DD'),
                endDate: moment().endOf('month').format('YYYY/MM/DD'),
                disabled: true
            }
        };
    },
    created: function created() {
        this.syncRelatedMultipleSelectByQuery({ vm: this, relatedFilterWatcher: this.relatedFilterWatcher });
    },
    mounted: function mounted() {
        var _this = this;

        this.configuredRun(function () {

            _this.changeFilterOption({
                prop: 'studioId',
                value: {
                    id: _this.configureStates.studioId,
                    brand_name: ''
                }
            });
            _this.changeFilterOption({
                prop: 'branchId',
                value: _this.configureStates.branchId
            });

            if (_this.configureStates.isSeventeen) {
                return _this.fetchStudioList();
            }

            if (_this.configureStates.isBranch) {
                _this.branchIds = [{
                    'id': _this.configureStates.branchId,
                    'branch_name': ''
                }];
            }
        });

        this.changeItemOption({
            prop: 'viewMode',
            value: 'detail'
        });
    },

    watch: (_watch = {
        'configureStates.isBranch': function configureStatesIsBranch(newVal, oldVal) {
            if (newVal) {
                document.getElementsByClassName("control-box")[1].style.display = "none";
            }
        }
    }, (0, _defineProperty3.default)(_watch, 'filterOptions.studioId', function filterOptionsStudioId(n, o) {
        if (this.configureStates.isSeventeen && !_lodash2.default.isEmpty(n)) {
            this.fetchBranchList({
                studioId: n.id
            });
        }
        if (this.configureStates.isStudio) {
            this.fetchBranchList({
                studioId: n.id
            });
        }
    }), (0, _defineProperty3.default)(_watch, 'export', function _export(newV) {
        if (newV && newV.length > 0) {
            this.csvConfig.jsonData = _lodash2.default.cloneDeep(newV);
            this.$refs.smart_table.downloadCsv();
        }
    }), _watch),
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        configureStates: function configureStates(state) {
            return state.webadmin.configure;
        }
    }), (0, _vuex.mapState)('webadmin/configure', ['configured', 'studioList', 'branchList', 'branchId', 'isSeventeen']), (0, _vuex.mapState)('webadmin/baseReport', ['blockOpenStatus', 'filterOptions', 'ajaxing', 'itemOptions']), {
        studioId: {
            get: function get() {
                return this.filterOptions.studioId;
            },
            set: function set(newValue) {
                var _this2 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                    return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.next = 2;
                                    return _this2.changeFilterOption({ 'prop': 'studioId', value: newValue });

                                case 2:
                                    _this2.cleanBranch();

                                    if (!newValue) {
                                        _context.next = 6;
                                        break;
                                    }

                                    _context.next = 6;
                                    return _this2.fetchBranchList({ studioId: newValue.id });

                                case 6:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this2);
                }))();
            }
        },
        branchIds: {
            get: function get() {
                return this.filterOptions.branchIds;
            },
            set: function set(newValue) {
                var _this3 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                    return _regenerator2.default.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    _this3.changeFilterOption({ 'prop': 'branchIds', value: newValue });

                                case 1:
                                case 'end':
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, _this3);
                }))();
            }
        },
        viewMode: {
            get: function get() {
                return this.itemOptions.viewMode;
            },
            set: function set(value) {
                this.changeItemOption({
                    prop: 'viewMode',
                    value: value
                });
            }
        },
        display: {
            get: function get() {
                return this.$store.state.webadmin.baseReport.display;
            },
            set: function () {
                var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(newValue) {
                    return _regenerator2.default.wrap(function _callee3$(_context3) {
                        while (1) {
                            switch (_context3.prev = _context3.next) {
                                case 0:
                                    _context3.next = 2;
                                    return this.changeDisplay(newValue);

                                case 2:
                                case 'end':
                                    return _context3.stop();
                            }
                        }
                    }, _callee3, this);
                }));

                function set(_x) {
                    return _ref.apply(this, arguments);
                }

                return set;
            }()
        }
    }),
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('webadmin/configure', ['configuredRun', 'fetchStudioList', 'fetchBranchList']), (0, _vuex.mapActions)('webadmin/baseReport', ['beforeSubmit', 'toggleBlock', 'changeDateOption', 'changeFilterOption', 'cleanBranch', 'changeItemOption', 'changeAjaxing', "syncDateAndDisplayByQuery", "syncRelatedMultipleSelectByQuery", "changeDisplay"]), {
        submit: function submit() {
            // this.beforeSubmit();
            var data = this.getPara();
            $17.updateUrlQueryString(data, true);
            this.getSummary(data);
            this.getResult(data);
        },
        getPara: function getPara() {
            var data = {};

            if (this.branchIds.length > 0) {
                data.branch_ids = this.branchIds.map(function (item) {
                    return item.id;
                });
            }

            return data;
        },
        getSummary: function getSummary(data) {
            var _this4 = this;

            this.$http.get('/adminapi/report/fetch-member-discovery-summary-for-studio', { params: data }).then(function (response) {
                _this4.summaryList = response.data.records;
            }, function (error) {
                $17.swal({
                    title: error.body.message,
                    type: 'warning'
                });
            });
        },
        getResult: function getResult(params) {
            var _this5 = this;

            var data = params;

            switch (this.display) {
                case "export":
                    data.page_size = 9999999;
                    break;
                case "show":
                    data.page_size = 25;
                    break;
                default:
                    null;
            }

            this.changeAjaxing(true);
            this.$http.get('/adminapi/report/fetch-member-discovery-detail-for-studio', { params: data }).then(function (response) {
                if (_this5.display == 'export') {
                    _this5.export = response.data.records;
                }

                if (_this5.display == 'show') {
                    _this5.detailList = response.data;
                }
                _this5.changeAjaxing(false);
            }, function (error) {
                _this5.changeAjaxing(false);
                $17.swal({
                    title: error.body.message,
                    type: 'warning'
                });
            });
        },
        changePage: function changePage(page) {
            var _this6 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
                var params;
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _this6.changeFilterOption({
                                    prop: "page",
                                    value: page
                                });

                                params = _this6.getPara();


                                params.page_size = _this6.filterOptions.pageSize;
                                params.page = _this6.filterOptions.page;

                                _context4.next = 6;
                                return _this6.getResult(params);

                            case 6:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this6);
            }))();
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"page-div\" _v-60a66a1c=\"\">\n<v-webadmin-report :block-open-status=\"blockOpenStatus\" :date-options=\"dateOptions\" :toggle-block=\"toggleBlock\" :change-date-option=\"changeDateOption\" ref=\"report\" :submit=\"submit\" limit-date=\"730\" title=\"行銷服務費試算 - 新客戶\" _v-60a66a1c=\"\">\n        <div slot=\"second-block\" _v-60a66a1c=\"\">\n            <div class=\"row\" _v-60a66a1c=\"\">\n                <div class=\"col-sm-6\" v-show=\"isSeventeen\" _v-60a66a1c=\"\">\n                    <div class=\"form-group\" _v-60a66a1c=\"\">\n                        <v-mutiselect :model.sync=\"studioId\" :options=\"studioList\" :preserve-search=\"true\" :close-on-select=\"true\" :placeholder=\"configureStates.ajaxing.studioList ? '品牌讀取中…' : '請選擇品牌'\" label=\"brand_name\" track-by=\"id\" _v-60a66a1c=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n                <div class=\"col-sm-6\" _v-60a66a1c=\"\">\n                    <div class=\"form-group\" _v-60a66a1c=\"\">\n                        <v-mutiselect :model.sync=\"branchIds\" :options=\"branchList\" :disabled=\"configureStates.ajaxing.branchList\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"false\" :placeholder=\"configureStates.ajaxing.branchList ? '場館讀取中…' : '全部場館'\" label=\"branch_name\" track-by=\"id\" :taggable=\"true\" tag-name=\"branch_name\" _v-60a66a1c=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div slot=\"third-block\" _v-60a66a1c=\"\">\n            <div class=\"row\" _v-60a66a1c=\"\">\n                <div class=\"col-sm-6\" _v-60a66a1c=\"\">\n                    <div class=\"form-group\" _v-60a66a1c=\"\">\n                        <label _v-60a66a1c=\"\">\n                            <input name=\"view\" type=\"radio\" value=\"detail\" v-model=\"viewMode\" checked=\"\" _v-60a66a1c=\"\"> 顯示細節\n                        </label>\n                        <!-- <label> V1只顯示細節\n                            <input name=\"view\" type=\"radio\" value=\"summary\" v-model=\"viewMode\"> 顯示總和\n                        </label> -->\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div slot=\"fourth-block\" _v-60a66a1c=\"\">\n            <div class=\"row\" _v-60a66a1c=\"\">\n                <div class=\"col-sm-6\" _v-60a66a1c=\"\">\n                    <div class=\"form-group\" _v-60a66a1c=\"\">\n                        <label _v-60a66a1c=\"\">\n                            <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"show\" checked=\"\" _v-60a66a1c=\"\"> 顯示於網頁\n                        </label>\n                        <label _v-60a66a1c=\"\">\n                            <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"export\" _v-60a66a1c=\"\"> 匯出CSV\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </v-webadmin-report>\n    <div v-show=\"display === 'show'\" _v-60a66a1c=\"\">\n        <div class=\"m-top-30\" _v-60a66a1c=\"\">\n            <v-smart-table-summary :col-config=\"colConfig\" :data=\"summaryList\" _v-60a66a1c=\"\"></v-smart-table-summary>\n        </div>\n        <div class=\"m-top-10\" _v-60a66a1c=\"\">\n            <v-smart-table ref=\"smart_table\" :table-config=\"tableConfig\" :csv-config=\"csvConfig\" :is-ajaxing=\"ajaxing\" :data=\"detailList\" :page-sync-url-query=\"false\" @change-page=\"changePage\" _v-60a66a1c=\"\"></v-smart-table>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.page-div[_v-60a66a1c] {\n  padding: 0px 15px;\n  margin-bottom: 15px; }\n\n/* line 6, stdin */\n.table-div[_v-60a66a1c] {\n  padding: 20px 0px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-60a66a1c", module.exports)
  } else {
    hotAPI.update("_v-60a66a1c", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/defineProperty":65,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1365:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.page-div[_v-d7248c22] {\n  padding: 0px 15px;\n  margin-bottom: 15px; }\n\n/* line 6, stdin */\n.table-div[_v-d7248c22] {\n  padding: 20px 0px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            paymentSourceRecordCategories: [],
            paymentSourceRecordCategory: null,
            ajaxingPaymentSourceRecordCategory: false,
            detailList: {},
            export: [],
            colConfig: {
                columns: [{ keys: "should_pay_total", head: "項目總額" }, { keys: "expense_total", head: "費用總額" }]
            },
            summaryList: {},
            tableConfig: {
                columns: [{ keys: "created_at", head: "購買日期時間" }, { keys: "order_id", head: "訂單編號" }, { keys: "studio_name", head: "品牌名稱" }, { keys: "branch_name", head: "場館名稱" }, { keys: "member_name", head: "客戶" }, { keys: "product_name", head: "項目" }, { keys: "sub_total", head: "項目金額" }, { keys: "expense", head: "費用" }]
            },
            csvConfig: {
                column: [{ keys: "created_at", name: "購買日期時間" }, { keys: "order_id", name: "訂單編號" }, { keys: "studio_name", name: "品牌名稱" }, { keys: "branch_name", name: "場館名稱" }, { keys: "member_name", name: "客戶" }, { keys: "product_name", name: "項目" }, { keys: "sub_total", name: "項目金額" }, { keys: "expense", name: "費用" }],
                fileName: "member_discovery_fee_records"
            },
            relatedFilterWatcher: {
                studio_id: {
                    watcher: null,
                    options: "studioList",
                    vModel: "studioId",
                    trackBy: "id",
                    type: "single"
                },
                branch_ids: {
                    watcher: null,
                    options: 'branchList',
                    vModel: 'branchIds',
                    trackBy: 'id',
                    type: "multiple"
                }
            }
        };
    },
    created: function created() {
        this.syncRelatedMultipleSelectByQuery({ vm: this, relatedFilterWatcher: this.relatedFilterWatcher });
    },
    mounted: function mounted() {
        var _this = this;

        this.configuredRun(function () {
            _this.changeFilterOption({
                prop: 'studioId',
                value: {
                    id: _this.configureStates.studioId,
                    brand_name: ''
                }
            });

            _this.changeFilterOption({
                prop: 'branchId',
                value: _this.configureStates.branchId
            });

            _this.fetchStudioList();
        });

        this.changeItemOption({
            prop: 'viewMode',
            value: 'detail'
        });

        this.syncDateAndDisplayByQuery({
            'diffType': 'months',
            'diffNumber': -1
        });
    },

    watch: {
        'configureStates.isBranch': function configureStatesIsBranch(newVal, oldVal) {
            if (newVal) {
                document.getElementsByClassName("control-box")[1].style.display = "none";
            }
        },
        export: function _export(newV) {
            if (newV && newV.length > 0) {
                this.csvConfig.jsonData = _lodash2.default.cloneDeep(newV);
                this.$refs.smart_table.downloadCsv();
            }
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        configureStates: function configureStates(state) {
            return state.webadmin.configure;
        }
    }), (0, _vuex.mapState)('webadmin/configure', ['configured', 'studioList', 'branchList', 'branchId']), (0, _vuex.mapState)('webadmin/baseReport', ['blockOpenStatus', 'dateOptions', 'filterOptions', 'ajaxing', 'itemOptions']), {
        studioId: {
            get: function get() {
                return this.filterOptions.studioId;
            },
            set: function set(newValue) {
                var _this2 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                    return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.next = 2;
                                    return _this2.changeFilterOption({ 'prop': 'studioId', value: newValue });

                                case 2:
                                    _this2.cleanBranch();

                                    if (!newValue) {
                                        _context.next = 6;
                                        break;
                                    }

                                    _context.next = 6;
                                    return _this2.fetchBranchList({ studioId: newValue.id });

                                case 6:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this2);
                }))();
            }
        },
        branchIds: {
            get: function get() {
                return this.filterOptions.branchIds;
            },
            set: function set(newValue) {
                var _this3 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                    return _regenerator2.default.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    _this3.changeFilterOption({ 'prop': 'branchIds', value: newValue });

                                case 1:
                                case 'end':
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, _this3);
                }))();
            }
        },
        viewMode: {
            get: function get() {
                return this.itemOptions.viewMode;
            },
            set: function set(value) {
                this.changeItemOption({
                    prop: 'viewMode',
                    value: value
                });
            }
        },
        display: {
            get: function get() {
                return this.$store.state.webadmin.baseReport.display;
            },
            set: function () {
                var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(newValue) {
                    return _regenerator2.default.wrap(function _callee3$(_context3) {
                        while (1) {
                            switch (_context3.prev = _context3.next) {
                                case 0:
                                    _context3.next = 2;
                                    return this.changeDisplay(newValue);

                                case 2:
                                case 'end':
                                    return _context3.stop();
                            }
                        }
                    }, _callee3, this);
                }));

                function set(_x) {
                    return _ref.apply(this, arguments);
                }

                return set;
            }()
        }
    }),
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('webadmin/configure', ['configuredRun', 'fetchStudioList', 'fetchBranchList']), (0, _vuex.mapActions)('webadmin/baseReport', ['beforeSubmit', 'toggleBlock', 'changeDateOption', 'changeFilterOption', 'cleanBranch', 'changeItemOption', 'changeAjaxing', "syncDateAndDisplayByQuery", "syncRelatedMultipleSelectByQuery", "changeDisplay"]), {
        submit: function submit() {
            this.beforeSubmit();
            var data = this.getPara();
            $17.updateUrlQueryString(data, true);
            this.getSummary(data);
            this.getResult(data);
        },
        getPara: function getPara() {
            var data = {
                'start_date': this.dateOptions.startDate,
                'end_date': this.dateOptions.endDate
            };

            if (this.studioId && this.studioId.id) {
                data.studio_id = this.studioId.id;
            }
            if (this.branchIds.length > 0) {
                data.branch_ids = this.branchIds.map(function (item) {
                    return item.id;
                });
            }

            return data;
        },
        getSummary: function getSummary(data) {
            var _this4 = this;

            this.$http.get('/adminapi/report/fetch-member-discovery-summary', { params: data }).then(function (response) {
                _this4.summaryList = response.data.records;
            }, function (error) {
                $17.swal({
                    title: error.body.message,
                    type: 'warning'
                });
            });
        },
        getResult: function getResult(params) {
            var _this5 = this;

            var data = params;

            switch (this.display) {
                case "export":
                    data.page_size = 9999999;
                    break;
                case "show":
                    data.page_size = 25;
                    break;
                default:
                    null;
            }

            this.changeAjaxing(true);
            this.$http.get('/adminapi/report/fetch-member-discovery-detail', { params: data }).then(function (response) {
                if (_this5.display == 'export') {
                    _this5.export = response.data.records;
                }

                if (_this5.display == 'show') {
                    _this5.detailList = response.data;
                }
                _this5.changeAjaxing(false);
            }, function (error) {
                _this5.changeAjaxing(false);
                $17.swal({
                    title: error.body.message,
                    type: 'warning'
                });
            });
        },
        changePage: function changePage(page) {
            var _this6 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
                var params;
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _this6.changeFilterOption({
                                    prop: "page",
                                    value: page
                                });

                                params = _this6.getPara();


                                params.page_size = _this6.filterOptions.pageSize;
                                params.page = _this6.filterOptions.page;

                                _context4.next = 6;
                                return _this6.getResult(params);

                            case 6:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this6);
            }))();
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"page-div\" _v-d7248c22=\"\">\n    <v-webadmin-report :block-open-status=\"blockOpenStatus\" :date-options=\"dateOptions\" :toggle-block=\"toggleBlock\" :change-date-option=\"changeDateOption\" ref=\"report\" :submit=\"submit\" limit-date=\"730\" title=\"行銷服務費試算 - 新客戶(17FIT)\" _v-d7248c22=\"\">\n        <div slot=\"second-block\" _v-d7248c22=\"\">\n            <div class=\"row\" _v-d7248c22=\"\">\n                <div class=\"col-sm-6\" _v-d7248c22=\"\">\n                    <div class=\"form-group\" _v-d7248c22=\"\">\n                        <v-mutiselect :model.sync=\"studioId\" :options=\"studioList\" :preserve-search=\"true\" :close-on-select=\"true\" :placeholder=\"configureStates.ajaxing.studioList ? '品牌讀取中…' : '請選擇品牌'\" label=\"brand_name\" track-by=\"id\" _v-d7248c22=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n                <div class=\"col-sm-6\" _v-d7248c22=\"\">\n                    <div class=\"form-group\" _v-d7248c22=\"\">\n                        <v-mutiselect :model.sync=\"branchIds\" :options=\"branchList\" :disabled=\"configureStates.ajaxing.branchList\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"false\" :placeholder=\"configureStates.ajaxing.branchList ? '場館讀取中…' : '全部場館'\" label=\"branch_name\" track-by=\"id\" :taggable=\"true\" tag-name=\"branch_name\" _v-d7248c22=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div slot=\"third-block\" _v-d7248c22=\"\">\n            <div class=\"row\" _v-d7248c22=\"\">\n                <div class=\"col-sm-6\" _v-d7248c22=\"\">\n                    <div class=\"form-group\" _v-d7248c22=\"\">\n                        <label _v-d7248c22=\"\">\n                            <input name=\"view\" type=\"radio\" value=\"detail\" v-model=\"viewMode\" checked=\"\" _v-d7248c22=\"\"> 顯示細節\n                        </label>\n                        <!-- <label> V1只顯示細節\n                            <input name=\"view\" type=\"radio\" value=\"summary\" v-model=\"viewMode\"> 顯示總和\n                        </label> -->\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div slot=\"fourth-block\" _v-d7248c22=\"\">\n            <div class=\"row\" _v-d7248c22=\"\">\n                <div class=\"col-sm-6\" _v-d7248c22=\"\">\n                    <div class=\"form-group\" _v-d7248c22=\"\">\n                        <label _v-d7248c22=\"\">\n                            <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"show\" checked=\"\" _v-d7248c22=\"\"> 顯示於網頁\n                        </label>\n                        <label _v-d7248c22=\"\">\n                            <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"export\" _v-d7248c22=\"\"> 匯出CSV\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </v-webadmin-report>\n    <div v-show=\"display === 'show'\" _v-d7248c22=\"\">\n        <div class=\"m-top-30\" _v-d7248c22=\"\">\n            <v-smart-table-summary :col-config=\"colConfig\" :data=\"summaryList\" _v-d7248c22=\"\"></v-smart-table-summary>\n        </div>\n        <div class=\"m-top-10\" _v-d7248c22=\"\">\n            <v-smart-table ref=\"smart_table\" :table-config=\"tableConfig\" :csv-config=\"csvConfig\" :is-ajaxing=\"ajaxing\" :data=\"detailList\" :page-sync-url-query=\"false\" @change-page=\"changePage\" _v-d7248c22=\"\"></v-smart-table>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.page-div[_v-d7248c22] {\n  padding: 0px 15px;\n  margin-bottom: 15px; }\n\n/* line 6, stdin */\n.table-div[_v-d7248c22] {\n  padding: 20px 0px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-d7248c22", module.exports)
  } else {
    hotAPI.update("_v-d7248c22", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1366:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.page-div[_v-08f2c932] {\n  padding: 0 15px;\n  margin-bottom: 15px; }\n\n/* line 7, stdin */\n.table-div[_v-08f2c932] {\n  padding: 20px 0; }\n\n/* line 11, stdin */\n.table-striped thead[_v-08f2c932] {\n  border-bottom: 1px solid #000; }\n\n/* line 15, stdin */\n.multiselect[_v-08f2c932] {\n  padding-bottom: 5px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _watch;

var _vuex = require('vuex');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            display: 'show'
        };
    },
    mounted: function mounted() {
        var _this = this;

        this.configuredRun(function () {
            _this.changeFilterOption({
                prop: 'studioId',
                value: {
                    id: _this.configureStates.studioId,
                    brand_name: ''
                }
            });
            if (_this.configureStates.isSeventeen) {
                return _this.fetchStudioList();
            }
        });
        this.changeDateOption({
            prop: 'startDate',
            value: moment().add(-1, 'month').format('YYYY/MM/DD')
        });
        this.changeDateOption({
            prop: 'endDate',
            value: moment().format('YYYY/MM/DD')
        });
    },

    watch: (_watch = {}, (0, _defineProperty3.default)(_watch, 'filterOptions.studioId', function filterOptionsStudioId(n, o) {
        if (n.id > 0) {
            this.fetchTags();
            this.fetchCustomFields();
        }
    }), (0, _defineProperty3.default)(_watch, 'list', function list(n, o) {
        if (this.display === 'export') {
            var results = this.csvDataHandler(n);
            this.download(results);
        }
    }), _watch),
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        configureStates: function configureStates(state) {
            return state.webadmin.configure;
        }
    }), (0, _vuex.mapState)('webadmin/configure', ['configured', 'studioList']), (0, _vuex.mapState)('webadmin/memberReport', ['blockOpenStatus', 'dateOptions', 'filterOptions', 'ajaxing', 'tagAjaxing', 'fieldAjaxing', 'list', 'tags', 'fields']), {
        studioId: {
            get: function get() {
                return this.filterOptions.studioId;
            },
            set: function set(newValue) {
                var _this2 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                    return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.next = 2;
                                    return _this2.changeFilterOption({ 'prop': 'studioId', value: newValue });

                                case 2:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this2);
                }))();
            }
        },
        searchTags: {
            get: function get() {
                return this.filterOptions.searchTags;
            },
            set: function set(newValue) {
                var _this3 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                    return _regenerator2.default.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    _context2.next = 2;
                                    return _this3.$store.dispatch('webadmin/memberReport/changeFilterOption', { 'prop': 'searchTags', value: newValue });

                                case 2:
                                case 'end':
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, _this3);
                }))();
            }
        },
        searchExcludeTags: {
            get: function get() {
                return this.filterOptions.searchExcludeTags;
            },
            set: function set(newValue) {
                var _this4 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
                    return _regenerator2.default.wrap(function _callee3$(_context3) {
                        while (1) {
                            switch (_context3.prev = _context3.next) {
                                case 0:
                                    _context3.next = 2;
                                    return _this4.$store.dispatch('webadmin/memberReport/changeFilterOption', { 'prop': 'searchExcludeTags', value: newValue });

                                case 2:
                                case 'end':
                                    return _context3.stop();
                            }
                        }
                    }, _callee3, _this4);
                }))();
            }
        },
        searchCustomFields: {
            get: function get() {
                return this.filterOptions.searchCustomFields;
            },
            set: function set(newValue) {
                var _this5 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
                    return _regenerator2.default.wrap(function _callee4$(_context4) {
                        while (1) {
                            switch (_context4.prev = _context4.next) {
                                case 0:
                                    _context4.next = 2;
                                    return _this5.$store.dispatch('webadmin/memberReport/changeFilterOption', { 'prop': 'searchCustomFields', value: newValue });

                                case 2:
                                case 'end':
                                    return _context4.stop();
                            }
                        }
                    }, _callee4, _this5);
                }))();
            }
        }
    }),
    methods: (0, _extends3.default)({
        updateFilterOption: function updateFilterOption(field) {
            var _this6 = this;

            return function (value) {
                return _this6.changeFilterOption({
                    prop: field,
                    value: value
                });
            };
        }
    }, (0, _vuex.mapActions)('webadmin/configure', ['configuredRun', 'fetchStudioList']), (0, _vuex.mapActions)('webadmin/memberReport', ['submitReport', 'toggleBlock', 'changeDateOption', 'changeFilterOption', 'changeItemOption', 'fetchTags', 'fetchCustomFields']), {
        download: function download(_csvString) {
            var downloadLink = document.createElement("a");
            downloadLink.download = "data.csv";
            downloadLink.innerHTML = "Download File";
            if (window.URL != null) {
                var csvData = new Blob(['\uFEFF' + _csvString], { type: 'text/csv;charset=utf-8' });
                var csvUrl = URL.createObjectURL(csvData);
                downloadLink.href = csvUrl;
            }
            downloadLink.click();
        },
        csvDataHandler: function csvDataHandler(data) {
            data = this.columnFormatter(data);
            return Papa.unparse(data, {
                delimiter: ','
            });
        },
        columnFormatter: function columnFormatter(d) {
            var vm = this;
            String.prototype.replaceAll = function (search, replacement) {
                var target = this;
                return target.replace(new RegExp(search, 'g'), replacement);
            };
            var needColumn = vm.searchCustomFields.slice();
            var data = _lodash2.default.map(d, function (row) {
                var newRow = {};
                newRow['created_at'] = row.created_at;
                for (var i = 0; i < needColumn.length; i++) {
                    var key = 'c_' + needColumn[i];
                    if (row.hasOwnProperty(key)) {
                        newRow[key] = row[key];
                    } else {
                        newRow[key] = '';
                    }
                }
                return newRow;
            });
            data = (0, _stringify2.default)(data);
            data = data.replaceAll('created_at', '註冊時間');
            for (var i = 0; i < (0, _keys2.default)(this.filterOptions.showFields).length; i++) {
                var filed = this.filterOptions.showFields[i];
                data = data.replaceAll('c_' + filed.id, filed.name);
            }
            return data;
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"page-div\" _v-08f2c932=\"\">\n    <v-webadmin-report :block-open-status=\"blockOpenStatus\" :date-options=\"dateOptions\" :toggle-block=\"toggleBlock\" :change-date-option=\"changeDateOption\" :disable-submit=\"ajaxing\" :submit=\"submitReport\" limit-date=\"365\" title=\"新註冊客戶\" _v-08f2c932=\"\">\n        <div slot=\"second-block\" _v-08f2c932=\"\">\n            <div class=\"filters\" _v-08f2c932=\"\">\n                <div class=\"row\" _v-08f2c932=\"\">\n                    <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen\" _v-08f2c932=\"\">\n                        <div class=\"form-group\" _v-08f2c932=\"\">\n                            <v-mutiselect :model.sync=\"studioId\" :options=\"studioList\" :preserve-search=\"true\" :placeholder=\"configureStates.ajaxing.studioList ? '品牌讀取中…' : '請選擇品牌'\" label=\"brand_name\" track-by=\"id\" _v-08f2c932=\"\">\n                            </v-mutiselect>\n                        </div>\n                    </div>\n                    <div class=\"col-sm-12\" _v-08f2c932=\"\">\n                        <div class=\"row\" _v-08f2c932=\"\">\n                            <div class=\"col-sm-6\" _v-08f2c932=\"\">\n                                <div class=\"form-group\" _v-08f2c932=\"\">\n                                    <v-mutiselect :model.sync=\"searchTags\" :options=\"tags\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"true\" :placeholder=\"tagAjaxing ? '標籤讀取中…' : '包含選擇的標籤'\" label=\"name\" track-by=\"id\" :max-height=\"500\" tag-name=\"name\" _v-08f2c932=\"\">\n                                    </v-mutiselect>\n                                </div>\n                            </div>\n                            <div class=\"col-sm-6\" _v-08f2c932=\"\">\n                                <div class=\"form-group\" _v-08f2c932=\"\">\n                                    <v-mutiselect :model.sync=\"searchExcludeTags\" :options=\"tags\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"true\" :placeholder=\"tagAjaxing ? '標籤讀取中…' : '排除選擇的標籤'\" label=\"name\" track-by=\"id\" :max-height=\"500\" tag-name=\"name\" _v-08f2c932=\"\">\n                                    </v-mutiselect>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div slot=\"third-block\" _v-08f2c932=\"\">\n            <div class=\"row\" _v-08f2c932=\"\">\n                <div class=\"col-sm-12\" _v-08f2c932=\"\">\n                    <v-spinner :ajaxing=\"fieldAjaxing\" _v-08f2c932=\"\"></v-spinner>\n                    <div class=\"form-group\" v-show=\"!fieldAjaxing\" _v-08f2c932=\"\">\n                        <label class=\"m-bottom-10 m-left-10 m-right-10\" v-for=\"field in fields\" _v-08f2c932=\"\">\n                            <input type=\"checkbox\" :disabled=\"filterOptions.defaultFields.includes(field.id)&amp;&amp;field.ref_field==='name'?true:false\" v-model=\"searchCustomFields\" :value=\"field.id\" _v-08f2c932=\"\"> {{field.name}}\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div slot=\"fourth-block\" _v-08f2c932=\"\">\n            <div class=\"row\" _v-08f2c932=\"\">\n                <div class=\"col-sm-6\" _v-08f2c932=\"\">\n                    <div class=\"form-group row\" _v-08f2c932=\"\">\n                        <label _v-08f2c932=\"\">\n                            <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"show\" checked=\"\" _v-08f2c932=\"\"> 顯示於網頁\n                        </label>\n                        <label _v-08f2c932=\"\">\n                            <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"export\" _v-08f2c932=\"\"> 匯出 CSV\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </v-webadmin-report>\n    <div v-show=\"display==='show'\" _v-08f2c932=\"\">\n        <div class=\"m-top-25\" v-if=\"Object.keys(list).length\" _v-08f2c932=\"\">\n            <h4 _v-08f2c932=\"\">總人數：{{Object.keys(list).length}}</h4>\n        </div>\n        <div class=\"table-div\" _v-08f2c932=\"\">\n            <v-table :ajaxing=\"ajaxing\" :length=\"Object.keys(list).length\" _v-08f2c932=\"\">\n                <table class=\"table table-striped\" _v-08f2c932=\"\">\n                    <thead _v-08f2c932=\"\">\n                    <tr _v-08f2c932=\"\">\n                        <td _v-08f2c932=\"\">註冊建立時間</td>\n                        <td v-for=\"field in filterOptions.showFields\" _v-08f2c932=\"\">{{field.name}}</td>\n                    </tr>\n                    </thead>\n                    <tbody _v-08f2c932=\"\">\n                    <tr v-for=\"item in list\" _v-08f2c932=\"\">\n                        <td _v-08f2c932=\"\">{{item.created_at}}</td>\n                        <td v-for=\"field in filterOptions.showFields\" _v-08f2c932=\"\">{{typeof (item['c_'+field.id]) === 'object' ? (item['c_'+field.id]).join(\",\") : item['c_'+field.id]}}</td>\n                    </tr>\n                    </tbody>\n                </table>\n            </v-table>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.page-div[_v-08f2c932] {\n  padding: 0 15px;\n  margin-bottom: 15px; }\n\n/* line 7, stdin */\n.table-div[_v-08f2c932] {\n  padding: 20px 0; }\n\n/* line 11, stdin */\n.table-striped thead[_v-08f2c932] {\n  border-bottom: 1px solid #000; }\n\n/* line 15, stdin */\n.multiselect[_v-08f2c932] {\n  padding-bottom: 5px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-08f2c932", module.exports)
  } else {
    hotAPI.update("_v-08f2c932", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/json/stringify":48,"babel-runtime/core-js/object/keys":56,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/defineProperty":65,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1367:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.page-div[_v-cc8a59b4] {\n  padding: 0px 15px;\n  margin-bottom: 15px; }\n\n/* line 6, stdin */\n.table-div[_v-cc8a59b4] {\n  padding: 20px 0px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _watch;

var _vuex = require('vuex');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            paymentSourceRecordTypes: [],
            paymentSourceRecordType: null,
            ajaxingPaymentSourceRecordType: false,
            detailList: {},
            export: [],
            colConfig: {
                columns: [{ keys: "should_pay_total", head: "訂單總額" }, { keys: "expense_total", head: "費用總額" }]
            },
            summaryList: {},
            tableConfig: {
                columns: [{ keys: "created_at", head: "購買日期時間" }, { keys: "order_id", head: "訂單編號" }, { keys: "branch_name", head: "場館名稱" }, { keys: "member_name", head: "客戶" }, { keys: "amount", head: "支付金額" }, { keys: "expense", head: "費用" }]
            },
            csvConfig: {
                column: [{ keys: "created_at", name: "購買日期時間" }, { keys: "order_id", name: "訂單編號" }, { keys: "branch_name", name: "場館名稱" }, { keys: "member_name", name: "客戶" }, { keys: "amount", name: "支付金額" }, { keys: "expense", name: "費用" }],
                fileName: "payment-flow-service-charge-" + moment().format("YYYYMMDDHHmmss")
            },
            relatedFilterWatcher: {
                studio_id: {
                    watcher: null,
                    options: "studioList",
                    vModel: "studioId",
                    trackBy: "id",
                    type: "single"
                },
                branch_ids: {
                    watcher: null,
                    options: 'branchList',
                    vModel: 'branchIds',
                    trackBy: 'id',
                    type: "multiple"
                }
            },
            dateOptions: {
                startDate: moment().startOf('month').format('YYYY/MM/DD'),
                endDate: moment().endOf('month').format('YYYY/MM/DD'),
                disabled: true
            }
        };
    },
    created: function created() {
        this.syncRelatedMultipleSelectByQuery({ vm: this, relatedFilterWatcher: this.relatedFilterWatcher });
    },
    mounted: function mounted() {
        var _this = this;

        this.configuredRun(function () {

            _this.changeFilterOption({
                prop: 'studioId',
                value: {
                    id: _this.configureStates.studioId,
                    brand_name: ''
                }
            });
            _this.changeFilterOption({
                prop: 'branchId',
                value: _this.configureStates.branchId
            });

            if (_this.configureStates.isSeventeen) {
                return _this.fetchStudioList();
            }

            if (_this.configureStates.isBranch) {
                _this.branchIds = [{
                    'id': _this.configureStates.branchId,
                    'branch_name': ''
                }];
            }
        });

        this.changeItemOption({
            prop: 'viewMode',
            value: 'detail'
        });
    },

    watch: (_watch = {
        'configureStates.isBranch': function configureStatesIsBranch(newVal, oldVal) {
            if (newVal) {
                document.getElementsByClassName("control-box")[1].style.display = "none";
            }
        }
    }, (0, _defineProperty3.default)(_watch, 'filterOptions.studioId', function filterOptionsStudioId(n, o) {
        if (this.configureStates.isSeventeen && !_lodash2.default.isEmpty(n)) {
            this.fetchBranchList({
                studioId: n.id
            });
        }
        if (this.configureStates.isStudio) {
            this.fetchBranchList({
                studioId: n.id
            });
        }
    }), (0, _defineProperty3.default)(_watch, 'export', function _export(newV) {
        if (newV && newV.length > 0) {
            this.csvConfig.jsonData = _lodash2.default.cloneDeep(newV);
            this.$refs.smart_table.downloadCsv();
        }
    }), _watch),
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        configureStates: function configureStates(state) {
            return state.webadmin.configure;
        }
    }), (0, _vuex.mapState)('webadmin/configure', ['configured', 'studioList', 'branchList', 'branchId', 'isSeventeen']), (0, _vuex.mapState)('webadmin/baseReport', ['blockOpenStatus', 'filterOptions', 'ajaxing', 'itemOptions']), {
        studioId: {
            get: function get() {
                return this.filterOptions.studioId;
            },
            set: function set(newValue) {
                var _this2 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                    return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.next = 2;
                                    return _this2.changeFilterOption({ 'prop': 'studioId', value: newValue });

                                case 2:
                                    _this2.cleanBranch();

                                    if (!newValue) {
                                        _context.next = 6;
                                        break;
                                    }

                                    _context.next = 6;
                                    return _this2.fetchBranchList({ studioId: newValue.id });

                                case 6:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this2);
                }))();
            }
        },
        branchIds: {
            get: function get() {
                return this.filterOptions.branchIds;
            },
            set: function set(newValue) {
                var _this3 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                    return _regenerator2.default.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    _this3.changeFilterOption({ 'prop': 'branchIds', value: newValue });

                                case 1:
                                case 'end':
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, _this3);
                }))();
            }
        },
        viewMode: {
            get: function get() {
                return this.itemOptions.viewMode;
            },
            set: function set(value) {
                this.changeItemOption({
                    prop: 'viewMode',
                    value: value
                });
            }
        },
        display: {
            get: function get() {
                return this.$store.state.webadmin.baseReport.display;
            },
            set: function () {
                var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(newValue) {
                    return _regenerator2.default.wrap(function _callee3$(_context3) {
                        while (1) {
                            switch (_context3.prev = _context3.next) {
                                case 0:
                                    _context3.next = 2;
                                    return this.changeDisplay(newValue);

                                case 2:
                                case 'end':
                                    return _context3.stop();
                            }
                        }
                    }, _callee3, this);
                }));

                function set(_x) {
                    return _ref.apply(this, arguments);
                }

                return set;
            }()
        }
    }),
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('webadmin/configure', ['configuredRun', 'fetchStudioList', 'fetchBranchList']), (0, _vuex.mapActions)('webadmin/baseReport', ['beforeSubmit', 'toggleBlock', 'changeDateOption', 'changeFilterOption', 'cleanBranch', 'changeItemOption', 'changeAjaxing', "syncDateAndDisplayByQuery", "syncRelatedMultipleSelectByQuery", "changeDisplay"]), {
        submit: function submit() {
            var data = this.getPara();
            $17.updateUrlQueryString(data, true);
            this.getSummary(data);
            this.getResult(data);
        },
        getPara: function getPara() {
            var data = {};

            if (this.branchIds.length > 0) {
                data.branch_ids = this.branchIds.map(function (item) {
                    return item.id;
                });
            }

            return data;
        },
        getSummary: function getSummary(data) {
            var _this4 = this;

            this.$http.get('/adminapi/report/fetch-neweb-bank-transfer-fee-summary-for-studio', { params: data }).then(function (response) {
                _this4.summaryList = response.data.records;
            }, function (error) {
                $17.swal({
                    title: error.body.message,
                    type: 'warning'
                });
            });
        },
        getResult: function getResult(params) {
            var _this5 = this;

            var data = params;

            switch (this.display) {
                case "export":
                    data.page_size = 9999999;
                    break;
                case "show":
                    data.page_size = 25;
                    break;
                default:
                    null;
            }

            this.changeAjaxing(true);
            this.$http.get('/adminapi/report/fetch-neweb-bank-transfer-fee-detail-for-studio', { params: data }).then(function (response) {
                if (_this5.display == 'export') {
                    _this5.export = response.data.records;
                }

                if (_this5.display == 'show') {
                    _this5.detailList = response.data;
                }
                _this5.changeAjaxing(false);
            }, function (error) {
                _this5.changeAjaxing(false);
                $17.swal({
                    title: error.body.message,
                    type: 'warning'
                });
            });
        },
        changePage: function changePage(page) {
            var _this6 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
                var params;
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _this6.changeFilterOption({
                                    prop: "page",
                                    value: page
                                });

                                params = _this6.getPara();


                                params.page_size = _this6.filterOptions.pageSize;
                                params.page = _this6.filterOptions.page;

                                _context4.next = 6;
                                return _this6.getResult(params);

                            case 6:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this6);
            }))();
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"page-div\" _v-cc8a59b4=\"\">\n<v-webadmin-report :block-open-status=\"blockOpenStatus\" :date-options=\"dateOptions\" :toggle-block=\"toggleBlock\" :change-date-option=\"changeDateOption\" ref=\"report\" :submit=\"submit\" limit-date=\"730\" title=\"金流服務費試算 - 銀行轉帳\" _v-cc8a59b4=\"\">\n        <div slot=\"second-block\" _v-cc8a59b4=\"\">\n            <div class=\"row\" _v-cc8a59b4=\"\">\n                <div class=\"col-sm-6\" v-show=\"isSeventeen\" _v-cc8a59b4=\"\">\n                    <div class=\"form-group\" _v-cc8a59b4=\"\">\n                        <v-mutiselect :model.sync=\"studioId\" :options=\"studioList\" :preserve-search=\"true\" :close-on-select=\"true\" :placeholder=\"configureStates.ajaxing.studioList ? '品牌讀取中…' : '請選擇品牌'\" label=\"brand_name\" track-by=\"id\" _v-cc8a59b4=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n                <div class=\"col-sm-6\" _v-cc8a59b4=\"\">\n                    <div class=\"form-group\" _v-cc8a59b4=\"\">\n                        <v-mutiselect :model.sync=\"branchIds\" :options=\"branchList\" :disabled=\"configureStates.ajaxing.branchList\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"false\" :placeholder=\"configureStates.ajaxing.branchList ? '場館讀取中…' : '全部場館'\" label=\"branch_name\" track-by=\"id\" :taggable=\"true\" tag-name=\"branch_name\" _v-cc8a59b4=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div slot=\"third-block\" _v-cc8a59b4=\"\">\n            <div class=\"row\" _v-cc8a59b4=\"\">\n                <div class=\"col-sm-6\" _v-cc8a59b4=\"\">\n                    <div class=\"form-group\" _v-cc8a59b4=\"\">\n                        <label _v-cc8a59b4=\"\">\n                            <input name=\"view\" type=\"radio\" value=\"detail\" v-model=\"viewMode\" checked=\"\" _v-cc8a59b4=\"\"> 顯示細節\n                        </label>\n                        <!-- <label> V1只顯示細節\n                            <input name=\"view\" type=\"radio\" value=\"summary\" v-model=\"viewMode\"> 顯示總和\n                        </label> -->\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div slot=\"fourth-block\" _v-cc8a59b4=\"\">\n            <div class=\"row\" _v-cc8a59b4=\"\">\n                <div class=\"col-sm-6\" _v-cc8a59b4=\"\">\n                    <div class=\"form-group\" _v-cc8a59b4=\"\">\n                        <label _v-cc8a59b4=\"\">\n                            <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"show\" checked=\"\" _v-cc8a59b4=\"\"> 顯示於網頁\n                        </label>\n                        <label _v-cc8a59b4=\"\">\n                            <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"export\" _v-cc8a59b4=\"\"> 匯出CSV\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </v-webadmin-report>\n    <div v-show=\"display === 'show'\" _v-cc8a59b4=\"\">\n        <div class=\"m-top-30\" _v-cc8a59b4=\"\">\n            <v-smart-table-summary :col-config=\"colConfig\" :data=\"summaryList\" _v-cc8a59b4=\"\"></v-smart-table-summary>\n        </div>\n        <div class=\"m-top-10\" _v-cc8a59b4=\"\">\n            <v-smart-table ref=\"smart_table\" :table-config=\"tableConfig\" :csv-config=\"csvConfig\" :is-ajaxing=\"ajaxing\" :data=\"detailList\" :page-sync-url-query=\"false\" @change-page=\"changePage\" _v-cc8a59b4=\"\"></v-smart-table>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.page-div[_v-cc8a59b4] {\n  padding: 0px 15px;\n  margin-bottom: 15px; }\n\n/* line 6, stdin */\n.table-div[_v-cc8a59b4] {\n  padding: 20px 0px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-cc8a59b4", module.exports)
  } else {
    hotAPI.update("_v-cc8a59b4", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/defineProperty":65,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1368:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.page-div[_v-90b1079e] {\n  padding: 0px 15px;\n  margin-bottom: 15px; }\n\n/* line 6, stdin */\n.table-div[_v-90b1079e] {\n  padding: 20px 0px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            paymentSourceRecordCategories: [],
            paymentSourceRecordCategory: null,
            ajaxingPaymentSourceRecordCategory: false,
            detailList: {},
            export: [],
            colConfig: {
                columns: [{ keys: "should_pay_total", head: "訂單總額" }, { keys: "expense_total", head: "費用總額" }]
            },
            summaryList: {},
            tableConfig: {
                columns: [{ keys: "created_at", head: "購買日期時間" }, { keys: "order_id", head: "訂單編號" }, { keys: "studio_name", head: "品牌名稱" }, { keys: "branch_name", head: "場館名稱" }, { keys: "member_name", head: "客戶" }, { keys: "amount", head: "支付金額" }, { keys: "expense", head: "費用" }]
            },
            csvConfig: {
                column: [{ keys: "created_at", name: "購買日期時間" }, { keys: "order_id", name: "訂單編號" }, { keys: "studio_name", name: "品牌名稱" }, { keys: "branch_name", name: "場館名稱" }, { keys: "member_name", name: "客戶" }, { keys: "amount", name: "支付金額" }, { keys: "expense", name: "費用" }],
                fileName: "payment-flow-service-charge-" + moment().format("YYYYMMDDHHmmss")
            },
            relatedFilterWatcher: {
                studio_id: {
                    watcher: null,
                    options: "studioList",
                    vModel: "studioId",
                    trackBy: "id",
                    type: "single"
                },
                branch_ids: {
                    watcher: null,
                    options: 'branchList',
                    vModel: 'branchIds',
                    trackBy: 'id',
                    type: "multiple"
                }
            }
        };
    },
    created: function created() {
        this.syncRelatedMultipleSelectByQuery({ vm: this, relatedFilterWatcher: this.relatedFilterWatcher });
    },
    mounted: function mounted() {
        var _this = this;

        this.configuredRun(function () {
            _this.changeFilterOption({
                prop: 'studioId',
                value: {
                    id: _this.configureStates.studioId,
                    brand_name: ''
                }
            });

            _this.changeFilterOption({
                prop: 'branchId',
                value: _this.configureStates.branchId
            });

            _this.fetchStudioList();
        });

        this.changeItemOption({
            prop: 'viewMode',
            value: 'detail'
        });

        this.syncDateAndDisplayByQuery({
            'diffType': 'months',
            'diffNumber': -1
        });
    },

    watch: {
        'configureStates.isBranch': function configureStatesIsBranch(newVal, oldVal) {
            if (newVal) {
                document.getElementsByClassName("control-box")[1].style.display = "none";
            }
        },
        export: function _export(newV) {
            if (newV && newV.length > 0) {
                this.csvConfig.jsonData = _lodash2.default.cloneDeep(newV);
                this.$refs.smart_table.downloadCsv();
            }
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        configureStates: function configureStates(state) {
            return state.webadmin.configure;
        }
    }), (0, _vuex.mapState)('webadmin/configure', ['configured', 'studioList', 'branchList', 'branchId']), (0, _vuex.mapState)('webadmin/baseReport', ['blockOpenStatus', 'dateOptions', 'filterOptions', 'ajaxing', 'itemOptions']), {
        studioId: {
            get: function get() {
                return this.filterOptions.studioId;
            },
            set: function set(newValue) {
                var _this2 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                    return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.next = 2;
                                    return _this2.changeFilterOption({ 'prop': 'studioId', value: newValue });

                                case 2:
                                    _this2.cleanBranch();

                                    if (!newValue) {
                                        _context.next = 6;
                                        break;
                                    }

                                    _context.next = 6;
                                    return _this2.fetchBranchList({ studioId: newValue.id });

                                case 6:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this2);
                }))();
            }
        },
        branchIds: {
            get: function get() {
                return this.filterOptions.branchIds;
            },
            set: function set(newValue) {
                var _this3 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                    return _regenerator2.default.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    _this3.changeFilterOption({ 'prop': 'branchIds', value: newValue });

                                case 1:
                                case 'end':
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, _this3);
                }))();
            }
        },
        viewMode: {
            get: function get() {
                return this.itemOptions.viewMode;
            },
            set: function set(value) {
                this.changeItemOption({
                    prop: 'viewMode',
                    value: value
                });
            }
        },
        display: {
            get: function get() {
                return this.$store.state.webadmin.baseReport.display;
            },
            set: function () {
                var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(newValue) {
                    return _regenerator2.default.wrap(function _callee3$(_context3) {
                        while (1) {
                            switch (_context3.prev = _context3.next) {
                                case 0:
                                    _context3.next = 2;
                                    return this.changeDisplay(newValue);

                                case 2:
                                case 'end':
                                    return _context3.stop();
                            }
                        }
                    }, _callee3, this);
                }));

                function set(_x) {
                    return _ref.apply(this, arguments);
                }

                return set;
            }()
        }
    }),
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('webadmin/configure', ['configuredRun', 'fetchStudioList', 'fetchBranchList']), (0, _vuex.mapActions)('webadmin/baseReport', ['beforeSubmit', 'toggleBlock', 'changeDateOption', 'changeFilterOption', 'cleanBranch', 'changeItemOption', 'changeAjaxing', "syncDateAndDisplayByQuery", "syncRelatedMultipleSelectByQuery", "changeDisplay"]), {
        submit: function submit() {
            this.beforeSubmit();
            var data = this.getPara();
            $17.updateUrlQueryString(data, true);
            this.getSummary(data);
            this.getResult(data);
        },
        getPara: function getPara() {
            var data = {
                'start_date': this.dateOptions.startDate,
                'end_date': this.dateOptions.endDate
            };

            if (this.studioId && this.studioId.id) {
                data.studio_id = this.studioId.id;
            }
            if (this.branchIds.length > 0) {
                data.branch_ids = this.branchIds.map(function (item) {
                    return item.id;
                });
            }

            return data;
        },
        getSummary: function getSummary(data) {
            var _this4 = this;

            this.$http.get('/adminapi/report/fetch-neweb-bank-transfer-fee-summary', { params: data }).then(function (response) {
                _this4.summaryList = response.data.records;
            }, function (error) {
                $17.swal({
                    title: error.body.message,
                    type: 'warning'
                });
            });
        },
        getResult: function getResult(params) {
            var _this5 = this;

            var data = params;

            switch (this.display) {
                case "export":
                    data.page_size = 9999999;
                    break;
                case "show":
                    data.page_size = 25;
                    break;
                default:
                    null;
            }

            this.changeAjaxing(true);
            this.$http.get('/adminapi/report/fetch-neweb-bank-transfer-fee-detail', { params: data }).then(function (response) {
                if (_this5.display == 'export') {
                    _this5.export = response.data.records;
                }

                if (_this5.display == 'show') {
                    _this5.detailList = response.data;
                }
                _this5.changeAjaxing(false);
            }, function (error) {
                _this5.changeAjaxing(false);
                $17.swal({
                    title: error.body.message,
                    type: 'warning'
                });
            });
        },
        changePage: function changePage(page) {
            var _this6 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
                var params;
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _this6.changeFilterOption({
                                    prop: "page",
                                    value: page
                                });

                                params = _this6.getPara();


                                params.page_size = _this6.filterOptions.pageSize;
                                params.page = _this6.filterOptions.page;

                                _context4.next = 6;
                                return _this6.getResult(params);

                            case 6:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this6);
            }))();
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"page-div\" _v-90b1079e=\"\">\n    <v-webadmin-report :block-open-status=\"blockOpenStatus\" :date-options=\"dateOptions\" :toggle-block=\"toggleBlock\" :change-date-option=\"changeDateOption\" ref=\"report\" :disable-submit=\"ajaxing\" :submit=\"submit\" limit-date=\"60\" title=\"金流服務費試算 - 銀行轉帳(17FIT)\" _v-90b1079e=\"\">\n        <div slot=\"second-block\" _v-90b1079e=\"\">\n            <div class=\"row\" _v-90b1079e=\"\">\n                <div class=\"col-sm-6\" _v-90b1079e=\"\">\n                    <div class=\"form-group\" _v-90b1079e=\"\">\n                        <v-mutiselect :model.sync=\"studioId\" :options=\"studioList\" :preserve-search=\"true\" :close-on-select=\"true\" :placeholder=\"configureStates.ajaxing.studioList ? '品牌讀取中…' : '請選擇品牌'\" label=\"brand_name\" track-by=\"id\" _v-90b1079e=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n                <div class=\"col-sm-6\" _v-90b1079e=\"\">\n                    <div class=\"form-group\" _v-90b1079e=\"\">\n                        <v-mutiselect :model.sync=\"branchIds\" :options=\"branchList\" :disabled=\"configureStates.ajaxing.branchList\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"false\" :placeholder=\"configureStates.ajaxing.branchList ? '場館讀取中…' : '全部場館'\" label=\"branch_name\" track-by=\"id\" :taggable=\"true\" tag-name=\"branch_name\" _v-90b1079e=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div slot=\"third-block\" _v-90b1079e=\"\">\n            <div class=\"row\" _v-90b1079e=\"\">\n                <div class=\"col-sm-6\" _v-90b1079e=\"\">\n                    <div class=\"form-group\" _v-90b1079e=\"\">\n                        <label _v-90b1079e=\"\">\n                            <input name=\"view\" type=\"radio\" value=\"detail\" v-model=\"viewMode\" checked=\"\" _v-90b1079e=\"\"> 顯示細節\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div slot=\"fourth-block\" _v-90b1079e=\"\">\n            <div class=\"row\" _v-90b1079e=\"\">\n                <div class=\"col-sm-6\" _v-90b1079e=\"\">\n                    <div class=\"form-group\" _v-90b1079e=\"\">\n                        <label _v-90b1079e=\"\">\n                            <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"show\" checked=\"\" _v-90b1079e=\"\"> 顯示於網頁\n                        </label>\n                        <label _v-90b1079e=\"\">\n                            <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"export\" _v-90b1079e=\"\"> 匯出 CSV\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </v-webadmin-report>\n    <div v-show=\"display === 'show'\" _v-90b1079e=\"\">\n        <div class=\"m-top-30\" _v-90b1079e=\"\">\n            <v-smart-table-summary :col-config=\"colConfig\" :data=\"summaryList\" _v-90b1079e=\"\"></v-smart-table-summary>\n        </div>\n        <div class=\"m-top-10\" _v-90b1079e=\"\">\n            <v-smart-table ref=\"smart_table\" :table-config=\"tableConfig\" :csv-config=\"csvConfig\" :is-ajaxing=\"ajaxing\" :data=\"detailList\" :page-sync-url-query=\"false\" @change-page=\"changePage\" _v-90b1079e=\"\"></v-smart-table>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.page-div[_v-90b1079e] {\n  padding: 0px 15px;\n  margin-bottom: 15px; }\n\n/* line 6, stdin */\n.table-div[_v-90b1079e] {\n  padding: 20px 0px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-90b1079e", module.exports)
  } else {
    hotAPI.update("_v-90b1079e", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1369:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.page-div[_v-7df84bdf] {\n  padding: 0px 15px;\n  margin-bottom: 15px; }\n\n/* line 7, stdin */\n.m-l-15[_v-7df84bdf] {\n  margin-left: 15px; }\n\n/* line 11, stdin */\n.table-div[_v-7df84bdf] {\n  padding: 20px 0px; }\n\n/* line 15, stdin */\n.form-title[_v-7df84bdf] {\n  font-size: 16px;\n  font-weight: bold;\n  display: inline-block;\n  width: 60px; }\n\n/* line 22, stdin */\n.negative-number[_v-7df84bdf] {\n  color: red; }\n\n/* line 26, stdin */\n.cube[_v-7df84bdf] {\n  max-width: 80px;\n  float: left;\n  margin: 12px 24px;\n  font-weight: bold;\n  font-size: 18px; }\n\n/* line 33, stdin */\n.total-list[_v-7df84bdf] {\n  width: 100%;\n  border: 1px solid;\n  margin: 30px 0px; }\n\n/* line 38, stdin */\n.total-list[_v-7df84bdf]:after {\n  clear: both; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _watch;

var _vuex = require('vuex');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            display: 'show',
            salsemanVisible: {},
            orderRemark: ''
        };
    },
    mounted: function mounted() {
        var _this = this;

        this.getItemTypes();
        this.configuredRun(function () {
            _this.changeFilterOption({
                prop: 'studioId',
                value: {
                    id: _this.configureStates.studioId,
                    brand_name: ''
                }
            });
            _this.changeFilterOption({
                prop: 'branchId',
                value: _this.configureStates.branchId
            });
            if (_this.configureStates.isSeventeen) {
                return _this.fetchStudioList();
            }
            if (_this.configureStates.isBranch) {
                _this.branchIds = [{
                    'id': _this.configureStates.branchId,
                    'branch_name': ''
                }];
            }
        });

        this.changeDateOption({
            prop: 'startDate',
            value: moment().format('YYYY/MM/DD')
        });

        this.changeDateOption({
            prop: 'endDate',
            value: moment().format('YYYY/MM/DD')
        });
    },

    watch: (_watch = {}, (0, _defineProperty3.default)(_watch, 'filterOptions.studioId', function filterOptionsStudioId(n, o) {
        if (this.configureStates.isSeventeen || this.configureStates.isStudio) {
            this.fetchBranchList({
                studioId: n.id
            });
        }
        this.initPayment();
        this.initSalesmen();
        this.getSalsemanVisible(n.id);
    }), (0, _defineProperty3.default)(_watch, 'filterOptions.branchIds', function filterOptionsBranchIds(n, o) {
        this.initPayment();
        this.initSalesmen();
    }), (0, _defineProperty3.default)(_watch, 'details', function details(newValue, oldValue) {
        var _this2 = this;

        this.$nextTick(function () {
            if (newValue.hasOwnProperty('data') && newValue.data.length > 0 && _this2.display === 'export' && _this2.viewMode === 'detail') {
                _this2.$refs.detailTable.exportCsv();
            }
        });
    }), (0, _defineProperty3.default)(_watch, 'summaries', function summaries(newValue, oldValue) {
        var _this3 = this;

        this.$nextTick(function () {
            if (newValue.sales.length > 0 && _this3.display === 'export' && _this3.viewMode === 'summary') {
                _this3.$refs.summaryTable.exportCsv();
            }
        });
    }), (0, _defineProperty3.default)(_watch, 'display', function display(newVal) {
        if (newVal == 'export') {
            this.perPage = 9999999;
        }
        if (newVal == 'show') {
            this.perPage = 100;
        }

        this.CHANGE_SUMMARIES({ 'value': [] });
        this.CHANGE_DETAILS({ 'value': [] });
        this.CHANGE_TOTAL({ 'value': [] });
    }), _watch),
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        configureStates: function configureStates(state) {
            return state.webadmin.configure;
        }
    }), (0, _vuex.mapState)('webadmin/configure', ['configured', 'studioList', 'branchList', 'branchId']), (0, _vuex.mapState)('webadmin/orderDetailsTotalSale', ['blockOpenStatus', 'dateOptions', 'filterOptions', 'ajaxing', 'details', 'summaries',
    // 'total',
    'moneyStatusShow', 'payments', 'paymentAjaxing', "item_types", "items", "itemAjaxing", 'salesmen', 'salesmenAjaxing']), {
        studioId: {
            get: function get() {
                return this.filterOptions.studioId;
            },
            set: function set(newValue) {
                var _this4 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                    return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.next = 2;
                                    return _this4.changeFilterOption({ 'prop': 'studioId', value: newValue });

                                case 2:
                                    _this4.cleanBranch();

                                    if (!newValue) {
                                        _context.next = 6;
                                        break;
                                    }

                                    _context.next = 6;
                                    return _this4.fetchBranchList({ studioId: newValue.id });

                                case 6:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this4);
                }))();
            }
        },
        branchIds: {
            get: function get() {
                return this.filterOptions.branchIds;
            },
            set: function set(newValue) {
                var _this5 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                    return _regenerator2.default.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    _context2.next = 2;
                                    return _this5.changeFilterOption({ 'prop': 'branchIds', value: newValue });

                                case 2:
                                    if (_this5.selectedItemType !== 'all') {
                                        _this5.selectedItem = [];
                                        _this5.getItems();
                                    }

                                case 3:
                                case 'end':
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, _this5);
                }))();
            }
        },
        viewMode: {
            get: function get() {
                return this.$store.state.webadmin.orderDetailsTotalSale.itemOptions.viewMode;
            },
            set: function set(value) {
                this.changeItemOption({
                    prop: 'viewMode',
                    value: value
                });
            }
        },
        moneyStatuses: {
            get: function get() {
                return this.filterOptions.moneyStatuses;
            },
            set: function set(newValue) {
                var _this6 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
                    return _regenerator2.default.wrap(function _callee3$(_context3) {
                        while (1) {
                            switch (_context3.prev = _context3.next) {
                                case 0:
                                    _context3.next = 2;
                                    return _this6.$store.dispatch('webadmin/orderDetailsTotalSale/changeFilterOption', { 'prop': 'moneyStatuses', value: newValue });

                                case 2:
                                case 'end':
                                    return _context3.stop();
                            }
                        }
                    }, _callee3, _this6);
                }))();
            }
        },
        selectedPayment: {
            get: function get() {
                return this.filterOptions.selectedPayment;
            },
            set: function set(newValue) {
                var _this7 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
                    return _regenerator2.default.wrap(function _callee4$(_context4) {
                        while (1) {
                            switch (_context4.prev = _context4.next) {
                                case 0:
                                    _context4.next = 2;
                                    return _this7.$store.dispatch('webadmin/orderDetailsTotalSale/changeFilterOption', { 'prop': 'selectedPayment', value: newValue });

                                case 2:
                                case 'end':
                                    return _context4.stop();
                            }
                        }
                    }, _callee4, _this7);
                }))();
            }
        },
        selectedItemType: {
            get: function get() {
                return this.filterOptions.selectedItemType;
            },
            set: function set(newValue) {
                var _this8 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5() {
                    return _regenerator2.default.wrap(function _callee5$(_context5) {
                        while (1) {
                            switch (_context5.prev = _context5.next) {
                                case 0:
                                    _context5.next = 2;
                                    return _this8.$store.dispatch('webadmin/orderDetailsTotalSale/changeFilterOption', { 'prop': 'selectedItemType', value: newValue });

                                case 2:
                                    if (_this8.selectedItemType !== 'all') {
                                        _this8.selectedItem = [];
                                        _this8.getItems();
                                    }

                                case 3:
                                case 'end':
                                    return _context5.stop();
                            }
                        }
                    }, _callee5, _this8);
                }))();
            }
        },
        selectedItem: {
            get: function get() {
                return this.filterOptions.selectedItem;
            },
            set: function set(newValue) {
                var _this9 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6() {
                    return _regenerator2.default.wrap(function _callee6$(_context6) {
                        while (1) {
                            switch (_context6.prev = _context6.next) {
                                case 0:
                                    _context6.next = 2;
                                    return _this9.$store.dispatch('webadmin/orderDetailsTotalSale/changeFilterOption', { 'prop': 'selectedItem', value: newValue });

                                case 2:
                                case 'end':
                                    return _context6.stop();
                            }
                        }
                    }, _callee6, _this9);
                }))();
            }
        },
        item_type_name: function item_type_name() {
            v = this;
            if (v.item_types.length <= 0 || v.item_types === null || v.selectedItemType === 'all' || v.selectedItemType === '') {
                return "";
            }
            item_type = _lodash2.default.find(v.item_types, function (o) {
                return o.id == v.selectedItemType;
            });
            return item_type.name;
        },
        selectedSalesmen: {
            get: function get() {
                return this.filterOptions.selectedSalesmen;
            },
            set: function set(newValue) {
                var _this10 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7() {
                    return _regenerator2.default.wrap(function _callee7$(_context7) {
                        while (1) {
                            switch (_context7.prev = _context7.next) {
                                case 0:
                                    _context7.next = 2;
                                    return _this10.$store.dispatch('webadmin/orderDetailsTotalSale/changeFilterOption', { 'prop': 'selectedSalesmen', value: newValue });

                                case 2:
                                case 'end':
                                    return _context7.stop();
                            }
                        }
                    }, _callee7, _this10);
                }))();
            }
        },
        page: {
            get: function get() {
                return this.filterOptions.page;
            },
            set: function set(newValue) {
                var _this11 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8() {
                    return _regenerator2.default.wrap(function _callee8$(_context8) {
                        while (1) {
                            switch (_context8.prev = _context8.next) {
                                case 0:
                                    _context8.next = 2;
                                    return _this11.$store.dispatch('webadmin/orderDetailsTotalSale/changeFilterOption', { 'prop': 'page', value: newValue });

                                case 2:
                                case 'end':
                                    return _context8.stop();
                            }
                        }
                    }, _callee8, _this11);
                }))();
            }
        },
        perPage: {
            get: function get() {
                return this.filterOptions.perPage;
            },
            set: function set(newValue) {
                var _this12 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee9() {
                    return _regenerator2.default.wrap(function _callee9$(_context9) {
                        while (1) {
                            switch (_context9.prev = _context9.next) {
                                case 0:
                                    _context9.next = 2;
                                    return _this12.$store.dispatch('webadmin/orderDetailsTotalSale/changeFilterOption', { 'prop': 'perPage', value: newValue });

                                case 2:
                                case 'end':
                                    return _context9.stop();
                            }
                        }
                    }, _callee9, _this12);
                }))();
            }
        }
    }),
    methods: (0, _extends3.default)({
        updateFilterOption: function updateFilterOption(field) {
            var _this13 = this;

            return function (value) {
                return _this13.changeFilterOption({
                    prop: field,
                    value: value
                });
            };
        },
        checkMode: function checkMode(mode) {
            return this.viewMode === mode;
        }
    }, (0, _vuex.mapActions)('webadmin/configure', ['configuredRun', 'fetchStudioList', 'fetchBranchList']), (0, _vuex.mapActions)('webadmin/orderDetailsTotalSale', ['submit', 'toggleBlock', 'changeDateOption', 'changeFilterOption', 'cleanBranch', 'cleanBranchRelated', 'changeItemOption', 'setDetailTarget', 'initPayment', 'getItemTypes', 'getItems', 'initSalesmen']), {
        getSalsemanVisible: function getSalsemanVisible(studioId) {
            var _this14 = this;

            this.$http.post('/adminapi/layout-setting/salesperson-visible/get', { 'studio_id': studioId }).then(function (response) {
                _this14.salsemanVisible = response.data.result;
            });
        },
        appendRemarkFilter: function appendRemarkFilter() {
            var pattern = /{|,|"|'|\/|\\|}/g;
            var str = this.orderRemark.replace(pattern, "");
            this.$store.dispatch('webadmin/orderDetailsTotalSale/changeFilterOption', { 'prop': 'orderRemark', value: str });
        },
        changePage: function changePage() {
            this.appendRemarkFilter();
            var query = $17.getUrlQueryStrings();
            this.page = query.hasOwnProperty('page') ? query.page : 1;
            this.submit();
        },
        firstPage: function firstPage() {
            this.appendRemarkFilter();
            $17.updateUrlQueryString({ page: 1 });
            this.page = 1;
            this.submit();
        }
    }, (0, _vuex.mapMutations)('webadmin/orderDetailsTotalSale', ['CHANGE_DETAILS', 'CHANGE_SUMMARIES', 'CHANGE_TOTAL']))
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"page-div\" _v-7df84bdf=\"\">\n    <v-webadmin-report :block-open-status=\"blockOpenStatus\" :date-options=\"dateOptions\" :toggle-block=\"toggleBlock\" :change-date-option=\"changeDateOption\" :disable-submit=\"ajaxing\" :submit=\"firstPage\" limit-date=\"92\" title=\"銷售總覽\" _v-7df84bdf=\"\">\n        <div slot=\"second-block\" _v-7df84bdf=\"\">\n            <div class=\"row st-flex st-flex-wrap\" _v-7df84bdf=\"\">\n                <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen\" _v-7df84bdf=\"\">\n                    <div class=\"form-group\" _v-7df84bdf=\"\">\n                        <v-mutiselect :model.sync=\"studioId\" :options=\"studioList\" :preserve-search=\"true\" :placeholder=\"configureStates.ajaxing.studioList ? '品牌讀取中…' : '請選擇品牌'\" label=\"brand_name\" track-by=\"id\" _v-7df84bdf=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n                <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen || configureStates.isStudio\" _v-7df84bdf=\"\">\n                    <div class=\"form-group\" _v-7df84bdf=\"\">\n                        <v-mutiselect :model.sync=\"branchIds\" :options=\"branchList\" :disabled=\"configureStates.ajaxing.branchList\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"false\" :placeholder=\"configureStates.ajaxing.branchList ? '場館讀取中…' : '全部場館'\" label=\"branch_name\" track-by=\"id\" :taggable=\"true\" tag-name=\"branch_name\" :max-height=\"500\" _v-7df84bdf=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n                <div class=\"col-sm-6\" _v-7df84bdf=\"\">\n                    <div class=\"form-group\" _v-7df84bdf=\"\">\n                        <v-mutiselect :model.sync=\"moneyStatuses\" :options=\"moneyStatusShow\" :preserve-search=\"true\" :searchable=\"false\" :placeholder=\"'包含收入及退費'\" label=\"name\" track-by=\"status\" tag-name=\"name\" _v-7df84bdf=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n                <div class=\"col-sm-6\" _v-7df84bdf=\"\">\n                    <div class=\"form-group\" _v-7df84bdf=\"\">\n                        <v-mutiselect :model.sync=\"selectedPayment\" :options=\"payments\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"true\" :placeholder=\"paymentAjaxing ? '交易方式讀取中…' : '全部交易方式'\" label=\"payment_name\" track-by=\"studio_payment_method_id\" tag-name=\"payment_name\" _v-7df84bdf=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n                <div class=\"col-sm-6\" _v-7df84bdf=\"\">\n                    <div class=\"form-group\" _v-7df84bdf=\"\">\n                        <v-mutiselect :model.sync=\"selectedSalesmen\" :options=\"salesmen\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"true\" :placeholder=\"salesmenAjaxing ? '業務代表讀取中…' : '全部業務代表'\" label=\"name\" track-by=\"id\" :max-height=\"500\" tag-name=\"name\" _v-7df84bdf=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n                <div v-if=\"filterOptions.studioId !== null &amp;&amp; filterOptions.studioId.id !== 0\" class=\"col-sm-6\" _v-7df84bdf=\"\">\n                    <div class=\"form-group\" _v-7df84bdf=\"\">\n                        <st-input _v-7df84bdf=\"\">\n                            <template slot=\"input\" slot-scope=\"{ inputClass }\">\n                                <select :class=\"inputClass\" v-model=\"selectedItemType\" _v-7df84bdf=\"\">\n                                    <option value=\"all\" _v-7df84bdf=\"\">全部項目類型</option>\n                                    <option :value=\"itemType.id\" :key=\"itemType.id\" v-for=\"itemType in item_types\" _v-7df84bdf=\"\">{{ itemType.name }}</option>\n                                </select>\n                            </template>\n                        </st-input>\n                    </div>\n                </div>\n                <div v-if=\"selectedItemType !== 'schedules' &amp;&amp; selectedItemType !== 'services' &amp;&amp; selectedItemType !== 'all' &amp;&amp; filterOptions.studioId.id !== 0\" class=\"col-sm-6\" _v-7df84bdf=\"\">\n                    <div class=\"form-group\" _v-7df84bdf=\"\">\n                        <v-mutiselect :model.sync=\"selectedItem\" :options=\"items\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"true\" :placeholder=\"itemAjaxing ? '項目讀取中…' : '全部' + item_type_name\" label=\"name\" track-by=\"id\" tag-name=\"name\" _v-7df84bdf=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n                <div class=\"col-sm-6\" _v-7df84bdf=\"\">\n                    <div class=\"form-group\" _v-7df84bdf=\"\">\n                        <st-input type=\"text\" placeholder=\"搜尋訂單備註\" v-model=\"orderRemark\" _v-7df84bdf=\"\"></st-input>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div slot=\"third-block\" _v-7df84bdf=\"\">\n            <div class=\"row\" _v-7df84bdf=\"\">\n                <div class=\"col-sm-6\" _v-7df84bdf=\"\">\n                    <div class=\"form-group\" _v-7df84bdf=\"\">\n                        <label _v-7df84bdf=\"\">\n                            <input name=\"view\" type=\"radio\" value=\"detail\" v-model=\"viewMode\" checked=\"\" _v-7df84bdf=\"\"> 顯示細節\n                        </label>\n                        <label _v-7df84bdf=\"\">\n                            <input name=\"view\" type=\"radio\" value=\"summary\" v-model=\"viewMode\" _v-7df84bdf=\"\"> 顯示總和\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div slot=\"fourth-block\" _v-7df84bdf=\"\">\n            <div class=\"row\" _v-7df84bdf=\"\">\n                <div class=\"col-sm-6\" _v-7df84bdf=\"\">\n                    <div class=\"form-group row\" _v-7df84bdf=\"\">\n                        <label _v-7df84bdf=\"\">\n                            <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"show\" checked=\"\" _v-7df84bdf=\"\"> 顯示於網頁\n                        </label>\n                        <label _v-7df84bdf=\"\">\n                            <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"export\" _v-7df84bdf=\"\"> 匯出 CSV\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </v-webadmin-report>\n    <div v-show=\"display==='show'\" _v-7df84bdf=\"\">\n        <div class=\"table-div\" _v-7df84bdf=\"\">\n            <webadmin-sale-report-detail-result v-if=\"checkMode('detail')\" ref=\"detailTable\" :ajaxing=\"ajaxing\" :list=\"details\" :salseman-visible=\"salsemanVisible\" :change-page=\"changePage\" _v-7df84bdf=\"\">\n            </webadmin-sale-report-detail-result>\n            <webadmin-sale-report-summary-result v-if=\"checkMode('summary')\" ref=\"summaryTable\" :ajaxing=\"ajaxing\" :list=\"summaries\" :show-income=\"true\" :show-refund=\"true\" _v-7df84bdf=\"\">\n            </webadmin-sale-report-summary-result>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.page-div[_v-7df84bdf] {\n  padding: 0px 15px;\n  margin-bottom: 15px; }\n\n/* line 7, stdin */\n.m-l-15[_v-7df84bdf] {\n  margin-left: 15px; }\n\n/* line 11, stdin */\n.table-div[_v-7df84bdf] {\n  padding: 20px 0px; }\n\n/* line 15, stdin */\n.form-title[_v-7df84bdf] {\n  font-size: 16px;\n  font-weight: bold;\n  display: inline-block;\n  width: 60px; }\n\n/* line 22, stdin */\n.negative-number[_v-7df84bdf] {\n  color: red; }\n\n/* line 26, stdin */\n.cube[_v-7df84bdf] {\n  max-width: 80px;\n  float: left;\n  margin: 12px 24px;\n  font-weight: bold;\n  font-size: 18px; }\n\n/* line 33, stdin */\n.total-list[_v-7df84bdf] {\n  width: 100%;\n  border: 1px solid;\n  margin: 30px 0px; }\n\n/* line 38, stdin */\n.total-list[_v-7df84bdf]:after {\n  clear: both; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-7df84bdf", module.exports)
  } else {
    hotAPI.update("_v-7df84bdf", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/defineProperty":65,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1370:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n/* line 2, stdin */\nh4[_v-d5dd6dfc] {\n  display: inline;\n  padding-right: 30px; }\n\n/* line 6, stdin */\n.page-div[_v-d5dd6dfc] {\n  padding: 0 15px;\n  margin-bottom: 15px; }\n\n/* line 11, stdin */\n.m-l-15[_v-d5dd6dfc] {\n  margin-left: 15px; }\n\n/* line 15, stdin */\n.table-div[_v-d5dd6dfc] {\n  padding: 20px 0; }\n\n/* line 19, stdin */\n.total-list[_v-d5dd6dfc] {\n  margin: 15px 0 0 0; }\n\n/* line 23, stdin */\n.total-list[_v-d5dd6dfc]:after {\n  clear: both; }\n\n/* line 27, stdin */\n.table-striped thead[_v-d5dd6dfc] {\n  border-bottom: 1px solid #000; }\n\n/* line 31, stdin */\n.multiselect[_v-d5dd6dfc] {\n  padding-bottom: 5px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _watch;

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    mounted: function mounted() {
        var _this = this;

        this.configuredRun(function () {
            _this.changeFilterOption({
                prop: 'studioId',
                value: {
                    id: _this.configureStates.studioId,
                    brand_name: ''
                }
            });
            _this.changeFilterOption({
                prop: 'branchId',
                value: _this.configureStates.branchId
            });
            if (_this.configureStates.isSeventeen) {
                return _this.fetchStudioList();
            }
            if (_this.configureStates.isBranch) {
                _this.branchIds = [{
                    'id': _this.configureStates.branchId,
                    'branch_name': ''
                }];
            }
        });
        this.changeDateOption({
            prop: 'startDate',
            value: moment().format('YYYY/MM/DD')
        });
        this.changeDateOption({
            prop: 'endDate',
            value: moment().format('YYYY/MM/DD')
        });
    },

    watch: (_watch = {}, (0, _defineProperty3.default)(_watch, 'filterOptions.studioId', function filterOptionsStudioId(n, o) {
        if (this.configureStates.isSeventeen || this.configureStates.isStudio) {
            this.fetchBranchList({
                studioId: n.id
            });
        }
        this.initStaff();
    }), (0, _defineProperty3.default)(_watch, 'dateOptions.startDate', function dateOptionsStartDate(n, o) {
        this.initStaff();
    }), (0, _defineProperty3.default)(_watch, 'dateOptions.endDate', function dateOptionsEndDate(n, o) {
        this.initStaff();
    }), _watch),
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        configureStates: function configureStates(state) {
            return state.webadmin.configure;
        }
    }), (0, _vuex.mapState)('webadmin/configure', ['configured', 'studioList', 'branchList', 'branchId']), (0, _vuex.mapState)('webadmin/orderInvoiceList', ['blockOpenStatus', 'dateOptions', 'filterOptions', 'ajaxing', 'list', 'order_total', 'invoice_total']), {
        studioId: {
            get: function get() {
                return this.filterOptions.studioId;
            },
            set: function set(newValue) {
                var _this2 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                    return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.next = 2;
                                    return _this2.changeFilterOption({ 'prop': 'studioId', value: newValue });

                                case 2:
                                    _this2.cleanBranch();

                                    if (!newValue) {
                                        _context.next = 6;
                                        break;
                                    }

                                    _context.next = 6;
                                    return _this2.fetchBranchList({ studioId: newValue.id });

                                case 6:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this2);
                }))();
            }
        },
        branchIds: {
            get: function get() {
                return this.filterOptions.branchIds;
            },
            set: function set(newValue) {
                var _this3 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                    return _regenerator2.default.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    _context2.next = 2;
                                    return _this3.changeFilterOption({ 'prop': 'branchIds', value: newValue });

                                case 2:
                                case 'end':
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, _this3);
                }))();
            }
        }
    }),
    methods: (0, _extends3.default)({
        updateFilterOption: function updateFilterOption(field) {
            var _this4 = this;

            return function (value) {
                return _this4.changeFilterOption({
                    prop: field,
                    value: value
                });
            };
        },
        thousandthFormat: function thousandthFormat(money) {
            return $17.thousandthFormat(money);
        }
    }, (0, _vuex.mapActions)('webadmin/configure', ['configuredRun', 'fetchStudioList', 'fetchBranchList', 'pushObjectStatus']), (0, _vuex.mapActions)('webadmin/orderInvoiceList', ['submitIssue', 'toggleBlock', 'changeDateOption', 'changeFilterOption', 'changeItemOption', 'cleanBranch', 'cleanBranchRelated', 'initStaff']))
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"page-div\" _v-d5dd6dfc=\"\">\n    <v-webadmin-report :block-open-status=\"blockOpenStatus\" :date-options=\"dateOptions\" :toggle-block=\"toggleBlock\" :change-date-option=\"changeDateOption\" :disable-submit=\"ajaxing\" :submit=\"submitIssue\" limit-date=\"90\" title=\"發票開立報表\" _v-d5dd6dfc=\"\"> \n        <div slot=\"second-block\" _v-d5dd6dfc=\"\">\n            <div class=\"filters\" _v-d5dd6dfc=\"\">\n                <div class=\"row\" _v-d5dd6dfc=\"\">\n                    <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen\" _v-d5dd6dfc=\"\">\n                        <div class=\"form-group\" _v-d5dd6dfc=\"\">\n                            <v-mutiselect :model.sync=\"studioId\" :options=\"studioList\" :preserve-search=\"true\" :placeholder=\"configureStates.ajaxing.studioList ? '品牌讀取中…' : '請選擇品牌'\" label=\"brand_name\" track-by=\"id\" _v-d5dd6dfc=\"\">\n                            </v-mutiselect>\n                        </div>\n                    </div>\n                    <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen || configureStates.isStudio\" _v-d5dd6dfc=\"\">\n                        <div class=\"form-group\" _v-d5dd6dfc=\"\">\n                            <v-mutiselect :model.sync=\"branchIds\" :options=\"branchList\" :disabled=\"configureStates.ajaxing.branchList\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"false\" :placeholder=\"configureStates.ajaxing.branchList ? '場館讀取中…' : '全部場館'\" label=\"branch_name\" track-by=\"id\" :taggable=\"true\" tag-name=\"branch_name\" :max-height=\"500\" _v-d5dd6dfc=\"\">\n                            </v-mutiselect>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </v-webadmin-report>\n    <div class=\"row total-list\" v-if=\"list.length>0\" _v-d5dd6dfc=\"\">\n        <div class=\"col-sm-6\" _v-d5dd6dfc=\"\">\n            <h4 _v-d5dd6dfc=\"\">總銷售金額:{{order_total}}</h4>\n            <h4 _v-d5dd6dfc=\"\">總開立金額:{{invoice_total}}</h4>\n        </div>\n    </div>\n    <div class=\"table-div\" _v-d5dd6dfc=\"\">\n        <v-table :ajaxing=\"ajaxing\" :length=\"list.length\" _v-d5dd6dfc=\"\">\n            <table class=\"table table-striped\" _v-d5dd6dfc=\"\">\n                <thead _v-d5dd6dfc=\"\">\n                <tr _v-d5dd6dfc=\"\">\n                    <td _v-d5dd6dfc=\"\">發票開立日期</td>\n                    <td _v-d5dd6dfc=\"\">訂單結帳日期</td>\n                    <td _v-d5dd6dfc=\"\">訂單編號</td>\n                    <td _v-d5dd6dfc=\"\">訂單金額</td>\n                    <td _v-d5dd6dfc=\"\">發票開立金額</td>\n                    <td _v-d5dd6dfc=\"\">發票號碼</td>\n                    <td _v-d5dd6dfc=\"\">發票開立類型</td>\n                    <td _v-d5dd6dfc=\"\">載具號碼</td>\n                </tr>\n                </thead>\n                <tbody _v-d5dd6dfc=\"\">\n                <tr v-for=\"item in list\" _v-d5dd6dfc=\"\">\n                    <td _v-d5dd6dfc=\"\">{{ item.invoice_issue_at }}</td>\n                    <td _v-d5dd6dfc=\"\">{{ item.checkout_at }}</td>\n                    <td _v-d5dd6dfc=\"\">{{ item.order_id }}</td>\n                    <td _v-d5dd6dfc=\"\">{{ item.order_total }}</td>\n                    <td _v-d5dd6dfc=\"\">{{ item.invoice_total }}</td>\n                    <td _v-d5dd6dfc=\"\">{{ item.invoice_number }}</td>\n                    <td _v-d5dd6dfc=\"\">{{ item.invoice_method }}</td>\n                    <td _v-d5dd6dfc=\"\">{{ item.invoice_carrier_num }}</td>\n                </tr>\n                </tbody>\n            </table>\n        </v-table>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n/* line 2, stdin */\nh4[_v-d5dd6dfc] {\n  display: inline;\n  padding-right: 30px; }\n\n/* line 6, stdin */\n.page-div[_v-d5dd6dfc] {\n  padding: 0 15px;\n  margin-bottom: 15px; }\n\n/* line 11, stdin */\n.m-l-15[_v-d5dd6dfc] {\n  margin-left: 15px; }\n\n/* line 15, stdin */\n.table-div[_v-d5dd6dfc] {\n  padding: 20px 0; }\n\n/* line 19, stdin */\n.total-list[_v-d5dd6dfc] {\n  margin: 15px 0 0 0; }\n\n/* line 23, stdin */\n.total-list[_v-d5dd6dfc]:after {\n  clear: both; }\n\n/* line 27, stdin */\n.table-striped thead[_v-d5dd6dfc] {\n  border-bottom: 1px solid #000; }\n\n/* line 31, stdin */\n.multiselect[_v-d5dd6dfc] {\n  padding-bottom: 5px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-d5dd6dfc", module.exports)
  } else {
    hotAPI.update("_v-d5dd6dfc", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/defineProperty":65,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1371:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _watch;

var _vuex = require('vuex');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            display: 'show',
            list: [],
            listKey: [],
            listTitle: {}
        };
    },
    mounted: function mounted() {
        var _this = this;

        this.configuredRun(function () {
            _this.changeFilterOption({
                prop: 'studioId',
                value: {
                    id: _this.configureStates.studioId,
                    brand_name: ''
                }
            });
            _this.changeFilterOption({
                prop: 'branchId',
                value: _this.configureStates.branchId
            });
            if (_this.configureStates.isSeventeen) {
                return _this.fetchStudioList();
            }
            if (_this.configureStates.isBranch) {
                _this.branchIds = {
                    'id': _this.configureStates.branchId,
                    'branch_name': ''
                };
            }
        });

        this.changeDateOption({
            prop: 'startDate',
            value: moment().add(-1, 'days').format('YYYY/MM/DD')
        });

        this.changeDateOption({
            prop: 'endDate',
            value: moment().add(-1, 'days').format('YYYY/MM/DD')
        });
    },

    watch: (_watch = {}, (0, _defineProperty3.default)(_watch, 'filterOptions.studioId', function filterOptionsStudioId(n, o) {
        if (this.configureStates.isSeventeen || this.configureStates.isStudio) {
            this.fetchBranchList({
                studioId: n.id
            });
        }
    }), (0, _defineProperty3.default)(_watch, 'list', function list(newValue, oldValue) {
        var _this2 = this;

        if (newValue.length > 0 && this.display === 'export') {
            this.csvDataHandler({ data: newValue, columnFormater: this.columnFormatter }).then(function (results) {
                _this2.download({ csvString: results, name: 'change_record' });
            });
        }
    }), _watch),
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        configureStates: function configureStates(state) {
            return state.webadmin.configure;
        }
    }), (0, _vuex.mapState)('webadmin/configure', ['configured', 'studioList', 'branchList', 'branchId', 'isBranch', 'isStudio', 'isSeventeen']), (0, _vuex.mapState)('webadmin/baseReport', ['blockOpenStatus', 'dateOptions', 'filterOptions']), {
        studioId: {
            get: function get() {
                return this.filterOptions.studioId;
            },
            set: function set(newValue) {
                var _this3 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                    return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.next = 2;
                                    return _this3.changeFilterOption({ 'prop': 'studioId', value: newValue });

                                case 2:
                                    _this3.cleanBranch();

                                    if (!newValue) {
                                        _context.next = 7;
                                        break;
                                    }

                                    _context.next = 6;
                                    return _this3.fetchBranchList({ studioId: newValue.id });

                                case 6:
                                    if (_this3.isSeventeen) {
                                        _this3.getStaff(newValue, 0);
                                    }

                                case 7:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this3);
                }))();
            }
        },
        branchIds: {
            get: function get() {
                return this.filterOptions.branchIds;
            },
            set: function set(newValue) {
                var _this4 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                    return _regenerator2.default.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    _context2.next = 2;
                                    return _this4.changeFilterOption({ 'prop': 'branchIds', value: newValue });

                                case 2:
                                case 'end':
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, _this4);
                }))();
            }
        },
        ajaxing: {
            get: function get() {
                return this.$store.state.webadmin.baseReport.ajaxing;
            },
            set: function set(newValue) {
                var _this5 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
                    return _regenerator2.default.wrap(function _callee3$(_context3) {
                        while (1) {
                            switch (_context3.prev = _context3.next) {
                                case 0:
                                    _context3.next = 2;
                                    return _this5.changeAjaxing(newValue);

                                case 2:
                                case 'end':
                                    return _context3.stop();
                            }
                        }
                    }, _callee3, _this5);
                }))();
            }
        },
        viewMode: {
            get: function get() {
                return this.$store.state.webadmin.baseReport.itemOptions.viewMode;
            },
            set: function set(value) {
                this.changeItemOption({
                    prop: 'viewMode',
                    value: value
                });
            }
        }
    }),
    methods: (0, _extends3.default)({
        checkMode: function checkMode(mode) {
            return this.viewMode === mode;
        }
    }, (0, _vuex.mapActions)('webadmin/configure', ['configuredRun', 'fetchStudioList', 'fetchBranchList', 'fetchContractList']), (0, _vuex.mapActions)('webadmin/baseReport', ['beforeSubmit', 'toggleBlock', 'changeDateOption', 'changeFilterOption', 'cleanBranch', 'cleanBranchRelated', 'changeItemOption', 'setDetailTarget', 'download', 'csvDataHandler', 'columnFormater', "changeAjaxing"]), {
        submit: function submit() {
            this.beforeSubmit();
            this.getResult();
        },
        getResult: function getResult() {
            var _this6 = this;

            var data = {
                'studio_id': this.studioId.id,
                'branch_id': this.branchIds.id,
                'start_date': this.dateOptions.startDate,
                'end_date': this.dateOptions.endDate
            };
            var params = $.param(data);
            this.ajaxing = true;
            this.$http.get('/adminapi/report/fetch_payment_change_record_report?' + params).then(function (response) {
                _this6.ajaxing = false;
                _this6.list = response.body.list;
                _this6.listKey = response.body.key;
                _this6.listTitle = response.body.title;
            }, function (error) {
                _this6.ajaxing = false;
            });
        },
        columnFormatter: function columnFormatter(d) {
            var data = JSON.parse((0, _stringify2.default)(d));
            data = (0, _stringify2.default)(data);
            data = data.replaceAll('order_id', '訂單編號');
            data = data.replaceAll('origin_paid_money', '金額');
            data = data.replaceAll('origin_payment_method', '原結帳方式');
            data = data.replaceAll('changed_payment_method_id', '更改後結帳方式');
            data = data.replaceAll('checkout_member', '結帳人員');
            data = data.replaceAll('change_member', '更改人員');
            data = data.replaceAll('checkout_time', '結帳時間');
            data = data.replaceAll('edit_time', '更改時間');
            return data;
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"page-div\" _v-0ba5146e=\"\">\n    <v-webadmin-report :block-open-status=\"blockOpenStatus\" :date-options=\"dateOptions\" :toggle-block=\"toggleBlock\" :change-date-option=\"changeDateOption\" :disable-submit=\"ajaxing\" :submit=\"submit\" limit-date=\"365\" title=\"支付方式異動紀錄\" _v-0ba5146e=\"\">\n        <div slot=\"second-block\" _v-0ba5146e=\"\">\n            <div class=\"row\" _v-0ba5146e=\"\">\n                <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen\" _v-0ba5146e=\"\">\n                    <div class=\"form-group\" _v-0ba5146e=\"\">\n                        <v-mutiselect :model.sync=\"studioId\" :options=\"studioList\" :preserve-search=\"true\" :placeholder=\"configureStates.ajaxing.studioList ? '品牌讀取中…' : '請選擇品牌'\" label=\"brand_name\" track-by=\"id\" _v-0ba5146e=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n            </div>\n            <div class=\"row\" _v-0ba5146e=\"\">\n                <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen || configureStates.isStudio\" _v-0ba5146e=\"\">\n                    <div class=\"form-group\" _v-0ba5146e=\"\">\n                        <v-mutiselect :model.sync=\"branchIds\" :options=\"branchList\" :disabled=\"configureStates.ajaxing.branchList\" :multiple=\"false\" :close-on-select=\"true\" :clear-on-select=\"false\" :hide-selected=\"false\" :preserve-search=\"false\" :searchable=\"false\" :placeholder=\"configureStates.ajaxing.branchList ? '場館讀取中…' : '全部場館'\" label=\"branch_name\" track-by=\"id\" :taggable=\"true\" tag-name=\"branch_name\" :max-height=\"500\" _v-0ba5146e=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div slot=\"fourth-block\" _v-0ba5146e=\"\">\n            <div class=\"row\" _v-0ba5146e=\"\">\n                <div class=\"col-sm-6\" _v-0ba5146e=\"\">\n                    <div class=\"form-group row\" _v-0ba5146e=\"\">\n                        <label _v-0ba5146e=\"\">\n                            <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"show\" checked=\"\" _v-0ba5146e=\"\"> 顯示於網頁\n                        </label>\n                        <label _v-0ba5146e=\"\">\n                            <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"export\" _v-0ba5146e=\"\"> 匯出 CSV\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </v-webadmin-report>\n    <div _v-0ba5146e=\"\">\n        <v-webadmin-report-list :list=\"list\" :list-key=\"listKey\" :list-title=\"listTitle\" :ajaxing=\"ajaxing\" _v-0ba5146e=\"\"></v-webadmin-report-list>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-0ba5146e", module.exports)
  } else {
    hotAPI.update("_v-0ba5146e", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/json/stringify":48,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/defineProperty":65,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vuex":803}],1372:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.page-div[_v-1e5c7fbd] {\n  padding: 0px 15px;\n  margin-bottom: 15px; }\n\n/* line 7, stdin */\n.table-div[_v-1e5c7fbd] {\n  padding: 20px 0px; }\n\n/* line 10, stdin */\n.total-list[_v-1e5c7fbd] {\n  margin-left: 10px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _values = require('babel-runtime/core-js/object/values');

var _values2 = _interopRequireDefault(_values);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _vuex = require('vuex');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            display: 'show',
            result: {},
            export: {},
            status: null,
            stateList: [],
            tableSeventeenConfig: {
                columns: [{ keys: "studio_name", head: "品牌" }, { keys: "branch_name", head: "場館" }, { keys: "order_id",
                    head: "訂單編號",
                    colClick: true,
                    html: function html(item) {
                        return '\n                            <a @click.prevent.stop="clickHandler(\'open-order\', $event)">' + item.order_id + '</i></a>';
                    }
                }, { keys: "id",
                    head: "動作",
                    colClick: true,
                    html: function html(item) {
                        if (item.status == 5) {
                            return '';
                        }
                        return '\n                            <a @click.prevent.stop="clickHandler(\'request-action\', $event)">\u7DE8\u8F2F</i></a>';
                    }
                }, { keys: "created_at", head: "退費申請時間" }, { keys: "updated_at", head: "最後更新時間" }, { keys: "order_total", head: "訂單交易金額" }, { keys: "refund_item", head: "申請退費項目" }, { keys: "refund_reason", head: "退費原因" }, { keys: "refund_order_id", head: "退費訂單編號" }, { keys: "status_name", head: "退費狀態" }, { keys: "remark", head: "處理備註" }, { keys: "last_update_actor_name", head: "最後更新人員" }]
            },
            csvSeventeenConfig: {
                column: [{ keys: "studio_name", name: "品牌" }, { keys: "branch_name", name: "場館" }, { keys: "order_id", name: "訂單編號" }, { keys: "created_at", name: "退費申請時間" }, { keys: "updated_at", name: "最後更新時間" }, { keys: "order_total", name: "訂單交易金額" }, { keys: "refund_item", name: "申請退費項目" }, { keys: "refund_reason", name: "退費原因" }, { keys: "refund_order_id", name: "退費訂單編號" }, { keys: "status_name", name: "退費狀態" }, { keys: "remark", name: "處理備註" }, { keys: "last_update_actor_name", name: "最後更新人員" }],
                fileName: 'refund-req-' + moment().format('YYYYMMDDHHmmss') + '.csv '
            },
            tableNormalConfig: {
                columns: [{ keys: "branch_name", head: "場館" }, { keys: "order_id",
                    head: "訂單編號",
                    colClick: true,
                    html: function html(item) {
                        return '\n                            <a @click.prevent.stop="clickHandler(\'open-order\', $event)">' + item.order_id + '</i></a>';
                    }
                }, { keys: "created_at", head: "退費申請時間" }, { keys: "updated_at", head: "最後更新時間" }, { keys: "order_total", head: "訂單交易金額" }, { keys: "refund_item", head: "申請退費項目" }, { keys: "refund_reason", head: "退費原因" }, { keys: "refund_order_id", head: "退費訂單編號" }, { keys: "status_name", head: "退費狀態" }, { keys: "remark", head: "處理備註" }, { keys: "id",
                    head: "",
                    colClick: true,
                    html: function html(item) {
                        if (item.status != 1) {
                            return '';
                        }
                        return '\n                            <a @click.prevent.stop="clickHandler(\'request-cancel-action\', $event)">\u53D6\u6D88\u7533\u8ACB</i></a>';
                    }
                }]
            },
            csvNormalConfig: {
                column: [{ keys: "branch_name", name: "場館" }, { keys: "order_id", name: "訂單編號" }, { keys: "created_at", name: "退費申請時間" }, { keys: "updated_at", name: "最後更新時間" }, { keys: "order_total", name: "訂單交易金額" }, { keys: "refund_item", name: "申請退費項目" }, { keys: "refund_reason", name: "退費原因" }, { keys: "refund_order_id", name: "退費訂單編號" }, { keys: "status_name", name: "退費狀態" }, { keys: "remark", name: "處理備註" }],
                fileName: 'refund-req-' + moment().format('YYYYMMDDHHmmss') + '.csv '
            },
            relatedFilterWatcher: {
                studio_id: {
                    watcher: null,
                    options: "studioList",
                    vModel: "studioId",
                    trackBy: "id",
                    type: "single"
                },
                branch_ids: {
                    watcher: "studioId",
                    options: "branchList",
                    vModel: "branchIds",
                    trackBy: "id",
                    type: "multiple"
                },
                status: {
                    watcher: null,
                    options: "stateList",
                    vModel: "status",
                    trackBy: "key",
                    type: "single"
                }
            },
            orderId: '',
            requestId: null,
            eventSlotData: {
                refund: {}
            }
        };
    },
    created: function created() {
        this.syncRelatedMultipleSelectByQuery({ vm: this, relatedFilterWatcher: this.relatedFilterWatcher });
    },
    mounted: function mounted() {
        var _this = this;

        this.getRequest();
        this.configuredRun(function () {
            _this.changeFilterOption({
                prop: 'studioId',
                value: {
                    id: _this.configureStates.studioId,
                    brand_name: ''
                }
            });
            _this.changeFilterOption({
                prop: 'branchId',
                value: _this.configureStates.branchId
            });
            if (_this.configureStates.isSeventeen) {
                return _this.fetchStudioList();
            }
            if (_this.configureStates.isBranch) {
                _this.branchIds = [{
                    'id': _this.configureStates.branchId,
                    'branch_name': ''
                }];
            }
        });
        this.syncDateAndDisplayByQuery({
            'diffType': 'months',
            'diffNumber': -1
        });
        var query = $17.getUrlQueryStrings();
        this.viewMode = query.view_mode ? query.view_mode : 'detail';
        this.orderId = query.order_id ? query.order_id : '';
        Vue.nextTick(function () {
            if (_this.orderId != '') {
                _this.submitSearch();
            }
        });
    },

    watch: (0, _defineProperty3.default)({}, 'filterOptions.studioId', function filterOptionsStudioId(n, o) {
        if (n == null) {
            return;
        }
        if (this.configureStates.isSeventeen || this.configureStates.isStudio) {
            this.fetchBranchList({
                studioId: n.id
            });
        }
    }),
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        configureStates: function configureStates(state) {
            return state.webadmin.configure;
        }
    }), (0, _vuex.mapState)('webadmin/configure', ['configured', 'studioList', 'branchList', 'branchId', 'contractList']), (0, _vuex.mapState)('webadmin/baseReport', ['blockOpenStatus', 'dateOptions', 'filterOptions', "ajaxing"]), {

        studioId: {
            get: function get() {
                return this.filterOptions.studioId;
            },
            set: function set(newValue) {
                var _this2 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                    return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.next = 2;
                                    return _this2.changeFilterOption({ 'prop': 'studioId', value: newValue });

                                case 2:
                                    _this2.cleanBranch();

                                    if (!newValue) {
                                        _context.next = 6;
                                        break;
                                    }

                                    _context.next = 6;
                                    return _this2.fetchBranchList({ studioId: newValue.id });

                                case 6:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this2);
                }))();
            }
        },
        branchIds: {
            get: function get() {
                return this.filterOptions.branchIds;
            },
            set: function set(newValue) {
                var _this3 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                    return _regenerator2.default.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    _context2.next = 2;
                                    return _this3.changeFilterOption({ 'prop': 'branchIds', value: newValue });

                                case 2:
                                case 'end':
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, _this3);
                }))();
            }
        },
        viewMode: {
            get: function get() {
                return this.$store.state.webadmin.baseReport.itemOptions.viewMode;
            },
            set: function set(value) {
                this.changeItemOption({
                    prop: 'viewMode',
                    value: value
                });
            }
        },
        tableConfig: function tableConfig() {
            if (this.configureStates.isSeventeen) {
                return this.tableSeventeenConfig;
            } else {
                return this.tableNormalConfig;
            }
        },
        csvConfig: function csvConfig() {
            if (this.configureStates.isSeventeen) {
                return this.csvSeventeenConfig;
            } else {
                return this.csvNormalConfig;
            }
        },

        selectOrderId: function selectOrderId() {
            return store.state.pos.order_id;
        },
        alertObj: function alertObj() {
            return Array.isArray(store.state.pos.alert_obj) ? store.state.pos.alert_obj : (0, _values2.default)(store.state.pos.alert_obj);
        }
    }),
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('webadmin/configure', ['configuredRun', 'fetchStudioList', 'fetchBranchList']), (0, _vuex.mapActions)('webadmin/baseReport', ['beforeSubmit', 'toggleBlock', 'changeDateOption', 'changeFilterOption', 'cleanBranch', 'cleanBranchRelated', 'changeItemOption', 'setDetailTarget', 'keepQueryParam', "changeAjaxing", "syncDateAndDisplayByQuery", "syncLocalMultipleSelectByQuery", "syncRelatedMultipleSelectByQuery", "changeDisplay"]), {
        submitSearch: function submitSearch() {
            this.beforeSubmit();
            switch (this.display) {
                case "export":
                    this.changeFilterOption({ prop: "pageSize", value: 9999999 });
                    break;
                case "show":
                    this.changeFilterOption({ prop: "pageSize", value: 25 });
                    break;
                default:
                    null;
            }
            var params = this.getParams();

            this.keepQueryParam(params);
            $17.updateUrlQueryString(params);

            this.changePage(1);
        },
        getDetailResult: function getDetailResult(params) {
            var _this4 = this;

            this.changeAjaxing(true);
            this.$http.get('/adminapi/order-refund-request/list', { params: params }).then(function (response) {
                if (_this4.display === 'export') {
                    _this4.csvConfig.jsonData = _lodash2.default.cloneDeep(response.data.records);
                    _this4.$refs.smart_table_detail.downloadCsv();
                } else {
                    _this4.result = response.data;
                }
                _this4.changeAjaxing(false);
            }, function (error) {
                _this4.changeAjaxing(false);
                $17.swal({
                    title: error.body.message,
                    type: 'warning'
                });
            });
        },
        getParams: function getParams() {
            return {
                'studio_id': this.studioId != null ? this.studioId.id : null,
                'branch_ids': this.branchIds.map(function (item) {
                    return item.id;
                }),
                'start_date': this.dateOptions.startDate,
                'end_date': this.dateOptions.endDate,
                'status': this.status != null ? this.status.key : null,
                'order_id': this.orderId,
                'view_mode': this.viewMode
            };
        },
        changePage: function changePage(page) {
            var _this5 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
                var params;
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _this5.changeFilterOption({
                                    prop: "page",
                                    value: page
                                });

                                params = _this5.getParams();


                                params.page_size = _this5.filterOptions.pageSize;
                                params.page = _this5.filterOptions.page;

                                _this5.reset();
                                _this5.getDetailResult(params);

                            case 6:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this5);
            }))();
        },
        reset: function reset() {
            this.result = {};
        },
        getRequest: function getRequest() {
            var _this6 = this;

            this.$http.get('/adminapi/order-refund-request/status').then(function (response) {
                _this6.stateList = response.data;
            }, function (error) {
                $17.swal({
                    title: error.body.message,
                    type: 'warning'
                });
            });
        },
        actionOperate: function actionOperate(event) {
            if (event.action == 'open-order') {
                this.openOrder(event.row);
            }
            if (event.action == 'request-action') {
                this.requestId = event.row.id;
            }
            if (event.action == 'request-cancel-action') {
                if (event.row.status != '1') {
                    $17.swal({
                        title: '取消申請失敗',
                        text: '狀態不可變更',
                        type: 'error',
                        showCancelButton: false
                    });

                    return;
                }
                this.updateRequest(event.row.id);
            }
        },
        openOrder: function openOrder(item) {
            var orderId = item.order_id;

            this.openOrCreateOperateOrder({
                'order_id': orderId,
                'mode': 'show',
                'event_type': 'refundRequest'
            });
            this.eventSlotData.refund.reason = item.refund_reason;
            this.eventSlotData.refund.details = item.refund_details;
        },
        resetRequestId: function resetRequestId() {
            this.requestId = null;
        },
        updateRequest: function updateRequest(requestId) {
            var _this7 = this;

            var data = {
                'request_id': requestId,
                'status': 5
            };

            $17.swal({
                title: '確認要取消申請?',
                text: '',
                type: 'warning',
                confirmButtonText: '確認',
                cancelButtonText: '取消'
            }, function (isConfirm) {
                if (isConfirm) {
                    _this7.changePage(1);
                    _this7.$http.post('/adminapi/order-refund-request/update', data).then(function (response) {
                        $17.swal({
                            title: '取消申請成功',
                            text: "",
                            type: 'success',
                            showCancelButton: false
                        });
                    }).catch(function (response) {
                        $17.swal({
                            title: '取消申請失敗',
                            text: response.data.message,
                            type: 'error',
                            showCancelButton: false
                        });
                    });
                };
            });
        },

        refundCallBack: function refundCallBack(response) {
            $('#order-refund').modal('hide');
        },
        openOrCreateOperateOrder: function () {
            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(payload) {
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return window.Event.$emit("System.Pos.Order.Open", payload);

                            case 2:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function openOrCreateOperateOrder(_x) {
                return _ref.apply(this, arguments);
            }

            return openOrCreateOperateOrder;
        }(),
        refundFailCallBack: function refundFailCallBack(response) {
            $('#multi-alert-modal').modal('show');
        },
        refundCancelCallBack: function refundCancelCallBack(response) {
            $('#order-refund').modal('hide');
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n    <div class=\"page-div\" _v-1e5c7fbd=\"\">\n        <v-webadmin-report :block-open-status=\"blockOpenStatus\" :date-options=\"dateOptions\" :toggle-block=\"toggleBlock\" :change-date-option=\"changeDateOption\" :studio-id=\"studioId\" ref=\"report\" :disable-submit=\"ajaxing\" :submit=\"submitSearch\" limit-date=\"90\" title=\"藍新金流 - 申請退刷處理紀錄\" _v-1e5c7fbd=\"\">\n            <div slot=\"second-block\" _v-1e5c7fbd=\"\">\n                <div class=\"row\" _v-1e5c7fbd=\"\">\n                    <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen\" _v-1e5c7fbd=\"\">\n                        <div class=\"form-group\" _v-1e5c7fbd=\"\">\n                            <v-mutiselect :model.sync=\"studioId\" :options=\"studioList\" :preserve-search=\"true\" :placeholder=\"configureStates.ajaxing.studioList ? '品牌讀取中…' : '請選擇品牌'\" label=\"brand_name\" track-by=\"id\" _v-1e5c7fbd=\"\">\n                            </v-mutiselect>\n                        </div>\n                    </div>\n                    <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen || configureStates.isStudio\" _v-1e5c7fbd=\"\">\n                        <div class=\"form-group\" _v-1e5c7fbd=\"\">\n                            <v-mutiselect :model.sync=\"branchIds\" :options=\"branchList\" :disabled=\"configureStates.ajaxing.branchList\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"false\" :placeholder=\"configureStates.ajaxing.branchList ? '場館讀取中…' : '全部場館'\" label=\"branch_name\" track-by=\"id\" :taggable=\"true\" tag-name=\"branch_name\" _v-1e5c7fbd=\"\">\n                            </v-mutiselect>\n                        </div>\n                    </div>\n                    <div class=\"col-sm-6\" _v-1e5c7fbd=\"\">\n                        <div class=\"form-group\" _v-1e5c7fbd=\"\">\n                            <v-mutiselect :model.sync=\"status\" :options=\"stateList\" :multiple=\"false\" :close-on-select=\"true\" :clear-on-select=\"false\" :hide-selected=\"false\" :preserve-search=\"true\" :searchable=\"true\" placeholder=\"退費狀態\" label=\"name\" track-by=\"key\" :taggable=\"false\" tag-name=\"name\" :max-height=\"300\" open-direction=\"bottom\" _v-1e5c7fbd=\"\">\n                            </v-mutiselect>\n                        </div>\n                    </div>\n                    <div class=\"col-sm-6\" _v-1e5c7fbd=\"\">\n                        <div class=\"form-group\" _v-1e5c7fbd=\"\">\n                            <input type=\"text\" placeholder=\"輸入訂單編號\" v-model=\"orderId\" _v-1e5c7fbd=\"\">\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div slot=\"third-block\" _v-1e5c7fbd=\"\">\n                <div class=\"row\" _v-1e5c7fbd=\"\">\n                    <div class=\"col-sm-6\" _v-1e5c7fbd=\"\">\n                        <div class=\"form-group\" _v-1e5c7fbd=\"\">\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div slot=\"fourth-block\" _v-1e5c7fbd=\"\">\n                <div class=\"row\" _v-1e5c7fbd=\"\">\n                    <div class=\"col-sm-6\" _v-1e5c7fbd=\"\">\n                        <div class=\"form-group\" _v-1e5c7fbd=\"\">\n                            <label _v-1e5c7fbd=\"\">\n                                <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"show\" checked=\"\" _v-1e5c7fbd=\"\"> 顯示於網頁\n                            </label>\n                            <label _v-1e5c7fbd=\"\">\n                                <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"export\" _v-1e5c7fbd=\"\"> 匯出 CSV\n                            </label>\n                        </div>\n                    </div>\n                </div>\n            </div> \n        </v-webadmin-report>\n        <div class=\"m-top-10\" v-show=\"display == 'show'\" _v-1e5c7fbd=\"\">\n            <v-smart-table ref=\"smart_table_detail\" :table-config=\"tableConfig\" :csv-config=\"csvConfig\" :is-ajaxing=\"ajaxing\" :data=\"result\" :page-sync-url-query=\"false\" @change-page=\"changePage\" @html-click-callback=\"actionOperate\" _v-1e5c7fbd=\"\"></v-smart-table>\n        </div>\n        <v-multi-alert-model :model-title=\"'訂單 '+selectOrderId\" :alert-obj=\"alertObj\" _v-1e5c7fbd=\"\">\n\t    </v-multi-alert-model>\n        <webadmin-refund-order-operate-modal ref=\"order_operate_modal\" :request-id=\"requestId\" @operate-close=\"resetRequestId\" _v-1e5c7fbd=\"\"></webadmin-refund-order-operate-modal>\n        <webadmin-operate-modal ref=\"operate\" :enable-change-member=\"false\" event-scope=\"webadmin\" _v-1e5c7fbd=\"\"> \n            <template slot=\"event\">\n                <webadmin-order-operate-event-slot-utility event-scope=\"webadmin\" :operate-ref=\"$refs.operate\" :event-optional-data=\"eventSlotData\" _v-1e5c7fbd=\"\"></webadmin-order-operate-event-slot-utility>\n            </template>\n        </webadmin-operate-modal>\n    </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.page-div[_v-1e5c7fbd] {\n  padding: 0px 15px;\n  margin-bottom: 15px; }\n\n/* line 7, stdin */\n.table-div[_v-1e5c7fbd] {\n  padding: 20px 0px; }\n\n/* line 10, stdin */\n.total-list[_v-1e5c7fbd] {\n  margin-left: 10px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-1e5c7fbd", module.exports)
  } else {
    hotAPI.update("_v-1e5c7fbd", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/object/values":58,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/defineProperty":65,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1373:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 4, stdin */\n.refund-order[_v-760f1fee] {\n  color: red; }\n\n/* line 8, stdin */\n.negative-number[_v-760f1fee] {\n  color: red; }\n\n/* line 12, stdin */\n.origin-refunded[_v-760f1fee] {\n  color: #C7C4C3; }\n\n/* line 16, stdin */\n.price[_v-760f1fee] {\n  text-align: center; }\n\n/* line 20, stdin */\n.table-striped thead[_v-760f1fee] {\n  border-bottom: 1px solid #000; }\n\n/* line 24, stdin */\n.total-row[_v-760f1fee] {\n  font-weight: bold; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['ajaxing', 'list', 'total'],
    computed: {}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-table :ajaxing=\"ajaxing\" :length=\"list.length\" _v-760f1fee=\"\">\n    <table class=\"table table-striped\" _v-760f1fee=\"\">\n        <thead _v-760f1fee=\"\">\n            <tr _v-760f1fee=\"\">\n                <td _v-760f1fee=\"\">訂單編號</td>\n                <td _v-760f1fee=\"\">客戶</td>\n                <td _v-760f1fee=\"\">銷售場館</td>\n                <td _v-760f1fee=\"\">結帳時間</td>\n                <td _v-760f1fee=\"\">優惠券名稱</td>\n                <td _v-760f1fee=\"\">訂單商品</td>\n                <td _v-760f1fee=\"\">折扣前金額</td>\n                <td _v-760f1fee=\"\">折扣</td>\n            </tr>\n        </thead>\n        <tbody _v-760f1fee=\"\">\n            <tr _v-760f1fee=\"\">\n                <td _v-760f1fee=\"\">{{ total.order_id }}</td>\n                <td _v-760f1fee=\"\">{{ total.member_name }}</td>\n                <td _v-760f1fee=\"\">{{ total.branch_name }}</td>\n                <td _v-760f1fee=\"\">{{ total.checkout_at }}</td>\n                <td _v-760f1fee=\"\">{{ total.coupon_name }}</td>\n                <td _v-760f1fee=\"\">{{ total.product_name }}</td>\n                <td _v-760f1fee=\"\">{{ total.price }}</td>\n                <td _v-760f1fee=\"\">{{ total.discount }}</td>\n            </tr>\n            <tr v-for=\"item in list\" _v-760f1fee=\"\">\n                <td _v-760f1fee=\"\">{{ item.order_id }}</td>\n                <td _v-760f1fee=\"\">{{ item.member_name }}</td>\n                <td _v-760f1fee=\"\">{{ item.branch_name }}</td>\n                <td _v-760f1fee=\"\">{{ item.checkout_at }}</td>\n                <td _v-760f1fee=\"\">{{ item.coupon_name }}</td>\n                <td _v-760f1fee=\"\">{{ item.product_name }}</td>\n                <td _v-760f1fee=\"\">{{ item.price }}</td>\n                <td _v-760f1fee=\"\">{{ item.discount }}</td>\n            </tr>\n        </tbody>\n    </table>\n</v-table>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 4, stdin */\n.refund-order[_v-760f1fee] {\n  color: red; }\n\n/* line 8, stdin */\n.negative-number[_v-760f1fee] {\n  color: red; }\n\n/* line 12, stdin */\n.origin-refunded[_v-760f1fee] {\n  color: #C7C4C3; }\n\n/* line 16, stdin */\n.price[_v-760f1fee] {\n  text-align: center; }\n\n/* line 20, stdin */\n.table-striped thead[_v-760f1fee] {\n  border-bottom: 1px solid #000; }\n\n/* line 24, stdin */\n.total-row[_v-760f1fee] {\n  font-weight: bold; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-760f1fee", module.exports)
  } else {
    hotAPI.update("_v-760f1fee", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1374:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 3, stdin */\n.table-striped thead[_v-0fcd959e] {\n  border-bottom: 1px solid #000; }\n\n/* line 6, stdin */\n.refund[_v-0fcd959e] {\n  color: red; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['ajaxing', 'list', 'total']
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-0fcd959e=\"\">\n    <v-table :ajaxing=\"ajaxing\" :length=\"list.length\" _v-0fcd959e=\"\">\n        <table class=\"table table-striped\" _v-0fcd959e=\"\">\n            <thead _v-0fcd959e=\"\">\n                <tr _v-0fcd959e=\"\">\n                    <td _v-0fcd959e=\"\">優惠券名稱</td>\n                    <td _v-0fcd959e=\"\">開始時間</td>\n                    <td _v-0fcd959e=\"\">結束時間</td>\n                    <td _v-0fcd959e=\"\">最大使用量</td>\n                    <td _v-0fcd959e=\"\">使用數量</td>\n                    <td _v-0fcd959e=\"\">折扣前總金額</td>\n                    <td _v-0fcd959e=\"\">折扣金額</td>\n                </tr>\n            </thead>\n            <tbody _v-0fcd959e=\"\">\n                <tr _v-0fcd959e=\"\">\n                    <td _v-0fcd959e=\"\">{{ total.name }}</td>\n                    <td _v-0fcd959e=\"\">{{ total.start_date }}</td>\n                    <td _v-0fcd959e=\"\">{{ total.end_date }}</td>\n                    <td _v-0fcd959e=\"\">{{ total.max_usage_count }}</td>\n                    <td _v-0fcd959e=\"\">{{ total.use_count }}</td>\n                    <td _v-0fcd959e=\"\">{{ total.order_price_sum }}</td>\n                    <td _v-0fcd959e=\"\">{{ total.discount_sum }}</td>\n                </tr>\n                <tr v-for=\"item in list\" _v-0fcd959e=\"\">\n                    <td _v-0fcd959e=\"\">{{ item.name }}</td>\n                    <td _v-0fcd959e=\"\">{{ item.start_date }}</td>\n                    <td _v-0fcd959e=\"\">{{ item.end_date }}</td>\n                    <td _v-0fcd959e=\"\">{{ item.max_usage_count }}</td>\n                    <td _v-0fcd959e=\"\">{{ item.use_count }}</td>\n                    <td _v-0fcd959e=\"\">{{ item.order_price_sum }}</td>\n                    <td _v-0fcd959e=\"\">{{ item.discount_sum }}</td>\n                </tr>\n            </tbody>\n        </table>\n    </v-table>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 3, stdin */\n.table-striped thead[_v-0fcd959e] {\n  border-bottom: 1px solid #000; }\n\n/* line 6, stdin */\n.refund[_v-0fcd959e] {\n  color: red; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-0fcd959e", module.exports)
  } else {
    hotAPI.update("_v-0fcd959e", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1375:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 4, stdin */\n.refund-order[_v-677a64cc] {\n  color: red; }\n\n/* line 8, stdin */\n.negative-number[_v-677a64cc] {\n  color: red; }\n\n/* line 12, stdin */\n.origin-refunded[_v-677a64cc] {\n  color: #C7C4C3; }\n\n/* line 16, stdin */\n.price[_v-677a64cc] {\n  text-align: center; }\n\n/* line 20, stdin */\n.table-striped thead[_v-677a64cc] {\n  border-bottom: 1px solid #000; }\n\n/* line 24, stdin */\n.total-row[_v-677a64cc] {\n  font-weight: bold; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['ajaxing', 'list', 'total'],
    computed: {}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-table :ajaxing=\"ajaxing\" :length=\"list.length\" _v-677a64cc=\"\">\n    <table class=\"table table-striped\" _v-677a64cc=\"\">\n        <thead _v-677a64cc=\"\">\n            <tr _v-677a64cc=\"\">\n                <td _v-677a64cc=\"\">訂單編號</td>\n                <td _v-677a64cc=\"\">客戶</td>\n                <td _v-677a64cc=\"\">銷售場館</td>\n                <td _v-677a64cc=\"\">結帳時間</td>\n                <td _v-677a64cc=\"\">促銷名稱</td>\n                <td _v-677a64cc=\"\">訂單商品</td>\n                <td _v-677a64cc=\"\">折扣前金額</td>\n                <td _v-677a64cc=\"\">折扣</td>\n            </tr>\n        </thead>\n        <tbody _v-677a64cc=\"\">\n            <tr _v-677a64cc=\"\">\n                <td _v-677a64cc=\"\">{{ total.order_id }}</td>\n                <td _v-677a64cc=\"\">{{ total.member_name }}</td>\n                <td _v-677a64cc=\"\">{{ total.branch_name }}</td>\n                <td _v-677a64cc=\"\">{{ total.checkout_at }}</td>\n                <td _v-677a64cc=\"\">{{ total.coupon_name }}</td>\n                <td _v-677a64cc=\"\">{{ total.product_name }}</td>\n                <td _v-677a64cc=\"\">{{ total.price }}</td>\n                <td _v-677a64cc=\"\">{{ total.discount }}</td>\n            </tr>\n            <tr v-for=\"item in list\" _v-677a64cc=\"\">\n                <td _v-677a64cc=\"\">{{ item.order_id }}</td>\n                <td _v-677a64cc=\"\">{{ item.member_name }}</td>\n                <td _v-677a64cc=\"\">{{ item.branch_name }}</td>\n                <td _v-677a64cc=\"\">{{ item.checkout_at }}</td>\n                <td _v-677a64cc=\"\">{{ item.coupon_name }}</td>\n                <td _v-677a64cc=\"\">{{ item.product_name }}</td>\n                <td _v-677a64cc=\"\">{{ item.price }}</td>\n                <td _v-677a64cc=\"\">{{ item.discount }}</td>\n            </tr>\n        </tbody>\n    </table>\n</v-table>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 4, stdin */\n.refund-order[_v-677a64cc] {\n  color: red; }\n\n/* line 8, stdin */\n.negative-number[_v-677a64cc] {\n  color: red; }\n\n/* line 12, stdin */\n.origin-refunded[_v-677a64cc] {\n  color: #C7C4C3; }\n\n/* line 16, stdin */\n.price[_v-677a64cc] {\n  text-align: center; }\n\n/* line 20, stdin */\n.table-striped thead[_v-677a64cc] {\n  border-bottom: 1px solid #000; }\n\n/* line 24, stdin */\n.total-row[_v-677a64cc] {\n  font-weight: bold; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-677a64cc", module.exports)
  } else {
    hotAPI.update("_v-677a64cc", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1376:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 3, stdin */\n.table-striped thead[_v-1c622ba6] {\n  border-bottom: 1px solid #000; }\n\n/* line 6, stdin */\n.refund[_v-1c622ba6] {\n  color: red; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['ajaxing', 'list', 'total']
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-1c622ba6=\"\">\n    <v-table :ajaxing=\"ajaxing\" :length=\"list.length\" _v-1c622ba6=\"\">\n        <table class=\"table table-striped\" _v-1c622ba6=\"\">\n            <thead _v-1c622ba6=\"\">\n                <tr _v-1c622ba6=\"\">\n                    <td _v-1c622ba6=\"\">促銷名稱</td>\n                    <td _v-1c622ba6=\"\">開始時間</td>\n                    <td _v-1c622ba6=\"\">結束時間</td>\n                    <td _v-1c622ba6=\"\">使用數量</td>\n                    <td _v-1c622ba6=\"\">折扣前總金額</td>\n                    <td _v-1c622ba6=\"\">折扣金額</td>\n                </tr>\n            </thead>\n            <tbody _v-1c622ba6=\"\">\n                <tr _v-1c622ba6=\"\">\n                    <td _v-1c622ba6=\"\">{{ total.name }}</td>\n                    <td _v-1c622ba6=\"\">{{ total.start_date }}</td>\n                    <td _v-1c622ba6=\"\">{{ total.end_date }}</td>\n                    <td _v-1c622ba6=\"\">{{ total.use_count }}</td>\n                    <td _v-1c622ba6=\"\">{{ total.order_price_sum }}</td>\n                    <td _v-1c622ba6=\"\">{{ total.discount_sum }}</td>\n                </tr>\n                <tr v-for=\"item in list\" _v-1c622ba6=\"\">\n                    <td _v-1c622ba6=\"\">{{ item.name }}</td>\n                    <td _v-1c622ba6=\"\">{{ item.start_date }}</td>\n                    <td _v-1c622ba6=\"\">{{ item.end_date }}</td>\n                    <td _v-1c622ba6=\"\">{{ item.use_count }}</td>\n                    <td _v-1c622ba6=\"\">{{ item.order_price_sum }}</td>\n                    <td _v-1c622ba6=\"\">{{ item.discount_sum }}</td>\n                </tr>\n            </tbody>\n        </table>\n    </v-table>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 3, stdin */\n.table-striped thead[_v-1c622ba6] {\n  border-bottom: 1px solid #000; }\n\n/* line 6, stdin */\n.refund[_v-1c622ba6] {\n  color: red; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-1c622ba6", module.exports)
  } else {
    hotAPI.update("_v-1c622ba6", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1377:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 4, stdin */\n.refund-order[_v-0ebb3775] {\n  color: red; }\n\n/* line 8, stdin */\n.negative-number[_v-0ebb3775] {\n  color: red; }\n\n/* line 12, stdin */\n.origin-refunded[_v-0ebb3775] {\n  color: #C7C4C3; }\n\n/* line 16, stdin */\n.price[_v-0ebb3775] {\n  text-align: center; }\n\n/* line 20, stdin */\n.table-striped thead[_v-0ebb3775] {\n  border-bottom: 1px solid #000; }\n\n/* line 24, stdin */\n.total-row[_v-0ebb3775] {\n  font-weight: bold; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['ajaxing', 'list', 'calculateTotalRecognizedValue', 'calculateRecognizedValue']
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-table :ajaxing=\"ajaxing\" :length=\"list.length\" _v-0ebb3775=\"\">\n    <table class=\"table table-striped\" _v-0ebb3775=\"\">\n        <thead _v-0ebb3775=\"\">\n            <tr _v-0ebb3775=\"\">\n                <td width=\"110px\" _v-0ebb3775=\"\">方案名稱</td>\n                <td width=\"150px\" _v-0ebb3775=\"\">訂單ID</td>\n                <td _v-0ebb3775=\"\">客戶姓名</td>\n                <td _v-0ebb3775=\"\">總價值</td>\n                <td _v-0ebb3775=\"\">開始日</td>\n                <td _v-0ebb3775=\"\">結束日</td>\n                <td _v-0ebb3775=\"\">總天數</td>\n                <td _v-0ebb3775=\"\">使用天數</td>\n                <td _v-0ebb3775=\"\">認列價值</td>\n            </tr>\n        </thead>\n        <tbody _v-0ebb3775=\"\">\n            <tr class=\"total-row\" _v-0ebb3775=\"\">\n                <td _v-0ebb3775=\"\">總計</td>\n                <td _v-0ebb3775=\"\"></td>\n                <td _v-0ebb3775=\"\"></td>\n                <td _v-0ebb3775=\"\">{{calculateTotalRecognizedValue}}</td>\n                <td _v-0ebb3775=\"\"></td>\n                <td _v-0ebb3775=\"\"></td>\n                <td _v-0ebb3775=\"\"></td>\n                <td _v-0ebb3775=\"\"></td>\n                <td _v-0ebb3775=\"\">{{calculateRecognizedValue}}</td>\n            </tr>\n            <tr v-for=\"item in list\" _v-0ebb3775=\"\">\n                <td _v-0ebb3775=\"\">{{ item.contractName }}</td>\n                <td _v-0ebb3775=\"\">{{ item.orderId }}</td>\n                <td _v-0ebb3775=\"\">{{ item.memberName }}</td>\n                <td _v-0ebb3775=\"\">{{ item.totalRecognizedValue }}</td>\n                <td _v-0ebb3775=\"\">{{ item.contractStartDay }}</td>\n                <td _v-0ebb3775=\"\">{{ item.contractEndDay }}</td>\n                <td _v-0ebb3775=\"\">{{ item.totalValue }}</td>\n                <td _v-0ebb3775=\"\">{{ item.usedValue }}</td>\n                <td _v-0ebb3775=\"\">{{ item.currentRecognizedValue }}</td>\n            </tr>\n        </tbody>\n    </table>\n</v-table>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 4, stdin */\n.refund-order[_v-0ebb3775] {\n  color: red; }\n\n/* line 8, stdin */\n.negative-number[_v-0ebb3775] {\n  color: red; }\n\n/* line 12, stdin */\n.origin-refunded[_v-0ebb3775] {\n  color: #C7C4C3; }\n\n/* line 16, stdin */\n.price[_v-0ebb3775] {\n  text-align: center; }\n\n/* line 20, stdin */\n.table-striped thead[_v-0ebb3775] {\n  border-bottom: 1px solid #000; }\n\n/* line 24, stdin */\n.total-row[_v-0ebb3775] {\n  font-weight: bold; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-0ebb3775", module.exports)
  } else {
    hotAPI.update("_v-0ebb3775", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1378:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 4, stdin */\n.refund-order[_v-0a3ac580] {\n  color: red; }\n\n/* line 8, stdin */\n.negative-number[_v-0a3ac580] {\n  color: red; }\n\n/* line 12, stdin */\n.origin-refunded[_v-0a3ac580] {\n  color: #C7C4C3; }\n\n/* line 16, stdin */\n.price[_v-0a3ac580] {\n  text-align: center; }\n\n/* line 20, stdin */\n.table-striped thead[_v-0a3ac580] {\n  border-bottom: 1px solid #000; }\n\n/* line 24, stdin */\n.total-row[_v-0a3ac580] {\n  font-weight: bold; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['ajaxing', 'list', 'calculateTotalRecognizedValue', 'calculateRecognizedValue']
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-table :ajaxing=\"ajaxing\" :length=\"list.length\" _v-0a3ac580=\"\">\n    <table class=\"table table-striped\" _v-0a3ac580=\"\">\n        <thead _v-0a3ac580=\"\">\n            <tr _v-0a3ac580=\"\">\n                <td width=\"110px\" _v-0a3ac580=\"\">方案名稱</td>\n                <td width=\"150px\" _v-0a3ac580=\"\">訂單ID</td>\n                <td _v-0a3ac580=\"\">客戶姓名</td>\n                <td _v-0a3ac580=\"\">總價值</td>\n                <td _v-0a3ac580=\"\">開始日</td>\n                <td _v-0a3ac580=\"\">結束日</td>\n                <td _v-0a3ac580=\"\">總點次</td>\n                <td _v-0a3ac580=\"\">使用點次</td>\n                <td _v-0a3ac580=\"\">認列價值</td>\n            </tr>\n        </thead>\n        <tbody _v-0a3ac580=\"\">\n            <tr class=\"total-row\" _v-0a3ac580=\"\">\n                <td _v-0a3ac580=\"\">總計</td>\n                <td _v-0a3ac580=\"\"></td>\n                <td _v-0a3ac580=\"\"></td>\n                <td _v-0a3ac580=\"\">{{calculateTotalRecognizedValue}}</td>\n                <td _v-0a3ac580=\"\"></td>\n                <td _v-0a3ac580=\"\"></td>\n                <td _v-0a3ac580=\"\"></td>\n                <td _v-0a3ac580=\"\"></td>\n                <td _v-0a3ac580=\"\">{{calculateRecognizedValue}}</td>\n            </tr>\n            <tr v-for=\"item in list\" _v-0a3ac580=\"\">\n                <td _v-0a3ac580=\"\">{{ item.contractName }}</td>\n                <td _v-0a3ac580=\"\">{{ item.orderId }}</td>\n                <td _v-0a3ac580=\"\">{{ item.memberName }}</td>\n                <td _v-0a3ac580=\"\">{{ item.totalRecognizedValue }}</td>\n                <td _v-0a3ac580=\"\">{{ item.contractStartDay }}</td>\n                <td _v-0a3ac580=\"\">{{ item.contractEndDay }}</td>\n                <td _v-0a3ac580=\"\">{{ item.totalValue }}</td>\n                <td _v-0a3ac580=\"\">{{ item.usedValue }}</td>\n                <td _v-0a3ac580=\"\">{{ item.currentRecognizedValue }}</td>\n            </tr>\n        </tbody>\n    </table>\n</v-table>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 4, stdin */\n.refund-order[_v-0a3ac580] {\n  color: red; }\n\n/* line 8, stdin */\n.negative-number[_v-0a3ac580] {\n  color: red; }\n\n/* line 12, stdin */\n.origin-refunded[_v-0a3ac580] {\n  color: #C7C4C3; }\n\n/* line 16, stdin */\n.price[_v-0a3ac580] {\n  text-align: center; }\n\n/* line 20, stdin */\n.table-striped thead[_v-0a3ac580] {\n  border-bottom: 1px solid #000; }\n\n/* line 24, stdin */\n.total-row[_v-0a3ac580] {\n  font-weight: bold; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-0a3ac580", module.exports)
  } else {
    hotAPI.update("_v-0a3ac580", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1379:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['requestId'],
    watch: {
        requestId: function requestId(n, o) {
            if (n == null) {
                return;
            }
            this.getRequest();
        }
    },
    data: function data() {
        return {
            status: null,
            stateList: [],
            orderId: '',
            refundReason: '',
            currentStatus: '',
            remark: '',
            refundOrders: [],
            branchEmail: '',
            refundOrderId: ''
        };
    },
    mounted: function mounted() {
        this.getRequestStatus();
    },

    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('webadmin/configure', ['configuredRun', 'fetchStudioList', 'fetchBranchList']), {
        getRequestStatus: function getRequestStatus() {
            var _this = this;

            this.$http.get('/adminapi/order-refund-request/status').then(function (response) {
                var statuses = response.data;
                _this.stateList = statuses.filter(function (status) {
                    console.log(status);
                    return status.key !== 5;
                });
            }, function (error) {
                $17.swal({
                    title: error.body.message,
                    type: 'warning'
                });
            });
        },
        getRequest: function getRequest() {
            var _this2 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this2.$http.get('/adminapi/order-refund-request/edit?request_id=' + _this2.requestId).then(function (response) {
                                    var data = response.data;

                                    _this2.orderId = data.order_id;
                                    _this2.refundReason = data.refund_reason;
                                    _this2.currentStatus = data.current_status_name;
                                    _this2.remark = data.remark;
                                    _this2.refundOrderId = data.refund_order_id;
                                    _this2.branchEmail = data.branch_email;
                                    _this2.refundOrders = data.refund_orders;
                                    _this2.status = _this2.stateList.reduce(function (current, item) {
                                        if (item.key == data.current_status) {
                                            current = item;
                                        }

                                        return current;
                                    }, null);
                                    $(_this2.$el).find('div.modal').modal('show');
                                }, function (error) {
                                    $17.swal({
                                        title: error.body.message,
                                        type: 'warning'
                                    });
                                });

                            case 2:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        reset: function reset() {
            this.$emit('operate-close');
        },
        updateRequest: function updateRequest() {
            var _this3 = this;

            var data = {
                'request_id': this.requestId,
                'remark': this.remark,
                'status': this.status.key,
                'refund_order_id': this.refundOrderId
            };

            if (!this.refundOrderId && this.status.key == 3) {
                $17.swal({
                    title: '修改失敗',
                    text: '關聯退費訂單為必填資訊',
                    type: 'error',
                    showCancelButton: false
                });

                return;
            }

            this.$http.post('/adminapi/order-refund-request/update', data).then(function (response) {
                $17.swal({
                    title: '已修改',
                    text: "",
                    type: 'success',
                    showCancelButton: false
                });
                $(_this3.$el).find('div.modal').modal('hide');
            }).catch(function (response) {

                $17.swal({
                    title: '修改失敗',
                    text: response.data.message,
                    type: 'error',
                    showCancelButton: false
                });
            });
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-3695087e=\"\">\n    <v-modal id=\"operate-modal\" :close-modal-event=\"reset\" :save-clicked=\"updateRequest\" _v-3695087e=\"\">\n        <template>\n            <span slot=\"title\" _v-3695087e=\"\">編輯</span>\n            <div slot=\"body\" _v-3695087e=\"\">\n                <div class=\"row m-top-15\" _v-3695087e=\"\">\n                    <label for=\"name\" class=\"col-sm-3 text-right\" _v-3695087e=\"\">訂單ID</label>\n                    <div class=\"col-sm-9\" _v-3695087e=\"\">\n                        {{orderId}}\n                    </div>\n                </div>\n                <div class=\"row m-top-15\" _v-3695087e=\"\">\n                    <label for=\"name\" class=\"col-sm-3 text-right\" _v-3695087e=\"\">退費原因</label>\n                    <div class=\"col-sm-9\" _v-3695087e=\"\">\n                        {{refundReason}}\n                    </div>\n                </div>\n                <div class=\"row m-top-15\" _v-3695087e=\"\">\n                    <label for=\"name\" class=\"col-sm-3 text-right\" _v-3695087e=\"\">目前狀態</label>\n                    <div class=\"col-sm-9\" _v-3695087e=\"\">\n                        {{currentStatus}}\n                    </div>\n                </div>\n                <div class=\"row m-top-15\" _v-3695087e=\"\">\n                    <label for=\"name\" class=\"col-sm-3 text-right\" _v-3695087e=\"\">變更狀態</label>\n                    <div class=\"col-sm-9\" _v-3695087e=\"\">\n                    <v-mutiselect :model.sync=\"status\" :options=\"stateList\" :multiple=\"false\" :close-on-select=\"true\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"true\" placeholder=\"請選擇狀態\" label=\"name\" track-by=\"key\" :taggable=\"false\" tag-name=\"name\" :max-height=\"300\" open-direction=\"bottom\" _v-3695087e=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n                <div class=\"row m-top-15\" _v-3695087e=\"\">\n                    <label for=\"name\" class=\"col-sm-3 text-right\" _v-3695087e=\"\">處理備註</label>\n                    <div class=\"col-sm-9\" _v-3695087e=\"\">\n                        <textarea name=\"\" id=\"\" cols=\"30\" row=\"\" m-top-15s=\"10\" v-model=\"remark\" _v-3695087e=\"\"></textarea>\n                    </div>\n                </div>\n                <div class=\"row m-top-15\" v-if=\"refundOrders.length==0\" _v-3695087e=\"\">\n                        <label for=\"name\" class=\"col-sm-3 text-right\" _v-3695087e=\"\">關聯退費訂單</label>\n                </div>\n                <template v-for=\"(item, index) in refundOrders\" v-if=\"refundOrders.length>0\">\n                    <div class=\"row m-top-15\" _v-3695087e=\"\">\n                        <label for=\"name\" class=\"col-sm-3 text-right\" v-if=\"index==0\" _v-3695087e=\"\">關聯退費訂單</label>\n                        <div class=\"col-sm-9\" v-if=\"index==0\" _v-3695087e=\"\">\n                            <label :for=\"'id-'+item\" _v-3695087e=\"\">\n                                <input type=\"checkbox\" :value=\"item\" v-model=\"refundOrderId\" :id=\"'id-'+item\" :true-value=\"item\" false-value=\"\" _v-3695087e=\"\">\n                                {{item}}\n                            </label>\n                        </div>\n                        <div class=\"col-sm-offset-3 col-sm-9\" v-if=\"index!=0\" _v-3695087e=\"\">\n                            <label :for=\"'id-'+item\" _v-3695087e=\"\">\n                                <input type=\"checkbox\" :value=\"item\" v-model=\"refundOrderId\" :id=\"'id-'+item\" :true-value=\"item\" false-value=\"\" _v-3695087e=\"\">\n                                {{item}}\n                            </label>\n                        </div>\n                    </div>\n                </template>\n                <div class=\"row m-top-15\" _v-3695087e=\"\">\n                    <label for=\"name\" class=\"col-sm-3 text-right\" _v-3695087e=\"\">場館email</label>\n                    <div class=\"col-sm-9\" _v-3695087e=\"\">\n                        {{branchEmail}}\n                    </div>\n                </div>\n            </div>\n        </template>\n    </v-modal>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-3695087e", module.exports)
  } else {
    hotAPI.update("_v-3695087e", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vuex":803}],1380:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 3, stdin */\n.table-striped thead[_v-08efc073] {\n  border-bottom: 1px solid #000; }\n\n/* line 6, stdin */\n.refund[_v-08efc073] {\n  color: red; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['ajaxing', 'details', 'head'],
    computed: {
        total: function total() {
            return this.list.reduce(function (carry, item) {
                carry += item.sub_total;
                return carry;
            }, 0);
        },
        classDetails: function classDetails() {
            return this.details && this.details.classes && this.details.classes.detail ? this.details.classes.detail : [];
        },
        serviceDetails: function serviceDetails() {
            return this.details && this.details.services && this.details.services.detail ? this.details.services.detail : [];
        },
        classSalary: function classSalary() {
            return this.details && this.details.classes && this.details.classes.summary ? this.details.classes.summary.salary : 0;
        },
        classBonus: function classBonus() {
            return this.details && this.details.classes && this.details.classes.summary ? this.details.classes.summary.bonus : 0;
        },
        classFinalMoneys: function classFinalMoneys() {
            return this.details && this.details.classes && this.details.classes.summary ? this.details.classes.summary.final_money : 0;
        },
        serviceSalary: function serviceSalary() {
            return this.details && this.details.services && this.details.services.summary ? this.details.services.summary.salary : 0;
        },
        serviceBonus: function serviceBonus() {
            return '';
            // return (this.details &&this.details.services && this.details.services.summary)?this.details.services.summary.bonus:''; 
        },
        serviceFinalMoneys: function serviceFinalMoneys() {
            return this.details && this.details.services && this.details.services.summary ? this.details.services.summary.final_money : 0;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-08efc073=\"\">\n    <v-modal id=\"salary-detail\" no-footer=\"\" _v-08efc073=\"\">\n        <template>\n            <span slot=\"title\" _v-08efc073=\"\">{{ head.member_name }}</span>\n            <div slot=\"body\" _v-08efc073=\"\">\n                <div class=\"form-group\" _v-08efc073=\"\">\n                    <span class=\"form-title\" _v-08efc073=\"\">場館</span>\n                    {{ head.branch_name }}\n                </div>\n                <div class=\"form-group\" _v-08efc073=\"\">\n                    <span class=\"form-title\" _v-08efc073=\"\">薪資</span>\n                    {{ moneyFormat(head.total) }}\n                </div>\n                <table class=\"table table-striped\" v-if=\"details.classes\" _v-08efc073=\"\">\n                    <thead _v-08efc073=\"\">\n                    <tr _v-08efc073=\"\">\n                        <td _v-08efc073=\"\">課程名稱</td>\n                        <td _v-08efc073=\"\">日期</td>\n                        <td _v-08efc073=\"\">開始時間</td>\n                        <td _v-08efc073=\"\">訂課人數</td>\n                        <td _v-08efc073=\"\">出席人數</td>\n                        <td _v-08efc073=\"\">缺席人數</td>\n                        <td _v-08efc073=\"\">遲退人數</td>\n                        <td _v-08efc073=\"\">薪資條件</td>\n                        <td _v-08efc073=\"\">薪資</td>\n                        <td _v-08efc073=\"\">獎金</td>\n                        <td _v-08efc073=\"\">應計薪資</td>\n                    </tr>\n                    </thead>\n                    <tbody _v-08efc073=\"\">\n                    <tr v-for=\"detail in classDetails\" _v-08efc073=\"\">\n                        <td _v-08efc073=\"\">{{ detail.name }}</td>\n                        <td _v-08efc073=\"\">{{ detail.date }}</td>\n                        <td _v-08efc073=\"\">{{ detail.time }}</td>\n                        <td _v-08efc073=\"\">{{ detail.booking_number }}</td>\n                        <td _v-08efc073=\"\">{{ detail.comfirm_number }}</td>\n                        <td _v-08efc073=\"\">{{ detail.absence_number }}</td>\n                        <td _v-08efc073=\"\">{{ detail.late_cancle_number }}</td>\n                        <td _v-08efc073=\"\">{{ detail.calculate_condition }}</td>\n                        <td _v-08efc073=\"\">{{ detail.salary }}</td>\n                        <td _v-08efc073=\"\">{{ detail.bonus }}</td>\n                        <td _v-08efc073=\"\">{{ detail.final_money }}</td>\n                    </tr>\n                    </tbody>\n                    <tfoot _v-08efc073=\"\">\n                        <tr _v-08efc073=\"\"><td _v-08efc073=\"\">小計</td>\n                        <td _v-08efc073=\"\"></td>\n                        <td _v-08efc073=\"\"></td>\n                        <td _v-08efc073=\"\"></td>\n                        <td _v-08efc073=\"\"></td>\n                        <td _v-08efc073=\"\"></td>\n                        <td _v-08efc073=\"\"></td>\n                        <td _v-08efc073=\"\"></td>\n                        <td _v-08efc073=\"\">{{ classSalary}}</td>\n                        <td _v-08efc073=\"\">{{ classBonus}}</td>\n                        <td _v-08efc073=\"\">{{ classFinalMoneys}}</td>\n                    </tr></tfoot>\n                </table>\n                <table class=\"table table-striped\" v-if=\"details.services\" _v-08efc073=\"\">\n                    <thead _v-08efc073=\"\">\n                    <tr _v-08efc073=\"\">\n                        <td _v-08efc073=\"\">服務名稱</td>\n                        <td _v-08efc073=\"\">日期</td>\n                        <td _v-08efc073=\"\">開始時間</td>\n                        <td _v-08efc073=\"\">狀態</td>\n                        <td _v-08efc073=\"\">預約方式</td>\n                        <td _v-08efc073=\"\">薪資條件</td>\n                        <td _v-08efc073=\"\">薪資</td>\n                        <td _v-08efc073=\"\"></td>\n                        <td _v-08efc073=\"\">應計薪資</td>\n                    </tr>\n                    </thead>\n                    <tbody _v-08efc073=\"\">\n                    <tr v-for=\"detail in serviceDetails\" _v-08efc073=\"\">\n                        <td _v-08efc073=\"\">{{ detail.name }}</td>\n                        <td _v-08efc073=\"\">{{ detail.date }}</td>\n                        <td _v-08efc073=\"\">{{ detail.time }}</td>\n                        <td _v-08efc073=\"\">{{ detail.confirm_status }}</td>\n                        <td _v-08efc073=\"\">{{ detail.booking_way }}</td>\n                        <td _v-08efc073=\"\">{{ detail.calculate_condition }}</td>\n                        <td _v-08efc073=\"\">{{ detail.salary }}</td>\n                        <td _v-08efc073=\"\"></td>\n                        <td _v-08efc073=\"\">{{ detail.final_money }}</td>\n                    </tr>\n                    </tbody>\n                    <tfoot _v-08efc073=\"\">\n                        <tr _v-08efc073=\"\"><td _v-08efc073=\"\">小計</td>\n                        <td _v-08efc073=\"\"></td>\n                        <td _v-08efc073=\"\"></td>\n                        <td _v-08efc073=\"\"></td>\n                        <td _v-08efc073=\"\"></td>\n                        <td _v-08efc073=\"\"></td>\n                        <td _v-08efc073=\"\">{{ serviceSalary}}</td>\n                        <td _v-08efc073=\"\">{{ serviceBonus}}</td>\n                        <td _v-08efc073=\"\">{{ serviceFinalMoneys}}</td>\n                    </tr></tfoot>\n                </table>\n            </div>\n        </template>\n    </v-modal>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 3, stdin */\n.table-striped thead[_v-08efc073] {\n  border-bottom: 1px solid #000; }\n\n/* line 6, stdin */\n.refund[_v-08efc073] {\n  color: red; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-08efc073", module.exports)
  } else {
    hotAPI.update("_v-08efc073", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1381:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 3, stdin */\n.table-striped thead[_v-79c52a9c] {\n  border-bottom: 1px solid #000; }\n\n/* line 6, stdin */\n.refund[_v-79c52a9c] {\n  color: red; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['ajaxing', 'list'],
    computed: {
        total: function total() {
            return this.list.reduce(function (carry, item) {
                carry += item.sub_total;
                return carry;
            }, 0);
        }
    },
    methods: {
        openDetail: function openDetail(branchId, memberId, openType) {
            this.$emit('open-detail', {
                'branchId': branchId,
                'memberId': memberId,
                'openType': openType
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-79c52a9c=\"\">\n    <v-table :ajaxing=\"ajaxing\" :length=\"list.length\" _v-79c52a9c=\"\">\n        <table class=\"table table-striped\" _v-79c52a9c=\"\">\n            <thead _v-79c52a9c=\"\">\n                <tr _v-79c52a9c=\"\">\n                    <td _v-79c52a9c=\"\">場館</td>\n                    <td _v-79c52a9c=\"\">姓名</td>\n                    <td _v-79c52a9c=\"\">課程薪資</td>\n                    <td _v-79c52a9c=\"\">服務薪資</td>\n                    <td _v-79c52a9c=\"\">小計</td>\n                    <td _v-79c52a9c=\"\"></td>\n                </tr>\n            </thead>\n            <tbody _v-79c52a9c=\"\">\n                <tr v-for=\"item in list\" _v-79c52a9c=\"\">\n                   <td _v-79c52a9c=\"\">{{ item.branch_name }}</td>\n                   <td _v-79c52a9c=\"\">{{ item.member_name }}</td>\n                   <td _v-79c52a9c=\"\">{{ item.schedule_money }}</td>\n                   <td _v-79c52a9c=\"\">{{ item.service_money }}</td>\n                   <td _v-79c52a9c=\"\">{{ item.sub_total }}</td>\n                   <td _v-79c52a9c=\"\">\n                       <a href=\"\" class=\"btn btn-default\" @click.stop.prevent=\"openDetail(item.branch_id,item.member_id,'modal')\" _v-79c52a9c=\"\">紀錄</a>\n                       <a href=\"\" class=\"btn btn-default\" @click.stop.prevent=\"openDetail(item.branch_id,item.member_id,'export')\" _v-79c52a9c=\"\">下載明細</a>\n                   </td>\n                </tr>\n            </tbody>\n            <tfoot _v-79c52a9c=\"\">\n                <tr _v-79c52a9c=\"\">\n                    <td _v-79c52a9c=\"\">總計</td>\n                    <td _v-79c52a9c=\"\"></td>\n                    <td _v-79c52a9c=\"\"></td>\n                    <td _v-79c52a9c=\"\"></td>\n                    <td _v-79c52a9c=\"\">{{ total }}</td>\n                    <td _v-79c52a9c=\"\"></td>\n                </tr>\n            </tfoot>\n        </table>\n    </v-table>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 3, stdin */\n.table-striped thead[_v-79c52a9c] {\n  border-bottom: 1px solid #000; }\n\n/* line 6, stdin */\n.refund[_v-79c52a9c] {\n  color: red; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-79c52a9c", module.exports)
  } else {
    hotAPI.update("_v-79c52a9c", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1382:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 4, stdin */\n.refund-order {\n  color: red; }\n\n/* line 8, stdin */\n.negative-number {\n  color: red; }\n\n/* line 12, stdin */\n.origin-refunded {\n  color: #C7C4C3; }\n\n/* line 16, stdin */\n.price {\n  text-align: center; }\n\n/* line 20, stdin */\n.table-striped thead {\n  border-bottom: 1px solid #000; }\n\n/* line 26, stdin */\n.total-row {\n  font-weight: bold; }\n\n\n.table-responsive {\n    overflow-y: hidden;\n    white-space: nowrap;\n}\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        'ajaxing': { type: Boolean },
        'list': { type: Array | Object },
        'salsemanVisible': {
            type: Object,
            default: function _default() {
                return {};
            }
        },
        pageMeta: {},
        changePage: {
            type: Function,
            default: function _default() {}
        }
    },
    data: function data() {
        var vm = this;
        return {
            csvConfig: {
                column: [{ keys: 'order_id', name: '訂單編號' }, { keys: 'branch_name', name: '場館' }, { keys: 'product_name', name: '項目' }, { keys: 'checkout_at', name: '交易日期' }, { keys: 'name', name: '客戶姓名' }, { keys: 'email', name: '電子郵件' }, { keys: 'phone', name: '客戶電話' }, { keys: 'price', name: '單價' }, { keys: 'qty', name: '數量' }, { keys: 'discounts_value', name: '折扣' }, { keys: 'sub_total', name: '金額' }, { keys: 'show_payment_way', name: '交易方式' }, { keys: 'transaction_number', name: '交易序號' }, { keys: 'invoice_number', name: '發票號碼' }, { keys: 'checkout_staff', name: '結帳人員' }, { keys: 'order_remark', name: '訂單備註' }],
                fileName: 'data',
                jsonData: []
            },
            tableConfig: {
                columns: [{ keys: 'order_id', head: '訂單編號' }, { keys: 'branch_name', head: '場館' }, { keys: 'checkout_at', head: '交易日期時間' }, { keys: 'name', head: '客戶姓名' }, {
                    keys: 'product_name',
                    head: '項目',
                    html: function html(item) {
                        if (item.isRefundOrder) {
                            return '<span class="refund-order">' + item.product_name + '</span>';
                        } else if (item.isOriginRefunded) {
                            return '<span class="origin-refunded">' + item.product_name + '</span>';
                        } else {
                            return item.product_name;
                        }
                    }
                }, { keys: 'price', head: '單價' }, {
                    keys: 'qty',
                    head: '數量',
                    html: function html(item) {
                        return '<span class="' + (item.qty < 0 ? 'negative-number' : '') + '">' + item.qty + '</span>';
                    }
                }, {
                    keys: 'discounts_value',
                    head: '折扣',
                    html: function html(item) {
                        return '<span class="negative-number">' + (parseInt(item.discounts_value) > 0 ? '$' + item.discounts_value : '') + '</span>';
                    }
                }, {
                    keys: 'sub_total',
                    head: '金額',
                    html: function html(item) {
                        return '<span class="' + (item.qty < 0 ? 'negative-number' : '') + '">$' + item.sub_total + '</span>';
                    }
                }, {
                    keys: 'show_payment_name',
                    head: '交易方式',
                    html: function html(item) {
                        return vm.showPaymentName(item);
                    }
                }, { keys: 'transaction_number', head: '交易序號' }, { keys: 'invoice_number', head: '發票號碼' }, { keys: 'checkout_staff', head: '結帳人員' }, { keys: 'order_remark', head: '訂單備註' }]
            }
        };
    },

    watch: {
        salsemanVisible: function salsemanVisible(n, o) {
            this.genSalesmenTableConfig(n);
        }
    },
    mounted: function mounted() {
        this.genSalesmenTableConfig(this.salsemanVisible);
    },

    computed: {
        records: function records() {
            return { records: this.list.hasOwnProperty('data') && this.list.data.length ? this.list.data : [], pageMeta: this.list.pageMeta };
        }
    },
    methods: {
        exportCsv: function exportCsv() {
            this.csvConfig.jsonData = this.genCsvData(this.records.records);
            this.$refs.smart_table.downloadCsv();
        },
        genSalesmenTableConfig: function genSalesmenTableConfig(data) {
            if (data && (0, _keys2.default)(data).length > 0) {
                for (var i = 1; i < 7; i++) {
                    var name = 'level_' + i + '_salesperson_visible';
                    if (data.hasOwnProperty(name)) {
                        var column = 'level_' + i + '_member';
                        this.tableConfig.columns.push({ keys: column, head: '業務代表' + i });
                        this.csvConfig.column.push({ keys: column, name: '業務代表' + i });
                    }
                }
                this.adjustRemarkPlace();
            }
        },
        adjustRemarkPlace: function adjustRemarkPlace() {
            var moveToEnd = function moveToEnd(array, keys) {
                var idx = array.findIndex(function (element) {
                    return element.keys == keys;
                });
                var item = array.splice(idx, 1)[0];
                array.push(item);
            };
            moveToEnd(this.tableConfig.columns, 'order_remark');
            moveToEnd(this.csvConfig.column, 'order_remark');
        },
        genCsvData: function genCsvData(data) {
            var newData = _lodash2.default.cloneDeep(data);
            for (var key in newData) {
                newData[key].show_payment_way = this.showPaymentName(newData[key]);
            }
            return newData;
        },
        showPaymentName: function showPaymentName(item) {
            return this.paymentDisplayName({ 'name': item.studio_payment_method_name, 'alias_name': item.studio_payment_method_alias_name });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div id=\"detail-table\">\n    <div class=\"row total-list\" v-if=\"list.hasOwnProperty('total') &amp;&amp; !ajaxing\">\n        <h4 class=\"col-xs-12\">總計：${{list.total}}</h4>\n    </div>\n    <v-smart-table ref=\"smart_table\" :table-config=\"tableConfig\" :csv-config=\"csvConfig\" :is-ajaxing=\"ajaxing\" :data=\"records\" @change-page=\"changePage\"></v-smart-table>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 4, stdin */\n.refund-order {\n  color: red; }\n\n/* line 8, stdin */\n.negative-number {\n  color: red; }\n\n/* line 12, stdin */\n.origin-refunded {\n  color: #C7C4C3; }\n\n/* line 16, stdin */\n.price {\n  text-align: center; }\n\n/* line 20, stdin */\n.table-striped thead {\n  border-bottom: 1px solid #000; }\n\n/* line 26, stdin */\n.total-row {\n  font-weight: bold; }\n\n\n.table-responsive {\n    overflow-y: hidden;\n    white-space: nowrap;\n}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-340d0ee9", module.exports)
  } else {
    hotAPI.update("_v-340d0ee9", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/object/keys":56,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1383:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.refund[_v-7c02a420] {\n  color: red; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['ajaxing', 'list', 'showIncome', 'showRefund'],
    data: function data() {
        return {
            csvConfig: {
                column: [{ keys: 'product_name', name: '項目' }, { keys: 'total_qty', name: '數量' }, { keys: 'percentage_of_total', name: '%金額' }, { keys: 'total', name: '金額' }],
                fileName: 'data',
                jsonData: []
            },
            tableConfig: {
                columns: [{ keys: 'product_name', head: '項目' }, { keys: 'total_qty', head: '數量' }, {
                    keys: 'total',
                    head: '金額',
                    html: function html(item) {
                        return '$' + item.total;
                    }
                }, {
                    keys: 'percentage_of_total',
                    head: '%金額',
                    html: function html(item) {
                        return item.percentage_of_total + '%';
                    }
                }]
            }
        };
    },

    computed: {
        records: function records() {
            return { records: this.list.hasOwnProperty('sales') && this.list.sales.length ? this.list.sales : [], pageMeta: {} };
        },
        refund_records: function refund_records() {
            return { records: this.list.hasOwnProperty('refund') && this.list.refund.length ? this.list.refund : [], pageMeta: {} };
        },
        csv_records: function csv_records() {
            return this.records.records.concat(this.refund_records.records);
        }
    },
    methods: {
        exportCsv: function exportCsv() {
            this.csvConfig.jsonData = this.csv_records;
            this.$refs.smartTable.downloadCsv();
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-7c02a420=\"\">\n    <v-smart-table ref=\"smartTable\" v-if=\"showIncome\" :table-config=\"tableConfig\" :csv-config=\"csvConfig\" :is-ajaxing=\"ajaxing\" :data=\"records\" _v-7c02a420=\"\"></v-smart-table>\n    <v-smart-table ref=\"smartTableRefund\" v-if=\"showRefund\" class=\"refund m-top-50\" :table-config=\"tableConfig\" :is-ajaxing=\"ajaxing\" :data=\"refund_records\" _v-7c02a420=\"\"></v-smart-table>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.refund[_v-7c02a420] {\n  color: red; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-7c02a420", module.exports)
  } else {
    hotAPI.update("_v-7c02a420", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1384:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.page-div[_v-3f963970] {\n  padding: 0px 15px;\n  margin-bottom: 15px; }\n\n/* line 6, stdin */\n.m-l-15[_v-3f963970] {\n  margin-left: 15px; }\n\n/* line 9, stdin */\n.table-div[_v-3f963970] {\n  padding: 20px 0px; }\n\n/* line 12, stdin */\n.form-title[_v-3f963970] {\n  font-size: 16px;\n  font-weight: bold;\n  display: inline-block;\n  width: 60px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	mounted: function mounted() {
		var _this = this;

		this.configuredRun(function () {
			_this.changeFilterOption({
				prop: 'studioId',
				value: _this.configureStates.studioId
			});
			_this.changeFilterOption({
				prop: 'branchId',
				value: _this.configureStates.branchId
			});
			if (_this.configureStates.isSeventeen) {
				return _this.fetchStudioList();
			}
		});
	},

	watch: (0, _defineProperty3.default)({}, 'filterOptions.studioId', function filterOptionsStudioId(n, o) {
		if (this.configureStates.isSeventeen || this.configureStates.isStudio) {
			this.fetchBranchList({
				studioId: n
			});
		}
	}),
	computed: (0, _extends3.default)({
		branchListModify: function branchListModify() {
			if (this.branchList.length == 0) {
				return [];
			}
			var all = {
				id: -1,
				branch_name: '所有場館'
			};
			return [all].concat((0, _toConsumableArray3.default)(this.branchList));
		}
	}, (0, _vuex.mapState)({
		configureStates: function configureStates(state) {
			return state.webadmin.configure;
		}
	}), (0, _vuex.mapState)('webadmin/configure', ['configured', 'studioList', 'branchList']), (0, _vuex.mapState)('webadmin/payrollStatistics', ['blockOpenStatus', 'dateOptions', 'filterOptions', 'ajaxing', 'records', 'detail'])),
	methods: (0, _extends3.default)({
		moneyFormat: function moneyFormat(number) {
			return $17.moneyFormat(number);
		},
		updateFilterOption: function updateFilterOption(field) {
			var _this2 = this;

			return function (value) {
				return _this2.changeFilterOption({
					prop: field,
					value: value
				});
			};
		},
		updateCheckboxItemOption: function updateCheckboxItemOption(field, event) {
			this.changeItemOption({
				prop: field,
				value: event.target.checked
			});
		},
		showDetailModal: function showDetailModal(staff, branch) {
			this.setDetailTarget({
				detail: {
					name: staff.name,
					branch: branch.branch_name,
					payroll: branch.payroll,
					records: branch.records
				}
			});
			$(this.$el).find('.modal').modal('show');
		},
		download: function download(_csvString) {
			var downloadLink = document.createElement("a");
			downloadLink.download = "data.csv";
			downloadLink.innerHTML = "Download File";
			if (window.webkitURL != null) {
				var code = encodeURIComponent(_csvString);
				downloadLink.href = "data:application/csv;charset=utf-8,%EF%BB%BF" + code;
			}
			downloadLink.click();
		},
		downloadStaffCSV: function downloadStaffCSV(staff, branch) {
			var staffData = {
				name: staff.name,
				branch: branch.branch_name,
				payroll: branch.payroll,
				records: branch.records
			};
			var result = this.csvDataHandler(staffData);
			this.download(result);
		},
		csvDataHandler: function csvDataHandler(staffData) {
			var data = [['服務人員', staffData.name], ['場館', staffData.branch], ['薪資', staffData.payroll], ['課程名稱', '日期', '開始時間', '類型', '費用', '次數', '小計']];
			staffData.records.forEach(function (value) {
				data.push([value['name'], value['date'], value['time_start'], value['type'], value['commission_rate'], value['count'], value['subtotal']]);
			});
			var result = Papa.unparse(data, {
				header: false,
				delimiter: ','
			});
			return result;
		}
	}, (0, _vuex.mapActions)('webadmin/configure', ['configuredRun', 'fetchStudioList', 'fetchBranchList']), (0, _vuex.mapActions)('webadmin/payrollStatistics', ['submit', 'toggleBlock', 'changeDateOption', 'changeFilterOption', 'changeItemOption', 'setDetailTarget']))
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<!-- TODO REMOVE 此頁對應權限'webadmin.report.payroll_statistics'已下架 -->\n    <div class=\"page-div\" _v-3f963970=\"\">\n        <v-webadmin-report :block-open-status=\"blockOpenStatus\" :date-options=\"dateOptions\" :toggle-block=\"toggleBlock\" :change-date-option=\"changeDateOption\" :disable-submit=\"ajaxing\" :submit=\"submit\" title=\"薪資統計\" limit-date=\"365\" _v-3f963970=\"\">\n            <div slot=\"second-block\" _v-3f963970=\"\">\n                <div class=\"row\" _v-3f963970=\"\">\n                    <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen\" _v-3f963970=\"\">\n                        <div class=\"form-group\" _v-3f963970=\"\">\n                            <v-select2 text=\"brand_name\" :options=\"studioList\" :disabled=\"configureStates.ajaxing.studioList\" :updated=\"updateFilterOption.call(this, 'studioId')\" :placeholder=\"configureStates.ajaxing.studioList ? '品牌讀取中…' : '請選擇品牌'\" _v-3f963970=\"\">\n                            </v-select2>\n                        </div>\n                    </div>\n                    <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen || configureStates.isStudio\" _v-3f963970=\"\">\n                        <div class=\"form-group\" _v-3f963970=\"\">\n                            <v-select2 text=\"branch_name\" :options=\"branchListModify\" :disabled=\"configureStates.ajaxing.branchList\" :updated=\"updateFilterOption.call(this, 'branchId')\" :placeholder=\"configureStates.ajaxing.branchList ? '場館讀取中…' : '請選擇場館'\" _v-3f963970=\"\">\n                            </v-select2>\n                        </div>\n                    </div>\n                    <div class=\"col-sm-12\" _v-3f963970=\"\">\n                        <div class=\"form-group\" _v-3f963970=\"\">\n                            哪些狀態要納入薪資：\n                            <label class=\"m-l-15\" _v-3f963970=\"\">\n                                <input class=\"current\" type=\"checkbox\" disabled=\"\" checked=\"\" _v-3f963970=\"\"> 出席\n                            </label>\n                            <label _v-3f963970=\"\">\n                                <input type=\"checkbox\" @change=\"updateCheckboxItemOption('absence', $event)\" _v-3f963970=\"\"> 缺席\n                            </label>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </v-webadmin-report>\n        <div class=\"table-div\" _v-3f963970=\"\">\n            <v-table :ajaxing=\"ajaxing\" :length=\"records.length\" _v-3f963970=\"\">\n                <table class=\"table table-striped\" _v-3f963970=\"\">\n                    <thead _v-3f963970=\"\">\n                    <tr _v-3f963970=\"\">\n                        <td _v-3f963970=\"\">場館</td>\n                        <td _v-3f963970=\"\">姓名</td>\n                        <td _v-3f963970=\"\">薪水</td>\n                        <td _v-3f963970=\"\"></td>\n                        <td _v-3f963970=\"\"></td>\n                    </tr>\n                    </thead>\n                    <tbody _v-3f963970=\"\">\n                    <template v-for=\"staff in records\">\n                        <tr v-for=\"branch in staff.payrolls\" _v-3f963970=\"\">\n                            <td _v-3f963970=\"\">{{ branch.branch_name }}</td>\n                            <td _v-3f963970=\"\">{{ staff.name }}</td>\n                            <td _v-3f963970=\"\">{{ moneyFormat(branch.payroll) }}</td>\n                            <td _v-3f963970=\"\"><a @click=\"showDetailModal(staff, branch)\" _v-3f963970=\"\">紀錄</a></td>\n                            <td _v-3f963970=\"\"><a @click=\"downloadStaffCSV(staff, branch)\" _v-3f963970=\"\">下載明細</a></td>\n                        </tr>\n                    </template>\n                    </tbody>\n                </table>\n            </v-table>\n        </div>\n        <v-modal no-footer=\"\" _v-3f963970=\"\">\n            <template v-if=\"detail\">\n                <span slot=\"title\" _v-3f963970=\"\">{{ detail.name }}</span>\n                <div slot=\"body\" _v-3f963970=\"\">\n                    <div class=\"form-group\" _v-3f963970=\"\">\n                        <span class=\"form-title\" _v-3f963970=\"\">場館</span>\n                        {{ detail.branch }}\n                    </div>\n                    <div class=\"form-group\" _v-3f963970=\"\">\n                        <span class=\"form-title\" _v-3f963970=\"\">薪資</span>\n                        {{ moneyFormat(detail.payroll) }}\n                    </div>\n                    <table class=\"table table-striped\" _v-3f963970=\"\">\n                        <thead _v-3f963970=\"\">\n                        <tr _v-3f963970=\"\">\n                            <td _v-3f963970=\"\">課程名稱</td>\n                            <td _v-3f963970=\"\">日期</td>\n                            <td _v-3f963970=\"\">開始時間</td>\n                            <td _v-3f963970=\"\">類型</td>\n                            <td _v-3f963970=\"\">費用</td>\n                            <td _v-3f963970=\"\">次數</td>\n                            <td _v-3f963970=\"\">小計</td>\n                        </tr>\n                        </thead>\n                        <tbody _v-3f963970=\"\">\n                        <tr v-for=\"record in detail.records\" _v-3f963970=\"\">\n                            <td _v-3f963970=\"\">{{ record.name }}</td>\n                            <td _v-3f963970=\"\">{{ record.date }}</td>\n                            <td _v-3f963970=\"\">{{ record.time_start }}</td>\n                            <td _v-3f963970=\"\">{{ record.type }}</td>\n                            <td _v-3f963970=\"\">{{ moneyFormat(record.commission_rate) }}</td>\n                            <td _v-3f963970=\"\">{{ record.count }}</td>\n                            <td _v-3f963970=\"\">{{ moneyFormat(record.subtotal) }}</td>\n                        </tr>\n                        </tbody>\n                    </table>\n                </div>\n            </template>\n        </v-modal>\n    </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.page-div[_v-3f963970] {\n  padding: 0px 15px;\n  margin-bottom: 15px; }\n\n/* line 6, stdin */\n.m-l-15[_v-3f963970] {\n  margin-left: 15px; }\n\n/* line 9, stdin */\n.table-div[_v-3f963970] {\n  padding: 20px 0px; }\n\n/* line 12, stdin */\n.form-title[_v-3f963970] {\n  font-size: 16px;\n  font-weight: bold;\n  display: inline-block;\n  width: 60px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-3f963970", module.exports)
  } else {
    hotAPI.update("_v-3f963970", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/defineProperty":65,"babel-runtime/helpers/extends":66,"babel-runtime/helpers/toConsumableArray":71,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1385:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.page-div[_v-e2d38c88] {\n  padding: 0px 15px;\n  margin-bottom: 15px; }\n\n/* line 7, stdin */\n.m-l-15[_v-e2d38c88] {\n  margin-left: 15px; }\n\n/* line 11, stdin */\n.table-div[_v-e2d38c88] {\n  padding: 20px 0px; }\n\n/* line 15, stdin */\n.form-title[_v-e2d38c88] {\n  font-size: 16px;\n  font-weight: bold;\n  display: inline-block;\n  width: 60px; }\n\n/* line 22, stdin */\n.negative-number[_v-e2d38c88] {\n  color: red; }\n\n/* line 26, stdin */\n.cube[_v-e2d38c88] {\n  max-width: 80px;\n  float: left;\n  margin: 12px 24px;\n  font-weight: bold;\n  font-size: 18px; }\n\n/* line 33, stdin */\n.total-list[_v-e2d38c88] {\n  width: 100%;\n  border: 1px solid;\n  margin: 30px 0px; }\n\n/* line 38, stdin */\n.total-list[_v-e2d38c88]:after {\n  clear: both; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _watch;

var _vuex = require('vuex');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            display: 'show',
            type: {
                'name': '促銷',
                'value': 1
            },
            discountOption: [{
                'name': '促銷',
                'value': 1
            }, {
                'name': '優惠券',
                'value': 2
            }],
            promotionIds: [],
            promotionLists: [],
            view: {
                ajaxing: {
                    promotionList: false,
                    fetchList: false
                }
            },
            detailList: [],
            summaryList: [],
            detailTotal: [],
            summaryTotal: []
        };
    },
    mounted: function mounted() {
        var _this = this;

        this.configuredRun(function () {
            _this.changeFilterOption({
                prop: 'studioId',
                value: {
                    id: _this.configureStates.studioId,
                    brand_name: ''
                }
            });
            _this.changeFilterOption({
                prop: 'branchId',
                value: _this.configureStates.branchId
            });
            if (_this.configureStates.isSeventeen) {
                return _this.fetchStudioList();
            }
            if (_this.configureStates.isBranch) {
                _this.branchIds = [{
                    'id': _this.configureStates.branchId,
                    'branch_name': ''
                }];
            }
            // if (this.configureStates.isStudio) {
            //     this.fetchContractList({ 'studioId':this.configureStates.studioId,'withDelete':true});
            // }
            // if (this.configureStates.isBranch) {
            //     this.fetchContractList({'studioId':this.configureStates.studioId,'branchId':this.configureStates.branchID,'withDelete':true});
            // }
        });

        this.changeDateOption({
            prop: 'startDate',
            value: moment().add(-1, 'months').format('YYYY/MM/DD')
        });

        this.changeDateOption({
            prop: 'endDate',
            value: moment().add(-1, 'days').format('YYYY/MM/DD')
        });

        this.changeItemOption({
            prop: 'viewMode',
            value: 'detail'
        });
    },

    watch: (_watch = {}, (0, _defineProperty3.default)(_watch, 'filterOptions.studioId', function filterOptionsStudioId(n, o) {
        if (this.configureStates.isSeventeen || this.configureStates.isStudio) {
            this.fetchBranchList({
                studioId: n.id,
                appendStduio: true,
                showStudioName: '品牌促銷'
            });
        }
    }), (0, _defineProperty3.default)(_watch, 'detailList', function detailList(newValue, oldValue) {
        if (newValue.length > 0 && this.display === 'export' && this.viewMode === 'detail') {
            var results = this.csvDataHandler(newValue, this.viewMode);
            this.download(results);
        }
    }), (0, _defineProperty3.default)(_watch, 'summaryList', function summaryList(newValue, oldValue) {
        if (newValue.length > 0 && this.display === 'export' && this.viewMode === 'summary') {
            var results = this.csvDataHandler(newValue, this.viewMode);
            this.download(results);
        }
    }), (0, _defineProperty3.default)(_watch, 'branchIds', function branchIds(newValue, oldValue) {
        this.promotionLists = [];
        if (newValue.length > 0) {
            this.getCoupon();
            return;
        }
    }), (0, _defineProperty3.default)(_watch, 'type', function type(newValue, oldValue) {
        this.promotionIds = [];
        this.detailList = [];
        this.summaryList = [];
        this.detailTotal = [];
        this.summaryTotal = [];
        this.promotionLists = [];
        if (this.branchIds.length > 0) {
            this.getCoupon();
            return;
        }
    }), _watch),
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        configureStates: function configureStates(state) {
            return state.webadmin.configure;
        }
    }), (0, _vuex.mapState)('webadmin/configure', ['configured', 'studioList', 'branchList', 'branchId', 'contractList']), (0, _vuex.mapState)('webadmin/baseReport', ['blockOpenStatus', 'dateOptions', 'filterOptions']), {
        studioId: {
            get: function get() {
                return this.filterOptions.studioId;
            },
            set: function set(newValue) {
                var _this2 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                    return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.next = 2;
                                    return _this2.changeFilterOption({ 'prop': 'studioId', value: newValue });

                                case 2:
                                    _this2.cleanBranch();

                                    if (!newValue) {
                                        _context.next = 6;
                                        break;
                                    }

                                    _context.next = 6;
                                    return _this2.fetchBranchList({
                                        studioId: newValue.id,
                                        appendStduio: true,
                                        showStudioName: '品牌促銷'
                                    });

                                case 6:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this2);
                }))();
            }
        },
        branchIds: {
            get: function get() {
                return this.filterOptions.branchIds;
            },
            set: function set(newValue) {
                var _this3 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                    return _regenerator2.default.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    _context2.next = 2;
                                    return _this3.changeFilterOption({ 'prop': 'branchIds', value: newValue });

                                case 2:
                                case 'end':
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, _this3);
                }))();
            }
        },
        ajaxing: {
            get: function get() {
                return this.$store.state.webadmin.baseReport.ajaxing;
            },
            set: function set(newValue) {
                var _this4 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
                    return _regenerator2.default.wrap(function _callee3$(_context3) {
                        while (1) {
                            switch (_context3.prev = _context3.next) {
                                case 0:
                                    _context3.next = 2;
                                    return _this4.changeAjaxing(newValue);

                                case 2:
                                case 'end':
                                    return _context3.stop();
                            }
                        }
                    }, _callee3, _this4);
                }))();
            }
        },
        viewMode: {
            get: function get() {
                return this.$store.state.webadmin.baseReport.itemOptions.viewMode;
            },
            set: function set(value) {
                this.changeItemOption({
                    prop: 'viewMode',
                    value: value
                });
            }
        }

    }),
    methods: (0, _extends3.default)({
        updateFilterOption: function updateFilterOption(field) {
            var _this5 = this;

            return function (value) {
                return _this5.changeFilterOption({
                    prop: field,
                    value: value
                });
            };
        },
        checkMode: function checkMode(mode) {
            return this.viewMode === mode;
        }
    }, (0, _vuex.mapActions)('webadmin/configure', ['configuredRun', 'fetchStudioList', 'fetchBranchList', 'fetchContractList', 'appendBranchListStudio']), (0, _vuex.mapActions)('webadmin/baseReport', ['beforeSubmit', 'toggleBlock', 'changeDateOption', 'changeFilterOption', 'cleanBranch', 'cleanBranchRelated', 'changeItemOption', 'setDetailTarget', "changeAjaxing"]), {
        download: function download(_csvString) {
            var downloadLink = document.createElement("a");
            downloadLink.download = "promotion.csv";
            downloadLink.innerHTML = "Download File";
            if (window.webkitURL != null) {
                var code = encodeURIComponent(_csvString);
                downloadLink.href = "data:application/csv;charset=utf-8,%EF%BB%BF" + code;
            }
            downloadLink.click();
        },
        columnFormatter: function columnFormatter(data, type) {
            String.prototype.replaceAll = function (search, replacement) {
                var target = this;
                return target.replace(new RegExp(search, 'g'), replacement);
            };

            if (this.type.value == 1) {
                if (type === 'detail') {
                    return this.detailPromotionColumnFormatter(data);
                }
                if (type === 'summary') {
                    return this.summaryPromotionColumnFormatter(data);
                }
            }
            if (this.type.value == 2) {
                if (type === 'detail') {
                    return this.detailCouponColumnFormatter(data);
                }
                if (type === 'summary') {
                    return this.summaryCouponColumnFormatter(data);
                }
            }
        },
        detailPromotionColumnFormatter: function detailPromotionColumnFormatter(data) {
            var data = _lodash2.default.map(data, function (value) {
                return _lodash2.default.pick(value, ['order_id', 'member_name', 'branch_name', 'checkout_at', 'coupon_name', 'product_name', 'price', 'discount']);
            });
            data.unshift({
                'order_id': this.detailTotal.order_id,
                'member_name': this.detailTotal.member_name,
                'branch_name': this.detailTotal.branch_name,
                'checkout_at': this.detailTotal.checkout_at,
                'coupon_name': this.detailTotal.coupon_name,
                'product_name': this.detailTotal.product_name,
                'price': this.detailTotal.price,
                'discount': this.detailTotal.discount
            });

            data = (0, _stringify2.default)(data);
            data = data.replaceAll('branch_name', '銷售場館');
            data = data.replaceAll('checkout_at', '結帳時間');
            data = data.replaceAll('coupon_name', '促銷名稱');
            data = data.replaceAll('discount', '總價值');
            data = data.replaceAll('member_name', '客戶');
            data = data.replaceAll('order_id', '訂單編號');
            data = data.replaceAll('product_name', '訂單商品');
            data = data.replaceAll('price', '折扣前金額');
            data = data.replaceAll('discount', '折扣');

            return data;
        },
        summaryPromotionColumnFormatter: function summaryPromotionColumnFormatter(data) {
            var data = _lodash2.default.map(data, function (value) {
                return _lodash2.default.pick(value, ['name', 'start_date', 'end_date', 'use_count', 'order_price_sum', 'discount_sum']);
            });

            data.unshift({
                'name': this.summaryTotal.name,
                'start_date': this.summaryTotal.start_date,
                'end_date': this.summaryTotal.end_date,
                'use_count': this.summaryTotal.use_count,
                'order_price_sum': this.summaryTotal.order_price_sum,
                'discount_sum': this.summaryTotal.discount_sum
            });

            data = (0, _stringify2.default)(data);
            data = data.replaceAll('name', '促銷名稱');
            data = data.replaceAll('start_date', '開始時間');
            data = data.replaceAll('end_date', '結束時間');
            data = data.replaceAll('discount_sum', '折扣金額');
            data = data.replaceAll('order_price_sum', '折扣前總金額');
            data = data.replaceAll('use_count', '使用數量');

            return data;
        },
        detailCouponColumnFormatter: function detailCouponColumnFormatter(data) {
            var data = _lodash2.default.map(data, function (value) {
                return _lodash2.default.pick(value, ['order_id', 'member_name', 'branch_name', 'checkout_at', 'coupon_name', 'product_name', 'price', 'discount']);
            });

            data.unshift({
                'order_id': this.detailTotal.order_id,
                'member_name': this.detailTotal.member_name,
                'branch_name': this.detailTotal.branch_name,
                'checkout_at': this.detailTotal.checkout_at,
                'coupon_name': this.detailTotal.coupon_name,
                'product_name': this.detailTotal.product_name,
                'price': this.detailTotal.price,
                'discount': this.detailTotal.discount
            });

            data = (0, _stringify2.default)(data);
            data = data.replaceAll('branch_name', '銷售場館');
            data = data.replaceAll('checkout_at', '結帳時間');
            data = data.replaceAll('coupon_name', '優惠券名稱');
            data = data.replaceAll('member_name', '客戶');
            data = data.replaceAll('order_id', '訂單編號');
            data = data.replaceAll('product_name', '訂單商品');
            data = data.replaceAll('price', '折扣前金額');
            data = data.replaceAll('discount', '折扣');

            return data;
        },
        summaryCouponColumnFormatter: function summaryCouponColumnFormatter(data) {
            var data = _lodash2.default.map(data, function (value) {
                return _lodash2.default.pick(value, ['name', 'start_date', 'end_date', 'max_usage_count', 'use_count', 'order_price_sum', 'discount_sum']);
            });

            data.unshift({
                'name': this.summaryTotal.name,
                'start_date': this.summaryTotal.start_date,
                'end_date': this.summaryTotal.end_date,
                'max_usage_count': this.summaryTotal.max_usage_count,
                'use_count': this.summaryTotal.use_count,
                'order_price_sum': this.summaryTotal.order_price_sum,
                'discount_sum': this.summaryTotal.discount_sum
            });

            data = (0, _stringify2.default)(data);
            data = data.replaceAll('name', '優惠券名稱');
            data = data.replaceAll('start_date', '開始時間');
            data = data.replaceAll('end_date', '結束時間');
            data = data.replaceAll('discount_sum', '折扣金額');
            data = data.replaceAll('order_price_sum', '折扣前總金額');
            data = data.replaceAll('use_count', '使用數量');
            data = data.replaceAll('max_usage_count', '最大使用量');

            return data;
        },
        csvDataHandler: function csvDataHandler(watchData, type) {
            var data = [];
            _lodash2.default.assign(data, watchData);
            data = this.columnFormatter(data, type);
            var results = Papa.unparse(data, {
                delimiter: ','
            });
            return results;
        },
        submit: function submit() {
            if (this.branchIds.length === 0) {
                $17.swal({
                    title: '至少需一間場館。',
                    type: 'error'
                });
                return;
            }
            this.beforeSubmit();
            this.getQueryResult();
        },
        getQueryResult: function getQueryResult() {
            var _this6 = this;

            var branchPara = this.branchIds.reduce(function (carry, branch) {
                return carry + '&branch_ids[]=' + branch.id;
            }, '');
            var studioPara = '&studio_id=' + this.studioId.id;
            this.ajaxing = true;

            var branchQuery = '';
            var promotionQuery = '';
            if (this.branchIds.length > 0) {
                branchQuery = this.branchIds.reduce(function (carry, branch) {
                    carry += '&branch_ids[]=' + branch.id;

                    return carry;
                }, '');
            }
            if (this.promotionIds.length > 0) {
                promotionQuery = this.promotionIds.reduce(function (carry, promotion) {
                    carry += '&promotion_ids[]=' + promotion.id;
                    return carry;
                }, '');
            }
            var queryString = 'date_range[start_date]=' + this.dateOptions.startDate + '&date_range[end_date]=' + this.dateOptions.endDate + '&type=' + this.type.value + branchPara + branchQuery + promotionQuery + studioPara;

            this.$http.get('/adminapi/report/fetch_promotion_and_coupon_result?' + queryString).then(function (response) {
                _this6.ajaxing = false;
                var data = response.body;
                _this6.detailList = data.detailList;
                _this6.summaryList = data.totalList;
                _this6.detailTotal = data.detailSum;
                _this6.summaryTotal = data.totalSum;
            }, function (error) {
                _this6.ajaxing = false;
                if (error.status == 0) {
                    $17.swal({
                        title: '伺服器無回應，請檢查網路。',
                        type: 'error'
                    });
                    return;
                }
                $17.swal({
                    title: error.message,
                    type: 'warning'
                });
            });
        },
        getCoupon: function getCoupon() {
            var _this7 = this;

            if (this.branchIds.length > 0) {
                branchQuery = this.branchIds.reduce(function (carry, branch) {
                    carry += '&branch_ids[]=' + branch.id;

                    return carry;
                }, '');
            }
            var studioPara = '&studio_id=' + this.studioId.id;
            this.view.ajaxing.promotionList = true;

            var queryString = 'discount_type=' + this.type.value + branchQuery + studioPara;

            this.$http.get('/adminapi/coupons/filtered?' + queryString).then(function (response) {
                _this7.view.ajaxing.promotionList = false;

                var data = response.body;
                _this7.promotionLists = data;
            }, function (error) {
                _this7.view.ajaxing.promotionList = false;

                if (error.status == 0) {
                    $17.swal({
                        title: '伺服器無回應，請檢查網路。',
                        type: 'error'
                    });
                    return;
                }
                $17.swal({
                    title: error.message,
                    type: 'warning'
                });
            });
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"page-div\" _v-e2d38c88=\"\">\n    <v-webadmin-report :block-open-status=\"blockOpenStatus\" :date-options=\"dateOptions\" :toggle-block=\"toggleBlock\" :change-date-option=\"changeDateOption\" :disable-submit=\"ajaxing\" :submit=\"submit\" limit-date=\"90\" title=\"促銷及優惠券報表\" _v-e2d38c88=\"\">\n        <div slot=\"second-block\" _v-e2d38c88=\"\">\n            <div class=\"row\" _v-e2d38c88=\"\">\n                <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen\" _v-e2d38c88=\"\">\n                    <div class=\"form-group\" _v-e2d38c88=\"\">\n                        <v-mutiselect :model.sync=\"studioId\" :options=\"studioList\" :preserve-search=\"true\" :placeholder=\"configureStates.ajaxing.studioList ? '品牌讀取中…' : '請選擇品牌'\" label=\"brand_name\" track-by=\"id\" _v-e2d38c88=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n                <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen || configureStates.isStudio\" _v-e2d38c88=\"\">\n                    <div class=\"form-group\" _v-e2d38c88=\"\">\n                        <v-mutiselect :model.sync=\"branchIds\" :options=\"branchList\" :disabled=\"configureStates.ajaxing.branchList || view.ajaxing.promotionList\" :multiple=\"true\" :close-on-select=\"true\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"false\" :placeholder=\"configureStates.ajaxing.branchList ? '場館讀取中…' : '請選擇場館'\" label=\"branch_name\" track-by=\"id\" :taggable=\"true\" tag-name=\"branch_name\" :max-height=\"500\" _v-e2d38c88=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n                <div class=\"col-sm-6\" _v-e2d38c88=\"\">\n                    <div class=\"form-group\" _v-e2d38c88=\"\">\n                        <v-mutiselect :model.sync=\"type\" :options=\"discountOption\" :multiple=\"false\" :close-on-select=\"true\" :clear-on-select=\"false\" :hide-selected=\"false\" :preserve-search=\"false\" :searchable=\"false\" label=\"name\" track-by=\"value\" open-direction=\"bottom\" _v-e2d38c88=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n                <div class=\"col-sm-6\" _v-e2d38c88=\"\">\n                    <div class=\"form-group\" _v-e2d38c88=\"\">\n                        <v-mutiselect :model.sync=\"promotionIds\" :options=\"promotionLists\" :disabled=\"view.ajaxing.promotionList\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"false\" :searchable=\"true\" :placeholder=\"configureStates.ajaxing.promotionLists ? '促銷讀取中…' : '全部促銷'\" label=\"name\" track-by=\"id\" :taggable=\"false\" tag-name=\"name\" :max-height=\"300\" open-direction=\"bottom\" _v-e2d38c88=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div slot=\"third-block\" _v-e2d38c88=\"\">\n            <div class=\"row\" _v-e2d38c88=\"\">\n                <div class=\"col-sm-6\" _v-e2d38c88=\"\">\n                    <div class=\"form-group\" _v-e2d38c88=\"\">\n                        <label _v-e2d38c88=\"\">\n                            <input name=\"view\" type=\"radio\" value=\"detail\" v-model=\"viewMode\" checked=\"\" _v-e2d38c88=\"\"> 顯示細節\n                        </label>\n                        <label _v-e2d38c88=\"\">\n                            <input name=\"view\" type=\"radio\" value=\"summary\" v-model=\"viewMode\" _v-e2d38c88=\"\"> 顯示總和\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div slot=\"fourth-block\" _v-e2d38c88=\"\">\n            <div class=\"row\" _v-e2d38c88=\"\">\n                <div class=\"col-sm-6\" _v-e2d38c88=\"\">\n                    <div class=\"form-group row\" _v-e2d38c88=\"\">\n                        <label _v-e2d38c88=\"\">\n                            <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"show\" checked=\"\" _v-e2d38c88=\"\"> 顯示於網頁\n                        </label>\n                        <label _v-e2d38c88=\"\">\n                            <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"export\" _v-e2d38c88=\"\"> 匯出 CSV\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </v-webadmin-report>\n    <div v-show=\"display == 'show'\" _v-e2d38c88=\"\">\n        <div class=\"table-div\" v-if=\"type.value==1\" _v-e2d38c88=\"\">\n            <webadmin-promotion-report-detail v-if=\"checkMode('detail') &amp;&amp; type.value==1\" :list=\"detailList\" :total=\"detailTotal\" :ajaxing=\"ajaxing\" _v-e2d38c88=\"\"></webadmin-promotion-report-detail>\n            <webadmin-promotion-report-summary v-if=\"checkMode('summary') &amp;&amp; type.value==1\" :list=\"summaryList\" :total=\"summaryTotal\" :ajaxing=\"ajaxing\" _v-e2d38c88=\"\"></webadmin-promotion-report-summary>\n            \n        </div>\n        <div class=\"table-div\" v-if=\"type.value==2\" _v-e2d38c88=\"\">\n            <webadmin-coupon-report-detail v-if=\"checkMode('detail') &amp;&amp; type.value==2\" :list=\"detailList\" :total=\"detailTotal\" :ajaxing=\"ajaxing\" _v-e2d38c88=\"\"></webadmin-coupon-report-detail>\n            <webadmin-coupon-report-summary v-if=\"checkMode('summary') &amp;&amp; type.value==2\" :list=\"summaryList\" :total=\"summaryTotal\" :ajaxing=\"ajaxing\" _v-e2d38c88=\"\"></webadmin-coupon-report-summary>\n            \n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.page-div[_v-e2d38c88] {\n  padding: 0px 15px;\n  margin-bottom: 15px; }\n\n/* line 7, stdin */\n.m-l-15[_v-e2d38c88] {\n  margin-left: 15px; }\n\n/* line 11, stdin */\n.table-div[_v-e2d38c88] {\n  padding: 20px 0px; }\n\n/* line 15, stdin */\n.form-title[_v-e2d38c88] {\n  font-size: 16px;\n  font-weight: bold;\n  display: inline-block;\n  width: 60px; }\n\n/* line 22, stdin */\n.negative-number[_v-e2d38c88] {\n  color: red; }\n\n/* line 26, stdin */\n.cube[_v-e2d38c88] {\n  max-width: 80px;\n  float: left;\n  margin: 12px 24px;\n  font-weight: bold;\n  font-size: 18px; }\n\n/* line 33, stdin */\n.total-list[_v-e2d38c88] {\n  width: 100%;\n  border: 1px solid;\n  margin: 30px 0px; }\n\n/* line 38, stdin */\n.total-list[_v-e2d38c88]:after {\n  clear: both; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-e2d38c88", module.exports)
  } else {
    hotAPI.update("_v-e2d38c88", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/json/stringify":48,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/defineProperty":65,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1386:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.page-div[_v-b32bd27c] {\n  padding: 0px 15px;\n  margin-bottom: 15px; }\n\n/* line 7, stdin */\n.table-div[_v-b32bd27c] {\n  padding: 20px 0px; }\n\n/* line 11, stdin */\n.modal-btn[_v-b32bd27c] {\n  color: #38B0E3; }\n\n/* line 14, stdin */\n.total-list[_v-b32bd27c] {\n  margin: 15px 0px 0px 0px; }\n\n/* line 18, stdin */\n.total-list[_v-b32bd27c]:after {\n  clear: both; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _watch;

var _vuex = require('vuex');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        var _this = this;

        return {
            display: 'show',
            result: {},
            list: [],
            scoreAvg: { staff: 0, studio: 0 },
            tableConfig: {
                columns: [{ keys: 'branch_name', head: '場館名稱' }, { keys: 'name', head: '預約項目' }, { keys: 'date', head: '課程/服務開始日期' }, { keys: 'time', head: '課程/服務開始時間' }, { keys: 'staff_name', head: '人員' }, { keys: 'member_name', head: '客戶名稱' }, { keys: 'updated_at', head: '評價更新時間' }, { keys: 'staff_score', head: '人員評價分數' }, { keys: 'studio_score', head: '整體評價分數' }, {
                    keys: 'comment',
                    head: '客戶評論',
                    html: function html(item) {
                        return _this.commentFormat(item.comment);
                    }
                }, {
                    keys: 'id',
                    head: '',
                    minWidth: '4em',
                    html: function html(item) {
                        return _this.commentModal(item.comment);
                    }
                }]
            },
            csvConfig: {
                column: [{ keys: 'branch_name', name: '場館名稱' }, { keys: 'name', name: '預約項目' }, { keys: 'date', name: '課程/服務開始日期' }, { keys: 'time', name: '課程/服務開始時間' }, { keys: 'staff_name', name: '人員' }, { keys: 'member_name', name: '客戶名稱' }, { keys: 'updated_at', name: '評價更新時間' }, { keys: 'staff_score', name: '人員評價分數' }, { keys: 'studio_score', name: '整體評價分數' }, { keys: 'comment', name: '客戶評論' }],
                fileName: 'rating-report-' + moment().format("YYYYMMDDHHmmss"),
                jsonData: []
            },
            relatedFilterWatcher: {
                studio_id: { watcher: null, options: 'studioList', vModel: 'studioId', trackBy: 'id', select: 'single' },
                branch_ids: { watcher: null, options: 'branchList', vModel: 'branchIds', trackBy: 'id', select: 'multi' },
                service_ids: { watcher: null, options: 'serviceList', vModel: 'serviceIds', trackBy: 'id', select: 'multi' },
                service_provider_ids: { watcher: null, options: 'serviceProviderList', vModel: 'serviceProviderIds', trackBy: 'id', select: 'multi' }
            },
            multiFilter: {
                customer_review: { watcher: null, options: 'customerReviewList', vModel: 'customerReviews', trackBy: 'value', type: 'single' },
                staff_score: { watcher: null, options: 'staffScoreList', vModel: 'staffScoreList', trackBy: 'value', type: 'multiple-dropdown' },
                studio_score: { watcher: null, options: 'studioScoreList', vModel: 'studioScoreList', trackBy: 'value', type: 'multiple-dropdown' }
            },
            customerReviews: null,
            customerReviewList: [{
                name: "全部",
                value: "all"
            }, {
                name: "只顯示有評論",
                value: "hasconfirm"
            }],
            staffScoreList: [{ text: "0", value: '0', selected: false }, { text: "1", value: '1', selected: false }, { text: "2", value: '2', selected: false }, { text: "3", value: '3', selected: false }, { text: "4", value: '4', selected: false }, { text: "5", value: '5', selected: false }, { text: "6", value: '6', selected: false }, { text: "7", value: '7', selected: false }, { text: "8", value: '8', selected: false }, { text: "9", value: '9', selected: false }, { text: "10", value: '10', selected: false }],
            studioScoreList: [{ text: "0", value: '0', selected: false }, { text: "1", value: '1', selected: false }, { text: "2", value: '2', selected: false }, { text: "3", value: '3', selected: false }, { text: "4", value: '4', selected: false }, { text: "5", value: '5', selected: false }, { text: "6", value: '6', selected: false }, { text: "7", value: '7', selected: false }, { text: "8", value: '8', selected: false }, { text: "9", value: '9', selected: false }, { text: "10", value: '10', selected: false }],
            chooseDateFilter: [{ text: "依課程/服務開始日期", value: '0', selected: true }, { text: "依評價日期", value: '1', selected: false }],
            comment_all: ''
        };
    },
    created: function created() {
        this.syncMultiSelectByQuery();
        this.syncLocalMultipleSelectByQuery({ vm: this, multiFilter: this.multiFilter });
    },
    mounted: function mounted() {
        var _this2 = this;

        this.configuredRun(function () {
            _this2.changeFilterOption({
                prop: 'studioId',
                value: {
                    id: _this2.configureStates.studioId,
                    brand_name: ''
                }
            });
            _this2.changeFilterOption({
                prop: 'branchId',
                value: _this2.configureStates.branchId
            });
            if (_this2.configureStates.isSeventeen) {
                return _this2.fetchStudioList();
            }
            if (_this2.configureStates.isBranch) {
                _this2.branchIds = [{
                    'id': _this2.configureStates.branchId,
                    'branch_name': ''
                }];
            }
        });
        this.syncDateAndDisplayByQuery();
    },

    watch: (_watch = {}, (0, _defineProperty3.default)(_watch, 'filterOptions.studioId', function filterOptionsStudioId(n, o) {
        if (this.configureStates.isSeventeen && !_lodash2.default.isEmpty(n)) {
            this.fetchBranchList({
                studioId: n.id
            });
        }
        if (this.configureStates.isStudio) {
            this.fetchBranchList({
                studioId: n.id
            });
        }
    }), (0, _defineProperty3.default)(_watch, 'result', function result(newV) {
        if (newV.records !== undefined && newV.records.length > 0 && this.display === 'export') {
            this.csvConfig.jsonData = _lodash2.default.cloneDeep(newV.records);
            this.$refs.smart_table.downloadCsv();
        }
    }), _watch),
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        configureStates: function configureStates(state) {
            return state.webadmin.configure;
        }
    }), (0, _vuex.mapState)('webadmin/configure', ['configured', 'studioList', 'branchList', 'branchId', 'serviceProviderList', 'serviceList']), (0, _vuex.mapState)('webadmin/baseReport', ['blockOpenStatus', 'dateOptions', 'filterOptions', 'queryPara', "ajaxing"]), {
        studioId: {
            get: function get() {
                return this.filterOptions.studioId;
            },
            set: function () {
                var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(newValue) {
                    return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.next = 2;
                                    return this.changeFilterOption({ 'prop': 'studioId', value: newValue });

                                case 2:
                                    if (!_lodash2.default.isEmpty(newValue)) {
                                        $17.updateUrlQueryString({ studio_id: newValue.id });
                                    }
                                    this.cleanBranch();
                                    this.cleanBranchRelated();

                                    if (!newValue) {
                                        _context.next = 9;
                                        break;
                                    }

                                    _context.next = 8;
                                    return this.fetchBranchList({ studioId: newValue.id });

                                case 8:
                                    this.fetchBranchAppendList();

                                case 9:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, this);
                }));

                function set(_x) {
                    return _ref.apply(this, arguments);
                }

                return set;
            }()
        },
        branchIds: {
            get: function get() {
                return this.filterOptions.branchIds;
            },
            set: function () {
                var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(newValue) {
                    return _regenerator2.default.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    _context2.next = 2;
                                    return this.changeFilterOption({ 'prop': 'branchIds', value: newValue });

                                case 2:
                                    $17.updateUrlQueryString({ branch_ids: newValue.map(function (el) {
                                            return el.id;
                                        }) });
                                    this.cleanBranchRelated();
                                    if (newValue) {
                                        this.fetchBranchAppendList();
                                    }

                                case 5:
                                case 'end':
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, this);
                }));

                function set(_x2) {
                    return _ref2.apply(this, arguments);
                }

                return set;
            }()
        },
        serviceIds: {
            get: function get() {
                return this.filterOptions.serviceIds;
            },
            set: function () {
                var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(newValue) {
                    return _regenerator2.default.wrap(function _callee3$(_context3) {
                        while (1) {
                            switch (_context3.prev = _context3.next) {
                                case 0:
                                    _context3.next = 2;
                                    return this.changeFilterOption({ 'prop': 'serviceIds', value: newValue });

                                case 2:
                                    $17.updateUrlQueryString({ service_ids: newValue.map(function (el) {
                                            return el.id;
                                        }) });

                                case 3:
                                case 'end':
                                    return _context3.stop();
                            }
                        }
                    }, _callee3, this);
                }));

                function set(_x3) {
                    return _ref3.apply(this, arguments);
                }

                return set;
            }()
        },
        serviceProviderIds: {
            get: function get() {
                return this.filterOptions.serviceProviderIds;
            },
            set: function () {
                var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(newValue) {
                    return _regenerator2.default.wrap(function _callee4$(_context4) {
                        while (1) {
                            switch (_context4.prev = _context4.next) {
                                case 0:
                                    _context4.next = 2;
                                    return this.changeFilterOption({ 'prop': 'serviceProviderIds', value: newValue });

                                case 2:
                                    $17.updateUrlQueryString({ service_provider_ids: newValue.map(function (el) {
                                            return el.id;
                                        }) });

                                case 3:
                                case 'end':
                                    return _context4.stop();
                            }
                        }
                    }, _callee4, this);
                }));

                function set(_x4) {
                    return _ref4.apply(this, arguments);
                }

                return set;
            }()
        }
    }),
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('webadmin/configure', ['configuredRun', 'fetchStudioList', 'fetchBranchList', 'fetchServiceProviderAllList', 'fetchServiceList']), (0, _vuex.mapActions)('webadmin/baseReport', ['beforeSubmit', 'toggleBlock', 'changeDateOption', 'changeFilterOption', 'cleanBranch', 'cleanBranchRelated', 'changeItemOption', 'setDetailTarget', 'keepQueryParam', "changeAjaxing", "syncLocalMultipleSelectByQuery"]), {
        clickHtmlHandler: function clickHtmlHandler(val) {
            this[val.action](val.row);
        },
        commentFormat: function commentFormat(comment) {
            if (comment.length > 100) {
                comment = comment.substring(0, 100) + '...';
            }
            return '<div class="st-break-all">' + comment + '</div>';
        },
        commentModal: function commentModal(comment) {
            var comment_modal = '';
            if (comment.length > 100) {
                comment_modal += '<a class="modal-btn btn btn-guest" @click.prevent.stop="clickHandler(\'commentModalShow\', $event)">\n                        <i class="material-icons st-text-16 st-align-sub">open_in_full</i>\n                    </a>';
            }
            return '' + comment_modal;
        },
        commentModalShow: function commentModalShow(data) {
            this.comment_all = data.comment;
            $('#comment_modal').modal('show');
        },
        staffScoreHandler: function staffScoreHandler(selectedArr, selectObj, menuItems) {
            this.staffScoreList = menuItems;
        },
        studioScoreHandler: function studioScoreHandler(selectedArr, selectObj, menuItems) {
            this.studioScoreList = menuItems;
        },
        submitSearch: function submitSearch() {
            this.beforeSubmit();
            switch (this.display) {
                case "export":
                    this.changeFilterOption({ prop: "pageSize", value: 9999999 });
                    break;
                case "show":
                    this.changeFilterOption({ prop: "pageSize", value: 25 });
                    break;
                default:
                    null;
            }
            var params = this.getParams();
            this.keepQueryParam(params);
            $17.updateUrlQueryString(params);
            this.changePage(1);
        },
        getDetailResult: function getDetailResult(params) {
            var _this3 = this;

            this.changeAjaxing(true);
            this.$http.get('/adminapi/report/fetch_rating_detail', { params: params }).then(function (response) {
                _this3.result = response.data;
                _this3.changeAjaxing(false);
            }, function (error) {
                _this3.changeAjaxing(false);
                $17.swal({
                    title: error.body.message || '伺服器無回應，請檢查網路。',
                    type: 'warning'
                });
            });
        },
        getScoreAvg: function getScoreAvg(params) {
            var _this4 = this;

            this.changeAjaxing(true);
            this.$http.get('/adminapi/report/fetch_rating_score_avg', { params: params }).then(function (response) {
                _this4.scoreAvg = response.body;
            }, function (error) {
                _this4.changeAjaxing(false);
                $17.swal({
                    title: error.body.message || '伺服器無回應，請檢查網路。',
                    type: 'warning'
                });
            });
        },
        getParams: function getParams() {
            return {
                'studio_id': this.studioId && this.studioId.hasOwnProperty('id') ? this.studioId.id : 0,
                'branch_ids': this.branchIds ? this.branchIds.map(function (item) {
                    return item.id;
                }) : [],
                'service_provider_ids': this.serviceProviderIds ? this.serviceProviderIds.map(function (item) {
                    return item.id;
                }) : [],
                'service_ids': this.serviceIds ? this.serviceIds.map(function (item) {
                    return item.id;
                }) : [],
                'staff_score': this.staffScoreList.filter(function (item) {
                    return item.selected;
                }).map(function (item) {
                    return item.value;
                }),
                'studio_score': this.studioScoreList.filter(function (item) {
                    return item.selected;
                }).map(function (item) {
                    return item.value;
                }),
                'start_date': this.dateOptions.startDate,
                'end_date': this.dateOptions.endDate,
                'filter_date': this.dateOptions.filterDate,
                'customer_review': this.customerReviews ? this.customerReviews.value : 'null'
            };
        },
        syncDateAndDisplayByQuery: function syncDateAndDisplayByQuery() {
            var query = $17.getUrlQueryStrings();
            var start_date = query.start_date ? query.start_date : moment().add(-6, 'days');
            var end_date = query.end_date ? query.end_date : moment();
            var filter_date = query.filter_date ? query.filter_date : '0';
            this.display = query.display ? query.display : 'show';
            this.changeDateOption({
                prop: 'startDate',
                value: this.dateFormat(start_date)
            });
            this.changeDateOption({
                prop: 'endDate',
                value: this.dateFormat(end_date)
            });
            this.changeDateOption({
                prop: 'filterDate',
                value: filter_date
            });
        },
        dateFormat: function dateFormat(date) {
            return moment(date).format('YYYY/MM/DD');
        },
        syncMultiSelectByQuery: function syncMultiSelectByQuery() {
            var vm = this;
            var query = _lodash2.default.cloneDeep($17.getUrlQueryStrings());
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                var _loop = function _loop() {
                    var _step$value = (0, _slicedToArray3.default)(_step.value, 2),
                        key = _step$value[0],
                        value = _step$value[1];

                    value.watcher = vm.$watch(value.options, function (newV, oldV) {
                        if (!_lodash2.default.isEmpty(newV)) {
                            var queryArr = query[key] ? query[key].split(",") : [];
                            var resultArr = [];
                            var isMultiSelect = value.select == 'multi';
                            queryArr.forEach(function (el) {
                                var findEl = newV.find(function (item) {
                                    return item[value.trackBy] == el;
                                });
                                findEl ? resultArr.push(findEl) : null;
                            });
                            vm[value.vModel] = isMultiSelect ? resultArr : resultArr[0];
                            value.watcher();
                        }
                    });
                };

                for (var _iterator = (0, _getIterator3.default)((0, _entries2.default)(vm.relatedFilterWatcher)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    _loop();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        },
        fetchBranchAppendList: function fetchBranchAppendList() {
            var studioId = this.filterOptions.studioId;
            var branchIds = this.filterOptions.branchIds.map(function (elem) {
                return elem.id;
            });
            if (branchIds.length == 0) {
                branchIds = this.branchList.map(function (elem) {
                    return elem.id;
                });
            }
            var payload = {
                studioId: studioId.id,
                branchIds: branchIds,
                isNotDelete: '1',
                startDate: this.dateOptions.startDate,
                endDate: this.dateOptions.endDate
            };
            this.fetchServiceProviderAllList(payload);
            this.fetchServiceList(payload);
        },
        changeDateOptionAfter: function changeDateOptionAfter($dateObj) {
            this.changeDateOption($dateObj);
            this.cleanBranchRelated();
            this.fetchBranchAppendList();
            $17.updateUrlQueryString({
                start_date: this.dateOptions.startDate,
                end_date: this.dateOptions.endDate
            });
        },
        scoreFormat: function scoreFormat(score) {
            return parseFloat(score).toFixed(2);
        },
        changePage: function changePage(page) {
            var _this5 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5() {
                var params;
                return _regenerator2.default.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _this5.changeFilterOption({
                                    prop: "page",
                                    value: page
                                });

                                params = _this5.queryPara;


                                params.page_size = _this5.filterOptions.pageSize;
                                params.page = _this5.filterOptions.page;
                                if (_this5.filterOptions.studioId.id > 0) {
                                    _this5.reset();
                                    if (_this5.display == 'show') {
                                        _this5.getScoreAvg(params);
                                    }
                                    _this5.getDetailResult(params);
                                }

                            case 5:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this5);
            }))();
        },
        reset: function reset() {
            this.result = {};
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"page-div\" _v-b32bd27c=\"\">\n    <v-webadmin-report :block-open-status=\"blockOpenStatus\" :date-options=\"dateOptions\" :toggle-block=\"toggleBlock\" :change-date-option=\"changeDateOptionAfter\" :disable-submit=\"ajaxing\" :submit=\"submitSearch\" :choose-date-filter=\"chooseDateFilter\" limit-date=\"180\" title=\"評價報表\" _v-b32bd27c=\"\">\n        <div slot=\"second-block\" _v-b32bd27c=\"\">\n            <div class=\"filters\" _v-b32bd27c=\"\">\n                <div class=\"row\" _v-b32bd27c=\"\">\n                    <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen\" _v-b32bd27c=\"\">\n                        <div class=\"form-group\" _v-b32bd27c=\"\">\n                            <v-mutiselect :model.sync=\"studioId\" :options=\"studioList\" :preserve-search=\"true\" :placeholder=\"configureStates.ajaxing.studioList ? '品牌讀取中…' : '請選擇品牌'\" label=\"brand_name\" track-by=\"id\" _v-b32bd27c=\"\">\n                            </v-mutiselect>\n                        </div>\n                    </div>\n                    <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen || configureStates.isStudio\" _v-b32bd27c=\"\">\n                        <div class=\"form-group\" _v-b32bd27c=\"\">\n                            <v-mutiselect :model.sync=\"branchIds\" :options=\"branchList\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"false\" :placeholder=\"configureStates.ajaxing.branchList ? '場館讀取中…' : '全部場館'\" label=\"branch_name\" track-by=\"id\" :taggable=\"true\" tag-name=\"branch_name\" :max-height=\"500\" _v-b32bd27c=\"\">\n                            </v-mutiselect>\n                        </div>\n                    </div>\n                    <div class=\"col-sm-6\" _v-b32bd27c=\"\">\n                        <div class=\"form-group\" _v-b32bd27c=\"\">\n                            <v-mutiselect :model.sync=\"serviceProviderIds\" :options=\"serviceProviderList\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"false\" :placeholder=\"configureStates.ajaxing.serviceProviderList ? '人員讀取中…' : '全部人員'\" label=\"name\" track-by=\"id\" :max-height=\"500\" tag-name=\"name\" _v-b32bd27c=\"\">\n\n                            </v-mutiselect>\n                        </div>\n                    </div>\n                    <div class=\"col-sm-6\" _v-b32bd27c=\"\">\n                        <div class=\"form-group\" _v-b32bd27c=\"\">\n                            <v-mutiselect :model.sync=\"serviceIds\" :options=\"serviceList\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :placeholder=\"configureStates.ajaxing.serviceList ? '項目讀取中…' : '全部項目'\" label=\"name\" track-by=\"id\" :max-height=\"500\" tag-name=\"name\" _v-b32bd27c=\"\">\n                            </v-mutiselect>\n                        </div>\n                    </div>\n                    <div class=\"col-sm-6\" _v-b32bd27c=\"\">\n                        <div class=\"form-group\" _v-b32bd27c=\"\">\n                            <v-mutiselect :model.sync=\"customerReviews\" :options=\"customerReviewList\" :multiple=\"false\" :close-on-select=\"true\" :clear-on-select=\"false\" :hide-selected=\"false\" :preserve-search=\"true\" :searchable=\"false\" placeholder=\"客戶評論\" label=\"name\" track-by=\"value\" :max-height=\"500\" _v-b32bd27c=\"\">\n                            </v-mutiselect>\n                        </div>\n                    </div>\n                    <div class=\"col-sm-6\" _v-b32bd27c=\"\">\n                        <div class=\"form-group\" _v-b32bd27c=\"\">\n                            <div class=\"input-group\" _v-b32bd27c=\"\">\n                                <st-multiple-select @change=\"staffScoreHandler\" :options=\"staffScoreList\" empty-text=\"人員評價分數\" select-all=\"\" _v-b32bd27c=\"\"></st-multiple-select>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"col-sm-6\" _v-b32bd27c=\"\">\n                        <div class=\"form-group\" _v-b32bd27c=\"\">\n                            <div class=\"input-group\" _v-b32bd27c=\"\">\n                                <st-multiple-select @change=\"studioScoreHandler\" :options=\"studioScoreList\" empty-text=\"整體評價分數\" select-all=\"\" _v-b32bd27c=\"\"></st-multiple-select>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div slot=\"fourth-block\" _v-b32bd27c=\"\">\n            <div class=\"row m-left-0\" _v-b32bd27c=\"\">\n                <div class=\"col-sm-6\" _v-b32bd27c=\"\">\n                    <div class=\"form-group row\" _v-b32bd27c=\"\">\n                        <label _v-b32bd27c=\"\">\n                            <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"show\" checked=\"\" _v-b32bd27c=\"\"> 顯示於網頁\n                        </label>\n                        <label _v-b32bd27c=\"\">\n                            <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"export\" _v-b32bd27c=\"\"> 匯出 CSV\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </v-webadmin-report>\n    <div v-show=\"display==='show'\" _v-b32bd27c=\"\">\n        <div class=\"row total-list\" _v-b32bd27c=\"\">\n            <h4 _v-b32bd27c=\"\">人員平均評價：{{scoreFormat(scoreAvg.staff)}} 整體平均評價：{{scoreFormat(scoreAvg.studio)}}</h4>\n        </div>\n        <div class=\"table-div\" _v-b32bd27c=\"\">\n            <v-smart-table ref=\"smart_table\" :table-config=\"tableConfig\" :csv-config=\"csvConfig\" :is-ajaxing=\"ajaxing\" :data=\"result\" :page-sync-url-query=\"false\" @change-page=\"changePage\" @html-click-callback=\"clickHtmlHandler\" _v-b32bd27c=\"\"></v-smart-table>\n        </div>\n    </div>\n    <v-modal id=\"comment_modal\" no-footer=\"\" _v-b32bd27c=\"\">\n        <div slot=\"title\" _v-b32bd27c=\"\">\n            <p class=\"modal-title\" _v-b32bd27c=\"\">客戶評論</p>\n        </div>\n        <div slot=\"body\" _v-b32bd27c=\"\">\n            <p class=\"txt-small word-break grey--100\" _v-b32bd27c=\"\">{{this.comment_all}}</p>\n        </div>\n    </v-modal>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.page-div[_v-b32bd27c] {\n  padding: 0px 15px;\n  margin-bottom: 15px; }\n\n/* line 7, stdin */\n.table-div[_v-b32bd27c] {\n  padding: 20px 0px; }\n\n/* line 11, stdin */\n.modal-btn[_v-b32bd27c] {\n  color: #38B0E3; }\n\n/* line 14, stdin */\n.total-list[_v-b32bd27c] {\n  margin: 15px 0px 0px 0px; }\n\n/* line 18, stdin */\n.total-list[_v-b32bd27c]:after {\n  clear: both; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-b32bd27c", module.exports)
  } else {
    hotAPI.update("_v-b32bd27c", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/get-iterator":46,"babel-runtime/core-js/object/entries":54,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/defineProperty":65,"babel-runtime/helpers/extends":66,"babel-runtime/helpers/slicedToArray":70,"babel-runtime/regenerator":75,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1387:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.page-div[_v-2fcad844] {\n  padding: 0px 15px;\n  margin-bottom: 15px; }\n\n/* line 7, stdin */\n.m-l-15[_v-2fcad844] {\n  margin-left: 15px; }\n\n/* line 11, stdin */\n.table-div[_v-2fcad844] {\n  padding: 20px 0px; }\n\n/* line 15, stdin */\n.form-title[_v-2fcad844] {\n  font-size: 16px;\n  font-weight: bold;\n  display: inline-block;\n  width: 60px; }\n\n/* line 22, stdin */\n.negative-number[_v-2fcad844] {\n  color: red; }\n\n/* line 26, stdin */\n.cube[_v-2fcad844] {\n  max-width: 80px;\n  float: left;\n  margin: 12px 24px;\n  font-weight: bold;\n  font-size: 18px; }\n\n/* line 33, stdin */\n.total-list[_v-2fcad844] {\n  width: 100%;\n  border: 1px solid;\n  margin: 30px 0px; }\n\n/* line 38, stdin */\n.total-list[_v-2fcad844]:after {\n  clear: both; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _watch;

var _vuex = require('vuex');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            display: 'show',
            valuesList: [],
            daysList: [],
            contractIds: [],
            calculateTotalRecognizedValue: {
                days: '',
                values: ''
            },
            calculateRecognizedValue: {
                days: '',
                values: ''
            }
        };
    },
    mounted: function mounted() {
        var _this = this;

        this.configuredRun(function () {
            _this.changeFilterOption({
                prop: 'studioId',
                value: {
                    id: _this.configureStates.studioId,
                    brand_name: ''
                }
            });
            _this.changeFilterOption({
                prop: 'branchId',
                value: _this.configureStates.branchId
            });
            if (_this.configureStates.isSeventeen) {
                return _this.fetchStudioList();
            }
            if (_this.configureStates.isBranch) {
                _this.branchIds = [{
                    'id': _this.configureStates.branchId,
                    'branch_name': ''
                }];
            }
            if (_this.configureStates.isStudio) {
                _this.fetchContractList({ 'studioId': _this.configureStates.studioId, 'withDelete': true });
            }
            if (_this.configureStates.isBranch) {
                _this.fetchContractList({ 'studioId': _this.configureStates.studioId, 'branchId': _this.configureStates.branchID, 'withDelete': true });
            }
        });

        this.changeDateOption({
            prop: 'startDate',
            value: moment().add(-1, 'days').format('YYYY/MM/DD')
        });

        this.changeDateOption({
            prop: 'endDate',
            value: moment().add(-1, 'days').format('YYYY/MM/DD')
        });

        this.changeItemOption({
            prop: 'viewMode',
            value: 'values'
        });
    },

    watch: (_watch = {}, (0, _defineProperty3.default)(_watch, 'filterOptions.studioId', function filterOptionsStudioId(n, o) {
        if (this.configureStates.isSeventeen || this.configureStates.isStudio) {
            this.fetchBranchList({
                studioId: n.id
            });
        }
        if (this.configureStates.isSeventeen && n.id != 0) {
            this.fetchContractList({ 'studioId': n.id });
        }
    }), (0, _defineProperty3.default)(_watch, 'valuesList', function valuesList(newValue, oldValue) {
        var _this2 = this;

        if (newValue.length > 0 && this.display === 'export' && this.viewMode === 'values') {
            var results = this.csvDataHandler({ data: newValue, columnFormater: this.valueColumnFormater }).then(function (results) {
                _this2.download({ csvString: results, name: 'recognition' });
            });
        }
    }), (0, _defineProperty3.default)(_watch, 'daysList', function daysList(newValue, oldValue) {
        var _this3 = this;

        if ((0, _keys2.default)(newValue).length > 0 && this.display === 'export' && this.viewMode === 'days') {
            var results = this.csvDataHandler({ data: newValue, columnFormater: this.daysColumnFormater }).then(function (results) {
                _this3.download({ csvString: results, name: 'recognition' });
            });
        }
    }), _watch),
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        configureStates: function configureStates(state) {
            return state.webadmin.configure;
        }
    }), (0, _vuex.mapState)('webadmin/configure', ['configured', 'studioList', 'branchList', 'branchId', 'contractList']), (0, _vuex.mapState)('webadmin/baseReport', ['blockOpenStatus', 'dateOptions', 'filterOptions']), {
        studioId: {
            get: function get() {
                return this.filterOptions.studioId;
            },
            set: function set(newValue) {
                var _this4 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                    return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.next = 2;
                                    return _this4.changeFilterOption({ 'prop': 'studioId', value: newValue });

                                case 2:
                                    _this4.cleanBranch();

                                    if (!newValue) {
                                        _context.next = 6;
                                        break;
                                    }

                                    _context.next = 6;
                                    return _this4.fetchBranchList({ studioId: newValue.id });

                                case 6:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this4);
                }))();
            }
        },
        branchIds: {
            get: function get() {
                return this.filterOptions.branchIds;
            },
            set: function set(newValue) {
                var _this5 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                    return _regenerator2.default.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    _context2.next = 2;
                                    return _this5.changeFilterOption({ 'prop': 'branchIds', value: newValue });

                                case 2:
                                case 'end':
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, _this5);
                }))();
            }
        },
        ajaxing: {
            get: function get() {
                return this.$store.state.webadmin.baseReport.ajaxing;
            },
            set: function set(newValue) {
                var _this6 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
                    return _regenerator2.default.wrap(function _callee3$(_context3) {
                        while (1) {
                            switch (_context3.prev = _context3.next) {
                                case 0:
                                    _context3.next = 2;
                                    return _this6.changeAjaxing(newValue);

                                case 2:
                                case 'end':
                                    return _context3.stop();
                            }
                        }
                    }, _callee3, _this6);
                }))();
            }
        },
        viewMode: {
            get: function get() {
                return this.$store.state.webadmin.baseReport.itemOptions.viewMode;
            },
            set: function set(value) {
                this.changeItemOption({
                    prop: 'viewMode',
                    value: value
                });
            }
        }
    }),
    methods: (0, _extends3.default)({
        updateFilterOption: function updateFilterOption(field) {
            var _this7 = this;

            return function (value) {
                return _this7.changeFilterOption({
                    prop: field,
                    value: value
                });
            };
        },
        checkMode: function checkMode(mode) {
            return this.viewMode === mode;
        }
    }, (0, _vuex.mapActions)('webadmin/configure', ['configuredRun', 'fetchStudioList', 'fetchBranchList', 'fetchContractList']), (0, _vuex.mapActions)('webadmin/baseReport', ['beforeSubmit', 'toggleBlock', 'changeDateOption', 'changeFilterOption', 'cleanBranch', 'cleanBranchRelated', 'changeItemOption', 'setDetailTarget', 'download', 'csvDataHandler', 'columnFormater', "changeAjaxing"]), {
        valueColumnFormater: function valueColumnFormater(data) {
            var data = _lodash2.default.map(data, function (value) {
                return _lodash2.default.pick(value, ['contractName', 'orderId', 'memberName', 'memberEmail', 'memberPhone', 'totalRecognizedValue', 'contractStartDay', 'contractStartDay', 'contractEndDay', 'totalValue', 'usedValue', 'currentRecognizedValue']);
            });
            data.unshift({
                'contractName': '總計',
                'orderId': '',
                'memberName': '',
                'memberEmail': '',
                'memberPhone': '',
                'totalRecognizedValue': this.calculateTotalRecognizedValue.values,
                'contractStartDay': '',
                'contractEndDay': '',
                'totalValue': '',
                'usedValue': '',
                'currentRecognizedValue': this.calculateRecognizedValue.values
            });
            data = (0, _stringify2.default)(data);
            data = data.replaceAll('contractName', '方案名稱');
            data = data.replaceAll('orderId', '訂單 ID');
            data = data.replaceAll('memberName', '客戶姓名');
            data = data.replaceAll('memberEmail', '電子郵件');
            data = data.replaceAll('memberPhone', '客戶電話');
            data = data.replaceAll('totalRecognizedValue', '總價值');
            data = data.replaceAll('contractStartDay', '開始日');
            data = data.replaceAll('contractEndDay', '結束日');
            data = data.replaceAll('totalValue', '總點次');
            data = data.replaceAll('usedValue', '使用點次');
            data = data.replaceAll('currentRecognizedValue', '認列價值');

            return data;
        },
        daysColumnFormater: function daysColumnFormater(data) {
            var data = _lodash2.default.map(data, function (value) {
                return _lodash2.default.pick(value, ['contractName', 'orderId', 'memberName', 'memberEmail', 'memberPhone', 'totalRecognizedValue', 'contractStartDay', 'contractStartDay', 'contractEndDay', 'totalValue', 'usedValue', 'currentRecognizedValue']);
            });
            data.unshift({
                'contractName': '總計',
                'orderId': '',
                'memberName': '',
                'memberEmail': '',
                'memberPhone': '',
                'totalRecognizedValue': this.calculateTotalRecognizedValue.days,
                'contractStartDay': '',
                'contractEndDay': '',
                'totalValue': '',
                'usedValue': '',
                'currentRecognizedValue': this.calculateRecognizedValue.days
            });
            data = (0, _stringify2.default)(data);
            data = data.replaceAll('contractName', '方案名稱');
            data = data.replaceAll('orderId', '訂單 ID');
            data = data.replaceAll('memberName', '客戶姓名');
            data = data.replaceAll('memberEmail', '電子郵件');
            data = data.replaceAll('memberPhone', '客戶電話');
            data = data.replaceAll('totalRecognizedValue', '總價值');
            data = data.replaceAll('contractStartDay', '開始日');
            data = data.replaceAll('contractEndDay', '結束日');
            data = data.replaceAll('totalValue', '總天數');
            data = data.replaceAll('usedValue', '使用天數');
            data = data.replaceAll('currentRecognizedValue', '認列價值');

            return data;
        },
        submit: function submit() {
            this.beforeSubmit();
            this.getQUeryResault();
        },
        getQUeryResault: function getQUeryResault() {
            var _this8 = this;

            var branchPara = this.branchIds.reduce(function (carry, branch) {
                return carry + '&branch_ids[]=' + branch.id;
            }, '');
            var studioPara = this.configureStates.isSeventeen ? '&studio_id=' + this.studioId.id : '';
            this.ajaxing = true;

            var branchQuery = '';
            var contractQuery = '';
            if (this.branchIds.length > 0) {
                branchQuery = this.branchIds.reduce(function (carry, branch) {
                    carry += '&branch_ids[]=' + branch.id;

                    return carry;
                }, '');
            }
            if (this.contractIds.length > 0) {
                contractQuery = this.contractIds.reduce(function (carry, contract) {
                    carry += '&contract_ids[]=' + contract.id;
                    return carry;
                }, '');
            }
            var queryString = 'start_date=' + this.dateOptions.startDate + '&end_date=' + this.dateOptions.endDate + branchPara + branchQuery + contractQuery + studioPara;

            this.$http.get('/adminapi/report/fetch_reconition_value_record?' + queryString).then(function (response) {
                var data = response.body;
                _this8.valuesList = data.list;
                _this8.calculateTotalRecognizedValue.values = data.calculateTotalRecognizedValue;
                _this8.calculateRecognizedValue.values = data.calculateRecognizedValue;
                _this8.ajaxing = false;
            }, function (error) {
                _this8.ajaxing = false;
                if (error.status == 0) {
                    $17.swal({
                        title: '伺服器無回應，請檢查網路。',
                        type: 'error'
                    });
                    return;
                }
                $17.swal({
                    title: error.message,
                    type: 'warning'
                });
            });

            this.$http.get('/adminapi/report/fetch_reconition_day_record?' + queryString).then(function (response) {
                var data = response.body;
                _this8.daysList = data.list;
                _this8.calculateTotalRecognizedValue.days = data.calculateTotalRecognizedValue;
                _this8.calculateRecognizedValue.days = data.calculateRecognizedValue;
                _this8.ajaxing = false;
            }, function (error) {
                _this8.ajaxing = false;
                if (error.status == 0) {
                    $17.swal({
                        title: '伺服器無回應，請檢查網路。',
                        type: 'error'
                    });
                    return;
                }
                $17.swal({
                    title: error.message,
                    type: 'warning'
                });
            });
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"page-div\" _v-2fcad844=\"\">\n    <v-webadmin-report :block-open-status=\"blockOpenStatus\" :date-options=\"dateOptions\" :toggle-block=\"toggleBlock\" :change-date-option=\"changeDateOption\" :disable-submit=\"ajaxing\" :submit=\"submit\" limit-date=\"365\" title=\"認列價值報表\" _v-2fcad844=\"\">\n        <div slot=\"second-block\" _v-2fcad844=\"\">\n            <div class=\"row\" _v-2fcad844=\"\">\n                <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen\" _v-2fcad844=\"\">\n                    <div class=\"form-group\" _v-2fcad844=\"\">\n                        <v-mutiselect :model.sync=\"studioId\" :options=\"studioList\" :preserve-search=\"true\" :placeholder=\"configureStates.ajaxing.studioList ? '品牌讀取中…' : '請選擇品牌'\" label=\"brand_name\" track-by=\"id\" _v-2fcad844=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n            </div>\n            <div class=\"row\" _v-2fcad844=\"\">\n                <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen || configureStates.isStudio\" _v-2fcad844=\"\">\n                    <div class=\"form-group\" _v-2fcad844=\"\">\n                        <v-mutiselect :model.sync=\"branchIds\" :options=\"branchList\" :disabled=\"configureStates.ajaxing.branchList\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"false\" :placeholder=\"configureStates.ajaxing.branchList ? '場館讀取中…' : '全部場館'\" label=\"branch_name\" track-by=\"id\" :taggable=\"true\" tag-name=\"branch_name\" :max-height=\"500\" _v-2fcad844=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n                <div class=\"col-sm-6\" _v-2fcad844=\"\">\n                    <div class=\"form-group\" _v-2fcad844=\"\">\n                        <v-mutiselect :model.sync=\"contractIds\" :options=\"contractList\" :disabled=\"configureStates.ajaxing.contractList\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"true\" :placeholder=\"configureStates.ajaxing.branchList ? '方案讀取中…' : '全部方案'\" label=\"name\" track-by=\"id\" :taggable=\"false\" tag-name=\"name\" :max-height=\"300\" open-direction=\"bottom\" _v-2fcad844=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div slot=\"third-block\" _v-2fcad844=\"\">\n            <div class=\"row\" _v-2fcad844=\"\">\n                <div class=\"col-sm-6\" _v-2fcad844=\"\">\n                    <div class=\"form-group\" _v-2fcad844=\"\">\n                        <label _v-2fcad844=\"\">\n                            <input name=\"view\" type=\"radio\" value=\"values\" v-model=\"viewMode\" checked=\"\" _v-2fcad844=\"\"> 計次\n                        </label>\n                        <label _v-2fcad844=\"\">\n                            <input name=\"view\" type=\"radio\" value=\"days\" v-model=\"viewMode\" _v-2fcad844=\"\"> 計時\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div slot=\"fourth-block\" _v-2fcad844=\"\">\n            <div class=\"row\" _v-2fcad844=\"\">\n                <div class=\"col-sm-6\" _v-2fcad844=\"\">\n                    <div class=\"form-group row\" _v-2fcad844=\"\">\n                        <label _v-2fcad844=\"\">\n                            <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"show\" checked=\"\" _v-2fcad844=\"\"> 顯示於網頁\n                        </label>\n                        <label _v-2fcad844=\"\">\n                            <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"export\" _v-2fcad844=\"\"> 匯出 CSV\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </v-webadmin-report>\n    <div v-show=\"display == 'show'\" _v-2fcad844=\"\">\n        <div class=\"table-div\" _v-2fcad844=\"\">\n            <webadmin-reconition-report-values v-if=\"checkMode('values')\" :ajaxing=\"ajaxing\" :list=\"valuesList\" :calculate-total-recognized-value=\"calculateTotalRecognizedValue.values\" :calculate-recognized-value=\"calculateRecognizedValue.values\" _v-2fcad844=\"\">\n            </webadmin-reconition-report-values>\n            <webadmin-reconition-report-days v-if=\"checkMode('days')\" :ajaxing=\"ajaxing\" :list=\"daysList\" :calculate-total-recognized-value=\"calculateTotalRecognizedValue.days\" :calculate-recognized-value=\"calculateRecognizedValue.days\" _v-2fcad844=\"\">\n            </webadmin-reconition-report-days>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.page-div[_v-2fcad844] {\n  padding: 0px 15px;\n  margin-bottom: 15px; }\n\n/* line 7, stdin */\n.m-l-15[_v-2fcad844] {\n  margin-left: 15px; }\n\n/* line 11, stdin */\n.table-div[_v-2fcad844] {\n  padding: 20px 0px; }\n\n/* line 15, stdin */\n.form-title[_v-2fcad844] {\n  font-size: 16px;\n  font-weight: bold;\n  display: inline-block;\n  width: 60px; }\n\n/* line 22, stdin */\n.negative-number[_v-2fcad844] {\n  color: red; }\n\n/* line 26, stdin */\n.cube[_v-2fcad844] {\n  max-width: 80px;\n  float: left;\n  margin: 12px 24px;\n  font-weight: bold;\n  font-size: 18px; }\n\n/* line 33, stdin */\n.total-list[_v-2fcad844] {\n  width: 100%;\n  border: 1px solid;\n  margin: 30px 0px; }\n\n/* line 38, stdin */\n.total-list[_v-2fcad844]:after {\n  clear: both; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-2fcad844", module.exports)
  } else {
    hotAPI.update("_v-2fcad844", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/json/stringify":48,"babel-runtime/core-js/object/keys":56,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/defineProperty":65,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1388:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n/* line 2, stdin */\nh4[_v-e6756186] {\n  display: inline;\n  padding-right: 50px; }\n\n/* line 6, stdin */\n.page-div[_v-e6756186] {\n  padding: 0 15px;\n  margin-bottom: 15px; }\n\n/* line 11, stdin */\n.m-l-15[_v-e6756186] {\n  margin-left: 15px; }\n\n/* line 15, stdin */\n.table-div[_v-e6756186] {\n  padding: 20px 0; }\n\n/* line 19, stdin */\n.total-list[_v-e6756186] {\n  margin: 15px 0 0 0; }\n\n/* line 23, stdin */\n.total-list[_v-e6756186]:after {\n  clear: both; }\n\n/* line 27, stdin */\n.table-striped thead[_v-e6756186] {\n  border-bottom: 1px solid #000; }\n\n/* line 31, stdin */\n.multiselect[_v-e6756186] {\n  padding-bottom: 5px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _watch;

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    mounted: function mounted() {
        var _this = this;

        this.configuredRun(function () {
            _this.changeFilterOption({
                prop: 'studioId',
                value: {
                    id: _this.configureStates.studioId,
                    brand_name: ''
                }
            });
            _this.changeFilterOption({
                prop: 'branchId',
                value: _this.configureStates.branchId
            });
            if (_this.configureStates.isSeventeen) {
                return _this.fetchStudioList();
            }
            if (_this.configureStates.isBranch) {
                _this.branchIds = [{
                    'id': _this.configureStates.branchId,
                    'branch_name': ''
                }];
            }
        });
        this.changeDateOption({
            prop: 'startDate',
            value: moment().format('YYYY/MM/DD')
        });
        this.changeDateOption({
            prop: 'endDate',
            value: moment().format('YYYY/MM/DD')
        });
    },

    watch: (_watch = {}, (0, _defineProperty3.default)(_watch, 'filterOptions.studioId', function filterOptionsStudioId(n, o) {
        if (this.configureStates.isSeventeen || this.configureStates.isStudio) {
            this.fetchBranchList({
                studioId: n.id
            });
        }
        this.initStaff();
    }), (0, _defineProperty3.default)(_watch, 'dateOptions.startDate', function dateOptionsStartDate(n, o) {
        this.initStaff();
    }), (0, _defineProperty3.default)(_watch, 'dateOptions.endDate', function dateOptionsEndDate(n, o) {
        this.initStaff();
    }), _watch),
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        configureStates: function configureStates(state) {
            return state.webadmin.configure;
        }
    }), (0, _vuex.mapState)('webadmin/configure', ['configured', 'studioList', 'branchList', 'branchId']), (0, _vuex.mapState)('webadmin/orderInvoiceList', ['blockOpenStatus', 'dateOptions', 'filterOptions', 'ajaxing', 'list', 'order_total', 'allowance_total', 'confirmStatus', 'allowanceStatusShow', 'staffMembers', 'staffAjaxing']), {
        studioId: {
            get: function get() {
                return this.filterOptions.studioId;
            },
            set: function set(newValue) {
                var _this2 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                    return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.next = 2;
                                    return _this2.changeFilterOption({ 'prop': 'studioId', value: newValue });

                                case 2:
                                    _this2.cleanBranch();

                                    if (!newValue) {
                                        _context.next = 6;
                                        break;
                                    }

                                    _context.next = 6;
                                    return _this2.fetchBranchList({ studioId: newValue.id });

                                case 6:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this2);
                }))();
            }
        },
        branchIds: {
            get: function get() {
                return this.filterOptions.branchIds;
            },
            set: function set(newValue) {
                var _this3 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                    return _regenerator2.default.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    _context2.next = 2;
                                    return _this3.changeFilterOption({ 'prop': 'branchIds', value: newValue });

                                case 2:
                                case 'end':
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, _this3);
                }))();
            }
        },
        allowanceStatuses: {
            get: function get() {
                return this.filterOptions.allowanceStatuses;
            },
            set: function set(newValue) {
                var _this4 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
                    return _regenerator2.default.wrap(function _callee3$(_context3) {
                        while (1) {
                            switch (_context3.prev = _context3.next) {
                                case 0:
                                    _context3.next = 2;
                                    return _this4.$store.dispatch('webadmin/orderInvoiceList/changeFilterOption', { 'prop': 'allowanceStatuses', value: newValue });

                                case 2:
                                case 'end':
                                    return _context3.stop();
                            }
                        }
                    }, _callee3, _this4);
                }))();
            }
        },
        selectedStaff: {
            get: function get() {
                return this.filterOptions.selectedStaff;
            },
            set: function set(newValue) {
                var _this5 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
                    return _regenerator2.default.wrap(function _callee4$(_context4) {
                        while (1) {
                            switch (_context4.prev = _context4.next) {
                                case 0:
                                    _context4.next = 2;
                                    return _this5.$store.dispatch('webadmin/orderInvoiceList/changeFilterOption', { 'prop': 'selectedStaff', value: newValue });

                                case 2:
                                case 'end':
                                    return _context4.stop();
                            }
                        }
                    }, _callee4, _this5);
                }))();
            }
        }
    }),
    methods: (0, _extends3.default)({
        updateFilterOption: function updateFilterOption(field) {
            var _this6 = this;

            return function (value) {
                return _this6.changeFilterOption({
                    prop: field,
                    value: value
                });
            };
        },
        thousandthFormat: function thousandthFormat(money) {
            return $17.thousandthFormat(money);
        }
    }, (0, _vuex.mapActions)('webadmin/configure', ['configuredRun', 'fetchStudioList', 'fetchBranchList', 'pushObjectStatus']), (0, _vuex.mapActions)('webadmin/orderInvoiceList', ['submitAllowance', 'toggleBlock', 'changeDateOption', 'changeFilterOption', 'changeItemOption', 'cleanBranch', 'cleanBranchRelated', 'initStaff']))
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"page-div\" _v-e6756186=\"\">\n    <v-webadmin-report :block-open-status=\"blockOpenStatus\" :date-options=\"dateOptions\" :toggle-block=\"toggleBlock\" :change-date-option=\"changeDateOption\" :disable-submit=\"ajaxing\" :submit=\"submitAllowance\" limit-date=\"90\" title=\"發票折讓報表\" _v-e6756186=\"\">\n        <div slot=\"second-block\" _v-e6756186=\"\">\n            <div class=\"filters\" _v-e6756186=\"\">\n                <div class=\"row\" _v-e6756186=\"\">\n                    <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen\" _v-e6756186=\"\">\n                        <div class=\"form-group\" _v-e6756186=\"\">\n                            <v-mutiselect :model.sync=\"studioId\" :options=\"studioList\" :preserve-search=\"true\" :placeholder=\"configureStates.ajaxing.studioList ? '品牌讀取中…' : '請選擇品牌'\" label=\"brand_name\" track-by=\"id\" _v-e6756186=\"\">\n                            </v-mutiselect>\n                        </div>\n                    </div>\n                    <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen || configureStates.isStudio\" _v-e6756186=\"\">\n                        <div class=\"form-group\" _v-e6756186=\"\">\n                            <v-mutiselect :model.sync=\"branchIds\" :options=\"branchList\" :disabled=\"configureStates.ajaxing.branchList\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"false\" :placeholder=\"configureStates.ajaxing.branchList ? '場館讀取中…' : '全部場館'\" label=\"branch_name\" track-by=\"id\" :taggable=\"true\" tag-name=\"branch_name\" :max-height=\"500\" _v-e6756186=\"\">\n                            </v-mutiselect>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"row\" _v-e6756186=\"\">\n                    <div class=\"col-sm-6\" _v-e6756186=\"\">\n                        <div class=\"form-group\" _v-e6756186=\"\">\n                            <v-mutiselect :model.sync=\"selectedStaff\" :options=\"staffMembers\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"true\" :placeholder=\"staffAjaxing ? '結帳人員讀取中…' : '全部結帳人員'\" label=\"name\" track-by=\"id\" :max-height=\"500\" tag-name=\"name\" _v-e6756186=\"\">\n                            </v-mutiselect>\n                        </div>\n                    </div>\n                    <div class=\"col-sm-6\" _v-e6756186=\"\">\n                        <div class=\"form-group\" _v-e6756186=\"\">\n                            <v-mutiselect :model.sync=\"allowanceStatuses\" :options=\"allowanceStatusShow\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"false\" :placeholder=\"allowanceStatuses.length>0 ? '' : '所有折讓狀態'\" label=\"name\" track-by=\"status\" :max-height=\"500\" tag-name=\"name\" _v-e6756186=\"\">\n                            </v-mutiselect>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </v-webadmin-report>\n    <div class=\"row total-list\" v-if=\"list.length>0\" _v-e6756186=\"\">\n        <div class=\"col-sm-6\" _v-e6756186=\"\">\n            <h4 _v-e6756186=\"\">總退費金額:{{thousandthFormat(order_total)}}</h4>\n            <h4 _v-e6756186=\"\">總折讓金額:{{thousandthFormat(allowance_total)}}</h4>\n        </div>\n    </div>\n    <div class=\"table-div\" _v-e6756186=\"\">\n        <v-table :ajaxing=\"ajaxing\" :length=\"list.length\" _v-e6756186=\"\">\n            <table class=\"table table-striped\" _v-e6756186=\"\">\n                <thead _v-e6756186=\"\">\n                <tr _v-e6756186=\"\">\n                    <td _v-e6756186=\"\">訂單編號</td>\n                    <td _v-e6756186=\"\">結帳日期</td>\n                    <td _v-e6756186=\"\">退費金額</td>\n                    <td _v-e6756186=\"\">發票折讓金額</td>\n                    <td _v-e6756186=\"\">發票號碼</td>\n                    <td _v-e6756186=\"\">狀態</td>\n                    <td _v-e6756186=\"\">結帳人員</td>\n                </tr>\n                </thead>\n                <tbody _v-e6756186=\"\">\n                <tr v-for=\"item in list\" _v-e6756186=\"\">\n                    <td _v-e6756186=\"\">{{ item.order_id }}</td>\n                    <td _v-e6756186=\"\">{{ item.checkout_at }}</td>\n                    <td _v-e6756186=\"\">{{ item.order_total }}</td>\n                    <td _v-e6756186=\"\">{{ item.allowance_total }}</td>\n                    <td _v-e6756186=\"\">{{ item.invoice_number }}</td>\n                    <td _v-e6756186=\"\">{{ item.status_show }}</td>\n                    <td _v-e6756186=\"\">{{ item.checkout_member }}</td>\n                </tr>\n                </tbody>\n            </table>\n        </v-table>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n/* line 2, stdin */\nh4[_v-e6756186] {\n  display: inline;\n  padding-right: 50px; }\n\n/* line 6, stdin */\n.page-div[_v-e6756186] {\n  padding: 0 15px;\n  margin-bottom: 15px; }\n\n/* line 11, stdin */\n.m-l-15[_v-e6756186] {\n  margin-left: 15px; }\n\n/* line 15, stdin */\n.table-div[_v-e6756186] {\n  padding: 20px 0; }\n\n/* line 19, stdin */\n.total-list[_v-e6756186] {\n  margin: 15px 0 0 0; }\n\n/* line 23, stdin */\n.total-list[_v-e6756186]:after {\n  clear: both; }\n\n/* line 27, stdin */\n.table-striped thead[_v-e6756186] {\n  border-bottom: 1px solid #000; }\n\n/* line 31, stdin */\n.multiselect[_v-e6756186] {\n  padding-bottom: 5px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-e6756186", module.exports)
  } else {
    hotAPI.update("_v-e6756186", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/defineProperty":65,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1389:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.required[_v-3c7d58fa] {\n  color: red; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	data: function data() {
		return {
			categories: {
				1: {
					type: 'sale',
					name: '銷售'
				},
				2: {
					type: 'customer',
					name: '客戶'
				},
				3: {
					type: 'staff',
					name: '人員'
				}
			},
			list: {
				sale: {
					1: {
						name: '每日營業彙總表',
						clickUrl: '/webadmin/report/fetch-branch-sale-daily-summary',
						clickWord: '開啟'
					},
					2: {
						name: '銷售總覽',
						clickUrl: '/webadmin/report/order-detail-total-sale',
						clickWord: '開啟'
					},
					5: {
						name: '發票開立',
						clickUrl: '/webadmin/report/order-invoice-list',
						clickWord: '開啟'
					},
					6: {
						name: '發票折讓',
						clickUrl: '/webadmin/report/refund-order-invoice-list',
						clickWord: '開啟'
					},
					7: {
						name: '全體銷售人員結帳紀錄',
						clickUrl: '/webadmin/report/checkout-report',
						clickWord: '開啟'
					},
					8: {
						name: '個別銷售人員結帳紀錄',
						clickUrl: '/webadmin/report/checkout-member-report',
						clickWord: '開啟'
					},
					9: {
						name: '認列價值報表',
						clickUrl: '/webadmin/report/recognition',
						clickWord: '開啟'
					},
					10: {
						name: '促銷及優惠券報表',
						clickUrl: '/webadmin/report/promotion-coupon-report',
						clickWord: '開啟'
					},
					11: {
						name: '預約價值報表',
						clickUrl: '/webadmin/report/booking-consume-money-report',
						clickWord: '開啟'
					},
					12: {
						name: '自動支付計畫總覽',
						clickUrl: '/webadmin/report/auto-pay-plan-report',
						clickWord: '開啟'
					},
					13: {
						name: '自動支付排程細節',
						clickUrl: '/webadmin/report/auto-pay-plan-detail',
						clickWord: '開啟'
					},
					14: {
						name: '營收對比報表',
						clickUrl: '/webadmin/report/y-o-y-revenue-report',
						clickWord: '開啟'
					},
					16: {
						name: '個別業務業績報表',
						clickUrl: '/webadmin/report/salesmen-kpi-report',
						clickWord: '開啟'
					},
					15: {
						name: '轉贈記錄',
						clickUrl: '/webadmin/report/member-contract-transfer-report',
						clickWord: '開啟'
					},
					17: {
						name: '金流服務試算-銀行轉帳',
						clickUrl: '/webadmin/report/newebpay-bank-transfer-service-fee-report-for-studio',
						clickWord: '開啟'
					}
				},
				customer: {
					1: {
						name: '預約總覽',
						clickUrl: '/webadmin/report/booking-total-list',
						clickWord: '開啟'
					},
					// 2:{
					// 	name:'方案使用總覽',
					// 	clickUrl:'/webadmin/report/sales-performance',
					// 	clickWord:'開啟',
					// },
					// 3:{
					// 	name:'方案剩餘明細',
					// 	clickUrl:'/webadmin/report/member_contract',
					// 	clickWord:'開啟',
					// },
					// 4:{
					// 	name:'方案消耗細節',
					// 	clickUrl:'/webadmin/report/studio_consume_report',
					// 	clickWord:'開啟',
					// },
					5: {
						name: '入場報表',
						clickUrl: '/webadmin/report/admission_statistics',
						clickWord: '開啟'
					},
					6: {
						name: '票券使用紀錄',
						clickUrl: '/webadmin/report/tickets-used-report',
						clickWord: '開啟'
					},
					7: {
						name: '最後一次出席入場',
						clickUrl: '/webadmin/report/last-booking-admission-report',
						clickWord: '開啟'
					},
					8: {
						name: '新註冊客戶',
						clickUrl: '/webadmin/report/member-report',
						clickWord: '開啟'
					},
					9: {
						name: '缺席及遲退報表',
						clickUrl: '/webadmin/report/booking-absence-report',
						clickWord: '開啟'
					},
					10: {
						name: '客戶方案剩餘分析',
						clickUrl: '/webadmin/report/member-contract-remain-report',
						clickWord: '開啟'
					},
					11: {
						name: '客戶方案使用紀錄',
						clickUrl: '/webadmin/report/unlimited-contract-used-record-report',
						clickWord: '開啟'
					},
					12: {
						name: '大戶報表',
						clickUrl: '/webadmin/report/customer-spend-report',
						clickWord: '開啟'
					},
					13: {
						name: '評價報表',
						clickUrl: '/webadmin/report/rating-report',
						clickWord: '開啟'
					}
				},
				staff: {
					2: {
						name: '管理者異動方案紀錄',
						clickUrl: '/webadmin/report/member_contact_admin_change_report',
						clickWord: '開啟'
					},
					3: {
						name: '開課及出席分析',
						clickUrl: '/webadmin/report/booking_report_by_schedule',
						clickWord: '開啟'
					},
					4: {
						name: '薪資統計',
						clickUrl: '/webadmin/salary_report/main',
						clickWord: '開啟'
					},
					5: {
						name: '支付方式異動紀錄',
						clickUrl: '/webadmin/report/order-payment-action-changed-report',
						clickWord: '開啟'
					}
				}
			}
		};
	}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-tab-open-list :categories=\"categories\" :list=\"list\" _v-3c7d58fa=\"\"></v-tab-open-list>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.required[_v-3c7d58fa] {\n  color: red; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-3c7d58fa", module.exports)
  } else {
    hotAPI.update("_v-3c7d58fa", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1390:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _watch;

var _vuex = require('vuex');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            display: 'show',
            list: [],
            staffList: [],
            summaryList: [],
            detailBody: {},
            detailHead: {},
            salaryCategoryId: {
                'id': 0,
                'name': '全部'
            },
            memberIds: [],
            salaryCategories: [{
                'id': 0,
                'name': '全部'
            }, {
                'id': 1,
                'name': '課程'
            }, {
                'id': 2,
                'name': '服務'
            }],
            view: {
                staffAjaxing: false,
                detailAjaxing: false
            }
        };
    },
    mounted: function mounted() {
        var _this = this;

        this.configuredRun(function () {
            _this.changeFilterOption({
                prop: 'studioId',
                value: {
                    id: _this.configureStates.studioId,
                    brand_name: ''
                }
            });
            _this.changeFilterOption({
                prop: 'branchId',
                value: _this.configureStates.branchId
            });
            if (_this.configureStates.isSeventeen) {
                return _this.fetchStudioList();
            }
            if (_this.configureStates.isBranch) {
                _this.branchIds = [{
                    'id': _this.configureStates.branchId,
                    'branch_name': ''
                }];
            }
            if (_this.configureStates.isStudio) {
                _this.getStaff(_this.configureStates.studioId, 0);
            }
            if (_this.configureStates.isBranch) {
                _this.getStaff(_this.configureStates.studioId, _this.configureStates.branchId);
            }
        });

        this.changeDateOption({
            prop: 'startDate',
            value: moment().add(-1, 'days').format('YYYY/MM/DD')
        });

        this.changeDateOption({
            prop: 'endDate',
            value: moment().add(-1, 'days').format('YYYY/MM/DD')
        });

        this.changeItemOption({
            prop: 'viewMode',
            value: 'values'
        });
    },

    watch: (_watch = {}, (0, _defineProperty3.default)(_watch, 'filterOptions.studioId', function filterOptionsStudioId(n, o) {
        if (this.configureStates.isSeventeen || this.configureStates.isStudio) {
            this.fetchBranchList({
                studioId: n.id
            });
        }
    }), (0, _defineProperty3.default)(_watch, 'summaryList', function summaryList(newValue, oldValue) {
        var _this2 = this;

        if (newValue.length > 0 && this.display === 'export') {
            this.csvDataHandler({ data: newValue, columnFormater: this.summaryColumnFormater }).then(function (results) {
                _this2.download({ csvString: results, name: 'salary' });
            });
        }
    }), _watch),
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        configureStates: function configureStates(state) {
            return state.webadmin.configure;
        }
    }), (0, _vuex.mapState)('webadmin/configure', ['configured', 'studioList', 'branchList', 'branchId', 'isBranch', 'isStudio', 'isSeventeen']), (0, _vuex.mapState)('webadmin/baseReport', ['blockOpenStatus', 'dateOptions', 'filterOptions']), {
        studioId: {
            get: function get() {
                return this.filterOptions.studioId;
            },
            set: function set(newValue) {
                var _this3 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                    return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.next = 2;
                                    return _this3.changeFilterOption({ 'prop': 'studioId', value: newValue });

                                case 2:
                                    _this3.cleanBranch();

                                    if (!newValue) {
                                        _context.next = 7;
                                        break;
                                    }

                                    _context.next = 6;
                                    return _this3.fetchBranchList({ studioId: newValue.id });

                                case 6:
                                    if (_this3.isSeventeen) {
                                        _this3.getStaff(newValue, 0);
                                    }

                                case 7:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this3);
                }))();
            }
        },
        branchIds: {
            get: function get() {
                return this.filterOptions.branchIds;
            },
            set: function set(newValue) {
                var _this4 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                    return _regenerator2.default.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    _context2.next = 2;
                                    return _this4.changeFilterOption({ 'prop': 'branchIds', value: newValue });

                                case 2:
                                case 'end':
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, _this4);
                }))();
            }
        },
        ajaxing: {
            get: function get() {
                return this.$store.state.webadmin.baseReport.ajaxing;
            },
            set: function set(newValue) {
                var _this5 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
                    return _regenerator2.default.wrap(function _callee3$(_context3) {
                        while (1) {
                            switch (_context3.prev = _context3.next) {
                                case 0:
                                    _context3.next = 2;
                                    return _this5.changeAjaxing(newValue);

                                case 2:
                                case 'end':
                                    return _context3.stop();
                            }
                        }
                    }, _callee3, _this5);
                }))();
            }
        },
        viewMode: {
            get: function get() {
                return this.$store.state.webadmin.baseReport.itemOptions.viewMode;
            },
            set: function set(value) {
                this.changeItemOption({
                    prop: 'viewMode',
                    value: value
                });
            }
        }
    }),
    methods: (0, _extends3.default)({
        checkMode: function checkMode(mode) {
            return this.viewMode === mode;
        }
    }, (0, _vuex.mapActions)('webadmin/configure', ['configuredRun', 'fetchStudioList', 'fetchBranchList', 'fetchContractList']), (0, _vuex.mapActions)('webadmin/baseReport', ['beforeSubmit', 'toggleBlock', 'changeDateOption', 'changeFilterOption', 'cleanBranch', 'cleanBranchRelated', 'changeItemOption', 'setDetailTarget', 'download', 'csvDataHandler', 'columnFormater', "changeAjaxing"]), {
        submit: function submit() {
            this.beforeSubmit();
            this.getSummaryResault();
        },
        getStaff: function getStaff(studio_id, branch_id) {
            var _this6 = this;

            this.$http.get('/adminapi/staff/list?studio_id=' + studio_id + '&branch_id=' + branch_id).then(function (response) {
                _this6.view.staffAjaxing = false;
                _this6.staffList = response.body;
            }, function (error) {
                _this6.view.staffAjaxing = false;
            });
        },
        getSummaryResault: function getSummaryResault() {
            var _this7 = this;

            var data = {
                'studio_id': this.studioId.id,
                'branch_ids': this.branchIds.map(function (ids) {
                    return ids.id;
                }),
                'member_ids': this.memberIds.map(function (ids) {
                    return ids.id;
                }),
                'salary_category_id': this.salaryCategoryId.id,
                'date_range': {
                    'start': this.dateOptions.startDate,
                    'end': this.dateOptions.endDate
                }
            };
            var params = $.param(data);
            this.ajaxing = true;
            this.$http.get('/adminapi/salary/report/list?' + params).then(function (response) {
                _this7.ajaxing = false;
                _this7.summaryList = response.body;
            }, function (error) {
                _this7.ajaxing = false;
            });
        },
        showModal: function showModal() {
            $(this.$el).find('#salary-detail').modal('show');
        },
        openDetail: function openDetail(filter) {
            var _this8 = this;

            var data = {
                'studio_id': this.studioId.id,
                'branch_id': filter.branchId,
                'member_id': filter.memberId,
                'salary_category_id': this.salaryCategoryId.id,
                'date_range': {
                    'start': this.dateOptions.startDate,
                    'end': this.dateOptions.endDate
                }
            };
            var params = $.param(data);
            this.ajaxing = true;
            this.detailAjaxing = true;
            this.$http.get('/adminapi/salary/report/details?' + params).then(function (response) {
                _this8.ajaxing = false;
                _this8.detailAjaxing = false;
                _this8.detailBody = response.body.body;
                _this8.detailHead = response.body.head;
                if (filter.openType == 'modal') {
                    _this8.showModal();
                }
                if (filter.openType == 'export') {
                    _this8.exportDetail();
                }
            }, function (error) {
                _this8.ajaxing = false;
                _this8.detailAjaxing = false;
            });
        },
        summaryColumnFormater: function summaryColumnFormater(d) {
            var data = JSON.parse((0, _stringify2.default)(d));
            data = data.map(function (rows) {
                delete rows["branch_id"];
                delete rows["member_id"];
                return rows;
            });
            data = (0, _stringify2.default)(data);
            data = data.replaceAll('branch_name', '場館');
            data = data.replaceAll('member_name', '姓名');
            data = data.replaceAll('schedule_money', '課程薪資');
            data = data.replaceAll('service_money', '服務薪資');
            data = data.replaceAll('sub_total', '小計');
            return data;
        },
        detailClassColumnFormater: function detailClassColumnFormater(d) {
            var data = JSON.parse((0, _stringify2.default)(d));
            data = data.map(function (rows) {
                delete rows["salary_category_id"];
                return rows;
            });
            data = (0, _stringify2.default)(data);
            data = data.replaceAll('name', '課程名稱');
            data = data.replaceAll('date', '日期');
            data = data.replaceAll('time', '時間');
            data = data.replaceAll('booking_number', '預約人數');
            data = data.replaceAll('comfirm_number', '出席人數');
            data = data.replaceAll('absence_number', '缺席人數');
            data = data.replaceAll('late_cancle_number', '遲退人數');
            data = data.replaceAll('calculate_condition', '薪資條件');
            data = data.replaceAll('salary', '薪資');
            data = data.replaceAll('bonus', '獎金');
            data = data.replaceAll('final_money', '應計薪資');
            return data;
        },
        detailServiceColumnFormater: function detailServiceColumnFormater(d) {
            var data = JSON.parse((0, _stringify2.default)(d));
            data = data.map(function (rows) {
                delete rows["salary_category_id"];
                return rows;
            });
            data = (0, _stringify2.default)(data);
            data = data.replaceAll('name', '服務名稱');
            data = data.replaceAll('date', '日期');
            data = data.replaceAll('time', '時間');
            data = data.replaceAll('confirm_status', '狀態');
            data = data.replaceAll('booking_way', '預約方式');
            data = data.replaceAll('calculate_condition', '薪資條件');
            data = data.replaceAll('salary', '薪資');
            data = data.replaceAll('bonus', '獎金');
            data = data.replaceAll('final_money', '應計薪資');
            return data;
        },
        detailHeadColumnFormater: function detailHeadColumnFormater(d) {

            var data = (0, _stringify2.default)(d);
            return data;
        },
        exportDetail: function exportDetail() {
            var _this9 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
                var rowString, headString, classString, serviceString, headData, combineString;
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                rowString = '';
                                headString = '';
                                classString = '';
                                serviceString = '';
                                headData = [[_this9.detailHead.member_name, ''], ['場館 ', _this9.detailHead.branch_name], ['薪資 ', _this9.detailHead.total]];
                                _context4.next = 7;
                                return _this9.csvDataHandler({ data: [[], [], []], columnFormater: _this9.detailHeadColumnFormater }).then(function (results) {
                                    rowString = results;
                                });

                            case 7:
                                _context4.next = 9;
                                return _this9.csvDataHandler({ data: headData, columnFormater: _this9.detailHeadColumnFormater }).then(function (results) {
                                    headString = results;
                                });

                            case 9:
                                combineString = headString;

                                if (!_this9.detailBody.classes) {
                                    _context4.next = 14;
                                    break;
                                }

                                _context4.next = 13;
                                return _this9.csvDataHandler({ data: _this9.detailBody.classes.detail, columnFormater: _this9.detailClassColumnFormater }).then(function (results) {
                                    classString = results;
                                });

                            case 13:
                                combineString = combineString + rowString + classString;

                            case 14:
                                if (!_this9.detailBody.services) {
                                    _context4.next = 18;
                                    break;
                                }

                                _context4.next = 17;
                                return _this9.csvDataHandler({ data: _this9.detailBody.services.detail, columnFormater: _this9.detailServiceColumnFormater }).then(function (results) {
                                    serviceString = results;
                                });

                            case 17:
                                combineString = combineString + rowString + serviceString;

                            case 18:
                                _context4.next = 20;
                                return _this9.download({ csvString: combineString, name: 'salary' });

                            case 20:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this9);
            }))();
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"page-div\" _v-0a640070=\"\">\n    <v-webadmin-report :block-open-status=\"blockOpenStatus\" :date-options=\"dateOptions\" :toggle-block=\"toggleBlock\" :change-date-option=\"changeDateOption\" :disable-submit=\"ajaxing\" :submit=\"submit\" limit-date=\"365\" title=\"薪資統計\" _v-0a640070=\"\">\n        <div slot=\"second-block\" _v-0a640070=\"\">\n            <div class=\"row\" _v-0a640070=\"\">\n                <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen\" _v-0a640070=\"\">\n                    <div class=\"form-group\" _v-0a640070=\"\">\n                        <v-mutiselect :model.sync=\"studioId\" :options=\"studioList\" :preserve-search=\"true\" :placeholder=\"configureStates.ajaxing.studioList ? '品牌讀取中…' : '請選擇品牌'\" label=\"brand_name\" track-by=\"id\" _v-0a640070=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n            </div>\n            <div class=\"row\" _v-0a640070=\"\">\n                <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen || configureStates.isStudio\" _v-0a640070=\"\">\n                    <div class=\"form-group\" _v-0a640070=\"\">\n                        <v-mutiselect :model.sync=\"branchIds\" :options=\"branchList\" :disabled=\"configureStates.ajaxing.branchList\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"false\" :placeholder=\"configureStates.ajaxing.branchList ? '場館讀取中…' : '全部場館'\" label=\"branch_name\" track-by=\"id\" :taggable=\"true\" tag-name=\"branch_name\" :max-height=\"500\" _v-0a640070=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n                <div class=\"col-sm-6\" _v-0a640070=\"\">\n                    <div class=\"form-group\" _v-0a640070=\"\">\n                        <v-mutiselect :model.sync=\"salaryCategoryId\" :options=\"salaryCategories\" :multiple=\"false\" :close-on-select=\"true\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"false\" :searchable=\"false\" label=\"name\" track-by=\"id\" :taggable=\"false\" _v-0a640070=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n            </div>\n            <div class=\"row\" _v-0a640070=\"\">\n                <div class=\"col-sm-6\" _v-0a640070=\"\">\n                    <div class=\"form-group\" _v-0a640070=\"\">\n                        <v-mutiselect :model.sync=\"memberIds\" :options=\"staffList\" :disabled=\"view.staffAjaxing\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"true\" :placeholder=\"configureStates.ajaxing.branchList ? '人員讀取中…' : '全部人員'\" label=\"name\" track-by=\"id\" :taggable=\"true\" tag-name=\"name\" :max-height=\"500\" _v-0a640070=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div slot=\"third-block\" _v-0a640070=\"\">\n            <div class=\"row\" _v-0a640070=\"\">\n                <div class=\"col-sm-6\" _v-0a640070=\"\">\n                    <div class=\"form-group\" _v-0a640070=\"\">\n                        <label _v-0a640070=\"\">\n                            <input name=\"view\" type=\"radio\" value=\"values\" v-model=\"viewMode\" checked=\"\" _v-0a640070=\"\"> 顯示總和\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div slot=\"fourth-block\" _v-0a640070=\"\">\n            <div class=\"row\" _v-0a640070=\"\">\n                <div class=\"col-sm-6\" _v-0a640070=\"\">\n                    <div class=\"form-group row\" _v-0a640070=\"\">\n                        <label _v-0a640070=\"\">\n                            <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"show\" checked=\"\" _v-0a640070=\"\"> 顯示於網頁\n                        </label>\n                        <label _v-0a640070=\"\">\n                            <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"export\" _v-0a640070=\"\"> 匯出 CSV\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </v-webadmin-report>\n    <div v-show=\"display == 'show'\" _v-0a640070=\"\">\n        <webadmin-salary-report-summary :list=\"summaryList\" :ajaxing=\"ajaxing\" @open-detail=\"openDetail\" _v-0a640070=\"\"></webadmin-salary-report-summary>\n    </div>\n    <webadmin-salary-detail-modal :details=\"detailBody\" :ajaxing=\"view.detailAjaxing\" :head=\"detailHead\" _v-0a640070=\"\"></webadmin-salary-detail-modal>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-0a640070", module.exports)
  } else {
    hotAPI.update("_v-0a640070", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/json/stringify":48,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/defineProperty":65,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vuex":803}],1391:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\nh4[_v-2075787a] {\n  display: inline;\n  padding-right: 30px; }\n\n/* line 7, stdin */\n.page-div[_v-2075787a] {\n  padding: 0 15px;\n  margin-bottom: 15px; }\n\n/* line 12, stdin */\n.table-div[_v-2075787a] {\n  padding: 20px 0; }\n\n/* line 16, stdin */\n.total-list[_v-2075787a] {\n  margin: 15px 0; }\n\n/* line 20, stdin */\n.total-list[_v-2075787a]:after {\n  clear: both; }\n\n/* line 24, stdin */\n.table-striped thead[_v-2075787a] {\n  border-bottom: 1px solid #000; }\n\n/* line 28, stdin */\n.multiselect[_v-2075787a] {\n  padding-bottom: 5px; }\n\n/* line 32, stdin */\n.negative-number[_v-2075787a] {\n  color: red; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _watch;

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    mounted: function mounted() {
        var _this = this;

        this.configuredRun(function () {
            _this.changeFilterOption({
                prop: 'studioId',
                value: {
                    id: _this.configureStates.studioId,
                    brand_name: ''
                }
            });
            _this.changeFilterOption({
                prop: 'branchId',
                value: _this.configureStates.branchId
            });
            if (_this.configureStates.isSeventeen) {
                return _this.fetchStudioList();
            }
            if (_this.configureStates.isBranch) {
                _this.branchIds = [{
                    'id': _this.configureStates.branchId,
                    'branch_name': ''
                }];
            }
        });
        this.changeDateOption({
            prop: 'startDate',
            value: moment().format('YYYY/MM/DD')
        });
        this.changeDateOption({
            prop: 'endDate',
            value: moment().format('YYYY/MM/DD')
        });
    },

    watch: (_watch = {}, (0, _defineProperty3.default)(_watch, 'filterOptions.studioId', function filterOptionsStudioId(n, o) {
        if (this.configureStates.isSeventeen || this.configureStates.isStudio) {
            this.fetchBranchList({
                studioId: n.id
            });
        }
        this.initStaff();
    }), (0, _defineProperty3.default)(_watch, 'dateOptions.startDate', function dateOptionsStartDate(n, o) {
        this.initStaff();
    }), (0, _defineProperty3.default)(_watch, 'dateOptions.endDate', function dateOptionsEndDate(n, o) {
        this.initStaff();
    }), _watch),
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        configureStates: function configureStates(state) {
            return state.webadmin.configure;
        }
    }), (0, _vuex.mapState)('webadmin/configure', ['configured', 'studioList', 'branchList', 'branchId']), (0, _vuex.mapState)('webadmin/checkoutReport', ['blockOpenStatus', 'dateOptions', 'filterOptions', 'ajaxing', 'list', 'invoice_order_total', 'invoice_total', 'allowance_order_total', 'allowance_total', 'total_by_payment', 'total_by_branch', 'confirmStatus', 'issueStatusShow', 'staffMembers', 'staffAjaxing', 'initTotalPayments', 'initBranchTotalPayments']), {
        studioId: {
            get: function get() {
                return this.filterOptions.studioId;
            },
            set: function set(newValue) {
                var _this2 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                    return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.next = 2;
                                    return _this2.changeFilterOption({ 'prop': 'studioId', value: newValue });

                                case 2:
                                    _this2.cleanBranch();

                                    if (!newValue) {
                                        _context.next = 6;
                                        break;
                                    }

                                    _context.next = 6;
                                    return _this2.fetchBranchList({ studioId: newValue.id });

                                case 6:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this2);
                }))();
            }
        },
        branchIds: {
            get: function get() {
                return this.filterOptions.branchIds;
            },
            set: function set(newValue) {
                var _this3 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                    return _regenerator2.default.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    _context2.next = 2;
                                    return _this3.changeFilterOption({ 'prop': 'branchIds', value: newValue });

                                case 2:
                                case 'end':
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, _this3);
                }))();
            }
        },
        issueStatuses: {
            get: function get() {
                return this.filterOptions.issueStatuses;
            },
            set: function set(newValue) {
                var _this4 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
                    return _regenerator2.default.wrap(function _callee3$(_context3) {
                        while (1) {
                            switch (_context3.prev = _context3.next) {
                                case 0:
                                    _context3.next = 2;
                                    return _this4.$store.dispatch('webadmin/checkoutReport/changeFilterOption', { 'prop': 'issueStatuses', value: newValue });

                                case 2:
                                case 'end':
                                    return _context3.stop();
                            }
                        }
                    }, _callee3, _this4);
                }))();
            }
        },
        selectedStaff: {
            get: function get() {
                return this.filterOptions.selectedStaff;
            },
            set: function set(newValue) {
                var _this5 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
                    return _regenerator2.default.wrap(function _callee4$(_context4) {
                        while (1) {
                            switch (_context4.prev = _context4.next) {
                                case 0:
                                    _context4.next = 2;
                                    return _this5.$store.dispatch('webadmin/checkoutReport/changeFilterOption', { 'prop': 'selectedStaff', value: newValue });

                                case 2:
                                case 'end':
                                    return _context4.stop();
                            }
                        }
                    }, _callee4, _this5);
                }))();
            }
        },
        viewMode: {
            get: function get() {
                return this.$store.state.webadmin.checkoutReport.itemOptions.viewMode;
            },
            set: function set(value) {
                this.changeItemOption({
                    prop: 'viewMode',
                    value: value
                });
            }
        }
    }),
    methods: (0, _extends3.default)({
        checkMode: function checkMode(mode) {
            return this.viewMode === mode;
        },
        updateFilterOption: function updateFilterOption(field) {
            var _this6 = this;

            return function (value) {
                return _this6.changeFilterOption({
                    prop: field,
                    value: value
                });
            };
        },
        thousandthFormat: function thousandthFormat(money) {
            return $17.thousandthFormat(money);
        }
    }, (0, _vuex.mapActions)('webadmin/configure', ['configuredRun', 'fetchStudioList', 'fetchBranchList', 'pushObjectStatus']), (0, _vuex.mapActions)('webadmin/checkoutReport', ['submitCheckoutMemberReport', 'toggleBlock', 'changeDateOption', 'changeFilterOption', 'changeItemOption', 'cleanBranch', 'cleanBranchRelated', 'initStaff']), {
        generatePaymentDisplayName: function generatePaymentDisplayName(payment) {
            var _this7 = this;

            var result = '';
            payment.forEach(function (item) {
                result += _this7.paymentDisplayName(item);
            });
            return result;
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"page-div\" _v-2075787a=\"\">\n    <v-webadmin-report :block-open-status=\"blockOpenStatus\" :date-options=\"dateOptions\" :toggle-block=\"toggleBlock\" :change-date-option=\"changeDateOption\" :submit=\"submitCheckoutMemberReport\" limit-date=\"90\" title=\"全體銷售人員結帳紀錄\" _v-2075787a=\"\">\n        <div slot=\"second-block\" _v-2075787a=\"\">\n            <div class=\"filters\" _v-2075787a=\"\">\n                <div class=\"row\" _v-2075787a=\"\">\n                    <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen\" _v-2075787a=\"\">\n                        <div class=\"form-group\" _v-2075787a=\"\">\n                            <v-mutiselect :model.sync=\"studioId\" :options=\"studioList\" :preserve-search=\"true\" :placeholder=\"configureStates.ajaxing.studioList ? '品牌讀取中…' : '請選擇品牌'\" label=\"brand_name\" track-by=\"id\" _v-2075787a=\"\">\n                            </v-mutiselect>\n                        </div>\n                    </div>\n                    <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen || configureStates.isStudio\" _v-2075787a=\"\">\n                        <div class=\"form-group\" _v-2075787a=\"\">\n                            <v-mutiselect :model.sync=\"branchIds\" :options=\"branchList\" :disabled=\"configureStates.ajaxing.branchList\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"false\" :placeholder=\"configureStates.ajaxing.branchList ? '場館讀取中…' : '全部場館'\" label=\"branch_name\" track-by=\"id\" :taggable=\"true\" tag-name=\"branch_name\" :max-height=\"500\" _v-2075787a=\"\">\n                            </v-mutiselect>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"row\" _v-2075787a=\"\">\n                    <div class=\"col-sm-6\" _v-2075787a=\"\">\n                        <div class=\"form-group\" _v-2075787a=\"\">\n                            <v-mutiselect :model.sync=\"selectedStaff\" :options=\"staffMembers\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"true\" :placeholder=\"staffAjaxing ? '結帳人員讀取中…' : '全部結帳人員'\" label=\"name\" track-by=\"id\" :max-height=\"500\" tag-name=\"name\" _v-2075787a=\"\">\n                            </v-mutiselect>\n                        </div>\n                    </div>\n                    <div class=\"col-sm-6\" _v-2075787a=\"\">\n                        <div class=\"form-group\" _v-2075787a=\"\">\n                            <v-mutiselect :model.sync=\"issueStatuses\" :options=\"issueStatusShow\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"false\" :placeholder=\"issueStatuses.length>0 ? '' : '所有發票狀態'\" label=\"name\" track-by=\"status\" :max-height=\"500\" tag-name=\"name\" _v-2075787a=\"\">\n                            </v-mutiselect>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div slot=\"third-block\" _v-2075787a=\"\">\n            <div class=\"row\" _v-2075787a=\"\">\n                <div class=\"col-sm-6\" _v-2075787a=\"\">\n                    <div class=\"form-group\" _v-2075787a=\"\">\n                        <label _v-2075787a=\"\">\n                            <input name=\"view\" type=\"radio\" value=\"detail\" v-model=\"viewMode\" checked=\"\" _v-2075787a=\"\"> 顯示細節\n                        </label>\n                        <label _v-2075787a=\"\">\n                            <input name=\"view\" type=\"radio\" value=\"summary\" v-model=\"viewMode\" _v-2075787a=\"\"> 顯示總和\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </v-webadmin-report>\n    <div class=\"row total-list\" v-if=\"Object.keys(list).length>0\" _v-2075787a=\"\">\n        <div class=\"col-sm-12\" _v-2075787a=\"\">\n            <h4 _v-2075787a=\"\">總銷售金額: {{thousandthFormat(invoice_order_total)}}</h4>\n            <h4 _v-2075787a=\"\">總開立金額: {{thousandthFormat(invoice_total)}}</h4>\n            <h4 _v-2075787a=\"\">總退費金額: {{thousandthFormat(allowance_order_total)}}</h4>\n            <h4 _v-2075787a=\"\">總折讓金額: {{thousandthFormat(allowance_total)}}</h4>\n        </div>\n        <div class=\"col-sm-12 m-top-20\" _v-2075787a=\"\">\n            <h4 v-for=\"payment in total_by_payment\" _v-2075787a=\"\">\n                {{ paymentDisplayName(payment) }}淨收入:\n                <span :class=\"[payment.income+payment.refund<0?'negative-number':'']\" _v-2075787a=\"\">\n                    {{thousandthFormat(payment.income+payment.refund)}}\n                </span>\n            </h4>\n        </div>\n    </div>\n    <div class=\"table-div\" _v-2075787a=\"\">\n        <v-table v-if=\"checkMode('detail')\" :ajaxing=\"ajaxing\" :length=\"Object.keys(list).length\" _v-2075787a=\"\">\n            <table class=\"table table-striped\" _v-2075787a=\"\">\n                <thead _v-2075787a=\"\">\n                <tr _v-2075787a=\"\">\n                    <td _v-2075787a=\"\">訂單編號</td>\n                    <td _v-2075787a=\"\">場館</td>\n                    <td _v-2075787a=\"\">結帳日期</td>\n                    <td _v-2075787a=\"\">銷售(退費)金額</td>\n                    <td _v-2075787a=\"\">發票開立(折讓)金額</td>\n                    <td _v-2075787a=\"\">發票號碼</td>\n                    <td _v-2075787a=\"\">狀態</td>\n                    <td _v-2075787a=\"\">結帳人員</td>\n                    <td _v-2075787a=\"\">交易方式</td>\n                </tr>\n                </thead>\n                <tbody _v-2075787a=\"\">\n                <tr v-for=\"item in list\" _v-2075787a=\"\">\n                    <td _v-2075787a=\"\">{{ item.order_id }}</td>\n                    <td _v-2075787a=\"\">{{ item.branch_name }}</td>\n                    <td _v-2075787a=\"\">{{ item.checkout_at }}</td>\n                    <td v-if=\"((item.status==2||item.status==3)&amp;&amp;item.order_total>0)||(item.status==4&amp;&amp;item.order_total<0)\" class=\"negative-number text-center\" _v-2075787a=\"\">({{ Math.abs(item.order_total) }})</td>\n                    <td class=\"text-center\" v-else=\"\" _v-2075787a=\"\">{{ item.order_total }}</td>\n                    <td v-if=\"(item.status==2||item.status==3)&amp;&amp;item.allowance_total>0\" class=\"negative-number text-center\" _v-2075787a=\"\">({{ item.allowance_total }})</td>\n                    <td class=\"text-center\" v-else=\"\" _v-2075787a=\"\">{{ item.invoice_total }}</td>\n                    <td _v-2075787a=\"\">{{ item.invoice_number }}</td>\n                    <td _v-2075787a=\"\">{{ item.status_show }}</td>\n                    <td _v-2075787a=\"\">{{ item.checkout_member }}</td>\n                    <td _v-2075787a=\"\">{{ generatePaymentDisplayName(item.payment_method) }}</td>\n                </tr>\n                </tbody>\n            </table>\n        </v-table>\n        <v-table v-if=\"checkMode('summary')\" :ajaxing=\"ajaxing\" :length=\"Object.keys(list).length\" _v-2075787a=\"\">\n            <table class=\"table table-striped\" _v-2075787a=\"\">\n                <thead _v-2075787a=\"\">\n                <tr _v-2075787a=\"\">\n                    <td class=\"text-center\" _v-2075787a=\"\">場館</td>\n                    <td v-for=\"payment in initTotalPayments\" class=\"text-center\" _v-2075787a=\"\">{{payment}}</td>\n                </tr>\n                </thead>\n                <tbody _v-2075787a=\"\">\n                <tr v-for=\"details in initBranchTotalPayments\" _v-2075787a=\"\">\n                    <td v-for=\"value in details\" class=\"text-center\" _v-2075787a=\"\">{{value}}</td>\n                </tr>\n                </tbody>\n            </table>\n        </v-table>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\nh4[_v-2075787a] {\n  display: inline;\n  padding-right: 30px; }\n\n/* line 7, stdin */\n.page-div[_v-2075787a] {\n  padding: 0 15px;\n  margin-bottom: 15px; }\n\n/* line 12, stdin */\n.table-div[_v-2075787a] {\n  padding: 20px 0; }\n\n/* line 16, stdin */\n.total-list[_v-2075787a] {\n  margin: 15px 0; }\n\n/* line 20, stdin */\n.total-list[_v-2075787a]:after {\n  clear: both; }\n\n/* line 24, stdin */\n.table-striped thead[_v-2075787a] {\n  border-bottom: 1px solid #000; }\n\n/* line 28, stdin */\n.multiselect[_v-2075787a] {\n  padding-bottom: 5px; }\n\n/* line 32, stdin */\n.negative-number[_v-2075787a] {\n  color: red; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-2075787a", module.exports)
  } else {
    hotAPI.update("_v-2075787a", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/defineProperty":65,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1392:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.page-div[_v-23bb3e8b] {\n  padding: 0px 15px;\n  margin-bottom: 15px; }\n\n/* line 7, stdin */\n.table-div[_v-23bb3e8b] {\n  padding: 20px 0px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _watch;

var _vuex = require('vuex');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            display: 'show'
        };
    },
    mounted: function mounted() {
        var _this = this;

        this.getItemTypes();
        this.configuredRun(function () {
            _this.changeFilterOption({
                prop: 'studioId',
                value: {
                    id: _this.configureStates.studioId,
                    brand_name: ''
                }
            });
            _this.changeFilterOption({
                prop: 'branchId',
                value: _this.configureStates.branchId
            });
            if (_this.configureStates.isSeventeen) {
                return _this.fetchStudioList();
            }
            if (_this.configureStates.isBranch) {
                _this.branchIds = [{
                    'id': _this.configureStates.branchId,
                    'branch_name': ''
                }];
            }
        });

        this.changeDateOption({ prop: 'startDate', value: moment().format('YYYY/MM/DD') });
        this.changeDateOption({ prop: 'endDate', value: moment().format('YYYY/MM/DD') });
    },

    watch: (_watch = {}, (0, _defineProperty3.default)(_watch, 'filterOptions.studioId', function filterOptionsStudioId(n, o) {
        if (this.configureStates.isSeventeen || this.configureStates.isStudio) {
            this.fetchBranchList({
                studioId: n.id
            });
        }
        this.initPayment();
    }), (0, _defineProperty3.default)(_watch, 'filterOptions.branchIds', function filterOptionsBranchIds(n, o) {
        this.initPayment();
    }), (0, _defineProperty3.default)(_watch, 'details', function details(newValue, oldValue) {
        var _this2 = this;

        this.$nextTick(function () {
            if (newValue.hasOwnProperty('data') && newValue.data.length > 0 && _this2.display === 'export' && _this2.viewMode === 'detail') {
                _this2.$refs.detailTable.exportCsv();
            }
        });
    }), (0, _defineProperty3.default)(_watch, 'summaries', function summaries(newValue, oldValue) {
        var _this3 = this;

        this.$nextTick(function () {
            if (newValue.hasOwnProperty('sales') && newValue.sales.length > 0 && _this3.display === 'export' && _this3.viewMode === 'summary') {
                _this3.$refs.summaryTable.exportCsv();
            }
        });
    }), _watch),
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        configureStates: function configureStates(state) {
            return state.webadmin.configure;
        }
    }), (0, _vuex.mapState)('webadmin/configure', ['configured', 'studioList', 'branchList', 'branchId']), (0, _vuex.mapState)("webadmin/baseReport", ["blockOpenStatus", "dateOptions", "itemOptions", "ajaxing"]), (0, _vuex.mapState)('webadmin/orderDetailsTotalSale', ['filterOptions', 'details', 'summaries', 'payments', 'paymentAjaxing', "item_types", "items", "itemAjaxing"]), {
        studioId: {
            get: function get() {
                return this.filterOptions.studioId;
            },
            set: function set(newValue) {
                var _this4 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                    return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.next = 2;
                                    return _this4.changeFilterOption({ 'prop': 'studioId', value: newValue });

                                case 2:
                                    _this4.cleanBranch();

                                    if (!newValue) {
                                        _context.next = 6;
                                        break;
                                    }

                                    _context.next = 6;
                                    return _this4.fetchBranchList({ studioId: newValue.id });

                                case 6:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this4);
                }))();
            }
        },
        branchIds: {
            get: function get() {
                return this.filterOptions.branchIds;
            },
            set: function set(newValue) {
                var _this5 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                    return _regenerator2.default.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    _context2.next = 2;
                                    return _this5.changeFilterOption({ 'prop': 'branchIds', value: newValue });

                                case 2:
                                    if (_this5.selectedItemType !== 'all') {
                                        _this5.selectedItem = [];
                                        _this5.getItems();
                                    }

                                case 3:
                                case 'end':
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, _this5);
                }))();
            }
        },
        viewMode: {
            get: function get() {
                return this.itemOptions.viewMode;
            },
            set: function set(value) {
                this.changeItemOption({ prop: 'viewMode', value: value });
            }
        },
        selectedPayment: {
            get: function get() {
                return this.filterOptions.selectedPayment;
            },
            set: function set(newValue) {
                var _this6 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
                    return _regenerator2.default.wrap(function _callee3$(_context3) {
                        while (1) {
                            switch (_context3.prev = _context3.next) {
                                case 0:
                                    _context3.next = 2;
                                    return _this6.changeFilterOption({ 'prop': 'selectedPayment', value: newValue });

                                case 2:
                                case 'end':
                                    return _context3.stop();
                            }
                        }
                    }, _callee3, _this6);
                }))();
            }
        },
        selectedItemType: {
            get: function get() {
                return this.filterOptions.selectedItemType;
            },
            set: function set(newValue) {
                var _this7 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
                    return _regenerator2.default.wrap(function _callee4$(_context4) {
                        while (1) {
                            switch (_context4.prev = _context4.next) {
                                case 0:
                                    _context4.next = 2;
                                    return _this7.changeFilterOption({ 'prop': 'selectedItemType', value: newValue });

                                case 2:
                                    if (_this7.selectedItemType !== 'all') {
                                        _this7.selectedItem = [];
                                        _this7.getItems();
                                    }

                                case 3:
                                case 'end':
                                    return _context4.stop();
                            }
                        }
                    }, _callee4, _this7);
                }))();
            }
        },
        selectedItem: {
            get: function get() {
                return this.filterOptions.selectedItem;
            },
            set: function set(newValue) {
                var _this8 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5() {
                    return _regenerator2.default.wrap(function _callee5$(_context5) {
                        while (1) {
                            switch (_context5.prev = _context5.next) {
                                case 0:
                                    _context5.next = 2;
                                    return _this8.changeFilterOption({ 'prop': 'selectedItem', value: newValue });

                                case 2:
                                case 'end':
                                    return _context5.stop();
                            }
                        }
                    }, _callee5, _this8);
                }))();
            }
        },
        item_type_name: function item_type_name() {
            v = this;
            if (v.item_types.length <= 0 || v.item_types === null || v.selectedItemType === 'all' || v.selectedItemType === '') {
                return "";
            }
            item_type = _lodash2.default.find(v.item_types, function (o) {
                return o.id == v.selectedItemType;
            });
            return item_type.name;
        }
    }),
    methods: (0, _extends3.default)({
        submitSearch: function submitSearch() {
            this.fetchData();
        },
        fetchData: function fetchData() {
            var _this9 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6() {
                var branchIds, paymentMethodIds, itemIds, postData;
                return _regenerator2.default.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                branchIds = _this9.filterOptions.branchIds.map(function (elem) {
                                    return elem.id;
                                });
                                paymentMethodIds = _this9.filterOptions.selectedPayment.map(function (elem) {
                                    return elem.studio_payment_method_id;
                                });
                                itemIds = _this9.filterOptions.selectedItem.map(function (elem) {
                                    return elem.id;
                                });
                                postData = {
                                    params: {
                                        studio_id: _this9.filterOptions.studioId && _this9.filterOptions.studioId.hasOwnProperty('id') ? _this9.filterOptions.studioId.id : 0,
                                        branch_ids: branchIds,
                                        start_date: _this9.dateOptions.startDate,
                                        end_date: _this9.dateOptions.endDate,
                                        payment_method_ids: paymentMethodIds,
                                        money_status: 1, //只顯示收入
                                        item_type: _this9.filterOptions.selectedItemType,
                                        items: itemIds
                                    }
                                };

                                _this9.beforeSubmit();
                                _this9.changeAjaxing(true);
                                _this9.$http.get('/adminapi/report/fetch_salesmen_kpi_report', postData).then(function (response) {
                                    _this9.changeAjaxing(false);
                                    _this9.$store.commit('webadmin/orderDetailsTotalSale/CHANGE_DETAILS', { value: response.data.data.details });
                                    _this9.$store.commit('webadmin/orderDetailsTotalSale/CHANGE_SUMMARIES', { value: response.data.data.summaries });
                                }).catch(function (err) {
                                    _this9.changeAjaxing(false);
                                });

                            case 7:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, _this9);
            }))();
        },
        checkMode: function checkMode(mode) {
            return this.viewMode === mode;
        }
    }, (0, _vuex.mapActions)('webadmin/configure', ['configuredRun', 'fetchStudioList', 'fetchBranchList']), (0, _vuex.mapActions)('webadmin/orderDetailsTotalSale', ['changeFilterOption', 'cleanBranch', 'initPayment', 'getItemTypes', 'getItems']), (0, _vuex.mapActions)('webadmin/baseReport', ['changeAjaxing', 'changeItemOption', 'changeDateOption', 'beforeSubmit', 'toggleBlock']))
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"page-div\" _v-23bb3e8b=\"\">\n    <v-webadmin-report :block-open-status=\"blockOpenStatus\" :date-options=\"dateOptions\" :toggle-block=\"toggleBlock\" :change-date-option=\"changeDateOption\" :disable-submit=\"ajaxing\" :submit=\"submitSearch\" limit-date=\"92\" title=\"個別業務業績報表\" _v-23bb3e8b=\"\">\n        <div slot=\"second-block\" _v-23bb3e8b=\"\">\n            <div class=\"row\" _v-23bb3e8b=\"\">\n                <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen\" _v-23bb3e8b=\"\">\n                    <div class=\"form-group\" _v-23bb3e8b=\"\">\n                        <v-mutiselect :model.sync=\"studioId\" :options=\"studioList\" :preserve-search=\"true\" :placeholder=\"configureStates.ajaxing.studioList ? '品牌讀取中…' : '請選擇品牌'\" label=\"brand_name\" track-by=\"id\" _v-23bb3e8b=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n                <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen || configureStates.isStudio\" _v-23bb3e8b=\"\">\n                    <div class=\"form-group\" _v-23bb3e8b=\"\">\n                        <v-mutiselect :model.sync=\"branchIds\" :options=\"branchList\" :disabled=\"configureStates.ajaxing.branchList\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"false\" :placeholder=\"configureStates.ajaxing.branchList ? '場館讀取中…' : '全部場館'\" label=\"branch_name\" track-by=\"id\" :taggable=\"true\" tag-name=\"branch_name\" :max-height=\"500\" _v-23bb3e8b=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n                <div class=\"col-sm-6\" _v-23bb3e8b=\"\">\n                    <div class=\"form-group\" _v-23bb3e8b=\"\">\n                        <v-mutiselect :model.sync=\"selectedPayment\" :options=\"payments\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"true\" :placeholder=\"paymentAjaxing ? '交易方式讀取中…' : '全部交易方式'\" label=\"payment_name\" track-by=\"studio_payment_method_id\" tag-name=\"payment_name\" _v-23bb3e8b=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n                <div v-if=\"filterOptions.studioId !== null &amp;&amp; filterOptions.studioId.id !== 0\" class=\"col-sm-6\" _v-23bb3e8b=\"\">\n                    <div class=\"form-group\" _v-23bb3e8b=\"\">\n                        <select class=\"form-control\" v-model=\"selectedItemType\" _v-23bb3e8b=\"\">\n                            <option value=\"all\" _v-23bb3e8b=\"\">全部項目類型</option>\n                            <option :value=\"itemType.id\" :key=\"itemType.id\" v-for=\"itemType in item_types\" _v-23bb3e8b=\"\">{{ itemType.name }}</option>\n                        </select>\n                    </div>\n                </div>\n                <div v-if=\"selectedItemType !== 'schedules' &amp;&amp; selectedItemType !== 'services' &amp;&amp; selectedItemType !== 'all' &amp;&amp; filterOptions.studioId.id !== 0\" class=\"col-sm-6\" _v-23bb3e8b=\"\">\n                    <div class=\"form-group\" _v-23bb3e8b=\"\">\n                        <v-mutiselect :model.sync=\"selectedItem\" :options=\"items\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"true\" :placeholder=\"itemAjaxing ? '項目讀取中…' : '全部' + item_type_name\" label=\"name\" track-by=\"id\" tag-name=\"name\" _v-23bb3e8b=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div slot=\"third-block\" _v-23bb3e8b=\"\">\n            <div class=\"row\" _v-23bb3e8b=\"\">\n                <div class=\"col-sm-6\" _v-23bb3e8b=\"\">\n                    <div class=\"form-group\" _v-23bb3e8b=\"\">\n                        <label _v-23bb3e8b=\"\">\n                            <input name=\"view\" type=\"radio\" value=\"detail\" v-model=\"viewMode\" checked=\"\" _v-23bb3e8b=\"\"> 顯示細節\n                        </label>\n                        <label _v-23bb3e8b=\"\">\n                            <input name=\"view\" type=\"radio\" value=\"summary\" v-model=\"viewMode\" _v-23bb3e8b=\"\"> 顯示總和\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div slot=\"fourth-block\" _v-23bb3e8b=\"\">\n            <div class=\"row\" _v-23bb3e8b=\"\">\n                <div class=\"col-sm-6\" _v-23bb3e8b=\"\">\n                    <div class=\"form-group row\" _v-23bb3e8b=\"\">\n                        <label _v-23bb3e8b=\"\">\n                            <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"show\" checked=\"\" _v-23bb3e8b=\"\"> 顯示於網頁\n                        </label>\n                        <label _v-23bb3e8b=\"\">\n                            <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"export\" _v-23bb3e8b=\"\"> 匯出 CSV\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </v-webadmin-report>\n    <div v-show=\"display==='show'\" _v-23bb3e8b=\"\">\n        <div class=\"table-div\" _v-23bb3e8b=\"\">\n            <webadmin-sale-report-detail-result v-if=\"checkMode('detail')\" ref=\"detailTable\" :ajaxing=\"ajaxing\" :list=\"details\" _v-23bb3e8b=\"\">\n            </webadmin-sale-report-detail-result>\n            <webadmin-sale-report-summary-result v-if=\"checkMode('summary')\" ref=\"summaryTable\" :ajaxing=\"ajaxing\" :list=\"summaries\" :show-income=\"true\" :show-refund=\"false\" _v-23bb3e8b=\"\">\n            </webadmin-sale-report-summary-result>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.page-div[_v-23bb3e8b] {\n  padding: 0px 15px;\n  margin-bottom: 15px; }\n\n/* line 7, stdin */\n.table-div[_v-23bb3e8b] {\n  padding: 20px 0px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-23bb3e8b", module.exports)
  } else {
    hotAPI.update("_v-23bb3e8b", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/defineProperty":65,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1393:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n/* line 3, stdin */\n.page-div[_v-4e31ff94] {\n  padding: 0px 15px;\n  margin-bottom: 15px; }\n\n/* line 8, stdin */\n.m-l-15[_v-4e31ff94] {\n  margin-left: 15px; }\n\n/* line 12, stdin */\n.table-div[_v-4e31ff94] {\n  padding: 20px 0px; }\n\n/* line 16, stdin */\n.form-title[_v-4e31ff94] {\n  font-size: 16px;\n  font-weight: bold;\n  display: inline-block;\n  width: 60px; }\n\n/* line 23, stdin */\n.price[_v-4e31ff94] {\n  text-align: center; }\n\n/* line 27, stdin */\n.cube[_v-4e31ff94] {\n  max-width: 80px;\n  float: left;\n  margin: 12px 24px;\n  font-weight: blod;\n  font-size: 18px; }\n\n/* line 35, stdin */\n.total-list[_v-4e31ff94] {\n  margin: 15px 0px 0px 0px; }\n\n/* line 39, stdin */\n.total-list[_v-4e31ff94]:after {\n  clear: both; }\n\n/* line 43, stdin */\n.table-striped thead[_v-4e31ff94] {\n  border-bottom: 1px solid #000; }\n\n/* line 47, stdin */\n.multiselect[_v-4e31ff94] {\n  padding-bottom: 5px; }\n\n/* line 51, stdin */\nh4[_v-4e31ff94] {\n  display: inline;\n  padding: 0 15px;\n  border-right: 2px solid #C4C4C4; }\n\n/* line 57, stdin */\nh4[_v-4e31ff94]:last-child {\n  border: navajowhite; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _watch;

var _vuex = require('vuex');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        var detailColumns = [{ keys: 'branch_name', head: '場館名稱' }, { keys: 'service_name', head: '課程名稱' }, { keys: 'schedule_name', head: '課表名稱' }, { keys: 'date', head: '開課日期' }, { keys: 'week', head: '週間' }, { keys: 'time_start', head: '開課時間' }, { keys: 'name', head: '人員' }, { keys: 'qty', head: '課表名額' }, { keys: 'booking_count', head: '訂課人次' }, { keys: 'attend_count', head: '出席人次' }, { keys: 'absent_count', head: '缺席人次' }, { keys: 'waiting_count', head: '候補人次' }, { keys: 'rating_count', head: '獲得評價次數' }, { keys: 'rating_sum', head: '評價平均分數' }];
        var summaryColumns = [{ keys: 'name', head: '人員' }, { keys: 'schedule_count', head: '課表數量' }, { keys: 'qty', head: '總名額' }, { keys: 'booking_count', head: '訂課人次' }, { keys: 'attend_count', head: '出席人次' }, { keys: 'absent_count', head: '缺席人次' }, { keys: 'waiting_count', head: '候補人次' }, { keys: 'rating_count', head: '獲得評價次數' }, { keys: 'rating_sum', head: '評價平均分數' }, { keys: 'booking_percentage', head: '訂課率' }, { keys: 'attend_percentage', head: '出席率' }, { keys: 'absent_percentage', head: '缺席率' }];
        var detailCsvColumns = [{ keys: 'branch_name', name: '場館名稱' }, { keys: 'service_name', name: '課程名稱' }, { keys: 'schedule_name', name: '課表名稱' }, { keys: 'date', name: '開課日期' }, { keys: 'week', name: '週間' }, { keys: 'time_start', name: '開課時間' }, { keys: 'name', name: '人員' }, { keys: 'qty', name: '課表名額' }, { keys: 'booking_count', name: '訂課人次' }, { keys: 'attend_count', name: '出席人次' }, { keys: 'absent_count', name: '缺席人次' }, { keys: 'waiting_count', name: '候補人次' }, { keys: 'rating_count', name: '獲得評價次數' }, { keys: 'rating_sum', name: '評價平均分數' }];
        var summaryCsvColumns = [{ keys: 'name', name: '人員' }, { keys: 'schedule_count', name: '課表數量' }, { keys: 'qty', name: '總名額' }, { keys: 'booking_count', name: '訂課人次' }, { keys: 'attend_count', name: '出席人次' }, { keys: 'absent_count', name: '缺席人次' }, { keys: 'waiting_count', name: '候補人次' }, { keys: 'rating_count', name: '獲得評價次數' }, { keys: 'rating_sum', name: '評價平均分數' }, { keys: 'booking_percentage', name: '訂課率' }, { keys: 'attend_percentage', name: '出席率' }, { keys: 'absent_percentage', name: '缺席率' }];
        return {
            display: 'show',
            viewMode: 'detail',
            detailTableConfig: {
                columns: detailColumns
            },
            detailCsvConfig: {
                column: detailCsvColumns,
                fileName: 'booking_report_by_schedule',
                jsonData: []
            },
            summaryTableConfig: {
                columns: summaryColumns
            },
            summaryCsvConfig: {
                column: summaryCsvColumns,
                fileName: 'booking_report_by_schedule',
                jsonData: []
            },
            relatedFilterWatcher: {
                studio_id: {
                    watcher: null,
                    options: 'studioList',
                    vModel: 'studioId',
                    trackBy: 'id',
                    select: 'single'
                },
                branch_ids: {
                    watcher: null,
                    options: 'branchList',
                    vModel: 'branchIds',
                    trackBy: 'id',
                    select: 'multi'
                },
                service_ids: {
                    watcher: null,
                    options: 'serviceList',
                    vModel: 'serviceIds',
                    trackBy: 'id',
                    select: 'multi'
                },
                service_provider_ids: {
                    watcher: null,
                    options: 'serviceProviderList',
                    vModel: 'serviceProviderIds',
                    trackBy: 'id',
                    select: 'multi'
                }
            },
            serviceProviderAll: false,
            export: [],
            list: [],
            pageMeta: {},
            paginationPayload: {},
            percentage: []
        };
    },
    created: function created() {
        this.syncMultiSelectByQuery();
    },
    mounted: function mounted() {
        var _this = this;

        this.configuredRun(function () {
            _this.changeFilterOption({
                prop: 'studioId',
                value: {
                    id: _this.configureStates.studioId,
                    brand_name: ''
                }
            });
            _this.changeFilterOption({
                prop: 'branchId',
                value: _this.configureStates.branchId
            });
            if (_this.configureStates.isSeventeen) {
                return _this.fetchStudioList();
            }
            if (_this.configureStates.isBranch) {
                _this.branchIds = [{
                    'id': _this.configureStates.branchId,
                    'branch_name': ''
                }];
            }
        });
        this.syncDateAndDisplayByQuery();
    },

    watch: (_watch = {}, (0, _defineProperty3.default)(_watch, 'filterOptions.studioId', function filterOptionsStudioId(n, o) {
        if (this.configureStates.isSeventeen && !_lodash2.default.isEmpty(n)) {
            this.fetchBranchList({
                studioId: n.id
            });
        }
        if (this.configureStates.isStudio) {
            this.fetchBranchList({
                studioId: n.id
            });
        }
    }), (0, _defineProperty3.default)(_watch, 'export', function _export(newV) {
        if (newV) {
            if (this.viewMode === 'detail') {
                this.detailCsvConfig.jsonData = newV;
            } else {
                this.summaryCsvConfig.jsonData = newV;
            }
            if (newV.length !== 0) {
                this.$refs.smart_table.downloadCsv();
            }
        }
    }), (0, _defineProperty3.default)(_watch, 'display', function display(newV, oldV) {
        if (newV) {
            var obj = {
                display: newV
            };
            $17.updateUrlQueryString(obj);
        }
    }), (0, _defineProperty3.default)(_watch, 'viewMode', function viewMode(newV, oldV) {
        if (newV) {
            this.resetData();
        }
    }), (0, _defineProperty3.default)(_watch, 'serviceProviderAll', function serviceProviderAll(newV, oldV) {
        if (this.filterOptions.branchIds.length !== 0) {
            if (oldV !== newV) {
                var studioId = this.filterOptions.studioId;
                var branchIds = this.filterOptions.branchIds.map(function (elem) {
                    return elem.id;
                });
                var payload = {
                    studioId: studioId.id,
                    branchIds: branchIds
                };
                if (newV) {
                    this.fetchServiceProviderAllList(payload);
                } else {
                    this.fetchServiceProviderList(payload);
                }
            }
        }
    }), _watch),
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        configureStates: function configureStates(state) {
            return state.webadmin.configure;
        }
    }), (0, _vuex.mapState)('webadmin/configure', ['configured', 'studioList', 'branchList', 'serviceProviderList', 'serviceList', 'branchId']), (0, _vuex.mapState)('webadmin/baseReport', ['blockOpenStatus', 'dateOptions', 'filterOptions', 'ajaxing']), {
        bookingTotalRecord: function bookingTotalRecord() {
            return { records: this.list, pageMeta: this.pageMeta };
        },

        studioId: {
            get: function get() {
                return this.filterOptions.studioId;
            },
            set: function () {
                var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(newValue) {
                    return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.next = 2;
                                    return this.$store.dispatch('webadmin/baseReport/changeFilterOption', {
                                        'prop': 'studioId',
                                        value: newValue
                                    });

                                case 2:
                                    if (!_lodash2.default.isEmpty(newValue)) {
                                        $17.updateUrlQueryString({ studio_id: newValue.id });
                                    }
                                    this.cleanBranch();
                                    this.cleanBranchRelated();

                                    if (!newValue) {
                                        _context.next = 9;
                                        break;
                                    }

                                    _context.next = 8;
                                    return this.fetchBranchList({ studioId: newValue.id });

                                case 8:
                                    this.fetchBranchAppendList();

                                case 9:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, this);
                }));

                function set(_x) {
                    return _ref.apply(this, arguments);
                }

                return set;
            }()
        },
        branchIds: {
            get: function get() {
                return this.filterOptions.branchIds;
            },
            set: function () {
                var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(newValue) {
                    return _regenerator2.default.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    _context2.next = 2;
                                    return this.$store.dispatch('webadmin/baseReport/changeFilterOption', {
                                        'prop': 'branchIds',
                                        value: newValue
                                    });

                                case 2:
                                    $17.updateUrlQueryString({
                                        branch_ids: newValue.map(function (el) {
                                            return el.id;
                                        })
                                    });
                                    this.cleanBranchRelated();
                                    if (newValue.length != 0) {
                                        this.fetchBranchAppendList();
                                    }

                                case 5:
                                case 'end':
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, this);
                }));

                function set(_x2) {
                    return _ref2.apply(this, arguments);
                }

                return set;
            }()
        },
        serviceIds: {
            get: function get() {
                return this.filterOptions.serviceIds;
            },
            set: function () {
                var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(newValue) {
                    return _regenerator2.default.wrap(function _callee3$(_context3) {
                        while (1) {
                            switch (_context3.prev = _context3.next) {
                                case 0:
                                    _context3.next = 2;
                                    return this.$store.dispatch('webadmin/baseReport/changeFilterOption', {
                                        'prop': 'serviceIds',
                                        value: newValue
                                    });

                                case 2:
                                    $17.updateUrlQueryString({
                                        service_ids: newValue.map(function (el) {
                                            return el.id;
                                        })
                                    });

                                case 3:
                                case 'end':
                                    return _context3.stop();
                            }
                        }
                    }, _callee3, this);
                }));

                function set(_x3) {
                    return _ref3.apply(this, arguments);
                }

                return set;
            }()
        },
        serviceProviderIds: {
            get: function get() {
                return this.filterOptions.serviceProviderIds;
            },
            set: function () {
                var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(newValue) {
                    return _regenerator2.default.wrap(function _callee4$(_context4) {
                        while (1) {
                            switch (_context4.prev = _context4.next) {
                                case 0:
                                    _context4.next = 2;
                                    return this.$store.dispatch('webadmin/baseReport/changeFilterOption', {
                                        'prop': 'serviceProviderIds',
                                        value: newValue
                                    });

                                case 2:
                                    $17.updateUrlQueryString({
                                        service_provider_ids: newValue.map(function (el) {
                                            return el.id;
                                        })
                                    });

                                case 3:
                                case 'end':
                                    return _context4.stop();
                            }
                        }
                    }, _callee4, this);
                }));

                function set(_x4) {
                    return _ref4.apply(this, arguments);
                }

                return set;
            }()
        }
    }),
    methods: (0, _extends3.default)({
        checkMode: function checkMode(mode) {
            return this.viewMode === mode;
        },
        submitSearch: function submitSearch() {
            this.beforeSubmit();
            this.page = 1;
            switch (this.display) {
                case 'export':
                    this.pageSize = 999999;
                    break;
                case 'show':
                    this.pageSize = 25;
                    break;
                default:
                    null;
            }
            this.changeAjaxing(true);
            var payload = this.postData();
            $17.updateUrlQueryString(payload);
            this.paginationPayload = payload;

            if (this.display === 'export') {
                this.fetchExport(payload);
            } else {
                this.fetchData(payload);
            }
        },
        fetchData: function fetchData(payload) {
            var _this2 = this;

            var url = '';
            if (this.viewMode === 'detail') {
                url = '/adminapi/report/fetch-schedule-attend-detail-record';
            } else {
                url = '/adminapi/report/fetch-schedule-attend-summary-record';
            }
            this.$http.get(url, { params: payload }).then(function (response) {
                _this2.changeAjaxing(false);
                _this2.list = response.data.list;
                _this2.pageMeta = response.data.pageMeta;
            }, function (error) {
                _this2.changeAjaxing(false);
                var message = error.body.message || '伺服器無回應，請檢查網路。';
                $17.swal({
                    title: message,
                    type: 'warning'
                });
            });
            payload['viewMode'] = this.viewMode;
            this.$http.get('/adminapi/report/fetch-schedule-attend-all-summary', { params: payload }).then(function (response) {
                _this2.percentage = response.data;
            });
        },
        fetchExport: function fetchExport(payload) {
            var _this3 = this;

            var url = '';
            if (this.viewMode === 'detail') {
                url = '/adminapi/report/fetch-schedule-attend-detail-record';
            } else {
                url = '/adminapi/report/fetch-schedule-attend-summary-record';
            }
            this.$http.get(url, { params: payload }).then(function (response) {
                _this3.changeAjaxing(false);
                _this3.export = response.data.list;
                _this3.list = [];
                _this3.pageMeta = {};
            }, function (error) {
                _this3.changeAjaxing(false);
                var message = error.body.message || '伺服器無回應，請檢查網路。';
                $17.swal({
                    title: message,
                    type: 'warning'
                });
            });
        },
        postData: function postData() {
            var branchIds = this.branchIds.map(function (elem) {
                return elem.id;
            });
            var serviceProviderIds = this.serviceProviderIds.map(function (elem) {
                return elem.id;
            });
            var serviceIds = this.serviceIds.map(function (elem) {
                return elem.id;
            });
            var postData = {
                studio_id: this.studioId && this.studioId.hasOwnProperty('id') ? this.studioId.id : 0,
                branch_ids: branchIds,
                start_date: this.dateOptions.startDate,
                end_date: this.dateOptions.endDate,
                service_provider_ids: serviceProviderIds,
                service_ids: serviceIds,
                service_provider_all: this.serviceProviderAll,
                page: this.page ? this.page : 1,
                page_size: this.pageSize ? this.pageSize : 25
            };
            return postData;
        },
        changePage: function changePage(payload) {
            var _this4 = this;

            this.changeAjaxing(true);
            this.paginationPayload = (0, _extends3.default)({}, this.paginationPayload, {
                page: payload
            });
            var url = '';
            if (this.viewMode === 'detail') {
                url = '/adminapi/report/fetch-schedule-attend-detail-record';
            } else {
                url = '/adminapi/report/fetch-schedule-attend-summary-record';
            }
            this.$http.get(url, { params: this.paginationPayload }).then(function (response) {
                _this4.changeAjaxing(false);
                _this4.list = response.data.list;
                _this4.pageMeta = response.data.pageMeta;
            }, function (error) {
                _this4.changeAjaxing(false);
                var message = error.body.message || '伺服器無回應，請檢查網路。';
                $17.swal({
                    title: message,
                    type: 'warning'
                });
            });
        },
        resetData: function resetData() {
            this.list = [];
            this.pageMeta = {};
        },
        syncMultiSelectByQuery: function syncMultiSelectByQuery() {
            var _this5 = this;

            var vm = this;
            var query = _lodash2.default.cloneDeep($17.getUrlQueryStrings());
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                var _loop = function _loop() {
                    var _step$value = (0, _slicedToArray3.default)(_step.value, 2),
                        key = _step$value[0],
                        value = _step$value[1];

                    value.watcher = _this5.$watch(value.options, function (newV, oldV) {
                        if (!_lodash2.default.isEmpty(newV)) {
                            var queryArr = query[key] ? query[key].split(",") : [];
                            var resultArr = [];
                            var isMultiSelect = value.select == 'multi';
                            queryArr.forEach(function (el) {
                                var findEl = newV.find(function (item) {
                                    return item[value.trackBy] == el;
                                });
                                findEl ? resultArr.push(findEl) : null;
                            });
                            vm[value.vModel] = isMultiSelect ? resultArr : resultArr[0];
                            value.watcher();
                        }
                    });
                };

                for (var _iterator = (0, _getIterator3.default)((0, _entries2.default)(this.relatedFilterWatcher)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    _loop();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        },
        dateFormat: function dateFormat(date) {
            return moment(date).format('YYYY/MM/DD');
        },
        updateFilterOption: function updateFilterOption(field) {
            var _this6 = this;

            return function (value) {
                return _this6.changeFilterOption({
                    prop: field,
                    value: value
                });
            };
        }
    }, (0, _vuex.mapActions)('webadmin/configure', ['configuredRun', 'fetchStudioList', 'fetchBranchList', 'fetchServiceProviderList', 'fetchServiceProviderAllList', 'fetchServiceList']), (0, _vuex.mapActions)('webadmin/baseReport', ['syncDateAndDisplayByQuery', 'beforeSubmit', 'toggleBlock', 'changeFilterOption', 'changeDateOption', 'changeItemOption', 'cleanBranch', 'cleanBranchRelated', 'download', 'csvDataHandler', 'columnFormater', 'changeAjaxing']), {
        fetchBranchAppendList: function fetchBranchAppendList() {
            var studioId = this.filterOptions.studioId;
            var branchIds = this.filterOptions.branchIds.map(function (elem) {
                return elem.id;
            });
            if (branchIds.length == 0) {
                branchIds = this.branchList.map(function (elem) {
                    return elem.id;
                });
            }
            var payload = {
                studioId: studioId.id,
                branchIds: branchIds,
                startDate: this.dateOptions.startDate,
                endDate: this.dateOptions.endDate,
                isService: 0
            };
            if (this.serviceProviderAll) {
                this.fetchServiceProviderAllList(payload);
            } else {
                this.fetchServiceProviderList(payload);
            }

            this.fetchServiceList(payload);
        },
        changeDateOptionAfter: function changeDateOptionAfter($dateObj) {
            this.changeDateOption($dateObj);
            this.cleanBranchRelated();
            this.fetchBranchAppendList();
            $17.updateUrlQueryString({
                start_date: this.dateOptions.startDate,
                end_date: this.dateOptions.endDate
            });
        },
        getTableConfig: function getTableConfig() {
            if (this.viewMode === 'detail') {
                return this.detailTableConfig;
            } else {
                return this.summaryTableConfig;
            }
        },
        getCsvConfig: function getCsvConfig() {
            if (this.viewMode === 'detail') {
                return this.detailCsvConfig;
            } else {
                return this.summaryCsvConfig;
            }
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"page-div\" _v-4e31ff94=\"\">\n    <v-webadmin-report :block-open-status=\"blockOpenStatus\" :date-options=\"dateOptions\" :toggle-block=\"toggleBlock\" :change-date-option=\"changeDateOptionAfter\" :submit=\"submitSearch\" limit-date=\"184\" title=\"開課及出席分析\" _v-4e31ff94=\"\">\n        <div slot=\"second-block\" _v-4e31ff94=\"\">\n            <div class=\"filters\" _v-4e31ff94=\"\">\n                <div class=\"row\" _v-4e31ff94=\"\">\n                    <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen\" _v-4e31ff94=\"\">\n                        <div class=\"form-group\" _v-4e31ff94=\"\">\n                            <v-mutiselect :model.sync=\"studioId\" :options=\"studioList\" :preserve-search=\"true\" :placeholder=\"configureStates.ajaxing.studioList ? '品牌讀取中…' : '請選擇品牌'\" label=\"brand_name\" track-by=\"id\" _v-4e31ff94=\"\">\n                            </v-mutiselect>\n                        </div>\n                    </div>\n                    <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen || configureStates.isStudio\" _v-4e31ff94=\"\">\n                        <div class=\"form-group\" _v-4e31ff94=\"\">\n                            <v-mutiselect :model.sync=\"branchIds\" :options=\"branchList\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"false\" :placeholder=\"configureStates.ajaxing.branchList ? '場館讀取中…' : '全部場館'\" label=\"branch_name\" track-by=\"id\" :taggable=\"true\" tag-name=\"branch_name\" :max-height=\"500\" _v-4e31ff94=\"\">\n                            </v-mutiselect>\n                        </div>\n                    </div>\n                    <div class=\"col-sm-6\" _v-4e31ff94=\"\">\n                        <div class=\"form-group\" _v-4e31ff94=\"\">\n                            <v-mutiselect :model.sync=\"serviceProviderIds\" :options=\"serviceProviderList\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :placeholder=\"configureStates.ajaxing.serviceProviderList ? '人員讀取中…' : '全部人員'\" label=\"name\" track-by=\"id\" :max-height=\"500\" tag-name=\"name\" _v-4e31ff94=\"\">\n                            </v-mutiselect>\n                            <label style=\"padding-top: 10px;\" _v-4e31ff94=\"\">\n                                <input type=\"checkbox\" v-model=\"serviceProviderAll\" _v-4e31ff94=\"\"> 包含已刪除的人員\n                            </label>\n                        </div>\n                    </div>\n                    <div class=\"col-sm-6\" _v-4e31ff94=\"\">\n                        <div class=\"form-group\" _v-4e31ff94=\"\">\n                            <v-mutiselect :model.sync=\"serviceIds\" :options=\"serviceList\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :placeholder=\"configureStates.ajaxing.serviceList ? '課程讀取中…' : '全部課程'\" label=\"name\" track-by=\"id\" :max-height=\"500\" tag-name=\"name\" _v-4e31ff94=\"\">\n                            </v-mutiselect>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div slot=\"third-block\" _v-4e31ff94=\"\">\n            <div class=\"row\" _v-4e31ff94=\"\">\n                <div class=\"col-sm-6\" _v-4e31ff94=\"\">\n                    <div class=\"form-group\" _v-4e31ff94=\"\">\n                        <label _v-4e31ff94=\"\">\n                            <input name=\"view\" type=\"radio\" value=\"detail\" v-model=\"viewMode\" checked=\"\" _v-4e31ff94=\"\"> 顯示細節\n                        </label>\n                        <label _v-4e31ff94=\"\">\n                            <input name=\"view\" type=\"radio\" value=\"summary\" v-model=\"viewMode\" _v-4e31ff94=\"\"> 顯示總和\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div slot=\"fourth-block\" _v-4e31ff94=\"\">\n            <div class=\"row m-left-0\" _v-4e31ff94=\"\">\n                <div class=\"col-sm-6\" _v-4e31ff94=\"\">\n                    <div class=\"form-group row\" _v-4e31ff94=\"\">\n                        <label _v-4e31ff94=\"\">\n                            <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"show\" checked=\"\" _v-4e31ff94=\"\"> 顯示於網頁\n                        </label>\n                        <label _v-4e31ff94=\"\">\n                            <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"export\" _v-4e31ff94=\"\"> 匯出CSV\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </v-webadmin-report>\n    <div v-show=\"display==='show'\" _v-4e31ff94=\"\">\n        <div class=\"row total-list\" v-if=\"list.length>0\" _v-4e31ff94=\"\">\n            <div class=\"col-sm-6\" _v-4e31ff94=\"\">\n                <h4 _v-4e31ff94=\"\">訂課率：{{percentage.booking}}%</h4><h4 _v-4e31ff94=\"\">出席率：{{percentage.attend}}%</h4><h4 _v-4e31ff94=\"\">\n                缺席率：{{percentage.absent}}%</h4>\n            </div>\n        </div>\n        <div class=\"table-div\" _v-4e31ff94=\"\">\n            <v-smart-table ref=\"smart_table\" :table-config=\"getTableConfig()\" :csv-config=\"getCsvConfig()\" :is-ajaxing=\"ajaxing\" :data=\"bookingTotalRecord\" :page-sync-url-query=\"false\" @change-page=\"changePage\" _v-4e31ff94=\"\"></v-smart-table>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n/* line 3, stdin */\n.page-div[_v-4e31ff94] {\n  padding: 0px 15px;\n  margin-bottom: 15px; }\n\n/* line 8, stdin */\n.m-l-15[_v-4e31ff94] {\n  margin-left: 15px; }\n\n/* line 12, stdin */\n.table-div[_v-4e31ff94] {\n  padding: 20px 0px; }\n\n/* line 16, stdin */\n.form-title[_v-4e31ff94] {\n  font-size: 16px;\n  font-weight: bold;\n  display: inline-block;\n  width: 60px; }\n\n/* line 23, stdin */\n.price[_v-4e31ff94] {\n  text-align: center; }\n\n/* line 27, stdin */\n.cube[_v-4e31ff94] {\n  max-width: 80px;\n  float: left;\n  margin: 12px 24px;\n  font-weight: blod;\n  font-size: 18px; }\n\n/* line 35, stdin */\n.total-list[_v-4e31ff94] {\n  margin: 15px 0px 0px 0px; }\n\n/* line 39, stdin */\n.total-list[_v-4e31ff94]:after {\n  clear: both; }\n\n/* line 43, stdin */\n.table-striped thead[_v-4e31ff94] {\n  border-bottom: 1px solid #000; }\n\n/* line 47, stdin */\n.multiselect[_v-4e31ff94] {\n  padding-bottom: 5px; }\n\n/* line 51, stdin */\nh4[_v-4e31ff94] {\n  display: inline;\n  padding: 0 15px;\n  border-right: 2px solid #C4C4C4; }\n\n/* line 57, stdin */\nh4[_v-4e31ff94]:last-child {\n  border: navajowhite; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-4e31ff94", module.exports)
  } else {
    hotAPI.update("_v-4e31ff94", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/get-iterator":46,"babel-runtime/core-js/object/entries":54,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/defineProperty":65,"babel-runtime/helpers/extends":66,"babel-runtime/helpers/slicedToArray":70,"babel-runtime/regenerator":75,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1394:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n/* line 2, stdin */\n.page-div[_v-5e0739ee] {\n  padding: 0 15px;\n  margin-bottom: 15px; }\n\n/* line 7, stdin */\n.m-l-15[_v-5e0739ee] {\n  margin-left: 15px; }\n\n/* line 11, stdin */\n.table-div[_v-5e0739ee] {\n  padding: 20px 0; }\n\n/* line 15, stdin */\n.total-list[_v-5e0739ee] {\n  margin: 15px 0 0 0; }\n\n/* line 19, stdin */\n.total-list[_v-5e0739ee]:after {\n  clear: both; }\n\n/* line 23, stdin */\n.table-striped thead[_v-5e0739ee] {\n  border-bottom: 1px solid #000; }\n\n/* line 27, stdin */\n.multiselect[_v-5e0739ee] {\n  padding-bottom: 5px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    mounted: function mounted() {
        var _this = this;

        this.configuredRun(function () {
            _this.changeFilterOption({
                prop: 'studioId',
                value: {
                    id: _this.configureStates.studioId,
                    brand_name: ''
                }
            });
            _this.changeFilterOption({
                prop: 'branchId',
                value: _this.configureStates.branchId
            });
            if (_this.configureStates.isSeventeen) {
                return _this.fetchStudioList();
            }
            if (_this.configureStates.isBranch) {
                _this.branchIds = [{
                    'id': _this.configureStates.branchId,
                    'branch_name': ''
                }];
            }
        });
        this.changeDateOption({
            prop: 'startDate',
            value: moment().add(-6, 'day').format('YYYY/MM/DD')
        });
        this.changeDateOption({
            prop: 'endDate',
            value: moment().format('YYYY/MM/DD')
        });
        this.initConfirmStatus();
    },

    watch: (0, _defineProperty3.default)({}, 'filterOptions.studioId', function filterOptionsStudioId(n, o) {
        if (this.configureStates.isSeventeen || this.configureStates.isStudio) {
            this.fetchBranchList({
                studioId: n.id
            });
        }
    }),
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        configureStates: function configureStates(state) {
            return state.webadmin.configure;
        }
    }), (0, _vuex.mapState)('webadmin/configure', ['configured', 'studioList', 'branchList', 'branchId']), (0, _vuex.mapState)('webadmin/ticketsUsedReport', ['blockOpenStatus', 'dateOptions', 'filterOptions', 'ajaxing', 'list', 'total', 'confirmStatus', 'confirmStatusShow']), {
        studioId: {
            get: function get() {
                return this.filterOptions.studioId;
            },
            set: function set(newValue) {
                var _this2 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                    return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.next = 2;
                                    return _this2.changeFilterOption({ 'prop': 'studioId', value: newValue });

                                case 2:
                                    _this2.cleanBranch();

                                    if (!newValue) {
                                        _context.next = 6;
                                        break;
                                    }

                                    _context.next = 6;
                                    return _this2.fetchBranchList({ studioId: newValue.id });

                                case 6:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this2);
                }))();
            }
        },
        branchIds: {
            get: function get() {
                return this.filterOptions.branchIds;
            },
            set: function set(newValue) {
                var _this3 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                    return _regenerator2.default.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    _context2.next = 2;
                                    return _this3.changeFilterOption({ 'prop': 'branchIds', value: newValue });

                                case 2:
                                case 'end':
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, _this3);
                }))();
            }
        },
        confirmStatuses: {
            get: function get() {
                return this.filterOptions.confirmStatuses;
            },
            set: function set(newValue) {
                var _this4 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
                    return _regenerator2.default.wrap(function _callee3$(_context3) {
                        while (1) {
                            switch (_context3.prev = _context3.next) {
                                case 0:
                                    _context3.next = 2;
                                    return _this4.$store.dispatch('webadmin/ticketsUsedReport/changeFilterOption', { 'prop': 'confirmStatuses', value: newValue });

                                case 2:
                                case 'end':
                                    return _context3.stop();
                            }
                        }
                    }, _callee3, _this4);
                }))();
            }
        }
    }),
    methods: (0, _extends3.default)({
        updateFilterOption: function updateFilterOption(field) {
            var _this5 = this;

            return function (value) {
                return _this5.changeFilterOption({
                    prop: field,
                    value: value
                });
            };
        }
    }, (0, _vuex.mapActions)('webadmin/configure', ['configuredRun', 'fetchStudioList', 'fetchBranchList', 'pushObjectStatus']), (0, _vuex.mapActions)('webadmin/ticketsUsedReport', ['submit', 'toggleBlock', 'changeDateOption', 'changeFilterOption', 'changeItemOption', 'cleanBranch', 'cleanBranchRelated', 'initConfirmStatus']))
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"page-div\" _v-5e0739ee=\"\">\n    <v-webadmin-report :block-open-status=\"blockOpenStatus\" :date-options=\"dateOptions\" :toggle-block=\"toggleBlock\" :change-date-option=\"changeDateOption\" :disable-submit=\"ajaxing\" :submit=\"submit\" limit-date=\"180\" title=\"票券使用紀錄\" _v-5e0739ee=\"\">\n        <div slot=\"second-block\" _v-5e0739ee=\"\">\n            <div class=\"filters\" _v-5e0739ee=\"\">\n                <div class=\"row\" _v-5e0739ee=\"\">\n                    <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen\" _v-5e0739ee=\"\">\n                        <div class=\"form-group\" _v-5e0739ee=\"\">\n                            <v-mutiselect :model.sync=\"studioId\" :options=\"studioList\" :preserve-search=\"true\" :placeholder=\"configureStates.ajaxing.studioList ? '品牌讀取中…' : '請選擇品牌'\" label=\"brand_name\" track-by=\"id\" _v-5e0739ee=\"\">\n                            </v-mutiselect>\n                        </div>\n                    </div>\n                    <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen || configureStates.isStudio\" _v-5e0739ee=\"\">\n                        <div class=\"form-group\" _v-5e0739ee=\"\">\n                            <v-mutiselect :model.sync=\"branchIds\" :options=\"branchList\" :disabled=\"configureStates.ajaxing.branchList\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"false\" :placeholder=\"configureStates.ajaxing.branchList ? '場館讀取中…' : '全部場館'\" label=\"branch_name\" track-by=\"id\" :taggable=\"true\" tag-name=\"branch_name\" :max-height=\"500\" _v-5e0739ee=\"\">\n                            </v-mutiselect>\n                        </div>\n                    </div>\n                    <div class=\"col-sm-6\" _v-5e0739ee=\"\">\n                        <div class=\"form-group\" _v-5e0739ee=\"\">\n                            <v-mutiselect :model.sync=\"confirmStatuses\" :options=\"confirmStatus\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"false\" placeholder=\"票券狀態\" label=\"name\" track-by=\"status\" :max-height=\"500\" tag-name=\"name\" _v-5e0739ee=\"\">\n                            </v-mutiselect>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </v-webadmin-report>\n    <div class=\"row total-list\" v-if=\"list.length>0\" _v-5e0739ee=\"\">\n        <h4 _v-5e0739ee=\"\">總票券數：{{total}}</h4>\n    </div>\n    <div class=\"table-div\" _v-5e0739ee=\"\">\n        <v-table :ajaxing=\"ajaxing\" :length=\"list.length\" _v-5e0739ee=\"\">\n            <table class=\"table table-striped\" _v-5e0739ee=\"\">\n                <thead _v-5e0739ee=\"\">\n                <tr _v-5e0739ee=\"\">\n                    <td _v-5e0739ee=\"\">場館</td>\n                    <td _v-5e0739ee=\"\">票券號碼</td>\n                    <td _v-5e0739ee=\"\">結帳日期</td>\n                    <td _v-5e0739ee=\"\">訂單編號</td>\n                    <td _v-5e0739ee=\"\">客戶姓名</td>\n                    <td _v-5e0739ee=\"\">狀態</td>\n                </tr>\n                </thead>\n                <tbody _v-5e0739ee=\"\">\n                <tr v-for=\"item in list\" _v-5e0739ee=\"\">\n                    <td _v-5e0739ee=\"\">{{ item.branch_name }}</td>\n                    <td _v-5e0739ee=\"\">{{ item.id }}</td>\n                    <td _v-5e0739ee=\"\">{{ item.checkout_at }}</td>\n                    <td _v-5e0739ee=\"\">{{ item.order_id }}</td>\n                    <td _v-5e0739ee=\"\">{{ item.member_name }}</td>\n                    <td _v-5e0739ee=\"\">{{ item.status_show }}</td>\n                </tr>\n                </tbody>\n            </table>\n        </v-table>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n/* line 2, stdin */\n.page-div[_v-5e0739ee] {\n  padding: 0 15px;\n  margin-bottom: 15px; }\n\n/* line 7, stdin */\n.m-l-15[_v-5e0739ee] {\n  margin-left: 15px; }\n\n/* line 11, stdin */\n.table-div[_v-5e0739ee] {\n  padding: 20px 0; }\n\n/* line 15, stdin */\n.total-list[_v-5e0739ee] {\n  margin: 15px 0 0 0; }\n\n/* line 19, stdin */\n.total-list[_v-5e0739ee]:after {\n  clear: both; }\n\n/* line 23, stdin */\n.table-striped thead[_v-5e0739ee] {\n  border-bottom: 1px solid #000; }\n\n/* line 27, stdin */\n.multiselect[_v-5e0739ee] {\n  padding-bottom: 5px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-5e0739ee", module.exports)
  } else {
    hotAPI.update("_v-5e0739ee", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/defineProperty":65,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1395:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.page-div[_v-c31fb38c] {\n  padding: 0px 15px;\n  margin-bottom: 15px; }\n\n/* line 7, stdin */\n.table-div[_v-c31fb38c] {\n  padding: 20px 0px; }\n\n/* line 10, stdin */\n.total-list[_v-c31fb38c] {\n  margin-left: 10px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _watch;

var _vuex = require('vuex');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            display: 'show',
            result: {},
            localFilter: {
                contractType: {
                    name: "全部方案類型",
                    value: '1,2,3'
                }
            },
            contractTypeList: [{ name: '全部方案類型', value: '1,2,3' }, { name: '次數', value: '3' }, { name: '點數', value: '2' }, { name: '無限', value: '1' }],
            relatedFilterWatcher: {
                studio_id: {
                    watcher: null,
                    options: "studioList",
                    vModel: "studioId",
                    trackBy: "id",
                    type: "single"
                },
                branch_ids: {
                    watcher: "studioId",
                    options: "branchList",
                    vModel: "branchIds",
                    trackBy: "id",
                    type: "multiple"
                },
                contract_ids: {
                    watcher: "studioId",
                    options: "contractList",
                    vModel: "contractIds",
                    trackBy: "id",
                    type: "multiple"
                },
                contract_type: {
                    watcher: null,
                    options: "contractTypeList",
                    vModel: "contractType",
                    trackBy: "value",
                    type: "single"
                }
            },
            contractIds: null,
            actionType: 'booking',
            customerType: 'all',
            member: null,
            export: []
        };
    },
    created: function created() {
        this.syncRelatedMultipleSelectByQuery({ vm: this, relatedFilterWatcher: this.relatedFilterWatcher });
        this.syncDateAndDisplayByQuery({
            'diffType': 'months',
            'diffNumber': -1
        });
        var query = $17.getUrlQueryStrings();
        this.actionType = query.action ? query.action : 'booking';
        this.customerType = query.member_id && query.member_id != 0 ? 'selected' : 'all';
    },
    mounted: function mounted() {
        var _this = this;

        this.configuredRun(function () {
            _this.changeFilterOption({
                prop: 'studioId',
                value: {
                    id: _this.configureStates.studioId,
                    brand_name: ''
                }
            });
            _this.changeFilterOption({
                prop: 'branchId',
                value: _this.configureStates.branchId
            });
            if (_this.configureStates.isSeventeen) {
                return _this.fetchStudioList();
            }
            if (_this.configureStates.isStudio) {
                _this.fetchContractList({ 'studioId': _this.configureStates.studioId, 'withDelete': true, 'contractType': _this.localFilter.contractType.value });
            }
            if (_this.configureStates.isBranch) {
                _this.fetchContractList({ 'studioId': _this.configureStates.studioId, 'branchId': _this.configureStates.branchID, 'withDelete': true, 'contractType': _this.localFilter.contractType.value });
            }
            _this.$nextTick(function () {
                var query = $17.getUrlQueryStrings();
                if (query.member_id && query.member_id != 0) {
                    _this.member = {
                        id: query.member_id,
                        name: query.member_name
                    };
                }
            });
        });
    },

    watch: (_watch = {}, (0, _defineProperty3.default)(_watch, 'filterOptions.studioId', function filterOptionsStudioId(n, o) {
        if (this.configureStates.isSeventeen || this.configureStates.isStudio) {
            this.fetchBranchList({
                studioId: n.id
            });
        }
        if (this.configureStates.isSeventeen && n.id != 0) {
            this.fetchContractList({ 'studioId': n.id, 'withDelete': true, 'contractType': this.localFilter.contractType.value });
            this.memberChange(null);
        }
    }), (0, _defineProperty3.default)(_watch, 'configureStates.ajaxing.contractList', function configureStatesAjaxingContractList(n, o) {
        if (n) this.contractIds = [];
    }), (0, _defineProperty3.default)(_watch, 'localFilter.contractType', function localFilterContractType(n, o) {
        if (n != undefined) {
            this.fetchContractList({ 'studioId': this.studioId.id, 'withDelete': true, 'contractType': n.value });
        }
    }), (0, _defineProperty3.default)(_watch, 'export', function _export(newV) {
        if (newV) {
            this.csvConfig.jsonData = _lodash2.default.cloneDeep(newV);
            this.$refs.smart_table.downloadCsv();
        }
    }), (0, _defineProperty3.default)(_watch, 'customerType', function customerType() {
        this.member = null;
    }), (0, _defineProperty3.default)(_watch, 'actionType', function actionType() {
        this.result = {};
    }), _watch),
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        configureStates: function configureStates(state) {
            return state.webadmin.configure;
        }
    }), (0, _vuex.mapState)('webadmin/configure', ['configured', 'studioList', 'branchList', 'branchId', 'contractList']), (0, _vuex.mapState)('webadmin/baseReport', ['blockOpenStatus', 'dateOptions', 'filterOptions', 'queryPara', "ajaxing"]), {
        studioId: {
            get: function get() {
                return this.filterOptions.studioId;
            },
            set: function set(newValue) {
                var _this2 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                    return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.next = 2;
                                    return _this2.changeFilterOption({ 'prop': 'studioId', value: newValue });

                                case 2:
                                    _this2.cleanBranch();

                                    if (!newValue) {
                                        _context.next = 6;
                                        break;
                                    }

                                    _context.next = 6;
                                    return _this2.fetchBranchList({ studioId: newValue.id });

                                case 6:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this2);
                }))();
            }
        },
        branchIds: {
            get: function get() {
                return this.filterOptions.branchIds;
            },
            set: function set(newValue) {
                var _this3 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                    return _regenerator2.default.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    _context2.next = 2;
                                    return _this3.changeFilterOption({ 'prop': 'branchIds', value: newValue });

                                case 2:
                                case 'end':
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, _this3);
                }))();
            }
        },
        contractType: {
            get: function get() {
                return this.localFilter.contractType;
            },
            set: function () {
                var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(newValue) {
                    return _regenerator2.default.wrap(function _callee3$(_context3) {
                        while (1) {
                            switch (_context3.prev = _context3.next) {
                                case 0:
                                    this.localFilter.contractType = newValue;

                                case 1:
                                case 'end':
                                    return _context3.stop();
                            }
                        }
                    }, _callee3, this);
                }));

                function set(_x) {
                    return _ref.apply(this, arguments);
                }

                return set;
            }()
        },
        viewMode: {
            get: function get() {
                return this.$store.state.webadmin.baseReport.itemOptions.viewMode;
            },
            set: function set(value) {
                this.changeItemOption({
                    prop: 'viewMode',
                    value: value
                });
            }
        },
        memberData: function memberData() {
            if (this.member == null) {
                return {
                    id: '',
                    name: '',
                    phone: '',
                    email: ''
                };
            }
            return {
                id: this.member.id,
                name: this.member.name,
                phone: this.member.phone,
                email: this.member.email
            };
        },
        tableConfig: function tableConfig() {
            if (this.actionType == 'booking') {
                return {
                    columns: [{ keys: "created_at", head: "建立日期時間" }, { keys: "member_name", head: "客戶名稱" }, { keys: "member_phone", head: "電話" }, { keys: "member_email", head: "E-mail" }, { keys: "contract_name", head: "使用方案" }, { keys: "contract_type", head: "方案類型" }, { keys: "branch_name", head: "場館名稱" }, { keys: "item_type", head: "項目類型" }, { keys: "items_name", head: "項目名稱" }, { keys: "start_time", head: "預約日期時間" }, { keys: "status", head: "狀態" }]
                };
            }

            if (this.actionType == 'admission') {
                return {
                    columns: [{ keys: "member_name", head: "客戶名稱" }, { keys: "member_phone", head: "電話" }, { keys: "member_email", head: "E-mail" }, { keys: "contract_name", head: "使用方案" }, { keys: "contract_type", head: "方案類型" }, { keys: "branch_name", head: "場館名稱" }, { keys: "entered_at", head: "入場日期時間" }, { keys: "leaved_at", head: "出場日期時間" }]
                };
            }
        },
        csvConfig: function csvConfig() {
            if (this.actionType == 'booking') {
                return {
                    column: [{ keys: "created_at", name: "建立日期時間" }, { keys: "member_name", name: "客戶名稱" }, { keys: "member_phone", name: "電話" }, { keys: "member_email", name: "E-mail" }, { keys: "contract_name", name: "使用方案" }, { keys: "contract_type", name: "方案類型" }, { keys: "branch_name", name: "場館名稱" }, { keys: "item_type", name: "項目類型" }, { keys: "items_name", name: "項目名稱" }, { keys: "start_time", name: "預約日期時間" }, { keys: "status", name: "狀態" }],
                    fileName: "customer-contract-consume-records-" + moment().format("YYYYMMDDHHmmss")
                };
            }

            if (this.actionType == 'admission') {
                return {
                    column: [{ keys: "member_name", name: "客戶名稱" }, { keys: "member_phone", name: "電話" }, { keys: "member_email", name: "E-mail" }, { keys: "contract_name", name: "使用方案" }, { keys: "contract_type", name: "方案類型" }, { keys: "branch_name", name: "場館名稱" }, { keys: "entered_at", name: "入場日期時間" }, { keys: "leaved_at", name: "出場日期時間" }],
                    fileName: "customer-contract-consume-records-" + moment().format("YYYYMMDDHHmmss")
                };
            }
        }
    }),
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('webadmin/configure', ['configuredRun', 'fetchStudioList', 'fetchBranchList', 'fetchContractList']), (0, _vuex.mapActions)('webadmin/baseReport', ['beforeSubmit', 'toggleBlock', 'changeDateOption', 'changeFilterOption', 'cleanBranch', 'cleanBranchRelated', 'changeItemOption', 'setDetailTarget', 'keepQueryParam', "changeAjaxing", "syncDateAndDisplayByQuery", "syncLocalMultipleSelectByQuery", "syncRelatedMultipleSelectByQuery", "changeDisplay"]), {
        submitSearch: function submitSearch() {
            this.beforeSubmit();
            switch (this.display) {
                case "export":
                    this.changeFilterOption({ prop: "pageSize", value: 9999999 });
                    break;
                case "show":
                    this.changeFilterOption({ prop: "pageSize", value: 25 });
                    break;
                default:
                    null;
            }
            var params = this.getParams();

            this.keepQueryParam(params);
            $17.updateUrlQueryString(params);

            this.changePage(1);
        },
        getResult: function getResult(params) {
            var _this4 = this;

            this.changeAjaxing(true);
            this.$http.get('/adminapi/report/fetch-unlimited-change-record-report', { params: params }).then(function (response) {
                if (_this4.display == 'export') {
                    _this4.export = response.data.records;
                }
                if (_this4.display == 'show') {
                    _this4.result = response.data;
                }
                _this4.changeAjaxing(false);
            }, function (error) {
                _this4.changeAjaxing(false);
                $17.swal({
                    title: error.body.message,
                    type: 'warning'
                });
            });
        },
        checkMode: function checkMode(mode) {
            return this.viewMode === mode;
        },
        getParams: function getParams() {
            return {
                'studio_id': this.studioId.id,
                'branch_ids': this.branchIds.map(function (item) {
                    return item.id;
                }),
                'contract_ids': this.contractIds.map(function (item) {
                    return item.id;
                }),
                'contract_type': this.localFilter.contractType && this.localFilter.contractType.value ? this.localFilter.contractType.value : null,
                'start_date': this.dateOptions.startDate,
                'end_date': this.dateOptions.endDate,
                'action': this.actionType,
                'member_id': this.customerType !== 'all' && this.member != null && this.member.id ? this.member.id : 0,
                'member_name': this.customerType !== 'all' && this.member != null && this.member.id ? this.member.name : ''
            };
        },
        changePage: function changePage(page) {
            var _this5 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
                var params;
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _this5.changeFilterOption({
                                    prop: "page",
                                    value: page
                                });

                                params = _this5.queryPara;


                                params.page_size = _this5.filterOptions.pageSize;
                                params.page = _this5.filterOptions.page;

                                if (_this5.filterOptions.studioId.id > 0) {
                                    _this5.reset();
                                    _this5.getResult(params);
                                }

                            case 5:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this5);
            }))();
        },
        reset: function reset() {
            this.result = {};
        },
        memberChange: function memberChange(member) {
            this.member = member;
        },
        resetMember: function resetMember() {
            this.member = null;
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"page-div\" _v-c31fb38c=\"\">\n    <v-webadmin-report :block-open-status=\"blockOpenStatus\" :date-options=\"dateOptions\" :toggle-block=\"toggleBlock\" :change-date-option=\"changeDateOption\" :studio-id=\"studioId\" ref=\"report\" :disable-submit=\"ajaxing\" :submit=\"submitSearch\" limit-date=\"365\" title=\"客戶方案使用紀錄\" _v-c31fb38c=\"\">\n        <div slot=\"second-block\" _v-c31fb38c=\"\">\n            <div class=\"row\" _v-c31fb38c=\"\">\n                <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen\" _v-c31fb38c=\"\">\n                    <div class=\"form-group\" _v-c31fb38c=\"\">\n                        <v-mutiselect :model.sync=\"studioId\" :options=\"studioList\" :preserve-search=\"true\" :placeholder=\"configureStates.ajaxing.studioList ? '品牌讀取中…' : '請選擇品牌'\" label=\"brand_name\" track-by=\"id\" _v-c31fb38c=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n                <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen || configureStates.isStudio\" _v-c31fb38c=\"\">\n                    <div class=\"form-group\" _v-c31fb38c=\"\">\n                        <v-mutiselect :model.sync=\"branchIds\" :options=\"branchList\" :disabled=\"configureStates.ajaxing.branchList\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"false\" :placeholder=\"configureStates.ajaxing.branchList ? '場館讀取中…' : '全部場館'\" label=\"branch_name\" track-by=\"id\" :taggable=\"true\" tag-name=\"branch_name\" _v-c31fb38c=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n                <div class=\"col-sm-6\" _v-c31fb38c=\"\">\n                    <div class=\"form-group\" _v-c31fb38c=\"\">\n                        <v-mutiselect :model.sync=\"localFilter.contractType\" :options=\"contractTypeList\" :searchable=\"false\" :placeholder=\"'方案類型'\" :allow-empty=\"false\" label=\"name\" track-by=\"value\" tag-name=\"name\" _v-c31fb38c=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n                <div class=\"col-sm-6\" _v-c31fb38c=\"\">\n                    <div class=\"form-group\" _v-c31fb38c=\"\">\n                        <v-mutiselect :model.sync=\"contractIds\" :options=\"contractList\" :disabled=\"configureStates.ajaxing.contractList\" :multiple=\"true\" :close-on-select=\"false\" :clear-on-select=\"false\" :hide-selected=\"true\" :preserve-search=\"true\" :searchable=\"true\" :placeholder=\"configureStates.ajaxing.contractList ? '方案讀取中…' : '全部方案'\" label=\"name\" track-by=\"id\" :taggable=\"false\" tag-name=\"name\" :max-height=\"300\" open-direction=\"bottom\" _v-c31fb38c=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n            </div>\n            <div class=\"row\" _v-c31fb38c=\"\">\n                <div class=\"col-sm-6\" _v-c31fb38c=\"\">\n                    <div class=\"form-group\" _v-c31fb38c=\"\">\n                        <label _v-c31fb38c=\"\">\n                            客戶 \n                        </label>\n                        <label for=\"all-action\" class=\"m-left-15\" _v-c31fb38c=\"\">\n                            <input name=\"member\" type=\"radio\" value=\"all\" id=\"all-action\" v-model=\"customerType\" _v-c31fb38c=\"\"> 全部客戶\n                        </label>\n                        <label for=\"selected-action\" class=\"m-left-15\" _v-c31fb38c=\"\">\n                            <input name=\"member\" type=\"radio\" value=\"selected\" id=\"selected-action\" v-model=\"customerType\" _v-c31fb38c=\"\"> 選擇客戶:\n                        </label>\n                        <v-member-multi-select v-if=\"studioId!=null\" id=\"search-member\" :studio-id=\"studioId.id\" :clear-when-select=\"false\" :disabled=\"customerType=='all'\" :selected-action=\"memberChange\" :unselected-action=\"resetMember\" :max-height=\"250\" v-show=\"member==null &amp;&amp; customerType=='selected'\" _v-c31fb38c=\"\">\n                        </v-member-multi-select>\n                        <label for=\"\" v-show=\"member!==null\" _v-c31fb38c=\"\">\n                            {{memberData.name}}\n                            <div class=\"btn btn-primary\" @click=\"resetMember\" _v-c31fb38c=\"\">重新選擇</div>\n                        </label>\n                    </div>\n                </div>\n            </div>\n            <div class=\"row\" _v-c31fb38c=\"\">\n                <div class=\"col-sm-6\" _v-c31fb38c=\"\">\n                    <div class=\"form-group\" _v-c31fb38c=\"\">\n                        <label _v-c31fb38c=\"\">\n                            行為 \n                        </label>\n                        <label for=\"booking-action\" class=\"m-left-15\" _v-c31fb38c=\"\">\n                            <input name=\"action\" type=\"radio\" value=\"booking\" id=\"booking-action\" v-model=\"actionType\" _v-c31fb38c=\"\"> 預約\n                        </label>\n                        <label for=\"admission-action\" class=\"m-left-15\" _v-c31fb38c=\"\">\n                            <input name=\"action\" type=\"radio\" value=\"admission\" id=\"admission-action\" v-model=\"actionType\" _v-c31fb38c=\"\"> 入場\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div slot=\"third-block\" _v-c31fb38c=\"\">\n            <div class=\"row\" _v-c31fb38c=\"\">\n                <div class=\"col-sm-6\" _v-c31fb38c=\"\">\n                    <div class=\"form-group\" _v-c31fb38c=\"\">\n                        <label _v-c31fb38c=\"\">\n                            <input name=\"view\" type=\"radio\" value=\"detail\" v-model=\"viewMode\" checked=\"\" _v-c31fb38c=\"\"> 顯示細節\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div slot=\"fourth-block\" _v-c31fb38c=\"\">\n            <div class=\"row\" _v-c31fb38c=\"\">\n                <div class=\"col-sm-6\" _v-c31fb38c=\"\">\n                    <div class=\"form-group\" _v-c31fb38c=\"\">\n                        <label _v-c31fb38c=\"\">\n                            <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"show\" checked=\"\" _v-c31fb38c=\"\"> 顯示於網頁\n                        </label>\n                        <label _v-c31fb38c=\"\">\n                            <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"export\" _v-c31fb38c=\"\"> 匯出 CSV\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div> \n    </v-webadmin-report>\n    <div class=\"m-top-10\" v-show=\"display == 'show'\" _v-c31fb38c=\"\">\n        <v-smart-table ref=\"smart_table\" :table-config=\"tableConfig\" :csv-config=\"csvConfig\" :is-ajaxing=\"ajaxing\" :data=\"result\" :page-sync-url-query=\"false\" @change-page=\"changePage\" _v-c31fb38c=\"\"></v-smart-table>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.page-div[_v-c31fb38c] {\n  padding: 0px 15px;\n  margin-bottom: 15px; }\n\n/* line 7, stdin */\n.table-div[_v-c31fb38c] {\n  padding: 20px 0px; }\n\n/* line 10, stdin */\n.total-list[_v-c31fb38c] {\n  margin-left: 10px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-c31fb38c", module.exports)
  } else {
    hotAPI.update("_v-c31fb38c", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/defineProperty":65,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1396:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _vuex = require('vuex');

var _line2 = require('../../../utilities/webadmin/chart/line.js');

var _line3 = _interopRequireDefault(_line2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        LineChart: _line3.default
    },
    data: function data() {
        return {
            ajaxing: false,
            display: 'show',
            originChartData: {},
            chartData: {},
            compareLastYear: 0,
            showType: 'all',
            dateType: 'day',
            options: {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: false
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            callback: function callback(value) {
                                if (value % 1 === 0) {
                                    return value;
                                }
                            }
                        }
                    }]
                }
            }
        };
    },
    mounted: function mounted() {
        var _this = this;

        this.configuredRun(function () {
            _this.changeFilterOption({
                prop: 'studioId',
                value: {
                    id: _this.configureStates.studioId,
                    brand_name: ''
                }
            });
            _this.changeFilterOption({
                prop: 'branchId',
                value: _this.configureStates.branchId
            });
            if (_this.configureStates.isSeventeen) {
                return _this.fetchStudioList();
            }
            if (_this.configureStates.isBranch) {
                _this.branchIds = {
                    'id': _this.configureStates.branchId,
                    'branch_name': ''
                };
            }
        });

        this.changeDateOption({
            prop: 'startDate',
            value: moment().add(-1, 'days').format('YYYY/MM/DD')
        });

        this.changeDateOption({
            prop: 'endDate',
            value: moment().add(-1, 'days').format('YYYY/MM/DD')
        });
    },

    watch: (0, _defineProperty3.default)({}, 'filterOptions.studioId', function filterOptionsStudioId(n, o) {
        if (this.configureStates.isSeventeen || this.configureStates.isStudio) {
            this.fetchBranchList({
                studioId: n.id
            });
        }
    }),
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        configureStates: function configureStates(state) {
            return state.webadmin.configure;
        }
    }), (0, _vuex.mapState)('webadmin/configure', ['configured', 'studioList', 'branchList', 'branchId', 'isBranch', 'isStudio', 'isSeventeen']), (0, _vuex.mapState)('webadmin/baseReport', ['blockOpenStatus', 'dateOptions', 'filterOptions']), {
        studioId: {
            get: function get() {
                return this.filterOptions.studioId;
            },
            set: function set(newValue) {
                var _this2 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                    return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.next = 2;
                                    return _this2.changeFilterOption({ 'prop': 'studioId', value: newValue });

                                case 2:
                                    _this2.cleanBranch();

                                    if (!newValue) {
                                        _context.next = 6;
                                        break;
                                    }

                                    _context.next = 6;
                                    return _this2.fetchBranchList({ studioId: newValue.id });

                                case 6:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this2);
                }))();
            }
        },
        branchIds: {
            get: function get() {
                return this.filterOptions.branchIds;
            },
            set: function set(newValue) {
                var _this3 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                    return _regenerator2.default.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    _context2.next = 2;
                                    return _this3.changeFilterOption({ 'prop': 'branchIds', value: newValue });

                                case 2:
                                case 'end':
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, _this3);
                }))();
            }
        },
        viewMode: {
            get: function get() {
                return this.$store.state.webadmin.baseReport.itemOptions.viewMode;
            },
            set: function set(value) {
                this.changeItemOption({
                    prop: 'viewMode',
                    value: value
                });
            }
        }
    }),
    methods: (0, _extends3.default)({
        checkMode: function checkMode(mode) {
            return this.viewMode === mode;
        }
    }, (0, _vuex.mapActions)('webadmin/configure', ['configuredRun', 'fetchStudioList', 'fetchBranchList']), (0, _vuex.mapActions)('webadmin/baseReport', ['beforeSubmit', 'toggleBlock', 'changeDateOption', 'changeFilterOption', 'cleanBranch', 'cleanBranchRelated']), {
        submit: function submit() {
            this.beforeSubmit();
            this.getResult();
        },
        getResult: function getResult() {
            var _this4 = this;

            var data = {
                'studio_id': this.studioId.id,
                'branch_id': this.branchIds.id,
                'start_date': this.dateOptions.startDate,
                'end_date': this.dateOptions.endDate,
                'show_type': this.showType,
                'compare_last_year': this.compareLastYear
            };
            var params = $.param(data);
            this.ajaxing = true;
            this.$http.get('/adminapi/report/y_o_y_revenue_report?' + params).then(function (response) {
                _this4.ajaxing = false;
                _this4.originChartData = response.body;
                _this4.convertToDateType(response.body);
            }, function (error) {
                _this4.ajaxing = false;
            });
        },
        convertToDateType: function convertToDateType(allData) {
            var lineData = [];
            var data = [];
            var showData = [];
            if (this.dateType == 'day') {
                data = [];
                data.labels = [];
                data.perLine = [];

                for (var key in allData[0]['day']) {
                    data.labels.push(key);
                }

                for (var line in allData) {
                    var days = allData[line]['day'];
                    if (!days) {
                        continue;
                    }
                    showData = [];
                    for (var _key in days) {
                        showData.push(days[_key]);
                    }
                    data['perLine'][[allData[line]['show_label']]] = showData;
                }
            }
            if (this.dateType == 'month') {
                data = [];
                data.labels = [];
                data.perLine = [];

                for (var _key2 in allData[0]['month']) {
                    data.labels.push(_key2);
                }

                for (var _line in allData) {
                    var month = allData[_line]['month'];
                    if (!month) {
                        continue;
                    }
                    showData = [];
                    for (var _key3 in month) {
                        showData.push(month[_key3]);
                    }
                    data['perLine'][[allData[_line]['show_label']]] = showData;
                }
            }
            this.update(data);
        },
        update: function update(data) {
            var perLineData = data.perLine;
            var labels = data.labels;
            var allData = [];
            var colors = ['#38b0e3', 'rgb(184,184,184)', 'rgb(85,85,85)', 'rgb(229,229,229)'];
            var colorIndex = 0;

            var currentData = [];
            for (var index in perLineData) {
                if (perLineData.hasOwnProperty(index)) {
                    // let showColor = Object.keys(perLineData).length > 1 && colors.hasOwnProperty(colorIndex) ? colors[colorIndex] : '#38b0e3';
                    var showColor = colors[colorIndex];

                    allData.push({
                        label: index,
                        fill: false,
                        borderColor: showColor,
                        backgroundColor: showColor,
                        pointBackgroundColor: showColor,
                        pointBorderColor: showColor,
                        pointHoverBackgroundColor: "#fff",
                        pointHoverBorderColor: showColor,
                        data: Array.isArray(perLineData[index]) ? perLineData[index] : []
                    });
                    colorIndex++;
                }
            }
            if (allData.length > 1) {
                this.options.legend.display = true;
            }
            this.chartData = {
                labels: labels,
                datasets: allData
            };
        },
        getByDay: function getByDay() {
            this.dateType = 'day';
            this.convertToDateType(this.originChartData);
        },
        getByMonth: function getByMonth() {
            this.dateType = 'month';
            this.convertToDateType(this.originChartData);
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"page-div\" _v-25bd86b0=\"\">\n    <v-webadmin-report :block-open-status=\"blockOpenStatus\" :date-options=\"dateOptions\" :toggle-block=\"toggleBlock\" :change-date-option=\"changeDateOption\" :disable-submit=\"ajaxing\" :submit=\"submit\" limit-date=\"365\" title=\"營收對比報表\" _v-25bd86b0=\"\">\n        <div slot=\"second-block\" _v-25bd86b0=\"\">\n            <div class=\"row\" _v-25bd86b0=\"\">\n                <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen\" _v-25bd86b0=\"\">\n                    <div class=\"form-group\" _v-25bd86b0=\"\">\n                        <v-mutiselect :model.sync=\"studioId\" :options=\"studioList\" :preserve-search=\"true\" :placeholder=\"configureStates.ajaxing.studioList ? '品牌讀取中…' : '請選擇品牌'\" label=\"brand_name\" track-by=\"id\" _v-25bd86b0=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n            </div>\n            <div class=\"row\" _v-25bd86b0=\"\">\n                <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen || configureStates.isStudio\" _v-25bd86b0=\"\">\n                    <div class=\"form-group\" _v-25bd86b0=\"\">\n                        <v-mutiselect :model.sync=\"branchIds\" :options=\"branchList\" :disabled=\"configureStates.ajaxing.branchList\" :multiple=\"false\" :close-on-select=\"true\" :clear-on-select=\"false\" :hide-selected=\"false\" :preserve-search=\"false\" :searchable=\"false\" :placeholder=\"configureStates.ajaxing.branchList ? '場館讀取中…' : '全部場館'\" label=\"branch_name\" track-by=\"id\" :taggable=\"true\" tag-name=\"branch_name\" :max-height=\"500\" _v-25bd86b0=\"\">\n                        </v-mutiselect>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div slot=\"third-block\" _v-25bd86b0=\"\">\n            <div class=\"row\" _v-25bd86b0=\"\">\n                <div class=\"col-sm-6\" _v-25bd86b0=\"\">\n                    <span _v-25bd86b0=\"\">\n                        <input type=\"radio\" id=\"all\" v-model=\"showType\" value=\"all\" _v-25bd86b0=\"\">\n                        <label for=\"all\" _v-25bd86b0=\"\">包含收入及退費</label>\n                        <input type=\"radio\" id=\"income\" v-model=\"showType\" value=\"income\" _v-25bd86b0=\"\">\n                        <label for=\"income\" _v-25bd86b0=\"\">收入</label>\n                        <input type=\"radio\" id=\"outcome\" v-model=\"showType\" value=\"outcome\" _v-25bd86b0=\"\">\n                        <label for=\"outcome\" _v-25bd86b0=\"\">退費</label>\n                    </span>\n                    <span style=\"padding-left:1.5em\" _v-25bd86b0=\"\">\n                        <input type=\"checkbox\" v-model=\"compareLastYear\" :false-value=\"0\" :true-value=\"1\" id=\"compareLastYear\" _v-25bd86b0=\"\">\n                        <label for=\"compareLastYear\" _v-25bd86b0=\"\">比較前一年度</label>\n                    </span>\n                </div>\n            </div>\n        </div>\n    </v-webadmin-report>\n    <v-spinner :ajaxing=\"ajaxing\" _v-25bd86b0=\"\"></v-spinner>\n    <div class=\"row col-xs-12\" v-show=\"!ajaxing\" _v-25bd86b0=\"\">\n        <h4 class=\"pull-left\" _v-25bd86b0=\"\"></h4>\n        <div class=\"btn-group pull-right\" role=\"group\" _v-25bd86b0=\"\">\n            <button @click=\"getByDay()\" :class=\"{'active':dateType=='day'}\" type=\"button\" class=\"btn btn-default\" _v-25bd86b0=\"\">日</button>\n            <button @click=\"getByMonth()\" :class=\"{'active':dateType=='month'}\" type=\"button\" class=\"btn btn-default\" _v-25bd86b0=\"\">月</button>\n        </div>\n    </div>\n    <div class=\"row col-xs-12\" v-show=\"!ajaxing\" _v-25bd86b0=\"\">\n        <line-chart :height=\"300\" :options=\"options\" :chart-data=\"chartData\" _v-25bd86b0=\"\">\n        </line-chart>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-25bd86b0", module.exports)
  } else {
    hotAPI.update("_v-25bd86b0", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"../../../utilities/webadmin/chart/line.js":1563,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/defineProperty":65,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vuex":803}],1397:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _roomList = require('./room-list.vue');

var _roomList2 = _interopRequireDefault(_roomList);

var _roomModal = require('./room-modal.vue');

var _roomModal2 = _interopRequireDefault(_roomModal);

var _roomSettingModal = require('./room-setting-modal.vue');

var _roomSettingModal2 = _interopRequireDefault(_roomSettingModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//Page
_vue2.default.component('room-list', _roomList2.default);
_vue2.default.component('room-modal', _roomModal2.default);
_vue2.default.component('room-setting-modal', _roomSettingModal2.default);

},{"./room-list.vue":1398,"./room-modal.vue":1399,"./room-setting-modal.vue":1400,"vue":792}],1398:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n#room-list tbody tr td {\n    background-color: white;\n    border-bottom: solid 1px #ddd;\n}\n.top-border {\n    border-top: solid 1px silver;\n}\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            modal: {
                title: '',
                id: ''
            },
            view: {
                room_list: [],
                ajaxing: false
            }
        };
    },
    created: function created() {
        // this.getRoomList(this.branchId);
        // this.configureStates.branchId
    },
    watch: {
        branchId: function () {
            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(val, oldVal) {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (this.isBranch) {
                                    this.getRoomList(val);
                                }

                            case 1:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function branchId(_x, _x2) {
                return _ref.apply(this, arguments);
            }

            return branchId;
        }()
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId', 'isBranch']), (0, _vuex.mapState)('filters', ['selected_studio_id', 'selected_branch_id'])),
    methods: {
        getRoomList: function getRoomList(branchId) {
            var _this = this;

            this.view.ajaxing = true;
            this.$http.get('/adminapi/rooms?branch_id=' + branchId).then(function (response) {
                _this.view.room_list = response.body;
                _this.view.ajaxing = false;
            }, function (error) {
                _this.view.ajaxing = false;
            });
        },
        showModal: function showModal(item) {
            this.modal.title = item.name;
            this.modal.id = item.id;
            $('#gate-modal').modal('show');
        },
        showSettingModal: function showSettingModal(item) {
            this.modal.title = item.name;
            this.modal.id = item.id;
            $('#setting-modal').modal('show');
        },
        resetId: function resetId() {
            this.modal = {
                title: '',
                id: ''
            };
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div>\n    <div>\n        <v-select-studio-and-branch :studio_id=\"studioId\" :branch_id=\"branchId\" :branch-change-call-back=\"getRoomList\"></v-select-studio-and-branch>\n    </div>\n\n    <div class=\"table-div m-top-20\">\n            <v-spinner :ajaxing=\"view.ajaxing\"></v-spinner>\n            <table v-if=\"!view.ajaxing\" id=\"room-list\" class=\"table table-striped\">\n                <tbody>\n                <tr class=\"top-border\" v-for=\"item in view.room_list\">\n                    <td class=\"col-md-6\"><span class=\"pull-left\">{{ item.name }}</span></td>\n                    <td class=\"col-md-6\">\n                        <a class=\"btn btn-primary\" @click.prevent=\"showModal(item)\">閘門設定</a>\n                        <a class=\"btn btn-primary\" @click.prevent=\"showSettingModal(item)\">條碼設定</a>\n                    </td>\n                </tr>\n                </tbody>\n            </table>\n    </div>\n\n    <room-modal :title=\"modal.title\" :id=\"modal.id\"></room-modal>\n    <room-setting-modal :title=\"modal.title\" :id=\"modal.id\" @reset-id=\"resetId\"></room-setting-modal>\n\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n#room-list tbody tr td {\n    background-color: white;\n    border-bottom: solid 1px #ddd;\n}\n.top-border {\n    border-top: solid 1px silver;\n}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-3ef89d71", module.exports)
  } else {
    hotAPI.update("_v-3ef89d71", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1399:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n.gate-cell {\n    padding:5px 0px 5px 0px;\n}\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vuex = require('vuex');

exports.default = {
    props: ['id', 'title'],
    data: function data() {
        return {
            view: {
                gate_list: [],
                ajaxing: false
            },
            model: {
                id: null,
                name: '',
                admission_type: 0,
                branch_id: null
            }
        };
    },
    mounted: function mounted() {
        $.fn.bootstrapSwitch.defaults.onColor = 'info';
        $(this.$el).find('.admission_type').bootstrapSwitch({ onText: '出場', offText: '入場' }).on('switchChange.bootstrapSwitch', this.switchChange);
        $(this.$el).find('.admission_type').bootstrapSwitch('state', this.model.admission_type);
    },

    created: function created() {},
    watch: {
        '$props': {
            handler: function handler(val, oldVal) {
                if (val['id'] != '') {
                    this.getGateList();
                }
            },
            deep: true
        }
    },
    computed: {},
    methods: {
        getGateList: function getGateList() {
            var _this = this;

            this.view.ajaxing = true;
            this.$http.get('/adminapi/rooms/' + this.id).then(function (response) {
                _this.view.gate_list = response.body.roomGates;
                // this.model.id = response.body.id;
                // this.model.name = response.body.name;
                _this.model.branch_id = response.body.branch_id;
                _this.view.ajaxing = false;
                // console.log(this.view.room_list);
            }, function (error) {
                _this.view.ajaxing = false;
            });
        },
        createGate: function createGate() {
            var _this2 = this;

            this.view.ajaxing = true;
            this.$http.post('/adminapi/room_gates', {
                room_id: this.id,
                name: this.model.name,
                admission_type: this.model.admission_type
            }).then(function (response) {
                var gate = { id: response.body.id, name: response.body.name };
                //this.view.gate_list.push(gate);
                _this2.model.name = '';
                _this2.model.admission_type = 0;
                _this2.getGateList();
                _this2.view.ajaxing = false;
            }, function (error) {
                _this2.view.ajaxing = false;
            });
        },
        deleteGate: function deleteGate(id) {
            var _this3 = this;

            this.view.ajaxing = true;
            this.$http.delete('/adminapi/room_gates/' + id).then(function (response) {
                var index = _this3.view.gate_list.findIndex(function (gate) {
                    return gate.id === id;
                });
                if (index > -1) {
                    _this3.view.gate_list.splice(index, 1);
                }
                _this3.view.ajaxing = false;
            }, function (error) {
                _this3.view.ajaxing = false;
            });
        },
        downloadQRcode: function downloadQRcode(gateID, event) {
            //event.target.href = '#';
            var canvas = document.getElementById('qr' + gateID);
            event.target.href = canvas.toDataURL();
        },
        switchChange: function switchChange(event, state) {
            this.model.admission_type = Number(state);
        },
        gateName: function gateName(gate) {
            var type = gate.admission_type === 0 ? '入場' : '出場';
            return gate.name + '(' + type + ')';
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div>\n    <div id=\"gate-modal\" class=\"modal fade\" role=\"dialog\">\n        <div class=\"modal-dialog\">\n            <div class=\"modal-content\">\n                <div class=\"modal-header\">\n                    <button type=\"button\" class=\"close\" data-dismiss=\"modal\">×</button>\n                    <h4 class=\"modal-title\">{{ title }}</h4>\n                </div>\n\n                <div class=\"modal-body\">\n                    <div class=\"clearfix\">\n                        <div class=\"col-lg-2 col-md-2 col-xs-2 p-top-5\">閘門設定</div>\n                        <div class=\"group-input col-lg-10 col-md-10 col-xs-10\">\n                            <div>\n                                <div>\n                                    <v-spinner :ajaxing=\"view.ajaxing\"></v-spinner>\n                                    <div v-for=\"gate in view.gate_list\" :key=\"gate.id\" class=\"clearfix gate-cell\">\n                                        <div class=\"pull-left\">\n                                            <div>{{ gateName(gate) }}</div>\n                                            <div>閘門編號:{{ gate.id }}</div>\n                                        </div>\n                                        <div class=\"pull-right\">\n                                            <v-qrcode :id=\"'qr' + gate.id\" :options=\"{ width: 200 }\" :value=\"gate.qrcode\"></v-qrcode>\n                                            <div class=\"clearfix\">\n                                                <button @click=\"deleteGate(gate.id)\" class=\"btn btn-danger pull-right\" v-if=\"!gate.is_default\" type=\"button\">刪除</button>\n                                                <a href=\"#\" download=\"dl.png\" @click=\"downloadQRcode(gate.id, $event)\" class=\"btn btn-primary pull-left m-right-5\">下載QRcode設定檔</a>\n                                             </div>\n                                        </div>\n                                    </div>\n                                </div>\n                                <div class=\"clearfix m-top-10\">\n                                    <div class=\"clearfix\">\n                                        <input v-model=\"model.name\" class=\"col-lg-9 col-md-9 col-xs-12\" type=\"text\" maxlength=\"30\" placeholder=\"請輸入閘門名稱\">\n                                        <div class=\"col-md-3\">\n                                             <input type=\"checkbox\" v-model=\"model.admission_type\" id=\"admission_type\" class=\"admission_type\">\n                                        </div>\n                                    </div>\n                                    <button @click=\"createGate\" class=\"col-xs-12 btn btn-success m-top-15\" type=\"button\">新增</button>\n                                </div>\n\n                            </div>\n                        </div>\n                    </div>\n\n                </div>\n\n            </div>\n        </div>\n    </div>\n\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n.gate-cell {\n    padding:5px 0px 5px 0px;\n}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-6d05fcea", module.exports)
  } else {
    hotAPI.update("_v-6d05fcea", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1400:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\ninput[_v-b33b56a6] {\n  border-radius: 4px;\n  margin-top: 5px; }\n\n/* line 7, stdin */\n.confirm[_v-b33b56a6] {\n  margin-top: 1em; }\n\n/* line 10, stdin */\n.code-setting[_v-b33b56a6] {\n  display: table; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vuex = require('vuex');

exports.default = {
    props: ['id', 'title'],
    data: function data() {
        return {
            view: {
                gate_list: [],
                ajaxing: false
            },
            booking: {
                active: 0,
                room_code_setting_id: '',
                limit_admission: 0,
                limit_admission_before: '',
                limit_admission_after: '',
                limit_appearance: 0,
                limit_appearance_before: '',
                limit_appearance_after: '',
                action_auto_attend: 0,
                limit_enter_once: 0
            },
            ticket: {
                active: 0
            },
            member_contract: {
                active: 0
            }
        };
    },

    watch: {
        'id': {
            handler: function handler(val, oldVal) {
                if (val != '') {
                    this.getSetting();
                }
            },
            deep: true
        }
    },
    methods: {
        getSetting: function getSetting() {
            var _this = this;

            this.view.ajaxing = true;
            this.$http.get('/adminapi/room_settings/room/' + this.id).then(function (response) {

                _this.view.ajaxing = false;
                var data = response.data;
                _this.booking = data.booking;
                _this.ticket = data.ticket;
                _this.member_contract = data.member_contract;
            }, function (error) {
                _this.view.ajaxing = false;
                $17.swal({
                    title: '更新資料發生錯誤',
                    text: error.data.message,
                    type: 'error',
                    showCancelButton: false
                });
            });
        },
        updateSetting: function updateSetting() {
            var _this2 = this;

            this.view.ajaxing = true;
            this.$http.post('/adminapi/room_settings/room/' + this.id, {
                booking: this.booking,
                ticket: this.ticket,
                member_contract: this.member_contract
            }).then(function (response) {
                _this2.view.ajaxing = false;
                _this2.reset();
                $('#setting-modal').modal('hide');
            }, function (error) {
                _this2.view.ajaxing = false;
                $17.swal({
                    title: '更新資料發生錯誤',
                    text: error.data.message,
                    type: 'error',
                    showCancelButton: false
                });
            });
        },
        closeModalEvent: function closeModalEvent() {
            this.reset();
        },
        reset: function reset() {
            this.booking = {
                active: 0,
                room_code_setting_id: '',
                limit_admission: 0,
                limit_admission_before: '',
                limit_admission_after: '',
                limit_appearance: 0,
                limit_appearance_before: '',
                limit_appearance_after: '',
                limit_enter_once: 0
            };
            this.ticket = {
                active: 0
            };
            this.member_contract = {
                active: 0
            };
            this.$emit('reset-id');
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal id=\"setting-modal\" :remove-btn-show=\"false\" no-footer=\"\" :close-modal-event=\"closeModalEvent\" _v-b33b56a6=\"\">\n    <span slot=\"title\" _v-b33b56a6=\"\">條碼設定</span>\n    <template slot=\"body\">\n        <v-spinner :ajaxing=\"view.ajaxing\" _v-b33b56a6=\"\"></v-spinner>\n        <div class=\"clearfix\" v-show=\"!view.ajaxing\" _v-b33b56a6=\"\">\n            <div class=\"booking code-setting\" _v-b33b56a6=\"\">\n                <div class=\"col-xs-12\" _v-b33b56a6=\"\">\n                    <input type=\"checkbox\" :true-value=\"1\" :false-value=\"0\" name=\"\" id=\"allow-booking\" v-model=\"booking.active\" _v-b33b56a6=\"\">\n                    <label for=\"allow-booking\" _v-b33b56a6=\"\">允許:預約條碼</label>\n                </div>\n                <div class=\"col-xs-12 m-left-50\" _v-b33b56a6=\"\">\n                    <input type=\"checkbox\" :true-value=\"1\" :false-value=\"0\" name=\"\" id=\"booking-limit-in-time\" v-model=\"booking.limit_admission\" _v-b33b56a6=\"\">\n                    <label for=\"booking-limit-in-time\" _v-b33b56a6=\"\">限制入場時間</label>\n                </div>\n                <div class=\"col-xs-12 m-left-100 m-bottom-10\" _v-b33b56a6=\"\">\n                    <label for=\"booking-in-time-start\" _v-b33b56a6=\"\">在開始前</label>\n                    <input type=\"number\" name=\"\" id=\"booking-in-time-start\" v-model=\"booking.limit_admission_before\" number=\"\" min=\"1\" max=\"999\" _v-b33b56a6=\"\">\n                    <label for=\"booking-in-time-start\" _v-b33b56a6=\"\">分鐘</label>\n                </div>\n                <div class=\"col-xs-12 m-left-100 m-bottom-10\" _v-b33b56a6=\"\">\n                    <label for=\"booking-in-time-after\" _v-b33b56a6=\"\">至開始後</label>\n                    <input type=\"number\" name=\"\" id=\"booking-in-time-after\" v-model=\"booking.limit_admission_after\" number=\"\" min=\"1\" max=\"999\" _v-b33b56a6=\"\">\n                    <label for=\"booking-in-time-after\" _v-b33b56a6=\"\">分鐘</label>\n                </div>\n                <div class=\"col-xs-12 m-left-50\" _v-b33b56a6=\"\">\n                    <input type=\"checkbox\" :true-value=\"1\" :false-value=\"0\" name=\"\" id=\"booking-auto-attend\" v-model=\"booking.action_auto_attend\" _v-b33b56a6=\"\">\n                    <label for=\"booking-auto-attend\" _v-b33b56a6=\"\">入場時，自動標記為出席</label>\n                </div>\n                <div class=\"col-xs-12 m-left-50 m-top-10\" _v-b33b56a6=\"\">\n                    <input type=\"radio\" :value=\"1\" name=\"limit_enter_once\" id=\"limit-enter-once\" v-model=\"booking.limit_enter_once\" _v-b33b56a6=\"\">\n                    <label for=\"limit-enter-once\" _v-b33b56a6=\"\">只允許入場一次</label>\n                </div>\n                <div class=\"col-xs-12 m-left-50\" _v-b33b56a6=\"\">\n                    <input type=\"radio\" :value=\"0\" name=\"limit_enter_once\" id=\"no-limit-enter-once\" v-model=\"booking.limit_enter_once\" _v-b33b56a6=\"\">\n                    <label for=\"no-limit-enter-once\" _v-b33b56a6=\"\">允許重複出入場</label>\n                </div>\n                <div class=\"col-xs-12 m-left-50 m-top-30\" _v-b33b56a6=\"\">\n                    <input type=\"checkbox\" :true-value=\"1\" :false-value=\"0\" name=\"\" id=\"booking-limit-out-time\" v-model=\"booking.limit_appearance\" _v-b33b56a6=\"\">\n                    <label for=\"booking-limit-out-time\" _v-b33b56a6=\"\">限制出場時間</label>\n                </div>\n                <div class=\"col-xs-12 m-left-100 m-bottom-10\" _v-b33b56a6=\"\">\n                    <label for=\"booking-out-time-start\" _v-b33b56a6=\"\">在結束前</label>\n                    <input type=\"number\" name=\"\" id=\"booking-out-time-start\" v-model=\"booking.limit_appearance_before\" number=\"\" min=\"1\" max=\"999\" _v-b33b56a6=\"\">\n                    <label for=\"booking-out-time-start\" _v-b33b56a6=\"\">分鐘</label>\n                </div>\n                <div class=\"col-xs-12 m-left-100 m-bottom-10\" _v-b33b56a6=\"\">\n                    <label for=\"booking-out-time-after\" _v-b33b56a6=\"\">至結束後</label>\n                    <input type=\"number\" name=\"\" id=\"booking-out-time-after\" v-model=\"booking.limit_appearance_after\" number=\"\" min=\"1\" max=\"999\" _v-b33b56a6=\"\">\n                    <label for=\"booking-out-time-after\" _v-b33b56a6=\"\">分鐘</label>\n                </div>\n            </div>\n            <hr _v-b33b56a6=\"\">\n            <div class=\"ticket code-setting\" _v-b33b56a6=\"\">\n                <div class=\"col-xs-12\" _v-b33b56a6=\"\">\n                    <input type=\"checkbox\" :true-value=\"1\" :false-value=\"0\" name=\"\" id=\"allow-ticket\" v-model=\"ticket.active\" _v-b33b56a6=\"\">\n                    <label for=\"allow-ticket\" _v-b33b56a6=\"\">允許:票券條碼</label>\n                </div>\n            </div>\n            <hr _v-b33b56a6=\"\">\n            <div class=\"member_contract code-setting\" _v-b33b56a6=\"\">\n                <div class=\"col-xs-12\" _v-b33b56a6=\"\">\n                    <input type=\"checkbox\" :true-value=\"1\" :false-value=\"0\" name=\"\" id=\"allow-contract\" v-model=\"member_contract.active\" _v-b33b56a6=\"\">\n                    <label for=\"allow-contract\" _v-b33b56a6=\"\">允許:方案條碼</label>\n                </div>\n            </div>\n            <div class=\"col-xs-12 confirm text-right\" _v-b33b56a6=\"\">\n                <input type=\"button\" value=\"確認\" class=\"btn btn-primary\" @click=\"updateSetting\" _v-b33b56a6=\"\">\n            </div>\n        </div>\n    </template>\n</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\ninput[_v-b33b56a6] {\n  border-radius: 4px;\n  margin-top: 5px; }\n\n/* line 7, stdin */\n.confirm[_v-b33b56a6] {\n  margin-top: 1em; }\n\n/* line 10, stdin */\n.code-setting[_v-b33b56a6] {\n  display: table; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-b33b56a6", module.exports)
  } else {
    hotAPI.update("_v-b33b56a6", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1401:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\nlabel[_v-5b4f8734] {\n  margin-right: 5px; }\n\n/* line 5, stdin */\n.tabs[_v-5b4f8734] {\n  margin-top: 15px; }\n\n/* line 8, stdin */\n.row[_v-5b4f8734] {\n  margin: 20px -15px; }\n\n/* line 12, stdin */\n.calculate-head[_v-5b4f8734] {\n  display: -ms-inline-flexbox;\n  display: inline-flex; }\n  /* line 14, stdin */\n  .calculate-head div[_v-5b4f8734] {\n    margin-left: 5px;\n    margin-right: 5px; }\n  /* line 19, stdin */\n  .calculate-head .form-control[_v-5b4f8734] {\n    height: 40px; }\n\n/* line 23, stdin */\n.current-job[_v-5b4f8734] {\n  margin-top: 30px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {

    data: function data() {
        return {
            data: {
                startDate: null,
                endDate: null
            },
            view: {
                ajaxing: false,
                jobAjaxing: false,
                jobList: [],
                pageMeta: {}
            }
        };
    },
    watch: {
        activeStudioId: function activeStudioId(newVal) {
            if (newVal) {
                this.getJobList();
            }
        },
        activeBranchId: function activeBranchId(newVal) {
            if (newVal) {
                this.getJobList();
            }
        }
    },
    mounted: function mounted() {
        this.$nextTick(function () {
            var vm = this;
            $('.datepicker').datetimepicker({
                format: 'YYYY-MM-DD',
                locale: 'zh-tw',
                minDate: '2018-11-01',
                maxDate: moment(moment().subtract(1, 'days')).format('YYYY-MM-DD'),
                useCurrent: false
            }).on("dp.change", function (e) {
                var startDate = $(vm.$el).find('#startDate').val();
                var endDate = $(vm.$el).find('#endDate').val();

                vm.data.startDate = startDate;
                vm.data.endDate = endDate;
            });
            this.getJobList();
        });
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId', 'isBranch', 'isStudio', 'isSeventeen']), (0, _vuex.mapState)('filters', ['selected_studio_id', 'selected_branch_id']), {
        activeStudioId: function activeStudioId() {
            if (this.isSeventeen) {
                return this.selected_studio_id;
            }
            return this.studioId;
        },
        activeBranchId: function activeBranchId() {
            if (this.isSeventeen || this.isStudio) {
                return this.selected_branch_id;
            }
            return this.branchId;
        }
    }),
    methods: {
        appendJob: function appendJob() {
            var _this = this;

            this.view.ajaxing = true;
            this.$http.post('/adminapi/salary/calculate/studio/' + this.activeStudioId, {
                'c_end_date': this.data.endDate,
                'c_start_date': this.data.startDate,
                'studio_id': this.activeStudioId,
                'branch_ids': this.activeBranchId

            }).then(function (response) {
                _this.view.ajaxing = false;
                _this.getJobList();
                $17.swal({
                    title: '資料已更新',
                    text: '已設定計算計算結果將於明日05:00之後可於薪資報表查詢',
                    type: 'warning',
                    showCancelButton: false
                });
            }, function (error) {
                _this.view.ajaxing = false;
                $17.swal({
                    title: '更新資料發生錯誤',
                    text: error.data.message,
                    type: 'error',
                    showCancelButton: false
                });
            });
        },
        getJobList: function getJobList() {
            var _this2 = this;

            var page = this.getUrlParamValue('page') ? this.getUrlParamValue('page') : 1;
            this.view.jobAjaxing = true;
            this.$http.get('/adminapi/salary/calculate/queue?studio_id=' + this.activeStudioId + '&page=' + page + '&branch_id=' + this.activeBranchId).then(function (response) {
                _this2.view.jobList = response.body.list;
                _this2.view.pageMeta = response.body.pageMeta;
                _this2.view.jobAjaxing = false;
            }, function (error) {
                $17.swal({
                    title: '讀取資料發生錯誤',
                    text: error.data.message,
                    type: 'error',
                    showCancelButton: false
                });
                _this2.view.jobAjaxing = false;
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"container\" _v-5b4f8734=\"\">\n    <v-spinner :ajaxing=\"view.ajaxing\" _v-5b4f8734=\"\"></v-spinner>\n    <div class=\"calculate-head\" v-show=\"!view.ajaxing\" _v-5b4f8734=\"\">\n        <v-select-studio-and-branch :studio_id=\"studioId\" :branch_id=\"branchId\" :branch-without-filtered-option=\"true\" _v-5b4f8734=\"\">\n        </v-select-studio-and-branch>\n        \n        <div class=\"date-range\" _v-5b4f8734=\"\">\n            <input type=\"text\" id=\"startDate\" class=\"form-control datepicker\" :value=\"data.start_date\" placeholder=\"開始日期\" _v-5b4f8734=\"\">\n        </div>\n        <div class=\"date-range\" _v-5b4f8734=\"\">\n            <input type=\"text\" id=\"endDate\" class=\"form-control datepicker\" :value=\"data.end_date\" placeholder=\"結束日期\" _v-5b4f8734=\"\">\n        </div>\n         <div _v-5b4f8734=\"\">\n            <input type=\"button\" value=\"計算\" class=\"btn btn-primary form-control\" @click=\"appendJob\" _v-5b4f8734=\"\">\n         </div>\n    </div>\n    <div class=\"current-job\" v-show=\"!view.ajaxing\" _v-5b4f8734=\"\">\n        <v-table :ajaxing=\"view.jobAjaxing\" :length=\"view.jobList\" _v-5b4f8734=\"\">\n            <table class=\"table sortable\" _v-5b4f8734=\"\">\n                <thead _v-5b4f8734=\"\">\n                    <tr _v-5b4f8734=\"\">\n                        <th _v-5b4f8734=\"\">場館</th>\n                        <th _v-5b4f8734=\"\">薪資計算區間</th>\n                        <th _v-5b4f8734=\"\">執行時間</th>\n                        <th _v-5b4f8734=\"\">狀態</th>\n                    </tr>\n                </thead>\n                <tbody _v-5b4f8734=\"\">\n                    <tr v-for=\"l in view.jobList\" :key=\"l.id\" _v-5b4f8734=\"\">\n                        <td _v-5b4f8734=\"\">{{ l.branch_name }}</td>\n                        <td _v-5b4f8734=\"\">{{ l.duration }}</td>\n                        <td _v-5b4f8734=\"\">{{ l.calculat_time }}</td>\n                        <td _v-5b4f8734=\"\">{{ l.status }}</td>\n                    </tr>\n                </tbody>\n            </table>\n        </v-table>\n        <v-sql-pagination v-show=\"!view.jobAjaxing\" ref=\"pager\" :page-meta=\"view.pageMeta\" @page-change-callback=\"getJobList\" _v-5b4f8734=\"\">\n        </v-sql-pagination>\n    </div>\n</div>    \n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\nlabel[_v-5b4f8734] {\n  margin-right: 5px; }\n\n/* line 5, stdin */\n.tabs[_v-5b4f8734] {\n  margin-top: 15px; }\n\n/* line 8, stdin */\n.row[_v-5b4f8734] {\n  margin: 20px -15px; }\n\n/* line 12, stdin */\n.calculate-head[_v-5b4f8734] {\n  display: -ms-inline-flexbox;\n  display: inline-flex; }\n  /* line 14, stdin */\n  .calculate-head div[_v-5b4f8734] {\n    margin-left: 5px;\n    margin-right: 5px; }\n  /* line 19, stdin */\n  .calculate-head .form-control[_v-5b4f8734] {\n    height: 40px; }\n\n/* line 23, stdin */\n.current-job[_v-5b4f8734] {\n  margin-top: 30px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-5b4f8734", module.exports)
  } else {
    hotAPI.update("_v-5b4f8734", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1402:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\nlabel[_v-49da9d40] {\n  margin-right: 5px; }\n\n/* line 5, stdin */\n.tabs[_v-49da9d40] {\n  margin-top: 15px; }\n\n/* line 8, stdin */\n.row[_v-49da9d40] {\n  margin: 20px -15px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            tabs: [{
                'name': '排程計算',
                'type': 'webadmin-salary-calculate-job',
                'event': this.changeTab
            }, {
                'name': '即時計算',
                'type': 'webadmin-salary-calculate-member',
                'event': this.changeTab
            }, {
                'name': '歷史紀錄',
                'type': 'webadmin-salary-calculate-record',
                'event': this.changeTab
            }],
            view: {
                ajaxing: false
            },
            activeTab: 'webadmin-salary-calculate-job'
        };
    },
    watch: {},
    created: function created() {},
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId', 'isBranch', 'isStudio', 'isSeventeen']), (0, _vuex.mapState)('filters', ['selected_studio_id', 'selected_branch_id']), {
        activeStudioId: function activeStudioId() {
            if (this.isSeventeen) {
                return this.selected_studio_id;
            }
            return this.studioId;
        },
        activeBranchId: function activeBranchId() {
            if (this.isSeventeen || this.isStudio) {
                return this.selected_branch_id;
            }
            return this.branchId;
        }
    }),
    methods: {
        changeTab: function changeTab(tab) {
            this.activeTab = tab.type;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"container\" _v-49da9d40=\"\">\n    <v-spinner :ajaxing=\"view.ajaxing\" _v-49da9d40=\"\"></v-spinner>\n    <div v-show=\"!view.ajaxing\" _v-49da9d40=\"\">\n         <div class=\"row\" _v-49da9d40=\"\">\n            <div class=\"col-xs-12\" _v-49da9d40=\"\">\n                <v-simple-tabs :tabs=\"tabs\" _v-49da9d40=\"\"></v-simple-tabs>\n            </div>\n        </div>\n        <component v-bind:is=\"activeTab\" _v-49da9d40=\"\"></component>\n    </div>\n</div>    \n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\nlabel[_v-49da9d40] {\n  margin-right: 5px; }\n\n/* line 5, stdin */\n.tabs[_v-49da9d40] {\n  margin-top: 15px; }\n\n/* line 8, stdin */\n.row[_v-49da9d40] {\n  margin: 20px -15px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-49da9d40", module.exports)
  } else {
    hotAPI.update("_v-49da9d40", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1403:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\nlabel[_v-3479b601] {\n  margin-right: 5px; }\n\n/* line 5, stdin */\n.tabs[_v-3479b601] {\n  margin-top: 15px; }\n\n/* line 8, stdin */\n.row[_v-3479b601] {\n  margin: 20px -15px; }\n\n/* line 11, stdin */\n.calculate-head[_v-3479b601] {\n  display: -ms-inline-flexbox;\n  display: inline-flex; }\n  /* line 13, stdin */\n  .calculate-head div[_v-3479b601] {\n    margin-left: 5px;\n    margin-right: 5px; }\n  /* line 18, stdin */\n  .calculate-head .form-control[_v-3479b601] {\n    height: 40px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {

    data: function data() {
        return {
            data: {
                start_date: null,
                end_date: null,
                trainerId: null
            },
            view: {
                ajaxing: false
            }
        };
    },
    watch: {
        activeStudioId: function activeStudioId(newVal) {},
        selected_branch_id: function selected_branch_id() {
            $('#ssab_branch_id').trigger('change');
        }
    },
    mounted: function mounted() {
        this.$nextTick(function () {
            var vm = this;
            $('.datepicker').datetimepicker({
                format: 'YYYY-MM-DD',
                locale: 'zh-tw',
                minDate: '2018-11-01',
                maxDate: moment(moment().subtract(1, 'days')).format('YYYY-MM-DD'),
                useCurrent: false
            }).on("dp.change", function (e) {
                var start_date = $(vm.$el).find('#start_date').val();
                var end_date = $(vm.$el).find('#end_date').val();

                vm.data.start_date = start_date;
                vm.data.end_date = end_date;
            });
        });
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId', 'isBranch', 'isStudio', 'isSeventeen']), (0, _vuex.mapState)('filters', ['selected_studio_id', 'selected_branch_id']), {
        activeStudioId: function activeStudioId() {
            if (this.isSeventeen) {
                return this.selected_studio_id;
            }
            return this.studioId;
        },
        activeBranchId: function activeBranchId() {
            if (this.isSeventeen || this.isStudio) {
                return this.selected_branch_id;
            }
            return this.branchId;
        }
    }),
    methods: {
        setTrainer: function setTrainer(trainerObj) {
            this.data.trainerId = trainerObj.id;
        },
        calculate: function calculate() {
            var _this = this;

            this.view.ajaxing = true;

            if (!this.checkProps()) {
                this.view.ajaxing = false;
                return;
            }
            this.$http.post('/adminapi/salary/calculate/branch/' + this.activeBranchId + '/member/' + this.data.trainerId, this.data).then(function (response) {
                _this.view.ajaxing = false;
                $17.swal({
                    title: '已重新計算',
                    text: '計算結果可於薪資報表查詢',
                    type: 'warning',
                    showCancelButton: false
                });
            }, function (error) {
                _this.view.ajaxing = false;
                $17.swal({
                    title: '計算發生錯誤',
                    text: error.data.message,
                    type: 'error',
                    showCancelButton: false
                });
            });
        },
        checkProps: function checkProps() {
            if (!this.activeBranchId) {
                $17.swal({
                    title: '請選擇一個場館',
                    type: 'error',
                    showCancelButton: false
                });
                return false;
            }

            if (!this.data.trainerId) {
                $17.swal({
                    title: '請選擇一個服務提供者',
                    type: 'error',
                    showCancelButton: false
                });
                return false;
            }
            if (!this.data.start_date || !this.data.end_date) {
                $17.swal({
                    title: '請輸入計算日期',
                    type: 'error',
                    showCancelButton: false
                });
                return false;
            }

            if (moment(this.data.end_date).diff(moment(this.data.start_date), 'days') > 31) {
                $17.swal({
                    title: '計算區間不可大於31日',
                    type: 'error',
                    showCancelButton: false
                });
                return false;
            }

            return true;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"container\" _v-3479b601=\"\">\n    <v-spinner :ajaxing=\"view.ajaxing\" _v-3479b601=\"\"></v-spinner>\n    <div class=\"calculate-head\" v-show=\"!view.ajaxing\" _v-3479b601=\"\">\n        <v-select-studio-and-branch :studio_id=\"studioId\" :branch_id=\"branchId\" :branch-without-filtered-option=\"false\" _v-3479b601=\"\">\n        </v-select-studio-and-branch>\n        <div _v-3479b601=\"\"> \n            <v-trainer-selector :studio-id=\"activeStudioId\" :branch-id=\"activeBranchId\" :force-fetch=\"1\" @trainer-select=\"setTrainer\" min-width=\"200px\" _v-3479b601=\"\"></v-trainer-selector>\n        </div>\n        <div class=\"date-range\" _v-3479b601=\"\">\n            <input type=\"text\" id=\"start_date\" class=\"form-control datepicker\" :value=\"data.start_date\" placeholder=\"開始日期\" _v-3479b601=\"\">\n        </div>\n        <div class=\"date-range\" _v-3479b601=\"\">\n            <input type=\"text\" id=\"end_date\" class=\"form-control datepicker\" :value=\"data.end_date\" placeholder=\"結束日期\" _v-3479b601=\"\">\n        </div>\n         <div _v-3479b601=\"\">\n            <input type=\"button\" value=\"計算\" class=\"btn btn-primary form-control\" @click=\"calculate\" _v-3479b601=\"\">\n         </div>\n    </div>\n</div>    \n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\nlabel[_v-3479b601] {\n  margin-right: 5px; }\n\n/* line 5, stdin */\n.tabs[_v-3479b601] {\n  margin-top: 15px; }\n\n/* line 8, stdin */\n.row[_v-3479b601] {\n  margin: 20px -15px; }\n\n/* line 11, stdin */\n.calculate-head[_v-3479b601] {\n  display: -ms-inline-flexbox;\n  display: inline-flex; }\n  /* line 13, stdin */\n  .calculate-head div[_v-3479b601] {\n    margin-left: 5px;\n    margin-right: 5px; }\n  /* line 18, stdin */\n  .calculate-head .form-control[_v-3479b601] {\n    height: 40px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-3479b601", module.exports)
  } else {
    hotAPI.update("_v-3479b601", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1404:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\nlabel[_v-9f903790] {\n  margin-right: 5px; }\n\n/* line 5, stdin */\n.tabs[_v-9f903790] {\n  margin-top: 15px; }\n\n/* line 8, stdin */\n.row[_v-9f903790] {\n  margin: 20px -15px; }\n\n/* line 12, stdin */\n.calculate-head[_v-9f903790] {\n  display: -ms-inline-flexbox;\n  display: inline-flex; }\n  /* line 14, stdin */\n  .calculate-head div[_v-9f903790] {\n    margin-left: 5px;\n    margin-right: 5px; }\n  /* line 19, stdin */\n  .calculate-head .form-control[_v-9f903790] {\n    height: 40px; }\n\n/* line 23, stdin */\n.current-job[_v-9f903790] {\n  margin-top: 30px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {

    data: function data() {
        return {
            view: {
                ajaxing: false,
                jobAjaxing: false,
                jobList: [],
                pageMeta: {}
            }
        };
    },
    watch: {
        activeBranchId: function activeBranchId(newVal) {
            if (newVal) {
                this.getRecordList();
            }
        }
    },
    mounted: function mounted() {
        this.$nextTick(function () {
            if (this.activeStudioId) {
                this.getRecordList();
            }
        });
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId', 'isBranch', 'isStudio', 'isSeventeen']), (0, _vuex.mapState)('filters', ['selected_studio_id', 'selected_branch_id']), {
        activeStudioId: function activeStudioId() {
            if (this.isSeventeen) {
                return this.selected_studio_id;
            }
            return this.studioId;
        },
        activeBranchId: function activeBranchId() {
            if (this.isSeventeen || this.isStudio) {
                return this.selected_branch_id;
            }
            return this.branchId;
        }
    }),
    methods: {
        getRecordList: function getRecordList() {
            var _this = this;

            var page = this.getUrlParamValue('page') ? this.getUrlParamValue('page') : 1;
            this.view.jobAjaxing = true;
            this.$http.get('/adminapi/salary/calculate/record?studio_id=' + this.activeStudioId + '&branch_id=' + this.activeBranchId + '&page=' + page).then(function (response) {
                _this.view.jobList = response.body.list;
                _this.view.pageMeta = response.body.pageMeta;
                _this.view.jobAjaxing = false;
            }, function (error) {
                $17.swal({
                    title: '讀取資料發生錯誤',
                    text: error.data.message,
                    type: 'error',
                    showCancelButton: false
                });
                _this.view.jobAjaxing = false;
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"container\" _v-9f903790=\"\">\n    <v-spinner :ajaxing=\"view.ajaxing\" _v-9f903790=\"\"></v-spinner>\n    <div class=\"calculate-head\" v-show=\"!view.ajaxing\" _v-9f903790=\"\">\n        <v-select-studio-and-branch :studio_id=\"studioId\" :branch_id=\"branchId\" :branch-without-filtered-option=\"true\" _v-9f903790=\"\">\n        </v-select-studio-and-branch>\n    </div>\n    <div class=\"current-job\" v-show=\"!view.ajaxing\" _v-9f903790=\"\">\n        <v-table :ajaxing=\"view.jobAjaxing\" :length=\"view.jobList\" _v-9f903790=\"\">\n            <table class=\"table sortable\" _v-9f903790=\"\">\n                <thead _v-9f903790=\"\">\n                    <tr _v-9f903790=\"\">\n                        <th _v-9f903790=\"\">場館</th>\n                        <th _v-9f903790=\"\">薪資計算區間</th>\n                        <th _v-9f903790=\"\">服務提供者</th>\n                        <th _v-9f903790=\"\">操作人員</th>\n                        <th _v-9f903790=\"\">執行時間</th>\n                    </tr>\n                </thead>\n                <tbody _v-9f903790=\"\">\n                    <tr v-for=\"l in view.jobList\" :key=\"l.id\" _v-9f903790=\"\">\n                        <td _v-9f903790=\"\">{{ l.branch_name}}</td>\n                        <td _v-9f903790=\"\">{{ l.duration}}</td>\n                        <td _v-9f903790=\"\">{{ l.staff_name}}</td>\n                        <td _v-9f903790=\"\">{{ l.member_name}}</td>\n                        <td _v-9f903790=\"\">{{ l.calculate_time}}</td>\n                    </tr>\n                </tbody>\n            </table>\n        </v-table>\n        <v-sql-pagination v-show=\"!view.jobAjaxing\" ref=\"pager\" :page-meta=\"view.pageMeta\" @page-change-callback=\"getRecordList\" _v-9f903790=\"\">\n        </v-sql-pagination>\n    </div>\n</div>    \n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\nlabel[_v-9f903790] {\n  margin-right: 5px; }\n\n/* line 5, stdin */\n.tabs[_v-9f903790] {\n  margin-top: 15px; }\n\n/* line 8, stdin */\n.row[_v-9f903790] {\n  margin: 20px -15px; }\n\n/* line 12, stdin */\n.calculate-head[_v-9f903790] {\n  display: -ms-inline-flexbox;\n  display: inline-flex; }\n  /* line 14, stdin */\n  .calculate-head div[_v-9f903790] {\n    margin-left: 5px;\n    margin-right: 5px; }\n  /* line 19, stdin */\n  .calculate-head .form-control[_v-9f903790] {\n    height: 40px; }\n\n/* line 23, stdin */\n.current-job[_v-9f903790] {\n  margin-top: 30px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-9f903790", module.exports)
  } else {
    hotAPI.update("_v-9f903790", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1405:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.base-data[_v-5ac92ff0] {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-align: baseline;\n      align-items: baseline; }\n  /* line 5, stdin */\n  .base-data h4[_v-5ac92ff0] {\n    margin-right: 20px;\n    font-size: 24px; }\n\n/* line 10, stdin */\n.tab-list[_v-5ac92ff0] {\n  margin-top: 15px; }\n\n/* line 13, stdin */\n.form-group > *[_v-5ac92ff0] {\n  margin-right: 5px; }\n\n/* line 16, stdin */\n.copy-template[_v-5ac92ff0] {\n  min-width: 150px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            tabs: [{
                'name': '課程薪資條件設定',
                'type': 'webadmin-salary-template-class',
                'event': this.changeTab
            }, {
                'name': '服務薪資條件設定',
                'type': 'webadmin-salary-service',
                'event': this.changeTab
            }],
            view: {
                ajaxing: false,
                ajaxingMember: false
            },
            activeTab: 'webadmin-salary-template-class',
            defaultRows: {
                'classes': [],
                'services': []
            },
            cache: {
                'classes': {},
                'services': {
                    serviceCategory: []
                }
            },
            memberId: null,
            groupId: null,
            member: {
                name: null
            },
            templates: [],
            copyId: null,
            isCopyFromTemplate: false
        };
    },
    watch: {
        activeBranchId: function activeBranchId(newVal) {
            this.resetDefaultRows();
            this.fetchData(this.memberId, newVal);
            this.getTemplate(newVal);
            this.resetCache();
        },
        memberId: function memberId(newVal) {
            this.fetchData(newVal, this.activeBranchId);
            this.getMember(newVal);
        }
    },
    mounted: function mounted() {
        this.getMemberId();
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId', 'isBranch', 'isStudio', 'isSeventeen']), (0, _vuex.mapState)('filters', ['selected_studio_id', 'selected_branch_id', 'selected_branch_id']), {
        activeStudioId: function activeStudioId() {
            if (this.isSeventeen) {
                return this.selected_studio_id;
            }
            return this.studioId;
        },
        activeBranchId: function activeBranchId() {
            if (this.isSeventeen || this.isStudio) {
                return this.selected_branch_id;
            }
            return this.branchId;
        }
    }),
    methods: {
        changeTab: function changeTab(tab) {
            this.activeTab = tab.type;
        },
        fetchData: function fetchData(memberId, branchId) {
            var _this = this;

            if (!memberId || !branchId) {
                return;
            }
            this.view.ajaxing = true;
            this.$http.get('/adminapi/salary/employee/member/' + memberId + '/branch/' + branchId).then(function (response) {
                _this.defaultRows = response.body.settings;
                _this.groupId = response.body.head.id;
                _this.view.ajaxing = false;
            }, function (error) {
                $17.swal({
                    title: '薪資設定資料載入失敗',
                    type: 'error',
                    showCancelButton: false
                });
                _this.view.ajaxing = false;
            });
        },
        updtaeCurrentTab: function updtaeCurrentTab(data) {
            var _this2 = this;

            var category = data.category;
            var value = data.value;
            this.view.ajaxing = true;
            this.$http.post('/adminapi/salary/employee/action', {
                'change_category': category,
                'head': {
                    studio_id: this.activeStudioId,
                    branch_id: this.activeBranchId,
                    name: this.templateName,
                    member_id: this.memberId
                },
                'settings': value

            }).then(function (response) {
                _this2.view.ajaxing = false;
                $17.swal({
                    title: '資料已更新',
                    type: 'success',
                    showCancelButton: false
                });

                _this2.defaultRows[category] = response.body.settings[category];
            }, function (error) {
                _this2.view.ajaxing = false;
                $17.swal({
                    title: '資料更新失敗',
                    text: error.data.message,
                    type: 'error',
                    showCancelButton: false
                });
            });
        },
        cancleEdit: function cancleEdit() {
            this.backToStaffList();
            this.defaultRows = {
                'classes': [],
                'services': []
            };
        },
        getMemberId: function getMemberId() {
            var urlParams = new URLSearchParams(window.location.search);
            this.memberId = urlParams.get('member_id');
            if (!this.memberId) {
                this.backToStaffList();
            }
        },
        getMember: function getMember(memberId) {
            var _this3 = this;

            this.view.ajaxingMember = true;
            this.$http.get('/adminapi/member/' + memberId).then(function (response) {
                _this3.member = response.body.member;
                _this3.view.ajaxingMember = false;
            }, function (error) {
                $17.swal({
                    title: '無此人員設定資料載入失敗',
                    type: 'error',
                    showCancelButton: false
                });
                _this3.view.ajaxingMember = false;
            });
        },
        getTemplate: function getTemplate(branchId) {
            var _this4 = this;

            if (!branchId) {
                return;
            }
            this.view.ajaxing = true;
            this.$http.get('/adminapi/salary/template/branch/' + branchId).then(function (response) {
                _this4.templates = response.body;
                _this4.view.ajaxing = false;
            }, function (error) {
                $17.swal({
                    title: '讀取樣板列表發生錯誤',
                    type: 'error',
                    showCancelButton: false
                });
                _this4.view.ajaxing = false;
            });
        },
        fetchTemplateData: function fetchTemplateData() {
            var _this5 = this;

            if (!this.copyId) {
                return;
            }

            $17.swal({
                title: '薪資條件已變更!',
                text: '按下更新將保存目前設定的條件資料',
                type: 'warning',
                showCancelButton: false
            });

            this.view.ajaxing = true;
            this.$http.get('/adminapi/salary/template/' + this.copyId).then(function (response) {
                var settings = response.body.settings;
                (0, _keys2.default)(settings).map(function (category) {
                    settings[category].map(function (setting) {
                        setting['id'] = 0;
                        return setting;
                    });
                });

                _this5.defaultRows = settings;
                _this5.templateName = response.body.head.name;
                _this5.view.ajaxing = false;
                _this5.isCopyFromTemplate = true;
            }, function (error) {
                _this5.view.ajaxing = false;
            });
        },
        backToStaffList: function backToStaffList() {
            location.href = '/webadmin/staff';
        },
        updateCache: function updateCache(object) {
            var category = object.category;
            var key = object.key;
            var value = object.value;

            this['cache'][category][key] = value;
        },
        resetCache: function resetCache() {
            this.cache = {
                'classes': {},
                'services': {
                    serviceCategory: []
                }
            };
        },
        resetDefaultRows: function resetDefaultRows() {
            this.defaultRows = {
                'classes': [],
                'services': []
            };
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"container\" _v-5ac92ff0=\"\"> \n    <v-spinner :ajaxing=\"view.ajaxing\" _v-5ac92ff0=\"\"></v-spinner>\n    <div v-show=\"!view.ajaxing\" _v-5ac92ff0=\"\">\n        <div class=\"row \" v-show=\"!view.ajaxingMember\" _v-5ac92ff0=\"\">\n            <v-spinner :ajaxing=\"view.ajaxingMember\" _v-5ac92ff0=\"\"></v-spinner>\n            <div class=\"col-xs-12 base-data\" _v-5ac92ff0=\"\">\n                <h4 _v-5ac92ff0=\"\">{{ member.name }}</h4>\n                <v-select-studio-and-branch :studio_id=\"studioId\" :branch_id=\"branchId\" :branch-without-filtered-option=\"false\" _v-5ac92ff0=\"\">\n                </v-select-studio-and-branch>\n            </div>\n        </div> \n        <div class=\"row form-inline\" _v-5ac92ff0=\"\">\n            <div class=\"col-xs-12 form-group\" _v-5ac92ff0=\"\">\n                <span _v-5ac92ff0=\"\">從</span> \n                <select class=\"form-control copy-template\" v-model=\"copyId\" _v-5ac92ff0=\"\">\n                    <option :value=\"null\" disabled=\"\" _v-5ac92ff0=\"\">請選擇</option>\n                    <option :value=\"template.id\" v-for=\"template in templates\" _v-5ac92ff0=\"\">{{ template.name }}</option>\n                </select>\n                <input type=\"button\" value=\"複製範本\" class=\"btn btn-default m-left-1\" @click=\"fetchTemplateData\" _v-5ac92ff0=\"\">\n            </div>\n        </div> \n        <div class=\"row tab-list\" _v-5ac92ff0=\"\">\n            <div class=\"col-xs-12\" _v-5ac92ff0=\"\">\n                <v-simple-tabs :tabs=\"tabs\" :need-check=\"false\" title=\"確定切換?\" text=\"請先按下更新，否則未更新的變更都將不會儲存\" _v-5ac92ff0=\"\"></v-simple-tabs>\n            </div>\n        </div>\n        <component v-bind:is=\"activeTab\" :default-rows=\"defaultRows\" :group-id=\"groupId\" :cache=\"cache\" @update-current=\"updtaeCurrentTab\" @cancel-change=\"cancleEdit\" @update-cache=\"updateCache\" _v-5ac92ff0=\"\"></component>\n    </div>\n</div>    \n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.base-data[_v-5ac92ff0] {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-align: baseline;\n      align-items: baseline; }\n  /* line 5, stdin */\n  .base-data h4[_v-5ac92ff0] {\n    margin-right: 20px;\n    font-size: 24px; }\n\n/* line 10, stdin */\n.tab-list[_v-5ac92ff0] {\n  margin-top: 15px; }\n\n/* line 13, stdin */\n.form-group > *[_v-5ac92ff0] {\n  margin-right: 5px; }\n\n/* line 16, stdin */\n.copy-template[_v-5ac92ff0] {\n  min-width: 150px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-5ac92ff0", module.exports)
  } else {
    hotAPI.update("_v-5ac92ff0", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/object/keys":56,"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1406:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _templateList = require('./template-list.vue');

var _templateList2 = _interopRequireDefault(_templateList);

var _templateMain = require('./template-main.vue');

var _templateMain2 = _interopRequireDefault(_templateMain);

var _templateClass = require('./template-class.vue');

var _templateClass2 = _interopRequireDefault(_templateClass);

var _templateClassAppend = require('./template-class-append.vue');

var _templateClassAppend2 = _interopRequireDefault(_templateClassAppend);

var _templateClassFixation = require('./template-class-fixation.vue');

var _templateClassFixation2 = _interopRequireDefault(_templateClassFixation);

var _templateClassConfirmation = require('./template-class-confirmation.vue');

var _templateClassConfirmation2 = _interopRequireDefault(_templateClassConfirmation);

var _service = require('./service.vue');

var _service2 = _interopRequireDefault(_service);

var _serviceOptionFixation = require('./service-option-fixation.vue');

var _serviceOptionFixation2 = _interopRequireDefault(_serviceOptionFixation);

var _serviceAppendModal = require('./service-append-modal.vue');

var _serviceAppendModal2 = _interopRequireDefault(_serviceAppendModal);

var _serviceRow = require('./service-row.vue');

var _serviceRow2 = _interopRequireDefault(_serviceRow);

var _employeeMain = require('./employee-main.vue');

var _employeeMain2 = _interopRequireDefault(_employeeMain);

var _calculateMain = require('./calculate-main.vue');

var _calculateMain2 = _interopRequireDefault(_calculateMain);

var _calculateJob = require('./calculate-job.vue');

var _calculateJob2 = _interopRequireDefault(_calculateJob);

var _calculateMember = require('./calculate-member.vue');

var _calculateMember2 = _interopRequireDefault(_calculateMember);

var _calculateRecord = require('./calculate-record.vue');

var _calculateRecord2 = _interopRequireDefault(_calculateRecord);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//Page
_vue2.default.component('webadmin-salary-template-list', _templateList2.default);
_vue2.default.component('webadmin-salary-template-main', _templateMain2.default);
_vue2.default.component('webadmin-salary-template-class', _templateClass2.default);
_vue2.default.component('webadmin-salary-template-class-append', _templateClassAppend2.default);
_vue2.default.component('webadmin-salary-template-class-fixation', _templateClassFixation2.default);
_vue2.default.component('webadmin-salary-template-class-confirmation', _templateClassConfirmation2.default);

_vue2.default.component('webadmin-salary-service', _service2.default);
_vue2.default.component('webadmin-service-option-fixation', _serviceOptionFixation2.default);
_vue2.default.component('webadmin-service-append-modal', _serviceAppendModal2.default);
_vue2.default.component('webadmin-service-row', _serviceRow2.default);

_vue2.default.component('webadmin-salary-employee-main', _employeeMain2.default);

_vue2.default.component('webadmin-salary-calculate-main', _calculateMain2.default);
_vue2.default.component('webadmin-salary-calculate-job', _calculateJob2.default);
_vue2.default.component('webadmin-salary-calculate-member', _calculateMember2.default);
_vue2.default.component('webadmin-salary-calculate-record', _calculateRecord2.default);

},{"./calculate-job.vue":1401,"./calculate-main.vue":1402,"./calculate-member.vue":1403,"./calculate-record.vue":1404,"./employee-main.vue":1405,"./service-append-modal.vue":1407,"./service-option-fixation.vue":1408,"./service-row.vue":1409,"./service.vue":1410,"./template-class-append.vue":1411,"./template-class-confirmation.vue":1412,"./template-class-fixation.vue":1413,"./template-class.vue":1414,"./template-list.vue":1415,"./template-main.vue":1416,"vue":792}],1407:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n.gate-cell {\n    padding:5px 0px 5px 0px;\n}\n\n/* line 2, stdin */\n.category-title[_v-1250a61c] {\n  font-size: 16px;\n  font-weight: bold;\n  border-bottom: #ddd solid 2px;\n  padding-bottom: 10px;\n  margin-bottom: 10px;\n  margin-top: 15px;\n  max-width: 70%; }\n\n/* line 11, stdin */\n.options[_v-1250a61c] {\n  border-top: #ddd solid 1px;\n  margin-top: 15px;\n  padding-top: 10px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vuex = require('vuex');

exports.default = {
    props: {
        serviceCategory: {},
        types: {
            default: {}
        },
        getComponentName: {
            default: function _default() {}
        },
        currentServiceIds: {
            default: []
        }
    },
    data: function data() {
        return {
            appendValue: {
                serviceIds: [],
                propValues: {},
                selectedType: null
            }
        };
    },

    methods: {
        changeAppendProp: function changeAppendProp(obj) {
            this.appendValue.propValues[obj.key] = obj.value;
        },
        appendService: function appendService() {
            this.$emit('append-new', this.appendValue);
            $("#salary-service-append-modal").modal('hide');
            this.appendValue = {
                serviceIds: [],
                propValues: {},
                selectedType: null
            };
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-1250a61c=\"\">\n    <div id=\"salary-service-append-modal\" class=\"modal fade\" role=\"dialog\" _v-1250a61c=\"\">\n        <div class=\"modal-dialog\" _v-1250a61c=\"\">\n            <div class=\"modal-content\" _v-1250a61c=\"\">\n                <div class=\"modal-body\" _v-1250a61c=\"\">\n                    <div class=\"category form-inline\" v-for=\"category in serviceCategory\" _v-1250a61c=\"\">\n                        <div class=\"row category-title\" _v-1250a61c=\"\">\n                            <div class=\"col-xs-12\" _v-1250a61c=\"\">\n                                {{ category.name }}\n                            </div>\n                        </div>\n                        <div v-for=\"service in category.services\" v-if=\"currentServiceIds.indexOf(service.id) === -1\" class=\"from-group\" _v-1250a61c=\"\">\n                            <input type=\"checkbox\" :value=\"service.id\" :id=\"'append-'+service.id\" v-model=\"appendValue.serviceIds\" _v-1250a61c=\"\">\n                            <label :for=\"'append-'+service.id\" _v-1250a61c=\"\">{{ service.name }}</label>\n                        </div>\n                    </div>\n\n                    <div class=\"row options\" _v-1250a61c=\"\">\n                        <div class=\"col-xs-12 form-inline\" _v-1250a61c=\"\">\n                            <label for=\"salary-selected-type\" _v-1250a61c=\"\">將選取項目套用</label>\n                            <select v-model=\"appendValue.selectedType\" id=\"salary-selected-type\" class=\"form-control\" _v-1250a61c=\"\">\n                                <option value=\"null\" disabled=\"\" _v-1250a61c=\"\">請選擇</option>\n                                <option :value=\"type.value\" v-for=\"type in types\" _v-1250a61c=\"\">\n                                    {{type.name}}\n                                </option>\n                            </select>\n                            <component v-bind:is=\"getComponentName(appendValue.selectedType)\" @props-value-change=\"changeAppendProp\" :init-props=\"appendValue.propValues\" _v-1250a61c=\"\"></component>\n                            <a href=\"\" class=\"btn btn-primary\" @click.stop.prevent=\"appendService\" _v-1250a61c=\"\">確認</a>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n.gate-cell {\n    padding:5px 0px 5px 0px;\n}\n\n/* line 2, stdin */\n.category-title[_v-1250a61c] {\n  font-size: 16px;\n  font-weight: bold;\n  border-bottom: #ddd solid 2px;\n  padding-bottom: 10px;\n  margin-bottom: 10px;\n  margin-top: 15px;\n  max-width: 70%; }\n\n/* line 11, stdin */\n.options[_v-1250a61c] {\n  border-top: #ddd solid 1px;\n  margin-top: 15px;\n  padding-top: 10px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-1250a61c", module.exports)
  } else {
    hotAPI.update("_v-1250a61c", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1408:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        initProps: {
            fixed_money: null
        }
    },
    data: function data() {
        return {
            propsValue: {
                fixed_money: null
            }
        };
    },
    methods: {},
    watch: {
        "initProps.fixed_money": function initPropsFixed_money(newVal, oldVal) {
            if (!RegExp("^(0|[1-9][0-9]*)$").test(newVal)) {
                this.fixedMoney = oldVal;
                $17.swal({
                    title: '輸入值需為正整數',
                    type: 'error',
                    showCancelButton: false
                });
            }
        }
    },
    computed: {
        fixedMoney: {
            get: function get() {
                return this.initProps.fixed_money;
            },
            set: function set(newValue) {
                this.$emit('props-value-change', { 'key': 'fixed_money', 'value': newValue });
            }
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n    <span class=\"\" _v-4f5ecfd0=\"\">\n        <label for=\"service-fixed-money\" _v-4f5ecfd0=\"\">金額:</label>\n        <input type=\"number\" name=\"\" id=\"service-fixed-money\" v-model=\"fixedMoney\" class=\"form-control\" _v-4f5ecfd0=\"\">\n    \n</span>"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-4f5ecfd0", module.exports)
  } else {
    hotAPI.update("_v-4f5ecfd0", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],1409:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vuex = require('vuex');

exports.default = {
    props: {
        services: {},
        types: {
            default: []
        },
        initVal: {},
        getComponentName: {
            default: function _default() {}
        },
        objectKey: {
            default: null
        }
    },
    data: function data() {
        return {
            changeValue: {
                id: 0,
                salary_category_id: 0,
                name: '',
                is_default: false,
                method_type: '',
                props: {
                    fixed_money: null,
                    service_id: null
                }
            }
        };
    },
    mounted: function mounted() {
        this.changeValue = this.initVal;
    },
    methods: {
        changeSyncValue: function changeSyncValue(obj) {
            this.changeValue.props[obj.key] = obj.value;
        },
        deleteRow: function deleteRow() {
            this.$emit('delete-row', this.objectKey);
        }
    },
    watch: {
        "changeValue": {
            handler: function handler(newVal, oldVal) {
                this.$emit('value-change', newVal);
            },
            deep: true
        },
        initVal: {
            handler: function handler(newVal, oldVal) {
                this.changeValue = newVal;
            },
            deep: true
        }
    },
    computed: {
        initProps: function initProps() {
            return this.changeValue.props;
        },
        servieName: function servieName() {
            if (this.changeValue && this.changeValue.props && this.changeValue.props.service_id && this.services[this.changeValue.props.service_id]) {
                return this.services[this.changeValue.props.service_id]['name'];
            }
            return '';
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"row form-inline\" _v-20c0a652=\"\">\n    <div class=\"col-xs-2\" _v-20c0a652=\"\">\n        {{ servieName }}\n    </div>\n    <div class=\"col-xs-2\" _v-20c0a652=\"\">\n            <select v-model=\"changeValue.method_type\" class=\"form-control\" _v-20c0a652=\"\">\n                <option value=\"null\" disabled=\"\" _v-20c0a652=\"\">請選擇</option>\n                <option :value=\"type.value\" v-for=\"type in types\" _v-20c0a652=\"\">\n                    {{type.name}}\n                </option>\n            </select>\n    </div>\n    <div class=\"col-xs-7\" _v-20c0a652=\"\">\n        <component v-bind:is=\"getComponentName(changeValue.method_type)\" :init-props=\"initProps\" @props-value-change=\"changeSyncValue\" _v-20c0a652=\"\"></component>\n    </div>\n    <div class=\"col-xs-1\" _v-20c0a652=\"\">\n        <a class=\"btn btn-danger\" @click=\"deleteRow\" _v-20c0a652=\"\">刪除</a>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-20c0a652", module.exports)
  } else {
    hotAPI.update("_v-20c0a652", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vuex":803}],1410:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.row[_v-0fdd64c5] {\n  margin: 20px -15px; }\n\n/* line 5, stdin */\n.footer-button[_v-0fdd64c5] {\n  margin-top: 50px; }\n\n/* line 8, stdin */\n.head[_v-0fdd64c5] {\n  border-bottom: solid #ddd 1px;\n  padding-bottom: 10px; }\n\n/* line 2, stdin */\n.salary-list .row-list {\n  border-bottom: 1px solid #ddd;\n  padding-bottom: 10px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        'defaultRows': {
            default: function _default() {
                return {};
            }
        },
        'groupId': {
            default: {}
        },
        cache: {
            default: {
                'classes': {},
                'services': {}
            }
        }
    },
    data: function data() {
        return {
            appendModeActive: false,
            valueArray: [],
            view: {
                ajaxing: false
            },
            'types': [{
                value: 'service_fixation',
                'name': '固定薪資'
            }]
        };
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId', 'isBranch', 'isStudio', 'isSeventeen']), (0, _vuex.mapState)('filters', ['selected_studio_id', 'selected_branch_id']), {
        activeStudioId: function activeStudioId() {
            if (this.isSeventeen) {
                return this.selected_studio_id;
            }
            return this.studioId;
        },
        activeBranchId: function activeBranchId() {
            if (this.isSeventeen || this.isStudio) {
                return this.selected_branch_id;
            }
            return this.branchId;
        },
        serviceList: function serviceList() {
            return this.serviceCategory.reduce(function (carry, category) {
                return carry.concat(category.services);
            }, []).reduce(function (carry, service) {
                carry[service.id] = service;
                return carry;
            }, {});
        },
        currentServiceIds: function currentServiceIds() {
            return this.valueArray.map(function (value) {
                return value.props.service_id;
            }, []);
        },

        serviceCategory: {
            get: function get() {
                if (!this.cache.services || !this.cache.services.serviceCategory) {
                    return [];
                }
                return this.cache.services.serviceCategory;
            },
            set: function set(newValue) {
                this.$emit('update-cache', {
                    'category': 'services',
                    'key': 'serviceCategory',
                    'value': newValue
                });
            }
        }
    }),
    mounted: function mounted() {
        this.$nextTick(function () {
            this.getServiceCategory();
            if (this.defaultRows && this.defaultRows.services) {
                this.valueArray = this.defaultRows.services;
            }
        });
    },
    watch: {
        defaultRows: {
            handler: function handler(newVal, oldVal) {
                this.valueArray = newVal.services;
            },
            deep: true
        },
        activeBranchId: function activeBranchId() {
            if (this.defaultRows && this.defaultRows.services) {
                this.valueArray = this.defaultRows.services;
            }
            this.getServiceCategory();
        }
    },
    methods: {
        getServiceCategory: function getServiceCategory() {
            var _this = this;

            if (this.serviceCategory.length > 0) {
                return;
            }
            this.view.ajaxing = true;
            this.$http.get('/adminapi/menu_group/list?studio_id=' + this.activeStudioId + '&branch_id=' + this.activeBranchId).then(function (response) {
                _this.serviceCategory = response.body;
                _this.view.ajaxing = false;
            }, function (error) {
                $17.swal({
                    title: '讀取服務發生錯誤',
                    type: 'error',
                    showCancelButton: false
                });
                _this.view.ajaxing = false;
            });
        },
        appendServices: function appendServices(value) {
            var _this2 = this;

            var serviceIds = value.serviceIds;
            var propValues = value.propValues;
            var selectedType = value.selectedType;

            serviceIds.map(function (serviceId) {
                _this2.valueArray.push({
                    id: 0,
                    salary_category_id: 0,
                    name: '',
                    is_default: false,
                    method_type: selectedType,
                    props: {
                        fixed_money: propValues.fixed_money,
                        service_id: serviceId
                    }
                });
            });
        },
        cancelChange: function cancelChange() {
            this.$emit('cancel-change');
            this.valueArray = [];
        },
        updateCurrent: function updateCurrent() {
            this.$emit('update-current', { 'category': 'services', 'value': this.valueArray });
        },
        appendNew: function appendNew() {
            $("#salary-service-append-modal").modal('show');
        },
        getComponentName: function getComponentName(methodType) {
            switch (methodType) {
                case 'service_fixation':
                    return 'webadmin-service-option-fixation';
                    break;

                default:
                    break;
            }
        },
        deleteRow: function deleteRow(key) {
            var newArray = JSON.parse((0, _stringify2.default)(this.valueArray));
            this.valueArray = [];
            this.$delete(newArray, key);
            this.valueArray = newArray;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-0fdd64c5=\"\">\n    <v-spinner :ajaxing=\"view.ajaxing\" _v-0fdd64c5=\"\"></v-spinner>\n    <div v-show=\"!view.ajaxing\" _v-0fdd64c5=\"\">\n        <div class=\"row\" _v-0fdd64c5=\"\">\n            <div class=\"col-xs-12\" _v-0fdd64c5=\"\">\n                <a type=\"button\" value=\"\" class=\"btn btn--primary\" @click=\"appendNew()\" _v-0fdd64c5=\"\">\n                    新增薪資條件\n                </a>\n            </div>\n        </div>\n        <div class=\"row head\" _v-0fdd64c5=\"\">\n            <div class=\"col-xs-2\" _v-0fdd64c5=\"\">\n                服務名稱\n            </div>\n            <div class=\"col-xs-2\" _v-0fdd64c5=\"\">\n                薪資條件\n            </div>\n            <div class=\"col-xs-7\" _v-0fdd64c5=\"\">\n                \n            </div>\n            <div class=\"col-xs-1\" _v-0fdd64c5=\"\">\n                \n            </div>\n        </div>\n        <div class=\"salary-list\" _v-0fdd64c5=\"\">\n            <div v-for=\"(objectValue,key) in valueArray\" _v-0fdd64c5=\"\">\n                <webadmin-service-row :services=\"serviceList\" :types=\"types\" :init-val=\"objectValue\" :get-component-name=\"getComponentName\" :object-key=\"key\" @delete-row=\"deleteRow\" _v-0fdd64c5=\"\"></webadmin-service-row>\n            </div>\n        </div>\n        <div class=\"row text-center footer-button\" _v-0fdd64c5=\"\">\n            <div class=\"col-xs-12\" _v-0fdd64c5=\"\">\n                <input type=\"button\" value=\"回列表\" @click=\"cancelChange\" class=\"btn btn-default \" _v-0fdd64c5=\"\">\n                <input type=\"button\" value=\"更新\" @click=\"updateCurrent\" class=\"btn btn-primary \" _v-0fdd64c5=\"\">\n            </div>\n        </div>\n    </div>\n    <webadmin-service-append-modal :service-category=\"serviceCategory\" :types=\"types\" :current-service-ids=\"currentServiceIds\" @append-new=\"appendServices\" :get-component-name=\"getComponentName\" _v-0fdd64c5=\"\"></webadmin-service-append-modal>\n</div>    \n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.row[_v-0fdd64c5] {\n  margin: 20px -15px; }\n\n/* line 5, stdin */\n.footer-button[_v-0fdd64c5] {\n  margin-top: 50px; }\n\n/* line 8, stdin */\n.head[_v-0fdd64c5] {\n  border-bottom: solid #ddd 1px;\n  padding-bottom: 10px; }\n\n/* line 2, stdin */\n.salary-list .row-list {\n  border-bottom: 1px solid #ddd;\n  padding-bottom: 10px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-0fdd64c5", module.exports)
  } else {
    hotAPI.update("_v-0fdd64c5", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/json/stringify":48,"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1411:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vuex = require('vuex');

exports.default = {
    props: {
        'appendModeActive': {
            default: false
        }
    },
    data: function data() {
        return {
            'types': [{
                value: 'class_fixation',
                'name': '固定制'
            }, {
                value: 'class_confirmation',
                'name': '人頭制'
            }],
            appendValue: {
                selectedType: null,
                name: null
            }
        };
    },
    created: function created() {
        this.selectedType = this.types[0];
    },
    methods: {
        append: function append() {
            if (this.appendValue.selectedType == null) {
                $17.swal({
                    title: '請選擇一個類型',
                    type: 'error',
                    showCancelButton: false
                });
                return;
            }
            this.$emit('append', this.appendValue);
            this.appendValue.selectedType = null;
            this.appendValue.name = null;
        },
        disableAppend: function disableAppend() {
            this.appendValue.selectedType = null;
            this.appendValue.name = null;
            this.selectedType = this.types[0];
            this.$emit('disable-append', false);
        }
    },
    watch: {
        "appendValue.selectedType": {
            handler: function handler(newVal, oldVal) {
                if (newVal != null) {
                    this.append();
                }
            }
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"row\" v-show=\"appendModeActive\" _v-61060512=\"\">\n    <div class=\"col-xs-1\" _v-61060512=\"\">\n    </div>\n    <div class=\"col-xs-2\" _v-61060512=\"\">\n        <select v-model=\"appendValue.selectedType\" class=\"form-control\" _v-61060512=\"\">\n            <option value=\"null\" disabled=\"\" _v-61060512=\"\">請選擇</option>\n            <option :value=\"type.value\" v-for=\"type in types\" _v-61060512=\"\">\n                {{type.name}}\n            </option>\n        </select>\n    </div>\n    <div class=\"col-xs-2\" _v-61060512=\"\">\n        <input type=\"text\" v-model=\"appendValue.name\" class=\"form-control\" _v-61060512=\"\">\n    </div>\n    <div class=\"col-xs-7\" _v-61060512=\"\">\n        \n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-61060512", module.exports)
  } else {
    hotAPI.update("_v-61060512", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vuex":803}],1412:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.row[_v-1c9816a6] {\n  margin: 20px -15px; }\n\n/* line 5, stdin */\n.form-group[_v-1c9816a6] {\n  margin-top: 10px; }\n  /* line 7, stdin */\n  .form-group *[_v-1c9816a6] {\n    margin-right: 5px; }\n\n/* line 11, stdin */\n.number-input[_v-1c9816a6] {\n  max-width: 100px; }\n\n/* line 14, stdin */\n.big-icon[_v-1c9816a6] {\n  font-size: 50px; }\n\n/* line 17, stdin */\nspan[_v-1c9816a6] {\n  margin-right: 5px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        'initValue': {
            default: []
        },
        'objectKey': {
            default: null
        }
    },
    data: function data() {
        return {
            changeValue: {
                id: 0,
                salary_category_id: 0,
                name: '',
                is_default: false,
                method_type: '',
                props: {
                    salary_template_group_id: null,
                    hightest_limit_money: null,
                    lowest_limit_money: null,
                    no_attend_money: null,
                    confirmation_money: null,
                    enable_bonus: null,
                    minimun_bonus_num: null,
                    bonus_condition: null,
                    bonus_money: null,
                    enable_hightest_limit: 0,
                    enable_lowest_limit: 0,
                    enable_no_attend: 0
                }
            },
            changeValueCopy: {}
        };
    },
    created: function created() {
        this.setDefaultValue(this.initValue);
    },
    destroy: function destroy() {
        this.changeValue = {};
    },

    watch: {
        changeValue: {
            handler: function handler(newVal, oldVal) {
                if (newVal.props && this.checkIsPositive(newVal.props)) {
                    this.changeValueCopy = (0, _stringify2.default)(newVal);

                    this.$emit('value-change', { keyEl: this.objectKey, newVal: newVal });
                } else {
                    (0, _assign2.default)(this.changeValue, JSON.parse(this.changeValueCopy));
                }
            },
            deep: true
        },
        initValue: {
            handler: function handler(newVal, oldVal) {
                this.setDefaultValue(newVal);
            },
            deep: true
        }
    },
    methods: {
        append: function append() {
            this.checkProps();
            this.$emit('append', this.changeValue);
        },
        deleteRow: function deleteRow() {
            this.$emit('delete-row', this.objectKey);
        },
        setDefaultValue: function setDefaultValue(newVal) {
            this.changeValue.id = newVal.id;
            this.changeValue.salary_category_id = newVal.salary_category_id;
            this.changeValue.is_default = newVal.is_default;
            this.changeValue.method_type = newVal.method_type;
            this.changeValue.name = newVal.name;

            if (newVal.id == 0 && !newVal.props) {
                this.getEmptyProps();
            } else {
                this.getProps(newVal.props);
            }
        },
        getProps: function getProps(subProps) {
            this.changeValue.props.salary_template_group_id = subProps.salary_template_group_id;
            this.changeValue.props.hightest_limit_money = subProps.hightest_limit_money;
            this.changeValue.props.lowest_limit_money = subProps.lowest_limit_money;
            this.changeValue.props.no_attend_money = subProps.no_attend_money;
            this.changeValue.props.confirmation_money = subProps.confirmation_money;
            this.changeValue.props.enable_bonus = subProps.enable_bonus;
            this.changeValue.props.minimun_bonus_num = subProps.minimun_bonus_num;
            this.changeValue.props.bonus_condition = subProps.bonus_condition;
            this.changeValue.props.bonus_money = subProps.bonus_money;
            this.changeValue.props.enable_hightest_limit = subProps.enable_hightest_limit;
            this.changeValue.props.enable_no_attend = subProps.enable_no_attend;
            this.changeValue.props.enable_lowest_limit = subProps.enable_lowest_limit;
        },
        getEmptyProps: function getEmptyProps() {
            this.changeValue.props.salary_template_group_id = null;
            this.changeValue.props.hightest_limit_money = null;
            this.changeValue.props.lowest_limit_money = null;
            this.changeValue.props.no_attend_money = null;
            this.changeValue.props.confirmation_money = null;
            this.changeValue.props.enable_bonus = null;
            this.changeValue.props.minimun_bonus_num = null;
            this.changeValue.props.bonus_condition = null;
            this.changeValue.props.bonus_money = null;
            this.changeValue.props.enable_hightest_limit = 0;
            this.changeValue.props.enable_no_attend = 0;
            this.changeValue.props.enable_lowest_limit = 0;
        },
        resetDefault: function resetDefault() {
            this.$emit('reset-default', this.objectKey);
        },
        checkIsPositive: function checkIsPositive(props) {
            return (0, _keys2.default)(props).reduce(function (carry, key) {
                var prop = props[key];
                if (prop < 0 && prop != 'null') {
                    $17.swal({
                        title: '輸入值須為正整數',
                        type: 'error',
                        showCancelButton: false
                    });
                    carry = false;
                }

                return carry;
            }, true);
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"row row-list\" _v-1c9816a6=\"\">\n    <div class=\"col-xs-1\" _v-1c9816a6=\"\">\n        <input class=\"big-icon\" type=\"radio\" :value=\"1\" @click=\"resetDefault\" v-model.number=\"changeValue.is_default\" name=\"default-set\" _v-1c9816a6=\"\">\n    </div>\n    <div class=\"col-xs-2\" _v-1c9816a6=\"\">\n        <label for=\"\" _v-1c9816a6=\"\">人頭制</label>\n    </div>\n    <div class=\"col-xs-2\" _v-1c9816a6=\"\">\n        <input class=\"form-control\" type=\"text\" v-model=\"changeValue.name\" _v-1c9816a6=\"\">\n    </div>\n    <div class=\"col-xs-6\" _v-1c9816a6=\"\">\n        <form class=\"form-inline\" _v-1c9816a6=\"\">\n            <div class=\"row\" _v-1c9816a6=\"\">\n                <div class=\"col-xs-4 col-sm-3\" _v-1c9816a6=\"\">\n                    <span _v-1c9816a6=\"\">每位出席客戶固定薪資</span>\n                </div>\n                <div class=\"col-xs-8 col-sm-9\" _v-1c9816a6=\"\">\n                    <input class=\"form-control number-input\" type=\"number\" min=\"0\" v-model.number=\"changeValue.props.confirmation_money\" _v-1c9816a6=\"\">\n                    元\n                </div>\n            </div>\n            <div class=\"row\" _v-1c9816a6=\"\">\n                <div class=\"col-xs-4 col-sm-3\" _v-1c9816a6=\"\">\n                    <input class=\"big-icon\" type=\"checkbox\" :true-value=\"1\" :false-value=\"0\" name=\"enable_bonus\" v-model.number=\"changeValue.props.enable_bonus\" _v-1c9816a6=\"\">\n                    <span _v-1c9816a6=\"\">獎金</span>\n                </div>\n                <div class=\"col-xs-8 col-sm-9\" v-show=\"changeValue.props.enable_bonus\" _v-1c9816a6=\"\">\n                    <span _v-1c9816a6=\"\">超過</span>\n                    <input class=\"form-control number-input\" type=\"number\" min=\"0\" v-model.number=\"changeValue.props.minimun_bonus_num\" _v-1c9816a6=\"\">\n                    <span _v-1c9816a6=\"\">人出席課程後，依 </span>\n                    <select v-model.number=\"changeValue.props.bonus_condition\" class=\"form-control\" _v-1c9816a6=\"\">\n                        <option :value=\"1\" _v-1c9816a6=\"\">所有出席</option>\n                        <option :value=\"2\" _v-1c9816a6=\"\">超過</option>\n                    </select>\n                    <span _v-1c9816a6=\"\">人數每人加發獎金</span>\n                    <input class=\"form-control number-input\" type=\"number\" min=\"0\" v-model.number=\"changeValue.props.bonus_money\" _v-1c9816a6=\"\">\n                    <span _v-1c9816a6=\"\">元</span>\n                </div>\n            </div>\n            <div class=\"row\" _v-1c9816a6=\"\">\n                <div class=\"col-xs-4 col-sm-3\" _v-1c9816a6=\"\">\n                    <input class=\"big-icon\" type=\"checkbox\" :true-value=\"1\" :false-value=\"0\" name=\"enable_bonus\" v-model.number=\"changeValue.props.enable_hightest_limit\" _v-1c9816a6=\"\">\n                    <span _v-1c9816a6=\"\">每堂課薪資上限</span>\n                </div>\n                <div class=\"col-xs-8 col-sm-9\" v-show=\"changeValue.props.enable_hightest_limit\" _v-1c9816a6=\"\">\n                    <input class=\"form-control number-input\" type=\"number\" min=\"0\" v-model.number=\"changeValue.props.hightest_limit_money\" _v-1c9816a6=\"\">\n                    <span _v-1c9816a6=\"\">元</span>\n                </div>\n            </div>\n            <div class=\"row\" _v-1c9816a6=\"\">\n                <div class=\"col-xs-4 col-sm-3\" _v-1c9816a6=\"\">\n                    <input class=\"big-icon\" type=\"checkbox\" :true-value=\"1\" :false-value=\"0\" name=\"enable_bonus\" v-model.number=\"changeValue.props.enable_lowest_limit\" _v-1c9816a6=\"\">\n                    <span _v-1c9816a6=\"\">每堂課薪資下限</span>\n                </div>\n                <div class=\"col-xs-8 col-sm-9\" v-show=\"changeValue.props.enable_lowest_limit\" _v-1c9816a6=\"\">\n                    <input class=\"form-control number-input\" type=\"number\" min=\"0\" v-model.number=\"changeValue.props.lowest_limit_money\" _v-1c9816a6=\"\">\n                    <span _v-1c9816a6=\"\">元</span>\n                </div>\n            </div>\n            <div class=\"row\" _v-1c9816a6=\"\">\n                <div class=\"col-xs-12 col-sm-12\" _v-1c9816a6=\"\">\n                    <span _v-1c9816a6=\"\">無人出席時，是否要給予薪資?</span>\n                    <input class=\"big-icon\" type=\"radio\" :value=\"0\" name=\"enable_bonus\" v-model.number=\"changeValue.props.enable_no_attend\" _v-1c9816a6=\"\">\n                    <span _v-1c9816a6=\"\"> 否</span>\n                    <input class=\"big-icon\" type=\"radio\" :value=\"1\" name=\"enable_bonus\" v-model.number=\"changeValue.props.enable_no_attend\" _v-1c9816a6=\"\">\n                    <span _v-1c9816a6=\"\"> 是</span>\n                    <span v-show=\"changeValue.props.enable_no_attend\" _v-1c9816a6=\"\">\n                        <input class=\"form-control number-input\" type=\"number\" min=\"0\" v-model.number=\"changeValue.props.no_attend_money\" _v-1c9816a6=\"\">\n                        <span _v-1c9816a6=\"\">元</span>\n                    </span>\n                </div>\n            </div>\n        </form>\n    </div>\n    <div class=\"col-xs-1\" _v-1c9816a6=\"\">\n        <a class=\"btn btn-danger\" @click=\"deleteRow\" _v-1c9816a6=\"\">刪除</a>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.row[_v-1c9816a6] {\n  margin: 20px -15px; }\n\n/* line 5, stdin */\n.form-group[_v-1c9816a6] {\n  margin-top: 10px; }\n  /* line 7, stdin */\n  .form-group *[_v-1c9816a6] {\n    margin-right: 5px; }\n\n/* line 11, stdin */\n.number-input[_v-1c9816a6] {\n  max-width: 100px; }\n\n/* line 14, stdin */\n.big-icon[_v-1c9816a6] {\n  font-size: 50px; }\n\n/* line 17, stdin */\nspan[_v-1c9816a6] {\n  margin-right: 5px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-1c9816a6", module.exports)
  } else {
    hotAPI.update("_v-1c9816a6", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/json/stringify":48,"babel-runtime/core-js/object/assign":50,"babel-runtime/core-js/object/keys":56,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1413:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.row[_v-f9aaa210] {\n  margin: 20px -15px; }\n\n/* line 5, stdin */\n.form-group[_v-f9aaa210] {\n  margin-top: 10px; }\n  /* line 7, stdin */\n  .form-group *[_v-f9aaa210] {\n    margin-right: 5px; }\n\n/* line 11, stdin */\n.number-input[_v-f9aaa210] {\n  max-width: 100px; }\n\n/* line 14, stdin */\n.big-icon[_v-f9aaa210] {\n  font-size: 50px; }\n\n/* line 17, stdin */\nspan[_v-f9aaa210] {\n  margin-right: 5px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        'initValue': {
            default: []
        },
        'objectKey': {
            default: null
        }
    },
    data: function data() {
        return {
            changeValue: {
                id: 0,
                salary_category_id: 0,
                name: '',
                is_default: false,
                method_type: '',
                props: {
                    salary_template_group_id: null,
                    hightest_limit_money: null,
                    lowest_limit_money: 0,
                    no_attend_money: null,
                    fixed_money: null,
                    enable_bonus: null,
                    minimun_bonus_num: null,
                    bonus_condition: null,
                    bonus_money: null,
                    enable_hightest_limit: 0,
                    enable_lowest_limit: 0,
                    enable_no_attend: 0
                }
            },
            changeValueCopy: {}
        };
    },
    created: function created() {
        this.setDefaultValue(this.initValue);
    },
    destroy: function destroy() {
        this.changeValue = {};
    },

    watch: {
        changeValue: {
            handler: function handler(newVal, oldVal) {
                if (newVal.props && this.checkIsPositive(newVal.props)) {
                    this.changeValueCopy = (0, _stringify2.default)(newVal);

                    this.$emit('value-change', { keyEl: this.objectKey, newVal: newVal });
                } else {
                    (0, _assign2.default)(this.changeValue, JSON.parse(this.changeValueCopy));
                }
            },
            deep: true
        },
        initValue: {
            handler: function handler(newVal, oldVal) {
                this.setDefaultValue(newVal);
            },
            deep: true
        }
    },
    methods: {
        append: function append() {
            this.checkProps();
            this.$emit('append', this.changeValue);
        },
        deleteRow: function deleteRow() {
            this.$emit('delete-row', this.objectKey);
        },
        setDefaultValue: function setDefaultValue(newVal) {
            this.changeValue.id = newVal.id;
            this.changeValue.salary_category_id = newVal.salary_category_id;
            this.changeValue.is_default = newVal.is_default;
            this.changeValue.method_type = newVal.method_type;
            this.changeValue.name = newVal.name;

            if (newVal.id == 0 && !newVal.props) {
                this.getEmptyProps();
            } else {
                this.getProps(newVal.props);
            }
        },
        getProps: function getProps(subProps) {
            this.changeValue.props.salary_template_group_id = subProps.salary_template_group_id;
            this.changeValue.props.hightest_limit_money = subProps.hightest_limit_money;
            this.changeValue.props.lowest_limit_money = subProps.lowest_limit_money;
            this.changeValue.props.no_attend_money = subProps.no_attend_money;
            this.changeValue.props.fixed_money = subProps.fixed_money;
            this.changeValue.props.enable_bonus = subProps.enable_bonus;
            this.changeValue.props.minimun_bonus_num = subProps.minimun_bonus_num;
            this.changeValue.props.bonus_condition = subProps.bonus_condition;
            this.changeValue.props.bonus_money = subProps.bonus_money;
            this.changeValue.props.enable_hightest_limit = subProps.enable_hightest_limit;
            this.changeValue.props.enable_no_attend = subProps.enable_no_attend;
        },
        getEmptyProps: function getEmptyProps() {
            this.changeValue.props.salary_template_group_id = null;
            this.changeValue.props.hightest_limit_money = null;
            this.changeValue.props.lowest_limit_money = null;
            this.changeValue.props.no_attend_money = null;
            this.changeValue.props.fixed_money = null;
            this.changeValue.props.enable_bonus = null;
            this.changeValue.props.minimun_bonus_num = null;
            this.changeValue.props.bonus_condition = null;
            this.changeValue.props.bonus_money = null;
            this.changeValue.props.enable_hightest_limit = 0;
            this.changeValue.props.enable_no_attend = 0;
        },
        resetDefault: function resetDefault() {
            this.$emit('reset-default', this.objectKey);
        },
        checkIsPositive: function checkIsPositive(props) {
            return (0, _keys2.default)(props).reduce(function (carry, key) {
                var prop = props[key];
                if (prop < 0 && prop != 'null') {
                    $17.swal({
                        title: '輸入值須為正整數',
                        type: 'error',
                        showCancelButton: false
                    });
                    carry = false;
                }

                return carry;
            }, true);
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"row row-list\" _v-f9aaa210=\"\">\n    <div class=\"col-xs-1\" _v-f9aaa210=\"\">\n        <input class=\"big-icon\" type=\"radio\" :value=\"1\" @click=\"resetDefault\" v-model.number=\"changeValue.is_default\" name=\"default-set\" _v-f9aaa210=\"\">\n    </div>\n    <div class=\"col-xs-2\" _v-f9aaa210=\"\">\n        <label for=\"\" _v-f9aaa210=\"\">固定制</label>\n    </div>\n    <div class=\"col-xs-2\" _v-f9aaa210=\"\">\n        <input class=\"form-control\" type=\"text\" v-model=\"changeValue.name\" _v-f9aaa210=\"\">\n    </div>\n    <div class=\"col-xs-6\" _v-f9aaa210=\"\">\n        <form class=\"form-inline\" _v-f9aaa210=\"\">\n            <div class=\"row\" _v-f9aaa210=\"\">\n                <div class=\"col-xs-4 col-sm-3\" _v-f9aaa210=\"\">\n                    <span _v-f9aaa210=\"\">每堂課固定薪資</span>\n                </div>\n                <div class=\"col-xs-8 col-sm-9\" _v-f9aaa210=\"\">\n                    <input class=\"form-control number-input\" type=\"number\" min=\"0\" v-model.number=\"changeValue.props.fixed_money\" _v-f9aaa210=\"\">\n                    元\n                </div>\n            </div>\n            <div class=\"row\" _v-f9aaa210=\"\">\n                <div class=\"col-xs-4 col-sm-3\" _v-f9aaa210=\"\">\n                    <input class=\"big-icon\" type=\"checkbox\" :true-value=\"1\" :false-value=\"0\" name=\"enable_bonus\" v-model.number=\"changeValue.props.enable_bonus\" _v-f9aaa210=\"\">\n                    <span _v-f9aaa210=\"\">獎金</span>\n                </div>\n                <div class=\"col-xs-8 col-sm-9\" v-show=\"changeValue.props.enable_bonus\" _v-f9aaa210=\"\">\n                    <span _v-f9aaa210=\"\">超過</span>\n                    <input class=\"form-control number-input\" type=\"number\" min=\"0\" v-model.number=\"changeValue.props.minimun_bonus_num\" _v-f9aaa210=\"\">\n                    <span _v-f9aaa210=\"\">人出席課程後，依 </span>\n                    <select v-model.number=\"changeValue.props.bonus_condition\" class=\"form-control\" _v-f9aaa210=\"\">\n                        <option :value=\"1\" _v-f9aaa210=\"\">所有出席</option>\n                        <option :value=\"2\" _v-f9aaa210=\"\">超過</option>\n                    </select>\n                    <span _v-f9aaa210=\"\">人數每人加發獎金</span>\n                    <input class=\"form-control number-input\" type=\"number\" min=\"0\" v-model.number=\"changeValue.props.bonus_money\" _v-f9aaa210=\"\">\n                    <span _v-f9aaa210=\"\">元</span>\n                </div>\n            </div>\n            <div class=\"row\" _v-f9aaa210=\"\">\n                <div class=\"col-xs-4 col-sm-3\" _v-f9aaa210=\"\">\n                    <input class=\"big-icon\" type=\"checkbox\" :true-value=\"1\" :false-value=\"0\" name=\"enable_bonus\" v-model.number=\"changeValue.props.enable_hightest_limit\" _v-f9aaa210=\"\">\n                    <span _v-f9aaa210=\"\">每堂課薪資上限</span>\n                </div>\n                <div class=\"col-xs-8 col-sm-9\" v-show=\"changeValue.props.enable_hightest_limit\" _v-f9aaa210=\"\">\n                    <input class=\"form-control number-input\" type=\"number\" min=\"0\" v-model.number=\"changeValue.props.hightest_limit_money\" _v-f9aaa210=\"\">\n                    <span _v-f9aaa210=\"\">元</span>\n                </div>\n            </div>\n            <div class=\"row\" _v-f9aaa210=\"\">\n                <div class=\"col-xs-12 col-sm-12\" _v-f9aaa210=\"\">\n                    <span _v-f9aaa210=\"\">無人出席時，是否要給予薪資?</span>\n                    <input class=\"big-icon\" type=\"radio\" :value=\"0\" name=\"enable_bonus\" v-model.number=\"changeValue.props.enable_no_attend\" _v-f9aaa210=\"\">\n                    <span _v-f9aaa210=\"\"> 否</span>\n                    <input class=\"big-icon\" type=\"radio\" :value=\"1\" name=\"enable_bonus\" v-model.number=\"changeValue.props.enable_no_attend\" _v-f9aaa210=\"\">\n                    <span _v-f9aaa210=\"\"> 是</span>\n                    <span v-show=\"changeValue.props.enable_no_attend\" _v-f9aaa210=\"\">\n                        <input class=\"form-control number-input\" type=\"number\" min=\"0\" v-model.number=\"changeValue.props.no_attend_money\" _v-f9aaa210=\"\">\n                        <span _v-f9aaa210=\"\">元</span>\n                    </span>\n                </div>\n            </div>\n        </form>\n    </div>\n    <div class=\"col-xs-1\" _v-f9aaa210=\"\">\n        <a class=\"btn btn-danger\" @click=\"deleteRow\" _v-f9aaa210=\"\">刪除</a>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.row[_v-f9aaa210] {\n  margin: 20px -15px; }\n\n/* line 5, stdin */\n.form-group[_v-f9aaa210] {\n  margin-top: 10px; }\n  /* line 7, stdin */\n  .form-group *[_v-f9aaa210] {\n    margin-right: 5px; }\n\n/* line 11, stdin */\n.number-input[_v-f9aaa210] {\n  max-width: 100px; }\n\n/* line 14, stdin */\n.big-icon[_v-f9aaa210] {\n  font-size: 50px; }\n\n/* line 17, stdin */\nspan[_v-f9aaa210] {\n  margin-right: 5px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-f9aaa210", module.exports)
  } else {
    hotAPI.update("_v-f9aaa210", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/json/stringify":48,"babel-runtime/core-js/object/assign":50,"babel-runtime/core-js/object/keys":56,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1414:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.row[_v-755f6cf6] {\n  margin: 20px -15px; }\n\n/* line 5, stdin */\n.footer-button[_v-755f6cf6] {\n  margin-top: 50px; }\n\n/* line 8, stdin */\n.head[_v-755f6cf6] {\n  border-bottom: solid #ddd 1px;\n  padding-bottom: 10px; }\n\n/* line 2, stdin */\n.salary-list .row-list {\n  border-bottom: 1px solid #ddd;\n  padding-bottom: 10px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        'defaultRows': {
            default: function _default() {
                return {};
            }
        },
        'groupId': {
            default: {}

        }
    },
    data: function data() {
        return {
            appendModeActive: false,
            valueArray: []
        };
    },
    mounted: function mounted() {
        this.valueArray = this.defaultRows.classes;
    },

    watch: {
        defaultRows: {
            handler: function handler(newVal, oldVal) {
                this.valueArray = newVal.classes;
            },
            deep: true
        }
    },
    methods: {
        appendNewRow: function appendNewRow(props) {
            if (!Array.isArray(this.valueArray)) {
                this.valueArray = [];
            }

            var valueArray = JSON.parse((0, _stringify2.default)(this.valueArray));
            valueArray.unshift({
                "id": 0,
                "method_type": props.selectedType,
                "salary_category_id": 1,
                "name": props.name,
                "is_default": 0
            });
            this.valueArray = valueArray;
            this.changeAppendMode(false);
        },
        changeAppendMode: function changeAppendMode(status) {
            this.appendModeActive = status;
        },
        changeSyncValue: function changeSyncValue(val) {
            this.valueArray[val.keyEl] = val.newVal;
        },
        getComponentName: function getComponentName(methodType) {
            switch (methodType) {
                case 'class_fixation':
                    return 'webadmin-salary-template-class-fixation';
                    break;

                case 'class_confirmation':
                    return 'webadmin-salary-template-class-confirmation';
                    break;

                default:
                    break;
            }
        },
        deleteRow: function deleteRow(key) {
            var newArray = JSON.parse((0, _stringify2.default)(this.valueArray));
            this.valueArray = [];
            this.$delete(newArray, key);
            this.valueArray = newArray;
        },
        updateCurrent: function updateCurrent() {
            this.$emit('update-current', { 'category': 'classes', 'value': this.valueArray });
        },
        cancelChange: function cancelChange() {
            this.$emit('cancel-change');
            this.appendModeActive = false;
            this.valueArray = [];
        },
        resetDefault: function resetDefault() {
            this.valueArray.map(function (value) {
                value.is_default = 0;
                return value;
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-755f6cf6=\"\">\n    <div class=\"row\" _v-755f6cf6=\"\">\n        <div class=\"col-xs-12\" _v-755f6cf6=\"\">\n            <a type=\"button\" value=\"\" class=\"btn btn--primary\" @click=\"changeAppendMode(true)\" _v-755f6cf6=\"\">\n                新增條件\n            </a>\n        </div>\n    </div>\n    <div class=\"row head\" _v-755f6cf6=\"\">\n        <div class=\"col-xs-1\" _v-755f6cf6=\"\">\n            預設\n        </div>\n        <div class=\"col-xs-2\" _v-755f6cf6=\"\">\n            類型\n        </div>\n        <div class=\"col-xs-2\" _v-755f6cf6=\"\">\n            命名\n        </div>\n        <div class=\"col-xs-6\" _v-755f6cf6=\"\">\n            條件\n        </div>\n        <div class=\"col-xs-1\" _v-755f6cf6=\"\">\n             \n        </div>\n    </div>\n    <div class=\"salary-list\" _v-755f6cf6=\"\">\n        <webadmin-salary-template-class-append @append=\"appendNewRow\" @disable-append=\"changeAppendMode\" :append-mode-active=\"appendModeActive\" _v-755f6cf6=\"\"></webadmin-salary-template-class-append>\n        <div v-for=\"(objectValue,key) in valueArray\" _v-755f6cf6=\"\">\n            <component v-bind:is=\"getComponentName(objectValue.method_type)\" @value-change=\"changeSyncValue\" @delete-row=\"deleteRow\" @reset-default=\"resetDefault\" :init-value=\"objectValue\" :object-key=\"key\" _v-755f6cf6=\"\"></component>\n        </div>\n    </div>\n     <div class=\"row text-center footer-button\" _v-755f6cf6=\"\">\n        <div class=\"col-xs-12\" _v-755f6cf6=\"\">\n            <input type=\"button\" value=\"回列表\" @click=\"cancelChange\" class=\"btn btn-default \" _v-755f6cf6=\"\">\n            <input type=\"button\" value=\"更新\" @click=\"updateCurrent\" class=\"btn btn-primary \" _v-755f6cf6=\"\">\n        </div>\n    </div>\n</div>    \n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.row[_v-755f6cf6] {\n  margin: 20px -15px; }\n\n/* line 5, stdin */\n.footer-button[_v-755f6cf6] {\n  margin-top: 50px; }\n\n/* line 8, stdin */\n.head[_v-755f6cf6] {\n  border-bottom: solid #ddd 1px;\n  padding-bottom: 10px; }\n\n/* line 2, stdin */\n.salary-list .row-list {\n  border-bottom: 1px solid #ddd;\n  padding-bottom: 10px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-755f6cf6", module.exports)
  } else {
    hotAPI.update("_v-755f6cf6", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/json/stringify":48,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1415:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.table[_v-7fd0f821] {\n  width: 100%; }\n\n/* line 6, stdin */\n.name[_v-7fd0f821] {\n  padding-left: 5%; }\n\n/* line 9, stdin */\n.append-new[_v-7fd0f821] {\n  margin-top: 20px;\n  margin-bottom: 20px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            view: {
                ajaxing: false,
                currentTab: 'list'
            },
            items: [],
            editSettingId: null
        };
    },
    created: function created() {},
    watch: {
        selected_branch_id: function selected_branch_id() {
            if (!this.isBranch && this.selected_branch_id) {
                this.getTemplate();
            }
        },
        branchId: function branchId() {
            if (this.isBranch) {
                this.getTemplate();
            }
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId', 'isBranch']), (0, _vuex.mapState)('filters', ['selected_studio_id', 'selected_branch_id']), {
        activeStudioId: function activeStudioId() {
            if (this.isSeventeen) {
                return this.selected_studio_id;
            }
            return this.studioId;
        },
        activeBranchId: function activeBranchId() {
            if (this.isSeventeen || this.isStudio) {
                return this.selected_branch_id;
            }
            return this.branchId;
        }
    }),
    methods: {
        getTemplate: function getTemplate() {
            var _this = this;

            var branchId = this.isBranch ? this.branchId : this.selected_branch_id;
            this.view.ajaxing = true;
            this.$http.get('/adminapi/salary/template/branch/' + branchId).then(function (response) {
                _this.items = response.body;
                _this.view.ajaxing = false;
            }, function (error) {
                $17.swal({
                    title: '讀取樣板列表發生錯誤',
                    type: 'error',
                    showCancelButton: false
                });
                _this.view.ajaxing = false;
            });
        },
        changeEditType: function changeEditType(type, id) {
            this.view.currentTab = type;
            this.editSettingId = id;
        },
        cancleEdit: function cancleEdit() {
            this.getTemplate();
            this.changeEditType('list', null);
        },
        deleteTemplate: function deleteTemplate(id, key) {
            var _this2 = this;

            $17.swal({
                title: '確認刪除此範本?',
                //   text:'刪除此範本時，所有與人員設定關聯將被解除。',
                type: 'warning'
            }, function () {
                _this2.$http.delete('/adminapi/salary/template/' + id).then(function (response) {
                    $17.swal({
                        title: '樣板已刪除',
                        type: 'success',
                        showCancelButton: false
                    });
                    _this2.$delete(_this2.items, key);
                    _this2.view.ajaxing = false;
                }, function (error) {
                    $17.swal({
                        title: '樣板刪除發生錯誤',
                        type: 'error',
                        showCancelButton: false
                    });
                    _this2.view.ajaxing = false;
                });
            });
        },
        changeEditId: function changeEditId(id) {
            this.editSettingId = id;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"container\" _v-7fd0f821=\"\">\n    <div v-show=\"view.currentTab=='list'\" _v-7fd0f821=\"\">\n        <div class=\"row\" _v-7fd0f821=\"\">\n            <div class=\"col-xs-12\" _v-7fd0f821=\"\">\n                <v-select-studio-and-branch :studio_id=\"studioId\" :branch_id=\"branchId\" :branch-without-filtered-option=\"false\" _v-7fd0f821=\"\">\n                </v-select-studio-and-branch>\n            </div>\n        </div> \n        <div class=\"row\" _v-7fd0f821=\"\">\n            <div class=\"col-xs-12 append-new\" _v-7fd0f821=\"\">\n                <input type=\"button\" class=\"btn btn--primary \" value=\"新增範本\" @click=\"changeEditType('edit',0)\" _v-7fd0f821=\"\">\n            </div>\n        </div> \n        <v-table :length=\"items.length\" :ajaxing=\"view.ajaxing\" _v-7fd0f821=\"\">\n            <table class=\"table\" _v-7fd0f821=\"\">\n                <thead _v-7fd0f821=\"\">\n                    <tr _v-7fd0f821=\"\">\n                        <th _v-7fd0f821=\"\">\n                            <p class=\"name\" _v-7fd0f821=\"\">命名</p>\n                        </th>\n                        <th _v-7fd0f821=\"\"></th>\n                    </tr>\n                </thead>\n                <tbody _v-7fd0f821=\"\">\n                    <tr v-for=\"(it,key) in items\" :key=\"it.id\" _v-7fd0f821=\"\">\n                        <td _v-7fd0f821=\"\"> \n                            {{ it.name }}\n                        </td>\n                        <td class=\"text-right\" _v-7fd0f821=\"\"> \n                            <input type=\"button\" class=\"btn btn-primary\" value=\"編輯\" @click=\"changeEditType('edit',it.id)\" _v-7fd0f821=\"\">\n                            <input type=\"button\" class=\"btn btn-danger\" value=\"刪除\" @click=\"deleteTemplate(it.id,key)\" _v-7fd0f821=\"\">\n                        </td>\n                    </tr>\n                </tbody>\n            </table>\n        </v-table>\n    </div>\n    <div class=\"list\" v-show=\"view.currentTab=='edit'\" _v-7fd0f821=\"\">\n        <webadmin-salary-template-main :edit-id=\"editSettingId\" :studio-id=\"activeStudioId\" :branch-id=\"activeBranchId\" @cancel-change=\"cancleEdit\" @edit-id-change=\"changeEditId\" _v-7fd0f821=\"\"></webadmin-salary-template-main>\n    </div>\n</div>    \n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.table[_v-7fd0f821] {\n  width: 100%; }\n\n/* line 6, stdin */\n.name[_v-7fd0f821] {\n  padding-left: 5%; }\n\n/* line 9, stdin */\n.append-new[_v-7fd0f821] {\n  margin-top: 20px;\n  margin-bottom: 20px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-7fd0f821", module.exports)
  } else {
    hotAPI.update("_v-7fd0f821", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1416:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\nlabel[_v-2f1b47bc] {\n  margin-right: 5px; }\n\n/* line 5, stdin */\n.tabs[_v-2f1b47bc] {\n  margin-top: 15px; }\n\n/* line 8, stdin */\n.row[_v-2f1b47bc] {\n  margin: 20px -15px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        'editId': {
            default: null
        }
    },
    data: function data() {
        return {
            tabs: [{
                'name': '課程薪資條件設定',
                'type': 'webadmin-salary-template-class',
                'event': this.changeTab
            }, {
                'name': '服務薪資條件設定',
                'type': 'webadmin-salary-service',
                'event': this.changeTab
            }],
            view: {
                ajaxing: false
            },
            activeTab: 'webadmin-salary-template-class',
            templateName: null,
            defaultRows: {
                'classes': [],
                'services': []
            },
            cache: {
                'classes': {},
                'services': {
                    serviceCategory: []
                }
            }
        };
    },
    watch: {
        editId: function editId(newVal) {
            this.templateName = null;
            this.fetchData(newVal);
        }
    },
    created: function created() {},
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId', 'isBranch', 'isStudio', 'isSeventeen']), (0, _vuex.mapState)('filters', ['selected_studio_id', 'selected_branch_id']), {
        activeStudioId: function activeStudioId() {
            if (this.isSeventeen) {
                return this.selected_studio_id;
            }
            return this.studioId;
        },
        activeBranchId: function activeBranchId() {
            if (this.isSeventeen || this.isStudio) {
                return this.selected_branch_id;
            }
            return this.branchId;
        }
    }),
    methods: {
        changeTab: function changeTab(tab) {
            this.activeTab = tab.type;
        },
        fetchData: function fetchData(editId) {
            var _this = this;

            if (!editId) {
                return;
            }
            this.view.ajaxing = true;
            this.$http.get('/adminapi/salary/template/' + editId).then(function (response) {
                _this.defaultRows = response.body.settings;
                _this.templateName = response.body.head.name;
                _this.view.ajaxing = false;
            }, function (error) {
                $17.swal({
                    title: '讀取資料發生錯誤',
                    text: error.data.message,
                    type: 'error',
                    showCancelButton: false
                });
                _this.view.ajaxing = false;
            });
        },
        updateCurrentTab: function updateCurrentTab(data) {
            var _this2 = this;

            var category = data.category;
            var value = data.value;
            this.view.ajaxing = true;
            this.$http.post('/adminapi/salary/template/action', {
                'change_category': category,
                'head': {
                    id: this.editId,
                    studio_id: this.activeStudioId,
                    branch_id: this.activeBranchId,
                    name: this.templateName
                },
                'settings': value

            }).then(function (response) {
                $17.swal({
                    title: '資料已更新',
                    type: 'success',
                    showCancelButton: false
                });
                _this2.checkNeedUpdateEditId(response.body.head.id);
                _this2.defaultRows[category] = response.body.settings[category];
                _this2.view.ajaxing = false;
            }, function (error) {
                $17.swal({
                    title: '更新資料發生錯誤',
                    text: error.data.message,
                    type: 'error',
                    showCancelButton: false
                });
                _this2.view.ajaxing = false;
            });
        },
        cancelEdit: function cancelEdit() {
            this.$emit('cancel-change');
            this.defaultRows = {
                'classes': [],
                'services': []
            };
            this.activeTab = 'webadmin-salary-template-class';
        },
        checkNeedUpdateEditId: function checkNeedUpdateEditId(editId) {
            this.$emit('edit-id-change', editId);
        },
        updateCache: function updateCache(object) {
            var category = object.category;
            var key = object.key;
            var value = object.value;

            this['cache'][category][key] = value;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"container\" _v-2f1b47bc=\"\">\n    <v-spinner :ajaxing=\"view.ajaxing\" _v-2f1b47bc=\"\"></v-spinner>\n    <div v-show=\"!view.ajaxing\" _v-2f1b47bc=\"\">\n        <div class=\"row form-inline\" _v-2f1b47bc=\"\">\n            <div class=\"col-xs-12 form-group\" _v-2f1b47bc=\"\">\n                <label for=\"template-name\" _v-2f1b47bc=\"\">範本名稱</label>\n                <input type=\"text\" name=\"\" id=\"template-name\" placeholder=\"\" class=\"form-control\" v-model=\"templateName\" _v-2f1b47bc=\"\">\n            </div>\n        </div> \n        <div class=\"row\" _v-2f1b47bc=\"\">\n            <div class=\"col-xs-12\" _v-2f1b47bc=\"\">\n                <v-simple-tabs :tabs=\"tabs\" :need-check=\"true\" title=\"確定切換?\" text=\"請先按下更新，否則未更新的變更都將不會儲存\" _v-2f1b47bc=\"\"></v-simple-tabs>\n            </div>\n        </div>\n        <component v-bind:is=\"activeTab\" :default-rows=\"defaultRows\" :group-id=\"editId\" :cache=\"cache\" @update-current=\"updateCurrentTab\" @cancel-change=\"cancelEdit\" @update-cache=\"updateCache\" _v-2f1b47bc=\"\"></component>\n    </div>\n</div>    \n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\nlabel[_v-2f1b47bc] {\n  margin-right: 5px; }\n\n/* line 5, stdin */\n.tabs[_v-2f1b47bc] {\n  margin-top: 15px; }\n\n/* line 8, stdin */\n.row[_v-2f1b47bc] {\n  margin: 20px -15px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-2f1b47bc", module.exports)
  } else {
    hotAPI.update("_v-2f1b47bc", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1417:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n\n")
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require("vuex");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        sales: {
            required: true
        },
        salsemenList: {
            required: true
        },
        siteList: {
            required: true
        },
        isLevelSelect: {
            required: true
        }
    },
    data: function data() {
        return {};
    },

    watch: {
        isLevelSelect: function isLevelSelect(newV) {
            if (newV.member_id) {
                var branch_id = newV.branch_id || 0;
                this.sales.branch = this.siteList.find(function (item, index, array) {
                    return item.id == branch_id;
                });
                this.sales.selectedSales = this.salsemenList[branch_id].find(function (item, index, array) {
                    return item.id == newV.member_id;
                });
            } else {
                this.sales.branch = "";
                this.sales.selectedSales = "";
            }
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId', 'isBranch'])),
    mounted: function mounted() {},

    created: function created() {},
    methods: {
        getBranchSalsemenList: function getBranchSalsemenList(branch) {
            if (this.salsemenList && branch) {
                return this.salsemenList[branch.id] || [];
            } else {
                return [];
            }
        },
        clearSelectedSales: function clearSelectedSales() {
            this.sales.selectedSales = '';
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div>\n    <div class=\"col-sm-3 text-right p-top-10\">{{sales.label}}</div>\n    <div class=\"col-sm-4\">\n        <v-mutiselect :model.sync=\"sales.branch\" :options=\"siteList\" :multiple=\"false\" :close-on-select=\"true\" :clear-on-select=\"true\" :preserve-search=\"true\" :searchable=\"false\" :placeholder=\"'請選擇場館'\" label=\"branch_name\" track-by=\"id\" :taggable=\"true\" tag-name=\"branch_name\" :max-height=\"400\" :select-event-append=\"clearSelectedSales\" :remove-event-append=\"clearSelectedSales\"></v-mutiselect>\n    </div>\n    <div class=\"col-sm-5\">\n        <v-mutiselect :model.sync=\"sales.selectedSales\" :options=\"getBranchSalsemenList(sales.branch)\" :multiple=\"false\" :close-on-select=\"true\" :clear-on-select=\"true\" :preserve-search=\"true\" :searchable=\"true\" :placeholder=\"'請選擇'+sales.label\" label=\"name\" track-by=\"id\" :taggable=\"true\" tag-name=\"name\" :max-height=\"400\"></v-mutiselect>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-7e5fda37", module.exports)
  } else {
    hotAPI.update("_v-7e5fda37", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1418:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _list = require('./list.vue');

var _list2 = _interopRequireDefault(_list);

var _modal = require('./modal.vue');

var _modal2 = _interopRequireDefault(_modal);

var _memberSelect = require('./member-select.vue');

var _memberSelect2 = _interopRequireDefault(_memberSelect);

var _orderSetting = require('./order-setting.vue');

var _orderSetting2 = _interopRequireDefault(_orderSetting);

var _branchSelect = require('./branch-select.vue');

var _branchSelect2 = _interopRequireDefault(_branchSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('webadmin-salseman-list', _list2.default);
_vue2.default.component('webadmin-salseman-modal', _modal2.default);
_vue2.default.component('webadmin-salseman-member-select', _memberSelect2.default);
_vue2.default.component('webadmin-salseman-order-setting', _orderSetting2.default);
_vue2.default.component('webadmin-salseman-branch-select', _branchSelect2.default);

},{"./branch-select.vue":1417,"./list.vue":1419,"./member-select.vue":1420,"./modal.vue":1421,"./order-setting.vue":1422,"vue":792}],1419:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.btn-success[_v-2b0df59e] {\n  margin-bottom: 15px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            list: {},
            ajaxing: false
        };
    },
    created: function created() {},
    watch: {
        branchId: function branchId() {
            if (this.branchId !== 0) {
                this.selected_studio_id = this.studioId;
                this.selected_branch_id = this.branchId;
                this.changed();
            }
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId']), (0, _vuex.mapState)('filters', []), {
        allListIds: function allListIds() {
            var _this = this;

            var ids = [];
            (0, _keys2.default)(this.list).map(function (item, index) {

                ids[index] = _this.list[index].member_id;
            });
            return ids;
        },

        selected_studio_id: {
            get: function get() {
                return this.$store.state.filters.selected_studio_id;
            },
            set: function set(studioId) {
                this.$store.commit('filters/SETSTATUS', { 'key': 'selected_studio_id', value: studioId });
            }
        },
        selected_branch_id: {
            get: function get() {
                return this.$store.state.filters.selected_branch_id;
            },
            set: function set(branch_id) {
                this.$store.commit('filters/SETSTATUS', { 'key': 'selected_branch_id', value: branch_id });
            }
        }
    }),
    methods: {
        showModal: function showModal(item) {
            $('#saleman-modal').modal('show');
        },
        changed: function changed() {
            var _this2 = this;

            var branch_id = this.selected_branch_id;
            if (this.selected_branch_id === null || this.selected_branch_id === 'null') {
                branch_id = '';
            }
            this.ajaxing = true;
            this.$http.get('/adminapi/salseman/customer-servants/studio/' + this.selected_studio_id + '/branch/' + branch_id).then(function (response) {
                _this2.ajaxing = false;
                _this2.list = response.body.list;
            }, function (error) {
                _this2.ajaxing = false;
            });
        },
        deleteSalse: function deleteSalse(servant_id, member_id) {
            var _this3 = this;

            this.ajaxing = true;
            this.$http.delete('/adminapi/salseman/' + servant_id, {
                body: { member_id: member_id }
            }).then(function (response) {
                _this3.ajaxing = false;
                _this3.changed();
            }, function (error) {
                _this3.ajaxing = false;
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"container\" _v-2b0df59e=\"\">\n    <div class=\"row\" _v-2b0df59e=\"\">\n        <div class=\"col-sm-6\" _v-2b0df59e=\"\">\n            <button type=\"button\" class=\"btn btn-success\" @click=\"showModal\" _v-2b0df59e=\"\">\n                新增業務代表\n            </button>\n        </div>\n    </div>\n    <div class=\"row\" _v-2b0df59e=\"\">\n        <div class=\"col-sm-6\" _v-2b0df59e=\"\">\n            <v-select-studio-and-branch :studio_id=\"studioId\" :branch_id=\"branchId\" :branch-change-call-back=\"changed\" :branch-without-filtered-option=\"true\" branch-without-filtered-option-word=\"品牌\" _v-2b0df59e=\"\"></v-select-studio-and-branch>\n        </div>\n    </div>\n    <div class=\"text-center\" _v-2b0df59e=\"\">\n\n        <v-spinner :ajaxing=\"ajaxing\" _v-2b0df59e=\"\">\n\n        </v-spinner>\n\n        <table v-show=\"!ajaxing\" class=\"table pagin-table\" _v-2b0df59e=\"\">\n            <thead _v-2b0df59e=\"\">\n                <tr _v-2b0df59e=\"\">\n                    <th _v-2b0df59e=\"\">人員名稱</th>\n                    <th _v-2b0df59e=\"\">動作</th>\n                </tr>\n            </thead>\n\n            <tbody align=\"left\" _v-2b0df59e=\"\">\n                <tr v-for=\"servant in list\" _v-2b0df59e=\"\">\n                    <td _v-2b0df59e=\"\">{{servant.name}}</td>\n                    <td _v-2b0df59e=\"\">\n                        <a @click.prevent=\"deleteSalse(servant.servant_id, servant.member_id)\" _v-2b0df59e=\"\">刪除</a>\n                    </td>\n                </tr>\n            </tbody>\n        </table>\n    </div>\n    <webadmin-salseman-modal :exist-ids=\"allListIds\" @created=\"changed\" open-size=\"modal-sm\" _v-2b0df59e=\"\"></webadmin-salseman-modal>\n</div>    \n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.btn-success[_v-2b0df59e] {\n  margin-bottom: 15px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-2b0df59e", module.exports)
  } else {
    hotAPI.update("_v-2b0df59e", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/object/keys":56,"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1420:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.show-salseman[_v-4b1e2a3f] {\n  margin-bottom: 15px; }\n\n/* line 5, stdin */\n.btn-reselect[_v-4b1e2a3f] {\n  color: #C7C4C3; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            salseman: {},
            id: {},
            ajaxing: false
        };
    },
    created: function created() {},
    props: {
        branchId: {
            required: true
        },
        studioId: {
            required: true
        },
        changed: {
            type: Function,
            required: true
        },
        clearClicked: {
            type: Function,
            required: true
        },
        initValue: {
            required: false
        },
        currentId: {
            required: true
        },
        editright: {}
    },
    watch: {
        studioId: function studioId(_studioId) {
            if (!_studioId) {
                return;
            }
            this.fetchSalseman(_studioId);
        },
        branchId: function branchId(_branchId) {
            if (!_branchId) {
                return;
            }

            this.changeSalseman({ 'branchId': _branchId, 'studioId': this.studioId });
            if (typeof this.currentId !== 'undefined' && this.initValue === "") {
                this.salseman = {};
            }
        },
        salseman: function salseman(_salseman) {
            var vm = this;
            if (this.initValue == _salseman.id) {
                return;
            }
            if (_salseman && _salseman.id) {
                vm.ajaxing = true;
                this.$emit('update:salseman', _salseman);
                this.changed().then(function () {
                    vm.ajaxing = false;
                }, function () {
                    vm.ajaxing = false;
                });
            }
        },
        currentId: function currentId(value) {
            if (value != this.id) {
                this.salseman = {};
                this.setInitValue(this.initValue);
            }
            this.id = value;
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/crm', ['salsemen', 'salsemenCurrentBranchId'])),
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('webadmin/crm', ['fetchSalseman', 'changeSalseman']), {
        clearSelected: function clearSelected() {
            var vm = this;
            vm.ajaxing = true;
            this.clearClicked().then(function () {
                vm.ajaxing = false;
            }, function () {
                vm.ajaxing = false;
            });
            this.salseman = {};
        },
        setInitValue: function setInitValue(value) {
            if (!value) {
                return;
            }
            selectedSalseman = this.salsemen.reduce(function (carry, salseman) {
                if (salseman.id == value) {
                    carry = salseman;
                }
                // console.log(carry);
                return carry;
            }, {});

            if (selectedSalseman.id) {
                this.salseman = selectedSalseman;
            }
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-4b1e2a3f=\"\">\n    <div v-if=\"!salseman.id &amp;&amp; editright\" _v-4b1e2a3f=\"\">\n        <v-mutiselect v-if=\"!ajaxing\" class=\"salseman\" :model.sync=\"salseman\" :options=\"salsemen\" :multiple=\"false\" :close-on-select=\"true\" :clear-on-select=\"true\" :searchable=\"true\" label=\"name\" track-by=\"id\" tag-name=\"name\" placeholder=\"業務代表\" _v-4b1e2a3f=\"\">\n        </v-mutiselect>\n        <div class=\"row\" _v-4b1e2a3f=\"\">\n            <div class=\"col-xs-12\" v-if=\"ajaxing\" _v-4b1e2a3f=\"\">\n                <v-spinner-button :ajaxing=\"ajaxing\" _v-4b1e2a3f=\"\"></v-spinner-button>\n            </div>\n        </div>\n    </div>\n    <div class=\"show-salseman\" v-if=\"salseman.id\" _v-4b1e2a3f=\"\">\n        <div class=\"row\" _v-4b1e2a3f=\"\">\n            <div class=\"col-xs-12\" _v-4b1e2a3f=\"\">\n                {{salseman.name}}\n            </div>\n        </div>\n        <div class=\"row\" _v-4b1e2a3f=\"\">\n            <div class=\"col-xs-12\" v-if=\"!ajaxing\" _v-4b1e2a3f=\"\">\n                <div type=\"button\" class=\"btn btn-default btn-reselect\" @click=\"clearSelected\" v-if=\"editright\" _v-4b1e2a3f=\"\">\n                    <i aria-hidden=\"true\" class=\"fa fa-times-circle\" _v-4b1e2a3f=\"\"></i>\n                    變更業務代表\n                </div>\n                <div type=\"button\" class=\"btn btn-default btn-reselect\" v-else=\"!editright\" disabled=\"\" _v-4b1e2a3f=\"\">\n                    <i aria-hidden=\"true\" class=\"fa fa-times-circle\" _v-4b1e2a3f=\"\"></i>\n                    變更業務代表\n                </div>\n            </div>\n            <div class=\"col-xs-12\" v-if=\"ajaxing\" _v-4b1e2a3f=\"\">\n                <v-spinner-button :ajaxing=\"ajaxing\" _v-4b1e2a3f=\"\"></v-spinner-button>\n            </div>\n        </div>\n    </div>\n</div>    \n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.show-salseman[_v-4b1e2a3f] {\n  margin-bottom: 15px; }\n\n/* line 5, stdin */\n.btn-reselect[_v-4b1e2a3f] {\n  color: #C7C4C3; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-4b1e2a3f", module.exports)
  } else {
    hotAPI.update("_v-4b1e2a3f", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1421:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.row[_v-039baa5d] {\n  margin-top: 15px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['existIds'],
    data: function data() {
        return {
            list: [],
            select_member: null,
            createAjax: false,
            ajaxing: false
        };
    },
    mounted: function mounted() {},

    created: function created() {},
    watch: {
        selected_branch_id: function selected_branch_id() {
            this.changed();
            $('#ssab_branch_id').change();
        },
        branchId: function branchId() {
            if (this.branchId !== 0) {
                this.selected_branch_id = this.branchId;
            }
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId']), (0, _vuex.mapState)('filters', ['branchOptions', 'selected_studio_id', 'selected_branch_id']), {
        filterItems: function filterItems() {
            var _this = this;

            if (this.list.length === 0) {
                return [];
            }
            return this.list.reduce(function (carry, current) {

                if (_this.existIds.indexOf(current.memberId) === -1) {
                    carry.push(current);
                }
                return carry;
            }, []);
        },

        selected_branch_id: {
            get: function get() {
                return this.$store.state.filters.selected_branch_id;
            },
            set: function set(branch_id) {
                this.$store.commit('filters/SETSTATUS', { 'key': 'selected_branch_id', value: branch_id });
            }
        }
    }),
    methods: {
        changed: function changed() {
            var _this2 = this;

            this.ajaxing = true;
            var branch_id = this.selected_branch_id;
            if (this.selected_branch_id === null || this.selected_branch_id === 'null') {
                branch_id = '';
            }
            this.$http.get('/adminapi/member-right/studio/' + this.selected_studio_id + '/branch/' + branch_id).then(function (response) {
                _this2.ajaxing = false;
                _this2.list = response.body.list;
                $(_this2.$el).change();
            }, function (error) {
                _this2.ajaxing = false;
            });
        },
        create: function create() {
            var _this3 = this;

            this.createAjax = true;
            this.$http.post('/adminapi/salseman', { 'member_id': this.select_member.memberId, 'studio': this.selected_studio_id, 'branch': this.selected_branch_id }).then(function (response) {
                _this3.createAjax = false;
                _this3.select_member = null;
                _this3.$emit('created');
                _this3.changed();
            }, function (error) {
                _this3.createAjax = false;
                $17.swal({
                    type: 'error',
                    title: error.body.message,
                    showCancelButton: false
                });
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-039baa5d=\"\">\n    <div id=\"saleman-modal\" class=\"modal fade\" role=\"dialog\" _v-039baa5d=\"\">\n        <div class=\"modal-dialog\" _v-039baa5d=\"\">\n            <div class=\"modal-content\" _v-039baa5d=\"\">\n                <div class=\"modal-header\" _v-039baa5d=\"\">\n                    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" _v-039baa5d=\"\">×</button>\n                    <h4 class=\"modal-title\" _v-039baa5d=\"\">新增業務代表</h4>\n                </div>\n\n                <div class=\"modal-body\" _v-039baa5d=\"\">\n                    <div class=\"container\" _v-039baa5d=\"\">\n                    <div class=\"row\" _v-039baa5d=\"\">\n                        <div class=\"col-sm-8\" _v-039baa5d=\"\">\n                            <select id=\"ssab_branch_id\" class=\"form-control\" v-model=\"selected_branch_id\" v-if=\"branchId===0\" _v-039baa5d=\"\">\n                                <option value=\"null\" _v-039baa5d=\"\">品牌</option>\n                                <option v-for=\"branchOption in branchOptions\" :value=\"branchOption.id\" :key=\"branchOption.id\" _v-039baa5d=\"\">{{ branchOption.branch_name }}</option>\n                            </select>\n                        </div>\n                    </div>\n                    <v-spinner :ajaxing=\"ajaxing\" _v-039baa5d=\"\"></v-spinner>\n                    <div class=\"row\" v-show=\"!ajaxing\" _v-039baa5d=\"\">\n                        <div class=\"col-sm-8\" _v-039baa5d=\"\">\n                            <v-mutiselect :model.sync=\"select_member\" :options=\"filterItems\" :multiple=\"false\" :close-on-select=\"true\" :clear-on-select=\"true\" :searchable=\"true\" label=\"name\" track-by=\"memberId\" tag-name=\"name\" placeholder=\"請選擇一個人員\" _v-039baa5d=\"\">\n                            </v-mutiselect>\n                        </div>\n                    </div>\n\n                    <div class=\"row\" _v-039baa5d=\"\">\n                        <div class=\"col-sm-8 text-right\" _v-039baa5d=\"\">\n                            <input type=\"button\" value=\"新增\" class=\"btn btn-primary\" v-show=\"!createAjax\" @click=\"create\" _v-039baa5d=\"\">\n                            <v-spinner-button :ajaxing=\"createAjax\" _v-039baa5d=\"\"></v-spinner-button>\n                        </div>\n                    </div>\n                </div>\n                </div>\n            </div>\n        </div>\n    </div>\n\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.row[_v-039baa5d] {\n  margin-top: 15px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-039baa5d", module.exports)
  } else {
    hotAPI.update("_v-039baa5d", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1422:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        orderSalesmen: {
            required: true,
            default: {}
        },
        salsemanVisible: {
            required: true
        },
        modelId: {
            required: true
        },
        customerServantTypeId: {},
        servantOperationType: {
            default: 'order'
        },
        typeString: {
            default: '業務代表'
        }
    },
    data: function data() {
        return {
            salesList: [{ 'label': this.typeString + '１',
                'branch': '',
                'selectedSales': '' }, { 'label': this.typeString + '２',
                'branch': '',
                'selectedSales': '' }, { 'label': this.typeString + '３',
                'branch': '',
                'selectedSales': '' }, { 'label': this.typeString + '４',
                'branch': '',
                'selectedSales': '' }, { 'label': this.typeString + '５',
                'branch': '',
                'selectedSales': '' }, { 'label': this.typeString + '６',
                'branch': '',
                'selectedSales': '' }],
            siteList: [],
            salsemenList: [],
            ajaxing: false
        };
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId', 'isBranch', 'branchList'])),
    mounted: function mounted() {
        this.addListenerOnModal();
    },
    destroyed: function destroyed() {
        this.removeListener();
    },

    created: function created() {},
    watch: {
        studioId: function studioId(newV) {
            if (newV) {
                this.fetchBranchList({ studioId: newV });
                this.getSalesList(newV);
            }
        },
        branchList: function branchList(newV) {
            if (newV) {
                this.siteList = [{ id: 0, branch_name: '不限場館' }];
                this.siteList = this.siteList.concat(newV);
            }
        },
        customerServantTypeId: function customerServantTypeId(newV) {
            this.getSalesList(this.studioId);
        },
        typeString: function typeString(newVal) {
            this.salesList = [{ 'label': newVal + '１',
                'branch': '',
                'selectedSales': '' }, { 'label': newVal + '２',
                'branch': '',
                'selectedSales': '' }, { 'label': newVal + '３',
                'branch': '',
                'selectedSales': '' }, { 'label': newVal + '４',
                'branch': '',
                'selectedSales': '' }, { 'label': newVal + '５',
                'branch': '',
                'selectedSales': '' }, { 'label': newVal + '６',
                'branch': '',
                'selectedSales': '' }];
        }
    },
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('webadmin/configure', ['fetchBranchList']), {
        closeModel: function closeModel() {
            $('#' + this.modelId).modal('hide');
        },
        addListenerOnModal: function addListenerOnModal() {
            var vm = this;
            $('#order-edit').on('hide.bs.modal', function (event) {
                vm.checkOrderSalesmanIsClosed(event);
            });
            $('#order-show').on('hide.bs.modal', function (event) {
                vm.checkOrderSalesmanIsClosed(event);
            });
            $('#' + this.modelId).on('hide.bs.modal', function (event) {
                event.stopPropagation();
            });
            $('#' + this.modelId).on('hidden.bs.modal', function (event) {
                return event.stopPropagation();
            });
        },
        removeListener: function removeListener() {
            $('#order-edit').unbind('hide.bs.modal');
            $('#order-show').unbind('hide.bs.modal');
            $('#' + this.modelId).unbind('hide.bs.modal');
            $('#' + this.modelId).unbind('hidden.bs.modal');
        },
        checkOrderSalesmanIsClosed: function checkOrderSalesmanIsClosed(event) {
            event.stopPropagation();
            if ($('#' + this.modelId).hasClass('in')) {
                event.preventDefault();
                return false;
            }
        },
        getSalesList: function getSalesList(studioId) {
            switch (this.servantOperationType) {
                case 'order':
                    this.getOrderSalesList(studioId);
                    break;

                case 'studio-member':
                    this.getStudioMemberSalesList(studioId);
                    break;

                default:
                    this.getOrderSalesList(studioId);
                    break;
            }
        },
        getOrderSalesList: function getOrderSalesList(studioId) {
            var _this = this;

            this.$http.get('/adminapi/salseman/getAllServant/' + studioId).then(function (response) {
                _this.salsemenList = response.data.list;
            });
        },
        getStudioMemberSalesList: function getStudioMemberSalesList(studioId) {
            var _this2 = this;

            if (!this.customerServantTypeId || !studioId) {
                return;
            }
            this.$http.get('/adminapi/servant/studio/' + studioId + '/customer_servant_type/' + this.customerServantTypeId + '/getAllServant').then(function (response) {
                _this2.salsemenList = response.data.list;
            });
        },
        getBranchSalsemenList: function getBranchSalsemenList(branch) {
            if (this.salsemenList && branch) {
                return this.salsemenList[branch.id] || [];
            } else {
                return [];
            }
        },
        getSelectList: function getSelectList(index) {
            if (!this.orderSalesmen) return;
            var list = {};
            list.member_id = this.orderSalesmen['level_' + (index + 1) + '_member_id'];

            if (index === 0 && this.servantOperationType == 'order') {
                list.member_id = this.orderSalesmen.member_id;
            }

            list.branch_id = this.orderSalesmen['level_' + (index + 1) + '_member_branch_id'];
            return list;
        },
        isShowOrderSalesmen: function isShowOrderSalesmen(index) {
            if (!this.salsemanVisible) return;
            return this.salsemanVisible['level_' + (index + 1) + '_salesperson_visible'] || this.salsemanVisible['level_' + (index + 1) + '_visible'];
        },
        save: function save() {
            var _this3 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this3.ajaxing = true;
                                _context.t0 = _this3.servantOperationType;
                                _context.next = _context.t0 === 'order' ? 4 : _context.t0 === 'studio-member' ? 7 : 10;
                                break;

                            case 4:
                                _context.next = 6;
                                return _this3.orderSave();

                            case 6:
                                return _context.abrupt('break', 13);

                            case 7:
                                _context.next = 9;
                                return _this3.studioMemberSave();

                            case 9:
                                return _context.abrupt('break', 13);

                            case 10:
                                _context.next = 12;
                                return _this3.orderSave();

                            case 12:
                                return _context.abrupt('break', 13);

                            case 13:

                                _this3.ajaxing = false;

                            case 14:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this3);
            }))();
        },
        studioMemberSave: function studioMemberSave() {
            var _this4 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return _this4.$http.post('/adminapi/servant/update/' + _this4.orderSalesmen.id, { salesList: _this4.salesList }).then(function (response) {
                                    _this4.$emit('refresh-salesmen-list');
                                    _this4.alert('儲存成功', '', 'success');
                                    _this4.closeModel();
                                }).catch(function (response) {
                                    _this4.alert('儲存失敗', '', 'error');
                                });

                            case 2:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this4);
            }))();
        },
        orderSave: function orderSave() {
            var _this5 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return _this5.$http.post('/adminapi/salseman/order/' + _this5.orderSalesmen.id, { salesList: _this5.salesList }).then(function (response) {
                                    _this5.$emit('refresh-salesmen-list');
                                    _this5.alert('儲存成功', '', 'success');
                                    _this5.closeModel();
                                }).catch(function (response) {
                                    _this5.alert('儲存失敗', '', 'error');
                                });

                            case 2:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this5);
            }))();
        },
        alert: function alert(title, message, type) {
            $17.swal({
                title: title,
                text: message,
                type: type,
                showCancelButton: false,
                showLoaderOnConfirm: true
            });
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div>\n    <v-modal :id=\"modelId\" :block-hide-without-close=\"true\" parallel-modal=\"\">\n        <div slot=\"title\">\n            <h4 class=\"modal-title\">設定{{typeString}}</h4>\n        </div>\n        <div slot=\"body\">\n            <div class=\"m-top-30 m-bottom-30 m-right-30\" style=\"min-height: 250px\">\n                <div class=\"row m-bottom-15\" v-for=\"(sales, index) in salesList\" v-show=\"isShowOrderSalesmen(index)\">\n                    <webadmin-salseman-branch-select :sales=\"sales\" :salsemen-list=\"salsemenList\" :site-list=\"siteList\" :is-level-select=\"getSelectList(index)\"></webadmin-salseman-branch-select>\n                </div>\n            </div>\n        </div>\n        <div slot=\"footer\">\n            <button type=\"button\" v-show=\"!ajaxing\" class=\"btn btn-default btn--inverse\" @click=\"closeModel\">取消</button>\n            <button type=\"button\" v-show=\"!ajaxing\" class=\"btn btn-info\" @click=\"save\">儲存更新</button>\n            <v-spinner-button :ajaxing=\"ajaxing\"></v-spinner-button>\n        </div>\n    </v-modal>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-16ba3081", module.exports)
  } else {
    hotAPI.update("_v-16ba3081", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1423:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.mx-datepicker {\n  width: 100%; }\n\n/* line 5, stdin */\n.schedule-date {\n  width: 100%; }\n\n/* line 8, stdin */\n.schedule-endtime-modal-calendar {\n  right: -20px; }\n\n/* line 11, stdin */\n.ck-content {\n  min-height: 115px !important; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        modalId: {
            default: 'schedule-modal'
        },
        studioId: {
            type: Number,
            default: null
        },
        branchId: {
            type: Number,
            default: null
        },
        mode: {
            type: String,
            default: ''
        },
        defaultStart: {
            type: Object,
            default: function _default() {
                return {};
            }
        },
        scheduleId: {
            default: null
        },
        defaultServiceId: {
            type: Number,
            default: null
        }
    },
    data: function data() {
        var today = moment().format('YYYY-MM-DD');
        var after30days = moment().add(30, 'days').format('YYYY-MM-DD');
        return {
            savingEditorData: false,
            ajaxing: {
                serviceList: false,
                trainerList: false,
                getServiceList: false,
                getSchedule: false,
                getLocation: false
            },
            templateData: {
                name: '',
                schedule_service: null,
                date: today,
                start_hour: '00',
                start_minute: '00',
                service_time: null,
                qty: null,
                price: null,
                trainer: null,
                description: '',
                html_description: '',
                notice: '',
                html_notice: '',
                unpaid_online_booking: 1,
                point_switch: 0,
                point: 0,
                is_recurring: 0,
                week_start_date: today,
                week_end_date: after30days,
                is_open: 1,
                week: [],
                third_party_marketing: 0,
                commission_rate: 0,
                default_member_id: 0,
                trainers: [],
                mainTrainer: null,
                enable_external_link: 0,
                before_external_link_object: {},
                after_external_link_object: {},
                before_default_external_link_id: null,
                after_default_external_link_id: null,
                booked_number: 0
            },
            postData: {
                name: '',
                schedule_service: null,
                date: today,
                start_hour: '00',
                start_minute: '00',
                service_time: null,
                qty: null,
                price: null,
                trainer: null,
                description: '',
                html_description: '',
                notice: '',
                html_notice: '',
                unpaid_online_booking: 1,
                point_switch: 0,
                point: 0,
                is_recurring: 0,
                week_start_date: today,
                week_end_date: after30days,
                is_open: 1,
                week: [],
                third_party_marketing: 0,
                commission_rate: 0,
                default_member_id: 0,
                trainers: [],
                mainTrainer: null,
                enable_external_link: 0,
                before_external_link_object: {},
                after_external_link_object: {},
                before_default_external_link_id: null,
                after_default_external_link_id: null,
                booked_number: 0,
                terminate_reason: 'Common',
                terminate_reason_description: null
            },
            editFile: [],
            serviceList: [],
            trainerList: [],
            availableEditField: {
                0: [],
                1: ['name', 'qty', 'html_description', 'html_notice', 'unpaid_online_booking', 'is_open'],
                2: ['*']
            },
            stopClass: false,
            trainerFresh: false,
            editTrainers: [],
            locationList: {},
            scheduleInit: false,
            scheduleList: {}
        };
    },
    mounted: function mounted() {
        this.getServiceList();
        if (this.studioId) {
            this.getLocation();
        }
    },

    watch: {
        branchId: function branchId(newVal) {
            this.getServiceList();
        },
        scheduleId: function scheduleId(newVal) {
            if (newVal == null) {
                return;
            }
            this.getScheduleData(newVal);
        },
        'postData.schedule_service': function postDataSchedule_service(newVal) {
            this.changeService(newVal);
        },
        'postData.type': function postDataType() {},
        'postData.point_switch': function postDataPoint_switch(newVal) {
            if (!newVal) {
                this.postData.point = 0;
            }
        },
        'postData.point': function postDataPoint(newVal) {
            if (newVal < 0) {
                this.postData.point = 0;
            }
        },
        'postData.price': function postDataPrice(newVal) {
            if (newVal < 0) {
                this.postData.price = 0;
            }
        },
        defaultStart: function defaultStart(date) {
            if (date == null) {
                return;
            }
            this.postData.date = date.format('YYYY-MM-DD');
            this.postData.start_hour = date.format('HH');
            this.postData.start_minute = date.format('mm');
        },
        studioId: function studioId(newVal) {
            this.getLocation();
        },
        defaultServiceGroup: function defaultServiceGroup(newVal) {
            if (newVal !== {}) {
                this.postData.schedule_service = newVal;
            }
        },
        mode: function mode(newVal) {
            if (!this.ajaxing.serviceList) {
                this.setServiceGroup();
            }
        }
    },
    computed: (0, _extends3.default)({
        editMode: function editMode() {
            return this.mode == 'update';
        },
        openHours: function openHours() {
            var range = [];
            for (var index = 0; index < 24; index++) {
                if (index < 10) {
                    range.push('0' + index);
                } else {
                    range.push(String(index));
                }
            }
            return range;
        },
        openMins: function openMins() {
            var range = [];
            for (var index = 0; index < 60; index = index + 5) {
                if (index < 10) {
                    range.push('0' + index);
                } else {
                    range.push(String(index));
                }
            }
            return range;
        },
        isEnded: function isEnded() {
            return this.editMode && moment(this.postData.date).hours(this.postData.start_hour).minutes(this.postData.start_minute).add(this.postData.service_time, 'minutes').diff(moment()) < 0;
        }
    }, (0, _vuex.mapState)({
        canDelete: function canDelete(state) {
            return state.webadmin.configure.webFunctions.WebadminScheduleDelete;
        },
        canEdit: function canEdit(state) {
            return state.webadmin.configure.webFunctions.WebadminScheduleIndex;
        }
    }), {
        locationName: function locationName() {
            if (!this.branchId) {
                return '';
            }
            return this.locationList[this.branchId];
        }
    }, (0, _vuex.mapState)('webadmin/configure', ['isSeventeen']), {
        modeName: function modeName() {
            return this.editMode ? '修改' : '新增';
        }
    }),
    methods: {
        getEditorDataAndSave: function getEditorDataAndSave(data) {
            this.postData.html_notice = data;
        },
        watchCkEditor: function watchCkEditor(data) {
            this.postData.html_notice = data;
        },
        getEditorDataAndSaveByDescription: function getEditorDataAndSaveByDescription(data) {
            this.postData.html_description = data;
        },
        watchCkEditorByDescription: function watchCkEditorByDescription(data) {
            this.postData.html_description = data;
        },
        editableFieldCHeck: function editableFieldCHeck(filedName) {
            var isOpen = this.postData.is_open;

            if (this.mode == '' || this.isEnded || this.scheduleList.is_open != 2 && this.editMode) {
                return true;
            }

            if (this.mode == 'add') {
                return false;
            }

            if (isOpen == 2 && this.postData.booked_number > 0) {
                isOpen = 1;
            }

            checkArray = this.availableEditField[isOpen];
            if (checkArray.indexOf(filedName) > -1 || checkArray.indexOf('*') > -1) {
                return false;
            }
            return true;
        },
        getServiceList: function getServiceList() {
            var _this = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!(_this.branchId === null)) {
                                    _context.next = 2;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 2:
                                _this.ajaxing.serviceList = true;
                                _context.next = 5;
                                return _this.$http.get('/adminapi/service/list/branch/' + _this.branchId + '?is_service=0').then(function (response) {
                                    this.serviceList = response.data;
                                    this.ajaxing.serviceList = false;
                                }, function (error) {
                                    _this.ajaxing.serviceList = false;
                                });

                            case 5:
                                _context.next = 7;
                                return _this.setServiceGroup();

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        changeService: function changeService(service) {
            var _this2 = this;

            if (this.scheduleInit || service == null || !service.id || this.postData.schedule_service == null) {
                this.scheduleInit = false;
                return;
            }
            this.ajaxing.getServiceList = true;
            this.$http.post('/webadmin/service/detail/' + service.id).then(function (response) {
                if (!response.data.success) {
                    $.notify('此課程不存在或已被刪除', { className: 'error', globalPosition: 'top center' });
                    return;
                }
                service = response.data.service;

                this.postData.service_time = service.service_time;
                this.postData.price = service.price;
                this.postData.point = service.point;
                this.postData.name = service.name;
                this.postData.html_notice = service.html_notice;
                this.postData.html_description = service.html_description;
                if (this.postData.point > 0) {
                    this.postData.point_switch = 1;
                }
                this.ajaxing.getServiceList = false;
            }, function (error) {
                _this2.ajaxing.getServiceList = false;
            });
        },
        deleteSchedule: function deleteSchedule() {
            var _this3 = this;

            var vm = this;
            $17.swal({
                title: "確定刪除",
                text: "您確定要刪除課表: " + this.postData.name,
                type: "warning"
            }, function (isConfirm) {
                if (!isConfirm) return;
                $.blockUI();
                _this3.$http.post('/webadmin/schedule/delete', {
                    schedule_id: vm.scheduleId
                }).then(function (response) {
                    $.unblockUI();
                    if (response.data.success) {
                        vm.$emit('remove-single-schedule', vm.scheduleId);
                        $('#' + _this3.modalId).modal('hide');
                        $.notify('刪除課表成功', { className: 'success', globalPosition: 'top center' });
                        vm.reset();
                        _this3.$emit('fresh');
                        $('#' + _this3.modalId).modal('hide');
                        return;
                    }
                    $.notify(response.data.msg, { className: 'error', globalPosition: 'top center' });
                    $('#' + _this3.modalId).modal('hide');
                }, function (error) {
                    $.unblockUI();
                    $17.swal({
                        title: '刪除失敗',
                        text: error.data.message,
                        type: 'error'
                    });
                });
            });
        },
        submitSchedule: function submitSchedule() {
            if (this.postData.is_open == 0) {
                this.stopSchedule();
                return;
            }
            this.directSubmit();
        },
        directSubmit: function directSubmit() {
            var _this4 = this;

            var checkState = this.validateData();
            if (!checkState) {
                return;
            }
            $.blockUI();
            this.$http.post('/webadmin/schedule/handler', this.constructData()).then(function (response) {
                $.unblockUI();
                if (response.data.success == false) {
                    $.notify(this.modeName + '失敗', { className: 'error', globalPosition: 'top center' });
                    return;
                }
                this.reset();
                $('#' + this.modalId).modal('hide');
                this.$emit('fresh');
                $.notify(this.modeName + '成功', { className: 'success', globalPosition: 'top center' });
            }, function (error) {
                $.notify(_this4.modeName + '失敗', { className: 'error', globalPosition: 'top center' });
                $.unblockUI();
                // $17.swal({
                //     title: '儲存失敗',
                //     text: error.data.message,
                //     type: 'error',
                // });
            });
        },
        constructData: function constructData() {
            data = _lodash2.default.clone(this.postData);
            if (this.editMode) {
                data.id = this.scheduleId;
            }
            data.date = moment(data.date).format('YYYY-MM-DD');
            data.week_start_date = moment(data.week_start_date).format('YYYY-MM-DD');
            data.week_end_date = moment(data.week_end_date).format('YYYY-MM-DD');
            data.mode = this.mode;
            data.service_id = this.postData.schedule_service.id;
            data.main_trainer = this.postData.mainTrainer;
            data.trainers = data.trainers.reduce(function (carry, trainer) {
                carry[trainer.id] = {
                    'member_id': trainer.id,
                    'salary_employee_related_id': trainer.selectSalary !== null && trainer.selectSalary.id !== undefined ? trainer.selectSalary.id : ''
                };
                return carry;
            }, {});
            delete data.before_external_link_object;
            delete data.after_external_link_object;

            data.before_external_link_id = this.postData.before_external_link_object.id ? this.postData.before_external_link_object.id : null;
            data.after_external_link_id = this.postData.after_external_link_object.id ? this.postData.after_external_link_object.id : null;

            return data;
        },
        validateData: function validateData() {
            var alert = '';
            var check = true;
            if (this.postData.name.length == 0) {
                alert += '請填寫顯示名稱<br>';
                check = false;
            }
            if (!this.postData.schedule_service || this.postData.schedule_service.id <= 0) {
                alert += '請選擇課程<br>';
                check = false;
            }
            if (!this.postData.date) {
                alert += '請填寫日期<br>';
                check = false;
            }
            if (!this.postData.service_time) {
                alert += '請填寫課程時間<br>';
                check = false;
            }
            if (this.postData.qty <= 0) {
                alert += '請填寫名額<br>';
                check = false;
            }
            if (this.postData.price < 0) {
                alert += '價格須為整數<br>';
                check = false;
            }
            if (this.postData.is_recurring && (!this.postData.week_start_date || !this.postData.week_end_date)) {
                alert += '周期課表未選擇開始日期或結束日期<br>';
                check = false;
            }

            if (!check) {
                this.showAlert(alert);
            }
            return check;
        },
        showAlert: function showAlert(text) {
            $17.swal({
                title: '請填寫必要欄位',
                html: text,
                type: 'error'
            });
        },
        reset: function reset() {
            this.postData = _lodash2.default.clone(this.templateData);
            this.stopClass = false;
            this.trainerFresh = true;
            this.editTrainers = [];
        },
        clearParent: function clearParent(event) {
            if (event) {
                if (event.target.id !== this.modalId) {
                    return;
                }
            }
            this.reset();
            this.$emit('clear');
        },
        getScheduleData: function getScheduleData() {
            var _this5 = this;

            this.scheduleInit = true;
            $.blockUI();
            this.ajaxing.getSchedule = true;
            this.$http.post('/webadmin/schedule/get', { 'id': this.scheduleId }).then(function (response) {
                this.reset();
                this.setEditData(response.data.schedule);
                if (response.data.msg) {
                    $.notify(resp.msg, { className: 'error', globalPosition: 'top center' });
                }
                this.scheduleList = response.data.schedule;
                this.ajaxing.getSchedule = false;
                $('#' + this.modalId).modal('show');
                $.unblockUI();
            }, function (error) {
                _this5.ajaxing.getSchedule = false;
                $.unblockUI();
                $17.swal({
                    title: '讀取課表錯誤',
                    html: '請重新整理後，再試一次。',
                    type: 'error'
                });
            });
        },
        setEditData: function setEditData(schedule) {
            this.postData.name = schedule.name;
            this.postData.schedule_service = {
                'id': schedule.service_id,
                'name': schedule.service_name
            };
            this.postData.date = moment(schedule.date).format('YYYY-MM-DD');
            this.postData.start_hour = schedule.time_start.substring(0, 2);
            this.postData.start_minute = schedule.time_start.substring(3, 5);
            this.postData.service_time = schedule.service_time;
            this.postData.qty = schedule.qty;
            this.postData.price = schedule.price;
            this.postData.service_time = schedule.service_time;
            this.postData.html_description = schedule.html_description;
            this.postData.html_notice = schedule.html_notice;
            this.postData.unpaid_online_booking = schedule.unpaid_online_booking;
            this.postData.point_switch = schedule.point > 0 ? 1 : 0;
            this.postData.point = schedule.point;
            this.postData.is_recurring = 0;
            this.postData.week_start_date = null;
            this.postData.week_end_date = null;
            this.postData.is_open = schedule.is_open;
            this.postData.week = [];
            this.postData.third_party_marketing = 0;
            this.postData.commission_rate = 0;
            this.postData.enable_external_link = schedule.enable_external_link;
            this.postData.before_default_external_link_id = schedule.before_default_external_link_id;
            this.postData.after_default_external_link_id = schedule.after_default_external_link_id;
            this.editTrainers = schedule.trainer_salary_settings;
            this.postData.booked_number = schedule.booked_number;
            this.postData.terminate_reason = schedule.terminate_reason != null ? schedule.terminate_reason : 'Common';
            this.postData.terminate_reason_description = schedule.terminate_reason_description;
            if (schedule.is_open == 0) {
                this.stopClass = true;
            }
        },
        setTrainer: function setTrainer(data) {
            this.postData.trainers = data.trainers;
            this.postData.mainTrainer = data.mainTrainer;
        },
        stopSchedule: function stopSchedule() {
            var _this6 = this;

            var vm = this;
            $17.swal({
                title: "請確認是否停課？",
                html: '<br><span class="text-danger">*系統會將已訂課的會員退課<br>並發送停課通知信</span>',
                type: "warning"
            }, function (isConfirm) {
                if (isConfirm) {
                    _this6.directSubmit();
                }
            });
        },
        freshTrainer: function freshTrainer() {
            this.trainerFresh = false;
        },
        getLocation: function getLocation() {
            var _this7 = this;

            if (!this.studioId || (0, _keys2.default)(this.locationList).length > 0 && !this.isSeventeen) {
                return;
            }
            this.ajaxing.getLocation = true;
            this.locationList = {};
            this.$http.get('/adminapi/locations/name-list/studio/' + this.studioId).then(function (response) {
                _this7.locationList = response.data;
                _this7.ajaxing.getLocation = false;
            }, function (error) {
                _this7.ajaxing.getLocation = false;
                $17.swal({
                    title: '讀取地點列表失敗',
                    type: 'error'
                });
            });
        },
        setServiceGroup: function setServiceGroup() {
            var _this8 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                var group;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!(!_this8.defaultServiceId || _this8.mode != 'add')) {
                                    _context2.next = 2;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 2:
                                group = _this8.serviceList.reduce(function (carry, serviceItem) {
                                    if (_this8.defaultServiceId == serviceItem.id) {
                                        carry = serviceItem;
                                    }
                                    return carry;
                                }, {});

                                _this8.postData.schedule_service = group;

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this8);
            }))();
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div>\n    <v-modal :id=\"modalId\" :close-modal-event=\"clearParent\" v-if=\"canEdit\">\n        <div slot=\"title\">\n            <h4>\n                {{ modeName }}課表\n                <v-admin-operate-record v-if=\"editMode\" type=\"schedule\" :id=\"scheduleId\"></v-admin-operate-record>\n            </h4>\n        </div>\n        <div slot=\"body\"> \n            <div class=\"row form-group\">\n                <div class=\"field-lab col-sm-3\">\n                    <label class=\"control-label\">地點</label>\n                </div>\n                <div class=\"col-sm-8\">\n                    <label class=\"control-label\" v-show=\"!ajaxing.getLocation\">\n                        {{ locationName  }}\n                    </label>\n                    <v-spinner-button :ajaxing=\"ajaxing.getLocation\"></v-spinner-button>\n                </div>\n            </div>\n\n            <div class=\"row form-group\">\n                <div class=\"field-lab col-sm-3\">\n                    <label class=\"control-label\" for=\"service_id\">課程</label>\n                </div>\n                <div class=\"col-sm-8\">\n                    <v-mutiselect v-show=\"!ajaxing.getServiceList\" id=\"service_id\" :disabled=\"editableFieldCHeck('schedule_service') || defaultServiceId != null\" :model.sync=\"postData.schedule_service\" :options=\"serviceList\" :preserve-search=\"true\" :placeholder=\"ajaxing.serviceList ? '服務讀取中…' : '請選擇服務'\" label=\"name\" track-by=\"id\"> \n                    </v-mutiselect>\n                     <v-spinner-button :ajaxing=\"ajaxing.getServiceList\"></v-spinner-button>\n                </div>\n            </div>\n            <div class=\"row form-group\">\n                <div class=\"field-lab col-sm-3\">\n                    <label for=\"name\" class=\"control-label\">顯示名稱</label>\n                    <a href=\"javascript:void(0)\">\n                        <i class=\"fa fa-question-circle\" help=\"線上預約時, 客戶會看到的名稱\"></i>\n                    </a>\n                </div>\n                <div class=\"col-sm-8\">\n                    <input type=\"text\" name=\"\" class=\"form-control\" v-model=\"postData.name\" :disabled=\"editableFieldCHeck('name')\">\n                </div>\n            </div>\n            <div class=\"row form-group\">\n                <div class=\"field-lab col-sm-3 col-md-3\">\n                    <label for=\"date\" class=\"control-label\">日期與時間</label>\n                </div>\n                <div class=\"col-sm-3 col-md-3\">\n                    <v-date-picker input-class=\"schedule-date\" v-model=\"postData.date\" placeholder=\"開始日期\" :disabled=\"editableFieldCHeck('date')\"></v-date-picker>\n                </div>\n                <div class=\"col-sm-3 col-md-3\">\n                    <select class=\"form-control\" v-model=\"postData.start_hour\" :disabled=\"editableFieldCHeck('start_hour')\">\n                        <option v-for=\"n in openHours\">{{ n }}</option>\n                    </select>\n                </div>\n                <div class=\"col-sm-3 col-md-3\">\n                    <select class=\"form-control\" v-model=\"postData.start_minute\" :disabled=\"editableFieldCHeck('start_minute')\">\n                        <option v-for=\"n in openMins\">{{ n }}</option>\n                    </select>\n                </div>\n            </div>\n            <div class=\"row form-group\">\n                <div class=\"field-lab col-sm-3\">\n                    <label for=\"service_time\" class=\"control-label\">課程時間</label>\n                </div>\n                <div class=\"col-sm-3\">\n                    <input type=\"number\" id=\"service_time\" class=\"form-control\" placeholder=\"課程時間\" :disabled=\"editableFieldCHeck('service_time')\" v-model=\"postData.service_time\">\n                </div>\n                <label for=\"service_time\" class=\"col-sm-2 control-label\">分鐘</label>\n            </div>\n            <div class=\"row form-group\">\n                <div class=\"field-lab col-sm-3\">\n                    <label for=\"qty\" class=\"control-label\">名額</label>\n                </div>\n                <div class=\"col-sm-3\">\n                    <div class=\"input-group qty-group\">\n                        <input type=\"number\" id=\"qty\" class=\"form-control\" placeholder=\"可預約人數\" v-model.number=\"postData.qty\" :disabled=\"editableFieldCHeck('qty')\">\n                        <div class=\"input-group-addon\">人</div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"row form-group\">\n                <div class=\"field-lab col-sm-3\">\n                    <label for=\"price\" class=\"control-label\">價格</label>\n                    <a href=\"javascript:void(0)\"><i class=\"fa fa-question-circle\" help=\"單堂售價\"></i></a>\n                </div>\n                <div class=\"col-xs-5 col-sm-4 hide-in-edit-mode\">\n                    <div class=\"input-group\">\n                        <input type=\"number\" id=\"price\" class=\"form-control\" placeholder=\"請輸入金額\" v-model.number=\"postData.price\" :disabled=\"editableFieldCHeck('price')\">\n                        <div class=\"input-group-addon\">元</div>\n                    </div>\n                </div>\n                <div class=\"col-sm-3 show-in-edit-mode\">\n                </div>\n            </div>\n            <div class=\"row form-group\">\n                <div class=\"field-lab col-sm-3\">\n                    <label for=\"description\" class=\"control-label\">人員</label>\n                </div>\n                <div class=\"col-sm-8\">\n                    <webadmin-schedule-trainer-salary :studio-id=\"studioId\" :branch-id=\"branchId\" :fresh=\"trainerFresh\" v-on:trainers=\"setTrainer\" v-on:freshed=\"freshTrainer\" :edit-trainers=\"editTrainers\"></webadmin-schedule-trainer-salary>\n                </div>\n            </div>\n            <div class=\"row form-group\">\n                <div class=\"field-lab col-sm-3\">\n                    <label for=\"html_description\" class=\"control-label\">課程介紹</label>\n                </div>\n                <div class=\"col-sm-8\">\n                    <ck-editor :click-save=\"savingEditorData\" :init-editor-data=\"postData.html_description\" @update-ck-editor-data=\"getEditorDataAndSaveByDescription\" @watch-ck-editor=\"watchCkEditorByDescription\" :disabled=\"editableFieldCHeck('html_description')\" :toolbar=\"[]\" data-paste-as-text=\"\"></ck-editor>\n                </div>\n            </div>\n            <div class=\"row form-group\">\n                <div class=\"field-lab col-sm-3\">\n                    <label for=\"html_notice\" class=\"control-label\">注意事項</label>\n                </div>\n                <div class=\"col-sm-8\">\n                    <ck-editor :click-save=\"savingEditorData\" :init-editor-data=\"postData.html_notice\" @update-ck-editor-data=\"getEditorDataAndSave\" @watch-ck-editor=\"watchCkEditor\" :disabled=\"editableFieldCHeck('html_notice')\" :toolbar=\"[]\" data-paste-as-text=\"\"></ck-editor>\n                </div>\n            </div>\n            <div class=\"row form-group\">\n                <div class=\"field-lab col-sm-3\">\n                    <label for=\"unpaid_online_booking\" class=\"control-label\">未付款的預約</label>\n                    <a href=\"javascript:void(0)\"><i class=\"fa fa-question-circle\" help=\"是否允許客戶在線上先預約，到現場再付款\"></i></a>\n                </div>\n                <div class=\"col-sm-8\" style=\"padding-left:0px\">\n                    <div class=\"col-xs-12\">\n                        <v-vue-switch v-model=\"postData.unpaid_online_booking\" id=\"effective_days_switch\" :disabled=\"editableFieldCHeck('unpaid_online_booking')\"></v-vue-switch>\n                    </div>\n                </div>\n            </div>\n            <div class=\"row form-group\">\n                <div class=\"field-lab col-sm-3\">\n                    <label for=\"point\" class=\"control-label\">消耗點數</label>\n                    <a href=\"javascript:void(0)\"><i class=\"fa fa-question-circle\" help=\"如果有點數型的方案，對應到這堂課會消耗多少點數\"></i></a>\n                </div>\n                <div class=\"col-sm-8\" style=\"padding-left:0px\">\n                    <div class=\"col-xs-4\">\n                        <v-vue-switch v-model=\"postData.point_switch\" id=\"point_switch\" :disabled=\"editableFieldCHeck('point_switch')\"></v-vue-switch> \n                    </div>\n                    <div class=\"col-xs-8\">\n                        <div id=\"point-group\" class=\"input-group\" v-show=\"postData.point_switch\">\n                            <input class=\"form-control hide-in-edit-mode\" placeholder=\"請輸入點數\" id=\"point\" v-model=\"postData.point\" :disabled=\"editableFieldCHeck('point')\" name=\"point\" type=\"number\">\n                            <div class=\"input-group-addon\">點</div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div id=\"recurring_select_block\" class=\"row form-group hide-in-edit-mode\" v-if=\"!editMode\">\n                <div class=\"field-lab col-sm-3\">\n                    <label for=\"is_recurring\" class=\"control-label\">周期課表</label>\n                </div>\n                <div class=\"col-sm-3\">\n                    <select id=\"is_recurring\" class=\"form-control valid\" name=\"is_recurring\" aria-invalid=\"false\" :disabled=\"editableFieldCHeck('is_recurring')\" v-model=\"postData.is_recurring\">\n                        <option value=\"0\">否</option>\n                        <option value=\"1\">是</option>\n                    </select>\n                </div>\n            </div>\n            <div class=\"row form-group\" v-show=\"postData.is_recurring==1 \">\n                <label class=\"control-label\"></label>\n                <div class=\"col-sm-8 col-sm-offset-3\">\n                    <div class=\"col-sm-5\" style=\"padding:0px;\">\n                        <v-date-picker v-model=\"postData.week_start_date\" placeholder=\"開始日期\"></v-date-picker>\n                    </div>\n                    <div class=\"col-sm-offset-2 col-sm-5\" style=\"padding:0px;\">\n                        <v-date-picker v-model=\"postData.week_end_date\" placeholder=\"結束日期\"></v-date-picker>\n                    </div>\n                    <div class=\"col-sm-12\">\n                        <div class=\"col-sm-12\">\n                            <div class=\"checkbox-toggle\">\n                                <label for=\"monday\">周一</label>\n                                <input id=\"monday\" name=\"week[]\" v-model=\"postData.week\" type=\"checkbox\" value=\"monday\">\n                            </div>\n                            <div class=\"checkbox-toggle\">\n                                <label for=\"tuesday\">周二</label>\n                                <input id=\"tuesday\" name=\"week[]\" v-model=\"postData.week\" type=\"checkbox\" value=\"tuesday\">\n                            </div>\n                            <div class=\"checkbox-toggle\">\n                                <label for=\"wednesday\">周三</label>\n                                <input id=\"wednesday\" name=\"week[]\" v-model=\"postData.week\" type=\"checkbox\" value=\"wednesday\">\n                            </div>\n                            <div class=\"checkbox-toggle\">\n                                <label for=\"thursday\">周四</label>\n                                <input id=\"thursday\" name=\"week[]\" v-model=\"postData.week\" type=\"checkbox\" value=\"thursday\">\n                            </div>\n                            <div class=\"checkbox-toggle\">\n                                <label for=\"friday\">周五</label>\n                                <input id=\"friday\" name=\"week[]\" v-model=\"postData.week\" type=\"checkbox\" value=\"friday\">\n                            </div>\n                            <div class=\"checkbox-toggle\">\n                                <label for=\"saturday\">周六</label>\n                                <input id=\"saturday\" name=\"week[]\" v-model=\"postData.week\" type=\"checkbox\" value=\"saturday\">\n                            </div>\n                            <div class=\"checkbox-toggle\">\n                                <label for=\"sunday\">周日</label>\n                                <input id=\"sunday\" name=\"week[]\" v-model=\"postData.week\" type=\"checkbox\" value=\"sunday\">\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"row form-group\">\n                <div class=\"field-lab col-sm-3\">\n                    <label for=\"is_open\" class=\"control-label\">狀態</label>\n                </div>\n                <div class=\"col-sm-4\">\n                    <select id=\"is_open\" class=\"col-sm-12 form-control\" name=\"type\" v-model=\"postData.is_open\" :disabled=\"stopClass\" v-show=\"!isEnded\">\n                        <option value=\"1\">上架</option>\n                        <option value=\"0\" v-if=\"editMode\">停課</option>\n                        <option value=\"2\">終止訂課</option>\n                    </select>\n                    <label for=\"\" v-show=\"isEnded\">已結束</label>\n                </div>\n            </div>\n            <div v-show=\"postData.is_open == 0\">\n                <div class=\"row form-group\">\n                    <div class=\"field-lab col-sm-3\">\n                        <label for=\"terminate_reason\" class=\"control-label\">停課原因</label>\n                    </div>\n                    <div class=\"col-sm-4\">\n                        <select id=\"terminate_reason\" class=\"col-sm-12 form-control\" name=\"terminate_reason\" v-model=\"postData.terminate_reason\" :disabled=\"stopClass\">\n                            <option value=\"Common\">因故停開</option>\n                            <option value=\"MemberIsNotEnough\">開課人數不足</option>\n                            <option value=\"WeatherTooBad\">天氣因素</option>\n                        </select>\n                    </div>\n                </div>\n                <div class=\"row form-group\">\n                    <div class=\"field-lab col-sm-3\">\n\n                    </div>\n                    <div class=\"col-sm-4\">\n                        <textarea id=\"terminate_reason_description\" class=\"form-control\" maxlength=\"100\" placeholder=\"停課原因\" v-model=\"postData.terminate_reason_description\" :disabled=\"stopClass\"></textarea>\n                    </div>\n                </div>\n            </div>\n            <div class=\"row m-left-0\">\n                <edit-live-link-btn-with-modal :schedule-id=\"scheduleId\" :btn-disabled=\"!editMode\"></edit-live-link-btn-with-modal>\n            </div>\n            <div class=\"form-group\">\n                <div class=\"group-input\">\n                    <label for=\"name\">\n                        \n                    </label>\n                    <div>\n                        <div>\n                            <label>\n                                <input type=\"checkbox\" v-bind:true-value=\"1\" v-bind:false-value=\"0\" v-model=\"postData.enable_external_link\"> 顯示外部連結按鈕\n                            </label>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"group-input\" v-show=\"postData.enable_external_link\">\n                    <label for=\"name\">\n                        \n                    </label>\n                    <div>\n                        預約前\n                        <v-select-external-link-item :studio-id=\"studioId\" v-model=\"postData.before_external_link_object\" :default-id=\"postData.before_default_external_link_id\"></v-select-external-link-item>\n                    </div>\n                </div>\n                <div class=\"group-input\" v-show=\"postData.enable_external_link\">\n                    <label for=\"name\">\n                        \n                    </label>\n                    <div>\n                        預約後\n                        <v-select-external-link-item :studio-id=\"studioId\" v-model=\"postData.after_external_link_object\" :default-id=\"postData.after_default_external_link_id\"></v-select-external-link-item>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div slot=\"footer\">\n            <div style=\"float:left;width:20%;\">\n                <a class=\"btn btn-danger\" v-show=\"editMode &amp;&amp; !stopClass &amp;&amp; !isEnded &amp;&amp; canDelete\" @click.prevent.stop=\"deleteSchedule\">\n                    <i class=\"fa fa-trash\"></i> 刪除課表\n                </a>\n            </div>\n            <div style=\"float:right;width:80%;\">\n                <a class=\"btn btn-primary\" @click.prevent.stop=\"submitSchedule\">送出</a>\n            </div>\n        </div>\n    </v-modal>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.mx-datepicker {\n  width: 100%; }\n\n/* line 5, stdin */\n.schedule-date {\n  width: 100%; }\n\n/* line 8, stdin */\n.schedule-endtime-modal-calendar {\n  right: -20px; }\n\n/* line 11, stdin */\n.ck-content {\n  min-height: 115px !important; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-97cddec6", module.exports)
  } else {
    hotAPI.update("_v-97cddec6", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/object/keys":56,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1424:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _editModal = require('./edit-modal.vue');

var _editModal2 = _interopRequireDefault(_editModal);

var _trainerSalary = require('./trainer-salary.vue');

var _trainerSalary2 = _interopRequireDefault(_trainerSalary);

var _vScheduleFilter = require('./v-schedule-filter.vue');

var _vScheduleFilter2 = _interopRequireDefault(_vScheduleFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('webadmin-schedule-edit-modal', _editModal2.default);
_vue2.default.component('webadmin-schedule-trainer-salary', _trainerSalary2.default);
_vue2.default.component('v-schedule-filter', _vScheduleFilter2.default);

},{"./edit-modal.vue":1423,"./trainer-salary.vue":1425,"./v-schedule-filter.vue":1426,"vue":792}],1425:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.trainer-item[_v-eca9d856] {\n  border: 1px solid #eee;\n  font-size: 0.875rem;\n  /* font-weight: bold; */\n  padding: 10px 20px;\n  margin-top: 1em;\n  border-radius: 5px; }\n  /* line 9, stdin */\n  .trainer-item .row[_v-eca9d856] {\n    margin-top: 10px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            trainers: [],
            ajaxing: false,
            mainTrainer: null
        };
    },
    props: {
        studioId: {
            type: Number,
            default: null
        },
        branchId: {
            type: Number,
            default: null
        },
        fresh: {
            default: false
        },
        editTrainers: {
            default: []
        }
    },
    watch: {
        trainers: {
            deep: true,
            handler: function handler(val, oldVal) {
                this.changeVal();
            }
        },
        mainTrainer: function mainTrainer() {
            this.changeVal();
        },
        fresh: function fresh(newVal) {
            if (newVal) {
                this.trainers = [];
                this.mainTrainer = null;
                this.$emit('freshed');
            }
        },
        editTrainers: function editTrainers(newVal) {
            if (!newVal.settings) {
                return;
            }
            if (!newVal.mainTrainer) {
                newVal.mainTrainer = 0;
            }
            this.trainers = newVal.settings;
            this.mainTrainer = newVal.mainTrainer;
        }
    },
    computed: {
        selectedTrainers: function selectedTrainers() {
            return this.trainers.map(function (trainer) {
                return trainer.id;
            });
        }
    },
    methods: {
        appendTrainer: function appendTrainer(trainer) {
            var _this = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                var salaries, defaultSalary, newTrainer;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!_this.checkExistTrainers(trainer)) {
                                    _context.next = 2;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 2:
                                salaries = [];
                                _context.next = 5;
                                return _this.getTrainerSalary(trainer.id);

                            case 5:
                                salaries = _context.sent;
                                defaultSalary = salaries.find(function (salary) {
                                    return salary.is_default === 1;
                                });
                                newTrainer = {
                                    id: trainer.id,
                                    name: trainer.name,
                                    salaries: salaries,
                                    selectSalary: defaultSalary ? defaultSalary : ''
                                };

                                _this.trainers.push(newTrainer);
                                if (_this.trainers.length == 1) {
                                    _this.mainTrainer = trainer.id;
                                }

                            case 10:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        getTrainerSalary: function getTrainerSalary(memberId) {
            var _this2 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _this2.ajaxing = true;
                                return _context2.abrupt('return', _this2.$http.get('/adminapi/salary/schedule/member/' + memberId + '/branch/' + _this2.branchId).then(function (response) {
                                    this.ajaxing = false;
                                    return response.data.settings;
                                }, function (error) {
                                    _this2.ajaxing = false;
                                }));

                            case 2:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        checkExistTrainers: function checkExistTrainers(trainer) {
            return this.selectedTrainers.indexOf(trainer.id) > -1 ? true : false;
        },
        removeTrainer: function removeTrainer(trainerId) {
            if (this.mainTrainer == trainerId) {
                this.mainTrainer = null;
            }

            var arrayKet = null;
            arrayKey = this.trainers.reduce(function (carry, tr, index) {
                if (tr.id == trainerId) {
                    carry = index;
                }
                return carry;
            }, null);
            this.trainers.splice(arrayKey, 1);
        },
        changeVal: function changeVal() {
            this.$emit('trainers', {
                'trainers': this.trainers,
                'mainTrainer': this.mainTrainer
            });
        }
    },
    mounted: function mounted() {
        if (this.fresh) {
            this.trainers = [];
            this.mainTrainer = null;
            this.$emit('freshed');
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-eca9d856=\"\">\n    <div class=\"trainer-select row\" _v-eca9d856=\"\">\n        <div class=\"col-sm-8\" _v-eca9d856=\"\">\n            <v-trainer-selector v-if=\"branchId\" v-show=\"!ajaxing\" :studio-id=\"studioId\" :branch-id=\"branchId\" :force-fetch=\"1\" @trainer-select=\"appendTrainer\" min-width=\"200px\" :reset-after=\"true\" :searchable=\"true\" _v-eca9d856=\"\"></v-trainer-selector>\n            <v-spinner-button :ajaxing=\"ajaxing\" _v-eca9d856=\"\"></v-spinner-button>\n        </div>\n    </div>\n    <div v-for=\"(trainer,key ) in trainers\" :key=\"key\" class=\"trainer-item\" _v-eca9d856=\"\">\n        <div class=\"row\" _v-eca9d856=\"\">\n            <div class=\"col-xs-3\" _v-eca9d856=\"\">名稱</div>\n            <div class=\"col-xs-9 text-right\" _v-eca9d856=\"\">\n                {{ trainer.name }}\n            </div>\n        </div>\n        <div class=\"row\" _v-eca9d856=\"\">\n            <div class=\"col-xs-3\" _v-eca9d856=\"\">薪資</div>\n            <div class=\"col-xs-9 text-right\" _v-eca9d856=\"\">\n                <v-mutiselect :model.sync=\"trainer.selectSalary\" :options=\"trainer.salaries\" :preserve-search=\"true\" label=\"name\" track-by=\"id\" tag-name=\"name\" placeholder=\"請選擇薪資\" _v-eca9d856=\"\">\n                </v-mutiselect>\n            </div>\n        </div>\n        <div class=\"row\" _v-eca9d856=\"\">\n            <div class=\"col-xs-3\" _v-eca9d856=\"\">\n                <a href=\"\" @click.prevent.stop=\"removeTrainer(trainer.id)\" _v-eca9d856=\"\">移除人員</a>\n            </div>\n            <div class=\"col-xs-9 text-right\" _v-eca9d856=\"\">\n                <input type=\"checkbox\" :true-value=\"trainer.id\" :false-value=\"null\" :id=\"'main'+trainer.id\" v-model=\"mainTrainer\" _v-eca9d856=\"\">\n                <label :for=\"'main'+trainer.id\" _v-eca9d856=\"\">設為主要人員</label>\n            </div>\n        </div>\n    </div>\n</div>    \n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.trainer-item[_v-eca9d856] {\n  border: 1px solid #eee;\n  font-size: 0.875rem;\n  /* font-weight: bold; */\n  padding: 10px 20px;\n  margin-top: 1em;\n  border-radius: 5px; }\n  /* line 9, stdin */\n  .trainer-item .row[_v-eca9d856] {\n    margin-top: 10px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-eca9d856", module.exports)
  } else {
    hotAPI.update("_v-eca9d856", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1426:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.schedule-filter-container[_v-70330cf4] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  margin-left: 10px; }\n\n/* line 7, stdin */\n.filterToggleBtn[_v-70330cf4] {\n  display: none; }\n\n/* line 11, stdin */\n.form-group .select-group[_v-70330cf4] {\n  width: 100%;\n  max-width: 400px;\n  min-width: 150px;\n  display: inline-block; }\n\n@media (min-width: 768px) {\n  /* line 19, stdin */\n  .form-group[_v-70330cf4] {\n    padding-right: 10px; } }\n\n@media (max-width: 480px) {\n  /* line 24, stdin */\n  #vue-schedule-filter[_v-70330cf4] {\n    width: -webkit-fill-available; }\n  /* line 27, stdin */\n  .filterToggleBtn[_v-70330cf4] {\n    display: block;\n    position: absolute;\n    right: 20px;\n    width: 76px;\n    padding: 10px;\n    transform: translateY(10px); }\n    /* line 34, stdin */\n    .filterToggleBtn div[_v-70330cf4] {\n      cursor: pointer;\n      font-size: 13px;\n      color: #555555; }\n  /* line 40, stdin */\n  .schedule-filter-container[_v-70330cf4] {\n    display: -ms-grid;\n    display: grid;\n    -ms-grid-columns: 1fr 1fr;\n        grid-template-columns: 1fr 1fr;\n    -ms-grid-rows: 1fr 1fr;\n        grid-template-rows: 1fr 1fr;\n    margin-top: 50px;\n    grid-gap: 5px;\n    margin-right: 20px;\n    margin-left: 20px;\n    opacity: 1;\n    transition: opacity 0.3s; }\n    /* line 50, stdin */\n    .schedule-filter-container.hidden-dropdown[_v-70330cf4] {\n      opacity: 0;\n      height: 0;\n      z-index: -999;\n      position: absolute; }\n    /* line 56, stdin */\n    .schedule-filter-container .form-group[_v-70330cf4] {\n      margin-bottom: 0; } }\n\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        changeStatus: {
            type: Function
        }
    },
    data: function data() {
        return {
            branch_id: '',
            defaultStudioId: 0,
            disableStatus: false,
            toggleFilter: true,
            selected_service_providers: {
                name: '全部人員',
                id: 0,
                role_relationship_id: 0
            },
            selected_type: { id: 'all', name: '全部類別' },
            selected_status: { id: 'all', name: '全部狀態' },

            service_providers: [{ id: 0, name: '全部人員' }],
            schedule_type: [],
            postData: {}
        };
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('webadmin/configure', ['ACTIVE_STUDIO_ID']), (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId', 'isSeventeen', 'isStudio', 'isBranch', 'isServiceProvider']), (0, _vuex.mapState)({
        userMemberId: function userMemberId(state) {
            return state.user_member_id;
        }
    }), {
        schedule_status: function schedule_status() {
            if (this.selected_type.id === 'all') {
                this.disableStatus = true;
                this.selected_status = { id: 'all', name: '全部狀態' };
                return [this.selected_status];
            } else {
                this.disableStatus = false;
                return this.selected_type.status;
            };
        }
    }),
    watch: {
        isSeventeen: function isSeventeen(newVal) {
            if (newVal) {
                var query = $17.getUrlQueryStrings();
                this.defaultStudioId = query.hasOwnProperty('studio_id') ? Number(query['studio_id']) : 286;
            };
        },
        isStudio: function isStudio(newVal) {
            if (newVal) {
                var query = $17.getUrlQueryStrings();
                var defaultBranch = query.hasOwnProperty('branch_id') ? Number(query['branch_id']) : 0;
                this.getBindBranch(defaultBranch);
            }
        },
        isBranch: function isBranch(newVal) {
            if (newVal) {
                this.getBindBranch(this.branchId);
            }
        },
        isServiceProvider: function isServiceProvider(newVal) {
            if (newVal) {
                this.syncCurrentQueryStatus();
                this.emitStatusChange();
            };
        }
    },
    mounted: function mounted() {
        this.fetchScheduleEnums();
    },

    methods: {
        fetchScheduleEnums: function fetchScheduleEnums() {
            var _this = this;

            this.$http.get('/adminapi/dashboard/status_enums').then(function (res) {
                _this.formatEnums(res.data);
            });
        },
        formatEnums: function formatEnums(data) {
            var classStatus = [{ id: 'all', name: '全部狀態' }];
            var sbStatus = [{ id: 'all', name: '全部狀態' }];
            (0, _keys2.default)(data.class).map(function (value) {
                switch (value) {
                    case '2':
                        classStatus.push({ id: value, name: data.class[value], style: 'isGreen' });
                        break;
                    case '4':
                        classStatus.push({ id: value, name: data.class[value], style: '' });
                        break;
                    case '5':
                        classStatus.push({ id: value, name: data.class[value], style: '' });
                        break;
                    default:
                        classStatus.push({ id: value, name: data.class[value], style: 'isRed' });
                };
            });
            (0, _keys2.default)(data.service_booking).map(function (value) {
                switch (value) {
                    case 'unstart':
                        sbStatus.push({ id: value, name: data.service_booking[value], style: 'isRed' });
                        break;
                    default:
                        sbStatus.push({ id: value, name: data.service_booking[value], style: '' });
                };
            });
            var types = [{ id: 'all', name: '全部類別' }, { id: 'class', name: '課程', status: classStatus }, { id: 'service_booking', name: '服務', status: sbStatus }];
            this.schedule_type = types;
            this.updateFilterSelectedItemByQuery(this.schedule_type, 'schedule_type', 'selected_type');
            this.updateFilterSelectedItemByQuery(this.schedule_status, 'schedule_type_status', 'selected_status');
            window.Event.$emit('Schedule.StatusListStyle.Fetched', types);
        },
        getBindBranch: function getBindBranch(id) {
            this.branch_id = id;
            this.syncCurrentQueryStatus();
            this.updateQueryStrings(this.postData);
            this.fetchServiceProvider();
        },
        getBindStudio: function getBindStudio(id) {
            this.getBindBranch(0);
        },
        fetchServiceProvider: function fetchServiceProvider() {
            var _this2 = this;

            this.$http.post('/webadmin/trainer/get_trainer', {
                branch_id: this.branch_id
            }).then(function (response) {
                var data = response.data.data;
                data.unshift({
                    name: '全部人員',
                    id: 0,
                    role_relationship_id: 0
                });
                _this2.service_providers = data;
                if (_this2.isServiceProvider) {
                    var sp = data.find(function (item) {
                        return item.id == _this2.user_member_id;
                    });
                    _this2.selected_service_providers = sp;
                } else {
                    _this2.updateFilterSelectedItemByQuery(data, 'member_id', 'selected_service_providers');
                };
                _this2.postData.member_id = _this2.selected_service_providers.id;
                _this2.postData.role_relationship_id = _this2.selected_service_providers.role_relationship_id;
                _this2.emitStatusChange();
            }).catch(function (error) {});
        },
        updateFilterSelectedItemByQuery: function updateFilterSelectedItemByQuery(list, query_key, selected_item) {
            var query = $17.getUrlQueryStrings();
            var item = list.find(function (item) {
                return item.id == query[query_key];
            });
            if (item) {
                this[selected_item] = item;
            } else {
                this[selected_item] = list[0];
            };
        },
        openFilter: function openFilter() {
            this.toggleFilter = !this.toggleFilter;
        },
        syncCurrentQueryStatus: function syncCurrentQueryStatus() {
            var query = $17.getUrlQueryStrings();
            this.postData = {
                branch_id: this.branch_id ? this.branch_id : 0,
                studio_id: this.ACTIVE_STUDIO_ID,
                member_id: query.hasOwnProperty('member_id') ? query.member_id : 0,
                role_relationship_id: query.hasOwnProperty('role_relationship_id') ? query.role_relationship_id : 0,
                schedule_type: query.hasOwnProperty('schedule_type') ? query.schedule_type : 'all',
                schedule_type_status: query.hasOwnProperty('schedule_type_status') ? query.schedule_type_status : 'all'
            };
        },
        updateQueryStrings: function updateQueryStrings(query) {
            var urlQuery = $17.getUrlQueryStrings();
            for (var param in query) {
                if (query[param].toString() == '0') {
                    delete urlQuery[param];
                } else {
                    urlQuery[param] = query[param].toString();
                }
            }
            var newQueryString = $17.queryStringBuilder(urlQuery);
            history.replaceState({}, null, '?' + newQueryString);
        },
        selectServiceProvider: function selectServiceProvider(selectedOption, id) {
            this.postData.member_id = selectedOption.id ? selectedOption.id : 0;
            this.postData.role_relationship_id = selectedOption.role_relationship_id ? selectedOption.role_relationship_id : 0;
            this.emitStatusChange();
        },
        selectType: function selectType(selectedOption, id) {
            this.postData.schedule_type = selectedOption.id;
            this.postData.schedule_type_status = 'all';
            this.selected_status = this.schedule_status[0];
            this.emitStatusChange();
        },
        selectStatus: function selectStatus(selectedOption, id) {
            this.postData.schedule_type_status = selectedOption.id;
            this.emitStatusChange();
        },
        emitStatusChange: function emitStatusChange() {
            this.updateQueryStrings(this.postData);
            this.changeStatus && this.changeStatus(this.postData);
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div id=\"vue-schedule-filter\" _v-70330cf4=\"\">\n    <div class=\"filterToggleBtn\" @click.prevent=\"openFilter\" _v-70330cf4=\"\">\n        <div _v-70330cf4=\"\">\n            <i class=\"fa fa-filter fa-lg\" _v-70330cf4=\"\"></i>\n            <span _v-70330cf4=\"\">篩選</span>\n            <i class=\"fa fa-sort-down\" v-if=\"toggleFilter\" _v-70330cf4=\"\"></i>\n            <i class=\"fa fa-sort-up\" v-else=\"\" _v-70330cf4=\"\"></i>\n        </div>\n    </div>\n    <div class=\"schedule-filter-container\" :class=\"{'hidden-dropdown': toggleFilter}\" _v-70330cf4=\"\">\n            <v-multiselect-studio-and-branch v-if=\"!isServiceProvider\" :studio_id=\"studioId\" :branch_id=\"branchId\" :default_studio_id=\"defaultStudioId\" :default_branch_id=\"branch_id\" :branch-without-filtered-option=\"true\" :branch-change-call-back=\"getBindBranch\" :studio-change-call-back=\"getBindStudio\" _v-70330cf4=\"\"></v-multiselect-studio-and-branch>\n            <div class=\"form-group\" v-if=\"!isServiceProvider\" _v-70330cf4=\"\">\n                <div class=\"select-group\" _v-70330cf4=\"\">\n                    <v-mutiselect :model.sync=\"selected_service_providers\" :options=\"service_providers\" :multiple=\"false\" :close-on-select=\"true\" :clear-on-select=\"true\" :searchable=\"false\" :allow-empty=\"false\" :select-event-append=\"selectServiceProvider\" label=\"name\" track-by=\"id\" tag-name=\"name\" placeholder=\"請選擇人員\" class=\"m-bottom-10\" _v-70330cf4=\"\"></v-mutiselect>                    \n                </div>\n            </div>\n            <div class=\"form-group\" _v-70330cf4=\"\">\n                <div class=\"select-group\" _v-70330cf4=\"\">\n                    <v-mutiselect :model.sync=\"selected_type\" :options=\"schedule_type\" :multiple=\"false\" :close-on-select=\"true\" :clear-on-select=\"true\" :searchable=\"false\" :allow-empty=\"false\" :select-event-append=\"selectType\" label=\"name\" track-by=\"id\" tag-name=\"name\" placeholder=\"請選擇類別\" class=\"m-bottom-10\" _v-70330cf4=\"\"></v-mutiselect>                    \n                </div>\n            </div>\n            <div class=\"form-group\" _v-70330cf4=\"\">\n                <div class=\"select-group\" _v-70330cf4=\"\">\n                    <v-mutiselect :model.sync=\"selected_status\" :options=\"schedule_status\" :multiple=\"false\" :close-on-select=\"true\" :clear-on-select=\"true\" :searchable=\"false\" :allow-empty=\"false\" :select-event-append=\"selectStatus\" label=\"name\" track-by=\"id\" tag-name=\"name\" placeholder=\"請選擇狀態\" class=\"m-bottom-10\" :disabled=\"disableStatus\" _v-70330cf4=\"\"></v-mutiselect>                    \n                </div>\n            </div>      \n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.schedule-filter-container[_v-70330cf4] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  margin-left: 10px; }\n\n/* line 7, stdin */\n.filterToggleBtn[_v-70330cf4] {\n  display: none; }\n\n/* line 11, stdin */\n.form-group .select-group[_v-70330cf4] {\n  width: 100%;\n  max-width: 400px;\n  min-width: 150px;\n  display: inline-block; }\n\n@media (min-width: 768px) {\n  /* line 19, stdin */\n  .form-group[_v-70330cf4] {\n    padding-right: 10px; } }\n\n@media (max-width: 480px) {\n  /* line 24, stdin */\n  #vue-schedule-filter[_v-70330cf4] {\n    width: -webkit-fill-available; }\n  /* line 27, stdin */\n  .filterToggleBtn[_v-70330cf4] {\n    display: block;\n    position: absolute;\n    right: 20px;\n    width: 76px;\n    padding: 10px;\n    transform: translateY(10px); }\n    /* line 34, stdin */\n    .filterToggleBtn div[_v-70330cf4] {\n      cursor: pointer;\n      font-size: 13px;\n      color: #555555; }\n  /* line 40, stdin */\n  .schedule-filter-container[_v-70330cf4] {\n    display: -ms-grid;\n    display: grid;\n    -ms-grid-columns: 1fr 1fr;\n        grid-template-columns: 1fr 1fr;\n    -ms-grid-rows: 1fr 1fr;\n        grid-template-rows: 1fr 1fr;\n    margin-top: 50px;\n    grid-gap: 5px;\n    margin-right: 20px;\n    margin-left: 20px;\n    opacity: 1;\n    transition: opacity 0.3s; }\n    /* line 50, stdin */\n    .schedule-filter-container.hidden-dropdown[_v-70330cf4] {\n      opacity: 0;\n      height: 0;\n      z-index: -999;\n      position: absolute; }\n    /* line 56, stdin */\n    .schedule-filter-container .form-group[_v-70330cf4] {\n      margin-bottom: 0; } }\n\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-70330cf4", module.exports)
  } else {
    hotAPI.update("_v-70330cf4", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/object/keys":56,"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1427:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _saleContract = require('./sale-contract.vue');

var _saleContract2 = _interopRequireDefault(_saleContract);

var _openingSchedule = require('./opening-schedule.vue');

var _openingSchedule2 = _interopRequireDefault(_openingSchedule);

var _quickViewModal = require('./quick-view-modal.vue');

var _quickViewModal2 = _interopRequireDefault(_quickViewModal);

var _searchMember = require('./search-member.vue');

var _searchMember2 = _interopRequireDefault(_searchMember);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('webadmin-sale-contract', _saleContract2.default);
_vue2.default.component('webadmin-opening-schedule', _openingSchedule2.default);
_vue2.default.component('webadmin-quick-view-modal', _quickViewModal2.default);
_vue2.default.component('webadmin-multi-search-member', _searchMember2.default);

},{"./opening-schedule.vue":1428,"./quick-view-modal.vue":1429,"./sale-contract.vue":1430,"./search-member.vue":1431,"vue":792}],1428:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        serviceId: {
            type: Number,
            default: 0
        },
        forceUpdateList: {
            type: Boolean,
            default: false
        },
        serviceIsActive: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            list: [],
            title: '已排定課表',
            view: {
                ajaxing: false
            }
        };
    },

    watch: {
        serviceId: function serviceId(newVal) {
            if (newVal) {
                this.fetchData();
            }
        },
        forceUpdateList: function forceUpdateList(newVal) {
            if (newVal) {
                this.fetchData();
                this.$emit('reset-force');
            }
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        scheduleCanEdit: function scheduleCanEdit(state) {
            return state.webadmin.configure.webFunctions.WebadminScheduleIndex;
        }
    })),
    methods: {
        fetchData: function fetchData() {
            var _this = this;

            this.view.ajaxing = true;
            this.$http.get('/adminapi/service/' + this.serviceId + '/schedule').then(function (response) {
                this.list = response.data;
                this.view.ajaxing = false;
            }, function (error) {
                _this.view.ajaxing = false;
            });
        },
        newSchedule: function newSchedule() {
            this.$emit('new-schedule', { 'service': this.serviceId });
        },
        openSchedule: function openSchedule(schedule) {
            if (!this.scheduleCanEdit) {
                return;
            }
            this.$emit('edit-schedule', schedule);
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-60db44ca=\"\">\n    <v-spinner :ajaxing=\"view.ajaxing\" _v-60db44ca=\"\"></v-spinner>\n    <v-title-list-two v-show=\"!view.ajaxing\" :title=\"title\" :list=\"list\" :enable-click=\"scheduleCanEdit\" @click=\"openSchedule\" _v-60db44ca=\"\">\n        <template slot=\"right-button\">\n            <input type=\"button\" value=\"新增課表\" class=\"btn btn-success\" @click=\"newSchedule\" v-if=\"scheduleCanEdit&amp;&amp;serviceIsActive\" _v-60db44ca=\"\">\n        </template>\n    </v-title-list-two>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-60db44ca", module.exports)
  } else {
    hotAPI.update("_v-60db44ca", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vuex":803}],1429:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.right-border[_v-80b6a1d8] {\n  border-right: 1px solid #eee; }\n\n/* line 5, stdin */\n.left-border[_v-80b6a1d8] {\n  border-left: 1px solid #eee; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        serviceId: {
            type: Number,
            default: 0
        },
        title: {
            type: String,
            default: ''
        },
        studioId: {
            type: Number,
            default: null
        },
        branchId: {
            type: Number,
            default: null
        },
        serviceIsActive: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            contracts: [],
            nowAction: '',
            scheduleMode: '',
            ajaxing: {
                list: false
            },
            forceUpdate: {
                contract: false,
                schedule: false
            },
            scheduleId: null,
            contractId: null
        };
    },
    mounted: function mounted() {},

    watch: {
        ACTIVE_STUDIO_ID: function ACTIVE_STUDIO_ID(newVal) {
            if (newVal) {
                this.getContractList();
            }
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['user_studio_id', 'user_branch_id']), (0, _vuex.mapGetters)('webadmin/configure', ['ACTIVE_STUDIO_ID', 'ACTIVE_BRANCH_ID']), (0, _vuex.mapState)({
        canCreateContract: function canCreateContract(state) {
            return state.webadmin.configure.webFunctions.WebadminContractCreate;
        }
    }), {
        currentBranchId: function currentBranchId() {
            return this.ACTIVE_BRANCH_ID > 0 ? this.ACTIVE_BRANCH_ID : 0;
        }
    }),
    methods: {
        clearService: function clearService() {
            this.$emit('clear-service');
        },
        getContractList: function getContractList() {
            var _this = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                var params;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.ajaxing.list = true;

                                params = {
                                    studio_id: _this.user_studio_id,
                                    branch_id: -1,
                                    actived: 1
                                };


                                _this.$http.get('/adminapi/contract', { params: params }).then(function (response) {
                                    _this.contracts = response.data;
                                    _this.ajaxing.list = false;
                                }, function (error) {
                                    _this.ajaxing.list = false;
                                    $17.swal({
                                        title: '讀取失敗。',
                                        type: 'error'
                                    });
                                });

                            case 3:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        newContract: function newContract(serviceId) {
            if (!this.ajaxing.list) {
                this.nowAction = 'create';
                $('#contract-modal').modal('show');
            }
        },
        newSchedule: function newSchedule(service) {
            this.scheduleMode = 'add';
            $('#schedule-modal').modal('show');
        },
        resetContract: function resetContract() {
            this.nowAction = '';
            this.contractId = null;
        },
        fetchContractList: function fetchContractList() {
            this.forceUpdate.contract = true;
        },
        resetSchedule: function resetSchedule() {
            this.scheduleMode = '';
            this.scheduleId = null;
        },
        editSchedule: function editSchedule(schedule) {
            this.scheduleMode = 'update';
            this.scheduleId = schedule.id;
            $('#schedule-modal').modal('show');
        },
        editContract: function editContract(contract) {
            if (!this.ajaxing.list) {
                this.nowAction = 'update';
                this.contractId = contract.id;
            }
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-80b6a1d8=\"\">\n    <v-modal id=\"service-quick-view-modal\" no-footer=\"\" open-size=\"modal-lg\" :body-class=\"['p-bottom-0']\" :close-modal-event=\"clearService\" _v-80b6a1d8=\"\">\n        <div slot=\"title\" _v-80b6a1d8=\"\">{{ title }}</div>\n        <div slot=\"body\" _v-80b6a1d8=\"\">\n            <div class=\"row\" _v-80b6a1d8=\"\">\n                <div class=\"col-xs-6 right-border\" _v-80b6a1d8=\"\">\n                    <webadmin-opening-schedule :service-id=\"serviceId\" @new-schedule=\"newSchedule\" @edit-schedule=\"editSchedule\" :force-update-list=\"forceUpdate.schedule\" @reset-force=\"forceUpdate.schedule=false\" :service-is-active=\"serviceIsActive\" _v-80b6a1d8=\"\"></webadmin-opening-schedule>\n                </div>\n                <div class=\"col-xs-6 left-border\" _v-80b6a1d8=\"\">\n                    <webadmin-sale-contract :service-id=\"serviceId\" @new-contract=\"newContract\" :force-update-list=\"forceUpdate.contract\" @reset-force=\"forceUpdate.contract=false\" @edit-contract=\"editContract\" :service-is-active=\"serviceIsActive\" _v-80b6a1d8=\"\"></webadmin-sale-contract>\n                </div>\n            </div>\n        </div>\n    </v-modal>\n\n    <webadmin-contract-modal v-if=\"studioId &amp;&amp; !ajaxing.list\" :studio-id=\"studioId\" :branch-id=\"branchId\" :contracts=\"contracts\" :now-action=\"nowAction\" :category-id=\"null\" :service-id=\"serviceId\" :current-id=\"contractId\" @fetch-list=\"getContractList\" @close=\"resetContract\" @fetch-new=\"fetchContractList\" _v-80b6a1d8=\"\"></webadmin-contract-modal>\n\n    <webadmin-schedule-edit-modal :studio-id=\"studioId\" :branch-id=\"branchId\" :mode=\"scheduleMode\" :default-service-id=\"serviceId\" v-on:clear=\"resetSchedule\" v-on:fresh=\"forceUpdate.schedule=true\" :schedule-id=\"scheduleId\" _v-80b6a1d8=\"\"></webadmin-schedule-edit-modal>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.right-border[_v-80b6a1d8] {\n  border-right: 1px solid #eee; }\n\n/* line 5, stdin */\n.left-border[_v-80b6a1d8] {\n  border-left: 1px solid #eee; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-80b6a1d8", module.exports)
  } else {
    hotAPI.update("_v-80b6a1d8", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1430:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        serviceId: {
            type: Number,
            default: 0
        },
        forceUpdateList: {
            default: false
        },
        serviceIsActive: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            list: [],
            title: '銷售方案',
            view: {
                ajaxing: false
            }
        };
    },

    watch: {
        serviceId: function serviceId(newVal) {
            if (newVal) {
                this.fetchData();
            }
        },
        forceUpdateList: function forceUpdateList(newVal) {
            if (newVal) {
                this.fetchData();
            }
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        canCreateContract: function canCreateContract(state) {
            return state.webadmin.configure.webFunctions.WebadminContractCreate;
        },
        contractCanEdit: function contractCanEdit(state) {
            return state.webadmin.configure.webFunctions.WebadminContractUpdate;
        }
    })),
    methods: {
        fetchData: function fetchData() {
            var _this = this;

            this.view.ajaxing = true;
            this.$http.get('/adminapi/service/' + this.serviceId + '/contract').then(function (response) {
                this.list = response.data;
                this.view.ajaxing = false;
            }, function (error) {
                _this.view.ajaxing = false;
            });
            this.$emit('reset-force');
        },
        newContract: function newContract() {
            this.$emit('new-contract', { 'service': this.serviceId });
        },
        openContract: function openContract(contract) {
            if (!this.contractCanEdit) {
                return;
            }
            this.$emit('edit-contract', contract);
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-4cfc078e=\"\">\n    <v-spinner :ajaxing=\"view.ajaxing\" _v-4cfc078e=\"\"></v-spinner>\n    <v-title-list-two v-show=\"!view.ajaxing\" :title=\"title\" :list=\"list\" :enable-click=\"contractCanEdit\" @click=\"openContract\" _v-4cfc078e=\"\">\n        <template slot=\"right-button\">\n            <input type=\"button\" value=\"新增方案\" class=\"btn btn-success\" v-if=\"canCreateContract&amp;&amp;serviceIsActive\" @click=\"newContract\" _v-4cfc078e=\"\">\n        </template>\n    </v-title-list-two>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-4cfc078e", module.exports)
  } else {
    hotAPI.update("_v-4cfc078e", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vuex":803}],1431:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n/* line 3, stdin */\n.block-div.control-box.open .body-div {\n  overflow: visible; }\n\n/* line 6, stdin */\n.block-div.control-box.open .multiselect__input, .block-div.control-box.open .multiselect__single {\n  position: inherit; }\n\n/* line 11, stdin */\n.multiselect__option--highlight, .multiselect__option--highlight:after {\n  background-color: #5293F6; }\n\n/* line 3, stdin */\n.multiselect__tags .custom__tag[_v-c972e180] {\n  background-color: #ddd;\n  padding: 2px 5px 2px 5px;\n  border: #aaa 1px solid;\n  border-radius: 5px;\n  margin: 0px 5px 5px 0px;\n  display: inline-block; }\n\n/* line 13, stdin */\n.multiselect__tags .fa.fa-times[_v-c972e180] {\n  color: #aaa;\n  cursor: pointer; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vueMultiselect = require('vue-multiselect');

var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { Multiselect: _vueMultiselect2.default },
  props: {
    memberChange: {},
    keep: {
      default: false
    },
    clearWhenSelect: {
      default: false
    },
    allowClear: {
      default: false
    },
    loading: {
      default: false
    }
  },
  data: function data() {
    return {
      memberList: [],
      selectMember: {},
      ajaxing: false,
      isOpen: false,
      disabled: false,
      label: 'seach_name',
      searchDelay: ''
    };
  },

  methods: {
    openMultiselect: function openMultiselect(id) {
      this.isOpen = true;
    },
    closeMultiselect: function closeMultiselect(value, id) {
      this.isOpen = false;
    },
    getMember: function getMember(query, initMode) {
      var vm = this;
      this.searchDelay = setTimeout(function () {
        vm.getSearchMember(query, initMode);
      }, 1000);
    },
    memberChangeAction: function memberChangeAction(selectedOption, id) {
      var _this = this;

      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                $('input[name="member_id"]').val(selectedOption.id);
                $('input[name="name"]').val(selectedOption.name);
                $('input[name="email"]').val(selectedOption.email);
                $('input[name="phone"]').val(selectedOption.phone);
                $('#name_label').html(selectedOption.name);
                $('#email_label').html(selectedOption.email);
                $('#phone_label').html(selectedOption.phone);
                _context.next = 9;
                return _this.memberOnlineBookingStatus(selectedOption, id);

              case 9:
                _context.next = 11;
                return _this.memberChange;

              case 11:
                _context.t0 = _context.sent;

                if (!_context.t0) {
                  _context.next = 14;
                  break;
                }

                _this.memberChange(_this.selectMember);

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getSearchMember: function getSearchMember(query, initMode) {
      var _this2 = this;

      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        var schedule_id, formData;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                schedule_id = $('#schedule_id').val();

                if (!(schedule_id === '' || schedule_id === null || schedule_id === 0 || schedule_id === '0')) {
                  _context2.next = 5;
                  break;
                }

                _this2.memberList = [];
                $17.swal({
                  type: 'error',
                  title: '請先選擇一個課表！',
                  showConfirmButton: true,
                  showCancelButton: false,
                  confirmButtonText: "確定"
                });
                return _context2.abrupt('return');

              case 5:
                ;

                _this2.label = 'name';
                formData = new FormData();

                _this2.ajaxing = true;
                formData.append('per_page', 50);
                if (!initMode) {
                  formData.append('q', query);
                };

                _context2.next = 14;
                return _this2.$http.post('/webadmin/member_studio/get_customers', formData, {
                  headers: { 'Content-Type': 'multipart/form-data' }
                }).then(function (response) {
                  _this2.memberList = response.data.customers;
                  _this2.ajaxing = false;
                }, function (error) {
                  _this2.ajaxing = false;
                });

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    memberOnlineBookingStatus: function memberOnlineBookingStatus(selectedOption, id) {
      var _this3 = this;

      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (selectedOption) {
                  _this3.selectMember = selectedOption;
                  _this3.disabled = true;
                  $('.add_new_member').attr('disabled', 'true');
                  _this3.$http.get('/adminapi/member/' + selectedOption.id + '/status').then(function (response) {
                    var memberOnlineBookingStatus = response.data.member_status.hasOwnProperty('online_booking') ? response.data.member_status.online_booking : 1;
                    if (memberOnlineBookingStatus === 0) {
                      $('#member-online-booking-status').removeClass('hidden');
                    } else {
                      $('#member-online-booking-status').addClass('hidden');
                    }
                    window.Event.$emit('search-member-success', _this3.selectMember);

                    _this3.disabled = false;
                    $('.add_new_member').removeAttr("disabled");
                  }, function (error) {
                    _this3.disabled = false;
                    $('.add_new_member').removeAttr("disabled");
                    $17.swal({
                      type: 'error',
                      title: '無法取得會員的狀態',
                      showConfirmButton: true,
                      showCancelButton: false,
                      confirmButtonText: "確定"
                    });
                  });
                };

              case 2:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    }
  },
  computed: {},
  watch: {
    isOpen: function isOpen(newVal) {
      if (newVal) {
        this.getSearchMember('', true);
      }
    },
    searchDelay: function searchDelay(newVal, oldVal) {
      clearTimeout(oldVal);
    }
  }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-c972e180=\"\">\n  <div class=\"search-member\" _v-c972e180=\"\">\n    <multiselect :options=\"memberList\" label=\"name\" track-by=\"id\" :multiple=\"false\" :searchable=\"true\" :hide-selected=\"true\" :clear-on-select=\"true\" :close-on-select=\"true\" :options-limit=\"300\" placeholder=\"請選擇\" select-label=\"\" @select=\"memberChangeAction\" @search-change=\"getMember\" @open=\"openMultiselect\" @close=\"closeMultiselect\" :disabled=\"disabled\" :loading=\"ajaxing\" :internal-search=\"false\" _v-c972e180=\"\">\n      <template slot=\"option\" slot-scope=\"{ option }\">\n        <div class=\"option__desc\" _v-c972e180=\"\">\n            <div class=\"option__title\" _v-c972e180=\"\">\n              <b class=\"fa fa-user\" style=\"margin-right:5px\" _v-c972e180=\"\"></b>\n              {{option.name}} \n            </div>\n            <div class=\"option__title\" _v-c972e180=\"\">{{option.phone}} </div>\n            <div class=\"option__small\" _v-c972e180=\"\">{{option.email}} </div>\n        </div>\n      </template>\n    </multiselect>\n  </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n/* line 3, stdin */\n.block-div.control-box.open .body-div {\n  overflow: visible; }\n\n/* line 6, stdin */\n.block-div.control-box.open .multiselect__input, .block-div.control-box.open .multiselect__single {\n  position: inherit; }\n\n/* line 11, stdin */\n.multiselect__option--highlight, .multiselect__option--highlight:after {\n  background-color: #5293F6; }\n\n/* line 3, stdin */\n.multiselect__tags .custom__tag[_v-c972e180] {\n  background-color: #ddd;\n  padding: 2px 5px 2px 5px;\n  border: #aaa 1px solid;\n  border-radius: 5px;\n  margin: 0px 5px 5px 0px;\n  display: inline-block; }\n\n/* line 13, stdin */\n.multiselect__tags .fa.fa-times[_v-c972e180] {\n  color: #aaa;\n  cursor: pointer; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-c972e180", module.exports)
  } else {
    hotAPI.update("_v-c972e180", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vue-multiselect":787,"vueify/lib/insert-css":799,"vuex":803}],1432:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n#service-booking-modal-buttons[_v-61ed6f97] {\n  padding: 15px;\n  text-align: right;\n  border-top: 1px solid #e5e5e5; }\n  /* line 6, stdin */\n  #service-booking-modal-buttons .btn--disabled[_v-61ed6f97] {\n    opacity: 0.7;\n    pointer-events: none; }\n  @media (max-width: 480px) {\n    /* line 11, stdin */\n    #service-booking-modal-buttons .btn[_v-61ed6f97] {\n      margin-bottom: 10px; } }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        currentBookingId: {
            type: Number,
            default: 0,
            required: true
        },
        buttonStatus: {
            type: Object,
            required: true
        },
        showBill: {
            type: Boolean,
            default: false
        },
        action: {
            type: String,
            default: 'view'
        },
        disableSubmit: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {};
    },
    mounted: function mounted() {},

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        canEdit: function canEdit(state) {
            return state.webadmin.configure.webFunctions.hasOwnProperty('WebadminService-bookingsEdit');
        },
        canCreate: function canCreate(state) {
            return state.webadmin.configure.webFunctions.hasOwnProperty('WebadminService-bookingsCreate');
        },
        canBill: function canBill(state) {
            return state.webadmin.configure.webFunctions.hasOwnProperty('WebadminService-bookingsBill');
        }
    }), {
        isAttend: function isAttend() {
            return this.buttonStatus.show_checked_attend === 1;
        },
        isAbsence: function isAbsence() {
            return this.buttonStatus.show_checked_absence === 1;
        }
    }),
    methods: {
        create: function create() {
            this.$emit('create-booking');
        },
        update: function update() {
            var _this = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                var isBilled;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this.checkOrderIdBilled();

                            case 2:
                                isBilled = _context.sent;

                                if (!isBilled) {
                                    _context.next = 5;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 5:
                                _this.$emit('update-booking');

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        bill: function bill() {
            var _this2 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                var isBilled;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return _this2.checkOrderIdBilled();

                            case 2:
                                isBilled = _context2.sent;

                                if (!isBilled) {
                                    _context2.next = 5;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 5:
                                _this2.$emit('bill-booking');

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        changeServiceBookingStatus: function changeServiceBookingStatus(status) {
            var _this3 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
                var isBilled, updateWithChangeStatus, alertCancelStatus, vm, statusText;
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                if (!([0, 4, 7].indexOf(status) == -1 || [0, 4, 7].indexOf(status) !== -1 && _this3.action !== 'view')) {
                                    _context3.next = 6;
                                    break;
                                }

                                _context3.next = 3;
                                return _this3.checkOrderIdBilled();

                            case 3:
                                isBilled = _context3.sent;

                                if (!isBilled) {
                                    _context3.next = 6;
                                    break;
                                }

                                return _context3.abrupt('return');

                            case 6:
                                updateWithChangeStatus = [4, 7, 0]; // 這些狀態需要同步儲存表格內容

                                alertCancelStatus = [5, 6];

                                if (updateWithChangeStatus.indexOf(status) > -1 && _this3.action === 'update') {
                                    _this3.$emit('update-booking', status);
                                } else if (alertCancelStatus.indexOf(status) > -1) {
                                    //取消要先跳警告再更新
                                    vm = _this3;
                                    statusText = {
                                        5: '請確認是否<span style="color:#d33">無條件取消</span>此次預約？',
                                        6: '請確認是否<span style="color:#d33">取消</span>此次預約？'
                                    };

                                    $17.swal({
                                        html: statusText[status],
                                        type: 'warning',
                                        showCancelButton: true
                                    }, function (isConfirm) {
                                        if (isConfirm) {
                                            vm.updateServiceBookingStatus(status);
                                        }
                                    });
                                } else {
                                    //單純改狀態
                                    _this3.updateServiceBookingStatus(status);
                                }

                            case 9:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3);
            }))();
        },
        updateServiceBookingStatus: function updateServiceBookingStatus(status) {
            var _this4 = this;

            this.$http.post('/adminapi/service-bookings/change-status/' + this.currentBookingId, { status: status }).then(function (response) {
                if (response.data.status == 1) {
                    $17.swal({
                        title: '服務預約更新成功',
                        type: 'success',
                        showCancelButton: false
                    });
                } else {
                    $17.swal({
                        title: '服務預約更新失敗',
                        text: response.data.message,
                        type: 'error',
                        showCancelButton: false
                    });
                }
                _this4.actionDone(status);
                _this4.$emit('refresh');
            }).catch(function (response) {
                $17.swal({
                    title: '服務預約更新失敗',
                    type: 'error',
                    showCancelButton: false
                });
            });
        },
        actionDone: function actionDone(status) {
            var event = '';
            switch (status) {
                case 0:
                    if (this.isAttend) {
                        event = 'System.Booking.Attend-Canceled';
                    } else {
                        event = 'System.Booking.Absence-Canceled';
                    }
                    break;
                case 4:
                    event = 'System.Booking.Absence';
                    break;
                case 5:
                    event = 'System.Booking.Canceled';
                    break;
                case 6:
                    event = 'System.Booking.Canceled';
                    break;
                case 7:
                    event = 'System.Booking.Attended';
                    break;
            }
            window.Event.$emit(event, this.currentBookingId);
        },
        checkOrderIdBilled: function checkOrderIdBilled() {
            var _this5 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
                var isBilled;
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return _this5.$http.get('/adminapi/service-bookings/check_billed/' + _this5.currentBookingId).then(function (response) {
                                    return response.data.status;
                                }).catch(function (response) {
                                    $17.swal({
                                        title: '查詢服務是否已結帳錯誤',
                                        type: 'error',
                                        showCancelButton: false
                                    });
                                });

                            case 2:
                                isBilled = _context4.sent;


                                if (isBilled) {
                                    $17.swal({
                                        title: '無法更新服務預約',
                                        text: '此服務預約的訂單已完成結帳',
                                        type: 'error',
                                        showCancelButton: false
                                    }, function () {
                                        _this5.$emit('order-billed');
                                    });
                                }
                                return _context4.abrupt('return', isBilled);

                            case 5:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this5);
            }))();
        },
        openOperateOrder: function openOperateOrder() {
            var _this6 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5() {
                var isBilled;
                return _regenerator2.default.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return _this6.checkOrderIdBilled();

                            case 2:
                                isBilled = _context5.sent;

                                if (!isBilled) {
                                    _context5.next = 5;
                                    break;
                                }

                                return _context5.abrupt('return');

                            case 5:
                                _this6.$emit('bill-operate-booking');

                            case 6:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this6);
            }))();
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div id=\"service-booking-modal-buttons\" class=\"row\" _v-61ed6f97=\"\">\n    <button v-if=\"canBill&amp;&amp;showBill&amp;&amp;action==='update'\" @click.prevent=\"openOperateOrder\" type=\"button\" class=\"btn btn-primary pull-left m-right-5\" :disabled=\"disableSubmit\" _v-61ed6f97=\"\">\n        結帳\n    </button>\n    <div v-if=\"action==='update'\" _v-61ed6f97=\"\">\n        <button v-if=\"buttonStatus.show_cancel_button===1\" @click.prevent=\"changeServiceBookingStatus(6)\" type=\"button\" class=\"btn btn-danger pull-left m-right-5\" _v-61ed6f97=\"\">\n            取消\n        </button>\n        <button @click.prevent=\"changeServiceBookingStatus(5)\" type=\"button\" class=\"btn btn-danger pull-left m-right-5\" id=\"btn-cancel-service-booking\" _v-61ed6f97=\"\">\n            無條件取消\n        </button>\n    </div>\n    <div v-if=\"buttonStatus.show_attend_absence_buttons===1\" _v-61ed6f97=\"\">\n        <div @click.prevent=\"changeServiceBookingStatus(isAttend?0:7)\" class=\"btn pull-left m-right-5\" :class=\"{\n                'btn-success': isAttend,\n                'btn-default': !isAttend,\n                'btn--disabled':disableSubmit\n             }\" _v-61ed6f97=\"\">\n            <i class=\"fa fa-check-square-o\" v-if=\"isAttend\" _v-61ed6f97=\"\"></i>\n            <i class=\"fa fa-square-o\" v-else=\"\" _v-61ed6f97=\"\"></i>\n            出席\n        </div>\n        <div @click.prevent=\"changeServiceBookingStatus(isAbsence?0:4)\" class=\"btn pull-left\" :class=\"{\n                'btn-danger': isAbsence,\n                'btn-default': !isAbsence,\n                'btn--disabled':disableSubmit\n             }\" _v-61ed6f97=\"\">\n            <i class=\"fa fa-check-square-o\" v-if=\"isAbsence\" _v-61ed6f97=\"\"></i>\n            <i class=\"fa fa-square-o\" v-else=\"\" _v-61ed6f97=\"\"></i>\n            缺席\n        </div>\n    </div>\n    <button v-if=\"canEdit&amp;&amp;action==='update'\" @click=\"update\" type=\"button\" class=\"btn btn-primary\" :disabled=\"disableSubmit\" _v-61ed6f97=\"\">儲存</button>\n    <button v-if=\"canCreate&amp;&amp;action==='create'\" @click.prevent=\"create\" type=\"button\" class=\"btn btn-primary\" :disabled=\"disableSubmit\" _v-61ed6f97=\"\">新增</button>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n#service-booking-modal-buttons[_v-61ed6f97] {\n  padding: 15px;\n  text-align: right;\n  border-top: 1px solid #e5e5e5; }\n  /* line 6, stdin */\n  #service-booking-modal-buttons .btn--disabled[_v-61ed6f97] {\n    opacity: 0.7;\n    pointer-events: none; }\n  @media (max-width: 480px) {\n    /* line 11, stdin */\n    #service-booking-modal-buttons .btn[_v-61ed6f97] {\n      margin-bottom: 10px; } }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-61ed6f97", module.exports)
  } else {
    hotAPI.update("_v-61ed6f97", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1433:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.search-member[_v-02068c42] {\n  margin: 0; }\n\n/* line 6, stdin */\n.booking-alert div[_v-02068c42] {\n  text-align: center;\n  border-radius: 4px;\n  padding: 9px; }\n\n/* line 11, stdin */\n.booking-alert .ajaxing[_v-02068c42] {\n  background: #E2E3E5;\n  border: 1px solid #D6D8DB; }\n\n/* line 15, stdin */\n.booking-alert .result[_v-02068c42] {\n  background: #FCD9A4;\n  border: 1px solid #FFEEBA;\n  color: #9B6006; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {},
    data: function data() {
        return {
            view: {
                member_allow_online_booking: 1,
                action: 'update',
                ajaxing: false,
                booking: {},
                group_services: {},
                staffs: {},
                contract_list: {},
                service_prices: {},
                total_money: {},
                currentBookingId: 0,
                button_status: {
                    show_cancel_button: 0,
                    show_attend_absence_buttons: 0,
                    show_checked_attend: 0,
                    show_checked_absence: 0
                }
            },
            postData: {
                studio_id: 0,
                branch_id: 0,
                member_id: 0,
                role_relationship_id: '',
                start_time: '',
                start_date: '',
                has_batch_booking: false,
                batch_start_date: '',
                batch_end_date: '',
                has_batch_day_1: false,
                has_batch_day_2: false,
                has_batch_day_3: false,
                has_batch_day_4: false,
                has_batch_day_5: false,
                has_batch_day_6: false,
                has_batch_day_7: false,
                batch_day_1_time: '',
                batch_day_2_time: '',
                batch_day_3_time: '',
                batch_day_4_time: '',
                batch_day_5_time: '',
                batch_day_6_time: '',
                batch_day_7_time: '',
                notice: '',
                services: []
            },
            total_service_time: 0,
            create_member: {
                status: false,
                name: '',
                phone: '',
                email: ''
            },
            show_bill: false,
            inspectBookingAvailable: {},
            modalReady: false,
            timeoutId: '',
            bookingDebounceTimer: 1200
        };
    },
    mounted: function mounted() {
        var vm = this;
        this.getConfigTimer();

        $('#date').datetimepicker({
            format: 'YYYY-MM-DD',
            locale: 'zh-tw'
        }).on("dp.change", function (e) {
            vm.postData.start_date = $(this).val();
            vm.checkBookingAvaliable();
        });

        $('#batch_start_date').datetimepicker({
            format: 'YYYY-MM-DD',
            locale: 'zh-tw'
        }).on("dp.change", function (e) {
            vm.postData.batch_start_date = $(this).val();
        });
        $(this.$el).find('#service-select').on('select2:select', function (e) {
            var duplicate = vm.postData.services.filter(function (service) {
                if (service.id === e.params.data.id) {
                    return true;
                }
            });
            if (duplicate.length === 0) {
                vm.serviceOnChange(e.params.data);
            }
        });
        $('#batch_end_date').datetimepicker({
            format: 'YYYY-MM-DD',
            locale: 'zh-tw'
        }).on("dp.change", function (e) {
            vm.postData.batch_end_date = $(this).val();
        });
        $('#edit-booking-form.form-horizontal .listening-click').on('click', function (e) {
            vm.checkBookingAvaliable();
        });
    },
    destroyed: function destroyed() {
        $('#edit-booking-form.form-horizontal .listening-click').off('click');
    },

    computed: {
        total: function total() {
            this.show_bill = false;
            var hasOneMoneyBuy = false;
            var total = 0;
            for (var sId in this.postData.services) {
                if (this.postData.services[sId].contract == 0) {
                    total += parseInt(this.postData.services[sId].price);
                    hasOneMoneyBuy = true;
                }
            }
            if (total >= 0 && hasOneMoneyBuy) {
                this.show_bill = true;
            }
            return total;
        },
        time_picker: function time_picker() {
            return $17.getTimePicker(15);
        },
        isDisabledBatchBooking: function isDisabledBatchBooking() {
            var postDataServices = this.postData.services || [];
            return postDataServices.length != 1;
        },
        isBookingAlert: function isBookingAlert() {
            if (this.inspectBookingAvailable.showAlert) {
                return !this.inspectBookingAvailable.ajaxing && !this.inspectBookingAvailable.isAvailable && this.modalReady;
            }
            return false;
        },
        disableSubmitBtn: function disableSubmitBtn() {
            return this.inspectBookingAvailable.ajaxing;
        }
    },
    watch: {
        total_service_time: function total_service_time(newV, oldV) {
            if (newV < 0) {
                this.total_service_time = 0;
            }
        },
        'postData.services': {
            handler: function handler(newV, oldV) {
                if (newV.length > 0) {
                    for (var i = 0; i < newV.length; i++) {
                        if (parseInt(newV[i].price) <= 0) {
                            this.postData.services[i].price = 0;
                        }
                    }
                    if (newV.length != 1) {
                        this.postData.has_batch_booking = false;
                    }
                }
            },

            immediate: true,
            deep: true
        },
        'postData.has_batch_booking': function postDataHas_batch_booking(hasBatchBooking) {
            if (!hasBatchBooking) {
                this.resetBatchData();
            }
        },
        timeoutId: function timeoutId(newV, oldV) {
            window.clearTimeout(oldV);
        },

        'view.group_services': function viewGroup_services() {
            var vm = this;
            var serviceSelectObj = {
                placeholder: '請選擇',
                templateResult: function templateResult(item) {
                    if (!item.id) {
                        return item.text;
                    }
                    var option = vm.$refs['service' + item.id][0];
                    return $('<div>' + '<p>' + item.text + '</p>' + '<div class="text-right">' + '<small>' + '&nbsp' + '<i class="fa fa-clock-o" aria-hidden="true"></i>' + option.dataset.time + '分' + '&nbsp' + '<i class="fa fa-dollar" aria-hidden="true"><i>' + option.dataset.price + '&nbsp' + '</small>' + '</div>' + '</div>');
                }
            };
            $(this.$el).find('#service-select').select2(serviceSelectObj);
        }
    },
    methods: {
        checkBookingAvaliable: function checkBookingAvaliable() {
            var vm = this;
            var delay = Number(this.bookingDebounceTimer);
            if (this.view.action == 'update' || this.view.action == 'create') {
                this.timeoutId = setTimeout(function () {
                    vm.getIsBookingAvaliable();
                }, delay);
            }
        },
        getConfigTimer: function getConfigTimer() {
            var _this = this;

            this.$http.get('/adminapi/system_config', {
                params: {
                    config: ['webadmin.timer']
                }
            }).then(function (response) {
                var timer = response.data['webadmin.timer'];
                _this.bookingDebounceTimer = timer.booking_debounce;
            });
        },
        getIsBookingAvaliable: function getIsBookingAvaliable() {
            var _this2 = this;

            var paramsValidate = Number(this.total_service_time) !== 0 && this.postData.role_relationship_id && this.postData.start_date && this.postData.start_time;
            if (!paramsValidate || !this.modalReady) return;
            this.inspectBookingAvailable.ajaxing = true;
            var postData = {
                role_relationship_id: this.postData.role_relationship_id,
                start_date: this.postData.start_date,
                start_time: this.postData.start_time,
                service_time: this.total_service_time
            };
            if (this.view.currentBookingId !== 0) {
                postData['booking_id'] = this.view.currentBookingId;
            }
            this.$http.get('/adminapi/service-bookings/check-booking-available', { params: postData }).then(function (response) {
                _this2.inspectBookingAvailable.ajaxing = false;
                _this2.inspectBookingAvailable.showAlert = true;
                _this2.inspectBookingAvailable.isAvailable = response.data.isAvailable == 0 ? false : true;
            }, function (error) {
                _this2.inspectBookingAvailable.ajaxing = false;
                _this2.inspectBookingAvailable.showAlert = false;
                $.notify('人員時段查詢錯誤，請重新操作', { className: 'error', globalPosition: 'top center', clickToHide: true });
            });
        },
        checkIsOverLimit: function checkIsOverLimit() {
            var service_contracts = this.postData.services.reduce(function (acc, curr) {
                acc[curr.id] = curr.contract;
                return acc;
            }, {});
            var checkData = {
                date_time: this.postData.start_date + ' ' + this.postData.start_time,
                member_id: this.postData.member_id,
                branch_id: this.postData.branch_id,
                service_contracts: service_contracts
            };
            this.$http.post(webadmin_base_url + '/member_contract/check-is-over-limit', checkData).then(function (response) {
                if (!response.data.can_order) {
                    $17.swal({
                        title: '所選用方案已經超過可以使用數量',
                        type: 'error',
                        showCancelButton: false
                    });
                }
            }).catch(function (response) {
                $17.swal({
                    title: '選擇服務可用方案發生錯誤',
                    type: 'error',
                    showCancelButton: false
                });
            });
        },
        getTotalServiceTime: function getTotalServiceTime(countTime) {
            if (typeof countTime !== 'undefined') {
                return countTime;
            }
            var total = 0;
            for (var sId in this.postData.services) {
                total += parseInt(this.postData.services[sId].time);
            }
            return total;
        },
        billOperate: function billOperate() {
            var _this3 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                var updateData, canOpenOrder;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                $.blockUI({ timeout: 10000 });
                                updateData = _this3.generateData();
                                canOpenOrder = false;
                                _context.next = 5;
                                return _this3.$http.put('/adminapi/service-bookings/update/' + _this3.view.currentBookingId, updateData).then(function (response) {
                                    if (response.data.status !== 1) {
                                        $17.swal({
                                            title: response.data.message,
                                            type: 'error',
                                            showCancelButton: false
                                        });
                                    } else {
                                        canOpenOrder = true;
                                    }
                                }).catch(function (response) {
                                    $17.swal({
                                        title: '服務預約更新失敗',
                                        html: '請檢查各欄位是否已填寫<br/>預估時間需大於 0 分鐘<br/>預估費用不可為負數',
                                        type: 'error',
                                        showCancelButton: false
                                    });
                                    $.unblockUI();
                                });

                            case 5:
                                if (!canOpenOrder) {
                                    _context.next = 11;
                                    break;
                                }

                                _context.next = 8;
                                return _this3.show();

                            case 8:
                                _context.next = 10;
                                return _this3.$http.get('/adminapi/pos/booking/' + _this3.view.currentBookingId + '/order').then(function (response) {
                                    $('#service-booking-edit-modal').modal('hide');
                                    window.Event.$emit("System.Pos.Order.Open", {
                                        'order_id': _this3.view.booking.order_id,
                                        'booking_id': _this3.view.currentBookingId,
                                        'mode': 'edit',
                                        'event_type': 'serviceBooking'
                                    });
                                }, function (error) {
                                    $17.swal({
                                        title: '開啟訂單失敗',
                                        type: 'error',
                                        showCancelButton: false
                                    });
                                });

                            case 10:
                                $.unblockUI();

                            case 11:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this3);
            }))();
        },
        submitCreate: function submitCreate() {
            var _this4 = this;

            $.blockUI();
            var createData = this.generateData();
            var mode = this.postData.has_batch_booking ? 'Batch-Create' : 'Created';
            createData = (0, _assign2.default)(createData, this.generateBatchData());
            this.$http.post('/adminapi/service-bookings/create', (0, _stringify2.default)(createData)).then(function (response) {
                var bookingId = response.data.booking;
                if (response.data.status === 1) {
                    $17.swal({
                        title: '服務預約新增成功',
                        type: 'success',
                        showCancelButton: false
                    });
                    _this4.finishModal(mode, bookingId);
                } else {
                    $17.swal({
                        title: response.data.message,
                        type: 'error',
                        showCancelButton: false
                    });
                }
                $.unblockUI();
            }).catch(function (response) {
                $17.swal({
                    title: '服務預約新增失敗',
                    html: '請檢查各欄位是否已填寫<br/>預估時間需大於 0 分鐘<br/>預估費用不可為負數',
                    type: 'error',
                    showCancelButton: false
                });
                $.unblockUI();
            });
        },
        create: function create() {
            if (this.postData.has_batch_booking) {
                $17.swal({
                    title: '循環預約時間可能與教練私人時間或其他預約重疊，確定繼續預約？',
                    type: 'warning',
                    showCancelButton: true
                }, this.submitCreate);
            } else {
                this.submitCreate();
            }
        },
        update: function update(WithBookingStatus) {
            var _this5 = this;

            $.blockUI();
            var updateData = this.generateData();
            if (typeof WithBookingStatus !== 'undefined') {
                updateData['status'] = WithBookingStatus;
            }
            this.$http.put('/adminapi/service-bookings/update/' + this.view.currentBookingId, updateData).then(function (response) {
                if (response.data.status === 1) {
                    $17.swal({
                        title: '服務預約更新成功',
                        type: 'success',
                        showCancelButton: false
                    });
                    _this5.finishModal('Updated', _this5.view.currentBookingId);
                } else {
                    $17.swal({
                        title: response.data.message,
                        type: 'error',
                        showCancelButton: false
                    });
                }
                $.unblockUI();
            }).catch(function (response) {
                $17.swal({
                    title: '服務預約更新失敗',
                    html: '請檢查各欄位是否已填寫<br/>預估時間需大於 0 分鐘<br/>預估費用不可為負數',
                    type: 'error',
                    showCancelButton: false
                });
                $.unblockUI();
            });
        },
        generateBatchData: function generateBatchData() {
            return {
                has_batch_booking: this.postData.has_batch_booking || false,
                batch_start_date: this.postData.batch_start_date || null,
                batch_end_date: this.postData.batch_end_date || null,
                has_batch_day_1: this.postData.has_batch_day_1 || false,
                has_batch_day_2: this.postData.has_batch_day_2 || false,
                has_batch_day_3: this.postData.has_batch_day_3 || false,
                has_batch_day_4: this.postData.has_batch_day_4 || false,
                has_batch_day_5: this.postData.has_batch_day_5 || false,
                has_batch_day_6: this.postData.has_batch_day_6 || false,
                has_batch_day_7: this.postData.has_batch_day_7 || false,
                batch_day_1_time: this.postData.batch_day_1_time || "00:00",
                batch_day_2_time: this.postData.batch_day_2_time || "00:00",
                batch_day_3_time: this.postData.batch_day_3_time || "00:00",
                batch_day_4_time: this.postData.batch_day_4_time || "00:00",
                batch_day_5_time: this.postData.batch_day_5_time || "00:00",
                batch_day_6_time: this.postData.batch_day_6_time || "00:00",
                batch_day_7_time: this.postData.batch_day_7_time || "00:00"
            };
        },

        // add property for create.
        generateData: function generateData() {
            var service_ids = [];
            var service_price = {};
            var service_contract = {};
            for (var idx in this.postData.services) {
                var service = this.postData.services[idx];
                service_ids.push(service.id);
                service_price[service.id] = service.price;
                service_contract[service.id] = service.contract;
            }
            return {
                studio_id: this.postData.studio_id,
                branch_id: this.postData.branch_id,
                member_id: this.postData.member_id > 0 ? this.postData.member_id : '',
                start_date: this.postData.start_date,
                start_time: this.postData.start_time,
                role_relationship_id: this.postData.role_relationship_id,
                notice: this.postData.notice,
                total_money: this.total,
                service_time: this.total_service_time,
                service_ids: service_ids,
                service_price: service_price,
                select_contract: service_contract
            };
        },
        deleteService: function deleteService(index) {
            this.total_service_time = parseInt(this.total_service_time) - parseInt(this.postData.services[index].time);
            this.postData.services.splice(index, 1);
            if (this.postData.services.length === 0) {
                this.total_service_time = 0;
            }
            this.checkBookingAvaliable();
        },
        serviceOnChange: function serviceOnChange(selected) {
            var _this6 = this;

            this.$http.post(webadmin_base_url + '/member_contract/getUseableContract', {
                service_id: selected.id,
                date_time: this.postData.start_date + ' ' + this.postData.start_time,
                member_id: this.postData.member_id
            }).then(function (response) {
                var useableContract = response.data[selected.id];
                _this6.view.contract_list[selected.id] = useableContract;

                var sService = _this6.$refs['service' + selected.id][0];
                //只有一個方案就預設帶入第一個方案
                var initSelectedContractId = useableContract.length === 2 ? useableContract[1]['member_contract_id'] : 0;

                _this6.postData.services.push({
                    id: selected.id,
                    price: parseInt(sService.dataset.price),
                    contract: initSelectedContractId,
                    name: sService.dataset.name,
                    time: parseInt(sService.dataset.time)
                });
                _this6.total_service_time = parseInt(_this6.total_service_time) + parseInt(sService.dataset.time);
                _this6.checkBookingAvaliable();
            }).catch(function (response) {
                $17.swal({
                    title: '選擇服務發生錯誤',
                    type: 'error',
                    showCancelButton: false
                });
            });
            $(this.$el).find('#service-select').val('').trigger('change.select2');
        },
        initBookingData: function initBookingData(data) {
            this.view.booking = data.booking;
            this.view.member_allow_online_booking = data.booking.member_allow_online_booking;
            this.view.group_services = data.group_services;
            this.view.staffs = data.staffs;
            this.view.contract_list = data.contract_list;
            this.view.service_prices = data.service_prices;
            this.view.total_money = parseInt(data.total_money);
            this.view.button_status.show_cancel_button = data.show_cancel_button;
            this.view.button_status.show_attend_absence_buttons = data.show_attend_absence_buttons;
            this.view.button_status.show_checked_attend = data.show_checked_attend;
            this.view.button_status.show_checked_absence = data.show_checked_absence;
        },
        onCall: function onCall(data, action, createPayload) {
            this.createPayload = createPayload;
            this.resetData();
            if (action === 'update') {
                this.view.currentBookingId = data.booking.id;
                this.initBookingData(data);
                this.initPostData(data);
            } else if (action === 'create') {
                this.postData.studio_id = createPayload.studio_id;
                this.postData.branch_id = createPayload.branch_id;
                this.postData.start_date = createPayload.start_date;
                this.postData.batch_start_date = createPayload.batch_start_date;
                this.postData.batch_end_date = createPayload.batch_end_date;
                this.postData.start_time = createPayload.start_time;
                this.postData.role_relationship_id = createPayload.role_relationship_id;
                this.view.group_services = createPayload.group_services;
                this.view.staffs = createPayload.staffs;
            }
            this.view.action = action;
            this.modalReady = true;
        },
        show: function show() {
            var _this7 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _this7.view.ajaxing = true;
                                _context2.next = 3;
                                return _this7.$http.get('/adminapi/service-bookings/show/' + _this7.view.currentBookingId).then(function (response) {
                                    var data = response.data.booking;
                                    _this7.initBookingData(data);
                                    _this7.initPostData(data);
                                    _this7.view.ajaxing = false;
                                }, function (error) {
                                    _this7.view.ajaxing = false;
                                });

                            case 3:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this7);
            }))();
        },
        initPostData: function initPostData(responseData) {
            this.postData = {
                studio_id: responseData.booking.studio_id,
                branch_id: responseData.booking.branch_id,
                member_id: responseData.booking.member_id,
                role_relationship_id: responseData.booking.service_provider_role_relationship_id,
                start_time: responseData.booking.start_time,
                start_date: responseData.booking.start_date,
                notice: responseData.booking.notice,
                services: []
            };
            this.total_service_time = responseData.booking.service_time;
            var bookingServices = responseData.booking.booking_services;
            for (var serviceId in bookingServices) {
                this.postData.services.push({
                    id: serviceId,
                    price: parseInt(bookingServices[serviceId].service_price),
                    contract: bookingServices[serviceId].member_contract_id,
                    name: bookingServices[serviceId].service_name,
                    time: parseInt(bookingServices[serviceId].service_time)
                });
            }
        },
        selectServiceProvider: function selectServiceProvider(value) {
            if (this.postData.role_relationship_id != value) {
                this.checkBookingAvaliable();
            }
            this.postData.role_relationship_id = value;
        },
        finishModal: function finishModal() {
            var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
            var bookingId = arguments[1];

            if (action) {
                var event = 'System.Booking.' + action;
                window.Event.$emit(event, bookingId);
            }
            this.$emit('refresh');
            window.clearTimeout(this.timeoutId);
            $('#service-booking-edit-modal').modal('hide');
        },
        resetBatchData: function resetBatchData() {
            var payload = (0, _assign2.default)({}, this.createPayload);
            this.postData.batch_start_date = payload.batch_start_date;
            this.postData.batch_end_date = payload.batch_end_date;
            this.postData.has_batch_day_1 = false;
            this.postData.has_batch_day_2 = false;
            this.postData.has_batch_day_3 = false;
            this.postData.has_batch_day_4 = false;
            this.postData.has_batch_day_5 = false;
            this.postData.has_batch_day_6 = false;
            this.postData.has_batch_day_7 = false;
            this.postData.batch_day_1_time = "00:00";
            this.postData.batch_day_2_time = "00:00";
            this.postData.batch_day_3_time = "00:00";
            this.postData.batch_day_4_time = "00:00";
            this.postData.batch_day_5_time = "00:00";
            this.postData.batch_day_6_time = "00:00";
            this.postData.batch_day_7_time = "00:00";
        },
        resetData: function resetData() {
            this.view = {
                member_allow_online_booking: 1,
                action: 'update',
                booking: {},
                group_services: {},
                staffs: {},
                contract_list: {},
                service_prices: {},
                total_money: {},
                currentBookingId: 0,
                button_status: {
                    show_cancel_button: 0,
                    show_attend_absence_buttons: 0,
                    show_checked_attend: 0,
                    show_checked_absence: 0
                }
            };
            this.total_service_time = 0;
            this.show_bill = false;
            this.create_member = {
                status: false,
                name: '',
                phone: '',
                email: ''
            };
            this.postData = {
                studio_id: 0,
                branch_id: 0,
                member_id: 0,
                role_relationship_id: '',
                start_time: '',
                start_date: '',
                notice: '',
                services: []
            };
            this.inspectBookingAvailable = {
                showAlert: false,
                ajaxing: false,
                isAvailable: false
            };
            this.modalReady = false;
        },
        openOrder: function openOrder() {
            var _this8 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
                var vm, branchId;
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                vm = _this8;
                                branchId = _this8.view.booking.branch_id;
                                _context3.next = 4;
                                return _this8.$store.dispatch('pos/updateAllStatus', [{ 'key': 'select_branch_id', value: branchId }]);

                            case 4:
                                _context3.next = 6;
                                return _this8.$store.dispatch('pos/openOrCreateOrder', { 'order_id': _this8.view.booking.order_id }).then(function () {
                                    vm.$store.dispatch('pos/getCommonlyUsedItem', branchId);
                                    vm.$store.commit('pos/POS_SETSTATUS', { 'key': 'select_branch_id', value: branchId });
                                    $('#service-booking-edit-modal').modal('hide');
                                    $('#order-edit').modal('show');
                                });

                            case 6:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this8);
            }))();
        },
        memberTemplateSelection: function memberTemplateSelection(state) {
            if (state.name) {
                return state.name;
            }
            return state.text;
        },
        memberSelectedAction: function memberSelectedAction(e) {
            var _this9 = this;

            this.$store.dispatch('webadmin/crm/getMemberStatus', e.params.data.id).then(function () {
                _this9.view.member_allow_online_booking = _this9.$store.state.webadmin.crm.memberStatus.hasOwnProperty('online_booking') ? _this9.$store.state.webadmin.crm.memberStatus.online_booking : 1;
            });

            this.view.booking.member_email = e.params.data.email;
            this.view.booking.member_name = e.params.data.name;
            this.view.booking.member_phone = e.params.data.phone;
            this.view.booking.member_is_walkin = 0;
            this.view.booking.booking_admin = 0;
            this.postData.member_id = e.params.data.id;
        },
        memberRunSelectedAction: function memberRunSelectedAction(e) {
            this.view.booking.member_email = '';
            this.view.booking.member_name = '';
            this.view.booking.member_phone = '';
            this.view.booking.member_is_walkin = 0;
            this.view.booking.booking_admin = 0;
            this.postData.member_id = 0;
        },
        submitNewMember: function submitNewMember() {
            var _this10 = this;

            this.$http.post(webadmin_base_url + '/member/add_studio_member/' + this.postData.studio_id, {
                name: this.create_member.name,
                phone: this.create_member.phone,
                email: this.create_member.email
            }).then(function (response) {
                if (response.data.status === 1) {
                    var newMember = response.data.member;
                    _this10.postData.member_id = newMember.id;
                    _this10.view.booking.member_id = newMember.id;
                    _this10.view.booking.member_name = newMember.name;
                    _this10.view.booking.member_email = newMember.email;
                    _this10.view.booking.member_phone = newMember.phone;
                    _this10.view.booking.member_is_walkin = 0;
                    _this10.view.booking.booking_admin = 0;
                    _this10.create_member = {
                        status: false,
                        name: '',
                        phone: '',
                        email: ''
                    };
                    $17.swal({
                        title: '新增客戶成功',
                        type: 'success',
                        showCancelButton: false
                    });
                } else {
                    var message = response.data.message;
                    if (response.data.hasOwnProperty('errors')) {
                        var column = (0, _keys2.default)(response.data.errors)[0];
                        message = column + ' ' + response.data.errors[column];
                    }
                    $17.swal({
                        title: message,
                        type: 'error',
                        showCancelButton: false
                    });
                }
            }).catch(function (response) {
                $17.swal({
                    title: '新增客戶發生錯誤',
                    type: 'error',
                    showCancelButton: false
                });
            });
        },
        resetMemberUI: function resetMemberUI(status) {
            if (!status) {
                this.postData.services = [];
                this.total_service_time = 0;
            }
            this.view.member_allow_online_booking = 1;
            this.postData.member_id = 0;
            this.create_member = {
                status: status,
                name: '',
                phone: '',
                email: ''
            };
        },
        hoverOnName: function hoverOnName(e) {
            window.Event.$emit('MemberCard.Show', e.target);
        },
        orderBilled: function orderBilled() {
            $('#service-booking-edit-modal').modal('hide');
            $('#service-booking-view-modal').modal('hide');
            this.$emit('order-billed');
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-02068c42=\"\">\n                <v-spinner :ajaxing=\"view.ajaxing\" _v-02068c42=\"\"></v-spinner>\n                <div v-show=\"!view.ajaxing\" _v-02068c42=\"\">\n                    <div id=\"edit-booking-form\" class=\"form-horizontal\" _v-02068c42=\"\">\n                        <div v-if=\"postData.member_id>0\" _v-02068c42=\"\">\n                            <div class=\"form-group\" _v-02068c42=\"\">\n                                <label class=\"col-sm-3 control-label\" _v-02068c42=\"\">客戶姓名</label>\n                                <div class=\"col-sm-5\" _v-02068c42=\"\">\n                                    <label class=\"control-label\" :data-member-id=\"postData.member_id\" @mouseover.prevent=\"hoverOnName\" _v-02068c42=\"\">{{view.booking.member_name}}</label>\n                                    <v-member-tag :member-id=\"postData.member_id\" _v-02068c42=\"\"></v-member-tag>\n                                </div>\n                                <div class=\"col-sm-1\" _v-02068c42=\"\"></div>\n                                <div class=\"col-sm-3\" v-if=\"view.action==='create'\" _v-02068c42=\"\">\n                                    <button class=\"btn btn-primary\" @click=\"resetMemberUI(false)\" _v-02068c42=\"\">重新選擇</button>\n                                </div>\n                                <div class=\"col-sm-3\" v-else-if=\"view.action==='update'&amp;&amp;view.booking.booking_admin===0&amp;&amp;view.booking.member_is_walkin===0\" _v-02068c42=\"\">\n                                    <h4 class=\"m-top-2\" _v-02068c42=\"\">\n                                        <span class=\"label label-info\" _v-02068c42=\"\">線上預約</span>\n                                    </h4>\n                                </div>\n                            </div>\n                            <div class=\"form-group\" v-show=\"view.booking.member_is_walkin===0\" _v-02068c42=\"\">\n                                <label class=\"col-sm-3 control-label\" _v-02068c42=\"\">電子郵件</label>\n                                <div class=\"col-sm-5\" _v-02068c42=\"\"><label class=\"control-label\" _v-02068c42=\"\">{{view.booking.member_email}}</label></div>\n                                <div class=\"col-sm-1\" _v-02068c42=\"\"></div>\n                            </div>\n                            <div class=\"form-group\" v-show=\"view.booking.member_is_walkin===0\" _v-02068c42=\"\">\n                                <label class=\"col-sm-3 control-label\" _v-02068c42=\"\">行動電話</label>\n                                <div class=\"col-sm-5\" _v-02068c42=\"\"><label class=\"control-label\" _v-02068c42=\"\">{{view.booking.member_phone}}</label></div>\n                                <div class=\"col-sm-1\" _v-02068c42=\"\"></div>\n                            </div>\n                        </div>\n                        <div v-else-if=\"create_member.status\" _v-02068c42=\"\">\n                            <div class=\"form-group\" _v-02068c42=\"\">\n                                <label class=\"col-sm-3 control-label\" _v-02068c42=\"\">新增客戶</label>\n                                <div class=\"col-sm-6\" _v-02068c42=\"\">\n                                    <input type=\"text\" v-model=\"create_member.name\" class=\"form-control\" placeholder=\"客戶姓名\" _v-02068c42=\"\">\n                                </div>\n                                <div class=\"col-sm-3\" _v-02068c42=\"\">\n                                    <button class=\"btn btn-primary\" @click=\"resetMemberUI(false)\" _v-02068c42=\"\">重新選擇</button>\n                                </div>\n                            </div>\n                            <div class=\"form-group\" _v-02068c42=\"\">\n                                <label class=\"col-sm-3 control-label\" _v-02068c42=\"\"></label>\n                                <div class=\"col-sm-6\" _v-02068c42=\"\">\n                                    <input type=\"email\" v-model=\"create_member.email\" class=\"form-control\" placeholder=\"電子郵件 ex.demo.xmail.com\" _v-02068c42=\"\">\n                                </div>\n                            </div>\n                            <div class=\"form-group\" _v-02068c42=\"\">\n                                <label class=\"col-sm-3 control-label\" _v-02068c42=\"\"></label>\n                                <div class=\"col-sm-6\" _v-02068c42=\"\">\n                                    <input type=\"number\" v-model=\"create_member.phone\" class=\"form-control\" placeholder=\"行動電話 ex.0987654321\" _v-02068c42=\"\">\n                                </div>\n                            </div>\n                            <div class=\"form-group\" _v-02068c42=\"\">\n                                <label class=\"col-sm-3 control-label\" _v-02068c42=\"\"></label>\n                                <div class=\"col-sm-6\" _v-02068c42=\"\">\n                                    <button class=\"btn btn-primary form-control\" @click=\"submitNewMember\" _v-02068c42=\"\">確認新增</button>\n                                </div>\n                            </div>\n                        </div>\n                        <div v-else=\"\" _v-02068c42=\"\">\n                            <div class=\"form-group\" _v-02068c42=\"\">\n                                <label class=\"col-sm-3 control-label\" _v-02068c42=\"\">客戶</label>\n                                <div class=\"col-sm-6\" _v-02068c42=\"\">\n                                    <v-member-selector id=\"search-member\" :studio-id=\"postData.studio_id\" :allow-clear=\"true\" placeholder=\"請選擇\" :keep=\"true\" :template-selection=\"memberTemplateSelection\" :selected-action=\"memberSelectedAction\" :unselected-action=\"memberRunSelectedAction\" _v-02068c42=\"\">\n                                    </v-member-selector>\n                                </div>\n                                <div class=\"col-sm-3\" v-if=\"view.action==='create'&amp;&amp;postData.member_id===0\" _v-02068c42=\"\">\n                                    <button class=\"btn btn-success\" v-if=\"!create_member.status\" @click=\"resetMemberUI(true)\" _v-02068c42=\"\">\n                                        <i class=\"fa fa-plus\" _v-02068c42=\"\"></i> 新增客戶\n                                    </button>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"form-group listening-click\" _v-02068c42=\"\">\n                            <label class=\"col-sm-3 control-label\" _v-02068c42=\"\">服務</label>\n                            <div class=\"col-sm-6\" _v-02068c42=\"\">\n                                <select id=\"service-select\" class=\"col-sm-12\" _v-02068c42=\"\">\n                                    <option _v-02068c42=\"\"></option>\n                                    <optgroup v-for=\"group in view.group_services\" :label=\"group.name\" _v-02068c42=\"\">\n                                        <option v-for=\"s in group.services\" :value=\"s.service.id\" :ref=\"'service'+s.service.id\" :data-name=\"s.service.name\" :data-price=\"s.service.price\" :data-price-floor=\"s.service.price_floor\" :data-time=\"s.service.service_time\" _v-02068c42=\"\">\n                                            {{ s.service.name }}\n                                        </option>\n                                    </optgroup>\n                                </select>\n                            </div>\n                        </div>\n                        <div class=\"form-group\" v-if=\"postData.services.length>0\" _v-02068c42=\"\">\n                            <label class=\"col-sm-3\" _v-02068c42=\"\"></label>\n                            <div class=\"col-sm-6\" _v-02068c42=\"\">\n                                <ul class=\"list-group m-bottom-0\" _v-02068c42=\"\">\n                                    <li v-for=\"(s,index) in postData.services\" class=\"list-group-item\" _v-02068c42=\"\">\n                                        <span _v-02068c42=\"\">{{s.name}}</span>\n                                        <button @click=\"deleteService(index)\" type=\"button\" help=\"移除此服務\" class=\"pull-right trash\" _v-02068c42=\"\">\n                                            <i class=\"fa fa-trash text-danger\" _v-02068c42=\"\"></i>\n                                        </button>\n                                        <select class=\"form-control input-sm select_contract\" :class=\"view.contract_list.hasOwnProperty(s.id)&amp;&amp;Object.keys(view.contract_list[s.id]).length===1?'hidden':''\" v-model=\"postData.services[index].contract\" @change=\"checkIsOverLimit\" _v-02068c42=\"\">\n                                            <option v-for=\"memberContract in view.contract_list[s.id]\" :value=\"memberContract.member_contract_id\" _v-02068c42=\"\">{{memberContract.name}}\n                                            </option>\n                                        </select>\n                                        <div class=\"input-group service-price-group\" :class=\"s.contract!=0?'hidden':''\" _v-02068c42=\"\">\n                                            <span class=\"input-group-addon\" _v-02068c42=\"\">$</span>\n                                            <input type=\"number\" class=\"form-control\" min=\"0\" step=\"1\" v-model=\"postData.services[index].price\" _v-02068c42=\"\">\n                                            <span class=\"input-group-addon\" _v-02068c42=\"\">NT</span>\n                                        </div>\n                                    </li>\n                                </ul>\n                            </div>\n                        </div>\n                        <div class=\"form-group listening-click\" _v-02068c42=\"\">\n                            <label class=\"col-sm-3 control-label\" _v-02068c42=\"\">人員</label>\n                            <div class=\"col-sm-6\" _v-02068c42=\"\">\n                                <v-select2 :match=\"postData.role_relationship_id\" :options=\"view.staffs\" :disabled=\"view.ajaxing\" :updated=\"selectServiceProvider\" :placeholder=\"view.ajaxing ? '人員讀取中…' : '請選擇人員'\" _v-02068c42=\"\">\n                                </v-select2>\n                            </div>\n                            <div class=\"col-sm-2\" _v-02068c42=\"\">\n                                <h4 class=\"m-top-2\" _v-02068c42=\"\">\n                                    <div class=\"label label-info\" _v-02068c42=\"\">{{view.booking.service_provider_label}}</div>\n                                </h4>\n                            </div>\n                        </div>\n                        <div class=\"form-group listening-click\" _v-02068c42=\"\">\n                            <label class=\"col-sm-3 control-label\" _v-02068c42=\"\">日期時間</label>\n                            <div class=\"col-sm-3\" _v-02068c42=\"\">\n                                <div class=\"input-group date\" _v-02068c42=\"\">\n                                    <input type=\"text\" v-model=\"postData.start_date\" id=\"date\" class=\"col-sm-12 form-control\" _v-02068c42=\"\">\n                                </div>\n                            </div>\n                            <div class=\"col-sm-3\" _v-02068c42=\"\">\n                                <select v-model=\"postData.start_time\" @change=\"checkBookingAvaliable()\" id=\"appointment_start_time\" class=\"form-control\" _v-02068c42=\"\">\n                                    <option v-for=\"time in time_picker\" :value=\"time\" _v-02068c42=\"\">{{time}}</option>\n                                </select>\n                            </div>\n                        </div>\n\n                        <div class=\"form-group\" v-show=\"view.currentBookingId == 0\" _v-02068c42=\"\">\n                            <label class=\"col-sm-3 control-label\" _v-02068c42=\"\">\n                                循環預約\n                            </label>\n                            <label class=\"col-sm-1 control-label\" style=\"text-align: left\" _v-02068c42=\"\">\n                                <input type=\"checkbox\" v-model=\"postData.has_batch_booking\" :disabled=\"isDisabledBatchBooking\" _v-02068c42=\"\">\n                            </label>\n                            <div class=\"col-sm-8\" _v-02068c42=\"\"></div>\n\n                            <div class=\"batch-options-form\" v-show=\"postData.has_batch_booking\" _v-02068c42=\"\">\n                                <!-- date options -->\n                                <div class=\"row\" _v-02068c42=\"\">\n                                    <div class=\"col-md-12\" style=\"margin-top: 5px;\" _v-02068c42=\"\">\n                                        <div class=\"col-sm-3\" _v-02068c42=\"\"></div>\n                                        <div class=\"col-sm-3\" _v-02068c42=\"\">\n                                            <div class=\"input-group date\" _v-02068c42=\"\">\n                                                <input type=\"text\" v-model=\"postData.batch_start_date\" id=\"batch_start_date\" class=\"col-sm-12 form-control\" _v-02068c42=\"\">\n                                            </div>\n                                        </div>\n                                        <div class=\"col-sm-3\" _v-02068c42=\"\">\n                                            <div class=\"input-group date\" _v-02068c42=\"\">\n                                                <input type=\"text\" v-model=\"postData.batch_end_date\" id=\"batch_end_date\" class=\"col-sm-12 form-control\" _v-02068c42=\"\">\n                                            </div>\n                                        </div>\n                                        <div class=\"col-sm-3\" _v-02068c42=\"\"></div>\n                                    </div>\n                                </div>\n                                <!-- /date options -->\n\n                                <!-- time options -->\n                                <div class=\"row\" _v-02068c42=\"\">\n                                    <div class=\"col-md-12\" style=\"margin-top: 5px;\" _v-02068c42=\"\">\n                                        <div class=\"col-sm-3\" _v-02068c42=\"\"></div>\n                                        <div class=\"col-sm-3 control-label\" style=\"text-align: left; padding-top: 3px;\" _v-02068c42=\"\">\n                                            <input type=\"checkbox\" v-model=\"postData.has_batch_day_1\" _v-02068c42=\"\"> 星期一\n                                        </div>\n                                        <div class=\"col-sm-3\" _v-02068c42=\"\">\n                                            <select v-model=\"postData.batch_day_1_time\" class=\"form-control\" _v-02068c42=\"\">\n                                                <option v-for=\"time in time_picker\" :value=\"time\" _v-02068c42=\"\">{{time}}</option>\n                                            </select>\n                                        </div>\n                                        <div class=\"col-sm-3\" _v-02068c42=\"\"></div>\n                                    </div>\n                                </div>\n                                <div class=\"row\" _v-02068c42=\"\">\n                                    <div class=\"col-md-12\" style=\"margin-top: 5px;\" _v-02068c42=\"\">\n                                        <div class=\"col-sm-3\" _v-02068c42=\"\"></div>\n                                        <div class=\"col-sm-3 control-label\" style=\"text-align: left; padding-top: 3px;\" _v-02068c42=\"\">\n                                            <input type=\"checkbox\" v-model=\"postData.has_batch_day_2\" _v-02068c42=\"\"> 星期二\n                                        </div>\n                                        <div class=\"col-sm-3\" _v-02068c42=\"\">\n                                            <select v-model=\"postData.batch_day_2_time\" class=\"form-control\" _v-02068c42=\"\">\n                                                <option v-for=\"time in time_picker\" :value=\"time\" _v-02068c42=\"\">{{time}}</option>\n                                            </select>\n                                        </div>\n                                        <div class=\"col-sm-3\" _v-02068c42=\"\"></div>\n                                    </div>\n                                </div>\n                                <div class=\"row\" _v-02068c42=\"\">\n                                    <div class=\"col-md-12\" style=\"margin-top: 5px;\" _v-02068c42=\"\">\n                                        <div class=\"col-sm-3\" _v-02068c42=\"\"></div>\n                                        <div class=\"col-sm-3 control-label\" style=\"text-align: left; padding-top: 3px;\" _v-02068c42=\"\">\n                                            <input type=\"checkbox\" v-model=\"postData.has_batch_day_3\" _v-02068c42=\"\"> 星期三\n                                        </div>\n                                        <div class=\"col-sm-3\" _v-02068c42=\"\">\n                                            <select v-model=\"postData.batch_day_3_time\" class=\"form-control\" _v-02068c42=\"\">\n                                                <option v-for=\"time in time_picker\" :value=\"time\" _v-02068c42=\"\">{{time}}</option>\n                                            </select>\n                                        </div>\n                                        <div class=\"col-sm-3\" _v-02068c42=\"\"></div>\n                                    </div>\n                                </div>\n                                <div class=\"row\" _v-02068c42=\"\">\n                                    <div class=\"col-md-12\" style=\"margin-top: 5px;\" _v-02068c42=\"\">\n                                        <div class=\"col-sm-3\" _v-02068c42=\"\"></div>\n                                        <div class=\"col-sm-3 control-label\" style=\"text-align: left; padding-top: 3px;\" _v-02068c42=\"\">\n                                            <input type=\"checkbox\" v-model=\"postData.has_batch_day_4\" _v-02068c42=\"\"> 星期四\n                                        </div>\n                                        <div class=\"col-sm-3\" _v-02068c42=\"\">\n                                            <select v-model=\"postData.batch_day_4_time\" class=\"form-control\" _v-02068c42=\"\">\n                                                <option v-for=\"time in time_picker\" :value=\"time\" _v-02068c42=\"\">{{time}}</option>\n                                            </select>\n                                        </div>\n                                        <div class=\"col-sm-3\" _v-02068c42=\"\"></div>\n                                    </div>\n                                </div>\n                                <div class=\"row\" _v-02068c42=\"\">\n                                    <div class=\"col-md-12\" style=\"margin-top: 5px;\" _v-02068c42=\"\">\n                                        <div class=\"col-sm-3\" _v-02068c42=\"\"></div>\n                                        <div class=\"col-sm-3 control-label\" style=\"text-align: left; padding-top: 3px;\" _v-02068c42=\"\">\n                                            <input type=\"checkbox\" v-model=\"postData.has_batch_day_5\" _v-02068c42=\"\"> 星期五\n                                        </div>\n                                        <div class=\"col-sm-3\" _v-02068c42=\"\">\n                                            <select v-model=\"postData.batch_day_5_time\" class=\"form-control\" _v-02068c42=\"\">\n                                                <option v-for=\"time in time_picker\" :value=\"time\" _v-02068c42=\"\">{{time}}</option>\n                                            </select>\n                                        </div>\n                                        <div class=\"col-sm-3\" _v-02068c42=\"\"></div>\n                                    </div>\n                                </div>\n                                <div class=\"row\" _v-02068c42=\"\">\n                                    <div class=\"col-md-12\" style=\"margin-top: 5px;\" _v-02068c42=\"\">\n                                        <div class=\"col-sm-3\" _v-02068c42=\"\"></div>\n                                        <div class=\"col-sm-3 control-label\" style=\"text-align: left; padding-top: 3px;\" _v-02068c42=\"\">\n                                            <input type=\"checkbox\" v-model=\"postData.has_batch_day_6\" _v-02068c42=\"\"> 星期六\n                                        </div>\n                                        <div class=\"col-sm-3\" _v-02068c42=\"\">\n                                            <select v-model=\"postData.batch_day_6_time\" class=\"form-control\" _v-02068c42=\"\">\n                                                <option v-for=\"time in time_picker\" :value=\"time\" _v-02068c42=\"\">{{time}}</option>\n                                            </select>\n                                        </div>\n                                        <div class=\"col-sm-3\" _v-02068c42=\"\"></div>\n                                    </div>\n                                </div>\n                                <div class=\"row\" _v-02068c42=\"\">\n                                    <div class=\"col-md-12\" style=\"margin-top: 5px;\" _v-02068c42=\"\">\n                                        <div class=\"col-sm-3\" _v-02068c42=\"\"></div>\n                                        <div class=\"col-sm-3 control-label\" style=\"text-align: left; padding-top: 3px;\" _v-02068c42=\"\">\n                                            <input type=\"checkbox\" v-model=\"postData.has_batch_day_7\" _v-02068c42=\"\"> 星期日\n                                        </div>\n                                        <div class=\"col-sm-3\" _v-02068c42=\"\">\n                                            <select v-model=\"postData.batch_day_7_time\" class=\"form-control\" _v-02068c42=\"\">\n                                                <option v-for=\"time in time_picker\" :value=\"time\" _v-02068c42=\"\">{{time}}</option>\n                                            </select>\n                                        </div>\n                                        <div class=\"col-sm-3\" _v-02068c42=\"\"></div>\n                                    </div>\n                                </div>\n                                <!-- /time options -->\n                            </div>\n\n                        </div>\n\n                        <div class=\"form-group listening-click\" _v-02068c42=\"\">\n                            <label class=\"col-sm-3 control-label\" _v-02068c42=\"\">預估時間</label>\n                            <div class=\"col-sm-6\" _v-02068c42=\"\">\n                                <div class=\"input-group\" _v-02068c42=\"\">\n                                    <span class=\"input-group-addon\" _v-02068c42=\"\"><i class=\"fa fa-clock-o\" _v-02068c42=\"\"></i></span>\n                                    <input id=\"service_time\" v-model=\"total_service_time\" @change=\"checkBookingAvaliable()\" type=\"number\" class=\"col-sm-6 form-control text-right\" min=\"1\" _v-02068c42=\"\">\n                                    <span class=\"input-group-addon\" _v-02068c42=\"\">分鐘</span>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"form-group\" _v-02068c42=\"\">\n                            <label class=\"col-sm-3 control-label\" _v-02068c42=\"\">預估費用</label>\n                            <div class=\"col-sm-6\" _v-02068c42=\"\">\n                                <div class=\"input-group\" _v-02068c42=\"\">\n                                    <span class=\"input-group-addon\" _v-02068c42=\"\"><i class=\"fa fa-dollar\" _v-02068c42=\"\"></i></span>\n                                    <input id=\"total_money\" v-model=\"total\" type=\"number\" class=\"col-sm-6 form-control text-right\" min=\"0\" readonly=\"readonly\" _v-02068c42=\"\">\n                                    <span class=\"input-group-addon\" _v-02068c42=\"\">NT</span>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"form-group\" v-if=\"view.booking.client_booking_note\" _v-02068c42=\"\">\n                            <label class=\"col-sm-3 control-label\" _v-02068c42=\"\">客戶預約備註</label>\n                            <div class=\"col-sm-6\" _v-02068c42=\"\">\n                                {{view.booking.client_booking_note}}\n                            </div>\n                        </div>\n                        <div class=\"form-group\" _v-02068c42=\"\">\n                            <label class=\"col-sm-3 control-label\" _v-02068c42=\"\">管理備註</label>\n                            <div class=\"col-sm-6\" _v-02068c42=\"\">\n                                <textarea v-model=\"postData.notice\" cols=\"30\" rows=\"10\" _v-02068c42=\"\"></textarea>\n                            </div>\n                        </div>\n                        <div class=\"form-group\" v-show=\"view.member_allow_online_booking===0\" _v-02068c42=\"\">\n                            <label class=\"col-sm-3 control-label\" _v-02068c42=\"\"></label>\n                            <div class=\"col-sm-6\" _v-02068c42=\"\">\n                                <label class=\"color-danger\" _v-02068c42=\"\"><i class=\"fa fa-warning p-right-5\" _v-02068c42=\"\"></i> 此客戶目前被停止線上預約</label>\n                            </div>\n                        </div>\n                        <div class=\"row\" _v-02068c42=\"\">\n                            <div class=\"col-sm-12 m-bottom-8 booking-alert\" _v-02068c42=\"\">\n                                <div v-show=\"inspectBookingAvailable.ajaxing\" class=\"ajaxing\" _v-02068c42=\"\"><i class=\"fa fa-spin fa-spinner\" _v-02068c42=\"\"></i>人員查詢段查詢中...</div>\n                                <div v-show=\"isBookingAlert\" class=\"result\" _v-02068c42=\"\">請留意此服務人員所選的時段，已經有其他預約</div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                    <service-booking-modal-buttons v-show=\"!view.ajaxing\" @refresh=\"finishModal\" @update-booking=\"update\" @create-booking=\"create\" @bill-operate-booking=\"billOperate\" @order-billed=\"orderBilled\" :current-booking-id=\"view.currentBookingId\" :action=\"view.action\" :button-status=\"view.button_status\" :show-bill=\"show_bill\" :disable-submit=\"disableSubmitBtn\" _v-02068c42=\"\">\n                    </service-booking-modal-buttons>\n                    \n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.search-member[_v-02068c42] {\n  margin: 0; }\n\n/* line 6, stdin */\n.booking-alert div[_v-02068c42] {\n  text-align: center;\n  border-radius: 4px;\n  padding: 9px; }\n\n/* line 11, stdin */\n.booking-alert .ajaxing[_v-02068c42] {\n  background: #E2E3E5;\n  border: 1px solid #D6D8DB; }\n\n/* line 15, stdin */\n.booking-alert .result[_v-02068c42] {\n  background: #FCD9A4;\n  border: 1px solid #FFEEBA;\n  color: #9B6006; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-02068c42", module.exports)
  } else {
    hotAPI.update("_v-02068c42", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/json/stringify":48,"babel-runtime/core-js/object/assign":50,"babel-runtime/core-js/object/keys":56,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1434:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _index = require('./index.vue');

var _index2 = _interopRequireDefault(_index);

var _modal = require('./modal.vue');

var _modal2 = _interopRequireDefault(_modal);

var _view = require('./view.vue');

var _view2 = _interopRequireDefault(_view);

var _edit = require('./edit.vue');

var _edit2 = _interopRequireDefault(_edit);

var _buttons = require('./_buttons.vue');

var _buttons2 = _interopRequireDefault(_buttons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('service-booking', _index2.default);
_vue2.default.component('service-booking-modal', _modal2.default);
_vue2.default.component('service-booking-view-modal', _view2.default);
_vue2.default.component('service-booking-edit-modal', _edit2.default);
_vue2.default.component('service-booking-modal-buttons', _buttons2.default);

},{"./_buttons.vue":1432,"./edit.vue":1433,"./index.vue":1435,"./modal.vue":1436,"./view.vue":1437,"vue":792}],1435:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.service-bookings-table tbody tr[_v-22523bcd] {\n  cursor: pointer; }\n\n/* line 6, stdin */\n.select2-container--default .select2-selection--single .select2-selection__placeholder[_v-22523bcd] {\n  color: inherit; }\n\n/* line 10, stdin */\n.select-outer-div[_v-22523bcd] {\n  display: block !important; }\n\n/* line 14, stdin */\n.search-option[_v-22523bcd] {\n  max-width: 400px; }\n\n@media screen and (min-width: 768px) {\n  /* line 19, stdin */\n  #search-member[_v-22523bcd] {\n    margin: 0 10px 0 0;\n    min-width: 150px; } }\n\n@media screen and (max-width: 768px) {\n  /* line 26, stdin */\n  #search-member[_v-22523bcd] {\n    margin-top: 15px;\n    max-width: 400px; } }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            modal: {},
            view: {
                list: [],
                ajaxing: false,
                pageMeta: {},
                filters: {
                    booking_method: '',
                    booking_status: '',
                    payment_status: '',
                    start_date: '',
                    end_date: '',
                    member_name: '',
                    member_id: ''
                }
            },
            selectMemberId: 0,
            jquery: $
        };
    },
    watch: {
        selected_studio_id: function selected_studio_id(val) {
            this.initList();
        }
    },
    mounted: function mounted() {
        var _this = this;

        var vm = this;
        this.$nextTick(function () {
            $('.datepicker-vue').datetimepicker({
                format: 'YYYY-MM-DD'
            }).on("dp.change", function (e) {
                var current = $(e.target);
                var name = current.attr('name');
                var value = $(this).val();
                vm.view.filters[name] = value;
            });
        });
        window.Event.$on('MemberCard.Show', function (target) {
            vm.$refs.memberProfileOverview.onCall(vm.selectMemberId, target);
        });
        window.Event.$on("System.Booking.Service.FreshList", function (data) {
            _this.refresh();
        });
    },
    destroyed: function destroyed() {
        window.Event.$off('MemberCard.Show');
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId', 'isBranch']), (0, _vuex.mapState)('filters', ['selected_studio_id', 'selected_branch_id']), (0, _vuex.mapState)({
        canView: function canView(state) {
            return state.webadmin.configure.webFunctions.hasOwnProperty('WebadminService-bookingsBookingList');
        }
    })),
    methods: {
        replaceServiceName: function replaceServiceName(names) {
            if (typeof names !== 'undefined') {
                return names.replace(/,/g, '<br/>');
            }
        },

        searchList: function searchList() {
            this.$store.dispatch('filters/updateQueryStrings', { page: 1, member_contract_id: '' });
            this.fetchList();
        },
        initList: function initList() {
            for (param in this.view.filters) {
                this.$data.view.filters[param] = this.getUrlParamValue(param);
            }
            this.fetchList();
        },
        fetchList: function fetchList() {
            var _this2 = this;

            var studioId = this.selected_studio_id;
            if (!studioId || studioId == 0) {
                return false;
            }
            var payload = {
                params: {
                    branch_id: this.selected_branch_id > 0 ? this.selected_branch_id : '',
                    member_id: this.view.filters.member_id,
                    start_date: this.view.filters.start_date,
                    end_date: this.view.filters.end_date,
                    booking_status: this.view.filters.booking_status,
                    booking_method: this.view.filters.booking_method,
                    payment_status: this.view.filters.payment_status,
                    member_contract_id: this.getUrlParamValue('member_contract_id'),
                    page: this.getUrlParamValue('page') ? this.getUrlParamValue('page') : 1
                }
            };
            this.view.ajaxing = true;
            this.$http.get('/adminapi/service-bookings/list/studio/' + studioId, payload).then(function (response) {
                this.view.list = response.data.list;
                this.view.pageMeta = response.data.pageMeta;

                delete payload.params.branch_id;
                delete payload.params.member_id;
                this.$store.dispatch('filters/updateQueryStrings', payload.params);
                this.view.ajaxing = false;
            }, function (error) {
                _this2.view.ajaxing = false;
            });
        },

        memberTemplateSelection: function memberTemplateSelection(state) {
            if (state.name) {
                return state.name;
            } else if (this.view.filters.member_name) {
                return this.view.filters.member_name;
            }
            return state.text;
        },
        memberSelectedAction: function memberSelectedAction(e) {
            this.view.filters.member_name = e.params.data.name;
            this.view.filters.member_id = e.params.data.id;
        },
        memberRunSelectedAction: function memberRunSelectedAction(e) {
            this.view.filters.member_name = '';
            this.view.filters.member_id = '';
        },
        showModal: function showModal(booking) {
            this.selectMemberId = booking.member_id;
            this.$refs.serviceBookingModal.onCall(booking.id);
        },
        hoverOnName: function hoverOnName(event) {
            this.$refs.memberProfileOverview.onCall(event.target.dataset.memberId, event.target);
        },

        refresh: function refresh() {
            this.view.ajaxing = true;
            this.fetchList();
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n    <div class=\"col-xs-12\" v-show=\"canView\" _v-22523bcd=\"\">\n        <div class=\"row p-bottom-10\" _v-22523bcd=\"\">\n            <div class=\"col-sm-3\" _v-22523bcd=\"\">\n                <v-select-studio-and-branch :studio_id=\"studioId\" :branch_id=\"branchId\" :branch-without-filtered-option=\"true\" _v-22523bcd=\"\">\n                </v-select-studio-and-branch>\n                <div class=\"form-group\" _v-22523bcd=\"\">\n                    <v-member-selector id=\"search-member\" :studio-id=\"selected_studio_id\" :allow-clear=\"true\" placeholder=\"選擇客戶\" :keep=\"true\" :template-selection=\"memberTemplateSelection\" :selected-action=\"memberSelectedAction\" :unselected-action=\"memberRunSelectedAction\" _v-22523bcd=\"\">\n                    </v-member-selector>\n                </div>\n            </div>\n            <div class=\"col-sm-3\" _v-22523bcd=\"\">\n                <div class=\"form-group search-option\" _v-22523bcd=\"\">\n                    <div class=\"input-group\" _v-22523bcd=\"\">\n                        <span class=\"input-group-addon\" _v-22523bcd=\"\">預約方式</span>\n                        <select class=\"input-sm form-control\" v-model=\"view.filters.booking_method\" _v-22523bcd=\"\">\n                            <option value=\"\" _v-22523bcd=\"\">請選擇</option>\n                            <option value=\"1\" _v-22523bcd=\"\">方案</option>\n                            <option value=\"2\" _v-22523bcd=\"\">單次</option>\n                            <option value=\"3\" _v-22523bcd=\"\">單次/方案</option>\n                        </select>\n                    </div>\n                </div>\n                <div class=\"form-group search-option\" _v-22523bcd=\"\">\n                    <div class=\"input-group\" _v-22523bcd=\"\">\n                        <span class=\"input-group-addon\" _v-22523bcd=\"\">結帳</span>\n                        <select class=\"input-sm form-control\" v-model=\"view.filters.payment_status\" _v-22523bcd=\"\">\n                            <option value=\"\" _v-22523bcd=\"\">請選擇</option>\n                            <option value=\"1\" _v-22523bcd=\"\">未結帳</option>\n                            <option value=\"2\" _v-22523bcd=\"\">已結帳</option>\n                            <option value=\"3\" _v-22523bcd=\"\">免結帳</option>\n                        </select>\n                    </div>\n                </div>\n                <div class=\"form-group search-option\" _v-22523bcd=\"\">\n                    <div class=\"input-group\" _v-22523bcd=\"\">\n                        <span class=\"input-group-addon\" _v-22523bcd=\"\">狀態</span>\n                        <select class=\"input-sm form-control\" v-model=\"view.filters.booking_status\" _v-22523bcd=\"\">\n                            <option value=\"\" _v-22523bcd=\"\">請選擇</option>\n                            <option value=\"unstart\" _v-22523bcd=\"\">尚未開始</option>\n                            <option value=\"absence\" _v-22523bcd=\"\">缺席</option>\n                            <option value=\"cancel\" _v-22523bcd=\"\">取消</option>\n                            <option value=\"cancellate\" _v-22523bcd=\"\">遲退</option>\n                            <option value=\"finish\" _v-22523bcd=\"\">已完成</option>\n                        </select>\n                    </div>\n                </div>\n            </div>\n            <div class=\"col-sm-3\" _v-22523bcd=\"\">\n                <div class=\"form-group search-option\" _v-22523bcd=\"\">\n                    預約日期範圍\n                </div>\n                <div class=\"form-group search-option\" _v-22523bcd=\"\">\n                    <div class=\"input-group\" _v-22523bcd=\"\">\n                        <span class=\"input-group-addon\" _v-22523bcd=\"\">開始日期</span>\n                        <input type=\"text\" class=\"input-sm form-control datepicker-vue\" id=\"start_date\" name=\"start_date\" v-model=\"view.filters.start_date\" lazy=\"\" _v-22523bcd=\"\">\n                    </div>\n                </div>\n                <div class=\"form-group search-option\" _v-22523bcd=\"\">\n                    <div class=\"input-group\" _v-22523bcd=\"\">\n                        <span class=\"input-group-addon\" _v-22523bcd=\"\">結束日期</span>\n                        <input type=\"text\" class=\"input-sm form-control datepicker-vue\" id=\"end_date\" name=\"end_date\" v-model=\"view.filters.end_date\" lazy=\"\" _v-22523bcd=\"\">\n                    </div>\n                </div>\n            </div>\n            <div class=\"col-sm-3\" _v-22523bcd=\"\">\n                <div class=\"search-btn btn btn-primary m-right-5 p-left-20 p-right-20\" @click=\"searchList\" _v-22523bcd=\"\">搜尋</div>\n                <a class=\"reset-btn btn btn-default\" href=\"/webadmin/service-bookings/list\" _v-22523bcd=\"\">重設</a>\n            </div>\n        </div>\n        <v-spinner :ajaxing=\"view.ajaxing\" _v-22523bcd=\"\"></v-spinner>\n        <div class=\"table-responsive\" v-if=\"Object.keys(this.view.list).length>0&amp;&amp;!view.ajaxing\" _v-22523bcd=\"\">\n            <table class=\"table table-hover service-bookings-table\" _v-22523bcd=\"\">\n                <thead _v-22523bcd=\"\">\n                <tr _v-22523bcd=\"\">\n                    <th _v-22523bcd=\"\"></th>\n                    <th _v-22523bcd=\"\">客戶</th>\n                    <th _v-22523bcd=\"\">預約日期</th>\n                    <th _v-22523bcd=\"\">時間</th>\n                    <th _v-22523bcd=\"\">服務項目</th>\n                    <th _v-22523bcd=\"\">預約方式</th>\n                    <th _v-22523bcd=\"\">結帳</th>\n                    <th _v-22523bcd=\"\">狀態</th>\n                </tr>\n                </thead> \n                <tbody _v-22523bcd=\"\">\n                <tr v-for=\"(booking, idx) in view.list\" @click=\"showModal(booking)\" _v-22523bcd=\"\">\n                    <td _v-22523bcd=\"\">\n\t\t\t\t\t\t<span v-if=\"booking.open_modal_action==1\" _v-22523bcd=\"\">\n\t\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-primary btn-xs\" :data-uid=\"booking.id\" @click=\"showModal(booking)\" _v-22523bcd=\"\">\n                                <i class=\"fa fa-pencil\" help=\"修改\" _v-22523bcd=\"\"></i>\n                            </button>\n\t\t\t\t\t\t</span>\n                        <span v-else=\"\" _v-22523bcd=\"\">\n\t\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-default btn-xs\" :data-uid=\"booking.id\" @click=\"showModal(booking)\" _v-22523bcd=\"\">\n                                <i class=\"fa fa-eye\" help=\"檢視\" _v-22523bcd=\"\"></i>\n                            </button>\n\t\t\t\t\t\t</span>\n                        <v-admin-operate-record type=\"appointment\" :id=\"booking.id\" :additions=\"['cancel']\" _v-22523bcd=\"\"></v-admin-operate-record>\n                    </td>\n                    <td _v-22523bcd=\"\">\n                        <a class=\"modal-link\" :data-member-id=\"booking.member_id\" @mouseover.prevent=\"hoverOnName\" _v-22523bcd=\"\">\n                            {{booking.member_name}}\n                        </a>\n                        <input type=\"hidden\" class=\"studio\" :value=\"booking.studio_id\" _v-22523bcd=\"\">\n                    </td>\n                    <td _v-22523bcd=\"\">{{booking.start_date}}</td>\n                    <td _v-22523bcd=\"\">{{booking.start_time}}</td>\n                    <td v-html=\"replaceServiceName(booking.appointment_schedule)\" _v-22523bcd=\"\"></td>\n                    <td _v-22523bcd=\"\">{{booking.booking_method}}</td>\n                    <td _v-22523bcd=\"\">{{booking.payment_status}}</td>\n                    <td _v-22523bcd=\"\">{{booking.show_status}}</td>\n                </tr>\n                </tbody>\n            </table>\n        </div>\n        <v-sql-pagination v-show=\"!view.ajaxing\" ref=\"pager\" :page-meta=\"view.pageMeta\" @page-change-callback=\"fetchList\" _v-22523bcd=\"\">\n        </v-sql-pagination>\n        <service-booking-modal @refresh=\"refresh\" ref=\"serviceBookingModal\" _v-22523bcd=\"\"></service-booking-modal>\n        <v-member-profile-overview :member-id=\"selectMemberId\" ref=\"memberProfileOverview\" position-config=\"webadmin/booking/schedule-service:modal.member\" _v-22523bcd=\"\"></v-member-profile-overview>\n    </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.service-bookings-table tbody tr[_v-22523bcd] {\n  cursor: pointer; }\n\n/* line 6, stdin */\n.select2-container--default .select2-selection--single .select2-selection__placeholder[_v-22523bcd] {\n  color: inherit; }\n\n/* line 10, stdin */\n.select-outer-div[_v-22523bcd] {\n  display: block !important; }\n\n/* line 14, stdin */\n.search-option[_v-22523bcd] {\n  max-width: 400px; }\n\n@media screen and (min-width: 768px) {\n  /* line 19, stdin */\n  #search-member[_v-22523bcd] {\n    margin: 0 10px 0 0;\n    min-width: 150px; } }\n\n@media screen and (max-width: 768px) {\n  /* line 26, stdin */\n  #search-member[_v-22523bcd] {\n    margin-top: 15px;\n    max-width: 400px; } }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-22523bcd", module.exports)
  } else {
    hotAPI.update("_v-22523bcd", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1436:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {},
    data: function data() {
        return {
            title: '預約資料',
            view: {
                booking: {},
                currentBookingId: 0
            }
        };
    },
    mounted: function mounted() {},

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({})),
    methods: {
        billSuccessCallBack: function billSuccessCallBack() {
            this.$store.dispatch('pos/resetSelectOrder');
            this.$store.dispatch('pos/orderEditSucces');
            window.Event.$emit('System.Booking.Checkout', this.view.currentBookingId);
            this.refresh();
        },
        billFailCallBack: function billFailCallBack() {
            $('#order-edit').modal('hide');
            $('#multi-alert-modal').modal('show');
            window.Event.$emit('System.Booking.Checkout', this.view.currentBookingId);
            this.refresh();
        },
        onCall: function onCall(bookingId, createPayload) {
            if (bookingId > 0 && typeof createPayload === 'undefined') {
                this.title = '預約資料';
                this.view.currentBookingId = bookingId;
                this.show();
            } else {
                this.title = '新增預約';
                this.$refs.serviceBookingEditModal.onCall(0, 'create', createPayload);
                $('#service-booking-edit-modal').modal('show');
            }
        },
        show: function show() {
            var _this = this;

            this.$http.get('/adminapi/service-bookings/show/' + this.view.currentBookingId).then(function (response) {
                _this.view.booking = response.body.booking;
                if (response.body.status === 'edit') {
                    _this.$refs.serviceBookingEditModal.onCall(_this.view.booking, 'update');
                    $('#service-booking-edit-modal').modal('show');
                } else {
                    _this.$refs.serviceBookingViewModal.onCall(_this.view.booking);
                    $('#service-booking-view-modal').modal('show');
                }
            }, function (error) {
                $17.swal({
                    title: '開啟服務預約失敗',
                    type: 'error',
                    showCancelButton: false
                });
            });
        },
        refresh: function refresh() {
            $('#service-booking-edit-modal').modal('hide');
            $('#service-booking-view-modal').modal('hide');
            this.$emit('refresh');
        },
        orderBilled: function orderBilled() {
            this.show();
            this.refresh();
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-586eafb0=\"\">\n    <v-modal id=\"service-booking-view-modal\" no-footer=\"\" :body-class=\"['p-bottom-0']\" _v-586eafb0=\"\">\n        <div slot=\"title\" _v-586eafb0=\"\">\n            {{title}}\n            <v-admin-operate-record type=\"appointment\" :id=\"view.currentBookingId\" _v-586eafb0=\"\"></v-admin-operate-record>\n        </div>\n        <service-booking-view-modal slot=\"body\" @refresh=\"refresh\" ref=\"serviceBookingViewModal\" _v-586eafb0=\"\">\n        </service-booking-view-modal>\n    </v-modal>\n    <v-modal id=\"service-booking-edit-modal\" no-footer=\"\" :body-class=\"['p-bottom-0']\" _v-586eafb0=\"\">\n        <div slot=\"title\" _v-586eafb0=\"\">\n            {{title}}\b\b\n            <v-admin-operate-record v-if=\"view.currentBookingId !=0\" type=\"appointment\" :id=\"view.currentBookingId\" _v-586eafb0=\"\"></v-admin-operate-record>\n        </div>\n        <service-booking-edit-modal slot=\"body\" @refresh=\"refresh\" @order-billed=\"orderBilled\" ref=\"serviceBookingEditModal\" _v-586eafb0=\"\">\n        </service-booking-edit-modal>\n    </v-modal>\n    <webadmin-operate-modal ref=\"operate\" :enable-change-member=\"false\" event-scope=\"webadmin\" _v-586eafb0=\"\">\n        <template slot=\"event\">\n            <webadmin-order-operate-event-slot-utility event-scope=\"webadmin\" :operate-ref=\"$refs.operate\" _v-586eafb0=\"\"></webadmin-order-operate-event-slot-utility>\n        </template>\n    </webadmin-operate-modal>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-586eafb0", module.exports)
  } else {
    hotAPI.update("_v-586eafb0", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vuex":803}],1437:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vuex = require('vuex');

exports.default = {
    props: {},
    data: function data() {
        return {
            view: {
                ajaxing: false,
                booking: {},
                currentBookingId: 0,
                button_status: {
                    show_attend_absence_buttons: 0,
                    show_checked_attend: 0,
                    show_checked_absence: 0
                }
            }
        };
    },
    mounted: function mounted() {},

    computed: {},
    methods: {
        replaceServiceName: function replaceServiceName(names) {
            if (typeof names !== 'undefined') {
                return names.replace(/,/g, '<br/>');
            }
        },
        onCall: function onCall(booking) {
            this.view.currentBookingId = booking.id;
            this.view.booking = booking;
            this.view.button_status.show_attend_absence_buttons = this.view.booking.show_attend_absence_buttons;
            this.view.button_status.show_checked_attend = this.view.booking.show_checked_attend;
            this.view.button_status.show_checked_absence = this.view.booking.show_checked_absence;
        },
        finishModal: function finishModal() {
            this.$emit('refresh');
            $('#service-booking-view-modal').modal('hide');
        },
        openOrder: function openOrder() {
            var _this = this;

            this.$http.get('/adminapi/pos/booking/' + this.view.currentBookingId + '/order').then(function (response) {
                $('#service-booking-edit-modal').modal('hide');
                window.Event.$emit("System.Pos.Order.Open", {
                    'order_id': _this.view.booking.order_id,
                    'booking_id': _this.view.currentBookingId,
                    'mode': 'show',
                    'event_type': 'serviceBooking'
                });
            }, function (error) {
                $17.swal({
                    title: '開啟訂單失敗',
                    type: 'error',
                    showCancelButton: false
                });
            });
            $.unblockUI();
        },
        hoverOnName: function hoverOnName(e) {
            window.Event.$emit('MemberCard.Show', e.target);
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-32727e0c=\"\">\n                <v-spinner :ajaxing=\"view.ajaxing\" _v-32727e0c=\"\"></v-spinner>\n                <div v-show=\"!view.ajaxing\" _v-32727e0c=\"\">\n                    <div class=\"form-horizontal\" _v-32727e0c=\"\">\n                        <div class=\"form-group\" _v-32727e0c=\"\">\n                            <label class=\"col-sm-3 control-label\" _v-32727e0c=\"\">客戶</label>\n                            <div class=\"col-sm-9\" _v-32727e0c=\"\">\n                                <label @mouseover.prevent=\"hoverOnName\" _v-32727e0c=\"\">{{view.booking.member_name}}</label>\n                                <span v-show=\"view.booking.booking_admin===0\" class=\"label label-info m-left-5\" style=\"font-size:100%\" _v-32727e0c=\"\">線上預約</span>\n                            </div>\n                        </div>\n                        <div class=\"form-group\" v-if=\"view.booking.member_is_walkin!=1\" _v-32727e0c=\"\">\n                            <label class=\"col-sm-3 control-label\" _v-32727e0c=\"\">手機</label>\n                            <div class=\"col-sm-9\" _v-32727e0c=\"\">\n                                <label _v-32727e0c=\"\">{{view.booking.member_phone}}</label>\n                            </div>\n                        </div>\n                        <div class=\"form-group\" _v-32727e0c=\"\">\n                            <label class=\"col-sm-3 control-label\" _v-32727e0c=\"\">日期</label>\n                            <div class=\"col-sm-9\" _v-32727e0c=\"\">\n                                <label _v-32727e0c=\"\">{{view.booking.start_date}}</label>\n                            </div>\n                        </div>\n                        <div class=\"form-group\" _v-32727e0c=\"\">\n                            <label class=\"col-sm-3 control-label\" _v-32727e0c=\"\">時段</label>\n                            <div class=\"col-sm-9\" _v-32727e0c=\"\">\n                                <label _v-32727e0c=\"\">{{view.booking.time_range}}</label>\n                            </div>\n                        </div>\n                        <div class=\"form-group\" _v-32727e0c=\"\">\n                            <label class=\"col-sm-3 control-label\" _v-32727e0c=\"\">時間</label>\n                            <div class=\"col-sm-9\" _v-32727e0c=\"\">\n                                <label _v-32727e0c=\"\">{{view.booking.service_time}}</label>\n                            </div>\n                        </div>\n                        <div class=\"form-group\" _v-32727e0c=\"\">\n                            <label class=\"col-sm-3 control-label\" _v-32727e0c=\"\">服務</label>\n                            <div class=\"col-sm-9\" _v-32727e0c=\"\">\n                                <label v-html=\"replaceServiceName(view.booking.appointment_schedule)\" _v-32727e0c=\"\"></label>\n                            </div>\n                        </div>\n                        <div class=\"form-group\" v-if=\"view.booking.booked_by_contract===0\" _v-32727e0c=\"\">\n                            <label class=\"col-sm-3 control-label\" _v-32727e0c=\"\">費用</label>\n                            <div class=\"col-sm-9\" _v-32727e0c=\"\">\n                                <label v-if=\"view.booking.order_id!==''\" @click=\"openOrder\" _v-32727e0c=\"\">$ {{view.booking.order_total}} <i class=\"fa fa-plus-circle\" _v-32727e0c=\"\"></i></label>\n                                <label v-else=\"\" _v-32727e0c=\"\">$ {{view.booking.order_total}}</label>\n                            </div>\n                        </div>\n                        <div class=\"form-group\" _v-32727e0c=\"\">\n                            <label class=\"col-sm-3 control-label\" _v-32727e0c=\"\">人員</label>\n                            <div class=\"col-sm-9\" _v-32727e0c=\"\">\n                                <label _v-32727e0c=\"\">{{view.booking.service_provider_name}}</label>\n                            </div>\n                        </div>\n                        <div class=\"form-group\" v-if=\"view.booking.client_booking_note\" _v-32727e0c=\"\">\n                            <label class=\"col-sm-3 control-label\" _v-32727e0c=\"\">客戶預約備註</label>\n                            <div class=\"col-sm-9\" _v-32727e0c=\"\">\n                                <label _v-32727e0c=\"\">{{view.booking.client_booking_note}}</label>\n                            </div>\n                        </div>\n                        <div class=\"form-group\" v-if=\"view.booking.notice\" _v-32727e0c=\"\">\n                            <label class=\"col-sm-3 control-label\" _v-32727e0c=\"\">管理備註</label>\n                            <div class=\"col-sm-9\" _v-32727e0c=\"\">\n                                <label _v-32727e0c=\"\">{{view.booking.notice}}</label>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                    <service-booking-modal-buttons v-show=\"!view.ajaxing\" @refresh=\"finishModal\" :current-booking-id=\"view.currentBookingId\" action=\"view\" :button-status=\"view.button_status\" _v-32727e0c=\"\">\n                    </service-booking-modal-buttons>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-32727e0c", module.exports)
  } else {
    hotAPI.update("_v-32727e0c", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vuex":803}],1438:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 3, stdin */\ninput[type=checkbox] .form-control[_v-43ec95f0] {\n  box-shadow: none; }\n\n/* line 8, stdin */\n.submit[_v-43ec95f0] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center; }\n\n/* line 13, stdin */\n.avatar[_v-43ec95f0] {\n  width: 100px;\n  height: 100px; }\n\n/* line 18, stdin */\n.pointer[_v-43ec95f0] {\n  cursor: pointer; }\n\n/* line 23, stdin */\n.show-photo[_v-43ec95f0] {\n  min-width: 210px;\n  text-align: center; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {},
    data: function data() {
        return {
            sortType: 1,
            ajaxing: false,
            ajaxingAvatar: false,
            changed: false,
            currentBranchId: null,
            oldBranchId: null,
            dataList: {},
            url: ""
        };
    },

    methods: {
        branchChangeCallBack: function () {
            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(branchId) {
                var _this = this;

                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!(branchId == 'null')) {
                                    _context.next = 2;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 2:
                                if (this.changed) {
                                    _context.next = 5;
                                    break;
                                }

                                this.getBranchData(branchId);
                                return _context.abrupt('return');

                            case 5:
                                $17.swal({
                                    title: '確認更換場館?',
                                    text: "異動資料將消失, 請先儲存變更！",
                                    type: 'warning'
                                }, function (result) {
                                    if (result) {
                                        _this.getBranchData(branchId);
                                        _this.changed = false;
                                        return;
                                    } else {
                                        _this.selected_branch_id = _this.oldBranchId;
                                        $("#ssab_branch_id").val(_this.oldBranchId).trigger('change.select2');
                                    }
                                });

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function branchChangeCallBack(_x) {
                return _ref.apply(this, arguments);
            }

            return branchChangeCallBack;
        }(),
        getBranchData: function getBranchData(branchId) {
            var _this2 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _this2.ajaxing = true;
                                _context2.next = 3;
                                return _this2.$http.get('/adminapi/service-provider-execute-module/customs/' + branchId).then(function (response) {
                                    _this2.dataList = response.body;
                                    _this2.ajaxing = false;
                                    _this2.oldBranchId = branchId;
                                    _this2.currentBranchId = branchId;
                                }, function (error) {
                                    $17.swal({
                                        title: '讀取資料發生錯誤',
                                        text: error.data.message,
                                        type: 'error',
                                        showCancelButton: false
                                    });
                                    _this2.ajaxing = false;
                                });

                            case 3:
                                _this2.changed = false;

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        updateCurrentBranch: function updateCurrentBranch() {
            var _this3 = this;

            this.ajaxing = true;
            this.$http.post('/adminapi/service-provider-execute-module/customs/' + this.currentBranchId, { data: (0, _stringify2.default)(this.dataList) }).then(function (response) {
                $17.swal({
                    title: '資料已更新',
                    type: 'success',
                    showCancelButton: false
                });
                _this3.ajaxing = false;
                _this3.getBranchData(_this3.currentBranchId);
            }, function (error) {
                $17.swal({
                    title: '更新資料發生錯誤',
                    text: error.data.message,
                    type: 'error',
                    showCancelButton: false
                });
                _this3.ajaxing = false;
            });
        },
        loadFile: function loadFile(event, index, id) {
            var _this4 = this;

            $17.imageCropToString({
                image: event.target.files[0],
                inputId: 'picture',
                width: 400,
                height: 400,
                cropBtnClass: 'btn btn--primary',
                reUploadBtnClass: 'btn btn-default',
                showCropCircle: false,
                callback: function () {
                    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(imageString) {
                        return _regenerator2.default.wrap(function _callee3$(_context3) {
                            while (1) {
                                switch (_context3.prev = _context3.next) {
                                    case 0:
                                        _this4.ajaxingAvatar = true;

                                        if (!(imageString == 'fail crop')) {
                                            _context3.next = 3;
                                            break;
                                        }

                                        return _context3.abrupt('return', false);

                                    case 3:
                                        _context3.next = 5;
                                        return _this4.$http.post('/adminapi/service-provider-execute-module/customs/avatar/' + id, { image: imageString }, {
                                            headers: {
                                                'Content-Type': 'multipart/form-data'
                                            }
                                        });

                                    case 5:
                                        _this4.ajaxingAvatar = false;
                                        $('#pic_' + index).val('');
                                        document.getElementById('pic_' + index).src = imageString;

                                    case 8:
                                    case 'end':
                                        return _context3.stop();
                                }
                            }
                        }, _callee3, _this4);
                    }));

                    return function callback(_x2) {
                        return _ref2.apply(this, arguments);
                    };
                }()
            });
        },
        clickFileInput: function clickFileInput(index) {
            if (this.ajaxingAvatar) {
                return;
            }
            if (!this.dataList[index]['custom_img']) {
                return;
            }
            $('#pic_file_' + index).val('');
            $('#pic_file_' + index).trigger('click');
        },
        changeChanged: function changeChanged() {
            this.changed = true;
        },
        openAlbum: function openAlbum(id, name, mediaAlbumId) {
            var _this5 = this;

            if (mediaAlbumId == null) {
                var postData = {
                    name: name,
                    id: id
                };
                this.$http.post('/adminapi/media/studio-album/create/service-provider', postData).then(function (response) {
                    _this5.getBranchData(_this5.currentBranchId);
                    window.open('/webadmin/media/studio-album/' + response.data.albumId);
                }, function (error) {
                    $17.swal({
                        title: '新增資料發生錯誤',
                        text: error.data.message,
                        type: 'error',
                        showCancelButton: false
                    });
                });
            } else {
                window.open('/webadmin/media/studio-album/' + mediaAlbumId);
            }
        }
    },
    mounted: function mounted() {},
    watch: {
        branchId: function () {
            var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(val, oldVal) {
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                if (this.isBranch) {
                                    this.branchChangeCallBack(val);
                                }

                            case 1:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function branchId(_x3, _x4) {
                return _ref3.apply(this, arguments);
            }

            return branchId;
        }()
        // dataList:{
        //     handler(newName, oldName) {
        //         if(this.ajaxing){
        //             return;
        //         }
        //          this.changed = true;
        //     },

        //     deep: true
        // }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId', 'isBranch']), {
        selected_branch_id: {
            get: function get() {
                return this.$store.state.filters.selected_branch_id;
            },
            set: function set(branch_id) {
                this.$store.commit('filters/SETSTATUS', { 'key': 'selected_branch_id', value: branch_id });
            }
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-43ec95f0=\"\">\n    <v-select-studio-and-branch :studio_id=\"studioId\" :branch_id=\"branchId\" :branch-change-call-back=\"branchChangeCallBack\" :branch-without-filtered-option=\"false\" _v-43ec95f0=\"\"></v-select-studio-and-branch>\n    <v-spinner :ajaxing=\"ajaxing\" _v-43ec95f0=\"\"></v-spinner>\n    <div class=\"table-responsive\" v-show=\"!ajaxing\" _v-43ec95f0=\"\">\n        <table class=\"table\" _v-43ec95f0=\"\">\n            <thead _v-43ec95f0=\"\">\n            <tr _v-43ec95f0=\"\">\n                <th class=\"text-center col-sm-2\" _v-43ec95f0=\"\">服務提供者</th>\n                <th class=\"col-sm-1\" _v-43ec95f0=\"\">\n                    自訂排序\n                    <a href=\"javascript:void(0)\" _v-43ec95f0=\"\"><i class=\"fa fa-question-circle column_desc\" help=\"您可以在此設定人員列表中每一位服務人員的排序：依照數字由小到大進行排列，最小為0，數字越小的人員排列越前。\" _v-43ec95f0=\"\"></i></a>\n                </th>\n                <th class=\"col-sm-1\" _v-43ec95f0=\"\">顯示於線上</th>\n                <th class=\"col-sm-1\" _v-43ec95f0=\"\">顯示於後台行事曆</th>\n                <th class=\"col-sm-1\" _v-43ec95f0=\"\">自訂照片</th>\n                <th class=\"show-photo col-sm-2\" _v-43ec95f0=\"\">顯示照片</th>\n                <th class=\"col-sm-4\" _v-43ec95f0=\"\">顯示相簿於線上</th>\n            </tr>\n            </thead>\n            <tbody _v-43ec95f0=\"\">\n            <tr v-for=\"(row,index) in dataList\" _v-43ec95f0=\"\">\n                <td class=\"text-center\" _v-43ec95f0=\"\">\n                    <img :src=\"row['default_img']\" class=\"avatar\" onerror=\"this.src ='/images/default.png';\" _v-43ec95f0=\"\">\n                    <p _v-43ec95f0=\"\">{{ row['default_name'] }}</p>\n                </td>\n                <td _v-43ec95f0=\"\">\n                    <input type=\"number\" min=\"0\" @change=\"changeChanged()\" v-model=\"dataList[index]['custom_serial']\" class=\"form-control\" _v-43ec95f0=\"\">\n                </td>\n                <td _v-43ec95f0=\"\">\n                    <input type=\"checkbox\" v-model=\"dataList[index]['show_online']\" :true-value=\"1\" :false-value=\"0\" @change=\"changeChanged()\" _v-43ec95f0=\"\">\n                </td>\n                <td _v-43ec95f0=\"\">\n                    <input type=\"checkbox\" v-model=\"dataList[index]['show_on_calender']\" :true-value=\"1\" :false-value=\"0\" @change=\"changeChanged()\" _v-43ec95f0=\"\">\n                </td>\n                <td _v-43ec95f0=\"\">\n                    <input type=\"checkbox\" v-model=\"dataList[index]['custom_img']\" :true-value=\"1\" :false-value=\"0\" @change=\"changeChanged()\" _v-43ec95f0=\"\">\n                </td>\n                <td @click=\"clickFileInput(index)\" class=\"show-photo\" _v-43ec95f0=\"\">\n                    <v-spinner-button :ajaxing=\"ajaxingAvatar\" _v-43ec95f0=\"\"></v-spinner-button>\n                    <span v-show=\"dataList[index]['custom_img'] &amp;&amp; !ajaxingAvatar\" class=\"pointer\" _v-43ec95f0=\"\">\n                            <img class=\"avatar\" :src=\"row['custom_pic_path']\" alt=\"\" :id=\"'pic_'+index\" onerror=\"this.src ='/images/default.png';\" _v-43ec95f0=\"\">\n                            <input type=\"file\" v-show=\"false\" name=\"\" :id=\"'pic_file_'+index\" @change=\"loadFile($event,index,row['id'])\" accept=\"image/gif, image/jpeg, image/png, image/jpg, image/x-icon\" _v-43ec95f0=\"\">\n                            <div class=\"text-danger\" _v-43ec95f0=\"\">(請上傳.jpg、png、gif)</div>\n                        </span>\n                </td>\n                <td _v-43ec95f0=\"\">\n                    <div class=\"m-bottom-10\" _v-43ec95f0=\"\">\n                        <input type=\"checkbox\" v-model=\"dataList[index]['show_studio_album']\" :true-value=\"1\" :false-value=\"0\" @change=\"changeChanged()\" _v-43ec95f0=\"\">顯示品牌相簿\n                        <a href=\"#\" @click.prevent=\"openAlbum(row['id'], row['default_name'], row['studio_media_album_id'])\" target=\"_blank\" _v-43ec95f0=\"\">管理</a>\n                    </div>\n                    <div _v-43ec95f0=\"\">\n                        <input type=\"checkbox\" v-model=\"dataList[index]['show_account_album']\" :true-value=\"1\" :false-value=\"0\" @change=\"changeChanged()\" _v-43ec95f0=\"\">顯示 17FIT 帳戶相簿\n                    </div>\n                </td>\n            </tr>\n            </tbody>\n        </table>\n        <div class=\"submit\" _v-43ec95f0=\"\">\n            <input type=\"button\" value=\"儲存\" class=\"btn btn-primary\" @click=\"updateCurrentBranch\" _v-43ec95f0=\"\">\n        </div>\n\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 3, stdin */\ninput[type=checkbox] .form-control[_v-43ec95f0] {\n  box-shadow: none; }\n\n/* line 8, stdin */\n.submit[_v-43ec95f0] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center; }\n\n/* line 13, stdin */\n.avatar[_v-43ec95f0] {\n  width: 100px;\n  height: 100px; }\n\n/* line 18, stdin */\n.pointer[_v-43ec95f0] {\n  cursor: pointer; }\n\n/* line 23, stdin */\n.show-photo[_v-43ec95f0] {\n  min-width: 210px;\n  text-align: center; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-43ec95f0", module.exports)
  } else {
    hotAPI.update("_v-43ec95f0", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/json/stringify":48,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1439:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _customs = require('./customs.vue');

var _customs2 = _interopRequireDefault(_customs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//Page
_vue2.default.component('webadmin-service-provider-execute-module-customs', _customs2.default);

},{"./customs.vue":1438,"vue":792}],1440:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            component: '',
            keepAliveInclude: []
        };
    },

    name: 'WebadminRouterView',
    created: function created() {
        this.bootstrapWebadmin();
        this.init();
    },

    watch: {
        '$route.query': {
            handler: function handler(newVal) {
                if (!_lodash2.default.isEmpty(newVal)) {
                    this.updateView();
                }
            },

            deep: true,
            immediate: true
        }
    },
    mounted: function mounted() {},

    methods: {
        init: function init() {
            var subPage = this.checkSubPage();
            this.keepAliveInclude = this.$route.meta.keep_alive_include || [];
            this.$router.replace({
                name: this.$route.name,
                params: (0, _extends3.default)({}, this.$route.params),
                query: (0, _extends3.default)({}, this.$route.query, {
                    sub_page: subPage
                })
            });
            $17.toggleWebadminTopTabsByQuery();
        },
        updateView: function updateView() {
            var subPage = this.checkSubPage();
            this.component = this.$route.meta.sub_page[subPage].component;
            $17.toggleWebadminTopTabsByQuery();
        },
        checkSubPage: function checkSubPage() {
            var redirect = this.$route.meta.sub_page[''].redirect();
            var subPage = this.$route.query.sub_page || '';
            if (!subPage || _lodash2.default.isEmpty(this.$route.meta.sub_page[subPage])) {
                subPage = redirect.path;
            }
            return subPage;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-54e7ac90=\"\">\n    <keep-alive :include=\"keepAliveInclude\" _v-54e7ac90=\"\">\n        <component :is=\"component\" _v-54e7ac90=\"\"></component>\n    </keep-alive>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-54e7ac90", module.exports)
  } else {
    hotAPI.update("_v-54e7ac90", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"lodash":717,"vue":792,"vue-hot-reload-api":785}],1441:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = require('vue-router');

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _calendarClass = require('./router/calendar-class');

var _calendarClass2 = _interopRequireDefault(_calendarClass);

var _printDeviceSetting = require('./router/print-device-setting');

var _printDeviceSetting2 = _interopRequireDefault(_printDeviceSetting);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

var routes = [].concat(_calendarClass2.default).concat(_printDeviceSetting2.default);

var routesConverter = function routesConverter(routes) {
    var result = [];
    routes.forEach(function (element) {
        var route = element;
        var subPage = {};
        route.children.forEach(function (page) {
            subPage[page.path] = page;
        });
        route.meta['sub_page'] = subPage;
        delete route.children;
        result.push(route);
    });
    return result;
};

var WebadminRouter = new _vueRouter2.default({
    mode: 'history',
    routes: routesConverter(routes)
});

exports.default = WebadminRouter;

/*
 * [Note] webadmin 透過 query 同頁切換 component 用法
 * Step1 : php Route 使用 'uses' => 'VueController@routerView'
 * Step2 : 新增相對應 vue-router
 * 其他備註 : router 無針對權限做控管，基本只要有當頁權限就能使用
 * 參考 calendar-class
 * {
        path: '/webadmin/calendar/classes', //對應 webadmin 真實網址
        name: 'calendar.class.index',
        meta: {
            keep_alive_include: ['schedule-full-calendar-index']
        },
        children: [ // 模擬 vue-router 寫法，但實際上會透過 routesConverter 將參數轉入 meta 使用
            {
                path: '', // [required] 預設初始頁面
                redirect: to => {
                    return {
                        path: 'calendar'
                    }
                }
            },
            {
                path: 'calendar', // query sub_page name (?sub_page=calendar)
                name: 'calendar.class.fullcalendar', // 暫時無用
                component: 'schedule-full-calendar-index' // vue component name
            },
            {
                path: 'class_copy',
                name: 'calendar.class.copy',
                component: 'class-copy-set-branch',
            }
        ]
    },
 */

},{"./router/calendar-class":1442,"./router/print-device-setting":1443,"vue":792,"vue-router":789}],1442:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = [{
    path: '/webadmin/calendar/classes',
    name: 'calendar.class.index',
    meta: {
        keep_alive_include: ['schedule-full-calendar-index']
    },
    children: [{
        path: '',
        redirect: function redirect(to) {
            return {
                path: 'calendar'
            };
        }
    }, {
        path: 'calendar',
        name: 'calendar.class.fullcalendar',
        component: 'schedule-full-calendar-index'
    }, {
        path: 'class_copy',
        name: 'calendar.class.copy',
        component: 'class-copy-index'
    }]
}];

},{}],1443:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = [{
    path: '/webadmin/print-device',
    name: 'setting.printer.index',
    meta: {
        keep_alive_include: ['webadmin-print-device-index']
    },
    children: [{
        path: '',
        redirect: function redirect(to) {
            return {
                path: 'printer_list'
            };
        }
    }, {
        path: 'printer_list',
        name: 'setting.printer.list',
        component: 'webadmin-print-device-index'
    }, {
        path: 'printer_setting',
        name: 'setting.printer.auto.print',
        component: 'web-local-setting'
    }]
}];

},{}],1444:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _messageModal = require('./message-modal.vue');

var _messageModal2 = _interopRequireDefault(_messageModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//Page
_vue2.default.component('webadmin-studio-message-modal', _messageModal2.default);

},{"./message-modal.vue":1445,"vue":792}],1445:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['studioId'],
    data: function data() {
        return {
            remainOld: 0,
            remain: 0,
            studioMessageId: null,
            ajaxing: false
        };
    },
    methods: {
        getCurrent: function getCurrent() {
            var _this = this;

            this.ajaxing = true;
            this.$http.get('/adminapi/studio_message/' + this.studioId).then(function (response) {
                _this.studioMessageId = response.data.id;
                _this.remain = response.data.remain;
                _this.remainOld = response.data.remain;
                _this.ajaxing = false;
            }, function (error) {
                _this.ajaxing = false;
            });
        },
        update: function update() {
            var _this2 = this;

            this.ajaxing = true;
            this.$http.post('/adminapi/studio_message/' + this.studioMessageId, {
                remain: this.remain
            }).then(function (response) {
                _this2.remain = response.data.remain;
                _this2.remainOld = response.data.remain;
                _this2.ajaxing = false;
            }, function (error) {
                _this2.ajaxing = false;
            });
        }
    },
    watch: {
        studioId: function studioId(newVal) {
            this.getCurrent();
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal id=\"studioMessageModal\" no-cancel=\"\" confirm-btn-text=\"修改\" :save-clicked=\"update\" _v-26e7bd83=\"\">\n    <h4 slot=\"title\" _v-26e7bd83=\"\">修改剩餘訊息</h4>\n    <div slot=\"body\" _v-26e7bd83=\"\">\n        <form class=\"form-horizontal\" v-show=\"!ajaxing\" _v-26e7bd83=\"\">\n            <div class=\"form-group\" _v-26e7bd83=\"\">\n                <label for=\"remain\" class=\"col-sm-3 control-label\" _v-26e7bd83=\"\">原始可用數量</label>\n                <div class=\"col-sm-9\" _v-26e7bd83=\"\">\n                    <p class=\"form-control-static\" _v-26e7bd83=\"\">{{remainOld}}</p>\n                </div>\n            </div>\n            <div class=\"form-group\" _v-26e7bd83=\"\">\n                <label for=\"remain\" class=\"col-sm-3 control-label\" _v-26e7bd83=\"\">修改數量</label>\n                <div class=\"col-sm-9\" _v-26e7bd83=\"\">\n                    <input for=\"remain\" id=\"editremain\" class=\"form-control\" v-model=\"remain\" type=\"number\" _v-26e7bd83=\"\">\n                </div>\n            </div>\n        </form>\n        <v-spinner :ajaxing=\"ajaxing\" _v-26e7bd83=\"\"></v-spinner>\n    </div>\n</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-26e7bd83", module.exports)
  } else {
    hotAPI.update("_v-26e7bd83", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],1446:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 3, stdin */\n#vue-app-theme-setting .title[_v-320b64ef] {\n  font-size: 21px;\n  font-weight: 500;\n  margin-bottom: 7px; }\n\n/* line 8, stdin */\n#vue-app-theme-setting .desciprtion[_v-320b64ef] {\n  font-size: 16px;\n  color: #4a4a4a; }\n\n/* line 12, stdin */\n#vue-app-theme-setting .input-color[_v-320b64ef] {\n  margin-top: 30px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  gap: 9px; }\n\n/* line 18, stdin */\n#vue-app-theme-setting .warning[_v-320b64ef] {\n  margin-left: 25px;\n  margin-top: -5px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #ff001f; }\n\n/* line 25, stdin */\n#vue-app-theme-setting input[_v-320b64ef] {\n  padding: 3px 12px; }\n\n/* line 28, stdin */\n#vue-app-theme-setting label span[_v-320b64ef] {\n  font-size: 21px; }\n\n/* line 31, stdin */\n#vue-app-theme-setting .dot[_v-320b64ef] {\n  height: 47px;\n  width: 47px;\n  border-radius: 50%;\n  display: inline-block;\n  cursor: pointer; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            ajaxing: false,
            beforColor: {
                primary_color: '252525',
                secondary_color: '38afe2',
                third_color: '38afe2'
            },
            afterColor: {
                primary_color: '252525',
                secondary_color: '38afe2',
                third_color: '38afe2'
            }
        };
    },
    watch: {
        selected_studio_id: function selected_studio_id(newV, oldV) {
            if (newV > 0) {
                this.init();
            }
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId']), (0, _vuex.mapState)('filters', ['selected_studio_id']), (0, _vuex.mapState)({
        canUse: function canUse(state) {
            return state.webadmin.configure.webFunctions.WebadminStudioAppLayoutSetting;
        }
    })),
    methods: {
        init: function init() {
            this.getSettings();
        },
        getSettings: function getSettings() {
            var _this = this;

            this.ajaxing = true;
            this.$http.get('/adminapi/studio_app_layout_setting/' + this.selected_studio_id).then(function (response) {
                var result = response.data;
                _this.reset(result);
                _this.ajaxing = false;
            }, function (error) {
                _this.ajaxing = false;
                $17.swal({
                    title: '取得資料失敗',
                    type: 'error',
                    showCancelButton: false
                });
            });
        },
        update: function update() {
            var _this2 = this;

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)((0, _entries2.default)(this.afterColor)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var _step$value = (0, _slicedToArray3.default)(_step.value, 2),
                        key = _step$value[0],
                        value = _step$value[1];

                    if (!this.isValidColor('#' + value)) {
                        $17.swal({
                            title: '儲存失敗',
                            text: '輸入色碼有誤！',
                            type: 'warning',
                            showCancelButton: false
                        });
                        return;
                    };
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            ;
            this.ajaxing = true;
            this.$http.patch('/adminapi/studio_app_layout_setting/update/' + this.selected_studio_id, {
                'primary_color': '#' + this.afterColor.primary_color,
                'secondary_color': '#' + this.afterColor.secondary_color,
                'third_color': '#' + this.afterColor.third_color
            }).then(function (response) {
                _this2.reset(_this2.afterColor);
                _this2.ajaxing = false;
                $17.swal({
                    title: '儲存成功',
                    type: 'success',
                    showCancelButton: false
                });
            }, function (error) {
                var text = error.data.message ? error.data.message : '';
                _this2.ajaxing = false;
                $17.swal({
                    title: '儲存失敗',
                    text: text,
                    type: 'error',
                    showCancelButton: false
                });
            });
        },
        reset: function reset(data) {
            if (data) {
                this.beforColor = {
                    primary_color: data.primary_color.replace("#", ""),
                    secondary_color: data.secondary_color.replace("#", ""),
                    third_color: data.third_color.replace("#", "")
                };
            };
            this.afterColor = (0, _assign2.default)({}, this.beforColor);
        },
        bindPrimaryColor: function bindPrimaryColor(hex) {
            this.afterColor.primary_color = hex.replace("#", "");
        },
        bindSecondaryColor: function bindSecondaryColor(hex) {
            this.afterColor.secondary_color = hex.replace("#", "");
        },
        bindThirdColor: function bindThirdColor(hex) {
            this.afterColor.third_color = hex.replace("#", "");
        },
        isValidColor: function isValidColor(str) {
            return $17.isValidColor(str);
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"col-xs-12 m-left-30\" _v-320b64ef=\"\">\n    <v-select-studio-and-branch :studio_id=\"studioId\" :show-branch=\"false\" _v-320b64ef=\"\">\n    </v-select-studio-and-branch>\n    <v-spinner :ajaxing=\"ajaxing\" _v-320b64ef=\"\"></v-spinner>\n    <div id=\"vue-app-theme-setting\" v-show=\"!ajaxing&amp;&amp;canUse\" _v-320b64ef=\"\">\n        <div class=\"row m-top-20\" _v-320b64ef=\"\">\n            <div class=\"title\" _v-320b64ef=\"\">主色</div>\n            <div class=\"description\" _v-320b64ef=\"\">主色貫穿整個APP，將品牌色運用在頂部導航是常見的做法。<br _v-320b64ef=\"\">避免選用淺淡的色系，以提高可讀性。</div>\n            <div class=\"input-color\" _v-320b64ef=\"\">\n                <label _v-320b64ef=\"\"> <span _v-320b64ef=\"\">＃</span>\n                    <input type=\"text\" maxlength=\"6\" placeholder=\"請輸入六位數色碼\" v-model=\"afterColor.primary_color\" _v-320b64ef=\"\">\n                </label>\n                <v-color-picker :input-color=\"'#'+afterColor.primary_color\" :changed-color-call-back=\"bindPrimaryColor\" _v-320b64ef=\"\"></v-color-picker>\n            </div>\n            <div class=\"warning\" v-if=\"!isValidColor('#'+afterColor.primary_color)\" _v-320b64ef=\"\">*請輸入正確色碼</div>\n        </div>\n        <div class=\"row m-top-70\" _v-320b64ef=\"\">\n            <div class=\"title\" _v-320b64ef=\"\">輔色1</div>\n            <div class=\"description\" _v-320b64ef=\"\">避免選用淺淡的色系，以提高可讀性。</div>\n            <div class=\"input-color\" _v-320b64ef=\"\">\n                <label _v-320b64ef=\"\"> <span _v-320b64ef=\"\">＃</span>\n                    <input type=\"text\" maxlength=\"6\" placeholder=\"請輸入六位數色碼\" v-model=\"afterColor.secondary_color\" _v-320b64ef=\"\">\n                </label>\n                <v-color-picker :input-color=\"'#'+afterColor.secondary_color\" :changed-color-call-back=\"bindSecondaryColor\" _v-320b64ef=\"\"></v-color-picker>\n            </div>\n            <div class=\"warning\" v-if=\"!isValidColor('#'+afterColor.secondary_color)\" _v-320b64ef=\"\">*請輸入正確色碼</div>\n        </div>\n        <div class=\"row m-top-70\" _v-320b64ef=\"\">\n            <div class=\"title\" _v-320b64ef=\"\">輔色2</div>\n            <div class=\"description\" _v-320b64ef=\"\">避免選用淺淡的色系，以提高可讀性。</div>\n            <div class=\"input-color\" _v-320b64ef=\"\">\n                <label _v-320b64ef=\"\"> <span _v-320b64ef=\"\">＃</span>\n                    <input type=\"text\" maxlength=\"6\" placeholder=\"請輸入六位數色碼\" v-model=\"afterColor.third_color\" _v-320b64ef=\"\">\n                </label>\n                <v-color-picker :input-color=\"'#'+afterColor.third_color\" :changed-color-call-back=\"bindThirdColor\" _v-320b64ef=\"\"></v-color-picker>\n            </div>\n            <div class=\"warning\" v-if=\"!isValidColor('#'+afterColor.third_color)\" _v-320b64ef=\"\">*請輸入正確色碼</div>\n        </div>\n\n        <div class=\"m-top-30\" _v-320b64ef=\"\">\n            <button @click=\"update\" class=\"btn btn-primary\" _v-320b64ef=\"\">儲存</button>\n            <button @click=\"reset(null)\" class=\"btn btn-defult btn--inverse\" _v-320b64ef=\"\">重置</button>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 3, stdin */\n#vue-app-theme-setting .title[_v-320b64ef] {\n  font-size: 21px;\n  font-weight: 500;\n  margin-bottom: 7px; }\n\n/* line 8, stdin */\n#vue-app-theme-setting .desciprtion[_v-320b64ef] {\n  font-size: 16px;\n  color: #4a4a4a; }\n\n/* line 12, stdin */\n#vue-app-theme-setting .input-color[_v-320b64ef] {\n  margin-top: 30px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  gap: 9px; }\n\n/* line 18, stdin */\n#vue-app-theme-setting .warning[_v-320b64ef] {\n  margin-left: 25px;\n  margin-top: -5px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #ff001f; }\n\n/* line 25, stdin */\n#vue-app-theme-setting input[_v-320b64ef] {\n  padding: 3px 12px; }\n\n/* line 28, stdin */\n#vue-app-theme-setting label span[_v-320b64ef] {\n  font-size: 21px; }\n\n/* line 31, stdin */\n#vue-app-theme-setting .dot[_v-320b64ef] {\n  height: 47px;\n  width: 47px;\n  border-radius: 50%;\n  display: inline-block;\n  cursor: pointer; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-320b64ef", module.exports)
  } else {
    hotAPI.update("_v-320b64ef", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/get-iterator":46,"babel-runtime/core-js/object/assign":50,"babel-runtime/core-js/object/entries":54,"babel-runtime/helpers/extends":66,"babel-runtime/helpers/slicedToArray":70,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1447:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _appThemeSetting = require('./app-theme-setting.vue');

var _appThemeSetting2 = _interopRequireDefault(_appThemeSetting);

var _index = require('./index.vue');

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('webadmin-app-theme-setting', _appThemeSetting2.default);
_vue2.default.component('webadmin-studio-app-setting', _index2.default);

},{"./app-theme-setting.vue":1446,"./index.vue":1448,"vue":792}],1448:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            ajaxing: false,
            postData: {
                display_branch_people_flow: 0,
                display_branch_member_admission: 0,
                branches_people_flow: [],
                branches_member_admission: []
            }
        };
    },
    watch: {
        selected_studio_id: function selected_studio_id(newV, oldV) {
            if (newV > 0) {
                this.init();
            }
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId']), (0, _vuex.mapState)('filters', ['selected_studio_id', 'branchOptions']), (0, _vuex.mapState)({
        canUse: function canUse(state) {
            return state.webadmin.configure.webFunctions.WebadminStudioAppSetting;
        }
    })),
    methods: {
        update: function update() {
            var _this = this;

            if (this.postData.display_branch_people_flow === 1 && !this.postData.branches_people_flow.length) {
                $17.swal({
                    title: '請選擇場館',
                    text: '允許客戶透過品牌APP查詢即時現場人數',
                    type: 'warning',
                    showCancelButton: false
                });
                return false;
            }
            if (this.postData.display_branch_member_admission === 1 && !this.postData.branches_member_admission.length) {
                $17.swal({
                    title: '請選擇場館',
                    text: '允許客戶透過品牌APP查詢入場紀錄',
                    type: 'warning',
                    showCancelButton: false
                });
                return false;
            }

            this.ajaxing = true;
            this.$http.patch('/adminapi/studio_app_setting/update/' + this.selected_studio_id, this.postData).then(function (response) {
                _this.ajaxing = false;
                $17.swal({
                    title: '儲存成功',
                    type: 'success',
                    showCancelButton: false
                });
            }, function (error) {
                _this.ajaxing = false;
                $17.swal({
                    title: '儲存失敗',
                    type: 'error',
                    showCancelButton: false
                });
            });
        },
        init: function init() {
            this.getBranchList();
            this.getSettings();
        },
        getBranchList: function getBranchList() {
            this.$store.dispatch('filters/getBranchList');
        },
        getSettings: function getSettings() {
            var _this2 = this;

            this.ajaxing = true;
            this.$http.get('/adminapi/studio_app_setting/' + this.selected_studio_id).then(function (response) {
                _this2.postData.display_branch_people_flow = response.data.setting.display_branch_people_flow;
                _this2.postData.display_branch_member_admission = response.data.setting.display_branch_member_admission;
                _this2.postData.branches_people_flow = response.data.branches_people_flow;
                _this2.postData.branches_member_admission = response.data.branches_member_admission;
                _this2.ajaxing = false;
            }, function (error) {
                _this2.ajaxing = false;
                $17.swal({
                    title: '取得資料失敗',
                    type: 'error',
                    showCancelButton: false
                });
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"col-xs-12\">\n    <v-select-studio-and-branch :studio_id=\"studioId\" :show-branch=\"false\">\n    </v-select-studio-and-branch>\n    <h3>品牌APP設定</h3>\n    <v-spinner :ajaxing=\"ajaxing\"></v-spinner>\n    <div class=\"m-top-20\" v-show=\"!ajaxing&amp;&amp;canUse&amp;&amp;branchOptions.length\">\n        <div class=\"row\">\n            <label for=\"display_branch_people_flow\" class=\"col-xs-12\">\n                <input type=\"checkbox\" id=\"display_branch_people_flow\" :true-value=\"1\" :false-value=\"0\" v-model=\"postData.display_branch_people_flow\"> 允許客戶透過品牌APP查詢即時現場人數\n            </label>\n            <v-mutiselect v-if=\"postData.display_branch_people_flow==1\" id=\"branches_people_flow\" class=\"col-xs-8\" :model.sync=\"postData.branches_people_flow\" :options=\"branchOptions\" :multiple=\"true\" :close-on-select=\"true\" :clear-on-select=\"true\" :searchable=\"false\" label=\"branch_name\" track-by=\"id\" tag-name=\"branch_name\" placeholder=\"請選擇場館\">\n            </v-mutiselect>\n        </div>\n        <div class=\"row m-top-30\">\n            <label for=\"display_branch_member_admission\" class=\"col-xs-12\">\n                <input type=\"checkbox\" id=\"display_branch_member_admission\" :true-value=\"1\" :false-value=\"0\" v-model=\"postData.display_branch_member_admission\"> 允許客戶透過品牌APP查詢入場紀錄\n            </label>\n            <v-mutiselect v-if=\"postData.display_branch_member_admission==1\" id=\"branches_member_admission\" class=\"col-xs-8\" :model.sync=\"postData.branches_member_admission\" :options=\"branchOptions\" :multiple=\"true\" :close-on-select=\"true\" :clear-on-select=\"true\" :searchable=\"false\" label=\"branch_name\" track-by=\"id\" tag-name=\"branch_name\" placeholder=\"請選擇場館\">\n            </v-mutiselect>\n        </div>\n\n        <div class=\"m-top-30\">\n            <button @click=\"update\" class=\"btn btn-primary\">儲存</button>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-1c5513a1", module.exports)
  } else {
    hotAPI.update("_v-1c5513a1", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vuex":803}],1449:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n.app_id{\n    word-break: break-all;\n}\n.locked{\n    margin-top:1em;\n}\n.permissions{\n    margin-bottom: 1em;\n    margin-top: 0.5em;\n    margin-left: 1em;\n}\n.btn{\n    margin-left:5px;\n}\n\n.footer{\n    margin-top:5em;\n}\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vuex = require('vuex');

exports.default = {
    props: {
        currentAppId: {
            default: null
        }
    },
    data: function data() {
        return {
            view: {
                ajaxingAppInfo: false,
                ajaxingEditApp: false
            },
            appInfo: {
                'name': '',
                'appId': '',
                'app_token': '',
                'token_secret': '',
                'locked': true
            },
            permissionList: [],
            currentPermissions: {}
        };
    },

    watch: {
        currentAppId: function currentAppId(newVal) {
            if (newVal) {
                this.getAppInfo();
            }
        },
        permissionList: function permissionList(newVal) {
            newVal.map(function (permission) {
                permission.checked = 1;
                return permission;
            });
        }
    },
    methods: {
        getAppInfo: function getAppInfo() {
            var _this = this;

            this.view.ajaxingAppInfo = true;
            this.$http.get('/adminapi/studio_business_app/edit/' + this.currentAppId).then(function (response) {
                _this.appInfo = response.body.app;
                _this.permissionList = response.body.permissions;

                _this.view.ajaxingAppInfo = false;
            }, function (error) {
                $17.swal({
                    title: '讀取樣板列表發生錯誤',
                    type: 'error',
                    showCancelButton: false
                });
                _this.view.ajaxingAppInfo = false;
            });
        },
        setSelectedPermission: function setSelectedPermission(permissions) {
            return this.currentPermissions = permissions.reduce(function (carry, permission) {
                if (permission.checked) {
                    carry[permission.enum] = permission.enum;
                }

                return carry;
            }, {});
        },
        editApp: function editApp() {
            var _this2 = this;

            this.view.ajaxingEditApp = true;

            var postData = {};
            postData['locked'] = this.appInfo.locked;
            if (this.appInfo.locked == 0) {
                postData['permissions'] = this.setSelectedPermission(this.permissionList);
            }

            this.$http.post('/adminapi/studio_business_app/edit/' + this.currentAppId, postData).then(function (response) {
                $17.swal({
                    title: 'App更新',
                    type: 'success',
                    showCancelButton: false
                });
                $("#studio-business-app").modal('hide');
                _this2.resetAppInfo();
                _this2.view.ajaxingEditApp = false;
                _this2.name = null;

                _this2.$emit('fetch-list');
                _this2.$emit('reset-edit-id');
            }, function (error) {
                $17.swal({
                    title: '更新App發生錯誤',
                    text: error.data.message,
                    type: 'error',
                    showCancelButton: false
                });
                _this2.view.ajaxingEditApp = false;
            });
        },
        resetAppInfo: function resetAppInfo() {
            this.appInfo = {
                'name': '',
                'appId': '',
                'app_token': '',
                'token_secret': '',
                'locked': true
            };
            this.permissionList = [];
            this.currentPermissions = {};
        },
        freshToken: function freshToken() {
            var _this3 = this;

            $17.swal({
                title: '確認刪除APP?',
                type: 'warning'
            }, function () {
                _this3.view.ajaxingAppInfo = true;
                _this3.$http.post('/adminapi/studio_business_app/fresh_key/' + _this3.currentAppId, {}).then(function (response) {
                    $17.swal({
                        title: 'Token已更新',
                        type: 'success',
                        showCancelButton: false
                    });
                    _this3.view.ajaxingAppInfo = false;
                    _this3.getAppInfo();
                }, function (error) {
                    $17.swal({
                        title: '更新Token發生錯誤',
                        text: error.data.message,
                        type: 'error',
                        showCancelButton: false
                    });
                    _this3.view.ajaxingAppInfo = false;
                });
            });
        },
        deleteApp: function deleteApp() {
            var _this4 = this;

            $17.swal({
                title: '確認刪除APP?',
                text: "",
                type: 'error'
            }, function () {
                _this4.view.ajaxingAppInfo = true;
                _this4.$http.post('/adminapi/studio_business_app/delete/' + _this4.currentAppId, {
                    "_method": "delete"
                }).then(function (response) {
                    $17.swal({
                        title: 'APP已刪除',
                        type: 'success',
                        showCancelButton: false
                    });
                    $("#studio-business-app").modal('hide');
                    _this4.resetAppInfo();
                    _this4.view.ajaxingEditApp = false;
                    _this4.name = null;

                    _this4.$emit('fetch-list');
                    _this4.$emit('reset-edit-id');
                }, function (error) {
                    $17.swal({
                        title: '刪除App發生錯誤',
                        text: error.data.message,
                        type: 'error',
                        showCancelButton: false
                    });
                    _this4.view.ajaxingAppInfo = false;
                });
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div>\n    <v-modal id=\"studio-business-app\" no-footer=\"\" no-border-radius=\"\">\n        <div slot=\"title\">API 權限設定</div>\n        <div slot=\"body\">\n            <v-spinner :ajaxing=\"view.ajaxingAppInfo\"></v-spinner>\n            <div v-show=\"!view.ajaxingAppInfo\">\n                <div class=\"row\">\n                    <div class=\"col-xs-12\">\n                        名稱:{{ appInfo.name }}\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"col-xs-12\">\n                        APP_ID:\n                        <span class=\"app_id\">\n                            {{ appInfo.app_id }}\n                        </span>\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"col-xs-12\">\n                        Token:{{ appInfo.app_token }}\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"col-xs-12\">\n                        Secret:{{ appInfo.token_secret }}\n                    </div>\n                </div>\n                <div class=\"row locked\">\n                    <div class=\"col-xs-12\">\n                        <input type=\"radio\" id=\"unlocked\" :value=\"0\" v-model=\"appInfo.locked\">\n                        <label for=\"unlocked\">啟用</label>\n\n                        <input type=\"radio\" id=\"locked\" :value=\"1\" v-model=\"appInfo.locked\">\n                        <label for=\"locked\">停用</label>\n                    </div>\n                </div>\n                <div class=\"row permissions\" v-show=\"appInfo.locked==0\">\n                    <div class=\"col-xs-11\" v-for=\"permission in permissionList\" :key=\"permission.enum\">\n                        <input type=\"checkbox\" :id=\"permission.enum\" :value=\"permission.enum\" v-model=\"permission.checked\" :true-value=\"1\" :false-value=\"0\" :disabled=\"true\">\n                        <label :for=\"permission.enum\">{{permission.name}}</label>\n                    </div>\n                </div>\n                \n                <div class=\"row footer\">\n                    <v-spinner :ajaxing=\"view.ajaxingAppInfo\"></v-spinner>\n                    <div class=\"col-xs-6\" v-show=\"!view.ajaxingAppInfo\">\n                        <input type=\"button\" value=\"刪除APP\" @click=\"deleteApp\" class=\"btn btn-danger\">\n                        <input type=\"button\" @click=\"freshToken\" value=\"重設Token&amp;Secret\" class=\"btn btn-default\">\n                    </div>\n                    <div class=\"col-xs-6 text-right\" v-show=\"!view.ajaxingAppInfo\">\n                        <input type=\"button\" value=\"確認送出\" @click=\"editApp\" class=\"btn btn-primary\">\n                    </div>\n                </div>\n            </div>\n        </div>\n    </v-modal>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n.app_id{\n    word-break: break-all;\n}\n.locked{\n    margin-top:1em;\n}\n.permissions{\n    margin-bottom: 1em;\n    margin-top: 0.5em;\n    margin-left: 1em;\n}\n.btn{\n    margin-left:5px;\n}\n\n.footer{\n    margin-top:5em;\n}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-7ea3f676", module.exports)
  } else {
    hotAPI.update("_v-7ea3f676", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1450:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _settingList = require('./setting-list.vue');

var _settingList2 = _interopRequireDefault(_settingList);

var _editModal = require('./edit-modal.vue');

var _editModal2 = _interopRequireDefault(_editModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//Page
_vue2.default.component('webadmin-studio-business-setting-list', _settingList2.default);
_vue2.default.component('webadmin-studio-business-edit-modal', _editModal2.default);

},{"./edit-modal.vue":1449,"./setting-list.vue":1451,"vue":792}],1451:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.table[_v-36bcaf54] {\n  width: 100%; }\n\n/* line 6, stdin */\n.name[_v-36bcaf54] {\n  padding-left: 5%; }\n\n/* line 9, stdin */\n.append-new[_v-36bcaf54] {\n  margin-top: 20px;\n  margin-bottom: 20px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            view: {
                ajaxing: false,
                ajaxingAppend: false,
                currentTab: 'list'
            },
            items: [],
            editAppId: null,
            name: null
        };
    },
    created: function created() {},
    watch: {
        activeStudioId: function activeStudioId(newVal) {
            if (newVal != 0) {
                this.getList();
            }
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'isSeventeen']), (0, _vuex.mapState)('filters', ['selected_studio_id']), {
        activeStudioId: function activeStudioId() {
            if (this.isSeventeen) {
                return this.selected_studio_id;
            }
            return this.studioId;
        }
    }),
    methods: {
        getList: function getList() {
            var _this = this;

            this.view.ajaxing = true;
            this.$http.get('/adminapi/studio_business_app/list?studio_id=' + this.activeStudioId).then(function (response) {
                _this.items = response.body.apps;
                _this.view.ajaxing = false;
            }, function (error) {
                $17.swal({
                    title: '讀取樣板列表發生錯誤',
                    type: 'error',
                    showCancelButton: false
                });
                _this.view.ajaxing = false;
            });
        },
        appendNewApp: function appendNewApp() {
            var _this2 = this;

            $17.swal({
                title: '確認新增APP?',
                text: "",
                type: 'warning'
            }, function () {
                _this2.view.ajaxingAppend = true;
                _this2.$http.post('/adminapi/studio_business_app/create/' + _this2.activeStudioId, {
                    'name': _this2.name
                }).then(function (response) {
                    $17.swal({
                        title: 'App已新增',
                        type: 'success',
                        showCancelButton: false
                    });
                    _this2.getList();
                    _this2.view.ajaxingAppend = false;
                    _this2.name = null;
                }, function (error) {
                    $17.swal({
                        title: '新增App發生錯誤',
                        text: error.data.message,
                        type: 'error',
                        showCancelButton: false
                    });
                    _this2.view.ajaxingAppend = false;
                });
            });
        },
        changeEditId: function changeEditId(id, show) {
            this.editAppId = id;
            if (show) {
                $("#studio-business-app").modal('show');
            }
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"container\" _v-36bcaf54=\"\">\n    <div v-show=\"view.currentTab=='list'\" _v-36bcaf54=\"\">\n        <div class=\"row\" _v-36bcaf54=\"\">\n            <div class=\"col-xs-12\" _v-36bcaf54=\"\">\n                <v-select-studio-and-branch :studio_id=\"studioId\" :show-branch=\"false\" :branch-without-filtered-option=\"false\" _v-36bcaf54=\"\">\n                </v-select-studio-and-branch>\n            </div>\n        </div> \n        <div class=\"row form-inline\" _v-36bcaf54=\"\">\n            <v-spinner :ajaxing=\"view.ajaxingAppend\" _v-36bcaf54=\"\"></v-spinner>\n            <div class=\"col-xs-12 append-new\" v-show=\"!view.ajaxingAppend\" _v-36bcaf54=\"\">\n                <input type=\"text\" class=\"form-control\" id=\"\" v-model=\"name\" placeholder=\"輸入APP 名稱\" _v-36bcaf54=\"\">\n                <input type=\"button\" class=\"btn btn--primary \" value=\"新增\" @click=\"appendNewApp()\" _v-36bcaf54=\"\">\n            </div>\n        </div> \n        <v-table :length=\"items.length\" :ajaxing=\"view.ajaxing\" _v-36bcaf54=\"\">\n            <table class=\"table\" _v-36bcaf54=\"\">\n                <thead _v-36bcaf54=\"\">\n                    <tr _v-36bcaf54=\"\">\n                        <th _v-36bcaf54=\"\">\n                            <p class=\"name\" _v-36bcaf54=\"\">App名稱</p>\n                        </th>\n                        <th _v-36bcaf54=\"\">\n                            <p class=\"name\" _v-36bcaf54=\"\">APP_id</p>\n                        </th>\n                        <th _v-36bcaf54=\"\">\n                            <p class=\"name\" _v-36bcaf54=\"\">建立時間</p>\n                        </th>\n                        <th _v-36bcaf54=\"\">\n                            <p class=\"name\" _v-36bcaf54=\"\">狀態</p>\n                        </th>\n                        <th _v-36bcaf54=\"\">\n                            <p class=\"name\" _v-36bcaf54=\"\">設定</p>\n                        </th>\n                    </tr>\n                </thead>\n                <tbody _v-36bcaf54=\"\">\n                    <tr v-for=\"(it,key) in items\" :key=\"it.id\" _v-36bcaf54=\"\">\n                        <td _v-36bcaf54=\"\"> \n                            {{ it.name }}\n                        </td>\n                        <td _v-36bcaf54=\"\"> \n                            {{ it.app_id }}\n                        </td>\n                        <td _v-36bcaf54=\"\"> \n                            {{ it.created_at }}\n                        </td>\n                        <td _v-36bcaf54=\"\"> \n                            {{ it.locked }}\n                        </td>\n                        <td class=\"text-right\" _v-36bcaf54=\"\"> \n                            <input type=\"button\" class=\"btn btn-primary\" value=\"編輯\" @click=\"changeEditId(it.id,true)\" _v-36bcaf54=\"\">\n                        </td>\n                    </tr>\n                </tbody>\n            </table>\n        </v-table>\n    </div>\n     <webadmin-studio-business-edit-modal :current-app-id=\"editAppId\" @reset-edit-id=\"changeEditId(null,false)\" @fetch-list=\"getList()\" _v-36bcaf54=\"\"></webadmin-studio-business-edit-modal>\n</div>    \n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.table[_v-36bcaf54] {\n  width: 100%; }\n\n/* line 6, stdin */\n.name[_v-36bcaf54] {\n  padding-left: 5%; }\n\n/* line 9, stdin */\n.append-new[_v-36bcaf54] {\n  margin-top: 20px;\n  margin-bottom: 20px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-36bcaf54", module.exports)
  } else {
    hotAPI.update("_v-36bcaf54", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1452:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _test = require('./test.vue');

var _test2 = _interopRequireDefault(_test);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//Page
_vue2.default.component('webadmin-studio-business-app-test', _test2.default);

},{"./test.vue":1453,"vue":792}],1453:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n.app_id{\n    word-break: break-all;\n}\n.locked{\n    margin-top:1em;\n}\n.permissions{\n    margin-bottom: 1em;\n    margin-top: 0.5em;\n    margin-left: 1em;\n}\n.btn{\n    margin-left:5px;\n}\n\n.footer{\n    margin-top:5em;\n}\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            view: {
                ajaxingAppInfo: false
            },
            data: {
                app_id: '',
                secret: '',
                data: {
                    device_code: '',
                    voucher_code: ''
                }
            },
            action: {
                attend: 'attend'
            },
            result: {}
        };
    },

    methods: {
        getAppInfo: function getAppInfo() {
            var _this = this;

            this.view.ajaxingAppInfo = false;
            this.$http.post('/adminapi/studio_business_app/test', {
                'data': this.data,
                'action': this.action
            }).then(function (response) {
                _this.result = '';
                _this.result = (0, _stringify2.default)(response.data);
            }, function (error) {
                $17.swal({
                    title: '新增App發生錯誤',
                    text: error.data.message,
                    type: 'error',
                    showCancelButton: false
                });
                _this.view.ajaxingAppend = false;
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<form class=\"form-horizontal\">\n    <v-spinner :ajaxing=\"view.ajaxingAppInfo\"></v-spinner>\n    <div v-show=\"!view.ajaxingAppInfo\">\n        <div class=\"form-group\">\n            <label for=\"app_id\" class=\"col-xs-2 text-right\">APP_ID</label>\n            <div class=\"col-xs-8\">\n                <input type=\"text\" class=\"form-control\" id=\"app_id\" v-model=\"data.app_id\">\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label for=\"secret\" class=\"col-xs-2 text-right\">Secert</label>\n            <div class=\"col-xs-8\">\n                <input type=\"text\" class=\"form-control\" id=\"secret\" v-model=\"data.secret\">\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label for=\"device_code\" class=\"col-xs-2 text-right\">閘門設備編號</label>\n            <div class=\"col-xs-8\">\n                <input type=\"text\" class=\"form-control\" id=\"device_code\" v-model=\"data.data.device_code\">\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label for=\"voucher_code\" class=\"col-xs-2 text-right\">BookingId</label>\n            <div class=\"col-xs-8\">\n                <input type=\"text\" class=\"form-control\" id=\"voucher_code\" v-model=\"data.data.voucher_code\">\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label for=\"attend.attend\" class=\"col-xs-2 text-right\">預設行為</label>\n            <div class=\"col-xs-8\">\n                <input type=\"radio\" id=\"attend.attend\" value=\"attend\" v-model=\"action.attend\">\n                <label for=\"attend.attend\">出席</label>\n            \n                <input type=\"radio\" id=\"attend.attend_auto\" value=\"attend_auto\" v-model=\"action.attend\">\n                <label for=\"attend.attend_auto\">依系統設定</label>\n            \n                <input type=\"radio\" id=\"attend.none\" value=\"\" v-model=\"action.attend\">\n                <label for=\"attend.none\">不動作</label>\n            </div>\n        </div>\n        <div class=\"row footer\">\n            <div class=\"col-xs-6 text-right\">\n                <input type=\"button\" value=\"確認送出\" @click=\"getAppInfo\" class=\"btn btn-primary\">\n            </div>\n        </div>\n        <div class=\"\">\n            <div id=\"resault\">\n                {{result}}\n            </div>\n        </div>\n    </div>\n</form>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n.app_id{\n    word-break: break-all;\n}\n.locked{\n    margin-top:1em;\n}\n.permissions{\n    margin-bottom: 1em;\n    margin-top: 0.5em;\n    margin-left: 1em;\n}\n.btn{\n    margin-left:5px;\n}\n\n.footer{\n    margin-top:5em;\n}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-aebabd6a", module.exports)
  } else {
    hotAPI.update("_v-aebabd6a", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/json/stringify":48,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1454:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\ntd[_v-3b3c8ec8] {\n  text-align: center; }\n\n/* line 6, stdin */\n.tab[_v-3b3c8ec8] {\n  padding: 20px 0;\n  font-size: medium; }\n  /* line 10, stdin */\n  .tab span[_v-3b3c8ec8] {\n    cursor: pointer;\n    padding-right: 5px;\n    padding-left: 5px; }\n\n/* line 17, stdin */\n.status-cell[_v-3b3c8ec8] {\n  vertical-align: middle;\n  line-height: 33px;\n  font-size: medium; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        studioId: {
            default: null
        }
    },
    data: function data() {
        return {
            view: {
                ajaxing: false,
                tab: 'progress'
            },
            latest_by: null,
            latest_time: null,
            studio: null,
            brand_name: null,
            plans: {
                primary: [],
                addon: []
            },
            postData: {
                primary: [],
                addon: []
            }
        };
    },
    mounted: function mounted() {
        this.fetchData();
    },

    computed: {
        disabledDates: function disabledDates() {
            var today = moment().format('YYYY-MM-DD');
            return {
                to: moment(today, ['YYYY-MM-DD']).toDate()
            };
        },
        lockPrimary: function lockPrimary() {
            return !!this.postData.primary.find(function (row) {
                return !row.exist;
            });
        },
        lockAddon: function lockAddon() {
            return !!this.postData.addon.find(function (row) {
                return !row.exist;
            });
        },
        count: function count() {
            var count = { all: 0, expired: 0, future: 0, expired_soon: 0, progress: 0 };
            for (var type in this.postData) {
                for (var i in this.postData[type]) {
                    var row = this.postData[type][i];
                    if (row.exist) {
                        var status = this.checkStatus(row);
                        count[status] += 1;
                        count['all'] += 1;
                    }
                }
            }
            return count;
        }
    },
    methods: {
        getStudioPlanName: function getStudioPlanName(planId, type) {
            var plan = this.plans[type].find(function (item) {
                return item.id == planId;
            });
            return plan.name;
        },
        showRow: function showRow(row) {
            if (this.view.tab === 'all' || !row.exist) {
                return true;
            } else {
                var status = this.checkStatus(row);
                return status === this.view.tab;
            }
        },
        checkStatus: function checkStatus(row) {
            var now = moment();
            var validEndTime = moment(row.valid_end_time, ['YYYY-MM-DD']).endOf('day');
            var diff = Math.abs(validEndTime.diff(now, 'days'));

            if (!row.is_valid) {
                return 'expired'; //失效
            } else if (moment(row.start_time, ['YYYY-MM-DD']).isAfter(now)) {
                return 'future'; //尚未開始
            } else if (validEndTime.isAfter(now) && diff <= 7) {
                return 'expired_soon'; //即將失效
            } else {
                return 'progress'; //進行中
            }
        },
        checkStatusColor: function checkStatusColor(row) {
            if (!row.exist) return 'transparent';

            var status = this.checkStatus(row);
            switch (status) {
                case 'expired':
                    return '#D9534F';
                case 'expired_soon':
                    return '#F0AD4E';
                case 'progress':
                    return '#5CB85C';
                default:
                    return 'transparent';
            }
        },
        addRow: function addRow(type) {
            this.postData[type].push({
                exist: false,
                plan_id: null,
                start_time: null,
                end_time: null,
                delay_days: null,
                valid_end_time: null,
                is_actived: 0,
                status: 1
            });
        },
        changeStatus: function changeStatus(value, row) {
            var txt = value == 1 ? '正常' : '鎖定';
            var vm = this;
            $17.swal({
                title: '\u78BA\u8A8D\u8981\u5C07\u72C0\u614B\u6539\u70BA\u300C' + txt + '\u300D\uFF1F',
                type: 'warning',
                showCancelButton: true
            }, function (answer) {
                if (answer) {
                    vm.view.ajaxing = true;
                    var updateData = { status: value };
                    vm.$http.patch('/adminapi/studio_plan/update/' + row.id, updateData).then(function (response) {
                        vm.fetchData();
                        $17.swal({
                            title: '已更新狀態',
                            type: 'success',
                            showCancelButton: false
                        });
                    }, function (error) {
                        $17.swal({
                            title: '更新狀態失敗',
                            type: 'error',
                            showCancelButton: false
                        });
                        vm.view.ajaxing = false;
                    });
                }
            });
        },
        changeIsActived: function changeIsActived(value, row) {
            var txt = value == 1 ? '啟用' : '未啟用';
            var vm = this;
            $17.swal({
                title: '\u78BA\u8A8D\u8981\u6539\u70BA\u300C' + txt + '\u300D\uFF1F',
                text: '\u555F\u7528\u5F8C\u7121\u6CD5\u518D\u66F4\u6539',
                type: 'warning',
                showCancelButton: true
            }, function (answer) {
                if (answer) {
                    vm.view.ajaxing = true;
                    var updateData = { is_actived: value };
                    vm.$http.patch('/adminapi/studio_plan/update/' + row.id, updateData).then(function (response) {
                        vm.fetchData();
                        $17.swal({
                            title: '已更新',
                            type: 'success',
                            showCancelButton: false
                        });
                    }, function (error) {
                        $17.swal({
                            title: '更新失敗',
                            type: 'error',
                            showCancelButton: false
                        });
                        vm.view.ajaxing = false;
                    });
                }
            });
        },
        deleteRow: function deleteRow(row, idx, type) {
            if (!row.exist) {
                this.postData[type].splice(idx, 1);
                return;
            }

            var vm = this;
            $17.swal({
                title: '確認刪除此系統方案？',
                type: 'warning',
                showCancelButton: true
            }, function (answer) {
                if (answer) {
                    vm.view.ajaxing = true;
                    vm.$http.delete('/adminapi/studio_plan/delete/' + row.id).then(function (response) {
                        $17.swal({
                            title: '刪除成功',
                            type: 'success',
                            showCancelButton: false
                        });
                        vm.postData[type].splice(idx, 1);
                        vm.view.ajaxing = false;
                    }, function (error) {
                        $17.swal({
                            title: '刪除失敗',
                            type: 'error',
                            showCancelButton: false
                        });
                        vm.view.ajaxing = false;
                    });
                }
            });
        },
        fetchData: function fetchData() {
            var _this = this;

            this.view.ajaxing = true;
            this.$http.get('/adminapi/studio_plan/studio/' + this.studioId).then(function (response) {
                var data = response.data;
                _this.plans.primary = data.plans.primary.map(function (item) {
                    item.name = '【' + item.id + '】' + item.name;
                    return item;
                });
                _this.plans.addon = data.plans.addon.map(function (item) {
                    item.name = '【' + item.id + '】' + item.name;
                    return item;
                });
                _this.brand_name = data.studio.brand_name;
                _this.latest_by = data.latest.updated_by;
                _this.latest_time = data.latest.updated_at;
                _this.postData.primary = data.primary.map(function (item) {
                    var row = item;
                    row['exist'] = true;
                    row['delay_days'] = item.delay_days > 0 ? item.delay_days : null;
                    row['valid_end_time'] = moment(item.valid_end_time).format('YYYY/MM/DD');
                    return row;
                });
                _this.postData.addon = data.addon.map(function (item) {
                    var row = item;
                    row['exist'] = true;
                    row['delay_days'] = item.delay_days > 0 ? item.delay_days : null;
                    row['valid_end_time'] = moment(item.valid_end_time).format('YYYY/MM/DD');
                    return row;
                });
                _this.view.ajaxing = false;

                if (!data.top_owner) {
                    $17.swal({
                        title: '請先幫品牌新增最高權限管理員',
                        text: '否則無法任何做異動，只能看',
                        type: 'warning',
                        showCancelButton: false
                    });
                }
            }, function (error) {
                _this.view.ajaxing = false;
            });
        },
        createRow: function createRow(idx, type) {
            var _this2 = this;

            var planId = (0, _typeof3.default)(this.postData[type][idx].plan_id) === 'object' ? this.postData[type][idx].plan_id.id : this.postData[type][idx].plan_id;
            var createData = {
                delay_days: this.postData[type][idx].delay_days > 0 ? this.postData[type][idx].delay_days : 0,
                status: this.postData[type][idx].status,
                start_time: this.postData[type][idx].start_time,
                end_time: this.postData[type][idx].end_time,
                plan_id: planId
            };
            this.view.ajaxing = true;
            this.$http.post('/adminapi/studio_plan/assign_plan/' + planId + '/studio/' + this.studioId, createData).then(function (response) {
                _this2.fetchData();
                $17.swal({
                    title: '新增成功',
                    type: 'success',
                    showCancelButton: false
                });
            }, function (error) {
                $17.swal({
                    title: '新增失敗',
                    text: '起始到期日錯誤 或 系統方案重複',
                    type: 'error',
                    showCancelButton: false
                });
                _this2.view.ajaxing = false;
            });
        },
        updateDelayDays: function updateDelayDays(row) {
            var _this3 = this;

            this.view.ajaxing = true;
            var updateData = { delay_days: row.delay_days > 0 ? row.delay_days.trim() : 0 };
            this.$http.patch('/adminapi/studio_plan/update/' + row.id, updateData).then(function (response) {
                _this3.fetchData();
                $17.swal({
                    title: '已更新寬限期',
                    type: 'success',
                    showCancelButton: false
                });
            }, function (error) {
                $17.swal({
                    title: '更新寬限期失敗',
                    text: '寬限期不得小於0',
                    type: 'error',
                    showCancelButton: false
                });
                _this3.view.ajaxing = false;
            });
        },
        tabChange: function tabChange(type) {
            this.view.tab = type;
        },
        toList: function toList() {
            window.history.back();
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"content-inner\" _v-3b3c8ec8=\"\">\n    <h2 class=\"m-bottom-30\" _v-3b3c8ec8=\"\">\n        編輯品牌系統方案\n        <span v-if=\"!view.ajaxing &amp;&amp; (latest_time || latest_by)\" class=\"text-muted font-small\" _v-3b3c8ec8=\"\">{{ '最後一次編輯：' + latest_time + ' ' + latest_by }}</span>\n    </h2>\n\n    <v-spinner :ajaxing=\"view.ajaxing\" _v-3b3c8ec8=\"\"></v-spinner>\n\n    <div v-if=\"!view.ajaxing\" _v-3b3c8ec8=\"\">\n        <h3 class=\"text-primary\" _v-3b3c8ec8=\"\">{{ brand_name }}</h3>\n\n        <div class=\"tab\" _v-3b3c8ec8=\"\">\n            <span :class=\"{'text-primary':view.tab==='all'}\" @click.prevent=\"tabChange('all')\" _v-3b3c8ec8=\"\">全部 ({{ count.all }})</span>｜\n            <span :class=\"{'text-primary':view.tab==='progress'}\" @click.prevent=\"tabChange('progress')\" _v-3b3c8ec8=\"\">進行中 ({{ count.progress }})</span>｜\n            <span :class=\"{'text-primary':view.tab==='expired_soon'}\" @click.prevent=\"tabChange('expired_soon')\" _v-3b3c8ec8=\"\">即將失效 ({{ count.expired_soon }})</span>｜\n            <span :class=\"{'text-primary':view.tab==='expired'}\" @click.prevent=\"tabChange('expired')\" _v-3b3c8ec8=\"\">失效 ({{ count.expired }})</span>\n        </div>\n\n        <div class=\"m-top-20\" _v-3b3c8ec8=\"\">\n            <table class=\"table text-center\" style=\"height: 100%;\" _v-3b3c8ec8=\"\">\n                <thead _v-3b3c8ec8=\"\">\n                <tr v-if=\"view.tab!='expired'\" _v-3b3c8ec8=\"\">\n                    <th colspan=\"9\" align=\"left\" _v-3b3c8ec8=\"\">\n                        <button :disabled=\"lockPrimary\" class=\"btn btn-primary\" @click=\"addRow('primary')\" _v-3b3c8ec8=\"\">新增主要系統方案</button>\n                    </th>\n                </tr>\n                <tr _v-3b3c8ec8=\"\">\n                    <th class=\"text-center\" _v-3b3c8ec8=\"\">類型</th>\n                    <th class=\"text-center\" _v-3b3c8ec8=\"\">啟用 <i class=\"fa fa-question-circle\" help=\"啟用後代表賦予品牌此系統方案，無法再調回未啟用\" _v-3b3c8ec8=\"\"></i></th>\n                    <th class=\"text-center\" width=\"350px\" _v-3b3c8ec8=\"\">系統方案 <i class=\"fa fa-question-circle\" help=\"【大括號裡面是系統方案序號】\" _v-3b3c8ec8=\"\"></i></th>\n                    <th class=\"text-center\" width=\"120px\" _v-3b3c8ec8=\"\">起始日期 <i class=\"fa fa-question-circle\" help=\"簽約的起始日期\" _v-3b3c8ec8=\"\"></i></th>\n                    <th class=\"text-center\" width=\"120px\" _v-3b3c8ec8=\"\">到期日期 <i class=\"fa fa-question-circle\" help=\"簽約的到期日期\" _v-3b3c8ec8=\"\"></i></th>\n                    <th class=\"text-center\" width=\"180px\" _v-3b3c8ec8=\"\">寬限期(天) <i class=\"fa fa-question-circle\" help=\"不得為負數\" _v-3b3c8ec8=\"\"></i></th>\n                    <th class=\"text-center\" _v-3b3c8ec8=\"\">方案有效到期日 <i class=\"fa fa-question-circle\" help=\"寬限期加上到期日期\" _v-3b3c8ec8=\"\"></i></th>\n                    <th class=\"text-center\" _v-3b3c8ec8=\"\">狀態 <i class=\"fa fa-question-circle\" help=\"鎖定=暫時停止該系統方案運作\" _v-3b3c8ec8=\"\"></i></th>\n                    <th class=\"text-center\" _v-3b3c8ec8=\"\"></th>\n                </tr>\n                </thead>\n                <tbody _v-3b3c8ec8=\"\"><tr v-for=\"(row,idx) in postData.primary\" v-show=\"showRow(row)\" _v-3b3c8ec8=\"\">\n                    <td _v-3b3c8ec8=\"\">\n                        <i class=\"fa fa-circle p-right-10\" :style=\"{ color: checkStatusColor(row) }\" _v-3b3c8ec8=\"\"></i>主要\n                    </td>\n                    <td _v-3b3c8ec8=\"\">\n                        <v-vue-switch v-if=\"row.exist\" @input=\"changeIsActived($event,row)\" :font-size=\"13\" :value=\"row.is_actived\" :disabled=\"row.is_actived==1 || !row.is_valid\" on-text=\"啟用\" off-text=\"未啟用\" _v-3b3c8ec8=\"\"></v-vue-switch>\n                    </td>\n                    <td _v-3b3c8ec8=\"\">\n                        <div v-if=\"row.exist\" _v-3b3c8ec8=\"\">{{ getStudioPlanName(postData.primary[idx].plan_id, 'primary') }}</div>\n                        <v-mutiselect v-else=\"\" :model.sync=\"postData.primary[idx].plan_id\" :options=\"plans.primary\" :multiple=\"false\" label=\"name\" track-by=\"id\" tag-name=\"name\" placeholder=\"請選擇\" _v-3b3c8ec8=\"\"></v-mutiselect>\n                    </td>\n                    <td _v-3b3c8ec8=\"\">\n                        <v-datepicker input-class=\"form-control\" v-model=\"postData.primary[idx].start_time\" placeholder=\"起始日期\" :disabled=\"row.exist\" :disabled-dates=\"disabledDates\" _v-3b3c8ec8=\"\"></v-datepicker>\n                    </td>\n                    <td _v-3b3c8ec8=\"\">\n                        <v-datepicker input-class=\"form-control\" v-model=\"postData.primary[idx].end_time\" placeholder=\"到期日期\" :disabled=\"row.exist\" :disabled-dates=\"disabledDates\" _v-3b3c8ec8=\"\"></v-datepicker>\n                    </td>\n                    <td _v-3b3c8ec8=\"\">\n                        <div class=\"input-group\" _v-3b3c8ec8=\"\">\n                            <input type=\"number\" :disabled=\"!row.is_valid\" v-model=\"postData.primary[idx].delay_days\" min=\"0\" placeholder=\"寬限期(天)\" class=\"form-control\" _v-3b3c8ec8=\"\">\n                            <span class=\"input-group-btn\" _v-3b3c8ec8=\"\">\n                                <button v-if=\"row.exist\" :disabled=\"!row.is_valid\" class=\"btn btn-primary\" @click=\"updateDelayDays(row)\" _v-3b3c8ec8=\"\">更新</button>\n                            </span>\n                        </div>\n                    </td>\n                    <td _v-3b3c8ec8=\"\">{{ postData.primary[idx].valid_end_time }}</td>\n                    <td _v-3b3c8ec8=\"\">\n                        <v-vue-switch v-if=\"row.exist\" @input=\"changeStatus($event,row)\" :disabled=\"!row.is_valid\" :value=\"row.status\" :font-size=\"13\" on-text=\"正常\" off-text=\"鎖定\" _v-3b3c8ec8=\"\">\n                        </v-vue-switch>\n                        <v-vue-switch v-else=\"\" v-model=\"postData.primary[idx].status\" :disabled=\"!row.is_valid\" :font-size=\"13\" on-text=\"正常\" off-text=\"鎖定\" _v-3b3c8ec8=\"\"></v-vue-switch>\n                    </td>\n                    <td _v-3b3c8ec8=\"\">\n                        <button v-if=\"!row.exist\" class=\"btn btn-success btn-sm\" @click=\"createRow(idx,'primary')\" _v-3b3c8ec8=\"\"><i class=\"fa fa-check\" _v-3b3c8ec8=\"\"></i></button>\n                        <button class=\"btn btn-danger btn-sm\" @click=\"deleteRow(row,idx,'primary')\" _v-3b3c8ec8=\"\"><i class=\"fa fa-remove\" _v-3b3c8ec8=\"\"></i></button>\n                    </td>\n                </tr>\n\n                <!--加值-->\n                <tr v-if=\"view.tab!='expired'\" _v-3b3c8ec8=\"\">\n                    <th colspan=\"9\" align=\"left\" _v-3b3c8ec8=\"\">\n                        <button :disabled=\"lockAddon\" class=\"btn btn-primary\" @click=\"addRow('addon')\" _v-3b3c8ec8=\"\">新增加值系統方案</button>\n                    </th>\n                </tr>\n                <tr v-for=\"(row,idx) in postData.addon\" v-show=\"showRow(row)\" _v-3b3c8ec8=\"\">\n                    <td _v-3b3c8ec8=\"\">\n                        <i class=\"fa fa-circle p-right-10\" :style=\"{ color: checkStatusColor(row) }\" _v-3b3c8ec8=\"\"></i>加值\n                    </td>\n                    <td _v-3b3c8ec8=\"\">\n                        <v-vue-switch v-if=\"row.exist\" @input=\"changeIsActived($event,row)\" :font-size=\"13\" :value=\"row.is_actived\" :disabled=\"row.is_actived==1 || !row.is_valid\" on-text=\"啟用\" off-text=\"未啟用\" _v-3b3c8ec8=\"\"></v-vue-switch>\n                    </td>\n                    <td _v-3b3c8ec8=\"\">\n                        <div v-if=\"row.exist\" _v-3b3c8ec8=\"\">{{ getStudioPlanName(postData.addon[idx].plan_id, 'addon') }}</div>\n                        <v-mutiselect v-else=\"\" :model.sync=\"postData.addon[idx].plan_id\" :options=\"plans.addon\" :multiple=\"false\" label=\"name\" track-by=\"id\" tag-name=\"name\" placeholder=\"請選擇\" _v-3b3c8ec8=\"\"></v-mutiselect>\n                    </td>\n                    <td _v-3b3c8ec8=\"\">\n                        <v-datepicker input-class=\"form-control\" v-model=\"postData.addon[idx].start_time\" placeholder=\"起始日期\" :disabled=\"row.exist\" :disabled-dates=\"disabledDates\" _v-3b3c8ec8=\"\"></v-datepicker>\n                    </td>\n                    <td _v-3b3c8ec8=\"\">\n                        <v-datepicker input-class=\"form-control\" v-model=\"postData.addon[idx].end_time\" placeholder=\"到期日期\" :disabled=\"row.exist\" :disabled-dates=\"disabledDates\" _v-3b3c8ec8=\"\"></v-datepicker>\n                    </td>\n                    <td _v-3b3c8ec8=\"\">\n                        <div class=\"input-group\" _v-3b3c8ec8=\"\">\n                            <input type=\"number\" :disabled=\"!row.is_valid\" v-model=\"postData.addon[idx].delay_days\" min=\"0\" placeholder=\"寬限期(天)\" class=\"form-control\" _v-3b3c8ec8=\"\">\n                            <span class=\"input-group-btn\" _v-3b3c8ec8=\"\">\n                                <button v-if=\"row.exist\" :disabled=\"!row.is_valid\" class=\"btn btn-primary\" @click=\"updateDelayDays(row)\" _v-3b3c8ec8=\"\">更新</button>\n                            </span>\n                        </div>\n                    </td>\n                    <td _v-3b3c8ec8=\"\">{{ postData.addon[idx].valid_end_time }}</td>\n                    <td _v-3b3c8ec8=\"\">\n                        <v-vue-switch v-if=\"row.exist\" @input=\"changeStatus($event,row)\" :disabled=\"!row.is_valid\" :value=\"row.status\" :font-size=\"13\" on-text=\"正常\" off-text=\"鎖定\" _v-3b3c8ec8=\"\">\n                        </v-vue-switch>\n                        <v-vue-switch v-else=\"\" v-model=\"postData.addon[idx].status\" :disabled=\"!row.is_valid\" :font-size=\"13\" on-text=\"正常\" off-text=\"鎖定\" _v-3b3c8ec8=\"\"></v-vue-switch>\n                    </td>\n                    <td _v-3b3c8ec8=\"\">\n                        <button v-if=\"!row.exist\" class=\"btn btn-success btn-sm\" @click=\"createRow(idx,'addon')\" _v-3b3c8ec8=\"\"><i class=\"fa fa-check\" _v-3b3c8ec8=\"\"></i></button>\n                        <button class=\"btn btn-danger btn-sm\" @click=\"deleteRow(row,idx,'addon')\" _v-3b3c8ec8=\"\"><i class=\"fa fa-remove\" _v-3b3c8ec8=\"\"></i></button>\n                    </td>\n                </tr>\n            </tbody></table>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\ntd[_v-3b3c8ec8] {\n  text-align: center; }\n\n/* line 6, stdin */\n.tab[_v-3b3c8ec8] {\n  padding: 20px 0;\n  font-size: medium; }\n  /* line 10, stdin */\n  .tab span[_v-3b3c8ec8] {\n    cursor: pointer;\n    padding-right: 5px;\n    padding-left: 5px; }\n\n/* line 17, stdin */\n.status-cell[_v-3b3c8ec8] {\n  vertical-align: middle;\n  line-height: 33px;\n  font-size: medium; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-3b3c8ec8", module.exports)
  } else {
    hotAPI.update("_v-3b3c8ec8", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/typeof":72,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1455:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _edit = require('./edit.vue');

var _edit2 = _interopRequireDefault(_edit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('webadmin-studio-plan-edit', _edit2.default);

},{"./edit.vue":1454,"vue":792}],1456:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _subscribeList = require('./subscribe-list.vue');

var _subscribeList2 = _interopRequireDefault(_subscribeList);

var _modifyModal = require('./modify-modal.vue');

var _modifyModal2 = _interopRequireDefault(_modifyModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//Page
_vue2.default.component('webadmin-contract-subscribe-list', _subscribeList2.default);
_vue2.default.component('webadmin-contract-subscribe-modify-modal', _modifyModal2.default);

},{"./modify-modal.vue":1457,"./subscribe-list.vue":1458,"vue":792}],1457:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.information[_v-6a0a2554] {\n  color: #919292;\n  font-size: 14px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        id: {
            default: null
        },
        contract: {
            default: null
        }
    },
    mounted: function mounted() {
        this.getSubscribeStrategy();
        this.getContracts();
    },
    data: function data() {
        return {
            ajaxing: {
                strategy: false,
                edit: false
            },
            autoPayStrategies: [],
            subscribeData: {
                'purchase_strategy': null,
                'is_enable': 0,
                'price': null,
                contract: null,
                value: null,
                effective_days: null,
                enable_first_price: false, //參數名稱待定
                first_price: 0, //參數名稱待定
                description: '' //參數名稱待定
            },
            contractProducts: []
        };
    },

    watch: {
        ACTIVE_STUDIO_ID: function ACTIVE_STUDIO_ID(val) {
            this.getContracts();
        },
        'subscribeData.contract': function subscribeDataContract(newVal) {
            if (this.id != null) {

                return;
            }
            if (newVal == null) {
                this.subscribeData.value = null;
                this.subscribeData.effective_days = null;
                this.subscribeData.price = null;
                return;
            }
            this.subscribeData.value = newVal.value;
            this.subscribeData.effective_days = newVal.effective_days;
            this.subscribeData.price = newVal.price;
        },
        id: function id(newVal) {
            if (newVal == null) {
                //reset subscribeData
            }
            this.edit();
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)("webadmin/configure", ["ACTIVE_STUDIO_ID"]), {
        enableAutopayFirstPrice: function enableAutopayFirstPrice() {
            if (this.$store.state.webadmin.configure.functionSwitch) {
                return this.$store.state.webadmin.configure.functionSwitch.enableAutopayFirstPrice || false;
            }
            return false;
        },
        currentStrategy: function currentStrategy() {
            var _this = this;

            if (this.subscribeData.purchase_strategy == null) {
                return {
                    'name': '',
                    'notify_wording': ''
                };
            }
            return this.autoPayStrategies.reduce(function (subscribe, data) {
                if (data.id == _this.subscribeData.purchase_strategy.id) {
                    subscribe = data;
                }

                return subscribe;
            }, {});
        },
        contractInformation: function contractInformation() {
            var contract = this.subscribeData.contract;
            if (contract == null) {
                return '';
            }
            var typeWord = '';
            switch (contract.type) {
                case 1:
                    typeWord = '';
                    break;
                case 2:
                    typeWord = '\u9EDE\u6578\uFF1A' + contract.value + '\u9EDE\uFF0C';
                    break;
                case 3:
                    typeWord = '\u6B21\u6578\uFF1A' + contract.value + '\u6B21\uFF0C';
                    break;

                default:
                    break;
            }
            return typeWord + '\u91D1\u984D\uFF1A' + $17.thousandthFormat(contract.price) + '\uFF0C\u6709\u6548\u5929\u6578\uFF1A' + contract.effective_days + '\u5929';
        },
        contractTypeWord: function contractTypeWord() {
            if (this.subscribeData.contract == null) {
                return '';
            }
            var typeWord = '';
            switch (this.subscribeData.contract.type) {
                case 1:
                    typeWord = '';
                    break;
                case 2:
                    typeWord = '點數';
                    break;
                case 3:
                    typeWord = '次數';
                    break;

                default:
                    break;
            }
            return typeWord;
        },
        showContractValue: function showContractValue() {
            if (this.subscribeData.contract == null) {
                return false;
            }
            return [2, 3].indexOf(this.subscribeData.contract.type) != -1;
        },
        readonlyMode: function readonlyMode() {
            return this.id !== null;
        }
    }),
    methods: {
        priceFormat: function priceFormat(data) {
            var num = Number(data);
            return '$' + $17.thousandthFormat(num);
        },
        getSubscribeStrategy: function getSubscribeStrategy() {
            var _this2 = this;

            this.ajaxing.strategy = true;
            this.$http.get('/adminapi/contract-subscribe/strategy').then(function (response) {
                _this2.ajaxing.strategy = false;
                _this2.autoPayStrategies = response.data;
            }).catch(function (response) {
                _this2.alert('error', '付款週期失敗');
                $17.swal({
                    type: 'error',
                    title: '發生錯誤',
                    text: '取得付款週期失敗',
                    showCancelButton: false
                });
                _this2.ajaxing.strategy = false;
            });
        },
        getContracts: function getContracts() {
            var _this3 = this;

            this.ajaxing.contract = true;
            if (!this.ACTIVE_STUDIO_ID) {
                return;
            }
            this.contractProducts = [];
            this.$http.get('/adminapi/contract/online-sellable/studio/' + this.ACTIVE_STUDIO_ID).then(function (response) {
                _this3.ajaxing.contract = false;
                _this3.contractProducts = response.data;
            }).catch(function (response) {
                $17.swal({
                    type: 'error',
                    title: '發生錯誤',
                    text: '取得可訂閱方案失敗',
                    showCancelButton: false
                });
                _this3.ajaxing.contract = false;
            });
        },
        save: function save() {
            var _this4 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                var param, id;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!(_this4.subscribeData.price <= 0)) {
                                    _context.next = 3;
                                    break;
                                }

                                $17.swal({
                                    type: 'error',
                                    title: '新增失敗',
                                    text: '訂閱價格欄位,金額需>0',
                                    showCancelButton: false
                                });

                                return _context.abrupt('return');

                            case 3:
                                if (!(_this4.subscribeData.enable_first_price && _this4.subscribeData.first_price <= 0)) {
                                    _context.next = 6;
                                    break;
                                }

                                //參數名稱待定
                                $17.swal({
                                    type: 'error',
                                    title: '新增失敗',
                                    text: '訂閱首期價格欄位,金額需>0',
                                    showCancelButton: false
                                });
                                return _context.abrupt('return');

                            case 6:
                                if (!(_this4.subscribeData.purchase_strategy == null || _this4.subscribeData.is_enable == null || !_this4.subscribeData.price || _this4.subscribeData.contract == null || _this4.subscribeData.effective_days == null)) {
                                    _context.next = 9;
                                    break;
                                }

                                $17.swal({
                                    type: 'error',
                                    title: '新增失敗',
                                    text: '請檢查是否有欄位或選項未填寫或選擇',
                                    showCancelButton: false
                                });
                                return _context.abrupt('return');

                            case 9:
                                if (!(_this4.showContractValue && _this4.subscribeData.value == null)) {
                                    _context.next = 12;
                                    break;
                                }

                                $17.swal({
                                    type: 'error',
                                    title: '新增失敗',
                                    text: '請檢查是否有欄位或選項未填寫或選擇',
                                    showCancelButton: false
                                });
                                return _context.abrupt('return');

                            case 12:
                                _this4.ajaxing.save = true;
                                param = {
                                    'purchase_strategy_type': _this4.subscribeData.purchase_strategy.type,
                                    'purchase_strategy_id': _this4.subscribeData.purchase_strategy.id,
                                    'is_enable': _this4.subscribeData.is_enable,
                                    'price': _this4.subscribeData.price,
                                    'spec_table_id': _this4.subscribeData.contract.id,
                                    'value': _this4.subscribeData.value,
                                    'effective_days': _this4.subscribeData.effective_days,
                                    'enable_first_price': _this4.subscribeData.enable_first_price ? 1 : 0, //參數名稱待定
                                    'first_price': _this4.subscribeData.first_price, //參數名稱待定
                                    'description': _this4.subscribeData.description //參數名稱待定
                                };
                                id = _this4.id == null ? '' : _this4.id;
                                _context.next = 17;
                                return _this4.$http.post('/adminapi/contract-subscribe/setting/product_price_option/' + id, param).then(function (response) {
                                    _this4.ajaxing.save = false;
                                    _this4.hide();
                                    _this4.$emit('fresh-list');
                                }).catch(function (response) {
                                    $17.swal({
                                        type: 'error',
                                        title: '發生錯誤',
                                        text: response.data.message,
                                        showCancelButton: false
                                    });
                                    _this4.ajaxing.save = false;
                                });

                            case 17:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this4);
            }))();
        },
        edit: function edit() {
            var _this5 = this;

            if (this.id == null) {
                return;
            }
            this.ajaxing.edit = true;
            this.$http.get('/adminapi/contract-subscribe/setting/product_price_option/' + this.id).then(function (response) {
                var editData = response.data;
                var purchase_strategy = _this5.autoPayStrategies.reduce(function (subscribe, data) {
                    if (data.id == editData.purchase_strategy_id && data.type == editData.purchase_strategy_type) {
                        subscribe = data;
                    }

                    return subscribe;
                }, {});

                _this5.subscribeData = {
                    'purchase_strategy': purchase_strategy,
                    'is_enable': editData.is_enable,
                    'price': editData.price,
                    contract: _this5.contract,
                    value: editData.value,
                    effective_days: editData.effective_days,
                    'enable_first_price': editData.enable_first_price, //參數名稱待定
                    'first_price': editData.first_price, //參數名稱待定
                    'description': editData.description //參數名稱待定
                };
                _this5.ajaxing.edit = false;
            }).catch(function (response) {
                $17.swal({
                    type: 'error',
                    title: '發生錯誤',
                    text: '取得設定失敗',
                    showCancelButton: false
                });
                _this5.ajaxing.edit = false;
            });
        },
        clear: function clear() {
            this.subscribeData = {
                'purchase_strategy': null,
                'is_enable': 0,
                'price': null,
                contract: null,
                value: null,
                effective_days: null,
                enable_first_price: false, //參數名稱待定
                first_price: 0, //參數名稱待定
                description: '' //參數名稱待定
            };
            this.$emit('reset-id');
        },
        hide: function hide() {
            $(this.$el).find('#contract-subscribe-modify-modal').modal('hide');
        },
        updateDirection: function updateDirection(data) {
            this.subscribeData.description = data; //參數名稱待定
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-6a0a2554=\"\">\n    <v-modal id=\"contract-subscribe-modify-modal\" :close-modal-event=\"clear\" _v-6a0a2554=\"\">\n        <div slot=\"title\" _v-6a0a2554=\"\">訂閱設定</div>\n        <div slot=\"body\" _v-6a0a2554=\"\">\n            <v-spinner :ajaxing=\"ajaxing.edit\" _v-6a0a2554=\"\"></v-spinner>\n            <div v-show=\"!ajaxing.edit\" _v-6a0a2554=\"\">\n                <div v-show=\"!ajaxing.strategy &amp;&amp; id==null\" class=\"row m-bottom-15\" _v-6a0a2554=\"\">\n                    <div class=\"col-xs-3 text-right\" _v-6a0a2554=\"\">\n                        <label _v-6a0a2554=\"\">付款週期</label>\n                    </div>\n                    <div class=\"col-xs-9\" _v-6a0a2554=\"\">\n                        <div class=\"st-space-y-4\" _v-6a0a2554=\"\">\n                            <st-radio v-for=\"(strategy,index) in autoPayStrategies\" :name=\"'strategy'+strategy.id\" :label=\"strategy.name\" :value=\"strategy\" :model.sync=\"subscribeData.purchase_strategy\" _v-6a0a2554=\"\">\n                            </st-radio>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"row m-bottom-15\" v-show=\"ajaxing.strategy\" _v-6a0a2554=\"\">\n                    <div class=\"col-xs-3 text-right\" _v-6a0a2554=\"\">\n                        <label _v-6a0a2554=\"\">付款週期</label>\n                    </div>\n                    <div class=\"col-xs-9\" _v-6a0a2554=\"\">\n                        <v-spinner-button v-if=\"ajaxing.strategy\" :ajaxing=\"ajaxing.strategy\" _v-6a0a2554=\"\"></v-spinner-button>\n                    </div>\n                </div>\n                <div class=\"row m-bottom-15\" v-if=\"id!=null\" _v-6a0a2554=\"\">\n                    <div class=\"col-xs-3 text-right\" _v-6a0a2554=\"\">\n                        <label _v-6a0a2554=\"\">付款週期</label>\n                    </div>\n                    <div class=\"col-xs-9\" _v-6a0a2554=\"\">\n                        <label _v-6a0a2554=\"\">{{ currentStrategy.name }}</label>\n                    </div>\n                </div>\n                <div class=\"row m-bottom-20\" v-show=\"currentStrategy.notify_wording\" _v-6a0a2554=\"\">\n                    <div class=\"col-xs-offset-2 col-xs-8\" _v-6a0a2554=\"\">\n                        <div class=\"alert alert-warning\" role=\"alert\" _v-6a0a2554=\"\">\n                            <i class=\"fa fa-exclamation-circle\" _v-6a0a2554=\"\"></i>\n                            {{ currentStrategy.notify_wording }}\n                        </div>\n                    </div>\n                </div>\n                <div class=\"row\" _v-6a0a2554=\"\">\n                    <div class=\"col-xs-3 text-right\" _v-6a0a2554=\"\">\n                        <label _v-6a0a2554=\"\">訂閱方案</label>\n                    </div>\n                    <div class=\"col-xs-6\" _v-6a0a2554=\"\">\n                        <v-mutiselect :model.sync=\"subscribeData.contract\" :options=\"contractProducts\" :multiple=\"false\" :close-on-select=\"true\" :searchable=\"false\" label=\"name\" track-by=\"id\" :placeholder=\"ajaxing.contract?'方案讀取中':'請選擇方案'\" v-if=\"id==null\" _v-6a0a2554=\"\"></v-mutiselect>\n\n                        <label v-if=\"id!=null&amp;&amp;subscribeData.contract!=null\" _v-6a0a2554=\"\">{{ subscribeData.contract.name }}</label>\n                    </div>\n                </div>\n                <div class=\"row m-bottom-20\" _v-6a0a2554=\"\">\n                    <div class=\"col-xs-3 text-right\" _v-6a0a2554=\"\">\n\n                    </div>\n                    <div class=\"col-xs-9\" _v-6a0a2554=\"\">\n                        <small class=\"information\" _v-6a0a2554=\"\">\n                            {{ contractInformation }}\n                        </small>\n                    </div>\n                </div>\n                <div v-if=\"subscribeData.contract!=null &amp;&amp; id==null\" class=\"m-bottom-50\" _v-6a0a2554=\"\">\n                    <div class=\"row m-bottom-20\" v-if=\"showContractValue\" _v-6a0a2554=\"\">\n                        <div class=\"col-xs-6 col-xs-offset-3\" _v-6a0a2554=\"\">\n                            <st-input type=\"number\" v-model=\"subscribeData.value\" min=\"0\" :label=\"contractTypeWord\" _v-6a0a2554=\"\">\n                            </st-input>\n                        </div>\n                    </div>\n                    <div class=\"row\" _v-6a0a2554=\"\">\n                        <div class=\"col-xs-6 col-xs-offset-3\" _v-6a0a2554=\"\">\n                            <st-input type=\"number\" v-model=\"subscribeData.effective_days\" min=\"0\" label=\"有效天數\" _v-6a0a2554=\"\">\n                            </st-input>\n                        </div>\n                    </div>\n                </div>\n                <div v-if=\"subscribeData.contract!=null &amp;&amp; id!=null\" _v-6a0a2554=\"\">\n                    <div class=\"row m-bottom-25\" v-if=\"showContractValue\" _v-6a0a2554=\"\">\n                        <div class=\"col-xs-3 text-right\" _v-6a0a2554=\"\">\n                            <label _v-6a0a2554=\"\">{{ contractTypeWord }}</label>\n                        </div>\n                        <div class=\"col-xs-6\" _v-6a0a2554=\"\">\n                            <label _v-6a0a2554=\"\">{{ subscribeData.value }}</label>\n                        </div>\n                    </div>\n                    <div class=\"row m-bottom-25\" _v-6a0a2554=\"\">\n                        <div class=\"col-xs-3 text-right\" _v-6a0a2554=\"\">\n                            <label _v-6a0a2554=\"\">有效天數</label>\n                        </div>\n                        <div class=\"col-xs-6\" _v-6a0a2554=\"\">\n                            <label v-if=\"id!==null\" _v-6a0a2554=\"\">{{ subscribeData.effective_days }}</label>\n                        </div>\n                    </div>\n                </div>\n                <template v-if=\"enableAutopayFirstPrice\">    \n                <div class=\"row m-bottom-25\" v-if=\"readonlyMode&amp;&amp;subscribeData.enable_first_price\" _v-6a0a2554=\"\">\n                    <div class=\"col-xs-3 text-right\" _v-6a0a2554=\"\">\n                        <label _v-6a0a2554=\"\">首期價格</label>\n                    </div>\n                    <div class=\"col-xs-6 st-space-y-1\" _v-6a0a2554=\"\">\n                        <label _v-6a0a2554=\"\">{{ priceFormat(subscribeData.first_price) }}</label> \n                    </div>\n                </div>\n                <div class=\"row m-bottom-25\" v-if=\"!readonlyMode\" _v-6a0a2554=\"\">\n                    <div class=\"col-xs-3 text-right\" _v-6a0a2554=\"\">\n                        <label _v-6a0a2554=\"\">首期價格設定</label>\n                    </div>\n                    <div class=\"col-xs-6 st-space-y-1\" _v-6a0a2554=\"\">\n                        <st-checkbox name=\"enable_first_price\" :model.sync=\"subscribeData.enable_first_price\" label=\"開啟\" _v-6a0a2554=\"\">\n                        </st-checkbox> \n                        <st-input v-show=\"subscribeData.enable_first_price\" v-model=\"subscribeData.first_price\" min=\"1\" type=\"number\" placeholder=\"請輸入首期價格\" _v-6a0a2554=\"\"> \n                        </st-input>\n                    </div>\n                </div>\n                </template>\n                <div class=\"row m-bottom-25\" _v-6a0a2554=\"\">\n                    <div class=\"col-xs-3 text-right\" _v-6a0a2554=\"\">\n                        <label _v-6a0a2554=\"\">訂閱價格</label>\n                    </div>\n                    <div class=\"col-xs-6\" _v-6a0a2554=\"\">\n                        <st-input v-if=\"id==null\" type=\"number\" v-model=\"subscribeData.price\" placeholder=\"請輸入訂閱價格\" required=\"\" min=\"1\" _v-6a0a2554=\"\">\n                            <div slot=\"infoBlock\" v-if=\"subscribeData.price <=0\" _v-6a0a2554=\"\">\n                                <div class=\"st-text-14 st-text-danger\" _v-6a0a2554=\"\">*訂閱價格必須&gt;0</div>\n                            </div>\n                        </st-input>\n                        <label v-if=\"id!==null\" _v-6a0a2554=\"\">{{ priceFormat(subscribeData.price) }}</label>\n                    </div>\n                </div>\n                <div class=\"row m-bottom-25\" _v-6a0a2554=\"\">\n                    <div class=\"col-xs-3 text-right\" _v-6a0a2554=\"\">\n                        <label _v-6a0a2554=\"\">訂閱說明</label>\n                    </div>\n                    <div class=\"col-xs-6\" _v-6a0a2554=\"\">\n                        <st-ck-editor :init-editor-data=\"subscribeData.description\" @watch-ck-editor=\"updateDirection\" :toolbar=\"[]\" placeholder=\"請輸入訂閱說明\" _v-6a0a2554=\"\">\n                        </st-ck-editor>\n                    </div>\n                </div>\n                <div class=\"row m-bottom-25\" _v-6a0a2554=\"\">\n                    <div class=\"col-xs-3 text-right\" _v-6a0a2554=\"\">\n                        <label _v-6a0a2554=\"\">訂閱銷售狀態</label>\n                    </div>\n                    <div class=\"col-xs-6\" _v-6a0a2554=\"\">\n                        <div class=\"st-space-y-4\" _v-6a0a2554=\"\">\n                            <st-radio label=\"上架\" name=\"1\" :value=\"1\" :model.sync=\"subscribeData.is_enable\" _v-6a0a2554=\"\"></st-radio>\n                            <st-radio label=\"下架\" name=\"0\" :value=\"0\" :model.sync=\"subscribeData.is_enable\" _v-6a0a2554=\"\"></st-radio>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div slot=\"footer\" _v-6a0a2554=\"\">\n            <div class=\"st-flex st-justify-end st-space-x-2\" _v-6a0a2554=\"\">\n                <st-button black=\"\" ghost=\"\" text=\"關閉\" @click.prevent=\"hide\" _v-6a0a2554=\"\"></st-button>\n                <st-button secondary=\"\" filled=\"\" normal=\"\" text=\"確定\" @click.prevent=\"save\" _v-6a0a2554=\"\"></st-button>\n            </div>\n        </div>\n    </v-modal>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.information[_v-6a0a2554] {\n  color: #919292;\n  font-size: 14px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-6a0a2554", module.exports)
  } else {
    hotAPI.update("_v-6a0a2554", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1458:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            editId: null,
            contract: null,
            tableConfig: {
                columns: [{
                    keys: 'contract_name',
                    head: '方案名稱',
                    disabledClick: false
                }, {
                    keys: 'contract_value',
                    head: '方案內容',
                    disabledClick: false
                }, {
                    keys: 'contract_effective_days',
                    head: '訂閱有效天數',
                    disabledClick: false
                }, {
                    keys: 'first_price', // 欄位名稱待定
                    head: '首期價格',
                    html: function html(item) {
                        return item.first_price > 0 ? '$' + $17.thousandthFormat(item.first_price) : '-';
                    },
                    disabledClick: false
                }, {
                    keys: 'price',
                    head: '訂閱價格',
                    disabledClick: false
                }, {
                    keys: 'autopay_purchase_strategy_name',
                    head: '訂閱模式',
                    disabledClick: false
                }, {
                    keys: 'is_enable',
                    head: '訂閱銷售狀態',
                    disabledClick: false
                }]
            },
            apiConfig: {
                method: 'get',
                apiurl: '/adminapi/contract-subscribe/setting/list',
                payload: {
                    studio_id: null,
                    is_enable: null,
                    page: 1,
                    page_size: 3
                },
                recordName: 'orders'
            }

        };
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/configure', ['studioId', 'branchId', 'isBranch']), (0, _vuex.mapState)('filters', ['selected_studio_id', 'selected_branch_id']), (0, _vuex.mapGetters)('webadmin/configure', ['ACTIVE_STUDIO_ID', 'ACTIVE_BRANCH_ID'])),
    watch: {
        ACTIVE_STUDIO_ID: function ACTIVE_STUDIO_ID(newVal) {
            this.apiConfig.payload.studio_id = newVal;
        }
    },
    methods: {
        openCreateModal: function openCreateModal() {
            $('#contract-subscribe-modify-modal').modal('show');
        },
        rowClickCallback: function rowClickCallback(item) {
            this.editId = item.row.id;
            this.contract = item.row.contract;
            this.openCreateModal();
        },
        freshList: function freshList() {
            this.$refs.smartTable.fetchRecords();
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"container m-top-20\">\n    <v-multiselect-studio-and-branch :studio_id=\"studioId\" :branch_id=\"branchId\" :show-branch=\"false\"></v-multiselect-studio-and-branch>\n    <div class=\"row m-bottom-15\">\n        <div class=\"col-xs-6\">\n            <st-button success=\"\" filled=\"\" normal=\"\" left-icon=\"add\" @click.prevent=\"openCreateModal\" text=\"新增\">\n            </st-button>\n        </div>\n        <div class=\"col-xs-offset-4 col-xs-2 text-right\">\n            <select class=\"form-control\" v-model=\"apiConfig.payload.is_enable\">\n                <option :value=\"null\">顯示全部</option>\n                <option :value=\"1\">上架</option>\n                <option :value=\"0\">下架</option>\n            </select>\n        </div>\n    </div>\n\n    <v-smart-table ref=\"smartTable\" :table-config=\"tableConfig\" :api-config=\"apiConfig\" @row-click-callback=\"rowClickCallback\" :enable-row-click=\"true\"></v-smart-table> \n\n    <webadmin-contract-subscribe-modify-modal :id=\"editId\" :contract=\"contract\" @fresh-list=\"freshList\" @reset-id=\"editId=null\"></webadmin-contract-subscribe-modify-modal>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-7375c8bb", module.exports)
  } else {
    hotAPI.update("_v-7375c8bb", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1459:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    data: function data() {
        return {
            position: 'webadmin'
        };
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<notification-setting :position=\"position\"></notification-setting>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-61790868", module.exports)
  } else {
    hotAPI.update("_v-61790868", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],1460:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    data: function data() {
        return {
            position: 'web'
        };
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<notification-setting :position=\"position\"></notification-setting>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-fb91da30", module.exports)
  } else {
    hotAPI.update("_v-fb91da30", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],1461:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _backendNotificationSetting = require('./backendNotificationSetting.vue');

var _backendNotificationSetting2 = _interopRequireDefault(_backendNotificationSetting);

var _frontendNotificationSetting = require('./frontendNotificationSetting.vue');

var _frontendNotificationSetting2 = _interopRequireDefault(_frontendNotificationSetting);

var _notificationSetting = require('./notificationSetting.vue');

var _notificationSetting2 = _interopRequireDefault(_notificationSetting);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('backend-notification-setting', _backendNotificationSetting2.default);
_vue2.default.component('frontend-notification-setting', _frontendNotificationSetting2.default);
_vue2.default.component('notification-setting', _notificationSetting2.default);

},{"./backendNotificationSetting.vue":1459,"./frontendNotificationSetting.vue":1460,"./notificationSetting.vue":1462,"vue":792}],1462:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    data: function data() {
        return {
            ajaxing: false,
            openLink: false,
            postData: {
                style: 'alert-info',
                state: 0,
                text: '',
                link: '',
                allow_close: 0
            }
        };
    },
    props: {
        position: {
            type: String,
            required: true
        }
    },
    mounted: function mounted() {
        this.getConfig();
    },

    computed: {
        disabledSave: function disabledSave() {
            if (this.postData.state === 1 && this.postData.text === '') {
                return true;
            }
            return false;
        }
    },
    methods: {
        getConfig: function getConfig() {
            var _this = this;

            this.ajaxing = true;
            this.$http.get('/adminapi/system/get-notification/' + this.position).then(function (response) {
                if (response.data.length !== 0) {
                    _this.postData = response.data;
                    if (_this.postData.link != '') {
                        _this.openLink = true;
                    }
                }
                _this.ajaxing = false;
            }).catch(function (response) {
                _this.alert('error', '取得設定失敗');
                _this.ajaxing = false;
            });
        },
        save: function save() {
            var _this2 = this;

            this.ajaxing = true;
            var postData = this.postData;
            postData.allow_close = postData.allow_close ? 1 : 0;
            postData.position = this.position;
            this.$http.post('/adminapi/system/notification', postData).then(function (response) {
                _this2.alert('success', '變更成功');
                _this2.ajaxing = false;
            }).catch(function (response) {
                _this2.alert('error', '變更失敗');
                _this2.ajaxing = false;
            });
        },
        clearLink: function clearLink() {
            if (!this.openLink) {
                this.postData.link = '';
            }
        },
        alert: function alert(type, title) {
            var text = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
            var html = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

            $17.swal({
                title: title,
                text: text,
                type: type,
                html: html,
                showCancelButton: false
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div>\n    <v-spinner :ajaxing=\"ajaxing\"></v-spinner>\n    <div class=\"col-xs-12 m-bottom-50\" v-if=\"!ajaxing\">\n        <div class=\"form-horizontal\">\n            <div class=\"form-group\">\n                <label class=\"col-sm-5\"></label>\n                <div class=\"col-sm-7\">\n                    <v-bs-switch v-model=\"postData.state\" id=\"state\"></v-bs-switch>\n                </div>\n            </div>\n            <hr>\n            <div class=\"form-group\">\n                <label class=\"col-sm-5 control-label\">樣式</label>\n                <div class=\"col-sm-3\">\n                    <select v-model=\"postData.style\" class=\"form-control w-100 d-inline\">\n                        <option value=\"alert-info\">info</option>\n                        <option value=\"alert-success\">success</option>\n                        <option value=\"alert-warning\">warning</option>\n                        <option value=\"alert-danger\">danger</option>\n                    </select>\n                </div>\n            </div>\n            <div class=\"form-group\">\n                <label class=\"col-sm-5 control-label\">文字</label>\n                <div class=\"col-sm-5\">\n                    <input type=\"text\" class=\"form-control\" v-model=\"postData.text\">\n                </div>\n            </div>\n            <div class=\"form-group\">\n                <label class=\"col-sm-5 control-label\">新視窗連結</label>\n                <div class=\"col-sm-5\">\n                    <input type=\"checkbox\" class=\"switch-btn\" v-model=\"openLink\" @change=\"clearLink\">\n                </div>\n            </div>\n            <div class=\"form-group\" v-show=\"openLink\">\n                <label class=\"col-sm-5\"></label>\n                <div class=\"col-sm-5\">\n                    <input type=\"text\" class=\"form-control\" v-model=\"postData.link\" placeholder=\"http://\">\n                </div>\n            </div>\n            <div class=\"form-group\">\n                <label class=\"col-sm-5 control-label\">允許用戶關閉提示</label>\n                <div class=\"col-sm-7\">\n                    <input type=\"checkbox\" class=\"switch-btn\" v-model=\"postData.allow_close\">\n                </div>\n            </div>\n        </div>\n\n        <div class=\"text-center m-top-50\">\n            <button class=\"btn btn-primary\" :disabled=\"disabledSave\" @click.prevent=\"save()\">確認</button>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-af1dab4c", module.exports)
  } else {
    hotAPI.update("_v-af1dab4c", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],1463:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _viewMain = require('./view-main.vue');

var _viewMain2 = _interopRequireDefault(_viewMain);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//Page
_vue2.default.component('webadmin-system_right-view-main', _viewMain2.default);

},{"./view-main.vue":1464,"vue":792}],1464:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\np[_v-28ba16f3] {\n  display: block;\n  margin: 0; }\n\n/* line 6, stdin */\n.content[_v-28ba16f3] {\n  padding-top: 15px;\n  padding-bottom: 15px; }\n\n/* line 11, stdin */\n.data-list[_v-28ba16f3], .diff-data[_v-28ba16f3], .filter-option[_v-28ba16f3] {\n  padding-top: 3em;\n  padding-bottom: 3em; }\n\n/* line 15, stdin */\n.content[_v-28ba16f3]:nth-child(odd) {\n  background-color: #ddd; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        var _ref;

        return _ref = {
            ajaxing: {
                studioAndBranch: false,
                roleRelated: false,
                roleRelatedMember: false
            }
        }, (0, _defineProperty3.default)(_ref, 'ajaxing', true), (0, _defineProperty3.default)(_ref, 'studioId', 0), (0, _defineProperty3.default)(_ref, 'branchId', 0), (0, _defineProperty3.default)(_ref, 'data', []), (0, _defineProperty3.default)(_ref, 'roles', []), (0, _defineProperty3.default)(_ref, 'roleSelected', null), (0, _defineProperty3.default)(_ref, 'roleMembers', []), (0, _defineProperty3.default)(_ref, 'roleMemberSelected', null), (0, _defineProperty3.default)(_ref, 'selectMember', false), (0, _defineProperty3.default)(_ref, 'memberCurrentActions', []), (0, _defineProperty3.default)(_ref, 'memberCacheActions', []), _ref;
    },
    created: function created() {
        this.getCurrent();
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('filters', ['selected_studio_id', 'selected_branch_id']), {
        actions: function actions() {
            return this.data.reduce(function (carry, item) {
                item.systemRightFunctionGroup.actions.map(function (action) {
                    carry.push(action.name);
                });

                return carry;
            }, []);
        },
        actionCurrentDIff: function actionCurrentDIff() {
            var _this = this;

            return this.actions.filter(function (x) {
                return !_this.memberCurrentActions.includes(x);
            });
        },
        actionCacheDIff: function actionCacheDIff() {
            var _this2 = this;

            return this.actions.filter(function (x) {
                return !_this2.memberCacheActions.includes(x);
            });
        },
        title: function title() {
            if (this.roleSelected == null && this.roleMemberSelected == null) {
                return '系統預設的權限對應';
            }

            if (this.roleSelected != null && this.roleMemberSelected == null) {
                return '品牌或場館角色的權限對應';
            }

            if (this.roleSelected != null && this.roleMemberSelected != null) {
                return '選定角色人員的權限對應';
            }
        }
    }),
    methods: {
        getCurrent: function getCurrent() {
            var _this3 = this;

            this.ajaxing.studioAndBranch = true;
            this.$http.get('/adminapi/web-function/system-right').then(function (response) {
                _this3.data = response.data;
                _this3.ajaxing.studioAndBranch = false;
            }, function (error) {
                _this3.ajaxing.studioAndBranch = false;
            });
        },
        getRoles: function getRoles() {
            var _this4 = this;

            if (!this.selected_studio_id) {
                return;
            }
            this.ajaxing.studioAndBranch = true;
            this.reset();
            this.$http.get('/adminapi/web-function/system-right/bizapp-role', { params: { studio_id: this.selected_studio_id, branch_id: this.selected_branch_id } }).then(function (response) {
                _this4.roles = response.data;
                _this4.ajaxing.studioAndBranch = false;
            }, function (error) {
                _this4.ajaxing.studioAndBranch = false;
            });
        },
        getRoleRelateds: function getRoleRelateds() {
            var _this5 = this;

            if (this.roleSelected == null || !this.selected_studio_id || !this.roleSelected.id) {
                return;
            }
            this.data = [];
            this.roleMembers = [];
            this.roleMemberSelected = null;

            this.ajaxing.roleRelated = true;
            this.$http.get('/adminapi/web-function/system-right/bizapp-role/group-and-action', { params: { studio_id: this.selected_studio_id, branch_id: this.selected_branch_id, system_right_role_id: this.roleSelected.id } }).then(function (response) {
                _this5.data = response.data;
                _this5.ajaxing.roleRelated = false;
            }, function (error) {
                _this5.ajaxing.roleRelated = false;
            });
        },
        getRoleRelatedMembers: function getRoleRelatedMembers() {
            var _this6 = this;

            if (this.roleSelected == null || !this.selected_studio_id || !this.roleSelected.id) {
                return;
            }

            this.ajaxing.roleRelatedMember = true;
            this.$http.get('/adminapi/web-function/system-right/bizapp-role/related-member', { params: { system_right_role_id: this.roleSelected.id } }).then(function (response) {
                _this6.roleMembers = response.data;
                _this6.ajaxing.roleRelatedMember = false;
            }, function (error) {
                _this6.ajaxing.roleRelatedMember = false;
            });
        },
        getRoleRelatedMemberActions: function getRoleRelatedMemberActions() {
            var _this7 = this;

            if (!this.roleMemberSelected.system_right_related_role_id) {
                return;
            }
            this.ajaxing.roleRelatedMemberAction = true;
            this.$http.get('/adminapi/web-function/system-right/bizapp-role/related-role-action', { params: { system_right_related_role_id: this.roleMemberSelected.system_right_related_role_id } }).then(function (response) {
                _this7.memberCurrentActions = response.data.currentPermissions;
                _this7.memberCacheActions = response.data.cachePermissions;
                _this7.ajaxing.roleRelatedMemberAction = false;
            }, function (error) {
                _this7.ajaxing.roleRelatedMemberAction = false;
            });
        },
        reset: function reset() {
            this.roleSelected = null;
            this.data = [];
            this.roles = [];
        },
        checkCurrentMemberActionExist: function checkCurrentMemberActionExist(action) {
            if (this.selectMember) {
                return this.memberCurrentActions.indexOf(action) == -1 ? 'X' : 'O';
            }
        },
        checkCacheMemberActionExist: function checkCacheMemberActionExist(action) {
            if (this.selectMember) {
                return this.memberCacheActions.indexOf(action) == -1 ? 'X' : 'O';
            }
        },
        clearMemberFunctionActionCache: function clearMemberFunctionActionCache() {
            if (!this.roleMemberSelected.system_right_related_role_id) {
                return;
            }
            var vm = this;
            this.$http.post('/adminapi/web-function/system-right/bizapp-role/clear-role-action', { system_right_related_role_id: this.roleMemberSelected.system_right_related_role_id }).then(function (response) {
                $17.swal({
                    title: '清除成功',
                    text: '即將重新取得快取資料',
                    type: 'info',
                    showCancelButton: false
                });
                vm.getRoleRelatedMemberActions();
            }, function (error) {});
        }
    },
    watch: {
        selected_studio_id: function selected_studio_id() {
            this.getRoles();
        },
        selected_branch_id: function selected_branch_id() {
            this.getRoles();
        },
        roleSelected: function roleSelected(newVal) {
            if (newVal == null) {
                this.getCurrent();
                return;
            }
            this.getRoleRelateds();
            this.getRoleRelatedMembers();
        },
        selectMember: function selectMember(newVal) {
            if (!newVal) {
                this.memberCurrentActions = [];
                this.memberCacheActions = [];
                this.roleMemberSelected = null;
            }
        },
        roleMemberSelected: function roleMemberSelected() {
            this.getRoleRelatedMemberActions();
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"content-inner\" _v-28ba16f3=\"\">\n    <div class=\"filter-option\" _v-28ba16f3=\"\">\n        <v-select-studio-and-branch :studio_id=\"studioId\" :branch_id=\"branchId\" :branch-without-filtered-option=\"true\" _v-28ba16f3=\"\">\n        </v-select-studio-and-branch>\n        <div class=\"row\" _v-28ba16f3=\"\">\n            <div class=\"col-xs-6\" _v-28ba16f3=\"\">\n                <v-mutiselect v-show=\"!ajaxing.roleRelated\" :model.sync=\"roleSelected\" :options=\"roles\" :multiple=\"false\" :close-on-select=\"true\" :searchable=\"true\" label=\"name\" track-by=\"id\" tag-name=\"name\" placeholder=\"選擇角色\" _v-28ba16f3=\"\"></v-mutiselect>\n            </div>\n            <div class=\"col-xs-2\" v-show=\"roleSelected != null\" _v-28ba16f3=\"\">\n                <input type=\"checkbox\" v-model=\"selectMember\" _v-28ba16f3=\"\">選擇人員\n            </div>\n            <div class=\"col-xs-4\" v-show=\"roleSelected != null\" _v-28ba16f3=\"\">\n                <v-mutiselect v-show=\"!ajaxing.roleRelatedMember &amp;&amp; selectMember\" :model.sync=\"roleMemberSelected\" :options=\"roleMembers\" :multiple=\"false\" :close-on-select=\"true\" :searchable=\"true\" label=\"name\" track-by=\"system_right_related_role_id\" placeholder=\"選擇員工\" _v-28ba16f3=\"\"></v-mutiselect>\n                <div class=\"btn btn-info\" v-if=\"roleMemberSelected !=null &amp;&amp; selectMember\" @click=\"clearMemberFunctionActionCache\" _v-28ba16f3=\"\">\n                    清除快取\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"title\" _v-28ba16f3=\"\">\n        <h4 _v-28ba16f3=\"\">{{ title }}</h4>\n    </div>\n    <div class=\"data-list\" _v-28ba16f3=\"\">\n        <div class=\"row\" _v-28ba16f3=\"\">\n            <div class=\"col-xs-4\" _v-28ba16f3=\"\">系統權限</div>\n            <div class=\"col-xs-4\" _v-28ba16f3=\"\">BizApp系統群組</div>\n            <div class=\"col-xs-4\" _v-28ba16f3=\"\">BizApp系統權限\n                <small _v-28ba16f3=\"\">(資料庫:o , 快取:x 代表使用者目前還沒有使用bizapp 並沒有已存在的紀錄)</small>\n            </div>\n        </div> \n        <hr _v-28ba16f3=\"\">\n        <div class=\"row content\" v-for=\"row in data\" _v-28ba16f3=\"\">\n            <div class=\"col-xs-4\" _v-28ba16f3=\"\">\n                <p _v-28ba16f3=\"\">{{ row['webFunction']['name'] }}</p>\n                <small _v-28ba16f3=\"\">({{ row['webFunction']['function_name'] }})</small>\n            </div>\n            <div class=\"col-xs-4\" _v-28ba16f3=\"\">\n                <p _v-28ba16f3=\"\">{{ row['systemRightFunctionGroup']['name'] }}</p>\n                <small _v-28ba16f3=\"\">({{ row['systemRightFunctionGroup']['group_name'] }})</small>\n            </div>\n            <div class=\"col-xs-4\" _v-28ba16f3=\"\">\n                <div class=\"row\" v-for=\"action in row['systemRightFunctionGroup']['actions']\" _v-28ba16f3=\"\">\n                    <div class=\"col-xs-12\" _v-28ba16f3=\"\">\n                        {{ action['name'] }}\n                        \n                        <span v-if=\"selectMember\" _v-28ba16f3=\"\">\n                            資料庫 ({{ checkCurrentMemberActionExist(action['name']) }}) \n                        </span>\n                        <span v-if=\"selectMember\" _v-28ba16f3=\"\">\n                            快取({{ checkCacheMemberActionExist(action['name']) }})\n                        </span>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"diff-data\" _v-28ba16f3=\"\">\n        <div class=\"row\" v-if=\"selectMember &amp;&amp; memberCurrentActions.length>0\" _v-28ba16f3=\"\">\n            <div class=\"col-xs-4\" _v-28ba16f3=\"\">資料庫權限差異</div>\n            <div class=\"col-xs-4\" _v-28ba16f3=\"\">\n                {{ actionCurrentDIff }}\n            </div>\n        </div> \n        <div class=\"row\" v-if=\"selectMember &amp;&amp; memberCurrentActions.length>0\" _v-28ba16f3=\"\">\n            <div class=\"col-xs-4\" _v-28ba16f3=\"\">快取權限差異</div>\n            <div class=\"col-xs-4\" _v-28ba16f3=\"\">\n                {{ actionCacheDIff }}\n            </div>\n        </div> \n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\np[_v-28ba16f3] {\n  display: block;\n  margin: 0; }\n\n/* line 6, stdin */\n.content[_v-28ba16f3] {\n  padding-top: 15px;\n  padding-bottom: 15px; }\n\n/* line 11, stdin */\n.data-list[_v-28ba16f3], .diff-data[_v-28ba16f3], .filter-option[_v-28ba16f3] {\n  padding-top: 3em;\n  padding-bottom: 3em; }\n\n/* line 15, stdin */\n.content[_v-28ba16f3]:nth-child(odd) {\n  background-color: #ddd; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-28ba16f3", module.exports)
  } else {
    hotAPI.update("_v-28ba16f3", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/defineProperty":65,"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1465:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n#delete[_v-189ec35b] {\n  margin-right: 5%; }\n\n/* line 5, stdin */\n.btn-success[_v-189ec35b] {\n  margin-top: 10px;\n  margin-bottom: 15px;\n  margin-left: 15px; }\n\n/* line 11, stdin */\ntr.border_bottom td[_v-189ec35b] {\n  border-bottom: 1pt solid #ddd; }\n\n/* line 15, stdin */\n.alert[_v-189ec35b] {\n  display: none; }\n\n/* line 19, stdin */\nh6[_v-189ec35b] {\n  color: #807a7a; }\n\n/* line 23, stdin */\ntable[_v-189ec35b] {\n  width: 100%;\n  border-bottom: 10px; }\n\n/* line 28, stdin */\ntr.border_bottom td span[_v-189ec35b] {\n  display: inline; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    created: function created() {
        this.refresh();
    },

    data: function data() {
        return {
            editBtn: '儲存更新',
            createBtn: '確認新增',
            tags: [],
            tagName: {},
            tagId: {},
            startOrder: [],
            resultOrder: [],
            length: 0,
            startAjax: false,
            text: ''
        };
    },
    methods: {
        editModal: function editModal(id, name) {
            this.tagId = id;
            this.tagName = name;
            $('#editTagName').val(this.tagName);
            $('#editModal').modal('show');
        },
        createModal: function createModal() {
            $('#createModal').modal('show');
        },
        refresh: function refresh() {
            this.startAjax = true;
            this.text = '';
            this.$http.get('/adminapi/tag/index').then(function (response) {
                if (response.body.columns.length > 0) {
                    this.startAjax = false;
                    this.tags = response.body.columns;
                    this.length = this.tags.length;
                } else {
                    this.startAjax = false;
                    this.tags = [];
                    this.text = '尚未新增標籤';
                }
            }, function (response) {
                this.startAjax = false;
            });
        },
        createTag: function createTag() {
            var tagName = $('#createTagName').val();
            this.startAjax = true;
            this.$http.post('/adminapi/tag/create', { name: tagName, length: this.length }).then(function (response) {
                this.startAjax = false;
                $('#createModal').modal('hide');
                this.refresh();
                this.alert('新增標籤', '新增成功', 'success');
            }, function (response) {
                this.alert('新增失敗', '新增失敗', 'warning');
                this.startAjax = false;
            });
        },
        editTag: function editTag() {
            var tagName = $('#editTagName').val();
            this.startAjax = true;
            this.$http.patch('/adminapi/tag/' + this.tagId, { name: tagName }).then(function (response) {
                this.startAjax = false;
                $('#editModal').modal('hide');
                this.refresh();
                this.alert('編輯成功', '', 'success');
            }, function (response) {
                this.startAjax = false;
            });
        },
        deleteTag: function deleteTag(id) {
            var _this = this;
            $17.swal({
                title: '刪除標籤',
                text: '刪除後，也會一併刪除客戶的標籤紀錄，這項操作無法返回，確認要刪除此標籤嗎？',
                type: 'warning',
                showCancelButton: true,
                closeOnConfirm: false,
                showLoaderOnConfirm: true
            }, function (answer) {
                if (answer) {
                    _this.startAjax = true;
                    _this.$http.delete('/adminapi/tag/' + id).then(function (response) {
                        _this.startAjax = false;
                        _this.refresh();
                    }, function (response) {
                        _this.startAjax = false;
                    });
                }
            });
        },
        alert: function alert(title, message, type, showCancelBtn) {
            $17.swal({
                title: title,
                text: message,
                type: type,
                showCancelButton: false,
                showLoaderOnConfirm: true
            });
        }
    },
    mounted: function mounted() {
        var _this = this;
        $('#sortableArea').sortable({
            stop: function stop(e, ui) {
                _this.resultOrder = $('#sortableArea').sortable("toArray", { attribute: 'id' });
                //start AJAXing
                _this.startAjax = true;
                _this.$http.post('/adminapi/tag/order', { new: _this.resultOrder }).then(function (response) {
                    _this.startAjax = false;
                    $(".alert-success").fadeTo(2000, 500).slideUp(500, function () {
                        $(".alert-success").slideUp(500);
                    });
                }, function (response) {
                    $(".alert-danger").fadeTo(2000, 500).slideUp(500, function () {
                        $(".alert-danger").slideUp(500);
                    });
                });
            },
            start: function start(event, ui) {
                this.startOrder = $('#sortableArea').sortable("toArray", { attribute: 'id' });
            }
        });
        $('#sortableArea').disableSelection();
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n    <div _v-189ec35b=\"\">\n        <!--alert success-->\n        <div class=\"alert alert-success\" role=\"alert\" _v-189ec35b=\"\">\n            <strong _v-189ec35b=\"\">排序更新成功！</strong>\n        </div>\n\t\t<!--alert success-->\n\n\t\t<!--alert danger-->\n        <div class=\"alert alert-danger\" role=\"alert\" _v-189ec35b=\"\">\n            <strong _v-189ec35b=\"\">排序更新失敗</strong>\n        </div>\n\t\t<!--alert danger-->\n\n        <button type=\"button\" class=\"btn btn-success\" v-on:click=\"createModal\" _v-189ec35b=\"\">新增標籤</button>\n\n        <div class=\"container text-center\" _v-189ec35b=\"\">\n\n            <v-spinner :ajaxing=\"startAjax\" _v-189ec35b=\"\">\n\n            </v-spinner>\n\n            <table v-show=\"!startAjax\" class=\"table pagin-table\" _v-189ec35b=\"\">\n                <thead _v-189ec35b=\"\">\n                <tr _v-189ec35b=\"\">\n                    <th width=\"30%\" _v-189ec35b=\"\">標籤名稱</th>\n                    <th _v-189ec35b=\"\">動作</th>\n                </tr>\n                </thead>\n\n                <tbody align=\"left\" id=\"sortableArea\" _v-189ec35b=\"\">\n                <tr class=\"border_bottom\" v-for=\"tag in tags\" :id=\"tag.id\" _v-189ec35b=\"\">\n                    <td _v-189ec35b=\"\">{{tag.name}} <h6 _v-189ec35b=\"\">{{tag.count}}位客戶</h6></td>\n                    <td _v-189ec35b=\"\">\n                        <span id=\"delete\" _v-189ec35b=\"\"><a href=\"#\" v-on:click=\"deleteTag(tag.id)\" _v-189ec35b=\"\">刪除</a></span>\n                        <span _v-189ec35b=\"\"><a href=\"#\" v-on:click=\"editModal(tag.id,tag.name)\" _v-189ec35b=\"\">編輯</a></span>\n                    </td>\n                </tr>\n                </tbody>\n            </table>\n        </div>\n\n        <v-modal id=\"createModal\" :confirm-btn-text=\"createBtn\" no-cancel=\"\" :save-clicked=\"createTag\" _v-189ec35b=\"\">\n            <h4 slot=\"title\" _v-189ec35b=\"\">新增標籤</h4>\n            <form slot=\"body\" class=\"form-horizontal\" _v-189ec35b=\"\">\n                <div class=\"form-group\" _v-189ec35b=\"\">\n                    <label for=\"tagName\" class=\"col-sm-2 control-label\" _v-189ec35b=\"\">標籤名稱</label>\n                    <div class=\"col-sm-10\" _v-189ec35b=\"\">\n                        <input for=\"tagName\" class=\"form-control\" id=\"createTagName\" placeholder=\"標籤名稱\" _v-189ec35b=\"\">\n                    </div>\n                </div>\n                <v-spinner :ajaxing=\"startAjax\" _v-189ec35b=\"\">\n\n                </v-spinner>\n            </form>\n        </v-modal>\n\n\n        <v-modal id=\"editModal\" no-cancel=\"\" :confirm-btn-text=\"editBtn\" :save-clicked=\"editTag\" _v-189ec35b=\"\">\n            <h4 slot=\"title\" _v-189ec35b=\"\">編輯標籤</h4>\n            <form slot=\"body\" class=\"form-horizontal\" _v-189ec35b=\"\">\n                <div class=\"form-group\" _v-189ec35b=\"\">\n                    <label for=\"tagName\" class=\"col-sm-2 control-label\" _v-189ec35b=\"\">標籤名稱</label>\n                    <div class=\"col-sm-10\" _v-189ec35b=\"\">\n                        <input for=\"tagName\" id=\"editTagName\" class=\"form-control\" placeholder=\"標籤名稱\" _v-189ec35b=\"\">\n                    </div>\n                </div>\n                <v-spinner :ajaxing=\"startAjax\" _v-189ec35b=\"\">\n\n                </v-spinner>\n            </form>\n        </v-modal>\n\n\n    </div>\n\n\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n#delete[_v-189ec35b] {\n  margin-right: 5%; }\n\n/* line 5, stdin */\n.btn-success[_v-189ec35b] {\n  margin-top: 10px;\n  margin-bottom: 15px;\n  margin-left: 15px; }\n\n/* line 11, stdin */\ntr.border_bottom td[_v-189ec35b] {\n  border-bottom: 1pt solid #ddd; }\n\n/* line 15, stdin */\n.alert[_v-189ec35b] {\n  display: none; }\n\n/* line 19, stdin */\nh6[_v-189ec35b] {\n  color: #807a7a; }\n\n/* line 23, stdin */\ntable[_v-189ec35b] {\n  width: 100%;\n  border-bottom: 10px; }\n\n/* line 28, stdin */\ntr.border_bottom td span[_v-189ec35b] {\n  display: inline; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-189ec35b", module.exports)
  } else {
    hotAPI.update("_v-189ec35b", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1466:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _watch;

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            modal: {
                id: null,
                title: '',
                action: '',
                category_id: null
            },
            view: {
                ticketGroups: [],
                groupTxt: '分類',
                isListShow: true,
                ajaxing: false
            },
            state: {
                studio_id: 0,
                canCreate: true,
                canUpdate: true,
                canRemoveGroup: false,
                canEditTitle: false
            },
            relatedFilterWatcher: {
                studio_id: {
                    watcher: null,
                    options: "studioList",
                    vModel: "studioId",
                    trackBy: "id",
                    type: "single"
                },
                branch_ids: {
                    watcher: "studioId",
                    options: "branchList",
                    vModel: "branchIds",
                    trackBy: "id",
                    type: "multiple"
                }
            }
        };
    },
    mounted: function mounted() {
        var _this = this;

        $('#ticket-modal').on('hidden.bs.modal', function (e) {
            _this.$refs.ticket_modal.resetForm();
        });
        this.configuredRun(function () {
            _this.changeFilterOption({
                prop: 'studioId',
                value: {
                    id: _this.configureStates.studioId,
                    brand_name: ''
                }
            });
            _this.changeFilterOption({
                prop: 'branchId',
                value: _this.configureStates.branchId
            });
            if (_this.configureStates.isSeventeen) {
                return _this.fetchStudioList();
            }
            if (_this.configureStates.isBranch) {
                _this.branchIds = [{
                    'id': _this.configureStates.branchId,
                    'branch_name': ''
                }];
            }
        });
    },

    created: function created() {},
    watch: (_watch = {}, (0, _defineProperty3.default)(_watch, 'filterOptions.studioId', function filterOptionsStudioId(n, o) {
        if (this.configureStates.isSeventeen || this.configureStates.isStudio) {
            this.fetchBranchList({
                studioId: n.id
            });
        }
    }), (0, _defineProperty3.default)(_watch, 'studioId', function studioId() {
        var params = this.getParams();
        if (params.studio_id !== 0) {
            this.getTickets(params);
        }
    }), (0, _defineProperty3.default)(_watch, 'branchIds', function branchIds() {
        var params = this.getParams();
        this.getTickets(params);
    }), _watch),
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        configureStates: function configureStates(state) {
            return state.webadmin.configure;
        }
    }), (0, _vuex.mapState)('webadmin/configure', ['configured', 'studioList', 'branchList', 'branchId']), (0, _vuex.mapState)('webadmin/baseReport', ['filterOptions', "ajaxing"]), {
        studioId: {
            get: function get() {
                return this.filterOptions.studioId;
            },
            set: function set(newValue) {
                var _this2 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                    return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.next = 2;
                                    return _this2.changeFilterOption({ 'prop': 'studioId', value: newValue });

                                case 2:
                                    newValue.id ? $17.updateUrlQueryString({ studio_id: newValue.id }) : null;
                                    _this2.cleanBranch();

                                    if (!newValue) {
                                        _context.next = 7;
                                        break;
                                    }

                                    _context.next = 7;
                                    return _this2.fetchBranchList({ studioId: newValue.id });

                                case 7:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this2);
                }))();
            }
        },
        branchIds: {
            get: function get() {
                return this.filterOptions.branchIds;
            },
            set: function set(newValue) {
                var _this3 = this;

                return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                    return _regenerator2.default.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    _context2.next = 2;
                                    return _this3.changeFilterOption({ 'prop': 'branchIds', value: newValue });

                                case 2:
                                case 'end':
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, _this3);
                }))();
            }
        }
    }),
    methods: (0, _extends3.default)({
        updateFilterOption: function updateFilterOption(field) {
            var _this4 = this;

            return function (value) {
                return _this4.changeFilterOption({
                    prop: field,
                    value: value
                });
            };
        }
    }, (0, _vuex.mapActions)('webadmin/configure', ['configuredRun', 'fetchStudioList', 'fetchBranchList']), (0, _vuex.mapActions)('webadmin/baseReport', ['beforeSubmit', 'toggleBlock', 'changeDateOption', 'changeFilterOption', 'cleanBranch', 'cleanBranchRelated']), {
        getParams: function getParams() {
            return {
                'studio_id': this.studioId ? this.studioId.id : 0,
                'branch_ids': this.branchIds ? this.branchIds.id : undefined
            };
        },

        getTickets: function getTickets(params) {
            var _this5 = this;

            this.view.ajaxing = true;
            this.$http.get('/adminapi/ticket_setting', { params: params }).then(function (response) {
                _this5.view.ticketGroups = response.body;
                if (_this5.view.ticketGroups.length > 0) {
                    _this5.view.isListShow = true;
                }
                _this5.view.ajaxing = false;
            }, function (error) {
                _this5.view.ajaxing = false;
            });
        },
        itemCreateClick: function itemCreateClick(group) {
            var params = this.getParams();
            this.modal.action = 'create';
            this.modal.title = '新增票券';
            this.modal.category_id = group.id;
            this.$refs.ticket_modal.setStudioID(params.studio_id);
            this.$refs.ticket_modal.resetForm();
            $('#ticket-modal').modal('show');
        },
        itemClick: function itemClick(item) {
            var params = this.getParams();
            this.modal.id = item.id;
            this.modal.title = '編輯票券';
            this.modal.action = 'update';
            this.$refs.ticket_modal.setStudioID(params.studio_id);
            this.$refs.ticket_modal.onCall(item.id, 'update', params.studio_id);
            $('#ticket-modal').modal('show');
        },
        groupOrderChange: function groupOrderChange(ids) {},
        itemOrderChange: function itemOrderChange(categoryId, ids) {
            var params = this.getParams();
            this.$http.post('/adminapi/ticket_setting/sort', {
                studio_id: params.studio_id,
                order_num: ids
            }).then(function (response) {});
        },
        refresh: function refresh() {
            this.view.ticketGroups = {};
            var params = this.getParams();
            this.getTickets(params);
        }
    })

};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"content-inner\" id=\"webadmin-ticket\">\n    <div class=\"row\">\n        <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen\">\n            <div class=\"form-group\">\n                <v-mutiselect :model.sync=\"studioId\" :options=\"studioList\" :preserve-search=\"true\" :placeholder=\"configureStates.ajaxing.studioList ? '品牌讀取中…' : '請選擇品牌'\" label=\"brand_name\" track-by=\"id\">\n                </v-mutiselect>\n            </div>\n        </div>\n        <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen || configureStates.isStudio\">\n            <div class=\"form-group\">\n                <v-mutiselect :model.sync=\"branchIds\" :options=\"branchList\" :close-on-select=\"true\" :clear-on-select=\"false\" :hide-selected=\"false\" :preserve-search=\"true\" :searchable=\"false\" :allow-empty=\"true\" :placeholder=\"configureStates.ajaxing.branchList ? '場館讀取中…' : '全部場館'\" label=\"branch_name\" track-by=\"id\" :taggable=\"true\" tag-name=\"branch_name\" :max-height=\"500\">\n                </v-mutiselect>\n            </div>\n        </div>\n    </div>\n    <div>\n        <v-spinner :ajaxing=\"view.ajaxing\"></v-spinner>\n        <v-sortable v-show=\"view.isListShow &amp;&amp; !view.ajaxing\" :group-txt=\"view.groupTxt\" item-txt=\"票卷\" :groups=\"view.ticketGroups\" :show-first-id=\"state.studio_id\" :item-click=\"itemClick\" :item-create-click=\"itemCreateClick\" :item-order-change=\"itemOrderChange\" :create-allow=\"state.canCreate\" :edit-allow=\"state.canUpdate\" :edit-title=\"state.canEditTitle\"></v-sortable>\n    </div>\n\n\n    <ticket-modal @refresh=\"refresh\" ref=\"ticket_modal\" :id=\"modal.id\" :title=\"modal.title\" :action=\"modal.action\" :category_id=\"modal.category_id\"></ticket-modal>\n\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-259f1911", module.exports)
  } else {
    hotAPI.update("_v-259f1911", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/defineProperty":65,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1467:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n.item-head {\n    padding:3px 0px 3px 10px;\n    background-color: #efefef;\n    color: gray;\n}\n.modal-body .clearfix {\n    margin-top:15px;\n}\n.require span {\n    color: red;\n}\n.admission-setting {\n    display: inline-block;\n}\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vuex = require('vuex');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['id', 'title', 'action', 'category_id'],
    data: function data() {
        return {
            ticket: {
                id: null,
                name: '',
                price: null,
                limit_days: 0,
                default_printer: false,
                description: '',
                enable_limit_days: 1,
                studio_id: null,
                ticket_setting_category_id: null
            },
            admissions: [],
            selectedAdmissions: [],
            ticket_type: 0,
            state: {
                showButton: false,
                submitAjaxing: false,
                showAdmissionTicket: true,
                showClassTicket: false,
                canSubmit: true
            }
        };
    },
    mounted: function mounted() {
        $.fn.bootstrapSwitch.defaults.onColor = 'info';
        $(this.$el).find('.effective_days_switch').bootstrapSwitch({ onText: '有限', offText: '無限' }).on('switchChange.bootstrapSwitch', this.switchChange);
        $(this.$el).find('.effective_days_switch').bootstrapSwitch('state', this.ticket.enable_limit_days);
    },

    created: function created() {},
    watch: {
        '$props': {
            handler: function handler(val, oldVal) {
                this.action = val.action;
                this.id = val.id;
                this.onCall(val.id, val.action, this.ticket.studio_id);
            },
            deep: true
        },
        ticket_type: function ticket_type(val, old) {
            if (val === 0 || val === '0') {
                this.state.showAdmissionTicket = true;
                this.state.showClassTicket = false;
            } else {
                this.state.showAdmissionTicket = false;
                this.state.showClassTicket = true;
            }
        },
        submitAjaxing: function submitAjaxing(val, old) {}
    },
    computed: {
        default_printer_number: function default_printer_number() {
            if (this.ticket.default_printer === false) {
                return 0;
            } else if (this.ticket.default_printer === true) {
                return 1;
            }
        }
    },
    methods: {
        showTicket: function showTicket(id) {
            var _this = this;

            this.state.submitAjaxing = true;
            /*this.ticket = {
               id: null,
               name: '',
               price: null,
               limit_days: 0,
               default_printer: false,
               description: '',
               enable_limit_days: true,
               studio_id: null,
               ticket_setting_category_id: null
            };*/
            this.$http.get('/adminapi/ticket_setting/' + id).then(function (response) {
                _this.ticket = response.body;
                $('.effective_days_switch').bootstrapSwitch('state', _this.ticket.enable_limit_days);
                _this.selectedAdmissions = response.body.ticket_admissions;
                _lodash2.default.delay(function () {
                    _this.state.submitAjaxing = false;
                }, 400);
            }, function (error) {
                _this.state.submitAjaxing = false;
            });
        },
        deleteTicket: function deleteTicket() {
            var _this2 = this;

            if (this.action === 'update') {
                this.$http.delete('/adminapi/ticket_setting/' + this.id, {
                    _method: 'delete'
                }).then(function (response) {
                    $('#ticket-modal').modal('hide');
                    _this2.$emit('refresh');
                    //this.state.submitAjaxing = false;
                }, function (error) {
                    //this.state.submitAjaxing = false;
                });
            }
        },
        submitTicket: function submitTicket() {
            this.state.submitAjaxing = true;
            this.checkRequire();
            if (this.state.canSubmit === false) {
                $17.swal({
                    title: '尚有必填欄位未填',
                    type: 'warning'
                });
                this.state.submitAjaxing = false;
            } else {
                if (this.action === 'update') {
                    this.updateItem();
                } else {
                    this.createItem();
                }
            }
        },
        checkRequire: function checkRequire() {
            this.state.canSubmit = true;
            if (this.ticket.name === '') {
                this.state.canSubmit = false;
            }
            if (this.ticket.price === '' || this.ticket.price < 0) {
                this.state.canSubmit = false;
            }
            if (this.ticket.enable_limit_days == 1 && (this.ticket.limit_days === '' || this.ticket.limit_days < 0)) {
                this.state.canSubmit = false;
            }
        },
        checkPrice: function checkPrice() {
            if (this.ticket.price < 0) {
                this.ticket.price = 0;
            }
        },
        getAdmissionSetting: function getAdmissionSetting(id) {
            var _this3 = this;

            this.$http.get('/adminapi/studio/' + id + '/branches/admissions').then(function (response) {
                _this3.admissions = response.body;
            });
        },
        switchChange: function switchChange(event, state) {
            this.ticket.enable_limit_days = Number(state);
        },

        settingChecked: function settingChecked(branch_id, admission_id) {
            var serviceIndex = _lodash2.default.findIndex(this.selectedAdmissions, function (serviceItem, i) {
                return serviceItem.admission_id === admission_id;
            });
            if (serviceIndex < 0) {
                return false;
            } else {
                //let admission = {branch_id: branch_id, admission_id: admission_id}
                //this.selectedAdmissions.push(admission);
                return true;
            }
        },
        admissionChanged: function admissionChanged(branch_id, admission_id, event) {
            if (event.target.checked === true) {
                var group = "input:checkbox[name='setting" + branch_id + "']";
                $(group).prop("checked", false);
                event.target.checked = true;
            } else {
                event.target.checked = false;
            }
            var serviceIndex = _lodash2.default.findIndex(this.selectedAdmissions, function (serviceItem, i) {
                return serviceItem.branch_id === branch_id;
            });
            if (serviceIndex < 0 && event.target.checked === true) {
                var admission = { branch_id: branch_id, admission_id: admission_id };
                this.selectedAdmissions.push(admission);
            } else if (serviceIndex >= 0 && event.target.checked === true) {
                this.selectedAdmissions.splice(serviceIndex, 1);
                var _admission = { branch_id: branch_id, admission_id: admission_id };
                this.selectedAdmissions.push(_admission);
            } else if (serviceIndex >= 0 && event.target.checked === false) {
                this.selectedAdmissions.splice(serviceIndex, 1);
            }
        },
        resetForm: function resetForm() {
            this.ticket.id = null;
            this.ticket.name = '';
            this.ticket.price = 0;
            this.ticket.effective_days = null;
            this.ticket.description = '';
            this.ticket.enable_limit_days = 1;
            $(this.$el).find('.effective_days_switch').bootstrapSwitch('state', this.ticket.enable_limit_days);
            this.ticket.default_printer = false;
            this.ticket.limit_days = 0;
            this.ticket_type = 0;
            this.state.showButton = false;
            this.state.submitAjaxing = false;
            this.state.showAdmissionTicket = true;
            this.state.showClassTicket = false;
            this.selectedAdmissions = [];
        },

        createItem: function createItem() {
            var _this4 = this;

            this.$http.post('/adminapi/ticket_setting', {
                studio_id: this.ticket.studio_id,
                ticket_setting_category_id: this.category_id,
                name: this.ticket.name,
                price: this.ticket.price,
                enable_limit_days: Number(this.ticket.enable_limit_days),
                limit_days: this.ticket.limit_days,
                default_printer: this.default_printer_number,
                description: this.ticket.description,
                type: 1,
                data: this.selectedAdmissions,
                _method: 'post'
            }).then(function (response) {
                _this4.resetForm();
                $('#ticket-modal').modal('hide');
                _this4.$emit('refresh');
            }).catch(function (response) {
                _this4.state.submitAjaxing = false;
                $17.swal({
                    title: '儲存失敗',
                    text: response.data.message,
                    type: 'warning',
                    showCancelButton: false
                });
            });
        },
        updateItem: function updateItem() {
            var _this5 = this;

            this.$http.post('/adminapi/ticket_setting/' + this.id, {
                studio_id: this.ticket.studio_id,
                ticket_setting_category_id: this.ticket.ticket_setting_category_id,
                name: this.ticket.name,
                price: this.ticket.price,
                enable_limit_days: Number(this.ticket.enable_limit_days),
                limit_days: this.ticket.limit_days,
                default_printer: this.default_printer_number,
                description: this.ticket.description,
                type: 1,
                data: this.selectedAdmissions,
                _method: 'patch'
            }).then(function (response) {
                _this5.resetForm();
                $('#ticket-modal').modal('hide');
                _this5.$emit('refresh');
            }).catch(function (response) {
                _this5.state.submitAjaxing = false;
                $17.swal({
                    title: '更新失敗',
                    text: response.data.message,
                    type: 'warning',
                    showCancelButton: false
                });
            });
        },
        onCall: function onCall(id, action, studio_id) {
            this.selectedAdmissions = [];
            if (action === 'update') {
                this.state.showButton = true;
                this.showTicket(id);
            } else {
                this.state.showButton = false;
            }
            this.getAdmissionSetting(studio_id);
        },
        setStudioID: function setStudioID(id) {
            this.ticket.studio_id = id;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n\n<div id=\"ticket-modal\" class=\"modal fade\" data-backdrop=\"static\" data-keyboard=\"false\" role=\"dialog\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n\n            <div class=\"modal-header\">\n                <button type=\"button\" v-show=\"!state.submitAjaxing\" class=\"close\" data-dismiss=\"modal\">×</button>\n                <h4 class=\"modal-title\">\n                    {{ title }}\n                    <v-admin-operate-record v-if=\"action!='create'\" type=\"ticket_setting\" :id=\"id\"></v-admin-operate-record>\n                </h4>\n            </div>\n\n            <div class=\"modal-body\">\n                <v-spinner :ajaxing=\"state.submitAjaxing\"></v-spinner>\n                <div v-show=\"!state.submitAjaxing\">\n                    <div class=\"clearfix\">\n                        <label class=\"col-lg-3 col-md-3 col-xs-12 p-top-5 require\" for=\"name\">票券名稱 <span>*</span></label>\n                        <div class=\"col-lg-9 col-md-9 col-xs-12\"><input maxlength=\"10\" type=\"text\" class=\"form-control\" id=\"name\" placeholder=\"請輸入名稱\" v-model=\"ticket.name\"></div>\n                    </div>\n\n                    <div class=\"clearfix\">\n                        <label class=\"col-lg-3 col-md-3 col-xs-12 p-top-5 require\" for=\"price\">價格 <span>*</span></label>\n                        <div class=\"col-lg-9 col-md-9 col-xs-12\"><input type=\"number\" maxlength=\"6\" id=\"price\" placeholder=\"請輸入價格\" class=\"form-control\" v-model=\"ticket.price\" min=\"0\" @change=\"checkPrice\"></div>\n                    </div>\n\n                    <div>\n                        <div class=\"clearfix\">\n                            <label class=\"col-lg-3 col-md-3 col-xs-12 p-top-5\" for=\"effective_days\">有效天數 <span>*</span><a href=\"javascript:void(0)\"><i class=\"fa fa-question-circle column_desc\" help=\"設定有效天數代表在完成結帳後，過了幾天會失效\"></i></a></label>\n\n                            <div class=\"col-lg-9 col-md-9 col-xs-12\">\n                                <div class=\"btn-group col-md-3 p-left-0\">\n                                    <input type=\"checkbox\" v-model=\"ticket.enable_limit_days\" id=\"enable_limit_days\" class=\"limit-btn effective_days_switch\">\n                                </div>\n                                <div v-show=\"ticket.enable_limit_days\" class=\"count-group col-md-9 p-right-0\">\n                                    <input type=\"number\" maxlength=\"6\" min=\"0\" id=\"effective_days\" placeholder=\"請輸入天數限制\" class=\"form-control\" v-model=\"ticket.limit_days\">\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- <div class=\"clearfix\">\n                        <label class=\"col-lg-3 col-md-3 col-xs-3 require\" for=\"price\">列印票券</label>\n                        <div class=\"col-lg-9 col-md-9 col-xs-12 form-check\">\n                            <div class=\"form-check-label\">\n                                <input v-model=\"ticket.default_printer\" type=\"checkbox\" class=\"form-check-input\">\n                                <span class=\"p-left-10\">完成結帳時，自動列印票券QRcode</span>\n                            </div>\n                        </div>\n                    </div> -->\n\n                    <div class=\"clearfix\">\n                        <label class=\"col-lg-3 col-md-3 col-xs-3\" for=\"description\">票券說明</label>\n\n                        <div class=\"col-lg-9 col-md-9 col-xs-12\"><textarea id=\"description\" name=\"description\" maxlength=\"140\" placeholder=\"在這裡輸入的文字將會被列印\" v-model=\"ticket.description\"></textarea></div>\n                    </div>\n\n                    <div>\n                        <p class=\"item-head\">\n                            設定這張票券可以使用的範圍及項目\n                        </p>\n                        <div style=\"display: none;\" class=\"clearfix p-top-10\">\n                            <div class=\"col-md-6 col-md-offset-3\">\n                                <input type=\"radio\" v-model=\"ticket_type\" name=\"ticket-type\" checked=\"checked\" value=\"0\">\n                                <label class=\"m-right-15\">入場券</label>\n                                <input type=\"radio\" v-model=\"ticket_type\" name=\"ticket-type\" value=\"1\">\n                                <label>課程券</label>\n                            </div>\n                        </div>\n                        <div>\n                            <div v-show=\"state.showAdmissionTicket\" class=\"clearfix\">\n                                <div class=\"col-lg-2 col-md-2 col-xs-12 p-right-0\">入場設定\n                                </div>\n                                <div class=\"col-lg-9 col-md-9 col-xs-12\">\n                                    <div class=\"m-bottom-15\">場館：</div>\n                                    <div v-for=\"admission in admissions\" :key=\"admission.id\" class=\"m-bottom-15 admission-setting col-lg-12 col-md-12 col-xs-12\">\n\n                                        <div class=\"col-lg-5 col-md-5 col-xs-12 p-left-0 p-right-0\">\n                                             {{ admission.name }}\n                                        </div>\n\n                                        <div class=\"col-lg-7 col-md-7 col-xs-12\">\n                                            <div v-show=\"setting.type == 4\" v-for=\"setting in admission.admissions\">\n                                                <input :checked=\"settingChecked(admission.id, setting.id)\" @change=\"admissionChanged(admission.id, setting.id, $event)\" :name=\"'setting' + admission.id\" :key=\"setting.id\" type=\"checkbox\" :value=\"setting.id\" :id=\"'setting' +setting.id\">\n                                                <label :for=\"'setting' + setting.id\">{{ setting.name }}</label>\n                                                <!--<a href=\"javascript:void(0)\"><i class=\"fa fa-exclamation-circle column_desc\" help=\"\"></i></a>-->\n                                            </div>\n                                        </div>\n\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n\n                </div>\n\n            </div>\n\n            <div class=\"modal-footer\">\n                <button v-show=\"state.showButton &amp;&amp; !state.submitAjaxing\" @click=\"deleteTicket\" type=\"button\" class=\"btn btn-danger\" style=\"position:absolute;left: 10px;\" data-dismiss=\"modal\">刪除</button>\n                <button v-show=\"!state.submitAjaxing\" type=\"button\" class=\"btn btn-primary\" @click=\"submitTicket\">送出\n                </button>\n                <button type=\"button\" v-show=\"!state.submitAjaxing\" class=\"btn btn-default\" data-dismiss=\"modal\">關閉</button>\n            </div>\n        </div>\n    </div>\n</div>\n\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n.item-head {\n    padding:3px 0px 3px 10px;\n    background-color: #efefef;\n    color: gray;\n}\n.modal-body .clearfix {\n    margin-top:15px;\n}\n.require span {\n    color: red;\n}\n.admission-setting {\n    display: inline-block;\n}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-5b2ef54a", module.exports)
  } else {
    hotAPI.update("_v-5b2ef54a", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1468:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.endtime-modal-calendar[_v-d3937934] {\n  right: 90px; }\n\n/* line 5, stdin */\n.time_span_duration[_v-d3937934],\n.query-by-order[_v-d3937934] {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-align: center;\n      align-items: center; }\n")
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vuex = require("vuex");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {},
  data: function data() {
    return {
      ajaxing: {
        branch: false,
        records: false,
        payment: false
      },
      defaultStudioId: null,
      defaultBranchId: null,
      filter: {
        start_date: moment().subtract(7, "days").format("YYYY/MM/DD"),
        end_date: moment().format("YYYY/MM/DD"),
        branch_id: null,
        studio_id: null,
        order_id: "",
        status_code: null,
        payment_type_id: null
      },
      statusCodeStatuses: [{
        name: "完成",
        value: 1
      }, {
        name: "失敗",
        value: 3
      }, {
        name: "處理中",
        value: 2
      }, {
        name: "取消",
        value: "cancel"
      }],
      payments: [],
      records: { records: [], pageMeta: {} },
      tableConfig: {
        columns: []
      },
      csvConfig: {
        column: [],
        jsonData: [],
        fileName: '訂單項目撥款事件明細'
      },
      queryType: 'time'
    };
  },

  watch: {
    branchId: function branchId(val, oldVal) {
      this.filter.branch_id = val;
    },
    studioId: function studioId(val, oldVal) {
      this.filter.studio_id = val;
    },
    payments: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(val, oldVal) {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.getUrlParamValue("payment_type_id")) {
                  paymentTypeId = this.getUrlParamValue("payment_type_id");
                  this.filter.payment_type_id = val.reduce(function (selected, status) {
                    if (paymentTypeId == status.id) {
                      selected = status;
                    }

                    return selected;
                  }, null);
                }

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function payments(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return payments;
    }(),
    studioList: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(val, oldVal) {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.getUrlParamValue("studio_id")) {
                  studioId = this.getUrlParamValue("studio_id");
                  this.filter.studio_id = this.val.reduce(function (selected, status) {
                    if (studioId == status.studio_id) {
                      selected = status;
                    }

                    return selected;
                  }, null);
                }

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function studioList(_x3, _x4) {
        return _ref2.apply(this, arguments);
      }

      return studioList;
    }(),
    isSeventeen: function isSeventeen(val, oldVal) {
      this.setColumnConfig(val);
    }
  },
  created: function created() {
    this.getPayment();
    if (this.getUrlParamValue("start_date")) {
      this.filter.start_date = this.getUrlParamValue("start_date");
    }
    if (this.getUrlParamValue("studio_id")) {
      this.defaultStudioId = this.filter.studio_id = parseInt(this.getUrlParamValue("studio_id"));
    }
    if (this.getUrlParamValue("branch_id")) {
      this.defaultBranchId = this.filter.branch_id = parseInt(this.getUrlParamValue("branch_id"));
    }
    if (this.getUrlParamValue("query_type")) {
      this.queryType = this.getUrlParamValue("query_type");
    }
    if (this.getUrlParamValue("end_date")) {
      this.filter.end_date = this.getUrlParamValue("end_date");
    }

    if (this.getUrlParamValue("order_id")) {
      this.filter.order_id = this.getUrlParamValue("order_id");
    }

    if (this.getUrlParamValue("status_code")) {
      selectedStatusCode = this.getUrlParamValue("status_code");
      this.filter.status_code = this.statusCodeStatuses.reduce(function (selected, status) {
        if (selectedStatusCode == status.value) {
          selected = status;
        }

        return selected;
      }, null);
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.setColumnConfig(this.isSeventeen);

    this.$nextTick(function () {
      if (_this.defaultBranchId) _this.fetchShowData();
    });
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapState)("webadmin/configure", ["studioId", "studioList", "branchId", "branchList", "isBranch", "isSeventeen"])),
  methods: {
    studioChangeCallBack: function studioChangeCallBack(studioId) {
      this.filter.studio_id = studioId;
    },
    branchChangeCallBack: function branchChangeCallBack(branchId) {
      this.filter.branch_id = branchId;
    },
    fetchShowData: function fetchShowData(page) {
      var _this2 = this;

      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
        var params;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (page) {
                  _this2.updateQueryStrings("page", page);
                }

                params = _this2.getParams(25);

                _this2.updateQueryStrings(params);
                _context3.next = 5;
                return _this2.fetchRecords(params);

              case 5:
                _this2.records = _context3.sent;

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },
    fetchRecords: function fetchRecords(params) {
      var _this3 = this;

      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
        var _records;

        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(['time', 'order_id'].indexOf(_this3.queryType) == -1)) {
                  _context4.next = 3;
                  break;
                }

                $17.formatErrorAlert('請選擇訂單查詢類型');
                return _context4.abrupt("return");

              case 3:
                if (!(_this3.queryType == 'time' && moment(params.end_date).diff(moment(params.start_date), 'days') > 90)) {
                  _context4.next = 6;
                  break;
                }

                $17.formatErrorAlert('可查詢時間不可超過' + 90 + '天');
                return _context4.abrupt("return");

              case 6:
                if (!(_this3.queryType == 'order_id' && params.order_id.length < 10)) {
                  _context4.next = 9;
                  break;
                }

                $17.formatErrorAlert('請輸入正確訂單編號');
                return _context4.abrupt("return");

              case 9:
                if (!_this3.filter.branch_id) {
                  _context4.next = 15;
                  break;
                }

                _this3.ajaxing.records = true;

                _context4.next = 13;
                return _this3.$http.get("/adminapi/verification-appropriation/report/appropriation/event-detail-record", { params: params }).then(function (response) {
                  _this3.ajaxing.records = false;
                  // this.records = response.data.data;
                  return response.data.data;
                }).catch(function (response) {
                  _this3.ajaxing.records = false;
                  $17.swal({
                    title: "取得資料失敗",
                    text: response.data.message,
                    type: "warning",
                    showCancelButton: false
                  });
                });

              case 13:
                _records = _context4.sent;
                return _context4.abrupt("return", _records);

              case 15:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this3);
      }))();
    },
    downloadCsv: function downloadCsv() {
      var _this4 = this;

      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5() {
        var params;
        return _regenerator2.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                params = _this4.getParams(99999);
                _context5.next = 3;
                return _this4.fetchRecords(params);

              case 3:
                records = _context5.sent;

                _this4.csvConfig.jsonData = records.records;
                _this4.$refs.smart_table.downloadCsv();

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this4);
      }))();
    },
    getParams: function getParams(pageSize) {
      var params = {
        page_size: pageSize,
        page: this.getUrlParamValue("page") ? this.getUrlParamValue("page") : 1,
        studio_id: this.filter.studio_id,
        branch_id: this.filter.branch_id,
        query_type: this.queryType,
        status_code: this.filter.status_code != null ? this.filter.status_code.value : "",
        payment_type_id: this.filter.payment_type_id != null ? this.filter.payment_type_id.id : ""
      };

      if (this.queryType == 'time') {
        params.start_date = this.filter.start_date;
        params.end_date = this.filter.end_date;
      }

      if (this.queryType == 'order_id') {
        params.order_id = this.filter.order_id;
      }

      return params;
    },
    getPayment: function getPayment() {
      var _this5 = this;

      if (this.filter.studio_id == 0) {
        return;
      }
      this.$http.get("/adminapi/payment-types").then(function (response) {
        _this5.payments = response.data;
      });
    },
    updateQueryStrings: function updateQueryStrings(query) {
      var newQueryString = $17.queryStringBuilder(query);
      history.replaceState({}, null, "?" + newQueryString);
    },
    setColumnConfig: function setColumnConfig(val) {
      if (val) {
        this.tableConfig.columns = [{ keys: "orderId", head: "訂單編號" }, { keys: "orderDetailProductName", head: "訂單項目名稱" }, { keys: "checkoutAmount", head: "結帳金額" }, { keys: "paymentType", head: "訂單支付模式" }, { keys: "approveEventOperatorType", head: "執行模組" }, { keys: "approveEventRecordId", head: "撥款明細編號" }, { keys: "approveEventRecordCreated", head: "撥款事件明細建立時間" }, { keys: "approveAmount", head: "撥款金額" }, { keys: "statusCode", head: "執行狀態" }, { keys: "operatorReason", head: "原因" }, { keys: "description", head: "描述" }];
        this.csvConfig.column = [{ keys: "orderId", name: "訂單編號" }, { keys: "orderDetailProductName", name: "訂單項目名稱" }, { keys: "checkoutAmount", name: "結帳金額" }, { keys: "paymentType", name: "訂單支付模式" }, { keys: "approveEventOperatorType", name: "執行模組" }, { keys: "approveEventRecordId", name: "撥款明細編號" }, { keys: "approveEventRecordCreated", name: "撥款事件明細建立時間" }, { keys: "approveAmount", name: "撥款金額" }, { keys: "statusCode", name: "執行狀態" }, { keys: "operatorReason", name: "原因" }, { keys: "description", name: "描述" }];
      } else {
        this.tableConfig.columns = [{ keys: "orderId", head: "訂單編號" }, { keys: "orderDetailProductName", head: "訂單項目名稱" }, { keys: "checkoutAmount", head: "結帳金額" }, { keys: "paymentType", head: "訂單支付模式" }, { keys: "approveEventRecordId", head: "撥款明細編號" }, { keys: "approveEventRecordCreated", head: "撥款事件明細建立時間" }, { keys: "approveAmount", head: "撥款金額" }, { keys: "statusCode", head: "執行狀態" }, { keys: "operatorReason", head: "原因" }, { keys: "description", head: "描述" }];
        this.csvConfig.column = [{ keys: "orderId", name: "訂單編號" }, { keys: "orderDetailProductName", name: "訂單項目名稱" }, { keys: "checkoutAmount", name: "結帳金額" }, { keys: "paymentType", name: "訂單支付模式" }, { keys: "approveEventRecordId", name: "撥款明細編號" }, { keys: "approveEventRecordCreated", name: "撥款事件明細建立時間" }, { keys: "approveAmount", name: "撥款金額" }, { keys: "statusCode", name: "執行狀態" }, { keys: "operatorReason", name: "原因" }, { keys: "description", name: "描述" }];
      }
    }
  }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"content-inner\" _v-d3937934=\"\">\n  <div class=\"row m-bottom-20 m-left-10\" _v-d3937934=\"\">\n    <h3 class=\"\" _v-d3937934=\"\">訂單項目撥款事件明細</h3>\n  </div>\n  <div class=\"row m-bottom-20 m-left-20\" _v-d3937934=\"\">\n    <v-multiselect-studio-and-branch :studio_id=\"studioId\" :branch_id=\"branchId\" :branch-change-call-back=\"branchChangeCallBack\" :studio-change-call-back=\"studioChangeCallBack\" :default_studio_id=\"defaultStudioId\" :default_branch_id=\"defaultBranchId\" _v-d3937934=\"\"></v-multiselect-studio-and-branch>\n  </div>\n  <div class=\"row m-bottom-20 m-left-5\" _v-d3937934=\"\">\n    <div class=\"col-sm-6\" _v-d3937934=\"\">\n      <v-mutiselect :model.sync=\"filter.payment_type_id\" :options=\"payments\" :multiple=\"false\" :close-on-select=\"true\" :clear-on-select=\"true\" :hide-selected=\"false\" :searchable=\"true\" :placeholder=\"\n          ajaxing.payment ? '支付模式讀取中…' : '全部支付模式'\n        \" label=\"name\" track-by=\"id\" _v-d3937934=\"\">\n      </v-mutiselect>\n    </div>\n\n    <div class=\"col-sm-6\" _v-d3937934=\"\">\n      <v-mutiselect :model.sync=\"filter.status_code\" :options=\"statusCodeStatuses\" :multiple=\"false\" :close-on-select=\"true\" :clear-on-select=\"true\" :searchable=\"true\" label=\"name\" track-by=\"value\" tag-name=\"name\" placeholder=\"全部執行狀態\" _v-d3937934=\"\">\n      </v-mutiselect>\n    </div>\n  </div>\n  <div class=\"row m-bottom-20 m-left-5\" _v-d3937934=\"\">\n    <div class=\"col-sm-12\" _v-d3937934=\"\">\n      <input type=\"radio\" id=\"query-by-time\" value=\"time\" v-model=\"queryType\" _v-d3937934=\"\">\n      <label for=\"query-by-time\" class=\"m-right-15\" _v-d3937934=\"\"> 訂單建立時間 </label>\n      <div class=\"time_span_duration\" _v-d3937934=\"\">\n        <v-datepicker v-model=\"filter.start_date\" placeholder=\"開始日期\" :disabled=\"queryType=='order_id'\" _v-d3937934=\"\"></v-datepicker>\n        <div class=\"m-right-5 m-left-5\" _v-d3937934=\"\">~</div>\n        <v-datepicker v-model=\"filter.end_date\" placeholder=\"結束日期\" calendar-class=\"endtime-modal-calendar\" :disabled=\"queryType=='order_id'\" _v-d3937934=\"\"></v-datepicker>\n      </div>\n    </div>\n  </div>\n  <div class=\"row m-top-5 m-bottom-20 m-left-5\" _v-d3937934=\"\">\n    <div class=\"col-sm-12\" _v-d3937934=\"\">\n      <input type=\"radio\" id=\"query-by-order\" value=\"order_id\" v-model=\"queryType\" _v-d3937934=\"\">\n      <label for=\"query-by-order\" class=\"m-right-15\" _v-d3937934=\"\"> 訂單編號 </label>\n      <input type=\"text\" name=\"\" placeholder=\"訂單ID\" v-model=\"filter.order_id\" :disabled=\"queryType=='time'\" _v-d3937934=\"\">\n    </div>\n  </div>\n  <div class=\"row m-bottom-50 m-left-0\" _v-d3937934=\"\">\n    <div class=\"col-sm-12\" _v-d3937934=\"\">\n      <div class=\"btn btn-primary\" @click=\"fetchShowData(1)\" _v-d3937934=\"\">查詢</div>\n      <div class=\"btn btn-success\" @click=\"downloadCsv\" _v-d3937934=\"\">匯出CSV</div>\n    </div>\n  </div>\n  <div class=\"row col-sm-12\" _v-d3937934=\"\">\n    <v-smart-table ref=\"smart_table\" :table-config=\"tableConfig\" :csv-config=\"csvConfig\" :is-ajaxing=\"ajaxing.records\" :data=\"records\" :page-sync-url-query=\"true\" @change-page=\"fetchShowData\" _v-d3937934=\"\"></v-smart-table>\n  </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.endtime-modal-calendar[_v-d3937934] {\n  right: 90px; }\n\n/* line 5, stdin */\n.time_span_duration[_v-d3937934],\n.query-by-order[_v-d3937934] {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-align: center;\n      align-items: center; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-d3937934", module.exports)
  } else {
    hotAPI.update("_v-d3937934", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1469:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _setting = require('./setting.vue');

var _setting2 = _interopRequireDefault(_setting);

var _verificationEventRecord = require('./verification-event-record.vue');

var _verificationEventRecord2 = _interopRequireDefault(_verificationEventRecord);

var _approveEventRecord = require('./approve-event-record.vue');

var _approveEventRecord2 = _interopRequireDefault(_approveEventRecord);

var _overview = require('./overview/overview.vue');

var _overview2 = _interopRequireDefault(_overview);

var _sub = require('./overview/_sub.vue');

var _sub2 = _interopRequireDefault(_sub);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//Page


//overview
_vue2.default.component('webadmin-verification-appropriation-setting', _setting2.default);
_vue2.default.component('webadmin-verification-event-record', _verificationEventRecord2.default);
_vue2.default.component('webadmin-approve-event-record', _approveEventRecord2.default);

//overview
_vue2.default.component('webadmin-verification-appropriation-overview', _overview2.default);
_vue2.default.component('verification-appropriation-overview-sub-row', _sub2.default);

},{"./approve-event-record.vue":1468,"./overview/_sub.vue":1470,"./overview/overview.vue":1471,"./setting.vue":1472,"./verification-event-record.vue":1473,"vue":792}],1470:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['rowData'],
    data: function data() {
        return {
            ajaxing: false,
            verify_ajaxing: false,
            approve_ajaxing: false,
            records: [],
            verify_reason_options: [{ id: 'Operation.Workaround', text: '營運措施' }, { id: 'Dispute', text: '爭議處理' }, { id: 'Adjust', text: '帳務修正' }],
            approve_reason_options: [{ id: 'Operation.Workaround', text: '營運措施' }, { id: 'Dispute', text: '爭議處理' }, { id: 'Adjust', text: '帳務修正' }],
            currentVerify: {},
            currentApprove: {},
            postDataVerify: {
                operator_reason: null,
                description: null,
                amount: null
            },
            postDataApprove: {
                operator_reason: null,
                description: null,
                amount: null
            },
            apiConfig: {}
        };
    },
    mounted: function mounted() {
        this.fetchRecords();
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)("webadmin/configure", ["isSeventeen"]), {
        tableConfigModify: function tableConfigModify() {
            var vm = this;
            var configs = {
                columns: [{ keys: "product_name", head: "項目名稱" }, {
                    keys: 'sub_total',
                    head: '銷售金額',
                    html: function html(item) {
                        return item.has_verification ? '$' + $17.thousandthFormat(item.sub_total) : '-';
                    }
                }, {
                    keys: 'verification_checkout_amount',
                    head: '應核銷金額',
                    html: function html(item) {
                        return item.has_verification ? '$' + $17.thousandthFormat(item.verification_checkout_amount) : '-';
                    }
                }, {
                    keys: 'verification_verified_amount',
                    head: '已核銷金額',
                    html: function html(item) {
                        return item.has_verification ? '$' + $17.thousandthFormat(item.verification_verified_amount) : '-';
                    }
                }, {
                    keys: '',
                    head: '項目核銷鎖定狀態',
                    html: function html(item) {
                        if (item.has_verification) {
                            if (vm.isSeventeen) {
                                var iconClass = item.verification_status == 1 ? 'fa fa-unlock' : 'fa fa-lock';
                                return '<a @click.prevent.stop="clickHandler(\'changeVerificationStatus\')">' + item.verification_status_name + ' <span class="' + iconClass + '"></span></a>';
                            } else {
                                return item.verification_status_name;
                            }
                        } else {
                            return '-';
                        }
                    }
                }, {
                    keys: 'verification_checkout_amount',
                    head: '應撥款金額',
                    html: function html(item) {
                        return item.has_appropriation ? '$' + $17.thousandthFormat(item.appropriation_checkout_amount) : '-';
                    }
                }, {
                    keys: 'verification_verified_amount',
                    head: '已撥款金額',
                    html: function html(item) {
                        return item.has_appropriation ? '$' + $17.thousandthFormat(item.appropriation_approve_amount) : '-';
                    }
                }, {
                    keys: '',
                    head: '項目撥款鎖定狀態',
                    html: function html(item) {
                        if (item.has_appropriation) {
                            if (vm.isSeventeen) {
                                var iconClass = item.appropriation_status == 1 ? 'fa fa-unlock' : 'fa fa-lock';
                                return '<a @click.prevent.stop="clickHandler(\'changeAppropriationStatus\')">' + item.appropriation_status_name + ' <span class="' + iconClass + '"></span></a>';
                            } else {
                                return item.appropriation_status_name;
                            }
                        } else {
                            return '-';
                        }
                    }
                }]
            };
            if (this.isSeventeen) {
                configs.columns.splice(2, 0, {
                    keys: 'verification_setting_display_name',
                    head: '核銷模式',
                    html: function html(item) {
                        return item.has_verification ? item.verification_setting_display_name : '-';
                    }
                });
                configs.columns.splice(5, 0, {
                    keys: '',
                    head: '手動核銷',
                    html: function html(item) {
                        if (vm.isSeventeen && item.has_verification) {
                            return '<a class="btn btn-primary" @click.prevent.stop="clickHandler(\'verifyModal\')">\u9032\u884C\u6838\u92B7</a>';
                        } else {
                            return '-';
                        }
                    }
                });
                configs.columns.splice(7, 0, {
                    keys: 'appropriation_setting_display_name',
                    head: '撥款模式',
                    html: function html(item) {
                        return item.has_appropriation ? item.appropriation_setting_display_name : '-';
                    }
                });
                configs.columns.splice(10, 0, {
                    keys: '',
                    head: '手動撥款',
                    html: function html(item) {
                        if (vm.isSeventeen && item.has_appropriation) {
                            return '<a class="btn btn-primary" @click.prevent.stop="clickHandler(\'approveModal\')">\u9032\u884C\u64A5\u6B3E</a>';
                        } else {
                            return '-';
                        }
                    }
                });
            }
            return configs;
        }
    }),
    methods: {
        refreshData: function refreshData() {
            this.$refs['smart_table'].refresh();
        },
        verifyModal: function verifyModal(item) {
            var _this = this;

            if (item.verification_balance < 1 || item.verification_status != 1) {
                $17.swal({
                    title: '無額度可核銷或該筆已鎖定',
                    type: 'warning',
                    showCancelButton: false
                });
                return false;
            }
            this.postDataVerify = {
                operator_reason: null,
                description: null,
                amount: null
            };
            this.currentVerify = item;
            this.$nextTick(function () {
                $('#' + _this.currentVerify.order_id + '-verify-modal-' + _this.currentVerify.verification_payment_action_record_id).modal('show');
            });
        },
        approveModal: function approveModal(item) {
            var _this2 = this;

            if (item.appropriation_balance < 1 || item.appropriation_status != 1) {
                $17.swal({
                    title: '無額度可撥款或該筆已鎖定',
                    type: 'warning',
                    showCancelButton: false
                });
                return false;
            }
            this.postDataApprove = {
                operator_reason: null,
                description: null,
                amount: null
            };
            this.currentApprove = item;
            this.$nextTick(function () {
                $('#' + _this2.currentApprove.order_id + '-approve-modal-' + _this2.currentApprove.appropriation_payment_action_record_id).modal('show');
            });
        },
        verify: function verify() {
            var _this3 = this;

            if (this.verify_ajaxing) return;
            if (!this.postDataVerify.operator_reason || !this.postDataVerify.operator_reason.hasOwnProperty('id') || !this.postDataVerify.description || this.postDataVerify.amount < 1) {
                $17.swal({
                    title: '請填寫每一個欄位',
                    type: 'warning',
                    showCancelButton: false
                });
                return false;
            }

            $.blockUI();
            this.verify_ajaxing = true;
            this.$http.post('/adminapi/verification-appropriation/verification-condition/' + this.currentVerify.verification_id + '/event', {
                operator_reason: this.postDataVerify.operator_reason.id,
                description: this.postDataVerify.description,
                amount: Number(this.postDataVerify.amount)
            }).then(function (response) {
                $17.swal({
                    title: '核銷成功',
                    type: 'success',
                    showCancelButton: false
                });
                _this3.refreshData();
                $.unblockUI();
                _this3.verify_ajaxing = false;
                $('#' + _this3.currentVerify.order_id + '-verify-modal-' + _this3.currentVerify.verification_payment_action_record_id).modal('hide');
            }).catch(function (response) {
                $17.swal({
                    title: '核銷失敗',
                    text: response.data.hasOwnProperty('message') ? response.data.message : '',
                    type: 'error',
                    showCancelButton: false
                });
                $.unblockUI();
                _this3.verify_ajaxing = false;
            });
        },
        approve: function approve() {
            var _this4 = this;

            if (this.approve_ajaxing) return;
            if (!this.postDataApprove.operator_reason || !this.postDataApprove.operator_reason.hasOwnProperty('id') || !this.postDataApprove.description || this.postDataApprove.amount < 1) {
                $17.swal({
                    title: '請填寫每一個欄位',
                    type: 'warning',
                    showCancelButton: false
                });
                return false;
            }

            $.blockUI();
            this.approve_ajaxing = true;
            this.$http.post('/adminapi/verification-appropriation/approve-condition/' + this.currentApprove.appropriation_id + '/event', {
                operator_reason: this.postDataApprove.operator_reason.id,
                description: this.postDataApprove.description,
                amount: Number(this.postDataApprove.amount)
            }).then(function (response) {
                $17.swal({
                    title: '撥款成功',
                    type: 'success',
                    showCancelButton: false
                });
                _this4.refreshData();
                $.unblockUI();
                _this4.approve_ajaxing = false;
                $('#' + _this4.currentApprove.order_id + '-approve-modal-' + _this4.currentApprove.appropriation_payment_action_record_id).modal('hide');
            }).catch(function (response) {
                $17.swal({
                    title: '撥款失敗',
                    text: response.data.hasOwnProperty('message') ? response.data.message : '',
                    type: 'error',
                    showCancelButton: false
                });
                $.unblockUI();
                _this4.approve_ajaxing = false;
            });
        },
        changeVerificationStatus: function changeVerificationStatus(item) {
            var vm = this;
            var title = '核銷鎖定';
            var text = '確認鎖定此筆項目？';
            var status = 2;
            if (item.verification_status != 1) {
                title = '解除核銷鎖定';
                text = '確認解除鎖定此筆項目？';
                status = 1;
            }
            $17.swal({
                title: title,
                text: text,
                type: 'warning',
                confirmButtonText: '確定'
            }, function () {
                $.blockUI();

                vm.$http.put('/adminapi/verification-appropriation/verification-condition/' + item.verification_id + '/status', { status: status }).then(function (response) {
                    $17.swal({
                        title: title + '  成功',
                        type: 'success',
                        showCancelButton: false
                    });
                    vm.refreshData();
                    $.unblockUI();
                }).catch(function (response) {
                    $17.swal({
                        title: '發生錯誤',
                        text: response.data.hasOwnProperty('message') ? response.data.message : '',
                        type: 'error',
                        showCancelButton: false
                    });
                    $.unblockUI();
                });
            });
        },
        changeAppropriationStatus: function changeAppropriationStatus(item) {
            var vm = this;
            var title = '撥款鎖定';
            var text = '確認鎖定此筆項目？';
            var status = 2;
            if (item.appropriation_status != 1) {
                title = '解除撥款鎖定';
                text = '確認解除鎖定此筆項目？';
                status = 1;
            }
            $17.swal({
                title: title,
                text: text,
                type: 'warning',
                confirmButtonText: '確定'
            }, function () {
                $.blockUI();

                vm.$http.put('/adminapi/verification-appropriation/approve-condition/' + item.appropriation_id + '/status', { status: status }).then(function (response) {
                    $17.swal({
                        title: title + '  成功',
                        type: 'success',
                        showCancelButton: false
                    });
                    vm.refreshData();
                    $.unblockUI();
                }).catch(function (response) {
                    $17.swal({
                        title: '發生錯誤',
                        text: response.data.hasOwnProperty('message') ? response.data.message : '',
                        type: 'error',
                        showCancelButton: false
                    });
                    $.unblockUI();
                });
            });
        },
        fetchRecords: function fetchRecords() {
            this.apiConfig = {
                method: 'get',
                apiurl: '/adminapi/verification-appropriation/report/overview/details',
                payload: {
                    page: 1,
                    order_id: this.rowData.order_id,
                    payment_type_id: this.rowData.payment_type_id
                },
                recordName: 'data'
            };
        },
        thousandthFormat: function thousandthFormat(value) {
            return '$' + $17.thousandthFormat(value);
        },
        close: function close() {
            this.rowData.subRow.close();
        },
        clickHtmlHandler: function clickHtmlHandler(val) {
            this[val.action](val.row);
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-82a66576=\"\">\n    <div style=\"display: flex; justify-content: space-between; align-items: center;\" _v-82a66576=\"\">\n        <h5 _v-82a66576=\"\">更多資訊</h5>\n        <button type=\"button\" @click=\"close\" class=\"close\" _v-82a66576=\"\"><i class=\"fa fa-remove\" _v-82a66576=\"\"></i></button>\n    </div>\n\n    <v-smart-table ref=\"smart_table\" :table-config=\"tableConfigModify\" :api-config=\"apiConfig\" @html-click-callback=\"clickHtmlHandler\" _v-82a66576=\"\"></v-smart-table>\n\n    <v-modal :id=\"currentVerify.order_id+'-verify-modal-'+currentVerify.verification_payment_action_record_id\" data-backdrop=\"static\" no-cancel=\"\" :save-clicked=\"verify\" _v-82a66576=\"\">\n        <h4 slot=\"title\" _v-82a66576=\"\">進行核銷</h4>\n        <div slot=\"body\" _v-82a66576=\"\">\n            <v-spinner :ajaxing=\"verify_ajaxing\" _v-82a66576=\"\"></v-spinner>\n            <div v-if=\"!verify_ajaxing\" class=\"form-horizontal\" _v-82a66576=\"\">\n                <div class=\"form-group\" _v-82a66576=\"\">\n                    <label class=\"col-sm-3 control-label\" _v-82a66576=\"\">訂單編號</label>\n                    <div class=\"col-sm-9 p-top-8\" _v-82a66576=\"\">{{ currentVerify.order_id }}</div>\n                </div>\n                <div class=\"form-group\" _v-82a66576=\"\">\n                    <label class=\"col-sm-3 control-label\" _v-82a66576=\"\">項目名稱</label>\n                    <div class=\"col-sm-9 p-top-8\" _v-82a66576=\"\">{{ currentVerify.product_name }}</div>\n                </div>\n                <div class=\"form-group\" _v-82a66576=\"\">\n                    <label class=\"col-sm-3 control-label\" _v-82a66576=\"\">支付方式</label>\n                    <div class=\"col-sm-9 p-top-8\" _v-82a66576=\"\">{{ currentVerify.verification_payment_type }}</div>\n                </div>\n                <div class=\"form-group\" _v-82a66576=\"\">\n                    <label class=\"col-sm-3 control-label\" _v-82a66576=\"\">應核銷金額</label>\n                    <div class=\"col-sm-9 p-top-8\" _v-82a66576=\"\">{{ thousandthFormat(currentVerify.verification_checkout_amount) }}</div>\n                </div>\n                <div class=\"form-group\" _v-82a66576=\"\">\n                    <label class=\"col-sm-3 control-label\" _v-82a66576=\"\">已核銷金額</label>\n                    <div class=\"col-sm-9 p-top-8\" _v-82a66576=\"\">{{ thousandthFormat(currentVerify.verification_verified_amount) }}</div>\n                </div>\n                <div class=\"form-group\" _v-82a66576=\"\">\n                    <label class=\"col-sm-3 control-label\" _v-82a66576=\"\">原因類型</label>\n                    <div class=\"col-sm-9\" _v-82a66576=\"\">\n                        <div _v-82a66576=\"\">\n                            <v-mutiselect style=\"width:300px\" :model.sync=\"postDataVerify.operator_reason\" :options=\"verify_reason_options\" :multiple=\"false\" :close-on-select=\"true\" :searchable=\"false\" label=\"text\" track-by=\"id\" tag-name=\"text\" placeholder=\"請選擇核銷原因\" _v-82a66576=\"\"></v-mutiselect>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"form-group\" _v-82a66576=\"\">\n                    <label class=\"col-sm-3 control-label\" _v-82a66576=\"\">核銷描述</label>\n                    <div class=\"col-sm-9\" _v-82a66576=\"\">\n                        <input type=\"text\" v-model=\"postDataVerify.description\" placeholder=\"請輸入核銷描述\" class=\"form-control\" _v-82a66576=\"\">\n                    </div>\n                </div>\n                <div class=\"form-group\" _v-82a66576=\"\">\n                    <label class=\"col-sm-3 control-label\" _v-82a66576=\"\">核銷金額</label>\n                    <div class=\"col-sm-9\" _v-82a66576=\"\">\n                        <input type=\"number\" v-model=\"postDataVerify.amount\" placeholder=\"請輸入核銷金額\" class=\"form-control\" _v-82a66576=\"\">\n                    </div>\n                </div>\n            </div>\n        </div>\n    </v-modal>\n\n    <v-modal :id=\"currentApprove.order_id+'-approve-modal-'+currentApprove.appropriation_payment_action_record_id\" data-backdrop=\"static\" no-cancel=\"\" :save-clicked=\"approve\" _v-82a66576=\"\">\n        <h4 slot=\"title\" _v-82a66576=\"\">進行撥款</h4>\n        <div slot=\"body\" _v-82a66576=\"\">\n            <v-spinner :ajaxing=\"approve_ajaxing\" _v-82a66576=\"\"></v-spinner>\n            <div v-if=\"!approve_ajaxing\" class=\"form-horizontal\" _v-82a66576=\"\">\n                <div class=\"form-group\" _v-82a66576=\"\">\n                    <label class=\"col-sm-3 control-label\" _v-82a66576=\"\">訂單編號</label>\n                    <div class=\"col-sm-9 p-top-8\" _v-82a66576=\"\">{{ currentApprove.order_id }}</div>\n                </div>\n                <div class=\"form-group\" _v-82a66576=\"\">\n                    <label class=\"col-sm-3 control-label\" _v-82a66576=\"\">項目名稱</label>\n                    <div class=\"col-sm-9 p-top-8\" _v-82a66576=\"\">{{ currentApprove.product_name }}</div>\n                </div>\n                <div class=\"form-group\" _v-82a66576=\"\">\n                    <label class=\"col-sm-3 control-label\" _v-82a66576=\"\">支付方式</label>\n                    <div class=\"col-sm-9 p-top-8\" _v-82a66576=\"\">{{ currentApprove.appropriation_payment_type }}</div>\n                </div>\n                <div class=\"form-group\" _v-82a66576=\"\">\n                    <label class=\"col-sm-3 control-label\" _v-82a66576=\"\">應撥款金額</label>\n                    <div class=\"col-sm-9 p-top-8\" _v-82a66576=\"\">{{ thousandthFormat(currentApprove.appropriation_checkout_amount) }}</div>\n                </div>\n                <div class=\"form-group\" _v-82a66576=\"\">\n                    <label class=\"col-sm-3 control-label\" _v-82a66576=\"\">已撥款金額</label>\n                    <div class=\"col-sm-9 p-top-8\" _v-82a66576=\"\">{{ thousandthFormat(currentApprove.appropriation_approve_amount) }}</div>\n                </div>\n                <div class=\"form-group\" _v-82a66576=\"\">\n                    <label class=\"col-sm-3 control-label\" _v-82a66576=\"\">原因類型</label>\n                    <div class=\"col-sm-9\" _v-82a66576=\"\">\n                        <div _v-82a66576=\"\">\n                            <v-mutiselect style=\"width:300px\" :model.sync=\"postDataApprove.operator_reason\" :options=\"approve_reason_options\" :multiple=\"false\" :close-on-select=\"true\" :searchable=\"false\" label=\"text\" track-by=\"id\" tag-name=\"text\" placeholder=\"請選擇撥款原因\" _v-82a66576=\"\"></v-mutiselect>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"form-group\" _v-82a66576=\"\">\n                    <label class=\"col-sm-3 control-label\" _v-82a66576=\"\">撥款描述</label>\n                    <div class=\"col-sm-9\" _v-82a66576=\"\">\n                        <input type=\"text\" v-model=\"postDataApprove.description\" placeholder=\"請輸入撥款描述\" class=\"form-control\" _v-82a66576=\"\">\n                    </div>\n                </div>\n                <div class=\"form-group\" _v-82a66576=\"\">\n                    <label class=\"col-sm-3 control-label\" _v-82a66576=\"\">撥款金額</label>\n                    <div class=\"col-sm-9\" _v-82a66576=\"\">\n                        <input type=\"number\" v-model=\"postDataApprove.amount\" placeholder=\"請輸入撥款金額\" class=\"form-control\" _v-82a66576=\"\">\n                    </div>\n                </div>\n            </div>\n        </div>\n    </v-modal>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-82a66576", module.exports)
  } else {
    hotAPI.update("_v-82a66576", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vuex":803}],1471:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n/* line 2, stdin */\n.page-div[_v-7c2d5b3d] {\n  padding: 0px 15px;\n  margin-bottom: 15px; }\n\n/* line 7, stdin */\n.form-title[_v-7c2d5b3d] {\n  font-size: 16px;\n  font-weight: bold;\n  display: inline-block;\n  width: 60px; }\n")
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _watch;

var _vuex = require("vuex");

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        var vm = this;
        return {
            tableConfig: {
                subRow: {
                    enable: true
                },
                subRowStyleCondition: function subRowStyleCondition(row, idx) {
                    return {
                        'background-color': '#E5E7EB'
                    };
                },
                columns: [{
                    keys: 'order_id',
                    head: '訂單編號',
                    minWidth: '160px',
                    html: function html(item) {
                        var iconClass = item.subRow.isShow ? 'fa fa-caret-up' : 'fa fa-caret-down';
                        return "<button class=\"btn btn-sm m-right-10\" @click=\"clickHandler('viewSubRow')\"><span class=\"" + iconClass + "\"></span></button>" + item.order_id;
                    }
                }, { keys: "brand_name", head: "品牌名稱" }, { keys: "branch_name", head: "場館名稱" }, { keys: "checkout_at", head: "訂單完成日" }, { keys: "payment_type", head: "訂單支付方式" }, {
                    keys: "total",
                    head: "訂單結帳金額",
                    html: function html(item) {
                        return vm.thousandthFormat(item.total);
                    }
                }, {
                    keys: "verification_checkout_amount",
                    head: "應核銷金額",
                    html: function html(item) {
                        return vm.thousandthFormat(item.verification_checkout_amount);
                    }
                }, {
                    keys: "verification_verified_amount",
                    head: "已核銷金額",
                    html: function html(item) {
                        return vm.thousandthFormat(item.verification_verified_amount);
                    }
                }, {
                    keys: "appropriation_checkout_amount",
                    head: "應撥款金額",
                    html: function html(item) {
                        return vm.thousandthFormat(item.appropriation_checkout_amount);
                    }
                }, {
                    keys: "appropriation_approve_amount",
                    head: "已撥款金額",
                    html: function html(item) {
                        return vm.thousandthFormat(item.appropriation_approve_amount);
                    }
                }, {
                    keys: 'verification',
                    head: '核銷項目紀錄',
                    html: function html(item) {
                        return "<a @click.prevent.stop=\"clickHandler('viewVerification')\">\u67E5\u8A62\u7D30\u7BC0</a>";
                    }
                }, {
                    keys: 'appropriation',
                    head: '項目撥款明細',
                    html: function html(item) {
                        return "<a @click.prevent.stop=\"clickHandler('viewAppropriation')\">\u67E5\u8A62\u7D30\u7BC0</a>";
                    }
                }]
            },
            csvConfig: {
                fileName: '訂單核銷及撥款總覽',
                column: [{ keys: "order_id", name: "訂單編號" }, { keys: "brand_name", name: "品牌名稱" }, { keys: "branch_name", name: "場館名稱" }, { keys: "checkout_at", name: "訂單完成日" }, { keys: "payment_type", name: "訂單支付方式" }, { keys: "total", name: "訂單結帳金額" }, { keys: "verification_checkout_amount", name: "應核銷金額" }, { keys: "verification_verified_amount", name: "已核銷金額" }, { keys: "appropriation_checkout_amount", name: "應撥款金額" }, { keys: "appropriation_approve_amount", name: "已撥款金額" }]
            },
            relatedFilterWatcher: {
                studio_id: {
                    watcher: null,
                    options: "studioList",
                    vModel: "studioId",
                    trackBy: "id",
                    type: "single"
                },
                branch_id: {
                    watcher: null,
                    options: "branchList",
                    vModel: "branchIds",
                    trackBy: "id",
                    type: "single"
                }
            },
            multiFilter: {
                verification_status: {
                    watcher: null,
                    options: "verification_statuses",
                    vModel: "verification_status",
                    trackBy: "value",
                    type: "single"
                },
                appropriation_status: {
                    watcher: null,
                    options: "appropriation_statuses",
                    vModel: "appropriation_status",
                    trackBy: "value",
                    type: "single"
                }
            },
            result: {
                records: [],
                pageMeta: {},
                total: 0,
                verificationCheckoutTotal: 0,
                verificationVerifiedTotal: 0,
                appropriationCheckoutTotal: 0,
                appropriationApproveTotal: 0
            },
            localFilter: {
                order_id: '',
                payment_type: '',
                verification_status: '',
                appropriation_status: ''
            },
            payment_types: [{ name: "全部", value: '' }, { name: "信用卡", value: 2 }, { name: "現金", value: 1 }],
            appropriation_statuses: [{ name: "全部", value: '' }, { name: "正常", value: 1 }, { name: "已鎖定", value: 2 }],
            verification_statuses: [{ name: "全部", value: '' }, { name: "正常", value: 1 }, { name: "已鎖定", value: 2 }],
            export: []
        };
    },
    created: function created() {
        this.syncRelatedMultipleSelectByQuery({ vm: this, relatedFilterWatcher: this.relatedFilterWatcher });
        this.syncLocalMultipleSelectByQuery({ vm: this, multiFilter: this.multiFilter });
    },
    mounted: function mounted() {
        var _this = this;

        this.configuredRun(function () {
            _this.changeFilterOption({
                prop: "studioId",
                value: {
                    id: _this.configureStates.studioId,
                    brand_name: ""
                }
            });
            _this.changeFilterOption({
                prop: "branchIds",
                value: _this.configureStates.branchIds
            });
            if (_this.configureStates.isSeventeen) {
                return _this.fetchStudioList();
            }
            if (_this.configureStates.isBranch) {
                _this.branchIds = [{
                    id: _this.configureStates.branchIds,
                    branch_name: ""
                }];
            }
        });
        this.syncDateAndDisplayByQuery({
            'diffType': 'week',
            'diffNumber': -1
        });
    },

    watch: (_watch = {}, (0, _defineProperty3.default)(_watch, "filterOptions.studioId", function filterOptionsStudioId(n, o) {
        if ((this.configureStates.isSeventeen || this.configureStates.isStudio) && n && n.id) {
            this.fetchBranchList({
                studioId: n.id
            });
        }
    }), (0, _defineProperty3.default)(_watch, "export", function _export(newV) {
        if (newV && newV.length > 0) {
            this.csvConfig.jsonData = newV;
            this.$refs.smart_table.downloadCsv();
        }
    }), _watch),
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        configureStates: function configureStates(state) {
            return state.webadmin.configure;
        }
    }), (0, _vuex.mapState)("webadmin/configure", ["configured", "studioList", "branchList", "branchId"]), (0, _vuex.mapState)("webadmin/baseReport", ["blockOpenStatus", "dateOptions", "filterOptions", "itemOptions", "ajaxing", "list", "total", "pageMeta", "queryPara"]), {
        studioId: {
            get: function get() {
                return this.filterOptions.studioId;
            },
            set: function () {
                var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(newValue) {
                    return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.next = 2;
                                    return this.$store.dispatch("webadmin/baseReport/changeFilterOption", {
                                        prop: "studioId",
                                        value: newValue
                                    });

                                case 2:
                                    this.cleanBranch();

                                    if (!newValue) {
                                        _context.next = 6;
                                        break;
                                    }

                                    _context.next = 6;
                                    return this.fetchBranchList({ studioId: newValue.id });

                                case 6:
                                case "end":
                                    return _context.stop();
                            }
                        }
                    }, _callee, this);
                }));

                function set(_x) {
                    return _ref.apply(this, arguments);
                }

                return set;
            }()
        },
        branchIds: {
            get: function get() {
                return this.filterOptions.branchIds;
            },
            set: function () {
                var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(newValue) {
                    return _regenerator2.default.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    _context2.next = 2;
                                    return this.$store.dispatch("webadmin/baseReport/changeFilterOption", {
                                        prop: "branchIds",
                                        value: newValue
                                    });

                                case 2:
                                case "end":
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, this);
                }));

                function set(_x2) {
                    return _ref2.apply(this, arguments);
                }

                return set;
            }()
        },
        payment_type: {
            get: function get() {
                return this.localFilter.payment_type;
            },
            set: function () {
                var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(newValue) {
                    return _regenerator2.default.wrap(function _callee3$(_context3) {
                        while (1) {
                            switch (_context3.prev = _context3.next) {
                                case 0:
                                    this.localFilter.payment_type = newValue;

                                case 1:
                                case "end":
                                    return _context3.stop();
                            }
                        }
                    }, _callee3, this);
                }));

                function set(_x3) {
                    return _ref3.apply(this, arguments);
                }

                return set;
            }()
        },
        verification_status: {
            get: function get() {
                return this.localFilter.verification_status;
            },
            set: function () {
                var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(newValue) {
                    return _regenerator2.default.wrap(function _callee4$(_context4) {
                        while (1) {
                            switch (_context4.prev = _context4.next) {
                                case 0:
                                    this.localFilter.verification_status = newValue;

                                case 1:
                                case "end":
                                    return _context4.stop();
                            }
                        }
                    }, _callee4, this);
                }));

                function set(_x4) {
                    return _ref4.apply(this, arguments);
                }

                return set;
            }()
        },
        appropriation_status: {
            get: function get() {
                return this.localFilter.appropriation_status;
            },
            set: function () {
                var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(newValue) {
                    return _regenerator2.default.wrap(function _callee5$(_context5) {
                        while (1) {
                            switch (_context5.prev = _context5.next) {
                                case 0:
                                    this.localFilter.appropriation_status = newValue;

                                case 1:
                                case "end":
                                    return _context5.stop();
                            }
                        }
                    }, _callee5, this);
                }));

                function set(_x5) {
                    return _ref5.apply(this, arguments);
                }

                return set;
            }()
        },
        display: {
            get: function get() {
                return this.$store.state.webadmin.baseReport.display;
            },
            set: function () {
                var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(newValue) {
                    return _regenerator2.default.wrap(function _callee6$(_context6) {
                        while (1) {
                            switch (_context6.prev = _context6.next) {
                                case 0:
                                    _context6.next = 2;
                                    return this.$store.dispatch("webadmin/baseReport/changeDisplay", newValue);

                                case 2:
                                case "end":
                                    return _context6.stop();
                            }
                        }
                    }, _callee6, this);
                }));

                function set(_x6) {
                    return _ref6.apply(this, arguments);
                }

                return set;
            }()
        },
        tableConfigModify: function tableConfigModify() {
            var configs = this.tableConfig;
            // if (this.configureStates.isSeventeen) {
            //     configs.columns.unshift({keys: "studio_name", head: "品牌名稱"});
            // }
            return configs;
        },
        csvConfigModify: function csvConfigModify() {
            var configs = this.csvConfig;
            // if (this.configureStates.isSeventeen) {
            //     configs.column.unshift({keys: "studio_name", name: "品牌名稱"});
            // }
            return configs;
        }
    }),
    methods: (0, _extends3.default)({
        thousandthFormat: function thousandthFormat(value) {
            return '$' + $17.thousandthFormat(value);
        },
        getParam: function getParam() {
            return {
                'start_date': this.dateOptions.startDate,
                'end_date': this.dateOptions.endDate,
                'display': this.display,
                'studio_id': this.filterOptions.studioId && this.filterOptions.studioId.hasOwnProperty('id') ? this.filterOptions.studioId.id : '',
                'branch_id': this.filterOptions.branchIds && this.filterOptions.branchIds.hasOwnProperty('id') ? this.filterOptions.branchIds.id : '',
                'payment_type': this.localFilter.payment_type && this.localFilter.payment_type.value ? this.localFilter.payment_type.value : '',
                'verification_status': this.localFilter.verification_status && this.localFilter.verification_status.value ? this.localFilter.verification_status.value : '',
                'appropriation_status': this.localFilter.appropriation_status && this.localFilter.appropriation_status.value ? this.localFilter.appropriation_status.value : '',
                'order_id': this.localFilter.order_id ? this.localFilter.order_id : ''
            };
        },
        submitSearch: function submitSearch() {
            switch (this.display) {
                case "export":
                    this.changeFilterOption({ prop: "pageSize", value: 9999999 });
                    break;
                case "show":
                    this.changeFilterOption({ prop: "pageSize", value: 25 });
                    break;
                default:
                    return false;
            }
            var params = this.getParam();
            $17.updateUrlQueryString(params);
            this.keepQueryParam(params);

            this.changePage(1);
        }
    }, (0, _vuex.mapActions)("webadmin/configure", ["configuredRun", "fetchStudioList", "fetchBranchList"]), (0, _vuex.mapActions)("webadmin/baseReport", ["submit", "toggleBlock", "changeDateOption", "changeFilterOption", "changeItemOption", "cleanBranch", "changeAjaxing", "changeDateOptionAfter", "syncDateAndDisplayByQuery", "syncLocalMultipleSelectByQuery", "syncRelatedMultipleSelectByQuery", "changeDisplay", "keepQueryParam"]), {
        getQueryResult: function getQueryResult(params) {
            var _this2 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7() {
                return _regenerator2.default.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                params['query_type'] = params.order_id ? 'order_id' : 'time';

                                _this2.result = {
                                    records: [],
                                    pageMeta: {},
                                    total: 0,
                                    verificationCheckoutTotal: 0,
                                    verificationVerifiedTotal: 0,
                                    appropriationCheckoutTotal: 0,
                                    appropriationApproveTotal: 0
                                };
                                _this2.changeAjaxing(true);
                                _context7.next = 5;
                                return _this2.$http.get("/adminapi/verification-appropriation/report/overview", { params: params }).then(function (response) {
                                    if (_this2.display == 'export') {
                                        _this2.export = response.data.data.records;
                                    }

                                    if (_this2.display == 'show') {
                                        _this2.result = response.data.data;
                                    }
                                }, function (error) {
                                    $17.swal({
                                        title: error.body.message,
                                        type: "warning"
                                    });
                                });

                            case 5:
                                _this2.changeAjaxing(false);

                            case 6:
                            case "end":
                                return _context7.stop();
                        }
                    }
                }, _callee7, _this2);
            }))();
        },
        changePage: function changePage(page) {
            var _this3 = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8() {
                var params;
                return _regenerator2.default.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _this3.changeFilterOption({
                                    prop: "page",
                                    value: page
                                });

                                params = _this3.queryPara;


                                params.page_size = _this3.filterOptions.pageSize;
                                params.page = _this3.filterOptions.page;

                                _context8.next = 6;
                                return _this3.getQueryResult(params);

                            case 6:
                            case "end":
                                return _context8.stop();
                        }
                    }
                }, _callee8, _this3);
            }))();
        },
        clickHtmlHandler: function clickHtmlHandler(val) {
            this[val.action](val.row);
        },
        viewVerification: function viewVerification(item) {
            var params = this.getParam();
            var url = webadmin_base_url + ("/verification-appropriation/verification-event-record?query_type=order_id&studio_id=" + item.studio_id + "&branch_id=" + item.branch_id + "&start_date=" + params.start_date + "&end_date=" + params.end_date + "&order_id=" + item.order_id);
            window.open(url, '_blank');
        },
        viewAppropriation: function viewAppropriation(item) {
            var params = this.getParam();
            var url = webadmin_base_url + ("/verification-appropriation/approve-event-record?query_type=order_id&studio_id=" + item.studio_id + "&branch_id=" + item.branch_id + "&start_date=" + params.start_date + "&end_date=" + params.end_date + "&order_id=" + item.order_id + "&studio_payment_method_id=&status_code=");
            window.open(url, '_blank');
        },
        viewSubRow: function viewSubRow(item) {
            var subRow = { component: 'verification-appropriation-overview-sub-row' };
            item.subRow.auto(subRow);
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"page-div\" _v-7c2d5b3d=\"\">\n    <v-webadmin-report :block-open-status=\"blockOpenStatus\" :date-options=\"dateOptions\" :toggle-block=\"toggleBlock\" :change-date-option=\"changeDateOptionAfter\" :submit=\"submitSearch\" limit-date=\"90\" title=\"訂單核銷及撥款指示總覽\" _v-7c2d5b3d=\"\">\n        <div slot=\"second-block\" _v-7c2d5b3d=\"\">\n            <div class=\"filters\" _v-7c2d5b3d=\"\">\n                <div class=\"row\" _v-7c2d5b3d=\"\">\n                    <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen\" _v-7c2d5b3d=\"\">\n                        <div class=\"form-group\" _v-7c2d5b3d=\"\">\n                            <v-mutiselect :model.sync=\"studioId\" :options=\"studioList\" :preserve-search=\"true\" :placeholder=\"configureStates.ajaxing.studioList ? '品牌讀取中…' : '全部品牌'\" label=\"brand_name\" track-by=\"id\" _v-7c2d5b3d=\"\">\n                            </v-mutiselect>\n                        </div>\n                    </div>\n                    <div class=\"col-sm-6\" v-if=\"configureStates.isSeventeen || configureStates.isStudio\" _v-7c2d5b3d=\"\">\n                        <div class=\"form-group\" _v-7c2d5b3d=\"\">\n                            <v-mutiselect :model.sync=\"branchIds\" :options=\"branchList\" :multiple=\"false\" :close-on-select=\"true\" :clear-on-select=\"false\" :hide-selected=\"false\" :preserve-search=\"true\" :searchable=\"false\" :placeholder=\"configureStates.ajaxing.branchList ? '場館讀取中…' : '全部場館'\" label=\"branch_name\" track-by=\"id\" tag-name=\"branch_name\" :max-height=\"500\" _v-7c2d5b3d=\"\">\n                            </v-mutiselect>\n                        </div>\n                    </div>\n                    <div class=\"col-sm-3\" _v-7c2d5b3d=\"\">\n                        <div class=\"form-group\" _v-7c2d5b3d=\"\">\n                            <input class=\"form-control\" type=\"text\" placeholder=\"請輸入訂單ID\" v-model.trim=\"localFilter.order_id\" _v-7c2d5b3d=\"\">\n                        </div>\n                    </div>\n                    <div class=\"col-sm-3\" _v-7c2d5b3d=\"\">\n                        <div class=\"form-group\" _v-7c2d5b3d=\"\">\n                            <v-mutiselect :model.sync=\"localFilter.payment_type\" :options=\"payment_types\" :multiple=\"false\" :close-on-select=\"true\" :clear-on-select=\"false\" :hide-selected=\"false\" :preserve-search=\"true\" :searchable=\"false\" placeholder=\"請選擇支付類型\" label=\"name\" track-by=\"value\" :max-height=\"500\" _v-7c2d5b3d=\"\">\n                            </v-mutiselect>\n                        </div>\n                    </div>\n                    <div class=\"col-sm-3\" _v-7c2d5b3d=\"\">\n                        <div class=\"form-group\" _v-7c2d5b3d=\"\">\n                            <v-mutiselect :model.sync=\"localFilter.verification_status\" :options=\"verification_statuses\" :multiple=\"false\" :close-on-select=\"true\" :clear-on-select=\"false\" :hide-selected=\"false\" :preserve-search=\"true\" :searchable=\"false\" placeholder=\"核銷鎖定狀態\" label=\"name\" track-by=\"value\" :max-height=\"500\" _v-7c2d5b3d=\"\">\n                            </v-mutiselect>\n                        </div>\n                    </div>\n                    <div class=\"col-sm-3\" _v-7c2d5b3d=\"\">\n                        <div class=\"form-group\" _v-7c2d5b3d=\"\">\n                            <v-mutiselect :model.sync=\"localFilter.appropriation_status\" :options=\"appropriation_statuses\" :multiple=\"false\" :close-on-select=\"true\" :clear-on-select=\"false\" :hide-selected=\"false\" :preserve-search=\"true\" :searchable=\"false\" placeholder=\"撥款鎖定狀態\" label=\"name\" track-by=\"value\" :max-height=\"500\" _v-7c2d5b3d=\"\">\n                            </v-mutiselect>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div slot=\"fourth-block\" _v-7c2d5b3d=\"\">\n            <div class=\"row\" _v-7c2d5b3d=\"\">\n                <div class=\"col-sm-6\" _v-7c2d5b3d=\"\">\n                    <div class=\"form-group\" _v-7c2d5b3d=\"\">\n                        <label _v-7c2d5b3d=\"\">\n                            <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"show\" checked=\"\" _v-7c2d5b3d=\"\"> 顯示於網頁\n                        </label>\n                        <label _v-7c2d5b3d=\"\">\n                            <input name=\"display\" v-model=\"display\" type=\"radio\" value=\"export\" _v-7c2d5b3d=\"\"> 匯出CSV\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </v-webadmin-report>\n    <div v-show=\"display === 'show'\" _v-7c2d5b3d=\"\">\n        <div class=\"m-top-30\" _v-7c2d5b3d=\"\">\n            <h4 v-if=\"!ajaxing&amp;&amp;result.records.length\" _v-7c2d5b3d=\"\">\n                <span class=\"p-right-25\" _v-7c2d5b3d=\"\">訂單結帳總金額：{{ thousandthFormat(result.total) }}</span>\n                <span class=\"p-right-25\" _v-7c2d5b3d=\"\">應核銷總金額：{{ thousandthFormat(result.verificationCheckoutTotal) }}</span>\n                <span class=\"p-right-25\" _v-7c2d5b3d=\"\">已核銷總金額：{{ thousandthFormat(result.verificationVerifiedTotal) }}</span>\n                <span class=\"p-right-25\" _v-7c2d5b3d=\"\">應撥款總金額：{{ thousandthFormat(result.appropriationCheckoutTotal) }}</span>\n                <span class=\"p-right-25\" _v-7c2d5b3d=\"\">已撥款總金額：{{ thousandthFormat(result.appropriationApproveTotal) }}</span>\n            </h4>\n        </div>\n        <div class=\"m-top-10\" _v-7c2d5b3d=\"\">\n            <v-smart-table ref=\"smart_table\" :table-config=\"tableConfigModify\" :csv-config=\"csvConfigModify\" :is-ajaxing=\"ajaxing\" :data=\"{records:result.records,pageMeta:result.pageMeta}\" :page-sync-url-query=\"false\" @change-page=\"changePage\" @html-click-callback=\"clickHtmlHandler\" _v-7c2d5b3d=\"\"></v-smart-table>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n/* line 2, stdin */\n.page-div[_v-7c2d5b3d] {\n  padding: 0px 15px;\n  margin-bottom: 15px; }\n\n/* line 7, stdin */\n.form-title[_v-7c2d5b3d] {\n  font-size: 16px;\n  font-weight: bold;\n  display: inline-block;\n  width: 60px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-7c2d5b3d", module.exports)
  } else {
    hotAPI.update("_v-7c2d5b3d", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/defineProperty":65,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1472:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\nhr[_v-1ab60984] {\n  border-top: 1px solid #c0c0c0; }\n\n/* line 5, stdin */\n.position-flex[_v-1ab60984] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center; }\n\n/* line 9, stdin */\n.inactive[_v-1ab60984] {\n  color: #929292; }\n\n/* line 12, stdin */\n.activated[_v-1ab60984] {\n  color: #72bb53; }\n\n/* line 15, stdin */\n.label-verification[_v-1ab60984], .label-approve[_v-1ab60984] {\n  font-size: 16px; }\n\n/* line 18, stdin */\n.btn-default[_v-1ab60984] {\n  color: #337ab7; }\n")
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vuex = require("vuex");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {},
  data: function data() {
    return {
      ajaxing: {
        branch: false,
        seventeenCollection: false,
        paymentActive: false,
        verificationSetting: {
          seventeenAgent: false,
          branchNewebpay: false
        },
        approveSetting: {
          seventeenAgent: false,
          branchNewebpay: false
        }
      },
      selectedBranch: null,
      defaultItemValue: {
        seventeenAgent: {
          payment_active: 0,
          veri_branch_setting_selected_setting_id: null,
          approve_branch_setting_selected_setting_id: null
        },
        branchNewebpay: {
          payment_active: 0,
          veri_branch_setting_selected_setting_id: null,
          approve_branch_setting_selected_setting_id: null
        }
      },
      branchNewebpay: {
        payment_active: 0,
        payment_id: null,
        veri_branch_setting_id: null,
        veri_branch_setting_selected_setting_id: null,
        veri_setting_options: [],
        approve_branch_setting_id: null,
        approve_branch_setting_selected_setting_id: null,
        approve_setting_options: []
      },
      seventeenAgent: {
        payment_active: 0,
        payment_id: null,
        veri_branch_setting_id: null,
        veri_branch_setting_selected_setting_id: null,
        veri_setting_options: [],
        approve_branch_setting_id: null,
        approve_branch_setting_selected_setting_id: null,
        approve_setting_options: []
      },
      branchNewebpayMapping: []
    };
  },

  watch: {
    branchId: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(val, oldVal) {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.isBranch) {
                  this.branchChangeCallBack(val);
                }

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function branchId(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return branchId;
    }()
  },
  mounted: function mounted() {},

  computed: (0, _extends3.default)({}, (0, _vuex.mapState)("webadmin/configure", ["studioId", "branchId", "isBranch", "isSeventeen"]), {
    seventeenAgentActive: function seventeenAgentActive() {
      return this.seventeenAgent.payment_id != null;
    },
    seventeenAgentPaymentChanged: function seventeenAgentPaymentChanged() {
      return this.defaultItemValue.seventeenAgent.payment_active != this.seventeenAgent.payment_active;
    },
    seventeenAgentSelectedChanged: function seventeenAgentSelectedChanged() {
      return this.defaultItemValue.seventeenAgent.veri_branch_setting_selected_setting_id != this.seventeenAgent.veri_branch_setting_selected_setting_id;
    },
    seventeenAgentApproveSelectedChanged: function seventeenAgentApproveSelectedChanged() {
      return this.defaultItemValue.seventeenAgent.approve_branch_setting_selected_setting_id != this.seventeenAgent.approve_branch_setting_selected_setting_id;
    },
    branchNewebpayActive: function branchNewebpayActive() {
      return this.branchNewebpay.payment_id != null;
    },
    branchNewebpayPaymentChanged: function branchNewebpayPaymentChanged() {
      return this.defaultItemValue.branchNewebpay.payment_active != this.branchNewebpay.payment_active;
    },
    branchNewebpaySelectedChanged: function branchNewebpaySelectedChanged() {
      return this.defaultItemValue.branchNewebpay.veri_branch_setting_selected_setting_id != this.branchNewebpay.veri_branch_setting_selected_setting_id;
    },
    branchNewebpayApproveSelectedChanged: function branchNewebpayApproveSelectedChanged() {
      return this.defaultItemValue.branchNewebpay.approve_branch_setting_selected_setting_id != this.branchNewebpay.approve_branch_setting_selected_setting_id;
    }
  }),
  methods: {
    branchChangeCallBack: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(branchId) {
        var _this = this;

        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.reset();
                if (branchId) {
                  this.ajaxing.branch = true;
                  this.selectedBranch = branchId;
                  this.$http.get("/adminapi/verification-appropriation/setting/branch/" + branchId).then(function (response) {
                    // this.setting = response.data;
                    var data = response.data;
                    _this.branchNewebpayMapping = data.branchNewebpayMapping;

                    _this.seventeenAgent = data.seventeenAgent;
                    _this.defaultItemValue.seventeenAgent.payment_active = data.seventeenAgent.payment_active;
                    _this.defaultItemValue.seventeenAgent.veri_branch_setting_selected_setting_id = data.seventeenAgent.veri_branch_setting_selected_setting_id;
                    _this.defaultItemValue.seventeenAgent.approve_branch_setting_selected_setting_id = data.seventeenAgent.approve_branch_setting_selected_setting_id;

                    _this.branchNewebpay = data.branchNewebpay;
                    _this.defaultItemValue.branchNewebpay.payment_active = data.branchNewebpay.payment_active;
                    _this.defaultItemValue.branchNewebpay.veri_branch_setting_selected_setting_id = data.branchNewebpay.veri_branch_setting_selected_setting_id;
                    _this.defaultItemValue.branchNewebpay.approve_branch_setting_selected_setting_id = data.branchNewebpay.approve_branch_setting_selected_setting_id;
                    _this.ajaxing.branch = false;
                  }).catch(function (response) {
                    _this.ajaxing.branch = false;
                    var msg = response.data.message;
                    if (msg != '支付方式尚未啟用') {
                      msg = '取得資料失敗';
                    }
                    $17.swal({
                      title: msg,
                      text: "",
                      type: "warning",
                      showCancelButton: false
                    });
                  });
                }

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function branchChangeCallBack(_x3) {
        return _ref2.apply(this, arguments);
      }

      return branchChangeCallBack;
    }(),
    activate: function activate() {
      var _this2 = this;

      this.ajaxing.seventeenCollection = true;
      this.$http.post("/adminapi/verification-appropriation/seventeen-collection/active/branch/" + this.selectedBranch).then(function (response) {
        _this2.ajaxing.seventeenCollection = false;
        _this2.branchChangeCallBack(_this2.selectedBranch);
        $17.swal({
          title: "儲存成功",
          text: "",
          type: "success",
          showCancelButton: false
        });
      }).catch(function (response) {
        _this2.ajaxing.seventeenCollection = false;
        $17.swal({
          title: "儲存失敗",
          text: "",
          type: "warning",
          showCancelButton: false
        });
      });
    },
    changeSeventeenAgent: function changeSeventeenAgent() {
      var _this3 = this;

      this.ajaxing.paymentActive = true;
      this.$http.put("/adminapi/verification-appropriation/seventeen-collection/active/studio_17fit_payment_method_agent", {
        payment_active: this.seventeenAgent.payment_active,
        studio_17fit_payment_method_agent_id: this.seventeenAgent.payment_id
      }).then(function (response) {
        _this3.ajaxing.paymentActive = false;
        _this3.branchChangeCallBack(_this3.selectedBranch);
        $17.swal({
          title: "儲存成功",
          text: "",
          type: "success",
          showCancelButton: false
        });
      }).catch(function (response) {
        _this3.ajaxing.paymentActive = false;
        $17.swal({
          title: "儲存失敗",
          text: "",
          type: "warning",
          showCancelButton: false
        });
      });
    },
    changeVerificationSetting: function changeVerificationSetting(changeType) {
      var _this4 = this;

      this.ajaxing.verificationSetting[changeType] = true;
      this.$http.put("/adminapi/verification-appropriation/branch/verification-setting", {
        'type': changeType,
        'branch_id': this.selectedBranch,
        'branch_order_detail_verification_setting_id': this[changeType]["veri_branch_setting_id"],
        'branch_order_detail_verification_setting_setting_id': this[changeType]["veri_branch_setting_selected_setting_id"]
      }).then(function (response) {
        _this4.ajaxing.verificationSetting[changeType] = false;
        _this4.branchChangeCallBack(_this4.selectedBranch);
        $17.swal({
          title: "儲存成功",
          text: "",
          type: "success",
          showCancelButton: false
        });
      }).catch(function (response) {
        _this4.ajaxing.verificationSetting[changeType] = false;
        $17.swal({
          title: "儲存失敗",
          text: "",
          type: "warning",
          showCancelButton: false
        });
      });
    },
    changeApproveSetting: function changeApproveSetting(changeType) {
      var _this5 = this;

      this.ajaxing.approveSetting[changeType] = true;
      this.$http.put("/adminapi/verification-appropriation/branch/approve-setting", {
        'type': changeType,
        'branch_id': this.selectedBranch,
        'branch_order_detail_approve_setting_id': this[changeType]["approve_branch_setting_id"],
        'branch_order_detail_approve_setting_setting_id': this[changeType]["approve_branch_setting_selected_setting_id"]
      }).then(function (response) {
        _this5.ajaxing.approveSetting[changeType] = false;
        _this5.branchChangeCallBack(_this5.selectedBranch);
        $17.swal({
          title: "儲存成功",
          text: "",
          type: "success",
          showCancelButton: false
        });
      }).catch(function (response) {
        _this5.ajaxing.approveSetting[changeType] = false;
        $17.swal({
          title: "儲存失敗",
          text: "",
          type: "warning",
          showCancelButton: false
        });
      });
    },
    updateBranchNewebpaySettings: function updateBranchNewebpaySettings(title, column) {
      var _this6 = this;

      var mapping = '';
      var html = '';
      var params = {};
      if (column === 'veri_branch_setting_selected_setting_id') {
        mapping = this.branchNewebpayMapping.find(function (item) {
          return item.verification_setting_id === _this6.branchNewebpay.veri_branch_setting_selected_setting_id;
        });
        console.log(mapping);
        html = "\u300C\u8A02\u55AE\u6838\u92B7\u6A21\u5F0F\u300D \u5C07\u6539\u70BA\uFF1A" + mapping.verification_setting_display_name;
        params = {
          branch_order_detail_verification_setting_id: this.branchNewebpay.veri_branch_setting_id,
          branch_order_detail_verification_setting_setting_id: this.branchNewebpay.veri_branch_setting_selected_setting_id
        };
      } else {
        mapping = this.branchNewebpayMapping.find(function (item) {
          return item.approve_setting_id === _this6.branchNewebpay.approve_branch_setting_selected_setting_id;
        });
        console.log(mapping);
        html = "\u300C\u91D1\u6D41\u64A5\u6B3E\u6307\u793A\u6A21\u5F0F\u300D \u5C07\u6539\u70BA\uFF1A" + mapping.approve_setting_display_name;
        params = {
          branch_order_detail_approve_setting_id: this.branchNewebpay.approve_branch_setting_id,
          branch_order_detail_approve_setting_setting_id: this.branchNewebpay.approve_branch_setting_selected_setting_id
          // branch_order_detail_approve_setting_setting_id: this.branchNewebpay.approve_branch_setting_selected_setting_id,
        };
      }
      $17.swal({
        title: title + '？',
        type: 'warning',
        html: html
      }, function () {
        _this6.ajaxing.verificationSetting.branchNewebpay = true;
        _this6.ajaxing.approveSetting.branchNewebpay = true;
        _this6.$http.put("/adminapi/verification-appropriation/branch/newebpay-setting", (0, _extends3.default)({
          type: 'branchNewebpay',
          branch_id: _this6.selectedBranch
        }, params)).then(function (response) {
          _this6.ajaxing.verificationSetting.branchNewebpay = false;
          _this6.ajaxing.approveSetting.branchNewebpay = false;
          _this6.branchChangeCallBack(_this6.selectedBranch);
          $17.swal({
            title: "儲存成功",
            type: "success",
            showCancelButton: false
          });
        }).catch(function (response) {
          _this6.ajaxing.verificationSetting.branchNewebpay = false;
          _this6.ajaxing.approveSetting.branchNewebpay = false;
          $17.swal({
            title: "儲存失敗",
            type: "warning",
            showCancelButton: false
          });
        });
      });
    },
    reset: function reset() {
      this.defaultItemValue = {
        seventeenAgent: {
          payment_active: 0,
          veri_branch_setting_selected_setting_id: null,
          approve_branch_setting_selected_setting_id: null
        },
        branchNewebpay: {
          payment_active: 0,
          veri_branch_setting_selected_setting_id: null,
          approve_branch_setting_selected_setting_id: null
        }
      };

      this.branchNewebpay = {
        payment_active: 0,
        payment_id: null,
        veri_branch_setting_id: null,
        veri_branch_setting_selected_setting_id: null,
        veri_setting_options: [],
        approve_branch_setting_id: null,
        approve_branch_setting_selected_setting_id: null,
        approve_setting_options: []
      };
      this.seventeenAgent = {
        payment_active: 0,
        payment_id: null,
        veri_branch_setting_id: null,
        veri_branch_setting_selected_setting_id: null,
        veri_setting_options: [],
        approve_branch_setting_id: null,
        approve_branch_setting_selected_setting_id: null,
        approve_setting_options: []
      };
    }
  }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"content-inner\" _v-1ab60984=\"\">\n  <div class=\"row m-bottom-20 m-left-10\" _v-1ab60984=\"\">\n    <h3 class=\"\" _v-1ab60984=\"\">金流及核銷撥款設定</h3>\n  </div>\n  <div class=\"m-bottom-50 m-left-5\" _v-1ab60984=\"\">\n    <v-multiselect-studio-and-branch :studio_id=\"studioId\" :branch_id=\"branchId\" :branch-change-call-back=\"branchChangeCallBack\" _v-1ab60984=\"\"></v-multiselect-studio-and-branch>\n  </div>\n  <v-spinner :ajaxing=\"ajaxing.branch\" _v-1ab60984=\"\"></v-spinner>\n  <template v-if=\"!ajaxing.branch\">\n    <div class=\"row position-flex m-bottom-15 m-left-30\" _v-1ab60984=\"\">\n      <div class=\"col-sm-3 col-xs-6\" _v-1ab60984=\"\">\n        <h4 class=\"\" _v-1ab60984=\"\">17FIT金流代收</h4>\n      </div>\n      <div class=\"col-sm-9 col-xs-6\" v-if=\"!seventeenAgentActive\" _v-1ab60984=\"\">\n        <div class=\"btn btn-success\" @click=\"activate\" v-show=\"!ajaxing.seventeenCollection\" _v-1ab60984=\"\">開通</div>\n        <v-spinner-button :ajaxing=\"ajaxing.seventeenCollection\" fa-size=\"fa-2x\" _v-1ab60984=\"\"></v-spinner-button>\n      </div>\n      <div class=\"col-sm-9 col-xs-6\" v-if=\"seventeenAgentActive\" _v-1ab60984=\"\">\n        <span class=\"activated p-right-20\" _v-1ab60984=\"\">已開通</span>\n        <input type=\"radio\" name=\"seventeenAgent\" :value=\"1\" v-model=\"seventeenAgent.payment_active\" id=\"seventeen-activated\" _v-1ab60984=\"\">\n        <label for=\"seventeen-activated\" class=\"p-right-20\" _v-1ab60984=\"\">啟用</label>\n        <input type=\"radio\" name=\"seventeenAgent\" :value=\"0\" id=\"seventeen-close\" v-model=\"seventeenAgent.payment_active\" _v-1ab60984=\"\">\n        <label for=\"seventeen-close\" class=\"p-right-20\" _v-1ab60984=\"\">關閉</label>\n        <a class=\"btn btn-primary\" v-if=\"seventeenAgentPaymentChanged &amp;&amp; !ajaxing.paymentActive\" @click=\"changeSeventeenAgent\" _v-1ab60984=\"\">確認變更</a>\n        <v-spinner-button :ajaxing=\"ajaxing.paymentActive\" fa-size=\"fa-2x\" _v-1ab60984=\"\"></v-spinner-button>\n      </div>\n    </div>\n    <hr _v-1ab60984=\"\">\n    <div class=\"row m-bottom-15 m-left-30\" _v-1ab60984=\"\">\n      <div class=\"col-sm-3 col-xs-6\" _v-1ab60984=\"\">\n        <h4 class=\"\" _v-1ab60984=\"\">訂單核銷模式</h4>\n      </div>\n      <div class=\"col-sm-9 col-xs-6\" _v-1ab60984=\"\"></div>\n    </div>\n    <div class=\"row position-flex m-left-30 m-bottom-15\" _v-1ab60984=\"\">\n      <div class=\"col-sm-3 col-xs-6\" _v-1ab60984=\"\">\n        <span class=\"label-verification\" _v-1ab60984=\"\">線上刷卡(17FIT)</span>\n      </div>\n      <div class=\"col-sm-9 col-xs-6\" v-if=\"!seventeenAgentActive\" _v-1ab60984=\"\">\n        <div class=\"inactive p-right-20\" _v-1ab60984=\"\">尚未開通</div>\n      </div>\n      <div class=\"col-sm-9 col-xs-6\" v-if=\"seventeenAgentActive\" _v-1ab60984=\"\"> \n        <span class=\"activated p-right-20\" _v-1ab60984=\"\">已開通</span>\n        <template v-for=\"option in seventeenAgent.veri_setting_options\">\n          <input type=\"radio\" name=\"verification-seventeen\" v-model=\"\n              seventeenAgent.veri_branch_setting_selected_setting_id\n            \" :value=\"option.id\" :id=\"'seventeen'+option.name\" :disabled=\"ajaxing.verificationSetting.seventeenAgent\" _v-1ab60984=\"\">\n          <label :for=\"'seventeen'+option.name\" class=\"p-right-20\" _v-1ab60984=\"\">\n            {{ option.display_name }}\n          </label>\n        </template>\n        <a class=\"btn btn-primary\" @click=\"changeVerificationSetting('seventeenAgent')\" v-if=\"seventeenAgentSelectedChanged &amp;&amp; !ajaxing.verificationSetting.seventeenAgent\" _v-1ab60984=\"\">確認變更</a>\n      </div>\n    </div>\n    <div class=\"row position-flex m-bottom-15 m-left-30 m-bottom-15\" _v-1ab60984=\"\">\n      <div class=\"col-sm-3 col-xs-6\" _v-1ab60984=\"\">\n        <span class=\"label-verification\" _v-1ab60984=\"\">線上刷卡(藍新)</span>\n      </div>\n      <div class=\"col-sm-9 col-xs-6\" v-if=\"!branchNewebpayActive\" _v-1ab60984=\"\">\n        <div class=\"inactive p-right-20\" _v-1ab60984=\"\">尚未開通</div>\n      </div>\n      <div class=\"col-sm-9 col-xs-6\" v-if=\"branchNewebpayActive\" _v-1ab60984=\"\">\n        <span class=\"activated p-right-20\" _v-1ab60984=\"\">已開通</span>\n        <template v-for=\"option in branchNewebpay.veri_setting_options\">\n          <input type=\"radio\" name=\"verification-branch\" v-model=\"\n              branchNewebpay.veri_branch_setting_selected_setting_id\n            \" :value=\"option.id\" :id=\"'branch'+option.name\" :disabled=\"ajaxing.verificationSetting.branchNewebpay\" _v-1ab60984=\"\">\n          <label :for=\"'branch'+option.name\" class=\"p-right-20\" _v-1ab60984=\"\">\n            {{ option.display_name }}\n          </label>\n        </template>\n        <a class=\"btn btn-primary\" @click=\"updateBranchNewebpaySettings('確認變更','veri_branch_setting_selected_setting_id')\" v-if=\"branchNewebpaySelectedChanged &amp;&amp; !ajaxing.verificationSetting.branchNewebpay\" _v-1ab60984=\"\">確認變更</a>\n      </div>\n    </div>\n    <hr _v-1ab60984=\"\">\n    <div class=\"row m-bottom-15 m-left-30\" _v-1ab60984=\"\">\n      <div class=\"col-sm-3 col-xs-6\" _v-1ab60984=\"\">\n        <h4 class=\"\" _v-1ab60984=\"\">金流撥款指示模式</h4>\n      </div>\n      <div class=\"col-sm-9 col-xs-6\" _v-1ab60984=\"\"></div>\n    </div>\n    <div class=\"row position-flex m-left-30 m-bottom-15\" _v-1ab60984=\"\">\n      <div class=\"col-sm-3 col-xs-6\" _v-1ab60984=\"\">\n        <span class=\"label-approve\" _v-1ab60984=\"\">線上刷卡(17FIT)</span>\n      </div>\n      <div class=\"col-sm-9 col-xs-6\" v-if=\"!seventeenAgentActive\" _v-1ab60984=\"\">\n        <div class=\"inactive p-right-20\" _v-1ab60984=\"\">尚未開通</div>\n      </div>\n      <div class=\"col-sm-9 col-xs-6\" v-if=\"seventeenAgentActive\" _v-1ab60984=\"\">\n        <span class=\"activated p-right-20\" _v-1ab60984=\"\">已開通</span>\n        <template v-for=\"option in seventeenAgent.approve_setting_options\">\n          <input type=\"radio\" name=\"approve-seventeen\" v-model=\"\n              seventeenAgent.approve_branch_setting_selected_setting_id\n            \" :value=\"option.id\" :id=\"'seventeen-approve-'+option.name\" :disabled=\"ajaxing.approveSetting.seventeenAgent\" _v-1ab60984=\"\">\n          <label :for=\"'seventeen-approve-'+option.name\" _v-1ab60984=\"\">\n            {{ option.display_name }}\n          </label>\n        </template>\n        <a class=\"btn btn-primary\" @click=\"changeApproveSetting('seventeenAgent')\" v-if=\"seventeenAgentApproveSelectedChanged &amp;&amp; !ajaxing.approveSetting.seventeenAgent\" _v-1ab60984=\"\">確認變更</a>\n        <v-spinner-button :ajaxing=\"ajaxing.approveSetting.seventeenAgent\" fa-size=\"fa-2x\" _v-1ab60984=\"\"></v-spinner-button>\n      </div>\n    </div>\n    <div class=\"row position-flex m-bottom-15 m-left-30 m-bottom-15\" _v-1ab60984=\"\">\n      <div class=\"col-sm-3 col-xs-6\" _v-1ab60984=\"\">\n        <span class=\"label-approve\" _v-1ab60984=\"\">線上刷卡(藍新)</span>\n      </div>\n      <div class=\"col-sm-9 col-xs-6\" v-if=\"!branchNewebpayActive\" _v-1ab60984=\"\">\n        <div class=\"inactive p-right-20\" _v-1ab60984=\"\">尚未開通</div>\n      </div>\n      <div class=\"col-sm-9 col-xs-6\" v-if=\"branchNewebpayActive\" _v-1ab60984=\"\">\n        <span class=\"activated p-right-20\" _v-1ab60984=\"\">已開通</span>\n        <template v-for=\"option in branchNewebpay.approve_setting_options\">\n          <input type=\"radio\" name=\"approve-branch\" v-model=\"\n              branchNewebpay.approve_branch_setting_selected_setting_id\n            \" :value=\"option.id\" :id=\"'branch-approve-'+option.name\" :disabled=\"ajaxing.approveSetting.branchNewebpay\" _v-1ab60984=\"\">\n          <label :for=\"'branch-approve-'+option.name\" class=\"p-right-20\" _v-1ab60984=\"\">\n            {{ option.display_name }}\n          </label>\n        </template>\n        <a class=\"btn btn-primary\" @click=\"updateBranchNewebpaySettings('確認變更','approve_branch_setting_selected_setting_id')\" v-if=\"branchNewebpayApproveSelectedChanged &amp;&amp; !ajaxing.approveSetting.branchNewebpay\" _v-1ab60984=\"\">確認變更</a>\n        <a class=\"btn btn-default\" @click=\"updateBranchNewebpaySettings('重新送出','approve_branch_setting_selected_setting_id')\" v-if=\"!branchNewebpayApproveSelectedChanged &amp;&amp; !ajaxing.approveSetting.branchNewebpay\" _v-1ab60984=\"\">\n          重新送出</a>\n        <v-spinner-button :ajaxing=\"ajaxing.verificationSetting.branchNewebpay\" fa-size=\"fa-2x\" _v-1ab60984=\"\"></v-spinner-button>\n        <v-spinner-button :ajaxing=\"ajaxing.approveSetting.branchNewebpay\" fa-size=\"fa-2x\" _v-1ab60984=\"\"></v-spinner-button>\n      </div>\n    </div>\n    <hr _v-1ab60984=\"\">\n  </template>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\nhr[_v-1ab60984] {\n  border-top: 1px solid #c0c0c0; }\n\n/* line 5, stdin */\n.position-flex[_v-1ab60984] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center; }\n\n/* line 9, stdin */\n.inactive[_v-1ab60984] {\n  color: #929292; }\n\n/* line 12, stdin */\n.activated[_v-1ab60984] {\n  color: #72bb53; }\n\n/* line 15, stdin */\n.label-verification[_v-1ab60984], .label-approve[_v-1ab60984] {\n  font-size: 16px; }\n\n/* line 18, stdin */\n.btn-default[_v-1ab60984] {\n  color: #337ab7; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-1ab60984", module.exports)
  } else {
    hotAPI.update("_v-1ab60984", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1473:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.endtime-modal-calendar[_v-c35a7478] {\n  right: 90px; }\n\n/* line 5, stdin */\n.time_span_duration[_v-c35a7478] {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-align: center;\n      align-items: center; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _watch;

var _vuex = require('vuex');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {},
  data: function data() {
    return {
      ajaxing: {
        branch: false,
        records: false
      },
      filter: {
        queryType: 'time',
        startDate: moment().subtract(7, 'days').format('YYYY/MM/DD'),
        endDate: moment().format('YYYY/MM/DD'),
        branchId: null,
        studioId: null,
        orderId: null
      },
      more: null,
      records: [],
      relatedFilterWatcher: {
        studio_id: { watcher: null, options: 'studioList', vModel: 'studioId', trackBy: 'id', select: 'single' },
        branch_id: { watcher: null, options: 'branchList', vModel: 'branchId', trackBy: 'id', select: 'single' }
      }
    };
  },

  watch: (_watch = {}, (0, _defineProperty3.default)(_watch, 'filter.studioId', function filterStudioId(n, o) {
    if (this.configureStates.isSeventeen && !_lodash2.default.isEmpty(n)) {
      this.fetchBranchList({
        studioId: n.id
      });
    }
    if (this.configureStates.isStudio) {
      this.fetchBranchList({
        studioId: n.id
      });
    }
  }), (0, _defineProperty3.default)(_watch, 'configureStates.studioId', function configureStatesStudioId(n, o) {
    if (n) {
      this.filter.studioId = { id: n };
    }
  }), (0, _defineProperty3.default)(_watch, 'configureStates.branchId', function configureStatesBranchId(n, o) {
    if (n) {
      this.filter.branchId = { id: n };
      this.fetchRecords();
    }
  }), _watch),
  created: function created() {
    this.syncMultiSelectByQuery();
  },
  mounted: function mounted() {
    var _this = this;

    this.configuredRun(function () {
      _this.changeFilterOption({
        prop: 'studioId',
        value: {
          id: _this.configureStates.studioId,
          brand_name: ''
        }
      });
      _this.changeFilterOption({
        prop: 'branchId',
        value: _this.configureStates.branchId
      });
      if (_this.configureStates.isSeventeen) {
        return _this.fetchStudioList();
      }
    });
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapState)("webadmin/configure", ["studioId", "branchId", "isBranch", "isSeventeen", 'studioList', 'branchList']), (0, _vuex.mapState)({
    configureStates: function configureStates(state) {
      return state.webadmin.configure;
    }
  }), {
    studioId: {
      get: function get() {
        return this.filter.studioId;
      },
      set: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(newValue) {
          return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return this.$store.dispatch('webadmin/bookingTotalList/changeFilterOption', { 'prop': 'studioId', value: newValue });

                case 2:
                  if (!_lodash2.default.isEmpty(newValue)) {
                    $17.updateUrlQueryString({ studio_id: newValue.id });
                  }
                  this.cleanBranch();

                  if (!newValue) {
                    _context.next = 7;
                    break;
                  }

                  _context.next = 7;
                  return this.fetchBranchList({ studioId: newValue.id });

                case 7:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function set(_x) {
          return _ref.apply(this, arguments);
        }

        return set;
      }()
    },
    branchId: {
      get: function get() {
        return this.filter.branchId;
      },
      set: function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(newValue) {
          return _regenerator2.default.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return this.$store.dispatch('webadmin/bookingTotalList/changeFilterOption', { 'prop': 'branchIds', value: newValue });

                case 2:
                  $17.updateUrlQueryString({ branch_id: newValue.id });

                case 3:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        function set(_x2) {
          return _ref2.apply(this, arguments);
        }

        return set;
      }()
    }
  }),
  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('webadmin/configure', ['configuredRun', 'fetchStudioList', 'fetchBranchList']), (0, _vuex.mapActions)('webadmin/bookingTotalList', ['changeFilterOption', 'cleanBranch']), {
    showMore: function showMore(data) {
      this.more = data.referenceData ? JSON.parse(data.referenceData) : '';
      $('#more-modal').modal('show');
    },

    studioChangeCallBack: function studioChangeCallBack(studioId) {
      this.filter.studioId = studioId;
    },
    branchChangeCallBack: function branchChangeCallBack(branchId) {
      this.filter.branchId = branchId;
    },
    fetchRecords: function fetchRecords() {
      var _this2 = this;

      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
        var params;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(_this2.filter.branchId && _this2.filter.queryType && _this2.checkQueryType())) {
                  _context3.next = 6;
                  break;
                }

                _this2.ajaxing.records = true;

                params = {
                  query_type: _this2.filter.queryType,
                  studio_id: _this2.filter.studioId.id,
                  branch_id: _this2.filter.branchId.id,
                  start_date: _this2.filter.queryType == 'time' ? _this2.filter.startDate : null,
                  end_date: _this2.filter.queryType == 'time' ? _this2.filter.endDate : null,
                  order_id: _this2.filter.queryType == 'order_id' ? _this2.filter.orderId : null
                };

                $17.updateUrlQueryString(params);
                _context3.next = 6;
                return _this2.$http.get("/adminapi/verification-appropriation/report/verification/event-record", { 'params': params }).then(function (response) {
                  _this2.ajaxing.records = false;
                  _this2.records = response.data;
                }).catch(function (response) {
                  _this2.ajaxing.records = false;
                  $17.swal({
                    title: "取得資料失敗",
                    text: response.data.message,
                    type: "warning",
                    showCancelButton: false
                  });
                });

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },
    download: function download(_csvString) {
      var downloadLink = document.createElement("a");
      downloadLink.download = "核銷事件紀錄.csv";
      downloadLink.innerHTML = "Download File";
      if (window.URL != null) {
        var code = encodeURIComponent(_csvString);
        downloadLink.href = "data:application/csv;charset=utf-8,%EF%BB%BF" + code;
      }
      downloadLink.click();
    },
    columnFormater: function columnFormater(data) {
      csv = (0, _stringify2.default)(data);
      csv = csv.replaceAll('studioName', '品牌名稱');
      csv = csv.replaceAll('branchName', '場館名稱');
      csv = csv.replaceAll('eventId', '核銷事件編號');
      csv = csv.replaceAll('eventTime', '核銷事件產生時間');
      csv = csv.replaceAll('verificationReason', '核銷原因');
      if (this.configureStates.isSeventeen) csv = csv.replaceAll('referenceData', '補充資料');
      csv = csv.replaceAll('orderId', '訂單編號');
      csv = csv.replaceAll('orderDetailProductName', '訂單項目名稱');
      csv = csv.replaceAll('checkoutAt', '結帳時間');
      csv = csv.replaceAll('beforeBalance', '本次核銷前-待核銷金額');
      csv = csv.replaceAll('verificationAmount', '本次項目核銷金額');
      csv = csv.replaceAll('afterBalance', '本次核銷後-待核銷金額');
      csv = csv.replaceAll('tradeNo', '訂單關聯的第三方支付交易序號');
      return csv;
    },
    csvDataHandler: function csvDataHandler(data) {
      data = this.columnFormater(data);
      var results = Papa.unparse(data, {
        delimiter: ','
      });

      return results;
    },
    downloadCsv: function downloadCsv() {
      var _this3 = this;

      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
        var results;
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this3.fetchRecords();

              case 2:
                results = _this3.csvDataHandler(_this3.records);

                _this3.download(results);

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this3);
      }))();
    },
    checkQueryType: function checkQueryType() {
      if (this.filter.queryType == 'time' && (!this.filter.startDate || !this.filter.endDate)) {
        $17.swal({
          title: "您輸入的格式有錯誤",
          text: "請填寫開始日期或結束日期",
          type: "warning",
          showCancelButton: false
        });

        return false;
      }
      if (this.filter.queryType == 'order_id' && !this.filter.orderId) {
        $17.swal({
          title: "您輸入的格式有錯誤",
          text: "請填寫訂單編號",
          type: "warning",
          showCancelButton: false
        });

        return false;
      }

      return true;
    },
    syncMultiSelectByQuery: function syncMultiSelectByQuery() {
      var _this4 = this;

      var vm = this;
      var query = _lodash2.default.cloneDeep($17.getUrlQueryStrings());
      this.filter.queryType = query.query_type ? query.query_type : 'time';
      this.filter.orderId = query.order_id != 'null' ? query.order_id : null;
      if (query.start_date) {
        this.filter.startDate = query.start_date;
        this.filter.endDate = query.end_date;
      }

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        var _loop = function _loop() {
          var _step$value = (0, _slicedToArray3.default)(_step.value, 2),
              key = _step$value[0],
              value = _step$value[1];

          value.watcher = _this4.$watch(value.options, function (newV, oldV) {
            if (!_lodash2.default.isEmpty(newV)) {
              var queryArr = query[key] ? query[key].split(",") : [];
              var resultArr = [];
              var isMultiSelect = value.select == 'multi';
              queryArr.forEach(function (el) {
                var findEl = newV.find(function (item) {
                  return item[value.trackBy] == el;
                });
                findEl ? resultArr.push(findEl) : null;
              });
              vm.filter[value.vModel] = isMultiSelect ? resultArr : resultArr[0];
              value.watcher();
              if (value.vModel == "branchId") {
                _this4.fetchRecords();
              }
            }
          });
        };

        for (var _iterator = (0, _getIterator3.default)((0, _entries2.default)(this.relatedFilterWatcher)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          _loop();
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"content-inner\" _v-c35a7478=\"\">\n  <div class=\"row m-bottom-20 m-left-10\" _v-c35a7478=\"\">\n    <h3 class=\"\" _v-c35a7478=\"\">訂單項目-核銷事件紀錄</h3>\n  </div>\n  <div class=\"row m-bottom-50 m-left-5\" _v-c35a7478=\"\">\n    <div class=\"col-sm-3\" v-if=\"configureStates.isSeventeen\" _v-c35a7478=\"\">\n      <div class=\"form-group\" _v-c35a7478=\"\">\n        <v-mutiselect :model.sync=\"filter.studioId\" :options=\"studioList\" :preserve-search=\"true\" :placeholder=\"configureStates.ajaxing.studioList ? '品牌讀取中…' : '請選擇品牌'\" label=\"brand_name\" track-by=\"id\" _v-c35a7478=\"\">\n        </v-mutiselect>\n      </div>\n    </div>\n    <div class=\"col-sm-3\" v-if=\"configureStates.isSeventeen || configureStates.isStudio\" _v-c35a7478=\"\">\n      <div class=\"form-group\" _v-c35a7478=\"\">\n        <v-mutiselect :model.sync=\"filter.branchId\" :options=\"branchList\" :preserve-search=\"true\" :placeholder=\"configureStates.ajaxing.branchList ? '場館讀取中…' : '請選擇場館'\" label=\"branch_name\" track-by=\"id\" tag-name=\"branch_name\" :max-height=\"500\" _v-c35a7478=\"\">\n        </v-mutiselect>\n      </div>\n    </div>\n  </div>\n  <div class=\"row\" _v-c35a7478=\"\">\n    <div class=\"col-sm-3\" _v-c35a7478=\"\">\n      <label for=\"query-by-time\" _v-c35a7478=\"\">\n        <input type=\"radio\" name=\"query-by\" v-model=\"filter.queryType\" value=\"time\" id=\"query-by-time\" _v-c35a7478=\"\">\n        透過建立時間查詢\n      </label>\n    </div>\n    <div class=\"col-sm-8 \" _v-c35a7478=\"\">\n      <div class=\"time_span_duration\" _v-c35a7478=\"\">\n        <v-datepicker v-model=\"filter.startDate\" placeholder=\"開始日期\" _v-c35a7478=\"\"></v-datepicker>\n        <div class=\"m-right-5 m-left-5\" _v-c35a7478=\"\">~</div>\n        <v-datepicker v-model=\"filter.endDate\" placeholder=\"結束日期\" calendar-class=\"endtime-modal-calendar\" _v-c35a7478=\"\"></v-datepicker>\n      </div>\n    </div>\n  </div>\n  <div class=\"row m-top-5\" _v-c35a7478=\"\">\n    <div class=\"col-sm-3\" _v-c35a7478=\"\">\n      <label for=\"query-by-order\" _v-c35a7478=\"\">\n        <input type=\"radio\" name=\"query-by\" v-model=\"filter.queryType\" value=\"order_id\" id=\"query-by-order\" _v-c35a7478=\"\">\n        透過訂單編號查詢\n      </label>\n    </div>\n    <div class=\"col-sm-8\" _v-c35a7478=\"\">\n      <div _v-c35a7478=\"\">\n        <input type=\"text\" name=\"\" placeholder=\"訂單編號\" v-model=\"filter.orderId\" _v-c35a7478=\"\">\n      </div>\n    </div>\n  </div>\n  <div class=\"row m-top-15\" _v-c35a7478=\"\">\n    <div class=\"col-sm-12\" _v-c35a7478=\"\">\n      <div class=\"btn btn-primary\" @click=\"fetchRecords\" _v-c35a7478=\"\">查詢</div>\n      <div class=\"btn btn-success\" @click=\"downloadCsv\" _v-c35a7478=\"\">匯出CSV</div>\n    </div>\n  </div>\n  <div class=\"row\" _v-c35a7478=\"\">\n    <v-table :ajaxing=\"ajaxing.records\" :length=\"records\" _v-c35a7478=\"\">\n      <table class=\"table sortable\" _v-c35a7478=\"\">\n        <thead _v-c35a7478=\"\">\n          <tr _v-c35a7478=\"\">\n            <th _v-c35a7478=\"\">品牌名稱</th>\n            <th _v-c35a7478=\"\">場館名稱</th>\n            <th _v-c35a7478=\"\">核銷事件編號</th>\n            <th _v-c35a7478=\"\">核銷事件產生時間</th>\n            <th _v-c35a7478=\"\">核銷原因</th>\n            <th v-if=\"configureStates.isSeventeen\" _v-c35a7478=\"\">補充資料</th>\n            <th _v-c35a7478=\"\">訂單編號</th>\n            <th _v-c35a7478=\"\">訂單項目名稱</th>\n            <th _v-c35a7478=\"\">結帳時間</th>\n            <th _v-c35a7478=\"\">本次核銷前-待核銷金額</th>\n            <th _v-c35a7478=\"\">本次項目核銷金額</th>\n            <th _v-c35a7478=\"\">本次核銷後-待核銷金額</th>\n            <th _v-c35a7478=\"\">訂單關聯的第三方支付交易序號</th>\n          </tr>\n        </thead>\n        <tbody _v-c35a7478=\"\">\n          <tr v-for=\"r in records\" :key=\"r.id\" _v-c35a7478=\"\">\n              <td _v-c35a7478=\"\">{{ r.studioName }}</td>\n              <td _v-c35a7478=\"\">{{ r.branchName }}</td>\n              <td _v-c35a7478=\"\">{{ r.eventId }}</td>\n              <td _v-c35a7478=\"\">{{ r.eventTime }}</td>\n              <td _v-c35a7478=\"\">{{ r.verificationReason }}</td>\n              <td v-if=\"configureStates.isSeventeen\" _v-c35a7478=\"\">\n                  <a @click.prevent=\"showMore(r)\" _v-c35a7478=\"\"><i class=\"material-icons\" _v-c35a7478=\"\">open_in_full</i></a>\n              </td>\n              <td _v-c35a7478=\"\">{{ r.orderId }}</td>\n              <td _v-c35a7478=\"\">{{ r.orderDetailProductName }}</td>\n              <td _v-c35a7478=\"\">{{ r.checkoutAt }}</td>\n              <td _v-c35a7478=\"\">{{ r.beforeBalance }}</td>\n              <td _v-c35a7478=\"\">{{ r.verificationAmount }}</td>\n              <td _v-c35a7478=\"\">{{ r.afterBalance }}</td>\n              <td _v-c35a7478=\"\">{{ r.tradeNo }}</td>\n          </tr>\n        </tbody>\n      </table>\n    </v-table>\n  </div>\n\n    <v-modal id=\"more-modal\" no-footer=\"\" _v-c35a7478=\"\">\n        <h4 slot=\"title\" _v-c35a7478=\"\">補充資料</h4>\n        <div slot=\"body\" _v-c35a7478=\"\">\n            <div class=\"row\" _v-c35a7478=\"\">\n                <div class=\"col-sm-12\" _v-c35a7478=\"\">{{ more }}</div>\n            </div>\n        </div>\n    </v-modal>\n\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.endtime-modal-calendar[_v-c35a7478] {\n  right: 90px; }\n\n/* line 5, stdin */\n.time_span_duration[_v-c35a7478] {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-align: center;\n      align-items: center; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-c35a7478", module.exports)
  } else {
    hotAPI.update("_v-c35a7478", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/get-iterator":46,"babel-runtime/core-js/json/stringify":48,"babel-runtime/core-js/object/entries":54,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/defineProperty":65,"babel-runtime/helpers/extends":66,"babel-runtime/helpers/slicedToArray":70,"babel-runtime/regenerator":75,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1474:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

},{"vue":792}],1475:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        type: {
            type: String,
            required: true,
            validator: function validator(value) {
                return ['checkbox', 'radio'].includes(value);
            }
        },
        name: {
            type: [String, Number]
        },
        value: {
            type: [String, Boolean, Number, Object]
        },
        model: {},
        label: {
            type: String,
            default: ''
        },
        disabled: Boolean,
        inputClass: {
            type: Array
        }
    },
    data: function data() {
        return {
            inputId: ''
        };
    },

    computed: {
        vModel: {
            get: function get() {
                return this.model;
            },
            set: function set(value) {
                this.$emit('update:model', value);
            }
        },
        styleClass: function styleClass() {
            var style = ["st-cursor-pointer", "st-w-4 st-h-4 !st-m-0", "st-accent-neutral", "checked:st-accent-primary", "disabled:st-opacity-60"];
            return style.concat(this.inputClass);
        }
    },
    mounted: function mounted() {
        this.inputId = this.randomString();
    },

    methods: {
        randomString: function randomString() {
            var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 7;

            var possibleChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
            var text = "";

            for (var i = 0; i < length; i++) {
                text += possibleChars.charAt(Math.floor(Math.random() * possibleChars.length));
            }return text;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"st-flex st-items-center\">\n    <input :id=\"inputId\" :type=\"type\" :name=\"name\" :value=\"value\" v-model=\"vModel\" v-bind=\"$attrs\" :disabled=\"disabled\" :class=\"styleClass\">\n    <label :for=\"inputId\" class=\"st-mb-0 st-pl-2 st-text-16 st-font-regular\">\n        <slot name=\"label\">{{ label }}</slot>\n    </label>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-c76d21bc", module.exports)
  } else {
    hotAPI.update("_v-c76d21bc", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],1476:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        required: Boolean,
        error: Boolean,
        focused: Boolean,
        isInputSlot: Boolean,
        label: {
            type: String,
            default: ''
        },
        infoText: {
            type: String,
            default: ''
        },
        errorText: {
            type: String,
            default: ''
        }

    },
    data: function data() {
        return {};
    },

    computed: {
        inputBaseStyle: function inputBaseStyle() {
            var style = this.appendBasicStyle();
            style = this.appendErrorStyle(style);
            style = this.appendFocusedStyle(style);
            return style;
        }
    },
    mounted: function mounted() {},

    methods: {
        appendBasicStyle: function appendBasicStyle() {
            var isBold = this.focused || this.error;
            return ['st-transition', 'st-w-full', 'st-bg-white', 'st-border-solid', 'st-rounded-4', 'st-border', { 'st-border-neutral': !isBold }, { 'focus:st-outline-none st-p-3': this.isInputSlot }];
        },
        appendErrorStyle: function appendErrorStyle(arr) {
            var style = [{ 'st-ring-danger st-border-danger st-ring-1 st-ring-inset': this.error }, { 'focus:st-border-danger': this.isInputSlot && this.error }];
            return arr.concat(style);
        },
        appendFocusedStyle: function appendFocusedStyle(arr) {
            var style = [{ 'st-ring-secondary st-border-secondary st-ring-1 st-ring-inset': this.focused && !this.error }, { 'focus:st-border-secondary focus:st-ring-secondary focus:st-ring-1 focus:st-ring-inset': this.isInputSlot && !this.error }];
            return arr.concat(style);
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"st-max-w-full st-flex st-flex-1 st-flex-col\">\n    <slot name=\"label\">\n        <st-label :label=\"label\" :required=\"required\"></st-label>\n    </slot>\n\n    <slot name=\"input\" v-bind=\"{ inputBaseStyle }\"></slot>\n\n    <slot name=\"errorBlock\" v-if=\"error\">\n        <st-form-error-text :error-text=\"errorText\"></st-form-error-text>\n    </slot>\n    <slot name=\"infoBlock\" v-else=\"\">\n        <st-form-info-text :info-text=\"infoText\"></st-form-info-text>\n    </slot>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-98609412", module.exports)
  } else {
    hotAPI.update("_v-98609412", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],1477:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _stLabel = require('../form/st-label.vue');

var _stLabel2 = _interopRequireDefault(_stLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: { StLabel: _stLabel2.default },
    props: {
        required: Boolean,
        disabled: Boolean,
        allowEmpty: Boolean,
        ajaxing: {
            type: Boolean,
            default: false
        },
        mode: {
            type: String,
            required: true,
            description: 'single or multiple'
        },
        selectAll: {
            type: Boolean,
            default: false,
            description: 'mode=multiple 時，是否顯示 [選擇全部] 的 option'
        },
        maxHeight: {
            type: String,
            default: ''
        },
        label: {
            type: String
        },
        emptyText: {
            type: String,
            description: 'mode=multiple 時，必填'
        },
        options: {
            type: Array,
            default: function _default() {
                return [];
            }
            /*
            * 只有一層
                options:[
                    {text: item.name, value: item.id, selected: false},
                    {text: item.name, value: item.id, selected: false}
                ]
                 兩層
                options:[
                    {
                        category: 分類，
                        children: [
                            {text: item.name, value: item.id, selected: false},
                            {text: item.name, value: item.id, selected: false}
                        ]
                    },
                    {
                        category: 分類，
                        children: [
                            {text: item.name, value: item.id, selected: false},
                            {text: item.name, value: item.id, selected: false}
                        ]
                    },
                ]
                * */
        }
    },
    data: function data() {
        return {
            isOpen: false,
            checkAll: false,
            items: [],
            selectedValuesArr: []
        };
    },

    computed: {
        isMultiple: function isMultiple() {
            return this.mode === 'multiple';
        },
        isSingle: function isSingle() {
            return this.mode === 'single';
        },
        singleText: function singleText() {
            if (this.selectedValuesArr.length === 1) {
                var select = null;
                this.items.forEach(function (item) {
                    if (!select) {
                        if (item.children) {
                            select = item.children.find(function (child) {
                                return child.selected;
                            });
                        } else {
                            if (item.selected) {
                                select = item;
                            }
                        }
                    }
                });
                return select.text;
            } else {
                return this.emptyText;
            }
        },
        baseStyle: function baseStyle() {
            return ['st-inline-flex st-items-center st-justify-between', 'st-p-3', 'st-font-regular st-text-black', 'st-transition', 'st-w-full', 'st-border st-border-solid', 'st-rounded-4', { 'st-bg-white': !this.disabled }, { 'st-cursor-not-allowed st-bg-gray-20 st-text-gray-50': this.disabled }, { 'st-border-neutral': !this.isOpen }, { 'st-ring-secondary st-border-secondary st-ring-1 st-ring-inset': this.isOpen }];
        },
        optionsStyle: function optionsStyle() {
            var maxHeight = this.maxHeight ? 'st-max-h-[' + this.maxHeight + ']' : 'st-max-h-80';
            return ['st-w-full', maxHeight, 'st-bg-white', 'st-rounded-4', 'st-shadow-dropdown', 'st-overflow-auto'];
        },
        countSelectedItems: function countSelectedItems() {
            return this.selectedValuesArr.length || 0;
        }
    },
    watch: {
        options: {
            handler: function handler(newVal) {
                this.mountData();
            },

            deep: true
        }
    },
    mounted: function mounted() {
        this.mountData();
    },

    methods: {
        closeMenu: function closeMenu() {
            this.isOpen = false;
        },
        openMenu: function openMenu() {
            if (this.disabled || this.ajaxing) return;
            this.isOpen = true;
        },
        mountData: function mountData() {
            this.resetMenuItems();
            this.sortSelectedItem();
        },
        resetMenuItems: function resetMenuItems() {
            var data = this.options || [];
            this.items = _lodash2.default.cloneDeep(data);
        },
        actionSelect: function actionSelect(item) {
            var _this = this;

            return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                var newItems, idx, idxChildren;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!_this.isMultiple) {
                                    _context.next = 4;
                                    break;
                                }

                                _context.next = 3;
                                return _this.sortSelectedItem();

                            case 3:
                                _this.emitChange(item);

                            case 4:
                                if (_this.isSingle) {
                                    newItems = _lodash2.default.cloneDeep(_this.options);

                                    for (idx in newItems) {
                                        if (newItems[idx].children) {
                                            for (idxChildren in newItems[idx].children) {
                                                newItems[idx].children[idxChildren].selected = item.selected && item.value === newItems[idx].children[idxChildren].value;
                                            }
                                        } else {
                                            newItems[idx].selected = item.selected && item.value === newItems[idx].value;
                                        }
                                    }
                                    _this.selectedValuesArr = item.selected ? [item.value] : [];
                                    _this.items = newItems;
                                    _this.emitChange(item);
                                }

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        sortSelectedItem: function sortSelectedItem() {
            var result = [];
            this.items.forEach(function (item) {
                if (item.children) {
                    item.children.forEach(function (child) {
                        if (child.selected) {
                            result.push(child.value);
                        }
                    });
                } else {
                    if (item.selected) {
                        result.push(item.value);
                    }
                }
            });
            this.selectedValuesArr = result;
            this.checkAll = result.length === this.items.length;
        },
        actionSelectAll: function actionSelectAll(event) {
            var _this2 = this;

            var all = { text: '選擇全部', value: 'selectAll', selected: this.checkAll };
            var result = [];
            this.items.forEach(function (item) {
                if (item.children) {
                    item.children.forEach(function (child) {
                        child.selected = _this2.checkAll;
                        if (_this2.checkAll) {
                            result.push(child.value);
                        }
                    });
                } else {
                    item.selected = _this2.checkAll;
                    if (_this2.checkAll) {
                        result.push(item.value);
                    }
                }
            });
            this.selectedValuesArr = result;
            this.emitChange(all);
        },
        emitChange: function emitChange(itemObj) {
            var selectedValues = this.selectedValuesArr;
            if (this.isSingle) {
                selectedValues = this.selectedValuesArr.length ? this.selectedValuesArr[0] : '';
            }
            this.$emit('change', selectedValues, itemObj, this.items);
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"st-flex st-flex-1 st-flex-col\">\n    <div class=\"st-relative st-inline-block st-w-full st-cursor-pointer\" tabindex=\"0\" @focusout=\"closeMenu\">\n        <st-label :label=\"label\" :required=\"required\"></st-label>\n        <div @click=\"openMenu\" :class=\"baseStyle\">\n            <div v-if=\"isMultiple\" class=\"st-flex st-w-11/12\">\n                <div class=\"st-truncate\">{{ emptyText }}</div>\n                <span v-show=\"countSelectedItems\" class=\"st-ml-1 st-whitespace-nowrap\">( {{ countSelectedItems }} )</span>\n            </div>\n            <div v-if=\"isSingle\">\n                {{ singleText }}\n            </div>\n\n            <img v-if=\"ajaxing\" src=\"/images/loading-small.svg\" class=\"st-animate-spin st-w-4 st-h-4\" alt=\"loading...\">\n            <span v-else=\"\" class=\"material-icons st-text-20\" :class=\"[{'st-text-gray-90':disabled},{'st-text-black':!disabled}]\">arrow_drop_down</span>\n        </div>\n\n        <div v-if=\"isOpen\" @click=\"closeMenu\" class=\"st-fixed st-inset-0\" tabindex=\"-1\"></div>\n\n        <transition enter-class=\"st-opacity-0 st-transform st-scale-90 st-transition-all\" enter-active-class=\"st-transition st-ease-out st-duration-75\" enter-to-class=\"st-opacity-100 st-transform st-scale-100\" leave-class=\"st-opacity-100 st-transform st-scale-100\" leave-active-class=\"st-transition st-ease-in st-duration-75\" leave-to-class=\"st-opacity-0 st-transform st-scale-90\">\n\n            <div v-if=\"isOpen\" class=\"st-absolute st-w-full st-right-0 st-text-left st-z-[100] st-mt-2 st-transform st-origin-top-right\">\n                <div :class=\"optionsStyle\">\n                    <div class=\"st-border-t-2 st-border-gray-200 st-py-1\">\n                        <label v-if=\"selectAll\" class=\"st-flex st-justify-between st-text-16 st-leading-md st-px-3 st-py-2 st-mb-0 st-border-0 st-border-solid st-border-b st-border-black/[.06] hover:st-bg-black/[.03]\" :class=\"{'st-bg-black/[.06]': checkAll}\">\n                            <input type=\"checkbox\" v-model=\"checkAll\" @change=\"actionSelectAll\" class=\"st-hidden\">\n                            <span>選擇全部</span>\n                            <span class=\"material-icons st-text-success\" v-show=\"checkAll\">done</span>\n                        </label>\n\n                        <div v-for=\"item in items\">\n                            <label v-if=\"!item.hasOwnProperty('children')\" class=\"st-flex st-justify-between st-text-16 st-leading-md st-px-3 st-py-2 st-mb-0 hover:st-bg-black/[.03]\" :class=\"{'st-bg-black/[.06]': item.selected}\">\n                                <input type=\"checkbox\" v-model=\"item.selected\" @change=\"actionSelect(item)\" class=\"st-hidden\">\n                                <span class=\"st-inline-flex st-items-center\">\n                                    <span v-if=\"item.icon\" class=\"material-icons st-mr-1\">{{ item.icon }}</span>\n                                    <span v-if=\"item.prefix\" class=\"st-mr-1\">{{ item.prefix }}</span>\n                                    <span>{{ item.text }}</span>\n                                </span>\n                                <span class=\"material-icons st-text-success\" v-show=\"item.selected\">done</span>\n                            </label>\n\n                            <div v-else=\"\">\n                                <div class=\"st-text-gray-90 st-text-14 st-px-3 st-py-2 st-cursor-default\">{{ item.category }}</div>\n                                <label v-for=\"child in item.children\" class=\"st-flex st-justify-between st-text-16 st-leading-md st-px-3 st-py-2 st-mb-0 hover:st-bg-black/[.03]\" :class=\"{'st-bg-black/[.06]': child.selected}\">\n                                    <input type=\"checkbox\" v-model=\"child.selected\" @change=\"actionSelect(child)\" class=\"st-hidden\">\n                                    <span class=\"st-inline-flex st-items-center\">\n                                        <span v-if=\"child.icon\" class=\"material-icons st-mr-1\">{{ child.icon }}</span>\n                                        <span v-if=\"child.prefix\" class=\"st-mr-1\">{{ child.prefix }}</span>\n                                        <span class=\"material-icons\">{{ child.text }}</span>\n                                    </span>\n                                    <span class=\"material-icons st-text-success\" v-show=\"child.selected\">done</span>\n                                </label>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n        </transition>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-136c7b9f", module.exports)
  } else {
    hotAPI.update("_v-136c7b9f", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"../form/st-label.vue":1485,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/regenerator":75,"lodash":717,"vue":792,"vue-hot-reload-api":785}],1478:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stBaseChecker = require('../base/st-base-checker.vue');

var _stBaseChecker2 = _interopRequireDefault(_stBaseChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: { StBaseChecker: _stBaseChecker2.default },
    props: {
        name: {
            type: [String, Number]
        },
        value: {
            type: [String, Boolean, Number, Object]
        },
        model: {},
        label: {
            type: String,
            default: ''
        },
        disabled: Boolean,
        inputClass: {
            type: Array,
            default: function _default() {
                return [];
            }
        }
    },
    data: function data() {
        return {};
    },

    computed: {
        vModel: {
            get: function get() {
                return this.model;
            },
            set: function set(value) {
                this.$emit('update:model', value);
            }
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<st-base-checker type=\"checkbox\" :model.sync=\"vModel\" :name=\"name\" :label=\"label\" :value=\"value\" :disabled=\"disabled\" :input-class=\"inputClass\" v-bind=\"$attrs\">\n    <template slot=\"label\">\n        <slot name=\"label\"></slot>\n    </template>\n</st-base-checker>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-02ce2d9f", module.exports)
  } else {
    hotAPI.update("_v-02ce2d9f", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"../base/st-base-checker.vue":1475,"vue":792,"vue-hot-reload-api":785}],1479:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _stBaseInput = require('../base/st-base-input.vue');

var _stBaseInput2 = _interopRequireDefault(_stBaseInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: { StBaseInput: _stBaseInput2.default },
    props: {
        required: Boolean,
        initEditorData: {
            type: String,
            description: 'default content from database'
        },
        label: {
            type: String,
            default: ''
        },
        inputClass: {
            type: Array,
            default: function _default() {
                return [];
            },
            description: 'Input css class'
        }
    },
    data: function data() {
        return {};
    },

    computed: {
        listeners: function listeners() {
            return (0, _extends3.default)({}, this.$listeners);
        }
    },
    mounted: function mounted() {},

    methods: {
        inputSlotData: function inputSlotData(_ref) {
            var inputBaseStyle = _ref.inputBaseStyle;

            return (0, _extends3.default)({
                inputClass: inputBaseStyle.concat(this.inputClass)
            }, this.listeners);
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<st-base-input :required=\"required\" :label=\"label\" :is-input-slot=\"$scopedSlots.input?true:false\" v-bind=\"$attrs\">\n    <template slot=\"label\">\n        <slot name=\"label\"></slot>\n    </template>\n    <template slot=\"input\" slot-scope=\"{ inputBaseStyle }\">\n        <slot name=\"input\" v-bind=\"inputSlotData({ inputBaseStyle })\">\n            <ck-editor :init-editor-data=\"initEditorData\" v-on=\"listeners\" v-bind=\"$attrs\"></ck-editor>\n        </slot>\n    </template>\n    <template slot=\"errorBlock\">\n        <slot name=\"errorBlock\"></slot>\n    </template>\n    <template slot=\"infoBlock\">\n        <slot name=\"errorBlock\"></slot>\n    </template>\n</st-base-input>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-eabaf874", module.exports)
  } else {
    hotAPI.update("_v-eabaf874", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"../base/st-base-input.vue":1476,"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785}],1480:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        required: Boolean,
        errorText: {
            type: String,
            default: ''
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div v-if=\"errorText\" class=\"st-text-14 st-text-danger\">\n    {{ errorText }}\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-3646764f", module.exports)
  } else {
    hotAPI.update("_v-3646764f", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],1481:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        label: {
            type: String,
            default: ''
        },
        infoText: {
            type: String,
            default: ''
        },
        errorText: {
            type: String,
            default: ''
        }
    },
    data: function data() {
        return {
            messageTextClasses: []
        };
    },
    created: function created() {},
    mounted: function mounted() {},

    computed: {
        groupId: function groupId() {
            return 'form-group-' + this.randomString();
        }
    },
    methods: {
        randomString: function randomString() {
            var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 7;

            var possibleChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
            var text = "";

            for (var i = 0; i < length; i++) {
                text += possibleChars.charAt(Math.floor(Math.random() * possibleChars.length));
            }return text;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"st-relative\">\n    <st-label :label=\"label\">\n        <slot name=\"label\"></slot>\n    </st-label>\n\n    <div class=\"st-flex st-items-center\" :ref=\"this.groupId+'-content'\">\n        <slot></slot>\n    </div>\n\n    <slot name=\"errorBlock\">\n        <st-form-error-text :error-text=\"errorText\" :class=\"messageTextClasses\"></st-form-error-text>\n    </slot>\n\n    <slot name=\"infoBlock\">\n        <st-form-info-text :info-text=\"infoText\" :class=\"messageTextClasses\"></st-form-info-text>\n    </slot>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-77e7f392", module.exports)
  } else {
    hotAPI.update("_v-77e7f392", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],1482:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        required: Boolean,
        infoText: {
            type: String,
            default: ''
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div v-if=\"infoText\" class=\"st-text-14 st-text-gray-90\">\n    {{ infoText }}\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-79a447ff", module.exports)
  } else {
    hotAPI.update("_v-79a447ff", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],1483:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        required: Boolean,
        level: {
            type: Number,
            default: 1
        }
    },
    data: function data() {
        return {};
    },

    computed: {
        dynamicClasses: function dynamicClasses() {
            var levelMF = 2 * (this.level - 1);
            this.$parent.$data.messageTextClasses = ["st-ml-" + (levelMF + 3)];
            return ["st-ml-" + levelMF];
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"level-mark st-w-1 st-h-10 st-bg-gray-40 st-mr-2\" :class=\"dynamicClasses\" ref=\"levelMark\"></div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-255189f3", module.exports)
  } else {
    hotAPI.update("_v-255189f3", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],1484:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _stBaseInput = require('../base/st-base-input.vue');

var _stBaseInput2 = _interopRequireDefault(_stBaseInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: { StBaseInput: _stBaseInput2.default },
    props: {
        required: Boolean,
        error: Boolean,
        label: {
            type: String,
            default: ''
        },
        infoText: {
            type: String,
            default: ''
        },
        errorText: {
            type: String,
            default: ''
        },
        inputClass: {
            type: Array,
            default: function _default() {
                return [];
            },
            description: 'Input css class'
        },
        iconClass: {
            type: Array,
            default: function _default() {
                return [];
            },
            description: 'Icon css class'
        },
        icon: {
            type: String,
            default: '',
            description: 'Material icon name'
        },
        iconDirection: {
            type: String,
            default: 'right',
            validator: function validator(value) {
                return ['left', 'right'].includes(value);
            },

            description: 'Icon place left or right to input'
        }
    },
    data: function data() {
        return {
            focused: false
        };
    },

    computed: {
        listeners: function listeners() {
            return (0, _extends3.default)({}, this.$listeners, {
                input: this.updateValue,
                focus: this.onFocus,
                blur: this.onBlur
            });
        }
    },
    mounted: function mounted() {},

    methods: {
        inputSlotData: function inputSlotData(_ref) {
            var inputBaseStyle = _ref.inputBaseStyle;

            return (0, _extends3.default)({
                focused: this.focused,
                inputClass: inputBaseStyle.concat(this.inputClass)
            }, this.listeners);
        },
        inputStyle: function inputStyle(base) {
            var style = [];
            if (this.icon || this.$slots.icon) {
                style.push('st-flex st-items-center');
                if (this.iconDirection == 'left') {
                    style.push('st-pl-2');
                } else if (this.iconDirection == 'right') {
                    style.push('st-pr-2 st-flex-row-reverse');
                }
            }
            return style.concat(base);
        },
        updateValue: function updateValue(event) {
            var value = event.target.value;
            this.$emit('input', value);
        },
        onFocus: function onFocus(value) {
            this.focused = true;
            this.$emit('focus', value);
        },
        onBlur: function onBlur(value) {
            this.focused = false;
            this.$emit('blur', value);
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<st-base-input :required=\"required\" :label=\"label\" :error=\"error\" :error-text=\"errorText\" :info-text=\"infoText\" :focused=\"focused\" :is-input-slot=\"$scopedSlots.input?true:false\" v-bind=\"$attrs\">\n    <template slot=\"label\">\n        <slot name=\"label\"></slot>\n    </template>\n    <template slot=\"input\" slot-scope=\"{ inputBaseStyle }\">\n        <slot name=\"input\" v-bind=\"inputSlotData({ inputBaseStyle })\">\n            <div :class=\"inputStyle(inputBaseStyle)\">\n                <slot name=\"icon\">\n                    <span class=\"material-icons\" :class=\"iconClass\" v-if=\"icon\">\n                        {{ icon }}\n                    </span>\n                </slot>\n                <input v-on=\"listeners\" v-bind=\"$attrs\" class=\"st-mb-0 st-text-black st-p-3 st-w-full st-border-none st-bg-transparent focus:st-border-none focus:st-outline-none disabled:st-cursor-not-allowed\">\n            </div>\n        </slot>\n    </template>\n    <template slot=\"errorBlock\">\n        <slot name=\"errorBlock\"></slot>\n    </template>\n    <template slot=\"infoBlock\">\n        <slot name=\"infoBlock\"></slot>\n    </template>\n</st-base-input>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-2f23731e", module.exports)
  } else {
    hotAPI.update("_v-2f23731e", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"../base/st-base-input.vue":1476,"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785}],1485:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        required: Boolean,
        label: {
            type: String,
            default: ''
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div>\n    <label v-if=\"label\" class=\"st-text-16 st-font-regular st-text-black st-mb-1\">\n        {{ label }}<span v-if=\"required\" class=\"st-text-danger\">*</span>\n    </label>\n    <slot></slot>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-b5a81570", module.exports)
  } else {
    hotAPI.update("_v-b5a81570", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],1486:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _stBaseSelect = require('../base/st-base-select.vue');

var _stBaseSelect2 = _interopRequireDefault(_stBaseSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: { StBaseSelect: _stBaseSelect2.default },
    props: {
        ajaxing: {
            type: Boolean,
            default: false
        },
        emptyText: {
            type: String,
            required: true
        },
        options: {
            type: Array
        }
    },
    data: function data() {
        return {};
    },

    computed: {
        listeners: function listeners() {
            return (0, _extends3.default)({}, this.$listeners);
        }
    },
    watch: {},
    mounted: function mounted() {},

    methods: {}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<st-base-select :empty-text=\"emptyText\" :options=\"options\" mode=\"multiple\" :ajaxing=\"ajaxing\" v-on=\"listeners\" v-bind=\"$attrs\"></st-base-select>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-1ea5c82d", module.exports)
  } else {
    hotAPI.update("_v-1ea5c82d", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"../base/st-base-select.vue":1477,"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785}],1487:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stBaseChecker = require('../base/st-base-checker.vue');

var _stBaseChecker2 = _interopRequireDefault(_stBaseChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: { StBaseChecker: _stBaseChecker2.default },
    props: {
        name: {
            type: [String, Number],
            required: true
        },
        value: {
            type: [String, Boolean, Number, Object],
            required: true
        },
        model: {},
        label: {
            type: String,
            default: ''
        },
        disabled: Boolean,
        inputClass: {
            type: Array,
            default: function _default() {
                return [];
            }
        }
    },
    data: function data() {
        return {};
    },

    computed: {
        vModel: {
            get: function get() {
                return this.model;
            },
            set: function set(value) {
                this.$emit('update:model', value);
            }
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<st-base-checker type=\"radio\" :model.sync=\"vModel\" :name=\"name\" :label=\"label\" :value=\"value\" :disabled=\"disabled\" :input-class=\"inputClass\" v-bind=\"$attrs\">\n    <template slot=\"label\">\n        <slot name=\"label\"></slot>\n    </template>\n</st-base-checker>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-e0dea262", module.exports)
  } else {
    hotAPI.update("_v-e0dea262", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"../base/st-base-checker.vue":1475,"vue":792,"vue-hot-reload-api":785}],1488:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _stBaseSelect = require('../base/st-base-select.vue');

var _stBaseSelect2 = _interopRequireDefault(_stBaseSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: { StBaseSelect: _stBaseSelect2.default },
    props: {
        ajaxing: {
            type: Boolean,
            default: false
        },
        emptyText: {
            type: String,
            default: '請選擇'
        },
        options: {
            type: Array
        }
    },
    data: function data() {
        return {};
    },

    computed: {
        listeners: function listeners() {
            return (0, _extends3.default)({}, this.$listeners);
        }
    },
    watch: {},
    mounted: function mounted() {},

    methods: {}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<st-base-select :empty-text=\"emptyText\" :options=\"options\" mode=\"single\" :ajaxing=\"ajaxing\" v-on=\"listeners\" v-bind=\"$attrs\"></st-base-select>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-617cd5f5", module.exports)
  } else {
    hotAPI.update("_v-617cd5f5", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"../base/st-base-select.vue":1477,"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785}],1489:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _stBaseInput = require('../base/st-base-input.vue');

var _stBaseInput2 = _interopRequireDefault(_stBaseInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: { StBaseInput: _stBaseInput2.default },
    props: {
        required: Boolean,
        error: Boolean,
        resize: Boolean,
        label: {
            type: String,
            default: ''
        },
        infoText: {
            type: String,
            default: ''
        },
        errorText: {
            type: String,
            default: ''
        },
        inputClass: {
            type: Array,
            default: function _default() {
                return [];
            },
            descirption: 'Input css class'
        }
    },
    data: function data() {
        return {
            focused: false
        };
    },

    computed: {
        listeners: function listeners() {
            return (0, _extends3.default)({}, this.$listeners, {
                input: this.updateValue,
                focus: this.onFocus,
                blur: this.onBlur
            });
        }
    },
    mounted: function mounted() {},

    methods: {
        inputSlotData: function inputSlotData(data) {
            return (0, _extends3.default)({
                focused: this.focused,
                inputClass: data.inputClass
            }, this.listeners);
        },
        inputStyle: function inputStyle(base) {
            var style = [];
            return style.concat(base);
        },
        updateValue: function updateValue(event) {
            var value = event.target.value;
            this.$emit('input', value);
        },
        onFocus: function onFocus(value) {
            this.focused = true;
            this.$emit('focus', value);
        },
        onBlur: function onBlur(value) {
            this.focused = false;
            this.$emit('blur', value);
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<st-base-input :required=\"required\" :label=\"label\" :error=\"error\" :error-text=\"errorText\" :info-text=\"infoText\" :focused=\"focused\" v-bind=\"$attrs\">\n    <template slot=\"label\">\n        <slot name=\"label\"></slot>\n    </template>\n    <template slot=\"input\" slot-scope=\"{ inputBaseStyle }\">\n        <slot name=\"input\" v-bind=\"inputSlotData(inputBaseStyle)\">\n            <div :class=\"inputStyle(inputBaseStyle)\">\n                <textarea v-on=\"listeners\" v-bind=\"$attrs\" class=\"st-p-3 st-w-full st-mb-0 st-border-none st-bg-transparent focus:st-border-none focus:st-outline-none disabled:st-cursor-not-allowed\" :class=\"[{'st-resize-none': !resize}, {'st-resize-y': resize}]\"></textarea>\n            </div>\n        </slot>\n    </template>\n    <template slot=\"errorBlock\">\n        <slot name=\"errorBlock\"></slot>\n    </template>\n    <template slot=\"infoBlock\">\n        <slot name=\"errorBlock\"></slot>\n    </template>\n</st-base-input>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-23a394d4", module.exports)
  } else {
    hotAPI.update("_v-23a394d4", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"../base/st-base-input.vue":1476,"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785}],1490:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _stLabel = require('./form/st-label.vue');

var _stLabel2 = _interopRequireDefault(_stLabel);

var _stInput = require('./form/st-input.vue');

var _stInput2 = _interopRequireDefault(_stInput);

var _stTextarea = require('./form/st-textarea.vue');

var _stTextarea2 = _interopRequireDefault(_stTextarea);

var _stRadio = require('./form/st-radio.vue');

var _stRadio2 = _interopRequireDefault(_stRadio);

var _stCheckbox = require('./form/st-checkbox.vue');

var _stCheckbox2 = _interopRequireDefault(_stCheckbox);

var _stMultipleSelect = require('./form/st-multiple-select.vue');

var _stMultipleSelect2 = _interopRequireDefault(_stMultipleSelect);

var _stSingleSelect = require('./form/st-single-select.vue');

var _stSingleSelect2 = _interopRequireDefault(_stSingleSelect);

var _stCkEditor = require('./form/st-ck-editor.vue');

var _stCkEditor2 = _interopRequireDefault(_stCkEditor);

var _stFormGroup = require('./form/st-form-group.vue');

var _stFormGroup2 = _interopRequireDefault(_stFormGroup);

var _stFormLevelMark = require('./form/st-form-level-mark.vue');

var _stFormLevelMark2 = _interopRequireDefault(_stFormLevelMark);

var _stFormErrorText = require('./form/st-form-error-text.vue');

var _stFormErrorText2 = _interopRequireDefault(_stFormErrorText);

var _stFormInfoText = require('./form/st-form-info-text.vue');

var _stFormInfoText2 = _interopRequireDefault(_stFormInfoText);

var _stButton = require('./st-button.vue');

var _stButton2 = _interopRequireDefault(_stButton);

var _stToolbar = require('./st-toolbar.vue');

var _stToolbar2 = _interopRequireDefault(_stToolbar);

var _stActionBar = require('./st-action-bar.vue');

var _stActionBar2 = _interopRequireDefault(_stActionBar);

var _stMediaAlbumGroupGrid = require('./st-media-album-group-grid.vue');

var _stMediaAlbumGroupGrid2 = _interopRequireDefault(_stMediaAlbumGroupGrid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('st-form-error-text', _stFormErrorText2.default);
_vue2.default.component('st-form-info-text', _stFormInfoText2.default);
_vue2.default.component('st-label', _stLabel2.default);
_vue2.default.component('st-button', _stButton2.default);
_vue2.default.component('st-input', _stInput2.default);
_vue2.default.component('st-textarea', _stTextarea2.default);
_vue2.default.component('st-radio', _stRadio2.default);
_vue2.default.component('st-checkbox', _stCheckbox2.default);
_vue2.default.component('st-action-bar', _stActionBar2.default);
_vue2.default.component('st-toolbar', _stToolbar2.default);
_vue2.default.component('st-multiple-select', _stMultipleSelect2.default);
_vue2.default.component('st-single-select', _stSingleSelect2.default);
_vue2.default.component('st-ck-editor', _stCkEditor2.default);
_vue2.default.component('st-form-group', _stFormGroup2.default);
_vue2.default.component('st-form-level-mark', _stFormLevelMark2.default);
_vue2.default.component('st-media-album-group-grid', _stMediaAlbumGroupGrid2.default);

},{"./form/st-checkbox.vue":1478,"./form/st-ck-editor.vue":1479,"./form/st-form-error-text.vue":1480,"./form/st-form-group.vue":1481,"./form/st-form-info-text.vue":1482,"./form/st-form-level-mark.vue":1483,"./form/st-input.vue":1484,"./form/st-label.vue":1485,"./form/st-multiple-select.vue":1486,"./form/st-radio.vue":1487,"./form/st-single-select.vue":1488,"./form/st-textarea.vue":1489,"./st-action-bar.vue":1491,"./st-button.vue":1492,"./st-media-album-group-grid.vue":1493,"./st-toolbar.vue":1494,"vue":792}],1491:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        confirmText: {
            type: String,
            default: '確認'
        },
        cancelText: {
            type: String,
            default: '取消'
        },
        disabledConfirm: Boolean,
        disabledCancel: Boolean
    },
    data: function data() {
        return {
            isHideNavBar: false
        };
    },
    mounted: function mounted() {
        this.adjustFunctionBar();
    },

    computed: {
        outlineStyle: function outlineStyle() {
            return ["st-bg-white", "st-space-x-2 st-px-4", "st-fixed st-z-10", "st-h-20 st-bottom-0 st-left-0 st-right-0", "st-border-solid st-border-0 st-border-t st-border-gray-40", "st-flex st-items-center st-justify-end", { "md:st-left-[171px]": !this.isHideNavBar }];
        }
    },
    methods: {
        adjustFunctionBar: function adjustFunctionBar() {
            var _this = this;

            if (!$('.side-nav')[0]) {
                this.isHideNavBar = true;return;
            }
            var resizeObserver = new ResizeObserver(function () {
                _this.isHideNavBar = $('.side-nav').hasClass("hide-side-nav-pc");
            });
            resizeObserver.observe($('.side-nav')[0]);
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"bottom-function\" :class=\"outlineStyle\">\n    <slot name=\"options\"></slot>\n    <slot name=\"cancel\">\n        <st-button primary=\"\" ghost=\"\" :disabled=\"disabledCancel\" @click.prevent=\"$emit('cancel')\">{{ cancelText }}</st-button>\n    </slot>\n    <slot name=\"confirm\">\n        <st-button primary=\"\" filled=\"\" :disabled=\"disabledConfirm\" @click.prevent=\"$emit('confirm')\">{{ confirmText }}</st-button>\n    </slot>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-6ed3d83d", module.exports)
  } else {
    hotAPI.update("_v-6ed3d83d", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],1492:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        //type (main-color)
        primary: Boolean,
        secondary: Boolean,
        neutral: Boolean,
        black: Boolean,
        success: Boolean,
        warning: Boolean,
        danger: Boolean,
        info: Boolean,
        //variant
        filled: Boolean,
        outline: Boolean,
        ghost: Boolean,
        //size
        small: Boolean,
        normal: Boolean,
        large: Boolean,
        full: Boolean,
        icon: Boolean,
        text: {
            type: String,
            default: ''
        },
        leftIcon: {
            type: String,
            default: ''
        },
        rightIcon: {
            type: String,
            default: ''
        },
        disabled: {
            type: false,
            default: false
        },
        btnClass: {
            type: Array,
            default: function _default() {
                return [];
            },
            description: 'Button css classes'
        },
        loading: Boolean
    },
    data: function data() {
        return {
            basicStyle: [],
            typeStyle: [],
            sizeStyle: []
        };
    },
    mounted: function mounted() {
        this.init();
    },

    watch: {
        disabled: function disabled() {
            this.init();
        }
    },
    computed: {
        variant: function variant() {
            var _this = this;

            var values = ['filled', 'outline', 'ghost'];
            return values.find(function (element) {
                return _this[element];
            }) || 'filled';
        },
        size: function size() {
            var _this2 = this;

            var values = ['small', 'normal', 'large', 'full', 'icon'];
            return values.find(function (element) {
                return _this2[element];
            }) || 'normal';
        },
        type: function type() {
            var _this3 = this;

            var values = ['primary', 'secondary', 'neutral', 'black', 'success', 'warning', 'danger', 'info'];
            return values.find(function (element) {
                return _this3[element];
            }) || 'primary';
        },
        classes: function classes() {
            return this.basicStyle.concat(this.btnClass, this.typeStyle, this.sizeStyle);
        },
        loadingImg: function loadingImg() {
            if (this.variant == 'filled' || this.variant == 'ghost') {
                return '/images/default/loading-small-white.svg';
            } else {
                return '/images/default/loading-small-brand.svg';
            }
        }
    },
    methods: {
        init: function init() {
            this.appendBasicStyle();
            this.appendStyleByType();
            this.appendStyleBySize();
        },
        kebabCase: function kebabCase() {
            var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

            return string.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, '-').toLowerCase();
        },
        handleClick: function handleClick(event) {
            this.$emit("click", event);
        },
        handleHover: function handleHover(event) {
            this.$emit("hover", event);
        },
        appendBasicStyle: function appendBasicStyle() {
            var style = ['st-transition', 'st-rounded-4', 'st-flex', 'st-items-center', 'st-justify-center', 'st-gap-x-1'];
            this.basicStyle = style;
        },
        appendStyleBySize: function appendStyleBySize() {
            var style = [];
            switch (this.size) {
                case 'small':
                    style = ['st-px-3', 'st-py-1', 'st-text-16'];
                    break;
                case 'large':
                    style = ['st-px-6', 'st-py-3.5', 'st-text-20'];
                    break;
                case 'full':
                    style = ['st-py-2', 'st-w-full', 'st-text-16'];
                    break;
                case 'icon':
                    style = ['st-p-2', 'st-text-16'];
                    break;
                default:
                    //normal
                    style = ['st-px-4', 'st-py-2', 'st-text-16'];
            }
            this.sizeStyle = style;
        },
        appendStyleByType: function appendStyleByType() {
            var style = [];
            if (this.type == 'neutral') {
                style = ['st-bg-white', 'st-text-black', 'st-border-solid st-border', 'st-border-neutral', { 'hover:st-bg-black/5 hover:st-grayscale-[20%]': !this.disabled }, { 'st-opacity-50': this.disabled }];
            } else {
                var type = this.kebabCase(this.type);
                switch (this.variant) {
                    case 'ghost':
                        style = ['st-border-none', 'st-bg-transparent', 'st-text-' + type, { 'hover:st-opacity-70': !this.disabled }, { 'st-opacity-60': this.disabled }];
                        break;
                    case 'outline':
                        style = ['st-bg-white', 'st-text-' + type, 'st-border-' + type, 'st-border-solid st-border', { 'hover:st-bg-black/5 hover:st-grayscale-[20%]': !this.disabled }, { 'st-opacity-50': this.disabled }];
                        break;
                    default:
                        // filled
                        style = ['st-bg-' + type, 'st-text-white', 'st-border-' + type, 'st-border-solid st-border', { 'hover:st-opacity-90': !this.disabled }, { 'st-opacity-60': this.disabled }];
                }
            }
            this.typeStyle = style;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<button type=\"button\" :class=\"classes\" :disabled=\"disabled\" @click.prevent=\"handleClick\" @mouseover.prevent=\"handleHover\" _v-03924cf3=\"\">\n    <div :class=\"{'st-absolute': true, 'st-opacity-0': !loading}\" _v-03924cf3=\"\">\n        <img :src=\"loadingImg\" class=\"st-animate-spin\" _v-03924cf3=\"\">\n    </div>\n    <div :class=\"{'st-opacity-0': loading}\" class=\"st-flex st-items-center\" _v-03924cf3=\"\">\n        <slot name=\"addonLeft\" _v-03924cf3=\"\">\n            <span class=\"material-icons st-text-16\" v-if=\"leftIcon\" _v-03924cf3=\"\">{{ leftIcon }}</span>\n        </slot>\n        <slot _v-03924cf3=\"\">\n            {{text}}\n        </slot>\n        <slot name=\"addonRight\" _v-03924cf3=\"\">\n            <span class=\"material-icons st-text-16\" v-if=\"rightIcon\" _v-03924cf3=\"\">{{ rightIcon }}</span>\n        </slot>\n    </div>\n</button>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-03924cf3", module.exports)
  } else {
    hotAPI.update("_v-03924cf3", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],1493:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        imgObj: {
            type: Object,
            required: true
            // description: {
            //     "file_sort_number": 0,//0為第一張=設為主要圖片
            //     "default_mata_type": "Image16x9",
            //     "album_id": 146,//0為新增相簿//大於0則代表DB 相簿id
            //     "album_item_id": 0,//0為新增照片//大於0則代表DB 相片id
            //     "file_name": "a6b43e2d0db277ca6b1f6b91c06fd6840313877e4d6438b6a2f813d6f758d4ba.jpg",//媒體庫api取得
            //     "folder": "http://17fit-test.s3-website-ap-northeast-1.amazonaws.com/studio_media/286/",//媒體庫api取得
            //     "s3_url": "http://17fit-test.s3-website-ap-northeast-1.amazonaws.com/studio_media/286/xxx.jpg",//媒體庫api取得
            //     "image": "data:image/png;base64,xxxx"//若有裁切，裁切後的base64
            // },
        },
        showBorderColor: {
            type: Boolean,
            default: false
        },
        clickSetMainCallback: {
            type: Function
        },
        clickRemoveCallback: {
            type: Function
        }
    },
    data: function data() {
        return {};
    },

    computed: {
        showFunctionMenu: function showFunctionMenu() {
            return this.clickRemoveCallback || this.clickSetMainCallback;
        },
        containerClass: function containerClass() {
            var classes = [];
            var border = ['st-ring-secondary st-border-secondary st-ring-1 st-ring-inset'];

            if (this.showBorderColor) classes = classes.concat(border);

            return classes;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"st-relative st-bg-white st-rounded-4 st-border-solid st-border st-border-gray-40\" :class=\"containerClass\" _v-56371c08=\"\">\n    <div class=\"st-text-right st-relative\" v-if=\"showFunctionMenu\" _v-56371c08=\"\">\n        <st-button icon=\"\" ghost=\"\" left-icon=\"more_horiz\" class=\"dropdown-toggle st-float-right\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" _v-56371c08=\"\"></st-button>\n        <ul class=\"dropdown-menu st-top-8 st-left-inherit st-right-0\" style=\"left: inherit;\" _v-56371c08=\"\">\n            <li v-if=\"clickSetMainCallback\" _v-56371c08=\"\"><a class=\"!st-px-4 !st-py-2 st-text-16\" @click.prevent=\"clickSetMainCallback(imgObj)\" _v-56371c08=\"\">設為主要</a></li>\n            <li v-if=\"clickRemoveCallback\" _v-56371c08=\"\"><a class=\"!st-px-4 !st-py-2 st-text-16\" @click.prevent=\"clickRemoveCallback(imgObj)\" _v-56371c08=\"\">刪除</a></li>\n        </ul>\n    </div>\n    <img class=\"st-h-auto st-max-w-full st-px-2 st-pb-2\" alt=\"特色圖\" :class=\"{'st-pt-2':!showFunctionMenu}\" :src=\"imgObj.image ? imgObj.image : imgObj.s3_url\" _v-56371c08=\"\">\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-56371c08", module.exports)
  } else {
    hotAPI.update("_v-56371c08", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],1494:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        actionBack: Boolean,
        actionFilter: Boolean,
        barHidden: Boolean,
        title: {
            Type: String
        }
    },
    data: function data() {
        return {
            containerCss: [],
            extraTopHeight: 0, //算高度來拉滿 filter 的高
            showFilter: false
        };
    },
    updated: function updated() {
        var headerH = document.getElementById("admin-header").clientHeight;
        var alertH = document.getElementById("system-alert") ? document.getElementById("system-alert").clientHeight : 0;
        var tabH = document.getElementById("top-tabs") ? document.getElementById("top-tabs").clientHeight : 0;
        this.extraTopHeight = headerH + alertH + tabH;
    },

    watch: {
        showFilter: function showFilter(n) {
            var h = "st-h-[calc(100vh-" + (this.extraTopHeight + 'px') + ")]";
            if (n) {
                this.containerCss.push(h);
            } else {
                this.containerCss = _lodash2.default.remove(this.containerCss, h);
            }
        }
    },
    methods: {
        toggleFilter: function toggleFilter() {
            this.showFilter = !this.showFilter;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"st--mt-2 md:st--ml-2 st-relative\" :class=\"containerCss\">\n    <div class=\"st-flex st-h-full st-flex-col\">\n        <div id=\"top-tool-bar\" class=\"st-shrink-0 st-bg-gray-20\" v-show=\"!barHidden\">\n            <div class=\"st-flex st-border-0 st-border-b st-border-gray-40 st-border-solid st-px-2 st-py-1\">\n                <div class=\"st-grow st-flex st-items-center st-space-x-2\">\n                <span v-if=\"actionBack\" class=\"material-icons st-text-20 st-text-primary st-cursor-pointer\" @click.prevent=\"$emit('back')\">\n                    arrow_back\n                </span>\n                    <st-button neutral=\"\" icon=\"\" left-icon=\"filter_alt\" v-if=\"actionFilter\" @click.prevent.stop=\"toggleFilter\">\n                    </st-button>\n                    <slot name=\"select-tool\"></slot>\n                </div>\n                <slot name=\"buttons-tool\"></slot>\n            </div>\n        </div>\n        <div class=\"st-flex st-flex-1 st-h-full\">\n            <div v-show=\"showFilter\" class=\"st-bg-gray-20 st-w-64 st-p-4 st-border-0 st-border-r st-border-gray-40 st-border-solid\">\n                <div class=\"st-flex st-items-center st-justify-between st-whitespace-nowrap\">\n                    <div class=\"st-font-medium st-text-18\">篩選項目</div>\n                    <div class=\"st-flex-auto st-justify-end st-flex st-items-center\">\n                        <a class=\"st-font-medium st-p-2 st-mr-2 st-text-16 st-text-gray-90 st-whitespace-nowrap\" @click.prevent=\"$emit('filter-reset')\">重設</a>\n                        <st-button primary=\"\" small=\"\" text=\"送出\" @click.prevent=\"$emit('filter-submit')\"></st-button>\n                    </div>\n                </div>\n                <div class=\"st-py-4\">\n                    <slot name=\"filter-section\"></slot>\n                </div>\n            </div>\n            <div class=\"st-w-full st-overflow-auto\">\n                <div v-show=\"title\">\n                    <div class=\"st-px-4 st-mt-3 st-text-24 st-font-bold st-text-black\">{{ title }}</div>\n                    <hr class=\"st-border-gray-40 st-my-2.5\">\n                </div>\n                <div class=\"st-px-4\">\n                    <slot name=\"main-section\"></slot>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-4671318a", module.exports)
  } else {
    hotAPI.update("_v-4671318a", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"lodash":717,"vue":792,"vue-hot-reload-api":785}],1495:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _vPosIncrement = require('./v-pos-increment.vue');

var _vPosIncrement2 = _interopRequireDefault(_vPosIncrement);

var _vCustomerProfile = require('./webadmin/crm/v-customer-profile.vue');

var _vCustomerProfile2 = _interopRequireDefault(_vCustomerProfile);

var _vSharedContract = require('./webadmin/crm/v-shared-contract.vue');

var _vSharedContract2 = _interopRequireDefault(_vSharedContract);

var _vMemberInfo = require('./webadmin/v-member-info.vue');

var _vMemberInfo2 = _interopRequireDefault(_vMemberInfo);

var _vSelect = require('./v-select2.vue');

var _vSelect2 = _interopRequireDefault(_vSelect);

var _vTable = require('./v-table.vue');

var _vTable2 = _interopRequireDefault(_vTable);

var _vTabOpenList = require('./v-tab-open-list.vue');

var _vTabOpenList2 = _interopRequireDefault(_vTabOpenList);

var _vRequired = require('./v-required.vue');

var _vRequired2 = _interopRequireDefault(_vRequired);

var _vSelectStudioAndBranch = require('./v-select-studio-and-branch.vue');

var _vSelectStudioAndBranch2 = _interopRequireDefault(_vSelectStudioAndBranch);

var _vMultiselectStudioAndBranch = require('./v-multiselect-studio-and-branch.vue');

var _vMultiselectStudioAndBranch2 = _interopRequireDefault(_vMultiselectStudioAndBranch);

var _vMultiselectStudioAndBranchForm = require('./v-multiselect-studio-and-branch-form.vue');

var _vMultiselectStudioAndBranchForm2 = _interopRequireDefault(_vMultiselectStudioAndBranchForm);

var _vMemberSelector = require('./v-member-selector.vue');

var _vMemberSelector2 = _interopRequireDefault(_vMemberSelector);

var _vMemberMultiSelect = require('./v-member-multi-select.vue');

var _vMemberMultiSelect2 = _interopRequireDefault(_vMemberMultiSelect);

var _vMemberSelectorResult = require('./v-member-selector-result.vue');

var _vMemberSelectorResult2 = _interopRequireDefault(_vMemberSelectorResult);

var _vSelectCity = require('./v-select-city.vue');

var _vSelectCity2 = _interopRequireDefault(_vSelectCity);

var _vSelectDistrict = require('./v-select-district.vue');

var _vSelectDistrict2 = _interopRequireDefault(_vSelectDistrict);

var _vSpinner = require('./v-spinner.vue');

var _vSpinner2 = _interopRequireDefault(_vSpinner);

var _vSingelAjaxTextarea = require('./v-singel-ajax-textarea.vue');

var _vSingelAjaxTextarea2 = _interopRequireDefault(_vSingelAjaxTextarea);

var _vMemberContractRecordTable = require('./v-member-contract-record-table.vue');

var _vMemberContractRecordTable2 = _interopRequireDefault(_vMemberContractRecordTable);

var _vMemberContractRecordBtn = require('./v-member-contract-record-btn.vue');

var _vMemberContractRecordBtn2 = _interopRequireDefault(_vMemberContractRecordBtn);

var _vMultiselect = require('./v-multiselect.vue');

var _vMultiselect2 = _interopRequireDefault(_vMultiselect);

var _vCustomAlertItem = require('./v-custom-alert-item.vue');

var _vCustomAlertItem2 = _interopRequireDefault(_vCustomAlertItem);

var _vMultiAlertModel = require('./v-multi-alert-model.vue');

var _vMultiAlertModel2 = _interopRequireDefault(_vMultiAlertModel);

var _vQrcode = require('./v-qrcode.vue');

var _vQrcode2 = _interopRequireDefault(_vQrcode);

var _vSpinnerButton = require('./v-spinner-button.vue');

var _vSpinnerButton2 = _interopRequireDefault(_vSpinnerButton);

var _vCustomerTag = require('./v-customer-tag.vue');

var _vCustomerTag2 = _interopRequireDefault(_vCustomerTag);

var _vStartEndDate = require('./v-start-end-date.vue');

var _vStartEndDate2 = _interopRequireDefault(_vStartEndDate);

var _vMemberSelectorBinding = require('./v-member-selector-binding.vue');

var _vMemberSelectorBinding2 = _interopRequireDefault(_vMemberSelectorBinding);

var _vSqlPagination = require('./v-sql-pagination.vue');

var _vSqlPagination2 = _interopRequireDefault(_vSqlPagination);

var _vSqlPaginationNoquery = require('./v-sql-pagination-noquery.vue');

var _vSqlPaginationNoquery2 = _interopRequireDefault(_vSqlPaginationNoquery);

var _vPaginate = require('./v-paginate.vue');

var _vPaginate2 = _interopRequireDefault(_vPaginate);

var _vCkedior = require('./v-ckedior.vue');

var _vCkedior2 = _interopRequireDefault(_vCkedior);

var _vSimpleTabs = require('./v-simple-tabs.vue');

var _vSimpleTabs2 = _interopRequireDefault(_vSimpleTabs);

var _vTrainerSelector = require('./v-trainer-selector.vue');

var _vTrainerSelector2 = _interopRequireDefault(_vTrainerSelector);

var _vCollapse = require('./v-collapse.vue');

var _vCollapse2 = _interopRequireDefault(_vCollapse);

var _vCollapseList = require('./v-collapse-list.vue');

var _vCollapseList2 = _interopRequireDefault(_vCollapseList);

var _vBootstrapSwitch = require('./v-bootstrap-switch.vue');

var _vBootstrapSwitch2 = _interopRequireDefault(_vBootstrapSwitch);

var _vColorPicker = require('./v-color-picker.vue');

var _vColorPicker2 = _interopRequireDefault(_vColorPicker);

var _vCarousel = require('./v-carousel.vue');

var _vCarousel2 = _interopRequireDefault(_vCarousel);

var _vAlbumCarousel = require('./v-album-carousel.vue');

var _vAlbumCarousel2 = _interopRequireDefault(_vAlbumCarousel);

var _vTitleListTwo = require('./v-title-list-two.vue');

var _vTitleListTwo2 = _interopRequireDefault(_vTitleListTwo);

var _vImageFullView = require('./v-image-full-view.vue');

var _vImageFullView2 = _interopRequireDefault(_vImageFullView);

var _vDatepicker = require('./v-datepicker.vue');

var _vDatepicker2 = _interopRequireDefault(_vDatepicker);

var _vDatePicker = require('./v-date-picker.vue');

var _vDatePicker2 = _interopRequireDefault(_vDatePicker);

var _vVueSwitch = require('./v-vue-switch.vue');

var _vVueSwitch2 = _interopRequireDefault(_vVueSwitch);

var _vDismissibleAlert = require('./v-dismissible-alert.vue');

var _vDismissibleAlert2 = _interopRequireDefault(_vDismissibleAlert);

var _vBackendNotifications = require('./v-backend-notifications.vue');

var _vBackendNotifications2 = _interopRequireDefault(_vBackendNotifications);

var _vDismissibleAlertBootstrap = require('./v-dismissible-alert-bootstrap.vue');

var _vDismissibleAlertBootstrap2 = _interopRequireDefault(_vDismissibleAlertBootstrap);

var _stepProgressGroup = require('./step-progress-group.vue');

var _stepProgressGroup2 = _interopRequireDefault(_stepProgressGroup);

var _vBlockPercentageUi = require('./v-block-percentage-ui.vue');

var _vBlockPercentageUi2 = _interopRequireDefault(_vBlockPercentageUi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('./message');
require('./webadmin');
require('./layout');
require('./common-component');
// import Multiselect from 'vue-multiselect'


_vue2.default.component('v-start-end-date', _vStartEndDate2.default);
_vue2.default.component('v-qrcode', _vQrcode2.default);
_vue2.default.component('v-select-studio-and-branch', _vSelectStudioAndBranch2.default);
_vue2.default.component('v-multiselect-studio-and-branch', _vMultiselectStudioAndBranch2.default);
_vue2.default.component('v-multiselect-studio-and-branch-form', _vMultiselectStudioAndBranchForm2.default);
_vue2.default.component('v-member-selector', _vMemberSelector2.default);
_vue2.default.component('v-member-multi-select', _vMemberMultiSelect2.default);
_vue2.default.component('v-member-selector-result', _vMemberSelectorResult2.default);
_vue2.default.component('v-customer-profile', _vCustomerProfile2.default);

_vue2.default.component('v-pos-increment', _vPosIncrement2.default);
_vue2.default.component('v-select2', _vSelect2.default);
_vue2.default.component('v-table', _vTable2.default);
_vue2.default.component('v-tab-open-list', _vTabOpenList2.default);
_vue2.default.component('v-ckeditor', _vCkedior2.default);
_vue2.default.component('v-bs-switch', _vBootstrapSwitch2.default);
_vue2.default.component('v-vue-switch', _vVueSwitch2.default);

_vue2.default.component('v-required', _vRequired2.default);
_vue2.default.component('v-select-city', _vSelectCity2.default);
_vue2.default.component('v-select-district', _vSelectDistrict2.default);
_vue2.default.component('v-spinner', _vSpinner2.default);
_vue2.default.component('v-shared-contract', _vSharedContract2.default);
_vue2.default.component('v-singel-ajax-textarea', _vSingelAjaxTextarea2.default);
_vue2.default.component('v-member-contract-record-table', _vMemberContractRecordTable2.default);
_vue2.default.component('v-member-contract-record-btn', _vMemberContractRecordBtn2.default);
_vue2.default.component('v-member-info', _vMemberInfo2.default);

_vue2.default.component('v-mutiselect', _vMultiselect2.default);
_vue2.default.component('v-custom-alert-item', _vCustomAlertItem2.default);
_vue2.default.component('v-multi-alert-model', _vMultiAlertModel2.default);
_vue2.default.component('v-spinner-button', _vSpinnerButton2.default);
_vue2.default.component('v-customer-tag', _vCustomerTag2.default);
_vue2.default.component('v-member-selector-binding', _vMemberSelectorBinding2.default);
_vue2.default.component('v-sql-pagination', _vSqlPagination2.default);
_vue2.default.component('v-sql-pagination-noquery', _vSqlPaginationNoquery2.default);
_vue2.default.component('v-paginate', _vPaginate2.default);
_vue2.default.component('v-simple-tabs', _vSimpleTabs2.default);
_vue2.default.component('v-trainer-selector', _vTrainerSelector2.default);
_vue2.default.component('v-collapse', _vCollapse2.default);
_vue2.default.component('v-collapse-list', _vCollapseList2.default);
_vue2.default.component('v-carousel', _vCarousel2.default);
_vue2.default.component('v-color-picker', _vColorPicker2.default);
_vue2.default.component('v-album-carousel', _vAlbumCarousel2.default);
_vue2.default.component('v-title-list-two', _vTitleListTwo2.default);
_vue2.default.component('v-image-full-view', _vImageFullView2.default);
_vue2.default.component('v-datepicker', _vDatepicker2.default); //要棄用
_vue2.default.component('v-date-picker', _vDatePicker2.default); //新版的
_vue2.default.component('v-dismissible-alert', _vDismissibleAlert2.default);
_vue2.default.component('v-backend-notifications', _vBackendNotifications2.default);
_vue2.default.component('v-dismissible-alert-bootstrap', _vDismissibleAlertBootstrap2.default);
_vue2.default.component('step-progress-group', _stepProgressGroup2.default);
_vue2.default.component('v-block-percentage-ui', _vBlockPercentageUi2.default);

},{"./common-component":1490,"./layout":1496,"./message":1503,"./step-progress-group.vue":1505,"./v-album-carousel.vue":1506,"./v-backend-notifications.vue":1507,"./v-block-percentage-ui.vue":1508,"./v-bootstrap-switch.vue":1509,"./v-carousel.vue":1510,"./v-ckedior.vue":1511,"./v-collapse-list.vue":1512,"./v-collapse.vue":1513,"./v-color-picker.vue":1514,"./v-custom-alert-item.vue":1515,"./v-customer-tag.vue":1516,"./v-date-picker.vue":1517,"./v-datepicker.vue":1518,"./v-dismissible-alert-bootstrap.vue":1519,"./v-dismissible-alert.vue":1520,"./v-image-full-view.vue":1521,"./v-member-contract-record-btn.vue":1522,"./v-member-contract-record-table.vue":1523,"./v-member-multi-select.vue":1524,"./v-member-selector-binding.vue":1525,"./v-member-selector-result.vue":1526,"./v-member-selector.vue":1527,"./v-multi-alert-model.vue":1528,"./v-multiselect-studio-and-branch-form.vue":1529,"./v-multiselect-studio-and-branch.vue":1530,"./v-multiselect.vue":1531,"./v-paginate.vue":1532,"./v-pos-increment.vue":1533,"./v-qrcode.vue":1534,"./v-required.vue":1535,"./v-select-city.vue":1536,"./v-select-district.vue":1537,"./v-select-studio-and-branch.vue":1538,"./v-select2.vue":1539,"./v-simple-tabs.vue":1540,"./v-singel-ajax-textarea.vue":1541,"./v-spinner-button.vue":1542,"./v-spinner.vue":1543,"./v-sql-pagination-noquery.vue":1544,"./v-sql-pagination.vue":1545,"./v-start-end-date.vue":1546,"./v-tab-open-list.vue":1547,"./v-table.vue":1548,"./v-title-list-two.vue":1549,"./v-trainer-selector.vue":1550,"./v-vue-switch.vue":1551,"./webadmin":1575,"./webadmin/crm/v-customer-profile.vue":1571,"./webadmin/crm/v-shared-contract.vue":1572,"./webadmin/v-member-info.vue":1586,"vue":792}],1496:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _vSwitchLayout = require('./v-switch-layout.vue');

var _vSwitchLayout2 = _interopRequireDefault(_vSwitchLayout);

var _vBaseCard = require('./v-base-card.vue');

var _vBaseCard2 = _interopRequireDefault(_vBaseCard);

var _vSwitchLayoutBtn = require('./v-switch-layout-btn.vue');

var _vSwitchLayoutBtn2 = _interopRequireDefault(_vSwitchLayoutBtn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('v-switch-layout', _vSwitchLayout2.default);
_vue2.default.component('v-base-card', _vBaseCard2.default);
_vue2.default.component('v-switch-layout-btn', _vSwitchLayoutBtn2.default);

},{"./v-base-card.vue":1497,"./v-switch-layout-btn.vue":1498,"./v-switch-layout.vue":1499,"vue":792}],1497:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.round-border {\n  border-radius: 8px;\n  background-color: #FFFFFF;\n  border: 1px solid #EEEEEE;\n  margin: 12px;\n  padding: 0;\n  cursor: pointer; }\n  /* line 9, stdin */\n  .round-border:hover {\n    box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;\n    transition: all .2s; }\n\n/* line 14, stdin */\n.divide-line {\n  border-bottom: 1px solid #EEEEEE;\n  margin: 0 16px 16px 16px; }\n  /* line 17, stdin */\n  .divide-line:last-child {\n    border-bottom: none; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        isLoading: {
            type: Boolean,
            default: false
        },
        dataSource: {
            type: [Array, Object],
            default: function _default() {
                return [];
            }
        },
        cssClass: {
            type: String,
            default: ''
        },
        ajaxingNext: {
            type: Boolean,
            default: false
        },
        noDataMessage: {
            type: String,
            default: ''
        }
    },
    computed: {
        noData: function noData() {
            return _lodash2.default.isEmpty(this.dataSource);
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div>\n    <v-spinner :ajaxing=\"isLoading\"></v-spinner>\n    <div v-show=\"!isLoading\">\n        <div v-if=\"noData\" style=\"text-align: center; padding: 25px 0;\">\n            <img src=\"/images/noData.svg\" width=\"105\" height=\"60\">\n            <div style=\"color: #6c6c6c;\" class=\"m-top-10\">{{noDataMessage}}</div>\n        </div>\n        <div v-else=\"\">\n            <div class=\"row\" style=\"margin: 0;\">\n                <div v-for=\"(el, idx) in dataSource\" :key=\"'item-'+idx\" :class=\"cssClass\">\n                <slot :item=\"el\"></slot>                \n                </div>\n            </div>\n            <v-spinner :ajaxing=\"ajaxingNext\"></v-spinner>                \n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.round-border {\n  border-radius: 8px;\n  background-color: #FFFFFF;\n  border: 1px solid #EEEEEE;\n  margin: 12px;\n  padding: 0;\n  cursor: pointer; }\n  /* line 9, stdin */\n  .round-border:hover {\n    box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;\n    transition: all .2s; }\n\n/* line 14, stdin */\n.divide-line {\n  border-bottom: 1px solid #EEEEEE;\n  margin: 0 16px 16px 16px; }\n  /* line 17, stdin */\n  .divide-line:last-child {\n    border-bottom: none; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-cb96ee4e", module.exports)
  } else {
    hotAPI.update("_v-cb96ee4e", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1498:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.switch--btn[_v-a9bfb482] {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-align: center;\n      align-items: center;\n  border-radius: 9px;\n  border: 1px solid #EEEEEE;\n  background-color: #ffffff; }\n  /* line 8, stdin */\n  .switch--btn a[_v-a9bfb482]:first-child {\n    border-bottom-left-radius: 9px;\n    border-top-left-radius: 9px; }\n  /* line 12, stdin */\n  .switch--btn a[_v-a9bfb482]:last-child {\n    border-bottom-right-radius: 9px;\n    border-top-right-radius: 9px; }\n  /* line 16, stdin */\n  .switch--btn a[_v-a9bfb482]:hover {\n    box-shadow: rgba(0, 0, 0, 0.35) 0px -47px 36px -60px inset; }\n  /* line 19, stdin */\n  .switch--btn label[_v-a9bfb482] {\n    margin: 0;\n    padding: 10px 36px 7px 36px;\n    color: #000000; }\n  /* line 24, stdin */\n  .switch--btn .active[_v-a9bfb482] {\n    background: #38B0E3; }\n    /* line 26, stdin */\n    .switch--btn .active label[_v-a9bfb482] {\n      color: #ffffff; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        targetView: {
            description: '$refs of target v-switch-layout'
        }
    },
    data: function data() {
        return {
            pickedView: '',
            disableSwitch: false,
            showSwitchBtn: false
        };
    },
    mounted: function mounted() {},

    watch: {
        targetView: function targetView(newV) {
            if (newV) {
                this.mountedBtn();
            }
        },
        pickedView: function pickedView(newV) {
            this.targetView.changeView(newV);
        }
    },
    computed: {},
    methods: {
        mountedBtn: function mountedBtn() {
            this.pickedView = this.targetView._data.pickedView;
            this.showSwitchBtn = !this.targetView._data.hiddenSwitch;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div v-show=\"showSwitchBtn\" _v-a9bfb482=\"\">\n    <div class=\"switch--btn\" _v-a9bfb482=\"\">\n        <a :class=\"{active: pickedView == 'grid', 'primary-business-color-background': pickedView == 'grid'}\" _v-a9bfb482=\"\">\n            <input type=\"radio\" id=\"grid\" value=\"grid\" v-model=\"pickedView\" style=\"display: none;\" _v-a9bfb482=\"\">\n            <label for=\"grid\" _v-a9bfb482=\"\">\n                <i class=\"material-icons\" _v-a9bfb482=\"\">grid_on</i>\n            </label> \n        </a>\n        <a :class=\"{active: pickedView == 'list', 'primary-business-color-background': pickedView == 'list'}\" _v-a9bfb482=\"\">\n            <input type=\"radio\" id=\"list\" value=\"list\" v-model=\"pickedView\" style=\"display: none;\" _v-a9bfb482=\"\">\n            <label for=\"list\" _v-a9bfb482=\"\">\n                <i class=\"material-icons\" _v-a9bfb482=\"\">list</i>\n            </label>\n        </a>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.switch--btn[_v-a9bfb482] {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-align: center;\n      align-items: center;\n  border-radius: 9px;\n  border: 1px solid #EEEEEE;\n  background-color: #ffffff; }\n  /* line 8, stdin */\n  .switch--btn a[_v-a9bfb482]:first-child {\n    border-bottom-left-radius: 9px;\n    border-top-left-radius: 9px; }\n  /* line 12, stdin */\n  .switch--btn a[_v-a9bfb482]:last-child {\n    border-bottom-right-radius: 9px;\n    border-top-right-radius: 9px; }\n  /* line 16, stdin */\n  .switch--btn a[_v-a9bfb482]:hover {\n    box-shadow: rgba(0, 0, 0, 0.35) 0px -47px 36px -60px inset; }\n  /* line 19, stdin */\n  .switch--btn label[_v-a9bfb482] {\n    margin: 0;\n    padding: 10px 36px 7px 36px;\n    color: #000000; }\n  /* line 24, stdin */\n  .switch--btn .active[_v-a9bfb482] {\n    background: #38B0E3; }\n    /* line 26, stdin */\n    .switch--btn .active label[_v-a9bfb482] {\n      color: #ffffff; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-a9bfb482", module.exports)
  } else {
    hotAPI.update("_v-a9bfb482", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1499:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _props$data$mounted$w;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (_props$data$mounted$w = {
    props: {
        defulatView: {
            type: String,
            default: 'grid',
            description: 'type of view: grid or list, 如果只存在一個template會自動設為defualt'
        },
        jsonData: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        pageMeta: {
            type: Object
        },
        listStyleClass: {
            type: String,
            default: ''
        },
        gridStyleClass: {
            type: String,
            default: ''
        },
        apiConfig: {
            type: Object
        },
        isAjaxing: {
            type: Boolean,
            default: false
        },
        noDataMessage: {
            type: String,
            default: '暫無內容'
        }
    },
    data: function data() {
        return {
            apiResponse: {
                data: [],
                pageMeta: {}
            },
            ajaxing: false,
            ajaxingNext: false,
            pickedView: 'grid',
            hiddenSwitch: false,
            fetchingNext: false,
            page: 1
        };
    },
    mounted: function mounted() {
        document.addEventListener("scroll", this.handleScroll);
        this.generateDefaultView();
    },

    watch: {
        pickedView: function pickedView(newV) {
            if (newV) {
                this.$forceUpdate();
            }
        }
    },
    computed: {
        dataSource: function dataSource() {
            return _lodash2.default.isEmpty(this.jsonData) ? this.apiResponse.data : this.jsonData;
        },
        pagination: function pagination() {
            return _lodash2.default.isEmpty(this.pageMeta) ? this.apiResponse.pageMeta : this.pageMeta;
        },
        isLoading: function isLoading() {
            return this.ajaxing || this.isAjaxing;
        },
        isAllowFetchingNext: function isAllowFetchingNext() {
            if (_lodash2.default.isEmpty(this.apiResponse.pageMeta)) {
                return false;
            }
            var isNextAvailable = false;
            if (this.apiResponse.pageMeta.total == null) {
                if (this.apiResponse.pageMeta.hasOwnProperty('count') && this.apiResponse.pageMeta.hasOwnProperty('perPage')) {
                    isNextAvailable = this.apiResponse.pageMeta.count == this.apiResponse.pageMeta.perPage;
                } else {
                    isNextAvailable = false;
                }
            } else {
                isNextAvailable = this.apiResponse.pageMeta.currentPage < this.apiResponse.pageMeta.lastPage;
            }
            return isNextAvailable ? true : false;
        },
        isExistBothTemplate: function isExistBothTemplate() {
            return this.$scopedSlots.hasOwnProperty('list') && this.$scopedSlots.hasOwnProperty('grid');
        }
    }
}, (0, _defineProperty3.default)(_props$data$mounted$w, 'watch', {}), (0, _defineProperty3.default)(_props$data$mounted$w, 'methods', {
    generateDefaultView: function generateDefaultView() {
        if (this.isExistBothTemplate) {
            //disable switch and default grid view on mobile
            this.hiddenSwitch = $('body').width() < 576;
            if (this.hiddenSwitch) {
                this.changeView('grid');
            } else {
                this.changeView(this.defulatView);
            }
        } else {
            this.hiddenSwitch = true;
            this.changeView((0, _keys2.default)(this.$scopedSlots)[0]);
        }
    },
    changeView: function changeView(type) {
        this.pickedView = type;
    },
    fetchData: function fetchData() {
        var _this = this;

        var nextPage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        var api = this.apiConfig;
        if (_lodash2.default.isEmpty(api) || this.ajaxingNext || this.ajaxing) return;
        if (nextPage) {
            this.ajaxingNext = true;
            api.payload = (0, _extends3.default)({}, api.payload, {
                page: this.apiResponse.pageMeta.total ? this.apiResponse.pageMeta.currentPage + 1 : this.page + 1
            });
        } else {
            this.ajaxing = true;
            this.page = 1;
        }
        var method = api.methods ? api.methods : 'get';
        var payload = method == 'get' ? { params: api.payload } : api.payload;
        var dataName = api.dataName ? api.dataName : '';
        this.$http[method](api.apiurl, payload).then(function (response) {
            var result = dataName ? response.data[dataName] : response.data;
            if (nextPage) {
                result = this.apiResponse.data.concat(result);
            };
            this.apiResponse = {
                data: result,
                pageMeta: response.data.pageMeta
            };
            nextPage ? this.ajaxingNext = false : this.ajaxing = false;
            this.$emit('fetch-success-callback', response.data);
        }, function (error) {
            nextPage ? _this.ajaxingNext = false : _this.ajaxing = false;
            _this.$emit('fetch-fail-callback', error);
        });
    },
    handleScroll: function handleScroll() {
        var rootElement = document.documentElement;
        var scrollTotal = rootElement.scrollHeight - rootElement.clientHeight;
        var ratio = rootElement.scrollTop / scrollTotal;
        if (ratio > 0.8 && this.isAllowFetchingNext) {
            this.fetchData(true);
        }
    }
}), _props$data$mounted$w);
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div id=\"v-switch-view\" _v-1e97de30=\"\">\n    <v-base-card v-if=\"pickedView == 'list'\" ref=\"list_view\" :is-loading=\"isLoading\" :data-source=\"dataSource\" :css-class=\"listStyleClass\" :ajaxing-next=\"ajaxingNext\" :no-data-message=\"noDataMessage\" _v-1e97de30=\"\">\n        <template slot-scope=\"{item}\">\n            <slot name=\"list\" :item=\"item\" _v-1e97de30=\"\"></slot>\n        </template>\n    </v-base-card>\n    <v-base-card v-if=\"pickedView == 'grid'\" ref=\"grid_view\" :is-loading=\"isLoading\" :data-source=\"dataSource\" :css-class=\"gridStyleClass\" :ajaxing-next=\"ajaxingNext\" :no-data-message=\"noDataMessage\" _v-1e97de30=\"\">&gt;\n        <template slot-scope=\"{item}\">\n            <slot name=\"grid\" :item=\"item\" _v-1e97de30=\"\"></slot>\n        </template>\n    </v-base-card>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-1e97de30", module.exports)
  } else {
    hotAPI.update("_v-1e97de30", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/object/keys":56,"babel-runtime/helpers/defineProperty":65,"babel-runtime/helpers/extends":66,"lodash":717,"vue":792,"vue-hot-reload-api":785}],1500:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    mounted: function mounted() {},

    data: function data() {
        return {};
    },
    props: ['data', 'memberMessageId'],
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        isInWebadmin: function isInWebadmin(state) {
            return state.is_in_webadmin;
        }
    }), {
        url: function url() {
            if (this.data.content[0].hasOwnProperty('contract')) {
                return this.data.content[0].contract.buy_url;
            }
            return '';
        }
    }),
    methods: {
        actionClick: function actionClick() {
            if (!this.isInWebadmin) {
                this.$http.post('/webapi/messages/event-action-click/' + this.memberMessageId);
            }
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"text-center m-top-5\" _v-d3e15828=\"\">\n    <a :href=\"url\" target=\"_blank\" class=\"btn btn-lg btn-primary\" @click=\"actionClick\" _v-d3e15828=\"\">立即購買</a>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-d3e15828", module.exports)
  } else {
    hotAPI.update("_v-d3e15828", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vuex":803}],1501:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    mounted: function mounted() {},

    data: function data() {
        return {};
    },
    props: ['data', 'memberMessageId'],
    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        isInWebadmin: function isInWebadmin(state) {
            return state.is_in_webadmin;
        }
    })),
    methods: {
        actionClick: function actionClick() {
            if (!this.isInWebadmin) {
                this.$http.post('/webapi/messages/event-action-click/' + this.memberMessageId);
            }
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"text-center m-top-5\" _v-7f178555=\"\">\n    <a :href=\"data.content[0]\" target=\"_blank\" class=\"btn btn-lg btn-primary\" @click=\"actionClick\" _v-7f178555=\"\">立即前往</a>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-7f178555", module.exports)
  } else {
    hotAPI.update("_v-7f178555", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vuex":803}],1502:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.carousel-control[_v-68544906] {\n  background: none; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vuex = require('vuex');

exports.default = {
    mounted: function mounted() {},
    data: function data() {
        return {};
    },
    props: ['data'],
    computed: {},
    methods: {}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div id=\"carousel-event\" class=\"carousel slide\" data-ride=\"carousel\" _v-68544906=\"\">\n    <div class=\"carousel-inner\" role=\"listbox\" _v-68544906=\"\">\n        <div class=\"item\" :class=\"[key==0?'active':'']\" v-for=\"(image,key) in data.content\" _v-68544906=\"\">\n            <img :src=\"image\" _v-68544906=\"\">\n            <div class=\"carousel-caption\" _v-68544906=\"\">\n            </div>\n        </div>\n    </div>\n    <a v-show=\"data.content.length>1\" class=\"left carousel-control\" href=\"#carousel-event\" role=\"button\" data-slide=\"prev\" _v-68544906=\"\">\n        <span class=\"glyphicon glyphicon-chevron-left\" aria-hidden=\"true\" _v-68544906=\"\"></span>\n        <span class=\"sr-only\" _v-68544906=\"\">Previous</span>\n    </a>\n    <a v-show=\"data.content.length>1\" class=\"right carousel-control\" href=\"#carousel-event\" role=\"button\" data-slide=\"next\" _v-68544906=\"\">\n        <span class=\"glyphicon glyphicon-chevron-right\" aria-hidden=\"true\" _v-68544906=\"\"></span>\n        <span class=\"sr-only\" _v-68544906=\"\">Next</span>\n    </a>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.carousel-control[_v-68544906] {\n  background: none; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-68544906", module.exports)
  } else {
    hotAPI.update("_v-68544906", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1503:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _textContent = require('./text-content.vue');

var _textContent2 = _interopRequireDefault(_textContent);

var _galleryContent = require('./gallery-content.vue');

var _galleryContent2 = _interopRequireDefault(_galleryContent);

var _actionBuyContent = require('./action-buy-content.vue');

var _actionBuyContent2 = _interopRequireDefault(_actionBuyContent);

var _actionUrlContent = require('./action-url-content.vue');

var _actionUrlContent2 = _interopRequireDefault(_actionUrlContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('v-messages-text-content', _textContent2.default);
_vue2.default.component('v-messages-gallery-content', _galleryContent2.default);
_vue2.default.component('v-messages-action-buy-content', _actionBuyContent2.default);
_vue2.default.component('v-messages-action-url-content', _actionUrlContent2.default);

},{"./action-buy-content.vue":1500,"./action-url-content.vue":1501,"./gallery-content.vue":1502,"./text-content.vue":1504,"vue":792}],1504:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vuex = require('vuex');

exports.default = {
    mounted: function mounted() {},

    data: function data() {
        return {};
    },
    props: ['data'],
    computed: {
        textString: function textString() {
            if (typeof this.data.content[0] === 'undefined') {
                return '';
            }
            return $17.nl2br(String(this.data.content[0]));
        }
    },
    methods: {}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"m-top-20 m-bottom-20\" _v-cdfaf72c=\"\">\n    <p v-html=\"textString\" _v-cdfaf72c=\"\"></p>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-cdfaf72c", module.exports)
  } else {
    hotAPI.update("_v-cdfaf72c", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vuex":803}],1505:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.step-progress-group-container[_v-98e0d1f2] {\n  background: #FFFFFF;\n  box-shadow: 0px 2px 2px 2px rgba(0, 0, 0, 0.05);\n  border-radius: 2px;\n  padding: 8px 0; }\n  /* line 8, stdin */\n  .step-progress-group-container .bar[_v-98e0d1f2] {\n    list-style: none;\n    -webkit-padding-start: 0;\n            padding-inline-start: 0;\n    margin-bottom: 0; }\n    /* line 13, stdin */\n    .step-progress-group-container .bar li[_v-98e0d1f2] {\n      position: relative;\n      font-size: 14px;\n      font-weight: 500;\n      padding: 5px; }\n      /* line 19, stdin */\n      .step-progress-group-container .bar li[_v-98e0d1f2]:hover {\n        background: #FAFAFB; }\n      /* line 23, stdin */\n      .step-progress-group-container .bar li[_v-98e0d1f2]::before {\n        content: '\\25CF';\n        margin-right: 10px;\n        font-size: 12px;\n        z-index: 10;\n        position: relative; }\n      /* line 31, stdin */\n      .step-progress-group-container .bar li[_v-98e0d1f2]:not(.only-one)::after {\n        position: absolute;\n        left: 5px;\n        top: 0;\n        content: '';\n        border-left: 1px solid #D5D5D5;\n        margin-left: 5px;\n        height: 100%; }\n    /* line 42, stdin */\n    .step-progress-group-container .bar li[_v-98e0d1f2]:not(.only-one):first-of-type:after {\n      top: 50%; }\n    /* line 46, stdin */\n    .step-progress-group-container .bar li[_v-98e0d1f2]:not(.only-one):last-of-type:after {\n      top: -50%; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        activeColor: {
            type: String,
            default: '#17AA6F'
        },
        passiveColor: {
            type: String,
            default: '#696974'
        },
        ongoingColor: {
            type: String,
            default: '#000000'
        },
        beforeJump: {
            type: Function,
            default: function _default() {}
        },
        defaultStepIndex: {
            type: Number,
            default: 0
        }
    },
    created: function created() {},
    mounted: function mounted() {
        this.init();
    },
    data: function data() {
        return {};
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)('webadmin/stepProgressGroup', ['steps', 'configs', 'currentStepIndex'])),
    watch: {},
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('webadmin/stepProgressGroup', ['jumpToStep']), {
        init: function init() {
            if (this.defaultStepIndex > 0) {
                this.jumpToStep(this.defaultStepIndex);
            }
        },
        liStyle: function liStyle(idx) {
            var color = '';
            if (this.currentStepIndex === idx) {
                color = this.ongoingColor;
            } else if (this.currentStepIndex < idx) {
                color = this.passiveColor;
            } else {
                color = this.activeColor;
            }
            return {
                color: color
            };
        },
        jumpTo: function jumpTo(idx) {
            if (this.currentStepIndex <= idx) return false;
            if (this.configs.showAlertWhenJump) {
                var _vm = this;
                $17.swal({
                    title: '確定要前往此步驟？',
                    text: _vm.steps[idx].name,
                    type: 'warning'
                }, function (confirm) {
                    if (confirm) {
                        _vm.beforeJump(idx);
                        _vm.$nextTick(function () {
                            _vm.jumpToStep(idx);
                        });
                    }
                });
            } else {
                this.beforeJump(idx);
                this.$nextTick(function () {
                    vm.jumpToStep(idx);
                });
            }
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"step-progress-group-container\" _v-98e0d1f2=\"\">\n    <ul class=\"bar\" _v-98e0d1f2=\"\">\n        <template v-for=\"(item, idx) in steps\">\n            <li v-if=\"item.name\" :class=\"{\n                    'only-one':steps.length === 1,\n                    'st-cursor-pointer':idx < currentStepIndex,\n                }\" :key=\"'step-'+idx\" :style=\"liStyle(idx)\" @click.prevent=\"jumpTo(idx)\" _v-98e0d1f2=\"\">\n                {{ item.name }}\n            </li>\n        </template>\n    </ul>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.step-progress-group-container[_v-98e0d1f2] {\n  background: #FFFFFF;\n  box-shadow: 0px 2px 2px 2px rgba(0, 0, 0, 0.05);\n  border-radius: 2px;\n  padding: 8px 0; }\n  /* line 8, stdin */\n  .step-progress-group-container .bar[_v-98e0d1f2] {\n    list-style: none;\n    -webkit-padding-start: 0;\n            padding-inline-start: 0;\n    margin-bottom: 0; }\n    /* line 13, stdin */\n    .step-progress-group-container .bar li[_v-98e0d1f2] {\n      position: relative;\n      font-size: 14px;\n      font-weight: 500;\n      padding: 5px; }\n      /* line 19, stdin */\n      .step-progress-group-container .bar li[_v-98e0d1f2]:hover {\n        background: #FAFAFB; }\n      /* line 23, stdin */\n      .step-progress-group-container .bar li[_v-98e0d1f2]::before {\n        content: '\\25CF';\n        margin-right: 10px;\n        font-size: 12px;\n        z-index: 10;\n        position: relative; }\n      /* line 31, stdin */\n      .step-progress-group-container .bar li[_v-98e0d1f2]:not(.only-one)::after {\n        position: absolute;\n        left: 5px;\n        top: 0;\n        content: '';\n        border-left: 1px solid #D5D5D5;\n        margin-left: 5px;\n        height: 100%; }\n    /* line 42, stdin */\n    .step-progress-group-container .bar li[_v-98e0d1f2]:not(.only-one):first-of-type:after {\n      top: 50%; }\n    /* line 46, stdin */\n    .step-progress-group-container .bar li[_v-98e0d1f2]:not(.only-one):last-of-type:after {\n      top: -50%; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-98e0d1f2", module.exports)
  } else {
    hotAPI.update("_v-98e0d1f2", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1506:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/**\n * Swiper 4.5.1\n * Most modern mobile touch slider and framework with hardware accelerated transitions\n * http://www.idangero.us/swiper/\n *\n * Copyright 2014-2019 Vladimir Kharlampidi\n *\n * Released under the MIT License\n *\n * Released on: September 13, 2019\n */\n.swiper-container {\n  margin-left: auto;\n  margin-right: auto;\n  position: relative;\n  overflow: hidden;\n  list-style: none;\n  padding: 0;\n  /* Fix of Webkit flickering */\n  z-index: 1;\n}\n.swiper-container-no-flexbox .swiper-slide {\n  float: left;\n}\n.swiper-container-vertical > .swiper-wrapper {\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n}\n.swiper-wrapper {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-transition-property: -webkit-transform;\n  transition-property: -webkit-transform;\n  -o-transition-property: transform;\n  transition-property: transform;\n  transition-property: transform, -webkit-transform;\n  -webkit-box-sizing: content-box;\n  box-sizing: content-box;\n}\n.swiper-container-android .swiper-slide,\n.swiper-wrapper {\n  -webkit-transform: translate3d(0px, 0, 0);\n  transform: translate3d(0px, 0, 0);\n}\n.swiper-container-multirow > .swiper-wrapper {\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n.swiper-container-free-mode > .swiper-wrapper {\n  -webkit-transition-timing-function: ease-out;\n  -o-transition-timing-function: ease-out;\n  transition-timing-function: ease-out;\n  margin: 0 auto;\n}\n.swiper-slide {\n  -webkit-flex-shrink: 0;\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n  width: 100%;\n  height: 100%;\n  position: relative;\n  -webkit-transition-property: -webkit-transform;\n  transition-property: -webkit-transform;\n  -o-transition-property: transform;\n  transition-property: transform;\n  transition-property: transform, -webkit-transform;\n}\n.swiper-slide-invisible-blank {\n  visibility: hidden;\n}\n/* Auto Height */\n.swiper-container-autoheight,\n.swiper-container-autoheight .swiper-slide {\n  height: auto;\n}\n.swiper-container-autoheight .swiper-wrapper {\n  -webkit-box-align: start;\n  -webkit-align-items: flex-start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  -webkit-transition-property: height, -webkit-transform;\n  transition-property: height, -webkit-transform;\n  -o-transition-property: transform, height;\n  transition-property: transform, height;\n  transition-property: transform, height, -webkit-transform;\n}\n/* 3D Effects */\n.swiper-container-3d {\n  -webkit-perspective: 1200px;\n  perspective: 1200px;\n}\n.swiper-container-3d .swiper-wrapper,\n.swiper-container-3d .swiper-slide,\n.swiper-container-3d .swiper-slide-shadow-left,\n.swiper-container-3d .swiper-slide-shadow-right,\n.swiper-container-3d .swiper-slide-shadow-top,\n.swiper-container-3d .swiper-slide-shadow-bottom,\n.swiper-container-3d .swiper-cube-shadow {\n  -webkit-transform-style: preserve-3d;\n  transform-style: preserve-3d;\n}\n.swiper-container-3d .swiper-slide-shadow-left,\n.swiper-container-3d .swiper-slide-shadow-right,\n.swiper-container-3d .swiper-slide-shadow-top,\n.swiper-container-3d .swiper-slide-shadow-bottom {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  z-index: 10;\n}\n.swiper-container-3d .swiper-slide-shadow-left {\n  background-image: -webkit-gradient(linear, right top, left top, from(rgba(0, 0, 0, 0.5)), to(rgba(0, 0, 0, 0)));\n  background-image: -webkit-linear-gradient(right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n  background-image: -o-linear-gradient(right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n  background-image: linear-gradient(to left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n}\n.swiper-container-3d .swiper-slide-shadow-right {\n  background-image: -webkit-gradient(linear, left top, right top, from(rgba(0, 0, 0, 0.5)), to(rgba(0, 0, 0, 0)));\n  background-image: -webkit-linear-gradient(left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n  background-image: -o-linear-gradient(left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n}\n.swiper-container-3d .swiper-slide-shadow-top {\n  background-image: -webkit-gradient(linear, left bottom, left top, from(rgba(0, 0, 0, 0.5)), to(rgba(0, 0, 0, 0)));\n  background-image: -webkit-linear-gradient(bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n  background-image: -o-linear-gradient(bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n  background-image: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n}\n.swiper-container-3d .swiper-slide-shadow-bottom {\n  background-image: -webkit-gradient(linear, left top, left bottom, from(rgba(0, 0, 0, 0.5)), to(rgba(0, 0, 0, 0)));\n  background-image: -webkit-linear-gradient(top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n  background-image: -o-linear-gradient(top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n}\n/* IE10 Windows Phone 8 Fixes */\n.swiper-container-wp8-horizontal,\n.swiper-container-wp8-horizontal > .swiper-wrapper {\n  -ms-touch-action: pan-y;\n  touch-action: pan-y;\n}\n.swiper-container-wp8-vertical,\n.swiper-container-wp8-vertical > .swiper-wrapper {\n  -ms-touch-action: pan-x;\n  touch-action: pan-x;\n}\n.swiper-button-prev,\n.swiper-button-next {\n  position: absolute;\n  top: 50%;\n  width: 27px;\n  height: 44px;\n  margin-top: -22px;\n  z-index: 10;\n  cursor: pointer;\n  background-size: 27px 44px;\n  background-position: center;\n  background-repeat: no-repeat;\n}\n.swiper-button-prev.swiper-button-disabled,\n.swiper-button-next.swiper-button-disabled {\n  opacity: 0.35;\n  cursor: auto;\n  pointer-events: none;\n}\n.swiper-button-prev,\n.swiper-container-rtl .swiper-button-next {\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z'%20fill%3D'%23007aff'%2F%3E%3C%2Fsvg%3E\");\n  left: 10px;\n  right: auto;\n}\n.swiper-button-next,\n.swiper-container-rtl .swiper-button-prev {\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%23007aff'%2F%3E%3C%2Fsvg%3E\");\n  right: 10px;\n  left: auto;\n}\n.swiper-button-prev.swiper-button-white,\n.swiper-container-rtl .swiper-button-next.swiper-button-white {\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z'%20fill%3D'%23ffffff'%2F%3E%3C%2Fsvg%3E\");\n}\n.swiper-button-next.swiper-button-white,\n.swiper-container-rtl .swiper-button-prev.swiper-button-white {\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%23ffffff'%2F%3E%3C%2Fsvg%3E\");\n}\n.swiper-button-prev.swiper-button-black,\n.swiper-container-rtl .swiper-button-next.swiper-button-black {\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z'%20fill%3D'%23000000'%2F%3E%3C%2Fsvg%3E\");\n}\n.swiper-button-next.swiper-button-black,\n.swiper-container-rtl .swiper-button-prev.swiper-button-black {\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%23000000'%2F%3E%3C%2Fsvg%3E\");\n}\n.swiper-button-lock {\n  display: none;\n}\n.swiper-pagination {\n  position: absolute;\n  text-align: center;\n  -webkit-transition: 300ms opacity;\n  -o-transition: 300ms opacity;\n  transition: 300ms opacity;\n  -webkit-transform: translate3d(0, 0, 0);\n  transform: translate3d(0, 0, 0);\n  z-index: 10;\n}\n.swiper-pagination.swiper-pagination-hidden {\n  opacity: 0;\n}\n/* Common Styles */\n.swiper-pagination-fraction,\n.swiper-pagination-custom,\n.swiper-container-horizontal > .swiper-pagination-bullets {\n  bottom: 10px;\n  left: 0;\n  width: 100%;\n}\n/* Bullets */\n.swiper-pagination-bullets-dynamic {\n  overflow: hidden;\n  font-size: 0;\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n  -webkit-transform: scale(0.33);\n  -ms-transform: scale(0.33);\n  transform: scale(0.33);\n  position: relative;\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active {\n  -webkit-transform: scale(1);\n  -ms-transform: scale(1);\n  transform: scale(1);\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main {\n  -webkit-transform: scale(1);\n  -ms-transform: scale(1);\n  transform: scale(1);\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev {\n  -webkit-transform: scale(0.66);\n  -ms-transform: scale(0.66);\n  transform: scale(0.66);\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev {\n  -webkit-transform: scale(0.33);\n  -ms-transform: scale(0.33);\n  transform: scale(0.33);\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next {\n  -webkit-transform: scale(0.66);\n  -ms-transform: scale(0.66);\n  transform: scale(0.66);\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next {\n  -webkit-transform: scale(0.33);\n  -ms-transform: scale(0.33);\n  transform: scale(0.33);\n}\n.swiper-pagination-bullet {\n  width: 8px;\n  height: 8px;\n  display: inline-block;\n  border-radius: 100%;\n  background: #000;\n  opacity: 0.2;\n}\nbutton.swiper-pagination-bullet {\n  border: none;\n  margin: 0;\n  padding: 0;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n}\n.swiper-pagination-clickable .swiper-pagination-bullet {\n  cursor: pointer;\n}\n.swiper-pagination-bullet-active {\n  opacity: 1;\n  background: #007aff;\n}\n.swiper-container-vertical > .swiper-pagination-bullets {\n  right: 10px;\n  top: 50%;\n  -webkit-transform: translate3d(0px, -50%, 0);\n  transform: translate3d(0px, -50%, 0);\n}\n.swiper-container-vertical > .swiper-pagination-bullets .swiper-pagination-bullet {\n  margin: 6px 0;\n  display: block;\n}\n.swiper-container-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic {\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%);\n  width: 8px;\n}\n.swiper-container-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n  display: inline-block;\n  -webkit-transition: 200ms top, 200ms -webkit-transform;\n  transition: 200ms top, 200ms -webkit-transform;\n  -o-transition: 200ms transform, 200ms top;\n  transition: 200ms transform, 200ms top;\n  transition: 200ms transform, 200ms top, 200ms -webkit-transform;\n}\n.swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet {\n  margin: 0 4px;\n}\n.swiper-container-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic {\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n  -ms-transform: translateX(-50%);\n  transform: translateX(-50%);\n  white-space: nowrap;\n}\n.swiper-container-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n  -webkit-transition: 200ms left, 200ms -webkit-transform;\n  transition: 200ms left, 200ms -webkit-transform;\n  -o-transition: 200ms transform, 200ms left;\n  transition: 200ms transform, 200ms left;\n  transition: 200ms transform, 200ms left, 200ms -webkit-transform;\n}\n.swiper-container-horizontal.swiper-container-rtl > .swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n  -webkit-transition: 200ms right, 200ms -webkit-transform;\n  transition: 200ms right, 200ms -webkit-transform;\n  -o-transition: 200ms transform, 200ms right;\n  transition: 200ms transform, 200ms right;\n  transition: 200ms transform, 200ms right, 200ms -webkit-transform;\n}\n/* Progress */\n.swiper-pagination-progressbar {\n  background: rgba(0, 0, 0, 0.25);\n  position: absolute;\n}\n.swiper-pagination-progressbar .swiper-pagination-progressbar-fill {\n  background: #007aff;\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  -webkit-transform: scale(0);\n  -ms-transform: scale(0);\n  transform: scale(0);\n  -webkit-transform-origin: left top;\n  -ms-transform-origin: left top;\n  transform-origin: left top;\n}\n.swiper-container-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {\n  -webkit-transform-origin: right top;\n  -ms-transform-origin: right top;\n  transform-origin: right top;\n}\n.swiper-container-horizontal > .swiper-pagination-progressbar,\n.swiper-container-vertical > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite {\n  width: 100%;\n  height: 4px;\n  left: 0;\n  top: 0;\n}\n.swiper-container-vertical > .swiper-pagination-progressbar,\n.swiper-container-horizontal > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite {\n  width: 4px;\n  height: 100%;\n  left: 0;\n  top: 0;\n}\n.swiper-pagination-white .swiper-pagination-bullet-active {\n  background: #ffffff;\n}\n.swiper-pagination-progressbar.swiper-pagination-white {\n  background: rgba(255, 255, 255, 0.25);\n}\n.swiper-pagination-progressbar.swiper-pagination-white .swiper-pagination-progressbar-fill {\n  background: #ffffff;\n}\n.swiper-pagination-black .swiper-pagination-bullet-active {\n  background: #000000;\n}\n.swiper-pagination-progressbar.swiper-pagination-black {\n  background: rgba(0, 0, 0, 0.25);\n}\n.swiper-pagination-progressbar.swiper-pagination-black .swiper-pagination-progressbar-fill {\n  background: #000000;\n}\n.swiper-pagination-lock {\n  display: none;\n}\n/* Scrollbar */\n.swiper-scrollbar {\n  border-radius: 10px;\n  position: relative;\n  -ms-touch-action: none;\n  background: rgba(0, 0, 0, 0.1);\n}\n.swiper-container-horizontal > .swiper-scrollbar {\n  position: absolute;\n  left: 1%;\n  bottom: 3px;\n  z-index: 50;\n  height: 5px;\n  width: 98%;\n}\n.swiper-container-vertical > .swiper-scrollbar {\n  position: absolute;\n  right: 3px;\n  top: 1%;\n  z-index: 50;\n  width: 5px;\n  height: 98%;\n}\n.swiper-scrollbar-drag {\n  height: 100%;\n  width: 100%;\n  position: relative;\n  background: rgba(0, 0, 0, 0.5);\n  border-radius: 10px;\n  left: 0;\n  top: 0;\n}\n.swiper-scrollbar-cursor-drag {\n  cursor: move;\n}\n.swiper-scrollbar-lock {\n  display: none;\n}\n.swiper-zoom-container {\n  width: 100%;\n  height: 100%;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  text-align: center;\n}\n.swiper-zoom-container > img,\n.swiper-zoom-container > svg,\n.swiper-zoom-container > canvas {\n  max-width: 100%;\n  max-height: 100%;\n  -o-object-fit: contain;\n  object-fit: contain;\n}\n.swiper-slide-zoomed {\n  cursor: move;\n}\n/* Preloader */\n.swiper-lazy-preloader {\n  width: 42px;\n  height: 42px;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  margin-left: -21px;\n  margin-top: -21px;\n  z-index: 10;\n  -webkit-transform-origin: 50%;\n  -ms-transform-origin: 50%;\n  transform-origin: 50%;\n  -webkit-animation: swiper-preloader-spin 1s steps(12, end) infinite;\n  animation: swiper-preloader-spin 1s steps(12, end) infinite;\n}\n.swiper-lazy-preloader:after {\n  display: block;\n  content: '';\n  width: 100%;\n  height: 100%;\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20viewBox%3D'0%200%20120%20120'%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20xmlns%3Axlink%3D'http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink'%3E%3Cdefs%3E%3Cline%20id%3D'l'%20x1%3D'60'%20x2%3D'60'%20y1%3D'7'%20y2%3D'27'%20stroke%3D'%236c6c6c'%20stroke-width%3D'11'%20stroke-linecap%3D'round'%2F%3E%3C%2Fdefs%3E%3Cg%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(30%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(60%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(90%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(120%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(150%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.37'%20transform%3D'rotate(180%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.46'%20transform%3D'rotate(210%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.56'%20transform%3D'rotate(240%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.66'%20transform%3D'rotate(270%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.75'%20transform%3D'rotate(300%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.85'%20transform%3D'rotate(330%2060%2C60)'%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E\");\n  background-position: 50%;\n  background-size: 100%;\n  background-repeat: no-repeat;\n}\n.swiper-lazy-preloader-white:after {\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20viewBox%3D'0%200%20120%20120'%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20xmlns%3Axlink%3D'http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink'%3E%3Cdefs%3E%3Cline%20id%3D'l'%20x1%3D'60'%20x2%3D'60'%20y1%3D'7'%20y2%3D'27'%20stroke%3D'%23fff'%20stroke-width%3D'11'%20stroke-linecap%3D'round'%2F%3E%3C%2Fdefs%3E%3Cg%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(30%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(60%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(90%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(120%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(150%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.37'%20transform%3D'rotate(180%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.46'%20transform%3D'rotate(210%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.56'%20transform%3D'rotate(240%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.66'%20transform%3D'rotate(270%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.75'%20transform%3D'rotate(300%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.85'%20transform%3D'rotate(330%2060%2C60)'%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E\");\n}\n@-webkit-keyframes swiper-preloader-spin {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@keyframes swiper-preloader-spin {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n/* a11y */\n.swiper-container .swiper-notification {\n  position: absolute;\n  left: 0;\n  top: 0;\n  pointer-events: none;\n  opacity: 0;\n  z-index: -1000;\n}\n.swiper-container-fade.swiper-container-free-mode .swiper-slide {\n  -webkit-transition-timing-function: ease-out;\n  -o-transition-timing-function: ease-out;\n  transition-timing-function: ease-out;\n}\n.swiper-container-fade .swiper-slide {\n  pointer-events: none;\n  -webkit-transition-property: opacity;\n  -o-transition-property: opacity;\n  transition-property: opacity;\n}\n.swiper-container-fade .swiper-slide .swiper-slide {\n  pointer-events: none;\n}\n.swiper-container-fade .swiper-slide-active,\n.swiper-container-fade .swiper-slide-active .swiper-slide-active {\n  pointer-events: auto;\n}\n.swiper-container-cube {\n  overflow: visible;\n}\n.swiper-container-cube .swiper-slide {\n  pointer-events: none;\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  z-index: 1;\n  visibility: hidden;\n  -webkit-transform-origin: 0 0;\n  -ms-transform-origin: 0 0;\n  transform-origin: 0 0;\n  width: 100%;\n  height: 100%;\n}\n.swiper-container-cube .swiper-slide .swiper-slide {\n  pointer-events: none;\n}\n.swiper-container-cube.swiper-container-rtl .swiper-slide {\n  -webkit-transform-origin: 100% 0;\n  -ms-transform-origin: 100% 0;\n  transform-origin: 100% 0;\n}\n.swiper-container-cube .swiper-slide-active,\n.swiper-container-cube .swiper-slide-active .swiper-slide-active {\n  pointer-events: auto;\n}\n.swiper-container-cube .swiper-slide-active,\n.swiper-container-cube .swiper-slide-next,\n.swiper-container-cube .swiper-slide-prev,\n.swiper-container-cube .swiper-slide-next + .swiper-slide {\n  pointer-events: auto;\n  visibility: visible;\n}\n.swiper-container-cube .swiper-slide-shadow-top,\n.swiper-container-cube .swiper-slide-shadow-bottom,\n.swiper-container-cube .swiper-slide-shadow-left,\n.swiper-container-cube .swiper-slide-shadow-right {\n  z-index: 0;\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n}\n.swiper-container-cube .swiper-cube-shadow {\n  position: absolute;\n  left: 0;\n  bottom: 0px;\n  width: 100%;\n  height: 100%;\n  background: #000;\n  opacity: 0.6;\n  -webkit-filter: blur(50px);\n  filter: blur(50px);\n  z-index: 0;\n}\n.swiper-container-flip {\n  overflow: visible;\n}\n.swiper-container-flip .swiper-slide {\n  pointer-events: none;\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  z-index: 1;\n}\n.swiper-container-flip .swiper-slide .swiper-slide {\n  pointer-events: none;\n}\n.swiper-container-flip .swiper-slide-active,\n.swiper-container-flip .swiper-slide-active .swiper-slide-active {\n  pointer-events: auto;\n}\n.swiper-container-flip .swiper-slide-shadow-top,\n.swiper-container-flip .swiper-slide-shadow-bottom,\n.swiper-container-flip .swiper-slide-shadow-left,\n.swiper-container-flip .swiper-slide-shadow-right {\n  z-index: 0;\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n}\n.swiper-container-coverflow .swiper-wrapper {\n  /* Windows 8 IE 10 fix */\n  -ms-perspective: 1200px;\n}\n\n/* line 2, stdin */\n.v-album-carousel {\n  margin: 0 auto;\n  margin-bottom: 160px;\n  max-height: 480px;\n  max-width: 640px;\n  background-color: white;\n  position: relative; }\n  /* line 10, stdin */\n  .v-album-carousel .pointer {\n    cursor: pointer; }\n  /* line 14, stdin */\n  .v-album-carousel .top-image {\n    max-height: 480px;\n    max-width: 640px;\n    width: auto;\n    height: auto;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    margin: auto;\n    border-radius: 15px; }\n  /* line 27, stdin */\n  .v-album-carousel .thumbs-image {\n    max-height: 120px;\n    max-width: 160px;\n    width: auto;\n    height: auto; }\n  /* line 35, stdin */\n  .v-album-carousel .swiper .swiper-slide {\n    background-size: cover;\n    background-position: center;\n    max-height: 480px;\n    overflow: hidden; }\n  /* line 41, stdin */\n  .v-album-carousel .swiper.gallery-top {\n    height: 80%;\n    width: 100%; }\n  /* line 45, stdin */\n  .v-album-carousel .swiper.gallery-thumbs {\n    height: 20%;\n    box-sizing: border-box;\n    padding: 18px 0; }\n  /* line 50, stdin */\n  .v-album-carousel .swiper.gallery-thumbs .swiper-slide {\n    width: 25%;\n    height: 100%;\n    opacity: 0.4; }\n  /* line 55, stdin */\n  .v-album-carousel .swiper.gallery-thumbs .swiper-slide-active {\n    opacity: 1; }\n\n@media (max-width: 1200px) {\n  /* line 62, stdin */\n  .v-album-carousel {\n    margin-bottom: 80px; } }\n\n@media (max-width: 992px) {\n  /* line 68, stdin */\n  .v-album-carousel {\n    margin-bottom: 0px; }\n  /* line 71, stdin */\n  .gallery-thumbs {\n    display: none; } }\n\n@media (max-width: 768px) {\n  /* line 77, stdin */\n  .gallery-thumbs {\n    display: none; } }\n\n@media (max-width: 576px) {\n  /* line 84, stdin */\n  .v-album-carousel {\n    margin-bottom: none; }\n    /* line 87, stdin */\n    .v-album-carousel .top-image {\n      border-radius: 0; }\n  /* line 91, stdin */\n  .swiper-button-prev, .swiper-button-next {\n    height: 30px; }\n  /* line 94, stdin */\n  .gallery-thumbs {\n    display: none; } }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vueAwesomeSwiper = require('vue-awesome-swiper');

exports.default = {
    components: {
        swiper: _vueAwesomeSwiper.swiper,
        swiperSlide: _vueAwesomeSwiper.swiperSlide
    },
    props: {
        width: {
            default: undefined
        },
        height: {
            default: undefined
        },
        loop: {
            type: Boolean,
            default: true
        },
        onClick: {
            type: Function,
            default: function _default() {}
        },
        slidSlots: {
            default: {}
        },
        init: {
            type: Boolean,
            default: true
        },
        navigationShow: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        swiperOptionTop: function swiperOptionTop() {
            return {
                'width': this.width,
                'height': this.height,
                'loop': this.loop,
                'init': this.init,
                'loopedSlides': 5, // looped slides should be the same
                'spaceBetween': 10,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                }
            };
        },
        swiperOptionThumbs: function swiperOptionThumbs() {
            return {
                'loop': this.loop,
                'loopedSlides': 5, // looped slides should be the same
                'spaceBetween': 10,
                'centeredSlides': true,
                'slidesPerView': 'auto',
                'touchRatio': 0.2,
                'slideToClickedSlide': true
            };
        },
        moreThan1Img: function moreThan1Img() {
            return this.slidSlots.length > 1;
        }
    },
    watch: {
        slidSlots: {
            deep: true,
            immediate: true,
            handler: function handler(newVal, oldVal) {
                if (newVal.length > 0) {
                    this.mountedCarousel();
                }
            }
        }
    },
    methods: {
        mountedCarousel: function mountedCarousel() {
            var _this = this;

            this.$nextTick(function () {
                var swiperTop = _this.$refs.myCarousel.swiper;
                var swiperThumbs = _this.$refs.swiperThumbs.swiper;
                swiperTop.controller.control = swiperThumbs;
                swiperThumbs.controller.control = swiperTop;
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"v-album-carousel\" v-if=\"Object.keys(slidSlots).length>0\">\n    <!--swiper carousel-->\n    <swiper class=\"swiper gallery-top\" :options=\"swiperOptionTop\" :auto-update=\"true\" ref=\"myCarousel\">\n        <swiper-slide v-for=\"(slidSlot,index) in slidSlots\" :key=\"index\">\n            <img class=\"top-image\" :src=\"slidSlot.src\" style=\"\n                    width: 100%;\n                    height: 100%;\n                \">\n        </swiper-slide>\n        \n        <!-- Optional controls -->\n        <div class=\"swiper-button-prev swiper-button-white pointer\" v-if=\"navigationShow &amp;&amp; moreThan1Img\" slot=\"button-prev\"></div>\n        <div class=\"swiper-button-next swiper-button-white pointer\" v-if=\"navigationShow &amp;&amp; moreThan1Img\" slot=\"button-next\"></div>\n    </swiper>\n    <!--/swiper carousel-->\n\n    <!--swiper thumb-->\n    <swiper v-if=\"moreThan1Img\" class=\"swiper gallery-thumbs\" :options=\"swiperOptionThumbs\" :auto-update=\"true\" ref=\"swiperThumbs\">\n        <swiper-slide v-for=\"(slidSlot,index) in slidSlots\" :key=\"index\">\n            <img class=\"pointer thumbs-image\" :src=\"slidSlot.src\" style=\"\n                    width: 100%;\n                    height: 100%;\n                \">\n        </swiper-slide>\n        \n    </swiper>\n    <!--/swiper thumb-->\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/**\n * Swiper 4.5.1\n * Most modern mobile touch slider and framework with hardware accelerated transitions\n * http://www.idangero.us/swiper/\n *\n * Copyright 2014-2019 Vladimir Kharlampidi\n *\n * Released under the MIT License\n *\n * Released on: September 13, 2019\n */\n.swiper-container {\n  margin-left: auto;\n  margin-right: auto;\n  position: relative;\n  overflow: hidden;\n  list-style: none;\n  padding: 0;\n  /* Fix of Webkit flickering */\n  z-index: 1;\n}\n.swiper-container-no-flexbox .swiper-slide {\n  float: left;\n}\n.swiper-container-vertical > .swiper-wrapper {\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n}\n.swiper-wrapper {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-transition-property: -webkit-transform;\n  transition-property: -webkit-transform;\n  -o-transition-property: transform;\n  transition-property: transform;\n  transition-property: transform, -webkit-transform;\n  -webkit-box-sizing: content-box;\n  box-sizing: content-box;\n}\n.swiper-container-android .swiper-slide,\n.swiper-wrapper {\n  -webkit-transform: translate3d(0px, 0, 0);\n  transform: translate3d(0px, 0, 0);\n}\n.swiper-container-multirow > .swiper-wrapper {\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n.swiper-container-free-mode > .swiper-wrapper {\n  -webkit-transition-timing-function: ease-out;\n  -o-transition-timing-function: ease-out;\n  transition-timing-function: ease-out;\n  margin: 0 auto;\n}\n.swiper-slide {\n  -webkit-flex-shrink: 0;\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n  width: 100%;\n  height: 100%;\n  position: relative;\n  -webkit-transition-property: -webkit-transform;\n  transition-property: -webkit-transform;\n  -o-transition-property: transform;\n  transition-property: transform;\n  transition-property: transform, -webkit-transform;\n}\n.swiper-slide-invisible-blank {\n  visibility: hidden;\n}\n/* Auto Height */\n.swiper-container-autoheight,\n.swiper-container-autoheight .swiper-slide {\n  height: auto;\n}\n.swiper-container-autoheight .swiper-wrapper {\n  -webkit-box-align: start;\n  -webkit-align-items: flex-start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  -webkit-transition-property: height, -webkit-transform;\n  transition-property: height, -webkit-transform;\n  -o-transition-property: transform, height;\n  transition-property: transform, height;\n  transition-property: transform, height, -webkit-transform;\n}\n/* 3D Effects */\n.swiper-container-3d {\n  -webkit-perspective: 1200px;\n  perspective: 1200px;\n}\n.swiper-container-3d .swiper-wrapper,\n.swiper-container-3d .swiper-slide,\n.swiper-container-3d .swiper-slide-shadow-left,\n.swiper-container-3d .swiper-slide-shadow-right,\n.swiper-container-3d .swiper-slide-shadow-top,\n.swiper-container-3d .swiper-slide-shadow-bottom,\n.swiper-container-3d .swiper-cube-shadow {\n  -webkit-transform-style: preserve-3d;\n  transform-style: preserve-3d;\n}\n.swiper-container-3d .swiper-slide-shadow-left,\n.swiper-container-3d .swiper-slide-shadow-right,\n.swiper-container-3d .swiper-slide-shadow-top,\n.swiper-container-3d .swiper-slide-shadow-bottom {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  z-index: 10;\n}\n.swiper-container-3d .swiper-slide-shadow-left {\n  background-image: -webkit-gradient(linear, right top, left top, from(rgba(0, 0, 0, 0.5)), to(rgba(0, 0, 0, 0)));\n  background-image: -webkit-linear-gradient(right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n  background-image: -o-linear-gradient(right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n  background-image: linear-gradient(to left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n}\n.swiper-container-3d .swiper-slide-shadow-right {\n  background-image: -webkit-gradient(linear, left top, right top, from(rgba(0, 0, 0, 0.5)), to(rgba(0, 0, 0, 0)));\n  background-image: -webkit-linear-gradient(left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n  background-image: -o-linear-gradient(left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n}\n.swiper-container-3d .swiper-slide-shadow-top {\n  background-image: -webkit-gradient(linear, left bottom, left top, from(rgba(0, 0, 0, 0.5)), to(rgba(0, 0, 0, 0)));\n  background-image: -webkit-linear-gradient(bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n  background-image: -o-linear-gradient(bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n  background-image: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n}\n.swiper-container-3d .swiper-slide-shadow-bottom {\n  background-image: -webkit-gradient(linear, left top, left bottom, from(rgba(0, 0, 0, 0.5)), to(rgba(0, 0, 0, 0)));\n  background-image: -webkit-linear-gradient(top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n  background-image: -o-linear-gradient(top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n}\n/* IE10 Windows Phone 8 Fixes */\n.swiper-container-wp8-horizontal,\n.swiper-container-wp8-horizontal > .swiper-wrapper {\n  -ms-touch-action: pan-y;\n  touch-action: pan-y;\n}\n.swiper-container-wp8-vertical,\n.swiper-container-wp8-vertical > .swiper-wrapper {\n  -ms-touch-action: pan-x;\n  touch-action: pan-x;\n}\n.swiper-button-prev,\n.swiper-button-next {\n  position: absolute;\n  top: 50%;\n  width: 27px;\n  height: 44px;\n  margin-top: -22px;\n  z-index: 10;\n  cursor: pointer;\n  background-size: 27px 44px;\n  background-position: center;\n  background-repeat: no-repeat;\n}\n.swiper-button-prev.swiper-button-disabled,\n.swiper-button-next.swiper-button-disabled {\n  opacity: 0.35;\n  cursor: auto;\n  pointer-events: none;\n}\n.swiper-button-prev,\n.swiper-container-rtl .swiper-button-next {\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z'%20fill%3D'%23007aff'%2F%3E%3C%2Fsvg%3E\");\n  left: 10px;\n  right: auto;\n}\n.swiper-button-next,\n.swiper-container-rtl .swiper-button-prev {\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%23007aff'%2F%3E%3C%2Fsvg%3E\");\n  right: 10px;\n  left: auto;\n}\n.swiper-button-prev.swiper-button-white,\n.swiper-container-rtl .swiper-button-next.swiper-button-white {\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z'%20fill%3D'%23ffffff'%2F%3E%3C%2Fsvg%3E\");\n}\n.swiper-button-next.swiper-button-white,\n.swiper-container-rtl .swiper-button-prev.swiper-button-white {\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%23ffffff'%2F%3E%3C%2Fsvg%3E\");\n}\n.swiper-button-prev.swiper-button-black,\n.swiper-container-rtl .swiper-button-next.swiper-button-black {\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z'%20fill%3D'%23000000'%2F%3E%3C%2Fsvg%3E\");\n}\n.swiper-button-next.swiper-button-black,\n.swiper-container-rtl .swiper-button-prev.swiper-button-black {\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%23000000'%2F%3E%3C%2Fsvg%3E\");\n}\n.swiper-button-lock {\n  display: none;\n}\n.swiper-pagination {\n  position: absolute;\n  text-align: center;\n  -webkit-transition: 300ms opacity;\n  -o-transition: 300ms opacity;\n  transition: 300ms opacity;\n  -webkit-transform: translate3d(0, 0, 0);\n  transform: translate3d(0, 0, 0);\n  z-index: 10;\n}\n.swiper-pagination.swiper-pagination-hidden {\n  opacity: 0;\n}\n/* Common Styles */\n.swiper-pagination-fraction,\n.swiper-pagination-custom,\n.swiper-container-horizontal > .swiper-pagination-bullets {\n  bottom: 10px;\n  left: 0;\n  width: 100%;\n}\n/* Bullets */\n.swiper-pagination-bullets-dynamic {\n  overflow: hidden;\n  font-size: 0;\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n  -webkit-transform: scale(0.33);\n  -ms-transform: scale(0.33);\n  transform: scale(0.33);\n  position: relative;\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active {\n  -webkit-transform: scale(1);\n  -ms-transform: scale(1);\n  transform: scale(1);\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main {\n  -webkit-transform: scale(1);\n  -ms-transform: scale(1);\n  transform: scale(1);\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev {\n  -webkit-transform: scale(0.66);\n  -ms-transform: scale(0.66);\n  transform: scale(0.66);\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev {\n  -webkit-transform: scale(0.33);\n  -ms-transform: scale(0.33);\n  transform: scale(0.33);\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next {\n  -webkit-transform: scale(0.66);\n  -ms-transform: scale(0.66);\n  transform: scale(0.66);\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next {\n  -webkit-transform: scale(0.33);\n  -ms-transform: scale(0.33);\n  transform: scale(0.33);\n}\n.swiper-pagination-bullet {\n  width: 8px;\n  height: 8px;\n  display: inline-block;\n  border-radius: 100%;\n  background: #000;\n  opacity: 0.2;\n}\nbutton.swiper-pagination-bullet {\n  border: none;\n  margin: 0;\n  padding: 0;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n}\n.swiper-pagination-clickable .swiper-pagination-bullet {\n  cursor: pointer;\n}\n.swiper-pagination-bullet-active {\n  opacity: 1;\n  background: #007aff;\n}\n.swiper-container-vertical > .swiper-pagination-bullets {\n  right: 10px;\n  top: 50%;\n  -webkit-transform: translate3d(0px, -50%, 0);\n  transform: translate3d(0px, -50%, 0);\n}\n.swiper-container-vertical > .swiper-pagination-bullets .swiper-pagination-bullet {\n  margin: 6px 0;\n  display: block;\n}\n.swiper-container-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic {\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%);\n  width: 8px;\n}\n.swiper-container-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n  display: inline-block;\n  -webkit-transition: 200ms top, 200ms -webkit-transform;\n  transition: 200ms top, 200ms -webkit-transform;\n  -o-transition: 200ms transform, 200ms top;\n  transition: 200ms transform, 200ms top;\n  transition: 200ms transform, 200ms top, 200ms -webkit-transform;\n}\n.swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet {\n  margin: 0 4px;\n}\n.swiper-container-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic {\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n  -ms-transform: translateX(-50%);\n  transform: translateX(-50%);\n  white-space: nowrap;\n}\n.swiper-container-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n  -webkit-transition: 200ms left, 200ms -webkit-transform;\n  transition: 200ms left, 200ms -webkit-transform;\n  -o-transition: 200ms transform, 200ms left;\n  transition: 200ms transform, 200ms left;\n  transition: 200ms transform, 200ms left, 200ms -webkit-transform;\n}\n.swiper-container-horizontal.swiper-container-rtl > .swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n  -webkit-transition: 200ms right, 200ms -webkit-transform;\n  transition: 200ms right, 200ms -webkit-transform;\n  -o-transition: 200ms transform, 200ms right;\n  transition: 200ms transform, 200ms right;\n  transition: 200ms transform, 200ms right, 200ms -webkit-transform;\n}\n/* Progress */\n.swiper-pagination-progressbar {\n  background: rgba(0, 0, 0, 0.25);\n  position: absolute;\n}\n.swiper-pagination-progressbar .swiper-pagination-progressbar-fill {\n  background: #007aff;\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  -webkit-transform: scale(0);\n  -ms-transform: scale(0);\n  transform: scale(0);\n  -webkit-transform-origin: left top;\n  -ms-transform-origin: left top;\n  transform-origin: left top;\n}\n.swiper-container-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {\n  -webkit-transform-origin: right top;\n  -ms-transform-origin: right top;\n  transform-origin: right top;\n}\n.swiper-container-horizontal > .swiper-pagination-progressbar,\n.swiper-container-vertical > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite {\n  width: 100%;\n  height: 4px;\n  left: 0;\n  top: 0;\n}\n.swiper-container-vertical > .swiper-pagination-progressbar,\n.swiper-container-horizontal > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite {\n  width: 4px;\n  height: 100%;\n  left: 0;\n  top: 0;\n}\n.swiper-pagination-white .swiper-pagination-bullet-active {\n  background: #ffffff;\n}\n.swiper-pagination-progressbar.swiper-pagination-white {\n  background: rgba(255, 255, 255, 0.25);\n}\n.swiper-pagination-progressbar.swiper-pagination-white .swiper-pagination-progressbar-fill {\n  background: #ffffff;\n}\n.swiper-pagination-black .swiper-pagination-bullet-active {\n  background: #000000;\n}\n.swiper-pagination-progressbar.swiper-pagination-black {\n  background: rgba(0, 0, 0, 0.25);\n}\n.swiper-pagination-progressbar.swiper-pagination-black .swiper-pagination-progressbar-fill {\n  background: #000000;\n}\n.swiper-pagination-lock {\n  display: none;\n}\n/* Scrollbar */\n.swiper-scrollbar {\n  border-radius: 10px;\n  position: relative;\n  -ms-touch-action: none;\n  background: rgba(0, 0, 0, 0.1);\n}\n.swiper-container-horizontal > .swiper-scrollbar {\n  position: absolute;\n  left: 1%;\n  bottom: 3px;\n  z-index: 50;\n  height: 5px;\n  width: 98%;\n}\n.swiper-container-vertical > .swiper-scrollbar {\n  position: absolute;\n  right: 3px;\n  top: 1%;\n  z-index: 50;\n  width: 5px;\n  height: 98%;\n}\n.swiper-scrollbar-drag {\n  height: 100%;\n  width: 100%;\n  position: relative;\n  background: rgba(0, 0, 0, 0.5);\n  border-radius: 10px;\n  left: 0;\n  top: 0;\n}\n.swiper-scrollbar-cursor-drag {\n  cursor: move;\n}\n.swiper-scrollbar-lock {\n  display: none;\n}\n.swiper-zoom-container {\n  width: 100%;\n  height: 100%;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  text-align: center;\n}\n.swiper-zoom-container > img,\n.swiper-zoom-container > svg,\n.swiper-zoom-container > canvas {\n  max-width: 100%;\n  max-height: 100%;\n  -o-object-fit: contain;\n  object-fit: contain;\n}\n.swiper-slide-zoomed {\n  cursor: move;\n}\n/* Preloader */\n.swiper-lazy-preloader {\n  width: 42px;\n  height: 42px;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  margin-left: -21px;\n  margin-top: -21px;\n  z-index: 10;\n  -webkit-transform-origin: 50%;\n  -ms-transform-origin: 50%;\n  transform-origin: 50%;\n  -webkit-animation: swiper-preloader-spin 1s steps(12, end) infinite;\n  animation: swiper-preloader-spin 1s steps(12, end) infinite;\n}\n.swiper-lazy-preloader:after {\n  display: block;\n  content: '';\n  width: 100%;\n  height: 100%;\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20viewBox%3D'0%200%20120%20120'%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20xmlns%3Axlink%3D'http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink'%3E%3Cdefs%3E%3Cline%20id%3D'l'%20x1%3D'60'%20x2%3D'60'%20y1%3D'7'%20y2%3D'27'%20stroke%3D'%236c6c6c'%20stroke-width%3D'11'%20stroke-linecap%3D'round'%2F%3E%3C%2Fdefs%3E%3Cg%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(30%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(60%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(90%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(120%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(150%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.37'%20transform%3D'rotate(180%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.46'%20transform%3D'rotate(210%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.56'%20transform%3D'rotate(240%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.66'%20transform%3D'rotate(270%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.75'%20transform%3D'rotate(300%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.85'%20transform%3D'rotate(330%2060%2C60)'%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E\");\n  background-position: 50%;\n  background-size: 100%;\n  background-repeat: no-repeat;\n}\n.swiper-lazy-preloader-white:after {\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20viewBox%3D'0%200%20120%20120'%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20xmlns%3Axlink%3D'http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink'%3E%3Cdefs%3E%3Cline%20id%3D'l'%20x1%3D'60'%20x2%3D'60'%20y1%3D'7'%20y2%3D'27'%20stroke%3D'%23fff'%20stroke-width%3D'11'%20stroke-linecap%3D'round'%2F%3E%3C%2Fdefs%3E%3Cg%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(30%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(60%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(90%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(120%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(150%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.37'%20transform%3D'rotate(180%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.46'%20transform%3D'rotate(210%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.56'%20transform%3D'rotate(240%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.66'%20transform%3D'rotate(270%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.75'%20transform%3D'rotate(300%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.85'%20transform%3D'rotate(330%2060%2C60)'%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E\");\n}\n@-webkit-keyframes swiper-preloader-spin {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@keyframes swiper-preloader-spin {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n/* a11y */\n.swiper-container .swiper-notification {\n  position: absolute;\n  left: 0;\n  top: 0;\n  pointer-events: none;\n  opacity: 0;\n  z-index: -1000;\n}\n.swiper-container-fade.swiper-container-free-mode .swiper-slide {\n  -webkit-transition-timing-function: ease-out;\n  -o-transition-timing-function: ease-out;\n  transition-timing-function: ease-out;\n}\n.swiper-container-fade .swiper-slide {\n  pointer-events: none;\n  -webkit-transition-property: opacity;\n  -o-transition-property: opacity;\n  transition-property: opacity;\n}\n.swiper-container-fade .swiper-slide .swiper-slide {\n  pointer-events: none;\n}\n.swiper-container-fade .swiper-slide-active,\n.swiper-container-fade .swiper-slide-active .swiper-slide-active {\n  pointer-events: auto;\n}\n.swiper-container-cube {\n  overflow: visible;\n}\n.swiper-container-cube .swiper-slide {\n  pointer-events: none;\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  z-index: 1;\n  visibility: hidden;\n  -webkit-transform-origin: 0 0;\n  -ms-transform-origin: 0 0;\n  transform-origin: 0 0;\n  width: 100%;\n  height: 100%;\n}\n.swiper-container-cube .swiper-slide .swiper-slide {\n  pointer-events: none;\n}\n.swiper-container-cube.swiper-container-rtl .swiper-slide {\n  -webkit-transform-origin: 100% 0;\n  -ms-transform-origin: 100% 0;\n  transform-origin: 100% 0;\n}\n.swiper-container-cube .swiper-slide-active,\n.swiper-container-cube .swiper-slide-active .swiper-slide-active {\n  pointer-events: auto;\n}\n.swiper-container-cube .swiper-slide-active,\n.swiper-container-cube .swiper-slide-next,\n.swiper-container-cube .swiper-slide-prev,\n.swiper-container-cube .swiper-slide-next + .swiper-slide {\n  pointer-events: auto;\n  visibility: visible;\n}\n.swiper-container-cube .swiper-slide-shadow-top,\n.swiper-container-cube .swiper-slide-shadow-bottom,\n.swiper-container-cube .swiper-slide-shadow-left,\n.swiper-container-cube .swiper-slide-shadow-right {\n  z-index: 0;\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n}\n.swiper-container-cube .swiper-cube-shadow {\n  position: absolute;\n  left: 0;\n  bottom: 0px;\n  width: 100%;\n  height: 100%;\n  background: #000;\n  opacity: 0.6;\n  -webkit-filter: blur(50px);\n  filter: blur(50px);\n  z-index: 0;\n}\n.swiper-container-flip {\n  overflow: visible;\n}\n.swiper-container-flip .swiper-slide {\n  pointer-events: none;\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  z-index: 1;\n}\n.swiper-container-flip .swiper-slide .swiper-slide {\n  pointer-events: none;\n}\n.swiper-container-flip .swiper-slide-active,\n.swiper-container-flip .swiper-slide-active .swiper-slide-active {\n  pointer-events: auto;\n}\n.swiper-container-flip .swiper-slide-shadow-top,\n.swiper-container-flip .swiper-slide-shadow-bottom,\n.swiper-container-flip .swiper-slide-shadow-left,\n.swiper-container-flip .swiper-slide-shadow-right {\n  z-index: 0;\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n}\n.swiper-container-coverflow .swiper-wrapper {\n  /* Windows 8 IE 10 fix */\n  -ms-perspective: 1200px;\n}\n\n/* line 2, stdin */\n.v-album-carousel {\n  margin: 0 auto;\n  margin-bottom: 160px;\n  max-height: 480px;\n  max-width: 640px;\n  background-color: white;\n  position: relative; }\n  /* line 10, stdin */\n  .v-album-carousel .pointer {\n    cursor: pointer; }\n  /* line 14, stdin */\n  .v-album-carousel .top-image {\n    max-height: 480px;\n    max-width: 640px;\n    width: auto;\n    height: auto;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    margin: auto;\n    border-radius: 15px; }\n  /* line 27, stdin */\n  .v-album-carousel .thumbs-image {\n    max-height: 120px;\n    max-width: 160px;\n    width: auto;\n    height: auto; }\n  /* line 35, stdin */\n  .v-album-carousel .swiper .swiper-slide {\n    background-size: cover;\n    background-position: center;\n    max-height: 480px;\n    overflow: hidden; }\n  /* line 41, stdin */\n  .v-album-carousel .swiper.gallery-top {\n    height: 80%;\n    width: 100%; }\n  /* line 45, stdin */\n  .v-album-carousel .swiper.gallery-thumbs {\n    height: 20%;\n    box-sizing: border-box;\n    padding: 18px 0; }\n  /* line 50, stdin */\n  .v-album-carousel .swiper.gallery-thumbs .swiper-slide {\n    width: 25%;\n    height: 100%;\n    opacity: 0.4; }\n  /* line 55, stdin */\n  .v-album-carousel .swiper.gallery-thumbs .swiper-slide-active {\n    opacity: 1; }\n\n@media (max-width: 1200px) {\n  /* line 62, stdin */\n  .v-album-carousel {\n    margin-bottom: 80px; } }\n\n@media (max-width: 992px) {\n  /* line 68, stdin */\n  .v-album-carousel {\n    margin-bottom: 0px; }\n  /* line 71, stdin */\n  .gallery-thumbs {\n    display: none; } }\n\n@media (max-width: 768px) {\n  /* line 77, stdin */\n  .gallery-thumbs {\n    display: none; } }\n\n@media (max-width: 576px) {\n  /* line 84, stdin */\n  .v-album-carousel {\n    margin-bottom: none; }\n    /* line 87, stdin */\n    .v-album-carousel .top-image {\n      border-radius: 0; }\n  /* line 91, stdin */\n  .swiper-button-prev, .swiper-button-next {\n    height: 30px; }\n  /* line 94, stdin */\n  .gallery-thumbs {\n    display: none; } }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-122e2b3e", module.exports)
  } else {
    hotAPI.update("_v-122e2b3e", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-awesome-swiper":783,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1507:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    data: function data() {
        return {
            notifications: {}
        };
    },
    mounted: function mounted() {
        this.fetchBgNotifications();
    },

    methods: {
        fetchBgNotifications: function fetchBgNotifications() {
            $.getJSON('/adminapi/system/show-alert/webadmin', function (data) {
                this.notifications = data;
            }.bind(this));
        },
        alertClose: function alertClose() {
            var postData = {
                alert_id: this.notifications.alert_id,
                position: this.notifications.position
            };
            this.$http.post('/adminapi/system/close-alert', postData);
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"alert alert-dismissible\" :class=\"notifications.style\" v-show=\"notifications.state === 1\">\n    <button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-label=\"Close\" v-if=\"notifications.allow_close === 1\" @click=\"alertClose\">\n        <span aria-hidden=\"true\">×</span>\n    </button>\n    <span><a v-if=\"notifications.link\" :href=\"notifications.link\" target=\"_blank\">{{notifications.text}}</a><span v-else=\"\">{{notifications.text}}</span></span>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-a7474a42", module.exports)
  } else {
    hotAPI.update("_v-a7474a42", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],1508:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n.blockUI {\n  z-index: 2011;\n  position: fixed;\n  padding: 5px;\n  margin: 0px;\n  width: 30%;\n  top: 40%;\n  left: 35%;\n  text-align: center;\n  color: rgb(255, 255, 255);\n  border: none;\n  background-color: rgb(0, 0, 0);\n  cursor: wait;\n  opacity: 0.6;\n  border-radius: 10px;\n}\n.blockOverlay{\n  z-index: 2000;\n  border: none;\n  margin: 0px;\n  padding: 0px;\n  width: 100%;\n  height: 100%;\n  top: 0px;\n  left: 0px;\n  background-color: rgb(0, 0, 0);\n  opacity: 0.6;\n  cursor: wait;\n  position: fixed;\n}\n")
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    count: {
      type: [String, Number],
      required: true,
      default: 1
    },
    singleTime: {
      type: [String, Number],
      required: true,
      default: 100
    }
  },
  data: function data() {
    return {
      percentage: 0,
      execution: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    var interval = parseInt(this.count) * parseInt(this.singleTime) / 100;
    this.execution = setInterval(function () {
      if (_this.percentage < 100) {
        _this.percentage++;
      } else {
        clearInterval(_this.execution);
      }
    }, interval);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.execution);
  }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div>\n  <div class=\"blockOverlay\"></div>\n  <div class=\"blockUI\">\n    <h5><i class=\"fa fa-refresh fa-spin\"></i> 處理中...{{percentage}}%</h5>\n  </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n.blockUI {\n  z-index: 2011;\n  position: fixed;\n  padding: 5px;\n  margin: 0px;\n  width: 30%;\n  top: 40%;\n  left: 35%;\n  text-align: center;\n  color: rgb(255, 255, 255);\n  border: none;\n  background-color: rgb(0, 0, 0);\n  cursor: wait;\n  opacity: 0.6;\n  border-radius: 10px;\n}\n.blockOverlay{\n  z-index: 2000;\n  border: none;\n  margin: 0px;\n  padding: 0px;\n  width: 100%;\n  height: 100%;\n  top: 0px;\n  left: 0px;\n  background-color: rgb(0, 0, 0);\n  opacity: 0.6;\n  cursor: wait;\n  position: fixed;\n}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-7fcd9cd7", module.exports)
  } else {
    hotAPI.update("_v-7fcd9cd7", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1509:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});


var inc = new Date().getTime();
exports.default = {
    props: {
        value: {
            default: 1 // 1=開啟,0=關閉
        },
        trueValue: {
            default: 1
        },
        falseValue: {
            default: 0
        },
        id: {
            type: String,
            default: 'bs-switch-' + inc
        },
        onText: {
            type: String,
            default: '開啟'
        },
        offText: {
            type: String,
            default: '關閉'
        },
        disabled: {
            default: false
        }
    },
    data: function data() {
        return {};
    },
    mounted: function mounted() {
        this.init();
    },

    watch: {
        disabled: function disabled(newVal) {
            var _this = this;

            this.$nextTick(function () {
                $('#' + _this.id).bootstrapSwitch('toggleDisabled', newVal, newVal);
            });
        }
    },
    updated: function updated() {
        var value = this.value == this.trueValue ? 1 : 0;
        $('#' + this.id).bootstrapSwitch('state', value);
    },

    methods: {
        init: function init() {
            var _this2 = this;

            var id = this.id;
            var onText = this.onText;
            var offText = this.offText;
            var value = this.value == this.trueValue ? 1 : 0;
            $.fn.bootstrapSwitch.defaults.onColor = 'info';
            this.$nextTick(function () {
                $('#' + id).bootstrapSwitch({
                    onText: onText,
                    offText: offText,
                    state: value
                }).on('switchChange.bootstrapSwitch', _this2.switchChange);
            });
        },
        switchChange: function switchChange(event, state) {
            var newValue = state == 1 ? this.trueValue : this.falseValue;
            this.$emit('input', newValue);
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<input type=\"checkbox\" :disabled=\"disabled\" :id=\"id\" :value=\"value\">\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-425c0733", module.exports)
  } else {
    hotAPI.update("_v-425c0733", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],1510:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/**\n * Swiper 4.5.1\n * Most modern mobile touch slider and framework with hardware accelerated transitions\n * http://www.idangero.us/swiper/\n *\n * Copyright 2014-2019 Vladimir Kharlampidi\n *\n * Released under the MIT License\n *\n * Released on: September 13, 2019\n */\n.swiper-container {\n  margin-left: auto;\n  margin-right: auto;\n  position: relative;\n  overflow: hidden;\n  list-style: none;\n  padding: 0;\n  /* Fix of Webkit flickering */\n  z-index: 1;\n}\n.swiper-container-no-flexbox .swiper-slide {\n  float: left;\n}\n.swiper-container-vertical > .swiper-wrapper {\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n}\n.swiper-wrapper {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-transition-property: -webkit-transform;\n  transition-property: -webkit-transform;\n  -o-transition-property: transform;\n  transition-property: transform;\n  transition-property: transform, -webkit-transform;\n  -webkit-box-sizing: content-box;\n  box-sizing: content-box;\n}\n.swiper-container-android .swiper-slide,\n.swiper-wrapper {\n  -webkit-transform: translate3d(0px, 0, 0);\n  transform: translate3d(0px, 0, 0);\n}\n.swiper-container-multirow > .swiper-wrapper {\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n.swiper-container-free-mode > .swiper-wrapper {\n  -webkit-transition-timing-function: ease-out;\n  -o-transition-timing-function: ease-out;\n  transition-timing-function: ease-out;\n  margin: 0 auto;\n}\n.swiper-slide {\n  -webkit-flex-shrink: 0;\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n  width: 100%;\n  height: 100%;\n  position: relative;\n  -webkit-transition-property: -webkit-transform;\n  transition-property: -webkit-transform;\n  -o-transition-property: transform;\n  transition-property: transform;\n  transition-property: transform, -webkit-transform;\n}\n.swiper-slide-invisible-blank {\n  visibility: hidden;\n}\n/* Auto Height */\n.swiper-container-autoheight,\n.swiper-container-autoheight .swiper-slide {\n  height: auto;\n}\n.swiper-container-autoheight .swiper-wrapper {\n  -webkit-box-align: start;\n  -webkit-align-items: flex-start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  -webkit-transition-property: height, -webkit-transform;\n  transition-property: height, -webkit-transform;\n  -o-transition-property: transform, height;\n  transition-property: transform, height;\n  transition-property: transform, height, -webkit-transform;\n}\n/* 3D Effects */\n.swiper-container-3d {\n  -webkit-perspective: 1200px;\n  perspective: 1200px;\n}\n.swiper-container-3d .swiper-wrapper,\n.swiper-container-3d .swiper-slide,\n.swiper-container-3d .swiper-slide-shadow-left,\n.swiper-container-3d .swiper-slide-shadow-right,\n.swiper-container-3d .swiper-slide-shadow-top,\n.swiper-container-3d .swiper-slide-shadow-bottom,\n.swiper-container-3d .swiper-cube-shadow {\n  -webkit-transform-style: preserve-3d;\n  transform-style: preserve-3d;\n}\n.swiper-container-3d .swiper-slide-shadow-left,\n.swiper-container-3d .swiper-slide-shadow-right,\n.swiper-container-3d .swiper-slide-shadow-top,\n.swiper-container-3d .swiper-slide-shadow-bottom {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  z-index: 10;\n}\n.swiper-container-3d .swiper-slide-shadow-left {\n  background-image: -webkit-gradient(linear, right top, left top, from(rgba(0, 0, 0, 0.5)), to(rgba(0, 0, 0, 0)));\n  background-image: -webkit-linear-gradient(right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n  background-image: -o-linear-gradient(right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n  background-image: linear-gradient(to left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n}\n.swiper-container-3d .swiper-slide-shadow-right {\n  background-image: -webkit-gradient(linear, left top, right top, from(rgba(0, 0, 0, 0.5)), to(rgba(0, 0, 0, 0)));\n  background-image: -webkit-linear-gradient(left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n  background-image: -o-linear-gradient(left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n}\n.swiper-container-3d .swiper-slide-shadow-top {\n  background-image: -webkit-gradient(linear, left bottom, left top, from(rgba(0, 0, 0, 0.5)), to(rgba(0, 0, 0, 0)));\n  background-image: -webkit-linear-gradient(bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n  background-image: -o-linear-gradient(bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n  background-image: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n}\n.swiper-container-3d .swiper-slide-shadow-bottom {\n  background-image: -webkit-gradient(linear, left top, left bottom, from(rgba(0, 0, 0, 0.5)), to(rgba(0, 0, 0, 0)));\n  background-image: -webkit-linear-gradient(top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n  background-image: -o-linear-gradient(top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n}\n/* IE10 Windows Phone 8 Fixes */\n.swiper-container-wp8-horizontal,\n.swiper-container-wp8-horizontal > .swiper-wrapper {\n  -ms-touch-action: pan-y;\n  touch-action: pan-y;\n}\n.swiper-container-wp8-vertical,\n.swiper-container-wp8-vertical > .swiper-wrapper {\n  -ms-touch-action: pan-x;\n  touch-action: pan-x;\n}\n.swiper-button-prev,\n.swiper-button-next {\n  position: absolute;\n  top: 50%;\n  width: 27px;\n  height: 44px;\n  margin-top: -22px;\n  z-index: 10;\n  cursor: pointer;\n  background-size: 27px 44px;\n  background-position: center;\n  background-repeat: no-repeat;\n}\n.swiper-button-prev.swiper-button-disabled,\n.swiper-button-next.swiper-button-disabled {\n  opacity: 0.35;\n  cursor: auto;\n  pointer-events: none;\n}\n.swiper-button-prev,\n.swiper-container-rtl .swiper-button-next {\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z'%20fill%3D'%23007aff'%2F%3E%3C%2Fsvg%3E\");\n  left: 10px;\n  right: auto;\n}\n.swiper-button-next,\n.swiper-container-rtl .swiper-button-prev {\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%23007aff'%2F%3E%3C%2Fsvg%3E\");\n  right: 10px;\n  left: auto;\n}\n.swiper-button-prev.swiper-button-white,\n.swiper-container-rtl .swiper-button-next.swiper-button-white {\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z'%20fill%3D'%23ffffff'%2F%3E%3C%2Fsvg%3E\");\n}\n.swiper-button-next.swiper-button-white,\n.swiper-container-rtl .swiper-button-prev.swiper-button-white {\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%23ffffff'%2F%3E%3C%2Fsvg%3E\");\n}\n.swiper-button-prev.swiper-button-black,\n.swiper-container-rtl .swiper-button-next.swiper-button-black {\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z'%20fill%3D'%23000000'%2F%3E%3C%2Fsvg%3E\");\n}\n.swiper-button-next.swiper-button-black,\n.swiper-container-rtl .swiper-button-prev.swiper-button-black {\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%23000000'%2F%3E%3C%2Fsvg%3E\");\n}\n.swiper-button-lock {\n  display: none;\n}\n.swiper-pagination {\n  position: absolute;\n  text-align: center;\n  -webkit-transition: 300ms opacity;\n  -o-transition: 300ms opacity;\n  transition: 300ms opacity;\n  -webkit-transform: translate3d(0, 0, 0);\n  transform: translate3d(0, 0, 0);\n  z-index: 10;\n}\n.swiper-pagination.swiper-pagination-hidden {\n  opacity: 0;\n}\n/* Common Styles */\n.swiper-pagination-fraction,\n.swiper-pagination-custom,\n.swiper-container-horizontal > .swiper-pagination-bullets {\n  bottom: 10px;\n  left: 0;\n  width: 100%;\n}\n/* Bullets */\n.swiper-pagination-bullets-dynamic {\n  overflow: hidden;\n  font-size: 0;\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n  -webkit-transform: scale(0.33);\n  -ms-transform: scale(0.33);\n  transform: scale(0.33);\n  position: relative;\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active {\n  -webkit-transform: scale(1);\n  -ms-transform: scale(1);\n  transform: scale(1);\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main {\n  -webkit-transform: scale(1);\n  -ms-transform: scale(1);\n  transform: scale(1);\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev {\n  -webkit-transform: scale(0.66);\n  -ms-transform: scale(0.66);\n  transform: scale(0.66);\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev {\n  -webkit-transform: scale(0.33);\n  -ms-transform: scale(0.33);\n  transform: scale(0.33);\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next {\n  -webkit-transform: scale(0.66);\n  -ms-transform: scale(0.66);\n  transform: scale(0.66);\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next {\n  -webkit-transform: scale(0.33);\n  -ms-transform: scale(0.33);\n  transform: scale(0.33);\n}\n.swiper-pagination-bullet {\n  width: 8px;\n  height: 8px;\n  display: inline-block;\n  border-radius: 100%;\n  background: #000;\n  opacity: 0.2;\n}\nbutton.swiper-pagination-bullet {\n  border: none;\n  margin: 0;\n  padding: 0;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n}\n.swiper-pagination-clickable .swiper-pagination-bullet {\n  cursor: pointer;\n}\n.swiper-pagination-bullet-active {\n  opacity: 1;\n  background: #007aff;\n}\n.swiper-container-vertical > .swiper-pagination-bullets {\n  right: 10px;\n  top: 50%;\n  -webkit-transform: translate3d(0px, -50%, 0);\n  transform: translate3d(0px, -50%, 0);\n}\n.swiper-container-vertical > .swiper-pagination-bullets .swiper-pagination-bullet {\n  margin: 6px 0;\n  display: block;\n}\n.swiper-container-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic {\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%);\n  width: 8px;\n}\n.swiper-container-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n  display: inline-block;\n  -webkit-transition: 200ms top, 200ms -webkit-transform;\n  transition: 200ms top, 200ms -webkit-transform;\n  -o-transition: 200ms transform, 200ms top;\n  transition: 200ms transform, 200ms top;\n  transition: 200ms transform, 200ms top, 200ms -webkit-transform;\n}\n.swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet {\n  margin: 0 4px;\n}\n.swiper-container-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic {\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n  -ms-transform: translateX(-50%);\n  transform: translateX(-50%);\n  white-space: nowrap;\n}\n.swiper-container-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n  -webkit-transition: 200ms left, 200ms -webkit-transform;\n  transition: 200ms left, 200ms -webkit-transform;\n  -o-transition: 200ms transform, 200ms left;\n  transition: 200ms transform, 200ms left;\n  transition: 200ms transform, 200ms left, 200ms -webkit-transform;\n}\n.swiper-container-horizontal.swiper-container-rtl > .swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n  -webkit-transition: 200ms right, 200ms -webkit-transform;\n  transition: 200ms right, 200ms -webkit-transform;\n  -o-transition: 200ms transform, 200ms right;\n  transition: 200ms transform, 200ms right;\n  transition: 200ms transform, 200ms right, 200ms -webkit-transform;\n}\n/* Progress */\n.swiper-pagination-progressbar {\n  background: rgba(0, 0, 0, 0.25);\n  position: absolute;\n}\n.swiper-pagination-progressbar .swiper-pagination-progressbar-fill {\n  background: #007aff;\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  -webkit-transform: scale(0);\n  -ms-transform: scale(0);\n  transform: scale(0);\n  -webkit-transform-origin: left top;\n  -ms-transform-origin: left top;\n  transform-origin: left top;\n}\n.swiper-container-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {\n  -webkit-transform-origin: right top;\n  -ms-transform-origin: right top;\n  transform-origin: right top;\n}\n.swiper-container-horizontal > .swiper-pagination-progressbar,\n.swiper-container-vertical > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite {\n  width: 100%;\n  height: 4px;\n  left: 0;\n  top: 0;\n}\n.swiper-container-vertical > .swiper-pagination-progressbar,\n.swiper-container-horizontal > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite {\n  width: 4px;\n  height: 100%;\n  left: 0;\n  top: 0;\n}\n.swiper-pagination-white .swiper-pagination-bullet-active {\n  background: #ffffff;\n}\n.swiper-pagination-progressbar.swiper-pagination-white {\n  background: rgba(255, 255, 255, 0.25);\n}\n.swiper-pagination-progressbar.swiper-pagination-white .swiper-pagination-progressbar-fill {\n  background: #ffffff;\n}\n.swiper-pagination-black .swiper-pagination-bullet-active {\n  background: #000000;\n}\n.swiper-pagination-progressbar.swiper-pagination-black {\n  background: rgba(0, 0, 0, 0.25);\n}\n.swiper-pagination-progressbar.swiper-pagination-black .swiper-pagination-progressbar-fill {\n  background: #000000;\n}\n.swiper-pagination-lock {\n  display: none;\n}\n/* Scrollbar */\n.swiper-scrollbar {\n  border-radius: 10px;\n  position: relative;\n  -ms-touch-action: none;\n  background: rgba(0, 0, 0, 0.1);\n}\n.swiper-container-horizontal > .swiper-scrollbar {\n  position: absolute;\n  left: 1%;\n  bottom: 3px;\n  z-index: 50;\n  height: 5px;\n  width: 98%;\n}\n.swiper-container-vertical > .swiper-scrollbar {\n  position: absolute;\n  right: 3px;\n  top: 1%;\n  z-index: 50;\n  width: 5px;\n  height: 98%;\n}\n.swiper-scrollbar-drag {\n  height: 100%;\n  width: 100%;\n  position: relative;\n  background: rgba(0, 0, 0, 0.5);\n  border-radius: 10px;\n  left: 0;\n  top: 0;\n}\n.swiper-scrollbar-cursor-drag {\n  cursor: move;\n}\n.swiper-scrollbar-lock {\n  display: none;\n}\n.swiper-zoom-container {\n  width: 100%;\n  height: 100%;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  text-align: center;\n}\n.swiper-zoom-container > img,\n.swiper-zoom-container > svg,\n.swiper-zoom-container > canvas {\n  max-width: 100%;\n  max-height: 100%;\n  -o-object-fit: contain;\n  object-fit: contain;\n}\n.swiper-slide-zoomed {\n  cursor: move;\n}\n/* Preloader */\n.swiper-lazy-preloader {\n  width: 42px;\n  height: 42px;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  margin-left: -21px;\n  margin-top: -21px;\n  z-index: 10;\n  -webkit-transform-origin: 50%;\n  -ms-transform-origin: 50%;\n  transform-origin: 50%;\n  -webkit-animation: swiper-preloader-spin 1s steps(12, end) infinite;\n  animation: swiper-preloader-spin 1s steps(12, end) infinite;\n}\n.swiper-lazy-preloader:after {\n  display: block;\n  content: '';\n  width: 100%;\n  height: 100%;\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20viewBox%3D'0%200%20120%20120'%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20xmlns%3Axlink%3D'http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink'%3E%3Cdefs%3E%3Cline%20id%3D'l'%20x1%3D'60'%20x2%3D'60'%20y1%3D'7'%20y2%3D'27'%20stroke%3D'%236c6c6c'%20stroke-width%3D'11'%20stroke-linecap%3D'round'%2F%3E%3C%2Fdefs%3E%3Cg%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(30%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(60%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(90%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(120%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(150%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.37'%20transform%3D'rotate(180%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.46'%20transform%3D'rotate(210%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.56'%20transform%3D'rotate(240%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.66'%20transform%3D'rotate(270%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.75'%20transform%3D'rotate(300%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.85'%20transform%3D'rotate(330%2060%2C60)'%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E\");\n  background-position: 50%;\n  background-size: 100%;\n  background-repeat: no-repeat;\n}\n.swiper-lazy-preloader-white:after {\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20viewBox%3D'0%200%20120%20120'%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20xmlns%3Axlink%3D'http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink'%3E%3Cdefs%3E%3Cline%20id%3D'l'%20x1%3D'60'%20x2%3D'60'%20y1%3D'7'%20y2%3D'27'%20stroke%3D'%23fff'%20stroke-width%3D'11'%20stroke-linecap%3D'round'%2F%3E%3C%2Fdefs%3E%3Cg%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(30%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(60%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(90%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(120%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(150%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.37'%20transform%3D'rotate(180%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.46'%20transform%3D'rotate(210%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.56'%20transform%3D'rotate(240%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.66'%20transform%3D'rotate(270%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.75'%20transform%3D'rotate(300%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.85'%20transform%3D'rotate(330%2060%2C60)'%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E\");\n}\n@-webkit-keyframes swiper-preloader-spin {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@keyframes swiper-preloader-spin {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n/* a11y */\n.swiper-container .swiper-notification {\n  position: absolute;\n  left: 0;\n  top: 0;\n  pointer-events: none;\n  opacity: 0;\n  z-index: -1000;\n}\n.swiper-container-fade.swiper-container-free-mode .swiper-slide {\n  -webkit-transition-timing-function: ease-out;\n  -o-transition-timing-function: ease-out;\n  transition-timing-function: ease-out;\n}\n.swiper-container-fade .swiper-slide {\n  pointer-events: none;\n  -webkit-transition-property: opacity;\n  -o-transition-property: opacity;\n  transition-property: opacity;\n}\n.swiper-container-fade .swiper-slide .swiper-slide {\n  pointer-events: none;\n}\n.swiper-container-fade .swiper-slide-active,\n.swiper-container-fade .swiper-slide-active .swiper-slide-active {\n  pointer-events: auto;\n}\n.swiper-container-cube {\n  overflow: visible;\n}\n.swiper-container-cube .swiper-slide {\n  pointer-events: none;\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  z-index: 1;\n  visibility: hidden;\n  -webkit-transform-origin: 0 0;\n  -ms-transform-origin: 0 0;\n  transform-origin: 0 0;\n  width: 100%;\n  height: 100%;\n}\n.swiper-container-cube .swiper-slide .swiper-slide {\n  pointer-events: none;\n}\n.swiper-container-cube.swiper-container-rtl .swiper-slide {\n  -webkit-transform-origin: 100% 0;\n  -ms-transform-origin: 100% 0;\n  transform-origin: 100% 0;\n}\n.swiper-container-cube .swiper-slide-active,\n.swiper-container-cube .swiper-slide-active .swiper-slide-active {\n  pointer-events: auto;\n}\n.swiper-container-cube .swiper-slide-active,\n.swiper-container-cube .swiper-slide-next,\n.swiper-container-cube .swiper-slide-prev,\n.swiper-container-cube .swiper-slide-next + .swiper-slide {\n  pointer-events: auto;\n  visibility: visible;\n}\n.swiper-container-cube .swiper-slide-shadow-top,\n.swiper-container-cube .swiper-slide-shadow-bottom,\n.swiper-container-cube .swiper-slide-shadow-left,\n.swiper-container-cube .swiper-slide-shadow-right {\n  z-index: 0;\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n}\n.swiper-container-cube .swiper-cube-shadow {\n  position: absolute;\n  left: 0;\n  bottom: 0px;\n  width: 100%;\n  height: 100%;\n  background: #000;\n  opacity: 0.6;\n  -webkit-filter: blur(50px);\n  filter: blur(50px);\n  z-index: 0;\n}\n.swiper-container-flip {\n  overflow: visible;\n}\n.swiper-container-flip .swiper-slide {\n  pointer-events: none;\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  z-index: 1;\n}\n.swiper-container-flip .swiper-slide .swiper-slide {\n  pointer-events: none;\n}\n.swiper-container-flip .swiper-slide-active,\n.swiper-container-flip .swiper-slide-active .swiper-slide-active {\n  pointer-events: auto;\n}\n.swiper-container-flip .swiper-slide-shadow-top,\n.swiper-container-flip .swiper-slide-shadow-bottom,\n.swiper-container-flip .swiper-slide-shadow-left,\n.swiper-container-flip .swiper-slide-shadow-right {\n  z-index: 0;\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n}\n.swiper-container-coverflow .swiper-wrapper {\n  /* Windows 8 IE 10 fix */\n  -ms-perspective: 1200px;\n}\n\n/* line 2, stdin */\n.pointer {\n  cursor: pointer; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _vueAwesomeSwiper = require('vue-awesome-swiper');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        swiper: _vueAwesomeSwiper.swiper,
        swiperSlide: _vueAwesomeSwiper.swiperSlide
    },
    props: {
        speed: {
            default: 2000
        },
        width: {
            default: undefined
        },
        height: {
            default: undefined
        },
        loop: {
            type: Boolean,
            default: true
        },
        onClick: {
            type: Function,
            default: function _default() {}
        },
        slidSlots: {
            default: function _default() {}
        },
        autoplay: {
            type: Boolean,
            default: true
        },
        paginationDynamicBullets: {
            type: Boolean,
            default: false
        },
        paginationClickable: {
            type: Boolean,
            default: true
        },
        init: {
            type: Boolean,
            default: true
        },
        paginationShow: {
            type: Boolean,
            default: true
        },
        navigationShow: {
            type: Boolean,
            default: false
        },
        customSwiperOption: {
            type: Object,
            default: null
        },
        swiperSlideStyle: {
            type: String,
            default: ''
        }
    },
    computed: (0, _defineProperty3.default)({
        swiper: function swiper() {
            return this.$refs.myCarousel.swiper;
        },
        defaultOption: function defaultOption() {
            return {
                'width': this.width,
                'height': this.height,
                'loop': this.loop,
                'init': this.init,
                pagination: {
                    el: this.paginationEl,
                    'clickable': this.paginationClickable,
                    'dynamicBullets': this.paginationDynamicBullets
                },
                speed: 300,
                autoplay: {
                    delay: this.speed
                }
            };
        },
        swiperOption: function swiperOption() {
            if (this.customSwiperOption) {
                var config = _lodash2.default.cloneDeep(this.customSwiperOption);
                config['pagination'] = {
                    el: this.paginationEl,
                    'clickable': this.paginationClickable,
                    'dynamicBullets': this.paginationDynamicBullets
                };
                if (this.navigationShow) {
                    config['navigation'] = {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    };
                }
                return config;
            } else {
                return this.defaultOption;
            }
        },
        showCarousel: function showCarousel() {
            return this.slidSlots.length > 0;
        },
        paginationEl: function paginationEl() {
            return this.paginationShow ? '.swiper-pagination' : null;
        }
    }, 'swiperOption', function swiperOption() {
        if (this.customSwiperOption) {
            var config = _lodash2.default.cloneDeep(this.customSwiperOption);
            config['pagination'] = {
                el: this.paginationEl,
                'clickable': this.paginationClickable,
                'dynamicBullets': this.paginationDynamicBullets
            };
            if (this.navigationShow) {
                config['navigation'] = {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                };
            }
            return config;
        } else {
            return this.defaultOption;
        }
    }),
    mounted: function mounted() {
        // current swiper instance
        // 然后你就可以使用当前上下文内的 swiper 对象去做你想做的事了
        //   console.log('this is current swiper instance object', this.swiper)
        //   this.swiper.init();
        //   this.swiper.slideTo(3, 1000, false)
    },

    methods: {
        next: function next() {
            this.swiper.slideNext();
        },
        prev: function prev() {
            this.swiper.slidePrev();
        },
        openUrl: function openUrl(slot) {
            if (slot.action_url != '') {
                var win = window.open(slot.action_url, '_blank');
                win.focus();
            }
        },
        manualUpdate: function manualUpdate() {
            this.$forceUpdate();
        },
        initSwiper: function initSwiper() {
            this.swiper.init();
        },
        updateSwiper: function updateSwiper() {
            this.swiper.update();
        }
    },
    watch: {
        slidSlots: function slidSlots(newVal) {
            // if(newVal.length > 0){
            //     this.swiper.slideTo(0, 1000, false);
            // }
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"v-carousel\" v-if=\"Object.keys(slidSlots).length>0\">\n    <swiper :options=\"swiperOption\" ref=\"myCarousel\">\n        <swiper-slide v-for=\"(slidSlot,index) in slidSlots\" :key=\"index\" :style=\"swiperSlideStyle\">\n            <slot name=\"swiper-card\" :item=\"slidSlot\"></slot>\n            <img v-if=\"slidSlot.type =='img'\" :src=\"slidSlot.src\" style=\"\n                    width: 100%;\n                    height: 100%;\n                \" @click=\"openUrl(slidSlot)\" :class=\"{'pointer':slidSlot.action_url != ''}\" :alt=\"slidSlot.alt\">\n            <video v-if=\"slidSlot.type =='video'\" :src=\"slidSlot.src\" style=\"\n                    width: 100%;\n                    height: 100%;\n                \" :autoplay=\"slidSlot.autoplay\" :muted=\"slidSlot.muted\" :title=\"slidSlot.title\"></video>\n        </swiper-slide>\n        \n        <!-- Optional controls -->\n        <div class=\"swiper-pagination\" slot=\"pagination\"></div>\n        <div class=\"swiper-button-prev\" v-if=\"navigationShow\" @click=\"prev\" slot=\"button-prev\"></div>\n        <div class=\"swiper-button-next\" v-if=\"navigationShow\" @click=\"next\" slot=\"button-next\"></div>\n    </swiper>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/**\n * Swiper 4.5.1\n * Most modern mobile touch slider and framework with hardware accelerated transitions\n * http://www.idangero.us/swiper/\n *\n * Copyright 2014-2019 Vladimir Kharlampidi\n *\n * Released under the MIT License\n *\n * Released on: September 13, 2019\n */\n.swiper-container {\n  margin-left: auto;\n  margin-right: auto;\n  position: relative;\n  overflow: hidden;\n  list-style: none;\n  padding: 0;\n  /* Fix of Webkit flickering */\n  z-index: 1;\n}\n.swiper-container-no-flexbox .swiper-slide {\n  float: left;\n}\n.swiper-container-vertical > .swiper-wrapper {\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n}\n.swiper-wrapper {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-transition-property: -webkit-transform;\n  transition-property: -webkit-transform;\n  -o-transition-property: transform;\n  transition-property: transform;\n  transition-property: transform, -webkit-transform;\n  -webkit-box-sizing: content-box;\n  box-sizing: content-box;\n}\n.swiper-container-android .swiper-slide,\n.swiper-wrapper {\n  -webkit-transform: translate3d(0px, 0, 0);\n  transform: translate3d(0px, 0, 0);\n}\n.swiper-container-multirow > .swiper-wrapper {\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n.swiper-container-free-mode > .swiper-wrapper {\n  -webkit-transition-timing-function: ease-out;\n  -o-transition-timing-function: ease-out;\n  transition-timing-function: ease-out;\n  margin: 0 auto;\n}\n.swiper-slide {\n  -webkit-flex-shrink: 0;\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n  width: 100%;\n  height: 100%;\n  position: relative;\n  -webkit-transition-property: -webkit-transform;\n  transition-property: -webkit-transform;\n  -o-transition-property: transform;\n  transition-property: transform;\n  transition-property: transform, -webkit-transform;\n}\n.swiper-slide-invisible-blank {\n  visibility: hidden;\n}\n/* Auto Height */\n.swiper-container-autoheight,\n.swiper-container-autoheight .swiper-slide {\n  height: auto;\n}\n.swiper-container-autoheight .swiper-wrapper {\n  -webkit-box-align: start;\n  -webkit-align-items: flex-start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  -webkit-transition-property: height, -webkit-transform;\n  transition-property: height, -webkit-transform;\n  -o-transition-property: transform, height;\n  transition-property: transform, height;\n  transition-property: transform, height, -webkit-transform;\n}\n/* 3D Effects */\n.swiper-container-3d {\n  -webkit-perspective: 1200px;\n  perspective: 1200px;\n}\n.swiper-container-3d .swiper-wrapper,\n.swiper-container-3d .swiper-slide,\n.swiper-container-3d .swiper-slide-shadow-left,\n.swiper-container-3d .swiper-slide-shadow-right,\n.swiper-container-3d .swiper-slide-shadow-top,\n.swiper-container-3d .swiper-slide-shadow-bottom,\n.swiper-container-3d .swiper-cube-shadow {\n  -webkit-transform-style: preserve-3d;\n  transform-style: preserve-3d;\n}\n.swiper-container-3d .swiper-slide-shadow-left,\n.swiper-container-3d .swiper-slide-shadow-right,\n.swiper-container-3d .swiper-slide-shadow-top,\n.swiper-container-3d .swiper-slide-shadow-bottom {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  z-index: 10;\n}\n.swiper-container-3d .swiper-slide-shadow-left {\n  background-image: -webkit-gradient(linear, right top, left top, from(rgba(0, 0, 0, 0.5)), to(rgba(0, 0, 0, 0)));\n  background-image: -webkit-linear-gradient(right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n  background-image: -o-linear-gradient(right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n  background-image: linear-gradient(to left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n}\n.swiper-container-3d .swiper-slide-shadow-right {\n  background-image: -webkit-gradient(linear, left top, right top, from(rgba(0, 0, 0, 0.5)), to(rgba(0, 0, 0, 0)));\n  background-image: -webkit-linear-gradient(left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n  background-image: -o-linear-gradient(left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n}\n.swiper-container-3d .swiper-slide-shadow-top {\n  background-image: -webkit-gradient(linear, left bottom, left top, from(rgba(0, 0, 0, 0.5)), to(rgba(0, 0, 0, 0)));\n  background-image: -webkit-linear-gradient(bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n  background-image: -o-linear-gradient(bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n  background-image: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n}\n.swiper-container-3d .swiper-slide-shadow-bottom {\n  background-image: -webkit-gradient(linear, left top, left bottom, from(rgba(0, 0, 0, 0.5)), to(rgba(0, 0, 0, 0)));\n  background-image: -webkit-linear-gradient(top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n  background-image: -o-linear-gradient(top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n}\n/* IE10 Windows Phone 8 Fixes */\n.swiper-container-wp8-horizontal,\n.swiper-container-wp8-horizontal > .swiper-wrapper {\n  -ms-touch-action: pan-y;\n  touch-action: pan-y;\n}\n.swiper-container-wp8-vertical,\n.swiper-container-wp8-vertical > .swiper-wrapper {\n  -ms-touch-action: pan-x;\n  touch-action: pan-x;\n}\n.swiper-button-prev,\n.swiper-button-next {\n  position: absolute;\n  top: 50%;\n  width: 27px;\n  height: 44px;\n  margin-top: -22px;\n  z-index: 10;\n  cursor: pointer;\n  background-size: 27px 44px;\n  background-position: center;\n  background-repeat: no-repeat;\n}\n.swiper-button-prev.swiper-button-disabled,\n.swiper-button-next.swiper-button-disabled {\n  opacity: 0.35;\n  cursor: auto;\n  pointer-events: none;\n}\n.swiper-button-prev,\n.swiper-container-rtl .swiper-button-next {\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z'%20fill%3D'%23007aff'%2F%3E%3C%2Fsvg%3E\");\n  left: 10px;\n  right: auto;\n}\n.swiper-button-next,\n.swiper-container-rtl .swiper-button-prev {\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%23007aff'%2F%3E%3C%2Fsvg%3E\");\n  right: 10px;\n  left: auto;\n}\n.swiper-button-prev.swiper-button-white,\n.swiper-container-rtl .swiper-button-next.swiper-button-white {\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z'%20fill%3D'%23ffffff'%2F%3E%3C%2Fsvg%3E\");\n}\n.swiper-button-next.swiper-button-white,\n.swiper-container-rtl .swiper-button-prev.swiper-button-white {\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%23ffffff'%2F%3E%3C%2Fsvg%3E\");\n}\n.swiper-button-prev.swiper-button-black,\n.swiper-container-rtl .swiper-button-next.swiper-button-black {\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z'%20fill%3D'%23000000'%2F%3E%3C%2Fsvg%3E\");\n}\n.swiper-button-next.swiper-button-black,\n.swiper-container-rtl .swiper-button-prev.swiper-button-black {\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%23000000'%2F%3E%3C%2Fsvg%3E\");\n}\n.swiper-button-lock {\n  display: none;\n}\n.swiper-pagination {\n  position: absolute;\n  text-align: center;\n  -webkit-transition: 300ms opacity;\n  -o-transition: 300ms opacity;\n  transition: 300ms opacity;\n  -webkit-transform: translate3d(0, 0, 0);\n  transform: translate3d(0, 0, 0);\n  z-index: 10;\n}\n.swiper-pagination.swiper-pagination-hidden {\n  opacity: 0;\n}\n/* Common Styles */\n.swiper-pagination-fraction,\n.swiper-pagination-custom,\n.swiper-container-horizontal > .swiper-pagination-bullets {\n  bottom: 10px;\n  left: 0;\n  width: 100%;\n}\n/* Bullets */\n.swiper-pagination-bullets-dynamic {\n  overflow: hidden;\n  font-size: 0;\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n  -webkit-transform: scale(0.33);\n  -ms-transform: scale(0.33);\n  transform: scale(0.33);\n  position: relative;\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active {\n  -webkit-transform: scale(1);\n  -ms-transform: scale(1);\n  transform: scale(1);\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main {\n  -webkit-transform: scale(1);\n  -ms-transform: scale(1);\n  transform: scale(1);\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev {\n  -webkit-transform: scale(0.66);\n  -ms-transform: scale(0.66);\n  transform: scale(0.66);\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev {\n  -webkit-transform: scale(0.33);\n  -ms-transform: scale(0.33);\n  transform: scale(0.33);\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next {\n  -webkit-transform: scale(0.66);\n  -ms-transform: scale(0.66);\n  transform: scale(0.66);\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next {\n  -webkit-transform: scale(0.33);\n  -ms-transform: scale(0.33);\n  transform: scale(0.33);\n}\n.swiper-pagination-bullet {\n  width: 8px;\n  height: 8px;\n  display: inline-block;\n  border-radius: 100%;\n  background: #000;\n  opacity: 0.2;\n}\nbutton.swiper-pagination-bullet {\n  border: none;\n  margin: 0;\n  padding: 0;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n}\n.swiper-pagination-clickable .swiper-pagination-bullet {\n  cursor: pointer;\n}\n.swiper-pagination-bullet-active {\n  opacity: 1;\n  background: #007aff;\n}\n.swiper-container-vertical > .swiper-pagination-bullets {\n  right: 10px;\n  top: 50%;\n  -webkit-transform: translate3d(0px, -50%, 0);\n  transform: translate3d(0px, -50%, 0);\n}\n.swiper-container-vertical > .swiper-pagination-bullets .swiper-pagination-bullet {\n  margin: 6px 0;\n  display: block;\n}\n.swiper-container-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic {\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%);\n  width: 8px;\n}\n.swiper-container-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n  display: inline-block;\n  -webkit-transition: 200ms top, 200ms -webkit-transform;\n  transition: 200ms top, 200ms -webkit-transform;\n  -o-transition: 200ms transform, 200ms top;\n  transition: 200ms transform, 200ms top;\n  transition: 200ms transform, 200ms top, 200ms -webkit-transform;\n}\n.swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet {\n  margin: 0 4px;\n}\n.swiper-container-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic {\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n  -ms-transform: translateX(-50%);\n  transform: translateX(-50%);\n  white-space: nowrap;\n}\n.swiper-container-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n  -webkit-transition: 200ms left, 200ms -webkit-transform;\n  transition: 200ms left, 200ms -webkit-transform;\n  -o-transition: 200ms transform, 200ms left;\n  transition: 200ms transform, 200ms left;\n  transition: 200ms transform, 200ms left, 200ms -webkit-transform;\n}\n.swiper-container-horizontal.swiper-container-rtl > .swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n  -webkit-transition: 200ms right, 200ms -webkit-transform;\n  transition: 200ms right, 200ms -webkit-transform;\n  -o-transition: 200ms transform, 200ms right;\n  transition: 200ms transform, 200ms right;\n  transition: 200ms transform, 200ms right, 200ms -webkit-transform;\n}\n/* Progress */\n.swiper-pagination-progressbar {\n  background: rgba(0, 0, 0, 0.25);\n  position: absolute;\n}\n.swiper-pagination-progressbar .swiper-pagination-progressbar-fill {\n  background: #007aff;\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  -webkit-transform: scale(0);\n  -ms-transform: scale(0);\n  transform: scale(0);\n  -webkit-transform-origin: left top;\n  -ms-transform-origin: left top;\n  transform-origin: left top;\n}\n.swiper-container-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {\n  -webkit-transform-origin: right top;\n  -ms-transform-origin: right top;\n  transform-origin: right top;\n}\n.swiper-container-horizontal > .swiper-pagination-progressbar,\n.swiper-container-vertical > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite {\n  width: 100%;\n  height: 4px;\n  left: 0;\n  top: 0;\n}\n.swiper-container-vertical > .swiper-pagination-progressbar,\n.swiper-container-horizontal > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite {\n  width: 4px;\n  height: 100%;\n  left: 0;\n  top: 0;\n}\n.swiper-pagination-white .swiper-pagination-bullet-active {\n  background: #ffffff;\n}\n.swiper-pagination-progressbar.swiper-pagination-white {\n  background: rgba(255, 255, 255, 0.25);\n}\n.swiper-pagination-progressbar.swiper-pagination-white .swiper-pagination-progressbar-fill {\n  background: #ffffff;\n}\n.swiper-pagination-black .swiper-pagination-bullet-active {\n  background: #000000;\n}\n.swiper-pagination-progressbar.swiper-pagination-black {\n  background: rgba(0, 0, 0, 0.25);\n}\n.swiper-pagination-progressbar.swiper-pagination-black .swiper-pagination-progressbar-fill {\n  background: #000000;\n}\n.swiper-pagination-lock {\n  display: none;\n}\n/* Scrollbar */\n.swiper-scrollbar {\n  border-radius: 10px;\n  position: relative;\n  -ms-touch-action: none;\n  background: rgba(0, 0, 0, 0.1);\n}\n.swiper-container-horizontal > .swiper-scrollbar {\n  position: absolute;\n  left: 1%;\n  bottom: 3px;\n  z-index: 50;\n  height: 5px;\n  width: 98%;\n}\n.swiper-container-vertical > .swiper-scrollbar {\n  position: absolute;\n  right: 3px;\n  top: 1%;\n  z-index: 50;\n  width: 5px;\n  height: 98%;\n}\n.swiper-scrollbar-drag {\n  height: 100%;\n  width: 100%;\n  position: relative;\n  background: rgba(0, 0, 0, 0.5);\n  border-radius: 10px;\n  left: 0;\n  top: 0;\n}\n.swiper-scrollbar-cursor-drag {\n  cursor: move;\n}\n.swiper-scrollbar-lock {\n  display: none;\n}\n.swiper-zoom-container {\n  width: 100%;\n  height: 100%;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  text-align: center;\n}\n.swiper-zoom-container > img,\n.swiper-zoom-container > svg,\n.swiper-zoom-container > canvas {\n  max-width: 100%;\n  max-height: 100%;\n  -o-object-fit: contain;\n  object-fit: contain;\n}\n.swiper-slide-zoomed {\n  cursor: move;\n}\n/* Preloader */\n.swiper-lazy-preloader {\n  width: 42px;\n  height: 42px;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  margin-left: -21px;\n  margin-top: -21px;\n  z-index: 10;\n  -webkit-transform-origin: 50%;\n  -ms-transform-origin: 50%;\n  transform-origin: 50%;\n  -webkit-animation: swiper-preloader-spin 1s steps(12, end) infinite;\n  animation: swiper-preloader-spin 1s steps(12, end) infinite;\n}\n.swiper-lazy-preloader:after {\n  display: block;\n  content: '';\n  width: 100%;\n  height: 100%;\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20viewBox%3D'0%200%20120%20120'%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20xmlns%3Axlink%3D'http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink'%3E%3Cdefs%3E%3Cline%20id%3D'l'%20x1%3D'60'%20x2%3D'60'%20y1%3D'7'%20y2%3D'27'%20stroke%3D'%236c6c6c'%20stroke-width%3D'11'%20stroke-linecap%3D'round'%2F%3E%3C%2Fdefs%3E%3Cg%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(30%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(60%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(90%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(120%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(150%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.37'%20transform%3D'rotate(180%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.46'%20transform%3D'rotate(210%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.56'%20transform%3D'rotate(240%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.66'%20transform%3D'rotate(270%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.75'%20transform%3D'rotate(300%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.85'%20transform%3D'rotate(330%2060%2C60)'%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E\");\n  background-position: 50%;\n  background-size: 100%;\n  background-repeat: no-repeat;\n}\n.swiper-lazy-preloader-white:after {\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20viewBox%3D'0%200%20120%20120'%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20xmlns%3Axlink%3D'http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink'%3E%3Cdefs%3E%3Cline%20id%3D'l'%20x1%3D'60'%20x2%3D'60'%20y1%3D'7'%20y2%3D'27'%20stroke%3D'%23fff'%20stroke-width%3D'11'%20stroke-linecap%3D'round'%2F%3E%3C%2Fdefs%3E%3Cg%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(30%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(60%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(90%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(120%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(150%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.37'%20transform%3D'rotate(180%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.46'%20transform%3D'rotate(210%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.56'%20transform%3D'rotate(240%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.66'%20transform%3D'rotate(270%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.75'%20transform%3D'rotate(300%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.85'%20transform%3D'rotate(330%2060%2C60)'%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E\");\n}\n@-webkit-keyframes swiper-preloader-spin {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@keyframes swiper-preloader-spin {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n/* a11y */\n.swiper-container .swiper-notification {\n  position: absolute;\n  left: 0;\n  top: 0;\n  pointer-events: none;\n  opacity: 0;\n  z-index: -1000;\n}\n.swiper-container-fade.swiper-container-free-mode .swiper-slide {\n  -webkit-transition-timing-function: ease-out;\n  -o-transition-timing-function: ease-out;\n  transition-timing-function: ease-out;\n}\n.swiper-container-fade .swiper-slide {\n  pointer-events: none;\n  -webkit-transition-property: opacity;\n  -o-transition-property: opacity;\n  transition-property: opacity;\n}\n.swiper-container-fade .swiper-slide .swiper-slide {\n  pointer-events: none;\n}\n.swiper-container-fade .swiper-slide-active,\n.swiper-container-fade .swiper-slide-active .swiper-slide-active {\n  pointer-events: auto;\n}\n.swiper-container-cube {\n  overflow: visible;\n}\n.swiper-container-cube .swiper-slide {\n  pointer-events: none;\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  z-index: 1;\n  visibility: hidden;\n  -webkit-transform-origin: 0 0;\n  -ms-transform-origin: 0 0;\n  transform-origin: 0 0;\n  width: 100%;\n  height: 100%;\n}\n.swiper-container-cube .swiper-slide .swiper-slide {\n  pointer-events: none;\n}\n.swiper-container-cube.swiper-container-rtl .swiper-slide {\n  -webkit-transform-origin: 100% 0;\n  -ms-transform-origin: 100% 0;\n  transform-origin: 100% 0;\n}\n.swiper-container-cube .swiper-slide-active,\n.swiper-container-cube .swiper-slide-active .swiper-slide-active {\n  pointer-events: auto;\n}\n.swiper-container-cube .swiper-slide-active,\n.swiper-container-cube .swiper-slide-next,\n.swiper-container-cube .swiper-slide-prev,\n.swiper-container-cube .swiper-slide-next + .swiper-slide {\n  pointer-events: auto;\n  visibility: visible;\n}\n.swiper-container-cube .swiper-slide-shadow-top,\n.swiper-container-cube .swiper-slide-shadow-bottom,\n.swiper-container-cube .swiper-slide-shadow-left,\n.swiper-container-cube .swiper-slide-shadow-right {\n  z-index: 0;\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n}\n.swiper-container-cube .swiper-cube-shadow {\n  position: absolute;\n  left: 0;\n  bottom: 0px;\n  width: 100%;\n  height: 100%;\n  background: #000;\n  opacity: 0.6;\n  -webkit-filter: blur(50px);\n  filter: blur(50px);\n  z-index: 0;\n}\n.swiper-container-flip {\n  overflow: visible;\n}\n.swiper-container-flip .swiper-slide {\n  pointer-events: none;\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  z-index: 1;\n}\n.swiper-container-flip .swiper-slide .swiper-slide {\n  pointer-events: none;\n}\n.swiper-container-flip .swiper-slide-active,\n.swiper-container-flip .swiper-slide-active .swiper-slide-active {\n  pointer-events: auto;\n}\n.swiper-container-flip .swiper-slide-shadow-top,\n.swiper-container-flip .swiper-slide-shadow-bottom,\n.swiper-container-flip .swiper-slide-shadow-left,\n.swiper-container-flip .swiper-slide-shadow-right {\n  z-index: 0;\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n}\n.swiper-container-coverflow .swiper-wrapper {\n  /* Windows 8 IE 10 fix */\n  -ms-perspective: 1200px;\n}\n\n/* line 2, stdin */\n.pointer {\n  cursor: pointer; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-fdf212c0", module.exports)
  } else {
    hotAPI.update("_v-fdf212c0", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/defineProperty":65,"lodash":717,"vue":792,"vue-awesome-swiper":783,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1511:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n.ckeditor::after {\n    content: \"\";\n    display: table;\n    clear: both;\n}\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});


/*
用法：
<v-ckeditor id="123" v-model="content"
            :config="config" @blur="onBlur($event)" @focus="onFocus($event)">
</v-ckeditor>
config: {
        toolbar: [
            ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript']
        ],
        height: 300
    },
*/
var inc = new Date().getTime();
exports.default = {
    props: {
        name: {
            type: String,
            default: function _default() {
                return 'editor-' + ++inc;
            }
        },
        value: {
            type: String
        },
        id: {
            type: String,
            default: function _default() {
                return 'editor-' + inc;
            }
        },
        types: {
            type: String,
            default: function _default() {
                return 'classic';
            }
        },
        config: {
            type: Object,
            default: function _default() {}
        },
        instanceReadyCallback: {
            type: Function
        },
        readOnlyMode: {
            type: Boolean,
            default: function _default() {
                return false;
            }
        }
    },
    data: function data() {
        return {
            destroyed: false,
            instanceValue: ''
        };
    },

    computed: {
        instance: function instance() {
            return CKEDITOR.instances[this.id];
        }
    },
    watch: {
        value: function value(val) {
            try {
                if (this.instance) {
                    this.update(val);
                }
            } catch (e) {}
        },
        readOnlyMode: function readOnlyMode(val) {
            this.instance.setReadOnly(val);
        }
    },
    mounted: function mounted() {
        this.create();
    },
    beforeDestroy: function beforeDestroy() {
        this.destroy();
    },

    methods: {
        create: function create() {
            var _this = this;

            if (typeof CKEDITOR === 'undefined') {
                console.log('CKEDITOR is missing (http://ckeditor.com/)');
            } else {
                if (this.types === 'inline') {
                    CKEDITOR.inline(this.id, this.config);
                } else {
                    CKEDITOR.replace(this.id, this.config);
                }
                this.instance.setData(this.value);
                this.instance.on('instanceReady', function () {
                    _this.instance.setData(_this.value);
                });
                this.instance.on('change', this.onChange);
                this.instance.on('mode', this.onMode);
                this.instance.on('blur', this.onBlur);
                this.instance.on('focus', this.onFocus);
                this.instance.on('fileUploadResponse', function () {
                    setTimeout(function () {
                        _this.onChange();
                    }, 0);
                });
                if (typeof this.instanceReadyCallback !== 'undefined') {
                    this.instance.on('instanceReady', this.instanceReadyCallback);
                }
            }
        },
        update: function update(val) {
            if (this.instanceValue !== val) {
                this.instance.setData(val, { internal: false });
            }
        },
        destroy: function destroy() {
            try {
                if (!this.destroyed) {
                    this.instance.focusManager.blur(true);
                    this.instance.removeAllListeners();
                    this.instance.destroy();
                    this.destroyed = true;
                }
            } catch (e) {}
        },
        onChange: function onChange() {
            var html = this.instance.getData();
            if (html !== this.value) {
                this.$emit('input', html);
                this.instanceValue = html;
            }
        },
        onBlur: function onBlur() {
            this.$emit('blur', this.instance);
        },
        onFocus: function onFocus() {
            this.$emit('focus', this.instance);
        },
        onMode: function onMode() {
            var _this2 = this;

            if (this.instance.mode === 'source') {
                var editable = this.instance.editable();
                editable.attachListener(editable, 'input', function () {
                    _this2.onChange();
                });
            }
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"ckeditor\">\n    <textarea :name=\"name\" :id=\"id\" :value=\"value\" :types=\"types\" :config=\"config\" :disabled=\"readOnlyMode\">        </textarea>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n.ckeditor::after {\n    content: \"\";\n    display: table;\n    clear: both;\n}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-39299815", module.exports)
  } else {
    hotAPI.update("_v-39299815", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1512:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.group-list[_v-5ed6ecae] {\n  margin-bottom: 16px; }\n  /* line 4, stdin */\n  .group-list .panel-heading[_v-5ed6ecae] {\n    background: #E2E2EA;\n    border-top-left-radius: 8px;\n    border-top-right-radius: 8px;\n    padding: 2px 10px; }\n  /* line 10, stdin */\n  .group-list .group-head[_v-5ed6ecae] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n    cursor: pointer; }\n    /* line 14, stdin */\n    .group-list .group-head[_v-5ed6ecae]:hover {\n      opacity: .8; }\n    /* line 17, stdin */\n    .group-list .group-head.collapsed i[_v-5ed6ecae] {\n      transition: transform .3s linear;\n      transform: rotate(-90deg); }\n  /* line 22, stdin */\n  .group-list .group-body[_v-5ed6ecae] {\n    background: white;\n    border: 1px solid #EEEEEE;\n    border-bottom-left-radius: 8px;\n    border-bottom-right-radius: 8px;\n    padding: 0; }\n  /* line 29, stdin */\n  .group-list .content[_v-5ed6ecae] {\n    border-bottom: 1px solid #F6F7F8; }\n    /* line 31, stdin */\n    .group-list .content[_v-5ed6ecae]:last-child {\n      border-bottom: none; }\n\n@media (min-width: 0px) and (max-width: 1000px) {\n  /* line 37, stdin */\n  .accordion-list[_v-5ed6ecae] {\n    margin: 0 16px; } }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        listId: {
            type: String,
            required: true
        },
        isLoading: {
            type: Boolean,
            default: false
        },
        dataSource: {
            type: [Array, Object],
            default: function _default() {
                return [];
            }
        },
        noDataMessage: {
            type: String,
            default: '暫無資料'
        },
        childItemKey: {
            type: String,
            default: ''
        },
        cssClass: {
            default: ''
        },
        collapseAll: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        noData: function noData() {
            return _lodash2.default.isEmpty(this.dataSource);
        }
    },
    mounted: function mounted() {},

    methods: {
        emptyGroup: function emptyGroup(group) {
            if (group.hasOwnProperty(this.childItemKey)) {
                return group[this.childItemKey].length == 0;
            };
            return true;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-5ed6ecae=\"\">\n    <v-spinner :ajaxing=\"isLoading\" _v-5ed6ecae=\"\"></v-spinner>\n    <div v-show=\"!isLoading\" _v-5ed6ecae=\"\">\n        <div v-if=\"noData\" style=\"text-align: center; padding: 25px 0;\" _v-5ed6ecae=\"\">\n            <img src=\"/images/noData.svg\" width=\"105\" height=\"60\" _v-5ed6ecae=\"\">\n            <div style=\"color: #6c6c6c;\" class=\"m-top-10\" _v-5ed6ecae=\"\">{{noDataMessage}}</div>\n        </div>\n        <div :id=\"listId\" class=\"accordion-list\" v-else=\"\" _v-5ed6ecae=\"\">\n            <div v-for=\"(el, idx) in dataSource\" class=\"group-list\" v-if=\"!emptyGroup(el)\" _v-5ed6ecae=\"\">\n                <div class=\"panel-heading\" _v-5ed6ecae=\"\">\n                    <div class=\"panel-title\" _v-5ed6ecae=\"\">\n                        <a class=\"group-head\" data-toggle=\"collapse\" :data-parent=\"'#'+listId\" :href=\"'#'+listId+idx\" _v-5ed6ecae=\"\">\n                            <div _v-5ed6ecae=\"\"><i class=\"material-icons m-top-5\" _v-5ed6ecae=\"\">expand_more</i></div>\n                            <slot name=\"head\" :item=\"el\" _v-5ed6ecae=\"\"></slot>\n                        </a>\n                    </div>\n                </div>\n                <div :id=\"listId+idx\" class=\"panel-collapse collapse\" :class=\"{ in: !collapseAll}\" _v-5ed6ecae=\"\">\n                    <div class=\"panel-body group-body\" _v-5ed6ecae=\"\">\n                        <div v-for=\"item in el[childItemKey]\" class=\"content\" _v-5ed6ecae=\"\">\n                            <slot name=\"body\" :child_item=\"item\" _v-5ed6ecae=\"\"></slot>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.group-list[_v-5ed6ecae] {\n  margin-bottom: 16px; }\n  /* line 4, stdin */\n  .group-list .panel-heading[_v-5ed6ecae] {\n    background: #E2E2EA;\n    border-top-left-radius: 8px;\n    border-top-right-radius: 8px;\n    padding: 2px 10px; }\n  /* line 10, stdin */\n  .group-list .group-head[_v-5ed6ecae] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n    cursor: pointer; }\n    /* line 14, stdin */\n    .group-list .group-head[_v-5ed6ecae]:hover {\n      opacity: .8; }\n    /* line 17, stdin */\n    .group-list .group-head.collapsed i[_v-5ed6ecae] {\n      transition: transform .3s linear;\n      transform: rotate(-90deg); }\n  /* line 22, stdin */\n  .group-list .group-body[_v-5ed6ecae] {\n    background: white;\n    border: 1px solid #EEEEEE;\n    border-bottom-left-radius: 8px;\n    border-bottom-right-radius: 8px;\n    padding: 0; }\n  /* line 29, stdin */\n  .group-list .content[_v-5ed6ecae] {\n    border-bottom: 1px solid #F6F7F8; }\n    /* line 31, stdin */\n    .group-list .content[_v-5ed6ecae]:last-child {\n      border-bottom: none; }\n\n@media (min-width: 0px) and (max-width: 1000px) {\n  /* line 37, stdin */\n  .accordion-list[_v-5ed6ecae] {\n    margin: 0 16px; } }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-5ed6ecae", module.exports)
  } else {
    hotAPI.update("_v-5ed6ecae", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1513:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 3, stdin */\n.category > div[_v-eb8c6b26] {\n  border: 1px solid #ccc;\n  font-size: 1.5em; }\n\n/* line 7, stdin */\n.category .first[_v-eb8c6b26] {\n  padding-left: 1em;\n  font-weight: 800;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  cursor: pointer; }\n  /* line 14, stdin */\n  .category .first .fa-pencil[_v-eb8c6b26] {\n    margin-right: 0.5em; }\n  /* line 18, stdin */\n  .category .first .show-detail[_v-eb8c6b26] {\n    margin-right: 0.5em; }\n\n/* line 22, stdin */\n.category .second[_v-eb8c6b26] {\n  padding-left: 3.5em;\n  font-weight: 200;\n  cursor: pointer;\n  font-size: 1.25em; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	props: {
		disabledForCheckbox: {
			type: Boolean,
			default: false
		},
		currentMode: {
			type: String,
			default: 'none'
		},
		keyMaps: {
			default: {}
		},
		subList: {
			type: Object,
			default: {}
		},
		defaultChecked: {
			type: Array,
			default: []
		}
	},
	data: function data() {
		return {
			checkBoxList: []
		};
	},

	methods: {
		toggleMenu: function toggleMenu(key) {
			this.keyMaps[key]['currentOpen'] = !this.keyMaps[key]['currentOpen'];
		},
		clickEditTitleEvent: function clickEditTitleEvent(method, value) {
			this.$emit('click-title-event', { value: value, method: method });
		},
		clickCheckboxTitleEvent: function clickCheckboxTitleEvent(method) {
			this.$emit('click-title-event', { value: this.checkBoxList, method: method });
		},
		clickSubEvent: function clickSubEvent(value) {
			this.$emit('click-sub-event', { value: value });
		}
	},
	watch: {
		defaultChecked: function defaultChecked(newVal) {
			this.checkBoxList = newVal;
		},
		checkBoxList: function checkBoxList(newVal) {
			this.clickCheckboxTitleEvent('checkbox');
		}
	}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-eb8c6b26=\"\">\n\t<div v-for=\"(value,key) in keyMaps\" class=\"category\" _v-eb8c6b26=\"\">\n\t\t<div class=\"first\" @click=\"toggleMenu(key)\" _v-eb8c6b26=\"\">\n\t\t\t<div _v-eb8c6b26=\"\">\n\t\t\t\t<div v-if=\"currentMode ==='edit'\" @click.stop=\"clickEditTitleEvent('edit',value)\" _v-eb8c6b26=\"\">\n\t\t\t\t\t<i class=\"fa fa-pencil\" aria-hidden=\"true\" _v-eb8c6b26=\"\"></i>\n\t\t\t\t\t<label _v-eb8c6b26=\"\">{{ value.name }}</label>\n\t\t\t\t</div>\n\t\t\t\t<div v-if=\"currentMode ==='checkbox'\" @click.stop=\"\" _v-eb8c6b26=\"\">\n\t\t\t\t\t<input type=\"checkbox\" v-model=\"checkBoxList\" :value=\"value.key\" :id=\"'checked'+key\" :disabled=\"disabledForCheckbox\" _v-eb8c6b26=\"\">\n\t\t\t\t\t<label :for=\"'checked'+key\" _v-eb8c6b26=\"\">{{ value.name }}</label>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"show-detail\" _v-eb8c6b26=\"\">\n\t\t\t\t<i class=\"fa fa-chevron-up\" aria-hidden=\"true\" v-show=\"!value.currentOpen\" _v-eb8c6b26=\"\"></i>\n\t\t\t\t<i class=\"fa fa-chevron-down\" aria-hidden=\"true\" v-show=\"value.currentOpen\" _v-eb8c6b26=\"\"></i>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"second\" v-for=\"subValue in   subList[(value.key)]\" v-show=\"value.currentOpen\" @click.stop=\"clickSubEvent(subValue)\" _v-eb8c6b26=\"\">\n\t\t\t{{ subValue.name }}\n\t\t</div>\n\t</div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 3, stdin */\n.category > div[_v-eb8c6b26] {\n  border: 1px solid #ccc;\n  font-size: 1.5em; }\n\n/* line 7, stdin */\n.category .first[_v-eb8c6b26] {\n  padding-left: 1em;\n  font-weight: 800;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  cursor: pointer; }\n  /* line 14, stdin */\n  .category .first .fa-pencil[_v-eb8c6b26] {\n    margin-right: 0.5em; }\n  /* line 18, stdin */\n  .category .first .show-detail[_v-eb8c6b26] {\n    margin-right: 0.5em; }\n\n/* line 22, stdin */\n.category .second[_v-eb8c6b26] {\n  padding-left: 3.5em;\n  font-weight: 200;\n  cursor: pointer;\n  font-size: 1.25em; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-eb8c6b26", module.exports)
  } else {
    hotAPI.update("_v-eb8c6b26", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1514:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert(".vue-swatches__check__wrapper{position:absolute;width:100%;height:100%}.vue-swatches__check__circle{width:21px;height:21px;border-radius:50%;background-color:rgba(0,0,0,.15)}.vue-swatches__check__path{fill:#fff}.vue-swatches__swatch{position:relative;display:inline-block;font-size:0}.vue-swatches__swatch:focus,.vue-swatches__swatch:hover{opacity:.9;box-shadow:inset 0 0 2px rgba(0,0,0,.75);outline:none}.vue-swatches__swatch.vue-swatches__swatch--border,.vue-swatches__swatch.vue-swatches__swatch--selected{box-shadow:inset 0 0 2px rgba(0,0,0,.75)}.vue-swatches__swatch__label{position:absolute;left:0;right:0;color:#666;font-size:10px;font-weight:700;text-align:center}.vue-swatches__swatch .vue-swatches__diagonal__wrapper{position:absolute}fieldset[disabled] .vue-swatches{pointer-events:none}.vue-swatches{position:relative;display:inline-block;outline:none}.vue-swatches__trigger__wrapper{display:inline-block;cursor:pointer}.vue-swatches__trigger.vue-swatches--is-empty{border:2px solid #ccc}.vue-swatches__trigger.vue-swatches--is-disabled{cursor:not-allowed}.vue-swatches__container{box-sizing:content-box}.vue-swatches__container.vue-swatches--inline{font-size:0}.vue-swatches__container:not(.vue-swatches--inline){position:absolute;display:block;overflow:auto;border-radius:5px;box-shadow:0 2px 3px rgba(10,10,10,.2),0 0 0 1px rgba(10,10,10,.2);z-index:50}.vue-swatches__wrapper{background-color:inherit;box-sizing:content-box}.vue-swatches__row{font-size:0}.vue-swatches__fallback__wrapper{display:table}.vue-swatches__fallback__input--wrapper{display:table-cell;padding-right:10px;width:100%;font-size:14px}.vue-swatches__fallback__input{width:100%;padding-top:6px;padding-bottom:6px;border-radius:5px;border:1px solid #dcdcdc;color:#35495e;background:#fff}.vue-swatches__fallback__button{display:table-cell;padding:6px 15px;border:0;cursor:pointer;font-weight:700;color:#fff;background-color:#3571c8;border-radius:5px}.vue-swatches-show-hide-enter-active,.vue-swatches-show-hide-leave-active{transition:all .3s ease}.vue-swatches-show-hide-enter,.vue-swatches-show-hide-leave-active{opacity:0}.vue-swatches--has-children-centered{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.vue-swatches__diagonal__wrapper{width:100%;height:100%}.vue-swatches__diagonal{width:75%;height:75%;background:linear-gradient(to top right,transparent 0,transparent calc(50% - 2.4px),#de080a 50%,transparent calc(50% + 2.4px),transparent)}")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vueSwatches = require('vue-swatches');

var _vueSwatches2 = _interopRequireDefault(_vueSwatches);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: { VSwatches: _vueSwatches2.default },
    props: {
        swatches: {
            type: String,
            default: 'text-advanced'
        },
        shapes: {
            type: String,
            default: 'circles'
        },
        inputColor: {
            type: String,
            description: 'hex'
        },
        changedColorCallBack: {
            type: Function
        }
    },
    data: function data() {
        return {
            color: ''
        };
    },
    mounted: function mounted() {
        if (!this.inputColor) return;
        this.color = this.inputColor;
    },

    watch: {
        inputColor: function inputColor(newVal) {
            if ($17.isValidColor(newVal)) {
                this.color = newVal;
            }
        },
        color: function color(newVal) {
            if (newVal !== this.inputColor) {
                this.changedColorCallBack && this.changedColorCallBack(newVal);
            }
        }
    },
    methods: {}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-swatches v-model=\"color\" popover-x=\"right\" :swatches=\"swatches\" :shapes=\"shapes\"></v-swatches>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache[".vue-swatches__check__wrapper{position:absolute;width:100%;height:100%}.vue-swatches__check__circle{width:21px;height:21px;border-radius:50%;background-color:rgba(0,0,0,.15)}.vue-swatches__check__path{fill:#fff}.vue-swatches__swatch{position:relative;display:inline-block;font-size:0}.vue-swatches__swatch:focus,.vue-swatches__swatch:hover{opacity:.9;box-shadow:inset 0 0 2px rgba(0,0,0,.75);outline:none}.vue-swatches__swatch.vue-swatches__swatch--border,.vue-swatches__swatch.vue-swatches__swatch--selected{box-shadow:inset 0 0 2px rgba(0,0,0,.75)}.vue-swatches__swatch__label{position:absolute;left:0;right:0;color:#666;font-size:10px;font-weight:700;text-align:center}.vue-swatches__swatch .vue-swatches__diagonal__wrapper{position:absolute}fieldset[disabled] .vue-swatches{pointer-events:none}.vue-swatches{position:relative;display:inline-block;outline:none}.vue-swatches__trigger__wrapper{display:inline-block;cursor:pointer}.vue-swatches__trigger.vue-swatches--is-empty{border:2px solid #ccc}.vue-swatches__trigger.vue-swatches--is-disabled{cursor:not-allowed}.vue-swatches__container{box-sizing:content-box}.vue-swatches__container.vue-swatches--inline{font-size:0}.vue-swatches__container:not(.vue-swatches--inline){position:absolute;display:block;overflow:auto;border-radius:5px;box-shadow:0 2px 3px rgba(10,10,10,.2),0 0 0 1px rgba(10,10,10,.2);z-index:50}.vue-swatches__wrapper{background-color:inherit;box-sizing:content-box}.vue-swatches__row{font-size:0}.vue-swatches__fallback__wrapper{display:table}.vue-swatches__fallback__input--wrapper{display:table-cell;padding-right:10px;width:100%;font-size:14px}.vue-swatches__fallback__input{width:100%;padding-top:6px;padding-bottom:6px;border-radius:5px;border:1px solid #dcdcdc;color:#35495e;background:#fff}.vue-swatches__fallback__button{display:table-cell;padding:6px 15px;border:0;cursor:pointer;font-weight:700;color:#fff;background-color:#3571c8;border-radius:5px}.vue-swatches-show-hide-enter-active,.vue-swatches-show-hide-leave-active{transition:all .3s ease}.vue-swatches-show-hide-enter,.vue-swatches-show-hide-leave-active{opacity:0}.vue-swatches--has-children-centered{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.vue-swatches__diagonal__wrapper{width:100%;height:100%}.vue-swatches__diagonal{width:75%;height:75%;background:linear-gradient(to top right,transparent 0,transparent calc(50% - 2.4px),#de080a 50%,transparent calc(50% + 2.4px),transparent)}"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-53a2d910", module.exports)
  } else {
    hotAPI.update("_v-53a2d910", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vue-swatches":790,"vueify/lib/insert-css":799}],1515:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.modal-footer > .alert-item {\n  padding: 0px; }\n\n/* line 5, stdin */\n.alert-item {\n  border-bottom: 1px solid #C7C4C3;\n  padding: 20px 0px 15px 0px; }\n\n/* line 9, stdin */\n.alert-item:last-child {\n  border: 0px; }\n\n/* line 2, stdin */\n.action[_v-3b766ca0] {\n  margin-top: 20px; }\n\n/* line 6, stdin */\n.icon[_v-3b766ca0] {\n  margin-top: 5px; }\n\n/* line 9, stdin */\n.btn[_v-3b766ca0] {\n  margin-right: 5px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	props: {
		actionBtn: {
			default: 'btn-default'
		},
		statusWord: {
			default: ''
		},
		actionWord: {
			default: ''
		},
		actionFunction: {},
		detailTitle: {},
		detailContent: {},
		icon: {
			default: 'success'
		},
		btnDisabled: Boolean
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapState)('pos', ['order_id'])),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('pos', ['openOrCreateOrder']), (0, _vuex.mapActions)('webadmin/print', ['outputInvoice', 'previewInvoice', 'previewOrder', 'previewDiscountNote']), {
		action: function action(actionFunction) {
			if (this.btnDisabled) return;
			switch (actionFunction) {
				case 'openOrder':
					$('#multi-alert-modal').modal('hide');
					this.openOrCreateOrder({ order_id: this.order_id });
					$('#order-show').modal('show');
					break;
				case 'outputInvoice':
					this.outputInvoice(this.order_id);
					break;
				case 'printInvoice':
					this.previewInvoice({ orderId: this.order_id });
					break;
				case 'previewOrder':
					this.previewOrder({ orderId: this.order_id });
					break;
				case 'previewDiscountNote':
					this.previewDiscountNote({ orderId: this.order_id });
					break;
			}
		}
	})
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"alert-item\" _v-3b766ca0=\"\">\n\t<div class=\"row\" _v-3b766ca0=\"\">\n\t\t<div class=\"col-xs-2 text-right icon\" _v-3b766ca0=\"\">\n\t\t\t<i v-if=\"icon=='success'\" class=\"fa fa-check-circle fa-4x\" aria-hidden=\"true\" style=\"color:green\" _v-3b766ca0=\"\"></i>\n\t\t\t<i v-if=\"icon=='fail'\" class=\"fa fa-times-circle fa-4x\" aria-hidden=\"true\" style=\"color:red\" _v-3b766ca0=\"\"></i>\n\t\t</div>\n\t\t<div class=\"col-xs-4\" _v-3b766ca0=\"\">\n\t\t\t<h3 _v-3b766ca0=\"\">{{ statusWord }}</h3>\n\t\t</div>\n\t\t<div class=\"col-xs-6 action\" v-if=\"actionWord!=''\" _v-3b766ca0=\"\">\n\t\t\t<span v-if=\"Array.isArray(actionWord)\" _v-3b766ca0=\"\">\n\t\t\t\t\t<div class=\"btn\" v-for=\"(word,index) in actionWord\" :class=\"actionBtn\" :disabled=\"btnDisabled\" @click=\"action(actionFunction[index])\" _v-3b766ca0=\"\">\n\t\t\t\t\t\t{{ word }}\n\t\t\t\t\t</div>\n\t\t\t</span>\n\t\t\t<span v-else=\"\" _v-3b766ca0=\"\">\n\t\t\t\t<div class=\"btn\" :class=\"actionBtn\" :disabled=\"btnDisabled\" @click=\"action(actionFunction)\" _v-3b766ca0=\"\">\n\t\t\t\t\t{{ actionWord }}\n\t\t\t\t</div>\n\t\t\t</span>\n\t\t</div>\n\t</div>\n\t<div class=\"row\" v-if=\"detailTitle\" _v-3b766ca0=\"\">\n\t\t<div class=\"col-xs-10 col-xs-offset-2\" _v-3b766ca0=\"\">\n\t\t\t{{ detailTitle}}\n\t\t</div>\n\t</div>\n\t<div class=\"row\" v-if=\"detailContent\" _v-3b766ca0=\"\">\n\t\t<div class=\"col-xs-10 col-xs-offset-2\" _v-3b766ca0=\"\">\n\t\t\t{{ detailContent}}\n\t\t</div>\n\t</div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.modal-footer > .alert-item {\n  padding: 0px; }\n\n/* line 5, stdin */\n.alert-item {\n  border-bottom: 1px solid #C7C4C3;\n  padding: 20px 0px 15px 0px; }\n\n/* line 9, stdin */\n.alert-item:last-child {\n  border: 0px; }\n\n/* line 2, stdin */\n.action[_v-3b766ca0] {\n  margin-top: 20px; }\n\n/* line 6, stdin */\n.icon[_v-3b766ca0] {\n  margin-top: 5px; }\n\n/* line 9, stdin */\n.btn[_v-3b766ca0] {\n  margin-right: 5px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-3b766ca0", module.exports)
  } else {
    hotAPI.update("_v-3b766ca0", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1516:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _vuex = require('vuex');

exports.default = {
	data: function data() {
		return {
			tags: [{}],
			selectTag: [],
			ajaxing: false

		};
	},

	props: {
		clearOnEmit: {
			default: false
		},
		disabled: {
			default: false
		}
	},
	computed: {},
	methods: {
		selectEventAppend: function selectEventAppend(payload) {
			var _this = this;

			this.ajaxing = true;
			this.$http.get('/adminapi/tag/' + payload.id + '/member').then(function (response) {
				var needAppendMembers = [];
				var memberIds = [];
				needAppendMembers = response.data;
				memberIds = needAppendMembers.reduce(function (carry, item) {
					carry.push(item.member_id);
					return carry;
				}, []);
				_this.$emit('append-member', { memberIds: memberIds });
				_this.ajaxing = false;
				if (_this.clearOnEmit) {
					_this.selectTag = [];
				}
			}, function (error) {
				_this.ajaxing = false;
				if (_this.clearOnEmit) {
					_this.selectTag = [];
				}
			});
		}
	},
	watch: {
		// studioId:{

		// }
	},
	mounted: function mounted() {
		var _this2 = this;

		this.ajaxing = true;
		this.$http.get('/adminapi/tag/list').then(function (response) {
			_this2.tags = response.data.result;
			_this2.ajaxing = false;
		}, function (error) {
			_this2.ajaxing = false;
		});
	}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"customer-tag\" _v-e9168e2a=\"\">\t\n\t<div v-show=\"!ajaxing\" _v-e9168e2a=\"\">\n\t\t<v-mutiselect :model.sync=\"selectTag\" :options=\"tags\" :multiple=\"false\" :close-on-select=\"true\" :clear-on-select=\"true\" :searchable=\"true\" label=\"name\" track-by=\"id\" tag-name=\"name\" placeholder=\"加入客戶標籤\" :select-event-append=\"selectEventAppend\" :disabled=\"disabled\" _v-e9168e2a=\"\">\t\t\t\n\t</v-mutiselect></div>\t  \n\t<div v-show=\"ajaxing\" _v-e9168e2a=\"\">\n\t\t<v-spinner-button :ajaxing=\"ajaxing\" _v-e9168e2a=\"\"></v-spinner-button>\n\t</div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-e9168e2a", module.exports)
  } else {
    hotAPI.update("_v-e9168e2a", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vuex":803}],1517:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 3, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/icon.scss */\n.mx-icon-left:before,\n.mx-icon-right:before,\n.mx-icon-double-left:before,\n.mx-icon-double-right:before,\n.mx-icon-double-left:after,\n.mx-icon-double-right:after {\n  content: '';\n  position: relative;\n  top: -1px;\n  display: inline-block;\n  width: 10px;\n  height: 10px;\n  vertical-align: middle;\n  border-style: solid;\n  border-color: currentColor;\n  border-width: 2px 0 0 2px;\n  border-radius: 1px;\n  box-sizing: border-box;\n  transform-origin: center;\n  transform: rotate(-45deg) scale(0.7); }\n\n/* line 20, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/icon.scss */\n.mx-icon-double-left:after {\n  left: -4px; }\n\n/* line 24, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/icon.scss */\n.mx-icon-double-right:before {\n  left: 4px; }\n\n/* line 28, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/icon.scss */\n.mx-icon-right:before,\n.mx-icon-double-right:before,\n.mx-icon-double-right:after {\n  transform: rotate(135deg) scale(0.7); }\n\n/* line 3, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/btn.scss */\n.mx-btn {\n  box-sizing: border-box;\n  line-height: 1;\n  font-size: 14px;\n  font-weight: 500;\n  padding: 7px 15px;\n  margin: 0;\n  cursor: pointer;\n  background-color: transparent;\n  outline: none;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  border-radius: 4px;\n  color: #73879c;\n  white-space: nowrap; }\n  /* line 17, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/btn.scss */\n  .mx-btn:hover {\n    border-color: #38b0e3;\n    color: #38b0e3; }\n\n/* line 23, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/btn.scss */\n.mx-btn-text {\n  border: 0;\n  padding: 0 4px;\n  text-align: left;\n  line-height: inherit; }\n\n/* line 3, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/scrollbar.scss */\n.mx-scrollbar {\n  height: 100%; }\n  /* line 6, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/scrollbar.scss */\n  .mx-scrollbar:hover .mx-scrollbar-track {\n    opacity: 1; }\n\n/* line 12, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/scrollbar.scss */\n.mx-scrollbar-wrap {\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto; }\n\n/* line 18, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/scrollbar.scss */\n.mx-scrollbar-track {\n  position: absolute;\n  top: 2px;\n  right: 2px;\n  bottom: 2px;\n  width: 6px;\n  z-index: 1;\n  border-radius: 4px;\n  opacity: 0;\n  transition: opacity 0.24s ease-out; }\n  /* line 28, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/scrollbar.scss */\n  .mx-scrollbar-track .mx-scrollbar-thumb {\n    position: absolute;\n    width: 100%;\n    height: 0;\n    cursor: pointer;\n    border-radius: inherit;\n    background-color: rgba(144, 147, 153, 0.3);\n    transition: background-color 0.3s; }\n\n/* line 3, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/animation.scss */\n.mx-zoom-in-down-enter-active,\n.mx-zoom-in-down-leave-active {\n  opacity: 1;\n  transform: scaleY(1);\n  transition: transform 0.3s cubic-bezier(0.23, 1, 0.32, 1), opacity 0.3s cubic-bezier(0.23, 1, 0.32, 1);\n  transform-origin: center top; }\n\n/* line 11, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/animation.scss */\n.mx-zoom-in-down-enter,\n.mx-zoom-in-down-enter-from,\n.mx-zoom-in-down-leave-to {\n  opacity: 0;\n  transform: scaleY(0); }\n\n/* line 7, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-datepicker {\n  position: relative;\n  display: inline-block;\n  width: 210px; }\n  /* line 11, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n  .mx-datepicker svg {\n    width: 1em;\n    height: 1em;\n    vertical-align: -0.15em;\n    fill: currentColor;\n    overflow: hidden; }\n\n/* line 20, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-datepicker-range {\n  width: 320px; }\n\n/* line 24, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-datepicker-inline {\n  width: auto; }\n\n/* line 28, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-input-wrapper {\n  position: relative; }\n  /* line 30, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n  .mx-input-wrapper .mx-icon-clear {\n    display: none; }\n  /* line 34, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n  .mx-input-wrapper:hover .mx-icon-clear {\n    display: block; }\n  /* line 37, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n  .mx-input-wrapper:hover .mx-icon-clear + .mx-icon-calendar {\n    display: none; }\n\n/* line 43, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-input {\n  display: inline-block;\n  box-sizing: border-box;\n  width: 100%;\n  height: 34px;\n  padding: 6px 30px;\n  padding-left: 10px;\n  font-size: 14px;\n  line-height: 1.4;\n  color: #555;\n  background-color: #fff;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075); }\n  /* line 58, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n  .mx-input:hover, .mx-input:focus {\n    border-color: #409aff; }\n  /* line 62, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n  .mx-input:disabled, .mx-input.disabled {\n    color: #ccc;\n    background-color: #f3f3f3;\n    border-color: #ccc;\n    cursor: not-allowed; }\n  /* line 69, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n  .mx-input:focus {\n    outline: none; }\n  /* line 72, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n  .mx-input::-ms-clear {\n    display: none; }\n\n/* line 77, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-icon-calendar,\n.mx-icon-clear {\n  position: absolute;\n  top: 50%;\n  right: 8px;\n  transform: translateY(-50%);\n  font-size: 16px;\n  line-height: 1;\n  color: rgba(0, 0, 0, 0.5);\n  vertical-align: middle; }\n\n/* line 88, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-icon-clear {\n  cursor: pointer; }\n  /* line 90, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n  .mx-icon-clear:hover {\n    color: rgba(0, 0, 0, 0.8); }\n\n/* line 95, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-datepicker-main {\n  font: 14px/1.5 'Helvetica Neue', Helvetica, Arial, 'Microsoft Yahei', sans-serif;\n  color: #73879c;\n  background-color: #fff;\n  border: 1px solid #e8e8e8; }\n\n/* line 102, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-datepicker-popup {\n  position: absolute;\n  margin-top: 1px;\n  margin-bottom: 1px;\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\n  z-index: 2001; }\n\n/* line 110, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-datepicker-sidebar {\n  float: left;\n  box-sizing: border-box;\n  width: 100px;\n  padding: 6px;\n  overflow: auto; }\n\n/* line 118, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-datepicker-sidebar + .mx-datepicker-content {\n  margin-left: 100px;\n  border-left: 1px solid #e8e8e8; }\n\n/* line 123, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-datepicker-body {\n  position: relative;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none; }\n\n/* line 128, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-btn-shortcut {\n  display: block;\n  padding: 0 6px;\n  line-height: 24px; }\n\n/* line 134, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-range-wrapper {\n  display: -ms-flexbox;\n  display: flex; }\n  @media (max-width: 750px) {\n    /* line 134, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n    .mx-range-wrapper {\n      -ms-flex-direction: column;\n          flex-direction: column; } }\n\n/* line 141, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-datepicker-header {\n  padding: 6px 8px;\n  border-bottom: 1px solid #e8e8e8; }\n\n/* line 146, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-datepicker-footer {\n  padding: 6px 8px;\n  text-align: right;\n  border-top: 1px solid #e8e8e8; }\n\n/* line 152, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-calendar {\n  box-sizing: border-box;\n  width: 248px;\n  padding: 6px 12px; }\n  /* line 156, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n  .mx-calendar + .mx-calendar {\n    border-left: 1px solid #e8e8e8; }\n\n/* line 161, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-calendar-header, .mx-time-header {\n  box-sizing: border-box;\n  height: 34px;\n  line-height: 34px;\n  text-align: center;\n  overflow: hidden; }\n\n/* line 169, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-btn-icon-left,\n.mx-btn-icon-double-left {\n  float: left; }\n\n/* line 172, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-btn-icon-right,\n.mx-btn-icon-double-right {\n  float: right; }\n\n/* line 176, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-calendar-header-label {\n  font-size: 14px; }\n\n/* line 180, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-calendar-decade-separator {\n  margin: 0 2px; }\n  /* line 182, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n  .mx-calendar-decade-separator:after {\n    content: '~'; }\n\n/* line 187, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-calendar-content {\n  position: relative;\n  height: 224px;\n  box-sizing: border-box; }\n  /* line 191, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n  .mx-calendar-content .cell {\n    cursor: pointer; }\n    /* line 193, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n    .mx-calendar-content .cell:hover {\n      color: #73879c;\n      background-color: #f5fbfe; }\n    /* line 197, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n    .mx-calendar-content .cell.active {\n      color: #fff;\n      background-color: #38b0e3; }\n    /* line 201, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n    .mx-calendar-content .cell.in-range, .mx-calendar-content .cell.hover-in-range {\n      color: #73879c;\n      background-color: #e1f3fb; }\n    /* line 206, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n    .mx-calendar-content .cell.disabled {\n      cursor: not-allowed;\n      color: #ccc;\n      background-color: #f3f3f3; }\n\n/* line 215, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-calendar-week-mode .mx-date-row {\n  cursor: pointer; }\n  /* line 217, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n  .mx-calendar-week-mode .mx-date-row:hover {\n    background-color: #f5fbfe; }\n  /* line 220, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n  .mx-calendar-week-mode .mx-date-row.mx-active-week {\n    background-color: #e1f3fb; }\n  /* line 224, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n  .mx-calendar-week-mode .mx-date-row .cell:hover {\n    color: inherit;\n    background-color: transparent; }\n  /* line 228, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n  .mx-calendar-week-mode .mx-date-row .cell.active {\n    color: inherit;\n    background-color: transparent; }\n\n/* line 236, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-week-number {\n  opacity: 0.5; }\n\n/* line 240, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-table {\n  table-layout: fixed;\n  border-collapse: separate;\n  border-spacing: 0;\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n  text-align: center; }\n  /* line 249, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n  .mx-table th {\n    padding: 0;\n    font-weight: 500;\n    vertical-align: middle; }\n  /* line 254, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n  .mx-table td {\n    padding: 0;\n    vertical-align: middle; }\n\n/* line 261, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-table-date td,\n.mx-table-date th {\n  height: 32px;\n  font-size: 12px; }\n\n/* line 267, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-table-date .today {\n  color: #4cb8e6; }\n\n/* line 270, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-table-date .cell.not-current-month {\n  color: #ccc;\n  background: none; }\n\n/* line 276, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-time {\n  -ms-flex: 1;\n      flex: 1;\n  width: 224px;\n  background: #fff; }\n  /* line 280, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n  .mx-time + .mx-time {\n    border-left: 1px solid #e8e8e8; }\n\n/* line 284, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-calendar-time {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%; }\n\n/* line 291, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-time-header {\n  border-bottom: 1px solid #e8e8e8; }\n\n/* line 296, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-time-content {\n  height: 224px;\n  box-sizing: border-box;\n  overflow: hidden; }\n\n/* line 302, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-time-columns {\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  height: 100%;\n  overflow: hidden; }\n\n/* line 309, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-time-column {\n  -ms-flex: 1;\n      flex: 1;\n  position: relative;\n  border-left: 1px solid #e8e8e8;\n  text-align: center; }\n  /* line 315, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n  .mx-time-column:first-child {\n    border-left: 0; }\n  /* line 318, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n  .mx-time-column .mx-time-list {\n    margin: 0;\n    padding: 0;\n    list-style: none; }\n    /* line 322, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n    .mx-time-column .mx-time-list::after {\n      content: '';\n      display: block;\n      height: 192px; }\n  /* line 328, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n  .mx-time-column .mx-time-item {\n    cursor: pointer;\n    font-size: 12px;\n    height: 32px;\n    line-height: 32px; }\n    /* line 333, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n    .mx-time-column .mx-time-item:hover {\n      color: #73879c;\n      background-color: #f5fbfe; }\n    /* line 337, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n    .mx-time-column .mx-time-item.active {\n      color: #38b0e3;\n      background-color: transparent;\n      font-weight: 700; }\n    /* line 342, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n    .mx-time-column .mx-time-item.disabled {\n      cursor: not-allowed;\n      color: #ccc;\n      background-color: #f3f3f3; }\n\n/* line 350, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-time-option {\n  cursor: pointer;\n  padding: 8px 10px;\n  font-size: 14px;\n  line-height: 20px; }\n  /* line 355, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n  .mx-time-option:hover {\n    color: #73879c;\n    background-color: #f5fbfe; }\n  /* line 359, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n  .mx-time-option.active {\n    color: #38b0e3;\n    background-color: transparent;\n    font-weight: 700; }\n  /* line 364, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n  .mx-time-option.disabled {\n    cursor: not-allowed;\n    color: #ccc;\n    background-color: #f3f3f3; }\n\n/* line 5, stdin */\n.mx-datepicker-range {\n  max-width: 100%; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue2Datepicker = require('vue2-datepicker');

var _vue2Datepicker2 = _interopRequireDefault(_vue2Datepicker);

require('vue2-datepicker/locale/zh-cn');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        DatePicker: _vue2Datepicker2.default
    },
    props: {
        value: {
            default: null
        },
        format: {
            default: 'YYYY-MM-DD' //參考 moment.js//datetime:'YYYY-MM-DD HH:mm:ss'
        },
        type: {
            default: 'date' //date|datetime|year|month|time|week
        },
        placeholder: {
            default: '請選擇日期'
        },
        range: {
            default: false
        },
        rangeDateFixedEnd: { // RangeDatePicker 固定結束日期
            type: String
        },
        disabled: {
            default: false
        },
        editable: {
            default: true
        },
        clearable: {
            default: true
        },
        shortcuts: {
            type: Array, //從 shortcut_list 挑要使用的捷徑名稱 ex.['range_today','range_yesterday','range_past_30d']
            default: function _default() {
                return [];
            }
        },
        disabledDate: {
            type: Function | String
        },
        disabledTime: {
            type: Function | String
        },
        inputClass: {
            default: null
        }
    },
    mounted: function mounted() {
        this.date = this.value;
        this.enableInputSlot = this.$slots.hasOwnProperty('input');
    },
    data: function data() {
        var vm = this;
        return {
            unit: 'd',
            date: null,
            open: false,
            shortcuts_text: '',
            shortcut_list: {
                date_today: {
                    text: '今天',
                    onClick: function onClick() {
                        var date = moment().toDate();
                        vm.unit = 'd';
                        vm.shortcuts_text = '今天';
                        return date;
                    }
                },
                date_yesterday: {
                    text: '昨天',
                    onClick: function onClick() {
                        var date = moment().subtract(1, 'days').toDate();
                        vm.unit = 'd';
                        vm.shortcuts_text = '昨天';
                        return date;
                    }
                },
                range_today: {
                    text: '今天',
                    onClick: function onClick() {
                        var date = moment().toDate();
                        vm.unit = 'd';
                        vm.shortcuts_text = '今天';
                        return [date, date];
                    }
                },
                range_yesterday: {
                    text: '昨天',
                    onClick: function onClick() {
                        var date = moment().subtract(1, 'days').toDate();
                        vm.unit = 'd';
                        vm.shortcuts_text = '昨天';
                        return [date, date];
                    }
                },
                range_past_7d: {
                    text: '過去 7 天',
                    onClick: function onClick() {
                        var end = moment().subtract(1, 'days').toDate();
                        var date = moment().subtract(7, 'days').toDate();
                        vm.unit = 'd';
                        vm.shortcuts_text = '過去 7 天';
                        return [date, end];
                    }
                },
                range_past_14d: {
                    text: '過去 14 天',
                    onClick: function onClick() {
                        var end = moment().subtract(1, 'days').toDate();
                        var date = moment().subtract(14, 'days').toDate();
                        vm.unit = 'd';
                        vm.shortcuts_text = '過去 14 天';
                        return [date, end];
                    }
                },
                range_past_30d: {
                    text: '過去 30 天',
                    onClick: function onClick() {
                        var end = moment().subtract(1, 'days').toDate();
                        var date = moment().subtract(30, 'days').toDate();
                        vm.unit = 'd';
                        vm.shortcuts_text = '過去 30 天';
                        return [date, end];
                    }
                },
                range_past_30d_include_today: {
                    text: '過去 30 天',
                    onClick: function onClick() {
                        var end = moment().toDate();
                        var date = moment().subtract(29, 'days').toDate();
                        vm.shortcuts_text = '過去 30 天';
                        return [date, end];
                    }
                },
                range_past_60d: {
                    text: '過去 60 天',
                    onClick: function onClick() {
                        var today = moment().subtract(1, 'days').toDate();
                        var date = moment().subtract(60, 'days').toDate();
                        vm.unit = 'd';
                        vm.shortcuts_text = '過去 60 天';
                        return [date, today];
                    }
                },
                range_past_90d: {
                    text: '過去 90 天',
                    onClick: function onClick() {
                        var end = moment().subtract(1, 'days').toDate();
                        var date = moment().subtract(90, 'days').toDate();
                        vm.unit = 'd';
                        vm.shortcuts_text = '過去 90 天';
                        return [date, end];
                    }
                },
                range_past_90d_include_today: {
                    text: '過去 90 天',
                    onClick: function onClick() {
                        var end = moment().toDate();
                        var date = moment().subtract(89, 'days').toDate();
                        vm.shortcuts_text = '過去 90 天';
                        return [date, end];
                    }
                },
                range_past_180d: {
                    text: '過去 180 天',
                    onClick: function onClick() {
                        var end = moment().subtract(1, 'days').toDate();
                        var date = moment().subtract(180, 'days').toDate();
                        vm.unit = 'd';
                        vm.shortcuts_text = '過去 180 天';
                        return [date, end];
                    }
                },
                range_past_180d_include_today: {
                    text: '過去 180 天',
                    onClick: function onClick() {
                        var end = moment().toDate();
                        var date = moment().subtract(179, 'days').toDate();
                        vm.shortcuts_text = '過去 180 天';
                        return [date, end];
                    }
                },
                range_past_365d_include_today: {
                    text: '過去 365 天',
                    onClick: function onClick() {
                        var end = moment().toDate();
                        var date = moment().subtract(364, 'days').toDate();
                        vm.shortcuts_text = '過去 365 天';
                        return [date, end];
                    }
                },
                range_monthly_3m: {
                    text: '前 3 個月',
                    onClick: function onClick() {
                        var start = moment().subtract(3, 'months').startOf('month').toDate();
                        var end = moment().subtract(1, 'months').endOf('month').toDate();
                        vm.unit = 'monthly';
                        vm.shortcuts_text = '前 3 個月';
                        return [start, end];
                    }
                },
                range_monthly_6m: {
                    text: '前 6 個月',
                    onClick: function onClick() {
                        var start = moment().subtract(6, 'months').startOf('month').toDate();
                        var end = moment().subtract(1, 'months').endOf('month').toDate();
                        vm.unit = 'monthly';
                        vm.shortcuts_text = '前 6 個月';
                        return [start, end];
                    }
                },
                range_past_1m: {
                    text: '上個月',
                    onClick: function onClick() {
                        var start = moment().subtract(1, 'months').startOf('month').toDate();
                        var end = moment().subtract(1, 'months').endOf('month').toDate();
                        vm.unit = 'd';
                        vm.shortcuts_text = '上個月';
                        return [start, end];
                    }
                }
                // range_past_1y: { // (測試用) "過去 1 年", "過去 2 年" 的計算方式尚未正式定義。
                //     text: '過去 1 年',
                //     onClick() {
                //         const start = moment().startOf('year').toDate();
                //         const end = moment().endOf('year').toDate();
                //         vm.unit = 'monthly';
                //         vm.shortcuts_text = '過去 1 年';
                //         return [start, end];
                //     },
                // },
                // range_past_2y: {
                //     text: '過去 2 年',
                //     onClick() {
                //         const start = moment().subtract(2, 'years').startOf('year').toDate();
                //         const end = moment().endOf('year').toDate();
                //         vm.unit = 'monthly';
                //         vm.shortcuts_text = '過去 2 年';
                //         return [start, end];
                //     },
                // },
            },
            enableInputSlot: false
        };
    },

    computed: {
        pickShortcuts: function pickShortcuts() {
            var data = _.pick(this.shortcut_list, this.shortcuts);
            data = _.toArray(data);
            return data;
        },
        pickDisabledDate: function pickDisabledDate() {
            if (typeof this.disabledDate == 'string') {
                //可以呼叫這邊 methods 寫好的方法
                return this[this.disabledDate];
                //ex. return this['disabledBeforePast3DaysAndAfterToday'];
            } else {
                return this.disabledDate;
            }
        },
        pickDisabledTime: function pickDisabledTime() {
            if (typeof this.disabledTime == 'string') {
                //可以呼叫這邊 methods 寫好的方法
                return this[this.disabledTime];
                //ex. return this['disabledBeforePast3DaysAndAfterToday'];
            } else {
                return this.disabledTime;
            }
        }
    },
    watch: {
        value: function value(newVal, oldVal) {
            this.date = newVal;
        }
    },
    methods: {
        changeEvent: function changeEvent($event) {
            var payload = {
                dates: $event,
                start: $event[0],
                end: $event[1],
                unit: this.unit,
                shortcuts_text: this.shortcuts_text
            };
            this.$emit('change', payload);
        },
        selectDate: function selectDate(date) {
            this.$emit('pick', date);
            if (this.range && this.rangeDateFixedEnd) {
                this.date = [moment(date).format('YYYY-MM-DD'), moment(this.rangeDateFixedEnd).format('YYYY-MM-DD')];
                this.$emit('input', this.date);
                this.changeEvent(this.date);
                this.open = false;
            }
        },
        disabledBeforePast3DaysAndAfterToday: function disabledBeforePast3DaysAndAfterToday(date) {
            //只能選三天內其他都 disabled
            var today = moment().toDate();
            var afterDate7Days = moment().subtract(3, 'days').toDate();
            return date < afterDate7Days || date > today;
        },
        disabledBeforePast365DaysAndAfterToday: function disabledBeforePast365DaysAndAfterToday(date) {
            //只能選今天以前 365 天的日期
            var today = moment().toDate();
            var beforePast365Days = moment().subtract(365, 'days').toDate();
            return date < beforePast365Days || date > today;
        },
        notBeforeToday: function notBeforeToday(date) {
            //只能選今天以後的日期
            var today = moment().toDate();
            return date < today;
        },
        disabledAllDate: function disabledAllDate(date) {
            return true;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<date-picker v-model=\"date\" @input=\"$emit('input',date)\" @change=\"changeEvent($event)\" @pick=\"selectDate\" :type=\"type\" :value-type=\"format\" :format=\"format\" :range=\"range\" :disabled=\"disabled\" :clearable=\"clearable\" :editable=\"editable\" :shortcuts=\"pickShortcuts\" :placeholder=\"placeholder\" :input-class=\"inputClass\" :disabled-date=\"pickDisabledDate\" :disabled-time=\"pickDisabledTime\" :open.sync=\"open\">\n    <template slot=\"input\" v-if=\"enableInputSlot\">\n        <div class=\"mx-input\">\n            <slot name=\"input\"></slot>\n        </div>\n    </template>\n</date-picker>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 3, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/icon.scss */\n.mx-icon-left:before,\n.mx-icon-right:before,\n.mx-icon-double-left:before,\n.mx-icon-double-right:before,\n.mx-icon-double-left:after,\n.mx-icon-double-right:after {\n  content: '';\n  position: relative;\n  top: -1px;\n  display: inline-block;\n  width: 10px;\n  height: 10px;\n  vertical-align: middle;\n  border-style: solid;\n  border-color: currentColor;\n  border-width: 2px 0 0 2px;\n  border-radius: 1px;\n  box-sizing: border-box;\n  transform-origin: center;\n  transform: rotate(-45deg) scale(0.7); }\n\n/* line 20, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/icon.scss */\n.mx-icon-double-left:after {\n  left: -4px; }\n\n/* line 24, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/icon.scss */\n.mx-icon-double-right:before {\n  left: 4px; }\n\n/* line 28, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/icon.scss */\n.mx-icon-right:before,\n.mx-icon-double-right:before,\n.mx-icon-double-right:after {\n  transform: rotate(135deg) scale(0.7); }\n\n/* line 3, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/btn.scss */\n.mx-btn {\n  box-sizing: border-box;\n  line-height: 1;\n  font-size: 14px;\n  font-weight: 500;\n  padding: 7px 15px;\n  margin: 0;\n  cursor: pointer;\n  background-color: transparent;\n  outline: none;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  border-radius: 4px;\n  color: #73879c;\n  white-space: nowrap; }\n  /* line 17, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/btn.scss */\n  .mx-btn:hover {\n    border-color: #38b0e3;\n    color: #38b0e3; }\n\n/* line 23, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/btn.scss */\n.mx-btn-text {\n  border: 0;\n  padding: 0 4px;\n  text-align: left;\n  line-height: inherit; }\n\n/* line 3, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/scrollbar.scss */\n.mx-scrollbar {\n  height: 100%; }\n  /* line 6, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/scrollbar.scss */\n  .mx-scrollbar:hover .mx-scrollbar-track {\n    opacity: 1; }\n\n/* line 12, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/scrollbar.scss */\n.mx-scrollbar-wrap {\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto; }\n\n/* line 18, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/scrollbar.scss */\n.mx-scrollbar-track {\n  position: absolute;\n  top: 2px;\n  right: 2px;\n  bottom: 2px;\n  width: 6px;\n  z-index: 1;\n  border-radius: 4px;\n  opacity: 0;\n  transition: opacity 0.24s ease-out; }\n  /* line 28, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/scrollbar.scss */\n  .mx-scrollbar-track .mx-scrollbar-thumb {\n    position: absolute;\n    width: 100%;\n    height: 0;\n    cursor: pointer;\n    border-radius: inherit;\n    background-color: rgba(144, 147, 153, 0.3);\n    transition: background-color 0.3s; }\n\n/* line 3, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/animation.scss */\n.mx-zoom-in-down-enter-active,\n.mx-zoom-in-down-leave-active {\n  opacity: 1;\n  transform: scaleY(1);\n  transition: transform 0.3s cubic-bezier(0.23, 1, 0.32, 1), opacity 0.3s cubic-bezier(0.23, 1, 0.32, 1);\n  transform-origin: center top; }\n\n/* line 11, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/animation.scss */\n.mx-zoom-in-down-enter,\n.mx-zoom-in-down-enter-from,\n.mx-zoom-in-down-leave-to {\n  opacity: 0;\n  transform: scaleY(0); }\n\n/* line 7, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-datepicker {\n  position: relative;\n  display: inline-block;\n  width: 210px; }\n  /* line 11, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n  .mx-datepicker svg {\n    width: 1em;\n    height: 1em;\n    vertical-align: -0.15em;\n    fill: currentColor;\n    overflow: hidden; }\n\n/* line 20, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-datepicker-range {\n  width: 320px; }\n\n/* line 24, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-datepicker-inline {\n  width: auto; }\n\n/* line 28, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-input-wrapper {\n  position: relative; }\n  /* line 30, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n  .mx-input-wrapper .mx-icon-clear {\n    display: none; }\n  /* line 34, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n  .mx-input-wrapper:hover .mx-icon-clear {\n    display: block; }\n  /* line 37, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n  .mx-input-wrapper:hover .mx-icon-clear + .mx-icon-calendar {\n    display: none; }\n\n/* line 43, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-input {\n  display: inline-block;\n  box-sizing: border-box;\n  width: 100%;\n  height: 34px;\n  padding: 6px 30px;\n  padding-left: 10px;\n  font-size: 14px;\n  line-height: 1.4;\n  color: #555;\n  background-color: #fff;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075); }\n  /* line 58, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n  .mx-input:hover, .mx-input:focus {\n    border-color: #409aff; }\n  /* line 62, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n  .mx-input:disabled, .mx-input.disabled {\n    color: #ccc;\n    background-color: #f3f3f3;\n    border-color: #ccc;\n    cursor: not-allowed; }\n  /* line 69, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n  .mx-input:focus {\n    outline: none; }\n  /* line 72, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n  .mx-input::-ms-clear {\n    display: none; }\n\n/* line 77, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-icon-calendar,\n.mx-icon-clear {\n  position: absolute;\n  top: 50%;\n  right: 8px;\n  transform: translateY(-50%);\n  font-size: 16px;\n  line-height: 1;\n  color: rgba(0, 0, 0, 0.5);\n  vertical-align: middle; }\n\n/* line 88, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-icon-clear {\n  cursor: pointer; }\n  /* line 90, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n  .mx-icon-clear:hover {\n    color: rgba(0, 0, 0, 0.8); }\n\n/* line 95, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-datepicker-main {\n  font: 14px/1.5 'Helvetica Neue', Helvetica, Arial, 'Microsoft Yahei', sans-serif;\n  color: #73879c;\n  background-color: #fff;\n  border: 1px solid #e8e8e8; }\n\n/* line 102, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-datepicker-popup {\n  position: absolute;\n  margin-top: 1px;\n  margin-bottom: 1px;\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\n  z-index: 2001; }\n\n/* line 110, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-datepicker-sidebar {\n  float: left;\n  box-sizing: border-box;\n  width: 100px;\n  padding: 6px;\n  overflow: auto; }\n\n/* line 118, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-datepicker-sidebar + .mx-datepicker-content {\n  margin-left: 100px;\n  border-left: 1px solid #e8e8e8; }\n\n/* line 123, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-datepicker-body {\n  position: relative;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none; }\n\n/* line 128, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-btn-shortcut {\n  display: block;\n  padding: 0 6px;\n  line-height: 24px; }\n\n/* line 134, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-range-wrapper {\n  display: -ms-flexbox;\n  display: flex; }\n  @media (max-width: 750px) {\n    /* line 134, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n    .mx-range-wrapper {\n      -ms-flex-direction: column;\n          flex-direction: column; } }\n\n/* line 141, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-datepicker-header {\n  padding: 6px 8px;\n  border-bottom: 1px solid #e8e8e8; }\n\n/* line 146, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-datepicker-footer {\n  padding: 6px 8px;\n  text-align: right;\n  border-top: 1px solid #e8e8e8; }\n\n/* line 152, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-calendar {\n  box-sizing: border-box;\n  width: 248px;\n  padding: 6px 12px; }\n  /* line 156, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n  .mx-calendar + .mx-calendar {\n    border-left: 1px solid #e8e8e8; }\n\n/* line 161, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-calendar-header, .mx-time-header {\n  box-sizing: border-box;\n  height: 34px;\n  line-height: 34px;\n  text-align: center;\n  overflow: hidden; }\n\n/* line 169, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-btn-icon-left,\n.mx-btn-icon-double-left {\n  float: left; }\n\n/* line 172, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-btn-icon-right,\n.mx-btn-icon-double-right {\n  float: right; }\n\n/* line 176, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-calendar-header-label {\n  font-size: 14px; }\n\n/* line 180, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-calendar-decade-separator {\n  margin: 0 2px; }\n  /* line 182, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n  .mx-calendar-decade-separator:after {\n    content: '~'; }\n\n/* line 187, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-calendar-content {\n  position: relative;\n  height: 224px;\n  box-sizing: border-box; }\n  /* line 191, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n  .mx-calendar-content .cell {\n    cursor: pointer; }\n    /* line 193, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n    .mx-calendar-content .cell:hover {\n      color: #73879c;\n      background-color: #f5fbfe; }\n    /* line 197, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n    .mx-calendar-content .cell.active {\n      color: #fff;\n      background-color: #38b0e3; }\n    /* line 201, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n    .mx-calendar-content .cell.in-range, .mx-calendar-content .cell.hover-in-range {\n      color: #73879c;\n      background-color: #e1f3fb; }\n    /* line 206, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n    .mx-calendar-content .cell.disabled {\n      cursor: not-allowed;\n      color: #ccc;\n      background-color: #f3f3f3; }\n\n/* line 215, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-calendar-week-mode .mx-date-row {\n  cursor: pointer; }\n  /* line 217, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n  .mx-calendar-week-mode .mx-date-row:hover {\n    background-color: #f5fbfe; }\n  /* line 220, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n  .mx-calendar-week-mode .mx-date-row.mx-active-week {\n    background-color: #e1f3fb; }\n  /* line 224, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n  .mx-calendar-week-mode .mx-date-row .cell:hover {\n    color: inherit;\n    background-color: transparent; }\n  /* line 228, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n  .mx-calendar-week-mode .mx-date-row .cell.active {\n    color: inherit;\n    background-color: transparent; }\n\n/* line 236, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-week-number {\n  opacity: 0.5; }\n\n/* line 240, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-table {\n  table-layout: fixed;\n  border-collapse: separate;\n  border-spacing: 0;\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n  text-align: center; }\n  /* line 249, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n  .mx-table th {\n    padding: 0;\n    font-weight: 500;\n    vertical-align: middle; }\n  /* line 254, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n  .mx-table td {\n    padding: 0;\n    vertical-align: middle; }\n\n/* line 261, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-table-date td,\n.mx-table-date th {\n  height: 32px;\n  font-size: 12px; }\n\n/* line 267, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-table-date .today {\n  color: #4cb8e6; }\n\n/* line 270, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-table-date .cell.not-current-month {\n  color: #ccc;\n  background: none; }\n\n/* line 276, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-time {\n  -ms-flex: 1;\n      flex: 1;\n  width: 224px;\n  background: #fff; }\n  /* line 280, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n  .mx-time + .mx-time {\n    border-left: 1px solid #e8e8e8; }\n\n/* line 284, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-calendar-time {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%; }\n\n/* line 291, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-time-header {\n  border-bottom: 1px solid #e8e8e8; }\n\n/* line 296, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-time-content {\n  height: 224px;\n  box-sizing: border-box;\n  overflow: hidden; }\n\n/* line 302, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-time-columns {\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  height: 100%;\n  overflow: hidden; }\n\n/* line 309, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-time-column {\n  -ms-flex: 1;\n      flex: 1;\n  position: relative;\n  border-left: 1px solid #e8e8e8;\n  text-align: center; }\n  /* line 315, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n  .mx-time-column:first-child {\n    border-left: 0; }\n  /* line 318, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n  .mx-time-column .mx-time-list {\n    margin: 0;\n    padding: 0;\n    list-style: none; }\n    /* line 322, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n    .mx-time-column .mx-time-list::after {\n      content: '';\n      display: block;\n      height: 192px; }\n  /* line 328, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n  .mx-time-column .mx-time-item {\n    cursor: pointer;\n    font-size: 12px;\n    height: 32px;\n    line-height: 32px; }\n    /* line 333, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n    .mx-time-column .mx-time-item:hover {\n      color: #73879c;\n      background-color: #f5fbfe; }\n    /* line 337, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n    .mx-time-column .mx-time-item.active {\n      color: #38b0e3;\n      background-color: transparent;\n      font-weight: 700; }\n    /* line 342, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n    .mx-time-column .mx-time-item.disabled {\n      cursor: not-allowed;\n      color: #ccc;\n      background-color: #f3f3f3; }\n\n/* line 350, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n.mx-time-option {\n  cursor: pointer;\n  padding: 8px 10px;\n  font-size: 14px;\n  line-height: 20px; }\n  /* line 355, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n  .mx-time-option:hover {\n    color: #73879c;\n    background-color: #f5fbfe; }\n  /* line 359, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n  .mx-time-option.active {\n    color: #38b0e3;\n    background-color: transparent;\n    font-weight: 700; }\n  /* line 364, /home/deploy/feature-app/releases/20240702091150/node_modules/vue2-datepicker/scss/index.scss */\n  .mx-time-option.disabled {\n    cursor: not-allowed;\n    color: #ccc;\n    background-color: #f3f3f3; }\n\n/* line 5, stdin */\n.mx-datepicker-range {\n  max-width: 100%; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-5dd7d3fd", module.exports)
  } else {
    hotAPI.update("_v-5dd7d3fd", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vue2-datepicker":797,"vue2-datepicker/locale/zh-cn":798,"vueify/lib/insert-css":799}],1518:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.vdp-datepicker input:disabled {\n  background-color: #E3E3E3; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vuejsDatepicker = require('vuejs-datepicker');

var _vuejsDatepicker2 = _interopRequireDefault(_vuejsDatepicker);

var _locale = require('vuejs-datepicker/dist/locale');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        VueDatepicker: _vuejsDatepicker2.default
    },
    props: {
        uniqueName: {
            default: 'default-date'
        },
        formatString: {
            default: 'Y/MM/DD'
        },
        placeholder: {
            default: '請選擇日期'
        },
        typeable: {
            default: false
        },
        disabledDates: {
            default: function _default() {
                return {};
            }
        },
        disabled: {
            default: false
        },
        readonly: {
            default: false
        },
        language: {
            default: 'zh'
        },
        openDate: {
            default: null
        },
        calendarClass: {
            default: ''
        },
        value: {
            default: ''
        },
        toTime: {
            default: ''
        },
        id: {
            default: null
        },
        inputClass: {
            default: ''
        },
        inline: {
            type: Boolean,
            default: false
        },
        minimumView: {
            default: 'day'
        }
    },
    computed: {},
    watch: {
        value: function value(newVal) {
            this.state.highlighted.from = new Date(this.value);
            if (this.toTime) {
                this.state.highlighted.to = new Date(this.toTime);
            } else {
                this.state.highlighted.to = new Date(this.value);
            }
        }
        // currentDate(newDate){
        //     this.emitSelectEvent(newDate);
        // },

    },
    methods: {
        customFormatter: function customFormatter(date) {
            return moment(date).format(this.formatString);
        },
        emitSelectEvent: function emitSelectEvent(date) {
            this.$emit('input', this.customFormatter(date));
        }
    },
    data: function data() {
        return {
            zh: _locale.zh,
            // currentDate: null,
            state: {
                highlighted: {
                    from: '',
                    to: ''
                }
            }
        };
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<vue-datepicker :format=\"customFormatter\" :name=\"uniqueName\" :placeholder=\"placeholder\" @selected=\"emitSelectEvent\" :language=\"zh\" :open-date=\"openDate\" :value=\"value\" :transfer=\"true\" :calendar-class=\"calendarClass\" :disabled=\"disabled\" :readonly=\"readonly\" :id=\"id\" :input-class=\"inputClass\" :highlighted=\"state.highlighted\" :typeable=\"typeable\" :disabled-dates=\"disabledDates\" :inline=\"inline\" :minimum-view=\"minimumView\"></vue-datepicker>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.vdp-datepicker input:disabled {\n  background-color: #E3E3E3; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-4433fafc", module.exports)
  } else {
    hotAPI.update("_v-4433fafc", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuejs-datepicker":801,"vuejs-datepicker/dist/locale":800}],1519:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	data: function data() {
		return {
			show: 1
		};
	},

	props: {
		dismissibleStyle: {
			type: String,
			default: 'alert-success'
		},
		allowClose: {
			type: Boolean,
			default: false
		},
		link: {
			type: String,
			default: ''
		},
		text: {
			type: String,
			default: ''
		}
	},
	methods: {
		closeAlertBox: function closeAlertBox() {
			this.show = 0;
		},
		showAlert: function showAlert() {
			this.show = 1;
		}
	}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n\t<div class=\"alert alert-dismissible\" :class=\"dismissibleStyle\" v-if=\"show &amp;&amp; text!=''\" _v-497cc388=\"\">\n        <button type=\"button\" class=\"close st-opacity-100\" aria-label=\"Close\" v-if=\"allowClose\" @click=\"closeAlertBox\" _v-497cc388=\"\">\n            <span aria-hidden=\"true\" _v-497cc388=\"\">×</span>\n        </button>\n        <span _v-497cc388=\"\">\n\t\t\t<a v-if=\"link!==''\" :href=\"link\" target=\"_blank\" v-html=\"text\" _v-497cc388=\"\"></a>\n        \t<span v-else=\"\" v-html=\"text\" _v-497cc388=\"\"></span>\n\t\t</span>\n    </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-497cc388", module.exports)
  } else {
    hotAPI.update("_v-497cc388", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],1520:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n#dismissible-alert[_v-bdf024ca] {\n  -moz-animation: showHide 0.6s ease;\n  -webkit-animation: showHide 0.6s ease;\n  -ms-animation: showHide 0.6s ease;\n  animation: showHide 0.6s ease; }\n  /* line 7, stdin */\n  #dismissible-alert .dismissible-alert-container[_v-bdf024ca] {\n    position: fixed;\n    top: 60px;\n    left: 50%;\n    margin-left: var(--alert-offset-width);\n    z-index: 2000; }\n\n@-webkit-keyframes showHide {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n\n@keyframes showHide {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {},
    data: function data() {
        return {
            visible: false,
            type: 'success',
            message: '',
            speed: 4500,
            timeoutId: ''
        };
    },
    created: function created() {
        var _this = this;

        /**
         * @param data 
         * {
         *  'type': 'success',    (Alert type: success, info, warning, danger; optional; default: success)
         *  'message': '儲存成功'  (Alert message)
         *  'speed': 5000         (optional; default: 4500)
         * }
         */
        window.Event.$on("dismissible-alert", function (data) {
            _this.showAlert(data);
        });
    },

    watch: {
        timeoutId: function timeoutId(newVal, oldVal) {
            if (this.visible) {
                window.clearTimeout(oldVal);
            }
        }
    },
    methods: {
        showAlert: function showAlert(data) {
            this.visible = true;
            this.type = data.type ? data.type : 'success';
            this.message = data.message;
            this.speed = data.speed ? data.speed : 4500;

            this.setTimeoutFun();

            this.$nextTick(function () {
                var alertComponent = document.getElementsByClassName("dismissible-alert-container")[0];
                var width = alertComponent.offsetWidth;
                alertComponent.style.setProperty('--alert-offset-width', '-' + width / 2 + 'px');
            });
        },
        setTimeoutFun: function setTimeoutFun() {
            var vm = this;
            this.timeoutId = setTimeout(function () {
                vm.visible = false;
            }, this.speed);
        },
        closeAlert: function closeAlert() {
            this.visible = false;
        }
    },
    beforeDestroy: function beforeDestroy() {
        window.Event.$off("dismissible-alert");
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div id=\"dismissible-alert\" v-show=\"visible\" _v-bdf024ca=\"\">\n    <div class=\"alert dismissible-alert-container m-right-10 m-left-10\" :class=\"'alert-'+type\" role=\"alert\" _v-bdf024ca=\"\">\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" @click.prevent.stop=\"closeAlert\" _v-bdf024ca=\"\"><span aria-hidden=\"true\" _v-bdf024ca=\"\">×</span></button>\n        <strong _v-bdf024ca=\"\">\n            <i class=\"fa fa-check-circle\" v-show=\"type === 'success'\" _v-bdf024ca=\"\"></i>\n            <i class=\"fa fa-exclamation-circle\" v-show=\"type === 'warning'\" _v-bdf024ca=\"\"></i>\n            <i class=\"fa fa-times-circle\" v-show=\"type === 'danger'\" _v-bdf024ca=\"\"></i>\n            <i class=\"fa fa-info-circle\" v-show=\"type === 'info'\" _v-bdf024ca=\"\"></i>\n        </strong> \n        {{ message }}\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n#dismissible-alert[_v-bdf024ca] {\n  -moz-animation: showHide 0.6s ease;\n  -webkit-animation: showHide 0.6s ease;\n  -ms-animation: showHide 0.6s ease;\n  animation: showHide 0.6s ease; }\n  /* line 7, stdin */\n  #dismissible-alert .dismissible-alert-container[_v-bdf024ca] {\n    position: fixed;\n    top: 60px;\n    left: 50%;\n    margin-left: var(--alert-offset-width);\n    z-index: 2000; }\n\n@-webkit-keyframes showHide {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n\n@keyframes showHide {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-bdf024ca", module.exports)
  } else {
    hotAPI.update("_v-bdf024ca", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1521:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.view-background[_v-4b1da3a1] {\n  position: fixed;\n  height: 100%;\n  width: 100%;\n  top: 0;\n  left: 0;\n  z-index: 2000;\n  overflow-y: scroll;\n  background-color: rgba(0, 0, 0, 0.7); }\n  /* line 11, stdin */\n  .view-background .view-img[_v-4b1da3a1] {\n    max-width: 90vw; }\n  /* line 15, stdin */\n  .view-background .view-img-contain[_v-4b1da3a1] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: center;\n        justify-content: center;\n    -ms-flex-align: center;\n        align-items: center;\n    margin-bottom: 20vh; }\n  /* line 21, stdin */\n  .view-background .view-close[_v-4b1da3a1] {\n    text-align: right;\n    color: #ddd;\n    padding-right: 15px;\n    padding-top: 10px;\n    cursor: pointer; }\n  /* line 28, stdin */\n  .view-background .view-action[_v-4b1da3a1] {\n    background-color: rgba(0, 0, 0, 0.3);\n    position: fixed;\n    top: 80vh;\n    width: 100%;\n    height: 20vh;\n    text-align: center;\n    padding-top: 2em;\n    color: #ddd; }\n    /* line 37, stdin */\n    .view-background .view-action .name[_v-4b1da3a1] {\n      font-size: 1.5em; }\n    /* line 40, stdin */\n    .view-background .view-action .download[_v-4b1da3a1] {\n      font-size: 0.5em;\n      cursor: pointer; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	mounted: function mounted() {
		var _this = this;

		window.Event.$on('openViewImg', function (data) {
			_this.url = data.url;
			_this.name = data.name;
			_this.show = true;
		});
	},
	data: function data() {
		return {
			show: false,
			url: '',
			name: ''
		};
	},

	watch: {},
	methods: {
		close: function close() {
			this.show = false;
		},
		download: function download() {
			var link = document.createElement('a');
			link.href = this.url;
			link.download = "";
			link.click();
		}
	}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"view-background\" v-show=\"show\" @click=\"close\" _v-4b1da3a1=\"\">\n\t<div class=\"view-close\" @click=\"close\" _v-4b1da3a1=\"\">\n\t\t<i class=\"fa fa-close fa-2x\" _v-4b1da3a1=\"\"></i>\n\t</div>\n\t<div class=\"view-img-contain\" _v-4b1da3a1=\"\">\n\t\t<img class=\"view-img\" :src=\"url\" _v-4b1da3a1=\"\">\n\t</div>\n\t<div class=\"view-action\" @click.prevent.stop=\"\" _v-4b1da3a1=\"\">\n\t\t<p class=\"name\" _v-4b1da3a1=\"\">\n\t\t\t{{ name }}\n\t\t</p>\n\t\t<p class=\"download\" @click.prevent.stop=\"download\" _v-4b1da3a1=\"\">\n\t\t\t<i class=\"fa fa-download \" _v-4b1da3a1=\"\"></i>下載\n\t\t</p>\n\t</div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.view-background[_v-4b1da3a1] {\n  position: fixed;\n  height: 100%;\n  width: 100%;\n  top: 0;\n  left: 0;\n  z-index: 2000;\n  overflow-y: scroll;\n  background-color: rgba(0, 0, 0, 0.7); }\n  /* line 11, stdin */\n  .view-background .view-img[_v-4b1da3a1] {\n    max-width: 90vw; }\n  /* line 15, stdin */\n  .view-background .view-img-contain[_v-4b1da3a1] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: center;\n        justify-content: center;\n    -ms-flex-align: center;\n        align-items: center;\n    margin-bottom: 20vh; }\n  /* line 21, stdin */\n  .view-background .view-close[_v-4b1da3a1] {\n    text-align: right;\n    color: #ddd;\n    padding-right: 15px;\n    padding-top: 10px;\n    cursor: pointer; }\n  /* line 28, stdin */\n  .view-background .view-action[_v-4b1da3a1] {\n    background-color: rgba(0, 0, 0, 0.3);\n    position: fixed;\n    top: 80vh;\n    width: 100%;\n    height: 20vh;\n    text-align: center;\n    padding-top: 2em;\n    color: #ddd; }\n    /* line 37, stdin */\n    .view-background .view-action .name[_v-4b1da3a1] {\n      font-size: 1.5em; }\n    /* line 40, stdin */\n    .view-background .view-action .download[_v-4b1da3a1] {\n      font-size: 0.5em;\n      cursor: pointer; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-4b1da3a1", module.exports)
  } else {
    hotAPI.update("_v-4b1da3a1", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1522:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	props: ['memberContractId'],
	data: function data() {
		return {
			toggled: false
		};
	},

	computed: {
		toggleClass: function toggleClass() {
			return this.toggled ? { 'fa-minus': true } : { 'fa-plus': true };
		}
	},
	methods: {
		toggleRecords: function toggleRecords() {
			this.toggled = !this.toggled;
			this.$store.dispatch('webadmin/crm/fetchMemberContractRecords', {
				memberContractId: this.memberContractId,
				toggled: this.toggled
			});
		}
	}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<a @click=\"toggleRecords\"><i class=\"fa\" :class=\"toggleClass\"></i> {{ i18n.t('general.details') }}</a>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-93734bf0", module.exports)
  } else {
    hotAPI.update("_v-93734bf0", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],1523:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _vuex = require('vuex');

exports.default = {
	props: ['memberContractId', 'showUsers'],
	computed: (0, _vuex.mapState)({
		records: function records(state) {
			var r = state.webadmin.crm.memberContractRecords[this.memberContractId];
			if (r) return r.records || [];
			return [];
		},
		toggled: function toggled(state) {
			var t = state.webadmin.crm.memberContractRecords[this.memberContractId];
			if (t) return t.toggled || false;
			return false;
		}
	}),
	methods: {
		getId: function getId(data) {
			if (data.actionId != 0) {
				return '<' + data.actionId + '>';
			}
		}
	}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div>\n\t<table class=\"table\" v-if=\"toggled\">\n\t\t<thead>\n\t\t\t<tr>\n\t\t\t\t<td>{{ i18n.t('general.date') }}</td>\n\t\t\t\t<td>{{ i18n.t('general.reason') }}</td>\n\t\t\t\t<td>{{ i18n.t('general.update') }}</td>\n\t\t\t\t<td v-if=\"showUsers\">{{ i18n.t('pass.contract_used_member') }}</td>\n\t\t\t</tr>\n\t\t</thead>\n\t\t<tbody>\n\t\t\t<tr v-for=\"r in records\" :class=\"{'color-danger': r.isMinus}\">\n\t\t\t\t<td>{{ r.date }}</td>\n\t\t\t\t<td>{{ r.reason}}\n\t\t\t\t\t<span style=\"font-size: 11px;color:#ccc;font-style:italic;\">{{getId(r)}}</span>\n\t\t\t\t</td>\n\t\t\t\t<td>{{ r.change }}</td>\n\t\t\t\t<td v-if=\"showUsers\">{{ r.usedMemberName }}</td>\n\t\t\t</tr>\n\t\t</tbody>\n\t</table>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-39b8cd0c", module.exports)
  } else {
    hotAPI.update("_v-39b8cd0c", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vuex":803}],1524:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("fieldset[disabled] .multiselect{pointer-events:none}.multiselect__spinner{position:absolute;right:1px;top:1px;width:48px;height:35px;background:#fff;display:block}.multiselect__spinner:after,.multiselect__spinner:before{position:absolute;content:\"\";top:50%;left:50%;margin:-8px 0 0 -8px;width:16px;height:16px;border-radius:100%;border:2px solid transparent;border-top-color:#41b883;box-shadow:0 0 0 1px transparent}.multiselect__spinner:before{animation:spinning 2.4s cubic-bezier(.41,.26,.2,.62);animation-iteration-count:infinite}.multiselect__spinner:after{animation:spinning 2.4s cubic-bezier(.51,.09,.21,.8);animation-iteration-count:infinite}.multiselect__loading-enter-active,.multiselect__loading-leave-active{transition:opacity .4s ease-in-out;opacity:1}.multiselect__loading-enter,.multiselect__loading-leave-active{opacity:0}.multiselect,.multiselect__input,.multiselect__single{font-family:inherit;font-size:16px;-ms-touch-action:manipulation;touch-action:manipulation}.multiselect{box-sizing:content-box;display:block;position:relative;width:100%;min-height:40px;text-align:left;color:#35495e}.multiselect *{box-sizing:border-box}.multiselect:focus{outline:none}.multiselect--disabled{background:#ededed;pointer-events:none;opacity:.6}.multiselect--active{z-index:50}.multiselect--active:not(.multiselect--above) .multiselect__current,.multiselect--active:not(.multiselect--above) .multiselect__input,.multiselect--active:not(.multiselect--above) .multiselect__tags{border-bottom-left-radius:0;border-bottom-right-radius:0}.multiselect--active .multiselect__select{transform:rotate(180deg)}.multiselect--above.multiselect--active .multiselect__current,.multiselect--above.multiselect--active .multiselect__input,.multiselect--above.multiselect--active .multiselect__tags{border-top-left-radius:0;border-top-right-radius:0}.multiselect__input,.multiselect__single{position:relative;display:inline-block;min-height:20px;line-height:20px;border:none;border-radius:5px;background:#fff;padding:0 0 0 5px;width:100%;transition:border .1s ease;box-sizing:border-box;margin-bottom:8px;vertical-align:top}.multiselect__input:-ms-input-placeholder{color:#35495e}.multiselect__input::placeholder{color:#35495e}.multiselect__tag~.multiselect__input,.multiselect__tag~.multiselect__single{width:auto}.multiselect__input:hover,.multiselect__single:hover{border-color:#cfcfcf}.multiselect__input:focus,.multiselect__single:focus{border-color:#a8a8a8;outline:none}.multiselect__single{padding-left:5px;margin-bottom:8px}.multiselect__tags-wrap{display:inline}.multiselect__tags{min-height:40px;display:block;padding:8px 40px 0 8px;border-radius:5px;border:1px solid #e8e8e8;background:#fff;font-size:14px}.multiselect__tag{position:relative;display:inline-block;padding:4px 26px 4px 10px;border-radius:5px;margin-right:10px;color:#fff;line-height:1;background:#41b883;margin-bottom:5px;white-space:nowrap;overflow:hidden;max-width:100%;text-overflow:ellipsis}.multiselect__tag-icon{cursor:pointer;margin-left:7px;position:absolute;right:0;top:0;bottom:0;font-weight:700;font-style:normal;width:22px;text-align:center;line-height:22px;transition:all .2s ease;border-radius:5px}.multiselect__tag-icon:after{content:\"\\D7\";color:#266d4d;font-size:14px}.multiselect__tag-icon:focus,.multiselect__tag-icon:hover{background:#369a6e}.multiselect__tag-icon:focus:after,.multiselect__tag-icon:hover:after{color:#fff}.multiselect__current{min-height:40px;overflow:hidden;padding:8px 30px 0 12px;white-space:nowrap;border-radius:5px;border:1px solid #e8e8e8}.multiselect__current,.multiselect__select{line-height:16px;box-sizing:border-box;display:block;margin:0;text-decoration:none;cursor:pointer}.multiselect__select{position:absolute;width:40px;height:38px;right:1px;top:1px;padding:4px 8px;text-align:center;transition:transform .2s ease}.multiselect__select:before{position:relative;right:0;top:65%;color:#999;margin-top:4px;border-color:#999 transparent transparent;border-style:solid;border-width:5px 5px 0;content:\"\"}.multiselect__placeholder{color:#adadad;display:inline-block;margin-bottom:10px;padding-top:2px}.multiselect--active .multiselect__placeholder{display:none}.multiselect__content-wrapper{position:absolute;display:block;background:#fff;width:100%;max-height:240px;overflow:auto;border:1px solid #e8e8e8;border-top:none;border-bottom-left-radius:5px;border-bottom-right-radius:5px;z-index:50;-webkit-overflow-scrolling:touch}.multiselect__content{list-style:none;display:inline-block;padding:0;margin:0;min-width:100%;vertical-align:top}.multiselect--above .multiselect__content-wrapper{bottom:100%;border-bottom-left-radius:0;border-bottom-right-radius:0;border-top-left-radius:5px;border-top-right-radius:5px;border-bottom:none;border-top:1px solid #e8e8e8}.multiselect__content::webkit-scrollbar{display:none}.multiselect__element{display:block}.multiselect__option{display:block;padding:12px;min-height:40px;line-height:16px;text-decoration:none;text-transform:none;vertical-align:middle;position:relative;cursor:pointer;white-space:nowrap}.multiselect__option:after{top:0;right:0;position:absolute;line-height:40px;padding-right:12px;padding-left:20px;font-size:13px}.multiselect__option--highlight{background:#41b883;outline:none;color:#fff}.multiselect__option--highlight:after{content:attr(data-select);background:#41b883;color:#fff}.multiselect__option--selected{background:#f3f3f3;color:#35495e;font-weight:700}.multiselect__option--selected:after{content:attr(data-selected);color:silver}.multiselect__option--selected.multiselect__option--highlight{background:#ff6a6a;color:#fff}.multiselect__option--selected.multiselect__option--highlight:after{background:#ff6a6a;content:attr(data-deselect);color:#fff}.multiselect--disabled .multiselect__current,.multiselect--disabled .multiselect__select{background:#ededed;color:#a6a6a6}.multiselect__option--disabled{background:#ededed!important;color:#a6a6a6!important;cursor:text;pointer-events:none}.multiselect__option--group{background:#ededed;color:#35495e}.multiselect__option--group.multiselect__option--highlight{background:#35495e;color:#fff}.multiselect__option--group.multiselect__option--highlight:after{background:#35495e}.multiselect__option--disabled.multiselect__option--highlight{background:#dedede}.multiselect__option--group-selected.multiselect__option--highlight{background:#ff6a6a;color:#fff}.multiselect__option--group-selected.multiselect__option--highlight:after{background:#ff6a6a;content:attr(data-deselect);color:#fff}.multiselect-enter-active,.multiselect-leave-active{transition:all .15s ease}.multiselect-enter,.multiselect-leave-active{opacity:0}.multiselect__strong{margin-bottom:8px;line-height:20px;display:inline-block;vertical-align:top}[dir=rtl] .multiselect{text-align:right}[dir=rtl] .multiselect__select{right:auto;left:1px}[dir=rtl] .multiselect__tags{padding:8px 8px 0 40px}[dir=rtl] .multiselect__content{text-align:right}[dir=rtl] .multiselect__option:after{right:auto;left:0}[dir=rtl] .multiselect__clear{right:auto;left:12px}[dir=rtl] .multiselect__spinner{right:auto;left:1px}@keyframes spinning{0%{transform:rotate(0)}to{transform:rotate(2turn)}}\n/* line 3, stdin */\n.block-div.control-box.open .body-div {\n  overflow: visible; }\n\n/* line 6, stdin */\n.block-div.control-box.open .multiselect__input, .block-div.control-box.open .multiselect__single {\n  position: inherit; }\n\n/* line 11, stdin */\n.multiselect__option--highlight, .multiselect__option--highlight:after {\n  background-color: #5293F6; }\n\n/* line 15, stdin */\n.multiselect__tags {\n  border-color: #aaaaaa !important; }\n\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vueMultiselect = require('vue-multiselect');

var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { Multiselect: _vueMultiselect2.default },
  props: {
    memberChange: {},
    studioId: {
      default: 0
    },
    placeholder: {
      default: '請選擇'
    },
    keep: {
      default: false
    },
    clearWhenSelect: {
      default: false
    },
    allowClear: {
      default: false
    },
    loading: {
      default: false
    },
    maxHeight: {
      default: 300
    },
    disabled: {
      default: false
    },
    defaultSelectedMember: {
      default: function _default() {
        return {}; //有預設的話必傳 id:xxx, name:xxx
      }
    },
    clearAction: {
      type: Function,
      default: function _default() {
        if (this.memberChange) {
          this.memberChange(null);
        }
        this.selectMember = {};
        this.$store.commit('filters/SETSTATUS', { 'key': 'selected_search_member_id', value: null });
        this.$store.commit('filters/SETSTATUS', { 'key': 'selected_search_member_name', value: null });
        this.$store.commit('filters/SETSTATUS', { 'key': 'selected_search_member_phone', value: null });
        this.$store.commit('filters/SETSTATUS', { 'key': 'selected_search_member_email', value: null });
        this.$store.commit('filters/SETSTATUS', { 'key': 'selected_search_member_photo', value: null });
      }
    },
    selectedAction: {
      type: Function,
      default: function _default(e) {
        if (this.memberChange) {
          this.memberChange(e);
        }
        this.$store.commit('filters/SETSTATUS', { 'key': 'selected_search_member_id', value: e.id });
        this.$store.commit('filters/SETSTATUS', { 'key': 'selected_search_member_name', value: e.name });
        this.$store.commit('filters/SETSTATUS', { 'key': 'selected_search_member_phone', value: e.phone });
        this.$store.commit('filters/SETSTATUS', { 'key': 'selected_search_member_email', value: e.email });
        this.$store.commit('filters/SETSTATUS', { 'key': 'selected_search_member_photo', value: e.picture_path });
      }
    },
    unselectedAction: {
      type: Function,
      default: function _default(e) {
        if (!this.allowClear) {
          return;
        }
        this.$store.commit('filters/SETSTATUS', { 'key': 'selected_search_member_id', value: null });
        this.$store.commit('filters/SETSTATUS', { 'key': 'selected_search_member_name', value: null });
        this.$store.commit('filters/SETSTATUS', { 'key': 'selected_search_member_phone', value: null });
        this.$store.commit('filters/SETSTATUS', { 'key': 'selected_search_member_email', value: null });
        this.$store.commit('filters/SETSTATUS', { 'key': 'selected_search_member_photo', value: null });
      }
    }
  },
  created: function created() {
    this.initDefaultMember();
  },
  data: function data() {
    return {
      memberList: [],
      selectMember: {},
      ajaxing: false,
      isOpen: false,
      searchDelay: ''
    };
  },

  methods: {
    initDefaultMember: function initDefaultMember() {
      if (this.defaultSelectedMember && this.defaultSelectedMember.hasOwnProperty('id') && this.defaultSelectedMember.hasOwnProperty('name')) {
        this.selectMember = {
          id: this.defaultSelectedMember.id,
          name: this.defaultSelectedMember.name
        };
      } else if (this.selected_search_member_id && this.selected_search_member_name && this.selected_search_member_phone && this.selected_search_member_email && this.selected_search_member_photo) {
        var member = {
          id: this.selected_search_member_id,
          name: this.selected_search_member_name,
          phone: this.selected_search_member_phone,
          email: this.selected_search_member_email,
          picture_path: this.selected_search_member_photo
        };
        this.memberSelectAction(member);
      }
    },
    clear: function clear() {
      this.clearAction();
    },
    openMultiselect: function openMultiselect(id) {
      this.isOpen = true;
    },
    closeMultiselect: function closeMultiselect(value, id) {
      this.isOpen = false;
    },
    getMember: function getMember(query, initMode) {
      var vm = this;
      this.searchDelay = setTimeout(function () {
        vm.getSearchMember(query, initMode);
      }, 1000);
    },
    memberSelectAction: function memberSelectAction(selectedOption, id) {
      this.selectMember = selectedOption;
      this.selectedAction(selectedOption);
    },
    memberUnselectAction: function memberUnselectAction(selectedOption, id) {
      this.selectMember = {};
      this.unselectedAction(selectedOption);
    },
    getSearchMember: function getSearchMember(query, initMode) {
      var _this = this;

      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var formData;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                formData = new FormData();

                _this.ajaxing = true;
                formData.append('per_page', 30);
                formData.append('studio_id', _this.studioId);
                if (!initMode) {
                  formData.append('q', query);
                };

                _context.next = 8;
                return _this.$http.post('/webadmin/member_studio/get_customers', formData, {
                  headers: { 'Content-Type': 'multipart/form-data' }
                }).then(function (response) {
                  _this.memberList = response.data.customers;
                  _this.ajaxing = false;
                }, function (error) {
                  _this.ajaxing = false;
                });

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapState)('filters', ['selected_search_member_id', 'selected_search_member_name', 'selected_search_member_phone', 'selected_search_member_email', 'selected_search_member_photo'])),
  watch: {
    isOpen: function isOpen(newVal) {
      if (newVal) {
        this.getSearchMember('', true);
      }
    },
    searchDelay: function searchDelay(newVal, oldVal) {
      clearTimeout(oldVal);
    }
  },
  destroyed: function destroyed() {
    this.clear();
  }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-1dde6c5a=\"\">\n  <div class=\"search-member st-flex st-items-center\" _v-1dde6c5a=\"\">\n    <multiselect v-if=\"!allowClear || (allowClear &amp;&amp; (!selectMember.hasOwnProperty('id') || !selectMember.id))\" :options=\"memberList\" label=\"name\" track-by=\"id\" :multiple=\"false\" :searchable=\"true\" :hide-selected=\"true\" :clear-on-select=\"true\" :close-on-select=\"true\" :options-limit=\"300\" :placeholder=\"placeholder\" select-label=\"\" @select=\"memberSelectAction\" @remove=\"memberUnselectAction\" @search-change=\"getMember\" @open=\"openMultiselect\" @close=\"closeMultiselect\" :disabled=\"disabled\" :loading=\"ajaxing\" :internal-search=\"false\" :max-height=\"maxHeight\" _v-1dde6c5a=\"\">\n      <template slot=\"option\" slot-scope=\"{ option }\">\n        <div class=\"option__desc\" _v-1dde6c5a=\"\">\n            <div class=\"option__title\" _v-1dde6c5a=\"\">\n              <b class=\"fa fa-user\" style=\"margin-right:5px\" _v-1dde6c5a=\"\"></b>\n              {{option.name}} \n            </div>\n            <div class=\"option__title\" _v-1dde6c5a=\"\">{{option.phone}} </div>\n            <div class=\"option__small\" _v-1dde6c5a=\"\">{{option.email}} </div>\n        </div>\n      </template>\n      <span slot=\"noResult\" _v-1dde6c5a=\"\">沒有找到相符的項目</span>\n    </multiselect>\n      <div v-if=\"allowClear &amp;&amp; selectMember.hasOwnProperty('id') &amp;&amp; selectMember.id > 0\" class=\"st-flex st-items-center\" _v-1dde6c5a=\"\">\n          <div class=\"st-pr-4 st-text-16\" _v-1dde6c5a=\"\">{{selectMember.name}}</div>\n          <st-button neutral=\"\" class=\"st-whitespace-nowrap\" :disabled=\"disabled\" small=\"\" @click=\"clear\" _v-1dde6c5a=\"\">重選</st-button>\n      </div>\n  </div>\n</div>\n\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["fieldset[disabled] .multiselect{pointer-events:none}.multiselect__spinner{position:absolute;right:1px;top:1px;width:48px;height:35px;background:#fff;display:block}.multiselect__spinner:after,.multiselect__spinner:before{position:absolute;content:\"\";top:50%;left:50%;margin:-8px 0 0 -8px;width:16px;height:16px;border-radius:100%;border:2px solid transparent;border-top-color:#41b883;box-shadow:0 0 0 1px transparent}.multiselect__spinner:before{animation:spinning 2.4s cubic-bezier(.41,.26,.2,.62);animation-iteration-count:infinite}.multiselect__spinner:after{animation:spinning 2.4s cubic-bezier(.51,.09,.21,.8);animation-iteration-count:infinite}.multiselect__loading-enter-active,.multiselect__loading-leave-active{transition:opacity .4s ease-in-out;opacity:1}.multiselect__loading-enter,.multiselect__loading-leave-active{opacity:0}.multiselect,.multiselect__input,.multiselect__single{font-family:inherit;font-size:16px;-ms-touch-action:manipulation;touch-action:manipulation}.multiselect{box-sizing:content-box;display:block;position:relative;width:100%;min-height:40px;text-align:left;color:#35495e}.multiselect *{box-sizing:border-box}.multiselect:focus{outline:none}.multiselect--disabled{background:#ededed;pointer-events:none;opacity:.6}.multiselect--active{z-index:50}.multiselect--active:not(.multiselect--above) .multiselect__current,.multiselect--active:not(.multiselect--above) .multiselect__input,.multiselect--active:not(.multiselect--above) .multiselect__tags{border-bottom-left-radius:0;border-bottom-right-radius:0}.multiselect--active .multiselect__select{transform:rotate(180deg)}.multiselect--above.multiselect--active .multiselect__current,.multiselect--above.multiselect--active .multiselect__input,.multiselect--above.multiselect--active .multiselect__tags{border-top-left-radius:0;border-top-right-radius:0}.multiselect__input,.multiselect__single{position:relative;display:inline-block;min-height:20px;line-height:20px;border:none;border-radius:5px;background:#fff;padding:0 0 0 5px;width:100%;transition:border .1s ease;box-sizing:border-box;margin-bottom:8px;vertical-align:top}.multiselect__input:-ms-input-placeholder{color:#35495e}.multiselect__input::placeholder{color:#35495e}.multiselect__tag~.multiselect__input,.multiselect__tag~.multiselect__single{width:auto}.multiselect__input:hover,.multiselect__single:hover{border-color:#cfcfcf}.multiselect__input:focus,.multiselect__single:focus{border-color:#a8a8a8;outline:none}.multiselect__single{padding-left:5px;margin-bottom:8px}.multiselect__tags-wrap{display:inline}.multiselect__tags{min-height:40px;display:block;padding:8px 40px 0 8px;border-radius:5px;border:1px solid #e8e8e8;background:#fff;font-size:14px}.multiselect__tag{position:relative;display:inline-block;padding:4px 26px 4px 10px;border-radius:5px;margin-right:10px;color:#fff;line-height:1;background:#41b883;margin-bottom:5px;white-space:nowrap;overflow:hidden;max-width:100%;text-overflow:ellipsis}.multiselect__tag-icon{cursor:pointer;margin-left:7px;position:absolute;right:0;top:0;bottom:0;font-weight:700;font-style:normal;width:22px;text-align:center;line-height:22px;transition:all .2s ease;border-radius:5px}.multiselect__tag-icon:after{content:\"\\D7\";color:#266d4d;font-size:14px}.multiselect__tag-icon:focus,.multiselect__tag-icon:hover{background:#369a6e}.multiselect__tag-icon:focus:after,.multiselect__tag-icon:hover:after{color:#fff}.multiselect__current{min-height:40px;overflow:hidden;padding:8px 30px 0 12px;white-space:nowrap;border-radius:5px;border:1px solid #e8e8e8}.multiselect__current,.multiselect__select{line-height:16px;box-sizing:border-box;display:block;margin:0;text-decoration:none;cursor:pointer}.multiselect__select{position:absolute;width:40px;height:38px;right:1px;top:1px;padding:4px 8px;text-align:center;transition:transform .2s ease}.multiselect__select:before{position:relative;right:0;top:65%;color:#999;margin-top:4px;border-color:#999 transparent transparent;border-style:solid;border-width:5px 5px 0;content:\"\"}.multiselect__placeholder{color:#adadad;display:inline-block;margin-bottom:10px;padding-top:2px}.multiselect--active .multiselect__placeholder{display:none}.multiselect__content-wrapper{position:absolute;display:block;background:#fff;width:100%;max-height:240px;overflow:auto;border:1px solid #e8e8e8;border-top:none;border-bottom-left-radius:5px;border-bottom-right-radius:5px;z-index:50;-webkit-overflow-scrolling:touch}.multiselect__content{list-style:none;display:inline-block;padding:0;margin:0;min-width:100%;vertical-align:top}.multiselect--above .multiselect__content-wrapper{bottom:100%;border-bottom-left-radius:0;border-bottom-right-radius:0;border-top-left-radius:5px;border-top-right-radius:5px;border-bottom:none;border-top:1px solid #e8e8e8}.multiselect__content::webkit-scrollbar{display:none}.multiselect__element{display:block}.multiselect__option{display:block;padding:12px;min-height:40px;line-height:16px;text-decoration:none;text-transform:none;vertical-align:middle;position:relative;cursor:pointer;white-space:nowrap}.multiselect__option:after{top:0;right:0;position:absolute;line-height:40px;padding-right:12px;padding-left:20px;font-size:13px}.multiselect__option--highlight{background:#41b883;outline:none;color:#fff}.multiselect__option--highlight:after{content:attr(data-select);background:#41b883;color:#fff}.multiselect__option--selected{background:#f3f3f3;color:#35495e;font-weight:700}.multiselect__option--selected:after{content:attr(data-selected);color:silver}.multiselect__option--selected.multiselect__option--highlight{background:#ff6a6a;color:#fff}.multiselect__option--selected.multiselect__option--highlight:after{background:#ff6a6a;content:attr(data-deselect);color:#fff}.multiselect--disabled .multiselect__current,.multiselect--disabled .multiselect__select{background:#ededed;color:#a6a6a6}.multiselect__option--disabled{background:#ededed!important;color:#a6a6a6!important;cursor:text;pointer-events:none}.multiselect__option--group{background:#ededed;color:#35495e}.multiselect__option--group.multiselect__option--highlight{background:#35495e;color:#fff}.multiselect__option--group.multiselect__option--highlight:after{background:#35495e}.multiselect__option--disabled.multiselect__option--highlight{background:#dedede}.multiselect__option--group-selected.multiselect__option--highlight{background:#ff6a6a;color:#fff}.multiselect__option--group-selected.multiselect__option--highlight:after{background:#ff6a6a;content:attr(data-deselect);color:#fff}.multiselect-enter-active,.multiselect-leave-active{transition:all .15s ease}.multiselect-enter,.multiselect-leave-active{opacity:0}.multiselect__strong{margin-bottom:8px;line-height:20px;display:inline-block;vertical-align:top}[dir=rtl] .multiselect{text-align:right}[dir=rtl] .multiselect__select{right:auto;left:1px}[dir=rtl] .multiselect__tags{padding:8px 8px 0 40px}[dir=rtl] .multiselect__content{text-align:right}[dir=rtl] .multiselect__option:after{right:auto;left:0}[dir=rtl] .multiselect__clear{right:auto;left:12px}[dir=rtl] .multiselect__spinner{right:auto;left:1px}@keyframes spinning{0%{transform:rotate(0)}to{transform:rotate(2turn)}}\n/* line 3, stdin */\n.block-div.control-box.open .body-div {\n  overflow: visible; }\n\n/* line 6, stdin */\n.block-div.control-box.open .multiselect__input, .block-div.control-box.open .multiselect__single {\n  position: inherit; }\n\n/* line 11, stdin */\n.multiselect__option--highlight, .multiselect__option--highlight:after {\n  background-color: #5293F6; }\n\n/* line 15, stdin */\n.multiselect__tags {\n  border-color: #aaaaaa !important; }\n\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-1dde6c5a", module.exports)
  } else {
    hotAPI.update("_v-1dde6c5a", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/extends":66,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vue-multiselect":787,"vueify/lib/insert-css":799,"vuex":803}],1525:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("fieldset[disabled] .multiselect{pointer-events:none}.multiselect__spinner{position:absolute;right:1px;top:1px;width:48px;height:35px;background:#fff;display:block}.multiselect__spinner:after,.multiselect__spinner:before{position:absolute;content:\"\";top:50%;left:50%;margin:-8px 0 0 -8px;width:16px;height:16px;border-radius:100%;border:2px solid transparent;border-top-color:#41b883;box-shadow:0 0 0 1px transparent}.multiselect__spinner:before{animation:spinning 2.4s cubic-bezier(.41,.26,.2,.62);animation-iteration-count:infinite}.multiselect__spinner:after{animation:spinning 2.4s cubic-bezier(.51,.09,.21,.8);animation-iteration-count:infinite}.multiselect__loading-enter-active,.multiselect__loading-leave-active{transition:opacity .4s ease-in-out;opacity:1}.multiselect__loading-enter,.multiselect__loading-leave-active{opacity:0}.multiselect,.multiselect__input,.multiselect__single{font-family:inherit;font-size:16px;-ms-touch-action:manipulation;touch-action:manipulation}.multiselect{box-sizing:content-box;display:block;position:relative;width:100%;min-height:40px;text-align:left;color:#35495e}.multiselect *{box-sizing:border-box}.multiselect:focus{outline:none}.multiselect--disabled{background:#ededed;pointer-events:none;opacity:.6}.multiselect--active{z-index:50}.multiselect--active:not(.multiselect--above) .multiselect__current,.multiselect--active:not(.multiselect--above) .multiselect__input,.multiselect--active:not(.multiselect--above) .multiselect__tags{border-bottom-left-radius:0;border-bottom-right-radius:0}.multiselect--active .multiselect__select{transform:rotate(180deg)}.multiselect--above.multiselect--active .multiselect__current,.multiselect--above.multiselect--active .multiselect__input,.multiselect--above.multiselect--active .multiselect__tags{border-top-left-radius:0;border-top-right-radius:0}.multiselect__input,.multiselect__single{position:relative;display:inline-block;min-height:20px;line-height:20px;border:none;border-radius:5px;background:#fff;padding:0 0 0 5px;width:100%;transition:border .1s ease;box-sizing:border-box;margin-bottom:8px;vertical-align:top}.multiselect__input:-ms-input-placeholder{color:#35495e}.multiselect__input::placeholder{color:#35495e}.multiselect__tag~.multiselect__input,.multiselect__tag~.multiselect__single{width:auto}.multiselect__input:hover,.multiselect__single:hover{border-color:#cfcfcf}.multiselect__input:focus,.multiselect__single:focus{border-color:#a8a8a8;outline:none}.multiselect__single{padding-left:5px;margin-bottom:8px}.multiselect__tags-wrap{display:inline}.multiselect__tags{min-height:40px;display:block;padding:8px 40px 0 8px;border-radius:5px;border:1px solid #e8e8e8;background:#fff;font-size:14px}.multiselect__tag{position:relative;display:inline-block;padding:4px 26px 4px 10px;border-radius:5px;margin-right:10px;color:#fff;line-height:1;background:#41b883;margin-bottom:5px;white-space:nowrap;overflow:hidden;max-width:100%;text-overflow:ellipsis}.multiselect__tag-icon{cursor:pointer;margin-left:7px;position:absolute;right:0;top:0;bottom:0;font-weight:700;font-style:normal;width:22px;text-align:center;line-height:22px;transition:all .2s ease;border-radius:5px}.multiselect__tag-icon:after{content:\"\\D7\";color:#266d4d;font-size:14px}.multiselect__tag-icon:focus,.multiselect__tag-icon:hover{background:#369a6e}.multiselect__tag-icon:focus:after,.multiselect__tag-icon:hover:after{color:#fff}.multiselect__current{min-height:40px;overflow:hidden;padding:8px 30px 0 12px;white-space:nowrap;border-radius:5px;border:1px solid #e8e8e8}.multiselect__current,.multiselect__select{line-height:16px;box-sizing:border-box;display:block;margin:0;text-decoration:none;cursor:pointer}.multiselect__select{position:absolute;width:40px;height:38px;right:1px;top:1px;padding:4px 8px;text-align:center;transition:transform .2s ease}.multiselect__select:before{position:relative;right:0;top:65%;color:#999;margin-top:4px;border-color:#999 transparent transparent;border-style:solid;border-width:5px 5px 0;content:\"\"}.multiselect__placeholder{color:#adadad;display:inline-block;margin-bottom:10px;padding-top:2px}.multiselect--active .multiselect__placeholder{display:none}.multiselect__content-wrapper{position:absolute;display:block;background:#fff;width:100%;max-height:240px;overflow:auto;border:1px solid #e8e8e8;border-top:none;border-bottom-left-radius:5px;border-bottom-right-radius:5px;z-index:50;-webkit-overflow-scrolling:touch}.multiselect__content{list-style:none;display:inline-block;padding:0;margin:0;min-width:100%;vertical-align:top}.multiselect--above .multiselect__content-wrapper{bottom:100%;border-bottom-left-radius:0;border-bottom-right-radius:0;border-top-left-radius:5px;border-top-right-radius:5px;border-bottom:none;border-top:1px solid #e8e8e8}.multiselect__content::webkit-scrollbar{display:none}.multiselect__element{display:block}.multiselect__option{display:block;padding:12px;min-height:40px;line-height:16px;text-decoration:none;text-transform:none;vertical-align:middle;position:relative;cursor:pointer;white-space:nowrap}.multiselect__option:after{top:0;right:0;position:absolute;line-height:40px;padding-right:12px;padding-left:20px;font-size:13px}.multiselect__option--highlight{background:#41b883;outline:none;color:#fff}.multiselect__option--highlight:after{content:attr(data-select);background:#41b883;color:#fff}.multiselect__option--selected{background:#f3f3f3;color:#35495e;font-weight:700}.multiselect__option--selected:after{content:attr(data-selected);color:silver}.multiselect__option--selected.multiselect__option--highlight{background:#ff6a6a;color:#fff}.multiselect__option--selected.multiselect__option--highlight:after{background:#ff6a6a;content:attr(data-deselect);color:#fff}.multiselect--disabled .multiselect__current,.multiselect--disabled .multiselect__select{background:#ededed;color:#a6a6a6}.multiselect__option--disabled{background:#ededed!important;color:#a6a6a6!important;cursor:text;pointer-events:none}.multiselect__option--group{background:#ededed;color:#35495e}.multiselect__option--group.multiselect__option--highlight{background:#35495e;color:#fff}.multiselect__option--group.multiselect__option--highlight:after{background:#35495e}.multiselect__option--disabled.multiselect__option--highlight{background:#dedede}.multiselect__option--group-selected.multiselect__option--highlight{background:#ff6a6a;color:#fff}.multiselect__option--group-selected.multiselect__option--highlight:after{background:#ff6a6a;content:attr(data-deselect);color:#fff}.multiselect-enter-active,.multiselect-leave-active{transition:all .15s ease}.multiselect-enter,.multiselect-leave-active{opacity:0}.multiselect__strong{margin-bottom:8px;line-height:20px;display:inline-block;vertical-align:top}[dir=rtl] .multiselect{text-align:right}[dir=rtl] .multiselect__select{right:auto;left:1px}[dir=rtl] .multiselect__tags{padding:8px 8px 0 40px}[dir=rtl] .multiselect__content{text-align:right}[dir=rtl] .multiselect__option:after{right:auto;left:0}[dir=rtl] .multiselect__clear{right:auto;left:12px}[dir=rtl] .multiselect__spinner{right:auto;left:1px}@keyframes spinning{0%{transform:rotate(0)}to{transform:rotate(2turn)}}\n/* line 3, stdin */\n.block-div.control-box.open .body-div {\n  overflow: visible; }\n\n/* line 6, stdin */\n.block-div.control-box.open .multiselect__input, .block-div.control-box.open .multiselect__single {\n  position: inherit; }\n\n/* line 11, stdin */\n.multiselect__option--highlight, .multiselect__option--highlight:after {\n  background-color: #5293F6; }\n\n/* line 14, stdin */\n.multiselect__tags {\n  /*margin-bottom: 10px;*/ }\n\n/* line 4, stdin */\n.multiselect__tags .custom__tag[_v-3e8ca14c] {\n  background-color: #ddd;\n  padding: 2px 5px 2px 5px;\n  border: #aaa 1px solid;\n  border-radius: 5px;\n  margin: 0px 5px 5px 0px;\n  display: inline-block; }\n\n/* line 14, stdin */\n.multiselect__tags .fa.fa-times[_v-3e8ca14c] {\n  color: #aaa;\n  cursor: pointer; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vueMultiselect = require('vue-multiselect');

var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      'memberList': [],
      'selectMember': {},
      'ajaxing': false
    };
  },

  components: { Multiselect: _vueMultiselect2.default },
  props: {
    memberChange: {},
    studioId: {
      default: 0
    },
    withoutMemberId: null,
    keep: {
      default: false
    },
    clearWhenSelect: {
      default: false
    },
    allowClear: {
      default: false
    },
    placeholder: {
      default: '選擇客戶'
    },
    disabled: {
      default: false
    },
    loading: {
      default: false
    },
    templateSelection: {
      type: Function,
      default: function _default(state) {
        if (!state.name) {
          return state.text;
        }
        var email = state.email ? state.email : '';
        var phone = state.phone ? state.phone : '';
        var $state = $('<span>' + state.name + ' ' + email + ' ' + phone + '</span>');
        return $state;
      }
    },
    selectedAction: {
      type: Function,
      default: function _default(member) {
        if (member.id) {
          this.memberChange && this.memberChange(member.id);
        }
      }
    },
    unselectedAction: {
      type: Function,
      default: function _default(e) {
        if (!this.allowClear) {
          return;
        }
      }
    }
  },
  methods: {
    getMember: function getMember(query, initMode) {
      var _this = this;

      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var queryString;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(query === '')) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                _this.ajaxing = true;
                queryString = '?q=' + query + '&studio_id=' + _this.studioId + '&without_member_id=' + _this.withoutMemberId;


                if (initMode) {
                  queryString = queryString + '&init=1';
                }

                _context.next = 7;
                return _this.$http.get('/adminapi/member_studio/' + queryString).then(function (response) {
                  _this.memberList = response.data.customers;
                  _this.ajaxing = false;
                }, function (error) {
                  _this.ajaxing = false;
                });

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    memberChangeAction: function memberChangeAction() {
      var _this2 = this;

      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.memberChange;

              case 2:
                _context2.t0 = _context2.sent;

                if (!_context2.t0) {
                  _context2.next = 5;
                  break;
                }

                _this2.memberChange(_this2.selectMember);

              case 5:

                if (_this2.clearWhenSelect) {
                  _this2.selectMember = {};
                }

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  },
  watch: {
    studioId: function studioId() {
      this.getMember('09', true);
    }
  }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n  <div class=\"search-member\" _v-3e8ca14c=\"\">\n    <div v-show=\"selectMember.id == null || keep\" _v-3e8ca14c=\"\">\n    <multiselect v-model=\"selectMember\" :options=\"memberList\" label=\"seach_name\" track-by=\"id\" :multiple=\"false\" :searchable=\"true\" :hide-selected=\"true\" :clear-on-select=\"true\" :close-on-select=\"true\" :options-limit=\"300\" select-label=\"選擇已連結客戶\" selected-label=\"已選取\" deselect-label=\"移除\" @select=\"memberChangeAction\" @search-change=\"getMember\" :disabled=\"disabled\" :loading=\"ajaxing\" :internal-search=\"true\" _v-3e8ca14c=\"\">\n      <template slot=\"singleLabel\" slot-scope=\"props\">\n        <span class=\"option__desc\" _v-3e8ca14c=\"\"><span class=\"option__title\" _v-3e8ca14c=\"\">{{ props.option.name }}</span></span>\n      </template>\n      <template slot=\"option\" slot-scope=\"props\">\n        <div class=\"option__desc\" _v-3e8ca14c=\"\">\n            <div class=\"option__title\" _v-3e8ca14c=\"\">\n              <b class=\"fa fa-user\" style=\"margin-right:5px\" _v-3e8ca14c=\"\"></b>\n              {{props.option.name}} \n            </div>\n            <div class=\"option__title\" _v-3e8ca14c=\"\">{{props.option.phone}} </div>\n            <div class=\"option__small\" _v-3e8ca14c=\"\">{{props.option.email}} </div>\n        </div>\n      </template>\n    </multiselect>\n    <div v-show=\"selectMember.id\" _v-3e8ca14c=\"\">\n      <slot _v-3e8ca14c=\"\"></slot>\n    </div>\n  </div>\n</div>"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["fieldset[disabled] .multiselect{pointer-events:none}.multiselect__spinner{position:absolute;right:1px;top:1px;width:48px;height:35px;background:#fff;display:block}.multiselect__spinner:after,.multiselect__spinner:before{position:absolute;content:\"\";top:50%;left:50%;margin:-8px 0 0 -8px;width:16px;height:16px;border-radius:100%;border:2px solid transparent;border-top-color:#41b883;box-shadow:0 0 0 1px transparent}.multiselect__spinner:before{animation:spinning 2.4s cubic-bezier(.41,.26,.2,.62);animation-iteration-count:infinite}.multiselect__spinner:after{animation:spinning 2.4s cubic-bezier(.51,.09,.21,.8);animation-iteration-count:infinite}.multiselect__loading-enter-active,.multiselect__loading-leave-active{transition:opacity .4s ease-in-out;opacity:1}.multiselect__loading-enter,.multiselect__loading-leave-active{opacity:0}.multiselect,.multiselect__input,.multiselect__single{font-family:inherit;font-size:16px;-ms-touch-action:manipulation;touch-action:manipulation}.multiselect{box-sizing:content-box;display:block;position:relative;width:100%;min-height:40px;text-align:left;color:#35495e}.multiselect *{box-sizing:border-box}.multiselect:focus{outline:none}.multiselect--disabled{background:#ededed;pointer-events:none;opacity:.6}.multiselect--active{z-index:50}.multiselect--active:not(.multiselect--above) .multiselect__current,.multiselect--active:not(.multiselect--above) .multiselect__input,.multiselect--active:not(.multiselect--above) .multiselect__tags{border-bottom-left-radius:0;border-bottom-right-radius:0}.multiselect--active .multiselect__select{transform:rotate(180deg)}.multiselect--above.multiselect--active .multiselect__current,.multiselect--above.multiselect--active .multiselect__input,.multiselect--above.multiselect--active .multiselect__tags{border-top-left-radius:0;border-top-right-radius:0}.multiselect__input,.multiselect__single{position:relative;display:inline-block;min-height:20px;line-height:20px;border:none;border-radius:5px;background:#fff;padding:0 0 0 5px;width:100%;transition:border .1s ease;box-sizing:border-box;margin-bottom:8px;vertical-align:top}.multiselect__input:-ms-input-placeholder{color:#35495e}.multiselect__input::placeholder{color:#35495e}.multiselect__tag~.multiselect__input,.multiselect__tag~.multiselect__single{width:auto}.multiselect__input:hover,.multiselect__single:hover{border-color:#cfcfcf}.multiselect__input:focus,.multiselect__single:focus{border-color:#a8a8a8;outline:none}.multiselect__single{padding-left:5px;margin-bottom:8px}.multiselect__tags-wrap{display:inline}.multiselect__tags{min-height:40px;display:block;padding:8px 40px 0 8px;border-radius:5px;border:1px solid #e8e8e8;background:#fff;font-size:14px}.multiselect__tag{position:relative;display:inline-block;padding:4px 26px 4px 10px;border-radius:5px;margin-right:10px;color:#fff;line-height:1;background:#41b883;margin-bottom:5px;white-space:nowrap;overflow:hidden;max-width:100%;text-overflow:ellipsis}.multiselect__tag-icon{cursor:pointer;margin-left:7px;position:absolute;right:0;top:0;bottom:0;font-weight:700;font-style:normal;width:22px;text-align:center;line-height:22px;transition:all .2s ease;border-radius:5px}.multiselect__tag-icon:after{content:\"\\D7\";color:#266d4d;font-size:14px}.multiselect__tag-icon:focus,.multiselect__tag-icon:hover{background:#369a6e}.multiselect__tag-icon:focus:after,.multiselect__tag-icon:hover:after{color:#fff}.multiselect__current{min-height:40px;overflow:hidden;padding:8px 30px 0 12px;white-space:nowrap;border-radius:5px;border:1px solid #e8e8e8}.multiselect__current,.multiselect__select{line-height:16px;box-sizing:border-box;display:block;margin:0;text-decoration:none;cursor:pointer}.multiselect__select{position:absolute;width:40px;height:38px;right:1px;top:1px;padding:4px 8px;text-align:center;transition:transform .2s ease}.multiselect__select:before{position:relative;right:0;top:65%;color:#999;margin-top:4px;border-color:#999 transparent transparent;border-style:solid;border-width:5px 5px 0;content:\"\"}.multiselect__placeholder{color:#adadad;display:inline-block;margin-bottom:10px;padding-top:2px}.multiselect--active .multiselect__placeholder{display:none}.multiselect__content-wrapper{position:absolute;display:block;background:#fff;width:100%;max-height:240px;overflow:auto;border:1px solid #e8e8e8;border-top:none;border-bottom-left-radius:5px;border-bottom-right-radius:5px;z-index:50;-webkit-overflow-scrolling:touch}.multiselect__content{list-style:none;display:inline-block;padding:0;margin:0;min-width:100%;vertical-align:top}.multiselect--above .multiselect__content-wrapper{bottom:100%;border-bottom-left-radius:0;border-bottom-right-radius:0;border-top-left-radius:5px;border-top-right-radius:5px;border-bottom:none;border-top:1px solid #e8e8e8}.multiselect__content::webkit-scrollbar{display:none}.multiselect__element{display:block}.multiselect__option{display:block;padding:12px;min-height:40px;line-height:16px;text-decoration:none;text-transform:none;vertical-align:middle;position:relative;cursor:pointer;white-space:nowrap}.multiselect__option:after{top:0;right:0;position:absolute;line-height:40px;padding-right:12px;padding-left:20px;font-size:13px}.multiselect__option--highlight{background:#41b883;outline:none;color:#fff}.multiselect__option--highlight:after{content:attr(data-select);background:#41b883;color:#fff}.multiselect__option--selected{background:#f3f3f3;color:#35495e;font-weight:700}.multiselect__option--selected:after{content:attr(data-selected);color:silver}.multiselect__option--selected.multiselect__option--highlight{background:#ff6a6a;color:#fff}.multiselect__option--selected.multiselect__option--highlight:after{background:#ff6a6a;content:attr(data-deselect);color:#fff}.multiselect--disabled .multiselect__current,.multiselect--disabled .multiselect__select{background:#ededed;color:#a6a6a6}.multiselect__option--disabled{background:#ededed!important;color:#a6a6a6!important;cursor:text;pointer-events:none}.multiselect__option--group{background:#ededed;color:#35495e}.multiselect__option--group.multiselect__option--highlight{background:#35495e;color:#fff}.multiselect__option--group.multiselect__option--highlight:after{background:#35495e}.multiselect__option--disabled.multiselect__option--highlight{background:#dedede}.multiselect__option--group-selected.multiselect__option--highlight{background:#ff6a6a;color:#fff}.multiselect__option--group-selected.multiselect__option--highlight:after{background:#ff6a6a;content:attr(data-deselect);color:#fff}.multiselect-enter-active,.multiselect-leave-active{transition:all .15s ease}.multiselect-enter,.multiselect-leave-active{opacity:0}.multiselect__strong{margin-bottom:8px;line-height:20px;display:inline-block;vertical-align:top}[dir=rtl] .multiselect{text-align:right}[dir=rtl] .multiselect__select{right:auto;left:1px}[dir=rtl] .multiselect__tags{padding:8px 8px 0 40px}[dir=rtl] .multiselect__content{text-align:right}[dir=rtl] .multiselect__option:after{right:auto;left:0}[dir=rtl] .multiselect__clear{right:auto;left:12px}[dir=rtl] .multiselect__spinner{right:auto;left:1px}@keyframes spinning{0%{transform:rotate(0)}to{transform:rotate(2turn)}}\n/* line 3, stdin */\n.block-div.control-box.open .body-div {\n  overflow: visible; }\n\n/* line 6, stdin */\n.block-div.control-box.open .multiselect__input, .block-div.control-box.open .multiselect__single {\n  position: inherit; }\n\n/* line 11, stdin */\n.multiselect__option--highlight, .multiselect__option--highlight:after {\n  background-color: #5293F6; }\n\n/* line 14, stdin */\n.multiselect__tags {\n  /*margin-bottom: 10px;*/ }\n\n/* line 4, stdin */\n.multiselect__tags .custom__tag[_v-3e8ca14c] {\n  background-color: #ddd;\n  padding: 2px 5px 2px 5px;\n  border: #aaa 1px solid;\n  border-radius: 5px;\n  margin: 0px 5px 5px 0px;\n  display: inline-block; }\n\n/* line 14, stdin */\n.multiselect__tags .fa.fa-times[_v-3e8ca14c] {\n  color: #aaa;\n  cursor: pointer; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-3e8ca14c", module.exports)
  } else {
    hotAPI.update("_v-3e8ca14c", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785,"vue-multiselect":787,"vueify/lib/insert-css":799,"vuex":803}],1526:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.reselect[_v-97cd0050] {\n  color: #C7C4C3; }\n\n/* line 5, stdin */\n.less-space[_v-97cd0050] {\n  margin-left: 5px; }\n\n/* line 9, stdin */\n.select-info > div[_v-97cd0050] {\n  float: left;\n  margin-right: 20px; }\n\n/* line 13, stdin */\n.select-info[_v-97cd0050]:after {\n  content: '';\n  display: block;\n  clear: both;\n  visibility: hidden;\n  height: 0; }\n\n/* line 20, stdin */\n.member-photo > img[_v-97cd0050] {\n  height: 60px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    resetMemberAction: Function,
    enableChangeMember: {
      default: false
    }
  },
  computed: {
    member_id: function member_id() {
      return this.$store.state.filters.selected_search_member_id;
    },
    phone: function phone() {
      return this.$store.state.filters.selected_search_member_phone;
    },
    email: function email() {
      return this.$store.state.filters.selected_search_member_email;
    },
    name: function name() {
      return this.$store.state.filters.selected_search_member_name;
    },
    photo: function photo() {
      return this.$store.state.filters.selected_search_member_photo;
    },
    is_walkin: function is_walkin() {
      return this.$store.state.filters.selected_search_member_is_walkin;
    }
  },
  methods: {
    resetSelectMember: function resetSelectMember() {
      this.$store.commit('filters/SETSTATUS', { 'key': 'selected_search_member_id', value: null });
      this.$store.commit('filters/SETSTATUS', { 'key': 'selected_search_member_email', value: null });
      this.$store.commit('filters/SETSTATUS', { 'key': 'selected_search_member_name', value: null });
      this.$store.commit('filters/SETSTATUS', { 'key': 'selected_search_member_phone', value: null });
      this.$store.commit('filters/SETSTATUS', { 'key': 'selected_search_member_photo', value: null });
      this.$store.commit('filters/SETSTATUS', { 'key': 'selected_search_member_is_walkin', value: null });
      this.resetMemberAction && this.resetMemberAction(0);
    }
  }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"select-info\" _v-97cd0050=\"\">\n  <div class=\"member-photo\" _v-97cd0050=\"\">\n    <img :src=\"photo\" :alt=\"name\" _v-97cd0050=\"\">\n  </div>\n  <div _v-97cd0050=\"\">\n    <div class=\"name\" _v-97cd0050=\"\">{{name}}\n      <div @click=\"resetSelectMember\" class=\"reselect btn btn-default btn-xs\" v-if=\"enableChangeMember\" _v-97cd0050=\"\">\n        <i class=\"fa fa-times-circle\" aria-hidden=\"true\" _v-97cd0050=\"\"></i>\n        <span class=\"less-space\" _v-97cd0050=\"\">變更客戶</span>\n      </div>\n    </div>\n    <div class=\"phone\" v-if=\"is_walkin != 1\" _v-97cd0050=\"\">{{phone}}</div>\n    <div class=\"email\" v-if=\"is_walkin != 1\" _v-97cd0050=\"\">{{email}}</div>\n  </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.reselect[_v-97cd0050] {\n  color: #C7C4C3; }\n\n/* line 5, stdin */\n.less-space[_v-97cd0050] {\n  margin-left: 5px; }\n\n/* line 9, stdin */\n.select-info > div[_v-97cd0050] {\n  float: left;\n  margin-right: 20px; }\n\n/* line 13, stdin */\n.select-info[_v-97cd0050]:after {\n  content: '';\n  display: block;\n  clear: both;\n  visibility: hidden;\n  height: 0; }\n\n/* line 20, stdin */\n.member-photo > img[_v-97cd0050] {\n  height: 60px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-97cd0050", module.exports)
  } else {
    hotAPI.update("_v-97cd0050", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1527:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.search-member[_v-713c63a2] {\n  margin: 20px 0; }\n\n\n.select2-dropdown {\n  z-index: 1100;\n}\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vuex = require('vuex');

exports.default = {
  props: {
    memberChange: {},
    studioId: {
      default: 0
    },
    withoutMemberId: null,
    keep: {
      default: false
    },
    clearWhenSelect: {
      default: false
    },
    allowClear: {
      default: false
    },
    placeholder: {
      default: '選擇客戶'
    },
    disabled: {
      default: false
    },
    templateSelection: {
      type: Function,
      default: function _default(state) {
        if (!state.name) {
          return state.text;
        }
        var email = state.email ? state.email : '';
        var phone = state.phone ? state.phone : '';
        var $state = $('<span>' + state.name + ' ' + email + ' ' + phone + '</span>');
        return $state;
      }
    },
    selectedAction: {
      type: Function,
      default: function _default(e) {
        if (e.params.data.id) {
          this.memberChange && this.memberChange(e.params.data.id);
        }
        this.$store.commit('filters/SETSTATUS', { 'key': 'selected_search_member_id', value: e.params.data.id });
        this.$store.commit('filters/SETSTATUS', { 'key': 'selected_search_member_name', value: e.params.data.name });
        this.$store.commit('filters/SETSTATUS', { 'key': 'selected_search_member_phone', value: e.params.data.phone });
        this.$store.commit('filters/SETSTATUS', { 'key': 'selected_search_member_email', value: e.params.data.email });
        this.$store.commit('filters/SETSTATUS', { 'key': 'selected_search_member_photo', value: e.params.data.picture_path });
        if (this.clearWhenSelect) {
          $(this.$el).find('select').val(null).trigger('change');
        }
      }
    },
    unselectedAction: {
      type: Function,
      default: function _default(e) {
        if (!this.allowClear) {
          return;
        }
        this.$store.commit('filters/SETSTATUS', { 'key': 'selected_search_member_id', value: null });
        this.$store.commit('filters/SETSTATUS', { 'key': 'selected_search_member_name', value: null });
        this.$store.commit('filters/SETSTATUS', { 'key': 'selected_search_member_phone', value: null });
        this.$store.commit('filters/SETSTATUS', { 'key': 'selected_search_member_email', value: null });
        this.$store.commit('filters/SETSTATUS', { 'key': 'selected_search_member_photo', value: null });
        $(this.$el).find('select').val(null).trigger('change');
      }
    }
  },
  computed: {
    member_id: function member_id() {
      return this.$store.state.filters.selected_search_member_id;
    }
  },
  methods: {
    formatCustomer: function formatCustomer(data) {
      if (data.loading) {
        return data.text;
      }

      var phone = data.phone != null ? data.phone : '';
      var email = data.email != null ? data.email : '';
      return $('<div><b class="fa fa-user" style="margin-right:5px"></b>' + data.name + '</div><div>' + phone + '</div><div>' + email + '</div>');
    }
  },
  watch: {
    member_id: function member_id(val) {
      if (!val) {
        $(this.$el).find('select').val(null).trigger('change');
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    var cnt = 30;
    $(this.$el).find('select').select2({
      ajax: {
        url: '/webadmin/member_studio/get_customers',
        type: 'post',
        dataType: 'json',
        delay: 500,
        data: function data(params) {
          return {
            q: params.term,
            page: params.page,
            per_page: cnt,
            studio_id: _this.studioId,
            without_member_id: _this.withoutMemberId
          };
        },
        processResults: function processResults(data, params) {
          params.page = params.page || 1;
          return {
            results: data.customers,
            pagination: {
              more: params.page * cnt < data.customers.length
            }
          };
        },
        cache: true
      },
      templateResult: this.formatCustomer,
      language: 'zh-TW',
      placeholder: this.placeholder,
      allowClear: this.allowClear,
      templateSelection: this.templateSelection
    }).on('select2:select', function (e) {
      _this.selectedAction(e);
    }).on('select2:unselect', function (e) {
      _this.unselectedAction(e);
    });
  }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"search-member\" _v-713c63a2=\"\">\n  <div v-show=\"member_id == null || keep\" _v-713c63a2=\"\">\n    <select name=\"member_id\" :disabled=\"disabled\" _v-713c63a2=\"\">\n    </select>\n  </div>\n  <div v-show=\"member_id\" _v-713c63a2=\"\">\n    <slot _v-713c63a2=\"\"></slot>\n  </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.search-member[_v-713c63a2] {\n  margin: 20px 0; }\n\n\n.select2-dropdown {\n  z-index: 1100;\n}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-713c63a2", module.exports)
  } else {
    hotAPI.update("_v-713c63a2", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1528:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        alertObj: Array,
        modelTitle: {
            type: String,
            default: function _default(rawProps) {
                return "";
            }
        },
        id: {
            type: String,
            default: function _default(rawProps) {
                return "multi-alert-modal";
            }
        },
        disabledAllAction: {
            type: Boolean,
            default: function _default(rawProps) {
                return false;
            }
        }
    },
    computed: {}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal :id=\"id\" parallel-modal=\"\" no-border-radius=\"\">\n    <template slot=\"title\">{{ modelTitle }}</template>\n    <template slot=\"body\">\n        <slot name=\"body\">\n            <v-custom-alert-item :key=\"index\" v-for=\"(alert, index) in alertObj\" :icon=\"alert.icon\" :status-word=\"alert.statusWord\" :action-word=\"alert.actionWord\" :action-function=\"alert.actionFunction\" :detail-title=\"alert.detailTitle\" :detail-content=\"alert.detailContent\" :action-btn=\"alert.actionBtn\" :btn-disabled=\"(disabledAllAction || alert.disabled)\">\n            </v-custom-alert-item>\n        </slot>\n    </template>\n\n    <template slot=\"footer\">\n        <slot name=\"footer\"></slot>\n    </template>\n</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-31eef058", module.exports)
  } else {
    hotAPI.update("_v-31eef058", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],1529:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.form-group[_v-2b2d54ba] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: baseline;\n      align-items: baseline; }\n\n/* line 6, stdin */\n.field-title[_v-2b2d54ba] {\n  text-align: right; }\n\n@media screen and (max-width: 480px) {\n  /* line 11, stdin */\n  .form-group[_v-2b2d54ba] {\n    display: block; }\n  /* line 14, stdin */\n  .field-title[_v-2b2d54ba] {\n    text-align: left; } }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        'studio_id': {
            type: Number
        },
        'branch_id': {
            type: Number
        },
        'default_branch_id': {
            type: Number,
            default: 0,
            description: "預選場館"
        },
        'branchChangeCallBack': {
            type: Function
        },
        'studioChangeCallBack': {
            type: Function
        },
        'branchWithoutFilteredOption': {
            default: false,
            type: Boolean
        },
        'showBranch': {
            default: true,
            type: Boolean
        },
        'branchWithoutFilteredOptionWord': {
            default: '全部場館',
            type: String
        },
        'showStudioLabel': {
            default: true,
            type: Boolean
        },
        'showBranchLabel': {
            default: true,
            type: Boolean
        },
        'disableStudioOption': {
            default: false,
            type: Boolean
        },
        'disableBranchOption': {
            default: false,
            type: Boolean
        }
    },
    data: function data() {
        return {
            branchName: '',
            sync_selected_studio: '',
            sync_selected_branch: '',
            multiselect_branch_option: []
        };
    },
    mounted: function mounted() {},

    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
        studioOptions: function studioOptions(state) {
            return state.filters.studioOptions;
        },
        branchOptions: function branchOptions(state) {
            return state.filters.branchOptions;
        }
    }), (0, _vuex.mapState)('webadmin/configure', ['isSeventeen', 'isStudio', 'isBranch', 'branchId']), {
        selected_studio_id: {
            get: function get() {
                if (this.studio_id) {
                    this.$store.commit('filters/SETSTATUS', { 'key': 'selected_studio_id', value: this.studio_id });
                    this.studioChange(this.studio_id);
                }
                return this.$store.state.filters.selected_studio_id;
            },
            set: function set(studio_id) {
                this.$store.commit('filters/SETSTATUS', { 'key': 'selected_studio_id', value: studio_id });
            }
        },
        selected_branch_id: {
            get: function get() {
                if (!this.branchWithoutFilteredOption && !!this.branchOptions[0] && this.branchOptions[0]['id'] && !this.$store.state.filters.selected_branch_id) {
                    this.$store.commit('filters/SETSTATUS', { 'key': 'selected_branch_id', value: this.branchOptions[0]['id'] });
                }
                return this.$store.state.filters.selected_branch_id;
            },
            set: function set(branch_id) {
                this.$store.commit('filters/SETSTATUS', { 'key': 'selected_branch_id', value: branch_id });
            }
        }
    }),
    watch: {
        isSeventeen: function isSeventeen(v) {
            if (v) {
                this.initStudioId();
                this.initBranchId();
            }
        },
        studio_id: function studio_id(v) {
            var _this = this;

            this.sync_selected_studio = this.studioOptions.find(function (item) {
                return item.id == _this.studio_id;
            });
        },
        branch_id: function branch_id(v) {
            var _this2 = this;

            this.sync_selected_branch = this.branchOptions.find(function (item) {
                return item.id == _this2.branch_id;
            });
        },
        studioOptions: function studioOptions(v) {
            var _this3 = this;

            if (this.disableStudioOption && v) {
                this.sync_selected_studio = this.studioOptions.find(function (item) {
                    return item.id == _this3.studio_id;
                });
            };
        },
        branchOptions: function branchOptions(v) {
            var _this4 = this;

            if (this.disableBranchOption && v) {
                this.sync_selected_branch = v.find(function (item) {
                    return item.id == _this4.branch_id;
                });
            };
        }
    },
    methods: {
        getStudioList: function getStudioList() {
            this.$store.dispatch('filters/getStudioList');
        },
        getBranchList: function getBranchList() {
            this.$store.dispatch('filters/getBranchList');
        },
        studioChange: function studioChange(studio_id) {
            this.studioChangeCallBack && this.studioChangeCallBack(studio_id);
        },
        branchChange: function branchChange(branch_id) {
            this.branchChangeCallBack && this.branchChangeCallBack(branch_id);
        },
        initStudioId: function initStudioId() {
            this.getStudioList();
            this.selected_studio_id = this.studio_id;
        },
        initBranchId: function initBranchId() {
            if (this.isBranch) {
                this.getBranchName();
                return;
            };

            this.getBranchList();
            this.selected_branch_id = this.branch_id;
        },
        getBranchName: function getBranchName() {
            var _this5 = this;

            this.$http.get('/adminapi/init/get_branch/' + this.branchId).then(function (response) {
                _this5.branchName = response.data.name;
                _this5.sync_selected_branch = {
                    id: _this5.branch_id,
                    branch_name: response.data.name
                };
            }, function (error) {});
        },
        selectBranch: function selectBranch(selectOption) {
            this.studioChange(this.selected_studio_id);
            this.branchChange(selectOption.id);
        },
        selectStudio: function selectStudio(selectOption) {
            this.studioChange(selectOption.id);
            this.selected_studio_id = selectOption.id;
            this.selected_branch_id = '';
            this.sync_selected_branch = '';
            this.getBranchList();
        },
        removeStudio: function removeStudio(selectOption) {
            this.studioChange();
            this.branchChange();
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"select-outer-div\" _v-2b2d54ba=\"\">\n    <div v-if=\"isSeventeen\" class=\"row form-group\" _v-2b2d54ba=\"\">\n        <div v-if=\"showStudioLabel\" class=\"field-title col-sm-3\" _v-2b2d54ba=\"\">\n            <label class=\"control-label\" _v-2b2d54ba=\"\">品牌</label>\n        </div>\n        <div class=\"select-group col-sm-8\" _v-2b2d54ba=\"\">\n            <v-mutiselect :model.sync=\"sync_selected_studio\" :options=\"studioOptions\" :close-on-select=\"true\" :clear-on-select=\"false\" :preserve-search=\"true\" :searchable=\"true\" placeholder=\"請選擇品牌\" label=\"brand_name\" track-by=\"id\" :disabled=\"disableStudioOption\" :select-event-append=\"selectStudio\" :remove-event-append=\"removeStudio\" _v-2b2d54ba=\"\"></v-mutiselect>\n        </div>\n    </div>\n    <div class=\"row form-group\" _v-2b2d54ba=\"\">\n        <div class=\"field-title col-sm-3\" v-if=\"showBranchLabel\" _v-2b2d54ba=\"\">\n            <label class=\"control-label\" _v-2b2d54ba=\"\">場館</label>\n        </div>\n        <div class=\"select-group col-sm-8\" _v-2b2d54ba=\"\">\n            <v-mutiselect :model.sync=\"sync_selected_branch\" :options=\"branchOptions\" :close-on-select=\"true\" :clear-on-select=\"false\" :searchable=\"true\" :allow-empty=\"false\" placeholder=\"請選擇場館\" label=\"branch_name\" track-by=\"id\" :disabled=\"disableBranchOption\" :select-event-append=\"selectBranch\" _v-2b2d54ba=\"\"></v-mutiselect>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.form-group[_v-2b2d54ba] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: baseline;\n      align-items: baseline; }\n\n/* line 6, stdin */\n.field-title[_v-2b2d54ba] {\n  text-align: right; }\n\n@media screen and (max-width: 480px) {\n  /* line 11, stdin */\n  .form-group[_v-2b2d54ba] {\n    display: block; }\n  /* line 14, stdin */\n  .field-title[_v-2b2d54ba] {\n    text-align: left; } }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-2b2d54ba", module.exports)
  } else {
    hotAPI.update("_v-2b2d54ba", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1530:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n.form-group .select-group[_v-508bf872] {\n    width: 100%;\n    max-width: 400px;\n    min-width: 150px;\n    display: inline-block;\n}\n.hide[_v-508bf872] {\n    display: none;\n}\n@media (min-width: 768px) {\n    .select-outer-div[_v-508bf872] {\n        display: -ms-flexbox;\n        display: flex;\n    }\n    .form-group[_v-508bf872] {\n        -ms-flex: 1;\n            flex: 1;\n        padding-right: 10px;\n    }\n}\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        'studio_id': {
            type: Number
        },
        'branch_id': {
            type: Number
        },
        'default_studio_id': {
            type: Number,
            default: 0,
            description: "預選品牌"
        },
        'default_branch_id': {
            type: [Number, String],
            default: 0,
            description: "預選場館"
        },
        'default_branch_source': {
            type: String,
            default: 'filters/getBranchList',
            description: "預設場館的來源 ex.filters/getBranchPayment 只撈有開通線上刷卡的場館"
        },
        'branchChangeCallBack': {
            type: Function
        },
        'studioChangeCallBack': {
            type: Function
        },
        'branchWithoutFilteredOption': {
            default: false,
            type: Boolean
        },
        'showBranch': {
            default: true,
            type: Boolean
        },
        'branchWithoutFilteredOptionWord': {
            default: '全部場館',
            type: String
        },
        'showBranchLable': {
            default: false,
            type: Boolean
        },
        'dropDownContainerClass': {
            default: 'form-group',
            type: [Array, Object, String]
        }
    },
    data: function data() {
        return {
            branchName: '',
            sync_selected_studio: '',
            sync_selected_branch: '',
            multiselect_branch_option: []
        };
    },
    mounted: function mounted() {
        this.initStudioId();
        this.initBranchId();
    },

    computed: (0, _extends3.default)({
        shouldDisplay: function shouldDisplay() {
            return this.studio_id == 0 || this.branch_id == 0 || this.showBranchLable;
        }
    }, (0, _vuex.mapState)({
        studioOptions: function studioOptions(state) {
            return state.filters.studioOptions;
        },
        branchOptions: function branchOptions(state) {
            return state.filters.branchOptions;
        }
    }), {
        selected_studio_id: {
            get: function get() {
                return this.$store.state.filters.selected_studio_id;
            },
            set: function set(studio_id) {
                this.$store.commit('filters/SETSTATUS', { 'key': 'selected_studio_id', value: studio_id });
            }
        },
        selected_branch_id: {
            get: function get() {
                if (!this.branchWithoutFilteredOption && !!this.branchOptions[0] && this.branchOptions[0]['id'] && !this.$store.state.filters.selected_branch_id) {
                    this.$store.commit('filters/SETSTATUS', { 'key': 'selected_branch_id', value: this.branchOptions[0]['id'] });
                    this.branchChange(this.branchOptions[0]['id'], this.branchOptions[0]['branch_name']);
                }
                return this.$store.state.filters.selected_branch_id;
            },
            set: function set(branch_id) {
                this.$store.commit('filters/SETSTATUS', { 'key': 'selected_branch_id', value: branch_id });
            }
        }
    }),
    watch: {
        studio_id: function studio_id(v) {
            this.initStudioId();
        },
        branch_id: function branch_id(v) {
            this.initBranchId();
        },
        branchOptions: function branchOptions(v) {
            var data = JSON.parse((0, _stringify2.default)(v));
            if (this.branchWithoutFilteredOption) {
                data.unshift({
                    branch_name: this.branchWithoutFilteredOptionWord,
                    id: null
                });
            }
            this.multiselect_branch_option = data;
            this.initDefaultSelect();
        },
        studioOptions: function studioOptions(v) {
            var _this = this;

            if (this.default_studio_id) {
                this.sync_selected_studio = this.studioOptions.find(function (item) {
                    return item.id == _this.default_studio_id;
                });
            };
        },
        sync_selected_studio: function sync_selected_studio(v) {
            if (v) {
                this.selected_studio_id = v.id;
                this.studioChange(v.id);
                if (this.showBranch) {
                    this.getBranchList();
                };
            }
        },
        sync_selected_branch: function sync_selected_branch(v) {
            if (v) {
                this.selected_branch_id = v.id;
                if (v.id) {
                    this.branchChange(v.id, v.branch_name);
                } else {
                    this.branchChange(0);
                }
            }
        }
    },
    methods: {
        getStudioList: function getStudioList() {
            this.$store.dispatch('filters/getStudioList');
        },
        getBranchList: function getBranchList() {
            this.$store.dispatch(this.default_branch_source);
        },
        studioChange: function studioChange(studio_id) {
            this.studioChangeCallBack && this.studioChangeCallBack(studio_id);
        },
        branchChange: function branchChange(branch_id) {
            var branch_name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

            this.branchChangeCallBack && this.branchChangeCallBack(branch_id, branch_name);
        },
        initDefaultSelect: function initDefaultSelect() {
            var _this2 = this;

            if (this.default_branch_id) {
                this.sync_selected_branch = this.multiselect_branch_option.find(function (branch) {
                    return branch.id == _this2.default_branch_id;
                });
                return;
            };
            this.sync_selected_branch = this.multiselect_branch_option[0];
        },
        initStudioId: function initStudioId() {
            if (this.studio_id == 0) {
                this.getStudioList();
                return;
            };
            this.selected_studio_id = this.studio_id;
        },
        initBranchId: function initBranchId() {
            var _this3 = this;

            if (this.branch_id == 0) {
                this.getBranchList();
                return;
            }
            this.selected_branch_id = this.branch_id;

            if (this.branch_id != 0 && this.showBranchLable) {
                this.$http.get('/adminapi/init/get_branch/' + this.branch_id).then(function (response) {
                    _this3.branchName = response.data.name;
                }, function (error) {});
            }
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"select-outer-div\" v-if=\"shouldDisplay\" _v-508bf872=\"\">\n    <div v-if=\"studio_id == 0\" :class=\"dropDownContainerClass\" _v-508bf872=\"\">\n      <div class=\"select-group\" _v-508bf872=\"\">\n          <v-mutiselect :model.sync=\"sync_selected_studio\" :options=\"studioOptions\" :close-on-select=\"true\" :clear-on-select=\"false\" :preserve-search=\"true\" :searchable=\"true\" placeholder=\"請選擇品牌\" label=\"brand_name\" track-by=\"id\" _v-508bf872=\"\"></v-mutiselect>\n      </div>\n    </div>\n    <div v-show=\"showBranch\" v-if=\"branch_id == 0\" :class=\"dropDownContainerClass\" _v-508bf872=\"\">\n      <div class=\"select-group\" _v-508bf872=\"\">\n        <v-mutiselect :model.sync=\"sync_selected_branch\" :options=\"multiselect_branch_option\" :close-on-select=\"true\" :clear-on-select=\"false\" :searchable=\"true\" :allow-empty=\"false\" placeholder=\"請選擇場館\" label=\"branch_name\" track-by=\"id\" _v-508bf872=\"\"></v-mutiselect>\n      </div>\n    </div>\n    <div v-show=\"showBranch\" v-if=\"branch_id != 0\" :class=\"dropDownContainerClass\" _v-508bf872=\"\">\n        <label _v-508bf872=\"\">{{ branchName }}</label>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n.form-group .select-group[_v-508bf872] {\n    width: 100%;\n    max-width: 400px;\n    min-width: 150px;\n    display: inline-block;\n}\n.hide[_v-508bf872] {\n    display: none;\n}\n@media (min-width: 768px) {\n    .select-outer-div[_v-508bf872] {\n        display: -ms-flexbox;\n        display: flex;\n    }\n    .form-group[_v-508bf872] {\n        -ms-flex: 1;\n            flex: 1;\n        padding-right: 10px;\n    }\n}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-508bf872", module.exports)
  } else {
    hotAPI.update("_v-508bf872", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/json/stringify":48,"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1531:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("fieldset[disabled] .multiselect{pointer-events:none}.multiselect__spinner{position:absolute;right:1px;top:1px;width:48px;height:35px;background:#fff;display:block}.multiselect__spinner:after,.multiselect__spinner:before{position:absolute;content:\"\";top:50%;left:50%;margin:-8px 0 0 -8px;width:16px;height:16px;border-radius:100%;border:2px solid transparent;border-top-color:#41b883;box-shadow:0 0 0 1px transparent}.multiselect__spinner:before{animation:spinning 2.4s cubic-bezier(.41,.26,.2,.62);animation-iteration-count:infinite}.multiselect__spinner:after{animation:spinning 2.4s cubic-bezier(.51,.09,.21,.8);animation-iteration-count:infinite}.multiselect__loading-enter-active,.multiselect__loading-leave-active{transition:opacity .4s ease-in-out;opacity:1}.multiselect__loading-enter,.multiselect__loading-leave-active{opacity:0}.multiselect,.multiselect__input,.multiselect__single{font-family:inherit;font-size:16px;-ms-touch-action:manipulation;touch-action:manipulation}.multiselect{box-sizing:content-box;display:block;position:relative;width:100%;min-height:40px;text-align:left;color:#35495e}.multiselect *{box-sizing:border-box}.multiselect:focus{outline:none}.multiselect--disabled{background:#ededed;pointer-events:none;opacity:.6}.multiselect--active{z-index:50}.multiselect--active:not(.multiselect--above) .multiselect__current,.multiselect--active:not(.multiselect--above) .multiselect__input,.multiselect--active:not(.multiselect--above) .multiselect__tags{border-bottom-left-radius:0;border-bottom-right-radius:0}.multiselect--active .multiselect__select{transform:rotate(180deg)}.multiselect--above.multiselect--active .multiselect__current,.multiselect--above.multiselect--active .multiselect__input,.multiselect--above.multiselect--active .multiselect__tags{border-top-left-radius:0;border-top-right-radius:0}.multiselect__input,.multiselect__single{position:relative;display:inline-block;min-height:20px;line-height:20px;border:none;border-radius:5px;background:#fff;padding:0 0 0 5px;width:100%;transition:border .1s ease;box-sizing:border-box;margin-bottom:8px;vertical-align:top}.multiselect__input:-ms-input-placeholder{color:#35495e}.multiselect__input::placeholder{color:#35495e}.multiselect__tag~.multiselect__input,.multiselect__tag~.multiselect__single{width:auto}.multiselect__input:hover,.multiselect__single:hover{border-color:#cfcfcf}.multiselect__input:focus,.multiselect__single:focus{border-color:#a8a8a8;outline:none}.multiselect__single{padding-left:5px;margin-bottom:8px}.multiselect__tags-wrap{display:inline}.multiselect__tags{min-height:40px;display:block;padding:8px 40px 0 8px;border-radius:5px;border:1px solid #e8e8e8;background:#fff;font-size:14px}.multiselect__tag{position:relative;display:inline-block;padding:4px 26px 4px 10px;border-radius:5px;margin-right:10px;color:#fff;line-height:1;background:#41b883;margin-bottom:5px;white-space:nowrap;overflow:hidden;max-width:100%;text-overflow:ellipsis}.multiselect__tag-icon{cursor:pointer;margin-left:7px;position:absolute;right:0;top:0;bottom:0;font-weight:700;font-style:normal;width:22px;text-align:center;line-height:22px;transition:all .2s ease;border-radius:5px}.multiselect__tag-icon:after{content:\"\\D7\";color:#266d4d;font-size:14px}.multiselect__tag-icon:focus,.multiselect__tag-icon:hover{background:#369a6e}.multiselect__tag-icon:focus:after,.multiselect__tag-icon:hover:after{color:#fff}.multiselect__current{min-height:40px;overflow:hidden;padding:8px 30px 0 12px;white-space:nowrap;border-radius:5px;border:1px solid #e8e8e8}.multiselect__current,.multiselect__select{line-height:16px;box-sizing:border-box;display:block;margin:0;text-decoration:none;cursor:pointer}.multiselect__select{position:absolute;width:40px;height:38px;right:1px;top:1px;padding:4px 8px;text-align:center;transition:transform .2s ease}.multiselect__select:before{position:relative;right:0;top:65%;color:#999;margin-top:4px;border-color:#999 transparent transparent;border-style:solid;border-width:5px 5px 0;content:\"\"}.multiselect__placeholder{color:#adadad;display:inline-block;margin-bottom:10px;padding-top:2px}.multiselect--active .multiselect__placeholder{display:none}.multiselect__content-wrapper{position:absolute;display:block;background:#fff;width:100%;max-height:240px;overflow:auto;border:1px solid #e8e8e8;border-top:none;border-bottom-left-radius:5px;border-bottom-right-radius:5px;z-index:50;-webkit-overflow-scrolling:touch}.multiselect__content{list-style:none;display:inline-block;padding:0;margin:0;min-width:100%;vertical-align:top}.multiselect--above .multiselect__content-wrapper{bottom:100%;border-bottom-left-radius:0;border-bottom-right-radius:0;border-top-left-radius:5px;border-top-right-radius:5px;border-bottom:none;border-top:1px solid #e8e8e8}.multiselect__content::webkit-scrollbar{display:none}.multiselect__element{display:block}.multiselect__option{display:block;padding:12px;min-height:40px;line-height:16px;text-decoration:none;text-transform:none;vertical-align:middle;position:relative;cursor:pointer;white-space:nowrap}.multiselect__option:after{top:0;right:0;position:absolute;line-height:40px;padding-right:12px;padding-left:20px;font-size:13px}.multiselect__option--highlight{background:#41b883;outline:none;color:#fff}.multiselect__option--highlight:after{content:attr(data-select);background:#41b883;color:#fff}.multiselect__option--selected{background:#f3f3f3;color:#35495e;font-weight:700}.multiselect__option--selected:after{content:attr(data-selected);color:silver}.multiselect__option--selected.multiselect__option--highlight{background:#ff6a6a;color:#fff}.multiselect__option--selected.multiselect__option--highlight:after{background:#ff6a6a;content:attr(data-deselect);color:#fff}.multiselect--disabled .multiselect__current,.multiselect--disabled .multiselect__select{background:#ededed;color:#a6a6a6}.multiselect__option--disabled{background:#ededed!important;color:#a6a6a6!important;cursor:text;pointer-events:none}.multiselect__option--group{background:#ededed;color:#35495e}.multiselect__option--group.multiselect__option--highlight{background:#35495e;color:#fff}.multiselect__option--group.multiselect__option--highlight:after{background:#35495e}.multiselect__option--disabled.multiselect__option--highlight{background:#dedede}.multiselect__option--group-selected.multiselect__option--highlight{background:#ff6a6a;color:#fff}.multiselect__option--group-selected.multiselect__option--highlight:after{background:#ff6a6a;content:attr(data-deselect);color:#fff}.multiselect-enter-active,.multiselect-leave-active{transition:all .15s ease}.multiselect-enter,.multiselect-leave-active{opacity:0}.multiselect__strong{margin-bottom:8px;line-height:20px;display:inline-block;vertical-align:top}[dir=rtl] .multiselect{text-align:right}[dir=rtl] .multiselect__select{right:auto;left:1px}[dir=rtl] .multiselect__tags{padding:8px 8px 0 40px}[dir=rtl] .multiselect__content{text-align:right}[dir=rtl] .multiselect__option:after{right:auto;left:0}[dir=rtl] .multiselect__clear{right:auto;left:12px}[dir=rtl] .multiselect__spinner{right:auto;left:1px}@keyframes spinning{0%{transform:rotate(0)}to{transform:rotate(2turn)}}\n/* line 3, stdin */\n.block-div.control-box.open .body-div {\n  overflow: visible; }\n\n/* line 6, stdin */\n.block-div.control-box.open .multiselect__input, .block-div.control-box.open .multiselect__single {\n  position: inherit; }\n\n/* line 11, stdin */\n.multiselect__option--highlight, .multiselect__option--highlight:after {\n  background-color: #5293F6; }\n\n/* line 14, stdin */\n.multiselect__tags {\n  /*margin-bottom: 10px;*/ }\n\n/* line 4, stdin */\n.multiselect__tags .custom__tag[_v-02cef7e5] {\n  background-color: #ddd;\n  padding: 2px 5px 2px 5px;\n  border: #aaa 1px solid;\n  border-radius: 5px;\n  margin: 0px 5px 5px 0px;\n  display: inline-block; }\n\n/* line 14, stdin */\n.multiselect__tags .fa.fa-times[_v-02cef7e5] {\n  color: #aaa;\n  cursor: pointer; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vueMultiselect = require('vue-multiselect');

var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['model', 'options', 'preserveSearch', 'placeholder', 'label', 'trackBy', 'maxHeight', 'multiple', 'searchable', 'taggable', 'hideSelected', 'tagName', 'tagPlaceholder', 'closeOnSelect', 'removeEventAppend', 'selectEventAppend', 'inputEventAppend', 'openEventAppend', 'closeEventAppend', 'disabled', 'openDirection', 'resetAfter', 'allowEmpty', 'isLoading'],
    components: { Multiselect: _vueMultiselect2.default },
    computed: {
        vmodel: {
            get: function get() {
                return this.model;
            },
            set: function set(newValue) {
                this.$emit('update:model', newValue);
            }
        }
    },
    methods: {
        removeEvent: function removeEvent(removedOption, id) {
            this.removeEventAppend && this.removeEventAppend(removedOption, id);
        },
        selectEvent: function selectEvent(selectedOption, id) {
            this.selectEventAppend && this.selectEventAppend(selectedOption, id);
        },
        inputEvent: function inputEvent(value, id) {
            this.inputEventAppend && this.inputEventAppend(value, id);
            this.hidePlaceHolder();
        },
        closeEvent: function closeEvent(value, id) {
            this.closeEventAppend && this.closeEventAppend(value, id);
        },
        openEvent: function openEvent(value, id) {
            this.openEventAppend && this.openEventAppend(value, id);
        },
        hidePlaceHolder: function hidePlaceHolder() {
            if (this.multiple) {
                if (this.vmodel.length > 0) {
                    $(this.$el).find('.multiselect__single').hide();
                } else {
                    $(this.$el).find('.multiselect__single').show();
                }
            }
        },
        setMobilePosition: function setMobilePosition() {
            if ($17.isMobile()) {
                //console.log($('.multiselect__content-wrapper').css('position'));
                $('.multiselect__content-wrapper').css('position', 'absolute');
            }
        }
    },
    watch: {
        vmodel: function vmodel() {
            this.hidePlaceHolder();
        }
    },
    mounted: function mounted() {
        this.$nextTick(function () {
            this.setMobilePosition();
        });
    },
    updated: function updated() {
        this.$nextTick(function () {
            this.setMobilePosition();
        });
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-02cef7e5=\"\">\n  <multiselect v-model=\"vmodel\" :options=\"options\" :preserve-search=\"preserveSearch\" :placeholder=\"placeholder\" :label=\"label\" :track-by=\"trackBy\" :multiple=\"multiple\" :searchable=\"searchable\" :max-height=\"maxHeight\" :taggable=\"taggable\" :hide-selected=\"hideSelected\" select-label=\"請選擇\" selected-label=\"已選取\" deselect-label=\"移除\" :tag-placeholder=\"tagPlaceholder\" :close-on-select=\"closeOnSelect\" @select=\"selectEvent\" @remove=\"removeEvent\" @input=\"inputEvent\" @open=\"openEvent\" @close=\"closeEvent\" :disabled=\"disabled\" :open-direction=\"openDirection\" :reset-after=\"resetAfter\" :allow-empty=\"allowEmpty\" :loading=\"isLoading\" _v-02cef7e5=\"\">\n  <template slot=\"tag\" scope=\"props\">\n      <span class=\"custom__tag\" _v-02cef7e5=\"\">\n          <span class=\"custom__remove\" @click=\"props.remove(props.option)\" _v-02cef7e5=\"\">\n              <i class=\"fa fa-times\" aria-hidden=\"true\" _v-02cef7e5=\"\"></i>\n          </span>\n          <span _v-02cef7e5=\"\">{{ props.option[tagName] }}</span>\n      </span>\n  </template>\n  <span slot=\"noResult\" _v-02cef7e5=\"\">沒有找到相符的項目</span>\n  </multiselect>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["fieldset[disabled] .multiselect{pointer-events:none}.multiselect__spinner{position:absolute;right:1px;top:1px;width:48px;height:35px;background:#fff;display:block}.multiselect__spinner:after,.multiselect__spinner:before{position:absolute;content:\"\";top:50%;left:50%;margin:-8px 0 0 -8px;width:16px;height:16px;border-radius:100%;border:2px solid transparent;border-top-color:#41b883;box-shadow:0 0 0 1px transparent}.multiselect__spinner:before{animation:spinning 2.4s cubic-bezier(.41,.26,.2,.62);animation-iteration-count:infinite}.multiselect__spinner:after{animation:spinning 2.4s cubic-bezier(.51,.09,.21,.8);animation-iteration-count:infinite}.multiselect__loading-enter-active,.multiselect__loading-leave-active{transition:opacity .4s ease-in-out;opacity:1}.multiselect__loading-enter,.multiselect__loading-leave-active{opacity:0}.multiselect,.multiselect__input,.multiselect__single{font-family:inherit;font-size:16px;-ms-touch-action:manipulation;touch-action:manipulation}.multiselect{box-sizing:content-box;display:block;position:relative;width:100%;min-height:40px;text-align:left;color:#35495e}.multiselect *{box-sizing:border-box}.multiselect:focus{outline:none}.multiselect--disabled{background:#ededed;pointer-events:none;opacity:.6}.multiselect--active{z-index:50}.multiselect--active:not(.multiselect--above) .multiselect__current,.multiselect--active:not(.multiselect--above) .multiselect__input,.multiselect--active:not(.multiselect--above) .multiselect__tags{border-bottom-left-radius:0;border-bottom-right-radius:0}.multiselect--active .multiselect__select{transform:rotate(180deg)}.multiselect--above.multiselect--active .multiselect__current,.multiselect--above.multiselect--active .multiselect__input,.multiselect--above.multiselect--active .multiselect__tags{border-top-left-radius:0;border-top-right-radius:0}.multiselect__input,.multiselect__single{position:relative;display:inline-block;min-height:20px;line-height:20px;border:none;border-radius:5px;background:#fff;padding:0 0 0 5px;width:100%;transition:border .1s ease;box-sizing:border-box;margin-bottom:8px;vertical-align:top}.multiselect__input:-ms-input-placeholder{color:#35495e}.multiselect__input::placeholder{color:#35495e}.multiselect__tag~.multiselect__input,.multiselect__tag~.multiselect__single{width:auto}.multiselect__input:hover,.multiselect__single:hover{border-color:#cfcfcf}.multiselect__input:focus,.multiselect__single:focus{border-color:#a8a8a8;outline:none}.multiselect__single{padding-left:5px;margin-bottom:8px}.multiselect__tags-wrap{display:inline}.multiselect__tags{min-height:40px;display:block;padding:8px 40px 0 8px;border-radius:5px;border:1px solid #e8e8e8;background:#fff;font-size:14px}.multiselect__tag{position:relative;display:inline-block;padding:4px 26px 4px 10px;border-radius:5px;margin-right:10px;color:#fff;line-height:1;background:#41b883;margin-bottom:5px;white-space:nowrap;overflow:hidden;max-width:100%;text-overflow:ellipsis}.multiselect__tag-icon{cursor:pointer;margin-left:7px;position:absolute;right:0;top:0;bottom:0;font-weight:700;font-style:normal;width:22px;text-align:center;line-height:22px;transition:all .2s ease;border-radius:5px}.multiselect__tag-icon:after{content:\"\\D7\";color:#266d4d;font-size:14px}.multiselect__tag-icon:focus,.multiselect__tag-icon:hover{background:#369a6e}.multiselect__tag-icon:focus:after,.multiselect__tag-icon:hover:after{color:#fff}.multiselect__current{min-height:40px;overflow:hidden;padding:8px 30px 0 12px;white-space:nowrap;border-radius:5px;border:1px solid #e8e8e8}.multiselect__current,.multiselect__select{line-height:16px;box-sizing:border-box;display:block;margin:0;text-decoration:none;cursor:pointer}.multiselect__select{position:absolute;width:40px;height:38px;right:1px;top:1px;padding:4px 8px;text-align:center;transition:transform .2s ease}.multiselect__select:before{position:relative;right:0;top:65%;color:#999;margin-top:4px;border-color:#999 transparent transparent;border-style:solid;border-width:5px 5px 0;content:\"\"}.multiselect__placeholder{color:#adadad;display:inline-block;margin-bottom:10px;padding-top:2px}.multiselect--active .multiselect__placeholder{display:none}.multiselect__content-wrapper{position:absolute;display:block;background:#fff;width:100%;max-height:240px;overflow:auto;border:1px solid #e8e8e8;border-top:none;border-bottom-left-radius:5px;border-bottom-right-radius:5px;z-index:50;-webkit-overflow-scrolling:touch}.multiselect__content{list-style:none;display:inline-block;padding:0;margin:0;min-width:100%;vertical-align:top}.multiselect--above .multiselect__content-wrapper{bottom:100%;border-bottom-left-radius:0;border-bottom-right-radius:0;border-top-left-radius:5px;border-top-right-radius:5px;border-bottom:none;border-top:1px solid #e8e8e8}.multiselect__content::webkit-scrollbar{display:none}.multiselect__element{display:block}.multiselect__option{display:block;padding:12px;min-height:40px;line-height:16px;text-decoration:none;text-transform:none;vertical-align:middle;position:relative;cursor:pointer;white-space:nowrap}.multiselect__option:after{top:0;right:0;position:absolute;line-height:40px;padding-right:12px;padding-left:20px;font-size:13px}.multiselect__option--highlight{background:#41b883;outline:none;color:#fff}.multiselect__option--highlight:after{content:attr(data-select);background:#41b883;color:#fff}.multiselect__option--selected{background:#f3f3f3;color:#35495e;font-weight:700}.multiselect__option--selected:after{content:attr(data-selected);color:silver}.multiselect__option--selected.multiselect__option--highlight{background:#ff6a6a;color:#fff}.multiselect__option--selected.multiselect__option--highlight:after{background:#ff6a6a;content:attr(data-deselect);color:#fff}.multiselect--disabled .multiselect__current,.multiselect--disabled .multiselect__select{background:#ededed;color:#a6a6a6}.multiselect__option--disabled{background:#ededed!important;color:#a6a6a6!important;cursor:text;pointer-events:none}.multiselect__option--group{background:#ededed;color:#35495e}.multiselect__option--group.multiselect__option--highlight{background:#35495e;color:#fff}.multiselect__option--group.multiselect__option--highlight:after{background:#35495e}.multiselect__option--disabled.multiselect__option--highlight{background:#dedede}.multiselect__option--group-selected.multiselect__option--highlight{background:#ff6a6a;color:#fff}.multiselect__option--group-selected.multiselect__option--highlight:after{background:#ff6a6a;content:attr(data-deselect);color:#fff}.multiselect-enter-active,.multiselect-leave-active{transition:all .15s ease}.multiselect-enter,.multiselect-leave-active{opacity:0}.multiselect__strong{margin-bottom:8px;line-height:20px;display:inline-block;vertical-align:top}[dir=rtl] .multiselect{text-align:right}[dir=rtl] .multiselect__select{right:auto;left:1px}[dir=rtl] .multiselect__tags{padding:8px 8px 0 40px}[dir=rtl] .multiselect__content{text-align:right}[dir=rtl] .multiselect__option:after{right:auto;left:0}[dir=rtl] .multiselect__clear{right:auto;left:12px}[dir=rtl] .multiselect__spinner{right:auto;left:1px}@keyframes spinning{0%{transform:rotate(0)}to{transform:rotate(2turn)}}\n/* line 3, stdin */\n.block-div.control-box.open .body-div {\n  overflow: visible; }\n\n/* line 6, stdin */\n.block-div.control-box.open .multiselect__input, .block-div.control-box.open .multiselect__single {\n  position: inherit; }\n\n/* line 11, stdin */\n.multiselect__option--highlight, .multiselect__option--highlight:after {\n  background-color: #5293F6; }\n\n/* line 14, stdin */\n.multiselect__tags {\n  /*margin-bottom: 10px;*/ }\n\n/* line 4, stdin */\n.multiselect__tags .custom__tag[_v-02cef7e5] {\n  background-color: #ddd;\n  padding: 2px 5px 2px 5px;\n  border: #aaa 1px solid;\n  border-radius: 5px;\n  margin: 0px 5px 5px 0px;\n  display: inline-block; }\n\n/* line 14, stdin */\n.multiselect__tags .fa.fa-times[_v-02cef7e5] {\n  color: #aaa;\n  cursor: pointer; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-02cef7e5", module.exports)
  } else {
    hotAPI.update("_v-02cef7e5", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vue-multiselect":787,"vueify/lib/insert-css":799}],1532:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("fieldset[disabled] .multiselect{pointer-events:none}.multiselect__spinner{position:absolute;right:1px;top:1px;width:48px;height:35px;background:#fff;display:block}.multiselect__spinner:after,.multiselect__spinner:before{position:absolute;content:\"\";top:50%;left:50%;margin:-8px 0 0 -8px;width:16px;height:16px;border-radius:100%;border:2px solid transparent;border-top-color:#41b883;box-shadow:0 0 0 1px transparent}.multiselect__spinner:before{animation:spinning 2.4s cubic-bezier(.41,.26,.2,.62);animation-iteration-count:infinite}.multiselect__spinner:after{animation:spinning 2.4s cubic-bezier(.51,.09,.21,.8);animation-iteration-count:infinite}.multiselect__loading-enter-active,.multiselect__loading-leave-active{transition:opacity .4s ease-in-out;opacity:1}.multiselect__loading-enter,.multiselect__loading-leave-active{opacity:0}.multiselect,.multiselect__input,.multiselect__single{font-family:inherit;font-size:16px;-ms-touch-action:manipulation;touch-action:manipulation}.multiselect{box-sizing:content-box;display:block;position:relative;width:100%;min-height:40px;text-align:left;color:#35495e}.multiselect *{box-sizing:border-box}.multiselect:focus{outline:none}.multiselect--disabled{background:#ededed;pointer-events:none;opacity:.6}.multiselect--active{z-index:50}.multiselect--active:not(.multiselect--above) .multiselect__current,.multiselect--active:not(.multiselect--above) .multiselect__input,.multiselect--active:not(.multiselect--above) .multiselect__tags{border-bottom-left-radius:0;border-bottom-right-radius:0}.multiselect--active .multiselect__select{transform:rotate(180deg)}.multiselect--above.multiselect--active .multiselect__current,.multiselect--above.multiselect--active .multiselect__input,.multiselect--above.multiselect--active .multiselect__tags{border-top-left-radius:0;border-top-right-radius:0}.multiselect__input,.multiselect__single{position:relative;display:inline-block;min-height:20px;line-height:20px;border:none;border-radius:5px;background:#fff;padding:0 0 0 5px;width:100%;transition:border .1s ease;box-sizing:border-box;margin-bottom:8px;vertical-align:top}.multiselect__input:-ms-input-placeholder{color:#35495e}.multiselect__input::placeholder{color:#35495e}.multiselect__tag~.multiselect__input,.multiselect__tag~.multiselect__single{width:auto}.multiselect__input:hover,.multiselect__single:hover{border-color:#cfcfcf}.multiselect__input:focus,.multiselect__single:focus{border-color:#a8a8a8;outline:none}.multiselect__single{padding-left:5px;margin-bottom:8px}.multiselect__tags-wrap{display:inline}.multiselect__tags{min-height:40px;display:block;padding:8px 40px 0 8px;border-radius:5px;border:1px solid #e8e8e8;background:#fff;font-size:14px}.multiselect__tag{position:relative;display:inline-block;padding:4px 26px 4px 10px;border-radius:5px;margin-right:10px;color:#fff;line-height:1;background:#41b883;margin-bottom:5px;white-space:nowrap;overflow:hidden;max-width:100%;text-overflow:ellipsis}.multiselect__tag-icon{cursor:pointer;margin-left:7px;position:absolute;right:0;top:0;bottom:0;font-weight:700;font-style:normal;width:22px;text-align:center;line-height:22px;transition:all .2s ease;border-radius:5px}.multiselect__tag-icon:after{content:\"\\D7\";color:#266d4d;font-size:14px}.multiselect__tag-icon:focus,.multiselect__tag-icon:hover{background:#369a6e}.multiselect__tag-icon:focus:after,.multiselect__tag-icon:hover:after{color:#fff}.multiselect__current{min-height:40px;overflow:hidden;padding:8px 30px 0 12px;white-space:nowrap;border-radius:5px;border:1px solid #e8e8e8}.multiselect__current,.multiselect__select{line-height:16px;box-sizing:border-box;display:block;margin:0;text-decoration:none;cursor:pointer}.multiselect__select{position:absolute;width:40px;height:38px;right:1px;top:1px;padding:4px 8px;text-align:center;transition:transform .2s ease}.multiselect__select:before{position:relative;right:0;top:65%;color:#999;margin-top:4px;border-color:#999 transparent transparent;border-style:solid;border-width:5px 5px 0;content:\"\"}.multiselect__placeholder{color:#adadad;display:inline-block;margin-bottom:10px;padding-top:2px}.multiselect--active .multiselect__placeholder{display:none}.multiselect__content-wrapper{position:absolute;display:block;background:#fff;width:100%;max-height:240px;overflow:auto;border:1px solid #e8e8e8;border-top:none;border-bottom-left-radius:5px;border-bottom-right-radius:5px;z-index:50;-webkit-overflow-scrolling:touch}.multiselect__content{list-style:none;display:inline-block;padding:0;margin:0;min-width:100%;vertical-align:top}.multiselect--above .multiselect__content-wrapper{bottom:100%;border-bottom-left-radius:0;border-bottom-right-radius:0;border-top-left-radius:5px;border-top-right-radius:5px;border-bottom:none;border-top:1px solid #e8e8e8}.multiselect__content::webkit-scrollbar{display:none}.multiselect__element{display:block}.multiselect__option{display:block;padding:12px;min-height:40px;line-height:16px;text-decoration:none;text-transform:none;vertical-align:middle;position:relative;cursor:pointer;white-space:nowrap}.multiselect__option:after{top:0;right:0;position:absolute;line-height:40px;padding-right:12px;padding-left:20px;font-size:13px}.multiselect__option--highlight{background:#41b883;outline:none;color:#fff}.multiselect__option--highlight:after{content:attr(data-select);background:#41b883;color:#fff}.multiselect__option--selected{background:#f3f3f3;color:#35495e;font-weight:700}.multiselect__option--selected:after{content:attr(data-selected);color:silver}.multiselect__option--selected.multiselect__option--highlight{background:#ff6a6a;color:#fff}.multiselect__option--selected.multiselect__option--highlight:after{background:#ff6a6a;content:attr(data-deselect);color:#fff}.multiselect--disabled .multiselect__current,.multiselect--disabled .multiselect__select{background:#ededed;color:#a6a6a6}.multiselect__option--disabled{background:#ededed!important;color:#a6a6a6!important;cursor:text;pointer-events:none}.multiselect__option--group{background:#ededed;color:#35495e}.multiselect__option--group.multiselect__option--highlight{background:#35495e;color:#fff}.multiselect__option--group.multiselect__option--highlight:after{background:#35495e}.multiselect__option--disabled.multiselect__option--highlight{background:#dedede}.multiselect__option--group-selected.multiselect__option--highlight{background:#ff6a6a;color:#fff}.multiselect__option--group-selected.multiselect__option--highlight:after{background:#ff6a6a;content:attr(data-deselect);color:#fff}.multiselect-enter-active,.multiselect-leave-active{transition:all .15s ease}.multiselect-enter,.multiselect-leave-active{opacity:0}.multiselect__strong{margin-bottom:8px;line-height:20px;display:inline-block;vertical-align:top}[dir=rtl] .multiselect{text-align:right}[dir=rtl] .multiselect__select{right:auto;left:1px}[dir=rtl] .multiselect__tags{padding:8px 8px 0 40px}[dir=rtl] .multiselect__content{text-align:right}[dir=rtl] .multiselect__option:after{right:auto;left:0}[dir=rtl] .multiselect__clear{right:auto;left:12px}[dir=rtl] .multiselect__spinner{right:auto;left:1px}@keyframes spinning{0%{transform:rotate(0)}to{transform:rotate(2turn)}}\n/* line 3, stdin */\n.block-div.control-box.open .body-div {\n  overflow: visible; }\n\n/* line 6, stdin */\n.block-div.control-box.open .multiselect__input, .block-div.control-box.open .multiselect__single {\n  position: inherit; }\n\n/* line 11, stdin */\n.multiselect__option--highlight, .multiselect__option--highlight:after {\n  background-color: #5293F6; }\n\n/* line 14, stdin */\n.multiselect__tags {\n  /*margin-bottom: 10px;*/ }\n\n/* line 4, stdin */\n.multiselect__tags .custom__tag[_v-76278e37] {\n  background-color: #ddd;\n  padding: 2px 5px 2px 5px;\n  border: #aaa 1px solid;\n  border-radius: 5px;\n  margin: 0px 5px 5px 0px;\n  display: inline-block; }\n\n/* line 14, stdin */\n.multiselect__tags .fa.fa-times[_v-76278e37] {\n  color: #aaa;\n  cursor: pointer; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vuejsPaginate = require('vuejs-paginate');

var _vuejsPaginate2 = _interopRequireDefault(_vuejsPaginate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['value', 'pageCount', 'clickHandler', 'prevText', 'nextText'],
    components: { Paginate: _vuejsPaginate2.default },
    computed: {
        vmodel: {
            get: function get() {
                return this.value;
            },
            set: function set(newValue) {
                this.$emit('input', newValue);
            }
        },
        prev: function prev() {
            return this.prevText ? this.prevText : '<<';
        },
        next: function next() {
            return this.nextText ? this.nextText : '>>';
        }
    },
    methods: {
        selectEvent: function selectEvent(selectedOption, id) {
            this.selectEventAppend && this.selectEventAppend(selectedOption, id);
        },
        inputEvent: function inputEvent(value, id) {
            this.inputEventAppend && this.inputEventAppend(value, id);
            this.hidePlaceHolder();
        },
        closeEvent: function closeEvent(value, id) {
            this.closeEventAppend && this.closeEventAppend(value, id);
        },
        openEvent: function openEvent(value, id) {
            this.openEventAppend && this.openEventAppend(value, id);
        },
        hidePlaceHolder: function hidePlaceHolder() {
            if (this.multiple) {
                if (this.vmodel.length > 0) {
                    $(this.$el).find('.multiselect__single').hide();
                } else {
                    $(this.$el).find('.multiselect__single').show();
                }
            }
        },
        setMobilePosition: function setMobilePosition() {
            if ($17.isMobile()) {
                //console.log($('.multiselect__content-wrapper').css('position'));
                $('.multiselect__content-wrapper').css('position', 'absolute');
            }
        }
    },
    watch: {
        vmodel: function vmodel() {
            this.hidePlaceHolder();
        }
    },
    mounted: function mounted() {
        this.$nextTick(function () {
            this.setMobilePosition();
        });
    },
    updated: function updated() {
        this.$nextTick(function () {
            this.setMobilePosition();
        });
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<paginate v-model=\"vmodel\" :page-count=\"pageCount\" container-class=\"pagination\" :prev-text=\"prev\" :next-text=\"next\" :click-handler=\"clickHandler\" _v-76278e37=\"\">\n</paginate>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["fieldset[disabled] .multiselect{pointer-events:none}.multiselect__spinner{position:absolute;right:1px;top:1px;width:48px;height:35px;background:#fff;display:block}.multiselect__spinner:after,.multiselect__spinner:before{position:absolute;content:\"\";top:50%;left:50%;margin:-8px 0 0 -8px;width:16px;height:16px;border-radius:100%;border:2px solid transparent;border-top-color:#41b883;box-shadow:0 0 0 1px transparent}.multiselect__spinner:before{animation:spinning 2.4s cubic-bezier(.41,.26,.2,.62);animation-iteration-count:infinite}.multiselect__spinner:after{animation:spinning 2.4s cubic-bezier(.51,.09,.21,.8);animation-iteration-count:infinite}.multiselect__loading-enter-active,.multiselect__loading-leave-active{transition:opacity .4s ease-in-out;opacity:1}.multiselect__loading-enter,.multiselect__loading-leave-active{opacity:0}.multiselect,.multiselect__input,.multiselect__single{font-family:inherit;font-size:16px;-ms-touch-action:manipulation;touch-action:manipulation}.multiselect{box-sizing:content-box;display:block;position:relative;width:100%;min-height:40px;text-align:left;color:#35495e}.multiselect *{box-sizing:border-box}.multiselect:focus{outline:none}.multiselect--disabled{background:#ededed;pointer-events:none;opacity:.6}.multiselect--active{z-index:50}.multiselect--active:not(.multiselect--above) .multiselect__current,.multiselect--active:not(.multiselect--above) .multiselect__input,.multiselect--active:not(.multiselect--above) .multiselect__tags{border-bottom-left-radius:0;border-bottom-right-radius:0}.multiselect--active .multiselect__select{transform:rotate(180deg)}.multiselect--above.multiselect--active .multiselect__current,.multiselect--above.multiselect--active .multiselect__input,.multiselect--above.multiselect--active .multiselect__tags{border-top-left-radius:0;border-top-right-radius:0}.multiselect__input,.multiselect__single{position:relative;display:inline-block;min-height:20px;line-height:20px;border:none;border-radius:5px;background:#fff;padding:0 0 0 5px;width:100%;transition:border .1s ease;box-sizing:border-box;margin-bottom:8px;vertical-align:top}.multiselect__input:-ms-input-placeholder{color:#35495e}.multiselect__input::placeholder{color:#35495e}.multiselect__tag~.multiselect__input,.multiselect__tag~.multiselect__single{width:auto}.multiselect__input:hover,.multiselect__single:hover{border-color:#cfcfcf}.multiselect__input:focus,.multiselect__single:focus{border-color:#a8a8a8;outline:none}.multiselect__single{padding-left:5px;margin-bottom:8px}.multiselect__tags-wrap{display:inline}.multiselect__tags{min-height:40px;display:block;padding:8px 40px 0 8px;border-radius:5px;border:1px solid #e8e8e8;background:#fff;font-size:14px}.multiselect__tag{position:relative;display:inline-block;padding:4px 26px 4px 10px;border-radius:5px;margin-right:10px;color:#fff;line-height:1;background:#41b883;margin-bottom:5px;white-space:nowrap;overflow:hidden;max-width:100%;text-overflow:ellipsis}.multiselect__tag-icon{cursor:pointer;margin-left:7px;position:absolute;right:0;top:0;bottom:0;font-weight:700;font-style:normal;width:22px;text-align:center;line-height:22px;transition:all .2s ease;border-radius:5px}.multiselect__tag-icon:after{content:\"\\D7\";color:#266d4d;font-size:14px}.multiselect__tag-icon:focus,.multiselect__tag-icon:hover{background:#369a6e}.multiselect__tag-icon:focus:after,.multiselect__tag-icon:hover:after{color:#fff}.multiselect__current{min-height:40px;overflow:hidden;padding:8px 30px 0 12px;white-space:nowrap;border-radius:5px;border:1px solid #e8e8e8}.multiselect__current,.multiselect__select{line-height:16px;box-sizing:border-box;display:block;margin:0;text-decoration:none;cursor:pointer}.multiselect__select{position:absolute;width:40px;height:38px;right:1px;top:1px;padding:4px 8px;text-align:center;transition:transform .2s ease}.multiselect__select:before{position:relative;right:0;top:65%;color:#999;margin-top:4px;border-color:#999 transparent transparent;border-style:solid;border-width:5px 5px 0;content:\"\"}.multiselect__placeholder{color:#adadad;display:inline-block;margin-bottom:10px;padding-top:2px}.multiselect--active .multiselect__placeholder{display:none}.multiselect__content-wrapper{position:absolute;display:block;background:#fff;width:100%;max-height:240px;overflow:auto;border:1px solid #e8e8e8;border-top:none;border-bottom-left-radius:5px;border-bottom-right-radius:5px;z-index:50;-webkit-overflow-scrolling:touch}.multiselect__content{list-style:none;display:inline-block;padding:0;margin:0;min-width:100%;vertical-align:top}.multiselect--above .multiselect__content-wrapper{bottom:100%;border-bottom-left-radius:0;border-bottom-right-radius:0;border-top-left-radius:5px;border-top-right-radius:5px;border-bottom:none;border-top:1px solid #e8e8e8}.multiselect__content::webkit-scrollbar{display:none}.multiselect__element{display:block}.multiselect__option{display:block;padding:12px;min-height:40px;line-height:16px;text-decoration:none;text-transform:none;vertical-align:middle;position:relative;cursor:pointer;white-space:nowrap}.multiselect__option:after{top:0;right:0;position:absolute;line-height:40px;padding-right:12px;padding-left:20px;font-size:13px}.multiselect__option--highlight{background:#41b883;outline:none;color:#fff}.multiselect__option--highlight:after{content:attr(data-select);background:#41b883;color:#fff}.multiselect__option--selected{background:#f3f3f3;color:#35495e;font-weight:700}.multiselect__option--selected:after{content:attr(data-selected);color:silver}.multiselect__option--selected.multiselect__option--highlight{background:#ff6a6a;color:#fff}.multiselect__option--selected.multiselect__option--highlight:after{background:#ff6a6a;content:attr(data-deselect);color:#fff}.multiselect--disabled .multiselect__current,.multiselect--disabled .multiselect__select{background:#ededed;color:#a6a6a6}.multiselect__option--disabled{background:#ededed!important;color:#a6a6a6!important;cursor:text;pointer-events:none}.multiselect__option--group{background:#ededed;color:#35495e}.multiselect__option--group.multiselect__option--highlight{background:#35495e;color:#fff}.multiselect__option--group.multiselect__option--highlight:after{background:#35495e}.multiselect__option--disabled.multiselect__option--highlight{background:#dedede}.multiselect__option--group-selected.multiselect__option--highlight{background:#ff6a6a;color:#fff}.multiselect__option--group-selected.multiselect__option--highlight:after{background:#ff6a6a;content:attr(data-deselect);color:#fff}.multiselect-enter-active,.multiselect-leave-active{transition:all .15s ease}.multiselect-enter,.multiselect-leave-active{opacity:0}.multiselect__strong{margin-bottom:8px;line-height:20px;display:inline-block;vertical-align:top}[dir=rtl] .multiselect{text-align:right}[dir=rtl] .multiselect__select{right:auto;left:1px}[dir=rtl] .multiselect__tags{padding:8px 8px 0 40px}[dir=rtl] .multiselect__content{text-align:right}[dir=rtl] .multiselect__option:after{right:auto;left:0}[dir=rtl] .multiselect__clear{right:auto;left:12px}[dir=rtl] .multiselect__spinner{right:auto;left:1px}@keyframes spinning{0%{transform:rotate(0)}to{transform:rotate(2turn)}}\n/* line 3, stdin */\n.block-div.control-box.open .body-div {\n  overflow: visible; }\n\n/* line 6, stdin */\n.block-div.control-box.open .multiselect__input, .block-div.control-box.open .multiselect__single {\n  position: inherit; }\n\n/* line 11, stdin */\n.multiselect__option--highlight, .multiselect__option--highlight:after {\n  background-color: #5293F6; }\n\n/* line 14, stdin */\n.multiselect__tags {\n  /*margin-bottom: 10px;*/ }\n\n/* line 4, stdin */\n.multiselect__tags .custom__tag[_v-76278e37] {\n  background-color: #ddd;\n  padding: 2px 5px 2px 5px;\n  border: #aaa 1px solid;\n  border-radius: 5px;\n  margin: 0px 5px 5px 0px;\n  display: inline-block; }\n\n/* line 14, stdin */\n.multiselect__tags .fa.fa-times[_v-76278e37] {\n  color: #aaa;\n  cursor: pointer; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-76278e37", module.exports)
  } else {
    hotAPI.update("_v-76278e37", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuejs-paginate":802}],1533:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

var _actions = require('../../store/actions');

var _getters = require('../../store/getters');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['count'])),
  methods: (0, _vuex.mapActions)(['increment'])
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-608175b4=\"\">\n    <input type=\"button\" value=\"+1\" @click=\"increment\" _v-608175b4=\"\">\n    <p _v-608175b4=\"\">{{count}}</p> \n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-608175b4", module.exports)
  } else {
    hotAPI.update("_v-608175b4", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"../../store/actions":1588,"../../store/getters":1589,"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vuex":803}],1534:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _qrcode = require('qrcode');

var _qrcode2 = _interopRequireDefault(_qrcode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	mounted: function mounted() {
		this.generate();
	},

	watch: {
		$props: {
			deep: true,
			immediate: true,

			/**
    * Update the QR code when props changed.
    */
			handler: function handler() {
				if (this.$el) {
					this.generate();
				}
			}
		}
	},
	props: {
		id: {
			type: String,
			default: 'qrcode-vue'
		},
		options: {
			type: Object,
			default: Object
		},
		value: {
			type: String,
			default: ''
		},
		type: {
			type: String,
			default: 'canvas'
		}
	},
	methods: {
		generate: function generate() {
			if (this.value.length === 0) {
				return;
			}
			if (this.type == 'canvas') {
				this.toCanvas();
			}
		},
		toCanvas: function toCanvas() {
			_qrcode2.default.toCanvas(document.getElementById(this.id), this.value, this.options, function (error) {
				if (error) console.error(error);
				// console.log('success!');
			});
		}
	}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<canvas :id=\"id\" v-if=\"type=='canvas'\" _v-2b3f1bce=\"\"></canvas>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-2b3f1bce", module.exports)
  } else {
    hotAPI.update("_v-2b3f1bce", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"qrcode":735,"vue":792,"vue-hot-reload-api":785}],1535:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.required[_v-8d22ed42] {\n  color: red; }\n")
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<span class=\"required\" _v-8d22ed42=\"\">*</span>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.required[_v-8d22ed42] {\n  color: red; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-8d22ed42", module.exports)
  } else {
    hotAPI.update("_v-8d22ed42", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1536:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	props: {
		id: {
			type: String,
			default: null
		},
		name: {
			type: String,
			default: 'city'
		},
		selected: {
			default: null
		}
	},
	data: function data() {
		return {
			options: [],
			city: null,
			defaultOption: {
				id: 0,
				name: '請選擇'
			}
		};
	},

	watch: {
		city: function city(v) {
			var _this = this;

			this.$nextTick(function () {
				_this.refreshDistrict(v);
			});
		}
	},
	mounted: function mounted() {
		var _this2 = this;

		this.$http.get('/api/cities').then(function (response) {
			_this2.options = [_this2.defaultOption].concat(response.body);
			_this2.initCity();
		});
	},

	methods: {
		refreshDistrict: function refreshDistrict(v) {
			window.Event.$emit('refresh-district', v);
		},
		initCity: function initCity() {
			if (this.options.length <= 0) return;
			if (this.selected) {
				this.city = this.selected;
			} else {
				this.city = this.options[0].id;
			}
		}
	}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<select :id=\"id\" class=\"form-control\" :name=\"name\" v-model=\"city\" _v-42cb56e8=\"\">\n\t<option v-for=\"option in options\" :value=\"option.id\" _v-42cb56e8=\"\">\n\t\t{{ option.name }}\n\t</option>\n</select>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-42cb56e8", module.exports)
  } else {
    hotAPI.update("_v-42cb56e8", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],1537:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	props: {
		id: {
			type: String,
			default: null
		},
		name: {
			type: String,
			default: 'district'
		},
		selected: {
			default: null
		},
		selectedCity: {
			default: null
		}
	},
	data: function data() {
		return {
			options: [{
				id: 0,
				name: '請選擇'
			}],
			defaultOption: {
				id: 0,
				name: '請選擇'
			},
			district: null,
			cnt: 0
		};
	},
	mounted: function mounted() {
		var _this = this;

		window.Event.$on('refresh-district', function (id) {
			_this.cnt++;
			_this.refreshDistricts(id);
		});
	},

	methods: {
		refreshDistricts: function refreshDistricts(id) {
			var _this2 = this;

			this.$http.get('/api/districts/' + id).then(function (response) {
				_this2.options = [_this2.defaultOption].concat(response.body);
				_this2.initDistrict();
			});
		},
		initDistrict: function initDistrict() {
			if (this.options.length <= 0) return;
			if (this.selected && this.cnt == 1) {
				this.district = this.selected;
			} else {
				this.district = this.options[0].id;
			}
		}
	},
	destroyed: function destroyed() {
		window.Event.$off('refresh-district');
	}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<select class=\"form-control\" :id=\"id\" :name=\"name\" v-model=\"district\" _v-bd2e0ea2=\"\">\n\t<option v-for=\"option in options\" :value=\"option.id\" _v-bd2e0ea2=\"\">\n\t\t{{ option.name }}\n\t</option>\n</select>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-bd2e0ea2", module.exports)
  } else {
    hotAPI.update("_v-bd2e0ea2", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],1538:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n.form-group .select-group[_v-7bc5ea5e] {\n    width: 100%;\n    max-width: 400px;\n    min-width: 150px;\n    display: inline-block;\n}\n.hide[_v-7bc5ea5e] {\n    display: none;\n}\n@media (min-width: 768px) {\n    .select-outer-div[_v-7bc5ea5e] {\n        display: -ms-flexbox;\n        display: flex;\n    }\n    .form-group[_v-7bc5ea5e] {\n        -ms-flex: 1;\n            flex: 1;\n        padding-right: 10px;\n    }\n}\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        'studio_id': {
            type: Number
        },
        'branch_id': {
            type: Number
        },
        'branchChangeCallBack': {
            type: Function
        },
        'studioChangeCallBack': {
            type: Function
        },
        'branchWithoutFilteredOption': {
            default: false,
            type: Boolean
        },
        'showBranch': {
            default: true,
            type: Boolean
        },
        'branchWithoutFilteredOptionWord': {
            default: '全部場館',
            type: String
        },
        'showBranchLable': {
            default: false,
            type: Boolean
        }
    },
    data: function data() {
        return {
            branchName: ''
        };
    },

    methods: {
        getStudioList: function getStudioList() {
            this.$store.dispatch('filters/getStudioList');
        },
        getBranchList: function getBranchList() {
            this.$store.dispatch('filters/getBranchList');
        },

        studioChange: function studioChange(studio_id) {
            this.studioChangeCallBack && this.studioChangeCallBack(studio_id);
        },
        branchChange: function branchChange(branch_id) {
            this.branchChangeCallBack && this.branchChangeCallBack(branch_id);
        },
        initStudioId: function initStudioId() {
            var _this = this;

            if (this.studio_id == 0) {
                this.$nextTick(function () {
                    $(_this.$el).find('#ssab_studio_id').select2({
                        theme: 'classic',
                        placeholder: '請選擇品牌',
                        language: {
                            noResults: function noResults(params) {
                                return "沒有符合的資料";
                            }
                        }
                    }).on('change', function (e) {
                        _this.selected_studio_id = e.target.value;
                        _this.studioChange(e.target.value);
                        if (_this.showBranch !== false) {
                            _this.getBranchList();
                        }
                    });
                    _this.getStudioList();
                });
                return;
            }
            this.selected_studio_id = this.studio_id;
        },
        initBranchId: function initBranchId() {
            var _this2 = this;

            if (this.branch_id == 0) {
                this.$nextTick(function () {
                    $(_this2.$el).find('#ssab_branch_id').select2({
                        theme: 'classic',
                        placeholder: '請選擇場館',
                        language: {
                            noResults: function noResults(params) {
                                return "沒有符合的資料";
                            }
                        }
                    }).on('change', function (e) {
                        _this2.selected_branch_id = e.target.value;
                        if (e.target.value) _this2.branchChange(e.target.value);
                    });
                    _this2.getBranchList();
                });
                return;
            }

            this.selected_branch_id = this.branch_id;
            if (this.branch_id != 0 && this.showBranchLable) {
                this.$http.get('/adminapi/init/get_branch/' + this.branch_id).then(function (response) {
                    _this2.branchName = response.data.name;
                }, function (error) {});
            }
        }
    },
    computed: (0, _extends3.default)({
        shouldDisplay: function shouldDisplay() {
            return this.studio_id == 0 || this.branch_id == 0 || this.showBranchLable;
        }
    }, (0, _vuex.mapState)({
        studioOptions: function studioOptions(state) {
            return state.filters.studioOptions;
        },
        branchOptions: function branchOptions(state) {
            return state.filters.branchOptions;
        }
    }), {
        selected_studio_id: {
            get: function get() {
                return this.$store.state.filters.selected_studio_id;
            },
            set: function set(studio_id) {
                this.$store.commit('filters/SETSTATUS', { 'key': 'selected_studio_id', value: studio_id });
            }
        },
        selected_branch_id: {
            get: function get() {
                if (!this.branchWithoutFilteredOption && !!this.branchOptions[0] && this.branchOptions[0]['id'] && !this.$store.state.filters.selected_branch_id) {
                    this.$store.commit('filters/SETSTATUS', { 'key': 'selected_branch_id', value: this.branchOptions[0]['id'] });
                    this.branchChange(this.branchOptions[0]['id']);
                }
                return this.$store.state.filters.selected_branch_id;
            },
            set: function set(branch_id) {
                this.$store.commit('filters/SETSTATUS', { 'key': 'selected_branch_id', value: branch_id });
            }
        }
    }),
    watch: {
        studio_id: function studio_id(v) {
            this.initStudioId();
        },
        branch_id: function branch_id(v) {
            this.initBranchId();
        }
    },
    mounted: function mounted() {
        this.initStudioId();
        this.initBranchId();
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"select-outer-div\" v-if=\"shouldDisplay\" _v-7bc5ea5e=\"\">\n    <div v-if=\"studio_id == 0\" class=\"form-group\" _v-7bc5ea5e=\"\">\n      <div class=\"select-group\" _v-7bc5ea5e=\"\">\n        <select id=\"ssab_studio_id\" class=\"form-control custom-select2\" :value=\"selected_studio_id\" _v-7bc5ea5e=\"\">\n            <option class=\"hide\" _v-7bc5ea5e=\"\"></option>\n            <option v-for=\"studioOption in studioOptions\" :value=\"studioOption.id\" _v-7bc5ea5e=\"\">{{ studioOption.brand_name }}</option>\n        </select>\n      </div>\n    </div>\n    <div v-show=\"showBranch\" v-if=\"branch_id == 0\" class=\"form-group\" _v-7bc5ea5e=\"\">\n      <div class=\"select-group\" _v-7bc5ea5e=\"\">\n        <select id=\"ssab_branch_id\" class=\"form-control custom-select2\" :value=\"selected_branch_id\" _v-7bc5ea5e=\"\">\n            <option value=\"null\" v-if=\"branchWithoutFilteredOption\" _v-7bc5ea5e=\"\">{{branchWithoutFilteredOptionWord}}</option>\n            <option v-for=\"branchOption in branchOptions\" :value=\"branchOption.id\" :key=\"branchOption.id\" _v-7bc5ea5e=\"\">{{ branchOption.branch_name }}</option>\n        </select>\n      </div>\n    </div>\n    <div v-show=\"showBranch\" v-if=\"branch_id != 0\" class=\"form-group\" _v-7bc5ea5e=\"\">\n        <label _v-7bc5ea5e=\"\">{{ branchName }}</label>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n.form-group .select-group[_v-7bc5ea5e] {\n    width: 100%;\n    max-width: 400px;\n    min-width: 150px;\n    display: inline-block;\n}\n.hide[_v-7bc5ea5e] {\n    display: none;\n}\n@media (min-width: 768px) {\n    .select-outer-div[_v-7bc5ea5e] {\n        display: -ms-flexbox;\n        display: flex;\n    }\n    .form-group[_v-7bc5ea5e] {\n        -ms-flex: 1;\n            flex: 1;\n        padding-right: 10px;\n    }\n}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-7bc5ea5e", module.exports)
  } else {
    hotAPI.update("_v-7bc5ea5e", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1539:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.hide[_v-0b194aa6] {\n  display: none; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	props: {
		options: {},
		'prop': {},
		'text': {},
		'placeholder': {},
		'disabled': {},
		'updated': {},
		'multiple': {
			default: false
		},
		'match': {}
	},
	watch: {
		options: function options(n, o) {
			this.formatSelect2();
		},
		match: function match(n, o) {
			this.matchSelect2(n);
		}
	},
	methods: {
		formatSelect2: function formatSelect2() {
			var vm = this;
			$(this.$el).find('select').unbind().select2({
				theme: 'classic',
				language: 'zh-TW',
				placeholder: this.placeholder || '請選擇'
			}).on('change', function () {
				vm.updated && vm.updated(this.value);
			});
		},
		matchSelect2: function matchSelect2(value) {
			this.$nextTick(function () {
				$(this.$el).find('select').val(value).trigger('change');
			});
		}
	},
	computed: {
		propField: function propField() {
			return this.prop || 'id';
		},
		textField: function textField() {
			return this.text || 'text';
		}
	},
	mounted: function mounted() {
		this.formatSelect2();
	}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-0b194aa6=\"\">\n\t<select :disabled=\"disabled\" :multiple=\"multiple\" _v-0b194aa6=\"\">\n\t\t<option class=\"hide\" value=\"\" _v-0b194aa6=\"\"></option>\n\t\t<option v-for=\"o in options\" :value=\"o[propField]\" _v-0b194aa6=\"\">{{ o[textField] }}</option>\n\t</select>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.hide[_v-0b194aa6] {\n  display: none; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-0b194aa6", module.exports)
  } else {
    hotAPI.update("_v-0b194aa6", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1540:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['tabs', 'needCheck', 'title', 'text'],
    data: function data() {
        return {
            selectTab: null
        };
    },

    watch: {
        tabs: function tabs(newVal) {
            //    if(newVal.length&& newVal[0]){
            //         this.selectTab = newVal[0]['type'];
            //     }
        }
    },
    methods: {
        bindTabActive: function bindTabActive(t) {
            if (this.selectTab == null && this.tabs.length && this.tabs[0]) {
                this.selectTab = this.tabs[0]['type'];
            }
            return this.selectTab === t ? { active: true } : {};
        },
        clickEvent: function clickEvent(tab) {
            if (this.needCheck) {
                this.checkEvent(tab);
            } else {
                this.actualEvent(tab);
            }
        },
        actualEvent: function actualEvent(tab) {
            this.selectTab = tab.type;
            tab.event(tab);
        },
        checkEvent: function checkEvent(tab) {
            var _this = this;

            return $17.swal({
                title: this.title,
                type: 'warning',
                text: this.text,
                showCancelButton: true,
                confirmButtonText: '確認',
                cancelButtonText: '取消'
            }, function (isConfirm) {
                if (isConfirm) {
                    _this.actualEvent(tab);
                }
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div>\n    <ul class=\"nav nav-tabs\">\n        <li v-for=\" tab in tabs\" v-bind:class=\"bindTabActive(tab.type)\" @click.stop.prevent=\"clickEvent(tab)\">\n            <a href=\"\">{{tab.name}}</a>\n        </li>\n    </ul>\n    <div style=\"padding-top: 10px\"></div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-96acc5ae", module.exports)
  } else {
    hotAPI.update("_v-96acc5ae", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],1541:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _vuex = require('vuex');

exports.default = {
	props: {
		title: {
			default: ''
		},
		currentText: {
			default: ''
		},
		saveClicked: {
			default: function _default() {}
		},
		resetClicked: {
			default: function _default() {}
		},
		changeText: {
			default: function _default(value) {}
		},
		textareaStyle: {},
		editBtnStyle: {},
		isEditMode: {
			default: function _default(value) {}
		}
	},
	updated: function updated() {
		if (this.currentText != this.textinput) {}
	},
	data: function data() {
		return {
			textDefault: '輸入文字...',
			textinput: '',
			isEdit: false
		};
	},

	methods: {
		saveText: function saveText() {
			if (this.saveClicked && this.saveClicked(this.currentText)) {
				this.resetEdit();
			}
		},
		reset: function reset() {
			this.resetEdit();
			this.resetClicked && this.resetClicked();
		},
		editMode: function editMode() {
			if (!this.isEdit) {
				this.isEdit = true;
				this.isEditMode(this.isEdit);
			}
		},
		resetEdit: function resetEdit() {
			this.isEdit = false;
			this.isEditMode(this.isEdit);
		}
	}

};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-b644e920=\"\">\n\t<div class=\"row\" _v-b644e920=\"\">\n\t\t<div class=\"col-xs-12 text-left\" _v-b644e920=\"\">\n\t\t\t<span class=\"title\" _v-b644e920=\"\">{{title}}</span>\n\t\t</div>\n\t</div>\n\t<div class=\"row\" _v-b644e920=\"\">\n\t\t<div class=\"col-xs-12\" _v-b644e920=\"\">\n\t\t\t<textarea :style=\"textareaStyle\" name=\"\" :value=\"currentText\" :placeholder=\"textDefault\" :readonly=\"!isEdit\" @click=\"editMode\" @change=\"changeText($event.target.value)\" _v-b644e920=\"\"></textarea>\n\t\t</div>\n\t</div>\n\t<div class=\"row\" v-if=\"isEdit\" :style=\"editBtnStyle\" _v-b644e920=\"\">\n\t\t<div class=\"col-xs-12\" _v-b644e920=\"\">\n\t\t\t<div class=\"btn btn-primary\" @click=\"saveText\" _v-b644e920=\"\">\n\t\t\t\t儲存\n\t\t\t</div>\n\t\t\t<div class=\"btn btn-default btn--inverse\" @click=\"reset\" _v-b644e920=\"\">\n\t\t\t\t<i class=\"fa fa-times\" aria-hidden=\"true\" _v-b644e920=\"\"></i>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-b644e920", module.exports)
  } else {
    hotAPI.update("_v-b644e920", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vuex":803}],1542:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.fa-spinner[_v-33c585a6] {\n  color: #38B0E3; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        ajaxing: {
            type: Boolean,
            default: false
        },
        faSize: {
            default: 'fa-1x'
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div v-if=\"ajaxing\" _v-33c585a6=\"\">\n    <i class=\"fa fa-spinner fa-spin \" :class=\"faSize\" _v-33c585a6=\"\"></i>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.fa-spinner[_v-33c585a6] {\n  color: #38B0E3; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-33c585a6", module.exports)
  } else {
    hotAPI.update("_v-33c585a6", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1543:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        ajaxing: {
            type: Boolean,
            default: false
        },
        color: {
            type: String,
            default: "#38b0e3"
        }
    },
    data: function data() {
        return {
            showColor: ''
        };
    },
    mounted: function mounted() {
        var businessColor = $('.primary-business-color-background').css('background-color');
        var transparent = businessColor == 'rgb(0, 0, 0)' || businessColor == 'rgba(0, 0, 0, 0)';
        this.showColor = transparent ? this.color : this.businessColor;
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div style=\"text-align:center;\">\n    <div v-show=\"ajaxing\" class=\"loader triangle\" :style=\"{ '--theme-path': showColor, '--theme-dot': showColor }\">\n        <svg viewBox=\"0 0 86 80\">\n            <path d=\"M40 65L5.35899 4.99999L74.641 5L40 65Z\"></path>\n        </svg>\n    </div>\n    <slot></slot>\n    <div class=\"primary-business-color-background\" style=\"display: none;\"></div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-b79faeee", module.exports)
  } else {
    hotAPI.update("_v-b79faeee", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],1544:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.pagination > li > a[_v-723fe6da]:focus {\n  background-color: inherit;\n  border-color: #ddd; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        pageMeta: {
            required: true
        }
    },
    data: function data() {
        return {};
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({}), {
        currentPage: {
            get: function get() {
                var page = 1;
                if (this.pageMeta.hasOwnProperty('currentPage')) {
                    page = parseInt(this.pageMeta.currentPage);
                }
                return page;
            },
            set: function set(newValue) {
                this.updatePageString(newValue);
            }
        },
        startSide: function startSide() {
            if ((0, _keys2.default)(this.pageMeta).length > 0) {
                if (this.currentPage <= 6) {
                    return this.currentPage - 1;
                } else {
                    return [1, 0, this.currentPage - 3, this.currentPage - 2, this.currentPage - 1];
                }
            }
            return 0;
        },
        endSide: function endSide() {
            if ((0, _keys2.default)(this.pageMeta).length > 0) {
                var cnt = this.pageMeta.lastPage - this.currentPage;
                if (cnt < 6) {
                    var pageCount = [];
                    for (var i = 1; i <= cnt; i++) {
                        pageCount.push(i + this.currentPage);
                    }
                    return pageCount;
                } else {
                    return [this.currentPage + 1, this.currentPage + 2, this.currentPage + 3, 0, this.pageMeta.lastPage];
                }
            }
            return 0;
        }
    }),
    methods: {
        updatePageString: function updatePageString(page) {
            this.$emit('page-change-callback', page);
        },

        toPage: function toPage(page) {
            if (page <= 0) {
                return false;
            } else if (page > this.pageMeta.lastPage) {
                this.currentPage = this.pageMeta.lastPage;
            } else {
                this.currentPage = page;
            }
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"text-center\" v-if=\"Object.keys(pageMeta).length>0\" _v-723fe6da=\"\">\n    <nav aria-label=\"Page navigation\" _v-723fe6da=\"\">\n        <ul class=\"pagination\" _v-723fe6da=\"\">\n            <li :class=\"[currentPage==1?'disabled':'']\" _v-723fe6da=\"\">\n                <a href=\"javascript:;\" aria-label=\"Previous\" @click.stop.prevent=\"toPage(currentPage-1)\" _v-723fe6da=\"\">\n                    <span aria-hidden=\"true\" _v-723fe6da=\"\">«</span>\n                </a>\n            </li>\n            <li v-for=\"page in startSide\" :class=\"page===0?'disabled':''\" _v-723fe6da=\"\">\n                <a href=\"javascript:;\" @click.stop.prevent=\"toPage(page)\" _v-723fe6da=\"\">\n                    <span v-if=\"page===0\" _v-723fe6da=\"\">...</span>\n                    <span v-else=\"\" _v-723fe6da=\"\">{{page}}</span>\n                </a>\n            </li>\n            <li class=\"active\" _v-723fe6da=\"\">\n                <a href=\"javascript:;\" @click.stop.prevent=\"toPage(currentPage)\" _v-723fe6da=\"\">\n                    <span _v-723fe6da=\"\">{{currentPage}}</span>\n                </a>\n            </li>\n            <li v-for=\"page in endSide\" :class=\"page===0?'disabled':''\" _v-723fe6da=\"\">\n                <a href=\"javascript:;\" @click.stop.prevent=\"toPage(page)\" _v-723fe6da=\"\">\n                    <span v-if=\"page===0\" _v-723fe6da=\"\">...</span>\n                    <span v-else=\"\" _v-723fe6da=\"\">{{page}}</span>\n                </a>\n            </li>\n            <li :class=\"[currentPage==pageMeta.lastPage?'disabled':'']\" _v-723fe6da=\"\">\n                <a href=\"javascript:;\" aria-label=\"Next\" @click.stop.prevent=\"toPage(currentPage+1)\" _v-723fe6da=\"\">\n                    <span aria-hidden=\"true\" _v-723fe6da=\"\">»</span>\n                </a>\n            </li>\n        </ul>\n        <div class=\"m-bottom-30\" _v-723fe6da=\"\">\n            顯示 {{((currentPage-1)*pageMeta.perPage)+1}} 筆到 {{currentPage==pageMeta.lastPage?pageMeta.total:currentPage*pageMeta.perPage}} 筆 總共 {{pageMeta.total}} 筆\n        </div>\n    </nav>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.pagination > li > a[_v-723fe6da]:focus {\n  background-color: inherit;\n  border-color: #ddd; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-723fe6da", module.exports)
  } else {
    hotAPI.update("_v-723fe6da", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/object/keys":56,"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1545:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.pagination > li > a[_v-e96b488e]:focus {\n  background-color: inherit;\n  border-color: #ddd; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        pageMeta: {
            required: true
        },
        pageSyncUrlQuery: {
            type: Boolean,
            default: true
        },
        cssClass: {
            type: String,
            default: ''
        }
    },
    data: function data() {
        return {};
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({}), {
        currentPage: {
            get: function get() {
                if (this.pageSyncUrlQuery) {
                    return this.getCurrenPageByUrl();
                } else {
                    return this.getCurrenPageByPage();
                }
            },
            set: function set(newValue) {
                this.updatePageQueryString(newValue);
            }
        },
        startSide: function startSide() {
            if ((0, _keys2.default)(this.pageMeta).length > 0) {
                if (this.currentPage <= 6) {
                    return this.currentPage - 1;
                } else {
                    return [1, 0, this.currentPage - 3, this.currentPage - 2, this.currentPage - 1];
                }
            }
            return 0;
        },
        endSide: function endSide() {
            if ((0, _keys2.default)(this.pageMeta).length > 0) {
                var cnt = this.pageMeta.lastPage - this.currentPage;
                if (cnt < 6) {
                    var pageCount = [];
                    for (var i = 1; i <= cnt; i++) {
                        pageCount.push(i + this.currentPage);
                    }
                    return pageCount;
                } else {
                    return [this.currentPage + 1, this.currentPage + 2, this.currentPage + 3, 0, this.pageMeta.lastPage];
                }
            }
            return 0;
        }
    }),
    methods: {
        getCurrenPageByUrl: function getCurrenPageByUrl() {
            var page = 1;
            if (this.getUrlParamValue('page')) {
                page = parseInt(this.getUrlParamValue('page'));
                if (page < 1 || isNaN(page)) {
                    page = 1;
                } else if (page > this.pageMeta.lastPage) {
                    page = this.pageMeta.lastPage;
                }
            } else if (this.pageMeta.hasOwnProperty('currentPage')) {
                page = parseInt(this.pageMeta.currentPage);
            }
            this.$store.dispatch('filters/updateQueryStrings', { page: page });
            return page;
        },
        getCurrenPageByPage: function getCurrenPageByPage() {
            var page = 1;
            if (this.pageMeta.hasOwnProperty('currentPage')) {
                page = parseInt(this.pageMeta.currentPage);
            }
            return page;
        },
        updatePageQueryString: function updatePageQueryString(page) {
            if (this.pageSyncUrlQuery) {
                this.$store.dispatch('filters/updateQueryStrings', { page: page });
                this.$emit('page-change-callback');
            } else {
                this.$emit('page-change-callback', page);
            }
        },

        toPage: function toPage(page) {
            if (page <= 0) {
                return false;
            } else if (page > this.pageMeta.lastPage) {
                this.currentPage = this.pageMeta.lastPage;
            } else {
                this.currentPage = page;
            }
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"text-center\" :class=\"cssClass\" v-if=\"Object.keys(pageMeta).length>0\" _v-e96b488e=\"\">\n    <nav aria-label=\"Page navigation\" _v-e96b488e=\"\">\n        <ul class=\"pagination\" _v-e96b488e=\"\">\n            <li :class=\"[currentPage==1?'disabled':'']\" _v-e96b488e=\"\">\n                <a href=\"javascript:;\" aria-label=\"Previous\" @click=\"toPage(currentPage-1)\" _v-e96b488e=\"\">\n                    <span aria-hidden=\"true\" _v-e96b488e=\"\">«</span>\n                </a>\n            </li>\n            <li v-for=\"page in startSide\" :class=\"page===0?'disabled':''\" _v-e96b488e=\"\">\n                <a href=\"javascript:;\" @click=\"toPage(page)\" _v-e96b488e=\"\">\n                    <span v-if=\"page===0\" _v-e96b488e=\"\">...</span>\n                    <span v-else=\"\" _v-e96b488e=\"\">{{page}}</span>\n                </a>\n            </li>\n            <li class=\"active\" _v-e96b488e=\"\">\n                <a href=\"javascript:;\" @click=\"toPage(currentPage)\" _v-e96b488e=\"\">\n                    <span _v-e96b488e=\"\">{{currentPage}}</span>\n                </a>\n            </li>\n            <li v-for=\"page in endSide\" :class=\"page===0?'disabled':''\" _v-e96b488e=\"\">\n                <a href=\"javascript:;\" @click=\"toPage(page)\" _v-e96b488e=\"\">\n                    <span v-if=\"page===0\" _v-e96b488e=\"\">...</span>\n                    <span v-else=\"\" _v-e96b488e=\"\">{{page}}</span>\n                </a>\n            </li>\n            <li :class=\"[currentPage==pageMeta.lastPage?'disabled':'']\" _v-e96b488e=\"\">\n                <a href=\"javascript:;\" aria-label=\"Next\" @click=\"toPage(currentPage+1)\" _v-e96b488e=\"\">\n                    <span aria-hidden=\"true\" _v-e96b488e=\"\">»</span>\n                </a>\n            </li>\n        </ul>\n        <div class=\"m-bottom-30\" _v-e96b488e=\"\">\n            顯示 {{((currentPage-1)*pageMeta.perPage)+1}} 筆到 {{currentPage==pageMeta.lastPage?pageMeta.total:currentPage*pageMeta.perPage}} 筆 總共 {{pageMeta.total}} 筆\n        </div>\n    </nav>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.pagination > li > a[_v-e96b488e]:focus {\n  background-color: inherit;\n  border-color: #ddd; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-e96b488e", module.exports)
  } else {
    hotAPI.update("_v-e96b488e", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/object/keys":56,"babel-runtime/helpers/extends":66,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1546:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['type'],
    data: function data() {
        return {
            hours: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'],
            minutes: ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'],
            startTime: {
                time: ''
            },
            endTime: {
                time: ''
            },
            startHour: '00',
            startMinute: '00',
            endHour: '00',
            endMinute: '00',
            neverEnd: false,
            option: {
                type: 'day',
                week: ['一', '二', '三', '四', '五', '六', '日'],
                month: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
                format: 'YYYY-MM-DD',
                placeholder: '',
                inputStyle: {
                    'display': 'inline-block',
                    'padding': '2px',
                    'font-size': '13px',
                    'color': '#5F5F5F'
                },
                color: {
                    header: '#38b0e3',
                    headerText: '#ffffff'
                },
                buttons: {
                    ok: '確定',
                    cancel: '取消'
                },
                overlayOpacity: 0.5, // 0.5 as default
                dismissible: true // as true as default
            }
        };
    },

    computed: {},
    methods: {
        refreshDate: function refreshDate(date, type) {
            if (type === 1) {
                this.$emit('startdate', date);
            } else {
                this.$emit('enddate', date);
            }
        },
        refreshHour: function refreshHour(hour, type) {
            if (type === 1) {
                this.$emit('starthour', hour);
            } else {
                this.$emit('endhour', hour);
            }
        },
        refreshMinute: function refreshMinute(minute, type) {
            if (type === 1) {
                this.$emit('startminute', minute);
            } else {
                this.$emit('endminute', minute);
            }
        },
        setStartDate: function setStartDate(date) {
            this.startTime.time = date;
        },
        setStartHour: function setStartHour(hour) {
            this.startHour = hour;
        },
        setStartMinute: function setStartMinute(minute) {
            this.startMinute = minute;
        },
        setEndDate: function setEndDate(date) {
            this.endTime.time = date;
        },
        setEndHour: function setEndHour(hour) {
            this.endHour = hour;
        },
        setEndMinute: function setEndMinute(minute) {
            this.endMinute = minute;
        },
        setNeverEnd: function setNeverEnd(value) {
            this.neverEnd = value;
        }
    },
    watch: {
        startTime: {
            handler: function handler(newValue, oldValue) {
                this.refreshDate(newValue.time, 1);
            },

            immediate: true,
            deep: true
        },
        endTime: {
            handler: function handler(newValue, oldValue) {
                this.refreshDate(newValue.time, 2);
            },

            immediate: true,
            deep: true
        },
        startHour: {
            handler: function handler(newValue, oldValue) {
                this.refreshHour(newValue, 1);
            },

            immediate: true
        },
        endHour: {
            handler: function handler(newValue, oldValue) {
                this.refreshHour(newValue, 2);
            },

            immediate: true
        },
        startMinute: {
            handler: function handler(newValue, oldValue) {
                this.refreshMinute(newValue, 1);
            },

            immediate: true
        },
        endMinute: {
            handler: function handler(newValue, oldValue) {
                this.refreshMinute(newValue, 2);
            },

            immediate: true
        },
        neverEnd: {
            handler: function handler(newValue, oldValue) {
                if (this.neverEnd === true) {
                    this.setEndDate('');
                    this.setEndHour('00');
                    this.setEndMinute('00');
                }
            },

            immediate: true
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-2c14e02b=\"\">\n    <div class=\"clearfix\" _v-2c14e02b=\"\">\n        <label class=\"p-top-5 require\" for=\"start_date\" _v-2c14e02b=\"\">開始時間: </label>\n        <span _v-2c14e02b=\"\">\n            <datepicker :date=\"startTime\" :option=\"option\" _v-2c14e02b=\"\"></datepicker>\n        </span>\n        <span v-if=\"type==='datetime'\" _v-2c14e02b=\"\">\n            <select v-model=\"startHour\" _v-2c14e02b=\"\">\n                <option v-for=\"hour in hours\" :value=\"hour\" _v-2c14e02b=\"\">{{hour}}</option>\n            </select>\n        </span>\n        <span v-if=\"type==='datetime'\" _v-2c14e02b=\"\">\n            <select v-model=\"startMinute\" _v-2c14e02b=\"\">\n                <option v-for=\"minute in minutes\" :value=\"minute\" _v-2c14e02b=\"\">{{minute}}</option>\n            </select>\n        </span>\n    </div>\n    <div class=\"clearfix\" _v-2c14e02b=\"\">\n        <label class=\"p-top-5 require\" for=\"end_date\" _v-2c14e02b=\"\">結束時間: </label>\n        <span _v-2c14e02b=\"\">\n            <datepicker :disabled=\"neverEnd\" :date=\"endTime\" :option=\"option\" _v-2c14e02b=\"\"></datepicker>     \n        </span>\n        <span v-if=\"type==='datetime'\" _v-2c14e02b=\"\">\n            <select :disabled=\"neverEnd\" v-model=\"endHour\" _v-2c14e02b=\"\">\n                <option v-for=\"hour in hours\" :value=\"hour\" _v-2c14e02b=\"\">{{hour}}</option>\n            </select>\n        </span>\n        <span v-if=\"type==='datetime'\" _v-2c14e02b=\"\">\n            <select :disabled=\"neverEnd\" v-model=\"endMinute\" _v-2c14e02b=\"\">\n                <option v-for=\"minute in minutes\" :value=\"minute\" _v-2c14e02b=\"\">{{minute}}</option>\n            </select>\n        </span>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-2c14e02b", module.exports)
  } else {
    hotAPI.update("_v-2c14e02b", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1547:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.categories[_v-6d895b0e] {\n  margin-top: 10px;\n  margin-left: 15px; }\n\n/* line 7, stdin */\n.list[_v-6d895b0e] {\n  margin: 10px 15px; }\n\n/* line 11, stdin */\n.item-name[_v-6d895b0e] {\n  font-size: 16px; }\n\n/* line 15, stdin */\n.well[_v-6d895b0e] {\n  margin-top: 10px;\n  margin-right: 15px;\n  background: #f7f7f7;\n  border: 1px solid #c5c5c5; }\n\n/* line 21, stdin */\n.btn-default.btn--inverse[_v-6d895b0e]:hover {\n  background: #38b0e3;\n  color: white;\n  border-color: #38b0e3;\n  -webkit-box-shadow: inset 0px 0px 0px 2px #38b0e3;\n  -moz-box-shadow: inset 0px 0px 0px 2px #38b0e3;\n  box-shadow: inset 0px 0px 0px 2px #38b0e3; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	data: function data() {
		return {
			selectCategory: 'sale'
		};
	},

	props: {
		categories: {
			type: Object,
			required: true
		},
		list: {
			type: Object,
			required: true
		}
	},
	methods: {
		changeSelect: function changeSelect(type) {
			this.selectCategory = type;
		}
	}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"row\" _v-6d895b0e=\"\">\n\t<div class=\"col-sm-3\" _v-6d895b0e=\"\">\n\t\t<div class=\"row categories\" v-for=\"category in categories\" _v-6d895b0e=\"\">\n\t\t\t<div class=\"col-xs-12\" _v-6d895b0e=\"\">\n\t\t\t\t<div class=\"btn btn-lg btn-block\" v-bind:class=\"{ \n\t\t\t\t\t\t'btn--primary': selectCategory==category.type, \n\t\t\t\t\t\t'btn-default': selectCategory!=category.type,\n\t\t\t\t\t\t'btn--inverse': selectCategory!=category.type,\n\t\t\t\t\t}\" @click=\"changeSelect(category.type)\" _v-6d895b0e=\"\">\n\t\t\t\t\t{{category.name}}\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\t<div class=\"col-sm-9\" _v-6d895b0e=\"\">\n\t\t<div class=\"well\" v-if=\"list[selectCategory]\" _v-6d895b0e=\"\">\n\t\t\t<div class=\"row list\" v-for=\"item in list[selectCategory]\" _v-6d895b0e=\"\">\n\t\t\t\t<div class=\"col-xs-9\" _v-6d895b0e=\"\">\n\t\t\t\t\t<span class=\"item-name\" _v-6d895b0e=\"\">{{item.name}}</span>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-xs-3\" _v-6d895b0e=\"\">\n\t\t\t\t\t<a class=\"btn btn-primary btn-block\" v-bind:href=\"item.clickUrl\" _v-6d895b0e=\"\">{{item.clickWord}}</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.categories[_v-6d895b0e] {\n  margin-top: 10px;\n  margin-left: 15px; }\n\n/* line 7, stdin */\n.list[_v-6d895b0e] {\n  margin: 10px 15px; }\n\n/* line 11, stdin */\n.item-name[_v-6d895b0e] {\n  font-size: 16px; }\n\n/* line 15, stdin */\n.well[_v-6d895b0e] {\n  margin-top: 10px;\n  margin-right: 15px;\n  background: #f7f7f7;\n  border: 1px solid #c5c5c5; }\n\n/* line 21, stdin */\n.btn-default.btn--inverse[_v-6d895b0e]:hover {\n  background: #38b0e3;\n  color: white;\n  border-color: #38b0e3;\n  -webkit-box-shadow: inset 0px 0px 0px 2px #38b0e3;\n  -moz-box-shadow: inset 0px 0px 0px 2px #38b0e3;\n  box-shadow: inset 0px 0px 0px 2px #38b0e3; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-6d895b0e", module.exports)
  } else {
    hotAPI.update("_v-6d895b0e", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1548:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.t-c[_v-9213f484] {\n  text-align: center; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	props: ['ajaxing', 'length', 'heads']
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-9213f484=\"\">\n\t<template v-if=\"ajaxing\">\n\t\t<v-spinner :ajaxing=\"ajaxing\" _v-9213f484=\"\"></v-spinner>\n\t</template>\n\t<template v-else-if=\"!length\">\n\t\t<div class=\"t-c\" _v-9213f484=\"\">\n\t\t\t沒有資料\n\t\t</div>\n\t</template>\n\t<template v-else=\"\">\n\t\t<div class=\"table-responsive\" _v-9213f484=\"\">\n\t\t\t<slot _v-9213f484=\"\"></slot>\n\t\t</div>\n\t</template>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.t-c[_v-9213f484] {\n  text-align: center; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-9213f484", module.exports)
  } else {
    hotAPI.update("_v-9213f484", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1549:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.list-row[_v-3e180ab2] {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  width: 100%; }\n\n/* line 7, stdin */\n.header-hr[_v-3e180ab2] {\n  border-top: 3px solid #eee; }\n\n/* line 10, stdin */\n.row-hr[_v-3e180ab2]:last-child {\n  display: none; }\n\n/* line 13, stdin */\n.two-list[_v-3e180ab2] {\n  margin-bottom: 2em; }\n\n/* line 16, stdin */\n.clickable[_v-3e180ab2] {\n  cursor: pointer; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vuex = require('vuex');

exports.default = {
    props: {
        title: {
            type: String,
            default: ''
        },
        list: {
            type: Array,
            default: []
        },
        enableClick: {
            default: false
        }
    },
    computed: {
        listNumber: function listNumber() {
            return this.list.length;
        }
    },
    methods: {
        emitClick: function emitClick(id) {
            if (!this.enableClick || !id) {
                return;
            }

            this.$emit('click', { 'id': id });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"two-list\" _v-3e180ab2=\"\">\n    <div _v-3e180ab2=\"\">\n         <div class=\"list-row\" _v-3e180ab2=\"\">\n            <div _v-3e180ab2=\"\">\n                <h4 _v-3e180ab2=\"\">{{title}}({{listNumber}})</h4>\n            </div>\n            <div _v-3e180ab2=\"\">\n                <slot name=\"right-button\" _v-3e180ab2=\"\"></slot>\n            </div>\n        </div>\n    </div>\n    <div _v-3e180ab2=\"\">\n        <hr class=\"header-hr\" _v-3e180ab2=\"\">\n    </div>\n    <template v-for=\"data in list\">\n        <div class=\"list-row\" :class=\"{'clickable':enableClick}\" @click=\"emitClick(data.id)\" _v-3e180ab2=\"\">\n            <div _v-3e180ab2=\"\">{{ data.left }}</div>\n            <div _v-3e180ab2=\"\">{{ data.right }}</div>\n        </div>\n        <div class=\"row-hr\" _v-3e180ab2=\"\">\n            <hr _v-3e180ab2=\"\">\n        </div>\n    </template>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.list-row[_v-3e180ab2] {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  width: 100%; }\n\n/* line 7, stdin */\n.header-hr[_v-3e180ab2] {\n  border-top: 3px solid #eee; }\n\n/* line 10, stdin */\n.row-hr[_v-3e180ab2]:last-child {\n  display: none; }\n\n/* line 13, stdin */\n.two-list[_v-3e180ab2] {\n  margin-bottom: 2em; }\n\n/* line 16, stdin */\n.clickable[_v-3e180ab2] {\n  cursor: pointer; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-3e180ab2", module.exports)
  } else {
    hotAPI.update("_v-3e180ab2", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1550:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.trainer-select[_v-59a4c092] {\n  min-width: 150px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	props: {
		studioId: {
			default: 0
		},
		branchId: {
			default: 0
		},
		minWidth: {
			default: '150px'
		},
		forceFetch: {
			default: 0
		},
		resetAfter: {
			default: false
		},
		searchable: {
			default: false
		},
		defaultTrainerRoleId: {
			default: 0
		}
	},
	data: function data() {
		return {
			selectTrainer: null,
			selectTrainers: [],
			view: {
				ajaxing: false
			}
		};
	},

	computed: {},
	methods: {
		getTrainers: function getTrainers() {
			var _this = this;

			this.view.ajaxing = true;
			this.$http.post('/webadmin/trainer/get_trainer', {
				'studio_id': this.studioId,
				'branch_id': this.branchId
			}).then(function (response) {
				_this.view.ajaxing = false;
				_this.selectTrainers = response.data.data;
				_this.setDefaultTrainer();
			}, function (error) {
				_this.view.ajaxing = false;
			});
		},
		reset: function reset() {
			this.selectTrainer = null;
			this.selectTrainers = [];
		},
		setDefaultTrainer: function setDefaultTrainer() {
			var _this2 = this;

			if (this.selectTrainers.length == 0 || this.defaultTrainerRoleId == 0) return;
			this.selectTrainer = this.selectTrainers.find(function (trainer) {
				return trainer.role_relationship_id == _this2.defaultTrainerRoleId;
			});
		}
	},
	watch: {
		selectTrainer: function selectTrainer(newVal) {
			if (newVal == null) {
				return;
			}
			this.$emit('trainer-select', newVal);
		},
		studioId: function studioId(newVal) {
			this.getTrainers();
		},
		branchId: function branchId(newVal) {
			this.reset();
			this.getTrainers();
		},
		defaultTrainerRoleId: function defaultTrainerRoleId(newVal) {
			this.setDefaultTrainer();
		}
	},
	mounted: function mounted() {
		if (this.forceFetch === 1) {
			this.getTrainers();
		}
	}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"trainer-select\" _v-59a4c092=\"\"> \n\t<v-spinner-button :ajaxing=\"view.ajaxing\" fa-size=\"fa-2x\" _v-59a4c092=\"\"></v-spinner-button>\n\t<v-mutiselect :model.sync=\"selectTrainer\" :options=\"selectTrainers\" :multiple=\"false\" :close-on-select=\"true\" :searchable=\"true\" :show-labels=\"false\" label=\"name\" track-by=\"id\" tag-name=\"name\" placeholder=\"選擇服務提供者\" v-show=\"!view.ajaxing\" :reset-after=\"resetAfter\" _v-59a4c092=\"\"> \n\t</v-mutiselect>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.trainer-select[_v-59a4c092] {\n  min-width: 150px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-59a4c092", module.exports)
  } else {
    hotAPI.update("_v-59a4c092", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1551:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vueJsToggleButton = require('vue-js-toggle-button');

exports.default = {
    components: {
        ToggleButton: _vueJsToggleButton.ToggleButton
    },
    props: {
        value: {
            default: 1 // 1=開啟,0=關閉
        },
        trueValue: {
            default: 1
        },
        falseValue: {
            default: 0
        },
        id: {
            type: String,
            default: 'vue-switch'
        },
        onText: {
            type: String,
            default: '開啟'
        },
        offText: {
            type: String,
            default: '關閉'
        },
        disabled: {
            default: false
        },
        fontSize: {
            type: Number,
            default: 16
        }
    },
    data: function data() {
        return {
            switchColor: {
                checked: '#fff',
                unchecked: '#fff'
            },
            color: {
                checked: '#5bc0de',
                unchecked: '#aaa',
                disabled: '#CCCCCC'
            },
            sync: true
        };
    },

    computed: {
        labels: function labels() {
            return {
                checked: this.onText,
                unchecked: this.offText
            };
        },
        buttonValue: function buttonValue() {
            return this.value ? true : false;
        },
        width: function width() {
            return (this.onText.length + 4) * this.fontSize;
        },
        height: function height() {
            return this.fontSize * 2;
        }
    },
    methods: {
        onChangeEventHandler: function onChangeEventHandler(data) {
            if (data.value) {
                this.$emit('input', this.trueValue);
            } else {
                this.$emit('input', this.falseValue);
            }
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<toggle-button :value=\"buttonValue\" @change=\"onChangeEventHandler\" :color=\"color\" :switch-color=\"switchColor\" :labels=\"labels\" :disabled=\"disabled\" :sync=\"true\" :width=\"width\" :height=\"height\" :font-size=\"fontSize\">\n</toggle-button>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-029bcb1b", module.exports)
  } else {
    hotAPI.update("_v-029bcb1b", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vue-js-toggle-button":786}],1552:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _vAdminOperateRecord = require('./v-admin-operate-record.vue');

var _vAdminOperateRecord2 = _interopRequireDefault(_vAdminOperateRecord);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('v-admin-operate-record', _vAdminOperateRecord2.default);

},{"./v-admin-operate-record.vue":1553,"vue":792}],1553:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.row[_v-2a84c518] {\n  margin-bottom: 12px; }\n\n/* line 5, stdin */\n.content[_v-2a84c518] {\n  margin: 30px 45px; }\n\n/* line 8, stdin */\n.tippy-name[_v-2a84c518] {\n  font-weight: 700;\n  color: #455A72; }\n\n/* line 12, stdin */\n.tippy-value[_v-2a84c518] {\n  font-weight: 400;\n  margin-left: 10px; }\n\n/* line 16, stdin */\nhr[_v-2a84c518] {\n  margin-top: 12px;\n  margin-bottom: 12px; }\n  /* line 19, stdin */\n  hr [_v-2a84c518]:last-child {\n    display: none; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _tippy = require('tippy.js');

var _tippy2 = _interopRequireDefault(_tippy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        type: {
            type: String,
            default: null
        },
        id: {
            default: null
        },
        additions: {
            default: function _default() {
                return [];
            }
        },
        btnClass: {
            default: 'btn btn-default btn-xs'
        },
        defaultData: {
            type: [Array, Object],
            default: function _default() {
                return [];
            }
        }
    },
    data: function data() {
        return {
            content: 'Loading...',
            data: {}
        };
    },

    watch: {
        id: function id(newVal) {}
    },
    mounted: function mounted() {},

    methods: {
        initDate: function initDate(instance) {
            var _this = this;

            if ((0, _keys2.default)(this.defaultData).length) {
                this.data = this.defaultData;
                this.$nextTick(function () {
                    var template = _this.$el.getElementsByClassName('tippy')[0];
                    instance.setProps({
                        content: template.innerHTML
                    });
                });
            } else {
                return this.$http.get("/adminapi/admin-operate/record", {
                    params: {
                        type: this.type,
                        id: this.id,
                        additions: this.additions
                    }
                }).then(function (response) {
                    _this.data = response.data;
                    var template = _this.$el.getElementsByClassName('tippy')[0];
                    return template;
                }).then(function (template) {
                    instance.setProps({
                        content: template.innerHTML
                    });
                });
            }
        },
        showTippy: function showTippy(e) {
            var vm = this;
            var tooltip = (0, _tippy2.default)(e.target, {
                content: this.content,
                duration: 0,
                arrow: false,
                placement: 'right',
                theme: 'light-border',
                interactive: false,
                allowHTML: true,
                trigger: 'click',
                maxWidth: 'none',
                onShow: function onShow(instance) {
                    vm.initDate(instance);
                },
                onShown: function onShown(instance, event) {
                    instance.setProps({
                        interactive: true
                    });
                },
                onHidden: function onHidden(instance) {
                    instance.setProps({
                        content: this.content
                    });
                    instance.destroy();
                }
            });
            tooltip.show();
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<span _v-2a84c518=\"\">\n  <span class=\"text-center m-top-5\" _v-2a84c518=\"\">\n    <a target=\"_blank\" :class=\"btnClass\" @click.stop.prevent=\"showTippy($event)\" help=\"異動記錄\" _v-2a84c518=\"\">\n      <i class=\"fa fa-history\" aria-hidden=\"true\" _v-2a84c518=\"\"></i>\n    </a>\n  </span>\n  <div class=\"tippy\" style=\"display:none\" _v-2a84c518=\"\">\n    <div class=\"content\" _v-2a84c518=\"\">\n      <template v-for=\"(item,key) in data\">\n        <div class=\"row\" _v-2a84c518=\"\">\n          <div class=\"col-xs-12\" _v-2a84c518=\"\">\n            <span class=\"tippy-name\" _v-2a84c518=\"\">{{ item.name}}</span>\n            <span class=\"tippy-value\" _v-2a84c518=\"\">{{ item.value}}</span>\n          </div>\n        </div>\n        <div class=\"row\" v-if=\"item.need_hr &amp;&amp; key != (Object.keys(data).length)\" _v-2a84c518=\"\">\n          <div class=\"col-xs-12\" _v-2a84c518=\"\">\n            <hr _v-2a84c518=\"\">\n          </div>\n        </div>\n      </template>\n    </div>\n  </div>\n</span>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.row[_v-2a84c518] {\n  margin-bottom: 12px; }\n\n/* line 5, stdin */\n.content[_v-2a84c518] {\n  margin: 30px 45px; }\n\n/* line 8, stdin */\n.tippy-name[_v-2a84c518] {\n  font-weight: 700;\n  color: #455A72; }\n\n/* line 12, stdin */\n.tippy-value[_v-2a84c518] {\n  font-weight: 400;\n  margin-left: 10px; }\n\n/* line 16, stdin */\nhr[_v-2a84c518] {\n  margin-top: 12px;\n  margin-bottom: 12px; }\n  /* line 19, stdin */\n  hr [_v-2a84c518]:last-child {\n    display: none; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-2a84c518", module.exports)
  } else {
    hotAPI.update("_v-2a84c518", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/object/keys":56,"tippy.js":780,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1554:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _vBaseTable = require('./v-base-table.vue');

var _vBaseTable2 = _interopRequireDefault(_vBaseTable);

var _vSmartTable = require('./v-smart-table.vue');

var _vSmartTable2 = _interopRequireDefault(_vSmartTable);

var _vSmartButton = require('./v-smart-button.vue');

var _vSmartButton2 = _interopRequireDefault(_vSmartButton);

var _vSmartTableSummary = require('./v-smart-table-summary.vue');

var _vSmartTableSummary2 = _interopRequireDefault(_vSmartTableSummary);

var _vSmartCheck = require('./v-smart-check.vue');

var _vSmartCheck2 = _interopRequireDefault(_vSmartCheck);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('v-base-table', _vBaseTable2.default);
_vue2.default.component('v-smart-table', _vSmartTable2.default);
_vue2.default.component('v-smart-button', _vSmartButton2.default);
_vue2.default.component('v-smart-table-summary', _vSmartTableSummary2.default);
_vue2.default.component('v-smart-check', _vSmartCheck2.default);

},{"./v-base-table.vue":1556,"./v-smart-button.vue":1557,"./v-smart-check.vue":1558,"./v-smart-table-summary.vue":1559,"./v-smart-table.vue":1560,"vue":792}],1555:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

exports.tableConfigValidation = tableConfigValidation;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var tableConfig = {
    'xScrolling': [{ params: 'defaultColMaxWidth', type: 'string', required: true }, { params: 'defaultColMinWidth', type: 'string', required: true }, { params: 'enable', type: 'boolean', required: true }, { params: 'fixLeftCols', type: 'array', required: false }, { params: 'fixRightCols', type: 'array', required: false }],
    'yScrolling': [{ params: 'defaultRowMaxHeight', type: 'string', required: true }, { params: 'defaultRowMinHeight', type: 'string', required: true }, { params: 'enable', type: 'boolean', required: true }, { params: 'fixTopRows', type: 'array', required: false }, { params: 'fixBottomRows', type: 'array', required: false }]
};

function tableConfigValidation(attr, config) {
    var validation = [];
    tableConfig[attr].forEach(function (item) {
        if (config[attr].hasOwnProperty(item.params)) {
            if (!checkParamsIsValidType(item.type, config[attr][item.params])) {
                validation.push('Type error: ' + attr + '.' + item.params + ' should be ' + item.type + '.');
            }
        } else {
            if (item.required) {
                validation.push('Missing params: ' + attr + '.' + item.params + ' is required.');
            }
        }
    });

    if (validation.length > 0) {
        console.error(validation);
        return false;
    }
    return true;
}

function checkParamsIsValidType(type, params) {
    if (params === null) {
        return false;
    }
    if (params === undefined) {
        return false;
    }
    if (type == 'array') {
        return Array.isArray(params);
    }
    return (typeof params === 'undefined' ? 'undefined' : (0, _typeof3.default)(params)) == type;
}

},{"babel-runtime/helpers/typeof":72}],1556:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("\n#v-base-table th, #v-base-table td {\n    vertical-align: middle;\n    padding: 0 10px;\n    border-bottom: solid 1px #E5E7EB;\n}\n#v-base-table .body-row.main-row:hover td {\n    background-color: #f5f5f5 !important;\n}\n.smart-table-paginate nav{\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n    -ms-flex-pack: justify;\n        justify-content: space-between;\n    -ms-flex-direction: row-reverse;\n        flex-direction: row-reverse;\n}\n.smart-table-paginate nav div{\n    margin: 0;\n}\n@media screen and (max-width: 767px) {\n    .smart-table-paginate nav{\n        -ms-flex-direction: column;\n            flex-direction: column;\n    }\n}\n\n/* line 2, stdin */\n#v-base-table[_v-4191909b] {\n  display: block;\n  width: 100%;\n  border: solid 1px #E5E7EB;\n  border-bottom: none;\n  border-radius: 4px;\n  overflow-x: auto; }\n  /* line 9, stdin */\n  #v-base-table .table[_v-4191909b] {\n    display: table;\n    margin: 0; }\n    /* line 12, stdin */\n    #v-base-table .table .thead[_v-4191909b] {\n      background: #F9FAFB;\n      height: 40px;\n      color: #6B7280; }\n    /* line 17, stdin */\n    #v-base-table .table .sticky-table-head[_v-4191909b] {\n      position: -webkit-sticky;\n      position: sticky;\n      top: 0;\n      z-index: 100; }\n    /* line 22, stdin */\n    #v-base-table .table .body-row[_v-4191909b] {\n      height: 50px; }\n      /* line 24, stdin */\n      #v-base-table .table .body-row.pointer[_v-4191909b] {\n        cursor: pointer; }\n    /* line 28, stdin */\n    #v-base-table .table .table-row[_v-4191909b] {\n      display: table-row;\n      background-color: white; }\n    /* line 32, stdin */\n    #v-base-table .table .table-cell[_v-4191909b] {\n      display: table-cell; }\n    /* line 35, stdin */\n    #v-base-table .table .sticky-position[_v-4191909b] {\n      position: -webkit-sticky;\n      position: sticky; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        ajaxing: {
            type: Boolean,
            default: false
        },
        data: {
            type: Array,
            description: 'Table data'
        },
        pageMeta: {},
        pageSyncUrlQuery: {
            type: Boolean,
            default: true
        },
        enableRowClick: {
            type: Boolean,
            default: false
        },
        theadClasses: {
            type: String,
            default: '',
            description: 'css classes'
        },
        tbodyClasses: {
            type: String,
            default: '',
            description: 'css classes'
        },
        tsubRowClasses: {
            type: String,
            default: '',
            description: 'css classes'
        },
        subRowStyle: {
            type: Function,
            default: function _default() {},
            description: 'function given row_data and row_idx, should return style object'
        },
        subRowDisplayConfig: {
            type: Object,
            default: {
                enable: false,
                defaultLoad: false,
                showByIdx: {}
            }
        },
        tableScrollSetting: {
            type: Object
        },
        emptyDataText: {
            type: String,
            default: '暫無內容'
        }
    },
    data: function data() {
        return {
            mainRowStyleList: {}
        };
    },

    watch: {},
    computed: {
        setting: function setting() {
            var _this = this;

            var vm = this;
            return function (item) {
                if (_this.enableRowClick) {
                    return { click: function click($event) {
                            vm.clickRow(item, $event);
                        } };
                } else {
                    return {};
                }
            };
        },
        noData: function noData() {
            return this.data.length <= 0;
        },
        isEnableSubRow: function isEnableSubRow() {
            return this.subRowDisplayConfig.enable || false;
        },
        tableStyle: function tableStyle() {
            return {
                'max-height': this.tableScrollSetting.tableMaxHeight || ''
            };
        },
        headerClass: function headerClass() {
            var classStr = this.theadClasses;
            var stickyHeader = this.tableScrollSetting.fixTopHeadRow || false;
            if (stickyHeader) {
                classStr = classStr + ' sticky-table-head';
            };
            return classStr;
        },
        bodyClass: function bodyClass() {
            var classStr = this.tbodyClasses;
            if (this.enableRowClick) {
                classStr = classStr + ' pointer';
            };
            return classStr;
        },
        subRowClass: function subRowClass() {
            return this.tsubRowClasses;
        }
    },
    mounted: function mounted() {},

    methods: {
        clickRow: function clickRow(data, event) {
            this.$emit('click-row', { row: data, target: event.target.closest(".table-row") });
        },
        pageChangeCallback: function pageChangeCallback(page) {
            this.$emit('change-page', page);
        },
        mainRowStyleGenerator: function mainRowStyleGenerator(row_data, row_idx) {
            return this.mainRowStyleList[row_idx] || {};
        },
        subRowStyleGenerator: function subRowStyleGenerator(row_data, row_idx) {
            return this.subRowStyle(row_data, row_idx);
        },
        isShowSubRow: function isShowSubRow(row_idx) {
            var rowShowSet = this.subRowDisplayConfig.showByIdx || {};
            return rowShowSet.hasOwnProperty(row_idx) ? rowShowSet[row_idx] : false;
        },
        generateRowSticky: function generateRowSticky() {
            var _this2 = this;

            var fixTopRows = this.tableScrollSetting.yScrolling.fixTopRows || [];
            var fixBottomRows = this.tableScrollSetting.yScrolling.fixBottomRows || [];
            var dataLength = this.data.length;
            var headerHeight = $(this.$el).find('.thead').height();
            var topOffset = this.tableScrollSetting.fixTopHeadRow ? headerHeight : 0;
            var bottomOffset = 0;

            fixTopRows.forEach(function (el, index) {
                var rowIndex = el >= 0 ? el : dataLength + el;
                _this2.mainRowStyleList[rowIndex] = {
                    position: 'sticky',
                    top: Number(topOffset) + 'px',
                    'z-index': 100 - Number(index)
                };
                topOffset += $(_this2.$el).find('.main-row[data-row-idx=' + rowIndex + ']').height();
            });
            fixBottomRows.forEach(function (el, index) {
                var rowIndex = el >= 0 ? el : dataLength + el;
                _this2.mainRowStyleList[rowIndex] = {
                    position: 'sticky',
                    bottom: Number(bottomOffset) + 'px',
                    'z-index': 100 - Number(index)
                };
                bottomOffset += $(_this2.$el).find('.main-row[data-row-idx=' + rowIndex + ']').height();
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-4191909b=\"\">\n    <v-spinner :ajaxing=\"ajaxing\" _v-4191909b=\"\"></v-spinner>\n    <div v-show=\"!ajaxing\" _v-4191909b=\"\">\n        <div v-if=\"noData\" style=\"text-align: center; padding-top: 50px;\" _v-4191909b=\"\">\n            <img src=\"/images/no-data-img.png\" width=\"105\" height=\"60\" _v-4191909b=\"\">\n            <div style=\"color: #6c6c6c;\" class=\"m-top-10\" _v-4191909b=\"\">{{ emptyDataText }}</div>\n        </div>\n        <div v-else=\"\" _v-4191909b=\"\">\n            <div id=\"v-base-table\" :style=\"tableStyle\" _v-4191909b=\"\">\n                <div class=\"table\" _v-4191909b=\"\">\n                    <div class=\"table-row thead\" :class=\"theadClasses\" v-if=\"$slots['top-th-row']\" _v-4191909b=\"\">\n                        <slot name=\"top-th-row\" _v-4191909b=\"\"></slot>\n                    </div>\n                    <div class=\"table-row thead\" :class=\"headerClass\" _v-4191909b=\"\">\n                        <slot name=\"columns\" _v-4191909b=\"\"></slot>\n                    </div>\n                    <template v-for=\"(item, idx) in data\">\n                       <div class=\"table-row body-row main-row\" :class=\"bodyClass\" :style=\"mainRowStyleGenerator(item, idx)\" :key=\"'trcol-'+idx\" :data-row-idx=\"idx\" v-on=\"setting(item)\" _v-4191909b=\"\">\n                            <slot name=\"main-row\" :row=\"item\" :index=\"idx\" _v-4191909b=\"\"></slot>\n                        </div>\n                        <div class=\"table-row body-row\" :class=\"subRowClass\" :style=\"subRowStyleGenerator(item, idx)\" :key=\"'srcol-'+idx\" :data-row-idx=\"idx\" v-if=\"isEnableSubRow &amp;&amp; isShowSubRow(idx)\" _v-4191909b=\"\">\n                            <slot name=\"sub-row\" :row=\"item\" :index=\"idx\" _v-4191909b=\"\"></slot>\n                        </div>\n                    </template>\n                </div>\n            </div>\n            <div class=\"table-paginate\" v-if=\"pageMeta\" _v-4191909b=\"\">\n                <v-sql-pagination :page-meta=\"pageMeta\" :page-sync-url-query=\"pageSyncUrlQuery\" :css-class=\"'smart-table-paginate'\" @page-change-callback=\"pageChangeCallback\" _v-4191909b=\"\">\n                </v-sql-pagination>\n            </div>            \n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["\n#v-base-table th, #v-base-table td {\n    vertical-align: middle;\n    padding: 0 10px;\n    border-bottom: solid 1px #E5E7EB;\n}\n#v-base-table .body-row.main-row:hover td {\n    background-color: #f5f5f5 !important;\n}\n.smart-table-paginate nav{\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n    -ms-flex-pack: justify;\n        justify-content: space-between;\n    -ms-flex-direction: row-reverse;\n        flex-direction: row-reverse;\n}\n.smart-table-paginate nav div{\n    margin: 0;\n}\n@media screen and (max-width: 767px) {\n    .smart-table-paginate nav{\n        -ms-flex-direction: column;\n            flex-direction: column;\n    }\n}\n\n/* line 2, stdin */\n#v-base-table[_v-4191909b] {\n  display: block;\n  width: 100%;\n  border: solid 1px #E5E7EB;\n  border-bottom: none;\n  border-radius: 4px;\n  overflow-x: auto; }\n  /* line 9, stdin */\n  #v-base-table .table[_v-4191909b] {\n    display: table;\n    margin: 0; }\n    /* line 12, stdin */\n    #v-base-table .table .thead[_v-4191909b] {\n      background: #F9FAFB;\n      height: 40px;\n      color: #6B7280; }\n    /* line 17, stdin */\n    #v-base-table .table .sticky-table-head[_v-4191909b] {\n      position: -webkit-sticky;\n      position: sticky;\n      top: 0;\n      z-index: 100; }\n    /* line 22, stdin */\n    #v-base-table .table .body-row[_v-4191909b] {\n      height: 50px; }\n      /* line 24, stdin */\n      #v-base-table .table .body-row.pointer[_v-4191909b] {\n        cursor: pointer; }\n    /* line 28, stdin */\n    #v-base-table .table .table-row[_v-4191909b] {\n      display: table-row;\n      background-color: white; }\n    /* line 32, stdin */\n    #v-base-table .table .table-cell[_v-4191909b] {\n      display: table-cell; }\n    /* line 35, stdin */\n    #v-base-table .table .sticky-position[_v-4191909b] {\n      position: -webkit-sticky;\n      position: sticky; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-4191909b", module.exports)
  } else {
    hotAPI.update("_v-4191909b", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1557:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: (0, _defineProperty3.default)({
        buttonShow: {
            type: Boolean,
            default: true
        },
        buttonString: {
            type: String,
            default: '點擊'
        },
        clickFunctionEvent: {
            type: Function,
            default: function _default(data) {
                console.log('clickFunction');
            }
        },
        clickData: {
            type: Object,
            default: function _default() {
                return {};
            }
        },
        buttonClass: {
            type: String,
            default: '',
            description: '表格標題欄 css classes'
        },
        buttonCss: {
            type: String,
            default: '',
            description: '表格標題欄 css classes'
        }
    }, 'buttonCss', {
        type: String,
        default: '',
        description: '表格標題欄 css classes'
    }),
    computed: {},
    data: function data() {
        return {};
    },


    methods: {
        clickFunctionAction: function clickFunctionAction() {
            this.clickFunctionEvent(this.clickData);
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div v-if=\"buttonShow\" slot=\"button\" _v-228dd83f=\"\">\n    <a href=\"#\" @click.stop.prevent=\"clickFunctionAction\" :style=\"buttonCss\" :class=\"buttonClass\" _v-228dd83f=\"\">\n    {{buttonString}}\n    </a>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-228dd83f", module.exports)
  } else {
    hotAPI.update("_v-228dd83f", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/defineProperty":65,"vue":792,"vue-hot-reload-api":785}],1558:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        check: {
            type: Boolean | Number,
            default: 0
        },
        change: {
            type: Function,
            default: function _default(data) {
                console.log('click change');
            }
        }
    },
    data: function data() {
        return {
            value: 0
        };
    },
    mounted: function mounted() {
        this.value = this.check;
    },

    watch: {
        check: function check(newVal) {
            this.value = newVal;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div>\n    <input type=\"checkbox\" v-model=\"value\" :true-value=\"1\" :false-value=\"0\" @change=\"change\">\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-6468acea", module.exports)
  } else {
    hotAPI.update("_v-6468acea", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],1559:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.font-bold[_v-2e544aac] {\n  font-weight: 500;\n  font-size: 18px; }\n\n/* line 8, stdin */\n.head[_v-2e544aac] {\n  margin-right: 5px; }\n")
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    colConfig: {
      type: Object,

      required: true
    },

    apiConfig: {
      type: Object
    },

    data: {
      type: Object,

      description: "不使用 apiConfig，直接帶入 table data -> { records: []}"
    },

    isAjaxing: {
      type: Boolean,

      default: false
    }
  },

  computed: {
    isReadyToFetch: function isReadyToFetch() {
      if (this.api) {
        return (0, _keys2.default)(this.api).length > 0;
      }

      return false;
    },
    isLoading: function isLoading() {
      return this.isAjaxing || this.ajaxing;
    }
  },

  data: function data() {
    return {
      ajaxing: false,

      api: {},

      records: {},

      colWidthSetting: {}
    };
  },
  mounted: function mounted() {
    this.updateApiConfig();

    this.fetchRecords();
  },


  watch: {
    colConfig: {
      handler: function handler(newV) {
        if (!_lodash2.default.isEmpty(newV)) {
          this.updateColWidthSetting();
        }
      },

      deep: true,

      immediate: true
    },

    apiConfig: {
      handler: function handler(newVal) {
        if (newVal) {
          this.updateApiConfig();

          this.fetchRecords();
        }
      },

      deep: true
    },

    data: {
      handler: function handler(newVal) {
        if (_lodash2.default.isEmpty(newVal)) {
          this.records = {};
        } else {
          this.records = newVal;
        }
      },

      immediate: true,

      deep: true
    }
  },

  methods: {
    updateColWidthSetting: function updateColWidthSetting() {
      var colsConfig = this.colConfig.columns;

      this.colWidthSetting = colsConfig;
    },
    fetchRecords: function fetchRecords() {
      var _this = this;

      if (!this.isReadyToFetch) return;

      var method = this.api.method ? this.api.method : "get";

      var recordName = this.api.recordName ? this.api.recordName : "records";

      var payload = method == "get" ? { params: this.api.payload } : this.api.payload;

      this.ajaxing = true;

      this.$http[method](this.api.apiurl, payload).then(function (response) {
        _this.records = response.data[recordName];

        _this.$emit("fetch-success-callback", response.data);

        _this.ajaxing = false;
      }, function (error) {
        _this.$emit("fetch-fail-callback", error);

        _this.ajaxing = false;
      });
    },
    updateApiConfig: function updateApiConfig() {
      this.api = _lodash2.default.cloneDeep(this.apiConfig);
    },
    shouldShow: function shouldShow() {
      return _lodash2.default.size(this.records) > 0;
    },
    compiledData: function compiledData(html) {
      return {
        props: {
          rowData: {}
        },
        template: '<span>' + html + '</span>'
      };
    },
    isHTML: function isHTML(item) {
      return typeof item.html != 'undefined';
    }
  }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div v-show=\"shouldShow()\" _v-2e544aac=\"\">\n  <span v-for=\"(column, index) in colConfig.columns\" class=\"font-bold st-mr-6\" _v-2e544aac=\"\">\n    <span class=\"head\" _v-2e544aac=\"\">{{ column.head }}</span>\n    <span class=\"keys\" v-if=\"isHTML(column)\" _v-2e544aac=\"\">\n        <component :is=\"compiledData(column.html(records))\" :row-data=\"records\" _v-2e544aac=\"\"></component>\n    </span>\n    <span v-else=\"\" class=\"keys\" _v-2e544aac=\"\">{{ records[column.keys] }}</span>\n  </span>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.font-bold[_v-2e544aac] {\n  font-weight: 500;\n  font-size: 18px; }\n\n/* line 8, stdin */\n.head[_v-2e544aac] {\n  margin-right: 5px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-2e544aac", module.exports)
  } else {
    hotAPI.update("_v-2e544aac", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/core-js/object/keys":56,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1560:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\nth[_v-3f832d51] {\n  background-color: #F9FAFB; }\n\n/* line 5, stdin */\n.font-bold[_v-3f832d51] {\n  font-weight: 500; }\n\n/* line 8, stdin */\n.st-edit[_v-3f832d51] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: end;\n      justify-content: flex-end;\n  margin-bottom: 5px; }\n  /* line 12, stdin */\n  .st-edit .cog-btn[_v-3f832d51] {\n    color: #5f6368;\n    border: none;\n    border-radius: 50px;\n    padding: 10px 12px; }\n\n/* line 19, stdin */\n.sub-row-wrapper[_v-3f832d51] {\n  padding: 10px !important; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _vuex = require('vuex');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _smtHelper = require('./smt-helper.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        tableConfig: {
            type: Object,
            required: true
        },
        apiConfig: {
            type: Object
        },
        csvConfig: {
            type: Object
        },
        enableRowClick: {
            type: Boolean,
            default: false,
            description: 'if true, click row 透過 @row-click-callback 取得 row data -> { ... }'
        },
        pageSyncUrlQuery: {
            type: Boolean,
            default: true,
            description: 'pagination－current page 是否保存在 url query'
        },
        theadClasses: {
            type: String,
            default: '',
            description: '表格標題欄 css classes'
        },
        tbodyClasses: {
            type: String,
            default: '',
            description: '表格內容欄 css classes'
        },
        tsubRowClasses: {
            type: String,
            default: '',
            description: 'sub-row css classes'
        },
        data: {
            type: Object,
            description: '不使用 apiConfig，直接帶入 table data -> { records: [], pageMeta: {} }'
        },
        isAjaxing: {
            type: Boolean,
            default: false
        },
        emptyDataText: {
            type: String,
            default: '暫無內容'
        }
    },
    computed: {
        isReadyToFetch: function isReadyToFetch() {
            if (this.api) {
                return (0, _keys2.default)(this.api).length > 0;
            };
            return false;
        },

        // showTableSetting() { //Table col show/hidden panel: 此階段先隱藏，待 UI 完整後再補上
        //     if(this.tableConfig.hasOwnProperty('displaySetting')) {
        //         this.tableConfig.displaySetting.forEach(el => {
        //             this.displaySetting[el.keys] = el;
        //         });
        //         return true;
        //     };
        //     return false
        // },
        isLoading: function isLoading() {
            return this.isAjaxing || this.ajaxing;
        },
        isEnableSubRow: function isEnableSubRow() {
            return this.subRowDisplayConfig.enable;
        },
        isEnableColSticky: function isEnableColSticky() {
            return this.defaultSetting.xScrolling.enable && (!_lodash2.default.isEmpty(this.defaultSetting.xScrolling.fixLeftCols) || !_lodash2.default.isEmpty(this.defaultSetting.xScrolling.fixRightCols));
        },
        isEnableRowSticky: function isEnableRowSticky() {
            return this.defaultSetting.yScrolling.enable && (!_lodash2.default.isEmpty(this.defaultSetting.yScrolling.fixTopRows) || !_lodash2.default.isEmpty(this.defaultSetting.yScrolling.fixBottomRows));
        }
    },
    data: function data() {
        return {
            ajaxing: false,
            downloading: false,
            api: {},
            pageMeta: {},
            records: [],
            displaySetting: {},
            csvReport: {},
            headStyleSetting: {},
            cellStyleSetting: {},
            defaultSetting: {
                xScrolling: {
                    defaultColMaxWidth: '20em',
                    defaultColMinWidth: '9em',
                    enable: true,
                    fixLeftCols: [],
                    fixRightCols: []
                },
                yScrolling: {
                    defaultRowMaxHeight: '7em',
                    defaultRowMinHeight: '1.5em',
                    enable: false,
                    fixTopRows: [],
                    fixBottomRows: []
                },
                fixTopHeadRow: false,
                tableMaxHeight: ''
            },
            subRowDisplayConfig: {},
            subComponentData: {},
            // smart-table default view
            mainRowStyleCondition: function mainRowStyleCondition(row_data, row_idx, keys) {
                if (row_idx % 2) {
                    return { 'background-color': '#FAFAFB' };
                } else {
                    return { 'background-color': '#FFFFFF' };
                }
            },
            subRowStyleCondition: function subRowStyleCondition() {}
        };
    },
    mounted: function mounted() {
        this.initTableStyle();
        this.initSubRowDisplay();
        this.updateApiConfig();
        this.fetchRecords();
    },

    watch: {
        'tableConfig': {
            handler: function handler(newV) {
                if (!_lodash2.default.isEmpty(newV)) {
                    this.initStyleSetting();
                }
            },
            deep: true,
            immediate: true
        },
        'apiConfig': {
            handler: function handler(newVal) {
                if (newVal) {
                    this.updateApiConfig();
                    this.fetchRecords();
                }
            },
            deep: true
        },
        'data': {
            handler: function handler(newVal) {
                var _this = this;

                if (_lodash2.default.isEmpty(newVal)) {
                    this.pageMeta = {};
                    this.records = [];
                } else {
                    this.pageMeta = newVal.pageMeta;
                    this.records = newVal.records;
                    this.$nextTick(function () {
                        _this.smartTableUpdated();
                    });
                }
            },
            immediate: true,
            deep: true
        }
    },
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('webadmin/baseReport', ['download', 'csvDataHandler', 'columnFormater']), {
        initTableStyle: function initTableStyle() {
            if (this.tableConfig.hasOwnProperty('mainRowStyleCondition')) {
                this.mainRowStyleCondition = this.tableConfig.mainRowStyleCondition;
            }
            if (this.tableConfig.hasOwnProperty('subRowStyleCondition')) {
                this.subRowStyleCondition = this.tableConfig.subRowStyleCondition;
            }
        },
        initSubRowDisplay: function initSubRowDisplay() {
            var defaultLoad = false;
            var enable = false;
            var defaultComponent = function defaultComponent() {};
            if (this.tableConfig.hasOwnProperty('subRow')) {
                defaultLoad = this.tableConfig.subRow.defaultLoad || false;
                enable = this.tableConfig.subRow.enable || false;
                defaultComponent = this.tableConfig.subRow.defaultComponent || defaultComponent;
            }
            this.subRowDisplayConfig = {
                enable: enable,
                defaultLoad: defaultLoad,
                defaultComponent: defaultComponent,
                showByIdx: {}
            };
        },
        subRowDefaultLoad: function subRowDefaultLoad() {
            var _this2 = this;

            if (this.subRowDisplayConfig.enable && this.subRowDisplayConfig.defaultLoad) {
                this.records.forEach(function (rowData, rowIdx) {
                    _this2.subComponentData[rowIdx] = _this2.subRowDisplayConfig.defaultComponent(rowData);
                    _this2.subRowDisplayConfig.showByIdx[rowIdx] = true;
                });
                this.$forceUpdate();
            }
        },
        dynamicLoadSubRow: function dynamicLoadSubRow(data, payload, rowIdx) {
            var component = this.subRowDisplayConfig.defaultComponent(payload);
            if (data !== '$default') {
                component = data;
            }
            this.subRowDisplayConfig.showByIdx[rowIdx] = true;
            this.subComponentData[rowIdx] = component;
            this.$forceUpdate();
        },
        subRowComponent: function subRowComponent(row_idx) {
            if (!this.isEnableSubRow) return;
            return _lodash2.default.isEmpty(this.subComponentData[row_idx]) ? '' : this.subComponentData[row_idx].component;
        },
        subRowBindingAttr: function subRowBindingAttr(row_idx) {
            if (!this.isEnableSubRow) return;
            return _lodash2.default.isEmpty(this.subComponentData[row_idx]) ? {} : this.subComponentData[row_idx].attrs;
        },
        appendDefaultParams: function appendDefaultParams(payload, rowId) {
            var _this3 = this;

            return (0, _extends3.default)({}, payload, {
                subRow: {
                    isShow: this.subRowDisplayConfig.hasOwnProperty('showByIdx') && this.subRowDisplayConfig.showByIdx[rowId] ? this.subRowDisplayConfig.showByIdx[rowId] : false,
                    auto: function auto(data) {
                        var isShow = _this3.subRowDisplayConfig.showByIdx[rowId] || false;
                        if (isShow) {
                            _this3.subRowDisplayConfig.showByIdx[rowId] = false;
                            _this3.$forceUpdate();
                        } else {
                            _this3.dynamicLoadSubRow(data, payload, rowId);
                        }
                    },
                    load: function load(data) {
                        _this3.dynamicLoadSubRow(data, payload, rowId);
                    },
                    close: function close() {
                        _this3.subRowDisplayConfig.showByIdx[rowId] = false;
                        _this3.$forceUpdate();
                    }
                }
            });
        },
        initStyleSetting: function initStyleSetting() {
            var colsConfig = this.tableConfig.columns;
            if (_lodash2.default.isEmpty(colsConfig)) return;

            if (this.tableConfig.hasOwnProperty('xScrolling')) {
                if (!(0, _smtHelper.tableConfigValidation)('xScrolling', this.tableConfig)) return;
                if (!this.tableConfig.xScrolling.enable) return;
                this.defaultSetting.xScrolling = this.tableConfig.xScrolling;
            }
            if (this.tableConfig.hasOwnProperty('yScrolling')) {
                if (!(0, _smtHelper.tableConfigValidation)('yScrolling', this.tableConfig)) return;
                if (!this.tableConfig.yScrolling.enable) return;
                this.defaultSetting.yScrolling = this.tableConfig.yScrolling;
            }
            this.defaultSetting.fixTopHeadRow = this.tableConfig.fixTopHeadRow || false;
            this.defaultSetting.tableMaxHeight = this.tableConfig.tableMaxHeight || '';

            this.generateTdStyle();
        },
        generateTdStyle: function generateTdStyle() {
            var settings = {};
            var headSetting = {};
            var colsConfig = this.tableConfig.columns;
            var xScrolling = this.defaultSetting.xScrolling;
            var yScrolling = this.defaultSetting.yScrolling;
            colsConfig.forEach(function (item) {
                settings[item.keys] = {};
                headSetting[item.keys] = item.headerStyle || {};
                if (item.colClick) {
                    settings[item.keys]['cursor'] = 'pointer';
                }
                if (xScrolling.enable) {
                    settings[item.keys] = (0, _extends3.default)({}, settings[item.keys], {
                        'min-width': item.minWidth ? item.minWidth : xScrolling.defaultColMinWidth,
                        'max-width': item.maxWidth ? item.maxWidth : xScrolling.defaultColMaxWidth
                    });
                }
                if (yScrolling.enable) {
                    settings[item.keys] = (0, _extends3.default)({}, settings[item.keys], {
                        'min-height': item.minHeight ? item.minHeight : yScrolling.defaultRowMinHeight,
                        'max-height': item.maxHeight ? item.maxHeight : yScrolling.defaultRowMaxHeight
                    });
                }
            });
            this.cellStyleSetting = settings;
            this.headStyleSetting = headSetting;
        },
        tdStyleGenerator: function tdStyleGenerator(rowData, rowIdx) {
            var keys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

            var cellStyle = this.cellStyleSetting[keys];
            var style = this.mainRowStyleCondition(rowData, rowIdx, keys) || {};
            style = (0, _extends3.default)({}, style, cellStyle);
            return style;
        },
        generateColSticky: function generateColSticky() {
            var _this4 = this;

            if (!this.isEnableColSticky) return;
            var fixLeftCols = this.defaultSetting.xScrolling.fixLeftCols || [];
            var fixRightCols = this.defaultSetting.xScrolling.fixRightCols || [];
            var leftOffset = 0;
            var rightOffset = 0;
            fixLeftCols.forEach(function (item, index) {
                _this4.cellStyleSetting[item]['position'] = 'sticky';
                _this4.cellStyleSetting[item]['left'] = Number(leftOffset) + 'px';
                _this4.headStyleSetting[item]['position'] = 'sticky';
                _this4.headStyleSetting[item]['left'] = Number(leftOffset) + 'px';
                leftOffset += $(_this4.$el).find('th[data-key=' + item + ']').width();
            });
            fixRightCols.forEach(function (item, index) {
                _this4.cellStyleSetting[item]['position'] = 'sticky';
                _this4.cellStyleSetting[item]['right'] = Number(rightOffset) + 'px';
                _this4.headStyleSetting[item]['position'] = 'sticky';
                _this4.headStyleSetting[item]['right'] = Number(rightOffset) + 'px';
                rightOffset += $(_this4.$el).find('th[data-key=' + item + ']').width();
            });
        },
        generateRowSticky: function generateRowSticky() {
            if (!this.isEnableRowSticky) return;
            this.$refs.smt_base_table.generateRowSticky();
        },
        smartTableUpdated: function smartTableUpdated() {
            var _this5 = this;

            var isEnableSticky = this.isEnableRowSticky || this.isEnableColSticky;
            var isEnableSubRow = this.subRowDisplayConfig.enable;
            if (isEnableSticky && isEnableSubRow) {
                console.error('Table config error: table sticky & sub row cannot use together!');
                return;
            }
            if (isEnableSubRow) {
                this.initSubRowDisplay();
                this.subRowDefaultLoad();
                return;
            }
            if (isEnableSticky) {
                _promise2.default.all([this.generateColSticky(), this.generateRowSticky()]).then(function () {
                    _this5.$forceUpdate();
                });
            }
        },
        fetchRecords: function fetchRecords() {
            var _this6 = this;

            if (!this.isReadyToFetch) return;
            var method = this.api.method ? this.api.method : 'get';
            var recordName = this.api.recordName ? this.api.recordName : 'records';
            var urlPage = this.getUrlParamValue('page') || 0;
            if (this.pageSyncUrlQuery && urlPage) {
                this.api.payload['page'] = urlPage;
            }
            var payload = method == 'get' ? { params: this.api.payload } : this.api.payload;
            this.ajaxing = true;
            this.$http[method](this.api.apiurl, payload).then(function (response) {
                _this6.pageMeta = response.data.pageMeta;
                _this6.records = response.data[recordName];
                _this6.$nextTick(function () {
                    _this6.smartTableUpdated();
                });
                _this6.$emit('fetch-success-callback', response.data);
                _this6.ajaxing = false;
            }, function (error) {
                _this6.$emit('fetch-fail-callback', error);
                _this6.ajaxing = false;
            });
        },
        changePage: function changePage(page) {
            var toPage = 0;
            if (this.pageSyncUrlQuery) {
                toPage = this.getUrlParamValue('page') ? this.getUrlParamValue('page') : 1;
            } else {
                toPage = page ? page : 1;
            };
            if (this.isReadyToFetch) {
                this.api.payload.page = toPage;
                this.fetchRecords();
            };
            this.$emit('change-page', page);
        },
        updateApiConfig: function updateApiConfig() {
            this.api = _lodash2.default.cloneDeep(this.apiConfig);
        },
        refresh: function refresh() {
            this.fetchRecords();
        },
        showEditModal: function showEditModal() {
            $(this.$refs.smart_table_edit_modal.$el).modal('show');
        },
        colClickHandler: function colClickHandler(colConfig, row) {
            var vm = this;
            if (colConfig.colClick) {
                return { click: function click(event) {
                        event.stopPropagation();
                        event.preventDefault();
                        vm.colCallback(colConfig, row, event);
                    } };
            } else if (colConfig.disabledClick) {
                return { click: function click(event) {
                        event.stopPropagation();
                        event.preventDefault();
                        return false;
                    } };
            } else {
                return {};
            }
        },
        colCallback: function colCallback(colConfig, rowData, event) {
            var payload = {
                row: rowData,
                target: event.target.closest("td")
            };
            var rowId = $(payload.target).closest('.table-row').data('rowIdx');
            payload[colConfig.keys] = rowData[colConfig.keys];
            payload = this.appendDefaultParams(payload, rowId);
            this.$emit('col-click-callback', payload);
        },
        rowCallback: function rowCallback(row) {
            var rowId = $(row.target).data('rowIdx');
            payload = this.appendDefaultParams(row, rowId);
            this.$emit('row-click-callback', payload);
        },
        clickHandler: function clickHandler(event) {
            this.$emit('html-click-callback', event);
        },
        compiledData: function compiledData(html) {
            return {
                props: {
                    rowData: {}
                },

                template: '<div>' + html + '</div>',

                methods: {
                    clickHandler: function clickHandler(event, $event) {
                        this.$emit('click-handler', { action: event, row: this.rowData, mouseEvent: $event });
                    }
                }
            };
        },
        isHTML: function isHTML(item) {
            return typeof item.html != 'undefined';
        },
        isComponent: function isComponent(item) {
            return typeof item.component != 'undefined';
        },
        colShow: function colShow(col) {
            // if(Object.keys(this.displaySetting).length > 0){ //Table col show/hidden panel: 此階段先隱藏，待 UI 完整後再補上
            //     if(this.displaySetting[col.keys]){
            //         return this.displaySetting[col.keys].show == 1 ? true : false;
            //     }
            //     return true;
            // }
            return true;
        },
        downloadCsv: function downloadCsv() {
            var _this7 = this;

            if (this.downloading) {
                $.notify('報表匯出中，請稍候', { className: 'info', globalPosition: 'top center' });
                return;
            }
            this.fetchCsvData().then(function (response) {
                _this7.downloading = false;
                _this7.csvReport = response;
                var fileName = _this7.csvConfig.fileName ? _this7.csvConfig.fileName : 'report';
                var result = _this7.csvDataHandler({ data: _this7.csvReport, columnFormater: _this7.reportColumnFormater }).then(function (result) {
                    _this7.download({ csvString: result, name: fileName });
                });
            });
        },
        fetchCsvData: function fetchCsvData() {
            var vm = this;
            return new _promise2.default(function (resolve) {
                if (vm.csvConfig.hasOwnProperty('api')) {
                    vm.downloading = true;
                    var api = vm.csvConfig.api;
                    var method = api.method ? api.method : 'get';
                    var recordName = api.recordName ? api.recordName : 'records';
                    var _payload = method == 'get' ? { params: api.payload } : api.payload;
                    vm.$http[method](api.apiurl, _payload).then(function (_ref) {
                        var data = _ref.data;
                        return resolve(data[recordName]);
                    });
                } else if (vm.csvConfig.hasOwnProperty('jsonData')) {
                    resolve(vm.csvConfig.jsonData);
                };
            });
        },
        reportColumnFormater: function reportColumnFormater(data) {
            var vm = this;
            var data = _lodash2.default.map(data, function (value) {
                var list = (0, _assign2.default)({}, value);
                var set = [];
                vm.csvConfig.column.forEach(function (item) {
                    set.push(item.keys);
                });
                var columnData = _lodash2.default.pick(list, set);
                return columnData;
            });
            data = (0, _stringify2.default)(data);
            this.csvConfig.column.forEach(function (item) {
                data = data.replaceAll('"' + item.keys + '"', '"' + item.name + '"');
            });
            return data;
        }
    })
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-3f832d51=\"\">\n    <!-- <div class=\"st-edit\" v-if=\"!isLoading && showTableSetting\"> //Table col show/hidden panel: 此階段先隱藏，待 UI 完整後再補上\n        <a class=\"btn btn-default btn-sm cog-btn\" @click.stop=\"showEditModal\"><i class=\"fa fa-cog fa-lg\"></i></a>\n        <v-modal ref=\"smart_table_edit_modal\" open-size=\"modal-sm\" no-footer>\n            <span slot=\"title\">自訂表格</span>\n            <div slot=\"body\" style=\"font-size: 16px;\">\n                <div class=\"row m-bottom-15\">\n                    <div class=\"col-sm-6 text-right font-bold\">欄位名稱</div>\n                    <div class=\"col-sm-6 font-bold\">狀態</div>\n                </div>\n                <div v-for=\"(value, key, idx) in displaySetting\">\n                    <div class=\"row\">\n                        <div class=\"col-sm-6 text-right\">{{ value.name }}</div>\n                        <div class=\"col-sm-6\">\n                            <v-vue-switch v-model=\"value.show\"\n                            on-text=\"顯示\"\n                            off-text=\"隱藏\"\n                            :font-size=\"12\"></v-vue-switch>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </v-modal>\n    </div> -->\n\n    <v-base-table ref=\"smt_base_table\" :page-meta=\"pageMeta\" :page-sync-url-query=\"pageSyncUrlQuery\" :data=\"records\" :ajaxing=\"isLoading\" :thead-classes=\"theadClasses\" :tbody-classes=\"tbodyClasses\" :tsub-row-classes=\"tsubRowClasses\" :main-row-style=\"mainRowStyleCondition\" :sub-row-style=\"subRowStyleCondition\" @change-page=\"changePage\" @click-row=\"rowCallback\" :enable-row-click=\"enableRowClick\" :sub-row-display-config=\"subRowDisplayConfig\" :table-scroll-setting=\"defaultSetting\" :empty-data-text=\"emptyDataText\" _v-3f832d51=\"\">\n        <template slot=\"top-th-row\" v-if=\"tableConfig.topThRow\">\n            <th v-for=\"col in tableConfig.columns\" v-show=\"colShow(col)\" v-html=\"tableConfig.topThRow[col.keys]\" _v-3f832d51=\"\">\n            </th>\n        </template>\n        <template slot=\"columns\">\n            <th v-for=\"col in tableConfig.columns\" v-show=\"colShow(col)\" :data-key=\"col.keys\" :style=\"headStyleSetting[col.keys]\" _v-3f832d51=\"\">\n                {{ col.head }}\n            </th>\n        </template>\n        <template slot=\"main-row\" slot-scope=\"{row, index}\">\n            <td v-for=\"col in tableConfig.columns\" :page-role=\"col.keys\" v-on=\"colClickHandler(col, row)\" v-show=\"colShow(col)\" :style=\"tdStyleGenerator(row, index, col.keys)\" _v-3f832d51=\"\">\n                <div v-if=\"isHTML(col)\" :class=\"col.cssClass\" _v-3f832d51=\"\">\n                    <component :is=\"compiledData(col.html(appendDefaultParams(row, index)))\" :row-data=\"appendDefaultParams(row, index)\" @click-handler=\"clickHandler\" _v-3f832d51=\"\"></component>\n                </div>\n                <div v-else-if=\"isComponent(col)\" :class=\"col.cssClass\" _v-3f832d51=\"\">\n                    <component :is=\"col.component.name\" :row-data=\"appendDefaultParams(row, index)\" v-bind=\" col.component.hasOwnProperty('vBind') ? col.component.vBind(row) : ''\" _v-3f832d51=\"\"></component>\n                </div>\n                <div v-else=\"\" :class=\"col.cssClass\" _v-3f832d51=\"\">\n                    {{row[col.keys]}}\n                </div>\n            </td>\n        </template>\n        <template slot=\"sub-row\" slot-scope=\"{row, index}\">\n            <td :colspan=\"tableConfig.columns.length || 1\" class=\"sub-row-wrapper\" _v-3f832d51=\"\">\n                <div _v-3f832d51=\"\">\n                    <component :is=\"subRowComponent(index)\" :row-data=\"appendDefaultParams(row, index)\" v-bind=\"subRowBindingAttr(index)\" _v-3f832d51=\"\"></component>\n                </div>\n            </td>\n        </template>\n    </v-base-table>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\nth[_v-3f832d51] {\n  background-color: #F9FAFB; }\n\n/* line 5, stdin */\n.font-bold[_v-3f832d51] {\n  font-weight: 500; }\n\n/* line 8, stdin */\n.st-edit[_v-3f832d51] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: end;\n      justify-content: flex-end;\n  margin-bottom: 5px; }\n  /* line 12, stdin */\n  .st-edit .cog-btn[_v-3f832d51] {\n    color: #5f6368;\n    border: none;\n    border-radius: 50px;\n    padding: 10px 12px; }\n\n/* line 19, stdin */\n.sub-row-wrapper[_v-3f832d51] {\n  padding: 10px !important; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-3f832d51", module.exports)
  } else {
    hotAPI.update("_v-3f832d51", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"./smt-helper.js":1555,"babel-runtime/core-js/json/stringify":48,"babel-runtime/core-js/object/assign":50,"babel-runtime/core-js/object/keys":56,"babel-runtime/core-js/promise":59,"babel-runtime/helpers/extends":66,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799,"vuex":803}],1561:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vueChartjs = require('vue-chartjs');

var reactiveProp = _vueChartjs.mixins.reactiveProp;
exports.default = {
    extends: _vueChartjs.Bar,
    mixins: [reactiveProp],
    props: ['options'],
    mounted: function mounted() {
        // this.chartData is created in the mixin
        this.renderChart(this.chartData, this.options);
    },
    activated: function activated() {
        this.renderChart(this.chartData, this.options);
    }
};

},{"vue-chartjs":784}],1562:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vueChartjs = require('vue-chartjs');

var reactiveProp = _vueChartjs.mixins.reactiveProp;
exports.default = {
    extends: _vueChartjs.Doughnut,
    mixins: [reactiveProp],
    props: ['options'],
    mounted: function mounted() {
        this.addTextCenterPlugin();

        // this.chartData is created in the mixin
        this.renderChart(this.chartData, this.options);
    },
    activated: function activated() {
        this.renderChart(this.chartData, this.options);
    },

    watch: {
        chartData: function chartData(val) {
            if (val) {
                this.addTextCenterPlugin();
                this.renderChart(val, this.options);
            }
        }
    },
    methods: {
        addTextCenterPlugin: function addTextCenterPlugin() {
            var vm = this;
            this.addPlugin({
                id: 'text-center-plugin',
                beforeDraw: function beforeDraw(chart) {
                    if (vm.options.hasOwnProperty('elements') && vm.options.elements.center) {
                        // example.
                        // elements: {
                        //     center: {
                        //         text: '1.9 萬',
                        //             color: 'red', // Default is #000000
                        //             fontStyle: 'Arial', // Default is Arial
                        //             sidePadding: 20, // Default is 20 (as a percentage)
                        //             minFontSize: 16, // Default is 16 (in px), set to false and text will not wrap.
                        //             maxFontSize: 16, // Default is 75 (in px), set to false and text will not wrap.
                        //             lineHeight: 25 // Default is 25 (in px), used for when text wraps
                        //     }
                        // }

                        // Get ctx from string
                        var ctx = chart.chart.ctx;

                        // Get options from the center object in options
                        var centerConfig = chart.config.options.elements.center;
                        var fontStyle = centerConfig.fontStyle || 'Arial';
                        var txt = centerConfig.text;
                        var color = centerConfig.color || '#000';
                        var maxFontSize = centerConfig.maxFontSize || 75;
                        var sidePadding = centerConfig.sidePadding || 20;
                        var sidePaddingCalculated = sidePadding / 100 * (chart.innerRadius * 2);
                        // Start with a base font of 30px
                        ctx.font = "30px " + fontStyle;

                        // Get the width of the string and also the width of the element minus 10 to give it 5px side padding
                        var stringWidth = ctx.measureText(txt).width;
                        var elementWidth = chart.innerRadius * 2 - sidePaddingCalculated;

                        // Find out how much the font can grow in width.
                        var widthRatio = elementWidth / stringWidth;
                        var newFontSize = Math.floor(30 * widthRatio);
                        var elementHeight = chart.innerRadius * 2;

                        // Pick a new font size so it will not be larger than the height of label.
                        var fontSizeToUse = Math.min(newFontSize, elementHeight, maxFontSize);
                        var minFontSize = centerConfig.minFontSize;
                        var lineHeight = centerConfig.lineHeight || 25;
                        var wrapText = false;

                        if (minFontSize === undefined) {
                            minFontSize = 16;
                        }

                        if (minFontSize && fontSizeToUse < minFontSize) {
                            fontSizeToUse = minFontSize;
                            wrapText = true;
                        }

                        // Set font settings to draw it correctly.
                        ctx.textAlign = 'center';
                        ctx.textBaseline = 'middle';
                        var centerX = (chart.chartArea.left + chart.chartArea.right) / 2;
                        var centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2;
                        ctx.font = fontSizeToUse + "px " + fontStyle;
                        ctx.fillStyle = color;

                        if (!wrapText) {
                            ctx.fillText(txt, centerX, centerY);
                            return;
                        }

                        var words = txt.split(' ');
                        var line = '';
                        var lines = [];

                        // Break words up into multiple lines if necessary
                        for (var n = 0; n < words.length; n++) {
                            var testLine = line + words[n] + ' ';
                            var metrics = ctx.measureText(testLine);
                            var testWidth = metrics.width;
                            if (testWidth > elementWidth && n > 0) {
                                lines.push(line);
                                line = words[n] + ' ';
                            } else {
                                line = testLine;
                            }
                        }

                        // Move the center up depending on line height and number of lines
                        centerY -= lines.length / 2 * lineHeight;

                        for (var _n = 0; _n < lines.length; _n++) {
                            ctx.fillText(lines[_n], centerX, centerY);
                            centerY += lineHeight;
                        }
                        //Draw text in center
                        ctx.fillText(line, centerX, centerY);
                    }
                }
            });
        }
    }
};

},{"vue-chartjs":784}],1563:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vueChartjs = require('vue-chartjs');

var reactiveProp = _vueChartjs.mixins.reactiveProp;
exports.default = {
    extends: _vueChartjs.Line,
    mixins: [reactiveProp],
    props: ['options'],
    mounted: function mounted() {
        // this.chartData is created in the mixin
        this.renderChart(this.chartData, this.options);
    }
};

},{"vue-chartjs":784}],1564:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vueChartjs = require('vue-chartjs');

var reactiveProp = _vueChartjs.mixins.reactiveProp;
exports.default = {
    extends: _vueChartjs.Scatter,
    mixins: [reactiveProp],
    props: ['options'],
    mounted: function mounted() {
        // this.chartData is created in the mixin
        this.renderChart(this.chartData, this.options);
    },

    watch: {
        chartData: function chartData(val) {
            if (val) {
                this.renderChart(val, this.options);
                this.$data._chart.update();
            }
        }
    }
};

},{"vue-chartjs":784}],1565:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _vClientUpload = require('./v-client-upload.vue');

var _vClientUpload2 = _interopRequireDefault(_vClientUpload);

var _vClientUploading = require('./v-client-uploading.vue');

var _vClientUploading2 = _interopRequireDefault(_vClientUploading);

var _vClientFileItem = require('./v-client-file-item.vue');

var _vClientFileItem2 = _interopRequireDefault(_vClientFileItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('v-client-upload', _vClientUpload2.default);
_vue2.default.component('v-client-uploading', _vClientUploading2.default);
_vue2.default.component('v-client-file-item', _vClientFileItem2.default);

},{"./v-client-file-item.vue":1566,"./v-client-upload.vue":1567,"./v-client-uploading.vue":1568,"vue":792}],1566:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.thumbnail-item[_v-eefa4d40] {\n  display: inline-block; }\n\n/* line 5, stdin */\n.item-preview[_v-eefa4d40] {\n  border-radius: 10px;\n  padding: 10px 4px;\n  border: 1px solid #ddd;\n  margin-left: 10px;\n  margin-bottom: 10px; }\n\n/* line 12, stdin */\n.not-image-type[_v-eefa4d40] {\n  background-color: #ddd;\n  color: gray;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  width: 100%; }\n\n/* line 20, stdin */\n.preview-size[_v-eefa4d40] {\n  vertical-align: middle; }\n\n/* line 23, stdin */\n.icon[_v-eefa4d40] {\n  color: #000;\n  margin-left: 5px; }\n\n/* line 27, stdin */\n.title-word[_v-eefa4d40] {\n  font-size: 8px;\n  color: #337AB7; }\n\n/* line 31, stdin */\n.pointer[_v-eefa4d40] {\n  cursor: pointer; }\n\n/* line 34, stdin */\n.fa-times-circle[_v-eefa4d40] {\n  color: gray; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	props: {
		subUrl: {
			required: true
		},
		name: {
			required: true
		},
		downUrl: {
			required: true
		},
		thumbnail: {
			required: true
		},
		fileType: {
			required: true
		},
		icon: {
			required: true
		},
		height: {
			default: '50px'
		},
		canDownload: {
			default: false
		},
		canDelete: {
			default: false
		},
		displayType: {
			default: 'row'
		},
		id: {
			required: true
		}
	},
	data: function data() {
		return {
			ajaxing: false,
			ajaxingDownload: false,
			ajaxingDelete: false,
			tempUrl: ''
		};
	},

	computed: {
		hasThumbnail: function hasThumbnail() {
			return !!this.thumbnail;
		},
		shortName: function shortName() {
			return this.name.length > 10 ? this.name.slice(0, 10) + '...' : this.name;
		}
	},
	methods: {
		download: function download() {
			var _this = this;

			if (!this.canDownload) {
				return;
			}
			this.ajaxingDownload = true;
			this.$http.post('/adminapi/client_stored_file/' + this.subUrl + '/temp', {
				'url_segment': this.downUrl
			}).then(function (response) {
				var data = response.data;
				_this.tempUrl = data;
				if (_this.hasThumbnail) {
					_this.showPreview();
				} else {
					_this.realDownload();
				}

				_this.ajaxingDownload = false;
			}, function (error) {
				$17.swal({
					title: '下載失敗',
					text: error.data.message,
					type: 'error',
					showCancelButton: false
				});
				_this.ajaxingDownload = false;
			});
		},
		showPreview: function showPreview() {
			var data = {};
			data.name = this.name;
			data.url = this.tempUrl;
			window.Event.$emit('openViewImg', data);
		},
		realDownload: function realDownload() {
			var link = document.createElement('a');
			link.href = this.tempUrl;
			link.download = "";
			link.click();
			this.tempUrl = '';
		},
		deleteFile: function deleteFile(event) {
			var _this2 = this;

			// this.$emit('deleted',this.id);
			this.ajaxingDelete = true;
			this.$http.delete('/adminapi/client_stored_file/' + this.id + '/' + this.subUrl).then(function (response) {
				var data = response.data.data;
				_this2.$emit('deleted', _this2.id);
				_this2.ajaxingDelete = false;
			}, function (error) {
				$17.swal({
					title: '刪除失敗',
					text: error.data.message,
					type: 'error',
					showCancelButton: false
				});
				_this2.ajaxingDelete = false;
			});
		}
	}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<span _v-eefa4d40=\"\">\n\t<div class=\"thumbnail-item\" v-if=\"displayType == 'thumbnail'\" _v-eefa4d40=\"\">\n\t\t<v-spinner-button :ajaxing=\"ajaxingDownload\" fa-size=\"fa-4x\" _v-eefa4d40=\"\"></v-spinner-button>\n\t\t<div class=\"item-preview\" v-show=\"!ajaxingDownload\" _v-eefa4d40=\"\">\n\t\t\t<div class=\"border-outside\" :class=\"{pointer:canDownload}\" @click.stop.prevent=\"download\" _v-eefa4d40=\"\">\n\t\t\t\t<div _v-eefa4d40=\"\">\n\t\t\t\t\t<i :class=\"icon\" class=\"icon\" aria-hidden=\"true\" _v-eefa4d40=\"\"></i>\n\t\t\t\t\t<span class=\"title-word\" _v-eefa4d40=\"\">\n\t\t\t\t\t\t{{ shortName }}\n\t\t\t\t\t</span>\n\t\t\t\t</div>\n\t\t\t\t<img v-if=\"hasThumbnail\" :src=\"thumbnail\" class=\"preview-size\" :style=\"{height:height,'min-width':this.height}\" alt=\"\" _v-eefa4d40=\"\">\n\t\t\t\t<div v-if=\"!hasThumbnail\" class=\"not-image-type preview-size\" :style=\"{ height:height}\" _v-eefa4d40=\"\">\n\t\t\t\t\t{{fileType}}\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\t<div v-if=\"displayType == 'row'\" _v-eefa4d40=\"\">\n\t\t<span v-show=\"!ajaxingDownload\" _v-eefa4d40=\"\">\n\t\t\t<div @click.stop.prevent=\"download\" :class=\"{pointer:canDownload}\" class=\"title-word\" _v-eefa4d40=\"\">\n\t\t\t\t{{ name }}\n\t\t\t\t<a href=\"#\" @click.prevent.stop=\"deleteFile\" class=\"m-left-5\" v-show=\"canDelete&amp;&amp;!ajaxingDelete\" _v-eefa4d40=\"\">\n\t\t\t\t\t<i class=\"fa fa-times-circle \" aria-hidden=\"true\" _v-eefa4d40=\"\"></i>\n\t\t\t\t</a>\n\t\t\t</div>\n\t\t</span>\n\t\t<v-spinner-button class=\"m-left-5\" :ajaxing=\"ajaxingDelete||ajaxingDownload\" _v-eefa4d40=\"\"></v-spinner-button>\n\t</div>\n</span>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.thumbnail-item[_v-eefa4d40] {\n  display: inline-block; }\n\n/* line 5, stdin */\n.item-preview[_v-eefa4d40] {\n  border-radius: 10px;\n  padding: 10px 4px;\n  border: 1px solid #ddd;\n  margin-left: 10px;\n  margin-bottom: 10px; }\n\n/* line 12, stdin */\n.not-image-type[_v-eefa4d40] {\n  background-color: #ddd;\n  color: gray;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  width: 100%; }\n\n/* line 20, stdin */\n.preview-size[_v-eefa4d40] {\n  vertical-align: middle; }\n\n/* line 23, stdin */\n.icon[_v-eefa4d40] {\n  color: #000;\n  margin-left: 5px; }\n\n/* line 27, stdin */\n.title-word[_v-eefa4d40] {\n  font-size: 8px;\n  color: #337AB7; }\n\n/* line 31, stdin */\n.pointer[_v-eefa4d40] {\n  cursor: pointer; }\n\n/* line 34, stdin */\n.fa-times-circle[_v-eefa4d40] {\n  color: gray; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-eefa4d40", module.exports)
  } else {
    hotAPI.update("_v-eefa4d40", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1567:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.client-file[_v-057b8295] {\n  display: none; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	props: {
		subUrl: {
			required: true
		},
		groupId: {
			required: true
		},
		relationId: {
			required: true
		},
		accept: {
			default: '.jpg, .png, .pdf, .zip'
		}
	},
	data: function data() {
		return {
			ajaxing: false
		};
	},

	computed: {},
	watch: {
		ajaxing: function ajaxing(val, oldV) {
			this.$emit('change-ajaxing', val);
		}
	},
	methods: {
		uploadFile: function uploadFile(event) {
			var _this = this;

			this.ajaxing = true;
			var file = event.target.files[0];
			var formData = new FormData();
			formData.append('file', file);
			formData.append('group_id', this.groupId);
			formData.append('relation_id', this.relationId);

			this.$http.post('/adminapi/client_stored_file/' + this.subUrl, formData, {
				headers: { 'Content-Type': 'multipart/form-data' }
			}).then(function (response) {
				_this.ajaxing = false;
				event.target.value = '';
				var data = response.data;
				_this.$emit('uploaded', data);
			}, function (error) {
				$17.swal({
					title: '上傳失敗',
					type: 'error',
					text: error.data.message,
					showCancelButton: false
				});
				_this.ajaxing = false;
			});
		}
	}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-057b8295=\"\">\n\t<label :for=\"'file'+this._uid\" class=\"btn btn-default\" v-show=\"!ajaxing\" _v-057b8295=\"\">\n\t\t上傳檔案\n\t\t<input :id=\"'file'+this._uid\" class=\"client-file\" type=\"file\" :accept=\"accept\" @change=\"uploadFile($event)\" _v-057b8295=\"\">\n\t</label>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.client-file[_v-057b8295] {\n  display: none; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-057b8295", module.exports)
  } else {
    hotAPI.update("_v-057b8295", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1568:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        ajaxing: {
            required: true
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div v-show=\"ajaxing\" _v-228d5c5d=\"\">\n\t<v-spinner-button :ajaxing=\"ajaxing\" _v-228d5c5d=\"\"></v-spinner-button>\n\t上傳中...\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-228d5c5d", module.exports)
  } else {
    hotAPI.update("_v-228d5c5d", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],1569:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _vContentTab = require('./v-content-tab.vue');

var _vContentTab2 = _interopRequireDefault(_vContentTab);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('v-content-tab', _vContentTab2.default);

},{"./v-content-tab.vue":1570,"vue":792}],1570:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ["model", "title", "items"],
    data: function data() {
        return {
            currentView: this.model
        };
    },

    computed: {},
    watch: {},
    mounted: function mounted() {},

    methods: {
        isActive: function isActive(name, disabled) {
            return this.currentView == name && !disabled ? 'st-font-medium after:st-content-[\'\'] after:st-absolute after:st-bottom-0 after:st-inset-x-0 after:st-w-full after:st-h-1 after:st-rounded-4 after:st-mx-auto after:st-bg-[#38B0E3]' : '';
        },
        isDisabled: function isDisabled(disabled) {
            return disabled ? 'st-pointer-events-none st-opacity-60	' : '';
        },
        tabClick: function tabClick(name) {
            this.currentView = name;
            this.$emit('update:model', name);
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"st-grid\">\n    <div class=\"st-bg-[#F1F1F5] st-h-9 st-text-16 st-py-2 st-px-3\" v-show=\"title !== undefined\">{{title}}</div>\n    <ul class=\"nav nav-tabs st-text-16 st-flex\">\n        <li v-for=\"item in items\" class=\"st-p-2.5 st-relative st-cursor-pointer\" @click.prevent=\"tabClick(item.name)\" :class=\"[isDisabled(item.disable), isActive(item.name, item.disable)]\">\n            <a class=\"st-text-black\">{{ item.title }}</a>\n        </li>\n    </ul>\n    <slot name=\"content-tab-items\"></slot>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-52f8fdd1", module.exports)
  } else {
    hotAPI.update("_v-52f8fdd1", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785}],1571:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.crud-form select[_v-87b076c6] {\n  display: inline; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	props: ['mode', 'memberId', 'studioId', 'storeSuccessCallback'],
	data: function data() {
		return {
			fields: [],
			member: {},
			failData: {},
			ajaxing: true
		};
	},

	watch: {
		fields: function fields() {
			var vm = this;
			this.$nextTick(function () {
				$('.datepicker').datetimepicker({
					format: 'YYYY-MM-DD',
					locale: 'zh-tw'
				}).on('dp.change', function (e) {
					var current = $(e.target);
					var name = current.attr('name');
					var value = $(this).val();
					vm.member[name] = value;
				});
			});
		}
	},
	created: function created() {
		var _this = this;

		window.Event.$on('store-customer-profile-' + this.mode, function () {
			_this.store();
		});
		this.fetchFields();
		this.fetchProfile();
	},

	computed: {
		pictureUrl: function pictureUrl() {
			return this.member.picture ? this.member.picture : '/images/default.png';
		},
		actionUrl: function actionUrl() {
			return this.memberId ? '/webadmin/member_studio/update/' + this.memberId : '/webadmin/member_studio/creating';
		}
	},
	methods: {
		storeProfile: function storeProfile() {
			window.Event.$emit('store-customer-profile-' + this.mode);
		},
		loadFile: function loadFile(event) {
			var output = document.getElementById('output');
			$17.imageCropToString({
				image: event.target.files[0],
				inputId: 'picture',
				width: 200,
				height: 200,
				cropBtnClass: 'btn btn--primary',
				reUploadBtnClass: 'btn btn-default',
				showCropCircle: false,
				callback: function callback(imageString) {
					if (imageString == 'fail crop') {
						return false;
					}
					$('#picture').val('');
					$('#mug_shot').val(imageString);
					output.src = imageString;
				}
			});
		},
		isCustomField: function isCustomField(item, type) {
			return String(item.id).indexOf('custom_') === 0 && this.typeIs(item, type);
		},
		typeIs: function typeIs(item, type) {
			return item.type === type;
		},
		fetchFields: function fetchFields() {
			var _this2 = this;

			this.$http.get('/adminapi/customers/fields/' + this.studioId).then(function (response) {
				_this2.fields = response.body;
				_this2.ajaxing = false;
			});
		},
		fetchProfile: function fetchProfile() {
			var _this3 = this;

			if (!this.memberId) return;
			this.$http.get('/adminapi/customers/profile/' + this.memberId).then(function (response) {
				_this3.member = response.body;
			});
		},
		store: function store() {
			var _this4 = this;

			var formData = new FormData($(this.$el).find('form')[0]);
			this.$http.post(this.actionUrl, formData).then(function (response) {
				if (response.body.error) {
					_this4.failData = {
						picture: ['請上傳 jpg、png、gif 的圖片檔']
					};
					return;
				}
				_this4.storeSuccessCallback(response);
			}, function (response) {
				_this4.failData = response.body;
			}).finally(function (response) {
				$('body').scrollTop(0);
			});
		}
	}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n\t<div _v-87b076c6=\"\">\n\t\t<v-spinner :ajaxing=\"ajaxing\" _v-87b076c6=\"\"></v-spinner>\n\t\t<form v-show=\"!ajaxing\" method=\"POST\" accept-charset=\"UTF-8\" class=\"form-horizontal\" autocomplete=\"off\" enctype=\"multipart/form-data\" :action=\"actionUrl\" _v-87b076c6=\"\">\n\t\t\t<input name=\"studio_id\" type=\"hidden\" v-model=\"studioId\" _v-87b076c6=\"\">\n\t\t    <div class=\"form-group\" v-for=\"f in fields\" _v-87b076c6=\"\">\n\t\t    \t<template v-if=\"f.id === 'picture'\">\n\t\t\t\t\t<label :for=\"f.id\" class=\"col-sm-2 control-label\" _v-87b076c6=\"\">\n\t\t\t\t\t\t{{ f.name }}\n\t\t\t\t\t\t<label class=\"fileUpload\" _v-87b076c6=\"\">\n\t\t\t\t\t\t\t<input class=\"upload\" id=\"picture\" @change=\"loadFile($event)\" accept=\"image/gif, image/jpeg, image/png, image/jpg, image/x-icon\" :name=\"f.id\" type=\"file\" _v-87b076c6=\"\">\n\t\t\t\t\t\t\t<input type=\"hidden\" name=\"mug_shot\" id=\"mug_shot\" _v-87b076c6=\"\">\n\t\t\t\t\t\t\t<a class=\"btn btn-default btn-xs\" _v-87b076c6=\"\"><i class=\"fa fa-camera\" _v-87b076c6=\"\"></i></a>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</label>\n\t\t\t        <div class=\"col-sm-4\" _v-87b076c6=\"\">\n\t\t\t        \t<div _v-87b076c6=\"\">\n\t\t\t        \t\t<img id=\"output\" :src=\"pictureUrl\" _v-87b076c6=\"\">\n\t\t\t        \t</div>\n\t\t\t\t\t\t<span class=\"text-danger\" _v-87b076c6=\"\">(請上傳.jpg、png、gif)</span><br _v-87b076c6=\"\">\n\t\t\t        \t<span v-if=\"failData[f.id]\" class=\"error-msg\" _v-87b076c6=\"\">{{ failData[f.id][0] }}</span>\n\t\t\t        </div>\n\t\t    \t</template>\n\t\t    \t<template v-if=\"f.id === 'phone'\">\n\t\t\t\t\t<label :for=\"f.id\" class=\"col-sm-2 control-label\" _v-87b076c6=\"\">{{ f.name }}</label>\n\t\t\t\t\t<div class=\"col-sm-5 col-md-4 col-lg-4\" _v-87b076c6=\"\">\n\t\t\t\t\t\t<input class=\"form-control\" :placeholder=\"f.name\" :name=\"f.id\" :for=\"f.id\" type=\"text\" v-model=\"member.phone\" _v-87b076c6=\"\">\n\t\t\t\t\t\t<span v-if=\"failData[f.id]\" class=\"error-msg\" _v-87b076c6=\"\">{{ failData[f.id][0] }}</span>\n\t\t\t\t\t</div>\n\t\t    \t</template>\n\t\t    \t<template v-if=\"f.id === 'name'\">\n\t\t\t\t\t<label :for=\"f.id\" class=\"col-sm-2 control-label\" _v-87b076c6=\"\"><v-required v-if=\"f.required\" _v-87b076c6=\"\"></v-required>{{ f.name }}</label>\n\t\t\t\t\t<div class=\"col-sm-5 col-md-4 col-lg-4\" _v-87b076c6=\"\">\n\t\t\t\t\t\t<input class=\"form-control\" :placeholder=\"f.name\" :name=\"f.id\" type=\"text\" v-model=\"member.name\" _v-87b076c6=\"\">\n\t\t\t\t\t\t<span v-if=\"failData[f.id]\" class=\"error-msg\" _v-87b076c6=\"\">{{ failData[f.id][0] }}</span>\n\t\t\t\t\t</div>\n\t\t    \t</template>\n\t\t    \t<template v-if=\"f.id === 'email'\">\n\t\t\t\t\t<label :for=\"f.id\" class=\"col-sm-2 control-label\" _v-87b076c6=\"\">{{ f.name }}</label>\n\t\t\t\t\t<div class=\"col-sm-5 col-md-4 col-lg-4\" _v-87b076c6=\"\">\n\t\t\t\t\t\t<input class=\"form-control\" :placeholder=\"f.name\" :name=\"f.id\" type=\"text\" v-model=\"member.email\" _v-87b076c6=\"\">\n\t\t\t\t\t\t<span v-if=\"failData[f.id]\" class=\"error-msg\" _v-87b076c6=\"\">{{ failData[f.id][0] }}</span>\n\t\t\t\t\t</div>\n\t\t    \t</template>\n\t\t    \t<template v-if=\"f.id === 'address'\">\n\t\t\t\t\t<label :for=\"f.id\" class=\"col-sm-2 col-lg-2 control-label\" _v-87b076c6=\"\">{{ f.name }}</label>\n\t\t\t\t\t<div class=\"col-sm-6 col-lg-5\" _v-87b076c6=\"\">\n\t\t\t\t\t\t<input class=\"form-control\" :placeholder=\"f.name\" :name=\"f.id\" type=\"text\" v-model=\"member.address\" _v-87b076c6=\"\">\n\t\t\t\t\t\t<span v-if=\"failData[f.id]\" class=\"error-msg\" _v-87b076c6=\"\">{{ failData[f.id][0] }}</span>\n\t\t\t\t\t</div>\n\t\t    \t</template>\n\t\t    \t<template v-if=\"typeIs(f, 'date')\">\n\t\t\t\t\t<label :for=\"f.id\" class=\"col-sm-2 control-label\" _v-87b076c6=\"\">{{ f.name }}</label>\n\t\t\t\t\t<div class=\"col-sm-4 col-md-3 col-lg-3\" _v-87b076c6=\"\">\n\t\t\t\t\t\t<input class=\"form-control datepicker\" :placeholder=\"f.name\" :name=\"f.id\" type=\"text\" v-model=\"member[f.id]\" _v-87b076c6=\"\">\n\t\t\t\t\t\t<span v-if=\"failData[f.id]\" class=\"error-msg\" _v-87b076c6=\"\">{{ failData[f.id][0] }}</span>\n\t\t\t\t\t</div>\n\t\t    \t</template>\n\t\t    \t<template v-if=\"isCustomField(f, 'single_line')\">\n\t\t\t\t\t<label class=\"col-sm-2 control-label\" _v-87b076c6=\"\">{{ f.name }}</label>\n\t\t\t\t\t<div class=\"col-sm-5\" _v-87b076c6=\"\">\n\t\t\t\t\t\t<input class=\"form-control\" :name=\"f.id\" type=\"text\" v-model=\"member[f.id]\" _v-87b076c6=\"\">\n\t\t\t\t\t\t<span v-if=\"failData[f.id]\" class=\"error-msg\" _v-87b076c6=\"\">{{ failData[f.id][0] }}</span>\n\t\t\t\t\t</div>\n\t\t    \t</template>\n\t\t    \t<template v-if=\"isCustomField(f, 'multi_line')\">\n\t\t\t\t\t<label class=\"col-sm-2 control-label\" _v-87b076c6=\"\">{{ f.name }}</label>\n\t\t\t\t\t<div class=\"col-sm-5\" _v-87b076c6=\"\">\n\t\t\t\t\t\t<textarea :name=\"f.id\" class=\"form-control\" :placeholder=\"f.name\" style=\"height:100px;\" cols=\"50\" rows=\"10\" _v-87b076c6=\"\">{{ member[f.id] }}</textarea>\n\t\t\t\t\t\t<span v-if=\"failData[f.id]\" class=\"error-msg\" _v-87b076c6=\"\">{{ failData[f.id][0] }}</span>\n\t\t\t\t\t</div>\n\t\t    \t</template>\n\t\t    \t<template v-if=\"typeIs(f, 'single_option')\">\n\t\t\t\t\t<label class=\"col-sm-2 control-label\" _v-87b076c6=\"\">{{ f.name }}</label>\n\t\t\t\t\t<div class=\"col-sm-3\" _v-87b076c6=\"\">\n\t\t\t\t\t\t<select :name=\"f.id\" class=\"form-control\" v-model=\"member[f.id]\" _v-87b076c6=\"\">\n\t\t\t\t\t\t\t<option :value=\"fi.id\" v-for=\"fi in f.items\" _v-87b076c6=\"\">{{ fi.name }}</option>\n\t\t\t\t\t\t</select>\n\t\t\t\t\t\t<span v-if=\"failData[f.id]\" class=\"error-msg\" _v-87b076c6=\"\">{{ failData[f.id][0] }}</span>\n\t\t\t\t\t</div>\n\t\t    \t</template>\n\t\t    \t<template v-if=\"isCustomField(f, 'multi_option')\">\n\t\t\t\t\t<label class=\"col-sm-2 control-label\" _v-87b076c6=\"\">{{ f.name }}</label>\n\t\t\t\t\t<div class=\"col-sm-5\" _v-87b076c6=\"\">\n\t\t\t\t\t\t<span v-for=\"fi in f.items\" _v-87b076c6=\"\">\n\t\t\t\t\t\t\t<label _v-87b076c6=\"\">\n\t\t\t\t\t\t\t\t<input :name=\"f.id + '[]'\" type=\"checkbox\" :value=\"fi.id\" :checked=\"member[f.id] &amp;&amp; member[f.id].indexOf(fi.id) >= 0\" _v-87b076c6=\"\"> {{ fi.name }}\n\t\t\t\t\t\t\t</label><br _v-87b076c6=\"\">\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span v-if=\"failData[f.id]\" class=\"error-msg\" _v-87b076c6=\"\">{{ failData[f.id][0] }}</span>\n\t\t\t\t\t</div>\n\t\t    \t</template>\n\t        </div>\n            <div class=\"form-group\" _v-87b076c6=\"\">\n                <label for=\"remark\" class=\"col-sm-2 control-label\" _v-87b076c6=\"\">額外資訊</label>\n                <div class=\"col-sm-5\" _v-87b076c6=\"\">\n                    <textarea class=\"form-control\" placeholder=\"額外資訊\" style=\"height:100px;\" name=\"remark\" cols=\"50\" rows=\"10\" _v-87b076c6=\"\">{{ member.remark }}</textarea>\n                </div>\n            </div>\n\t\t\t<slot _v-87b076c6=\"\"></slot>\n\t\t\t<div class=\"col-sm-offset-2 col-sm-10\" _v-87b076c6=\"\">\n\t\t\t\t<button class=\"btn btn-primary\" @click.prevent=\"storeProfile\" _v-87b076c6=\"\">送出</button>\n\t\t\t</div>\n\t    </form>\n    </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.crud-form select[_v-87b076c6] {\n  display: inline; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-87b076c6", module.exports)
  } else {
    hotAPI.update("_v-87b076c6", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1572:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.extend[_v-a1d22d32] {\n  background: #eee;\n  padding-left: 15px; }\n\n/* line 6, stdin */\n.shared-member-pic[_v-a1d22d32] {\n  width: 80px; }\n\n/* line 9, stdin */\n.shared-row[_v-a1d22d32] {\n  border-bottom: 1px solid #ccc;\n  padding-bottom: 10px;\n  margin-bottom: 15px; }\n\n/* line 14, stdin */\n.ready-info[_v-a1d22d32] {\n  margin-top: 10px;\n  margin-bottom: 10px; }\n\n/* line 18, stdin */\n.area[_v-a1d22d32] {\n  overflow-y: scroll;\n  overflow-x: hidden;\n  height: 300px; }\n\n/* line 23, stdin */\n.ready-info-pic[_v-a1d22d32] {\n  margin-bottom: 5px; }\n\n/* line 26, stdin */\n.remove-member[_v-a1d22d32] {\n  cursor: pointer; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	props: ['studioId'],
	data: function data() {
		return {
			memberContractId: null,
			sharedMembers: [],
			ajaxing: false
		};
	},
	mounted: function mounted() {
		var _this = this;

		window.Event.$on('openSharedMemberModal', function (data) {
			_this.resetReadyMember();
			_this.memberContractId = data.memberContractId;
			_this.sharedMembers = [];
			_this.fetchMembers();
			$('#shared-member-modal').modal('show');
		});
	},

	computed: {
		ownerId: function ownerId() {
			return this.$store.state.webadmin.crm.member.id;
		},
		memberId: function memberId() {
			return this.$store.state.filters.selected_search_member_id;
		},
		phone: function phone() {
			return this.$store.state.filters.selected_search_member_phone;
		},
		email: function email() {
			return this.$store.state.filters.selected_search_member_email;
		},
		name: function name() {
			return this.$store.state.filters.selected_search_member_name;
		},
		photo: function photo() {
			return this.$store.state.filters.selected_search_member_photo;
		}
	},
	methods: {
		fetchMembers: function fetchMembers() {
			var _this2 = this;

			this.ajaxing = true;
			this.$http.get('/adminapi/member-contract/shared-members/' + this.memberContractId).then(function (response) {
				_this2.sharedMembers = response.data;
				_this2.ajaxing = false;
			});
		},
		markToShared: function markToShared() {
			var _this3 = this;

			this.$http.post('/adminapi/member-contract/shared-members/' + this.memberContractId, {
				member_id: this.memberId
			}).then(function (response) {
				_this3.resetReadyMember();
				_this3.fetchMembers();
			});
		},
		resetReadyMember: function resetReadyMember() {
			this.$store.commit('filters/SETSTATUS', { 'key': 'selected_search_member_id', value: null });
			this.$store.commit('filters/SETSTATUS', { 'key': 'selected_search_member_email', value: null });
			this.$store.commit('filters/SETSTATUS', { 'key': 'selected_search_member_name', value: null });
			this.$store.commit('filters/SETSTATUS', { 'key': 'selected_search_member_phone', value: null });
			this.$store.commit('filters/SETSTATUS', { 'key': 'selected_search_member_photo', value: null });
		},
		removeMember: function removeMember(member, index) {
			var _this4 = this;

			this.$http.delete('/adminapi/member-contract/shared-members/delete/' + this.memberContractId + '/' + member.id).then(function (response) {
				_this4.sharedMembers.splice(index, 1);
			}).catch(function (response) {
				if (response.body.message) {
					$17.swal({
						type: 'warning',
						title: response.body.message,
						showCancelButton: false
					});
				}
			});
		}
	}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<v-modal id=\"shared-member-modal\" no-footer=\"\" no-border-radius=\"\" _v-a1d22d32=\"\">\n\t<template slot=\"title\">管理分享對象</template>\n\t<template slot=\"body\">\n\t\t<div class=\"row\" _v-a1d22d32=\"\">\n\t\t\t<p class=\"extend\" _v-a1d22d32=\"\">新增</p>\n\t\t</div>\n        <v-member-selector v-show=\"memberId == null\" :studio-id=\"studioId\" :without-member-id=\"ownerId\" :keep=\"true\" _v-a1d22d32=\"\"></v-member-selector>\n\t\t<div class=\"row ready-info\" v-if=\"memberId\" _v-a1d22d32=\"\">\n\t\t\t<div class=\"col-xs-6 col-sm-3 col-md-2 ready-info-pic\" _v-a1d22d32=\"\">\n\t\t\t\t<img :src=\"photo\" :alt=\"name\" class=\"shared-member-pic\" _v-a1d22d32=\"\">\n\t\t\t</div>\n\t\t\t<div class=\"col-xs-6 col-sm-7 col-md-8\" _v-a1d22d32=\"\">\n\t\t\t\t<p _v-a1d22d32=\"\">{{ name }}</p>\n\t\t\t\t<p _v-a1d22d32=\"\">{{ email }}</p>\n\t\t\t\t<p _v-a1d22d32=\"\">{{ phone }}</p>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"row ready-info\" v-if=\"memberId\" _v-a1d22d32=\"\">\n\t\t\t<div class=\"col-xs-12\" _v-a1d22d32=\"\">\n\t\t\t\t<button class=\"btn btn-primary\" @click.prevent=\"markToShared\" _v-a1d22d32=\"\">建立分享</button>\n\t\t\t\t<button class=\"btn btn-default\" @click.prevent=\"resetReadyMember\" _v-a1d22d32=\"\">X</button>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"row\" _v-a1d22d32=\"\">\n\t\t\t<p class=\"extend\" _v-a1d22d32=\"\">管理目前({{ sharedMembers.length }})</p>\n\t\t</div>\n\t\t<v-spinner :ajaxing=\"ajaxing\" _v-a1d22d32=\"\"></v-spinner>\n\t\t<div class=\"area\" v-show=\"!ajaxing\" _v-a1d22d32=\"\">\n\t\t\t<div class=\"row shared-row\" v-for=\"(m, $key) in sharedMembers\" _v-a1d22d32=\"\">\n\t\t\t\t<div class=\"col-xs-4 col-sm-2 col-md-2\" _v-a1d22d32=\"\">\n\t\t\t\t\t<img :src=\"m.picture_url\" :alt=\"m.name\" class=\"shared-member-pic\" _v-a1d22d32=\"\">\n\t\t\t\t</div>\n\t\t\t\t<div class=\"clearfix visible-xs-block\" _v-a1d22d32=\"\"></div>\n\t\t\t\t<div class=\"col-xs-8 col-sm-7 col-md-8\" _v-a1d22d32=\"\">\n\t\t\t\t\t<p _v-a1d22d32=\"\">{{ m.name }}</p>\n\t\t\t\t\t<p _v-a1d22d32=\"\">{{ m.email }}</p>\n\t\t\t\t\t<p _v-a1d22d32=\"\">{{ m.phone }}</p>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-xs-4 col-sm-2 col-md-1\" _v-a1d22d32=\"\">\n\t\t\t\t\t<i class=\"fa fa-times-circle fa-2x remove-member\" aria-hidden=\"true\" @click.prevent=\"removeMember(m, $key)\" _v-a1d22d32=\"\"></i>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</template>\n</v-modal>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.extend[_v-a1d22d32] {\n  background: #eee;\n  padding-left: 15px; }\n\n/* line 6, stdin */\n.shared-member-pic[_v-a1d22d32] {\n  width: 80px; }\n\n/* line 9, stdin */\n.shared-row[_v-a1d22d32] {\n  border-bottom: 1px solid #ccc;\n  padding-bottom: 10px;\n  margin-bottom: 15px; }\n\n/* line 14, stdin */\n.ready-info[_v-a1d22d32] {\n  margin-top: 10px;\n  margin-bottom: 10px; }\n\n/* line 18, stdin */\n.area[_v-a1d22d32] {\n  overflow-y: scroll;\n  overflow-x: hidden;\n  height: 300px; }\n\n/* line 23, stdin */\n.ready-info-pic[_v-a1d22d32] {\n  margin-bottom: 5px; }\n\n/* line 26, stdin */\n.remove-member[_v-a1d22d32] {\n  cursor: pointer; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-a1d22d32", module.exports)
  } else {
    hotAPI.update("_v-a1d22d32", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1573:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _vSelectExternalItem = require('./v-select-external-item.vue');

var _vSelectExternalItem2 = _interopRequireDefault(_vSelectExternalItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('v-select-external-link-item', _vSelectExternalItem2.default);

},{"./v-select-external-item.vue":1574,"vue":792}],1574:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	props: {
		studioId: {
			default: null
		},
		reset: {
			default: false
		},
		defaultId: {
			default: null
		},
		value: {
			default: function _default() {
				return {};
			}
		}
	},
	data: function data() {
		return {
			options: [],
			selected: {},
			ajaxing: false
		};
	},

	watch: {
		studioId: function studioId(newVal) {
			var _this = this;

			this.$nextTick(function () {
				_this.fetchExternal(newVal);
			});
		},
		selected: function selected(newVal) {
			if (newVal == null) {
				newVal = {};
			}
			this.$emit('input', newVal);
		},
		value: function value(newVal) {
			this.selected = newVal;
		},
		reset: function reset(newVal) {
			if (newVal) {
				this.selected = {};
			}
		},
		defaultId: function defaultId(newVal) {
			if (newVal) {
				this.setDefault();
			}
		}
	},
	mounted: function mounted() {
		this.fetchExternal(this.studioId);
	},

	methods: {
		fetchExternal: function fetchExternal(studioId) {
			var _this2 = this;

			return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								if (studioId) {
									_context.next = 2;
									break;
								}

								return _context.abrupt('return');

							case 2:
								_this2.ajaxing = true;
								_context.next = 5;
								return _this2.$http.get('/adminapi/external-link/studio/' + studioId).then(function (response) {
									_this2.options = response.data;
								});

							case 5:
								_this2.ajaxing = false;
								if (_this2.defaultId) {
									_this2.setDefault();
								}

							case 7:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this2);
			}))();
		},
		setDefault: function setDefault() {
			var _this3 = this;

			this.selected = this.options.reduce(function (carry, item) {
				if (item.id == _this3.defaultId) {
					carry = item;
				}

				return carry;
			}, {});
		}
	}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-c4e7ea6e=\"\">\n\t<v-mutiselect v-show=\"!ajaxing\" :model.sync=\"selected\" :options=\"options\" :multiple=\"false\" :close-on-select=\"true\" :searchable=\"true\" label=\"name\" track-by=\"id\" tag-name=\"name\" placeholder=\"請選擇連結\" _v-c4e7ea6e=\"\"></v-mutiselect>\n\t<v-spinner-button :ajaxing=\"ajaxing\" _v-c4e7ea6e=\"\"></v-spinner-button>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-c4e7ea6e", module.exports)
  } else {
    hotAPI.update("_v-c4e7ea6e", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/regenerator":75,"vue":792,"vue-hot-reload-api":785}],1575:[function(require,module,exports){
'use strict';

require('./report');
require('./client-upload');
require('./external-link');
require('./schedule');
require('./base-table');
require('./admin-oprate');
require('./label-group');
require('./content-tab');

},{"./admin-oprate":1552,"./base-table":1554,"./client-upload":1565,"./content-tab":1569,"./external-link":1573,"./label-group":1576,"./report":1581,"./schedule":1584}],1576:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _labelGroup = require('./label-group.vue');

var _labelGroup2 = _interopRequireDefault(_labelGroup);

var _singleLabel = require('./single-label.vue');

var _singleLabel2 = _interopRequireDefault(_singleLabel);

var _moreLabel = require('./more-label.vue');

var _moreLabel2 = _interopRequireDefault(_moreLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('label-group', _labelGroup2.default);
_vue2.default.component('single-label', _singleLabel2.default);
_vue2.default.component('more-label', _moreLabel2.default);

},{"./label-group.vue":1577,"./more-label.vue":1578,"./single-label.vue":1579,"vue":792}],1577:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        labelItems: {
            type: Object,
            default: function _default() {
                return {};
            },
            description: ' \u6BCF\u4E00\u500B properties \u7686\u70BA flag \u7528\uFF0C\u5B58\u5728 value \u5373\u986F\u793A\u5C0D\u61C9\u7684 label\n                {\n                    label-1: true,\n                    label-2: true\n                }\n            '
        },
        labelConfig: {
            type: Object,
            default: function _default() {
                return {
                    labelComponent: {},
                    showMoreComponent: {},
                    order: [],
                    maxItemCount: 3
                };
            },
            required: true,
            description: '\n                {\n                    labelComponent: { (object) \u6BCF\u4E00\u7A2E label items \u5C0D\u61C9\u7684 label component\n                        componentName: \'\',\n                        params: { ... }\n                    },\n                    showMoreComponent: { ... }, (object) light-mode \u986F\u793A\u66F4\u591A\u8CC7\u8A0A component, default show this.showMoreComponent\n                    order: [], (array) labels \u986F\u793A\u512A\u5148\u5E8F\n                    maxItemCount: 3 (number) \u5B9A\u7FA9\u6700\u591A\u53EF\u4E00\u6B21\u986F\u793A\u7684 label \u6578\u91CF (default = 3)\uFF0C\u8D85\u904E\u5247\u5207\u63DB\u81F3\u7CBE\u7C21\u986F\u793A\u6A21\u5F0F\n\n                }\n            '
        },
        displayMode: {
            type: String,
            default: 'light-mode',
            validator: function validator(value) {
                return ['full-mode', 'light-mode'].includes(value);
            },

            description: 'light-mode: 精簡模式 | full-mode: 完整模式'
        },
        moreText: {
            type: String,
            default: '更多資訊'
        }
    },
    data: function data() {
        return {
            defaultLightMode: {
                maxItemCount: 3,
                previewCount: 1,
                showMoreComponent: {
                    componentName: 'more-label',
                    params: {
                        background: '#1355C1',
                        color: '#fff',
                        labelText: '更多資訊'
                    }
                }
            },
            showTags: [],
            isLightMode: false,
            labelComponent: {},
            showMoreComponent: {},
            moreLabels: ''
        };
    },

    computed: {},
    watch: {
        labelItems: function labelItems(newVal) {
            if (!_lodash2.default.isEmpty(newVal)) {
                this.initTags();
            }
        }
    },
    mounted: function mounted() {
        this.initTags();
    },

    methods: {
        initTags: function initTags() {
            this.showTags = this.sortTags();
            this.labelComponent = this.labelConfig.labelComponent;
            this.isLightMode = this.isLightModeDisplay();
            if (this.isLightMode) {
                this.showMoreComponent = this.labelConfig.showMoreComponent || this.defaultLightMode.showMoreComponent;
                this.moreLabels = this.generateMoreTooltip();
            }
        },
        sortTags: function sortTags() {
            var labelItems = _lodash2.default.clone(this.labelItems);
            var order = this.labelConfig.order || [];
            var labelComponent = this.labelConfig.labelComponent;
            var result = [];
            order.forEach(function (element) {
                if (labelItems[element] == true && labelComponent[element]) {
                    result.push(element);
                    delete labelItems[element];
                }
            });
            for (var element in labelItems) {
                if (labelItems[element] == true && labelComponent[element]) {
                    result.push(element);
                }
            };
            return result;
        },
        isLightModeDisplay: function isLightModeDisplay() {
            if (this.displayMode === 'light-mode') {
                var maxItemCount = this.labelConfig.maxItemCount || this.defaultLightMode.maxItemCount;
                if (this.showTags.length > maxItemCount) {
                    return true;
                }
                return false;
            }
            return false;
        },
        generateMoreTooltip: function generateMoreTooltip() {
            var moreLabels = "";
            var count = this.defaultLightMode.previewCount;
            for (var i = count; i < this.showTags.length; i++) {
                moreLabels += '<div>' + this.labelComponent[this.showTags[i]].params.tooltip + '</div>';
            }
            return moreLabels;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div v-if=\"showTags.length > 0\" id=\"label-group\" _v-071aee9c=\"\">\n    <div v-if=\"isLightMode\" class=\"light-mode\" _v-071aee9c=\"\">\n        <template v-for=\"(tag, idx) in showTags\">\n            <component v-if=\"idx < defaultLightMode.previewCount\" :is=\"labelComponent[tag].componentName\" :params=\"labelComponent[tag].params\" _v-071aee9c=\"\"></component>\n        </template>\n        <component :is=\"showMoreComponent.componentName\" :params=\"showMoreComponent.params\" :tooltip=\"moreLabels\" _v-071aee9c=\"\"></component>\n    </div>\n\n    <div v-else=\"\" class=\"full-mode\" _v-071aee9c=\"\">\n        <template v-for=\"(tag, idx) in showTags\">\n            <component :is=\"labelComponent[tag].componentName\" :params=\"labelComponent[tag].params\" _v-071aee9c=\"\"></component>\n        </template>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-071aee9c", module.exports)
  } else {
    hotAPI.update("_v-071aee9c", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"lodash":717,"vue":792,"vue-hot-reload-api":785}],1578:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\nspan.tag[_v-00969c40] {\n  background: #D5D5DC;\n  border-radius: 4px;\n  color: #92929D;\n  margin-right: 6px;\n  padding: 2px 6px;\n  word-break: keep-all; }\n  /* line 9, stdin */\n  span.tag[_v-00969c40]:last-child {\n    margin-right: 0; }\n\n@media (max-width: 480px) {\n  /* line 15, stdin */\n  span.tag[_v-00969c40]:last-child {\n    margin-right: 6px; } }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _tippy = require('tippy.js');

var _tippy2 = _interopRequireDefault(_tippy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        params: {
            type: Object,
            required: true
        },
        tooltip: {
            type: String,
            default: ''
        }
    },
    data: function data() {
        return {
            background: '',
            color: '',
            labelText: ''
        };
    },
    mounted: function mounted() {
        this.init();
    },

    watch: {
        params: function params(newVal) {
            this.init();
        }
    },
    methods: {
        init: function init() {
            var _this = this;

            var _params = this.params,
                background = _params.background,
                color = _params.color,
                labelText = _params.labelText;

            this.background = background || '#D5D5DC';
            this.color = color || '#92929D';
            this.labelText = labelText || '';

            this.$nextTick(function () {
                _this.mountedTooltip();
            });
        },
        mountedTooltip: function mountedTooltip() {
            if (this.tooltip) {
                (0, _tippy2.default)(this.$el, {
                    content: this.tooltip,
                    allowHTML: true,
                    placement: 'bottom'
                });
            }
        },
        tagStyle: function tagStyle() {
            return {
                background: this.background,
                color: this.color
            };
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<span class=\"tag show-tippy\" :style=\"tagStyle()\" _v-00969c40=\"\">\n    {{ labelText }}\n</span>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\nspan.tag[_v-00969c40] {\n  background: #D5D5DC;\n  border-radius: 4px;\n  color: #92929D;\n  margin-right: 6px;\n  padding: 2px 6px;\n  word-break: keep-all; }\n  /* line 9, stdin */\n  span.tag[_v-00969c40]:last-child {\n    margin-right: 0; }\n\n@media (max-width: 480px) {\n  /* line 15, stdin */\n  span.tag[_v-00969c40]:last-child {\n    margin-right: 6px; } }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-00969c40", module.exports)
  } else {
    hotAPI.update("_v-00969c40", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"tippy.js":780,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1579:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\nspan.tag[_v-14082413] {\n  background: #D5D5DC;\n  border-radius: 4px;\n  color: #92929D;\n  margin-right: 6px;\n  padding: 2px 6px;\n  word-break: keep-all; }\n  /* line 9, stdin */\n  span.tag[_v-14082413]:last-child {\n    margin-right: 0; }\n\n@media (max-width: 480px) {\n  /* line 15, stdin */\n  span.tag[_v-14082413]:last-child {\n    margin-right: 6px; } }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _tippy = require('tippy.js');

var _tippy2 = _interopRequireDefault(_tippy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        params: {
            type: Object,
            required: true
        }
    },
    data: function data() {
        return {
            background: '',
            color: '',
            labelText: '',
            tooltip: ''
        };
    },
    mounted: function mounted() {
        this.init();
    },

    watch: {
        params: function params(newVal) {
            this.init();
        }
    },
    methods: {
        init: function init() {
            var _this = this;

            var _params = this.params,
                background = _params.background,
                color = _params.color,
                labelText = _params.labelText,
                tooltip = _params.tooltip;

            this.background = background || '#D5D5DC';
            this.color = color || '#92929D';
            this.labelText = labelText || '';
            this.tooltip = tooltip || '';

            this.$nextTick(function () {
                _this.mountedTooltip();
            });
        },
        mountedTooltip: function mountedTooltip() {
            if (this.mobileHideTooltip()) return;
            if (this.tooltip) {
                (0, _tippy2.default)(this.$el, {
                    content: this.tooltip,
                    placement: 'bottom'
                });
            }
        },
        mobileHideTooltip: function mobileHideTooltip() {
            var width = window.innerWidth;
            var maxWidth = 480;
            return width < maxWidth;
        },
        tagStyle: function tagStyle() {
            return {
                background: this.background,
                color: this.color
            };
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<span class=\"tag show-tippy\" :style=\"tagStyle()\" _v-14082413=\"\">\n    {{ labelText }}\n</span>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\nspan.tag[_v-14082413] {\n  background: #D5D5DC;\n  border-radius: 4px;\n  color: #92929D;\n  margin-right: 6px;\n  padding: 2px 6px;\n  word-break: keep-all; }\n  /* line 9, stdin */\n  span.tag[_v-14082413]:last-child {\n    margin-right: 0; }\n\n@media (max-width: 480px) {\n  /* line 15, stdin */\n  span.tag[_v-14082413]:last-child {\n    margin-right: 6px; } }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-14082413", module.exports)
  } else {
    hotAPI.update("_v-14082413", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"tippy.js":780,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1580:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.title-div[_v-3d90654d] {\n  padding: 15px 35px;\n  position: relative;\n  font-size: 18px;\n  cursor: pointer;\n  transition-duration: .3s; }\n  /* line 8, stdin */\n  .title-div[_v-3d90654d]:hover {\n    background-color: #fafafa; }\n\n/* line 12, stdin */\n.body-div[_v-3d90654d] {\n  word-wrap: break-word;\n  box-sizing: border-box;\n  transition-duration: .3s;\n  max-height: 0px;\n  overflow: hidden;\n  opacity: 0; }\n  /* line 19, stdin */\n  .open > .body-div[_v-3d90654d] {\n    opacity: 1;\n    max-height: 300px; }\n\n/* line 24, stdin */\n.symbol[_v-3d90654d] {\n  position: absolute;\n  left: 15px;\n  top: 50%; }\n  /* line 28, stdin */\n  .symbol span[_v-3d90654d] {\n    box-sizing: border-box;\n    transform: rotate(135deg);\n    transition-duration: .3s;\n    position: relative;\n    display: block;\n    top: -5px;\n    width: 10px;\n    height: 10px;\n    border-top: 3px solid #38b0e3;\n    border-left: 3px solid #38b0e3; }\n    /* line 39, stdin */\n    .open > .title-div > .symbol span[_v-3d90654d] {\n      top: -8px;\n      transform: rotate(225deg); }\n\n/* line 45, stdin */\n.body-content-wrap[_v-3d90654d] {\n  padding: 15px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	props: ['title', 'toggleBlock', 'block']
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"block-div\" _v-3d90654d=\"\">\n\t<div class=\"title-div\" @click=\"toggleBlock({ block })\" _v-3d90654d=\"\">\n\t\t{{ title }}\n\t\t<div class=\"symbol\" _v-3d90654d=\"\">\n\t\t\t<span _v-3d90654d=\"\"></span>\n\t\t</div>\n\t</div>\n\t<div class=\"body-div\" _v-3d90654d=\"\">\n\t\t<div class=\"body-content-wrap\" _v-3d90654d=\"\">\n\t\t\t<slot _v-3d90654d=\"\"></slot>\n\t\t</div>\n\t</div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.title-div[_v-3d90654d] {\n  padding: 15px 35px;\n  position: relative;\n  font-size: 18px;\n  cursor: pointer;\n  transition-duration: .3s; }\n  /* line 8, stdin */\n  .title-div[_v-3d90654d]:hover {\n    background-color: #fafafa; }\n\n/* line 12, stdin */\n.body-div[_v-3d90654d] {\n  word-wrap: break-word;\n  box-sizing: border-box;\n  transition-duration: .3s;\n  max-height: 0px;\n  overflow: hidden;\n  opacity: 0; }\n  /* line 19, stdin */\n  .open > .body-div[_v-3d90654d] {\n    opacity: 1;\n    max-height: 300px; }\n\n/* line 24, stdin */\n.symbol[_v-3d90654d] {\n  position: absolute;\n  left: 15px;\n  top: 50%; }\n  /* line 28, stdin */\n  .symbol span[_v-3d90654d] {\n    box-sizing: border-box;\n    transform: rotate(135deg);\n    transition-duration: .3s;\n    position: relative;\n    display: block;\n    top: -5px;\n    width: 10px;\n    height: 10px;\n    border-top: 3px solid #38b0e3;\n    border-left: 3px solid #38b0e3; }\n    /* line 39, stdin */\n    .open > .title-div > .symbol span[_v-3d90654d] {\n      top: -8px;\n      transform: rotate(225deg); }\n\n/* line 45, stdin */\n.body-content-wrap[_v-3d90654d] {\n  padding: 15px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-3d90654d", module.exports)
  } else {
    hotAPI.update("_v-3d90654d", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1581:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _main = require('./main.vue');

var _main2 = _interopRequireDefault(_main);

var _block = require('./block.vue');

var _block2 = _interopRequireDefault(_block);

var _list = require('./list.vue');

var _list2 = _interopRequireDefault(_list);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('v-webadmin-report', _main2.default);
_vue2.default.component('v-webadmin-report-block', _block2.default);
_vue2.default.component('v-webadmin-report-list', _list2.default);

},{"./block.vue":1580,"./list.vue":1582,"./main.vue":1583,"vue":792}],1582:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 3, stdin */\n.table-striped thead[_v-14c69ae4] {\n  border-bottom: 1px solid #000; }\n\n/* line 6, stdin */\n.refund[_v-14c69ae4] {\n  color: red; }\n")
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        ajaxing: {
            default: false,
            required: true
        },
        list: {
            default: [],
            required: true
        },
        listKey: {
            required: true,
            default: []
        },
        listTitle: {
            default: {},
            required: true
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-14c69ae4=\"\">\n    <v-table :ajaxing=\"ajaxing\" :length=\"list.length\" _v-14c69ae4=\"\">\n        <table class=\"table table-striped\" _v-14c69ae4=\"\">\n            <thead _v-14c69ae4=\"\">\n                <tr _v-14c69ae4=\"\">\n                    <td v-for=\"key in listKey\" _v-14c69ae4=\"\">{{ listTitle[(key)] }}</td>\n                </tr>\n            </thead>\n            <tbody _v-14c69ae4=\"\">\n                <tr v-for=\"item in list\" _v-14c69ae4=\"\">\n                    <td v-for=\"key in listKey\" _v-14c69ae4=\"\">{{ item[(key)] }}</td>\n                </tr>\n            </tbody>\n        </table>\n    </v-table>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 3, stdin */\n.table-striped thead[_v-14c69ae4] {\n  border-bottom: 1px solid #000; }\n\n/* line 6, stdin */\n.refund[_v-14c69ae4] {\n  color: red; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-14c69ae4", module.exports)
  } else {
    hotAPI.update("_v-14c69ae4", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1583:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 4, stdin */\n.block-div.control-box.open .body-div[_v-b631fbae] {\n  overflow: visible; }\n\n/* line 8, stdin */\n.block-div.control-box.open .multiselect__input[_v-b631fbae], .block-div.control-box.open .multiselect__single[_v-b631fbae] {\n  position: inherit; }\n\n/* line 13, stdin */\n.top-bar[_v-b631fbae] {\n  position: relative; }\n  /* line 15, stdin */\n  .top-bar > .btn-info[_v-b631fbae] {\n    position: absolute;\n    top: -9px;\n    right: 0px;\n    background-color: #38b0e3;\n    border-color: #38b0e3;\n    padding: 9px 50px;\n    font-size: 18px; }\n    /* line 23, stdin */\n    .top-bar > .btn-info[_v-b631fbae]:hover {\n      background-color: #1f97ca;\n      border-color: #1f97ca; }\n\n/* line 29, stdin */\n.main-title[_v-b631fbae] {\n  font-size: 24px;\n  margin-bottom: 35px; }\n\n/* line 33, stdin */\n.control-box[_v-b631fbae] {\n  border-top: 1px solid #ddd;\n  clear: both; }\n  /* line 36, stdin */\n  .control-box[_v-b631fbae]:last-child, .control-box[_v-b631fbae]:nth-last-child(2) {\n    border-bottom: 1px solid #ddd; }\n\n/* line 40, stdin */\n.flex-block[_v-b631fbae] {\n  display: -ms-flexbox;\n  display: flex;\n  clear: both; }\n  /* line 43, stdin */\n  .flex-block .control-box[_v-b631fbae] {\n    width: 50%; }\n\n@media screen and (max-width: 768px) {\n  /* line 49, stdin */\n  .flex-block[_v-b631fbae] {\n    display: block; }\n    /* line 51, stdin */\n    .flex-block .control-box[_v-b631fbae] {\n      width: 100%; }\n      /* line 53, stdin */\n      .flex-block .control-box[_v-b631fbae]:nth-last-child(2) {\n        border-bottom: none; } }\n\n/* line 60, stdin */\n.first-block-default[_v-b631fbae] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  gap: 5px; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	props: ['title', 'blockOpenStatus', 'toggleBlock', 'submit', 'dateOptions', 'changeDateOption', 'limitDate', "isOpenTemporaryCustomerButton", "studioId", "disableSubmit", "chooseDateFilter"],
	data: function data() {
		return {
			customers: ''
		};
	},
	mounted: function mounted() {},


	methods: {
		showCustomerListModal: function showCustomerListModal() {
			this.$refs.customerListModal.setCustomers(this.customers);
			$('#customer-list-modal').modal('show');
		},
		setCustomers: function setCustomers(customers) {
			this.customers = customers;
		},
		checkSubmit: function checkSubmit() {
			if (moment(this.endDate).diff(moment(this.startDate), 'days') > this.limitDate) {
				$17.formatErrorAlert('可查詢時間不可超過' + this.limitDate + '天');
				return false;
			}
			if (moment(this.endDate).isBefore(moment(this.startDate))) {
				$17.formatErrorAlert('開始日期不可大於結束日期');
				return false;
			}
			this.submit();
		}
	},
	computed: {
		activeStudioId: {
			get: function get() {
				return this.studioId ? this.studioId.id : null;
			}
		},
		startDate: {
			get: function get() {
				return this.dateOptions.startDate;
			},
			set: function set(newV) {
				var _this = this;

				return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
					return _regenerator2.default.wrap(function _callee$(_context) {
						while (1) {
							switch (_context.prev = _context.next) {
								case 0:
									_context.next = 2;
									return _this.changeDateOption({ prop: 'startDate', value: newV });

								case 2:
								case 'end':
									return _context.stop();
							}
						}
					}, _callee, _this);
				}))();
			}
		},
		endDate: {
			get: function get() {
				return this.dateOptions.endDate;
			},
			set: function set(newV) {
				var _this2 = this;

				return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
					return _regenerator2.default.wrap(function _callee2$(_context2) {
						while (1) {
							switch (_context2.prev = _context2.next) {
								case 0:
									_context2.next = 2;
									return _this2.changeDateOption({ prop: 'endDate', value: newV });

								case 2:
								case 'end':
									return _context2.stop();
							}
						}
					}, _callee2, _this2);
				}))();
			}
		},
		filterDate: {
			get: function get() {
				return this.dateOptions.filterDate;
			},
			set: function set(newV) {
				var _this3 = this;

				return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
					return _regenerator2.default.wrap(function _callee3$(_context3) {
						while (1) {
							switch (_context3.prev = _context3.next) {
								case 0:
									_context3.next = 2;
									return _this3.changeDateOption({ prop: 'filterDate', value: newV });

								case 2:
								case 'end':
									return _context3.stop();
							}
						}
					}, _callee3, _this3);
				}))();
			}
		}
	}
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div _v-b631fbae=\"\"> \n\t<div class=\"top-bar\" _v-b631fbae=\"\">\n\t\t<h1 class=\"main-title\" _v-b631fbae=\"\">{{ title }}</h1>\t\n\t\t<button class=\"btn btn-info\" @click=\"checkSubmit\" :disabled=\"disableSubmit\" _v-b631fbae=\"\">開始</button>\n\t</div>\n\t<v-webadmin-report-block title=\"日期\" class=\"control-box\" :class=\"{open: blockOpenStatus &amp;&amp; blockOpenStatus.first}\" :toggle-block=\"toggleBlock\" block=\"first\" _v-b631fbae=\"\">\n\t\t<slot name=\"choose-date\" v-for=\"item in chooseDateFilter\" _v-b631fbae=\"\">\n\t\t\t<input type=\"radio\" :value=\"item.value\" v-model=\"filterDate\" :checked=\"item.selected\" _v-b631fbae=\"\">\n\t\t\t<label class=\"m-left-5 m-right-15\" _v-b631fbae=\"\">{{item.text}}</label>\n\t\t</slot>\n\t\t<slot name=\"first-block\" _v-b631fbae=\"\">\n\t\t\t<div class=\"first-block-default\" _v-b631fbae=\"\"> \n\t\t\t\t<v-datepicker :disabled=\"dateOptions.disabled\" v-model=\"startDate\" placeholder=\"選擇開始日期\" :minimum-view=\"dateOptions.minimumView\" :format-string=\"dateOptions.formatString\" _v-b631fbae=\"\"></v-datepicker>\n\t\t\t\t<div _v-b631fbae=\"\">～</div>\n\t\t\t\t<v-datepicker :disabled=\"dateOptions.disabled\" v-model=\"endDate\" placeholder=\"選擇結束日期\" :minimum-view=\"dateOptions.minimumView\" :format-string=\"dateOptions.formatString\" _v-b631fbae=\"\"></v-datepicker>\n\t\t\t</div>\n\t\t</slot>\n\t</v-webadmin-report-block>\n\t<v-webadmin-report-block title=\"篩選\" class=\"control-box\" :class=\"{open: blockOpenStatus &amp;&amp; blockOpenStatus.second}\" :toggle-block=\"toggleBlock\" block=\"second\" _v-b631fbae=\"\">\n\t\t<slot name=\"second-block\" _v-b631fbae=\"\"></slot>\n\t\t<div class=\"clearfix\" _v-b631fbae=\"\"></div>\n\t</v-webadmin-report-block>\n\t<div class=\"flex-block\" _v-b631fbae=\"\">\n\t\t<v-webadmin-report-block title=\"項目\" class=\"control-box\" :class=\"{open: blockOpenStatus &amp;&amp; blockOpenStatus.third}\" :toggle-block=\"toggleBlock\" block=\"third\" _v-b631fbae=\"\">\n\t\t\t<slot name=\"third-block\" _v-b631fbae=\"\"></slot>\n\t\t</v-webadmin-report-block>\n\t\t<v-webadmin-report-block title=\"顯示\" class=\"control-box\" :class=\"{open: blockOpenStatus &amp;&amp; blockOpenStatus.fourth}\" :toggle-block=\"toggleBlock\" block=\"fourth\" _v-b631fbae=\"\">\n\t\t\t<slot name=\"fourth-block\" _v-b631fbae=\"\"></slot>\n\t\t</v-webadmin-report-block>\t\t\t\n\t</div>\n\t<div v-show=\"isOpenTemporaryCustomerButton\" class=\"text-right m-top-15 p-right-10\" _v-b631fbae=\"\">\n\t\t<button class=\"btn btn-primary\" type=\"button\" @click=\"showCustomerListModal\" _v-b631fbae=\"\">加入到暫存客戶名單</button>\n\t</div>\n\t<customer-list-modal :studio-id=\"activeStudioId\" ref=\"customerListModal\" _v-b631fbae=\"\"></customer-list-modal>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 4, stdin */\n.block-div.control-box.open .body-div[_v-b631fbae] {\n  overflow: visible; }\n\n/* line 8, stdin */\n.block-div.control-box.open .multiselect__input[_v-b631fbae], .block-div.control-box.open .multiselect__single[_v-b631fbae] {\n  position: inherit; }\n\n/* line 13, stdin */\n.top-bar[_v-b631fbae] {\n  position: relative; }\n  /* line 15, stdin */\n  .top-bar > .btn-info[_v-b631fbae] {\n    position: absolute;\n    top: -9px;\n    right: 0px;\n    background-color: #38b0e3;\n    border-color: #38b0e3;\n    padding: 9px 50px;\n    font-size: 18px; }\n    /* line 23, stdin */\n    .top-bar > .btn-info[_v-b631fbae]:hover {\n      background-color: #1f97ca;\n      border-color: #1f97ca; }\n\n/* line 29, stdin */\n.main-title[_v-b631fbae] {\n  font-size: 24px;\n  margin-bottom: 35px; }\n\n/* line 33, stdin */\n.control-box[_v-b631fbae] {\n  border-top: 1px solid #ddd;\n  clear: both; }\n  /* line 36, stdin */\n  .control-box[_v-b631fbae]:last-child, .control-box[_v-b631fbae]:nth-last-child(2) {\n    border-bottom: 1px solid #ddd; }\n\n/* line 40, stdin */\n.flex-block[_v-b631fbae] {\n  display: -ms-flexbox;\n  display: flex;\n  clear: both; }\n  /* line 43, stdin */\n  .flex-block .control-box[_v-b631fbae] {\n    width: 50%; }\n\n@media screen and (max-width: 768px) {\n  /* line 49, stdin */\n  .flex-block[_v-b631fbae] {\n    display: block; }\n    /* line 51, stdin */\n    .flex-block .control-box[_v-b631fbae] {\n      width: 100%; }\n      /* line 53, stdin */\n      .flex-block .control-box[_v-b631fbae]:nth-last-child(2) {\n        border-bottom: none; } }\n\n/* line 60, stdin */\n.first-block-default[_v-b631fbae] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  gap: 5px; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-b631fbae", module.exports)
  } else {
    hotAPI.update("_v-b631fbae", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/regenerator":75,"lodash":717,"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1584:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _vTimeFilter = require('./v-time-filter.vue');

var _vTimeFilter2 = _interopRequireDefault(_vTimeFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('v-time-filter', _vTimeFilter2.default);

},{"./v-time-filter.vue":1585,"vue":792}],1585:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.time-filter[_v-3fc61844] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  margin-left: 10px;\n  margin-bottom: 25px;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap; }\n  /* line 8, stdin */\n  .time-filter .fa-calendar[_v-3fc61844] {\n    position: absolute;\n    z-index: 2;\n    margin: 12px; }\n  /* line 13, stdin */\n  .time-filter button[_v-3fc61844] {\n    color: #575757;\n    border-radius: 3px;\n    border: solid 1px #dddddd;\n    padding: 8px 12px; }\n    /* line 18, stdin */\n    .time-filter button .fa-chevron-right[_v-3fc61844], .time-filter button .fa-chevron-left[_v-3fc61844] {\n      color: #b0b0b0; }\n  /* line 22, stdin */\n  .time-filter .btnActive[_v-3fc61844] {\n    border: solid 1px #38b0e3;\n    background-color: #ffffff;\n    box-shadow: none;\n    color: #38b0e3;\n    z-index: 2; }\n  @media (max-width: 480px) {\n    /* line 2, stdin */\n    .time-filter[_v-3fc61844] {\n      margin: auto 20px; }\n      /* line 31, stdin */\n      .time-filter .date-container[_v-3fc61844] {\n        width: 100%;\n        margin-bottom: 10px; } }\n\n/* line 3, stdin */\n.vdp-datepicker .date-filter-class {\n  cursor: pointer;\n  padding: 9px 18px 9px 37px;\n  border-radius: 3px;\n  border: solid 1px #dddddd;\n  width: 133px; }\n  /* line 9, stdin */\n  .vdp-datepicker .date-filter-class:focus {\n    border: solid 1px #38b0e3; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        changeDate: {
            type: Function
        }
    },
    data: function data() {
        return {
            date: '',
            isDay: true,
            isWeek: false,
            fromTime: '',
            toTime: ''
        };
    },

    watch: {
        date: function date(newVal) {
            if (newVal) {
                this.isDay ? this.range('day') : this.range('week');
            }
        }
    },
    mounted: function mounted() {
        this.initDate();
    },

    methods: {
        initDate: function initDate() {
            var urlQuery = $17.getUrlQueryStrings();
            if (urlQuery.hasOwnProperty('date') && urlQuery.hasOwnProperty('span')) {
                this.date = this.formatTime(urlQuery.date);
                this.range(urlQuery.span);
            } else {
                this.date = this.formatTime(moment());
                this.range('day');
            };
        },
        current: function current() {
            this.date = this.formatTime(moment());
            this.isDay ? this.range('day') : this.range('week');
        },
        range: function range(mode) {
            if (mode === 'day') {
                this.isDay = true;
                this.isWeek = false;
                this.fromTime = this.date;
                this.toTime = this.date;
            } else if (mode === 'week') {
                var startOfWeek = moment(this.date).startOf('week').toDate();
                this.isDay = false;
                this.isWeek = true;
                this.date = this.formatTime(startOfWeek);
                this.fromTime = this.date;
                this.toTime = this.formatTime(moment(startOfWeek).add(6, 'days').toDate());
            };
            this.updateQueryStrings({ date: this.date, span: mode });
            this.changeDate && this.changeDate(this.fromTime, this.toTime);
        },
        updateQueryStrings: function updateQueryStrings(query) {
            var urlQuery = $17.getUrlQueryStrings();
            urlQuery['date'] = query.date;
            urlQuery['span'] = query.span;
            var newQueryString = $17.queryStringBuilder(urlQuery);
            history.replaceState({}, null, '?' + newQueryString);
        },
        jumpTo: function jumpTo(days, state) {
            if (state === 'before') {
                this.date = this.formatTime(moment(this.date).subtract(days, 'days').toDate());
            } else {
                this.date = this.formatTime(moment(this.date).add(days, 'days').toDate());
            };
            days === 1 ? this.range('day') : this.range('week');
        },
        formatTime: function formatTime(date) {
            return moment(date).format('YYYY-MM-DD');
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n\t<div class=\"time-filter\" _v-3fc61844=\"\">\n        <div class=\"date-container m-right-15\" _v-3fc61844=\"\">\n            <i class=\"fa fa-calendar\" _v-3fc61844=\"\"></i>\n            <v-datepicker v-model=\"date\" :to-time=\"toTime\" placeholder=\"請輸入日期\" input-class=\"date-filter-class\" _v-3fc61844=\"\"></v-datepicker>\n        </div>\n\n        <button class=\"btn-default\" @click.prevent=\"current()\" _v-3fc61844=\"\">{{isDay?'今天':'本週'}}</button>\n\n        <div class=\"btn-group m-left-15\" role=\"group\" aria-label=\"...\" _v-3fc61844=\"\">\n            <button type=\"button\" class=\"btn btn-default\" @click.prevent=\"jumpTo(1, 'before')\" _v-3fc61844=\"\"><i class=\"fa fa-chevron-left\" _v-3fc61844=\"\"></i></button>\n            <button type=\"button\" class=\"btn btn-default\" :class=\"{btnActive: isDay}\" @click.prevent=\"range('day')\" _v-3fc61844=\"\">天</button>\n            <button type=\"button\" class=\"btn btn-default\" @click.prevent=\"jumpTo(1, 'after')\" _v-3fc61844=\"\"><i class=\"fa fa-chevron-right\" _v-3fc61844=\"\"></i></button>\n        </div>\n\n        <div class=\"btn-group m-left-15\" role=\"group\" aria-label=\"...\" _v-3fc61844=\"\">\n            <button type=\"button\" class=\"btn btn-default\" @click.prevent=\"jumpTo(7, 'before')\" _v-3fc61844=\"\"><i class=\"fa fa-chevron-left\" _v-3fc61844=\"\"></i></button>\n            <button type=\"button\" class=\"btn btn-default\" :class=\"{btnActive: isWeek}\" @click.prevent=\"range('week')\" _v-3fc61844=\"\">週</button>\n            <button type=\"button\" class=\"btn btn-default\" @click.prevent=\"jumpTo(7, 'after')\" _v-3fc61844=\"\"><i class=\"fa fa-chevron-right\" _v-3fc61844=\"\"></i></button>\n        </div>\n\t</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.time-filter[_v-3fc61844] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  margin-left: 10px;\n  margin-bottom: 25px;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap; }\n  /* line 8, stdin */\n  .time-filter .fa-calendar[_v-3fc61844] {\n    position: absolute;\n    z-index: 2;\n    margin: 12px; }\n  /* line 13, stdin */\n  .time-filter button[_v-3fc61844] {\n    color: #575757;\n    border-radius: 3px;\n    border: solid 1px #dddddd;\n    padding: 8px 12px; }\n    /* line 18, stdin */\n    .time-filter button .fa-chevron-right[_v-3fc61844], .time-filter button .fa-chevron-left[_v-3fc61844] {\n      color: #b0b0b0; }\n  /* line 22, stdin */\n  .time-filter .btnActive[_v-3fc61844] {\n    border: solid 1px #38b0e3;\n    background-color: #ffffff;\n    box-shadow: none;\n    color: #38b0e3;\n    z-index: 2; }\n  @media (max-width: 480px) {\n    /* line 2, stdin */\n    .time-filter[_v-3fc61844] {\n      margin: auto 20px; }\n      /* line 31, stdin */\n      .time-filter .date-container[_v-3fc61844] {\n        width: 100%;\n        margin-bottom: 10px; } }\n\n/* line 3, stdin */\n.vdp-datepicker .date-filter-class {\n  cursor: pointer;\n  padding: 9px 18px 9px 37px;\n  border-radius: 3px;\n  border: solid 1px #dddddd;\n  width: 133px; }\n  /* line 9, stdin */\n  .vdp-datepicker .date-filter-class:focus {\n    border: solid 1px #38b0e3; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-3fc61844", module.exports)
  } else {
    hotAPI.update("_v-3fc61844", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1586:[function(require,module,exports){
var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("/* line 2, stdin */\n.main-body[_v-4d784f5f] {\n  display: -ms-flexbox;\n  display: flex; }\n\n@media screen and (max-width: 768px) {\n  /* line 6, stdin */\n  div.img-box[_v-4d784f5f] {\n    width: 100px;\n    min-width: 100px;\n    padding-right: 10px; }\n  /* line 11, stdin */\n  div.info > div[_v-4d784f5f] {\n    padding: 5px 0; } }\n\n/* line 15, stdin */\n.img-box[_v-4d784f5f] {\n  width: 150px;\n  min-width: 150px;\n  padding-right: 20px; }\n  /* line 19, stdin */\n  .img-box img[_v-4d784f5f] {\n    width: 100%; }\n\n/* line 23, stdin */\n.info[_v-4d784f5f] {\n  -ms-flex: 1;\n      flex: 1; }\n  /* line 25, stdin */\n  .info > div[_v-4d784f5f] {\n    padding: 10px 0; }\n\n/* line 29, stdin */\n.info span[_v-4d784f5f] {\n  width: 90px;\n  display: inline-block; }\n")
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['picture', 'name', 'phone', 'email', 'account']
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"main-body\" _v-4d784f5f=\"\">\n    <div class=\"img-box\" _v-4d784f5f=\"\">\n        <img :src=\"picture\" _v-4d784f5f=\"\">\n    </div>\n    <div class=\"info\" _v-4d784f5f=\"\">\n        <div _v-4d784f5f=\"\"><span _v-4d784f5f=\"\">姓名</span>: {{ name }}</div>\n        <div _v-4d784f5f=\"\"><span _v-4d784f5f=\"\">使用者帳號</span>: {{ account }}</div>\n        <div _v-4d784f5f=\"\"><span _v-4d784f5f=\"\">手機</span>: {{ phone }}</div>\n        <div _v-4d784f5f=\"\"><span _v-4d784f5f=\"\">Email</span>: {{ email }}</div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.dispose(function () {
    __vueify_insert__.cache["/* line 2, stdin */\n.main-body[_v-4d784f5f] {\n  display: -ms-flexbox;\n  display: flex; }\n\n@media screen and (max-width: 768px) {\n  /* line 6, stdin */\n  div.img-box[_v-4d784f5f] {\n    width: 100px;\n    min-width: 100px;\n    padding-right: 10px; }\n  /* line 11, stdin */\n  div.info > div[_v-4d784f5f] {\n    padding: 5px 0; } }\n\n/* line 15, stdin */\n.img-box[_v-4d784f5f] {\n  width: 150px;\n  min-width: 150px;\n  padding-right: 20px; }\n  /* line 19, stdin */\n  .img-box img[_v-4d784f5f] {\n    width: 100%; }\n\n/* line 23, stdin */\n.info[_v-4d784f5f] {\n  -ms-flex: 1;\n      flex: 1; }\n  /* line 25, stdin */\n  .info > div[_v-4d784f5f] {\n    padding: 10px 0; }\n\n/* line 29, stdin */\n.info span[_v-4d784f5f] {\n  width: 90px;\n  display: inline-block; }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord("_v-4d784f5f", module.exports)
  } else {
    hotAPI.update("_v-4d784f5f", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":792,"vue-hot-reload-api":785,"vueify/lib/insert-css":799}],1587:[function(require,module,exports){
'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _vuex = require('vuex');

var _vuex2 = _interopRequireDefault(_vuex);

var _vueResource = require('vue-resource');

var _vueResource2 = _interopRequireDefault(_vueResource);

var _store = require('./store');

var _store2 = _interopRequireDefault(_store);

require('babel-polyfill');

var _router = require('../vue/components/pages/webadmin/float_widget/router');

var _router2 = _interopRequireDefault(_router);

var _app = require('../vue/components/pages/webadmin/float_widget/app.vue');

var _app2 = _interopRequireDefault(_app);

var _main = require('./components/pages/webadmin/spa-page/main');

var _main2 = _interopRequireDefault(_main);

var _entry = require('./components/pages/webadmin/spa-page/entry.vue');

var _entry2 = _interopRequireDefault(_entry);

var _vueI18n = require('../../global/vue-i18n');

var _vueI18n2 = _interopRequireDefault(_vueI18n);

var _en = require('../../i18n/web/en/en.js');

var _en2 = _interopRequireDefault(_en);

var _tw = require('../../i18n/web/tw/tw.js');

var _tw2 = _interopRequireDefault(_tw);

var _index = require('../../i18n/webadmin/en/index.js');

var _index2 = _interopRequireDefault(_index);

var _index3 = require('../../i18n/webadmin/tw/index.js');

var _index4 = _interopRequireDefault(_index3);

var _main3 = require('../../global/vue_google_maps/main');

var VueGoogleMaps = _interopRequireWildcard(_main3);

var _vuePagination = require('../../global/vue-pagination');

var _vuePagination2 = _interopRequireDefault(_vuePagination);

var _ckeditor5Vue = require('@ckeditor/ckeditor5-vue');

var _ckeditor5Vue2 = _interopRequireDefault(_ckeditor5Vue);

var _socialite = require('../../global/socialite');

var _socialite2 = _interopRequireDefault(_socialite);

var _web = require('../../../../error/identifiable/web.js');

var _web2 = _interopRequireDefault(_web);

var _webadmin = require('../../../../error/identifiable/webadmin.js');

var _webadmin2 = _interopRequireDefault(_webadmin);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('./components');


_vue2.default.use(_ckeditor5Vue2.default);

_vue2.default.use(_vuePagination2.default);
_vue2.default.use(_vueI18n2.default);

var i18n = new _vueI18n2.default({
    locale: localStorage.getItem('lang17fit') === null ? 'zh-tw' : localStorage.getItem('lang17fit'),
    messages: {
        'en-us': _en2.default,
        'zh-tw': _tw2.default
    }
});

_vue2.default.prototype.i18n = i18n;
window.i18n = i18n;
_vue2.default.prototype.$socialite = _socialite2.default;
_vue2.default.prototype.$errorIdentifiable = _web2.default;

_vue2.default.use(_vueResource2.default);
_vue2.default.http.options.emulateJSON = true;

_vue2.default.http.interceptors.push(function (request, next) {
    request.headers.set('X-CSRF-TOKEN', $('meta[name="csrf_token"]').attr('content'));
    next(function (response) {
        if (response.status == 401) {
            location.reload();
        }
    });
});
var methods = {
    bootFloatWidget: function bootFloatWidget() {
        _vue2.default.prototype.$bus = window.Event;
        var app = new _vue2.default({
            router: _router2.default,
            store: _store2.default,
            render: function render(h) {
                return h(_app2.default);
            }
        }).$mount('#float-widget');
    },
    bootstrapWebadmin: function bootstrapWebadmin() {
        _vue2.default.use(VueGoogleMaps, {
            load: {
                key: 'AIzaSyDaFqo-YXF0upV72wuHMl2yZ9W-XxWJ0CM',
                libraries: 'places'
            }
        });
        _store2.default.dispatch('webadmin/configure/setUp');
        _store2.default.dispatch('webadmin/configure/initLayoutSetting');
        _store2.default.dispatch('initAllUserValue');

        // Overwrite i18n messages for webadmin
        i18n.setLocaleMessage('zh-tw', _index4.default);
        i18n.setLocaleMessage('en-us', _index2.default);
        _vue2.default.prototype.$errorIdentifiable = _webadmin2.default;
    },
    onVueRouter: function onVueRouter() {
        var app = new _vue2.default({
            router: _main2.default,
            store: _store2.default,
            render: function render(h) {
                return h(_entry2.default);
            }
        }).$mount('#spa-webadmin');
    },
    moneyFormat: function moneyFormat(number) {
        return $17.moneyFormat(number);
    },
    getUrlParamValue: function getUrlParamValue(param) {
        var q = $17.getUrlQueryStrings();
        return q.hasOwnProperty(param) ? q[param] : '';
    },
    bootGoogleMap: function bootGoogleMap() {
        _vue2.default.use(VueGoogleMaps, {
            load: {
                key: 'AIzaSyDaFqo-YXF0upV72wuHMl2yZ9W-XxWJ0CM',
                libraries: 'places'
            }
        });
    },
    paymentDisplayName: function paymentDisplayName(method) {
        if (_.isEmpty(method)) {
            return '';
        } else {
            return method.alias_name ? method.alias_name : method.name;
        }
    },
    fullCalendarKey: function fullCalendarKey() {
        return 'CC-Attribution-NonCommercial-NoDerivatives';
    }
};

_vue2.default.mixin({ store: _store2.default, methods: methods });

window.Vue = _vue2.default;
window.store = _store2.default;
window.Event = new _vue2.default();

// error handler.
// if (!Vue.config.debug) {
//     window.onerror = function (errorMsg, url, lineNumber, column, errorObj) {
//         let errMsg = {
//             Error: errorMsg,
//             Script: url,
//             Line: lineNumber,
//             Column: column,
//             StackTrace: errorObj,
//         };
//         store.dispatch('setWeblog', {'name': '全域', 'message': errMsg});
//     };
//     Vue.config.errorHandler = function (err, vm, info) {
//         store.dispatch('setWeblog', {'name': 'VueE', 'message': err + '-' + info});
//     };
//     Vue.config.warnHandler = function (err, vm, info) {
//         store.dispatch('setWeblog', {'name': 'VueW', 'message': err + '-' + info});
//     };
// }

},{"../../../../error/identifiable/web.js":1614,"../../../../error/identifiable/webadmin.js":1615,"../../global/socialite":807,"../../global/vue-i18n":811,"../../global/vue-pagination":812,"../../global/vue_google_maps/main":825,"../../i18n/web/en/en.js":835,"../../i18n/web/tw/tw.js":838,"../../i18n/webadmin/en/index.js":841,"../../i18n/webadmin/tw/index.js":844,"../vue/components/pages/webadmin/float_widget/app.vue":1164,"../vue/components/pages/webadmin/float_widget/router":1168,"./components":858,"./components/pages/webadmin/spa-page/entry.vue":1440,"./components/pages/webadmin/spa-page/main":1441,"./store":1590,"@ckeditor/ckeditor5-vue":2,"babel-polyfill":44,"vue":792,"vue-resource":788,"vuex":803}],1588:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setWeblog = exports.getMembers = exports.initAllUserValue = exports.increment = undefined;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _mutationTypes = require('./mutation-types');

var types = _interopRequireWildcard(_mutationTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var increment = exports.increment = function increment(context) {
    context.commit(types.POS_INCREASE);
};
var initAllUserValue = exports.initAllUserValue = function initAllUserValue(context) {
    var vm = undefined;
    Vue.http.get('/adminapi/init/init_user_value').then(function (response) {
        context.commit(types.INIT_USER_VALUE, response.data);
    });
};
var getMembers = exports.getMembers = function getMembers(context, member_id) {
    var vm = undefined;
    Vue.http.get('/adminapi/init/get_member/' + member_id).then(function (response) {
        context.commit(types.INIT_USER_VALUE, response.data);
    });
};

var setWeblog = exports.setWeblog = function setWeblog(context, log) {
    var vm = undefined;
    Vue.http.post('/simple/adminapi/log', {
        'log_name': log.name,
        'log_message': (0, _stringify2.default)(log.message)
    }).then(function (response) {}).catch(function (err) {});
};

},{"./mutation-types":1612,"babel-runtime/core-js/json/stringify":48}],1589:[function(require,module,exports){
"use strict";

},{}],1590:[function(require,module,exports){
(function (process){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _vuex = require('vuex');

var _vuex2 = _interopRequireDefault(_vuex);

var _mutations = require('./mutations');

var _actions = require('./actions');

var actions = _interopRequireWildcard(_actions);

var _modules = require('./modules');

var _modules2 = _interopRequireDefault(_modules);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('./modules');
// import * as getters from './getters'


var debug = process.env.NODE_ENV !== 'production';
_vue2.default.use(_vuex2.default);

exports.default = new _vuex2.default.Store({
  state: _mutations.state,
  actions: actions,
  // getters,
  mutations: _mutations.mutations,
  modules: _modules2.default,
  strict: debug
  // plugins: debug ? [createLogger()] : []
});

}).call(this,require('_process'))
},{"./actions":1588,"./modules":1592,"./mutations":1613,"_process":734,"vue":792,"vuex":803}],1591:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _mutations;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var types = {
    FILTERS_APPEND_STUDIO: 'FILTERS_APPEND_STUDIO',
    FILTERS_APPEND_BRANCH: 'FILTERS_APPEND_BRANCH',
    SETSTATUS: 'SETSTATUS',
    RESET_SELECTED_MEMBER: 'RESET_SELECTED_MEMBER',
    APPEND_SELECT_MEMBER: 'APPEND_SELECT_MEMBER'
    // initial state
    // shape: [{ id, quantity }]
};var state = {
    selected_studio_id: null,
    selected_branch_id: null,
    studioOptions: [],
    branchOptions: [],
    selected_search_member_id: null,
    selected_search_member_name: null,
    selected_search_member_phone: null,
    selected_search_member_email: null,
    selected_search_member_photo: null,
    selected_search_member_is_walkin: null,
    selected_search_member: {}
};

var api = {
    getMember: function getMember(member_id) {
        return new _promise2.default(function (resolve) {
            Vue.http.get('/adminapi/init/get_member/' + member_id).then(function (_ref) {
                var data = _ref.data;
                return resolve({
                    member: data
                });
            });
        });
    },
    getBindedMember: function getBindedMember(member_id) {
        return new _promise2.default(function (resolve) {
            Vue.http.get('/adminapi/init/get_member/' + member_id).then(function (_ref2) {
                var data = _ref2.data;
                return resolve({
                    member: data
                });
            });
        });
    }
};

// getters
var getters = {};

// actions
var actions = {
    getStudioList: function getStudioList(context) {
        Vue.http.get('/adminapi/studio_select_list').then(function (response) {
            context.commit('FILTERS_APPEND_STUDIO', response.data);
            $('#ssab_studio_id').val('').trigger('change');
        });
    },
    getBranchList: function getBranchList(context) {
        if (store.state.filters.selected_studio_id < 1) return;
        Vue.http.get('/adminapi/init/branch_select_list?studio_id=' + store.state.filters.selected_studio_id).then(function (response) {
            context.commit('FILTERS_APPEND_BRANCH', response.data);
            if (state.branchOptions.length > 0) {
                $('#ssab_branch_id').val('null').trigger('change');
            } else {
                $('#ssab_branch_id').val(state.branchOptions[0].id).trigger('change');
            }
        });
    },
    getBranchPayment: function getBranchPayment(context) {
        if (store.state.filters.selected_studio_id < 1) return;
        Vue.http.get('/adminapi/init/branch_select_payment_list?studio_id=' + store.state.filters.selected_studio_id).then(function (response) {
            context.commit('FILTERS_APPEND_BRANCH', response.data);
            if (state.branchOptions.length > 0) {
                $('#ssab_branch_id').val('null').trigger('change');
            } else {
                $('#ssab_branch_id').val(state.branchOptions[0].id).trigger('change');
            }
        });
    },
    getMember: function getMember(context, member_id) {
        var _this = this;

        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            var response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return api.getMember(member_id);

                        case 2:
                            response = _context.sent;


                            context.commit('SETSTATUS', { 'key': 'selected_search_member_name', value: response.member.name });
                            context.commit('SETSTATUS', { 'key': 'selected_search_member_phone', value: response.member.phone });
                            context.commit('SETSTATUS', { 'key': 'selected_search_member_email', value: response.member.email });
                            context.commit('SETSTATUS', { 'key': 'selected_search_member_id', value: member_id });
                            context.commit('SETSTATUS', { 'key': 'selected_search_member_photo', value: response.member.picture_path });
                            context.commit('SETSTATUS', { 'key': 'selected_search_member_is_walkin', value: response.member.is_walkin });

                        case 9:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },
    resetSelectedMember: function resetSelectedMember(context) {
        var _this2 = this;

        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            context.commit(types.RESET_SELECTED_MEMBER);

                        case 1:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }))();
    },
    updateQueryStrings: function updateQueryStrings(context, payload) {
        //更新數個queryStrings//ex.dispatch('filters/updateQueryStrings', {key1:'value1',key2:'value2'});
        var q = $17.getUrlQueryStrings();
        for (var param in payload) {
            q[param] = payload[param].toString();
        }
        var newQueryString = $17.queryStringBuilder(q);
        history.replaceState({}, null, '?' + newQueryString);
    }
};

// mutations
var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.FILTERS_APPEND_STUDIO, function (state, payload) {
    state.studioOptions = payload.studios;
}), (0, _defineProperty3.default)(_mutations, types.FILTERS_APPEND_BRANCH, function (state, payload) {
    state.branchOptions = payload.branches;
}), (0, _defineProperty3.default)(_mutations, types.SETSTATUS, function (state, payload) {
    state[payload.key] = payload.value;
}), (0, _defineProperty3.default)(_mutations, types.APPEND_SELECT_MEMBER, function (state, payload) {
    state.selected_search_member = payload;
}), (0, _defineProperty3.default)(_mutations, types.RESET_SELECTED_MEMBER, function (state, payload) {
    state['selected_search_member_name'] = null;
    state['selected_search_member_phone'] = null;
    state['selected_search_member_email'] = null;
    state['selected_search_member_id'] = null;
    state['selected_search_member_photo'] = null;
    state['selected_search_member_is_walkin'] = null;
}), _mutations);

exports.default = {
    namespaced: true,
    types: types,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
};

},{"babel-runtime/core-js/promise":59,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/defineProperty":65,"babel-runtime/regenerator":75}],1592:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _payrollStatistics = require('./webadmin/payroll-statistics');

var _payrollStatistics2 = _interopRequireDefault(_payrollStatistics);

var _configure = require('./webadmin/configure');

var _configure2 = _interopRequireDefault(_configure);

var _pos = require('./pos');

var _pos2 = _interopRequireDefault(_pos);

var _filters = require('./filters');

var _filters2 = _interopRequireDefault(_filters);

var _crm = require('./webadmin/crm');

var _crm2 = _interopRequireDefault(_crm);

var _admission = require('./webadmin/admission');

var _admission2 = _interopRequireDefault(_admission);

var _orderDetailsTotalSale = require('./webadmin/order-details-total-sale');

var _orderDetailsTotalSale2 = _interopRequireDefault(_orderDetailsTotalSale);

var _invoice = require('./webadmin/invoice');

var _invoice2 = _interopRequireDefault(_invoice);

var _bookingTotalList = require('./webadmin/booking-total-list');

var _bookingTotalList2 = _interopRequireDefault(_bookingTotalList);

var _print = require('./webadmin/print');

var _print2 = _interopRequireDefault(_print);

var _ticketsUsedReport = require('./webadmin/tickets-used-report');

var _ticketsUsedReport2 = _interopRequireDefault(_ticketsUsedReport);

var _orderInvoiceList = require('./webadmin/order-invoice-list');

var _orderInvoiceList2 = _interopRequireDefault(_orderInvoiceList);

var _checkoutReport = require('./webadmin/checkout-report');

var _checkoutReport2 = _interopRequireDefault(_checkoutReport);

var _lastBookingAdmission = require('./webadmin/last-booking-admission');

var _lastBookingAdmission2 = _interopRequireDefault(_lastBookingAdmission);

var _memberReport = require('./webadmin/member-report');

var _memberReport2 = _interopRequireDefault(_memberReport);

var _baseReport = require('./webadmin/base-report');

var _baseReport2 = _interopRequireDefault(_baseReport);

var _classCopyProgressLine = require('./webadmin/class-copy-progress-line');

var _classCopyProgressLine2 = _interopRequireDefault(_classCopyProgressLine);

var _stepProgressGroup = require('./webadmin/step-progress-group');

var _stepProgressGroup2 = _interopRequireDefault(_stepProgressGroup);

var _webLocalSetting = require('./webadmin/web-local-setting');

var _webLocalSetting2 = _interopRequireDefault(_webLocalSetting);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    webadmin: {
        namespaced: true,
        modules: {
            admission: _admission2.default,
            payrollStatistics: _payrollStatistics2.default,
            configure: _configure2.default,
            crm: _crm2.default,
            orderDetailsTotalSale: _orderDetailsTotalSale2.default,
            invoice: _invoice2.default,
            bookingTotalList: _bookingTotalList2.default,
            print: _print2.default,
            ticketsUsedReport: _ticketsUsedReport2.default,
            orderInvoiceList: _orderInvoiceList2.default,
            checkoutReport: _checkoutReport2.default,
            lastBookingAdmissionReport: _lastBookingAdmission2.default,
            memberReport: _memberReport2.default,
            baseReport: _baseReport2.default,
            stepProgressGroup: _stepProgressGroup2.default,
            classCopyProgressLine: _classCopyProgressLine2.default,
            webLocalSetting: _webLocalSetting2.default
        }
    },
    pos: _pos2.default,
    filters: _filters2.default
};

},{"./filters":1591,"./pos":1593,"./webadmin/admission":1594,"./webadmin/base-report":1596,"./webadmin/booking-total-list":1597,"./webadmin/checkout-report":1598,"./webadmin/class-copy-progress-line":1599,"./webadmin/configure":1600,"./webadmin/crm":1601,"./webadmin/invoice":1602,"./webadmin/last-booking-admission":1603,"./webadmin/member-report":1604,"./webadmin/order-details-total-sale":1605,"./webadmin/order-invoice-list":1606,"./webadmin/payroll-statistics":1607,"./webadmin/print":1608,"./webadmin/step-progress-group":1609,"./webadmin/tickets-used-report":1610,"./webadmin/web-local-setting":1611}],1593:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _values = require('babel-runtime/core-js/object/values');

var _values2 = _interopRequireDefault(_values);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _getters, _mutations;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var types = {
    SET_ORDER: 'SET_ORDER',
    POS_INCREASE: 'POS_INCREASE',
    POS_SETSTATUS: 'POS_SETSTATUS',
    CHANGE_EDIT_STATUS: 'CHANGE_EDIT_STATUS',
    CLEAN_SELECT_ORDER: 'CLEAN_SELECT_ORDER',
    CHECK_MULTI_BUY: 'CHECK_MULTI_BUY',
    POS_REFUND_SETSTATUS: 'POS_REFUND_SETSTATUS',
    RESET_REFUND: 'RESET_REFUND',
    SET_CARRIER: 'SET_CARRIER',
    RESET_CARRIER: 'RESET_CARRIER',
    SET_ORDER_REMARK: 'SET_ORDER_REMARK',
    SET_INVOICE_REMARK: 'SET_INVOICE_REMARK',
    SET_INVOICE_NUMBER: 'SET_INVOICE_NUMBER',
    SHOW_MANAUAL_INVOICE: 'SHOW_MANAUAL_INVOICE',
    BOUGHT_ITEM: 'BOUGHT_ITEM',
    RESET_BOUGHT_ITEM: 'RESET_BOUGHT_ITEM',
    SET_ORDER_SALSEMAN: 'SET_ORDER_SALSEMAN',
    CALCULATE_DISCOUNT_DETAIL_MONEY: 'CALCULATE_DISCOUNT_DETAIL_MONEY',
    CHANGE_EDIT_AJAXING: 'CHANGE_EDIT_AJAXING',
    CHANGE_FETCH_AJAXING: 'CHANGE_FETCH_AJAXING',
    CHANGE_COMMONLY_AJAXING: 'CHANGE_COMMONLY_AJAXING',
    CHANGE_COMMONLY_DISCOUNT_AJAXING: 'CHANGE_COMMONLY_DISCOUNT_AJAXING',
    GET_ACTIVE_STUDIO_ID: 'GET_ACTIVE_STUDIO_ID',
    CHANGE_CREDIT_INPUT: 'CHANGE_CREDIT_INPUT',
    CREDIT_INFO: 'CREDIT_INFO',
    SET_PAYMENT_METHOD: 'SET_PAYMENT_METHOD',
    CHANGE_CUSTOM_USER_INPUT: 'CHANGE_CUSTOM_USER_INPUT'
};

var state = {
    'time_start': null,
    'time_end': null,
    'select_branch_id': '',
    'is_17fit': '',
    'payment_status': '',
    'payment_filter': false,
    'orders': [],
    'page_meta': [],
    'product_name': null,
    'member_name': null,
    'order_id': null,
    'product_list': [],
    'product_filter': '',
    'product_category': [],
    'product_category_selected': 0,
    'product_show_list': [],
    'select_order': [],
    'is_order_edit': false,
    'select_product': [],
    // 'action_product':null,
    'discount_value': null,
    'discount_type': null,
    'discount_reason': '',
    'buy_number': 1,
    'append_mode': 'add',
    'select_order_detail': {},
    'current_selected_product_type': '',
    'custom_total': 0,
    'refund': {
        ids: {},
        moneys: {},
        reason: ''
    },
    'invoice_issue_methods': {},
    'issue_method_select': '',
    'issue_method_carrier': {
        num: '',
        name: ''
    },
    auto_allowance_issue: null,
    'invoice_remark': '',
    'alert_obj': [],
    'current_order_detail': {},
    'studio_payment_methods': [],
    'payment_method_select': '',
    'bought_details': {
        title: '',
        items: [],
        detail_id: null
    },
    selected_salseman: {},
    'edit_ajaxing': false,
    'fetch_ajaxing': true,
    'fetch_order_ajaxing': false,
    'get_commonly_used_item_ajaxing': false,
    'get_commonly_used_discounts_ajaxing': false,
    'commonly_used_items': [],
    'commonly_used_discounts': [],
    'filter_member_name': '',
    'filter_member_id': '',
    'filter_invoice_number': '',
    'filter_item_name': '',
    'filter_checkout_member_name': '',
    'filter_issue_status': '',
    'filter_payment_statuses': [],
    'filter_payment_types': [],
    'credit_input': {
        'auth_type': 'input',
        'exist_main_card': 0,
        'main_card_num': '',
        'credit_num': '',
        'expi_mon': '',
        'expi_year': '',
        'cvs': '',
        'is_checked': false,
        'auto_pay_card_num': '',
        'exist_auto_pay_cards': false
    },
    'custom_user_input': {
        key: ''
    }
};
var api = {
    getOrder: function getOrder(order_id, payload) {
        var payment_filter = payload.payment || null;
        var bind_auto_pay_plan_detail_id = payload.bind_auto_pay_plan_detail_id || null;
        return new _promise2.default(function (resolve, reject) {
            Vue.http.get('/adminapi/pos/get_order/' + order_id, {
                params: {
                    payment_filter: payment_filter,
                    bind_auto_pay_plan_detail_id: bind_auto_pay_plan_detail_id
                }
            }).then(function (_ref) {
                var data = _ref.data;

                resolve({ order: data });
            }, function (_ref2) {
                var data = _ref2.data;

                reject({ errMessage: data.message, err: data });
            });
        });
    },
    getProductList: function getProductList(payload) {
        return new _promise2.default(function (resolve, reject) {
            Vue.http.get('/adminapi/pos/get_product_list/' + payload.branch_id + '/' + payload.type).then(function (_ref3) {
                var data = _ref3.data;

                resolve({ data: data });
            }, function (_ref4) {
                var data = _ref4.data;

                reject({ errMessage: '開啟列表發生錯誤', err: data });
            });
        });
    },
    getCommonlyUsedDiscountList: function getCommonlyUsedDiscountList(payload) {
        return new _promise2.default(function (resolve, reject) {
            Vue.http.get('/adminapi/commonly_used_discounts/branch/' + payload.branch_id).then(function (_ref5) {
                var data = _ref5.data;

                resolve({ data: data });
            }, function (_ref6) {
                var data = _ref6.data;

                reject({ errMessage: '開啟常用折扣項目發生錯誤', err: data });
            });
        });
    },
    removcOrderDetail: function removcOrderDetail(order_detail_id) {
        return new _promise2.default(function (resolve, reject) {
            Vue.http.post('/adminapi/pos/remove_order_detail/' + order_detail_id).then(function (_ref7) {
                var data = _ref7.data;

                resolve({ status: data.status });
            }, function (_ref8) {
                var data = _ref8.data;

                reject({ errMessage: data.message, err: data });
            });
        });
    },
    invalidOrder: function invalidOrder() {
        return new _promise2.default(function (resolve, reject) {
            Vue.http.post('/adminapi/pos/invalid_order/' + state.select_order.id).then(function (_ref9) {
                var data = _ref9.data;

                resolve({ status: data.status });
            }, function (_ref10) {
                var data = _ref10.data;

                reject({ errMessage: data.message, err: data });
            });
        });
    },
    getOrderList: function getOrderList(payload) {
        var getParams = {
            params: {
                payment_filter: payload.payment_filter,
                member_id: payload.member_id,
                time_start: payload.query_strings.time_start,
                time_end: payload.query_strings.time_end,
                issue_status: payload.query_strings.issue_status,
                invoice_number: payload.query_strings.invoice_number,
                item_name: payload.query_strings.item_name,
                checkout_member: payload.query_strings.checkout_member,
                page: payload.query_strings.page,
                page_size: payload.query_strings.page_size,
                payment_statuses: payload.query_strings.payment_statuses,
                payment_types: payload.query_strings.payment_types
            }
        };
        var url = '/adminapi/pos/get_order_list/' + payload.selected_studio_id;
        if (payload.selected_branch_id > 0) {
            url = '/adminapi/pos/get_order_list/' + payload.selected_studio_id + '/' + payload.selected_branch_id;
        }
        return new _promise2.default(function (resolve, reject) {
            Vue.http.get(url, getParams).then(function (_ref11) {
                var data = _ref11.data;

                resolve({
                    orders: data.orders,
                    page_meta: data.pageMeta
                });
            }, function (_ref12) {
                var data = _ref12.data;

                reject({ errMessage: '取得訂單資料發生錯誤', err: data });
            });
        });
    },
    appendOrderDetail: function appendOrderDetail(payload) {
        // pos/append_order_detail(order_id,[product_type,product_id,amount,discount_type,discount_value])
        return new _promise2.default(function (resolve, reject) {
            Vue.http.post('/adminapi/pos/append_order_detail/' + payload.order_id, {
                'branch_id': payload.branch_id,
                'product_type': payload.product_type,
                'product_id': payload.product_id,
                'amount': payload.amount,
                'discount_type': payload.discount_type,
                'discount_value': payload.discount_value,
                'discount_reason': payload.discount_reason
            }).then(function (_ref13) {
                var data = _ref13.data;

                resolve({ order: data });
            }, function (_ref14) {
                var data = _ref14.data;

                reject({ errMessage: data.message, err: data });
            });
        });
    },
    changeOrderValue: function changeOrderValue(order_id, payload) {
        return new _promise2.default(function (resolve, reject) {
            Vue.http.post('/adminapi/pos/change_order_value/' + order_id, payload).then(function (_ref15) {
                var data = _ref15.data;

                resolve({ order: data });
            }, function (data) {
                reject({ errMessage: '修改訂單資訊發生錯誤', err: data });
            });
        });
    },
    showOrderDetailWithProduct: function showOrderDetailWithProduct(order_detail_id) {
        return new _promise2.default(function (resolve, reject) {
            Vue.http.get('/adminapi/pos/show_order_detail_product/' + order_detail_id).then(function (_ref16) {
                var data = _ref16.data;

                resolve({
                    order_detail: data.order_detail
                });
            }, function (data) {
                reject({ errMessage: '開啟產品發生錯誤', err: data });
            });
        });
    },
    changeOrderDetail: function changeOrderDetail(order_detail_id, payload) {
        return new _promise2.default(function (resolve, reject) {
            Vue.http.post('/adminapi/pos/modify_order_detail/' + order_detail_id, {
                'amount': payload.amount,
                'discount_value': payload.discount_value,
                'discount_type': payload.discount_type,
                'discount_reason': payload.discount_reason
            }).then(function (_ref17) {
                var data = _ref17.data;

                resolve({ order: data });
            }, function (_ref18) {
                var data = _ref18.data;

                reject({ errMessage: data.message, err: data });
            });
        });
    },
    billOrder: function billOrder(order_id, payload) {
        return new _promise2.default(function (resolve, reject) {
            Vue.http.post('/adminapi/pos/bill_order/' + order_id, payload).then(function (_ref19) {
                var data = _ref19.data;

                resolve({
                    data: data.data,
                    success: data.success,
                    order: data.order,
                    order_id: data.orderId
                });
            }, function (data) {
                reject({ errMessage: '結帳發生錯誤', err: data });
            });
        });
    },

    /** [refundOrderDetails description] 
      detailIds: {},
      moneys: {},
      reason: string
    */
    refundOrderDetails: function refundOrderDetails(order_id, _ref20) {
        var detailIds = _ref20.detailIds,
            moneys = _ref20.moneys,
            reason = _ref20.reason,
            auto_allowance_issue = _ref20.auto_allowance_issue,
            payment_method_select = _ref20.payment_method_select;

        return new _promise2.default(function (resolve, reject) {
            Vue.http.post('/adminapi/pos/order/' + order_id + '/refund', {
                detailIds: detailIds,
                moneys: moneys,
                reason: reason,
                auto_allowance_issue: auto_allowance_issue,
                payment_method_select: payment_method_select
            }).then(function (_ref21) {
                var data = _ref21.data;

                resolve({
                    data: data.data,
                    success: data.success,
                    order_id: data.orderId,
                    order: data.order
                });
            }, function (data) {
                reject({ errMessage: '退費發生錯誤', err: data });
            });
        });
    },
    getOrderIssueMethod: function getOrderIssueMethod(order_id) {
        return new _promise2.default(function (resolve, reject) {
            Vue.http.get('/adminapi/invoice/order/' + order_id + '/issue_method').then(function (_ref22) {
                var data = _ref22.data;

                resolve({
                    issue_method: data.issue_method
                });
            }, function (_ref23) {
                var data = _ref23.data;

                reject({ errMessage: '取得發票開立方式發生錯誤', err: data });
            });
        });
    },
    changeOrderIssueMethod: function changeOrderIssueMethod(order_id, _ref24) {
        var issue_method_select = _ref24.issue_method_select,
            issue_method_carrier_num = _ref24.issue_method_carrier_num,
            issue_method_carrier_name = _ref24.issue_method_carrier_name;

        return new _promise2.default(function (resolve, reject) {
            Vue.http.post('/adminapi/invoice/order/' + order_id + '/issue_method', {
                method: issue_method_select,
                carrier_num: issue_method_carrier_num,
                carrier_name: issue_method_carrier_name
            }).then(function (_ref25) {
                var data = _ref25.data;

                resolve({
                    status: data.status
                });
            }, function (_ref26) {
                var data = _ref26.data;

                reject({ errMessage: '修改發票開立方式發生錯誤', err: data });
            });
        });
    },
    orderIssue: function orderIssue(order_id) {
        return new _promise2.default(function (resolve, reject) {
            Vue.http.post('/adminapi/invoice/order/' + order_id).then(function (_ref27) {
                var data = _ref27.data;

                resolve({
                    data: data.data,
                    success: data.success,
                    order: data.order,
                    order_id: data.orderId
                });
            }, function (_ref28) {
                var data = _ref28.data;

                reject({ errMessage: '開立發票發生錯誤', err: data });
            });
        });
    },
    orderAllowance: function orderAllowance(order_id) {
        return new _promise2.default(function (resolve, reject) {
            Vue.http.post('/adminapi/invoice/order/' + order_id + '/allowance').then(function (_ref29) {
                var data = _ref29.data;

                resolve({
                    data: data.data,
                    success: data.success,
                    order_id: data.orderId,
                    order: data.order
                });
            }, function (_ref30) {
                var data = _ref30.data;

                reject({ errMessage: '折讓發票發生錯誤', err: data });
            });
        });
    },
    orderRemark: function orderRemark(order_id, remark) {
        return new _promise2.default(function (resolve, reject) {
            Vue.http.post('/adminapi/pos/order/' + order_id + '/remark', { remark: remark }).then(function (_ref31) {
                var data = _ref31.data;

                resolve({
                    msg: data.msg,
                    code: data.code
                });
            }, function (_ref32) {
                var data = _ref32.data;

                reject({ errMessage: '寫入訂單備註發生錯誤', err: data });
            });
        });
    },
    invoiceRemark: function invoiceRemark(order_id, remark) {
        return new _promise2.default(function (resolve, reject) {
            Vue.http.post('/adminapi/invoice/order/' + order_id + '/remark', { remark: remark }).then(function (_ref33) {
                var data = _ref33.data;

                resolve({
                    msg: data.msg,
                    code: data.code
                });
            }, function (_ref34) {
                var data = _ref34.data;

                reject({ errMessage: '寫入發票備註發生錯誤', err: data });
            });
        });
    },
    changeInvoiceNumber: function changeInvoiceNumber(order_id, invoiceNumber) {
        return new _promise2.default(function (resolve, reject) {
            Vue.http.post('/adminapi/pos/order/' + order_id + '/invoice_number', { invoiceNumber: invoiceNumber }).then(function (_ref35) {
                var data = _ref35.data;

                resolve({
                    order: data
                });
            }, function (_ref36) {
                var data = _ref36.data;

                reject({ errMessage: '寫入發票號碼發生錯誤', err: data });
            });
        });
    },
    getStudioPaumentMethod: function getStudioPaumentMethod(studio_id) {
        return new _promise2.default(function (resolve, reject) {
            Vue.http.get('/adminapi/pos/payment_method/studio/' + studio_id).then(function (_ref37) {
                var data = _ref37.data;

                resolve({
                    payment_methods: data.payment_methods
                });
            }, function (_ref38) {
                var data = _ref38.data;

                reject({ errMessage: '取得支付方式發生錯誤', err: data });
            });
        });
    },
    getBoughtItem: function getBoughtItem(order_detail_id) {
        return new _promise2.default(function (resolve, reject) {
            Vue.http.get('/adminapi/pos/order_detail/' + order_detail_id + '/bought_item').then(function (_ref39) {
                var data = _ref39.data;

                resolve({
                    title: data.title,
                    items: data.items
                });
            }, function (_ref40) {
                var data = _ref40.data;

                reject({ errMessage: '取得訂單項目發生錯誤', err: data });
            });
        });
    },
    invliadTicket: function invliadTicket(ticket_id) {
        return new _promise2.default(function (resolve, reject) {
            Vue.http.post('/adminapi/ticket/' + ticket_id + '/invalid').then(function (_ref41) {
                var data = _ref41.data;

                resolve({});
            }, function (_ref42) {
                var data = _ref42.data;

                reject({ errMessage: '作廢票券發生錯誤', err: data });
            });
        });
    },
    invliadAllTicket: function invliadAllTicket(order_detail_id) {
        return new _promise2.default(function (resolve, reject) {
            Vue.http.post('/adminapi/ticket/invalidAll/order_detail/' + order_detail_id).then(function (_ref43) {
                var data = _ref43.data;

                resolve({});
            }, function (_ref44) {
                var data = _ref44.data;

                reject({ errMessage: '作廢全部票券發生錯誤', err: data });
            });
        });
    },
    changePaymentMethod: function changePaymentMethod(order_id, studio_payment_method_id) {
        return new _promise2.default(function (resolve, reject) {
            Vue.http.post('/adminapi/pos/order/' + order_id + '/payment_method', { studio_payment_method_id: studio_payment_method_id }).then(function (_ref45) {
                var data = _ref45.data;

                resolve({
                    order: data
                });
            }, function (_ref46) {
                var data = _ref46.data;

                reject({ errMessage: '修改支付方式發生錯誤', err: data });
            });
        });
    },
    changeOrderSalseman: function changeOrderSalseman(orderId, memberId) {
        return new _promise2.default(function (resolve, reject) {
            Vue.http.post('/adminapi/pos/order/' + orderId + '/salseman/member/' + memberId).then(function (_ref47) {
                var data = _ref47.data;

                resolve({
                    order: data
                });
            }, function (_ref48) {
                var data = _ref48.data;

                reject({ errMessage: '修改業務人員發生錯誤', err: data });
            });
        });
    },
    seventeenExportOrder: function seventeenExportOrder(orderId) {
        return new _promise2.default(function (resolve, reject) {
            Vue.http.post('/adminapi/pos/order/' + orderId + '/seventeen_export').then(function (_ref49) {
                var data = _ref49.data;

                resolve({ message: data.Message });
            }, function (_ref50) {
                var data = _ref50.data;

                reject({ errMessage: '立即撥款發生錯誤', err: data });
            });
        });
    },
    invalidSuccessOrder: function invalidSuccessOrder(orderId) {
        return new _promise2.default(function (resolve, reject) {
            Vue.http.post('/adminapi/pos/order/' + orderId + '/invalid-success-order').then(function (_ref51) {
                var data = _ref51.data;

                resolve({ status: data.status });
            }, function (_ref52) {
                var data = _ref52.data;

                reject({ errMessage: data.message, err: data });
            });
        });
    }
};
// getters
var getters = (_getters = {}, (0, _defineProperty3.default)(_getters, types.CHECK_MULTI_BUY, function (state) {
    return ['physical_products', 'ticket_settings'].indexOf(state.current_selected_product_type) != -1 ? true : false;
}), (0, _defineProperty3.default)(_getters, types.SHOW_MANAUAL_INVOICE, function (state, getters, rootState) {
    return state.select_order && !state.select_order.invoice_active && state.select_order.total > 0 ? true : false;
}), (0, _defineProperty3.default)(_getters, types.CALCULATE_DISCOUNT_DETAIL_MONEY, function (state) {
    return function (total, discountType, discountValue) {
        discountType = parseInt(discountType);
        switch (discountType) {
            case 1:
                return discountValue;
                break;
            case 2:
                return Math.round(total * (discountValue / 100));
                break;
            default:
                return discountValue;
        }
    };
}), (0, _defineProperty3.default)(_getters, types.GET_ACTIVE_STUDIO_ID, function (state, getters, rootState) {
    return rootState.is_17fit ? state.select_order.studio_id : rootState.user_studio_id;
}), _getters);

// actions
var actions = {
    updateAllStatus: function updateAllStatus(context, data) {
        data.map(function (item) {
            context.commit('POS_SETSTATUS', item);
        });
    },
    openProductList: function openProductList(context, payload) {
        var _this = this;

        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            return _context.abrupt('return', api.getProductList(payload).then(function (response) {
                                context.commit('POS_SETSTATUS', { 'key': 'product_list', 'value': response.data.list });
                                context.commit('POS_SETSTATUS', { 'key': 'product_category', 'value': response.data.type });
                                context.commit('POS_SETSTATUS', { 'key': 'product_show_list', 'value': response.data.show_list });
                                // context.commit('POS_SETSTATUS', {'key':'action_product','value':payload.type});
                            }).catch(function (response) {
                                actions.showJsonExceptionMessage(context, { errMessage: response.errMessage, err: response.err });
                            }));

                        case 1:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },
    getCommonlyUsedDiscountList: function getCommonlyUsedDiscountList(context, payload) {
        var _this2 = this;

        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            context.commit(types.CHANGE_COMMONLY_DISCOUNT_AJAXING, { status: true });
                            return _context2.abrupt('return', api.getCommonlyUsedDiscountList(payload).then(function (response) {
                                context.commit('POS_SETSTATUS', { 'key': 'commonly_used_discounts', 'value': response.data.items });
                                context.commit(types.CHANGE_COMMONLY_DISCOUNT_AJAXING, { status: false });
                            }).catch(function (response) {
                                actions.showJsonExceptionMessage(context, { errMessage: response.errMessage, err: response.err });
                                context.commit(types.CHANGE_COMMONLY_DISCOUNT_AJAXING, { status: false });
                            }));

                        case 2:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }))();
    },
    getOrder: function getOrder(context, payload) {
        var _this3 = this;

        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
            var response;
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            if (!(context.state.fetch_order_ajaxing && moment().diff(context.state.fetch_order_ajaxing, 'seconds') <= 15)) {
                                _context3.next = 3;
                                break;
                            }

                            $17.swal({
                                title: '系統忙碌中',
                                text: "因系統正在新增或搜尋訂單，請耐心等候後再重新嘗試",
                                type: 'warning',
                                showCancelButton: false,
                                confirmButtonText: '確定'
                            });
                            throw 'request not finished';

                        case 3:
                            _context3.prev = 3;

                            context.commit('POS_SETSTATUS', { 'key': 'fetch_order_ajaxing', 'value': moment() });
                            _context3.next = 7;
                            return api.getOrder(payload.order_id, payload);

                        case 7:
                            response = _context3.sent;

                            context.commit(types.SET_ORDER, response);
                            context.commit('POS_SETSTATUS', { 'key': 'invoice_remark', 'value': response.order.invoice_remark });
                            context.commit('POS_SETSTATUS', { 'key': 'fetch_order_ajaxing', 'value': false });
                            _context3.next = 19;
                            break;

                        case 13:
                            _context3.prev = 13;
                            _context3.t0 = _context3['catch'](3);

                            context.dispatch('setWeblog', { 'name': '後台POS', 'message': _context3.t0.err }, { root: true });
                            context.commit('POS_SETSTATUS', { 'key': 'fetch_order_ajaxing', 'value': false });
                            $17.swal({
                                title: _context3.t0.errMessage,
                                text: "",
                                type: 'warning',
                                showCancelButton: false,
                                confirmButtonText: '確定'
                            });
                            // $.unblockUI();
                            throw false;

                        case 19:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3, [[3, 13]]);
        }))();
    },
    removeDetail: function removeDetail(context, payload) {
        $17.swal({
            title: '刪除確認？',
            text: "確認刪除此項目",
            type: 'warning'
        }, function () {
            actions.changeEditStatus(context, true);
            api.removcOrderDetail(payload.order_detail_id).then(function (response) {
                if (response.status) {
                    context.dispatch('getOrder', { order_id: context.state.select_order.id });
                }
            }).catch(function (response) {
                actions.showJsonExceptionMessage(context, { errMessage: response.errMessage, err: response.err });
            });
            actions.changeEditStatus(context, false);
        });
    },
    openOrCreateOrder: function openOrCreateOrder(context, payload) {
        var _this4 = this;

        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
            var order_id, payment, isPending, order;
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            _context4.next = 2;
                            return context.dispatch('resetSelectOrder');

                        case 2:
                            order_id = payload.order_id ? payload.order_id : '';
                            payment = payload.payment == 0 ? payload.payment : 1;
                            _context4.next = 6;
                            return context.dispatch('getOrder', { 'order_id': order_id, 'payment': payment, 'bind_auto_pay_plan_detail_id': payload.bind_auto_pay_plan_detail_id });

                        case 6:
                            if (!context.state.select_order.member_id) {
                                _context4.next = 11;
                                break;
                            }

                            _context4.next = 9;
                            return context.dispatch('filters/getMember', context.state.select_order.member_id, { root: true });

                        case 9:
                            _context4.next = 13;
                            break;

                        case 11:
                            _context4.next = 13;
                            return context.dispatch('filters/resetSelectedMember', null, { root: true });

                        case 13:
                            if (!!context.state.select_order.branch_id) {
                                context.commit('POS_SETSTATUS', { 'key': 'select_branch_id', value: context.state.select_order.branch_id });
                            }

                            if (payload.skipPendingError) {
                                _context4.next = 23;
                                break;
                            }

                            isPending = false;
                            order = context.state.select_order;

                            if (order.checkout_pending || order.refund_pending || order.invoice_issue_pending || order.invoice_allowance_pending) {
                                isPending = true;
                            }

                            if (!isPending) {
                                _context4.next = 23;
                                break;
                            }

                            $17.swal({
                                title: '無法開啟',
                                text: '此訂單尚未處理完成',
                                type: 'warning',
                                showCancelButton: false
                            });
                            $.unblockUI();
                            throw Error("Open pending order error.");

                        case 23:
                            _context4.next = 25;
                            return context.commit(types.CHANGE_EDIT_STATUS, payload.status);

                        case 25:
                            payload.successCallBack && payload.successCallBack();

                        case 26:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this4);
        }))();
    },
    checkOrderPaymentStatus: function checkOrderPaymentStatus(context, payload) {
        var order = context.state.select_order;
        if (payload.payment == 1 && !order.payment_status || payload.payment == 0 && order.payment_status) {
            return false;
        };
        return true;
    },
    invalidOrder: function invalidOrder(context, payload) {
        var vm = this;
        $17.swal({
            title: '刪除確認？',
            text: "確認刪除此訂單",
            type: 'warning'
        }, function () {
            actions.changeEditStatus(context, true);
            $('#order-edit').modal('hide');
            api.invalidOrder().then(function (response) {
                if (response.status) {
                    context.dispatch('resetSelectOrder');
                    payload.successCallBack && payload.successCallBack();
                }
            }).catch(function (response) {
                actions.showJsonExceptionMessage(context, { errMessage: response.errMessage, err: response.err });
            });
            actions.changeEditStatus(context, false);
        });
    },
    appendOrderDetail: function appendOrderDetail(_ref53, payload) {
        var _this5 = this;

        var state = _ref53.state,
            dispatch = _ref53.dispatch,
            commit = _ref53.commit;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5() {
            return _regenerator2.default.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            actions.changeEditStatus({ commit: commit }, true);
                            _context5.next = 3;
                            return api.appendOrderDetail(payload).then(function (response) {
                                dispatch('resetAllSelectProduct');
                                commit(types.SET_ORDER, response);
                            }).catch(function (response) {
                                actions.showJsonExceptionMessage({ state: state, dispatch: dispatch }, { errMessage: response.errMessage, err: response.err });
                            });

                        case 3:
                            actions.changeEditStatus({ commit: commit }, false);

                        case 4:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this5);
        }))();
    },
    getOrderList: function getOrderList(_ref54) {
        var state = _ref54.state,
            commit = _ref54.commit,
            rootState = _ref54.rootState,
            dispatch = _ref54.dispatch;

        if (!rootState.filters.selected_studio_id || rootState.filters.selected_studio_id == 0) {
            console.warn('pos.store not set selected_studio_id');
            return;
        }
        if (state.time_start === null || state.time_end === null) {
            var today = moment().format('YYYY-MM-DD');
            commit(types.POS_SETSTATUS, { 'key': 'time_start', value: today });
            commit(types.POS_SETSTATUS, { 'key': 'time_end', value: today });
        }
        var stateTimeStart = moment(state.time_start);
        var stateTimeEnd = moment(state.time_end);
        if (!stateTimeStart && !stateTimeEnd || !moment(stateTimeStart).isValid() || !moment(stateTimeEnd).isValid() || Math.abs(moment(stateTimeStart).diff(stateTimeEnd, 'days')) > 31 && state.filter_time_limit !== 'no_limit') {
            $17.swal({
                title: '日期錯誤',
                text: '查詢區間不可大於一個月',
                type: 'warning',
                showCancelButton: false
            });
            return false;
        }
        if (moment(stateTimeEnd).isBefore(stateTimeStart) || moment(stateTimeStart).isAfter(stateTimeEnd)) {
            $17.swal({
                title: '日期錯誤',
                text: '開始日期不可晚於結束日期 結束日期不可早於開始日期',
                type: 'warning',
                showCancelButton: false
            });
            return false;
        }

        var pageFromQuery = $17.getUrlQueryStrings().hasOwnProperty('page') ? $17.getUrlQueryStrings()['page'] : 1;
        var orderListPage = state.page ? state.page : pageFromQuery;
        var payload = {
            'selected_studio_id': rootState.filters.selected_studio_id,
            'selected_branch_id': rootState.filters.selected_branch_id,
            'payment_filter': state.payment_filter,
            'member_id': state.filter_member_id,
            'query_strings': {
                'time_start': state.time_start,
                'time_end': state.time_end,
                'issue_status': state.filter_issue_status,
                'payment_statuses': state.filter_payment_statuses,
                'payment_types': state.filter_payment_types,
                'invoice_number': state.filter_invoice_number,
                'item_name': state.filter_item_name,
                'checkout_member': state.filter_checkout_member_name,
                'page': orderListPage,
                'page_size': state.page_size ? state.page_size : 25
            }
        };
        if (state.payment_filter != 1) {
            delete payload.query_strings.issue_status;
            delete payload.query_strings.invoice_number;
            delete payload.query_strings.checkout_member;
        }
        commit(types.CHANGE_FETCH_AJAXING, { status: true });
        $.blockUI();
        api.getOrderList(payload).then(function (response) {
            commit(types.POS_SETSTATUS, { 'key': 'orders', value: response.orders });
            commit(types.POS_SETSTATUS, { 'key': 'page_meta', value: response.page_meta });
            commit(types.CHANGE_FETCH_AJAXING, { status: false });
            $.unblockUI();
        }).catch(function (response) {
            actions.showJsonExceptionMessage({ state: state, dispatch: dispatch }, { errMessage: response.errMessage, err: response.err });
            commit(types.CHANGE_FETCH_AJAXING, { status: false });
            $.unblockUI();
        });
    },
    resetAllSelectProduct: function resetAllSelectProduct(_ref55) {
        var commit = _ref55.commit;

        commit(types.POS_SETSTATUS, { 'key': 'select_product', value: {} });
        commit(types.POS_SETSTATUS, { 'key': 'buy_number', value: 1 });
        commit(types.POS_SETSTATUS, { 'key': 'discount_value', value: null });
        commit(types.POS_SETSTATUS, { 'key': 'discount_type', value: null });
        commit(types.POS_SETSTATUS, { 'key': 'discount_reason', value: null });
    },
    changeOrderValue: function changeOrderValue(_ref56, payload) {
        var _this6 = this;

        var state = _ref56.state,
            commit = _ref56.commit,
            rootState = _ref56.rootState,
            dispatch = _ref56.dispatch;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6() {
            return _regenerator2.default.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            if (state.select_order.id) {
                                _context6.next = 2;
                                break;
                            }

                            return _context6.abrupt('return');

                        case 2:
                            _context6.next = 4;
                            return api.changeOrderValue(state.select_order.id, payload).then(function (response) {
                                commit(types.SET_ORDER, response);
                            }).catch(function (response) {
                                actions.showJsonExceptionMessage({ state: state, dispatch: dispatch }, { errMessage: response.errMessage, err: response.err });
                            });

                        case 4:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, _this6);
        }))();
    },
    changeOrderDetail: function changeOrderDetail(_ref57, payload) {
        var _this7 = this;

        var state = _ref57.state,
            commit = _ref57.commit,
            rootState = _ref57.rootState,
            dispatch = _ref57.dispatch;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7() {
            return _regenerator2.default.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            actions.changeEditStatus({ commit: commit }, true);
                            _context7.next = 3;
                            return api.changeOrderDetail(state.select_order_detail.id, payload).then(function (response) {
                                commit(types.SET_ORDER, response);
                            }).catch(function (response) {
                                actions.showJsonExceptionMessage({ state: state, dispatch: dispatch }, { errMessage: response.errMessage, err: response.err });
                            });

                        case 3:
                            actions.changeEditStatus({ commit: commit }, false);

                        case 4:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee7, _this7);
        }))();
    },
    showOrderDetailWithProduct: function showOrderDetailWithProduct(_ref58, order_detail_id) {
        var _this8 = this;

        var state = _ref58.state,
            commit = _ref58.commit,
            dispatch = _ref58.dispatch;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8() {
            return _regenerator2.default.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            _context8.next = 2;
                            return api.showOrderDetailWithProduct(order_detail_id).then(function (response) {
                                commit(types.POS_SETSTATUS, { 'key': 'select_product', value: response.order_detail.product });
                                commit(types.POS_SETSTATUS, { 'key': 'buy_number', value: response.order_detail.qty });
                                commit(types.POS_SETSTATUS, { 'key': 'current_selected_product_type', value: response.order_detail.product.table_type });

                                if (response.order_detail.order_detail_discount == null) {
                                    return;
                                }
                                commit(types.POS_SETSTATUS, { 'key': 'discount_value', value: response.order_detail.order_detail_discount.value });
                                commit(types.POS_SETSTATUS, { 'key': 'discount_type', value: response.order_detail.order_detail_discount.type });
                                commit(types.POS_SETSTATUS, { 'key': 'discount_reason', value: response.order_detail.order_detail_discount.reason });
                            }).catch(function (response) {
                                actions.showJsonExceptionMessage({ state: state, dispatch: dispatch }, { errMessage: response.errMessage, err: response.err });
                            });

                        case 2:
                        case 'end':
                            return _context8.stop();
                    }
                }
            }, _callee8, _this8);
        }))();
    },
    billOrder: function billOrder(_ref59, _ref60) {
        var _this9 = this;

        var state = _ref59.state,
            commit = _ref59.commit,
            dispatch = _ref59.dispatch,
            rootState = _ref59.rootState;
        var order_id = _ref60.order_id,
            successCallBack = _ref60.successCallBack,
            failCallBack = _ref60.failCallBack,
            alertCallBack = _ref60.alertCallBack,
            skipAlert = _ref60.skipAlert;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee9() {
            var data, payment_method_select_full;
            return _regenerator2.default.wrap(function _callee9$(_context9) {
                while (1) {
                    switch (_context9.prev = _context9.next) {
                        case 0:
                            data = {};


                            data = {
                                'credit_info': {},
                                'skip_alert': skipAlert
                            };

                            if (!(state.issue_method_select && !actions.checkIssueMethodAvalible(rootState))) {
                                _context9.next = 4;
                                break;
                            }

                            return _context9.abrupt('return');

                        case 4:
                            payment_method_select_full = {};


                            if ((0, _typeof3.default)(state.studio_payment_methods[state.select_order.branch_id]) === undefined) {
                                $17.swal({
                                    title: '目前尚未選擇任何支付方式',
                                    text: "",
                                    showCancelButton: false,
                                    type: 'warning'
                                });
                            }
                            payment_method_select_full = state.studio_payment_methods[state.select_order.branch_id].reduce(function (carry, item) {
                                if (item.id == state.payment_method_select) {
                                    carry = item;
                                }

                                return carry;
                            }, { 'payment_type': 1 });

                            if (!(payment_method_select_full.payment_type === 2 && !actions.checkCreditInfo(state.credit_input))) {
                                _context9.next = 9;
                                break;
                            }

                            return _context9.abrupt('return');

                        case 9:

                            if (state.credit_input.auth_type == 'input' && state.credit_input.credit_num.length != 0 && state.credit_input.cvs.length != 0) {
                                data['credit_info'] = {
                                    'auth_type': state.credit_input.auth_type,
                                    'credit_num': state.credit_input.credit_num,
                                    'cvs': state.credit_input.cvs,
                                    'expi_mon': state.credit_input.expi_mon,
                                    'expi_year': state.credit_input.expi_year
                                };
                            }

                            if (!(state.credit_input.auth_type == 'auth')) {
                                _context9.next = 15;
                                break;
                            }

                            if (!(!state.credit_input.exist_main_card || !state.select_order.allow_main_credit)) {
                                _context9.next = 14;
                                break;
                            }

                            $17.swal({
                                title: '支付方式錯誤',
                                text: "請聯繫客戶在線上輸入新的信用卡，或選擇其他支付方式",
                                showCancelButton: false,
                                type: 'warning'
                            });
                            return _context9.abrupt('return');

                        case 14:
                            data['credit_info'] = {
                                'auth_type': state.credit_input.auth_type
                            };

                        case 15:
                            if (!(state.credit_input.auth_type == 'auth-auto-pay-plan')) {
                                _context9.next = 20;
                                break;
                            }

                            if (!(!state.credit_input.exist_auto_pay_cards || !state.select_order.is_auto_pay_order)) {
                                _context9.next = 19;
                                break;
                            }

                            $17.swal({
                                title: '支付方式錯誤',
                                text: "尚未有授權信用卡，請使用輸入信用卡，或選擇其他支付方式",
                                showCancelButton: false,
                                type: 'warning'
                            });
                            return _context9.abrupt('return');

                        case 19:
                            data['credit_info'] = {
                                'auth_type': state.credit_input.auth_type
                            };

                        case 20:
                            if (state.custom_user_input.key.length != 0) {
                                data['third_custom_user_key'] = state.custom_user_input.key;
                            }
                            if (state.select_order.is_auto_pay_order) {
                                data['bind_auto_pay_plan_credit_card_payload'] = 1;
                            }
                            _context9.next = 24;
                            return api.billOrder(order_id, data).then(function (response) {
                                commit('POS_SETSTATUS', { 'key': 'alert_obj', 'value': response.data });
                                commit('POS_SETSTATUS', { 'key': 'order_id', 'value': response.order_id });
                                commit('POS_SETSTATUS', { 'key': 'current_order_detail', 'value': response.order });
                                if (response.success) {
                                    commit(types.CREDIT_INFO);
                                    commit('CHANGE_CUSTOM_USER_INPUT', { 'key': 'key', 'value': '' });
                                    successCallBack && successCallBack(response);
                                } else {
                                    if (response.data.show_alert) {
                                        alertCallBack && alertCallBack(response);
                                        return;
                                    }

                                    failCallBack && failCallBack(response);
                                }
                            }).catch(function (response) {
                                var errMessage = response.errMessage;
                                if (response.err.data.message) {
                                    errMessage = response.err.data.message;
                                }
                                actions.showJsonExceptionMessage({ state: state, dispatch: dispatch }, { errMessage: errMessage, err: response.err });
                            });

                        case 24:
                        case 'end':
                            return _context9.stop();
                    }
                }
            }, _callee9, _this9);
        }))();
    },
    resetSelectOrder: function resetSelectOrder(_ref61, payload) {
        var _this10 = this;

        var commit = _ref61.commit,
            dispatch = _ref61.dispatch,
            rootState = _ref61.rootState;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee10() {
            return _regenerator2.default.wrap(function _callee10$(_context10) {
                while (1) {
                    switch (_context10.prev = _context10.next) {
                        case 0:
                            dispatch('getOrderList').then(function () {
                                commit(types.CHANGE_EDIT_STATUS, false);
                                commit(types.CLEAN_SELECT_ORDER);
                                commit(types.CREDIT_INFO);
                                commit('POS_SETSTATUS', { 'key': 'custom_total', value: 0 });
                                commit('CHANGE_CUSTOM_USER_INPUT', { 'key': 'key', 'value': '' });
                                store.dispatch('filters/resetSelectedMember');
                                payload && payload.callback && payload.callback(payload.callbackPayload);
                            });

                        case 1:
                        case 'end':
                            return _context10.stop();
                    }
                }
            }, _callee10, _this10);
        }))();
    },
    refundOrderDetails: function refundOrderDetails(_ref62, _ref63) {
        var _this11 = this;

        var commit = _ref62.commit,
            state = _ref62.state,
            dispatch = _ref62.dispatch;
        var order_id = _ref63.order_id,
            detailIds = _ref63.detailIds,
            moneys = _ref63.moneys,
            reason = _ref63.reason,
            auto_allowance_issue = _ref63.auto_allowance_issue,
            successCallBack = _ref63.successCallBack,
            failCallBack = _ref63.failCallBack,
            payment_method_select = _ref63.payment_method_select;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee11() {
            return _regenerator2.default.wrap(function _callee11$(_context11) {
                while (1) {
                    switch (_context11.prev = _context11.next) {
                        case 0:
                            if (!(!detailIds || (0, _values2.default)(detailIds).indexOf(true) === -1)) {
                                _context11.next = 3;
                                break;
                            }

                            $17.swal({
                                title: '請選擇要退的訂單項目！',
                                text: "",
                                showCancelButton: false,
                                type: 'warning'
                            });
                            return _context11.abrupt('return');

                        case 3:
                            _context11.next = 5;
                            return api.refundOrderDetails(order_id, { detailIds: detailIds, moneys: moneys, reason: reason, auto_allowance_issue: auto_allowance_issue, payment_method_select: payment_method_select }).then(function (response) {
                                commit('POS_SETSTATUS', { 'key': 'alert_obj', 'value': response.data });
                                commit('POS_SETSTATUS', { 'key': 'order_id', 'value': response.order_id });
                                commit('POS_SETSTATUS', { 'key': 'current_order_detail', 'value': response.order });
                                if (response.success) {
                                    commit('POS_REFUND_SETSTATUS', { 'key': 'ids', value: {} });
                                    commit('POS_REFUND_SETSTATUS', { 'key': 'moneys', value: {} });
                                    commit('POS_REFUND_SETSTATUS', { 'key': 'reason', value: "" });
                                    commit('POS_SETSTATUS', { 'key': 'custom_total', value: 0 });
                                    successCallBack && successCallBack(response);
                                } else {
                                    failCallBack && failCallBack(response);
                                }
                            }).catch(function (response) {
                                actions.showJsonExceptionMessage({ state: state, dispatch: dispatch }, { errMessage: response.errMessage, err: response.err });
                            });

                        case 5:
                        case 'end':
                            return _context11.stop();
                    }
                }
            }, _callee11, _this11);
        }))();
    },
    orderEditSucces: function orderEditSucces(_ref64, message) {
        var commit = _ref64.commit;

        $('#order-edit').modal('hide');
        $('#multi-alert-modal').modal('show');
    },
    getOrderIssueMethod: function getOrderIssueMethod(_ref65) {
        var _this12 = this;

        var state = _ref65.state,
            commit = _ref65.commit,
            rootState = _ref65.rootState,
            dispatch = _ref65.dispatch;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee12() {
            return _regenerator2.default.wrap(function _callee12$(_context12) {
                while (1) {
                    switch (_context12.prev = _context12.next) {
                        case 0:
                            _context12.next = 2;
                            return api.getOrderIssueMethod(state.select_order.id).then(function (response) {
                                commit('POS_SETSTATUS', { 'key': 'invoice_issue_methods', 'value': response.issue_method });
                            }).catch(function (response) {
                                actions.showJsonExceptionMessage({ state: state, dispatch: dispatch }, { errMessage: response.errMessage, err: response.err });
                            });

                        case 2:
                        case 'end':
                            return _context12.stop();
                    }
                }
            }, _callee12, _this12);
        }))();
    },
    changeOrderIssueMethod: function changeOrderIssueMethod(_ref66) {
        var _this13 = this;

        var state = _ref66.state,
            commit = _ref66.commit,
            rootState = _ref66.rootState,
            dispatch = _ref66.dispatch;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee13() {
            var num, payload;
            return _regenerator2.default.wrap(function _callee13$(_context13) {
                while (1) {
                    switch (_context13.prev = _context13.next) {
                        case 0:
                            if (state.select_order.id) {
                                _context13.next = 2;
                                break;
                            }

                            return _context13.abrupt('return');

                        case 2:
                            if (state.issue_method_select) {
                                _context13.next = 4;
                                break;
                            }

                            return _context13.abrupt('return');

                        case 4:
                            num = state.issue_method_carrier.num;

                            if (!(state.issue_method_select == "UBN" && !actions.checkUBNLength(num))) {
                                _context13.next = 8;
                                break;
                            }

                            commit('SET_CARRIER', { 'key': 'num', 'value': '' });
                            return _context13.abrupt('return');

                        case 8:

                            if (state.issue_method_select == "LoveCode" && state.issue_method_carrier.num) {
                                num = state.issue_method_carrier.num.love_code;
                            }

                            payload = {
                                'issue_method_select': state.issue_method_select,
                                'issue_method_carrier_num': num,
                                'issue_method_carrier_name': state.issue_method_carrier.name
                            };

                            actions.changeEditStatus({ state: state, commit: commit, rootState: rootState }, true);
                            _context13.next = 13;
                            return api.changeOrderIssueMethod(state.select_order.id, payload).then(function (response) {
                                // commit('POS_SETSTATUS', {'key':'invoice_issue_methods','value':response.issue_method});
                            }).catch(function (response) {
                                actions.showJsonExceptionMessage({ state: state, dispatch: dispatch }, { errMessage: response.errMessage, err: response.err });
                            });

                        case 13:
                            actions.changeEditStatus({ state: state, commit: commit, rootState: rootState }, false);

                        case 14:
                        case 'end':
                            return _context13.stop();
                    }
                }
            }, _callee13, _this13);
        }))();
    },
    orderIssue: function orderIssue(_ref67, _ref68) {
        var _this14 = this;

        var state = _ref67.state,
            commit = _ref67.commit,
            rootState = _ref67.rootState,
            dispatch = _ref67.dispatch;
        var successCallBack = _ref68.successCallBack,
            failCallBack = _ref68.failCallBack;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee14() {
            return _regenerator2.default.wrap(function _callee14$(_context14) {
                while (1) {
                    switch (_context14.prev = _context14.next) {
                        case 0:
                            if (actions.checkIssueMethodAvalible(rootState)) {
                                _context14.next = 2;
                                break;
                            }

                            return _context14.abrupt('return');

                        case 2:
                            _context14.next = 4;
                            return api.orderIssue(state.select_order.id).then(function (response) {
                                commit('POS_SETSTATUS', { 'key': 'alert_obj', 'value': response.data });
                                commit('POS_SETSTATUS', { 'key': 'order_id', 'value': response.order_id });
                                commit('POS_SETSTATUS', { 'key': 'current_order_detail', 'value': response.order });

                                if (response.success) {
                                    successCallBack && successCallBack(response);
                                } else {
                                    failCallBack && failCallBack(response);
                                }
                            }).catch(function (response) {
                                var errMessage = response.errMessage;
                                if (response.err.message) {
                                    errMessage = response.err.message;
                                }
                                actions.showJsonExceptionMessage({ state: state, dispatch: dispatch }, { errMessage: errMessage, err: response.err });
                            });

                        case 4:
                        case 'end':
                            return _context14.stop();
                    }
                }
            }, _callee14, _this14);
        }))();
    },
    orderAllowance: function orderAllowance(_ref69, _ref70) {
        var _this15 = this;

        var state = _ref69.state,
            commit = _ref69.commit,
            dispatch = _ref69.dispatch;
        var successCallBack = _ref70.successCallBack,
            failCallBack = _ref70.failCallBack;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee15() {
            return _regenerator2.default.wrap(function _callee15$(_context15) {
                while (1) {
                    switch (_context15.prev = _context15.next) {
                        case 0:
                            _context15.next = 2;
                            return api.orderAllowance(state.select_order.id).then(function (response) {
                                commit('POS_SETSTATUS', { 'key': 'alert_obj', 'value': response.data });
                                commit('POS_SETSTATUS', { 'key': 'order_id', 'value': response.order_id });
                                commit('POS_SETSTATUS', { 'key': 'current_order_detail', 'value': response.order });

                                if (response.success) {
                                    successCallBack && successCallBack(response);
                                } else {
                                    failCallBack && failCallBack(response);
                                }
                            }).catch(function (response) {
                                actions.showJsonExceptionMessage({ state: state, dispatch: dispatch }, { errMessage: response.errMessage, err: response.err });
                            });

                        case 2:
                        case 'end':
                            return _context15.stop();
                    }
                }
            }, _callee15, _this15);
        }))();
    },
    orderRemark: function orderRemark(_ref71) {
        var state = _ref71.state,
            dispatch = _ref71.dispatch;

        api.orderRemark(state.select_order.id, state.select_order.remark).then(function (response) {}).catch(function (response) {
            actions.showJsonExceptionMessage({ state: state, dispatch: dispatch }, { errMessage: response.errMessage, err: response.err });
        });
    },
    invoiceRemark: function invoiceRemark(_ref72) {
        var state = _ref72.state,
            dispatch = _ref72.dispatch;

        api.invoiceRemark(state.select_order.id, state.invoice_remark).then(function (response) {}).catch(function (response) {
            actions.showJsonExceptionMessage({ state: state, dispatch: dispatch }, { errMessage: response.errMessage, err: response.err });
        });
    },
    changeInvoiceNumber: function changeInvoiceNumber(_ref73) {
        var state = _ref73.state,
            dispatch = _ref73.dispatch;

        api.changeInvoiceNumber(state.select_order.id, state.select_order.invoice_manaual.invoice_number).then(function (response) {}).catch(function (response) {
            actions.showJsonExceptionMessage({ state: state, dispatch: dispatch }, { errMessage: response.errMessage, err: response.err });
        });
    },
    checkIssueMethodAvalible: function checkIssueMethodAvalible(rootState) {
        var num = state.issue_method_carrier.num;
        if (state.issue_method_select == "LoveCode" && state.issue_method_carrier.num) {
            num = state.issue_method_carrier.num.love_code;
        }
        if (state.invoice_issue_methods[state.issue_method_select].need_input && (num == null || num === '')) {
            $17.swal({
                title: '請輸入發票相關資料',
                text: "",
                showCancelButton: false,
                type: 'warning'
            });
            return false;
        }
        if (state.issue_method_select == 'UBN' && state.issue_method_carrier.name == '') {
            $17.swal({
                title: '請輸入抬頭',
                text: "",
                showCancelButton: false,
                type: 'warning'
            });
            return false;
        }
        if (state.issue_method_select == 'CarrierPay2Go' && (rootState.filters.selected_search_member_email == null || rootState.filters.selected_search_member_email == '')) {
            $17.swal({
                title: '此客戶無電子郵件，無法使用會員載具！',
                text: "",
                showCancelButton: false,
                type: 'warning'
            });
            return false;
        }

        return true;
    },
    checkUBNLength: function checkUBNLength(UBNNumber) {
        if (UBNNumber && UBNNumber.length > 8) {
            $17.swal({
                title: '統一編號不可超過 8 碼',
                text: "",
                showCancelButton: false,
                type: 'warning'
            });
            return false;
        }

        return true;
    },
    getStudioPaumentMethod: function getStudioPaumentMethod(_ref74, studioId) {
        var _this16 = this;

        var state = _ref74.state,
            commit = _ref74.commit;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee16() {
            return _regenerator2.default.wrap(function _callee16$(_context16) {
                while (1) {
                    switch (_context16.prev = _context16.next) {
                        case 0:
                            api.getStudioPaumentMethod(studioId).then(function (response) {
                                commit('POS_SETSTATUS', { 'key': 'studio_payment_methods', 'value': response.payment_methods });
                            }).catch(function (response) {
                                actions.showJsonExceptionMessage({ state: state, dispatch: dispatch }, { errMessage: response.errMessage, err: response.err });
                            });

                        case 1:
                        case 'end':
                            return _context16.stop();
                    }
                }
            }, _callee16, _this16);
        }))();
    },
    getBoughtItem: function getBoughtItem(_ref75, order_detail_id) {
        var _this17 = this;

        var commit = _ref75.commit,
            state = _ref75.state,
            dispatch = _ref75.dispatch;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee17() {
            return _regenerator2.default.wrap(function _callee17$(_context17) {
                while (1) {
                    switch (_context17.prev = _context17.next) {
                        case 0:
                            _context17.next = 2;
                            return api.getBoughtItem(order_detail_id).then(function (response) {
                                commit('BOUGHT_ITEM', { 'title': response.title, 'items': response.items, 'detail_id': order_detail_id });
                            }).catch(function (response) {
                                actions.showJsonExceptionMessage({ state: state, dispatch: dispatch }, { errMessage: response.errMessage, err: response.err });
                            });

                        case 2:
                        case 'end':
                            return _context17.stop();
                    }
                }
            }, _callee17, _this17);
        }))();
    },
    invliadTicket: function invliadTicket(_ref76, ticket_id) {
        var _this18 = this;

        var commit = _ref76.commit,
            state = _ref76.state,
            dispatch = _ref76.dispatch;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee18() {
            return _regenerator2.default.wrap(function _callee18$(_context18) {
                while (1) {
                    switch (_context18.prev = _context18.next) {
                        case 0:
                            _context18.next = 2;
                            return api.invliadTicket(ticket_id).then(function (response) {
                                actions.getBoughtItem({ commit: commit }, state.bought_details.detail_id);
                                $17.swal({
                                    title: '此張票券作廢成功',
                                    text: "",
                                    showCancelButton: false,
                                    type: 'success'
                                });
                            }).catch(function (response) {
                                actions.showJsonExceptionMessage({ state: state, dispatch: dispatch }, { errMessage: response.errMessage, err: response.err });
                            });

                        case 2:
                        case 'end':
                            return _context18.stop();
                    }
                }
            }, _callee18, _this18);
        }))();
    },
    invliadAllTicket: function invliadAllTicket(_ref77, order_detail_id) {
        var _this19 = this;

        var commit = _ref77.commit,
            state = _ref77.state,
            dispatch = _ref77.dispatch;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee19() {
            return _regenerator2.default.wrap(function _callee19$(_context19) {
                while (1) {
                    switch (_context19.prev = _context19.next) {
                        case 0:
                            _context19.next = 2;
                            return api.invliadAllTicket(order_detail_id).then(function (response) {
                                actions.getBoughtItem({ commit: commit }, state.bought_details.detail_id);
                                $17.swal({
                                    title: '此筆項目作廢成功',
                                    text: "",
                                    showCancelButton: false,
                                    type: 'success'
                                });
                            }).catch(function (response) {
                                actions.showJsonExceptionMessage({ state: state, dispatch: dispatch }, { errMessage: response.errMessage, err: response.err });
                            });

                        case 2:
                        case 'end':
                            return _context19.stop();
                    }
                }
            }, _callee19, _this19);
        }))();
    },
    changePaymentMethod: function changePaymentMethod(_ref78) {
        var _this20 = this;

        var commit = _ref78.commit,
            state = _ref78.state,
            dispatch = _ref78.dispatch;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee20() {
            return _regenerator2.default.wrap(function _callee20$(_context20) {
                while (1) {
                    switch (_context20.prev = _context20.next) {
                        case 0:
                            actions.changeEditStatus({ commit: commit }, true);
                            _context20.next = 3;
                            return api.changePaymentMethod(state.select_order.id, state.payment_method_select).then(function (response) {
                                commit(types.SET_ORDER, response);
                                actions.changeEditStatus({ commit: commit }, false);
                            }).catch(function (response) {
                                actions.showJsonExceptionMessage({ state: state, dispatch: dispatch }, { errMessage: response.errMessage, err: response.err });
                            });

                        case 3:
                        case 'end':
                            return _context20.stop();
                    }
                }
            }, _callee20, _this20);
        }))();
    },
    changeEditStatus: function changeEditStatus(_ref79, status) {
        var commit = _ref79.commit;

        commit('CHANGE_EDIT_AJAXING', { 'status': status });
    },
    changeOrderSalseman: function changeOrderSalseman(_ref80) {
        var _this21 = this;

        var commit = _ref80.commit,
            state = _ref80.state,
            dispatch = _ref80.dispatch;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee21() {
            return _regenerator2.default.wrap(function _callee21$(_context21) {
                while (1) {
                    switch (_context21.prev = _context21.next) {
                        case 0:
                            _context21.next = 2;
                            return api.changeOrderSalseman(state.select_order.id, state.selected_salseman.id).then(function (response) {
                                commit(types.SET_ORDER, response);
                            }).catch(function (response) {
                                actions.showJsonExceptionMessage({ state: state, dispatch: dispatch }, { errMessage: response.errMessage, err: response.err });
                            });

                        case 2:
                        case 'end':
                            return _context21.stop();
                    }
                }
            }, _callee21, _this21);
        }))();
    },
    clearOrderSalseman: function clearOrderSalseman(_ref81) {
        var _this22 = this;

        var commit = _ref81.commit,
            state = _ref81.state,
            dispatch = _ref81.dispatch;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee22() {
            return _regenerator2.default.wrap(function _callee22$(_context22) {
                while (1) {
                    switch (_context22.prev = _context22.next) {
                        case 0:
                            commit('SET_ORDER_SALSEMAN', {});
                            _context22.next = 3;
                            return api.changeOrderSalseman(state.select_order.id, '').then(function (response) {
                                commit(types.SET_ORDER, response);
                            }).catch(function (err) {
                                actions.showJsonExceptionMessage({ state: state, dispatch: dispatch }, err.errMessage);
                            });

                        case 3:
                        case 'end':
                            return _context22.stop();
                    }
                }
            }, _callee22, _this22);
        }))();
    },
    seventeenExportOrder: function seventeenExportOrder(_ref82) {
        var _this23 = this;

        var commit = _ref82.commit,
            state = _ref82.state,
            dispatch = _ref82.dispatch;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee23() {
            return _regenerator2.default.wrap(function _callee23$(_context23) {
                while (1) {
                    switch (_context23.prev = _context23.next) {
                        case 0:
                            $.blockUI();
                            _context23.next = 3;
                            return api.seventeenExportOrder(state.select_order.id).then(function (response) {
                                dispatch('getOrder', { order_id: state.select_order.id }).finally(function (res) {
                                    return $.unblockUI();
                                });
                                var msg = response.message ? response.message : '撥款成功';
                                $.unblockUI();
                                $17.swal({
                                    title: msg,
                                    showCancelButton: false,
                                    type: 'success'
                                });
                            }).catch(function (response) {
                                $.unblockUI();
                                var msg = response.err.hasOwnProperty('message') ? response.err.message : response.errMessage;
                                actions.showJsonExceptionMessage({ state: state, dispatch: dispatch }, { errMessage: msg, err: response.err });
                            });

                        case 3:
                        case 'end':
                            return _context23.stop();
                    }
                }
            }, _callee23, _this23);
        }))();
    },
    showJsonExceptionMessage: function showJsonExceptionMessage(context, errPayload) {
        var message = typeof errPayload.errMessage === 'undefined' ? '發生錯誤，請重新整理' : errPayload.errMessage;
        context.dispatch('setWeblog', { 'name': '後台 POS', 'message': errPayload.err }, { root: true });
        $17.swal({
            title: message,
            text: "",
            type: 'warning',
            showCancelButton: false,
            confirmButtonText: '重新整理'
        }, function () {
            location.reload();
        });
    },
    checkIsValidOrderId: function checkIsValidOrderId(_ref83, payload) {
        var commit = _ref83.commit;

        if (payload.orderId.length != 10) {
            $17.swal({
                title: '訂單編號輸入錯誤',
                text: "",
                type: 'warning',
                showCancelButton: false,
                confirmButtonText: '確定'
            });
            return false;
        }
        return true;
    },
    getCommonlyUsedItem: function getCommonlyUsedItem(_ref84, branchId) {
        var _this24 = this;

        var commit = _ref84.commit,
            state = _ref84.state,
            dispatch = _ref84.dispatch;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee24() {
            var api;
            return _regenerator2.default.wrap(function _callee24$(_context24) {
                while (1) {
                    switch (_context24.prev = _context24.next) {
                        case 0:
                            api = '/adminapi/commonly_used_items';

                            if (branchId !== 0 && branchId !== null && branchId !== '' && branchId !== undefined) {
                                api += '?branch_id=' + branchId;
                            }
                            commit(types.CHANGE_COMMONLY_AJAXING, { status: true });
                            _context24.next = 5;
                            return Vue.http.get(api).then(function (response) {
                                commit('POS_SETSTATUS', { 'key': 'commonly_used_items', 'value': response.body });
                                commit(types.CHANGE_COMMONLY_AJAXING, { status: false });
                            }, function (error) {
                                commit(types.CHANGE_COMMONLY_AJAXING, { status: false });
                                actions.showJsonExceptionMessage({ state: state, dispatch: dispatch }, '取得常用項目發生錯誤');
                            });

                        case 5:
                        case 'end':
                            return _context24.stop();
                    }
                }
            }, _callee24, _this24);
        }))();
    },
    checkCreditInfo: function checkCreditInfo(creditInput) {
        if (creditInput.auth_type == 'auth' || creditInput.auth_type == 'auth-auto-pay-plan') {
            return true;
        }

        if (creditInput.credit_num.length < 13) {
            $17.swal({
                title: '信用卡號長度錯誤',
                text: "",
                type: 'warning',
                showCancelButton: false
            });
            return false;
        }

        if (creditInput.cvs.length < 3 || creditInput.cvs.length > 4) {
            $17.swal({
                title: '安全碼須為 3 碼',
                text: "",
                showCancelButton: false,
                type: 'warning'
            });
            return false;
        }

        var expiDate = creditInput.expi_year + creditInput.expi_mon;

        if (moment(expiDate, 'YYYYMM').isValid() && moment(expiDate, "YYYYMMDD").isBefore(moment())) {
            $17.swal({
                title: '信用卡到期日設定錯誤',
                text: "",
                showCancelButton: false,
                type: 'warning'
            });
            return false;
        }

        return true;
    },
    invalidSuccessOrder: function invalidSuccessOrder(_ref85, _ref86) {
        var _this25 = this;

        var state = _ref85.state,
            commit = _ref85.commit,
            dispatch = _ref85.dispatch;
        var successCallBack = _ref86.successCallBack,
            failCallBack = _ref86.failCallBack;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee25() {
            return _regenerator2.default.wrap(function _callee25$(_context25) {
                while (1) {
                    switch (_context25.prev = _context25.next) {
                        case 0:
                            _context25.next = 2;
                            return api.invalidSuccessOrder(state.select_order.id).then(function (response) {
                                commit('POS_SETSTATUS', { 'key': 'alert_obj', 'value': response.data });
                                commit('POS_SETSTATUS', { 'key': 'order_id', 'value': response.order_id });
                                commit('POS_SETSTATUS', { 'key': 'current_order_detail', 'value': response.order });
                                successCallBack && successCallBack(response);
                            }).catch(function (response) {
                                failCallBack && failCallBack(response);
                                if (!failCallBack) {
                                    actions.showJsonExceptionMessage({ state: state, dispatch: dispatch }, { errMessage: response.errMessage, err: response.err });
                                }
                            });

                        case 2:
                        case 'end':
                            return _context25.stop();
                    }
                }
            }, _callee25, _this25);
        }))();
    }
};

// mutations
var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.POS_SETSTATUS, function (state, payload) {
    state[payload.key] = payload.value;
}), (0, _defineProperty3.default)(_mutations, types.SET_CARRIER, function (state, payload) {
    state.issue_method_carrier[payload.key] = payload.value;
}), (0, _defineProperty3.default)(_mutations, types.RESET_CARRIER, function () {
    var _ref87 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee26(state, payload) {
        return _regenerator2.default.wrap(function _callee26$(_context26) {
            while (1) {
                switch (_context26.prev = _context26.next) {
                    case 0:
                        state.issue_method_carrier.num = null;
                        state.issue_method_carrier.name = '';

                    case 2:
                    case 'end':
                        return _context26.stop();
                }
            }
        }, _callee26, this);
    }));

    return function (_x, _x2) {
        return _ref87.apply(this, arguments);
    };
}()), (0, _defineProperty3.default)(_mutations, types.SET_ORDER, function (state, payload) {
    state.select_order = payload.order;
}), (0, _defineProperty3.default)(_mutations, types.CHANGE_EDIT_STATUS, function (state, status) {
    state.is_order_edit = status;
}), (0, _defineProperty3.default)(_mutations, types.RESET_REFUND, function (state, status) {
    state.refund.ids = {};
    state.refund.moneys = {};
    state.refund.reason = '';
}), (0, _defineProperty3.default)(_mutations, types.CLEAN_SELECT_ORDER, function (state) {
    state.select_order = [];
    state.select_order_detail = [];
    state.select_branch_id = null;
    state.discount_value = 0;
    state.discount_value = 0;
    state.invoice_issue_methods = {};
    state.issue_method_select = '';
    state.issue_method_carrier.name = '';
    state.issue_method_carrier.num = '';
    state.auto_allowance_issue = null;
}), (0, _defineProperty3.default)(_mutations, types.POS_REFUND_SETSTATUS, function (state, payload) {
    var keys = payload.key.split(".");
    if (keys.length == 2) {
        if (!state.refund[keys[0]]) {
            state.refund[keys[0]] = {};
        }
        state.refund[keys[0]][keys[1]] = payload.value;
        return;
    }
    state.refund[payload.key] = payload.value;
}), (0, _defineProperty3.default)(_mutations, types.SET_ORDER_REMARK, function (state, payload) {
    state.select_order.remark = payload.value;
}), (0, _defineProperty3.default)(_mutations, types.SET_INVOICE_REMARK, function (state, payload) {
    state.invoice_remark = payload.value;
}), (0, _defineProperty3.default)(_mutations, types.SET_INVOICE_NUMBER, function (state, value) {
    state.select_order.invoice_manaual.invoice_number = value;
}), (0, _defineProperty3.default)(_mutations, types.BOUGHT_ITEM, function (state, payload) {
    state.bought_details.title = payload.title;
    state.bought_details.items = payload.items;
    state.bought_details.detail_id = payload.detail_id;
}), (0, _defineProperty3.default)(_mutations, types.RESET_BOUGHT_ITEM, function (state, payload) {
    state.bought_details.title = '';
    state.bought_details.items = [];
}), (0, _defineProperty3.default)(_mutations, types.SET_ORDER_SALSEMAN, function (state, payload) {
    state.selected_salseman = payload.salseman;
}), (0, _defineProperty3.default)(_mutations, types.CHANGE_EDIT_AJAXING, function (state, payload) {
    state.edit_ajaxing = payload.status;
}), (0, _defineProperty3.default)(_mutations, types.CHANGE_FETCH_AJAXING, function (state, payload) {
    state.fetch_ajaxing = payload.status;
}), (0, _defineProperty3.default)(_mutations, types.CHANGE_COMMONLY_AJAXING, function (state, payload) {
    state.get_commonly_used_item_ajaxing = payload.status;
}), (0, _defineProperty3.default)(_mutations, types.CHANGE_COMMONLY_DISCOUNT_AJAXING, function (state, payload) {
    state.get_commonly_used_discounts_ajaxing = payload.status;
}), (0, _defineProperty3.default)(_mutations, types.CHANGE_CREDIT_INPUT, function (state, payload) {
    state.credit_input[payload.key] = payload.value;
}), (0, _defineProperty3.default)(_mutations, types.CHANGE_CUSTOM_USER_INPUT, function (state, payload) {
    state.custom_user_input[payload.key] = payload.value;
}), (0, _defineProperty3.default)(_mutations, types.CREDIT_INFO, function (state) {
    state.credit_input = {
        'auth_type': 'input',
        'exist_main_card': 0,
        'main_card_num': '',
        'credit_num': '',
        'expi_mon': '',
        'expi_year': '',
        'cvs': '',
        'is_checked': false,
        'auto_pay_card_num': '',
        'exist_auto_pay_cards': false
    };
}), _mutations);

function checkFilter(key, data) {
    var reg = new RegExp(key + '.*');
    return reg.test(data);
}

exports.default = {
    namespaced: true,
    types: types,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
};

},{"babel-runtime/core-js/object/values":58,"babel-runtime/core-js/promise":59,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/defineProperty":65,"babel-runtime/helpers/typeof":72,"babel-runtime/regenerator":75}],1594:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mutations;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var types = {
    FETCH_ADMISSION_SETTINGS: 'FETCH_ADMISSION_SETTINGS',
    FETCH_ONE_ADMISSION_SETTING: 'FETCH_ONE_ADMISSION_SETTING',
    RESET_FORM_DATA: 'RESET_FORM_DATA',
    UPDATE_FORM_INPUT: 'UPDATE_FORM_INPUT',
    CREATE_ADMISSION_RECORD: 'CREATE_ADMISSION_RECORD',
    GET_UNLEAVED_RECORD: 'GET_UNLEAVED_RECORD',
    GET_BRANCH_UNLEAVED_RECORDS: 'GET_BRANCH_UNLEAVED_RECORDS',
    GET_BRANCH_DAILY_RECORDS: 'GET_BRANCH_DAILY_RECORDS',
    RESET_MEMBER_ADMISSION: 'RESET_MEMBER_ADMISSION',
    GET_CUSTOMER_CONTRACTS: 'GET_CUSTOMER_CONTRACTS',
    SET_SELECTED_MEMBER_CONTRACT: 'SET_SELECTED_MEMBER_CONTRACT',
    TRUN_AJAXING_SETTING_ON: 'TRUN_AJAXING_SETTING_ON',
    REFRESH_ELAPSED_TIME: 'REFRESH_ELAPSED_TIME',
    UPDATE_SETTING_INFO: 'UPDATE_SETTING_INFO',
    SET_SELECT_TICKET: 'SET_SELECT_TICKET',
    SET_SELECT_TICKET_ID: 'SET_SELECT_TICKET_ID',
    RESET_TICKET_ADMISSION: 'RESET_TICKET_ADMISSION',
    SET_DURATION: 'SET_DURATION',
    SET_SELECT_DURATION: 'SET_SELECT_DURATION',
    SET_FLOW_QUERY_DATE: 'SET_FLOW_QUERY_DATE'
};

var state = {
    settings: [],
    ajaxingSettings: true,
    branchUnleavedRecords: [],
    branchDailyRecords: [],
    ignoreOverLimit: false,
    errorData: {
        '00022': '點數不足',
        '00036': '使用方案與持有人不符',
        '00037': '方案過期或尚未開始',
        '00049': '會員被停止自助入場',
        '00050': '使用的方案已暫停或失效',
        '00058': '不允許的入場時段'
    },
    data: {
        id: null,
        name: '',
        type: '',
        limit_time: 0,
        is_enabled_out: 0,
        is_enabled_limit_time: 0,
        is_enabled_enter_point: 0,
        is_enabled_out_point: 0,
        enter_minus_point: 0,
        after_enter_time_minus_point: 0,
        out_time_unit: 1,
        out_minus_point: 1,
        limit_time_duration: 0,
        allow_start: '',
        allow_end: '',
        durations: []
    },
    unLeavedRecord: {
        admission: {
            name: ''
        }
    },
    memberContracts: [],
    selectTicketId: '',
    selectTicket: {},
    selectedMemberContract: {
        admission: {
            name: ''
        }
    },
    types: {
        unlimited: {
            id: 1,
            name: '無限'
        },
        point: {
            id: 2,
            name: '點數'
        },
        count: {
            id: 3,
            name: '次數'
        },
        ticket: {
            id: 4,
            name: '票券'
        }
    },
    contractTypes: {
        unlimited: 1,
        point: 2,
        count: 3,
        ticket: 4
    },
    settingInfo: {
        name: '',
        is_enabled_out: false,
        is_enabled_limit_time: false,
        limit_time: 0,
        is_enabled_enter_point: false,
        is_enabled_out_point: false,
        enter_minus_point: 0,
        after_enter_time_minus_point: 0,
        out_time_unit: 1,
        out_minus_point: 0,
        limit_time_duration: 0,
        allow_start: '',
        allow_end: '',
        durations: [],
        type: null
    },
    ticket: {},
    flowQueryDate: {
        'value': '7',
        'option': '顯示最近 7 天 '
    }
};

var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.FETCH_ADMISSION_SETTINGS, function (state, payload) {
    state.settings = payload;
    state.ajaxingSettings = false;
}), (0, _defineProperty3.default)(_mutations, types.RESET_FORM_DATA, function (state) {
    state.data = {
        name: '',
        type: '',
        limit_time: 0,
        is_enabled_out: 0,
        is_enabled_limit_time: 0,
        is_enabled_enter_point: 0,
        is_enabled_out_point: 0,
        enter_minus_point: 0,
        after_enter_time_minus_point: 0,
        out_time_unit: 1,
        out_minus_point: 1,
        limit_time_duration: 0,
        allow_start: '',
        allow_end: '',
        durations: []
    };
}), (0, _defineProperty3.default)(_mutations, types.FETCH_ONE_ADMISSION_SETTING, function (state, payload) {
    state.data = payload;
}), (0, _defineProperty3.default)(_mutations, types.UPDATE_FORM_INPUT, function (state, payload) {
    for (var key in payload) {
        state.data[key] = payload[key];
    }
}), (0, _defineProperty3.default)(_mutations, types.CREATE_ADMISSION_RECORD, function (state, payload) {}), (0, _defineProperty3.default)(_mutations, types.GET_UNLEAVED_RECORD, function (state, payload) {
    state.unLeavedRecord = payload;
}), (0, _defineProperty3.default)(_mutations, types.REFRESH_ELAPSED_TIME, function (state, payload) {
    var records = payload || state.branchUnleavedRecords;
    for (var key in records) {
        var now = moment();
        var enteredAt = moment(records[key].entered_at);
        var duration = moment.duration(now.diff(enteredAt));
        records[key]['elapsed_time'] = Math.floor(duration.asMinutes());
    }
}), (0, _defineProperty3.default)(_mutations, types.GET_BRANCH_UNLEAVED_RECORDS, function (state, payload) {
    mutations.REFRESH_ELAPSED_TIME(state, payload);
    state.branchUnleavedRecords = payload;
}), (0, _defineProperty3.default)(_mutations, types.GET_BRANCH_DAILY_RECORDS, function (state, payload) {
    state.branchDailyRecords = payload;
}), (0, _defineProperty3.default)(_mutations, types.RESET_MEMBER_ADMISSION, function (state, payload) {
    state.unLeavedRecord = {
        admission: {
            name: ''
        }
    };
    state.memberContracts = [];
    state.selectedMemberContract = {
        admission: {
            name: ''
        }
    };
}), (0, _defineProperty3.default)(_mutations, types.RESET_TICKET_ADMISSION, function (state, payload) {
    state.unLeavedRecord = {
        admission: {
            name: ''
        }
    };
    // state.selectTicketId = '';
    state.selectTicket = {};
}), (0, _defineProperty3.default)(_mutations, types.GET_CUSTOMER_CONTRACTS, function (state, payload) {
    state.memberContracts = payload;
}), (0, _defineProperty3.default)(_mutations, types.SET_SELECTED_MEMBER_CONTRACT, function (state, payload) {
    state.selectedMemberContract = payload;
}), (0, _defineProperty3.default)(_mutations, types.TRUN_AJAXING_SETTING_ON, function (state, payload) {
    state.ajaxingSettings = true;
}), (0, _defineProperty3.default)(_mutations, types.UPDATE_SETTING_INFO, function (state, payload) {
    state.settingInfo = payload;
}), (0, _defineProperty3.default)(_mutations, types.SET_SELECT_TICKET, function (state, payload) {
    state.selectTicket = payload;
}), (0, _defineProperty3.default)(_mutations, types.SET_SELECT_TICKET_ID, function (state, payload) {
    state.selectTicketId = payload;
}), (0, _defineProperty3.default)(_mutations, types.SET_DURATION, function (state, payload) {
    state.data.durations = payload;
}), (0, _defineProperty3.default)(_mutations, types.SET_SELECT_DURATION, function (state, payload) {
    state.data.durations[payload.index] = payload.value;
}), (0, _defineProperty3.default)(_mutations, types.SET_FLOW_QUERY_DATE, function (state, payload) {
    state.flowQueryDate = payload;
}), _mutations);

var api = {
    fetchAdmissionSettings: function fetchAdmissionSettings(branchId) {
        return new _promise2.default(function (resolve) {
            Vue.http.get('/adminapi/admission?' + $.param({ branch_id: branchId })).then(function (response) {
                return resolve({
                    settings: response.body
                });
            });
        });
    },
    fetchOne: function fetchOne(obj) {
        return new _promise2.default(function (resolve) {
            Vue.http.get('/adminapi/admission/' + obj.id).then(function (response) {
                return resolve({
                    admission: response.body
                });
            });
        });
    },
    create: function create(formData) {
        return new _promise2.default(function (resolve) {
            Vue.http.post('/adminapi/admission', formData).then(function (response) {
                return resolve({});
            }).catch($17.responseErrorMessage);
        });
    },
    update: function update(id, formData) {
        return new _promise2.default(function (resolve) {
            Vue.http.patch('/adminapi/admission/' + id, formData).then(function (response) {
                return resolve({});
            }).catch($17.responseErrorMessage);
        });
    },
    delete: function _delete(id) {
        return new _promise2.default(function (resolve) {
            Vue.http.delete('/adminapi/admission/' + id).then(function (response) {
                return resolve({});
            });
        });
    },
    createEnterRecord: function createEnterRecord(memberId, data) {
        return new _promise2.default(function (resolve, reject) {
            Vue.http.post('/adminapi/customers/' + memberId + '/admission_record', data).then(function (response) {
                return resolve({});
            }).catch(function (response) {
                return reject({
                    error: response.body.code
                });
            });
        });
    },
    createTicketEnterRecord: function createTicketEnterRecord(ticketId, data) {
        return new _promise2.default(function (resolve, reject) {
            Vue.http.post('/adminapi/ticket/' + ticketId + '/admission_record', data).then(function (response) {
                return resolve({});
            }).catch(function (response) {
                return reject({
                    error: response.body.code
                });
            });
        });
    },
    getUnLeavedRecord: function getUnLeavedRecord(memberId) {
        return new _promise2.default(function (resolve) {
            Vue.http.get('/adminapi/customers/' + memberId + '/admission_record').then(function (response) {
                return resolve({
                    unLeavedRecord: response.body
                });
            });
        });
    },
    getTicketUnLeavedRecord: function getTicketUnLeavedRecord(ticketId) {
        return new _promise2.default(function (resolve) {
            Vue.http.get('/adminapi/ticket/' + ticketId + '/admission_record').then(function (response) {
                return resolve({
                    unLeavedRecord: response.body
                });
            });
        });
    },
    getUnLeavedRecords: function getUnLeavedRecords() {
        return new _promise2.default(function (resolve) {
            Vue.http.get('/adminapi/customers/admission/unleaved_records', {
                'params': {
                    flow_query_date: state.flowQueryDate.value
                }
            }).then(function (response) {
                return resolve({
                    records: response.body
                });
            });
        });
    },
    getDailyRecords: function getDailyRecords() {
        return new _promise2.default(function (resolve) {
            Vue.http.get('/adminapi/customers/admission/daily_records').then(function (response) {
                return resolve({
                    records: response.body
                });
            });
        });
    },
    getContracts: function getContracts(memberId) {
        return new _promise2.default(function (resolve) {
            Vue.http.get('/adminapi/customers/' + memberId + '/admission/contracts').then(function (response) {
                return resolve({
                    contracts: response.body
                });
            });
        });
    },
    stopTiming: function stopTiming(id) {
        return new _promise2.default(function (resolve) {
            Vue.http.put('/adminapi/customers/' + id + '/admission/stop_timing').then(function (response) {
                return resolve({});
            });
        });
    },
    markLeaved: function markLeaved(id) {
        return new _promise2.default(function (resolve, reject) {
            Vue.http.put('/adminapi/customers/' + id + '/admission/mark_come_out').then(function (response) {
                return resolve({});
            }).catch(function (response) {
                return reject({
                    error: response.body.code
                });
            });
        });
    },
    markTicketLeaved: function markTicketLeaved(payload) {
        var id = payload.id;
        var force = payload.force;
        return new _promise2.default(function (resolve, reject) {
            Vue.http.put('/adminapi/ticket/' + id + '/admission/mark_come_out', { force_out: force }).then(function (response) {
                return resolve({});
            }).catch(function (response) {
                return reject({
                    error: response.body.code
                });
            });
        });
    },
    getTicket: function getTicket(ticketId, branchId) {
        return new _promise2.default(function (resolve, reject) {
            Vue.http.get('/adminapi/ticket/' + ticketId + '/info/branch/' + branchId).then(function (response) {
                return resolve({
                    ticket: response.data.ticket,
                    settingInfo: response.data.settingInfo
                });
            }).catch(function (response) {
                return reject({
                    error: response.body.code
                });
            });
        });
    }
};

var actions = {
    fetchAdmissionSettings: function fetchAdmissionSettings(_ref, branchId) {
        var _this = this;

        var commit = _ref.commit;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            return _context.abrupt('return', api.fetchAdmissionSettings(branchId).then(function (response) {
                                commit('TRUN_AJAXING_SETTING_ON');
                                commit('FETCH_ADMISSION_SETTINGS', response.settings);
                            }));

                        case 1:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },
    fetchOne: function fetchOne(_ref2, branchId) {
        var _this2 = this;

        var commit = _ref2.commit;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            return _context2.abrupt('return', api.fetchOne(branchId).then(function (response) {
                                commit('FETCH_ONE_ADMISSION_SETTING', response.admission);
                            }));

                        case 1:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }))();
    },
    create: function create(_ref3, payload) {
        var _this3 = this;

        var commit = _ref3.commit;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            return _context3.abrupt('return', api.create(payload));

                        case 1:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3);
        }))();
    },
    update: function update(_ref4, payload) {
        var _this4 = this;

        var commit = _ref4.commit;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            return _context4.abrupt('return', api.update(payload.id, payload.data));

                        case 1:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this4);
        }))();
    },
    delete: function _delete(_ref5, payload) {
        var _this5 = this;

        var commit = _ref5.commit;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5() {
            return _regenerator2.default.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            return _context5.abrupt('return', api.delete(payload.id));

                        case 1:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this5);
        }))();
    },
    createEnterRecord: function createEnterRecord(_ref6, payload) {
        var _this6 = this;

        var commit = _ref6.commit;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6() {
            return _regenerator2.default.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            return _context6.abrupt('return', api.createEnterRecord(payload.id, payload.data));

                        case 1:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, _this6);
        }))();
    },
    createTicketEnterRecord: function createTicketEnterRecord(_ref7, payload) {
        var _this7 = this;

        var commit = _ref7.commit;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7() {
            return _regenerator2.default.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            return _context7.abrupt('return', api.createTicketEnterRecord(payload.id, payload.data));

                        case 1:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee7, _this7);
        }))();
    },
    getUnLeavedRecord: function getUnLeavedRecord(_ref8, payload) {
        var _this8 = this;

        var commit = _ref8.commit;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8() {
            return _regenerator2.default.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            return _context8.abrupt('return', api.getUnLeavedRecord(payload).then(function (response) {
                                commit('GET_UNLEAVED_RECORD', response.unLeavedRecord);
                                if (!response.unLeavedRecord.admission) return;
                                commit('UPDATE_SETTING_INFO', response.unLeavedRecord.admission);
                            }));

                        case 1:
                        case 'end':
                            return _context8.stop();
                    }
                }
            }, _callee8, _this8);
        }))();
    },
    getTicketUnLeavedRecord: function getTicketUnLeavedRecord(_ref9, payload) {
        var _this9 = this;

        var commit = _ref9.commit;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee9() {
            return _regenerator2.default.wrap(function _callee9$(_context9) {
                while (1) {
                    switch (_context9.prev = _context9.next) {
                        case 0:
                            return _context9.abrupt('return', api.getTicketUnLeavedRecord(payload).then(function (response) {
                                commit('GET_UNLEAVED_RECORD', response.unLeavedRecord);
                                if (!response.unLeavedRecord.admission) return;
                                commit('UPDATE_SETTING_INFO', response.unLeavedRecord.admission);
                            }));

                        case 1:
                        case 'end':
                            return _context9.stop();
                    }
                }
            }, _callee9, _this9);
        }))();
    },
    getUnLeavedRecords: function getUnLeavedRecords(_ref10, payload) {
        var _this10 = this;

        var commit = _ref10.commit;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee10() {
            return _regenerator2.default.wrap(function _callee10$(_context10) {
                while (1) {
                    switch (_context10.prev = _context10.next) {
                        case 0:
                            return _context10.abrupt('return', api.getUnLeavedRecords(payload).then(function (response) {
                                commit('GET_BRANCH_UNLEAVED_RECORDS', response.records);
                            }));

                        case 1:
                        case 'end':
                            return _context10.stop();
                    }
                }
            }, _callee10, _this10);
        }))();
    },
    getDailyRecords: function getDailyRecords(_ref11, payload) {
        var _this11 = this;

        var commit = _ref11.commit;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee11() {
            return _regenerator2.default.wrap(function _callee11$(_context11) {
                while (1) {
                    switch (_context11.prev = _context11.next) {
                        case 0:
                            return _context11.abrupt('return', api.getDailyRecords(payload).then(function (response) {
                                commit('GET_BRANCH_DAILY_RECORDS', response.records);
                            }));

                        case 1:
                        case 'end':
                            return _context11.stop();
                    }
                }
            }, _callee11, _this11);
        }))();
    },
    getContracts: function getContracts(_ref12, payload) {
        var _this12 = this;

        var commit = _ref12.commit;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee12() {
            return _regenerator2.default.wrap(function _callee12$(_context12) {
                while (1) {
                    switch (_context12.prev = _context12.next) {
                        case 0:
                            return _context12.abrupt('return', api.getContracts(payload).then(function (response) {
                                commit('GET_CUSTOMER_CONTRACTS', response.contracts);
                            }));

                        case 1:
                        case 'end':
                            return _context12.stop();
                    }
                }
            }, _callee12, _this12);
        }))();
    },
    stopTiming: function stopTiming(_ref13, payload) {
        var _this13 = this;

        var commit = _ref13.commit;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee13() {
            return _regenerator2.default.wrap(function _callee13$(_context13) {
                while (1) {
                    switch (_context13.prev = _context13.next) {
                        case 0:
                            return _context13.abrupt('return', api.stopTiming(payload));

                        case 1:
                        case 'end':
                            return _context13.stop();
                    }
                }
            }, _callee13, _this13);
        }))();
    },
    markLeaved: function markLeaved(_ref14, payload) {
        var _this14 = this;

        var commit = _ref14.commit;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee14() {
            return _regenerator2.default.wrap(function _callee14$(_context14) {
                while (1) {
                    switch (_context14.prev = _context14.next) {
                        case 0:
                            return _context14.abrupt('return', api.markLeaved(payload));

                        case 1:
                        case 'end':
                            return _context14.stop();
                    }
                }
            }, _callee14, _this14);
        }))();
    },
    markTicketLeaved: function markTicketLeaved(_ref15, payload) {
        var _this15 = this;

        var commit = _ref15.commit;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee15() {
            return _regenerator2.default.wrap(function _callee15$(_context15) {
                while (1) {
                    switch (_context15.prev = _context15.next) {
                        case 0:
                            return _context15.abrupt('return', api.markTicketLeaved(payload));

                        case 1:
                        case 'end':
                            return _context15.stop();
                    }
                }
            }, _callee15, _this15);
        }))();
    },
    admissionErrorAlert: function admissionErrorAlert(_ref16, payload) {
        var _this16 = this;

        var commit = _ref16.commit;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee16() {
            var m;
            return _regenerator2.default.wrap(function _callee16$(_context16) {
                while (1) {
                    switch (_context16.prev = _context16.next) {
                        case 0:
                            if (payload.error) {
                                _context16.next = 2;
                                break;
                            }

                            return _context16.abrupt('return');

                        case 2:
                            m = state.errorData[payload.error];

                            $17.swal({
                                type: 'warning',
                                title: m,
                                showCancelButton: false
                            });

                        case 4:
                        case 'end':
                            return _context16.stop();
                    }
                }
            }, _callee16, _this16);
        }))();
    },
    alertNotAdmissionContract: function alertNotAdmissionContract(_ref17, payload) {
        var commit = _ref17.commit;

        $17.swal({
            title: '無入場方案',
            type: 'error',
            showCancelButton: false
        });
    },
    alertEnterSuccess: function alertEnterSuccess(_ref18, payload) {
        var commit = _ref18.commit;

        $17.swal({
            title: '確認入場',
            type: 'success',
            showCancelButton: false
        });
    },
    alertNoTicket: function alertNoTicket() {
        $17.swal({
            title: '無此票券',
            type: 'error',
            showCancelButton: false
        });
    },
    showAdmissionInfo: function showAdmissionInfo(_ref19, payload) {
        var commit = _ref19.commit;

        $('#admission-info-modal').modal('show');
    },
    getTicket: function getTicket(_ref20, payload) {
        var _this17 = this;

        var commit = _ref20.commit;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee17() {
            return _regenerator2.default.wrap(function _callee17$(_context17) {
                while (1) {
                    switch (_context17.prev = _context17.next) {
                        case 0:
                            if (!(state.selectTicketId.length < 14)) {
                                _context17.next = 2;
                                break;
                            }

                            return _context17.abrupt('return');

                        case 2:
                            return _context17.abrupt('return', api.getTicket(payload.ticketId, payload.branchId).then(function (response) {
                                commit('UPDATE_SETTING_INFO', response.settingInfo);
                                commit('SET_SELECT_TICKET', response.ticket);
                                return true;
                            }).catch(function (response) {
                                actions.alertNoTicket();
                                return false;
                            }));

                        case 3:
                        case 'end':
                            return _context17.stop();
                    }
                }
            }, _callee17, _this17);
        }))();
    },
    getCurrentType: function getCurrentType(_ref21, payload) {
        var commit = _ref21.commit;

        return state.selectTicket.state == 0 ? 'in' : 'out';
    }
};

exports.default = {
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations
};

},{"babel-runtime/core-js/promise":59,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/defineProperty":65,"babel-runtime/regenerator":75}],1595:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AgentAdapter = {
    printer: null,
    on: function on(target) {
        var handler = {
            get: function get(target, prop) {
                if (prop == 'realPrint') {
                    return AgentAdapter.realPrint;
                }
                return target[prop];
            }
        };
        AgentAdapter.printer = new Proxy(target, handler);
        return AgentAdapter.printer;
    },
    realPrint: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            var vm, data, key, remarks, path;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            vm = AgentAdapter.printer;
                            _context.next = 3;
                            return AgentAdapter.buildData();

                        case 3:
                            data = _context.sent;

                            AgentAdapter.setWebLog('確認切割後資料無異常', (0, _stringify2.default)(data));

                            if (data) {
                                _context.next = 7;
                                break;
                            }

                            return _context.abrupt('return');

                        case 7:
                            key = Math.random().toString(36).slice(2);
                            remarks = new URLSearchParams(data.data_remark);
                            path = "/simple/quick/forward?" + remarks.toString() + '&key=' + key;

                            $.post('/simple/adminapi/print_agent/forward_data', {
                                forward_data: (0, _stringify2.default)(data),
                                key: key
                            }, function (res) {
                                window.open(path, '_blank', 'width=500px,height=400px,location=no');
                                vm.onReceive();
                            }).fail(function (error) {
                                AgentAdapter.setWebLog('切割後資料異常', (0, _stringify2.default)(error));
                                console.log(error);
                            });

                        case 11:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined);
        }));

        return function realPrint() {
            return _ref.apply(this, arguments);
        };
    }(),
    buildData: function buildData() {
        var vm = AgentAdapter.printer;
        var data = vm._builder.toString();
        var invoiceData = '<?xml version="1.0" encoding="utf-8"?><s:Envelope xmlns:s="http://schemas.xmlsoap.org/soap/envelope/"><s:Body>';
        invoiceData += data;
        invoiceData += '</s:Body></s:Envelope>';
        var emptyPrint = '<epos-print xmlns="http://www.epson-pos.com/schemas/2011/03/epos-print"></epos-print>';
        if (data === emptyPrint) return false;
        var forward_input = {
            type: 'text/xml',
            data: invoiceData
        };
        var forward_to = vm._printerAddress;
        forward_to['method'] = 'post';
        var data_remark = '';
        var appendRemark = function appendRemark(params, name) {
            var separator = data_remark ? ' || ' : '';
            if (params) {
                data_remark += '' + separator + name + '\uFF1A' + params;
            }
        };
        appendRemark(vm._buyerOrderId, '訂單');
        appendRemark(vm._invoiceNumber, '發票');
        vm.clearCache();
        return {
            forward_to: forward_to,
            forward_input: forward_input,
            data_remark: {
                remark: data_remark
            }
        };
    },
    setWebLog: function setWebLog(name, message) {
        console.log(name, message);
        _axios2.default.post('https://' + location.hostname + '/adminapi/log', {
            'log_name': name,
            'log_message': message
        }).catch(function (error) {
            return console.log(error);
        });
    }
};

exports.default = AgentAdapter;

},{"axios":19,"babel-runtime/core-js/json/stringify":48,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/regenerator":75}],1596:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _objectDestructuringEmpty2 = require('babel-runtime/helpers/objectDestructuringEmpty');

var _objectDestructuringEmpty3 = _interopRequireDefault(_objectDestructuringEmpty2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mutations;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var type = {
    CLOSE_ALL_BLOCK: 'CLOSE_ALL_BLOCK',
    TOGGLE_BLOCK: 'TOGGLE_BLOCK',
    CHANGE_DATE_OPTIONS: 'CHANGE_DATE_OPTIONS',
    CHANGE_FILTER_OPTIONS: 'CHANGE_FILTER_OPTIONS',
    CLEAN_BRANCH_RELATED_SELECTED: 'CLEAN_BRANCH_RELATED_SELECTED',
    CLEAN_BRANCH_SELECTED: 'CLEAN_BRANCH_SELECTED',
    CHANGE_ITEM_OPTIONS: 'CHANGE_ITEM_OPTIONS',
    CHANGE_AJAXING: 'CHANGE_AJAXING',
    ALL_OPTION_DATA: 'ALL_OPTION_DATA',
    CHANGE_DISPLAY: 'CHANGE_DISPLAY',
    CHANGE_QUERY_PARAM: 'CHANGE_QUERY_PARAM'
};

var state = {
    blockOpenStatus: {
        first: true,
        second: true,
        third: false,
        fourth: false
    },
    dateOptions: {
        startDate: null,
        endDate: null,
        disabled: false,
        minimumView: 'day',
        filterDate: '0'
    },
    filterOptions: {
        studioId: null,
        branchIds: [],
        serviceIds: [],
        serviceProviderIds: [],
        page: 1,
        pageSize: 25
    },
    itemOptions: {
        viewMode: 'detail'
    },
    display: 'show',
    ajaxing: false,
    queryPara: {}
};

var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, type.CLOSE_ALL_BLOCK, function (state) {
    state.blockOpenStatus.first = false;
    state.blockOpenStatus.second = false;
    state.blockOpenStatus.third = false;
    state.blockOpenStatus.fourth = false;
}), (0, _defineProperty3.default)(_mutations, type.TOGGLE_BLOCK, function (state, payload) {
    state.blockOpenStatus[payload.block] = !state.blockOpenStatus[payload.block];
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_DATE_OPTIONS, function (state, payload) {
    state.dateOptions[payload.prop] = payload.value;
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_FILTER_OPTIONS, function (state, payload) {
    state.filterOptions[payload.prop] = payload.value;
}), (0, _defineProperty3.default)(_mutations, type.CLEAN_BRANCH_SELECTED, function (state) {
    state.filterOptions.branchIds = [];
}), (0, _defineProperty3.default)(_mutations, type.CLEAN_BRANCH_RELATED_SELECTED, function (state) {
    state.filterOptions.serviceProviderIds = [];
    state.filterOptions.scheduleIds = [];
    state.filterOptions.serviceIds = [];
    $17.updateUrlQueryString({ service_provider_ids: '', service_ids: '' });
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_ITEM_OPTIONS, function (state, payload) {
    state.itemOptions[payload.prop] = payload.value;
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_AJAXING, function (state, payload) {
    state.ajaxing = payload.value;
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_DISPLAY, function (state, payload) {
    state.display = payload;
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_QUERY_PARAM, function (state, payload) {
    state.queryPara = payload;
}), _mutations);

var api = {};

var actions = {
    beforeSubmit: function beforeSubmit(_ref) {
        var commit = _ref.commit,
            dispatch = _ref.dispatch;

        if (!state.dateOptions.startDate || state.dateOptions.startDate == 'Invalid date') {
            return $17.formatErrorAlert('日期：請填寫 開始日期');
        }
        if (!state.dateOptions.endDate || state.dateOptions.endDate == 'Invalid date') {
            return $17.formatErrorAlert('日期：請填寫 結束日期');
        }
        if (state.dateOptions.startDate > state.dateOptions.endDate) {
            return $17.formatErrorAlert('日期：開始日期不能大於結束日期');
        }

        // commit(type.CLOSE_ALL_BLOCK) //Disabled close all block when submit form
    },
    toggleBlock: function toggleBlock(_ref2, payload) {
        var commit = _ref2.commit;

        commit(type.TOGGLE_BLOCK, payload);
    },
    changeDateOption: function changeDateOption(_ref3, payload) {
        var commit = _ref3.commit;

        commit(type.CHANGE_DATE_OPTIONS, payload);
    },
    changeFilterOption: function changeFilterOption(_ref4, payload) {
        var commit = _ref4.commit;

        commit(type.CHANGE_FILTER_OPTIONS, payload);
    },
    cleanBranch: function cleanBranch(_ref5) {
        var commit = _ref5.commit;

        commit(type.CLEAN_BRANCH_SELECTED);
    },
    cleanBranchRelated: function cleanBranchRelated(_ref6) {
        var commit = _ref6.commit;

        commit(type.CLEAN_BRANCH_RELATED_SELECTED);
    },
    changeItemOption: function changeItemOption(_ref7, payload) {
        var commit = _ref7.commit;

        commit(type.CHANGE_ITEM_OPTIONS, payload);
    },
    setDetailTarget: function setDetailTarget(_ref8, payload) {
        var commit = _ref8.commit;

        commit(type.CHANGE_DETAIL, payload);
    },
    changeDisplay: function changeDisplay(_ref9, payload) {
        var commit = _ref9.commit;

        commit(type.CHANGE_DISPLAY, payload);
    },
    download: function download(_ref10, _ref11) {
        var commit = _ref10.commit;
        var csvString = _ref11.csvString,
            name = _ref11.name;

        var downloadLink = document.createElement("a");
        downloadLink.download = name + ".csv";
        downloadLink.innerHTML = "Download File";
        if (window.webkitURL != null) {
            var code = encodeURIComponent(csvString);
            downloadLink.href = "data:application/csv;charset=utf-8,%EF%BB%BF" + code;
        }
        downloadLink.click();
    },
    csvDataHandler: function csvDataHandler(_ref12, param) {
        var commit = _ref12.commit;

        var data = [];
        _lodash2.default.assign(data, param.data);
        data = actions.columnFormaterProp({}, { data: data, columnFormater: param.columnFormater });
        var results = Papa.unparse(data, {
            delimiter: ','
        });
        return results;
    },
    columnFormaterProp: function columnFormaterProp(_ref13, param) {
        (0, _objectDestructuringEmpty3.default)(_ref13);

        var data = param.data;
        String.prototype.replaceAll = function (search, replacement) {
            var target = this;
            return target.replace(new RegExp(search, 'g'), replacement);
        };
        return param.columnFormater(data);
    },
    changeAjaxing: function changeAjaxing(_ref14, ajaxingStatus) {
        var commit = _ref14.commit;

        commit(type.CHANGE_AJAXING, {
            value: ajaxingStatus
        });
    },
    changeDateOptionAfter: function changeDateOptionAfter(_ref15, dateObj) {
        var commit = _ref15.commit,
            state = _ref15.state;

        commit(type.CHANGE_DATE_OPTIONS, dateObj);
        $17.updateUrlQueryString({
            start_date: state.dateOptions.startDate,
            end_date: state.dateOptions.endDate
        });
    },
    syncDateAndDisplayByQuery: function syncDateAndDisplayByQuery(_ref16, defaultSetting) {
        var commit = _ref16.commit;

        var query = $17.getUrlQueryStrings();
        var setting = defaultSetting || {};
        var defaultDiffType = setting.diffType ? setting.diffType : "days";
        var defaultDiffNumber = setting.diffNumber ? setting.diffNumber : -6;
        var start_date = query.start_date ? query.start_date : moment().add(defaultDiffNumber, defaultDiffType);
        var end_date = query.end_date ? query.end_date : moment();
        var display = query.display ? query.display : "show";
        var format = setting.formate ? setting.formate : "YYYY/MM/DD";

        commit(type.CHANGE_DATE_OPTIONS, {
            prop: "startDate",
            value: moment(start_date).format(format)
        });
        commit(type.CHANGE_DATE_OPTIONS, {
            prop: "endDate",
            value: moment(end_date).format(format)
        });
        commit(type.CHANGE_DISPLAY, display);
    },
    syncLocalMultipleSelectByQuery: function syncLocalMultipleSelectByQuery(_ref17, _ref18) {
        var vm = _ref18.vm,
            multiFilter = _ref18.multiFilter;
        (0, _objectDestructuringEmpty3.default)(_ref17);

        var query = _lodash2.default.cloneDeep($17.getUrlQueryStrings());
        var newV = null;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            var _loop = function _loop() {
                var _step$value = (0, _slicedToArray3.default)(_step.value, 2),
                    key = _step$value[0],
                    value = _step$value[1];

                newV = vm[value.options];
                var queryArr = query[key] ? query[key].split(",") : [];
                var resultArr = null;
                if (value.type == 'multiple') {
                    resultArr = [];
                    queryArr.forEach(function (el) {
                        var findEl = newV.find(function (item) {
                            return item[value.trackBy] == el;
                        });
                        findEl ? resultArr.push(findEl) : null;
                    });
                }
                if (value.type == 'single') {
                    resultArr = null;
                    queryArr.forEach(function (el) {
                        var findEl = newV.find(function (item) {
                            return item[value.trackBy] == el;
                        });
                        findEl ? resultArr = findEl : null;
                    });
                }
                if (value.type == 'multiple-dropdown') {
                    resultArr = vm[value.vModel];
                    queryArr.forEach(function (el) {
                        var findEl = newV.find(function (item) {
                            return item[value.trackBy] == el;
                        });
                        findEl ? resultArr[el - 1]['selected'] = true : null;
                    });
                }
                vm[value.vModel] = resultArr;
            };

            for (var _iterator = (0, _getIterator3.default)((0, _entries2.default)(multiFilter)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                _loop();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    },
    syncRelatedMultipleSelectByQuery: function syncRelatedMultipleSelectByQuery(_ref19, _ref20) {
        var vm = _ref20.vm,
            relatedFilterWatcher = _ref20.relatedFilterWatcher;
        (0, _objectDestructuringEmpty3.default)(_ref19);

        var query = _lodash2.default.cloneDeep($17.getUrlQueryStrings());
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            var _loop2 = function _loop2() {
                var _step2$value = (0, _slicedToArray3.default)(_step2.value, 2),
                    key = _step2$value[0],
                    value = _step2$value[1];

                value.watcher = vm.$watch(value.options, function (newV, oldV) {
                    if (!_lodash2.default.isEmpty(newV)) {
                        var _queryArr = query[key] ? query[key].split(",") : [];
                        var _resultArr = null;
                        if (value.type == 'multiple') {
                            _resultArr = [];
                            _queryArr.forEach(function (el) {
                                var findEl = newV.find(function (item) {
                                    return item[value.trackBy] == el;
                                });
                                findEl ? _resultArr.push(findEl) : null;
                            });
                        }
                        if (value.type == 'single') {
                            _resultArr = null;
                            _queryArr.forEach(function (el) {
                                var findEl = newV.find(function (item) {
                                    return item[value.trackBy] == el;
                                });
                                findEl ? _resultArr = findEl : null;
                            });
                        }
                        vm[value.vModel] = _resultArr;
                        value.watcher();
                    }
                });
            };

            for (var _iterator2 = (0, _getIterator3.default)((0, _entries2.default)(relatedFilterWatcher)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                _loop2();
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }
    },
    keepQueryParam: function keepQueryParam(_ref21, queryPara) {
        var commit = _ref21.commit;

        commit(type.CHANGE_QUERY_PARAM, queryPara);
    }
};

exports.default = {
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations
};

},{"babel-runtime/core-js/get-iterator":46,"babel-runtime/core-js/object/entries":54,"babel-runtime/helpers/defineProperty":65,"babel-runtime/helpers/objectDestructuringEmpty":68,"babel-runtime/helpers/slicedToArray":70,"lodash":717}],1597:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mutations;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var type = {
    CLOSE_ALL_BLOCK: 'CLOSE_ALL_BLOCK',
    TOGGLE_BLOCK: 'TOGGLE_BLOCK',
    CHANGE_DATE_OPTIONS: 'CHANGE_DATE_OPTIONS',
    CHANGE_FILTER_OPTIONS: 'CHANGE_FILTER_OPTIONS',
    CHANGE_ITEM_OPTIONS: 'CHANGE_ITEM_OPTIONS',
    CHANGE_AJAXING: 'CHANGE_AJAXING',
    CHANGE_LIST: 'CHANGE_LIST',
    CHANGE_TOTAL: 'CHANGE_TOTAL',
    CHANGE_EXPORT: 'CHANGE_EXPORT',
    CHANGE_PAGE_PAYLOAD: 'CHANGE_PAGE_PAYLOAD',
    CLEAN_BRANCH_RELATED_SELECTED: 'CLEAN_BRANCH_RELATED_SELECTED',
    CLEAN_BRANCH_SELECTED: 'CLEAN_BRANCH_SELECTED',
    INIT_CONFRIM_STATUS: 'INIT_CONFRIM_STATUS',
    INIT_CONFRIM_STATUS_SHOW: 'INIT_CONFRIM_STATUS_SHOW'
};

var state = {
    blockOpenStatus: {
        first: true,
        second: true,
        third: false,
        fourth: false
    },
    dateOptions: {
        startDate: null,
        endDate: null
    },
    filterOptions: {
        studioId: null,
        branchIds: [],
        serviceProviderIds: [],
        serviceIds: [],
        confirmStatuses: []
    },
    ajaxing: false,
    export: [],
    list: [],
    total: [],
    pageMeta: {},
    paginationPayload: {},
    confirmStatus: [],
    confirmStatusShow: {}
};

var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, type.CLOSE_ALL_BLOCK, function (state) {
    state.blockOpenStatus.first = false;
    state.blockOpenStatus.second = false;
    state.blockOpenStatus.third = false;
    state.blockOpenStatus.fourth = false;
}), (0, _defineProperty3.default)(_mutations, type.TOGGLE_BLOCK, function (state, payload) {
    state.blockOpenStatus[payload.block] = !state.blockOpenStatus[payload.block];
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_DATE_OPTIONS, function (state, payload) {
    state.dateOptions[payload.prop] = payload.value;
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_FILTER_OPTIONS, function (state, payload) {
    state.filterOptions[payload.prop] = payload.value;
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_AJAXING, function (state, payload) {
    state.ajaxing = payload.value;
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_LIST, function (state, payload) {
    state.list = payload.value;
    state.pageMeta = payload.pageMeta;
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_TOTAL, function (state, payload) {
    state.total = payload.value;
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_EXPORT, function (state, payload) {
    state.export = payload.value;
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_PAGE_PAYLOAD, function (state, payload) {
    state.paginationPayload = payload;
}), (0, _defineProperty3.default)(_mutations, type.CLEAN_BRANCH_SELECTED, function (state) {
    state.filterOptions.branchIds = [];
    $17.updateUrlQueryString({ branch_ids: '' });
}), (0, _defineProperty3.default)(_mutations, type.CLEAN_BRANCH_RELATED_SELECTED, function (state) {
    state.filterOptions.serviceProviderIds = [];
    state.filterOptions.scheduleIds = [];
    state.filterOptions.serviceIds = [];
    $17.updateUrlQueryString({ service_provider_ids: '', service_ids: '' });
}), (0, _defineProperty3.default)(_mutations, type.INIT_CONFRIM_STATUS, function (state, payload) {
    state.confirmStatus = payload.status;
}), (0, _defineProperty3.default)(_mutations, type.INIT_CONFRIM_STATUS_SHOW, function (state, payload) {
    state.confirmStatusShow = payload;
}), _mutations);

var api = {
    postData: function postData() {
        var branchIds = state.filterOptions.branchIds.map(function (elem) {
            return elem.id;
        });
        var serviceProviderIds = state.filterOptions.serviceProviderIds.map(function (elem) {
            return elem.id;
        });
        var serviceIds = state.filterOptions.serviceIds.map(function (elem) {
            return elem.id;
        });
        var confirmStatuses = state.filterOptions.confirmStatuses.map(function (elem) {
            return elem.status;
        });
        var postData = {
            studio_id: state.filterOptions.studioId && state.filterOptions.studioId.hasOwnProperty('id') ? state.filterOptions.studioId.id : 0,
            branch_ids: branchIds,
            start_date: state.dateOptions.startDate,
            end_date: state.dateOptions.endDate,
            service_provider_ids: serviceProviderIds,
            service_ids: serviceIds,
            confirm_statuses: confirmStatuses,
            page: state.filterOptions.page ? state.filterOptions.page : 1,
            page_size: state.filterOptions.pageSize ? state.filterOptions.pageSize : 25
        };
        return postData;
    },
    fetchData: function fetchData(payload) {
        return new _promise2.default(function (resolve) {
            Vue.http.post('/adminapi/report/fetch_all_booking_total_data', payload).then(function (_ref) {
                var data = _ref.data;
                return resolve(data.data);
            });
        });
    },
    initConfirmStatus: function initConfirmStatus() {
        return new _promise2.default(function (resolve) {
            Vue.http.get('/adminapi/init/booking_confirm_status').then(function (_ref2) {
                var data = _ref2.data;
                return resolve({
                    status: data
                });
            });
        });
    }
};

var actions = {
    submit: function submit(_ref3, payload) {
        var commit = _ref3.commit,
            dispatch = _ref3.dispatch;

        if (!state.dateOptions.startDate || state.dateOptions.startDate == 'Invalid date') {
            return $17.formatErrorAlert('日期：請填寫 開始日期');
        }
        if (!state.dateOptions.endDate || state.dateOptions.endDate == 'Invalid date') {
            return $17.formatErrorAlert('日期：請填寫 結束日期');
        }
        if (state.dateOptions.startDate > state.dateOptions.endDate) {
            return $17.formatErrorAlert('日期：開始日期不能大於結束日期');
        }
        // commit(type.CLOSE_ALL_BLOCK) //Disabled close all block when submit form
        if (payload.display == 'export') {
            dispatch('fetchExport');
        } else {
            dispatch('fetchData');
        }
    },
    toggleBlock: function toggleBlock(_ref4, payload) {
        var commit = _ref4.commit;

        commit(type.TOGGLE_BLOCK, payload);
    },
    changeDateOption: function changeDateOption(_ref5, payload) {
        var commit = _ref5.commit;

        commit(type.CHANGE_DATE_OPTIONS, payload);
    },
    changeFilterOption: function changeFilterOption(_ref6, payload) {
        var commit = _ref6.commit;

        commit(type.CHANGE_FILTER_OPTIONS, payload);
    },
    cleanBranch: function cleanBranch(_ref7) {
        var commit = _ref7.commit;

        commit(type.CLEAN_BRANCH_SELECTED);
    },
    cleanBranchRelated: function cleanBranchRelated(_ref8) {
        var commit = _ref8.commit;

        commit(type.CLEAN_BRANCH_RELATED_SELECTED);
    },
    fetchData: function fetchData(_ref9) {
        var commit = _ref9.commit;

        commit(type.CHANGE_AJAXING, {
            value: true
        });
        var payload = api.postData();
        $17.updateUrlQueryString(payload);
        commit(type.CHANGE_PAGE_PAYLOAD, (0, _assign2.default)({}, payload));
        api.fetchData(payload).then(function (response) {
            commit(type.CHANGE_AJAXING, {
                value: false
            });
            commit(type.CHANGE_LIST, {
                value: response.list,
                pageMeta: response.pageMeta
            });
            commit(type.CHANGE_TOTAL, {
                value: response.pageMeta.total
            });
        });
    },
    fetchExport: function fetchExport(_ref10) {
        var commit = _ref10.commit;

        commit(type.CHANGE_AJAXING, {
            value: true
        });
        var payload = api.postData();
        $17.updateUrlQueryString(payload);
        api.fetchData(payload).then(function (response) {
            commit(type.CHANGE_AJAXING, {
                value: false
            });
            commit(type.CHANGE_EXPORT, {
                value: response.list
            });
            commit(type.CHANGE_LIST, {
                value: [],
                pageMeta: {}
            });
            commit(type.CHANGE_TOTAL, {
                value: ''
            });
        });
    },
    changePage: function changePage(_ref11, payload) {
        var commit = _ref11.commit;

        commit(type.CHANGE_AJAXING, {
            value: true
        });
        commit(type.CHANGE_PAGE_PAYLOAD, (0, _extends3.default)({}, state.paginationPayload, {
            page: payload
        }));
        api.fetchData(state.paginationPayload).then(function (response) {
            commit(type.CHANGE_AJAXING, {
                value: false
            });
            commit(type.CHANGE_LIST, {
                value: response.list,
                pageMeta: response.pageMeta
            });
        });
    },
    setDetailTarget: function setDetailTarget(_ref12, payload) {
        var commit = _ref12.commit;

        commit(type.CHANGE_DETAIL, payload);
    },
    initConfirmStatus: function initConfirmStatus(_ref13) {
        var commit = _ref13.commit;

        api.initConfirmStatus().then(function (response) {
            commit(type.INIT_CONFRIM_STATUS, response);
            var show = response.status.reduce(function (result, item) {
                result[item.status] = item.name;
                return result;
            }, {});
            commit(type.INIT_CONFRIM_STATUS_SHOW, show);
        });
    }
};

exports.default = {
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations
};

},{"babel-runtime/core-js/object/assign":50,"babel-runtime/core-js/promise":59,"babel-runtime/helpers/defineProperty":65,"babel-runtime/helpers/extends":66}],1598:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mutations;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var type = {
    CLOSE_ALL_BLOCK: 'CLOSE_ALL_BLOCK',
    TOGGLE_BLOCK: 'TOGGLE_BLOCK',
    CHANGE_DATE_OPTIONS: 'CHANGE_DATE_OPTIONS',
    CHANGE_FILTER_OPTIONS: 'CHANGE_FILTER_OPTIONS',
    CHANGE_ITEM_OPTIONS: 'CHANGE_ITEM_OPTIONS',
    CHANGE_AJAXING: 'CHANGE_AJAXING',
    CHANGE_LIST: 'CHANGE_LIST',
    CHANGE_TOTAL: 'CHANGE_TOTAL',
    CLEAN_BRANCH_RELATED_SELECTED: 'CLEAN_BRANCH_RELATED_SELECTED',
    CLEAN_BRANCH_SELECTED: 'CLEAN_BRANCH_SELECTED',
    INIT_CONFRIM_STATUS: 'INIT_CONFRIM_STATUS',
    INIT_STAFF_SHOW: 'INIT_STAFF_SHOW',
    CHANGE_STAFF_AJAXING: 'CHANGE_STAFF_AJAXING',
    CLEAR_STAFF_SELECTED: 'CLEAR_STAFF_SELECTED',
    INIT_TOTAL_PAYMENTS: 'INIT_TOTAL_PAYMENTS', //動態產生各支付方式的<th>
    INIT_BRANCH_TOTAL_PAYMENTS: 'INIT_BRANCH_TOTAL_PAYMENTS' //各場館若無 [動態產生的支付方式] 就補 0
};

var state = {
    blockOpenStatus: {
        first: true,
        second: true,
        third: false,
        fourth: false
    },
    dateOptions: {
        startDate: null,
        endDate: null
    },
    filterOptions: {
        studioId: null,
        branchIds: [],
        issueStatuses: [],
        selectedStaff: [],
        checkoutMemberIsMe: 0
    },
    itemOptions: {
        viewMode: 'detail'
    },
    ajaxing: false,
    list: [],
    invoice_order_total: 0,
    invoice_total: 0,
    allowance_order_total: 0,
    allowance_total: 0,
    total_by_payment: [],
    total_by_branch: [],
    issueStatusShow: [{
        name: "未開立",
        status: 0
    }, {
        name: "已開立",
        status: 1
    }, {
        name: "未折讓",
        status: 2
    }, {
        name: "已折讓",
        status: 3
    }, {
        name: "手動輸入",
        status: 4
    }],
    issueStatus: [],
    staffMembers: [],
    staffAjaxing: false,
    initTotalPayments: [],
    initBranchTotalPayments: []
};

var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, type.CLOSE_ALL_BLOCK, function (state) {
    state.blockOpenStatus.first = false;
    state.blockOpenStatus.second = false;
    state.blockOpenStatus.third = false;
    state.blockOpenStatus.fourth = false;
}), (0, _defineProperty3.default)(_mutations, type.TOGGLE_BLOCK, function (state, payload) {
    state.blockOpenStatus[payload.block] = !state.blockOpenStatus[payload.block];
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_DATE_OPTIONS, function (state, payload) {
    state.dateOptions[payload.prop] = payload.value;
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_FILTER_OPTIONS, function (state, payload) {
    state.filterOptions[payload.prop] = payload.value;
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_AJAXING, function (state, payload) {
    state.ajaxing = payload.value;
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_LIST, function (state, payload) {
    state.list = payload.value;
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_TOTAL, function (state, payload) {
    state.invoice_total = payload.invoice_total;
    state.invoice_order_total = payload.invoice_order_total;
    state.allowance_total = payload.allowance_total;
    state.allowance_order_total = payload.allowance_order_total;
    state.total_by_branch = payload.total_by_branch;
    state.total_by_payment = payload.total_by_payment;
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_ITEM_OPTIONS, function (state, payload) {
    state.itemOptions[payload.prop] = payload.value;
}), (0, _defineProperty3.default)(_mutations, type.CLEAN_BRANCH_SELECTED, function (state) {
    state.filterOptions.branchIds = [];
}), (0, _defineProperty3.default)(_mutations, type.CLEAN_BRANCH_RELATED_SELECTED, function (state) {
    state.filterOptions.serviceIds = [];
}), (0, _defineProperty3.default)(_mutations, type.INIT_CONFRIM_STATUS, function (state, payload) {
    state.confirmStatus = payload.status;
}), (0, _defineProperty3.default)(_mutations, type.INIT_STAFF_SHOW, function (state, payload) {
    state.staffMembers = payload;
}), (0, _defineProperty3.default)(_mutations, type.CLEAR_STAFF_SELECTED, function (state) {
    state.filterOptions.selectedStaff = [];
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_STAFF_AJAXING, function (state, payload) {
    state.staffAjaxing = payload;
}), (0, _defineProperty3.default)(_mutations, type.INIT_TOTAL_PAYMENTS, function (state, payload) {
    state.initTotalPayments = payload;
}), (0, _defineProperty3.default)(_mutations, type.INIT_BRANCH_TOTAL_PAYMENTS, function (state, payload) {
    state.initBranchTotalPayments = payload;
}), _mutations);

var api = {
    fetchCheckoutMemberData: function fetchCheckoutMemberData(memberIds) {
        return new _promise2.default(function (resolve) {
            var branchIds = state.filterOptions.branchIds.map(function (elem) {
                return elem.id;
            });
            var issueStatuses = [];
            var allowanceStatuses = [];
            var manualStatuses = [];
            state.filterOptions.issueStatuses.forEach(function (elem) {
                if (elem.status == 4) {
                    manualStatuses.push(elem.status);
                } else if (elem.status == 0 || elem.status == 1) {
                    issueStatuses.push(elem.status);
                } else {
                    allowanceStatuses.push(elem.status);
                }
            });
            var checkoutMembers = state.filterOptions.selectedStaff.map(function (elem) {
                return elem.id;
            });
            if (checkoutMembers.length == 0) {
                checkoutMembers = memberIds;
            }
            var postData = {
                params: {
                    studio_id: state.filterOptions.studioId.id,
                    branch_ids: branchIds,
                    start_date: state.dateOptions.startDate,
                    end_date: state.dateOptions.endDate,
                    issue_statuses: issueStatuses,
                    allowance_statuses: allowanceStatuses,
                    manual_statuses: manualStatuses,
                    checkout_member_ids: checkoutMembers,
                    checkout_member_is_me: state.filterOptions.checkoutMemberIsMe
                }
            };
            Vue.http.get('/adminapi/report/fetch_checkout_member_order_data', postData).then(function (_ref) {
                var data = _ref.data;
                return resolve(data.data);
            });
        });
    },
    initStaff: function initStaff() {
        return new _promise2.default(function (resolve) {
            var branchIds = state.filterOptions.branchIds.map(function (elem) {
                return elem.id;
            });
            var postData = {
                params: {
                    branch_ids: branchIds,
                    start_date: state.dateOptions.startDate,
                    end_date: state.dateOptions.endDate
                }
            };
            if (!state.filterOptions.studioId || state.filterOptions.studioId.id == "0") {
                return;
            }
            Vue.http.get('/adminapi/pos/checkout_members/studio/' + state.filterOptions.studioId.id, postData).then(function (_ref2) {
                var data = _ref2.data;
                return resolve({
                    members: data.members
                });
            });
        });
    }
};

var actions = {
    generatePayment: function generatePayment(_ref3) {
        var commit = _ref3.commit;
        //動態產生各支付方式的<th>
        var totalByPayment = state.total_by_payment;
        var paymentList = [];
        (0, _keys2.default)(totalByPayment).map(function (pId) {
            var paymentDisplayName = totalByPayment[pId].alias_name ? totalByPayment[pId].alias_name : totalByPayment[pId].name;
            paymentList.push(paymentDisplayName + '收入');
            paymentList.push(paymentDisplayName + '退費');
        });
        commit(type.INIT_TOTAL_PAYMENTS, paymentList);
    },
    generateBranch: function generateBranch(_ref4) {
        var commit = _ref4.commit;
        //各場館若無 [動態產生的支付方式] 就補 0
        var totalByBranch = state.total_by_branch;
        var results = (0, _keys2.default)(totalByBranch).map(function (branchName) {
            var pObj = [];
            pObj.push(branchName);
            (0, _keys2.default)(state.total_by_payment).map(function (pId) {
                //收入
                pObj.push(totalByBranch[branchName].hasOwnProperty(pId) ? $17.thousandthFormat(totalByBranch[branchName][pId]['income']) : 0);
                //退費
                pObj.push(totalByBranch[branchName].hasOwnProperty(pId) ? $17.thousandthFormat(Math.abs(totalByBranch[branchName][pId]['refund'])) : 0);
            });
            return pObj;
        });
        commit(type.INIT_BRANCH_TOTAL_PAYMENTS, results);
    },
    submitCheckoutMemberReport: function submitCheckoutMemberReport(_ref5) {
        var commit = _ref5.commit,
            dispatch = _ref5.dispatch;

        if (!state.dateOptions.startDate || state.dateOptions.startDate == 'Invalid date') {
            return $17.formatErrorAlert('日期：請填寫 開始日期');
        }
        if (!state.dateOptions.endDate || state.dateOptions.endDate == 'Invalid date') {
            return $17.formatErrorAlert('日期：請填寫 結束日期');
        }
        if (state.dateOptions.startDate > state.dateOptions.endDate) {
            return $17.formatErrorAlert('日期：開始日期不能大於結束日期');
        }
        // commit(type.CLOSE_ALL_BLOCK); //Disabled close all block when submit form
        dispatch('fetchCheckoutMemberData');
    },
    toggleBlock: function toggleBlock(_ref6, payload) {
        var commit = _ref6.commit;

        commit(type.TOGGLE_BLOCK, payload);
    },
    changeDateOption: function changeDateOption(_ref7, payload) {
        var commit = _ref7.commit;

        commit(type.CHANGE_DATE_OPTIONS, payload);
    },
    changeFilterOption: function changeFilterOption(_ref8, payload) {
        var commit = _ref8.commit;

        commit(type.CHANGE_FILTER_OPTIONS, payload);
    },
    cleanBranch: function cleanBranch(_ref9) {
        var commit = _ref9.commit;

        commit(type.CLEAN_BRANCH_SELECTED);
    },
    cleanBranchRelated: function cleanBranchRelated(_ref10) {
        var commit = _ref10.commit;

        commit(type.CLEAN_BRANCH_RELATED_SELECTED);
    },
    changeItemOption: function changeItemOption(_ref11, payload) {
        var commit = _ref11.commit;

        commit(type.CHANGE_ITEM_OPTIONS, payload);
    },
    fetchCheckoutMemberData: function fetchCheckoutMemberData(_ref12) {
        var commit = _ref12.commit,
            state = _ref12.state,
            dispatch = _ref12.dispatch;

        var memberIds = state.staffMembers.reduce(function (carry, member) {
            carry.push(member.id);
            return carry;
        }, []);
        commit(type.CHANGE_AJAXING, {
            value: true
        });
        api.fetchCheckoutMemberData(memberIds).then(function (response) {
            commit(type.CHANGE_AJAXING, {
                value: false
            });
            commit(type.CHANGE_LIST, {
                value: response.list
            });
            commit(type.CHANGE_TOTAL, {
                invoice_order_total: response.invoiceOrderTotal + response.manualInvoiceOrderTotal,
                invoice_total: response.invoiceTotal,
                allowance_order_total: response.allowanceOrderTotal + response.manualAllowanceOrderTotal,
                allowance_total: response.allowanceTotal,
                total_by_payment: response.totalByPayment,
                total_by_branch: response.totalByBranch
            });
            dispatch('generatePayment');
            dispatch('generateBranch');
        });
    },
    setDetailTarget: function setDetailTarget(_ref13, payload) {
        var commit = _ref13.commit;

        commit(type.CHANGE_DETAIL, payload);
    },
    initStaff: function initStaff(_ref14) {
        var commit = _ref14.commit;

        commit(type.CHANGE_STAFF_AJAXING, true);
        commit(type.CLEAR_STAFF_SELECTED, []);
        commit(type.INIT_STAFF_SHOW, []);
        api.initStaff().then(function (response) {
            commit(type.INIT_CONFRIM_STATUS, response);
            commit(type.INIT_STAFF_SHOW, response.members);
            commit(type.CHANGE_STAFF_AJAXING, false);
        }, function (reason) {
            commit(type.CHANGE_STAFF_AJAXING, false);
        });
    }
};

exports.default = {
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations
};

},{"babel-runtime/core-js/object/keys":56,"babel-runtime/core-js/promise":59,"babel-runtime/helpers/defineProperty":65}],1599:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {
    progressLine: {
        1: { name: '', component: '' }
    },
    currentStepNo: 1,
    dataCollection: {}
};

var mutations = {
    initProgressLine: function initProgressLine(state, payload) {
        state.progressLine = payload;
    },
    clearData: function clearData(state) {
        state.currentStepNo = 1;
        state.dataCollection = {};
    },
    clearUsedData: function clearUsedData(state, stepNo) {
        if (!state.progressLine[stepNo]) return;
        for (var index in state.progressLine) {
            var key = state.progressLine[index].component;
            if (index >= stepNo && state.dataCollection[key]) {
                delete state.dataCollection[key];
            }
        }
    },
    setCurrentStep: function setCurrentStep(state, stepNo) {
        if (state.progressLine[stepNo]) {
            state.currentStepNo = stepNo;
        } else {
            $17.swal({
                title: '發生錯誤',
                text: '請重新整理',
                type: 'error',
                showCancelButton: false
            });
        }
    },
    updateData: function updateData(state, payload) {
        var currentStepComponent = state.progressLine[state.currentStepNo].component;
        state.dataCollection[currentStepComponent] = payload;
    },
    setDataCollection: function setDataCollection(state, _ref) {
        var name = _ref.name,
            payload = _ref.payload;

        state.dataCollection[name] = payload;
    }
};

var actions = {
    initProgressLine: function initProgressLine(_ref2, payload) {
        var commit = _ref2.commit;

        commit('initProgressLine', payload);
    },
    jumpToStep: function jumpToStep(_ref3, stepNo) {
        var commit = _ref3.commit;
        // jump to assigned step
        commit('setCurrentStep', stepNo);
        commit('clearUsedData', stepNo);
    },
    goStep: function goStep(_ref4, steps) {
        var commit = _ref4.commit;
        // if steps = 1, move one step forward
        var goNo = Number(state.currentStepNo) + steps;
        if (goNo <= (0, _keys2.default)(state.progressLine).length) {
            commit('setCurrentStep', goNo);
            commit('clearUsedData', goNo);
        } else {
            commit('clearData');
        }
    },
    resetProgressLine: function resetProgressLine(_ref5) {
        var commit = _ref5.commit;

        commit('clearData');
    },
    updateData: function updateData(_ref6, payload) {
        var commit = _ref6.commit;

        commit('updateData', payload);
    },
    setDataCollection: function setDataCollection(_ref7, _ref8) {
        var commit = _ref7.commit;
        var name = _ref8.name,
            payload = _ref8.payload;

        commit('setDataCollection', { name: name, payload: payload });
    }
};

exports.default = {
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations
};

},{"babel-runtime/core-js/object/keys":56,"lodash":717}],1600:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mutations, _getters;

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var type = {
    FETCH_BASIC_INFO: 'FETCH_BASIC_INFO',
    FETCH_LAYOUT_SETTING: 'FETCH_LAYOUT_SETTING',
    FETCH_STUDIO_LIST: 'FETCH_STUDIO_LIST',
    FETCH_BRANCH_LIST: 'FETCH_BRANCH_LIST',
    FETCH_STAFF_LIST: 'FETCH_STAFF_LIST',
    FETCH_SERVICE_LIST: 'FETCH_SERVICE_LIST',
    FETCH_CONTRACT_LIST: 'FETCH_CONTRACT_LIST',
    FETCH_SERVICE_PROVIDER_LIST: 'FETCH_SERVICE_PROVIDER_LIST',
    CLEAN_STUDIO_LIST: 'CLEAN_STUDIO_LIST',
    CLEAN_BRANCH_LIST: 'CLEAN_BRANCH_LIST',
    CLEAN_READY_LIST: 'CLEAN_READY_LIST',
    CLEAN_SERVICE_PROVIDER_LIST: 'CLEAN_SERVICE_PROVIDER_LIST',
    CLEAN_SCHEDULE_LIST: 'CLEAN_SCHEDUE_LIST',
    CLEAN_SERVICE_LIST: 'CLEAN_SERVICE_LIST',
    CLEAN_CONTRACT_LIST: 'CLEAN_CONTRACT_LIST',
    CHANGE_AJAXING: 'CHANGE_AJAXING',
    CONFIGURED: 'CONFIGURED',
    ADD_TO_READY_LIST: 'ADD_TO_READY_LIST',
    APPEND_VALUE: 'APPEND_VALUE',
    APPEND_BRANCH_LIST_STUDIO: 'APPEND_BRANCH_LIST_STUDIO',
    ACTIVE_STUDIO_ID: 'ACTIVE_STUDIO_ID',
    ACTIVE_BRANCH_ID: 'ACTIVE_BRANCH_ID'
};

var state = {
    isSeventeen: false,
    isStudio: false,
    isBranch: false,
    isServiceProvider: false,
    studioId: null,
    studioName: null,
    branchId: null,
    studioList: [],
    branchList: [],
    contractList: [],
    readyList: [],
    serviceProviderList: [],
    serviceList: [],
    configured: false,
    webFunctions: [],
    customLayout: {},
    socketHost: null,
    lineLiffv2Id: null,
    preventMemberIds: [],
    s3StudioMedia: null,
    functionSwitch: [],

    ajaxing: {
        studioList: false,
        branchList: false,
        contractList: false,
        validPlan: false
    }
};

var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, type.FETCH_BASIC_INFO, function (state, payload) {
    state.isSeventeen = payload.isSeventeen;
    state.isStudio = payload.isStudio;
    state.isBranch = payload.isBranch;
    state.isServiceProvider = payload.isServiceProvider;
    state.studioId = payload.studioId;
    state.studioName = payload.studioName;
    state.branchId = payload.branchId;
    state.webFunctions = payload.webFunctions;
    state.socketHost = payload.socketHost;
    state.lineLiffv2Id = payload.lineLiffv2Id;
    state.preventMemberIds = payload.preventMemberIds;
    state.s3StudioMedia = payload.s3StudioMedia;
    state.functionSwitch = payload.functionSwitch;
}), (0, _defineProperty3.default)(_mutations, type.FETCH_LAYOUT_SETTING, function (state, payload) {
    state.customLayout['customCard'] = payload.customCard;
}), (0, _defineProperty3.default)(_mutations, type.FETCH_STUDIO_LIST, function (state, payload) {
    state.studioList = payload.studioList;
}), (0, _defineProperty3.default)(_mutations, type.FETCH_BRANCH_LIST, function (state, payload) {
    state.branchList = payload.branchList;
}), (0, _defineProperty3.default)(_mutations, type.CLEAN_STUDIO_LIST, function (state) {
    state.studioList = [];
}), (0, _defineProperty3.default)(_mutations, type.CLEAN_BRANCH_LIST, function (state) {
    state.branchList = [];
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_AJAXING, function (state, payload) {
    state.ajaxing[payload.key] = payload.value;
}), (0, _defineProperty3.default)(_mutations, type.CONFIGURED, function (state) {
    state.configured = true;
}), (0, _defineProperty3.default)(_mutations, type.ADD_TO_READY_LIST, function (state, payload) {
    state.readyList.push(payload.func);
}), (0, _defineProperty3.default)(_mutations, type.CLEAN_READY_LIST, function (state) {
    state.readyList = [];
}), (0, _defineProperty3.default)(_mutations, type.FETCH_SERVICE_PROVIDER_LIST, function (state, payload) {
    state.serviceProviderList = payload.serviceProviderList;
}), (0, _defineProperty3.default)(_mutations, type.CLEAN_SERVICE_PROVIDER_LIST, function (state) {
    state.serviceProviderList = [];
}), (0, _defineProperty3.default)(_mutations, type.FETCH_SERVICE_LIST, function (state, payload) {
    state.serviceList = payload.serviceList;
}), (0, _defineProperty3.default)(_mutations, type.CLEAN_SERVICE_LIST, function (state) {
    state.serviceList = [];
}), (0, _defineProperty3.default)(_mutations, type.FETCH_CONTRACT_LIST, function (state, payload) {
    state.contractList = payload;
}), (0, _defineProperty3.default)(_mutations, type.CLEAN_CONTRACT_LIST, function (state) {
    state.contractList = [];
}), (0, _defineProperty3.default)(_mutations, type.APPEND_VALUE, function (state, payload) {
    state[payload.key].push(payload.value);
}), (0, _defineProperty3.default)(_mutations, type.APPEND_BRANCH_LIST_STUDIO, function (state, payload) {
    state.branchList.unshift({
        branch_name: payload.showStudioName,
        id: 0
    });
}), _mutations);

var api = {
    fetchBasicInfo: function fetchBasicInfo() {
        return new _promise2.default(function (resolve) {
            _vue2.default.http.post('/adminapi/init/basic_info').then(function (_ref) {
                var data = _ref.data;
                return resolve({
                    isSeventeen: data.is_seventeen,
                    isStudio: data.is_studio,
                    isBranch: data.is_branch,
                    isServiceProvider: data.is_service_provider,
                    studioId: data.studio_id,
                    studioName: data.studioName,
                    branchId: data.branch_id,
                    webFunctions: data.web_functions,
                    socketHost: data.socket_host,
                    lineLiffv2Id: data.line_liffv2_id,
                    preventMemberIds: data.prevent_member_ids,
                    s3StudioMedia: data.s3_studio_media,
                    functionSwitch: data.function_switch
                });
            });
        });
    },
    fetchLayoutSetting: function fetchLayoutSetting() {
        return new _promise2.default(function (resolve) {
            _vue2.default.http.get('/adminapi/init/layout_setting').then(function (_ref2) {
                var data = _ref2.data;
                return resolve({
                    customCard: {
                        hidden_position: data.custom_card_hidden_position,
                        hidden_field: data.custom_card_hidden_field
                    }
                });
            });
        });
    },
    createWebLocalSettingId: function createWebLocalSettingId(studio_id, branch_id) {
        return new _promise2.default(function (resolve) {
            _vue2.default.http.post('/adminapi/web-local-setting/create', {
                studio_id: studio_id,
                branch_id: branch_id
            }).then(function (response) {
                resolve(response.data);
            });
        });
    },
    fetchStudioList: function fetchStudioList() {
        return new _promise2.default(function (resolve) {
            _vue2.default.http.post('/adminapi/studio_select_list').then(function (_ref3) {
                var data = _ref3.data;
                return resolve({
                    studioList: data.studios
                });
            });
        });
    },
    fetchBranchList: function fetchBranchList(studioId) {
        studioId = studioId || state.studioId;
        return new _promise2.default(function (resolve) {
            _vue2.default.http.get('/adminapi/init/branch_select_list?studio_id=' + studioId).then(function (_ref4) {
                var data = _ref4.data;
                return resolve({
                    branchList: data.branches
                });
            });
        });
    },
    fetchServiceProviderList: function fetchServiceProviderList(branchIds, studioId) {
        studioId = studioId || state.studioId;
        return new _promise2.default(function (resolve) {
            var postData = {
                studio_id: studioId,
                branch_ids: branchIds
            };
            _vue2.default.http.post('/adminapi/service_provider_select_list', postData).then(function (_ref5) {
                var data = _ref5.data;
                return resolve({
                    serviceProviderList: data.service_providers
                });
            });
        });
    },
    fetchServiceProviderAllList: function fetchServiceProviderAllList(payload) {

        var studioId = payload.studioId || state.studioId;
        return new _promise2.default(function (resolve) {
            var postData = {
                studio_id: studioId,
                branch_ids: payload.branchIds
            };
            if (payload.startDate && payload.endDate) {
                postData.start_date = payload.startDate;
                postData.end_date = payload.endDate;
            }
            _vue2.default.http.post('/adminapi/service_provider_select_all_list', postData).then(function (_ref6) {
                var data = _ref6.data;
                return resolve({
                    serviceProviderList: data.service_providers
                });
            });
        });
    },
    fetchServiceList: function fetchServiceList(branchIds, studioId) {
        var isService = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        var isNotDelete = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

        studioId = studioId || state.studioId;
        return new _promise2.default(function (resolve) {
            var postData = {
                studio_id: studioId,
                branch_ids: branchIds,
                isService: isService,
                isNotDelete: isNotDelete
            };
            _vue2.default.http.post('/adminapi/service_select_list', postData).then(function (_ref7) {
                var data = _ref7.data;
                return resolve({
                    serviceList: data.services
                });
            });
        });
    },
    fetchContractList: function fetchContractList(studioId, branchId, props) {

        studioId = studioId || state.studioId;
        branchId = branchId || state.branchId;

        return new _promise2.default(function (resolve) {
            var queryString = '?studio_id=' + studioId + '&with_delete=' + props.withDelete;
            if (branchId != 0) {
                queryString = queryString + '&branch_id=' + branchId;
            }
            if (props.contractType != null) {
                queryString = queryString + '&contract_type=' + props.contractType;
            }
            _vue2.default.http.get('/adminapi/studio_branch_resources/contracts' + queryString).then(function (_ref8) {
                var data = _ref8.data;
                return resolve({
                    contracts: data
                });
            });
        });
    }
};

var actions = {
    fetchBasicInfo: function fetchBasicInfo(_ref9) {
        var commit = _ref9.commit;

        return new _promise2.default(function (resolve) {
            api.fetchBasicInfo().then(function (response) {
                commit(type.FETCH_BASIC_INFO, response);
                commit(type.CONFIGURED);
                var readyList = state.readyList;
                commit(type.CLEAN_READY_LIST);
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = (0, _getIterator3.default)(readyList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var func = _step.value;

                        func();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                resolve(response);
            });
        });
    },
    fetchLayoutSetting: function fetchLayoutSetting(_ref10) {
        var commit = _ref10.commit;

        api.fetchLayoutSetting().then(function (response) {
            commit(type.FETCH_LAYOUT_SETTING, response);
        });
    },
    fetchStudioList: function fetchStudioList(_ref11) {
        var commit = _ref11.commit;

        commit(type.CHANGE_AJAXING, {
            key: 'studioList',
            value: true
        });
        commit(type.CLEAN_STUDIO_LIST);
        commit(type.CLEAN_BRANCH_LIST);
        api.fetchStudioList().then(function (response) {
            commit(type.FETCH_STUDIO_LIST, response);
            commit(type.CHANGE_AJAXING, {
                key: 'studioList',
                value: false
            });
        });
    },
    fetchBranchList: function fetchBranchList(_ref12) {
        var commit = _ref12.commit;
        var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        commit(type.CHANGE_AJAXING, {
            key: 'branchList',
            value: true
        });
        commit(type.CLEAN_BRANCH_LIST);

        api.fetchBranchList(payload.studioId).then(function (response) {
            commit(type.FETCH_BRANCH_LIST, response);
            commit(type.CHANGE_AJAXING, {
                key: 'branchList',
                value: false
            });
            if (payload.appendStduio && payload.showStudioName) {
                commit(type.APPEND_BRANCH_LIST_STUDIO, payload);
            }
        });
    },
    configuredRun: function configuredRun(_ref13, payload) {
        var commit = _ref13.commit;

        var isFunction = typeof payload == 'function';
        payload = isFunction ? { func: payload } : payload;
        state.configured ? payload.func() : commit(type.ADD_TO_READY_LIST, payload);
    },
    setUp: function setUp(_ref14) {
        var dispatch = _ref14.dispatch;

        dispatch('fetchBasicInfo').then(function (response) {
            dispatch('webadmin/webLocalSetting/init', {}, { root: true });
        });
    },
    initLayoutSetting: function initLayoutSetting(_ref15) {
        var dispatch = _ref15.dispatch;

        dispatch('fetchLayoutSetting');
    },
    checkHasRight: function checkHasRight(_ref16, payload) {
        var state = _ref16.state;

        return state.webFunctions.indexOf(payload.functionName) > -1;
    },
    fetchServiceProviderList: function fetchServiceProviderList(_ref17) {
        var commit = _ref17.commit;
        var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        commit(type.CHANGE_AJAXING, {
            key: 'serviceProviderList',
            value: true
        });
        commit(type.CLEAN_SERVICE_PROVIDER_LIST);
        api.fetchServiceProviderList(payload.branchIds, payload.studioId).then(function (response) {
            commit(type.FETCH_SERVICE_PROVIDER_LIST, response);
            commit(type.CHANGE_AJAXING, {
                key: 'serviceProviderList',
                value: false
            });
        });
    },
    fetchServiceProviderAllList: function fetchServiceProviderAllList(_ref18) {
        var _this = this;

        var commit = _ref18.commit;
        var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            commit(type.CHANGE_AJAXING, {
                                key: 'serviceProviderList',
                                value: true
                            });
                            commit(type.CLEAN_SERVICE_PROVIDER_LIST);
                            _context.next = 4;
                            return api.fetchServiceProviderAllList(payload).then(function (response) {
                                commit(type.FETCH_SERVICE_PROVIDER_LIST, response);
                                commit(type.CHANGE_AJAXING, {
                                    key: 'serviceProviderList',
                                    value: false
                                });
                            });

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },
    fetchServiceList: function fetchServiceList(_ref19) {
        var commit = _ref19.commit;
        var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        commit(type.CHANGE_AJAXING, {
            key: 'serviceList',
            value: true
        });
        commit(type.CLEAN_SERVICE_LIST);
        api.fetchServiceList(payload.branchIds, payload.studioId, payload.isService, payload.isNotDelete).then(function (response) {
            // response.serviceList.unshift({id:0,name:'所有服務'});
            commit(type.FETCH_SERVICE_LIST, response);
            commit(type.CHANGE_AJAXING, {
                key: 'serviceList',
                value: false
            });
        });
    },
    fetchContractList: function fetchContractList(_ref20) {
        var commit = _ref20.commit;
        var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        commit(type.CHANGE_AJAXING, {
            key: 'contractList',
            value: true
        });
        commit(type.CLEAN_SERVICE_LIST);
        var props = {
            withDelete: typeof payload.withDelete !== 'undefined' ? payload.withDelete : false,
            contractType: typeof payload.contractType !== 'undefined' ? payload.contractType : null
        };
        api.fetchContractList(payload.studioId, payload.branchId, props).then(function (response) {
            commit(type.FETCH_CONTRACT_LIST, response.contracts);
            commit(type.CHANGE_AJAXING, {
                key: 'contractList',
                value: false
            });
        });
    },
    pushObjectStatus: function pushObjectStatus(_ref21, payload) {
        var commit = _ref21.commit;

        commit(type.APPEND_VALUE, payload);
    },
    appendBranchListStudio: function appendBranchListStudio(_ref22, payload) {
        var commit = _ref22.commit;

        commit(type.APPEND_BRANCH_LIST_STUDIO, payload);
    }
};
// getters
var getters = (_getters = {}, (0, _defineProperty3.default)(_getters, type.ACTIVE_STUDIO_ID, function (state, getters, rootState) {
    if (state.isSeventeen) {
        return rootState.filters.selected_studio_id;
    }
    return state.studioId;
}), (0, _defineProperty3.default)(_getters, type.ACTIVE_BRANCH_ID, function (state, getters, rootState) {
    if (state.isSeventeen || state.isStudio) {
        return rootState.filters.selected_branch_id;
    }
    return state.branchId;
}), _getters);
exports.default = {
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
};

},{"babel-runtime/core-js/get-iterator":46,"babel-runtime/core-js/promise":59,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/defineProperty":65,"babel-runtime/regenerator":75,"vue":792}],1601:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mutations;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var types = {
    CRM_SETSTATUS: 'CRM_SETSTATUS',
    CRM_CHANGE_CONTRACT: 'CRM_CHANGE_CONTRACT',
    CRM_RESET: 'CRM_RESET',
    CRM_CHANGE_COMMENT: 'CRM_CHANGE_COMMENT',
    CRM_MEMBER_CONTRACT_RECORD: 'CRM_MEMBER_CONTRACT_RECORD',
    SET_SALSEMEN_LIST: 'SET_SALSEMEN_LIST',
    SET_ALL_BRANCH_SALSEMEN: 'SET_ALL_BRANCH_SALSEMEN',
    SET_BRANCH_SALSEMEN: 'SET_BRANCH_SALSEMEN'
};

var state = {
    mainContracts: [],
    changedContract: {},
    member: {
        name: '',
        email: '',
        phone: '',
        picture_path: '',
        contract_remark: ''
    },
    memberStatus: {},
    memberContractRecords: {},
    salsemen: [],
    allBranchSalsemen: [],
    salsemenCurrentBranchId: null
};

var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.CRM_SETSTATUS, function (state, payload) {
    for (var key in payload) {
        state[key] = payload[key];
    }
}), (0, _defineProperty3.default)(_mutations, types.CRM_CHANGE_CONTRACT, function (state, changedContract) {
    state.changedContract = changedContract;
}), (0, _defineProperty3.default)(_mutations, types.CRM_RESET, function (state) {
    state.mainContracts = [];
    state.member = {
        name: '',
        email: '',
        phone: '',
        picture_path: '',
        contract_remark: ''
    };
    state.contractRemark = '';
    state.memberContractRecords = {};
    state.memberStatus = {};
}), (0, _defineProperty3.default)(_mutations, types.CRM_CHANGE_COMMENT, function (state, comment) {
    state.member.contract_remark = comment;
}), (0, _defineProperty3.default)(_mutations, types.CRM_MEMBER_CONTRACT_RECORD, function (state, _ref) {
    var memberContractId = _ref.memberContractId,
        records = _ref.records,
        toggled = _ref.toggled;

    Vue.set(state.memberContractRecords, memberContractId, {
        records: records,
        toggled: toggled
    });
}), (0, _defineProperty3.default)(_mutations, types.SET_ALL_BRANCH_SALSEMEN, function (state, _ref2) {
    var branchSalsemen = _ref2.branchSalsemen;

    state.allBranchSalsemen = branchSalsemen;
}), (0, _defineProperty3.default)(_mutations, types.SET_SALSEMEN_LIST, function (state, _ref3) {
    var salsemen = _ref3.salsemen;

    state.salsemen = salsemen;
    state.salsemenCurrentBranchId = branchId;
}), (0, _defineProperty3.default)(_mutations, types.SET_BRANCH_SALSEMEN, function (state, branchId) {
    if (typeof state.allBranchSalsemen[branchId] === 'undefined') {
        state.salsemen = [];
        state.salsemenCurrentBranchId = branchId;
        return;
    }
    state.salsemen = state.allBranchSalsemen[branchId];
    state.salsemenCurrentBranchId = branchId;
}), _mutations);

var api = {
    fetchMemberContract: function fetchMemberContract(memberId) {
        return new _promise2.default(function (resolve) {
            Vue.http.get('/adminapi/member-contract/' + memberId).then(function (response) {
                return resolve({
                    mainContracts: response.body
                });
            });
        });
    },
    fetchOneMemberContract: function fetchOneMemberContract(memberContractId) {
        return new _promise2.default(function (resolve) {
            Vue.http.get('/adminapi/member-contract/contract/' + memberContractId).then(function (response) {
                return resolve({
                    mainContract: response.body
                });
            });
        });
    },
    deleteMember: function deleteMember(memberId, failCallBack) {
        return new _promise2.default(function (resolve) {
            Vue.http.delete('/adminapi/member/' + memberId).then(function (response) {
                return resolve({
                    ok: response.ok
                });
            }, function (response) {
                failCallBack && failCallBack();
            });
        });
    },
    getMember: function getMember(memberId) {
        return new _promise2.default(function (resolve) {
            Vue.http.get('/adminapi/member/' + memberId).then(function (response) {
                return resolve({
                    member: response.body.member
                });
            });
        });
    },
    getMemberStatus: function getMemberStatus(memberId) {
        return new _promise2.default(function (resolve, reject) {
            Vue.http.get('/adminapi/member/' + memberId + '/status').then(function (response) {
                resolve({ memberStatus: response.data.member_status });
            }, function (response) {
                reject({ error: response });
            });
        });
    },
    fetchMemberContractRecords: function fetchMemberContractRecords(memberContractId) {
        return new _promise2.default(function (resolve) {
            Vue.http.get('/my-account/member-contract/' + memberContractId + '/records').then(function (response) {
                return resolve({
                    records: response.body
                });
            });
        });
    },
    fetchSalseman: function fetchSalseman(studioId) {
        return new _promise2.default(function (resolve) {
            Vue.http.get('/adminapi/salseman/member/studio/' + studioId).then(function (response) {
                return resolve({
                    members: response.body.list
                });
            });
        });
    }
};

var actions = {
    fetchMemberContract: function fetchMemberContract(_ref4, memberId) {
        var _this = this;

        var commit = _ref4.commit;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            return _context.abrupt('return', api.fetchMemberContract(memberId).then(function (response) {
                                commit('CRM_SETSTATUS', { 'mainContracts': response.mainContracts });
                            }));

                        case 1:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },
    fetchOneMemberContract: function fetchOneMemberContract(_ref5, memberContractId) {
        var _this2 = this;

        var commit = _ref5.commit;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            return _context2.abrupt('return', api.fetchOneMemberContract(memberContractId).then(function (response) {
                                commit('CRM_SETSTATUS', { 'mainContracts': response.mainContract });
                                commit('CRM_CHANGE_CONTRACT', response.mainContract[0].main);
                            }));

                        case 1:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }))();
    },
    deleteMember: function deleteMember(_ref6, _ref7) {
        var _this3 = this;

        var commit = _ref6.commit;
        var memberId = _ref7.memberId,
            successCallBack = _ref7.successCallBack,
            failCallBack = _ref7.failCallBack;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            api.deleteMember(memberId, failCallBack).then(function (response) {
                                successCallBack && successCallBack();
                            });

                        case 1:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3);
        }))();
    },
    getMember: function getMember(_ref8, _ref9) {
        var _this4 = this;

        var commit = _ref8.commit;
        var memberId = _ref9.memberId;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            _context4.next = 2;
                            return api.getMember(memberId).then(function (response) {
                                commit('CRM_SETSTATUS', { member: response.member });
                            });

                        case 2:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this4);
        }))();
    },
    getMemberStatus: function getMemberStatus(_ref10, memberId) {
        var _this5 = this;

        var commit = _ref10.commit;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5() {
            return _regenerator2.default.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            _context5.next = 2;
                            return api.getMemberStatus(memberId).then(function (response) {
                                commit('CRM_SETSTATUS', { 'memberStatus': response.memberStatus });
                            }).catch(function (response) {
                                $17.swal({
                                    title: '無法取得會員的狀態',
                                    type: 'error',
                                    showCancelButton: false,
                                    showLoaderOnConfirm: true
                                });
                            });

                        case 2:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this5);
        }))();
    },
    fetchMemberContractRecords: function fetchMemberContractRecords(_ref11, _ref12) {
        var _this6 = this;

        var commit = _ref11.commit;
        var memberContractId = _ref12.memberContractId,
            toggled = _ref12.toggled;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6() {
            return _regenerator2.default.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            return _context6.abrupt('return', api.fetchMemberContractRecords(memberContractId).then(function (response) {
                                commit('CRM_MEMBER_CONTRACT_RECORD', { memberContractId: memberContractId, records: response.records, toggled: toggled });
                            }));

                        case 1:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, _this6);
        }))();
    },
    fetchSalseman: function fetchSalseman(_ref13, studioId) {
        var commit = _ref13.commit;

        return api.fetchSalseman(studioId).then(function (response) {
            commit('SET_ALL_BRANCH_SALSEMEN', { branchSalsemen: response.members });
        });
    },
    changeSalseman: function changeSalseman(_ref14, _ref15) {
        var commit = _ref14.commit;
        var branchId = _ref15.branchId,
            studioId = _ref15.studioId;

        // if (typeof state.allBranchSalsemen[branchId] === 'undefined') {
        //     actions.fetchSalseman({ commit }, studioId).then(response => {
        //         commit('SET_BRANCH_SALSEMEN', branchId);
        //     });
        //     return;
        // }
        commit('SET_BRANCH_SALSEMEN', branchId);
    }
};

exports.default = {
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations
};

},{"babel-runtime/core-js/promise":59,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/defineProperty":65,"babel-runtime/regenerator":75}],1602:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mutations, _getters;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var type = {
    SET_CHARITIES: 'SET_CHARITIES',
    SET_BRANCH_CHARITIES: 'SET_BRANCH_CHARITIES',
    SET_SETTINGS: 'SET_SETTINGS',
    SET_SETTING: 'SET_SETTING',
    SET_ISSUE_ACTIVE: 'SET_ISSUE_ACTIVE',
    SET_ISSUE_DEFAULT: 'SET_ISSUE_DEFAULT',
    APPEND_ISSUE_ACTIVE: 'APPEND_ISSUE_ACTIVE',
    EPSON_PRINT_DATA: 'EPSON_PRINT_DATA',
    SET_PRINTER_DATA: 'SET_PRINTER_DATA',
    EPSON_PRINT_DATA_DETAIL: 'EPSON_PRINT_DATA_DETAIL'

};

var state = {
    charities: [],
    branchCharities: [],
    setting: {
        id: '',
        active: '',
        auto_allowance_issue: '',
        auto_issue: '',
        charities: [],
        hash_iv: '',
        hash_key: '',
        issue_methods: {
            active: [],
            default: ''
        },
        merchant_id: '',
        type: '',
        ubn: '',
        show_title: '',
        invoice_online: '',
        allow_duplicate_invoice_on_site: '',
        invoice_online_print_remark: ''
    },
    printData: {}
};

var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, type.SET_CHARITIES, function (state, payload) {
    state.charities = payload;
}), (0, _defineProperty3.default)(_mutations, type.SET_PRINTER_DATA, function (state, payload) {
    state.printData = payload;
}), (0, _defineProperty3.default)(_mutations, type.SET_BRANCH_CHARITIES, function (state, payload) {
    state.branchCharities = payload;
}), (0, _defineProperty3.default)(_mutations, type.SET_SETTING, function (state, payload) {
    state.setting[payload.key] = payload.value;
}), (0, _defineProperty3.default)(_mutations, type.SET_ISSUE_ACTIVE, function (state, payload) {
    state.setting.issue_methods.active = payload;
}), (0, _defineProperty3.default)(_mutations, type.APPEND_ISSUE_ACTIVE, function (state, payload) {
    state.setting.issue_methods.active.push(payload);
}), (0, _defineProperty3.default)(_mutations, type.SET_ISSUE_DEFAULT, function (state, payload) {
    state.setting.issue_methods.default = payload;
}), (0, _defineProperty3.default)(_mutations, type.SET_SETTINGS, function (state, payload) {
    state.setting.id = payload.id;
    state.setting.ubn = payload.ubn;
    state.setting.show_title = payload.show_title;
    state.setting.active = payload.active;
    state.setting.auto_allowance_issue = payload.auto_allowance_issue;
    state.setting.auto_issue = payload.auto_issue;
    state.setting.charities = payload.charities;
    state.setting.hash_iv = payload.hash_iv;
    state.setting.hash_key = payload.hash_key;
    state.setting.issue_methods = payload.issue_methods;
    state.setting.merchant_id = payload.merchant_id;
    state.setting.invoice_online = payload.invoice_online;
    state.setting.allow_duplicate_invoice_on_site = payload.allow_duplicate_invoice_on_site;
    state.setting.invoice_online_print_remark = payload.invoice_online_print_remark;
}), _mutations);

var api = {
    fetchCharities: function fetchCharities() {
        return new _promise2.default(function (resolve) {
            Vue.http.get('/adminapi/invoice_setting/charities').then(function (_ref) {
                var data = _ref.data;
                return resolve(data.list);
            });
        });
    },
    fetchBranchCharities: function fetchBranchCharities(branchId) {
        return new _promise2.default(function (resolve) {
            Vue.http.get('/adminapi/invoice_setting/charities/branch/' + branchId).then(function (_ref2) {
                var data = _ref2.data;
                return resolve(data.list);
            });
        });
    },
    fetchBranchSetting: function fetchBranchSetting(branchId) {
        return new _promise2.default(function (resolve) {
            Vue.http.get('/adminapi/invoice_setting/edit/' + branchId).then(function (_ref3) {
                var data = _ref3.data;
                return resolve(data);
            });
        });
    },
    update: function update(settingId, setting) {
        return new _promise2.default(function (resolve) {
            Vue.http.put('/adminapi/invoice_setting/' + settingId, setting).then(function (_ref4) {
                var data = _ref4.data;
                return resolve(data);
            });
        });
    },
    fetchInvoiceData: function fetchInvoiceData(orderId) {
        return new _promise2.default(function (resolve) {
            Vue.http.get('/adminapi/invoice/order/' + orderId + '/print/printEpson').then(function (_ref5) {
                var data = _ref5.data;
                return resolve({ invoice: data.invoice });
            });
        });
    }
};
// getters
var getters = (_getters = {}, (0, _defineProperty3.default)(_getters, type.EPSON_PRINT_DATA, function (state, getters, rootState) {
    return {
        "lang": "zh-tw", //語系
        "invoiceWord": state.printData.invoiceWord,
        "sellerTitle": state.printData.showTitle,
        "invoicePeriod": state.printData.periodNumber,
        "invoiceNumber": state.printData.invoiceNumber,
        "invoiceDateTime": state.printData.invoiceTime,
        "randomNumber": state.printData.randomNumber,
        "salesAmount": state.printData.taxTotal,
        "taxAmount": state.printData.tax,
        "totalAmount": state.printData.total,
        "sellerIdentifier": state.printData.salerUbn,
        "buyerIdentifier": state.printData.buyerUbn,
        "barCodeContent": state.printData.barcode,
        "qrCodeContentOne": state.printData.qrcode_l,
        "qrCodeContentTwo": state.printData.qrcode_r,
        "taxType": "TX",
        "buyerName": state.printData.memberName,
        "buyerOrderId": state.printData.orderId,
        "detail": getters.EPSON_PRINT_DATA_DETAIL
    };
}), (0, _defineProperty3.default)(_getters, type.EPSON_PRINT_DATA_DETAIL, function (getters) {
    if (!state.printData.details) {
        return [];
    }
    return state.printData.details.reduce(function (carry, detail, index) {
        if (index == 0) {
            return carry;
        }
        carry.push([detail.name, detail.count, detail.price, detail.amount]);
        return carry;
    }, []);
}), _getters);
var actions = {
    fetchCharities: function fetchCharities(_ref6) {
        var _this = this;

        var commit = _ref6.commit;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return api.fetchCharities().then(function (response) {
                                commit(type.SET_CHARITIES, response);
                            });

                        case 2:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },
    fetchBranchSetting: function fetchBranchSetting(_ref7, payload) {
        var commit = _ref7.commit;

        api.fetchBranchSetting(payload.branchId).then(function (response) {
            commit(type.SET_SETTINGS, response);
        });
    },
    update: function update(_ref8, settingId) {
        var commit = _ref8.commit;

        return api.update(settingId, state.setting).then(function (response) {
            return response;
        });
    },
    fetchBranchCharities: function fetchBranchCharities(_ref9, payload) {
        var _this2 = this;

        var commit = _ref9.commit;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return api.fetchBranchCharities(payload.branchId).then(function (response) {
                                commit(type.SET_BRANCH_CHARITIES, response);
                            });

                        case 2:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }))();
    },
    fetchInvoiceData: function fetchInvoiceData(_ref10, payload) {
        var _this3 = this;

        var commit = _ref10.commit;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.next = 2;
                            return api.fetchInvoiceData(payload.orderId).then(function (response) {
                                commit(type.SET_PRINTER_DATA, response.invoice);
                            });

                        case 2:
                            return _context3.abrupt('return', state.printData);

                        case 3:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3);
        }))();
    }
};

exports.default = {
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters,
    type: type
};

},{"babel-runtime/core-js/promise":59,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/defineProperty":65,"babel-runtime/regenerator":75}],1603:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mutations;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var type = {
    CLOSE_ALL_BLOCK: 'CLOSE_ALL_BLOCK',
    TOGGLE_BLOCK: 'TOGGLE_BLOCK',
    CHANGE_DATE_OPTIONS: 'CHANGE_DATE_OPTIONS',
    CHANGE_FILTER_OPTIONS: 'CHANGE_FILTER_OPTIONS',
    CHANGE_ITEM_OPTIONS: 'CHANGE_ITEM_OPTIONS',
    CHANGE_AJAXING: 'CHANGE_AJAXING',
    CHANGE_LIST: 'CHANGE_LIST',
    CLEAN_BRANCH_RELATED_SELECTED: 'CLEAN_BRANCH_RELATED_SELECTED',
    CLEAN_BRANCH_SELECTED: 'CLEAN_BRANCH_SELECTED'
};

var state = {
    blockOpenStatus: {
        first: true,
        second: true,
        third: false,
        fourth: false
    },
    dateOptions: {
        startDate: null,
        endDate: null
    },
    filterOptions: {
        studioId: null,
        branchIds: [],
        searchTypes: [],
        excludeFuture: false
    },
    itemOptions: {
        viewMode: 'detail'
    },
    ajaxing: false,
    list: [],
    typeShow: [{
        name: "出席",
        type: 0
    }, {
        name: "入場",
        type: 1
    }]
};

var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, type.CLOSE_ALL_BLOCK, function (state) {
    state.blockOpenStatus.first = false;
    state.blockOpenStatus.second = false;
    state.blockOpenStatus.third = false;
    state.blockOpenStatus.fourth = false;
}), (0, _defineProperty3.default)(_mutations, type.TOGGLE_BLOCK, function (state, payload) {
    state.blockOpenStatus[payload.block] = !state.blockOpenStatus[payload.block];
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_DATE_OPTIONS, function (state, payload) {
    state.dateOptions[payload.prop] = payload.value;
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_FILTER_OPTIONS, function (state, payload) {
    state.filterOptions[payload.prop] = payload.value;
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_AJAXING, function (state, payload) {
    state.ajaxing = payload.value;
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_LIST, function (state, payload) {
    state.list = payload.value;
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_ITEM_OPTIONS, function (state, payload) {
    state.itemOptions[payload.prop] = payload.value;
}), (0, _defineProperty3.default)(_mutations, type.CLEAN_BRANCH_SELECTED, function (state) {
    state.filterOptions.branchIds = [];
}), (0, _defineProperty3.default)(_mutations, type.CLEAN_BRANCH_RELATED_SELECTED, function (state) {
    state.filterOptions.serviceIds = [];
}), _mutations);

var api = {
    fetchLastBookingAdmissionData: function fetchLastBookingAdmissionData() {
        return new _promise2.default(function (resolve) {
            var branchIds = state.filterOptions.branchIds.map(function (elem) {
                return elem.id;
            });
            var searchTypes = state.filterOptions.searchTypes.map(function (elem) {
                return elem.type;
            });
            var postData = {
                params: {
                    studio_id: state.filterOptions.studioId.id,
                    branch_ids: branchIds,
                    start_date: state.dateOptions.startDate,
                    end_date: state.dateOptions.endDate,
                    search_types: searchTypes,
                    exclude_future: state.filterOptions.excludeFuture
                }
            };
            Vue.http.get('/adminapi/report/fetch_last_booking_admission_data', postData).then(function (_ref) {
                var data = _ref.data;
                return resolve(data);
            });
        });
    }
};

var actions = {
    submitReport: function submitReport(_ref2) {
        var commit = _ref2.commit,
            dispatch = _ref2.dispatch;

        if (!state.dateOptions.startDate || state.dateOptions.startDate == 'Invalid date') {
            return $17.formatErrorAlert('日期：請填寫 開始日期');
        }
        if (!state.dateOptions.endDate || state.dateOptions.endDate == 'Invalid date') {
            return $17.formatErrorAlert('日期：請填寫 結束日期');
        }
        if (state.dateOptions.startDate > state.dateOptions.endDate) {
            return $17.formatErrorAlert('日期：開始日期不能大於結束日期');
        }
        if (moment(state.dateOptions.startDate) < moment('2017-01-01')) {
            return $17.formatErrorAlert('日期: 查詢日期不能早於2017/01/01');
        }
        // commit(type.CLOSE_ALL_BLOCK); //Disabled close all block when submit form
        dispatch('fetchLastBookingAdmissionData');
    },
    toggleBlock: function toggleBlock(_ref3, payload) {
        var commit = _ref3.commit;

        commit(type.TOGGLE_BLOCK, payload);
    },
    changeDateOption: function changeDateOption(_ref4, payload) {
        var commit = _ref4.commit;

        commit(type.CHANGE_DATE_OPTIONS, payload);
    },
    changeFilterOption: function changeFilterOption(_ref5, payload) {
        var commit = _ref5.commit;

        commit(type.CHANGE_FILTER_OPTIONS, payload);
    },
    cleanBranch: function cleanBranch(_ref6) {
        var commit = _ref6.commit;

        commit(type.CLEAN_BRANCH_SELECTED);
    },
    cleanBranchRelated: function cleanBranchRelated(_ref7) {
        var commit = _ref7.commit;

        commit(type.CLEAN_BRANCH_RELATED_SELECTED);
    },
    changeItemOption: function changeItemOption(_ref8, payload) {
        var commit = _ref8.commit;

        commit(type.CHANGE_ITEM_OPTIONS, payload);
    },
    fetchLastBookingAdmissionData: function fetchLastBookingAdmissionData(_ref9) {
        var commit = _ref9.commit,
            state = _ref9.state,
            dispatch = _ref9.dispatch;

        commit(type.CHANGE_AJAXING, {
            value: true
        });
        api.fetchLastBookingAdmissionData().then(function (response) {
            commit(type.CHANGE_AJAXING, {
                value: false
            });
            commit(type.CHANGE_LIST, {
                value: response.list
            });
        });
    },
    setDetailTarget: function setDetailTarget(_ref10, payload) {
        var commit = _ref10.commit;

        commit(type.CHANGE_DETAIL, payload);
    }
};

exports.default = {
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations
};

},{"babel-runtime/core-js/promise":59,"babel-runtime/helpers/defineProperty":65}],1604:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mutations;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var type = {
    CLOSE_ALL_BLOCK: 'CLOSE_ALL_BLOCK',
    TOGGLE_BLOCK: 'TOGGLE_BLOCK',
    CHANGE_DATE_OPTIONS: 'CHANGE_DATE_OPTIONS',
    CHANGE_FILTER_OPTIONS: 'CHANGE_FILTER_OPTIONS',
    CHANGE_ITEM_OPTIONS: 'CHANGE_ITEM_OPTIONS',
    CHANGE_AJAXING: 'CHANGE_AJAXING',
    CHANGE_TAG_AJAXING: 'CHANGE_TAG_AJAXING',
    CHANGE_FIELD_AJAXING: 'CHANGE_FIELD_AJAXING',
    CHANGE_LIST: 'CHANGE_LIST',
    INIT_TAG_LIST: 'INIT_TAG_LIST',
    INIT_FIELD_LIST: 'INIT_FIELD_LIST',
    CLEAN_BRANCH_RELATED_SELECTED: 'CLEAN_BRANCH_RELATED_SELECTED',
    CLEAN_BRANCH_SELECTED: 'CLEAN_BRANCH_SELECTED',
    CLEAN_INIT_DATA: 'CLEAN_INIT_DATA'
};

var state = {
    blockOpenStatus: {
        first: true,
        second: true,
        third: false,
        fourth: false
    },
    dateOptions: {
        startDate: null,
        endDate: null
    },
    filterOptions: {
        studioId: null,
        branchIds: [],
        searchTags: [],
        searchExcludeTags: [],
        searchCustomFields: [],
        defaultFields: [],
        showFields: []
    },
    itemOptions: {
        viewMode: 'detail'
    },
    ajaxing: false,
    tagAjaxing: false,
    fieldAjaxing: false,
    list: [],
    tags: [],
    fields: []
};

var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, type.CLOSE_ALL_BLOCK, function (state) {
    state.blockOpenStatus.first = false;
    state.blockOpenStatus.second = false;
    state.blockOpenStatus.third = false;
    state.blockOpenStatus.fourth = false;
}), (0, _defineProperty3.default)(_mutations, type.TOGGLE_BLOCK, function (state, payload) {
    state.blockOpenStatus[payload.block] = !state.blockOpenStatus[payload.block];
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_DATE_OPTIONS, function (state, payload) {
    state.dateOptions[payload.prop] = payload.value;
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_FILTER_OPTIONS, function (state, payload) {
    state.filterOptions[payload.prop] = payload.value;
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_AJAXING, function (state, payload) {
    state.ajaxing = payload.value;
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_TAG_AJAXING, function (state, payload) {
    state.tagAjaxing = payload;
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_FIELD_AJAXING, function (state, payload) {
    state.fieldAjaxing = payload;
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_LIST, function (state, payload) {
    state.list = payload.value;
}), (0, _defineProperty3.default)(_mutations, type.INIT_TAG_LIST, function (state, payload) {
    state.tags = payload;
}), (0, _defineProperty3.default)(_mutations, type.INIT_FIELD_LIST, function (state, payload) {
    state.fields = payload;
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_ITEM_OPTIONS, function (state, payload) {
    state.itemOptions[payload.prop] = payload.value;
}), (0, _defineProperty3.default)(_mutations, type.CLEAN_BRANCH_SELECTED, function (state) {
    state.filterOptions.branchIds = [];
}), (0, _defineProperty3.default)(_mutations, type.CLEAN_BRANCH_RELATED_SELECTED, function (state) {
    state.filterOptions.serviceIds = [];
}), (0, _defineProperty3.default)(_mutations, type.CLEAN_INIT_DATA, function (state) {
    state.tags = [];
    state.filterOptions.searchTags = [];
    state.filterOptions.searchExcludeTags = [];

    state.fields = [];
    state.filterOptions.searchCustomFields = [];
    state.filterOptions.defaultFields = [];
}), _mutations);

var api = {
    fetchData: function fetchData() {
        return new _promise2.default(function (resolve) {
            var searchTags = state.filterOptions.searchTags.map(function (elem) {
                return elem.id;
            });
            var searchExcludeTags = state.filterOptions.searchExcludeTags.map(function (elem) {
                return elem.id;
            });
            var getData = {
                params: {
                    custom_fields: 1,
                    studio_id: state.filterOptions.studioId.id,
                    start_date: state.dateOptions.startDate,
                    end_date: state.dateOptions.endDate,
                    include_tags: searchTags,
                    exclude_tags: searchExcludeTags
                }
            };
            Vue.http.get('/adminapi/report/fetch_studio_member_data', getData).then(function (_ref) {
                var data = _ref.data;
                return resolve(data);
            });
        });
    },
    fetchTags: function fetchTags() {
        return new _promise2.default(function (resolve) {
            Vue.http.get('/adminapi/tag/studio_tags/' + state.filterOptions.studioId.id).then(function (_ref2) {
                var data = _ref2.data;
                return resolve({
                    tags: data.tags
                });
            });
        });
    },
    fetchCustomFields: function fetchCustomFields() {
        return new _promise2.default(function (resolve) {
            Vue.http.get('/adminapi/custom_fields/' + state.filterOptions.studioId.id).then(function (response) {
                var fields = response.data.fields.filter(function (field) {
                    return field.ref_field !== 'picture';
                });
                resolve({ fields: fields });
            });
        });
    }
};

var actions = {
    submitReport: function submitReport(_ref3) {
        var commit = _ref3.commit,
            dispatch = _ref3.dispatch,
            state = _ref3.state;

        if (!state.dateOptions.startDate || state.dateOptions.startDate == 'Invalid date') {
            return $17.formatErrorAlert('日期：請填寫 開始日期');
        }
        if (!state.dateOptions.endDate || state.dateOptions.endDate == 'Invalid date') {
            return $17.formatErrorAlert('日期：請填寫 結束日期');
        }
        if (state.dateOptions.startDate > state.dateOptions.endDate) {
            return $17.formatErrorAlert('日期：開始日期不能大於結束日期');
        }
        // commit(type.CLOSE_ALL_BLOCK); //Disabled close all block when submit form
        var stateSearchCustomeFields = state.filterOptions.searchCustomFields;
        var newShowCustomField = state.fields.filter(function (field) {
            return stateSearchCustomeFields.includes(field.id);
        });
        commit(type.CHANGE_FILTER_OPTIONS, { 'prop': 'showFields', value: newShowCustomField });
        dispatch('fetchData');
    },
    toggleBlock: function toggleBlock(_ref4, payload) {
        var commit = _ref4.commit;

        commit(type.TOGGLE_BLOCK, payload);
    },
    changeDateOption: function changeDateOption(_ref5, payload) {
        var commit = _ref5.commit;

        commit(type.CHANGE_DATE_OPTIONS, payload);
    },
    changeFilterOption: function changeFilterOption(_ref6, payload) {
        var commit = _ref6.commit;

        commit(type.CHANGE_FILTER_OPTIONS, payload);
    },
    cleanBranch: function cleanBranch(_ref7) {
        var commit = _ref7.commit;

        commit(type.CLEAN_BRANCH_SELECTED);
    },
    cleanBranchRelated: function cleanBranchRelated(_ref8) {
        var commit = _ref8.commit;

        commit(type.CLEAN_BRANCH_RELATED_SELECTED);
    },
    changeItemOption: function changeItemOption(_ref9, payload) {
        var commit = _ref9.commit;

        commit(type.CHANGE_ITEM_OPTIONS, payload);
    },
    fetchData: function fetchData(_ref10) {
        var commit = _ref10.commit,
            state = _ref10.state,
            dispatch = _ref10.dispatch;

        commit(type.CHANGE_AJAXING, {
            value: true
        });
        api.fetchData().then(function (response) {
            commit(type.CHANGE_AJAXING, {
                value: false
            });
            commit(type.CHANGE_LIST, {
                value: response.list
            });
        });
    },
    fetchTags: function fetchTags(_ref11) {
        var commit = _ref11.commit;

        commit(type.CHANGE_TAG_AJAXING, true);
        commit(type.CLEAN_INIT_DATA);
        api.fetchTags().then(function (response) {
            commit(type.INIT_TAG_LIST, response.tags);
            commit(type.CHANGE_TAG_AJAXING, false);
        }, function (reason) {
            commit(type.CHANGE_TAG_AJAXING, false);
        });
    },
    fetchCustomFields: function fetchCustomFields(_ref12) {
        var commit = _ref12.commit,
            state = _ref12.state;

        commit(type.CHANGE_FIELD_AJAXING, true);
        commit(type.CLEAN_INIT_DATA);
        api.fetchCustomFields().then(function (response) {
            var fields = response.fields;
            var defaultFields = ['name', 'email', 'phone'];
            for (var i = 0; i < fields.length; i++) {
                var field = fields[i];
                if (defaultFields.indexOf(field.ref_field) > -1) {
                    var copyState = state.filterOptions.defaultFields.slice();
                    copyState.push(field.id);
                    commit(type.CHANGE_FILTER_OPTIONS, { 'prop': 'searchCustomFields', value: copyState });
                    commit(type.CHANGE_FILTER_OPTIONS, { 'prop': 'defaultFields', value: copyState });
                }
            }

            commit(type.INIT_FIELD_LIST, fields);
            commit(type.CHANGE_FIELD_AJAXING, false);
        }, function (reason) {
            commit(type.CHANGE_FIELD_AJAXING, false);
        });
    },
    setDetailTarget: function setDetailTarget(_ref13, payload) {
        var commit = _ref13.commit;

        commit(type.CHANGE_DETAIL, payload);
    }
};

exports.default = {
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations
};

},{"babel-runtime/core-js/promise":59,"babel-runtime/helpers/defineProperty":65}],1605:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mutations;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var type = {
    CLOSE_ALL_BLOCK: 'CLOSE_ALL_BLOCK',
    TOGGLE_BLOCK: 'TOGGLE_BLOCK',
    CHANGE_DATE_OPTIONS: 'CHANGE_DATE_OPTIONS',
    CHANGE_FILTER_OPTIONS: 'CHANGE_FILTER_OPTIONS',
    CLEAN_BRANCH_RELATED_SELECTED: 'CLEAN_BRANCH_RELATED_SELECTED',
    CLEAN_BRANCH_SELECTED: 'CLEAN_BRANCH_SELECTED',
    CHANGE_ITEM_OPTIONS: 'CHANGE_ITEM_OPTIONS',
    CHANGE_AJAXING: 'CHANGE_AJAXING',
    CHANGE_DETAILS: 'CHANGE_DETAILS',
    CHANGE_SUMMARIES: 'CHANGE_SUMMARIES',
    CHANGE_TOTAL: 'CHANGE_TOTAL',
    INIT_PAYMENT_SHOW: 'INIT_PAYMENT_SHOW',
    INIT_ITEM_TYPES_SHOW: 'INIT_ITEM_TYPES_SHOW',
    INIT_ITEM_SHOW: 'INIT_ITEM_SHOW',
    CHANGE_ITEM_AJAXING: 'CHANGE_ITEM_AJAXING',
    CHANGE_PAYMENT_AJAXING: 'CHANGE_PAYMENT_AJAXING',
    CLEAR_PAYMENT_SELECTED: 'CLEAR_PAYMENT_SELECTED',
    INIT_SALESMEN_SHOW: 'INIT_SALESMEN_SHOW',
    CHANGE_SALESMEN_AJAXING: 'CHANGE_SALESMEN_AJAXING',
    CLEAR_SALESMEN_SELECTED: 'CLEAR_SALESMEN_SELECTED'
};

var state = {
    blockOpenStatus: {
        first: true,
        second: true,
        third: false,
        fourth: false
    },
    dateOptions: {
        startDate: null,
        endDate: null
    },
    filterOptions: {
        studioId: null,
        branchIds: [],
        moneyStatuses: { name: '包含收入及退費', status: 0 },
        selectedPayment: [],
        selectedItem: [],
        selectedSalesmen: [],
        selectedItemType: 'all',
        page: 1,
        perPage: 100
    },
    itemOptions: {
        viewMode: 'detail'
    },
    item_types: [],
    items: [],
    ajaxing: false,
    details: [],
    summaries: [],
    total: [],
    moneyStatusShow: [{ name: '包含收入及退費', status: 0 }, { name: '只顯示收入', status: 1 }, { name: '只顯示退費', status: 2 }],
    payments: [],
    paymentAjaxing: false,
    itemAjaxing: false,
    salesmenAjaxing: false,
    salesmen: []
};

var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, type.CLOSE_ALL_BLOCK, function (state) {
    state.blockOpenStatus.first = false;
    state.blockOpenStatus.second = false;
    state.blockOpenStatus.third = false;
    state.blockOpenStatus.fourth = false;
}), (0, _defineProperty3.default)(_mutations, type.TOGGLE_BLOCK, function (state, payload) {
    state.blockOpenStatus[payload.block] = !state.blockOpenStatus[payload.block];
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_DATE_OPTIONS, function (state, payload) {
    state.dateOptions[payload.prop] = payload.value;
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_FILTER_OPTIONS, function (state, payload) {
    state.filterOptions[payload.prop] = payload.value;
}), (0, _defineProperty3.default)(_mutations, type.CLEAN_BRANCH_SELECTED, function (state) {
    state.filterOptions.branchIds = [];
}), (0, _defineProperty3.default)(_mutations, type.CLEAN_BRANCH_RELATED_SELECTED, function (state) {
    state.filterOptions.serviceIds = [];
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_ITEM_OPTIONS, function (state, payload) {
    state.itemOptions[payload.prop] = payload.value;
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_AJAXING, function (state, payload) {
    state.ajaxing = payload.value;
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_DETAILS, function (state, payload) {
    state.details = payload.value;
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_SUMMARIES, function (state, payload) {
    state.summaries = payload.value;
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_TOTAL, function (state, payload) {
    state.total = payload.value;
}), (0, _defineProperty3.default)(_mutations, type.INIT_PAYMENT_SHOW, function (state, payload) {
    state.payments = payload;
}), (0, _defineProperty3.default)(_mutations, type.INIT_ITEM_TYPES_SHOW, function (state, payload) {
    state.item_types = payload;
}), (0, _defineProperty3.default)(_mutations, type.INIT_ITEM_SHOW, function (state, payload) {
    state.items = payload;
}), (0, _defineProperty3.default)(_mutations, type.CLEAR_PAYMENT_SELECTED, function (state) {
    state.filterOptions.selectedPayment = [];
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_ITEM_AJAXING, function (state, payload) {
    state.itemAjaxing = payload;
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_PAYMENT_AJAXING, function (state, payload) {
    state.paymentAjaxing = payload;
}), (0, _defineProperty3.default)(_mutations, type.INIT_SALESMEN_SHOW, function (state, payload) {
    state.salesmen = payload;
}), (0, _defineProperty3.default)(_mutations, type.CLEAR_SALESMEN_SELECTED, function (state) {
    state.filterOptions.selectedSalesmen = [];
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_SALESMEN_AJAXING, function (state, payload) {
    state.salesmenAjaxing = payload;
}), _mutations);

var api = {
    fetchData: function fetchData() {
        return new _promise2.default(function (resolve) {
            var branchIds = state.filterOptions.branchIds.map(function (elem) {
                return elem.id;
            });
            var paymentMethodIds = state.filterOptions.selectedPayment.map(function (elem) {
                return elem.studio_payment_method_id;
            });
            var itemIds = state.filterOptions.selectedItem.map(function (elem) {
                return elem.id;
            });
            var salesmen = state.filterOptions.selectedSalesmen.map(function (elem) {
                return elem.id;
            });
            var postData = {
                studio_id: state.filterOptions.studioId && state.filterOptions.studioId.hasOwnProperty('id') ? state.filterOptions.studioId.id : 0,
                branch_ids: branchIds,
                start_date: state.dateOptions.startDate,
                end_date: state.dateOptions.endDate,
                payment_method_ids: paymentMethodIds,
                money_status: state.filterOptions.moneyStatuses.status,
                view_mode: state.itemOptions.viewMode,
                item_type: state.filterOptions.selectedItemType,
                items: itemIds,
                salesmen: salesmen,
                per_page: state.filterOptions.perPage,
                order_remark: state.filterOptions.orderRemark
            };
            Vue.http.post('/adminapi/report/fetch_all_order_detail_total_data?page=' + state.filterOptions.page, postData).then(function (_ref) {
                var data = _ref.data;
                return resolve(data.data);
            });
        });
    },
    initPayment: function initPayment() {
        return new _promise2.default(function (resolve) {
            if (!state.filterOptions.studioId || state.filterOptions.studioId.id == "0") {
                return;
            }
            var branchIds = state.filterOptions.branchIds.map(function (elem) {
                return elem.id;
            });
            var postData = {
                params: {
                    branch_ids: branchIds
                }
            };
            Vue.http.get('/adminapi/studio/' + state.filterOptions.studioId.id + '/branches/payments', postData).then(function (response) {
                resolve({ payments: response.data.payments });
            });
        });
    },
    getItemTypes: function getItemTypes() {
        return new _promise2.default(function (resolve) {
            Vue.http.get('/adminapi/studio_branch_resources/item_types').then(function (response) {
                resolve({ item_types: response.data.item_types });
            });
        });
    },
    getItems: function getItems() {
        return new _promise2.default(function (resolve) {
            if (!state.filterOptions.studioId || state.filterOptions.studioId.id === "0" || state.filterOptions.studioId.id === 0) {
                return;
            }
            var branchIds = state.filterOptions.branchIds.map(function (elem) {
                return elem.id;
            });
            var postData = {
                params: {
                    studio_id: state.filterOptions.studioId.id,
                    branch_id: branchIds,
                    item_type: state.filterOptions.selectedItemType
                }
            };
            Vue.http.get('/adminapi/studio_branch_resources/items', postData).then(function (response) {
                resolve({ items: response.data });
            });
        });
    },
    initSalesmen: function initSalesmen() {
        return new _promise2.default(function (resolve) {
            if (!state.filterOptions.studioId || state.filterOptions.studioId.id == "0") {
                return;
            }
            var branchIds = state.filterOptions.branchIds.map(function (elem) {
                return elem.id;
            });
            if (branchIds.length == 0) {
                return;
            }
            var postData = {
                params: {
                    branch_ids: branchIds
                }
            };
            Vue.http.get('/adminapi/salseman/' + state.filterOptions.studioId.id, postData).then(function (response) {
                var existIds = [];
                var members = response.data.list.filter(function (member) {
                    if (existIds.indexOf(member.id) == -1) {
                        existIds.push(member.id);
                        return true;
                    }
                    return false;
                });
                resolve({ members: members });
            });
        });
    }
};

var actions = {
    submit: function submit(_ref2) {
        var commit = _ref2.commit,
            dispatch = _ref2.dispatch;

        if (!state.dateOptions.startDate || state.dateOptions.startDate == 'Invalid date') {
            return $17.formatErrorAlert('日期：請填寫 開始日期');
        }
        if (!state.dateOptions.endDate || state.dateOptions.endDate == 'Invalid date') {
            return $17.formatErrorAlert('日期：請填寫 結束日期');
        }
        if (state.dateOptions.startDate > state.dateOptions.endDate) {
            return $17.formatErrorAlert('日期：開始日期不能大於結束日期');
        }
        // commit(type.CLOSE_ALL_BLOCK) //Disabled close all block when submit form
        dispatch('fetchData');
    },
    toggleBlock: function toggleBlock(_ref3, payload) {
        var commit = _ref3.commit;

        commit(type.TOGGLE_BLOCK, payload);
    },
    changeDateOption: function changeDateOption(_ref4, payload) {
        var commit = _ref4.commit;

        commit(type.CHANGE_DATE_OPTIONS, payload);
    },
    changeFilterOption: function changeFilterOption(_ref5, payload) {
        var commit = _ref5.commit;

        commit(type.CHANGE_FILTER_OPTIONS, payload);
    },
    cleanBranch: function cleanBranch(_ref6) {
        var commit = _ref6.commit;

        commit(type.CLEAN_BRANCH_SELECTED);
    },
    cleanBranchRelated: function cleanBranchRelated(_ref7) {
        var commit = _ref7.commit;

        commit(type.CLEAN_BRANCH_RELATED_SELECTED);
    },
    changeItemOption: function changeItemOption(_ref8, payload) {
        var commit = _ref8.commit;

        commit(type.CHANGE_ITEM_OPTIONS, payload);
    },
    fetchData: function fetchData(_ref9) {
        var commit = _ref9.commit;

        commit(type.CHANGE_AJAXING, {
            value: true
        });
        api.fetchData().then(function (response) {
            commit(type.CHANGE_AJAXING, {
                value: false
            });
            commit(type.CHANGE_DETAILS, {
                value: response.details
            });
            commit(type.CHANGE_SUMMARIES, {
                value: response.summaries
            });
            commit(type.CHANGE_TOTAL, {
                value: response.totals
            });
        });
    },
    setDetailTarget: function setDetailTarget(_ref10, payload) {
        var commit = _ref10.commit;

        commit(type.CHANGE_DETAIL, payload);
    },
    getItems: function getItems(_ref11, payload) {
        var commit = _ref11.commit;

        commit(type.CHANGE_ITEM_AJAXING, true);
        api.getItems().then(function (response) {
            commit(type.INIT_ITEM_SHOW, response.items);
            commit(type.CHANGE_ITEM_AJAXING, false);
        }, function (error) {
            commit(type.CHANGE_ITEM_AJAXING, false);
        });
    },
    getItemTypes: function getItemTypes(_ref12, payload) {
        var commit = _ref12.commit;

        api.getItemTypes().then(function (response) {
            commit(type.INIT_ITEM_TYPES_SHOW, response.item_types);
        }, function (error) {});
    },
    initPayment: function initPayment(_ref13) {
        var commit = _ref13.commit;

        commit(type.CHANGE_PAYMENT_AJAXING, true);
        commit(type.CLEAR_PAYMENT_SELECTED, []);
        commit(type.INIT_PAYMENT_SHOW, []);
        api.initPayment().then(function (response) {
            commit(type.INIT_PAYMENT_SHOW, response.payments);
            commit(type.CHANGE_PAYMENT_AJAXING, false);
        }, function (error) {
            commit(type.CHANGE_PAYMENT_AJAXING, false);
        });
    },
    initSalesmen: function initSalesmen(_ref14) {
        var commit = _ref14.commit;

        commit(type.CHANGE_SALESMEN_AJAXING, true);
        commit(type.CLEAR_SALESMEN_SELECTED, []);
        commit(type.INIT_SALESMEN_SHOW, []);
        api.initSalesmen().then(function (response) {
            commit(type.INIT_SALESMEN_SHOW, response.members);
            commit(type.CHANGE_SALESMEN_AJAXING, false);
        }, function (reason) {
            commit(type.CHANGE_SALESMEN_AJAXING, false);
        });
    }
};

exports.default = {
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations
};

},{"babel-runtime/core-js/promise":59,"babel-runtime/helpers/defineProperty":65}],1606:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mutations;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var type = {
    CLOSE_ALL_BLOCK: 'CLOSE_ALL_BLOCK',
    TOGGLE_BLOCK: 'TOGGLE_BLOCK',
    CHANGE_DATE_OPTIONS: 'CHANGE_DATE_OPTIONS',
    CHANGE_FILTER_OPTIONS: 'CHANGE_FILTER_OPTIONS',
    CHANGE_ITEM_OPTIONS: 'CHANGE_ITEM_OPTIONS',
    CHANGE_AJAXING: 'CHANGE_AJAXING',
    CHANGE_LIST: 'CHANGE_LIST',
    CHANGE_TOTAL: 'CHANGE_TOTAL',
    CLEAN_BRANCH_RELATED_SELECTED: 'CLEAN_BRANCH_RELATED_SELECTED',
    CLEAN_BRANCH_SELECTED: 'CLEAN_BRANCH_SELECTED',
    INIT_CONFRIM_STATUS: 'INIT_CONFRIM_STATUS',
    INIT_STAFF_SHOW: 'INIT_STAFF_SHOW',
    CHANGE_STAFF_AJAXING: 'CHANGE_STAFF_AJAXING',
    CLEAR_STAFF_SELECTED: 'CLEAR_STAFF_SELECTED'
};

var state = {
    blockOpenStatus: {
        first: true,
        second: true,
        third: false,
        fourth: false
    },
    dateOptions: {
        startDate: null,
        endDate: null
    },
    filterOptions: {
        studioId: null,
        branchIds: [],
        allowanceStatuses: [],
        selectedStaff: []
    },
    ajaxing: false,
    list: {},
    invoice_total: 0,
    order_total: 0,
    allowance_total: 0,
    allowanceStatusShow: [{
        name: "未折讓",
        status: 2
    }, {
        name: "已折讓",
        status: 3
    }],
    issueStatus: [],
    staffMembers: [],
    staffAjaxing: false
};

var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, type.CLOSE_ALL_BLOCK, function (state) {
    state.blockOpenStatus.first = false;
    state.blockOpenStatus.second = false;
    state.blockOpenStatus.third = false;
    state.blockOpenStatus.fourth = false;
}), (0, _defineProperty3.default)(_mutations, type.TOGGLE_BLOCK, function (state, payload) {
    state.blockOpenStatus[payload.block] = !state.blockOpenStatus[payload.block];
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_DATE_OPTIONS, function (state, payload) {
    state.dateOptions[payload.prop] = payload.value;
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_FILTER_OPTIONS, function (state, payload) {
    state.filterOptions[payload.prop] = payload.value;
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_AJAXING, function (state, payload) {
    state.ajaxing = payload.value;
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_LIST, function (state, payload) {
    state.list = payload.value;
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_TOTAL, function (state, payload) {
    state.order_total = payload.order_total;
    state.invoice_total = payload.invoice_total;
    state.allowance_total = payload.allowance_total;
}), (0, _defineProperty3.default)(_mutations, type.CLEAN_BRANCH_SELECTED, function (state) {
    state.filterOptions.branchIds = [];
}), (0, _defineProperty3.default)(_mutations, type.CLEAN_BRANCH_RELATED_SELECTED, function (state) {
    state.filterOptions.serviceIds = [];
}), (0, _defineProperty3.default)(_mutations, type.INIT_CONFRIM_STATUS, function (state, payload) {
    state.confirmStatus = payload.status;
}), (0, _defineProperty3.default)(_mutations, type.INIT_STAFF_SHOW, function (state, payload) {
    state.staffMembers = payload;
}), (0, _defineProperty3.default)(_mutations, type.CLEAR_STAFF_SELECTED, function (state) {
    state.filterOptions.selectedStaff = [];
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_STAFF_AJAXING, function (state, payload) {
    state.staffAjaxing = payload;
}), _mutations);

var api = {
    fetchIssueData: function fetchIssueData() {
        return new _promise2.default(function (resolve) {
            var branchIds = state.filterOptions.branchIds.map(function (elem) {
                return elem.id;
            });
            var postData = {
                params: {
                    studio_id: state.filterOptions.studioId.id,
                    branch_ids: branchIds,
                    start_date: state.dateOptions.startDate,
                    end_date: state.dateOptions.endDate
                }
            };
            Vue.http.get('/adminapi/report/fetch_order_invoices', postData).then(function (_ref) {
                var data = _ref.data;
                return resolve(data.data);
            });
        });
    },
    fetchAllowanceData: function fetchAllowanceData() {
        return new _promise2.default(function (resolve) {
            var branchIds = state.filterOptions.branchIds.map(function (elem) {
                return elem.id;
            });
            var allowanceStatuses = state.filterOptions.allowanceStatuses.map(function (elem) {
                return elem.status;
            });
            var checkoutMembers = state.filterOptions.selectedStaff.map(function (elem) {
                return elem.id;
            });
            var postData = {
                params: {
                    studio_id: state.filterOptions.studioId.id,
                    branch_ids: branchIds,
                    start_date: state.dateOptions.startDate,
                    end_date: state.dateOptions.endDate,
                    allowance_statuses: allowanceStatuses,
                    checkout_member_ids: checkoutMembers
                }
            };
            Vue.http.get('/adminapi/report/fetch_refund_order_invoices', postData).then(function (_ref2) {
                var data = _ref2.data;
                return resolve(data.data);
            });
        });
    },
    initStaff: function initStaff() {
        return new _promise2.default(function (resolve) {
            var branchIds = state.filterOptions.branchIds.map(function (elem) {
                return elem.id;
            });
            var postData = {
                params: {
                    branch_ids: branchIds,
                    start_date: state.dateOptions.startDate,
                    end_date: state.dateOptions.endDate
                }
            };
            if (!state.filterOptions.studioId || state.filterOptions.studioId.id == "0") {
                return;
            }
            Vue.http.get('/adminapi/pos/checkout_members/studio/' + state.filterOptions.studioId.id, postData).then(function (_ref3) {
                var data = _ref3.data;
                return resolve({
                    members: data.members
                });
            });
        });
    }
};

var actions = {
    submitIssue: function submitIssue(_ref4) {
        var commit = _ref4.commit,
            dispatch = _ref4.dispatch;

        if (!state.dateOptions.startDate || state.dateOptions.startDate == 'Invalid date') {
            return $17.formatErrorAlert('日期：請填寫 開始日期');
        }
        if (!state.dateOptions.endDate || state.dateOptions.endDate == 'Invalid date') {
            return $17.formatErrorAlert('日期：請填寫 結束日期');
        }
        if (state.dateOptions.startDate > state.dateOptions.endDate) {
            return $17.formatErrorAlert('日期：開始日期不能大於結束日期');
        }
        // commit(type.CLOSE_ALL_BLOCK); //Disabled close all block when submit form
        dispatch('fetchIssueData');
    },
    submitAllowance: function submitAllowance(_ref5) {
        var commit = _ref5.commit,
            dispatch = _ref5.dispatch;

        if (!state.dateOptions.startDate || state.dateOptions.startDate == 'Invalid date') {
            return $17.formatErrorAlert('日期：請填寫 開始日期');
        }
        if (!state.dateOptions.endDate || state.dateOptions.endDate == 'Invalid date') {
            return $17.formatErrorAlert('日期：請填寫 結束日期');
        }
        if (state.dateOptions.startDate > state.dateOptions.endDate) {
            return $17.formatErrorAlert('日期：開始日期不能大於結束日期');
        }
        // commit(type.CLOSE_ALL_BLOCK); //Disabled close all block when submit form
        dispatch('fetchAllowanceData');
    },
    toggleBlock: function toggleBlock(_ref6, payload) {
        var commit = _ref6.commit;

        commit(type.TOGGLE_BLOCK, payload);
    },
    changeDateOption: function changeDateOption(_ref7, payload) {
        var commit = _ref7.commit;

        commit(type.CHANGE_DATE_OPTIONS, payload);
    },
    changeFilterOption: function changeFilterOption(_ref8, payload) {
        var commit = _ref8.commit;

        commit(type.CHANGE_FILTER_OPTIONS, payload);
    },
    cleanBranch: function cleanBranch(_ref9) {
        var commit = _ref9.commit;

        commit(type.CLEAN_BRANCH_SELECTED);
    },
    cleanBranchRelated: function cleanBranchRelated(_ref10) {
        var commit = _ref10.commit;

        commit(type.CLEAN_BRANCH_RELATED_SELECTED);
    },
    fetchIssueData: function fetchIssueData(_ref11) {
        var commit = _ref11.commit;

        commit(type.CHANGE_AJAXING, {
            value: true
        });
        api.fetchIssueData().then(function (response) {
            commit(type.CHANGE_AJAXING, {
                value: false
            });
            commit(type.CHANGE_LIST, {
                value: response.list
            });
            commit(type.CHANGE_TOTAL, {
                invoice_total: response.invoice_total,
                order_total: response.order_total
            });
        });
    },
    fetchAllowanceData: function fetchAllowanceData(_ref12) {
        var commit = _ref12.commit;

        commit(type.CHANGE_AJAXING, {
            value: true
        });
        api.fetchAllowanceData().then(function (response) {
            commit(type.CHANGE_AJAXING, {
                value: false
            });
            commit(type.CHANGE_LIST, {
                value: response.list
            });
            commit(type.CHANGE_TOTAL, {
                allowance_total: response.allowance_total,
                order_total: response.order_total
            });
        });
    },
    setDetailTarget: function setDetailTarget(_ref13, payload) {
        var commit = _ref13.commit;

        commit(type.CHANGE_DETAIL, payload);
    },
    initStaff: function initStaff(_ref14) {
        var commit = _ref14.commit;

        commit(type.CHANGE_STAFF_AJAXING, true);
        commit(type.CLEAR_STAFF_SELECTED, []);
        commit(type.INIT_STAFF_SHOW, []);
        api.initStaff().then(function (response) {
            commit(type.INIT_CONFRIM_STATUS, response);

            commit(type.INIT_STAFF_SHOW, response.members);
            commit(type.CHANGE_STAFF_AJAXING, false);
        }, function (reason) {
            commit(type.CHANGE_STAFF_AJAXING, false);
        });
    }
};

exports.default = {
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations
};

},{"babel-runtime/core-js/promise":59,"babel-runtime/helpers/defineProperty":65}],1607:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mutations;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var type = {
	CLOSE_ALL_BLOCK: 'CLOSE_ALL_BLOCK',
	TOGGLE_BLOCK: 'TOGGLE_BLOCK',
	CHANGE_DATE_OPTIONS: 'CHANGE_DATE_OPTIONS',
	CHANGE_FILTER_OPTIONS: 'CHANGE_FILTER_OPTIONS',
	CHANGE_ITEM_OPTIONS: 'CHANGE_ITEM_OPTIONS',
	CHANGE_AJAXING: 'CHANGE_AJAXING',
	CHANGE_RECORDS: 'CHANGE_RECORDS',
	CHANGE_DETAIL: 'CHANGE_DETAIL'
};

var state = {
	blockOpenStatus: {
		first: true,
		second: true,
		third: false,
		fourth: false
	},
	dateOptions: {
		startDate: null,
		endDate: null
	},
	filterOptions: {
		studioId: null,
		branchId: null
	},
	itemOptions: {
		absence: false
	},
	ajaxing: false,
	records: [],
	detail: null
};

var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, type.CLOSE_ALL_BLOCK, function (state) {
	state.blockOpenStatus.first = false;
	state.blockOpenStatus.second = false;
	state.blockOpenStatus.third = false;
	state.blockOpenStatus.fourth = false;
}), (0, _defineProperty3.default)(_mutations, type.TOGGLE_BLOCK, function (state, payload) {
	state.blockOpenStatus[payload.block] = !state.blockOpenStatus[payload.block];
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_DATE_OPTIONS, function (state, payload) {
	state.dateOptions[payload.prop] = payload.value;
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_FILTER_OPTIONS, function (state, payload) {
	state.filterOptions[payload.prop] = payload.value;
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_ITEM_OPTIONS, function (state, payload) {
	state.itemOptions[payload.prop] = payload.value;
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_AJAXING, function (state, payload) {
	state.ajaxing = payload.value;
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_RECORDS, function (state, payload) {
	state.records = payload.records;
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_DETAIL, function (state, payload) {
	state.detail = payload.detail;
}), _mutations);

var api = {
	fetchData: function fetchData() {
		return new _promise2.default(function (resolve) {
			var postData = {
				studio_id: state.filterOptions.studioId,
				branch_id: state.filterOptions.branchId,
				start_date: state.dateOptions.startDate,
				end_date: state.dateOptions.endDate,
				absence: state.itemOptions.absence ? 1 : 0
			};
			Vue.http.post('/adminapi/fetch_payroll_statistics_data', postData).then(function (_ref) {
				var data = _ref.data;
				return resolve(data.data);
			});
		});
	}
};

var actions = {
	submit: function submit(_ref2) {
		var commit = _ref2.commit,
		    dispatch = _ref2.dispatch;

		if (!state.dateOptions.startDate || state.dateOptions.startDate == 'Invalid date') {
			return $17.formatErrorAlert('日期：請填寫 開始日期');
		}
		if (!state.dateOptions.endDate || state.dateOptions.endDate == 'Invalid date') {
			return $17.formatErrorAlert('日期：請填寫 結束日期');
		}
		if (state.dateOptions.startDate > state.dateOptions.endDate) {
			return $17.formatErrorAlert('日期：開始日期不能大於結束日期');
		}
		if (!state.filterOptions.branchId) {
			return $17.formatErrorAlert('篩選：場館不能為空白');
		}
		// commit(type.CLOSE_ALL_BLOCK) //Disabled close all block when submit form
		dispatch('fetchData');
	},
	toggleBlock: function toggleBlock(_ref3, payload) {
		var commit = _ref3.commit;

		commit(type.TOGGLE_BLOCK, payload);
	},
	changeDateOption: function changeDateOption(_ref4, payload) {
		var commit = _ref4.commit;

		commit(type.CHANGE_DATE_OPTIONS, payload);
	},
	changeFilterOption: function changeFilterOption(_ref5, payload) {
		var commit = _ref5.commit;

		commit(type.CHANGE_FILTER_OPTIONS, payload);
	},
	changeItemOption: function changeItemOption(_ref6, payload) {
		var commit = _ref6.commit;

		commit(type.CHANGE_ITEM_OPTIONS, payload);
	},
	fetchData: function fetchData(_ref7) {
		var commit = _ref7.commit;

		commit(type.CHANGE_AJAXING, {
			value: true
		});
		api.fetchData().then(function (response) {
			commit(type.CHANGE_AJAXING, {
				value: false
			});
			commit(type.CHANGE_RECORDS, {
				records: response
			});
		});
	},
	setDetailTarget: function setDetailTarget(_ref8, payload) {
		var commit = _ref8.commit;

		commit(type.CHANGE_DETAIL, payload);
	}
};

exports.default = {
	namespaced: true,
	state: state,
	actions: actions,
	mutations: mutations
};

},{"babel-runtime/core-js/promise":59,"babel-runtime/helpers/defineProperty":65}],1608:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _objectDestructuringEmpty2 = require("babel-runtime/helpers/objectDestructuringEmpty");

var _objectDestructuringEmpty3 = _interopRequireDefault(_objectDestructuringEmpty2);

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getters, _mutations;

var _agentAdapter = require("./agent-adapter");

var _agentAdapter2 = _interopRequireDefault(_agentAdapter);

var _axios = require("axios");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var client = null;
var types = {
    FETCH_PRINT_SETTINGS: 'FETCH_PRINT_SETTINGS',
    FETCH_ONE_PRINT_SETTING: 'FETCH_ONE_PRINT_SETTING',
    UPDATE_FORM_INPUT: 'UPDATE_FORM_INPUT',
    RESET_FORM_DATA: 'RESET_FORM_DATA',
    TRUN_AJAXING_SETTING_ON: 'TRUN_AJAXING_SETTING_ON',
    PRINT_INVOICE_DATA: 'PRINT_INVOICE_DATA',
    EPSON_PRINT_DATA: 'EPSON_PRINT_DATA',
    EPSON_PRINT_DATA_DETAIL: 'EPSON_PRINT_DATA_DETAIL',
    PRINT_TICKET_DATA: 'PRINT_TICKET_DATA',
    CHANGE_PRINT_STATUS: 'CHANGE_PRINT_STATUS',
    PRINT_MEMBERCONTRACT_DATA: 'PRINT_MEMBERCONTRACT_DATA',
    PRINT_ALL_TICKET_DATA: 'PRINT_ALL_TICKET_DATA',
    PRINTER_AGENT: 'PRINTER_AGENT',
    WEB_LOCAL_SETTING_ID: 'WEB_LOCAL_SETTING_ID',
    IN_USE_PRINTER: 'IN_USE_PRINTER'
};

var state = {
    settings: [],
    ajaxingSettings: true,
    data: {
        id: null,
        device_name: '',
        device_ip: ''
    },
    print_invoice_data: {},
    print_ticket_data: {},
    print_all_ticket_data: {},
    print_member_contract_data: {},
    printing: false,
    printer_agent: 'iot_kit',
    local_print_setting: {},
    in_use_printer: {
        id: 0,
        device_ip: '',
        device_name: ''
    }
};

var getters = (_getters = {}, (0, _defineProperty3.default)(_getters, types.EPSON_PRINT_DATA, function (state, getters, rootState) {
    return {
        "lang": "zh-tw", //語系
        "sellerTitle": state.print_invoice_data.showTitle,
        "invoiceWord": state.print_invoice_data.invoiceWord,
        "invoicePeriod": state.print_invoice_data.periodNumber,
        "invoiceNumber": state.print_invoice_data.invoiceNumber,
        "invoiceDateTime": state.print_invoice_data.invoiceTime,
        "randomNumber": state.print_invoice_data.randomNumber,
        "salesAmount": state.print_invoice_data.taxTotal,
        "taxAmount": state.print_invoice_data.tax,
        "totalAmount": state.print_invoice_data.total,
        "sellerIdentifier": state.print_invoice_data.salerUbn,
        "buyerIdentifier": state.print_invoice_data.buyerUbn,
        "barCodeContent": state.print_invoice_data.barcode,
        "qrCodeContentOne": state.print_invoice_data.qrcode_l,
        "qrCodeContentTwo": state.print_invoice_data.qrcode_r,
        "remark": state.print_invoice_data.remark,
        "taxType": "TX",
        "buyerName": state.print_invoice_data.memberName,
        "buyerOrderId": state.print_invoice_data.orderId,
        "detail": getters.EPSON_PRINT_DATA_DETAIL
    };
}), (0, _defineProperty3.default)(_getters, types.EPSON_PRINT_DATA_DETAIL, function (getters) {
    if (!state.print_invoice_data.details) {
        return [];
    }
    return state.print_invoice_data.details.reduce(function (carry, detail, index) {
        if (index == 0) {
            return carry;
        }
        carry.push([detail.name, detail.count, detail.price, detail.amount]);
        return carry;
    }, []);
}), _getters);

var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.FETCH_PRINT_SETTINGS, function (state, payload) {
    state.settings = payload;
    state.ajaxingSettings = false;
}), (0, _defineProperty3.default)(_mutations, types.FETCH_ONE_PRINT_SETTING, function (state, payload) {
    state.data = payload;
}), (0, _defineProperty3.default)(_mutations, types.UPDATE_FORM_INPUT, function (state, payload) {
    for (var key in payload) {
        state.data[key] = payload[key];
    }
}), (0, _defineProperty3.default)(_mutations, types.RESET_FORM_DATA, function (state) {
    state.data = {
        device_name: '',
        device_ip: ''
    };
}), (0, _defineProperty3.default)(_mutations, types.TRUN_AJAXING_SETTING_ON, function (state, payload) {
    state.ajaxingSettings = true;
}), (0, _defineProperty3.default)(_mutations, types.PRINT_INVOICE_DATA, function (state, payload) {
    state.print_invoice_data = payload;
}), (0, _defineProperty3.default)(_mutations, types.PRINT_TICKET_DATA, function (state, payload) {
    state.print_ticket_data = payload;
}), (0, _defineProperty3.default)(_mutations, types.PRINT_ALL_TICKET_DATA, function (state, payload) {
    state.print_all_ticket_data = payload;
}), (0, _defineProperty3.default)(_mutations, types.CHANGE_PRINT_STATUS, function (state, status) {
    state.printing = status;
}), (0, _defineProperty3.default)(_mutations, types.PRINT_MEMBERCONTRACT_DATA, function (state, payload) {
    state.print_member_contract_data = payload;
}), (0, _defineProperty3.default)(_mutations, types.PRINTER_AGENT, function (state, payload) {
    state.printer_agent = payload;
}), (0, _defineProperty3.default)(_mutations, types.IN_USE_PRINTER, function (state, payload) {
    state.in_use_printer = payload || {};
}), _mutations);

var api = {
    fetchPrintSettings: function fetchPrintSettings(branchId) {
        return new _promise2.default(function (resolve) {
            Vue.http.get('/adminapi/print_device?' + $.param({ branch_id: branchId })).then(function (response) {
                return resolve({
                    settings: response.body
                });
            });
        });
    },
    fetchPrintSettingsNoneHttps: function fetchPrintSettingsNoneHttps(branchId) {
        return new _promise2.default(function (resolve) {
            Vue.http.get('/simple/adminapi/print_device?' + $.param({ branch_id: branchId })).then(function (response) {
                return resolve({
                    settings: response.body
                });
            });
        });
    },
    fetchAllPrintSettings: function fetchAllPrintSettings(studioId) {
        return new _promise2.default(function (resolve) {
            Vue.http.get('/adminapi/print_device?' + $.param({ studio_id: studioId })).then(function (response) {
                return resolve({
                    settings: response.body
                });
            });
        });
    },
    fetchOne: function fetchOne(obj) {
        return new _promise2.default(function (resolve) {
            Vue.http.get('/adminapi/print_device/' + obj.id).then(function (response) {
                return resolve({
                    printDevice: response.body
                });
            });
        });
    },
    create: function create(formData) {
        return new _promise2.default(function (resolve) {
            Vue.http.post('/adminapi/print_device', formData).then(function (response) {
                return resolve({});
            }).catch($17.responseErrorMessage);
        });
    },
    update: function update(id, formData) {
        return new _promise2.default(function (resolve) {
            Vue.http.patch('/adminapi/print_device/' + id, formData).then(function (response) {
                return resolve({});
            }).catch($17.responseErrorMessage);
        });
    },
    delete: function _delete(id) {
        return new _promise2.default(function (resolve, reject) {
            Vue.http.delete('/adminapi/print_device/' + id).then(function (response) {
                return resolve(response);
            }).catch(function (error) {
                return reject(error);
            });
        });
    },
    fetchTicketData: function fetchTicketData(ticketNumber) {
        return new _promise2.default(function (resolve) {
            Vue.http.get("/adminapi/ticket/" + ticketNumber + "/print/printEpson").then(function (_ref) {
                var data = _ref.data;
                return resolve({ ticket: data.ticket });
            });
        });
    },
    fetchMemberConteactData: function fetchMemberConteactData(memberContractId, memberId) {
        return new _promise2.default(function (resolve) {
            Vue.http.get("/adminapi/member-contract/" + memberContractId + "/member/" + memberId + "/print/printEpson").then(function (_ref2) {
                var data = _ref2.data;
                return resolve({ memberContract: data.memberContract });
            });
        });
    },
    fetchAllTicketData: function fetchAllTicketData(orderDetailId) {
        return new _promise2.default(function (resolve) {
            Vue.http.get("/adminapi/ticket/order_detail/" + orderDetailId + "/print/printEpson").then(function (_ref3) {
                var data = _ref3.data;
                return resolve({ tickets: data.tickets });
            });
        });
    },
    fetchDiscountNoteData: function fetchDiscountNoteData(orderId) {
        return new _promise2.default(function (resolve) {
            // http: //localhost:8000/adminapi/invoice/order/17112470bf/print/discount-note/printEpson
            Vue.http.get("/adminapi/invoice/order/" + orderId + "/print/discount-note/printEpson").then(function (_ref4) {
                var data = _ref4.data;
                return resolve({ discountNote: data.discountNote });
            });
        });
    },
    fetchOrderData: function fetchOrderData(orderId) {
        return new _promise2.default(function (resolve) {
            Vue.http.get("/adminapi/order/" + orderId + "/print/printEpson").then(function (_ref5) {
                var data = _ref5.data;
                return resolve({ order: data.order });
            });
        });
    }
};

var actions = {
    setInUsePrinter: function setInUsePrinter(_ref6, printer) {
        var commit = _ref6.commit;

        commit('IN_USE_PRINTER', printer);
    },
    fetchPrintSettings: function fetchPrintSettings(_ref7, branchId) {
        var _this = this;

        var commit = _ref7.commit;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            var response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return api.fetchPrintSettings(branchId).then(function (response) {
                                commit('TRUN_AJAXING_SETTING_ON');
                                commit('FETCH_PRINT_SETTINGS', response.settings);
                            });

                        case 2:
                            response = _context.sent;

                        case 3:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },
    fetchPrintSettingsNoneHttps: function fetchPrintSettingsNoneHttps(_ref8, branchId) {
        var _this2 = this;

        var commit = _ref8.commit;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
            var response;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return api.fetchPrintSettingsNoneHttps(branchId).then(function (response) {
                                commit('TRUN_AJAXING_SETTING_ON');
                                commit('FETCH_PRINT_SETTINGS', response.settings);
                            });

                        case 2:
                            response = _context2.sent;

                        case 3:
                        case "end":
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }))();
    },
    fetchAllPrintSettings: function fetchAllPrintSettings(_ref9, studioId) {
        var _this3 = this;

        var commit = _ref9.commit;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
            var response;
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.next = 2;
                            return api.fetchAllPrintSettings(studioId).then(function (response) {
                                commit('TRUN_AJAXING_SETTING_ON');
                                commit('FETCH_PRINT_SETTINGS', response.settings);
                            });

                        case 2:
                            response = _context3.sent;

                        case 3:
                        case "end":
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3);
        }))();
    },
    fetchOne: function fetchOne(_ref10, branchId) {
        var _this4 = this;

        var commit = _ref10.commit;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            _context4.next = 2;
                            return api.fetchOne(branchId).then(function (response) {
                                commit('FETCH_ONE_PRINT_SETTING', response.printDevice);
                            });

                        case 2:
                        case "end":
                            return _context4.stop();
                    }
                }
            }, _callee4, _this4);
        }))();
    },
    create: function create(_ref11, payload) {
        var _this5 = this;

        var commit = _ref11.commit;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5() {
            return _regenerator2.default.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            return _context5.abrupt("return", api.create(payload));

                        case 1:
                        case "end":
                            return _context5.stop();
                    }
                }
            }, _callee5, _this5);
        }))();
    },
    update: function update(_ref12, payload) {
        var _this6 = this;

        var commit = _ref12.commit;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6() {
            return _regenerator2.default.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            return _context6.abrupt("return", api.update(payload.id, payload.data));

                        case 1:
                        case "end":
                            return _context6.stop();
                    }
                }
            }, _callee6, _this6);
        }))();
    },
    delete: function _delete(_ref13, payload) {
        var _this7 = this;

        var commit = _ref13.commit;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7() {
            return _regenerator2.default.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            return _context7.abrupt("return", api.delete(payload.id));

                        case 1:
                        case "end":
                            return _context7.stop();
                    }
                }
            }, _callee7, _this7);
        }))();
    },

    // setDefaultPrinter({ commit }, payload) {
    //     Cookies.set('defaultPrinter', payload.ip);
    // },
    // getDefaultPrinter({ commit }, payload) {
    //     return Cookies.get('defaultPrinter');
    // },
    outputInvoice: function outputInvoice(_ref14, orderId) {
        (0, _objectDestructuringEmpty3.default)(_ref14);

        window.open(window.location.origin + "/adminapi/invoice/order/" + orderId + "/print/pdf", '_blank');
    },
    outputMembercontract: function outputMembercontract(_ref15, option) {
        (0, _objectDestructuringEmpty3.default)(_ref15);

        window.open(window.location.origin + "/adminapi/member-contract/" + option.memberContractId + "/member/" + option.memberId + "/print/pdf", '_blank');
    },
    outputTicket: function outputTicket(_ref16, ticketNumber) {
        (0, _objectDestructuringEmpty3.default)(_ref16);

        window.open(window.location.origin + "/adminapi/ticket/" + ticketNumber + "/print/pdf", '_blank');
    },
    outputAllTicket: function outputAllTicket(_ref17, orderDetailId) {
        (0, _objectDestructuringEmpty3.default)(_ref17);

        window.open(window.location.origin + "/adminapi/ticket/order_detail/" + orderDetailId + "/print/pdf", '_blank');
    },
    printerAgent: function printerAgent(_ref18, agent) {
        var commit = _ref18.commit;

        commit('PRINTER_AGENT', agent);
        var isIotKitMode = agent === 'iot_kit' ? true : false;
        if (isIotKitMode) {
            client = _agentAdapter2.default.on(printer);
        } else {
            client = printer;
        }
    },
    printInvoice: function printInvoice(_ref19, orderId) {
        var _this8 = this;

        var dispatch = _ref19.dispatch,
            state = _ref19.state,
            commit = _ref19.commit,
            getters = _ref19.getters;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8() {
            var status, data;
            return _regenerator2.default.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            _context8.next = 2;
                            return dispatch('checkDefaultPrinter');

                        case 2:
                            status = _context8.sent;

                            if (!status) {
                                _context8.next = 14;
                                break;
                            }

                            _context8.next = 6;
                            return dispatch('webadmin/invoice/fetchInvoiceData', { 'orderId': orderId }, { root: true });

                        case 6:
                            data = _context8.sent;

                            commit('PRINT_INVOICE_DATA', data);

                            client.init(state.in_use_printer.device_ip, 'local_printer');
                            client.setOptionByPrintDetail();
                            client.setInvoice(getters.EPSON_PRINT_DATA);
                            client.print();
                            client.realPrint();
                            return _context8.abrupt("return");

                        case 14:
                        case "end":
                            return _context8.stop();
                    }
                }
            }, _callee8, _this8);
        }))();
    },
    checkDefaultPrinter: function checkDefaultPrinter(_ref20) {
        var _this9 = this;

        var dispatch = _ref20.dispatch,
            state = _ref20.state;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee9() {
            return _regenerator2.default.wrap(function _callee9$(_context9) {
                while (1) {
                    switch (_context9.prev = _context9.next) {
                        case 0:
                            _context9.next = 2;
                            return dispatch('printerAgent', state.printer_agent);

                        case 2:
                            if (state.in_use_printer.device_ip) {
                                _context9.next = 4;
                                break;
                            }

                            return _context9.abrupt("return", false);

                        case 4:
                            return _context9.abrupt("return", true);

                        case 5:
                        case "end":
                            return _context9.stop();
                    }
                }
            }, _callee9, _this9);
        }))();
    },

    // async defaultPrinter({ rootState }) {
    //     let ip = Cookies.get('defaultPrinter');
    //     let ips = state.settings.map(function(it) {
    //         return it.device_ip;
    //     });
    //     if (ips.indexOf(ip) === -1) {
    //         Cookies.remove('defaultPrinter');
    //         return false;
    //     }

    //     return ip;
    // },
    fetchTicketData: function fetchTicketData(_ref21, payload) {
        var _this10 = this;

        var commit = _ref21.commit;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee10() {
            return _regenerator2.default.wrap(function _callee10$(_context10) {
                while (1) {
                    switch (_context10.prev = _context10.next) {
                        case 0:
                            _context10.next = 2;
                            return api.fetchTicketData(payload.ticketNumber).then(function (response) {
                                commit(types.PRINT_TICKET_DATA, response.ticket);
                            });

                        case 2:
                            return _context10.abrupt("return", state.print_ticket_data);

                        case 3:
                        case "end":
                            return _context10.stop();
                    }
                }
            }, _callee10, _this10);
        }))();
    },
    fetchAllTicketData: function fetchAllTicketData(_ref22, payload) {
        var _this11 = this;

        var commit = _ref22.commit;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee11() {
            return _regenerator2.default.wrap(function _callee11$(_context11) {
                while (1) {
                    switch (_context11.prev = _context11.next) {
                        case 0:
                            _context11.next = 2;
                            return api.fetchAllTicketData(payload.orderDetailId).then(function (response) {
                                return response.tickets;
                            });

                        case 2:
                            return _context11.abrupt("return", _context11.sent);

                        case 3:
                        case "end":
                            return _context11.stop();
                    }
                }
            }, _callee11, _this11);
        }))();
    },
    printTicket: function printTicket(_ref23, ticketNumber) {
        var _this12 = this;

        var dispatch = _ref23.dispatch,
            rootState = _ref23.rootState,
            rootDispatch = _ref23.rootDispatch,
            commit = _ref23.commit,
            getters = _ref23.getters,
            state = _ref23.state;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee12() {
            var status;
            return _regenerator2.default.wrap(function _callee12$(_context12) {
                while (1) {
                    switch (_context12.prev = _context12.next) {
                        case 0:
                            _context12.next = 2;
                            return dispatch('checkDefaultPrinter');

                        case 2:
                            status = _context12.sent;

                            if (!status) {
                                _context12.next = 11;
                                break;
                            }

                            _context12.next = 6;
                            return dispatch('fetchTicketData', { 'ticketNumber': ticketNumber });

                        case 6:

                            client.init(state.in_use_printer.device_ip, 'local_printer');
                            client.setTicket(state.print_ticket_data);
                            client.printTicket();
                            client.realPrint();
                            return _context12.abrupt("return");

                        case 11:
                        case "end":
                            return _context12.stop();
                    }
                }
            }, _callee12, _this12);
        }))();
    },
    printAllTicket: function printAllTicket(_ref24, orderDetailId) {
        var _this13 = this;

        var dispatch = _ref24.dispatch,
            rootState = _ref24.rootState,
            rootDispatch = _ref24.rootDispatch,
            commit = _ref24.commit,
            getters = _ref24.getters,
            state = _ref24.state;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee13() {
            var status, allTicketData;
            return _regenerator2.default.wrap(function _callee13$(_context13) {
                while (1) {
                    switch (_context13.prev = _context13.next) {
                        case 0:
                            _context13.next = 2;
                            return dispatch('checkDefaultPrinter');

                        case 2:
                            status = _context13.sent;

                            if (!status) {
                                _context13.next = 11;
                                break;
                            }

                            _context13.next = 6;
                            return dispatch('fetchAllTicketData', { 'orderDetailId': orderDetailId });

                        case 6:
                            allTicketData = _context13.sent;

                            actions.setWebLog('確認全部票卷初始要列印資料無異常', (0, _stringify2.default)(allTicketData));
                            client.init(state.in_use_printer.device_ip, 'local_printer');
                            actions.printManyTicket(allTicketData);
                            return _context13.abrupt("return");

                        case 11:
                        case "end":
                            return _context13.stop();
                    }
                }
            }, _callee13, _this13);
        }))();
    },
    fetchMemberConteactData: function fetchMemberConteactData(_ref25, payload) {
        var _this14 = this;

        var commit = _ref25.commit;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee14() {
            return _regenerator2.default.wrap(function _callee14$(_context14) {
                while (1) {
                    switch (_context14.prev = _context14.next) {
                        case 0:
                            _context14.next = 2;
                            return api.fetchMemberConteactData(payload.memberContractId, payload.memberId).then(function (response) {
                                commit(types.PRINT_MEMBERCONTRACT_DATA, response.memberContract);
                            });

                        case 2:
                            return _context14.abrupt("return", state.print_member_contract_data);

                        case 3:
                        case "end":
                            return _context14.stop();
                    }
                }
            }, _callee14, _this14);
        }))();
    },
    printMembercontract: function printMembercontract(_ref26, option) {
        var _this15 = this;

        var dispatch = _ref26.dispatch,
            rootState = _ref26.rootState,
            rootDispatch = _ref26.rootDispatch,
            commit = _ref26.commit,
            getters = _ref26.getters,
            state = _ref26.state;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee15() {
            var status;
            return _regenerator2.default.wrap(function _callee15$(_context15) {
                while (1) {
                    switch (_context15.prev = _context15.next) {
                        case 0:
                            _context15.next = 2;
                            return dispatch('checkDefaultPrinter');

                        case 2:
                            status = _context15.sent;

                            if (!status) {
                                _context15.next = 12;
                                break;
                            }

                            _context15.next = 6;
                            return dispatch('fetchMemberConteactData', { 'memberContractId': option.memberContractId, 'memberId': option.memberId });

                        case 6:
                            actions.setWebLog('確認方案初始要列印資料無異常', (0, _stringify2.default)(option));
                            client.init(state.in_use_printer.device_ip, 'local_printer');
                            client.setMemberContract(state.print_member_contract_data);
                            client.printMemberContract();
                            client.realPrint();
                            return _context15.abrupt("return");

                        case 12:
                        case "end":
                            return _context15.stop();
                    }
                }
            }, _callee15, _this15);
        }))();
    },
    fetchOrderData: function fetchOrderData(_ref27, payload) {
        var _this16 = this;

        var commit = _ref27.commit;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee16() {
            return _regenerator2.default.wrap(function _callee16$(_context16) {
                while (1) {
                    switch (_context16.prev = _context16.next) {
                        case 0:
                            _context16.next = 2;
                            return api.fetchOrderData(payload.orderId).then(function (response) {
                                return response.order;
                            });

                        case 2:
                            return _context16.abrupt("return", _context16.sent);

                        case 3:
                        case "end":
                            return _context16.stop();
                    }
                }
            }, _callee16, _this16);
        }))();
    },
    printOrder: function printOrder(_ref28, option) {
        var _this17 = this;

        var dispatch = _ref28.dispatch,
            rootState = _ref28.rootState,
            rootDispatch = _ref28.rootDispatch,
            commit = _ref28.commit,
            getters = _ref28.getters,
            state = _ref28.state;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee17() {
            var status, order, allTicket;
            return _regenerator2.default.wrap(function _callee17$(_context17) {
                while (1) {
                    switch (_context17.prev = _context17.next) {
                        case 0:
                            _context17.next = 2;
                            return dispatch('checkDefaultPrinter');

                        case 2:
                            status = _context17.sent;

                            if (!status) {
                                _context17.next = 17;
                                break;
                            }

                            _context17.next = 6;
                            return dispatch('fetchOrderData', { 'orderId': option.orderId });

                        case 6:
                            order = _context17.sent;

                            actions.setWebLog('確認訂單初始要列印資料無異常', (0, _stringify2.default)(order));

                            if (!(order.length === 0)) {
                                _context17.next = 10;
                                break;
                            }

                            return _context17.abrupt("return");

                        case 10:
                            client.init(state.in_use_printer.device_ip, 'local_printer');
                            client.setBuyerOrderId(option.orderId);

                            if (typeof order.invoice !== 'undefined') {
                                commit('PRINT_INVOICE_DATA', order.invoice);
                                client.setOptionByPrintDetail();
                                client.setInvoice(getters.EPSON_PRINT_DATA);
                                client.print();
                            }
                            if (typeof order.member_contracts !== 'undefined') {
                                order.member_contracts.map(function (print_data) {
                                    client.setMemberContract(print_data);
                                    client.printMemberContract();
                                });
                            }
                            _context17.next = 16;
                            return client.realPrint();

                        case 16:

                            if (typeof order.ticket !== 'undefined') {
                                allTicket = [];

                                order.ticket.map(function (tickets) {
                                    allTicket = allTicket.concat(tickets);
                                });

                                actions.printManyTicket(allTicket);
                            }

                        case 17:
                        case "end":
                            return _context17.stop();
                    }
                }
            }, _callee17, _this17);
        }))();
    },
    directPrintOrder: function directPrintOrder(_ref29, printerData) {
        var _this18 = this;

        var dispatch = _ref29.dispatch,
            rootState = _ref29.rootState,
            rootDispatch = _ref29.rootDispatch,
            commit = _ref29.commit,
            getters = _ref29.getters,
            state = _ref29.state;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee18() {
            var status, order;
            return _regenerator2.default.wrap(function _callee18$(_context18) {
                while (1) {
                    switch (_context18.prev = _context18.next) {
                        case 0:
                            _context18.next = 2;
                            return dispatch('checkDefaultPrinter');

                        case 2:
                            status = _context18.sent;

                            client.init(state.in_use_printer.device_ip, 'local_printer');
                            order = printerData.order;


                            if (typeof order.invoice !== 'undefined') {
                                commit('PRINT_INVOICE_DATA', order.invoice);
                                client.setOptionByPrintDetail();
                                client.setInvoice(getters.EPSON_PRINT_DATA);
                                client.print();
                            }
                            if (typeof order.member_contracts !== 'undefined') {
                                order.member_contracts.map(function (print_data) {
                                    client.setMemberContract(print_data);
                                    client.printMemberContract();
                                });
                            }

                            if (typeof order.ticket !== 'undefined') {
                                order.ticket.map(function (tickets) {
                                    tickets.map(function (ticket) {
                                        client.setTicket(ticket);
                                        client.printTicket();
                                    });
                                });
                            }

                            _context18.next = 10;
                            return client.realPrint();

                        case 10:
                            return _context18.abrupt("return", _context18.sent);

                        case 11:
                        case "end":
                            return _context18.stop();
                    }
                }
            }, _callee18, _this18);
        }))();
    },
    outputDiscountNote: function outputDiscountNote(_ref30, orderId) {
        var dispatch = _ref30.dispatch,
            commit = _ref30.commit,
            rootState = _ref30.rootState;

        window.open(window.location.origin + "/adminapi/invoice/order/" + orderId + "/print/discount-note/pdf", '_blank');
    },
    printDiscountNote: function printDiscountNote(_ref31, orderId) {
        var _this19 = this;

        var dispatch = _ref31.dispatch,
            commit = _ref31.commit,
            getters = _ref31.getters,
            state = _ref31.state;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee19() {
            var status, print_data;
            return _regenerator2.default.wrap(function _callee19$(_context19) {
                while (1) {
                    switch (_context19.prev = _context19.next) {
                        case 0:
                            _context19.next = 2;
                            return dispatch('checkDefaultPrinter');

                        case 2:
                            status = _context19.sent;

                            if (!status) {
                                _context19.next = 13;
                                break;
                            }

                            _context19.next = 6;
                            return api.fetchDiscountNoteData(orderId);

                        case 6:
                            print_data = _context19.sent;

                            // print_data.discountNote.detail.shift();
                            client.init(state.in_use_printer.device_ip, 'local_printer');
                            client.setBuyerOrderId(orderId);
                            client.setCreditInvoice(print_data.discountNote);
                            client.printCreditInvoice();
                            client.realPrint();
                            return _context19.abrupt("return");

                        case 13:
                        case "end":
                            return _context19.stop();
                    }
                }
            }, _callee19, _this19);
        }))();
    },
    openString: function openString() {
        return 'width=700px,height=505px,location=no';
    },
    previewInvoice: function previewInvoice(_ref32, option) {
        var dispatch = _ref32.dispatch,
            rootState = _ref32.rootState,
            rootDispatch = _ref32.rootDispatch,
            commit = _ref32.commit,
            getters = _ref32.getters;

        window.open('https://' + location.hostname + "/simple/webadmin/print/preview?type=invoice&id=" + option.orderId, 'external', actions.openString());
    },
    previewOrder: function previewOrder(_ref33, option) {
        var dispatch = _ref33.dispatch,
            rootState = _ref33.rootState,
            rootDispatch = _ref33.rootDispatch,
            commit = _ref33.commit,
            getters = _ref33.getters;

        window.open('https://' + location.hostname + "/simple/webadmin/print/preview?type=order&id=" + option.orderId, 'external', actions.openString());
    },
    previewDiscountNote: function previewDiscountNote(_ref34, option) {
        var dispatch = _ref34.dispatch,
            rootState = _ref34.rootState,
            rootDispatch = _ref34.rootDispatch,
            commit = _ref34.commit,
            getters = _ref34.getters;

        window.open('https://' + location.hostname + "/simple/webadmin/print/preview?type=discount-note&id=" + option.orderId, 'external', actions.openString());
    },
    previewTicket: function previewTicket(_ref35, option) {
        var dispatch = _ref35.dispatch,
            rootState = _ref35.rootState,
            rootDispatch = _ref35.rootDispatch,
            commit = _ref35.commit,
            getters = _ref35.getters;

        window.open('https://' + location.hostname + "/simple/webadmin/print/preview?type=ticket&id=" + option.ticketId, 'external', actions.openString());
    },
    previewAllTicket: function previewAllTicket(_ref36, option) {
        var dispatch = _ref36.dispatch,
            rootState = _ref36.rootState,
            rootDispatch = _ref36.rootDispatch,
            commit = _ref36.commit,
            getters = _ref36.getters,
            state = _ref36.state;

        window.open('https://' + location.hostname + "/simple/webadmin/print/preview?type=all-ticket&id=" + option.orderDetailId, 'external', actions.openString());
    },
    previewMembercontract: function previewMembercontract(_ref37, option) {
        var dispatch = _ref37.dispatch,
            rootState = _ref37.rootState,
            rootDispatch = _ref37.rootDispatch,
            commit = _ref37.commit,
            getters = _ref37.getters,
            state = _ref37.state;

        window.open('https://' + location.hostname + "/simple/webadmin/print/preview?type=member-contract&id-member-contract=" + option.memberContractId + "&id-member=" + option.memberId, 'external', actions.openString());
    },
    printManyTicket: function printManyTicket(allTicketData) {
        var current = 0;
        var maxlength = allTicketData.length;

        client.onReceive = function (res) {
            current += 1;
            if (current >= maxlength) {
                return;
            }
            for (; current < maxlength; current++) {
                client.setTicket(allTicketData[current]);
                client.printTicket();
                if (current % 10 === 9 || current === maxlength - 1) {
                    client.realPrint();
                    break;
                }
            }
        };

        client.setTicket(allTicketData[0]);
        client.printTicket();
        client.realPrint();
    },
    orderAutoPrint: function orderAutoPrint(_ref38, _ref39) {
        var _this20 = this;

        var commit = _ref38.commit,
            state = _ref38.state,
            dispatch = _ref38.dispatch,
            getters = _ref38.getters;
        var orderId = _ref39.orderId,
            printConfig = _ref39.printConfig;

        return new _promise2.default(function () {
            var _ref40 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee21(resolve, reject) {
                var autoPrintConfig, options, params;
                return _regenerator2.default.wrap(function _callee21$(_context21) {
                    while (1) {
                        switch (_context21.prev = _context21.next) {
                            case 0:
                                autoPrintConfig = printConfig || {};

                                if (autoPrintConfig.auto_printer_status) {
                                    _context21.next = 4;
                                    break;
                                }

                                resolve();
                                return _context21.abrupt("return");

                            case 4:
                                _context21.next = 6;
                                return dispatch('printerAgent', autoPrintConfig.printer_agent);

                            case 6:
                                options = [autoPrintConfig.scope_invoice_status ? 'invoice' : '', autoPrintConfig.scope_ticket_status ? 'ticket' : '', autoPrintConfig.scope_contract_status ? 'member-contracts' : ''];
                                params = {
                                    converter: {
                                        type: 'order',
                                        target_id: orderId,
                                        condition_option: options.filter(function (item) {
                                            return item;
                                        })
                                    },
                                    format_type: 'print-epson',
                                    is_preview: false
                                };

                                Vue.http.post('/adminapi/print/get', params).then(function () {
                                    var _ref41 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee20(response) {
                                        var printData, allTicket;
                                        return _regenerator2.default.wrap(function _callee20$(_context20) {
                                            while (1) {
                                                switch (_context20.prev = _context20.next) {
                                                    case 0:
                                                        printData = response.data.records;

                                                        actions.setWebLog('確認訂單初始要列印資料無異常', (0, _stringify2.default)(printData));
                                                        client.init(autoPrintConfig.device_ip, 'local_printer');
                                                        client.setBuyerOrderId(orderId);
                                                        if (typeof printData.invoice !== 'undefined') {
                                                            commit('PRINT_INVOICE_DATA', printData.invoice[0]);
                                                            client.setOptionByPrintDetail();
                                                            client.setInvoice(getters.EPSON_PRINT_DATA);
                                                            client.print();
                                                        }
                                                        if (typeof printData['member-contract'] !== 'undefined') {
                                                            printData['member-contract'].map(function (contract) {
                                                                client.setMemberContract(contract);
                                                                client.printMemberContract();
                                                            });
                                                        }
                                                        _context20.next = 8;
                                                        return client.realPrint();

                                                    case 8:
                                                        if (typeof printData.ticket !== 'undefined') {
                                                            allTicket = [];

                                                            printData.ticket.map(function (ticket) {
                                                                allTicket = allTicket.concat(ticket);
                                                            });
                                                            actions.printManyTicket(allTicket);
                                                        }
                                                        resolve(printData);

                                                    case 10:
                                                    case "end":
                                                        return _context20.stop();
                                                }
                                            }
                                        }, _callee20, _this20);
                                    }));

                                    return function (_x3) {
                                        return _ref41.apply(this, arguments);
                                    };
                                }()).catch(function (error) {
                                    actions.setWebLog('訂單初始要列印資料異常', (0, _stringify2.default)(error));
                                    reject(error);
                                });

                            case 9:
                            case "end":
                                return _context21.stop();
                        }
                    }
                }, _callee21, _this20);
            }));

            return function (_x, _x2) {
                return _ref40.apply(this, arguments);
            };
        }());
    },
    setWebLog: function setWebLog(name, message) {
        console.log(name, message);
        _axios2.default.post('https://' + location.hostname + '/adminapi/log', {
            'log_name': name,
            'log_message': message
        }).catch(function (error) {
            return console.log(error);
        });
    }
};

exports.default = {
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations,
    types: types,
    getters: getters
};

},{"./agent-adapter":1595,"axios":19,"babel-runtime/core-js/json/stringify":48,"babel-runtime/core-js/promise":59,"babel-runtime/helpers/asyncToGenerator":62,"babel-runtime/helpers/defineProperty":65,"babel-runtime/helpers/objectDestructuringEmpty":68,"babel-runtime/regenerator":75}],1609:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getDefaultStates = function getDefaultStates() {
    return {
        steps: [
            // {name: xxx, data: {}}, //example 必傳參數
        ],
        configs: {
            showAlertWhenJump: true, //點擊步驟時要不要出現警告避免誤觸
            clearAfterCurrentDataWhenJump: false //點擊步驟時，若從第8跳去第2．需不需要自動刪掉第3.4.5...步的data
        },
        currentStepIndex: 0
    };
};

var state = getDefaultStates();

var mutations = {
    setConfig: function setConfig(state, payload) {
        state.configs[payload.key] = payload.value;
    },
    setCurrentStep: function setCurrentStep(state, index) {
        if (index <= state.steps.length) {
            state.currentStepIndex = index;
        } else {
            $17.swal({
                title: '發生錯誤',
                text: '請重新整理',
                type: 'error',
                showCancelButton: false
            });
        }
    },
    appendStep: function appendStep(state, payload) {
        state.steps.push(payload);
    },
    updateCurrentData: function updateCurrentData(state, data) {
        var current = state.steps[state.currentStepIndex].data;
        state.steps[state.currentStepIndex].data = (0, _assign2.default)(current, _lodash2.default.cloneDeep(data));
    },
    clearDataByIndex: function clearDataByIndex(state, index) {
        state.steps[index].data = {};
    },
    initSteps: function initSteps(state, payload) {
        state.steps = payload;
        state.currentStepIndex = 0;
    },
    clearAll: function clearAll(state) {
        (0, _assign2.default)(state, getDefaultStates());
    }
};

var getters = {
    currentStep: function currentStep(state) {
        return state.steps[state.currentStepIndex];
    },
    hasCurrentStepData: function hasCurrentStepData(state) {
        return Boolean((0, _keys2.default)(state.steps[state.currentStepIndex].data).length);
    },
    finalStepIndex: function finalStepIndex(state) {
        return state.steps.length - 1;
    },
    totalSteps: function totalSteps(state) {
        return state.steps.length;
    },
    stepsData: function stepsData(state) {
        return state.steps.map(function (step) {
            return step.data;
        });
    },

    getDataByIndex: function getDataByIndex(state) {
        return function (index) {
            return state.steps[index].data;
        };
    }
};

var actions = {
    setConfig: function setConfig(_ref, payload) {
        var commit = _ref.commit;

        commit('setConfig', payload);
    },
    jumpToStep: function jumpToStep(_ref2, toIndex) {
        var commit = _ref2.commit,
            state = _ref2.state;

        if (!state.steps[toIndex]) return;

        commit('setCurrentStep', toIndex);

        if (state.configs.clearAfterCurrentDataWhenJump) {
            for (var idx = toIndex + 1; idx < state.steps.length; idx++) {
                commit('clearDataByIndex', idx);
            }
        }
    },
    prevStep: function prevStep(_ref3) {
        var commit = _ref3.commit,
            state = _ref3.state;
        var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        var prev = Number(state.currentStepIndex) - 1;
        if (!state.steps[prev]) return;
        if (data) commit('updateCurrentData', data);
        commit('setCurrentStep', prev);
    },
    nextStep: function nextStep(_ref4) {
        var commit = _ref4.commit,
            state = _ref4.state;
        var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        var next = Number(state.currentStepIndex) + 1;
        if (!state.steps[next]) return;
        if (data) commit('updateCurrentData', data);
        commit('setCurrentStep', next);
    },
    updateCurrentData: function updateCurrentData(_ref5, data) {
        var commit = _ref5.commit;

        commit('updateCurrentData', data);
    },
    initSteps: function initSteps(_ref6, payload) {
        var commit = _ref6.commit;

        commit('initSteps', payload);
    },
    appendStep: function appendStep(_ref7, payload) {
        var commit = _ref7.commit;

        commit('appendStep', payload);
    },
    clearAll: function clearAll(_ref8) {
        var commit = _ref8.commit;

        commit('clearAll');
    }
};

exports.default = {
    namespaced: true,
    state: state,
    actions: actions,
    getters: getters,
    mutations: mutations
};

},{"babel-runtime/core-js/object/assign":50,"babel-runtime/core-js/object/keys":56,"lodash":717}],1610:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mutations;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var type = {
    CLOSE_ALL_BLOCK: 'CLOSE_ALL_BLOCK',
    TOGGLE_BLOCK: 'TOGGLE_BLOCK',
    CHANGE_DATE_OPTIONS: 'CHANGE_DATE_OPTIONS',
    CHANGE_FILTER_OPTIONS: 'CHANGE_FILTER_OPTIONS',
    CHANGE_ITEM_OPTIONS: 'CHANGE_ITEM_OPTIONS',
    CHANGE_AJAXING: 'CHANGE_AJAXING',
    CHANGE_LIST: 'CHANGE_LIST',
    CHANGE_TOTAL: 'CHANGE_TOTAL',
    CLEAN_BRANCH_RELATED_SELECTED: 'CLEAN_BRANCH_RELATED_SELECTED',
    CLEAN_BRANCH_SELECTED: 'CLEAN_BRANCH_SELECTED',
    INIT_CONFRIM_STATUS: 'INIT_CONFRIM_STATUS',
    INIT_CONFRIM_STATUS_SHOW: 'INIT_CONFRIM_STATUS_SHOW'
};

var state = {
    blockOpenStatus: {
        first: true,
        second: true,
        third: false,
        fourth: false
    },
    dateOptions: {
        startDate: null,
        endDate: null
    },
    filterOptions: {
        studioId: null,
        branchIds: [],
        confirmStatuses: []
    },
    ajaxing: false,
    list: [],
    total: [],
    confirmStatus: [],
    confirmStatusShow: {}
};

var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, type.CLOSE_ALL_BLOCK, function (state) {
    state.blockOpenStatus.first = false;
    state.blockOpenStatus.second = false;
    state.blockOpenStatus.third = false;
    state.blockOpenStatus.fourth = false;
}), (0, _defineProperty3.default)(_mutations, type.TOGGLE_BLOCK, function (state, payload) {
    state.blockOpenStatus[payload.block] = !state.blockOpenStatus[payload.block];
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_DATE_OPTIONS, function (state, payload) {
    state.dateOptions[payload.prop] = payload.value;
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_FILTER_OPTIONS, function (state, payload) {
    state.filterOptions[payload.prop] = payload.value;
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_AJAXING, function (state, payload) {
    state.ajaxing = payload.value;
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_LIST, function (state, payload) {
    state.list = payload.value;
}), (0, _defineProperty3.default)(_mutations, type.CHANGE_TOTAL, function (state, payload) {
    state.total = payload.value;
}), (0, _defineProperty3.default)(_mutations, type.CLEAN_BRANCH_SELECTED, function (state) {
    state.filterOptions.branchIds = [];
}), (0, _defineProperty3.default)(_mutations, type.CLEAN_BRANCH_RELATED_SELECTED, function (state) {
    state.filterOptions.serviceIds = [];
}), (0, _defineProperty3.default)(_mutations, type.INIT_CONFRIM_STATUS, function (state, payload) {
    state.confirmStatus = payload.status;
}), (0, _defineProperty3.default)(_mutations, type.INIT_CONFRIM_STATUS_SHOW, function (state, payload) {
    state.confirmStatusShow = payload;
}), _mutations);

var api = {
    fetchData: function fetchData() {
        return new _promise2.default(function (resolve) {
            var branchIds = state.filterOptions.branchIds.map(function (elem) {
                return elem.id;
            });
            var confirmStatuses = state.filterOptions.confirmStatuses.map(function (elem) {
                return elem.status;
            });
            var postData = {
                studio_id: state.filterOptions.studioId && state.filterOptions.studioId.hasOwnProperty('id') ? state.filterOptions.studioId.id : 0,
                branch_ids: branchIds,
                start_date: state.dateOptions.startDate,
                end_date: state.dateOptions.endDate,
                confirm_statuses: confirmStatuses
            };
            Vue.http.post('/adminapi/report/fetch_all_tickets_used_total_data', postData).then(function (_ref) {
                var data = _ref.data;
                return resolve(data.data);
            });
        });
    },
    initConfirmStatus: function initConfirmStatus() {
        return new _promise2.default(function (resolve) {
            Vue.http.get('/adminapi/init/get_ticket_status').then(function (_ref2) {
                var data = _ref2.data;
                return resolve({
                    status: data
                });
            });
        });
    }
};

var actions = {
    submit: function submit(_ref3) {
        var commit = _ref3.commit,
            dispatch = _ref3.dispatch;

        if (!state.dateOptions.startDate || state.dateOptions.startDate == 'Invalid date') {
            return $17.formatErrorAlert('日期：請填寫 開始日期');
        }
        if (!state.dateOptions.endDate || state.dateOptions.endDate == 'Invalid date') {
            return $17.formatErrorAlert('日期：請填寫 結束日期');
        }
        if (state.dateOptions.startDate > state.dateOptions.endDate) {
            return $17.formatErrorAlert('日期：開始日期不能大於結束日期');
        }
        // commit(type.CLOSE_ALL_BLOCK); //Disabled close all block when submit form
        dispatch('fetchData');
    },
    toggleBlock: function toggleBlock(_ref4, payload) {
        var commit = _ref4.commit;

        commit(type.TOGGLE_BLOCK, payload);
    },
    changeDateOption: function changeDateOption(_ref5, payload) {
        var commit = _ref5.commit;

        commit(type.CHANGE_DATE_OPTIONS, payload);
    },
    changeFilterOption: function changeFilterOption(_ref6, payload) {
        var commit = _ref6.commit;

        commit(type.CHANGE_FILTER_OPTIONS, payload);
    },
    cleanBranch: function cleanBranch(_ref7) {
        var commit = _ref7.commit;

        commit(type.CLEAN_BRANCH_SELECTED);
    },
    cleanBranchRelated: function cleanBranchRelated(_ref8) {
        var commit = _ref8.commit;

        commit(type.CLEAN_BRANCH_RELATED_SELECTED);
    },
    fetchData: function fetchData(_ref9) {
        var commit = _ref9.commit;

        commit(type.CHANGE_AJAXING, {
            value: true
        });
        api.fetchData().then(function (response) {
            commit(type.CHANGE_AJAXING, {
                value: false
            });
            commit(type.CHANGE_LIST, {
                value: response.list
            });
            commit(type.CHANGE_TOTAL, {
                value: response.total
            });
        });
    },
    setDetailTarget: function setDetailTarget(_ref10, payload) {
        var commit = _ref10.commit;

        commit(type.CHANGE_DETAIL, payload);
    },
    initConfirmStatus: function initConfirmStatus(_ref11) {
        var commit = _ref11.commit;

        api.initConfirmStatus().then(function (response) {
            commit(type.INIT_CONFRIM_STATUS, response);
            var show = response.status.reduce(function (result, item) {
                result[item.status] = item.name;
                return result;
            }, {});
            commit(type.INIT_CONFRIM_STATUS_SHOW, show);
        });
    }
};

exports.default = {
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations
};

},{"babel-runtime/core-js/promise":59,"babel-runtime/helpers/defineProperty":65}],1611:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {
    webLocalSettingId: '',
    printerSetting: {},
    ajaxing: {
        webLocalSettingId: false,
        printerSetting: false
    }
};

var mutations = {
    webLocalSettingId: function webLocalSettingId(state, id) {
        var cookieExpireDays = 365;
        state.webLocalSettingId = id;
        Cookies.set('webLocalSettingId', id, { expires: cookieExpireDays });
    },
    printerSetting: function printerSetting(state, payload) {
        state.printerSetting = payload || {};
    },
    changeAjaxing: function changeAjaxing(state, _ref) {
        var key = _ref.key,
            value = _ref.value;

        state.ajaxing[key] = value;
    }
};

var actions = {
    init: function init(_ref2) {
        var commit = _ref2.commit,
            state = _ref2.state,
            dispatch = _ref2.dispatch,
            rootState = _ref2.rootState;

        if (state.ajaxing.webLocalSettingId) return;
        var id = Cookies.get('webLocalSettingId');
        var studioId = rootState.webadmin.configure.studioId || 0;
        var branchId = rootState.webadmin.configure.branchId || 0;
        var params = id ? { uwlid: id } : {};
        commit('changeAjaxing', { key: 'webLocalSettingId', value: true });
        Vue.http.post('/adminapi/web-local-setting/studio/' + studioId + '/branch/' + branchId, params).then(function (response) {
            commit('webLocalSettingId', response.data.data.uwlid);
            commit('changeAjaxing', { key: 'webLocalSettingId', value: false });
            dispatch('fetchPrinterSetting');
        }, function (error) {
            commit('changeAjaxing', { key: 'webLocalSettingId', value: false });
        });
    },
    fetchPrinterSetting: function fetchPrinterSetting(_ref3) {
        var commit = _ref3.commit,
            state = _ref3.state,
            dispatch = _ref3.dispatch,
            rootState = _ref3.rootState;

        commit('changeAjaxing', { key: 'printerSetting', value: true });
        var uwlid = state.webLocalSettingId;
        var studioId = rootState.webadmin.configure.studioId || 0;
        var branchId = rootState.webadmin.configure.branchId || 0;
        Vue.http.get('/adminapi/web-local-setting/' + uwlid + '/printer/studio/' + studioId + '/branch/' + branchId).then(function (response) {
            commit('printerSetting', response.data.printer);
            dispatch('checkDefaultPrinter');
            commit('changeAjaxing', { key: 'printerSetting', value: false });
        }, function (error) {
            console.error(error);
            commit('changeAjaxing', { key: 'printerSetting', value: false });
        });
    },
    putPrinterSetting: function putPrinterSetting(_ref4, payload) {
        var commit = _ref4.commit,
            state = _ref4.state,
            rootState = _ref4.rootState;

        return new _promise2.default(function (resolve, reject) {
            var uwlid = state.webLocalSettingId;
            if (!uwlid) {
                reject({ data: { message: '設定發生錯誤，請重新整理頁面。' } });
                return;
            }
            var studioId = rootState.webadmin.configure.studioId || 0;
            var branchId = rootState.webadmin.configure.branchId || 0;
            Vue.http.put('/adminapi/web-local-setting/' + uwlid + '/printer/studio/' + studioId + '/branch/' + branchId, payload).then(function (response) {
                resolve(response);
            }, function (error) {
                reject(error);
            });
        });
    },
    checkDefaultPrinter: function checkDefaultPrinter(_ref5) {
        var commit = _ref5.commit,
            state = _ref5.state,
            dispatch = _ref5.dispatch,
            rootState = _ref5.rootState;

        var defaultPrinterIp = Cookies.get('defaultPrinter');
        if (state.printerSetting.device_id == undefined && defaultPrinterIp != undefined) {
            var studioId = rootState.webadmin.configure.studioId || 0;
            Vue.http.get('/adminapi/print_device/get-id-by-ip/device-ip/' + defaultPrinterIp + '/studio/' + studioId).then(function (response) {
                var params = {
                    settings_params: {
                        print_devices_id: response.data.id,
                        auto_printer_status: 0,
                        scope_invoice_status: 0,
                        scope_ticket_status: 0,
                        scope_contract_status: 0,
                        printer_agent: 'iot_kit'
                    }
                };
                dispatch('putPrinterSetting', params);
            }, function (error) {
                console.error(error);
                commit('changeAjaxing', { key: 'printerSetting', value: false });
            });
        }
    }
};

var getters = {
    webLocalSettingId: function webLocalSettingId(state) {
        return state.webLocalSettingId;
    },
    printerSetting: function printerSetting(state) {
        return state.printerSetting;
    }
};

exports.default = {
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
};

},{"babel-runtime/core-js/promise":59,"lodash":717}],1612:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var INIT_USER_VALUE = exports.INIT_USER_VALUE = 'INIT_USER_VALUE';

// export const POS_INCREASE = 'POS_INCREASE';
// export const POS_SETSTATUS = 'POS_SETSTATUS';

// export const FILTERS_APPEND_STUDIO = 'FILTERS_APPEND_STUDIO';
// export const FILTERS_APPEND_BRANCH = 'FILTERS_APPEND_BRANCH';
// export const FILTERS_SET_SELECTED_STUDIO_ID = 'FILTERS_SET_SELECTED_STUDIO_ID';
// export const FILTERS_SET_SELECTED_BRANCH_ID = 'FILTERS_SET_SELECTED_BRANCH_ID';

},{}],1613:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mutations = exports.state = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mutations;

var _mutationTypes = require('./mutation-types');

var types = _interopRequireWildcard(_mutationTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = exports.state = {

  csrfToken: '',
  count: 0,
  studio_id: 0,
  branch_id: 0,
  member_id: 0,
  user_studio_id: null,
  user_branch_id: null,
  user_member_id: null,
  is_17fit: null,
  is_studio: null,
  is_branch: null,
  is_in_webadmin: null
};

var mutations = exports.mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.POS_INCREASE, function (state) {
  state.count++;
}), (0, _defineProperty3.default)(_mutations, types.INIT_USER_VALUE, function (state, payload) {
  for (var key in payload) {
    state[key] = payload[key];
  }
}), _mutations);

},{"./mutation-types":1612,"babel-runtime/helpers/defineProperty":65}],1614:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ["1R001", "1R002", "1R003", "1R004", "1R005", "1R006", "M1000", "M1001", "M1002", "M1003", "M1004", "M1005", "M1006", "M1007", "M1008", "M1009", "M1010", "M1011", "M1012", "M1013", "M1014", "M1015", "M1016"];

},{}],1615:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ["1R001", "1R002", "1R003", "1R004", "1R005", "1R006", "M1000", "M1001", "M1002", "M1003", "M1004", "M1005", "M1006", "M1007", "M1008", "M1009", "M1010", "M1011", "M1012", "M1013", "M1014", "M1015", "M1016"];

},{}]},{},[857]);

//# sourceMappingURL=$17.js.map
